// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gX9nn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _client = require("react-dom/client");
var _uiReact = require("@aws-amplify/ui-react");
var _app = require("./App");
(0, _client.createRoot)(document.getElementById("root")).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.Authenticator).Provider, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {})
        })
    })
}));

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","react-dom/client":"8C8Pt","@aws-amplify/ui-react":"40VMD","./App":"7zW2R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1elNt":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"5mt7x"}],"5mt7x":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"gVheC"}],"gVheC":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"hKabY"}],"hKabY":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"k10Fc":[function(require,module,exports) {
/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"gVheC","react-dom":"d8jlt","react-router":"d32wV","@remix-run/router":"iEJ3d","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d8jlt":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"57rmM"}],"57rmM":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"gVheC","ece50e903283a22f":"fXTxA"}],"fXTxA":[function(require,module,exports) {
"use strict";
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"laXjn"}],"laXjn":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"d32wV":[function(require,module,exports) {
/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties
    }).initialize();
}

},{"react":"gVheC","@remix-run/router":"iEJ3d","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iEJ3d":[function(require,module,exports) {
/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class AbortedDeferredError extends Error {
}
class DeferredData {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited, loaderData, errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState(_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        invariant(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return callLoaderOrAction("loader", createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: ResultType.error,
                        error: getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results,
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if (isQueryRouteResponse(e)) {
                if (e.type === ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest,
                requestContext
            });
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return _extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: _extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest,
                    requestContext
                }))
        ]);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if (isResponse(result)) {
        let status = result.status;
        // Process redirects
        if (redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!ABSOLUTE_URL_REGEX.test(location)) location = normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = stripBasename(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: ResultType.redirect,
                status,
                location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === ResultType.error ? ResultType.error : ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (resultType === ResultType.error) return {
            type: resultType,
            error: new ErrorResponseImpl(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === ResultType.error) return {
        type: resultType,
        error: result
    };
    if (isDeferredData(result)) {
        var _result$init, _result$init2;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if (isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, match, controller } = revalidatingFetchers[index];
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if (isRedirectResult(result)) return {
            result,
            idx: i
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isQueryRouteResponse(obj) {
    return obj && isResponse(obj.response) && (obj.type === ResultType.data || obj.type === ResultType.error);
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kznVD":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"8C8Pt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"d8jlt"}],"40VMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAmplify", ()=>(0, _useAmplifyMjs.useAmplify));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeMjs.useTheme));
parcelHelpers.export(exports, "useBreakpointValue", ()=>(0, _useBreakpointValueMjs.useBreakpointValue));
parcelHelpers.export(exports, "createTheme", ()=>(0, _ui.createTheme));
parcelHelpers.export(exports, "defaultDarkModeOverride", ()=>(0, _ui.defaultDarkModeOverride));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _ui.defaultTheme));
parcelHelpers.export(exports, "translations", ()=>(0, _ui.translations));
parcelHelpers.export(exports, "AccountSettings", ()=>(0, _accountSettingsMjsDefault.default));
parcelHelpers.export(exports, "Authenticator", ()=>(0, _authenticatorMjs.Authenticator));
parcelHelpers.export(exports, "withAuthenticator", ()=>(0, _withAuthenticatorMjs.withAuthenticator));
parcelHelpers.export(exports, "useAuthenticator", ()=>(0, _uiReactCore.useAuthenticator));
parcelHelpers.export(exports, "FileUploader", ()=>(0, _fileUploaderMjs.FileUploader));
parcelHelpers.export(exports, "AmplifyProvider", ()=>(0, _themeProviderMjs.AmplifyProvider));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderMjs.ThemeProvider));
parcelHelpers.export(exports, "IconsProvider", ()=>(0, _iconsProviderMjs.IconsProvider));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertMjs.Alert));
parcelHelpers.export(exports, "Autocomplete", ()=>(0, _autocompleteMjs.Autocomplete));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeMjs.Badge));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbsMjs.Breadcrumbs));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonMjs.Button));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupMjs.ButtonGroup));
parcelHelpers.export(exports, "Card", ()=>(0, _cardMjs.Card));
parcelHelpers.export(exports, "CheckboxField", ()=>(0, _checkboxFieldMjs.CheckboxField));
parcelHelpers.export(exports, "Collection", ()=>(0, _collectionMjs.Collection));
parcelHelpers.export(exports, "Divider", ()=>(0, _dividerMjs.Divider));
parcelHelpers.export(exports, "DropZone", ()=>(0, _dropZoneMjs.DropZone));
parcelHelpers.export(exports, "Expander", ()=>(0, _expanderMjs.Expander));
parcelHelpers.export(exports, "ExpanderItem", ()=>(0, _expanderItemMjs.ExpanderItem));
parcelHelpers.export(exports, "FieldGroupIcon", ()=>(0, _fieldGroupIconMjs.FieldGroupIcon));
parcelHelpers.export(exports, "FieldGroupIconButton", ()=>(0, _fieldGroupIconButtonMjs.FieldGroupIconButton));
parcelHelpers.export(exports, "Fieldset", ()=>(0, _fieldsetMjs.Fieldset));
parcelHelpers.export(exports, "Flex", ()=>(0, _flexMjs.Flex));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridMjs.Grid));
parcelHelpers.export(exports, "Heading", ()=>(0, _headingMjs.Heading));
parcelHelpers.export(exports, "HighlightMatch", ()=>(0, _highlightMatchMjs.HighlightMatch));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconMjs.Icon));
parcelHelpers.export(exports, "Image", ()=>(0, _imageMjs.Image));
parcelHelpers.export(exports, "Input", ()=>(0, _inputMjs.Input));
parcelHelpers.export(exports, "Label", ()=>(0, _labelMjs.Label));
parcelHelpers.export(exports, "Link", ()=>(0, _linkMjs.Link));
parcelHelpers.export(exports, "Loader", ()=>(0, _loaderMjs.Loader));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuMjs.Menu));
parcelHelpers.export(exports, "MenuButton", ()=>(0, _menuButtonMjs.MenuButton));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItemMjs.MenuItem));
parcelHelpers.export(exports, "Message", ()=>(0, _messageMjs.Message));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationMjs.Pagination));
parcelHelpers.export(exports, "PasswordField", ()=>(0, _passwordFieldMjs.PasswordField));
parcelHelpers.export(exports, "PhoneNumberField", ()=>(0, _phoneNumberFieldMjs.PhoneNumberField));
parcelHelpers.export(exports, "Placeholder", ()=>(0, _placeholderMjs.Placeholder));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioMjs.Radio));
parcelHelpers.export(exports, "RadioGroupField", ()=>(0, _radioGroupFieldMjs.RadioGroupField));
parcelHelpers.export(exports, "Rating", ()=>(0, _ratingMjs.Rating));
parcelHelpers.export(exports, "ScrollView", ()=>(0, _scrollViewMjs.ScrollView));
parcelHelpers.export(exports, "SearchField", ()=>(0, _searchFieldMjs.SearchField));
parcelHelpers.export(exports, "SelectField", ()=>(0, _selectFieldMjs.SelectField));
parcelHelpers.export(exports, "SliderField", ()=>(0, _sliderFieldMjs.SliderField));
parcelHelpers.export(exports, "StepperField", ()=>(0, _stepperFieldMjs.StepperField));
parcelHelpers.export(exports, "SwitchField", ()=>(0, _switchFieldMjs.SwitchField));
parcelHelpers.export(exports, "TabItem", ()=>(0, _tabsMjs.TabItem));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsMjs.Tabs));
parcelHelpers.export(exports, "Text", ()=>(0, _textMjs.Text));
parcelHelpers.export(exports, "TextAreaField", ()=>(0, _textAreaFieldMjs.TextAreaField));
parcelHelpers.export(exports, "TextField", ()=>(0, _textFieldMjs.TextField));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonMjs.ToggleButton));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupMjs.ToggleButtonGroup));
parcelHelpers.export(exports, "View", ()=>(0, _viewMjs.View));
parcelHelpers.export(exports, "VisuallyHidden", ()=>(0, _visuallyHiddenMjs.VisuallyHidden));
parcelHelpers.export(exports, "Table", ()=>(0, _tableMjs.Table));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableBodyMjs.TableBody));
parcelHelpers.export(exports, "TableCell", ()=>(0, _tableCellMjs.TableCell));
parcelHelpers.export(exports, "TableFoot", ()=>(0, _tableFootMjs.TableFoot));
parcelHelpers.export(exports, "TableHead", ()=>(0, _tableHeadMjs.TableHead));
parcelHelpers.export(exports, "TableRow", ()=>(0, _tableRowMjs.TableRow));
parcelHelpers.export(exports, "usePagination", ()=>(0, _usePaginationMjs.usePagination));
parcelHelpers.export(exports, "ComponentClassNames", ()=>(0, _constantsMjs.ComponentClassNames));
parcelHelpers.export(exports, "ComponentClassObject", ()=>(0, _constantsMjs.ComponentClassObject));
parcelHelpers.export(exports, "ComponentPropsToStylePropsMap", ()=>(0, _styleMjs.ComponentPropsToStylePropsMap));
parcelHelpers.export(exports, "ComponentPropsToStylePropsMapKeys", ()=>(0, _styleMjs.ComponentPropsToStylePropsMapKeys));
parcelHelpers.export(exports, "components", ()=>_indexMjs);
parcelHelpers.export(exports, "primitives", ()=>_indexMjs1);
var _indexMjs = require("./components/index.mjs");
var _useAmplifyMjs = require("./hooks/useAmplify.mjs");
var _useThemeMjs = require("./hooks/useTheme.mjs");
var _useBreakpointValueMjs = require("./hooks/useBreakpointValue.mjs");
var _indexMjs1 = require("./primitives/index.mjs");
var _ui = require("@aws-amplify/ui");
var _accountSettingsMjs = require("./components/AccountSettings/AccountSettings.mjs");
var _accountSettingsMjsDefault = parcelHelpers.interopDefault(_accountSettingsMjs);
var _authenticatorMjs = require("./components/Authenticator/Authenticator.mjs");
var _withAuthenticatorMjs = require("./components/Authenticator/withAuthenticator.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _fileUploaderMjs = require("./components/Storage/FileUploader/FileUploader.mjs");
var _themeProviderMjs = require("./components/ThemeProvider/ThemeProvider.mjs");
var _iconsProviderMjs = require("./primitives/Icon/context/IconsProvider.mjs");
var _alertMjs = require("./primitives/Alert/Alert.mjs");
var _autocompleteMjs = require("./primitives/Autocomplete/Autocomplete.mjs");
var _badgeMjs = require("./primitives/Badge/Badge.mjs");
var _breadcrumbsMjs = require("./primitives/Breadcrumbs/Breadcrumbs.mjs");
var _buttonMjs = require("./primitives/Button/Button.mjs");
var _buttonGroupMjs = require("./primitives/ButtonGroup/ButtonGroup.mjs");
var _cardMjs = require("./primitives/Card/Card.mjs");
var _checkboxFieldMjs = require("./primitives/CheckboxField/CheckboxField.mjs");
var _collectionMjs = require("./primitives/Collection/Collection.mjs");
var _dividerMjs = require("./primitives/Divider/Divider.mjs");
var _dropZoneMjs = require("./primitives/DropZone/DropZone.mjs");
var _expanderMjs = require("./primitives/Expander/Expander.mjs");
var _expanderItemMjs = require("./primitives/Expander/ExpanderItem.mjs");
var _fieldGroupIconMjs = require("./primitives/FieldGroupIcon/FieldGroupIcon.mjs");
var _fieldGroupIconButtonMjs = require("./primitives/FieldGroupIcon/FieldGroupIconButton.mjs");
var _fieldsetMjs = require("./primitives/Fieldset/Fieldset.mjs");
var _flexMjs = require("./primitives/Flex/Flex.mjs");
var _gridMjs = require("./primitives/Grid/Grid.mjs");
var _headingMjs = require("./primitives/Heading/Heading.mjs");
var _highlightMatchMjs = require("./primitives/HighlightMatch/HighlightMatch.mjs");
var _iconMjs = require("./primitives/Icon/Icon.mjs");
var _imageMjs = require("./primitives/Image/Image.mjs");
var _inputMjs = require("./primitives/Input/Input.mjs");
var _labelMjs = require("./primitives/Label/Label.mjs");
var _linkMjs = require("./primitives/Link/Link.mjs");
var _loaderMjs = require("./primitives/Loader/Loader.mjs");
var _menuMjs = require("./primitives/Menu/Menu.mjs");
var _menuButtonMjs = require("./primitives/Menu/MenuButton.mjs");
var _menuItemMjs = require("./primitives/Menu/MenuItem.mjs");
var _messageMjs = require("./primitives/Message/Message.mjs");
var _paginationMjs = require("./primitives/Pagination/Pagination.mjs");
var _passwordFieldMjs = require("./primitives/PasswordField/PasswordField.mjs");
var _phoneNumberFieldMjs = require("./primitives/PhoneNumberField/PhoneNumberField.mjs");
var _placeholderMjs = require("./primitives/Placeholder/Placeholder.mjs");
var _radioMjs = require("./primitives/Radio/Radio.mjs");
var _radioGroupFieldMjs = require("./primitives/RadioGroupField/RadioGroupField.mjs");
var _ratingMjs = require("./primitives/Rating/Rating.mjs");
var _scrollViewMjs = require("./primitives/ScrollView/ScrollView.mjs");
var _searchFieldMjs = require("./primitives/SearchField/SearchField.mjs");
var _selectFieldMjs = require("./primitives/SelectField/SelectField.mjs");
var _sliderFieldMjs = require("./primitives/SliderField/SliderField.mjs");
var _stepperFieldMjs = require("./primitives/StepperField/StepperField.mjs");
var _switchFieldMjs = require("./primitives/SwitchField/SwitchField.mjs");
var _tabsMjs = require("./primitives/Tabs/Tabs.mjs");
var _textMjs = require("./primitives/Text/Text.mjs");
var _textAreaFieldMjs = require("./primitives/TextAreaField/TextAreaField.mjs");
var _textFieldMjs = require("./primitives/TextField/TextField.mjs");
var _toggleButtonMjs = require("./primitives/ToggleButton/ToggleButton.mjs");
var _toggleButtonGroupMjs = require("./primitives/ToggleButtonGroup/ToggleButtonGroup.mjs");
var _viewMjs = require("./primitives/View/View.mjs");
var _visuallyHiddenMjs = require("./primitives/VisuallyHidden/VisuallyHidden.mjs");
var _tableMjs = require("./primitives/Table/Table.mjs");
var _tableBodyMjs = require("./primitives/Table/TableBody.mjs");
var _tableCellMjs = require("./primitives/Table/TableCell.mjs");
var _tableFootMjs = require("./primitives/Table/TableFoot.mjs");
var _tableHeadMjs = require("./primitives/Table/TableHead.mjs");
var _tableRowMjs = require("./primitives/Table/TableRow.mjs");
var _usePaginationMjs = require("./primitives/Pagination/usePagination.mjs");
var _constantsMjs = require("./primitives/shared/constants.mjs");
var _styleMjs = require("./primitives/types/style.mjs");

},{"./components/index.mjs":false,"./hooks/useAmplify.mjs":false,"./hooks/useTheme.mjs":false,"./hooks/useBreakpointValue.mjs":false,"./primitives/index.mjs":false,"@aws-amplify/ui":false,"./components/AccountSettings/AccountSettings.mjs":false,"./components/Authenticator/Authenticator.mjs":"31OA9","./components/Authenticator/withAuthenticator.mjs":false,"@aws-amplify/ui-react-core":"cZFwB","./components/Storage/FileUploader/FileUploader.mjs":false,"./components/ThemeProvider/ThemeProvider.mjs":"726cS","./primitives/Icon/context/IconsProvider.mjs":false,"./primitives/Alert/Alert.mjs":false,"./primitives/Autocomplete/Autocomplete.mjs":false,"./primitives/Badge/Badge.mjs":false,"./primitives/Breadcrumbs/Breadcrumbs.mjs":false,"./primitives/Button/Button.mjs":"4aRAq","./primitives/ButtonGroup/ButtonGroup.mjs":false,"./primitives/Card/Card.mjs":false,"./primitives/CheckboxField/CheckboxField.mjs":false,"./primitives/Collection/Collection.mjs":false,"./primitives/Divider/Divider.mjs":false,"./primitives/DropZone/DropZone.mjs":false,"./primitives/Expander/Expander.mjs":false,"./primitives/Expander/ExpanderItem.mjs":false,"./primitives/FieldGroupIcon/FieldGroupIcon.mjs":false,"./primitives/FieldGroupIcon/FieldGroupIconButton.mjs":false,"./primitives/Fieldset/Fieldset.mjs":false,"./primitives/Flex/Flex.mjs":false,"./primitives/Grid/Grid.mjs":false,"./primitives/Heading/Heading.mjs":false,"./primitives/HighlightMatch/HighlightMatch.mjs":false,"./primitives/Icon/Icon.mjs":false,"./primitives/Image/Image.mjs":"f1URh","./primitives/Input/Input.mjs":false,"./primitives/Label/Label.mjs":false,"./primitives/Link/Link.mjs":false,"./primitives/Loader/Loader.mjs":false,"./primitives/Menu/Menu.mjs":false,"./primitives/Menu/MenuButton.mjs":false,"./primitives/Menu/MenuItem.mjs":false,"./primitives/Message/Message.mjs":false,"./primitives/Pagination/Pagination.mjs":false,"./primitives/PasswordField/PasswordField.mjs":false,"./primitives/PhoneNumberField/PhoneNumberField.mjs":false,"./primitives/Placeholder/Placeholder.mjs":false,"./primitives/Radio/Radio.mjs":false,"./primitives/RadioGroupField/RadioGroupField.mjs":false,"./primitives/Rating/Rating.mjs":false,"./primitives/ScrollView/ScrollView.mjs":false,"./primitives/SearchField/SearchField.mjs":false,"./primitives/SelectField/SelectField.mjs":false,"./primitives/SliderField/SliderField.mjs":false,"./primitives/StepperField/StepperField.mjs":false,"./primitives/SwitchField/SwitchField.mjs":false,"./primitives/Tabs/Tabs.mjs":false,"./primitives/Text/Text.mjs":"bYgXO","./primitives/TextAreaField/TextAreaField.mjs":false,"./primitives/TextField/TextField.mjs":false,"./primitives/ToggleButton/ToggleButton.mjs":false,"./primitives/ToggleButtonGroup/ToggleButtonGroup.mjs":false,"./primitives/View/View.mjs":"dfO6K","./primitives/VisuallyHidden/VisuallyHidden.mjs":false,"./primitives/Table/Table.mjs":false,"./primitives/Table/TableBody.mjs":false,"./primitives/Table/TableCell.mjs":false,"./primitives/Table/TableFoot.mjs":false,"./primitives/Table/TableHead.mjs":false,"./primitives/Table/TableRow.mjs":false,"./primitives/Pagination/usePagination.mjs":false,"./primitives/shared/constants.mjs":false,"./primitives/types/style.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"48i37":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeFromContext", ()=>m);
parcelHelpers.export(exports, "useTheme", ()=>r);
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _amplifyContextMjs = require("../components/ThemeProvider/AmplifyContext.mjs");
const m = (o)=>void 0 === o || void 0 === o.theme ? (0, _ui.createTheme)() : o.theme, r = ()=>{
    const t = _react.useContext((0, _amplifyContextMjs.AmplifyContext));
    return m(t);
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../components/ThemeProvider/AmplifyContext.mjs":"dXMi7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2NgwQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActorContext", ()=>(0, _actorMjs.getActorContext));
parcelHelpers.export(exports, "getActorState", ()=>(0, _actorMjs.getActorState));
parcelHelpers.export(exports, "getConfiguredAliases", ()=>(0, _contextMjs.getConfiguredAliases));
parcelHelpers.export(exports, "getPrimaryAlias", ()=>(0, _contextMjs.getPrimaryAlias));
parcelHelpers.export(exports, "getSendEventAliases", ()=>(0, _facadeMjs.getSendEventAliases));
parcelHelpers.export(exports, "getServiceContextFacade", ()=>(0, _facadeMjs.getServiceContextFacade));
parcelHelpers.export(exports, "getServiceFacade", ()=>(0, _facadeMjs.getServiceFacade));
parcelHelpers.export(exports, "ALLOWED_SPECIAL_CHARACTERS", ()=>(0, _constantsMjs.ALLOWED_SPECIAL_CHARACTERS));
parcelHelpers.export(exports, "defaultFormFieldOptions", ()=>(0, _constantsMjs.defaultFormFieldOptions));
parcelHelpers.export(exports, "emailRegex", ()=>(0, _constantsMjs.emailRegex));
parcelHelpers.export(exports, "getErrors", ()=>(0, _formMjs.getErrors));
parcelHelpers.export(exports, "getFormDataFromEvent", ()=>(0, _formMjs.getFormDataFromEvent));
parcelHelpers.export(exports, "isAuthFieldWithDefaults", ()=>(0, _formMjs.isAuthFieldWithDefaults));
parcelHelpers.export(exports, "setFormOrder", ()=>(0, _formMjs.setFormOrder));
parcelHelpers.export(exports, "censorAllButFirstAndLast", ()=>(0, _utilsMjs.censorAllButFirstAndLast));
parcelHelpers.export(exports, "censorPhoneNumber", ()=>(0, _utilsMjs.censorPhoneNumber));
parcelHelpers.export(exports, "configureComponent", ()=>(0, _utilsMjs.configureComponent));
parcelHelpers.export(exports, "defaultAuthHubHandler", ()=>(0, _utilsMjs.defaultAuthHubHandler));
parcelHelpers.export(exports, "getTotpCodeURL", ()=>(0, _utilsMjs.getTotpCodeURL));
parcelHelpers.export(exports, "hasSpecialChars", ()=>(0, _utilsMjs.hasSpecialChars));
parcelHelpers.export(exports, "isValidEmail", ()=>(0, _utilsMjs.isValidEmail));
parcelHelpers.export(exports, "listenToAuthHub", ()=>(0, _utilsMjs.listenToAuthHub));
parcelHelpers.export(exports, "trimValues", ()=>(0, _utilsMjs.trimValues));
parcelHelpers.export(exports, "getCustomFormFields", ()=>(0, _formFieldsMjs.getCustomFormFields));
parcelHelpers.export(exports, "getDefaultFormFields", ()=>(0, _formFieldsMjs.getDefaultFormFields));
parcelHelpers.export(exports, "getFormFields", ()=>(0, _formFieldsMjs.getFormFields));
parcelHelpers.export(exports, "getSortedFormFields", ()=>(0, _formFieldsMjs.getSortedFormFields));
parcelHelpers.export(exports, "removeOrderKeys", ()=>(0, _formFieldsMjs.removeOrderKeys));
parcelHelpers.export(exports, "defaultFormFieldsGetters", ()=>(0, _defaultsMjs.defaultFormFieldsGetters));
parcelHelpers.export(exports, "getAliasDefaultFormField", ()=>(0, _defaultsMjs.getAliasDefaultFormField));
parcelHelpers.export(exports, "applyTranslation", ()=>(0, _utilMjs.applyTranslation));
parcelHelpers.export(exports, "sortFormFields", ()=>(0, _utilMjs.sortFormFields));
parcelHelpers.export(exports, "authenticatorTextUtil", ()=>(0, _textUtilMjs.authenticatorTextUtil));
parcelHelpers.export(exports, "changePassword", ()=>(0, _utilsMjs1.changePassword));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _utilsMjs1.deleteUser));
parcelHelpers.export(exports, "getDefaultConfirmPasswordValidators", ()=>(0, _validatorMjs.getDefaultConfirmPasswordValidators));
parcelHelpers.export(exports, "getDefaultPasswordValidators", ()=>(0, _validatorMjs.getDefaultPasswordValidators));
parcelHelpers.export(exports, "runFieldValidators", ()=>(0, _validatorMjs.runFieldValidators));
parcelHelpers.export(exports, "checkMaxSize", ()=>(0, _uploaderMjs.checkMaxSize));
parcelHelpers.export(exports, "humanFileSize", ()=>(0, _uploaderMjs.humanFileSize));
parcelHelpers.export(exports, "isValidExtension", ()=>(0, _uploaderMjs.isValidExtension));
parcelHelpers.export(exports, "returnAcceptedFiles", ()=>(0, _uploaderMjs.returnAcceptedFiles));
parcelHelpers.export(exports, "uploadFile", ()=>(0, _uploaderMjs.uploadFile));
parcelHelpers.export(exports, "getLogger", ()=>(0, _utilsMjs2.getLogger));
parcelHelpers.export(exports, "countryDialCodes", ()=>(0, _countryDialCodesMjs.countryDialCodes));
parcelHelpers.export(exports, "DefaultTexts", ()=>(0, _translationsMjs.DefaultTexts));
parcelHelpers.export(exports, "hasTranslation", ()=>(0, _translationsMjs.hasTranslation));
parcelHelpers.export(exports, "translate", ()=>(0, _translationsMjs.translate));
parcelHelpers.export(exports, "translations", ()=>(0, _translationsMjs.translations));
parcelHelpers.export(exports, "createAuthenticatorMachine", ()=>(0, _indexMjs.createAuthenticatorMachine));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeMjs.createTheme));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _defaultThemeMjs.defaultTheme));
parcelHelpers.export(exports, "defaultDarkModeOverride", ()=>(0, _defaultDarkModeOverrideMjs.defaultDarkModeOverride));
parcelHelpers.export(exports, "reactNativeDarkTokens", ()=>(0, _defaultDarkModeOverrideMjs.reactNativeDarkTokens));
parcelHelpers.export(exports, "reactNativeTokens", ()=>(0, _indexMjs1.reactNativeTokens));
parcelHelpers.export(exports, "cssNameTransform", ()=>(0, _utilsMjs3.cssNameTransform));
parcelHelpers.export(exports, "isDesignToken", ()=>(0, _utilsMjs3.isDesignToken));
parcelHelpers.export(exports, "setupTokens", ()=>(0, _utilsMjs3.setupTokens));
parcelHelpers.export(exports, "FederatedIdentityProviders", ()=>(0, _userMjs.FederatedIdentityProviders));
parcelHelpers.export(exports, "UnverifiedContactMethodType", ()=>(0, _userMjs.UnverifiedContactMethodType));
parcelHelpers.export(exports, "isUnverifiedContactMethodType", ()=>(0, _utilsMjs4.isUnverifiedContactMethodType));
parcelHelpers.export(exports, "LoginMechanismArray", ()=>(0, _attributesMjs.LoginMechanismArray));
parcelHelpers.export(exports, "authFieldsWithDefaults", ()=>(0, _attributesMjs.authFieldsWithDefaults));
parcelHelpers.export(exports, "isAuthFieldsWithDefaults", ()=>(0, _attributesMjs.isAuthFieldsWithDefaults));
parcelHelpers.export(exports, "signUpFieldsWithDefault", ()=>(0, _attributesMjs.signUpFieldsWithDefault));
parcelHelpers.export(exports, "signUpFieldsWithoutDefault", ()=>(0, _attributesMjs.signUpFieldsWithoutDefault));
parcelHelpers.export(exports, "ComponentClassName", ()=>(0, _componentClassNameMjs.ComponentClassName));
parcelHelpers.export(exports, "areEmptyArrays", ()=>(0, _indexMjs2.areEmptyArrays));
parcelHelpers.export(exports, "areEmptyObjects", ()=>(0, _indexMjs2.areEmptyObjects));
parcelHelpers.export(exports, "capitalize", ()=>(0, _indexMjs2.capitalize));
parcelHelpers.export(exports, "classNameModifier", ()=>(0, _indexMjs2.classNameModifier));
parcelHelpers.export(exports, "classNameModifierByFlag", ()=>(0, _indexMjs2.classNameModifierByFlag));
parcelHelpers.export(exports, "has", ()=>(0, _indexMjs2.has));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _indexMjs2.isEmpty));
parcelHelpers.export(exports, "isFunction", ()=>(0, _indexMjs2.isFunction));
parcelHelpers.export(exports, "isMap", ()=>(0, _indexMjs2.isMap));
parcelHelpers.export(exports, "isNil", ()=>(0, _indexMjs2.isNil));
parcelHelpers.export(exports, "isObject", ()=>(0, _indexMjs2.isObject));
parcelHelpers.export(exports, "isSet", ()=>(0, _indexMjs2.isSet));
parcelHelpers.export(exports, "isString", ()=>(0, _indexMjs2.isString));
parcelHelpers.export(exports, "isTypedFunction", ()=>(0, _indexMjs2.isTypedFunction));
parcelHelpers.export(exports, "isUndefined", ()=>(0, _indexMjs2.isUndefined));
parcelHelpers.export(exports, "noop", ()=>(0, _indexMjs2.noop));
parcelHelpers.export(exports, "sanitizeNamespaceImport", ()=>(0, _indexMjs2.sanitizeNamespaceImport));
parcelHelpers.export(exports, "templateJoin", ()=>(0, _indexMjs2.templateJoin));
var _actorMjs = require("./helpers/authenticator/actor.mjs");
var _contextMjs = require("./helpers/authenticator/context.mjs");
var _facadeMjs = require("./helpers/authenticator/facade.mjs");
var _constantsMjs = require("./helpers/authenticator/constants.mjs");
var _formMjs = require("./helpers/authenticator/form.mjs");
var _utilsMjs = require("./helpers/authenticator/utils.mjs");
var _formFieldsMjs = require("./helpers/authenticator/formFields/formFields.mjs");
var _defaultsMjs = require("./helpers/authenticator/formFields/defaults.mjs");
var _utilMjs = require("./helpers/authenticator/formFields/util.mjs");
var _textUtilMjs = require("./helpers/authenticator/textUtil.mjs");
var _utilsMjs1 = require("./helpers/accountSettings/utils.mjs");
var _validatorMjs = require("./helpers/accountSettings/validator.mjs");
var _uploaderMjs = require("./helpers/storage/fileUploader/utils/uploader.mjs");
var _utilsMjs2 = require("./helpers/utils.mjs");
var _countryDialCodesMjs = require("./i18n/country-dial-codes.mjs");
var _translationsMjs = require("./i18n/translations.mjs");
var _indexMjs = require("./machines/authenticator/index.mjs");
var _createThemeMjs = require("./theme/createTheme.mjs");
var _defaultThemeMjs = require("./theme/defaultTheme.mjs");
var _defaultDarkModeOverrideMjs = require("./theme/defaultDarkModeOverride.mjs");
var _indexMjs1 = require("./theme/tokens/index.mjs");
var _utilsMjs3 = require("./theme/utils.mjs");
var _userMjs = require("./types/authenticator/user.mjs");
var _utilsMjs4 = require("./types/authenticator/utils.mjs");
var _attributesMjs = require("./types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("./types/primitives/componentClassName.mjs");
var _indexMjs2 = require("./utils/index.mjs");

},{"./helpers/authenticator/actor.mjs":"b1Die","./helpers/authenticator/context.mjs":"ksAim","./helpers/authenticator/facade.mjs":"8uYLM","./helpers/authenticator/constants.mjs":"ku5eE","./helpers/authenticator/form.mjs":"dVV3Q","./helpers/authenticator/utils.mjs":"l02QH","./helpers/authenticator/formFields/formFields.mjs":"1FkDX","./helpers/authenticator/formFields/defaults.mjs":"a6cbS","./helpers/authenticator/formFields/util.mjs":"cvLf4","./helpers/authenticator/textUtil.mjs":"c4Omk","./helpers/accountSettings/utils.mjs":"2PkvP","./helpers/accountSettings/validator.mjs":"k9HMx","./helpers/storage/fileUploader/utils/uploader.mjs":"3vEul","./helpers/utils.mjs":"5hKBo","./i18n/country-dial-codes.mjs":"afTXN","./i18n/translations.mjs":"jSmFc","./machines/authenticator/index.mjs":"gBWIb","./theme/createTheme.mjs":"9hjHj","./theme/defaultTheme.mjs":"fwsDH","./theme/defaultDarkModeOverride.mjs":"jZIGj","./theme/tokens/index.mjs":"11JYE","./theme/utils.mjs":"7CFl2","./types/authenticator/user.mjs":"aZbQw","./types/authenticator/utils.mjs":"jcjxO","./types/authenticator/attributes.mjs":"2ngIN","./types/primitives/componentClassName.mjs":"62ykl","./utils/index.mjs":"a3Yxt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b1Die":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActorContext", ()=>o);
parcelHelpers.export(exports, "getActorState", ()=>t);
const t = (t)=>{
    var o;
    return null === (o = t.context.actorRef) || void 0 === o ? void 0 : o.getSnapshot();
}, o = (o)=>{
    var n;
    return null === (n = t(o)) || void 0 === n ? void 0 : n.context;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ksAim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getConfiguredAliases", ()=>s);
parcelHelpers.export(exports, "getPrimaryAlias", ()=>i);
var _userMjs = require("../../types/authenticator/user.mjs");
var _attributesMjs = require("../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../types/primitives/componentClassName.mjs");
const i = (t)=>{
    var i;
    const s = null === (i = null == t ? void 0 : t.context.config) || void 0 === i ? void 0 : i.loginMechanisms, [n] = null != s ? s : [
        "username"
    ];
    return n;
}, s = (i)=>{
    var s;
    const n = (null === (s = i.config) || void 0 === s ? void 0 : s.loginMechanisms).filter((i)=>(0, _attributesMjs.LoginMechanismArray).includes(i)), [o, ...e] = n;
    return {
        primaryAlias: o,
        secondaryAliases: e
    };
};

},{"../../types/authenticator/user.mjs":"aZbQw","../../types/authenticator/attributes.mjs":"2ngIN","../../types/primitives/componentClassName.mjs":"62ykl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZbQw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FederatedIdentityProviders", ()=>o);
parcelHelpers.export(exports, "UnverifiedContactMethodType", ()=>e);
var o, e;
!function(o) {
    o.Apple = "SignInWithApple", o.Amazon = "LoginWithAmazon", o.Facebook = "Facebook", o.Google = "Google";
}(o || (o = {})), function(o) {
    o.Email = "email", o.PhoneNumber = "phone_number";
}(e || (e = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ngIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoginMechanismArray", ()=>a);
parcelHelpers.export(exports, "authFieldsWithDefaults", ()=>r);
parcelHelpers.export(exports, "isAuthFieldsWithDefaults", ()=>i);
parcelHelpers.export(exports, "signUpFieldsWithDefault", ()=>e);
parcelHelpers.export(exports, "signUpFieldsWithoutDefault", ()=>n);
const e = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
], n = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
], a = [
    "username",
    "email",
    "phone_number"
], r = [
    ...a,
    ...e,
    "confirmation_code",
    "password",
    "confirm_password"
], i = (e)=>r.includes(e);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"62ykl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentClassName", ()=>e);
var e;
!function(e) {
    e.Alert = "amplify-alert", e.AlertIcon = "amplify-alert__icon", e.AlertHeading = "amplify-alert__heading", e.AlertBody = "amplify-alert__body", e.AlertDismiss = "amplify-alert__dismiss", e.Autocomplete = "amplify-autocomplete", e.AutocompleteMenu = "amplify-autocomplete__menu", e.AutocompleteMenuEmpty = "amplify-autocomplete__menu--empty", e.AutocompleteMenuFooter = "amplify-autocomplete__menu__footer", e.AutocompleteMenuHeader = "amplify-autocomplete__menu__header", e.AutocompleteMenuLoading = "amplify-autocomplete__menu--loading", e.AutocompleteMenuOption = "amplify-autocomplete__menu__option", e.AutocompleteMenuOptions = "amplify-autocomplete__menu__options", e.Badge = "amplify-badge", e.Breadcrumbs = "amplify-breadcrumbs", e.BreadcrumbsList = "amplify-breadcrumbs__list", e.BreadcrumbsItem = "amplify-breadcrumbs__item", e.BreadcrumbsSeparator = "amplify-breadcrumbs__separator", e.BreadcrumbsLink = "amplify-breadcrumbs__link", e.Button = "amplify-button", e.ButtonGroup = "amplify-buttongroup", e.ButtonLoaderWrapper = "amplify-button__loader-wrapper", e.Card = "amplify-card", e.Checkbox = "amplify-checkbox", e.CheckboxButton = "amplify-checkbox__button", e.CheckboxIcon = "amplify-checkbox__icon", e.CheckboxInput = "amplify-checkbox__input", e.CheckboxLabel = "amplify-checkbox__label", e.CheckboxField = "amplify-checkboxfield", e.Collection = "amplify-collection", e.CollectionItems = "amplify-collection-items", e.CollectionSearch = "amplify-collection-search", e.CollectionPagination = "amplify-collection-pagination", e.CountryCodeSelect = "amplify-countrycodeselect", e.DialCodeSelect = "amplify-dialcodeselect", e.Divider = "amplify-divider", e.DividerLabel = "amplify-divider--label", e.DropZone = "amplify-dropzone", e.Expander = "amplify-expander", e.ExpanderContent = "amplify-expander__content", e.ExpanderContentText = "amplify-expander__content__text", e.ExpanderHeader = "amplify-expander__header", e.ExpanderIcon = "amplify-expander__icon", e.ExpanderItem = "amplify-expander__item", e.ExpanderTrigger = "amplify-expander__trigger", e.Field = "amplify-field", e.FieldDescription = "amplify-field__description", e.FieldErrorMessage = "amplify-field__error-message", e.FieldGroup = "amplify-field-group", e.FieldGroupControl = "amplify-field-group__control", e.FieldGroupOuterEnd = "amplify-field-group__outer-end", e.FieldGroupOuterStart = "amplify-field-group__outer-start", e.FieldGroupInnerEnd = "amplify-field-group__inner-end", e.FieldGroupInnerStart = "amplify-field-group__inner-start", e.FieldGroupIcon = "amplify-field-group__icon", e.FieldGroupIconButton = "amplify-field-group__icon-button", e.FieldGroupHasInnerEnd = "amplify-field-group--has-inner-end", e.FieldGroupHasInnerStart = "amplify-field-group--has-inner-start", e.FieldShowPassword = "amplify-field__show-password", e.FieldGroupFieldWrapper = "amplify-field-group__field-wrapper", e.Fieldset = "amplify-fieldset", e.FieldsetLegend = "amplify-fieldset__legend", e.FileUploaderDropZone = "amplify-fileuploader__dropzone", e.FileUploaderDropZoneIcon = "amplify-fileuploader__dropzone__icon", e.FileUploaderDropZoneText = "amplify-fileuploader__dropzone__text", e.FileUploaderDropZoneButton = "amplify-fileuploader__dropzone__button", e.FileUploaderFile = "amplify-fileuploader__file", e.FileUploaderFileWrapper = "amplify-fileuploader__file__wrapper", e.FileUploaderFileName = "amplify-fileuploader__file__name", e.FileUploaderFileSize = "amplify-fileuploader__file__size", e.FileUploaderFileInfo = "amplify-fileuploader__file__info", e.FileUploaderFileImage = "amplify-fileuploader__file__image", e.FileUploaderFileMain = "amplify-fileuploader__file__main", e.FileUploaderFileStatus = "amplify-fileuploader__file__status", e.FileUploaderLoader = "amplify-fileuploader__loader", e.FileUploaderPreviewer = "amplify-fileuploader__previewer", e.FileUploaderPreviewerText = "amplify-fileuploader__previewer__text", e.FileUploaderPreviewerBody = "amplify-fileuploader__previewer__body", e.FileUploaderPreviewerFooter = "amplify-fileuploader__previewer__footer", e.FileUploaderPreviewerFooterActions = "amplify-fileuploader__previewer__footer__actions", e.Flex = "amplify-flex", e.Grid = "amplify-grid", e.Heading = "amplify-heading", e.HighlightMatch = "amplify-highlightmatch", e.HighlightMatchHighlighted = "amplify-highlightmatch__highlighted", e.Icon = "amplify-icon", e.Image = "amplify-image", e.Input = "amplify-input", e.Label = "amplify-label", e.Link = "amplify-link", e.Loader = "amplify-loader", e.LoaderDeterminate = "amplify-loader--determinate", e.LoaderPercentageText = "amplify-loader__percentage-text", e.MenuContent = "amplify-menu-content", e.MenuContentWrapper = "amplify-menu-content-wrapper", e.MenuItem = "amplify-menu-content__item", e.MenuTrigger = "amplify-menu-trigger", e.Message = "amplify-message", e.MessageIcon = "amplify-message__icon", e.MessageHeading = "amplify-message__heading", e.MessageBody = "amplify-message__body", e.MessageContent = "amplify-message__content", e.MessageDismiss = "amplify-message__dismiss", e.Pagination = "amplify-pagination", e.PaginationItemButton = "amplify-pagination__item-button", e.PaginationItemCurrent = "amplify-pagination__item-current", e.PaginationItemEllipsis = "amplify-pagination__item-ellipsis", e.PasswordField = "amplify-passwordfield", e.PhoneNumberField = "amplify-phonenumberfield", e.Placeholder = "amplify-placeholder", e.Radio = "amplify-radio", e.RadioButton = "amplify-radio__button", e.RadioInput = "amplify-radio__input", e.RadioLabel = "amplify-radio__label", e.RadioGroupField = "amplify-radiogroupfield", e.RadioGroup = "amplify-radiogroup", e.Rating = "amplify-rating", e.ScrollView = "amplify-scrollview", e.SearchField = "amplify-searchfield", e.SearchFieldClear = "amplify-searchfield__clear", e.SearchFieldSearch = "amplify-searchfield__search", e.Select = "amplify-select", e.SelectField = "amplify-selectfield", e.SelectWrapper = "amplify-select__wrapper", e.SelectIconWrapper = "amplify-select__icon-wrapper", e.SliderField = "amplify-sliderfield", e.SliderFieldGroup = "amplify-sliderfield__group", e.SliderFieldLabel = "amplify-sliderfield__label", e.SliderFieldRange = "amplify-sliderfield__range", e.SliderFieldRoot = "amplify-sliderfield__root", e.SliderFieldThumb = "amplify-sliderfield__thumb", e.SliderFieldTrack = "amplify-sliderfield__track", e.StepperField = "amplify-stepperfield", e.StepperFieldButtonDecrease = "amplify-stepperfield__button--decrease", e.StepperFieldButtonIncrease = "amplify-stepperfield__button--increase", e.StepperFieldInput = "amplify-stepperfield__input", e.StorageImage = "amplify-storageimage", e.StorageManager = "amplify-storagemanager", e.StorageManagerDropZone = "amplify-storagemanager__dropzone", e.StorageManagerDropZoneIcon = "amplify-storagemanager__dropzone__icon", e.StorageManagerDropZoneText = "amplify-storagemanager__dropzone__text", e.StorageManagerFilePicker = "amplify-storagemanager__file__picker", e.StorageManagerFile = "amplify-storagemanager__file", e.StorageManagerFileWrapper = "amplify-storagemanager__file__wrapper", e.StorageManagerFileList = "amplify-storagemanager__file__list", e.StorageManagerFileName = "amplify-storagemanager__file__name", e.StorageManagerFileSize = "amplify-storagemanager__file__size", e.StorageManagerFileInfo = "amplify-storagemanager__file__info", e.StorageManagerFileImage = "amplify-storagemanager__file__image", e.StorageManagerFileMain = "amplify-storagemanager__file__main", e.StorageManagerFileStatus = "amplify-storagemanager__file__status", e.StorageManagerLoader = "amplify-storagemanager__loader", e.StorageManagerPreviewer = "amplify-storagemanager__previewer", e.StorageManagerPreviewerText = "amplify-storagemanager__previewer__text", e.StorageManagerPreviewerActions = "amplify-storagemanager__previewer__actions", e.StorageManagerPreviewerFooter = "amplify-storagemanager__previewer__footer", e.SwitchField = "amplify-switchfield", e.SwitchLabel = "amplify-switch-label", e.SwitchThumb = "amplify-switch-thumb", e.SwitchTrack = "amplify-switch-track", e.SwitchWrapper = "amplify-switch__wrapper", e.Table = "amplify-table", e.TableCaption = "amplify-table__caption", e.TableBody = "amplify-table__body", e.TableTd = "amplify-table__td", e.TableTh = "amplify-table__th", e.TableFoot = "amplify-table__foot", e.TableHead = "amplify-table__head", e.TableRow = "amplify-table__row", e.Tabs = "amplify-tabs", e.TabItems = "amplify-tabs-item", e.Text = "amplify-text", e.Textarea = "amplify-textarea", e.TextAreaField = "amplify-textareafield", e.TextField = "amplify-textfield", e.ToggleButton = "amplify-togglebutton", e.ToggleButtonGroup = "amplify-togglebuttongroup", e.VisuallyHidden = "amplify-visually-hidden";
}(e || (e = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uYLM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSendEventAliases", ()=>r);
parcelHelpers.export(exports, "getServiceContextFacade", ()=>n);
parcelHelpers.export(exports, "getServiceFacade", ()=>s);
var _actorMjs = require("./actor.mjs");
const r = (e)=>{
    const t = (t)=>(r)=>e({
                type: t,
                data: r
            });
    return {
        initializeMachine: t("INIT"),
        resendCode: t("RESEND"),
        signOut: t("SIGN_OUT"),
        submitForm: t("SUBMIT"),
        updateForm: t("CHANGE"),
        updateBlur: t("BLUR"),
        toFederatedSignIn: t("FEDERATED_SIGN_IN"),
        toResetPassword: t("RESET_PASSWORD"),
        toSignIn: t("SIGN_IN"),
        toSignUp: t("SIGN_UP"),
        skipVerification: t("SKIP")
    };
}, n = (r)=>{
    var n, s, i, a, o;
    const c = null !== (n = (0, _actorMjs.getActorContext)(r)) && void 0 !== n ? n : {}, { codeDeliveryDetails: u, remoteError: d, unverifiedContactMethods: l, validationError: m, totpSecretCode: h = null } = c, { socialProviders: v } = null !== (i = null === (s = r.context) || void 0 === s ? void 0 : s.config) && void 0 !== i ? i : {}, g = null !== (a = null == c ? void 0 : c.user) && void 0 !== a ? a : null === (o = r.context) || void 0 === o ? void 0 : o.user, f = m && Object.keys(m).length > 0, p = (0, _actorMjs.getActorState)(r), S = r.hasTag("pending") || (null == p ? void 0 : p.hasTag("pending")), I = (()=>{
        switch(!0){
            case r.matches("idle"):
                return "idle";
            case r.matches("setup"):
                return "setup";
            case r.matches("signOut"):
                return "signOut";
            case r.matches("authenticated"):
                return "authenticated";
            case null == p ? void 0 : p.matches("confirmSignUp"):
                return "confirmSignUp";
            case null == p ? void 0 : p.matches("confirmSignIn"):
                return "confirmSignIn";
            case null == p ? void 0 : p.matches("setupTOTP.edit"):
            case null == p ? void 0 : p.matches("setupTOTP.submit"):
                return "setupTOTP";
            case null == p ? void 0 : p.matches("signIn"):
                return "signIn";
            case null == p ? void 0 : p.matches("signUp"):
                return "signUp";
            case null == p ? void 0 : p.matches("forceNewPassword"):
                return "forceNewPassword";
            case null == p ? void 0 : p.matches("resetPassword"):
                return "resetPassword";
            case null == p ? void 0 : p.matches("confirmResetPassword"):
                return "confirmResetPassword";
            case null == p ? void 0 : p.matches("verifyUser"):
                return "verifyUser";
            case null == p ? void 0 : p.matches("confirmVerifyUser"):
                return "confirmVerifyUser";
            case null == p ? void 0 : p.matches("setupTOTP.getTotpSecretCode"):
            case r.matches("signIn.runActor"):
                return "transition";
            default:
                return console.debug("Cannot infer `route` from Authenticator state:", r.value), null;
        }
    })(), P = ((e)=>{
        switch(e){
            case "idle":
            case "setup":
                return "configuring";
            case "authenticated":
                return "authenticated";
            default:
                return "unauthenticated";
        }
    })(I);
    return {
        authStatus: P,
        codeDeliveryDetails: u,
        error: d,
        hasValidationErrors: f,
        isPending: S,
        route: I,
        socialProviders: v,
        totpSecretCode: h,
        unverifiedContactMethods: l,
        user: g,
        validationErrors: m
    };
}, s = ({ send: e, state: t })=>{
    const s = r(e), i = n(t);
    return Object.assign(Object.assign({}, s), i);
};

},{"./actor.mjs":"b1Die","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ku5eE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALLOWED_SPECIAL_CHARACTERS", ()=>r);
parcelHelpers.export(exports, "defaultFormFieldOptions", ()=>a);
parcelHelpers.export(exports, "emailRegex", ()=>l);
var _countryDialCodesMjs = require("../../i18n/country-dial-codes.mjs");
var _translationsMjs = require("../../i18n/translations.mjs");
const a = {
    birthdate: {
        label: "Birthdate",
        placeholder: "Enter your Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: !0
    },
    confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code",
        type: "number",
        autocomplete: "one-time-code",
        isRequired: !0
    },
    confirm_password: {
        label: "Confirm Password",
        placeholder: "Please confirm your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    email: {
        label: "Email",
        placeholder: "Enter your Email",
        type: "email",
        autocomplete: "username",
        isRequired: !0
    },
    family_name: {
        label: "Family Name",
        placeholder: "Enter your Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: !0
    },
    given_name: {
        label: "Given Name",
        placeholder: "Enter your Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: !0
    },
    middle_name: {
        label: "Middle Name",
        placeholder: "Enter your Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: !0
    },
    name: {
        label: "Name",
        placeholder: "Enter your Name",
        type: "text",
        autocomplete: "name",
        isRequired: !0
    },
    nickname: {
        label: "Nickname",
        placeholder: "Enter your Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: !0
    },
    password: {
        label: "Password",
        placeholder: "Enter your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: !0
    },
    phone_number: {
        label: "Phone Number",
        placeholder: "Enter your Phone Number",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, _countryDialCodesMjs.countryDialCodes),
        isRequired: !0
    },
    preferred_username: {
        label: "Preferred Username",
        placeholder: "Enter your Preferred Username",
        type: "text",
        isRequired: !0
    },
    profile: {
        label: "Profile",
        placeholder: "Add your Profile",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    website: {
        label: "Website",
        placeholder: "Add your Website",
        type: "url",
        autocomplete: "url",
        isRequired: !0
    },
    username: {
        label: "Username",
        placeholder: "Enter your Username",
        type: "text",
        autocomplete: "username",
        isRequired: !0
    }
}, r = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
], l = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

},{"../../i18n/country-dial-codes.mjs":"afTXN","../../i18n/translations.mjs":"jSmFc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"afTXN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "countryDialCodes", ()=>o);
const o = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jSmFc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTexts", ()=>x);
parcelHelpers.export(exports, "hasTranslation", ()=>w);
parcelHelpers.export(exports, "translate", ()=>v);
parcelHelpers.export(exports, "translations", ()=>y);
var _awsAmplify = require("aws-amplify");
var _indexMjs = require("./dictionaries/index.mjs");
const x = Object.assign({}, (0, _indexMjs.defaultTexts));
function v(n) {
    return (0, _awsAmplify.I18n).get(n);
}
function w(n) {
    return (0, _awsAmplify.I18n).get(n) !== n;
}
const y = {
    de: (0, _indexMjs.deDict),
    en: (0, _indexMjs.enDict),
    es: (0, _indexMjs.esDict),
    fr: (0, _indexMjs.frDict),
    id: (0, _indexMjs.idDict),
    it: (0, _indexMjs.itDict),
    ja: (0, _indexMjs.jaDict),
    kr: (0, _indexMjs.krDict),
    ko: (0, _indexMjs.krDict),
    nb: (0, _indexMjs.nbDict),
    nl: (0, _indexMjs.nlDict),
    pl: (0, _indexMjs.plDict),
    pt: (0, _indexMjs.ptDict),
    zh: (0, _indexMjs.zhDict),
    sv: (0, _indexMjs.svDict),
    tr: (0, _indexMjs.trDict),
    ru: (0, _indexMjs.ruDict),
    he: (0, _indexMjs.heDict),
    ua: (0, _indexMjs.uaDict)
};

},{"aws-amplify":"75VoS","./dictionaries/index.mjs":"3IhSv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75VoS":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", ()=>(0, _core.Amplify));
parcelHelpers.export(exports, "Analytics", ()=>(0, _analytics.Analytics));
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _analytics.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _analytics.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _analytics.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _analytics.AmazonPersonalizeProvider));
parcelHelpers.export(exports, "Auth", ()=>(0, _auth.Auth));
parcelHelpers.export(exports, "Storage", ()=>(0, _storage.Storage));
parcelHelpers.export(exports, "StorageClass", ()=>(0, _storage.StorageClass));
parcelHelpers.export(exports, "API", ()=>(0, _api.API));
parcelHelpers.export(exports, "APIClass", ()=>(0, _api.APIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _api.graphqlOperation));
parcelHelpers.export(exports, "AuthModeStrategyType", ()=>(0, _datastore.AuthModeStrategyType));
parcelHelpers.export(exports, "DataStore", ()=>(0, _datastore.DataStore));
parcelHelpers.export(exports, "Predicates", ()=>(0, _datastore.Predicates));
parcelHelpers.export(exports, "SortDirection", ()=>(0, _datastore.SortDirection));
parcelHelpers.export(exports, "syncExpression", ()=>(0, _datastore.syncExpression));
parcelHelpers.export(exports, "PubSub", ()=>(0, _pubsub.PubSub));
parcelHelpers.export(exports, "Cache", ()=>(0, _cache.Cache));
parcelHelpers.export(exports, "Interactions", ()=>(0, _interactions.Interactions));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notifications.Notifications));
parcelHelpers.export(exports, "Predictions", ()=>(0, _predictions.Predictions));
parcelHelpers.export(exports, "Logger", ()=>(0, _core.ConsoleLogger));
parcelHelpers.export(exports, "Hub", ()=>(0, _core.Hub));
parcelHelpers.export(exports, "ClientDevice", ()=>(0, _core.ClientDevice));
parcelHelpers.export(exports, "Signer", ()=>(0, _core.Signer));
parcelHelpers.export(exports, "I18n", ()=>(0, _core.I18n));
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _core.ServiceWorker));
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _core.AWSCloudWatchProvider));
parcelHelpers.export(exports, "withSSRContext", ()=>(0, _withSSRContext.withSSRContext));
parcelHelpers.export(exports, "Geo", ()=>(0, _geo.Geo));
var _core = require("@aws-amplify/core");
var _analytics = require("@aws-amplify/analytics");
var _auth = require("@aws-amplify/auth");
var _storage = require("@aws-amplify/storage");
var _api = require("@aws-amplify/api");
var _datastore = require("@aws-amplify/datastore");
var _pubsub = require("@aws-amplify/pubsub");
var _cache = require("@aws-amplify/cache");
var _interactions = require("@aws-amplify/interactions");
var _notifications = require("@aws-amplify/notifications");
var _predictions = require("@aws-amplify/predictions");
var _withSSRContext = require("./withSSRContext");
var _geo = require("@aws-amplify/geo");

},{"@aws-amplify/core":"3rlh1","@aws-amplify/analytics":"4FqWo","@aws-amplify/auth":"ilv20","@aws-amplify/storage":"dt8H8","@aws-amplify/api":"6PDaW","@aws-amplify/datastore":"fPd7W","@aws-amplify/pubsub":"bJVAp","@aws-amplify/cache":"hVdVQ","@aws-amplify/interactions":"lH2Zb","@aws-amplify/notifications":"29fbL","@aws-amplify/predictions":"lJ5pk","./withSSRContext":"dqyLX","@aws-amplify/geo":"3VEgf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rlh1":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Amplify", ()=>(0, _amplify.Amplify));
parcelHelpers.export(exports, "AmplifyClass", ()=>(0, _amplify.AmplifyClass));
parcelHelpers.export(exports, "ClientDevice", ()=>(0, _clientDevice.ClientDevice));
parcelHelpers.export(exports, "ConsoleLogger", ()=>(0, _logger.ConsoleLogger));
parcelHelpers.export(exports, "Logger", ()=>(0, _logger.ConsoleLogger));
parcelHelpers.export(exports, "invalidParameter", ()=>(0, _errors.invalidParameter));
parcelHelpers.export(exports, "missingConfig", ()=>(0, _errors.missingConfig));
parcelHelpers.export(exports, "Hub", ()=>(0, _hub.Hub));
parcelHelpers.export(exports, "I18n", ()=>(0, _i18N.I18n));
parcelHelpers.export(exports, "browserOrNode", ()=>(0, _js.browserOrNode));
parcelHelpers.export(exports, "filenameToContentType", ()=>(0, _js.filenameToContentType));
parcelHelpers.export(exports, "generateRandomString", ()=>(0, _js.generateRandomString));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _js.isEmpty));
parcelHelpers.export(exports, "isStrictObject", ()=>(0, _js.isStrictObject));
parcelHelpers.export(exports, "isTextFile", ()=>(0, _js.isTextFile));
parcelHelpers.export(exports, "isWebWorker", ()=>(0, _js.isWebWorker));
parcelHelpers.export(exports, "makeQuerablePromise", ()=>(0, _js.makeQuerablePromise));
parcelHelpers.export(exports, "objectLessAttributes", ()=>(0, _js.objectLessAttributes));
parcelHelpers.export(exports, "sortByField", ()=>(0, _js.sortByField));
parcelHelpers.export(exports, "transferKeyToLowerCase", ()=>(0, _js.transferKeyToLowerCase));
parcelHelpers.export(exports, "transferKeyToUpperCase", ()=>(0, _js.transferKeyToUpperCase));
parcelHelpers.export(exports, "Signer", ()=>(0, _signer.Signer));
parcelHelpers.export(exports, "parseAWSExports", ()=>(0, _parseAWSExports.parseAWSExports));
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _providers.AWSCloudWatchProvider));
parcelHelpers.export(exports, "FacebookOAuth", ()=>(0, _oauthHelper.FacebookOAuth));
parcelHelpers.export(exports, "GoogleOAuth", ()=>(0, _oauthHelper.GoogleOAuth));
parcelHelpers.export(exports, "AppState", ()=>(0, _rncomponents.AppState));
parcelHelpers.export(exports, "AsyncStorage", ()=>(0, _rncomponents.AsyncStorage));
parcelHelpers.export(exports, "Linking", ()=>(0, _rncomponents.Linking));
parcelHelpers.export(exports, "Credentials", ()=>(0, _credentials.Credentials));
parcelHelpers.export(exports, "CredentialsClass", ()=>(0, _credentials.CredentialsClass));
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _serviceWorker.ServiceWorker));
parcelHelpers.export(exports, "StorageHelper", ()=>(0, _storageHelper.StorageHelper));
parcelHelpers.export(exports, "MemoryStorage", ()=>(0, _storageHelper.MemoryStorage));
parcelHelpers.export(exports, "UniversalStorage", ()=>(0, _universalStorage.UniversalStorage));
parcelHelpers.export(exports, "Platform", ()=>(0, _platform.Platform));
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>(0, _platform.getAmplifyUserAgentObject));
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>(0, _platform.getAmplifyUserAgent));
parcelHelpers.export(exports, "ApiAction", ()=>(0, _types.ApiAction));
parcelHelpers.export(exports, "AuthAction", ()=>(0, _types.AuthAction));
parcelHelpers.export(exports, "AnalyticsAction", ()=>(0, _types.AnalyticsAction));
parcelHelpers.export(exports, "Category", ()=>(0, _types.Category));
parcelHelpers.export(exports, "DataStoreAction", ()=>(0, _types.DataStoreAction));
parcelHelpers.export(exports, "Framework", ()=>(0, _types.Framework));
parcelHelpers.export(exports, "GeoAction", ()=>(0, _types.GeoAction));
parcelHelpers.export(exports, "InteractionsAction", ()=>(0, _types.InteractionsAction));
parcelHelpers.export(exports, "InAppMessagingAction", ()=>(0, _types.InAppMessagingAction));
parcelHelpers.export(exports, "PredictionsAction", ()=>(0, _types.PredictionsAction));
parcelHelpers.export(exports, "PubSubAction", ()=>(0, _types.PubSubAction));
parcelHelpers.export(exports, "PushNotificationAction", ()=>(0, _types.PushNotificationAction));
parcelHelpers.export(exports, "StorageAction", ()=>(0, _types.StorageAction));
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", ()=>(0, _constants.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER));
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>(0, _constants.USER_AGENT_HEADER));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_BASE_BUFFER_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>(0, _util.AWS_CLOUDWATCH_CATEGORY));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>(0, _util.AWS_CLOUDWATCH_MAX_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>(0, _util.AWS_CLOUDWATCH_PROVIDER_NAME));
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>(0, _util.BackgroundManagerNotOpenError));
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>(0, _util.BackgroundProcessManager));
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>(0, _util.BackgroundProcessManagerState));
parcelHelpers.export(exports, "DateUtils", ()=>(0, _util.DateUtils));
parcelHelpers.export(exports, "Mutex", ()=>(0, _util.Mutex));
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>(0, _util.NO_CREDS_ERROR_STRING));
parcelHelpers.export(exports, "NonRetryableError", ()=>(0, _util.NonRetryableError));
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>(0, _util.RETRY_ERROR_CODES));
parcelHelpers.export(exports, "Reachability", ()=>(0, _util.Reachability));
parcelHelpers.export(exports, "isNonRetryableError", ()=>(0, _util.isNonRetryableError));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _util.jitteredBackoff));
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>(0, _util.jitteredExponentialRetry));
parcelHelpers.export(exports, "retry", ()=>(0, _util.retry));
parcelHelpers.export(exports, "urlSafeDecode", ()=>(0, _util.urlSafeDecode));
parcelHelpers.export(exports, "urlSafeEncode", ()=>(0, _util.urlSafeEncode));
parcelHelpers.export(exports, "Constants", ()=>Constants);
var _amplify = require("./Amplify");
var _platform = require("./Platform");
var _clientDevice = require("./ClientDevice");
var _logger = require("./Logger");
var _errors = require("./Errors");
var _hub = require("./Hub");
var _i18N = require("./I18n");
var _js = require("./JS");
var _signer = require("./Signer");
var _parseAWSExports = require("./parseAWSExports");
var _providers = require("./Providers");
var _oauthHelper = require("./OAuthHelper");
var _rncomponents = require("./RNComponents");
var _credentials = require("./Credentials");
var _serviceWorker = require("./ServiceWorker");
var _storageHelper = require("./StorageHelper");
var _universalStorage = require("./UniversalStorage");
var _types = require("./Platform/types");
var _constants = require("./constants");
var _util = require("./Util");
var Constants = {
    userAgent: (0, _platform.Platform).userAgent
};
/**
 * @deprecated use named import
 */ exports.default = (0, _amplify.Amplify);

},{"./Amplify":"fr4N4","./Platform":"jNyBX","./ClientDevice":"580p9","./Logger":"jVGZ5","./Errors":false,"./Hub":"5RtWX","./I18n":"hwXvC","./JS":"58R8D","./Signer":"byego","./parseAWSExports":"jNxFP","./Providers":"aPXfS","./OAuthHelper":false,"./RNComponents":false,"./Credentials":"knFIj","./ServiceWorker":"kspiO","./StorageHelper":"5ekFt","./UniversalStorage":"8JhHm","./Platform/types":"jomcL","./constants":"jxe0I","./Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fr4N4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyClass", ()=>AmplifyClass);
parcelHelpers.export(exports, "Amplify", ()=>Amplify);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _logger.ConsoleLogger)("Amplify");
var AmplifyClass = /** @class */ function() {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Geo = null;
        this.Notifications = null;
        this.Logger = (0, _logger.ConsoleLogger);
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function(comp) {
        logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        } else logger.debug("no getModuleName method for component", comp);
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        logger.debug("amplify config", this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function(_a) {
            var _b = __read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function(property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) comp[property] = _this._modules[property];
            });
        });
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    return AmplifyClass;
}();
var Amplify = new AmplifyClass();

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jVGZ5":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsoleLogger", ()=>(0, _consoleLogger.ConsoleLogger));
parcelHelpers.export(exports, "LOG_TYPE", ()=>(0, _consoleLogger.LOG_TYPE));
var _consoleLogger = require("./ConsoleLogger");

},{"./ConsoleLogger":"dY8EL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dY8EL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOG_TYPE", ()=>LOG_TYPE);
parcelHelpers.export(exports, "ConsoleLogger", ()=>ConsoleLogger);
var _constants = require("../Util/Constants");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
var LOG_TYPE;
(function(LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})(LOG_TYPE || (LOG_TYPE = {}));
var ConsoleLogger = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = LOG_TYPE.WARN;
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    ConsoleLogger.prototype.configure = function(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var e_1, _a;
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = LOG_LEVELS[logger_level_name];
        var type_level = LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === LOG_TYPE.ERROR && console.error) log = console.error.bind(console);
        if (type === LOG_TYPE.WARN && console.warn) log = console.warn.bind(console);
        var prefix = "[".concat(type, "] ").concat(this._ts(), " ").concat(this.name);
        var message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = "".concat(prefix, " - ").concat(msg[0]);
            log(message);
        } else if (msg.length === 1) {
            message = "".concat(prefix, " ").concat(msg[0]);
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = "".concat(prefix, " - ").concat(msg[0], " ").concat(obj);
            log("".concat(prefix, " - ").concat(msg[0]), obj);
        } else {
            message = "".concat(prefix, " ").concat(msg);
            log(prefix, msg);
        }
        try {
            for(var _b = __values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()){
                var plugin = _c.value;
                var logEvent = {
                    message: message,
                    timestamp: Date.now()
                };
                plugin.pushLogs([
                    logEvent
                ]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.INFO
        ], __read(msg), false));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.WARN
        ], __read(msg), false));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.ERROR
        ], __read(msg), false));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.DEBUG
        ], __read(msg), false));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, __spreadArray([
            LOG_TYPE.VERBOSE
        ], __read(msg), false));
    };
    ConsoleLogger.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, _constants.AWS_CLOUDWATCH_CATEGORY)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function() {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

},{"../Util/Constants":"4siXq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4siXq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>AWS_CLOUDWATCH_BASE_BUFFER_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>AWS_CLOUDWATCH_CATEGORY);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>AWS_CLOUDWATCH_MAX_EVENT_SIZE);
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>AWS_CLOUDWATCH_PROVIDER_NAME);
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>NO_CREDS_ERROR_STRING);
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>RETRY_ERROR_CODES);
var AWS_CLOUDWATCH_BASE_BUFFER_SIZE = 26;
var AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE = 1048576;
var AWS_CLOUDWATCH_MAX_EVENT_SIZE = 256000;
var AWS_CLOUDWATCH_CATEGORY = "Logging";
var AWS_CLOUDWATCH_PROVIDER_NAME = "AWSCloudWatch";
var NO_CREDS_ERROR_STRING = "No credentials";
var RETRY_ERROR_CODES = [
    "ResourceNotFoundException",
    "InvalidSequenceTokenException"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNyBX":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getAmplifyUserAgentObject", ()=>getAmplifyUserAgentObject);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
var _types = require("./types");
var _version = require("./version");
var _detectFramework = require("./detectFramework");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var BASE_USER_AGENT = "aws-amplify";
var PlatformBuilder = /** @class */ function() {
    function PlatformBuilder() {
        this.userAgent = "".concat(BASE_USER_AGENT, "/").concat((0, _version.version));
    }
    Object.defineProperty(PlatformBuilder.prototype, "framework", {
        get: function() {
            return (0, _detectFramework.detectFramework)();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlatformBuilder.prototype, "isReactNative", {
        get: function() {
            return this.framework === (0, _types.Framework).ReactNative || this.framework === (0, _types.Framework).Expo;
        },
        enumerable: false,
        configurable: true
    });
    PlatformBuilder.prototype.observeFrameworkChanges = function(fcn) {
        (0, _detectFramework.observeFrameworkChanges)(fcn);
    };
    return PlatformBuilder;
}();
var Platform = new PlatformBuilder();
var getAmplifyUserAgentObject = function(_a) {
    var _b = _a === void 0 ? {} : _a, category = _b.category, action = _b.action, framework = _b.framework;
    var userAgent = [
        [
            BASE_USER_AGENT,
            (0, _version.version)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, _detectFramework.detectFramework)()
    ]);
    return userAgent;
};
var getAmplifyUserAgent = function(customUserAgentDetails) {
    var userAgent = getAmplifyUserAgentObject(customUserAgentDetails);
    var userAgentString = userAgent.map(function(_a) {
        var _b = __read(_a, 2), agentKey = _b[0], agentValue = _b[1];
        return "".concat(agentKey, "/").concat(agentValue);
    }).join(" ");
    return userAgentString;
};

},{"./types":"jomcL","./version":"fBLLc","./detectFramework":"kTkOK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jomcL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Framework", ()=>Framework);
parcelHelpers.export(exports, "Category", ()=>Category);
parcelHelpers.export(exports, "AnalyticsAction", ()=>AnalyticsAction);
parcelHelpers.export(exports, "ApiAction", ()=>ApiAction);
parcelHelpers.export(exports, "AuthAction", ()=>AuthAction);
parcelHelpers.export(exports, "DataStoreAction", ()=>DataStoreAction);
parcelHelpers.export(exports, "GeoAction", ()=>GeoAction);
parcelHelpers.export(exports, "InAppMessagingAction", ()=>InAppMessagingAction);
parcelHelpers.export(exports, "InteractionsAction", ()=>InteractionsAction);
parcelHelpers.export(exports, "PredictionsAction", ()=>PredictionsAction);
parcelHelpers.export(exports, "PubSubAction", ()=>PubSubAction);
parcelHelpers.export(exports, "PushNotificationAction", ()=>PushNotificationAction);
parcelHelpers.export(exports, "StorageAction", ()=>StorageAction);
var Framework;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})(Framework || (Framework = {}));
var Category;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})(Category || (Category = {}));
var AnalyticsAction;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["UpdateEndpoint"] = "2";
})(AnalyticsAction || (AnalyticsAction = {}));
var ApiAction;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})(ApiAction || (ApiAction = {}));
var AuthAction;
(function(AuthAction) {
    // SignUp = '1',
    // ConfirmSignUp = '2',
    // ResendSignUp = '3',
    // SignIn = '4',
    // GetMFAOptions = '5',
    // GetPreferredMFA = '6',
    // SetPreferredMFA = '7',
    // DisableSMS = '8',
    // EnableSMS = '9',
    // SetupTOTP = '10',
    // VerifyTotpToken = '11',
    // ConfirmSignIn = '12',
    // CompleteNewPassword = '13',
    // SendCustomChallengeAnswer = '14',
    // DeleteUserAttributes = '15',
    // DeleteUser = '16',
    // UpdateUserAttributes = '17',
    // UserAttributes = '18',
    // CurrentUserPoolUser = '19',
    // CurrentAuthenticatedUser = '20',
    // CurrentSession = '21',
    // VerifyUserAttribute = '22',
    // VerifyUserAttributeSubmit = '23',
    // VerifyCurrentUserAttribute = '24',
    // VerifyCurrentUserAttributeSubmit = '25',
    // SignOut = '26',
    // ChangePassword = '27',
    // ForgotPassword = '28',
    // ForgotPasswordSubmit = '29',
    AuthAction["FederatedSignIn"] = "30";
// CurrentUserInfo = '31',
// RememberDevice = '32',
// ForgetDevice = '33',
// FetchDevices = '34',
})(AuthAction || (AuthAction = {}));
var DataStoreAction;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})(DataStoreAction || (DataStoreAction = {}));
var GeoAction;
(function(GeoAction) {
    GeoAction["None"] = "0";
})(GeoAction || (GeoAction = {}));
var InAppMessagingAction;
(function(InAppMessagingAction) {
    InAppMessagingAction["None"] = "0";
})(InAppMessagingAction || (InAppMessagingAction = {}));
var InteractionsAction;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})(InteractionsAction || (InteractionsAction = {}));
var PredictionsAction;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})(PredictionsAction || (PredictionsAction = {}));
var PubSubAction;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})(PubSubAction || (PubSubAction = {}));
var PushNotificationAction;
(function(PushNotificationAction) {
    PushNotificationAction["None"] = "0";
})(PushNotificationAction || (PushNotificationAction = {}));
var StorageAction;
(function(StorageAction) {
    StorageAction["Put"] = "1";
    StorageAction["Get"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
})(StorageAction || (StorageAction = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBLLc":[function(require,module,exports) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "5.3.16";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kTkOK":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameworkChangeObservers", ()=>frameworkChangeObservers);
parcelHelpers.export(exports, "detectFramework", ()=>detectFramework);
parcelHelpers.export(exports, "observeFrameworkChanges", ()=>observeFrameworkChanges);
parcelHelpers.export(exports, "clearCache", ()=>clearCache);
var _types = require("./types");
var _detection = require("./detection");
// We want to cache detection since the framework won't change
var frameworkCache;
var frameworkChangeObservers = [];
// Setup the detection reset tracking / timeout delays
var resetTriggered = false;
var SSR_RESET_TIMEOUT = 10; // ms
var WEB_RESET_TIMEOUT = 10; // ms
var PRIME_FRAMEWORK_DELAY = 1000; // ms
var detectFramework = function() {
    if (!frameworkCache) {
        frameworkCache = (0, _detection.detect)();
        if (resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while(frameworkChangeObservers.length)frameworkChangeObservers.pop()();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        frameworkChangeObservers.forEach(function(fcn) {
            return fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        resetTimeout((0, _types.Framework).ServerSideUnknown, SSR_RESET_TIMEOUT);
        resetTimeout((0, _types.Framework).WebUnknown, WEB_RESET_TIMEOUT);
    }
    return frameworkCache;
};
var observeFrameworkChanges = function(fcn) {
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if (resetTriggered) return;
    frameworkChangeObservers.push(fcn);
};
function clearCache() {
    frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function resetTimeout(framework, delay) {
    if (frameworkCache === framework && !resetTriggered) setTimeout(function() {
        clearCache();
        resetTriggered = true;
        setTimeout(detectFramework, PRIME_FRAMEWORK_DELAY);
    }, delay);
}

},{"./types":"jomcL","./detection":"hf2EC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hf2EC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detect", ()=>detect);
var _types = require("../types");
var _react = require("./React");
var _vue = require("./Vue");
var _svelte = require("./Svelte");
var _next = require("./Next");
var _nuxt = require("./Nuxt");
var _angular = require("./Angular");
var _reactNative = require("./ReactNative");
var _expo = require("./Expo");
var _web = require("./Web");
// These are in the order of detection where when both are detectable, the early Framework will be reported
var detectionMap = [
    // First, detect mobile
    {
        platform: (0, _types.Framework).Expo,
        detectionMethod: (0, _expo.expoDetect)
    },
    {
        platform: (0, _types.Framework).ReactNative,
        detectionMethod: (0, _reactNative.reactNativeDetect)
    },
    // Next, detect web frameworks
    {
        platform: (0, _types.Framework).NextJs,
        detectionMethod: (0, _next.nextWebDetect)
    },
    {
        platform: (0, _types.Framework).Nuxt,
        detectionMethod: (0, _nuxt.nuxtWebDetect)
    },
    {
        platform: (0, _types.Framework).Angular,
        detectionMethod: (0, _angular.angularWebDetect)
    },
    {
        platform: (0, _types.Framework).React,
        detectionMethod: (0, _react.reactWebDetect)
    },
    {
        platform: (0, _types.Framework).VueJs,
        detectionMethod: (0, _vue.vueWebDetect)
    },
    {
        platform: (0, _types.Framework).Svelte,
        detectionMethod: (0, _svelte.svelteWebDetect)
    },
    {
        platform: (0, _types.Framework).WebUnknown,
        detectionMethod: (0, _web.webDetect)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, _types.Framework).NextJsSSR,
        detectionMethod: (0, _next.nextSSRDetect)
    },
    {
        platform: (0, _types.Framework).NuxtSSR,
        detectionMethod: (0, _nuxt.nuxtSSRDetect)
    },
    {
        platform: (0, _types.Framework).ReactSSR,
        detectionMethod: (0, _react.reactSSRDetect)
    },
    {
        platform: (0, _types.Framework).VueJsSSR,
        detectionMethod: (0, _vue.vueSSRDetect)
    },
    {
        platform: (0, _types.Framework).AngularSSR,
        detectionMethod: (0, _angular.angularSSRDetect)
    },
    {
        platform: (0, _types.Framework).SvelteSSR,
        detectionMethod: (0, _svelte.svelteSSRDetect)
    }
];
function detect() {
    var _a;
    return ((_a = detectionMap.find(function(detectionEntry) {
        return detectionEntry.detectionMethod();
    })) === null || _a === void 0 ? void 0 : _a.platform) || (0, _types.Framework).ServerSideUnknown;
}

},{"../types":"jomcL","./React":"hbF7t","./Vue":"19gI0","./Svelte":"jCyCb","./Next":"5T7ZV","./Nuxt":"gzCwO","./Angular":"c7uZn","./ReactNative":"h4UrI","./Expo":"bXX26","./Web":"9Tuu9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hbF7t":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with react 18.2 - built using Vite
parcelHelpers.export(exports, "reactWebDetect", ()=>reactWebDetect);
parcelHelpers.export(exports, "reactSSRDetect", ()=>reactSSRDetect);
var _helpers = require("./helpers");
var process = require("76821670e4d57432");
function reactWebDetect() {
    var elementKeyPrefixedWithReact = function(key) {
        return key.startsWith("_react") || key.startsWith("__react");
    };
    var elementIsReactEnabled = function(element) {
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    var allElementsWithId = function() {
        return Array.from(document.querySelectorAll("[id]"));
    };
    return (0, _helpers.documentExists)() && allElementsWithId().some(elementIsReactEnabled);
}
function reactSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
        return key.includes("react");
    });
}

},{"76821670e4d57432":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4avz9":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"7lyme":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalExists", ()=>globalExists);
parcelHelpers.export(exports, "globalThisExists", ()=>globalThisExists);
parcelHelpers.export(exports, "windowExists", ()=>windowExists);
parcelHelpers.export(exports, "documentExists", ()=>documentExists);
parcelHelpers.export(exports, "processExists", ()=>processExists);
parcelHelpers.export(exports, "keyPrefixMatch", ()=>keyPrefixMatch);
var global = arguments[3];
var process = require("c86167827cfb2a42");
var globalExists = function() {
    return typeof global !== "undefined";
};
var globalThisExists = function() {
    return typeof globalThis !== "undefined";
};
var windowExists = function() {
    return typeof window !== "undefined";
};
var documentExists = function() {
    return typeof document !== "undefined";
};
var processExists = function() {
    return typeof process !== "undefined";
};
var keyPrefixMatch = function(object, prefix) {
    return !!Object.keys(object).find(function(key) {
        return key.startsWith(prefix);
    });
};

},{"c86167827cfb2a42":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"19gI0":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with vue 3.3.2
parcelHelpers.export(exports, "vueWebDetect", ()=>vueWebDetect);
parcelHelpers.export(exports, "vueSSRDetect", ()=>vueSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function vueWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, "__VUE");
}
function vueSSRDetect() {
    return (0, _helpers.globalExists)() && (0, _helpers.keyPrefixMatch)(global, "__VUE");
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jCyCb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with svelte 3.59
parcelHelpers.export(exports, "svelteWebDetect", ()=>svelteWebDetect);
parcelHelpers.export(exports, "svelteSSRDetect", ()=>svelteSSRDetect);
var _helpers = require("./helpers");
var process = require("138f303fa47701cc");
function svelteWebDetect() {
    return (0, _helpers.windowExists)() && (0, _helpers.keyPrefixMatch)(window, "__SVELTE");
}
function svelteSSRDetect() {
    return (0, _helpers.processExists)() && typeof process.env !== "undefined" && !!Object.keys(process.env).find(function(key) {
        return key.includes("svelte");
    });
}

},{"138f303fa47701cc":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5T7ZV":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with next 13.4 / react 18.2
parcelHelpers.export(exports, "nextWebDetect", ()=>nextWebDetect);
parcelHelpers.export(exports, "nextSSRDetect", ()=>nextSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function nextWebDetect() {
    // @ts-ignore
    return (0, _helpers.windowExists)() && window["next"] && typeof window["next"] === "object";
}
function nextSSRDetect() {
    return (0, _helpers.globalExists)() && ((0, _helpers.keyPrefixMatch)(global, "__next") || (0, _helpers.keyPrefixMatch)(global, "__NEXT"));
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gzCwO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with nuxt 2.15 / vue 2.7
parcelHelpers.export(exports, "nuxtWebDetect", ()=>nuxtWebDetect);
parcelHelpers.export(exports, "nuxtSSRDetect", ()=>nuxtSSRDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function nuxtWebDetect() {
    return (0, _helpers.windowExists)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function nuxtSSRDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global["__NUXT_PATHS__"] !== "undefined";
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c7uZn":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with @angular/core 16.0.0
parcelHelpers.export(exports, "angularWebDetect", ()=>angularWebDetect);
parcelHelpers.export(exports, "angularSSRDetect", ()=>angularSSRDetect);
var _helpers = require("./helpers");
var process = require("6c589ba30cc3d7d");
function angularWebDetect() {
    var angularVersionSetInDocument = Boolean((0, _helpers.documentExists)() && document.querySelector("[ng-version]"));
    var angularContentSetInWindow = Boolean(// @ts-ignore
    (0, _helpers.windowExists)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function angularSSRDetect() {
    var _a;
    return (0, _helpers.processExists)() && typeof process.env === "object" && ((_a = undefined, _a === void 0) ? void 0 : _a.startsWith("ng ")) || false;
}

},{"6c589ba30cc3d7d":"4avz9","./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h4UrI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactNativeDetect", ()=>reactNativeDetect);
function reactNativeDetect() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bXX26":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Tested with expo 48 / react-native 0.71.3
parcelHelpers.export(exports, "expoDetect", ()=>expoDetect);
var _helpers = require("./helpers");
var global = arguments[3];
function expoDetect() {
    // @ts-ignore
    return (0, _helpers.globalExists)() && typeof global["expo"] !== "undefined";
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Tuu9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webDetect", ()=>webDetect);
var _helpers = require("./helpers");
function webDetect() {
    return (0, _helpers.windowExists)();
}

},{"./helpers":"7lyme","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"580p9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDevice", ()=>ClientDevice);
var _browser = require("./browser");
var ClientDevice = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return (0, _browser.clientInfo)();
    };
    ClientDevice.dimension = function() {
        return (0, _browser.dimension)();
    };
    return ClientDevice;
}();

},{"./browser":"83cuF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"83cuF":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clientInfo", ()=>clientInfo);
parcelHelpers.export(exports, "dimension", ()=>dimension);
parcelHelpers.export(exports, "browserType", ()=>browserType);
var _logger = require("../Logger");
var logger = new (0, _logger.ConsoleLogger)("ClientDevice_Browser");
function clientInfo() {
    if (typeof window === "undefined") return {};
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === "undefined") {
        logger.warn("No window object available to get browser client info");
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        logger.warn("No navigator object available to get browser client info");
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = browserType(userAgent);
    var timezone = browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join("/"),
        language: language,
        timezone: timezone
    };
}
function dimension() {
    if (typeof window === "undefined") {
        logger.warn("No window object available to get browser client info");
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || "" : "";
}
function browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: "",
        version: ""
    };
}

},{"../Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RtWX":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HubClass", ()=>HubClass);
parcelHelpers.export(exports, "Hub", ()=>Hub);
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)("Hub");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var HubClass = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype._remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.patterns = __spreadArray([], __read(this.patterns.filter(function(x) {
                return x !== pattern_1;
            })), false);
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                logger.warn("No listeners for ".concat(channel));
                return;
            }
            this.listeners[channel] = __spreadArray([], __read(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            })), false);
        }
    };
    /**
     * @deprecated Instead of calling Hub.remove, call the result of Hub.listen.
     */ HubClass.prototype.remove = function(channel, listener) {
        this._remove(channel, listener);
    };
    /**
     * Used to send a Hub event.
     *
     * @param channel - The channel on which the event will be broadcast
     * @param payload - The HubPayload
     * @param source  - The source of the event; defaults to ''
     * @param ampSymbol - Symbol used to determine if the event is dispatched internally on a protected channel
     *
     */ HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) logger.warn("WARNING: ".concat(channel, " is protected and dispatching on it can have unintended consequences"));
        }
        var capsule = {
            channel: channel,
            payload: __assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            logger.error(e);
        }
    };
    /**
     * Used to listen for Hub events.
     *
     * @param channel - The channel on which to listen
     * @param callback - The callback to execute when an event is received on the specified channel
     * @param listenerName - The name of the listener; defaults to 'noname'
     * @returns A function which can be called to cancel the listener.
     *
     */ HubClass.prototype.listen = function(channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if (isLegacyCallback(callback)) {
            logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
        return function() {
            _this._remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            logger.debug("Dispatching to ".concat(channel, " with "), payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = __read(match), groups = _a.slice(1);
                    var dispatchingCapsule = __assign(__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
var Hub = new HubClass("__default__");

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwXvC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _i18N = require("./I18n");
var _logger = require("../Logger");
var _amplify = require("../Amplify");
var logger = new (0, _logger.ConsoleLogger)("I18n");
var _config = null;
var _i18n = null;
/**
 * Export I18n APIs
 */ var I18n = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        logger.debug("configure I18n");
        if (!config) return _config;
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        logger.debug("create I18n instance");
        if (_i18n) return;
        _i18n = new (0, _i18N.I18n)(_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return _i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return _i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!_i18n) _i18n = new (0, _i18N.I18n)(_config);
        return true;
    };
    return I18n;
}();
(0, _amplify.Amplify).register(I18n);

},{"./I18n":"kEkfq","../Logger":"jVGZ5","../Amplify":"fr4N4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kEkfq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18n", ()=>I18n);
var _logger = require("../Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)("I18n");
/**
 * Language transition class
 */ var I18n = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = __assign(__assign({}, lang_dict), vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

},{"../Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"58R8D":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "sortByField", ()=>sortByField);
parcelHelpers.export(exports, "objectLessAttributes", ()=>objectLessAttributes);
parcelHelpers.export(exports, "filenameToContentType", ()=>filenameToContentType);
parcelHelpers.export(exports, "isTextFile", ()=>isTextFile);
parcelHelpers.export(exports, "generateRandomString", ()=>generateRandomString);
parcelHelpers.export(exports, "makeQuerablePromise", ()=>makeQuerablePromise);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "browserOrNode", ()=>browserOrNode);
parcelHelpers.export(exports, "transferKeyToLowerCase", ()=>transferKeyToLowerCase);
parcelHelpers.export(exports, "transferKeyToUpperCase", ()=>transferKeyToUpperCase);
parcelHelpers.export(exports, "isStrictObject", ()=>isStrictObject);
var process = require("6dd1111aaf1faf9b");
var MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/apng",
        ext: "apng"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/x-icon",
        ext: "cur"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/jpeg",
        ext: "jfif"
    },
    {
        type: "image/jpeg",
        ext: "pjp"
    },
    {
        type: "image/jpeg",
        ext: "pjpeg"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/webp",
        ext: "webp"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var isEmpty = function(obj) {
    if (obj === void 0) obj = {};
    return Object.keys(obj).length === 0;
};
var sortByField = function(list, field, dir) {
    if (!list || !list.sort) return false;
    var dirX = dir && dir === "desc" ? -1 : 1;
    list.sort(function(a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
        if (typeof a_val === "undefined") return -1 * dirX;
        if (a_val < b_val) return -1 * dirX;
        if (a_val > b_val) return 1 * dirX;
        return 0;
    });
    return true;
};
var objectLessAttributes = function(obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === "string") delete ret[less];
        else less.forEach(function(attr) {
            delete ret[attr];
        });
    }
    return ret;
};
var filenameToContentType = function(filename, defVal) {
    if (defVal === void 0) defVal = "application/octet-stream";
    var name = filename.toLowerCase();
    var filtered = MIME_MAP.filter(function(mime) {
        return name.endsWith("." + mime.ext);
    });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var isTextFile = function(contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith("text/")) return true;
    return "application/json" === type || "application/xml" === type || "application/sh" === type;
};
var generateRandomString = function() {
    var result = "";
    var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
var makeQuerablePromise = function(promise) {
    if (promise.isResolved) return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function(data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function(e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function() {
        return isFullfilled;
    };
    result.isPending = function() {
        return isPending;
    };
    result.isRejected = function() {
        return isRejected;
    };
    return result;
};
var isWebWorker = function() {
    if (typeof self === "undefined") return false;
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== "undefined" && self instanceof selfContext.WorkerGlobalScope;
};
var browserOrNode = function() {
    var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
    var isNode = typeof process !== "undefined" && process.versions != null && process.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode
    };
};
var transferKeyToLowerCase = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
        ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var transferKeyToUpperCase = function(obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) whiteListForItself = [];
    if (whiteListForChildren === void 0) whiteListForChildren = [];
    if (!isStrictObject(obj)) return obj;
    var ret = {};
    for(var key in obj)if (obj.hasOwnProperty(key)) {
        var transferredKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
        ret[transferredKey] = whiteListForChildren.includes(key) ? obj[key] : transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
    }
    return ret;
};
var isStrictObject = function(obj) {
    return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
};

},{"6dd1111aaf1faf9b":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byego":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Signer", ()=>Signer);
var _util = require("./Util");
var _signatureV4 = require("./clients/middleware/signing/signer/signatureV4");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var IOT_SERVICE_NAME = "iotdevicegateway";
// Best practice regex to parse the service and region from an AWS endpoint
var AWS_ENDPOINT_REGEX = /([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(.cn)?$/;
var Signer = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, accessInfo, serviceInfo) {
        request.headers = request.headers || {};
        if (request.body && !request.data) throw new Error('The attribute "body" was found on the request object. Please use the attribute "data" instead.');
        var requestToSign = __assign(__assign({}, request), {
            body: request.data,
            url: new URL(request.url)
        });
        var options = getOptions(requestToSign, accessInfo, serviceInfo);
        var signedRequest = (0, _signatureV4.signRequest)(requestToSign, options);
        // Prior to using `signRequest`, Signer accepted urls as strings and outputted urls as string. Coerce the property
        // back to a string so as not to disrupt consumers of Signer.
        signedRequest.url = signedRequest.url.toString();
        // HTTP headers should be case insensitive but, to maintain parity with the previous Signer implementation and
        // limit the impact of this implementation swap, replace lowercased headers with title cased ones.
        signedRequest.headers.Authorization = signedRequest.headers.authorization;
        signedRequest.headers["X-Amz-Security-Token"] = signedRequest.headers["x-amz-security-token"];
        delete signedRequest.headers.authorization;
        delete signedRequest.headers["x-amz-security-token"];
        return signedRequest;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
        var body = typeof urlOrRequest === "object" ? urlOrRequest.body : undefined;
        var presignable = {
            body: body,
            method: method,
            url: new URL(urlToSign)
        };
        var options = getOptions(presignable, accessInfo, serviceInfo, expiration);
        var signedUrl = (0, _signatureV4.presignUrl)(presignable, options);
        if (accessInfo.session_token && !sessionTokenRequiredInSigning(options.signingService)) signedUrl.searchParams.append((0, _signatureV4.TOKEN_QUERY_PARAM), accessInfo.session_token);
        return signedUrl.toString();
    };
    return Signer;
}();
var getOptions = function(request, accessInfo, serviceInfo, expiration) {
    var _a = accessInfo !== null && accessInfo !== void 0 ? accessInfo : {}, access_key = _a.access_key, secret_key = _a.secret_key, session_token = _a.session_token;
    var _b = parseServiceInfo(request.url), urlRegion = _b.region, urlService = _b.service;
    var _c = serviceInfo !== null && serviceInfo !== void 0 ? serviceInfo : {}, _d = _c.region, region = _d === void 0 ? urlRegion : _d, _e = _c.service, service = _e === void 0 ? urlService : _e;
    var credentials = __assign({
        accessKeyId: access_key,
        secretAccessKey: secret_key
    }, sessionTokenRequiredInSigning(service) ? {
        sessionToken: session_token
    } : {});
    return __assign({
        credentials: credentials,
        signingDate: (0, _util.DateUtils).getDateWithClockOffset(),
        signingRegion: region,
        signingService: service
    }, expiration && {
        expiration: expiration
    });
};
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var parseServiceInfo = function(url) {
    var _a;
    var host = url.host;
    var matched = (_a = host.match(AWS_ENDPOINT_REGEX)) !== null && _a !== void 0 ? _a : [];
    var parsed = matched.slice(1, 3);
    if (parsed[1] === "es") // Elastic Search
    parsed = parsed.reverse();
    return {
        service: parsed[0],
        region: parsed[1]
    };
};
// IoT service does not allow the session token in the canonical request
// https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
// TODO: V6 investigate whether add to custom clients' general signer implementation.
var sessionTokenRequiredInSigning = function(service) {
    return service !== IOT_SERVICE_NAME;
};

},{"./Util":"5E0Hy","./clients/middleware/signing/signer/signatureV4":"2tT6s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5E0Hy":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", ()=>(0, _retry.NonRetryableError));
parcelHelpers.export(exports, "isNonRetryableError", ()=>(0, _retry.isNonRetryableError));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _retry.jitteredBackoff));
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>(0, _retry.jitteredExponentialRetry));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "Mutex", ()=>(0, _mutexDefault.default));
parcelHelpers.export(exports, "Reachability", ()=>(0, _reachabilityDefault.default));
parcelHelpers.export(exports, "DateUtils", ()=>(0, _dateUtils.DateUtils));
parcelHelpers.export(exports, "urlSafeDecode", ()=>(0, _stringUtils.urlSafeDecode));
parcelHelpers.export(exports, "urlSafeEncode", ()=>(0, _stringUtils.urlSafeEncode));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_CATEGORY", ()=>(0, _constants.AWS_CLOUDWATCH_CATEGORY));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", ()=>(0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE));
parcelHelpers.export(exports, "AWS_CLOUDWATCH_PROVIDER_NAME", ()=>(0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME));
parcelHelpers.export(exports, "NO_CREDS_ERROR_STRING", ()=>(0, _constants.NO_CREDS_ERROR_STRING));
parcelHelpers.export(exports, "RETRY_ERROR_CODES", ()=>(0, _constants.RETRY_ERROR_CODES));
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>(0, _backgroundProcessManager.BackgroundProcessManager));
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>(0, _backgroundProcessManager.BackgroundManagerNotOpenError));
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>(0, _backgroundProcessManager.BackgroundProcessManagerState));
var _retry = require("./Retry");
var _mutex = require("./Mutex");
var _mutexDefault = parcelHelpers.interopDefault(_mutex);
var _reachability = require("./Reachability");
var _reachabilityDefault = parcelHelpers.interopDefault(_reachability);
var _dateUtils = require("./DateUtils");
var _stringUtils = require("./StringUtils");
var _constants = require("./Constants");
var _backgroundProcessManager = require("./BackgroundProcessManager");

},{"./Retry":"2d9ab","./Mutex":"47qe0","./Reachability":"b5eoY","./DateUtils":"ic7zB","./StringUtils":"cCkPA","./Constants":false,"./BackgroundProcessManager":"lMpbt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2d9ab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRetryableError", ()=>NonRetryableError);
parcelHelpers.export(exports, "isNonRetryableError", ()=>isNonRetryableError);
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "retry", ()=>retry);
/**
 * @private
 * Internal use of Amplify only
 */ parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
parcelHelpers.export(exports, "jitteredExponentialRetry", ()=>jitteredExponentialRetry);
var _consoleLogger = require("../Logger/ConsoleLogger");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _consoleLogger.ConsoleLogger)("Util");
var NonRetryableError = /** @class */ function(_super) {
    __extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, onTerminate) {
    return __awaiter(this, void 0, void 0, function() {
        var _this = this;
        return __generator(this, function(_a) {
            if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var attempt, terminated, timeout, wakeUp, lastError, _loop_1, state_1;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    attempt = 0;
                                    terminated = false;
                                    wakeUp = function() {};
                                    onTerminate && onTerminate.then(function() {
                                        // signal not to try anymore.
                                        terminated = true;
                                        // stop sleeping if we're sleeping.
                                        clearTimeout(timeout);
                                        wakeUp();
                                    });
                                    _loop_1 = function() {
                                        var _b, _c, err_1, retryIn_1;
                                        return __generator(this, function(_d) {
                                            switch(_d.label){
                                                case 0:
                                                    attempt++;
                                                    logger.debug("".concat(functionToRetry.name, " attempt #").concat(attempt, " with this vars: ").concat(JSON.stringify(args)));
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        7
                                                    ]);
                                                    _b = {};
                                                    _c = resolve;
                                                    return [
                                                        4 /*yield*/ ,
                                                        functionToRetry.apply(void 0, __spreadArray([], __read(args), false))
                                                    ];
                                                case 2:
                                                    return [
                                                        2 /*return*/ ,
                                                        (_b.value = _c.apply(void 0, [
                                                            _d.sent()
                                                        ]), _b)
                                                    ];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    lastError = err_1;
                                                    logger.debug("error on ".concat(functionToRetry.name), err_1);
                                                    if (isNonRetryableError(err_1)) {
                                                        logger.debug("".concat(functionToRetry.name, " non retryable error"), err_1);
                                                        return [
                                                            2 /*return*/ ,
                                                            {
                                                                value: reject(err_1)
                                                            }
                                                        ];
                                                    }
                                                    retryIn_1 = delayFn(attempt, args, err_1);
                                                    logger.debug("".concat(functionToRetry.name, " retrying in ").concat(retryIn_1, " ms"));
                                                    if (!(retryIn_1 === false || terminated)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            value: reject(err_1)
                                                        }
                                                    ];
                                                case 4:
                                                    return [
                                                        4 /*yield*/ ,
                                                        new Promise(function(r) {
                                                            wakeUp = r; // export wakeUp for onTerminate handling
                                                            timeout = setTimeout(wakeUp, retryIn_1);
                                                        })
                                                    ];
                                                case 5:
                                                    _d.sent();
                                                    _d.label = 6;
                                                case 6:
                                                    return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                case 7:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    };
                                    _a.label = 1;
                                case 1:
                                    if (!!terminated) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        5 /*yield**/ ,
                                        _loop_1()
                                    ];
                                case 2:
                                    state_1 = _a.sent();
                                    if (typeof state_1 === "object") return [
                                        2 /*return*/ ,
                                        state_1.value
                                    ];
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 3:
                                    // reached if terminated while waiting for a timer.
                                    reject(lastError);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })
            ];
        });
    });
}
var MAX_DELAY_MS = 300000;
function jitteredBackoff(maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var jitteredExponentialRetry = function(functionToRetry, args, maxDelayMs, onTerminate) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs), onTerminate);
};

},{"../Logger/ConsoleLogger":"dY8EL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47qe0":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
exports.default = Mutex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b5eoY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function(netInfo) {
        if ((0, _core.browserOrNode)().isNode) return (0, _zenObservableTsDefault.default).from([
            {
                online: true
            }
        ]);
        var globalObj = (0, _core.isWebWorker)() ? self : window;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            observer.next({
                online: globalObj.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            globalObj.addEventListener("online", notifyOnline);
            globalObj.addEventListener("offline", notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function() {
                globalObj.removeEventListener("online", notifyOnline);
                globalObj.removeEventListener("offline", notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function(status) {
        var e_1, _a;
        var _loop_1 = function(observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function(_observer) {
                    return _observer !== observer;
                });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for(var _b = __values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()){
                var observer = _c.value;
                _loop_1(observer);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}();
exports.default = ReachabilityNavigator;

},{"@aws-amplify/core":"3rlh1","zen-observable-ts":"57mma","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"57mma":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _zenObservable = require("zen-observable");
var _zenObservableDefault = parcelHelpers.interopDefault(_zenObservable);
var Observable = (0, _zenObservableDefault.default);
exports.default = Observable;

},{"zen-observable":"kW3N9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kW3N9":[function(require,module,exports) {
module.exports = require("fe6bb7da9da67ed3").Observable;

},{"fe6bb7da9da67ed3":"b9Fnb"}],"b9Fnb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Observable = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var hasSymbols = function() {
    return typeof Symbol === "function";
};
var hasSymbol = function(name) {
    return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function(name) {
    return hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if (hasSymbols() && !hasSymbol("observable")) Symbol.observable = Symbol("observable");
var SymbolIterator = getSymbol("iterator");
var SymbolObservable = getSymbol("observable");
var SymbolSpecies = getSymbol("species"); // === Abstract Operations ===
function getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : Observable;
}
function isObservable(x) {
    return x instanceof Observable; // SPEC: Brand check
}
function hostReportError(e) {
    if (hostReportError.log) hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            hostReportError(e);
        }
    });
}
function cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        hostReportError(e);
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        hostReportError(e);
    }
    if (subscription._state === "closed") cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        enqueue(function() {
            return flushSubscription(subscription);
        });
        return;
    }
    notifySubscription(subscription, type, value);
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        _classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    _createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    closeSubscription(this);
                    cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        _classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    _createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        _classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    _createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = getMethod(x, SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if (isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if (hasSymbol("iterator")) {
                    method = getMethod(x, SymbolIterator);
                    if (method) return new C(function(observer) {
                        enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
exports.Observable = Observable;
if (hasSymbols()) Object.defineProperty(Observable, Symbol("extensions"), {
    value: {
        symbol: SymbolObservable,
        hostReportError: hostReportError
    },
    configurable: true
});

},{}],"ic7zB":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateUtils", ()=>DateUtils);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// Comment - TODO: remove
var FIVE_MINUTES_IN_MS = 300000;
var DateUtils = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if (DateUtils.clockOffset) return new Date(new Date().getTime() + DateUtils.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return DateUtils.clockOffset;
    },
    getHeaderStringFromDate: function(date) {
        if (date === void 0) date = DateUtils.getDateWithClockOffset();
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    },
    getDateFromHeaderString: function(header) {
        var _a = __read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function(serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS;
    },
    isClockSkewError: function(error) {
        if (!error.response || !error.response.headers) return false;
        var headers = error.response.headers;
        return Boolean([
            "BadRequestException",
            "InvalidSignatureException"
        ].includes(headers["x-amzn-errortype"]) && (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        DateUtils.clockOffset = offset;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cCkPA":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlSafeEncode", ()=>urlSafeEncode);
parcelHelpers.export(exports, "urlSafeDecode", ()=>urlSafeDecode);
function urlSafeEncode(str) {
    return str.split("").map(function(char) {
        return char.charCodeAt(0).toString(16).padStart(2, "0");
    }).join("");
}
function urlSafeDecode(hex) {
    return hex.match(/.{2}/g).map(function(char) {
        return String.fromCharCode(parseInt(char, 16));
    }).join("");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lMpbt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackgroundProcessManager", ()=>BackgroundProcessManager);
parcelHelpers.export(exports, "BackgroundManagerNotOpenError", ()=>BackgroundManagerNotOpenError);
parcelHelpers.export(exports, "BackgroundProcessManagerState", ()=>BackgroundProcessManagerState);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private For internal Amplify use.
 *
 * Creates a new scope for promises, observables, and other types of work or
 * processes that may be running in the background. This manager provides
 * an singular entrypoint to request termination and await completion.
 *
 * As work completes on its own prior to close, the manager removes them
 * from the registry to avoid holding references to completed jobs.
 */ var BackgroundProcessManager = /** @class */ function() {
    /**
     * Creates a new manager for promises, observables, and other types
     * of work that may be running in the background. This manager provides
     * a centralized mechanism to request termination and await completion.
     */ function BackgroundProcessManager() {
        /**
         * A string indicating whether the manager is accepting new work ("Open"),
         * waiting for work to complete ("Closing"), or fully done with all
         * submitted work and *not* accepting new jobs ("Closed").
         */ this._state = BackgroundProcessManagerState.Open;
        /**
         * The list of outstanding jobs we'll need to wait for upon `close()`
         */ this.jobs = new Set();
    }
    BackgroundProcessManager.prototype.add = function(jobOrDescription, optionalDescription) {
        var job;
        var description;
        if (typeof jobOrDescription === "string") {
            job = undefined;
            description = jobOrDescription;
        } else {
            job = jobOrDescription;
            description = optionalDescription;
        }
        var error = this.closedFailure(description);
        if (error) return error;
        if (job === undefined) return this.addHook(description);
        else if (typeof job === "function") return this.addFunction(job, description);
        else if (job instanceof BackgroundProcessManager) return this.addManager(job, description);
        else throw new Error("If `job` is provided, it must be an Observable, Function, or BackgroundProcessManager.");
    };
    /**
     * Adds a **cleaner** function that doesn't immediately get executed.
     * Instead, the caller gets a **terminate** function back. The *cleaner* is
     * invoked only once the mananger *closes* or the returned **terminate**
     * function is called.
     *
     * @param clean The cleanup function.
     * @param description Optional description to help identify pending jobs.
     * @returns A terminate function.
     */ BackgroundProcessManager.prototype.addCleaner = function(clean, description) {
        var _this = this;
        var _a = this.addHook(description), resolve = _a.resolve, onTerminate = _a.onTerminate;
        var proxy = function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                clean()
                            ];
                        case 1:
                            _a.sent();
                            resolve();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        onTerminate.then(proxy);
        return proxy;
    };
    BackgroundProcessManager.prototype.addFunction = function(job, description) {
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolve) {
            terminate = resolve;
        });
        // finally! start the job.
        var jobResult = job(onTerminate);
        // depending on what the job gives back, register the result
        // so we can monitor for completion.
        if (typeof (jobResult === null || jobResult === void 0 ? void 0 : jobResult.then) === "function") this.registerPromise(jobResult, terminate, description);
        // At the end of the day, or you know, method call, it doesn't matter
        // what the return value is at all; we just pass it through to the
        // caller.
        return jobResult;
    };
    BackgroundProcessManager.prototype.addManager = function(manager, description) {
        var _this = this;
        this.addCleaner(function() {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                manager.close()
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        }, description);
    };
    /**
     * Creates and registers a fabricated job for processes that need to operate
     * with callbacks/hooks. The returned `resolve` and `reject`
     * functions can be used to signal the job is done successfully or not.
     * The returned `onTerminate` is a promise that will resolve when the
     * manager is requesting the termination of the job.
     *
     * @param description Optional description to help identify pending jobs.
     * @returns `{ resolve, reject, onTerminate }`
     */ BackgroundProcessManager.prototype.addHook = function(description) {
        // the resolve/reject functions we'll provide to the caller to signal
        // the state of the job.
        var resolve;
        var reject;
        // the underlying promise we'll use to manage it, pretty much like
        // any other promise.
        var promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        // the function we call when we want to try to terminate this job.
        var terminate;
        // the promise the job can opt into listening to for termination.
        var onTerminate = new Promise(function(resolveTerminate) {
            terminate = resolveTerminate;
        });
        this.registerPromise(promise, terminate, description);
        return {
            resolve: resolve,
            reject: reject,
            onTerminate: onTerminate
        };
    };
    /**
     * Adds a Promise based job to the list of jobs for monitoring and listens
     * for either a success or failure, upon which the job is considered "done"
     * and removed from the registry.
     *
     * @param promise A promise that is on its way to being returned to a
     * caller, which needs to be tracked as a background job.
     * @param terminate The termination function to register, which can be
     * invoked to request the job stop.
     * @param description Optional description to help identify pending jobs.
     */ BackgroundProcessManager.prototype.registerPromise = function(promise, terminate, description) {
        var _this = this;
        var jobEntry = {
            promise: promise,
            terminate: terminate,
            description: description
        };
        this.jobs.add(jobEntry);
        // in all of my testing, it is safe to multi-subscribe to a promise.
        // so, rather than create another layer of promising, we're just going
        // to hook into the promise we already have, and when it's done
        // (successfully or not), we no longer need to wait for it upon close.
        //
        // sorry this is a bit hand-wavy:
        //
        // i believe we use `.then` and `.catch` instead of `.finally` because
        // `.finally` is invoked in a different order in the sequence, and this
        // breaks assumptions throughout and causes failures.
        promise.then(function() {
            _this.jobs.delete(jobEntry);
        }).catch(function() {
            _this.jobs.delete(jobEntry);
        });
    };
    Object.defineProperty(BackgroundProcessManager.prototype, "length", {
        /**
         * The number of jobs being waited on.
         *
         * We don't use this for anything. It's just informational for the caller,
         * and can be used in logging and testing.
         *
         * @returns the number of jobs.
         */ get: function() {
            return this.jobs.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "state", {
        /**
         * The execution state of the manager. One of:
         *
         * 1. "Open" -> Accepting new jobs
         * 1. "Closing" -> Not accepting new work. Waiting for jobs to complete.
         * 1. "Closed" -> Not accepting new work. All submitted jobs are complete.
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "pending", {
        /**
         * The registered `description` of all still-pending jobs.
         *
         * @returns descriptions as an array.
         */ get: function() {
            return Array.from(this.jobs).map(function(job) {
                return job.description;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isOpen", {
        /**
         * Whether the manager is accepting new jobs.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Open;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosing", {
        /**
         * Whether the manager is rejecting new work, but still waiting for
         * submitted work to complete.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Closing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundProcessManager.prototype, "isClosed", {
        /**
         * Whether the manager is rejecting work and done waiting for submitted
         * work to complete.
         */ get: function() {
            return this._state === BackgroundProcessManagerState.Closed;
        },
        enumerable: false,
        configurable: true
    });
    BackgroundProcessManager.prototype.closedFailure = function(description) {
        if (!this.isOpen) return Promise.reject(new BackgroundManagerNotOpenError([
            "The manager is ".concat(this.state, "."),
            'You tried to add "'.concat(description, '".'),
            "Pending jobs: [\n".concat(this.pending.map(function(t) {
                return "    " + t;
            }).join(",\n"), "\n]")
        ].join("\n")));
    };
    /**
     * Signals jobs to stop (for those that accept interruptions) and waits
     * for confirmation that jobs have stopped.
     *
     * This immediately puts the manager into a closing state and just begins
     * to reject new work. After all work in the manager is complete, the
     * manager goes into a `Completed` state and `close()` returns.
     *
     * This call is idempotent.
     *
     * If the manager is already closing or closed, `finalCleaup` is not executed.
     *
     * @param onClosed
     * @returns The settled results of each still-running job's promise. If the
     * manager is already closed, this will contain the results as of when the
     * manager's `close()` was called in an `Open` state.
     */ BackgroundProcessManager.prototype.close = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, job;
            var e_1, _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!this.isOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._state = BackgroundProcessManagerState.Closing;
                        try {
                            for(_a = __values(Array.from(this.jobs)), _b = _a.next(); !_b.done; _b = _a.next()){
                                job = _b.value;
                                try {
                                    job.terminate();
                                } catch (error) {
                                    // Due to potential races with a job's natural completion, it's
                                    // reasonable to expect the termination call to fail. Hence,
                                    // not logging as an error.
                                    console.warn("Failed to send termination signal to job. Error: ".concat(error.message), job);
                                }
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        // Use `allSettled()` because we want to wait for all to finish. We do
                        // not want to stop waiting if there is a failure.
                        this._closingPromise = Promise.allSettled(Array.from(this.jobs).map(function(j) {
                            return j.promise;
                        }));
                        return [
                            4 /*yield*/ ,
                            this._closingPromise
                        ];
                    case 1:
                        _d.sent();
                        this._state = BackgroundProcessManagerState.Closed;
                        _d.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._closingPromise
                        ];
                }
            });
        });
    };
    /**
     * Signals the manager to start accepting work (again) and returns once
     * the manager is ready to do so.
     *
     * If the state is already `Open`, this call is a no-op.
     *
     * If the state is `Closed`, this call simply updates state and returns.
     *
     * If the state is `Closing`, this call waits for completion before it
     * updates the state and returns.
     */ BackgroundProcessManager.prototype.open = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.isClosing) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.close()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this._state = BackgroundProcessManagerState.Open;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackgroundProcessManager;
}();
/**
 *
 */ var BackgroundManagerNotOpenError = /** @class */ function(_super) {
    __extends(BackgroundManagerNotOpenError, _super);
    function BackgroundManagerNotOpenError(message) {
        return _super.call(this, "BackgroundManagerNotOpenError: ".concat(message)) || this;
    }
    return BackgroundManagerNotOpenError;
}(Error);
var BackgroundProcessManagerState;
(function(BackgroundProcessManagerState) {
    /**
     * Accepting new jobs.
     */ BackgroundProcessManagerState["Open"] = "Open";
    /**
     * Not accepting new jobs. Waiting for submitted jobs to complete.
     */ BackgroundProcessManagerState["Closing"] = "Closing";
    /**
     * Not accepting new jobs. All submitted jobs are complete.
     */ BackgroundProcessManagerState["Closed"] = "Closed";
})(BackgroundProcessManagerState || (BackgroundProcessManagerState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2tT6s":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 replace Signer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", ()=>(0, _signRequest.signRequest));
parcelHelpers.export(exports, "presignUrl", ()=>(0, _presignUrl.presignUrl));
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>(0, _constants.TOKEN_QUERY_PARAM));
parcelHelpers.export(exports, "getHashedPayload", ()=>(0, _getHashedPayload.getHashedPayload));
var _signRequest = require("./signRequest");
var _presignUrl = require("./presignUrl");
var _constants = require("./constants");
var _getHashedPayload = require("./utils/getHashedPayload");

},{"./signRequest":"dCCl6","./presignUrl":"dkRwv","./constants":"frxal","./utils/getHashedPayload":"8TceH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dCCl6":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signRequest", ()=>signRequest);
var _getSignedHeaders = require("./utils/getSignedHeaders");
var _getSigningValues = require("./utils/getSigningValues");
var _constants = require("./constants");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var signRequest = function(request, options) {
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    var headers = __assign({}, request.headers);
    headers[0, _constants.HOST_HEADER] = request.url.host;
    headers[0, _constants.AMZ_DATE_HEADER] = longDate;
    if (sessionToken) headers[0, _constants.TOKEN_HEADER] = sessionToken;
    var requestToSign = __assign(__assign({}, request), {
        headers: headers
    });
    // calculate and add the signature to the request
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    var credentialEntry = "Credential=".concat(accessKeyId, "/").concat(credentialScope);
    var signedHeadersEntry = "SignedHeaders=".concat((0, _getSignedHeaders.getSignedHeaders)(headers));
    var signatureEntry = "Signature=".concat(signature);
    headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.SHA256_ALGORITHM_IDENTIFIER), " ").concat(credentialEntry, ", ").concat(signedHeadersEntry, ", ").concat(signatureEntry);
    return requestToSign;
};

},{"./utils/getSignedHeaders":"aGJ5y","./utils/getSigningValues":"a9VXR","./constants":"frxal","./utils/getSignature":"1QRjI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGJ5y":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignedHeaders", ()=>getSignedHeaders);
var getSignedHeaders = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a9VXR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningValues", ()=>getSigningValues);
var _getCredentialScope = require("./getCredentialScope");
var _getFormattedDates = require("./getFormattedDates");
var getSigningValues = function(_a) {
    var credentials = _a.credentials, _b = _a.signingDate, signingDate = _b === void 0 ? new Date() : _b, signingRegion = _a.signingRegion, signingService = _a.signingService, _c = _a.uriEscapePath, uriEscapePath = _c === void 0 ? true : _c;
    // get properties from credentials
    var accessKeyId = credentials.accessKeyId, secretAccessKey = credentials.secretAccessKey, sessionToken = credentials.sessionToken;
    // get formatted dates for signing
    var _d = (0, _getFormattedDates.getFormattedDates)(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
    // copy header and set signing properties
    var credentialScope = (0, _getCredentialScope.getCredentialScope)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};

},{"./getCredentialScope":"cfih6","./getFormattedDates":"2Ix3y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cfih6":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialScope", ()=>getCredentialScope);
var _constants = require("../constants");
var getCredentialScope = function(date, region, service) {
    return "".concat(date, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};

},{"../constants":"frxal","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"frxal":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "SHA256_ALGORITHM_IDENTIFIER", ()=>SHA256_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "SIGNATURE_IDENTIFIER", ()=>SIGNATURE_IDENTIFIER);
parcelHelpers.export(exports, "EMPTY_HASH", ()=>EMPTY_HASH);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var HOST_HEADER = "host";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var KEY_TYPE_IDENTIFIER = "aws4_request";
var SHA256_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var SIGNATURE_IDENTIFIER = "AWS4";
var EMPTY_HASH = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Ix3y":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormattedDates", ()=>getFormattedDates);
var getFormattedDates = function(date) {
    var longDate = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QRjI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSignature", ()=>getSignature);
var _dataHashHelpers = require("./dataHashHelpers");
var _getCanonicalRequest = require("./getCanonicalRequest");
var _getSigningKey = require("./getSigningKey");
var _getStringToSign = require("./getStringToSign");
var getSignature = function(request, _a) {
    var credentialScope = _a.credentialScope, longDate = _a.longDate, secretAccessKey = _a.secretAccessKey, shortDate = _a.shortDate, signingRegion = _a.signingRegion, signingService = _a.signingService, uriEscapePath = _a.uriEscapePath;
    // step 1: create a canonical request
    var canonicalRequest = (0, _getCanonicalRequest.getCanonicalRequest)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    var hashedRequest = (0, _dataHashHelpers.getHashedDataAsHex)(null, canonicalRequest);
    // step 3: create a string to sign
    var stringToSign = (0, _getStringToSign.getStringToSign)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    var signature = (0, _dataHashHelpers.getHashedDataAsHex)((0, _getSigningKey.getSigningKey)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};

},{"./dataHashHelpers":"eBHPH","./getCanonicalRequest":"hjw41","./getSigningKey":"d6PXj","./getStringToSign":"E7i3P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eBHPH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedData", ()=>getHashedData);
parcelHelpers.export(exports, "getHashedDataAsHex", ()=>getHashedDataAsHex);
var _sha256Js = require("@aws-crypto/sha256-js");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var getHashedData = function(key, data) {
    var sha256 = new (0, _sha256Js.Sha256)(key);
    sha256.update(data);
    // TODO: V6 flip to async digest
    var hashedData = sha256.digestSync();
    return hashedData;
};
var getHashedDataAsHex = function(key, data) {
    var hashedData = getHashedData(key, data);
    return (0, _utilHexEncoding.toHex)(hashedData);
};

},{"@aws-crypto/sha256-js":"1pg4I","@aws-sdk/util-hex-encoding":"dTdhV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1pg4I":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("847e9f41fbd48d18");
(0, tslib_1.__exportStar)(require("952fa851a97011d6"), exports);

},{"847e9f41fbd48d18":"6vDGG","952fa851a97011d6":"cBehM"}],"6vDGG":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cBehM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("4cf08e042cbd4f6b");
var constants_1 = require("2f5507f5e1102429");
var RawSha256_1 = require("c4be19be66a5b026");
var util_1 = require("2d947ee16d17c108");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"4cf08e042cbd4f6b":"6vDGG","2f5507f5e1102429":"ciFKs","c4be19be66a5b026":"1lh4r","2d947ee16d17c108":"1R05H"}],"ciFKs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"1lh4r":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("611362490e842507");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"611362490e842507":"ciFKs"}],"1R05H":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("d546aa13e7a4f234");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("688570fbe8307eb0");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("9f8c2d94c37c0290");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("65327eb5bf877089");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"d546aa13e7a4f234":"1CD9C","688570fbe8307eb0":"kNGoz","9f8c2d94c37c0290":"13Gve","65327eb5bf877089":"9noVK"}],"1CD9C":[function(require,module,exports) {
var Buffer = require("c6f30219801e45d2").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("edd31833385d65db");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"c6f30219801e45d2":"cvSE8","edd31833385d65db":"iZmxX"}],"cvSE8":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"MlSYJ","aceacb6a4531a9d2":"15Xnl"}],"MlSYJ":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"15Xnl":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"iZmxX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"9OMpz","./whatwgEncodingApi":"clj9V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9OMpz":[function(require,module,exports) {
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"clj9V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNGoz":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"13Gve":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"9noVK":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"dTdhV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ parcelHelpers.export(exports, "fromHex", ()=>fromHex);
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0" + encodedByte;
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hjw41":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalRequest", ()=>getCanonicalRequest);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQueryString = require("./getCanonicalQueryString");
var _getCanonicalUri = require("./getCanonicalUri");
var _getHashedPayload = require("./getHashedPayload");
var _getSignedHeaders = require("./getSignedHeaders");
var getCanonicalRequest = function(_a, uriEscapePath) {
    var body = _a.body, headers = _a.headers, method = _a.method, url = _a.url;
    if (uriEscapePath === void 0) uriEscapePath = true;
    return [
        method,
        (0, _getCanonicalUri.getCanonicalUri)(url.pathname, uriEscapePath),
        (0, _getCanonicalQueryString.getCanonicalQueryString)(url.searchParams),
        (0, _getCanonicalHeaders.getCanonicalHeaders)(headers),
        (0, _getSignedHeaders.getSignedHeaders)(headers),
        (0, _getHashedPayload.getHashedPayload)(body)
    ].join("\n");
};

},{"./getCanonicalHeaders":"8mDLP","./getCanonicalQueryString":"etapY","./getCanonicalUri":"kltn4","./getHashedPayload":"8TceH","./getSignedHeaders":"aGJ5y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mDLP":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalHeaders = function(headers) {
    return Object.entries(headers).map(function(_a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return {
            key: key.toLowerCase(),
            value: (_b = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, " ")) !== null && _b !== void 0 ? _b : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(entry) {
        return "".concat(entry.key, ":").concat(entry.value, "\n");
    }).join("");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"etapY":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQueryString", ()=>getCanonicalQueryString);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var getCanonicalQueryString = function(searchParams) {
    return Array.from(searchParams).sort(function(_a, _b) {
        var _c = __read(_a, 2), keyA = _c[0], valA = _c[1];
        var _d = __read(_b, 2), keyB = _d[0], valB = _d[1];
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(function(_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return "".concat(escapeUri(key), "=").concat(escapeUri(val));
    }).join("&");
};
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kltn4":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalUri", ()=>getCanonicalUri);
var getCanonicalUri = function(pathname, uriEscapePath) {
    if (uriEscapePath === void 0) uriEscapePath = true;
    return pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TceH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHashedPayload", ()=>getHashedPayload);
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getHashedPayload = function(body) {
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, _constants.EMPTY_HASH;
    if (isSourceData(body)) {
        var hashedData = (0, _dataHashHelpers.getHashedDataAsHex)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, _constants.UNSIGNED_PAYLOAD;
};
var isSourceData = function(body) {
    return typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body);
};
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"../constants":"frxal","./dataHashHelpers":"eBHPH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d6PXj":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
var _constants = require("../constants");
var _dataHashHelpers = require("./dataHashHelpers");
var getSigningKey = function(secretAccessKey, date, region, service) {
    var key = "".concat((0, _constants.SIGNATURE_IDENTIFIER)).concat(secretAccessKey);
    var dateKey = (0, _dataHashHelpers.getHashedData)(key, date);
    var regionKey = (0, _dataHashHelpers.getHashedData)(dateKey, region);
    var serviceKey = (0, _dataHashHelpers.getHashedData)(regionKey, service);
    var signingKey = (0, _dataHashHelpers.getHashedData)(serviceKey, (0, _constants.KEY_TYPE_IDENTIFIER));
    return signingKey;
};

},{"../constants":"frxal","./dataHashHelpers":"eBHPH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"E7i3P":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStringToSign", ()=>getStringToSign);
var _constants = require("../constants");
var getStringToSign = function(date, credentialScope, hashedRequest) {
    return [
        (0, _constants.SHA256_ALGORITHM_IDENTIFIER),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");
};

},{"../constants":"frxal","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dkRwv":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presignUrl", ()=>presignUrl);
var _constants = require("./constants");
var _getSigningValues = require("./utils/getSigningValues");
var _getSignature = require("./utils/getSignature");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var presignUrl = function(_a, _b) {
    var _c, _d, _e, _f;
    var body = _a.body, _g = _a.method, method = _g === void 0 ? "GET" : _g, url = _a.url;
    var expiration = _b.expiration, options = __rest(_b, [
        "expiration"
    ]);
    var signingValues = (0, _getSigningValues.getSigningValues)(options);
    var accessKeyId = signingValues.accessKeyId, credentialScope = signingValues.credentialScope, longDate = signingValues.longDate, sessionToken = signingValues.sessionToken;
    // create the request to sign
    // @ts-ignore URL constructor accepts a URL object
    var presignedUrl = new URL(url);
    Object.entries(__assign(__assign((_c = {}, _c[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.SHA256_ALGORITHM_IDENTIFIER), _c[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(accessKeyId, "/").concat(credentialScope), _c[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate, _c[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = (0, _constants.HOST_HEADER), _c), expiration && (_d = {}, _d[0, _constants.EXPIRES_QUERY_PARAM] = expiration.toString(), _d)), sessionToken && (_e = {}, _e[0, _constants.TOKEN_QUERY_PARAM] = sessionToken, _e))).forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        presignedUrl.searchParams.append(key, value);
    });
    var requestToSign = {
        body: body,
        headers: (_f = {}, _f[0, _constants.HOST_HEADER] = url.host, _f),
        method: method,
        url: presignedUrl
    };
    // calculate and add the signature to the url
    var signature = (0, _getSignature.getSignature)(requestToSign, signingValues);
    presignedUrl.searchParams.append((0, _constants.SIGNATURE_QUERY_PARAM), signature);
    return presignedUrl;
};

},{"./constants":"frxal","./utils/getSigningValues":"a9VXR","./utils/getSignature":"1QRjI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNxFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAWSExports", ()=>parseAWSExports);
var _logger = require("./Logger");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var logger = new (0, _logger.ConsoleLogger)("Parser");
var parseAWSExports = function(config) {
    var amplifyConfig = {};
    // Analytics
    if (config["aws_mobile_analytics_app_id"]) {
        var Analytics = {
            AWSPinpoint: {
                appId: config["aws_mobile_analytics_app_id"],
                region: config["aws_mobile_analytics_app_region"]
            }
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) amplifyConfig.Auth = {
        userPoolId: config["aws_user_pools_id"],
        userPoolWebClientId: config["aws_user_pools_web_client_id"],
        region: config["aws_cognito_region"],
        identityPoolId: config["aws_cognito_identity_pool_id"],
        identityPoolRegion: config["aws_cognito_region"],
        mandatorySignIn: config["aws_mandatory_sign_in"] === "enable",
        signUpVerificationMethod: config["aws_cognito_sign_up_verification_method"] || "code"
    };
    // Storage
    var storageConfig;
    if (config["aws_user_files_s3_bucket"]) storageConfig = {
        AWSS3: {
            bucket: config["aws_user_files_s3_bucket"],
            region: config["aws_user_files_s3_bucket_region"],
            dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
        }
    };
    else storageConfig = config ? config.Storage || config : {};
    // Logging
    if (config["Logging"]) amplifyConfig.Logging = __assign(__assign({}, config["Logging"]), {
        region: config["aws_project_region"]
    });
    // Geo
    if (config["geo"]) {
        amplifyConfig.Geo = Object.assign({}, config.geo);
        if (config.geo["amazon_location_service"]) amplifyConfig.Geo = {
            AmazonLocationService: config.geo["amazon_location_service"]
        };
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
    return amplifyConfig;
};

},{"./Logger":"jVGZ5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPXfS":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>(0, _awscloudWatchProvider.AWSCloudWatchProvider));
var _awscloudWatchProvider = require("./AWSCloudWatchProvider");

},{"./AWSCloudWatchProvider":"eX5Mv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eX5Mv":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSCloudWatchProvider", ()=>AWSCloudWatchProvider);
var _clientCloudwatchLogs = require("@aws-sdk/client-cloudwatch-logs");
var _ = require("../..");
var _logger = require("../Logger");
var _platform = require("../Platform");
var _parseAWSExports = require("../parseAWSExports");
var _constants = require("../Util/Constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _logger.ConsoleLogger)("AWSCloudWatch");
var AWSCloudWatchProvider = /** @class */ function() {
    function AWSCloudWatchProvider(config) {
        this.configure(config);
        this._dataTracker = {
            eventUploadInProgress: false,
            logEvents: []
        };
        this._currentLogBatch = [];
        this._initiateLogPushInterval();
    }
    AWSCloudWatchProvider.prototype.getProviderName = function() {
        return AWSCloudWatchProvider.PROVIDER_NAME;
    };
    AWSCloudWatchProvider.prototype.getCategoryName = function() {
        return AWSCloudWatchProvider.CATEGORY;
    };
    AWSCloudWatchProvider.prototype.getLogQueue = function() {
        return this._dataTracker.logEvents;
    };
    AWSCloudWatchProvider.prototype.configure = function(config) {
        if (!config) return this._config || {};
        var conf = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(config).Logging, config);
        this._config = conf;
        return this._config;
    };
    AWSCloudWatchProvider.prototype.createLogGroup = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("creating new log group in CloudWatch - ", params.logGroupName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogGroupCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.error("error creating log group - ".concat(error_1));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogGroups = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting list of log groups");
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogGroupsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.error("error getting log group - ".concat(error_2));
                        throw error_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.createLogStream = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_3;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("creating new log stream in CloudWatch - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.CreateLogStreamCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.error("error creating log stream - ".concat(error_3));
                        throw error_3;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogStreams = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting list of log streams");
                        cmd = new (0, _clientCloudwatchLogs.DescribeLogStreamsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.error("error getting log stream - ".concat(error_4));
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var cmd, credentialsOK, client, output, error_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting log events from stream - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.GetLogEventsCommand)(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 3:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 4:
                        error_5 = _a.sent();
                        logger.error("error getting log events - ".concat(error_5));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.pushLogs = function(logs) {
        logger.debug("pushing log events to Cloudwatch...");
        this._dataTracker.logEvents = __spreadArray(__spreadArray([], __read(this._dataTracker.logEvents), false), __read(logs), false);
    };
    AWSCloudWatchProvider.prototype._validateLogGroupExistsAndCreate = function(logGroupName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currGroups, foundGroups, err_1, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._dataTracker.verifiedLogGroup) return [
                            2 /*return*/ ,
                            this._dataTracker.verifiedLogGroup
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogGroups({
                                logGroupNamePrefix: logGroupName
                            })
                        ];
                    case 3:
                        currGroups = _a.sent();
                        if (!(typeof currGroups === "string") && currGroups.logGroups) {
                            foundGroups = currGroups.logGroups.filter(function(group) {
                                return group.logGroupName === logGroupName;
                            });
                            if (foundGroups.length > 0) {
                                this._dataTracker.verifiedLogGroup = foundGroups[0];
                                return [
                                    2 /*return*/ ,
                                    foundGroups[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogGroup({
                                logGroupName: logGroupName
                            })
                        ];
                    case 4:
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 5:
                        err_1 = _a.sent();
                        errString = "failure during log group search: ".concat(err_1);
                        logger.error(errString);
                        throw err_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._validateLogStreamExists = function(logGroupName, logStreamName) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, currStreams, foundStreams, err_2, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        return [
                            4 /*yield*/ ,
                            this.getLogStreams({
                                logGroupName: logGroupName,
                                logStreamNamePrefix: logStreamName
                            })
                        ];
                    case 2:
                        currStreams = _a.sent();
                        if (currStreams.logStreams) {
                            foundStreams = currStreams.logStreams.filter(function(stream) {
                                return stream.logStreamName === logStreamName;
                            });
                            if (foundStreams.length > 0) {
                                this._nextSequenceToken = foundStreams[0].uploadSequenceToken;
                                return [
                                    2 /*return*/ ,
                                    foundStreams[0]
                                ];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ return [
                            4 /*yield*/ ,
                            this.createLogStream({
                                logGroupName: logGroupName,
                                logStreamName: logStreamName
                            })
                        ];
                    case 3:
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */ _a.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        err_2 = _a.sent();
                        errString = "failure during log stream search: ".concat(err_2);
                        logger.error(errString);
                        throw err_2;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._sendLogEvents = function(params) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, cmd, client, output, err_3, errString;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error((0, _constants.NO_CREDS_ERROR_STRING));
                        logger.debug("sending log events to stream - ", params.logStreamName);
                        cmd = new (0, _clientCloudwatchLogs.PutLogEventsCommand)(params);
                        client = this._initCloudWatchLogs();
                        return [
                            4 /*yield*/ ,
                            client.send(cmd)
                        ];
                    case 2:
                        output = _a.sent();
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        err_3 = _a.sent();
                        errString = "failure during log push: ".concat(err_3);
                        logger.error(errString);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initCloudWatchLogs = function() {
        return new (0, _clientCloudwatchLogs.CloudWatchLogsClient)({
            region: this._config.region,
            credentials: this._config.credentials,
            customUserAgent: (0, _platform.getAmplifyUserAgentObject)(),
            endpoint: this._config.endpoint
        });
    };
    AWSCloudWatchProvider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _.Credentials).get().then(function(credentials) {
                                if (!credentials) return false;
                                var cred = (0, _.Credentials).shear(credentials);
                                logger.debug("set credentials for logging", cred);
                                _this._config.credentials = cred;
                                return true;
                            }).catch(function(error) {
                                logger.warn("ensure credentials error", error);
                                return false;
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getNextSequenceToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            var logStream, err_4;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._nextSequenceToken && this._nextSequenceToken.length > 0) return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._validateLogGroupExistsAndCreate(this._config.logGroupName)
                        ];
                    case 2:
                        _a.sent();
                        this._nextSequenceToken = undefined;
                        return [
                            4 /*yield*/ ,
                            this._validateLogStreamExists(this._config.logGroupName, this._config.logStreamName)
                        ];
                    case 3:
                        logStream = _a.sent();
                        if (logStream) this._nextSequenceToken = logStream.uploadSequenceToken;
                        return [
                            2 /*return*/ ,
                            this._nextSequenceToken
                        ];
                    case 4:
                        err_4 = _a.sent();
                        logger.error("failure while getting next sequence token: ".concat(err_4));
                        throw err_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._safeUploadLogEvents = function() {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, logBatch, putLogsPayload, sendLogEventsResponse, err_5;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        logBatch = this._currentLogBatch.length === 0 ? this._getBufferedBatchOfLogs() : this._currentLogBatch;
                        putLogsPayload = {
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName,
                            logEvents: logBatch,
                            sequenceToken: seqToken
                        };
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(putLogsPayload)
                        ];
                    case 2:
                        sendLogEventsResponse = _a.sent();
                        this._nextSequenceToken = sendLogEventsResponse.nextSequenceToken;
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsResponse
                        ];
                    case 3:
                        err_5 = _a.sent();
                        logger.error("error during _safeUploadLogEvents: ".concat(err_5));
                        if ((0, _constants.RETRY_ERROR_CODES).includes(err_5.name)) this._getNewSequenceTokenAndSubmit({
                            logEvents: this._currentLogBatch,
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName
                        });
                        else {
                            this._dataTracker.eventUploadInProgress = false;
                            throw err_5;
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getBufferedBatchOfLogs = function() {
        /**
         * CloudWatch has restrictions on the size of the log events that get sent up.
         * We need to track both the size of each event and the total size of the batch
         * of logs.
         *
         * We also need to ensure that the logs in the batch are sorted in chronological order.
         * https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html
         */ var currentEventIdx = 0;
        var totalByteSize = 0;
        while(currentEventIdx < this._dataTracker.logEvents.length){
            var currentEvent = this._dataTracker.logEvents[currentEventIdx];
            var eventSize = currentEvent ? new TextEncoder().encode(currentEvent.message).length + (0, _constants.AWS_CLOUDWATCH_BASE_BUFFER_SIZE) : 0;
            if (eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_EVENT_SIZE)) {
                var errString = "Log entry exceeds maximum size for CloudWatch logs. Log size: ".concat(eventSize, ". Truncating log message.");
                logger.warn(errString);
                currentEvent.message = currentEvent.message.substring(0, eventSize);
            }
            if (totalByteSize + eventSize > (0, _constants.AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE)) break;
            totalByteSize += eventSize;
            currentEventIdx++;
        }
        this._currentLogBatch = this._dataTracker.logEvents.splice(0, currentEventIdx);
        return this._currentLogBatch;
    };
    AWSCloudWatchProvider.prototype._getNewSequenceTokenAndSubmit = function(payload) {
        return __awaiter(this, void 0, void 0, function() {
            var seqToken, sendLogEventsRepsonse, err_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        this._nextSequenceToken = undefined;
                        this._dataTracker.eventUploadInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._getNextSequenceToken()
                        ];
                    case 1:
                        seqToken = _a.sent();
                        payload.sequenceToken = seqToken;
                        return [
                            4 /*yield*/ ,
                            this._sendLogEvents(payload)
                        ];
                    case 2:
                        sendLogEventsRepsonse = _a.sent();
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [
                            2 /*return*/ ,
                            sendLogEventsRepsonse
                        ];
                    case 3:
                        err_6 = _a.sent();
                        logger.error("error when retrying log submission with new sequence token: ".concat(err_6));
                        this._dataTracker.eventUploadInProgress = false;
                        throw err_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initiateLogPushInterval = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        this._timer = setInterval(function() {
            return __awaiter(_this, void 0, void 0, function() {
                var err_7;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!this._getDocUploadPermissibility()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this._safeUploadLogEvents()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_7 = _a.sent();
                            logger.error("error when calling _safeUploadLogEvents in the timer interval - ".concat(err_7));
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }, 2000);
    };
    AWSCloudWatchProvider.prototype._getDocUploadPermissibility = function() {
        return (this._dataTracker.logEvents.length !== 0 || this._currentLogBatch.length !== 0) && !this._dataTracker.eventUploadInProgress;
    };
    AWSCloudWatchProvider.PROVIDER_NAME = (0, _constants.AWS_CLOUDWATCH_PROVIDER_NAME);
    AWSCloudWatchProvider.CATEGORY = (0, _constants.AWS_CLOUDWATCH_CATEGORY);
    return AWSCloudWatchProvider;
}();

},{"@aws-sdk/client-cloudwatch-logs":"59afR","../..":"3rlh1","../Logger":"jVGZ5","../Platform":"jNyBX","../parseAWSExports":"jNxFP","../Util/Constants":"4siXq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"59afR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloudWatchLogsClient = require("./CloudWatchLogsClient");
parcelHelpers.exportAll(_cloudWatchLogsClient, exports);
var _cloudWatchLogs = require("./CloudWatchLogs");
parcelHelpers.exportAll(_cloudWatchLogs, exports);
var _associateKmsKeyCommand = require("./commands/AssociateKmsKeyCommand");
parcelHelpers.exportAll(_associateKmsKeyCommand, exports);
var _cancelExportTaskCommand = require("./commands/CancelExportTaskCommand");
parcelHelpers.exportAll(_cancelExportTaskCommand, exports);
var _createExportTaskCommand = require("./commands/CreateExportTaskCommand");
parcelHelpers.exportAll(_createExportTaskCommand, exports);
var _createLogGroupCommand = require("./commands/CreateLogGroupCommand");
parcelHelpers.exportAll(_createLogGroupCommand, exports);
var _createLogStreamCommand = require("./commands/CreateLogStreamCommand");
parcelHelpers.exportAll(_createLogStreamCommand, exports);
var _deleteDestinationCommand = require("./commands/DeleteDestinationCommand");
parcelHelpers.exportAll(_deleteDestinationCommand, exports);
var _deleteLogGroupCommand = require("./commands/DeleteLogGroupCommand");
parcelHelpers.exportAll(_deleteLogGroupCommand, exports);
var _deleteLogStreamCommand = require("./commands/DeleteLogStreamCommand");
parcelHelpers.exportAll(_deleteLogStreamCommand, exports);
var _deleteMetricFilterCommand = require("./commands/DeleteMetricFilterCommand");
parcelHelpers.exportAll(_deleteMetricFilterCommand, exports);
var _deleteQueryDefinitionCommand = require("./commands/DeleteQueryDefinitionCommand");
parcelHelpers.exportAll(_deleteQueryDefinitionCommand, exports);
var _deleteResourcePolicyCommand = require("./commands/DeleteResourcePolicyCommand");
parcelHelpers.exportAll(_deleteResourcePolicyCommand, exports);
var _deleteRetentionPolicyCommand = require("./commands/DeleteRetentionPolicyCommand");
parcelHelpers.exportAll(_deleteRetentionPolicyCommand, exports);
var _deleteSubscriptionFilterCommand = require("./commands/DeleteSubscriptionFilterCommand");
parcelHelpers.exportAll(_deleteSubscriptionFilterCommand, exports);
var _describeDestinationsCommand = require("./commands/DescribeDestinationsCommand");
parcelHelpers.exportAll(_describeDestinationsCommand, exports);
var _describeDestinationsPaginator = require("./pagination/DescribeDestinationsPaginator");
parcelHelpers.exportAll(_describeDestinationsPaginator, exports);
var _describeExportTasksCommand = require("./commands/DescribeExportTasksCommand");
parcelHelpers.exportAll(_describeExportTasksCommand, exports);
var _describeLogGroupsCommand = require("./commands/DescribeLogGroupsCommand");
parcelHelpers.exportAll(_describeLogGroupsCommand, exports);
var _describeLogGroupsPaginator = require("./pagination/DescribeLogGroupsPaginator");
parcelHelpers.exportAll(_describeLogGroupsPaginator, exports);
var _describeLogStreamsCommand = require("./commands/DescribeLogStreamsCommand");
parcelHelpers.exportAll(_describeLogStreamsCommand, exports);
var _describeLogStreamsPaginator = require("./pagination/DescribeLogStreamsPaginator");
parcelHelpers.exportAll(_describeLogStreamsPaginator, exports);
var _describeMetricFiltersCommand = require("./commands/DescribeMetricFiltersCommand");
parcelHelpers.exportAll(_describeMetricFiltersCommand, exports);
var _describeMetricFiltersPaginator = require("./pagination/DescribeMetricFiltersPaginator");
parcelHelpers.exportAll(_describeMetricFiltersPaginator, exports);
var _describeQueriesCommand = require("./commands/DescribeQueriesCommand");
parcelHelpers.exportAll(_describeQueriesCommand, exports);
var _describeQueryDefinitionsCommand = require("./commands/DescribeQueryDefinitionsCommand");
parcelHelpers.exportAll(_describeQueryDefinitionsCommand, exports);
var _describeResourcePoliciesCommand = require("./commands/DescribeResourcePoliciesCommand");
parcelHelpers.exportAll(_describeResourcePoliciesCommand, exports);
var _describeSubscriptionFiltersCommand = require("./commands/DescribeSubscriptionFiltersCommand");
parcelHelpers.exportAll(_describeSubscriptionFiltersCommand, exports);
var _describeSubscriptionFiltersPaginator = require("./pagination/DescribeSubscriptionFiltersPaginator");
parcelHelpers.exportAll(_describeSubscriptionFiltersPaginator, exports);
var _disassociateKmsKeyCommand = require("./commands/DisassociateKmsKeyCommand");
parcelHelpers.exportAll(_disassociateKmsKeyCommand, exports);
var _filterLogEventsCommand = require("./commands/FilterLogEventsCommand");
parcelHelpers.exportAll(_filterLogEventsCommand, exports);
var _filterLogEventsPaginator = require("./pagination/FilterLogEventsPaginator");
parcelHelpers.exportAll(_filterLogEventsPaginator, exports);
var _getLogEventsCommand = require("./commands/GetLogEventsCommand");
parcelHelpers.exportAll(_getLogEventsCommand, exports);
var _getLogEventsPaginator = require("./pagination/GetLogEventsPaginator");
parcelHelpers.exportAll(_getLogEventsPaginator, exports);
var _getLogGroupFieldsCommand = require("./commands/GetLogGroupFieldsCommand");
parcelHelpers.exportAll(_getLogGroupFieldsCommand, exports);
var _getLogRecordCommand = require("./commands/GetLogRecordCommand");
parcelHelpers.exportAll(_getLogRecordCommand, exports);
var _getQueryResultsCommand = require("./commands/GetQueryResultsCommand");
parcelHelpers.exportAll(_getQueryResultsCommand, exports);
var _listTagsLogGroupCommand = require("./commands/ListTagsLogGroupCommand");
parcelHelpers.exportAll(_listTagsLogGroupCommand, exports);
var _putDestinationCommand = require("./commands/PutDestinationCommand");
parcelHelpers.exportAll(_putDestinationCommand, exports);
var _putDestinationPolicyCommand = require("./commands/PutDestinationPolicyCommand");
parcelHelpers.exportAll(_putDestinationPolicyCommand, exports);
var _putLogEventsCommand = require("./commands/PutLogEventsCommand");
parcelHelpers.exportAll(_putLogEventsCommand, exports);
var _putMetricFilterCommand = require("./commands/PutMetricFilterCommand");
parcelHelpers.exportAll(_putMetricFilterCommand, exports);
var _putQueryDefinitionCommand = require("./commands/PutQueryDefinitionCommand");
parcelHelpers.exportAll(_putQueryDefinitionCommand, exports);
var _putResourcePolicyCommand = require("./commands/PutResourcePolicyCommand");
parcelHelpers.exportAll(_putResourcePolicyCommand, exports);
var _putRetentionPolicyCommand = require("./commands/PutRetentionPolicyCommand");
parcelHelpers.exportAll(_putRetentionPolicyCommand, exports);
var _putSubscriptionFilterCommand = require("./commands/PutSubscriptionFilterCommand");
parcelHelpers.exportAll(_putSubscriptionFilterCommand, exports);
var _startQueryCommand = require("./commands/StartQueryCommand");
parcelHelpers.exportAll(_startQueryCommand, exports);
var _stopQueryCommand = require("./commands/StopQueryCommand");
parcelHelpers.exportAll(_stopQueryCommand, exports);
var _tagLogGroupCommand = require("./commands/TagLogGroupCommand");
parcelHelpers.exportAll(_tagLogGroupCommand, exports);
var _testMetricFilterCommand = require("./commands/TestMetricFilterCommand");
parcelHelpers.exportAll(_testMetricFilterCommand, exports);
var _untagLogGroupCommand = require("./commands/UntagLogGroupCommand");
parcelHelpers.exportAll(_untagLogGroupCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./CloudWatchLogsClient":"i8wCc","./CloudWatchLogs":false,"./commands/AssociateKmsKeyCommand":false,"./commands/CancelExportTaskCommand":false,"./commands/CreateExportTaskCommand":false,"./commands/CreateLogGroupCommand":"8RjO6","./commands/CreateLogStreamCommand":"9C9RJ","./commands/DeleteDestinationCommand":false,"./commands/DeleteLogGroupCommand":false,"./commands/DeleteLogStreamCommand":false,"./commands/DeleteMetricFilterCommand":false,"./commands/DeleteQueryDefinitionCommand":false,"./commands/DeleteResourcePolicyCommand":false,"./commands/DeleteRetentionPolicyCommand":false,"./commands/DeleteSubscriptionFilterCommand":false,"./commands/DescribeDestinationsCommand":false,"./pagination/DescribeDestinationsPaginator":false,"./commands/DescribeExportTasksCommand":false,"./commands/DescribeLogGroupsCommand":"6i2Hb","./pagination/DescribeLogGroupsPaginator":false,"./commands/DescribeLogStreamsCommand":"ceYdg","./pagination/DescribeLogStreamsPaginator":false,"./commands/DescribeMetricFiltersCommand":false,"./pagination/DescribeMetricFiltersPaginator":false,"./commands/DescribeQueriesCommand":false,"./commands/DescribeQueryDefinitionsCommand":false,"./commands/DescribeResourcePoliciesCommand":false,"./commands/DescribeSubscriptionFiltersCommand":false,"./pagination/DescribeSubscriptionFiltersPaginator":false,"./commands/DisassociateKmsKeyCommand":false,"./commands/FilterLogEventsCommand":false,"./pagination/FilterLogEventsPaginator":false,"./commands/GetLogEventsCommand":"78xAw","./pagination/GetLogEventsPaginator":false,"./commands/GetLogGroupFieldsCommand":false,"./commands/GetLogRecordCommand":false,"./commands/GetQueryResultsCommand":false,"./commands/ListTagsLogGroupCommand":false,"./commands/PutDestinationCommand":false,"./commands/PutDestinationPolicyCommand":false,"./commands/PutLogEventsCommand":"kEN1N","./commands/PutMetricFilterCommand":false,"./commands/PutQueryDefinitionCommand":false,"./commands/PutResourcePolicyCommand":false,"./commands/PutRetentionPolicyCommand":false,"./commands/PutSubscriptionFilterCommand":false,"./commands/StartQueryCommand":false,"./commands/StopQueryCommand":false,"./commands/TagLogGroupCommand":false,"./commands/TestMetricFilterCommand":false,"./commands/UntagLogGroupCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8wCc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloudWatchLogsClient", ()=>CloudWatchLogsClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>You can use Amazon CloudWatch Logs to monitor, store, and access your log files from
 *       EC2 instances, AWS CloudTrail, or other sources. You can then retrieve the associated
 *       log data from CloudWatch Logs using the CloudWatch console, CloudWatch Logs commands in the
 *       AWS CLI, CloudWatch Logs API, or CloudWatch Logs SDK.</p>
 *          <p>You can use CloudWatch Logs to:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <b>Monitor logs from EC2 instances in real-time</b>: You
 *           can use CloudWatch Logs to monitor applications and systems using log data. For example,
 *           CloudWatch Logs can track the number of errors that occur in your application logs and
 *           send you a notification whenever the rate of errors exceeds a threshold that you specify.
 *           CloudWatch Logs uses your log data for monitoring so no code changes are required. For
 *           example, you can monitor application logs for specific literal terms (such as
 *           "NullReferenceException") or count the number of occurrences of a literal term at a
 *           particular position in log data (such as "404" status codes in an Apache access log). When
 *           the term you are searching for is found, CloudWatch Logs reports the data to a CloudWatch
 *           metric that you specify.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Monitor AWS CloudTrail logged events</b>: You can
 *           create alarms in CloudWatch and receive notifications of particular API activity as
 *           captured by CloudTrail. You can use the notification to perform troubleshooting.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Archive log data</b>: You can use CloudWatch Logs to
 *           store your log data in highly durable storage. You can change the log retention setting so
 *           that any log events older than this setting are automatically deleted. The CloudWatch Logs
 *           agent makes it easy to quickly send both rotated and non-rotated log data off of a host
 *           and into the log service. You can then access the raw log data when you need it.</p>
 *             </li>
 *          </ul>
 */ var CloudWatchLogsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(CloudWatchLogsClient, _super);
    function CloudWatchLogsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    CloudWatchLogsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return CloudWatchLogsClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"6vI83","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86BcK":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6vI83":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"1aR25","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"8HQZt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1aR25":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-cloudwatch-logs","description":"AWS SDK for JavaScript Cloudwatch Logs Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cloudwatch-logs","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cloudwatch-logs"}}');

},{}],"cEl0z":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("62ec12493516a334");
(0, tslib_1.__exportStar)(require("e099a4a7ffb231f5"), exports);
var ie11Sha256_1 = require("de15e02776b0e316");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("8c4446d1ab49a729");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"62ec12493516a334":"d2ymI","e099a4a7ffb231f5":"tOtTN","de15e02776b0e316":"kytpI","8c4446d1ab49a729":"kyDUK"}],"d2ymI":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tOtTN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("a7f146ad1f3cbfc1");
var webCryptoSha256_1 = require("725c2de9fef54f64");
var sha256_js_1 = require("acd71c1991c101d8");
var supports_web_crypto_1 = require("b78851f350642902");
var ie11_detection_1 = require("d3a26cad479a1048");
var util_locate_window_1 = require("cb5027cfddf0ae5a");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"a7f146ad1f3cbfc1":"kytpI","725c2de9fef54f64":"kyDUK","acd71c1991c101d8":"1pg4I","b78851f350642902":"g0Ghc","d3a26cad479a1048":"gJG7X","cb5027cfddf0ae5a":"ljvil"}],"kytpI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("d8dc3989d6db06cb");
var constants_1 = require("d71db60dd455789b");
var util_utf8_browser_1 = require("b2a4d6e137ed6620");
var util_locate_window_1 = require("fb05deefe8f5231");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"d8dc3989d6db06cb":"eRP7L","d71db60dd455789b":"afoh6","b2a4d6e137ed6620":"iZmxX","fb05deefe8f5231":"ljvil"}],"eRP7L":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"afoh6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"ljvil":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locateWindow", ()=>locateWindow);
const fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return fallbackWindow;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kyDUK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("fd29082ab97241f2");
var constants_1 = require("a96b793b8f5ad16");
var util_locate_window_1 = require("3b3155587be8430d");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"fd29082ab97241f2":"1R05H","a96b793b8f5ad16":"afoh6","3b3155587be8430d":"ljvil"}],"g0Ghc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("77b6e702e4b0428a");
tslib_1.__exportStar(require("150bdc65f19f6fe8"), exports);

},{"77b6e702e4b0428a":"g9b8h","150bdc65f19f6fe8":"36D44"}],"g9b8h":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"36D44":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("d9d4edfd7f160da1");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"d9d4edfd7f160da1":"g9b8h"}],"gJG7X":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("349d4ad1a84f9391");
tslib_1.__exportStar(require("21db5ac52614a3fc"), exports);
tslib_1.__exportStar(require("d258f06221e01140"), exports);
tslib_1.__exportStar(require("ffb697f6ff78bfa1"), exports);
tslib_1.__exportStar(require("84552afc7d264010"), exports);
tslib_1.__exportStar(require("14b671c7aac632d"), exports);

},{"349d4ad1a84f9391":"4eh7s","21db5ac52614a3fc":"1ppqY","d258f06221e01140":"8zSRZ","ffb697f6ff78bfa1":"84MMK","84552afc7d264010":"7Y1ON","14b671c7aac632d":"6xkTm"}],"4eh7s":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ppqY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"8zSRZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"84MMK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"7Y1ON":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"6xkTm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"lTbku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"hgriS","./stream-collector":"irsLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hgriS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, _querystringBuilder.buildQueryString)(request.query);
            if (queryString) path += "?" + queryString;
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function(response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, _protocolHttp.HttpResponse)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, _protocolHttp.HttpResponse)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();

},{"tslib":"fMoho","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/querystring-builder":"4emBh","./request-timeout":"5eapE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMoho":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bfGiN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpResponse":"foxxV","./httpRequest":"28uGN","./httpHandler":"NqDLG","./isValidHostname":"iKte5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"foxxV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = /** @class */ function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        //determine if response is a valid HttpResponse
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28uGN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = /** @class */ function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.substr(-1) !== ":" ? options.protocol + ":" : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/" + options.path : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        //determine if request is a valid httpRequest
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"tslib":"dxGSc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxGSc":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"NqDLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iKte5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4emBh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push(key + "=" + (0, _utilUriEscape.escapeUri)(value[i]));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=" + (0, _utilUriEscape.escapeUri)(value);
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"6XdAl","@aws-sdk/util-uri-escape":"ZXyQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6XdAl":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ZXyQp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"7x4pk","./escape-uri-path":"aAhtl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7x4pk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aAhtl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"7x4pk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5eapE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irsLI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2 /*return*/ ,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"fMoho","@aws-sdk/util-base64-browser":"kTMBh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kTMBh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a base-64 encoded string to a Uint8Array of bytes.
 *
 * @param input The base-64 encoded string
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
/**
 * Converts a Uint8Array of binary data to a base-64 encoded string.
 *
 * @param input The binary data to encode
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */ parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.substr(-2) === "==") totalByteLength -= 2;
    else if (input.substr(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iUhkq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"8nmMY","./invalidProvider":"5mTWt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nmMY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5mTWt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"822il":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _defaultStrategy = require("./defaultStrategy");
parcelHelpers.exportAll(_defaultStrategy, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);

},{"./retryMiddleware":"fKUIX","./omitRetryHeadersMiddleware":"af8k9","./defaultStrategy":"7PTol","./configurations":"4nYBT","./delayDecider":"eeqB6","./retryDecider":"3t0qz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKUIX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode) context.userAgent = (0, _tslib.__spread)(context.userAgent || [], [
                        [
                            "cfg/retry-mode",
                            options.retryStrategy.mode
                        ]
                    ]);
                    return [
                        2 /*return*/ ,
                        options.retryStrategy.retry(next, args)
                    ];
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"9kFzn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9kFzn":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"af8k9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"9kFzn","@aws-sdk/protocol-http":"bfGiN","./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"co8Un":[function(require,module,exports) {
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7PTol":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = "standard";
var StandardRetryStrategy = /** @class */ function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = DEFAULT_RETRY_MODE;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = DEFAULT_MAX_ATTEMPTS;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4 /*yield*/ ,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _a, response, output, err_1, delay_1;
                            return (0, _tslib.__generator)(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        _b.trys.push([
                                            0,
                                            2,
                                            ,
                                            5
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        return [
                                            4 /*yield*/ ,
                                            next(args)
                                        ];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2 /*return*/ ,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err_1) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        totalDelay += delay_1;
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 3:
                                        _b.sent();
                                        return [
                                            2 /*return*/ ,
                                            "continue"
                                        ];
                                    case 4:
                                        if (!err_1.$metadata) err_1.$metadata = {};
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5 /*yield**/ ,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2 /*return*/ ,
                            state_1.value
                        ];
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();

},{"tslib":"9kFzn","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/service-error-classification":"iFCvv","uuid":"fMzf5","./constants":"co8Un","./defaultRetryQuota":"kbRba","./delayDecider":"eeqB6","./retryDecider":"3t0qz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFCvv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"aefPg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aefPg":[function(require,module,exports) {
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMzf5":[function(require,module,exports) {
var v1 = require("39836eaa6e4429b8");
var v4 = require("543fc0431cefe6cb");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"39836eaa6e4429b8":"jT9wy","543fc0431cefe6cb":"bp3VX"}],"jT9wy":[function(require,module,exports) {
var rng = require("7fe43858ce7fcaa");
var bytesToUuid = require("b3db1b6bec99ef4e");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"7fe43858ce7fcaa":"hlmCx","b3db1b6bec99ef4e":"a8nHo"}],"hlmCx":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"a8nHo":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"bp3VX":[function(require,module,exports) {
var rng = require("79b9dbd5219ea043");
var bytesToUuid = require("15f020f715f050ac");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"79b9dbd5219ea043":"hlmCx","15f020f715f050ac":"a8nHo"}],"kbRba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? (0, _constants.TIMEOUT_RETRY_COST) : (0, _constants.RETRY_COST);
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) // retryStrategy should stop retrying, and return last error
        throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : (0, _constants.NO_RETRY_INCREMENT);
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eeqB6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"co8Un","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3t0qz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"iFCvv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4nYBT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _defaultStrategy = require("./defaultStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable " + ENV_MAX_ATTEMPTS + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry " + CONFIG_MAX_ATTEMPTS + ' mast be a number, got "' + value + '"');
        return maxAttempt;
    },
    default: (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var maxAttempts = normalizeMaxAttempts(input.maxAttempts);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: input.retryStrategy || new (0, _defaultStrategy.StandardRetryStrategy)(maxAttempts)
    });
};
var normalizeMaxAttempts = function(maxAttempts) {
    if (maxAttempts === void 0) maxAttempts = (0, _defaultStrategy.DEFAULT_MAX_ATTEMPTS);
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function() {
            return promisified_1;
        };
    }
    return maxAttempts;
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _defaultStrategy.DEFAULT_RETRY_MODE)
};

},{"tslib":"9kFzn","./defaultStrategy":"7PTol","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jY9Ci":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
        }
        return len;
    } else if (typeof body.byteLength === "number") // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
    return body.byteLength;
    else if (typeof body.size === "number") // handles browser File object
    return body.size;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ohFm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    // sdk-metadata
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    // os-metadata
                    [
                        "os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    // language-metadata
                    // ECMAScript edition doesn't matter in JS.
                    [
                        "lang/js"
                    ],
                    // browser vendor and version.
                    [
                        "md/browser",
                        ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push([
                    "api/" + serviceId,
                    clientVersion
                ]);
                return [
                    2 /*return*/ ,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"3yM1h","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3yM1h":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"E5jm7":[function(require,module,exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

},{}],"8HQZt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2014-03-28",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "CloudWatch Logs",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"7Nxeq","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Nxeq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "logs.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "logs.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "logs.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "logs.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "logs.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "logs.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "logs.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "logs.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "logs.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "logs.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "logs.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "logs.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "logs.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "logs.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "logs.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "logs.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "logs.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "logs.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "logs.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "logs.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "logs-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "logs-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "logs-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "logs-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "logs.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "logs.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "logs.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "logs.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "logs.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "logs.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "logs.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "logs.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "logs.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "logs.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "logs"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3j6kE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"2AIKk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2AIKk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"5ZoIK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ZoIK":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kfZQF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./EndpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./RegionConfig");
parcelHelpers.exportAll(_regionConfig, exports);

},{"./EndpointsConfig":"aLbhN","./RegionConfig":"litQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aLbhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var resolveEndpointsConfig = function(input) {
    var _a;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: input.endpoint ? normalizeEndpoint(input) : function() {
            return getEndPointFromRegion(input);
        },
        isCustomEndpoint: input.endpoint ? true : false
    });
};
var normalizeEndpoint = function(input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function() {
            return promisified_1;
        };
    } else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function() {
            return promisified_2;
        };
    }
    return endpoint;
};
var getEndPointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4 /*yield*/ ,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4 /*yield*/ ,
                        input.regionInfoProvider(region)
                    ];
                case 2:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2 /*return*/ ,
                        input.urlParser((tls ? "https:" : "http:") + "//" + hostname)
                    ];
            }
        });
    });
};

},{"tslib":"2mqK7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2mqK7":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"litQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};
var resolveRegionConfig = function(input) {
    if (!input.region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: normalizeRegion(input.region)
    });
};
var normalizeRegion = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    }
    return region;
};

},{"tslib":"2mqK7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g0Zhq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
                            length = bodyLengthChecker(body);
                            if (length !== undefined) request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
                        }
                    }
                    return [
                        2 /*return*/ ,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"al6FD","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"al6FD":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jHFHF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2 /*return*/ ,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    //For H2 request, remove 'host' header and use ':authority' header instead
                    //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2 /*return*/ ,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"bs2Dn","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bs2Dn":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dyXzC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"dLrTw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dLrTw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2 /*return*/ ,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"cMvRZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMvRZ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"chM5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"kLesP","./middleware":"dviJz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kLesP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
var _tslib = require("tslib");
var _signatureV4 = require("@aws-sdk/signature-v4");
function resolveAwsAuthConfig(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) //if signer is supplied by user, normalize it to a function returning a promise for signer.
    signer = normalizeProvider(input.signer);
    else //construct a provider inferring signing from region.
    signer = function() {
        return normalizeProvider(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                input.regionInfoProvider(region)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                [
                                    _a.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            //update client's singing region and signing service config if they are resolved.
            //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
            input.signingRegion = input.signingRegion || signingRegion || region;
            //signing name resolving order:
            //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
            input.signingName = input.signingName || signingService || input.serviceId;
            return new (0, _signatureV4.SignatureV4)({
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
}
function normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function() {
            return promisified_1;
        };
    }
    return input;
}

},{"tslib":"cRT7q","@aws-sdk/signature-v4":"3LPO6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cRT7q":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LPO6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);

},{"./credentialDerivation":"gA2T8","./SignatureV4":"1MViS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gA2T8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */ parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
/**
 * @internal
 */ parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
function createScope(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + (0, _constants.KEY_TYPE_IDENTIFIER);
}
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = shortDate + ":" + region + ":" + service + ":" + (0, _utilHexEncoding.toHex)(credsHash) + ":" + credentials.sessionToken;
                    if (cacheKey in signingKeyCache) return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4" + credentials.secretAccessKey;
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4 /*yield*/ ,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ ,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
}
function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}

},{"tslib":"gTWgQ","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gTWgQ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1UGiB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1MViS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _hasHeader = require("./hasHeader");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = /** @class */ function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = normalizeRegionProvider(region);
        this.credentialProvider = normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2 /*return*/ ,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = credentials.accessKeyId + "/" + scope;
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2 /*return*/ ,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2 /*return*/ ,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2 /*return*/ ,
                    this.signRequest(toSign, options)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2 /*return*/ ,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4 /*yield*/ ,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _hasHeader.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4 /*yield*/ ,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = (0, _constants.ALGORITHM_IDENTIFIER) + " " + ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") + ("SignedHeaders=" + getCanonicalHeaderList(canonicalHeaders) + ", ") + ("Signature=" + signature);
                        return [
                            2 /*return*/ ,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + (0, _getCanonicalQuery.getCanonicalQuery)(request) + "\n" + sortedHeaders.map(function(name) {
            return name + ":" + canonicalHeaders[name];
        }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, _constants.ALGORITHM_IDENTIFIER) + "\n" + longDate + "\n" + credentialScope + "\n" + (0, _utilHexEncoding.toHex)(hashedRequest)
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4 /*yield*/ ,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4 /*yield*/ ,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};
var normalizeRegionProvider = function(region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function() {
            return promisified_1;
        };
    } else return region;
};
var normalizeCredentialsProvider = function(credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function() {
            return promisified_2;
        };
    } else return credentials;
};

},{"tslib":"gTWgQ","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","./credentialDerivation":"gA2T8","./getCanonicalHeaders":"3fcRk","./getCanonicalQuery":"6bGAS","./getPayloadHash":"3dDIV","./hasHeader":"5Atvk","./moveHeadersToQuery":"lsriS","./prepareRequest":"lxoo5","./utilDate":"6CtpL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fcRk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
}

},{"tslib":"gTWgQ","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6bGAS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value);
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                (0, _utilUriEscape.escapeUri)(key) + "=" + (0, _utilUriEscape.escapeUri)(value)
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }) // omit any falsy values
    .join("&");
}

},{"tslib":"gTWgQ","@aws-sdk/util-uri-escape":"ZXyQp","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3dDIV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2 /*return*/ ,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    return [
                        2 /*return*/ ,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3 /*break*/ ,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4 /*yield*/ ,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    // As any defined body that is not a string or binary data is a stream, this
                    // body is unsignable. Attempt to send the request with an unsigned payload,
                    // which may or may not be accepted by the service.
                    return [
                        2 /*return*/ ,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
}

},{"tslib":"gTWgQ","@aws-sdk/is-array-buffer":"jH4ux","@aws-sdk/util-hex-encoding":"dTdhV","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jH4ux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Atvk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
var _tslib = require("tslib");
function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

},{"tslib":"gTWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lsriS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
}

},{"tslib":"gTWgQ","./cloneRequest":"b3SzD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b3SzD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
var _tslib = require("tslib");
function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
}
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spread)(param) : param, _a));
    }, {});
}

},{"tslib":"gTWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lxoo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
function prepareRequest(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
}

},{"tslib":"gTWgQ","./cloneRequest":"b3SzD","./constants":"1UGiB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6CtpL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
function iso8601(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function toDate(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dviJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var isClockSkewed = function(newServerTime, systemClockOffset) {
    return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};
function awsAuthMiddleware(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            if (!(typeof options.signer === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                options.signer()
                            ];
                        case 1:
                            _a = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _d = {};
                            return [
                                4 /*yield*/ ,
                                signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 4:
                            return [
                                4 /*yield*/ ,
                                _b.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _c.concat([
                                        (_d.request = _e.sent(), _d)
                                    ]))
                                ])
                            ];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if (isClockSkewed(serverTime, options.systemClockOffset)) options.systemClockOffset = serverTime - Date.now();
                            }
                            return [
                                2 /*return*/ ,
                                output
                            ];
                    }
                });
            });
        };
    };
}
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};

},{"tslib":"cRT7q","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kIyUO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"2QXGp","./user-agent-middleware":"dvaiR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2QXGp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"eqDkx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eqDkx":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dvaiR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2 /*return*/ ,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4 /*yield*/ ,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            // Set value to AWS-specific user agent header
                            headers[0, _constants.X_AMZ_USER_AGENT] = (0, _tslib.__spread)(defaultUserAgent, userAgent, customUserAgent).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spread)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            }), customUserAgent).join((0, _constants.SPACE));
                            if (options.runtime !== "browser" && normalUAValue) headers[0, _constants.USER_AGENT] = headers[0, _constants.USER_AGENT] ? headers[0, _constants.USER_AGENT] + " " + normalUAValue : normalUAValue;
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */ var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"eqDkx","@aws-sdk/protocol-http":"bfGiN","./constants":"h3KjP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h3KjP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6UNh4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _documentType = require("./document-type");
parcelHelpers.exportAll(_documentType, exports);
var _exception = require("./exception");
parcelHelpers.exportAll(_exception, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _retryableTrait = require("./retryable-trait");
parcelHelpers.exportAll(_retryableTrait, exports);
var _sdkError = require("./sdk-error");
parcelHelpers.exportAll(_sdkError, exports);

},{"./client":"cld3U","./command":"4ml49","./document-type":"eOcGT","./exception":"2qkZF","./extended-encode-uri-component":"boRvB","./get-array-if-single-item":"gPMPO","./get-value-from-text-node":"lCOpr","./lazy-json":"cnq16","./date-utils":"c5TbK","./split-every":"dmF0m","./constants":"ld9uE","./retryable-trait":"bSQ1d","./sdk-error":"bLYLt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cld3U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = /** @class */ function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(// prevent any errors thrown in the callback from triggering an
        // unhandled promise rejection
        function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"jfbQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jfbQp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"6f5BJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6f5BJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spread)(expandRelativeMiddlewareList(entry)));
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */ var getMiddlewareList = function() {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, (0, _tslib.__spread)(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function(entry) {
            return entry.middleware;
        });
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"' + name + '" middleware with ' + toOverride.priority + " priority in " + toOverride.step + " step cannot be " + ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"' + name + '" middleware ' + toOverride.relation + ' "' + toOverride.toMiddleware + '" middleware cannot be overridden ' + ("by same-name middleware " + entry.relation + ' "' + entry.toMiddleware + '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"4ZbuQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ZbuQ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ml49":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = /** @class */ function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"jfbQp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eOcGT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2qkZF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boRvB":[function(require,module,exports) {
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gPMPO":[function(require,module,exports) {
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lCOpr":[function(require,module,exports) {
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cnq16":[function(require,module,exports) {
/**
 * Lazy String holder for JSON typed contents.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spread)([
        null
    ], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = /** @class */ function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"d1ysp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d1ysp":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5TbK":[function(require,module,exports) {
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */ // Build indexes outside so we allocate them once.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
var days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
// prettier-ignore
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return days[dayOfWeek] + ", " + dayOfMonthString + " " + months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dmF0m":[function(require,module,exports) {
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") // Start a new segment.
        currentSegment = segments[i];
        else // Compound the current segment with the delimiter.
        currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ld9uE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bSQ1d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bLYLt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8RjO6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogGroupCommand", ()=>CreateLogGroupCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log group with the specified name. You can create up to 20,000 log groups per account.</p>
 *          <p>You must use the following guidelines when naming a log group:</p>
 *          <ul>
 *             <li>
 *                <p>Log group names must be unique within a region for an AWS account.</p>
 *             </li>
 *             <li>
 *                <p>Log group names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>Log group names consist of the following characters: a-z, A-Z, 0-9, '_' (underscore), '-' (hyphen),
 *           '/' (forward slash), '.' (period), and '#' (number sign)</p>
 *             </li>
 *          </ul>
 *          <p>When you create a log group, by default the log events in the log group never expire. To set
 *     a retention policy so that events expire and are deleted after a specified time, use
 *       <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutRetentionPolicy.html">PutRetentionPolicy</a>.</p>
 *          <p>If you associate a AWS Key Management Service (AWS KMS) customer master key (CMK) with the log group, ingested data is encrypted using the CMK.
 *       This association is stored as long as the data encrypted with the CMK is still within Amazon CloudWatch Logs.
 *       This enables Amazon CloudWatch Logs to decrypt this data whenever it is requested.</p>
 *          <p>If you attempt to associate a CMK with the log group but the CMK does not exist or the
 *       CMK is disabled, you receive an <code>InvalidParameterException</code> error. </p>
 *          <important>
 *             <p> CloudWatch Logs supports only symmetric CMKs. Do not associate an asymmetric CMK with
 *         your log group. For more information, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric
 *           Keys</a>.</p>
 *          </important>
 */ var CreateLogGroupCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogGroupCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogGroupCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogGroupRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogGroupCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogGroupCommand)(input, context);
    };
    CreateLogGroupCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogGroupCommand)(output, context);
    };
    return CreateLogGroupCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZkQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssociateKmsKeyRequest", ()=>AssociateKmsKeyRequest);
parcelHelpers.export(exports, "InvalidParameterException", ()=>InvalidParameterException);
parcelHelpers.export(exports, "OperationAbortedException", ()=>OperationAbortedException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "ServiceUnavailableException", ()=>ServiceUnavailableException);
parcelHelpers.export(exports, "CancelExportTaskRequest", ()=>CancelExportTaskRequest);
parcelHelpers.export(exports, "InvalidOperationException", ()=>InvalidOperationException);
parcelHelpers.export(exports, "CreateExportTaskRequest", ()=>CreateExportTaskRequest);
parcelHelpers.export(exports, "CreateExportTaskResponse", ()=>CreateExportTaskResponse);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceAlreadyExistsException", ()=>ResourceAlreadyExistsException);
parcelHelpers.export(exports, "CreateLogGroupRequest", ()=>CreateLogGroupRequest);
parcelHelpers.export(exports, "CreateLogStreamRequest", ()=>CreateLogStreamRequest);
parcelHelpers.export(exports, "DataAlreadyAcceptedException", ()=>DataAlreadyAcceptedException);
parcelHelpers.export(exports, "DeleteDestinationRequest", ()=>DeleteDestinationRequest);
parcelHelpers.export(exports, "DeleteLogGroupRequest", ()=>DeleteLogGroupRequest);
parcelHelpers.export(exports, "DeleteLogStreamRequest", ()=>DeleteLogStreamRequest);
parcelHelpers.export(exports, "DeleteMetricFilterRequest", ()=>DeleteMetricFilterRequest);
parcelHelpers.export(exports, "DeleteQueryDefinitionRequest", ()=>DeleteQueryDefinitionRequest);
parcelHelpers.export(exports, "DeleteQueryDefinitionResponse", ()=>DeleteQueryDefinitionResponse);
parcelHelpers.export(exports, "DeleteResourcePolicyRequest", ()=>DeleteResourcePolicyRequest);
parcelHelpers.export(exports, "DeleteRetentionPolicyRequest", ()=>DeleteRetentionPolicyRequest);
parcelHelpers.export(exports, "DeleteSubscriptionFilterRequest", ()=>DeleteSubscriptionFilterRequest);
parcelHelpers.export(exports, "DescribeDestinationsRequest", ()=>DescribeDestinationsRequest);
parcelHelpers.export(exports, "Destination", ()=>Destination);
parcelHelpers.export(exports, "DescribeDestinationsResponse", ()=>DescribeDestinationsResponse);
parcelHelpers.export(exports, "ExportTaskStatusCode", ()=>ExportTaskStatusCode);
parcelHelpers.export(exports, "DescribeExportTasksRequest", ()=>DescribeExportTasksRequest);
parcelHelpers.export(exports, "ExportTaskExecutionInfo", ()=>ExportTaskExecutionInfo);
parcelHelpers.export(exports, "ExportTaskStatus", ()=>ExportTaskStatus);
parcelHelpers.export(exports, "ExportTask", ()=>ExportTask);
parcelHelpers.export(exports, "DescribeExportTasksResponse", ()=>DescribeExportTasksResponse);
parcelHelpers.export(exports, "DescribeLogGroupsRequest", ()=>DescribeLogGroupsRequest);
parcelHelpers.export(exports, "LogGroup", ()=>LogGroup);
parcelHelpers.export(exports, "DescribeLogGroupsResponse", ()=>DescribeLogGroupsResponse);
parcelHelpers.export(exports, "OrderBy", ()=>OrderBy);
parcelHelpers.export(exports, "DescribeLogStreamsRequest", ()=>DescribeLogStreamsRequest);
parcelHelpers.export(exports, "LogStream", ()=>LogStream);
parcelHelpers.export(exports, "DescribeLogStreamsResponse", ()=>DescribeLogStreamsResponse);
parcelHelpers.export(exports, "DescribeMetricFiltersRequest", ()=>DescribeMetricFiltersRequest);
parcelHelpers.export(exports, "MetricTransformation", ()=>MetricTransformation);
parcelHelpers.export(exports, "MetricFilter", ()=>MetricFilter);
parcelHelpers.export(exports, "DescribeMetricFiltersResponse", ()=>DescribeMetricFiltersResponse);
parcelHelpers.export(exports, "QueryStatus", ()=>QueryStatus);
parcelHelpers.export(exports, "DescribeQueriesRequest", ()=>DescribeQueriesRequest);
parcelHelpers.export(exports, "QueryInfo", ()=>QueryInfo);
parcelHelpers.export(exports, "DescribeQueriesResponse", ()=>DescribeQueriesResponse);
parcelHelpers.export(exports, "DescribeQueryDefinitionsRequest", ()=>DescribeQueryDefinitionsRequest);
parcelHelpers.export(exports, "QueryDefinition", ()=>QueryDefinition);
parcelHelpers.export(exports, "DescribeQueryDefinitionsResponse", ()=>DescribeQueryDefinitionsResponse);
parcelHelpers.export(exports, "DescribeResourcePoliciesRequest", ()=>DescribeResourcePoliciesRequest);
parcelHelpers.export(exports, "ResourcePolicy", ()=>ResourcePolicy);
parcelHelpers.export(exports, "DescribeResourcePoliciesResponse", ()=>DescribeResourcePoliciesResponse);
parcelHelpers.export(exports, "DescribeSubscriptionFiltersRequest", ()=>DescribeSubscriptionFiltersRequest);
parcelHelpers.export(exports, "Distribution", ()=>Distribution);
parcelHelpers.export(exports, "SubscriptionFilter", ()=>SubscriptionFilter);
parcelHelpers.export(exports, "DescribeSubscriptionFiltersResponse", ()=>DescribeSubscriptionFiltersResponse);
parcelHelpers.export(exports, "DisassociateKmsKeyRequest", ()=>DisassociateKmsKeyRequest);
parcelHelpers.export(exports, "FilteredLogEvent", ()=>FilteredLogEvent);
parcelHelpers.export(exports, "FilterLogEventsRequest", ()=>FilterLogEventsRequest);
parcelHelpers.export(exports, "SearchedLogStream", ()=>SearchedLogStream);
parcelHelpers.export(exports, "FilterLogEventsResponse", ()=>FilterLogEventsResponse);
parcelHelpers.export(exports, "GetLogEventsRequest", ()=>GetLogEventsRequest);
parcelHelpers.export(exports, "OutputLogEvent", ()=>OutputLogEvent);
parcelHelpers.export(exports, "GetLogEventsResponse", ()=>GetLogEventsResponse);
parcelHelpers.export(exports, "GetLogGroupFieldsRequest", ()=>GetLogGroupFieldsRequest);
parcelHelpers.export(exports, "LogGroupField", ()=>LogGroupField);
parcelHelpers.export(exports, "GetLogGroupFieldsResponse", ()=>GetLogGroupFieldsResponse);
parcelHelpers.export(exports, "GetLogRecordRequest", ()=>GetLogRecordRequest);
parcelHelpers.export(exports, "GetLogRecordResponse", ()=>GetLogRecordResponse);
parcelHelpers.export(exports, "GetQueryResultsRequest", ()=>GetQueryResultsRequest);
parcelHelpers.export(exports, "ResultField", ()=>ResultField);
parcelHelpers.export(exports, "QueryStatistics", ()=>QueryStatistics);
parcelHelpers.export(exports, "GetQueryResultsResponse", ()=>GetQueryResultsResponse);
parcelHelpers.export(exports, "InputLogEvent", ()=>InputLogEvent);
parcelHelpers.export(exports, "InvalidSequenceTokenException", ()=>InvalidSequenceTokenException);
parcelHelpers.export(exports, "ListTagsLogGroupRequest", ()=>ListTagsLogGroupRequest);
parcelHelpers.export(exports, "ListTagsLogGroupResponse", ()=>ListTagsLogGroupResponse);
parcelHelpers.export(exports, "PutDestinationRequest", ()=>PutDestinationRequest);
parcelHelpers.export(exports, "PutDestinationResponse", ()=>PutDestinationResponse);
parcelHelpers.export(exports, "PutDestinationPolicyRequest", ()=>PutDestinationPolicyRequest);
parcelHelpers.export(exports, "PutLogEventsRequest", ()=>PutLogEventsRequest);
parcelHelpers.export(exports, "RejectedLogEventsInfo", ()=>RejectedLogEventsInfo);
parcelHelpers.export(exports, "PutLogEventsResponse", ()=>PutLogEventsResponse);
parcelHelpers.export(exports, "UnrecognizedClientException", ()=>UnrecognizedClientException);
parcelHelpers.export(exports, "PutMetricFilterRequest", ()=>PutMetricFilterRequest);
parcelHelpers.export(exports, "PutQueryDefinitionRequest", ()=>PutQueryDefinitionRequest);
parcelHelpers.export(exports, "PutQueryDefinitionResponse", ()=>PutQueryDefinitionResponse);
parcelHelpers.export(exports, "PutResourcePolicyRequest", ()=>PutResourcePolicyRequest);
parcelHelpers.export(exports, "PutResourcePolicyResponse", ()=>PutResourcePolicyResponse);
parcelHelpers.export(exports, "PutRetentionPolicyRequest", ()=>PutRetentionPolicyRequest);
parcelHelpers.export(exports, "PutSubscriptionFilterRequest", ()=>PutSubscriptionFilterRequest);
parcelHelpers.export(exports, "QueryCompileErrorLocation", ()=>QueryCompileErrorLocation);
parcelHelpers.export(exports, "QueryCompileError", ()=>QueryCompileError);
parcelHelpers.export(exports, "MalformedQueryException", ()=>MalformedQueryException);
parcelHelpers.export(exports, "StartQueryRequest", ()=>StartQueryRequest);
parcelHelpers.export(exports, "StartQueryResponse", ()=>StartQueryResponse);
parcelHelpers.export(exports, "StopQueryRequest", ()=>StopQueryRequest);
parcelHelpers.export(exports, "StopQueryResponse", ()=>StopQueryResponse);
parcelHelpers.export(exports, "TagLogGroupRequest", ()=>TagLogGroupRequest);
parcelHelpers.export(exports, "TestMetricFilterRequest", ()=>TestMetricFilterRequest);
parcelHelpers.export(exports, "MetricFilterMatchRecord", ()=>MetricFilterMatchRecord);
parcelHelpers.export(exports, "TestMetricFilterResponse", ()=>TestMetricFilterResponse);
parcelHelpers.export(exports, "UntagLogGroupRequest", ()=>UntagLogGroupRequest);
var _tslib = require("tslib");
var AssociateKmsKeyRequest;
(function(AssociateKmsKeyRequest) {
    AssociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
var InvalidParameterException;
(function(InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidParameterException || (InvalidParameterException = {}));
var OperationAbortedException;
(function(OperationAbortedException) {
    OperationAbortedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OperationAbortedException || (OperationAbortedException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var CancelExportTaskRequest;
(function(CancelExportTaskRequest) {
    CancelExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
var InvalidOperationException;
(function(InvalidOperationException) {
    InvalidOperationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidOperationException || (InvalidOperationException = {}));
var CreateExportTaskRequest;
(function(CreateExportTaskRequest) {
    CreateExportTaskRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
var CreateExportTaskResponse;
(function(CreateExportTaskResponse) {
    CreateExportTaskResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceAlreadyExistsException;
(function(ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
var CreateLogGroupRequest;
(function(CreateLogGroupRequest) {
    CreateLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
var CreateLogStreamRequest;
(function(CreateLogStreamRequest) {
    CreateLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
var DataAlreadyAcceptedException;
(function(DataAlreadyAcceptedException) {
    DataAlreadyAcceptedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
var DeleteDestinationRequest;
(function(DeleteDestinationRequest) {
    DeleteDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
var DeleteLogGroupRequest;
(function(DeleteLogGroupRequest) {
    DeleteLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
var DeleteLogStreamRequest;
(function(DeleteLogStreamRequest) {
    DeleteLogStreamRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
var DeleteMetricFilterRequest;
(function(DeleteMetricFilterRequest) {
    DeleteMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
var DeleteQueryDefinitionRequest;
(function(DeleteQueryDefinitionRequest) {
    DeleteQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
var DeleteQueryDefinitionResponse;
(function(DeleteQueryDefinitionResponse) {
    DeleteQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
var DeleteResourcePolicyRequest;
(function(DeleteResourcePolicyRequest) {
    DeleteResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
var DeleteRetentionPolicyRequest;
(function(DeleteRetentionPolicyRequest) {
    DeleteRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
var DeleteSubscriptionFilterRequest;
(function(DeleteSubscriptionFilterRequest) {
    DeleteSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
var DescribeDestinationsRequest;
(function(DescribeDestinationsRequest) {
    DescribeDestinationsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
var Destination;
(function(Destination) {
    Destination.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Destination || (Destination = {}));
var DescribeDestinationsResponse;
(function(DescribeDestinationsResponse) {
    DescribeDestinationsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
var ExportTaskStatusCode;
(function(ExportTaskStatusCode) {
    ExportTaskStatusCode["CANCELLED"] = "CANCELLED";
    ExportTaskStatusCode["COMPLETED"] = "COMPLETED";
    ExportTaskStatusCode["FAILED"] = "FAILED";
    ExportTaskStatusCode["PENDING"] = "PENDING";
    ExportTaskStatusCode["PENDING_CANCEL"] = "PENDING_CANCEL";
    ExportTaskStatusCode["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
var DescribeExportTasksRequest;
(function(DescribeExportTasksRequest) {
    DescribeExportTasksRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
var ExportTaskExecutionInfo;
(function(ExportTaskExecutionInfo) {
    ExportTaskExecutionInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
var ExportTaskStatus;
(function(ExportTaskStatus) {
    ExportTaskStatus.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTaskStatus || (ExportTaskStatus = {}));
var ExportTask;
(function(ExportTask) {
    ExportTask.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExportTask || (ExportTask = {}));
var DescribeExportTasksResponse;
(function(DescribeExportTasksResponse) {
    DescribeExportTasksResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
var DescribeLogGroupsRequest;
(function(DescribeLogGroupsRequest) {
    DescribeLogGroupsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
var LogGroup;
(function(LogGroup) {
    LogGroup.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroup || (LogGroup = {}));
var DescribeLogGroupsResponse;
(function(DescribeLogGroupsResponse) {
    DescribeLogGroupsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
var OrderBy;
(function(OrderBy) {
    OrderBy["LastEventTime"] = "LastEventTime";
    OrderBy["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
var DescribeLogStreamsRequest;
(function(DescribeLogStreamsRequest) {
    DescribeLogStreamsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
var LogStream;
(function(LogStream) {
    LogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogStream || (LogStream = {}));
var DescribeLogStreamsResponse;
(function(DescribeLogStreamsResponse) {
    DescribeLogStreamsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
var DescribeMetricFiltersRequest;
(function(DescribeMetricFiltersRequest) {
    DescribeMetricFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
var MetricTransformation;
(function(MetricTransformation) {
    MetricTransformation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricTransformation || (MetricTransformation = {}));
var MetricFilter;
(function(MetricFilter) {
    MetricFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilter || (MetricFilter = {}));
var DescribeMetricFiltersResponse;
(function(DescribeMetricFiltersResponse) {
    DescribeMetricFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
var QueryStatus;
(function(QueryStatus) {
    QueryStatus["Cancelled"] = "Cancelled";
    QueryStatus["Complete"] = "Complete";
    QueryStatus["Failed"] = "Failed";
    QueryStatus["Running"] = "Running";
    QueryStatus["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
var DescribeQueriesRequest;
(function(DescribeQueriesRequest) {
    DescribeQueriesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
var QueryInfo;
(function(QueryInfo) {
    QueryInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryInfo || (QueryInfo = {}));
var DescribeQueriesResponse;
(function(DescribeQueriesResponse) {
    DescribeQueriesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
var DescribeQueryDefinitionsRequest;
(function(DescribeQueryDefinitionsRequest) {
    DescribeQueryDefinitionsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
var QueryDefinition;
(function(QueryDefinition) {
    QueryDefinition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryDefinition || (QueryDefinition = {}));
var DescribeQueryDefinitionsResponse;
(function(DescribeQueryDefinitionsResponse) {
    DescribeQueryDefinitionsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
var DescribeResourcePoliciesRequest;
(function(DescribeResourcePoliciesRequest) {
    DescribeResourcePoliciesRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
var ResourcePolicy;
(function(ResourcePolicy) {
    ResourcePolicy.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourcePolicy || (ResourcePolicy = {}));
var DescribeResourcePoliciesResponse;
(function(DescribeResourcePoliciesResponse) {
    DescribeResourcePoliciesResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
var DescribeSubscriptionFiltersRequest;
(function(DescribeSubscriptionFiltersRequest) {
    DescribeSubscriptionFiltersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
var Distribution;
(function(Distribution) {
    Distribution["ByLogStream"] = "ByLogStream";
    Distribution["Random"] = "Random";
})(Distribution || (Distribution = {}));
var SubscriptionFilter;
(function(SubscriptionFilter) {
    SubscriptionFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscriptionFilter || (SubscriptionFilter = {}));
var DescribeSubscriptionFiltersResponse;
(function(DescribeSubscriptionFiltersResponse) {
    DescribeSubscriptionFiltersResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
var DisassociateKmsKeyRequest;
(function(DisassociateKmsKeyRequest) {
    DisassociateKmsKeyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
var FilteredLogEvent;
(function(FilteredLogEvent) {
    FilteredLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilteredLogEvent || (FilteredLogEvent = {}));
var FilterLogEventsRequest;
(function(FilterLogEventsRequest) {
    FilterLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
var SearchedLogStream;
(function(SearchedLogStream) {
    SearchedLogStream.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SearchedLogStream || (SearchedLogStream = {}));
var FilterLogEventsResponse;
(function(FilterLogEventsResponse) {
    FilterLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
var GetLogEventsRequest;
(function(GetLogEventsRequest) {
    GetLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
var OutputLogEvent;
(function(OutputLogEvent) {
    OutputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputLogEvent || (OutputLogEvent = {}));
var GetLogEventsResponse;
(function(GetLogEventsResponse) {
    GetLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
var GetLogGroupFieldsRequest;
(function(GetLogGroupFieldsRequest) {
    GetLogGroupFieldsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
var LogGroupField;
(function(LogGroupField) {
    LogGroupField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LogGroupField || (LogGroupField = {}));
var GetLogGroupFieldsResponse;
(function(GetLogGroupFieldsResponse) {
    GetLogGroupFieldsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
var GetLogRecordRequest;
(function(GetLogRecordRequest) {
    GetLogRecordRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
var GetLogRecordResponse;
(function(GetLogRecordResponse) {
    GetLogRecordResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
var GetQueryResultsRequest;
(function(GetQueryResultsRequest) {
    GetQueryResultsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
var ResultField;
(function(ResultField) {
    ResultField.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResultField || (ResultField = {}));
var QueryStatistics;
(function(QueryStatistics) {
    QueryStatistics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryStatistics || (QueryStatistics = {}));
var GetQueryResultsResponse;
(function(GetQueryResultsResponse) {
    GetQueryResultsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
var InputLogEvent;
(function(InputLogEvent) {
    InputLogEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputLogEvent || (InputLogEvent = {}));
var InvalidSequenceTokenException;
(function(InvalidSequenceTokenException) {
    InvalidSequenceTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
var ListTagsLogGroupRequest;
(function(ListTagsLogGroupRequest) {
    ListTagsLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
var ListTagsLogGroupResponse;
(function(ListTagsLogGroupResponse) {
    ListTagsLogGroupResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
var PutDestinationRequest;
(function(PutDestinationRequest) {
    PutDestinationRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationRequest || (PutDestinationRequest = {}));
var PutDestinationResponse;
(function(PutDestinationResponse) {
    PutDestinationResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationResponse || (PutDestinationResponse = {}));
var PutDestinationPolicyRequest;
(function(PutDestinationPolicyRequest) {
    PutDestinationPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
var PutLogEventsRequest;
(function(PutLogEventsRequest) {
    PutLogEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
var RejectedLogEventsInfo;
(function(RejectedLogEventsInfo) {
    RejectedLogEventsInfo.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
var PutLogEventsResponse;
(function(PutLogEventsResponse) {
    PutLogEventsResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
var UnrecognizedClientException;
(function(UnrecognizedClientException) {
    UnrecognizedClientException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
var PutMetricFilterRequest;
(function(PutMetricFilterRequest) {
    PutMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
var PutQueryDefinitionRequest;
(function(PutQueryDefinitionRequest) {
    PutQueryDefinitionRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
var PutQueryDefinitionResponse;
(function(PutQueryDefinitionResponse) {
    PutQueryDefinitionResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
var PutResourcePolicyRequest;
(function(PutResourcePolicyRequest) {
    PutResourcePolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
var PutResourcePolicyResponse;
(function(PutResourcePolicyResponse) {
    PutResourcePolicyResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
var PutRetentionPolicyRequest;
(function(PutRetentionPolicyRequest) {
    PutRetentionPolicyRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
var PutSubscriptionFilterRequest;
(function(PutSubscriptionFilterRequest) {
    PutSubscriptionFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
var QueryCompileErrorLocation;
(function(QueryCompileErrorLocation) {
    QueryCompileErrorLocation.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
var QueryCompileError;
(function(QueryCompileError) {
    QueryCompileError.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(QueryCompileError || (QueryCompileError = {}));
var MalformedQueryException;
(function(MalformedQueryException) {
    MalformedQueryException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MalformedQueryException || (MalformedQueryException = {}));
var StartQueryRequest;
(function(StartQueryRequest) {
    StartQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryRequest || (StartQueryRequest = {}));
var StartQueryResponse;
(function(StartQueryResponse) {
    StartQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartQueryResponse || (StartQueryResponse = {}));
var StopQueryRequest;
(function(StopQueryRequest) {
    StopQueryRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryRequest || (StopQueryRequest = {}));
var StopQueryResponse;
(function(StopQueryResponse) {
    StopQueryResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopQueryResponse || (StopQueryResponse = {}));
var TagLogGroupRequest;
(function(TagLogGroupRequest) {
    TagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
var TestMetricFilterRequest;
(function(TestMetricFilterRequest) {
    TestMetricFilterRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
var MetricFilterMatchRecord;
(function(MetricFilterMatchRecord) {
    MetricFilterMatchRecord.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
var TestMetricFilterResponse;
(function(TestMetricFilterResponse) {
    TestMetricFilterResponse.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
var UntagLogGroupRequest;
(function(UntagLogGroupRequest) {
    UntagLogGroupRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fkUQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AssociateKmsKeyCommand", ()=>serializeAws_json1_1AssociateKmsKeyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CancelExportTaskCommand", ()=>serializeAws_json1_1CancelExportTaskCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateExportTaskCommand", ()=>serializeAws_json1_1CreateExportTaskCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogGroupCommand", ()=>serializeAws_json1_1CreateLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateLogStreamCommand", ()=>serializeAws_json1_1CreateLogStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDestinationCommand", ()=>serializeAws_json1_1DeleteDestinationCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogGroupCommand", ()=>serializeAws_json1_1DeleteLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteLogStreamCommand", ()=>serializeAws_json1_1DeleteLogStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteMetricFilterCommand", ()=>serializeAws_json1_1DeleteMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteQueryDefinitionCommand", ()=>serializeAws_json1_1DeleteQueryDefinitionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteResourcePolicyCommand", ()=>serializeAws_json1_1DeleteResourcePolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteRetentionPolicyCommand", ()=>serializeAws_json1_1DeleteRetentionPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteSubscriptionFilterCommand", ()=>serializeAws_json1_1DeleteSubscriptionFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDestinationsCommand", ()=>serializeAws_json1_1DescribeDestinationsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeExportTasksCommand", ()=>serializeAws_json1_1DescribeExportTasksCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogGroupsCommand", ()=>serializeAws_json1_1DescribeLogGroupsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLogStreamsCommand", ()=>serializeAws_json1_1DescribeLogStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeMetricFiltersCommand", ()=>serializeAws_json1_1DescribeMetricFiltersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueriesCommand", ()=>serializeAws_json1_1DescribeQueriesCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeQueryDefinitionsCommand", ()=>serializeAws_json1_1DescribeQueryDefinitionsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeResourcePoliciesCommand", ()=>serializeAws_json1_1DescribeResourcePoliciesCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeSubscriptionFiltersCommand", ()=>serializeAws_json1_1DescribeSubscriptionFiltersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DisassociateKmsKeyCommand", ()=>serializeAws_json1_1DisassociateKmsKeyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1FilterLogEventsCommand", ()=>serializeAws_json1_1FilterLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogEventsCommand", ()=>serializeAws_json1_1GetLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogGroupFieldsCommand", ()=>serializeAws_json1_1GetLogGroupFieldsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetLogRecordCommand", ()=>serializeAws_json1_1GetLogRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetQueryResultsCommand", ()=>serializeAws_json1_1GetQueryResultsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsLogGroupCommand", ()=>serializeAws_json1_1ListTagsLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationCommand", ()=>serializeAws_json1_1PutDestinationCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutDestinationPolicyCommand", ()=>serializeAws_json1_1PutDestinationPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutLogEventsCommand", ()=>serializeAws_json1_1PutLogEventsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutMetricFilterCommand", ()=>serializeAws_json1_1PutMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutQueryDefinitionCommand", ()=>serializeAws_json1_1PutQueryDefinitionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutResourcePolicyCommand", ()=>serializeAws_json1_1PutResourcePolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRetentionPolicyCommand", ()=>serializeAws_json1_1PutRetentionPolicyCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutSubscriptionFilterCommand", ()=>serializeAws_json1_1PutSubscriptionFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartQueryCommand", ()=>serializeAws_json1_1StartQueryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopQueryCommand", ()=>serializeAws_json1_1StopQueryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TagLogGroupCommand", ()=>serializeAws_json1_1TagLogGroupCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TestMetricFilterCommand", ()=>serializeAws_json1_1TestMetricFilterCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UntagLogGroupCommand", ()=>serializeAws_json1_1UntagLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1AssociateKmsKeyCommand", ()=>deserializeAws_json1_1AssociateKmsKeyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CancelExportTaskCommand", ()=>deserializeAws_json1_1CancelExportTaskCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateExportTaskCommand", ()=>deserializeAws_json1_1CreateExportTaskCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogGroupCommand", ()=>deserializeAws_json1_1CreateLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateLogStreamCommand", ()=>deserializeAws_json1_1CreateLogStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDestinationCommand", ()=>deserializeAws_json1_1DeleteDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogGroupCommand", ()=>deserializeAws_json1_1DeleteLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteLogStreamCommand", ()=>deserializeAws_json1_1DeleteLogStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteMetricFilterCommand", ()=>deserializeAws_json1_1DeleteMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteQueryDefinitionCommand", ()=>deserializeAws_json1_1DeleteQueryDefinitionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteResourcePolicyCommand", ()=>deserializeAws_json1_1DeleteResourcePolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteRetentionPolicyCommand", ()=>deserializeAws_json1_1DeleteRetentionPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteSubscriptionFilterCommand", ()=>deserializeAws_json1_1DeleteSubscriptionFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDestinationsCommand", ()=>deserializeAws_json1_1DescribeDestinationsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeExportTasksCommand", ()=>deserializeAws_json1_1DescribeExportTasksCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogGroupsCommand", ()=>deserializeAws_json1_1DescribeLogGroupsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLogStreamsCommand", ()=>deserializeAws_json1_1DescribeLogStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeMetricFiltersCommand", ()=>deserializeAws_json1_1DescribeMetricFiltersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueriesCommand", ()=>deserializeAws_json1_1DescribeQueriesCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeQueryDefinitionsCommand", ()=>deserializeAws_json1_1DescribeQueryDefinitionsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeResourcePoliciesCommand", ()=>deserializeAws_json1_1DescribeResourcePoliciesCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeSubscriptionFiltersCommand", ()=>deserializeAws_json1_1DescribeSubscriptionFiltersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DisassociateKmsKeyCommand", ()=>deserializeAws_json1_1DisassociateKmsKeyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1FilterLogEventsCommand", ()=>deserializeAws_json1_1FilterLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogEventsCommand", ()=>deserializeAws_json1_1GetLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogGroupFieldsCommand", ()=>deserializeAws_json1_1GetLogGroupFieldsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetLogRecordCommand", ()=>deserializeAws_json1_1GetLogRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetQueryResultsCommand", ()=>deserializeAws_json1_1GetQueryResultsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsLogGroupCommand", ()=>deserializeAws_json1_1ListTagsLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationCommand", ()=>deserializeAws_json1_1PutDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutDestinationPolicyCommand", ()=>deserializeAws_json1_1PutDestinationPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutLogEventsCommand", ()=>deserializeAws_json1_1PutLogEventsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutMetricFilterCommand", ()=>deserializeAws_json1_1PutMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutQueryDefinitionCommand", ()=>deserializeAws_json1_1PutQueryDefinitionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutResourcePolicyCommand", ()=>deserializeAws_json1_1PutResourcePolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRetentionPolicyCommand", ()=>deserializeAws_json1_1PutRetentionPolicyCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutSubscriptionFilterCommand", ()=>deserializeAws_json1_1PutSubscriptionFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartQueryCommand", ()=>deserializeAws_json1_1StartQueryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopQueryCommand", ()=>deserializeAws_json1_1StopQueryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TagLogGroupCommand", ()=>deserializeAws_json1_1TagLogGroupCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TestMetricFilterCommand", ()=>deserializeAws_json1_1TestMetricFilterCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UntagLogGroupCommand", ()=>deserializeAws_json1_1UntagLogGroupCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AssociateKmsKeyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.AssociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1AssociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CancelExportTaskCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CancelExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CancelExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateExportTaskCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateExportTask"
            };
            body = JSON.stringify(serializeAws_json1_1CreateExportTaskRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateLogStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.CreateLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteDestination"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteLogStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteLogStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteLogStreamRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteQueryDefinitionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteResourcePolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteRetentionPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DeleteSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDestinationsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeDestinations"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDestinationsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeExportTasksCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeExportTasks"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeExportTasksRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogGroupsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogGroups"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogGroupsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLogStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeLogStreams"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLogStreamsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeMetricFiltersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeMetricFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeMetricFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueriesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueries"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueriesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeQueryDefinitions"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeQueryDefinitionsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeResourcePoliciesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeResourcePolicies"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeResourcePoliciesRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DescribeSubscriptionFilters"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeSubscriptionFiltersRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisassociateKmsKeyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.DisassociateKmsKey"
            };
            body = JSON.stringify(serializeAws_json1_1DisassociateKmsKeyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1FilterLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.FilterLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1FilterLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogGroupFieldsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogGroupFields"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogGroupFieldsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetLogRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetLogRecord"
            };
            body = JSON.stringify(serializeAws_json1_1GetLogRecordRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetQueryResultsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.GetQueryResults"
            };
            body = JSON.stringify(serializeAws_json1_1GetQueryResultsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.ListTagsLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestination"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutDestinationPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutDestinationPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutDestinationPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutLogEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutLogEvents"
            };
            body = JSON.stringify(serializeAws_json1_1PutLogEventsRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutQueryDefinitionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutQueryDefinition"
            };
            body = JSON.stringify(serializeAws_json1_1PutQueryDefinitionRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutResourcePolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutResourcePolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutResourcePolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRetentionPolicyCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutRetentionPolicy"
            };
            body = JSON.stringify(serializeAws_json1_1PutRetentionPolicyRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutSubscriptionFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.PutSubscriptionFilter"
            };
            body = JSON.stringify(serializeAws_json1_1PutSubscriptionFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartQueryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StartQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StartQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopQueryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.StopQuery"
            };
            body = JSON.stringify(serializeAws_json1_1StopQueryRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1TagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TestMetricFilterCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.TestMetricFilter"
            };
            body = JSON.stringify(serializeAws_json1_1TestMetricFilterRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagLogGroupCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Logs_20140328.UntagLogGroup"
            };
            body = JSON.stringify(serializeAws_json1_1UntagLogGroupRequest(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AssociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AssociateKmsKeyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CancelExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CancelExportTaskCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidOperationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidOperationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateExportTaskCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateExportTaskResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateExportTaskCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateLogStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteLogStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteLogStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteQueryDefinitionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteResourcePolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteRetentionPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteSubscriptionFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDestinationsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDestinationsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDestinationsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeExportTasksCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeExportTasksResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeExportTasksCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogGroupsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogGroupsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogGroupsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLogStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLogStreamsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLogStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeMetricFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeMetricFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeMetricFiltersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueriesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueriesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueriesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeQueryDefinitionsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeQueryDefinitionsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeQueryDefinitionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeResourcePoliciesCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeResourcePoliciesResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeResourcePoliciesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeSubscriptionFiltersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeSubscriptionFiltersResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeSubscriptionFiltersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisassociateKmsKeyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisassociateKmsKeyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1FilterLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1FilterLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1FilterLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogGroupFieldsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogGroupFieldsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogGroupFieldsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetLogRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetLogRecordResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetLogRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetQueryResultsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetQueryResultsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetQueryResultsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsLogGroupResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutDestinationResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutDestinationPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutDestinationPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutLogEventsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutLogEventsResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutLogEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
        var _j;
        return (0, _tslib.__generator)(this, function(_k) {
            switch(_k.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _j = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_j.body = _k.sent(), _j)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#DataAlreadyAcceptedException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidSequenceTokenException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.cloudwatchlogs#UnrecognizedClientException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _k.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        15
                    ];
                case 14:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _k.label = 15;
                case 15:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutQueryDefinitionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutQueryDefinitionResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutQueryDefinitionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutResourcePolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutResourcePolicyResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutResourcePolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRetentionPolicyCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRetentionPolicyCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutSubscriptionFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutSubscriptionFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#OperationAbortedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartQueryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#MalformedQueryException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1MalformedQueryExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopQueryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopQueryResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopQueryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TestMetricFilterCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TestMetricFilterResponse(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TestMetricFilterCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#InvalidParameterException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagLogGroupCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagLogGroupCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1DataAlreadyAcceptedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "DataAlreadyAcceptedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidOperationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidOperationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidOperationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidParameterExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidParameterException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidSequenceTokenExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidSequenceTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidSequenceTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1MalformedQueryExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1MalformedQueryException(body, context);
            contents = (0, _tslib.__assign)({
                name: "MalformedQueryException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1OperationAbortedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1OperationAbortedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "OperationAbortedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceAlreadyExistsException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceAlreadyExistsException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1UnrecognizedClientExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1UnrecognizedClientException(body, context);
            contents = (0, _tslib.__assign)({
                name: "UnrecognizedClientException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AssociateKmsKeyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1CancelExportTaskRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1CreateExportTaskRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destination !== undefined && input.destination !== null && {
        destination: input.destination
    }), input.destinationPrefix !== undefined && input.destinationPrefix !== null && {
        destinationPrefix: input.destinationPrefix
    }), input.from !== undefined && input.from !== null && {
        from: input.from
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.taskName !== undefined && input.taskName !== null && {
        taskName: input.taskName
    }), input.to !== undefined && input.to !== null && {
        to: input.to
    });
};
var serializeAws_json1_1CreateLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.kmsKeyId !== undefined && input.kmsKeyId !== null && {
        kmsKeyId: input.kmsKeyId
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1CreateLogStreamRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteDestinationRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1DeleteLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteLogStreamRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    });
};
var serializeAws_json1_1DeleteMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteQueryDefinitionRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    });
};
var serializeAws_json1_1DeleteResourcePolicyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1DeleteRetentionPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DeleteSubscriptionFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1DescribeDestinationsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DestinationNamePrefix !== undefined && input.DestinationNamePrefix !== null && {
        DestinationNamePrefix: input.DestinationNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeExportTasksRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.statusCode !== undefined && input.statusCode !== null && {
        statusCode: input.statusCode
    }), input.taskId !== undefined && input.taskId !== null && {
        taskId: input.taskId
    });
};
var serializeAws_json1_1DescribeLogGroupsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupNamePrefix !== undefined && input.logGroupNamePrefix !== null && {
        logGroupNamePrefix: input.logGroupNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeLogStreamsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.descending !== undefined && input.descending !== null && {
        descending: input.descending
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.orderBy !== undefined && input.orderBy !== null && {
        orderBy: input.orderBy
    });
};
var serializeAws_json1_1DescribeMetricFiltersRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeQueriesRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.status !== undefined && input.status !== null && {
        status: input.status
    });
};
var serializeAws_json1_1DescribeQueryDefinitionsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.maxResults !== undefined && input.maxResults !== null && {
        maxResults: input.maxResults
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.queryDefinitionNamePrefix !== undefined && input.queryDefinitionNamePrefix !== null && {
        queryDefinitionNamePrefix: input.queryDefinitionNamePrefix
    });
};
var serializeAws_json1_1DescribeResourcePoliciesRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DescribeSubscriptionFiltersRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterNamePrefix !== undefined && input.filterNamePrefix !== null && {
        filterNamePrefix: input.filterNamePrefix
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    });
};
var serializeAws_json1_1DisassociateKmsKeyRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1FilterLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.interleaved !== undefined && input.interleaved !== null && {
        interleaved: input.interleaved
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamNamePrefix !== undefined && input.logStreamNamePrefix !== null && {
        logStreamNamePrefix: input.logStreamNamePrefix
    }), input.logStreamNames !== undefined && input.logStreamNames !== null && {
        logStreamNames: serializeAws_json1_1InputLogStreamNames(input.logStreamNames, context)
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.nextToken !== undefined && input.nextToken !== null && {
        nextToken: input.nextToken
    }), input.startFromHead !== undefined && input.startFromHead !== null && {
        startFromHead: input.startFromHead
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1GetLogGroupFieldsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.time !== undefined && input.time !== null && {
        time: input.time
    });
};
var serializeAws_json1_1GetLogRecordRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logRecordPointer !== undefined && input.logRecordPointer !== null && {
        logRecordPointer: input.logRecordPointer
    });
};
var serializeAws_json1_1GetQueryResultsRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1InputLogEvent = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.message !== undefined && input.message !== null && {
        message: input.message
    }), input.timestamp !== undefined && input.timestamp !== null && {
        timestamp: input.timestamp
    });
};
var serializeAws_json1_1InputLogEvents = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1InputLogEvent(entry, context);
    });
};
var serializeAws_json1_1InputLogStreamNames = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    });
};
var serializeAws_json1_1LogGroupNames = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1MetricTransformation = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.defaultValue !== undefined && input.defaultValue !== null && {
        defaultValue: input.defaultValue
    }), input.metricName !== undefined && input.metricName !== null && {
        metricName: input.metricName
    }), input.metricNamespace !== undefined && input.metricNamespace !== null && {
        metricNamespace: input.metricNamespace
    }), input.metricValue !== undefined && input.metricValue !== null && {
        metricValue: input.metricValue
    });
};
var serializeAws_json1_1MetricTransformations = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1MetricTransformation(entry, context);
    });
};
var serializeAws_json1_1PutDestinationPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.accessPolicy !== undefined && input.accessPolicy !== null && {
        accessPolicy: input.accessPolicy
    }), input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    });
};
var serializeAws_json1_1PutDestinationRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationName !== undefined && input.destinationName !== null && {
        destinationName: input.destinationName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    }), input.targetArn !== undefined && input.targetArn !== null && {
        targetArn: input.targetArn
    });
};
var serializeAws_json1_1PutLogEventsRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logEvents !== undefined && input.logEvents !== null && {
        logEvents: serializeAws_json1_1InputLogEvents(input.logEvents, context)
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logStreamName !== undefined && input.logStreamName !== null && {
        logStreamName: input.logStreamName
    }), input.sequenceToken !== undefined && input.sequenceToken !== null && {
        sequenceToken: input.sequenceToken
    });
};
var serializeAws_json1_1PutMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.metricTransformations !== undefined && input.metricTransformations !== null && {
        metricTransformations: serializeAws_json1_1MetricTransformations(input.metricTransformations, context)
    });
};
var serializeAws_json1_1PutQueryDefinitionRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.name !== undefined && input.name !== null && {
        name: input.name
    }), input.queryDefinitionId !== undefined && input.queryDefinitionId !== null && {
        queryDefinitionId: input.queryDefinitionId
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    });
};
var serializeAws_json1_1PutResourcePolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.policyDocument !== undefined && input.policyDocument !== null && {
        policyDocument: input.policyDocument
    }), input.policyName !== undefined && input.policyName !== null && {
        policyName: input.policyName
    });
};
var serializeAws_json1_1PutRetentionPolicyRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.retentionInDays !== undefined && input.retentionInDays !== null && {
        retentionInDays: input.retentionInDays
    });
};
var serializeAws_json1_1PutSubscriptionFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.destinationArn !== undefined && input.destinationArn !== null && {
        destinationArn: input.destinationArn
    }), input.distribution !== undefined && input.distribution !== null && {
        distribution: input.distribution
    }), input.filterName !== undefined && input.filterName !== null && {
        filterName: input.filterName
    }), input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.roleArn !== undefined && input.roleArn !== null && {
        roleArn: input.roleArn
    });
};
var serializeAws_json1_1StartQueryRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.endTime !== undefined && input.endTime !== null && {
        endTime: input.endTime
    }), input.limit !== undefined && input.limit !== null && {
        limit: input.limit
    }), input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.logGroupNames !== undefined && input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context)
    }), input.queryString !== undefined && input.queryString !== null && {
        queryString: input.queryString
    }), input.startTime !== undefined && input.startTime !== null && {
        startTime: input.startTime
    });
};
var serializeAws_json1_1StopQueryRequest = function(input, context) {
    return (0, _tslib.__assign)({}, input.queryId !== undefined && input.queryId !== null && {
        queryId: input.queryId
    });
};
var serializeAws_json1_1TagList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1Tags(input.tags, context)
    });
};
var serializeAws_json1_1Tags = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1TestEventMessages = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TestMetricFilterRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.filterPattern !== undefined && input.filterPattern !== null && {
        filterPattern: input.filterPattern
    }), input.logEventMessages !== undefined && input.logEventMessages !== null && {
        logEventMessages: serializeAws_json1_1TestEventMessages(input.logEventMessages, context)
    });
};
var serializeAws_json1_1UntagLogGroupRequest = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.logGroupName !== undefined && input.logGroupName !== null && {
        logGroupName: input.logGroupName
    }), input.tags !== undefined && input.tags !== null && {
        tags: serializeAws_json1_1TagList(input.tags, context)
    });
};
var deserializeAws_json1_1CreateExportTaskResponse = function(output, context) {
    return {
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined
    };
};
var deserializeAws_json1_1DataAlreadyAcceptedException = function(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1DeleteQueryDefinitionResponse = function(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1DescribeDestinationsResponse = function(output, context) {
    return {
        destinations: output.destinations !== undefined && output.destinations !== null ? deserializeAws_json1_1Destinations(output.destinations, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeExportTasksResponse = function(output, context) {
    return {
        exportTasks: output.exportTasks !== undefined && output.exportTasks !== null ? deserializeAws_json1_1ExportTasks(output.exportTasks, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogGroupsResponse = function(output, context) {
    return {
        logGroups: output.logGroups !== undefined && output.logGroups !== null ? deserializeAws_json1_1LogGroups(output.logGroups, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeLogStreamsResponse = function(output, context) {
    return {
        logStreams: output.logStreams !== undefined && output.logStreams !== null ? deserializeAws_json1_1LogStreams(output.logStreams, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeMetricFiltersResponse = function(output, context) {
    return {
        metricFilters: output.metricFilters !== undefined && output.metricFilters !== null ? deserializeAws_json1_1MetricFilters(output.metricFilters, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined
    };
};
var deserializeAws_json1_1DescribeQueriesResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queries: output.queries !== undefined && output.queries !== null ? deserializeAws_json1_1QueryInfoList(output.queries, context) : undefined
    };
};
var deserializeAws_json1_1DescribeQueryDefinitionsResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queryDefinitions: output.queryDefinitions !== undefined && output.queryDefinitions !== null ? deserializeAws_json1_1QueryDefinitionList(output.queryDefinitions, context) : undefined
    };
};
var deserializeAws_json1_1DescribeResourcePoliciesResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        resourcePolicies: output.resourcePolicies !== undefined && output.resourcePolicies !== null ? deserializeAws_json1_1ResourcePolicies(output.resourcePolicies, context) : undefined
    };
};
var deserializeAws_json1_1DescribeSubscriptionFiltersResponse = function(output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        subscriptionFilters: output.subscriptionFilters !== undefined && output.subscriptionFilters !== null ? deserializeAws_json1_1SubscriptionFilters(output.subscriptionFilters, context) : undefined
    };
};
var deserializeAws_json1_1Destination = function(output, context) {
    return {
        accessPolicy: output.accessPolicy !== undefined && output.accessPolicy !== null ? output.accessPolicy : undefined,
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationName: output.destinationName !== undefined && output.destinationName !== null ? output.destinationName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined,
        targetArn: output.targetArn !== undefined && output.targetArn !== null ? output.targetArn : undefined
    };
};
var deserializeAws_json1_1Destinations = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Destination(entry, context);
    });
};
var deserializeAws_json1_1ExportTask = function(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? output.destination : undefined,
        destinationPrefix: output.destinationPrefix !== undefined && output.destinationPrefix !== null ? output.destinationPrefix : undefined,
        executionInfo: output.executionInfo !== undefined && output.executionInfo !== null ? deserializeAws_json1_1ExportTaskExecutionInfo(output.executionInfo, context) : undefined,
        from: output.from !== undefined && output.from !== null ? output.from : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        status: output.status !== undefined && output.status !== null ? deserializeAws_json1_1ExportTaskStatus(output.status, context) : undefined,
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined,
        taskName: output.taskName !== undefined && output.taskName !== null ? output.taskName : undefined,
        to: output.to !== undefined && output.to !== null ? output.to : undefined
    };
};
var deserializeAws_json1_1ExportTaskExecutionInfo = function(output, context) {
    return {
        completionTime: output.completionTime !== undefined && output.completionTime !== null ? output.completionTime : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined
    };
};
var deserializeAws_json1_1ExportTasks = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ExportTask(entry, context);
    });
};
var deserializeAws_json1_1ExportTaskStatus = function(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExtractedValues = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1FilteredLogEvent = function(output, context) {
    return {
        eventId: output.eventId !== undefined && output.eventId !== null ? output.eventId : undefined,
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1FilteredLogEvents = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1FilteredLogEvent(entry, context);
    });
};
var deserializeAws_json1_1FilterLogEventsResponse = function(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1FilteredLogEvents(output.events, context) : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        searchedLogStreams: output.searchedLogStreams !== undefined && output.searchedLogStreams !== null ? deserializeAws_json1_1SearchedLogStreams(output.searchedLogStreams, context) : undefined
    };
};
var deserializeAws_json1_1GetLogEventsResponse = function(output, context) {
    return {
        events: output.events !== undefined && output.events !== null ? deserializeAws_json1_1OutputLogEvents(output.events, context) : undefined,
        nextBackwardToken: output.nextBackwardToken !== undefined && output.nextBackwardToken !== null ? output.nextBackwardToken : undefined,
        nextForwardToken: output.nextForwardToken !== undefined && output.nextForwardToken !== null ? output.nextForwardToken : undefined
    };
};
var deserializeAws_json1_1GetLogGroupFieldsResponse = function(output, context) {
    return {
        logGroupFields: output.logGroupFields !== undefined && output.logGroupFields !== null ? deserializeAws_json1_1LogGroupFieldList(output.logGroupFields, context) : undefined
    };
};
var deserializeAws_json1_1GetLogRecordResponse = function(output, context) {
    return {
        logRecord: output.logRecord !== undefined && output.logRecord !== null ? deserializeAws_json1_1LogRecord(output.logRecord, context) : undefined
    };
};
var deserializeAws_json1_1GetQueryResultsResponse = function(output, context) {
    return {
        results: output.results !== undefined && output.results !== null ? deserializeAws_json1_1QueryResults(output.results, context) : undefined,
        statistics: output.statistics !== undefined && output.statistics !== null ? deserializeAws_json1_1QueryStatistics(output.statistics, context) : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1InvalidOperationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidParameterException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidSequenceTokenException = function(output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null ? output.expectedSequenceToken : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListTagsLogGroupResponse = function(output, context) {
    return {
        tags: output.tags !== undefined && output.tags !== null ? deserializeAws_json1_1Tags(output.tags, context) : undefined
    };
};
var deserializeAws_json1_1LogGroup = function(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        kmsKeyId: output.kmsKeyId !== undefined && output.kmsKeyId !== null ? output.kmsKeyId : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricFilterCount: output.metricFilterCount !== undefined && output.metricFilterCount !== null ? output.metricFilterCount : undefined,
        retentionInDays: output.retentionInDays !== undefined && output.retentionInDays !== null ? output.retentionInDays : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined
    };
};
var deserializeAws_json1_1LogGroupField = function(output, context) {
    return {
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        percent: output.percent !== undefined && output.percent !== null ? output.percent : undefined
    };
};
var deserializeAws_json1_1LogGroupFieldList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroupField(entry, context);
    });
};
var deserializeAws_json1_1LogGroupNames = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1LogGroups = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogGroup(entry, context);
    });
};
var deserializeAws_json1_1LogRecord = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1LogStream = function(output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        firstEventTimestamp: output.firstEventTimestamp !== undefined && output.firstEventTimestamp !== null ? output.firstEventTimestamp : undefined,
        lastEventTimestamp: output.lastEventTimestamp !== undefined && output.lastEventTimestamp !== null ? output.lastEventTimestamp : undefined,
        lastIngestionTime: output.lastIngestionTime !== undefined && output.lastIngestionTime !== null ? output.lastIngestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined,
        uploadSequenceToken: output.uploadSequenceToken !== undefined && output.uploadSequenceToken !== null ? output.uploadSequenceToken : undefined
    };
};
var deserializeAws_json1_1LogStreams = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1LogStream(entry, context);
    });
};
var deserializeAws_json1_1MalformedQueryException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        queryCompileError: output.queryCompileError !== undefined && output.queryCompileError !== null ? deserializeAws_json1_1QueryCompileError(output.queryCompileError, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilter = function(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricTransformations: output.metricTransformations !== undefined && output.metricTransformations !== null ? deserializeAws_json1_1MetricTransformations(output.metricTransformations, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilterMatches = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilterMatchRecord(entry, context);
    });
};
var deserializeAws_json1_1MetricFilterMatchRecord = function(output, context) {
    return {
        eventMessage: output.eventMessage !== undefined && output.eventMessage !== null ? output.eventMessage : undefined,
        eventNumber: output.eventNumber !== undefined && output.eventNumber !== null ? output.eventNumber : undefined,
        extractedValues: output.extractedValues !== undefined && output.extractedValues !== null ? deserializeAws_json1_1ExtractedValues(output.extractedValues, context) : undefined
    };
};
var deserializeAws_json1_1MetricFilters = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricFilter(entry, context);
    });
};
var deserializeAws_json1_1MetricTransformation = function(output, context) {
    return {
        defaultValue: output.defaultValue !== undefined && output.defaultValue !== null ? output.defaultValue : undefined,
        metricName: output.metricName !== undefined && output.metricName !== null ? output.metricName : undefined,
        metricNamespace: output.metricNamespace !== undefined && output.metricNamespace !== null ? output.metricNamespace : undefined,
        metricValue: output.metricValue !== undefined && output.metricValue !== null ? output.metricValue : undefined
    };
};
var deserializeAws_json1_1MetricTransformations = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1MetricTransformation(entry, context);
    });
};
var deserializeAws_json1_1OperationAbortedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1OutputLogEvent = function(output, context) {
    return {
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined
    };
};
var deserializeAws_json1_1OutputLogEvents = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1OutputLogEvent(entry, context);
    });
};
var deserializeAws_json1_1PutDestinationResponse = function(output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? deserializeAws_json1_1Destination(output.destination, context) : undefined
    };
};
var deserializeAws_json1_1PutLogEventsResponse = function(output, context) {
    return {
        nextSequenceToken: output.nextSequenceToken !== undefined && output.nextSequenceToken !== null ? output.nextSequenceToken : undefined,
        rejectedLogEventsInfo: output.rejectedLogEventsInfo !== undefined && output.rejectedLogEventsInfo !== null ? deserializeAws_json1_1RejectedLogEventsInfo(output.rejectedLogEventsInfo, context) : undefined
    };
};
var deserializeAws_json1_1PutQueryDefinitionResponse = function(output, context) {
    return {
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined
    };
};
var deserializeAws_json1_1PutResourcePolicyResponse = function(output, context) {
    return {
        resourcePolicy: output.resourcePolicy !== undefined && output.resourcePolicy !== null ? deserializeAws_json1_1ResourcePolicy(output.resourcePolicy, context) : undefined
    };
};
var deserializeAws_json1_1QueryCompileError = function(output, context) {
    return {
        location: output.location !== undefined && output.location !== null ? deserializeAws_json1_1QueryCompileErrorLocation(output.location, context) : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1QueryCompileErrorLocation = function(output, context) {
    return {
        endCharOffset: output.endCharOffset !== undefined && output.endCharOffset !== null ? output.endCharOffset : undefined,
        startCharOffset: output.startCharOffset !== undefined && output.startCharOffset !== null ? output.startCharOffset : undefined
    };
};
var deserializeAws_json1_1QueryDefinition = function(output, context) {
    return {
        lastModified: output.lastModified !== undefined && output.lastModified !== null ? output.lastModified : undefined,
        logGroupNames: output.logGroupNames !== undefined && output.logGroupNames !== null ? deserializeAws_json1_1LogGroupNames(output.logGroupNames, context) : undefined,
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null ? output.queryDefinitionId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined
    };
};
var deserializeAws_json1_1QueryDefinitionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryDefinition(entry, context);
    });
};
var deserializeAws_json1_1QueryInfo = function(output, context) {
    return {
        createTime: output.createTime !== undefined && output.createTime !== null ? output.createTime : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined
    };
};
var deserializeAws_json1_1QueryInfoList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1QueryInfo(entry, context);
    });
};
var deserializeAws_json1_1QueryResults = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultRows(entry, context);
    });
};
var deserializeAws_json1_1QueryStatistics = function(output, context) {
    return {
        bytesScanned: output.bytesScanned !== undefined && output.bytesScanned !== null ? output.bytesScanned : undefined,
        recordsMatched: output.recordsMatched !== undefined && output.recordsMatched !== null ? output.recordsMatched : undefined,
        recordsScanned: output.recordsScanned !== undefined && output.recordsScanned !== null ? output.recordsScanned : undefined
    };
};
var deserializeAws_json1_1RejectedLogEventsInfo = function(output, context) {
    return {
        expiredLogEventEndIndex: output.expiredLogEventEndIndex !== undefined && output.expiredLogEventEndIndex !== null ? output.expiredLogEventEndIndex : undefined,
        tooNewLogEventStartIndex: output.tooNewLogEventStartIndex !== undefined && output.tooNewLogEventStartIndex !== null ? output.tooNewLogEventStartIndex : undefined,
        tooOldLogEventEndIndex: output.tooOldLogEventEndIndex !== undefined && output.tooOldLogEventEndIndex !== null ? output.tooOldLogEventEndIndex : undefined
    };
};
var deserializeAws_json1_1ResourceAlreadyExistsException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourcePolicies = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResourcePolicy(entry, context);
    });
};
var deserializeAws_json1_1ResourcePolicy = function(output, context) {
    return {
        lastUpdatedTime: output.lastUpdatedTime !== undefined && output.lastUpdatedTime !== null ? output.lastUpdatedTime : undefined,
        policyDocument: output.policyDocument !== undefined && output.policyDocument !== null ? output.policyDocument : undefined,
        policyName: output.policyName !== undefined && output.policyName !== null ? output.policyName : undefined
    };
};
var deserializeAws_json1_1ResultField = function(output, context) {
    return {
        field: output.field !== undefined && output.field !== null ? output.field : undefined,
        value: output.value !== undefined && output.value !== null ? output.value : undefined
    };
};
var deserializeAws_json1_1ResultRows = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ResultField(entry, context);
    });
};
var deserializeAws_json1_1SearchedLogStream = function(output, context) {
    return {
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        searchedCompletely: output.searchedCompletely !== undefined && output.searchedCompletely !== null ? output.searchedCompletely : undefined
    };
};
var deserializeAws_json1_1SearchedLogStreams = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SearchedLogStream(entry, context);
    });
};
var deserializeAws_json1_1ServiceUnavailableException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1StartQueryResponse = function(output, context) {
    return {
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined
    };
};
var deserializeAws_json1_1StopQueryResponse = function(output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilter = function(output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationArn: output.destinationArn !== undefined && output.destinationArn !== null ? output.destinationArn : undefined,
        distribution: output.distribution !== undefined && output.distribution !== null ? output.distribution : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined
    };
};
var deserializeAws_json1_1SubscriptionFilters = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1SubscriptionFilter(entry, context);
    });
};
var deserializeAws_json1_1Tags = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1TestMetricFilterResponse = function(output, context) {
    return {
        matches: output.matches !== undefined && output.matches !== null ? deserializeAws_json1_1MetricFilterMatches(output.matches, context) : undefined
    };
};
var deserializeAws_json1_1UnrecognizedClientException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1RCV6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);

},{"./deserializerMiddleware":"3hbBu","./serializerMiddleware":"bUVil","./serdePlugin":"bbRvK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3hbBu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                deserializer(response, options)
                            ];
                        case 2:
                            parsed = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"4CYEX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4CYEX":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bUVil":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                serializer(args.input, options)
                            ];
                        case 1:
                            request = _a.sent();
                            return [
                                2 /*return*/ ,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"4CYEX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bbRvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"3hbBu","./serializerMiddleware":"bUVil","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9C9RJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateLogStreamCommand", ()=>CreateLogStreamCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Creates a log stream for the specified log group. A log stream is a sequence of log events
 *       that originate from a single source, such as an application instance or a resource that is
 *       being monitored.</p>
 *          <p>There is no limit on the number of log streams that you can create for a log group. There is a limit
 *     of 50 TPS on <code>CreateLogStream</code> operations, after which transactions are throttled.</p>
 *          <p>You must use the following guidelines when naming a log stream:</p>
 *          <ul>
 *             <li>
 *                <p>Log stream names must be unique within the log group.</p>
 *             </li>
 *             <li>
 *                <p>Log stream names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>The ':' (colon) and '*' (asterisk) characters are not allowed.</p>
 *             </li>
 *          </ul>
 */ var CreateLogStreamCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(CreateLogStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogStreamCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ CreateLogStreamCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.CreateLogStreamRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogStreamCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1CreateLogStreamCommand)(input, context);
    };
    CreateLogStreamCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1CreateLogStreamCommand)(output, context);
    };
    return CreateLogStreamCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6i2Hb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogGroupsCommand", ()=>DescribeLogGroupsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the specified log groups. You can list all your log groups or filter the results by prefix.
 *       The results are ASCII-sorted by log group name.</p>
 */ var DescribeLogGroupsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogGroupsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogGroupsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogGroupsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogGroupsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogGroupsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogGroupsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogGroupsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogGroupsCommand)(input, context);
    };
    DescribeLogGroupsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogGroupsCommand)(output, context);
    };
    return DescribeLogGroupsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ceYdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DescribeLogStreamsCommand", ()=>DescribeLogStreamsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists the log streams for the specified log group.
 *       You can list all the log streams or filter the results by prefix.
 *       You can also control how the results are ordered.</p>
 *          <p>This operation has a limit of five transactions per second, after which transactions are throttled.</p>
 */ var DescribeLogStreamsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(DescribeLogStreamsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogStreamsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ DescribeLogStreamsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogStreamsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.DescribeLogStreamsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.DescribeLogStreamsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogStreamsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1DescribeLogStreamsCommand)(input, context);
    };
    DescribeLogStreamsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1DescribeLogStreamsCommand)(output, context);
    };
    return DescribeLogStreamsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"78xAw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetLogEventsCommand", ()=>GetLogEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Lists log events from the specified log stream. You can list all of the log events or
 *       filter using a time range.</p>
 *
 *          <p>By default, this operation returns as many log events as can fit in a response size of 1MB (up to 10,000 log events).
 *       You can get additional log events by specifying one of the tokens in a subsequent call.
 *       This operation can return empty results while there are more log events available through the token.</p>
 */ var GetLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(GetLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ GetLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.GetLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1GetLogEventsCommand)(input, context);
    };
    GetLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1GetLogEventsCommand)(output, context);
    };
    return GetLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kEN1N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutLogEventsCommand", ()=>PutLogEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Uploads a batch of log events to the specified log stream.</p>
 *          <p>You must include the sequence token obtained from the response of the previous call. An
 *       upload in a newly created log stream does not require a sequence token. You can also get the
 *       sequence token in the <code>expectedSequenceToken</code> field from
 *         <code>InvalidSequenceTokenException</code>. If you call <code>PutLogEvents</code> twice
 *       within a narrow time period using the same value for <code>sequenceToken</code>, both calls
 *       might be successful or one might be rejected.</p>
 *          <p>The batch of events must satisfy the following constraints:</p>
 *          <ul>
 *             <li>
 *                <p>The maximum batch size is 1,048,576 bytes. This size is calculated as the sum of
 *           all event messages in UTF-8, plus 26 bytes for each log event.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be more than 2 hours in the future.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be older than 14 days or older than the retention
 *           period of the log group.</p>
 *             </li>
 *             <li>
 *                <p>The log events in the batch must be in chronological order by their timestamp. The
 *           timestamp is the time the event occurred, expressed as the number of milliseconds after
 *           Jan 1, 1970 00:00:00 UTC. (In AWS Tools for PowerShell and the AWS SDK for .NET, the
 *           timestamp is specified in .NET format: yyyy-mm-ddThh:mm:ss. For example,
 *           2017-09-15T13:45:30.) </p>
 *             </li>
 *             <li>
 *                <p>A batch of log events in a single request cannot span more than 24 hours. Otherwise, the operation fails.</p>
 *             </li>
 *             <li>
 *                <p>The maximum number of log events in a batch is 10,000.</p>
 *             </li>
 *             <li>
 *                <p>There is a quota of 5 requests per second per log stream. Additional requests are throttled. This quota can't be changed.</p>
 *             </li>
 *          </ul>
 *          <p>If a call to <code>PutLogEvents</code> returns "UnrecognizedClientException" the most likely cause is an invalid AWS access key ID or secret key. </p>
 */ var PutLogEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutLogEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutLogEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutLogEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutLogEventsResponse).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutLogEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutLogEventsCommand)(input, context);
    };
    PutLogEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutLogEventsCommand)(output, context);
    };
    return PutLogEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"gZkQO","../protocols/Aws_json1_1":"3fkUQ","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpBPz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", ()=>GoogleOAuth);
parcelHelpers.export(exports, "FacebookOAuth", ()=>FacebookOAuth);
var _googleOAuth = require("./GoogleOAuth");
var _facebookOAuth = require("./FacebookOAuth");
var GoogleOAuth = new (0, _googleOAuth.GoogleOAuth)();
var FacebookOAuth = new (0, _facebookOAuth.FacebookOAuth)();

},{"./GoogleOAuth":"dthS6","./FacebookOAuth":"9IZHN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dthS6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleOAuth", ()=>GoogleOAuth);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("CognitoCredentials");
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var GoogleOAuth = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, _js.browserOrNode)().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    logger.debug("google Auth undefined");
                    rej(new (0, _util.NonRetryableError)("google Auth undefined"));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    }).catch(function(err) {
                        if (err && err.error === "network_error") // Not using NonRetryableError so handler will be retried
                        rej("Network error reloading google auth response");
                        else rej(new (0, _util.NonRetryableError)("Failed to reload google auth response"));
                    });
                } else rej(new (0, _util.NonRetryableError)("User is not signed in with Google"));
            }).catch(function(err) {
                logger.debug("Failed to refresh google token", err);
                rej(new (0, _util.NonRetryableError)("Failed to refresh google token"));
            });
        });
    };
    return GoogleOAuth;
}();

},{"../Logger":"jVGZ5","../JS":"58R8D","../Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9IZHN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FacebookOAuth", ()=>FacebookOAuth);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("../Logger");
var _js = require("../JS");
var _util = require("../Util");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("CognitoCredentials");
var waitForInit = new Promise(function(res, rej) {
    if (!(0, _js.browserOrNode)().isBrowser) {
        logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var FacebookOAuth = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, _js.browserOrNode)().isBrowser) fb = window["FB"];
        if (!fb) {
            var errorMessage = "no fb sdk available";
            logger.debug(errorMessage);
            return Promise.reject(new (0, _util.NonRetryableError)(errorMessage));
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = "no response from facebook when refreshing the jwt token";
                    logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new (0, _util.NonRetryableError)(errorMessage));
                } else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = "the jwtToken is undefined";
                        logger.debug(errorMessage);
                        rej(new (0, _util.NonRetryableError)(errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at
                    });
                }
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();

},{"../Logger":"jVGZ5","../JS":"58R8D","../Util":"5E0Hy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"knFIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsClass", ()=>CredentialsClass);
parcelHelpers.export(exports, "Credentials", ()=>Credentials);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _logger = require("./Logger");
var _storageHelper = require("./StorageHelper");
var _js = require("./JS");
var _oauthHelper = require("./OAuthHelper");
var _util = require("./Util");
var _amplify = require("./Amplify");
var _cognitoIdentity = require("./AwsClients/CognitoIdentity");
var _parseAWSExports = require("./parseAWSExports");
var _hub = require("./Hub");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _logger.ConsoleLogger)("Credentials");
var CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var COGNITO_IDENTITY_KEY_PREFIX = "CognitoIdentityId-";
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchCredentialsEvent = function(event, data, message) {
    (0, _hub.Hub).dispatch("core", {
        event: event,
        data: data,
        message: message
    }, "Credentials", AMPLIFY_SYMBOL);
};
var CredentialsClass = /** @class */ function() {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers["google"] = (0, _oauthHelper.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, _oauthHelper.FacebookOAuth).refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function() {
        return "Credentials";
    };
    CredentialsClass.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = __assign(__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, _storageHelper.StorageHelper)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        dispatchCredentialsEvent("credentials_configured", null, "Credentials has been configured successfully");
        return this._config;
    };
    CredentialsClass.prototype.get = function() {
        logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function(identityPoolId) {
        return "".concat(COGNITO_IDENTITY_KEY_PREFIX).concat(identityPoolId);
    };
    CredentialsClass.prototype._pickupCredentials = function() {
        logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            logger.debug("getting new cred promise");
            this._gettingCredPromise = (0, _js.makeQuerablePromise)(this._keepAlive());
        } else logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function() {
        return __awaiter(this, void 0, void 0, function() {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug("checking if credentials exists and not expired");
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            logger.debug("credentials not changed and not expired, directly return");
                            return [
                                2 /*return*/ ,
                                Promise.resolve(cred)
                            ];
                        }
                        logger.debug("need to get a new credential or refresh the existing one");
                        _a = this.Auth, Auth = _a === void 0 ? (0, _amplify.Amplify).Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== "function") // If Auth module is not imported, do a best effort to get guest credentials
                        return [
                            2 /*return*/ ,
                            this._setCredentialsForGuest()
                        ];
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [
                            3 /*break*/ ,
                            6
                        ];
                        logger.debug("ttl has passed but token is not yet expired");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            Auth.currentUserPoolUser()
                        ];
                    case 2:
                        user_1 = _b.sent();
                        return [
                            4 /*yield*/ ,
                            Auth.currentSession()
                        ];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function(res, rej) {
                            user_1.refreshSession(refreshToken_1, function(err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            refreshRequest
                        ];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        logger.debug("Error attempting to refreshing the session", err_1);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ ,
                            Auth.currentUserCredentials()
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function(federatedInfo) {
        logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at = new Date(expires_at).getFullYear() === 1970 ? expires_at * 1000 : expires_at;
        var that = this;
        logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            logger.debug("getting refreshed jwt token from federation provider");
            return this._providerRefreshWithRetry({
                refreshHandler: that._refreshHandlers[provider],
                provider: provider,
                user: user
            });
        } else {
            logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function(_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return (0, _util.jitteredExponentialRetry)(refreshHandler, [], MAX_DELAY_MS).then(function(data) {
            logger.debug("refresh federated token sucessfully", data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at
            });
        }).catch(function(e) {
            var isNetworkError = typeof e === "string" && e.toLowerCase().lastIndexOf("network error", e.length) === 0;
            if (!isNetworkError) _this.clear();
            logger.debug("refresh federated token failed", e);
            return Promise.reject("refreshing federation token failed: " + e);
        });
    };
    CredentialsClass.prototype._isExpired = function(credentials) {
        if (!credentials) {
            logger.debug("no credentials for expiration check");
            return true;
        }
        logger.debug("are these credentials expired?", credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */ var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function() {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function() {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var _b, identityPoolId, region, mandatorySignIn, identityPoolRegion, identityId, _c, cognitoConfig, guestCredentialsProvider, credentials;
            var _this = this;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        logger.debug("setting credentials for guest");
                        if (!((_a = this._config) === null || _a === void 0 ? void 0 : _a.identityPoolId)) // If Credentials are not configured thru Auth module,
                        // doing best effort to check if the library was configured
                        this._config = Object.assign({}, this._config, (0, _parseAWSExports.parseAWSExports)(this._config || {}).Auth);
                        _b = this._config, identityPoolId = _b.identityPoolId, region = _b.region, mandatorySignIn = _b.mandatorySignIn, identityPoolRegion = _b.identityPoolRegion;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            logger.debug("No Cognito Identity pool provided for unauthenticated access");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Identity pool provided for unauthenticated access")
                            ];
                        }
                        if (!identityPoolRegion && !region) {
                            logger.debug("region is not configured for getting the credentials");
                            return [
                                2 /*return*/ ,
                                Promise.reject("region is not configured for getting the credentials")
                            ];
                        }
                        _c = this;
                        return [
                            4 /*yield*/ ,
                            this._getGuestIdentityId()
                        ];
                    case 1:
                        identityId = _c._identityId = _d.sent();
                        cognitoConfig = {
                            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
                        };
                        guestCredentialsProvider = function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var IdentityId, Credentials;
                                return __generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!!identityId) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                    IdentityPoolId: identityPoolId
                                                })
                                            ];
                                        case 1:
                                            IdentityId = _a.sent().IdentityId;
                                            this._identityId = IdentityId;
                                            _a.label = 2;
                                        case 2:
                                            return [
                                                4 /*yield*/ ,
                                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                    IdentityId: this._identityId
                                                })
                                            ];
                                        case 3:
                                            Credentials = _a.sent().Credentials;
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    identityId: this._identityId,
                                                    accessKeyId: Credentials.AccessKeyId,
                                                    secretAccessKey: Credentials.SecretKey,
                                                    sessionToken: Credentials.SessionToken,
                                                    expiration: Credentials.Expiration
                                                }
                                            ];
                                    }
                                });
                            });
                        };
                        credentials = guestCredentialsProvider().catch(function(err) {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    throw err;
                                });
                            });
                        });
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var guestCredentialsProvider_1;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!(e.name === "ResourceNotFoundException" && e.message === "Identity '".concat(identityId, "' not found."))) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                logger.debug("Failed to load guest credentials");
                                                return [
                                                    4 /*yield*/ ,
                                                    this._removeGuestIdentityId()
                                                ];
                                            case 1:
                                                _a.sent();
                                                guestCredentialsProvider_1 = function() {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        var IdentityId, Credentials;
                                                        return __generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getId)(cognitoConfig, {
                                                                            IdentityPoolId: identityPoolId
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    IdentityId = _a.sent().IdentityId;
                                                                    this._identityId = IdentityId;
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                                                            IdentityId: IdentityId
                                                                        })
                                                                    ];
                                                                case 2:
                                                                    Credentials = _a.sent().Credentials;
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        {
                                                                            identityId: IdentityId,
                                                                            accessKeyId: Credentials.AccessKeyId,
                                                                            secretAccessKey: Credentials.SecretKey,
                                                                            sessionToken: Credentials.SessionToken,
                                                                            expiration: Credentials.Expiration
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                };
                                                credentials = guestCredentialsProvider_1().catch(function(err) {
                                                    return __awaiter(_this, void 0, void 0, function() {
                                                        return __generator(this, function(_a) {
                                                            throw err;
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    this._loadCredentials(credentials, "guest", false, null)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    e
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function(params) {
        var _this = this;
        var provider = params.provider, token = params.token;
        var identity_id = params.identity_id;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        var authenticatedCredentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var IdentityId, Credentials;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!identity_id) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 1:
                            IdentityId = _a.sent().IdentityId;
                            identity_id = IdentityId;
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: identity_id,
                                    Logins: logins
                                })
                            ];
                        case 3:
                            Credentials = _a.sent().Credentials;
                            return [
                                2 /*return*/ ,
                                {
                                    identityId: identity_id,
                                    accessKeyId: Credentials.AccessKeyId,
                                    secretAccessKey: Credentials.SecretKey,
                                    sessionToken: Credentials.SessionToken,
                                    expiration: Credentials.Expiration
                                }
                            ];
                    }
                });
            });
        };
        var credentials = authenticatedCredentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function(session) {
        var _this = this;
        logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId, identityPoolRegion = _a.identityPoolRegion;
        if (!identityPoolId) {
            logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        if (!identityPoolRegion && !region) {
            logger.debug("region is not configured for getting the credentials");
            return Promise.reject("region is not configured for getting the credentials");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoConfig = {
            region: identityPoolRegion !== null && identityPoolRegion !== void 0 ? identityPoolRegion : region
        };
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */ var credentialsProvider = function() {
            return __awaiter(_this, void 0, void 0, function() {
                var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this._getGuestIdentityId()
                            ];
                        case 1:
                            guestIdentityId = _c.sent();
                            if (!!guestIdentityId) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getId)(cognitoConfig, {
                                    IdentityPoolId: identityPoolId,
                                    Logins: logins
                                })
                            ];
                        case 2:
                            IdentityId = _c.sent().IdentityId;
                            generatedOrRetrievedIdentityId = IdentityId;
                            _c.label = 3;
                        case 3:
                            return [
                                4 /*yield*/ ,
                                (0, _cognitoIdentity.getCredentialsForIdentity)(cognitoConfig, {
                                    IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                                    Logins: logins
                                })
                            ];
                        case 4:
                            _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                            this._identityId = primaryIdentityId;
                            if (!guestIdentityId) return [
                                3 /*break*/ ,
                                6
                            ];
                            // if guestIdentity is found and used by GetCredentialsForIdentity
                            // it will be linked to the logins provided, and disqualified as an unauth identity
                            logger.debug("The guest identity ".concat(guestIdentityId, " has been successfully linked to the logins"));
                            if (guestIdentityId === primaryIdentityId) logger.debug("The guest identity ".concat(guestIdentityId, " has become the primary identity"));
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            return [
                                4 /*yield*/ ,
                                this._removeGuestIdentityId()
                            ];
                        case 5:
                            // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                            _c.sent();
                            _c.label = 6;
                        case 6:
                            // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretKey,
                                    sessionToken: SessionToken,
                                    expiration: Expiration,
                                    identityId: primaryIdentityId
                                }
                            ];
                    }
                });
            });
        };
        var credentials = credentialsProvider().catch(function(err) {
            return __awaiter(_this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    throw err;
                });
            });
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    CredentialsClass.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            credentials.then(function(credentials) {
                return __awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug("Load credentials successfully", credentials);
                                if (this._identityId && !credentials.identityId) credentials["identityId"] = this._identityId;
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                                if (source === "federated") {
                                    user = Object.assign({
                                        id: this._credentials.identityId
                                    }, info.user);
                                    provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                    try {
                                        this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                            provider: provider,
                                            token: token,
                                            user: user,
                                            expires_at: expires_at,
                                            identity_id: identity_id
                                        }));
                                    } catch (e) {
                                        logger.debug("Failed to put federated info into auth storage", e);
                                    }
                                }
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this._setGuestIdentityId(credentials.identityId)
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(err) {
                if (err) {
                    logger.debug("Failed to load credentials", credentials);
                    logger.debug("Error loading credentials", err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    CredentialsClass.prototype.clear = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                this._credentials = null;
                this._credentials_source = null;
                logger.debug("removing aws-amplify-federatedInfo from storage");
                this._storage.removeItem("aws-amplify-federatedInfo");
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /* operations on local stored guest identity */ CredentialsClass.prototype._getGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))
                        ];
                    case 3:
                        e_1 = _a.sent();
                        logger.debug("Failed to get the cached guest identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function(identityId) {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId, e_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        logger.debug("Failed to cache guest identityId", e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function() {
        return __awaiter(this, void 0, void 0, function() {
            var identityPoolId;
            return __generator(this, function(_a) {
                identityPoolId = this._config.identityPoolId;
                logger.debug("removing ".concat(this._getCognitoIdentityIdStorageKey(identityPoolId), " from storage"));
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ CredentialsClass.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return CredentialsClass;
}();
var Credentials = new CredentialsClass(null);
(0, _amplify.Amplify).register(Credentials);

},{"./Logger":"jVGZ5","./StorageHelper":"5ekFt","./JS":"58R8D","./OAuthHelper":"hpBPz","./Util":"5E0Hy","./Amplify":"fr4N4","./AwsClients/CognitoIdentity":"dP4eT","./parseAWSExports":"jNxFP","./Hub":"5RtWX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ekFt":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
parcelHelpers.export(exports, "StorageHelper", ()=>StorageHelper);
var dataMemory = {};
/** @class */ var MemoryStorage = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
var StorageHelper = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dP4eT":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", ()=>(0, _getId.getId));
parcelHelpers.export(exports, "getCredentialsForIdentity", ()=>(0, _getCredentialsForIdentity.getCredentialsForIdentity));
var _getId = require("./getId");
var _getCredentialsForIdentity = require("./getCredentialsForIdentity");

},{"./getId":"52QTt","./getCredentialsForIdentity":"jlmxN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"52QTt":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getId", ()=>getId);
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getIdSerializer = function(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)("GetId");
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getIdDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getId = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getIdSerializer, getIdDeserializer, (0, _base.defaultConfig));

},{"./base":"5UjG1","../../clients":"cD43M","../../clients/internal":"ddv9k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5UjG1":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cognitoIdentityTransferHandler", ()=>cognitoIdentityTransferHandler);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "getSharedHeaders", ()=>getSharedHeaders);
parcelHelpers.export(exports, "buildHttpRpcRequest", ()=>buildHttpRpcRequest);
var _clients = require("../../clients");
var _composeTransferHandler = require("../../clients/internal/composeTransferHandler");
var _retry = require("../../clients/middleware/retry");
var _platform = require("../../Platform");
var _detectFramework = require("../../Platform/detectFramework");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://cognito-identity.".concat(region, ".").concat((0, _clients.getDnsSuffix)(region)))
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ var disableCacheMiddleware = function() {
    return function(next, context) {
        return function disableCacheMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    request.headers["cache-control"] = "no-store";
                    return [
                        2 /*return*/ ,
                        next(request)
                    ];
                });
            });
        };
    };
};
var cognitoIdentityTransferHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _clients.unauthenticatedHandler), [
    disableCacheMiddleware
]);
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _clients.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
(0, _detectFramework.observeFrameworkChanges)(function() {
    defaultConfig.userAgentValue = (0, _platform.getAmplifyUserAgent)();
});
var getSharedHeaders = function(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "AWSCognitoIdentityService.".concat(operation)
    };
};
var buildHttpRpcRequest = function(_a, headers, body) {
    var url = _a.url;
    return {
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    };
};

},{"../../clients":"cD43M","../../clients/internal/composeTransferHandler":"gZ7pH","../../clients/middleware/retry":"4tNHX","../../Platform":"jNyBX","../../Platform/detectFramework":"kTkOK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cD43M":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>(0, _endpoints.getDnsSuffix));
parcelHelpers.export(exports, "fetchTransferHandler", ()=>(0, _fetch.fetchTransferHandler));
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>(0, _unauthenticated.unauthenticatedHandler));
parcelHelpers.export(exports, "authenticatedHandler", ()=>(0, _authenticated.authenticatedHandler));
parcelHelpers.export(exports, "getHashedPayload", ()=>(0, _signatureV4.getHashedPayload));
parcelHelpers.export(exports, "presignUrl", ()=>(0, _signatureV4.presignUrl));
parcelHelpers.export(exports, "signRequest", ()=>(0, _signatureV4.signRequest));
parcelHelpers.export(exports, "EMPTY_SHA256_HASH", ()=>(0, _constants.EMPTY_HASH));
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>(0, _extendedEncodeURIComponent.extendedEncodeURIComponent));
parcelHelpers.export(exports, "signingMiddleware", ()=>(0, _signing.signingMiddleware));
parcelHelpers.export(exports, "getRetryDecider", ()=>(0, _retry.getRetryDecider));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _retry.jitteredBackoff));
parcelHelpers.export(exports, "retryMiddleware", ()=>(0, _retry.retryMiddleware));
parcelHelpers.export(exports, "userAgentMiddleware", ()=>(0, _userAgent.userAgentMiddleware));
parcelHelpers.export(exports, "parseJsonBody", ()=>(0, _serde.parseJsonBody));
parcelHelpers.export(exports, "parseJsonError", ()=>(0, _serde.parseJsonError));
parcelHelpers.export(exports, "parseMetadata", ()=>(0, _serde.parseMetadata));
parcelHelpers.export(exports, "withMemoization", ()=>(0, _memoization.withMemoization));
var _endpoints = require("./endpoints");
var _fetch = require("./handlers/fetch");
var _unauthenticated = require("./handlers/unauthenticated");
var _authenticated = require("./handlers/authenticated");
var _signatureV4 = require("./middleware/signing/signer/signatureV4");
var _constants = require("./middleware/signing/signer/signatureV4/constants");
var _extendedEncodeURIComponent = require("./middleware/signing/utils/extendedEncodeURIComponent");
var _signing = require("./middleware/signing");
var _retry = require("./middleware/retry");
var _userAgent = require("./middleware/userAgent");
var _serde = require("./serde");
var _memoization = require("./utils/memoization");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./endpoints":"dNrJb","./handlers/fetch":false,"./handlers/unauthenticated":"cqaZL","./handlers/authenticated":false,"./middleware/signing/signer/signatureV4":"2tT6s","./middleware/signing/signer/signatureV4/constants":"frxal","./middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","./middleware/signing":"9ytdg","./middleware/retry":"4tNHX","./middleware/userAgent":"gWdeK","./serde":"g2QPG","./utils/memoization":"dTJWW","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dNrJb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>(0, _getDnsSuffix.getDnsSuffix));
var _getDnsSuffix = require("./getDnsSuffix");

},{"./getDnsSuffix":"OF1rB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OF1rB":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDnsSuffix", ()=>getDnsSuffix);
var _partitions = require("./partitions");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getDnsSuffix = function(region) {
    var e_1, _a;
    var partitions = (0, _partitions.partitionsInfo).partitions;
    try {
        for(var partitions_1 = __values(partitions), partitions_1_1 = partitions_1.next(); !partitions_1_1.done; partitions_1_1 = partitions_1.next()){
            var _b = partitions_1_1.value, regions = _b.regions, outputs = _b.outputs, regionRegex = _b.regionRegex;
            var regex = new RegExp(regionRegex);
            if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (partitions_1_1 && !partitions_1_1.done && (_a = partitions_1.return)) _a.call(partitions_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _partitions.defaultPartition).outputs.dnsSuffix;
};

},{"./partitions":"kNHAa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNHAa":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPartition", ()=>defaultPartition);
parcelHelpers.export(exports, "partitionsInfo", ()=>partitionsInfo);
var defaultPartition = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
var partitionsInfo = {
    partitions: [
        defaultPartition,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"GHQhD":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTransferHandler", ()=>fetchTransferHandler);
var _isomorphicUnfetch = require("isomorphic-unfetch"); // TODO: remove this dependency in v6
var _memoization = require("../utils/memoization");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var shouldSendBody = function(method) {
    return ![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
};
var fetchTransferHandler = function(_a, _b) {
    var url = _a.url, method = _a.method, headers = _a.headers, body = _a.body;
    var abortSignal = _b.abortSignal;
    return __awaiter(void 0, void 0, void 0, function() {
        var resp, e_1, responseHeaders, httpResponse, bodyWithMixin;
        var _c, _d;
        return __generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    _e.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url, {
                            method: method,
                            headers: headers,
                            body: shouldSendBody(method) ? body : undefined,
                            signal: abortSignal
                        })
                    ];
                case 1:
                    resp = _e.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    e_1 = _e.sent();
                    // TODO: needs to revise error handling in v6
                    // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
                    // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
                    if (e_1 instanceof TypeError) throw new Error("Network error");
                    throw e_1;
                case 3:
                    responseHeaders = {};
                    (_c = resp.headers) === null || _c === void 0 || _c.forEach(function(value, key) {
                        responseHeaders[key.toLowerCase()] = value;
                    });
                    httpResponse = {
                        statusCode: resp.status,
                        headers: responseHeaders,
                        body: null
                    };
                    bodyWithMixin = Object.assign((_d = resp.body) !== null && _d !== void 0 ? _d : {}, {
                        text: (0, _memoization.withMemoization)(function() {
                            return resp.text();
                        }),
                        blob: (0, _memoization.withMemoization)(function() {
                            return resp.blob();
                        }),
                        json: (0, _memoization.withMemoization)(function() {
                            return resp.json();
                        })
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, httpResponse), {
                            body: bodyWithMixin
                        })
                    ];
            }
        });
    });
};

},{"isomorphic-unfetch":"cSe6x","../utils/memoization":"dTJWW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cSe6x":[function(require,module,exports) {
module.exports = self.fetch || (self.fetch = require("b3738725eb27f9ce").default || require("b3738725eb27f9ce"));

},{"b3738725eb27f9ce":"bNOnZ"}],"bNOnZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(e, n) {
        return n = n || {}, new Promise(function(t, r) {
            var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
                return {
                    ok: 2 == (s.status / 100 | 0),
                    statusText: s.statusText,
                    status: s.status,
                    url: s.responseURL,
                    text: function() {
                        return Promise.resolve(s.responseText);
                    },
                    json: function() {
                        return Promise.resolve(s.responseText).then(JSON.parse);
                    },
                    blob: function() {
                        return Promise.resolve(new Blob([
                            s.response
                        ]));
                    },
                    clone: a,
                    headers: {
                        keys: function() {
                            return o;
                        },
                        entries: function() {
                            return u;
                        },
                        get: function(e) {
                            return i[e.toLowerCase()];
                        },
                        has: function(e) {
                            return e.toLowerCase() in i;
                        }
                    }
                };
            };
            for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
                s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                    o.push(n = n.toLowerCase()), u.push([
                        n,
                        t
                    ]), i[n] = i[n] ? i[n] + "," + t : t;
                }), t(a());
            }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
            s.send(n.body || null);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dTJWW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withMemoization", ()=>withMemoization);
var withMemoization = function(payloadAccessor) {
    var cached;
    return function() {
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cqaZL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unauthenticatedHandler", ()=>unauthenticatedHandler);
var _retry = require("../middleware/retry");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var unauthenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware)
]);

},{"../middleware/retry":"4tNHX","../middleware/userAgent":"gWdeK","../internal/composeTransferHandler":"gZ7pH","./fetch":"GHQhD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tNHX":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>(0, _middleware.retryMiddleware));
parcelHelpers.export(exports, "jitteredBackoff", ()=>(0, _jitteredBackoff.jitteredBackoff));
parcelHelpers.export(exports, "getRetryDecider", ()=>(0, _defaultRetryDecider.getRetryDecider));
var _middleware = require("./middleware");
var _jitteredBackoff = require("./jitteredBackoff");
var _defaultRetryDecider = require("./defaultRetryDecider");

},{"./middleware":"g2hxw","./jitteredBackoff":"7Lxk8","./defaultRetryDecider":"hjJfJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g2hxw":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var DEFAULT_RETRY_ATTEMPTS = 3;
var retryMiddleware = function(_a) {
    var _b = _a.maxAttempts, maxAttempts = _b === void 0 ? DEFAULT_RETRY_ATTEMPTS : _b, retryDecider = _a.retryDecider, computeDelay = _a.computeDelay, abortSignal = _a.abortSignal;
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return function(next, context) {
        return function retryMiddleware(request) {
            var _a;
            return __awaiter(this, void 0, void 0, function() {
                var error, attemptsCount, response, handleTerminalErrorOrResponse, e_1, delay;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            attemptsCount = (_a = context.attemptsCount) !== null && _a !== void 0 ? _a : 0;
                            handleTerminalErrorOrResponse = function() {
                                if (response) {
                                    addOrIncrementMetadataAttempts(response, attemptsCount);
                                    return response;
                                } else {
                                    addOrIncrementMetadataAttempts(error, attemptsCount);
                                    throw error;
                                }
                            };
                            _b.label = 1;
                        case 1:
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                11
                            ];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _b.sent();
                            error = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _b.sent();
                            error = e_1;
                            response = undefined;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                            attemptsCount = context.attemptsCount > attemptsCount ? context.attemptsCount : attemptsCount + 1;
                            context.attemptsCount = attemptsCount;
                            return [
                                4 /*yield*/ ,
                                retryDecider(response, error)
                            ];
                        case 6:
                            if (!_b.sent()) return [
                                3 /*break*/ ,
                                9
                            ];
                            if (!(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts)) return [
                                3 /*break*/ ,
                                8
                            ];
                            delay = computeDelay(attemptsCount);
                            return [
                                4 /*yield*/ ,
                                cancellableSleep(delay, abortSignal)
                            ];
                        case 7:
                            _b.sent();
                            _b.label = 8;
                        case 8:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 9:
                            return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                        case 10:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 11:
                            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
                            else return [
                                2 /*return*/ ,
                                handleTerminalErrorOrResponse()
                            ];
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
};
var cancellableSleep = function(timeoutMs, abortSignal) {
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    var timeoutId;
    var sleepPromiseResolveFn;
    var sleepPromise = new Promise(function(resolve) {
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
var addOrIncrementMetadataAttempts = function(nextHandlerOutput, attempts) {
    var _a;
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = __assign(__assign({}, (_a = nextHandlerOutput["$metadata"]) !== null && _a !== void 0 ? _a : {}), {
        attempts: attempts
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Lxk8":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jitteredBackoff", ()=>jitteredBackoff);
var _retry = require("../../../Util/Retry");
var DEFAULT_MAX_DELAY_MS = 300000;
var jitteredBackoff = function(attempt) {
    var delayFunction = (0, _retry.jitteredBackoff)(DEFAULT_MAX_DELAY_MS);
    var delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? DEFAULT_MAX_DELAY_MS : delay;
};

},{"../../../Util/Retry":"2d9ab","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hjJfJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRetryDecider", ()=>getRetryDecider);
var _isClockSkewError = require("./isClockSkewError");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getRetryDecider = function(errorParser) {
    return function(response, error) {
        return __awaiter(void 0, void 0, void 0, function() {
            var errorCode, _a, statusCode;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(error !== null && error !== void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = error;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            errorParser(response)
                        ];
                    case 2:
                        _a = _c.sent();
                        _c.label = 3;
                    case 3:
                        errorCode = ((_b = _a) !== null && _b !== void 0 ? _b : {}).name;
                        statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
                        return [
                            2 /*return*/ ,
                            isConnectionError(error) || isThrottlingError(statusCode, errorCode) || (0, _isClockSkewError.isClockSkewError)(errorCode) || isServerSideError(statusCode, errorCode)
                        ];
                }
            });
        });
    };
};
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
var TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var isThrottlingError = function(statusCode, errorCode) {
    return statusCode === 429 || THROTTLING_ERROR_CODES.includes(errorCode);
};
var isConnectionError = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "Network error";
};
var isServerSideError = function(statusCode, errorCode) {
    return [
        500,
        502,
        503,
        504
    ].includes(statusCode) || TIMEOUT_ERROR_CODES.includes(errorCode);
};

},{"./isClockSkewError":"gCLt9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCLt9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
var isClockSkewError = function(errorCode) {
    return CLOCK_SKEW_ERROR_CODES.includes(errorCode);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gWdeK":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>(0, _middleware.userAgentMiddleware));
var _middleware = require("./middleware");

},{"./middleware":"i8RBu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8RBu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var userAgentMiddleware = function(_a) {
    var _b = _a.userAgentHeader, userAgentHeader = _b === void 0 ? "x-amz-user-agent" : _b, _c = _a.userAgentValue, userAgentValue = _c === void 0 ? "" : _c;
    return function(next) {
        return function userAgentMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var result, headerName, response;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(userAgentValue.trim().length === 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 1:
                            result = _a.sent();
                            return [
                                2 /*return*/ ,
                                result
                            ];
                        case 2:
                            headerName = userAgentHeader.toLowerCase();
                            request.headers[headerName] = request.headers[headerName] ? "".concat(request.headers[headerName], " ").concat(userAgentValue) : userAgentValue;
                            return [
                                4 /*yield*/ ,
                                next(request)
                            ];
                        case 3:
                            response = _a.sent();
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gZ7pH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeTransferHandler", ()=>composeTransferHandler);
var composeTransferHandler = function(coreHandler, middleware) {
    return function(request, options) {
        var context = {};
        var composedHandler = function(request) {
            return coreHandler(request, options);
        };
        for(var i = middleware.length - 1; i >= 0; i--){
            var m = middleware[i];
            var resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bO3n6":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticatedHandler", ()=>authenticatedHandler);
var _retry = require("../middleware/retry");
var _signing = require("../middleware/signing");
var _userAgent = require("../middleware/userAgent");
var _composeTransferHandler = require("../internal/composeTransferHandler");
var _fetch = require("./fetch");
var authenticatedHandler = (0, _composeTransferHandler.composeTransferHandler)((0, _fetch.fetchTransferHandler), [
    (0, _userAgent.userAgentMiddleware),
    (0, _retry.retryMiddleware),
    (0, _signing.signingMiddleware)
]);

},{"../middleware/retry":"4tNHX","../middleware/signing":"9ytdg","../middleware/userAgent":"gWdeK","../internal/composeTransferHandler":"gZ7pH","./fetch":"GHQhD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ytdg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", ()=>(0, _middleware.signingMiddleware));
var _middleware = require("./middleware");

},{"./middleware":"g7THz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g7THz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signingMiddleware", ()=>signingMiddleware);
var _signatureV4 = require("./signer/signatureV4");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var signingMiddleware = function(_a) {
    var credentials = _a.credentials, region = _a.region, service = _a.service, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
    var currentSystemClockOffset;
    return function(next) {
        return function signingMiddleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var signRequestOptions, _a, signedRequest, response, dateString;
                var _b;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
                            _b = {};
                            if (!(typeof credentials === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                credentials()
                            ];
                        case 1:
                            _a = _c.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _a = credentials;
                            _c.label = 3;
                        case 3:
                            signRequestOptions = (_b.credentials = _a, _b.signingDate = (0, _getSkewCorrectedDate.getSkewCorrectedDate)(currentSystemClockOffset), _b.signingRegion = region, _b.signingService = service, _b.uriEscapePath = uriEscapePath, _b);
                            return [
                                4 /*yield*/ ,
                                (0, _signatureV4.signRequest)(request, signRequestOptions)
                            ];
                        case 4:
                            signedRequest = _c.sent();
                            return [
                                4 /*yield*/ ,
                                next(signedRequest)
                            ];
                        case 5:
                            response = _c.sent();
                            dateString = getDateHeader(response);
                            if (dateString) currentSystemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(Date.parse(dateString), currentSystemClockOffset);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, headers = _d.headers;
    return (_c = (_b = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _b !== void 0 ? _b : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _c !== void 0 ? _c : headers === null || headers === void 0 ? void 0 : headers["x-amz-date"];
};

},{"./signer/signatureV4":"2tT6s","./utils/getSkewCorrectedDate":"7UTN1","./utils/getUpdatedSystemClockOffset":"4qK3e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7UTN1":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4qK3e":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTimeInMilliseconds, currentSystemClockOffset) {
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"gMoJz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMoJz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
var SKEW_WINDOW = 300000;
var isClockSkewed = function(clockTimeInMilliseconds, clockOffsetInMilliseconds) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= SKEW_WINDOW;
};

},{"./getSkewCorrectedDate":"7UTN1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gx4L4":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Wraps encodeURIComponent to encode additional characters to fully adhere to RFC 3986.
 * @see https://github.com/aws/aws-sdk-js-v3/blob/86b432c464150069678b25ff88d57c2ca26e75a2/packages/smithy-client/src/extended-encode-uri-component.ts#L7
 *
 * @param uri URI string to encode
 * @returns RFC 3986 encoded string
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
var extendedEncodeURIComponent = function(uri) {
    // Match characters normally not encoded by `encodeURIComponent`
    var extendedCharacters = /[!'()*]/g;
    return encodeURIComponent(uri).replace(extendedCharacters, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g2QPG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", ()=>(0, _responseInfo.parseMetadata));
parcelHelpers.export(exports, "parseJsonBody", ()=>(0, _json.parseJsonBody));
parcelHelpers.export(exports, "parseJsonError", ()=>(0, _json.parseJsonError));
var _responseInfo = require("./responseInfo");
var _json = require("./json");

},{"./responseInfo":"d9FuD","./json":"jR1RV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9FuD":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetadata", ()=>parseMetadata);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var parseMetadata = function(response) {
    var _a, _b;
    var headers = response.headers, statusCode = response.statusCode;
    return __assign(__assign({}, isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_b = (_a = headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
var isMetadataBearer = function(response) {
    return typeof (response === null || response === void 0 ? void 0 : response["$metadata"]) === "object";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jR1RV":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonError", ()=>parseJsonError);
parcelHelpers.export(exports, "parseJsonBody", ()=>parseJsonBody);
var _responseInfo = require("./responseInfo");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var parseJsonError = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var body, sanitizeErrorCode, code, message, error;
        var _a, _b, _c, _d, _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    return [
                        4 /*yield*/ ,
                        parseJsonBody(response)
                    ];
                case 1:
                    body = _f.sent();
                    sanitizeErrorCode = function(rawValue) {
                        var _a = __read(rawValue.toString().split(/[\,\:]+/), 1), cleanValue = _a[0];
                        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
                        return cleanValue;
                    };
                    code = sanitizeErrorCode((_c = (_b = (_a = response.headers["x-amzn-errortype"]) !== null && _a !== void 0 ? _a : body.code) !== null && _b !== void 0 ? _b : body.__type) !== null && _c !== void 0 ? _c : "UnknownError");
                    message = (_e = (_d = body.message) !== null && _d !== void 0 ? _d : body.Message) !== null && _e !== void 0 ? _e : "Unknown error";
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseJsonBody = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var output;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) throw new Error("Missing response payload");
                    return [
                        4 /*yield*/ ,
                        response.body.json()
                    ];
                case 1:
                    output = _a.sent();
                    return [
                        2 /*return*/ ,
                        Object.assign(output, {
                            $metadata: (0, _responseInfo.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};

},{"./responseInfo":"d9FuD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddv9k":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This index should NOT be included in the ../index.ts because the composer functions
 * here requires TypeScript >= 4. Given other scoped packages may use TypeScript < 4,
 * they should not be exposed to upper level index.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>(0, _composeServiceApi.composeServiceApi));
parcelHelpers.export(exports, "composeTransferHandler", ()=>(0, _composeTransferHandler.composeTransferHandler));
var _composeServiceApi = require("./composeServiceApi");
var _composeTransferHandler = require("./composeTransferHandler");

},{"./composeServiceApi":"5aofV","./composeTransferHandler":"gZ7pH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5aofV":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeServiceApi", ()=>composeServiceApi);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var composeServiceApi = function(transferHandler, serializer, deserializer, defaultConfig) {
    return function(config, input) {
        return __awaiter(void 0, void 0, void 0, function() {
            var resolvedConfig, endpoint, request, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resolvedConfig = __assign(__assign({}, defaultConfig), config);
                        return [
                            4 /*yield*/ ,
                            resolvedConfig.endpointResolver(resolvedConfig, input)
                        ];
                    case 1:
                        endpoint = _a.sent();
                        return [
                            4 /*yield*/ ,
                            serializer(input, endpoint)
                        ];
                    case 2:
                        request = _a.sent();
                        return [
                            4 /*yield*/ ,
                            transferHandler(request, __assign({}, resolvedConfig))
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            deserializer(response)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jlmxN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCredentialsForIdentity", ()=>getCredentialsForIdentity);
var _base = require("./base");
var _clients = require("../../clients");
var _internal = require("../../clients/internal");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getCredentialsForIdentitySerializer = function(input, endpoint) {
    var headers = (0, _base.getSharedHeaders)("GetCredentialsForIdentity");
    var body = JSON.stringify(input);
    return (0, _base.buildHttpRpcRequest)(endpoint, headers, body);
};
var getCredentialsForIdentityDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, body;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _clients.parseJsonBody)(response)
                    ];
                case 3:
                    body = _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            IdentityId: body.IdentityId,
                            Credentials: deserializeCredentials(body.Credentials),
                            $metadata: (0, _clients.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var deserializeCredentials = function(output) {
    if (output === void 0) output = {};
    return {
        AccessKeyId: output["AccessKeyId"],
        SecretKey: output["SecretKey"],
        SessionToken: output["SessionToken"],
        Expiration: new Date(output["Expiration"] * 1000)
    };
};
var getCredentialsForIdentity = (0, _internal.composeServiceApi)((0, _base.cognitoIdentityTransferHandler), getCredentialsForIdentitySerializer, getCredentialsForIdentityDeserializer, (0, _base.defaultConfig));

},{"./base":"5UjG1","../../clients":"cD43M","../../clients/internal":"ddv9k","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kspiO":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorker", ()=>(0, _serviceWorker.ServiceWorkerClass));
var _serviceWorker = require("./ServiceWorker");

},{"./ServiceWorker":"O7sSM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"O7sSM":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceWorkerClass", ()=>ServiceWorkerClass);
var _logger = require("../Logger");
var _js = require("../JS");
var _amplify = require("../Amplify");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var ServiceWorkerClass = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, _logger.ConsoleLogger)("ServiceWorker");
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = "/service-worker.js";
        if (scope === void 0) scope = "/";
        this._logger.debug("registering ".concat(filePath));
        this._logger.debug("registering service worker with scope ".concat(scope));
        return new Promise(function(resolve, reject) {
            if (navigator && "serviceWorker" in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: ".concat(registration));
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed ".concat(error));
                return reject(error);
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error("Service Worker not registered");
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, _js.browserOrNode)().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: ".concat(JSON.stringify(subscription)));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: ".concat(JSON.stringify(subscription)));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = "=".repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === "object" ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener("statechange", function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: ".concat(currentState));
            if ((0, _amplify.Amplify).Analytics && typeof (0, _amplify.Amplify).Analytics.record === "function") (0, _amplify.Amplify).Analytics.record({
                name: "ServiceWorker",
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener("message", function(event) {
            _this._logger.debug("ServiceWorker message event: ".concat(event));
        });
    };
    return ServiceWorkerClass;
}();

},{"../Logger":"jVGZ5","../JS":"58R8D","../Amplify":"fr4N4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8JhHm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniversalStorage", ()=>UniversalStorage);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _universalCookie = require("universal-cookie");
var _universalCookieDefault = parcelHelpers.interopDefault(_universalCookie);
var _js = require("../JS");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var isBrowser = (0, _js.browserOrNode)().isBrowser;
var ONE_YEAR_IN_MS = 31536000000;
var UniversalStorage = /** @class */ function() {
    function UniversalStorage(context) {
        if (context === void 0) context = {};
        this.cookies = new (0, _universalCookieDefault.default)();
        this.store = isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req ? new (0, _universalCookieDefault.default)(decodeURIComponent(context.req.headers.cookie)) : new (0, _universalCookieDefault.default)();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function() {
            return Object.entries(this.store).length;
        },
        enumerable: false,
        configurable: true
    });
    UniversalStorage.prototype.clear = function() {
        var _this = this;
        Array.from(new Array(this.length)).map(function(_, i) {
            return _this.key(i);
        }).forEach(function(key) {
            return _this.removeItem(key);
        });
    };
    UniversalStorage.prototype.getItem = function(key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function(key) {
        return Object.prototype.hasOwnProperty.call(this.store, key) ? this.store[key] : null;
    };
    UniversalStorage.prototype.getUniversalItem = function(key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function(index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function(key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function(key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function(key) {
        this.cookies.remove(key, {
            path: "/"
        });
    };
    UniversalStorage.prototype.setItem = function(key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split(".").pop();
        var sessionTokenTypes = [
            "LastAuthUser",
            "accessToken",
            // refreshToken originates on the client, but SSR pages won't fail when this expires
            // Note: the new `accessToken` will also be refreshed on the client (since Amplify doesn't set server-side cookies)
            "refreshToken",
            // Required for CognitoUserSession
            "idToken"
        ];
        if (sessionTokenTypes.includes(tokenType !== null && tokenType !== void 0 ? tokenType : "")) this.setUniversalItem(key, value, {
            expires: new Date(Date.now() + ONE_YEAR_IN_MS)
        });
    };
    UniversalStorage.prototype.setLocalItem = function(key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function(key, value, options) {
        if (options === void 0) options = {};
        this.cookies.set(key, value, __assign(__assign({}, options), {
            path: "/",
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: isBrowser && window.location.hostname === "localhost" ? false : true
        }));
    };
    return UniversalStorage;
}();

},{"universal-cookie":"a6HVs","../JS":"58R8D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a6HVs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cookies = require("./Cookies");
var _cookiesDefault = parcelHelpers.interopDefault(_cookies);
exports.default = (0, _cookiesDefault.default);

},{"./Cookies":"lhW4V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lhW4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cookie = require("cookie");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, _utils.parseCookies)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = _cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, _utils.readCookie)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, _utils.readCookie)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = _cookie.serialize(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = __assign(__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = _cookie.serialize(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
exports.default = Cookies;

},{"cookie":"9bZUN","./utils":"2PSau","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9bZUN":[function(require,module,exports) {
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ exports.parse = parse;
exports.serialize = serialize;
/**
 * Module variables.
 * @private
 */ var decode = decodeURIComponent;
var encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

},{}],"2PSau":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasDocumentCookie", ()=>hasDocumentCookie);
parcelHelpers.export(exports, "cleanCookies", ()=>cleanCookies);
parcelHelpers.export(exports, "parseCookies", ()=>parseCookies);
parcelHelpers.export(exports, "isParsingCookie", ()=>isParsingCookie);
parcelHelpers.export(exports, "readCookie", ()=>readCookie);
var _cookie = require("cookie");
function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function cleanCookies() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === "string") return _cookie.parse(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) options = {};
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}

},{"cookie":"9bZUN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jxe0I":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", ()=>INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER);
parcelHelpers.export(exports, "USER_AGENT_HEADER", ()=>USER_AGENT_HEADER);
var hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER = hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var USER_AGENT_HEADER = "x-amz-user-agent";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4FqWo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Analytics", ()=>(0, _analytics.Analytics));
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _providers.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _providers.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _providers.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _providers.AmazonPersonalizeProvider));
var _analytics = require("./Analytics");
var _providers = require("./Providers");

},{"./Analytics":"l22sr","./Providers":"nvQ6G","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l22sr":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsClass", ()=>AnalyticsClass);
parcelHelpers.export(exports, "Analytics", ()=>Analytics);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awspinpointProvider = require("./Providers/AWSPinpointProvider");
var _trackers = require("./trackers");
var logger = new (0, _core.ConsoleLogger)("AnalyticsClass");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("analytics", {
        event: event,
        data: data,
        message: message
    }, "Analytics", AMPLIFY_SYMBOL);
};
var trackers = {
    pageView: (0, _trackers.PageViewTracker),
    event: (0, _trackers.EventTracker),
    session: (0, _trackers.SessionTracker)
};
var _instance = null;
/**
 * Provide mobile analytics client functions
 */ var AnalyticsClass = /** @class */ function() {
    /**
     * Initialize Analtyics
     * @param config - Configuration of the Analytics
     */ function AnalyticsClass() {
        this._config = {};
        this._pluggables = [];
        this._disabled = false;
        this._trackers = {};
        _instance = this;
        this.record = this.record.bind(this);
        (0, _core.Hub).listen("auth", listener);
        (0, _core.Hub).listen("storage", listener);
        (0, _core.Hub).listen("analytics", listener);
        (0, _core.Hub).listen("core", listener);
    }
    AnalyticsClass.prototype.getModuleName = function() {
        return "Analytics";
    };
    /**
     * configure Analytics
     * @param {Object} config - Configuration of the Analytics
     */ AnalyticsClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        logger.debug("configure Analytics", config);
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Analytics, config);
        if (this._config["disabled"]) this._disabled = true;
        // turn on the autoSessionRecord if not specified
        if (this._config["autoSessionRecord"] === undefined) this._config["autoSessionRecord"] = true;
        this._pluggables.forEach(function(pluggable) {
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !_this._config["AWSPinpoint"] ? _this._config : _this._config[pluggable.getProviderName()];
            pluggable.configure((0, _tslib.__assign)({
                disabled: _this._config["disabled"],
                autoSessionRecord: _this._config["autoSessionRecord"]
            }, providerConfig));
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _awspinpointProvider.AWSPinpointProvider)());
        dispatchAnalyticsEvent("configured", null, "The Analytics category has been configured successfully");
        logger.debug("current configuration", this._config);
        return this._config;
    };
    /**
     * add plugin into Analytics category
     * @param pluggable - an instance of the plugin
     */ AnalyticsClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Analytics") {
            this._pluggables.push(pluggable);
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !this._config["AWSPinpoint"] ? this._config : this._config[pluggable.getProviderName()];
            var config = (0, _tslib.__assign)({
                disabled: this._config["disabled"]
            }, providerConfig);
            pluggable.configure(config);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.getPluggable = function(providerName) {
        for(var i = 0; i < this._pluggables.length; i += 1){
            var pluggable = this._pluggables[i];
            if (pluggable.getProviderName() === providerName) return pluggable;
        }
        logger.debug("No plugin found with providerName", providerName);
        return null;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the provider to be removed
     */ AnalyticsClass.prototype.removePluggable = function(providerName) {
        var idx = 0;
        while(idx < this._pluggables.length){
            if (this._pluggables[idx].getProviderName() === providerName) break;
            idx += 1;
        }
        if (idx === this._pluggables.length) {
            logger.debug("No plugin found with providerName", providerName);
            return;
        } else {
            this._pluggables.splice(idx, idx + 1);
            return;
        }
    };
    /**
     * stop sending events
     */ AnalyticsClass.prototype.disable = function() {
        this._disabled = true;
    };
    /**
     * start sending events
     */ AnalyticsClass.prototype.enable = function() {
        this._disabled = false;
    };
    /**
     * Record Session start
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.startSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: "_session.start"
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", event, "Recording Analytics session start event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record Session stop
     * @param [provider] - name of the provider.
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.stopSession = function(provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event, params;
            return (0, _tslib.__generator)(this, function(_a) {
                event = {
                    name: "_session.stop"
                };
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", event, "Recording Analytics session stop event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record one analytic event and send it to Pinpoint
     * @param event - An object with the name of the event, attributes of the event and event metrics.
     * @param [provider] - name of the provider.
     */ AnalyticsClass.prototype.record = function(event, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params;
            return (0, _tslib.__generator)(this, function(_a) {
                params = {
                    event: event,
                    provider: provider
                };
                dispatchAnalyticsEvent("record", params.event, "Recording Analytics event");
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    AnalyticsClass.prototype.updateEndpoint = function(attrs, provider) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = (0, _tslib.__assign)((0, _tslib.__assign)({}, attrs), {
                    name: "_update_endpoint"
                });
                return [
                    2 /*return*/ ,
                    this.record(event, provider)
                ];
            });
        });
    };
    AnalyticsClass.prototype._sendEvent = function(params) {
        var _this = this;
        if (this._disabled) {
            logger.debug("Analytics has been disabled");
            return Promise.resolve();
        }
        var provider = params.provider ? params.provider : "AWSPinpoint";
        return new Promise(function(resolve, reject) {
            _this._pluggables.forEach(function(pluggable) {
                if (pluggable.getProviderName() === provider) pluggable.record(params, {
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    };
    AnalyticsClass.prototype.autoTrack = function(trackerType, opts) {
        if (!trackers[trackerType]) {
            logger.debug("invalid tracker type");
            return;
        }
        // to sync up two different configuration ways of auto session tracking
        if (trackerType === "session") this._config["autoSessionRecord"] = opts["enable"];
        var tracker = this._trackers[trackerType];
        if (!tracker) this._trackers[trackerType] = new trackers[trackerType](this.record, opts);
        else tracker.configure(opts);
    };
    return AnalyticsClass;
}();
var endpointUpdated = false;
var authConfigured = false;
var analyticsConfigured = false;
var credentialsConfigured = false;
var listener = function(capsule) {
    var channel = capsule.channel, payload = capsule.payload;
    logger.debug("on hub capsule " + channel, payload);
    switch(channel){
        case "auth":
            authEvent(payload);
            break;
        case "storage":
            storageEvent(payload);
            break;
        case "analytics":
            analyticsEvent(payload);
            break;
        case "core":
            coreEvent(payload);
            break;
        default:
            break;
    }
};
var storageEvent = function(payload) {
    var _a = payload.data, attrs = _a.attrs, metrics = _a.metrics;
    if (!attrs) return;
    if (analyticsConfigured) _instance.record({
        name: "Storage",
        attributes: attrs,
        metrics: metrics
    }).catch(function(e) {
        logger.debug("Failed to send the storage event automatically", e);
    });
};
var authEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    var recordAuthEvent = function(eventName) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(authConfigured && analyticsConfigured)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            _instance.record({
                                name: "_userauth." + eventName
                            })
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        err_1 = _a.sent();
                        logger.debug("Failed to send the " + eventName + " event automatically", err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    switch(event){
        case "signIn":
            return recordAuthEvent("sign_in");
        case "signUp":
            return recordAuthEvent("sign_up");
        case "signOut":
            return recordAuthEvent("sign_out");
        case "signIn_failure":
            return recordAuthEvent("auth_fail");
        case "configured":
            authConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var analyticsEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case "pinpointProvider_configured":
            analyticsConfigured = true;
            if (authConfigured || credentialsConfigured) sendEvents();
            break;
    }
};
var coreEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case "credentials_configured":
            credentialsConfigured = true;
            if (analyticsConfigured) sendEvents();
            break;
    }
};
var sendEvents = function() {
    var config = _instance.configure();
    if (!endpointUpdated && config["autoSessionRecord"]) {
        _instance.updateEndpoint({
            immediate: true
        }).catch(function(e) {
            logger.debug("Failed to update the endpoint", e);
        });
        endpointUpdated = true;
    }
    _instance.autoTrack("session", {
        enable: config["autoSessionRecord"]
    });
};
var Analytics = new AnalyticsClass();
(0, _core.Amplify).register(Analytics);

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","./Providers/AWSPinpointProvider":"2eV5C","./trackers":"a0O3X","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eOnzl":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2eV5C":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>AWSPinpointProvider);
var _tslib = require("tslib");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var _userAgent = require("../utils/UserAgent");
var _eventBuffer = require("./EventBuffer");
var _eventBufferDefault = parcelHelpers.interopDefault(_eventBuffer);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAnalyticsEvent = function(event, data) {
    (0, _core.Hub).dispatch("analytics", {
        event: event,
        data: data
    }, "Analytics", AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)("AWSPinpointProvider");
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var FORBIDDEN_CODE = 403;
var MOBILE_SERVICE_NAME = "mobiletargeting";
var EXPIRED_TOKEN_CODE = "ExpiredTokenException";
var UPDATE_ENDPOINT = "_update_endpoint";
var SESSION_START = "_session.start";
var SESSION_STOP = "_session.stop";
var BEACON_SUPPORTED = typeof navigator !== "undefined" && navigator && typeof navigator.sendBeacon === "function";
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
// params: { event: {name: , .... }, timeStamp, config, resendLimits }
var AWSPinpointProvider = /** @class */ function() {
    function AWSPinpointProvider(config) {
        this._endpointGenerating = true;
        this._endpointUpdateInProgress = false;
        this._buffer = null;
        this._endpointBuffer = [];
        this._config = config ? config : {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._clientInfo = (0, _core.ClientDevice).clientInfo();
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProvider.prototype.getCategory = function() {
        return AWSPinpointProvider.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProvider.prototype.getProviderName = function() {
        return AWSPinpointProvider.providerName;
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSPinpointProvider.prototype.configure = function(config) {
        var _this = this;
        logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        // If autoSessionRecord is enabled, we need to wait for the endpoint to be
        // updated before sending any events. See `sendEvents` in `Analytics.ts`
        this._endpointGenerating = !!config["autoSessionRecord"];
        if (this._config.appId && !this._config.disabled) {
            if (!this._config.endpointId) {
                var cacheKey = this.getProviderName() + "_" + this._config.appId;
                this._getEndpointId(cacheKey).then(function(endpointId) {
                    logger.debug("setting endpoint id from the cache", endpointId);
                    _this._config.endpointId = endpointId;
                    dispatchAnalyticsEvent("pinpointProvider_configured", null);
                }).catch(function(err) {
                    logger.debug("Failed to generate endpointId", err);
                });
            } else dispatchAnalyticsEvent("pinpointProvider_configured", null);
        } else this._flushBuffer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSPinpointProvider.prototype.record = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, timestamp;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("_public record", params);
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials || !this._config.appId || !this._config.region) {
                            logger.debug("cannot send events without credentials, applicationId or region");
                            return [
                                2 /*return*/ ,
                                handlers.reject(new Error("No credentials, applicationId or region"))
                            ];
                        }
                        this._init(credentials);
                        timestamp = new Date().getTime();
                        // attach the session and eventId
                        this._generateSession(params);
                        params.event.eventId = (0, _uuid.v1)();
                        Object.assign(params, {
                            timestamp: timestamp,
                            config: this._config
                        });
                        if (params.event.immediate) return [
                            2 /*return*/ ,
                            this._send(params, handlers)
                        ];
                        else this._putToBuffer(params, handlers);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._sendEndpointUpdate = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var next;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._endpointUpdateInProgress) {
                            this._endpointBuffer.push(endpointObject);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._endpointUpdateInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._updateEndpoint(endpointObject)
                        ];
                    case 1:
                        _a.sent();
                        next = this._endpointBuffer.shift();
                        this._endpointUpdateInProgress = false;
                        next && this._sendEndpointUpdate(next);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     * @param params - params for event recording
     * Put events into buffer
     */ AWSPinpointProvider.prototype._putToBuffer = function(params, handlers) {
        var _a;
        if (params.event.name === UPDATE_ENDPOINT) {
            this._sendEndpointUpdate({
                params: params,
                handlers: handlers
            });
            return;
        }
        (_a = this._buffer) === null || _a === void 0 || _a.push({
            params: params,
            handlers: handlers
        });
    };
    AWSPinpointProvider.prototype._generateSession = function(params) {
        this._sessionId = this._sessionId || (0, _uuid.v1)();
        var event = params.event;
        switch(event.name){
            case SESSION_START:
                // refresh the session id and session start time
                this._sessionStartTimestamp = new Date().getTime();
                this._sessionId = (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
                break;
            case SESSION_STOP:
                var stopTimestamp = new Date().getTime();
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    Duration: stopTimestamp - this._sessionStartTimestamp,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString(),
                    StopTimestamp: new Date(stopTimestamp).toISOString()
                };
                this._sessionId = undefined;
                this._sessionStartTimestamp = undefined;
                break;
            default:
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, _uuid.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
        }
    };
    AWSPinpointProvider.prototype._send = function(params, handlers) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var event;
            return (0, _tslib.__generator)(this, function(_a) {
                event = params.event;
                switch(event.name){
                    case UPDATE_ENDPOINT:
                        return [
                            2 /*return*/ ,
                            this._updateEndpoint({
                                params: params,
                                handlers: handlers
                            })
                        ];
                    case SESSION_STOP:
                        return [
                            2 /*return*/ ,
                            this._pinpointSendStopSession(params, handlers)
                        ];
                    default:
                        return [
                            2 /*return*/ ,
                            this._pinpointPutEvents(params, handlers)
                        ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._generateBatchItemContext = function(params) {
        var _a, _b;
        var event = params.event, timestamp = params.timestamp, config = params.config;
        var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
        var appId = config.appId, endpointId = config.endpointId;
        var endpointContext = {};
        return {
            ApplicationId: appId,
            EventsRequest: {
                BatchItem: (_a = {}, _a[endpointId] = {
                    Endpoint: endpointContext,
                    Events: (_b = {}, _b[eventId] = {
                        EventType: name,
                        Timestamp: new Date(timestamp).toISOString(),
                        Attributes: attributes,
                        Metrics: metrics,
                        Session: session
                    }, _b)
                }, _a)
            }
        };
    };
    AWSPinpointProvider.prototype._pinpointPutEvents = function(params, handlers) {
        var _a, _b, _c, _d, _e;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventId, endpointId, eventParams, _f, credentials, region, data, _g, StatusCode, Message, err_1;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        eventId = params.event.eventId, endpointId = params.config.endpointId;
                        eventParams = this._generateBatchItemContext(params);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _f = this._config, credentials = _f.credentials, region = _f.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, eventParams)
                        ];
                    case 2:
                        data = _h.sent();
                        _g = (_e = (_d = (_c = (_b = (_a = data.EventsResponse) === null || _a === void 0 ? void 0 : _a.Results) === null || _b === void 0 ? void 0 : _b[endpointId]) === null || _c === void 0 ? void 0 : _c.EventsItemResponse) === null || _d === void 0 ? void 0 : _d[eventId]) !== null && _e !== void 0 ? _e : {}, StatusCode = _g.StatusCode, Message = _g.Message;
                        if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                            logger.debug("record event success. ", data);
                            return [
                                2 /*return*/ ,
                                handlers.resolve(data)
                            ];
                        } else if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) // TODO: v6 integrate retry to the service handler retryDecider
                        this._retry(params, handlers);
                        else {
                            logger.error("Event " + eventId + " is not accepted, the error is " + Message);
                            return [
                                2 /*return*/ ,
                                handlers.reject(data)
                            ];
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _h.sent();
                        this._eventError(err_1);
                        return [
                            2 /*return*/ ,
                            handlers.reject(err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._pinpointSendStopSession = function(params, handlers) {
        if (!BEACON_SUPPORTED) {
            this._pinpointPutEvents(params, handlers);
            return;
        }
        var eventParams = this._generateBatchItemContext(params);
        var region = this._config.region;
        var ApplicationId = eventParams.ApplicationId, EventsRequest = eventParams.EventsRequest;
        var accessInfo = {
            secret_key: this._config.credentials.secretAccessKey,
            access_key: this._config.credentials.accessKeyId,
            session_token: this._config.credentials.sessionToken
        };
        var url = "https://pinpoint." + region + ".amazonaws.com/v1/apps/" + ApplicationId + "/events/legacy";
        var body = JSON.stringify(EventsRequest);
        var method = "POST";
        var request = {
            url: url,
            body: body,
            method: method
        };
        var serviceInfo = {
            region: region,
            service: MOBILE_SERVICE_NAME
        };
        var requestUrl = (0, _core.Signer).signUrl(request, accessInfo, serviceInfo);
        var success = navigator.sendBeacon(requestUrl, body);
        if (success) return handlers.resolve("sendBeacon success");
        return handlers.reject("sendBeacon failure");
    };
    AWSPinpointProvider.prototype._retry = function(params, handlers) {
        var resendLimit = params.config.resendLimit;
        // For backward compatibility
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending event " + params.eventName + " with " + params.resendLimit + " retry times left");
            this._pinpointPutEvents(params, handlers);
        } else logger.debug("retry times used up for event " + params.eventName);
    };
    AWSPinpointProvider.prototype._updateEndpoint = function(endpointObject) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var params, handlers, config, event, appId, endpointId, request, update_params, _a, credentials, region, data, err_2, failureData;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        params = endpointObject.params, handlers = endpointObject.handlers;
                        config = params.config, event = params.event;
                        appId = config.appId, endpointId = config.endpointId;
                        request = this._endpointRequest(config, (0, _core.transferKeyToLowerCase)(event, [], [
                            "attributes",
                            "userAttributes",
                            "Attributes",
                            "UserAttributes"
                        ]));
                        update_params = {
                            ApplicationId: appId,
                            EndpointId: endpointId,
                            EndpointRequest: request
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.updateEndpoint)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).UpdateEndpoint)
                            }, update_params)
                        ];
                    case 2:
                        data = _b.sent();
                        logger.debug("updateEndpoint success", data);
                        this._endpointGenerating = false;
                        this._resumeBuffer();
                        handlers.resolve(data);
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        err_2 = _b.sent();
                        failureData = {
                            err: err_2,
                            update_params: update_params,
                            endpointObject: endpointObject
                        };
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateFailure(failureData)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateFailure = function(failureData) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err, endpointObject, statusCode, exponential;
            return (0, _tslib.__generator)(this, function(_a) {
                err = failureData.err, endpointObject = failureData.endpointObject;
                statusCode = err.$metadata && err.$metadata.httpStatusCode;
                logger.debug("updateEndpoint error", err);
                switch(statusCode){
                    case FORBIDDEN_CODE:
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateForbidden(failureData)
                        ];
                    default:
                        if (RETRYABLE_CODES.includes(statusCode)) {
                            exponential = true;
                            return [
                                2 /*return*/ ,
                                this._retryEndpointUpdate(endpointObject, exponential)
                            ];
                        }
                        logger.error("updateEndpoint failed", err);
                        endpointObject.handlers.reject(err);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateForbidden = function(failureData) {
        var err = failureData.err, endpointObject = failureData.endpointObject;
        var code = err.code, retryable = err.retryable;
        if (code !== EXPIRED_TOKEN_CODE && !retryable) return endpointObject.handlers.reject(err);
        this._retryEndpointUpdate(endpointObject);
    };
    AWSPinpointProvider.prototype._retryEndpointUpdate = function(endpointObject, exponential) {
        if (exponential === void 0) exponential = false;
        logger.debug("_retryEndpointUpdate", endpointObject);
        var params = endpointObject.params;
        // TODO: implement retry with exp back off once exp function is available
        var resendLimit = params.config.resendLimit;
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            logger.debug("resending endpoint update " + params.event.eventId + " with " + params.resendLimit + " retry attempts remaining");
            // insert at the front of endpointBuffer
            this._endpointBuffer.length ? this._endpointBuffer.unshift(endpointObject) : this._updateEndpoint(endpointObject);
            return;
        }
        logger.warn("resending endpoint update " + params.event.eventId + " failed after " + params.config.resendLimit + " attempts");
        if (this._endpointGenerating) logger.error("Initial endpoint update failed. ");
    };
    /**
     * @private
     * @param config
     * Configure credentials and init buffer
     */ AWSPinpointProvider.prototype._init = function(credentials) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var identityId;
            return (0, _tslib.__generator)(this, function(_a) {
                logger.debug("init provider");
                if (this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
                    logger.debug("no change for aws credentials, directly return from init");
                    return [
                        2 /*return*/ 
                    ];
                }
                identityId = this._config.credentials ? this._config.credentials.identityId : null;
                this._config.credentials = credentials;
                if (!this._bufferExists() || identityId !== credentials.identityId) // if the identity has changed, flush the buffer and instantiate a new one
                // this will cause the old buffer to send any remaining events
                // with the old credentials and then stop looping and shortly thereafter get picked up by GC
                this._initBuffer();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._bufferExists = function() {
        return this._buffer && this._buffer instanceof (0, _eventBufferDefault.default);
    };
    AWSPinpointProvider.prototype._initBuffer = function() {
        if (this._bufferExists()) this._flushBuffer();
        this._buffer = new (0, _eventBufferDefault.default)(this._config);
        // if the first endpoint update hasn't yet resolved pause the buffer to
        // prevent race conditions. It will be resumed as soon as that request succeeds
        if (this._endpointGenerating) this._buffer.pause();
    };
    AWSPinpointProvider.prototype._flushBuffer = function() {
        var _a;
        if (this._bufferExists()) {
            (_a = this._buffer) === null || _a === void 0 || _a.flush();
            this._buffer = null;
        }
    };
    AWSPinpointProvider.prototype._resumeBuffer = function() {
        var _a;
        if (this._bufferExists()) (_a = this._buffer) === null || _a === void 0 || _a.resume();
    };
    AWSPinpointProvider.prototype._getEndpointId = function(cacheKey) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointId, ttl, expiration;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem(cacheKey)
                        ];
                    case 1:
                        endpointId = _a.sent();
                        logger.debug("endpointId from cache", endpointId, "type", typeof endpointId);
                        if (!endpointId) {
                            endpointId = (0, _uuid.v1)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                        }
                        return [
                            2 /*return*/ ,
                            endpointId
                        ];
                }
            });
        });
    };
    /**
     * EndPoint request
     * @return {Object} - The request of updating endpoint
     */ AWSPinpointProvider.prototype._endpointRequest = function(config, event) {
        var credentials = config.credentials;
        var clientInfo = this._clientInfo || {};
        var clientContext = config.clientContext || {};
        // for now we have three different ways for default endpoint configurations
        // clientInfo
        // clientContext (deprecated)
        // config.endpoint
        var defaultEndpointConfig = config.endpoint || {};
        var demographicByClientInfo = {
            appVersion: clientInfo.appVersion,
            make: clientInfo.make,
            model: clientInfo.model,
            modelVersion: clientInfo.version,
            platform: clientInfo.platform
        };
        // for backward compatibility
        var clientId = clientContext.clientId, appTitle = clientContext.appTitle, appVersionName = clientContext.appVersionName, appVersionCode = clientContext.appVersionCode, appPackageName = clientContext.appPackageName, demographicByClientContext = (0, _tslib.__rest)(clientContext, [
            "clientId",
            "appTitle",
            "appVersionName",
            "appVersionCode",
            "appPackageName"
        ]);
        var channelType = event.address ? clientInfo.platform === "android" ? "GCM" : "APNS" : undefined;
        var tmp = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
            channelType: channelType,
            requestId: (0, _uuid.v1)(),
            effectiveDate: new Date().toISOString()
        }, defaultEndpointConfig), event), {
            attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.attributes), event.attributes),
            demographic: (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, demographicByClientInfo), demographicByClientContext), defaultEndpointConfig.demographic), event.demographic),
            location: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.location), event.location),
            metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.metrics), event.metrics),
            user: {
                userId: event.userId || defaultEndpointConfig.userId || credentials.identityId,
                userAttributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultEndpointConfig.userAttributes), event.userAttributes)
            }
        });
        // eliminate unnecessary params
        var userId = tmp.userId, userAttributes = tmp.userAttributes, name = tmp.name, session = tmp.session, eventId = tmp.eventId, immediate = tmp.immediate, ret = (0, _tslib.__rest)(tmp, [
            "userId",
            "userAttributes",
            "name",
            "session",
            "eventId",
            "immediate"
        ]);
        return (0, _core.transferKeyToUpperCase)(ret, [], [
            "metrics",
            "userAttributes",
            "attributes"
        ]);
    };
    AWSPinpointProvider.prototype._eventError = function(err) {
        logger.error("record event failed.", err);
        logger.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" in order to record events');
    };
    AWSPinpointProvider.prototype._getCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, err_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            null
                        ];
                        logger.debug("set credentials for analytics", credentials);
                        return [
                            2 /*return*/ ,
                            (0, _core.Credentials).shear(credentials)
                        ];
                    case 2:
                        err_3 = _a.sent();
                        logger.debug("ensure credentials error", err_3);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.category = "Analytics";
    AWSPinpointProvider.providerName = "AWSPinpoint";
    return AWSPinpointProvider;
}();

},{"tslib":"eOnzl","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","uuid":"aP4lL","../utils/UserAgent":"gxK6D","./EventBuffer":"5I0ha","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVdVQ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCache", ()=>(0, _browserStorageCache.BrowserStorageCache));
parcelHelpers.export(exports, "InMemoryCache", ()=>(0, _inMemoryCache.InMemoryCache));
// Standard `Cache` export to maintain interoperability with React Native
parcelHelpers.export(exports, "Cache", ()=>(0, _browserStorageCache.BrowserStorageCache));
var _browserStorageCache = require("./BrowserStorageCache");
var _inMemoryCache = require("./InMemoryCache");

},{"./BrowserStorageCache":"5lQDf","./InMemoryCache":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5lQDf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorageCacheClass", ()=>BrowserStorageCacheClass);
parcelHelpers.export(exports, "BrowserStorageCache", ()=>BrowserStorageCache);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _utils = require("./Utils");
var _storageCache = require("./StorageCache");
var logger = new (0, _core.ConsoleLogger)("Cache");
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var BrowserStorageCacheClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, _utils.defaultConfig), config) : (0, _utils.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCacheClass.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, _utils.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCacheClass.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, _utils.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCacheClass.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCacheClass.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCacheClass.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCacheClass.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCacheClass.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCacheClass.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCacheClass.prototype.setItem = function(key, value, options) {
        logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, _utils.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCacheClass.prototype.getItem = function(key, options) {
        logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCacheClass.prototype.removeItem = function(key) {
        logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCacheClass.prototype.clear = function() {
        logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCacheClass.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCacheClass.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, "0");
            ret = "0";
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCacheClass.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, _utils.defaultConfig).keyPrefix) {
            logger.error("invalid keyPrefix, setting keyPrefix with timeStamp");
            config.keyPrefix = (0, _utils.getCurrTime).toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}((0, _storageCache.StorageCache));
var BrowserStorageCache = new BrowserStorageCacheClass();
(0, _core.Amplify).register(BrowserStorageCache);

},{"tslib":"4rCQU","@aws-amplify/core":"3rlh1","./Utils":"9pvvt","./StorageCache":"eK8nw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rCQU":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9pvvt":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheObject", ()=>(0, _cacheUtils.CacheObject));
parcelHelpers.export(exports, "defaultConfig", ()=>(0, _cacheUtils.defaultConfig));
parcelHelpers.export(exports, "getByteLength", ()=>(0, _cacheUtils.getByteLength));
parcelHelpers.export(exports, "getCurrTime", ()=>(0, _cacheUtils.getCurrTime));
parcelHelpers.export(exports, "isInteger", ()=>(0, _cacheUtils.isInteger));
parcelHelpers.export(exports, "CacheList", ()=>(0, _cacheListDefault.default));
var _cacheUtils = require("./CacheUtils");
var _cacheList = require("./CacheList");
var _cacheListDefault = parcelHelpers.interopDefault(_cacheList);

},{"./CacheUtils":"1jtBv","./CacheList":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1jtBv":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
/**
 * return the byte size of the string
 * @param str
 */ parcelHelpers.export(exports, "getByteLength", ()=>getByteLength);
/**
 * get current time
 */ parcelHelpers.export(exports, "getCurrTime", ()=>getCurrTime);
/**
 * check if passed value is an integer
 */ parcelHelpers.export(exports, "isInteger", ()=>isInteger);
parcelHelpers.export(exports, "CacheObject", ()=>CacheObject);
var _core = require("@aws-amplify/core");
var defaultConfig = {
    keyPrefix: "aws-amplify-cache",
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, _core.StorageHelper)().getStorage()
};
function getByteLength(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function getCurrTime() {
    var currTime = new Date();
    return currTime.getTime();
}
function isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return _isInteger(value);
}
function _isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var store = {};
var CacheObject = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        store = {};
    };
    CacheObject.getItem = function(key) {
        return store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete store[key];
    };
    return CacheObject;
}();

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eK8nw":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageCache", ()=>StorageCache);
var _utils = require("./Utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("StorageCache");
/**
 * Initialization of the cache
 *
 */ var StorageCache = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return "Cache";
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, _utils.isInteger)(this.config.capacityInBytes)) {
            logger.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
        if (!(0, _utils.isInteger)(this.config.itemMaxSize)) {
            logger.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (!(0, _utils.isInteger)(this.config.defaultTTL)) {
            logger.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
            this.config.defaultTTL = (0, _utils.defaultConfig).defaultTTL;
        }
        if (!(0, _utils.isInteger)(this.config.defaultPriority)) {
            logger.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
            this.config.itemMaxSize = (0, _utils.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
            this.config.defaultPriority = (0, _utils.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            logger.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
            this.config.warningThreshold = (0, _utils.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
            this.config.capacityInBytes = (0, _utils.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, _utils.getCurrTime)(),
            visitedTime: (0, _utils.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, _utils.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();

},{"./Utils":"9pvvt","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0bYL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", ()=>(0, _getInAppMessages.getInAppMessages));
parcelHelpers.export(exports, "putEvents", ()=>(0, _putEvents.putEvents));
parcelHelpers.export(exports, "updateEndpoint", ()=>(0, _updateEndpoint.updateEndpoint));
var _getInAppMessages = require("./getInAppMessages");
var _putEvents = require("./putEvents");
var _updateEndpoint = require("./updateEndpoint");

},{"./getInAppMessages":"15wxL","./putEvents":"e1f1Q","./updateEndpoint":"cHApM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15wxL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInAppMessages", ()=>getInAppMessages);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var getInAppMessagesSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId), "/inappmessages");
    return {
        method: "GET",
        headers: headers,
        url: url
    };
};
var getInAppMessagesDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, InAppMessageCampaigns;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    InAppMessageCampaigns = _a.sent().InAppMessageCampaigns;
                    return [
                        2 /*return*/ ,
                        {
                            InAppMessagesResponse: {
                                InAppMessageCampaigns: InAppMessageCampaigns
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var getInAppMessages = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), getInAppMessagesSerializer, getInAppMessagesDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"an928":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "getSharedHeaders", ()=>getSharedHeaders);
var _endpoints = require("../../clients/endpoints");
var _retry = require("../../clients/middleware/retry");
var _json = require("../../clients/serde/json");
var _platform = require("../../Platform");
/**
 * The service name used to sign requests if the API requires authentication.
 */ var SERVICE_NAME = "mobiletargeting";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ var endpointResolver = function(_a) {
    var region = _a.region;
    return {
        url: new URL("https://pinpoint.".concat(region, ".").concat((0, _endpoints.getDnsSuffix)(region)))
    };
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _retry.getRetryDecider)((0, _json.parseJsonError)),
    computeDelay: (0, _retry.jitteredBackoff),
    userAgentValue: (0, _platform.getAmplifyUserAgent)()
};
var getSharedHeaders = function() {
    return {
        "content-type": "application/json"
    };
};

},{"../../clients/endpoints":"dNrJb","../../clients/middleware/retry":"4tNHX","../../clients/serde/json":"jR1RV","../../Platform":"jNyBX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e1f1Q":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putEvents", ()=>putEvents);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putEventsSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EventsRequest = _a.EventsRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/events");
    var body = JSON.stringify(EventsRequest !== null && EventsRequest !== void 0 ? EventsRequest : {});
    return {
        method: "POST",
        headers: headers,
        url: url,
        body: body
    };
};
var putEventsDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, Results;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    Results = _a.sent().Results;
                    return [
                        2 /*return*/ ,
                        {
                            EventsResponse: {
                                Results: Results
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var putEvents = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), putEventsSerializer, putEventsDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cHApM":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateEndpoint", ()=>updateEndpoint);
var _authenticated = require("../../clients/handlers/authenticated");
var _composeServiceApi = require("../../clients/internal/composeServiceApi");
var _extendedEncodeURIComponent = require("../../clients/middleware/signing/utils/extendedEncodeURIComponent");
var _serde = require("../../clients/serde");
var _base = require("./base");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var updateEndpointSerializer = function(_a, endpoint) {
    var ApplicationId = _a.ApplicationId, EndpointId = _a.EndpointId, EndpointRequest = _a.EndpointRequest;
    var headers = (0, _base.getSharedHeaders)();
    var url = new URL(endpoint.url);
    url.pathname = "v1/apps/".concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(ApplicationId), "/endpoints/").concat((0, _extendedEncodeURIComponent.extendedEncodeURIComponent)(EndpointId));
    var body = JSON.stringify(EndpointRequest !== null && EndpointRequest !== void 0 ? EndpointRequest : {});
    return {
        method: "PUT",
        headers: headers,
        url: url,
        body: body
    };
};
var updateEndpointDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, _a, Message, RequestID;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonError)(response)
                    ];
                case 1:
                    error = _b.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _serde.parseJsonBody)(response)
                    ];
                case 3:
                    _a = _b.sent(), Message = _a.Message, RequestID = _a.RequestID;
                    return [
                        2 /*return*/ ,
                        {
                            MessageBody: {
                                Message: Message,
                                RequestID: RequestID
                            },
                            $metadata: (0, _serde.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var updateEndpoint = (0, _composeServiceApi.composeServiceApi)((0, _authenticated.authenticatedHandler), updateEndpointSerializer, updateEndpointDeserializer, (0, _base.defaultConfig));

},{"../../clients/handlers/authenticated":"bO3n6","../../clients/internal/composeServiceApi":"5aofV","../../clients/middleware/signing/utils/extendedEncodeURIComponent":"gx4L4","../../clients/serde":"g2QPG","./base":"an928","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aP4lL":[function(require,module,exports) {
var v1 = require("fe150f59c12d858e");
var v4 = require("50aa310b9d863f41");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"fe150f59c12d858e":"3adno","50aa310b9d863f41":"3Njsm"}],"3adno":[function(require,module,exports) {
var rng = require("65e7dccaa8351beb");
var bytesToUuid = require("b03dc651ca0fa228");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"65e7dccaa8351beb":"5OgHU","b03dc651ca0fa228":"inNyt"}],"5OgHU":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"inNyt":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"3Njsm":[function(require,module,exports) {
var rng = require("f59be66f97be4efc");
var bytesToUuid = require("c91cc56388af5151");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"f59be66f97be4efc":"5OgHU","c91cc56388af5151":"inNyt"}],"gxK6D":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalyticsUserAgent", ()=>getAnalyticsUserAgent);
parcelHelpers.export(exports, "getAnalyticsUserAgentString", ()=>getAnalyticsUserAgentString);
var _core = require("@aws-amplify/core");
function getAnalyticsUserAgent(action) {
    return (0, _core.getAmplifyUserAgentObject)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}
function getAnalyticsUserAgentString(action) {
    return (0, _core.getAmplifyUserAgent)({
        category: (0, _core.Category).Analytics,
        action: action
    });
}

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5I0ha":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _appUtils = require("../utils/AppUtils");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("EventsBuffer");
var RETRYABLE_CODES = [
    429,
    500
];
var ACCEPTED_CODES = [
    202
];
var EventsBuffer = /** @class */ function() {
    function EventsBuffer(config) {
        this._pause = false;
        this._flush = false;
        logger.debug("Instantiating buffer with config:", config);
        this._buffer = [];
        this._config = config;
        this._sendBatch = this._sendBatch.bind(this);
        this._startLoop();
    }
    EventsBuffer.prototype.push = function(event) {
        var _a;
        // if the buffer is currently at the configured limit, pushing would exceed it
        if (this._buffer.length >= this._config.bufferSize) {
            logger.debug("Exceeded analytics events buffer size");
            return event.handlers.reject(new Error("Exceeded the size of analytics events buffer"));
        }
        var eventId = event.params.event.eventId;
        var bufferElement = (_a = {}, _a[eventId] = event, _a);
        this._buffer.push(bufferElement);
    };
    EventsBuffer.prototype.pause = function() {
        this._pause = true;
    };
    EventsBuffer.prototype.resume = function() {
        this._pause = false;
    };
    EventsBuffer.prototype.flush = function() {
        this._flush = true;
    };
    EventsBuffer.prototype._startLoop = function() {
        if (this._interval) clearInterval(this._interval);
        var flushInterval = this._config.flushInterval;
        this._interval = setInterval(this._sendBatch, flushInterval);
    };
    EventsBuffer.prototype._sendBatch = function() {
        var bufferLength = this._buffer.length;
        if (this._flush && !bufferLength) clearInterval(this._interval);
        // Do not send the batch of events if
        // the Buffer is paused or is empty or the App is not in the foreground
        // Apps should be in the foreground since
        // the OS may restrict access to the network in the background
        if (this._pause || !bufferLength || !(0, _appUtils.isAppInForeground)()) return;
        var flushSize = this._config.flushSize;
        var batchSize = Math.min(flushSize, bufferLength);
        var bufferSubset = this._buffer.splice(0, batchSize);
        this._putEvents(bufferSubset);
    };
    EventsBuffer.prototype._putEvents = function(buffer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var eventMap, batchEventParams, _a, credentials, region, data, err_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        eventMap = this._bufferToMap(buffer);
                        batchEventParams = this._generateBatchEventParams(eventMap);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this._config, credentials = _a.credentials, region = _a.region;
                        return [
                            4 /*yield*/ ,
                            (0, _pinpoint.putEvents)({
                                credentials: credentials,
                                region: region,
                                userAgentValue: (0, _userAgent.getAnalyticsUserAgentString)((0, _core.AnalyticsAction).Record)
                            }, batchEventParams)
                        ];
                    case 2:
                        data = _b.sent();
                        this._processPutEventsSuccessResponse(data, eventMap);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        return [
                            2 /*return*/ ,
                            this._handlePutEventsFailure(err_1, eventMap)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsBuffer.prototype._generateBatchEventParams = function(eventMap) {
        var batchEventParams = {
            ApplicationId: "",
            EventsRequest: {
                BatchItem: {}
            }
        };
        Object.values(eventMap).forEach(function(item) {
            var params = item.params;
            var event = params.event, timestamp = params.timestamp, config = params.config;
            var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
            var appId = config.appId, endpointId = config.endpointId;
            var batchItem = batchEventParams.EventsRequest.BatchItem;
            batchEventParams.ApplicationId = batchEventParams.ApplicationId || appId;
            if (!batchItem[endpointId]) batchItem[endpointId] = {
                Endpoint: {},
                Events: {}
            };
            batchItem[endpointId].Events[eventId] = {
                EventType: name,
                Timestamp: new Date(timestamp).toISOString(),
                Attributes: attributes,
                Metrics: metrics,
                Session: session
            };
        });
        return batchEventParams;
    };
    EventsBuffer.prototype._handlePutEventsFailure = function(err, eventMap) {
        logger.debug("_putEvents Failed: ", err);
        var statusCode = err.$metadata && err.$metadata.httpStatusCode;
        if (RETRYABLE_CODES.includes(statusCode)) {
            var retryableEvents = Object.values(eventMap);
            this._retry(retryableEvents);
            return;
        }
    };
    EventsBuffer.prototype._processPutEventsSuccessResponse = function(data, eventMap) {
        var _a;
        var _b = ((_a = data.EventsResponse) !== null && _a !== void 0 ? _a : {}).Results, Results = _b === void 0 ? {} : _b;
        var retryableEvents = [];
        Object.entries(Results).forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), endpointId = _b[0], endpointValues = _b[1];
            var _c;
            var responses = (_c = endpointValues.EventsItemResponse) !== null && _c !== void 0 ? _c : {};
            Object.entries(responses).forEach(function(_a) {
                var _b, _c;
                var _d = (0, _tslib.__read)(_a, 2), eventId = _d[0], eventValues = _d[1];
                var eventObject = eventMap[eventId];
                if (!eventObject) return;
                var _e = eventValues !== null && eventValues !== void 0 ? eventValues : {}, StatusCode = _e.StatusCode, Message = _e.Message;
                // manually crafting handlers response to keep API consistant
                var response = {
                    EventsResponse: {
                        Results: (_b = {}, _b[endpointId] = {
                            EventsItemResponse: (_c = {}, _c[eventId] = {
                                StatusCode: StatusCode,
                                Message: Message
                            }, _c)
                        }, _b)
                    }
                };
                if (StatusCode && ACCEPTED_CODES.includes(StatusCode)) {
                    eventObject.handlers.resolve(response);
                    return;
                }
                if (StatusCode && RETRYABLE_CODES.includes(StatusCode)) {
                    retryableEvents.push(eventObject);
                    return;
                }
                var name = eventObject.params.event.name;
                logger.error("event " + eventId + " : " + name + " failed with error: " + Message);
                return eventObject.handlers.reject(response);
            });
        });
        if (retryableEvents.length) this._retry(retryableEvents);
    };
    EventsBuffer.prototype._retry = function(retryableEvents) {
        var _a;
        // retryable events that haven't reached the resendLimit
        var eligibleEvents = [];
        retryableEvents.forEach(function(event) {
            var _a;
            var params = event.params;
            var _b = params.event, eventId = _b.eventId, name = _b.name;
            if (params.resendLimit-- > 0) {
                logger.debug("resending event " + eventId + " : " + name + " with " + params.resendLimit + " retry attempts remaining");
                eligibleEvents.push((_a = {}, _a[eventId] = event, _a));
                return;
            }
            logger.debug("no retry attempts remaining for event " + eventId + " : " + name);
        });
        // add the events to the front of the buffer
        (_a = this._buffer).unshift.apply(_a, (0, _tslib.__spread)(eligibleEvents));
    };
    // convert buffer to map, i.e. { eventId1: { params, handler }, eventId2: { params, handlers } }
    // this allows us to easily access the handlers after receiving a batch response
    EventsBuffer.prototype._bufferToMap = function(buffer) {
        return buffer.reduce(function(acc, curVal) {
            var _a = (0, _tslib.__read)(Object.entries(curVal), 1), _b = (0, _tslib.__read)(_a[0], 2), key = _b[0], value = _b[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    return EventsBuffer;
}();
exports.default = EventsBuffer;

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","../utils/AppUtils":"44ieJ","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"44ieJ":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAppInForeground", ()=>isAppInForeground);
var isAppInForeground = function() {
    return true;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0O3X":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", ()=>(0, _pageViewTracker.PageViewTracker));
parcelHelpers.export(exports, "EventTracker", ()=>(0, _eventTracker.EventTracker));
parcelHelpers.export(exports, "SessionTracker", ()=>(0, _sessionTracker.SessionTracker));
var _pageViewTracker = require("./PageViewTracker");
var _eventTracker = require("./EventTracker");
var _sessionTracker = require("./SessionTracker");

},{"./PageViewTracker":"eGwCs","./EventTracker":"4QTf3","./SessionTracker":"bsn1E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eGwCs":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageViewTracker", ()=>PageViewTracker);
var _tslib = require("tslib");
var _methodEmbed = require("../utils/MethodEmbed");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("PageViewTracker");
var PREV_URL_KEY = "aws-amplify-analytics-prevUrl";
var getUrl = function() {
    if (!(0, _core.browserOrNode)().isBrowser) return "";
    else return window.location.origin + window.location.pathname;
};
var defaultOpts = {
    enable: false,
    provider: "AWSPinpoint",
    getUrl: getUrl
};
var PageViewTracker = /** @class */ function() {
    function PageViewTracker(tracker, opts) {
        logger.debug("initialize pageview tracker with opts", opts);
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        else this._pageViewTrackDefault();
    }
    PageViewTracker.prototype.configure = function(opts) {
        Object.assign(this._config, opts);
        // if spa, need to remove those listeners if disabled
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        return this._config;
    };
    PageViewTracker.prototype._isSameUrl = function() {
        var prevUrl = sessionStorage.getItem(PREV_URL_KEY);
        var curUrl = this._config.getUrl();
        if (prevUrl === curUrl) {
            logger.debug("the url is same");
            return true;
        } else return false;
    };
    PageViewTracker.prototype._pageViewTrackDefault = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !window.sessionStorage) {
                            logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (this._config.enable && !this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState || !window.sessionStorage) {
                            logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (!this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem(PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._pageViewTrackSPA = function() {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener || !history.pushState) {
            logger.debug("not in the supported web enviroment");
            return;
        }
        if (this._config.enable && !this._hasEnabled) {
            (0, _methodEmbed.MethodEmbed).add(history, "pushState", this._trackFunc);
            (0, _methodEmbed.MethodEmbed).add(history, "replaceState", this._trackFunc);
            window.addEventListener("popstate", this._trackFunc);
            this._trackFunc();
            this._hasEnabled = true;
        } else {
            (0, _methodEmbed.MethodEmbed).remove(history, "pushState");
            (0, _methodEmbed.MethodEmbed).remove(history, "replaceState");
            window.removeEventListener("popstate", this._trackFunc);
            this._hasEnabled = false;
        }
    };
    return PageViewTracker;
}();

},{"tslib":"eOnzl","../utils/MethodEmbed":"in1wq","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"in1wq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MethodEmbed", ()=>MethodEmbed);
var _tslib = require("tslib");
var lists = [];
var MethodEmbed = /** @class */ function() {
    function MethodEmbed(context, methodName) {
        this.context = context;
        this.methodName = methodName;
        this._originalMethod = context[methodName].bind(context);
    }
    MethodEmbed.add = function(context, methodName, methodOverride) {
        getInstance(context, methodName).set(methodOverride);
    };
    MethodEmbed.remove = function(context, methodName) {
        getInstance(context, methodName).remove();
    };
    MethodEmbed.prototype.set = function(methodOverride) {
        var _this = this;
        this.context[this.methodName] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return methodOverride(_this._originalMethod.apply(_this, (0, _tslib.__spread)(args)));
        };
    };
    MethodEmbed.prototype.remove = function() {
        this.context[this.methodName] = this._originalMethod;
    };
    return MethodEmbed;
}();
function getInstance(context, methodName) {
    var instance = lists.filter(function(h) {
        return h.context === context && h.methodName === methodName;
    })[0];
    if (!instance) {
        instance = new MethodEmbed(context, methodName);
        lists.push(instance);
    }
    return instance;
}

},{"tslib":"eOnzl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4QTf3":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTracker", ()=>EventTracker);
var _tslib = require("tslib");
var _domUtils = require("../vendor/dom-utils");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("EventTracker");
var defaultOpts = {
    enable: false,
    events: [
        "click"
    ],
    selectorPrefix: "data-amplify-analytics-",
    provider: "AWSPinpoint"
};
var EventTracker = /** @class */ function() {
    function EventTracker(tracker, opts) {
        if (!(0, _core.browserOrNode)().isBrowser || !window.addEventListener) {
            logger.debug("not in the supported web environment");
            return;
        }
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._delegates = {};
        this._trackFunc = this._trackFunc.bind(this);
        logger.debug("initialize pageview tracker with opts", this._config);
        this.configure(this._config);
    }
    EventTracker.prototype.configure = function(opts) {
        var _this = this;
        Object.assign(this._config, opts);
        if (!this._config.enable) {
            Object.keys(this._delegates).forEach(function(key) {
                if (typeof _this._delegates[key].destroy === "function") _this._delegates[key].destroy();
            });
            this._delegates = {};
        } else if (this._config.enable && Object.keys(this._delegates).length === 0) {
            var selector_1 = "[" + this._config.selectorPrefix + "on]";
            this._config.events.forEach(function(evt) {
                _this._delegates[evt] = (0, _domUtils.delegate)(document, evt, selector_1, _this._trackFunc, {
                    composed: true,
                    useCapture: true
                });
            });
        }
        return this._config;
    };
    EventTracker.prototype._trackFunc = function(event, element) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, events, eventName, attrs, defaultAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        customAttrs = {};
                        events = element.getAttribute(this._config.selectorPrefix + "on").split(/\s*,\s*/);
                        eventName = element.getAttribute(this._config.selectorPrefix + "name");
                        attrs = element.getAttribute(this._config.selectorPrefix + "attrs");
                        if (attrs) attrs.split(/\s*,\s*/).forEach(function(attr) {
                            var tmp = attr.trim().split(/\s*:\s*/);
                            customAttrs[tmp[0]] = tmp[1];
                        });
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        defaultAttrs = _a;
                        attributes = Object.assign({
                            type: event.type,
                            target: event.target.localName + " with id " + event.target.id
                        }, defaultAttrs, customAttrs);
                        logger.debug("events needed to be recorded", events);
                        logger.debug("attributes needed to be attached", customAttrs);
                        if (events.indexOf(event.type) < 0) {
                            logger.debug("event " + event.type + " is not selected to be recorded");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._tracker({
                            name: eventName || "event",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("Failed to record the " + event.type + " event', " + e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return EventTracker;
}();

},{"tslib":"eOnzl","../vendor/dom-utils":"kOmfH","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kOmfH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closest", ()=>(0, _closest.closest));
parcelHelpers.export(exports, "delegate", ()=>(0, _delegate.delegate));
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatch.dispatch));
parcelHelpers.export(exports, "getAttributes", ()=>(0, _getAttributes.getAttributes));
parcelHelpers.export(exports, "matches", ()=>(0, _matches.matches));
parcelHelpers.export(exports, "parents", ()=>(0, _parents.parents));
parcelHelpers.export(exports, "parseUrl", ()=>(0, _parseUrl.parseUrl));
var _closest = require("./closest");
var _delegate = require("./delegate");
var _dispatch = require("./dispatch");
var _getAttributes = require("./get-attributes");
var _matches = require("./matches");
var _parents = require("./parents");
var _parseUrl = require("./parse-url");

},{"./closest":false,"./delegate":"6wqgF","./dispatch":false,"./get-attributes":false,"./matches":false,"./parents":false,"./parse-url":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kdusL":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the closest parent element that matches the passed selector.
 * @param {Element} element The element whose parents to check.
 * @param {string} selector The CSS selector to match against.
 * @param {boolean=} shouldCheckSelf True if the selector should test against
 *     the passed element itself.
 * @return {Element|undefined} The matching element or undefined.
 */ parcelHelpers.export(exports, "closest", ()=>closest);
var _matches = require("./matches");
var _parents = require("./parents");
function closest(element, selector, shouldCheckSelf) {
    if (shouldCheckSelf === void 0) shouldCheckSelf = false;
    if (!(element && element.nodeType === 1 && selector)) return;
    var parentElements = (shouldCheckSelf ? [
        element
    ] : []).concat((0, _parents.parents)(element));
    for(var i = 0, parent_1; parent_1 = parentElements[i]; i++){
        if ((0, _matches.matches)(parent_1, selector)) return parent_1;
    }
}

},{"./matches":"iG3qm","./parents":"23Iu7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iG3qm":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tests if a DOM elements matches any of the test DOM elements or selectors.
 * @param {Element} element The DOM element to test.
 * @param {Element|string|Array<Element|string>} test A DOM element, a CSS
 *     selector, or an array of DOM elements or CSS selectors to match against.
 * @return {boolean} True of any part of the test matches.
 */ parcelHelpers.export(exports, "matches", ()=>matches);
var _core = require("@aws-amplify/core");
var proto = (0, _core.browserOrNode)().isBrowser && window["Element"] ? window["Element"].prototype : null;
var nativeMatches = proto ? proto.matches || // @ts-ignore
proto.matchesSelector || // @ts-ignore
proto.webkitMatchesSelector || // @ts-ignore
proto.mozMatchesSelector || // @ts-ignore
proto.msMatchesSelector || // @ts-ignore
proto.oMatchesSelector : null;
function matches(element, test) {
    // Validate input.
    if (element && element.nodeType === 1 && test) {
        // if test is a string or DOM element test it.
        if (typeof test === "string" || test.nodeType === 1) return element === test || matchesSelector(element, /** @type {string} */ test);
        else if ("length" in test) // if it has a length property iterate over the items
        // and return true if any match.
        for(var i = 0, item = void 0; item = test[i]; i++){
            if (element === item || matchesSelector(element, item)) return true;
        }
    }
    // Still here? Return false
    return false;
}
/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */ function matchesSelector(element, selector) {
    if (typeof selector !== "string") return false;
    if (nativeMatches) return nativeMatches.call(element, selector);
    var nodes = element.parentNode.querySelectorAll(selector);
    for(var i = 0, node = void 0; node = nodes[i]; i++){
        if (node === element) return true;
    }
    return false;
}

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"23Iu7":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parents", ()=>parents);
function parents(ele) {
    var list = [];
    var element = ele;
    while(element && element.parentNode && element.parentNode.nodeType === 1){
        element = /** @type {!Element} */ element.parentNode;
        list.push(element);
    }
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6wqgF":[function(require,module,exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Delegates the handling of events for an element matching a selector to an
 * ancestor of the matching element.
 * @param {!Node} ancestor The ancestor element to add the listener to.
 * @param {string} eventType The event type to listen to.
 * @param {string} selector A CSS selector to match against child elements.
 * @param {!Function} callback A function to run any time the event happens.
 * @param {Object=} opts A configuration options object. The available options:
 *     - useCapture<boolean>: If true, bind to the event capture phase.
 *     - deep<boolean>: If true, delegate into shadow trees.
 * @return {Object} The delegate object. It contains a destroy method.
 */ parcelHelpers.export(exports, "delegate", ()=>delegate);
var _closest = require("./closest");
var _matches = require("./matches");
function delegate(ancestor, eventType, selector, callback, opts) {
    if (opts === void 0) opts = {};
    // Defines the event listener.
    var listener = function(event) {
        var delegateTarget;
        // If opts.composed is true and the event originated from inside a Shadow
        // tree, check the composed path nodes.
        if (opts["composed"] && typeof event["composedPath"] === "function") {
            var composedPath = event.composedPath();
            for(var i = 0, node = void 0; node = composedPath[i]; i++)if (node.nodeType === 1 && (0, _matches.matches)(node, selector)) delegateTarget = node;
        } else // Otherwise check the parents.
        delegateTarget = (0, _closest.closest)(event.target, selector, true);
        if (delegateTarget) callback.call(delegateTarget, event, delegateTarget);
    };
    ancestor.addEventListener(eventType, listener, opts["useCapture"]);
    return {
        destroy: function() {
            ancestor.removeEventListener(eventType, listener, opts["useCapture"]);
        }
    };
}

},{"./closest":"kdusL","./matches":"iG3qm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bsn1E":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTracker", ()=>SessionTracker);
var _tslib = require("tslib");
// the session tracker for web
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("SessionTracker");
var defaultOpts = {
    enable: false,
    provider: "AWSPinpoint"
};
var initialEventSent = false;
var SessionTracker = /** @class */ function() {
    function SessionTracker(tracker, opts) {
        this._config = Object.assign({}, defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        this._trackBeforeUnload = this._trackBeforeUnload.bind(this);
        this.configure(this._config);
    }
    SessionTracker.prototype._envCheck = function() {
        if (!(0, _core.browserOrNode)().isBrowser) return false;
        if (!document || !document.addEventListener) {
            logger.debug("not in the supported web environment");
            return false;
        }
        if (typeof document.hidden !== "undefined") {
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document["msHidden"] !== "undefined") {
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document["webkitHidden"] !== "undefined") {
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        } else {
            logger.debug("not in the supported web environment");
            return false;
        }
        return true;
    };
    SessionTracker.prototype._trackFunc = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        if (document.visibilityState === this._hidden) this._tracker({
                            name: "_session.stop",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session stop event failed.", e);
                        });
                        else this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype._trackBeforeUnload = function(event) {
        // before unload callback cannot be async => https://github.com/aws-amplify/amplify-js/issues/2088
        var _this = this;
        var customAttrs = typeof this._config.attributes === "function" ? Promise.resolve(this._config.attributes()) : Promise.resolve(this._config.attributes);
        customAttrs.then(function(custom) {
            var attributes = Object.assign({}, custom);
            _this._tracker({
                name: "_session.stop",
                attributes: attributes,
                immediate: true
            }, _this._config.provider).catch(function(e) {
                logger.debug("record session stop event failed.", e);
            });
        });
    };
    // to keep configure a synchronized function
    SessionTracker.prototype._sendInitialEvent = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (initialEventSent) {
                            logger.debug("the start session has been sent when the page is loaded");
                            return [
                                2 /*return*/ 
                            ];
                        } else initialEventSent = true;
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype.configure = function(opts) {
        if (!this._envCheck()) return this._config;
        Object.assign(this._config, opts);
        if (this._config.enable && !this._hasEnabled) {
            // send a start session as soon as it's enabled
            this._sendInitialEvent();
            // listen on events
            document.addEventListener(this._visibilityChange, this._trackFunc, false);
            window.addEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = true;
        } else if (!this._config.enable && this._hasEnabled) {
            document.removeEventListener(this._visibilityChange, this._trackFunc, false);
            window.removeEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = false;
        }
        return this._config;
    };
    return SessionTracker;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"nvQ6G":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _awspinpointProvider.AWSPinpointProvider));
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>(0, _awskinesisProvider.AWSKinesisProvider));
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>(0, _awskinesisFirehoseProvider.AWSKinesisFirehoseProvider));
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>(0, _amazonPersonalizeProvider.AmazonPersonalizeProvider));
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _awskinesisFirehoseProvider = require("./AWSKinesisFirehoseProvider");
var _amazonPersonalizeProvider = require("./AmazonPersonalizeProvider");

},{"./AWSPinpointProvider":"2eV5C","./AWSKinesisProvider":"2sXdp","./AWSKinesisFirehoseProvider":"fxYWT","./AmazonPersonalizeProvider":"8mvSm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sXdp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisProvider", ()=>AWSKinesisProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientKinesis = require("@aws-sdk/client-kinesis");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AWSKinesisProvider");
// events buffer
var BUFFER_SIZE = 1000;
var FLUSH_SIZE = 100;
var FLUSH_INTERVAL = 5000; // 5s
var RESEND_LIMIT = 5;
var AWSKinesisProvider = /** @class */ function() {
    function AWSKinesisProvider(config) {
        this._buffer = [];
        this._config = config || {};
        this._config.bufferSize = this._config.bufferSize || BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || RESEND_LIMIT;
        this._setupTimer();
    }
    AWSKinesisProvider.prototype._setupTimer = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        var _a = this._config, flushSize = _a.flushSize, flushInterval = _a.flushInterval;
        this._timer = setInterval(function() {
            var size = _this._buffer.length < flushSize ? _this._buffer.length : flushSize;
            var events = [];
            for(var i = 0; i < size; i += 1){
                var params = _this._buffer.shift();
                events.push(params);
            }
            _this._sendFromBuffer(events);
        }, flushInterval);
    };
    /**
     * get the category of the plugin
     */ AWSKinesisProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AWSKinesisProvider.prototype.getProviderName = function() {
        return "AWSKinesis";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSKinesisProvider.prototype.configure = function(config) {
        logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        this._setupTimer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSKinesisProvider.prototype.record = function(params) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials
                        });
                        if ((_a = params.event) === null || _a === void 0 ? void 0 : _a.immediate) {
                            this._sendEvents([
                                params
                            ]);
                            return [
                                2 /*return*/ ,
                                Promise.resolve(true)
                            ];
                        } else return [
                            2 /*return*/ ,
                            this._putToBuffer(params)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSKinesisProvider.prototype.updateEndpoint = function() {
        logger.debug("updateEndpoint is not implemented in Kinesis provider");
        return Promise.resolve(true);
    };
    /**
     * @private
     * @param params - params for the event recording
     * Put events into buffer
     */ AWSKinesisProvider.prototype._putToBuffer = function(params) {
        if (this._buffer.length < BUFFER_SIZE) {
            this._buffer.push(params);
            return Promise.resolve(true);
        } else {
            logger.debug("exceed analytics events buffer size");
            return Promise.reject(false);
        }
    };
    AWSKinesisProvider.prototype._sendFromBuffer = function(events) {
        var _this = this;
        // collapse events by credentials
        // events = [ {params} ]
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < events.length; i += 1){
            var cred = events[i].credentials;
            if (i === 0) {
                group.push(events[i]);
                preCred = cred;
            } else if (cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug("no change for cred, put event in the same group");
                group.push(events[i]);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(events[i]);
                preCred = cred;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(evts) {
            _this._sendEvents(evts);
        });
    };
    AWSKinesisProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // spit by streamName
            var evt = params.event;
            var streamName = evt.streamName;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = evt.data && typeof evt.data !== "string" ? JSON.stringify(evt.data) : evt.data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var PartitionKey = evt.partitionKey || "partition-" + credentials.identityId;
            var record = {
                Data: Data,
                PartitionKey: PartitionKey
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var command, err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            logger.debug("putting records to kinesis with records", records[streamName]);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            command = new (0, _clientKinesis.PutRecordsCommand)({
                                Records: records[streamName],
                                StreamName: streamName
                            });
                            return [
                                4 /*yield*/ ,
                                this._kinesis.send(command)
                            ];
                        case 2:
                            _a.sent();
                            logger.debug("Upload records to stream", streamName);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_1 = _a.sent();
                            logger.debug("Failed to upload records to Kinesis", err_1);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSKinesisProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._kinesis && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region, endpoint = config.endpoint;
        return this._initKinesis(region, endpoint, credentials);
    };
    AWSKinesisProvider.prototype._initKinesis = function(region, endpoint, credentials) {
        logger.debug("initialize kinesis with credentials", credentials);
        this._kinesis = new (0, _clientKinesis.KinesisClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record),
            endpoint: endpoint
        });
        return true;
    };
    /**
     * @private
     * check if current credentials exists
     */ AWSKinesisProvider.prototype._getCredentials = function() {
        var _this = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug("set credentials for analytics", _this._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AWSKinesisProvider;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-sdk/client-kinesis":"eAkwt","@aws-sdk/util-utf8-browser":"iZmxX","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eAkwt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _kinesisClient = require("./KinesisClient");
parcelHelpers.exportAll(_kinesisClient, exports);
var _kinesis = require("./Kinesis");
parcelHelpers.exportAll(_kinesis, exports);
var _addTagsToStreamCommand = require("./commands/AddTagsToStreamCommand");
parcelHelpers.exportAll(_addTagsToStreamCommand, exports);
var _createStreamCommand = require("./commands/CreateStreamCommand");
parcelHelpers.exportAll(_createStreamCommand, exports);
var _decreaseStreamRetentionPeriodCommand = require("./commands/DecreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_decreaseStreamRetentionPeriodCommand, exports);
var _deleteStreamCommand = require("./commands/DeleteStreamCommand");
parcelHelpers.exportAll(_deleteStreamCommand, exports);
var _deregisterStreamConsumerCommand = require("./commands/DeregisterStreamConsumerCommand");
parcelHelpers.exportAll(_deregisterStreamConsumerCommand, exports);
var _describeLimitsCommand = require("./commands/DescribeLimitsCommand");
parcelHelpers.exportAll(_describeLimitsCommand, exports);
var _describeStreamCommand = require("./commands/DescribeStreamCommand");
parcelHelpers.exportAll(_describeStreamCommand, exports);
var _waitForStreamExists = require("./waiters/waitForStreamExists");
parcelHelpers.exportAll(_waitForStreamExists, exports);
var _waitForStreamNotExists = require("./waiters/waitForStreamNotExists");
parcelHelpers.exportAll(_waitForStreamNotExists, exports);
var _describeStreamConsumerCommand = require("./commands/DescribeStreamConsumerCommand");
parcelHelpers.exportAll(_describeStreamConsumerCommand, exports);
var _describeStreamSummaryCommand = require("./commands/DescribeStreamSummaryCommand");
parcelHelpers.exportAll(_describeStreamSummaryCommand, exports);
var _disableEnhancedMonitoringCommand = require("./commands/DisableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_disableEnhancedMonitoringCommand, exports);
var _enableEnhancedMonitoringCommand = require("./commands/EnableEnhancedMonitoringCommand");
parcelHelpers.exportAll(_enableEnhancedMonitoringCommand, exports);
var _getRecordsCommand = require("./commands/GetRecordsCommand");
parcelHelpers.exportAll(_getRecordsCommand, exports);
var _getShardIteratorCommand = require("./commands/GetShardIteratorCommand");
parcelHelpers.exportAll(_getShardIteratorCommand, exports);
var _increaseStreamRetentionPeriodCommand = require("./commands/IncreaseStreamRetentionPeriodCommand");
parcelHelpers.exportAll(_increaseStreamRetentionPeriodCommand, exports);
var _listShardsCommand = require("./commands/ListShardsCommand");
parcelHelpers.exportAll(_listShardsCommand, exports);
var _listStreamConsumersCommand = require("./commands/ListStreamConsumersCommand");
parcelHelpers.exportAll(_listStreamConsumersCommand, exports);
var _listStreamConsumersPaginator = require("./pagination/ListStreamConsumersPaginator");
parcelHelpers.exportAll(_listStreamConsumersPaginator, exports);
var _listStreamsCommand = require("./commands/ListStreamsCommand");
parcelHelpers.exportAll(_listStreamsCommand, exports);
var _listTagsForStreamCommand = require("./commands/ListTagsForStreamCommand");
parcelHelpers.exportAll(_listTagsForStreamCommand, exports);
var _mergeShardsCommand = require("./commands/MergeShardsCommand");
parcelHelpers.exportAll(_mergeShardsCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordsCommand = require("./commands/PutRecordsCommand");
parcelHelpers.exportAll(_putRecordsCommand, exports);
var _registerStreamConsumerCommand = require("./commands/RegisterStreamConsumerCommand");
parcelHelpers.exportAll(_registerStreamConsumerCommand, exports);
var _removeTagsFromStreamCommand = require("./commands/RemoveTagsFromStreamCommand");
parcelHelpers.exportAll(_removeTagsFromStreamCommand, exports);
var _splitShardCommand = require("./commands/SplitShardCommand");
parcelHelpers.exportAll(_splitShardCommand, exports);
var _startStreamEncryptionCommand = require("./commands/StartStreamEncryptionCommand");
parcelHelpers.exportAll(_startStreamEncryptionCommand, exports);
var _stopStreamEncryptionCommand = require("./commands/StopStreamEncryptionCommand");
parcelHelpers.exportAll(_stopStreamEncryptionCommand, exports);
var _subscribeToShardCommand = require("./commands/SubscribeToShardCommand");
parcelHelpers.exportAll(_subscribeToShardCommand, exports);
var _updateShardCountCommand = require("./commands/UpdateShardCountCommand");
parcelHelpers.exportAll(_updateShardCountCommand, exports);
var _interfaces = require("./pagination/Interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./KinesisClient":"hFqJe","./Kinesis":false,"./commands/AddTagsToStreamCommand":false,"./commands/CreateStreamCommand":false,"./commands/DecreaseStreamRetentionPeriodCommand":false,"./commands/DeleteStreamCommand":false,"./commands/DeregisterStreamConsumerCommand":false,"./commands/DescribeLimitsCommand":false,"./commands/DescribeStreamCommand":false,"./waiters/waitForStreamExists":false,"./waiters/waitForStreamNotExists":false,"./commands/DescribeStreamConsumerCommand":false,"./commands/DescribeStreamSummaryCommand":false,"./commands/DisableEnhancedMonitoringCommand":false,"./commands/EnableEnhancedMonitoringCommand":false,"./commands/GetRecordsCommand":false,"./commands/GetShardIteratorCommand":false,"./commands/IncreaseStreamRetentionPeriodCommand":false,"./commands/ListShardsCommand":false,"./commands/ListStreamConsumersCommand":false,"./pagination/ListStreamConsumersPaginator":false,"./commands/ListStreamsCommand":false,"./commands/ListTagsForStreamCommand":false,"./commands/MergeShardsCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordsCommand":"7gn9k","./commands/RegisterStreamConsumerCommand":false,"./commands/RemoveTagsFromStreamCommand":false,"./commands/SplitShardCommand":false,"./commands/StartStreamEncryptionCommand":false,"./commands/StopStreamEncryptionCommand":false,"./commands/SubscribeToShardCommand":false,"./commands/UpdateShardCountCommand":false,"./pagination/Interfaces":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hFqJe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KinesisClient", ()=>KinesisClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _eventstreamSerdeConfigResolver = require("@aws-sdk/eventstream-serde-config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Streams Service API Reference</fullname>
 *         <p>Amazon Kinesis Data Streams is a managed service that scales elastically for
 *             real-time processing of streaming big data.</p>
 */ var KinesisClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(KinesisClient, _super);
    function KinesisClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        var _config_7 = (0, _eventstreamSerdeConfigResolver.resolveEventStreamSerdeConfig)(_config_6);
        _this = _super.call(this, _config_7) || this;
        _this.config = _config_7;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    KinesisClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return KinesisClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"7QUww","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/eventstream-serde-config-resolver":"fxdMw","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7QUww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _eventstreamSerdeBrowser = require("@aws-sdk/eventstream-serde-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    eventStreamSerdeProvider: (0, _eventstreamSerdeBrowser.eventStreamSerdeProvider),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"1Bv1F","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/eventstream-serde-browser":"eHxWA","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"3BGdL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Bv1F":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-kinesis","description":"AWS SDK for JavaScript Kinesis Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/eventstream-serde-browser":"3.6.1","@aws-sdk/eventstream-serde-config-resolver":"3.6.1","@aws-sdk/eventstream-serde-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","@aws-sdk/util-waiter":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-kinesis","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-kinesis"}}');

},{}],"eHxWA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./provider":"8FjsJ","./EventStreamMarshaller":"haGlH","./utils":"1LOzm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FjsJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", ()=>eventStreamSerdeProvider);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"haGlH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"haGlH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _eventstreamSerdeUniversal = require("@aws-sdk/eventstream-serde-universal");
var _utils = require("./utils");
/**
 * Utility class used to serialize and deserialize event streams in
 * browsers and ReactNative.
 *
 * In browsers where ReadableStream API is available:
 * * deserialize from ReadableStream to an async iterable of output structure
 * * serialize from async iterable of input structure to ReadableStream
 * In ReactNative where only async iterable API is available:
 * * deserialize from async iterable of binaries to async iterable of output structure
 * * serialize from async iterable of input structure to async iterable of binaries
 *
 * We use ReadableStream API in browsers because of the consistency with other
 * streaming operations, where ReadableStream API is used to denote streaming data.
 * Whereas in ReactNative, ReadableStream API is not available, we use async iterable
 * for streaming data although it has lower throughput.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.universalMarshaller = new (0, _eventstreamSerdeUniversal.EventStreamMarshaller)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var bodyIterable = isReadableStream(body) ? (0, _utils.readableStreamtoIterable)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    };
    /**
     * Generate a stream that serialize events into stream of binary chunks;
     *
     * Caveat is that streaming request payload doesn't work on browser with native
     * xhr or fetch handler currently because they don't support upload streaming.
     * reference:
     * * https://bugs.chromium.org/p/chromium/issues/detail?id=688906
     * * https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
     *
     */ EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, _utils.iterableToReadableStream)(serialziedIterable) : serialziedIterable;
    };
    return EventStreamMarshaller;
}();
var isReadableStream = function(body) {
    return typeof ReadableStream === "function" && body instanceof ReadableStream;
};

},{"@aws-sdk/eventstream-marshaller":"rVrTA","@aws-sdk/eventstream-serde-universal":"2t1dy","./utils":"1LOzm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"rVrTA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);
var _int64 = require("./Int64");
parcelHelpers.exportAll(_int64, exports);
var _message = require("./Message");
parcelHelpers.exportAll(_message, exports);

},{"./EventStreamMarshaller":"9JiTD","./Int64":"alU3V","./Message":"h7wrT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JiTD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _crc32 = require("@aws-crypto/crc32");
var _headerMarshaller = require("./HeaderMarshaller");
var _splitMessage = require("./splitMessage");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new (0, _headerMarshaller.HeaderMarshaller)(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new (0, _crc32.Crc32)();
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = (0, _splitMessage.splitMessage)(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message header.
     */ EventStreamMarshaller.prototype.formatHeaders = function(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    };
    return EventStreamMarshaller;
}();

},{"@aws-crypto/crc32":"5zVRa","./HeaderMarshaller":"aKI8K","./splitMessage":"8Qj0j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5zVRa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = exports.Crc32 = exports.crc32 = void 0;
var tslib_1 = require("ff93ff6885dc1cf");
var util_1 = require("c823117d943f0b79");
function crc32(data) {
    return new Crc32().update(data).digest();
}
exports.crc32 = crc32;
var Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = (0, tslib_1.__values)(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
exports.Crc32 = Crc32;
// prettier-ignore
var a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
var aws_crc32_1 = require("584239808b1ee7cb");
Object.defineProperty(exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return aws_crc32_1.AwsCrc32;
    }
});

},{"ff93ff6885dc1cf":"78SAV","c823117d943f0b79":"1R05H","584239808b1ee7cb":"gPocM"}],"78SAV":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gPocM":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AwsCrc32 = void 0;
var tslib_1 = require("b907f97435eccd7a");
var util_1 = require("3a796558421f7605");
var index_1 = require("3cb74d8e5af5d83d");
var AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new index_1.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash)) return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, util_1.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    return AwsCrc32;
}();
exports.AwsCrc32 = AwsCrc32;

},{"b907f97435eccd7a":"78SAV","3a796558421f7605":"1R05H","3cb74d8e5af5d83d":"5zVRa"}],"aKI8K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderMarshaller", ()=>HeaderMarshaller);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _int64 = require("./Int64");
/**
 * @internal
 */ var HeaderMarshaller = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = (0, _tslib.__values)(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = (0, _tslib.__values)(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set((0, _int64.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set((0, _utilHexEncoding.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: LONG_TAG,
                        value: new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: TIMESTAMP_TAG,
                        value: new Date(new (0, _int64.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: UUID_TAG,
                        value: (0, _utilHexEncoding.toHex)(uuidBytes.subarray(0, 4)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(4, 6)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(6, 8)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(8, 10)) + "-" + (0, _utilHexEncoding.toHex)(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
var BOOLEAN_TAG = "boolean";
var BYTE_TAG = "byte";
var SHORT_TAG = "short";
var INT_TAG = "integer";
var LONG_TAG = "long";
var BINARY_TAG = "binary";
var STRING_TAG = "string";
var TIMESTAMP_TAG = "timestamp";
var UUID_TAG = "uuid";
var UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

},{"tslib":"78SAV","@aws-sdk/util-hex-encoding":"dTdhV","./Int64":"alU3V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"alU3V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Int64", ()=>Int64);
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var Int64 = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) negate(bytes);
        return parseInt((0, _utilHexEncoding.toHex)(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
function negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

},{"@aws-sdk/util-hex-encoding":"dTdhV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Qj0j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 */ parcelHelpers.export(exports, "splitMessage", ()=>splitMessage);
var _crc32 = require("@aws-crypto/crc32");
// All prelude components are unsigned, 32-bit integers
var PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32(PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32(PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - CHECKSUM_LENGTH, false);
    var checksummer = new (0, _crc32.Crc32)().update(new Uint8Array(buffer, byteOffset, PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
    };
}

},{"@aws-crypto/crc32":"5zVRa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h7wrT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2t1dy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
parcelHelpers.exportAll(_eventStreamMarshaller, exports);

},{"./provider":"8QUUN","./EventStreamMarshaller":"gbe5j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8QUUN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventStreamSerdeProvider", ()=>eventStreamSerdeProvider);
var _eventStreamMarshaller = require("./EventStreamMarshaller");
var eventStreamSerdeProvider = function(options) {
    return new (0, _eventStreamMarshaller.EventStreamMarshaller)(options);
};

},{"./EventStreamMarshaller":"gbe5j","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gbe5j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStreamMarshaller", ()=>EventStreamMarshaller);
var _tslib = require("tslib");
var _eventstreamMarshaller = require("@aws-sdk/eventstream-marshaller");
var _getChunkedStream = require("./getChunkedStream");
var _getUnmarshalledStream = require("./getUnmarshalledStream");
var EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(_a) {
        var utf8Encoder = _a.utf8Encoder, utf8Decoder = _a.utf8Decoder;
        this.eventMarshaller = new (0, _eventstreamMarshaller.EventStreamMarshaller)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    EventStreamMarshaller.prototype.deserialize = function(body, deserializer) {
        var chunkedStream = (0, _getChunkedStream.getChunkedStream)(body);
        var unmarshalledStream = (0, _getUnmarshalledStream.getUnmarshalledStream)(chunkedStream, {
            eventMarshaller: this.eventMarshaller,
            deserializer: deserializer,
            toUtf8: this.utfEncoder
        });
        return unmarshalledStream;
    };
    EventStreamMarshaller.prototype.serialize = function(input, serializer) {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var serializedIterator = function() {
            return (0, _tslib.__asyncGenerator)(this, arguments, function() {
                var input_1, input_1_1, chunk, payloadBuf, e_1_1;
                var e_1, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            _b.trys.push([
                                0,
                                7,
                                8,
                                13
                            ]);
                            input_1 = (0, _tslib.__asyncValues)(input);
                            _b.label = 1;
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(input_1.next())
                            ];
                        case 2:
                            if (!(input_1_1 = _b.sent(), !input_1_1.done)) return [
                                3 /*break*/ ,
                                6
                            ];
                            chunk = input_1_1.value;
                            payloadBuf = self.eventMarshaller.marshall(serializer(chunk));
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(payloadBuf)
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 4:
                            _b.sent();
                            _b.label = 5;
                        case 5:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 7:
                            e_1_1 = _b.sent();
                            e_1 = {
                                error: e_1_1
                            };
                            return [
                                3 /*break*/ ,
                                13
                            ];
                        case 8:
                            _b.trys.push([
                                8,
                                ,
                                11,
                                12
                            ]);
                            if (!(input_1_1 && !input_1_1.done && (_a = input_1.return))) return [
                                3 /*break*/ ,
                                10
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(_a.call(input_1))
                            ];
                        case 9:
                            _b.sent();
                            _b.label = 10;
                        case 10:
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            if (e_1) throw e_1.error;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 12:
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 13:
                            return [
                                4 /*yield*/ ,
                                (0, _tslib.__await)(new Uint8Array(0))
                            ];
                        case 14:
                            // Ending frame
                            return [
                                4 /*yield*/ ,
                                _b.sent()
                            ];
                        case 15:
                            // Ending frame
                            _b.sent();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        return _a = {}, _a[Symbol.asyncIterator] = serializedIterator, _a;
    };
    return EventStreamMarshaller;
}();

},{"tslib":"dRdOi","@aws-sdk/eventstream-marshaller":"rVrTA","./getChunkedStream":"1qlSF","./getUnmarshalledStream":"8qfGv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRdOi":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1qlSF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChunkedStream", ()=>getChunkedStream);
var _tslib = require("tslib");
function getChunkedStream(source) {
    var _a;
    var currentMessageTotalLength = 0;
    var currentMessagePendingLength = 0;
    var currentMessage = null;
    var messageLengthBuffer = null;
    var allocateMessage = function(size) {
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        var currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false); //set big-endian Uint32 to 0~3 bytes
    };
    var iterator = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var sourceIterator, _a, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        sourceIterator = source[Symbol.asyncIterator]();
                        _b.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(sourceIterator.next())
                        ];
                    case 2:
                        _a = _b.sent(), value = _a.value, done = _a.done;
                        if (!done) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!!currentMessageTotalLength) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        if (!(currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 6:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        throw new Error("Truncated event message received.");
                    case 8:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 10:
                        chunkLength = value.length;
                        currentOffset = 0;
                        _b.label = 11;
                    case 11:
                        if (!(currentOffset < chunkLength)) return [
                            3 /*break*/ ,
                            15
                        ];
                        // create new message if necessary
                        if (!currentMessage) {
                            bytesRemaining = chunkLength - currentOffset;
                            // prevent edge case where total length spans 2 chunks
                            if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                            numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining // bytes left in chunk
                            );
                            messageLengthBuffer.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                            value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                            currentMessagePendingLength += numBytesForTotal;
                            currentOffset += numBytesForTotal;
                            if (currentMessagePendingLength < 4) // not enough information to create the current message
                            return [
                                3 /*break*/ ,
                                15
                            ];
                            allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                            messageLengthBuffer = null;
                        }
                        numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset // number of bytes left in the original chunk
                        );
                        currentMessage.set(// @ts-ignore error TS2532: Object is possibly 'undefined' for value
                        value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                        currentMessagePendingLength += numBytesToWrite;
                        currentOffset += numBytesToWrite;
                        if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(currentMessage)
                        ];
                    case 12:
                        // push out the message
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 13:
                        // push out the message
                        _b.sent();
                        // cleanup
                        currentMessage = null;
                        currentMessageTotalLength = 0;
                        currentMessagePendingLength = 0;
                        _b.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return _a = {}, _a[Symbol.asyncIterator] = iterator, _a;
}

},{"tslib":"dRdOi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qfGv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUnmarshalledStream", ()=>getUnmarshalledStream);
var _tslib = require("tslib");
function getUnmarshalledStream(source, options) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var source_1, source_1_1, chunk, message, messageType, unmodeledError, code, exception, deserializedException, error, event, deserialized, e_1_1;
            var _a, _b;
            var e_1, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            12,
                            13,
                            18
                        ]);
                        source_1 = (0, _tslib.__asyncValues)(source);
                        _d.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(source_1.next())
                        ];
                    case 2:
                        if (!(source_1_1 = _d.sent(), !source_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        chunk = source_1_1.value;
                        message = options.eventMarshaller.unmarshall(chunk);
                        messageType = message.headers[":message-type"].value;
                        if (!(messageType === "error")) return [
                            3 /*break*/ ,
                            3
                        ];
                        unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
                        unmodeledError.name = message.headers[":error-code"].value;
                        throw unmodeledError;
                    case 3:
                        if (!(messageType === "exception")) return [
                            3 /*break*/ ,
                            5
                        ];
                        code = message.headers[":exception-type"].value;
                        exception = (_a = {}, _a[code] = message, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(exception))
                        ];
                    case 4:
                        deserializedException = _d.sent();
                        if (deserializedException.$unknown) {
                            error = new Error(options.toUtf8(message.body));
                            error.name = code;
                            throw error;
                        }
                        throw deserializedException[code];
                    case 5:
                        if (!(messageType === "event")) return [
                            3 /*break*/ ,
                            9
                        ];
                        event = (_b = {}, _b[message.headers[":event-type"].value] = message, _b);
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(options.deserializer(event))
                        ];
                    case 6:
                        deserialized = _d.sent();
                        if (deserialized.$unknown) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(deserialized)
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            _d.sent()
                        ];
                    case 8:
                        _d.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        throw Error("Unrecognizable event type: " + message.headers[":event-type"].value);
                    case 10:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _d.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _d.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(source_1_1 && !source_1_1.done && (_c = source_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(_c.call(source_1))
                        ];
                    case 14:
                        _d.sent();
                        _d.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
}

},{"tslib":"dRdOi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1LOzm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamtoIterable", ()=>readableStreamtoIterable);
parcelHelpers.export(exports, "iterableToReadableStream", ()=>iterableToReadableStream);
var _tslib = require("tslib");
var readableStreamtoIterable = function(readableStream) {
    var _a;
    return _a = {}, _a[Symbol.asyncIterator] = function() {
        return (0, _tslib.__asyncGenerator)(this, arguments, function() {
            var reader, _a, done, value;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reader = readableStream.getReader();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(reader.read())
                        ];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (!done) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(void 0)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            (0, _tslib.__await)(value)
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        reader.releaseLock();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, _a;
};
var iterableToReadableStream = function(asyncIterable) {
    var iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        pull: function(controller) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var _a, done, value;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                iterator.next()
                            ];
                        case 1:
                            _a = _b.sent(), done = _a.done, value = _a.value;
                            if (done) return [
                                2 /*return*/ ,
                                controller.close()
                            ];
                            controller.enqueue(value);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"fCvjy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fCvjy":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3BGdL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2013-12-02",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Kinesis",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"bnUVz","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bnUVz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "kinesis.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "kinesis.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "kinesis.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "kinesis.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "kinesis.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "kinesis.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "kinesis.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "kinesis.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "kinesis.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "kinesis.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "kinesis.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "kinesis.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "kinesis.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "kinesis.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "kinesis.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "kinesis.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "kinesis.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "kinesis.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "kinesis.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "kinesis.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "kinesis.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "kinesis-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "kinesis-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "kinesis-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "kinesis-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "kinesis.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "kinesis.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "kinesis.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "kinesis.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "kinesis.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "kinesis.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "kinesis.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso"
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "kinesis.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "kinesis.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "kinesis.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "kinesis"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxdMw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventStreamSerdeConfig = require("./EventStreamSerdeConfig");
parcelHelpers.exportAll(_eventStreamSerdeConfig, exports);

},{"./EventStreamSerdeConfig":"8wY6r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8wY6r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEventStreamSerdeConfig", ()=>resolveEventStreamSerdeConfig);
var _tslib = require("tslib");
var resolveEventStreamSerdeConfig = function(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });
};

},{"tslib":"8t8vB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8t8vB":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gn9k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordsCommand", ()=>PutRecordsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a Kinesis data stream in a single call (also
 *             referred to as a <code>PutRecords</code> request). Use this operation to send data into
 *             the stream for data ingestion and processing. </p>
 *         <p>Each <code>PutRecords</code> request can support up to 500 records. Each record in
 *             the request can be as large as 1 MiB, up to a limit of 5 MiB for the entire request,
 *             including partition keys. Each shard can support writes up to 1,000 records per second,
 *             up to a maximum data write total of 1 MiB per second.</p>
 *         <p>You must specify the name of the stream that captures, stores, and transports the
 *             data; and an array of request <code>Records</code>, with each record in the array
 *             requiring a partition key and data blob. The record size limit applies to the total size
 *             of the partition key and data blob.</p>
 *         <p>The data blob can be any type of data; for example, a segment from a log file,
 *             geographic/location data, website clickstream data, and so on.</p>
 *         <p>The partition key is used by Kinesis Data Streams as input to a hash function that
 *             maps the partition key and associated data to a specific shard. An MD5 hash function is
 *             used to map partition keys to 128-bit integer values and to map associated data records
 *             to shards. As a result of this hashing mechanism, all data records with the same
 *             partition key map to the same shard within the stream. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-add-data-to-stream">Adding Data to a Stream</a> in the <i>Amazon Kinesis Data Streams
 *                 Developer Guide</i>.</p>
 *         <p>Each record in the <code>Records</code> array may include an optional parameter,
 *                 <code>ExplicitHashKey</code>, which overrides the partition key to shard mapping.
 *             This parameter allows a data producer to determine explicitly the shard where the record
 *             is stored. For more information, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/developing-producers-with-sdk.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <p>The <code>PutRecords</code> response includes an array of response
 *                 <code>Records</code>. Each record in the response array directly correlates with a
 *             record in the request array using natural ordering, from the top to the bottom of the
 *             request and response. The response <code>Records</code> array always includes the same
 *             number of records as the request array.</p>
 *         <p>The response <code>Records</code> array includes both successfully and
 *             unsuccessfully processed records. Kinesis Data Streams attempts to process all records
 *             in each <code>PutRecords</code> request. A single record failure does not stop the
 *             processing of subsequent records. As a result, PutRecords doesn't guarantee the ordering
 *             of records. If you need to read records in the same order they are written to the
 *             stream, use <a>PutRecord</a> instead of <code>PutRecords</code>, and write to
 *             the same shard.</p>
 *         <p>A successfully processed record includes <code>ShardId</code> and
 *                 <code>SequenceNumber</code> values. The <code>ShardId</code> parameter identifies
 *             the shard in the stream where the record is stored. The <code>SequenceNumber</code>
 *             parameter is an identifier assigned to the put record, unique to all records in the
 *             stream.</p>
 *         <p>An unsuccessfully processed record includes <code>ErrorCode</code> and
 *                 <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error
 *             and can be one of the following values:
 *                 <code>ProvisionedThroughputExceededException</code> or <code>InternalFailure</code>.
 *                 <code>ErrorMessage</code> provides more detailed information about the
 *                 <code>ProvisionedThroughputExceededException</code> exception including the account
 *             ID, stream name, and shard ID of the record that was throttled. For more information
 *             about partially successful responses, see <a href="https://docs.aws.amazon.com/kinesis/latest/dev/kinesis-using-sdk-java-add-data-to-stream.html#kinesis-using-sdk-java-putrecords">Adding Multiple Records with PutRecords</a> in the <i>Amazon Kinesis
 *                 Data Streams Developer Guide</i>.</p>
 *         <important>
 *             <p>After you write a record to a stream, you cannot modify that record or its order
 *                 within the stream.</p>
 *         </important>
 *         <p>By default, data records are accessible for 24 hours from the time that they are
 *             added to a stream. You can use <a>IncreaseStreamRetentionPeriod</a> or <a>DecreaseStreamRetentionPeriod</a> to modify this retention period.</p>
 */ var PutRecordsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "PutRecordsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordsInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordsOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordsCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordsCommand)(input, context);
    };
    PutRecordsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordsCommand)(output, context);
    };
    return PutRecordsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"dLNd8","../protocols/Aws_json1_1":"dGZXC","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dLNd8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddTagsToStreamInput", ()=>AddTagsToStreamInput);
parcelHelpers.export(exports, "InvalidArgumentException", ()=>InvalidArgumentException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceInUseException", ()=>ResourceInUseException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "HashKeyRange", ()=>HashKeyRange);
parcelHelpers.export(exports, "ChildShard", ()=>ChildShard);
parcelHelpers.export(exports, "ConsumerStatus", ()=>ConsumerStatus);
parcelHelpers.export(exports, "Consumer", ()=>Consumer);
parcelHelpers.export(exports, "ConsumerDescription", ()=>ConsumerDescription);
parcelHelpers.export(exports, "CreateStreamInput", ()=>CreateStreamInput);
parcelHelpers.export(exports, "DecreaseStreamRetentionPeriodInput", ()=>DecreaseStreamRetentionPeriodInput);
parcelHelpers.export(exports, "DeleteStreamInput", ()=>DeleteStreamInput);
parcelHelpers.export(exports, "DeregisterStreamConsumerInput", ()=>DeregisterStreamConsumerInput);
parcelHelpers.export(exports, "DescribeLimitsInput", ()=>DescribeLimitsInput);
parcelHelpers.export(exports, "DescribeLimitsOutput", ()=>DescribeLimitsOutput);
parcelHelpers.export(exports, "DescribeStreamInput", ()=>DescribeStreamInput);
parcelHelpers.export(exports, "EncryptionType", ()=>EncryptionType);
parcelHelpers.export(exports, "MetricsName", ()=>MetricsName);
parcelHelpers.export(exports, "EnhancedMetrics", ()=>EnhancedMetrics);
parcelHelpers.export(exports, "SequenceNumberRange", ()=>SequenceNumberRange);
parcelHelpers.export(exports, "Shard", ()=>Shard);
parcelHelpers.export(exports, "StreamStatus", ()=>StreamStatus);
parcelHelpers.export(exports, "StreamDescription", ()=>StreamDescription);
parcelHelpers.export(exports, "DescribeStreamOutput", ()=>DescribeStreamOutput);
parcelHelpers.export(exports, "DescribeStreamConsumerInput", ()=>DescribeStreamConsumerInput);
parcelHelpers.export(exports, "DescribeStreamConsumerOutput", ()=>DescribeStreamConsumerOutput);
parcelHelpers.export(exports, "DescribeStreamSummaryInput", ()=>DescribeStreamSummaryInput);
parcelHelpers.export(exports, "StreamDescriptionSummary", ()=>StreamDescriptionSummary);
parcelHelpers.export(exports, "DescribeStreamSummaryOutput", ()=>DescribeStreamSummaryOutput);
parcelHelpers.export(exports, "DisableEnhancedMonitoringInput", ()=>DisableEnhancedMonitoringInput);
parcelHelpers.export(exports, "EnhancedMonitoringOutput", ()=>EnhancedMonitoringOutput);
parcelHelpers.export(exports, "EnableEnhancedMonitoringInput", ()=>EnableEnhancedMonitoringInput);
parcelHelpers.export(exports, "ExpiredIteratorException", ()=>ExpiredIteratorException);
parcelHelpers.export(exports, "ExpiredNextTokenException", ()=>ExpiredNextTokenException);
parcelHelpers.export(exports, "GetRecordsInput", ()=>GetRecordsInput);
parcelHelpers.export(exports, "_Record", ()=>_Record);
parcelHelpers.export(exports, "GetRecordsOutput", ()=>GetRecordsOutput);
parcelHelpers.export(exports, "KMSAccessDeniedException", ()=>KMSAccessDeniedException);
parcelHelpers.export(exports, "KMSDisabledException", ()=>KMSDisabledException);
parcelHelpers.export(exports, "KMSInvalidStateException", ()=>KMSInvalidStateException);
parcelHelpers.export(exports, "KMSNotFoundException", ()=>KMSNotFoundException);
parcelHelpers.export(exports, "KMSOptInRequired", ()=>KMSOptInRequired);
parcelHelpers.export(exports, "KMSThrottlingException", ()=>KMSThrottlingException);
parcelHelpers.export(exports, "ProvisionedThroughputExceededException", ()=>ProvisionedThroughputExceededException);
parcelHelpers.export(exports, "ShardIteratorType", ()=>ShardIteratorType);
parcelHelpers.export(exports, "GetShardIteratorInput", ()=>GetShardIteratorInput);
parcelHelpers.export(exports, "GetShardIteratorOutput", ()=>GetShardIteratorOutput);
parcelHelpers.export(exports, "IncreaseStreamRetentionPeriodInput", ()=>IncreaseStreamRetentionPeriodInput);
parcelHelpers.export(exports, "InternalFailureException", ()=>InternalFailureException);
parcelHelpers.export(exports, "ShardFilterType", ()=>ShardFilterType);
parcelHelpers.export(exports, "ShardFilter", ()=>ShardFilter);
parcelHelpers.export(exports, "ListShardsInput", ()=>ListShardsInput);
parcelHelpers.export(exports, "ListShardsOutput", ()=>ListShardsOutput);
parcelHelpers.export(exports, "ListStreamConsumersInput", ()=>ListStreamConsumersInput);
parcelHelpers.export(exports, "ListStreamConsumersOutput", ()=>ListStreamConsumersOutput);
parcelHelpers.export(exports, "ListStreamsInput", ()=>ListStreamsInput);
parcelHelpers.export(exports, "ListStreamsOutput", ()=>ListStreamsOutput);
parcelHelpers.export(exports, "ListTagsForStreamInput", ()=>ListTagsForStreamInput);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "ListTagsForStreamOutput", ()=>ListTagsForStreamOutput);
parcelHelpers.export(exports, "MergeShardsInput", ()=>MergeShardsInput);
parcelHelpers.export(exports, "PutRecordInput", ()=>PutRecordInput);
parcelHelpers.export(exports, "PutRecordOutput", ()=>PutRecordOutput);
parcelHelpers.export(exports, "PutRecordsRequestEntry", ()=>PutRecordsRequestEntry);
parcelHelpers.export(exports, "PutRecordsInput", ()=>PutRecordsInput);
parcelHelpers.export(exports, "PutRecordsResultEntry", ()=>PutRecordsResultEntry);
parcelHelpers.export(exports, "PutRecordsOutput", ()=>PutRecordsOutput);
parcelHelpers.export(exports, "RegisterStreamConsumerInput", ()=>RegisterStreamConsumerInput);
parcelHelpers.export(exports, "RegisterStreamConsumerOutput", ()=>RegisterStreamConsumerOutput);
parcelHelpers.export(exports, "RemoveTagsFromStreamInput", ()=>RemoveTagsFromStreamInput);
parcelHelpers.export(exports, "SplitShardInput", ()=>SplitShardInput);
parcelHelpers.export(exports, "StartStreamEncryptionInput", ()=>StartStreamEncryptionInput);
parcelHelpers.export(exports, "StopStreamEncryptionInput", ()=>StopStreamEncryptionInput);
parcelHelpers.export(exports, "StartingPosition", ()=>StartingPosition);
parcelHelpers.export(exports, "SubscribeToShardInput", ()=>SubscribeToShardInput);
parcelHelpers.export(exports, "SubscribeToShardEvent", ()=>SubscribeToShardEvent);
parcelHelpers.export(exports, "SubscribeToShardEventStream", ()=>SubscribeToShardEventStream);
parcelHelpers.export(exports, "SubscribeToShardOutput", ()=>SubscribeToShardOutput);
parcelHelpers.export(exports, "ScalingType", ()=>ScalingType);
parcelHelpers.export(exports, "UpdateShardCountInput", ()=>UpdateShardCountInput);
parcelHelpers.export(exports, "UpdateShardCountOutput", ()=>UpdateShardCountOutput);
var _tslib = require("tslib");
var AddTagsToStreamInput;
(function(AddTagsToStreamInput) {
    AddTagsToStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(AddTagsToStreamInput || (AddTagsToStreamInput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var HashKeyRange;
(function(HashKeyRange) {
    HashKeyRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HashKeyRange || (HashKeyRange = {}));
var ChildShard;
(function(ChildShard) {
    ChildShard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ChildShard || (ChildShard = {}));
var ConsumerStatus;
(function(ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "ACTIVE";
    ConsumerStatus["CREATING"] = "CREATING";
    ConsumerStatus["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
var Consumer;
(function(Consumer) {
    Consumer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Consumer || (Consumer = {}));
var ConsumerDescription;
(function(ConsumerDescription) {
    ConsumerDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConsumerDescription || (ConsumerDescription = {}));
var CreateStreamInput;
(function(CreateStreamInput) {
    CreateStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateStreamInput || (CreateStreamInput = {}));
var DecreaseStreamRetentionPeriodInput;
(function(DecreaseStreamRetentionPeriodInput) {
    DecreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DecreaseStreamRetentionPeriodInput || (DecreaseStreamRetentionPeriodInput = {}));
var DeleteStreamInput;
(function(DeleteStreamInput) {
    DeleteStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteStreamInput || (DeleteStreamInput = {}));
var DeregisterStreamConsumerInput;
(function(DeregisterStreamConsumerInput) {
    DeregisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeregisterStreamConsumerInput || (DeregisterStreamConsumerInput = {}));
var DescribeLimitsInput;
(function(DescribeLimitsInput) {
    DescribeLimitsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsInput || (DescribeLimitsInput = {}));
var DescribeLimitsOutput;
(function(DescribeLimitsOutput) {
    DescribeLimitsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeLimitsOutput || (DescribeLimitsOutput = {}));
var DescribeStreamInput;
(function(DescribeStreamInput) {
    DescribeStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamInput || (DescribeStreamInput = {}));
var EncryptionType;
(function(EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
var MetricsName;
(function(MetricsName) {
    MetricsName["ALL"] = "ALL";
    MetricsName["INCOMING_BYTES"] = "IncomingBytes";
    MetricsName["INCOMING_RECORDS"] = "IncomingRecords";
    MetricsName["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
    MetricsName["OUTGOING_BYTES"] = "OutgoingBytes";
    MetricsName["OUTGOING_RECORDS"] = "OutgoingRecords";
    MetricsName["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
    MetricsName["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
var EnhancedMetrics;
(function(EnhancedMetrics) {
    EnhancedMetrics.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMetrics || (EnhancedMetrics = {}));
var SequenceNumberRange;
(function(SequenceNumberRange) {
    SequenceNumberRange.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SequenceNumberRange || (SequenceNumberRange = {}));
var Shard;
(function(Shard) {
    Shard.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Shard || (Shard = {}));
var StreamStatus;
(function(StreamStatus) {
    StreamStatus["ACTIVE"] = "ACTIVE";
    StreamStatus["CREATING"] = "CREATING";
    StreamStatus["DELETING"] = "DELETING";
    StreamStatus["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
var StreamDescription;
(function(StreamDescription) {
    StreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescription || (StreamDescription = {}));
var DescribeStreamOutput;
(function(DescribeStreamOutput) {
    DescribeStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamOutput || (DescribeStreamOutput = {}));
var DescribeStreamConsumerInput;
(function(DescribeStreamConsumerInput) {
    DescribeStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerInput || (DescribeStreamConsumerInput = {}));
var DescribeStreamConsumerOutput;
(function(DescribeStreamConsumerOutput) {
    DescribeStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamConsumerOutput || (DescribeStreamConsumerOutput = {}));
var DescribeStreamSummaryInput;
(function(DescribeStreamSummaryInput) {
    DescribeStreamSummaryInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryInput || (DescribeStreamSummaryInput = {}));
var StreamDescriptionSummary;
(function(StreamDescriptionSummary) {
    StreamDescriptionSummary.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StreamDescriptionSummary || (StreamDescriptionSummary = {}));
var DescribeStreamSummaryOutput;
(function(DescribeStreamSummaryOutput) {
    DescribeStreamSummaryOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeStreamSummaryOutput || (DescribeStreamSummaryOutput = {}));
var DisableEnhancedMonitoringInput;
(function(DisableEnhancedMonitoringInput) {
    DisableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DisableEnhancedMonitoringInput || (DisableEnhancedMonitoringInput = {}));
var EnhancedMonitoringOutput;
(function(EnhancedMonitoringOutput) {
    EnhancedMonitoringOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnhancedMonitoringOutput || (EnhancedMonitoringOutput = {}));
var EnableEnhancedMonitoringInput;
(function(EnableEnhancedMonitoringInput) {
    EnableEnhancedMonitoringInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EnableEnhancedMonitoringInput || (EnableEnhancedMonitoringInput = {}));
var ExpiredIteratorException;
(function(ExpiredIteratorException) {
    ExpiredIteratorException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredIteratorException || (ExpiredIteratorException = {}));
var ExpiredNextTokenException;
(function(ExpiredNextTokenException) {
    ExpiredNextTokenException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExpiredNextTokenException || (ExpiredNextTokenException = {}));
var GetRecordsInput;
(function(GetRecordsInput) {
    GetRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsInput || (GetRecordsInput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var GetRecordsOutput;
(function(GetRecordsOutput) {
    GetRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetRecordsOutput || (GetRecordsOutput = {}));
var KMSAccessDeniedException;
(function(KMSAccessDeniedException) {
    KMSAccessDeniedException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSAccessDeniedException || (KMSAccessDeniedException = {}));
var KMSDisabledException;
(function(KMSDisabledException) {
    KMSDisabledException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSDisabledException || (KMSDisabledException = {}));
var KMSInvalidStateException;
(function(KMSInvalidStateException) {
    KMSInvalidStateException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSInvalidStateException || (KMSInvalidStateException = {}));
var KMSNotFoundException;
(function(KMSNotFoundException) {
    KMSNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSNotFoundException || (KMSNotFoundException = {}));
var KMSOptInRequired;
(function(KMSOptInRequired) {
    KMSOptInRequired.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSOptInRequired || (KMSOptInRequired = {}));
var KMSThrottlingException;
(function(KMSThrottlingException) {
    KMSThrottlingException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSThrottlingException || (KMSThrottlingException = {}));
var ProvisionedThroughputExceededException;
(function(ProvisionedThroughputExceededException) {
    ProvisionedThroughputExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
var ShardIteratorType;
(function(ShardIteratorType) {
    ShardIteratorType["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
    ShardIteratorType["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
    ShardIteratorType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardIteratorType["LATEST"] = "LATEST";
    ShardIteratorType["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
var GetShardIteratorInput;
(function(GetShardIteratorInput) {
    GetShardIteratorInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorInput || (GetShardIteratorInput = {}));
var GetShardIteratorOutput;
(function(GetShardIteratorOutput) {
    GetShardIteratorOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(GetShardIteratorOutput || (GetShardIteratorOutput = {}));
var IncreaseStreamRetentionPeriodInput;
(function(IncreaseStreamRetentionPeriodInput) {
    IncreaseStreamRetentionPeriodInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(IncreaseStreamRetentionPeriodInput || (IncreaseStreamRetentionPeriodInput = {}));
var InternalFailureException;
(function(InternalFailureException) {
    InternalFailureException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InternalFailureException || (InternalFailureException = {}));
var ShardFilterType;
(function(ShardFilterType) {
    ShardFilterType["AFTER_SHARD_ID"] = "AFTER_SHARD_ID";
    ShardFilterType["AT_LATEST"] = "AT_LATEST";
    ShardFilterType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardFilterType["AT_TRIM_HORIZON"] = "AT_TRIM_HORIZON";
    ShardFilterType["FROM_TIMESTAMP"] = "FROM_TIMESTAMP";
    ShardFilterType["FROM_TRIM_HORIZON"] = "FROM_TRIM_HORIZON";
})(ShardFilterType || (ShardFilterType = {}));
var ShardFilter;
(function(ShardFilter) {
    ShardFilter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ShardFilter || (ShardFilter = {}));
var ListShardsInput;
(function(ListShardsInput) {
    ListShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsInput || (ListShardsInput = {}));
var ListShardsOutput;
(function(ListShardsOutput) {
    ListShardsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListShardsOutput || (ListShardsOutput = {}));
var ListStreamConsumersInput;
(function(ListStreamConsumersInput) {
    ListStreamConsumersInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersInput || (ListStreamConsumersInput = {}));
var ListStreamConsumersOutput;
(function(ListStreamConsumersOutput) {
    ListStreamConsumersOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamConsumersOutput || (ListStreamConsumersOutput = {}));
var ListStreamsInput;
(function(ListStreamsInput) {
    ListStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsInput || (ListStreamsInput = {}));
var ListStreamsOutput;
(function(ListStreamsOutput) {
    ListStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListStreamsOutput || (ListStreamsOutput = {}));
var ListTagsForStreamInput;
(function(ListTagsForStreamInput) {
    ListTagsForStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamInput || (ListTagsForStreamInput = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var ListTagsForStreamOutput;
(function(ListTagsForStreamOutput) {
    ListTagsForStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForStreamOutput || (ListTagsForStreamOutput = {}));
var MergeShardsInput;
(function(MergeShardsInput) {
    MergeShardsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(MergeShardsInput || (MergeShardsInput = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var PutRecordsRequestEntry;
(function(PutRecordsRequestEntry) {
    PutRecordsRequestEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsRequestEntry || (PutRecordsRequestEntry = {}));
var PutRecordsInput;
(function(PutRecordsInput) {
    PutRecordsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsInput || (PutRecordsInput = {}));
var PutRecordsResultEntry;
(function(PutRecordsResultEntry) {
    PutRecordsResultEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsResultEntry || (PutRecordsResultEntry = {}));
var PutRecordsOutput;
(function(PutRecordsOutput) {
    PutRecordsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordsOutput || (PutRecordsOutput = {}));
var RegisterStreamConsumerInput;
(function(RegisterStreamConsumerInput) {
    RegisterStreamConsumerInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerInput || (RegisterStreamConsumerInput = {}));
var RegisterStreamConsumerOutput;
(function(RegisterStreamConsumerOutput) {
    RegisterStreamConsumerOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RegisterStreamConsumerOutput || (RegisterStreamConsumerOutput = {}));
var RemoveTagsFromStreamInput;
(function(RemoveTagsFromStreamInput) {
    RemoveTagsFromStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RemoveTagsFromStreamInput || (RemoveTagsFromStreamInput = {}));
var SplitShardInput;
(function(SplitShardInput) {
    SplitShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplitShardInput || (SplitShardInput = {}));
var StartStreamEncryptionInput;
(function(StartStreamEncryptionInput) {
    StartStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartStreamEncryptionInput || (StartStreamEncryptionInput = {}));
var StopStreamEncryptionInput;
(function(StopStreamEncryptionInput) {
    StopStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopStreamEncryptionInput || (StopStreamEncryptionInput = {}));
var StartingPosition;
(function(StartingPosition) {
    StartingPosition.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartingPosition || (StartingPosition = {}));
var SubscribeToShardInput;
(function(SubscribeToShardInput) {
    SubscribeToShardInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardInput || (SubscribeToShardInput = {}));
var SubscribeToShardEvent;
(function(SubscribeToShardEvent) {
    SubscribeToShardEvent.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SubscribeToShardEvent || (SubscribeToShardEvent = {}));
var SubscribeToShardEventStream;
(function(SubscribeToShardEventStream) {
    SubscribeToShardEventStream.visit = function(value, visitor) {
        if (value.SubscribeToShardEvent !== undefined) return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
        if (value.ResourceNotFoundException !== undefined) return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.ResourceInUseException !== undefined) return visitor.ResourceInUseException(value.ResourceInUseException);
        if (value.KMSDisabledException !== undefined) return visitor.KMSDisabledException(value.KMSDisabledException);
        if (value.KMSInvalidStateException !== undefined) return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
        if (value.KMSAccessDeniedException !== undefined) return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
        if (value.KMSNotFoundException !== undefined) return visitor.KMSNotFoundException(value.KMSNotFoundException);
        if (value.KMSOptInRequired !== undefined) return visitor.KMSOptInRequired(value.KMSOptInRequired);
        if (value.KMSThrottlingException !== undefined) return visitor.KMSThrottlingException(value.KMSThrottlingException);
        if (value.InternalFailureException !== undefined) return visitor.InternalFailureException(value.InternalFailureException);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SubscribeToShardEventStream.filterSensitiveLog = function(obj) {
        var _a;
        if (obj.SubscribeToShardEvent !== undefined) return {
            SubscribeToShardEvent: SubscribeToShardEvent.filterSensitiveLog(obj.SubscribeToShardEvent)
        };
        if (obj.ResourceNotFoundException !== undefined) return {
            ResourceNotFoundException: ResourceNotFoundException.filterSensitiveLog(obj.ResourceNotFoundException)
        };
        if (obj.ResourceInUseException !== undefined) return {
            ResourceInUseException: ResourceInUseException.filterSensitiveLog(obj.ResourceInUseException)
        };
        if (obj.KMSDisabledException !== undefined) return {
            KMSDisabledException: KMSDisabledException.filterSensitiveLog(obj.KMSDisabledException)
        };
        if (obj.KMSInvalidStateException !== undefined) return {
            KMSInvalidStateException: KMSInvalidStateException.filterSensitiveLog(obj.KMSInvalidStateException)
        };
        if (obj.KMSAccessDeniedException !== undefined) return {
            KMSAccessDeniedException: KMSAccessDeniedException.filterSensitiveLog(obj.KMSAccessDeniedException)
        };
        if (obj.KMSNotFoundException !== undefined) return {
            KMSNotFoundException: KMSNotFoundException.filterSensitiveLog(obj.KMSNotFoundException)
        };
        if (obj.KMSOptInRequired !== undefined) return {
            KMSOptInRequired: KMSOptInRequired.filterSensitiveLog(obj.KMSOptInRequired)
        };
        if (obj.KMSThrottlingException !== undefined) return {
            KMSThrottlingException: KMSThrottlingException.filterSensitiveLog(obj.KMSThrottlingException)
        };
        if (obj.InternalFailureException !== undefined) return {
            InternalFailureException: InternalFailureException.filterSensitiveLog(obj.InternalFailureException)
        };
        if (obj.$unknown !== undefined) return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
var SubscribeToShardOutput;
(function(SubscribeToShardOutput) {
    SubscribeToShardOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EventStream && {
            EventStream: "STREAMING_CONTENT"
        });
    };
})(SubscribeToShardOutput || (SubscribeToShardOutput = {}));
var ScalingType;
(function(ScalingType) {
    ScalingType["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
var UpdateShardCountInput;
(function(UpdateShardCountInput) {
    UpdateShardCountInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountInput || (UpdateShardCountInput = {}));
var UpdateShardCountOutput;
(function(UpdateShardCountOutput) {
    UpdateShardCountOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateShardCountOutput || (UpdateShardCountOutput = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGZXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1AddTagsToStreamCommand", ()=>serializeAws_json1_1AddTagsToStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1CreateStreamCommand", ()=>serializeAws_json1_1CreateStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DecreaseStreamRetentionPeriodCommand", ()=>serializeAws_json1_1DecreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteStreamCommand", ()=>serializeAws_json1_1DeleteStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeregisterStreamConsumerCommand", ()=>serializeAws_json1_1DeregisterStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeLimitsCommand", ()=>serializeAws_json1_1DescribeLimitsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamCommand", ()=>serializeAws_json1_1DescribeStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamConsumerCommand", ()=>serializeAws_json1_1DescribeStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeStreamSummaryCommand", ()=>serializeAws_json1_1DescribeStreamSummaryCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DisableEnhancedMonitoringCommand", ()=>serializeAws_json1_1DisableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "serializeAws_json1_1EnableEnhancedMonitoringCommand", ()=>serializeAws_json1_1EnableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetRecordsCommand", ()=>serializeAws_json1_1GetRecordsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1GetShardIteratorCommand", ()=>serializeAws_json1_1GetShardIteratorCommand);
parcelHelpers.export(exports, "serializeAws_json1_1IncreaseStreamRetentionPeriodCommand", ()=>serializeAws_json1_1IncreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListShardsCommand", ()=>serializeAws_json1_1ListShardsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamConsumersCommand", ()=>serializeAws_json1_1ListStreamConsumersCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListStreamsCommand", ()=>serializeAws_json1_1ListStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForStreamCommand", ()=>serializeAws_json1_1ListTagsForStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1MergeShardsCommand", ()=>serializeAws_json1_1MergeShardsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", ()=>serializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordsCommand", ()=>serializeAws_json1_1PutRecordsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1RegisterStreamConsumerCommand", ()=>serializeAws_json1_1RegisterStreamConsumerCommand);
parcelHelpers.export(exports, "serializeAws_json1_1RemoveTagsFromStreamCommand", ()=>serializeAws_json1_1RemoveTagsFromStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1SplitShardCommand", ()=>serializeAws_json1_1SplitShardCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartStreamEncryptionCommand", ()=>serializeAws_json1_1StartStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopStreamEncryptionCommand", ()=>serializeAws_json1_1StopStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1SubscribeToShardCommand", ()=>serializeAws_json1_1SubscribeToShardCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UpdateShardCountCommand", ()=>serializeAws_json1_1UpdateShardCountCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1AddTagsToStreamCommand", ()=>deserializeAws_json1_1AddTagsToStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateStreamCommand", ()=>deserializeAws_json1_1CreateStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand", ()=>deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteStreamCommand", ()=>deserializeAws_json1_1DeleteStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeregisterStreamConsumerCommand", ()=>deserializeAws_json1_1DeregisterStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeLimitsCommand", ()=>deserializeAws_json1_1DescribeLimitsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamCommand", ()=>deserializeAws_json1_1DescribeStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamConsumerCommand", ()=>deserializeAws_json1_1DescribeStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeStreamSummaryCommand", ()=>deserializeAws_json1_1DescribeStreamSummaryCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DisableEnhancedMonitoringCommand", ()=>deserializeAws_json1_1DisableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1EnableEnhancedMonitoringCommand", ()=>deserializeAws_json1_1EnableEnhancedMonitoringCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetRecordsCommand", ()=>deserializeAws_json1_1GetRecordsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1GetShardIteratorCommand", ()=>deserializeAws_json1_1GetShardIteratorCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand", ()=>deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListShardsCommand", ()=>deserializeAws_json1_1ListShardsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamConsumersCommand", ()=>deserializeAws_json1_1ListStreamConsumersCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListStreamsCommand", ()=>deserializeAws_json1_1ListStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForStreamCommand", ()=>deserializeAws_json1_1ListTagsForStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1MergeShardsCommand", ()=>deserializeAws_json1_1MergeShardsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", ()=>deserializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordsCommand", ()=>deserializeAws_json1_1PutRecordsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1RegisterStreamConsumerCommand", ()=>deserializeAws_json1_1RegisterStreamConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1RemoveTagsFromStreamCommand", ()=>deserializeAws_json1_1RemoveTagsFromStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1SplitShardCommand", ()=>deserializeAws_json1_1SplitShardCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartStreamEncryptionCommand", ()=>deserializeAws_json1_1StartStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopStreamEncryptionCommand", ()=>deserializeAws_json1_1StopStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1SubscribeToShardCommand", ()=>deserializeAws_json1_1SubscribeToShardCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateShardCountCommand", ()=>deserializeAws_json1_1UpdateShardCountCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1AddTagsToStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.AddTagsToStream"
            };
            body = JSON.stringify(serializeAws_json1_1AddTagsToStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1CreateStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.CreateStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DecreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1DecreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeleteStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeregisterStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DeregisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DeregisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeLimitsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeLimits"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeLimitsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeStreamSummaryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DescribeStreamSummary"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeStreamSummaryInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.DisableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1DisableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.EnableEnhancedMonitoring"
            };
            body = JSON.stringify(serializeAws_json1_1EnableEnhancedMonitoringInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetRecordsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetRecords"
            };
            body = JSON.stringify(serializeAws_json1_1GetRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1GetShardIteratorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.GetShardIterator"
            };
            body = JSON.stringify(serializeAws_json1_1GetShardIteratorInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.IncreaseStreamRetentionPeriod"
            };
            body = JSON.stringify(serializeAws_json1_1IncreaseStreamRetentionPeriodInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListShardsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListShards"
            };
            body = JSON.stringify(serializeAws_json1_1ListShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamConsumersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreamConsumers"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamConsumersInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.ListTagsForStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1MergeShardsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.MergeShards"
            };
            body = JSON.stringify(serializeAws_json1_1MergeShardsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.PutRecords"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RegisterStreamConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RegisterStreamConsumer"
            };
            body = JSON.stringify(serializeAws_json1_1RegisterStreamConsumerInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1RemoveTagsFromStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.RemoveTagsFromStream"
            };
            body = JSON.stringify(serializeAws_json1_1RemoveTagsFromStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SplitShardCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SplitShard"
            };
            body = JSON.stringify(serializeAws_json1_1SplitShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StartStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.StopStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1SubscribeToShardCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.SubscribeToShard"
            };
            body = JSON.stringify(serializeAws_json1_1SubscribeToShardInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateShardCountCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Kinesis_20131202.UpdateShardCount"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateShardCountInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1AddTagsToStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1AddTagsToStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DecreaseStreamRetentionPeriodCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeregisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeregisterStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeLimitsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeLimitsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeLimitsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeStreamSummaryCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeStreamSummaryOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeStreamSummaryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DisableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DisableEnhancedMonitoringCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1EnableEnhancedMonitoringCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1EnhancedMonitoringOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1EnableEnhancedMonitoringCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetRecordsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredIteratorException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredIteratorExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1GetShardIteratorCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1GetShardIteratorOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1GetShardIteratorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1IncreaseStreamRetentionPeriodCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListShardsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListShardsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamConsumersCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamConsumersOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamConsumersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#ExpiredNextTokenException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ExpiredNextTokenExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1MergeShardsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1MergeShardsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, parsedBody, message;
        var _m;
        return (0, _tslib.__generator)(this, function(_o) {
            switch(_o.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _m = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_m.body = _o.sent(), _m)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#ProvisionedThroughputExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        20
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _o.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        21
                    ];
                case 20:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _o.label = 21;
                case 21:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RegisterStreamConsumerCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1RegisterStreamConsumerOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RegisterStreamConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1RemoveTagsFromStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1RemoveTagsFromStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SplitShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SplitShardCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, parsedBody, message;
        var _o;
        return (0, _tslib.__generator)(this, function(_p) {
            switch(_p.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _o = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_o.body = _p.sent(), _o)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#KMSAccessDeniedException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#KMSDisabledException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#KMSInvalidStateException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.kinesis#KMSNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "com.amazonaws.kinesis#KMSOptInRequired":
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case "KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "com.amazonaws.kinesis#KMSThrottlingException":
                            return [
                                3 /*break*/ ,
                                14
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                20
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        22
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSAccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSDisabledExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSInvalidStateExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 12:
                    _h = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSOptInRequiredResponse(parsedOutput, context)
                    ];
                case 13:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _h.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 14:
                    _j = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1KMSThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _j.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 16:
                    _k = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _k.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 18:
                    _l = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _l.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 20:
                    _m = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _m.concat([
                            _p.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        23
                    ];
                case 22:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _p.label = 23;
                case 23:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    response = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1SubscribeToShardCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1SubscribeToShardOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1SubscribeToShardCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateShardCountCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateShardCountOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateShardCountCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.kinesis#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.kinesis#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.kinesis#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.kinesis#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ExpiredIteratorExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredIteratorException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredIteratorException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ExpiredNextTokenExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ExpiredNextTokenException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ExpiredNextTokenException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSAccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSAccessDeniedException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSAccessDeniedException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSDisabledExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSDisabledException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSDisabledException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSInvalidStateExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSInvalidStateException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSInvalidStateException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSOptInRequiredResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSOptInRequired(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSOptInRequired",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1KMSThrottlingExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1KMSThrottlingException(body, context);
            contents = (0, _tslib.__assign)({
                name: "KMSThrottlingException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ProvisionedThroughputExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ProvisionedThroughputExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1AddTagsToStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagMap(input.Tags, context)
    });
};
var serializeAws_json1_1CreateStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardCount !== undefined && input.ShardCount !== null && {
        ShardCount: input.ShardCount
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DecreaseStreamRetentionPeriodInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeleteStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.EnforceConsumerDeletion !== undefined && input.EnforceConsumerDeletion !== null && {
        EnforceConsumerDeletion: input.EnforceConsumerDeletion
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DeregisterStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeLimitsInput = function(input, context) {
    return {};
};
var serializeAws_json1_1DescribeStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1DescribeStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DescribeStreamSummaryInput = function(input, context) {
    return (0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1DisableEnhancedMonitoringInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1EnableEnhancedMonitoringInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardLevelMetrics !== undefined && input.ShardLevelMetrics !== null && {
        ShardLevelMetrics: serializeAws_json1_1MetricsNameList(input.ShardLevelMetrics, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1GetRecordsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.ShardIterator !== undefined && input.ShardIterator !== null && {
        ShardIterator: input.ShardIterator
    });
};
var serializeAws_json1_1GetShardIteratorInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.ShardIteratorType !== undefined && input.ShardIteratorType !== null && {
        ShardIteratorType: input.ShardIteratorType
    }), input.StartingSequenceNumber !== undefined && input.StartingSequenceNumber !== null && {
        StartingSequenceNumber: input.StartingSequenceNumber
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1IncreaseStreamRetentionPeriodInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.RetentionPeriodHours !== undefined && input.RetentionPeriodHours !== null && {
        RetentionPeriodHours: input.RetentionPeriodHours
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListShardsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartShardId !== undefined && input.ExclusiveStartShardId !== null && {
        ExclusiveStartShardId: input.ExclusiveStartShardId
    }), input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.ShardFilter !== undefined && input.ShardFilter !== null && {
        ShardFilter: serializeAws_json1_1ShardFilter(input.ShardFilter, context)
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1ListStreamConsumersInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults !== undefined && input.MaxResults !== null && {
        MaxResults: input.MaxResults
    }), input.NextToken !== undefined && input.NextToken !== null && {
        NextToken: input.NextToken
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    }), input.StreamCreationTimestamp !== undefined && input.StreamCreationTimestamp !== null && {
        StreamCreationTimestamp: Math.round(input.StreamCreationTimestamp.getTime() / 1000)
    });
};
var serializeAws_json1_1ListStreamsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartStreamName !== undefined && input.ExclusiveStartStreamName !== null && {
        ExclusiveStartStreamName: input.ExclusiveStartStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListTagsForStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MergeShardsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AdjacentShardToMerge !== undefined && input.AdjacentShardToMerge !== null && {
        AdjacentShardToMerge: input.AdjacentShardToMerge
    }), input.ShardToMerge !== undefined && input.ShardToMerge !== null && {
        ShardToMerge: input.ShardToMerge
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1MetricsNameList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1PutRecordInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    }), input.SequenceNumberForOrdering !== undefined && input.SequenceNumberForOrdering !== null && {
        SequenceNumberForOrdering: input.SequenceNumberForOrdering
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordsRequestEntryList(input.Records, context)
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1PutRecordsRequestEntry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    }), input.ExplicitHashKey !== undefined && input.ExplicitHashKey !== null && {
        ExplicitHashKey: input.ExplicitHashKey
    }), input.PartitionKey !== undefined && input.PartitionKey !== null && {
        PartitionKey: input.PartitionKey
    });
};
var serializeAws_json1_1PutRecordsRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1PutRecordsRequestEntry(entry, context);
    });
};
var serializeAws_json1_1RegisterStreamConsumerInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerName !== undefined && input.ConsumerName !== null && {
        ConsumerName: input.ConsumerName
    }), input.StreamARN !== undefined && input.StreamARN !== null && {
        StreamARN: input.StreamARN
    });
};
var serializeAws_json1_1RemoveTagsFromStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1ShardFilter = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1SplitShardInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.NewStartingHashKey !== undefined && input.NewStartingHashKey !== null && {
        NewStartingHashKey: input.NewStartingHashKey
    }), input.ShardToSplit !== undefined && input.ShardToSplit !== null && {
        ShardToSplit: input.ShardToSplit
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StartingPosition = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.SequenceNumber !== undefined && input.SequenceNumber !== null && {
        SequenceNumber: input.SequenceNumber
    }), input.Timestamp !== undefined && input.Timestamp !== null && {
        Timestamp: Math.round(input.Timestamp.getTime() / 1000)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1StartStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1StopStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EncryptionType !== undefined && input.EncryptionType !== null && {
        EncryptionType: input.EncryptionType
    }), input.KeyId !== undefined && input.KeyId !== null && {
        KeyId: input.KeyId
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    });
};
var serializeAws_json1_1SubscribeToShardInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ConsumerARN !== undefined && input.ConsumerARN !== null && {
        ConsumerARN: input.ConsumerARN
    }), input.ShardId !== undefined && input.ShardId !== null && {
        ShardId: input.ShardId
    }), input.StartingPosition !== undefined && input.StartingPosition !== null && {
        StartingPosition: serializeAws_json1_1StartingPosition(input.StartingPosition, context)
    });
};
var serializeAws_json1_1TagKeyList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1TagMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1UpdateShardCountInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.ScalingType !== undefined && input.ScalingType !== null && {
        ScalingType: input.ScalingType
    }), input.StreamName !== undefined && input.StreamName !== null && {
        StreamName: input.StreamName
    }), input.TargetShardCount !== undefined && input.TargetShardCount !== null && {
        TargetShardCount: input.TargetShardCount
    });
};
var deserializeAws_json1_1ChildShard = function(output, context) {
    return {
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShards: output.ParentShards !== undefined && output.ParentShards !== null ? deserializeAws_json1_1ShardIdList(output.ParentShards, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ChildShardList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ChildShard(entry, context);
    });
};
var deserializeAws_json1_1Consumer = function(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined
    };
};
var deserializeAws_json1_1ConsumerDescription = function(output, context) {
    return {
        ConsumerARN: output.ConsumerARN !== undefined && output.ConsumerARN !== null ? output.ConsumerARN : undefined,
        ConsumerCreationTimestamp: output.ConsumerCreationTimestamp !== undefined && output.ConsumerCreationTimestamp !== null ? new Date(Math.round(output.ConsumerCreationTimestamp * 1000)) : undefined,
        ConsumerName: output.ConsumerName !== undefined && output.ConsumerName !== null ? output.ConsumerName : undefined,
        ConsumerStatus: output.ConsumerStatus !== undefined && output.ConsumerStatus !== null ? output.ConsumerStatus : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined
    };
};
var deserializeAws_json1_1ConsumerList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Consumer(entry, context);
    });
};
var deserializeAws_json1_1DescribeLimitsOutput = function(output, context) {
    return {
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        ShardLimit: output.ShardLimit !== undefined && output.ShardLimit !== null ? output.ShardLimit : undefined
    };
};
var deserializeAws_json1_1DescribeStreamConsumerOutput = function(output, context) {
    return {
        ConsumerDescription: output.ConsumerDescription !== undefined && output.ConsumerDescription !== null ? deserializeAws_json1_1ConsumerDescription(output.ConsumerDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamOutput = function(output, context) {
    return {
        StreamDescription: output.StreamDescription !== undefined && output.StreamDescription !== null ? deserializeAws_json1_1StreamDescription(output.StreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1DescribeStreamSummaryOutput = function(output, context) {
    return {
        StreamDescriptionSummary: output.StreamDescriptionSummary !== undefined && output.StreamDescriptionSummary !== null ? deserializeAws_json1_1StreamDescriptionSummary(output.StreamDescriptionSummary, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMetrics = function(output, context) {
    return {
        ShardLevelMetrics: output.ShardLevelMetrics !== undefined && output.ShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.ShardLevelMetrics, context) : undefined
    };
};
var deserializeAws_json1_1EnhancedMonitoringList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1EnhancedMetrics(entry, context);
    });
};
var deserializeAws_json1_1EnhancedMonitoringOutput = function(output, context) {
    return {
        CurrentShardLevelMetrics: output.CurrentShardLevelMetrics !== undefined && output.CurrentShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.CurrentShardLevelMetrics, context) : undefined,
        DesiredShardLevelMetrics: output.DesiredShardLevelMetrics !== undefined && output.DesiredShardLevelMetrics !== null ? deserializeAws_json1_1MetricsNameList(output.DesiredShardLevelMetrics, context) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined
    };
};
var deserializeAws_json1_1ExpiredIteratorException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ExpiredNextTokenException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1GetRecordsOutput = function(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        NextShardIterator: output.NextShardIterator !== undefined && output.NextShardIterator !== null ? output.NextShardIterator : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1GetShardIteratorOutput = function(output, context) {
    return {
        ShardIterator: output.ShardIterator !== undefined && output.ShardIterator !== null ? output.ShardIterator : undefined
    };
};
var deserializeAws_json1_1HashKeyRange = function(output, context) {
    return {
        EndingHashKey: output.EndingHashKey !== undefined && output.EndingHashKey !== null ? output.EndingHashKey : undefined,
        StartingHashKey: output.StartingHashKey !== undefined && output.StartingHashKey !== null ? output.StartingHashKey : undefined
    };
};
var deserializeAws_json1_1InternalFailureException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSAccessDeniedException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSDisabledException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSInvalidStateException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSOptInRequired = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KMSThrottlingException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListShardsOutput = function(output, context) {
    return {
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined
    };
};
var deserializeAws_json1_1ListStreamConsumersOutput = function(output, context) {
    return {
        Consumers: output.Consumers !== undefined && output.Consumers !== null ? deserializeAws_json1_1ConsumerList(output.Consumers, context) : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined
    };
};
var deserializeAws_json1_1ListStreamsOutput = function(output, context) {
    return {
        HasMoreStreams: output.HasMoreStreams !== undefined && output.HasMoreStreams !== null ? output.HasMoreStreams : undefined,
        StreamNames: output.StreamNames !== undefined && output.StreamNames !== null ? deserializeAws_json1_1StreamNameList(output.StreamNames, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForStreamOutput = function(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1TagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1MetricsNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ProvisionedThroughputExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1PutRecordOutput = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsOutput = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        FailedRecordCount: output.FailedRecordCount !== undefined && output.FailedRecordCount !== null ? output.FailedRecordCount : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1PutRecordsResultEntryList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntry = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1PutRecordsResultEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordsResultEntry(entry, context);
    });
};
var deserializeAws_json1_1_Record = function(output, context) {
    return {
        ApproximateArrivalTimestamp: output.ApproximateArrivalTimestamp !== undefined && output.ApproximateArrivalTimestamp !== null ? new Date(Math.round(output.ApproximateArrivalTimestamp * 1000)) : undefined,
        Data: output.Data !== undefined && output.Data !== null ? context.base64Decoder(output.Data) : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        PartitionKey: output.PartitionKey !== undefined && output.PartitionKey !== null ? output.PartitionKey : undefined,
        SequenceNumber: output.SequenceNumber !== undefined && output.SequenceNumber !== null ? output.SequenceNumber : undefined
    };
};
var deserializeAws_json1_1RecordList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1_Record(entry, context);
    });
};
var deserializeAws_json1_1RegisterStreamConsumerOutput = function(output, context) {
    return {
        Consumer: output.Consumer !== undefined && output.Consumer !== null ? deserializeAws_json1_1Consumer(output.Consumer, context) : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SequenceNumberRange = function(output, context) {
    return {
        EndingSequenceNumber: output.EndingSequenceNumber !== undefined && output.EndingSequenceNumber !== null ? output.EndingSequenceNumber : undefined,
        StartingSequenceNumber: output.StartingSequenceNumber !== undefined && output.StartingSequenceNumber !== null ? output.StartingSequenceNumber : undefined
    };
};
var deserializeAws_json1_1Shard = function(output, context) {
    return {
        AdjacentParentShardId: output.AdjacentParentShardId !== undefined && output.AdjacentParentShardId !== null ? output.AdjacentParentShardId : undefined,
        HashKeyRange: output.HashKeyRange !== undefined && output.HashKeyRange !== null ? deserializeAws_json1_1HashKeyRange(output.HashKeyRange, context) : undefined,
        ParentShardId: output.ParentShardId !== undefined && output.ParentShardId !== null ? output.ParentShardId : undefined,
        SequenceNumberRange: output.SequenceNumberRange !== undefined && output.SequenceNumberRange !== null ? deserializeAws_json1_1SequenceNumberRange(output.SequenceNumberRange, context) : undefined,
        ShardId: output.ShardId !== undefined && output.ShardId !== null ? output.ShardId : undefined
    };
};
var deserializeAws_json1_1ShardIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ShardList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Shard(entry, context);
    });
};
var deserializeAws_json1_1StreamDescription = function(output, context) {
    return {
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        HasMoreShards: output.HasMoreShards !== undefined && output.HasMoreShards !== null ? output.HasMoreShards : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        Shards: output.Shards !== undefined && output.Shards !== null ? deserializeAws_json1_1ShardList(output.Shards, context) : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamDescriptionSummary = function(output, context) {
    return {
        ConsumerCount: output.ConsumerCount !== undefined && output.ConsumerCount !== null ? output.ConsumerCount : undefined,
        EncryptionType: output.EncryptionType !== undefined && output.EncryptionType !== null ? output.EncryptionType : undefined,
        EnhancedMonitoring: output.EnhancedMonitoring !== undefined && output.EnhancedMonitoring !== null ? deserializeAws_json1_1EnhancedMonitoringList(output.EnhancedMonitoring, context) : undefined,
        KeyId: output.KeyId !== undefined && output.KeyId !== null ? output.KeyId : undefined,
        OpenShardCount: output.OpenShardCount !== undefined && output.OpenShardCount !== null ? output.OpenShardCount : undefined,
        RetentionPeriodHours: output.RetentionPeriodHours !== undefined && output.RetentionPeriodHours !== null ? output.RetentionPeriodHours : undefined,
        StreamARN: output.StreamARN !== undefined && output.StreamARN !== null ? output.StreamARN : undefined,
        StreamCreationTimestamp: output.StreamCreationTimestamp !== undefined && output.StreamCreationTimestamp !== null ? new Date(Math.round(output.StreamCreationTimestamp * 1000)) : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        StreamStatus: output.StreamStatus !== undefined && output.StreamStatus !== null ? output.StreamStatus : undefined
    };
};
var deserializeAws_json1_1StreamNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1SubscribeToShardEvent = function(output, context) {
    return {
        ChildShards: output.ChildShards !== undefined && output.ChildShards !== null ? deserializeAws_json1_1ChildShardList(output.ChildShards, context) : undefined,
        ContinuationSequenceNumber: output.ContinuationSequenceNumber !== undefined && output.ContinuationSequenceNumber !== null ? output.ContinuationSequenceNumber : undefined,
        MillisBehindLatest: output.MillisBehindLatest !== undefined && output.MillisBehindLatest !== null ? output.MillisBehindLatest : undefined,
        Records: output.Records !== undefined && output.Records !== null ? deserializeAws_json1_1RecordList(output.Records, context) : undefined
    };
};
var deserializeAws_json1_1SubscribeToShardEventStream = function(output, context) {
    if (output.InternalFailureException !== undefined && output.InternalFailureException !== null) return {
        InternalFailureException: deserializeAws_json1_1InternalFailureException(output.InternalFailureException, context)
    };
    if (output.KMSAccessDeniedException !== undefined && output.KMSAccessDeniedException !== null) return {
        KMSAccessDeniedException: deserializeAws_json1_1KMSAccessDeniedException(output.KMSAccessDeniedException, context)
    };
    if (output.KMSDisabledException !== undefined && output.KMSDisabledException !== null) return {
        KMSDisabledException: deserializeAws_json1_1KMSDisabledException(output.KMSDisabledException, context)
    };
    if (output.KMSInvalidStateException !== undefined && output.KMSInvalidStateException !== null) return {
        KMSInvalidStateException: deserializeAws_json1_1KMSInvalidStateException(output.KMSInvalidStateException, context)
    };
    if (output.KMSNotFoundException !== undefined && output.KMSNotFoundException !== null) return {
        KMSNotFoundException: deserializeAws_json1_1KMSNotFoundException(output.KMSNotFoundException, context)
    };
    if (output.KMSOptInRequired !== undefined && output.KMSOptInRequired !== null) return {
        KMSOptInRequired: deserializeAws_json1_1KMSOptInRequired(output.KMSOptInRequired, context)
    };
    if (output.KMSThrottlingException !== undefined && output.KMSThrottlingException !== null) return {
        KMSThrottlingException: deserializeAws_json1_1KMSThrottlingException(output.KMSThrottlingException, context)
    };
    if (output.ResourceInUseException !== undefined && output.ResourceInUseException !== null) return {
        ResourceInUseException: deserializeAws_json1_1ResourceInUseException(output.ResourceInUseException, context)
    };
    if (output.ResourceNotFoundException !== undefined && output.ResourceNotFoundException !== null) return {
        ResourceNotFoundException: deserializeAws_json1_1ResourceNotFoundException(output.ResourceNotFoundException, context)
    };
    if (output.SubscribeToShardEvent !== undefined && output.SubscribeToShardEvent !== null) return {
        SubscribeToShardEvent: deserializeAws_json1_1SubscribeToShardEvent(output.SubscribeToShardEvent, context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
var deserializeAws_json1_1SubscribeToShardOutput = function(output, context) {
    return {
        EventStream: output.EventStream !== undefined && output.EventStream !== null ? deserializeAws_json1_1SubscribeToShardEventStream(output.EventStream, context) : undefined
    };
};
var deserializeAws_json1_1Tag = function(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1UpdateShardCountOutput = function(output, context) {
    return {
        CurrentShardCount: output.CurrentShardCount !== undefined && output.CurrentShardCount !== null ? output.CurrentShardCount : undefined,
        StreamName: output.StreamName !== undefined && output.StreamName !== null ? output.StreamName : undefined,
        TargetShardCount: output.TargetShardCount !== undefined && output.TargetShardCount !== null ? output.TargetShardCount : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxYWT":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSKinesisFirehoseProvider", ()=>AWSKinesisFirehoseProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _awskinesisProvider = require("./AWSKinesisProvider");
var _clientFirehose = require("@aws-sdk/client-firehose");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AWSKineisFirehoseProvider");
var AWSKinesisFirehoseProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSKinesisFirehoseProvider, _super);
    function AWSKinesisFirehoseProvider(config) {
        return _super.call(this, config) || this;
    }
    /**
     * get provider name of the plugin
     */ AWSKinesisFirehoseProvider.prototype.getProviderName = function() {
        return "AWSKinesisFirehose";
    };
    AWSKinesisFirehoseProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // split by streamName
            var evt = params.event;
            var streamName = evt.streamName, data = evt.data;
            if (records[streamName] === undefined) records[streamName] = [];
            var bufferData = data && typeof data !== "string" ? JSON.stringify(data) : data;
            var Data = (0, _utilUtf8Browser.fromUtf8)(bufferData);
            var record = {
                Data: Data
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            logger.debug("putting records to kinesis", streamName, "with records", records[streamName]);
            _this._kinesisFirehose.send(new (0, _clientFirehose.PutRecordBatchCommand)({
                Records: records[streamName],
                DeliveryStreamName: streamName
            })).then(function(res) {
                return logger.debug("Upload records to stream", streamName);
            }).catch(function(err) {
                return logger.debug("Failed to upload records to Kinesis", err);
            });
        });
    };
    AWSKinesisFirehoseProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._kinesisFirehose && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        return this._initFirehose(region, credentials);
    };
    AWSKinesisFirehoseProvider.prototype._initFirehose = function(region, credentials) {
        logger.debug("initialize kinesis firehose with credentials", credentials);
        this._kinesisFirehose = new (0, _clientFirehose.FirehoseClient)({
            apiVersion: "2015-08-04",
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    return AWSKinesisFirehoseProvider;
}((0, _awskinesisProvider.AWSKinesisProvider));

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","./AWSKinesisProvider":"2sXdp","@aws-sdk/client-firehose":"jfjSa","@aws-sdk/util-utf8-browser":"iZmxX","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jfjSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _firehoseClient = require("./FirehoseClient");
parcelHelpers.exportAll(_firehoseClient, exports);
var _firehose = require("./Firehose");
parcelHelpers.exportAll(_firehose, exports);
var _createDeliveryStreamCommand = require("./commands/CreateDeliveryStreamCommand");
parcelHelpers.exportAll(_createDeliveryStreamCommand, exports);
var _deleteDeliveryStreamCommand = require("./commands/DeleteDeliveryStreamCommand");
parcelHelpers.exportAll(_deleteDeliveryStreamCommand, exports);
var _describeDeliveryStreamCommand = require("./commands/DescribeDeliveryStreamCommand");
parcelHelpers.exportAll(_describeDeliveryStreamCommand, exports);
var _listDeliveryStreamsCommand = require("./commands/ListDeliveryStreamsCommand");
parcelHelpers.exportAll(_listDeliveryStreamsCommand, exports);
var _listTagsForDeliveryStreamCommand = require("./commands/ListTagsForDeliveryStreamCommand");
parcelHelpers.exportAll(_listTagsForDeliveryStreamCommand, exports);
var _putRecordCommand = require("./commands/PutRecordCommand");
parcelHelpers.exportAll(_putRecordCommand, exports);
var _putRecordBatchCommand = require("./commands/PutRecordBatchCommand");
parcelHelpers.exportAll(_putRecordBatchCommand, exports);
var _startDeliveryStreamEncryptionCommand = require("./commands/StartDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_startDeliveryStreamEncryptionCommand, exports);
var _stopDeliveryStreamEncryptionCommand = require("./commands/StopDeliveryStreamEncryptionCommand");
parcelHelpers.exportAll(_stopDeliveryStreamEncryptionCommand, exports);
var _tagDeliveryStreamCommand = require("./commands/TagDeliveryStreamCommand");
parcelHelpers.exportAll(_tagDeliveryStreamCommand, exports);
var _untagDeliveryStreamCommand = require("./commands/UntagDeliveryStreamCommand");
parcelHelpers.exportAll(_untagDeliveryStreamCommand, exports);
var _updateDestinationCommand = require("./commands/UpdateDestinationCommand");
parcelHelpers.exportAll(_updateDestinationCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./FirehoseClient":"9eNrP","./Firehose":false,"./commands/CreateDeliveryStreamCommand":false,"./commands/DeleteDeliveryStreamCommand":false,"./commands/DescribeDeliveryStreamCommand":false,"./commands/ListDeliveryStreamsCommand":false,"./commands/ListTagsForDeliveryStreamCommand":false,"./commands/PutRecordCommand":false,"./commands/PutRecordBatchCommand":"lLpZW","./commands/StartDeliveryStreamEncryptionCommand":false,"./commands/StopDeliveryStreamEncryptionCommand":false,"./commands/TagDeliveryStreamCommand":false,"./commands/UntagDeliveryStreamCommand":false,"./commands/UpdateDestinationCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eNrP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirehoseClient", ()=>FirehoseClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <fullname>Amazon Kinesis Data Firehose API Reference</fullname>
 *          <p>Amazon Kinesis Data Firehose is a fully managed service that delivers real-time
 *          streaming data to destinations such as Amazon Simple Storage Service (Amazon S3), Amazon
 *          Elasticsearch Service (Amazon ES), Amazon Redshift, and Splunk.</p>
 */ var FirehoseClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(FirehoseClient, _super);
    function FirehoseClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    FirehoseClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return FirehoseClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"3z64N","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3z64N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"hBp6e","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"hOYXY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hBp6e":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-firehose","description":"AWS SDK for JavaScript Firehose Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-firehose","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-firehose"}}');

},{}],"hOYXY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2015-08-04",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Firehose",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"lNb4h","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lNb4h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "firehose.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "firehose.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "firehose.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "firehose.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "firehose.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    switch(region){
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "firehose.af-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "firehose.ap-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "firehose.ap-northeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "firehose.ap-northeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "firehose.ap-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "firehose.ap-southeast-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "firehose.ap-southeast-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "firehose.ca-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "firehose.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "firehose.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn"
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "firehose.eu-central-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "firehose.eu-north-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "firehose.eu-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "firehose.eu-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "firehose.eu-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "firehose.eu-west-3.amazonaws.com",
                partition: "aws"
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1"
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "firehose-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2"
            };
            break;
        case "fips-us-gov-east-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1"
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1"
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "firehose-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1"
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "firehose-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2"
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "firehose.me-south-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "firehose.sa-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "firehose.us-east-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "firehose.us-east-2.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "firehose.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "firehose.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov"
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "firehose.us-west-1.amazonaws.com",
                partition: "aws"
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "firehose.us-west-2.amazonaws.com",
                partition: "aws"
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
            if (AWS_CN_REGIONS.has(region)) regionInfo = {
                hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                partition: "aws-cn"
            };
            if (AWS_ISO_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                partition: "aws-iso"
            };
            if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
                hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                partition: "aws-iso-b"
            };
            if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
                hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                partition: "aws-us-gov"
            };
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) regionInfo = {
                hostname: AWS_TEMPLATE.replace("{region}", region),
                partition: "aws"
            };
    }
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "firehose"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLpZW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutRecordBatchCommand", ()=>PutRecordBatchCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsJson11 = require("../protocols/Aws_json1_1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Writes multiple data records into a delivery stream in a single call, which can
 *          achieve higher throughput per producer than when writing single records. To write single
 *          data records into a delivery stream, use <a>PutRecord</a>. Applications using
 *          these operations are referred to as producers.</p>
 *          <p>For information about service quota, see <a href="https://docs.aws.amazon.com/firehose/latest/dev/limits.html">Amazon Kinesis Data Firehose
 *          Quota</a>.</p>
 *          <p>Each <a>PutRecordBatch</a> request supports up to 500 records. Each record
 *          in the request can be as large as 1,000 KB (before 64-bit encoding), up to a limit of 4 MB
 *          for the entire request. These limits cannot be changed.</p>
 *          <p>You must specify the name of the delivery stream and the data record when using <a>PutRecord</a>. The data record consists of a data blob that can be up to 1,000
 *          KB in size, and any kind of data. For example, it could be a segment from a log file,
 *          geographic location data, website clickstream data, and so on.</p>
 *          <p>Kinesis Data Firehose buffers records before delivering them to the destination. To
 *          disambiguate the data blobs at the destination, a common solution is to use delimiters in
 *          the data, such as a newline (<code>\n</code>) or some other character unique within the
 *          data. This allows the consumer application to parse individual data items when reading the
 *          data from the destination.</p>
 *          <p>The <a>PutRecordBatch</a> response includes a count of failed records,
 *             <code>FailedPutCount</code>, and an array of responses, <code>RequestResponses</code>.
 *          Even if the <a>PutRecordBatch</a> call succeeds, the value of
 *             <code>FailedPutCount</code> may be greater than 0, indicating that there are records for
 *          which the operation didn't succeed. Each entry in the <code>RequestResponses</code> array
 *          provides additional information about the processed record. It directly correlates with a
 *          record in the request array using the same ordering, from the top to the bottom. The
 *          response array always includes the same number of records as the request array.
 *             <code>RequestResponses</code> includes both successfully and unsuccessfully processed
 *          records. Kinesis Data Firehose tries to process all records in each <a>PutRecordBatch</a> request. A single record failure does not stop the processing
 *          of subsequent records. </p>
 *          <p>A successfully processed record includes a <code>RecordId</code> value, which is
 *          unique for the record. An unsuccessfully processed record includes <code>ErrorCode</code>
 *          and <code>ErrorMessage</code> values. <code>ErrorCode</code> reflects the type of error,
 *          and is one of the following values: <code>ServiceUnavailableException</code> or
 *             <code>InternalFailure</code>. <code>ErrorMessage</code> provides more detailed
 *          information about the error.</p>
 *          <p>If there is an internal server error or a timeout, the write might have completed or
 *          it might have failed. If <code>FailedPutCount</code> is greater than 0, retry the request,
 *          resending only those records that might have failed processing. This minimizes the possible
 *          duplicate records and also reduces the total bytes sent (and corresponding charges). We
 *          recommend that you handle any duplicates at the destination.</p>
 *          <p>If <a>PutRecordBatch</a> throws <code>ServiceUnavailableException</code>,
 *          back off and retry. If the exception persists, it is possible that the throughput limits
 *          have been exceeded for the delivery stream.</p>
 *
 *          <p>Data records sent to Kinesis Data Firehose are stored for 24 hours from the time they
 *          are added to a delivery stream as it attempts to send the records to the destination. If
 *          the destination is unreachable for more than 24 hours, the data is no longer
 *          available.</p>
 *          <important>
 *             <p>Don't concatenate two or more base64 strings to form the data fields of your records.
 *             Instead, concatenate the raw data, then perform base64 encoding.</p>
 *          </important>
 */ var PutRecordBatchCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutRecordBatchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordBatchCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutRecordBatchCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "PutRecordBatchCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutRecordBatchInput).filterSensitiveLog,
            outputFilterSensitiveLog: (0, _models0.PutRecordBatchOutput).filterSensitiveLog
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordBatchCommand.prototype.serialize = function(input, context) {
        return (0, _awsJson11.serializeAws_json1_1PutRecordBatchCommand)(input, context);
    };
    PutRecordBatchCommand.prototype.deserialize = function(output, context) {
        return (0, _awsJson11.deserializeAws_json1_1PutRecordBatchCommand)(output, context);
    };
    return PutRecordBatchCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"cGmm8","../protocols/Aws_json1_1":"lKm6X","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGmm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferingHints", ()=>BufferingHints);
parcelHelpers.export(exports, "CloudWatchLoggingOptions", ()=>CloudWatchLoggingOptions);
parcelHelpers.export(exports, "CompressionFormat", ()=>CompressionFormat);
parcelHelpers.export(exports, "ConcurrentModificationException", ()=>ConcurrentModificationException);
parcelHelpers.export(exports, "ContentEncoding", ()=>ContentEncoding);
parcelHelpers.export(exports, "CopyCommand", ()=>CopyCommand);
parcelHelpers.export(exports, "KeyType", ()=>KeyType);
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfigurationInput", ()=>DeliveryStreamEncryptionConfigurationInput);
parcelHelpers.export(exports, "ElasticsearchBufferingHints", ()=>ElasticsearchBufferingHints);
parcelHelpers.export(exports, "ProcessorParameterName", ()=>ProcessorParameterName);
parcelHelpers.export(exports, "ProcessorParameter", ()=>ProcessorParameter);
parcelHelpers.export(exports, "Processor", ()=>Processor);
parcelHelpers.export(exports, "ProcessingConfiguration", ()=>ProcessingConfiguration);
parcelHelpers.export(exports, "ElasticsearchRetryOptions", ()=>ElasticsearchRetryOptions);
parcelHelpers.export(exports, "KMSEncryptionConfig", ()=>KMSEncryptionConfig);
parcelHelpers.export(exports, "EncryptionConfiguration", ()=>EncryptionConfiguration);
parcelHelpers.export(exports, "S3DestinationConfiguration", ()=>S3DestinationConfiguration);
parcelHelpers.export(exports, "VpcConfiguration", ()=>VpcConfiguration);
parcelHelpers.export(exports, "ElasticsearchDestinationConfiguration", ()=>ElasticsearchDestinationConfiguration);
parcelHelpers.export(exports, "HiveJsonSerDe", ()=>HiveJsonSerDe);
parcelHelpers.export(exports, "OpenXJsonSerDe", ()=>OpenXJsonSerDe);
parcelHelpers.export(exports, "Deserializer", ()=>Deserializer);
parcelHelpers.export(exports, "InputFormatConfiguration", ()=>InputFormatConfiguration);
parcelHelpers.export(exports, "OrcCompression", ()=>OrcCompression);
parcelHelpers.export(exports, "OrcFormatVersion", ()=>OrcFormatVersion);
parcelHelpers.export(exports, "OrcSerDe", ()=>OrcSerDe);
parcelHelpers.export(exports, "ParquetCompression", ()=>ParquetCompression);
parcelHelpers.export(exports, "ParquetWriterVersion", ()=>ParquetWriterVersion);
parcelHelpers.export(exports, "ParquetSerDe", ()=>ParquetSerDe);
parcelHelpers.export(exports, "Serializer", ()=>Serializer);
parcelHelpers.export(exports, "OutputFormatConfiguration", ()=>OutputFormatConfiguration);
parcelHelpers.export(exports, "SchemaConfiguration", ()=>SchemaConfiguration);
parcelHelpers.export(exports, "DataFormatConversionConfiguration", ()=>DataFormatConversionConfiguration);
parcelHelpers.export(exports, "ExtendedS3DestinationConfiguration", ()=>ExtendedS3DestinationConfiguration);
parcelHelpers.export(exports, "HttpEndpointBufferingHints", ()=>HttpEndpointBufferingHints);
parcelHelpers.export(exports, "HttpEndpointConfiguration", ()=>HttpEndpointConfiguration);
parcelHelpers.export(exports, "HttpEndpointCommonAttribute", ()=>HttpEndpointCommonAttribute);
parcelHelpers.export(exports, "HttpEndpointRequestConfiguration", ()=>HttpEndpointRequestConfiguration);
parcelHelpers.export(exports, "HttpEndpointRetryOptions", ()=>HttpEndpointRetryOptions);
parcelHelpers.export(exports, "HttpEndpointDestinationConfiguration", ()=>HttpEndpointDestinationConfiguration);
parcelHelpers.export(exports, "KinesisStreamSourceConfiguration", ()=>KinesisStreamSourceConfiguration);
parcelHelpers.export(exports, "RedshiftRetryOptions", ()=>RedshiftRetryOptions);
parcelHelpers.export(exports, "RedshiftDestinationConfiguration", ()=>RedshiftDestinationConfiguration);
parcelHelpers.export(exports, "SplunkRetryOptions", ()=>SplunkRetryOptions);
parcelHelpers.export(exports, "SplunkDestinationConfiguration", ()=>SplunkDestinationConfiguration);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "CreateDeliveryStreamInput", ()=>CreateDeliveryStreamInput);
parcelHelpers.export(exports, "CreateDeliveryStreamOutput", ()=>CreateDeliveryStreamOutput);
parcelHelpers.export(exports, "InvalidArgumentException", ()=>InvalidArgumentException);
parcelHelpers.export(exports, "InvalidKMSResourceException", ()=>InvalidKMSResourceException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "ResourceInUseException", ()=>ResourceInUseException);
parcelHelpers.export(exports, "DeleteDeliveryStreamInput", ()=>DeleteDeliveryStreamInput);
parcelHelpers.export(exports, "DeleteDeliveryStreamOutput", ()=>DeleteDeliveryStreamOutput);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "DeliveryStreamFailureType", ()=>DeliveryStreamFailureType);
parcelHelpers.export(exports, "FailureDescription", ()=>FailureDescription);
parcelHelpers.export(exports, "DeliveryStreamEncryptionStatus", ()=>DeliveryStreamEncryptionStatus);
parcelHelpers.export(exports, "DeliveryStreamEncryptionConfiguration", ()=>DeliveryStreamEncryptionConfiguration);
parcelHelpers.export(exports, "DeliveryStreamStatus", ()=>DeliveryStreamStatus);
parcelHelpers.export(exports, "S3DestinationDescription", ()=>S3DestinationDescription);
parcelHelpers.export(exports, "VpcConfigurationDescription", ()=>VpcConfigurationDescription);
parcelHelpers.export(exports, "ElasticsearchDestinationDescription", ()=>ElasticsearchDestinationDescription);
parcelHelpers.export(exports, "ExtendedS3DestinationDescription", ()=>ExtendedS3DestinationDescription);
parcelHelpers.export(exports, "HttpEndpointDescription", ()=>HttpEndpointDescription);
parcelHelpers.export(exports, "HttpEndpointDestinationDescription", ()=>HttpEndpointDestinationDescription);
parcelHelpers.export(exports, "RedshiftDestinationDescription", ()=>RedshiftDestinationDescription);
parcelHelpers.export(exports, "SplunkDestinationDescription", ()=>SplunkDestinationDescription);
parcelHelpers.export(exports, "DestinationDescription", ()=>DestinationDescription);
parcelHelpers.export(exports, "KinesisStreamSourceDescription", ()=>KinesisStreamSourceDescription);
parcelHelpers.export(exports, "SourceDescription", ()=>SourceDescription);
parcelHelpers.export(exports, "DeliveryStreamDescription", ()=>DeliveryStreamDescription);
parcelHelpers.export(exports, "DescribeDeliveryStreamInput", ()=>DescribeDeliveryStreamInput);
parcelHelpers.export(exports, "DescribeDeliveryStreamOutput", ()=>DescribeDeliveryStreamOutput);
parcelHelpers.export(exports, "S3DestinationUpdate", ()=>S3DestinationUpdate);
parcelHelpers.export(exports, "ElasticsearchDestinationUpdate", ()=>ElasticsearchDestinationUpdate);
parcelHelpers.export(exports, "ExtendedS3DestinationUpdate", ()=>ExtendedS3DestinationUpdate);
parcelHelpers.export(exports, "ListDeliveryStreamsInput", ()=>ListDeliveryStreamsInput);
parcelHelpers.export(exports, "ListDeliveryStreamsOutput", ()=>ListDeliveryStreamsOutput);
parcelHelpers.export(exports, "ListTagsForDeliveryStreamInput", ()=>ListTagsForDeliveryStreamInput);
parcelHelpers.export(exports, "ListTagsForDeliveryStreamOutput", ()=>ListTagsForDeliveryStreamOutput);
parcelHelpers.export(exports, "_Record", ()=>_Record);
parcelHelpers.export(exports, "PutRecordInput", ()=>PutRecordInput);
parcelHelpers.export(exports, "PutRecordOutput", ()=>PutRecordOutput);
parcelHelpers.export(exports, "ServiceUnavailableException", ()=>ServiceUnavailableException);
parcelHelpers.export(exports, "PutRecordBatchInput", ()=>PutRecordBatchInput);
parcelHelpers.export(exports, "PutRecordBatchResponseEntry", ()=>PutRecordBatchResponseEntry);
parcelHelpers.export(exports, "PutRecordBatchOutput", ()=>PutRecordBatchOutput);
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionInput", ()=>StartDeliveryStreamEncryptionInput);
parcelHelpers.export(exports, "StartDeliveryStreamEncryptionOutput", ()=>StartDeliveryStreamEncryptionOutput);
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionInput", ()=>StopDeliveryStreamEncryptionInput);
parcelHelpers.export(exports, "StopDeliveryStreamEncryptionOutput", ()=>StopDeliveryStreamEncryptionOutput);
parcelHelpers.export(exports, "TagDeliveryStreamInput", ()=>TagDeliveryStreamInput);
parcelHelpers.export(exports, "TagDeliveryStreamOutput", ()=>TagDeliveryStreamOutput);
parcelHelpers.export(exports, "UntagDeliveryStreamInput", ()=>UntagDeliveryStreamInput);
parcelHelpers.export(exports, "UntagDeliveryStreamOutput", ()=>UntagDeliveryStreamOutput);
parcelHelpers.export(exports, "HttpEndpointDestinationUpdate", ()=>HttpEndpointDestinationUpdate);
parcelHelpers.export(exports, "RedshiftDestinationUpdate", ()=>RedshiftDestinationUpdate);
parcelHelpers.export(exports, "SplunkDestinationUpdate", ()=>SplunkDestinationUpdate);
parcelHelpers.export(exports, "UpdateDestinationInput", ()=>UpdateDestinationInput);
parcelHelpers.export(exports, "UpdateDestinationOutput", ()=>UpdateDestinationOutput);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var BufferingHints;
(function(BufferingHints) {
    BufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(BufferingHints || (BufferingHints = {}));
var CloudWatchLoggingOptions;
(function(CloudWatchLoggingOptions) {
    CloudWatchLoggingOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CloudWatchLoggingOptions || (CloudWatchLoggingOptions = {}));
var CompressionFormat;
(function(CompressionFormat) {
    CompressionFormat["GZIP"] = "GZIP";
    CompressionFormat["HADOOP_SNAPPY"] = "HADOOP_SNAPPY";
    CompressionFormat["SNAPPY"] = "Snappy";
    CompressionFormat["UNCOMPRESSED"] = "UNCOMPRESSED";
    CompressionFormat["ZIP"] = "ZIP";
})(CompressionFormat || (CompressionFormat = {}));
var ConcurrentModificationException;
(function(ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
var ContentEncoding;
(function(ContentEncoding) {
    ContentEncoding["GZIP"] = "GZIP";
    ContentEncoding["NONE"] = "NONE";
})(ContentEncoding || (ContentEncoding = {}));
var CopyCommand;
(function(CopyCommand) {
    CopyCommand.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CopyCommand || (CopyCommand = {}));
var KeyType;
(function(KeyType) {
    KeyType["AWS_OWNED_CMK"] = "AWS_OWNED_CMK";
    KeyType["CUSTOMER_MANAGED_CMK"] = "CUSTOMER_MANAGED_CMK";
})(KeyType || (KeyType = {}));
var DeliveryStreamEncryptionConfigurationInput;
(function(DeliveryStreamEncryptionConfigurationInput) {
    DeliveryStreamEncryptionConfigurationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfigurationInput || (DeliveryStreamEncryptionConfigurationInput = {}));
var ElasticsearchBufferingHints;
(function(ElasticsearchBufferingHints) {
    ElasticsearchBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchBufferingHints || (ElasticsearchBufferingHints = {}));
var ProcessorParameterName;
(function(ProcessorParameterName) {
    ProcessorParameterName["BUFFER_INTERVAL_IN_SECONDS"] = "BufferIntervalInSeconds";
    ProcessorParameterName["BUFFER_SIZE_IN_MB"] = "BufferSizeInMBs";
    ProcessorParameterName["LAMBDA_ARN"] = "LambdaArn";
    ProcessorParameterName["LAMBDA_NUMBER_OF_RETRIES"] = "NumberOfRetries";
    ProcessorParameterName["ROLE_ARN"] = "RoleArn";
})(ProcessorParameterName || (ProcessorParameterName = {}));
var ProcessorParameter;
(function(ProcessorParameter) {
    ProcessorParameter.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessorParameter || (ProcessorParameter = {}));
var Processor;
(function(Processor) {
    Processor.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Processor || (Processor = {}));
var ProcessingConfiguration;
(function(ProcessingConfiguration) {
    ProcessingConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ProcessingConfiguration || (ProcessingConfiguration = {}));
var ElasticsearchRetryOptions;
(function(ElasticsearchRetryOptions) {
    ElasticsearchRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchRetryOptions || (ElasticsearchRetryOptions = {}));
var KMSEncryptionConfig;
(function(KMSEncryptionConfig) {
    KMSEncryptionConfig.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KMSEncryptionConfig || (KMSEncryptionConfig = {}));
var EncryptionConfiguration;
(function(EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
var S3DestinationConfiguration;
(function(S3DestinationConfiguration) {
    S3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationConfiguration || (S3DestinationConfiguration = {}));
var VpcConfiguration;
(function(VpcConfiguration) {
    VpcConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfiguration || (VpcConfiguration = {}));
var ElasticsearchDestinationConfiguration;
(function(ElasticsearchDestinationConfiguration) {
    ElasticsearchDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationConfiguration || (ElasticsearchDestinationConfiguration = {}));
var HiveJsonSerDe;
(function(HiveJsonSerDe) {
    HiveJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HiveJsonSerDe || (HiveJsonSerDe = {}));
var OpenXJsonSerDe;
(function(OpenXJsonSerDe) {
    OpenXJsonSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OpenXJsonSerDe || (OpenXJsonSerDe = {}));
var Deserializer;
(function(Deserializer) {
    Deserializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Deserializer || (Deserializer = {}));
var InputFormatConfiguration;
(function(InputFormatConfiguration) {
    InputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InputFormatConfiguration || (InputFormatConfiguration = {}));
var OrcCompression;
(function(OrcCompression) {
    OrcCompression["NONE"] = "NONE";
    OrcCompression["SNAPPY"] = "SNAPPY";
    OrcCompression["ZLIB"] = "ZLIB";
})(OrcCompression || (OrcCompression = {}));
var OrcFormatVersion;
(function(OrcFormatVersion) {
    OrcFormatVersion["V0_11"] = "V0_11";
    OrcFormatVersion["V0_12"] = "V0_12";
})(OrcFormatVersion || (OrcFormatVersion = {}));
var OrcSerDe;
(function(OrcSerDe) {
    OrcSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OrcSerDe || (OrcSerDe = {}));
var ParquetCompression;
(function(ParquetCompression) {
    ParquetCompression["GZIP"] = "GZIP";
    ParquetCompression["SNAPPY"] = "SNAPPY";
    ParquetCompression["UNCOMPRESSED"] = "UNCOMPRESSED";
})(ParquetCompression || (ParquetCompression = {}));
var ParquetWriterVersion;
(function(ParquetWriterVersion) {
    ParquetWriterVersion["V1"] = "V1";
    ParquetWriterVersion["V2"] = "V2";
})(ParquetWriterVersion || (ParquetWriterVersion = {}));
var ParquetSerDe;
(function(ParquetSerDe) {
    ParquetSerDe.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ParquetSerDe || (ParquetSerDe = {}));
var Serializer;
(function(Serializer) {
    Serializer.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Serializer || (Serializer = {}));
var OutputFormatConfiguration;
(function(OutputFormatConfiguration) {
    OutputFormatConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(OutputFormatConfiguration || (OutputFormatConfiguration = {}));
var SchemaConfiguration;
(function(SchemaConfiguration) {
    SchemaConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SchemaConfiguration || (SchemaConfiguration = {}));
var DataFormatConversionConfiguration;
(function(DataFormatConversionConfiguration) {
    DataFormatConversionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DataFormatConversionConfiguration || (DataFormatConversionConfiguration = {}));
var ExtendedS3DestinationConfiguration;
(function(ExtendedS3DestinationConfiguration) {
    ExtendedS3DestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationConfiguration || (ExtendedS3DestinationConfiguration = {}));
var HttpEndpointBufferingHints;
(function(HttpEndpointBufferingHints) {
    HttpEndpointBufferingHints.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointBufferingHints || (HttpEndpointBufferingHints = {}));
var HttpEndpointConfiguration;
(function(HttpEndpointConfiguration) {
    HttpEndpointConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AccessKey && {
            AccessKey: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointConfiguration || (HttpEndpointConfiguration = {}));
var HttpEndpointCommonAttribute;
(function(HttpEndpointCommonAttribute) {
    HttpEndpointCommonAttribute.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.AttributeName && {
            AttributeName: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.AttributeValue && {
            AttributeValue: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointCommonAttribute || (HttpEndpointCommonAttribute = {}));
var HttpEndpointRequestConfiguration;
(function(HttpEndpointRequestConfiguration) {
    HttpEndpointRequestConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.CommonAttributes && {
            CommonAttributes: obj.CommonAttributes.map(function(item) {
                return HttpEndpointCommonAttribute.filterSensitiveLog(item);
            })
        });
    };
})(HttpEndpointRequestConfiguration || (HttpEndpointRequestConfiguration = {}));
var HttpEndpointRetryOptions;
(function(HttpEndpointRetryOptions) {
    HttpEndpointRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(HttpEndpointRetryOptions || (HttpEndpointRetryOptions = {}));
var HttpEndpointDestinationConfiguration;
(function(HttpEndpointDestinationConfiguration) {
    HttpEndpointDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationConfiguration || (HttpEndpointDestinationConfiguration = {}));
var KinesisStreamSourceConfiguration;
(function(KinesisStreamSourceConfiguration) {
    KinesisStreamSourceConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceConfiguration || (KinesisStreamSourceConfiguration = {}));
var RedshiftRetryOptions;
(function(RedshiftRetryOptions) {
    RedshiftRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(RedshiftRetryOptions || (RedshiftRetryOptions = {}));
var RedshiftDestinationConfiguration;
(function(RedshiftDestinationConfiguration) {
    RedshiftDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationConfiguration || (RedshiftDestinationConfiguration = {}));
var SplunkRetryOptions;
(function(SplunkRetryOptions) {
    SplunkRetryOptions.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkRetryOptions || (SplunkRetryOptions = {}));
var SplunkDestinationConfiguration;
(function(SplunkDestinationConfiguration) {
    SplunkDestinationConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationConfiguration || (SplunkDestinationConfiguration = {}));
var Tag;
(function(Tag) {
    Tag.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Tag || (Tag = {}));
var CreateDeliveryStreamInput;
(function(CreateDeliveryStreamInput) {
    CreateDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationConfiguration && {
            RedshiftDestinationConfiguration: RedshiftDestinationConfiguration.filterSensitiveLog(obj.RedshiftDestinationConfiguration)
        }), obj.HttpEndpointDestinationConfiguration && {
            HttpEndpointDestinationConfiguration: HttpEndpointDestinationConfiguration.filterSensitiveLog(obj.HttpEndpointDestinationConfiguration)
        });
    };
})(CreateDeliveryStreamInput || (CreateDeliveryStreamInput = {}));
var CreateDeliveryStreamOutput;
(function(CreateDeliveryStreamOutput) {
    CreateDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(CreateDeliveryStreamOutput || (CreateDeliveryStreamOutput = {}));
var InvalidArgumentException;
(function(InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidArgumentException || (InvalidArgumentException = {}));
var InvalidKMSResourceException;
(function(InvalidKMSResourceException) {
    InvalidKMSResourceException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidKMSResourceException || (InvalidKMSResourceException = {}));
var LimitExceededException;
(function(LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceInUseException;
(function(ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceInUseException || (ResourceInUseException = {}));
var DeleteDeliveryStreamInput;
(function(DeleteDeliveryStreamInput) {
    DeleteDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamInput || (DeleteDeliveryStreamInput = {}));
var DeleteDeliveryStreamOutput;
(function(DeleteDeliveryStreamOutput) {
    DeleteDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeleteDeliveryStreamOutput || (DeleteDeliveryStreamOutput = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var DeliveryStreamFailureType;
(function(DeliveryStreamFailureType) {
    DeliveryStreamFailureType["CREATE_ENI_FAILED"] = "CREATE_ENI_FAILED";
    DeliveryStreamFailureType["CREATE_KMS_GRANT_FAILED"] = "CREATE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["DELETE_ENI_FAILED"] = "DELETE_ENI_FAILED";
    DeliveryStreamFailureType["DISABLED_KMS_KEY"] = "DISABLED_KMS_KEY";
    DeliveryStreamFailureType["ENI_ACCESS_DENIED"] = "ENI_ACCESS_DENIED";
    DeliveryStreamFailureType["INVALID_KMS_KEY"] = "INVALID_KMS_KEY";
    DeliveryStreamFailureType["KMS_ACCESS_DENIED"] = "KMS_ACCESS_DENIED";
    DeliveryStreamFailureType["KMS_KEY_NOT_FOUND"] = "KMS_KEY_NOT_FOUND";
    DeliveryStreamFailureType["KMS_OPT_IN_REQUIRED"] = "KMS_OPT_IN_REQUIRED";
    DeliveryStreamFailureType["RETIRE_KMS_GRANT_FAILED"] = "RETIRE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["SECURITY_GROUP_ACCESS_DENIED"] = "SECURITY_GROUP_ACCESS_DENIED";
    DeliveryStreamFailureType["SECURITY_GROUP_NOT_FOUND"] = "SECURITY_GROUP_NOT_FOUND";
    DeliveryStreamFailureType["SUBNET_ACCESS_DENIED"] = "SUBNET_ACCESS_DENIED";
    DeliveryStreamFailureType["SUBNET_NOT_FOUND"] = "SUBNET_NOT_FOUND";
    DeliveryStreamFailureType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DeliveryStreamFailureType || (DeliveryStreamFailureType = {}));
var FailureDescription;
(function(FailureDescription) {
    FailureDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(FailureDescription || (FailureDescription = {}));
var DeliveryStreamEncryptionStatus;
(function(DeliveryStreamEncryptionStatus) {
    DeliveryStreamEncryptionStatus["DISABLED"] = "DISABLED";
    DeliveryStreamEncryptionStatus["DISABLING"] = "DISABLING";
    DeliveryStreamEncryptionStatus["DISABLING_FAILED"] = "DISABLING_FAILED";
    DeliveryStreamEncryptionStatus["ENABLED"] = "ENABLED";
    DeliveryStreamEncryptionStatus["ENABLING"] = "ENABLING";
    DeliveryStreamEncryptionStatus["ENABLING_FAILED"] = "ENABLING_FAILED";
})(DeliveryStreamEncryptionStatus || (DeliveryStreamEncryptionStatus = {}));
var DeliveryStreamEncryptionConfiguration;
(function(DeliveryStreamEncryptionConfiguration) {
    DeliveryStreamEncryptionConfiguration.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DeliveryStreamEncryptionConfiguration || (DeliveryStreamEncryptionConfiguration = {}));
var DeliveryStreamStatus;
(function(DeliveryStreamStatus) {
    DeliveryStreamStatus["ACTIVE"] = "ACTIVE";
    DeliveryStreamStatus["CREATING"] = "CREATING";
    DeliveryStreamStatus["CREATING_FAILED"] = "CREATING_FAILED";
    DeliveryStreamStatus["DELETING"] = "DELETING";
    DeliveryStreamStatus["DELETING_FAILED"] = "DELETING_FAILED";
})(DeliveryStreamStatus || (DeliveryStreamStatus = {}));
var S3DestinationDescription;
(function(S3DestinationDescription) {
    S3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationDescription || (S3DestinationDescription = {}));
var VpcConfigurationDescription;
(function(VpcConfigurationDescription) {
    VpcConfigurationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(VpcConfigurationDescription || (VpcConfigurationDescription = {}));
var ElasticsearchDestinationDescription;
(function(ElasticsearchDestinationDescription) {
    ElasticsearchDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationDescription || (ElasticsearchDestinationDescription = {}));
var ExtendedS3DestinationDescription;
(function(ExtendedS3DestinationDescription) {
    ExtendedS3DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationDescription || (ExtendedS3DestinationDescription = {}));
var HttpEndpointDescription;
(function(HttpEndpointDescription) {
    HttpEndpointDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Url && {
            Url: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(HttpEndpointDescription || (HttpEndpointDescription = {}));
var HttpEndpointDestinationDescription;
(function(HttpEndpointDestinationDescription) {
    HttpEndpointDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointDescription.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationDescription || (HttpEndpointDestinationDescription = {}));
var RedshiftDestinationDescription;
(function(RedshiftDestinationDescription) {
    RedshiftDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationDescription || (RedshiftDestinationDescription = {}));
var SplunkDestinationDescription;
(function(SplunkDestinationDescription) {
    SplunkDestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationDescription || (SplunkDestinationDescription = {}));
var DestinationDescription;
(function(DestinationDescription) {
    DestinationDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationDescription && {
            RedshiftDestinationDescription: RedshiftDestinationDescription.filterSensitiveLog(obj.RedshiftDestinationDescription)
        }), obj.HttpEndpointDestinationDescription && {
            HttpEndpointDestinationDescription: HttpEndpointDestinationDescription.filterSensitiveLog(obj.HttpEndpointDestinationDescription)
        });
    };
})(DestinationDescription || (DestinationDescription = {}));
var KinesisStreamSourceDescription;
(function(KinesisStreamSourceDescription) {
    KinesisStreamSourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(KinesisStreamSourceDescription || (KinesisStreamSourceDescription = {}));
var SourceDescription;
(function(SourceDescription) {
    SourceDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SourceDescription || (SourceDescription = {}));
var DeliveryStreamDescription;
(function(DeliveryStreamDescription) {
    DeliveryStreamDescription.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Destinations && {
            Destinations: obj.Destinations.map(function(item) {
                return DestinationDescription.filterSensitiveLog(item);
            })
        });
    };
})(DeliveryStreamDescription || (DeliveryStreamDescription = {}));
var DescribeDeliveryStreamInput;
(function(DescribeDeliveryStreamInput) {
    DescribeDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(DescribeDeliveryStreamInput || (DescribeDeliveryStreamInput = {}));
var DescribeDeliveryStreamOutput;
(function(DescribeDeliveryStreamOutput) {
    DescribeDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeliveryStreamDescription && {
            DeliveryStreamDescription: DeliveryStreamDescription.filterSensitiveLog(obj.DeliveryStreamDescription)
        });
    };
})(DescribeDeliveryStreamOutput || (DescribeDeliveryStreamOutput = {}));
var S3DestinationUpdate;
(function(S3DestinationUpdate) {
    S3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(S3DestinationUpdate || (S3DestinationUpdate = {}));
var ElasticsearchDestinationUpdate;
(function(ElasticsearchDestinationUpdate) {
    ElasticsearchDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ElasticsearchDestinationUpdate || (ElasticsearchDestinationUpdate = {}));
var ExtendedS3DestinationUpdate;
(function(ExtendedS3DestinationUpdate) {
    ExtendedS3DestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ExtendedS3DestinationUpdate || (ExtendedS3DestinationUpdate = {}));
var ListDeliveryStreamsInput;
(function(ListDeliveryStreamsInput) {
    ListDeliveryStreamsInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsInput || (ListDeliveryStreamsInput = {}));
var ListDeliveryStreamsOutput;
(function(ListDeliveryStreamsOutput) {
    ListDeliveryStreamsOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListDeliveryStreamsOutput || (ListDeliveryStreamsOutput = {}));
var ListTagsForDeliveryStreamInput;
(function(ListTagsForDeliveryStreamInput) {
    ListTagsForDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamInput || (ListTagsForDeliveryStreamInput = {}));
var ListTagsForDeliveryStreamOutput;
(function(ListTagsForDeliveryStreamOutput) {
    ListTagsForDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ListTagsForDeliveryStreamOutput || (ListTagsForDeliveryStreamOutput = {}));
var _Record;
(function(_Record) {
    _Record.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(_Record || (_Record = {}));
var PutRecordInput;
(function(PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordInput || (PutRecordInput = {}));
var PutRecordOutput;
(function(PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordOutput || (PutRecordOutput = {}));
var ServiceUnavailableException;
(function(ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var PutRecordBatchInput;
(function(PutRecordBatchInput) {
    PutRecordBatchInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchInput || (PutRecordBatchInput = {}));
var PutRecordBatchResponseEntry;
(function(PutRecordBatchResponseEntry) {
    PutRecordBatchResponseEntry.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchResponseEntry || (PutRecordBatchResponseEntry = {}));
var PutRecordBatchOutput;
(function(PutRecordBatchOutput) {
    PutRecordBatchOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutRecordBatchOutput || (PutRecordBatchOutput = {}));
var StartDeliveryStreamEncryptionInput;
(function(StartDeliveryStreamEncryptionInput) {
    StartDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionInput || (StartDeliveryStreamEncryptionInput = {}));
var StartDeliveryStreamEncryptionOutput;
(function(StartDeliveryStreamEncryptionOutput) {
    StartDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StartDeliveryStreamEncryptionOutput || (StartDeliveryStreamEncryptionOutput = {}));
var StopDeliveryStreamEncryptionInput;
(function(StopDeliveryStreamEncryptionInput) {
    StopDeliveryStreamEncryptionInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionInput || (StopDeliveryStreamEncryptionInput = {}));
var StopDeliveryStreamEncryptionOutput;
(function(StopDeliveryStreamEncryptionOutput) {
    StopDeliveryStreamEncryptionOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(StopDeliveryStreamEncryptionOutput || (StopDeliveryStreamEncryptionOutput = {}));
var TagDeliveryStreamInput;
(function(TagDeliveryStreamInput) {
    TagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamInput || (TagDeliveryStreamInput = {}));
var TagDeliveryStreamOutput;
(function(TagDeliveryStreamOutput) {
    TagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(TagDeliveryStreamOutput || (TagDeliveryStreamOutput = {}));
var UntagDeliveryStreamInput;
(function(UntagDeliveryStreamInput) {
    UntagDeliveryStreamInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamInput || (UntagDeliveryStreamInput = {}));
var UntagDeliveryStreamOutput;
(function(UntagDeliveryStreamOutput) {
    UntagDeliveryStreamOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UntagDeliveryStreamOutput || (UntagDeliveryStreamOutput = {}));
var HttpEndpointDestinationUpdate;
(function(HttpEndpointDestinationUpdate) {
    HttpEndpointDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.EndpointConfiguration && {
            EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration)
        }), obj.RequestConfiguration && {
            RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration)
        });
    };
})(HttpEndpointDestinationUpdate || (HttpEndpointDestinationUpdate = {}));
var RedshiftDestinationUpdate;
(function(RedshiftDestinationUpdate) {
    RedshiftDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Username && {
            Username: (0, _smithyClient.SENSITIVE_STRING)
        }), obj.Password && {
            Password: (0, _smithyClient.SENSITIVE_STRING)
        });
    };
})(RedshiftDestinationUpdate || (RedshiftDestinationUpdate = {}));
var SplunkDestinationUpdate;
(function(SplunkDestinationUpdate) {
    SplunkDestinationUpdate.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(SplunkDestinationUpdate || (SplunkDestinationUpdate = {}));
var UpdateDestinationInput;
(function(UpdateDestinationInput) {
    UpdateDestinationInput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RedshiftDestinationUpdate && {
            RedshiftDestinationUpdate: RedshiftDestinationUpdate.filterSensitiveLog(obj.RedshiftDestinationUpdate)
        }), obj.HttpEndpointDestinationUpdate && {
            HttpEndpointDestinationUpdate: HttpEndpointDestinationUpdate.filterSensitiveLog(obj.HttpEndpointDestinationUpdate)
        });
    };
})(UpdateDestinationInput || (UpdateDestinationInput = {}));
var UpdateDestinationOutput;
(function(UpdateDestinationOutput) {
    UpdateDestinationOutput.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(UpdateDestinationOutput || (UpdateDestinationOutput = {}));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lKm6X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_json1_1CreateDeliveryStreamCommand", ()=>serializeAws_json1_1CreateDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DeleteDeliveryStreamCommand", ()=>serializeAws_json1_1DeleteDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1DescribeDeliveryStreamCommand", ()=>serializeAws_json1_1DescribeDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListDeliveryStreamsCommand", ()=>serializeAws_json1_1ListDeliveryStreamsCommand);
parcelHelpers.export(exports, "serializeAws_json1_1ListTagsForDeliveryStreamCommand", ()=>serializeAws_json1_1ListTagsForDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordCommand", ()=>serializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "serializeAws_json1_1PutRecordBatchCommand", ()=>serializeAws_json1_1PutRecordBatchCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StartDeliveryStreamEncryptionCommand", ()=>serializeAws_json1_1StartDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1StopDeliveryStreamEncryptionCommand", ()=>serializeAws_json1_1StopDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "serializeAws_json1_1TagDeliveryStreamCommand", ()=>serializeAws_json1_1TagDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UntagDeliveryStreamCommand", ()=>serializeAws_json1_1UntagDeliveryStreamCommand);
parcelHelpers.export(exports, "serializeAws_json1_1UpdateDestinationCommand", ()=>serializeAws_json1_1UpdateDestinationCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1CreateDeliveryStreamCommand", ()=>deserializeAws_json1_1CreateDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DeleteDeliveryStreamCommand", ()=>deserializeAws_json1_1DeleteDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1DescribeDeliveryStreamCommand", ()=>deserializeAws_json1_1DescribeDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListDeliveryStreamsCommand", ()=>deserializeAws_json1_1ListDeliveryStreamsCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1ListTagsForDeliveryStreamCommand", ()=>deserializeAws_json1_1ListTagsForDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordCommand", ()=>deserializeAws_json1_1PutRecordCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1PutRecordBatchCommand", ()=>deserializeAws_json1_1PutRecordBatchCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StartDeliveryStreamEncryptionCommand", ()=>deserializeAws_json1_1StartDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1StopDeliveryStreamEncryptionCommand", ()=>deserializeAws_json1_1StopDeliveryStreamEncryptionCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1TagDeliveryStreamCommand", ()=>deserializeAws_json1_1TagDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UntagDeliveryStreamCommand", ()=>deserializeAws_json1_1UntagDeliveryStreamCommand);
parcelHelpers.export(exports, "deserializeAws_json1_1UpdateDestinationCommand", ()=>deserializeAws_json1_1UpdateDestinationCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var serializeAws_json1_1CreateDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.CreateDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1CreateDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DeleteDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DeleteDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DeleteDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1DescribeDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.DescribeDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1DescribeDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListDeliveryStreamsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListDeliveryStreams"
            };
            body = JSON.stringify(serializeAws_json1_1ListDeliveryStreamsInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.ListTagsForDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1ListTagsForDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecord"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1PutRecordBatchCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.PutRecordBatch"
            };
            body = JSON.stringify(serializeAws_json1_1PutRecordBatchInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StartDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StartDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.StopDeliveryStreamEncryption"
            };
            body = JSON.stringify(serializeAws_json1_1StopDeliveryStreamEncryptionInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1TagDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.TagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1TagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UntagDeliveryStreamCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UntagDeliveryStream"
            };
            body = JSON.stringify(serializeAws_json1_1UntagDeliveryStreamInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var serializeAws_json1_1UpdateDestinationCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, body;
        return (0, _tslib.__generator)(this, function(_a) {
            headers = {
                "content-type": "application/x-amz-json-1.1",
                "x-amz-target": "Firehose_20150804.UpdateDestination"
            };
            body = JSON.stringify(serializeAws_json1_1UpdateDestinationInput(input, context));
            return [
                2 /*return*/ ,
                buildHttpRpcRequest(context, headers, "/", undefined, body)
            ];
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1CreateDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1CreateDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1CreateDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DeleteDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DeleteDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DeleteDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1DescribeDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1DescribeDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListDeliveryStreamsCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListDeliveryStreamsOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListDeliveryStreamsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, parsedBody, message;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _b = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_b.body = _c.sent(), _b)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    errorCode;
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1ListTagsForDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1ListTagsForDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
        var _f;
        return (0, _tslib.__generator)(this, function(_g) {
            switch(_g.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _f = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_f.body = _g.sent(), _f)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _g.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _g.label = 9;
                case 9:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1PutRecordBatchCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1PutRecordBatchOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1PutRecordBatchCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ServiceUnavailableException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StartDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
        var _h;
        return (0, _tslib.__generator)(this, function(_j) {
            switch(_j.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _h = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_h.body = _j.sent(), _h)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidKMSResourceException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                10
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidKMSResourceExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 10:
                    _g = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _g.concat([
                            _j.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 12:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _j.label = 13;
                case 13:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1StopDeliveryStreamEncryptionOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1TagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1TagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1TagDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UntagDeliveryStreamCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UntagDeliveryStreamOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UntagDeliveryStreamCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#LimitExceededException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var data, contents, response;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_json1_1UpdateDestinationCommandError(output, context)
                    ];
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents = {};
                    contents = deserializeAws_json1_1UpdateDestinationOutput(data, context);
                    response = (0, _tslib.__assign)({
                        $metadata: deserializeMetadata(output)
                    }, contents);
                    return [
                        2 /*return*/ ,
                        Promise.resolve(response)
                    ];
            }
        });
    });
};
var deserializeAws_json1_1UpdateDestinationCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
        var _g;
        return (0, _tslib.__generator)(this, function(_h) {
            switch(_h.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _g = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_g.body = _h.sent(), _g)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.firehose#ConcurrentModificationException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.firehose#InvalidArgumentException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "com.amazonaws.firehose#ResourceInUseException":
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case "com.amazonaws.firehose#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                8
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1InvalidArgumentExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 6:
                    _e = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceInUseExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _e.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 8:
                    _f = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _f.concat([
                            _h.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _h.label = 11;
                case 11:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_json1_1ConcurrentModificationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ConcurrentModificationException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ConcurrentModificationException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidArgumentExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidArgumentException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidArgumentException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1InvalidKMSResourceExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1InvalidKMSResourceException(body, context);
            contents = (0, _tslib.__assign)({
                name: "InvalidKMSResourceException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1LimitExceededException(body, context);
            contents = (0, _tslib.__assign)({
                name: "LimitExceededException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceInUseExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceInUseException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceInUseException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var body, deserialized, contents;
        return (0, _tslib.__generator)(this, function(_a) {
            body = parsedOutput.body;
            deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
            contents = (0, _tslib.__assign)({
                name: "ServiceUnavailableException",
                $fault: "server",
                $metadata: deserializeMetadata(parsedOutput)
            }, deserialized);
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_json1_1BufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1CloudWatchLoggingOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.LogGroupName !== undefined && input.LogGroupName !== null && {
        LogGroupName: input.LogGroupName
    }), input.LogStreamName !== undefined && input.LogStreamName !== null && {
        LogStreamName: input.LogStreamName
    });
};
var serializeAws_json1_1ColumnToJsonKeyMappings = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1CopyCommand = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CopyOptions !== undefined && input.CopyOptions !== null && {
        CopyOptions: input.CopyOptions
    }), input.DataTableColumns !== undefined && input.DataTableColumns !== null && {
        DataTableColumns: input.DataTableColumns
    }), input.DataTableName !== undefined && input.DataTableName !== null && {
        DataTableName: input.DataTableName
    });
};
var serializeAws_json1_1CreateDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ElasticsearchDestinationConfiguration !== undefined && input.ElasticsearchDestinationConfiguration !== null && {
        ElasticsearchDestinationConfiguration: serializeAws_json1_1ElasticsearchDestinationConfiguration(input.ElasticsearchDestinationConfiguration, context)
    }), input.ExtendedS3DestinationConfiguration !== undefined && input.ExtendedS3DestinationConfiguration !== null && {
        ExtendedS3DestinationConfiguration: serializeAws_json1_1ExtendedS3DestinationConfiguration(input.ExtendedS3DestinationConfiguration, context)
    }), input.HttpEndpointDestinationConfiguration !== undefined && input.HttpEndpointDestinationConfiguration !== null && {
        HttpEndpointDestinationConfiguration: serializeAws_json1_1HttpEndpointDestinationConfiguration(input.HttpEndpointDestinationConfiguration, context)
    }), input.KinesisStreamSourceConfiguration !== undefined && input.KinesisStreamSourceConfiguration !== null && {
        KinesisStreamSourceConfiguration: serializeAws_json1_1KinesisStreamSourceConfiguration(input.KinesisStreamSourceConfiguration, context)
    }), input.RedshiftDestinationConfiguration !== undefined && input.RedshiftDestinationConfiguration !== null && {
        RedshiftDestinationConfiguration: serializeAws_json1_1RedshiftDestinationConfiguration(input.RedshiftDestinationConfiguration, context)
    }), input.S3DestinationConfiguration !== undefined && input.S3DestinationConfiguration !== null && {
        S3DestinationConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3DestinationConfiguration, context)
    }), input.SplunkDestinationConfiguration !== undefined && input.SplunkDestinationConfiguration !== null && {
        SplunkDestinationConfiguration: serializeAws_json1_1SplunkDestinationConfiguration(input.SplunkDestinationConfiguration, context)
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1DataFormatConversionConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.InputFormatConfiguration !== undefined && input.InputFormatConfiguration !== null && {
        InputFormatConfiguration: serializeAws_json1_1InputFormatConfiguration(input.InputFormatConfiguration, context)
    }), input.OutputFormatConfiguration !== undefined && input.OutputFormatConfiguration !== null && {
        OutputFormatConfiguration: serializeAws_json1_1OutputFormatConfiguration(input.OutputFormatConfiguration, context)
    }), input.SchemaConfiguration !== undefined && input.SchemaConfiguration !== null && {
        SchemaConfiguration: serializeAws_json1_1SchemaConfiguration(input.SchemaConfiguration, context)
    });
};
var serializeAws_json1_1DeleteDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AllowForceDelete !== undefined && input.AllowForceDelete !== null && {
        AllowForceDelete: input.AllowForceDelete
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KeyARN !== undefined && input.KeyARN !== null && {
        KeyARN: input.KeyARN
    }), input.KeyType !== undefined && input.KeyType !== null && {
        KeyType: input.KeyType
    });
};
var serializeAws_json1_1DescribeDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartDestinationId !== undefined && input.ExclusiveStartDestinationId !== null && {
        ExclusiveStartDestinationId: input.ExclusiveStartDestinationId
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1Deserializer = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.HiveJsonSerDe !== undefined && input.HiveJsonSerDe !== null && {
        HiveJsonSerDe: serializeAws_json1_1HiveJsonSerDe(input.HiveJsonSerDe, context)
    }), input.OpenXJsonSerDe !== undefined && input.OpenXJsonSerDe !== null && {
        OpenXJsonSerDe: serializeAws_json1_1OpenXJsonSerDe(input.OpenXJsonSerDe, context)
    });
};
var serializeAws_json1_1ElasticsearchBufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1ElasticsearchDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    }), input.VpcConfiguration !== undefined && input.VpcConfiguration !== null && {
        VpcConfiguration: serializeAws_json1_1VpcConfiguration(input.VpcConfiguration, context)
    });
};
var serializeAws_json1_1ElasticsearchDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1ElasticsearchBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterEndpoint !== undefined && input.ClusterEndpoint !== null && {
        ClusterEndpoint: input.ClusterEndpoint
    }), input.DomainARN !== undefined && input.DomainARN !== null && {
        DomainARN: input.DomainARN
    }), input.IndexName !== undefined && input.IndexName !== null && {
        IndexName: input.IndexName
    }), input.IndexRotationPeriod !== undefined && input.IndexRotationPeriod !== null && {
        IndexRotationPeriod: input.IndexRotationPeriod
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1ElasticsearchRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.TypeName !== undefined && input.TypeName !== null && {
        TypeName: input.TypeName
    });
};
var serializeAws_json1_1ElasticsearchRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1EncryptionConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KMSEncryptionConfig !== undefined && input.KMSEncryptionConfig !== null && {
        KMSEncryptionConfig: serializeAws_json1_1KMSEncryptionConfig(input.KMSEncryptionConfig, context)
    }), input.NoEncryptionConfig !== undefined && input.NoEncryptionConfig !== null && {
        NoEncryptionConfig: input.NoEncryptionConfig
    });
};
var serializeAws_json1_1ExtendedS3DestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    });
};
var serializeAws_json1_1ExtendedS3DestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.DataFormatConversionConfiguration !== undefined && input.DataFormatConversionConfiguration !== null && {
        DataFormatConversionConfiguration: serializeAws_json1_1DataFormatConversionConfiguration(input.DataFormatConversionConfiguration, context)
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    });
};
var serializeAws_json1_1HiveJsonSerDe = function(input, context) {
    return (0, _tslib.__assign)({}, input.TimestampFormats !== undefined && input.TimestampFormats !== null && {
        TimestampFormats: serializeAws_json1_1ListOfNonEmptyStrings(input.TimestampFormats, context)
    });
};
var serializeAws_json1_1HttpEndpointBufferingHints = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.IntervalInSeconds !== undefined && input.IntervalInSeconds !== null && {
        IntervalInSeconds: input.IntervalInSeconds
    }), input.SizeInMBs !== undefined && input.SizeInMBs !== null && {
        SizeInMBs: input.SizeInMBs
    });
};
var serializeAws_json1_1HttpEndpointCommonAttribute = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AttributeName !== undefined && input.AttributeName !== null && {
        AttributeName: input.AttributeName
    }), input.AttributeValue !== undefined && input.AttributeValue !== null && {
        AttributeValue: input.AttributeValue
    });
};
var serializeAws_json1_1HttpEndpointCommonAttributesList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var serializeAws_json1_1HttpEndpointConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AccessKey !== undefined && input.AccessKey !== null && {
        AccessKey: input.AccessKey
    }), input.Name !== undefined && input.Name !== null && {
        Name: input.Name
    }), input.Url !== undefined && input.Url !== null && {
        Url: input.Url
    });
};
var serializeAws_json1_1HttpEndpointDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1HttpEndpointDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1HttpEndpointBufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.EndpointConfiguration !== undefined && input.EndpointConfiguration !== null && {
        EndpointConfiguration: serializeAws_json1_1HttpEndpointConfiguration(input.EndpointConfiguration, context)
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RequestConfiguration !== undefined && input.RequestConfiguration !== null && {
        RequestConfiguration: serializeAws_json1_1HttpEndpointRequestConfiguration(input.RequestConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1HttpEndpointRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1HttpEndpointRequestConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.CommonAttributes !== undefined && input.CommonAttributes !== null && {
        CommonAttributes: serializeAws_json1_1HttpEndpointCommonAttributesList(input.CommonAttributes, context)
    }), input.ContentEncoding !== undefined && input.ContentEncoding !== null && {
        ContentEncoding: input.ContentEncoding
    });
};
var serializeAws_json1_1HttpEndpointRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1InputFormatConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Deserializer !== undefined && input.Deserializer !== null && {
        Deserializer: serializeAws_json1_1Deserializer(input.Deserializer, context)
    });
};
var serializeAws_json1_1KinesisStreamSourceConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.KinesisStreamARN !== undefined && input.KinesisStreamARN !== null && {
        KinesisStreamARN: input.KinesisStreamARN
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1KMSEncryptionConfig = function(input, context) {
    return (0, _tslib.__assign)({}, input.AWSKMSKeyARN !== undefined && input.AWSKMSKeyARN !== null && {
        AWSKMSKeyARN: input.AWSKMSKeyARN
    });
};
var serializeAws_json1_1ListDeliveryStreamsInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamType !== undefined && input.DeliveryStreamType !== null && {
        DeliveryStreamType: input.DeliveryStreamType
    }), input.ExclusiveStartDeliveryStreamName !== undefined && input.ExclusiveStartDeliveryStreamName !== null && {
        ExclusiveStartDeliveryStreamName: input.ExclusiveStartDeliveryStreamName
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1ListOfNonEmptyStrings = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1ListTagsForDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.ExclusiveStartTagKey !== undefined && input.ExclusiveStartTagKey !== null && {
        ExclusiveStartTagKey: input.ExclusiveStartTagKey
    }), input.Limit !== undefined && input.Limit !== null && {
        Limit: input.Limit
    });
};
var serializeAws_json1_1OpenXJsonSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CaseInsensitive !== undefined && input.CaseInsensitive !== null && {
        CaseInsensitive: input.CaseInsensitive
    }), input.ColumnToJsonKeyMappings !== undefined && input.ColumnToJsonKeyMappings !== null && {
        ColumnToJsonKeyMappings: serializeAws_json1_1ColumnToJsonKeyMappings(input.ColumnToJsonKeyMappings, context)
    }), input.ConvertDotsInJsonKeysToUnderscores !== undefined && input.ConvertDotsInJsonKeysToUnderscores !== null && {
        ConvertDotsInJsonKeysToUnderscores: input.ConvertDotsInJsonKeysToUnderscores
    });
};
var serializeAws_json1_1OrcSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.BloomFilterColumns !== undefined && input.BloomFilterColumns !== null && {
        BloomFilterColumns: serializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(input.BloomFilterColumns, context)
    }), input.BloomFilterFalsePositiveProbability !== undefined && input.BloomFilterFalsePositiveProbability !== null && {
        BloomFilterFalsePositiveProbability: input.BloomFilterFalsePositiveProbability
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.DictionaryKeyThreshold !== undefined && input.DictionaryKeyThreshold !== null && {
        DictionaryKeyThreshold: input.DictionaryKeyThreshold
    }), input.EnablePadding !== undefined && input.EnablePadding !== null && {
        EnablePadding: input.EnablePadding
    }), input.FormatVersion !== undefined && input.FormatVersion !== null && {
        FormatVersion: input.FormatVersion
    }), input.PaddingTolerance !== undefined && input.PaddingTolerance !== null && {
        PaddingTolerance: input.PaddingTolerance
    }), input.RowIndexStride !== undefined && input.RowIndexStride !== null && {
        RowIndexStride: input.RowIndexStride
    }), input.StripeSizeBytes !== undefined && input.StripeSizeBytes !== null && {
        StripeSizeBytes: input.StripeSizeBytes
    });
};
var serializeAws_json1_1OutputFormatConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Serializer !== undefined && input.Serializer !== null && {
        Serializer: serializeAws_json1_1Serializer(input.Serializer, context)
    });
};
var serializeAws_json1_1ParquetSerDe = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BlockSizeBytes !== undefined && input.BlockSizeBytes !== null && {
        BlockSizeBytes: input.BlockSizeBytes
    }), input.Compression !== undefined && input.Compression !== null && {
        Compression: input.Compression
    }), input.EnableDictionaryCompression !== undefined && input.EnableDictionaryCompression !== null && {
        EnableDictionaryCompression: input.EnableDictionaryCompression
    }), input.MaxPaddingBytes !== undefined && input.MaxPaddingBytes !== null && {
        MaxPaddingBytes: input.MaxPaddingBytes
    }), input.PageSizeBytes !== undefined && input.PageSizeBytes !== null && {
        PageSizeBytes: input.PageSizeBytes
    }), input.WriterVersion !== undefined && input.WriterVersion !== null && {
        WriterVersion: input.WriterVersion
    });
};
var serializeAws_json1_1ProcessingConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Enabled !== undefined && input.Enabled !== null && {
        Enabled: input.Enabled
    }), input.Processors !== undefined && input.Processors !== null && {
        Processors: serializeAws_json1_1ProcessorList(input.Processors, context)
    });
};
var serializeAws_json1_1Processor = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Parameters !== undefined && input.Parameters !== null && {
        Parameters: serializeAws_json1_1ProcessorParameterList(input.Parameters, context)
    }), input.Type !== undefined && input.Type !== null && {
        Type: input.Type
    });
};
var serializeAws_json1_1ProcessorList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Processor(entry, context);
    });
};
var serializeAws_json1_1ProcessorParameter = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.ParameterName !== undefined && input.ParameterName !== null && {
        ParameterName: input.ParameterName
    }), input.ParameterValue !== undefined && input.ParameterValue !== null && {
        ParameterValue: input.ParameterValue
    });
};
var serializeAws_json1_1ProcessorParameterList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var serializeAws_json1_1PutRecordBatchInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Records !== undefined && input.Records !== null && {
        Records: serializeAws_json1_1PutRecordBatchRequestEntryList(input.Records, context)
    });
};
var serializeAws_json1_1PutRecordBatchRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1_Record(entry, context);
    });
};
var serializeAws_json1_1PutRecordInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Record !== undefined && input.Record !== null && {
        Record: serializeAws_json1_1_Record(input.Record, context)
    });
};
var serializeAws_json1_1_Record = function(input, context) {
    return (0, _tslib.__assign)({}, input.Data !== undefined && input.Data !== null && {
        Data: context.base64Encoder(input.Data)
    });
};
var serializeAws_json1_1RedshiftDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupConfiguration !== undefined && input.S3BackupConfiguration !== null && {
        S3BackupConfiguration: serializeAws_json1_1S3DestinationConfiguration(input.S3BackupConfiguration, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.ClusterJDBCURL !== undefined && input.ClusterJDBCURL !== null && {
        ClusterJDBCURL: input.ClusterJDBCURL
    }), input.CopyCommand !== undefined && input.CopyCommand !== null && {
        CopyCommand: serializeAws_json1_1CopyCommand(input.CopyCommand, context)
    }), input.Password !== undefined && input.Password !== null && {
        Password: input.Password
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1RedshiftRetryOptions(input.RetryOptions, context)
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3BackupUpdate !== undefined && input.S3BackupUpdate !== null && {
        S3BackupUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3BackupUpdate, context)
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    }), input.Username !== undefined && input.Username !== null && {
        Username: input.Username
    });
};
var serializeAws_json1_1RedshiftRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1S3DestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1S3DestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BucketARN !== undefined && input.BucketARN !== null && {
        BucketARN: input.BucketARN
    }), input.BufferingHints !== undefined && input.BufferingHints !== null && {
        BufferingHints: serializeAws_json1_1BufferingHints(input.BufferingHints, context)
    }), input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.CompressionFormat !== undefined && input.CompressionFormat !== null && {
        CompressionFormat: input.CompressionFormat
    }), input.EncryptionConfiguration !== undefined && input.EncryptionConfiguration !== null && {
        EncryptionConfiguration: serializeAws_json1_1EncryptionConfiguration(input.EncryptionConfiguration, context)
    }), input.ErrorOutputPrefix !== undefined && input.ErrorOutputPrefix !== null && {
        ErrorOutputPrefix: input.ErrorOutputPrefix
    }), input.Prefix !== undefined && input.Prefix !== null && {
        Prefix: input.Prefix
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    });
};
var serializeAws_json1_1SchemaConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CatalogId !== undefined && input.CatalogId !== null && {
        CatalogId: input.CatalogId
    }), input.DatabaseName !== undefined && input.DatabaseName !== null && {
        DatabaseName: input.DatabaseName
    }), input.Region !== undefined && input.Region !== null && {
        Region: input.Region
    }), input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.TableName !== undefined && input.TableName !== null && {
        TableName: input.TableName
    }), input.VersionId !== undefined && input.VersionId !== null && {
        VersionId: input.VersionId
    });
};
var serializeAws_json1_1SecurityGroupIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Serializer = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.OrcSerDe !== undefined && input.OrcSerDe !== null && {
        OrcSerDe: serializeAws_json1_1OrcSerDe(input.OrcSerDe, context)
    }), input.ParquetSerDe !== undefined && input.ParquetSerDe !== null && {
        ParquetSerDe: serializeAws_json1_1ParquetSerDe(input.ParquetSerDe, context)
    });
};
var serializeAws_json1_1SplunkDestinationConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Configuration !== undefined && input.S3Configuration !== null && {
        S3Configuration: serializeAws_json1_1S3DestinationConfiguration(input.S3Configuration, context)
    });
};
var serializeAws_json1_1SplunkDestinationUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CloudWatchLoggingOptions !== undefined && input.CloudWatchLoggingOptions !== null && {
        CloudWatchLoggingOptions: serializeAws_json1_1CloudWatchLoggingOptions(input.CloudWatchLoggingOptions, context)
    }), input.HECAcknowledgmentTimeoutInSeconds !== undefined && input.HECAcknowledgmentTimeoutInSeconds !== null && {
        HECAcknowledgmentTimeoutInSeconds: input.HECAcknowledgmentTimeoutInSeconds
    }), input.HECEndpoint !== undefined && input.HECEndpoint !== null && {
        HECEndpoint: input.HECEndpoint
    }), input.HECEndpointType !== undefined && input.HECEndpointType !== null && {
        HECEndpointType: input.HECEndpointType
    }), input.HECToken !== undefined && input.HECToken !== null && {
        HECToken: input.HECToken
    }), input.ProcessingConfiguration !== undefined && input.ProcessingConfiguration !== null && {
        ProcessingConfiguration: serializeAws_json1_1ProcessingConfiguration(input.ProcessingConfiguration, context)
    }), input.RetryOptions !== undefined && input.RetryOptions !== null && {
        RetryOptions: serializeAws_json1_1SplunkRetryOptions(input.RetryOptions, context)
    }), input.S3BackupMode !== undefined && input.S3BackupMode !== null && {
        S3BackupMode: input.S3BackupMode
    }), input.S3Update !== undefined && input.S3Update !== null && {
        S3Update: serializeAws_json1_1S3DestinationUpdate(input.S3Update, context)
    });
};
var serializeAws_json1_1SplunkRetryOptions = function(input, context) {
    return (0, _tslib.__assign)({}, input.DurationInSeconds !== undefined && input.DurationInSeconds !== null && {
        DurationInSeconds: input.DurationInSeconds
    });
};
var serializeAws_json1_1StartDeliveryStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamEncryptionConfigurationInput !== undefined && input.DeliveryStreamEncryptionConfigurationInput !== null && {
        DeliveryStreamEncryptionConfigurationInput: serializeAws_json1_1DeliveryStreamEncryptionConfigurationInput(input.DeliveryStreamEncryptionConfigurationInput, context)
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1StopDeliveryStreamEncryptionInput = function(input, context) {
    return (0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    });
};
var serializeAws_json1_1SubnetIdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1Tag = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Key !== undefined && input.Key !== null && {
        Key: input.Key
    }), input.Value !== undefined && input.Value !== null && {
        Value: input.Value
    });
};
var serializeAws_json1_1TagDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.Tags !== undefined && input.Tags !== null && {
        Tags: serializeAws_json1_1TagDeliveryStreamInputTagList(input.Tags, context)
    });
};
var serializeAws_json1_1TagDeliveryStreamInputTagList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_json1_1Tag(entry, context);
    });
};
var serializeAws_json1_1TagKeyList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_json1_1UntagDeliveryStreamInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.TagKeys !== undefined && input.TagKeys !== null && {
        TagKeys: serializeAws_json1_1TagKeyList(input.TagKeys, context)
    });
};
var serializeAws_json1_1UpdateDestinationInput = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CurrentDeliveryStreamVersionId !== undefined && input.CurrentDeliveryStreamVersionId !== null && {
        CurrentDeliveryStreamVersionId: input.CurrentDeliveryStreamVersionId
    }), input.DeliveryStreamName !== undefined && input.DeliveryStreamName !== null && {
        DeliveryStreamName: input.DeliveryStreamName
    }), input.DestinationId !== undefined && input.DestinationId !== null && {
        DestinationId: input.DestinationId
    }), input.ElasticsearchDestinationUpdate !== undefined && input.ElasticsearchDestinationUpdate !== null && {
        ElasticsearchDestinationUpdate: serializeAws_json1_1ElasticsearchDestinationUpdate(input.ElasticsearchDestinationUpdate, context)
    }), input.ExtendedS3DestinationUpdate !== undefined && input.ExtendedS3DestinationUpdate !== null && {
        ExtendedS3DestinationUpdate: serializeAws_json1_1ExtendedS3DestinationUpdate(input.ExtendedS3DestinationUpdate, context)
    }), input.HttpEndpointDestinationUpdate !== undefined && input.HttpEndpointDestinationUpdate !== null && {
        HttpEndpointDestinationUpdate: serializeAws_json1_1HttpEndpointDestinationUpdate(input.HttpEndpointDestinationUpdate, context)
    }), input.RedshiftDestinationUpdate !== undefined && input.RedshiftDestinationUpdate !== null && {
        RedshiftDestinationUpdate: serializeAws_json1_1RedshiftDestinationUpdate(input.RedshiftDestinationUpdate, context)
    }), input.S3DestinationUpdate !== undefined && input.S3DestinationUpdate !== null && {
        S3DestinationUpdate: serializeAws_json1_1S3DestinationUpdate(input.S3DestinationUpdate, context)
    }), input.SplunkDestinationUpdate !== undefined && input.SplunkDestinationUpdate !== null && {
        SplunkDestinationUpdate: serializeAws_json1_1SplunkDestinationUpdate(input.SplunkDestinationUpdate, context)
    });
};
var serializeAws_json1_1VpcConfiguration = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.RoleARN !== undefined && input.RoleARN !== null && {
        RoleARN: input.RoleARN
    }), input.SecurityGroupIds !== undefined && input.SecurityGroupIds !== null && {
        SecurityGroupIds: serializeAws_json1_1SecurityGroupIdList(input.SecurityGroupIds, context)
    }), input.SubnetIds !== undefined && input.SubnetIds !== null && {
        SubnetIds: serializeAws_json1_1SubnetIdList(input.SubnetIds, context)
    });
};
var deserializeAws_json1_1BufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1CloudWatchLoggingOptions = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        LogGroupName: output.LogGroupName !== undefined && output.LogGroupName !== null ? output.LogGroupName : undefined,
        LogStreamName: output.LogStreamName !== undefined && output.LogStreamName !== null ? output.LogStreamName : undefined
    };
};
var deserializeAws_json1_1ColumnToJsonKeyMappings = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1ConcurrentModificationException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1CopyCommand = function(output, context) {
    return {
        CopyOptions: output.CopyOptions !== undefined && output.CopyOptions !== null ? output.CopyOptions : undefined,
        DataTableColumns: output.DataTableColumns !== undefined && output.DataTableColumns !== null ? output.DataTableColumns : undefined,
        DataTableName: output.DataTableName !== undefined && output.DataTableName !== null ? output.DataTableName : undefined
    };
};
var deserializeAws_json1_1CreateDeliveryStreamOutput = function(output, context) {
    return {
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined
    };
};
var deserializeAws_json1_1DataFormatConversionConfiguration = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        InputFormatConfiguration: output.InputFormatConfiguration !== undefined && output.InputFormatConfiguration !== null ? deserializeAws_json1_1InputFormatConfiguration(output.InputFormatConfiguration, context) : undefined,
        OutputFormatConfiguration: output.OutputFormatConfiguration !== undefined && output.OutputFormatConfiguration !== null ? deserializeAws_json1_1OutputFormatConfiguration(output.OutputFormatConfiguration, context) : undefined,
        SchemaConfiguration: output.SchemaConfiguration !== undefined && output.SchemaConfiguration !== null ? deserializeAws_json1_1SchemaConfiguration(output.SchemaConfiguration, context) : undefined
    };
};
var deserializeAws_json1_1DeleteDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1DeliveryStreamDescription = function(output, context) {
    return {
        CreateTimestamp: output.CreateTimestamp !== undefined && output.CreateTimestamp !== null ? new Date(Math.round(output.CreateTimestamp * 1000)) : undefined,
        DeliveryStreamARN: output.DeliveryStreamARN !== undefined && output.DeliveryStreamARN !== null ? output.DeliveryStreamARN : undefined,
        DeliveryStreamEncryptionConfiguration: output.DeliveryStreamEncryptionConfiguration !== undefined && output.DeliveryStreamEncryptionConfiguration !== null ? deserializeAws_json1_1DeliveryStreamEncryptionConfiguration(output.DeliveryStreamEncryptionConfiguration, context) : undefined,
        DeliveryStreamName: output.DeliveryStreamName !== undefined && output.DeliveryStreamName !== null ? output.DeliveryStreamName : undefined,
        DeliveryStreamStatus: output.DeliveryStreamStatus !== undefined && output.DeliveryStreamStatus !== null ? output.DeliveryStreamStatus : undefined,
        DeliveryStreamType: output.DeliveryStreamType !== undefined && output.DeliveryStreamType !== null ? output.DeliveryStreamType : undefined,
        Destinations: output.Destinations !== undefined && output.Destinations !== null ? deserializeAws_json1_1DestinationDescriptionList(output.Destinations, context) : undefined,
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        HasMoreDestinations: output.HasMoreDestinations !== undefined && output.HasMoreDestinations !== null ? output.HasMoreDestinations : undefined,
        LastUpdateTimestamp: output.LastUpdateTimestamp !== undefined && output.LastUpdateTimestamp !== null ? new Date(Math.round(output.LastUpdateTimestamp * 1000)) : undefined,
        Source: output.Source !== undefined && output.Source !== null ? deserializeAws_json1_1SourceDescription(output.Source, context) : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamEncryptionConfiguration = function(output, context) {
    return {
        FailureDescription: output.FailureDescription !== undefined && output.FailureDescription !== null ? deserializeAws_json1_1FailureDescription(output.FailureDescription, context) : undefined,
        KeyARN: output.KeyARN !== undefined && output.KeyARN !== null ? output.KeyARN : undefined,
        KeyType: output.KeyType !== undefined && output.KeyType !== null ? output.KeyType : undefined,
        Status: output.Status !== undefined && output.Status !== null ? output.Status : undefined
    };
};
var deserializeAws_json1_1DeliveryStreamNameList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1DescribeDeliveryStreamOutput = function(output, context) {
    return {
        DeliveryStreamDescription: output.DeliveryStreamDescription !== undefined && output.DeliveryStreamDescription !== null ? deserializeAws_json1_1DeliveryStreamDescription(output.DeliveryStreamDescription, context) : undefined
    };
};
var deserializeAws_json1_1Deserializer = function(output, context) {
    return {
        HiveJsonSerDe: output.HiveJsonSerDe !== undefined && output.HiveJsonSerDe !== null ? deserializeAws_json1_1HiveJsonSerDe(output.HiveJsonSerDe, context) : undefined,
        OpenXJsonSerDe: output.OpenXJsonSerDe !== undefined && output.OpenXJsonSerDe !== null ? deserializeAws_json1_1OpenXJsonSerDe(output.OpenXJsonSerDe, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescription = function(output, context) {
    return {
        DestinationId: output.DestinationId !== undefined && output.DestinationId !== null ? output.DestinationId : undefined,
        ElasticsearchDestinationDescription: output.ElasticsearchDestinationDescription !== undefined && output.ElasticsearchDestinationDescription !== null ? deserializeAws_json1_1ElasticsearchDestinationDescription(output.ElasticsearchDestinationDescription, context) : undefined,
        ExtendedS3DestinationDescription: output.ExtendedS3DestinationDescription !== undefined && output.ExtendedS3DestinationDescription !== null ? deserializeAws_json1_1ExtendedS3DestinationDescription(output.ExtendedS3DestinationDescription, context) : undefined,
        HttpEndpointDestinationDescription: output.HttpEndpointDestinationDescription !== undefined && output.HttpEndpointDestinationDescription !== null ? deserializeAws_json1_1HttpEndpointDestinationDescription(output.HttpEndpointDestinationDescription, context) : undefined,
        RedshiftDestinationDescription: output.RedshiftDestinationDescription !== undefined && output.RedshiftDestinationDescription !== null ? deserializeAws_json1_1RedshiftDestinationDescription(output.RedshiftDestinationDescription, context) : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        SplunkDestinationDescription: output.SplunkDestinationDescription !== undefined && output.SplunkDestinationDescription !== null ? deserializeAws_json1_1SplunkDestinationDescription(output.SplunkDestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1DestinationDescriptionList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1DestinationDescription(entry, context);
    });
};
var deserializeAws_json1_1ElasticsearchBufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1ElasticsearchDestinationDescription = function(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1ElasticsearchBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterEndpoint: output.ClusterEndpoint !== undefined && output.ClusterEndpoint !== null ? output.ClusterEndpoint : undefined,
        DomainARN: output.DomainARN !== undefined && output.DomainARN !== null ? output.DomainARN : undefined,
        IndexName: output.IndexName !== undefined && output.IndexName !== null ? output.IndexName : undefined,
        IndexRotationPeriod: output.IndexRotationPeriod !== undefined && output.IndexRotationPeriod !== null ? output.IndexRotationPeriod : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1ElasticsearchRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        TypeName: output.TypeName !== undefined && output.TypeName !== null ? output.TypeName : undefined,
        VpcConfigurationDescription: output.VpcConfigurationDescription !== undefined && output.VpcConfigurationDescription !== null ? deserializeAws_json1_1VpcConfigurationDescription(output.VpcConfigurationDescription, context) : undefined
    };
};
var deserializeAws_json1_1ElasticsearchRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1EncryptionConfiguration = function(output, context) {
    return {
        KMSEncryptionConfig: output.KMSEncryptionConfig !== undefined && output.KMSEncryptionConfig !== null ? deserializeAws_json1_1KMSEncryptionConfig(output.KMSEncryptionConfig, context) : undefined,
        NoEncryptionConfig: output.NoEncryptionConfig !== undefined && output.NoEncryptionConfig !== null ? output.NoEncryptionConfig : undefined
    };
};
var deserializeAws_json1_1ExtendedS3DestinationDescription = function(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        DataFormatConversionConfiguration: output.DataFormatConversionConfiguration !== undefined && output.DataFormatConversionConfiguration !== null ? deserializeAws_json1_1DataFormatConversionConfiguration(output.DataFormatConversionConfiguration, context) : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined
    };
};
var deserializeAws_json1_1FailureDescription = function(output, context) {
    return {
        Details: output.Details !== undefined && output.Details !== null ? output.Details : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1HiveJsonSerDe = function(output, context) {
    return {
        TimestampFormats: output.TimestampFormats !== undefined && output.TimestampFormats !== null ? deserializeAws_json1_1ListOfNonEmptyStrings(output.TimestampFormats, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointBufferingHints = function(output, context) {
    return {
        IntervalInSeconds: output.IntervalInSeconds !== undefined && output.IntervalInSeconds !== null ? output.IntervalInSeconds : undefined,
        SizeInMBs: output.SizeInMBs !== undefined && output.SizeInMBs !== null ? output.SizeInMBs : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttribute = function(output, context) {
    return {
        AttributeName: output.AttributeName !== undefined && output.AttributeName !== null ? output.AttributeName : undefined,
        AttributeValue: output.AttributeValue !== undefined && output.AttributeValue !== null ? output.AttributeValue : undefined
    };
};
var deserializeAws_json1_1HttpEndpointCommonAttributesList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1HttpEndpointCommonAttribute(entry, context);
    });
};
var deserializeAws_json1_1HttpEndpointDescription = function(output, context) {
    return {
        Name: output.Name !== undefined && output.Name !== null ? output.Name : undefined,
        Url: output.Url !== undefined && output.Url !== null ? output.Url : undefined
    };
};
var deserializeAws_json1_1HttpEndpointDestinationDescription = function(output, context) {
    return {
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1HttpEndpointBufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        EndpointConfiguration: output.EndpointConfiguration !== undefined && output.EndpointConfiguration !== null ? deserializeAws_json1_1HttpEndpointDescription(output.EndpointConfiguration, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RequestConfiguration: output.RequestConfiguration !== undefined && output.RequestConfiguration !== null ? deserializeAws_json1_1HttpEndpointRequestConfiguration(output.RequestConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1HttpEndpointRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRequestConfiguration = function(output, context) {
    return {
        CommonAttributes: output.CommonAttributes !== undefined && output.CommonAttributes !== null ? deserializeAws_json1_1HttpEndpointCommonAttributesList(output.CommonAttributes, context) : undefined,
        ContentEncoding: output.ContentEncoding !== undefined && output.ContentEncoding !== null ? output.ContentEncoding : undefined
    };
};
var deserializeAws_json1_1HttpEndpointRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1InputFormatConfiguration = function(output, context) {
    return {
        Deserializer: output.Deserializer !== undefined && output.Deserializer !== null ? deserializeAws_json1_1Deserializer(output.Deserializer, context) : undefined
    };
};
var deserializeAws_json1_1InvalidArgumentException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1InvalidKMSResourceException = function(output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1KinesisStreamSourceDescription = function(output, context) {
    return {
        DeliveryStartTimestamp: output.DeliveryStartTimestamp !== undefined && output.DeliveryStartTimestamp !== null ? new Date(Math.round(output.DeliveryStartTimestamp * 1000)) : undefined,
        KinesisStreamARN: output.KinesisStreamARN !== undefined && output.KinesisStreamARN !== null ? output.KinesisStreamARN : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1KMSEncryptionConfig = function(output, context) {
    return {
        AWSKMSKeyARN: output.AWSKMSKeyARN !== undefined && output.AWSKMSKeyARN !== null ? output.AWSKMSKeyARN : undefined
    };
};
var deserializeAws_json1_1LimitExceededException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ListDeliveryStreamsOutput = function(output, context) {
    return {
        DeliveryStreamNames: output.DeliveryStreamNames !== undefined && output.DeliveryStreamNames !== null ? deserializeAws_json1_1DeliveryStreamNameList(output.DeliveryStreamNames, context) : undefined,
        HasMoreDeliveryStreams: output.HasMoreDeliveryStreams !== undefined && output.HasMoreDeliveryStreams !== null ? output.HasMoreDeliveryStreams : undefined
    };
};
var deserializeAws_json1_1ListOfNonEmptyStrings = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutput = function(output, context) {
    return {
        HasMoreTags: output.HasMoreTags !== undefined && output.HasMoreTags !== null ? output.HasMoreTags : undefined,
        Tags: output.Tags !== undefined && output.Tags !== null ? deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList(output.Tags, context) : undefined
    };
};
var deserializeAws_json1_1ListTagsForDeliveryStreamOutputTagList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Tag(entry, context);
    });
};
var deserializeAws_json1_1OpenXJsonSerDe = function(output, context) {
    return {
        CaseInsensitive: output.CaseInsensitive !== undefined && output.CaseInsensitive !== null ? output.CaseInsensitive : undefined,
        ColumnToJsonKeyMappings: output.ColumnToJsonKeyMappings !== undefined && output.ColumnToJsonKeyMappings !== null ? deserializeAws_json1_1ColumnToJsonKeyMappings(output.ColumnToJsonKeyMappings, context) : undefined,
        ConvertDotsInJsonKeysToUnderscores: output.ConvertDotsInJsonKeysToUnderscores !== undefined && output.ConvertDotsInJsonKeysToUnderscores !== null ? output.ConvertDotsInJsonKeysToUnderscores : undefined
    };
};
var deserializeAws_json1_1OrcSerDe = function(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        BloomFilterColumns: output.BloomFilterColumns !== undefined && output.BloomFilterColumns !== null ? deserializeAws_json1_1ListOfNonEmptyStringsWithoutWhitespace(output.BloomFilterColumns, context) : undefined,
        BloomFilterFalsePositiveProbability: output.BloomFilterFalsePositiveProbability !== undefined && output.BloomFilterFalsePositiveProbability !== null ? output.BloomFilterFalsePositiveProbability : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        DictionaryKeyThreshold: output.DictionaryKeyThreshold !== undefined && output.DictionaryKeyThreshold !== null ? output.DictionaryKeyThreshold : undefined,
        EnablePadding: output.EnablePadding !== undefined && output.EnablePadding !== null ? output.EnablePadding : undefined,
        FormatVersion: output.FormatVersion !== undefined && output.FormatVersion !== null ? output.FormatVersion : undefined,
        PaddingTolerance: output.PaddingTolerance !== undefined && output.PaddingTolerance !== null ? output.PaddingTolerance : undefined,
        RowIndexStride: output.RowIndexStride !== undefined && output.RowIndexStride !== null ? output.RowIndexStride : undefined,
        StripeSizeBytes: output.StripeSizeBytes !== undefined && output.StripeSizeBytes !== null ? output.StripeSizeBytes : undefined
    };
};
var deserializeAws_json1_1OutputFormatConfiguration = function(output, context) {
    return {
        Serializer: output.Serializer !== undefined && output.Serializer !== null ? deserializeAws_json1_1Serializer(output.Serializer, context) : undefined
    };
};
var deserializeAws_json1_1ParquetSerDe = function(output, context) {
    return {
        BlockSizeBytes: output.BlockSizeBytes !== undefined && output.BlockSizeBytes !== null ? output.BlockSizeBytes : undefined,
        Compression: output.Compression !== undefined && output.Compression !== null ? output.Compression : undefined,
        EnableDictionaryCompression: output.EnableDictionaryCompression !== undefined && output.EnableDictionaryCompression !== null ? output.EnableDictionaryCompression : undefined,
        MaxPaddingBytes: output.MaxPaddingBytes !== undefined && output.MaxPaddingBytes !== null ? output.MaxPaddingBytes : undefined,
        PageSizeBytes: output.PageSizeBytes !== undefined && output.PageSizeBytes !== null ? output.PageSizeBytes : undefined,
        WriterVersion: output.WriterVersion !== undefined && output.WriterVersion !== null ? output.WriterVersion : undefined
    };
};
var deserializeAws_json1_1ProcessingConfiguration = function(output, context) {
    return {
        Enabled: output.Enabled !== undefined && output.Enabled !== null ? output.Enabled : undefined,
        Processors: output.Processors !== undefined && output.Processors !== null ? deserializeAws_json1_1ProcessorList(output.Processors, context) : undefined
    };
};
var deserializeAws_json1_1Processor = function(output, context) {
    return {
        Parameters: output.Parameters !== undefined && output.Parameters !== null ? deserializeAws_json1_1ProcessorParameterList(output.Parameters, context) : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined
    };
};
var deserializeAws_json1_1ProcessorList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1Processor(entry, context);
    });
};
var deserializeAws_json1_1ProcessorParameter = function(output, context) {
    return {
        ParameterName: output.ParameterName !== undefined && output.ParameterName !== null ? output.ParameterName : undefined,
        ParameterValue: output.ParameterValue !== undefined && output.ParameterValue !== null ? output.ParameterValue : undefined
    };
};
var deserializeAws_json1_1ProcessorParameterList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1ProcessorParameter(entry, context);
    });
};
var deserializeAws_json1_1PutRecordBatchOutput = function(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        FailedPutCount: output.FailedPutCount !== undefined && output.FailedPutCount !== null ? output.FailedPutCount : undefined,
        RequestResponses: output.RequestResponses !== undefined && output.RequestResponses !== null ? deserializeAws_json1_1PutRecordBatchResponseEntryList(output.RequestResponses, context) : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntry = function(output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        ErrorMessage: output.ErrorMessage !== undefined && output.ErrorMessage !== null ? output.ErrorMessage : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1PutRecordBatchResponseEntryList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_json1_1PutRecordBatchResponseEntry(entry, context);
    });
};
var deserializeAws_json1_1PutRecordOutput = function(output, context) {
    return {
        Encrypted: output.Encrypted !== undefined && output.Encrypted !== null ? output.Encrypted : undefined,
        RecordId: output.RecordId !== undefined && output.RecordId !== null ? output.RecordId : undefined
    };
};
var deserializeAws_json1_1RedshiftDestinationDescription = function(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        ClusterJDBCURL: output.ClusterJDBCURL !== undefined && output.ClusterJDBCURL !== null ? output.ClusterJDBCURL : undefined,
        CopyCommand: output.CopyCommand !== undefined && output.CopyCommand !== null ? deserializeAws_json1_1CopyCommand(output.CopyCommand, context) : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1RedshiftRetryOptions(output.RetryOptions, context) : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        S3BackupDescription: output.S3BackupDescription !== undefined && output.S3BackupDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3BackupDescription, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined,
        Username: output.Username !== undefined && output.Username !== null ? output.Username : undefined
    };
};
var deserializeAws_json1_1RedshiftRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1ResourceInUseException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1S3DestinationDescription = function(output, context) {
    return {
        BucketARN: output.BucketARN !== undefined && output.BucketARN !== null ? output.BucketARN : undefined,
        BufferingHints: output.BufferingHints !== undefined && output.BufferingHints !== null ? deserializeAws_json1_1BufferingHints(output.BufferingHints, context) : undefined,
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        CompressionFormat: output.CompressionFormat !== undefined && output.CompressionFormat !== null ? output.CompressionFormat : undefined,
        EncryptionConfiguration: output.EncryptionConfiguration !== undefined && output.EncryptionConfiguration !== null ? deserializeAws_json1_1EncryptionConfiguration(output.EncryptionConfiguration, context) : undefined,
        ErrorOutputPrefix: output.ErrorOutputPrefix !== undefined && output.ErrorOutputPrefix !== null ? output.ErrorOutputPrefix : undefined,
        Prefix: output.Prefix !== undefined && output.Prefix !== null ? output.Prefix : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined
    };
};
var deserializeAws_json1_1SchemaConfiguration = function(output, context) {
    return {
        CatalogId: output.CatalogId !== undefined && output.CatalogId !== null ? output.CatalogId : undefined,
        DatabaseName: output.DatabaseName !== undefined && output.DatabaseName !== null ? output.DatabaseName : undefined,
        Region: output.Region !== undefined && output.Region !== null ? output.Region : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        TableName: output.TableName !== undefined && output.TableName !== null ? output.TableName : undefined,
        VersionId: output.VersionId !== undefined && output.VersionId !== null ? output.VersionId : undefined
    };
};
var deserializeAws_json1_1SecurityGroupIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Serializer = function(output, context) {
    return {
        OrcSerDe: output.OrcSerDe !== undefined && output.OrcSerDe !== null ? deserializeAws_json1_1OrcSerDe(output.OrcSerDe, context) : undefined,
        ParquetSerDe: output.ParquetSerDe !== undefined && output.ParquetSerDe !== null ? deserializeAws_json1_1ParquetSerDe(output.ParquetSerDe, context) : undefined
    };
};
var deserializeAws_json1_1ServiceUnavailableException = function(output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined
    };
};
var deserializeAws_json1_1SourceDescription = function(output, context) {
    return {
        KinesisStreamSourceDescription: output.KinesisStreamSourceDescription !== undefined && output.KinesisStreamSourceDescription !== null ? deserializeAws_json1_1KinesisStreamSourceDescription(output.KinesisStreamSourceDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkDestinationDescription = function(output, context) {
    return {
        CloudWatchLoggingOptions: output.CloudWatchLoggingOptions !== undefined && output.CloudWatchLoggingOptions !== null ? deserializeAws_json1_1CloudWatchLoggingOptions(output.CloudWatchLoggingOptions, context) : undefined,
        HECAcknowledgmentTimeoutInSeconds: output.HECAcknowledgmentTimeoutInSeconds !== undefined && output.HECAcknowledgmentTimeoutInSeconds !== null ? output.HECAcknowledgmentTimeoutInSeconds : undefined,
        HECEndpoint: output.HECEndpoint !== undefined && output.HECEndpoint !== null ? output.HECEndpoint : undefined,
        HECEndpointType: output.HECEndpointType !== undefined && output.HECEndpointType !== null ? output.HECEndpointType : undefined,
        HECToken: output.HECToken !== undefined && output.HECToken !== null ? output.HECToken : undefined,
        ProcessingConfiguration: output.ProcessingConfiguration !== undefined && output.ProcessingConfiguration !== null ? deserializeAws_json1_1ProcessingConfiguration(output.ProcessingConfiguration, context) : undefined,
        RetryOptions: output.RetryOptions !== undefined && output.RetryOptions !== null ? deserializeAws_json1_1SplunkRetryOptions(output.RetryOptions, context) : undefined,
        S3BackupMode: output.S3BackupMode !== undefined && output.S3BackupMode !== null ? output.S3BackupMode : undefined,
        S3DestinationDescription: output.S3DestinationDescription !== undefined && output.S3DestinationDescription !== null ? deserializeAws_json1_1S3DestinationDescription(output.S3DestinationDescription, context) : undefined
    };
};
var deserializeAws_json1_1SplunkRetryOptions = function(output, context) {
    return {
        DurationInSeconds: output.DurationInSeconds !== undefined && output.DurationInSeconds !== null ? output.DurationInSeconds : undefined
    };
};
var deserializeAws_json1_1StartDeliveryStreamEncryptionOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1StopDeliveryStreamEncryptionOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1SubnetIdList = function(output, context) {
    return (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var deserializeAws_json1_1Tag = function(output, context) {
    return {
        Key: output.Key !== undefined && output.Key !== null ? output.Key : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined
    };
};
var deserializeAws_json1_1TagDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1UntagDeliveryStreamOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1UpdateDestinationOutput = function(output, context) {
    return {};
};
var deserializeAws_json1_1VpcConfigurationDescription = function(output, context) {
    return {
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        SecurityGroupIds: output.SecurityGroupIds !== undefined && output.SecurityGroupIds !== null ? deserializeAws_json1_1SecurityGroupIdList(output.SecurityGroupIds, context) : undefined,
        SubnetIds: output.SubnetIds !== undefined && output.SubnetIds !== null ? deserializeAws_json1_1SubnetIdList(output.SubnetIds, context) : undefined,
        VpcId: output.VpcId !== undefined && output.VpcId !== null ? output.VpcId : undefined
    };
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var buildHttpRpcRequest = function(context, headers, path, resolvedHostname, body) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, contents;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    contents = {
                        protocol: protocol,
                        hostname: hostname,
                        port: port,
                        method: "POST",
                        path: path,
                        headers: headers
                    };
                    if (resolvedHostname !== undefined) contents.hostname = resolvedHostname;
                    if (body !== undefined) contents.body = body;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)(contents)
                    ];
            }
        });
    });
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mvSm":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonPersonalizeProvider", ()=>AmazonPersonalizeProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _clientPersonalizeEvents = require("@aws-sdk/client-personalize-events");
var _amazonPersonalizeHelper = require("./AmazonPersonalizeHelper");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _userAgent = require("../utils/UserAgent");
var logger = new (0, _core.ConsoleLogger)("AmazonPersonalizeProvider");
// events buffer
var FLUSH_SIZE = 5;
var FLUSH_SIZE_THRESHHOLD = 10;
var FLUSH_INTERVAL = 5000; // 5s
var IDENTIFY_EVENT = "Identify";
var AmazonPersonalizeProvider = /** @class */ function() {
    function AmazonPersonalizeProvider(config) {
        this._buffer = [];
        this._config = config ? config : {};
        this._config.flushSize = this._config.flushSize > 0 && this._config.flushSize <= FLUSH_SIZE_THRESHHOLD ? this._config.flushSize : FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || FLUSH_INTERVAL;
        this._sessionManager = new (0, _amazonPersonalizeHelper.SessionInfoManager)();
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        // flush event buffer
        this._setupTimer();
    }
    AmazonPersonalizeProvider.prototype._setupTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var flushInterval = this._config.flushInterval;
        var that = this;
        this._timer = setInterval(function() {
            that._sendFromBuffer();
        }, flushInterval);
    };
    /**
     * Record event
     * @param eventType      - type of the event action. e.g. "Click"
     * @param properties     - properties of the event
     * @return Promise
     */ AmazonPersonalizeProvider.prototype.record = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, _a, eventType, properties, requestParams, isLoaded;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials,
                            sentAt: new Date()
                        });
                        _a = params.event, eventType = _a.eventType, properties = _a.properties;
                        if (eventType === IDENTIFY_EVENT) {
                            this._sessionManager.updateSessionInfo(properties && properties.userId ? properties.userId : "", this._sessionInfo);
                            return [
                                2 /*return*/ 
                            ];
                        } else if (!(0, _isEmptyDefault.default)(params.event.userId)) this._sessionManager.updateSessionInfo(params.event.userId, this._sessionInfo);
                        requestParams = this.generateRequestParams(params, this._sessionInfo);
                        if (!(eventType === "MediaAutoTrack")) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!this._isBrowser) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!!(0, _isEmptyDefault.default)((0, _getDefault.default)(requestParams, "eventData.properties.domElementId", null))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.isElementFullyLoaded(this.loadElement, requestParams.eventData.properties["domElementId"], 500, 5)
                        ];
                    case 2:
                        isLoaded = _b.sent();
                        if (isLoaded) new (0, _amazonPersonalizeHelper.MediaAutoTrack)(requestParams, this);
                        else logger.debug("Cannot find the media element.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        logger.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type.");
                        _b.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        logger.debug("MediaAutoTrack only for browser");
                        _b.label = 6;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            this.putToBuffer(requestParams)
                        ];
                }
            });
        });
    };
    AmazonPersonalizeProvider.prototype.loadElement = function(domId) {
        return new Promise(function(resolve, reject) {
            if (document.getElementById(domId) && document.getElementById(domId).clientHeight) return resolve(true);
            else return reject(true);
        });
    };
    AmazonPersonalizeProvider.prototype.isElementFullyLoaded = function(operation, params, delay, times) {
        var _this = this;
        var wait = function(ms) {
            return new Promise(function(r) {
                return setTimeout(r, ms);
            });
        };
        return new Promise(function(resolve, reject) {
            return operation(params).then(resolve).catch(function(reason) {
                if (times - 1 > 0) return wait(delay).then(_this.isElementFullyLoaded.bind(null, operation, params, delay, times - 1)).then(resolve).catch(reject);
                return reject(reason);
            });
        });
    };
    /**
     * get the category of the plugin
     */ AmazonPersonalizeProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AmazonPersonalizeProvider.prototype.getProviderName = function() {
        return "AmazonPersonalize";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AmazonPersonalizeProvider.prototype.configure = function(config) {
        logger.debug("configure Analytics", config);
        var conf = config ? config : {};
        this._config = Object.assign({}, this._config, conf);
        if (!(0, _isEmptyDefault.default)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._setupTimer();
        return this._config;
    };
    /**
     * Generate the requestParams from customer input params and sessionInfo
     * @private
     * @param eventData      - customer input for event data
     * @param api            - api name
     * @return RequestParams - wrapper object with all information required for make request
     */ AmazonPersonalizeProvider.prototype.generateRequestParams = function(params, sessionInfo) {
        var requestParams = {};
        var _a = params.event, eventType = _a.eventType, properties = _a.properties;
        requestParams.eventData = {
            eventType: eventType,
            properties: properties
        };
        requestParams.sessionInfo = sessionInfo;
        requestParams.sentAt = params.sentAt;
        requestParams.credentials = params.credentials;
        requestParams.config = params.config;
        return requestParams;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AmazonPersonalizeProvider.prototype._sendEvents = function(group) {
        var groupLen = group.length;
        if (groupLen === 0) {
            logger.debug("events array is empty, directly return");
            return;
        }
        var _a = group[0], config = _a.config, credentials = _a.credentials, sessionInfo = _a.sessionInfo;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        if (groupLen > 0) {
            var events = [];
            for(var i = 0; i < groupLen; i += 1){
                var params = group.shift();
                var eventPayload = this._generateSingleRecordPayload(params, sessionInfo);
                events.push(eventPayload);
            }
            var payload_1 = {};
            payload_1.trackingId = sessionInfo.trackingId;
            payload_1.sessionId = sessionInfo.sessionId;
            payload_1.userId = sessionInfo.userId;
            payload_1.eventList = [];
            events.forEach(function(event) {
                // @ts-ignore
                payload_1.eventList.push(event);
            });
            var command = new (0, _clientPersonalizeEvents.PutEventsCommand)(payload_1);
            this._personalize.send(command, function(err) {
                if (err) logger.debug("Failed to call putEvents in Personalize", err);
                else logger.debug("Put events");
            });
        }
    };
    /**
     * Put event into buffer
     * @private
     * @param params - params for the event recording
     */ AmazonPersonalizeProvider.prototype.putToBuffer = function(params) {
        if (this._buffer.length < this._config.flushSize) this._buffer.push(params);
        else {
            this._buffer.push(params);
            this._sendFromBuffer();
        }
        return Promise.resolve(true);
    };
    /**
     * flush the buffer and batch sending the request
     * @private
     * @param eventsParams - the buffer for cache the payload
     */ AmazonPersonalizeProvider.prototype._sendFromBuffer = function() {
        var _this = this;
        var size = this._buffer.length;
        if (size <= 0) return;
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < size; i += 1){
            var currRequestParams = this._buffer.shift();
            var cred = currRequestParams.credentials;
            var sessionInfo = currRequestParams.sessionInfo;
            if (i === 0) {
                group.push(currRequestParams);
                preCred = cred;
            } else if ((0, _isEqualDefault.default)(sessionInfo, this._sessionInfo) && cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                logger.debug("no change for cred, put event in the same group");
                group.push(currRequestParams);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(currRequestParams);
                preCred = cred;
                this._sessionInfo = sessionInfo;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(group) {
            _this._sendEvents(group);
        });
    };
    /**
     * Generate the record payload for single event
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._generateSingleRecordPayload = function(params, sessionInfo) {
        var eventData = params.eventData, sentAt = params.sentAt;
        var trackPayload = {};
        trackPayload.sentAt = sentAt;
        trackPayload.properties = eventData.properties && JSON.stringify(eventData.properties);
        trackPayload.eventId = this._sessionManager.getTimerKey() + sessionInfo.sessionId;
        trackPayload.eventType = eventData.eventType;
        return trackPayload;
    };
    /**
     * Initialize the personalize client
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._init = function(config, credentials) {
        logger.debug("init clients");
        if (this._personalize && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        logger.debug("initialize personalize with credentials", credentials);
        this._personalize = new (0, _clientPersonalizeEvents.PersonalizeEventsClient)({
            region: region,
            credentials: credentials,
            customUserAgent: (0, _userAgent.getAnalyticsUserAgent)((0, _core.AnalyticsAction).Record)
        });
        return true;
    };
    /**
     * check if current credentials exists
     * @private
     */ AmazonPersonalizeProvider.prototype._getCredentials = function() {
        var that = this;
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return null;
            logger.debug("set credentials for analytics", that._config.credentials);
            return (0, _core.Credentials).shear(credentials);
        }).catch(function(err) {
            logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AmazonPersonalizeProvider;
}();

},{"tslib":"eOnzl","@aws-amplify/core":"3rlh1","@aws-sdk/client-personalize-events":"ljv3X","./AmazonPersonalizeHelper":"ckMSu","lodash/get":"jeneQ","lodash/isEmpty":"15wZF","lodash/isEqual":"6bbKw","../utils/UserAgent":"gxK6D","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ljv3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _personalizeEventsClient = require("./PersonalizeEventsClient");
parcelHelpers.exportAll(_personalizeEventsClient, exports);
var _personalizeEvents = require("./PersonalizeEvents");
parcelHelpers.exportAll(_personalizeEvents, exports);
var _putEventsCommand = require("./commands/PutEventsCommand");
parcelHelpers.exportAll(_putEventsCommand, exports);
var _putItemsCommand = require("./commands/PutItemsCommand");
parcelHelpers.exportAll(_putItemsCommand, exports);
var _putUsersCommand = require("./commands/PutUsersCommand");
parcelHelpers.exportAll(_putUsersCommand, exports);
var _index = require("./models/index");
parcelHelpers.exportAll(_index, exports);

},{"./PersonalizeEventsClient":"1TRdF","./PersonalizeEvents":false,"./commands/PutEventsCommand":"1G0l4","./commands/PutItemsCommand":false,"./commands/PutUsersCommand":false,"./models/index":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1TRdF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PersonalizeEventsClient", ()=>PersonalizeEventsClient);
var _tslib = require("tslib");
var _runtimeConfig = require("./runtimeConfig");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Amazon Personalize can consume real-time user event data, such as <i>stream</i> or <i>click</i> data, and use
 *       it for model training either alone or combined with historical data. For more information see <a>recording-events</a>.</p>
 */ var PersonalizeEventsClient = /** @class */ function(_super) {
    (0, _tslib.__extends)(PersonalizeEventsClient, _super);
    function PersonalizeEventsClient(configuration) {
        var _this = this;
        var _config_0 = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfig.ClientDefaultValues)), configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_2);
        var _config_4 = (0, _middlewareRetry.resolveRetryConfig)(_config_3);
        var _config_5 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    PersonalizeEventsClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return PersonalizeEventsClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","./runtimeConfig":"h2SFZ","@aws-sdk/config-resolver":"kfZQF","@aws-sdk/middleware-content-length":"g0Zhq","@aws-sdk/middleware-host-header":"jHFHF","@aws-sdk/middleware-logger":"dyXzC","@aws-sdk/middleware-retry":"822il","@aws-sdk/middleware-signing":"chM5Y","@aws-sdk/middleware-user-agent":"kIyUO","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h2SFZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientDefaultValues", ()=>ClientDefaultValues);
var _tslib = require("tslib");
var _packageJson = require("./package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var ClientDefaultValues = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _runtimeConfigShared.ClientSharedValues)), {
    runtime: "browser",
    base64Decoder: (0, _utilBase64Browser.fromBase64),
    base64Encoder: (0, _utilBase64Browser.toBase64),
    bodyLengthChecker: (0, _utilBodyLengthBrowser.calculateBodyLength),
    credentialDefaultProvider: function(_) {
        return function() {
            return Promise.reject(new Error("Credential is missing"));
        };
    },
    defaultUserAgentProvider: (0, _utilUserAgentBrowser.defaultUserAgent)({
        serviceId: (0, _runtimeConfigShared.ClientSharedValues).serviceId,
        clientVersion: (0, _packageJsonDefault.default).version
    }),
    maxAttempts: (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
    region: (0, _invalidDependency.invalidProvider)("Region is missing"),
    requestHandler: new (0, _fetchHttpHandler.FetchHttpHandler)(),
    sha256: (0, _sha256Browser.Sha256),
    streamCollector: (0, _fetchHttpHandler.streamCollector),
    utf8Decoder: (0, _utilUtf8Browser.fromUtf8),
    utf8Encoder: (0, _utilUtf8Browser.toUtf8)
});

},{"tslib":"86BcK","./package.json":"febmM","@aws-crypto/sha256-browser":"cEl0z","@aws-sdk/fetch-http-handler":"lTbku","@aws-sdk/invalid-dependency":"iUhkq","@aws-sdk/middleware-retry":"822il","@aws-sdk/util-base64-browser":"kTMBh","@aws-sdk/util-body-length-browser":"jY9Ci","@aws-sdk/util-user-agent-browser":"3ohFm","@aws-sdk/util-utf8-browser":"iZmxX","./runtimeConfig.shared":"eioSM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"febmM":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-personalize-events","description":"AWS SDK for JavaScript Personalize Events Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-personalize-events","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-personalize-events"}}');

},{}],"eioSM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSharedValues", ()=>ClientSharedValues);
var _endpoints = require("./endpoints");
var _urlParser = require("@aws-sdk/url-parser");
var ClientSharedValues = {
    apiVersion: "2018-03-22",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: (0, _endpoints.defaultRegionInfoProvider),
    serviceId: "Personalize Events",
    urlParser: (0, _urlParser.parseUrl)
};

},{"./endpoints":"4ncNE","@aws-sdk/url-parser":"3j6kE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ncNE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
// Partition default templates
var AWS_TEMPLATE = "personalize-events.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "personalize-events.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "personalize-events.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "personalize-events.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "personalize-events.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2"
]);
var AWS_CN_REGIONS = new Set([
    "cn-north-1",
    "cn-northwest-1"
]);
var AWS_ISO_REGIONS = new Set([
    "us-iso-east-1"
]);
var AWS_ISO_B_REGIONS = new Set([
    "us-isob-east-1"
]);
var AWS_US_GOV_REGIONS = new Set([
    "us-gov-east-1",
    "us-gov-west-1"
]);
var defaultRegionInfoProvider = function(region, options) {
    var regionInfo = undefined;
    region;
    if (AWS_REGIONS.has(region)) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    if (AWS_CN_REGIONS.has(region)) regionInfo = {
        hostname: AWS_CN_TEMPLATE.replace("{region}", region),
        partition: "aws-cn"
    };
    if (AWS_ISO_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
        partition: "aws-iso"
    };
    if (AWS_ISO_B_REGIONS.has(region)) regionInfo = {
        hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
        partition: "aws-iso-b"
    };
    if (AWS_US_GOV_REGIONS.has(region)) regionInfo = {
        hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
        partition: "aws-us-gov"
    };
    // Finally, assume it's an AWS partition endpoint.
    if (regionInfo === undefined) regionInfo = {
        hostname: AWS_TEMPLATE.replace("{region}", region),
        partition: "aws"
    };
    return Promise.resolve((0, _tslib.__assign)({
        signingService: "personalize"
    }, regionInfo));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1G0l4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PutEventsCommand", ()=>PutEventsCommand);
var _tslib = require("tslib");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
/**
 * <p>Records user interaction event data. For more information see <a>event-record-api</a>.</p>
 */ var PutEventsCommand = /** @class */ function(_super) {
    (0, _tslib.__extends)(PutEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutEventsCommand(input) {
        var _this = // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
    // End section: command_constructor
    }
    /**
     * @internal
     */ PutEventsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PersonalizeEventsClient";
        var commandName = "PutEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PutEventsRequest).filterSensitiveLog,
            outputFilterSensitiveLog: function(output) {
                return output;
            }
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutEventsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PutEventsCommand)(input, context);
    };
    PutEventsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PutEventsCommand)(output, context);
    };
    return PutEventsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","../models/models_0":"jDuD1","../protocols/Aws_restJson1":"dH2Ht","@aws-sdk/middleware-serde":"1RCV6","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDuD1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvalidInputException", ()=>InvalidInputException);
parcelHelpers.export(exports, "Event", ()=>Event);
parcelHelpers.export(exports, "PutEventsRequest", ()=>PutEventsRequest);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "PutItemsRequest", ()=>PutItemsRequest);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "User", ()=>User);
parcelHelpers.export(exports, "PutUsersRequest", ()=>PutUsersRequest);
var _tslib = require("tslib");
var InvalidInputException;
(function(InvalidInputException) {
    InvalidInputException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(InvalidInputException || (InvalidInputException = {}));
var Event;
(function(Event) {
    Event.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Event || (Event = {}));
var PutEventsRequest;
(function(PutEventsRequest) {
    PutEventsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutEventsRequest || (PutEventsRequest = {}));
var Item;
(function(Item) {
    Item.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(Item || (Item = {}));
var PutItemsRequest;
(function(PutItemsRequest) {
    PutItemsRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutItemsRequest || (PutItemsRequest = {}));
var ResourceNotFoundException;
(function(ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var User;
(function(User) {
    User.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(User || (User = {}));
var PutUsersRequest;
(function(PutUsersRequest) {
    PutUsersRequest.filterSensitiveLog = function(obj) {
        return (0, _tslib.__assign)({}, obj);
    };
})(PutUsersRequest || (PutUsersRequest = {}));

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dH2Ht":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1PutEventsCommand", ()=>serializeAws_restJson1PutEventsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutItemsCommand", ()=>serializeAws_restJson1PutItemsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutUsersCommand", ()=>serializeAws_restJson1PutUsersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutEventsCommand", ()=>deserializeAws_restJson1PutEventsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutItemsCommand", ()=>deserializeAws_restJson1PutItemsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutUsersCommand", ()=>deserializeAws_restJson1PutUsersCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var serializeAws_restJson1PutEventsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/events";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventList !== undefined && input.eventList !== null && {
                        eventList: serializeAws_restJson1EventList(input.eventList, context)
                    }), input.sessionId !== undefined && input.sessionId !== null && {
                        sessionId: input.sessionId
                    }), input.trackingId !== undefined && input.trackingId !== null && {
                        trackingId: input.trackingId
                    }), input.userId !== undefined && input.userId !== null && {
                        userId: input.userId
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutItemsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/items";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.items !== undefined && input.items !== null && {
                        items: serializeAws_restJson1ItemList(input.items, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutUsersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var headers, resolvedPath, body, _a, hostname, _b, protocol, port;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "/users";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.datasetArn !== undefined && input.datasetArn !== null && {
                        datasetArn: input.datasetArn
                    }), input.users !== undefined && input.users !== null && {
                        users: serializeAws_restJson1UserList(input.users, context)
                    }));
                    return [
                        4 /*yield*/ ,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                    return [
                        2 /*return*/ ,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutEventsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutEventsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
        var _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _d = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_d.body = _e.sent(), _d)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _e.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 4:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _e.label = 5;
                case 5:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutItemsCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutItemsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2 /*return*/ ,
                        deserializeAws_restJson1PutUsersCommandError(output, context)
                    ];
                    contents = {
                        $metadata: deserializeMetadata(output)
                    };
                    return [
                        4 /*yield*/ ,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        Promise.resolve(contents)
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutUsersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
        var _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _e = {};
                    return [
                        4 /*yield*/ ,
                        parseBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_e.body = _f.sent(), _e)
                    ]));
                    errorCode = "UnknownError";
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "com.amazonaws.personalizeevents#InvalidInputException":
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case "com.amazonaws.personalizeevents#ResourceNotFoundException":
                            return [
                                3 /*break*/ ,
                                4
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 2:
                    _c = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1InvalidInputExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _c.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 4:
                    _d = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    response = (0, _tslib.__assign).apply(void 0, [
                        (0, _tslib.__assign).apply(void 0, _d.concat([
                            _f.sent()
                        ])),
                        {
                            name: errorCode,
                            $metadata: deserializeMetadata(output)
                        }
                    ]);
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    parsedBody = parsedOutput.body;
                    errorCode = parsedBody.code || parsedBody.Code || errorCode;
                    response = (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedBody), {
                        name: "" + errorCode,
                        message: parsedBody.message || parsedBody.Message || errorCode,
                        $fault: "client",
                        $metadata: deserializeMetadata(output)
                    });
                    _f.label = 7;
                case 7:
                    message = response.message || response.Message || errorCode;
                    response.message = message;
                    delete response.Message;
                    return [
                        2 /*return*/ ,
                        Promise.reject(Object.assign(new Error(message), response))
                    ];
            }
        });
    });
};
var deserializeAws_restJson1InvalidInputExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "InvalidInputException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = {
                name: "ResourceNotFoundException",
                $fault: "client",
                $metadata: deserializeMetadata(parsedOutput),
                message: undefined
            };
            data = parsedOutput.body;
            if (data.message !== undefined && data.message !== null) contents.message = data.message;
            return [
                2 /*return*/ ,
                contents
            ];
        });
    });
};
var serializeAws_restJson1Event = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.eventId !== undefined && input.eventId !== null && {
        eventId: input.eventId
    }), input.eventType !== undefined && input.eventType !== null && {
        eventType: input.eventType
    }), input.eventValue !== undefined && input.eventValue !== null && {
        eventValue: input.eventValue
    }), input.impression !== undefined && input.impression !== null && {
        impression: serializeAws_restJson1Impression(input.impression, context)
    }), input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.recommendationId !== undefined && input.recommendationId !== null && {
        recommendationId: input.recommendationId
    }), input.sentAt !== undefined && input.sentAt !== null && {
        sentAt: Math.round(input.sentAt.getTime() / 1000)
    });
};
var serializeAws_restJson1EventList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Event(entry, context);
    });
};
var serializeAws_restJson1Impression = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return entry;
    });
};
var serializeAws_restJson1Item = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.itemId !== undefined && input.itemId !== null && {
        itemId: input.itemId
    }), input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    });
};
var serializeAws_restJson1ItemList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1Item(entry, context);
    });
};
var serializeAws_restJson1User = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.properties !== undefined && input.properties !== null && {
        properties: (0, _smithyClient.LazyJsonString).fromObject(input.properties)
    }), input.userId !== undefined && input.userId !== null && {
        userId: input.userId
    });
};
var serializeAws_restJson1UserList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return serializeAws_restJson1User(entry, context);
    });
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */ var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
    return "";
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"bfGiN","@aws-sdk/smithy-client":"6UNh4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ckMSu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", ()=>(0, _sessionInfoManager.SessionInfoManager));
parcelHelpers.export(exports, "MediaAutoTrack", ()=>(0, _mediaAutoTrack.MediaAutoTrack));
var _sessionInfoManager = require("./SessionInfoManager");
var _mediaAutoTrack = require("./MediaAutoTrack");

},{"./SessionInfoManager":"Nivvt","./MediaAutoTrack":"lo4lH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Nivvt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionInfoManager", ()=>SessionInfoManager);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _uuid = require("uuid");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var PERSONALIZE_CACHE = "_awsct";
var PERSONALIZE_CACHE_USERID = "_awsct_uid";
var PERSONALIZE_CACHE_SESSIONID = "_awsct_sid";
var DEFAULT_CACHE_PREFIX = "personalize";
var TIMER_INTERVAL = 30000;
var DELIMITER = ".";
var CACHE_EXPIRY_IN_DAYS = 7;
var logger = new (0, _core.ConsoleLogger)("AmazonPersonalizeProvider");
var SessionInfoManager = /** @class */ function() {
    function SessionInfoManager(prefixKey) {
        if (prefixKey === void 0) prefixKey = "";
        this._isBrowser = (0, _core.browserOrNode)().isBrowser;
        this._timerKey = (0, _uuid.v1)().substr(0, 15);
        this._refreshTimer();
    }
    SessionInfoManager.prototype._refreshTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var that = this;
        this._timer = setInterval(function() {
            that._timerKey = (0, _uuid.v1)().substr(0, 15);
        }, TIMER_INTERVAL);
    };
    SessionInfoManager.prototype.storeValue = function(key, value) {
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 86400000 * CACHE_EXPIRY_IN_DAYS);
        (0, _cache.Cache).setItem(this._getCachePrefix(key), value, {
            expires: expire.getTime()
        });
    };
    SessionInfoManager.prototype.retrieveValue = function(key) {
        return (0, _cache.Cache).getItem(this._getCachePrefix(key));
    };
    SessionInfoManager.prototype._getCachePrefix = function(key) {
        if (this._isBrowser) return key + DELIMITER + window.location.host;
        return DEFAULT_CACHE_PREFIX;
    };
    SessionInfoManager.prototype.getTimerKey = function() {
        return this._timerKey;
    };
    SessionInfoManager.prototype.updateSessionInfo = function(userId, sessionInfo) {
        var existUserId = sessionInfo.userId;
        var existSessionId = sessionInfo.sessionId;
        if (this._isRequireNewSession(userId, existUserId, existSessionId)) {
            var newSessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_USERID, userId);
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, newSessionId);
            sessionInfo.sessionId = newSessionId;
        } else if (this._isRequireUpdateSessionInfo(userId, existUserId, existSessionId)) this.storeValue(PERSONALIZE_CACHE_USERID, userId);
        sessionInfo.userId = userId;
    };
    SessionInfoManager.prototype._isRequireUpdateSessionInfo = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // anonymouse => sign in : hasSession && s_userId == null && curr_userId !=null
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        return !isNoCachedSession && (0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEmptyDefault.default)(userId);
    };
    SessionInfoManager.prototype.retrieveSessionInfo = function(trackingId) {
        var sessionInfo = {};
        sessionInfo.trackingId = trackingId;
        sessionInfo.sessionId = this.retrieveValue(PERSONALIZE_CACHE_SESSIONID);
        sessionInfo.userId = this.retrieveValue(PERSONALIZE_CACHE_USERID);
        if ((0, _isEmptyDefault.default)(sessionInfo.sessionId)) {
            sessionInfo.sessionId = (0, _uuid.v1)();
            this.storeValue(PERSONALIZE_CACHE_SESSIONID, sessionInfo.sessionId);
        }
        this.storeValue(PERSONALIZE_CACHE, trackingId);
        return sessionInfo;
    };
    SessionInfoManager.prototype._isRequireNewSession = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // new session => 1. no cached session info 2. signOut: s_userId !=null && curr_userId ==null
        // 3. switch account: s_userId !=null && curr_userId !=null && s_userId != curr_userId
        var isNoCachedSession = (0, _isEmptyDefault.default)(cachedSessionSessionId);
        var isSignoutCase = (0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId);
        var isSwitchUserCase = !(0, _isEmptyDefault.default)(userId) && !(0, _isEmptyDefault.default)(cachedSessionUserId) && !(0, _isEqualDefault.default)(userId, cachedSessionUserId);
        return isNoCachedSession || isSignoutCase || isSwitchUserCase;
    };
    return SessionInfoManager;
}();

},{"lodash/isEmpty":"15wZF","lodash/isEqual":"6bbKw","uuid":"aP4lL","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15wZF":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"bPWWi","d63799a808049d04":"58o8p","1f4ee6aee3a7eae0":"jmDAu","b708be4f72c2a706":"jQGs4","ab4b4eaf96f9163a":"mL7I2","80b58ade5ee2f70":"5BMZo","3a444e8bd8b275f2":"36IG4","6af418b3352c301b":"cJbMf"}],"bPWWi":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"36IG4","3ec652610d8dd5d3":"208F5"}],"36IG4":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"208F5":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"2fV7A"}],"2fV7A":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"58o8p":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"53qXk","28e3344aae951f13":"03QB1","b286298be5b1d9a4":"7ryvA","3ae50c158f89813":"lp29B","9f458755f627d456":"g0Y3e","8e9160b373d7fe66":"iuqvy","b210627dd951641f":"7w7D8"}],"53qXk":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"bRlM4","f83c375075418382":"cN4l5"}],"bRlM4":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"6n7j5","16db51a0e009bd8c":"aeApT"}],"6n7j5":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"8ck2f","cabbc2adfaeb27d9":"8lEuR","cbb5703fe1562e7f":"8ffGS","388b819f47a43aa5":"7w7D8"}],"8ck2f":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"iuqvy","3cba3c966459d528":"8ffGS"}],"iuqvy":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"aflde","9b2aaf31b7bdd837":"6KCfR","46d5beb3375f8a28":"exVj8"}],"aflde":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"cN4l5"}],"cN4l5":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"iHmGM"}],"iHmGM":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"6KCfR":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"aflde"}],"exVj8":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"8ffGS":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"8lEuR":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"fMSAF"}],"fMSAF":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"cN4l5"}],"7w7D8":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"aeApT":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"03QB1":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"bRlM4","29224713b8d411e6":"cN4l5"}],"7ryvA":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"bRlM4","a5c6637bac681a0":"cN4l5"}],"lp29B":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"bRlM4","ca486d41cdf819d4":"cN4l5"}],"g0Y3e":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"bRlM4","7a9a6581834a8452":"cN4l5"}],"jmDAu":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"hvpUQ","bead821d6af018b5":"lm2eo"}],"hvpUQ":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"iuqvy","b6cdbe52dcf709f8":"lm2eo"}],"lm2eo":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"jQGs4":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"mL7I2":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"8ck2f","f3db08d4d1110aaf":"f9Q8Z"}],"f9Q8Z":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"5BMZo":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"cN4l5","a1e87b138cf75d1d":"h4jjK"}],"h4jjK":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"cJbMf":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"3GkRb","903f50eb1c16d257":"8g9lw","fa49853a82034c30":"hZg2H"}],"3GkRb":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"iuqvy","f661b3a120d7a4cb":"f9Q8Z","cdd86c83797c0618":"lm2eo"}],"8g9lw":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"hZg2H":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"iHmGM"}],"6bbKw":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"aP9FI"}],"aP9FI":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"l7P77","809bbb0c20650dbc":"lm2eo"}],"l7P77":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"hxIkB","96bc8a1825db53a5":"a10oQ","8bdece495e87fb69":"6izmf","bb94920432a68eca":"9k1JC","45495edff98e5837":"58o8p","18256411ae9e2858":"jQGs4","e5ba7abf54247fc5":"5BMZo","50d786bb5c7366af":"cJbMf"}],"hxIkB":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"4pLro","ceda2a63c77c915":"gXjo2","91ee1b348d9d7172":"fvPkJ","3fe28318f65b9332":"8WEr4","724ca4def8b84e06":"631vb","e9ceacb40d9582bd":"eXKez"}],"4pLro":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"bqAv0","b700cb849df2c166":"gu7Mx","d76dd90eead6cced":"6YLaC","3d210628ba60ec8":"5pysT","76026bf2d4cfff93":"5bMeQ"}],"bqAv0":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"gu7Mx":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"b99O6"}],"b99O6":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"8Gfg3"}],"8Gfg3":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"6YLaC":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"b99O6"}],"5pysT":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"b99O6"}],"5bMeQ":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"b99O6"}],"gXjo2":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"4pLro"}],"fvPkJ":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"8WEr4":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"631vb":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"eXKez":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"4pLro","1494efbafafa9552":"03QB1","6049e8027fe9407f":"CQbJD"}],"CQbJD":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"YzSka","d2967b0e32ccfa56":"d7ROV","ca21409ea89624c0":"5FZQk","f88fd07f8dd1f67d":"k11Cx","dbf3eae765642a3b":"hYpiP"}],"YzSka":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"63axu","a07dcf3fd3097a0c":"4pLro","92c01c953ef00ded":"03QB1"}],"63axu":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"iYuPM","bc25d439ccd1fb47":"kEVYK","f096b37295a92ab0":"4JYrB","d88173cbc6a133c8":"fm2qo","afb9b3bae0461cbf":"hodnJ"}],"iYuPM":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"c2chn"}],"c2chn":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bRlM4"}],"kEVYK":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"4JYrB":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"c2chn"}],"fm2qo":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"c2chn"}],"hodnJ":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"c2chn"}],"d7ROV":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"iz6u0"}],"iz6u0":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"43uyZ"}],"43uyZ":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"5FZQk":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"iz6u0"}],"k11Cx":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"iz6u0"}],"hYpiP":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"iz6u0"}],"a10oQ":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"h6Zwg","1ee20de911db0cb0":"3m5PV","defff3d81be91b23":"dF80X"}],"h6Zwg":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"CQbJD","9a831e81e9a1f98c":"hSWIH","1a2b6c8a7399c39f":"d1akK"}],"hSWIH":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"d1akK":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"3m5PV":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"dF80X":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"6izmf":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"aflde","dbf6aa5033a0f48":"aHxYs","539966708f906e61":"8Gfg3","8142d4017f0a425f":"a10oQ","48cddf732eff33ba":"hOBwA","9dc78b26c5daba20":"3eQLH"}],"aHxYs":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"cN4l5"}],"hOBwA":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"3eQLH":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"9k1JC":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lY5il"}],"lY5il":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"1VPsK","aa79b69a13f924db":"9pWhx","e3ad83e53433bc8a":"kLvI9"}],"1VPsK":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"iS8Vi","148b85918856c33a":"jQGs4"}],"iS8Vi":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"9pWhx":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"5GLUD","6b1c62cea92cdb9":"hZ3M8"}],"5GLUD":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"hZ3M8":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"kLvI9":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"vD0Yx","e8453365fdacc8da":"bPWWi","7760b47b02971dfa":"mL7I2"}],"vD0Yx":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"yuCUc","9cdb51ffa56f149b":"jmDAu","38cd49f1e493b3d7":"jQGs4","b379831fe1873fed":"5BMZo","f362a34cd8321bb7":"heeP8","c019db5297494469":"cJbMf"}],"yuCUc":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"heeP8":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"lo4lH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaAutoTrack", ()=>MediaAutoTrack);
var HTML5_MEDIA_EVENT;
(function(HTML5_MEDIA_EVENT) {
    HTML5_MEDIA_EVENT["PLAY"] = "play";
    HTML5_MEDIA_EVENT["PAUSE"] = "pause";
    HTML5_MEDIA_EVENT["ENDED"] = "Ended";
})(HTML5_MEDIA_EVENT || (HTML5_MEDIA_EVENT = {}));
var MEDIA_TYPE;
(function(MEDIA_TYPE) {
    MEDIA_TYPE["IFRAME"] = "IFRAME";
    MEDIA_TYPE["VIDEO"] = "VIDEO";
    MEDIA_TYPE["AUDIO"] = "AUDIO";
})(MEDIA_TYPE || (MEDIA_TYPE = {}));
var EVENT_TYPE;
(function(EVENT_TYPE) {
    EVENT_TYPE["PLAY"] = "Play";
    EVENT_TYPE["ENDED"] = "Ended";
    EVENT_TYPE["PAUSE"] = "Pause";
    EVENT_TYPE["TIME_WATCHED"] = "TimeWatched";
})(EVENT_TYPE || (EVENT_TYPE = {}));
var MediaAutoTrack = /** @class */ function() {
    function MediaAutoTrack(params, provider) {
        var _a;
        this.eventActionMapping = (_a = {}, _a[EVENT_TYPE.ENDED] = this.endedEventAction.bind(this), _a[EVENT_TYPE.PLAY] = this.playEventAction.bind(this), _a[EVENT_TYPE.PAUSE] = this.pauseEventAction.bind(this), _a);
        var eventData = params.eventData;
        this._params = params;
        this._mediaElement = document.getElementById(eventData.properties["domElementId"]);
        this._started = false;
        this._provider = provider;
        var mediaTrackFunMapping = {
            IFRAME: this._iframeMediaTracker,
            VIDEO: this._html5MediaTracker,
            AUDIO: this._html5MediaTracker
        };
        mediaTrackFunMapping[this._mediaElement.tagName].bind(this)();
        this._initYoutubeFrame();
    }
    MediaAutoTrack.prototype._initYoutubeFrame = function() {
        this._youTubeIframeLoader = {
            src: "https://www.youtube.com/iframe_api",
            loading: false,
            loaded: false,
            listeners: [],
            load: function(callback) {
                var _this = this;
                this.listeners.push(callback);
                if (this.loaded) {
                    setTimeout(function() {
                        _this.done();
                    });
                    return;
                }
                if (this.loading) return;
                this.loading = true;
                window["onYouTubeIframeAPIReady"] = function() {
                    _this.loaded = true;
                    _this.done();
                };
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = this.src;
                document.body.appendChild(script);
            },
            done: function() {
                delete window["onYouTubeIframeAPIReady"];
                while(this.listeners.length)this.listeners.pop()(window["YT"]);
            }
        };
    };
    MediaAutoTrack.prototype._iframeMediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.IFRAME, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._youTubeIframeLoader.load(function(YT) {
            that._iframePlayer = new YT.Player(that._mediaElement.id, {
                events: {
                    onStateChange: that._onPlayerStateChange.bind(that)
                }
            });
        });
    };
    MediaAutoTrack.prototype._onPlayerStateChange = function(event) {
        var iframeEventMapping = {
            0: EVENT_TYPE.ENDED,
            1: EVENT_TYPE.PLAY,
            2: EVENT_TYPE.PAUSE
        };
        var eventType = iframeEventMapping[event.data];
        if (eventType) this.eventActionMapping[eventType](MEDIA_TYPE.IFRAME);
    };
    MediaAutoTrack.prototype._html5MediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent(MEDIA_TYPE.VIDEO, EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PLAY, function() {
            that.eventActionMapping[EVENT_TYPE.PLAY](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.PAUSE, function() {
            that.eventActionMapping[EVENT_TYPE.PAUSE](MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener(HTML5_MEDIA_EVENT.ENDED, function() {
            that.eventActionMapping[EVENT_TYPE.ENDED](MEDIA_TYPE.VIDEO);
        }, false);
    };
    MediaAutoTrack.prototype.playEventAction = function(mediaType) {
        this._started = true;
        this.recordEvent(mediaType, EVENT_TYPE.PLAY);
    };
    MediaAutoTrack.prototype.pauseEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.PAUSE);
    };
    MediaAutoTrack.prototype.endedEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, EVENT_TYPE.ENDED);
    };
    MediaAutoTrack.prototype.recordEvent = function(mediaType, eventType) {
        var newParams = Object.assign({}, this._params);
        var eventData = newParams.eventData;
        eventData.eventType = eventType;
        var currentPlayTime;
        if (mediaType === MEDIA_TYPE.VIDEO) {
            currentPlayTime = this._mediaElement.currentTime;
            eventData.properties.duration = this._mediaElement.duration;
        } else {
            currentPlayTime = this._financial(this._iframePlayer.getCurrentTime());
            eventData.properties.duration = this._financial(this._iframePlayer.getDuration());
        }
        var percentage = parseFloat(currentPlayTime) / parseFloat(eventData.properties.duration);
        eventData.properties.eventValue = Number(percentage.toFixed(4));
        delete eventData.properties.domElementId;
        this._provider.putToBuffer(newParams);
    };
    MediaAutoTrack.prototype._financial = function(x) {
        return Number.parseFloat(x).toFixed(4);
    };
    return MediaAutoTrack;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jeneQ":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"3bgbL"}],"3bgbL":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"cLKKN","c3296f04fad32769":"ih6jk"}],"cLKKN":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"jQGs4","e823e604d75f975b":"gbNmb","f5fff1c342107fbd":"kcJlt","b04e8cc634273c23":"23Zly"}],"gbNmb":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"jQGs4","4cdff6c9e9ff5d38":"5eB4J"}],"5eB4J":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"iuqvy","74644060ad1a1d3c":"lm2eo"}],"kcJlt":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"axjLO"}],"axjLO":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"ajNZD"}],"ajNZD":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"CQbJD"}],"23Zly":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"33R5Z"}],"33R5Z":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"aflde","8439a3a1551d0706":"5ZiZU","4b12c9f502d3288a":"jQGs4","a0ebd327d618908a":"5eB4J"}],"5ZiZU":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"ih6jk":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"5eB4J"}],"ilv20":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth", ()=>(0, _auth.Auth));
parcelHelpers.export(exports, "CognitoUser", ()=>(0, _amazonCognitoIdentityJs.CognitoUser));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _amazonCognitoIdentityJs.CookieStorage));
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", ()=>(0, _auth1.CognitoHostedUIIdentityProvider));
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>(0, _amazonCognitoIdentityJs.appendToCognitoUserAgent));
parcelHelpers.export(exports, "AuthErrorStrings", ()=>(0, _authErrorStrings.AuthErrorStrings));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _auth1.GRAPHQL_AUTH_MODE));
var _auth = require("./Auth");
var _auth1 = require("./types/Auth");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _authErrorStrings = require("./common/AuthErrorStrings");
/**
 * @deprecated use named import
 */ exports.default = (0, _auth.Auth);

},{"./Auth":"4GZ7C","./types/Auth":"9VnfC","amazon-cognito-identity-js":"gyre7","./common/AuthErrorStrings":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4GZ7C":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthClass", ()=>AuthClass);
parcelHelpers.export(exports, "Auth", ()=>Auth);
var _tslib = require("tslib");
var _types = require("./types");
var _core = require("@aws-amplify/core");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _internals = require("amazon-cognito-identity-js/internals");
var _url = require("url");
var _oauth = require("./OAuth/OAuth");
var _oauthDefault = parcelHelpers.interopDefault(_oauth);
var _urlListener = require("./urlListener");
var _urlListenerDefault = parcelHelpers.interopDefault(_urlListener);
var _errors = require("./Errors");
var _auth = require("./types/Auth");
var logger = new (0, _core.ConsoleLogger)("AuthClass");
var USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var OAUTH_FLOW_MS_TIMEOUT = 10000;
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var MAX_DEVICES = 60;
var MAX_AUTOSIGNIN_POLLING_MS = 180000;
/**
 * Provide authentication steps
 */ var AuthClass = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.autoSignInInitiated = false;
        this.inflightSessionPromise = null;
        this.inflightSessionPromiseCounter = 0;
        this.Credentials = (0, _core.Credentials);
        this.wrapRefreshSessionCallback = function(callback) {
            var wrapped = function(error, data) {
                if (data) dispatchAuthEvent("tokenRefresh", undefined, "New token retrieved");
                else dispatchAuthEvent("tokenRefresh_failure", error, "Failed to retrieve new token");
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        (0, _core.Hub).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "verify":
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
        (0, _internals.addAuthCategoryToCognitoUserAgent)();
        (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        (0, _core.Platform).observeFrameworkChanges(function() {
            (0, _internals.addFrameworkToCognitoUserAgent)((0, _core.Platform).framework);
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, _core.parseAWSExports)(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint, storage = _a.storage;
        if (!storage) {
            // backward compatability
            if (cookieStorage) this._storage = new (0, _amazonCognitoIdentityJs.CookieStorage)(cookieStorage);
            else this._storage = config.ssr ? new (0, _core.UniversalStorage)() : new (0, _core.StorageHelper)().getStorage();
        } else {
            if (!this._isValidAuthStorage(storage)) {
                logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, _amazonCognitoIdentityJs.CognitoUserPool)(userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
            identityPoolRegion: identityPoolRegion
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, _types.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, _oauthDefault.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, _urlListenerDefault.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        if (!this.autoSignInInitiated && typeof this._storage["getItem"] === "function") {
            var pollingInitiated = this.isTrueStorageValue("amplify-polling-started");
            if (pollingInitiated) {
                dispatchAuthEvent("autoSignIn_failure", null, (0, _auth.AuthErrorTypes).AutoSignInError);
                this._storage.removeItem("amplify-auto-sign-in");
            }
            this._storage.removeItem("amplify-polling-started");
        }
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        var _a, _b, _c;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        var autoSignIn = {
            enabled: false
        };
        var autoSignInValidationData = {};
        var autoSignInClientMetaData = {};
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: "email",
                Value: email
            }));
            if (phone_number) attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                Name: "phone_number",
                Value: phone_number
            }));
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                attributes.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                    Name: key,
                    Value: attrs_1[key]
                }));
            });
            var validationDataObject_1 = params["validationData"];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function(key) {
                    validationData.push(new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)({
                        Name: key,
                        Value: validationDataObject_1[key]
                    }));
                });
            }
            autoSignIn = (_a = params.autoSignIn) !== null && _a !== void 0 ? _a : {
                enabled: false
            };
            if (autoSignIn.enabled) {
                this._storage.setItem("amplify-auto-sign-in", "true");
                autoSignInValidationData = (_b = autoSignIn.validationData) !== null && _b !== void 0 ? _b : {};
                autoSignInClientMetaData = (_c = autoSignIn.clientMetaData) !== null && _c !== void 0 ? _c : {};
            }
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        logger.debug("signUp attrs:", attributes);
        logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    if (autoSignIn.enabled) _this.handleAutoSignIn(username, password, autoSignInValidationData, autoSignInClientMetaData, data);
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.handleAutoSignIn = function(username, password, validationData, clientMetadata, data) {
        this.autoSignInInitiated = true;
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (data.userConfirmed) this.signInAfterUserConfirmed(authDetails);
        else if (this._config.signUpVerificationMethod === "link") this.handleLinkAutoSignIn(authDetails);
        else this.handleCodeAutoSignIn(authDetails);
    };
    AuthClass.prototype.handleCodeAutoSignIn = function(authDetails) {
        var _this = this;
        var listenEvent = function(_a) {
            var payload = _a.payload;
            if (payload.event === "confirmSignUp") _this.signInAfterUserConfirmed(authDetails, listenEvent);
        };
        (0, _core.Hub).listen("auth", listenEvent);
    };
    AuthClass.prototype.handleLinkAutoSignIn = function(authDetails) {
        var _this = this;
        this._storage.setItem("amplify-polling-started", "true");
        var start = Date.now();
        var autoSignInPollingIntervalId = setInterval(function() {
            if (Date.now() - start > MAX_AUTOSIGNIN_POLLING_MS) {
                clearInterval(autoSignInPollingIntervalId);
                dispatchAuthEvent("autoSignIn_failure", null, "Please confirm your account and use your credentials to sign in.");
                _this._storage.removeItem("amplify-auto-sign-in");
            } else _this.signInAfterUserConfirmed(authDetails, null, autoSignInPollingIntervalId);
        }, 5000);
    };
    AuthClass.prototype.signInAfterUserConfirmed = function(authDetails, listenEvent, autoSignInPollingIntervalId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var user, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user = this.createCognitoUser(authDetails.getUsername());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            user.authenticateUser(authDetails, this.authCallbacks(user, function(value) {
                                dispatchAuthEvent("autoSignIn", value, authDetails.getUsername() + " has signed in successfully");
                                if (listenEvent) (0, _core.Hub).remove("auth", listenEvent);
                                if (autoSignInPollingIntervalId) {
                                    clearInterval(autoSignInPollingIntervalId);
                                    _this._storage.removeItem("amplify-polling-started");
                                }
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }, function(error) {
                                logger.error(error);
                                _this._storage.removeItem("amplify-auto-sign-in");
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        logger.error(error_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else {
                    dispatchAuthEvent("confirmSignUp", data, username + " has been confirmed successfully");
                    var autoSignIn = _this.isTrueStorageValue("amplify-auto-sign-in");
                    if (autoSignIn && !_this.autoSignInInitiated) {
                        dispatchAuthEvent("autoSignIn_failure", null, (0, _auth.AuthErrorTypes).AutoSignInError);
                        _this._storage.removeItem("amplify-auto-sign-in");
                    }
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    AuthClass.prototype.isTrueStorageValue = function(value) {
        var item = this._storage.getItem(value);
        return item ? item === "true" : false;
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} pw - The password of the username
     * @param {ClientMetaData} clientMetadata - Client metadata for custom workflows
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, _types.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, _amazonCognitoIdentityJs.AuthenticationDetails)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                logger.debug("signIn failure", err);
                dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        if (this.pendingSignIn) throw new Error("Pending sign-in attempt already in progress");
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function(value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function(error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var _this = this;
        var that = this;
        return new Promise(function(res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_1, mfaType;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug("getting preferred mfa failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_1 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_1.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                mfaType = that._getMfaTypeFromUserData(data);
                                if (!mfaType) {
                                    rej("invalid MFA Type");
                                    return [
                                        2 /*return*/ 
                                    ];
                                } else {
                                    res(mfaType);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, {
                bypassCache: bypassCache,
                clientMetadata: clientMetadata
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        var _this = this;
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var cleanUpError_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!err) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                logger.debug("getting user data failed", err);
                                if (!this.isSessionInvalid(err)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.cleanUpInvalidSession(user)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                cleanUpError_2 = _a.sent();
                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_2.message));
                                return [
                                    2 /*return*/ 
                                ];
                            case 4:
                                rej(err);
                                return [
                                    2 /*return*/ 
                                ];
                            case 5:
                                res(data);
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SOFTWARE_TOKEN_MFA":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "SMS_MFA":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, _auth.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    logger.debug("Set user mfa success", result);
                                    logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_3;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug("getting user data failed", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_3 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_3.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        return [
                                                            2 /*return*/ ,
                                                            res(result)
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * disable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    logger.debug("associateSoftwareToken success", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        logger.debug("verification totp token", user, challengeAnswer);
        var signInUserSession;
        if (user && typeof user.getSignInUserSession === "function") signInUserSession = user.getSignInUserSession();
        var isLoggedIn = signInUserSession === null || signInUserSession === void 0 ? void 0 : signInUserSession.isValid();
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    if (!isLoggedIn) dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                    dispatchAuthEvent("verify", user, "A user " + user.getUsername() + " has been verified");
                    logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_3, currentUser, e_4;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        10
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        10
                                    ];
                                case 5:
                                    that.user = user;
                                    _a.label = 6;
                                case 6:
                                    _a.trys.push([
                                        6,
                                        8,
                                        ,
                                        9
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.currentUserPoolUser()
                                    ];
                                case 7:
                                    currentUser = _a.sent();
                                    user.attributes = currentUser.attributes;
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 8:
                                    e_4 = _a.sent();
                                    logger.debug("cannot get updated Cognito User", e_4);
                                    return [
                                        3 /*break*/ ,
                                        9
                                    ];
                                case 9:
                                    dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 10:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) requiredAttributes = {};
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var cred, e_5;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.Credentials.set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_5 = _a.sent();
                                    logger.debug("cannot get cognito credentials", e_5);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    dispatchAuthEvent("signIn", user, "A user " + user.getUsername() + " has been signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    logger.debug("completeNewPassword failure", err);
                    dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                totpRequired: function(challengeName, challengeParam) {
                    logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Delete an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.deleteUserAttributes = function(user, attributeNames) {
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                user.deleteAttributes(attributeNames, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                });
            });
        });
    };
    /**
     * Delete the current authenticated user
     * @return {Promise}
     **/ // TODO: Check return type void
    AuthClass.prototype.deleteUser = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_6, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_6 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_6);
                        throw new Error(e_6);
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var user_1;
                                    var _this = this;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        if (this.userPool) {
                                            user_1 = this.userPool.getCurrentUser();
                                            if (!user_1) {
                                                logger.debug("Failed to get user from user pool");
                                                return [
                                                    2 /*return*/ ,
                                                    rej(new Error("No current user."))
                                                ];
                                            } else user_1.getSession(function(err, session) {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var cleanUpError_4;
                                                    var _this = this;
                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                        switch(_a.label){
                                                            case 0:
                                                                if (!err) return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                                logger.debug("Failed to get the user session", err);
                                                                if (!this.isSessionInvalid(err)) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([
                                                                    1,
                                                                    3,
                                                                    ,
                                                                    4
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.cleanUpInvalidSession(user_1)
                                                                ];
                                                            case 2:
                                                                _a.sent();
                                                                return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                            case 3:
                                                                cleanUpError_4 = _a.sent();
                                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_4.message));
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            case 4:
                                                                return [
                                                                    2 /*return*/ ,
                                                                    rej(err)
                                                                ];
                                                            case 5:
                                                                user_1.deleteUser(function(err, result) {
                                                                    if (err) rej(err);
                                                                    else {
                                                                        dispatchAuthEvent("userDeleted", result, "The authenticated user has been deleted.");
                                                                        user_1.signOut();
                                                                        _this.user = null;
                                                                        try {
                                                                            _this.cleanCachedItems(); // clean aws credentials
                                                                        } catch (e) {
                                                                            // TODO: change to rejects in refactor
                                                                            logger.debug("failed to clear cached items");
                                                                        }
                                                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                        else {
                                                                            dispatchAuthEvent("signOut", _this.user, "A user has been signed out");
                                                                            res(result);
                                                                        }
                                                                    }
                                                                });
                                                                _a.label = 6;
                                                            case 6:
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            });
                                        } else {
                                            logger.debug("no Congito User pool");
                                            rej(new Error("Cognito User pool does not exist"));
                                        }
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result, details) {
                    if (err) {
                        dispatchAuthEvent("updateUserAttributes_failure", err, "Failed to update attributes");
                        return reject(err);
                    } else {
                        var attrs = _this.createUpdateAttributesResultList(attributes, details === null || details === void 0 ? void 0 : details.CodeDeliveryDetailsList);
                        dispatchAuthEvent("updateUserAttributes", attrs, "Attributes successfully updated");
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    AuthClass.prototype.createUpdateAttributesResultList = function(attributes, codeDeliveryDetailsList) {
        var attrs = {};
        Object.keys(attributes).forEach(function(key) {
            attrs[key] = {
                isUpdated: true
            };
            var codeDeliveryDetails = codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.find(function(value) {
                return value.AttributeName === key;
            });
            if (codeDeliveryDetails) {
                attrs[key].isUpdated = false;
                attrs[key].codeDeliveryDetails = codeDeliveryDetails;
            }
        });
        return attrs;
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    AuthClass.prototype.isErrorWithMessage = function(err) {
        return typeof err === "object" && Object.prototype.hasOwnProperty.call(err, "message");
    };
    // Session revoked by another app
    AuthClass.prototype.isTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Access Token has been revoked";
    };
    AuthClass.prototype.isRefreshTokenRevokedError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has been revoked";
    };
    AuthClass.prototype.isUserDisabledError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User is disabled.";
    };
    AuthClass.prototype.isUserDoesNotExistError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "User does not exist.";
    };
    AuthClass.prototype.isRefreshTokenExpiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Refresh Token has expired";
    };
    AuthClass.prototype.isPasswordResetRequiredError = function(err) {
        return this.isErrorWithMessage(err) && err.message === "Password reset required for the user";
    };
    AuthClass.prototype.isSignedInHostedUI = function() {
        return this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
    };
    AuthClass.prototype.isSessionInvalid = function(err) {
        return this.isUserDisabledError(err) || this.isUserDoesNotExistError(err) || this.isTokenRevokedError(err) || this.isRefreshTokenRevokedError(err) || this.isRefreshTokenExpiredError(err) || this.isPasswordResetRequiredError(err);
    };
    AuthClass.prototype.cleanUpInvalidSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_7;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        user.signOut();
                        this.user = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 2:
                        _a.sent(); // clean aws credentials
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        if (this.isSignedInHostedUI()) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                _this.oAuthSignOutRedirect(res, rej);
                            })
                        ];
                        else dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var user, session, bypassCache, clientMetadata, _a, scope, err_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                if (!this.isOAuthInProgress()) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                logger.debug("OAuth signIn in progress, waiting for resolution...");
                                return [
                                    4 /*yield*/ ,
                                    new Promise(function(res) {
                                        var timeoutId = setTimeout(function() {
                                            logger.debug("OAuth signIn in progress timeout");
                                            (0, _core.Hub).remove("auth", hostedUISignCallback);
                                            res();
                                        }, OAUTH_FLOW_MS_TIMEOUT);
                                        (0, _core.Hub).listen("auth", hostedUISignCallback);
                                        function hostedUISignCallback(_a) {
                                            var payload = _a.payload;
                                            var event = payload.event;
                                            if (event === "cognitoHostedUI" || event === "cognitoHostedUI_failure") {
                                                logger.debug("OAuth signIn resolved: " + event);
                                                clearTimeout(timeoutId);
                                                (0, _core.Hub).remove("auth", hostedUISignCallback);
                                                res();
                                            }
                                        }
                                    })
                                ];
                            case 1:
                                _b.sent();
                                _b.label = 2;
                            case 2:
                                user = this.userPool.getCurrentUser();
                                if (!user) {
                                    logger.debug("Failed to get user from user pool");
                                    rej("No current user");
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                _b.label = 3;
                            case 3:
                                _b.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._userSession(user)
                                ];
                            case 4:
                                session = _b.sent();
                                bypassCache = params ? params.bypassCache : false;
                                if (!bypassCache) return [
                                    3 /*break*/ ,
                                    6
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.Credentials.clear()
                                ];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6:
                                clientMetadata = this._config.clientMetadata;
                                _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                                if (scope.split(" ").includes(USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var cleanUpError_5, preferredMFA, attributeList, i, attribute, userAttribute, attributes;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!err) return [
                                                        3 /*break*/ ,
                                                        7
                                                    ];
                                                    logger.debug("getting user data failed", err);
                                                    if (!this.isSessionInvalid(err)) return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                    _a.label = 1;
                                                case 1:
                                                    _a.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.cleanUpInvalidSession(user)
                                                    ];
                                                case 2:
                                                    _a.sent();
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    cleanUpError_5 = _a.sent();
                                                    rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_5.message));
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    rej(err);
                                                    return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                case 5:
                                                    res(user);
                                                    _a.label = 6;
                                                case 6:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 7:
                                                    preferredMFA = data.PreferredMfaSetting || "NOMFA";
                                                    attributeList = [];
                                                    for(i = 0; i < data.UserAttributes.length; i++){
                                                        attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value
                                                        };
                                                        userAttribute = new (0, _amazonCognitoIdentityJs.CognitoUserAttribute)(attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    attributes = this.attributesToObject(attributeList);
                                                    Object.assign(user, {
                                                        attributes: attributes,
                                                        preferredMFA: preferredMFA
                                                    });
                                                    return [
                                                        2 /*return*/ ,
                                                        res(user)
                                                    ];
                                            }
                                        });
                                    });
                                }, {
                                    bypassCache: bypassCache,
                                    clientMetadata: clientMetadata
                                });
                                else {
                                    logger.debug("Unable to get the user data because the " + USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                                    return [
                                        2 /*return*/ ,
                                        res(user)
                                    ];
                                }
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                err_1 = _b.sent();
                                rej(err_1);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }).catch(function(e) {
                logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function() {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var federatedUser, e_8, federatedInfo, user, e_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_8 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                            if (federatedInfo) federatedUser = (0, _tslib.__assign)((0, _tslib.__assign)({}, federatedInfo.user), {
                                token: federatedInfo.token
                            });
                        } catch (e) {
                            logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_9 = _a.sent();
                        if (e_9 === "No userPool") logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        logger.debug("The user is not authenticated by the error", e_9);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject(new Error("No User Pool in the configuration."));
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    AuthClass.prototype._userSession = function(user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var clientMetadata, userSession;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!user) {
                            logger.debug("the user is null");
                            return [
                                2 /*return*/ ,
                                this.rejectAuthError((0, _auth.AuthErrorTypes).NoUserSession)
                            ];
                        }
                        clientMetadata = this._config.clientMetadata;
                        // Debouncing the concurrent userSession calls by caching the promise.
                        // This solution assumes users will always call this function with the same CognitoUser instance.
                        if (this.inflightSessionPromiseCounter === 0) this.inflightSessionPromise = new Promise(function(res, rej) {
                            user.getSession(function(err, session) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var cleanUpError_6;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!err) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                logger.debug("Failed to get the session from user", user);
                                                if (!this.isSessionInvalid(err)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.cleanUpInvalidSession(user)
                                                ];
                                            case 2:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                            case 3:
                                                cleanUpError_6 = _a.sent();
                                                rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_6.message));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 4:
                                                rej(err);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 5:
                                                logger.debug("Succeed to get the user session", session);
                                                res(session);
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, {
                                clientMetadata: clientMetadata
                            });
                        });
                        this.inflightSessionPromiseCounter++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.inflightSessionPromise
                        ];
                    case 2:
                        userSession = _a.sent();
                        // Set private member. Avoid user.setSignInUserSession() to prevent excessive localstorage refresh.
                        // @ts-ignore
                        user.signInUserSession = userSession;
                        return [
                            2 /*return*/ ,
                            userSession
                        ];
                    case 3:
                        this.inflightSessionPromiseCounter--;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        return this._userSession(user);
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_10, federatedInfo;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_10 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_10);
                        throw e_10;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            this.Credentials.refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                logger.debug("getting session success", session);
                                return _this.Credentials.set(session, "session");
                            }).catch(function() {
                                logger.debug("getting guest credentials");
                                return _this.Credentials.set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        logger.debug("getting current credentials");
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function(success) {
                    return resolve(success);
                },
                onFailure: function(err) {
                    return reject(err);
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_11, isSignedInHostedUI;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_11 = _a.sent();
                        logger.debug("Failed to sync cache info into memory", e_11);
                        throw e_11;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function(err, result) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var cleanUpError_7;
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_a) {
                                                switch(_a.label){
                                                    case 0:
                                                        if (!err) return [
                                                            3 /*break*/ ,
                                                            5
                                                        ];
                                                        logger.debug("failed to get the user session", err);
                                                        if (!this.isSessionInvalid(err)) return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                        _a.label = 1;
                                                    case 1:
                                                        _a.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.cleanUpInvalidSession(user)
                                                        ];
                                                    case 2:
                                                        _a.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        cleanUpError_7 = _a.sent();
                                                        rej(new Error("Session is invalid due to: " + err.message + " and failed to clean up invalid session: " + cleanUpError_7.message));
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    case 4:
                                                        return [
                                                            2 /*return*/ ,
                                                            rej(err)
                                                        ];
                                                    case 5:
                                                        user.globalSignOut({
                                                            onSuccess: function(data) {
                                                                logger.debug("global sign out success");
                                                                if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                                                else return res();
                                                            },
                                                            onFailure: function(err) {
                                                                logger.debug("global sign out failed", err);
                                                                return rej(err);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }, {
                                        clientMetadata: clientMetadata
                                    });
                                } else {
                                    logger.debug("user sign out", user);
                                    user.signOut(function() {
                                        if (isSignedInHostedUI) _this.oAuthSignOutRedirect(res, rej);
                                        else return res();
                                    });
                                }
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function(resolve, reject) {
        var isBrowser = (0, _core.browserOrNode)().isBrowser;
        if (isBrowser) this.oAuthSignOutRedirectOrReject(reject);
        else this.oAuthSignOutAndResolve(resolve);
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function(resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function(reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function() {
            return reject(Error("Signout timeout fail"));
        }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var e_12, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_12 = _a.sent();
                        logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        logger.debug("no Cognito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            this.Credentials.clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    logger.debug("forgot password failure", err);
                    dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, _auth.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function(success) {
                    dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve(success);
                    return;
                },
                onFailure: function(err) {
                    dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_13, info, err_2, user;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return logger.error(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_13 = _a.sent();
                        logger.debug("Failed to retrieve credentials while getting current user info", e_13);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_2 = _a.sent();
                        logger.error("currentUserInfo error", err_2);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, _types.isFederatedSignInOptions)(providerOrOptions) || (0, _types.isFederatedSignInOptionsCustom)(providerOrOptions) || (0, _types.hasCustomState)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: (0, _auth.CognitoHostedUIIdentityProvider).Cognito
                        };
                        provider = (0, _types.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, _types.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, _types.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_3;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            8,
                            9
                        ]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, _core.browserOrNode)().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, _url.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, _url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, _amazonCognitoIdentityJs.CognitoUserSession)({
                            IdToken: new (0, _amazonCognitoIdentityJs.CognitoIdToken)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, _amazonCognitoIdentityJs.CognitoRefreshToken)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, _amazonCognitoIdentityJs.CognitoAccessToken)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.Credentials.set(session, "session")
                        ];
                    case 4:
                        credentials = _b.sent();
                        logger.debug("AWS credentials", credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== "undefined") window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn);
                        dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            dispatchAuthEvent("customOAuthState", (0, _core.urlSafeDecode)(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 6:
                        err_3 = _b.sent();
                        logger.debug("Error in cognito hosted auth response", err_3);
                        // Just like a successful handling of `?code`, replace the window history to "dispose" of the `code`.
                        // Otherwise, reloading the page will throw errors as the `code` has already been spent.
                        if (window && typeof window.history !== "undefined") window.history.replaceState(window.history.state, "", this._config.oauth.redirectSignIn);
                        dispatchAuthEvent("signIn_failure", err_3, "The OAuth response flow failed");
                        dispatchAuthEvent("cognitoHostedUI_failure", err_3, "A failure occurred when returning to the Cognito Hosted UI");
                        dispatchAuthEvent("customState_failure", err_3, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var _this = this;
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Name === "email_verified" || attribute.Name === "phone_number_verified") obj[attribute.Name] = _this.isTruthyString(attribute.Value) || attribute.Value === true;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.isTruthyString = function(value) {
        return typeof value.toLowerCase === "function" && value.toLowerCase() === "true";
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, _amazonCognitoIdentityJs.CognitoUser)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, _auth.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, _auth.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, _errors.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, _errors.NoUserPoolError)(type));
    };
    AuthClass.prototype.rememberDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_2;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_2 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_2);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_3);
                        return [
                            2 /*return*/ ,
                            Promise.reject("The user is not authenticated")
                        ];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function(data) {
                                        res(data);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currUser, error_4;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser()
                        ];
                    case 1:
                        currUser = _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_4 = _a.sent();
                        logger.debug("The user is not authenticated by the error", error_4);
                        throw new Error("The user is not authenticated");
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                var cb = {
                                    onSuccess: function(data) {
                                        var deviceList = data.Devices.map(function(device) {
                                            var deviceName = device.DeviceAttributes.find(function(_a) {
                                                var Name = _a.Name;
                                                return Name === "device_name";
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function(err) {
                                        if (err.code === "InvalidParameterException") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).DeviceConfig));
                                        else if (err.code === "NetworkError") rej(new (0, _errors.AuthError)((0, _auth.AuthErrorTypes).NetworkError));
                                        else rej(err);
                                    }
                                };
                                currUser.listDevices(MAX_DEVICES, null, cb);
                            })
                        ];
                }
            });
        });
    };
    return AuthClass;
}();
var Auth = new AuthClass(null);
(0, _core.Amplify).register(Auth);

},{"tslib":"byrV7","./types":"17Pn9","@aws-amplify/core":"3rlh1","amazon-cognito-identity-js":"gyre7","amazon-cognito-identity-js/internals":"1eDWr","url":"7NJu4","./OAuth/OAuth":"1w9JI","./urlListener":"fh3I6","./Errors":"jFy1A","./types/Auth":"9VnfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byrV7":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17Pn9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("./Auth");
parcelHelpers.exportAll(_auth, exports);

},{"./Auth":"9VnfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9VnfC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CognitoHostedUIIdentityProvider", ()=>CognitoHostedUIIdentityProvider);
parcelHelpers.export(exports, "isFederatedSignInOptions", ()=>isFederatedSignInOptions);
parcelHelpers.export(exports, "isFederatedSignInOptionsCustom", ()=>isFederatedSignInOptionsCustom);
parcelHelpers.export(exports, "hasCustomState", ()=>hasCustomState);
parcelHelpers.export(exports, "isCognitoHostedOpts", ()=>isCognitoHostedOpts);
parcelHelpers.export(exports, "AuthErrorTypes", ()=>AuthErrorTypes);
parcelHelpers.export(exports, "isUsernamePasswordOpts", ()=>isUsernamePasswordOpts);
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>GRAPHQL_AUTH_MODE);
var CognitoHostedUIIdentityProvider;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})(CognitoHostedUIIdentityProvider || (CognitoHostedUIIdentityProvider = {}));
function isFederatedSignInOptions(obj) {
    var keys = [
        "provider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isFederatedSignInOptionsCustom(obj) {
    var keys = [
        "customProvider"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function hasCustomState(obj) {
    var keys = [
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function isCognitoHostedOpts(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var AuthErrorTypes;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
var GRAPHQL_AUTH_MODE;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})(GRAPHQL_AUTH_MODE || (GRAPHQL_AUTH_MODE = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gyre7":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticationDetails", ()=>(0, _authenticationDetailsDefault.default));
parcelHelpers.export(exports, "AuthenticationHelper", ()=>(0, _authenticationHelperDefault.default));
parcelHelpers.export(exports, "CognitoAccessToken", ()=>(0, _cognitoAccessTokenDefault.default));
parcelHelpers.export(exports, "CognitoIdToken", ()=>(0, _cognitoIdTokenDefault.default));
parcelHelpers.export(exports, "CognitoRefreshToken", ()=>(0, _cognitoRefreshTokenDefault.default));
parcelHelpers.export(exports, "CognitoUser", ()=>(0, _cognitoUserDefault.default));
parcelHelpers.export(exports, "CognitoUserAttribute", ()=>(0, _cognitoUserAttributeDefault.default));
parcelHelpers.export(exports, "CognitoUserPool", ()=>(0, _cognitoUserPoolDefault.default));
parcelHelpers.export(exports, "CognitoUserSession", ()=>(0, _cognitoUserSessionDefault.default));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _cookieStorageDefault.default));
parcelHelpers.export(exports, "DateHelper", ()=>(0, _dateHelperDefault.default));
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>(0, _userAgent.appendToCognitoUserAgent));
parcelHelpers.export(exports, "WordArray", ()=>(0, _wordArrayDefault.default));
var _authenticationDetails = require("./AuthenticationDetails");
var _authenticationDetailsDefault = parcelHelpers.interopDefault(_authenticationDetails);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _cognitoUserPool = require("./CognitoUserPool");
var _cognitoUserPoolDefault = parcelHelpers.interopDefault(_cognitoUserPool);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _cookieStorage = require("./CookieStorage");
var _cookieStorageDefault = parcelHelpers.interopDefault(_cookieStorage);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _userAgent = require("./UserAgent");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);

},{"./AuthenticationDetails":"ffCyO","./AuthenticationHelper":"dNzgw","./CognitoAccessToken":"47VT2","./CognitoIdToken":"2Yyhy","./CognitoRefreshToken":"bLwE0","./CognitoUser":"fOacZ","./CognitoUserAttribute":"e6Yqo","./CognitoUserPool":"gKAFL","./CognitoUserSession":"7c7t3","./CookieStorage":"26gE4","./DateHelper":"aZ6Xj","./UserAgent":"k12DG","./utils/WordArray":"84IdI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ffCyO":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationDetails);
var AuthenticationDetails = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dNzgw":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationHelper);
var _buffer = require("buffer");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);
var _sha256Js = require("@aws-crypto/sha256-js");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function randomBytes(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _wordArrayDefault.default)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var AuthenticationHelper = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, _bigIntegerDefault.default)(initN, 16);
        this.g = new (0, _bigIntegerDefault.default)("2", 16);
        this.k = new (0, _bigIntegerDefault.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, _buffer.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = randomBytes(128).toString("hex");
        var randomBigInt = new (0, _bigIntegerDefault.default)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, _bigIntegerDefault.default)(hexRandom, 16));
        this.g.modPow(new (0, _bigIntegerDefault.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, _bigIntegerDefault.default).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, _bigIntegerDefault.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, _buffer.Buffer).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, _buffer.Buffer).concat([
            this.infoBits,
            (0, _buffer.Buffer).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, _sha256Js.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, _sha256Js.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, _bigIntegerDefault.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, _buffer.Buffer).from(_this4.padHex(sValue), "hex"), (0, _buffer.Buffer).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, _bigIntegerDefault.default))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, _bigIntegerDefault.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, _bigIntegerDefault.default)(invertedNibbles, 16).add((0, _bigIntegerDefault.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

},{"buffer":"2MtSL","./utils/WordArray":"84IdI","@aws-crypto/sha256-js":"1pg4I","./BigInteger":"bJim1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2MtSL":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("cc9ef38945ca7514");
var ieee754 = require("2029602ab8d0f68");
var isArray = require("e1d6f34cfc72b474");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"cc9ef38945ca7514":"MlSYJ","2029602ab8d0f68":"15Xnl","e1d6f34cfc72b474":"9gjbG"}],"9gjbG":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"84IdI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WordArray);
var _cryptoSecureRandomInt = require("./cryptoSecureRandomInt");
var _cryptoSecureRandomIntDefault = parcelHelpers.interopDefault(_cryptoSecureRandomInt);
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var WordArray = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, _cryptoSecureRandomIntDefault.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return hexStringify(this);
    };
    return WordArray;
}();

},{"./cryptoSecureRandomInt":"6LZLm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6LZLm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cryptoSecureRandomInt);
var global = arguments[3];
var crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
// Native crypto import via require (NodeJS)
if (!crypto && true) try {
    crypto = require("c5b163c9469bd1a8");
} catch (err) {}
function cryptoSecureRandomInt() {
    if (crypto) {
        // Use getRandomValues method (Browser)
        if (typeof crypto.getRandomValues === "function") try {
            return crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof crypto.randomBytes === "function") try {
            return crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}

},{"c5b163c9469bd1a8":"ixEMk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ixEMk":[function(require,module,exports) {
"use strict";

},{}],"bJim1":[function(require,module,exports) {
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = nbi();
    var y = nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = nbv(1), z = new Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
    i = nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47VT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoAccessToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoAccessToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"1bWGP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1bWGP":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoJwtToken);
var _buffer = require("buffer");
/** @class */ var CognitoJwtToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, _buffer.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

},{"buffer":"2MtSL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Yyhy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoIdToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoIdToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"1bWGP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bLwE0":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoRefreshToken);
var CognitoRefreshToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fOacZ":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUser);
var _buffer = require("buffer");
var _sha256Js = require("@aws-crypto/sha256-js");
var _platform = require("./Platform");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var isNavigatorAvailable = typeof navigator !== "undefined";
var userAgent = isNavigatorAvailable ? (0, _platform.Platform).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var CognitoUser = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var dateHelper = new (0, _dateHelperDefault.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, _buffer.Buffer).from(_this2.username, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.deviceGroupKey);
        var dateHelper = new (0, _dateHelperDefault.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, _buffer.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, _authenticationHelperDefault.default)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, _cognitoUserAttributeDefault.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, _cognitoIdTokenDefault.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, _cognitoAccessTokenDefault.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, _cognitoRefreshTokenDefault.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, _cognitoUserSessionDefault.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, _cognitoIdTokenDefault.default)(authResult);
        var accessToken = new (0, _cognitoAccessTokenDefault.default)(authResult);
        var refreshToken = new (0, _cognitoRefreshTokenDefault.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, _cognitoUserSessionDefault.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

},{"buffer":"2MtSL","@aws-crypto/sha256-js":"1pg4I","./Platform":"iaAU8","./BigInteger":"bJim1","./AuthenticationHelper":"dNzgw","./CognitoAccessToken":"47VT2","./CognitoIdToken":"2Yyhy","./CognitoRefreshToken":"bLwE0","./CognitoUserSession":"7c7t3","./DateHelper":"aZ6Xj","./CognitoUserAttribute":"e6Yqo","./StorageHelper":"k8KEO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iaAU8":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
var _version = require("./version");
var BASE_USER_AGENT = "aws-amplify/" + (0, _version.version);
var Platform = {
    userAgent: BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var getUserAgent = function getUserAgent() {
    return Platform.userAgent;
};
/**
 * @deprecated use named import
 */ exports.default = Platform;

},{"./version":"5mDEo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5mDEo":[function(require,module,exports) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "5.0.4";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7c7t3":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserSession);
var CognitoUserSession = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZ6Xj":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateHelper);
var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var DateHelper = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = weekNames[now.getUTCDay()];
        var month = monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6Yqo":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserAttribute);
var CognitoUserAttribute = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k8KEO":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
parcelHelpers.export(exports, "default", ()=>StorageHelper);
var dataMemory = {};
var MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var StorageHelper = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gKAFL":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserPool);
var _client = require("./Client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
var USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var CognitoUserPool = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, _clientDefault.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, _cognitoUserDefault.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, _cognitoUserDefault.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

},{"./Client":"aTU6n","./CognitoUser":"fOacZ","./StorageHelper":"k8KEO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aTU6n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Client);
var _isomorphicUnfetch = require("isomorphic-unfetch");
var _userAgent = require("./UserAgent");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var CognitoError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/** @class */ var Client = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, _userAgent.getAmplifyUserAgent)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var NonRetryableError = /*#__PURE__*/ function(_Error2) {
    _inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
var isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        logger.debug("error on " + functionToRetry.name, err);
        if (isNonRetryableError(err)) {
            logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var MAX_DELAY_MS = 300000;
function jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
}

},{"isomorphic-unfetch":"cSe6x","./UserAgent":"k12DG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k12DG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>appendToCognitoUserAgent);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", ()=>addAuthCategoryToCognitoUserAgent);
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", ()=>addFrameworkToCognitoUserAgent);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
var _platform = require("./Platform");
var _constants = require("./Platform/constants");
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = (0, _platform.getUserAgent)();
var appendToCognitoUserAgent = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if (UserAgent.prototype.userAgent && !UserAgent.prototype.userAgent.includes(content)) UserAgent.prototype.userAgent = UserAgent.prototype.userAgent.concat(" ", content);
    if (!UserAgent.prototype.userAgent || UserAgent.prototype.userAgent === "") UserAgent.prototype.userAgent = content;
};
var addAuthCategoryToCognitoUserAgent = function addAuthCategoryToCognitoUserAgent() {
    UserAgent.category = (0, _constants.AUTH_CATEGORY);
};
var addFrameworkToCognitoUserAgent = function addFrameworkToCognitoUserAgent(framework) {
    UserAgent.framework = framework;
};
var getAmplifyUserAgent = function getAmplifyUserAgent(action) {
    var uaCategoryAction = UserAgent.category ? " " + UserAgent.category : "";
    var uaFramework = UserAgent.framework ? " framework/" + UserAgent.framework : "";
    var userAgent = "" + UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
// class for defining the amzn user-agent
exports.default = UserAgent;

},{"./Platform":"iaAU8","./Platform/constants":"bkUqc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkUqc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FRAMEWORK", ()=>FRAMEWORK);
parcelHelpers.export(exports, "AUTH_CATEGORY", ()=>AUTH_CATEGORY);
var FRAMEWORK = {
    None: "0",
    ReactNative: "1"
};
var AUTH_CATEGORY = "auth";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"26gE4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CookieStorage);
var _jsCookie = require("js-cookie");
/** @class */ var CookieStorage = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        _jsCookie.set(key, value, options);
        return _jsCookie.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return _jsCookie.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return _jsCookie.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = _jsCookie.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

},{"js-cookie":"7G5HO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7G5HO":[function(require,module,exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"1eDWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", ()=>(0, _userAgent.addAuthCategoryToCognitoUserAgent));
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", ()=>(0, _userAgent.addFrameworkToCognitoUserAgent));
var _userAgent = require("../UserAgent");

},{"../UserAgent":"k12DG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7NJu4":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var punycode = require("6aa635927f16f681");
var util = require("3270586ce442e355");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
}, querystring = require("768fe205c74a17e8");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && util.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (util.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!util.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

},{"6aa635927f16f681":"b2VnN","3270586ce442e355":"7pKDA","768fe205c74a17e8":"2djPJ"}],"b2VnN":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

},{}],"7pKDA":[function(require,module,exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

},{}],"2djPJ":[function(require,module,exports) {
"use strict";
exports.decode = exports.parse = require("636e0b84222e531a");
exports.encode = exports.stringify = require("8e17006a06cc4f8");

},{"636e0b84222e531a":"6Hf3W","8e17006a06cc4f8":"78b0p"}],"6Hf3W":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!hasOwnProperty(obj, k)) obj[k] = v;
        else if (isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

},{}],"78b0p":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return map(objectKeys(obj), function(k) {
        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
        if (isArray(obj[k])) return map(obj[k], function(v) {
            return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

},{}],"1w9JI":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _url = require("url"); // Used for OAuth parsing of Cognito Hosted UI
var _urlOpener = require("./urlOpener");
var _oauthStorage = require("./oauthStorage");
var _buffer = require("buffer");
var _auth = require("../types/Auth");
var _core = require("@aws-amplify/core");
var _sha256Js = require("@aws-crypto/sha256-js");
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var dispatchAuthEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", AMPLIFY_SYMBOL);
};
var logger = new (0, _core.ConsoleLogger)("OAuth");
var OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, _urlOpener.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes)) throw Error("scopes must be a String Array");
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function(scopes) {
        return Array.isArray(scopes) && scopes.every(function(scope) {
            return typeof scope === "string";
        });
    };
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, _auth.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ var state = customState ? generatedState + "-" + (0, _core.urlSafeEncode)(customState) : generatedState;
        _oauthStorage.setState(state);
        var pkce_key = this._generateRandom(128);
        _oauthStorage.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var scopesString = this._scopes.join(" ");
        var queryString = Object.entries((0, _tslib.__assign)((0, _tslib.__assign)({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scope: scopesString,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, customUserAgentDetails, _a, access_token, refresh_token, id_token, error;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        code = ((0, _url.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                            return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        currentUrlPathname = (0, _url.parse)(currentUrl).pathname || "/";
                        redirectSignInPathname = (0, _url.parse)(this._config.redirectSignIn).pathname || "/";
                        if (!code || currentUrlPathname !== redirectSignInPathname) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = _oauthStorage.getPKCE();
                        oAuthTokenBody = (0, _tslib.__assign)({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        customUserAgentDetails = {
                            category: (0, _core.Category).Auth,
                            action: (0, _core.AuthAction).FederatedSignIn
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: (_b = {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                }, _b[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _b),
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.sent().json()
                        ];
                    case 2:
                        _a = _c.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return (0, _tslib.__generator)(this, function(_b) {
                _a = ((0, _url.parse)(currentUrl).hash || "#").substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? (0, _tslib.__assign)((0, _tslib.__assign)({}, ((0, _url.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, _url.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        logger.debug("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = _oauthStorage.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return (0, _tslib.__generator)(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, _auth.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, _auth.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                }).join("&");
                dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint, signout_uri)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(code);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var b64 = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
        var base64URLFromAWSCrypto = this._base64URL(b64);
        return base64URLFromAWSCrypto;
    };
    OAuth.prototype._base64URL = function(string) {
        return string.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
exports.default = OAuth;

},{"tslib":"byrV7","url":"7NJu4","./urlOpener":"jAoxu","./oauthStorage":"9yxHU","buffer":"2MtSL","../types/Auth":"9VnfC","@aws-amplify/core":"3rlh1","@aws-crypto/sha256-js":"1pg4I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jAoxu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "launchUri", ()=>launchUri);
var SELF = "_self";
var launchUri = function(url) {
    var windowProxy = window.open(url, SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9yxHU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setState", ()=>setState);
parcelHelpers.export(exports, "getState", ()=>getState);
parcelHelpers.export(exports, "setPKCE", ()=>setPKCE);
parcelHelpers.export(exports, "getPKCE", ()=>getPKCE);
parcelHelpers.export(exports, "clearAll", ()=>clearAll);
var setState = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var getState = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var setPKCE = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var getPKCE = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var clearAll = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fh3I6":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
exports.default = function(callback) {
    if ((0, _core.browserOrNode)().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, _core.browserOrNode)().isNode) ;
    else throw new Error("Not supported");
};

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jFy1A":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
parcelHelpers.export(exports, "NoUserPoolError", ()=>NoUserPoolError);
parcelHelpers.export(exports, "authErrorMessages", ()=>authErrorMessages);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _authErrorStrings = require("./common/AuthErrorStrings");
var logger = new (0, _core.ConsoleLogger)("AuthError");
var AuthError = /** @class */ function(_super) {
    (0, _tslib.__extends)(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = authErrorMessages[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var NoUserPoolError = /** @class */ function(_super) {
    (0, _tslib.__extends)(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}(AuthError);
var authErrorMessages = {
    noConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        "
    },
    missingAuthConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        "
    },
    emptyUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CODE
    },
    signUpError: {
        message: (0, _authErrorStrings.AuthErrorStrings).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_MFA
    },
    invalidMFA: {
        message: (0, _authErrorStrings.AuthErrorStrings).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, _authErrorStrings.AuthErrorStrings).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, _authErrorStrings.AuthErrorStrings).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEVICE_CONFIG
    },
    networkError: {
        message: (0, _authErrorStrings.AuthErrorStrings).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, _authErrorStrings.AuthErrorStrings).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, _authErrorStrings.AuthErrorStrings).DEFAULT_MSG
    }
};

},{"tslib":"byrV7","@aws-amplify/core":"3rlh1","./common/AuthErrorStrings":"1aakP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1aakP":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthErrorStrings", ()=>AuthErrorStrings);
var AuthErrorStrings;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
})(AuthErrorStrings || (AuthErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dt8H8":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>(0, _providers.AWSS3Provider));
parcelHelpers.export(exports, "StorageClass", ()=>(0, _storage.Storage));
parcelHelpers.export(exports, "Storage", ()=>(0, _storage.StorageInstance));
var _storage = require("./Storage");
var _providers = require("./providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Storage":"bVIQD","./providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bVIQD":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Storage", ()=>Storage);
parcelHelpers.export(exports, "StorageInstance", ()=>StorageInstance);
var _core = require("@aws-amplify/core");
var _providers = require("./providers");
var _utils = require("./AwsClients/S3/utils");
var _awss3UploadTask = require("./providers/AWSS3UploadTask");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)("StorageClass");
var loggerStorageInstance = new (0, _core.ConsoleLogger)("Storage"); // Logging relating to Storage instance management
var DEFAULT_PROVIDER = "AWSS3";
/**
 * Provide storage methods to use AWS S3
 */ var Storage = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function Storage() {
        this._config = {};
        this._pluggables = [];
        this._abortControllerMap = new WeakMap();
        logger.debug("Storage Options", this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    Storage.prototype.getModuleName = function() {
        return "Storage";
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ Storage.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Storage") {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Storage.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ Storage.prototype.configure = function(config) {
        var _this = this;
        var _a;
        logger.debug("configure Storage");
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        var storageConfig = (_a = amplifyConfig.Storage) !== null && _a !== void 0 ? _a : {};
        var defaultProviderConfigKeys = [
            "bucket",
            "region",
            "level",
            "track",
            "customPrefix",
            "ContentMD5",
            "serverSideEncryption",
            "SSECustomerAlgorithm",
            "SSECustomerKey",
            // TODO(AllanZhengYP): remove in V6.
            "SSECustomerKeyMD5",
            "SSEKMSKeyId"
        ];
        var hasDefaultProviderConfigKeys = function(config) {
            return Object.keys(config).find(function(key) {
                return defaultProviderConfigKeys.includes(key);
            });
        };
        if (hasDefaultProviderConfigKeys(storageConfig) && !storageConfig[DEFAULT_PROVIDER]) storageConfig[DEFAULT_PROVIDER] = {};
        Object.entries(storageConfig).forEach(function(_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (key && defaultProviderConfigKeys.includes(key) && value !== undefined) {
                storageConfig[DEFAULT_PROVIDER][key] = value;
                delete storageConfig[key];
            }
        });
        // only update new values for each provider
        Object.keys(storageConfig).forEach(function(providerName) {
            if (typeof storageConfig[providerName] !== "string") _this._config[providerName] = __assign(__assign({}, _this._config[providerName]), storageConfig[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _providers.AWSS3Provider)());
        return this._config;
    };
    Storage.prototype.getAbortController = function() {
        return new AbortController();
    };
    Storage.prototype.updateRequestToBeCancellable = function(request, abortController) {
        this._abortControllerMap.set(request, abortController);
    };
    Storage.prototype.isUploadTask = function(x) {
        return typeof x !== "undefined" && typeof x["pause"] === "function" && typeof x["resume"] === "function";
    };
    Storage.prototype.cancel = function(request, message) {
        if (request instanceof (0, _awss3UploadTask.AWSS3UploadTask)) return request._cancel();
        var abortController = this._abortControllerMap.get(request);
        if (abortController) // TODO: [v6] clean up the aborted promise in the weak map.
        // Not doing it yet to avoid breaking changes when users may abort a request twice.
        abortController.abort(message);
        else logger.debug("The request does not map to any cancel token");
    };
    Storage.prototype.copy = function(src, dest, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.copy !== "function") return Promise.reject(".copy is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin.copy(src, dest, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.get = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var responsePromise = plugin.get(key, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.isCancelError = function(error) {
        return (0, _utils.isCancelError)(error);
    };
    Storage.prototype.getProperties = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            throw new Error("No plugin found with providerName");
        }
        var abortController = this.getAbortController();
        if (typeof plugin.getProperties !== "function") return Promise.reject(".getProperties is not implemented on provider ".concat(plugin.getProviderName()));
        var responsePromise = plugin === null || plugin === void 0 ? void 0 : plugin.getProperties(key, __assign({}, config));
        this.updateRequestToBeCancellable(responsePromise, abortController);
        return responsePromise;
    };
    Storage.prototype.put = function(key, object, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        var abortController = this.getAbortController();
        var response = plugin.put(key, object, __assign(__assign({}, config), {
            abortSignal: abortController.signal
        }));
        if (!this.isUploadTask(response)) this.updateRequestToBeCancellable(response, abortController);
        return response;
    };
    Storage.prototype.remove = function(key, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.remove(key, config);
    };
    Storage.prototype.list = function(path, config) {
        var provider = (config === null || config === void 0 ? void 0 : config.provider) || DEFAULT_PROVIDER;
        var plugin = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === provider;
        });
        if (plugin === undefined) {
            logger.debug("No plugin found with providerName", provider);
            return Promise.reject("No plugin found in Storage for the provider");
        }
        return plugin.list(path, config);
    };
    return Storage;
}();
/**
 * Configure & register Storage singleton instance.
 */ var _instance = null;
var getInstance = function() {
    if (_instance) return _instance;
    loggerStorageInstance.debug("Create Storage Instance, debug");
    _instance = new Storage();
    _instance.vault = new Storage();
    var old_configure = _instance.configure;
    _instance.configure = function(options) {
        loggerStorageInstance.debug("storage configure called");
        var vaultConfig = __assign({}, old_configure.call(_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== "string") vaultConfig[providerName] = __assign(__assign({}, vaultConfig[providerName]), {
                level: "private"
            });
        });
        loggerStorageInstance.debug("storage vault configure called");
        _instance.vault.configure(vaultConfig);
    };
    return _instance;
};
var StorageInstance = getInstance();
(0, _core.Amplify).register(StorageInstance);

},{"@aws-amplify/core":"3rlh1","./providers":"3XtUA","./AwsClients/S3/utils":"kSyt3","./providers/AWSS3UploadTask":"3YUiw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3XtUA":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>(0, _awss3Provider.AWSS3Provider));
var _awss3Provider = require("./AWSS3Provider");

},{"./AWSS3Provider":"lkzM9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lkzM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3Provider", ()=>AWSS3Provider);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _storageErrorStrings = require("../common/StorageErrorStrings");
var _storageUtils = require("../common/StorageUtils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _awss3ProviderManagedUpload = require("./AWSS3ProviderManagedUpload");
var _awss3UploadTask = require("./AWSS3UploadTask");
var _storageConstants = require("../common/StorageConstants");
var _events = require("events");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.ConsoleLogger)("AWSS3Provider");
var DEFAULT_STORAGE_LEVEL = "public";
var DEFAULT_PRESIGN_EXPIRATION = 900;
var AWSS3Provider = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        var _this = this;
        this._config = config ? config : {};
        this._storage = new (0, _core.StorageHelper)().getStorage();
        (0, _core.Hub).listen("auth", function(data) {
            var payload = data.payload;
            if (payload.event === "signOut" || payload.event === "signIn") _this._storage.removeItem((0, _storageConstants.UPLOADS_STORAGE_KEY));
        });
        logger.debug("Storage Options", this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        logger.debug("configure Storage", config);
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) logger.debug("Do not have bucket yet");
        return this._config;
    };
    AWSS3Provider.prototype.startResumableUpload = function(addTaskInput, config) {
        var _a;
        var s3Config = addTaskInput.s3Config, emitter = addTaskInput.emitter, key = addTaskInput.key, file = addTaskInput.file, params = addTaskInput.params;
        var progressCallback = config.progressCallback, completeCallback = config.completeCallback, errorCallback = config.errorCallback, track = (_a = config.track, _a === void 0 ? false : _a);
        if (!(file instanceof Blob)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).INVALID_BLOB);
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_PROGRESS, function(event) {
            if (progressCallback) {
                if (typeof progressCallback === "function") progressCallback(event);
                else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).UPLOAD_COMPLETE, function(event) {
            if (completeCallback) {
                if (typeof completeCallback === "function") completeCallback(event);
                else logger.warn("completeCallback should be a function, not a " + typeof completeCallback);
            }
        });
        emitter.on((0, _awss3UploadTask.TaskEvents).ERROR, function(err) {
            if (errorCallback) {
                if (typeof errorCallback === "function") errorCallback(err);
                else logger.warn("errorCallback should be a function, not a " + typeof errorCallback);
            }
        });
        // we want to keep this function sync so we defer this promise to AWSS3UploadTask to resolve when it's needed
        // when its doing a final check with _listSingleFile function
        var prefixPromise = (0, _core.Credentials).get().then(function(credentials) {
            var cred = (0, _core.Credentials).shear(credentials);
            return (0, _s3ClientUtils.getPrefix)(__assign(__assign({}, config), {
                level: addTaskInput.accessLevel,
                credentials: cred
            }));
        });
        var task = new (0, _awss3UploadTask.AWSS3UploadTask)({
            s3Config: s3Config,
            file: file,
            emitter: emitter,
            level: addTaskInput.accessLevel,
            storage: this._storage,
            params: params,
            prefixPromise: prefixPromise
        });
        (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
            method: "put",
            result: "success"
        }, null, "Upload Task created successfully for ".concat(key));
        // automatically start the upload task
        task.resume();
        return task;
    };
    /**
     * Copy an object from a source object to a new object within the same bucket. Can optionally copy files across
     * different level or identityId (if source object's level is 'protected').
     *
     * @async
     * @param {S3CopySource} src - Key and optionally access level and identityId of the source object.
     * @param {S3CopyDestination} dest - Key and optionally access level of the destination object.
     * @param {S3ProviderCopyConfig} [config] - Optional configuration for s3 commands.
     * @return {Promise<S3ProviderCopyOutput>} The key of the copied object.
     */ AWSS3Provider.prototype.copy = function(src, dest, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, acl, bucket, cacheControl, expires, track, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, srcLevel, srcIdentityId, srcKey, destLevel, destKey, srcPrefix, destPrefix, finalSrcKey, finalDestKey, params, error_1;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        acl = opt.acl, bucket = opt.bucket, cacheControl = opt.cacheControl, expires = opt.expires, track = opt.track, serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        srcLevel = (_a = src.level, _a === void 0 ? DEFAULT_STORAGE_LEVEL : _a), srcIdentityId = src.identityId, srcKey = src.key;
                        destLevel = (_b = dest.level, _b === void 0 ? DEFAULT_STORAGE_LEVEL : _b), destKey = dest.key;
                        if (!srcKey || typeof srcKey !== "string") throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_SRC_KEY);
                        if (!destKey || typeof destKey !== "string") throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_DEST_KEY);
                        if (srcLevel !== "protected" && srcIdentityId) logger.warn('You may copy files from another user if the source level is "protected", currently it\'s '.concat(srcLevel));
                        srcPrefix = this._prefix(__assign(__assign(__assign({}, opt), {
                            level: srcLevel
                        }), srcIdentityId && {
                            identityId: srcIdentityId
                        }));
                        destPrefix = this._prefix(__assign(__assign({}, opt), {
                            level: destLevel
                        }));
                        finalSrcKey = "".concat(bucket, "/").concat(srcPrefix).concat(srcKey);
                        finalDestKey = "".concat(destPrefix).concat(destKey);
                        logger.debug("copying ".concat(finalSrcKey, " to ").concat(finalDestKey));
                        params = {
                            Bucket: bucket,
                            CopySource: finalSrcKey,
                            Key: finalDestKey,
                            // Copies over metadata like contentType as well
                            MetadataDirective: "COPY"
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (expires) params.Expires = expires;
                        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        if (acl) params.ACL = acl;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.copyObject)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).Copy
                            })), params)
                        ];
                    case 3:
                        _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "copy", {
                            method: "copy",
                            result: "success"
                        }, null, "Copy success from ".concat(srcKey, " to ").concat(destKey));
                        return [
                            2 /*return*/ ,
                            {
                                key: destKey
                            }
                        ];
                    case 4:
                        error_1 = _c.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "copy", {
                            method: "copy",
                            result: "failed"
                        }, null, "Copy failed from ".concat(srcKey, " to ").concat(destKey));
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype.get = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, progressCallback, validateObjectExistence, prefix, final_key, emitter, s3Config, params, response, error_2, error_3, url, _b, _c, error_4;
            var _d, _e;
            return __generator(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _f.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, progressCallback = opt.progressCallback, validateObjectExistence = (_d = opt.validateObjectExistence, _d === void 0 ? false : _d);
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        emitter = new _events.EventEmitter();
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            emitter: emitter,
                            storageAction: (0, _core.StorageAction).Get
                        }));
                        logger.debug("get " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        if (!(download === true)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 2;
                    case 2:
                        _f.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        if (progressCallback) {
                            if (typeof progressCallback === "function") emitter.on((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT), function(progress) {
                                progressCallback(progress);
                            });
                            else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, _s3.getObject)(s3Config, params)
                        ];
                    case 3:
                        response = _f.sent();
                        emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
                        (0, _storageUtils.dispatchStorageEvent)(track, "download", {
                            method: "get",
                            result: "success"
                        }, {
                            fileSize: Number(response.Body["size"] || response.Body["length"])
                        }, "Download success for ".concat(key));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_2 = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "download", {
                            method: "get",
                            result: "failed"
                        }, null, "Download failed with ".concat(error_2.message));
                        throw error_2;
                    case 5:
                        if (!validateObjectExistence) return [
                            3 /*break*/ ,
                            9
                        ];
                        _f.label = 6;
                    case 6:
                        _f.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 7:
                        _f.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_3 = _f.sent();
                        if (((_a = error_3.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_3;
                    case 9:
                        _f.trys.push([
                            9,
                            12,
                            ,
                            13
                        ]);
                        _b = (0, _s3.getPresignedGetObjectUrl);
                        _c = [
                            __assign({}, s3Config)
                        ];
                        _e = {
                            expiration: expires || DEFAULT_PRESIGN_EXPIRATION
                        };
                        return [
                            4 /*yield*/ ,
                            s3Config.credentials()
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, [
                                __assign.apply(void 0, _c.concat([
                                    (_e.credentials = _f.sent(), _e.signingRegion = s3Config.region, _e.signingService = (0, _s3.SERVICE_NAME), _e)
                                ])),
                                params
                            ])
                        ];
                    case 11:
                        url = _f.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "success"
                        }, null, "Signed URL: ".concat(url));
                        return [
                            2 /*return*/ ,
                            url
                        ];
                    case 12:
                        error_4 = _f.sent();
                        logger.warn("get signed url error", error_4);
                        (0, _storageUtils.dispatchStorageEvent)(track, "getSignedUrl", {
                            method: "get",
                            result: "failed"
                        }, null, "Could not get a signed URL for ".concat(key));
                        throw error_4;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Properties of the object
     *
     * @param {string} key - key of the object
     * @param {S3ProviderGetPropertiesConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderGetPropertiesOutput>} - A promise resolves to contentType,
     * contentLength, eTag, lastModified, metadata
     */ AWSS3Provider.prototype.getProperties = function(key, config) {
        var _a;
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, prefix, final_key, s3Config, params, response, getPropertiesResponse, error_5;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = (_b = opt.track, _b === void 0 ? false : _b), SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug("getProperties ".concat(key, " from ").concat(final_key));
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).GetProperties
                        }));
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.headObject)(s3Config, params)
                        ];
                    case 3:
                        response = _c.sent();
                        getPropertiesResponse = {
                            contentLength: response.ContentLength,
                            contentType: response.ContentType,
                            eTag: response.ETag,
                            lastModified: response.LastModified,
                            metadata: response.Metadata
                        };
                        (0, _storageUtils.dispatchStorageEvent)(track, "getProperties", {
                            method: "getProperties",
                            result: "success"
                        }, null, "getProperties successful for ".concat(key));
                        return [
                            2 /*return*/ ,
                            getPropertiesResponse
                        ];
                    case 4:
                        error_5 = _c.sent();
                        if (((_a = error_5.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 404) (0, _storageUtils.dispatchStorageEvent)(track, "getProperties", {
                            method: "getProperties",
                            result: "failed"
                        }, null, "".concat(key, " not found"));
                        throw error_5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param key - key of the object
     * @param object - File to be put in Amazon S3 bucket
     * @param [config] - Optional configuration for the underlying S3 command
     * @return an instance of AWSS3UploadTask or a promise that resolves to an object with the new object's key on
     * success.
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        var opt = Object.assign({}, this._config, config);
        var bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback, level = opt.level, resumable = opt.resumable;
        var contentType = opt.contentType, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging, acl = opt.acl;
        var serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
        var type = contentType ? contentType : "binary/octet-stream";
        var params = {
            Bucket: bucket,
            Key: key,
            Body: object,
            ContentType: type
        };
        if (cacheControl) params.CacheControl = cacheControl;
        if (contentDisposition) params.ContentDisposition = contentDisposition;
        if (contentEncoding) params.ContentEncoding = contentEncoding;
        if (expires) params.Expires = expires;
        if (metadata) params.Metadata = metadata;
        if (tagging) params.Tagging = tagging;
        if (serverSideEncryption) params.ServerSideEncryption = serverSideEncryption;
        if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
        if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
        if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
        if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
        var emitter = new _events.EventEmitter();
        var uploader = new (0, _awss3ProviderManagedUpload.AWSS3ProviderManagedUpload)(params, opt, emitter);
        if (acl) params.ACL = acl;
        if (resumable === true) {
            var s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                storageAction: (0, _core.StorageAction).Put
            }));
            var addTaskInput = {
                bucket: bucket,
                key: key,
                s3Config: s3Config,
                file: object,
                emitter: emitter,
                accessLevel: level,
                params: params
            };
            // explicitly asserting the type here as Typescript could not infer that resumable is of type true
            return this.startResumableUpload(addTaskInput, config);
        }
        try {
            if (progressCallback) {
                if (typeof progressCallback === "function") emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
                    progressCallback(progress);
                });
                else logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
            }
            return uploader.upload().then(function(response) {
                logger.debug("upload result", response);
                (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
                    method: "put",
                    result: "success"
                }, null, "Upload success for ".concat(key));
                return {
                    key: key
                };
            });
        } catch (error) {
            logger.warn("error uploading", error);
            (0, _storageUtils.dispatchStorageEvent)(track, "upload", {
                method: "put",
                result: "failed"
            }, null, "Error uploading ".concat(key));
            throw error;
        }
    };
    /**
     * Remove the object for specified key
     * @param {string} key - key of the object
     * @param {S3ProviderRemoveConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderRemoveOutput>} - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, params, s3Config, response, error_6;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        logger.debug("remove " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                            storageAction: (0, _core.StorageAction).Remove
                        }));
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.deleteObject)(s3Config, params)
                        ];
                    case 3:
                        response = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "delete", {
                            method: "remove",
                            result: "success"
                        }, null, "Deleted ".concat(key, " successfully"));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 4:
                        error_6 = _a.sent();
                        (0, _storageUtils.dispatchStorageEvent)(track, "delete", {
                            method: "remove",
                            result: "failed"
                        }, null, "Deletion of ".concat(key, " failed with ").concat(error_6));
                        throw error_6;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._list = function(params, opt, prefix) {
        return __awaiter(this, void 0, void 0, function() {
            var list, response;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)((0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opt), {
                                storageAction: (0, _core.StorageAction).List
                            })), __assign({}, params))
                        ];
                    case 1:
                        response = _a.sent();
                        if (response && response.Contents) {
                            list.results = response.Contents.map(function(item) {
                                return {
                                    key: item.Key.substr(prefix.length),
                                    eTag: item.ETag,
                                    lastModified: item.LastModified,
                                    size: item.Size
                                };
                            });
                            list.nextToken = response.NextContinuationToken;
                            list.hasNextToken = response.IsTruncated;
                        }
                        return [
                            2 /*return*/ ,
                            list
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {string} path - the path that contains objects
     * @param {S3ProviderListConfig} [config] - Optional configuration for the underlying S3 command
     * @return {Promise<S3ProviderListOutput>} - Promise resolves to list of keys, eTags, lastModified
     * and file size for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return __awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, pageSize, nextToken, prefix, final_path, list, MAX_PAGE_SIZE, listResult, params, error_7;
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _c.sent();
                        if (!credentialsOK || !this._isWithCredentials(this._config)) throw new Error((0, _storageErrorStrings.StorageErrorStrings).NO_CREDENTIALS);
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, pageSize = opt.pageSize, nextToken = opt.nextToken;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        logger.debug("list " + path + " from " + final_path);
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        list = {
                            results: [],
                            hasNextToken: false
                        };
                        MAX_PAGE_SIZE = 1000;
                        listResult = void 0;
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: MAX_PAGE_SIZE,
                            ContinuationToken: nextToken
                        };
                        params.ContinuationToken = nextToken;
                        if (!(pageSize === "ALL")) return [
                            3 /*break*/ ,
                            7
                        ];
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 4:
                        listResult = _c.sent();
                        (_a = list.results).push.apply(_a, __spreadArray([], __read(listResult.results), false));
                        if (listResult.nextToken) params.ContinuationToken = listResult.nextToken;
                        _c.label = 5;
                    case 5:
                        if (listResult.nextToken) return [
                            3 /*break*/ ,
                            3
                        ];
                        _c.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        if (pageSize && pageSize <= MAX_PAGE_SIZE && typeof pageSize === "number") params.MaxKeys = pageSize;
                        else logger.warn("pageSize should be from 0 - ".concat(MAX_PAGE_SIZE, "."));
                        return [
                            4 /*yield*/ ,
                            this._list(params, opt, prefix)
                        ];
                    case 8:
                        listResult = _c.sent();
                        (_b = list.results).push.apply(_b, __spreadArray([], __read(listResult.results), false));
                        list.hasNextToken = listResult.hasNextToken;
                        list.nextToken = (0, listResult.nextToken);
                        _c.label = 9;
                    case 9:
                        (0, _storageUtils.dispatchStorageEvent)(track, "list", {
                            method: "list",
                            result: "success"
                        }, null, "".concat(list.results.length, " items returned from list operation"));
                        logger.debug("list", list);
                        return [
                            2 /*return*/ ,
                            list
                        ];
                    case 10:
                        error_7 = _c.sent();
                        logger.error("list InvalidArgument", error_7);
                        (0, _storageUtils.dispatchStorageEvent)(track, "list", {
                            method: "list",
                            result: "failed"
                        }, null, "Listing items failed: ".concat(error_7.message));
                        throw error_7;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._ensureCredentials = function() {
        return __awaiter(this, void 0, void 0, function() {
            var credentials, cred, error_8;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug("set credentials for storage", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_8 = _a.sent();
                        logger.warn("ensure credentials error", error_8);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3Provider.prototype._isWithCredentials = function(config) {
        return typeof config === "object" && config.hasOwnProperty("credentials");
    };
    AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : "private/") + identityId + "/";
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : "protected/") + identityId + "/";
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : "public/";
        switch(level){
            case "private":
                return privatePath;
            case "protected":
                return protectedPath;
            default:
                return publicPath;
        }
    };
    AWSS3Provider.CATEGORY = "Storage";
    AWSS3Provider.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider;
}();

},{"@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","../common/StorageErrorStrings":"5FJDR","../common/StorageUtils":"2VK2g","../common/S3ClientUtils":"iu1YF","./AWSS3ProviderManagedUpload":"6BvX7","./AWSS3UploadTask":"3YUiw","../common/StorageConstants":"34577","events":"dar5h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8H3Qf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", ()=>(0, _base.SERVICE_NAME));
parcelHelpers.export(exports, "getObject", ()=>(0, _getObject.getObject));
parcelHelpers.export(exports, "getPresignedGetObjectUrl", ()=>(0, _getObject.getPresignedGetObjectUrl));
parcelHelpers.export(exports, "listObjectsV2", ()=>(0, _listObjectsV2.listObjectsV2));
parcelHelpers.export(exports, "putObject", ()=>(0, _putObject.putObject));
parcelHelpers.export(exports, "createMultipartUpload", ()=>(0, _createMultipartUpload.createMultipartUpload));
parcelHelpers.export(exports, "uploadPart", ()=>(0, _uploadPart.uploadPart));
parcelHelpers.export(exports, "completeMultipartUpload", ()=>(0, _completeMultipartUpload.completeMultipartUpload));
parcelHelpers.export(exports, "listParts", ()=>(0, _listParts.listParts));
parcelHelpers.export(exports, "abortMultipartUpload", ()=>(0, _abortMultipartUpload.abortMultipartUpload));
parcelHelpers.export(exports, "copyObject", ()=>(0, _copyObject.copyObject));
parcelHelpers.export(exports, "headObject", ()=>(0, _headObject.headObject));
parcelHelpers.export(exports, "deleteObject", ()=>(0, _deleteObject.deleteObject));
var _base = require("./base");
var _getObject = require("./getObject");
var _listObjectsV2 = require("./listObjectsV2");
var _putObject = require("./putObject");
var _createMultipartUpload = require("./createMultipartUpload");
var _uploadPart = require("./uploadPart");
var _completeMultipartUpload = require("./completeMultipartUpload");
var _listParts = require("./listParts");
var _abortMultipartUpload = require("./abortMultipartUpload");
var _copyObject = require("./copyObject");
var _headObject = require("./headObject");
var _deleteObject = require("./deleteObject");

},{"./base":"5CQ3l","./getObject":"jm2cc","./listObjectsV2":"5tZz8","./putObject":"28JPR","./createMultipartUpload":"40v7G","./uploadPart":"hY7Iz","./completeMultipartUpload":"cP4XE","./listParts":"jAX3y","./abortMultipartUpload":"3NnE9","./copyObject":"dpqr0","./headObject":"cwNBH","./deleteObject":"cUAyH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5CQ3l":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICE_NAME", ()=>SERVICE_NAME);
parcelHelpers.export(exports, "isDnsCompatibleBucketName", ()=>isDnsCompatibleBucketName);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
var _core = require("@aws-amplify/core");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("./utils");
var DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
var IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
var DOTS_PATTERN = /\.\./;
var SERVICE_NAME = "s3";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region, and input parameters.
 */ var endpointResolver = function(options, apiInput) {
    var region = options.region, useAccelerateEndpoint = options.useAccelerateEndpoint, customEndpoint = options.customEndpoint, forcePathStyle = options.forcePathStyle;
    var endpoint;
    // 1. get base endpoint
    if (customEndpoint) endpoint = new URL(customEndpoint);
    else if (useAccelerateEndpoint) {
        if (forcePathStyle) throw new Error("Path style URLs are not supported with S3 Transfer Acceleration.");
        endpoint = new URL("https://s3-accelerate.".concat((0, _awsClientUtils.getDnsSuffix)(region)));
    } else endpoint = new URL("https://s3.".concat(region, ".").concat((0, _awsClientUtils.getDnsSuffix)(region)));
    // 2. inject bucket name
    if (apiInput === null || apiInput === void 0 ? void 0 : apiInput.Bucket) {
        if (!isDnsCompatibleBucketName(apiInput.Bucket)) throw new Error('Invalid bucket name: "'.concat(apiInput.Bucket, '".'));
        if (forcePathStyle || apiInput.Bucket.includes(".")) endpoint.pathname = "/".concat(apiInput.Bucket);
        else endpoint.host = "".concat(apiInput.Bucket, ".").concat(endpoint.host);
    }
    return {
        url: endpoint
    };
};
var isDnsCompatibleBucketName = function(bucketName) {
    return DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
};
var defaultConfig = {
    service: SERVICE_NAME,
    endpointResolver: endpointResolver,
    retryDecider: (0, _awsClientUtils.getRetryDecider)((0, _utils.parseXmlError)),
    computeDelay: (0, _awsClientUtils.jitteredBackoff),
    userAgentValue: (0, _core.getAmplifyUserAgent)(),
    useAccelerateEndpoint: false,
    uriEscapePath: false
};

},{"@aws-amplify/core":"3rlh1","@aws-amplify/core/internals/aws-client-utils":"cD43M","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kSyt3":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlBody", ()=>(0, _parsePayload.parseXmlBody));
parcelHelpers.export(exports, "parseXmlError", ()=>(0, _parsePayload.parseXmlError));
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>(0, _runtime.SEND_DOWNLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>(0, _runtime.SEND_UPLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "s3TransferHandler", ()=>(0, _runtime.s3TransferHandler));
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>(0, _runtime.CANCELED_ERROR_MESSAGE));
parcelHelpers.export(exports, "isCancelError", ()=>(0, _runtime.isCancelError));
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>(0, _runtime.CONTENT_SHA256_HEADER));
parcelHelpers.export(exports, "deserializeBoolean", ()=>(0, _deserializeHelpers.deserializeBoolean));
parcelHelpers.export(exports, "deserializeMetadata", ()=>(0, _deserializeHelpers.deserializeMetadata));
parcelHelpers.export(exports, "deserializeNumber", ()=>(0, _deserializeHelpers.deserializeNumber));
parcelHelpers.export(exports, "deserializeTimestamp", ()=>(0, _deserializeHelpers.deserializeTimestamp));
parcelHelpers.export(exports, "emptyArrayGuard", ()=>(0, _deserializeHelpers.emptyArrayGuard));
parcelHelpers.export(exports, "map", ()=>(0, _deserializeHelpers.map));
parcelHelpers.export(exports, "assignStringVariables", ()=>(0, _serializeHelpers.assignStringVariables));
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", ()=>(0, _serializeHelpers.serializeObjectConfigsToHeaders));
parcelHelpers.export(exports, "serializePathnameObjectKey", ()=>(0, _serializeHelpers.serializePathnameObjectKey));
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", ()=>(0, _serializeHelpers.serializeObjectSsecOptionsToHeaders));
parcelHelpers.export(exports, "toBase64", ()=>(0, _runtime.toBase64));
parcelHelpers.export(exports, "utf8Encode", ()=>(0, _runtime.utf8Encode));
var _parsePayload = require("./parsePayload");
var _runtime = require("../runtime");
var _deserializeHelpers = require("./deserializeHelpers");
var _serializeHelpers = require("./serializeHelpers");

},{"./parsePayload":"6LB8T","../runtime":"d4Suo","./deserializeHelpers":"JQAKY","./serializeHelpers":"gNA5n","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6LB8T":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseXmlError", ()=>parseXmlError);
parcelHelpers.export(exports, "parseXmlBody", ()=>parseXmlBody);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _runtime = require("../runtime");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var parseXmlError = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var statusCode, body, code, message, error;
        var _a, _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (!response || response.statusCode < 300) return [
                        2 /*return*/ 
                    ];
                    statusCode = response.statusCode;
                    return [
                        4 /*yield*/ ,
                        parseXmlBody(response)
                    ];
                case 1:
                    body = _c.sent();
                    code = (body === null || body === void 0 ? void 0 : body["Code"]) ? body.Code : statusCode === 404 ? "NotFound" : statusCode.toString();
                    message = (_b = (_a = body === null || body === void 0 ? void 0 : body["message"]) !== null && _a !== void 0 ? _a : body === null || body === void 0 ? void 0 : body["Message"]) !== null && _b !== void 0 ? _b : code;
                    error = new Error(message);
                    return [
                        2 /*return*/ ,
                        Object.assign(error, {
                            name: code,
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var parseXmlBody = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var data;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!response.body) // S3 can return 200 without a body indicating failure.
                    throw new Error("S3 aborted request.");
                    return [
                        4 /*yield*/ ,
                        response.body.text()
                    ];
                case 1:
                    data = _a.sent();
                    if ((data === null || data === void 0 ? void 0 : data.length) > 0) try {
                        return [
                            2 /*return*/ ,
                            (0, _runtime.parser).parse(data)
                        ];
                    } catch (error) {
                        throw new Error("Failed to parse XML response.");
                    }
                    return [
                        2 /*return*/ ,
                        {}
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","../runtime":"d4Suo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4Suo":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Entry point for browser-specific S3 client utilities. It's used where DOMParser is available.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>(0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>(0, _constants.SEND_UPLOAD_PROGRESS_EVENT));
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>(0, _constants.CANCELED_ERROR_MESSAGE));
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>(0, _constants.CONTENT_SHA256_HEADER));
parcelHelpers.export(exports, "s3TransferHandler", ()=>(0, _xhr.s3TransferHandler));
parcelHelpers.export(exports, "parser", ()=>(0, _dom.parser));
parcelHelpers.export(exports, "isCancelError", ()=>(0, _xhrTransferHandler.isCancelError));
parcelHelpers.export(exports, "toBase64", ()=>(0, _indexBrowser.toBase64));
parcelHelpers.export(exports, "utf8Encode", ()=>(0, _indexBrowser.utf8Encode));
var _constants = require("./constants");
var _xhr = require("./s3TransferHandler/xhr");
var _dom = require("./xmlParser/dom");
var _xhrTransferHandler = require("./xhrTransferHandler");
var _indexBrowser = require("./base64/index.browser");

},{"./constants":"3LpYx","./s3TransferHandler/xhr":"gVp0P","./xmlParser/dom":"hRe9F","./xhrTransferHandler":"iOmPL","./base64/index.browser":"iE3B9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LpYx":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_UPLOAD_PROGRESS_EVENT", ()=>SEND_UPLOAD_PROGRESS_EVENT);
parcelHelpers.export(exports, "SEND_DOWNLOAD_PROGRESS_EVENT", ()=>SEND_DOWNLOAD_PROGRESS_EVENT);
parcelHelpers.export(exports, "NETWORK_ERROR_MESSAGE", ()=>NETWORK_ERROR_MESSAGE);
parcelHelpers.export(exports, "NETWORK_ERROR_CODE", ()=>NETWORK_ERROR_CODE);
parcelHelpers.export(exports, "ABORT_ERROR_MESSAGE", ()=>ABORT_ERROR_MESSAGE);
parcelHelpers.export(exports, "ABORT_ERROR_CODE", ()=>ABORT_ERROR_CODE);
parcelHelpers.export(exports, "CANCELED_ERROR_MESSAGE", ()=>CANCELED_ERROR_MESSAGE);
parcelHelpers.export(exports, "CANCELED_ERROR_CODE", ()=>CANCELED_ERROR_CODE);
parcelHelpers.export(exports, "CONTENT_SHA256_HEADER", ()=>CONTENT_SHA256_HEADER);
var SEND_UPLOAD_PROGRESS_EVENT = "sendUploadProgress";
var SEND_DOWNLOAD_PROGRESS_EVENT = "sendDownloadProgress";
var NETWORK_ERROR_MESSAGE = "Network Error";
var NETWORK_ERROR_CODE = "ECONNABORTED";
var ABORT_ERROR_MESSAGE = "Request aborted";
var ABORT_ERROR_CODE = "ERR_ABORTED";
var CANCELED_ERROR_MESSAGE = "canceled";
var CANCELED_ERROR_CODE = "ERR_CANCELED";
var CONTENT_SHA256_HEADER = "x-amz-content-sha256";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gVp0P":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s3TransferHandler", ()=>s3TransferHandler);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _contentSha256Middleware = require("../contentSha256middleware");
var _xhrTransferHandler = require("../xhrTransferHandler");
var s3TransferHandler = (0, _composers.composeTransferHandler)((0, _xhrTransferHandler.xhrTransferHandler), [
    (0, _contentSha256Middleware.contentSha256Middleware),
    (0, _awsClientUtils.userAgentMiddleware),
    (0, _awsClientUtils.retryMiddleware),
    (0, _awsClientUtils.signingMiddleware)
]);

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","../contentSha256middleware":"9oaKA","../xhrTransferHandler":"iOmPL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9oaKA":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentSha256Middleware", ()=>contentSha256Middleware);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _constants = require("./constants");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var contentSha256Middleware = function(options) {
    return function(next) {
        return function contentSha256Middleware(request) {
            return __awaiter(this, void 0, void 0, function() {
                var hash;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!request.headers[0, _constants.CONTENT_SHA256_HEADER]) return [
                                3 /*break*/ ,
                                1
                            ];
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                (0, _awsClientUtils.getHashedPayload)(request.body)
                            ];
                        case 2:
                            hash = _a.sent();
                            request.headers[0, _constants.CONTENT_SHA256_HEADER] = hash;
                            return [
                                2 /*return*/ ,
                                next(request)
                            ];
                    }
                });
            });
        };
    };
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","./constants":"3LpYx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iOmPL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhrTransferHandler", ()=>xhrTransferHandler);
parcelHelpers.export(exports, "isCancelError", ()=>isCancelError);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _core = require("@aws-amplify/core");
var _constants = require("./constants");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var logger = new (0, _core.ConsoleLogger)("xhr-http-handler");
var xhrTransferHandler = function(request, options) {
    var url = request.url, method = request.method, headers = request.headers, body = request.body;
    var emitter = options.emitter, responseType = options.responseType, abortSignal = options.abortSignal;
    return new Promise(function(resolve, reject) {
        var _a;
        var xhr = new XMLHttpRequest();
        xhr.open(method.toUpperCase(), url.toString());
        Object.entries(headers).filter(function(_a) {
            var _b = __read(_a, 1), header = _b[0];
            return !FORBIDDEN_HEADERS.includes(header);
        }).forEach(function(_a) {
            var _b = __read(_a, 2), header = _b[0], value = _b[1];
            xhr.setRequestHeader(header, value);
        });
        xhr.responseType = responseType;
        if (emitter) {
            xhr.upload.addEventListener("progress", function(event) {
                emitter.emit((0, _constants.SEND_UPLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
            xhr.addEventListener("progress", function(event) {
                emitter.emit((0, _constants.SEND_DOWNLOAD_PROGRESS_EVENT), event);
                logger.debug(event);
            });
        }
        xhr.addEventListener("error", function() {
            var error = simulateAxiosError((0, _constants.NETWORK_ERROR_MESSAGE), (0, _constants.NETWORK_ERROR_CODE), xhr, options);
            logger.error((0, _constants.NETWORK_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Handle browser request cancellation (as opposed to a manual cancellation)
        xhr.addEventListener("abort", function() {
            // The abort event can be triggered after the error or load event. So we need to check if the xhr is null.
            if (!xhr || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted)) return;
            var error = simulateAxiosError((0, _constants.ABORT_ERROR_MESSAGE), (0, _constants.ABORT_ERROR_CODE), xhr, options);
            logger.error((0, _constants.ABORT_ERROR_MESSAGE));
            reject(error);
            xhr = null; // clean up request
        });
        // Skip handling timeout error since we don't have a timeout
        xhr.addEventListener("readystatechange", function() {
            if (!xhr || xhr.readyState !== xhr.DONE) return;
            var onloadend = function() {
                // The load event is triggered after the error/abort/load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var responseHeaders = convertResponseHeaders(xhr.getAllResponseHeaders());
                var responseType = xhr.responseType;
                var responseBlob = xhr.response;
                var responseText = responseType === "text" ? xhr.responseText : "";
                var bodyMixIn = {
                    blob: function() {
                        return Promise.resolve(responseBlob);
                    },
                    text: (0, _awsClientUtils.withMemoization)(function() {
                        return responseType === "blob" ? readBlobAsText(responseBlob) : Promise.resolve(responseText);
                    }),
                    json: function() {
                        return Promise.reject(// S3 does not support JSON response. So fail-fast here with nicer error message.
                        new Error("Parsing response to JSON is not implemented. Please use response.text() instead."));
                    }
                };
                var response = {
                    statusCode: xhr.status,
                    headers: responseHeaders,
                    // The xhr.responseType is only set to 'blob' for streaming binary S3 object data. The streaming data is
                    // exposed via public interface of Storage.get(). So we need to return the response as a Blob object for
                    // backward compatibility. In other cases, the response payload is only used internally, we return it is
                    // {@link ResponseBodyMixin}
                    body: xhr.responseType === "blob" ? Object.assign(responseBlob, bodyMixIn) : bodyMixIn
                };
                resolve(response);
                xhr = null; // clean up request
            };
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            // @see https://github.com/axios/axios/blob/9588fcdec8aca45c3ba2f7968988a5d03f23168c/lib/adapters/xhr.js#L98-L99
            setTimeout(onloadend);
        });
        if (abortSignal) {
            var onCancelled = function() {
                // The abort event is triggered after the error or load event. So we need to check if the xhr is null.
                if (!xhr) return;
                var canceledError = simulateAxiosCanceledError((0, _constants.CANCELED_ERROR_MESSAGE) !== null && (0, _constants.CANCELED_ERROR_MESSAGE) !== void 0 ? (0, _constants.CANCELED_ERROR_MESSAGE) : abortSignal.reason, (0, _constants.CANCELED_ERROR_CODE), xhr, options);
                xhr.abort();
                reject(canceledError);
                xhr = null;
            };
            abortSignal.aborted ? onCancelled() : abortSignal.addEventListener("abort", onCancelled);
        }
        if (typeof ReadableStream === "function" && body instanceof ReadableStream) // This does not matter as previous implementation uses Axios which does not support ReadableStream anyway.
        throw new Error("ReadableStream request payload is not supported.");
        xhr.send((_a = body) !== null && _a !== void 0 ? _a : null);
    });
};
// TODO: V6 remove this
var simulateAxiosError = function(message, code, request, config) {
    return Object.assign(new Error(message), {
        code: code,
        config: config,
        request: request
    });
};
var simulateAxiosCanceledError = function(message, code, request, config) {
    var error = simulateAxiosError(message, code, request, config);
    error.name = "CanceledError";
    error["__CANCEL__"] = true;
    return error;
};
var isCancelError = function(error) {
    return !!(error === null || error === void 0 ? void 0 : error["__CANCEL__"]);
};
/**
 * Convert xhr.getAllResponseHeaders() string to a Record<string, string>. Note that modern browser already returns
 * header names in lowercase.
 * @param xhrHeaders - string of headers returned from xhr.getAllResponseHeaders()
 */ var convertResponseHeaders = function(xhrHeaders) {
    if (!xhrHeaders) return {};
    return xhrHeaders.split("\r\n").reduce(function(headerMap, line) {
        var parts = line.split(": ");
        var header = parts.shift();
        var value = parts.join(": ");
        headerMap[header.toLowerCase()] = value;
        return headerMap;
    }, {});
};
var readBlobAsText = function(blob) {
    var reader = new FileReader();
    return new Promise(function(resolve, reject) {
        reader.onloadend = function() {
            if (reader.readyState !== FileReader.DONE) return;
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
        reader.readAsText(blob);
    });
};
// To add more forbidden headers as found set by S3. Intentionally NOT list all of them here to save bundle size.
// https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
var FORBIDDEN_HEADERS = [
    "host"
];

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core":"3rlh1","./constants":"3LpYx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hRe9F":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Drop-in replacement for fast-xml-parser's XmlParser class used in the AWS SDK S3 client XML deserializer. This
 * implementation is not tested against the full xml conformance test suite. It is only tested against the XML responses
 * from S3. This implementation requires the `DOMParser` class in the runtime.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parser", ()=>parser);
var parser = {
    parse: function(xmlStr) {
        var domParser = new DOMParser();
        var xml = domParser.parseFromString(xmlStr, "text/xml");
        var parsedObj = parseXmlNode(xml);
        var rootKey = Object.keys(parsedObj)[0];
        return parsedObj[rootKey];
    }
};
var parseXmlNode = function(node) {
    var _a;
    var _b, _c;
    if (isDocumentNode(node)) return _a = {}, _a[node.documentElement.nodeName] = parseXmlNode(node.documentElement), _a;
    if (node.nodeType === Node.TEXT_NODE) return (_b = node.nodeValue) === null || _b === void 0 ? void 0 : _b.trim();
    if (isElementNode(node)) {
        // Node like <Location>foo</Location> will be converted to { Location: 'foo' }
        // instead of { Location: { '#text': 'foo' } }.
        if (isTextOnlyElementNode(node)) return (_c = node.childNodes[0]) === null || _c === void 0 ? void 0 : _c.nodeValue;
        var nodeValue = {};
        // convert attributes
        for(var i = 0; i < node.attributes.length; i++){
            var attr = node.attributes[i];
            if (!isNamespaceAttributeName(attr.nodeName)) nodeValue[attr.nodeName] = attr.nodeValue;
        }
        // convert child nodes
        if (node.children.length > 0) for(var i = 0; i < node.children.length; i++){
            var child = node.children[i];
            var childValue = parseXmlNode(child);
            if (childValue === undefined) continue;
            var childName = child.nodeName;
            if (nodeValue[childName] === undefined) nodeValue[childName] = childValue;
            else if (Array.isArray(nodeValue[childName])) nodeValue[childName].push(childValue);
            else nodeValue[childName] = [
                nodeValue[childName],
                childValue
            ];
        }
        // Return empty element node as empty string instead of `{}`, which is the default behavior of fast-xml-parser.
        return Object.keys(nodeValue).length === 0 ? "" : nodeValue;
    }
};
var isElementNode = function(node) {
    return node.nodeType === Node.ELEMENT_NODE;
};
var isDocumentNode = function(node) {
    return node.nodeType === Node.DOCUMENT_NODE;
};
var isTextOnlyElementNode = function(node) {
    var _a;
    return hasOnlyNamespaceAttributes(node) && node.children.length === 0 && ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.nodeType) === Node.TEXT_NODE;
};
var hasOnlyNamespaceAttributes = function(node) {
    for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes[i];
        if (!isNamespaceAttributeName(attr.nodeName)) return false;
    }
    return true;
};
var isNamespaceAttributeName = function(name) {
    return name === "xmlns" || name.startsWith("xmlns:");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iE3B9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utf8Encode", ()=>utf8Encode);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
function bytesToBase64(bytes) {
    var base64Str = Array.from(bytes, function(x) {
        return String.fromCodePoint(x);
    }).join("");
    return btoa(base64Str);
}
function utf8Encode(input) {
    return new TextEncoder().encode(input);
}
function toBase64(input) {
    if (typeof input === "string") return bytesToBase64(utf8Encode(input));
    return bytesToBase64(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"JQAKY":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "deserializeNumber", ()=>deserializeNumber);
parcelHelpers.export(exports, "deserializeBoolean", ()=>deserializeBoolean);
parcelHelpers.export(exports, "deserializeTimestamp", ()=>deserializeTimestamp);
parcelHelpers.export(exports, "emptyArrayGuard", ()=>emptyArrayGuard);
parcelHelpers.export(exports, "deserializeMetadata", ()=>deserializeMetadata);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var map = function(obj, instructions) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = __values(Object.entries(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], instruction = _d[1];
            var _e = __read(Array.isArray(instruction) ? instruction : [
                instruction
            ], 2), accessor = _e[0], deserializer = _e[1];
            if (obj.hasOwnProperty(accessor)) result[key] = deserializer ? deserializer(obj[accessor]) : String(obj[accessor]);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
};
var deserializeNumber = function(value) {
    return value ? Number(value) : undefined;
};
var deserializeBoolean = function(value) {
    return value ? value === "true" : undefined;
};
var deserializeTimestamp = function(value) {
    return value ? new Date(value) : undefined;
};
var emptyArrayGuard = function(value, deserializer) {
    if (value === "") return [];
    var valueArray = (Array.isArray(value) ? value : [
        value
    ]).filter(function(e) {
        return e != null;
    });
    return deserializer(valueArray);
};
var deserializeMetadata = function(headers) {
    var objectMetadataHeaderPrefix = "x-amz-meta-";
    var deserialized = Object.keys(headers).filter(function(header) {
        return header.startsWith(objectMetadataHeaderPrefix);
    }).reduce(function(acc, header) {
        acc[header.replace(objectMetadataHeaderPrefix, "")] = headers[header];
        return acc;
    }, {});
    return Object.keys(deserialized).length > 0 ? deserialized : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gNA5n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignStringVariables", ()=>assignStringVariables);
parcelHelpers.export(exports, "serializeObjectSsecOptionsToHeaders", ()=>serializeObjectSsecOptionsToHeaders);
parcelHelpers.export(exports, "serializeObjectConfigsToHeaders", ()=>serializeObjectConfigsToHeaders);
parcelHelpers.export(exports, "serializePathnameObjectKey", ()=>serializePathnameObjectKey);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _md5Js = require("@aws-sdk/md5-js");
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _utils = require("../utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var assignStringVariables = function(values) {
    var e_1, _a;
    var queryParams = {};
    try {
        for(var _b = __values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) queryParams[key] = value.toString();
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return queryParams;
};
var serializeObjectSsecOptionsToHeaders = function(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var getMd5Digest, _a, _b, _c, _d;
        var _e;
        return __generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    getMd5Digest = function(content) {
                        return __awaiter(void 0, void 0, void 0, function() {
                            var md5Hasher;
                            return __generator(this, function(_a) {
                                md5Hasher = new (0, _md5Js.Md5)();
                                md5Hasher.update((0, _utils.utf8Encode)(content));
                                return [
                                    2 /*return*/ ,
                                    md5Hasher.digest()
                                ];
                            });
                        });
                    };
                    _a = assignStringVariables;
                    _e = {
                        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
                        // base64 encoded is need
                        // see: https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html#specifying-s3-c-encryption
                        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey && (0, _utils.toBase64)(input.SSECustomerKey)
                    };
                    // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                    // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                    _b = "x-amz-server-side-encryption-customer-key-md5";
                    _c = input.SSECustomerKey;
                    if (!_c) return [
                        3 /*break*/ ,
                        2
                    ];
                    _d = (0, _utils.toBase64);
                    return [
                        4 /*yield*/ ,
                        getMd5Digest(input.SSECustomerKey)
                    ];
                case 1:
                    _c = _d.apply(void 0, [
                        _f.sent()
                    ]);
                    _f.label = 2;
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            // Calculate the md5 digest of the the SSE-C key, for compatibility with AWS SDK
                            // see: https://github.com/aws/aws-sdk-js-v3/blob/91fc83307c38cc9cbe0b3acd919557d5b5b831d6/packages/middleware-ssec/src/index.ts#L36
                            (_e[_b] = _c, _e)
                        ])
                    ];
            }
        });
    });
};
var serializeObjectConfigsToHeaders = function(input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var _a;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        serializeObjectSsecOptionsToHeaders(input)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        __assign.apply(void 0, [
                            __assign.apply(void 0, _a.concat([
                                _c.sent()
                            ])),
                            assignStringVariables(__assign({
                                "x-amz-server-side-encryption": input.ServerSideEncryption,
                                "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
                                "x-amz-acl": input.ACL,
                                "cache-control": input.CacheControl,
                                "content-disposition": input.ContentDisposition,
                                "content-language": input.ContentLanguage,
                                "content-encoding": input.ContentEncoding,
                                "content-type": input.ContentType,
                                expires: (_b = input.Expires) === null || _b === void 0 ? void 0 : _b.toUTCString(),
                                "x-amz-tagging": input.Tagging
                            }, serializeMetadata(input.Metadata)))
                        ])
                    ];
            }
        });
    });
};
var serializeMetadata = function(metadata) {
    if (metadata === void 0) metadata = {};
    return Object.keys(metadata).reduce(function(acc, suffix) {
        acc["x-amz-meta-".concat(suffix.toLowerCase())] = metadata[suffix];
        return acc;
    }, {});
};
var serializePathnameObjectKey = function(url, key) {
    return url.pathname.replace(/\/$/, "") + "/".concat(key.split("/").map((0, _awsClientUtils.extendedEncodeURIComponent)).join("/"));
};

},{"@aws-sdk/md5-js":"3GaA7","@aws-amplify/core/internals/aws-client-utils":"cD43M","../utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3GaA7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Md5", ()=>Md5);
var _tslib = require("tslib");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _constants = require("./constants");
var Md5 = /** @class */ function() {
    function Md5() {
        this.state = Uint32Array.from((0, _constants.INIT));
        this.buffer = new DataView(new ArrayBuffer((0, _constants.BLOCK_SIZE)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
    Md5.prototype.update = function(sourceData) {
        if (isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var data = convertToBuffer(sourceData);
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, _constants.BLOCK_SIZE)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    Md5.prototype.digest = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, buffer, undecoratedLength, bytesHashed, bitsHashed, i, i, out, i;
            return (0, _tslib.__generator)(this, function(_b) {
                if (!this.finished) {
                    _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
                    bitsHashed = bytesHashed * 8;
                    buffer.setUint8(this.bufferLength++, 128);
                    // Ensure the final block has enough room for the hashed length
                    if (undecoratedLength % (0, _constants.BLOCK_SIZE) >= (0, _constants.BLOCK_SIZE) - 8) {
                        for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE); i++)buffer.setUint8(i, 0);
                        this.hashBuffer();
                        this.bufferLength = 0;
                    }
                    for(i = this.bufferLength; i < (0, _constants.BLOCK_SIZE) - 8; i++)buffer.setUint8(i, 0);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 8, bitsHashed >>> 0, true);
                    buffer.setUint32((0, _constants.BLOCK_SIZE) - 4, Math.floor(bitsHashed / 0x100000000), true);
                    this.hashBuffer();
                    this.finished = true;
                }
                out = new DataView(new ArrayBuffer((0, _constants.DIGEST_LENGTH)));
                for(i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
                return [
                    2 /*return*/ ,
                    new Uint8Array(out.buffer, out.byteOffset, out.byteLength)
                ];
            });
        });
    };
    Md5.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var a = state[0], b = state[1], c = state[2], d = state[3];
        a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    };
    return Md5;
}();
function cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") return (0, _utilUtf8Browser.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"tslib":"m02BL","@aws-sdk/util-utf8-browser":"iZmxX","./constants":"8bZZx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"m02BL":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8bZZx":[function(require,module,exports) {
/**
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLOCK_SIZE", ()=>BLOCK_SIZE);
parcelHelpers.export(exports, "DIGEST_LENGTH", ()=>DIGEST_LENGTH);
parcelHelpers.export(exports, "INIT", ()=>INIT);
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jm2cc":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getObject", ()=>getObject);
parcelHelpers.export(exports, "getPresignedGetObjectUrl", ()=>getPresignedGetObjectUrl);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _core = require("@aws-amplify/core");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var getObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, query, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    query = (0, _utils.map)(input, {
                        "response-cache-control": "ResponseCacheControl",
                        "response-content-disposition": "ResponseContentDisposition",
                        "response-content-encoding": "ResponseContentEncoding",
                        "response-content-language": "ResponseContentLanguage",
                        "response-content-type": "ResponseContentType"
                    });
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams(query).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var getObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    if (!response.body) throw new Error("Got empty response body.");
                    else return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            DeleteMarker: [
                                "x-amz-delete-marker",
                                (0, _utils.deserializeBoolean)
                            ],
                            AcceptRanges: "accept-ranges",
                            Expiration: "x-amz-expiration",
                            Restore: "x-amz-restore",
                            LastModified: [
                                "last-modified",
                                (0, _utils.deserializeTimestamp)
                            ],
                            ContentLength: [
                                "content-length",
                                (0, _utils.deserializeNumber)
                            ],
                            ETag: "etag",
                            ChecksumCRC32: "x-amz-checksum-crc32",
                            ChecksumCRC32C: "x-amz-checksum-crc32c",
                            ChecksumSHA1: "x-amz-checksum-sha1",
                            ChecksumSHA256: "x-amz-checksum-sha256",
                            MissingMeta: [
                                "x-amz-missing-meta",
                                (0, _utils.deserializeNumber)
                            ],
                            VersionId: "x-amz-version-id",
                            CacheControl: "cache-control",
                            ContentDisposition: "content-disposition",
                            ContentEncoding: "content-encoding",
                            ContentLanguage: "content-language",
                            ContentRange: "content-range",
                            ContentType: "content-type",
                            Expires: [
                                "expires",
                                (0, _utils.deserializeTimestamp)
                            ],
                            WebsiteRedirectLocation: "x-amz-website-redirect-location",
                            ServerSideEncryption: "x-amz-server-side-encryption",
                            SSECustomerAlgorithm: "x-amz-server-side-encryption-customer-algorithm",
                            SSECustomerKeyMD5: "x-amz-server-side-encryption-customer-key-md5",
                            SSEKMSKeyId: "x-amz-server-side-encryption-aws-kms-key-id",
                            BucketKeyEnabled: [
                                "x-amz-server-side-encryption-bucket-key-enabled",
                                (0, _utils.deserializeBoolean)
                            ],
                            StorageClass: "x-amz-storage-class",
                            RequestCharged: "x-amz-request-charged",
                            ReplicationStatus: "x-amz-replication-status",
                            PartsCount: [
                                "x-amz-mp-parts-count",
                                (0, _utils.deserializeNumber)
                            ],
                            TagCount: [
                                "x-amz-tagging-count",
                                (0, _utils.deserializeNumber)
                            ],
                            ObjectLockMode: "x-amz-object-lock-mode",
                            ObjectLockRetainUntilDate: [
                                "x-amz-object-lock-retain-until-date",
                                (0, _utils.deserializeTimestamp)
                            ],
                            ObjectLockLegalHoldStatus: "x-amz-object-lock-legal-hold"
                        })), {
                            Metadata: (0, _utils.deserializeMetadata)(response.headers),
                            $metadata: (0, _awsClientUtils.parseMetadata)(response),
                            Body: response.body
                        })
                    ];
                    _a.label = 3;
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var getObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), getObjectSerializer, getObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "blob"
}));
var getPresignedGetObjectUrl = function(config, input) {
    return __awaiter(void 0, void 0, void 0, function() {
        var endpoint, _a, url, headers, method, _b, _c, _d, headerName, value;
        var e_1, _e;
        var _f;
        return __generator(this, function(_g) {
            switch(_g.label){
                case 0:
                    endpoint = (0, _base.defaultConfig).endpointResolver(config, input);
                    return [
                        4 /*yield*/ ,
                        getObjectSerializer(input, endpoint)
                    ];
                case 1:
                    _a = _g.sent(), url = _a.url, headers = _a.headers, method = _a.method;
                    // TODO: set content sha256 query parameter with value of UNSIGNED-PAYLOAD.
                    // It requires changes in presignUrl. Without this change, the generated url still works,
                    // but not the same as other tools like AWS SDK and CLI.
                    url.searchParams.append((0, _utils.CONTENT_SHA256_HEADER), (0, _awsClientUtils.EMPTY_SHA256_HASH));
                    url.searchParams.append((_f = config.userAgentHeader) !== null && _f !== void 0 ? _f : (0, _core.USER_AGENT_HEADER), config.userAgentValue);
                    try {
                        for(_b = __values(Object.entries(headers).sort(function(_a, _b) {
                            var _c = __read(_a, 1), key1 = _c[0];
                            var _d = __read(_b, 1), key2 = _d[0];
                            return key1.localeCompare(key2);
                        })), _c = _b.next(); !_c.done; _c = _b.next()){
                            _d = __read(_c.value, 2), headerName = _d[0], value = _d[1];
                            url.searchParams.append(headerName, value);
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    return [
                        2 /*return*/ ,
                        (0, _awsClientUtils.presignUrl)({
                            method: method,
                            url: url,
                            body: null
                        }, __assign(__assign({}, (0, _base.defaultConfig)), config)).toString()
                    ];
            }
        });
    });
};

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","@aws-amplify/core":"3rlh1","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5tZz8":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listObjectsV2", ()=>listObjectsV2);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listObjectsV2Serializer = function(input, endpoint) {
    var headers = (0, _utils.assignStringVariables)({
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    var query = (0, _utils.assignStringVariables)({
        "list-type": "2",
        "continuation-token": input.ContinuationToken,
        delimiter: input.Delimiter,
        "encoding-type": input.EncodingType,
        "fetch-owner": input.FetchOwner,
        "max-keys": input.MaxKeys,
        prefix: input.Prefix,
        "start-after": input.StartAfter
    });
    var url = new URL(endpoint.url.toString());
    url.search = new URLSearchParams(query).toString();
    return {
        method: "GET",
        headers: headers,
        url: url
    };
};
var listObjectsV2Deserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        CommonPrefixes: [
                            "CommonPrefixes",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCommonPrefixList);
                            }
                        ],
                        Contents: [
                            "Contents",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeObjectList);
                            }
                        ],
                        ContinuationToken: "ContinuationToken",
                        Delimiter: "Delimiter",
                        EncodingType: "EncodingType",
                        IsTruncated: [
                            "IsTruncated",
                            (0, _utils.deserializeBoolean)
                        ],
                        KeyCount: [
                            "KeyCount",
                            (0, _utils.deserializeNumber)
                        ],
                        MaxKeys: [
                            "MaxKeys",
                            (0, _utils.deserializeNumber)
                        ],
                        Name: "Name",
                        NextContinuationToken: "NextContinuationToken",
                        Prefix: "Prefix",
                        StartAfter: "StartAfter"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCommonPrefixList = function(output) {
    return output.map(deserializeCommonPrefix);
};
var deserializeCommonPrefix = function(output) {
    return (0, _utils.map)(output, {
        Prefix: "Prefix"
    });
};
var deserializeObjectList = function(output) {
    return output.map(deserializeObject);
};
var deserializeObject = function(output) {
    return (0, _utils.map)(output, {
        Key: "Key",
        LastModified: [
            "LastModified",
            (0, _utils.deserializeTimestamp)
        ],
        ETag: "ETag",
        ChecksumAlgorithm: [
            "ChecksumAlgorithm",
            function(value) {
                return (0, _utils.emptyArrayGuard)(value, deserializeChecksumAlgorithmList);
            }
        ],
        Size: [
            "Size",
            (0, _utils.deserializeNumber)
        ],
        StorageClass: "StorageClass",
        Owner: [
            "Owner",
            deserializeOwner
        ]
    });
};
var deserializeChecksumAlgorithmList = function(output) {
    return output.map(function(entry) {
        return String(entry);
    });
};
var deserializeOwner = function(output) {
    return (0, _utils.map)(output, {
        DisplayName: "DisplayName",
        ID: "ID"
    });
};
var listObjectsV2 = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listObjectsV2Serializer, listObjectsV2Deserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28JPR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "putObject", ()=>putObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var putObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        var _b;
        return __generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(__assign(__assign({}, input), {
                            ContentType: (_b = input.ContentType) !== null && _b !== void 0 ? _b : "application/octet-stream"
                        }))
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _c.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var putObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: "etag",
                            VersionId: "x-amz-version-id"
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var putObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), putObjectSerializer, putObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40v7G":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMultipartUpload", ()=>createMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var createMultipartUploadSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = "uploads";
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var createMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: "UploadId"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var createMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), createMultipartUploadSerializer, createMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hY7Iz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uploadPart", ()=>uploadPart);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var uploadPartSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "content-md5": input.ContentMD5
                        })
                    ]);
                    headers["content-type"] = "application/octet-stream";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        partNumber: input.PartNumber + "",
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url,
                            body: input.Body
                        }
                    ];
            }
        });
    });
};
var uploadPartDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, (0, _utils.map)(response.headers, {
                            ETag: "etag"
                        })), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var uploadPart = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), uploadPartSerializer, uploadPartDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cP4XE":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "completeMultipartUpload", ()=>completeMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var INVALID_PARAMETER_ERROR_MSG = "Invalid parameter for ComplteMultipartUpload API";
var completeMultipartUploadSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    headers["content-type"] = "application/xml";
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "POST",
                            headers: headers,
                            url: url,
                            body: '<?xml version="1.0" encoding="UTF-8"?>' + serializeCompletedMultipartUpload(input.MultipartUpload)
                        }
                    ];
            }
        });
    });
};
var serializeCompletedMultipartUpload = function(input) {
    var _a;
    if (!((_a = input.Parts) === null || _a === void 0 ? void 0 : _a.length)) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return '<CompleteMultipartUpload xmlns="http://s3.amazonaws.com/doc/2006-03-01/">'.concat(input.Parts.map(serializeCompletedPartList).join(""), "</CompleteMultipartUpload>");
};
var serializeCompletedPartList = function(input) {
    if (!input.ETag || input.PartNumber == null) throw new Error("".concat(INVALID_PARAMETER_ERROR_MSG, ": ").concat(input));
    return "<Part><ETag>".concat(input.ETag, "</ETag><PartNumber>").concat(input.PartNumber, "</PartNumber></Part>");
};
/**
 * Parse CompleteMultipartUpload API response payload, which may be empty or error indicating internal
 * server error, even when the status code is 200.
 *
 * Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
 */ var parseXmlBodyOrThrow = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (!(parsed.Code !== undefined && parsed.Message !== undefined)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(__assign(__assign({}, response), {
                            statusCode: 500
                        }))
                    ];
                case 2:
                    error = _a.sent();
                    error.$metadata.httpStatusCode = response.statusCode;
                    throw error;
                case 3:
                    return [
                        2 /*return*/ ,
                        parsed
                    ];
            }
        });
    });
};
var completeMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        parseXmlBodyOrThrow(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        ETag: "ETag",
                        Key: "Key",
                        Location: "Location"
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
// CompleteMultiPartUpload API returns 200 status code with empty body or error message.
// This indicates internal server error after the response has been sent to the client.
// Ref: https://docs.aws.amazon.com/AmazonS3/latest/API/API_CompleteMultipartUpload.html#API_CompleteMultipartUpload_Example_4
var retryWhenErrorWith200StatusCode = function(response, error) {
    return __awaiter(void 0, void 0, void 0, function() {
        var parsed, defaultRetryDecider;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode === 200)) return [
                        3 /*break*/ ,
                        2
                    ];
                    if (!response.body) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 1:
                    parsed = _a.sent();
                    if (parsed.Code !== undefined && parsed.Message !== undefined) return [
                        2 /*return*/ ,
                        true
                    ];
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 2:
                    defaultRetryDecider = (0, _base.defaultConfig).retryDecider;
                    return [
                        2 /*return*/ ,
                        defaultRetryDecider(response, error)
                    ];
            }
        });
    });
};
var completeMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), completeMultipartUploadSerializer, completeMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text",
    retryDecider: retryWhenErrorWith200StatusCode
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jAX3y":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listParts", ()=>listParts);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var listPartsSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    url.search = new URLSearchParams({
                        uploadId: input.UploadId
                    }).toString();
                    return [
                        2 /*return*/ ,
                        {
                            method: "GET",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var listPartsDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, parsed, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    parsed = _a.sent();
                    contents = (0, _utils.map)(parsed, {
                        UploadId: "UploadId",
                        Parts: [
                            "Part",
                            function(value) {
                                return (0, _utils.emptyArrayGuard)(value, deserializeCompletedPartList);
                            }
                        ]
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var deserializeCompletedPartList = function(input) {
    return input.map(function(item) {
        return (0, _utils.map)(item, {
            PartNumber: [
                "PartNumber",
                (0, _utils.deserializeNumber)
            ],
            ETag: "ETag",
            Size: [
                "Size",
                (0, _utils.deserializeNumber)
            ]
        });
    });
};
var listParts = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), listPartsSerializer, listPartsDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NnE9":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abortMultipartUpload", ()=>abortMultipartUpload);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var abortMultipartUploadSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    url.search = new URLSearchParams({
        uploadId: input.UploadId
    }).toString();
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var abortMultipartUploadDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var abortMultipartUpload = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), abortMultipartUploadSerializer, abortMultipartUploadDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dpqr0":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyObject", ()=>copyObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var copyObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, _a, url;
        return __generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = [
                        {}
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectConfigsToHeaders)(input)
                    ];
                case 1:
                    headers = __assign.apply(void 0, [
                        __assign.apply(void 0, _a.concat([
                            _b.sent()
                        ])),
                        (0, _utils.assignStringVariables)({
                            "x-amz-copy-source": input.CopySource,
                            "x-amz-metadata-directive": input.MetadataDirective
                        })
                    ]);
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "PUT",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var copyObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlBody)(response)
                    ];
                case 3:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }
                    ];
            }
        });
    });
};
var copyObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), copyObjectSerializer, copyObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cwNBH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "headObject", ()=>headObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var headObjectSerializer = function(input, endpoint) {
    return __awaiter(void 0, void 0, void 0, function() {
        var headers, url;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, _utils.serializeObjectSsecOptionsToHeaders)(input)
                    ];
                case 1:
                    headers = _a.sent();
                    url = new URL(endpoint.url.toString());
                    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
                    return [
                        2 /*return*/ ,
                        {
                            method: "HEAD",
                            headers: headers,
                            url: url
                        }
                    ];
            }
        });
    });
};
var headObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, contents;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    contents = __assign(__assign({}, (0, _utils.map)(response.headers, {
                        ContentLength: [
                            "content-length",
                            (0, _utils.deserializeNumber)
                        ],
                        ContentType: "content-type",
                        ETag: "etag",
                        LastModified: [
                            "last-modified",
                            (0, _utils.deserializeTimestamp)
                        ],
                        VersionId: "x-amz-version-id"
                    })), {
                        Metadata: (0, _utils.deserializeMetadata)(response.headers)
                    });
                    return [
                        2 /*return*/ ,
                        __assign({
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        }, contents)
                    ];
            }
        });
    });
};
var headObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), headObjectSerializer, headObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cUAyH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteObject", ()=>deleteObject);
var _awsClientUtils = require("@aws-amplify/core/internals/aws-client-utils");
var _composers = require("@aws-amplify/core/internals/aws-client-utils/composers");
var _base = require("./base");
var _utils = require("./utils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var deleteObjectSerializer = function(input, endpoint) {
    var url = new URL(endpoint.url.toString());
    url.pathname = (0, _utils.serializePathnameObjectKey)(url, input.Key);
    return {
        method: "DELETE",
        headers: {},
        url: url
    };
};
var deleteObjectDeserializer = function(response) {
    return __awaiter(void 0, void 0, void 0, function() {
        var error, content;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(response.statusCode >= 300)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, _utils.parseXmlError)(response)
                    ];
                case 1:
                    error = _a.sent();
                    throw error;
                case 2:
                    content = (0, _utils.map)(response.headers, {
                        DeleteMarker: [
                            "x-amz-delete-marker",
                            (0, _utils.deserializeBoolean)
                        ],
                        VersionId: "x-amz-version-id",
                        RequestCharged: "x-amz-request-charged"
                    });
                    return [
                        2 /*return*/ ,
                        __assign(__assign({}, content), {
                            $metadata: (0, _awsClientUtils.parseMetadata)(response)
                        })
                    ];
            }
        });
    });
};
var deleteObject = (0, _composers.composeServiceApi)((0, _utils.s3TransferHandler), deleteObjectSerializer, deleteObjectDeserializer, __assign(__assign({}, (0, _base.defaultConfig)), {
    responseType: "text"
}));

},{"@aws-amplify/core/internals/aws-client-utils":"cD43M","@aws-amplify/core/internals/aws-client-utils/composers":"ddv9k","./base":"5CQ3l","./utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5FJDR":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageErrorStrings", ()=>StorageErrorStrings);
parcelHelpers.export(exports, "AWSS3ProviderMultipartCopierErrors", ()=>AWSS3ProviderMultipartCopierErrors);
parcelHelpers.export(exports, "AWSS3ProviderUploadErrorStrings", ()=>AWSS3ProviderUploadErrorStrings);
var StorageErrorStrings;
(function(StorageErrorStrings) {
    StorageErrorStrings["NO_CREDENTIALS"] = "No credentials";
    StorageErrorStrings["NO_SRC_KEY"] = 'source param should be an object with the property "key" with value of type string';
    StorageErrorStrings["NO_DEST_KEY"] = 'destination param should be an object with the property "key" with value of type string';
    StorageErrorStrings["INVALID_BLOB"] = "Object must be an instance of Blob";
})(StorageErrorStrings || (StorageErrorStrings = {}));
var AWSS3ProviderMultipartCopierErrors;
(function(AWSS3ProviderMultipartCopierErrors) {
    AWSS3ProviderMultipartCopierErrors["CLEANUP_FAILED"] = "Multipart copy clean up failed";
    AWSS3ProviderMultipartCopierErrors["NO_OBJECT_FOUND"] = "Object does not exist";
    AWSS3ProviderMultipartCopierErrors["INVALID_QUEUESIZE"] = "Queue size must be a positive number";
    AWSS3ProviderMultipartCopierErrors["NO_COPYSOURCE"] = "You must specify a copy source";
    AWSS3ProviderMultipartCopierErrors["MAX_NUM_PARTS_EXCEEDED"] = "Only a maximum of 10000 parts are allowed";
})(AWSS3ProviderMultipartCopierErrors || (AWSS3ProviderMultipartCopierErrors = {}));
var AWSS3ProviderUploadErrorStrings;
(function(AWSS3ProviderUploadErrorStrings) {
    AWSS3ProviderUploadErrorStrings["UPLOAD_PAUSED_MESSAGE"] = "paused";
})(AWSS3ProviderUploadErrorStrings || (AWSS3ProviderUploadErrorStrings = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VK2g":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "byteLength", ()=>byteLength);
parcelHelpers.export(exports, "dispatchStorageEvent", ()=>dispatchStorageEvent);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var byteLength = function(x) {
    if (typeof x === "string") return x.length;
    else if (isArrayBuffer(x)) return x.byteLength;
    else if (isBlob(x)) return x.size;
    else throw new Error("Cannot determine byte length of " + x);
};
var dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) {
        var data = {
            attrs: attrs
        };
        if (metrics) data["metrics"] = metrics;
        (0, _core.Hub).dispatch("storage", {
            event: event,
            data: data,
            message: message
        }, "Storage", (0, _storageConstants.AMPLIFY_SYMBOL));
    }
};
var isFile = function(x) {
    return typeof x !== "undefined" && x instanceof File;
};
var isBlob = function(x) {
    return typeof x !== "undefined" && x instanceof Blob;
};
var isArrayBuffer = function(x) {
    return typeof x !== "undefined" && x instanceof ArrayBuffer;
};

},{"@aws-amplify/core":"3rlh1","./StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"34577":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
parcelHelpers.export(exports, "localTestingStorageEndpoint", ()=>localTestingStorageEndpoint);
parcelHelpers.export(exports, "UPLOADS_STORAGE_KEY", ()=>UPLOADS_STORAGE_KEY);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var localTestingStorageEndpoint = "http://localhost:20005";
var UPLOADS_STORAGE_KEY = "__uploadInProgress";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iu1YF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrefix", ()=>getPrefix);
parcelHelpers.export(exports, "credentialsProvider", ()=>credentialsProvider);
parcelHelpers.export(exports, "loadS3Config", ()=>loadS3Config);
parcelHelpers.export(exports, "DEFAULT_PART_SIZE", ()=>DEFAULT_PART_SIZE);
parcelHelpers.export(exports, "MAX_OBJECT_SIZE", ()=>MAX_OBJECT_SIZE);
parcelHelpers.export(exports, "MAX_PARTS_COUNT", ()=>MAX_PARTS_COUNT);
parcelHelpers.export(exports, "DEFAULT_QUEUE_SIZE", ()=>DEFAULT_QUEUE_SIZE);
parcelHelpers.export(exports, "calculatePartSize", ()=>calculatePartSize);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _storageConstants = require("./StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.Logger)("S3ClientUtils");
// placeholder credentials in order to satisfy type requirement, always results in 403 when used
var INVALID_CRED = {
    accessKeyId: "",
    secretAccessKey: ""
};
var getPrefix = function(config) {
    var credentials = config.credentials, level = config.level, customPrefix = config.customPrefix, identityId = config.identityId;
    var resolvedCustomPrefix = customPrefix || {};
    var resolvedIdentityId = identityId || credentials.identityId;
    var privatePath = (resolvedCustomPrefix.private !== undefined ? resolvedCustomPrefix.private : "private/") + resolvedIdentityId + "/";
    var protectedPath = (resolvedCustomPrefix.protected !== undefined ? resolvedCustomPrefix.protected : "protected/") + resolvedIdentityId + "/";
    var publicPath = resolvedCustomPrefix.public !== undefined ? resolvedCustomPrefix.public : "public/";
    switch(level){
        case "private":
            return privatePath;
        case "protected":
            return protectedPath;
        default:
            return publicPath;
    }
};
var credentialsProvider = function() {
    return __awaiter(void 0, void 0, void 0, function() {
        var credentials, cred, error_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        (0, _core.Credentials).get()
                    ];
                case 1:
                    credentials = _a.sent();
                    if (!credentials) return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                    cred = (0, _core.Credentials).shear(credentials);
                    logger.debug("credentials provider get credentials", cred);
                    return [
                        2 /*return*/ ,
                        cred
                    ];
                case 2:
                    error_1 = _a.sent();
                    logger.warn("credentials provider error", error_1);
                    return [
                        2 /*return*/ ,
                        INVALID_CRED
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var loadS3Config = function(config) {
    if (!config.region) // Same error thrown by aws-sdk
    throw new Error("Region is missing.");
    return __assign(__assign(__assign({}, config), {
        region: config.region,
        credentials: config.credentials ? function() {
            return Promise.resolve(config.credentials);
        } : credentialsProvider,
        userAgentValue: (0, _core.getAmplifyUserAgent)({
            category: (0, _core.Category).Storage,
            action: config.storageAction
        })
    }), config.dangerouslyConnectToHttpEndpointForTesting ? {
        customEndpoint: (0, _storageConstants.localTestingStorageEndpoint),
        forcePathStyle: true
    } : {});
};
var MiB = 1048576;
var GiB = 1024 * MiB;
var TiB = 1024 * GiB;
var DEFAULT_PART_SIZE = 5 * MiB;
var MAX_OBJECT_SIZE = 5 * TiB;
var MAX_PARTS_COUNT = 10000;
var DEFAULT_QUEUE_SIZE = 4;
var calculatePartSize = function(totalSize) {
    var partSize = DEFAULT_PART_SIZE;
    var partsCount = Math.ceil(totalSize / partSize);
    while(partsCount > MAX_PARTS_COUNT){
        partSize *= 2;
        partsCount = Math.ceil(totalSize / partSize);
    }
    return partSize;
};

},{"@aws-amplify/core":"3rlh1","./StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6BvX7":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3ProviderManagedUpload", ()=>AWSS3ProviderManagedUpload);
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _events = require("events");
var _md5Utils = require("../common/MD5utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var logger = new (0, _core.ConsoleLogger)("AWSS3ProviderManagedUpload");
var AWSS3ProviderManagedUpload = /** @class */ function() {
    function AWSS3ProviderManagedUpload(params, opts, emitter) {
        this.opts = null;
        this.completedParts = [];
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        // Progress reporting
        this.bytesUploaded = 0;
        this.totalBytesToUpload = 0;
        this.emitter = null;
        this.params = params;
        this.opts = __assign({
            isObjectLockEnabled: false
        }, opts);
        this.emitter = emitter;
        this.s3Config = (0, _s3ClientUtils.loadS3Config)(__assign(__assign({}, opts), {
            emitter: emitter,
            storageAction: (0, _core.StorageAction).Put
        }));
    }
    AWSS3ProviderManagedUpload.prototype.upload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var isObjectLockEnabled, _a, _b, _c, _d, _e, numberOfPartsToUpload, parts, start, error_1;
            var _f;
            var _this = this;
            return __generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        _g.trys.push([
                            0,
                            12,
                            ,
                            14
                        ]);
                        isObjectLockEnabled = this.opts.isObjectLockEnabled;
                        if (!(isObjectLockEnabled === true)) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.params;
                        return [
                            4 /*yield*/ ,
                            (0, _md5Utils.calculateContentMd5)(// @ts-expect-error currently ReadableStream<any> is not being supported in put api
                            this.params.Body)
                        ];
                    case 1:
                        _a.ContentMD5 = _g.sent();
                        _g.label = 2;
                    case 2:
                        this.body = this.validateAndSanitizeBody(this.params.Body);
                        this.totalBytesToUpload = this.byteLength(this.body);
                        if (!(this.totalBytesToUpload <= (0, _s3ClientUtils.DEFAULT_PART_SIZE))) return [
                            3 /*break*/ ,
                            4
                        ];
                        // Multipart upload is not required. Upload the sanitized body as is
                        this.params.Body = this.body;
                        _b = (0, _s3.putObject);
                        _c = [
                            this.s3Config
                        ];
                        _d = [
                            __assign({}, this.params)
                        ];
                        _f = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.apply(void 0, _c.concat([
                                __assign.apply(void 0, _d.concat([
                                    (_f.Key = _g.sent(), _f)
                                ]))
                            ]))
                        ];
                    case 4:
                        // Step 1: Determine appropriate part size.
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytesToUpload);
                        // Step 2: Initiate the multi part upload
                        _e = this;
                        return [
                            4 /*yield*/ ,
                            this.createMultiPartUpload()
                        ];
                    case 5:
                        // Step 2: Initiate the multi part upload
                        _e.uploadId = _g.sent();
                        numberOfPartsToUpload = Math.ceil(this.totalBytesToUpload / this.partSize);
                        parts = this.createParts();
                        start = 0;
                        _g.label = 6;
                    case 6:
                        if (!(start < numberOfPartsToUpload)) return [
                            3 /*break*/ ,
                            9
                        ];
                        // Upload as many as `queueSize` parts simultaneously
                        return [
                            4 /*yield*/ ,
                            this.uploadParts(this.uploadId, parts.slice(start, start + (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE)))
                        ];
                    case 7:
                        // Upload as many as `queueSize` parts simultaneously
                        _g.sent();
                        _g.label = 8;
                    case 8:
                        start += (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 9:
                        parts.map(function(part) {
                            _this.removeEventListener(part);
                        });
                        return [
                            4 /*yield*/ ,
                            this.finishMultiPartUpload(this.uploadId)
                        ];
                    case 10:
                        // Step 3: Finalize the upload such that S3 can recreate the file
                        return [
                            2 /*return*/ ,
                            _g.sent()
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        error_1 = _g.sent();
                        // if any error is thrown, call cleanup
                        return [
                            4 /*yield*/ ,
                            this.cleanup(this.uploadId)
                        ];
                    case 13:
                        // if any error is thrown, call cleanup
                        _g.sent();
                        logger.error("Error. Cancelling the multipart upload.");
                        throw error_1;
                    case 14:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.createParts = function() {
        try {
            var parts = [];
            for(var bodyStart = 0; bodyStart < this.totalBytesToUpload;){
                var bodyEnd = Math.min(bodyStart + this.partSize, this.totalBytesToUpload);
                parts.push({
                    bodyPart: this.body.slice(bodyStart, bodyEnd),
                    partNumber: parts.length + 1,
                    emitter: new (0, _events.EventEmitter)(),
                    _lastUploadedBytes: 0
                });
                bodyStart += this.partSize;
            }
            return parts;
        } catch (error) {
            logger.error(error);
            throw error;
        }
    };
    AWSS3ProviderManagedUpload.prototype.createMultiPartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var response, _a, _b, _c, error_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent(), _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        response = _e.sent();
                        logger.debug(response.UploadId);
                        return [
                            2 /*return*/ ,
                            response.UploadId
                        ];
                    case 3:
                        error_2 = _e.sent();
                        logger.error(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private Not to be extended outside of tests
     * @VisibleFotTesting
     */ AWSS3ProviderManagedUpload.prototype.uploadParts = function(uploadId, parts) {
        return __awaiter(this, void 0, void 0, function() {
            var allResults, i, error_3;
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(parts.map(function(part) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var isObjectLockEnabled, _a, _b, Key, Bucket, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, ContentMD5, res, _c, _d;
                                    var _e;
                                    return __generator(this, function(_f) {
                                        switch(_f.label){
                                            case 0:
                                                this.setupEventListener(part);
                                                isObjectLockEnabled = this.opts.isObjectLockEnabled;
                                                if (!isObjectLockEnabled) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _a = this.params;
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _md5Utils.calculateContentMd5)(part.bodyPart)
                                                ];
                                            case 1:
                                                _a.ContentMD5 = _f.sent();
                                                _f.label = 2;
                                            case 2:
                                                _b = this.params, Key = _b.Key, Bucket = _b.Bucket, SSECustomerAlgorithm = _b.SSECustomerAlgorithm, SSECustomerKey = _b.SSECustomerKey, SSECustomerKeyMD5 = _b.SSECustomerKeyMD5, ContentMD5 = _b.ContentMD5;
                                                _c = (0, _s3.uploadPart);
                                                _d = [
                                                    __assign(__assign({}, this.s3Config), {
                                                        emitter: part.emitter
                                                    })
                                                ];
                                                _e = {
                                                    PartNumber: part.partNumber,
                                                    Body: part.bodyPart,
                                                    UploadId: uploadId
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getObjectKeyWithPrefix(this.params.Key)
                                                ];
                                            case 3:
                                                return [
                                                    4 /*yield*/ ,
                                                    _c.apply(void 0, _d.concat([
                                                        (_e.Key = _f.sent(), _e.Bucket = Bucket, _e.SSECustomerAlgorithm = SSECustomerAlgorithm, _e.SSECustomerKey = SSECustomerKey, _e.SSECustomerKeyMD5 = SSECustomerKeyMD5, _e.ContentMD5 = ContentMD5, _e)
                                                    ]))
                                                ];
                                            case 4:
                                                res = _f.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    res
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        allResults = _a.sent();
                        // The order of resolved promises is the same as input promise order.
                        for(i = 0; i < allResults.length; i++)this.completedParts.push({
                            PartNumber: parts[i].partNumber,
                            ETag: allResults[i].ETag
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        error_3 = _a.sent();
                        logger.error("Error happened while uploading a part. Cancelling the multipart upload");
                        throw error_3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.finishMultiPartUpload = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, Key, error_4;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a.MultipartUpload = {
                            Parts: this.completedParts
                        }, _a);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.completeMultipartUpload)(this.s3Config, input)
                        ];
                    case 3:
                        Key = _b.sent().Key;
                        return [
                            2 /*return*/ ,
                            Key
                        ];
                    case 4:
                        error_4 = _b.sent();
                        logger.error("Error happened while finishing the upload.");
                        throw error_4;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.cleanup = function(uploadId) {
        return __awaiter(this, void 0, void 0, function() {
            var input, data;
            var _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        // Reset this's state
                        this.body = null;
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.totalBytesToUpload = 0;
                        if (!uploadId) // This is a single part upload;
                        return [
                            2 /*return*/ 
                        ];
                        _a = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.getObjectKeyWithPrefix(this.params.Key)
                        ];
                    case 1:
                        input = (_a.Key = _b.sent(), _a.UploadId = uploadId, _a);
                        return [
                            4 /*yield*/ ,
                            (0, _s3.abortMultipartUpload)(this.s3Config, input)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listParts)(this.s3Config, input)
                        ];
                    case 3:
                        data = _b.sent();
                        if (data && data.Parts && data.Parts.length > 0) throw new Error("Multipart upload clean up failed.");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3ProviderManagedUpload.prototype.removeEventListener = function(part) {
        part.emitter.removeAllListeners((0, _utils.SEND_UPLOAD_PROGRESS_EVENT));
        part.emitter.removeAllListeners((0, _utils.SEND_DOWNLOAD_PROGRESS_EVENT));
    };
    AWSS3ProviderManagedUpload.prototype.setupEventListener = function(part) {
        var _this = this;
        part.emitter.on((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), function(progress) {
            _this.progressChanged(part.partNumber, progress.loaded - part._lastUploadedBytes);
            part._lastUploadedBytes = progress.loaded;
        });
    };
    AWSS3ProviderManagedUpload.prototype.progressChanged = function(partNumber, incrementalUpdate) {
        this.bytesUploaded += incrementalUpdate;
        this.emitter.emit((0, _utils.SEND_UPLOAD_PROGRESS_EVENT), {
            loaded: this.bytesUploaded,
            total: this.totalBytesToUpload,
            part: partNumber,
            key: this.params.Key
        });
    };
    AWSS3ProviderManagedUpload.prototype.byteLength = function(input) {
        if (input === null || input === undefined) return 0;
        if (typeof input.byteLength === "number") return input.byteLength;
        else if (typeof input.length === "number") return input.length;
        else if (typeof input.size === "number") return input.size;
        else if (typeof input.path === "string") ;
        else throw new Error("Cannot determine length of " + input);
    };
    AWSS3ProviderManagedUpload.prototype.validateAndSanitizeBody = function(body) {
        var sanitizedBody = this.isGenericObject(body) ? JSON.stringify(body) : body;
        /* TODO: streams and files for nodejs
        if (
            typeof body.path === 'string' &&
            require('fs').lstatSync(body.path).size > 0
        ) {
            sanitizedBody = body;
        } */ if (this.byteLength(sanitizedBody) > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytesToUpload, " Bytes"));
        return sanitizedBody;
    };
    AWSS3ProviderManagedUpload.prototype.isGenericObject = function(body) {
        if (body !== null && typeof body === "object") try {
            return !(this.byteLength(body) >= 0);
        } catch (error) {
            // If we cannot determine the length of the body, consider it
            // as a generic object and upload a stringified version of it
            return true;
        }
        return false;
    };
    AWSS3ProviderManagedUpload.prototype.getObjectKeyWithPrefix = function(keyWithoutPrefix) {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _s3ClientUtils.getPrefix);
                        _b = [
                            __assign({}, this.opts)
                        ];
                        _c = {};
                        return [
                            4 /*yield*/ ,
                            (0, _s3ClientUtils.credentialsProvider)()
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, [
                                __assign.apply(void 0, _b.concat([
                                    (_c.credentials = _d.sent(), _c)
                                ]))
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _d.sent() + keyWithoutPrefix
                        ];
                }
            });
        });
    };
    return AWSS3ProviderManagedUpload;
}();

},{"@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","events":"dar5h","../common/MD5utils":"cUKuj","../common/S3ClientUtils":"iu1YF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dar5h":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"cUKuj":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateContentMd5", ()=>calculateContentMd5);
var _md5Js = require("@aws-sdk/md5-js");
var _utils = require("../AwsClients/S3/utils");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var calculateContentMd5 = function(content) {
    return __awaiter(void 0, void 0, void 0, function() {
        var hasher, buffer, digest;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    hasher = new (0, _md5Js.Md5)();
                    if (!(typeof content === "string")) return [
                        3 /*break*/ ,
                        1
                    ];
                    hasher.update(content);
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        readFile(content)
                    ];
                case 2:
                    buffer = _a.sent();
                    hasher.update(buffer);
                    _a.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        hasher.digest()
                    ];
                case 4:
                    digest = _a.sent();
                    return [
                        2 /*return*/ ,
                        (0, _utils.toBase64)(digest)
                    ];
            }
        });
    });
};
var readFile = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            if (reader.result) resolve(reader.result);
            reader.onabort = function() {
                return reject(new Error("Read aborted"));
            };
            reader.onerror = function() {
                return reject(reader.error);
            };
        };
        if (file !== undefined) reader.readAsArrayBuffer(file);
    });
};

},{"@aws-sdk/md5-js":"3GaA7","../AwsClients/S3/utils":"kSyt3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3YUiw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSS3UploadTaskState", ()=>AWSS3UploadTaskState);
parcelHelpers.export(exports, "TaskEvents", ()=>TaskEvents);
parcelHelpers.export(exports, "AWSS3UploadTask", ()=>AWSS3UploadTask);
var _core = require("@aws-amplify/core");
var _s3 = require("../AwsClients/S3");
var _utils = require("../AwsClients/S3/utils");
var _s3ClientUtils = require("../common/S3ClientUtils");
var _storageUtils = require("../common/StorageUtils");
var _storageConstants = require("../common/StorageConstants");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var logger = new (0, _core.Logger)("AWSS3UploadTask");
var AWSS3UploadTaskState;
(function(AWSS3UploadTaskState) {
    AWSS3UploadTaskState[AWSS3UploadTaskState["INIT"] = 0] = "INIT";
    AWSS3UploadTaskState[AWSS3UploadTaskState["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    AWSS3UploadTaskState[AWSS3UploadTaskState["PAUSED"] = 2] = "PAUSED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["CANCELLED"] = 3] = "CANCELLED";
    AWSS3UploadTaskState[AWSS3UploadTaskState["COMPLETED"] = 4] = "COMPLETED";
})(AWSS3UploadTaskState || (AWSS3UploadTaskState = {}));
var TaskEvents;
(function(TaskEvents) {
    TaskEvents["CANCEL"] = "cancel";
    TaskEvents["UPLOAD_COMPLETE"] = "uploadComplete";
    TaskEvents["UPLOAD_PROGRESS"] = "uploadPartProgress";
    TaskEvents["ERROR"] = "error";
})(TaskEvents || (TaskEvents = {}));
function comparePartNumber(a, b) {
    return a.PartNumber - b.PartNumber;
}
var AWSS3UploadTask = /** @class */ function() {
    function AWSS3UploadTask(_a) {
        var s3Config = _a.s3Config, file = _a.file, emitter = _a.emitter, storage = _a.storage, params = _a.params, level = _a.level, prefixPromise = _a.prefixPromise;
        this.queueSize = (0, _s3ClientUtils.DEFAULT_QUEUE_SIZE);
        this.partSize = (0, _s3ClientUtils.DEFAULT_PART_SIZE);
        this.inProgress = [];
        this.completedParts = [];
        this.queued = [];
        this.bytesUploaded = 0;
        this.totalBytes = 0;
        this.state = AWSS3UploadTaskState.INIT;
        this.prefixPromise = prefixPromise;
        this.s3Config = s3Config;
        this.storage = storage;
        this.storageSync = Promise.resolve();
        if (typeof this.storage["sync"] === "function") this.storageSync = this.storage["sync"]();
        this.params = params;
        this.file = file;
        this.totalBytes = this.file.size;
        this.bytesUploaded = 0;
        this.emitter = emitter;
        this.queued = [];
        this.fileId = this._getFileId(level);
        this._validateParams();
        // event emitter will re-throw an error if an event emits an error unless there's a listener, attaching a no-op
        // function to it unless user adds their own onError callback
        this.emitter.on(TaskEvents.ERROR, function() {});
    }
    Object.defineProperty(AWSS3UploadTask.prototype, "percent", {
        get: function() {
            return this.bytesUploaded / this.totalBytes * 100;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AWSS3UploadTask.prototype, "isInProgress", {
        get: function() {
            return this.state === AWSS3UploadTaskState.IN_PROGRESS;
        },
        enumerable: false,
        configurable: true
    });
    AWSS3UploadTask.prototype._listSingleFile = function(_a) {
        var key = _a.key, bucket = _a.bucket;
        return __awaiter(this, void 0, void 0, function() {
            var objectKeyPrefix, _b, Contents, obj;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        objectKeyPrefix = _c.sent();
                        return [
                            4 /*yield*/ ,
                            (0, _s3.listObjectsV2)(this.s3Config, {
                                Bucket: bucket,
                                Prefix: objectKeyPrefix + key
                            })
                        ];
                    case 2:
                        _b = _c.sent().Contents, Contents = _b === void 0 ? [] : _b;
                        obj = Contents.find(function(o) {
                            return o.Key === "".concat(objectKeyPrefix).concat(key);
                        });
                        return [
                            2 /*return*/ ,
                            obj
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._getFileId = function(level) {
        // We should check if it's a File first because File is also instance of a Blob
        if ((0, _storageUtils.isFile)(this.file)) return [
            this.file.name,
            this.file.lastModified,
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
        else return [
            this.file.size,
            this.file.type,
            this.params.Bucket,
            level,
            this.params.Key
        ].join("-");
    };
    AWSS3UploadTask.prototype._findCachedUploadParts = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests, cachedUploadFileData, _a, Parts, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _e.sent();
                        if (Object.keys(uploadRequests).length === 0 || !Object.prototype.hasOwnProperty.call(uploadRequests, this.fileId)) return [
                            2 /*return*/ ,
                            {
                                parts: [],
                                uploadId: null
                            }
                        ];
                        cachedUploadFileData = uploadRequests[this.fileId];
                        cachedUploadFileData.lastTouched = Date.now();
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        _b = (0, _s3.listParts);
                        _c = [
                            this.s3Config
                        ];
                        _d = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _b.apply(void 0, _c.concat([
                                (_d.Key = _e.sent() + this.params.Key, _d.UploadId = cachedUploadFileData.uploadId, _d)
                            ]))
                        ];
                    case 3:
                        _a = _e.sent().Parts, Parts = _a === void 0 ? [] : _a;
                        return [
                            2 /*return*/ ,
                            {
                                parts: Parts,
                                uploadId: cachedUploadFileData.uploadId
                            }
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._emitEvent = function(event, payload) {
        this.emitter.emit(event, payload);
    };
    AWSS3UploadTask.prototype._validateParams = function() {
        if (this.totalBytes > (0, _s3ClientUtils.MAX_OBJECT_SIZE)) throw new Error("File size bigger than S3 Object limit of 5TB, got ".concat(this.totalBytes, " Bytes"));
    };
    AWSS3UploadTask.prototype._listCachedUploadTasks = function() {
        return __awaiter(this, void 0, void 0, function() {
            var tasks;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storageSync
                        ];
                    case 1:
                        _a.sent();
                        tasks = this.storage.getItem((0, _storageConstants.UPLOADS_STORAGE_KEY)) || "{}";
                        return [
                            2 /*return*/ ,
                            JSON.parse(tasks)
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._cache = function(fileMetadata) {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        uploadRequests[this.fileId] = fileMetadata;
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isCached = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = Object.prototype.hasOwnProperty).call;
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.apply(_a, [
                                _c.sent(),
                                this.fileId
                            ])
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._removeFromCache = function() {
        return __awaiter(this, void 0, void 0, function() {
            var uploadRequests;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._listCachedUploadTasks()
                        ];
                    case 1:
                        uploadRequests = _a.sent();
                        delete uploadRequests[this.fileId];
                        this.storage.setItem((0, _storageConstants.UPLOADS_STORAGE_KEY), JSON.stringify(uploadRequests));
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._onPartUploadCompletion = function(_a) {
        var eTag = _a.eTag, partNumber = _a.partNumber, chunk = _a.chunk;
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_b) {
                this.completedParts.push({
                    ETag: eTag,
                    PartNumber: partNumber
                });
                this.bytesUploaded += (0, _storageUtils.byteLength)(chunk);
                this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
                    loaded: this.bytesUploaded,
                    total: this.totalBytes
                });
                // Remove the completed item from the inProgress array
                this.inProgress = this.inProgress.filter(function(job) {
                    return job.uploadPartInput.PartNumber !== partNumber;
                });
                if (this.queued.length && this.state !== AWSS3UploadTaskState.PAUSED) this._startNextPart();
                if (this._isDone()) this._completeUpload();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSS3UploadTask.prototype._completeUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_1;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _d.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.completeMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c.MultipartUpload = {
                                    // Parts are not always completed in order, we need to manually sort them
                                    Parts: __spreadArray([], __read(this.completedParts), false).sort(comparePartNumber)
                                }, _c)
                            ]))
                        ];
                    case 2:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._verifyFileSize()
                        ];
                    case 3:
                        _d.sent();
                        this._emitEvent(TaskEvents.UPLOAD_COMPLETE, {
                            key: this.params.Key
                        });
                        this._removeFromCache();
                        this.state = AWSS3UploadTaskState.COMPLETED;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_1 = _d.sent();
                        logger.error("error completing upload", err_1);
                        this._emitEvent(TaskEvents.ERROR, err_1);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._makeUploadPartRequest = function(input, abortSignal) {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c, err_2;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        _a = (0, _s3.uploadPart);
                        _b = [
                            __assign(__assign({}, this.s3Config), {
                                abortSignal: abortSignal
                            })
                        ];
                        _c = [
                            __assign({}, input)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this._onPartUploadCompletion({
                                eTag: res.ETag,
                                partNumber: input.PartNumber,
                                chunk: input.Body
                            })
                        ];
                    case 3:
                        _e.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_2 = _e.sent();
                        if (this.state === AWSS3UploadTaskState.PAUSED) logger.log("upload paused");
                        else if (this.state === AWSS3UploadTaskState.CANCELLED) logger.log("upload aborted");
                        else logger.error("error starting next part of upload: ", err_2);
                        // xhr transfer handlers' cancel will also throw an error, however we don't need to emit an event in that case as it's an
                        // expected behavior
                        if (!(0, _utils.isCancelError)(err_2) && err_2.message !== (0, _utils.CANCELED_ERROR_MESSAGE)) {
                            this._emitEvent(TaskEvents.ERROR, err_2);
                            this.pause();
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._startNextPart = function() {
        if (this.queued.length > 0 && this.state !== AWSS3UploadTaskState.PAUSED) {
            var abortController = new AbortController();
            var nextPart = this.queued.shift();
            this.inProgress.push({
                uploadPartInput: nextPart,
                s3Request: this._makeUploadPartRequest(nextPart, abortController.signal),
                abortController: abortController
            });
        }
    };
    /**
     * Verify on S3 side that the file size matches the one on the client side.
     *
     * @async
     * @throws throws an error if the file size does not match between local copy of the file and the file on s3.
     */ AWSS3UploadTask.prototype._verifyFileSize = function() {
        return __awaiter(this, void 0, void 0, function() {
            var valid, obj, e_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._listSingleFile({
                                key: this.params.Key,
                                bucket: this.params.Bucket
                            })
                        ];
                    case 1:
                        obj = _a.sent();
                        valid = Boolean(obj && obj.Size === this.file.size);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _a.sent();
                        logger.log("Could not get file on s3 for size matching: ", e_1);
                        // Don't gate verification on auth or other errors
                        // unrelated to file size verification
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (!valid) throw new Error("File size does not match between local file and file on s3");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._isDone = function() {
        return !this.queued.length && !this.inProgress.length && this.bytesUploaded === this.totalBytes;
    };
    AWSS3UploadTask.prototype._createParts = function() {
        var size = this.file.size;
        var parts = [];
        for(var bodyStart = 0; bodyStart < size;){
            var bodyEnd = Math.min(bodyStart + this.partSize, size);
            parts.push({
                Body: this.file.slice(bodyStart, bodyEnd),
                Key: this.params.Key,
                Bucket: this.params.Bucket,
                PartNumber: parts.length + 1,
                UploadId: this.uploadId
            });
            bodyStart += this.partSize;
        }
        return parts;
    };
    AWSS3UploadTask.prototype._initCachedUploadParts = function(cachedParts) {
        this.bytesUploaded += cachedParts.reduce(function(acc, part) {
            return acc + part.Size;
        }, 0);
        // Find the set of part numbers that have already been uploaded
        var uploadedPartNumSet = new Set(cachedParts.map(function(part) {
            return part.PartNumber;
        }));
        this.queued = this.queued.filter(function(part) {
            return !uploadedPartNumSet.has(part.PartNumber);
        });
        this.completedParts = cachedParts.map(function(part) {
            return {
                PartNumber: part.PartNumber,
                ETag: part.ETag
            };
        });
        this._emitEvent(TaskEvents.UPLOAD_PROGRESS, {
            loaded: this.bytesUploaded,
            total: this.totalBytes
        });
    };
    AWSS3UploadTask.prototype._initMultipartUpload = function() {
        return __awaiter(this, void 0, void 0, function() {
            var res, _a, _b, _c;
            var _d;
            return __generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = (0, _s3.createMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = [
                            __assign({}, this.params)
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                __assign.apply(void 0, _c.concat([
                                    (_d.Key = _e.sent() + this.params.Key, _d)
                                ]))
                            ]))
                        ];
                    case 2:
                        res = _e.sent();
                        this._cache({
                            uploadId: res.UploadId,
                            lastTouched: Date.now(),
                            bucket: this.params.Bucket,
                            key: this.params.Key,
                            fileName: this.file instanceof File ? this.file.name : ""
                        });
                        return [
                            2 /*return*/ ,
                            res.UploadId
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype._initializeUploadTask = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, parts, uploadId, uploadId, err_3;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.state = AWSS3UploadTaskState.IN_PROGRESS;
                        this.partSize = (0, _s3ClientUtils.calculatePartSize)(this.totalBytes);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._isCached()
                        ];
                    case 2:
                        if (!_b.sent()) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._findCachedUploadParts()
                        ];
                    case 3:
                        _a = _b.sent(), parts = _a.parts, uploadId = _a.uploadId;
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._initCachedUploadParts(parts);
                        if (this._isDone()) this._completeUpload();
                        else this._startUpload();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        if (!!this.uploadId) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._initMultipartUpload()
                        ];
                    case 5:
                        uploadId = _b.sent();
                        this.uploadId = uploadId;
                        this.queued = this._createParts();
                        this._startUpload();
                        _b.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        err_3 = _b.sent();
                        if (!(0, _utils.isCancelError)(err_3)) {
                            logger.error("Error initializing the upload task", err_3);
                            this._emitEvent(TaskEvents.ERROR, err_3);
                        }
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSS3UploadTask.prototype.resume = function() {
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn("This task has already been cancelled");
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn("This task has already been completed");
        else if (this.state === AWSS3UploadTaskState.IN_PROGRESS) logger.warn("Upload task already in progress");
        else if (!this.uploadId) this._initializeUploadTask();
        else this._startUpload();
    };
    AWSS3UploadTask.prototype._startUpload = function() {
        this.state = AWSS3UploadTaskState.IN_PROGRESS;
        for(var i = 0; i < this.queueSize; i++)this._startNextPart();
    };
    AWSS3UploadTask.prototype._cancel = function() {
        return __awaiter(this, void 0, void 0, function() {
            var _a, _b, err_4;
            var _c;
            return __generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!(this.state === AWSS3UploadTaskState.CANCELLED)) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.warn("This task has already been cancelled");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 1:
                        if (!(this.state === AWSS3UploadTaskState.COMPLETED)) return [
                            3 /*break*/ ,
                            2
                        ];
                        logger.warn("This task has already been completed");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 2:
                        this.pause();
                        this.queued = [];
                        this.completedParts = [];
                        this.bytesUploaded = 0;
                        this.state = AWSS3UploadTaskState.CANCELLED;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([
                            3,
                            7,
                            ,
                            8
                        ]);
                        _a = (0, _s3.abortMultipartUpload);
                        _b = [
                            this.s3Config
                        ];
                        _c = {
                            Bucket: this.params.Bucket
                        };
                        return [
                            4 /*yield*/ ,
                            this.prefixPromise
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _a.apply(void 0, _b.concat([
                                (_c.Key = _d.sent() + this.params.Key, _c.UploadId = this.uploadId, _c)
                            ]))
                        ];
                    case 5:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this._removeFromCache()
                        ];
                    case 6:
                        _d.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 7:
                        err_4 = _d.sent();
                        logger.error("Error cancelling upload task", err_4);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * pause this particular upload task
     **/ AWSS3UploadTask.prototype.pause = function() {
        var _a;
        if (this.state === AWSS3UploadTaskState.CANCELLED) logger.warn("This task has already been cancelled");
        else if (this.state === AWSS3UploadTaskState.COMPLETED) logger.warn("This task has already been completed");
        else if (this.state === AWSS3UploadTaskState.PAUSED) logger.warn("This task is already paused");
        this.state = AWSS3UploadTaskState.PAUSED;
        // Abort the part request immediately
        // Add the inProgress parts back to pending
        var removedInProgressReq = this.inProgress.splice(0, this.inProgress.length);
        removedInProgressReq.forEach(function(req) {
            req.abortController.abort();
        });
        // Put all removed in progress parts back into the queue
        (_a = this.queued).unshift.apply(_a, __spreadArray([], __read(removedInProgressReq.map(function(req) {
            return req.uploadPartInput;
        })), false));
    };
    return AWSS3UploadTask;
}();

},{"@aws-amplify/core":"3rlh1","../AwsClients/S3":"8H3Qf","../AwsClients/S3/utils":"kSyt3","../common/S3ClientUtils":"iu1YF","../common/StorageUtils":"2VK2g","../common/StorageConstants":"34577","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6PDaW":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API", ()=>(0, _api.API));
parcelHelpers.export(exports, "APIClass", ()=>(0, _api.APIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _apiGraphql.graphqlOperation));
parcelHelpers.export(exports, "GraphQLAuthError", ()=>(0, _apiGraphql.GraphQLAuthError));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _apiGraphql.GRAPHQL_AUTH_MODE));
var _api = require("./API");
var _apiGraphql = require("@aws-amplify/api-graphql");

},{"./API":"jP8On","@aws-amplify/api-graphql":"eWncu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jP8On":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APIClass", ()=>APIClass);
parcelHelpers.export(exports, "API", ()=>API);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internalAPI = require("./internals/InternalAPI");
var logger = new (0, _core.ConsoleLogger)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var APIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(APIClass, _super);
    function APIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APIClass.prototype.getModuleName = function() {
        return "API";
    };
    APIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return APIClass;
}((0, _internalAPI.InternalAPIClass));
var API = new APIClass(null);
(0, _core.Amplify).register(API);

},{"tslib":"b0CnX","@aws-amplify/core":"3rlh1","./internals/InternalAPI":"icpYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b0CnX":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icpYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPIClass", ()=>InternalAPIClass);
parcelHelpers.export(exports, "InternalAPI", ()=>InternalAPI);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api-graphql/internals");
var _apiRest = require("@aws-amplify/api-rest");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("API");
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */ var InternalAPIClass = /** @class */ function() {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalAPIClass(options) {
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        this._restApi = new (0, _apiRest.RestAPIClass)(options);
        this._graphqlApi = new (0, _internals.InternalGraphQLAPIClass)(options);
        logger.debug("API Options", this._options);
    }
    InternalAPIClass.prototype.getModuleName = function() {
        return "InternalAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalAPIClass.prototype.configure = function(options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.get = function(apiName, path, init) {
        return this._restApi.get(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Get));
    };
    /**
     * Make a POST request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.post = function(apiName, path, init) {
        return this._restApi.post(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Post));
    };
    /**
     * Make a PUT request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.put = function(apiName, path, init) {
        return this._restApi.put(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Put));
    };
    /**
     * Make a PATCH request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.patch = function(apiName, path, init) {
        return this._restApi.patch(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Patch));
    };
    /**
     * Make a DEL request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.del = function(apiName, path, init) {
        return this._restApi.del(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Del));
    };
    /**
     * Make a HEAD request
     * @param apiName - The api name of the request
     * @param path - The path of the request
     * @param [init] - Request extra params
     * @return A promise that resolves to an object with response status and JSON data, if successful.
     */ InternalAPIClass.prototype.head = function(apiName, path, init) {
        return this._restApi.head(apiName, path, this.getInitWithCustomUserAgentDetails(init, (0, _core.ApiAction).Head));
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param error - Any error
     * @return If the error was from an api request cancellation
     */ InternalAPIClass.prototype.isCancel = function(error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request for either a GraphQL request or a Rest API request.
     * @param request - request to cancel
     * @param [message] - custom error message
     * @return If the request was cancelled
     */ InternalAPIClass.prototype.cancel = function(request, message) {
        if (this._restApi.hasCancelToken(request)) return this._restApi.cancel(request, message);
        else if (this._graphqlApi.hasCancelToken(request)) return this._graphqlApi.cancel(request, message);
        return false;
    };
    InternalAPIClass.prototype.getInitWithCustomUserAgentDetails = function(init, action) {
        var customUserAgentDetails = {
            category: (0, _core.Category).API,
            action: action
        };
        var initParams = (0, _tslib.__assign)((0, _tslib.__assign)({}, init), {
            customUserAgentDetails: customUserAgentDetails
        });
        return initParams;
    };
    /**
     * Getting endpoint for API
     * @param apiName - The name of the api
     * @return The endpoint of the api
     */ InternalAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._restApi.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalAPIClass.prototype.getGraphqlOperationType = function(operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    InternalAPIClass.prototype.graphql = function(options, additionalHeaders, customUserAgentDetails) {
        var apiUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).API,
            action: (0, _core.ApiAction).GraphQl
        }, customUserAgentDetails);
        return this._graphqlApi.graphql(options, additionalHeaders, apiUserAgentDetails);
    };
    return InternalAPIClass;
}();
var InternalAPI = new InternalAPIClass(null);
(0, _core.Amplify).register(InternalAPI);

},{"tslib":"b0CnX","@aws-amplify/api-graphql/internals":"fZD2p","@aws-amplify/api-rest":"by3r2","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fZD2p":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalGraphQLAPI", ()=>(0, _internalGraphQLAPI.InternalGraphQLAPI));
parcelHelpers.export(exports, "InternalGraphQLAPIClass", ()=>(0, _internalGraphQLAPI.InternalGraphQLAPIClass));
var _internalGraphQLAPI = require("./InternalGraphQLAPI");

},{"./InternalGraphQLAPI":"8V6kZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8V6kZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", ()=>graphqlOperation);
parcelHelpers.export(exports, "InternalGraphQLAPIClass", ()=>InternalGraphQLAPIClass);
parcelHelpers.export(exports, "InternalGraphQLAPI", ()=>InternalGraphQLAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _graphql = require("graphql");
var _core = require("@aws-amplify/core");
var _internals = require("@aws-amplify/pubsub/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _types = require("../types");
var _apiRest = require("@aws-amplify/api-rest");
var USER_AGENT_HEADER = "x-amz-user-agent";
var logger = new (0, _core.ConsoleLogger)("GraphQLAPI");
var graphqlOperation = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var InternalGraphQLAPIClass = /** @class */ function() {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function InternalGraphQLAPIClass(options) {
        this._api = null;
        this.Auth = (0, _auth.Auth);
        this.Cache = (0, _cache.Cache);
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
    }
    InternalGraphQLAPIClass.prototype.getModuleName = function() {
        return "InternalGraphQLAPI";
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ InternalGraphQLAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug("configure GraphQL API", {
            opt: opt
        });
        if (opt["aws_project_region"]) opt = Object.assign({}, opt, {
            region: opt["aws_project_region"],
            header: {}
        });
        if (typeof opt.graphql_headers !== "undefined" && typeof opt.graphql_headers !== "function") {
            logger.warn("graphql_headers should be a function");
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ InternalGraphQLAPIClass.prototype.createInstance = function() {
        logger.debug("create Rest instance");
        if (this._options) {
            this._api = new (0, _apiRest.RestClient)(this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        } else return Promise.reject("API not configured");
    };
    InternalGraphQLAPIClass.prototype._headerBasedAuth = function(defaultAuthenticationType, additionalHeaders) {
        if (additionalHeaders === void 0) additionalHeaders = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case "API_KEY":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "AWS_IAM":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "OPENID_CONNECT":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "AMAZON_COGNITO_USER_POOLS":
                                return [
                                    3 /*break*/ ,
                                    11
                                ];
                            case "AWS_LAMBDA":
                                return [
                                    3 /*break*/ ,
                                    15
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 1:
                        if (!apiKey) throw new Error((0, _types.GraphQLAuthError).NO_API_KEY);
                        headers = {
                            Authorization: null,
                            "X-Api-Key": apiKey
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error((0, _types.GraphQLAuthError).NO_CREDENTIALS);
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 4:
                        _c.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        token = void 0;
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem("federatedInfo")
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            6
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) token = currentUser.token;
                        _c.label = 8;
                    case 8:
                        if (!token) throw new Error((0, _types.GraphQLAuthError).NO_FEDERATED_JWT);
                        headers = {
                            Authorization: token
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            13,
                            ,
                            14
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Auth.currentSession()
                        ];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error((0, _types.GraphQLAuthError).NO_CURRENT_USER);
                    case 14:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 15:
                        if (!additionalHeaders.Authorization) throw new Error((0, _types.GraphQLAuthError).NO_AUTH_TOKEN);
                        headers = {
                            Authorization: additionalHeaders.Authorization
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 17:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ InternalGraphQLAPIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, _graphql.parse)(operation);
        var definitions = doc.definitions;
        var _a = (0, _tslib.__read)(definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ InternalGraphQLAPIClass.prototype.graphql = function(_a, additionalHeaders, customUserAgentDetails) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode, authToken = _a.authToken;
        var query = typeof paramQuery === "string" ? (0, _graphql.parse)(paramQuery) : (0, _graphql.parse)((0, _graphql.print)(paramQuery));
        var _c = (0, _tslib.__read)(query.definitions.filter(function(def) {
            return def.kind === "OperationDefinition";
        }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        var headers = additionalHeaders || {};
        // if an authorization header is set, have the explicit authToken take precedence
        if (authToken) headers.Authorization = authToken;
        switch(operationType){
            case "query":
            case "mutation":
                this.createInstanceIfNotCreated();
                var cancellableToken = this._api.getCancellableToken();
                var initParams = {
                    cancellableToken: cancellableToken,
                    withCredentials: this._options.withCredentials
                };
                var responsePromise = this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, initParams, customUserAgentDetails);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case "subscription":
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, headers, customUserAgentDetails);
            default:
                throw new Error("invalid operation type: ".concat(operationType));
        }
    };
    InternalGraphQLAPIClass.prototype._graphql = function(_a, additionalHeaders, initParams, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        if (initParams === void 0) initParams = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        this.createInstanceIfNotCreated();
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 1:
                        _e = _l.sent();
                        _l.label = 2;
                    case 2:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode, additionalHeaders)
                        ];
                    case 3:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 5;
                    case 5:
                        _g = _h;
                        _l.label = 6;
                    case 6:
                        _j = [
                            (0, _tslib.__assign).apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 7:
                        headers = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _k)
                        ]);
                        body = {
                            query: (0, _graphql.print)(query),
                            variables: variables
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? "appsync" : "execute-api",
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, _graphql.GraphQLError)("No graphql endpoint provided.");
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 8;
                    case 8:
                        _l.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 9:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) throw err_1;
                        response = {
                            data: {},
                            errors: [
                                new (0, _graphql.GraphQLError)(err_1.message, null, null, null, null, err_1)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 11:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    InternalGraphQLAPIClass.prototype.createInstanceIfNotCreated = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ InternalGraphQLAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ InternalGraphQLAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ InternalGraphQLAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    InternalGraphQLAPIClass.prototype._graphqlSubscribe = function(_a, additionalHeaders, customUserAgentDetails) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode, authToken = _a.authToken;
        if (additionalHeaders === void 0) additionalHeaders = {};
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
        if ((0, _internals.InternalPubSub) && typeof (0, _internals.InternalPubSub).subscribe === "function") return (0, _internals.InternalPubSub).subscribe("", {
            provider: (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, _graphql.print)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers,
            additionalHeaders: additionalHeaders,
            authToken: authToken
        }, customUserAgentDetails);
        else {
            logger.debug("No pubsub module applied for subscription");
            throw new Error("No pubsub module applied for subscription");
        }
    };
    /**
     * @private
     */ InternalGraphQLAPIClass.prototype._ensureCredentials = function() {
        var _this = this;
        return this.Credentials.get().then(function(credentials) {
            if (!credentials) return false;
            var cred = _this.Credentials.shear(credentials);
            logger.debug("set credentials for api", cred);
            return true;
        }).catch(function(err) {
            logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return InternalGraphQLAPIClass;
}();
var InternalGraphQLAPI = new InternalGraphQLAPIClass(null);
(0, _core.Amplify).register(InternalGraphQLAPI);

},{"tslib":"fPXxt","graphql":"8yODI","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub/internals":"4KMnX","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","../types":"4viCr","@aws-amplify/api-rest":"by3r2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPXxt":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8yODI":[function(require,module,exports) {
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */ // The GraphQL.js version info.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _versionMjs.version)) // The primary entry point into fulfilling a GraphQL request.
;
parcelHelpers.export(exports, "versionInfo", ()=>(0, _versionMjs.versionInfo));
parcelHelpers.export(exports, "graphql", ()=>(0, _graphqlMjs.graphql)) // Create and operate on GraphQL type definitions and schema.
;
parcelHelpers.export(exports, "graphqlSync", ()=>(0, _graphqlMjs.graphqlSync));
parcelHelpers.export(exports, "GraphQLSchema", ()=>(0, _indexMjs.GraphQLSchema));
parcelHelpers.export(exports, "GraphQLDirective", ()=>(0, _indexMjs.GraphQLDirective));
parcelHelpers.export(exports, "GraphQLScalarType", ()=>(0, _indexMjs.GraphQLScalarType));
parcelHelpers.export(exports, "GraphQLObjectType", ()=>(0, _indexMjs.GraphQLObjectType));
parcelHelpers.export(exports, "GraphQLInterfaceType", ()=>(0, _indexMjs.GraphQLInterfaceType));
parcelHelpers.export(exports, "GraphQLUnionType", ()=>(0, _indexMjs.GraphQLUnionType));
parcelHelpers.export(exports, "GraphQLEnumType", ()=>(0, _indexMjs.GraphQLEnumType));
parcelHelpers.export(exports, "GraphQLInputObjectType", ()=>(0, _indexMjs.GraphQLInputObjectType));
parcelHelpers.export(exports, "GraphQLList", ()=>(0, _indexMjs.GraphQLList));
parcelHelpers.export(exports, "GraphQLNonNull", ()=>(0, _indexMjs.GraphQLNonNull));
parcelHelpers.export(exports, "specifiedScalarTypes", ()=>(0, _indexMjs.specifiedScalarTypes));
parcelHelpers.export(exports, "GraphQLInt", ()=>(0, _indexMjs.GraphQLInt));
parcelHelpers.export(exports, "GraphQLFloat", ()=>(0, _indexMjs.GraphQLFloat));
parcelHelpers.export(exports, "GraphQLString", ()=>(0, _indexMjs.GraphQLString));
parcelHelpers.export(exports, "GraphQLBoolean", ()=>(0, _indexMjs.GraphQLBoolean));
parcelHelpers.export(exports, "GraphQLID", ()=>(0, _indexMjs.GraphQLID));
parcelHelpers.export(exports, "specifiedDirectives", ()=>(0, _indexMjs.specifiedDirectives));
parcelHelpers.export(exports, "GraphQLIncludeDirective", ()=>(0, _indexMjs.GraphQLIncludeDirective));
parcelHelpers.export(exports, "GraphQLSkipDirective", ()=>(0, _indexMjs.GraphQLSkipDirective));
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", ()=>(0, _indexMjs.GraphQLDeprecatedDirective));
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", ()=>(0, _indexMjs.GraphQLSpecifiedByDirective));
parcelHelpers.export(exports, "TypeKind", ()=>(0, _indexMjs.TypeKind));
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", ()=>(0, _indexMjs.DEFAULT_DEPRECATION_REASON));
parcelHelpers.export(exports, "introspectionTypes", ()=>(0, _indexMjs.introspectionTypes));
parcelHelpers.export(exports, "__Schema", ()=>(0, _indexMjs.__Schema));
parcelHelpers.export(exports, "__Directive", ()=>(0, _indexMjs.__Directive));
parcelHelpers.export(exports, "__DirectiveLocation", ()=>(0, _indexMjs.__DirectiveLocation));
parcelHelpers.export(exports, "__Type", ()=>(0, _indexMjs.__Type));
parcelHelpers.export(exports, "__Field", ()=>(0, _indexMjs.__Field));
parcelHelpers.export(exports, "__InputValue", ()=>(0, _indexMjs.__InputValue));
parcelHelpers.export(exports, "__EnumValue", ()=>(0, _indexMjs.__EnumValue));
parcelHelpers.export(exports, "__TypeKind", ()=>(0, _indexMjs.__TypeKind));
parcelHelpers.export(exports, "SchemaMetaFieldDef", ()=>(0, _indexMjs.SchemaMetaFieldDef));
parcelHelpers.export(exports, "TypeMetaFieldDef", ()=>(0, _indexMjs.TypeMetaFieldDef));
parcelHelpers.export(exports, "TypeNameMetaFieldDef", ()=>(0, _indexMjs.TypeNameMetaFieldDef));
parcelHelpers.export(exports, "isSchema", ()=>(0, _indexMjs.isSchema));
parcelHelpers.export(exports, "isDirective", ()=>(0, _indexMjs.isDirective));
parcelHelpers.export(exports, "isType", ()=>(0, _indexMjs.isType));
parcelHelpers.export(exports, "isScalarType", ()=>(0, _indexMjs.isScalarType));
parcelHelpers.export(exports, "isObjectType", ()=>(0, _indexMjs.isObjectType));
parcelHelpers.export(exports, "isInterfaceType", ()=>(0, _indexMjs.isInterfaceType));
parcelHelpers.export(exports, "isUnionType", ()=>(0, _indexMjs.isUnionType));
parcelHelpers.export(exports, "isEnumType", ()=>(0, _indexMjs.isEnumType));
parcelHelpers.export(exports, "isInputObjectType", ()=>(0, _indexMjs.isInputObjectType));
parcelHelpers.export(exports, "isListType", ()=>(0, _indexMjs.isListType));
parcelHelpers.export(exports, "isNonNullType", ()=>(0, _indexMjs.isNonNullType));
parcelHelpers.export(exports, "isInputType", ()=>(0, _indexMjs.isInputType));
parcelHelpers.export(exports, "isOutputType", ()=>(0, _indexMjs.isOutputType));
parcelHelpers.export(exports, "isLeafType", ()=>(0, _indexMjs.isLeafType));
parcelHelpers.export(exports, "isCompositeType", ()=>(0, _indexMjs.isCompositeType));
parcelHelpers.export(exports, "isAbstractType", ()=>(0, _indexMjs.isAbstractType));
parcelHelpers.export(exports, "isWrappingType", ()=>(0, _indexMjs.isWrappingType));
parcelHelpers.export(exports, "isNullableType", ()=>(0, _indexMjs.isNullableType));
parcelHelpers.export(exports, "isNamedType", ()=>(0, _indexMjs.isNamedType));
parcelHelpers.export(exports, "isRequiredArgument", ()=>(0, _indexMjs.isRequiredArgument));
parcelHelpers.export(exports, "isRequiredInputField", ()=>(0, _indexMjs.isRequiredInputField));
parcelHelpers.export(exports, "isSpecifiedScalarType", ()=>(0, _indexMjs.isSpecifiedScalarType));
parcelHelpers.export(exports, "isIntrospectionType", ()=>(0, _indexMjs.isIntrospectionType));
parcelHelpers.export(exports, "isSpecifiedDirective", ()=>(0, _indexMjs.isSpecifiedDirective));
parcelHelpers.export(exports, "assertSchema", ()=>(0, _indexMjs.assertSchema));
parcelHelpers.export(exports, "assertDirective", ()=>(0, _indexMjs.assertDirective));
parcelHelpers.export(exports, "assertType", ()=>(0, _indexMjs.assertType));
parcelHelpers.export(exports, "assertScalarType", ()=>(0, _indexMjs.assertScalarType));
parcelHelpers.export(exports, "assertObjectType", ()=>(0, _indexMjs.assertObjectType));
parcelHelpers.export(exports, "assertInterfaceType", ()=>(0, _indexMjs.assertInterfaceType));
parcelHelpers.export(exports, "assertUnionType", ()=>(0, _indexMjs.assertUnionType));
parcelHelpers.export(exports, "assertEnumType", ()=>(0, _indexMjs.assertEnumType));
parcelHelpers.export(exports, "assertInputObjectType", ()=>(0, _indexMjs.assertInputObjectType));
parcelHelpers.export(exports, "assertListType", ()=>(0, _indexMjs.assertListType));
parcelHelpers.export(exports, "assertNonNullType", ()=>(0, _indexMjs.assertNonNullType));
parcelHelpers.export(exports, "assertInputType", ()=>(0, _indexMjs.assertInputType));
parcelHelpers.export(exports, "assertOutputType", ()=>(0, _indexMjs.assertOutputType));
parcelHelpers.export(exports, "assertLeafType", ()=>(0, _indexMjs.assertLeafType));
parcelHelpers.export(exports, "assertCompositeType", ()=>(0, _indexMjs.assertCompositeType));
parcelHelpers.export(exports, "assertAbstractType", ()=>(0, _indexMjs.assertAbstractType));
parcelHelpers.export(exports, "assertWrappingType", ()=>(0, _indexMjs.assertWrappingType));
parcelHelpers.export(exports, "assertNullableType", ()=>(0, _indexMjs.assertNullableType));
parcelHelpers.export(exports, "assertNamedType", ()=>(0, _indexMjs.assertNamedType));
parcelHelpers.export(exports, "getNullableType", ()=>(0, _indexMjs.getNullableType));
parcelHelpers.export(exports, "getNamedType", ()=>(0, _indexMjs.getNamedType));
parcelHelpers.export(exports, "validateSchema", ()=>(0, _indexMjs.validateSchema));
parcelHelpers.export(exports, "assertValidSchema", ()=>(0, _indexMjs.assertValidSchema));
// Parse and operate on GraphQL language source files.
parcelHelpers.export(exports, "Token", ()=>(0, _indexMjs1.Token));
parcelHelpers.export(exports, "Source", ()=>(0, _indexMjs1.Source));
parcelHelpers.export(exports, "Location", ()=>(0, _indexMjs1.Location));
parcelHelpers.export(exports, "getLocation", ()=>(0, _indexMjs1.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _indexMjs1.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _indexMjs1.printSourceLocation));
parcelHelpers.export(exports, "Lexer", ()=>(0, _indexMjs1.Lexer));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _indexMjs1.TokenKind));
parcelHelpers.export(exports, "parse", ()=>(0, _indexMjs1.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _indexMjs1.parseValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _indexMjs1.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _indexMjs1.print));
parcelHelpers.export(exports, "visit", ()=>(0, _indexMjs1.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _indexMjs1.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _indexMjs1.getVisitFn));
parcelHelpers.export(exports, "BREAK", ()=>(0, _indexMjs1.BREAK));
parcelHelpers.export(exports, "Kind", ()=>(0, _indexMjs1.Kind));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _indexMjs1.DirectiveLocation));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _indexMjs1.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _indexMjs1.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _indexMjs1.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _indexMjs1.isValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _indexMjs1.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _indexMjs1.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _indexMjs1.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _indexMjs1.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _indexMjs1.isTypeExtensionNode));
// Execute GraphQL queries.
parcelHelpers.export(exports, "execute", ()=>(0, _indexMjs2.execute));
parcelHelpers.export(exports, "executeSync", ()=>(0, _indexMjs2.executeSync));
parcelHelpers.export(exports, "defaultFieldResolver", ()=>(0, _indexMjs2.defaultFieldResolver));
parcelHelpers.export(exports, "defaultTypeResolver", ()=>(0, _indexMjs2.defaultTypeResolver));
parcelHelpers.export(exports, "responsePathAsArray", ()=>(0, _indexMjs2.responsePathAsArray));
parcelHelpers.export(exports, "getDirectiveValues", ()=>(0, _indexMjs2.getDirectiveValues));
parcelHelpers.export(exports, "subscribe", ()=>(0, _indexMjs3.subscribe));
parcelHelpers.export(exports, "createSourceEventStream", ()=>(0, _indexMjs3.createSourceEventStream));
// Validate GraphQL documents.
parcelHelpers.export(exports, "validate", ()=>(0, _indexMjs4.validate));
parcelHelpers.export(exports, "ValidationContext", ()=>(0, _indexMjs4.ValidationContext));
parcelHelpers.export(exports, "specifiedRules", ()=>(0, _indexMjs4.specifiedRules));
parcelHelpers.export(exports, "ExecutableDefinitionsRule", ()=>(0, _indexMjs4.ExecutableDefinitionsRule));
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", ()=>(0, _indexMjs4.FieldsOnCorrectTypeRule));
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", ()=>(0, _indexMjs4.FragmentsOnCompositeTypesRule));
parcelHelpers.export(exports, "KnownArgumentNamesRule", ()=>(0, _indexMjs4.KnownArgumentNamesRule));
parcelHelpers.export(exports, "KnownDirectivesRule", ()=>(0, _indexMjs4.KnownDirectivesRule));
parcelHelpers.export(exports, "KnownFragmentNamesRule", ()=>(0, _indexMjs4.KnownFragmentNamesRule));
parcelHelpers.export(exports, "KnownTypeNamesRule", ()=>(0, _indexMjs4.KnownTypeNamesRule));
parcelHelpers.export(exports, "LoneAnonymousOperationRule", ()=>(0, _indexMjs4.LoneAnonymousOperationRule));
parcelHelpers.export(exports, "NoFragmentCyclesRule", ()=>(0, _indexMjs4.NoFragmentCyclesRule));
parcelHelpers.export(exports, "NoUndefinedVariablesRule", ()=>(0, _indexMjs4.NoUndefinedVariablesRule));
parcelHelpers.export(exports, "NoUnusedFragmentsRule", ()=>(0, _indexMjs4.NoUnusedFragmentsRule));
parcelHelpers.export(exports, "NoUnusedVariablesRule", ()=>(0, _indexMjs4.NoUnusedVariablesRule));
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", ()=>(0, _indexMjs4.OverlappingFieldsCanBeMergedRule));
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", ()=>(0, _indexMjs4.PossibleFragmentSpreadsRule));
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", ()=>(0, _indexMjs4.ProvidedRequiredArgumentsRule));
parcelHelpers.export(exports, "ScalarLeafsRule", ()=>(0, _indexMjs4.ScalarLeafsRule));
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", ()=>(0, _indexMjs4.SingleFieldSubscriptionsRule));
parcelHelpers.export(exports, "UniqueArgumentNamesRule", ()=>(0, _indexMjs4.UniqueArgumentNamesRule));
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", ()=>(0, _indexMjs4.UniqueDirectivesPerLocationRule));
parcelHelpers.export(exports, "UniqueFragmentNamesRule", ()=>(0, _indexMjs4.UniqueFragmentNamesRule));
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", ()=>(0, _indexMjs4.UniqueInputFieldNamesRule));
parcelHelpers.export(exports, "UniqueOperationNamesRule", ()=>(0, _indexMjs4.UniqueOperationNamesRule));
parcelHelpers.export(exports, "UniqueVariableNamesRule", ()=>(0, _indexMjs4.UniqueVariableNamesRule));
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", ()=>(0, _indexMjs4.ValuesOfCorrectTypeRule));
parcelHelpers.export(exports, "VariablesAreInputTypesRule", ()=>(0, _indexMjs4.VariablesAreInputTypesRule));
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", ()=>(0, _indexMjs4.VariablesInAllowedPositionRule));
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", ()=>(0, _indexMjs4.LoneSchemaDefinitionRule));
parcelHelpers.export(exports, "UniqueOperationTypesRule", ()=>(0, _indexMjs4.UniqueOperationTypesRule));
parcelHelpers.export(exports, "UniqueTypeNamesRule", ()=>(0, _indexMjs4.UniqueTypeNamesRule));
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", ()=>(0, _indexMjs4.UniqueEnumValueNamesRule));
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", ()=>(0, _indexMjs4.UniqueFieldDefinitionNamesRule));
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", ()=>(0, _indexMjs4.UniqueDirectiveNamesRule));
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", ()=>(0, _indexMjs4.PossibleTypeExtensionsRule));
parcelHelpers.export(exports, "NoDeprecatedCustomRule", ()=>(0, _indexMjs4.NoDeprecatedCustomRule));
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", ()=>(0, _indexMjs4.NoSchemaIntrospectionCustomRule));
// Create, format, and print GraphQL errors.
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _indexMjs5.GraphQLError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _indexMjs5.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _indexMjs5.locatedError));
parcelHelpers.export(exports, "printError", ()=>(0, _indexMjs5.printError));
parcelHelpers.export(exports, "formatError", ()=>(0, _indexMjs5.formatError));
// Utilities for operating on GraphQL type schema and parsed sources.
parcelHelpers.export(exports, "getIntrospectionQuery", ()=>(0, _indexMjs6.getIntrospectionQuery));
parcelHelpers.export(exports, "getOperationAST", ()=>(0, _indexMjs6.getOperationAST));
parcelHelpers.export(exports, "getOperationRootType", ()=>(0, _indexMjs6.getOperationRootType));
parcelHelpers.export(exports, "introspectionFromSchema", ()=>(0, _indexMjs6.introspectionFromSchema));
parcelHelpers.export(exports, "buildClientSchema", ()=>(0, _indexMjs6.buildClientSchema));
parcelHelpers.export(exports, "buildASTSchema", ()=>(0, _indexMjs6.buildASTSchema));
parcelHelpers.export(exports, "buildSchema", ()=>(0, _indexMjs6.buildSchema));
parcelHelpers.export(exports, "getDescription", ()=>(0, _indexMjs6.getDescription));
parcelHelpers.export(exports, "extendSchema", ()=>(0, _indexMjs6.extendSchema));
parcelHelpers.export(exports, "lexicographicSortSchema", ()=>(0, _indexMjs6.lexicographicSortSchema));
parcelHelpers.export(exports, "printSchema", ()=>(0, _indexMjs6.printSchema));
parcelHelpers.export(exports, "printType", ()=>(0, _indexMjs6.printType));
parcelHelpers.export(exports, "printIntrospectionSchema", ()=>(0, _indexMjs6.printIntrospectionSchema));
parcelHelpers.export(exports, "typeFromAST", ()=>(0, _indexMjs6.typeFromAST));
parcelHelpers.export(exports, "valueFromAST", ()=>(0, _indexMjs6.valueFromAST));
parcelHelpers.export(exports, "valueFromASTUntyped", ()=>(0, _indexMjs6.valueFromASTUntyped));
parcelHelpers.export(exports, "astFromValue", ()=>(0, _indexMjs6.astFromValue));
parcelHelpers.export(exports, "TypeInfo", ()=>(0, _indexMjs6.TypeInfo));
parcelHelpers.export(exports, "visitWithTypeInfo", ()=>(0, _indexMjs6.visitWithTypeInfo));
parcelHelpers.export(exports, "coerceInputValue", ()=>(0, _indexMjs6.coerceInputValue));
parcelHelpers.export(exports, "concatAST", ()=>(0, _indexMjs6.concatAST));
parcelHelpers.export(exports, "separateOperations", ()=>(0, _indexMjs6.separateOperations));
parcelHelpers.export(exports, "stripIgnoredCharacters", ()=>(0, _indexMjs6.stripIgnoredCharacters));
parcelHelpers.export(exports, "isEqualType", ()=>(0, _indexMjs6.isEqualType));
parcelHelpers.export(exports, "isTypeSubTypeOf", ()=>(0, _indexMjs6.isTypeSubTypeOf));
parcelHelpers.export(exports, "doTypesOverlap", ()=>(0, _indexMjs6.doTypesOverlap));
parcelHelpers.export(exports, "assertValidName", ()=>(0, _indexMjs6.assertValidName));
parcelHelpers.export(exports, "isValidNameError", ()=>(0, _indexMjs6.isValidNameError));
parcelHelpers.export(exports, "BreakingChangeType", ()=>(0, _indexMjs6.BreakingChangeType));
parcelHelpers.export(exports, "DangerousChangeType", ()=>(0, _indexMjs6.DangerousChangeType));
parcelHelpers.export(exports, "findBreakingChanges", ()=>(0, _indexMjs6.findBreakingChanges));
parcelHelpers.export(exports, "findDangerousChanges", ()=>(0, _indexMjs6.findDangerousChanges));
parcelHelpers.export(exports, "findDeprecatedUsages", ()=>(0, _indexMjs6.findDeprecatedUsages));
var _versionMjs = require("./version.mjs");
var _graphqlMjs = require("./graphql.mjs");
var _indexMjs = require("./type/index.mjs");
var _indexMjs1 = require("./language/index.mjs");
var _indexMjs2 = require("./execution/index.mjs");
var _indexMjs3 = require("./subscription/index.mjs");
var _indexMjs4 = require("./validation/index.mjs");
var _indexMjs5 = require("./error/index.mjs");
var _indexMjs6 = require("./utilities/index.mjs");

},{"./version.mjs":false,"./graphql.mjs":false,"./type/index.mjs":false,"./language/index.mjs":"2Doug","./execution/index.mjs":false,"./subscription/index.mjs":false,"./validation/index.mjs":false,"./error/index.mjs":"fonkX","./utilities/index.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Doug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", ()=>(0, _sourceMjs.Source));
parcelHelpers.export(exports, "getLocation", ()=>(0, _locationMjs.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _printLocationMjs.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _printLocationMjs.printSourceLocation));
parcelHelpers.export(exports, "Kind", ()=>(0, _kindsMjs.Kind));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _tokenKindMjs.TokenKind));
parcelHelpers.export(exports, "Lexer", ()=>(0, _lexerMjs.Lexer));
parcelHelpers.export(exports, "parse", ()=>(0, _parserMjs.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _parserMjs.parseValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _parserMjs.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _printerMjs.print));
parcelHelpers.export(exports, "visit", ()=>(0, _visitorMjs.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _visitorMjs.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _visitorMjs.getVisitFn));
parcelHelpers.export(exports, "BREAK", ()=>(0, _visitorMjs.BREAK));
parcelHelpers.export(exports, "Location", ()=>(0, _astMjs.Location));
parcelHelpers.export(exports, "Token", ()=>(0, _astMjs.Token));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _predicatesMjs.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _predicatesMjs.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _predicatesMjs.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _predicatesMjs.isValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _predicatesMjs.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _predicatesMjs.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _predicatesMjs.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _predicatesMjs.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _predicatesMjs.isTypeExtensionNode));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _directiveLocationMjs.DirectiveLocation));
var _sourceMjs = require("./source.mjs");
var _locationMjs = require("./location.mjs");
var _printLocationMjs = require("./printLocation.mjs");
var _kindsMjs = require("./kinds.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _lexerMjs = require("./lexer.mjs");
var _parserMjs = require("./parser.mjs");
var _printerMjs = require("./printer.mjs");
var _visitorMjs = require("./visitor.mjs");
var _astMjs = require("./ast.mjs");
var _predicatesMjs = require("./predicates.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");

},{"./source.mjs":false,"./location.mjs":false,"./printLocation.mjs":false,"./kinds.mjs":false,"./tokenKind.mjs":false,"./lexer.mjs":false,"./parser.mjs":"llVW2","./printer.mjs":"gBwoM","./visitor.mjs":false,"./ast.mjs":false,"./predicates.mjs":false,"./directiveLocation.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kcvwO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", ()=>Source);
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ // eslint-disable-next-line no-redeclare
parcelHelpers.export(exports, "isSource", ()=>isSource);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _devAssertMjsDefault = parcelHelpers.interopDefault(_devAssertMjs);
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
var _instanceOfMjsDefault = parcelHelpers.interopDefault(_instanceOfMjs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Source = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, _devAssertMjsDefault.default)(0, "Body must be a string. Received: ".concat((0, _inspectMjsDefault.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, _devAssertMjsDefault.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, _devAssertMjsDefault.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    _createClass(Source, [
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function isSource(source) {
    return (0, _instanceOfMjsDefault.default)(source, Source);
}

},{"../polyfills/symbols.mjs":"5WItw","../jsutils/inspect.mjs":"jMHVl","../jsutils/devAssert.mjs":"2MP4B","../jsutils/instanceOf.mjs":"axvoQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5WItw":[function(require,module,exports) {
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SYMBOL_ITERATOR", ()=>SYMBOL_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_ASYNC_ITERATOR", ()=>SYMBOL_ASYNC_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_TO_STRING_TAG", ()=>SYMBOL_TO_STRING_TAG);
var SYMBOL_ITERATOR = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_TO_STRING_TAG = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jMHVl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>inspect);
/* eslint-disable flowtype/no-weak-types */ var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
    return formatValue(value, []);
}
function formatValue(value, seenValues) {
    switch(_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return formatArray(value, seenValues);
    return formatObject(value, seenValues);
}
function formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[" + getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min(MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push(formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function getCustomFn(object) {
    var customInspectFn = object[String((0, _nodejsCustomInspectSymbolMjsDefault.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

},{"./nodejsCustomInspectSymbol.mjs":"a9rIu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a9rIu":[function(require,module,exports) {
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
exports.default = nodejsCustomInspectSymbol;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2MP4B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>devAssert);
function devAssert(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"axvoQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _inspectMjs = require("./inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
exports.default = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

},{"./inspect.mjs":"jMHVl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNJxY":[function(require,module,exports) {
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
function getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iG11e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printLocation", ()=>printLocation);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printSourceLocation", ()=>printSourceLocation);
var _locationMjs = require("./location.mjs");
function printLocation(location) {
    return printSourceLocation(location.source, (0, _locationMjs.getLocation)(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function whitespace(len) {
    return Array(len + 1).join(" ");
}
function leftPad(len, str) {
    return whitespace(len - str.length) + str;
}

},{"./location.mjs":"jNJxY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"itNp4":[function(require,module,exports) {
/**
 * The set of allowed kind values for AST nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Kind", ()=>Kind);
var Kind = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"en6Ez":[function(require,module,exports) {
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenKind", ()=>TokenKind);
var TokenKind = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kACVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lexer", ()=>Lexer);
/**
 * @internal
 */ parcelHelpers.export(exports, "isPunctuatorTokenKind", ()=>isPunctuatorTokenKind);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _blockStringMjs = require("./blockString.mjs");
var Lexer = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, _tokenKindMjs.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
        }while (token.kind === (0, _tokenKindMjs.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function isPunctuatorTokenKind(kind) {
    return kind === (0, _tokenKindMjs.TokenKind).BANG || kind === (0, _tokenKindMjs.TokenKind).DOLLAR || kind === (0, _tokenKindMjs.TokenKind).AMP || kind === (0, _tokenKindMjs.TokenKind).PAREN_L || kind === (0, _tokenKindMjs.TokenKind).PAREN_R || kind === (0, _tokenKindMjs.TokenKind).SPREAD || kind === (0, _tokenKindMjs.TokenKind).COLON || kind === (0, _tokenKindMjs.TokenKind).EQUALS || kind === (0, _tokenKindMjs.TokenKind).AT || kind === (0, _tokenKindMjs.TokenKind).BRACKET_L || kind === (0, _tokenKindMjs.TokenKind).BRACKET_R || kind === (0, _tokenKindMjs.TokenKind).BRACE_L || kind === (0, _tokenKindMjs.TokenKind).PIPE || kind === (0, _tokenKindMjs.TokenKind).BRACE_R;
}
function printCharCode(code) {
    return isNaN(code) ? (0, _tokenKindMjs.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return readBlockString(source, pos, _line, _col, prev, lexer);
                return readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return readName(source, pos, _line, _col, prev);
        }
        throw (0, _syntaxErrorMjs.syntaxError)(source, pos, unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    } else {
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || isNameStart(code)) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
    return new (0, _astMjs.Token)(isFloat ? (0, _tokenKindMjs.TokenKind).FLOAT : (0, _tokenKindMjs.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringMjs.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function uniCharCode(a, b, c, d) {
    return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

},{"../error/syntaxError.mjs":"2uCrZ","./ast.mjs":"d5f6y","./tokenKind.mjs":"en6Ez","./blockString.mjs":"hKkLC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2uCrZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ parcelHelpers.export(exports, "syntaxError", ()=>syntaxError);
var _graphQLErrorMjs = require("./GraphQLError.mjs");
function syntaxError(source, position, description) {
    return new (0, _graphQLErrorMjs.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

},{"./GraphQLError.mjs":"7wumG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7wumG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>GraphQLError);
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ parcelHelpers.export(exports, "printError", ()=>printError);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _locationMjs = require("../language/location.mjs");
var _printLocationMjs = require("../language/printLocation.mjs");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var GraphQLError = /*#__PURE__*/ function(_Error) {
    _inherits(GraphQLError, _Error);
    var _super = _createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        _classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, _locationMjs.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, _locationMjs.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, _isObjectLikeMjsDefault.default)(originalExtensions)) _this.extensions = _objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties(_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty(_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return _possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty(_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    _createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return printError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, _printLocationMjs.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, _printLocationMjs.printSourceLocation)(error.source, location);
    }
    return output;
}

},{"../jsutils/isObjectLike.mjs":"6nhkr","../polyfills/symbols.mjs":"5WItw","../language/location.mjs":"jNJxY","../language/printLocation.mjs":"iG11e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6nhkr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObjectLike);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isObjectLike(value) {
    return _typeof(value) == "object" && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d5f6y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Location", ()=>Location);
parcelHelpers.export(exports, "Token", ()=>Token);
/**
 * @internal
 */ parcelHelpers.export(exports, "isNode", ()=>isNode) /**
 * The list of all possible AST node types.
 */ ;
var _defineInspectMjs = require("../jsutils/defineInspect.mjs");
var _defineInspectMjsDefault = parcelHelpers.interopDefault(_defineInspectMjs);
var Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Location);
var Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, _defineInspectMjsDefault.default)(Token);
function isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
}

},{"../jsutils/defineInspect.mjs":"kB2jj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kB2jj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defineInspect);
var _invariantMjs = require("./invariant.mjs");
var _invariantMjsDefault = parcelHelpers.interopDefault(_invariantMjs);
var _nodejsCustomInspectSymbolMjs = require("./nodejsCustomInspectSymbol.mjs");
var _nodejsCustomInspectSymbolMjsDefault = parcelHelpers.interopDefault(_nodejsCustomInspectSymbolMjs);
function defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, _invariantMjsDefault.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, _nodejsCustomInspectSymbolMjsDefault.default) classObject.prototype[0, _nodejsCustomInspectSymbolMjsDefault.default] = fn;
}

},{"./invariant.mjs":"7gLZA","./nodejsCustomInspectSymbol.mjs":"a9rIu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gLZA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
function invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKkLC":[function(require,module,exports) {
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dedentBlockStringValue", ()=>dedentBlockStringValue);
/**
 * @internal
 */ parcelHelpers.export(exports, "getBlockStringIndentation", ()=>getBlockStringIndentation);
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ parcelHelpers.export(exports, "printBlockString", ()=>printBlockString);
function dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"llVW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Configuration options to control parser behavior
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ parcelHelpers.export(exports, "parseValue", ()=>parseValue);
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ parcelHelpers.export(exports, "parseType", ()=>parseType);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _kindsMjs = require("./kinds.mjs");
var _astMjs = require("./ast.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _sourceMjs = require("./source.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");
var _lexerMjs = require("./lexer.mjs");
function parse(source, options) {
    var parser = new Parser(source, options);
    return parser.parseDocument();
}
function parseValue(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return value;
}
function parseType(source, options) {
    var parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return type;
}
var Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, _sourceMjs.isSource)(source) ? source : new (0, _sourceMjs.Source)(source);
        this._lexer = new (0, _lexerMjs.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        return {
            kind: (0, _kindsMjs.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).DOCUMENT,
            definitions: this.many((0, _tokenKindMjs.TokenKind).SOF, this.parseDefinition, (0, _tokenKindMjs.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseVariableDefinition, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).DOLLAR);
        return {
            kind: (0, _kindsMjs.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).SELECTION_SET,
            selections: this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseSelection, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, _tokenKindMjs.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, _kindsMjs.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, item, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, _tokenKindMjs.TokenKind).NAME)) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, _tokenKindMjs.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, _tokenKindMjs.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, _tokenKindMjs.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, _kindsMjs.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, _tokenKindMjs.TokenKind).STRING:
            case (0, _tokenKindMjs.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, _tokenKindMjs.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, _kindsMjs.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, _kindsMjs.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, _tokenKindMjs.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, _kindsMjs.Kind).STRING,
            value: token.value,
            block: token.kind === (0, _tokenKindMjs.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).LIST,
            values: this.any((0, _tokenKindMjs.TokenKind).BRACKET_L, item, (0, _tokenKindMjs.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, _kindsMjs.Kind).OBJECT,
            fields: this.any((0, _tokenKindMjs.TokenKind).BRACE_L, item, (0, _tokenKindMjs.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, _tokenKindMjs.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, _tokenKindMjs.TokenKind).BRACKET_R);
            type = {
                kind: (0, _kindsMjs.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BANG)) return {
            kind: (0, _kindsMjs.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, _kindsMjs.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, _tokenKindMjs.TokenKind).STRING) || this.peek((0, _tokenKindMjs.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, _kindsMjs.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).AMP) || this.peek((0, _tokenKindMjs.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, _tokenKindMjs.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseFieldDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, _kindsMjs.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, _directiveLocationMjs.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, _astMjs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat(getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function getTokenDesc(token) {
    var value = token.value;
    return getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function getTokenKindDesc(kind) {
    return (0, _lexerMjs.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

},{"../error/syntaxError.mjs":"2uCrZ","./kinds.mjs":"itNp4","./ast.mjs":"d5f6y","./tokenKind.mjs":"en6Ez","./source.mjs":"kcvwO","./directiveLocation.mjs":"7Onsy","./lexer.mjs":"kACVA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Onsy":[function(require,module,exports) {
/**
 * The set of allowed directive location values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectiveLocation", ()=>DirectiveLocation);
var DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gBwoM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ parcelHelpers.export(exports, "print", ()=>print);
var _visitorMjs = require("./visitor.mjs");
var _blockStringMjs = require("./blockString.mjs");
function print(ast) {
    return (0, _visitorMjs.visit)(ast, {
        leave: printDocASTReducer
    });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
        var directives = join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : join([
            op,
            join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = wrap("", alias, ": ") + name;
        var argsLine = prefix + wrap("(", join(args, ", "), ")");
        if (argsLine.length > MAX_LINE_LENGTH) argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
        return join([
            argsLine,
            join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + wrap(" ", join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return join([
            "...",
            wrap("on ", typeCondition),
            join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat(wrap("(", join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat(wrap("", join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, _blockStringMjs.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + wrap("(", join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return join([
            "schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return join([
            "scalar",
            name,
            join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return join([
            "type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    FieldDefinition: addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "));
    }),
    InputValueDefinition: addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return join([
            name + ": " + type,
            wrap("= ", defaultValue),
            join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return join([
            "interface",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    UnionTypeDefinition: addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return join([
            "union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return join([
            "enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    }),
    EnumValueDefinition: addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return join([
            name,
            join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return join([
            "input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    DirectiveDefinition: addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return join([
            "extend schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return join([
            "extend scalar",
            name,
            join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return join([
            "extend type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return join([
            "extend interface",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return join([
            "extend union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return join([
            "extend enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return join([
            "extend input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }
};
function addDescription(cb) {
    return function(node) {
        return join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function block(array) {
    return wrap("{\n", indent(join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
    return wrap("  ", str.replace(/\n/g, "\n  "));
}
function isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some(isMultiline);
}

},{"./visitor.mjs":"7afYb","./blockString.mjs":"hKkLC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7afYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryDocumentKeys", ()=>QueryDocumentKeys);
parcelHelpers.export(exports, "BREAK", ()=>BREAK);
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ parcelHelpers.export(exports, "visit", ()=>visit);
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ parcelHelpers.export(exports, "visitInParallel", ()=>visitInParallel);
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ parcelHelpers.export(exports, "getVisitFn", ()=>getVisitFn);
var _inspectMjs = require("../jsutils/inspect.mjs");
var _inspectMjsDefault = parcelHelpers.interopDefault(_inspectMjs);
var _astMjs = require("./ast.mjs");
var QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var BREAK = Object.freeze({});
function visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, _astMjs.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, _inspectMjsDefault.default)(node), "."));
            var visitFn = getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, _astMjs.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === BREAK) skipping[i] = BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === BREAK) skipping[i] = BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

},{"../jsutils/inspect.mjs":"jMHVl","./ast.mjs":"d5f6y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fonkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _graphQLErrorMjs.GraphQLError));
parcelHelpers.export(exports, "printError", ()=>(0, _graphQLErrorMjs.printError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _syntaxErrorMjs.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _locatedErrorMjs.locatedError));
parcelHelpers.export(exports, "formatError", ()=>(0, _formatErrorMjs.formatError));
var _graphQLErrorMjs = require("./GraphQLError.mjs");
var _syntaxErrorMjs = require("./syntaxError.mjs");
var _locatedErrorMjs = require("./locatedError.mjs");
var _formatErrorMjs = require("./formatError.mjs");

},{"./GraphQLError.mjs":"7wumG","./syntaxError.mjs":false,"./locatedError.mjs":false,"./formatError.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KMnX":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSub", ()=>(0, _internalPubSub.InternalPubSub));
parcelHelpers.export(exports, "InternalPubSubClass", ()=>(0, _internalPubSub.InternalPubSubClass));
var _internalPubSub = require("./InternalPubSub");

},{"./InternalPubSub":"6yQcq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6yQcq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalPubSubClass", ()=>InternalPubSubClass);
parcelHelpers.export(exports, "InternalPubSub", ()=>InternalPubSub);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _providers = require("../Providers");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)("PubSub");
var InternalPubSubClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function InternalPubSubClass(options) {
        this._options = options !== null && options !== void 0 ? options : {};
        logger.debug("PubSub Options", this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(InternalPubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, _providers.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    InternalPubSubClass.prototype.getModuleName = function() {
        return "InternalPubSub";
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ InternalPubSubClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        logger.debug("configure PubSub", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ InternalPubSubClass.prototype.addPluggable = function(pluggable) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var config;
            return (0, _tslib.__generator)(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "PubSub") {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * remove plugin from PubSub category
     * @param providerName - the name of the plugin
     */ InternalPubSubClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
    };
    InternalPubSubClass.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, _core.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    InternalPubSubClass.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + String(providerName));
        return [
            provider
        ];
    };
    InternalPubSubClass.prototype.publish = function(topics, msg, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    InternalPubSubClass.prototype.subscribe = function(topics, options, customUserAgentDetails) {
        if (isNode && this._options && this._options.ssr) throw new Error("Subscriptions are not supported for Server-Side Rendering (SSR)");
        logger.debug("subscribe options", options);
        var providers = this.getProviders(options);
        var pubSubUserAgentDetails = (0, _tslib.__assign)({
            category: (0, _core.Category).PubSub,
            action: (0, _core.PubSubAction).Subscribe
        }, customUserAgentDetails);
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options, pubSubUserAgentDetails)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return InternalPubSubClass;
}();
var InternalPubSub = new InternalPubSubClass();
(0, _core.Amplify).register(InternalPubSub);

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","../Providers":"5uOZ2","zen-observable-ts":"57mma","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cUWSL":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5uOZ2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>(0, _pubSubProvider.AbstractPubSubProvider));
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>(0, _awsappSyncRealTimeProvider.AWSAppSyncRealTimeProvider));
parcelHelpers.export(exports, "AWSIoTProvider", ()=>(0, _awsiotProvider.AWSIoTProvider));
parcelHelpers.export(exports, "MqttOverWSProvider", ()=>(0, _mqttOverWSProvider.MqttOverWSProvider));
parcelHelpers.export(exports, "mqttTopicMatch", ()=>(0, _mqttOverWSProvider.mqttTopicMatch));
var _pubSubProvider = require("./PubSubProvider");
var _awsappSyncRealTimeProvider = require("./AWSAppSyncRealTimeProvider");
var _awsiotProvider = require("./AWSIotProvider");
var _mqttOverWSProvider = require("./MqttOverWSProvider");

},{"./PubSubProvider":false,"./AWSAppSyncRealTimeProvider":"dF0zQ","./AWSIotProvider":false,"./MqttOverWSProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNpQm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>AbstractPubSubProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("AbstractPubSubProvider");
var AbstractPubSubProvider = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, config), this._config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dF0zQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>AWSAppSyncRealTimeProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _graphql = require("graphql");
var _url = require("url");
var _uuid = require("uuid");
var _buffer = require("buffer");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _auth = require("@aws-amplify/auth");
var _pubSubProvider = require("../PubSubProvider");
var _pubSub = require("../../types/PubSub");
var _constants = require("../constants");
var _connectionStateMonitor = require("../../utils/ConnectionStateMonitor");
var _reconnectionMonitor = require("../../utils/ReconnectionMonitor");
var logger = new (0, _core.Logger)("AWSAppSyncRealTimeProvider");
var dispatchApiEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("api", {
        event: event,
        data: data,
        message: message
    }, "PubSub", (0, _constants.AMPLIFY_SYMBOL));
};
var standardDomainPattern = /^https:\/\/\w{26}\.appsync\-api\.\w{2}(?:(?:\-\w{2,})+)\-\d\.amazonaws.com(?:\.cn)?\/graphql$/i;
var customDomainPath = "/realtime";
var AWSAppSyncRealTimeProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        _this.keepAliveTimeout = (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT);
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        _this.connectionStateMonitor = new (0, _connectionStateMonitor.ConnectionStateMonitor)();
        _this.reconnectionMonitor = new (0, _reconnectionMonitor.ReconnectionMonitor)();
        // Monitor the connection state and pass changes along to Hub
        _this.connectionStateMonitorSubscription = _this.connectionStateMonitor.connectionStateObservable.subscribe(function(connectionState) {
            dispatchApiEvent((0, _constants.CONNECTION_STATE_CHANGE), {
                provider: _this,
                connectionState: connectionState
            }, "Connection state is " + connectionState);
            _this.connectionState = connectionState;
            // Trigger START_RECONNECT when the connection is disrupted
            if (connectionState === (0, _pubSub.ConnectionState).ConnectionDisrupted) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).START_RECONNECT);
            // Trigger HALT_RECONNECT to halt reconnection attempts when the state is anything other than
            //   ConnectionDisrupted or Connecting
            if ([
                (0, _pubSub.ConnectionState).Connected,
                (0, _pubSub.ConnectionState).ConnectedPendingDisconnect,
                (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive,
                (0, _pubSub.ConnectionState).ConnectedPendingNetwork,
                (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork,
                (0, _pubSub.ConnectionState).Disconnected
            ].includes(connectionState)) _this.reconnectionMonitor.record((0, _reconnectionMonitor.ReconnectEvent).HALT_RECONNECT);
        });
        return _this;
    }
    /**
     * Mark the socket closed and release all active listeners
     */ AWSAppSyncRealTimeProvider.prototype.close = function() {
        // Mark the socket closed both in status and the connection monitor
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
        // Turn off the subscription monitor Hub publishing
        this.connectionStateMonitorSubscription.unsubscribe();
        // Complete all reconnect observers
        this.reconnectionMonitor.close();
    };
    AWSAppSyncRealTimeProvider.prototype.getNewWebSocket = function(url, protocol) {
        return new WebSocket(url, protocol);
    };
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    // Check if url matches standard domain pattern
    AWSAppSyncRealTimeProvider.prototype.isCustomDomain = function(url) {
        return url.match(standardDomainPattern) === null;
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options, customUserAgentDetails) {
        var _this = this;
        var appSyncGraphqlEndpoint = options === null || options === void 0 ? void 0 : options.appSyncGraphqlEndpoint;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            if (!options || !appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionStartActive_1 = false;
                var subscriptionId_1 = (0, _uuid.v4)();
                var startSubscription_1 = function() {
                    if (!subscriptionStartActive_1) {
                        subscriptionStartActive_1 = true;
                        var startSubscriptionPromise = _this._startSubscriptionWithAWSAppSyncRealTime({
                            options: options,
                            observer: observer,
                            subscriptionId: subscriptionId_1,
                            customUserAgentDetails: customUserAgentDetails
                        }).catch(function(err) {
                            logger.debug((0, _pubSub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err);
                            _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
                        });
                        startSubscriptionPromise.finally(function() {
                            subscriptionStartActive_1 = false;
                        });
                    }
                };
                var reconnectSubscription_1;
                // Add an observable to the reconnection list to manage reconnection for this subscription
                reconnectSubscription_1 = new (0, _zenObservableTsDefault.default)(function(observer) {
                    _this.reconnectionMonitor.addObserver(observer);
                }).subscribe(function() {
                    startSubscription_1();
                });
                startSubscription_1();
                return function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    // Cleanup reconnection subscription
                                    reconnectSubscription_1 === null || reconnectSubscription_1 === void 0 || reconnectSubscription_1.unsubscribe();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        3,
                                        4,
                                        5
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 2:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error("Subscription never connected");
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 3:
                                    err_1 = _a.sent();
                                    logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options["aws_appsync_dangerously_connect_to_http_endpoint_for_testing"];
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId, customUserAgentDetails = _a.customUserAgentDetails;
        var _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _c, graphql_headers, _d, additionalHeaders, subscriptionState, data, dataString, headerObj, _e, _f, subscriptionMessage, stringToAWSRealTime, err_2, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _c = options.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, _d = options.additionalHeaders, additionalHeaders = _d === void 0 ? {} : _d;
                        subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: undefined
                        });
                        dataString = JSON.stringify(data);
                        _e = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 1:
                        _f = [
                            (0, _tslib.__assign).apply(void 0, _e.concat([
                                _j.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = (0, _tslib.__assign).apply(void 0, [
                            (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _f.concat([
                                    _j.sent()
                                ])),
                                additionalHeaders
                            ]),
                            (_h = {}, _h[0, _core.USER_AGENT_HEADER] = (0, _core.getAmplifyUserAgent)(customUserAgentDetails), _h)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: (0, _tslib.__assign)({}, headerObj)
                                }
                            },
                            type: (0, _constants.MESSAGE_TYPES).GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).OPENING_CONNECTION);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 4:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _j.sent();
                        this._logStartSubscriptionError(subscriptionId, observer, err_2);
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _g = (_b = this.subscriptionObserverMap.get(subscriptionId)) !== null && _b !== void 0 ? _b : {}, subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            query: query !== null && query !== void 0 ? query : "",
                            variables: variables !== null && variables !== void 0 ? variables : {},
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, (0, _constants.START_ACK_TIMEOUT))
                        });
                        if (this.awsRealTimeSocket) this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Log logic for start subscription failures
    AWSAppSyncRealTimeProvider.prototype._logStartSubscriptionError = function(subscriptionId, observer, err) {
        var _a;
        logger.debug({
            err: err
        });
        var message = String((_a = err.message) !== null && _a !== void 0 ? _a : "");
        // Resolving to give the state observer time to propogate the update
        Promise.resolve(this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED));
        // Capture the error only when the network didn't cause disruption
        if (this.connectionState !== (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork) {
            // When the error is non-retriable, error out the observable
            if ((0, _core.isNonRetryableError)(err)) observer.error({
                errors: [
                    (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message))
                ]
            });
            else logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + message);
            var subscriptionFailedCallback = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
            // Notify concurrent unsubscription
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var subscriptionObserver, subscriptionState;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
                if (subscriptionObserver) {
                    subscriptionState = subscriptionObserver.subscriptionState;
                    // This in case unsubscribe is invoked before sending start subscription message
                    if (subscriptionState === (0, _constants.SUBSCRIPTION_STATUS).PENDING) return [
                        2 /*return*/ ,
                        new Promise(function(res, rej) {
                            var observer = subscriptionObserver.observer, subscriptionState = subscriptionObserver.subscriptionState, variables = subscriptionObserver.variables, query = subscriptionObserver.query;
                            _this.subscriptionObserverMap.set(subscriptionId, {
                                observer: observer,
                                subscriptionState: subscriptionState,
                                variables: variables,
                                query: query,
                                subscriptionReadyCallback: res,
                                subscriptionFailedCallback: rej
                            });
                        })
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === (0, _constants.SOCKET_STATUS).READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: (0, _constants.MESSAGE_TYPES).GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            return;
        }
        this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSING_CONNECTION);
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            logger.debug("closing WebSocket...");
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = null;
            tempSocket.onerror = null;
            tempSocket.close(1000);
            this.awsRealTimeSocket = undefined;
            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        var _this = this;
        if (typeof message.data !== "string") return;
        logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(String(message.data)), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === (0, _constants.MESSAGE_TYPES).GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_START_ACK) {
            logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
            dispatchApiEvent((0, _pubSub.CONTROL_MSG).SUBSCRIPTION_ACK, {
                query: query,
                variables: variables
            }, "Connection established for subscription");
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).CONNECTED;
            if (observer) this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: undefined,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_ESTABLISHED);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_KEEP_ALIVE) {
            if (this.keepAliveTimeoutId) clearTimeout(this.keepAliveTimeoutId);
            if (this.keepAliveAlertTimeoutId) clearTimeout(this.keepAliveAlertTimeoutId);
            this.keepAliveTimeoutId = setTimeout(function() {
                return _this._errorDisconnect((0, _pubSub.CONTROL_MSG).TIMEOUT_DISCONNECT);
            }, this.keepAliveTimeout);
            this.keepAliveAlertTimeoutId = setTimeout(function() {
                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE_MISSED);
            }, (0, _constants.DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT));
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).KEEP_ALIVE);
            return;
        }
        if (type === (0, _constants.MESSAGE_TYPES).GQL_ERROR) {
            var subscriptionState = (0, _constants.SUBSCRIPTION_STATUS).FAILED;
            if (observer) {
                this.subscriptionObserverMap.set(id, {
                    observer: observer,
                    query: query,
                    variables: variables,
                    startAckTimeoutId: startAckTimeoutId,
                    subscriptionReadyCallback: subscriptionReadyCallback,
                    subscriptionFailedCallback: subscriptionFailedCallback,
                    subscriptionState: subscriptionState
                });
                logger.debug((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload));
                observer.error({
                    errors: [
                        (0, _tslib.__assign)({}, new (0, _graphql.GraphQLError)((0, _pubSub.CONTROL_MSG).CONNECTION_FAILED + ": " + JSON.stringify(payload)))
                    ]
                });
                if (startAckTimeoutId) clearTimeout(startAckTimeoutId);
                if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
            }
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        logger.debug("Disconnect error: " + msg);
        if (this.awsRealTimeSocket) {
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var subscriptionObserver = this.subscriptionObserverMap.get(subscriptionId);
        if (subscriptionObserver) {
            var observer = subscriptionObserver.observer, query = subscriptionObserver.query, variables = subscriptionObserver.variables;
            if (!observer) return;
            this.subscriptionObserverMap.set(subscriptionId, {
                observer: observer,
                query: query,
                variables: variables,
                subscriptionState: (0, _constants.SUBSCRIPTION_STATUS).FAILED
            });
            this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CLOSED);
            logger.debug("timeoutStartSubscription", JSON.stringify({
                query: query,
                variables: variables
            }));
        }
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        if (this.socketStatus === (0, _constants.SOCKET_STATUS).READY) return;
        return new Promise(function(res, rej) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var payloadString, authHeader, headerString, headerQs, payloadQs, discoverableEndpoint, protocol, awsRealTimeUrl, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === (0, _constants.SOCKET_STATUS).CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CONNECTING;
                            payloadString = "{}";
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region,
                                    additionalHeaders: additionalHeaders
                                })
                            ];
                        case 2:
                            authHeader = _a.sent();
                            headerString = authHeader ? JSON.stringify(authHeader) : "";
                            headerQs = (0, _buffer.Buffer).from(headerString).toString("base64");
                            payloadQs = (0, _buffer.Buffer).from(payloadString).toString("base64");
                            discoverableEndpoint = appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "";
                            if (this.isCustomDomain(discoverableEndpoint)) discoverableEndpoint = discoverableEndpoint.concat(customDomainPath);
                            else discoverableEndpoint = discoverableEndpoint.replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                            protocol = this.isSSLEnabled ? "wss://" : "ws://";
                            discoverableEndpoint = discoverableEndpoint.replace("https://", protocol).replace("http://", protocol);
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake(awsRealTimeUrl)
                            ];
                        case 3:
                            _a.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                logger.debug("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = (0, _constants.SOCKET_STATUS).READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.debug("Connection exited with", err_3);
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = undefined;
                            this.socketStatus = (0, _constants.SOCKET_STATUS).CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(awsRealTimeUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                awsRealTimeUrl
                            ], (0, _constants.MAX_DELAY_MS))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(awsRealTimeUrl) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var err_4, _a, errorType, errorCode;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = _this.getNewWebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    if (_this.awsRealTimeSocket) {
                                        var ackOk_1 = false;
                                        _this.awsRealTimeSocket.onerror = function(error) {
                                            logger.debug("WebSocket error " + JSON.stringify(error));
                                        };
                                        _this.awsRealTimeSocket.onclose = function(event) {
                                            logger.debug("WebSocket closed " + event.reason);
                                            rej(new Error(JSON.stringify(event)));
                                        };
                                        _this.awsRealTimeSocket.onmessage = function(message) {
                                            if (typeof message.data !== "string") return;
                                            logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                            var data = JSON.parse(message.data);
                                            var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? (0, _constants.DEFAULT_KEEP_ALIVE_TIMEOUT) : _b;
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ACK) {
                                                ackOk_1 = true;
                                                if (_this.awsRealTimeSocket) {
                                                    _this.keepAliveTimeout = connectionTimeoutMs;
                                                    _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                                    _this.awsRealTimeSocket.onerror = function(err) {
                                                        logger.debug(err);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                    _this.awsRealTimeSocket.onclose = function(event) {
                                                        logger.debug("WebSocket closed " + event.reason);
                                                        _this._errorDisconnect((0, _pubSub.CONTROL_MSG).CONNECTION_CLOSED);
                                                    };
                                                }
                                                res("Cool, connected to AWS AppSyncRealTime");
                                                return;
                                            }
                                            if (type === (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_ERROR) {
                                                var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (0, _tslib.__read)(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? "" : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                                rej({
                                                    errorType: errorType,
                                                    errorCode: errorCode
                                                });
                                            }
                                        };
                                        var gqlInit = {
                                            type: (0, _constants.MESSAGE_TYPES).GQL_CONNECTION_INIT
                                        };
                                        _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                        var checkAckOk_1 = function(ackOk) {
                                            if (!ackOk) {
                                                _this.connectionStateMonitor.record((0, _connectionStateMonitor.CONNECTION_CHANGE).CONNECTION_FAILED);
                                                rej(new Error("Connection timeout: ack from AWSAppSyncRealTime was not received after " + (0, _constants.CONNECTION_INIT_TIMEOUT) + " ms"));
                                            }
                                        };
                                        setTimeout(function() {
                                            return checkAckOk_1(ackOk_1);
                                        }, (0, _constants.CONNECTION_INIT_TIMEOUT));
                                    }
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        _a = err_4, errorType = _a.errorType, errorCode = _a.errorCode;
                        if ((0, _constants.NON_RETRYABLE_CODES).includes(errorCode)) throw new (0, _core.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region, additionalHeaders = _a.additionalHeaders;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                            AWS_LAMBDA: this._customAuthHeader
                        };
                        if (!(!authenticationType || !headerHandler[authenticationType])) return [
                            3 /*break*/ ,
                            1
                        ];
                        logger.debug("Authentication type " + authenticationType + " not supported");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 1:
                        handler = headerHandler[authenticationType];
                        host = _url.parse(appSyncGraphqlEndpoint !== null && appSyncGraphqlEndpoint !== void 0 ? appSyncGraphqlEndpoint : "").host;
                        logger.debug("Authenticating with " + authenticationType);
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                                additionalHeaders: additionalHeaders
                            })
                        ];
                    case 2:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var session;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var token, federatedInfo, currentUser;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _cache.Cache).getItem("federatedInfo")
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = federatedInfo.token;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, _auth.Auth).currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) token = currentUser.token;
                        _b.label = 4;
                    case 4:
                        if (!token) throw new Error("No federated jwt");
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var dt, dtStr;
            return (0, _tslib.__generator)(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: "appsync"
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get().then(function(credentials) {
                                var _a = credentials, secretAccessKey = _a.secretAccessKey, accessKeyId = _a.accessKeyId, sessionToken = _a.sessionToken;
                                return {
                                    secret_key: secretAccessKey,
                                    access_key: accessKeyId,
                                    session_token: sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: "POST",
                            headers: (0, _tslib.__assign)({}, (0, _constants.AWS_APPSYNC_REALTIME_HEADERS))
                        };
                        signed_params = (0, _core.Signer).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._customAuthHeader = function(_a) {
        var host = _a.host, additionalHeaders = _a.additionalHeaders;
        if (!additionalHeaders || !additionalHeaders["Authorization"]) throw new Error("No auth token specified");
        return {
            Authorization: additionalHeaders.Authorization,
            host: host
        };
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, _core.Credentials).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, _core.Credentials).shear(credentials);
            logger.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
            return true;
        }).catch(function(err) {
            logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, _pubSubProvider.AbstractPubSubProvider));

},{"tslib":"cUWSL","zen-observable-ts":"57mma","graphql":"2LAlU","url":"7NJu4","uuid":"kDvHV","buffer":"uEI7y","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@aws-amplify/auth":"ilv20","../PubSubProvider":"hNpQm","../../types/PubSub":"dTFhH","../constants":"dleHk","../../utils/ConnectionStateMonitor":"04hIN","../../utils/ReconnectionMonitor":"ikPBr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LAlU":[function(require,module,exports) {
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */ // The GraphQL.js version info.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _versionMjs.version)) // The primary entry point into fulfilling a GraphQL request.
;
parcelHelpers.export(exports, "versionInfo", ()=>(0, _versionMjs.versionInfo));
parcelHelpers.export(exports, "graphql", ()=>(0, _graphqlMjs.graphql)) // Create and operate on GraphQL type definitions and schema.
;
parcelHelpers.export(exports, "graphqlSync", ()=>(0, _graphqlMjs.graphqlSync));
parcelHelpers.export(exports, "GraphQLSchema", ()=>(0, _indexMjs.GraphQLSchema));
parcelHelpers.export(exports, "GraphQLDirective", ()=>(0, _indexMjs.GraphQLDirective));
parcelHelpers.export(exports, "GraphQLScalarType", ()=>(0, _indexMjs.GraphQLScalarType));
parcelHelpers.export(exports, "GraphQLObjectType", ()=>(0, _indexMjs.GraphQLObjectType));
parcelHelpers.export(exports, "GraphQLInterfaceType", ()=>(0, _indexMjs.GraphQLInterfaceType));
parcelHelpers.export(exports, "GraphQLUnionType", ()=>(0, _indexMjs.GraphQLUnionType));
parcelHelpers.export(exports, "GraphQLEnumType", ()=>(0, _indexMjs.GraphQLEnumType));
parcelHelpers.export(exports, "GraphQLInputObjectType", ()=>(0, _indexMjs.GraphQLInputObjectType));
parcelHelpers.export(exports, "GraphQLList", ()=>(0, _indexMjs.GraphQLList));
parcelHelpers.export(exports, "GraphQLNonNull", ()=>(0, _indexMjs.GraphQLNonNull));
parcelHelpers.export(exports, "specifiedScalarTypes", ()=>(0, _indexMjs.specifiedScalarTypes));
parcelHelpers.export(exports, "GraphQLInt", ()=>(0, _indexMjs.GraphQLInt));
parcelHelpers.export(exports, "GraphQLFloat", ()=>(0, _indexMjs.GraphQLFloat));
parcelHelpers.export(exports, "GraphQLString", ()=>(0, _indexMjs.GraphQLString));
parcelHelpers.export(exports, "GraphQLBoolean", ()=>(0, _indexMjs.GraphQLBoolean));
parcelHelpers.export(exports, "GraphQLID", ()=>(0, _indexMjs.GraphQLID));
parcelHelpers.export(exports, "specifiedDirectives", ()=>(0, _indexMjs.specifiedDirectives));
parcelHelpers.export(exports, "GraphQLIncludeDirective", ()=>(0, _indexMjs.GraphQLIncludeDirective));
parcelHelpers.export(exports, "GraphQLSkipDirective", ()=>(0, _indexMjs.GraphQLSkipDirective));
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", ()=>(0, _indexMjs.GraphQLDeprecatedDirective));
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", ()=>(0, _indexMjs.GraphQLSpecifiedByDirective));
parcelHelpers.export(exports, "TypeKind", ()=>(0, _indexMjs.TypeKind));
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", ()=>(0, _indexMjs.DEFAULT_DEPRECATION_REASON));
parcelHelpers.export(exports, "introspectionTypes", ()=>(0, _indexMjs.introspectionTypes));
parcelHelpers.export(exports, "__Schema", ()=>(0, _indexMjs.__Schema));
parcelHelpers.export(exports, "__Directive", ()=>(0, _indexMjs.__Directive));
parcelHelpers.export(exports, "__DirectiveLocation", ()=>(0, _indexMjs.__DirectiveLocation));
parcelHelpers.export(exports, "__Type", ()=>(0, _indexMjs.__Type));
parcelHelpers.export(exports, "__Field", ()=>(0, _indexMjs.__Field));
parcelHelpers.export(exports, "__InputValue", ()=>(0, _indexMjs.__InputValue));
parcelHelpers.export(exports, "__EnumValue", ()=>(0, _indexMjs.__EnumValue));
parcelHelpers.export(exports, "__TypeKind", ()=>(0, _indexMjs.__TypeKind));
parcelHelpers.export(exports, "SchemaMetaFieldDef", ()=>(0, _indexMjs.SchemaMetaFieldDef));
parcelHelpers.export(exports, "TypeMetaFieldDef", ()=>(0, _indexMjs.TypeMetaFieldDef));
parcelHelpers.export(exports, "TypeNameMetaFieldDef", ()=>(0, _indexMjs.TypeNameMetaFieldDef));
parcelHelpers.export(exports, "isSchema", ()=>(0, _indexMjs.isSchema));
parcelHelpers.export(exports, "isDirective", ()=>(0, _indexMjs.isDirective));
parcelHelpers.export(exports, "isType", ()=>(0, _indexMjs.isType));
parcelHelpers.export(exports, "isScalarType", ()=>(0, _indexMjs.isScalarType));
parcelHelpers.export(exports, "isObjectType", ()=>(0, _indexMjs.isObjectType));
parcelHelpers.export(exports, "isInterfaceType", ()=>(0, _indexMjs.isInterfaceType));
parcelHelpers.export(exports, "isUnionType", ()=>(0, _indexMjs.isUnionType));
parcelHelpers.export(exports, "isEnumType", ()=>(0, _indexMjs.isEnumType));
parcelHelpers.export(exports, "isInputObjectType", ()=>(0, _indexMjs.isInputObjectType));
parcelHelpers.export(exports, "isListType", ()=>(0, _indexMjs.isListType));
parcelHelpers.export(exports, "isNonNullType", ()=>(0, _indexMjs.isNonNullType));
parcelHelpers.export(exports, "isInputType", ()=>(0, _indexMjs.isInputType));
parcelHelpers.export(exports, "isOutputType", ()=>(0, _indexMjs.isOutputType));
parcelHelpers.export(exports, "isLeafType", ()=>(0, _indexMjs.isLeafType));
parcelHelpers.export(exports, "isCompositeType", ()=>(0, _indexMjs.isCompositeType));
parcelHelpers.export(exports, "isAbstractType", ()=>(0, _indexMjs.isAbstractType));
parcelHelpers.export(exports, "isWrappingType", ()=>(0, _indexMjs.isWrappingType));
parcelHelpers.export(exports, "isNullableType", ()=>(0, _indexMjs.isNullableType));
parcelHelpers.export(exports, "isNamedType", ()=>(0, _indexMjs.isNamedType));
parcelHelpers.export(exports, "isRequiredArgument", ()=>(0, _indexMjs.isRequiredArgument));
parcelHelpers.export(exports, "isRequiredInputField", ()=>(0, _indexMjs.isRequiredInputField));
parcelHelpers.export(exports, "isSpecifiedScalarType", ()=>(0, _indexMjs.isSpecifiedScalarType));
parcelHelpers.export(exports, "isIntrospectionType", ()=>(0, _indexMjs.isIntrospectionType));
parcelHelpers.export(exports, "isSpecifiedDirective", ()=>(0, _indexMjs.isSpecifiedDirective));
parcelHelpers.export(exports, "assertSchema", ()=>(0, _indexMjs.assertSchema));
parcelHelpers.export(exports, "assertDirective", ()=>(0, _indexMjs.assertDirective));
parcelHelpers.export(exports, "assertType", ()=>(0, _indexMjs.assertType));
parcelHelpers.export(exports, "assertScalarType", ()=>(0, _indexMjs.assertScalarType));
parcelHelpers.export(exports, "assertObjectType", ()=>(0, _indexMjs.assertObjectType));
parcelHelpers.export(exports, "assertInterfaceType", ()=>(0, _indexMjs.assertInterfaceType));
parcelHelpers.export(exports, "assertUnionType", ()=>(0, _indexMjs.assertUnionType));
parcelHelpers.export(exports, "assertEnumType", ()=>(0, _indexMjs.assertEnumType));
parcelHelpers.export(exports, "assertInputObjectType", ()=>(0, _indexMjs.assertInputObjectType));
parcelHelpers.export(exports, "assertListType", ()=>(0, _indexMjs.assertListType));
parcelHelpers.export(exports, "assertNonNullType", ()=>(0, _indexMjs.assertNonNullType));
parcelHelpers.export(exports, "assertInputType", ()=>(0, _indexMjs.assertInputType));
parcelHelpers.export(exports, "assertOutputType", ()=>(0, _indexMjs.assertOutputType));
parcelHelpers.export(exports, "assertLeafType", ()=>(0, _indexMjs.assertLeafType));
parcelHelpers.export(exports, "assertCompositeType", ()=>(0, _indexMjs.assertCompositeType));
parcelHelpers.export(exports, "assertAbstractType", ()=>(0, _indexMjs.assertAbstractType));
parcelHelpers.export(exports, "assertWrappingType", ()=>(0, _indexMjs.assertWrappingType));
parcelHelpers.export(exports, "assertNullableType", ()=>(0, _indexMjs.assertNullableType));
parcelHelpers.export(exports, "assertNamedType", ()=>(0, _indexMjs.assertNamedType));
parcelHelpers.export(exports, "getNullableType", ()=>(0, _indexMjs.getNullableType));
parcelHelpers.export(exports, "getNamedType", ()=>(0, _indexMjs.getNamedType));
parcelHelpers.export(exports, "validateSchema", ()=>(0, _indexMjs.validateSchema));
parcelHelpers.export(exports, "assertValidSchema", ()=>(0, _indexMjs.assertValidSchema));
// Parse and operate on GraphQL language source files.
parcelHelpers.export(exports, "Token", ()=>(0, _indexMjs1.Token));
parcelHelpers.export(exports, "Source", ()=>(0, _indexMjs1.Source));
parcelHelpers.export(exports, "Location", ()=>(0, _indexMjs1.Location));
parcelHelpers.export(exports, "getLocation", ()=>(0, _indexMjs1.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _indexMjs1.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _indexMjs1.printSourceLocation));
parcelHelpers.export(exports, "Lexer", ()=>(0, _indexMjs1.Lexer));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _indexMjs1.TokenKind));
parcelHelpers.export(exports, "parse", ()=>(0, _indexMjs1.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _indexMjs1.parseValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _indexMjs1.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _indexMjs1.print));
parcelHelpers.export(exports, "visit", ()=>(0, _indexMjs1.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _indexMjs1.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _indexMjs1.getVisitFn));
parcelHelpers.export(exports, "BREAK", ()=>(0, _indexMjs1.BREAK));
parcelHelpers.export(exports, "Kind", ()=>(0, _indexMjs1.Kind));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _indexMjs1.DirectiveLocation));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _indexMjs1.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _indexMjs1.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _indexMjs1.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _indexMjs1.isValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _indexMjs1.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _indexMjs1.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _indexMjs1.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _indexMjs1.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _indexMjs1.isTypeExtensionNode));
// Execute GraphQL queries.
parcelHelpers.export(exports, "execute", ()=>(0, _indexMjs2.execute));
parcelHelpers.export(exports, "executeSync", ()=>(0, _indexMjs2.executeSync));
parcelHelpers.export(exports, "defaultFieldResolver", ()=>(0, _indexMjs2.defaultFieldResolver));
parcelHelpers.export(exports, "defaultTypeResolver", ()=>(0, _indexMjs2.defaultTypeResolver));
parcelHelpers.export(exports, "responsePathAsArray", ()=>(0, _indexMjs2.responsePathAsArray));
parcelHelpers.export(exports, "getDirectiveValues", ()=>(0, _indexMjs2.getDirectiveValues));
parcelHelpers.export(exports, "subscribe", ()=>(0, _indexMjs3.subscribe));
parcelHelpers.export(exports, "createSourceEventStream", ()=>(0, _indexMjs3.createSourceEventStream));
// Validate GraphQL documents.
parcelHelpers.export(exports, "validate", ()=>(0, _indexMjs4.validate));
parcelHelpers.export(exports, "ValidationContext", ()=>(0, _indexMjs4.ValidationContext));
parcelHelpers.export(exports, "specifiedRules", ()=>(0, _indexMjs4.specifiedRules));
parcelHelpers.export(exports, "ExecutableDefinitionsRule", ()=>(0, _indexMjs4.ExecutableDefinitionsRule));
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", ()=>(0, _indexMjs4.FieldsOnCorrectTypeRule));
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", ()=>(0, _indexMjs4.FragmentsOnCompositeTypesRule));
parcelHelpers.export(exports, "KnownArgumentNamesRule", ()=>(0, _indexMjs4.KnownArgumentNamesRule));
parcelHelpers.export(exports, "KnownDirectivesRule", ()=>(0, _indexMjs4.KnownDirectivesRule));
parcelHelpers.export(exports, "KnownFragmentNamesRule", ()=>(0, _indexMjs4.KnownFragmentNamesRule));
parcelHelpers.export(exports, "KnownTypeNamesRule", ()=>(0, _indexMjs4.KnownTypeNamesRule));
parcelHelpers.export(exports, "LoneAnonymousOperationRule", ()=>(0, _indexMjs4.LoneAnonymousOperationRule));
parcelHelpers.export(exports, "NoFragmentCyclesRule", ()=>(0, _indexMjs4.NoFragmentCyclesRule));
parcelHelpers.export(exports, "NoUndefinedVariablesRule", ()=>(0, _indexMjs4.NoUndefinedVariablesRule));
parcelHelpers.export(exports, "NoUnusedFragmentsRule", ()=>(0, _indexMjs4.NoUnusedFragmentsRule));
parcelHelpers.export(exports, "NoUnusedVariablesRule", ()=>(0, _indexMjs4.NoUnusedVariablesRule));
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", ()=>(0, _indexMjs4.OverlappingFieldsCanBeMergedRule));
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", ()=>(0, _indexMjs4.PossibleFragmentSpreadsRule));
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", ()=>(0, _indexMjs4.ProvidedRequiredArgumentsRule));
parcelHelpers.export(exports, "ScalarLeafsRule", ()=>(0, _indexMjs4.ScalarLeafsRule));
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", ()=>(0, _indexMjs4.SingleFieldSubscriptionsRule));
parcelHelpers.export(exports, "UniqueArgumentNamesRule", ()=>(0, _indexMjs4.UniqueArgumentNamesRule));
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", ()=>(0, _indexMjs4.UniqueDirectivesPerLocationRule));
parcelHelpers.export(exports, "UniqueFragmentNamesRule", ()=>(0, _indexMjs4.UniqueFragmentNamesRule));
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", ()=>(0, _indexMjs4.UniqueInputFieldNamesRule));
parcelHelpers.export(exports, "UniqueOperationNamesRule", ()=>(0, _indexMjs4.UniqueOperationNamesRule));
parcelHelpers.export(exports, "UniqueVariableNamesRule", ()=>(0, _indexMjs4.UniqueVariableNamesRule));
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", ()=>(0, _indexMjs4.ValuesOfCorrectTypeRule));
parcelHelpers.export(exports, "VariablesAreInputTypesRule", ()=>(0, _indexMjs4.VariablesAreInputTypesRule));
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", ()=>(0, _indexMjs4.VariablesInAllowedPositionRule));
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", ()=>(0, _indexMjs4.LoneSchemaDefinitionRule));
parcelHelpers.export(exports, "UniqueOperationTypesRule", ()=>(0, _indexMjs4.UniqueOperationTypesRule));
parcelHelpers.export(exports, "UniqueTypeNamesRule", ()=>(0, _indexMjs4.UniqueTypeNamesRule));
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", ()=>(0, _indexMjs4.UniqueEnumValueNamesRule));
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", ()=>(0, _indexMjs4.UniqueFieldDefinitionNamesRule));
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", ()=>(0, _indexMjs4.UniqueDirectiveNamesRule));
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", ()=>(0, _indexMjs4.PossibleTypeExtensionsRule));
parcelHelpers.export(exports, "NoDeprecatedCustomRule", ()=>(0, _indexMjs4.NoDeprecatedCustomRule));
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", ()=>(0, _indexMjs4.NoSchemaIntrospectionCustomRule));
// Create, format, and print GraphQL errors.
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _indexMjs5.GraphQLError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _indexMjs5.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _indexMjs5.locatedError));
parcelHelpers.export(exports, "printError", ()=>(0, _indexMjs5.printError));
parcelHelpers.export(exports, "formatError", ()=>(0, _indexMjs5.formatError));
// Utilities for operating on GraphQL type schema and parsed sources.
parcelHelpers.export(exports, "getIntrospectionQuery", ()=>(0, _indexMjs6.getIntrospectionQuery));
parcelHelpers.export(exports, "getOperationAST", ()=>(0, _indexMjs6.getOperationAST));
parcelHelpers.export(exports, "getOperationRootType", ()=>(0, _indexMjs6.getOperationRootType));
parcelHelpers.export(exports, "introspectionFromSchema", ()=>(0, _indexMjs6.introspectionFromSchema));
parcelHelpers.export(exports, "buildClientSchema", ()=>(0, _indexMjs6.buildClientSchema));
parcelHelpers.export(exports, "buildASTSchema", ()=>(0, _indexMjs6.buildASTSchema));
parcelHelpers.export(exports, "buildSchema", ()=>(0, _indexMjs6.buildSchema));
parcelHelpers.export(exports, "getDescription", ()=>(0, _indexMjs6.getDescription));
parcelHelpers.export(exports, "extendSchema", ()=>(0, _indexMjs6.extendSchema));
parcelHelpers.export(exports, "lexicographicSortSchema", ()=>(0, _indexMjs6.lexicographicSortSchema));
parcelHelpers.export(exports, "printSchema", ()=>(0, _indexMjs6.printSchema));
parcelHelpers.export(exports, "printType", ()=>(0, _indexMjs6.printType));
parcelHelpers.export(exports, "printIntrospectionSchema", ()=>(0, _indexMjs6.printIntrospectionSchema));
parcelHelpers.export(exports, "typeFromAST", ()=>(0, _indexMjs6.typeFromAST));
parcelHelpers.export(exports, "valueFromAST", ()=>(0, _indexMjs6.valueFromAST));
parcelHelpers.export(exports, "valueFromASTUntyped", ()=>(0, _indexMjs6.valueFromASTUntyped));
parcelHelpers.export(exports, "astFromValue", ()=>(0, _indexMjs6.astFromValue));
parcelHelpers.export(exports, "TypeInfo", ()=>(0, _indexMjs6.TypeInfo));
parcelHelpers.export(exports, "visitWithTypeInfo", ()=>(0, _indexMjs6.visitWithTypeInfo));
parcelHelpers.export(exports, "coerceInputValue", ()=>(0, _indexMjs6.coerceInputValue));
parcelHelpers.export(exports, "concatAST", ()=>(0, _indexMjs6.concatAST));
parcelHelpers.export(exports, "separateOperations", ()=>(0, _indexMjs6.separateOperations));
parcelHelpers.export(exports, "stripIgnoredCharacters", ()=>(0, _indexMjs6.stripIgnoredCharacters));
parcelHelpers.export(exports, "isEqualType", ()=>(0, _indexMjs6.isEqualType));
parcelHelpers.export(exports, "isTypeSubTypeOf", ()=>(0, _indexMjs6.isTypeSubTypeOf));
parcelHelpers.export(exports, "doTypesOverlap", ()=>(0, _indexMjs6.doTypesOverlap));
parcelHelpers.export(exports, "assertValidName", ()=>(0, _indexMjs6.assertValidName));
parcelHelpers.export(exports, "isValidNameError", ()=>(0, _indexMjs6.isValidNameError));
parcelHelpers.export(exports, "BreakingChangeType", ()=>(0, _indexMjs6.BreakingChangeType));
parcelHelpers.export(exports, "DangerousChangeType", ()=>(0, _indexMjs6.DangerousChangeType));
parcelHelpers.export(exports, "findBreakingChanges", ()=>(0, _indexMjs6.findBreakingChanges));
parcelHelpers.export(exports, "findDangerousChanges", ()=>(0, _indexMjs6.findDangerousChanges));
parcelHelpers.export(exports, "findDeprecatedUsages", ()=>(0, _indexMjs6.findDeprecatedUsages));
var _versionMjs = require("./version.mjs");
var _graphqlMjs = require("./graphql.mjs");
var _indexMjs = require("./type/index.mjs");
var _indexMjs1 = require("./language/index.mjs");
var _indexMjs2 = require("./execution/index.mjs");
var _indexMjs3 = require("./subscription/index.mjs");
var _indexMjs4 = require("./validation/index.mjs");
var _indexMjs5 = require("./error/index.mjs");
var _indexMjs6 = require("./utilities/index.mjs");

},{"./version.mjs":false,"./graphql.mjs":false,"./type/index.mjs":false,"./language/index.mjs":false,"./execution/index.mjs":false,"./subscription/index.mjs":false,"./validation/index.mjs":false,"./error/index.mjs":"kmTtf","./utilities/index.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kmTtf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _graphQLErrorMjs.GraphQLError));
parcelHelpers.export(exports, "printError", ()=>(0, _graphQLErrorMjs.printError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _syntaxErrorMjs.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _locatedErrorMjs.locatedError));
parcelHelpers.export(exports, "formatError", ()=>(0, _formatErrorMjs.formatError));
var _graphQLErrorMjs = require("./GraphQLError.mjs");
var _syntaxErrorMjs = require("./syntaxError.mjs");
var _locatedErrorMjs = require("./locatedError.mjs");
var _formatErrorMjs = require("./formatError.mjs");

},{"./GraphQLError.mjs":"hWx0o","./syntaxError.mjs":false,"./locatedError.mjs":false,"./formatError.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hWx0o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLError", ()=>GraphQLError);
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ parcelHelpers.export(exports, "printError", ()=>printError);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _isObjectLikeMjsDefault = parcelHelpers.interopDefault(_isObjectLikeMjs);
var _symbolsMjs = require("../polyfills/symbols.mjs");
var _locationMjs = require("../language/location.mjs");
var _printLocationMjs = require("../language/printLocation.mjs");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var GraphQLError = /*#__PURE__*/ function(_Error) {
    _inherits(GraphQLError, _Error);
    var _super = _createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        _classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = "GraphQLError";
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, _locationMjs.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, _locationMjs.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, _isObjectLikeMjsDefault.default)(originalExtensions)) _this.extensions = _objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties(_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty(_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return _possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty(_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    _createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return printError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, _symbolsMjs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += "\n\n" + (0, _printLocationMjs.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += "\n\n" + (0, _printLocationMjs.printSourceLocation)(error.source, location);
    }
    return output;
}

},{"../jsutils/isObjectLike.mjs":"bdPmB","../polyfills/symbols.mjs":"ekyzo","../language/location.mjs":"jX9Yi","../language/printLocation.mjs":"dZlVw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bdPmB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObjectLike);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isObjectLike(value) {
    return _typeof(value) == "object" && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ekyzo":[function(require,module,exports) {
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SYMBOL_ITERATOR", ()=>SYMBOL_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_ASYNC_ITERATOR", ()=>SYMBOL_ASYNC_ITERATOR);
parcelHelpers.export(exports, "SYMBOL_TO_STRING_TAG", ()=>SYMBOL_TO_STRING_TAG);
var SYMBOL_ITERATOR = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_TO_STRING_TAG = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jX9Yi":[function(require,module,exports) {
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
function getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dZlVw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printLocation", ()=>printLocation);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printSourceLocation", ()=>printSourceLocation);
var _locationMjs = require("./location.mjs");
function printLocation(location) {
    return printSourceLocation(location.source, (0, _locationMjs.getLocation)(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function whitespace(len) {
    return Array(len + 1).join(" ");
}
function leftPad(len, str) {
    return whitespace(len - str.length) + str;
}

},{"./location.mjs":"jX9Yi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kDvHV":[function(require,module,exports) {
var v1 = require("2692d5b25cb636da");
var v4 = require("8e7ce4f7f63d6ab7");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"2692d5b25cb636da":"48M6l","8e7ce4f7f63d6ab7":"b5ECt"}],"48M6l":[function(require,module,exports) {
var rng = require("26576a3ba9c65f36");
var bytesToUuid = require("473ec57ef57135c8");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"26576a3ba9c65f36":"fSSVj","473ec57ef57135c8":"icBuX"}],"fSSVj":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"icBuX":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"b5ECt":[function(require,module,exports) {
var rng = require("8b8875286285a74a");
var bytesToUuid = require("51f068ffcb28ed6e");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"8b8875286285a74a":"fSSVj","51f068ffcb28ed6e":"icBuX"}],"uEI7y":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("d66f2e1ecf9cf00c");
var ieee754 = require("edca2e5113247e77");
var isArray = require("afbe907bb3b486b3");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"d66f2e1ecf9cf00c":"MlSYJ","edca2e5113247e77":"15Xnl","afbe907bb3b486b3":"9gjbG"}],"dTFhH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>CONTROL_MSG);
parcelHelpers.export(exports, "ConnectionState", ()=>ConnectionState);
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var ConnectionState;
(function(ConnectionState) {
    /*
     * The connection is alive and healthy
     */ ConnectionState["Connected"] = "Connected";
    /*
     * The connection is alive, but the connection is offline
     */ ConnectionState["ConnectedPendingNetwork"] = "ConnectedPendingNetwork";
    /*
     * The connection has been disconnected while in use
     */ ConnectionState["ConnectionDisrupted"] = "ConnectionDisrupted";
    /*
     * The connection has been disconnected and the network is offline
     */ ConnectionState["ConnectionDisruptedPendingNetwork"] = "ConnectionDisruptedPendingNetwork";
    /*
     * The connection is in the process of connecting
     */ ConnectionState["Connecting"] = "Connecting";
    /*
     * The connection is not in use and is being disconnected
     */ ConnectionState["ConnectedPendingDisconnect"] = "ConnectedPendingDisconnect";
    /*
     * The connection is not in use and has been disconnected
     */ ConnectionState["Disconnected"] = "Disconnected";
    /*
     * The connection is alive, but a keep alive message has been missed
     */ ConnectionState["ConnectedPendingKeepAlive"] = "ConnectedPendingKeepAlive";
})(ConnectionState || (ConnectionState = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dleHk":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_DELAY_MS", ()=>MAX_DELAY_MS);
parcelHelpers.export(exports, "NON_RETRYABLE_CODES", ()=>NON_RETRYABLE_CODES);
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", ()=>CONNECTION_STATE_CHANGE);
parcelHelpers.export(exports, "MESSAGE_TYPES", ()=>MESSAGE_TYPES);
parcelHelpers.export(exports, "SUBSCRIPTION_STATUS", ()=>SUBSCRIPTION_STATUS);
parcelHelpers.export(exports, "SOCKET_STATUS", ()=>SOCKET_STATUS);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
parcelHelpers.export(exports, "AWS_APPSYNC_REALTIME_HEADERS", ()=>AWS_APPSYNC_REALTIME_HEADERS);
parcelHelpers.export(exports, "CONNECTION_INIT_TIMEOUT", ()=>CONNECTION_INIT_TIMEOUT);
parcelHelpers.export(exports, "START_ACK_TIMEOUT", ()=>START_ACK_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_TIMEOUT", ()=>DEFAULT_KEEP_ALIVE_TIMEOUT);
parcelHelpers.export(exports, "DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT", ()=>DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT);
parcelHelpers.export(exports, "RECONNECT_DELAY", ()=>RECONNECT_DELAY);
parcelHelpers.export(exports, "RECONNECT_INTERVAL", ()=>RECONNECT_INTERVAL);
var MAX_DELAY_MS = 5000;
var NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var CONNECTION_STATE_CHANGE = "ConnectionStateChange";
var MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
var SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})(SOCKET_STATUS || (SOCKET_STATUS = {}));
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var AWS_APPSYNC_REALTIME_HEADERS = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
var CONNECTION_INIT_TIMEOUT = 15000;
var START_ACK_TIMEOUT = 15000;
var DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var DEFAULT_KEEP_ALIVE_ALERT_TIMEOUT = 65000;
var RECONNECT_DELAY = 5000;
var RECONNECT_INTERVAL = 60000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"04hIN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONNECTION_CHANGE", ()=>CONNECTION_CHANGE);
parcelHelpers.export(exports, "ConnectionStateMonitor", ()=>ConnectionStateMonitor);
var _tslib = require("tslib");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _pubSub = require("../types/PubSub");
var _reachabilityMonitor = require("./ReachabilityMonitor");
var CONNECTION_CHANGE = {
    KEEP_ALIVE_MISSED: {
        keepAliveState: "unhealthy"
    },
    KEEP_ALIVE: {
        keepAliveState: "healthy"
    },
    CONNECTION_ESTABLISHED: {
        connectionState: "connected"
    },
    CONNECTION_FAILED: {
        intendedConnectionState: "disconnected",
        connectionState: "disconnected"
    },
    CLOSING_CONNECTION: {
        intendedConnectionState: "disconnected"
    },
    OPENING_CONNECTION: {
        intendedConnectionState: "connected",
        connectionState: "connecting"
    },
    CLOSED: {
        connectionState: "disconnected"
    },
    ONLINE: {
        networkState: "connected"
    },
    OFFLINE: {
        networkState: "disconnected"
    }
};
var ConnectionStateMonitor = /** @class */ function() {
    function ConnectionStateMonitor() {
        var _this = this;
        this._networkMonitoringSubscription = undefined;
        this._linkedConnectionState = {
            networkState: "connected",
            connectionState: "disconnected",
            intendedConnectionState: "disconnected",
            keepAliveState: "healthy"
        };
        // Attempt to update the state with the current actual network state
        this._initialNetworkStateSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            var _b;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
            (_b = _this._initialNetworkStateSubscription) === null || _b === void 0 || _b.unsubscribe();
        });
        this._linkedConnectionStateObservable = new (0, _zenObservableTsDefault.default)(function(connectionStateObserver) {
            connectionStateObserver.next(_this._linkedConnectionState);
            _this._linkedConnectionStateObserver = connectionStateObserver;
        });
    }
    /**
     * Turn network state monitoring on if it isn't on already
     */ ConnectionStateMonitor.prototype.enableNetworkMonitoring = function() {
        var _this = this;
        var _a;
        // If no initial network state was discovered, stop trying
        (_a = this._initialNetworkStateSubscription) === null || _a === void 0 || _a.unsubscribe();
        // Maintain the network state based on the reachability monitor
        if (this._networkMonitoringSubscription === undefined) this._networkMonitoringSubscription = (0, _reachabilityMonitor.ReachabilityMonitor)().subscribe(function(_a) {
            var online = _a.online;
            _this.record(online ? CONNECTION_CHANGE.ONLINE : CONNECTION_CHANGE.OFFLINE);
        });
    };
    /**
     * Turn network state monitoring off if it isn't off already
     */ ConnectionStateMonitor.prototype.disableNetworkMonitoring = function() {
        var _a;
        (_a = this._networkMonitoringSubscription) === null || _a === void 0 || _a.unsubscribe();
        this._networkMonitoringSubscription = undefined;
    };
    Object.defineProperty(ConnectionStateMonitor.prototype, "connectionStateObservable", {
        /**
         * Get the observable that allows us to monitor the connection state
         *
         * @returns {Observable<ConnectionState>} - The observable that emits ConnectionState updates
         */ get: function() {
            var _this = this;
            var previous;
            // The linked state aggregates state changes to any of the network, connection,
            // intendedConnection and keepAliveHealth. Some states will change these independent
            // states without changing the overall connection state.
            // After translating from linked states to ConnectionState, then remove any duplicates
            return this._linkedConnectionStateObservable.map(function(value) {
                return _this.connectionStatesTranslator(value);
            }).filter(function(current) {
                var toInclude = current !== previous;
                previous = current;
                return toInclude;
            });
        },
        enumerable: true,
        configurable: true
    });
    /*
     * Updates local connection state and emits the full state to the observer.
     */ ConnectionStateMonitor.prototype.record = function(statusUpdates) {
        // Maintain the network monitor
        if (statusUpdates.intendedConnectionState === "connected") this.enableNetworkMonitoring();
        else if (statusUpdates.intendedConnectionState === "disconnected") this.disableNetworkMonitoring();
        // Maintain the socket state
        var newSocketStatus = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._linkedConnectionState), statusUpdates);
        this._linkedConnectionState = (0, _tslib.__assign)({}, newSocketStatus);
        this._linkedConnectionStateObserver.next(this._linkedConnectionState);
    };
    /*
     * Translate the ConnectionState structure into a specific ConnectionState string literal union
     */ ConnectionStateMonitor.prototype.connectionStatesTranslator = function(_a) {
        var connectionState = _a.connectionState, networkState = _a.networkState, intendedConnectionState = _a.intendedConnectionState, keepAliveState = _a.keepAliveState;
        if (connectionState === "connected" && networkState === "disconnected") return (0, _pubSub.ConnectionState).ConnectedPendingNetwork;
        if (connectionState === "connected" && intendedConnectionState === "disconnected") return (0, _pubSub.ConnectionState).ConnectedPendingDisconnect;
        if (connectionState === "disconnected" && intendedConnectionState === "connected" && networkState === "disconnected") return (0, _pubSub.ConnectionState).ConnectionDisruptedPendingNetwork;
        if (connectionState === "disconnected" && intendedConnectionState === "connected") return (0, _pubSub.ConnectionState).ConnectionDisrupted;
        if (connectionState === "connected" && keepAliveState === "unhealthy") return (0, _pubSub.ConnectionState).ConnectedPendingKeepAlive;
        // All remaining states directly correspond to the connection state
        if (connectionState === "connecting") return (0, _pubSub.ConnectionState).Connecting;
        if (connectionState === "disconnected") return (0, _pubSub.ConnectionState).Disconnected;
        return (0, _pubSub.ConnectionState).Connected;
    };
    return ConnectionStateMonitor;
}();

},{"tslib":"cUWSL","zen-observable-ts":"57mma","../types/PubSub":"dTFhH","./ReachabilityMonitor":"6G1lb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6G1lb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", ()=>ReachabilityMonitor);
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = function() {
    return new (0, _core.Reachability)().networkMonitor();
};

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ikPBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReconnectEvent", ()=>ReconnectEvent);
parcelHelpers.export(exports, "ReconnectionMonitor", ()=>ReconnectionMonitor);
var _constants = require("../Providers/constants");
var ReconnectEvent;
(function(ReconnectEvent) {
    ReconnectEvent["START_RECONNECT"] = "START_RECONNECT";
    ReconnectEvent["HALT_RECONNECT"] = "HALT_RECONNECT";
})(ReconnectEvent || (ReconnectEvent = {}));
/**
 * Captures the reconnect event logic used to determine when to reconnect to PubSub providers.
 *   Reconnnect attempts are delayed by 5 seconds to let the interface settle.
 *   Attempting to reconnect only once creates unrecoverable states when the network state isn't
 *   supported by the browser, so this keeps retrying every minute until halted.
 */ var ReconnectionMonitor = /** @class */ function() {
    function ReconnectionMonitor() {
        this.reconnectObservers = [];
    }
    /**
     * Add reconnect observer to the list of observers to alert on reconnect
     */ ReconnectionMonitor.prototype.addObserver = function(reconnectObserver) {
        this.reconnectObservers.push(reconnectObserver);
    };
    /**
     * Given a reconnect event, start the appropriate behavior
     */ ReconnectionMonitor.prototype.record = function(event) {
        var _this = this;
        if (event === ReconnectEvent.START_RECONNECT) // If the reconnection hasn't been started
        {
            if (this.reconnectSetTimeoutId === undefined && this.reconnectIntervalId === undefined) this.reconnectSetTimeoutId = setTimeout(function() {
                // Reconnect now
                _this._triggerReconnect();
                // Retry reconnect every periodically until it works
                _this.reconnectIntervalId = setInterval(function() {
                    _this._triggerReconnect();
                }, (0, _constants.RECONNECT_INTERVAL));
            }, (0, _constants.RECONNECT_DELAY));
        }
        if (event === ReconnectEvent.HALT_RECONNECT) {
            if (this.reconnectIntervalId) {
                clearInterval(this.reconnectIntervalId);
                this.reconnectIntervalId = undefined;
            }
            if (this.reconnectSetTimeoutId) {
                clearTimeout(this.reconnectSetTimeoutId);
                this.reconnectSetTimeoutId = undefined;
            }
        }
    };
    /**
     * Complete all reconnect observers
     */ ReconnectionMonitor.prototype.close = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.complete) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    ReconnectionMonitor.prototype._triggerReconnect = function() {
        this.reconnectObservers.forEach(function(reconnectObserver) {
            var _a;
            (_a = reconnectObserver.next) === null || _a === void 0 || _a.call(reconnectObserver);
        });
    };
    return ReconnectionMonitor;
}();

},{"../Providers/constants":"dleHk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4viCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _auth.GRAPHQL_AUTH_MODE));
parcelHelpers.export(exports, "GraphQLAuthError", ()=>GraphQLAuthError);
var _auth = require("@aws-amplify/auth");
var GraphQLAuthError;
(function(GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
    GraphQLAuthError["NO_AUTH_TOKEN"] = "No auth token specified";
})(GraphQLAuthError || (GraphQLAuthError = {}));

},{"@aws-amplify/auth":"ilv20","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"by3r2":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPI", ()=>(0, _restAPI.RestAPI));
parcelHelpers.export(exports, "RestAPIClass", ()=>(0, _restAPI.RestAPIClass));
parcelHelpers.export(exports, "RestClient", ()=>(0, _restClient.RestClient));
var _restAPI = require("./RestAPI");
var _restClient = require("./RestClient");

},{"./RestAPI":"g8YJt","./RestClient":"1QqNN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g8YJt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestAPIClass", ()=>RestAPIClass);
parcelHelpers.export(exports, "RestAPI", ()=>RestAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _restClient = require("./RestClient");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("RestAPI");
/**
 * Export Cloud Logic APIs
 */ var RestAPIClass = /** @class */ function() {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */ function RestAPIClass(options) {
        this._api = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
    }
    RestAPIClass.prototype.getModuleName = function() {
        return "RestAPI";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ RestAPIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = (0, _tslib.__rest)(_a, [
            "API"
        ]);
        var opt = (0, _tslib.__assign)((0, _tslib.__assign)({}, otherOptions), API);
        logger.debug("configure Rest API", {
            opt: opt
        });
        if (opt["aws_project_region"]) {
            if (opt["aws_cloud_logic_custom"]) {
                var custom = opt["aws_cloud_logic_custom"];
                opt.endpoints = typeof custom === "string" ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt["aws_project_region"],
                header: {}
            });
        }
        if (Array.isArray(opt.endpoints)) // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== "undefined" && typeof endpoint.custom_header !== "function") {
                logger.warn("Rest API " + endpoint.name + ", custom_header should be a function");
                endpoint.custom_header = undefined;
            }
        });
        else if (this._options && Array.isArray(this._options.endpoints)) opt.endpoints = this._options.endpoints;
        else opt.endpoints = [];
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ RestAPIClass.prototype.createInstance = function() {
        logger.debug("create Rest API instance");
        this._api = new (0, _restClient.RestClient)(this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.get = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.post = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.put = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.patch = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.del = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestAPIClass.prototype.head = function(apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        } catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestAPIClass.prototype.isCancel = function(error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */ RestAPIClass.prototype.cancel = function(request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestAPIClass.prototype.hasCancelToken = function(request) {
        return this._api.hasCancelToken(request);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestAPIClass.prototype.endpoint = function(apiName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._api.endpoint(apiName)
                ];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */ RestAPIClass.prototype.getEndpointInfo = function(apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) throw new Error("API category not configured");
        var apiConfig = cloud_logic_array.find(function(api) {
            return api.name === apiName;
        });
        if (!apiConfig) throw new Error("API ".concat(apiName, " does not exist"));
        var response = {
            endpoint: apiConfig.endpoint + path
        };
        if (typeof apiConfig.region === "string") response.region = apiConfig.region;
        else if (typeof this._options.region === "string") response.region = this._options.region;
        if (typeof apiConfig.service === "string") response.service = apiConfig.service || "execute-api";
        else response.service = "execute-api";
        if (typeof apiConfig.custom_header === "function") response.custom_header = apiConfig.custom_header;
        else response.custom_header = undefined;
        return response;
    };
    return RestAPIClass;
}();
var RestAPI = new RestAPIClass(null);
(0, _core.Amplify).register(RestAPI);

},{"tslib":"1ORaD","./RestClient":"1QqNN","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ORaD":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QqNN":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RestClient", ()=>RestClient);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _url = require("url");
var logger = new (0, _core.ConsoleLogger)("RestClient");
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var RestClient = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = "us-east-1"; // this will be updated by endpoint function
        this._service = "execute-api"; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */ this._cancelTokenMap = null;
        this.Credentials = (0, _core.Credentials);
        this._options = options;
        logger.debug("API Options", this._options);
        if (this._cancelTokenMap == null) this._cancelTokenMap = new WeakMap();
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(urlOrApiInfo, method, init) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl, credentials, error_1, signedParams, response, error_2, headers, dateHeader, responseDate, requestDate, rawClientDate;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        logger.debug(method, urlOrApiInfo);
                        region = "us-east-1";
                        service = "execute-api";
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === "string") {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        } else {
                            url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service;
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: "json",
                            timeout: 0,
                            cancelToken: null
                        };
                        libraryHeaders = {};
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === "function" && initParams.body instanceof FormData) {
                                libraryHeaders["Content-Type"] = "multipart/form-data";
                                params.data = initParams.body;
                            } else {
                                libraryHeaders["Content-Type"] = "application/json; charset=UTF-8";
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params["withCredentials"] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        if (initParams.cancellableToken) params.cancelToken = initParams.cancellableToken.token;
                        params["signerServiceInfo"] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = (0, _url.parse)(url, true, true), search = _b.search, parsedUrl = (0, _tslib.__rest)(_b, [
                            "search"
                        ]);
                        params.url = (0, _url.format)((0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl), {
                            query: (0, _tslib.__assign)((0, _tslib.__assign)({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers["Authorization"] !== "undefined") {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.Credentials.get()
                        ];
                    case 5:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_1 = _c.sent();
                        logger.debug("No credentials available, the request will be unsigned");
                        return [
                            2 /*return*/ ,
                            this._request(params, isAllResponse)
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        signedParams = this._sign((0, _tslib.__assign)({}, params), credentials, {
                            region: region,
                            service: service
                        });
                        return [
                            4 /*yield*/ ,
                            (0, _axiosDefault.default)(signedParams)
                        ];
                    case 8:
                        response = _c.sent();
                        return [
                            2 /*return*/ ,
                            isAllResponse ? response : response.data
                        ];
                    case 9:
                        error_2 = _c.sent();
                        logger.debug(error_2);
                        if ((0, _core.DateUtils).isClockSkewError(error_2)) {
                            headers = error_2.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            responseDate = new Date(dateHeader);
                            requestDate = (0, _core.DateUtils).getDateFromHeaderString(signedParams.headers["x-amz-date"]);
                            // Compare local clock to the server clock
                            if ((0, _core.DateUtils).isClockSkewed(responseDate)) {
                                rawClientDate = requestDate.getTime() - (0, _core.DateUtils).getClockOffset();
                                (0, _core.DateUtils).setClockOffset(responseDate.getTime() - rawClientDate);
                                return [
                                    2 /*return*/ ,
                                    this.ajax(urlOrApiInfo, method, init)
                                ];
                            }
                        }
                        throw error_2;
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "GET", init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PUT", init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "PATCH", init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "POST", init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "DELETE", init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, "HEAD", init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */ RestClient.prototype.cancel = function(request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) {
            source.cancel(message);
            return true;
        }
        return false;
    };
    /**
     * Check if the request has a corresponding cancel token in the WeakMap.
     * @params request - The request promise
     * @return if the request has a corresponding cancel token.
     */ RestClient.prototype.hasCancelToken = function(request) {
        return this._cancelTokenMap.has(request);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */ RestClient.prototype.isCancel = function(error) {
        return (0, _axiosDefault.default).isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */ RestClient.prototype.getCancellableToken = function() {
        return (0, _axiosDefault.default).CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */ RestClient.prototype.updateRequestToBeCancellable = function(promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = "";
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === "string") _this._region = v.region;
                else if (typeof _this._options.region === "string") _this._region = _this._options.region;
                if (typeof v.service === "string") _this._service = v.service || "execute-api";
                else _this._service = "execute-api";
                if (typeof v.custom_header === "function") _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._sign = function(params, credentials, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = (0, _tslib.__rest)(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, _core.Signer).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        logger.debug("Signed Request: ", signed_params);
        delete signed_params.headers["host"];
        return signed_params;
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, _axiosDefault.default)(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split("/");
        return {
            host: parts[2],
            path: "/" + parts.slice(3).join("/")
        };
    };
    return RestClient;
}();

},{"tslib":"1ORaD","@aws-amplify/core":"3rlh1","axios":"ebRwi","url":"7NJu4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ebRwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"5JUlc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5JUlc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"9h6FO","./helpers/bind.js":"dksnV","./core/Axios.js":"ivnjU","./core/mergeConfig.js":"lk3cu","./defaults/index.js":"03cMz","./helpers/formDataToJSON.js":"hW0hh","./cancel/CanceledError.js":"kIfPJ","./cancel/CancelToken.js":"aAhTh","./cancel/isCancel.js":"673ru","./env/data.js":"44Btw","./helpers/toFormData.js":"98O8i","./core/AxiosError.js":"2BBBE","./helpers/spread.js":"Rt4vC","./helpers/isAxiosError.js":"jd0zH","./core/AxiosHeaders.js":"77MZs","./adapters/adapters.js":"9phiH","./helpers/HttpStatusCode.js":"6GoLd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9h6FO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"dksnV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dksnV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ivnjU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"9h6FO","../helpers/buildURL.js":"3wgcs","./InterceptorManager.js":"1zkLW","./dispatchRequest.js":"tH08M","./mergeConfig.js":"lk3cu","./buildFullPath.js":"8uBwh","../helpers/validator.js":"inJar","./AxiosHeaders.js":"77MZs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3wgcs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"9h6FO","../helpers/AxiosURLSearchParams.js":"ci3NW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ci3NW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"98O8i","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"98O8i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"cvSE8","../utils.js":"9h6FO","../core/AxiosError.js":"2BBBE","../platform/node/classes/FormData.js":"eeTX0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2BBBE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eeTX0":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1zkLW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tH08M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"binIL","../cancel/isCancel.js":"673ru","../defaults/index.js":"03cMz","../cancel/CanceledError.js":"kIfPJ","../core/AxiosHeaders.js":"77MZs","../adapters/adapters.js":"9phiH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"binIL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"9h6FO","../defaults/index.js":"03cMz","../core/AxiosHeaders.js":"77MZs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"03cMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"9h6FO","../core/AxiosError.js":"2BBBE","./transitional.js":"dyY0Q","../helpers/toFormData.js":"98O8i","../helpers/toURLEncodedForm.js":"8jYGq","../platform/index.js":"5BNuA","../helpers/formDataToJSON.js":"hW0hh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dyY0Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8jYGq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"9h6FO","./toFormData.js":"98O8i","../platform/index.js":"5BNuA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5BNuA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"7Lddy","./common/utils.js":"8wG6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Lddy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"1Xqqb","./classes/FormData.js":"e65TW","./classes/Blob.js":"lantf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Xqqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"ci3NW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e65TW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lantf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8wG6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hW0hh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"77MZs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"9h6FO","../helpers/parseHeaders.js":"dEHJn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dEHJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"673ru":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kIfPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"2BBBE","../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9phiH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"9h6FO","./http.js":"eeTX0","./xhr.js":"6iQqp","../core/AxiosError.js":"2BBBE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6iQqp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"9h6FO","./../core/settle.js":"d0QeT","./../helpers/cookies.js":"4SQWF","./../helpers/buildURL.js":"3wgcs","../core/buildFullPath.js":"8uBwh","./../helpers/isURLSameOrigin.js":"bws7C","../defaults/transitional.js":"dyY0Q","../core/AxiosError.js":"2BBBE","../cancel/CanceledError.js":"kIfPJ","../helpers/parseProtocol.js":"bDJM0","../platform/index.js":"5BNuA","../core/AxiosHeaders.js":"77MZs","../helpers/speedometer.js":"pBUWQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d0QeT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"2BBBE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4SQWF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"9h6FO","../platform/index.js":"5BNuA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uBwh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"cP0Db","../helpers/combineURLs.js":"hIV2h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cP0Db":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hIV2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bws7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"9h6FO","../platform/index.js":"5BNuA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bDJM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"pBUWQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lk3cu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? thing.toJSON() : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"9h6FO","./AxiosHeaders.js":"77MZs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"inJar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"44Btw","../core/AxiosError.js":"2BBBE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"44Btw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.7";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aAhTh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"kIfPJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Rt4vC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jd0zH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"9h6FO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6GoLd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eWncu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLAuthError", ()=>(0, _types.GraphQLAuthError));
parcelHelpers.export(exports, "GRAPHQL_AUTH_MODE", ()=>(0, _types.GRAPHQL_AUTH_MODE));
parcelHelpers.export(exports, "GraphQLAPI", ()=>(0, _graphQLAPI.GraphQLAPI));
parcelHelpers.export(exports, "GraphQLAPIClass", ()=>(0, _graphQLAPI.GraphQLAPIClass));
parcelHelpers.export(exports, "graphqlOperation", ()=>(0, _graphQLAPI.graphqlOperation));
var _graphQLAPI = require("./GraphQLAPI");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
exports.default = (0, _graphQLAPI.GraphQLAPI);

},{"./GraphQLAPI":"iO0J1","./types":"4viCr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iO0J1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphqlOperation", ()=>graphqlOperation);
parcelHelpers.export(exports, "GraphQLAPIClass", ()=>GraphQLAPIClass);
parcelHelpers.export(exports, "GraphQLAPI", ()=>GraphQLAPI);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var graphqlOperation = function(query, variables, authToken) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables,
        authToken: authToken
    };
};
/**
 * Export Cloud Logic APIs
 */ var GraphQLAPIClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(GraphQLAPIClass, _super);
    function GraphQLAPIClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphQLAPIClass.prototype.getModuleName = function() {
        return "GraphQLAPI";
    };
    /**
     * Executes a GraphQL operation
     *
     * @param options - GraphQL Options
     * @param [additionalHeaders] - headers to merge in after any `graphql_headers` set in the config
     * @returns An Observable if the query is a subscription query, else a promise of the graphql result.
     */ GraphQLAPIClass.prototype.graphql = function(options, additionalHeaders) {
        return _super.prototype.graphql.call(this, options, additionalHeaders);
    };
    return GraphQLAPIClass;
}((0, _internals.InternalGraphQLAPIClass));
var GraphQLAPI = new GraphQLAPIClass(null);
(0, _core.Amplify).register(GraphQLAPI);

},{"tslib":"fPXxt","@aws-amplify/core":"3rlh1","./internals":"fZD2p","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPd7W":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataStore", ()=>(0, _datastore.DataStore));
parcelHelpers.export(exports, "DataStoreClass", ()=>(0, _datastore.DataStoreClass));
parcelHelpers.export(exports, "initSchema", ()=>(0, _datastore.initSchema));
parcelHelpers.export(exports, "AsyncCollection", ()=>(0, _datastore.AsyncCollection));
parcelHelpers.export(exports, "AsyncItem", ()=>(0, _datastore.AsyncItem));
parcelHelpers.export(exports, "Predicates", ()=>(0, _predicates.Predicates));
parcelHelpers.export(exports, "ModelPredicateCreator", ()=>(0, _predicates.ModelPredicateCreator));
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>(0, _predicates.ModelSortPredicateCreator));
parcelHelpers.export(exports, "NAMESPACES", ()=>(0, _util.NAMESPACES));
parcelHelpers.export(exports, "utils", ()=>utils);
var _datastore = require("./datastore/datastore");
var _predicates = require("./predicates");
var _util = require("./util");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var utils = {
    USER: (0, _util.USER),
    traverseModel: (0, _util.traverseModel),
    validatePredicate: (0, _util.validatePredicate),
    isNonModelConstructor: (0, _util.isNonModelConstructor),
    isModelConstructor: (0, _util.isModelConstructor)
};

},{"./datastore/datastore":"xIgIr","./predicates":"bohgw","./util":"iFXfl","./types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"xIgIr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "syncClasses", ()=>syncClasses);
/**
 * Registers a model instance against a data source (DataStore, API, or
 * Detached/None).
 *
 * The API option is demonstrative. Lazy loading against API is not yet
 * implemented.
 *
 * @param result A model instance or array of instances
 * @param attachment A ModelAttachment data source
 * @returns passes the `result` back through after attachment
 */ parcelHelpers.export(exports, "attached", ()=>attached);
parcelHelpers.export(exports, "getAttachment", ()=>getAttachment);
parcelHelpers.export(exports, "AsyncItem", ()=>AsyncItem);
parcelHelpers.export(exports, "AsyncCollection", ()=>AsyncCollection);
parcelHelpers.export(exports, "DataStoreClass", ()=>DataStore);
parcelHelpers.export(exports, "initSchema", ()=>initSchema);
parcelHelpers.export(exports, "DataStore", ()=>instance);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _immer = require("immer");
var _uuid = require("uuid");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _authModeStrategies = require("../authModeStrategies");
var _predicates = require("../predicates");
var _storage = require("../storage/storage");
var _relationship = require("../storage/relationship");
var _sync = require("../sync");
var _types = require("../types");
var _util = require("../util");
var _next = require("../predicates/next");
var _utils = require("../sync/utils");
(0, _immer.setAutoFreeze)(true);
(0, _immer.enablePatches)();
var logger = new (0, _core.ConsoleLogger)("DataStore");
var ulid = (0, _util.monotonicUlidFactory)(Date.now());
var isNode = (0, _core.browserOrNode)().isNode;
var SETTING_SCHEMA_VERSION = "schemaVersion";
var schema;
var modelNamespaceMap = new WeakMap();
/**
 * Stores data for crafting the correct update mutation input for a model.
 *
 * - `Patch[]` - array of changed fields and metadata.
 * - `PersistentModel` - the source model, used for diffing object-type fields.
 */ var modelPatchesMap = new WeakMap();
var getModelDefinition = function(modelConstructor) {
    var namespace = modelNamespaceMap.get(modelConstructor);
    var definition = namespace ? schema.namespaces[namespace].models[modelConstructor.name] : undefined;
    return definition;
};
/**
 * Determines whether the given object is a Model Constructor that DataStore can
 * safely use to construct objects and discover related metadata.
 *
 * @param obj The object to test.
 */ var isValidModelConstructor = function(obj) {
    return (0, _util.isModelConstructor)(obj) && modelNamespaceMap.has(obj);
};
var namespaceResolver = function(modelConstructor) {
    var resolver = modelNamespaceMap.get(modelConstructor);
    if (!resolver) throw new Error("Namespace Resolver for '" + modelConstructor.name + "' not found! This is probably a bug in '@amplify-js/datastore'.");
    return resolver;
};
/**
 * Creates a predicate without any conditions that can be passed to customer
 * code to have conditions added to it.
 *
 * For example, in this query:
 *
 * ```ts
 * await DataStore.query(
 * 	Model,
 * 	item => item.field.eq('value')
 * );
 * ```
 *
 * `buildSeedPredicate(Model)` is used to create `item`, which is passed to the
 * predicate function, which in turn uses that "seed" predicate (`item`) to build
 * a predicate tree.
 *
 * @param modelConstructor The model the predicate will query.
 */ var buildSeedPredicate = function(modelConstructor) {
    if (!modelConstructor) throw new Error("Missing modelConstructor");
    var modelSchema = getModelDefinition(modelConstructor);
    if (!modelSchema) throw new Error("Missing modelSchema");
    var pks = (0, _util.extractPrimaryKeyFieldNames)(modelSchema);
    if (!pks) throw new Error("Could not determine PK");
    return (0, _next.recursivePredicateFor)({
        builder: modelConstructor,
        schema: modelSchema,
        pkField: pks
    });
};
var syncClasses;
var userClasses;
var dataStoreClasses;
var storageClasses;
/**
 * Maps a model to its related models for memoization/immutability.
 */ var modelInstanceAssociationsMap = new WeakMap();
/**
 * Describes whether and to what a model is attached for lazy loading purposes.
 */ var ModelAttachment;
(function(ModelAttachment) {
    /**
     * Model doesn't lazy load from any data source.
     *
     * Related entity properties provided at instantiation are returned
     * via the respective lazy interfaces when their properties are invoked.
     */ ModelAttachment["Detached"] = "Detached";
    /**
     * Model lazy loads from the global DataStore.
     */ ModelAttachment["DataStore"] = "DataStore";
    /**
     * Demonstrative. Not yet implemented.
     */ ModelAttachment["API"] = "API";
})(ModelAttachment || (ModelAttachment = {}));
/**
 * Tells us which data source a model is attached to (lazy loads from).
 *
 * If `Deatched`, the model's lazy properties will only ever return properties
 * from memory provided at construction time.
 */ var attachedModelInstances = new WeakMap();
function attached(result, attachment) {
    if (Array.isArray(result)) result.map(function(record) {
        return attached(record, attachment);
    });
    else result && attachedModelInstances.set(result, attachment);
    return result;
}
var getAttachment = function(instance) {
    return attachedModelInstances.has(instance) ? attachedModelInstances.get(instance) : ModelAttachment.Detached;
};
var initSchema = function(userSchema) {
    var _a;
    if (schema !== undefined) {
        console.warn("The schema has already been initialized");
        return userClasses;
    }
    logger.log("validating schema", {
        schema: userSchema
    });
    checkSchemaCodegenVersion(userSchema.codegenVersion);
    var internalUserNamespace = (0, _tslib.__assign)({
        name: (0, _util.USER)
    }, userSchema);
    logger.log("DataStore", "Init models");
    userClasses = createTypeClasses(internalUserNamespace);
    logger.log("DataStore", "Models initialized");
    var dataStoreNamespace = getNamespace();
    var storageNamespace = (0, _storage.ExclusiveStorage).getNamespace();
    var syncNamespace = (0, _sync.SyncEngine).getNamespace();
    dataStoreClasses = createTypeClasses(dataStoreNamespace);
    storageClasses = createTypeClasses(storageNamespace);
    syncClasses = createTypeClasses(syncNamespace);
    schema = {
        namespaces: (_a = {}, _a[dataStoreNamespace.name] = dataStoreNamespace, _a[internalUserNamespace.name] = internalUserNamespace, _a[storageNamespace.name] = storageNamespace, _a[syncNamespace.name] = syncNamespace, _a),
        version: userSchema.version,
        codegenVersion: userSchema.codegenVersion
    };
    Object.keys(schema.namespaces).forEach(function(namespace) {
        var e_1, _a;
        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(schema.namespaces[namespace]), 2), relations = _b[0], keys = _b[1];
        schema.namespaces[namespace].relationships = relations;
        schema.namespaces[namespace].keys = keys;
        var modelAssociations = new Map();
        Object.values(schema.namespaces[namespace].models).forEach(function(model) {
            var e_2, _a, e_3, _b;
            var connectedModels = [];
            Object.values(model.fields).filter(function(field) {
                return field.association && field.association.connectionType === "BELONGS_TO" && field.type.model !== model.name;
            }).forEach(function(field) {
                return connectedModels.push(field.type.model);
            });
            modelAssociations.set(model.name, connectedModels);
            // Precompute model info (such as pk fields) so that downstream schema consumers
            // (such as predicate builders) don't have to reach back into "DataStore" space
            // to go looking for it.
            Object.values(model.fields).forEach(function(field) {
                var relatedModel = userClasses[field.type.model];
                if ((0, _util.isModelConstructor)(relatedModel)) Object.defineProperty(field.type, "modelConstructor", {
                    get: function() {
                        var relatedModelDefinition = getModelDefinition(relatedModel);
                        if (!relatedModelDefinition) throw new Error("Could not find model definition for " + relatedModel.name);
                        return {
                            builder: relatedModel,
                            schema: relatedModelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(relatedModelDefinition)
                        };
                    }
                });
            });
            // compatibility with legacy/pre-PK codegen for lazy loading to inject
            // index fields into the model definition.
            // definition.cloudFields = { ...definition.fields };
            var indexes = schema.namespaces[namespace].relationships[model.name].indexes;
            var indexFields = new Set();
            try {
                for(var indexes_1 = (0, _tslib.__values)(indexes), indexes_1_1 = indexes_1.next(); !indexes_1_1.done; indexes_1_1 = indexes_1.next()){
                    var index = indexes_1_1.value;
                    try {
                        for(var _c = (e_3 = void 0, (0, _tslib.__values)(index[1])), _d = _c.next(); !_d.done; _d = _c.next()){
                            var indexField = _d.value;
                            indexFields.add(indexField);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (indexes_1_1 && !indexes_1_1.done && (_a = indexes_1.return)) _a.call(indexes_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            model.allFields = (0, _tslib.__assign)((0, _tslib.__assign)({}, Object.fromEntries((0, _tslib.__spread)(indexFields.values()).map(function(name) {
                return [
                    name,
                    {
                        name: name,
                        type: "ID",
                        isArray: false
                    }
                ];
            }))), model.fields);
        });
        var result = new Map();
        var count = 1000;
        while(count > 0){
            if (modelAssociations.size === 0) break;
            count--;
            if (count === 0) throw new Error("Models are not topologically sortable. Please verify your schema.");
            try {
                for(var _c = (e_1 = void 0, (0, _tslib.__values)(Array.from(modelAssociations.keys()))), _d = _c.next(); !_d.done; _d = _c.next()){
                    var modelName = _d.value;
                    var parents = modelAssociations.get(modelName);
                    if (parents === null || parents === void 0 ? void 0 : parents.every(function(x) {
                        return result.has(x);
                    })) result.set(modelName, parents);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            Array.from(result.keys()).forEach(function(x) {
                return modelAssociations.delete(x);
            });
        }
        schema.namespaces[namespace].modelTopologicalOrdering = result;
    });
    return userClasses;
};
/**
 * Throws an exception if the schema has *not* been initialized
 * by `initSchema()`.
 *
 * **To be called before trying to access schema.**
 *
 * Currently this only needs to be called in `start()` and `clear()` because
 * all other functions will call start first.
 */ var checkSchemaInitialized = function() {
    if (schema === undefined) {
        var message = "Schema is not initialized. DataStore will not function as expected. This could happen if you have multiple versions of DataStore installed. Please see https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js/#check-for-duplicate-versions";
        logger.error(message);
        throw new Error(message);
    }
};
/**
 * Throws an exception if the schema is using a codegen version that is not supported.
 *
 * Set the supported version by setting majorVersion and minorVersion
 * This functions similar to ^ version range.
 * The tested codegenVersion major version must exactly match the set majorVersion
 * The tested codegenVersion minor version must be gt or equal to the set minorVersion
 * Example: For a min supported version of 5.4.0 set majorVersion = 5 and minorVersion = 4
 *
 * This regex will not work when setting a supported range with minor version
 * of 2 or more digits.
 * i.e. minorVersion = 10 will not work
 * The regex will work for testing a codegenVersion with multi digit minor
 * versions as long as the minimum minorVersion is single digit.
 * i.e. codegenVersion = 5.30.1, majorVersion = 5, minorVersion = 4 PASSES
 *
 * @param codegenVersion schema codegenVersion
 */ var checkSchemaCodegenVersion = function(codegenVersion) {
    var majorVersion = 3;
    var minorVersion = 2;
    var isValid = false;
    try {
        var versionParts = codegenVersion.split(".");
        var _a = (0, _tslib.__read)(versionParts, 4), major = _a[0], minor = _a[1], patch = _a[2], patchrevision = _a[3];
        isValid = Number(major) === majorVersion && Number(minor) >= minorVersion;
    } catch (err) {
        console.log("Error parsing codegen version: " + codegenVersion + "\n" + err);
    }
    if (!isValid) {
        var message = "Models were generated with an unsupported version of codegen. Codegen artifacts are from " + (codegenVersion || "an unknown version") + ", whereas ^" + majorVersion + "." + minorVersion + ".0 is required. " + "Update to the latest CLI and run 'amplify codegen models'.";
        logger.error(message);
        throw new Error(message);
    }
};
var createTypeClasses = function(namespace) {
    var classes = {};
    Object.entries(namespace.models).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], modelDefinition = _b[1];
        var clazz = createModelClass(modelDefinition);
        classes[modelName] = clazz;
        modelNamespaceMap.set(clazz, namespace.name);
    });
    Object.entries(namespace.nonModels || {}).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), typeName = _b[0], typeDefinition = _b[1];
        var clazz = createNonModelClass(typeDefinition);
        classes[typeName] = clazz;
    });
    return classes;
};
/**
 * Collection of instantiated models to allow storage of metadata apart from
 * the model visible to the consuming app -- in case the app doesn't have
 * metadata fields (_version, _deleted, etc.) exposed on the model itself.
 */ var instancesMetadata = new WeakSet();
function modelInstanceCreator(modelConstructor, init) {
    instancesMetadata.add(init);
    return new modelConstructor(init);
}
var validateModelFields = function(modelDefinition) {
    return function(k, v) {
        var fieldDefinition = modelDefinition.fields[k];
        if (fieldDefinition !== undefined) {
            var type_1 = fieldDefinition.type, isRequired_1 = fieldDefinition.isRequired, isArrayNullable = fieldDefinition.isArrayNullable, name_1 = fieldDefinition.name, isArray = fieldDefinition.isArray;
            var timestamps = (0, _types.isSchemaModelWithAttributes)(modelDefinition) ? (0, _util.getTimestampFields)(modelDefinition) : {};
            var isTimestampField = !!timestamps[name_1];
            if ((!isArray && isRequired_1 || isArray && !isArrayNullable) && !isTimestampField && (v === null || v === undefined)) throw new Error("Field " + name_1 + " is required");
            if ((0, _types.isSchemaModelWithAttributes)(modelDefinition) && !(0, _util.isIdManaged)(modelDefinition)) {
                var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                if (keys.includes(k) && v === "") {
                    logger.error((0, _util.errorMessages).idEmptyString, {
                        k: k,
                        value: v
                    });
                    throw new Error((0, _util.errorMessages).idEmptyString);
                }
            }
            if ((0, _types.isGraphQLScalarType)(type_1)) {
                var jsType_1 = (0, _types.GraphQLScalarType).getJSType(type_1);
                var validateScalar_1 = (0, _types.GraphQLScalarType).getValidationFunction(type_1);
                if (type_1 === "AWSJSON") {
                    if (typeof v === jsType_1) return;
                    if (typeof v === "string") try {
                        JSON.parse(v);
                        return;
                    } catch (error) {
                        throw new Error("Field " + name_1 + " is an invalid JSON object. " + v);
                    }
                }
                if (isArray) {
                    var errorTypeText = jsType_1;
                    if (!isRequired_1) errorTypeText = jsType_1 + " | null | undefined";
                    if (!Array.isArray(v) && !isArrayNullable) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + typeof v + " received. " + v);
                    if (!(0, _util.isNullOrUndefined)(v) && v.some(function(e) {
                        return (0, _util.isNullOrUndefined)(e) ? isRequired_1 : typeof e !== jsType_1;
                    })) {
                        var elemTypes = v.map(function(e) {
                            return e === null ? "null" : typeof e;
                        }).join(",");
                        throw new Error("All elements in the " + name_1 + " array should be of type " + errorTypeText + ", [" + elemTypes + "] received. " + v);
                    }
                    if (validateScalar_1 && !(0, _util.isNullOrUndefined)(v)) {
                        var validationStatus = v.map(function(e) {
                            if (!(0, _util.isNullOrUndefined)(e)) return validateScalar_1(e);
                            else if ((0, _util.isNullOrUndefined)(e) && !isRequired_1) return true;
                            else return false;
                        });
                        if (!validationStatus.every(function(s) {
                            return s;
                        })) throw new Error("All elements in the " + name_1 + " array should be of type " + type_1 + ", validation failed for one or more elements. " + v);
                    }
                } else if (!isRequired_1 && v === undefined) return;
                else if (typeof v !== jsType_1 && v !== null) throw new Error("Field " + name_1 + " should be of type " + jsType_1 + ", " + typeof v + " received. " + v);
                else if (!(0, _util.isNullOrUndefined)(v) && validateScalar_1 && !validateScalar_1(v) // TODO: why never, TS ... why ...
                ) throw new Error("Field " + name_1 + " should be of type " + type_1 + ", validation failed. " + v);
            } else if ((0, _types.isNonModelFieldType)(type_1)) // do not check non model fields if undefined or null
            {
                if (!(0, _util.isNullOrUndefined)(v)) {
                    var subNonModelDefinition_1 = schema.namespaces.user.nonModels[type_1.nonModel];
                    var modelValidator_1 = validateModelFields(subNonModelDefinition_1);
                    if (isArray) {
                        var errorTypeText = type_1.nonModel;
                        if (!isRequired_1) errorTypeText = type_1.nonModel + " | null | undefined";
                        if (!Array.isArray(v)) throw new Error("Field " + name_1 + " should be of type [" + errorTypeText + "], " + typeof v + " received. " + v);
                        v.forEach(function(item) {
                            if ((0, _util.isNullOrUndefined)(item) && isRequired_1 || typeof item !== "object" && typeof item !== "undefined") throw new Error("All elements in the " + name_1 + " array should be of type " + type_1.nonModel + ", [" + typeof item + "] received. " + item);
                            if (!(0, _util.isNullOrUndefined)(item)) Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                                modelValidator_1(subKey, item[subKey]);
                            });
                        });
                    } else {
                        if (typeof v !== "object") throw new Error("Field " + name_1 + " should be of type " + type_1.nonModel + ", " + typeof v + " recieved. " + v);
                        Object.keys(subNonModelDefinition_1.fields).forEach(function(subKey) {
                            modelValidator_1(subKey, v[subKey]);
                        });
                    }
                }
            }
        }
    };
};
var castInstanceType = function(modelDefinition, k, v) {
    var _a = modelDefinition.fields[k] || {}, isArray = _a.isArray, type = _a.type;
    // attempt to parse stringified JSON
    if (typeof v === "string" && (isArray || type === "AWSJSON" || (0, _types.isNonModelFieldType)(type) || (0, _types.isModelFieldType)(type))) try {
        return JSON.parse(v);
    } catch (_b) {
    // if JSON is invalid, don't throw and let modelValidator handle it
    }
    // cast from numeric representation of boolean to JS boolean
    if (typeof v === "number" && type === "Boolean") return Boolean(v);
    return v;
};
/**
 * Records the patches (as if against an empty object) used to initialize
 * an instance of a Model. This can be used for determining which fields to
 * send to the cloud durnig a CREATE mutation.
 */ var initPatches = new WeakMap();
/**
 * Attempts to apply type-aware, casted field values from a given `init`
 * object to the given `draft`.
 *
 * @param init The initialization object to extract field values from.
 * @param modelDefinition The definition describing the target object shape.
 * @param draft The draft to apply field values to.
 */ var initializeInstance = function(init, modelDefinition, draft) {
    var modelValidator = validateModelFields(modelDefinition);
    Object.entries(init).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        var parsedValue = castInstanceType(modelDefinition, k, v);
        modelValidator(k, parsedValue);
        draft[k] = parsedValue;
    });
};
/**
 * Updates a draft to standardize its customer-defined fields so that they are
 * consistent with the data as it would look after having been synchronized from
 * Cloud storage.
 *
 * The exceptions to this are:
 *
 * 1. Non-schema/Internal [sync] metadata fields.
 * 2. Cloud-managed fields, which are `null` until set by cloud storage.
 *
 * This function should be expanded if/when deviations between canonical Cloud
 * storage data and locally managed data are found. For now, the known areas
 * that require normalization are:
 *
 * 1. Ensuring all non-metadata fields are *defined*. (I.e., turn `undefined` -> `null`.)
 *
 * @param modelDefinition Definition for the draft. Used to discover all fields.
 * @param draft The instance draft to apply normalizations to.
 */ var normalize = function(modelDefinition, draft) {
    var e_4, _a;
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(modelDefinition.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
            var k = _c.value;
            if (draft[k] === undefined) draft[k] = null;
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
};
var createModelClass = function(modelDefinition) {
    var e_5, _a;
    var clazz = /** @class */ function() {
        function Model(init) {
            // we create a base instance first so we can distinguish which fields were explicitly
            // set by customer code versus those set by normalization. only those fields
            // which are explicitly set by customers should be part of create mutations.
            var patches = [];
            var baseInstance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, modelDefinition, draft);
                // model is initialized inside a DataStore component (e.g. by Sync Engine, Storage Engine, etc.)
                var isInternallyInitialized = instancesMetadata.has(init);
                var modelInstanceMetadata = isInternallyInitialized ? init : {};
                var _id = modelInstanceMetadata.id;
                if ((0, _util.isIdManaged)(modelDefinition)) {
                    var isInternalModel = _id !== null && _id !== undefined;
                    var id = isInternalModel ? _id : modelDefinition.syncable ? (0, _uuid.v4)() : ulid();
                    draft.id = id;
                } else if ((0, _util.isIdOptionallyManaged)(modelDefinition)) // only auto-populate if the id was not provided
                draft.id = draft.id || (0, _uuid.v4)();
                if (!isInternallyInitialized) checkReadOnlyPropertyOnCreate(draft, modelDefinition);
                var _version = modelInstanceMetadata._version, _lastChangedAt = modelInstanceMetadata._lastChangedAt, _deleted = modelInstanceMetadata._deleted;
                if (modelDefinition.syncable) {
                    draft._version = _version;
                    draft._lastChangedAt = _lastChangedAt;
                    draft._deleted = _deleted;
                }
            }, function(p) {
                return patches = p;
            });
            // now that we have a list of patches that encapsulate the explicit, customer-provided
            // fields, we can normalize. patches from normalization are ignored, because the changes
            // are only create to provide a consistent view of the data for fields pre/post sync
            // where possible. (not all fields can be normalized pre-sync, because they're generally
            // "cloud managed" fields, like createdAt and updatedAt.)
            var normalized = (0, _immer.produce)(baseInstance, function(draft) {
                return normalize(modelDefinition, draft);
            });
            initPatches.set(normalized, patches);
            return normalized;
        }
        Model.copyOf = function(source, fn) {
            var modelConstructor = Object.getPrototypeOf(source || {}).constructor;
            if (!isValidModelConstructor(modelConstructor)) {
                var msg = "The source object is not a valid model";
                logger.error(msg, {
                    source: source
                });
                throw new Error(msg);
            }
            var patches = [];
            var model = (0, _immer.produce)(source, function(draft) {
                fn(draft);
                var keyNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                // Keys are immutable
                keyNames.forEach(function(key) {
                    if (draft[key] !== source[key]) logger.warn("copyOf() does not update PK fields. The '" + key + "' update is being ignored.", {
                        source: source
                    });
                    draft[key] = source[key];
                });
                var modelValidator = validateModelFields(modelDefinition);
                Object.entries(draft).forEach(function(_a) {
                    var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                    var parsedValue = castInstanceType(modelDefinition, k, v);
                    modelValidator(k, parsedValue);
                });
                normalize(modelDefinition, draft);
            }, function(p) {
                return patches = p;
            });
            var hasExistingPatches = modelPatchesMap.has(source);
            if (patches.length || hasExistingPatches) {
                if (hasExistingPatches) {
                    var _a = (0, _tslib.__read)(modelPatchesMap.get(source), 2), existingPatches = _a[0], existingSource = _a[1];
                    var mergedPatches = (0, _util.mergePatches)(existingSource, existingPatches, patches);
                    modelPatchesMap.set(model, [
                        mergedPatches,
                        existingSource
                    ]);
                    checkReadOnlyPropertyOnUpdate(mergedPatches, modelDefinition);
                } else {
                    modelPatchesMap.set(model, [
                        patches,
                        source
                    ]);
                    checkReadOnlyPropertyOnUpdate(patches, modelDefinition);
                }
            } else // always register patches when performing a copyOf, even if the
            // patches list is empty. this allows `save()` to recognize when an
            // instance is the result of a `copyOf()`. without more significant
            // refactoring, this is the only way for `save()` to know which
            // diffs (patches) are relevant for `storage` to use in building
            // the list of "changed" fields for mutations.
            modelPatchesMap.set(model, [
                [],
                source
            ]);
            return attached(model, ModelAttachment.DataStore);
        };
        // "private" method (that's hidden via `Setting`) for `withSSRContext` to use
        // to gain access to `modelInstanceCreator` and `clazz` for persisting IDs from server to client.
        Model.fromJSON = function(json) {
            var _this = this;
            if (Array.isArray(json)) return json.map(function(init) {
                return _this.fromJSON(init);
            });
            var instance = modelInstanceCreator(clazz, json);
            var modelValidator = validateModelFields(modelDefinition);
            Object.entries(instance).forEach(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
                modelValidator(k, v);
            });
            return attached(instance, ModelAttachment.DataStore);
        };
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: modelDefinition.name
    });
    // Add getters/setters for relationship fields.
    //  getter - for lazy loading
    //  setter - for FK management
    var allModelRelationships = (0, _relationship.ModelRelationship).allFrom({
        builder: clazz,
        schema: modelDefinition,
        pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
    });
    var _loop_1 = function(relationship) {
        var field = relationship.field;
        Object.defineProperty(clazz.prototype, modelDefinition.fields[field].name, {
            set: function(model) {
                if (!(typeof model === "object" || typeof model === "undefined")) return;
                // if model is undefined or null, the connection should be removed
                if (model) // Avoid validation error when processing AppSync response with nested
                // selection set. Nested entitites lack version field and can not be validated
                // TODO: explore a more reliable method to solve this
                {
                    if (model.hasOwnProperty("_version")) {
                        var modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                        if (!isValidModelConstructor(modelConstructor)) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not a valid instance of a model";
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                        if (modelConstructor.name.toLowerCase() !== relationship.remoteModelConstructor.name.toLowerCase()) {
                            var msg = "Value passed to " + modelDefinition.name + "." + field + " is not an instance of " + relationship.remoteModelConstructor.name;
                            logger.error(msg, {
                                model: model
                            });
                            throw new Error(msg);
                        }
                    }
                }
                // if the relationship can be managed automagically, set the FK's
                if (relationship.isComplete) {
                    for(var i = 0; i < relationship.localJoinFields.length; i++)this[relationship.localJoinFields[i]] = model === null || model === void 0 ? void 0 : model[relationship.remoteJoinFields[i]];
                    var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                    instanceMemos[field] = model || undefined;
                }
            },
            get: function() {
                var _this = this;
                /**
                 * Bucket for holding related models instances specific to `this` instance.
                 */ var instanceMemos = modelInstanceAssociationsMap.has(this) ? modelInstanceAssociationsMap.get(this) : modelInstanceAssociationsMap.set(this, {}).get(this);
                // if the memos already has a result for this field, we'll use it.
                // there is no "cache" invalidation of any kind; memos are permanent to
                // keep an immutable perception of the instance.
                if (!instanceMemos.hasOwnProperty(field)) {
                    // before we populate the memo, we need to know where to look for relatives.
                    // today, this only supports DataStore. Models aren't managed elsewhere in Amplify.
                    if (getAttachment(this) === ModelAttachment.DataStore) {
                        // when we fetch the results using a query constructed under the guidance
                        // of the relationship metadata, we DO NOT AWAIT resolution. we want to
                        // drop the promise into the memo's synchronously, eliminating the chance
                        // for a race.
                        var resultPromise = instance.query(relationship.remoteModelConstructor, function(base) {
                            return base.and(function(q) {
                                return relationship.remoteJoinFields.map(function(field, index) {
                                    // TODO: anything we can use instead of `any` here?
                                    return q[field].eq(_this[relationship.localJoinFields[index]]);
                                });
                            });
                        });
                        // results in hand, how we return them to the caller depends on the relationship type.
                        if (relationship.type === "HAS_MANY") // collections should support async iteration, even though we don't
                        // leverage it fully [yet].
                        instanceMemos[field] = new AsyncCollection(resultPromise);
                        else // non-collections should only ever return 1 value *or nothing*.
                        // if we have more than 1 record, something's amiss. it's not our job
                        // pick a result for the customer. it's our job to say "something's wrong."
                        instanceMemos[field] = resultPromise.then(function(rows) {
                            if (rows.length > 1) {
                                // should never happen for a HAS_ONE or BELONGS_TO.
                                var err = new Error("\n									Data integrity error.\n									Too many records found for a HAS_ONE/BELONGS_TO field '" + modelDefinition.name + "." + field + "'\n								");
                                console.error(err);
                                throw err;
                            } else return rows[0];
                        });
                    } else if (getAttachment(this) === ModelAttachment.API) throw new Error("Lazy loading from API is not yet supported!");
                    else {
                        if (relationship.type === "HAS_MANY") return new AsyncCollection([]);
                        else return Promise.resolve(undefined);
                    }
                }
                return instanceMemos[field];
            }
        });
    };
    try {
        for(var allModelRelationships_1 = (0, _tslib.__values)(allModelRelationships), allModelRelationships_1_1 = allModelRelationships_1.next(); !allModelRelationships_1_1.done; allModelRelationships_1_1 = allModelRelationships_1.next()){
            var relationship = allModelRelationships_1_1.value;
            _loop_1(relationship);
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (allModelRelationships_1_1 && !allModelRelationships_1_1.done && (_a = allModelRelationships_1.return)) _a.call(allModelRelationships_1);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return clazz;
};
/**
 * An eventually loaded related model instance.
 */ var AsyncItem = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncItem, _super);
    function AsyncItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AsyncItem;
}(Promise);
/**
 * A collection of related model instances.
 *
 * This collection can be async-iterated or turned directly into an array using `toArray()`.
 */ var AsyncCollection = /** @class */ function() {
    function AsyncCollection(values) {
        this.values = values;
    }
    /**
     * Facilitates async iteration.
     *
     * ```ts
     * for await (const item of collection) {
     *   handle(item)
     * }
     * ```
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of
     */ AsyncCollection.prototype[Symbol.asyncIterator] = function() {
        var _this = this;
        var values;
        var index = 0;
        return {
            next: function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var result;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!values) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.values
                                ];
                            case 1:
                                values = _a.sent();
                                _a.label = 2;
                            case 2:
                                if (index < values.length) {
                                    result = {
                                        value: values[index],
                                        done: false
                                    };
                                    index++;
                                    return [
                                        2 /*return*/ ,
                                        result
                                    ];
                                }
                                return [
                                    2 /*return*/ ,
                                    {
                                        value: null,
                                        done: true
                                    }
                                ];
                        }
                    });
                });
            }
        };
    };
    /**
     * Turns the collection into an array, up to the amount specified in `max` param.
     *
     * ```ts
     * const all = await collection.toArray();
     * const first100 = await collection.toArray({max: 100});
     * ```
     */ AsyncCollection.prototype.toArray = function(_a) {
        var _b = (_a === void 0 ? {} : _a).max, max = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b;
        var e_6, _c;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var output, i, _d, _e, element, e_6_1;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        output = [];
                        i = 0;
                        _f.label = 1;
                    case 1:
                        _f.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        _d = (0, _tslib.__asyncValues)(this);
                        _f.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _d.next()
                        ];
                    case 3:
                        if (!(_e = _f.sent(), !_e.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        element = _e.value;
                        if (i < max) {
                            output.push(element);
                            i++;
                        } else return [
                            3 /*break*/ ,
                            5
                        ];
                        _f.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_6_1 = _f.sent();
                        e_6 = {
                            error: e_6_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _f.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(_e && !_e.done && (_c = _d.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(_d)
                        ];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_6) throw e_6.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        return [
                            2 /*return*/ ,
                            output
                        ];
                }
            });
        });
    };
    return AsyncCollection;
}();
var checkReadOnlyPropertyOnCreate = function(draft, modelDefinition) {
    var modelKeys = Object.keys(draft);
    var fields = modelDefinition.fields;
    modelKeys.forEach(function(key) {
        if (fields[key] && fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var checkReadOnlyPropertyOnUpdate = function(patches, modelDefinition) {
    var patchArray = patches.map(function(p) {
        return [
            p.path[0],
            p.value
        ];
    });
    var fields = modelDefinition.fields;
    patchArray.forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], val = _b[1];
        if (!val || !fields[key]) return;
        if (fields[key].isReadOnly) throw new Error(key + " is read-only.");
    });
};
var createNonModelClass = function(typeDefinition) {
    var clazz = /** @class */ function() {
        function Model(init) {
            var instance = (0, _immer.produce)(this, function(draft) {
                initializeInstance(init, typeDefinition, draft);
            });
            return instance;
        }
        return Model;
    }();
    clazz[0, _immer.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: typeDefinition.name
    });
    (0, _util.registerNonModelClass)(clazz);
    return clazz;
};
function isQueryOne(obj) {
    return typeof obj === "string";
}
function defaultConflictHandler(conflictData) {
    var localModel = conflictData.localModel, modelConstructor = conflictData.modelConstructor, remoteModel = conflictData.remoteModel;
    var _version = remoteModel._version;
    return modelInstanceCreator(modelConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, localModel), {
        _version: _version
    }));
}
function defaultErrorHandler(error) {
    logger.warn(error);
}
function getModelConstructorByModelName(namespaceName, modelName) {
    var result;
    switch(namespaceName){
        case 0, _util.DATASTORE:
            result = dataStoreClasses[modelName];
            break;
        case 0, _util.USER:
            result = userClasses[modelName];
            break;
        case 0, _util.SYNC:
            result = syncClasses[modelName];
            break;
        case 0, _util.STORAGE:
            result = storageClasses[modelName];
            break;
        default:
            throw new Error("Invalid namespace: " + namespaceName);
    }
    if (isValidModelConstructor(result)) return result;
    else {
        var msg = "Model name is not valid for namespace. modelName: " + modelName + ", namespace: " + namespaceName;
        logger.error(msg);
        throw new Error(msg);
    }
}
/**
 * Queries the DataStore metadata tables to see if they are the expected
 * version. If not, clobbers the whole DB. If so, leaves them alone.
 * Otherwise, simply writes the schema version.
 *
 * SIDE EFFECT:
 * 1. Creates a transaction
 * 1. Updates data.
 *
 * @param storage Storage adapter containing the metadata.
 * @param version The expected schema version.
 */ function checkSchemaVersion(storage, version) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var Setting, modelDefinition;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    Setting = dataStoreClasses.Setting;
                    modelDefinition = schema.namespaces[0, _util.DATASTORE].models.Setting;
                    return [
                        4 /*yield*/ ,
                        storage.runExclusive(function(s) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var _a, schemaVersionSetting, storedValue;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                s.query(Setting, (0, _predicates.ModelPredicateCreator).createFromAST(modelDefinition, {
                                                    and: {
                                                        key: {
                                                            eq: SETTING_SCHEMA_VERSION
                                                        }
                                                    }
                                                }), {
                                                    page: 0,
                                                    limit: 1
                                                })
                                            ];
                                        case 1:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), schemaVersionSetting = _a[0];
                                            if (!(schemaVersionSetting !== undefined && schemaVersionSetting.value !== undefined)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            storedValue = JSON.parse(schemaVersionSetting.value);
                                            if (!(storedValue !== version)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                s.clear(false)
                                            ];
                                        case 2:
                                            _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 4:
                                            return [
                                                4 /*yield*/ ,
                                                s.save(modelInstanceCreator(Setting, {
                                                    key: SETTING_SCHEMA_VERSION,
                                                    value: JSON.stringify(version)
                                                }))
                                            ];
                                        case 5:
                                            _b.sent();
                                            _b.label = 6;
                                        case 6:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var syncSubscription;
function getNamespace() {
    var namespace = {
        name: (0, _util.DATASTORE),
        relationships: {},
        enums: {},
        nonModels: {},
        models: {
            Setting: {
                name: "Setting",
                pluralName: "Settings",
                syncable: false,
                fields: {
                    id: {
                        name: "id",
                        type: "ID",
                        isRequired: true,
                        isArray: false
                    },
                    key: {
                        name: "key",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    },
                    value: {
                        name: "value",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    }
                }
            }
        }
    };
    return namespace;
}
var DataStoreState;
(function(DataStoreState) {
    DataStoreState["NotRunning"] = "Not Running";
    DataStoreState["Starting"] = "Starting";
    DataStoreState["Running"] = "Running";
    DataStoreState["Stopping"] = "Stopping";
    DataStoreState["Clearing"] = "Clearing";
})(DataStoreState || (DataStoreState = {}));
// TODO: How can we get rid of the non-null assertions?
// https://github.com/aws-amplify/amplify-js/pull/10477/files#r1007363485
var DataStore = /** @class */ function() {
    function DataStore() {
        var _this = this;
        // reference to configured category instances. Used for preserving SSR context
        this.Auth = (0, _auth.Auth);
        this.InternalAPI = (0, _internals.InternalAPI);
        this.Cache = (0, _cache.Cache);
        // Non-null assertions (bang operator) have been added to most of these properties
        // to make TS happy. These properties are all expected to be set immediately after
        // construction.
        // TODO: Refactor to use proper DI if possible. If not possible, change these to
        // optionals and implement conditional checks throughout. Rinse/repeat on all
        // sync engine processors, storage engine, adapters, etc..
        this.amplifyConfig = {};
        this.syncPredicates = new WeakMap();
        // object that gets passed to descendent classes. Allows us to pass these down by reference
        this.amplifyContext = {
            Auth: this.Auth,
            InternalAPI: this.InternalAPI,
            Cache: this.Cache
        };
        /**
         * **IMPORTANT!**
         *
         * Accumulator for background things that can **and MUST** be called when
         * DataStore stops.
         *
         * These jobs **MUST** be *idempotent promises* that resolve ONLY
         * once the intended jobs are completely finished and/or otherwise destroyed
         * and cleaned up with ZERO outstanding:
         *
         * 1. side effects (e.g., state changes)
         * 1. callbacks
         * 1. subscriptions
         * 1. calls to storage
         * 1. *etc.*
         *
         * Methods that create pending promises, subscriptions, callbacks, or any
         * type of side effect **MUST** be registered with the manager. And, a new
         * manager must be created after each `exit()`.
         *
         * Failure to comply will put DataStore into a highly unpredictable state
         * when it needs to stop or clear -- which occurs when restarting with new
         * sync expressions, during testing, and potentially during app code
         * recovery handling, etc..
         *
         * It is up to the discretion of each disposer whether to wait for job
         * completion or to cancel operations and issue failures *as long as the
         * disposer returns in a reasonable amount of time.*
         *
         * (Reasonable = *seconds*, not minutes.)
         */ this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        /**
         * Indicates what state DataStore is in.
         *
         * Not [yet?] used for actual state management; but for messaging
         * when errors occur, to help troubleshoot.
         */ this.state = DataStoreState.NotRunning;
        /**
         * If not already done:
         * 1. Attaches and initializes storage.
         * 2. Loads the schema and records metadata.
         * 3. If `this.amplifyConfig.aws_appsync_graphqlEndpoint` contains a URL,
         * attaches a sync engine, starts it, and subscribes.
         */ this.start = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var aws_appsync_graphqlEndpoint, _a, fullSyncIntervalInMilliseconds;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            this.state = DataStoreState.Starting;
                                            if (!(this.initialized === undefined)) return [
                                                3 /*break*/ ,
                                                1
                                            ];
                                            logger.debug("Starting DataStore");
                                            this.initialized = new Promise(function(res, rej) {
                                                _this.initResolve = res;
                                                _this.initReject = rej;
                                            });
                                            return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                        case 1:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 2:
                                            _b.sent();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        case 3:
                                            this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.init()
                                            ];
                                        case 4:
                                            _b.sent();
                                            checkSchemaInitialized();
                                            return [
                                                4 /*yield*/ ,
                                                checkSchemaVersion(this.storage, schema.version)
                                            ];
                                        case 5:
                                            _b.sent();
                                            aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                                            if (!aws_appsync_graphqlEndpoint) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            logger.debug("GraphQL endpoint available", aws_appsync_graphqlEndpoint);
                                            _a = this;
                                            return [
                                                4 /*yield*/ ,
                                                this.processSyncExpressions()
                                            ];
                                        case 6:
                                            _a.syncPredicates = _b.sent();
                                            this.sync = new (0, _sync.SyncEngine)(schema, namespaceResolver, syncClasses, userClasses, this.storage, modelInstanceCreator, this.conflictHandler, this.errorHandler, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, this.amplifyContext, this.connectivityMonitor);
                                            fullSyncIntervalInMilliseconds = this.fullSyncInterval * 60000;
                                            syncSubscription = this.sync.start({
                                                fullSyncInterval: fullSyncIntervalInMilliseconds
                                            }).subscribe({
                                                next: function(_a) {
                                                    var type = _a.type, data = _a.data;
                                                    // In Node, we need to wait for queries to be synced to prevent returning empty arrays.
                                                    // In the Browser, we can begin returning data once subscriptions are in place.
                                                    var readyType = isNode ? (0, _sync.ControlMessage).SYNC_ENGINE_SYNC_QUERIES_READY : (0, _sync.ControlMessage).SYNC_ENGINE_STORAGE_SUBSCRIBED;
                                                    if (type === readyType) _this.initResolve();
                                                    (0, _core.Hub).dispatch("datastore", {
                                                        event: type,
                                                        data: data
                                                    });
                                                },
                                                error: function(err) {
                                                    logger.warn("Sync error", err);
                                                    _this.initReject();
                                                }
                                            });
                                            return [
                                                3 /*break*/ ,
                                                8
                                            ];
                                        case 7:
                                            logger.warn("Data won't be synchronized. No GraphQL endpoint configured. Did you forget `Amplify.configure(awsconfig)`?", {
                                                config: this.amplifyConfig
                                            });
                                            this.initResolve();
                                            _b.label = 8;
                                        case 8:
                                            return [
                                                4 /*yield*/ ,
                                                this.initialized
                                            ];
                                        case 9:
                                            _b.sent();
                                            this.state = DataStoreState.Running;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }, "datastore start").catch(this.handleAddProcError("DataStore.start()"))
                    ];
                });
            });
        };
        this.query = function(modelConstructor, identifierOrCriteria, paginationProducer) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var result, msg, modelDefinition, pagination, keyFields, msg, predicate, predicate, seedPredicate, predicate, returnOne;
                                var _a;
                                var _b;
                                return (0, _tslib.__generator)(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _c.sent();
                                            if (!this.storage) throw new Error("No storage to query");
                                            //#region Input validation
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Constructor is not for a valid model";
                                                logger.error(msg, {
                                                    modelConstructor: modelConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (typeof identifierOrCriteria === "string") {
                                                if (paginationProducer !== undefined) logger.warn("Pagination is ignored when querying by id");
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Invalid model definition provided!");
                                            pagination = this.processPagination(modelDefinition, paginationProducer);
                                            keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                            if (!isQueryOne(identifierOrCriteria)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            if (keyFields.length > 1) {
                                                msg = (0, _util.errorMessages).queryByPkWithCompositeKeyPresent;
                                                logger.error(msg, {
                                                    keyFields: keyFields
                                                });
                                                throw new Error(msg);
                                            }
                                            predicate = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_a = {}, _a[keyFields[0]] = identifierOrCriteria, _a));
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 2:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 3:
                                            if (!(0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            predicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.query(modelConstructor, predicate, pagination)
                                            ];
                                        case 4:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 5:
                                            if (!(!identifierOrCriteria || (0, _predicates.isPredicatesAll)(identifierOrCriteria))) return [
                                                3 /*break*/ ,
                                                7
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                (_b = this.storage) === null || _b === void 0 ? void 0 : _b.query(modelConstructor, undefined, pagination)
                                            ];
                                        case 6:
                                            result = _c.sent();
                                            return [
                                                3 /*break*/ ,
                                                9
                                            ];
                                        case 7:
                                            seedPredicate = (0, _next.recursivePredicateFor)({
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            });
                                            predicate = (0, _next.internals)(identifierOrCriteria(seedPredicate));
                                            return [
                                                4 /*yield*/ ,
                                                predicate.fetch(this.storage)
                                            ];
                                        case 8:
                                            result = _c.sent();
                                            result = (0, _util.inMemoryPagination)(result, pagination);
                                            _c.label = 9;
                                        case 9:
                                            returnOne = isQueryOne(identifierOrCriteria) || (0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition);
                                            return [
                                                2 /*return*/ ,
                                                attached(returnOne ? result[0] : result, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore query").catch(this.handleAddProcError("DataStore.query()"))
                    ];
                });
            });
        };
        this.save = function(model, condition) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var updatedPatchesTuple, initPatchesTuple, patchesTuple, modelConstructor, msg, modelDefinition, modelMeta, producedCondition, _a, savedModel;
                                var _this = this;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _b.sent();
                                            if (!this.storage) throw new Error("No storage to save to");
                                            updatedPatchesTuple = modelPatchesMap.get(model);
                                            initPatchesTuple = initPatches.has(model) ? [
                                                initPatches.get(model),
                                                {}
                                            ] : undefined;
                                            patchesTuple = updatedPatchesTuple || initPatchesTuple;
                                            modelConstructor = model ? model.constructor : undefined;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Object is not an instance of a valid model";
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Model Definition could not be found for model");
                                            modelMeta = {
                                                builder: modelConstructor,
                                                schema: modelDefinition,
                                                pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                            };
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var nonHasManyRelationships, nonHasManyRelationships_1, nonHasManyRelationships_1_1, relationship, queryObject, related, e_7_1;
                                                        var e_7, _a;
                                                        var _b;
                                                        return (0, _tslib.__generator)(this, function(_c) {
                                                            switch(_c.label){
                                                                case 0:
                                                                    nonHasManyRelationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                                                                        return r.type === "BELONGS_TO";
                                                                    });
                                                                    _c.label = 1;
                                                                case 1:
                                                                    _c.trys.push([
                                                                        1,
                                                                        6,
                                                                        7,
                                                                        8
                                                                    ]);
                                                                    nonHasManyRelationships_1 = (0, _tslib.__values)(nonHasManyRelationships), nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    _c.label = 2;
                                                                case 2:
                                                                    if (!!nonHasManyRelationships_1_1.done) return [
                                                                        3 /*break*/ ,
                                                                        5
                                                                    ];
                                                                    relationship = nonHasManyRelationships_1_1.value;
                                                                    queryObject = relationship.createRemoteQueryObject(model);
                                                                    if (!(queryObject !== null)) return [
                                                                        3 /*break*/ ,
                                                                        4
                                                                    ];
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.query(relationship.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(relationship.remoteDefinition, queryObject))
                                                                    ];
                                                                case 3:
                                                                    related = _c.sent();
                                                                    if (related.length === 0) throw new Error([
                                                                        "Data integrity error. You tried to save a " + modelDefinition.name + " (" + JSON.stringify(model) + ")",
                                                                        'but the instance assigned to the "' + relationship.field + '" property',
                                                                        "does not exist in the local database. If you're trying to create the related",
                                                                        '"' + ((_b = relationship.remoteDefinition) === null || _b === void 0 ? void 0 : _b.name) + '", you must save it independently first.'
                                                                    ].join(" "));
                                                                    _c.label = 4;
                                                                case 4:
                                                                    nonHasManyRelationships_1_1 = nonHasManyRelationships_1.next();
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        2
                                                                    ];
                                                                case 5:
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 6:
                                                                    e_7_1 = _c.sent();
                                                                    e_7 = {
                                                                        error: e_7_1
                                                                    };
                                                                    return [
                                                                        3 /*break*/ ,
                                                                        8
                                                                    ];
                                                                case 7:
                                                                    try {
                                                                        if (nonHasManyRelationships_1_1 && !nonHasManyRelationships_1_1.done && (_a = nonHasManyRelationships_1.return)) _a.call(nonHasManyRelationships_1);
                                                                    } finally{
                                                                        if (e_7) throw e_7.error;
                                                                    }
                                                                    return [
                                                                        7 /*endfinally*/ 
                                                                    ];
                                                                case 8:
                                                                    return [
                                                                        2 /*return*/ 
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _b.sent();
                                            producedCondition = condition ? (0, _next.internals)(condition((0, _next.predicateFor)(modelMeta))).toStoragePredicate() : undefined;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.runExclusive(function(s) {
                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                        var saved;
                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        s.save(model, producedCondition, undefined, patchesTuple)
                                                                    ];
                                                                case 1:
                                                                    saved = _a.sent();
                                                                    return [
                                                                        2 /*return*/ ,
                                                                        s.query(modelConstructor, (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model))
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                })
                                            ];
                                        case 3:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _b.sent(),
                                                1
                                            ]), savedModel = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(savedModel, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore save").catch(this.handleAddProcError("DataStore.save()"))
                    ];
                });
            });
        };
        this.setConflictHandler = function(config) {
            var configDataStore = config.DataStore;
            var conflictHandlerIsDefault = function() {
                return _this.conflictHandler === defaultConflictHandler;
            };
            if (configDataStore && configDataStore.conflictHandler) return configDataStore.conflictHandler;
            if (conflictHandlerIsDefault() && config.conflictHandler) return config.conflictHandler;
            return _this.conflictHandler || defaultConflictHandler;
        };
        this.setErrorHandler = function(config) {
            var configDataStore = config.DataStore;
            var errorHandlerIsDefault = function() {
                return _this.errorHandler === defaultErrorHandler;
            };
            if (configDataStore && configDataStore.errorHandler) return configDataStore.errorHandler;
            if (errorHandlerIsDefault() && config.errorHandler) return config.errorHandler;
            return _this.errorHandler || defaultErrorHandler;
        };
        this.delete = function(modelOrConstructor, identifierOrCriteria) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.runningProcesses.add(function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var condition, msg, modelConstructor, msg, modelDefinition, keyFields, msg, msg, _a, deleted, model, modelConstructor, msg, modelDefinition, pkPredicate, msg, _b, _c, deleted;
                                var _d;
                                return (0, _tslib.__generator)(this, function(_e) {
                                    switch(_e.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.start()
                                            ];
                                        case 1:
                                            _e.sent();
                                            if (!this.storage) throw new Error("No storage to delete from");
                                            if (!modelOrConstructor) {
                                                msg = "Model or Model Constructor required";
                                                logger.error(msg, {
                                                    modelOrConstructor: modelOrConstructor
                                                });
                                                throw new Error(msg);
                                            }
                                            if (!isValidModelConstructor(modelOrConstructor)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            modelConstructor = modelOrConstructor;
                                            if (!identifierOrCriteria) {
                                                msg = "Id to delete or criteria required. Do you want to delete all? Pass Predicates.ALL";
                                                logger.error(msg, {
                                                    identifierOrCriteria: identifierOrCriteria
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Could not find model definition for modelConstructor.");
                                            if (typeof identifierOrCriteria === "string") {
                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                if (keyFields.length > 1) {
                                                    msg = (0, _util.errorMessages).deleteByPkWithCompositeKeyPresent;
                                                    logger.error(msg, {
                                                        keyFields: keyFields
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(modelDefinition, (_d = {}, _d[keyFields[0]] = identifierOrCriteria, _d));
                                            } else {
                                                if ((0, _types.isIdentifierObject)(identifierOrCriteria, modelDefinition)) condition = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, identifierOrCriteria);
                                                else condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                if (!condition || !(0, _predicates.ModelPredicateCreator).isValidPredicate(condition)) {
                                                    msg = "Criteria required. Do you want to delete all? Pass Predicates.ALL";
                                                    logger.error(msg, {
                                                        condition: condition
                                                    });
                                                    throw new Error(msg);
                                                }
                                            }
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(modelConstructor, condition)
                                            ];
                                        case 2:
                                            _a = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), deleted = _a[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                        case 3:
                                            model = modelOrConstructor;
                                            modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                                            if (!isValidModelConstructor(modelConstructor)) {
                                                msg = "Object is not an instance of a valid model";
                                                logger.error(msg, {
                                                    model: model
                                                });
                                                throw new Error(msg);
                                            }
                                            modelDefinition = getModelDefinition(modelConstructor);
                                            if (!modelDefinition) throw new Error("Could not find model definition for modelConstructor.");
                                            pkPredicate = (0, _predicates.ModelPredicateCreator).createForPk(modelDefinition, model);
                                            if (identifierOrCriteria) {
                                                if (typeof identifierOrCriteria !== "function") {
                                                    msg = "Invalid criteria";
                                                    logger.error(msg, {
                                                        identifierOrCriteria: identifierOrCriteria
                                                    });
                                                    throw new Error(msg);
                                                }
                                                condition = (0, _next.internals)(identifierOrCriteria((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                            } else condition = pkPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.delete(model, condition)
                                            ];
                                        case 4:
                                            _b = (0, _tslib.__read).apply(void 0, [
                                                _e.sent(),
                                                1
                                            ]), _c = (0, _tslib.__read)(_b[0], 1), deleted = _c[0];
                                            return [
                                                2 /*return*/ ,
                                                attached(deleted, ModelAttachment.DataStore)
                                            ];
                                    }
                                });
                            });
                        }, "datastore delete").catch(this.handleAddProcError("DataStore.delete()"))
                    ];
                });
            });
        };
        this.observe = function(modelOrConstructor, identifierOrCriteria) {
            var executivePredicate;
            var modelConstructor = modelOrConstructor && isValidModelConstructor(modelOrConstructor) ? modelOrConstructor : undefined;
            if (modelOrConstructor && modelConstructor === undefined) {
                var model = modelOrConstructor;
                var modelConstructor_1 = model && Object.getPrototypeOf(model).constructor;
                if (isValidModelConstructor(modelConstructor_1)) {
                    if (identifierOrCriteria) logger.warn("idOrCriteria is ignored when using a model instance", {
                        model: model,
                        identifierOrCriteria: identifierOrCriteria
                    });
                    return _this.observe(modelConstructor_1, model.id);
                } else {
                    var msg = "The model is not an instance of a PersistentModelConstructor";
                    logger.error(msg, {
                        model: model
                    });
                    throw new Error(msg);
                }
            }
            // observe should not accept object literal syntax
            if (identifierOrCriteria && modelConstructor && (0, _types.isIdentifierObject)(identifierOrCriteria, getModelDefinition(modelConstructor))) {
                var msg = (0, _util.errorMessages).observeWithObjectLiteral;
                logger.error(msg, {
                    objectLiteral: identifierOrCriteria
                });
                throw new Error(msg);
            }
            if (identifierOrCriteria !== undefined && modelConstructor === undefined) {
                var msg = "Cannot provide criteria without a modelConstructor";
                logger.error(msg, identifierOrCriteria);
                throw new Error(msg);
            }
            if (modelConstructor && !isValidModelConstructor(modelConstructor)) {
                var msg = "Constructor is not for a valid model";
                logger.error(msg, {
                    modelConstructor: modelConstructor
                });
                throw new Error(msg);
            }
            if (modelConstructor && typeof identifierOrCriteria === "string") {
                var buildIdPredicate = function(seed) {
                    return seed.id.eq(identifierOrCriteria);
                };
                executivePredicate = (0, _next.internals)(buildIdPredicate(buildSeedPredicate(modelConstructor)));
            } else if (modelConstructor && typeof identifierOrCriteria === "function") executivePredicate = (0, _next.internals)(identifierOrCriteria(buildSeedPredicate(modelConstructor)));
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var source;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this.start()
                                    ];
                                case 1:
                                    _a.sent();
                                    // Filter the events returned by Storage according to namespace,
                                    // append original element data, and subscribe to the observable
                                    source = this.storage.observe(modelConstructor).filter(function(_a) {
                                        var model = _a.model;
                                        return namespaceResolver(model) === (0, _util.USER);
                                    }).subscribe({
                                        next: function(item) {
                                            return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                    var message, modelDefinition, keyFields, primaryKeysAndValues, freshElement, _a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                message = item;
                                                                if (!(item.opType !== "DELETE")) return [
                                                                    3 /*break*/ ,
                                                                    2
                                                                ];
                                                                modelDefinition = getModelDefinition(item.model);
                                                                keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
                                                                primaryKeysAndValues = (0, _util.extractPrimaryKeysAndValues)(item.element, keyFields);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this.query(item.model, primaryKeysAndValues)
                                                                ];
                                                            case 1:
                                                                freshElement = _b.sent();
                                                                message = (0, _tslib.__assign)((0, _tslib.__assign)({}, message), {
                                                                    element: freshElement
                                                                });
                                                                _b.label = 2;
                                                            case 2:
                                                                _a = !executivePredicate;
                                                                if (_a) return [
                                                                    3 /*break*/ ,
                                                                    4
                                                                ];
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    executivePredicate.matches(message.element)
                                                                ];
                                                            case 3:
                                                                _a = _b.sent();
                                                                _b.label = 4;
                                                            case 4:
                                                                if (_a) observer.next(message);
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                });
                                            }, "datastore observe message handler");
                                        },
                                        error: function(err) {
                                            return observer.error(err);
                                        },
                                        complete: function() {
                                            return observer.complete();
                                        }
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "datastore observe observable initialization").catch(_this.handleAddProcError("DataStore.observe()")).catch(function(error) {
                    observer.error(error);
                });
                // better than no cleaner, but if the subscriber is handling the
                // complete() message async and not registering with the context,
                // this will still be problematic.
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (source) source.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, "DataStore.observe() cleanup");
            });
        };
        this.observeQuery = function(model, criteria, options) {
            return new (0, _zenObservableTsDefault.default)(function(observer) {
                var items = new Map();
                var itemsChanged = new Map();
                var deletedItemIds = [];
                var handle;
                // let predicate: ModelPredicate<T> | undefined;
                var executivePredicate;
                /**
                 * As the name suggests, this geneates a snapshot in the form of
                 * 	`{items: T[], isSynced: boolean}`
                 * and sends it to the observer.
                 *
                 * SIDE EFFECT: The underlying generation and emission methods may touch:
                 * `items`, `itemsChanged`, and `deletedItemIds`.
                 *
                 * Refer to `generateSnapshot` and `emitSnapshot` for more details.
                 */ var generateAndEmitSnapshot = function() {
                    var snapshot = generateSnapshot();
                    emitSnapshot(snapshot);
                };
                // a mechanism to return data after X amount of seconds OR after the
                // "limit" (itemsChanged >= this.syncPageSize) has been reached, whichever comes first
                var limitTimerRace = new (0, _util.DeferredCallbackResolver)({
                    callback: generateAndEmitSnapshot,
                    errorHandler: observer.error,
                    maxInterval: 2000
                });
                var sort = (options || {}).sort;
                var sortOptions = sort ? {
                    sort: sort
                } : undefined;
                var modelDefinition = getModelDefinition(model);
                if (!modelDefinition) throw new Error("Could not find model definition.");
                if (model && typeof criteria === "function") executivePredicate = (0, _next.internals)(criteria(buildSeedPredicate(model)));
                else if ((0, _predicates.isPredicatesAll)(criteria)) executivePredicate = undefined;
                _this.runningProcesses.add(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var err_1;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.query(model, criteria, sortOptions)
                                    ];
                                case 1:
                                    // first, query and return any locally-available records
                                    _a.sent().forEach(function(item) {
                                        var itemModelDefinition = getModelDefinition(model);
                                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                                        items.set(idOrPk, item);
                                    });
                                    // Observe the model and send a stream of updates (debounced).
                                    // We need to post-filter results instead of passing criteria through
                                    // to have visibility into items that move from in-set to out-of-set.
                                    // We need to explicitly remove those items from the existing snapshot.
                                    handle = this.observe(model).subscribe(function(_a) {
                                        var element = _a.element, model = _a.model, opType = _a.opType;
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var itemModelDefinition, idOrPk, _a, isSynced, limit;
                                                var _b, _c;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            itemModelDefinition = getModelDefinition(model);
                                                            idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, element);
                                                            _a = executivePredicate;
                                                            if (!_a) return [
                                                                3 /*break*/ ,
                                                                2
                                                            ];
                                                            return [
                                                                4 /*yield*/ ,
                                                                executivePredicate.matches(element)
                                                            ];
                                                        case 1:
                                                            _a = !_d.sent();
                                                            _d.label = 2;
                                                        case 2:
                                                            if (_a) {
                                                                if (opType === "UPDATE" && (items.has(idOrPk) || itemsChanged.has(idOrPk))) // tracking as a "deleted item" will include the item in
                                                                // page limit calculations and ensure it is removed from the
                                                                // final items collection, regardless of which collection(s)
                                                                // it is currently in. (I mean, it could be in both, right!?)
                                                                deletedItemIds.push(idOrPk);
                                                                else // ignore updates for irrelevant/filtered items.
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                            }
                                                            // Flag items which have been recently deleted
                                                            // NOTE: Merging of separate operations to the same model instance is handled upstream
                                                            // in the `mergePage` method within src/sync/merger.ts. The final state of a model instance
                                                            // depends on the LATEST record (for a given id).
                                                            if (opType === "DELETE") deletedItemIds.push(idOrPk);
                                                            else itemsChanged.set(idOrPk, element);
                                                            isSynced = (_c = (_b = this.sync) === null || _b === void 0 ? void 0 : _b.getModelSyncedStatus(model)) !== null && _c !== void 0 ? _c : false;
                                                            limit = itemsChanged.size - deletedItemIds.length >= this.syncPageSize;
                                                            if (limit || isSynced) limitTimerRace.resolve();
                                                            // kicks off every subsequent race as results sync down
                                                            limitTimerRace.start();
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        }, "handle observeQuery observed event");
                                    });
                                    // returns a set of initial/locally-available results
                                    generateAndEmitSnapshot();
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    observer.error(err_1);
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "datastore observequery startup").catch(_this.handleAddProcError("DataStore.observeQuery()")).catch(function(error) {
                    observer.error(error);
                });
                /**
                 * Combines the `items`, `itemsChanged`, and `deletedItemIds` collections into
                 * a snapshot in the form of `{ items: T[], isSynced: boolean}`.
                 *
                 * SIDE EFFECT: The shared `items` collection is recreated.
                 */ var generateSnapshot = function() {
                    var _a, _b;
                    var isSynced = (_b = (_a = _this.sync) === null || _a === void 0 ? void 0 : _a.getModelSyncedStatus(model)) !== null && _b !== void 0 ? _b : false;
                    var itemsArray = (0, _tslib.__spread)(Array.from(items.values()), Array.from(itemsChanged.values()));
                    items.clear();
                    itemsArray.forEach(function(item) {
                        var itemModelDefinition = getModelDefinition(model);
                        var idOrPk = (0, _utils.getIdentifierValue)(itemModelDefinition, item);
                        items.set(idOrPk, item);
                    });
                    // remove deleted items from the final result set
                    deletedItemIds.forEach(function(idOrPk) {
                        return items.delete(idOrPk);
                    });
                    var snapshot = Array.from(items.values());
                    // we sort after we merge the snapshots (items, itemsChanged)
                    // otherwise, the merge may not
                    if (options === null || options === void 0 ? void 0 : options.sort) sortItems(snapshot);
                    return {
                        items: snapshot,
                        isSynced: isSynced
                    };
                };
                /**
                 * Emits the list of items to the observer.
                 *
                 * SIDE EFFECT: `itemsChanged` and `deletedItemIds` are cleared to prepare
                 * for the next snapshot.
                 *
                 * @param snapshot The generated items data to emit.
                 */ var emitSnapshot = function(snapshot) {
                    // send the generated snapshot to the primary subscription.
                    // NOTE: This observer's handler *could* be async ...
                    observer.next(snapshot);
                    // reset the changed items sets
                    itemsChanged.clear();
                    deletedItemIds = [];
                };
                /**
                 * Sorts an `Array` of `T` according to the sort instructions given in the
                 * original  `observeQuery()` call.
                 *
                 * @param itemsToSort A array of model type.
                 */ var sortItems = function(itemsToSort) {
                    var modelDefinition = getModelDefinition(model);
                    var pagination = _this.processPagination(modelDefinition, options);
                    var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
                    if (sortPredicates.length) {
                        var compareFn = (0, _util.sortCompareFunction)(sortPredicates);
                        itemsToSort.sort(compareFn);
                    }
                };
                /**
                 * Force one last snapshot when the model is fully synced.
                 *
                 * This reduces latency for that last snapshot, which will otherwise
                 * wait for the configured timeout.
                 *
                 * @param payload The payload from the Hub event.
                 */ var hubCallback = function(_a) {
                    var payload = _a.payload;
                    var _b;
                    var event = payload.event, data = payload.data;
                    if (event === (0, _sync.ControlMessage).SYNC_ENGINE_MODEL_SYNCED && ((_b = data === null || data === void 0 ? void 0 : data.model) === null || _b === void 0 ? void 0 : _b.name) === model.name) {
                        generateAndEmitSnapshot();
                        (0, _core.Hub).remove("datastore", hubCallback);
                    }
                };
                (0, _core.Hub).listen("datastore", hubCallback);
                return _this.runningProcesses.addCleaner(function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (handle) handle.unsubscribe();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                }, "datastore observequery cleaner");
            });
        };
        this.configure = function(config) {
            if (config === void 0) config = {};
            _this.amplifyContext.Auth = _this.Auth;
            _this.amplifyContext.InternalAPI = _this.InternalAPI;
            _this.amplifyContext.Cache = _this.Cache;
            var configDataStore = config.DataStore, configAuthModeStrategyType = config.authModeStrategyType, configConflictHandler = config.conflictHandler, configErrorHandler = config.errorHandler, configMaxRecordsToSync = config.maxRecordsToSync, configSyncPageSize = config.syncPageSize, configFullSyncInterval = config.fullSyncInterval, configSyncExpressions = config.syncExpressions, configAuthProviders = config.authProviders, configStorageAdapter = config.storageAdapter, configFromAmplify = (0, _tslib.__rest)(config, [
                "DataStore",
                "authModeStrategyType",
                "conflictHandler",
                "errorHandler",
                "maxRecordsToSync",
                "syncPageSize",
                "fullSyncInterval",
                "syncExpressions",
                "authProviders",
                "storageAdapter"
            ]);
            _this.amplifyConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, configFromAmplify), _this.amplifyConfig);
            _this.conflictHandler = _this.setConflictHandler(config);
            _this.errorHandler = _this.setErrorHandler(config);
            var authModeStrategyType = configDataStore && configDataStore.authModeStrategyType || configAuthModeStrategyType || (0, _types.AuthModeStrategyType).DEFAULT;
            switch(authModeStrategyType){
                case (0, _types.AuthModeStrategyType).MULTI_AUTH:
                    _this.authModeStrategy = (0, _authModeStrategies.multiAuthStrategy)(_this.amplifyContext);
                    break;
                case (0, _types.AuthModeStrategyType).DEFAULT:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
                default:
                    _this.authModeStrategy = (0, _authModeStrategies.defaultAuthStrategy);
                    break;
            }
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.authProviders = configDataStore && configDataStore.authProviders || configAuthProviders;
            _this.syncExpressions = configDataStore && configDataStore.syncExpressions || configSyncExpressions || _this.syncExpressions;
            _this.maxRecordsToSync = configDataStore && configDataStore.maxRecordsToSync || configMaxRecordsToSync || _this.maxRecordsToSync || 10000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.maxRecordsToSync = _this.maxRecordsToSync;
            _this.syncPageSize = configDataStore && configDataStore.syncPageSize || configSyncPageSize || _this.syncPageSize || 1000;
            // store on config object, so that Sync, Subscription, and Mutation processors can have access
            _this.amplifyConfig.syncPageSize = _this.syncPageSize;
            _this.fullSyncInterval = configDataStore && configDataStore.fullSyncInterval || configFullSyncInterval || _this.fullSyncInterval || 1440; // 1 day
            _this.storageAdapter = configDataStore && configDataStore.storageAdapter || configStorageAdapter || _this.storageAdapter || undefined;
            _this.sessionId = _this.retrieveSessionId();
        };
    }
    DataStore.prototype.getModuleName = function() {
        return "DataStore";
    };
    /**
     * Builds a function to capture `BackgroundManagerNotOpenError`'s to produce friendlier,
     * more instructive errors for customers.
     *
     * @param operation The name of the operation (usually a Datastore method) the customer
     * tried to call.
     */ DataStore.prototype.handleAddProcError = function(operation) {
        var _this = this;
        /**
         * If the tested error is a `BackgroundManagerNotOpenError`, it will be captured
         * and replaced with a friendlier message that instructs the App Developer.
         *
         * @param err An error to test.
         */ var handler = function(err) {
            if (err.message.startsWith("BackgroundManagerNotOpenError")) throw new Error([
                "DataStoreStateError: Tried to execute `" + operation + '` while DataStore was "' + _this.state + '".',
                'This can only be done while DataStore is "Started" or "Stopped". To remedy:',
                "Ensure all calls to `stop()` and `clear()` have completed first.",
                "If this is not possible, retry the operation until it succeeds."
            ].join("\n"));
            else throw err;
        };
        return handler;
    };
    /**
     * Clears all data from storage and removes all data, schema info, other
     * initialization details, and then stops DataStore.
     *
     * That said, reinitialization is required after clearing. This can be done
     * by explicitiliy calling `start()` or any method that implicitly starts
     * DataStore, such as `query()`, `save()`, or `delete()`.
     */ DataStore.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        checkSchemaInitialized();
                        this.state = DataStoreState.Clearing;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (!(this.storage === undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // connect to storage so that it can be cleared without fully starting DataStore
                        this.storage = new (0, _storage.ExclusiveStorage)(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, this.storageAdapter, this.sessionId);
                        return [
                            4 /*yield*/ ,
                            this.storage.init()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.storage.clear()
                        ];
                    case 6:
                        _a.sent();
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.storage = undefined;
                        this.sync = undefined;
                        this.syncPredicates = new WeakMap();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 7:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Stops all DataStore sync activities.
     *
     * TODO: "Waits for graceful termination of
     * running queries and terminates subscriptions."
     */ DataStore.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.state = DataStoreState.Stopping;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        if (syncSubscription && !syncSubscription.closed) syncSubscription.unsubscribe();
                        if (!this.sync) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.sync.stop()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.initialized = undefined; // Should re-initialize when start() is called.
                        this.sync = undefined;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 4:
                        _a.sent();
                        this.state = DataStoreState.NotRunning;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Validates given pagination input from a query and creates a pagination
     * argument for use against the storage layer.
     *
     * @param modelDefinition
     * @param paginationProducer
     */ DataStore.prototype.processPagination = function(modelDefinition, paginationProducer) {
        var sortPredicate;
        var _a = paginationProducer || {}, limit = _a.limit, page = _a.page, sort = _a.sort;
        if (limit === undefined && page === undefined && sort === undefined) return undefined;
        if (page !== undefined && limit === undefined) throw new Error("Limit is required when requesting a page");
        if (page !== undefined) {
            if (typeof page !== "number") throw new Error("Page should be a number");
            if (page < 0) throw new Error("Page can't be negative");
        }
        if (limit !== undefined) {
            if (typeof limit !== "number") throw new Error("Limit should be a number");
            if (limit < 0) throw new Error("Limit can't be negative");
        }
        if (sort) sortPredicate = (0, _predicates.ModelSortPredicateCreator).createFromExisting(modelDefinition, sort);
        return {
            limit: limit,
            page: page,
            sort: sortPredicate
        };
    };
    /**
     * Examines the configured `syncExpressions` and produces a WeakMap of
     * SchemaModel -> predicate to use during sync.
     */ DataStore.prototype.processSyncExpressions = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var syncPredicates;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.syncExpressions || !this.syncExpressions.length) return [
                            2 /*return*/ ,
                            new WeakMap()
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(this.syncExpressions.map(function(syncExpression) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _a, modelConstructor, conditionProducer, modelDefinition, condition, predicate;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    syncExpression
                                                ];
                                            case 1:
                                                _a = _b.sent(), modelConstructor = _a.modelConstructor, conditionProducer = _a.conditionProducer;
                                                modelDefinition = getModelDefinition(modelConstructor);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.unwrapPromise(conditionProducer)
                                                ];
                                            case 2:
                                                condition = _b.sent();
                                                if ((0, _predicates.isPredicatesAll)(condition)) return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        null
                                                    ]
                                                ];
                                                predicate = (0, _next.internals)(condition((0, _next.predicateFor)({
                                                    builder: modelConstructor,
                                                    schema: modelDefinition,
                                                    pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                                                }))).toStoragePredicate();
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        modelDefinition,
                                                        predicate
                                                    ]
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        syncPredicates = _a.sent();
                        return [
                            2 /*return*/ ,
                            this.weakMapFromEntries(syncPredicates)
                        ];
                }
            });
        });
    };
    DataStore.prototype.unwrapPromise = function(conditionProducer) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var condition, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            conditionProducer()
                        ];
                    case 1:
                        condition = _a.sent();
                        return [
                            2 /*return*/ ,
                            condition || conditionProducer
                        ];
                    case 2:
                        error_1 = _a.sent();
                        if (error_1 instanceof TypeError) return [
                            2 /*return*/ ,
                            conditionProducer
                        ];
                        throw error_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DataStore.prototype.weakMapFromEntries = function(entries) {
        return entries.reduce(function(map, _a) {
            var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], predicate = _b[1];
            if (map.has(modelDefinition)) {
                var name_2 = modelDefinition.name;
                logger.warn("You can only utilize one Sync Expression per model.\n          Subsequent sync expressions for the " + name_2 + " model will be ignored.");
                return map;
            }
            if (predicate) map.set(modelDefinition, predicate);
            return map;
        }, new WeakMap());
    };
    /**
     * A session ID to allow CMS to open databases against multiple apps.
     * This session ID is only expected be set by AWS Amplify Studio.
     */ DataStore.prototype.retrieveSessionId = function() {
        try {
            var sessionId = sessionStorage.getItem("datastoreSessionId");
            if (sessionId) {
                var aws_appsync_graphqlEndpoint = this.amplifyConfig.aws_appsync_graphqlEndpoint;
                var appSyncUrl = aws_appsync_graphqlEndpoint.split("/")[2];
                var _a = (0, _tslib.__read)(appSyncUrl.split("."), 1), appSyncId = _a[0];
                return sessionId + "-" + appSyncId;
            }
        } catch (_b) {}
        return undefined;
    };
    return DataStore;
}();
var instance = new DataStore();
(0, _core.Amplify).register(instance);

},{"tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","immer":"8nxw2","uuid":"bpprZ","zen-observable-ts":"57mma","../authModeStrategies":"c6XSG","../predicates":"bohgw","../storage/storage":"gjDZS","../storage/relationship":"bT2iw","../sync":"4SDgb","../types":"9W0ar","../util":"iFXfl","../predicates/next":"8zsMQ","../sync/utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6j6uC":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalAPI", ()=>(0, _internalAPI.InternalAPI));
parcelHelpers.export(exports, "InternalAPIClass", ()=>(0, _internalAPI.InternalAPIClass));
var _internalAPI = require("./InternalAPI");

},{"./InternalAPI":"icpYk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nxw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>un);
parcelHelpers.export(exports, "applyPatches", ()=>pn);
parcelHelpers.export(exports, "castDraft", ()=>K);
parcelHelpers.export(exports, "castImmutable", ()=>$);
parcelHelpers.export(exports, "createDraft", ()=>ln);
parcelHelpers.export(exports, "current", ()=>D);
parcelHelpers.export(exports, "enableAllPlugins", ()=>J);
parcelHelpers.export(exports, "enableES5", ()=>N);
parcelHelpers.export(exports, "enableMapSet", ()=>C);
parcelHelpers.export(exports, "enablePatches", ()=>T);
parcelHelpers.export(exports, "finishDraft", ()=>dn);
parcelHelpers.export(exports, "freeze", ()=>d);
parcelHelpers.export(exports, "immerable", ()=>L);
parcelHelpers.export(exports, "isDraft", ()=>t);
parcelHelpers.export(exports, "isDraftable", ()=>r);
parcelHelpers.export(exports, "nothing", ()=>H);
parcelHelpers.export(exports, "original", ()=>e);
parcelHelpers.export(exports, "produce", ()=>fn);
parcelHelpers.export(exports, "produceWithPatches", ()=>cn);
parcelHelpers.export(exports, "setAutoFreeze", ()=>sn);
parcelHelpers.export(exports, "setUseProxies", ()=>vn);
function n(n) {
    for(var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)r[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n) {
    return !!n && !!n[Q];
}
function r(n) {
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var t = Object.getPrototypeOf(n);
        if (null === t) return !0;
        var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
        return r === Object || "function" == typeof r && Function.toString.call(r) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v(n));
}
function e(r) {
    return t(r) || n(23, r), r[Q].t;
}
function i(n, t, r) {
    void 0 === r && (r = !1), 0 === o(n) ? (r ? Object.keys : nn)(n).forEach(function(e) {
        r && "symbol" == typeof e || t(e, n[e], n);
    }) : n.forEach(function(r, e) {
        return t(e, r, n);
    });
}
function o(n) {
    var t = n[Q];
    return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, t) {
    return 2 === o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function a(n, t) {
    return 2 === o(n) ? n.get(t) : n[t];
}
function f(n, t, r) {
    var e = o(n);
    2 === e ? n.set(t, r) : 3 === e ? (n.delete(t), n.add(r)) : n[t] = r;
}
function c(n, t) {
    return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var t = tn(n);
    delete t[Q];
    for(var r = nn(t), e = 0; e < r.length; e++){
        var i = r[e], o = t[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), t);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || t(n) || !r(n) ? n : (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, t) {
        return d(t, !0);
    }, !0), n);
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(t) {
    var r = rn[t];
    return r || n(18, t), r;
}
function m(n, t) {
    rn[n] || (rn[n] = t);
}
function _() {
    return U;
}
function j(n, t) {
    t && (b("Patches"), n.u = [], n.s = [], n.v = t);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var t = n[Q];
    0 === t.i || 1 === t.i ? t.j() : t.O = !0;
}
function P(t, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== t && t !== i;
    return e.h.g || b("ES5").S(e, t, o), o ? (i[Q].P && (O(e), n(4)), r(t) && (t = M(e, t), e.l || x(e, t)), e.u && b("Patches").M(i[Q], t, e.u, e.s)) : t = M(e, i, []), O(e), e.u && e.v(e.u, e.s), t !== H ? t : void 0;
}
function M(n, t, r) {
    if (y(t)) return t;
    var e = t[Q];
    if (!e) return i(t, function(i, o) {
        return A(n, e, t, i, o, r);
    }, !0), t;
    if (e.A !== n) return t;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(t, i) {
            return A(n, e, o, t, i, r);
        }), x(n, o, !1), r && n.u && b("Patches").R(e, r, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (t(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !t(v)) return;
        e.m = !1;
    }
    if (r(c) && !y(c)) {
        if (!e.h.F && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, t, r) {
    void 0 === r && (r = !1), n.h.F && n.m && d(t, r);
}
function z(n, t) {
    var r = n[Q];
    return (r ? p(r) : n)[t];
}
function I(n, t) {
    if (t in n) for(var r = Object.getPrototypeOf(n); r;){
        var e = Object.getOwnPropertyDescriptor(r, t);
        if (e) return e;
        r = Object.getPrototypeOf(r);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function R(n, t, r) {
    var e = s(t) ? b("MapSet").N(t, r) : v(t) ? b("MapSet").T(t, r) : n.g ? function(n, t) {
        var r = Array.isArray(n), e = {
            i: r ? 1 : 0,
            A: t ? t.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: t,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        r && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(t, r) : b("ES5").J(t, r);
    return (r ? r.A : _()).p.push(e), e;
}
function D(e) {
    return t(e) || n(22, e), function n(t) {
        if (!r(t)) return t;
        var e, u = t[Q], c = o(t);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = F(t, c), u.I = !1;
        } else e = F(t, c);
        return i(e, function(t, r) {
            u && a(u.t, t) === r || f(e, t, n(r));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function F(n, t) {
    switch(t){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function N() {
    function r(n, t) {
        var r = s[n];
        return r ? r.enumerable = t : s[n] = r = {
            configurable: !0,
            enumerable: t,
            get: function() {
                var t = this[Q];
                return en.get(t, n);
            },
            set: function(t) {
                var r = this[Q];
                en.set(r, n, t);
            }
        }, r;
    }
    function e(n) {
        for(var t = n.length - 1; t >= 0; t--){
            var r = n[t][Q];
            if (!r.P) switch(r.i){
                case 5:
                    a(r) && k(r);
                    break;
                case 4:
                    o(r) && k(r);
            }
        }
    }
    function o(n) {
        for(var t = n.t, r = n.k, e = nn(r), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = t[o];
                if (void 0 === a && !u(t, o)) return !0;
                var f = r[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!t[Q];
        return e.length !== nn(t).length + (v ? 0 : 1);
    }
    function a(n) {
        var t = n.k;
        if (t.length !== n.t.length) return !0;
        var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!r || r.get);
    }
    function f(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var s = {};
    m("ES5", {
        J: function(n, t) {
            var e = Array.isArray(n), i = function(n, t) {
                if (n) {
                    for(var e = Array(t.length), i = 0; i < t.length; i++)Object.defineProperty(e, "" + i, r(i, !0));
                    return e;
                }
                var o = tn(t);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = r(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(t), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: n,
                k: i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, r, o) {
            o ? t(r) && r[Q].A === n && e(n.p) : (n.u && function n(t) {
                if (t && "object" == typeof t) {
                    var r = t[Q];
                    if (r) {
                        var e = r.t, o = r.k, f = r.D, c = r.i;
                        if (4 === c) i(o, function(t) {
                            t !== Q && (void 0 !== e[t] || u(e, t) ? f[t] || n(o[t]) : (f[t] = !0, k(r)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(r));
                        });
                        else if (5 === c) {
                            if (a(r) && (k(r), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!r(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var t = Object.create(Object.getPrototypeOf(n));
        for(var i in n)t[i] = e(n[i]);
        return u(n, L) && (t[L] = n[L]), t;
    }
    function f(n) {
        return t(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(t, r) {
            return r.forEach(function(r) {
                for(var i = r.path, u = r.op, f = t, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = "" + i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(r.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(r.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), t;
        },
        R: function(n, t, r, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, t, r, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = t.concat(n);
                                r.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, t, r, e);
                case 5:
                case 1:
                    return function(n, t, r, e) {
                        var i = n.t, o = n.D, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                r
                            ];
                            r = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = t.concat([
                                v
                            ]);
                            r.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = t.concat([
                                l
                            ]);
                            r.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: t.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, t, r, e);
                case 3:
                    return function(n, t, r, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, t, r, e);
            }
        },
        M: function(n, t, r, e) {
            r.push({
                op: "replace",
                path: [],
                value: t === H ? void 0 : t
            }), e.push({
                op: "replace",
                path: [],
                value: n.t
            });
        }
    });
}
function C() {
    function t(n, t) {
        function r() {
            this.constructor = n;
        }
        a(n, t), n.prototype = (r.prototype = t.prototype, new r);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(t) {
            if (r(t)) {
                var e = R(n.A.h, t, n);
                n.p.set(t, e), n.o.add(e);
            } else n.o.add(t);
        }));
    }
    function u(t) {
        t.O && n(3, JSON.stringify(p(t)));
    }
    var a = function(n, t) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, t) {
            n.__proto__ = t;
        } || function(n, t) {
            for(var r in t)t.hasOwnProperty(r) && (n[r] = t[r]);
        })(n, t);
    }, f = function() {
        function n(n, t) {
            return this[Q] = {
                i: 2,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        t(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, t) {
            var r = this[Q];
            return u(r), p(r).has(n) && p(r).get(n) === t || (e(r), k(r), r.D.set(n, !0), r.o.set(n, t), r.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[Q];
            return u(t), e(t), k(t), t.D.set(n, !1), t.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.D = new Map, i(n.t, function(t) {
                n.D.set(t, !1);
            }), n.o.clear());
        }, o.forEach = function(n, t) {
            var r = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(t, r.get(i), i, r);
            });
        }, o.get = function(n) {
            var t = this[Q];
            u(t);
            var i = p(t).get(n);
            if (t.I || !r(i)) return i;
            if (i !== t.t.get(n)) return i;
            var o = R(t.A.h, i, t);
            return e(t), t.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, t = this, r = this.keys();
            return (n = {})[V] = function() {
                return t.values();
            }, n.next = function() {
                var n = r.next();
                return n.done ? n : {
                    done: !1,
                    value: t.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, t = this, r = this.keys();
            return (n = {})[V] = function() {
                return t.entries();
            }, n.next = function() {
                var n = r.next();
                if (n.done) return n;
                var e = t.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, t) {
            return this[Q] = {
                i: 3,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        t(n, Set);
        var r = n.prototype;
        return Object.defineProperty(r, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), r.has = function(n) {
            var t = this[Q];
            return u(t), t.o ? !!t.o.has(n) || !(!t.p.has(n) || !t.o.has(t.p.get(n))) : t.t.has(n);
        }, r.add = function(n) {
            var t = this[Q];
            return u(t), this.has(n) || (o(t), k(t), t.o.add(n)), this;
        }, r.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[Q];
            return u(t), o(t), k(t), t.o.delete(n) || !!t.p.has(n) && t.o.delete(t.p.get(n));
        }, r.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, r.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, r.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, r.keys = function() {
            return this.values();
        }, r[V] = function() {
            return this.values();
        }, r.forEach = function(n, t) {
            for(var r = this.values(), e = r.next(); !e.done;)n.call(t, e.value, e.value, this), e = r.next();
        }, n;
    }();
    m("MapSet", {
        N: function(n, t) {
            return new f(n, t);
        },
        T: function(n, t) {
            return new c(n, t);
        }
    });
}
function J() {
    N(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, tn = Object.getOwnPropertyDescriptors || function(n) {
    var t = {};
    return nn(n).forEach(function(r) {
        t[r] = Object.getOwnPropertyDescriptor(n, r);
    }), t;
}, rn = {}, en = {
    get: function(n, t) {
        if (t === Q) return n;
        var e = p(n);
        if (!u(e, t)) return function(n, t, r) {
            var e, i = I(t, r);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, t);
        var i = e[t];
        return n.I || !r(i) ? i : i === z(n.t, t) ? (E(n), n.o[t] = R(n.A.h, i, n)) : i;
    },
    has: function(n, t) {
        return t in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, t, r) {
        var e = I(p(n), t);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, r), !0;
        if (!n.P) {
            var i = z(p(n), t), o = null == i ? void 0 : i[Q];
            if (o && o.t === r) return n.o[t] = r, n.D[t] = !1, !0;
            if (c(r, i) && (void 0 !== r || u(n.t, t))) return !0;
            E(n), k(n);
        }
        return n.o[t] === r && "number" != typeof r && (void 0 !== r || t in n.o) || (n.o[t] = r, n.D[t] = !0, !0);
    },
    deleteProperty: function(n, t) {
        return void 0 !== z(n.t, t) || t in n.t ? (n.D[t] = !1, E(n), k(n)) : delete n.D[t], n.o && delete n.o[t], !0;
    },
    getOwnPropertyDescriptor: function(n, t) {
        var r = p(n), e = Reflect.getOwnPropertyDescriptor(r, t);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== t,
            enumerable: e.enumerable,
            value: r[t]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, t) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
    };
}), on.deleteProperty = function(t, r) {
    return en.deleteProperty.call(this, t[0], r);
}, on.set = function(t, r, e) {
    return en.set.call(this, t[0], r, e, t[0]);
};
var un = function() {
    function e(t) {
        var e = this;
        this.g = B, this.F = !0, this.produce = function(t, i, o) {
            if ("function" == typeof t && "function" != typeof i) {
                var u = i;
                i = t;
                var a = e;
                return function(n) {
                    var t = this;
                    void 0 === n && (n = u);
                    for(var r = arguments.length, e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var r;
                        return (r = i).call.apply(r, [
                            t,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), r(t)) {
                var c = w(e), s = R(e, t, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!t || "object" != typeof t) {
                if ((f = i(t)) === H) return;
                return void 0 === f && (f = t), e.F && d(f, !0), f;
            }
            n(21, t);
        }, this.produceWithPatches = function(n, t) {
            var r, i;
            return "function" == typeof n ? function(t) {
                for(var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(t, function(t) {
                    return n.apply(void 0, [
                        t
                    ].concat(i));
                });
            } : [
                e.produce(n, t, function(n, t) {
                    r = n, i = t;
                }),
                r,
                i
            ];
        }, "boolean" == typeof (null == t ? void 0 : t.useProxies) && this.setUseProxies(t.useProxies), "boolean" == typeof (null == t ? void 0 : t.autoFreeze) && this.setAutoFreeze(t.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        r(e) || n(8), t(e) && (e = D(e));
        var i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, g(i), o;
    }, i.finishDraft = function(t, r) {
        var e = t && t[Q];
        var i = e.A;
        return j(i, r), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.F = n;
    }, i.setUseProxies = function(t) {
        t && !B && n(20), this.g = t;
    }, i.applyPatches = function(n, r) {
        var e;
        for(e = r.length - 1; e >= 0; e--){
            var i = r[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        var o = b("Patches").$;
        return t(n) ? o(n, r) : this.produce(n, function(n) {
            return o(n, r.slice(e + 1));
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
exports.default = fn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bpprZ":[function(require,module,exports) {
var v1 = require("ae6af6debf5ef9a0");
var v4 = require("729d1b22f337f992");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"ae6af6debf5ef9a0":"7s170","729d1b22f337f992":"5OHB6"}],"7s170":[function(require,module,exports) {
var rng = require("dc08c2655e77aa3c");
var bytesToUuid = require("b28d042a2206f51");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"dc08c2655e77aa3c":"36LDf","b28d042a2206f51":"bG9qM"}],"36LDf":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"bG9qM":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"5OHB6":[function(require,module,exports) {
var rng = require("327f4b6ca84176ae");
var bytesToUuid = require("8317f7597b0dd483");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"327f4b6ca84176ae":"36LDf","8317f7597b0dd483":"bG9qM"}],"c6XSG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", ()=>(0, _defaultAuthStrategy.defaultAuthStrategy));
parcelHelpers.export(exports, "multiAuthStrategy", ()=>(0, _multiAuthStrategy.multiAuthStrategy));
var _defaultAuthStrategy = require("./defaultAuthStrategy");
var _multiAuthStrategy = require("./multiAuthStrategy");

},{"./defaultAuthStrategy":"7AlEr","./multiAuthStrategy":"3xq5r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7AlEr":[function(require,module,exports) {
// Default behavior is to use the primary auth mode for an API,
// so we are returning an empty array so that DataStore will default
// to using the primary auth mode.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAuthStrategy", ()=>defaultAuthStrategy);
var defaultAuthStrategy = function() {
    return [];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3xq5r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multiAuthStrategy", ()=>multiAuthStrategy);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _auth = require("@aws-amplify/auth");
var _apiGraphql = require("@aws-amplify/api-graphql");
var _types = require("../types");
function getProviderFromRule(rule) {
    // private with no provider means userPools
    if (rule.allow === "private" && !rule.provider) return (0, _types.ModelAttributeAuthProvider).USER_POOLS;
    // public with no provider means apiKey
    if (rule.allow === "public" && !rule.provider) return (0, _types.ModelAttributeAuthProvider).API_KEY;
    return rule.provider;
}
function sortAuthRulesWithPriority(rules) {
    var allowSortPriority = [
        (0, _types.ModelAttributeAuthAllow).CUSTOM,
        (0, _types.ModelAttributeAuthAllow).OWNER,
        (0, _types.ModelAttributeAuthAllow).GROUPS,
        (0, _types.ModelAttributeAuthAllow).PRIVATE,
        (0, _types.ModelAttributeAuthAllow).PUBLIC
    ];
    var providerSortPriority = [
        (0, _types.ModelAttributeAuthProvider).FUNCTION,
        (0, _types.ModelAttributeAuthProvider).USER_POOLS,
        (0, _types.ModelAttributeAuthProvider).OIDC,
        (0, _types.ModelAttributeAuthProvider).IAM,
        (0, _types.ModelAttributeAuthProvider).API_KEY
    ];
    return (0, _tslib.__spread)(rules).sort(function(a, b) {
        if (a.allow === b.allow) return providerSortPriority.indexOf(getProviderFromRule(a)) - providerSortPriority.indexOf(getProviderFromRule(b));
        return allowSortPriority.indexOf(a.allow) - allowSortPriority.indexOf(b.allow);
    });
}
function getAuthRules(_a) {
    var rules = _a.rules, currentUser = _a.currentUser;
    // Using Set to ensure uniqueness
    var authModes = new Set();
    rules.forEach(function(rule) {
        switch(rule.allow){
            case (0, _types.ModelAttributeAuthAllow).CUSTOM:
                // custom with no provider -> function
                if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).FUNCTION) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                break;
            case (0, _types.ModelAttributeAuthAllow).GROUPS:
            case (0, _types.ModelAttributeAuthAllow).OWNER:
                // We shouldn't attempt User Pool or OIDC if there isn't an authenticated user
                if (currentUser) {
                    if (rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).OIDC) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).OPENID_CONNECT);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PRIVATE:
                // We shouldn't attempt private if there isn't an authenticated user
                if (currentUser) {
                    // private with no provider means userPools
                    if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).USER_POOLS) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS);
                    else if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                }
                break;
            case (0, _types.ModelAttributeAuthAllow).PUBLIC:
                if (rule.provider === (0, _types.ModelAttributeAuthProvider).IAM) authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_IAM);
                else if (!rule.provider || rule.provider === (0, _types.ModelAttributeAuthProvider).API_KEY) // public with no provider means apiKey
                authModes.add((0, _apiGraphql.GRAPHQL_AUTH_MODE).API_KEY);
                break;
            default:
                break;
        }
    });
    return Array.from(authModes);
}
var multiAuthStrategy = function(amplifyContext) {
    return function(_a) {
        var schema = _a.schema, modelName = _a.modelName;
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var currentUser, e_1, attributes, authAttribute, sortedRules;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        amplifyContext.Auth = amplifyContext.Auth || (0, _auth.Auth);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            amplifyContext.Auth.currentAuthenticatedUser()
                        ];
                    case 2:
                        currentUser = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        attributes = schema.namespaces.user.models[modelName].attributes;
                        if (attributes) {
                            authAttribute = attributes.find(function(attr) {
                                return attr.type === "auth";
                            });
                            if ((_b = authAttribute === null || authAttribute === void 0 ? void 0 : authAttribute.properties) === null || _b === void 0 ? void 0 : _b.rules) {
                                sortedRules = sortAuthRulesWithPriority(authAttribute.properties.rules);
                                return [
                                    2 /*return*/ ,
                                    getAuthRules({
                                        currentUser: currentUser,
                                        rules: sortedRules
                                    })
                                ];
                            }
                        }
                        return [
                            2 /*return*/ ,
                            []
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@aws-amplify/auth":"ilv20","@aws-amplify/api-graphql":"eWncu","../types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9W0ar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSchemaModel", ()=>isSchemaModel);
parcelHelpers.export(exports, "isSchemaModelWithAttributes", ()=>isSchemaModelWithAttributes);
parcelHelpers.export(exports, "isAssociatedWith", ()=>isAssociatedWith);
parcelHelpers.export(exports, "isTargetNameAssociation", ()=>isTargetNameAssociation);
parcelHelpers.export(exports, "isFieldAssociation", ()=>isFieldAssociation);
parcelHelpers.export(exports, "isModelAttributeAuth", ()=>isModelAttributeAuth);
parcelHelpers.export(exports, "isModelAttributeKey", ()=>isModelAttributeKey);
parcelHelpers.export(exports, "isModelAttributePrimaryKey", ()=>isModelAttributePrimaryKey);
parcelHelpers.export(exports, "isModelAttributeCompositeKey", ()=>isModelAttributeCompositeKey);
parcelHelpers.export(exports, "ModelAttributeAuthAllow", ()=>ModelAttributeAuthAllow);
parcelHelpers.export(exports, "ModelAttributeAuthProvider", ()=>ModelAttributeAuthProvider);
parcelHelpers.export(exports, "GraphQLScalarType", ()=>GraphQLScalarType);
parcelHelpers.export(exports, "isGraphQLScalarType", ()=>isGraphQLScalarType);
parcelHelpers.export(exports, "isModelFieldType", ()=>isModelFieldType);
parcelHelpers.export(exports, "isNonModelFieldType", ()=>isNonModelFieldType);
parcelHelpers.export(exports, "isEnumFieldType", ()=>isEnumFieldType);
parcelHelpers.export(exports, "isIdentifierObject", ()=>isIdentifierObject);
parcelHelpers.export(exports, "OpType", ()=>OpType);
parcelHelpers.export(exports, "isPredicateObj", ()=>isPredicateObj);
parcelHelpers.export(exports, "isPredicateGroup", ()=>isPredicateGroup);
parcelHelpers.export(exports, "QueryOne", ()=>QueryOne);
parcelHelpers.export(exports, "SortDirection", ()=>SortDirection);
parcelHelpers.export(exports, "AuthModeStrategyType", ()=>AuthModeStrategyType);
parcelHelpers.export(exports, "ModelOperation", ()=>ModelOperation);
parcelHelpers.export(exports, "syncExpression", ()=>syncExpression);
parcelHelpers.export(exports, "ProcessName", ()=>ProcessName);
parcelHelpers.export(exports, "DISCARD", ()=>DISCARD);
parcelHelpers.export(exports, "LimitTimerRaceResolvedValues", ()=>LimitTimerRaceResolvedValues);
parcelHelpers.export(exports, "PredicateInternalsKey", ()=>PredicateInternalsKey) // #endregion
;
var _tslib = require("tslib");
var _util = require("./util");
function isSchemaModel(obj) {
    return obj && obj.pluralName !== undefined;
}
function isSchemaModelWithAttributes(m) {
    return isSchemaModel(m) && m.attributes !== undefined;
}
function isAssociatedWith(obj) {
    return obj && obj.associatedWith;
}
function isTargetNameAssociation(obj) {
    return (obj === null || obj === void 0 ? void 0 : obj.targetName) || (obj === null || obj === void 0 ? void 0 : obj.targetNames);
}
function isFieldAssociation(obj, fieldName) {
    var _a, _b;
    return (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.fields[fieldName]) === null || _a === void 0 ? void 0 : _a.association) === null || _b === void 0 ? void 0 : _b.connectionType;
}
function isModelAttributeAuth(attr) {
    return attr.type === "auth" && attr.properties && attr.properties.rules && attr.properties.rules.length > 0;
}
function isModelAttributeKey(attr) {
    return attr.type === "key" && attr.properties && attr.properties.fields && attr.properties.fields.length > 0;
}
function isModelAttributePrimaryKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name === undefined;
}
function isModelAttributeCompositeKey(attr) {
    return isModelAttributeKey(attr) && attr.properties.name !== undefined && attr.properties.fields.length > 2;
}
var ModelAttributeAuthAllow;
(function(ModelAttributeAuthAllow) {
    ModelAttributeAuthAllow["CUSTOM"] = "custom";
    ModelAttributeAuthAllow["OWNER"] = "owner";
    ModelAttributeAuthAllow["GROUPS"] = "groups";
    ModelAttributeAuthAllow["PRIVATE"] = "private";
    ModelAttributeAuthAllow["PUBLIC"] = "public";
})(ModelAttributeAuthAllow || (ModelAttributeAuthAllow = {}));
var ModelAttributeAuthProvider;
(function(ModelAttributeAuthProvider) {
    ModelAttributeAuthProvider["FUNCTION"] = "function";
    ModelAttributeAuthProvider["USER_POOLS"] = "userPools";
    ModelAttributeAuthProvider["OIDC"] = "oidc";
    ModelAttributeAuthProvider["IAM"] = "iam";
    ModelAttributeAuthProvider["API_KEY"] = "apiKey";
})(ModelAttributeAuthProvider || (ModelAttributeAuthProvider = {}));
var GraphQLScalarType;
(function(GraphQLScalarType) {
    GraphQLScalarType[GraphQLScalarType["ID"] = 0] = "ID";
    GraphQLScalarType[GraphQLScalarType["String"] = 1] = "String";
    GraphQLScalarType[GraphQLScalarType["Int"] = 2] = "Int";
    GraphQLScalarType[GraphQLScalarType["Float"] = 3] = "Float";
    GraphQLScalarType[GraphQLScalarType["Boolean"] = 4] = "Boolean";
    GraphQLScalarType[GraphQLScalarType["AWSDate"] = 5] = "AWSDate";
    GraphQLScalarType[GraphQLScalarType["AWSTime"] = 6] = "AWSTime";
    GraphQLScalarType[GraphQLScalarType["AWSDateTime"] = 7] = "AWSDateTime";
    GraphQLScalarType[GraphQLScalarType["AWSTimestamp"] = 8] = "AWSTimestamp";
    GraphQLScalarType[GraphQLScalarType["AWSEmail"] = 9] = "AWSEmail";
    GraphQLScalarType[GraphQLScalarType["AWSJSON"] = 10] = "AWSJSON";
    GraphQLScalarType[GraphQLScalarType["AWSURL"] = 11] = "AWSURL";
    GraphQLScalarType[GraphQLScalarType["AWSPhone"] = 12] = "AWSPhone";
    GraphQLScalarType[GraphQLScalarType["AWSIPAddress"] = 13] = "AWSIPAddress";
})(GraphQLScalarType || (GraphQLScalarType = {}));
(function(GraphQLScalarType) {
    function getJSType(scalar) {
        switch(scalar){
            case "Boolean":
                return "boolean";
            case "ID":
            case "String":
            case "AWSDate":
            case "AWSTime":
            case "AWSDateTime":
            case "AWSEmail":
            case "AWSURL":
            case "AWSPhone":
            case "AWSIPAddress":
                return "string";
            case "Int":
            case "Float":
            case "AWSTimestamp":
                return "number";
            case "AWSJSON":
                return "object";
            default:
                throw new Error("Invalid scalar type");
        }
    }
    GraphQLScalarType.getJSType = getJSType;
    function getValidationFunction(scalar) {
        switch(scalar){
            case "AWSDate":
                return 0, _util.isAWSDate;
            case "AWSTime":
                return 0, _util.isAWSTime;
            case "AWSDateTime":
                return 0, _util.isAWSDateTime;
            case "AWSTimestamp":
                return 0, _util.isAWSTimestamp;
            case "AWSEmail":
                return 0, _util.isAWSEmail;
            case "AWSJSON":
                return 0, _util.isAWSJSON;
            case "AWSURL":
                return 0, _util.isAWSURL;
            case "AWSPhone":
                return 0, _util.isAWSPhone;
            case "AWSIPAddress":
                return 0, _util.isAWSIPAddress;
            default:
                return undefined;
        }
    }
    GraphQLScalarType.getValidationFunction = getValidationFunction;
})(GraphQLScalarType || (GraphQLScalarType = {}));
function isGraphQLScalarType(obj) {
    return obj && GraphQLScalarType[obj] !== undefined;
}
function isModelFieldType(obj) {
    var modelField = "model";
    if (obj && obj[modelField]) return true;
    return false;
}
function isNonModelFieldType(obj) {
    var typeField = "nonModel";
    if (obj && obj[typeField]) return true;
    return false;
}
function isEnumFieldType(obj) {
    var modelField = "enum";
    if (obj && obj[modelField]) return true;
    return false;
}
function isIdentifierObject(obj, modelDefinition) {
    var keys = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return typeof obj === "object" && obj && keys.every(function(k) {
        return obj[k] !== undefined;
    });
}
var OpType;
(function(OpType) {
    OpType["INSERT"] = "INSERT";
    OpType["UPDATE"] = "UPDATE";
    OpType["DELETE"] = "DELETE";
})(OpType || (OpType = {}));
function isPredicateObj(obj) {
    return obj && obj.field !== undefined;
}
function isPredicateGroup(obj) {
    return obj && obj.type !== undefined;
}
var QueryOne;
(function(QueryOne) {
    QueryOne[QueryOne["FIRST"] = 0] = "FIRST";
    QueryOne[QueryOne["LAST"] = 1] = "LAST";
})(QueryOne || (QueryOne = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["ASCENDING"] = "ASCENDING";
    SortDirection["DESCENDING"] = "DESCENDING";
})(SortDirection || (SortDirection = {}));
var AuthModeStrategyType;
(function(AuthModeStrategyType) {
    AuthModeStrategyType["DEFAULT"] = "DEFAULT";
    AuthModeStrategyType["MULTI_AUTH"] = "MULTI_AUTH";
})(AuthModeStrategyType || (AuthModeStrategyType = {}));
var ModelOperation;
(function(ModelOperation) {
    ModelOperation["CREATE"] = "CREATE";
    ModelOperation["READ"] = "READ";
    ModelOperation["UPDATE"] = "UPDATE";
    ModelOperation["DELETE"] = "DELETE";
})(ModelOperation || (ModelOperation = {}));
function syncExpression(modelConstructor, conditionProducer) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                {
                    modelConstructor: modelConstructor,
                    conditionProducer: conditionProducer
                }
            ];
        });
    });
}
var ProcessName;
(function(ProcessName) {
    ProcessName["sync"] = "sync";
    ProcessName["mutate"] = "mutate";
    ProcessName["subscribe"] = "subscribe";
})(ProcessName || (ProcessName = {}));
var DISCARD = Symbol("DISCARD");
var LimitTimerRaceResolvedValues;
(function(LimitTimerRaceResolvedValues) {
    LimitTimerRaceResolvedValues["LIMIT"] = "LIMIT";
    LimitTimerRaceResolvedValues["TIMER"] = "TIMER";
})(LimitTimerRaceResolvedValues || (LimitTimerRaceResolvedValues = {}));
/**
 * A pointer used by DataStore internally to lookup predicate details
 * that should not be exposed on public customer interfaces.
 */ var PredicateInternalsKey = /** @class */ function() {
    function PredicateInternalsKey() {
        this.__isPredicateInternalsKeySentinel = true;
    }
    return PredicateInternalsKey;
}();

},{"tslib":"86BcK","./util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFXfl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ID", ()=>ID);
parcelHelpers.export(exports, "DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR", ()=>DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR);
parcelHelpers.export(exports, "IDENTIFIER_KEY_SEPARATOR", ()=>IDENTIFIER_KEY_SEPARATOR);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
parcelHelpers.export(exports, "NAMESPACES", ()=>NAMESPACES);
parcelHelpers.export(exports, "USER", ()=>USER);
parcelHelpers.export(exports, "SYNC", ()=>SYNC);
parcelHelpers.export(exports, "STORAGE", ()=>STORAGE);
parcelHelpers.export(exports, "DATASTORE", ()=>DATASTORE);
parcelHelpers.export(exports, "exhaustiveCheck", ()=>exhaustiveCheck);
parcelHelpers.export(exports, "isNullOrUndefined", ()=>isNullOrUndefined);
parcelHelpers.export(exports, "validatePredicate", ()=>validatePredicate);
parcelHelpers.export(exports, "validatePredicateField", ()=>validatePredicateField);
parcelHelpers.export(exports, "isModelConstructor", ()=>isModelConstructor);
parcelHelpers.export(exports, "registerNonModelClass", ()=>registerNonModelClass);
parcelHelpers.export(exports, "isNonModelConstructor", ()=>isNonModelConstructor);
parcelHelpers.export(exports, "traverseModel", ()=>traverseModel);
parcelHelpers.export(exports, "isPrivateMode", ()=>isPrivateMode);
parcelHelpers.export(exports, "isSafariCompatabilityMode", ()=>isSafariCompatabilityMode);
parcelHelpers.export(exports, "monotonicUlidFactory", ()=>monotonicUlidFactory);
/**
 * Uses performance.now() if available, otherwise, uses Date.now() (e.g. react native without a polyfill)
 *
 * The values returned by performance.now() always increase at a constant rate,
 * independent of the system clock (which might be adjusted manually or skewed
 * by software like NTP).
 *
 * Otherwise, performance.timing.navigationStart + performance.now() will be
 * approximately equal to Date.now()
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/Performance/now#Example
 */ parcelHelpers.export(exports, "getNow", ()=>getNow);
parcelHelpers.export(exports, "sortCompareFunction", ()=>sortCompareFunction);
// deep compare any 2 values
// primitives or object types (including arrays, Sets, and Maps)
// returns true if equal by value
// if nullish is true, treat undefined and null values as equal
// to normalize for GQL response values for undefined fields
parcelHelpers.export(exports, "valuesEqual", ()=>valuesEqual);
/**
 * Statelessly extracts the specified page from an array.
 *
 * @param records - The source array to extract a page from.
 * @param pagination - A definition of the page to extract.
 * @returns This items from `records` matching the `pagination` definition.
 */ parcelHelpers.export(exports, "inMemoryPagination", ()=>inMemoryPagination);
/**
 * An `aysnc` implementation of `Array.some()`. Returns as soon as a match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if "some" items match; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncSome", ()=>asyncSome);
/**
 * An `aysnc` implementation of `Array.every()`. Returns as soon as a non-match is found.
 * @param items The items to check.
 * @param matches The async matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<boolean>`, `true` if every item matches; `false` otherwise.
 */ parcelHelpers.export(exports, "asyncEvery", ()=>asyncEvery);
/**
 * An `async` implementation of `Array.filter()`. Returns after all items have been filtered.
 * TODO: Return AsyncIterable.
 * @param items The items to filter.
 * @param matches The `async` matcher function, expected to
 * return Promise<boolean>: `true` for a matching item, `false` otherwise.
 * @returns A `Promise<T>` of matching items.
 */ parcelHelpers.export(exports, "asyncFilter", ()=>asyncFilter);
parcelHelpers.export(exports, "isAWSDate", ()=>isAWSDate);
parcelHelpers.export(exports, "isAWSTime", ()=>isAWSTime);
parcelHelpers.export(exports, "isAWSDateTime", ()=>isAWSDateTime);
parcelHelpers.export(exports, "isAWSTimestamp", ()=>isAWSTimestamp);
parcelHelpers.export(exports, "isAWSEmail", ()=>isAWSEmail);
parcelHelpers.export(exports, "isAWSJSON", ()=>isAWSJSON);
parcelHelpers.export(exports, "isAWSURL", ()=>isAWSURL);
parcelHelpers.export(exports, "isAWSPhone", ()=>isAWSPhone);
parcelHelpers.export(exports, "isAWSIPAddress", ()=>isAWSIPAddress);
parcelHelpers.export(exports, "DeferredPromise", ()=>DeferredPromise);
parcelHelpers.export(exports, "DeferredCallbackResolver", ()=>DeferredCallbackResolver);
/**
 * merge two sets of patches created by immer produce.
 * newPatches take precedent over oldPatches for patches modifying the same path.
 * In the case many consecutive pathces are merged the original model should
 * always be the root model.
 *
 * Example:
 * A -> B, patches1
 * B -> C, patches2
 *
 * mergePatches(A, patches1, patches2) to get patches for A -> C
 *
 * @param originalSource the original Model the patches should be applied to
 * @param oldPatches immer produce patch list
 * @param newPatches immer produce patch list (will take precedence)
 * @return merged patches
 */ parcelHelpers.export(exports, "mergePatches", ()=>mergePatches);
parcelHelpers.export(exports, "getStorename", ()=>getStorename);
parcelHelpers.export(exports, "processCompositeKeys", ()=>processCompositeKeys);
parcelHelpers.export(exports, "extractKeyIfExists", ()=>extractKeyIfExists);
parcelHelpers.export(exports, "extractPrimaryKeyFieldNames", ()=>extractPrimaryKeyFieldNames);
parcelHelpers.export(exports, "extractPrimaryKeyValues", ()=>extractPrimaryKeyValues);
parcelHelpers.export(exports, "extractPrimaryKeysAndValues", ()=>extractPrimaryKeysAndValues);
parcelHelpers.export(exports, "isIdManaged", ()=>isIdManaged);
parcelHelpers.export(exports, "isIdOptionallyManaged", ()=>isIdOptionallyManaged);
parcelHelpers.export(exports, "establishRelationAndKeys", ()=>establishRelationAndKeys);
parcelHelpers.export(exports, "getIndex", ()=>getIndex);
parcelHelpers.export(exports, "getIndexFromAssociation", ()=>getIndexFromAssociation);
parcelHelpers.export(exports, "extractTargetNamesFromSrc", ()=>extractTargetNamesFromSrc);
parcelHelpers.export(exports, "indexNameFromKeys", ()=>indexNameFromKeys);
parcelHelpers.export(exports, "keysEqual", ()=>keysEqual);
parcelHelpers.export(exports, "getIndexKeys", ()=>getIndexKeys);
parcelHelpers.export(exports, "getTimestampFields", ()=>getTimestampFields);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _buffer = require("buffer");
var _ulid = require("ulid");
var _uuid = require("uuid");
var _immer = require("immer");
var _types = require("./types");
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var _predicates = require("./predicates");
var ID = "id";
var DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR = "#";
var IDENTIFIER_KEY_SEPARATOR = "-";
var errorMessages = {
    idEmptyString: "An index field cannot contain an empty string value",
    queryByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be queried by a single key value. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
    deleteByPkWithCompositeKeyPresent: "Models with composite primary keys cannot be deleted by a single key value, unless using a predicate. Use object literal syntax for composite keys instead: https://docs.amplify.aws/lib/datastore/advanced-workflows/q/platform/js/#querying-records-with-custom-primary-keys",
    observeWithObjectLiteral: "Object literal syntax cannot be used with observe. Use a predicate instead: https://docs.amplify.aws/lib/datastore/data-access/q/platform/js/#predicates"
};
var NAMESPACES;
(function(NAMESPACES) {
    NAMESPACES["DATASTORE"] = "datastore";
    NAMESPACES["USER"] = "user";
    NAMESPACES["SYNC"] = "sync";
    NAMESPACES["STORAGE"] = "storage";
})(NAMESPACES || (NAMESPACES = {}));
var DATASTORE = NAMESPACES.DATASTORE;
var USER = NAMESPACES.USER;
var SYNC = NAMESPACES.SYNC;
var STORAGE = NAMESPACES.STORAGE;
var exhaustiveCheck = function(obj, throwOnError) {
    if (throwOnError === void 0) throwOnError = true;
    if (throwOnError) throw new Error("Invalid " + obj);
};
var isNullOrUndefined = function(val) {
    return typeof val === "undefined" || val === undefined || val === null;
};
var validatePredicate = function(model, groupType, predicatesOrGroups) {
    var filterType;
    var isNegation = false;
    if (predicatesOrGroups.length === 0) return true;
    switch(groupType){
        case "not":
            filterType = "every";
            isNegation = true;
            break;
        case "and":
            filterType = "every";
            break;
        case "or":
            filterType = "some";
            break;
        default:
            throw new Error("Invalid " + groupType);
    }
    var result = predicatesOrGroups[filterType](function(predicateOrGroup) {
        if ((0, _types.isPredicateObj)(predicateOrGroup)) {
            var field = predicateOrGroup.field, operator = predicateOrGroup.operator, operand = predicateOrGroup.operand;
            var value = model[field];
            return validatePredicateField(value, operator, operand);
        }
        if ((0, _types.isPredicateGroup)(predicateOrGroup)) {
            var type = predicateOrGroup.type, predicates = predicateOrGroup.predicates;
            return validatePredicate(model, type, predicates);
        }
        throw new Error("Not a predicate or group");
    });
    return isNegation ? !result : result;
};
var validatePredicateField = function(value, operator, operand) {
    switch(operator){
        case "ne":
            return value !== operand;
        case "eq":
            return value === operand;
        case "le":
            return value <= operand;
        case "lt":
            return value < operand;
        case "ge":
            return value >= operand;
        case "gt":
            return value > operand;
        case "between":
            var _c = (0, _tslib.__read)(operand, 2), min = _c[0], max = _c[1];
            return value >= min && value <= max;
        case "beginsWith":
            return !isNullOrUndefined(value) && value.startsWith(operand);
        case "contains":
            return !isNullOrUndefined(value) && value.indexOf(operand) > -1;
        case "notContains":
            return isNullOrUndefined(value) || value.indexOf(operand) === -1;
        default:
            return false;
    }
};
var isModelConstructor = function(obj) {
    return obj && typeof obj.copyOf === "function";
};
var nonModelClasses = new WeakSet();
function registerNonModelClass(clazz) {
    nonModelClasses.add(clazz);
}
var isNonModelConstructor = function(obj) {
    return nonModelClasses.has(obj);
};
var topologicallySortedModels = new WeakMap();
var traverseModel = function(srcModelName, instance, namespace, modelInstanceCreator, getModelConstructorByModelName) {
    var modelConstructor = getModelConstructorByModelName(namespace.name, srcModelName);
    var result = [];
    var newInstance = modelConstructor.copyOf(instance, function() {});
    result.unshift({
        modelName: srcModelName,
        item: newInstance,
        instance: newInstance
    });
    if (!topologicallySortedModels.has(namespace)) topologicallySortedModels.set(namespace, Array.from(namespace.modelTopologicalOrdering.keys()));
    var sortedModels = topologicallySortedModels.get(namespace);
    result.sort(function(a, b) {
        return sortedModels.indexOf(a.modelName) - sortedModels.indexOf(b.modelName);
    });
    return result;
};
var privateModeCheckResult;
var isPrivateMode = function() {
    return new Promise(function(resolve) {
        var dbname = (0, _uuid.v4)();
        var db;
        var isPrivate = function() {
            privateModeCheckResult = false;
            resolve(true);
        };
        var isNotPrivate = function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            if (!(db && db.result && typeof db.result.close === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                db.result.close()
                            ];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                indexedDB.deleteDatabase(dbname)
                            ];
                        case 3:
                            _c.sent();
                            privateModeCheckResult = true;
                            return [
                                2 /*return*/ ,
                                resolve(false)
                            ];
                    }
                });
            });
        };
        if (privateModeCheckResult === true) return isNotPrivate();
        if (privateModeCheckResult === false) return isPrivate();
        if (indexedDB === null) return isPrivate();
        db = indexedDB.open(dbname);
        db.onerror = isPrivate;
        db.onsuccess = isNotPrivate;
    });
};
var safariCompatabilityModeResult;
var isSafariCompatabilityMode = function() {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var dbName_1, storeName_1, indexName_1, db_1, rwTx, rwStore, result, error_1;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        6,
                        ,
                        7
                    ]);
                    dbName_1 = (0, _uuid.v4)();
                    storeName_1 = "indexedDBFeatureProbeStore";
                    indexName_1 = "idx";
                    if (indexedDB === null) return [
                        2 /*return*/ ,
                        false
                    ];
                    if (safariCompatabilityModeResult !== undefined) return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var dbOpenRequest = indexedDB.open(dbName_1);
                            dbOpenRequest.onerror = function() {
                                return resolve(false);
                            };
                            dbOpenRequest.onsuccess = function() {
                                var db = dbOpenRequest.result;
                                resolve(db);
                            };
                            dbOpenRequest.onupgradeneeded = function(event) {
                                var _c;
                                var db = (_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.result;
                                db.onerror = function() {
                                    return resolve(false);
                                };
                                var store = db.createObjectStore(storeName_1, {
                                    autoIncrement: true
                                });
                                store.createIndex(indexName_1, [
                                    "id"
                                ]);
                            };
                        })
                    ];
                case 1:
                    db_1 = _c.sent();
                    if (!db_1) throw new Error("Could not open probe DB");
                    rwTx = db_1.transaction(storeName_1, "readwrite");
                    rwStore = rwTx.objectStore(storeName_1);
                    rwStore.add({
                        id: 1
                    });
                    rwTx.commit();
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            var tx = db_1.transaction(storeName_1, "readonly");
                            var store = tx.objectStore(storeName_1);
                            var index = store.index(indexName_1);
                            var getRequest = index.get([
                                1
                            ]);
                            getRequest.onerror = function() {
                                return resolve(false);
                            };
                            getRequest.onsuccess = function(event) {
                                var _c;
                                resolve((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.result);
                            };
                        })
                    ];
                case 2:
                    result = _c.sent();
                    if (!(db_1 && typeof db_1.close === "function")) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        db_1.close()
                    ];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    return [
                        4 /*yield*/ ,
                        indexedDB.deleteDatabase(dbName_1)
                    ];
                case 5:
                    _c.sent();
                    if (result === undefined) safariCompatabilityModeResult = true;
                    else safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    error_1 = _c.sent();
                    safariCompatabilityModeResult = false;
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        safariCompatabilityModeResult
                    ];
            }
        });
    });
};
var randomBytes = function(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _amazonCognitoIdentityJs.WordArray)().random(nBytes).toString(), "hex");
};
var prng = function() {
    return randomBytes(1).readUInt8(0) / 0xff;
};
function monotonicUlidFactory(seed) {
    var ulid = (0, _ulid.monotonicFactory)(prng);
    return function() {
        return ulid(seed);
    };
}
function getNow() {
    if (typeof performance !== "undefined" && performance && typeof performance.now === "function") return performance.now() | 0; // convert to integer
    else return Date.now();
}
function sortCompareFunction(sortPredicates) {
    return function compareFunction(a, b) {
        var e_1, _c;
        try {
            // enable multi-field sort by iterating over predicates until
            // a comparison returns -1 or 1
            for(var sortPredicates_1 = (0, _tslib.__values)(sortPredicates), sortPredicates_1_1 = sortPredicates_1.next(); !sortPredicates_1_1.done; sortPredicates_1_1 = sortPredicates_1.next()){
                var predicate = sortPredicates_1_1.value;
                var field = predicate.field, sortDirection = predicate.sortDirection;
                // reverse result when direction is descending
                var sortMultiplier = sortDirection === (0, _types.SortDirection).ASCENDING ? 1 : -1;
                if (a[field] < b[field]) return -1 * sortMultiplier;
                if (a[field] > b[field]) return 1 * sortMultiplier;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (sortPredicates_1_1 && !sortPredicates_1_1.done && (_c = sortPredicates_1.return)) _c.call(sortPredicates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return 0;
    };
}
function valuesEqual(valA, valB, nullish) {
    var e_2, _c;
    if (nullish === void 0) nullish = false;
    var a = valA;
    var b = valB;
    var nullishCompare = function(_a, _b) {
        return (_a === undefined || _a === null) && (_b === undefined || _b === null);
    };
    // if one of the values is a primitive and the other is an object
    if (a instanceof Object && !(b instanceof Object) || !(a instanceof Object) && b instanceof Object) return false;
    // compare primitive types
    if (!(a instanceof Object)) {
        if (nullish && nullishCompare(a, b)) return true;
        return a === b;
    }
    // make sure object types match
    if (Array.isArray(a) && !Array.isArray(b) || Array.isArray(b) && !Array.isArray(a)) return false;
    if (a instanceof Set && b instanceof Set) {
        a = (0, _tslib.__spread)(a);
        b = (0, _tslib.__spread)(b);
    }
    if (a instanceof Map && b instanceof Map) {
        a = Object.fromEntries(a);
        b = Object.fromEntries(b);
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    // last condition is to ensure that [] !== [null] even if nullish. However [undefined] === [null] when nullish
    if (aKeys.length !== bKeys.length && (!nullish || Array.isArray(a))) return false;
    // iterate through the longer set of keys
    // e.g., for a nullish comparison of a={ a: 1 } and b={ a: 1, b: null }
    // we want to iterate through bKeys
    var keys = aKeys.length >= bKeys.length ? aKeys : bKeys;
    try {
        for(var keys_1 = (0, _tslib.__values)(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
            var key = keys_1_1.value;
            var aVal = a[key];
            var bVal = b[key];
            if (!valuesEqual(aVal, bVal, nullish)) return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (keys_1_1 && !keys_1_1.done && (_c = keys_1.return)) _c.call(keys_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function inMemoryPagination(records, pagination) {
    if (pagination && records.length > 1) {
        if (pagination.sort) {
            var sortPredicates = (0, _predicates.ModelSortPredicateCreator).getPredicates(pagination.sort);
            if (sortPredicates.length) {
                var compareFn = sortCompareFunction(sortPredicates);
                records.sort(compareFn);
            }
        }
        var _c = pagination.page, page = _c === void 0 ? 0 : _c, _d = pagination.limit, limit = _d === void 0 ? 0 : _d;
        var start = Math.max(0, page * limit) || 0;
        var end = limit > 0 ? start + limit : records.length;
        return records.slice(start, end);
    }
    return records;
}
function asyncSome(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_1, items_1_1, item, e_3_1;
        var e_3, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                    _d.label = 1;
                case 1:
                    if (!!items_1_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_1_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (_d.sent()) return [
                        2 /*return*/ ,
                        true
                    ];
                    _d.label = 3;
                case 3:
                    items_1_1 = items_1.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_3_1 = _d.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_1_1 && !items_1_1.done && (_c = items_1.return)) _c.call(items_1);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        false
                    ];
            }
        });
    });
}
function asyncEvery(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var items_2, items_2_1, item, e_4_1;
        var e_4, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _d.trys.push([
                        0,
                        5,
                        6,
                        7
                    ]);
                    items_2 = (0, _tslib.__values)(items), items_2_1 = items_2.next();
                    _d.label = 1;
                case 1:
                    if (!!items_2_1.done) return [
                        3 /*break*/ ,
                        4
                    ];
                    item = items_2_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 2:
                    if (!_d.sent()) return [
                        2 /*return*/ ,
                        false
                    ];
                    _d.label = 3;
                case 3:
                    items_2_1 = items_2.next();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 4:
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 5:
                    e_4_1 = _d.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        7
                    ];
                case 6:
                    try {
                        if (items_2_1 && !items_2_1.done && (_c = items_2.return)) _c.call(items_2);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        true
                    ];
            }
        });
    });
}
function asyncFilter(items, matches) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var results, items_3, items_3_1, item, e_5_1;
        var e_5, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    results = [];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    items_3 = (0, _tslib.__values)(items), items_3_1 = items_3.next();
                    _d.label = 2;
                case 2:
                    if (!!items_3_1.done) return [
                        3 /*break*/ ,
                        5
                    ];
                    item = items_3_1.value;
                    return [
                        4 /*yield*/ ,
                        matches(item)
                    ];
                case 3:
                    if (_d.sent()) results.push(item);
                    _d.label = 4;
                case 4:
                    items_3_1 = items_3.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 5:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 6:
                    e_5_1 = _d.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    try {
                        if (items_3_1 && !items_3_1.done && (_c = items_3.return)) _c.call(items_3);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 8:
                    return [
                        2 /*return*/ ,
                        results
                    ];
            }
        });
    });
}
var isAWSDate = function(val) {
    return !!/^\d{4}-\d{2}-\d{2}(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTime = function(val) {
    return !!/^\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSDateTime = function(val) {
    return !!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(.\d+)?)?(Z|[+-]\d{2}:\d{2}($|:\d{2}))?$/.exec(val);
};
var isAWSTimestamp = function(val) {
    return !!/^\d+$/.exec(String(val));
};
var isAWSEmail = function(val) {
    return !!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.exec(val);
};
var isAWSJSON = function(val) {
    try {
        JSON.parse(val);
        return true;
    } catch (_c) {
        return false;
    }
};
var isAWSURL = function(val) {
    try {
        return new URL(val), true;
    } catch (_c) {
        return false;
    }
};
var isAWSPhone = function(val) {
    return !!/^\+?\d[\d\s-]+$/.exec(val);
};
var isAWSIPAddress = function(val) {
    return !!/((^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$)|(^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?$))$/.exec(val);
};
var DeferredPromise = /** @class */ function() {
    function DeferredPromise() {
        var self = this;
        this.promise = new Promise(function(resolve, reject) {
            self.resolve = resolve;
            self.reject = reject;
        });
    }
    return DeferredPromise;
}();
var DeferredCallbackResolver = /** @class */ function() {
    function DeferredCallbackResolver(options) {
        this.limitPromise = new DeferredPromise();
        this.raceInFlight = false;
        this.callback = function() {};
        this.defaultErrorHandler = function(msg) {
            if (msg === void 0) msg = "DeferredCallbackResolver error";
            throw new Error(msg);
        };
        this.callback = options.callback;
        this.errorHandler = options.errorHandler || this.defaultErrorHandler;
        this.maxInterval = options.maxInterval || 2000;
    }
    DeferredCallbackResolver.prototype.startTimer = function() {
        var _this = this;
        this.timerPromise = new Promise(function(resolve, reject) {
            _this.timer = setTimeout(function() {
                resolve((0, _types.LimitTimerRaceResolvedValues).TIMER);
            }, _this.maxInterval);
        });
    };
    DeferredCallbackResolver.prototype.racePromises = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var winner, err_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        this.raceInFlight = true;
                        this.startTimer();
                        return [
                            4 /*yield*/ ,
                            Promise.race([
                                this.timerPromise,
                                this.limitPromise.promise
                            ])
                        ];
                    case 1:
                        winner = _c.sent();
                        this.callback();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        err_1 = _c.sent();
                        this.errorHandler(err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        // reset for the next race
                        this.clear();
                        this.raceInFlight = false;
                        this.limitPromise = new DeferredPromise();
                        return [
                            2 /*return*/ ,
                            winner
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    DeferredCallbackResolver.prototype.start = function() {
        if (!this.raceInFlight) this.racePromises();
    };
    DeferredCallbackResolver.prototype.clear = function() {
        clearTimeout(this.timer);
    };
    DeferredCallbackResolver.prototype.resolve = function() {
        this.limitPromise.resolve((0, _types.LimitTimerRaceResolvedValues).LIMIT);
    };
    return DeferredCallbackResolver;
}();
function mergePatches(originalSource, oldPatches, newPatches) {
    var patchesToMerge = oldPatches.concat(newPatches);
    var patches;
    (0, _immer.produce)(originalSource, function(draft) {
        (0, _immer.applyPatches)(draft, patchesToMerge);
    }, function(p) {
        patches = p;
    });
    return patches;
}
var getStorename = function(namespace, modelName) {
    var storeName = namespace + "_" + modelName;
    return storeName;
};
var processCompositeKeys = function(attributes) {
    var extractCompositeSortKey = function(_c) {
        var // ignore the HK (fields[0]) we only need to include the composite sort key fields[1...n]
        _d = (0, _tslib.__read)(_c.properties.fields), sortKeyFields = _d.slice(1);
        return sortKeyFields;
    };
    var compositeKeyFields = attributes.filter((0, _types.isModelAttributeCompositeKey)).map(extractCompositeSortKey);
    /*
        if 2 sets of fields have any intersecting fields => combine them into 1 union set
        e.g., ['a', 'b', 'c'] and ['a', 'b', 'd'] => ['a', 'b', 'c', 'd']
    */ var combineIntersecting = function(fields) {
        return fields.reduce(function(combined, sortKeyFields) {
            var sortKeyFieldsSet = new Set(sortKeyFields);
            if (combined.length === 0) {
                combined.push(sortKeyFieldsSet);
                return combined;
            }
            // does the current set share values with another set we've already added to `combined`?
            var intersectingSetIdx = combined.findIndex(function(existingSet) {
                return (0, _tslib.__spread)(existingSet).some(function(f) {
                    return sortKeyFieldsSet.has(f);
                });
            });
            if (intersectingSetIdx > -1) {
                var union = new Set((0, _tslib.__spread)(combined[intersectingSetIdx], sortKeyFieldsSet));
                // combine the current set with the intersecting set we found above
                combined[intersectingSetIdx] = union;
            } else // none of the sets in `combined` have intersecting values with the current set
            combined.push(sortKeyFieldsSet);
            return combined;
        }, []);
    };
    var initial = combineIntersecting(compositeKeyFields);
    // a single pass pay not be enough to correctly combine all the fields
    // call the function once more to get a final merged list of sets
    var combined = combineIntersecting(initial);
    return combined;
};
var extractKeyIfExists = function(modelDefinition) {
    var _c;
    var keyAttribute = (_c = modelDefinition === null || modelDefinition === void 0 ? void 0 : modelDefinition.attributes) === null || _c === void 0 ? void 0 : _c.find((0, _types.isModelAttributeKey));
    return keyAttribute;
};
var extractPrimaryKeyFieldNames = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields;
    return [
        ID
    ];
};
var extractPrimaryKeyValues = function(model, keyFields) {
    return keyFields.map(function(key) {
        return model[key];
    });
};
var extractPrimaryKeysAndValues = function(model, keyFields) {
    var primaryKeysAndValues = {};
    keyFields.forEach(function(key) {
        return primaryKeysAndValues[key] = model[key];
    });
    return primaryKeysAndValues;
};
var isIdManaged = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return false;
    return true;
};
var isIdOptionallyManaged = function(modelDefinition) {
    var keyAttribute = extractKeyIfExists(modelDefinition);
    if (keyAttribute && (0, _types.isModelAttributePrimaryKey)(keyAttribute)) return keyAttribute.properties.fields[0] === ID;
    return false;
};
var establishRelationAndKeys = function(namespace) {
    var relationship = {};
    var keys = {};
    Object.keys(namespace.models).forEach(function(mKey) {
        var e_6, _c;
        relationship[mKey] = {
            indexes: [],
            relationTypes: []
        };
        keys[mKey] = {};
        var model = namespace.models[mKey];
        Object.keys(model.fields).forEach(function(attr) {
            var fieldAttribute = model.fields[attr];
            if (typeof fieldAttribute.type === "object" && "model" in fieldAttribute.type) {
                var connectionType = fieldAttribute.association.connectionType;
                relationship[mKey].relationTypes.push({
                    fieldName: fieldAttribute.name,
                    modelName: fieldAttribute.type.model,
                    relationType: connectionType,
                    targetName: fieldAttribute.association["targetName"],
                    targetNames: fieldAttribute.association["targetNames"],
                    associatedWith: fieldAttribute.association["associatedWith"]
                });
                if (connectionType === "BELONGS_TO") {
                    var targetNames = extractTargetNamesFromSrc(fieldAttribute.association);
                    if (targetNames) {
                        var idxName_1 = indexNameFromKeys(targetNames);
                        var idxExists = relationship[mKey].indexes.find(function(_c) {
                            var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                            return index === idxName_1;
                        });
                        if (!idxExists) relationship[mKey].indexes.push([
                            idxName_1,
                            targetNames
                        ]);
                    }
                }
            }
        });
        if (model.attributes) {
            keys[mKey].compositeKeys = processCompositeKeys(model.attributes);
            var _loop_1 = function(attribute) {
                if (!(0, _types.isModelAttributeKey)(attribute)) return "continue";
                var fields = attribute.properties.fields;
                if ((0, _types.isModelAttributePrimaryKey)(attribute)) {
                    keys[mKey].primaryKey = fields;
                    return "continue";
                }
                // create indexes for all other keys
                var idxName = indexNameFromKeys(fields);
                var idxExists = relationship[mKey].indexes.find(function(_c) {
                    var _d = (0, _tslib.__read)(_c, 1), index = _d[0];
                    return index === idxName;
                });
                if (!idxExists) relationship[mKey].indexes.push([
                    idxName,
                    fields
                ]);
            };
            try {
                for(var _d = (0, _tslib.__values)(model.attributes), _e = _d.next(); !_e.done; _e = _d.next()){
                    var attribute = _e.value;
                    _loop_1(attribute);
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
        }
        // set 'id' as the PK for models without a custom PK explicitly defined
        if (!keys[mKey].primaryKey) keys[mKey].primaryKey = [
            ID
        ];
        // create primary index
        relationship[mKey].indexes.push([
            "byPk",
            keys[mKey].primaryKey,
            {
                unique: true
            }
        ]);
    });
    return [
        relationship,
        keys
    ];
};
var getIndex = function(rel, src) {
    var indexName;
    rel.some(function(relItem) {
        if (relItem.modelName === src) {
            var targetNames = extractTargetNamesFromSrc(relItem);
            indexName = targetNames && indexNameFromKeys(targetNames);
            return true;
        }
    });
    return indexName;
};
var getIndexFromAssociation = function(indexes, src) {
    var indexName;
    if (Array.isArray(src)) indexName = indexNameFromKeys(src);
    else indexName = src;
    var associationIndex = indexes.find(function(_c) {
        var _d = (0, _tslib.__read)(_c, 1), idxName = _d[0];
        return idxName === indexName;
    });
    return associationIndex && associationIndex[0];
};
var extractTargetNamesFromSrc = function(src) {
    var targetName = src === null || src === void 0 ? void 0 : src.targetName;
    var targetNames = src === null || src === void 0 ? void 0 : src.targetNames;
    if (Array.isArray(targetNames)) return targetNames;
    else if (typeof targetName === "string") return [
        targetName
    ];
    else return undefined;
};
var indexNameFromKeys = function(keys) {
    return keys.reduce(function(prev, cur, idx) {
        if (idx === 0) return cur;
        return "" + prev + IDENTIFIER_KEY_SEPARATOR + cur;
    }, "");
};
var keysEqual = function(keysA, keysB) {
    if (keysA.length !== keysB.length) return false;
    return keysA.every(function(key, idx) {
        return key === keysB[idx];
    });
};
var getIndexKeys = function(namespace, modelName) {
    var _c, _d;
    var keyPath = (_d = (_c = namespace === null || namespace === void 0 ? void 0 : namespace.keys) === null || _c === void 0 ? void 0 : _c[modelName]) === null || _d === void 0 ? void 0 : _d.primaryKey;
    if (keyPath) return keyPath;
    return [
        ID
    ];
};
var getTimestampFields = function(definition) {
    var _c, _d;
    var modelAttributes = (_c = definition.attributes) === null || _c === void 0 ? void 0 : _c.find(function(attr) {
        return attr.type === "model";
    });
    var timestampFieldsMap = (_d = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _d === void 0 ? void 0 : _d.timestamps;
    var defaultFields = {
        createdAt: "createdAt",
        updatedAt: "updatedAt"
    };
    var customFields = timestampFieldsMap || {};
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultFields), customFields);
};

},{"tslib":"86BcK","buffer":"7NC4b","ulid":"c7Ar3","uuid":"bpprZ","immer":"8nxw2","./types":"9W0ar","amazon-cognito-identity-js":"aZxGG","./predicates":"bohgw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7NC4b":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var global = arguments[3];
"use strict";
var base64 = require("8912f9896669a94d");
var ieee754 = require("cef07915f0cfc4ed");
var isArray = require("7fecdd7358c4d78c");
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
/*
 * Export kMaxLength after typed array support is determined.
 */ exports.kMaxLength = kMaxLength();
function typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
Buffer.compare = function compare(a, b) {
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

},{"8912f9896669a94d":"MlSYJ","cef07915f0cfc4ed":"15Xnl","7fecdd7358c4d78c":"9gjbG"}],"c7Ar3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceCharAt", ()=>replaceCharAt);
parcelHelpers.export(exports, "incrementBase32", ()=>incrementBase32);
parcelHelpers.export(exports, "randomChar", ()=>randomChar);
parcelHelpers.export(exports, "encodeTime", ()=>encodeTime);
parcelHelpers.export(exports, "encodeRandom", ()=>encodeRandom);
parcelHelpers.export(exports, "decodeTime", ()=>decodeTime);
parcelHelpers.export(exports, "detectPrng", ()=>detectPrng);
parcelHelpers.export(exports, "factory", ()=>factory);
parcelHelpers.export(exports, "monotonicFactory", ()=>monotonicFactory);
parcelHelpers.export(exports, "ulid", ()=>ulid);
function createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function replaceCharAt(str, index, char) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + char + str.substr(index + 1);
}
function incrementBase32(str) {
    var done = undefined;
    var index = str.length;
    var char = void 0;
    var charIndex = void 0;
    var maxCharIndex = ENCODING_LEN - 1;
    while(!done && index-- >= 0){
        char = str[index];
        charIndex = ENCODING.indexOf(char);
        if (charIndex === -1) throw createError("incorrectly encoded string");
        if (charIndex === maxCharIndex) {
            str = replaceCharAt(str, index, ENCODING[0]);
            continue;
        }
        done = replaceCharAt(str, index, ENCODING[charIndex + 1]);
    }
    if (typeof done === "string") return done;
    throw createError("cannot increment this string");
}
function randomChar(prng) {
    var rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) rand = ENCODING_LEN - 1;
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) throw new Error(now + " must be a number");
    if (now > TIME_MAX) throw createError("cannot encode time greater than " + TIME_MAX);
    if (now < 0) throw createError("time must be positive");
    if (Number.isInteger(now) === false) throw createError("time must be an integer");
    var mod = void 0;
    var str = "";
    for(; len > 0; len--){
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    var str = "";
    for(; len > 0; len--)str = randomChar(prng) + str;
    return str;
}
function decodeTime(id) {
    if (id.length !== TIME_LEN + RANDOM_LEN) throw createError("malformed ulid");
    var time = id.substr(0, TIME_LEN).split("").reverse().reduce(function(carry, char, index) {
        var encodingIndex = ENCODING.indexOf(char);
        if (encodingIndex === -1) throw createError("invalid character found: " + char);
        return carry += encodingIndex * Math.pow(ENCODING_LEN, index);
    }, 0);
    if (time > TIME_MAX) throw createError("malformed ulid, timestamp too large");
    return time;
}
function detectPrng() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];
    if (!root) root = typeof window !== "undefined" ? window : null;
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) return function() {
        var buffer = new Uint8Array(1);
        browserCrypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
    else try {
        var nodeCrypto = require("1002b1ce995ee642");
        return function() {
            return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
        };
    } catch (e) {}
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function() {
            return Math.random();
        };
    }
    throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
    };
}
function monotonicFactory(currPrng) {
    if (!currPrng) currPrng = detectPrng();
    var lastTime = 0;
    var lastRandom = void 0;
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        if (seedTime <= lastTime) {
            var incrementedRandom = lastRandom = incrementBase32(lastRandom);
            return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        var newRandom = lastRandom = encodeRandom(RANDOM_LEN, currPrng);
        return encodeTime(seedTime, TIME_LEN) + newRandom;
    };
}
var ulid = factory();

},{"1002b1ce995ee642":"bkmob","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkmob":[function(require,module,exports) {

},{}],"aZxGG":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticationDetails", ()=>(0, _authenticationDetailsDefault.default));
parcelHelpers.export(exports, "AuthenticationHelper", ()=>(0, _authenticationHelperDefault.default));
parcelHelpers.export(exports, "CognitoAccessToken", ()=>(0, _cognitoAccessTokenDefault.default));
parcelHelpers.export(exports, "CognitoIdToken", ()=>(0, _cognitoIdTokenDefault.default));
parcelHelpers.export(exports, "CognitoRefreshToken", ()=>(0, _cognitoRefreshTokenDefault.default));
parcelHelpers.export(exports, "CognitoUser", ()=>(0, _cognitoUserDefault.default));
parcelHelpers.export(exports, "CognitoUserAttribute", ()=>(0, _cognitoUserAttributeDefault.default));
parcelHelpers.export(exports, "CognitoUserPool", ()=>(0, _cognitoUserPoolDefault.default));
parcelHelpers.export(exports, "CognitoUserSession", ()=>(0, _cognitoUserSessionDefault.default));
parcelHelpers.export(exports, "CookieStorage", ()=>(0, _cookieStorageDefault.default));
parcelHelpers.export(exports, "DateHelper", ()=>(0, _dateHelperDefault.default));
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>(0, _userAgent.appendToCognitoUserAgent));
parcelHelpers.export(exports, "WordArray", ()=>(0, _wordArrayDefault.default));
var _authenticationDetails = require("./AuthenticationDetails");
var _authenticationDetailsDefault = parcelHelpers.interopDefault(_authenticationDetails);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _cognitoUserPool = require("./CognitoUserPool");
var _cognitoUserPoolDefault = parcelHelpers.interopDefault(_cognitoUserPool);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _cookieStorage = require("./CookieStorage");
var _cookieStorageDefault = parcelHelpers.interopDefault(_cookieStorage);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _userAgent = require("./UserAgent");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);

},{"./AuthenticationDetails":"2ViUu","./AuthenticationHelper":"iS1QL","./CognitoAccessToken":"6WV2t","./CognitoIdToken":"2EiGX","./CognitoRefreshToken":"c3n1E","./CognitoUser":"3eE33","./CognitoUserAttribute":"2Fxcf","./CognitoUserPool":"47LVS","./CognitoUserSession":"lX9c1","./CookieStorage":"2p086","./DateHelper":"fkM7A","./UserAgent":"8nozO","./utils/WordArray":"aKRvT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ViUu":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationDetails);
var AuthenticationDetails = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iS1QL":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticationHelper);
var _buffer = require("buffer");
var _wordArray = require("./utils/WordArray");
var _wordArrayDefault = parcelHelpers.interopDefault(_wordArray);
var _sha256Js = require("@aws-crypto/sha256-js");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function randomBytes(nBytes) {
    return (0, _buffer.Buffer).from(new (0, _wordArrayDefault.default)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var AuthenticationHelper = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, _bigIntegerDefault.default)(initN, 16);
        this.g = new (0, _bigIntegerDefault.default)("2", 16);
        this.k = new (0, _bigIntegerDefault.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, _buffer.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = randomBytes(128).toString("hex");
        var randomBigInt = new (0, _bigIntegerDefault.default)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, _bigIntegerDefault.default)(hexRandom, 16));
        this.g.modPow(new (0, _bigIntegerDefault.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, _bigIntegerDefault.default).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, _bigIntegerDefault.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, _sha256Js.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, _buffer.Buffer).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, _buffer.Buffer).concat([
            this.infoBits,
            (0, _buffer.Buffer).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, _sha256Js.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, _sha256Js.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, _bigIntegerDefault.default).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, _bigIntegerDefault.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, _buffer.Buffer).from(_this4.padHex(sValue), "hex"), (0, _buffer.Buffer).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, _bigIntegerDefault.default))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, _bigIntegerDefault.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, _bigIntegerDefault.default)(invertedNibbles, 16).add((0, _bigIntegerDefault.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

},{"buffer":"7NC4b","./utils/WordArray":"aKRvT","@aws-crypto/sha256-js":"1pg4I","./BigInteger":"jWnuZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aKRvT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WordArray);
var _cryptoSecureRandomInt = require("./cryptoSecureRandomInt");
var _cryptoSecureRandomIntDefault = parcelHelpers.interopDefault(_cryptoSecureRandomInt);
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var WordArray = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, _cryptoSecureRandomIntDefault.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return hexStringify(this);
    };
    return WordArray;
}();

},{"./cryptoSecureRandomInt":"deTnM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"deTnM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cryptoSecureRandomInt);
var global = arguments[3];
var crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
// Native crypto import via require (NodeJS)
if (!crypto && true) try {
    crypto = require("5a9a4b2c2dadb055");
} catch (err) {}
function cryptoSecureRandomInt() {
    if (crypto) {
        // Use getRandomValues method (Browser)
        if (typeof crypto.getRandomValues === "function") try {
            return crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof crypto.randomBytes === "function") try {
            return crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}

},{"5a9a4b2c2dadb055":"ixEMk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jWnuZ":[function(require,module,exports) {
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function nbi() {
    return new BigInteger(null);
}
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
    BigInteger.prototype.am = am2;
    dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
    BigInteger.prototype.am = am1;
    dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr, vv;
rr = "0".charCodeAt(0);
for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
function int2char(n) {
    return BI_RM.charAt(n);
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function bnNegate() {
    var r = nbi();
    BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = nbi();
    var y = nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function bnMod(a) {
    var r = nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function bnAdd(a) {
    var r = nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function bnSubtract(a) {
    var r = nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function bnMultiply(a) {
    var r = nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function bnDivide(a) {
    var r = nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function montConvert(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function montRevert(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
// (public) this^e % m (HAC 14.85)
function bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = nbv(1), z = new Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
    i = nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo;
// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow;
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6WV2t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoAccessToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoAccessToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"1TOTK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1TOTK":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoJwtToken);
var _buffer = require("buffer");
/** @class */ var CognitoJwtToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, _buffer.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

},{"buffer":"7NC4b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2EiGX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoIdToken);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var _cognitoJwtToken = require("./CognitoJwtToken");
var _cognitoJwtTokenDefault = parcelHelpers.interopDefault(_cognitoJwtToken);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** @class */ var CognitoIdToken = /*#__PURE__*/ function(_CognitoJwtToken) {
    _inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, _cognitoJwtTokenDefault.default));

},{"./CognitoJwtToken":"1TOTK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c3n1E":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoRefreshToken);
var CognitoRefreshToken = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3eE33":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUser);
var _buffer = require("buffer");
var _sha256Js = require("@aws-crypto/sha256-js");
var _platform = require("./Platform");
var _bigInteger = require("./BigInteger");
var _bigIntegerDefault = parcelHelpers.interopDefault(_bigInteger);
var _authenticationHelper = require("./AuthenticationHelper");
var _authenticationHelperDefault = parcelHelpers.interopDefault(_authenticationHelper);
var _cognitoAccessToken = require("./CognitoAccessToken");
var _cognitoAccessTokenDefault = parcelHelpers.interopDefault(_cognitoAccessToken);
var _cognitoIdToken = require("./CognitoIdToken");
var _cognitoIdTokenDefault = parcelHelpers.interopDefault(_cognitoIdToken);
var _cognitoRefreshToken = require("./CognitoRefreshToken");
var _cognitoRefreshTokenDefault = parcelHelpers.interopDefault(_cognitoRefreshToken);
var _cognitoUserSession = require("./CognitoUserSession");
var _cognitoUserSessionDefault = parcelHelpers.interopDefault(_cognitoUserSession);
var _dateHelper = require("./DateHelper");
var _dateHelperDefault = parcelHelpers.interopDefault(_dateHelper);
var _cognitoUserAttribute = require("./CognitoUserAttribute");
var _cognitoUserAttributeDefault = parcelHelpers.interopDefault(_cognitoUserAttribute);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var isNavigatorAvailable = typeof navigator !== "undefined";
var userAgent = isNavigatorAvailable ? (0, _platform.Platform).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var CognitoUser = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var dateHelper = new (0, _dateHelperDefault.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, _buffer.Buffer).from(_this2.username, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.deviceGroupKey);
        var dateHelper = new (0, _dateHelperDefault.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, _bigIntegerDefault.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, _bigIntegerDefault.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, _buffer.Buffer).concat([
                        (0, _buffer.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, _buffer.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, _buffer.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, _buffer.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, _sha256Js.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, _buffer.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, _authenticationHelperDefault.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, _authenticationHelperDefault.default)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, _buffer.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, _buffer.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, _cognitoUserAttributeDefault.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, _cognitoIdTokenDefault.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, _cognitoAccessTokenDefault.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, _cognitoRefreshTokenDefault.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, _cognitoUserSessionDefault.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, _cognitoIdTokenDefault.default)(authResult);
        var accessToken = new (0, _cognitoAccessTokenDefault.default)(authResult);
        var refreshToken = new (0, _cognitoRefreshTokenDefault.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, _cognitoUserSessionDefault.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

},{"buffer":"7NC4b","@aws-crypto/sha256-js":"1pg4I","./Platform":"cy6xc","./BigInteger":"jWnuZ","./AuthenticationHelper":"iS1QL","./CognitoAccessToken":"6WV2t","./CognitoIdToken":"2EiGX","./CognitoRefreshToken":"c3n1E","./CognitoUserSession":"lX9c1","./DateHelper":"fkM7A","./CognitoUserAttribute":"2Fxcf","./StorageHelper":"2LjYS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cy6xc":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Platform", ()=>Platform);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
var _version = require("./version");
var BASE_USER_AGENT = "aws-amplify/" + (0, _version.version);
var Platform = {
    userAgent: BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var getUserAgent = function getUserAgent() {
    return Platform.userAgent;
};
/**
 * @deprecated use named import
 */ exports.default = Platform;

},{"./version":"57OWh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"57OWh":[function(require,module,exports) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "5.0.4";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lX9c1":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserSession);
var CognitoUserSession = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fkM7A":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateHelper);
var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var DateHelper = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = weekNames[now.getUTCDay()];
        var month = monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Fxcf":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserAttribute);
var CognitoUserAttribute = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LjYS":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", ()=>MemoryStorage);
parcelHelpers.export(exports, "default", ()=>StorageHelper);
var dataMemory = {};
var MemoryStorage = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var StorageHelper = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47LVS":[function(require,module,exports) {
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CognitoUserPool);
var _client = require("./Client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _cognitoUser = require("./CognitoUser");
var _cognitoUserDefault = parcelHelpers.interopDefault(_cognitoUser);
var _storageHelper = require("./StorageHelper");
var _storageHelperDefault = parcelHelpers.interopDefault(_storageHelper);
var USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var CognitoUserPool = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, _clientDefault.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, _storageHelperDefault.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, _cognitoUserDefault.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, _cognitoUserDefault.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

},{"./Client":"hmpkw","./CognitoUser":"3eE33","./StorageHelper":"2LjYS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hmpkw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Client);
var _isomorphicUnfetch = require("isomorphic-unfetch");
var _userAgent = require("./UserAgent");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var CognitoError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/** @class */ var Client = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, _userAgent.getAmplifyUserAgent)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var NonRetryableError = /*#__PURE__*/ function(_Error2) {
    _inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
var isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        logger.debug("error on " + functionToRetry.name, err);
        if (isNonRetryableError(err)) {
            logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var MAX_DELAY_MS = 300000;
function jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = MAX_DELAY_MS;
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
}

},{"isomorphic-unfetch":"cSe6x","./UserAgent":"8nozO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nozO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendToCognitoUserAgent", ()=>appendToCognitoUserAgent);
parcelHelpers.export(exports, "addAuthCategoryToCognitoUserAgent", ()=>addAuthCategoryToCognitoUserAgent);
parcelHelpers.export(exports, "addFrameworkToCognitoUserAgent", ()=>addFrameworkToCognitoUserAgent);
parcelHelpers.export(exports, "getAmplifyUserAgent", ()=>getAmplifyUserAgent);
var _platform = require("./Platform");
var _constants = require("./Platform/constants");
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = (0, _platform.getUserAgent)();
var appendToCognitoUserAgent = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if (UserAgent.prototype.userAgent && !UserAgent.prototype.userAgent.includes(content)) UserAgent.prototype.userAgent = UserAgent.prototype.userAgent.concat(" ", content);
    if (!UserAgent.prototype.userAgent || UserAgent.prototype.userAgent === "") UserAgent.prototype.userAgent = content;
};
var addAuthCategoryToCognitoUserAgent = function addAuthCategoryToCognitoUserAgent() {
    UserAgent.category = (0, _constants.AUTH_CATEGORY);
};
var addFrameworkToCognitoUserAgent = function addFrameworkToCognitoUserAgent(framework) {
    UserAgent.framework = framework;
};
var getAmplifyUserAgent = function getAmplifyUserAgent(action) {
    var uaCategoryAction = UserAgent.category ? " " + UserAgent.category : "";
    var uaFramework = UserAgent.framework ? " framework/" + UserAgent.framework : "";
    var userAgent = "" + UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
// class for defining the amzn user-agent
exports.default = UserAgent;

},{"./Platform":"cy6xc","./Platform/constants":"9qX2d","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9qX2d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FRAMEWORK", ()=>FRAMEWORK);
parcelHelpers.export(exports, "AUTH_CATEGORY", ()=>AUTH_CATEGORY);
var FRAMEWORK = {
    None: "0",
    ReactNative: "1"
};
var AUTH_CATEGORY = "auth";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2p086":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CookieStorage);
var _jsCookie = require("js-cookie");
/** @class */ var CookieStorage = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        _jsCookie.set(key, value, options);
        return _jsCookie.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return _jsCookie.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return _jsCookie.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = _jsCookie.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

},{"js-cookie":"7G5HO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bohgw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>(0, _sort.ModelSortPredicateCreator));
parcelHelpers.export(exports, "isPredicatesAll", ()=>isPredicatesAll);
parcelHelpers.export(exports, "comparisonKeys", ()=>comparisonKeys);
parcelHelpers.export(exports, "PredicateAll", ()=>PredicateAll);
parcelHelpers.export(exports, "Predicates", ()=>Predicates);
parcelHelpers.export(exports, "ModelPredicateCreator", ()=>ModelPredicateCreator);
var _tslib = require("tslib");
var _util = require("../util");
var _sort = require("./sort");
var predicatesAllSet = new WeakSet();
function isPredicatesAll(predicate) {
    return predicatesAllSet.has(predicate);
}
/**
 * The valid logical grouping keys for a predicate group.
 */ var groupKeys = new Set([
    "and",
    "or",
    "not"
]);
/**
 * Determines whether an object is a GraphQL style predicate "group", which must be an
 * object containing a single "group key", which then contains the child condition(s).
 *
 * E.g.,
 *
 * ```
 * { and: [ ... ] }
 * { not: { ... } }
 * ```
 *
 * @param o The object to test.
 */ var isGroup = function(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return keys.length === 1 && groupKeys.has(keys[0]);
};
/**
 * Determines whether an object specifies no conditions and should match everything,
 * as would be the case with `Predicates.ALL`.
 *
 * @param o The object to test.
 */ var isEmpty = function(o) {
    return !Array.isArray(o) && Object.keys(o).length === 0;
};
var comparisonKeys = new Set([
    "eq",
    "ne",
    "gt",
    "lt",
    "ge",
    "le",
    "contains",
    "notContains",
    "beginsWith",
    "between"
]);
/**
 * Determines whether an object is a GraphQL style predicate comparison node, which must
 * be an object containing a single "comparison operator" key, which then contains the
 * operand or operands to compare against.
 *
 * @param o The object to test.
 */ var isComparison = function(o) {
    var keys = (0, _tslib.__spread)(Object.keys(o));
    return !Array.isArray(o) && keys.length === 1 && comparisonKeys.has(keys[0]);
};
/**
 * A light check to determine whether an object is a valid GraphQL Condition AST.
 *
 * @param o The object to test.
 */ var isValid = function(o) {
    if (Array.isArray(o)) return o.every(function(v) {
        return isValid(v);
    });
    else return Object.keys(o).length <= 1;
};
var PredicateAll = Symbol("A predicate that matches all records");
var Predicates = /** @class */ function() {
    function Predicates() {}
    Object.defineProperty(Predicates, "ALL", {
        get: function() {
            var predicate = function(c) {
                return c;
            };
            predicatesAllSet.add(predicate);
            return predicate;
        },
        enumerable: true,
        configurable: true
    });
    return Predicates;
}();
var ModelPredicateCreator = /** @class */ function() {
    function ModelPredicateCreator() {}
    /**
     * Determines whether the given storage predicate (lookup key) is a predicate
     * key that DataStore recognizes.
     *
     * @param predicate The storage predicate (lookup key) to test.
     */ ModelPredicateCreator.isValidPredicate = function(predicate) {
        return ModelPredicateCreator.predicateGroupsMap.has(predicate);
    };
    /**
     * Looks for the storage predicate AST that corresponds to a given storage
     * predicate key.
     *
     * The key must have been created internally by a DataStore utility
     * method, such as `ModelPredicate.createFromAST()`.
     *
     * @param predicate The predicate reference to look up.
     * @param throwOnInvalid Whether to throw an exception if the predicate
     * isn't a valid DataStore predicate.
     */ ModelPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelPredicateCreator.isValidPredicate(predicate)) throw new Error("The predicate is not valid");
        return ModelPredicateCreator.predicateGroupsMap.get(predicate);
    };
    /**
     * using the PK values from the given `model` (which can be a partial of T
     * Creates a predicate that matches an instance described by `modelDefinition`
     * that contains only PK field values.)
     *
     * @param modelDefinition The model definition to create a predicate for.
     * @param model The model instance to extract value equalities from.
     */ ModelPredicateCreator.createForPk = function(modelDefinition, model) {
        var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
        var keyValues = (0, _util.extractPrimaryKeyValues)(model, keyFields);
        var predicate = this.createFromAST(modelDefinition, {
            and: keyFields.map(function(field, idx) {
                var _a;
                var operand = keyValues[idx];
                return _a = {}, _a[field] = {
                    eq: operand
                }, _a;
            })
        });
        return predicate;
    };
    /**
     * Searches a `Model` table for records matching the given equalities object.
     *
     * This only matches against fields given in the equalities object. No other
     * fields are tested by the predicate.
     *
     * @param modelDefinition The model we need a predicate for.
     * @param flatEqualities An object holding field equalities to search for.
     */ ModelPredicateCreator.createFromFlatEqualities = function(modelDefinition, flatEqualities) {
        var ast = {
            and: Object.entries(flatEqualities).map(function(_a) {
                var _b;
                var _c = (0, _tslib.__read)(_a, 2), k = _c[0], v = _c[1];
                return _b = {}, _b[k] = {
                    eq: v
                }, _b;
            })
        };
        return this.createFromAST(modelDefinition, ast);
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into an
     * AST that can be used for a storage adapter predicate. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param gql GraphQL style filter node.
     */ ModelPredicateCreator.transformGraphQLFilterNodeToPredicateAST = function(gql) {
        var _this = this;
        if (!isValid(gql)) throw new Error("Invalid GraphQL Condition or subtree: " + JSON.stringify(gql));
        if (isEmpty(gql)) return {
            type: "and",
            predicates: []
        };
        else if (isGroup(gql)) {
            var groupkey = Object.keys(gql)[0];
            var children = this.transformGraphQLFilterNodeToPredicateAST(gql[groupkey]);
            return {
                type: groupkey,
                predicates: Array.isArray(children) ? children : [
                    children
                ]
            };
        } else if (isComparison(gql)) {
            var operatorKey = Object.keys(gql)[0];
            return {
                operator: operatorKey,
                operand: gql[operatorKey]
            };
        } else {
            if (Array.isArray(gql)) return gql.map(function(o) {
                return _this.transformGraphQLFilterNodeToPredicateAST(o);
            });
            else {
                var fieldKey = Object.keys(gql)[0];
                return (0, _tslib.__assign)({
                    field: fieldKey
                }, this.transformGraphQLFilterNodeToPredicateAST(gql[fieldKey]));
            }
        }
    };
    /**
     * Accepts a GraphQL style filter predicate tree and transforms it into a predicate
     * that storage adapters understand. Example input:
     *
     * ```js
     * {
     * 	and: [
     * 		{ name: { eq: "Bob Jones" } },
     * 		{ age: { between: [32, 64] } },
     * 		{ not: {
     * 			or: [
     * 				{ favoriteFood: { eq: 'pizza' } },
     * 				{ favoriteFood: { eq: 'tacos' } },
     * 			]
     * 		}}
     * 	]
     * }
     * ```
     *
     * @param modelDefinition The model that the AST/predicate must be compatible with.
     * @param ast The graphQL style AST that should specify conditions for `modelDefinition`.
     */ ModelPredicateCreator.createFromAST = function(modelDefinition, ast) {
        var key = {};
        ModelPredicateCreator.predicateGroupsMap.set(key, this.transformGraphQLFilterNodeToPredicateAST(ast));
        return key;
    };
    /**
     * Map of storage predicates (key objects) to storage predicate AST's.
     */ ModelPredicateCreator.predicateGroupsMap = new WeakMap();
    return ModelPredicateCreator;
}();

},{"tslib":"86BcK","../util":"iFXfl","./sort":"lO2Jp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lO2Jp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelSortPredicateCreator", ()=>ModelSortPredicateCreator);
var ModelSortPredicateCreator = /** @class */ function() {
    function ModelSortPredicateCreator() {}
    ModelSortPredicateCreator.createPredicateBuilder = function(modelDefinition) {
        var modelName = modelDefinition.name;
        var fieldNames = new Set(Object.keys(modelDefinition.fields));
        var handler;
        var predicate = new Proxy({}, handler = {
            get: function(_target, propertyKey, receiver) {
                var field = propertyKey;
                if (!fieldNames.has(field)) throw new Error("Invalid field for model. field: " + field + ", model: " + modelName);
                var result = function(sortDirection) {
                    var _a;
                    (_a = ModelSortPredicateCreator.sortPredicateGroupsMap.get(receiver)) === null || _a === void 0 || _a.push({
                        field: field,
                        sortDirection: sortDirection
                    });
                    return receiver;
                };
                return result;
            }
        });
        ModelSortPredicateCreator.sortPredicateGroupsMap.set(predicate, []);
        return predicate;
    };
    ModelSortPredicateCreator.isValidPredicate = function(predicate) {
        return ModelSortPredicateCreator.sortPredicateGroupsMap.has(predicate);
    };
    ModelSortPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelSortPredicateCreator.isValidPredicate(predicate)) throw new Error("The predicate is not valid");
        var predicateGroup = ModelSortPredicateCreator.sortPredicateGroupsMap.get(predicate);
        if (predicateGroup) return predicateGroup;
        else throw new Error("Predicate group not found");
    };
    // transforms cb-style predicate into Proxy
    ModelSortPredicateCreator.createFromExisting = function(modelDefinition, existing) {
        if (!existing || !modelDefinition) return undefined;
        return existing(ModelSortPredicateCreator.createPredicateBuilder(modelDefinition));
    };
    ModelSortPredicateCreator.sortPredicateGroupsMap = new WeakMap();
    return ModelSortPredicateCreator;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gjDZS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExclusiveStorage", ()=>ExclusiveStorage);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _zenPush = require("zen-push");
var _zenPushDefault = parcelHelpers.interopDefault(_zenPush);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("../sync/utils");
var _getDefaultAdapter = require("./adapter/getDefaultAdapter");
var _getDefaultAdapterDefault = parcelHelpers.interopDefault(_getDefaultAdapter);
var logger = new (0, _core.Logger)("DataStore");
var StorageClass = /** @class */ function() {
    function StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.getModelConstructorByModelName = getModelConstructorByModelName;
        this.modelInstanceCreator = modelInstanceCreator;
        this.adapter = adapter;
        this.sessionId = sessionId;
        this.adapter = this.adapter || (0, _getDefaultAdapterDefault.default)();
        this.pushStream = new (0, _zenPushDefault.default)();
    }
    StorageClass.getNamespace = function() {
        var namespace = {
            name: (0, _util.STORAGE),
            relationships: {},
            enums: {},
            models: {},
            nonModels: {}
        };
        return namespace;
    };
    StorageClass.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resolve, reject;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(this.initialized !== undefined)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        logger.debug("Starting Storage");
                        this.initialized = new Promise(function(res, rej) {
                            resolve = res;
                            reject = rej;
                        });
                        this.adapter.setUp(this.schema, this.namespaceResolver, this.modelInstanceCreator, this.getModelConstructorByModelName, this.sessionId).then(resolve, reject);
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.save(model, condition)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(r) {
                            var _a = (0, _tslib.__read)(r, 2), savedElement = _a[0], opType = _a[1];
                            // truthy when save is called by the Merger
                            var syncResponse = !!mutator;
                            var updateMutationInput;
                            // don't attempt to calc mutation input when storage.save
                            // is called by Merger, i.e., when processing an AppSync response
                            if ((opType === (0, _types.OpType).UPDATE || opType === (0, _types.OpType).INSERT) && !syncResponse) {
                                //
                                // TODO: LOOK!!!
                                // the `model` used here is in effect regardless of what model
                                // comes back from adapter.save().
                                // Prior to fix, SQLite adapter had been returning two models
                                // of different types, resulting in invalid outbox entries.
                                //
                                // the bug is essentially fixed in SQLite adapter.
                                // leaving as-is, because it's currently unclear whether anything
                                // depends on this remaining as-is.
                                //
                                updateMutationInput = _this.getChangedFieldsInput(model, savedElement, patchesTuple);
                                // // an update without changed user fields
                                // => don't create mutationEvent
                                if (updateMutationInput === null) return result;
                            }
                            var element = updateMutationInput || savedElement;
                            var modelConstructor = Object.getPrototypeOf(savedElement).constructor;
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: condition && (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) || null,
                                savedElement: savedElement
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    StorageClass.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var models, deleted, modelConstructor, namespaceName, modelDefinition, modelIds;
            var _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _b.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.delete(modelOrModelConstructor, condition)
                        ];
                    case 2:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), models = _a[0], deleted = _a[1];
                        modelConstructor = (0, _util.isModelConstructor)(modelOrModelConstructor) ? modelOrModelConstructor : Object.getPrototypeOf(modelOrModelConstructor || {}).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
                        modelIds = new Set(models.map(function(model) {
                            var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                            return modelId;
                        }));
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor) && !Array.isArray(deleted)) deleted = [
                            deleted
                        ];
                        deleted.forEach(function(model) {
                            var modelConstructor = Object.getPrototypeOf(model).constructor;
                            var theCondition;
                            if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) {
                                var modelId = (0, _utils.getIdentifierValue)(modelDefinition, model);
                                theCondition = modelIds.has(modelId) ? (0, _predicates.ModelPredicateCreator).getPredicates(condition, false) : undefined;
                            }
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: (0, _types.OpType).DELETE,
                                element: model,
                                mutator: mutator,
                                condition: theCondition || null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deleted
                            ]
                        ];
                }
            });
        });
    };
    StorageClass.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.query(modelConstructor, predicate, pagination)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.queryOne(modelConstructor, firstOrLast)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    StorageClass.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        var listenToAll = !modelConstructor;
        var _a = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate, false) || {}, predicates = _a.predicates, type = _a.type;
        var result = this.pushStream.observable.filter(function(_a) {
            var mutator = _a.mutator;
            return !skipOwn || mutator !== skipOwn;
        }).map(function(_a) {
            var _mutator = _a.mutator, message = (0, _tslib.__rest)(_a, [
                "mutator"
            ]);
            return message;
        });
        if (!listenToAll) result = result.filter(function(_a) {
            var model = _a.model, element = _a.element;
            if (modelConstructor !== model) return false;
            if (!!predicates && !!type) return (0, _util.validatePredicate)(element, type, predicates);
            return true;
        });
        return result;
    };
    StorageClass.prototype.clear = function(completeObservable) {
        if (completeObservable === void 0) completeObservable = true;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.initialized = undefined;
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.clear()
                        ];
                    case 1:
                        _a.sent();
                        if (completeObservable) this.pushStream.complete();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StorageClass.prototype.batchSave = function(modelConstructor, items, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        if (!this.adapter) throw new Error("Storage adapter is missing");
                        return [
                            4 /*yield*/ ,
                            this.adapter.batchSave(modelConstructor, items)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), element = _b[0], opType = _b[1];
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: null
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // returns null if no user fields were changed (determined by value comparison)
    StorageClass.prototype.getChangedFieldsInput = function(model, originalElement, patchesTuple) {
        var e_1, _a;
        var _b;
        var containsPatches = patchesTuple && patchesTuple.length;
        if (!containsPatches) return null;
        var _c = (0, _tslib.__read)(patchesTuple, 2), patches = _c[0], source = _c[1];
        var updatedElement = {};
        // extract array of updated fields from patches
        var updatedFields = patches.map(function(patch) {
            return patch.path && patch.path[0];
        });
        // check model def for association and replace with targetName if exists
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespace = this.namespaceResolver(modelConstructor);
        var fields = this.schema.namespaces[namespace].models[modelConstructor.name].fields;
        var _d = ((_b = this.schema.namespaces[namespace].keys) === null || _b === void 0 ? void 0 : _b[modelConstructor.name]) || {}, primaryKey = _d.primaryKey, _e = _d.compositeKeys, compositeKeys = _e === void 0 ? [] : _e;
        // set original values for these fields
        updatedFields.forEach(function(field) {
            var e_2, _a, e_3, _b, e_4, _c, e_5, _d, e_6, _e;
            var _f;
            var targetNames = (0, _types.isTargetNameAssociation)((_f = fields[field]) === null || _f === void 0 ? void 0 : _f.association);
            if (Array.isArray(targetNames)) try {
                // if field refers to a belongsTo relation, use the target field instead
                for(var targetNames_1 = (0, _tslib.__values)(targetNames), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                    var targetName = targetNames_1_1.value;
                    // check field values by value. Ignore unchanged fields
                    if (!(0, _util.valuesEqual)(source[targetName], originalElement[targetName])) {
                        // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                        updatedElement[targetName] = originalElement[targetName] === undefined ? null : originalElement[targetName];
                        try {
                            for(var compositeKeys_1 = (e_3 = void 0, (0, _tslib.__values)(compositeKeys)), compositeKeys_1_1 = compositeKeys_1.next(); !compositeKeys_1_1.done; compositeKeys_1_1 = compositeKeys_1.next()){
                                var fieldSet = compositeKeys_1_1.value;
                                // include all of the fields that comprise the composite key
                                if (fieldSet.has(targetName)) try {
                                    for(var fieldSet_1 = (e_4 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_1_1 = fieldSet_1.next(); !fieldSet_1_1.done; fieldSet_1_1 = fieldSet_1.next()){
                                        var compositeField = fieldSet_1_1.value;
                                        updatedElement[compositeField] = originalElement[compositeField];
                                    }
                                } catch (e_4_1) {
                                    e_4 = {
                                        error: e_4_1
                                    };
                                } finally{
                                    try {
                                        if (fieldSet_1_1 && !fieldSet_1_1.done && (_c = fieldSet_1.return)) _c.call(fieldSet_1);
                                    } finally{
                                        if (e_4) throw e_4.error;
                                    }
                                }
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (compositeKeys_1_1 && !compositeKeys_1_1.done && (_b = compositeKeys_1.return)) _b.call(compositeKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (targetNames_1_1 && !targetNames_1_1.done && (_a = targetNames_1.return)) _a.call(targetNames_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            else {
                // Backwards compatibility pre-CPK
                // if field refers to a belongsTo relation, use the target field instead
                var key = targetNames || field;
                // check field values by value. Ignore unchanged fields
                if (!(0, _util.valuesEqual)(source[key], originalElement[key])) {
                    // if the field was updated to 'undefined', replace with 'null' for compatibility with JSON and GraphQL
                    updatedElement[key] = originalElement[key] === undefined ? null : originalElement[key];
                    try {
                        for(var compositeKeys_2 = (0, _tslib.__values)(compositeKeys), compositeKeys_2_1 = compositeKeys_2.next(); !compositeKeys_2_1.done; compositeKeys_2_1 = compositeKeys_2.next()){
                            var fieldSet = compositeKeys_2_1.value;
                            // include all of the fields that comprise the composite key
                            if (fieldSet.has(key)) try {
                                for(var fieldSet_2 = (e_6 = void 0, (0, _tslib.__values)(fieldSet)), fieldSet_2_1 = fieldSet_2.next(); !fieldSet_2_1.done; fieldSet_2_1 = fieldSet_2.next()){
                                    var compositeField = fieldSet_2_1.value;
                                    updatedElement[compositeField] = originalElement[compositeField];
                                }
                            } catch (e_6_1) {
                                e_6 = {
                                    error: e_6_1
                                };
                            } finally{
                                try {
                                    if (fieldSet_2_1 && !fieldSet_2_1.done && (_e = fieldSet_2.return)) _e.call(fieldSet_2);
                                } finally{
                                    if (e_6) throw e_6.error;
                                }
                            }
                        }
                    } catch (e_5_1) {
                        e_5 = {
                            error: e_5_1
                        };
                    } finally{
                        try {
                            if (compositeKeys_2_1 && !compositeKeys_2_1.done && (_d = compositeKeys_2.return)) _d.call(compositeKeys_2);
                        } finally{
                            if (e_5) throw e_5.error;
                        }
                    }
                }
            }
        });
        // Exit early when there are no changes introduced in the update mutation
        if (Object.keys(updatedElement).length === 0) return null;
        // include field(s) from custom PK if one is specified for the model
        if (primaryKey && primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                updatedElement[pkField] = originalElement[pkField];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var id = originalElement.id, _version = originalElement._version, _lastChangedAt = originalElement._lastChangedAt, _deleted = originalElement._deleted;
        // For update mutations we only want to send fields with changes
        // and the required internal fields
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedElement), {
            id: id,
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        });
    };
    return StorageClass;
}();
var ExclusiveStorage = /** @class */ function() {
    function ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId) {
        this.mutex = new (0, _core.Mutex)();
        this.storage = new StorageClass(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter, sessionId);
    }
    ExclusiveStorage.prototype.runExclusive = function(fn) {
        return this.mutex.runExclusive(fn.bind(this, this.storage));
    };
    ExclusiveStorage.prototype.save = function(model, condition, mutator, patchesTuple) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.save(model, condition, mutator, patchesTuple);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        if ((0, _util.isModelConstructor)(modelOrModelConstructor)) {
                            var modelConstructor = modelOrModelConstructor;
                            return storage.delete(modelConstructor, condition, mutator);
                        } else {
                            var model = modelOrModelConstructor;
                            return storage.delete(model, condition, mutator);
                        }
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.query(modelConstructor, predicate, pagination);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.queryOne(modelConstructor, firstOrLast);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.getNamespace = function() {
        return StorageClass.getNamespace();
    };
    ExclusiveStorage.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        return this.storage.observe(modelConstructor, predicate, skipOwn);
    };
    ExclusiveStorage.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runExclusive(function(storage) {
                                return storage.clear();
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ExclusiveStorage.prototype.batchSave = function(modelConstructor, items) {
        return this.storage.batchSave(modelConstructor, items);
    };
    ExclusiveStorage.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.storage.init()
                ];
            });
        });
    };
    return ExclusiveStorage;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","zen-push":"lYxKt","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","../sync/utils":"3udIx","./adapter/getDefaultAdapter":"28vIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lYxKt":[function(require,module,exports) {
"use strict";
var Observable = require("8ee1d41987ca192");
function addMethods(target, methods) {
    Object.keys(methods).forEach(function(k) {
        var desc = Object.getOwnPropertyDescriptor(methods, k);
        desc.enumerable = false;
        Object.defineProperty(target, k, desc);
    });
}
function send(p, message, value) {
    if (p._observer) sendMessage(p._observer, message, value);
    else if (p._observers) {
        var list = [];
        p._observers.forEach(function(to) {
            list.push(to);
        });
        list.forEach(function(to) {
            sendMessage(to, message, value);
        });
    }
}
function sendMessage(observer, message, value) {
    if (observer.closed) return;
    switch(message){
        case "next":
            return observer.next(value);
        case "error":
            return observer.error(value);
        case "complete":
            return observer.complete(value);
    }
}
function hasObserver(p) {
    return p._observer || p._observers && p._observers.size > 0;
}
function addObserver(p, observer) {
    if (p._observers) p._observers.add(observer);
    else if (!p._observer) p._observer = observer;
    else {
        p._observers = new Set();
        p._observers.add(p._observer);
        p._observers.add(observer);
        p._observer = null;
    }
}
function deleteObserver(p, observer) {
    if (p._observers) p._observers.delete(observer);
    else if (p._observer === observer) p._observer = null;
}
function notifyStart(p, opts) {
    !hasObserver(p) && opts && opts.start && opts.start();
}
function notifyPause(p, opts) {
    !hasObserver(p) && opts && opts.pause && opts.pause();
}
function PushStream(opts) {
    var p = this;
    this._observer = null;
    this._observers = null;
    this._observable = new Observable(function(observer) {
        notifyStart(p, opts);
        addObserver(p, observer);
        return function() {
            deleteObserver(p, observer);
            notifyPause(p, opts);
        };
    });
}
addMethods(PushStream.prototype, {
    get observable () {
        return this._observable;
    },
    get observed () {
        return hasObserver(this);
    },
    next: function(x) {
        send(this, "next", x);
    },
    error: function(e) {
        send(this, "error", e);
    },
    complete: function(x) {
        send(this, "complete", x);
    }
});
module.exports = PushStream;

},{"8ee1d41987ca192":"8RDbS"}],"8RDbS":[function(require,module,exports) {
module.exports = require("b4c55f2c243ab7f3").Observable;

},{"b4c55f2c243ab7f3":"8bnYs"}],"8bnYs":[function(require,module,exports) {
"use strict";
(function(fn, name) {
    var e;
    fn(exports, module);
})(function(exports1, module1) {
    function hasSymbol(name) {
        return typeof Symbol === "function" && Boolean(Symbol[name]);
    }
    function getSymbol(name) {
        return hasSymbol(name) ? Symbol[name] : "@@" + name;
    }
    // Ponyfill Symbol.observable for interoperability with other libraries
    if (typeof Symbol === "function" && !Symbol.observable) Symbol.observable = Symbol("observable");
    // === Abstract Operations ===
    function hostReportError(e) {
        setTimeout(function() {
            throw e;
        });
    }
    function getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== "function") throw new TypeError(value + " is not a function");
        return value;
    }
    function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[getSymbol("species")];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : Observable;
    }
    function addMethods(target, methods) {
        Object.keys(methods).forEach(function(k) {
            var desc = Object.getOwnPropertyDescriptor(methods, k);
            desc.enumerable = false;
            Object.defineProperty(target, k, desc);
        });
    }
    function cleanupSubscription(subscription) {
        // Assert:  observer._observer is undefined
        var cleanup = subscription._cleanup;
        if (!cleanup) return;
        // Drop the reference to the cleanup function so that we won't call it
        // more than once
        subscription._cleanup = undefined;
        // Call the cleanup function
        try {
            cleanup();
        } catch (e) {
            hostReportError(e);
        }
    }
    function subscriptionClosed(subscription) {
        return subscription._observer === undefined;
    }
    function closeSubscription(subscription) {
        if (subscriptionClosed(subscription)) return;
        subscription._observer = undefined;
        cleanupSubscription(subscription);
    }
    function cleanupFromSubscription(subscription) {
        return function() {
            subscription.unsubscribe();
        };
    }
    function Subscription(observer, subscriber) {
        // Assert: subscriber is callable
        // The observer must be an object
        if (Object(observer) !== observer) throw new TypeError("Observer must be an object");
        this._cleanup = undefined;
        this._observer = observer;
        try {
            var start$0 = getMethod(observer, "start");
            if (start$0) start$0.call(observer, this);
        } catch (e) {
            hostReportError(e);
        }
        if (subscriptionClosed(this)) return;
        observer = new SubscriptionObserver(this);
        try {
            // Call the subscriber function
            var cleanup$0 = subscriber.call(undefined, observer);
            // The return value must be undefined, null, a subscription object, or a function
            if (cleanup$0 != null) {
                if (typeof cleanup$0.unsubscribe === "function") cleanup$0 = cleanupFromSubscription(cleanup$0);
                else if (typeof cleanup$0 !== "function") throw new TypeError(cleanup$0 + " is not a function");
                this._cleanup = cleanup$0;
            }
        } catch (e) {
            // If an error occurs during startup, then attempt to send the error
            // to the observer
            observer.error(e);
            return;
        }
        // If the stream is already finished, then perform cleanup
        if (subscriptionClosed(this)) cleanupSubscription(this);
    }
    addMethods(Subscription.prototype = {}, {
        get closed () {
            return subscriptionClosed(this);
        },
        unsubscribe: function() {
            closeSubscription(this);
        }
    });
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    addMethods(SubscriptionObserver.prototype = {}, {
        get closed () {
            return subscriptionClosed(this._subscription);
        },
        next: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, then return undefined
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            try {
                // If the observer has a "next" method, send the next value
                var m$0 = getMethod(observer, "next");
                if (m$0) m$0.call(observer, value);
            } catch (e) {
                hostReportError(e);
            }
        },
        error: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, throw the error to the caller
            if (subscriptionClosed(subscription)) {
                hostReportError(value);
                return;
            }
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$1 = getMethod(observer, "error");
                if (m$1) m$1.call(observer, value);
                else throw value;
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        },
        complete: function() {
            var subscription = this._subscription;
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$2 = getMethod(observer, "complete");
                if (m$2) m$2.call(observer);
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        }
    });
    function Observable(subscriber) {
        // Constructor cannot be called as a function
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        // The stream subscriber must be a function
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    addMethods(Observable.prototype, {
        subscribe: function(observer) {
            for(var args = [], __$0 = 1; __$0 < arguments.length; ++__$0)args.push(arguments[__$0]);
            if (typeof observer === "function") observer = {
                next: observer,
                error: args[0],
                complete: args[1]
            };
            else if (typeof observer !== "object" || observer === null) observer = {};
            return new Subscription(observer, this._subscriber);
        },
        forEach: function(fn) {
            var __this = this;
            return new Promise(function(resolve, reject) {
                if (typeof fn !== "function") return Promise.reject(new TypeError(fn + " is not a function"));
                __this.subscribe({
                    _subscription: null,
                    start: function(subscription) {
                        if (Object(subscription) !== subscription) throw new TypeError(subscription + " is not an object");
                        this._subscription = subscription;
                    },
                    next: function(value) {
                        var subscription = this._subscription;
                        if (subscription.closed) return;
                        try {
                            fn(value);
                        } catch (err) {
                            reject(err);
                            subscription.unsubscribe();
                        }
                    },
                    error: reject,
                    complete: resolve
                });
            });
        },
        map: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            value = fn(value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        filter: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            if (!fn(value)) return;
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        reduce: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            var hasSeed = arguments.length > 1;
            var hasValue = false;
            var seed = arguments[1];
            var acc = seed;
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        var first = !hasValue;
                        hasValue = true;
                        if (!first || hasSeed) try {
                            acc = fn(acc, value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        else acc = value;
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                        observer.next(acc);
                        observer.complete();
                    }
                });
            });
        }
    });
    Object.defineProperty(Observable.prototype, getSymbol("observable"), {
        value: function() {
            return this;
        },
        writable: true,
        configurable: true
    });
    addMethods(Observable, {
        from: function(x) {
            var C = typeof this === "function" ? this : Observable;
            if (x == null) throw new TypeError(x + " is not an object");
            var method = getMethod(x, getSymbol("observable"));
            if (method) {
                var observable$0 = method.call(x);
                if (Object(observable$0) !== observable$0) throw new TypeError(observable$0 + " is not an object");
                if (observable$0.constructor === C) return observable$0;
                return new C(function(observer) {
                    return observable$0.subscribe(observer);
                });
            }
            if (hasSymbol("iterator") && (method = getMethod(x, getSymbol("iterator")))) return new C(function(observer) {
                for(var __$0 = method.call(x)[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done;){
                    var item$0 = __$1.value;
                    observer.next(item$0);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            if (Array.isArray(x)) return new C(function(observer) {
                for(var i$0 = 0; i$0 < x.length; ++i$0){
                    observer.next(x[i$0]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            throw new TypeError(x + " is not observable");
        },
        of: function() {
            for(var items = [], __$0 = 0; __$0 < arguments.length; ++__$0)items.push(arguments[__$0]);
            var C = typeof this === "function" ? this : Observable;
            return new C(function(observer) {
                for(var i$1 = 0; i$1 < items.length; ++i$1){
                    observer.next(items[i$1]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        }
    });
    Object.defineProperty(Observable, getSymbol("species"), {
        get: function() {
            return this;
        },
        configurable: true
    });
    Object.defineProperty(Observable, "extensions", {
        value: {
            observableSymbol: getSymbol("observable"),
            setHostReportError: function(fn) {
                hostReportError = fn;
            }
        }
    });
    exports1.Observable = Observable;
}, "*");

},{}],"3udIx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransformerMutationType", ()=>TransformerMutationType);
parcelHelpers.export(exports, "getMetadataFields", ()=>getMetadataFields);
parcelHelpers.export(exports, "generateSelectionSet", ()=>generateSelectionSet);
parcelHelpers.export(exports, "getAuthorizationRules", ()=>getAuthorizationRules);
parcelHelpers.export(exports, "buildSubscriptionGraphQLOperation", ()=>buildSubscriptionGraphQLOperation);
parcelHelpers.export(exports, "buildGraphQLOperation", ()=>buildGraphQLOperation);
parcelHelpers.export(exports, "createMutationInstanceFromModelOperation", ()=>createMutationInstanceFromModelOperation);
parcelHelpers.export(exports, "predicateToGraphQLCondition", ()=>predicateToGraphQLCondition);
/**
 * @param predicatesGroup - Predicate Group
    @returns GQL Filter Expression from Predicate Group
    
    @remarks Flattens redundant list predicates
    @example

    ```js
    { and:[{ and:[{ username:  { eq: 'bob' }}] }] }
    ```
    Becomes
    ```js
    { and:[{ username: { eq: 'bob' }}] }
    ```
    */ parcelHelpers.export(exports, "predicateToGraphQLFilter", ()=>predicateToGraphQLFilter);
/**
 *
 * @param group - selective sync predicate group
 * @returns set of distinct field names in the filter group
 */ parcelHelpers.export(exports, "filterFields", ()=>filterFields);
/**
 *
 * @param modelDefinition
 * @returns set of field names used with dynamic auth modes configured for the provided model definition
 */ parcelHelpers.export(exports, "dynamicAuthFields", ()=>dynamicAuthFields);
/**
 *
 * @param group - selective sync predicate group
 * @returns the total number of OR'd predicates in the filter group
 *
 * @example returns 2
 * ```js
 * { type: "or", predicates: [
 * { field: "username", operator: "beginsWith", operand: "a" },
 * { field: "title", operator: "contains", operand: "abc" },
 * ]}
 * ```
 */ parcelHelpers.export(exports, "countFilterCombinations", ()=>countFilterCombinations);
/**
 *
 * @param group - selective sync predicate group
 * @returns name of repeated field | null
 *
 * @example returns "username"
 * ```js
 * { type: "and", predicates: [
 * 		{ field: "username", operator: "beginsWith", operand: "a" },
 * 		{ field: "username", operator: "contains", operand: "abc" },
 * ] }
 * ```
 */ parcelHelpers.export(exports, "repeatedFieldInGroup", ()=>repeatedFieldInGroup);
parcelHelpers.export(exports, "RTFError", ()=>RTFError);
parcelHelpers.export(exports, "generateRTFRemediation", ()=>generateRTFRemediation);
parcelHelpers.export(exports, "getUserGroupsFromToken", ()=>getUserGroupsFromToken);
parcelHelpers.export(exports, "getModelAuthModes", ()=>getModelAuthModes);
parcelHelpers.export(exports, "getForbiddenError", ()=>getForbiddenError);
parcelHelpers.export(exports, "getClientSideAuthError", ()=>getClientSideAuthError);
parcelHelpers.export(exports, "getTokenForCustomAuth", ()=>getTokenForCustomAuth);
// Util that takes a modelDefinition and model and returns either the id value(s) or the custom primary key value(s)
parcelHelpers.export(exports, "getIdentifierValue", ()=>getIdentifierValue);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _apiGraphql = require("@aws-amplify/api-graphql");
var _api = require("@aws-amplify/api");
var _core = require("@aws-amplify/core");
var _types = require("../types");
var _util = require("../util");
var logger = new (0, _core.Logger)("DataStore");
var GraphQLOperationType;
(function(GraphQLOperationType) {
    GraphQLOperationType["LIST"] = "query";
    GraphQLOperationType["CREATE"] = "mutation";
    GraphQLOperationType["UPDATE"] = "mutation";
    GraphQLOperationType["DELETE"] = "mutation";
    GraphQLOperationType["GET"] = "query";
})(GraphQLOperationType || (GraphQLOperationType = {}));
var TransformerMutationType;
(function(TransformerMutationType) {
    TransformerMutationType["CREATE"] = "Create";
    TransformerMutationType["UPDATE"] = "Update";
    TransformerMutationType["DELETE"] = "Delete";
    TransformerMutationType["GET"] = "Get";
})(TransformerMutationType || (TransformerMutationType = {}));
var dummyMetadata = {
    _version: undefined,
    _lastChangedAt: undefined,
    _deleted: undefined
};
var metadataFields = Object.keys(dummyMetadata);
function getMetadataFields() {
    return metadataFields;
}
function generateSelectionSet(namespace, modelDefinition) {
    var scalarFields = getScalarFields(modelDefinition);
    var nonModelFields = getNonModelFields(namespace, modelDefinition);
    var implicitOwnerField = getImplicitOwnerField(modelDefinition, scalarFields);
    var scalarAndMetadataFields = Object.values(scalarFields).map(function(_a) {
        var name = _a.name;
        return name;
    }).concat(implicitOwnerField).concat(nonModelFields);
    if ((0, _types.isSchemaModel)(modelDefinition)) scalarAndMetadataFields = scalarAndMetadataFields.concat(getMetadataFields()).concat(getConnectionFields(modelDefinition, namespace));
    var result = scalarAndMetadataFields.join("\n");
    return result;
}
function getImplicitOwnerField(modelDefinition, scalarFields) {
    var ownerFields = getOwnerFields(modelDefinition);
    if (!scalarFields.owner && ownerFields.includes("owner")) return [
        "owner"
    ];
    return [];
}
function getOwnerFields(modelDefinition) {
    var ownerFields = [];
    if ((0, _types.isSchemaModelWithAttributes)(modelDefinition)) modelDefinition.attributes.forEach(function(attr) {
        if (attr.properties && attr.properties.rules) {
            var rule = attr.properties.rules.find(function(rule) {
                return rule.allow === "owner";
            });
            if (rule && rule.ownerField) ownerFields.push(rule.ownerField);
        }
    });
    return ownerFields;
}
function getScalarFields(modelDefinition) {
    var fields = modelDefinition.fields;
    var result = Object.values(fields).filter(function(field) {
        if ((0, _types.isGraphQLScalarType)(field.type) || (0, _types.isEnumFieldType)(field.type)) return true;
        return false;
    }).reduce(function(acc, field) {
        acc[field.name] = field;
        return acc;
    }, {});
    return result;
}
// Used for generating the selection set for queries and mutations
function getConnectionFields(modelDefinition, namespace) {
    var result = [];
    Object.values(modelDefinition.fields).filter(function(_a) {
        var association = _a.association;
        return association && Object.keys(association).length;
    }).forEach(function(_a) {
        var name = _a.name, association = _a.association;
        var connectionType = (association || {}).connectionType;
        switch(connectionType){
            case "HAS_ONE":
            case "HAS_MANY":
                break;
            case "BELONGS_TO":
                if ((0, _types.isTargetNameAssociation)(association)) {
                    // New codegen (CPK)
                    if (association.targetNames && association.targetNames.length > 0) {
                        // Need to retrieve relations in order to get connected model keys
                        var _b = (0, _tslib.__read)((0, _util.establishRelationAndKeys)(namespace), 1), relations = _b[0];
                        var connectedModelName = modelDefinition.fields[name].type["model"];
                        var byPkIndex = relations[connectedModelName].indexes.find(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), name = _b[0];
                            return name === "byPk";
                        });
                        var keyFields = byPkIndex && byPkIndex[1];
                        var keyFieldSelectionSet = keyFields === null || keyFields === void 0 ? void 0 : keyFields.join(" ");
                        // We rely on `_deleted` when we process the sync query (e.g. in batchSave in the adapters)
                        result.push(name + " { " + keyFieldSelectionSet + " _deleted }");
                    } else // backwards-compatability for schema generated prior to custom primary key support
                    result.push(name + " { id _deleted }");
                }
                break;
            default:
                throw new Error("Invalid connection type " + connectionType);
        }
    });
    return result;
}
function getNonModelFields(namespace, modelDefinition) {
    var result = [];
    Object.values(modelDefinition.fields).forEach(function(_a) {
        var name = _a.name, type = _a.type;
        if ((0, _types.isNonModelFieldType)(type)) {
            var typeDefinition = namespace.nonModels[type.nonModel];
            var scalarFields = Object.values(getScalarFields(typeDefinition)).map(function(_a) {
                var name = _a.name;
                return name;
            });
            var nested_1 = [];
            Object.values(typeDefinition.fields).forEach(function(field) {
                var type = field.type, name = field.name;
                if ((0, _types.isNonModelFieldType)(type)) {
                    var typeDefinition_1 = namespace.nonModels[type.nonModel];
                    nested_1.push(name + " { " + generateSelectionSet(namespace, typeDefinition_1) + " }");
                }
            });
            result.push(name + " { " + scalarFields.join(" ") + " " + nested_1.join(" ") + " }");
        }
    });
    return result;
}
function getAuthorizationRules(modelDefinition) {
    // Searching for owner authorization on attributes
    var authConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
        return attr && attr.type === "auth";
    });
    var _a = (authConfig || {}).properties, _b = (_a === void 0 ? {} : _a).rules, rules = _b === void 0 ? [] : _b;
    var resultRules = [];
    // Multiple rules can be declared for allow: owner
    rules.forEach(function(rule) {
        // setting defaults for backwards compatibility with old cli
        var _a = rule.identityClaim, identityClaim = _a === void 0 ? "cognito:username" : _a, _b = rule.ownerField, ownerField = _b === void 0 ? "owner" : _b, _c = rule.operations, operations = _c === void 0 ? [
            "create",
            "update",
            "delete",
            "read"
        ] : _c, _d = rule.provider, provider = _d === void 0 ? "userPools" : _d, _e = rule.groupClaim, groupClaim = _e === void 0 ? "cognito:groups" : _e, _f = rule.allow, authStrategy = _f === void 0 ? "iam" : _f, _g = rule.groups, groups = _g === void 0 ? [] : _g, _h = rule.groupsField, groupsField = _h === void 0 ? "" : _h;
        var isReadAuthorized = operations.includes("read");
        var isOwnerAuth = authStrategy === "owner";
        if (!isReadAuthorized && !isOwnerAuth) return;
        var authRule = {
            identityClaim: identityClaim,
            ownerField: ownerField,
            provider: provider,
            groupClaim: groupClaim,
            authStrategy: authStrategy,
            groups: groups,
            groupsField: groupsField,
            areSubscriptionsPublic: false
        };
        if (isOwnerAuth) {
            // look for the subscription level override
            // only pay attention to the public level
            var modelConfig = [].concat(modelDefinition.attributes || []).find(function(attr) {
                return attr && attr.type === "model";
            });
            // find the subscriptions level. ON is default
            var _j = (modelConfig || {}).properties, _k = (_j === void 0 ? {} : _j).subscriptions, _l = (_k === void 0 ? {} : _k).level, level = _l === void 0 ? "on" : _l;
            // treat subscriptions as public for owner auth with unprotected reads
            // when `read` is omitted from `operations`
            authRule.areSubscriptionsPublic = !operations.includes("read") || level === "public";
        }
        if (isOwnerAuth) {
            // owner rules has least priority
            resultRules.push(authRule);
            return;
        }
        resultRules.unshift(authRule);
    });
    return resultRules;
}
function buildSubscriptionGraphQLOperation(namespace, modelDefinition, transformerMutationType, isOwnerAuthorization, ownerField, filterArg) {
    if (filterArg === void 0) filterArg = false;
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name;
    var opName = "on" + transformerMutationType + typeName;
    var docArgs = [];
    var opArgs = [];
    if (filterArg) {
        docArgs.push("$filter: ModelSubscription" + typeName + "FilterInput");
        opArgs.push("filter: $filter");
    }
    if (isOwnerAuthorization) {
        docArgs.push("$" + ownerField + ": String!");
        opArgs.push(ownerField + ": $" + ownerField);
    }
    var docStr = docArgs.length ? "(" + docArgs.join(",") + ")" : "";
    var opStr = opArgs.length ? "(" + opArgs.join(",") + ")" : "";
    return [
        transformerMutationType,
        opName,
        "subscription operation" + docStr + "{\n			" + opName + opStr + "{\n				" + selectionSet + "\n			}\n		}"
    ];
}
function buildGraphQLOperation(namespace, modelDefinition, graphQLOpType) {
    var selectionSet = generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
    var operation;
    var documentArgs;
    var operationArgs;
    var transformerMutationType;
    switch(graphQLOpType){
        case "LIST":
            operation = "sync" + pluralTypeName;
            documentArgs = "($limit: Int, $nextToken: String, $lastSync: AWSTimestamp, $filter: Model" + typeName + "FilterInput)";
            operationArgs = "(limit: $limit, nextToken: $nextToken, lastSync: $lastSync, filter: $filter)";
            selectionSet = "items {\n							" + selectionSet + "\n						}\n						nextToken\n						startedAt";
            break;
        case "CREATE":
            operation = "create" + typeName;
            documentArgs = "($input: Create" + typeName + "Input!)";
            operationArgs = "(input: $input)";
            transformerMutationType = TransformerMutationType.CREATE;
            break;
        case "UPDATE":
            operation = "update" + typeName;
            documentArgs = "($input: Update" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = TransformerMutationType.UPDATE;
            break;
        case "DELETE":
            operation = "delete" + typeName;
            documentArgs = "($input: Delete" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = TransformerMutationType.DELETE;
            break;
        case "GET":
            operation = "get" + typeName;
            documentArgs = "($id: ID!)";
            operationArgs = "(id: $id)";
            transformerMutationType = TransformerMutationType.GET;
            break;
        default:
            throw new Error("Invalid graphQlOpType " + graphQLOpType);
    }
    return [
        [
            transformerMutationType,
            operation,
            GraphQLOperationType[graphQLOpType] + " operation" + documentArgs + "{\n		" + operation + operationArgs + "{\n			" + selectionSet + "\n		}\n	}"
        ]
    ];
}
function createMutationInstanceFromModelOperation(relationships, modelDefinition, opType, model, element, condition, MutationEventConstructor, modelInstanceCreator, id) {
    var operation;
    switch(opType){
        case (0, _types.OpType).INSERT:
            operation = TransformerMutationType.CREATE;
            break;
        case (0, _types.OpType).UPDATE:
            operation = TransformerMutationType.UPDATE;
            break;
        case (0, _types.OpType).DELETE:
            operation = TransformerMutationType.DELETE;
            break;
        default:
            throw new Error("Invalid opType " + opType);
    }
    // stringify nested objects of type AWSJSON
    // this allows us to return parsed JSON to users (see `castInstanceType()` in datastore.ts),
    // but still send the object correctly over the wire
    var replacer = function(k, v) {
        var isAWSJSON = k && v !== null && typeof v === "object" && modelDefinition.fields[k] && modelDefinition.fields[k].type === "AWSJSON";
        if (isAWSJSON) return JSON.stringify(v);
        return v;
    };
    var modelId = getIdentifierValue(modelDefinition, element);
    var optionalId = (0, _types.OpType).INSERT && id ? {
        id: id
    } : {};
    var mutationEvent = modelInstanceCreator(MutationEventConstructor, (0, _tslib.__assign)((0, _tslib.__assign)({}, optionalId), {
        data: JSON.stringify(element, replacer),
        modelId: modelId,
        model: model.name,
        operation: operation,
        condition: JSON.stringify(condition)
    }));
    return mutationEvent;
}
function predicateToGraphQLCondition(predicate, modelDefinition) {
    var result = {};
    if (!predicate || !Array.isArray(predicate.predicates)) return result;
    // This is compatible with how the GQL Transform currently generates the Condition Input,
    // i.e. any PK and SK fields are omitted and can't be used as conditions.
    // However, I think this limits usability.
    // What if we want to delete all records where SK > some value
    // Or all records where PK = some value but SKs are different values
    // TODO: if the Transform gets updated we'll need to modify this logic to only omit
    // key fields from the predicate/condition when ALL of the keyFields are present and using `eq` operators
    var keyFields = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    return predicateToGraphQLFilter(predicate, keyFields);
}
function predicateToGraphQLFilter(predicatesGroup, fieldsToOmit, root) {
    if (fieldsToOmit === void 0) fieldsToOmit = [];
    if (root === void 0) root = true;
    var result = {};
    if (!predicatesGroup || !Array.isArray(predicatesGroup.predicates)) return result;
    var type = predicatesGroup.type, predicates = predicatesGroup.predicates;
    var isList = type === "and" || type === "or";
    result[type] = isList ? [] : {};
    var children = [];
    predicates.forEach(function(predicate) {
        var _a, _b;
        if ((0, _types.isPredicateObj)(predicate)) {
            var field = predicate.field, operator = predicate.operator, operand = predicate.operand;
            if (fieldsToOmit.includes(field)) return;
            var gqlField = (_a = {}, _a[field] = (_b = {}, _b[operator] = operand, _b), _a);
            children.push(gqlField);
            return;
        }
        var child = predicateToGraphQLFilter(predicate, fieldsToOmit, false);
        if (Object.keys(child).length > 0) children.push(child);
    });
    // flatten redundant list predicates
    if (children.length === 1) {
        var _a = (0, _tslib.__read)(children, 1), child = _a[0];
        if (// any nested list node
        isList && !root || // root list node where the only child is also a list node
        isList && root && ("and" in child || "or" in child)) {
            delete result[type];
            Object.assign(result, child);
            return result;
        }
    }
    children.forEach(function(child) {
        if (isList) result[type].push(child);
        else result[type] = child;
    });
    if (isList) {
        if (result[type].length === 0) return {};
    } else {
        if (Object.keys(result[type]).length === 0) return {};
    }
    return result;
}
function filterFields(group) {
    var fields = new Set();
    if (!group || !Array.isArray(group.predicates)) return fields;
    var predicates = group.predicates;
    var stack = (0, _tslib.__spread)(predicates);
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateObj)(current)) fields.add(current.field);
        else if ((0, _types.isPredicateGroup)(current)) stack.push.apply(stack, (0, _tslib.__spread)(current.predicates));
    }
    return fields;
}
function dynamicAuthFields(modelDefinition) {
    var e_1, _a;
    var rules = getAuthorizationRules(modelDefinition);
    var fields = new Set();
    try {
        for(var rules_1 = (0, _tslib.__values)(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()){
            var rule = rules_1_1.value;
            if (rule.groupsField && !rule.groups.length) // dynamic group rule will have no values in `rule.groups`
            fields.add(rule.groupsField);
            else if (rule.ownerField) fields.add(rule.ownerField);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return fields;
}
function countFilterCombinations(group) {
    if (!group || !Array.isArray(group.predicates)) return 0;
    var count = 0;
    var stack = [
        group
    ];
    while(stack.length > 0){
        var current = stack.pop();
        if ((0, _types.isPredicateGroup)(current)) {
            var predicates = current.predicates, type = current.type;
            // ignore length = 1; groups with 1 predicate will get flattened when converted to gqlFilter
            if (type === "or" && predicates.length > 1) count += predicates.length;
            stack.push.apply(stack, (0, _tslib.__spread)(predicates));
        }
    }
    // if we didn't encounter any OR groups, default to 1
    return count || 1;
}
function repeatedFieldInGroup(group) {
    if (!group || !Array.isArray(group.predicates)) return null;
    // convert to filter in order to flatten redundant groups
    var gqlFilter = predicateToGraphQLFilter(group);
    var stack = [
        gqlFilter
    ];
    var hasGroupRepeatedFields = function(fields) {
        var e_2, _a;
        var seen = {};
        try {
            for(var fields_1 = (0, _tslib.__values)(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()){
                var f = fields_1_1.value;
                var _b = (0, _tslib.__read)(Object.keys(f), 1), fieldName = _b[0];
                if (seen[fieldName]) return fieldName;
                seen[fieldName] = true;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return null;
    };
    while(stack.length > 0){
        var current = stack.pop();
        var _a = (0, _tslib.__read)(Object.keys(current), 1), key = _a[0];
        var values = current[key];
        if (!Array.isArray(values)) return null;
        // field value will be single object
        var predicateObjects = values.filter(function(v) {
            return !Array.isArray(Object.values(v)[0]);
        });
        // group value will be an array
        var predicateGroups = values.filter(function(v) {
            return Array.isArray(Object.values(v)[0]);
        });
        if (key === "and") {
            var repeatedField = hasGroupRepeatedFields(predicateObjects);
            if (repeatedField) return repeatedField;
        }
        stack.push.apply(stack, (0, _tslib.__spread)(predicateGroups));
    }
    return null;
}
var RTFError;
(function(RTFError) {
    RTFError[RTFError["UnknownField"] = 0] = "UnknownField";
    RTFError[RTFError["MaxAttributes"] = 1] = "MaxAttributes";
    RTFError[RTFError["MaxCombinations"] = 2] = "MaxCombinations";
    RTFError[RTFError["RepeatedFieldname"] = 3] = "RepeatedFieldname";
    RTFError[RTFError["NotGroup"] = 4] = "NotGroup";
    RTFError[RTFError["FieldNotInType"] = 5] = "FieldNotInType";
})(RTFError || (RTFError = {}));
function generateRTFRemediation(errorType, modelDefinition, predicatesGroup) {
    var selSyncFields = filterFields(predicatesGroup);
    var selSyncFieldStr = (0, _tslib.__spread)(selSyncFields).join(", ");
    var dynamicAuthModeFields = dynamicAuthFields(modelDefinition);
    var dynamicAuthFieldsStr = (0, _tslib.__spread)(dynamicAuthModeFields).join(", ");
    var filterCombinations = countFilterCombinations(predicatesGroup);
    var repeatedField = repeatedFieldInGroup(predicatesGroup);
    switch(errorType){
        case RTFError.UnknownField:
            return "Your API was generated with an older version of the CLI that doesn't support backend subscription filtering.To enable backend subscription filtering, upgrade your Amplify CLI to the latest version and push your app by running `amplify upgrade` followed by `amplify push`";
        case RTFError.MaxAttributes:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + selSyncFields.size + " different model fields: " + selSyncFieldStr + ".\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth each utilize 1 field.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.MaxCombinations:
            var message = "Your selective sync expression for " + modelDefinition.name + " contains " + filterCombinations + " field combinations (total number of predicates in an OR expression).\n\n";
            if (dynamicAuthModeFields.size > 0) message += "Note: the number of fields you can use with selective sync is affected by @auth rules configured on the model.\n\nDynamic auth modes, such as owner auth and dynamic group auth factor in to the number of combinations you're using.\n" + ("You currently have " + dynamicAuthModeFields.size + " dynamic auth mode(s) configured on this model: " + dynamicAuthFieldsStr + ".");
            return message;
        case RTFError.RepeatedFieldname:
            return "Your selective sync expression for " + modelDefinition.name + " contains multiple entries for " + repeatedField + " in the same AND group.";
        case RTFError.NotGroup:
            return "Your selective sync expression for " + modelDefinition.name + " uses a `not` group. If you'd like to filter subscriptions in the backend, " + "rewrite your expression using `ne` or `notContains` operators.";
        case RTFError.FieldNotInType:
            // no remediation instructions. We'll surface the message directly
            return "";
    }
}
function getUserGroupsFromToken(token, rule) {
    // validate token against groupClaim
    var userGroups = token[rule.groupClaim] || [];
    if (typeof userGroups === "string") {
        var parsedGroups = void 0;
        try {
            parsedGroups = JSON.parse(userGroups);
        } catch (e) {
            parsedGroups = userGroups;
        }
        userGroups = [].concat(parsedGroups);
    }
    return userGroups;
}
function getModelAuthModes(_a) {
    var authModeStrategy = _a.authModeStrategy, defaultAuthMode = _a.defaultAuthMode, modelName = _a.modelName, schema = _a.schema;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var operations, modelAuthModes, error_1;
        var _this = this;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    operations = Object.values((0, _types.ModelOperation));
                    modelAuthModes = {
                        CREATE: [],
                        READ: [],
                        UPDATE: [],
                        DELETE: []
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.all(operations.map(function(operation) {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var authModes;
                                return (0, _tslib.__generator)(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                authModeStrategy({
                                                    schema: schema,
                                                    modelName: modelName,
                                                    operation: operation
                                                })
                                            ];
                                        case 1:
                                            authModes = _a.sent();
                                            if (typeof authModes === "string") modelAuthModes[operation] = [
                                                authModes
                                            ];
                                            else if (Array.isArray(authModes) && authModes.length) modelAuthModes[operation] = authModes;
                                            else // Use default auth mode if nothing is returned from authModeStrategy
                                            modelAuthModes[operation] = [
                                                defaultAuthMode
                                            ];
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        }))
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    error_1 = _b.sent();
                    logger.debug("Error getting auth modes for model: " + modelName, error_1);
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 4:
                    return [
                        2 /*return*/ ,
                        modelAuthModes
                    ];
            }
        });
    });
}
function getForbiddenError(error) {
    var forbiddenErrorMessages = [
        "Request failed with status code 401",
        "Request failed with status code 403"
    ];
    var forbiddenError;
    if (error && error.errors) forbiddenError = error.errors.find(function(err) {
        return forbiddenErrorMessages.includes(err.message);
    });
    else if (error && error.message) forbiddenError = error;
    if (forbiddenError) return forbiddenError.message;
    return null;
}
function getClientSideAuthError(error) {
    var clientSideAuthErrors = Object.values((0, _api.GraphQLAuthError));
    var clientSideError = error && error.message && clientSideAuthErrors.find(function(clientError) {
        return error.message.includes(clientError);
    });
    return clientSideError || null;
}
function getTokenForCustomAuth(authMode, amplifyConfig) {
    if (amplifyConfig === void 0) amplifyConfig = {};
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var _a, functionAuthProvider, token, error_2;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!(authMode === (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA)) return [
                        3 /*break*/ ,
                        6
                    ];
                    _a = amplifyConfig.authProviders, functionAuthProvider = (_a === void 0 ? {
                        functionAuthProvider: null
                    } : _a).functionAuthProvider;
                    if (!(functionAuthProvider && typeof functionAuthProvider === "function")) return [
                        3 /*break*/ ,
                        5
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionAuthProvider()
                    ];
                case 2:
                    token = _b.sent().token;
                    return [
                        2 /*return*/ ,
                        token
                    ];
                case 3:
                    error_2 = _b.sent();
                    throw new Error("Error retrieving token from `functionAuthProvider`: " + error_2);
                case 4:
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 5:
                    // TODO: add docs link once available
                    throw new Error("You must provide a `functionAuthProvider` function to `DataStore.configure` when using " + (0, _apiGraphql.GRAPHQL_AUTH_MODE).AWS_LAMBDA);
                case 6:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function getIdentifierValue(modelDefinition, model) {
    var pkFieldNames = (0, _util.extractPrimaryKeyFieldNames)(modelDefinition);
    var idOrPk = pkFieldNames.map(function(f) {
        return model[f];
    }).join((0, _util.IDENTIFIER_KEY_SEPARATOR));
    return idOrPk;
}

},{"tslib":"86BcK","@aws-amplify/api-graphql":"eWncu","@aws-amplify/api":"6PDaW","@aws-amplify/core":"3rlh1","../types":"9W0ar","../util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28vIg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _indexedDBAdapter = require("../IndexedDBAdapter");
var _indexedDBAdapterDefault = parcelHelpers.interopDefault(_indexedDBAdapter);
var _asyncStorageAdapter = require("../AsyncStorageAdapter");
var _asyncStorageAdapterDefault = parcelHelpers.interopDefault(_asyncStorageAdapter);
var getDefaultAdapter = function() {
    var isBrowser = (0, _core.browserOrNode)().isBrowser;
    if (isBrowser && window.indexedDB || (0, _core.isWebWorker)() && self.indexedDB) return 0, _indexedDBAdapterDefault.default;
    return 0, _asyncStorageAdapterDefault.default;
};
exports.default = getDefaultAdapter;

},{"@aws-amplify/core":"3rlh1","../IndexedDBAdapter":"31vIO","../AsyncStorageAdapter":"aPgAF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"31vIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _idb = require("idb");
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var logger = new (0, _core.ConsoleLogger)("DataStore");
/**
 * The point after which queries composed of multiple simple OR conditions
 * should scan-and-filter instead of individual queries for each condition.
 *
 * At some point, this should be configurable and/or dynamic based on table
 * size and possibly even on observed average seek latency. For now, it's
 * based on an manual "binary search" for the breakpoint as measured in the
 * unit test suite. This isn't necessarily optimal. But, it's at least derived
 * empirically, rather than theoretically and without any verification!
 *
 * REMEMBER! If you run more realistic benchmarks and update this value, update
 * this comment so the validity and accuracy of future query tuning exercises
 * can be compared to the methods used to derive the current value. E.g.,
 *
 * 1. In browser benchmark > unit test benchmark
 * 2. Multi-browser benchmark > single browser benchmark
 * 3. Benchmarks of various table sizes > static table size benchmark
 *
 * etc...
 *
 */ var MULTI_OR_CONDITION_SCAN_BREAKPOINT = 7;
//
var DB_VERSION = 3;
var IndexedDBAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(IndexedDBAdapter, _super);
    function IndexedDBAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.safariCompatabilityMode = false;
        /**
         * Checks the given path against the browser's IndexedDB implementation for
         * necessary compatibility transformations, applying those transforms if needed.
         *
         * @param `keyArr` strings to compatibilize for browser-indexeddb index operations
         * @returns An array or string, depending on and given key,
         * that is ensured to be compatible with the IndexedDB implementation's nuances.
         */ _this.canonicalKeyPath = function(keyArr) {
            if (_this.safariCompatabilityMode) return keyArr.length > 1 ? keyArr : keyArr[0];
            return keyArr;
        };
        return _this;
    //#endregion
    }
    // checks are called by StorageAdapterBase class
    IndexedDBAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.setSafariCompatabilityMode()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initialize IndexedDB database
     * Create new DB if one doesn't exist
     * Upgrade outdated DB
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns IDB Database instance
     */ IndexedDBAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            _idb.openDB(this.dbName, DB_VERSION, {
                                upgrade: function(db, oldVersion, newVersion, txn) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var _a, _b, storeName, origStore, tmpName, _c, namespaceName, modelName, modelInCurrentSchema, newStore, cursor, count, e_1_1, error_1;
                                        var e_1, _d;
                                        var _this = this;
                                        return (0, _tslib.__generator)(this, function(_e) {
                                            switch(_e.label){
                                                case 0:
                                                    // create new database
                                                    if (oldVersion === 0) {
                                                        Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                            var namespace = _this.schema.namespaces[namespaceName];
                                                            Object.keys(namespace.models).forEach(function(modelName) {
                                                                var storeName = (0, _util.getStorename)(namespaceName, modelName);
                                                                _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                            });
                                                        });
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                    }
                                                    if (!((oldVersion === 1 || oldVersion === 2) && newVersion === 3)) return [
                                                        3 /*break*/ ,
                                                        16
                                                    ];
                                                    _e.label = 1;
                                                case 1:
                                                    _e.trys.push([
                                                        1,
                                                        14,
                                                        ,
                                                        15
                                                    ]);
                                                    _e.label = 2;
                                                case 2:
                                                    _e.trys.push([
                                                        2,
                                                        11,
                                                        12,
                                                        13
                                                    ]);
                                                    _a = (0, _tslib.__values)(txn.objectStoreNames), _b = _a.next();
                                                    _e.label = 3;
                                                case 3:
                                                    if (!!_b.done) return [
                                                        3 /*break*/ ,
                                                        10
                                                    ];
                                                    storeName = _b.value;
                                                    origStore = txn.objectStore(storeName);
                                                    tmpName = "tmp_" + storeName;
                                                    origStore.name = tmpName;
                                                    _c = this.getNamespaceAndModelFromStorename(storeName), namespaceName = _c.namespaceName, modelName = _c.modelName;
                                                    modelInCurrentSchema = modelName in this.schema.namespaces[namespaceName].models;
                                                    if (!modelInCurrentSchema) {
                                                        // delete original
                                                        db.deleteObjectStore(tmpName);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    }
                                                    newStore = this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                    return [
                                                        4 /*yield*/ ,
                                                        origStore.openCursor()
                                                    ];
                                                case 4:
                                                    cursor = _e.sent();
                                                    count = 0;
                                                    _e.label = 5;
                                                case 5:
                                                    if (!(cursor && cursor.value)) return [
                                                        3 /*break*/ ,
                                                        8
                                                    ];
                                                    // we don't pass key, since they are all new entries in the new store
                                                    return [
                                                        4 /*yield*/ ,
                                                        newStore.put(cursor.value)
                                                    ];
                                                case 6:
                                                    // we don't pass key, since they are all new entries in the new store
                                                    _e.sent();
                                                    return [
                                                        4 /*yield*/ ,
                                                        cursor.continue()
                                                    ];
                                                case 7:
                                                    cursor = _e.sent();
                                                    count++;
                                                    return [
                                                        3 /*break*/ ,
                                                        5
                                                    ];
                                                case 8:
                                                    // delete original
                                                    db.deleteObjectStore(tmpName);
                                                    logger.debug(count + " " + storeName + " records migrated");
                                                    _e.label = 9;
                                                case 9:
                                                    _b = _a.next();
                                                    return [
                                                        3 /*break*/ ,
                                                        3
                                                    ];
                                                case 10:
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 11:
                                                    e_1_1 = _e.sent();
                                                    e_1 = {
                                                        error: e_1_1
                                                    };
                                                    return [
                                                        3 /*break*/ ,
                                                        13
                                                    ];
                                                case 12:
                                                    try {
                                                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                                    } finally{
                                                        if (e_1) throw e_1.error;
                                                    }
                                                    return [
                                                        7 /*endfinally*/ 
                                                    ];
                                                case 13:
                                                    // add new models created after IndexedDB, but before migration
                                                    // this case may happen when a user has not opened an app for
                                                    // some time and a new model is added during that time
                                                    Object.keys(this.schema.namespaces).forEach(function(namespaceName) {
                                                        var namespace = _this.schema.namespaces[namespaceName];
                                                        var objectStoreNames = new Set(txn.objectStoreNames);
                                                        Object.keys(namespace.models).map(function(modelName) {
                                                            return [
                                                                modelName,
                                                                (0, _util.getStorename)(namespaceName, modelName)
                                                            ];
                                                        }).filter(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), storeName = _b[1];
                                                            return !objectStoreNames.has(storeName);
                                                        }).forEach(function(_a) {
                                                            var _b = (0, _tslib.__read)(_a, 2), modelName = _b[0], storeName = _b[1];
                                                            _this.createObjectStoreForModel(db, namespaceName, storeName, modelName);
                                                        });
                                                    });
                                                    return [
                                                        3 /*break*/ ,
                                                        15
                                                    ];
                                                case 14:
                                                    error_1 = _e.sent();
                                                    logger.error("Error migrating IndexedDB data", error_1);
                                                    txn.abort();
                                                    throw error_1;
                                                case 15:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 16:
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                }
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype._get = function(storeOrStoreName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var index, storeName, store, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof storeOrStoreName === "string") {
                            storeName = storeOrStoreName;
                            index = this.db.transaction(storeName, "readonly").store.index("byPk");
                        } else {
                            store = storeOrStoreName;
                            index = store.index("byPk");
                        }
                        return [
                            4 /*yield*/ ,
                            index.get(this.canonicalKeyPath(keyArr))
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.clear = function() {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.db) === null || _a === void 0 || _a.close();
                        return [
                            4 /*yield*/ ,
                            _idb.deleteDB(this.dbName)
                        ];
                    case 2:
                        _b.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, set, connectionStoreNames, modelKeyValues, tx, store, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, store_1, itemKeyValues, fromDB_1, opType, key, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _c.sent();
                        _b = this.saveMetadata(model), storeName = _b.storeName, set = _b.set, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        tx = this.db.transaction((0, _tslib.__spread)([
                            storeName
                        ], Array.from(set.values())), "readwrite");
                        store = tx.objectStore(storeName);
                        return [
                            4 /*yield*/ ,
                            this._get(store, modelKeyValues)
                        ];
                    case 2:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 3;
                    case 3:
                        _c.trys.push([
                            3,
                            11,
                            12,
                            17
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 5:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        store_1 = tx.objectStore(storeName_1);
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(store_1, itemKeyValues)
                        ];
                    case 6:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            store_1.index("byPk").getKey(this.canonicalKeyPath(itemKeyValues))
                        ];
                    case 7:
                        key = _c.sent();
                        return [
                            4 /*yield*/ ,
                            store_1.put(item, key)
                        ];
                    case 8:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            4 /*yield*/ ,
                            tx.done
                        ];
                    case 18:
                        _c.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, queryByKey)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!hasSort) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                if (hasPagination) return [
                                                    2 /*return*/ ,
                                                    this.enginePagination(storeName, pagination)
                                                ];
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 2:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, cursor, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.transaction([
                                storeName
                            ], "readonly").objectStore(storeName).openCursor(undefined, firstOrLast === (0, _types.QueryOne).FIRST ? "next" : "prev")
                        ];
                    case 2:
                        cursor = _a.sent();
                        result = cursor ? cursor.value : undefined;
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, result, txn, store, _loop_1, this_1, items_1, items_1_1, item, e_3_1;
            var e_3, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        result = [];
                        txn = this.db.transaction(storeName, "readwrite");
                        store = txn.store;
                        _loop_1 = function(item) {
                            var model, connectedModels, keyValues, _deleted, index, key, instance;
                            return (0, _tslib.__generator)(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        model = this_1.modelInstanceCreator(modelConstructor, item);
                                        connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                                        keyValues = this_1.getIndexKeyValuesFromModel(model);
                                        _deleted = item._deleted;
                                        index = store.index("byPk");
                                        return [
                                            4 /*yield*/ ,
                                            index.getKey(this_1.canonicalKeyPath(keyValues))
                                        ];
                                    case 1:
                                        key = _a.sent();
                                        if (!!_deleted) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        instance = connectedModels.find(function(_a) {
                                            var instance = _a.instance;
                                            var instanceKeyValues = _this.getIndexKeyValuesFromModel(instance);
                                            return (0, _util.keysEqual)(instanceKeyValues, keyValues);
                                        }).instance;
                                        result.push([
                                            instance,
                                            key ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                        ]);
                                        return [
                                            4 /*yield*/ ,
                                            store.put(instance, key)
                                        ];
                                    case 2:
                                        _a.sent();
                                        return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                    case 3:
                                        result.push([
                                            item,
                                            (0, _types.OpType).DELETE
                                        ]);
                                        if (!key) return [
                                            3 /*break*/ ,
                                            5
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            store.delete(key)
                                        ];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!items_1_1.done) return [
                            3 /*break*/ ,
                            6
                        ];
                        item = items_1_1.value;
                        return [
                            5 /*yield**/ ,
                            _loop_1(item)
                        ];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        items_1_1 = items_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        try {
                            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 9:
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 10:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_4, _a, e_5, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var connectionStoreNames, tx, _c, _d, deleteItem, storeName, items, store, items_2, items_2_1, item, key, keyValues, itemKey, e_5_1, e_4_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        connectionStoreNames = deleteQueue.map(function(_a) {
                            var storeName = _a.storeName;
                            return storeName;
                        });
                        tx = this.db.transaction((0, _tslib.__spread)(connectionStoreNames), "readwrite");
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            22,
                            23,
                            28
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 3:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            21
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        store = tx.objectStore(storeName);
                        _e.label = 4;
                    case 4:
                        _e.trys.push([
                            4,
                            14,
                            15,
                            20
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 6:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            13
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            12
                        ];
                        key = void 0;
                        if (!(typeof item === "object")) return [
                            3 /*break*/ ,
                            8
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(item);
                        return [
                            4 /*yield*/ ,
                            store.index("byPk").getKey(this.canonicalKeyPath(keyValues))
                        ];
                    case 7:
                        key = _e.sent();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        itemKey = item.toString();
                        return [
                            4 /*yield*/ ,
                            store.index("byPk").getKey(itemKey)
                        ];
                    case 9:
                        key = _e.sent();
                        _e.label = 10;
                    case 10:
                        if (!(key !== undefined)) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            store.delete(key)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 14:
                        e_5_1 = _e.sent();
                        e_5 = {
                            error: e_5_1
                        };
                        return [
                            3 /*break*/ ,
                            20
                        ];
                    case 15:
                        _e.trys.push([
                            15,
                            ,
                            18,
                            19
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            17
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 16:
                        _e.sent();
                        _e.label = 17;
                    case 17:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        if (e_5) throw e_5.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 20:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 21:
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 22:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 23:
                        _e.trys.push([
                            23,
                            ,
                            26,
                            27
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            25
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 24:
                        _e.sent();
                        _e.label = 25;
                    case 25:
                        return [
                            3 /*break*/ ,
                            27
                        ];
                    case 26:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 27:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 28:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    IndexedDBAdapter.prototype.checkPrivate = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var isPrivate;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _util.isPrivateMode)().then(function(isPrivate) {
                                return isPrivate;
                            })
                        ];
                    case 1:
                        isPrivate = _a.sent();
                        if (isPrivate) {
                            logger.error("IndexedDB not supported in this browser's private mode");
                            return [
                                2 /*return*/ ,
                                Promise.reject("IndexedDB not supported in this browser's private mode")
                            ];
                        } else return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Whether the browser's implementation of IndexedDB is coercing single-field
     * indexes to a scalar key.
     *
     * If this returns `true`, we need to treat indexes containing a single field
     * as scalars.
     *
     * See PR description for reference:
     * https://github.com/aws-amplify/amplify-js/pull/10527
     */ IndexedDBAdapter.prototype.setSafariCompatabilityMode = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, _util.isSafariCompatabilityMode)()
                        ];
                    case 1:
                        _a.safariCompatabilityMode = _b.sent();
                        if (this.safariCompatabilityMode === true) logger.debug("IndexedDB Adapter is running in Safari Compatability Mode");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getNamespaceAndModelFromStorename = function(storeName) {
        var _a = (0, _tslib.__read)(storeName.split("_")), namespaceName = _a[0], modelNameArr = _a.slice(1);
        return {
            namespaceName: namespaceName,
            modelName: modelNameArr.join("_")
        };
    };
    IndexedDBAdapter.prototype.createObjectStoreForModel = function(db, namespaceName, storeName, modelName) {
        var store = db.createObjectStore(storeName, {
            autoIncrement: true
        });
        var indexes = this.schema.namespaces[namespaceName].relationships[modelName].indexes;
        indexes.forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 3), idxName = _b[0], keyPath = _b[1], options = _b[2];
            store.createIndex(idxName, keyPath, options);
        });
        return store;
    };
    IndexedDBAdapter.prototype.getByKey = function(storeName, keyValue) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValue)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Tries to generate an index fetcher for the given predicates. Assumes
     * that the given predicate conditions are contained by an AND group and
     * should therefore all match a single record.
     *
     * @param storeName The table to query.
     * @param predicates The predicates to try to AND together.
     * @param transaction
     */ IndexedDBAdapter.prototype.matchingIndexQueries = function(storeName, predicates, transaction) {
        var e_6, _a, e_7, _b;
        var _this = this;
        // could be expanded later to include `exec()` and a `cardinality` estimate?
        var queries = [];
        var predicateIndex = new Map();
        try {
            for(var predicates_1 = (0, _tslib.__values)(predicates), predicates_1_1 = predicates_1.next(); !predicates_1_1.done; predicates_1_1 = predicates_1.next()){
                var predicate = predicates_1_1.value;
                predicateIndex.set(String(predicate.field), predicate);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (predicates_1_1 && !predicates_1_1.done && (_a = predicates_1.return)) _a.call(predicates_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var store = transaction.objectStore(storeName);
        var _loop_2 = function(name_1) {
            var e_8, _a;
            var idx = store.index(name_1);
            var keypath = Array.isArray(idx.keyPath) ? idx.keyPath : [
                idx.keyPath
            ];
            var matchingPredicateValues = [];
            try {
                for(var keypath_1 = (e_8 = void 0, (0, _tslib.__values)(keypath)), keypath_1_1 = keypath_1.next(); !keypath_1_1.done; keypath_1_1 = keypath_1.next()){
                    var field = keypath_1_1.value;
                    var p = predicateIndex.get(field);
                    if (p && p.operand !== null && p.operand !== undefined) matchingPredicateValues.push(p.operand);
                    else break;
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (keypath_1_1 && !keypath_1_1.done && (_a = keypath_1.return)) _a.call(keypath_1);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            // if we have a matching predicate field for each component of this index,
            // we can build a query for it. otherwise, we can't.
            if (matchingPredicateValues.length === keypath.length) // re-create a transaction, because the transaction used to fetch the
            // indexes may no longer be active.
            queries.push(function() {
                return _this.db.transaction(storeName).objectStore(storeName).index(name_1).getAll(_this.canonicalKeyPath(matchingPredicateValues));
            });
        };
        try {
            for(var _c = (0, _tslib.__values)(store.indexNames), _d = _c.next(); !_d.done; _d = _c.next()){
                var name_1 = _d.value;
                _loop_2(name_1);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return queries;
    };
    IndexedDBAdapter.prototype.baseQueryIndex = function(storeName, predicates, transaction) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, fieldPredicates, txn, result, groupQueries, objectQueries, indexedQueries;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        // the predicate objects we care about tend to be nested at least
                        // one level down: `{and: {or: {and: { <the predicates we want> }}}}`
                        // so, we unpack and/or groups until we find a group with more than 1
                        // child OR a child that is not a group (and is therefore a predicate "object").
                        while(predicateObjs.length === 1 && (0, _types.isPredicateGroup)(predicateObjs[0]) && predicateObjs[0].type !== "not"){
                            type = predicateObjs[0].type;
                            predicateObjs = predicateObjs[0].predicates;
                        }
                        fieldPredicates = predicateObjs.filter(function(p) {
                            return (0, _types.isPredicateObj)(p) && p.operator === "eq";
                        });
                        txn = transaction || this.db.transaction(storeName);
                        result = {};
                        if (!(type === "or")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            Promise.all(predicateObjs.filter(function(o) {
                                return (0, _types.isPredicateGroup)(o) && o.type === "and";
                            }).map(function(o) {
                                return _this.baseQueryIndex(storeName, o, txn);
                            })).then(function(queries) {
                                return queries.filter(function(q) {
                                    return q.indexedQueries.length === 1;
                                }).map(function(i) {
                                    return i.indexedQueries;
                                });
                            })
                        ];
                    case 1:
                        groupQueries = _a.sent();
                        objectQueries = predicateObjs.filter(function(o) {
                            return (0, _types.isPredicateObj)(o);
                        }).map(function(o) {
                            return _this.matchingIndexQueries(storeName, [
                                o
                            ], txn);
                        });
                        indexedQueries = (0, _tslib.__spread)(groupQueries, objectQueries).map(function(q) {
                            return q[0];
                        }).filter(function(i) {
                            return i;
                        });
                        // if, after hunting for base queries, we don't have exactly 1 base query
                        // for each child group + object, stop trying to optimize. we're not dealing
                        // with a simple query that fits the intended optimization path.
                        if (predicateObjs.length > indexedQueries.length) result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        else result = {
                            groupType: "or",
                            indexedQueries: indexedQueries
                        };
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (type === "and") // our potential indexes or lacks thereof.
                        // note that we're only optimizing for `eq` right now.
                        result = {
                            groupType: type,
                            indexedQueries: this.matchingIndexQueries(storeName, fieldPredicates, txn)
                        };
                        else result = {
                            groupType: null,
                            indexedQueries: []
                        };
                        _a.label = 3;
                    case 3:
                        if (!!transaction) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            txn.done
                        ];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, _a, groupType, indexedQueries, candidateResults, distinctResults, indexedQueries_1, indexedQueries_1_1, query, resultGroup, resultGroup_1, resultGroup_1_1, item, distinctificationString, e_9_1, filtered;
            var e_9, _b, e_10, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.baseQueryIndex(storeName, predicates)
                        ];
                    case 1:
                        _a = _d.sent(), groupType = _a.groupType, indexedQueries = _a.indexedQueries;
                        if (!(groupType === "and" && indexedQueries.length > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            indexedQueries[0]()
                        ];
                    case 2:
                        // each condition must be satsified, we can form a base set with any
                        // ONE of those conditions and then filter.
                        candidateResults = _d.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 3:
                        if (!(groupType === "or" && indexedQueries.length > 0 && indexedQueries.length <= MULTI_OR_CONDITION_SCAN_BREAKPOINT)) return [
                            3 /*break*/ ,
                            12
                        ];
                        distinctResults = new Map();
                        _d.label = 4;
                    case 4:
                        _d.trys.push([
                            4,
                            9,
                            10,
                            11
                        ]);
                        indexedQueries_1 = (0, _tslib.__values)(indexedQueries), indexedQueries_1_1 = indexedQueries_1.next();
                        _d.label = 5;
                    case 5:
                        if (!!indexedQueries_1_1.done) return [
                            3 /*break*/ ,
                            8
                        ];
                        query = indexedQueries_1_1.value;
                        return [
                            4 /*yield*/ ,
                            query()
                        ];
                    case 6:
                        resultGroup = _d.sent();
                        try {
                            for(resultGroup_1 = (e_10 = void 0, (0, _tslib.__values)(resultGroup)), resultGroup_1_1 = resultGroup_1.next(); !resultGroup_1_1.done; resultGroup_1_1 = resultGroup_1.next()){
                                item = resultGroup_1_1.value;
                                distinctificationString = JSON.stringify(item);
                                distinctResults.set(distinctificationString, item);
                            }
                        } catch (e_10_1) {
                            e_10 = {
                                error: e_10_1
                            };
                        } finally{
                            try {
                                if (resultGroup_1_1 && !resultGroup_1_1.done && (_c = resultGroup_1.return)) _c.call(resultGroup_1);
                            } finally{
                                if (e_10) throw e_10.error;
                            }
                        }
                        _d.label = 7;
                    case 7:
                        indexedQueries_1_1 = indexedQueries_1.next();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 9:
                        e_9_1 = _d.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        try {
                            if (indexedQueries_1_1 && !indexedQueries_1_1.done && (_b = indexedQueries_1.return)) _b.call(indexedQueries_1);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        // we could conceivably check for special conditions and return early here.
                        // but, this is simpler and has not yet had a measurable performance impact.
                        candidateResults = Array.from(distinctResults.values());
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 13:
                        // nothing intelligent we can do with `not` groups unless or until we start
                        // smashing comparison operators against indexes -- at which point we could
                        // perform some reversal here.
                        candidateResults = _d.sent();
                        _d.label = 14;
                    case 14:
                        filtered = predicateObjs ? candidateResults.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : candidateResults;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    IndexedDBAdapter.prototype.enginePagination = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, _a, page, _b, limit, initialRecord, cursor, pageResults, hasLimit;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!pagination) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = pagination.page, page = _a === void 0 ? 0 : _a, _b = pagination.limit, limit = _b === void 0 ? 0 : _b;
                        initialRecord = Math.max(0, page * limit) || 0;
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName).objectStore(storeName).openCursor()
                        ];
                    case 1:
                        cursor = _c.sent();
                        if (!(cursor && initialRecord > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.advance(initialRecord)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        pageResults = [];
                        hasLimit = typeof limit === "number" && limit > 0;
                        _c.label = 4;
                    case 4:
                        if (!(cursor && cursor.value)) return [
                            3 /*break*/ ,
                            6
                        ];
                        pageResults.push(cursor.value);
                        if (hasLimit && pageResults.length === limit) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.continue()
                        ];
                    case 5:
                        cursor = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 6:
                        result = pageResults;
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 8:
                        result = _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    return IndexedDBAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new IndexedDBAdapter();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","idb":"crryf","../../types":"9W0ar","../../util":"iFXfl","./StorageAdapterBase":"eAtlR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crryf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", ()=>(0, _wrapIdbValueJs.u));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapIdbValueJs.w));
parcelHelpers.export(exports, "deleteDB", ()=>deleteDB);
parcelHelpers.export(exports, "openDB", ()=>openDB);
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, _wrapIdbValueJs.w)(request).then(()=>undefined);
}
const readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        const returnVal = await target[targetFuncName](...args);
        if (isWrite) await tx.done;
        return returnVal;
    };
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));

},{"./wrap-idb-value.js":"eYyb9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eYyb9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>reverseTransformCache);
parcelHelpers.export(exports, "i", ()=>instanceOfAny);
parcelHelpers.export(exports, "r", ()=>replaceTraps);
parcelHelpers.export(exports, "u", ()=>unwrap);
parcelHelpers.export(exports, "w", ()=>wrap);
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === "function") return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eAtlR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageAdapterBase", ()=>StorageAdapterBase);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _types = require("../../types");
var _util = require("../../util");
var _relationship = require("../relationship");
var logger = new (0, _core.ConsoleLogger)("DataStore");
var DB_NAME = "amplify-datastore";
var StorageAdapterBase = /** @class */ function() {
    function StorageAdapterBase() {
        this.dbName = DB_NAME;
    }
    /**
     * Initializes local DB
     *
     * @param theSchema
     * @param namespaceResolver
     * @param modelInstanceCreator
     * @param getModelConstructorByModelName
     * @param sessionId
     */ StorageAdapterBase.prototype.setUp = function(theSchema, namespaceResolver, modelInstanceCreator, getModelConstructorByModelName, sessionId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, error_1;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preSetUpChecks()
                        ];
                    case 1:
                        _b.sent();
                        if (!!this.initPromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.initPromise = new Promise(function(res, rej) {
                            _this.resolve = res;
                            _this.reject = rej;
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.initPromise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        if (sessionId) this.dbName = DB_NAME + "-" + sessionId;
                        this.schema = theSchema;
                        this.namespaceResolver = namespaceResolver;
                        this.modelInstanceCreator = modelInstanceCreator;
                        this.getModelConstructorByModelName = getModelConstructorByModelName;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        if (!!this.db) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this.initDb()
                        ];
                    case 6:
                        _a.db = _b.sent();
                        this.resolve();
                        _b.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_1 = _b.sent();
                        this.reject(error_1);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @param modelConstructor
     * @returns local DB table name
     */ StorageAdapterBase.prototype.getStorenameForModel = function(modelConstructor) {
        var namespace = this.namespaceResolver(modelConstructor);
        var modelName = modelConstructor.name;
        return (0, _util.getStorename)(namespace, modelName);
    };
    /**
     *
     * @param model - instantiated model record
     * @returns the record's primary key values
     */ StorageAdapterBase.prototype.getIndexKeyValuesFromModel = function(model) {
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var namespaceName = this.namespaceResolver(modelConstructor);
        var keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        return (0, _util.extractPrimaryKeyValues)(model, keys);
    };
    /**
     * Common metadata for `save` operation
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.saveMetadata = function(model) {
        var _this = this;
        var modelConstructor = Object.getPrototypeOf(model).constructor;
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var connectedModels = (0, _util.traverseModel)(modelConstructor.name, model, this.schema.namespaces[namespaceName], this.modelInstanceCreator, this.getModelConstructorByModelName);
        var set = new Set();
        var connectionStoreNames = Object.values(connectedModels).map(function(_a) {
            var modelName = _a.modelName, item = _a.item, instance = _a.instance;
            var storeName = (0, _util.getStorename)(namespaceName, modelName);
            set.add(storeName);
            var keys = (0, _util.getIndexKeys)(_this.schema.namespaces[namespaceName], modelName);
            return {
                storeName: storeName,
                item: item,
                instance: instance,
                keys: keys
            };
        });
        var modelKeyValues = this.getIndexKeyValuesFromModel(model);
        return {
            storeName: storeName,
            set: set,
            connectionStoreNames: connectionStoreNames,
            modelKeyValues: modelKeyValues
        };
    };
    /**
     * Enforces conditional save. Throws if condition is not met.
     * used by individual storage adapters
     *
     * @param model
     */ StorageAdapterBase.prototype.validateSaveCondition = function(condition, fromDB) {
        if (!(condition && fromDB)) return;
        var predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
        var _a = predicates, predicateObjs = _a.predicates, type = _a.type;
        var isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
        if (!isValid) {
            var msg = "Conditional update failed";
            logger.error(msg, {
                model: fromDB,
                condition: predicateObjs
            });
            throw new Error(msg);
        }
    };
    /**
     * Instantiate models from POJO records returned from the database
     *
     * @param namespaceName - string model namespace
     * @param srcModelName - string model name
     * @param records - array of uninstantiated records
     * @returns
     */ StorageAdapterBase.prototype.load = function(namespaceName, srcModelName, records) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var namespace, relations, connectionStoreNames, modelConstructor;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                namespace = this.schema.namespaces[namespaceName];
                relations = namespace.relationships[srcModelName].relationTypes;
                connectionStoreNames = relations.map(function(_a) {
                    var modelName = _a.modelName;
                    return (0, _util.getStorename)(namespaceName, modelName);
                });
                modelConstructor = this.getModelConstructorByModelName(namespaceName, srcModelName);
                if (connectionStoreNames.length === 0) return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
                return [
                    2 /*return*/ ,
                    records.map(function(record) {
                        return _this.modelInstanceCreator(modelConstructor, record);
                    })
                ];
            });
        });
    };
    /**
     * Extracts operands from a predicate group into an array of key values
     * Used in the query method
     *
     * @param predicates - predicate group
     * @param keyPath - string array of key names ['id', 'sortKey']
     * @returns string[] of key values
     *
     * @example
     * ```js
     * { and:[{ id: { eq: 'abc' }}, { sortKey: { eq: 'def' }}] }
     * ```
     * Becomes
     * ```
     * ['abc', 'def']
     * ```
     */ StorageAdapterBase.prototype.keyValueFromPredicate = function(predicates, keyPath) {
        var e_1, _a;
        var predicateObjs = predicates.predicates;
        if (predicateObjs.length !== keyPath.length) return;
        var keyValues = [];
        var _loop_1 = function(key) {
            var predicateObj = predicateObjs.find(function(p) {
                // it's a relevant predicate object only if it's an equality
                // operation for a key field from the key:
                return (0, _types.isPredicateObj)(p) && p.field === key && p.operator === "eq" && p.operand !== null && p.operand !== undefined;
            });
            predicateObj && keyValues.push(predicateObj.operand);
        };
        try {
            for(var keyPath_1 = (0, _tslib.__values)(keyPath), keyPath_1_1 = keyPath_1.next(); !keyPath_1_1.done; keyPath_1_1 = keyPath_1.next()){
                var key = keyPath_1_1.value;
                _loop_1(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keyPath_1_1 && !keyPath_1_1.done && (_a = keyPath_1.return)) _a.call(keyPath_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return keyValues.length === keyPath.length ? keyValues : undefined;
    };
    /**
     * Common metadata for `query` operation
     * used by individual storage adapters
     *
     * @param modelConstructor
     * @param predicate
     * @param pagination
     */ StorageAdapterBase.prototype.queryMetadata = function(modelConstructor, predicate, pagination) {
        var storeName = this.getStorenameForModel(modelConstructor);
        var namespaceName = this.namespaceResolver(modelConstructor);
        var predicates = predicate && (0, _predicates.ModelPredicateCreator).getPredicates(predicate);
        var keyPath = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelConstructor.name);
        var queryByKey = predicates && this.keyValueFromPredicate(predicates, keyPath);
        var hasSort = pagination && pagination.sort;
        var hasPagination = pagination && pagination.limit;
        return {
            storeName: storeName,
            namespaceName: namespaceName,
            queryByKey: queryByKey,
            predicates: predicates,
            hasSort: hasSort,
            hasPagination: hasPagination
        };
    };
    /**
     * Delete record
     * Cascades to related records (for Has One and Has Many relationships)
     *
     * @param modelOrModelConstructor
     * @param condition
     * @returns
     */ StorageAdapterBase.prototype.delete = function(modelOrModelConstructor, condition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteQueue, modelConstructor, namespace, models, deletedModels, deletedModels, model, modelConstructor, namespaceName, storeName, keyValues, fromDB, msg, predicates, _a, predicateObjs, type, isValid, msg, deletedModels;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.preOpCheck()
                        ];
                    case 1:
                        _b.sent();
                        deleteQueue = [];
                        if (!(0, _util.isModelConstructor)(modelOrModelConstructor)) return [
                            3 /*break*/ ,
                            9
                        ];
                        modelConstructor = modelOrModelConstructor;
                        namespace = this.namespaceResolver(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.query(modelConstructor, condition)
                        ];
                    case 2:
                        models = _b.sent();
                        if (!(condition !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 3:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 4:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(models, modelConstructor, namespace, deleteQueue)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 7:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 9:
                        model = modelOrModelConstructor;
                        modelConstructor = Object.getPrototypeOf(model).constructor;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        if (!condition) return [
                            3 /*break*/ ,
                            12
                        ];
                        keyValues = this.getIndexKeyValuesFromModel(model);
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, keyValues)
                        ];
                    case 10:
                        fromDB = _b.sent();
                        if (fromDB === undefined) {
                            msg = "Model instance not found in storage";
                            logger.warn(msg, {
                                model: model
                            });
                            return [
                                2 /*return*/ ,
                                [
                                    [
                                        model
                                    ],
                                    []
                                ]
                            ];
                        }
                        predicates = (0, _predicates.ModelPredicateCreator).getPredicates(condition);
                        _a = predicates, predicateObjs = _a.predicates, type = _a.type;
                        isValid = (0, _util.validatePredicate)(fromDB, type, predicateObjs);
                        if (!isValid) {
                            msg = "Conditional update failed";
                            logger.error(msg, {
                                model: fromDB,
                                condition: predicateObjs
                            });
                            throw new Error(msg);
                        }
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 11:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse([
                                model
                            ], modelConstructor, namespaceName, deleteQueue)
                        ];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 15:
                        _b.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                [
                                    model
                                ],
                                deletedModels
                            ]
                        ];
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Recursively traverse relationship graph and add
     * all Has One and Has Many relations to `deleteQueue` param
     *
     * Actual deletion of records added to `deleteQueue` occurs in the `delete` method
     *
     * @param models
     * @param modelConstructor
     * @param namespace
     * @param deleteQueue
     */ StorageAdapterBase.prototype.deleteTraverse = function(models, modelConstructor, namespace, deleteQueue) {
        var models_1, models_1_1;
        var e_2, _a, e_3, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var cascadingRelationTypes, model, modelDefinition, modelMeta, relationships, relationships_1, relationships_1_1, r, queryObject, relatedRecords, e_3_1, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        cascadingRelationTypes = [
                            "HAS_ONE",
                            "HAS_MANY"
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            19,
                            20,
                            25
                        ]);
                        models_1 = (0, _tslib.__asyncValues)(models);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            models_1.next()
                        ];
                    case 3:
                        if (!(models_1_1 = _c.sent(), !models_1_1.done)) return [
                            3 /*break*/ ,
                            18
                        ];
                        model = models_1_1.value;
                        modelDefinition = this.schema.namespaces[namespace].models[modelConstructor.name];
                        modelMeta = {
                            builder: modelConstructor,
                            schema: modelDefinition,
                            pkField: (0, _util.extractPrimaryKeyFieldNames)(modelDefinition)
                        };
                        relationships = (0, _relationship.ModelRelationship).allFrom(modelMeta).filter(function(r) {
                            return cascadingRelationTypes.includes(r.type);
                        });
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            11,
                            12,
                            17
                        ]);
                        relationships_1 = (0, _tslib.__asyncValues)(relationships);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            relationships_1.next()
                        ];
                    case 6:
                        if (!(relationships_1_1 = _c.sent(), !relationships_1_1.done)) return [
                            3 /*break*/ ,
                            10
                        ];
                        r = relationships_1_1.value;
                        queryObject = r.createRemoteQueryObject(model);
                        if (!(queryObject !== null)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.query(r.remoteModelConstructor, (0, _predicates.ModelPredicateCreator).createFromFlatEqualities(r.remoteDefinition, queryObject))
                        ];
                    case 7:
                        relatedRecords = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relatedRecords, r.remoteModelConstructor, namespace, deleteQueue)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 11:
                        e_3_1 = _c.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 12:
                        _c.trys.push([
                            12,
                            ,
                            15,
                            16
                        ]);
                        if (!(relationships_1_1 && !relationships_1_1.done && (_b = relationships_1.return))) return [
                            3 /*break*/ ,
                            14
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(relationships_1)
                        ];
                    case 13:
                        _c.sent();
                        _c.label = 14;
                    case 14:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 18:
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 19:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 20:
                        _c.trys.push([
                            20,
                            ,
                            23,
                            24
                        ]);
                        if (!(models_1_1 && !models_1_1.done && (_a = models_1.return))) return [
                            3 /*break*/ ,
                            22
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(models_1)
                        ];
                    case 21:
                        _c.sent();
                        _c.label = 22;
                    case 22:
                        return [
                            3 /*break*/ ,
                            24
                        ];
                    case 23:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 24:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 25:
                        deleteQueue.push({
                            storeName: (0, _util.getStorename)(namespace, modelConstructor.name),
                            items: models
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return StorageAdapterBase;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","../../predicates":"bohgw","../../types":"9W0ar","../../util":"iFXfl","../relationship":"bT2iw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bT2iw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelRelationship", ()=>ModelRelationship);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
/**
 * Defines a relationship from a LOCAL model.field to a REMOTE model.field and helps
 * navigate the relationship, providing a simplified peek at the relationship details
 * pertinent to setting FK's and constructing join conditions.
 *
 * Because I mean, relationships are tough.
 *
 */ var ModelRelationship = /** @class */ function() {
    /**
     * @param modelDefinition The "local" model.
     * @param field The "local" model field.
     */ function ModelRelationship(model, field) {
        if (!(0, _types.isFieldAssociation)(model.schema, field)) throw new Error(model.schema.name + "." + field + " is not a relationship.");
        this.localModel = model;
        this._field = field;
    }
    /**
     * Returns a ModelRelationship for the the given model and field if the pair
     * indicates a relationship to another model. Else, returns `null`.
     *
     * @param model The model the relationship field exists in.
     * @param field The field that may relates the local model to the remote model.
     */ ModelRelationship.from = function(model, field) {
        if ((0, _types.isFieldAssociation)(model.schema, field)) return new this(model, field);
        else return null;
    };
    /**
     * Enumerates all valid `ModelRelationship`'s on the given model.
     *
     * @param model The model definition to enumerate relationships of.
     */ ModelRelationship.allFrom = function(model) {
        var e_1, _a;
        var relationships = [];
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(model.schema.fields)), _c = _b.next(); !_c.done; _c = _b.next()){
                var field = _c.value;
                var relationship = ModelRelationship.from(model, field);
                relationship && relationships.push(relationship);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return relationships;
    };
    Object.defineProperty(ModelRelationship.prototype, "localDefinition", {
        get: function() {
            return this.localModel.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "field", {
        /**
         * The virtual/computed field on the local model that should contain
         * the related model.
         */ get: function() {
            return this._field;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localConstructor", {
        /**
         * The constructor that can be used to query DataStore or create instance for
         * the local model.
         */ get: function() {
            return this.localModel.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "type", {
        /**
         * The name/type of the relationship the local model has with the remote model
         * via the defined local model field.
         */ get: function() {
            return this.localAssocation.connectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssocation", {
        /**
         * Raw details about the local FK as-is from the local model's field definition in
         * the schema. This field requires interpretation.
         *
         * @see localJoinFields
         * @see localAssociatedWith
         */ get: function() {
            return this.localDefinition.fields[this.field].association;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localJoinFields", {
        /**
         * The field names on the local model that can be used to query or queried to match
         * with instances of the remote model.
         *
         * Fields are returned in-order to match the order of `this.remoteKeyFields`.
         */ get: function() {
            /**
             * This is relatively straightforward, actually.
             *
             * If we have explicitly stated targetNames, codegen is telling us authoritatively
             * to use those fields for this relationship. The local model "points to" fields
             * in the remote one.
             *
             * In other cases, the remote model points to this one's
             */ if (this.localAssocation.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.localAssocation.targetName
            ];
            else if (this.localAssocation.targetNames) return this.localAssocation.targetNames;
            else return this.localPKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localPKFields", {
        /**
         * The field names on the local model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function() {
            return this.localModel.pkField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteDefinition", {
        get: function() {
            var _a;
            return (_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.schema;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelType", {
        get: function() {
            return this.localDefinition.fields[this.field].type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteModelConstructor", {
        /**
         * Constructor that can be used to query DataStore or create instances for
         * the remote model.
         */ get: function() {
            return this.remoteModelType.modelConstructor.builder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remotePKFields", {
        /**
         * The field names on the remote model that uniquely identify it.
         *
         * These fields may or may not be relevant to the join fields.
         */ get: function() {
            var _a;
            return ((_a = this.remoteModelType.modelConstructor) === null || _a === void 0 ? void 0 : _a.pkField) || [
                "id"
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "localAssociatedWith", {
        /**
         * The `associatedWith` fields from the local perspective.
         *
         * When present, these fields indicate which fields on the remote model to use
         * when looking for a remote association and/or determining the final remote
         * key fields.
         */ get: function() {
            if (this.localAssocation.connectionType === "HAS_MANY" || this.localAssocation.connectionType === "HAS_ONE") // This de-arraying is theoretically unnecessary going forward.
            return Array.isArray(this.localAssocation.associatedWith) ? this.localAssocation.associatedWith : [
                this.localAssocation.associatedWith
            ];
            else return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "explicitRemoteAssociation", {
        /**
         * The `remote` model's associated field's `assocation` metadata, if
         * present.
         *
         * This is used when determining if the remote model's associated field
         * specifies which FK fields to use. If this value is `undefined`, the
         * name of the remote field (`this.localAssociatedWith`) *is* the remote
         * key field.
         */ get: function() {
            var _a;
            if (this.localAssociatedWith) {
                if (this.localAssociatedWith.length === 1) return (_a = this.remoteDefinition.fields[this.localAssociatedWith[0]]) === null || _a === void 0 ? void 0 : _a.association;
                else return undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "remoteJoinFields", {
        /**
         * The field names on the remote model that can used to query or queried to match
         * with instances of the local model.
         *
         * Fields are returned in-order to match the order of `this.localKeyFields`.
         */ get: function() {
            /**
             * If the local relationship explicitly names "associated with" fields, we
             * need to see if this points direction to a reciprocating assocation. If it
             * does, the remote assocation indicates what fields to use.
             */ var _a, _b, _c;
            if ((_a = this.explicitRemoteAssociation) === null || _a === void 0 ? void 0 : _a.targetName) // This case is theoretically unnecessary going forward.
            return [
                this.explicitRemoteAssociation.targetName
            ];
            else if ((_b = this.explicitRemoteAssociation) === null || _b === void 0 ? void 0 : _b.targetNames) return (_c = this.explicitRemoteAssociation) === null || _c === void 0 ? void 0 : _c.targetNames;
            else if (this.localAssociatedWith) return this.localAssociatedWith;
            else return this.remotePKFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModelRelationship.prototype, "isComplete", {
        /**
         * Whether this relationship everything necessary to get, set, and query from
         * the perspective of the local model provided at instantiation.
         */ get: function() {
            return this.localJoinFields.length > 0 && this.remoteJoinFields.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates an FK mapper object with respect to the given related instance.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	parentId: remote.customId,
     * 	parentName: remote.name
     * }
     * ```
     *
     * @param remote The remote related instance.
     */ ModelRelationship.prototype.createLocalFKObject = function(remote) {
        var fk = {};
        for(var i = 0; i < this.localJoinFields.length; i++)fk[this.localJoinFields[i]] = remote[this.remoteJoinFields[i]];
        return fk;
    };
    /**
     * Creates an query mapper object to help fetch the remote instance(s) or
     * `null` if any of the necessary local fields are `null` or `undefined`.
     *
     * E.g., if the local FK fields are `[parentId, parentName]` and point to
     * `[customId, name]` on the remote model, `createLocalFKObject(remote)`
     * will return:
     *
     * ```
     * {
     * 	customId: local.parentId
     * 	name: local.parentName
     * }
     * ```
     *
     * If the local fields are not populated, returns
     *
     * @param local The local instance.
     */ ModelRelationship.prototype.createRemoteQueryObject = function(local) {
        var query = {};
        for(var i = 0; i < this.remoteJoinFields.length; i++){
            var localValue = local[this.localJoinFields[i]];
            if (localValue === null || localValue === undefined) return null;
            query[this.remoteJoinFields[i]] = local[this.localJoinFields[i]];
        }
        return query;
    };
    return ModelRelationship;
}();

},{"tslib":"86BcK","../types":"9W0ar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPgAF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncStorageAdapter", ()=>AsyncStorageAdapter);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _asyncStorageDatabase = require("./AsyncStorageDatabase");
var _asyncStorageDatabaseDefault = parcelHelpers.interopDefault(_asyncStorageDatabase);
var _types = require("../../types");
var _util = require("../../util");
var _storageAdapterBase = require("./StorageAdapterBase");
var AsyncStorageAdapter = /** @class */ function(_super) {
    (0, _tslib.__extends)(AsyncStorageAdapter, _super);
    function AsyncStorageAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // no-ops for this adapter
    AsyncStorageAdapter.prototype.preSetUpChecks = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AsyncStorageAdapter.prototype.preOpCheck = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Open AsyncStorage database
     * Create new DB if one doesn't exist
     *
     * Called by `StorageAdapterBase.setUp()`
     *
     * @returns AsyncStorageDatabase instance
     */ AsyncStorageAdapter.prototype.initDb = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var db;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        db = new (0, _asyncStorageDatabaseDefault.default)();
                        return [
                            4 /*yield*/ ,
                            db.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            db
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.clear()
                        ];
                    case 1:
                        _a.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.batchSave = function(modelConstructor, items) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelName, namespaceName, storeName, keys, batch, _loop_1, this_1, items_1, items_1_1, item;
            var e_1, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        modelName = modelConstructor.name;
                        namespaceName = this.namespaceResolver(modelConstructor);
                        storeName = (0, _util.getStorename)(namespaceName, modelName);
                        keys = (0, _util.getIndexKeys)(this.schema.namespaces[namespaceName], modelName);
                        batch = [];
                        _loop_1 = function(item) {
                            var model = this_1.modelInstanceCreator(modelConstructor, item);
                            var connectedModels = (0, _util.traverseModel)(modelName, model, this_1.schema.namespaces[namespaceName], this_1.modelInstanceCreator, this_1.getModelConstructorByModelName);
                            var keyValuesPath = this_1.getIndexKeyValuesPath(model);
                            var instance = connectedModels.find(function(_a) {
                                var instance = _a.instance;
                                var instanceKeyValuesPath = _this.getIndexKeyValuesPath(instance);
                                return (0, _util.keysEqual)([
                                    instanceKeyValuesPath
                                ], [
                                    keyValuesPath
                                ]);
                            }).instance;
                            batch.push(instance);
                        };
                        this_1 = this;
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.db.batchSave(storeName, batch, keys)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype._get = function(storeName, keyArr) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemKeyValuesPath;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        itemKeyValuesPath = keyArr.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                        return [
                            4 /*yield*/ ,
                            this.db.get(itemKeyValuesPath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.save = function(model, condition) {
        var e_2, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _b, storeName, connectionStoreNames, modelKeyValues, fromDB, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, keys, itemKeyValues, fromDB_1, opType, e_2_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = this.saveMetadata(model), storeName = _b.storeName, connectionStoreNames = _b.connectionStoreNames, modelKeyValues = _b.modelKeyValues;
                        return [
                            4 /*yield*/ ,
                            this._get(storeName, modelKeyValues)
                        ];
                    case 1:
                        fromDB = _c.sent();
                        this.validateSaveCondition(condition, fromDB);
                        result = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            9,
                            10,
                            15
                        ]);
                        connectionStoreNames_1 = (0, _tslib.__asyncValues)(connectionStoreNames);
                        _c.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 4:
                        if (!(connectionStoreNames_1_1 = _c.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance, keys = resItem.keys;
                        itemKeyValues = keys.map(function(key) {
                            return item[key];
                        });
                        return [
                            4 /*yield*/ ,
                            this._get(storeName_1, itemKeyValues)
                        ];
                    case 5:
                        fromDB_1 = _c.sent();
                        opType = fromDB_1 ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT;
                        if (!((0, _util.keysEqual)(itemKeyValues, modelKeyValues) || opType === (0, _types.OpType).INSERT)) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.db.save(item, storeName_1, keys, itemKeyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)))
                        ];
                    case 6:
                        _c.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _c.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_2_1 = _c.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _c.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, storeName, namespaceName, queryByKey, predicates, hasSort, hasPagination, records;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.queryMetadata(modelConstructor, predicate, pagination), storeName = _a.storeName, namespaceName = _a.namespaceName, queryByKey = _a.queryByKey, predicates = _a.predicates, hasSort = _a.hasSort, hasPagination = _a.hasPagination;
                        return [
                            4 /*yield*/ ,
                            function() {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var keyValues, record, filtered, all;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!queryByKey) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                keyValues = queryByKey.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getByKey(storeName, keyValues)
                                                ];
                                            case 1:
                                                record = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    record ? [
                                                        record
                                                    ] : []
                                                ];
                                            case 2:
                                                if (!predicates) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.filterOnPredicate(storeName, predicates)
                                                ];
                                            case 3:
                                                filtered = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(filtered, pagination)
                                                ];
                                            case 4:
                                                if (!(hasSort || hasPagination)) return [
                                                    3 /*break*/ ,
                                                    6
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getAll(storeName)
                                                ];
                                            case 5:
                                                all = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    this.inMemoryPagination(all, pagination)
                                                ];
                                            case 6:
                                                return [
                                                    2 /*return*/ ,
                                                    this.getAll(storeName)
                                                ];
                                        }
                                    });
                                });
                            }()
                        ];
                    case 1:
                        records = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, records)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getByKey = function(storeName, keyValuePath) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.get(keyValuePath, storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.getAll = function(storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.filterOnPredicate = function(storeName, predicates) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var predicateObjs, type, all, filtered;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        predicateObjs = predicates.predicates, type = predicates.type;
                        return [
                            4 /*yield*/ ,
                            this.getAll(storeName)
                        ];
                    case 1:
                        all = _a.sent();
                        filtered = predicateObjs ? all.filter(function(m) {
                            return (0, _util.validatePredicate)(m, type, predicateObjs);
                        }) : all;
                        return [
                            2 /*return*/ ,
                            filtered
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.inMemoryPagination = function(records, pagination) {
        return (0, _util.inMemoryPagination)(records, pagination);
    };
    AsyncStorageAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, _types.QueryOne).FIRST;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var storeName, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.getOne(firstOrLast, storeName)
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    AsyncStorageAdapter.prototype.deleteItem = function(deleteQueue) {
        var e_3, _a, e_4, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, _d, deleteItem, storeName, items, items_2, items_2_1, item, keyValuesPath, e_4_1, e_3_1;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            17,
                            18,
                            23
                        ]);
                        _c = (0, _tslib.__asyncValues)(deleteQueue);
                        _e.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _c.next()
                        ];
                    case 2:
                        if (!(_d = _e.sent(), !_d.done)) return [
                            3 /*break*/ ,
                            16
                        ];
                        deleteItem = _d.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([
                            3,
                            9,
                            10,
                            15
                        ]);
                        items_2 = (0, _tslib.__asyncValues)(items);
                        _e.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            items_2.next()
                        ];
                    case 5:
                        if (!(items_2_1 = _e.sent(), !items_2_1.done)) return [
                            3 /*break*/ ,
                            8
                        ];
                        item = items_2_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!(typeof item === "object")) return [
                            3 /*break*/ ,
                            7
                        ];
                        keyValuesPath = this.getIndexKeyValuesPath(item);
                        return [
                            4 /*yield*/ ,
                            this.db.delete(keyValuesPath, storeName)
                        ];
                    case 6:
                        _e.sent();
                        _e.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 9:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 10:
                        _e.trys.push([
                            10,
                            ,
                            13,
                            14
                        ]);
                        if (!(items_2_1 && !items_2_1.done && (_b = items_2.return))) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_2)
                        ];
                    case 11:
                        _e.sent();
                        _e.label = 12;
                    case 12:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 16:
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 17:
                        e_3_1 = _e.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            23
                        ];
                    case 18:
                        _e.trys.push([
                            18,
                            ,
                            21,
                            22
                        ]);
                        if (!(_d && !_d.done && (_a = _c.return))) return [
                            3 /*break*/ ,
                            20
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(_c)
                        ];
                    case 19:
                        _e.sent();
                        _e.label = 20;
                    case 20:
                        return [
                            3 /*break*/ ,
                            22
                        ];
                    case 21:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 22:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 23:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    //#region platform-specific helper methods
    /**
     * Retrieves concatenated primary key values from a model
     *
     * @param model
     * @returns
     */ AsyncStorageAdapter.prototype.getIndexKeyValuesPath = function(model) {
        return this.getIndexKeyValuesFromModel(model).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
    };
    return AsyncStorageAdapter;
}((0, _storageAdapterBase.StorageAdapterBase));
exports.default = new AsyncStorageAdapter();

},{"tslib":"86BcK","./AsyncStorageDatabase":"lhXYC","../../types":"9W0ar","../../util":"iFXfl","./StorageAdapterBase":"eAtlR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lhXYC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _types = require("../../types");
var _util = require("../../util");
var _inMemoryStore = require("./InMemoryStore");
var DB_NAME = "@AmplifyDatastore";
var COLLECTION = "Collection";
var DATA = "Data";
var monotonicFactoriesMap = new Map();
var AsyncStorageDatabase = /** @class */ function() {
    function AsyncStorageDatabase() {
        /**
         * Maps storeNames to a map of ulid->id
         */ this._collectionInMemoryIndex = new Map();
        this.storage = (0, _inMemoryStore.createInMemoryStore)();
    }
    /**
     * Collection index is map of stores (i.e. sync, metadata, mutation event, and data)
     * @param storeName {string} - Name of the store
     * @returns Map of ulid->id
     */ AsyncStorageDatabase.prototype.getCollectionIndex = function(storeName) {
        if (!this._collectionInMemoryIndex.has(storeName)) this._collectionInMemoryIndex.set(storeName, new Map());
        return this._collectionInMemoryIndex.get(storeName);
    };
    /**
     * Return ULID for store if it exists, otherwise create a new one
     * @param storeName {string} - Name of the store
     * @returns ulid
     */ AsyncStorageDatabase.prototype.getMonotonicFactory = function(storeName) {
        if (!monotonicFactoriesMap.has(storeName)) monotonicFactoriesMap.set(storeName, (0, _util.monotonicUlidFactory)());
        return monotonicFactoriesMap.get(storeName);
    };
    AsyncStorageDatabase.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, keysForCollectionEntries, allKeys_1, allKeys_1_1, key, _a, dbName, storeName, recordType, ulidOrId, id, ulid, id_1, newUlid, oldKey, newKey, item, e_1_1;
            var e_1, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this._collectionInMemoryIndex.clear();
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _c.sent();
                        keysForCollectionEntries = [];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([
                            2,
                            12,
                            13,
                            14
                        ]);
                        allKeys_1 = (0, _tslib.__values)(allKeys), allKeys_1_1 = allKeys_1.next();
                        _c.label = 3;
                    case 3:
                        if (!!allKeys_1_1.done) return [
                            3 /*break*/ ,
                            11
                        ];
                        key = allKeys_1_1.value;
                        _a = (0, _tslib.__read)(key.split("::"), 5), dbName = _a[0], storeName = _a[1], recordType = _a[2], ulidOrId = _a[3], id = _a[4];
                        if (!(dbName === DB_NAME)) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!(recordType === DATA)) return [
                            3 /*break*/ ,
                            9
                        ];
                        ulid = void 0;
                        if (!(id === undefined)) return [
                            3 /*break*/ ,
                            7
                        ];
                        id_1 = ulidOrId;
                        newUlid = this.getMonotonicFactory(storeName)();
                        oldKey = this.getLegacyKeyForItem(storeName, id_1);
                        newKey = this.getKeyForItem(storeName, id_1, newUlid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(oldKey)
                        ];
                    case 4:
                        item = _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(newKey, item)
                        ];
                    case 5:
                        _c.sent();
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(oldKey)
                        ];
                    case 6:
                        _c.sent();
                        ulid = newUlid;
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        ulid = ulidOrId;
                        _c.label = 8;
                    case 8:
                        this.getCollectionIndex(storeName).set(id, ulid);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        if (recordType === COLLECTION) keysForCollectionEntries.push(key);
                        _c.label = 10;
                    case 10:
                        allKeys_1_1 = allKeys_1.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 12:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        try {
                            if (allKeys_1_1 && !allKeys_1_1.done && (_b = allKeys_1.return)) _b.call(allKeys_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 14:
                        if (!(keysForCollectionEntries.length > 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(keysForCollectionEntries)
                        ];
                    case 15:
                        _c.sent();
                        _c.label = 16;
                    case 16:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.save = function(item, storeName, keys, keyValuesPath) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var idxName, ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        idxName = (0, _util.indexNameFromKeys)(keys);
                        ulid = ((_a = this.getCollectionIndex(storeName)) === null || _a === void 0 ? void 0 : _a.get(idxName)) || this.getMonotonicFactory(storeName)();
                        itemKey = this.getKeyForItem(storeName, keyValuesPath, ulid);
                        // Set key in collection index
                        (_b = this.getCollectionIndex(storeName)) === null || _b === void 0 || _b.set(keyValuesPath, ulid);
                        // Save item in db
                        return [
                            4 /*yield*/ ,
                            this.storage.setItem(itemKey, JSON.stringify(item))
                        ];
                    case 1:
                        // Save item in db
                        _c.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.batchSave = function(storeName, items, keys) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, collection, keysToDelete, keysToSave, allItemsKeys, itemsMap, _loop_1, this_1, items_1, items_1_1, item, existingRecordsMap, existingRecordsKeys, allItemsKeys_1, allItemsKeys_1_1, key;
            var e_2, _a, e_3, _b;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (items.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        result = [];
                        collection = this.getCollectionIndex(storeName);
                        keysToDelete = new Set();
                        keysToSave = new Set();
                        allItemsKeys = [];
                        itemsMap = {};
                        _loop_1 = function(item) {
                            // Extract keys from concatenated key path, map to item values
                            var keyValues = keys.map(function(field) {
                                return item[field];
                            });
                            var _deleted = item._deleted;
                            // If id is in the store, retrieve, otherwise generate new ULID
                            var ulid = collection.get(keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR))) || this_1.getMonotonicFactory(storeName)();
                            // Generate the "longer key" for the item
                            var key = this_1.getKeyForItem(storeName, keyValues.join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR)), ulid);
                            allItemsKeys.push(key);
                            itemsMap[key] = {
                                ulid: ulid,
                                model: item
                            };
                            if (_deleted) keysToDelete.add(key);
                            else keysToSave.add(key);
                        };
                        this_1 = this;
                        try {
                            /* Populate allItemKeys, keysToDelete, and keysToSave */ for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                _loop_1(item);
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(allItemsKeys)
                        ];
                    case 1:
                        existingRecordsMap = _c.sent();
                        existingRecordsKeys = existingRecordsMap.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
                            return !!v;
                        }).reduce(function(set, _a) {
                            var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
                            return set.add(k);
                        }, new Set());
                        // Delete
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToDelete.size === 0) {
                                    resolve();
                                    return;
                                }
                                var keysToDeleteArray = Array.from(keysToDelete);
                                keysToDeleteArray.forEach(function(key) {
                                    // key: full db key
                                    // keys: PK and/or SK keys
                                    var primaryKeyValues = keys.map(function(field) {
                                        return itemsMap[key].model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.delete(primaryKeyValues);
                                });
                                _this.storage.multiRemove(keysToDeleteArray, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 2:
                        // Delete
                        _c.sent();
                        // Save
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                if (keysToSave.size === 0) {
                                    resolve();
                                    return;
                                }
                                var entriesToSet = Array.from(keysToSave).map(function(key) {
                                    return [
                                        key,
                                        JSON.stringify(itemsMap[key].model)
                                    ];
                                });
                                keysToSave.forEach(function(key) {
                                    var _a = itemsMap[key], model = _a.model, ulid = _a.ulid;
                                    // Retrieve values from model, use as key for collection index
                                    var keyValues = keys.map(function(field) {
                                        return model[field];
                                    }).join((0, _util.DEFAULT_PRIMARY_KEY_VALUE_SEPARATOR));
                                    collection.set(keyValues, ulid);
                                });
                                _this.storage.multiSet(entriesToSet, function(errors) {
                                    if (errors && errors.length > 0) reject(errors);
                                    else resolve();
                                });
                            })
                        ];
                    case 3:
                        // Save
                        _c.sent();
                        try {
                            for(allItemsKeys_1 = (0, _tslib.__values)(allItemsKeys), allItemsKeys_1_1 = allItemsKeys_1.next(); !allItemsKeys_1_1.done; allItemsKeys_1_1 = allItemsKeys_1.next()){
                                key = allItemsKeys_1_1.value;
                                if (keysToDelete.has(key) && existingRecordsKeys.has(key)) result.push([
                                    itemsMap[key].model,
                                    (0, _types.OpType).DELETE
                                ]);
                                else if (keysToSave.has(key)) result.push([
                                    itemsMap[key].model,
                                    existingRecordsKeys.has(key) ? (0, _types.OpType).UPDATE : (0, _types.OpType).INSERT
                                ]);
                            }
                        } catch (e_3_1) {
                            e_3 = {
                                error: e_3_1
                            };
                        } finally{
                            try {
                                if (allItemsKeys_1_1 && !allItemsKeys_1_1.done && (_b = allItemsKeys_1.return)) _b.call(allItemsKeys_1);
                            } finally{
                                if (e_3) throw e_3.error;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.get = function(keyValuePath, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey, recordAsString, record;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(keyValuePath);
                        itemKey = this.getKeyForItem(storeName, keyValuePath, ulid);
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        recordAsString = _a.sent();
                        record = recordAsString && JSON.parse(recordAsString);
                        return [
                            2 /*return*/ ,
                            record
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getOne = function(firstOrLast, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, itemId, ulid, itemKey, itemString, _b, result;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = (0, _tslib.__read)(firstOrLast === (0, _types.QueryOne).FIRST ? function() {
                            var e_4, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_1 = (0, _tslib.__values)(collection), collection_1_1 = collection_1.next(); !collection_1_1.done; collection_1_1 = collection_1.next()){
                                    _b = (0, _tslib.__read)(collection_1_1.value, 2), id = _b[0], ulid = _b[1];
                                    break;
                                } // Get first element of the set
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (collection_1_1 && !collection_1_1.done && (_a = collection_1.return)) _a.call(collection_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }() : function() {
                            var e_5, _a, _b;
                            var id, ulid;
                            try {
                                for(var collection_2 = (0, _tslib.__values)(collection), collection_2_1 = collection_2.next(); !collection_2_1.done; collection_2_1 = collection_2.next())_b = (0, _tslib.__read)(collection_2_1.value, 2), id = _b[0], ulid = _b[1];
                                 // Get last element of the set
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (collection_2_1 && !collection_2_1.done && (_a = collection_2.return)) _a.call(collection_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                            return [
                                id,
                                ulid
                            ];
                        }(), 2), itemId = _a[0], ulid = _a[1];
                        itemKey = this.getKeyForItem(storeName, itemId, ulid);
                        _b = itemKey;
                        if (!_b) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.storage.getItem(itemKey)
                        ];
                    case 1:
                        _b = _c.sent();
                        _c.label = 2;
                    case 2:
                        itemString = _b;
                        result = itemString ? JSON.parse(itemString) || undefined : undefined;
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * This function gets all the records stored in async storage for a particular storeName
     * It then loads all the records for that filtered set of keys using multiGet()
     */ AsyncStorageDatabase.prototype.getAll = function(storeName, pagination) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var collection, _a, _b, page, _c, limit, start, end, keysForStore, count, collection_3, collection_3_1, _d, id, ulid, storeRecordStrings, records;
            var e_6, _e;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        collection = this.getCollectionIndex(storeName);
                        _a = pagination || {}, _b = _a.page, page = _b === void 0 ? 0 : _b, _c = _a.limit, limit = _c === void 0 ? 0 : _c;
                        start = Math.max(0, page * limit) || 0;
                        end = limit > 0 ? start + limit : undefined;
                        keysForStore = [];
                        count = 0;
                        try {
                            for(collection_3 = (0, _tslib.__values)(collection), collection_3_1 = collection_3.next(); !collection_3_1.done; collection_3_1 = collection_3.next()){
                                _d = (0, _tslib.__read)(collection_3_1.value, 2), id = _d[0], ulid = _d[1];
                                count++;
                                if (count <= start) continue;
                                keysForStore.push(this.getKeyForItem(storeName, id, ulid));
                                if (count === end) break;
                            }
                        } catch (e_6_1) {
                            e_6 = {
                                error: e_6_1
                            };
                        } finally{
                            try {
                                if (collection_3_1 && !collection_3_1.done && (_e = collection_3.return)) _e.call(collection_3);
                            } finally{
                                if (e_6) throw e_6.error;
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.storage.multiGet(keysForStore)
                        ];
                    case 1:
                        storeRecordStrings = _f.sent();
                        records = storeRecordStrings.filter(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return value;
                        }).map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), value = _b[1];
                            return JSON.parse(value);
                        });
                        return [
                            2 /*return*/ ,
                            records
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.delete = function(key, storeName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ulid, itemKey;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ulid = this.getCollectionIndex(storeName).get(key);
                        itemKey = this.getKeyForItem(storeName, key, ulid);
                        this.getCollectionIndex(storeName).delete(key);
                        return [
                            4 /*yield*/ ,
                            this.storage.removeItem(itemKey)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Clear the AsyncStorage of all DataStore entries
     */ AsyncStorageDatabase.prototype.clear = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var allKeys, allDataStoreKeys;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.getAllKeys()
                        ];
                    case 1:
                        allKeys = _a.sent();
                        allDataStoreKeys = allKeys.filter(function(key) {
                            return key.startsWith(DB_NAME);
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.multiRemove(allDataStoreKeys)
                        ];
                    case 2:
                        _a.sent();
                        this._collectionInMemoryIndex.clear();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AsyncStorageDatabase.prototype.getKeyForItem = function(storeName, id, ulid) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + ulid + "::" + id;
    };
    AsyncStorageDatabase.prototype.getLegacyKeyForItem = function(storeName, id) {
        return this.getKeyPrefixForStoreItems(storeName) + "::" + id;
    };
    AsyncStorageDatabase.prototype.getKeyPrefixForStoreItems = function(storeName) {
        return DB_NAME + "::" + storeName + "::" + DATA;
    };
    return AsyncStorageDatabase;
}();
exports.default = AsyncStorageDatabase;

},{"tslib":"86BcK","../../types":"9W0ar","../../util":"iFXfl","./InMemoryStore":"kjZTe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kjZTe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryStore", ()=>InMemoryStore);
parcelHelpers.export(exports, "createInMemoryStore", ()=>createInMemoryStore);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var InMemoryStore = /** @class */ function() {
    function InMemoryStore() {
        var _this = this;
        this.db = new Map();
        this.getAllKeys = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        Array.from(this.db.keys())
                    ];
                });
            });
        };
        this.multiGet = function(keys) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        keys.reduce(function(res, k) {
                            return res.push([
                                k,
                                _this.db.get(k)
                            ]), res;
                        }, [])
                    ];
                });
            });
        };
        this.multiRemove = function(keys, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    keys.forEach(function(k) {
                        return _this.db.delete(k);
                    });
                    typeof callback === "function" && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.multiSet = function(entries, callback) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    entries.forEach(function(_a) {
                        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
                        _this.setItem(key, value);
                    });
                    typeof callback === "function" && callback();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        this.setItem = function(key, value) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.set(key, value)
                    ];
                });
            });
        };
        this.removeItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.delete(key)
                    ];
                });
            });
        };
        this.getItem = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.db.get(key)
                    ];
                });
            });
        };
    }
    return InMemoryStore;
}();
function createInMemoryStore() {
    return new InMemoryStore();
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4SDgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlMessage", ()=>ControlMessage);
parcelHelpers.export(exports, "SyncEngine", ()=>SyncEngine);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _datastoreConnectivity = require("./datastoreConnectivity");
var _datastoreConnectivityDefault = parcelHelpers.interopDefault(_datastoreConnectivity);
var _merger = require("./merger");
var _outbox = require("./outbox");
var _mutation = require("./processors/mutation");
var _subscription = require("./processors/subscription");
var _sync = require("./processors/sync");
var _utils = require("./utils");
var isNode = (0, _core.browserOrNode)().isNode;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var ownSymbol = Symbol("sync");
var ControlMessage;
(function(ControlMessage) {
    ControlMessage["SYNC_ENGINE_STORAGE_SUBSCRIBED"] = "storageSubscribed";
    ControlMessage["SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED"] = "subscriptionsEstablished";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_STARTED"] = "syncQueriesStarted";
    ControlMessage["SYNC_ENGINE_SYNC_QUERIES_READY"] = "syncQueriesReady";
    ControlMessage["SYNC_ENGINE_MODEL_SYNCED"] = "modelSynced";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED"] = "outboxMutationEnqueued";
    ControlMessage["SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED"] = "outboxMutationProcessed";
    ControlMessage["SYNC_ENGINE_OUTBOX_STATUS"] = "outboxStatus";
    ControlMessage["SYNC_ENGINE_NETWORK_STATUS"] = "networkStatus";
    ControlMessage["SYNC_ENGINE_READY"] = "ready";
})(ControlMessage || (ControlMessage = {}));
var SyncEngine = /** @class */ function() {
    function SyncEngine(schema, namespaceResolver, modelClasses, userModelClasses, storage, modelInstanceCreator, conflictHandler, errorHandler, syncPredicates, amplifyConfig, authModeStrategy, amplifyContext, connectivityMonitor) {
        var _this = this;
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.modelClasses = modelClasses;
        this.userModelClasses = userModelClasses;
        this.storage = storage;
        this.modelInstanceCreator = modelInstanceCreator;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.amplifyContext = amplifyContext;
        this.connectivityMonitor = connectivityMonitor;
        this.online = false;
        this.modelSyncedStatus = new WeakMap();
        this.connectionDisrupted = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.waitForSleepState = new Promise(function(resolve) {
            _this.syncQueriesObservableStartSleeping = resolve;
        });
        var MutationEvent = this.modelClasses["MutationEvent"];
        this.outbox = new (0, _outbox.MutationEventOutbox)(this.schema, MutationEvent, modelInstanceCreator, ownSymbol);
        this.modelMerger = new (0, _merger.ModelMerger)(this.outbox, ownSymbol);
        this.syncQueriesProcessor = new (0, _sync.SyncProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.subscriptionsProcessor = new (0, _subscription.SubscriptionProcessor)(this.schema, this.syncPredicates, this.amplifyConfig, this.authModeStrategy, errorHandler, this.amplifyContext);
        this.mutationsProcessor = new (0, _mutation.MutationProcessor)(this.schema, this.storage, this.userModelClasses, this.outbox, this.modelInstanceCreator, MutationEvent, this.amplifyConfig, this.authModeStrategy, errorHandler, conflictHandler, this.amplifyContext);
        this.datastoreConnectivity = this.connectivityMonitor || new (0, _datastoreConnectivityDefault.default)();
    }
    SyncEngine.prototype.getModelSyncedStatus = function(modelConstructor) {
        return this.modelSyncedStatus.get(modelConstructor);
    };
    SyncEngine.prototype.start = function(params) {
        var _this = this;
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            logger.log("starting sync engine...");
            var subscriptions = [];
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1, startPromise, hasMutationsInOutbox;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.setupModels(params)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                observer.error(err_1);
                                return [
                                    2 /*return*/ 
                                ];
                            case 3:
                                startPromise = new Promise(function(doneStarting, failedStarting) {
                                    _this.datastoreConnectivity.status().subscribe(function(_a) {
                                        var online = _a.online;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var ctlSubsObservable_1, dataSubsObservable, err_2, error_1;
                                                            var _a;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_b) {
                                                                switch(_b.label){
                                                                    case 0:
                                                                        if (!(online && !this.online)) return [
                                                                            3 /*break*/ ,
                                                                            10
                                                                        ];
                                                                        this.online = online;
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                            data: {
                                                                                active: this.online
                                                                            }
                                                                        });
                                                                        dataSubsObservable = void 0;
                                                                        if (!isNode) return [
                                                                            3 /*break*/ ,
                                                                            1
                                                                        ];
                                                                        logger.warn("Realtime disabled when in a server-side environment");
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            6
                                                                        ];
                                                                    case 1:
                                                                        this.stopDisruptionListener = this.startDisruptionListener();
                                                                        //#region GraphQL Subscriptions
                                                                        _a = (0, _tslib.__read)(this.subscriptionsProcessor.start(), 2), ctlSubsObservable_1 = _a[0], dataSubsObservable = _a[1];
                                                                        _b.label = 2;
                                                                    case 2:
                                                                        _b.trys.push([
                                                                            2,
                                                                            4,
                                                                            ,
                                                                            5
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                onTerminate.then(reject);
                                                                                var ctlSubsSubscription = ctlSubsObservable_1.subscribe({
                                                                                    next: function(msg) {
                                                                                        if (msg === (0, _subscription.CONTROL_MSG).CONNECTED) resolve();
                                                                                    },
                                                                                    error: function(err) {
                                                                                        reject(err);
                                                                                        var handleDisconnect = _this.disconnectionHandler();
                                                                                        handleDisconnect(err);
                                                                                    }
                                                                                });
                                                                                subscriptions.push(ctlSubsSubscription);
                                                                            })
                                                                        ];
                                                                    case 3:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            5
                                                                        ];
                                                                    case 4:
                                                                        err_2 = _b.sent();
                                                                        observer.error(err_2);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 5:
                                                                        logger.log("Realtime ready");
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_SUBSCRIPTIONS_ESTABLISHED
                                                                        });
                                                                        _b.label = 6;
                                                                    case 6:
                                                                        _b.trys.push([
                                                                            6,
                                                                            8,
                                                                            ,
                                                                            9
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            new Promise(function(resolve, reject) {
                                                                                var syncQuerySubscription = _this.syncQueriesObservable().subscribe({
                                                                                    next: function(message) {
                                                                                        var type = message.type;
                                                                                        if (type === ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY) resolve();
                                                                                        observer.next(message);
                                                                                    },
                                                                                    complete: function() {
                                                                                        resolve();
                                                                                    },
                                                                                    error: function(error) {
                                                                                        reject(error);
                                                                                    }
                                                                                });
                                                                                if (syncQuerySubscription) subscriptions.push(syncQuerySubscription);
                                                                            })
                                                                        ];
                                                                    case 7:
                                                                        _b.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            9
                                                                        ];
                                                                    case 8:
                                                                        error_1 = _b.sent();
                                                                        observer.error(error_1);
                                                                        failedStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                    case 9:
                                                                        //#endregion
                                                                        //#region process mutations (outbox)
                                                                        subscriptions.push(this.mutationsProcessor.start().subscribe(function(_a) {
                                                                            var modelDefinition = _a.modelDefinition, item = _a.model, hasMore = _a.hasMore;
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_PROCESSED,
                                                                                                    data: {
                                                                                                        model: modelConstructor,
                                                                                                        element: model
                                                                                                    }
                                                                                                });
                                                                                                observer.next({
                                                                                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                                                    data: {
                                                                                                        isEmpty: !hasMore
                                                                                                    }
                                                                                                });
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, "mutation processor event");
                                                                        }));
                                                                        //#endregion
                                                                        //#region Merge subscriptions buffer
                                                                        // TODO: extract to function
                                                                        if (!isNode) subscriptions.push(dataSubsObservable.subscribe(function(_a) {
                                                                            var _b = (0, _tslib.__read)(_a, 3), _transformerMutationType = _b[0], modelDefinition = _b[1], item = _b[2];
                                                                            return _this.runningProcesses.add(function() {
                                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                    var modelConstructor, model;
                                                                                    var _this = this;
                                                                                    return (0, _tslib.__generator)(this, function(_a) {
                                                                                        switch(_a.label){
                                                                                            case 0:
                                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                                model = this.modelInstanceCreator(modelConstructor, item);
                                                                                                return [
                                                                                                    4 /*yield*/ ,
                                                                                                    this.storage.runExclusive(function(storage) {
                                                                                                        return _this.modelMerger.merge(storage, model, modelDefinition);
                                                                                                    })
                                                                                                ];
                                                                                            case 1:
                                                                                                _a.sent();
                                                                                                return [
                                                                                                    2 /*return*/ 
                                                                                                ];
                                                                                        }
                                                                                    });
                                                                                });
                                                                            }, "subscription dataSubsObservable event");
                                                                        }));
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            11
                                                                        ];
                                                                    case 10:
                                                                        if (!online) {
                                                                            this.online = online;
                                                                            observer.next({
                                                                                type: ControlMessage.SYNC_ENGINE_NETWORK_STATUS,
                                                                                data: {
                                                                                    active: this.online
                                                                                }
                                                                            });
                                                                            subscriptions.forEach(function(sub) {
                                                                                return sub.unsubscribe();
                                                                            });
                                                                            subscriptions = [];
                                                                        }
                                                                        _b.label = 11;
                                                                    case 11:
                                                                        doneStarting();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, "datastore connectivity event")
                                                ];
                                            });
                                        });
                                    });
                                });
                                this.storage.observe(null, null, ownSymbol).filter(function(_a) {
                                    var model = _a.model;
                                    var modelDefinition = _this.getModelDefinition(model);
                                    return modelDefinition.syncable === true;
                                }).subscribe({
                                    next: function(_a) {
                                        var opType = _a.opType, model = _a.model, element = _a.element, condition = _a.condition;
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var _this = this;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                return [
                                                    2 /*return*/ ,
                                                    this.runningProcesses.add(function() {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var namespace, MutationEventConstructor, modelDefinition, graphQLCondition, mutationEvent;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        namespace = this.schema.namespaces[this.namespaceResolver(model)];
                                                                        MutationEventConstructor = this.modelClasses["MutationEvent"];
                                                                        modelDefinition = this.getModelDefinition(model);
                                                                        graphQLCondition = (0, _utils.predicateToGraphQLCondition)(condition, modelDefinition);
                                                                        mutationEvent = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, this.getModelDefinition(model), opType, model, element, graphQLCondition, MutationEventConstructor, this.modelInstanceCreator);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.outbox.enqueue(this.storage, mutationEvent)
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_MUTATION_ENQUEUED,
                                                                            data: {
                                                                                model: model,
                                                                                element: element
                                                                            }
                                                                        });
                                                                        observer.next({
                                                                            type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                                                            data: {
                                                                                isEmpty: false
                                                                            }
                                                                        });
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            startPromise
                                                                        ];
                                                                    case 2:
                                                                        _a.sent();
                                                                        // Set by the this.datastoreConnectivity.status().subscribe() loop
                                                                        if (this.online) this.mutationsProcessor.resume();
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }, "storage event")
                                                ];
                                            });
                                        });
                                    }
                                });
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_STORAGE_SUBSCRIBED
                                });
                                return [
                                    4 /*yield*/ ,
                                    this.outbox.peek(this.storage)
                                ];
                            case 4:
                                hasMutationsInOutbox = _a.sent() === undefined;
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_OUTBOX_STATUS,
                                    data: {
                                        isEmpty: hasMutationsInOutbox
                                    }
                                });
                                return [
                                    4 /*yield*/ ,
                                    startPromise
                                ];
                            case 5:
                                _a.sent();
                                observer.next({
                                    type: ControlMessage.SYNC_ENGINE_READY
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "sync start");
        });
    };
    SyncEngine.prototype.getModelsMetadataWithNextFullSync = function(currentTimeStamp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var modelLastSync, _a;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = Map.bind;
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.add(function() {
                                return _this.getModelsMetadata();
                            }, "sync/index getModelsMetadataWithNextFullSync")
                        ];
                    case 1:
                        modelLastSync = new (_a.apply(Map, [
                            void 0,
                            _b.sent().map(function(_a) {
                                var namespace = _a.namespace, model = _a.model, lastSync = _a.lastSync, lastFullSync = _a.lastFullSync, fullSyncInterval = _a.fullSyncInterval, lastSyncPredicate = _a.lastSyncPredicate;
                                var nextFullSync = lastFullSync + fullSyncInterval;
                                var syncFrom = !lastFullSync || nextFullSync < currentTimeStamp ? 0 // perform full sync if expired
                                 : lastSync; // perform delta sync
                                return [
                                    _this.schema.namespaces[namespace].models[model],
                                    [
                                        namespace,
                                        syncFrom
                                    ]
                                ];
                            })
                        ]))();
                        return [
                            2 /*return*/ ,
                            modelLastSync
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.syncQueriesObservable = function() {
        var _this = this;
        if (!this.online) return (0, _zenObservableTsDefault.default).of();
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            var syncQueriesSubscription;
            _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var terminated, _loop_1, this_1;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                terminated = false;
                                _loop_1 = function() {
                                    var count, modelLastSync, paginatingModels, lastFullSyncStartedAt, syncInterval, start, syncDuration, lastStartedAt, msNextFullSync;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                count = new WeakMap();
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.getModelsMetadataWithNextFullSync(Date.now())
                                                ];
                                            case 1:
                                                modelLastSync = _a.sent();
                                                paginatingModels = new Set(modelLastSync.keys());
                                                return [
                                                    4 /*yield*/ ,
                                                    new Promise(function(resolve, reject) {
                                                        if (!_this.runningProcesses.isOpen) resolve();
                                                        onTerminate.then(function() {
                                                            return resolve();
                                                        });
                                                        syncQueriesSubscription = _this.syncQueriesProcessor.start(modelLastSync).subscribe({
                                                            next: function(_a) {
                                                                var namespace = _a.namespace, modelDefinition = _a.modelDefinition, items = _a.items, done = _a.done, startedAt = _a.startedAt, isFullSync = _a.isFullSync;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var modelConstructor, modelName, modelMetadata_1, lastFullSync, fullSyncInterval, counts;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                modelConstructor = this.userModelClasses[modelDefinition.name];
                                                                                if (!count.has(modelConstructor)) {
                                                                                    count.set(modelConstructor, {
                                                                                        new: 0,
                                                                                        updated: 0,
                                                                                        deleted: 0
                                                                                    });
                                                                                    start = (0, _util.getNow)();
                                                                                    lastStartedAt = lastStartedAt === undefined ? startedAt : Math.max(lastStartedAt, startedAt);
                                                                                }
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.runExclusive(function(storage) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var idsInOutbox, oneByOne, page, opTypeCount, oneByOne_1, oneByOne_1_1, item, opType, e_1_1, _a, _b, _c, counts;
                                                                                            var e_1, _d;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.outbox.getModelIds(storage)
                                                                                                        ];
                                                                                                    case 1:
                                                                                                        idsInOutbox = _e.sent();
                                                                                                        oneByOne = [];
                                                                                                        page = items.filter(function(item) {
                                                                                                            var itemId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                                                                                            if (!idsInOutbox.has(itemId)) return true;
                                                                                                            oneByOne.push(item);
                                                                                                            return false;
                                                                                                        });
                                                                                                        opTypeCount = [];
                                                                                                        _e.label = 2;
                                                                                                    case 2:
                                                                                                        _e.trys.push([
                                                                                                            2,
                                                                                                            7,
                                                                                                            8,
                                                                                                            9
                                                                                                        ]);
                                                                                                        oneByOne_1 = (0, _tslib.__values)(oneByOne), oneByOne_1_1 = oneByOne_1.next();
                                                                                                        _e.label = 3;
                                                                                                    case 3:
                                                                                                        if (!!oneByOne_1_1.done) return [
                                                                                                            3 /*break*/ ,
                                                                                                            6
                                                                                                        ];
                                                                                                        item = oneByOne_1_1.value;
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.merge(storage, item, modelDefinition)
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        opType = _e.sent();
                                                                                                        if (opType !== undefined) opTypeCount.push([
                                                                                                            item,
                                                                                                            opType
                                                                                                        ]);
                                                                                                        _e.label = 5;
                                                                                                    case 5:
                                                                                                        oneByOne_1_1 = oneByOne_1.next();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            3
                                                                                                        ];
                                                                                                    case 6:
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 7:
                                                                                                        e_1_1 = _e.sent();
                                                                                                        e_1 = {
                                                                                                            error: e_1_1
                                                                                                        };
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            9
                                                                                                        ];
                                                                                                    case 8:
                                                                                                        try {
                                                                                                            if (oneByOne_1_1 && !oneByOne_1_1.done && (_d = oneByOne_1.return)) _d.call(oneByOne_1);
                                                                                                        } finally{
                                                                                                            if (e_1) throw e_1.error;
                                                                                                        }
                                                                                                        return [
                                                                                                            7 /*endfinally*/ 
                                                                                                        ];
                                                                                                    case 9:
                                                                                                        _b = (_a = opTypeCount.push).apply;
                                                                                                        _c = [
                                                                                                            opTypeCount
                                                                                                        ];
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.modelMerger.mergePage(storage, modelConstructor, page, modelDefinition)
                                                                                                        ];
                                                                                                    case 10:
                                                                                                        _b.apply(_a, _c.concat([
                                                                                                            (0, _tslib.__spread).apply(void 0, [
                                                                                                                _e.sent()
                                                                                                            ])
                                                                                                        ]));
                                                                                                        counts = count.get(modelConstructor);
                                                                                                        opTypeCount.forEach(function(_a) {
                                                                                                            var _b = (0, _tslib.__read)(_a, 2), opType = _b[1];
                                                                                                            switch(opType){
                                                                                                                case (0, _types.OpType).INSERT:
                                                                                                                    counts.new++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).UPDATE:
                                                                                                                    counts.updated++;
                                                                                                                    break;
                                                                                                                case (0, _types.OpType).DELETE:
                                                                                                                    counts.deleted++;
                                                                                                                    break;
                                                                                                                default:
                                                                                                                    throw new Error("Invalid opType " + opType);
                                                                                                            }
                                                                                                        });
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    })
                                                                                ];
                                                                            case 1:
                                                                                /**
                                                                                 * If there are mutations in the outbox for a given id, those need to be
                                                                                 * merged individually. Otherwise, we can merge them in batches.
                                                                                 */ _b.sent();
                                                                                if (!done) return [
                                                                                    3 /*break*/ ,
                                                                                    4
                                                                                ];
                                                                                modelName = modelDefinition.name;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.getModelMetadata(namespace, modelName)
                                                                                ];
                                                                            case 2:
                                                                                modelMetadata_1 = _b.sent();
                                                                                lastFullSync = modelMetadata_1.lastFullSync, fullSyncInterval = modelMetadata_1.fullSyncInterval;
                                                                                syncInterval = fullSyncInterval;
                                                                                lastFullSyncStartedAt = lastFullSyncStartedAt === undefined ? lastFullSync : Math.max(lastFullSyncStartedAt, isFullSync ? startedAt : lastFullSync);
                                                                                modelMetadata_1 = this.modelClasses.ModelMetadata.copyOf(modelMetadata_1, function(draft) {
                                                                                    draft.lastSync = startedAt;
                                                                                    draft.lastFullSync = isFullSync ? startedAt : modelMetadata_1.lastFullSync;
                                                                                });
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    this.storage.save(modelMetadata_1, undefined, ownSymbol)
                                                                                ];
                                                                            case 3:
                                                                                _b.sent();
                                                                                counts = count.get(modelConstructor);
                                                                                this.modelSyncedStatus.set(modelConstructor, true);
                                                                                observer.next({
                                                                                    type: ControlMessage.SYNC_ENGINE_MODEL_SYNCED,
                                                                                    data: {
                                                                                        model: modelConstructor,
                                                                                        isFullSync: isFullSync,
                                                                                        isDeltaSync: !isFullSync,
                                                                                        counts: counts
                                                                                    }
                                                                                });
                                                                                paginatingModels.delete(modelDefinition);
                                                                                if (paginatingModels.size === 0) {
                                                                                    syncDuration = (0, _util.getNow)() - start;
                                                                                    resolve();
                                                                                    observer.next({
                                                                                        type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_READY
                                                                                    });
                                                                                    syncQueriesSubscription.unsubscribe();
                                                                                }
                                                                                _b.label = 4;
                                                                            case 4:
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            },
                                                            error: function(error) {
                                                                observer.error(error);
                                                            }
                                                        });
                                                        observer.next({
                                                            type: ControlMessage.SYNC_ENGINE_SYNC_QUERIES_STARTED,
                                                            data: {
                                                                models: Array.from(paginatingModels).map(function(_a) {
                                                                    var name = _a.name;
                                                                    return name;
                                                                })
                                                            }
                                                        });
                                                    })
                                                ];
                                            case 2:
                                                _a.sent();
                                                if (!lastFullSyncStartedAt) msNextFullSync = syncInterval - syncDuration;
                                                else msNextFullSync = lastFullSyncStartedAt + syncInterval - (lastStartedAt + syncDuration);
                                                logger.debug("Next fullSync in " + msNextFullSync / 1000 + " seconds. (" + new Date(Date.now() + msNextFullSync) + ")");
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                return [
                                                    4 /*yield*/ ,
                                                    this_1.runningProcesses.add(function(onTerminate) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var sleepTimer, unsleep, sleep;
                                                            var _this = this;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                sleep = new Promise(function(_unsleep) {
                                                                    unsleep = _unsleep;
                                                                    sleepTimer = setTimeout(unsleep, msNextFullSync);
                                                                });
                                                                onTerminate.then(function() {
                                                                    terminated = true;
                                                                    _this.syncQueriesObservableStartSleeping();
                                                                    unsleep();
                                                                });
                                                                this.unsleepSyncQueriesObservable = unsleep;
                                                                this.syncQueriesObservableStartSleeping();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    sleep
                                                                ];
                                                            });
                                                        });
                                                    }, "syncQueriesObservable sleep")
                                                ];
                                            case 3:
                                                // TODO: create `BackgroundProcessManager.sleep()` ... but, need to put
                                                // a lot of thought into what that contract looks like to
                                                //  support possible use-cases:
                                                //
                                                //  1. non-cancelable
                                                //  2. cancelable, unsleep on exit()
                                                //  3. cancelable, throw Error on exit()
                                                //  4. cancelable, callback first on exit()?
                                                //  5. ... etc. ? ...
                                                //
                                                // TLDR; this is a lot of complexity here for a sleep(),
                                                // but, it's not clear to me yet how to support an
                                                // extensible, centralized cancelable `sleep()` elegantly.
                                                _a.sent();
                                                this_1.unsleepSyncQueriesObservable = null;
                                                this_1.waitForSleepState = new Promise(function(resolve) {
                                                    _this.syncQueriesObservableStartSleeping = resolve;
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                };
                                this_1 = this;
                                _a.label = 1;
                            case 1:
                                if (!(!observer.closed && !terminated)) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                return [
                                    5 /*yield**/ ,
                                    _loop_1()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "syncQueriesObservable main");
        });
    };
    SyncEngine.prototype.disconnectionHandler = function() {
        var _this = this;
        return function(msg) {
            // This implementation is tied to AWSAppSyncRealTimeProvider 'Connection closed', 'Timeout disconnect' msg
            if ((0, _pubsub.CONTROL_MSG).CONNECTION_CLOSED === msg || (0, _pubsub.CONTROL_MSG).TIMEOUT_DISCONNECT === msg) _this.datastoreConnectivity.socketDisconnected();
        };
    };
    SyncEngine.prototype.unsubscribeConnectivity = function() {
        this.datastoreConnectivity.unsubscribe();
    };
    /**
     * Stops all subscription activities and resolves when all activies report
     * that they're disconnected, done retrying, etc..
     */ SyncEngine.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("stopping sync engine");
                        /**
                         * Gracefully disconnecting subscribers first just prevents *more* work
                         * from entering the pipelines.
                         */ this.unsubscribeConnectivity();
                        /**
                         * Stop listening for websocket connection disruption
                         */ this.stopDisruptionListener && this.stopDisruptionListener();
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ return [
                            4 /*yield*/ ,
                            this.mutationsProcessor.stop()
                        ];
                    case 1:
                        /**
                         * aggressively shut down any lingering background processes.
                         * some of this might be semi-redundant with unsubscribing. however,
                         * unsubscribing doesn't allow us to wait for settling.
                         * (Whereas `stop()` does.)
                         */ _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.subscriptionsProcessor.stop()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.datastoreConnectivity.stop()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.syncQueriesProcessor.stop()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 5:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 6:
                        _a.sent();
                        logger.debug("sync engine stopped and ready to restart");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.setupModels = function(params) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var fullSyncInterval, ModelMetadataConstructor, models, savedModel, promises, result, _a, _b, modelMetadata, modelName, e_2_1;
            var e_2, _c;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        fullSyncInterval = params.fullSyncInterval;
                        ModelMetadataConstructor = this.modelClasses.ModelMetadata;
                        models = [];
                        Object.values(this.schema.namespaces).forEach(function(namespace) {
                            Object.values(namespace.models).filter(function(_a) {
                                var syncable = _a.syncable;
                                return syncable;
                            }).forEach(function(model) {
                                models.push([
                                    namespace.name,
                                    model
                                ]);
                                if (namespace.name === (0, _util.USER)) {
                                    var modelConstructor = _this.userModelClasses[model.name];
                                    _this.modelSyncedStatus.set(modelConstructor, false);
                                }
                            });
                        });
                        promises = models.map(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 2), namespace = _b[0], model = _b[1];
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var modelMetadata, syncPredicate, lastSyncPredicate, prevSyncPredicate, syncPredicateUpdated_1;
                                var _c, _d, _e, _f;
                                return (0, _tslib.__generator)(this, function(_g) {
                                    switch(_g.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.getModelMetadata(namespace, model.name)
                                            ];
                                        case 1:
                                            modelMetadata = _g.sent();
                                            syncPredicate = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
                                            lastSyncPredicate = syncPredicate ? JSON.stringify(syncPredicate) : null;
                                            if (!(modelMetadata === undefined)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(this.modelInstanceCreator(ModelMetadataConstructor, {
                                                    model: model.name,
                                                    namespace: namespace,
                                                    lastSync: null,
                                                    fullSyncInterval: fullSyncInterval,
                                                    lastFullSync: null,
                                                    lastSyncPredicate: lastSyncPredicate
                                                }), undefined, ownSymbol)
                                            ];
                                        case 2:
                                            _c = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _d = (0, _tslib.__read)(_c[0], 1), savedModel = _d[0];
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 3:
                                            prevSyncPredicate = modelMetadata.lastSyncPredicate ? modelMetadata.lastSyncPredicate : null;
                                            syncPredicateUpdated_1 = prevSyncPredicate !== lastSyncPredicate;
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(ModelMetadataConstructor.copyOf(modelMetadata, function(draft) {
                                                    draft.fullSyncInterval = fullSyncInterval;
                                                    // perform a base sync if the syncPredicate changed in between calls to DataStore.start
                                                    // ensures that the local store contains all the data specified by the syncExpression
                                                    if (syncPredicateUpdated_1) {
                                                        draft.lastSync = null;
                                                        draft.lastFullSync = null;
                                                        draft.lastSyncPredicate = lastSyncPredicate;
                                                    }
                                                }))
                                            ];
                                        case 4:
                                            _e = (0, _tslib.__read).apply(void 0, [
                                                _g.sent(),
                                                1
                                            ]), _f = (0, _tslib.__read)(_e[0], 1), savedModel = _f[0];
                                            _g.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ ,
                                                savedModel
                                            ];
                                    }
                                });
                            });
                        });
                        result = {};
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 2:
                        _a = (0, _tslib.__values).apply(void 0, [
                            _d.sent()
                        ]), _b = _a.next();
                        _d.label = 3;
                    case 3:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        modelMetadata = _b.value;
                        modelName = modelMetadata.model;
                        result[modelName] = modelMetadata;
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelsMetadata = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, modelsMetadata;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata)
                        ];
                    case 1:
                        modelsMetadata = _a.sent();
                        return [
                            2 /*return*/ ,
                            modelsMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelMetadata = function(namespace, model) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var ModelMetadata, predicate, _a, modelMetadata;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(this.schema.namespaces[0, _util.SYNC].models[ModelMetadata.name], {
                            and: [
                                {
                                    namespace: {
                                        eq: namespace
                                    }
                                },
                                {
                                    model: {
                                        eq: model
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata, predicate, {
                                page: 0,
                                limit: 1
                            })
                        ];
                    case 1:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            1
                        ]), modelMetadata = _a[0];
                        return [
                            2 /*return*/ ,
                            modelMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelDefinition = function(modelConstructor) {
        var namespaceName = this.namespaceResolver(modelConstructor);
        var modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
        return modelDefinition;
    };
    SyncEngine.getNamespace = function() {
        var namespace = {
            name: (0, _util.SYNC),
            relationships: {},
            enums: {
                OperationType: {
                    name: "OperationType",
                    values: [
                        "CREATE",
                        "UPDATE",
                        "DELETE"
                    ]
                }
            },
            nonModels: {},
            models: {
                MutationEvent: {
                    name: "MutationEvent",
                    pluralName: "MutationEvents",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        data: {
                            name: "data",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        modelId: {
                            name: "modelId",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        operation: {
                            name: "operation",
                            type: {
                                enum: "Operationtype"
                            },
                            isArray: false,
                            isRequired: true
                        },
                        condition: {
                            name: "condition",
                            type: "String",
                            isArray: false,
                            isRequired: true
                        }
                    }
                },
                ModelMetadata: {
                    name: "ModelMetadata",
                    pluralName: "ModelsMetadata",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        namespace: {
                            name: "namespace",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        lastSync: {
                            name: "lastSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        lastFullSync: {
                            name: "lastFullSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        fullSyncInterval: {
                            name: "fullSyncInterval",
                            type: "Int",
                            isRequired: true,
                            isArray: false
                        },
                        lastSyncPredicate: {
                            name: "lastSyncPredicate",
                            type: "String",
                            isRequired: false,
                            isArray: false
                        }
                    }
                }
            }
        };
        return namespace;
    };
    /**
     * listen for websocket connection disruption
     *
     * May indicate there was a period of time where messages
     * from AppSync were missed. A sync needs to be triggered to
     * retrieve the missed data.
     */ SyncEngine.prototype.startDisruptionListener = function() {
        var _this = this;
        return (0, _core.Hub).listen("api", function(data) {
            if (data.source === "PubSub" && data.payload.event === (0, _pubsub.CONNECTION_STATE_CHANGE)) {
                var connectionState = data.payload.data.connectionState;
                switch(connectionState){
                    // Do not need to listen for ConnectionDisruptedPendingNetwork
                    // Normal network reconnection logic will handle the sync
                    case (0, _pubsub.ConnectionState).ConnectionDisrupted:
                        _this.connectionDisrupted = true;
                        break;
                    case (0, _pubsub.ConnectionState).Connected:
                        if (_this.connectionDisrupted) _this.scheduleSync();
                        _this.connectionDisrupted = false;
                        break;
                }
            }
        });
    };
    /*
     * Schedule a sync to start when syncQueriesObservable enters sleep state
     * Start sync immediately if syncQueriesObservable is already in sleep state
     */ SyncEngine.prototype.scheduleSync = function() {
        var _this = this;
        return this.runningProcesses.isOpen && this.runningProcesses.add(function() {
            return _this.waitForSleepState.then(function() {
                // unsleepSyncQueriesObservable will be set if waitForSleepState has resolved
                _this.unsleepSyncQueriesObservable();
            });
        });
    };
    return SyncEngine;
}();

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub":"bJVAp","zen-observable-ts":"57mma","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","./datastoreConnectivity":"LQTxI","./merger":"bjDLh","./outbox":"awQ3l","./processors/mutation":"hZWX4","./processors/subscription":"j7cif","./processors/sync":"bkNXz","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJVAp":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSub", ()=>(0, _pubSub.PubSub));
parcelHelpers.export(exports, "CONNECTION_STATE_CHANGE", ()=>(0, _constants.CONNECTION_STATE_CHANGE));
parcelHelpers.export(exports, "ConnectionState", ()=>(0, _types.ConnectionState));
parcelHelpers.export(exports, "CONTROL_MSG", ()=>(0, _types.CONTROL_MSG));
parcelHelpers.export(exports, "AWSAppSyncRealTimeProvider", ()=>(0, _providers.AWSAppSyncRealTimeProvider));
parcelHelpers.export(exports, "AWSIoTProvider", ()=>(0, _providers.AWSIoTProvider));
parcelHelpers.export(exports, "AbstractPubSubProvider", ()=>(0, _providers.AbstractPubSubProvider));
parcelHelpers.export(exports, "MqttOverWSProvider", ()=>(0, _providers.MqttOverWSProvider));
parcelHelpers.export(exports, "mqttTopicMatch", ()=>(0, _providers.mqttTopicMatch));
var _pubSub = require("./PubSub");
var _constants = require("./Providers/constants");
var _types = require("./types");
var _providers = require("./Providers");

},{"./PubSub":"gqEBt","./Providers/constants":"dleHk","./types":"fmtdF","./Providers":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gqEBt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PubSubClass", ()=>PubSubClass);
parcelHelpers.export(exports, "PubSub", ()=>PubSub);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _internals = require("./internals");
var PubSubClass = /** @class */ function(_super) {
    (0, _tslib.__extends)(PubSubClass, _super);
    function PubSubClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PubSubClass.prototype.getModuleName = function() {
        return "PubSub";
    };
    PubSubClass.prototype.subscribe = function(topics, options) {
        return _super.prototype.subscribe.call(this, topics, options);
    };
    return PubSubClass;
}((0, _internals.InternalPubSubClass));
var PubSub = new PubSubClass();
(0, _core.Amplify).register(PubSub);

},{"tslib":"cUWSL","@aws-amplify/core":"3rlh1","./internals":"4KMnX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fmtdF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>(0, _pubSub.CONTROL_MSG));
parcelHelpers.export(exports, "ConnectionState", ()=>(0, _pubSub.ConnectionState));
var _pubSub = require("./PubSub");

},{"./PubSub":"dTFhH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"LQTxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _core = require("@aws-amplify/core");
var _datastoreReachability = require("./datastoreReachability");
var logger = new (0, _core.ConsoleLogger)("DataStore");
var RECONNECTING_IN = 5000; // 5s this may be configurable in the future
var DataStoreConnectivity = /** @class */ function() {
    function DataStoreConnectivity() {
        this.connectionStatus = {
            online: false
        };
    }
    DataStoreConnectivity.prototype.status = function() {
        var _this = this;
        if (this.observer) throw new Error("Subscriber already exists");
        return new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            // Will be used to forward socket connection changes, enhancing Reachability
            _this.subscription = (0, _datastoreReachability.ReachabilityMonitor).subscribe(function(_a) {
                var online = _a.online;
                _this.connectionStatus.online = online;
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                observer.next(observerResult);
            });
            return function() {
                clearTimeout(_this.timeout);
                _this.unsubscribe();
            };
        });
    };
    DataStoreConnectivity.prototype.unsubscribe = function() {
        if (this.subscription) {
            clearTimeout(this.timeout);
            this.subscription.unsubscribe();
        }
    };
    // for consistency with other background processors.
    DataStoreConnectivity.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.unsubscribe();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    DataStoreConnectivity.prototype.socketDisconnected = function() {
        var _this = this;
        if (this.observer && typeof this.observer.next === "function") {
            this.observer.next({
                online: false
            }); // Notify network issue from the socket
            this.timeout = setTimeout(function() {
                var observerResult = (0, _tslib.__assign)({}, _this.connectionStatus); // copyOf status
                _this.observer.next(observerResult);
            }, RECONNECTING_IN); // giving time for socket cleanup and network status stabilization
        }
    };
    return DataStoreConnectivity;
}();
exports.default = DataStoreConnectivity;

},{"tslib":"86BcK","zen-observable-ts":"57mma","@aws-amplify/core":"3rlh1","./datastoreReachability":"j6Xwg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j6Xwg":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReachabilityMonitor", ()=>ReachabilityMonitor);
var _core = require("@aws-amplify/core");
var ReachabilityMonitor = new (0, _core.Reachability)().networkMonitor();

},{"@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bjDLh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelMerger", ()=>ModelMerger);
var _tslib = require("tslib");
var _types = require("../types");
var _utils = require("./utils");
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#merger
var ModelMerger = /** @class */ function() {
    function ModelMerger(outbox, ownSymbol) {
        this.outbox = outbox;
        this.ownSymbol = ownSymbol;
    }
    /**
     *
     * @param storage Storage adapter that contains the data.
     * @param model The model from an outbox mutation.
     * @returns The type of operation (INSERT/UPDATE/DELETE)
     */ ModelMerger.prototype.merge = function(storage, model, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, mutationsForModel, isDelete;
            var _a, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.outbox.getForModel(storage, model, modelDefinition)
                        ];
                    case 1:
                        mutationsForModel = _c.sent();
                        isDelete = model._deleted;
                        if (!(mutationsForModel.length === 0)) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!isDelete) return [
                            3 /*break*/ ,
                            3
                        ];
                        result = (0, _types.OpType).DELETE;
                        return [
                            4 /*yield*/ ,
                            storage.delete(model, undefined, this.ownSymbol)
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.save(model, undefined, this.ownSymbol)
                        ];
                    case 4:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _c.sent(),
                            1
                        ]), _b = (0, _tslib.__read)(_a[0], 2), result = _b[1];
                        _c.label = 5;
                    case 5:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    ModelMerger.prototype.mergePage = function(storage, modelConstructor, items, modelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemsMap, items_1, items_1_1, item, modelId, page;
            var e_1, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        itemsMap = new Map();
                        try {
                            for(items_1 = (0, _tslib.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                                item = items_1_1.value;
                                modelId = (0, _utils.getIdentifierValue)(modelDefinition, item);
                                itemsMap.set(modelId, item);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        page = (0, _tslib.__spread)(itemsMap.values());
                        return [
                            4 /*yield*/ ,
                            storage.batchSave(modelConstructor, page, this.ownSymbol)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    return ModelMerger;
}();

},{"tslib":"86BcK","../types":"9W0ar","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"awQ3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationEventOutbox", ()=>MutationEventOutbox);
var _tslib = require("tslib");
var _predicates = require("../predicates");
var _types = require("../types");
var _util = require("../util");
var _utils = require("./utils");
// TODO: Persist deleted ids
// https://github.com/aws-amplify/amplify-js/blob/datastore-docs/packages/datastore/docs/sync-engine.md#outbox
var MutationEventOutbox = /** @class */ function() {
    function MutationEventOutbox(schema, MutationEvent, modelInstanceCreator, ownSymbol) {
        this.schema = schema;
        this.MutationEvent = MutationEvent;
        this.modelInstanceCreator = modelInstanceCreator;
        this.ownSymbol = ownSymbol;
    }
    MutationEventOutbox.prototype.enqueue = function(storage, mutationEvent) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.runExclusive(function(s) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var mutationEventModelDefinition, predicate, _a, first, incomingMutationType, merged_1, incomingConditionJSON, incomingCondition, merged;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models["MutationEvent"];
                                                predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                                    and: [
                                                        {
                                                            modelId: {
                                                                eq: mutationEvent.modelId
                                                            }
                                                        },
                                                        {
                                                            id: {
                                                                ne: this.inProgressMutationEventId
                                                            }
                                                        }
                                                    ]
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    s.query(this.MutationEvent, predicate)
                                                ];
                                            case 1:
                                                _a = (0, _tslib.__read).apply(void 0, [
                                                    _b.sent(),
                                                    1
                                                ]), first = _a[0];
                                                if (!(first === undefined)) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(mutationEvent, undefined, this.ownSymbol)
                                                ];
                                            case 2:
                                                _b.sent();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                incomingMutationType = mutationEvent.operation;
                                                if (!(first.operation === (0, _utils.TransformerMutationType).CREATE)) return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                                if (!(incomingMutationType === (0, _utils.TransformerMutationType).DELETE)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 4:
                                                _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    7
                                                ];
                                            case 5:
                                                merged_1 = this.mergeUserFields(first, mutationEvent);
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(this.MutationEvent.copyOf(first, function(draft) {
                                                        draft.data = merged_1.data;
                                                    }), undefined, this.ownSymbol)
                                                ];
                                            case 6:
                                                _b.sent();
                                                _b.label = 7;
                                            case 7:
                                                return [
                                                    3 /*break*/ ,
                                                    12
                                                ];
                                            case 8:
                                                incomingConditionJSON = mutationEvent.condition;
                                                incomingCondition = JSON.parse(incomingConditionJSON);
                                                merged = void 0;
                                                if (!(Object.keys(incomingCondition).length === 0)) return [
                                                    3 /*break*/ ,
                                                    10
                                                ];
                                                merged = this.mergeUserFields(first, mutationEvent);
                                                // delete all for model
                                                return [
                                                    4 /*yield*/ ,
                                                    s.delete(this.MutationEvent, predicate)
                                                ];
                                            case 9:
                                                // delete all for model
                                                _b.sent();
                                                _b.label = 10;
                                            case 10:
                                                merged = merged || mutationEvent;
                                                // Enqueue new one
                                                return [
                                                    4 /*yield*/ ,
                                                    s.save(merged, undefined, this.ownSymbol)
                                                ];
                                            case 11:
                                                // Enqueue new one
                                                _b.sent();
                                                _b.label = 12;
                                            case 12:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.dequeue = function(storage, record, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.peek(storage)
                        ];
                    case 1:
                        head = _a.sent();
                        if (!record) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.syncOutboxVersionsOnDequeue(storage, record, head, recordOp)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            4 /*yield*/ ,
                            storage.delete(head)
                        ];
                    case 4:
                        _a.sent();
                        this.inProgressMutationEventId = undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    /**
     * Doing a peek() implies that the mutation goes "inProgress"
     *
     * @param storage
     */ MutationEventOutbox.prototype.peek = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var head;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.queryOne(this.MutationEvent, (0, _types.QueryOne).FIRST)
                        ];
                    case 1:
                        head = _a.sent();
                        this.inProgressMutationEventId = head ? head.id : undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getForModel = function(storage, model, userModelDefinition) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEventModelDefinition, modelId, mutationEvents;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models.MutationEvent;
                        modelId = (0, _utils.getIdentifierValue)(userModelDefinition, model);
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                                and: {
                                    modelId: {
                                        eq: modelId
                                    }
                                }
                            }))
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        return [
                            2 /*return*/ ,
                            mutationEvents
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getModelIds = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationEvents, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent)
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        result = new Set();
                        mutationEvents.forEach(function(_a) {
                            var modelId = _a.modelId;
                            return result.add(modelId);
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    // applies _version from the AppSync mutation response to other items
    // in the mutation queue with the same id
    // see https://github.com/aws-amplify/amplify-js/pull/7354 for more details
    MutationEventOutbox.prototype.syncOutboxVersionsOnDequeue = function(storage, record, head, recordOp) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _version, _lastChangedAt, _deleted, _incomingData, incomingData, data, __version, __lastChangedAt, __deleted, _outgoingData, outgoingData, mutationEventModelDefinition, userModelDefinition, recordId, predicate, outdatedMutations, reconciledMutations;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (head.operation !== recordOp) return [
                            2 /*return*/ 
                        ];
                        _version = record._version, _lastChangedAt = record._lastChangedAt, _deleted = record._deleted, _incomingData = (0, _tslib.__rest)(record, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        incomingData = this.removeTimestampFields(head.model, _incomingData);
                        data = JSON.parse(head.data);
                        if (!data) return [
                            2 /*return*/ 
                        ];
                        __version = data._version, __lastChangedAt = data._lastChangedAt, __deleted = data._deleted, _outgoingData = (0, _tslib.__rest)(data, [
                            "_version",
                            "_lastChangedAt",
                            "_deleted"
                        ]);
                        outgoingData = this.removeTimestampFields(head.model, _outgoingData);
                        // Don't sync the version when the data in the response does not match the data
                        // in the request, i.e., when there's a handled conflict
                        //
                        // NOTE: `incomingData` contains all the fields in the record, and `outgoingData`
                        // only contains updated fields, resulting in an error when doing a comparison
                        // of two equal mutations. Fix this, or mitigate otherwise.
                        if (!(0, _util.valuesEqual)(incomingData, outgoingData, true)) return [
                            2 /*return*/ 
                        ];
                        mutationEventModelDefinition = this.schema.namespaces[0, _util.SYNC].models["MutationEvent"];
                        userModelDefinition = this.schema.namespaces["user"].models[head.model];
                        recordId = (0, _utils.getIdentifierValue)(userModelDefinition, record);
                        predicate = (0, _predicates.ModelPredicateCreator).createFromAST(mutationEventModelDefinition, {
                            and: [
                                {
                                    modelId: {
                                        eq: recordId
                                    }
                                },
                                {
                                    id: {
                                        ne: this.inProgressMutationEventId
                                    }
                                }
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, predicate)
                        ];
                    case 1:
                        outdatedMutations = _a.sent();
                        if (!outdatedMutations.length) return [
                            2 /*return*/ 
                        ];
                        reconciledMutations = outdatedMutations.map(function(m) {
                            var oldData = JSON.parse(m.data);
                            var newData = (0, _tslib.__assign)((0, _tslib.__assign)({}, oldData), {
                                _version: _version,
                                _lastChangedAt: _lastChangedAt
                            });
                            return _this.MutationEvent.copyOf(m, function(draft) {
                                draft.data = JSON.stringify(newData);
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            storage.delete(this.MutationEvent, predicate)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all(reconciledMutations.map(function(m) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    storage.save(m, undefined, this.ownSymbol)
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.mergeUserFields = function(previous, current) {
        var _a = JSON.parse(previous.data), _version = _a._version, _lastChangedAt = _a._lastChangedAt, _deleted = _a._deleted, previousData = (0, _tslib.__rest)(_a, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var _b = JSON.parse(current.data), __version = _b._version, __lastChangedAt = _b._lastChangedAt, __deleted = _b._deleted, currentData = (0, _tslib.__rest)(_b, [
            "_version",
            "_lastChangedAt",
            "_deleted"
        ]);
        var data = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({
            _version: _version,
            _lastChangedAt: _lastChangedAt,
            _deleted: _deleted
        }, previousData), currentData));
        return this.modelInstanceCreator(this.MutationEvent, (0, _tslib.__assign)((0, _tslib.__assign)({}, current), {
            data: data
        }));
    };
    /*
    if a model is using custom timestamp fields
    the custom field names will be stored in the model attributes

    e.g.
    "attributes": [
    {
            "type": "model",
            "properties": {
                "timestamps": {
                    "createdAt": "createdOn",
                    "updatedAt": "updatedOn"
                }
            }
    }
    ]
    */ MutationEventOutbox.prototype.removeTimestampFields = function(model, record) {
        var _a, _b;
        var CREATED_AT_DEFAULT_KEY = "createdAt";
        var UPDATED_AT_DEFAULT_KEY = "updatedAt";
        var createdTimestampKey = CREATED_AT_DEFAULT_KEY;
        var updatedTimestampKey = UPDATED_AT_DEFAULT_KEY;
        var modelAttributes = (_a = this.schema.namespaces[0, _util.USER].models[model].attributes) === null || _a === void 0 ? void 0 : _a.find(function(attr) {
            return attr.type === "model";
        });
        var timestampFieldsMap = (_b = modelAttributes === null || modelAttributes === void 0 ? void 0 : modelAttributes.properties) === null || _b === void 0 ? void 0 : _b.timestamps;
        if (timestampFieldsMap) {
            createdTimestampKey = timestampFieldsMap[CREATED_AT_DEFAULT_KEY];
            updatedTimestampKey = timestampFieldsMap[UPDATED_AT_DEFAULT_KEY];
        }
        delete record[createdTimestampKey];
        delete record[updatedTimestampKey];
        return record;
    };
    return MutationEventOutbox;
}();

},{"tslib":"86BcK","../predicates":"bohgw","../types":"9W0ar","../util":"iFXfl","./utils":"3udIx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hZWX4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJitteredBackoff", ()=>safeJitteredBackoff);
parcelHelpers.export(exports, "MutationProcessor", ()=>MutationProcessor);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _core = require("@aws-amplify/core");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _util = require("../../util");
var _utils = require("../utils");
var _errorMaps = require("./errorMaps");
var MAX_ATTEMPTS = 10;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var MutationProcessor = /** @class */ function() {
    function MutationProcessor(schema, storage, userClasses, outbox, modelInstanceCreator, MutationEvent, amplifyConfig, authModeStrategy, errorHandler, conflictHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.storage = storage;
        this.userClasses = userClasses;
        this.outbox = outbox;
        this.modelInstanceCreator = modelInstanceCreator;
        this.MutationEvent = MutationEvent;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.conflictHandler = conflictHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.processing = false;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        this.amplifyContext.InternalAPI = this.amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    MutationProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "CREATE"), 1), createMutation = _a[0];
                var _b = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "UPDATE"), 1), updateMutation = _b[0];
                var _c = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "DELETE"), 1), deleteMutation = _c[0];
                _this.typeQuery.set(model, [
                    createMutation,
                    updateMutation,
                    deleteMutation
                ]);
            });
        });
    };
    MutationProcessor.prototype.isReady = function() {
        return this.observer !== undefined;
    };
    MutationProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.observer = observer;
            try {
                _this.resume();
            } catch (error) {
                logger.error("mutations processor start error", error);
                throw error;
            }
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        // The observer has unsubscribed and/or `stop()` has been called.
                        this.removeObserver();
                        this.pause();
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return observable;
    };
    MutationProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.removeObserver();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.removeObserver = function() {
        var _a, _b;
        (_b = (_a = this.observer) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
        this.observer = undefined;
    };
    MutationProcessor.prototype.resume = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.isOpen && this.runningProcesses.add(function(onTerminate) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var head, namespaceName, _loop_1, this_1, _a;
                                    var _this = this;
                                    var _b, _c;
                                    return (0, _tslib.__generator)(this, function(_d) {
                                        switch(_d.label){
                                            case 0:
                                                if (this.processing || !this.isReady() || !this.runningProcesses.isOpen) return [
                                                    2 /*return*/ 
                                                ];
                                                this.processing = true;
                                                namespaceName = (0, _util.USER);
                                                _loop_1 = function() {
                                                    var model, operation, data, condition, modelConstructor, result, opName, modelDefinition, modelAuthModes, operationAuthModes_1, authModeAttempts_1, authModeRetry_1, error_1, record, hasMore;
                                                    var _a;
                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                model = head.model, operation = head.operation, data = head.data, condition = head.condition;
                                                                modelConstructor = this_1.userClasses[model];
                                                                result = undefined;
                                                                opName = undefined;
                                                                modelDefinition = undefined;
                                                                _b.label = 1;
                                                            case 1:
                                                                _b.trys.push([
                                                                    1,
                                                                    4,
                                                                    ,
                                                                    5
                                                                ]);
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    (0, _utils.getModelAuthModes)({
                                                                        authModeStrategy: this_1.authModeStrategy,
                                                                        defaultAuthMode: this_1.amplifyConfig.aws_appsync_authenticationType,
                                                                        modelName: model,
                                                                        schema: this_1.schema
                                                                    })
                                                                ];
                                                            case 2:
                                                                modelAuthModes = _b.sent();
                                                                operationAuthModes_1 = modelAuthModes[operation.toUpperCase()];
                                                                authModeAttempts_1 = 0;
                                                                authModeRetry_1 = function() {
                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                        var response, error_2, e_1;
                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                            switch(_a.label){
                                                                                case 0:
                                                                                    _a.trys.push([
                                                                                        0,
                                                                                        2,
                                                                                        ,
                                                                                        9
                                                                                    ]);
                                                                                    logger.debug("Attempting mutation with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.jitteredRetry(namespaceName, model, operation, data, condition, modelConstructor, this.MutationEvent, head, operationAuthModes_1[authModeAttempts_1], onTerminate)
                                                                                    ];
                                                                                case 1:
                                                                                    response = _a.sent();
                                                                                    logger.debug("Mutation sent successfully with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        response
                                                                                    ];
                                                                                case 2:
                                                                                    error_2 = _a.sent();
                                                                                    authModeAttempts_1++;
                                                                                    if (!(authModeAttempts_1 >= operationAuthModes_1.length)) return [
                                                                                        3 /*break*/ ,
                                                                                        7
                                                                                    ];
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1]);
                                                                                    _a.label = 3;
                                                                                case 3:
                                                                                    _a.trys.push([
                                                                                        3,
                                                                                        5,
                                                                                        ,
                                                                                        6
                                                                                    ]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        this.errorHandler({
                                                                                            recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                            localModel: null,
                                                                                            message: error_2.message,
                                                                                            model: modelConstructor.name,
                                                                                            operation: opName,
                                                                                            errorType: (0, _errorMaps.getMutationErrorType)(error_2),
                                                                                            process: (0, _types.ProcessName).sync,
                                                                                            remoteModel: null,
                                                                                            cause: error_2
                                                                                        })
                                                                                    ];
                                                                                case 4:
                                                                                    _a.sent();
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 5:
                                                                                    e_1 = _a.sent();
                                                                                    logger.error("Mutation error handler failed with:", e_1);
                                                                                    return [
                                                                                        3 /*break*/ ,
                                                                                        6
                                                                                    ];
                                                                                case 6:
                                                                                    throw error_2;
                                                                                case 7:
                                                                                    logger.debug("Mutation failed with authMode: " + operationAuthModes_1[authModeAttempts_1 - 1] + ". Retrying with authMode: " + operationAuthModes_1[authModeAttempts_1]);
                                                                                    return [
                                                                                        4 /*yield*/ ,
                                                                                        authModeRetry_1()
                                                                                    ];
                                                                                case 8:
                                                                                    return [
                                                                                        2 /*return*/ ,
                                                                                        _a.sent()
                                                                                    ];
                                                                                case 9:
                                                                                    return [
                                                                                        2 /*return*/ 
                                                                                    ];
                                                                            }
                                                                        });
                                                                    });
                                                                };
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    authModeRetry_1()
                                                                ];
                                                            case 3:
                                                                _a = (0, _tslib.__read).apply(void 0, [
                                                                    _b.sent(),
                                                                    3
                                                                ]), result = _a[0], opName = _a[1], modelDefinition = _a[2];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 4:
                                                                error_1 = _b.sent();
                                                                if (error_1.message === "Offline" || error_1.message === "RetryMutation") return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                                return [
                                                                    3 /*break*/ ,
                                                                    5
                                                                ];
                                                            case 5:
                                                                if (!(result === undefined)) return [
                                                                    3 /*break*/ ,
                                                                    7
                                                                ];
                                                                logger.debug("done retrying");
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage)
                                                                                        ];
                                                                                    case 1:
                                                                                        _a.sent();
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 6:
                                                                _b.sent();
                                                                return [
                                                                    2 /*return*/ ,
                                                                    "continue"
                                                                ];
                                                            case 7:
                                                                record = result.data[opName];
                                                                hasMore = false;
                                                                return [
                                                                    4 /*yield*/ ,
                                                                    this_1.storage.runExclusive(function(storage) {
                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                                switch(_a.label){
                                                                                    case 0:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.dequeue(storage, record, operation)
                                                                                        ];
                                                                                    case 1:
                                                                                        // using runExclusive to prevent possible race condition
                                                                                        // when another record gets enqueued between dequeue and peek
                                                                                        _a.sent();
                                                                                        return [
                                                                                            4 /*yield*/ ,
                                                                                            this.outbox.peek(storage)
                                                                                        ];
                                                                                    case 2:
                                                                                        hasMore = _a.sent() !== undefined;
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                    })
                                                                ];
                                                            case 8:
                                                                _b.sent();
                                                                (_c = (_b = this_1.observer) === null || _b === void 0 ? void 0 : _b.next) === null || _c === void 0 || _c.call(_b, {
                                                                    operation: operation,
                                                                    modelDefinition: modelDefinition,
                                                                    model: record,
                                                                    hasMore: hasMore
                                                                });
                                                                return [
                                                                    2 /*return*/ 
                                                                ];
                                                        }
                                                    });
                                                };
                                                this_1 = this;
                                                _d.label = 1;
                                            case 1:
                                                _a = this.processing && this.runningProcesses.isOpen;
                                                if (!_a) return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    this.outbox.peek(this.storage)
                                                ];
                                            case 2:
                                                _a = (head = _d.sent()) !== undefined;
                                                _d.label = 3;
                                            case 3:
                                                if (!_a) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    5 /*yield**/ ,
                                                    _loop_1()
                                                ];
                                            case 4:
                                                _d.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 5:
                                                // pauses itself
                                                this.pause();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, "mutation resume loop")
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.jitteredRetry = function(namespaceName, model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent, authMode, onTerminate) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.retry)(function(model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var _a, query, variables, graphQLCondition, opName, modelDefinition, authToken, tryWith, attempt, opType, customUserAgentDetails, result, err_1, _b, error, _c, _d, code, retryWith, err_2, _e, _f, opName_1, query_1, authToken_1, serverData, namespace, updatedMutation;
                                    var _g;
                                    return (0, _tslib.__generator)(this, function(_h) {
                                        switch(_h.label){
                                            case 0:
                                                _a = (0, _tslib.__read)(this.createQueryVariables(namespaceName, model, operation, data, condition), 5), query = _a[0], variables = _a[1], graphQLCondition = _a[2], opName = _a[3], modelDefinition = _a[4];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _h.sent();
                                                tryWith = {
                                                    query: query,
                                                    variables: variables,
                                                    authMode: authMode,
                                                    authToken: authToken
                                                };
                                                attempt = 0;
                                                opType = this.opTypeFromTransformerOperation(operation);
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                _h.label = 2;
                                            case 2:
                                                _h.trys.push([
                                                    2,
                                                    4,
                                                    ,
                                                    17
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql(tryWith, undefined, customUserAgentDetails)
                                                ];
                                            case 3:
                                                result = _h.sent();
                                                // Use `as any` because TypeScript doesn't seem to like passing tuples
                                                // through generic params.
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        result,
                                                        opName,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 4:
                                                err_1 = _h.sent();
                                                if (!(err_1.errors && err_1.errors.length > 0)) return [
                                                    3 /*break*/ ,
                                                    15
                                                ];
                                                _b = (0, _tslib.__read)(err_1.errors, 1), error = _b[0];
                                                _c = error.originalError, _d = (_c === void 0 ? {} : _c).code, code = _d === void 0 ? null : _d;
                                                if (error.errorType === "Unauthorized") throw new (0, _core.NonRetryableError)("Unauthorized");
                                                if (error.message === "Network Error" || code === "ECONNABORTED" // refers to axios timeout error caused by device's bad network condition
                                                ) {
                                                    if (!this.processing) throw new (0, _core.NonRetryableError)("Offline");
                                                    // TODO: Check errors on different env (react-native or other browsers)
                                                    throw new Error("Network Error");
                                                }
                                                if (!(error.errorType === "ConflictUnhandled")) return [
                                                    3 /*break*/ ,
                                                    13
                                                ];
                                                // TODO: add on ConflictConditionalCheck error query last from server
                                                attempt++;
                                                retryWith = void 0;
                                                if (!(attempt > MAX_ATTEMPTS)) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                retryWith = (0, _types.DISCARD);
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 5:
                                                _h.trys.push([
                                                    5,
                                                    7,
                                                    ,
                                                    8
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.conflictHandler({
                                                        modelConstructor: modelConstructor,
                                                        localModel: this.modelInstanceCreator(modelConstructor, variables.input),
                                                        remoteModel: this.modelInstanceCreator(modelConstructor, error.data),
                                                        operation: opType,
                                                        attempts: attempt
                                                    })
                                                ];
                                            case 6:
                                                retryWith = _h.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                            case 7:
                                                err_2 = _h.sent();
                                                logger.warn("conflict trycatch", err_2);
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 8:
                                                if (!(retryWith === (0, _types.DISCARD))) return [
                                                    3 /*break*/ ,
                                                    11
                                                ];
                                                _e = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(this.schema.namespaces[namespaceName], modelDefinition, "GET"), 1), _f = (0, _tslib.__read)(_e[0], 3), opName_1 = _f[1], query_1 = _f[2];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 9:
                                                authToken_1 = _h.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query_1,
                                                        variables: {
                                                            id: variables.input.id
                                                        },
                                                        authMode: authMode,
                                                        authToken: authToken_1
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 10:
                                                serverData = _h.sent();
                                                // onTerminate cancel graphql()
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        serverData,
                                                        opName_1,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 11:
                                                namespace = this.schema.namespaces[namespaceName];
                                                updatedMutation = (0, _utils.createMutationInstanceFromModelOperation)(namespace.relationships, modelDefinition, opType, modelConstructor, retryWith, graphQLCondition, MutationEvent, this.modelInstanceCreator, mutationEvent.id);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.storage.save(updatedMutation)
                                                ];
                                            case 12:
                                                _h.sent();
                                                throw new (0, _core.NonRetryableError)("RetryMutation");
                                            case 13:
                                                try {
                                                    this.errorHandler({
                                                        recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                        localModel: variables.input,
                                                        message: error.message,
                                                        operation: operation,
                                                        errorType: (0, _errorMaps.getMutationErrorType)(error),
                                                        errorInfo: error.errorInfo,
                                                        process: (0, _types.ProcessName).mutate,
                                                        cause: error,
                                                        remoteModel: error.data ? this.modelInstanceCreator(modelConstructor, error.data) : null
                                                    });
                                                } catch (err) {
                                                    logger.warn("Mutation error handler failed with:", err);
                                                } finally{
                                                    // Return empty tuple, dequeues the mutation
                                                    return [
                                                        2 /*return*/ ,
                                                        error.data ? [
                                                            {
                                                                data: (_g = {}, _g[opName] = error.data, _g)
                                                            },
                                                            opName,
                                                            modelDefinition
                                                        ] : []
                                                    ];
                                                }
                                                _h.label = 14;
                                            case 14:
                                                return [
                                                    3 /*break*/ ,
                                                    16
                                                ];
                                            case 15:
                                                // Catch-all for client-side errors that don't come back in the `GraphQLError` format.
                                                // These errors should not be retried.
                                                throw new (0, _core.NonRetryableError)(err_1);
                                            case 16:
                                                return [
                                                    3 /*break*/ ,
                                                    17
                                                ];
                                            case 17:
                                                if (tryWith) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                _h.label = 18;
                                            case 18:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                model,
                                operation,
                                data,
                                condition,
                                modelConstructor,
                                MutationEvent,
                                mutationEvent
                            ], safeJitteredBackoff, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.createQueryVariables = function(namespaceName, model, operation, data, condition) {
        var e_2, _a, e_3, _b, e_4, _c;
        var _d, _e;
        var modelDefinition = this.schema.namespaces[namespaceName].models[model];
        var primaryKey = this.schema.namespaces[namespaceName].keys[model].primaryKey;
        var auth = (_d = modelDefinition.attributes) === null || _d === void 0 ? void 0 : _d.find(function(a) {
            return a.type === "auth";
        });
        var ownerFields = ((_e = auth === null || auth === void 0 ? void 0 : auth.properties) === null || _e === void 0 ? void 0 : _e.rules.map(function(rule) {
            return rule.ownerField;
        }).filter(function(f) {
            return f;
        })) || [
            "owner"
        ];
        var queriesTuples = this.typeQuery.get(modelDefinition);
        var _f = (0, _tslib.__read)(queriesTuples.find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), transformerMutationType = _b[0];
            return transformerMutationType === operation;
        }), 3), opName = _f[1], query = _f[2];
        var _g = JSON.parse(data), _version = _g._version, parsedData = (0, _tslib.__rest)(_g, [
            "_version"
        ]);
        // include all the fields that comprise a custom PK if one is specified
        var deleteInput = {};
        if (primaryKey === null || primaryKey === void 0 ? void 0 : primaryKey.length) try {
            for(var primaryKey_1 = (0, _tslib.__values)(primaryKey), primaryKey_1_1 = primaryKey_1.next(); !primaryKey_1_1.done; primaryKey_1_1 = primaryKey_1.next()){
                var pkField = primaryKey_1_1.value;
                deleteInput[pkField] = parsedData[pkField];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (primaryKey_1_1 && !primaryKey_1_1.done && (_a = primaryKey_1.return)) _a.call(primaryKey_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        else deleteInput[0, _util.ID] = parsedData.id;
        var mutationInput;
        if (operation === (0, _utils.TransformerMutationType).DELETE) // For DELETE mutations, only the key(s) are included in the input
        mutationInput = deleteInput;
        else {
            // Otherwise, we construct the mutation input with the following logic
            mutationInput = {};
            var modelFields = Object.values(modelDefinition.fields);
            try {
                for(var modelFields_1 = (0, _tslib.__values)(modelFields), modelFields_1_1 = modelFields_1.next(); !modelFields_1_1.done; modelFields_1_1 = modelFields_1.next()){
                    var _h = modelFields_1_1.value, name_1 = _h.name, type = _h.type, association = _h.association, isReadOnly = _h.isReadOnly;
                    // omit readonly fields. cloud storage doesn't need them and won't take them!
                    if (isReadOnly) continue;
                    // omit owner fields if it's `null`. cloud storage doesn't allow it.
                    if (ownerFields.includes(name_1) && parsedData[name_1] === null) continue;
                    // model fields should be stripped out from the input
                    if ((0, _types.isModelFieldType)(type)) {
                        // except for belongs to relations - we need to replace them with the correct foreign key(s)
                        if ((0, _types.isTargetNameAssociation)(association) && association.connectionType === "BELONGS_TO") {
                            var targetNames = (0, _util.extractTargetNamesFromSrc)(association);
                            if (targetNames) try {
                                // instead of including the connected model itself, we add its key(s) to the mutation input
                                for(var targetNames_1 = (e_4 = void 0, (0, _tslib.__values)(targetNames)), targetNames_1_1 = targetNames_1.next(); !targetNames_1_1.done; targetNames_1_1 = targetNames_1.next()){
                                    var targetName = targetNames_1_1.value;
                                    mutationInput[targetName] = parsedData[targetName];
                                }
                            } catch (e_4_1) {
                                e_4 = {
                                    error: e_4_1
                                };
                            } finally{
                                try {
                                    if (targetNames_1_1 && !targetNames_1_1.done && (_c = targetNames_1.return)) _c.call(targetNames_1);
                                } finally{
                                    if (e_4) throw e_4.error;
                                }
                            }
                        }
                        continue;
                    }
                    // scalar fields / non-model types
                    if (operation === (0, _utils.TransformerMutationType).UPDATE) {
                        if (!parsedData.hasOwnProperty(name_1)) continue;
                    }
                    // all other fields are added to the input object
                    mutationInput[name_1] = parsedData[name_1];
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (modelFields_1_1 && !modelFields_1_1.done && (_b = modelFields_1.return)) _b.call(modelFields_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        }
        // Build mutation variables input object
        var input = (0, _tslib.__assign)((0, _tslib.__assign)({}, mutationInput), {
            _version: _version
        });
        var graphQLCondition = JSON.parse(condition);
        var variables = (0, _tslib.__assign)({
            input: input
        }, operation === (0, _utils.TransformerMutationType).CREATE ? {} : {
            condition: Object.keys(graphQLCondition).length > 0 ? graphQLCondition : null
        });
        return [
            query,
            variables,
            graphQLCondition,
            opName,
            modelDefinition
        ];
    };
    MutationProcessor.prototype.opTypeFromTransformerOperation = function(operation) {
        switch(operation){
            case (0, _utils.TransformerMutationType).CREATE:
                return (0, _types.OpType).INSERT;
            case (0, _utils.TransformerMutationType).DELETE:
                return (0, _types.OpType).DELETE;
            case (0, _utils.TransformerMutationType).UPDATE:
                return (0, _types.OpType).UPDATE;
            case (0, _utils.TransformerMutationType).GET:
                break;
            default:
                throw new Error("Invalid operation " + operation);
        }
        // because it makes TS happy ...
        return undefined;
    };
    MutationProcessor.prototype.pause = function() {
        this.processing = false;
    };
    return MutationProcessor;
}();
var MAX_RETRY_DELAY_MS = 300000;
var originalJitteredBackoff = (0, _core.jitteredBackoff)(MAX_RETRY_DELAY_MS);
var safeJitteredBackoff = function(attempt, _args, error) {
    var attemptResult = originalJitteredBackoff(attempt);
    // If this is the last attempt and it is a network error, we retry indefinitively every 5 minutes
    if (attemptResult === false && (error === null || error === void 0 ? void 0 : error.message) === "Network Error") return MAX_RETRY_DELAY_MS;
    return attemptResult;
};

},{"tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","@aws-amplify/core":"3rlh1","zen-observable-ts":"57mma","../../types":"9W0ar","../../util":"iFXfl","../utils":"3udIx","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k8bnH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mutationErrorMap", ()=>mutationErrorMap);
parcelHelpers.export(exports, "subscriptionErrorMap", ()=>subscriptionErrorMap);
parcelHelpers.export(exports, "syncErrorMap", ()=>syncErrorMap);
parcelHelpers.export(exports, "getMutationErrorType", ()=>getMutationErrorType);
parcelHelpers.export(exports, "getSubscriptionErrorType", ()=>getSubscriptionErrorType);
parcelHelpers.export(exports, "getSyncErrorType", ()=>getSyncErrorType);
/**
 * Categorizes an error with a broad error type, intended to make
 * customer error handling code simpler.
 * @param errorMap Error names and a list of patterns that indicate them (each pattern as a regex or function)
 * @param error The underying error to categorize.
 */ parcelHelpers.export(exports, "mapErrorToType", ()=>mapErrorToType);
var _tslib = require("tslib");
var connectionTimeout = function(error) {
    return /^Connection failed: Connection Timeout/.test(error.message);
};
var serverError = function(error) {
    return /^Error: Request failed with status code 5\d\d/.test(error.message);
};
var mutationErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function(error) {
        var message = error.message;
        return /^Cannot return \w+ for [\w-_]+ type/.test(message) || /^Variable '.+' has coerced Null value for NonNull type/.test(message); // newly required field, out of date client
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(error) {
        return error.message === "Unauthorized" || /^Request failed with status code 401/.test(error.message);
    }
};
var subscriptionErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function() {
        return false;
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(observableError) {
        var error = unwrapObservableError(observableError);
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(observableError) {
        var error = unwrapObservableError(observableError);
        return /Connection failed.+Unauthorized/.test(error.message);
    }
};
var syncErrorMap = {
    BadModel: function() {
        return false;
    },
    BadRecord: function(error) {
        return /^Cannot return \w+ for [\w-_]+ type/.test(error.message);
    },
    ConfigError: function() {
        return false;
    },
    Transient: function(error) {
        return connectionTimeout(error) || serverError(error);
    },
    Unauthorized: function(error) {
        return error.errorType === "Unauthorized";
    }
};
/**
 * Get the first error reason of an observable.
 * Allows for error maps to be easily applied to observable errors
 *
 * @param observableError an error from ZenObservable subscribe error callback
 */ function unwrapObservableError(observableError) {
    var _a = observableError.error, _b = (0, _tslib.__read)((_a === void 0 ? {
        errors: []
    } : _a).errors, 1), error = _b[0];
    return error;
}
function getMutationErrorType(error) {
    return mapErrorToType(mutationErrorMap, error);
}
function getSubscriptionErrorType(error) {
    return mapErrorToType(subscriptionErrorMap, error);
}
function getSyncErrorType(error) {
    return mapErrorToType(syncErrorMap, error);
}
function mapErrorToType(errorMap, error) {
    var e_1, _a;
    var errorTypes = (0, _tslib.__spread)(Object.keys(errorMap));
    try {
        for(var errorTypes_1 = (0, _tslib.__values)(errorTypes), errorTypes_1_1 = errorTypes_1.next(); !errorTypes_1_1.done; errorTypes_1_1 = errorTypes_1.next()){
            var errorType = errorTypes_1_1.value;
            var matcher = errorMap[errorType];
            if (matcher === null || matcher === void 0 ? void 0 : matcher(error)) return errorType;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (errorTypes_1_1 && !errorTypes_1_1.done && (_a = errorTypes_1.return)) _a.call(errorTypes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return "Unknown";
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j7cif":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTROL_MSG", ()=>CONTROL_MSG);
parcelHelpers.export(exports, "USER_CREDENTIALS", ()=>USER_CREDENTIALS);
parcelHelpers.export(exports, "SubscriptionProcessor", ()=>SubscriptionProcessor);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _cache = require("@aws-amplify/cache");
var _core = require("@aws-amplify/core");
var _pubsub = require("@aws-amplify/pubsub");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _predicates = require("../../predicates");
var _util = require("../../util");
var _errorMaps = require("./errorMaps");
var Buffer = require("a5da572164cb8f31").Buffer;
var logger = new (0, _core.ConsoleLogger)("DataStore");
var CONTROL_MSG;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTED"] = "CONNECTED";
})(CONTROL_MSG || (CONTROL_MSG = {}));
var USER_CREDENTIALS;
(function(USER_CREDENTIALS) {
    USER_CREDENTIALS[USER_CREDENTIALS["none"] = 0] = "none";
    USER_CREDENTIALS[USER_CREDENTIALS["unauth"] = 1] = "unauth";
    USER_CREDENTIALS[USER_CREDENTIALS["auth"] = 2] = "auth";
})(USER_CREDENTIALS || (USER_CREDENTIALS = {}));
var SubscriptionProcessor = /** @class */ function() {
    function SubscriptionProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        if (amplifyContext === void 0) amplifyContext = {
            Auth: (0, _auth.Auth),
            InternalAPI: (0, _internals.InternalAPI),
            Cache: (0, _cache.Cache)
        };
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.buffer = [];
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
    }
    SubscriptionProcessor.prototype.buildSubscription = function(namespace, model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload, authMode, filterArg) {
        if (filterArg === void 0) filterArg = false;
        var aws_appsync_authenticationType = this.amplifyConfig.aws_appsync_authenticationType;
        var _a = this.getAuthorizationInfo(model, userCredentials, aws_appsync_authenticationType, cognitoTokenPayload, oidcTokenPayload, authMode) || {}, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue;
        var _b = (0, _tslib.__read)((0, _utils.buildSubscriptionGraphQLOperation)(namespace, model, transformerMutationType, isOwner, ownerField, filterArg), 3), opType = _b[0], opName = _b[1], query = _b[2];
        return {
            authMode: authMode,
            opType: opType,
            opName: opName,
            query: query,
            isOwner: isOwner,
            ownerField: ownerField,
            ownerValue: ownerValue
        };
    };
    SubscriptionProcessor.prototype.getAuthorizationInfo = function(model, userCredentials, defaultAuthType, cognitoTokenPayload, oidcTokenPayload, authMode) {
        if (cognitoTokenPayload === void 0) cognitoTokenPayload = {};
        if (oidcTokenPayload === void 0) oidcTokenPayload = {};
        var rules = (0, _utils.getAuthorizationRules)(model);
        // Return null if user doesn't have proper credentials for private API with IAM auth
        var iamPrivateAuth = authMode === (0, _api.GRAPHQL_AUTH_MODE).AWS_IAM && rules.find(function(rule) {
            return rule.authStrategy === "private" && rule.provider === "iam";
        });
        if (iamPrivateAuth && userCredentials === USER_CREDENTIALS.unauth) return null;
        // Group auth should take precedence over owner auth, so we are checking
        // if rule(s) have group authorization as well as if either the Cognito or
        // OIDC token has a groupClaim. If so, we are returning auth info before
        // any further owner-based auth checks.
        var groupAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "groups" && [
                "userPools",
                "oidc"
            ].includes(rule.provider);
        });
        var validGroup = (authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS || authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT) && groupAuthRules.find(function(groupAuthRule) {
            // validate token against groupClaim
            var cognitoUserGroups = (0, _utils.getUserGroupsFromToken)(cognitoTokenPayload, groupAuthRule);
            var oidcUserGroups = (0, _utils.getUserGroupsFromToken)(oidcTokenPayload, groupAuthRule);
            return (0, _tslib.__spread)(cognitoUserGroups, oidcUserGroups).find(function(userGroup) {
                return groupAuthRule.groups.find(function(group) {
                    return group === userGroup;
                });
            });
        });
        if (validGroup) return {
            authMode: authMode,
            isOwner: false
        };
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the Cognito token via the
        // identityClaim from the auth rule.
        var cognitoOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS ? rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "userPools";
        }) : [];
        var ownerAuthInfo;
        cognitoOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = cognitoTokenPayload[ownerAuthRule.identityClaim];
            // AuthZ for "list of owners" is handled dynamically in the subscription auth request
            // resolver. It doesn't rely on a subscription arg.
            // Only pass a subscription arg for single owner auth
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Owner auth needs additional values to be returned in order to create the subscription with
        // the correct parameters so we are getting the owner value from the OIDC token via the
        // identityClaim from the auth rule.
        var oidcOwnerAuthRules = authMode === (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT ? rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "oidc";
        }) : [];
        oidcOwnerAuthRules.forEach(function(ownerAuthRule) {
            var _a;
            var ownerValue = oidcTokenPayload[ownerAuthRule.identityClaim];
            var singleOwner = ((_a = model.fields[ownerAuthRule.ownerField]) === null || _a === void 0 ? void 0 : _a.isArray) !== true;
            var isOwnerArgRequired = singleOwner && !ownerAuthRule.areSubscriptionsPublic;
            if (ownerValue) ownerAuthInfo = {
                authMode: (0, _api.GRAPHQL_AUTH_MODE).OPENID_CONNECT,
                isOwner: isOwnerArgRequired,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (ownerAuthInfo) return ownerAuthInfo;
        // Fallback: return authMode or default auth type
        return {
            authMode: authMode || defaultAuthType,
            isOwner: false
        };
    };
    SubscriptionProcessor.prototype.hubQueryCompletionListener = function(completed, capsule) {
        var event = capsule.payload.event;
        if (event === (0, _pubsub.CONTROL_MSG).SUBSCRIPTION_ACK) completed();
    };
    SubscriptionProcessor.prototype.start = function() {
        var _this = this;
        this.runningProcesses = this.runningProcesses || new (0, _core.BackgroundProcessManager)();
        var ctlObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var promises = [];
            // Creating subs for each model/operation combo so they can be unsubscribed
            // independently, since the auth retry behavior is asynchronous.
            var subscriptions = {};
            var cognitoTokenPayload, oidcTokenPayload;
            var userCredentials = USER_CREDENTIALS.none;
            _this.runningProcesses.add(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var credentials, err_1, session, err_2, _a, aws_cognito_region, AuthConfig, token, federatedInfo, currentUser, payload, err_3;
                    var _this = this;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _b.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentCredentials()
                                ];
                            case 1:
                                credentials = _b.sent();
                                userCredentials = credentials.authenticated ? USER_CREDENTIALS.auth : USER_CREDENTIALS.unauth;
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                _b.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentSession()
                                ];
                            case 4:
                                session = _b.sent();
                                cognitoTokenPayload = session.getIdToken().decodePayload();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                err_2 = _b.sent();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                _b.trys.push([
                                    6,
                                    11,
                                    ,
                                    12
                                ]);
                                _a = this.amplifyConfig, aws_cognito_region = _a.aws_cognito_region, AuthConfig = _a.Auth;
                                if (!aws_cognito_region || AuthConfig && !AuthConfig.region) throw "Auth is not configured";
                                token = void 0;
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Cache.getItem("federatedInfo")
                                ];
                            case 7:
                                federatedInfo = _b.sent();
                                if (!federatedInfo) return [
                                    3 /*break*/ ,
                                    8
                                ];
                                token = federatedInfo.token;
                                return [
                                    3 /*break*/ ,
                                    10
                                ];
                            case 8:
                                return [
                                    4 /*yield*/ ,
                                    this.amplifyContext.Auth.currentAuthenticatedUser()
                                ];
                            case 9:
                                currentUser = _b.sent();
                                if (currentUser) token = currentUser.token;
                                _b.label = 10;
                            case 10:
                                if (token) {
                                    payload = token.split(".")[1];
                                    oidcTokenPayload = JSON.parse(Buffer.from(payload, "base64").toString("utf8"));
                                }
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 11:
                                err_3 = _b.sent();
                                logger.debug("error getting OIDC JWT", err_3);
                                return [
                                    3 /*break*/ ,
                                    12
                                ];
                            case 12:
                                Object.values(this.schema.namespaces).forEach(function(namespace) {
                                    Object.values(namespace.models).filter(function(_a) {
                                        var syncable = _a.syncable;
                                        return syncable;
                                    }).forEach(function(modelDefinition) {
                                        return _this.runningProcesses.isOpen && _this.runningProcesses.add(function() {
                                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                var modelAuthModes, readAuthModes, operations, operationAuthModeAttempts, predicatesGroup, addFilterArg, subscriptionRetry;
                                                var _a, _b, _c;
                                                var _this = this;
                                                return (0, _tslib.__generator)(this, function(_d) {
                                                    switch(_d.label){
                                                        case 0:
                                                            return [
                                                                4 /*yield*/ ,
                                                                (0, _utils.getModelAuthModes)({
                                                                    authModeStrategy: this.authModeStrategy,
                                                                    defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                                                    modelName: modelDefinition.name,
                                                                    schema: this.schema
                                                                })
                                                            ];
                                                        case 1:
                                                            modelAuthModes = _d.sent();
                                                            readAuthModes = modelAuthModes.READ;
                                                            subscriptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, subscriptions), (_a = {}, _a[modelDefinition.name] = (_b = {}, _b[(0, _utils.TransformerMutationType).CREATE] = [], _b[(0, _utils.TransformerMutationType).UPDATE] = [], _b[(0, _utils.TransformerMutationType).DELETE] = [], _b), _a));
                                                            operations = [
                                                                (0, _utils.TransformerMutationType).CREATE,
                                                                (0, _utils.TransformerMutationType).UPDATE,
                                                                (0, _utils.TransformerMutationType).DELETE
                                                            ];
                                                            operationAuthModeAttempts = (_c = {}, _c[(0, _utils.TransformerMutationType).CREATE] = 0, _c[(0, _utils.TransformerMutationType).UPDATE] = 0, _c[(0, _utils.TransformerMutationType).DELETE] = 0, _c);
                                                            predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(modelDefinition), false);
                                                            addFilterArg = predicatesGroup !== undefined;
                                                            subscriptionRetry = function(operation, addFilter) {
                                                                if (addFilter === void 0) addFilter = addFilterArg;
                                                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                    var _a, transformerMutationType, opName, query, isOwner, ownerField, ownerValue, authMode, authToken, variables, customUserAgentDetails, queryObservable, subscriptionReadyCallback;
                                                                    var _this = this;
                                                                    return (0, _tslib.__generator)(this, function(_b) {
                                                                        switch(_b.label){
                                                                            case 0:
                                                                                _a = this.buildSubscription(namespace, modelDefinition, operation, userCredentials, cognitoTokenPayload, oidcTokenPayload, readAuthModes[operationAuthModeAttempts[operation]], addFilter), transformerMutationType = _a.opType, opName = _a.opName, query = _a.query, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue, authMode = _a.authMode;
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                                                ];
                                                                            case 1:
                                                                                authToken = _b.sent();
                                                                                variables = {};
                                                                                customUserAgentDetails = {
                                                                                    category: (0, _core.Category).DataStore,
                                                                                    action: (0, _core.DataStoreAction).Subscribe
                                                                                };
                                                                                if (addFilter && predicatesGroup) variables["filter"] = (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
                                                                                if (isOwner) {
                                                                                    if (!ownerValue) {
                                                                                        observer.error("Owner field required, sign in is needed in order to perform this operation");
                                                                                        return [
                                                                                            2 /*return*/ 
                                                                                        ];
                                                                                    }
                                                                                    variables[ownerField] = ownerValue;
                                                                                }
                                                                                logger.debug("Attempting " + operation + " subscription with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                queryObservable = this.amplifyContext.InternalAPI.graphql((0, _tslib.__assign)((0, _tslib.__assign)({
                                                                                    query: query,
                                                                                    variables: variables
                                                                                }, {
                                                                                    authMode: authMode
                                                                                }), {
                                                                                    authToken: authToken
                                                                                }), undefined, customUserAgentDetails);
                                                                                // TODO: consider onTerminate.then(() => API.cancel(...))
                                                                                subscriptions[modelDefinition.name][transformerMutationType].push(queryObservable.map(function(_a) {
                                                                                    var value = _a.value;
                                                                                    return value;
                                                                                }).subscribe({
                                                                                    next: function(_a) {
                                                                                        var data = _a.data, errors = _a.errors;
                                                                                        if (Array.isArray(errors) && errors.length > 0) {
                                                                                            var messages = errors.map(function(_a) {
                                                                                                var message = _a.message;
                                                                                                return message;
                                                                                            });
                                                                                            logger.warn("Skipping incoming subscription. Messages: " + messages.join("\n"));
                                                                                            _this.drainBuffer();
                                                                                            return;
                                                                                        }
                                                                                        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(_this.syncPredicates.get(modelDefinition), false);
                                                                                        // @ts-ignore
                                                                                        var _b = data, _c = opName, record = _b[_c];
                                                                                        // checking incoming subscription against syncPredicate.
                                                                                        // once AppSync implements filters on subscriptions, we'll be
                                                                                        // able to set these when establishing the subscription instead.
                                                                                        // Until then, we'll need to filter inbound
                                                                                        if (_this.passesPredicateValidation(record, predicatesGroup)) _this.pushToBuffer(transformerMutationType, modelDefinition, record);
                                                                                        _this.drainBuffer();
                                                                                    },
                                                                                    error: function(subscriptionError) {
                                                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                            var _a, _b, _c, _d, message, isRTFError, e_1;
                                                                                            return (0, _tslib.__generator)(this, function(_e) {
                                                                                                switch(_e.label){
                                                                                                    case 0:
                                                                                                        _a = subscriptionError.error, _b = (0, _tslib.__read)((_a === void 0 ? {
                                                                                                            errors: []
                                                                                                        } : _a).errors, 1), _c = _b[0], _d = (_c === void 0 ? {} : _c).message, message = _d === void 0 ? "" : _d;
                                                                                                        isRTFError = // only attempt catch if a filter variable was added to the subscription query
                                                                                                        addFilter && this.catchRTFError(message, modelDefinition, predicatesGroup);
                                                                                                        // Catch RTF errors
                                                                                                        if (isRTFError) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            // retry subscription connection without filter
                                                                                                            subscriptionRetry(operation, false);
                                                                                                            return [
                                                                                                                2 /*return*/ 
                                                                                                            ];
                                                                                                        }
                                                                                                        if (message.includes((0, _pubsub.CONTROL_MSG).REALTIME_SUBSCRIPTION_INIT_ERROR) || message.includes((0, _pubsub.CONTROL_MSG).CONNECTION_FAILED)) {
                                                                                                            // Unsubscribe and clear subscription array for model/operation
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType].forEach(function(subscription) {
                                                                                                                return subscription.unsubscribe();
                                                                                                            });
                                                                                                            subscriptions[modelDefinition.name][transformerMutationType] = [];
                                                                                                            operationAuthModeAttempts[operation]++;
                                                                                                            if (operationAuthModeAttempts[operation] >= readAuthModes.length) // last auth mode retry. Continue with error
                                                                                                            logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1]);
                                                                                                            else {
                                                                                                                // retry with different auth mode. Do not trigger
                                                                                                                // observer error or error handler
                                                                                                                logger.debug(operation + " subscription failed with authMode: " + readAuthModes[operationAuthModeAttempts[operation] - 1] + ". Retrying with authMode: " + readAuthModes[operationAuthModeAttempts[operation]]);
                                                                                                                subscriptionRetry(operation);
                                                                                                                return [
                                                                                                                    2 /*return*/ 
                                                                                                                ];
                                                                                                            }
                                                                                                        }
                                                                                                        logger.warn("subscriptionError", message);
                                                                                                        _e.label = 1;
                                                                                                    case 1:
                                                                                                        _e.trys.push([
                                                                                                            1,
                                                                                                            3,
                                                                                                            ,
                                                                                                            4
                                                                                                        ]);
                                                                                                        return [
                                                                                                            4 /*yield*/ ,
                                                                                                            this.errorHandler({
                                                                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                                                localModel: null,
                                                                                                                message: message,
                                                                                                                model: modelDefinition.name,
                                                                                                                operation: operation,
                                                                                                                errorType: (0, _errorMaps.getSubscriptionErrorType)(subscriptionError),
                                                                                                                process: (0, _types.ProcessName).subscribe,
                                                                                                                remoteModel: null,
                                                                                                                cause: subscriptionError
                                                                                                            })
                                                                                                        ];
                                                                                                    case 2:
                                                                                                        _e.sent();
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 3:
                                                                                                        e_1 = _e.sent();
                                                                                                        logger.error("Subscription error handler failed with:", e_1);
                                                                                                        return [
                                                                                                            3 /*break*/ ,
                                                                                                            4
                                                                                                        ];
                                                                                                    case 4:
                                                                                                        if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
                                                                                                        if (message.includes('"errorType":"Unauthorized"') || message.includes('"errorType":"OperationDisabled"')) return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                        observer.error(message);
                                                                                                        return [
                                                                                                            2 /*return*/ 
                                                                                                        ];
                                                                                                }
                                                                                            });
                                                                                        });
                                                                                    }
                                                                                }));
                                                                                promises.push(function() {
                                                                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                                                        var boundFunction;
                                                                                        var _this = this;
                                                                                        return (0, _tslib.__generator)(this, function(_a) {
                                                                                            switch(_a.label){
                                                                                                case 0:
                                                                                                    return [
                                                                                                        4 /*yield*/ ,
                                                                                                        new Promise(function(res) {
                                                                                                            subscriptionReadyCallback = res;
                                                                                                            boundFunction = _this.hubQueryCompletionListener.bind(_this, res);
                                                                                                            (0, _core.Hub).listen("api", boundFunction);
                                                                                                        })
                                                                                                    ];
                                                                                                case 1:
                                                                                                    _a.sent();
                                                                                                    (0, _core.Hub).remove("api", boundFunction);
                                                                                                    return [
                                                                                                        2 /*return*/ 
                                                                                                    ];
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                }());
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            };
                                                            operations.forEach(function(op) {
                                                                return subscriptionRetry(op);
                                                            });
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                                this.runningProcesses.isOpen && this.runningProcesses.add(function() {
                                    return Promise.all(promises).then(function() {
                                        observer.next(CONTROL_MSG.CONNECTED);
                                    });
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, "subscription processor new subscriber");
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        Object.keys(subscriptions).forEach(function(modelName) {
                            subscriptions[modelName][(0, _utils.TransformerMutationType).CREATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).UPDATE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                            subscriptions[modelName][(0, _utils.TransformerMutationType).DELETE].forEach(function(subscription) {
                                return subscription.unsubscribe();
                            });
                        });
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        var dataObservable = new (0, _zenObservableTsDefault.default)(function(observer) {
            _this.dataObserver = observer;
            _this.drainBuffer();
            return _this.runningProcesses.addCleaner(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    return (0, _tslib.__generator)(this, function(_a) {
                        this.dataObserver = null;
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            });
        });
        return [
            ctlObservable,
            dataObservable
        ];
    };
    SubscriptionProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SubscriptionProcessor.prototype.passesPredicateValidation = function(record, predicatesGroup) {
        if (!predicatesGroup) return true;
        var predicates = predicatesGroup.predicates, type = predicatesGroup.type;
        return (0, _util.validatePredicate)(record, type, predicates);
    };
    SubscriptionProcessor.prototype.pushToBuffer = function(transformerMutationType, modelDefinition, data) {
        this.buffer.push([
            transformerMutationType,
            modelDefinition,
            data
        ]);
    };
    SubscriptionProcessor.prototype.drainBuffer = function() {
        var _this = this;
        if (this.dataObserver) {
            this.buffer.forEach(function(data) {
                return _this.dataObserver.next(data);
            });
            this.buffer = [];
        }
    };
    /**
     * @returns true if the service returned an RTF subscription error
     * @remarks logs a warning with remediation instructions
     *
     */ SubscriptionProcessor.prototype.catchRTFError = function(message, modelDefinition, predicatesGroup) {
        var header = "Backend subscriptions filtering error.\nSubscriptions filtering will be applied clientside.\n";
        var messageErrorTypeMap = {
            "UnknownArgument: Unknown field argument filter": (0, _utils.RTFError).UnknownField,
            "Filters exceed maximum attributes limit": (0, _utils.RTFError).MaxAttributes,
            "Filters combination exceed maximum limit": (0, _utils.RTFError).MaxCombinations,
            "filter uses same fieldName multiple time": (0, _utils.RTFError).RepeatedFieldname,
            "The variables input contains a field name 'not'": (0, _utils.RTFError).NotGroup,
            "The variables input contains a field that is not defined for input object type": (0, _utils.RTFError).FieldNotInType
        };
        var _a = (0, _tslib.__read)(Object.entries(messageErrorTypeMap).find(function(_a) {
            var _b = (0, _tslib.__read)(_a, 1), errorMsg = _b[0];
            return message.includes(errorMsg);
        }) || [], 2), _errorMsg = _a[0], errorType = _a[1];
        if (errorType !== undefined) {
            var remediationMessage = (0, _utils.generateRTFRemediation)(errorType, modelDefinition, predicatesGroup);
            logger.warn(header + "\n" + message + "\n" + remediationMessage);
            return true;
        }
        return false;
    };
    return SubscriptionProcessor;
}();

},{"a5da572164cb8f31":"7NC4b","tslib":"86BcK","@aws-amplify/api":"6PDaW","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/cache":"hVdVQ","@aws-amplify/core":"3rlh1","@aws-amplify/pubsub":"bJVAp","zen-observable-ts":"57mma","../../types":"9W0ar","../utils":"3udIx","../../predicates":"bohgw","../../util":"iFXfl","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bkNXz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncProcessor", ()=>SyncProcessor);
var _tslib = require("tslib");
var _internals = require("@aws-amplify/api/internals");
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _types = require("../../types");
var _utils = require("../utils");
var _core = require("@aws-amplify/core");
var _predicates = require("../../predicates");
var _errorMaps = require("./errorMaps");
var opResultDefaults = {
    items: [],
    nextToken: null,
    startedAt: null
};
var logger = new (0, _core.ConsoleLogger)("DataStore");
var SyncProcessor = /** @class */ function() {
    function SyncProcessor(schema, syncPredicates, amplifyConfig, authModeStrategy, errorHandler, amplifyContext) {
        if (amplifyConfig === void 0) amplifyConfig = {};
        this.schema = schema;
        this.syncPredicates = syncPredicates;
        this.amplifyConfig = amplifyConfig;
        this.authModeStrategy = authModeStrategy;
        this.errorHandler = errorHandler;
        this.amplifyContext = amplifyContext;
        this.typeQuery = new WeakMap();
        this.runningProcesses = new (0, _core.BackgroundProcessManager)();
        amplifyContext.InternalAPI = amplifyContext.InternalAPI || (0, _internals.InternalAPI);
        this.generateQueries();
    }
    SyncProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, _tslib.__read)((0, _utils.buildGraphQLOperation)(namespace, model, "LIST"), 1), _b = (0, _tslib.__read)(_a[0]), opNameQuery = _b.slice(1);
                _this.typeQuery.set(model, opNameQuery);
            });
        });
    };
    SyncProcessor.prototype.graphqlFilterFromPredicate = function(model) {
        if (!this.syncPredicates) return null;
        var predicatesGroup = (0, _predicates.ModelPredicateCreator).getPredicates(this.syncPredicates.get(model), false);
        if (!predicatesGroup) return null;
        return (0, _utils.predicateToGraphQLFilter)(predicatesGroup);
    };
    SyncProcessor.prototype.retrievePage = function(modelDefinition, lastSync, nextToken, limit, filter, onTerminate) {
        if (limit === void 0) limit = null;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, opName, query, variables, modelAuthModes, readAuthModes, authModeAttempts, authModeRetry, data, _b, _c, opResult, items, newNextToken, startedAt;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        _a = (0, _tslib.__read)(this.typeQuery.get(modelDefinition), 2), opName = _a[0], query = _a[1];
                        variables = {
                            limit: limit,
                            nextToken: nextToken,
                            lastSync: lastSync,
                            filter: filter
                        };
                        return [
                            4 /*yield*/ ,
                            (0, _utils.getModelAuthModes)({
                                authModeStrategy: this.authModeStrategy,
                                defaultAuthMode: this.amplifyConfig.aws_appsync_authenticationType,
                                modelName: modelDefinition.name,
                                schema: this.schema
                            })
                        ];
                    case 1:
                        modelAuthModes = _d.sent();
                        readAuthModes = modelAuthModes.READ;
                        authModeAttempts = 0;
                        authModeRetry = function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                var response, error_1, authMode;
                                var _a;
                                return (0, _tslib.__generator)(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            if (!this.runningProcesses.isOpen) throw new Error("sync.retreievePage termination was requested. Exiting.");
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([
                                                1,
                                                3,
                                                ,
                                                5
                                            ]);
                                            logger.debug("Attempting sync with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                this.jitteredRetry({
                                                    query: query,
                                                    variables: variables,
                                                    opName: opName,
                                                    modelDefinition: modelDefinition,
                                                    authMode: readAuthModes[authModeAttempts],
                                                    onTerminate: onTerminate
                                                })
                                            ];
                                        case 2:
                                            response = _b.sent();
                                            logger.debug("Sync successful with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                2 /*return*/ ,
                                                response
                                            ];
                                        case 3:
                                            error_1 = _b.sent();
                                            authModeAttempts++;
                                            if (authModeAttempts >= readAuthModes.length) {
                                                authMode = readAuthModes[authModeAttempts - 1];
                                                logger.debug("Sync failed with authMode: " + authMode, error_1);
                                                if ((0, _utils.getClientSideAuthError)(error_1) || (0, _utils.getForbiddenError)(error_1)) {
                                                    // return empty list of data so DataStore will continue to sync other models
                                                    logger.warn("User is unauthorized to query " + opName + " with auth mode " + authMode + ". No data could be returned.");
                                                    return [
                                                        2 /*return*/ ,
                                                        {
                                                            data: (_a = {}, _a[opName] = opResultDefaults, _a)
                                                        }
                                                    ];
                                                }
                                                throw error_1;
                                            }
                                            logger.debug("Sync failed with authMode: " + readAuthModes[authModeAttempts - 1] + ". Retrying with authMode: " + readAuthModes[authModeAttempts]);
                                            return [
                                                4 /*yield*/ ,
                                                authModeRetry()
                                            ];
                                        case 4:
                                            return [
                                                2 /*return*/ ,
                                                _b.sent()
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4 /*yield*/ ,
                            authModeRetry()
                        ];
                    case 2:
                        data = _d.sent().data;
                        _b = data, _c = opName, opResult = _b[_c];
                        items = opResult.items, newNextToken = opResult.nextToken, startedAt = opResult.startedAt;
                        return [
                            2 /*return*/ ,
                            {
                                nextToken: newNextToken,
                                startedAt: startedAt,
                                items: items
                            }
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.jitteredRetry = function(_a) {
        var query = _a.query, variables = _a.variables, opName = _a.opName, modelDefinition = _a.modelDefinition, authMode = _a.authMode, onTerminate = _a.onTerminate;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, _core.jitteredExponentialRetry)(function(query, variables) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var authToken, customUserAgentDetails, error_2, clientOrForbiddenErrorMessage, hasItems, unauthorized, otherErrors, result;
                                    var _this = this;
                                    var _a, _b, _c, _d;
                                    return (0, _tslib.__generator)(this, function(_e) {
                                        switch(_e.label){
                                            case 0:
                                                _e.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    6
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, _utils.getTokenForCustomAuth)(authMode, this.amplifyConfig)
                                                ];
                                            case 1:
                                                authToken = _e.sent();
                                                customUserAgentDetails = {
                                                    category: (0, _core.Category).DataStore,
                                                    action: (0, _core.DataStoreAction).GraphQl
                                                };
                                                return [
                                                    4 /*yield*/ ,
                                                    this.amplifyContext.InternalAPI.graphql({
                                                        query: query,
                                                        variables: variables,
                                                        authMode: authMode,
                                                        authToken: authToken
                                                    }, undefined, customUserAgentDetails)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _e.sent()
                                                ];
                                            case 3:
                                                error_2 = _e.sent();
                                                clientOrForbiddenErrorMessage = (0, _utils.getClientSideAuthError)(error_2) || (0, _utils.getForbiddenError)(error_2);
                                                if (clientOrForbiddenErrorMessage) {
                                                    logger.error("Sync processor retry error:", error_2);
                                                    throw new (0, _core.NonRetryableError)(clientOrForbiddenErrorMessage);
                                                }
                                                hasItems = Boolean((_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a[opName]) === null || _b === void 0 ? void 0 : _b.items);
                                                unauthorized = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.some(function(err) {
                                                    return err.errorType === "Unauthorized";
                                                });
                                                otherErrors = (error_2 === null || error_2 === void 0 ? void 0 : error_2.errors) && error_2.errors.filter(function(err) {
                                                    return err.errorType !== "Unauthorized";
                                                });
                                                result = error_2;
                                                if (hasItems) result.data[opName].items = result.data[opName].items.filter(function(item) {
                                                    return item !== null;
                                                });
                                                if (!(hasItems && (otherErrors === null || otherErrors === void 0 ? void 0 : otherErrors.length))) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(otherErrors.map(function(err) {
                                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                                            var e_1;
                                                            return (0, _tslib.__generator)(this, function(_a) {
                                                                switch(_a.label){
                                                                    case 0:
                                                                        _a.trys.push([
                                                                            0,
                                                                            2,
                                                                            ,
                                                                            3
                                                                        ]);
                                                                        return [
                                                                            4 /*yield*/ ,
                                                                            this.errorHandler({
                                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                                localModel: null,
                                                                                message: err.message,
                                                                                model: modelDefinition.name,
                                                                                operation: opName,
                                                                                errorType: (0, _errorMaps.getSyncErrorType)(err),
                                                                                process: (0, _types.ProcessName).sync,
                                                                                remoteModel: null,
                                                                                cause: err
                                                                            })
                                                                        ];
                                                                    case 1:
                                                                        _a.sent();
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 2:
                                                                        e_1 = _a.sent();
                                                                        logger.error("Sync error handler failed with:", e_1);
                                                                        return [
                                                                            3 /*break*/ ,
                                                                            3
                                                                        ];
                                                                    case 3:
                                                                        return [
                                                                            2 /*return*/ 
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                    }))
                                                ];
                                            case 4:
                                                _e.sent();
                                                (0, _core.Hub).dispatch("datastore", {
                                                    event: "nonApplicableDataReceived",
                                                    data: {
                                                        errors: otherErrors,
                                                        modelName: modelDefinition.name
                                                    }
                                                });
                                                _e.label = 5;
                                            case 5:
                                                /**
                                         * Handle $util.unauthorized() in resolver request mapper, which responses with something
                                         * like this:
                                         *
                                         * ```
                                         * {
                                         * 	data: { syncYourModel: null },
                                         * 	errors: [
                                         * 		{
                                         * 			path: ['syncLegacyJSONComments'],
                                         * 			data: null,
                                         * 			errorType: 'Unauthorized',
                                         * 			errorInfo: null,
                                         * 			locations: [{ line: 2, column: 3, sourceName: null }],
                                         * 			message:
                                         * 				'Not Authorized to access syncYourModel on type Query',
                                         * 			},
                                         * 		],
                                         * 	}
                                         * ```
                                         *
                                         * The correct handling for this is to signal that we've encountered a non-retryable error,
                                         * since the server has responded with an auth error and *NO DATA* at this point.
                                         */ if (unauthorized) {
                                                    this.errorHandler({
                                                        recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                        localModel: null,
                                                        message: error_2.message,
                                                        model: modelDefinition.name,
                                                        operation: opName,
                                                        errorType: (0, _errorMaps.getSyncErrorType)(error_2.errors[0]),
                                                        process: (0, _types.ProcessName).sync,
                                                        remoteModel: null,
                                                        cause: error_2
                                                    });
                                                    throw new (0, _core.NonRetryableError)(error_2);
                                                }
                                                if ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c[opName].items) === null || _d === void 0 ? void 0 : _d.length) return [
                                                    2 /*return*/ ,
                                                    result
                                                ];
                                                throw error_2;
                                            case 6:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                query,
                                variables
                            ], undefined, onTerminate)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.start = function(typesLastSync) {
        var _this = this;
        var _a = this.amplifyConfig, maxRecordsToSync = _a.maxRecordsToSync, syncPageSize = _a.syncPageSize;
        var parentPromises = new Map();
        var observable = new (0, _zenObservableTsDefault.default)(function(observer) {
            var sortedTypesLastSyncs = Object.values(_this.schema.namespaces).reduce(function(map, namespace) {
                var e_2, _a;
                try {
                    for(var _b = (0, _tslib.__values)(Array.from(namespace.modelTopologicalOrdering.keys())), _c = _b.next(); !_c.done; _c = _b.next()){
                        var modelName = _c.value;
                        var typeLastSync = typesLastSync.get(namespace.models[modelName]);
                        map.set(namespace.models[modelName], typeLastSync);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                return map;
            }, new Map());
            var allModelsReady = Array.from(sortedTypesLastSyncs.entries()).filter(function(_a) {
                var _b = (0, _tslib.__read)(_a, 1), syncable = _b[0].syncable;
                return syncable;
            }).map(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), modelDefinition = _b[0], _c = (0, _tslib.__read)(_b[1], 2), namespace = _c[0], lastSync = _c[1];
                return _this.runningProcesses.isOpen && _this.runningProcesses.add(function(onTerminate) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var done, nextToken, startedAt, items, recordsReceived, filter, parents, promises, promise;
                        var _this = this;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    done = false;
                                    nextToken = null;
                                    startedAt = null;
                                    items = null;
                                    recordsReceived = 0;
                                    filter = this.graphqlFilterFromPredicate(modelDefinition);
                                    parents = this.schema.namespaces[namespace].modelTopologicalOrdering.get(modelDefinition.name);
                                    promises = parents.map(function(parent) {
                                        return parentPromises.get(namespace + "_" + parent);
                                    });
                                    promise = new Promise(function(res) {
                                        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                            var limit, error_3, e_3;
                                            var _a;
                                            return (0, _tslib.__generator)(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        return [
                                                            4 /*yield*/ ,
                                                            Promise.all(promises)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        _b.label = 2;
                                                    case 2:
                                                        /**
                                                     * If `runningProcesses` is not open, it means that the sync processor has been
                                                     * stopped (for example by calling `DataStore.clear()` upstream) and has not yet
                                                     * finished terminating and/or waiting for its background processes to complete.
                                                     */ if (!this.runningProcesses.isOpen) {
                                                            logger.debug("Sync processor has been stopped, terminating sync for " + modelDefinition.name);
                                                            return [
                                                                2 /*return*/ ,
                                                                res()
                                                            ];
                                                        }
                                                        limit = Math.min(maxRecordsToSync - recordsReceived, syncPageSize);
                                                        _b.label = 3;
                                                    case 3:
                                                        _b.trys.push([
                                                            3,
                                                            5,
                                                            ,
                                                            10
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.retrievePage(modelDefinition, lastSync, nextToken, limit, filter, onTerminate)
                                                        ];
                                                    case 4:
                                                        _a = _b.sent(), items = _a.items, nextToken = _a.nextToken, startedAt = _a.startedAt;
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 5:
                                                        error_3 = _b.sent();
                                                        _b.label = 6;
                                                    case 6:
                                                        _b.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.errorHandler({
                                                                recoverySuggestion: "Ensure app code is up to date, auth directives exist and are correct on each model, and that server-side data has not been invalidated by a schema change. If the problem persists, search for or create an issue: https://github.com/aws-amplify/amplify-js/issues",
                                                                localModel: null,
                                                                message: error_3.message,
                                                                model: modelDefinition.name,
                                                                operation: null,
                                                                errorType: (0, _errorMaps.getSyncErrorType)(error_3),
                                                                process: (0, _types.ProcessName).sync,
                                                                remoteModel: null,
                                                                cause: error_3
                                                            })
                                                        ];
                                                    case 7:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 8:
                                                        e_3 = _b.sent();
                                                        logger.error("Sync error handler failed with:", e_3);
                                                        return [
                                                            3 /*break*/ ,
                                                            9
                                                        ];
                                                    case 9:
                                                        /**
                                                     * If there's an error, this model fails, but the rest of the sync should
                                                     * continue. To facilitate this, we explicitly mark this model as `done`
                                                     * with no items and allow the loop to continue organically. This ensures
                                                     * all callbacks (subscription messages) happen as normal, so anything
                                                     * waiting on them knows the model is as done as it can be.
                                                     */ done = true;
                                                        items = [];
                                                        return [
                                                            3 /*break*/ ,
                                                            10
                                                        ];
                                                    case 10:
                                                        recordsReceived += items.length;
                                                        done = nextToken === null || recordsReceived >= maxRecordsToSync;
                                                        observer.next({
                                                            namespace: namespace,
                                                            modelDefinition: modelDefinition,
                                                            items: items,
                                                            done: done,
                                                            startedAt: startedAt,
                                                            isFullSync: !lastSync
                                                        });
                                                        _b.label = 11;
                                                    case 11:
                                                        if (!done) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        _b.label = 12;
                                                    case 12:
                                                        res();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    });
                                    parentPromises.set(namespace + "_" + modelDefinition.name, promise);
                                    return [
                                        4 /*yield*/ ,
                                        promise
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                }, "adding model " + modelDefinition.name);
            });
            Promise.all(allModelsReady).then(function() {
                observer.complete();
            });
        });
        return observable;
    };
    SyncProcessor.prototype.stop = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.debug("stopping sync processor");
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.close()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.runningProcesses.open()
                        ];
                    case 2:
                        _a.sent();
                        logger.debug("sync processor stopped");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SyncProcessor;
}();

},{"tslib":"86BcK","@aws-amplify/api/internals":"6j6uC","zen-observable-ts":"57mma","../../types":"9W0ar","../utils":"3udIx","@aws-amplify/core":"3rlh1","../../predicates":"bohgw","./errorMaps":"k8bnH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8zsMQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "internals", ()=>internals);
parcelHelpers.export(exports, "FieldCondition", ()=>FieldCondition);
parcelHelpers.export(exports, "GroupCondition", ()=>GroupCondition);
/**
 * Creates a "seed" predicate that can be used to build an executable condition.
 * This is used in `query()`, for example, to seed customer- E.g.,
 *
 * ```
 * const p = predicateFor({builder: modelConstructor, schema: modelSchema, pkField: string[]});
 * p.and(child => [
 *   child.field.eq('whatever'),
 *   child.childModel.childField.eq('whatever else'),
 *   child.childModel.or(child => [
 *     child.otherField.contains('x'),
 *     child.otherField.contains('y'),
 *     child.otherField.contains('z'),
 *   ])
 * ])
 * ```
 *
 * `predicateFor()` returns objecst with recursive getters. To facilitate this,
 * a `query` and `tail` can be provided to "accumulate" nested conditions.
 *
 * @param ModelType The ModelMeta used to build child properties.
 * @param field Scopes the query branch to a field.
 * @param query A base query to build on. Omit to start a new query.
 * @param tail The point in an existing `query` to attach new conditions to.
 * @returns A ModelPredicate (builder) that customers can create queries with.
 * (As shown in function description.)
 */ parcelHelpers.export(exports, "recursivePredicateFor", ()=>recursivePredicateFor);
parcelHelpers.export(exports, "predicateFor", ()=>predicateFor);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _types = require("../types");
var _index = require("./index");
var _relationship = require("../storage/relationship");
var _util = require("../util");
var ops = (0, _tslib.__spread)((0, _index.comparisonKeys));
/**
 * A map from keys (exposed to customers) to the internal predicate data
 * structures invoking code should not muck with.
 */ var predicateInternalsMap = new Map();
/**
 * Creates a link between a key (and generates a key if needed) and an internal
 * `GroupCondition`, which allows us to return a key object instead of the gory
 * conditions details to customers/invoking code.
 *
 * @param condition The internal condition to keep hidden.
 * @param key The object DataStore will use to find the internal condition.
 * If no key is given, an empty one is created.
 */ var registerPredicateInternals = function(condition, key) {
    var finalKey = key || new (0, _types.PredicateInternalsKey)();
    predicateInternalsMap.set(finalKey, condition);
    return finalKey;
};
var internals = function(key) {
    if (!predicateInternalsMap.has(key)) throw new Error("Invalid predicate. Terminate your predicate with a valid condition (e.g., `p => p.field.eq('value')`) or pass `Predicates.ALL`.");
    return predicateInternalsMap.get(key);
};
/**
 * Maps operators to negated operators.
 * Used to facilitate propagation of negation down a tree of conditions.
 */ var negations = {
    and: "or",
    or: "and",
    not: "and",
    eq: "ne",
    ne: "eq",
    gt: "le",
    ge: "lt",
    lt: "ge",
    le: "gt",
    contains: "notContains",
    notContains: "contains"
};
/**
 * A condition that can operate against a single "primitive" field of a model or item.
 * @member field The field of *some record* to test against.
 * @member operator The equality or comparison operator to use.
 * @member operands The operands for the equality/comparison check.
 */ var FieldCondition = /** @class */ function() {
    function FieldCondition(field, operator, operands) {
        this.field = field;
        this.operator = operator;
        this.operands = operands;
        this.validate();
    }
    /**
     * Creates a copy of self.
     * @param extract Not used. Present only to fulfill the `UntypedCondition` interface.
     * @returns A new, identitical `FieldCondition`.
     */ FieldCondition.prototype.copy = function(extract) {
        return [
            new FieldCondition(this.field, this.operator, (0, _tslib.__spread)(this.operands)),
            undefined
        ];
    };
    /**
     * Produces a tree structure similar to a graphql condition. The returned
     * structure is "dumb" and is intended for another query/condition
     * generation mechanism to interpret, such as the cloud or storage query
     * builders.
     *
     * E.g.,
     *
     * ```json
     * {
     * 	"name": {
     * 		"eq": "robert"
     * 	}
     * }
     * ```
     */ FieldCondition.prototype.toAST = function() {
        var _a, _b;
        return _a = {}, _a[this.field] = (_b = {}, _b[this.operator] = this.operator === "between" ? [
            this.operands[0],
            this.operands[1]
        ] : this.operands[0], _b), _a;
    };
    /**
     * Produces a new condition (`FieldCondition` or `GroupCondition`) that
     * matches the opposite of this condition.
     *
     * Intended to be used when applying De Morgan's Law, which can be done to
     * produce more efficient queries against the storage layer if a negation
     * appears in the query tree.
     *
     * For example:
     *
     * 1. `name.eq('robert')` becomes `name.ne('robert')`
     * 2. `price.between(100, 200)` becomes `m => m.or(m => [m.price.lt(100), m.price.gt(200)])`
     *
     * @param model The model meta to use when construction a new `GroupCondition`
     * for cases where the negation requires multiple `FieldCondition`'s.
     */ FieldCondition.prototype.negated = function(model) {
        if (this.operator === "between") return new GroupCondition(model, undefined, undefined, "or", [
            new FieldCondition(this.field, "lt", [
                this.operands[0]
            ]),
            new FieldCondition(this.field, "gt", [
                this.operands[1]
            ])
        ]);
        else if (this.operator === "beginsWith") // beginsWith negation doesn't have a good, safe optimation right now.
        // just re-wrap it in negation. The adapter will have to scan-and-filter,
        // as is likely optimal for negated beginsWith conditions *anyway*.
        return new GroupCondition(model, undefined, undefined, "not", [
            new FieldCondition(this.field, "beginsWith", [
                this.operands[0]
            ])
        ]);
        else return new FieldCondition(this.field, negations[this.operator], this.operands);
    };
    /**
     * Not implemented. Not needed. GroupCondition instead consumes FieldConditions and
     * transforms them into legacy predicates. (*For now.*)
     * @param storage N/A. If ever implemented, the storage adapter to query.
     * @returns N/A. If ever implemented, return items from `storage` that match.
     */ FieldCondition.prototype.fetch = function(storage) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.reject("No implementation needed [yet].")
                ];
            });
        });
    };
    /**
     * Determins whether a given item matches the expressed condition.
     * @param item The item to test.
     * @returns `Promise<boolean>`, `true` if matches; `false` otherwise.
     */ FieldCondition.prototype.matches = function(item) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var v, operations, operation, result;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                v = item[this.field];
                operations = {
                    eq: function() {
                        return v === _this.operands[0];
                    },
                    ne: function() {
                        return v !== _this.operands[0];
                    },
                    gt: function() {
                        return v > _this.operands[0];
                    },
                    ge: function() {
                        return v >= _this.operands[0];
                    },
                    lt: function() {
                        return v < _this.operands[0];
                    },
                    le: function() {
                        return v <= _this.operands[0];
                    },
                    contains: function() {
                        return (v === null || v === void 0 ? void 0 : v.indexOf(_this.operands[0])) > -1;
                    },
                    notContains: function() {
                        return !v ? true : v.indexOf(_this.operands[0]) === -1;
                    },
                    beginsWith: function() {
                        return v === null || v === void 0 ? void 0 : v.startsWith(_this.operands[0]);
                    },
                    between: function() {
                        return v >= _this.operands[0] && v <= _this.operands[1];
                    }
                };
                operation = operations[this.operator];
                if (operation) {
                    result = operation();
                    return [
                        2 /*return*/ ,
                        result
                    ];
                } else throw new Error("Invalid operator given: " + this.operator);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Checks `this.operands` for compatibility with `this.operator`.
     */ FieldCondition.prototype.validate = function() {
        var _this = this;
        /**
         * Creates a validator that checks for a particular `operands` count.
         * Throws an exception if the `count` disagrees with `operands.length`.
         * @param count The number of `operands` expected.
         */ var argumentCount = function(count) {
            var argsClause = count === 1 ? "argument is" : "arguments are";
            return function() {
                if (_this.operands.length !== count) return "Exactly " + count + " " + argsClause + " required.";
            };
        };
        // NOTE: validations should return a message on failure.
        // hence, they should be "joined" together with logical OR's
        // as seen in the `between:` entry.
        var validations = {
            eq: argumentCount(1),
            ne: argumentCount(1),
            gt: argumentCount(1),
            ge: argumentCount(1),
            lt: argumentCount(1),
            le: argumentCount(1),
            contains: argumentCount(1),
            notContains: argumentCount(1),
            beginsWith: argumentCount(1),
            between: function() {
                return argumentCount(2)() || (_this.operands[0] > _this.operands[1] ? "The first argument must be less than or equal to the second argument." : null);
            }
        };
        var validate = validations[this.operator];
        if (validate) {
            var e = validate();
            if (typeof e === "string") throw new Error("Incorrect usage of `" + this.operator + "()`: " + e);
        } else throw new Error("Non-existent operator: `" + this.operator + "()`");
    };
    return FieldCondition;
}();
/**
 * Small utility function to generate a monotonically increasing ID.
 * Used by GroupCondition to help keep track of which group is doing what,
 * when, and where during troubleshooting.
 */ var getGroupId = function() {
    var seed = 1;
    return function() {
        return "group_" + seed++;
    };
}();
/**
 * A set of sub-conditions to operate against a model, optionally scoped to
 * a specific field, combined with the given operator (one of `and`, `or`, or `not`).
 * @member groupId Used to distinguish between GroupCondition instances for
 * debugging and troublehsooting.
 * @member model A metadata object that tells GroupCondition what to query and how.
 * @member field The field on the model that the sub-conditions apply to.
 * @member operator How to group child conditions together.
 * @member operands The child conditions.
 */ var GroupCondition = /** @class */ function() {
    function GroupCondition(/**
     * The `ModelMeta` of the model to query and/or filter against.
     * Expected to contain:
     *
     * ```js
     * {
     * 	builder: ModelConstructor,
     * 	schema: SchemaModel,
     * 	pkField: string[]
     * }
     * ```
     */ model, /**
     * If populated, this group specifices a condition on a relationship.
     *
     * If `field` does *not* point to a related model, that's an error. It
     * could indicate that the `GroupCondition` was instantiated with bad
     * data, or that the model metadata is incorrect.
     */ field, /**
     * If a `field` is given, whether the relationship is a `HAS_ONE`,
     * 'HAS_MANY`, or `BELONGS_TO`.
     *
     * TODO: Remove this and replace with derivation using
     * `ModelRelationship.from(this.model, this.field).relationship`;
     */ relationshipType, /**
     *
     */ operator, /**
     *
     */ operands, /**
     * Whether this GroupCondition is the result of an optimize call.
     *
     * This is used to guard against infinitely fetch -> optimize -> fetch
     * recursion.
     */ isOptimized) {
        if (isOptimized === void 0) isOptimized = false;
        this.model = model;
        this.field = field;
        this.relationshipType = relationshipType;
        this.operator = operator;
        this.operands = operands;
        this.isOptimized = isOptimized;
        // `groupId` was used for development/debugging.
        // Should we leave this in for future troubleshooting?
        this.groupId = getGroupId();
    }
    /**
     * Returns a copy of a GroupCondition, which also returns the copy of a
     * given reference node to "extract".
     * @param extract A node of interest. Its copy will *also* be returned if the node exists.
     * @returns [The full copy, the copy of `extract` | undefined]
     */ GroupCondition.prototype.copy = function(extract) {
        var copied = new GroupCondition(this.model, this.field, this.relationshipType, this.operator, []);
        var extractedCopy = extract === this ? copied : undefined;
        this.operands.forEach(function(o) {
            var _a = (0, _tslib.__read)(o.copy(extract), 2), operandCopy = _a[0], extractedFromOperand = _a[1];
            copied.operands.push(operandCopy);
            extractedCopy = extractedCopy || extractedFromOperand;
        });
        return [
            copied,
            extractedCopy
        ];
    };
    /**
     * Creates a new `GroupCondition` that contains only the local field conditions,
     * omitting related model conditions. That resulting `GroupCondition` can be
     * used to produce predicates that are compatible with the storage adapters and
     * Cloud storage.
     *
     * @param negate Whether the condition tree should be negated according
     * to De Morgan's law.
     */ GroupCondition.prototype.withFieldConditionsOnly = function(negate) {
        var _this = this;
        var negateChildren = negate !== (this.operator === "not");
        return new GroupCondition(this.model, undefined, undefined, negate ? negations[this.operator] : this.operator, this.operands.filter(function(o) {
            return o instanceof FieldCondition;
        }).map(function(o) {
            return negateChildren ? o.negated(_this.model) : o;
        }));
    };
    /**
     * Returns a version of the predicate tree with unnecessary logical groups
     * condensed and merged together. This is intended to create a dense tree
     * with leaf nodes (`FieldCondition`'s) aggregated under as few group conditions
     * as possible for the most efficient fetching possible -- it allows `fetch()`.
     *
     * E.g. a grouping like this:
     *
     * ```yaml
     * and:
     * 	and:
     * 		id:
     * 			eq: "abc"
     * 	and:
     * 		name:
     * 			eq: "xyz"
     * ```
     *
     * Will become this:
     *
     * ```yaml
     * and:
     * 	id:
     * 		eq: "abc"
     * 	name:
     * 		eq: "xyz"
     * ```
     *
     * This allows `fetch()` to pass both the `id` and `name` conditions to the adapter
     * together, which can then decide what index to use based on both fields together.
     *
     * @param preserveNode Whether to preserve the current node and to explicitly not eliminate
     * it during optimization. Used internally to preserve the root node and children of
     * `not` groups. `not` groups will always have a single child, so there's nothing to
     * optimize below a `not` (for now), and it makes the query logic simpler later.
     */ GroupCondition.prototype.optimized = function(preserveNode) {
        var _this = this;
        if (preserveNode === void 0) preserveNode = true;
        var operands = this.operands.map(function(o) {
            return o instanceof GroupCondition ? o.optimized(_this.operator === "not") : o;
        });
        // we're only collapsing and/or groups that contains a single child for now,
        // because they're much more common and much more trivial to collapse. basically,
        // an `and`/`or` that contains a single child doesn't require the layer of
        // logical grouping.
        if (!preserveNode && [
            "and",
            "or"
        ].includes(this.operator) && !this.field && operands.length === 1) {
            var operand = operands[0];
            if (operand instanceof FieldCondition) {
                // between conditions should NOT be passed up the chain. if they
                // need to be *negated* later, it is important that they be properly
                // contained in an AND group. when de morgan's law is applied, the
                // conditions are reversed and the AND group flips to an OR. this
                // doesn't work right if the a `between` doesn't live in an AND group.
                if (operand.operator !== "between") return operand;
            } else return operand;
        }
        return new GroupCondition(this.model, this.field, this.relationshipType, this.operator, operands, true);
    };
    /**
     * Fetches matching records from a given storage adapter using legacy predicates (for now).
     * @param storage The storage adapter this predicate will query against.
     * @param breadcrumb For debugging/troubleshooting. A list of the `groupId`'s this
     * GroupdCondition.fetch is nested within.
     * @param negate Whether to match on the `NOT` of `this`.
     * @returns An `Promise` of `any[]` from `storage` matching the child conditions.
     */ GroupCondition.prototype.fetch = function(storage, breadcrumb, negate) {
        if (breadcrumb === void 0) breadcrumb = [];
        if (negate === void 0) negate = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var resultGroups, operator, negateChildren, groups, conditions, groups_1, groups_1_1, g, relatives, relationship, allJoinConditions, relatives_1, relatives_1_1, relative, relativeConditions, i, predicate, _a, _b, e_1_1, predicate, _c, _d, _e, _f, getPKValue, resultIndex, resultGroups_1, resultGroups_1_1, group, intersectWith, _g, _h, k, resultGroups_2, resultGroups_2_1, group, group_1, group_1_1, item;
            var e_1, _j, e_2, _k, _l, e_3, _m, e_4, _o, e_5, _p, e_6, _q;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_r) {
                switch(_r.label){
                    case 0:
                        if (!this.isOptimized) return [
                            2 /*return*/ ,
                            this.optimized().fetch(storage)
                        ];
                        resultGroups = [];
                        operator = negate ? negations[this.operator] : this.operator;
                        negateChildren = negate !== (this.operator === "not");
                        groups = this.operands.filter(function(op) {
                            return op instanceof GroupCondition;
                        });
                        conditions = this.operands.filter(function(op) {
                            return op instanceof FieldCondition;
                        });
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        groups_1 = (0, _tslib.__values)(groups), groups_1_1 = groups_1.next();
                        _r.label = 2;
                    case 2:
                        if (!!groups_1_1.done) return [
                            3 /*break*/ ,
                            9
                        ];
                        g = groups_1_1.value;
                        return [
                            4 /*yield*/ ,
                            g.fetch(storage, (0, _tslib.__spread)(breadcrumb, [
                                this.groupId
                            ]), negateChildren)
                        ];
                    case 3:
                        relatives = _r.sent();
                        // no relatives -> no need to attempt to perform a "join" query for
                        // candidate results:
                        //
                        // select a.* from a,b where b.id in EMPTY_SET ==> EMPTY_SET
                        //
                        // Additionally, the entire (sub)-query can be short-circuited if
                        // the operator is `AND`. Illustrated in SQL:
                        //
                        // select a.* from a where
                        //   id in [a,b,c]
                        //     AND                        <
                        //   id in EMTPY_SET            <<< Look!
                        //     AND                        <
                        //   id in [x,y,z]
                        //
                        // YIELDS: EMPTY_SET           // <-- Easy peasy. Lemon squeezy.
                        //
                        if (relatives.length === 0) {
                            // aggressively short-circuit as soon as we know the group condition will fail
                            if (operator === "and") return [
                                2 /*return*/ ,
                                []
                            ];
                            // less aggressive short-circuit if we know the relatives will produce no
                            // candidate results; but aren't sure yet how this affects the group condition.
                            resultGroups.push([]);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        }
                        if (!g.field) return [
                            3 /*break*/ ,
                            7
                        ];
                        relationship = (0, _relationship.ModelRelationship).from(this.model, g.field);
                        if (!relationship) return [
                            3 /*break*/ ,
                            5
                        ];
                        allJoinConditions = [];
                        try {
                            for(relatives_1 = (e_2 = void 0, (0, _tslib.__values)(relatives)), relatives_1_1 = relatives_1.next(); !relatives_1_1.done; relatives_1_1 = relatives_1.next()){
                                relative = relatives_1_1.value;
                                relativeConditions = [];
                                for(i = 0; i < relationship.localJoinFields.length; i++)relativeConditions.push((_l = {}, _l[relationship.localJoinFields[i]] = {
                                    eq: relative[relationship.remoteJoinFields[i]]
                                }, _l));
                                allJoinConditions.push({
                                    and: relativeConditions
                                });
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (relatives_1_1 && !relatives_1_1.done && (_k = relatives_1.return)) _k.call(relatives_1);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        predicate = (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, {
                            or: allJoinConditions
                        });
                        _b = (_a = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 4:
                        _b.apply(_a, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        throw new Error("Missing field metadata.");
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        // relatives are not actually relatives. they're candidate results.
                        resultGroups.push(relatives);
                        _r.label = 8;
                    case 8:
                        groups_1_1 = groups_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        e_1_1 = _r.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        try {
                            if (groups_1_1 && !groups_1_1.done && (_j = groups_1.return)) _j.call(groups_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (!(conditions.length > 0)) return [
                            3 /*break*/ ,
                            14
                        ];
                        predicate = this.withFieldConditionsOnly(negateChildren).toStoragePredicate();
                        _d = (_c = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder, predicate)
                        ];
                    case 13:
                        _d.apply(_c, [
                            _r.sent()
                        ]);
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        if (!(conditions.length === 0 && resultGroups.length === 0)) return [
                            3 /*break*/ ,
                            16
                        ];
                        _f = (_e = resultGroups).push;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.model.builder)
                        ];
                    case 15:
                        _f.apply(_e, [
                            _r.sent()
                        ]);
                        _r.label = 16;
                    case 16:
                        getPKValue = function(item) {
                            return JSON.stringify(_this.model.pkField.map(function(name) {
                                return item[name];
                            }));
                        };
                        if (operator === "and") {
                            if (resultGroups.length === 0) return [
                                2 /*return*/ ,
                                []
                            ];
                            try {
                                // for each group, we intersect, removing items from the result index
                                // that aren't present in each subsequent group.
                                for(resultGroups_1 = (0, _tslib.__values)(resultGroups), resultGroups_1_1 = resultGroups_1.next(); !resultGroups_1_1.done; resultGroups_1_1 = resultGroups_1.next()){
                                    group = resultGroups_1_1.value;
                                    if (resultIndex === undefined) resultIndex = new Map(group.map(function(item) {
                                        return [
                                            getPKValue(item),
                                            item
                                        ];
                                    }));
                                    else {
                                        intersectWith = new Map(group.map(function(item) {
                                            return [
                                                getPKValue(item),
                                                item
                                            ];
                                        }));
                                        try {
                                            for(_g = (e_4 = void 0, (0, _tslib.__values)(resultIndex.keys())), _h = _g.next(); !_h.done; _h = _g.next()){
                                                k = _h.value;
                                                if (!intersectWith.has(k)) resultIndex.delete(k);
                                            }
                                        } catch (e_4_1) {
                                            e_4 = {
                                                error: e_4_1
                                            };
                                        } finally{
                                            try {
                                                if (_h && !_h.done && (_o = _g.return)) _o.call(_g);
                                            } finally{
                                                if (e_4) throw e_4.error;
                                            }
                                        }
                                    }
                                }
                            } catch (e_3_1) {
                                e_3 = {
                                    error: e_3_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_1_1 && !resultGroups_1_1.done && (_m = resultGroups_1.return)) _m.call(resultGroups_1);
                                } finally{
                                    if (e_3) throw e_3.error;
                                }
                            }
                        } else if (operator === "or" || operator === "not") {
                            // it's OK to handle NOT here, because NOT must always only negate
                            // a single child predicate. NOT logic will have been distributed down
                            // to the leaf conditions already.
                            resultIndex = new Map();
                            try {
                                // just merge the groups, performing DISTINCT-ification by ID.
                                for(resultGroups_2 = (0, _tslib.__values)(resultGroups), resultGroups_2_1 = resultGroups_2.next(); !resultGroups_2_1.done; resultGroups_2_1 = resultGroups_2.next()){
                                    group = resultGroups_2_1.value;
                                    try {
                                        for(group_1 = (e_6 = void 0, (0, _tslib.__values)(group)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()){
                                            item = group_1_1.value;
                                            resultIndex.set(getPKValue(item), item);
                                        }
                                    } catch (e_6_1) {
                                        e_6 = {
                                            error: e_6_1
                                        };
                                    } finally{
                                        try {
                                            if (group_1_1 && !group_1_1.done && (_q = group_1.return)) _q.call(group_1);
                                        } finally{
                                            if (e_6) throw e_6.error;
                                        }
                                    }
                                }
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (resultGroups_2_1 && !resultGroups_2_1.done && (_p = resultGroups_2.return)) _p.call(resultGroups_2);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                        }
                        return [
                            2 /*return*/ ,
                            Array.from((resultIndex === null || resultIndex === void 0 ? void 0 : resultIndex.values()) || [])
                        ];
                }
            });
        });
    };
    /**
     * Determines whether a single item matches the conditions of `this`.
     * When checking the target `item`'s properties, each property will be `await`'d
     * to ensure lazy-loading is respected where applicable.
     * @param item The item to match against.
     * @param ignoreFieldName Tells `match()` that the field name has already been dereferenced.
     * (Used for iterating over children on HAS_MANY checks.)
     * @returns A boolean (promise): `true` if matched, `false` otherwise.
     */ GroupCondition.prototype.matches = function(item, ignoreFieldName) {
        if (ignoreFieldName === void 0) ignoreFieldName = false;
        var e_7, _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var itemToCheck, _b, itemToCheck_1, itemToCheck_1_1, singleItem, e_7_1;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!(this.field && !ignoreFieldName)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            item[this.field]
                        ];
                    case 1:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _b = item;
                        _c.label = 3;
                    case 3:
                        itemToCheck = _b;
                        // if there is no item to check, we can stop recursing immediately.
                        // a condition cannot match against an item that does not exist. this
                        // can occur when `item.field` is optional in the schema.
                        if (!itemToCheck) return [
                            2 /*return*/ ,
                            false
                        ];
                        if (!(this.relationshipType === "HAS_MANY" && typeof itemToCheck[Symbol.asyncIterator] === "function")) return [
                            3 /*break*/ ,
                            17
                        ];
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            10,
                            11,
                            16
                        ]);
                        itemToCheck_1 = (0, _tslib.__asyncValues)(itemToCheck);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            itemToCheck_1.next()
                        ];
                    case 6:
                        if (!(itemToCheck_1_1 = _c.sent(), !itemToCheck_1_1.done)) return [
                            3 /*break*/ ,
                            9
                        ];
                        singleItem = itemToCheck_1_1.value;
                        return [
                            4 /*yield*/ ,
                            this.matches(singleItem, true)
                        ];
                    case 7:
                        if (_c.sent()) return [
                            2 /*return*/ ,
                            true
                        ];
                        _c.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 10:
                        e_7_1 = _c.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _c.trys.push([
                            11,
                            ,
                            14,
                            15
                        ]);
                        if (!(itemToCheck_1_1 && !itemToCheck_1_1.done && (_a = itemToCheck_1.return))) return [
                            3 /*break*/ ,
                            13
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(itemToCheck_1)
                        ];
                    case 12:
                        _c.sent();
                        _c.label = 13;
                    case 13:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        if (e_7) throw e_7.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 17:
                        if (!(this.operator === "or")) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncSome)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 18:
                        if (!(this.operator === "and")) return [
                            3 /*break*/ ,
                            19
                        ];
                        return [
                            2 /*return*/ ,
                            (0, _util.asyncEvery)(this.operands, function(c) {
                                return c.matches(itemToCheck);
                            })
                        ];
                    case 19:
                        if (!(this.operator === "not")) return [
                            3 /*break*/ ,
                            21
                        ];
                        if (this.operands.length !== 1) throw new Error("Invalid arguments! `not()` accepts exactly one predicate expression.");
                        return [
                            4 /*yield*/ ,
                            this.operands[0].matches(itemToCheck)
                        ];
                    case 20:
                        return [
                            2 /*return*/ ,
                            !_c.sent()
                        ];
                    case 21:
                        throw new Error("Invalid group operator!");
                }
            });
        });
    };
    /**
     * Tranfsorm to a AppSync GraphQL compatible AST.
     * (Does not support filtering in nested types.)
     */ GroupCondition.prototype.toAST = function() {
        var _a;
        if (this.field) throw new Error("Nested type conditions are not supported!");
        return _a = {}, _a[this.operator] = this.operands.map(function(operand) {
            return operand.toAST();
        }), _a;
    };
    /**
     * Turn this predicate group into something a storage adapter
     * understands how to use.
     */ GroupCondition.prototype.toStoragePredicate = function() {
        return (0, _index.ModelPredicateCreator).createFromAST(this.model.schema, this.toAST());
    };
    /**
     * A JSON representation that's good for debugging.
     */ GroupCondition.prototype.toJSON = function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            model: this.model.schema.name
        });
    };
    return GroupCondition;
}();
function recursivePredicateFor(ModelType, allowRecursion, field, query, tail) {
    if (allowRecursion === void 0) allowRecursion = true;
    // to be used if we don't have a base query or tail to build onto
    var starter = new GroupCondition(ModelType, field, undefined, "and", []);
    var baseCondition = query && tail ? query : starter;
    var tailCondition = query && tail ? tail : starter;
    // our eventual return object, which can be built upon.
    // next steps will be to add or(), and(), not(), and field.op() methods.
    var link = {};
    // so it can be looked up later with in the internals when processing conditions.
    registerPredicateInternals(baseCondition, link);
    var copyLink = function() {
        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), query = _a[0], newTail = _a[1];
        var newLink = recursivePredicateFor(ModelType, allowRecursion, undefined, query, newTail);
        return {
            query: query,
            newTail: newTail,
            newLink: newLink
        };
    };
    // Adds .or() and .and() methods to the link.
    // TODO: If revisiting this code, consider writing a Proxy instead.
    [
        "and",
        "or"
    ].forEach(function(op) {
        link[op] = function(builder) {
            // or() and and() will return a copy of the original link
            // to head off mutability concerns.
            var _a = copyLink(), query = _a.query, newTail = _a.newTail;
            var childConditions = builder(recursivePredicateFor(ModelType, allowRecursion));
            if (!Array.isArray(childConditions)) throw new Error("Invalid predicate. `" + op + "` groups must return an array of child conditions.");
            // the customer will supply a child predicate, which apply to the `model.field`
            // of the tail GroupCondition.
            newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, op, childConditions.map(function(c) {
                return internals(c);
            })));
            // FinalPredicate
            return registerPredicateInternals(query);
        };
    });
    // TODO: If revisiting this code, consider proxy.
    link.not = function(builder) {
        // not() will return a copy of the original link
        // to head off mutability concerns.
        var _a = copyLink(), query = _a.query, newTail = _a.newTail;
        // unlike and() and or(), the customer will supply a "singular" child predicate.
        // the difference being: not() does not accept an array of predicate-like objects.
        // it negates only a *single* predicate subtree.
        newTail === null || newTail === void 0 || newTail.operands.push(new GroupCondition(ModelType, field, undefined, "not", [
            internals(builder(recursivePredicateFor(ModelType, allowRecursion)))
        ]));
        // A `FinalModelPredicate`.
        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
        // or query storage: `.__query.fetch(storage)`.
        return registerPredicateInternals(query);
    };
    var _loop_1 = function(fieldName) {
        Object.defineProperty(link, fieldName, {
            enumerable: true,
            get: function() {
                var def = ModelType.schema.allFields[fieldName];
                if (!def.association) // we're looking at a value field. we need to return a
                // "field matcher object", which contains all of the comparison
                // functions ('eq', 'ne', 'gt', etc.), scoped to operate
                // against the target field (fieldName).
                return ops.reduce(function(fieldMatcher, operator) {
                    var _a;
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, fieldMatcher), (_a = {}, _a[operator] = function() {
                        var operands = [];
                        for(var _i = 0; _i < arguments.length; _i++)operands[_i] = arguments[_i];
                        // build off a fresh copy of the existing `link`, just in case
                        // the same link is being used elsewhere by the customer.
                        var _a = copyLink(), query = _a.query, newTail = _a.newTail;
                        // normalize operands. if any of the values are `undefiend`, use
                        // `null` instead, because that's what will be stored cross-platform.
                        var normalizedOperands = operands.map(function(o) {
                            return o === undefined ? null : o;
                        });
                        // add the given condition to the link's TAIL node.
                        // remember: the base link might go N nodes deep! e.g.,
                        newTail === null || newTail === void 0 || newTail.operands.push(new FieldCondition(fieldName, operator, normalizedOperands));
                        // A `FinalModelPredicate`.
                        // Return a thing that can no longer be extended, but instead used to `async filter(items)`
                        // or query storage: `.__query.fetch(storage)`.
                        return registerPredicateInternals(query);
                    }, _a));
                }, {});
                else {
                    if (!allowRecursion) throw new Error("Predication on releated models is not supported in this context.");
                    else if (def.association.connectionType === "BELONGS_TO" || def.association.connectionType === "HAS_ONE" || def.association.connectionType === "HAS_MANY") {
                        // the use has just typed '.someRelatedModel'. we need to given them
                        // back a predicate chain.
                        var relatedMeta = def.type.modelConstructor;
                        if (!relatedMeta) throw new Error("Related model metadata is missing. This is a bug! Please report it.");
                        // `Model.reletedModelField` returns a copy of the original link,
                        // and will contains copies of internal GroupConditions
                        // to head off mutability concerns.
                        var _a = (0, _tslib.__read)(baseCondition.copy(tailCondition), 2), newquery = _a[0], oldtail = _a[1];
                        var newtail = new GroupCondition(relatedMeta, fieldName, def.association.connectionType, "and", []);
                        // `oldtail` here refers to the *copy* of the old tail.
                        // so, it's safe to modify at this point. and we need to modify
                        // it to push the *new* tail onto the end of it.
                        oldtail.operands.push(newtail);
                        var newlink = recursivePredicateFor(relatedMeta, allowRecursion, undefined, newquery, newtail);
                        return newlink;
                    } else throw new Error("Related model definition doesn't have a typedef. This is a bug! Please report it.");
                }
            }
        });
    };
    // For each field on the model schema, we want to add a getter
    // that creates the appropriate new `link` in the query chain.
    // TODO: If revisiting, consider a proxy.
    for(var fieldName in ModelType.schema.allFields)_loop_1(fieldName);
    return link;
}
function predicateFor(ModelType) {
    // the cast here is just a cheap way to reduce the surface area from
    // the recursive type.
    return recursivePredicateFor(ModelType, false);
}

},{"tslib":"86BcK","../types":"9W0ar","./index":"bohgw","../storage/relationship":"bT2iw","../util":"iFXfl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lH2Zb":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interactions", ()=>(0, _interactions.Interactions));
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>(0, _interactionsProvider.AbstractInteractionsProvider));
parcelHelpers.export(exports, "AWSLexProvider", ()=>(0, _awslexProvider.AWSLexProvider));
parcelHelpers.export(exports, "AWSLexV2Provider", ()=>(0, _awslexV2Provider.AWSLexV2Provider));
var _interactions = require("./Interactions");
var _interactionsProvider = require("./Providers/InteractionsProvider");
var _awslexProvider = require("./Providers/AWSLexProvider");
var _awslexV2Provider = require("./Providers/AWSLexV2Provider");

},{"./Interactions":"8Wbhl","./Providers/InteractionsProvider":false,"./Providers/AWSLexProvider":false,"./Providers/AWSLexV2Provider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Wbhl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InteractionsClass", ()=>InteractionsClass);
parcelHelpers.export(exports, "Interactions", ()=>Interactions);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _providers = require("./Providers");
var logger = new (0, _core.ConsoleLogger)("Interactions");
var InteractionsClass = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     */ function InteractionsClass(options) {
        if (options === void 0) options = {};
        this._options = options;
        logger.debug("Interactions Options", this._options);
        this._pluggables = {};
    }
    InteractionsClass.prototype.getModuleName = function() {
        return "Interactions";
    };
    /**
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     * @return {InteractionsOptions} - The current configuration
     */ InteractionsClass.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.Interactions || options : {};
        logger.debug("configure Interactions", {
            opt: opt
        });
        this._options = (0, _tslib.__assign)((0, _tslib.__assign)({
            bots: {}
        }, opt), opt.Interactions);
        var aws_bots_config = this._options.aws_bots_config;
        var bots_config = this._options.bots;
        if (!Object.keys(bots_config).length && aws_bots_config) // Convert aws_bots_config to bots object
        {
            if (Array.isArray(aws_bots_config)) aws_bots_config.forEach(function(bot) {
                _this._options.bots[bot.name] = bot;
            });
        }
        // configure bots to their specific providers
        Object.keys(bots_config).forEach(function(botKey) {
            var _a;
            var bot = bots_config[botKey];
            var providerName = bot.providerName || "AWSLexProvider";
            // add default provider if required
            if (!_this._pluggables.AWSLexProvider && providerName === "AWSLexProvider") _this._pluggables.AWSLexProvider = new (0, _providers.AWSLexProvider)();
            // configure bot with it's respective provider
            if (_this._pluggables[providerName]) _this._pluggables[providerName].configure((_a = {}, _a[bot.name] = bot, _a));
            else logger.debug("bot " + bot.name + " was not configured as " + providerName + " provider was not found");
        });
        return this._options;
    };
    InteractionsClass.prototype.addPluggable = function(pluggable) {
        var _this = this;
        if (pluggable && pluggable.getCategory() === "Interactions") {
            if (!this._pluggables[pluggable.getProviderName()]) {
                // configure bots for the new plugin
                Object.keys(this._options.bots).filter(function(botKey) {
                    return _this._options.bots[botKey].providerName === pluggable.getProviderName();
                }).forEach(function(botKey) {
                    var _a;
                    var bot = _this._options.bots[botKey];
                    pluggable.configure((_a = {}, _a[bot.name] = bot, _a));
                });
                this._pluggables[pluggable.getProviderName()] = pluggable;
                return;
            } else throw new Error("Pluggable " + pluggable.getProviderName() + " already plugged");
        }
    };
    InteractionsClass.prototype.send = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var botProvider;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._options.bots || !this._options.bots[botname]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botname + " does not exist")
                        ];
                        botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
                        if (!this._pluggables[botProvider]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?")
                        ];
                        return [
                            4 /*yield*/ ,
                            this._pluggables[botProvider].sendMessage(botname, message)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    InteractionsClass.prototype.onComplete = function(botname, callback) {
        if (!this._options.bots || !this._options.bots[botname]) throw new Error("Bot " + botname + " does not exist");
        var botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
        if (!this._pluggables[botProvider]) throw new Error("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?");
        this._pluggables[botProvider].onComplete(botname, callback);
    };
    return InteractionsClass;
}();
var Interactions = new InteractionsClass();
(0, _core.Amplify).register(Interactions);

},{"tslib":"2gCWu","@aws-amplify/core":"3rlh1","./Providers":"aUnj8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2gCWu":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aUnj8":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", ()=>(0, _awslexProvider.AWSLexProvider));
parcelHelpers.export(exports, "AWSLexV2Provider", ()=>(0, _awslexV2Provider.AWSLexV2Provider));
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>(0, _interactionsProvider.AbstractInteractionsProvider));
var _awslexProvider = require("./AWSLexProvider");
var _awslexV2Provider = require("./AWSLexV2Provider");
var _interactionsProvider = require("./InteractionsProvider");

},{"./AWSLexProvider":"lRej8","./AWSLexV2Provider":false,"./InteractionsProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRej8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSLexProvider", ()=>AWSLexProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _interactionsProvider = require("./InteractionsProvider");
var _clientLexRuntimeService = require("@aws-sdk/client-lex-runtime-service");
var _core = require("@aws-amplify/core");
var _utils = require("./AWSLexProviderHelper/utils");
var logger = new (0, _core.ConsoleLogger)("AWSLexProvider");
var AWSLexProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSLexProvider, _super);
    function AWSLexProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this._botsCompleteCallback = {};
        return _this;
    }
    AWSLexProvider.prototype.getProviderName = function() {
        return "AWSLexProvider";
    };
    AWSLexProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        var propertiesToTest = [
            "name",
            "alias",
            "region"
        ];
        Object.keys(config).forEach(function(botKey) {
            var botConfig = config[botKey];
            // is bot config correct
            if (!propertiesToTest.every(function(x) {
                return x in botConfig;
            })) throw new Error("invalid bot configuration");
        });
        return _super.prototype.configure.call(this, config);
    };
    /**
     * @private
     * @deprecated
     * This is used internally by 'sendMessage' to call onComplete callback
     * for a bot if configured
     */ AWSLexProvider.prototype.reportBotStatus = function(data, botname) {
        var _this = this;
        // Check if state is fulfilled to resolve onFullfilment promise
        logger.debug("postContent state", data.dialogState);
        if (data.dialogState === "ReadyForFulfillment" || data.dialogState === "Fulfilled") {
            if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                return _this._botsCompleteCallback[botname](null, data);
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                return _this._config[botname].onComplete(null, data);
            }, 0);
        }
        if (data.dialogState === "Failed") {
            if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                return _this._botsCompleteCallback[botname]("Bot conversation failed");
            }, 0);
            if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                return _this._config[botname].onComplete("Bot conversation failed");
            }, 0);
        }
    };
    AWSLexProvider.prototype.sendMessage = function(botname, message) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, error_1, params, postTextCommand, data, err_1, content, messageType, inputStream, _a, postContentCommand, data, audioArray, _b, response, err_2;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        // check if bot exists
                        if (!this._config[botname]) return [
                            2 /*return*/ ,
                            Promise.reject("Bot " + botname + " does not exist")
                        ];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 2:
                        credentials = _c.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                    case 4:
                        this.lexRuntimeServiceClient = new (0, _clientLexRuntimeService.LexRuntimeServiceClient)({
                            region: this._config[botname].region,
                            credentials: credentials,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        if (!(typeof message === "string")) return [
                            3 /*break*/ ,
                            9
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            inputText: message,
                            userId: credentials.identityId
                        };
                        logger.debug("postText to lex", message);
                        _c.label = 5;
                    case 5:
                        _c.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        postTextCommand = new (0, _clientLexRuntimeService.PostTextCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postTextCommand)
                        ];
                    case 6:
                        data = _c.sent();
                        this.reportBotStatus(data, botname);
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    case 7:
                        err_1 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_1)
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            21
                        ];
                    case 9:
                        content = message.content, messageType = message.options.messageType;
                        if (!(messageType === "voice")) return [
                            3 /*break*/ ,
                            13
                        ];
                        if (typeof content !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("invalid content type")
                        ];
                        if (!(content instanceof Uint8Array)) return [
                            3 /*break*/ ,
                            10
                        ];
                        _a = content;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 10:
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(content)
                        ];
                    case 11:
                        _a = _c.sent();
                        _c.label = 12;
                    case 12:
                        inputStream = _a;
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: "audio/x-l16; sample-rate=16000; channel-count=1",
                            userId: credentials.identityId,
                            accept: "audio/mpeg",
                            inputStream: inputStream
                        };
                        return [
                            3 /*break*/ ,
                            14
                        ];
                    case 13:
                        if (typeof content !== "string") return [
                            2 /*return*/ ,
                            Promise.reject("invalid content type")
                        ];
                        params = {
                            botAlias: this._config[botname].alias,
                            botName: botname,
                            contentType: "text/plain; charset=utf-8",
                            inputStream: content,
                            userId: credentials.identityId,
                            accept: "audio/mpeg"
                        };
                        _c.label = 14;
                    case 14:
                        logger.debug("postContent to lex", message);
                        _c.label = 15;
                    case 15:
                        _c.trys.push([
                            15,
                            20,
                            ,
                            21
                        ]);
                        postContentCommand = new (0, _clientLexRuntimeService.PostContentCommand)(params);
                        return [
                            4 /*yield*/ ,
                            this.lexRuntimeServiceClient.send(postContentCommand)
                        ];
                    case 16:
                        data = _c.sent();
                        if (!data.audioStream) return [
                            3 /*break*/ ,
                            18
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _utils.convert)(data.audioStream)
                        ];
                    case 17:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 18:
                        _b = undefined;
                        _c.label = 19;
                    case 19:
                        audioArray = _b;
                        response = (0, _tslib.__assign)((0, _tslib.__assign)({}, data), {
                            audioStream: audioArray
                        });
                        this.reportBotStatus(response, botname);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 20:
                        err_2 = _c.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(err_2)
                        ];
                    case 21:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSLexProvider.prototype.onComplete = function(botname, callback) {
        // does bot exist
        if (!this._config[botname]) throw new Error("Bot " + botname + " does not exist");
        this._botsCompleteCallback[botname] = callback;
    };
    return AWSLexProvider;
}((0, _interactionsProvider.AbstractInteractionsProvider));

},{"tslib":"2gCWu","./InteractionsProvider":"6ZXQe","@aws-sdk/client-lex-runtime-service":"3Q3uZ","@aws-amplify/core":"3rlh1","./AWSLexProviderHelper/utils":"ep5zt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6ZXQe":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractInteractionsProvider", ()=>AbstractInteractionsProvider);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("AbstractInteractionsProvider");
var AbstractInteractionsProvider = /** @class */ function() {
    function AbstractInteractionsProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractInteractionsProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._config), config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractInteractionsProvider.prototype.getCategory = function() {
        return "Interactions";
    };
    Object.defineProperty(AbstractInteractionsProvider.prototype, "options", {
        get: function() {
            return (0, _tslib.__assign)({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractInteractionsProvider;
}();

},{"tslib":"2gCWu","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Q3uZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", ()=>(0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var _lexRuntimeService = require("./LexRuntimeService");
parcelHelpers.exportAll(_lexRuntimeService, exports);
var _lexRuntimeServiceClient = require("./LexRuntimeServiceClient");
parcelHelpers.exportAll(_lexRuntimeServiceClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _lexRuntimeServiceServiceException = require("./models/LexRuntimeServiceServiceException");

},{"./LexRuntimeService":false,"./LexRuntimeServiceClient":"b0HTK","./commands":"drgSa","./models":false,"./models/LexRuntimeServiceServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b0HTK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceClient", ()=>LexRuntimeServiceClient);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LexRuntimeServiceClient = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceClient, _super);
    function LexRuntimeServiceClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LexRuntimeServiceClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LexRuntimeServiceClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","@aws-sdk/config-resolver":"gu4pD","@aws-sdk/middleware-content-length":"eL4Ub","@aws-sdk/middleware-host-header":"4bXMX","@aws-sdk/middleware-logger":"8erYw","@aws-sdk/middleware-recursion-detection":"l81JW","@aws-sdk/middleware-retry":"fR8xr","@aws-sdk/middleware-signing":"7a9MX","@aws-sdk/middleware-user-agent":"8E67h","@aws-sdk/smithy-client":"alQg0","./runtimeConfig":"d4LcD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gu4pD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"4TG5X","./regionConfig":"kbLZy","./regionInfo":"d3mg8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TG5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"cLap0","./NodeUseFipsEndpointConfigOptions":"53tgq","./resolveCustomEndpointsConfig":"3NaN5","./resolveEndpointsConfig":"7edTs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cLap0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", ()=>ENV_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", ()=>CONFIG_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", ()=>DEFAULT_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5vFvE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _booleanSelector = require("./booleanSelector");
parcelHelpers.exportAll(_booleanSelector, exports);

},{"./booleanSelector":"eS7UQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eS7UQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectorType", ()=>SelectorType);
parcelHelpers.export(exports, "booleanSelector", ()=>booleanSelector);
var SelectorType;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));
var booleanSelector = function(obj, key, type) {
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error("Cannot load ".concat(type, ' "').concat(key, '". Expected "true" or "false", got ').concat(obj[key], "."));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53tgq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", ()=>ENV_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", ()=>CONFIG_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", ()=>DEFAULT_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NaN5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", ()=>resolveCustomEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2OCR6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _normalizeProvider = require("./normalizeProvider");
parcelHelpers.exportAll(_normalizeProvider, exports);

},{"./normalizeProvider":"4nawr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4nawr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeProvider", ()=>normalizeProvider);
var normalizeProvider = function(input) {
    if (typeof input === "function") return input;
    var promisified = Promise.resolve(input);
    return function() {
        return promisified;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7edTs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./utils/getEndpointFromRegion":"5p6la","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5p6la":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", ()=>getEndpointFromRegion);
var _tslib = require("tslib");
var getEndpointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbLZy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"lRPbk","./resolveRegionConfig":"1DAGI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRPbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1DAGI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","./getRealRegion":"hmeUf","./isFipsRegion":"i8GPw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hmeUf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", ()=>getRealRegion);
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"i8GPw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8GPw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", ()=>isFipsRegion);
var isFipsRegion = function(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d3mg8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"2h6AU","./RegionHash":"2Dzri","./getRegionInfo":"i13YL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2h6AU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Dzri":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i13YL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", ()=>getRegionInfo);
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"86BcK","./getHostnameFromVariants":"b8j9C","./getResolvedHostname":"D627q","./getResolvedPartition":"4UESF","./getResolvedSigningRegion":"2YoOr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b8j9C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", ()=>getHostnameFromVariants);
var getHostnameFromVariants = function(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"D627q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", ()=>getResolvedHostname);
var getResolvedHostname = function(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4UESF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", ()=>getResolvedPartition);
var getResolvedPartition = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2YoOr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", ()=>getResolvedSigningRegion);
var getResolvedSigningRegion = function(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eL4Ub":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f8OeQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"joyjT","./httpRequest":"098yS","./httpResponse":"49uKQ","./isValidHostname":"dbHlq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"joyjT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"098yS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49uKQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dbHlq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4bXMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8erYw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"QyXV7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"QyXV7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l81JW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recursionDetectionMiddleware", ()=>recursionDetectionMiddleware);
parcelHelpers.export(exports, "addRecursionDetectionMiddlewareOptions", ()=>addRecursionDetectionMiddlewareOptions);
parcelHelpers.export(exports, "getRecursionDetectionPlugin", ()=>getRecursionDetectionPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var process = require("390cf85b5344aa6c");
var TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
var ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
var ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
var recursionDetectionMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, functionName, traceId, nonEmptyString;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if (!(0, _protocolHttp.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) return [
                        2,
                        next(args)
                    ];
                    functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
                    traceId = process.env[ENV_TRACE_ID];
                    nonEmptyString = function(str) {
                        return typeof str === "string" && str.length > 0;
                    };
                    if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[TRACE_ID_HEADER_NAME] = traceId;
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
};
var addRecursionDetectionMiddlewareOptions = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
var getRecursionDetectionPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
        }
    };
};

},{"390cf85b5344aa6c":"4avz9","tslib":"86BcK","@aws-sdk/protocol-http":"hsGX6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hsGX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"bm7sA","./httpRequest":"f2L6x","./httpResponse":"hJEi1","./isValidHostname":"5DUhf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bm7sA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f2L6x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hJEi1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5DUhf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fR8xr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"ehWwQ","./DefaultRateLimiter":"9kPux","./StandardRetryStrategy":"9mCQW","./config":"hHa0h","./configurations":"2xFBa","./delayDecider":"3iteg","./omitRetryHeadersMiddleware":"3cKz1","./retryDecider":"lwkK2","./retryMiddleware":"kjJyl","./types":"gplCd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ehWwQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", ()=>AdaptiveRetryStrategy);
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"86BcK","./config":"hHa0h","./DefaultRateLimiter":"9kPux","./StandardRetryStrategy":"9mCQW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hHa0h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", ()=>RETRY_MODES);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9kPux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", ()=>DefaultRateLimiter);
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"86BcK","@aws-sdk/service-error-classification":"iEb89","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iEb89":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"87rG2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"87rG2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", ()=>NODEJS_TIMEOUT_ERROR_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9mCQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/service-error-classification":"iEb89","uuid":"fAGzL","./config":"hHa0h","./constants":"6Pp0Q","./defaultRetryQuota":"47ztD","./delayDecider":"3iteg","./retryDecider":"lwkK2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fAGzL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"8Txxz","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Txxz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"kQQyd","./stringify.js":"kZ7bc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kQQyd":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kZ7bc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"aX8ct","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aX8ct":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3x2ZQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3x2ZQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Pp0Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47ztD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3iteg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwkK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"iEb89","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2xFBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./AdaptiveRetryStrategy":"ehWwQ","./config":"hHa0h","./StandardRetryStrategy":"9mCQW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3cKz1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./constants":"6Pp0Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kjJyl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gplCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a9MX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"lXM3t","./middleware":"b357s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lXM3t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
parcelHelpers.export(exports, "resolveSigV4AuthConfig", ()=>resolveSigV4AuthConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"dN7r8","@aws-sdk/signature-v4":"dPbM8","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dN7r8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"9CcJJ","./ProviderError":"cXkWn","./TokenProviderError":"lKMlk","./chain":"bhXFi","./fromStatic":"fshlJ","./memoize":"hwgWf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CcJJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cXkWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lKMlk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bhXFi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"cXkWn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fshlJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwgWf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dPbM8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>(0, _getCanonicalHeaders.getCanonicalHeaders));
parcelHelpers.export(exports, "getCanonicalQuery", ()=>(0, _getCanonicalQuery.getCanonicalQuery));
parcelHelpers.export(exports, "getPayloadHash", ()=>(0, _getPayloadHash.getPayloadHash));
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>(0, _moveHeadersToQuery.moveHeadersToQuery));
parcelHelpers.export(exports, "prepareRequest", ()=>(0, _prepareRequest.prepareRequest));
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"2c5Im","./getCanonicalHeaders":"glkhC","./getCanonicalQuery":"fBu4t","./getPayloadHash":"kbirI","./moveHeadersToQuery":"beRjG","./prepareRequest":"kXIRz","./credentialDerivation":"9Ay5s","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2c5Im":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"2LppL","@aws-sdk/util-middleware":"2OCR6","./constants":"kn99E","./credentialDerivation":"9Ay5s","./getCanonicalHeaders":"glkhC","./getCanonicalQuery":"fBu4t","./getPayloadHash":"kbirI","./headerUtil":"e1gG6","./moveHeadersToQuery":"beRjG","./prepareRequest":"kXIRz","./utilDate":"3FVMU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LppL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kn99E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", ()=>ALGORITHM_IDENTIFIER_V4A);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Ay5s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"2LppL","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"glkhC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"86BcK","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBu4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"gFLYo","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gFLYo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"4oTvF","./escape-uri-path":"7CXhJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4oTvF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7CXhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"4oTvF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbirI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/is-array-buffer":"fO0Lw","@aws-sdk/util-hex-encoding":"2LppL","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fO0Lw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e1gG6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
parcelHelpers.export(exports, "getHeaderValue", ()=>getHeaderValue);
parcelHelpers.export(exports, "deleteHeader", ()=>deleteHeader);
var _tslib = require("tslib");
var hasHeader = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"beRjG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"86BcK","./cloneRequest":"3k3gD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3k3gD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
parcelHelpers.export(exports, "cloneQuery", ()=>cloneQuery);
var _tslib = require("tslib");
var cloneRequest = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kXIRz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"86BcK","./cloneRequest":"3k3gD","./constants":"kn99E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3FVMU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
var iso8601 = function(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b357s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
parcelHelpers.export(exports, "getSigV4AuthPlugin", ()=>getSigV4AuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./utils/getSkewCorrectedDate":"518Bv","./utils/getUpdatedSystemClockOffset":"gLERW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"518Bv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gLERW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"6asaS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6asaS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"518Bv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8E67h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"dRbDD","./user-agent-middleware":"4Uklr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRbDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Uklr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","./constants":"9JZPR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JZPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"alQg0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"5rm7f","./command":"j5DTN","./constants":"gScML","./date-utils":"6obag","./default-error-handler":"bs7hr","./defaults-mode":"1ODvk","./emitWarningIfUnsupportedVersion":"dM5eG","./exceptions":"7a9Y9","./extended-encode-uri-component":"1E3WA","./get-array-if-single-item":"3C1eR","./get-value-from-text-node":"2whIO","./lazy-json":"2sD0L","./object-mapping":"7BD7s","./parse-utils":"8DCnR","./resolve-path":"16FIx","./ser-utils":"3CiOx","./split-every":"idSjo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rm7f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"3LtOU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LtOU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"2AYZg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2AYZg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j5DTN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"3LtOU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gScML":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6obag":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
parcelHelpers.export(exports, "parseRfc3339DateTime", ()=>parseRfc3339DateTime);
parcelHelpers.export(exports, "parseRfc7231DateTime", ()=>parseRfc7231DateTime);
parcelHelpers.export(exports, "parseEpochTimestamp", ()=>parseEpochTimestamp);
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"86BcK","./parse-utils":"8DCnR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8DCnR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", ()=>parseBoolean);
parcelHelpers.export(exports, "expectBoolean", ()=>expectBoolean);
parcelHelpers.export(exports, "expectNumber", ()=>expectNumber);
parcelHelpers.export(exports, "expectFloat32", ()=>expectFloat32);
parcelHelpers.export(exports, "expectLong", ()=>expectLong);
parcelHelpers.export(exports, "expectInt", ()=>expectInt);
parcelHelpers.export(exports, "expectInt32", ()=>expectInt32);
parcelHelpers.export(exports, "expectShort", ()=>expectShort);
parcelHelpers.export(exports, "expectByte", ()=>expectByte);
parcelHelpers.export(exports, "expectNonNull", ()=>expectNonNull);
parcelHelpers.export(exports, "expectObject", ()=>expectObject);
parcelHelpers.export(exports, "expectString", ()=>expectString);
parcelHelpers.export(exports, "expectUnion", ()=>expectUnion);
parcelHelpers.export(exports, "strictParseDouble", ()=>strictParseDouble);
parcelHelpers.export(exports, "strictParseFloat", ()=>strictParseFloat);
parcelHelpers.export(exports, "strictParseFloat32", ()=>strictParseFloat32);
parcelHelpers.export(exports, "limitedParseDouble", ()=>limitedParseDouble);
parcelHelpers.export(exports, "handleFloat", ()=>handleFloat);
parcelHelpers.export(exports, "limitedParseFloat", ()=>limitedParseFloat);
parcelHelpers.export(exports, "limitedParseFloat32", ()=>limitedParseFloat32);
parcelHelpers.export(exports, "strictParseLong", ()=>strictParseLong);
parcelHelpers.export(exports, "strictParseInt", ()=>strictParseInt);
parcelHelpers.export(exports, "strictParseInt32", ()=>strictParseInt32);
parcelHelpers.export(exports, "strictParseShort", ()=>strictParseShort);
parcelHelpers.export(exports, "strictParseByte", ()=>strictParseByte);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var parseBoolean = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error('Unable to parse boolean value "'.concat(value, '"'));
    }
};
var expectBoolean = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value, ": ").concat(value));
};
var expectNumber = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value, ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var expectUnion = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bs7hr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", ()=>throwDefaultError);
var _exceptions = require("./exceptions");
var throwDefaultError = function(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"7a9Y9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a9Y9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", ()=>ServiceException);
parcelHelpers.export(exports, "decorateServiceException", ()=>decorateServiceException);
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ODvk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", ()=>loadConfigsForDefaultMode);
var loadConfigsForDefaultMode = function(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dM5eG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", ()=>emitWarningIfUnsupportedVersion);
var process = require("829cfc0ffb172e56");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"829cfc0ffb172e56":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1E3WA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3C1eR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2whIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sD0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7BD7s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "convertMap", ()=>convertMap);
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"16FIx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", ()=>resolvedPath);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function(resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

},{"./extended-encode-uri-component":"1E3WA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3CiOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", ()=>serializeFloat);
var serializeFloat = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"idSjo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4LcD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"86BcK","../package.json":"c5v9L","@aws-crypto/sha256-browser":"lGVg4","@aws-sdk/config-resolver":"gu4pD","@aws-sdk/fetch-http-handler":"aYKXX","@aws-sdk/invalid-dependency":"6Zzfj","@aws-sdk/middleware-retry":"fR8xr","@aws-sdk/util-base64-browser":"cXiT2","@aws-sdk/util-body-length-browser":"gnPhH","@aws-sdk/util-user-agent-browser":"adKTH","@aws-sdk/util-utf8-browser":"3N6ZC","./runtimeConfig.shared":"i9C8V","@aws-sdk/smithy-client":"alQg0","@aws-sdk/util-defaults-mode-browser":"gpbLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5v9L":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-lex-runtime-service","description":"AWS SDK for JavaScript Lex Runtime Service Client for Node.js, Browser and React Native","version":"3.186.3","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo","test":"yarn test:unit","test:unit":"ts-mocha test/**/*.spec.ts"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.186.3","@aws-sdk/config-resolver":"3.186.0","@aws-sdk/credential-provider-node":"3.186.0","@aws-sdk/fetch-http-handler":"3.186.0","@aws-sdk/hash-node":"3.186.0","@aws-sdk/invalid-dependency":"3.186.0","@aws-sdk/middleware-content-length":"3.186.0","@aws-sdk/middleware-host-header":"3.186.0","@aws-sdk/middleware-logger":"3.186.0","@aws-sdk/middleware-recursion-detection":"3.186.0","@aws-sdk/middleware-retry":"3.186.0","@aws-sdk/middleware-serde":"3.186.0","@aws-sdk/middleware-signing":"3.186.0","@aws-sdk/middleware-stack":"3.186.0","@aws-sdk/middleware-user-agent":"3.186.0","@aws-sdk/node-config-provider":"3.186.0","@aws-sdk/node-http-handler":"3.186.0","@aws-sdk/protocol-http":"3.186.0","@aws-sdk/smithy-client":"3.186.0","@aws-sdk/types":"3.186.0","@aws-sdk/url-parser":"3.186.0","@aws-sdk/util-base64-browser":"3.186.0","@aws-sdk/util-base64-node":"3.186.0","@aws-sdk/util-body-length-browser":"3.186.0","@aws-sdk/util-body-length-node":"3.186.0","@aws-sdk/util-defaults-mode-browser":"3.186.0","@aws-sdk/util-defaults-mode-node":"3.186.0","@aws-sdk/util-user-agent-browser":"3.186.0","@aws-sdk/util-user-agent-node":"3.186.0","@aws-sdk/util-utf8-browser":"3.186.0","@aws-sdk/util-utf8-node":"3.186.0","tslib":"^2.3.1"},"devDependencies":{"@aws-sdk/service-client-documentation-generator":"3.186.0","@tsconfig/recommended":"1.0.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.6.2"},"overrides":{"typedoc":{"typescript":"~4.6.2"}},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-lex-runtime-service","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-lex-runtime-service"}}');

},{}],"lGVg4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("d869f679f32f407d");
(0, tslib_1.__exportStar)(require("b0f537c8404fabe7"), exports);
var ie11Sha256_1 = require("ce93437bcebd91ab");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("68cca9e6fee69adf");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"d869f679f32f407d":"f3j8T","b0f537c8404fabe7":"2Z80W","ce93437bcebd91ab":"8M3DA","68cca9e6fee69adf":"kgHl2"}],"f3j8T":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Z80W":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("453cd7d5fb36332a");
var webCryptoSha256_1 = require("ef4321517786adfd");
var sha256_js_1 = require("e69e134258c464b3");
var supports_web_crypto_1 = require("f6560285c113a981");
var ie11_detection_1 = require("7008797b0496e8b2");
var util_locate_window_1 = require("4579f58fc373ace9");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"453cd7d5fb36332a":"8M3DA","ef4321517786adfd":"kgHl2","e69e134258c464b3":"iDAqR","f6560285c113a981":"gGrlG","7008797b0496e8b2":"aTIbG","4579f58fc373ace9":"ljvil"}],"8M3DA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("bf6d3fc2e60ba76d");
var constants_1 = require("b87616627cf2e0f5");
var util_utf8_browser_1 = require("f850988d1d541c92");
var util_locate_window_1 = require("e2bdadc602eaf4f6");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"bf6d3fc2e60ba76d":"a2Ugv","b87616627cf2e0f5":"32UPK","f850988d1d541c92":"3N6ZC","e2bdadc602eaf4f6":"ljvil"}],"a2Ugv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"32UPK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"3N6ZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"doi3l","./whatwgEncodingApi":"lCpEM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"doi3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lCpEM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kgHl2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("43a5977a498abeed");
var constants_1 = require("c3ed919bd9996f19");
var util_locate_window_1 = require("c35752418ef0f254");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"43a5977a498abeed":"8fK1S","c3ed919bd9996f19":"32UPK","c35752418ef0f254":"ljvil"}],"8fK1S":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("9193df0db021fb26");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("459998af8963a091");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("b42a68361f012efb");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("b7e6168de801e09f");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"9193df0db021fb26":"dniPO","459998af8963a091":"9nkeM","b42a68361f012efb":"fykUp","b7e6168de801e09f":"gl7iq"}],"dniPO":[function(require,module,exports) {
var Buffer = require("721a4c132673e957").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f3d90b8be1dc9038");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"721a4c132673e957":"cvSE8","f3d90b8be1dc9038":"3N6ZC"}],"9nkeM":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"fykUp":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"gl7iq":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"iDAqR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("418d1b4dc54207be");
(0, tslib_1.__exportStar)(require("6982378e65309145"), exports);

},{"418d1b4dc54207be":"j1GTA","6982378e65309145":"eEURr"}],"j1GTA":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eEURr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("ab77c912e1099c27");
var constants_1 = require("ce9cc4978892bad6");
var RawSha256_1 = require("ea4a3f6061c5aada");
var util_1 = require("ec7e02f81b214b94");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"ab77c912e1099c27":"j1GTA","ce9cc4978892bad6":"gXt9h","ea4a3f6061c5aada":"kcc1i","ec7e02f81b214b94":"8fK1S"}],"gXt9h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"kcc1i":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("36bcd02814e436e3");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"36bcd02814e436e3":"gXt9h"}],"gGrlG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("d4ba5b9f002454df");
tslib_1.__exportStar(require("42b6a840a4585dcd"), exports);

},{"d4ba5b9f002454df":"gF2FI","42b6a840a4585dcd":"aqGWG"}],"gF2FI":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aqGWG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("467da325f4507076");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"467da325f4507076":"gF2FI"}],"aTIbG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("4e93ca2400d71317");
tslib_1.__exportStar(require("f6df223ac5240f29"), exports);
tslib_1.__exportStar(require("c68313cfb7180b41"), exports);
tslib_1.__exportStar(require("46c26437e48ef7b3"), exports);
tslib_1.__exportStar(require("903a910efecb3acb"), exports);
tslib_1.__exportStar(require("bea87aa20e4b99bd"), exports);

},{"4e93ca2400d71317":"hmuDU","f6df223ac5240f29":"bdF35","c68313cfb7180b41":"8SweG","46c26437e48ef7b3":"76wxZ","903a910efecb3acb":"3xdwY","bea87aa20e4b99bd":"1Ty8Q"}],"hmuDU":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bdF35":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"8SweG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"76wxZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"3xdwY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1Ty8Q":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"aYKXX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"dGqow","./stream-collector":"m8aaR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGqow":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/querystring-builder":"dxT9Q","./request-timeout":"4Ne3U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dxT9Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"gFLYo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Ne3U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"m8aaR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"86BcK","@aws-sdk/util-base64-browser":"cXiT2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cXiT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Zzfj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"4keLO","./invalidProvider":"2UYGf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4keLO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2UYGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gnPhH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"drduY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drduY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
var calculateBodyLength = function(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"adKTH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"86BcK","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9C8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2016-11-28",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Lex Runtime Service",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"9rmyt","./endpoints":"hwk60","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9rmyt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    if (typeof url === "string") return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"9eFh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eFh1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hwk60":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {
    "us-east-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-east-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-gov-west-1": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-gov-west-1.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "us-west-2": {
        variants: [
            {
                hostname: "runtime-fips.lex.us-west-2.amazonaws.com",
                tags: [
                    "fips"
                ]
            }
        ]
    }
};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-1-fips",
            "us-east-2",
            "us-west-1",
            "us-west-2",
            "us-west-2-fips"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "runtime.lex-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1",
            "us-gov-west-1-fips"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "runtime.lex.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "runtime-fips.lex.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "runtime.lex.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "lex",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/config-resolver":"gu4pD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gpbLI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resolveDefaultsModeConfig = require("./resolveDefaultsModeConfig");
parcelHelpers.exportAll(_resolveDefaultsModeConfig, exports);

},{"./resolveDefaultsModeConfig":"br1ph","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"br1ph":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveDefaultsModeConfig", ()=>resolveDefaultsModeConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var _constants = require("./constants");
var resolveDefaultsModeConfig = function(_a) {
    var _b = _a === void 0 ? {} : _a, defaultsMode = _b.defaultsMode;
    return (0, _propertyProvider.memoize)(function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var mode, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof defaultsMode === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            defaultsMode()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _a = defaultsMode;
                        _b.label = 3;
                    case 3:
                        mode = _a;
                        switch(mode === null || mode === void 0 ? void 0 : mode.toLowerCase()){
                            case "auto":
                                return [
                                    2,
                                    Promise.resolve(isMobileBrowser() ? "mobile" : "standard")
                                ];
                            case "mobile":
                            case "in-region":
                            case "cross-region":
                            case "standard":
                            case "legacy":
                                return [
                                    2,
                                    Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase())
                                ];
                            case undefined:
                                return [
                                    2,
                                    Promise.resolve("legacy")
                                ];
                            default:
                                throw new Error('Invalid parameter for "defaultsMode", expect '.concat((0, _constants.DEFAULTS_MODE_OPTIONS).join(", "), ", got ").concat(mode));
                        }
                        return [
                            2
                        ];
                }
            });
        });
    });
};
var isMobileBrowser = function() {
    var _a, _b;
    var parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
    var platform = (_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.platform) === null || _b === void 0 ? void 0 : _b.type;
    return platform === "tablet" || platform === "mobile";
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"a0t3P","bowser":"E5jm7","./constants":"fclGj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0t3P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"Lil5i","./ProviderError":"6d2lg","./TokenProviderError":"dp0z4","./chain":"bnGGl","./fromStatic":"8Iwth","./memoize":"dfFCm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Lil5i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6d2lg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dp0z4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bnGGl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"6d2lg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Iwth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dfFCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fclGj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULTS_MODE_OPTIONS", ()=>DEFAULTS_MODE_OPTIONS);
var DEFAULTS_MODE_OPTIONS = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drgSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deleteSessionCommand = require("./DeleteSessionCommand");
parcelHelpers.exportAll(_deleteSessionCommand, exports);
var _getSessionCommand = require("./GetSessionCommand");
parcelHelpers.exportAll(_getSessionCommand, exports);
var _postContentCommand = require("./PostContentCommand");
parcelHelpers.exportAll(_postContentCommand, exports);
var _postTextCommand = require("./PostTextCommand");
parcelHelpers.exportAll(_postTextCommand, exports);
var _putSessionCommand = require("./PutSessionCommand");
parcelHelpers.exportAll(_putSessionCommand, exports);

},{"./DeleteSessionCommand":false,"./GetSessionCommand":false,"./PostContentCommand":"hVNkY","./PostTextCommand":"2kixx","./PutSessionCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hVNkY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostContentCommand", ()=>PostContentCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostContentCommand = function(_super) {
    (0, _tslib.__extends)(PostContentCommand, _super);
    function PostContentCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostContentCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostContentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostContentRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostContentResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostContentCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostContentCommand)(input, context);
    };
    PostContentCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostContentCommand)(output, context);
    };
    return PostContentCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"8ZTRr","@aws-sdk/smithy-client":"alQg0","../models/models_0":"l9pMX","../protocols/Aws_restJson1":"esFav","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ZTRr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"5RECM","./serdePlugin":"136kt","./serializerMiddleware":"gMbhA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RECM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"136kt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"5RECM","./serializerMiddleware":"gMbhA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMbhA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9pMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadRequestException", ()=>BadRequestException);
parcelHelpers.export(exports, "ConflictException", ()=>ConflictException);
parcelHelpers.export(exports, "InternalFailureException", ()=>InternalFailureException);
parcelHelpers.export(exports, "LimitExceededException", ()=>LimitExceededException);
parcelHelpers.export(exports, "NotFoundException", ()=>NotFoundException);
parcelHelpers.export(exports, "FulfillmentState", ()=>FulfillmentState);
parcelHelpers.export(exports, "MessageFormatType", ()=>MessageFormatType);
parcelHelpers.export(exports, "DialogActionType", ()=>DialogActionType);
parcelHelpers.export(exports, "ConfirmationStatus", ()=>ConfirmationStatus);
parcelHelpers.export(exports, "BadGatewayException", ()=>BadGatewayException);
parcelHelpers.export(exports, "DependencyFailedException", ()=>DependencyFailedException);
parcelHelpers.export(exports, "LoopDetectedException", ()=>LoopDetectedException);
parcelHelpers.export(exports, "NotAcceptableException", ()=>NotAcceptableException);
parcelHelpers.export(exports, "DialogState", ()=>DialogState);
parcelHelpers.export(exports, "RequestTimeoutException", ()=>RequestTimeoutException);
parcelHelpers.export(exports, "UnsupportedMediaTypeException", ()=>UnsupportedMediaTypeException);
parcelHelpers.export(exports, "ContentType", ()=>ContentType);
parcelHelpers.export(exports, "ActiveContextTimeToLiveFilterSensitiveLog", ()=>ActiveContextTimeToLiveFilterSensitiveLog);
parcelHelpers.export(exports, "ActiveContextFilterSensitiveLog", ()=>ActiveContextFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteSessionRequestFilterSensitiveLog", ()=>DeleteSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteSessionResponseFilterSensitiveLog", ()=>DeleteSessionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetSessionRequestFilterSensitiveLog", ()=>GetSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DialogActionFilterSensitiveLog", ()=>DialogActionFilterSensitiveLog);
parcelHelpers.export(exports, "IntentSummaryFilterSensitiveLog", ()=>IntentSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "GetSessionResponseFilterSensitiveLog", ()=>GetSessionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostContentRequestFilterSensitiveLog", ()=>PostContentRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PostContentResponseFilterSensitiveLog", ()=>PostContentResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostTextRequestFilterSensitiveLog", ()=>PostTextRequestFilterSensitiveLog);
parcelHelpers.export(exports, "IntentConfidenceFilterSensitiveLog", ()=>IntentConfidenceFilterSensitiveLog);
parcelHelpers.export(exports, "PredictedIntentFilterSensitiveLog", ()=>PredictedIntentFilterSensitiveLog);
parcelHelpers.export(exports, "ButtonFilterSensitiveLog", ()=>ButtonFilterSensitiveLog);
parcelHelpers.export(exports, "GenericAttachmentFilterSensitiveLog", ()=>GenericAttachmentFilterSensitiveLog);
parcelHelpers.export(exports, "ResponseCardFilterSensitiveLog", ()=>ResponseCardFilterSensitiveLog);
parcelHelpers.export(exports, "SentimentResponseFilterSensitiveLog", ()=>SentimentResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PostTextResponseFilterSensitiveLog", ()=>PostTextResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PutSessionRequestFilterSensitiveLog", ()=>PutSessionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PutSessionResponseFilterSensitiveLog", ()=>PutSessionResponseFilterSensitiveLog);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("./LexRuntimeServiceServiceException");
var BadRequestException = function(_super) {
    (0, _tslib.__extends)(BadRequestException, _super);
    function BadRequestException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadRequestException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "BadRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BadRequestException.prototype);
        return _this;
    }
    return BadRequestException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        return _this;
    }
    return ConflictException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var InternalFailureException = function(_super) {
    (0, _tslib.__extends)(InternalFailureException, _super);
    function InternalFailureException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalFailureException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalFailureException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalFailureException.prototype);
        return _this;
    }
    return InternalFailureException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LimitExceededException = function(_super) {
    (0, _tslib.__extends)(LimitExceededException, _super);
    function LimitExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LimitExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "LimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, LimitExceededException.prototype);
        _this.retryAfterSeconds = opts.retryAfterSeconds;
        return _this;
    }
    return LimitExceededException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotFoundException = function(_super) {
    (0, _tslib.__extends)(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        return _this;
    }
    return NotFoundException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var FulfillmentState;
(function(FulfillmentState) {
    FulfillmentState["FAILED"] = "Failed";
    FulfillmentState["FULFILLED"] = "Fulfilled";
    FulfillmentState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(FulfillmentState || (FulfillmentState = {}));
var MessageFormatType;
(function(MessageFormatType) {
    MessageFormatType["COMPOSITE"] = "Composite";
    MessageFormatType["CUSTOM_PAYLOAD"] = "CustomPayload";
    MessageFormatType["PLAIN_TEXT"] = "PlainText";
    MessageFormatType["SSML"] = "SSML";
})(MessageFormatType || (MessageFormatType = {}));
var DialogActionType;
(function(DialogActionType) {
    DialogActionType["CLOSE"] = "Close";
    DialogActionType["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogActionType["DELEGATE"] = "Delegate";
    DialogActionType["ELICIT_INTENT"] = "ElicitIntent";
    DialogActionType["ELICIT_SLOT"] = "ElicitSlot";
})(DialogActionType || (DialogActionType = {}));
var ConfirmationStatus;
(function(ConfirmationStatus) {
    ConfirmationStatus["CONFIRMED"] = "Confirmed";
    ConfirmationStatus["DENIED"] = "Denied";
    ConfirmationStatus["NONE"] = "None";
})(ConfirmationStatus || (ConfirmationStatus = {}));
var BadGatewayException = function(_super) {
    (0, _tslib.__extends)(BadGatewayException, _super);
    function BadGatewayException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "BadGatewayException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "BadGatewayException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, BadGatewayException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return BadGatewayException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DependencyFailedException = function(_super) {
    (0, _tslib.__extends)(DependencyFailedException, _super);
    function DependencyFailedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "DependencyFailedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "DependencyFailedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, DependencyFailedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return DependencyFailedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var LoopDetectedException = function(_super) {
    (0, _tslib.__extends)(LoopDetectedException, _super);
    function LoopDetectedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "LoopDetectedException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "LoopDetectedException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, LoopDetectedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return LoopDetectedException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var NotAcceptableException = function(_super) {
    (0, _tslib.__extends)(NotAcceptableException, _super);
    function NotAcceptableException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "NotAcceptableException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "NotAcceptableException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotAcceptableException.prototype);
        return _this;
    }
    return NotAcceptableException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var DialogState;
(function(DialogState) {
    DialogState["CONFIRM_INTENT"] = "ConfirmIntent";
    DialogState["ELICIT_INTENT"] = "ElicitIntent";
    DialogState["ELICIT_SLOT"] = "ElicitSlot";
    DialogState["FAILED"] = "Failed";
    DialogState["FULFILLED"] = "Fulfilled";
    DialogState["READY_FOR_FULFILLMENT"] = "ReadyForFulfillment";
})(DialogState || (DialogState = {}));
var RequestTimeoutException = function(_super) {
    (0, _tslib.__extends)(RequestTimeoutException, _super);
    function RequestTimeoutException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "RequestTimeoutException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "RequestTimeoutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, RequestTimeoutException.prototype);
        return _this;
    }
    return RequestTimeoutException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var UnsupportedMediaTypeException = function(_super) {
    (0, _tslib.__extends)(UnsupportedMediaTypeException, _super);
    function UnsupportedMediaTypeException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "UnsupportedMediaTypeException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "UnsupportedMediaTypeException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UnsupportedMediaTypeException.prototype);
        return _this;
    }
    return UnsupportedMediaTypeException;
}((0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException));
var ContentType;
(function(ContentType) {
    ContentType["GENERIC"] = "application/vnd.amazonaws.card.generic";
})(ContentType || (ContentType = {}));
var ActiveContextTimeToLiveFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ActiveContextFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.parameters && {
        parameters: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var DeleteSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DialogActionFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostContentResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedInputTranscript && {
        encodedInputTranscript: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PostTextRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.requestAttributes && {
        requestAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.inputText && {
        inputText: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var IntentConfidenceFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PredictedIntentFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ButtonFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GenericAttachmentFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ResponseCardFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SentimentResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PostTextResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.alternativeIntents && {
        alternativeIntents: obj.alternativeIntents.map(function(item) {
            return PredictedIntentFilterSensitiveLog(item);
        })
    }), obj.slots && {
        slots: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.sessionAttributes && {
        sessionAttributes: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.dialogAction && {
        dialogAction: DialogActionFilterSensitiveLog(obj.dialogAction)
    }), obj.recentIntentSummaryView && {
        recentIntentSummaryView: obj.recentIntentSummaryView.map(function(item) {
            return IntentSummaryFilterSensitiveLog(item);
        })
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var PutSessionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.message && {
        message: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.encodedMessage && {
        encodedMessage: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.activeContexts && {
        activeContexts: (0, _smithyClient.SENSITIVE_STRING)
    });
};

},{"tslib":"86BcK","@aws-sdk/smithy-client":"alQg0","./LexRuntimeServiceServiceException":"1vMJc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1vMJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LexRuntimeServiceServiceException", ()=>LexRuntimeServiceServiceException);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LexRuntimeServiceServiceException = function(_super) {
    (0, _tslib.__extends)(LexRuntimeServiceServiceException, _super);
    function LexRuntimeServiceServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LexRuntimeServiceServiceException.prototype);
        return _this;
    }
    return LexRuntimeServiceServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"alQg0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"esFav":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteSessionCommand", ()=>serializeAws_restJson1DeleteSessionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetSessionCommand", ()=>serializeAws_restJson1GetSessionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PostContentCommand", ()=>serializeAws_restJson1PostContentCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PostTextCommand", ()=>serializeAws_restJson1PostTextCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutSessionCommand", ()=>serializeAws_restJson1PutSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteSessionCommand", ()=>deserializeAws_restJson1DeleteSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetSessionCommand", ()=>deserializeAws_restJson1GetSessionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PostContentCommand", ()=>deserializeAws_restJson1PostContentCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PostTextCommand", ()=>deserializeAws_restJson1PostTextCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutSessionCommand", ()=>deserializeAws_restJson1PutSessionCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _lexRuntimeServiceServiceException = require("../models/LexRuntimeServiceServiceException");
var _models0 = require("../models/models_0");
var Buffer = require("140ff1ec17a71939").Buffer;
var serializeAws_restJson1DeleteSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    query = map({
                        checkpointLabelFilter: [
                            ,
                            input.checkpointLabelFilter
                        ]
                    });
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostContentCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
                        "content-type": input.contentType || "application/octet-stream",
                        "x-amz-lex-session-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.sessionAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.sessionAttributes)));
                            }
                        ],
                        "x-amz-lex-request-attributes": [
                            function() {
                                return isSerializableHeaderValue(input.requestAttributes);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.requestAttributes)));
                            }
                        ],
                        accept: input.accept,
                        "x-amz-lex-active-contexts": [
                            function() {
                                return isSerializableHeaderValue(input.activeContexts);
                            },
                            function() {
                                return context.base64Encoder(Buffer.from((0, _smithyClient.LazyJsonString).fromObject(input.activeContexts)));
                            }
                        ]
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/content";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    if (input.inputStream !== undefined) body = input.inputStream;
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PostTextCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.inputText != null && {
                        inputText: input.inputText
                    }), input.requestAttributes != null && {
                        requestAttributes: serializeAws_restJson1StringMap(input.requestAttributes, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutSessionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = map({}, isSerializableHeaderValue, {
                        "content-type": "application/json",
                        accept: input.accept
                    });
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/bot/{botName}/alias/{botAlias}/user/{userId}/session";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botName", function() {
                        return input.botName;
                    }, "{botName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "botAlias", function() {
                        return input.botAlias;
                    }, "{botAlias}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "userId", function() {
                        return input.userId;
                    }, "{userId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.activeContexts != null && {
                        activeContexts: serializeAws_restJson1ActiveContextsList(input.activeContexts, context)
                    }), input.dialogAction != null && {
                        dialogAction: serializeAws_restJson1DialogAction(input.dialogAction, context)
                    }), input.recentIntentSummaryView != null && {
                        recentIntentSummaryView: serializeAws_restJson1IntentSummaryList(input.recentIntentSummaryView, context)
                    }), input.sessionAttributes != null && {
                        sessionAttributes: serializeAws_restJson1StringMap(input.sessionAttributes, context)
                    }));
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: hostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.botAlias != null) contents.botAlias = (0, _smithyClient.expectString)(data.botAlias);
                    if (data.botName != null) contents.botName = (0, _smithyClient.expectString)(data.botName);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.userId != null) contents.userId = (0, _smithyClient.expectString)(data.userId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                6
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                8
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetSessionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.dialogAction != null) contents.dialogAction = deserializeAws_restJson1DialogAction(data.dialogAction, context);
                    if (data.recentIntentSummaryView != null) contents.recentIntentSummaryView = deserializeAws_restJson1IntentSummaryList(data.recentIntentSummaryView, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                2
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                4
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                6
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostContentCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PostContentCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                nluIntentConfidence: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-nlu-intent-confidence"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-nlu-intent-confidence"])).toString("utf8"));
                    }
                ],
                alternativeIntents: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-alternative-intents"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-alternative-intents"])).toString("utf8"));
                    }
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                sentimentResponse: [
                    ,
                    output.headers["x-amz-lex-sentiment"]
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                inputTranscript: [
                    ,
                    output.headers["x-amz-lex-input-transcript"]
                ],
                encodedInputTranscript: [
                    ,
                    output.headers["x-amz-lex-encoded-input-transcript"]
                ],
                botVersion: [
                    ,
                    output.headers["x-amz-lex-bot-version"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PostContentCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                16
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                18
                            ];
                        case "RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "com.amazonaws.lexruntimeservice#RequestTimeoutException":
                            return [
                                3,
                                20
                            ];
                        case "UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                        case "com.amazonaws.lexruntimeservice#UnsupportedMediaTypeException":
                            return [
                                3,
                                22
                            ];
                    }
                    return [
                        3,
                        24
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 19:
                    throw _d.sent();
                case 20:
                    return [
                        4,
                        deserializeAws_restJson1RequestTimeoutExceptionResponse(parsedOutput, context)
                    ];
                case 21:
                    throw _d.sent();
                case 22:
                    return [
                        4,
                        deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse(parsedOutput, context)
                    ];
                case 23:
                    throw _d.sent();
                case 24:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 25;
                case 25:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PostTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.activeContexts != null) contents.activeContexts = deserializeAws_restJson1ActiveContextsList(data.activeContexts, context);
                    if (data.alternativeIntents != null) contents.alternativeIntents = deserializeAws_restJson1IntentList(data.alternativeIntents, context);
                    if (data.botVersion != null) contents.botVersion = (0, _smithyClient.expectString)(data.botVersion);
                    if (data.dialogState != null) contents.dialogState = (0, _smithyClient.expectString)(data.dialogState);
                    if (data.intentName != null) contents.intentName = (0, _smithyClient.expectString)(data.intentName);
                    if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
                    if (data.messageFormat != null) contents.messageFormat = (0, _smithyClient.expectString)(data.messageFormat);
                    if (data.nluIntentConfidence != null) contents.nluIntentConfidence = deserializeAws_restJson1IntentConfidence(data.nluIntentConfidence, context);
                    if (data.responseCard != null) contents.responseCard = deserializeAws_restJson1ResponseCard(data.responseCard, context);
                    if (data.sentimentResponse != null) contents.sentimentResponse = deserializeAws_restJson1SentimentResponse(data.sentimentResponse, context);
                    if (data.sessionAttributes != null) contents.sessionAttributes = deserializeAws_restJson1StringMap(data.sessionAttributes, context);
                    if (data.sessionId != null) contents.sessionId = (0, _smithyClient.expectString)(data.sessionId);
                    if (data.slotToElicit != null) contents.slotToElicit = (0, _smithyClient.expectString)(data.slotToElicit);
                    if (data.slots != null) contents.slots = deserializeAws_restJson1StringMap(data.slots, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PostTextCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#LoopDetectedException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1LoopDetectedExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutSessionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            if (output.statusCode !== 200 && output.statusCode >= 300) return [
                2,
                deserializeAws_restJson1PutSessionCommandError(output, context)
            ];
            contents = map({
                $metadata: deserializeMetadata(output),
                contentType: [
                    ,
                    output.headers["content-type"]
                ],
                intentName: [
                    ,
                    output.headers["x-amz-lex-intent-name"]
                ],
                slots: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-slots"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-slots"])).toString("utf8"));
                    }
                ],
                sessionAttributes: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-session-attributes"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-session-attributes"])).toString("utf8"));
                    }
                ],
                message: [
                    ,
                    output.headers["x-amz-lex-message"]
                ],
                encodedMessage: [
                    ,
                    output.headers["x-amz-lex-encoded-message"]
                ],
                messageFormat: [
                    ,
                    output.headers["x-amz-lex-message-format"]
                ],
                dialogState: [
                    ,
                    output.headers["x-amz-lex-dialog-state"]
                ],
                slotToElicit: [
                    ,
                    output.headers["x-amz-lex-slot-to-elicit"]
                ],
                sessionId: [
                    ,
                    output.headers["x-amz-lex-session-id"]
                ],
                activeContexts: [
                    function() {
                        return void 0 !== output.headers["x-amz-lex-active-contexts"];
                    },
                    function() {
                        return new (0, _smithyClient.LazyJsonString)(Buffer.from(context.base64Decoder(output.headers["x-amz-lex-active-contexts"])).toString("utf8"));
                    }
                ]
            });
            data = output.body;
            contents.audioStream = data;
            return [
                2,
                contents
            ];
        });
    });
};
var deserializeAws_restJson1PutSessionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.lexruntimeservice#BadGatewayException":
                            return [
                                3,
                                2
                            ];
                        case "BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.lexruntimeservice#BadRequestException":
                            return [
                                3,
                                4
                            ];
                        case "ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.lexruntimeservice#ConflictException":
                            return [
                                3,
                                6
                            ];
                        case "DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.lexruntimeservice#DependencyFailedException":
                            return [
                                3,
                                8
                            ];
                        case "InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.lexruntimeservice#InternalFailureException":
                            return [
                                3,
                                10
                            ];
                        case "LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.lexruntimeservice#LimitExceededException":
                            return [
                                3,
                                12
                            ];
                        case "NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.lexruntimeservice#NotAcceptableException":
                            return [
                                3,
                                14
                            ];
                        case "NotFoundException":
                            return [
                                3,
                                16
                            ];
                        case "com.amazonaws.lexruntimeservice#NotFoundException":
                            return [
                                3,
                                16
                            ];
                    }
                    return [
                        3,
                        18
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1BadGatewayExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1DependencyFailedExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1InternalFailureExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1LimitExceededExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1NotAcceptableExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    return [
                        4,
                        deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 17:
                    throw _d.sent();
                case 18:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _lexRuntimeServiceServiceException.LexRuntimeServiceServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 19;
                case 19:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1BadGatewayExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.BadGatewayException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1BadRequestExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.BadRequestException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1DependencyFailedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.DependencyFailedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalFailureExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalFailureException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LimitExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({
                retryAfterSeconds: [
                    ,
                    parsedOutput.headers["retry-after"]
                ]
            });
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.LimitExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1LoopDetectedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.Message != null) contents.Message = (0, _smithyClient.expectString)(data.Message);
            exception = new (0, _models0.LoopDetectedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotAcceptableExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotAcceptableException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1NotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.NotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1RequestTimeoutExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.RequestTimeoutException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1UnsupportedMediaTypeExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.UnsupportedMediaTypeException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1ActiveContext = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.name != null && {
        name: input.name
    }), input.parameters != null && {
        parameters: serializeAws_restJson1ActiveContextParametersMap(input.parameters, context)
    }), input.timeToLive != null && {
        timeToLive: serializeAws_restJson1ActiveContextTimeToLive(input.timeToLive, context)
    });
};
var serializeAws_restJson1ActiveContextParametersMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1ActiveContextsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1ActiveContext(entry, context);
    });
};
var serializeAws_restJson1ActiveContextTimeToLive = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.timeToLiveInSeconds != null && {
        timeToLiveInSeconds: input.timeToLiveInSeconds
    }), input.turnsToLive != null && {
        turnsToLive: input.turnsToLive
    });
};
var serializeAws_restJson1DialogAction = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.message != null && {
        message: input.message
    }), input.messageFormat != null && {
        messageFormat: input.messageFormat
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    }), input.type != null && {
        type: input.type
    });
};
var serializeAws_restJson1IntentSummary = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.checkpointLabel != null && {
        checkpointLabel: input.checkpointLabel
    }), input.confirmationStatus != null && {
        confirmationStatus: input.confirmationStatus
    }), input.dialogActionType != null && {
        dialogActionType: input.dialogActionType
    }), input.fulfillmentState != null && {
        fulfillmentState: input.fulfillmentState
    }), input.intentName != null && {
        intentName: input.intentName
    }), input.slotToElicit != null && {
        slotToElicit: input.slotToElicit
    }), input.slots != null && {
        slots: serializeAws_restJson1StringMap(input.slots, context)
    });
};
var serializeAws_restJson1IntentSummaryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1IntentSummary(entry, context);
    });
};
var serializeAws_restJson1StringMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_restJson1ActiveContext = function(output, context) {
    return {
        name: (0, _smithyClient.expectString)(output.name),
        parameters: output.parameters != null ? deserializeAws_restJson1ActiveContextParametersMap(output.parameters, context) : undefined,
        timeToLive: output.timeToLive != null ? deserializeAws_restJson1ActiveContextTimeToLive(output.timeToLive, context) : undefined
    };
};
var deserializeAws_restJson1ActiveContextParametersMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1ActiveContextsList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ActiveContext(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ActiveContextTimeToLive = function(output, context) {
    return {
        timeToLiveInSeconds: (0, _smithyClient.expectInt32)(output.timeToLiveInSeconds),
        turnsToLive: (0, _smithyClient.expectInt32)(output.turnsToLive)
    };
};
var deserializeAws_restJson1Button = function(output, context) {
    return {
        text: (0, _smithyClient.expectString)(output.text),
        value: (0, _smithyClient.expectString)(output.value)
    };
};
var deserializeAws_restJson1DialogAction = function(output, context) {
    return {
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        message: (0, _smithyClient.expectString)(output.message),
        messageFormat: (0, _smithyClient.expectString)(output.messageFormat),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined,
        type: (0, _smithyClient.expectString)(output.type)
    };
};
var deserializeAws_restJson1GenericAttachment = function(output, context) {
    return {
        attachmentLinkUrl: (0, _smithyClient.expectString)(output.attachmentLinkUrl),
        buttons: output.buttons != null ? deserializeAws_restJson1listOfButtons(output.buttons, context) : undefined,
        imageUrl: (0, _smithyClient.expectString)(output.imageUrl),
        subTitle: (0, _smithyClient.expectString)(output.subTitle),
        title: (0, _smithyClient.expectString)(output.title)
    };
};
var deserializeAws_restJson1genericAttachmentList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1GenericAttachment(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentConfidence = function(output, context) {
    return {
        score: (0, _smithyClient.limitedParseDouble)(output.score)
    };
};
var deserializeAws_restJson1IntentList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1PredictedIntent(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1IntentSummary = function(output, context) {
    return {
        checkpointLabel: (0, _smithyClient.expectString)(output.checkpointLabel),
        confirmationStatus: (0, _smithyClient.expectString)(output.confirmationStatus),
        dialogActionType: (0, _smithyClient.expectString)(output.dialogActionType),
        fulfillmentState: (0, _smithyClient.expectString)(output.fulfillmentState),
        intentName: (0, _smithyClient.expectString)(output.intentName),
        slotToElicit: (0, _smithyClient.expectString)(output.slotToElicit),
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1IntentSummaryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1IntentSummary(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1listOfButtons = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Button(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PredictedIntent = function(output, context) {
    return {
        intentName: (0, _smithyClient.expectString)(output.intentName),
        nluIntentConfidence: output.nluIntentConfidence != null ? deserializeAws_restJson1IntentConfidence(output.nluIntentConfidence, context) : undefined,
        slots: output.slots != null ? deserializeAws_restJson1StringMap(output.slots, context) : undefined
    };
};
var deserializeAws_restJson1ResponseCard = function(output, context) {
    return {
        contentType: (0, _smithyClient.expectString)(output.contentType),
        genericAttachments: output.genericAttachments != null ? deserializeAws_restJson1genericAttachmentList(output.genericAttachments, context) : undefined,
        version: (0, _smithyClient.expectString)(output.version)
    };
};
var deserializeAws_restJson1SentimentResponse = function(output, context) {
    return {
        sentimentLabel: (0, _smithyClient.expectString)(output.sentimentLabel),
        sentimentScore: (0, _smithyClient.expectString)(output.sentimentScore)
    };
};
var deserializeAws_restJson1StringMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeMetadata = function(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"140ff1ec17a71939":"cvSE8","tslib":"86BcK","@aws-sdk/protocol-http":"f8OeQ","@aws-sdk/smithy-client":"alQg0","../models/LexRuntimeServiceServiceException":"1vMJc","../models/models_0":"l9pMX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2kixx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostTextCommand", ()=>PostTextCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var PostTextCommand = function(_super) {
    (0, _tslib.__extends)(PostTextCommand, _super);
    function PostTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PostTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LexRuntimeServiceClient";
        var commandName = "PostTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.PostTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.PostTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PostTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1PostTextCommand)(input, context);
    };
    PostTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1PostTextCommand)(output, context);
    };
    return PostTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"8ZTRr","@aws-sdk/smithy-client":"alQg0","../models/models_0":"l9pMX","../protocols/Aws_restJson1":"esFav","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ep5zt":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convert", ()=>convert);
parcelHelpers.export(exports, "base64ToArrayBuffer", ()=>base64ToArrayBuffer);
parcelHelpers.export(exports, "gzipDecompressToString", ()=>gzipDecompressToString);
var _tslib = require("tslib");
var _fflate = require("fflate");
var convert = function(stream) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            if (stream instanceof Blob || stream instanceof ReadableStream) return [
                2 /*return*/ ,
                new Response(stream).arrayBuffer().then(function(buffer) {
                    return new Uint8Array(buffer);
                })
            ];
            else return [
                2 /*return*/ ,
                Promise.reject("Invalid content type")
            ];
            return [
                2 /*return*/ 
            ];
        });
    });
};
var base64ToArrayBuffer = function(base64) {
    return Uint8Array.from(window.atob(base64), function(c) {
        return c.charCodeAt(0);
    });
};
var gzipDecompressToString = function(data) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve, reject) {
                            (0, _fflate.gunzip)(data, function(err, resp) {
                                if (err) reject(err);
                                else resolve((0, _fflate.strFromU8)(resp));
                            });
                        })
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
};

},{"tslib":"2gCWu","fflate":"86IGF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86IGF":[function(require,module,exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", ()=>FlateErrorCode);
parcelHelpers.export(exports, "Deflate", ()=>Deflate);
parcelHelpers.export(exports, "AsyncDeflate", ()=>AsyncDeflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", ()=>deflateSync);
parcelHelpers.export(exports, "Inflate", ()=>Inflate);
parcelHelpers.export(exports, "AsyncInflate", ()=>AsyncInflate);
parcelHelpers.export(exports, "inflate", ()=>inflate);
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", ()=>inflateSync);
parcelHelpers.export(exports, "Gzip", ()=>Gzip);
parcelHelpers.export(exports, "AsyncGzip", ()=>AsyncGzip);
parcelHelpers.export(exports, "gzip", ()=>gzip);
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", ()=>gzipSync);
parcelHelpers.export(exports, "Gunzip", ()=>Gunzip);
parcelHelpers.export(exports, "AsyncGunzip", ()=>AsyncGunzip);
parcelHelpers.export(exports, "gunzip", ()=>gunzip);
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", ()=>gunzipSync);
parcelHelpers.export(exports, "Zlib", ()=>Zlib);
parcelHelpers.export(exports, "AsyncZlib", ()=>AsyncZlib);
parcelHelpers.export(exports, "zlib", ()=>zlib);
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", ()=>zlibSync);
parcelHelpers.export(exports, "Unzlib", ()=>Unzlib);
parcelHelpers.export(exports, "AsyncUnzlib", ()=>AsyncUnzlib);
parcelHelpers.export(exports, "unzlib", ()=>unzlib);
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", ()=>unzlibSync);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", ()=>gzip);
parcelHelpers.export(exports, "AsyncCompress", ()=>AsyncGzip);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compressSync", ()=>gzipSync);
parcelHelpers.export(exports, "Compress", ()=>Gzip);
parcelHelpers.export(exports, "Decompress", ()=>Decompress);
parcelHelpers.export(exports, "AsyncDecompress", ()=>AsyncDecompress);
parcelHelpers.export(exports, "decompress", ()=>decompress);
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", ()=>decompressSync);
parcelHelpers.export(exports, "DecodeUTF8", ()=>DecodeUTF8);
parcelHelpers.export(exports, "EncodeUTF8", ()=>EncodeUTF8);
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", ()=>strToU8);
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", ()=>strFromU8);
parcelHelpers.export(exports, "ZipPassThrough", ()=>ZipPassThrough);
parcelHelpers.export(exports, "ZipDeflate", ()=>ZipDeflate);
parcelHelpers.export(exports, "AsyncZipDeflate", ()=>AsyncZipDeflate);
parcelHelpers.export(exports, "Zip", ()=>Zip);
parcelHelpers.export(exports, "zip", ()=>zip);
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", ()=>zipSync);
parcelHelpers.export(exports, "UnzipPassThrough", ()=>UnzipPassThrough);
parcelHelpers.export(exports, "UnzipInflate", ()=>UnzipInflate);
parcelHelpers.export(exports, "AsyncUnzipInflate", ()=>AsyncUnzipInflate);
parcelHelpers.export(exports, "Unzip", ()=>Unzip);
parcelHelpers.export(exports, "unzip", ()=>unzip);
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", ()=>unzipSync);
var ch2 = {};
var wk = function(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: "text/javascript"
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err["code"] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >>> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v.BYTES_PER_ELEMENT == 2 ? u16 : v.BYTES_PER_ELEMENT == 4 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
];
var err = function(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        et,
        0
    ];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
        var dst = syms[i] & 31;
        wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
    } else wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e >= s) // write final block
        w[pos >> 3] = lst;
        pos = wfblk(w, pos + 1, dat.subarray(i, e));
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var dopt = function(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf("[") + 1, st.lastIndexOf("]")).replace(/\s+/g, "").split(",");
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == "function") {
            fnStr += ";" + k + "=";
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf("[native code]") != -1) {
                    var spInd = st_1.indexOf(" ", 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf("(", spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ";" + k + ".prototype." + t + "=" + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var ch = [];
// clone bufs
var cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function(fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = "", td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + init.toString() + "}", id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gu8
    ];
};
var bDflt = function() {
    return [
        u8,
        u16,
        u32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function() {
    return [
        zlv
    ];
};
// post buf
var pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var gu8 = function(o) {
    return o && o.size && new u8(o.size);
};
// async helper
var cbify = function(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, "invalid gzip data");
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, "invalid zlib data");
    if (d[1] & 32) err(6, "invalid zlib data: preset dictionaries not supported");
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == "function") cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, 0, function() {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gu8(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) err(6, "invalid gzip data");
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, 0, function() {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0]));
    }, 3, cb);
}
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, "invalid zlib data");
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, 0, function() {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gu8(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, out) : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += "/"] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != "undefined" && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != "undefined" && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function(d) {
    for(var r = "", i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) err(8);
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = "";
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) err(8);
        return out;
    }
}
// deflate bit flag
var dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this_1.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this_1.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this_1.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this_1.ondata(err, dat, final);
                    _this_1.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var r = {};
    fltn(data, "", r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, "", r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, "unknown compression type " + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_3 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295;
        if (z) {
            e = b4(data, e - 12);
            if (b4(data, e) != 0x6064B50) {
                cbd(err(13, 0, 1), null);
                return tAll;
            }
            c = lft = b4(data, e + 32);
            o = b4(data, e + 48);
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    if (sc < 320000) try {
                        cbl(null, inflateSync(infl, new u8(su)));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, "unknown compression type " + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50) err(13);
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
            else err(14, "unknown compression type " + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"29fbL":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", ()=>(0, _notificationsDefault.default));
parcelHelpers.export(exports, "AWSPinpointProviderCommon", ()=>(0, _common.AWSPinpointProviderCommon));
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>(0, _inAppMessaging.InAppMessageInteractionEvent));
parcelHelpers.export(exports, "PushNotificationPermissionStatus", ()=>(0, _types.PushNotificationPermissionStatus));
var _notifications = require("./Notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _common = require("./common");
var _inAppMessaging = require("./InAppMessaging");
var _types = require("./PushNotification/types");

},{"./Notifications":"8snMy","./common":false,"./InAppMessaging":false,"./PushNotification/types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8snMy":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var logger = new (0, _core.ConsoleLogger)("Notifications");
var NotificationsClass = /** @class */ function() {
    function NotificationsClass() {
        var _this = this;
        this.config = {};
        /**
         * Configure Notifications
         * @param {Object} config - Notifications configuration object
         */ this.configure = function(_a) {
            var config = (_a === void 0 ? {} : _a).Notifications;
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug("configure Notifications", config);
            // Configure sub-categories
            _this.inAppMessaging.configure(_this.config.InAppMessaging);
            if (_this.config.Push) try {
                // only instantiate once
                if (!_this.pushNotification) _this.pushNotification = new (0, _pushNotificationDefault.default)();
                _this.pushNotification.configure(_this.config.Push);
            } catch (err) {
                logger.error(err);
            }
            return _this.config;
        };
        this.identifyUser = function(userId, userInfo) {
            var identifyFunctions = [];
            if (_this.inAppMessaging) identifyFunctions.push(_this.inAppMessaging.identifyUser);
            if (_this.pushNotification) identifyFunctions.push(_this.pushNotification.identifyUser);
            return Promise.all(identifyFunctions.map(function(identifyFunction) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    identifyFunction(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                logger.error("Failed to identify user", err_1);
                                throw err_1;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.inAppMessaging = new (0, _inAppMessagingDefault.default)();
    }
    /**
     * Get the name of the module category
     * @returns {string} name of the module category
     */ NotificationsClass.prototype.getModuleName = function() {
        return "Notifications";
    };
    Object.defineProperty(NotificationsClass.prototype, "InAppMessaging", {
        get: function() {
            return this.inAppMessaging;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClass.prototype, "Push", {
        get: function() {
            var _a;
            return (_a = this.pushNotification) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: true,
        configurable: true
    });
    return NotificationsClass;
}();
var Notifications = new NotificationsClass();
exports.default = Notifications;
(0, _core.Amplify).register(Notifications);

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","./InAppMessaging":"ahkvG","./PushNotification":"9aljh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ahkvG":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inAppMessagingDefault.default));
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>(0, _types.InAppMessageInteractionEvent));
var _inAppMessaging = require("./InAppMessaging");
var _inAppMessagingDefault = parcelHelpers.interopDefault(_inAppMessaging);
var _types = require("./types");

},{"./InAppMessaging":"j8jN5","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8jN5":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _flatten = require("lodash/flatten");
var _flattenDefault = parcelHelpers.interopDefault(_flatten);
var _common = require("../common");
var _providers = require("./Providers");
var _types = require("./types");
var STORAGE_KEY_SUFFIX = "_inAppMessages";
var logger = new (0, _core.ConsoleLogger)("Notifications.InAppMessaging");
var InAppMessaging = /** @class */ function() {
    function InAppMessaging() {
        var _this = this;
        this.config = {};
        this.listeningForAnalyticEvents = false;
        this.pluggables = [];
        this.storageSynced = false;
        /**
         * Configure InAppMessaging
         * @param {Object} config - InAppMessaging configuration object
         */ this.configure = function(_a) {
            if (_a === void 0) _a = {};
            var _b = _a.listenForAnalyticsEvents, listenForAnalyticsEvents = _b === void 0 ? true : _b, config = (0, _tslib.__rest)(_a, [
                "listenForAnalyticsEvents"
            ]);
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.config), config);
            logger.debug("configure InAppMessaging", _this.config);
            _this.pluggables.forEach(function(pluggable) {
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            });
            if (_this.pluggables.length === 0) _this.addPluggable(new (0, _providers.AWSPinpointProvider)());
            if (listenForAnalyticsEvents && !_this.listeningForAnalyticEvents) {
                (0, _core.Hub).listen("analytics", _this.analyticsListener);
                _this.listeningForAnalyticEvents = true;
            }
            return _this.config;
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(providerName) {
            var _a;
            var pluggable = (_a = _this.pluggables.find(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            })) !== null && _a !== void 0 ? _a : null;
            if (!pluggable) logger.debug("No plugin found with name " + providerName);
            return pluggable;
        };
        /**
         * Add plugin into InAppMessaging
         * @param {InAppMessagingProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(pluggable) {
            if (pluggable && pluggable.getCategory() === "Notifications" && pluggable.getSubCategory() === "InAppMessaging") {
                if (_this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable " + pluggable.getProviderName() + " has already been added.");
                _this.pluggables.push(pluggable);
                pluggable.configure(_this.config[pluggable.getProviderName()]);
            }
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function(providerName) {
            var index = _this.pluggables.findIndex(function(pluggable) {
                return pluggable.getProviderName() === providerName;
            });
            if (index === -1) logger.debug("No plugin found with name " + providerName);
            else _this.pluggables.splice(index, 1);
        };
        /**
         * Get the map resources that are currently available through the provider
         * @param {string} provider
         * @returns - Array of available map resources
         */ this.syncMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var messages, key, err_1;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.getInAppMessages()
                                ];
                            case 1:
                                messages = _a.sent();
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.setMessages(key, messages)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                logger.error("Failed to sync messages", err_1);
                                throw err_1;
                            case 4:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.clearMessages = function() {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var key;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                return [
                                    4 /*yield*/ ,
                                    this.removeMessages(key)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.dispatchEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var messages, flattenedMessages;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                Promise.all(this.pluggables.map(function(pluggable) {
                                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                        var key, messages;
                                        return (0, _tslib.__generator)(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    key = "" + pluggable.getProviderName() + STORAGE_KEY_SUFFIX;
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.getMessages(key)
                                                    ];
                                                case 1:
                                                    messages = _a.sent();
                                                    return [
                                                        2 /*return*/ ,
                                                        pluggable.processInAppMessages(messages, event)
                                                    ];
                                            }
                                        });
                                    });
                                }))
                            ];
                        case 1:
                            messages = _a.sent();
                            flattenedMessages = (0, _flattenDefault.default)(messages);
                            if (flattenedMessages.length) (0, _common.notifyEventListeners)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, this.conflictHandler(flattenedMessages));
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.identifyUser = function(userId, userInfo) {
            return Promise.all(_this.pluggables.map(function(pluggable) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var err_2;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    pluggable.identifyUser(userId, userInfo)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_2 = _a.sent();
                                logger.error("Failed to identify user", err_2);
                                throw err_2;
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }));
        };
        this.onMessageReceived = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_RECEIVED, handler);
        };
        this.onMessageDisplayed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, handler);
        };
        this.onMessageDismissed = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, handler);
        };
        this.onMessageActionTaken = function(handler) {
            return (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, handler);
        };
        this.notifyMessageInteraction = function(message, type) {
            (0, _common.notifyEventListeners)(type, message);
        };
        this.setConflictHandler = function(handler) {
            _this.conflictHandler = handler;
        };
        this.analyticsListener = function(_a) {
            var payload = _a.payload;
            var event = payload.event, data = payload.data;
            switch(event){
                case "record":
                    _this.dispatchEvent(data);
                    break;
                default:
                    break;
            }
        };
        this.syncStorage = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_3;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            storage = this.config.storage;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!(typeof storage.sync === "function")) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.storageSynced = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _a.sent();
                            logger.error("Failed to sync storage", err_3);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, storedMessages, err_4;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storedMessages = storage.getItem(key);
                            return [
                                2 /*return*/ ,
                                storedMessages ? JSON.parse(storedMessages) : []
                            ];
                        case 3:
                            err_4 = _a.sent();
                            logger.error("Failed to retrieve in-app messages from storage", err_4);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.setMessages = function(key, messages) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!messages) return [
                                2 /*return*/ 
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            storage = this.config.storage;
                            storage.setItem(key, JSON.stringify(messages));
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_5 = _a.sent();
                            logger.error("Failed to store in-app messages", err_5);
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.removeMessages = function(key) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var storage, err_6;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!!this.storageSynced) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.syncStorage()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            storage = this.config.storage;
                            storage.removeItem(key);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            err_6 = _a.sent();
                            logger.error("Failed to remove in-app messages from storage", err_6);
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.defaultConflictHandler = function(messages) {
            // default behavior is to return the message closest to expiry
            // this function assumes that messages processed by providers already filters out expired messages
            var sorted = messages.sort(function(a, b) {
                var _a, _b;
                var endDateA = (_a = a.metadata) === null || _a === void 0 ? void 0 : _a.endDate;
                var endDateB = (_b = b.metadata) === null || _b === void 0 ? void 0 : _b.endDate;
                // if both message end dates are falsy or have the same date string, treat them as equal
                if (endDateA === endDateB) return 0;
                // if only message A has an end date, treat it as closer to expiry
                if (endDateA && !endDateB) return -1;
                // if only message B has an end date, treat it as closer to expiry
                if (!endDateA && endDateB) return 1;
                // otherwise, compare them
                return new Date(endDateA) < new Date(endDateB) ? -1 : 1;
            });
            // always return the top sorted
            return sorted[0];
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.setConflictHandler(this.defaultConflictHandler);
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ InAppMessaging.prototype.getModuleName = function() {
        return "InAppMessaging";
    };
    return InAppMessaging;
}();
exports.default = InAppMessaging;

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","lodash/flatten":"b7fAH","../common":"fGILj","./Providers":"au5Fu","./types":"bbtoH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b7fAH":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"8iQ0s"}],"8iQ0s":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"iS8Vi","ec5f080ebf5764e8":"SMYwm"}],"SMYwm":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"aflde","ee6f325d7f5309b1":"jmDAu","ff8d93236e335297":"jQGs4"}],"fGILj":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProviderCommon", ()=>(0, _awspinpointProviderCommonDefault.default));
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>(0, _constants.AMPLIFY_SYMBOL));
parcelHelpers.export(exports, "addEventListener", ()=>(0, _eventListeners.addEventListener));
parcelHelpers.export(exports, "notifyEventListeners", ()=>(0, _eventListeners.notifyEventListeners));
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", ()=>(0, _eventListeners.notifyEventListenersAndAwaitHandlers));
var _awspinpointProviderCommon = require("./AWSPinpointProviderCommon");
var _awspinpointProviderCommonDefault = parcelHelpers.interopDefault(_awspinpointProviderCommon);
var _constants = require("./constants");
var _eventListeners = require("./eventListeners");

},{"./AWSPinpointProviderCommon":"7T8Yf","./constants":"8Gtaq","./eventListeners":"bXDAU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7T8Yf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _cache = require("@aws-amplify/cache");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _uuid = require("uuid");
var AWSPinpointProviderCommon = /** @class */ function() {
    function AWSPinpointProviderCommon(logger) {
        var _this = this;
        var _a;
        this.config = {};
        this.endpointInitialized = false;
        this.initialized = false;
        this.identifyUser = function(userId, userInfo) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var err_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint(userId, userInfo)
                            ];
                        case 3:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_1 = _a.sent();
                            this.logger.error("Error identifying user", err_1);
                            throw err_1;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.init = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, endpointId, storage, providerName, _b, err_2;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            _a = this.config, endpointId = _a.endpointId, storage = _a.storage;
                            providerName = this.getProviderName();
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                6,
                                ,
                                7
                            ]);
                            if (!(typeof storage.sync === "function")) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                storage.sync()
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            if (!!endpointId) return [
                                3 /*break*/ ,
                                5
                            ];
                            _b = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getEndpointId()
                            ];
                        case 4:
                            _b.endpointId = _c.sent();
                            _c.label = 5;
                        case 5:
                            this.initialized = true;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 6:
                            err_2 = _c.sent();
                            this.logger.error("Failed to initialize " + providerName, err_2);
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getUserAgentValue = function() {
            var customUserAgentDetails;
            if (_this.getSubCategory() === "PushNotification") customUserAgentDetails = {
                category: (0, _core.Category).PushNotification,
                action: (0, _core.PushNotificationAction).None
            };
            else customUserAgentDetails = {
                category: (0, _core.Category).InAppMessaging,
                action: (0, _core.InAppMessagingAction).None
            };
            return (0, _core.getAmplifyUserAgent)(customUserAgentDetails);
        };
        this.recordAnalyticsEvent = function(event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, _b, appId, credentials, endpointId, region, input, err_3;
                var _c, _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            // Update credentials
                            _a = this.config;
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            // Update credentials
                            _a.credentials = _e.sent();
                            // Assert required configuration properties to make `putEvents` request are present
                            this.assertNotEmptyConfiguration();
                            _b = this.config, appId = _b.appId, credentials = _b.credentials, endpointId = _b.endpointId, region = _b.region;
                            _e.label = 2;
                        case 2:
                            _e.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            input = {
                                ApplicationId: appId,
                                EventsRequest: {
                                    BatchItem: (_c = {}, _c[endpointId] = {
                                        Endpoint: {},
                                        Events: (_d = {}, _d[(0, _uuid.v4)()] = event, _d)
                                    }, _c)
                                }
                            };
                            this.logger.debug("recording analytics event");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.putEvents)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _e.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _e.sent();
                            this.logger.error("Error recording analytics event", err_3);
                            throw err_3;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.updateEndpoint = function(userId, userInfo) {
            if (userId === void 0) userId = null;
            if (userInfo === void 0) userInfo = null;
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, credentialsUpdated, _a, appId, endpointId, _b, endpointInfo, region, _c, address, attributes, demographic, location_1, metrics, optOut, _d, appVersion, make, model, platform, version, input, err_4;
                var _this = this;
                var _e;
                return (0, _tslib.__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getCredentials()
                            ];
                        case 1:
                            credentials = _f.sent();
                            credentialsUpdated = !this.config.credentials || Object.keys(credentials).some(function(key) {
                                return credentials[key] !== _this.config.credentials[key];
                            });
                            // If endpoint is already initialized, and nothing else is changing, just early return
                            if (this.endpointInitialized && !credentialsUpdated && !userId && !userInfo) return [
                                2 /*return*/ 
                            ];
                            // Update credentials
                            this.config.credentials = credentials;
                            // Assert required configuration properties to make `updateEndpoint` request are present
                            this.assertNotEmptyConfiguration();
                            _a = this.config, appId = _a.appId, endpointId = _a.endpointId, _b = _a.endpointInfo, endpointInfo = _b === void 0 ? {} : _b, region = _a.region;
                            _f.label = 2;
                        case 2:
                            _f.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            _c = userInfo !== null && userInfo !== void 0 ? userInfo : {}, address = _c.address, attributes = _c.attributes, demographic = _c.demographic, location_1 = _c.location, metrics = _c.metrics, optOut = _c.optOut;
                            _d = this.clientInfo, appVersion = _d.appVersion, make = _d.make, model = _d.model, platform = _d.platform, version = _d.version;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId,
                                EndpointRequest: {
                                    RequestId: (0, _uuid.v4)(),
                                    EffectiveDate: new Date().toISOString(),
                                    ChannelType: endpointInfo.channelType,
                                    Address: address !== null && address !== void 0 ? address : endpointInfo.address,
                                    Attributes: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.attributes), attributes),
                                    Demographic: (0, _tslib.__assign)({
                                        AppVersion: appVersion,
                                        Make: make,
                                        Model: model,
                                        ModelVersion: version,
                                        Platform: platform
                                    }, (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.demographic), demographic))),
                                    Location: (0, _core.transferKeyToUpperCase)((0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.location), location_1)),
                                    Metrics: (0, _tslib.__assign)((0, _tslib.__assign)({}, endpointInfo.metrics), metrics),
                                    OptOut: optOut !== null && optOut !== void 0 ? optOut : endpointInfo.optOut,
                                    User: {
                                        UserId: (_e = userId !== null && userId !== void 0 ? userId : endpointInfo.userId) !== null && _e !== void 0 ? _e : credentials.identityId,
                                        UserAttributes: attributes !== null && attributes !== void 0 ? attributes : endpointInfo.userAttributes
                                    }
                                }
                            };
                            this.logger.debug("updating endpoint");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.updateEndpoint)({
                                    credentials: credentials,
                                    region: region,
                                    userAgentValue: this.getUserAgentValue()
                                }, input)
                            ];
                        case 3:
                            _f.sent();
                            this.endpointInitialized = true;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_4 = _f.sent();
                            throw err_4;
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getEndpointId = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var appId, cacheKey, cachedEndpointId, endpointId, ttl, expiration;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            appId = this.config.appId;
                            cacheKey = this.getSubCategory() === "PushNotification" ? this.getProviderName() + "_" + appId : this.getSubCategory() + ":" + this.getProviderName() + ":" + appId;
                            return [
                                4 /*yield*/ ,
                                (0, _cache.Cache).getItem(cacheKey)
                            ];
                        case 1:
                            cachedEndpointId = _a.sent();
                            // Found in cache, just return it
                            if (cachedEndpointId) return [
                                2 /*return*/ ,
                                cachedEndpointId
                            ];
                            endpointId = (0, _uuid.v4)();
                            ttl = 3153600000000;
                            expiration = new Date().getTime() + ttl;
                            (0, _cache.Cache).setItem(cacheKey, endpointId, {
                                expires: expiration,
                                priority: 1
                            });
                            return [
                                2 /*return*/ ,
                                endpointId
                            ];
                    }
                });
            });
        };
        this.getCredentials = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var credentials, err_5;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4 /*yield*/ ,
                                (0, _core.Credentials).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            if (!credentials) {
                                this.logger.debug("no credentials found");
                                return [
                                    2 /*return*/ ,
                                    null
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                (0, _core.Credentials).shear(credentials)
                            ];
                        case 2:
                            err_5 = _a.sent();
                            this.logger.error("Error getting credentials:", err_5);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.assertNotEmptyConfiguration = function() {
            var _a = _this.config, appId = _a.appId, credentials = _a.credentials, region = _a.region;
            if (!appId || !credentials || !region) throw new Error("One or more of credentials, appId or region is not configured");
        };
        this.config = {
            storage: new (0, _core.StorageHelper)().getStorage()
        };
        this.clientInfo = (_a = (0, _core.ClientDevice).clientInfo()) !== null && _a !== void 0 ? _a : {};
        this.logger = logger;
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProviderCommon.prototype.getCategory = function() {
        return AWSPinpointProviderCommon.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProviderCommon.prototype.getProviderName = function() {
        return AWSPinpointProviderCommon.providerName;
    };
    AWSPinpointProviderCommon.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.config), config);
        this.logger.debug("configure " + this.getProviderName() + this.getSubCategory() + "Provider", this.config);
        return this.config;
    };
    AWSPinpointProviderCommon.category = "Notifications";
    AWSPinpointProviderCommon.providerName = "AWSPinpoint";
    return AWSPinpointProviderCommon;
}();
exports.default = AWSPinpointProviderCommon;

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","@aws-amplify/cache":"hVdVQ","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","uuid":"9F31Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9F31Y":[function(require,module,exports) {
var v1 = require("23915971d0a40fae");
var v4 = require("89aadb37e95f6307");
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
module.exports = uuid;

},{"23915971d0a40fae":"bAF9R","89aadb37e95f6307":"5d9wt"}],"bAF9R":[function(require,module,exports) {
var rng = require("19bd27879c56e2bd");
var bytesToUuid = require("5e1b6f67342a95a7");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq;
// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = rng();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : bytesToUuid(b);
}
module.exports = v1;

},{"19bd27879c56e2bd":"igbhR","5e1b6f67342a95a7":"8a81t"}],"igbhR":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return rnds;
    };
}

},{}],"8a81t":[function(require,module,exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex[i] = (i + 0x100).toString(16).substr(1);
function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = bytesToUuid;

},{}],"5d9wt":[function(require,module,exports) {
var rng = require("dc03197cb409b353");
var bytesToUuid = require("150df029d85223a4");
function v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || bytesToUuid(rnds);
}
module.exports = v4;

},{"dc03197cb409b353":"igbhR","150df029d85223a4":"8a81t"}],"8Gtaq":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPLIFY_SYMBOL", ()=>AMPLIFY_SYMBOL);
var AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bXDAU":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notifyEventListeners", ()=>notifyEventListeners);
parcelHelpers.export(exports, "notifyEventListenersAndAwaitHandlers", ()=>notifyEventListenersAndAwaitHandlers);
parcelHelpers.export(exports, "addEventListener", ()=>addEventListener);
var _tslib = require("tslib");
var eventListeners = {};
var notifyEventListeners = function(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    (_a = eventListeners[type]) === null || _a === void 0 || _a.forEach(function(listener) {
        listener.handleEvent.apply(listener, (0, _tslib.__spread)(args));
    });
};
var notifyEventListenersAndAwaitHandlers = function(type) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var _a;
    return Promise.all(Array.from((_a = eventListeners[type]) !== null && _a !== void 0 ? _a : []).map(function(listener) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var err_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            listener.handleEvent.apply(listener, (0, _tslib.__spread)(args))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }));
};
var addEventListener = function(type, handler) {
    // If there is no listener set for the event type, just create it
    if (!eventListeners[type]) eventListeners[type] = new Set();
    var listener = {
        handleEvent: handler,
        remove: function() {
            eventListeners[type].delete(listener);
        }
    };
    eventListeners[type].add(listener);
    return listener;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"au5Fu":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointProvider", ()=>(0, _awspinpointProviderDefault.default));
var _awspinpointProvider = require("./AWSPinpointProvider");
var _awspinpointProviderDefault = parcelHelpers.interopDefault(_awspinpointProvider);

},{"./AWSPinpointProvider":"co7Ur","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"co7Ur":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _pinpoint = require("@aws-amplify/core/internals/aws-clients/pinpoint");
var _common = require("../../../common");
var _sessionTracker = require("../../SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
var _types = require("../../types");
var _types1 = require("./types");
var _utils = require("./utils");
var MESSAGE_DAILY_COUNT_KEY = "pinpointProvider_inAppMessages_dailyCount";
var MESSAGE_TOTAL_COUNT_KEY = "pinpointProvider_inAppMessages_totalCount";
var AWSPinpointProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AWSPinpointProvider, _super);
    function AWSPinpointProvider() {
        var _this = _super.call(this, (0, _utils.logger)) || this;
        _this.configured = false;
        _this.configure = function(config) {
            if (config === void 0) config = {};
            _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, _super.prototype.configure.call(_this, config)), {
                endpointInfo: {
                    channelType: "IN_APP"
                }
            });
            // some configuration steps should not be re-run even if provider is re-configured for some reason
            if (!_this.configured) {
                _this.sessionTracker = new (0, _sessionTrackerDefault.default)(_this.sessionStateChangeHandler);
                _this.sessionTracker.start();
                // wire up default Pinpoint message event handling
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISPLAYED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_DISMISSED, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISMISSED);
                });
                (0, _common.addEventListener)((0, _types.InAppMessageInteractionEvent).MESSAGE_ACTION_TAKEN, function(message) {
                    _this.recordMessageEvent(message, (0, _types1.AWSPinpointMessageEvent).MESSAGE_ACTION_TAKEN);
                });
            }
            _this.configured = true;
            (0, _utils.dispatchInAppMessagingEvent)("pinpointProvider_configured", null);
            return _this.config;
        };
        _this.getInAppMessages = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, appId, credentials, endpointId, region, input, response, messages, err_1;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            // There is no way to granuarly reconcile the filter memoization as the keys are composited from a message id and
                            // event properties thus opting to just clear them out when getting messages rather than leave potentially
                            // obsolete entries that will no longer serve any purpose.
                            (0, _utils.clearMemo)();
                            _b.label = 3;
                        case 3:
                            _b.trys.push([
                                3,
                                6,
                                ,
                                7
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.updateEndpoint()
                            ];
                        case 4:
                            _b.sent();
                            _a = this.config, appId = _a.appId, credentials = _a.credentials, endpointId = _a.endpointId, region = _a.region;
                            input = {
                                ApplicationId: appId,
                                EndpointId: endpointId
                            };
                            this.logger.debug("getting in-app messages");
                            return [
                                4 /*yield*/ ,
                                (0, _pinpoint.getInAppMessages)({
                                    credentials: credentials,
                                    region: region
                                }, input)
                            ];
                        case 5:
                            response = _b.sent();
                            messages = response.InAppMessagesResponse.InAppMessageCampaigns;
                            (0, _utils.dispatchInAppMessagingEvent)("getInAppMessages", messages);
                            return [
                                2 /*return*/ ,
                                messages
                            ];
                        case 6:
                            err_1 = _b.sent();
                            this.logger.error("Error getting in-app messages", err_1);
                            throw err_1;
                        case 7:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.processInAppMessages = function(messages, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var highestPrioritySeen;
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ ,
                                this.normalizeMessages(messages.reduce(function(acc, message) {
                                    var messageQualifies = (0, _utils.matchesEventType)(message, event) && (0, _utils.matchesAttributes)(message, event) && (0, _utils.matchesMetrics)(message, event) && (0, _utils.isBeforeEndDate)(message) && _this.isBelowCap(message);
                                    // filter all qualifying messages returning only those that are of (relative) highest priority
                                    if (messageQualifies) {
                                        // have not yet encountered message with priority
                                        if (!highestPrioritySeen) {
                                            // this message has priority, so reset the accumulator with this message only
                                            if (message.Priority) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            } else // this message also has no priority, so just add this message to accumulator
                                            acc.push(message);
                                        } else if (message.Priority) {
                                            // this message has higher priority (lower number), so reset the accumulator with this message only
                                            if (message.Priority < highestPrioritySeen) {
                                                highestPrioritySeen = message.Priority;
                                                return [
                                                    message
                                                ];
                                            // this message has the same priority, so just add this message to accumulator
                                            } else if (message.Priority === highestPrioritySeen) acc.push(message);
                                        }
                                    }
                                    return acc;
                                }, []))
                            ];
                    }
                });
            });
        };
        _this.sessionStateChangeHandler = function(state) {
            if (state === "started") // reset all session counts
            _this.sessionMessageCountMap = {};
        };
        _this.isBelowCap = function(_a) {
            var CampaignId = _a.CampaignId, SessionCap = _a.SessionCap, DailyCap = _a.DailyCap, TotalCap = _a.TotalCap;
            var _b = _this.getMessageCounts(CampaignId), sessionCount = _b.sessionCount, dailyCount = _b.dailyCount, totalCount = _b.totalCount;
            return (!SessionCap || sessionCount < SessionCap) && (!DailyCap || dailyCount < DailyCap) && (!TotalCap || totalCount < TotalCap);
        };
        // Use the current session count in memory or initialize as empty count
        _this.getSessionCount = function(messageId) {
            return _this.sessionMessageCountMap[messageId] || 0;
        };
        _this.getDailyCount = function() {
            var storage = _this.config.storage;
            var today = (0, _utils.getStartOfDay)();
            var item = storage.getItem(MESSAGE_DAILY_COUNT_KEY);
            // Parse stored count or initialize as empty count
            var counter = item ? JSON.parse(item) : {
                count: 0,
                lastCountTimestamp: today
            };
            // If the stored counter timestamp is today, use it as the count, otherwise reset to 0
            return counter.lastCountTimestamp === today ? counter.count : 0;
        };
        _this.getTotalCountMap = function() {
            var storage = _this.config.storage;
            var item = storage.getItem(MESSAGE_TOTAL_COUNT_KEY);
            // Parse stored count map or initialize as empty
            return item ? JSON.parse(item) : {};
        };
        _this.getTotalCount = function(messageId) {
            var countMap = _this.getTotalCountMap();
            // Return stored count or initialize as empty count
            return countMap[messageId] || 0;
        };
        _this.getMessageCounts = function(messageId) {
            try {
                return {
                    sessionCount: _this.getSessionCount(messageId),
                    dailyCount: _this.getDailyCount(),
                    totalCount: _this.getTotalCount(messageId)
                };
            } catch (err) {
                _this.logger.error("Failed to get message counts from storage", err);
            }
        };
        _this.setSessionCount = function(messageId, count) {
            _this.sessionMessageCountMap[messageId] = count;
        };
        _this.setDailyCount = function(count) {
            var storage = _this.config.storage;
            var dailyCount = {
                count: count,
                lastCountTimestamp: (0, _utils.getStartOfDay)()
            };
            try {
                storage.setItem(MESSAGE_DAILY_COUNT_KEY, JSON.stringify(dailyCount));
            } catch (err) {
                _this.logger.error("Failed to save daily message count to storage", err);
            }
        };
        _this.setTotalCountMap = function(countMap) {
            var storage = _this.config.storage;
            try {
                storage.setItem(MESSAGE_TOTAL_COUNT_KEY, JSON.stringify(countMap));
            } catch (err) {
                _this.logger.error("Failed to save total count to storage", err);
            }
        };
        _this.setTotalCount = function(messageId, count) {
            var _a;
            var updatedMap = (0, _tslib.__assign)((0, _tslib.__assign)({}, _this.getTotalCountMap()), (_a = {}, _a[messageId] = count, _a));
            _this.setTotalCountMap(updatedMap);
        };
        _this.incrementCounts = function(messageId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _a, sessionCount, dailyCount, totalCount;
                return (0, _tslib.__generator)(this, function(_b) {
                    _a = this.getMessageCounts(messageId), sessionCount = _a.sessionCount, dailyCount = _a.dailyCount, totalCount = _a.totalCount;
                    this.setSessionCount(messageId, sessionCount + 1);
                    this.setDailyCount(dailyCount + 1);
                    this.setTotalCount(messageId, totalCount + 1);
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        _this.normalizeMessages = function(messages) {
            return messages.map(function(message) {
                var CampaignId = message.CampaignId, InAppMessage = message.InAppMessage;
                return {
                    id: CampaignId,
                    content: (0, _utils.extractContent)(message),
                    layout: (0, _utils.interpretLayout)(InAppMessage.Layout),
                    metadata: (0, _utils.extractMetadata)(message)
                };
            });
        };
        _this.recordMessageEvent = function(message, event) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!!this.initialized) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.init()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            (0, _utils.recordAnalyticsEvent)(event, message);
                            if (!(event === (0, _types1.AWSPinpointMessageEvent).MESSAGE_DISPLAYED)) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                this.incrementCounts(message.id)
                            ];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        _this.sessionMessageCountMap = {};
        return _this;
    }
    /**
     * get the sub-category of the plugin
     */ AWSPinpointProvider.prototype.getSubCategory = function() {
        return AWSPinpointProvider.subCategory;
    };
    AWSPinpointProvider.subCategory = "InAppMessaging";
    return AWSPinpointProvider;
}((0, _common.AWSPinpointProviderCommon));
exports.default = AWSPinpointProvider;

},{"tslib":"86BcK","@aws-amplify/core/internals/aws-clients/pinpoint":"l0bYL","../../../common":"fGILj","../../SessionTracker":"3jGxe","../../types":"bbtoH","./types":"hyGsE","./utils":"4Zk3y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3jGxe":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sessionTracker = require("./SessionTracker");
var _sessionTrackerDefault = parcelHelpers.interopDefault(_sessionTracker);
exports.default = (0, _sessionTrackerDefault.default);

},{"./SessionTracker":"bTAdv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bTAdv":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@aws-amplify/core");
var _noop = require("lodash/noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
// Per https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
var hidden;
var visibilityChange;
var isBrowser = (0, _core.browserOrNode)().isBrowser;
if (isBrowser && document) {
    if (typeof document.hidden !== "undefined") {
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (typeof document["msHidden"] !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (typeof document["webkitHidden"] !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }
}
var logger = new (0, _core.ConsoleLogger)("InAppMessagingSessionTracker");
var SessionTracker = /** @class */ function() {
    function SessionTracker(sessionStateChangeHandler) {
        var _this = this;
        if (sessionStateChangeHandler === void 0) sessionStateChangeHandler = (0, _noopDefault.default);
        this.start = function() {
            if (isBrowser) document === null || document === void 0 || document.addEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.end = function() {
            if (isBrowser) document === null || document === void 0 || document.removeEventListener(visibilityChange, _this.visibilityChangeHandler);
            return _this.getSessionState();
        };
        this.getSessionState = function() {
            if (isBrowser && document && !document[hidden]) return "started";
            // If, for any reason, document is undefined the session will never start
            return "ended";
        };
        this.visibilityChangeHandler = function() {
            if (!isBrowser || !document) return;
            if (document[hidden]) {
                logger.debug("App is now hidden");
                _this.sessionStateChangeHandler("ended");
            } else {
                logger.debug("App is now visible");
                _this.sessionStateChangeHandler("started");
            }
        };
        this.sessionStateChangeHandler = sessionStateChangeHandler;
    }
    return SessionTracker;
}();
exports.default = SessionTracker;

},{"@aws-amplify/core":"3rlh1","lodash/noop":"dS0xS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dS0xS":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"bbtoH":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InAppMessageInteractionEvent", ()=>InAppMessageInteractionEvent);
var InAppMessageInteractionEvent;
(function(InAppMessageInteractionEvent) {
    InAppMessageInteractionEvent["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISPLAYED"] = "MESSAGE_DISPLAYED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_DISMISSED"] = "MESSAGE_DISMISSED_EVENT";
    InAppMessageInteractionEvent["MESSAGE_ACTION_TAKEN"] = "MESSAGE_ACTION_TAKEN_EVENT";
})(InAppMessageInteractionEvent || (InAppMessageInteractionEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hyGsE":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AWSPinpointMessageEvent", ()=>AWSPinpointMessageEvent);
var AWSPinpointMessageEvent;
(function(AWSPinpointMessageEvent) {
    AWSPinpointMessageEvent["MESSAGE_DISPLAYED"] = "_inapp.message_displayed";
    AWSPinpointMessageEvent["MESSAGE_DISMISSED"] = "_inapp.message_dismissed";
    AWSPinpointMessageEvent["MESSAGE_ACTION_TAKEN"] = "_inapp.message_clicked";
})(AWSPinpointMessageEvent || (AWSPinpointMessageEvent = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Zk3y":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
parcelHelpers.export(exports, "dispatchInAppMessagingEvent", ()=>dispatchInAppMessagingEvent);
parcelHelpers.export(exports, "recordAnalyticsEvent", ()=>recordAnalyticsEvent);
parcelHelpers.export(exports, "getStartOfDay", ()=>getStartOfDay);
parcelHelpers.export(exports, "matchesEventType", ()=>matchesEventType);
parcelHelpers.export(exports, "matchesAttributes", ()=>matchesAttributes);
parcelHelpers.export(exports, "matchesMetrics", ()=>matchesMetrics);
parcelHelpers.export(exports, "getComparator", ()=>getComparator);
parcelHelpers.export(exports, "isBeforeEndDate", ()=>isBeforeEndDate);
parcelHelpers.export(exports, "isQuietTime", ()=>isQuietTime);
parcelHelpers.export(exports, "clearMemo", ()=>clearMemo);
parcelHelpers.export(exports, "interpretLayout", ()=>interpretLayout);
parcelHelpers.export(exports, "extractContent", ()=>extractContent);
parcelHelpers.export(exports, "extractMetadata", ()=>extractMetadata);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _common = require("../../../common");
var DELIVERY_TYPE = "IN_APP_MESSAGE";
var eventNameMemo = {};
var eventAttributesMemo = {};
var eventMetricsMemo = {};
var logger = new (0, _core.ConsoleLogger)("InAppMessaging.AWSPinpointProvider");
var dispatchInAppMessagingEvent = function(event, data, message) {
    (0, _core.Hub).dispatch("inAppMessaging", {
        event: event,
        data: data,
        message: message
    }, "InAppMessaging", (0, _common.AMPLIFY_SYMBOL));
};
var recordAnalyticsEvent = function(event, message) {
    if ((0, _core.Amplify).Analytics && typeof (0, _core.Amplify).Analytics.record === "function") {
        var id = message.id, metadata = message.metadata;
        (0, _core.Amplify).Analytics.record({
            name: event,
            attributes: {
                campaign_id: id,
                delivery_type: DELIVERY_TYPE,
                treatment_id: metadata === null || metadata === void 0 ? void 0 : metadata.treatmentId
            }
        });
    } else logger.debug("Analytics module is not registered into Amplify");
};
var getStartOfDay = function() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    return now.toISOString();
};
var matchesEventType = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var eventType = _b.name;
    var _c;
    var EventType = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).EventType;
    var memoKey = CampaignId + ":" + eventType;
    if (!eventNameMemo.hasOwnProperty(memoKey)) eventNameMemo[memoKey] = !!(EventType === null || EventType === void 0 ? void 0 : EventType.Values.includes(eventType));
    return eventNameMemo[memoKey];
};
var matchesAttributes = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var attributes = _b.attributes;
    var _c;
    var Attributes = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Attributes;
    if ((0, _isEmptyDefault.default)(Attributes)) // if message does not have attributes defined it does not matter what attributes are on the event
    return true;
    if ((0, _isEmptyDefault.default)(attributes)) // if message does have attributes but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(attributes);
    if (!eventAttributesMemo.hasOwnProperty(memoKey)) eventAttributesMemo[memoKey] = Object.entries(Attributes).every(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], Values = _b[1].Values;
        return Values.includes(attributes[key]);
    });
    return eventAttributesMemo[memoKey];
};
var matchesMetrics = function(_a, _b) {
    var CampaignId = _a.CampaignId, Schedule = _a.Schedule;
    var metrics = _b.metrics;
    var _c;
    var Metrics = ((_c = Schedule === null || Schedule === void 0 ? void 0 : Schedule.EventFilter) === null || _c === void 0 ? void 0 : _c.Dimensions).Metrics;
    if ((0, _isEmptyDefault.default)(Metrics)) // if message does not have metrics defined it does not matter what metrics are on the event
    return true;
    if ((0, _isEmptyDefault.default)(metrics)) // if message does have metrics but the event does not then it always fails the check
    return false;
    var memoKey = CampaignId + ":" + JSON.stringify(metrics);
    if (!eventMetricsMemo.hasOwnProperty(memoKey)) eventMetricsMemo[memoKey] = Object.entries(Metrics).every(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], _c = _b[1], ComparisonOperator = _c.ComparisonOperator, Value = _c.Value;
        var compare = getComparator(ComparisonOperator);
        // if there is some unknown comparison operator, treat as a comparison failure
        return compare ? compare(Value, metrics[key]) : false;
    });
    return eventMetricsMemo[memoKey];
};
var getComparator = function(operator) {
    switch(operator){
        case "EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal === eventVal;
            };
        case "GREATER_THAN":
            return function(metricsVal, eventVal) {
                return metricsVal < eventVal;
            };
        case "GREATER_THAN_OR_EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal <= eventVal;
            };
        case "LESS_THAN":
            return function(metricsVal, eventVal) {
                return metricsVal > eventVal;
            };
        case "LESS_THAN_OR_EQUAL":
            return function(metricsVal, eventVal) {
                return metricsVal >= eventVal;
            };
        default:
            return null;
    }
};
var isBeforeEndDate = function(_a) {
    var Schedule = _a.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate)) return true;
    return new Date() < new Date(Schedule.EndDate);
};
var isQuietTime = function(message) {
    var Schedule = message.Schedule;
    if (!(Schedule === null || Schedule === void 0 ? void 0 : Schedule.QuietTime)) return false;
    var pattern = /^[0-2]\d:[0-5]\d$/; // basic sanity check, not a fully featured HH:MM validation
    var _a = Schedule.QuietTime, Start = _a.Start, End = _a.End;
    if (!Start || !End || Start === End || !pattern.test(Start) || !pattern.test(End)) return false;
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    var _b = (0, _tslib.__read)(Start.split(":"), 2), startHours = _b[0], startMinutes = _b[1];
    var _c = (0, _tslib.__read)(End.split(":"), 2), endHours = _c[0], endMinutes = _c[1];
    start.setHours(Number.parseInt(startHours, 10), Number.parseInt(startMinutes, 10), 0, 0);
    end.setHours(Number.parseInt(endHours, 10), Number.parseInt(endMinutes, 10), 0, 0);
    // if quiet time includes midnight, bump the end time to the next day
    if (start > end) end.setDate(end.getDate() + 1);
    var isQuietTime = now >= start && now <= end;
    if (isQuietTime) logger.debug("message filtered due to quiet time", message);
    return isQuietTime;
};
var clearMemo = function() {
    eventNameMemo = {};
    eventAttributesMemo = {};
    eventMetricsMemo = {};
};
var interpretLayout = function(layout) {
    if (layout === "MOBILE_FEED") return "MODAL";
    if (layout === "OVERLAYS") return "FULL_SCREEN";
    // cast as PinpointInAppMessage['InAppMessage']['Layout'] allows `string` as a value
    return layout;
};
var extractContent = function(_a) {
    var message = _a.InAppMessage;
    var _b, _c;
    return (_c = (_b = message === null || message === void 0 ? void 0 : message.Content) === null || _b === void 0 ? void 0 : _b.map(function(content) {
        var BackgroundColor = content.BackgroundColor, BodyConfig = content.BodyConfig, HeaderConfig = content.HeaderConfig, ImageUrl = content.ImageUrl, PrimaryBtn = content.PrimaryBtn, SecondaryBtn = content.SecondaryBtn;
        var defaultPrimaryButton = PrimaryBtn === null || PrimaryBtn === void 0 ? void 0 : PrimaryBtn.DefaultConfig;
        var defaultSecondaryButton = SecondaryBtn === null || SecondaryBtn === void 0 ? void 0 : SecondaryBtn.DefaultConfig;
        var extractedContent = {};
        if (BackgroundColor) extractedContent.container = {
            style: {
                backgroundColor: BackgroundColor
            }
        };
        if (HeaderConfig) extractedContent.header = {
            content: HeaderConfig.Header,
            style: {
                color: HeaderConfig.TextColor,
                textAlign: HeaderConfig.Alignment.toLowerCase()
            }
        };
        if (BodyConfig) extractedContent.body = {
            content: BodyConfig.Body,
            style: {
                color: BodyConfig.TextColor,
                textAlign: BodyConfig.Alignment.toLowerCase()
            }
        };
        if (ImageUrl) extractedContent.image = {
            src: ImageUrl
        };
        if (defaultPrimaryButton) extractedContent.primaryButton = {
            title: defaultPrimaryButton.Text,
            action: defaultPrimaryButton.ButtonAction,
            url: defaultPrimaryButton.Link,
            style: {
                backgroundColor: defaultPrimaryButton.BackgroundColor,
                borderRadius: defaultPrimaryButton.BorderRadius,
                color: defaultPrimaryButton.TextColor
            }
        };
        if (defaultSecondaryButton) extractedContent.secondaryButton = {
            title: defaultSecondaryButton.Text,
            action: defaultSecondaryButton.ButtonAction,
            url: defaultSecondaryButton.Link,
            style: {
                backgroundColor: defaultSecondaryButton.BackgroundColor,
                borderRadius: defaultSecondaryButton.BorderRadius,
                color: defaultSecondaryButton.TextColor
            }
        };
        return extractedContent;
    })) !== null && _c !== void 0 ? _c : [];
};
var extractMetadata = function(_a) {
    var InAppMessage = _a.InAppMessage, Priority = _a.Priority, Schedule = _a.Schedule, TreatmentId = _a.TreatmentId;
    return {
        customData: InAppMessage === null || InAppMessage === void 0 ? void 0 : InAppMessage.CustomConfig,
        endDate: Schedule === null || Schedule === void 0 ? void 0 : Schedule.EndDate,
        priority: Priority,
        treatmentId: TreatmentId
    };
};

},{"tslib":"86BcK","@aws-amplify/core":"3rlh1","lodash/isEmpty":"15wZF","../../../common":"fGILj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9aljh":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _pushNotificationDefault.default));
parcelHelpers.export(exports, "PushNotificationPermissionStatus", ()=>(0, _types.PushNotificationPermissionStatus));
var _pushNotification = require("./PushNotification");
var _pushNotificationDefault = parcelHelpers.interopDefault(_pushNotification);
var _types = require("./types");

},{"./PushNotification":"fPIAz","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPIAz":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _platformNotSupportedError = require("./PlatformNotSupportedError");
var _platformNotSupportedErrorDefault = parcelHelpers.interopDefault(_platformNotSupportedError);
var PushNotification = /** @class */ function() {
    function PushNotification() {
        var _this = this;
        /**
         * Configure PushNotification
         * @param {Object} config - PushNotification configuration object
         */ this.configure = function(_) {
            if (_ === void 0) _ = {};
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Get a plugin from added plugins
         * @param {string} providerName - the name of the plugin to get
         */ this.getPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Add plugin into PushNotification
         * @param {PushNotificationProvider} pluggable - an instance of the plugin
         */ this.addPluggable = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        /**
         * Remove a plugin from added plugins
         * @param {string} providerName - the name of the plugin to remove
         */ this.removePluggable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.enable = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.identifyUser = function() {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getLaunchNotification = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.getBadgeCount = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.setBadgeCount = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.getPermissionStatus = function() {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.requestPermissions = function(_) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    throw new (0, _platformNotSupportedErrorDefault.default)();
                });
            });
        };
        this.onNotificationReceivedInBackground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationReceivedInForeground = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onTokenReceived = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
        this.onNotificationOpened = function(_) {
            throw new (0, _platformNotSupportedErrorDefault.default)();
        };
    }
    /**
     * Get the name of this module
     * @returns {string} name of this module
     */ PushNotification.prototype.getModuleName = function() {
        throw new (0, _platformNotSupportedErrorDefault.default)();
    };
    return PushNotification;
}();
exports.default = PushNotification;

},{"tslib":"86BcK","./PlatformNotSupportedError":"jy2rr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jy2rr":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var PlatformNotSupportedError = /** @class */ function(_super) {
    (0, _tslib.__extends)(PlatformNotSupportedError, _super);
    function PlatformNotSupportedError() {
        var _this = _super.call(this, "Function not supported on current platform") || this;
        _this.name = "PlatformNotSupportedError";
        return _this;
    }
    return PlatformNotSupportedError;
}(Error);
exports.default = PlatformNotSupportedError;

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lJ5pk":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Predictions", ()=>(0, _predictions.Predictions));
parcelHelpers.export(exports, "AmazonAIIdentifyPredictionsProvider", ()=>(0, _providers.AmazonAIIdentifyPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIConvertPredictionsProvider", ()=>(0, _providers.AmazonAIConvertPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIPredictionsProvider", ()=>(0, _providers.AmazonAIPredictionsProvider));
parcelHelpers.export(exports, "AmazonAIInterpretPredictionsProvider", ()=>(0, _providers.AmazonAIInterpretPredictionsProvider));
var _predictions = require("./Predictions");
var _providers = require("./Providers");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Predictions":"3ZuVO","./Providers":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ZuVO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PredictionsClass", ()=>PredictionsClass);
parcelHelpers.export(exports, "Predictions", ()=>Predictions);
var _tslib = require("tslib");
var _core = require("@aws-amplify/core");
var logger = new (0, _core.ConsoleLogger)("Predictions");
var PredictionsClass = /** @class */ function() {
    /**
     * Initialize Predictions with AWS configurations
     * @param {PredictionsOptions} options - Configuration object for Predictions
     */ function PredictionsClass(options) {
        this._options = options;
        this._convertPluggables = [];
        this._identifyPluggables = [];
        this._interpretPluggables = [];
    }
    PredictionsClass.prototype.getModuleName = function() {
        return "Predictions";
    };
    /**
     * add plugin/pluggable into Predictions category
     * @param {Object} pluggable - an instance of the plugin/pluggable
     **/ PredictionsClass.prototype.addPluggable = function(pluggable) {
        if (this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable with name " + pluggable.getProviderName() + " has already been added.");
        var pluggableAdded = false;
        if (this.implementsConvertPluggable(pluggable)) {
            this._convertPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsIdentifyPluggable(pluggable)) {
            this._identifyPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsInterpretPluggable(pluggable)) {
            this._interpretPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (pluggableAdded) this.configurePluggable(pluggable);
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.getPluggable = function(providerName) {
        var pluggable = this.getAllProviders().find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName=>", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ PredictionsClass.prototype.removePluggable = function(providerName) {
        this._convertPluggables = this._convertPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._identifyPluggables = this._identifyPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._interpretPluggables = this._interpretPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * To make both top level providers and category level providers work with same interface and configuration
     * this method duplicates Predictions config into parent level config (for top level provider) and
     * category level config (such as convert, identify etc) and pass both to each provider.
     */ PredictionsClass.prototype.configure = function(options) {
        var _this = this;
        var predictionsConfig = options ? options.predictions || options : {};
        predictionsConfig = (0, _tslib.__assign)((0, _tslib.__assign)({}, predictionsConfig), options);
        this._options = Object.assign({}, this._options, predictionsConfig);
        logger.debug("configure Predictions", this._options);
        this.getAllProviders().forEach(function(pluggable) {
            return _this.configurePluggable(pluggable);
        });
    };
    PredictionsClass.prototype.interpret = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._interpretPluggables, options);
        return pluggableToExecute.interpret(input);
    };
    PredictionsClass.prototype.convert = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._convertPluggables, options);
        return pluggableToExecute.convert(input);
    };
    PredictionsClass.prototype.identify = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._identifyPluggables, options);
        return pluggableToExecute.identify(input);
    };
    // tslint:disable-next-line: max-line-length
    PredictionsClass.prototype.getPluggableToExecute = function(pluggables, providerOptions) {
        // Give preference to provider name first since it is more specific to this call, even if
        // there is only one provider configured to error out if the name provided is not the one matched.
        if (providerOptions && providerOptions.providerName) return (0, _tslib.__spread)(pluggables).find(function(pluggable) {
            return pluggable.getProviderName() === providerOptions.providerName;
        });
        else {
            if (pluggables.length === 1) return pluggables[0];
            else throw new Error("More than one or no providers are configured, Either specify a provider name or configure exactly one provider");
        }
    };
    PredictionsClass.prototype.getAllProviders = function() {
        return (0, _tslib.__spread)(this._convertPluggables, this._identifyPluggables, this._interpretPluggables);
    };
    PredictionsClass.prototype.configurePluggable = function(pluggable) {
        var categoryConfig = Object.assign({}, this._options["predictions"], this._options[pluggable.getCategory().toLowerCase()] // Actual category level config
        );
        pluggable.configure(categoryConfig);
    };
    PredictionsClass.prototype.implementsConvertPluggable = function(obj) {
        return obj && typeof obj.convert === "function";
    };
    PredictionsClass.prototype.implementsIdentifyPluggable = function(obj) {
        return obj && typeof obj.identify === "function";
    };
    PredictionsClass.prototype.implementsInterpretPluggable = function(obj) {
        return obj && typeof obj.interpret === "function";
    };
    return PredictionsClass;
}();
var Predictions = new PredictionsClass({});
(0, _core.Amplify).register(Predictions);

},{"tslib":"bZghs","@aws-amplify/core":"3rlh1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bZghs":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dqyLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSRContext", ()=>withSSRContext);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _api = require("@aws-amplify/api");
var _internals = require("@aws-amplify/api/internals");
var _auth = require("@aws-amplify/auth");
var _core = require("@aws-amplify/core");
var _datastore = require("@aws-amplify/datastore");
// ! We have to use this exact reference, since it gets mutated with Amplify.Auth
var _index = require("./index");
var requiredModules = [
    // API cannot function without Auth
    (0, _auth.Auth),
    // Auth cannot function without Credentials
    (0, _core.Credentials)
];
// These modules have been tested with SSR
var defaultModules = [
    (0, _api.API),
    (0, _auth.Auth),
    (0, _datastore.DataStore)
];
function withSSRContext(context) {
    if (context === void 0) context = {};
    var _a = context.modules, modules = _a === void 0 ? defaultModules : _a, req = context.req;
    if (modules.includes((0, _datastore.DataStore)) && !modules.includes((0, _internals.InternalAPI))) modules.push((0, _internals.InternalAPI));
    var previousConfig = (0, _index.Amplify).configure();
    var amplify = new (0, _core.AmplifyClass)();
    var storage = new (0, _core.UniversalStorage)({
        req: req
    });
    requiredModules.forEach(function(m) {
        if (!modules.includes(m)) // @ts-ignore This expression is not constructable.
        // Type 'Function' has no construct signatures.ts(2351)
        amplify.register(new m.constructor());
    });
    // Associate new module instances with this amplify
    modules.forEach(function(m) {
        amplify.register(new m.constructor());
    });
    // Configure new Amplify instances with previous configuration
    amplify.configure((0, _tslib.__assign)((0, _tslib.__assign)({}, previousConfig), {
        storage: storage
    }));
    return amplify;
}

},{"tslib":"86BcK","@aws-amplify/api":"6PDaW","@aws-amplify/api/internals":"6j6uC","@aws-amplify/auth":"ilv20","@aws-amplify/core":"3rlh1","@aws-amplify/datastore":"fPd7W","./index":"75VoS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3VEgf":[function(require,module,exports) {
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geo", ()=>(0, _geo.Geo));
var _geo = require("./Geo");

},{"./Geo":"fMwG4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMwG4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeoClass", ()=>GeoClass);
parcelHelpers.export(exports, "Geo", ()=>Geo);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _core = require("@aws-amplify/core");
var _amazonLocationServiceProvider = require("./Providers/AmazonLocationServiceProvider");
var _util = require("./util");
var logger = new (0, _core.ConsoleLogger)("Geo");
var DEFAULT_PROVIDER = "AmazonLocationService";
var GeoClass = /** @class */ function() {
    function GeoClass() {
        this._config = {};
        this._pluggables = [];
        logger.debug("Geo Options", this._config);
    }
    /**
     * get the name of the module category
     * @returns {string} name of the module category
     */ GeoClass.prototype.getModuleName = function() {
        return GeoClass.MODULE;
    };
    /**
     * add plugin into Geo category
     * @param {Object} pluggable - an instance of the plugin
     */ GeoClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Geo") {
            this._pluggables.push(pluggable);
            var config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            logger.debug("No plugin found with providerName", providerName);
            throw new Error("No plugin found in Geo for the provider");
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ GeoClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Geo
     * @param {Object} config - Configuration object for Geo
     * @return {Object} - Current configuration
     */ GeoClass.prototype.configure = function(config) {
        var _this = this;
        logger.debug("configure Geo");
        if (!config) return this._config;
        var amplifyConfig = (0, _core.parseAWSExports)(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Geo, config);
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, _amazonLocationServiceProvider.AmazonLocationServiceProvider)());
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @param {string} provider
     * @returns - Array of available map resources
     */ GeoClass.prototype.getAvailableMaps = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getAvailableMaps();
    };
    /**
     * Get the map resource set as default in amplify config
     * @param {string} provider
     * @returns - Map resource set as the default in amplify config
     */ GeoClass.prototype.getDefaultMap = function(provider) {
        if (provider === void 0) provider = DEFAULT_PROVIDER;
        var prov = this.getPluggable(provider);
        return prov.getDefaultMap();
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ GeoClass.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_1;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByText(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_1 = _b.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for search term suggestions based on input text
     * @param  {string} text - The text string that is to be search for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ GeoClass.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_2;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchForSuggestions(text, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_2 = _b.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Search for location by unique ID
     * @param  {string} placeId - Unique ID of the location that is to be searched for
     * @param  {searchByPlaceIdOptions} options? - Optional parameters to the search
     * @returns {Promise<Place>} - Resolves to a place with the given placeId
     */ GeoClass.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var providerName, prov, error_3;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        providerName = DEFAULT_PROVIDER;
                        prov = this.getPluggable(providerName);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.searchByPlaceId(placeId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ GeoClass.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, _b, lng, lat, error_4;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b = (0, _tslib.__read)(coordinates, 2), lng = _b[0], lat = _b[1];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        (0, _util.validateCoordinates)(lng, lat);
                        return [
                            4 /*yield*/ ,
                            prov.searchByCoordinates(coordinates, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 3:
                        error_4 = _c.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create geofences
     * @param geofences - Single or array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<SaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ GeoClass.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceInputArray, error_5;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofences)) geofenceInputArray = [
                            geofences
                        ];
                        else geofenceInputArray = geofences;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.saveGeofences(geofenceInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_5 = _b.sent();
                        logger.debug(error_5);
                        throw error_5;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get a single geofence by geofenceId
     * @param geofenceId: GeofenceId - The string id of the geofence to get
     * @param options?: GeofenceOptions - Optional parameters for getting a geofence
     * @returns Promise<Geofence> - Promise that resolves to a geofence object
     */ GeoClass.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_6;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.getGeofence(geofenceId, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_6 = _b.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * List geofences
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ GeoClass.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, error_7;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.listGeofences(options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_7 = _b.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ GeoClass.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, providerName, prov, geofenceIdsInputArray, error_8;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = (options || {}).providerName, providerName = _a === void 0 ? DEFAULT_PROVIDER : _a;
                        prov = this.getPluggable(providerName);
                        if (!Array.isArray(geofenceIds)) geofenceIdsInputArray = [
                            geofenceIds
                        ];
                        else geofenceIdsInputArray = geofenceIds;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            prov.deleteGeofences(geofenceIdsInputArray, options)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 3:
                        error_8 = _b.sent();
                        logger.debug(error_8);
                        throw error_8;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    GeoClass.MODULE = "Geo";
    return GeoClass;
}();
var Geo = new GeoClass();
(0, _core.Amplify).register(Geo);

},{"tslib":"6BFzs","@aws-amplify/core":"3rlh1","./Providers/AmazonLocationServiceProvider":"grnCH","./util":"9llQK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6BFzs":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"grnCH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmazonLocationServiceProvider", ()=>AmazonLocationServiceProvider);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _camelcaseKeys = require("camelcase-keys");
var _camelcaseKeysDefault = parcelHelpers.interopDefault(_camelcaseKeys);
var _core = require("@aws-amplify/core");
var _clientLocation = require("@aws-sdk/client-location");
var _util = require("../util");
var logger = new (0, _core.ConsoleLogger)("AmazonLocationServiceProvider");
var AmazonLocationServiceProvider = /** @class */ function() {
    /**
     * Initialize Geo with AWS configurations
     * @param {Object} config - Configuration object for Geo
     */ function AmazonLocationServiceProvider(config) {
        this._config = config ? config : {};
        logger.debug("Geo Options", this._config);
    }
    /**
     * get the category of the plugin
     * @returns {string} name of the category
     */ AmazonLocationServiceProvider.prototype.getCategory = function() {
        return AmazonLocationServiceProvider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     * @returns {string} name of the provider
     */ AmazonLocationServiceProvider.prototype.getProviderName = function() {
        return AmazonLocationServiceProvider.PROVIDER_NAME;
    };
    /**
     * Configure Geo part with aws configuration
     * @param {Object} config - Configuration of the Geo
     * @return {Object} - Current configuration
     */ AmazonLocationServiceProvider.prototype.configure = function(config) {
        logger.debug("configure Amazon Location Service Provider", config);
        if (!config) return this._config;
        this._config = Object.assign({}, this._config, config);
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @returns {AmazonLocationServiceMapStyle[]}- Array of available map resources
     */ AmazonLocationServiceProvider.prototype.getAvailableMaps = function() {
        this._verifyMapResources();
        var mapStyles = [];
        var availableMaps = this._config.maps.items;
        var region = this._config.region;
        for(var mapName in availableMaps){
            var style = availableMaps[mapName].style;
            mapStyles.push({
                mapName: mapName,
                style: style,
                region: region
            });
        }
        return mapStyles;
    };
    /**
     * Get the map resource set as default in amplify config
     * @returns {AmazonLocationServiceMapStyle} - Map resource set as the default in amplify config
     */ AmazonLocationServiceProvider.prototype.getDefaultMap = function() {
        this._verifyMapResources();
        var mapName = this._config.maps.default;
        var style = this._config.maps.items[mapName].style;
        var region = this._config.region;
        return {
            mapName: mapName,
            style: style,
            region: region
        };
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */ AmazonLocationServiceProvider.prototype.searchByText = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_1, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForTextCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_1 = _a.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults, {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Search for suggestions based on the input text
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<SearchForSuggestionsResults>} - Resolves to an array of search suggestion strings
     */ AmazonLocationServiceProvider.prototype.searchForSuggestions = function(text, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_2, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */ if (options) locationServiceInput = (0, _tslib.__assign)((0, _tslib.__assign)({}, locationServiceInput), (0, _util.mapSearchOptions)(options, locationServiceInput));
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForSuggestionsCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_2 = _a.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 5:
                        results = response.Results.map(function(result) {
                            return {
                                text: result.Text,
                                placeId: result.PlaceId
                            };
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyPlaceId = function(placeId) {
        if (placeId.length === 0) {
            var errorString = "PlaceId cannot be an empty string.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype.searchByPlaceId = function(placeId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, searchByPlaceIdInput, command, response, error_3, place;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        this._verifyPlaceId(placeId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        searchByPlaceIdInput = {
                            PlaceId: placeId,
                            IndexName: (options === null || options === void 0 ? void 0 : options.searchIndexName) || this._config.search_indices.default
                        };
                        command = new (0, _clientLocation.GetPlaceCommand)(searchByPlaceIdInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_3 = _a.sent();
                        logger.debug(error_3);
                        throw error_3;
                    case 5:
                        place = response.Place;
                        if (place) return [
                            2 /*return*/ ,
                            (0, _camelcaseKeysDefault.default)(place, {
                                deep: true
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */ AmazonLocationServiceProvider.prototype.searchByCoordinates = function(coordinates, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, locationServiceInput, client, command, response, error_4, PascalResults, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Position: coordinates,
                            IndexName: this._config.search_indices.default
                        };
                        if (options) {
                            if (options.searchIndexName) locationServiceInput.IndexName = options.searchIndexName;
                            locationServiceInput.MaxResults = options.maxResults;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.SearchPlaceIndexForPositionCommand)(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_4 = _a.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 5:
                        PascalResults = response.Results.map(function(result) {
                            return result.Place;
                        });
                        results = (0, _camelcaseKeysDefault.default)(PascalResults[0], {
                            deep: true
                        });
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Create geofences inside of a geofence collection
     * @param geofences - Array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<AmazonLocationServiceSaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */ AmazonLocationServiceProvider.prototype.saveGeofences = function(geofences, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, PascalGeofences, results, geofenceBatches, apiLimit;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofences.length < 1) throw new Error("Geofence input array is empty");
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofencesInput)(geofences);
                        PascalGeofences = geofences.map(function(_a) {
                            var geofenceId = _a.geofenceId, polygon = _a.geometry.polygon;
                            return {
                                GeofenceId: geofenceId,
                                Geometry: {
                                    Polygon: polygon
                                }
                            };
                        });
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceBatches = [];
                        while(PascalGeofences.length > 0){
                            apiLimit = 10;
                            geofenceBatches.push(PascalGeofences.splice(0, apiLimit));
                        }
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_5;
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                _a.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchPutGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_5 = _a.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofence) {
                                                    results.errors.push({
                                                        geofenceId: geofence.GeofenceId,
                                                        error: {
                                                            code: "APIConnectionError",
                                                            message: error_5.message
                                                        }
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                // Push all successes to results
                                                response.Successes.forEach(function(success) {
                                                    var GeofenceId = success.GeofenceId, CreateTime = success.CreateTime, UpdateTime = success.UpdateTime;
                                                    results.successes.push({
                                                        geofenceId: GeofenceId,
                                                        createTime: CreateTime,
                                                        updateTime: UpdateTime
                                                    });
                                                });
                                                // Push all errors to results
                                                response.Errors.forEach(function(error) {
                                                    var _a = error.Error, Code = _a.Code, Message = _a.Message, GeofenceId = error.GeofenceId;
                                                    results.errors.push({
                                                        error: {
                                                            code: Code,
                                                            message: Message
                                                        },
                                                        geofenceId: GeofenceId
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Get geofence from a geofence collection
     * @param geofenceId:string
     * @param options?: Optional parameters for getGeofence
     * @returns {Promise<AmazonLocationServiceGeofence>} - Promise that resolves to a geofence object
     */ AmazonLocationServiceProvider.prototype.getGeofence = function(geofenceId, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, commandInput, command, response, error_6, GeofenceId, CreateTime, UpdateTime, Status, Geometry, geofence;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        (0, _util.validateGeofenceId)(geofenceId);
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        commandInput = {
                            GeofenceId: geofenceId,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.GetGeofenceCommand)(commandInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_6 = _a.sent();
                        logger.debug(error_6);
                        throw error_6;
                    case 5:
                        GeofenceId = response.GeofenceId, CreateTime = response.CreateTime, UpdateTime = response.UpdateTime, Status = response.Status, Geometry = response.Geometry;
                        geofence = {
                            createTime: CreateTime,
                            geofenceId: GeofenceId,
                            geometry: {
                                polygon: Geometry.Polygon
                            },
                            status: Status,
                            updateTime: UpdateTime
                        };
                        return [
                            2 /*return*/ ,
                            geofence
                        ];
                }
            });
        });
    };
    /**
     * List geofences from a geofence collection
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */ AmazonLocationServiceProvider.prototype.listGeofences = function(options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, client, listGeofencesInput, command, response, error_7, NextToken, Entries, results;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        } catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        listGeofencesInput = {
                            NextToken: options === null || options === void 0 ? void 0 : options.nextToken,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default
                        };
                        command = new (0, _clientLocation.ListGeofencesCommand)(listGeofencesInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 3:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        error_7 = _a.sent();
                        logger.debug(error_7);
                        throw error_7;
                    case 5:
                        NextToken = response.NextToken, Entries = response.Entries;
                        results = {
                            entries: Entries.map(function(_a) {
                                var GeofenceId = _a.GeofenceId, CreateTime = _a.CreateTime, UpdateTime = _a.UpdateTime, Status = _a.Status, Polygon = _a.Geometry.Polygon;
                                return {
                                    geofenceId: GeofenceId,
                                    createTime: CreateTime,
                                    updateTime: UpdateTime,
                                    status: Status,
                                    geometry: {
                                        polygon: Polygon
                                    }
                                };
                            }),
                            nextToken: NextToken
                        };
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * Delete geofences from a geofence collection
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */ AmazonLocationServiceProvider.prototype.deleteGeofences = function(geofenceIds, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentialsOK, badGeofenceIds, results, geofenceIdBatches, count;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (geofenceIds.length < 1) throw new Error("GeofenceId input array is empty");
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        badGeofenceIds = geofenceIds.filter(function(geofenceId) {
                            try {
                                (0, _util.validateGeofenceId)(geofenceId);
                            } catch (error) {
                                return true;
                            }
                        });
                        if (badGeofenceIds.length > 0) throw new Error("Invalid geofence ids: " + badGeofenceIds.join(", "));
                        results = {
                            successes: [],
                            errors: []
                        };
                        geofenceIdBatches = [];
                        count = 0;
                        while(count < geofenceIds.length)geofenceIdBatches.push(geofenceIds.slice(count, count += 10));
                        return [
                            4 /*yield*/ ,
                            Promise.all(geofenceIdBatches.map(function(batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    var response, error_8, badGeofenceIds;
                                    var _a;
                                    return (0, _tslib.__generator)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                _b.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this._AmazonLocationServiceBatchDeleteGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)
                                                ];
                                            case 1:
                                                response = _b.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 2:
                                                error_8 = _b.sent();
                                                // If the API call fails, add the geofences to the errors array and move to next batch
                                                batch.forEach(function(geofenceId) {
                                                    var errorObject = {
                                                        geofenceId: geofenceId,
                                                        error: {
                                                            code: error_8.message,
                                                            message: error_8.message
                                                        }
                                                    };
                                                    results.errors.push(errorObject);
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            case 3:
                                                badGeofenceIds = response.Errors.map(function(_a) {
                                                    var geofenceId = _a.geofenceId;
                                                    return geofenceId;
                                                });
                                                (_a = results.successes).push.apply(_a, (0, _tslib.__spread)(batch.filter(function(Id) {
                                                    return !badGeofenceIds.includes(Id);
                                                })));
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AmazonLocationServiceProvider.prototype._ensureCredentials = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, cred, error_9;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, _core.Credentials).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            false
                        ];
                        cred = (0, _core.Credentials).shear(credentials);
                        logger.debug("Set credentials for storage. Credentials are:", cred);
                        this._config.credentials = cred;
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 2:
                        error_9 = _a.sent();
                        logger.debug("Ensure credentials error. Credentials are:", error_9);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyMapResources = function() {
        if (!this._config.maps) {
            var errorString = "No map resources found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
        if (!this._config.maps.default) {
            var errorString = "No default map resource found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifySearchIndex = function(optionalSearchIndex) {
        if ((!this._config.search_indices || !this._config.search_indices.default) && !optionalSearchIndex) {
            var errorString = "No Search Index found in amplify config, please run `amplify add geo` to create one and run `amplify push` after.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifyGeofenceCollections = function(optionalGeofenceCollectionName) {
        if ((!this._config.geofenceCollections || !this._config.geofenceCollections.default) && !optionalGeofenceCollectionName) {
            var errorString = "No Geofence Collections found, please run `amplify add geo` to create one and run `amplify push` after.";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchPutGeofenceCall = function(PascalGeofences, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var geofenceInput, client, command, response, error_10;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        geofenceInput = {
                            Entries: PascalGeofences,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchPutGeofenceCommand)(geofenceInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_10 = _a.sent();
                        throw error_10;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchDeleteGeofenceCall = function(geofenceIds, collectionName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var deleteGeofencesInput, client, command, response, error_11;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        deleteGeofencesInput = {
                            GeofenceIds: geofenceIds,
                            CollectionName: collectionName || this._config.geofenceCollections.default
                        };
                        client = new (0, _clientLocation.LocationClient)({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: (0, _core.getAmplifyUserAgentObject)()
                        });
                        command = new (0, _clientLocation.BatchDeleteGeofenceCommand)(deleteGeofencesInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.send(command)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_11 = _a.sent();
                        throw error_11;
                    case 4:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    AmazonLocationServiceProvider.CATEGORY = "Geo";
    AmazonLocationServiceProvider.PROVIDER_NAME = "AmazonLocationService";
    return AmazonLocationServiceProvider;
}();

},{"tslib":"6BFzs","camelcase-keys":"2sk6s","@aws-amplify/core":"3rlh1","@aws-sdk/client-location":"cvUL3","../util":"9llQK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sk6s":[function(require,module,exports) {
"use strict";
const mapObj = require("bb83174fd2ff41c9");
const camelCase = require("cca3cebeca29a2f8");
const QuickLru = require("f54dcd543b16f228");
const has = (array, key)=>array.some((x)=>{
        if (typeof x === "string") return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
const cache = new QuickLru({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
const isObject = (value)=>typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const camelCaseConvert = (input, options)=>{
    if (!isObject(input)) return input;
    options = {
        deep: false,
        pascalCase: false,
        ...options
    };
    const { exclude, pascalCase, stopPaths, deep } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = mapObj(value, makeMapper(path));
            }
            if (!(exclude && has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if (cache.has(cacheKey)) key = cache.get(cacheKey);
                else {
                    const ret = camelCase(key, {
                        pascalCase
                    });
                    if (key.length < 100) cache.set(cacheKey, ret);
                    key = ret;
                }
            }
            return [
                key,
                value
            ];
        };
    return mapObj(input, makeMapper(undefined));
};
module.exports = (input, options)=>{
    if (Array.isArray(input)) return Object.keys(input).map((key)=>camelCaseConvert(input[key], options));
    return camelCaseConvert(input, options);
};

},{"bb83174fd2ff41c9":"kqPHR","cca3cebeca29a2f8":"2ZllB","f54dcd543b16f228":"alLML"}],"kqPHR":[function(require,module,exports) {
"use strict";
const isObject = (value)=>typeof value === "object" && value !== null;
const mapObjectSkip = Symbol("skip");
// Customized for this use-case
const isObjectCustom = (value)=>isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === mapObjectSkip) continue;
        let [newKey, newValue, { shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === "__proto__") continue;
        if (options.deep && shouldRecurse && isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
module.exports = (object, mapper, options)=>{
    if (!isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return mapObject(object, mapper, options);
};
module.exports.mapObjectSkip = mapObjectSkip;

},{}],"2ZllB":[function(require,module,exports) {
"use strict";
const preserveCamelCase = (string)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && /[a-zA-Z]/.test(character) && character.toUpperCase() === character) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(character) && character.toLowerCase() === character) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = character.toLowerCase() === character && character.toUpperCase() !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = character.toUpperCase() === character && character.toLowerCase() !== character;
        }
    }
    return string;
};
const camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = Object.assign({
        pascalCase: false
    }, options);
    const postProcess = (x)=>options.pascalCase ? x.charAt(0).toUpperCase() + x.slice(1) : x;
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    if (input.length === 1) return options.pascalCase ? input.toUpperCase() : input.toLowerCase();
    const hasUpperCase = input !== input.toLowerCase();
    if (hasUpperCase) input = preserveCamelCase(input);
    input = input.replace(/^[_.\- ]+/, "").toLowerCase().replace(/[_.\- ]+(\w|$)/g, (_, p1)=>p1.toUpperCase()).replace(/\d+(\w|$)/g, (m)=>m.toUpperCase());
    return postProcess(input);
};
module.exports = camelCase;
// TODO: Remove this for the next major release
module.exports.default = camelCase;

},{}],"alLML":[function(require,module,exports) {
"use strict";
class QuickLRU {
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this._set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.set(key, value);
        else this._set(key, value);
        return this;
    }
    has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
    }
    peek(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) return this.oldCache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache)yield item;
        for (const item of this.oldCache){
            const [key] = item;
            if (!this.cache.has(key)) yield item;
        }
    }
    get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return this._size + oldCacheSize;
    }
    constructor(options = {}){
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = options.maxSize;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
}
module.exports = QuickLRU;

},{}],"cvUL3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", ()=>(0, _locationServiceException.LocationServiceException));
var _location = require("./Location");
parcelHelpers.exportAll(_location, exports);
var _locationClient = require("./LocationClient");
parcelHelpers.exportAll(_locationClient, exports);
var _commands = require("./commands");
parcelHelpers.exportAll(_commands, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _pagination = require("./pagination");
parcelHelpers.exportAll(_pagination, exports);
var _locationServiceException = require("./models/LocationServiceException");

},{"./Location":false,"./LocationClient":"jYDhq","./commands":"9Rcjt","./models":false,"./pagination":false,"./models/LocationServiceException":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jYDhq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationClient", ()=>LocationClient);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var _middlewareContentLength = require("@aws-sdk/middleware-content-length");
var _middlewareHostHeader = require("@aws-sdk/middleware-host-header");
var _middlewareLogger = require("@aws-sdk/middleware-logger");
var _middlewareRecursionDetection = require("@aws-sdk/middleware-recursion-detection");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _middlewareSigning = require("@aws-sdk/middleware-signing");
var _middlewareUserAgent = require("@aws-sdk/middleware-user-agent");
var _smithyClient = require("@aws-sdk/smithy-client");
var _runtimeConfig = require("./runtimeConfig");
var LocationClient = function(_super) {
    (0, _tslib.__extends)(LocationClient, _super);
    function LocationClient(configuration) {
        var _this = this;
        var _config_0 = (0, _runtimeConfig.getRuntimeConfig)(configuration);
        var _config_1 = (0, _configResolver.resolveRegionConfig)(_config_0);
        var _config_2 = (0, _configResolver.resolveEndpointsConfig)(_config_1);
        var _config_3 = (0, _middlewareRetry.resolveRetryConfig)(_config_2);
        var _config_4 = (0, _middlewareHostHeader.resolveHostHeaderConfig)(_config_3);
        var _config_5 = (0, _middlewareSigning.resolveAwsAuthConfig)(_config_4);
        var _config_6 = (0, _middlewareUserAgent.resolveUserAgentConfig)(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use((0, _middlewareRetry.getRetryPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareContentLength.getContentLengthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareHostHeader.getHostHeaderPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareLogger.getLoggerPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareRecursionDetection.getRecursionDetectionPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareSigning.getAwsAuthPlugin)(_this.config));
        _this.middlewareStack.use((0, _middlewareUserAgent.getUserAgentPlugin)(_this.config));
        return _this;
    }
    LocationClient.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
    };
    return LocationClient;
}((0, _smithyClient.Client));

},{"tslib":"86BcK","@aws-sdk/config-resolver":"hrpyw","@aws-sdk/middleware-content-length":"5rsXh","@aws-sdk/middleware-host-header":"cj0v1","@aws-sdk/middleware-logger":"6uZPJ","@aws-sdk/middleware-recursion-detection":"l81JW","@aws-sdk/middleware-retry":"ijyar","@aws-sdk/middleware-signing":"5XJJZ","@aws-sdk/middleware-user-agent":"1ZRPH","@aws-sdk/smithy-client":"6yS5y","./runtimeConfig":"2UBhJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hrpyw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _endpointsConfig = require("./endpointsConfig");
parcelHelpers.exportAll(_endpointsConfig, exports);
var _regionConfig = require("./regionConfig");
parcelHelpers.exportAll(_regionConfig, exports);
var _regionInfo = require("./regionInfo");
parcelHelpers.exportAll(_regionInfo, exports);

},{"./endpointsConfig":"6x2PN","./regionConfig":"9Vx4e","./regionInfo":"aDVZ8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6x2PN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nodeUseDualstackEndpointConfigOptions = require("./NodeUseDualstackEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseDualstackEndpointConfigOptions, exports);
var _nodeUseFipsEndpointConfigOptions = require("./NodeUseFipsEndpointConfigOptions");
parcelHelpers.exportAll(_nodeUseFipsEndpointConfigOptions, exports);
var _resolveCustomEndpointsConfig = require("./resolveCustomEndpointsConfig");
parcelHelpers.exportAll(_resolveCustomEndpointsConfig, exports);
var _resolveEndpointsConfig = require("./resolveEndpointsConfig");
parcelHelpers.exportAll(_resolveEndpointsConfig, exports);

},{"./NodeUseDualstackEndpointConfigOptions":"6gtgL","./NodeUseFipsEndpointConfigOptions":"kd72E","./resolveCustomEndpointsConfig":"9gzGs","./resolveEndpointsConfig":"67yy8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gtgL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_DUALSTACK_ENDPOINT", ()=>ENV_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_DUALSTACK_ENDPOINT", ()=>CONFIG_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", ()=>DEFAULT_USE_DUALSTACK_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
var CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
var DEFAULT_USE_DUALSTACK_ENDPOINT = false;
var NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_DUALSTACK_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kd72E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_USE_FIPS_ENDPOINT", ()=>ENV_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "CONFIG_USE_FIPS_ENDPOINT", ()=>CONFIG_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "DEFAULT_USE_FIPS_ENDPOINT", ()=>DEFAULT_USE_FIPS_ENDPOINT);
parcelHelpers.export(exports, "NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS", ()=>NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS);
var _utilConfigProvider = require("@aws-sdk/util-config-provider");
var ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
var CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
var DEFAULT_USE_FIPS_ENDPOINT = false;
var NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return (0, _utilConfigProvider.booleanSelector)(env, ENV_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).ENV);
    },
    configFileSelector: function(profile) {
        return (0, _utilConfigProvider.booleanSelector)(profile, CONFIG_USE_FIPS_ENDPOINT, (0, _utilConfigProvider.SelectorType).CONFIG);
    },
    default: false
};

},{"@aws-sdk/util-config-provider":"5vFvE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9gzGs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveCustomEndpointsConfig", ()=>resolveCustomEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var resolveCustomEndpointsConfig = function(input) {
    var _a;
    var endpoint = input.endpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint)
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"67yy8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveEndpointsConfig", ()=>resolveEndpointsConfig);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _getEndpointFromRegion = require("./utils/getEndpointFromRegion");
var resolveEndpointsConfig = function(input) {
    var _a;
    var useDualstackEndpoint = (0, _utilMiddleware.normalizeProvider)(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true,
        endpoint: endpoint ? (0, _utilMiddleware.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : function() {
            return (0, _getEndpointFromRegion.getEndpointFromRegion)((0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }));
        },
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    });
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./utils/getEndpointFromRegion":"75X2L","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75X2L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndpointFromRegion", ()=>getEndpointFromRegion);
var _tslib = require("tslib");
var getEndpointFromRegion = function(input) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, tls, region, dnsHostRegex, useDualstackEndpoint, useFipsEndpoint, hostname;
        var _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    _a = input.tls, tls = _a === void 0 ? true : _a;
                    return [
                        4,
                        input.region()
                    ];
                case 1:
                    region = _c.sent();
                    dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
                    return [
                        4,
                        input.useDualstackEndpoint()
                    ];
                case 2:
                    useDualstackEndpoint = _c.sent();
                    return [
                        4,
                        input.useFipsEndpoint()
                    ];
                case 3:
                    useFipsEndpoint = _c.sent();
                    return [
                        4,
                        input.regionInfoProvider(region, {
                            useDualstackEndpoint: useDualstackEndpoint,
                            useFipsEndpoint: useFipsEndpoint
                        })
                    ];
                case 4:
                    hostname = ((_b = _c.sent()) !== null && _b !== void 0 ? _b : {}).hostname;
                    if (!hostname) throw new Error("Cannot resolve hostname from client config");
                    return [
                        2,
                        input.urlParser("".concat(tls ? "https:" : "http:", "//").concat(hostname))
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Vx4e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _resolveRegionConfig = require("./resolveRegionConfig");
parcelHelpers.exportAll(_resolveRegionConfig, exports);

},{"./config":"dW40D","./resolveRegionConfig":"lW1Hi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dW40D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REGION_ENV_NAME", ()=>REGION_ENV_NAME);
parcelHelpers.export(exports, "REGION_INI_NAME", ()=>REGION_INI_NAME);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_OPTIONS", ()=>NODE_REGION_CONFIG_OPTIONS);
parcelHelpers.export(exports, "NODE_REGION_CONFIG_FILE_OPTIONS", ()=>NODE_REGION_CONFIG_FILE_OPTIONS);
var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[REGION_ENV_NAME];
    },
    configFileSelector: function(profile) {
        return profile[REGION_INI_NAME];
    },
    default: function() {
        throw new Error("Region is missing");
    }
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lW1Hi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveRegionConfig", ()=>resolveRegionConfig);
var _tslib = require("tslib");
var _getRealRegion = require("./getRealRegion");
var _isFipsRegion = require("./isFipsRegion");
var resolveRegionConfig = function(input) {
    var region = input.region, useFipsEndpoint = input.useFipsEndpoint;
    if (!region) throw new Error("Region is missing");
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        region: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (typeof region === "string") return [
                                2,
                                (0, _getRealRegion.getRealRegion)(region)
                            ];
                            return [
                                4,
                                region()
                            ];
                        case 1:
                            providedRegion = _a.sent();
                            return [
                                2,
                                (0, _getRealRegion.getRealRegion)(providedRegion)
                            ];
                    }
                });
            });
        },
        useFipsEndpoint: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var providedRegion, _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!(typeof region === "string")) return [
                                3,
                                1
                            ];
                            _a = region;
                            return [
                                3,
                                3
                            ];
                        case 1:
                            return [
                                4,
                                region()
                            ];
                        case 2:
                            _a = _b.sent();
                            _b.label = 3;
                        case 3:
                            providedRegion = _a;
                            if ((0, _isFipsRegion.isFipsRegion)(providedRegion)) return [
                                2,
                                true
                            ];
                            return [
                                2,
                                typeof useFipsEndpoint === "boolean" ? Promise.resolve(useFipsEndpoint) : useFipsEndpoint()
                            ];
                    }
                });
            });
        }
    });
};

},{"tslib":"86BcK","./getRealRegion":"7qQ4P","./isFipsRegion":"4RbtZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7qQ4P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealRegion", ()=>getRealRegion);
var _isFipsRegion = require("./isFipsRegion");
var getRealRegion = function(region) {
    return (0, _isFipsRegion.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
};

},{"./isFipsRegion":"4RbtZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4RbtZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFipsRegion", ()=>isFipsRegion);
var isFipsRegion = function(region) {
    return typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aDVZ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _partitionHash = require("./PartitionHash");
parcelHelpers.exportAll(_partitionHash, exports);
var _regionHash = require("./RegionHash");
parcelHelpers.exportAll(_regionHash, exports);
var _getRegionInfo = require("./getRegionInfo");
parcelHelpers.exportAll(_getRegionInfo, exports);

},{"./PartitionHash":"80oMe","./RegionHash":"gjkpo","./getRegionInfo":"j29r8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"80oMe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gjkpo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j29r8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegionInfo", ()=>getRegionInfo);
var _tslib = require("tslib");
var _getHostnameFromVariants = require("./getHostnameFromVariants");
var _getResolvedHostname = require("./getResolvedHostname");
var _getResolvedPartition = require("./getResolvedPartition");
var _getResolvedSigningRegion = require("./getResolvedSigningRegion");
var getRegionInfo = function(region, _a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.useFipsEndpoint, useFipsEndpoint = _h === void 0 ? false : _h, _j = _a.useDualstackEndpoint, useDualstackEndpoint = _j === void 0 ? false : _j, signingService = _a.signingService, regionHash = _a.regionHash, partitionHash = _a.partitionHash;
    var partition = (0, _getResolvedPartition.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    var resolvedRegion = region in regionHash ? region : (_c = (_b = partitionHash[partition]) === null || _b === void 0 ? void 0 : _b.endpoint) !== null && _c !== void 0 ? _c : region;
    var hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    var regionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_d = regionHash[resolvedRegion]) === null || _d === void 0 ? void 0 : _d.variants, hostnameOptions);
    var partitionHostname = (0, _getHostnameFromVariants.getHostnameFromVariants)((_e = partitionHash[partition]) === null || _e === void 0 ? void 0 : _e.variants, hostnameOptions);
    var hostname = (0, _getResolvedHostname.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error("Endpoint resolution failed for: ".concat({
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }));
    var signingRegion = (0, _getResolvedSigningRegion.getResolvedSigningRegion)(hostname, {
        signingRegion: (_f = regionHash[resolvedRegion]) === null || _f === void 0 ? void 0 : _f.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({
        partition: partition,
        signingService: signingService,
        hostname: hostname
    }, signingRegion && {
        signingRegion: signingRegion
    }), ((_g = regionHash[resolvedRegion]) === null || _g === void 0 ? void 0 : _g.signingService) && {
        signingService: regionHash[resolvedRegion].signingService
    });
};

},{"tslib":"86BcK","./getHostnameFromVariants":"fGvhT","./getResolvedHostname":"hHIjA","./getResolvedPartition":"jJD5s","./getResolvedSigningRegion":"gQkaW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGvhT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHostnameFromVariants", ()=>getHostnameFromVariants);
var getHostnameFromVariants = function(variants, _a) {
    var _b;
    if (variants === void 0) variants = [];
    var useFipsEndpoint = _a.useFipsEndpoint, useDualstackEndpoint = _a.useDualstackEndpoint;
    return (_b = variants.find(function(_a) {
        var tags = _a.tags;
        return useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack");
    })) === null || _b === void 0 ? void 0 : _b.hostname;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hHIjA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedHostname", ()=>getResolvedHostname);
var getResolvedHostname = function(resolvedRegion, _a) {
    var regionHostname = _a.regionHostname, partitionHostname = _a.partitionHostname;
    return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jJD5s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedPartition", ()=>getResolvedPartition);
var getResolvedPartition = function(region, _a) {
    var _b;
    var partitionHash = _a.partitionHash;
    return (_b = Object.keys(partitionHash || {}).find(function(key) {
        return partitionHash[key].regions.includes(region);
    })) !== null && _b !== void 0 ? _b : "aws";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gQkaW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedSigningRegion", ()=>getResolvedSigningRegion);
var getResolvedSigningRegion = function(hostname, _a) {
    var signingRegion = _a.signingRegion, regionRegex = _a.regionRegex, useFipsEndpoint = _a.useFipsEndpoint;
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        var regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        var regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rsXh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentLengthMiddleware", ()=>contentLengthMiddleware);
parcelHelpers.export(exports, "contentLengthMiddlewareOptions", ()=>contentLengthMiddlewareOptions);
parcelHelpers.export(exports, "getContentLengthPlugin", ()=>getContentLengthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var request, body, headers, length_1;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        body = request.body, headers = request.headers;
                        if (body && Object.keys(headers).map(function(str) {
                            return str.toLowerCase();
                        }).indexOf(CONTENT_LENGTH_HEADER) === -1) try {
                            length_1 = bodyLengthChecker(body);
                            request.headers = (0, _tslib.__assign)((0, _tslib.__assign)({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length_1), _a));
                        } catch (error) {}
                    }
                    return [
                        2,
                        next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                            request: request
                        }))
                    ];
                });
            });
        };
    };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
var getContentLengthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k6jTb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _httpHandler = require("./httpHandler");
parcelHelpers.exportAll(_httpHandler, exports);
var _httpRequest = require("./httpRequest");
parcelHelpers.exportAll(_httpRequest, exports);
var _httpResponse = require("./httpResponse");
parcelHelpers.exportAll(_httpResponse, exports);
var _isValidHostname = require("./isValidHostname");
parcelHelpers.exportAll(_isValidHostname, exports);

},{"./httpHandler":"7Fcpb","./httpRequest":"eRSKt","./httpResponse":"aso92","./isValidHostname":"00bl8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Fcpb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eRSKt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpRequest", ()=>HttpRequest);
var _tslib = require("tslib");
var HttpRequest = function() {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? "".concat(options.protocol, ":") : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? "/".concat(options.path) : options.path : "/";
    }
    HttpRequest.isInstance = function(request) {
        if (!request) return false;
        var req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    };
    HttpRequest.prototype.clone = function() {
        var cloned = new HttpRequest((0, _tslib.__assign)((0, _tslib.__assign)({}, this), {
            headers: (0, _tslib.__assign)({}, this.headers)
        }));
        if (cloned.query) cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}();
function cloneQuery(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aso92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpResponse", ()=>HttpResponse);
var HttpResponse = function() {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function(response) {
        if (!response) return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"00bl8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidHostname", ()=>isValidHostname);
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cj0v1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHostHeaderConfig", ()=>resolveHostHeaderConfig);
parcelHelpers.export(exports, "hostHeaderMiddleware", ()=>hostHeaderMiddleware);
parcelHelpers.export(exports, "hostHeaderMiddlewareOptions", ()=>hostHeaderMiddlewareOptions);
parcelHelpers.export(exports, "getHostHeaderPlugin", ()=>getHostHeaderPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function(options) {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, _a, handlerProtocol;
                return (0, _tslib.__generator)(this, function(_b) {
                    if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                        2,
                        next(args)
                    ];
                    request = args.request;
                    _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
                    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                        delete request.headers["host"];
                        request.headers[":authority"] = "";
                    } else if (!request.headers["host"]) request.headers["host"] = request.hostname;
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
var getHostHeaderPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6uZPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loggerMiddleware = require("./loggerMiddleware");
parcelHelpers.exportAll(_loggerMiddleware, exports);

},{"./loggerMiddleware":"i9ywG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9ywG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggerMiddleware", ()=>loggerMiddleware);
parcelHelpers.export(exports, "loggerMiddlewareOptions", ()=>loggerMiddlewareOptions);
parcelHelpers.export(exports, "getLoggerPlugin", ()=>getLoggerPlugin);
var _tslib = require("tslib");
var loggerMiddleware = function() {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _b.sent();
                            if (!logger) return [
                                2,
                                response
                            ];
                            if (typeof logger.info === "function") {
                                _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = (0, _tslib.__rest)(_a, [
                                    "$metadata"
                                ]);
                                logger.info({
                                    clientName: clientName,
                                    commandName: commandName,
                                    input: inputFilterSensitiveLog(args.input),
                                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                                    metadata: $metadata
                                });
                            }
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
        };
    };
};
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
var getLoggerPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ijyar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
parcelHelpers.exportAll(_adaptiveRetryStrategy, exports);
var _defaultRateLimiter = require("./DefaultRateLimiter");
parcelHelpers.exportAll(_defaultRateLimiter, exports);
var _standardRetryStrategy = require("./StandardRetryStrategy");
parcelHelpers.exportAll(_standardRetryStrategy, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _delayDecider = require("./delayDecider");
parcelHelpers.exportAll(_delayDecider, exports);
var _omitRetryHeadersMiddleware = require("./omitRetryHeadersMiddleware");
parcelHelpers.exportAll(_omitRetryHeadersMiddleware, exports);
var _retryDecider = require("./retryDecider");
parcelHelpers.exportAll(_retryDecider, exports);
var _retryMiddleware = require("./retryMiddleware");
parcelHelpers.exportAll(_retryMiddleware, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./AdaptiveRetryStrategy":"emddA","./DefaultRateLimiter":"cCOer","./StandardRetryStrategy":"imedv","./config":"hQIHz","./configurations":"Q2Mhy","./delayDecider":"ebtOs","./omitRetryHeadersMiddleware":"fKO21","./retryDecider":"63w1T","./retryMiddleware":"cus98","./types":"eV7Cn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"emddA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveRetryStrategy", ()=>AdaptiveRetryStrategy);
var _tslib = require("tslib");
var _config = require("./config");
var _defaultRateLimiter = require("./DefaultRateLimiter");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var AdaptiveRetryStrategy = function(_super) {
    (0, _tslib.__extends)(AdaptiveRetryStrategy, _super);
    function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
        var _this = this;
        var _a = options !== null && options !== void 0 ? options : {}, rateLimiter = _a.rateLimiter, superOptions = (0, _tslib.__rest)(_a, [
            "rateLimiter"
        ]);
        _this = _super.call(this, maxAttemptsProvider, superOptions) || this;
        _this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new (0, _defaultRateLimiter.DefaultRateLimiter)();
        _this.mode = (0, _config.RETRY_MODES).ADAPTIVE;
        return _this;
    }
    AdaptiveRetryStrategy.prototype.retry = function(next, args) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    _super.prototype.retry.call(this, next, args, {
                        beforeRequest: function() {
                            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                return (0, _tslib.__generator)(this, function(_a) {
                                    return [
                                        2,
                                        this.rateLimiter.getSendToken()
                                    ];
                                });
                            });
                        },
                        afterRequest: function(response) {
                            _this.rateLimiter.updateClientSendingRate(response);
                        }
                    })
                ];
            });
        });
    };
    return AdaptiveRetryStrategy;
}((0, _standardRetryStrategy.StandardRetryStrategy));

},{"tslib":"86BcK","./config":"hQIHz","./DefaultRateLimiter":"cCOer","./StandardRetryStrategy":"imedv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hQIHz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RETRY_MODES", ()=>RETRY_MODES);
parcelHelpers.export(exports, "DEFAULT_MAX_ATTEMPTS", ()=>DEFAULT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_RETRY_MODE", ()=>DEFAULT_RETRY_MODE);
var RETRY_MODES;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
var DEFAULT_MAX_ATTEMPTS = 3;
var DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cCOer":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultRateLimiter", ()=>DefaultRateLimiter);
var _tslib = require("tslib");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var DefaultRateLimiter = function() {
    function DefaultRateLimiter(options) {
        var _a, _b, _c, _d, _e;
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = (_a = options === null || options === void 0 ? void 0 : options.beta) !== null && _a !== void 0 ? _a : 0.7;
        this.minCapacity = (_b = options === null || options === void 0 ? void 0 : options.minCapacity) !== null && _b !== void 0 ? _b : 1;
        this.minFillRate = (_c = options === null || options === void 0 ? void 0 : options.minFillRate) !== null && _c !== void 0 ? _c : 0.5;
        this.scaleConstant = (_d = options === null || options === void 0 ? void 0 : options.scaleConstant) !== null && _d !== void 0 ? _d : 0.4;
        this.smooth = (_e = options === null || options === void 0 ? void 0 : options.smooth) !== null && _e !== void 0 ? _e : 0.8;
        var currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    DefaultRateLimiter.prototype.getCurrentTimeInSeconds = function() {
        return Date.now() / 1000;
    };
    DefaultRateLimiter.prototype.getSendToken = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2,
                    this.acquireTokenBucket(1)
                ];
            });
        });
    };
    DefaultRateLimiter.prototype.acquireTokenBucket = function(amount) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var delay_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.enabled) return [
                            2
                        ];
                        this.refillTokenBucket();
                        if (!(amount > this.currentCapacity)) return [
                            3,
                            2
                        ];
                        delay_1 = (amount - this.currentCapacity) / this.fillRate * 1000;
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, delay_1);
                            })
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.currentCapacity = this.currentCapacity - amount;
                        return [
                            2
                        ];
                }
            });
        });
    };
    DefaultRateLimiter.prototype.refillTokenBucket = function() {
        var timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        var fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    };
    DefaultRateLimiter.prototype.updateClientSendingRate = function(response) {
        var calculatedRate;
        this.updateMeasuredRate();
        if ((0, _serviceErrorClassification.isThrottlingError)(response)) {
            var rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        var newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    };
    DefaultRateLimiter.prototype.calculateTimeWindow = function() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    };
    DefaultRateLimiter.prototype.cubicThrottle = function(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    };
    DefaultRateLimiter.prototype.cubicSuccess = function(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    };
    DefaultRateLimiter.prototype.enableTokenBucket = function() {
        this.enabled = true;
    };
    DefaultRateLimiter.prototype.updateTokenBucketRate = function(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    };
    DefaultRateLimiter.prototype.updateMeasuredRate = function() {
        var t = this.getCurrentTimeInSeconds();
        var timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            var currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    };
    DefaultRateLimiter.prototype.getPrecise = function(num) {
        return parseFloat(num.toFixed(8));
    };
    return DefaultRateLimiter;
}();

},{"tslib":"86BcK","@aws-sdk/service-error-classification":"cClIb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cClIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRetryableByTrait", ()=>isRetryableByTrait);
parcelHelpers.export(exports, "isClockSkewError", ()=>isClockSkewError);
parcelHelpers.export(exports, "isThrottlingError", ()=>isThrottlingError);
parcelHelpers.export(exports, "isTransientError", ()=>isTransientError);
var _constants = require("./constants");
var isRetryableByTrait = function(error) {
    return error.$retryable !== undefined;
};
var isClockSkewError = function(error) {
    return (0, _constants.CLOCK_SKEW_ERROR_CODES).includes(error.name);
};
var isThrottlingError = function(error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 || (0, _constants.THROTTLING_ERROR_CODES).includes(error.name) || ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function(error) {
    var _a;
    return (0, _constants.TRANSIENT_ERROR_CODES).includes(error.name) || (0, _constants.NODEJS_TIMEOUT_ERROR_CODES).includes((error === null || error === void 0 ? void 0 : error.code) || "") || (0, _constants.TRANSIENT_ERROR_STATUS_CODES).includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};

},{"./constants":"e6KTO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6KTO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_SKEW_ERROR_CODES", ()=>CLOCK_SKEW_ERROR_CODES);
parcelHelpers.export(exports, "THROTTLING_ERROR_CODES", ()=>THROTTLING_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_CODES", ()=>TRANSIENT_ERROR_CODES);
parcelHelpers.export(exports, "TRANSIENT_ERROR_STATUS_CODES", ()=>TRANSIENT_ERROR_STATUS_CODES);
parcelHelpers.export(exports, "NODEJS_TIMEOUT_ERROR_CODES", ()=>NODEJS_TIMEOUT_ERROR_CODES);
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
var TRANSIENT_ERROR_CODES = [
    "AbortError",
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
var TRANSIENT_ERROR_STATUS_CODES = [
    500,
    502,
    503,
    504
];
var NODEJS_TIMEOUT_ERROR_CODES = [
    "ECONNRESET",
    "EPIPE",
    "ETIMEDOUT"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"imedv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandardRetryStrategy", ()=>StandardRetryStrategy);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var _uuid = require("uuid");
var _config = require("./config");
var _constants = require("./constants");
var _defaultRetryQuota = require("./defaultRetryQuota");
var _delayDecider = require("./delayDecider");
var _retryDecider = require("./retryDecider");
var StandardRetryStrategy = function() {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, _config.RETRY_MODES).STANDARD;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : (0, _retryDecider.defaultRetryDecider);
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : (0, _delayDecider.defaultDelayDecider);
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : (0, _defaultRetryQuota.getDefaultRetryQuota)((0, _constants.INITIAL_RETRY_TOKENS));
    }
    StandardRetryStrategy.prototype.shouldRetry = function(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var maxAttempts, error_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            this.maxAttemptsProvider()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = (0, _config.DEFAULT_MAX_ATTEMPTS);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            maxAttempts
                        ];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function(next, args, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [
                            4,
                            this.getMaxAttempts()
                        ];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.INVOCATION_ID_HEADER] = (0, _uuid.v4)();
                        _loop_1 = function() {
                            var _b, response, output, e_1, err, delayFromDecider, delayFromResponse, delay_1;
                            return (0, _tslib.__generator)(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        _c.trys.push([
                                            0,
                                            4,
                                            ,
                                            7
                                        ]);
                                        if ((0, _protocolHttp.HttpRequest).isInstance(request)) request.headers[0, _constants.REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                                        if (!(options === null || options === void 0 ? void 0 : options.beforeRequest)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            options.beforeRequest()
                                        ];
                                    case 1:
                                        _c.sent();
                                        _c.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            next(args)
                                        ];
                                    case 3:
                                        _b = _c.sent(), response = _b.response, output = _b.output;
                                        if (options === null || options === void 0 ? void 0 : options.afterRequest) options.afterRequest(response);
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [
                                            2,
                                            {
                                                value: {
                                                    response: response,
                                                    output: output
                                                }
                                            }
                                        ];
                                    case 4:
                                        e_1 = _c.sent();
                                        err = asSdkError(e_1);
                                        attempts++;
                                        if (!this_1.shouldRetry(err, attempts, maxAttempts)) return [
                                            3,
                                            6
                                        ];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err);
                                        delayFromDecider = this_1.delayDecider((0, _serviceErrorClassification.isThrottlingError)(err) ? (0, _constants.THROTTLING_RETRY_DELAY_BASE) : (0, _constants.DEFAULT_RETRY_DELAY_BASE), attempts);
                                        delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                                        delay_1 = Math.max(delayFromResponse || 0, delayFromDecider);
                                        totalDelay += delay_1;
                                        return [
                                            4,
                                            new Promise(function(resolve) {
                                                return setTimeout(resolve, delay_1);
                                            })
                                        ];
                                    case 5:
                                        _c.sent();
                                        return [
                                            2,
                                            "continue"
                                        ];
                                    case 6:
                                        if (!err.$metadata) err.$metadata = {};
                                        err.$metadata.attempts = attempts;
                                        err.$metadata.totalRetryDelay = totalDelay;
                                        throw err;
                                    case 7:
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        return [
                            5,
                            _loop_1()
                        ];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object") return [
                            2,
                            state_1.value
                        ];
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StandardRetryStrategy;
}();
var getDelayFromRetryAfterHeader = function(response) {
    if (!(0, _protocolHttp.HttpResponse).isInstance(response)) return;
    var retryAfterHeaderName = Object.keys(response.headers).find(function(key) {
        return key.toLowerCase() === "retry-after";
    });
    if (!retryAfterHeaderName) return;
    var retryAfter = response.headers[retryAfterHeaderName];
    var retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    var retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};
var asSdkError = function(error) {
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error("AWS SDK error wrapper for ".concat(error));
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/service-error-classification":"cClIb","uuid":"hL32H","./config":"hQIHz","./constants":"9v1Q8","./defaultRetryQuota":"dVIOY","./delayDecider":"ebtOs","./retryDecider":"63w1T","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hL32H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"bNikX","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bNikX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"h8iZ0","./stringify.js":"bHrmw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h8iZ0":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bHrmw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"2p45N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2p45N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"3piaN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3piaN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9v1Q8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_DELAY_BASE", ()=>DEFAULT_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "MAXIMUM_RETRY_DELAY", ()=>MAXIMUM_RETRY_DELAY);
parcelHelpers.export(exports, "THROTTLING_RETRY_DELAY_BASE", ()=>THROTTLING_RETRY_DELAY_BASE);
parcelHelpers.export(exports, "INITIAL_RETRY_TOKENS", ()=>INITIAL_RETRY_TOKENS);
parcelHelpers.export(exports, "RETRY_COST", ()=>RETRY_COST);
parcelHelpers.export(exports, "TIMEOUT_RETRY_COST", ()=>TIMEOUT_RETRY_COST);
parcelHelpers.export(exports, "NO_RETRY_INCREMENT", ()=>NO_RETRY_INCREMENT);
parcelHelpers.export(exports, "INVOCATION_ID_HEADER", ()=>INVOCATION_ID_HEADER);
parcelHelpers.export(exports, "REQUEST_HEADER", ()=>REQUEST_HEADER);
var DEFAULT_RETRY_DELAY_BASE = 100;
var MAXIMUM_RETRY_DELAY = 20000;
var THROTTLING_RETRY_DELAY_BASE = 500;
var INITIAL_RETRY_TOKENS = 500;
var RETRY_COST = 5;
var TIMEOUT_RETRY_COST = 10;
var NO_RETRY_INCREMENT = 1;
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
var REQUEST_HEADER = "amz-sdk-request";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dVIOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultRetryQuota", ()=>getDefaultRetryQuota);
var _constants = require("./constants");
var getDefaultRetryQuota = function(initialRetryTokens, options) {
    var _a, _b, _c;
    var MAX_CAPACITY = initialRetryTokens;
    var noRetryIncrement = (_a = options === null || options === void 0 ? void 0 : options.noRetryIncrement) !== null && _a !== void 0 ? _a : (0, _constants.NO_RETRY_INCREMENT);
    var retryCost = (_b = options === null || options === void 0 ? void 0 : options.retryCost) !== null && _b !== void 0 ? _b : (0, _constants.RETRY_COST);
    var timeoutRetryCost = (_c = options === null || options === void 0 ? void 0 : options.timeoutRetryCost) !== null && _c !== void 0 ? _c : (0, _constants.TIMEOUT_RETRY_COST);
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function(error) {
        return error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    };
    var hasRetryTokens = function(error) {
        return getCapacityAmount(error) <= availableCapacity;
    };
    var retrieveRetryTokens = function(error) {
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function(capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

},{"./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ebtOs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDelayDecider", ()=>defaultDelayDecider);
var _constants = require("./constants");
var defaultDelayDecider = function(delayBase, attempts) {
    return Math.floor(Math.min((0, _constants.MAXIMUM_RETRY_DELAY), Math.random() * Math.pow(2, attempts) * delayBase));
};

},{"./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"63w1T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRetryDecider", ()=>defaultRetryDecider);
var _serviceErrorClassification = require("@aws-sdk/service-error-classification");
var defaultRetryDecider = function(error) {
    if (!error) return false;
    return (0, _serviceErrorClassification.isRetryableByTrait)(error) || (0, _serviceErrorClassification.isClockSkewError)(error) || (0, _serviceErrorClassification.isThrottlingError)(error) || (0, _serviceErrorClassification.isTransientError)(error);
};

},{"@aws-sdk/service-error-classification":"cClIb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Q2Mhy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENV_MAX_ATTEMPTS", ()=>ENV_MAX_ATTEMPTS);
parcelHelpers.export(exports, "CONFIG_MAX_ATTEMPTS", ()=>CONFIG_MAX_ATTEMPTS);
parcelHelpers.export(exports, "NODE_MAX_ATTEMPT_CONFIG_OPTIONS", ()=>NODE_MAX_ATTEMPT_CONFIG_OPTIONS);
parcelHelpers.export(exports, "resolveRetryConfig", ()=>resolveRetryConfig);
parcelHelpers.export(exports, "ENV_RETRY_MODE", ()=>ENV_RETRY_MODE);
parcelHelpers.export(exports, "CONFIG_RETRY_MODE", ()=>CONFIG_RETRY_MODE);
parcelHelpers.export(exports, "NODE_RETRY_MODE_CONFIG_OPTIONS", ()=>NODE_RETRY_MODE_CONFIG_OPTIONS);
var _tslib = require("tslib");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _adaptiveRetryStrategy = require("./AdaptiveRetryStrategy");
var _config = require("./config");
var _standardRetryStrategy = require("./StandardRetryStrategy");
var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    configFileSelector: function(profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value) return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, ' mast be a number, got "').concat(value, '"'));
        return maxAttempt;
    },
    default: (0, _config.DEFAULT_MAX_ATTEMPTS)
};
var resolveRetryConfig = function(input) {
    var _a;
    var maxAttempts = (0, _utilMiddleware.normalizeProvider)((_a = input.maxAttempts) !== null && _a !== void 0 ? _a : (0, _config.DEFAULT_MAX_ATTEMPTS));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        maxAttempts: maxAttempts,
        retryStrategy: function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryMode;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (input.retryStrategy) return [
                                2,
                                input.retryStrategy
                            ];
                            return [
                                4,
                                (0, _utilMiddleware.normalizeProvider)(input.retryMode)()
                            ];
                        case 1:
                            retryMode = _a.sent();
                            if (retryMode === (0, _config.RETRY_MODES).ADAPTIVE) return [
                                2,
                                new (0, _adaptiveRetryStrategy.AdaptiveRetryStrategy)(maxAttempts)
                            ];
                            return [
                                2,
                                new (0, _standardRetryStrategy.StandardRetryStrategy)(maxAttempts)
                            ];
                    }
                });
            });
        }
    });
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function(env) {
        return env[ENV_RETRY_MODE];
    },
    configFileSelector: function(profile) {
        return profile[CONFIG_RETRY_MODE];
    },
    default: (0, _config.DEFAULT_RETRY_MODE)
};

},{"tslib":"86BcK","@aws-sdk/util-middleware":"2OCR6","./AdaptiveRetryStrategy":"emddA","./config":"hQIHz","./StandardRetryStrategy":"imedv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKO21":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitRetryHeadersMiddleware", ()=>omitRetryHeadersMiddleware);
parcelHelpers.export(exports, "omitRetryHeadersMiddlewareOptions", ()=>omitRetryHeadersMiddlewareOptions);
parcelHelpers.export(exports, "getOmitRetryHeadersPlugin", ()=>getOmitRetryHeadersPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var omitRetryHeadersMiddleware = function() {
    return function(next) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request;
                return (0, _tslib.__generator)(this, function(_a) {
                    request = args.request;
                    if ((0, _protocolHttp.HttpRequest).isInstance(request)) {
                        delete request.headers[0, _constants.INVOCATION_ID_HEADER];
                        delete request.headers[0, _constants.REQUEST_HEADER];
                    }
                    return [
                        2,
                        next(args)
                    ];
                });
            });
        };
    };
};
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
var getOmitRetryHeadersPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./constants":"9v1Q8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cus98":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryMiddleware", ()=>retryMiddleware);
parcelHelpers.export(exports, "retryMiddlewareOptions", ()=>retryMiddlewareOptions);
parcelHelpers.export(exports, "getRetryPlugin", ()=>getRetryPlugin);
var _tslib = require("tslib");
var retryMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var retryStrategy;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                options.retryStrategy()
                            ];
                        case 1:
                            retryStrategy = _a.sent();
                            if (retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.mode) context.userAgent = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(context.userAgent || []), false), [
                                [
                                    "cfg/retry-mode",
                                    retryStrategy.mode
                                ]
                            ], false);
                            return [
                                2,
                                retryStrategy.retry(next, args)
                            ];
                    }
                });
            });
        };
    };
};
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
var getRetryPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eV7Cn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5XJJZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _middleware = require("./middleware");
parcelHelpers.exportAll(_middleware, exports);

},{"./configurations":"hNCtD","./middleware":"isI8R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNCtD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveAwsAuthConfig", ()=>resolveAwsAuthConfig);
parcelHelpers.export(exports, "resolveSigV4AuthConfig", ()=>resolveSigV4AuthConfig);
var _tslib = require("tslib");
var _propertyProvider = require("@aws-sdk/property-provider");
var _signatureV4 = require("@aws-sdk/signature-v4");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var CREDENTIAL_EXPIRE_WINDOW = 300000;
var resolveAwsAuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else if (input.regionInfoProvider) signer = function() {
        return (0, _utilMiddleware.normalizeProvider)(input.region)().then(function(region) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _b = (_a = input).regionInfoProvider;
                            _c = [
                                region
                            ];
                            _d = {};
                            return [
                                4,
                                input.useFipsEndpoint()
                            ];
                        case 1:
                            _d.useFipsEndpoint = _e.sent();
                            return [
                                4,
                                input.useDualstackEndpoint()
                            ];
                        case 2:
                            return [
                                4,
                                _b.apply(_a, _c.concat([
                                    (_d.useDualstackEndpoint = _e.sent(), _d)
                                ]))
                            ];
                        case 3:
                            return [
                                2,
                                [
                                    _e.sent() || {},
                                    region
                                ]
                            ];
                    }
                });
            });
        }).then(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), regionInfo = _b[0], region = _b[1];
            var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            var params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            });
            var SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
            return new SignerCtor(params);
        });
    };
    else signer = function(authScheme) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var signingRegion, signingService, params, SignerCtor;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!authScheme) throw new Error("Unexpected empty auth scheme config");
                signingRegion = authScheme.signingScope;
                signingService = authScheme.signingName;
                input.signingRegion = input.signingRegion || signingRegion;
                input.signingName = input.signingName || signingService || input.serviceId;
                params = (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath
                });
                SignerCtor = input.signerConstructor || (0, _signatureV4.SignatureV4);
                return [
                    2,
                    new SignerCtor(params)
                ];
            });
        });
    };
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var resolveSigV4AuthConfig = function(input) {
    var normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) signer = (0, _utilMiddleware.normalizeProvider)(input.signer);
    else signer = (0, _utilMiddleware.normalizeProvider)(new (0, _signatureV4.SignatureV4)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    });
};
var normalizeCredentialProvider = function(credentials) {
    if (typeof credentials === "function") return (0, _propertyProvider.memoize)(credentials, function(credentials) {
        return credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW;
    }, function(credentials) {
        return credentials.expiration !== undefined;
    });
    return (0, _utilMiddleware.normalizeProvider)(credentials);
};

},{"tslib":"86BcK","@aws-sdk/property-provider":"ltIOt","@aws-sdk/signature-v4":"bJCrY","@aws-sdk/util-middleware":"2OCR6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ltIOt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _credentialsProviderError = require("./CredentialsProviderError");
parcelHelpers.exportAll(_credentialsProviderError, exports);
var _providerError = require("./ProviderError");
parcelHelpers.exportAll(_providerError, exports);
var _tokenProviderError = require("./TokenProviderError");
parcelHelpers.exportAll(_tokenProviderError, exports);
var _chain = require("./chain");
parcelHelpers.exportAll(_chain, exports);
var _fromStatic = require("./fromStatic");
parcelHelpers.exportAll(_fromStatic, exports);
var _memoize = require("./memoize");
parcelHelpers.exportAll(_memoize, exports);

},{"./CredentialsProviderError":"dlwv5","./ProviderError":"8HNAw","./TokenProviderError":"gzwxR","./chain":"3udw1","./fromStatic":"9RC52","./memoize":"bUYoe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dlwv5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CredentialsProviderError", ()=>CredentialsProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var CredentialsProviderError = function(_super) {
    (0, _tslib.__extends)(CredentialsProviderError, _super);
    function CredentialsProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "CredentialsProviderError";
        Object.setPrototypeOf(_this, CredentialsProviderError.prototype);
        return _this;
    }
    return CredentialsProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8HNAw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProviderError", ()=>ProviderError);
var _tslib = require("tslib");
var ProviderError = function(_super) {
    (0, _tslib.__extends)(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "ProviderError";
        Object.setPrototypeOf(_this, ProviderError.prototype);
        return _this;
    }
    ProviderError.from = function(error, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        return Object.assign(new this(error.message, tryNextLink), error);
    };
    return ProviderError;
}(Error);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gzwxR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenProviderError", ()=>TokenProviderError);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
var TokenProviderError = function(_super) {
    (0, _tslib.__extends)(TokenProviderError, _super);
    function TokenProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) tryNextLink = true;
        var _this = _super.call(this, message, tryNextLink) || this;
        _this.tryNextLink = tryNextLink;
        _this.name = "TokenProviderError";
        Object.setPrototypeOf(_this, TokenProviderError.prototype);
        return _this;
    }
    return TokenProviderError;
}((0, _providerError.ProviderError));

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3udw1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chain", ()=>chain);
var _tslib = require("tslib");
var _providerError = require("./ProviderError");
function chain() {
    var providers = [];
    for(var _i = 0; _i < arguments.length; _i++)providers[_i] = arguments[_i];
    return function() {
        var e_1, _a;
        var promise = Promise.reject(new (0, _providerError.ProviderError)("No providers in chain"));
        var _loop_1 = function(provider) {
            promise = promise.catch(function(err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) return provider();
                throw err;
            });
        };
        try {
            for(var providers_1 = (0, _tslib.__values)(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()){
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return promise;
    };
}

},{"tslib":"86BcK","./ProviderError":"8HNAw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9RC52":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromStatic", ()=>fromStatic);
var fromStatic = function(staticValue) {
    return function() {
        return Promise.resolve(staticValue);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bUYoe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
var _tslib = require("tslib");
var memoize = function(provider, isExpired, requiresRefresh) {
    var resolved;
    var pending;
    var hasResult;
    var isConstant = false;
    var coalesceProvider = function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!pending) pending = provider();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            pending
                        ];
                    case 2:
                        resolved = _a.sent();
                        hasResult = true;
                        isConstant = false;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        pending = undefined;
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    if (isExpired === undefined) return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
    return function(options) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(!hasResult || (options === null || options === void 0 ? void 0 : options.forceRefresh))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 1:
                        resolved = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (isConstant) return [
                            2,
                            resolved
                        ];
                        if (requiresRefresh && !requiresRefresh(resolved)) {
                            isConstant = true;
                            return [
                                2,
                                resolved
                            ];
                        }
                        if (!isExpired(resolved)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            coalesceProvider()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2,
                            resolved
                        ];
                    case 4:
                        return [
                            2,
                            resolved
                        ];
                }
            });
        });
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJCrY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>(0, _getCanonicalHeaders.getCanonicalHeaders));
parcelHelpers.export(exports, "getCanonicalQuery", ()=>(0, _getCanonicalQuery.getCanonicalQuery));
parcelHelpers.export(exports, "getPayloadHash", ()=>(0, _getPayloadHash.getPayloadHash));
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>(0, _moveHeadersToQuery.moveHeadersToQuery));
parcelHelpers.export(exports, "prepareRequest", ()=>(0, _prepareRequest.prepareRequest));
var _signatureV4 = require("./SignatureV4");
parcelHelpers.exportAll(_signatureV4, exports);
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _credentialDerivation = require("./credentialDerivation");
parcelHelpers.exportAll(_credentialDerivation, exports);

},{"./SignatureV4":"3u9XY","./getCanonicalHeaders":"bx7bM","./getCanonicalQuery":"b9kbm","./getPayloadHash":"giq6m","./moveHeadersToQuery":"ilF8D","./prepareRequest":"ajmAz","./credentialDerivation":"5dTfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3u9XY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignatureV4", ()=>SignatureV4);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _utilMiddleware = require("@aws-sdk/util-middleware");
var _constants = require("./constants");
var _credentialDerivation = require("./credentialDerivation");
var _getCanonicalHeaders = require("./getCanonicalHeaders");
var _getCanonicalQuery = require("./getCanonicalQuery");
var _getPayloadHash = require("./getPayloadHash");
var _headerUtil = require("./headerUtil");
var _moveHeadersToQuery = require("./moveHeadersToQuery");
var _prepareRequest = require("./prepareRequest");
var _utilDate = require("./utilDate");
var SignatureV4 = function() {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, _utilMiddleware.normalizeProvider)(region);
        this.credentialProvider = (0, _utilMiddleware.normalizeProvider)(credentials);
    }
    SignatureV4.prototype.presign = function(originalRequest, options) {
        if (options === void 0) options = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return (0, _tslib.__generator)(this, function(_l) {
                switch(_l.label){
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _l.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _c = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _c = _l.sent();
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > (0, _constants.MAX_PRESIGNED_TTL)) return [
                            2,
                            Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future")
                        ];
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = (0, _moveHeadersToQuery.moveHeadersToQuery)((0, _prepareRequest.prepareRequest)(originalRequest), {
                            unhoistableHeaders: unhoistableHeaders
                        });
                        if (credentials.sessionToken) request.query[0, _constants.TOKEN_QUERY_PARAM] = credentials.sessionToken;
                        request.query[0, _constants.ALGORITHM_QUERY_PARAM] = (0, _constants.ALGORITHM_IDENTIFIER);
                        request.query[0, _constants.CREDENTIAL_QUERY_PARAM] = "".concat(credentials.accessKeyId, "/").concat(scope);
                        request.query[0, _constants.AMZ_DATE_QUERY_PARAM] = longDate;
                        request.query[0, _constants.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        request.query[0, _constants.SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = (0, _constants.SIGNATURE_QUERY_PARAM);
                        _g = this.getSignature;
                        _h = [
                            longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                        _j = this.createCanonicalRequest;
                        _k = [
                            request,
                            canonicalHeaders
                        ];
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(originalRequest, this.sha256)
                        ];
                    case 5:
                        return [
                            4,
                            _g.apply(this, _h.concat([
                                _j.apply(this, _k.concat([
                                    _l.sent()
                                ]))
                            ]))
                        ];
                    case 6:
                        _e[_f] = _l.sent();
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function(toSign, options) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof toSign === "string") return [
                    2,
                    this.signString(toSign, options)
                ];
                else if (toSign.headers && toSign.payload) return [
                    2,
                    this.signEvent(toSign, options)
                ];
                else return [
                    2,
                    this.signRequest(toSign, options)
                ];
                return [
                    2
                ];
            });
        });
    };
    SignatureV4.prototype.signEvent = function(_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return (0, _tslib.__generator)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            1
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 2:
                        _d = _g.sent();
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)({
                                headers: {},
                                body: payload
                            }, this.sha256)
                        ];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [
                            _g.sent()
                        ]);
                        stringToSign = [
                            (0, _constants.EVENT_ALGORITHM_IDENTIFIER),
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload
                        ].join("\n");
                        return [
                            2,
                            this.signString(stringToSign, {
                                signingDate: signingDate,
                                signingRegion: region,
                                signingService: signingService
                            })
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function(stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _h.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _h.sent();
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [
                            4,
                            this.getSigningKey(credentials, region, shortDate, signingService)
                        ];
                    case 5:
                        hash = new (_f.apply(_e, [
                            void 0,
                            _h.sent()
                        ]))();
                        hash.update(stringToSign);
                        _g = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 6:
                        return [
                            2,
                            _g.apply(void 0, [
                                _h.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function(requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        return [
                            4,
                            this.credentialProvider()
                        ];
                    case 1:
                        credentials = _f.sent();
                        this.validateResolvedCredentials(credentials);
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [
                            3,
                            2
                        ];
                        _d = signingRegion;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            this.regionProvider()
                        ];
                    case 3:
                        _d = _f.sent();
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = (0, _prepareRequest.prepareRequest)(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = (0, _credentialDerivation.createScope)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[0, _constants.AMZ_DATE_HEADER] = longDate;
                        if (credentials.sessionToken) request.headers[0, _constants.TOKEN_HEADER] = credentials.sessionToken;
                        return [
                            4,
                            (0, _getPayloadHash.getPayloadHash)(request, this.sha256)
                        ];
                    case 5:
                        payloadHash = _f.sent();
                        if (!(0, _headerUtil.hasHeader)((0, _constants.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, _constants.SHA256_HEADER] = payloadHash;
                        canonicalHeaders = (0, _getCanonicalHeaders.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
                        return [
                            4,
                            this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))
                        ];
                    case 6:
                        signature = _f.sent();
                        request.headers[0, _constants.AUTH_HEADER] = "".concat((0, _constants.ALGORITHM_IDENTIFIER), " ") + "Credential=".concat(credentials.accessKeyId, "/").concat(scope, ", ") + "SignedHeaders=".concat(getCanonicalHeaderList(canonicalHeaders), ", ") + "Signature=".concat(signature);
                        return [
                            2,
                            request
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function(request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return "".concat(request.method, "\n").concat(this.getCanonicalPath(request), "\n").concat((0, _getCanonicalQuery.getCanonicalQuery)(request), "\n").concat(sortedHeaders.map(function(name) {
            return "".concat(name, ":").concat(canonicalHeaders[name]);
        }).join("\n"), "\n\n").concat(sortedHeaders.join(";"), "\n").concat(payloadHash);
    };
    SignatureV4.prototype.createStringToSign = function(longDate, credentialScope, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var hash, hashedRequest;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 1:
                        hashedRequest = _a.sent();
                        return [
                            2,
                            "".concat((0, _constants.ALGORITHM_IDENTIFIER), "\n").concat(longDate, "\n").concat(credentialScope, "\n").concat((0, _utilHexEncoding.toHex)(hashedRequest))
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function(_a) {
        var e_1, _b;
        var path = _a.path;
        if (this.uriEscapePath) {
            var normalizedPathSegments = [];
            try {
                for(var _c = (0, _tslib.__values)(path.split("/")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var pathSegment = _d.value;
                    if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                    if (pathSegment === ".") continue;
                    if (pathSegment === "..") normalizedPathSegments.pop();
                    else normalizedPathSegments.push(pathSegment);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var normalizedPath = "".concat((path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : "").concat(normalizedPathSegments.join("/")).concat(normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : "");
            var doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function(longDate, credentialScope, keyPromise, canonicalRequest) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var stringToSign, hash, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4,
                            this.createStringToSign(longDate, credentialScope, canonicalRequest)
                        ];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [
                            4,
                            keyPromise
                        ];
                    case 2:
                        hash = new (_b.apply(_a, [
                            void 0,
                            _d.sent()
                        ]))();
                        hash.update(stringToSign);
                        _c = (0, _utilHexEncoding.toHex);
                        return [
                            4,
                            hash.digest()
                        ];
                    case 3:
                        return [
                            2,
                            _c.apply(void 0, [
                                _d.sent()
                            ])
                        ];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function(credentials, region, shortDate, service) {
        return (0, _credentialDerivation.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    };
    SignatureV4.prototype.validateResolvedCredentials = function(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    };
    return SignatureV4;
}();
var formatDate = function(now) {
    var longDate = (0, _utilDate.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
var getCanonicalHeaderList = function(headers) {
    return Object.keys(headers).sort().join(";");
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"i3yua","@aws-sdk/util-middleware":"2OCR6","./constants":"17jwR","./credentialDerivation":"5dTfS","./getCanonicalHeaders":"bx7bM","./getCanonicalQuery":"b9kbm","./getPayloadHash":"giq6m","./headerUtil":"dJVHr","./moveHeadersToQuery":"ilF8D","./prepareRequest":"ajmAz","./utilDate":"e3juT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i3yua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for(var i = 0; i < 256; i++){
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = "0".concat(encodedByte);
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) out[i / 2] = HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence ".concat(encodedByte, " as hexadecimal"));
    }
    return out;
}
function toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += SHORT_TO_HEX[bytes[i]];
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17jwR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALGORITHM_QUERY_PARAM", ()=>ALGORITHM_QUERY_PARAM);
parcelHelpers.export(exports, "CREDENTIAL_QUERY_PARAM", ()=>CREDENTIAL_QUERY_PARAM);
parcelHelpers.export(exports, "AMZ_DATE_QUERY_PARAM", ()=>AMZ_DATE_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNED_HEADERS_QUERY_PARAM", ()=>SIGNED_HEADERS_QUERY_PARAM);
parcelHelpers.export(exports, "EXPIRES_QUERY_PARAM", ()=>EXPIRES_QUERY_PARAM);
parcelHelpers.export(exports, "SIGNATURE_QUERY_PARAM", ()=>SIGNATURE_QUERY_PARAM);
parcelHelpers.export(exports, "TOKEN_QUERY_PARAM", ()=>TOKEN_QUERY_PARAM);
parcelHelpers.export(exports, "REGION_SET_PARAM", ()=>REGION_SET_PARAM);
parcelHelpers.export(exports, "AUTH_HEADER", ()=>AUTH_HEADER);
parcelHelpers.export(exports, "AMZ_DATE_HEADER", ()=>AMZ_DATE_HEADER);
parcelHelpers.export(exports, "DATE_HEADER", ()=>DATE_HEADER);
parcelHelpers.export(exports, "GENERATED_HEADERS", ()=>GENERATED_HEADERS);
parcelHelpers.export(exports, "SIGNATURE_HEADER", ()=>SIGNATURE_HEADER);
parcelHelpers.export(exports, "SHA256_HEADER", ()=>SHA256_HEADER);
parcelHelpers.export(exports, "TOKEN_HEADER", ()=>TOKEN_HEADER);
parcelHelpers.export(exports, "HOST_HEADER", ()=>HOST_HEADER);
parcelHelpers.export(exports, "ALWAYS_UNSIGNABLE_HEADERS", ()=>ALWAYS_UNSIGNABLE_HEADERS);
parcelHelpers.export(exports, "PROXY_HEADER_PATTERN", ()=>PROXY_HEADER_PATTERN);
parcelHelpers.export(exports, "SEC_HEADER_PATTERN", ()=>SEC_HEADER_PATTERN);
parcelHelpers.export(exports, "UNSIGNABLE_PATTERNS", ()=>UNSIGNABLE_PATTERNS);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER", ()=>ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "ALGORITHM_IDENTIFIER_V4A", ()=>ALGORITHM_IDENTIFIER_V4A);
parcelHelpers.export(exports, "EVENT_ALGORITHM_IDENTIFIER", ()=>EVENT_ALGORITHM_IDENTIFIER);
parcelHelpers.export(exports, "UNSIGNED_PAYLOAD", ()=>UNSIGNED_PAYLOAD);
parcelHelpers.export(exports, "MAX_CACHE_SIZE", ()=>MAX_CACHE_SIZE);
parcelHelpers.export(exports, "KEY_TYPE_IDENTIFIER", ()=>KEY_TYPE_IDENTIFIER);
parcelHelpers.export(exports, "MAX_PRESIGNED_TTL", ()=>MAX_PRESIGNED_TTL);
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var REGION_SET_PARAM = "X-Amz-Region-Set";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [
    AUTH_HEADER,
    AMZ_DATE_HEADER,
    DATE_HEADER
];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [
    /^proxy-/i,
    /^sec-/i
];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 604800;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5dTfS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScope", ()=>createScope);
parcelHelpers.export(exports, "getSigningKey", ()=>getSigningKey);
parcelHelpers.export(exports, "clearCredentialCache", ()=>clearCredentialCache);
var _tslib = require("tslib");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var signingKeyCache = {};
var cacheQueue = [];
var createScope = function(shortDate, region, service) {
    return "".concat(shortDate, "/").concat(region, "/").concat(service, "/").concat((0, _constants.KEY_TYPE_IDENTIFIER));
};
var getSigningKey = function(sha256Constructor, credentials, shortDate, region, service) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
        var e_1, _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    return [
                        4,
                        hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)
                    ];
                case 1:
                    credsHash = _d.sent();
                    cacheKey = "".concat(shortDate, ":").concat(region, ":").concat(service, ":").concat((0, _utilHexEncoding.toHex)(credsHash), ":").concat(credentials.sessionToken);
                    if (cacheKey in signingKeyCache) return [
                        2,
                        signingKeyCache[cacheKey]
                    ];
                    cacheQueue.push(cacheKey);
                    while(cacheQueue.length > (0, _constants.MAX_CACHE_SIZE))delete signingKeyCache[cacheQueue.shift()];
                    key = "AWS4".concat(credentials.secretAccessKey);
                    _d.label = 2;
                case 2:
                    _d.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = (0, _tslib.__values)([
                        shortDate,
                        region,
                        service,
                        (0, _constants.KEY_TYPE_IDENTIFIER)
                    ]), _b = _a.next();
                    _d.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3,
                        6
                    ];
                    signable = _b.value;
                    return [
                        4,
                        hmac(sha256Constructor, key, signable)
                    ];
                case 4:
                    key = _d.sent();
                    _d.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = {
                        error: e_1_1
                    };
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        signingKeyCache[cacheKey] = key
                    ];
            }
        });
    });
};
var clearCredentialCache = function() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function(cacheKey) {
        delete signingKeyCache[cacheKey];
    });
};
var hmac = function(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

},{"tslib":"86BcK","@aws-sdk/util-hex-encoding":"i3yua","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bx7bM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalHeaders", ()=>getCanonicalHeaders);
var _tslib = require("tslib");
var _constants = require("./constants");
var getCanonicalHeaders = function(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for(var _c = (0, _tslib.__values)(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()){
            var headerName = _d.value;
            if (headers[headerName] == undefined) continue;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in (0, _constants.ALWAYS_UNSIGNABLE_HEADERS) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, _constants.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, _constants.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
                if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return canonical;
};

},{"tslib":"86BcK","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b9kbm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanonicalQuery", ()=>getCanonicalQuery);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
var _constants = require("./constants");
var getCanonicalQuery = function(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function(key) {
        if (key.toLowerCase() === (0, _constants.SIGNATURE_HEADER)) return "continue";
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") serialized[key] = "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value));
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce(function(encoded, value) {
            return encoded.concat([
                "".concat((0, _utilUriEscape.escapeUri)(key), "=").concat((0, _utilUriEscape.escapeUri)(value))
            ]);
        }, []).join("&");
    };
    try {
        for(var _d = (0, _tslib.__values)(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()){
            var key = _e.value;
            _loop_1(key);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return keys.map(function(key) {
        return serialized[key];
    }).filter(function(serialized) {
        return serialized;
    }).join("&");
};

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"9ZH99","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ZH99":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _escapeUri = require("./escape-uri");
parcelHelpers.exportAll(_escapeUri, exports);
var _escapeUriPath = require("./escape-uri-path");
parcelHelpers.exportAll(_escapeUriPath, exports);

},{"./escape-uri":"9Vlcn","./escape-uri-path":"6tPfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Vlcn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUri", ()=>escapeUri);
var escapeUri = function(uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function(c) {
    return "%".concat(c.charCodeAt(0).toString(16).toUpperCase());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6tPfC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeUriPath", ()=>escapeUriPath);
var _escapeUri = require("./escape-uri");
var escapeUriPath = function(uri) {
    return uri.split("/").map((0, _escapeUri.escapeUri)).join("/");
};

},{"./escape-uri":"9Vlcn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"giq6m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPayloadHash", ()=>getPayloadHash);
var _tslib = require("tslib");
var _isArrayBuffer = require("@aws-sdk/is-array-buffer");
var _utilHexEncoding = require("@aws-sdk/util-hex-encoding");
var _constants = require("./constants");
var getPayloadHash = function(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return (0, _tslib.__generator)(this, function(_f) {
            switch(_f.label){
                case 0:
                    try {
                        for(_b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
                            headerName = _c.value;
                            if (headerName.toLowerCase() === (0, _constants.SHA256_HEADER)) return [
                                2,
                                headers[headerName]
                            ];
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (!(body == undefined)) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"
                    ];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || (0, _isArrayBuffer.isArrayBuffer)(body))) return [
                        3,
                        3
                    ];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = (0, _utilHexEncoding.toHex);
                    return [
                        4,
                        hashCtor.digest()
                    ];
                case 2:
                    return [
                        2,
                        _d.apply(void 0, [
                            _f.sent()
                        ])
                    ];
                case 3:
                    return [
                        2,
                        (0, _constants.UNSIGNED_PAYLOAD)
                    ];
            }
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/is-array-buffer":"4mNIj","@aws-sdk/util-hex-encoding":"i3yua","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4mNIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
var isArrayBuffer = function(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dJVHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasHeader", ()=>hasHeader);
parcelHelpers.export(exports, "getHeaderValue", ()=>getHeaderValue);
parcelHelpers.export(exports, "deleteHeader", ()=>deleteHeader);
var _tslib = require("tslib");
var hasHeader = function(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
};
var getHeaderValue = function(soughtHeader, headers) {
    var e_2, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return undefined;
};
var deleteHeader = function(soughtHeader, headers) {
    var e_3, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ilF8D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveHeadersToQuery", ()=>moveHeadersToQuery);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var moveHeadersToQuery = function(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) options = {};
    var _c = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for(var _e = (0, _tslib.__values)(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()){
            var name_1 = _f.value;
            var lname = name_1.toLowerCase();
            if (lname.slice(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name_1] = headers[name_1];
                delete headers[name_1];
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
        headers: headers,
        query: query
    });
};

},{"tslib":"86BcK","./cloneRequest":"hKxuc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKxuc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneRequest", ()=>cloneRequest);
parcelHelpers.export(exports, "cloneQuery", ()=>cloneQuery);
var _tslib = require("tslib");
var cloneRequest = function(_a) {
    var headers = _a.headers, query = _a.query, rest = (0, _tslib.__rest)(_a, [
        "headers",
        "query"
    ]);
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
        headers: (0, _tslib.__assign)({}, headers),
        query: query ? cloneQuery(query) : undefined
    });
};
var cloneQuery = function(query) {
    return Object.keys(query).reduce(function(carry, paramName) {
        var _a;
        var param = query[paramName];
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? (0, _tslib.__spreadArray)([], (0, _tslib.__read)(param), false) : param, _a));
    }, {});
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ajmAz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRequest", ()=>prepareRequest);
var _tslib = require("tslib");
var _cloneRequest = require("./cloneRequest");
var _constants = require("./constants");
var prepareRequest = function(request) {
    var e_1, _a;
    request = typeof request.clone === "function" ? request.clone() : (0, _cloneRequest.cloneRequest)(request);
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()){
            var headerName = _c.value;
            if ((0, _constants.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return request;
};

},{"tslib":"86BcK","./cloneRequest":"hKxuc","./constants":"17jwR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e3juT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iso8601", ()=>iso8601);
parcelHelpers.export(exports, "toDate", ()=>toDate);
var iso8601 = function(time) {
    return toDate(time).toISOString().replace(/\.\d{3}Z$/, "Z");
};
var toDate = function(time) {
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"isI8R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "awsAuthMiddleware", ()=>awsAuthMiddleware);
parcelHelpers.export(exports, "awsAuthMiddlewareOptions", ()=>awsAuthMiddlewareOptions);
parcelHelpers.export(exports, "getAwsAuthPlugin", ()=>getAwsAuthPlugin);
parcelHelpers.export(exports, "getSigV4AuthPlugin", ()=>getSigV4AuthPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _getSkewCorrectedDate = require("./utils/getSkewCorrectedDate");
var _getUpdatedSystemClockOffset = require("./utils/getUpdatedSystemClockOffset");
var awsAuthMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            var _a, _b, _c;
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var authScheme, signer, output, _d, _e, dateHeader;
                var _f;
                return (0, _tslib.__generator)(this, function(_g) {
                    switch(_g.label){
                        case 0:
                            if (!(0, _protocolHttp.HttpRequest).isInstance(args.request)) return [
                                2,
                                next(args)
                            ];
                            authScheme = (_c = (_b = (_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.authSchemes) === null || _c === void 0 ? void 0 : _c[0];
                            return [
                                4,
                                options.signer(authScheme)
                            ];
                        case 1:
                            signer = _g.sent();
                            _d = next;
                            _e = [
                                (0, _tslib.__assign)({}, args)
                            ];
                            _f = {};
                            return [
                                4,
                                signer.sign(args.request, {
                                    signingDate: (0, _getSkewCorrectedDate.getSkewCorrectedDate)(options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"]
                                })
                            ];
                        case 2:
                            return [
                                4,
                                _d.apply(void 0, [
                                    (0, _tslib.__assign).apply(void 0, _e.concat([
                                        (_f.request = _g.sent(), _f)
                                    ]))
                                ]).catch(function(error) {
                                    var _a;
                                    var serverTime = (_a = error.ServerTime) !== null && _a !== void 0 ? _a : getDateHeader(error.$response);
                                    if (serverTime) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(serverTime, options.systemClockOffset);
                                    throw error;
                                })
                            ];
                        case 3:
                            output = _g.sent();
                            dateHeader = getDateHeader(output.response);
                            if (dateHeader) options.systemClockOffset = (0, _getUpdatedSystemClockOffset.getUpdatedSystemClockOffset)(dateHeader, options.systemClockOffset);
                            return [
                                2,
                                output
                            ];
                    }
                });
            });
        };
    };
};
var getDateHeader = function(response) {
    var _a, _b, _c;
    return (0, _protocolHttp.HttpResponse).isInstance(response) ? (_b = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : (_c = response.headers) === null || _c === void 0 ? void 0 : _c.Date : undefined;
};
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
var getAwsAuthPlugin = function(options) {
    return {
        applyToStack: function(clientStack) {
            clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
        }
    };
};
var getSigV4AuthPlugin = getAwsAuthPlugin;

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./utils/getSkewCorrectedDate":"9WSC7","./utils/getUpdatedSystemClockOffset":"dzuy9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9WSC7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkewCorrectedDate", ()=>getSkewCorrectedDate);
var getSkewCorrectedDate = function(systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dzuy9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUpdatedSystemClockOffset", ()=>getUpdatedSystemClockOffset);
var _isClockSkewed = require("./isClockSkewed");
var getUpdatedSystemClockOffset = function(clockTime, currentSystemClockOffset) {
    var clockTimeInMs = Date.parse(clockTime);
    if ((0, _isClockSkewed.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

},{"./isClockSkewed":"lw2DU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lw2DU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClockSkewed", ()=>isClockSkewed);
var _getSkewCorrectedDate = require("./getSkewCorrectedDate");
var isClockSkewed = function(clockTime, systemClockOffset) {
    return Math.abs((0, _getSkewCorrectedDate.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;
};

},{"./getSkewCorrectedDate":"9WSC7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ZRPH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _configurations = require("./configurations");
parcelHelpers.exportAll(_configurations, exports);
var _userAgentMiddleware = require("./user-agent-middleware");
parcelHelpers.exportAll(_userAgentMiddleware, exports);

},{"./configurations":"3nzno","./user-agent-middleware":"i5uwN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3nzno":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveUserAgentConfig", ()=>resolveUserAgentConfig);
var _tslib = require("tslib");
function resolveUserAgentConfig(input) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input), {
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    });
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i5uwN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAgentMiddleware", ()=>userAgentMiddleware);
parcelHelpers.export(exports, "getUserAgentMiddlewareOptions", ()=>getUserAgentMiddlewareOptions);
parcelHelpers.export(exports, "getUserAgentPlugin", ()=>getUserAgentPlugin);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _constants = require("./constants");
var userAgentMiddleware = function(options) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var request, headers, userAgent, defaultUserAgent, customUserAgent, sdkUserAgentValue, normalUAValue;
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            request = args.request;
                            if (!(0, _protocolHttp.HttpRequest).isInstance(request)) return [
                                2,
                                next(args)
                            ];
                            headers = request.headers;
                            userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                            return [
                                4,
                                options.defaultUserAgentProvider()
                            ];
                        case 1:
                            defaultUserAgent = _c.sent().map(escapeUserAgent);
                            customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                            sdkUserAgentValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent), false), (0, _tslib.__read)(userAgent), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            normalUAValue = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(defaultUserAgent.filter(function(section) {
                                return section.startsWith("aws-sdk-");
                            })), false), (0, _tslib.__read)(customUserAgent), false).join((0, _constants.SPACE));
                            if (options.runtime !== "browser") {
                                if (normalUAValue) headers[0, _constants.X_AMZ_USER_AGENT] = headers[0, _constants.X_AMZ_USER_AGENT] ? "".concat(headers[0, _constants.USER_AGENT], " ").concat(normalUAValue) : normalUAValue;
                                headers[0, _constants.USER_AGENT] = sdkUserAgentValue;
                            } else headers[0, _constants.X_AMZ_USER_AGENT] = sdkUserAgentValue;
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};
var escapeUserAgent = function(_a) {
    var _b = (0, _tslib.__read)(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex);
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter(function(item) {
        return item && item.length > 0;
    }).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.replace((0, _constants.UA_ESCAPE_REGEX), "_");
    }).join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
var getUserAgentPlugin = function(config) {
    return {
        applyToStack: function(clientStack) {
            clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
        }
    };
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","./constants":"jDE9x","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDE9x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_AGENT", ()=>USER_AGENT);
parcelHelpers.export(exports, "X_AMZ_USER_AGENT", ()=>X_AMZ_USER_AGENT);
parcelHelpers.export(exports, "SPACE", ()=>SPACE);
parcelHelpers.export(exports, "UA_ESCAPE_REGEX", ()=>UA_ESCAPE_REGEX);
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6yS5y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("./client");
parcelHelpers.exportAll(_client, exports);
var _command = require("./command");
parcelHelpers.exportAll(_command, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _dateUtils = require("./date-utils");
parcelHelpers.exportAll(_dateUtils, exports);
var _defaultErrorHandler = require("./default-error-handler");
parcelHelpers.exportAll(_defaultErrorHandler, exports);
var _defaultsMode = require("./defaults-mode");
parcelHelpers.exportAll(_defaultsMode, exports);
var _emitWarningIfUnsupportedVersion = require("./emitWarningIfUnsupportedVersion");
parcelHelpers.exportAll(_emitWarningIfUnsupportedVersion, exports);
var _exceptions = require("./exceptions");
parcelHelpers.exportAll(_exceptions, exports);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
parcelHelpers.exportAll(_extendedEncodeUriComponent, exports);
var _getArrayIfSingleItem = require("./get-array-if-single-item");
parcelHelpers.exportAll(_getArrayIfSingleItem, exports);
var _getValueFromTextNode = require("./get-value-from-text-node");
parcelHelpers.exportAll(_getValueFromTextNode, exports);
var _lazyJson = require("./lazy-json");
parcelHelpers.exportAll(_lazyJson, exports);
var _objectMapping = require("./object-mapping");
parcelHelpers.exportAll(_objectMapping, exports);
var _parseUtils = require("./parse-utils");
parcelHelpers.exportAll(_parseUtils, exports);
var _resolvePath = require("./resolve-path");
parcelHelpers.exportAll(_resolvePath, exports);
var _serUtils = require("./ser-utils");
parcelHelpers.exportAll(_serUtils, exports);
var _splitEvery = require("./split-every");
parcelHelpers.exportAll(_splitEvery, exports);

},{"./client":"ivUKX","./command":"9XB6P","./constants":"cpIKJ","./date-utils":"sd4m2","./default-error-handler":"aEzmO","./defaults-mode":"6CC7y","./emitWarningIfUnsupportedVersion":"k6BsV","./exceptions":"dlYUN","./extended-encode-uri-component":"lLtny","./get-array-if-single-item":"2QL4f","./get-value-from-text-node":"krFAH","./lazy-json":"9CqeP","./object-mapping":"fTvky","./parse-utils":"93HHS","./resolve-path":"92rlt","./ser-utils":"5RkK2","./split-every":"avMYA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ivUKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Client", ()=>Client);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Client = function() {
    function Client(config) {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
        this.config = config;
    }
    Client.prototype.send = function(command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then(function(result) {
            return callback(null, result.output);
        }, function(err) {
            return callback(err);
        }).catch(function() {});
        else return handler(command).then(function(result) {
            return result.output;
        });
    };
    Client.prototype.destroy = function() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    };
    return Client;
}();

},{"@aws-sdk/middleware-stack":"irbe4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irbe4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _middlewareStack = require("./MiddlewareStack");
parcelHelpers.exportAll(_middlewareStack, exports);

},{"./MiddlewareStack":"lykEV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lykEV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constructStack", ()=>constructStack);
var _tslib = require("tslib");
var constructStack = function() {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function(entries) {
        return entries.sort(function(a, b) {
            return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function(toRemove) {
        var isRemoved = false;
        var filterCb = function(entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function(toStack) {
        absoluteEntries.forEach(function(entry) {
            toStack.add(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        relativeEntries.forEach(function(entry) {
            toStack.addRelativeTo(entry.middleware, (0, _tslib.__assign)({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function(from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function(entry) {
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push.apply(expandedMiddlewareList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expandRelativeMiddlewareList(entry)), false));
        });
        return expandedMiddlewareList;
    };
    var getMiddlewareList = function(debug) {
        if (debug === void 0) debug = false;
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function(entry) {
            var normalizedEntry = (0, _tslib.__assign)((0, _tslib.__assign)({}, entry), {
                before: [],
                after: []
            });
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function(entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error("".concat(entry.toMiddleware, " is not found when adding ").concat(entry.name || "anonymous", " middleware ").concat(entry.relation, " ").concat(entry.toMiddleware));
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function(wholeList, expendedMiddlewareList) {
            wholeList.push.apply(wholeList, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(expendedMiddlewareList), false));
            return wholeList;
        }, []);
        return mainChain;
    };
    var stack = {
        add: function(middleware, options) {
            if (options === void 0) options = {};
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                step: "initialize",
                priority: "normal",
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = absoluteEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error('"'.concat(name, '" middleware with ').concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot be ") + "overridden by same-name middleware with ".concat(entry.priority, " priority in ").concat(entry.step, " step."));
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function(middleware, options) {
            var name = options.name, override = options.override;
            var entry = (0, _tslib.__assign)({
                middleware: middleware
            }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error("Duplicate middleware name '".concat(name, "'"));
                    var toOverrideIndex = relativeEntries.findIndex(function(entry) {
                        return entry.name === name;
                    });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error('"'.concat(name, '" middleware ').concat(toOverride.relation, ' "').concat(toOverride.toMiddleware, '" middleware cannot be overridden ') + "by same-name middleware ".concat(entry.relation, ' "').concat(entry.toMiddleware, '" middleware.'));
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function() {
            return cloneTo(constructStack());
        },
        use: function(plugin) {
            plugin.applyToStack(stack);
        },
        remove: function(toRemove) {
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: function(toRemove) {
            var isRemoved = false;
            var filterCb = function(entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function(from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: function() {
            return getMiddlewareList(true).map(function(mw) {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: function(handler, context) {
            var e_1, _a;
            try {
                for(var _b = (0, _tslib.__values)(getMiddlewareList().map(function(entry) {
                    return entry.middleware;
                }).reverse()), _c = _b.next(); !_c.done; _c = _b.next()){
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return handler;
        }
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9XB6P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
var _middlewareStack = require("@aws-sdk/middleware-stack");
var Command = function() {
    function Command() {
        this.middlewareStack = (0, _middlewareStack.constructStack)();
    }
    return Command;
}();

},{"@aws-sdk/middleware-stack":"irbe4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cpIKJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENSITIVE_STRING", ()=>SENSITIVE_STRING);
var SENSITIVE_STRING = "***SensitiveInformation***";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"sd4m2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateToUtcString", ()=>dateToUtcString);
parcelHelpers.export(exports, "parseRfc3339DateTime", ()=>parseRfc3339DateTime);
parcelHelpers.export(exports, "parseRfc7231DateTime", ()=>parseRfc7231DateTime);
parcelHelpers.export(exports, "parseEpochTimestamp", ()=>parseEpochTimestamp);
var _tslib = require("tslib");
var _parseUtils = require("./parse-utils");
var DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    var dayOfMonthString = dayOfMonthInt < 10 ? "0".concat(dayOfMonthInt) : "".concat(dayOfMonthInt);
    var hoursString = hoursInt < 10 ? "0".concat(hoursInt) : "".concat(hoursInt);
    var minutesString = minutesInt < 10 ? "0".concat(minutesInt) : "".concat(minutesInt);
    var secondsString = secondsInt < 10 ? "0".concat(secondsInt) : "".concat(secondsInt);
    return "".concat(DAYS[dayOfWeek], ", ").concat(dayOfMonthString, " ").concat(MONTHS[month], " ").concat(year, " ").concat(hoursString, ":").concat(minutesString, ":").concat(secondsString, " GMT");
}
var RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
var parseRfc3339DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    var match = RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    var _a = (0, _tslib.__read)(match, 8), _ = _a[0], yearStr = _a[1], monthStr = _a[2], dayStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
    var year = (0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr));
    var month = parseDateValue(monthStr, "month", 1, 12);
    var day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
var IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
var ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
var parseRfc7231DateTime = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    var match = IMF_FIXDATE.exec(value);
    if (match) {
        var _a = (0, _tslib.__read)(match, 8), _1 = _a[0], dayStr = _a[1], monthStr = _a[2], yearStr = _a[3], hours = _a[4], minutes = _a[5], seconds = _a[6], fractionalMilliseconds = _a[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        var _b = (0, _tslib.__read)(match, 8), _2 = _b[0], dayStr = _b[1], monthStr = _b[2], yearStr = _b[3], hours = _b[4], minutes = _b[5], seconds = _b[6], fractionalMilliseconds = _b[7];
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        var _c = (0, _tslib.__read)(match, 8), _3 = _c[0], monthStr = _c[1], dayStr = _c[2], hours = _c[3], minutes = _c[4], seconds = _c[5], fractionalMilliseconds = _c[6], yearStr = _c[7];
        return buildDate((0, _parseUtils.strictParseShort)(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
var parseEpochTimestamp = function(value) {
    if (value === null || value === undefined) return undefined;
    var valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, _parseUtils.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
var buildDate = function(year, month, day, time) {
    var adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
var parseTwoDigitYear = function(value) {
    var thisYear = new Date().getUTCFullYear();
    var valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, _parseUtils.strictParseShort)(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
var FIFTY_YEARS_IN_MILLIS = 1576800000000;
var adjustRfc850Year = function(input) {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
var parseMonthByShortName = function(value) {
    var monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError("Invalid month: ".concat(value));
    return monthIdx + 1;
};
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var validateDayOfMonth = function(year, month, day) {
    var maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError("Invalid day for ".concat(MONTHS[month], " in ").concat(year, ": ").concat(day));
};
var isLeapYear = function(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
var parseDateValue = function(value, type, lower, upper) {
    var dateVal = (0, _parseUtils.strictParseByte)(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError("".concat(type, " must be between ").concat(lower, " and ").concat(upper, ", inclusive"));
    return dateVal;
};
var parseMilliseconds = function(value) {
    if (value === null || value === undefined) return 0;
    return (0, _parseUtils.strictParseFloat32)("0." + value) * 1000;
};
var stripLeadingZeroes = function(value) {
    var idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

},{"tslib":"86BcK","./parse-utils":"93HHS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"93HHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", ()=>parseBoolean);
parcelHelpers.export(exports, "expectBoolean", ()=>expectBoolean);
parcelHelpers.export(exports, "expectNumber", ()=>expectNumber);
parcelHelpers.export(exports, "expectFloat32", ()=>expectFloat32);
parcelHelpers.export(exports, "expectLong", ()=>expectLong);
parcelHelpers.export(exports, "expectInt", ()=>expectInt);
parcelHelpers.export(exports, "expectInt32", ()=>expectInt32);
parcelHelpers.export(exports, "expectShort", ()=>expectShort);
parcelHelpers.export(exports, "expectByte", ()=>expectByte);
parcelHelpers.export(exports, "expectNonNull", ()=>expectNonNull);
parcelHelpers.export(exports, "expectObject", ()=>expectObject);
parcelHelpers.export(exports, "expectString", ()=>expectString);
parcelHelpers.export(exports, "expectUnion", ()=>expectUnion);
parcelHelpers.export(exports, "strictParseDouble", ()=>strictParseDouble);
parcelHelpers.export(exports, "strictParseFloat", ()=>strictParseFloat);
parcelHelpers.export(exports, "strictParseFloat32", ()=>strictParseFloat32);
parcelHelpers.export(exports, "limitedParseDouble", ()=>limitedParseDouble);
parcelHelpers.export(exports, "handleFloat", ()=>handleFloat);
parcelHelpers.export(exports, "limitedParseFloat", ()=>limitedParseFloat);
parcelHelpers.export(exports, "limitedParseFloat32", ()=>limitedParseFloat32);
parcelHelpers.export(exports, "strictParseLong", ()=>strictParseLong);
parcelHelpers.export(exports, "strictParseInt", ()=>strictParseInt);
parcelHelpers.export(exports, "strictParseInt32", ()=>strictParseInt32);
parcelHelpers.export(exports, "strictParseShort", ()=>strictParseShort);
parcelHelpers.export(exports, "strictParseByte", ()=>strictParseByte);
parcelHelpers.export(exports, "logger", ()=>logger);
var _tslib = require("tslib");
var parseBoolean = function(value) {
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error('Unable to parse boolean value "'.concat(value, '"'));
    }
};
var expectBoolean = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        var lower = value.toLowerCase();
        if (lower === "false" || lower === "true") logger.warn(stackTraceWarning("Expected boolean, got ".concat(typeof value, ": ").concat(value)));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError("Expected boolean, got ".concat(typeof value, ": ").concat(value));
};
var expectNumber = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) logger.warn(stackTraceWarning("Expected number but observed string: ".concat(value)));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError("Expected number, got ".concat(typeof value, ": ").concat(value));
};
var MAX_FLOAT = Math.ceil(Math.pow(2, 127) * (2 - Math.pow(2, -23)));
var expectFloat32 = function(value) {
    var expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) throw new TypeError("Expected 32-bit float, got ".concat(value));
    }
    return expected;
};
var expectLong = function(value) {
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError("Expected integer, got ".concat(typeof value, ": ").concat(value));
};
var expectInt = expectLong;
var expectInt32 = function(value) {
    return expectSizedInt(value, 32);
};
var expectShort = function(value) {
    return expectSizedInt(value, 16);
};
var expectByte = function(value) {
    return expectSizedInt(value, 8);
};
var expectSizedInt = function(value, size) {
    var expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) throw new TypeError("Expected ".concat(size, "-bit integer, got ").concat(value));
    return expected;
};
var castInt = function(value, size) {
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
var expectNonNull = function(value, location) {
    if (value === null || value === undefined) {
        if (location) throw new TypeError("Expected a non-null value for ".concat(location));
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
var expectObject = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    var receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError("Expected object, got ".concat(receivedType, ": ").concat(value));
};
var expectString = function(value) {
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        logger.warn(stackTraceWarning("Expected string, got ".concat(typeof value, ": ").concat(value)));
        return String(value);
    }
    throw new TypeError("Expected string, got ".concat(typeof value, ": ").concat(value));
};
var expectUnion = function(value) {
    if (value === null || value === undefined) return undefined;
    var asObject = expectObject(value);
    var setKeys = Object.entries(asObject).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v != null;
    }).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 1), k = _b[0];
        return k;
    });
    if (setKeys.length === 0) throw new TypeError("Unions must have exactly one non-null member. None were found.");
    if (setKeys.length > 1) throw new TypeError("Unions must have exactly one non-null member. Keys ".concat(setKeys, " were not null."));
    return asObject;
};
var strictParseDouble = function(value) {
    if (typeof value == "string") return expectNumber(parseNumber(value));
    return expectNumber(value);
};
var strictParseFloat = strictParseDouble;
var strictParseFloat32 = function(value) {
    if (typeof value == "string") return expectFloat32(parseNumber(value));
    return expectFloat32(value);
};
var NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
var parseNumber = function(value) {
    var matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError("Expected real number, got implicit NaN");
    return parseFloat(value);
};
var limitedParseDouble = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectNumber(value);
};
var handleFloat = limitedParseDouble;
var limitedParseFloat = limitedParseDouble;
var limitedParseFloat32 = function(value) {
    if (typeof value == "string") return parseFloatString(value);
    return expectFloat32(value);
};
var parseFloatString = function(value) {
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error("Unable to parse float value: ".concat(value));
    }
};
var strictParseLong = function(value) {
    if (typeof value === "string") return expectLong(parseNumber(value));
    return expectLong(value);
};
var strictParseInt = strictParseLong;
var strictParseInt32 = function(value) {
    if (typeof value === "string") return expectInt32(parseNumber(value));
    return expectInt32(value);
};
var strictParseShort = function(value) {
    if (typeof value === "string") return expectShort(parseNumber(value));
    return expectShort(value);
};
var strictParseByte = function(value) {
    if (typeof value === "string") return expectByte(parseNumber(value));
    return expectByte(value);
};
var stackTraceWarning = function(message) {
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter(function(s) {
        return !s.includes("stackTraceWarning");
    }).join("\n");
};
var logger = {
    warn: console.warn
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aEzmO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwDefaultError", ()=>throwDefaultError);
var _exceptions = require("./exceptions");
var throwDefaultError = function(_a) {
    var output = _a.output, parsedBody = _a.parsedBody, exceptionCtor = _a.exceptionCtor, errorCode = _a.errorCode;
    var $metadata = deserializeMetadata(output);
    var statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    var response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknowError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, _exceptions.decorateServiceException)(response, parsedBody);
};
var deserializeMetadata = function(output) {
    var _a;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};

},{"./exceptions":"dlYUN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dlYUN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServiceException", ()=>ServiceException);
parcelHelpers.export(exports, "decorateServiceException", ()=>decorateServiceException);
var _tslib = require("tslib");
var ServiceException = function(_super) {
    (0, _tslib.__extends)(ServiceException, _super);
    function ServiceException(options) {
        var _this = _super.call(this, options.message) || this;
        Object.setPrototypeOf(_this, ServiceException.prototype);
        _this.name = options.name;
        _this.$fault = options.$fault;
        _this.$metadata = options.$metadata;
        return _this;
    }
    return ServiceException;
}(Error);
var decorateServiceException = function(exception, additions) {
    if (additions === void 0) additions = {};
    Object.entries(additions).filter(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), v = _b[1];
        return v !== undefined;
    }).forEach(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), k = _b[0], v = _b[1];
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    var message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6CC7y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadConfigsForDefaultMode", ()=>loadConfigsForDefaultMode);
var loadConfigsForDefaultMode = function(mode) {
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k6BsV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emitWarningIfUnsupportedVersion", ()=>emitWarningIfUnsupportedVersion);
var process = require("5d372f430481d1db");
var warningEmitted = false;
var emitWarningIfUnsupportedVersion = function(version) {
    if (version && !warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) {
        warningEmitted = true;
        process.emitWarning("The AWS SDK for JavaScript (v3) will\n" + "no longer support Node.js ".concat(version, " on November 1, 2022.\n\n") + "To continue receiving updates to AWS services, bug fixes, and security\n" + "updates please upgrade to Node.js 14.x or later.\n\n" + "For details, please refer our blog post: https://a.co/48dbdYz", "NodeDeprecationWarning");
    }
};

},{"5d372f430481d1db":"4avz9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLtny":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extendedEncodeURIComponent", ()=>extendedEncodeURIComponent);
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2QL4f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrayIfSingleItem", ()=>getArrayIfSingleItem);
var getArrayIfSingleItem = function(mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"krFAH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromTextNode", ()=>getValueFromTextNode);
var getValueFromTextNode = function(obj) {
    var textNodeName = "#text";
    for(var key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = getValueFromTextNode(obj[key]);
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CqeP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringWrapper", ()=>StringWrapper);
parcelHelpers.export(exports, "LazyJsonString", ()=>LazyJsonString);
var _tslib = require("tslib");
var StringWrapper = function() {
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, (0, _tslib.__spreadArray)([
        null
    ], (0, _tslib.__read)(arguments), false));
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = function(_super) {
    (0, _tslib.__extends)(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function() {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function() {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function(object) {
        if (object instanceof LazyJsonString) return object;
        else if (object instanceof String || typeof object === "string") return new LazyJsonString(object);
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper);

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fTvky":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "convertMap", ()=>convertMap);
var _tslib = require("tslib");
function map(arg0, arg1, arg2) {
    var e_1, _a;
    var target;
    var filter;
    var instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(instructions)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            if (!Array.isArray(instructions[key])) {
                target[key] = instructions[key];
                continue;
            }
            var _d = (0, _tslib.__read)(instructions[key], 2), filter_1 = _d[0], value = _d[1];
            if (typeof value === "function") {
                var _value = void 0;
                var defaultFilterPassed = filter_1 === undefined && (_value = value()) != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(void 0) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed) target[key] = _value;
                else if (customFilterPassed) target[key] = value();
            } else {
                var defaultFilterPassed = filter_1 === undefined && value != null;
                var customFilterPassed = typeof filter_1 === "function" && !!filter_1(value) || typeof filter_1 !== "function" && !!filter_1;
                if (defaultFilterPassed || customFilterPassed) target[key] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return target;
}
var convertMap = function(target) {
    var e_2, _a;
    var output = {};
    try {
        for(var _b = (0, _tslib.__values)(Object.entries(target || {})), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, _tslib.__read)(_c.value, 2), k = _d[0], v = _d[1];
            output[k] = [
                ,
                v
            ];
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return output;
};
var mapWithFilter = function(target, filter, instructions) {
    return map(target, Object.entries(instructions).reduce(function(_instructions, _a) {
        var _b = (0, _tslib.__read)(_a, 2), key = _b[0], value = _b[1];
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"92rlt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvedPath", ()=>resolvedPath);
var _extendedEncodeUriComponent = require("./extended-encode-uri-component");
var resolvedPath = function(resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) {
    if (input != null && input[memberName] !== undefined) {
        var labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map(function(segment) {
            return (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(segment);
        }).join("/") : (0, _extendedEncodeUriComponent.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

},{"./extended-encode-uri-component":"lLtny","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5RkK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFloat", ()=>serializeFloat);
var serializeFloat = function(value) {
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"avMYA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitEvery", ()=>splitEvery);
function splitEvery(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    var segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    var compoundSegments = [];
    var currentSegment = "";
    for(var i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2UBhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _tslib = require("tslib");
var _packageJson = require("../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
var _sha256Browser = require("@aws-crypto/sha256-browser");
var _configResolver = require("@aws-sdk/config-resolver");
var _fetchHttpHandler = require("@aws-sdk/fetch-http-handler");
var _invalidDependency = require("@aws-sdk/invalid-dependency");
var _middlewareRetry = require("@aws-sdk/middleware-retry");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var _utilBodyLengthBrowser = require("@aws-sdk/util-body-length-browser");
var _utilUserAgentBrowser = require("@aws-sdk/util-user-agent-browser");
var _utilUtf8Browser = require("@aws-sdk/util-utf8-browser");
var _runtimeConfigShared = require("./runtimeConfig.shared");
var _smithyClient = require("@aws-sdk/smithy-client");
var _utilDefaultsModeBrowser = require("@aws-sdk/util-defaults-mode-browser");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var defaultsMode = (0, _utilDefaultsModeBrowser.resolveDefaultsModeConfig)(config);
    var defaultConfigProvider = function() {
        return defaultsMode().then((0, _smithyClient.loadConfigsForDefaultMode));
    };
    var clientSharedValues = (0, _runtimeConfigShared.getRuntimeConfig)(config);
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, clientSharedValues), config), {
        runtime: "browser",
        defaultsMode: defaultsMode,
        base64Decoder: (_a = config === null || config === void 0 ? void 0 : config.base64Decoder) !== null && _a !== void 0 ? _a : (0, _utilBase64Browser.fromBase64),
        base64Encoder: (_b = config === null || config === void 0 ? void 0 : config.base64Encoder) !== null && _b !== void 0 ? _b : (0, _utilBase64Browser.toBase64),
        bodyLengthChecker: (_c = config === null || config === void 0 ? void 0 : config.bodyLengthChecker) !== null && _c !== void 0 ? _c : (0, _utilBodyLengthBrowser.calculateBodyLength),
        credentialDefaultProvider: (_d = config === null || config === void 0 ? void 0 : config.credentialDefaultProvider) !== null && _d !== void 0 ? _d : function(_) {
            return function() {
                return Promise.reject(new Error("Credential is missing"));
            };
        },
        defaultUserAgentProvider: (_e = config === null || config === void 0 ? void 0 : config.defaultUserAgentProvider) !== null && _e !== void 0 ? _e : (0, _utilUserAgentBrowser.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, _packageJsonDefault.default).version
        }),
        maxAttempts: (_f = config === null || config === void 0 ? void 0 : config.maxAttempts) !== null && _f !== void 0 ? _f : (0, _middlewareRetry.DEFAULT_MAX_ATTEMPTS),
        region: (_g = config === null || config === void 0 ? void 0 : config.region) !== null && _g !== void 0 ? _g : (0, _invalidDependency.invalidProvider)("Region is missing"),
        requestHandler: (_h = config === null || config === void 0 ? void 0 : config.requestHandler) !== null && _h !== void 0 ? _h : new (0, _fetchHttpHandler.FetchHttpHandler)(defaultConfigProvider),
        retryMode: (_j = config === null || config === void 0 ? void 0 : config.retryMode) !== null && _j !== void 0 ? _j : function() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                defaultConfigProvider()
                            ];
                        case 1:
                            return [
                                2,
                                _a.sent().retryMode || (0, _middlewareRetry.DEFAULT_RETRY_MODE)
                            ];
                    }
                });
            });
        },
        sha256: (_k = config === null || config === void 0 ? void 0 : config.sha256) !== null && _k !== void 0 ? _k : (0, _sha256Browser.Sha256),
        streamCollector: (_l = config === null || config === void 0 ? void 0 : config.streamCollector) !== null && _l !== void 0 ? _l : (0, _fetchHttpHandler.streamCollector),
        useDualstackEndpoint: (_m = config === null || config === void 0 ? void 0 : config.useDualstackEndpoint) !== null && _m !== void 0 ? _m : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_DUALSTACK_ENDPOINT));
        },
        useFipsEndpoint: (_o = config === null || config === void 0 ? void 0 : config.useFipsEndpoint) !== null && _o !== void 0 ? _o : function() {
            return Promise.resolve((0, _configResolver.DEFAULT_USE_FIPS_ENDPOINT));
        },
        utf8Decoder: (_p = config === null || config === void 0 ? void 0 : config.utf8Decoder) !== null && _p !== void 0 ? _p : (0, _utilUtf8Browser.fromUtf8),
        utf8Encoder: (_q = config === null || config === void 0 ? void 0 : config.utf8Encoder) !== null && _q !== void 0 ? _q : (0, _utilUtf8Browser.toUtf8)
    });
};

},{"tslib":"86BcK","../package.json":"8eHCo","@aws-crypto/sha256-browser":"5ntfd","@aws-sdk/config-resolver":"hrpyw","@aws-sdk/fetch-http-handler":"cBfhd","@aws-sdk/invalid-dependency":"hv19g","@aws-sdk/middleware-retry":"ijyar","@aws-sdk/util-base64-browser":"jzZOQ","@aws-sdk/util-body-length-browser":"6rztZ","@aws-sdk/util-user-agent-browser":"83az5","@aws-sdk/util-utf8-browser":"belsf","./runtimeConfig.shared":"8dpP6","@aws-sdk/smithy-client":"6yS5y","@aws-sdk/util-defaults-mode-browser":"gpbLI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8eHCo":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@aws-sdk/client-location","description":"AWS SDK for JavaScript Location Client for Node.js, Browser and React Native","version":"3.186.3","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"tsc -p tsconfig.cjs.json","build:docs":"typedoc","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"2.0.0","@aws-crypto/sha256-js":"2.0.0","@aws-sdk/client-sts":"3.186.3","@aws-sdk/config-resolver":"3.186.0","@aws-sdk/credential-provider-node":"3.186.0","@aws-sdk/fetch-http-handler":"3.186.0","@aws-sdk/hash-node":"3.186.0","@aws-sdk/invalid-dependency":"3.186.0","@aws-sdk/middleware-content-length":"3.186.0","@aws-sdk/middleware-host-header":"3.186.0","@aws-sdk/middleware-logger":"3.186.0","@aws-sdk/middleware-recursion-detection":"3.186.0","@aws-sdk/middleware-retry":"3.186.0","@aws-sdk/middleware-serde":"3.186.0","@aws-sdk/middleware-signing":"3.186.0","@aws-sdk/middleware-stack":"3.186.0","@aws-sdk/middleware-user-agent":"3.186.0","@aws-sdk/node-config-provider":"3.186.0","@aws-sdk/node-http-handler":"3.186.0","@aws-sdk/protocol-http":"3.186.0","@aws-sdk/smithy-client":"3.186.0","@aws-sdk/types":"3.186.0","@aws-sdk/url-parser":"3.186.0","@aws-sdk/util-base64-browser":"3.186.0","@aws-sdk/util-base64-node":"3.186.0","@aws-sdk/util-body-length-browser":"3.186.0","@aws-sdk/util-body-length-node":"3.186.0","@aws-sdk/util-defaults-mode-browser":"3.186.0","@aws-sdk/util-defaults-mode-node":"3.186.0","@aws-sdk/util-user-agent-browser":"3.186.0","@aws-sdk/util-user-agent-node":"3.186.0","@aws-sdk/util-utf8-browser":"3.186.0","@aws-sdk/util-utf8-node":"3.186.0","tslib":"^2.3.1"},"devDependencies":{"@aws-sdk/service-client-documentation-generator":"3.186.0","@tsconfig/recommended":"1.0.1","@types/node":"^12.7.5","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typedoc":"0.19.2","typescript":"~4.6.2"},"overrides":{"typedoc":{"typescript":"~4.6.2"}},"engines":{"node":">=12.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-location","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-location"}}');

},{}],"5ntfd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = require("2c225c7bd6ec0fe");
(0, tslib_1.__exportStar)(require("17fd527626e0957b"), exports);
var ie11Sha256_1 = require("b94d2f24e70883f0");
Object.defineProperty(exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return ie11Sha256_1.Sha256;
    }
});
var webCryptoSha256_1 = require("3c3335554c325413");
Object.defineProperty(exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return webCryptoSha256_1.Sha256;
    }
});

},{"2c225c7bd6ec0fe":"gaeA7","17fd527626e0957b":"evCVJ","b94d2f24e70883f0":"b5qUp","3c3335554c325413":"1UM5e"}],"gaeA7":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"evCVJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var ie11Sha256_1 = require("c668b1c6d918bcf6");
var webCryptoSha256_1 = require("eeda03e8bf347205");
var sha256_js_1 = require("39b1cf8cf20b539e");
var supports_web_crypto_1 = require("52eba68e276c6ae3");
var ie11_detection_1 = require("94511351fb1d82e6");
var util_locate_window_1 = require("65ca30ea13342516");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) this.hash = new webCryptoSha256_1.Sha256(secret);
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) this.hash = new ie11Sha256_1.Sha256(secret);
        else this.hash = new sha256_js_1.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"c668b1c6d918bcf6":"b5qUp","eeda03e8bf347205":"1UM5e","39b1cf8cf20b539e":"dbsiN","52eba68e276c6ae3":"3HGak","94511351fb1d82e6":"5ouwi","65ca30ea13342516":"ljvil"}],"b5qUp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var isEmptyData_1 = require("a38a5551ac6d8db2");
var constants_1 = require("c08111ec498c1a04");
var util_utf8_browser_1 = require("6ecfdac05b8dbe2b");
var util_locate_window_1 = require("9d645356577258e3");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function(keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") return (0, util_utf8_browser_1.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

},{"a38a5551ac6d8db2":"aO8Pd","c08111ec498c1a04":"jAHBB","6ecfdac05b8dbe2b":"belsf","9d645356577258e3":"ljvil"}],"aO8Pd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"jAHBB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = {
    name: "SHA-256"
};
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

},{}],"belsf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var _pureJs = require("./pureJs");
var _whatwgEncodingApi = require("./whatwgEncodingApi");
var fromUtf8 = function(input) {
    return typeof TextEncoder === "function" ? (0, _whatwgEncodingApi.fromUtf8)(input) : (0, _pureJs.fromUtf8)(input);
};
var toUtf8 = function(input) {
    return typeof TextDecoder === "function" ? (0, _whatwgEncodingApi.toUtf8)(input) : (0, _pureJs.toUtf8)(input);
};

},{"./pureJs":"jIvnd","./whatwgEncodingApi":"gV0ys","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jIvnd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
var fromUtf8 = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var toUtf8 = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gV0ys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
parcelHelpers.export(exports, "toUtf8", ()=>toUtf8);
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1UM5e":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var util_1 = require("92792c9325c69b4b");
var constants_1 = require("250c7f026fb5aedc");
var util_locate_window_1 = require("8f9e852ccf95572b");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha256.prototype.update = function(data) {
        if ((0, util_1.isEmptyData)(data)) return;
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, util_1.isEmptyData)(this.toHash)) return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;

},{"92792c9325c69b4b":"lve8V","250c7f026fb5aedc":"jAHBB","8f9e852ccf95572b":"ljvil"}],"lve8V":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = require("6970649ba32f1037");
Object.defineProperty(exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return convertToBuffer_1.convertToBuffer;
    }
});
var isEmptyData_1 = require("3cab579e81cbc793");
Object.defineProperty(exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return isEmptyData_1.isEmptyData;
    }
});
var numToUint8_1 = require("60a229355ca01f85");
Object.defineProperty(exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return numToUint8_1.numToUint8;
    }
});
var uint32ArrayFrom_1 = require("9df39cb9b7de08d0");
Object.defineProperty(exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return uint32ArrayFrom_1.uint32ArrayFrom;
    }
});

},{"6970649ba32f1037":"4KX2a","3cab579e81cbc793":"gKhpv","60a229355ca01f85":"aDO63","9df39cb9b7de08d0":"14wV5"}],"4KX2a":[function(require,module,exports) {
var Buffer = require("34441391e056678b").Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = require("f03a51a5418c7d38");
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
} : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;

},{"34441391e056678b":"cvSE8","f03a51a5418c7d38":"belsf"}],"gKhpv":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;

},{}],"aDO63":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
exports.numToUint8 = numToUint8;

},{}],"14wV5":[function(require,module,exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;

},{}],"dbsiN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("20c2714b53edfe01");
(0, tslib_1.__exportStar)(require("513196a22bbc18cf"), exports);

},{"20c2714b53edfe01":"4ZhS8","513196a22bbc18cf":"3vgVs"}],"4ZhS8":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vgVs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sha256 = void 0;
var tslib_1 = require("c06a41fb36a29a5");
var constants_1 = require("2dc139b64fda8f50");
var RawSha256_1 = require("aff94597fafaa776");
var util_1 = require("28ce9add8905c498");
var Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function() {
            return (0, tslib_1.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

},{"c06a41fb36a29a5":"4ZhS8","2dc139b64fda8f50":"iIRtp","aff94597fafaa776":"2Jb8c","28ce9add8905c498":"lve8V"}],"iIRtp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

},{}],"2Jb8c":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawSha256 = void 0;
var constants_1 = require("24d866a02214a751");
/**
 * @internal
 */ var RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < constants_1.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
exports.RawSha256 = RawSha256;

},{"24d866a02214a751":"iIRtp"}],"3HGak":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("6e3c17eeb0c4fc72");
tslib_1.__exportStar(require("f9aef6f49e6927f"), exports);

},{"6e3c17eeb0c4fc72":"3w13k","f9aef6f49e6927f":"dOav9"}],"3w13k":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dOav9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = require("e4ab527815ab542b");
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;

},{"e4ab527815ab542b":"3w13k"}],"5ouwi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("b50b9aa22aecfe99");
tslib_1.__exportStar(require("e3ed86ecc71f3053"), exports);
tslib_1.__exportStar(require("aadf0a87a5a4af6"), exports);
tslib_1.__exportStar(require("46bfbd58b14d6ddd"), exports);
tslib_1.__exportStar(require("df010a1df45e9da0"), exports);
tslib_1.__exportStar(require("d2102a2d7714dbcd"), exports);

},{"b50b9aa22aecfe99":"4HzYa","e3ed86ecc71f3053":"eukmf","aadf0a87a5a4af6":"c2Nkg","46bfbd58b14d6ddd":"bJJdo","df010a1df45e9da0":"1dZio","d2102a2d7714dbcd":"1tK0U"}],"4HzYa":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eukmf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"c2Nkg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"bJJdo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1dZio":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"1tK0U":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
exports.isMsWindow = isMsWindow;

},{}],"cBfhd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetchHttpHandler = require("./fetch-http-handler");
parcelHelpers.exportAll(_fetchHttpHandler, exports);
var _streamCollector = require("./stream-collector");
parcelHelpers.exportAll(_streamCollector, exports);

},{"./fetch-http-handler":"ja5Au","./stream-collector":"ceemt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ja5Au":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchHttpHandler", ()=>FetchHttpHandler);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _querystringBuilder = require("@aws-sdk/querystring-builder");
var _requestTimeout = require("./request-timeout");
var FetchHttpHandler = function() {
    function FetchHttpHandler(options) {
        if (typeof options === "function") this.configProvider = options().then(function(opts) {
            return opts || {};
        });
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    FetchHttpHandler.prototype.destroy = function() {};
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, requestOptions, fetchRequest, raceOfPromises;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (!!this.config) return [
                            3,
                            2
                        ];
                        _c = this;
                        return [
                            4,
                            this.configProvider
                        ];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = this.config.requestTimeout;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            return [
                                2,
                                Promise.reject(abortError)
                            ];
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = (0, _querystringBuilder.buildQueryString)(request.query);
                            if (queryString) path += "?".concat(queryString);
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        requestOptions = {
                            body: body,
                            headers: new Headers(request.headers),
                            method: method
                        };
                        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
                        fetchRequest = new Request(url, requestOptions);
                        raceOfPromises = [
                            fetch(fetchRequest).then(function(response) {
                                var e_1, _a;
                                var fetchHeaders = response.headers;
                                var transformedHeaders = {};
                                try {
                                    for(var _b = (0, _tslib.__values)(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                                        var pair = _c.value;
                                        transformedHeaders[pair[0]] = pair[1];
                                    }
                                } catch (e_1_1) {
                                    e_1 = {
                                        error: e_1_1
                                    };
                                } finally{
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    } finally{
                                        if (e_1) throw e_1.error;
                                    }
                                }
                                var hasReadableStream = response.body !== undefined;
                                if (!hasReadableStream) return response.blob().then(function(body) {
                                    return {
                                        response: new (0, _protocolHttp.HttpResponse)({
                                            headers: transformedHeaders,
                                            statusCode: response.status,
                                            body: body
                                        })
                                    };
                                });
                                return {
                                    response: new (0, _protocolHttp.HttpResponse)({
                                        headers: transformedHeaders,
                                        statusCode: response.status,
                                        body: response.body
                                    })
                                };
                            }),
                            (0, _requestTimeout.requestTimeout)(requestTimeoutInMs)
                        ];
                        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
                            abortSignal.onabort = function() {
                                var abortError = new Error("Request aborted");
                                abortError.name = "AbortError";
                                reject(abortError);
                            };
                        }));
                        return [
                            2,
                            Promise.race(raceOfPromises)
                        ];
                }
            });
        });
    };
    return FetchHttpHandler;
}();

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/querystring-builder":"3mpCm","./request-timeout":"1SCXU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3mpCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildQueryString", ()=>buildQueryString);
var _tslib = require("tslib");
var _utilUriEscape = require("@aws-sdk/util-uri-escape");
function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for(var _b = (0, _tslib.__values)(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var value = query[key];
            key = (0, _utilUriEscape.escapeUri)(key);
            if (Array.isArray(value)) for(var i = 0, iLen = value.length; i < iLen; i++)parts.push("".concat(key, "=").concat((0, _utilUriEscape.escapeUri)(value[i])));
            else {
                var qsEntry = key;
                if (value || typeof value === "string") qsEntry += "=".concat((0, _utilUriEscape.escapeUri)(value));
                parts.push(qsEntry);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return parts.join("&");
}

},{"tslib":"86BcK","@aws-sdk/util-uri-escape":"9ZH99","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1SCXU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestTimeout", ()=>requestTimeout);
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ceemt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamCollector", ()=>streamCollector);
var _tslib = require("tslib");
var _utilBase64Browser = require("@aws-sdk/util-base64-browser");
var streamCollector = function(stream) {
    if (typeof Blob === "function" && stream instanceof Blob) return collectBlob(stream);
    return collectStream(stream);
};
function collectBlob(blob) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var base64, arrayBuffer;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4,
                        readToBase64(blob)
                    ];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = (0, _utilBase64Browser.fromBase64)(base64);
                    return [
                        2,
                        new Uint8Array(arrayBuffer)
                    ];
            }
        });
    });
}
function collectStream(stream) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var res, reader, isDone, _a, done, value, prior;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        reader.read()
                    ];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function() {
            var _a;
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var result = (_a = reader.result) !== null && _a !== void 0 ? _a : "";
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function() {
            return reject(new Error("Read aborted"));
        };
        reader.onerror = function() {
            return reject(reader.error);
        };
        reader.readAsDataURL(blob);
    });
}

},{"tslib":"86BcK","@aws-sdk/util-base64-browser":"jzZOQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzZOQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromBase64", ()=>fromBase64);
parcelHelpers.export(exports, "toBase64", ()=>toBase64);
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for(var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for(var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for(var i = 0; i < 10; i++){
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
function fromBase64(input) {
    var totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for(var i = 0; i < input.length; i += 4){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in alphabetByEncoding)) throw new TypeError("Invalid character ".concat(input[j], " in base64 string."));
            bits |= alphabetByEncoding[input[j]] << (limit - j) * bitsPerLetter;
            bitLength += bitsPerLetter;
        } else bits >>= bitsPerLetter;
        var chunkOffset = i / 4 * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for(var k = 0; k < byteLength; k++){
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
}
function toBase64(input) {
    var str = "";
    for(var i = 0; i < input.length; i += 3){
        var bits = 0;
        var bitLength = 0;
        for(var j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * bitsPerByte;
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for(var k = 1; k <= bitClusterCount; k++){
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hv19g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invalidFunction = require("./invalidFunction");
parcelHelpers.exportAll(_invalidFunction, exports);
var _invalidProvider = require("./invalidProvider");
parcelHelpers.exportAll(_invalidProvider, exports);

},{"./invalidFunction":"khaJN","./invalidProvider":"irIaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"khaJN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidFunction", ()=>invalidFunction);
var invalidFunction = function(message) {
    return function() {
        throw new Error(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"irIaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invalidProvider", ()=>invalidProvider);
var invalidProvider = function(message) {
    return function() {
        return Promise.reject(message);
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6rztZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculateBodyLength = require("./calculateBodyLength");
parcelHelpers.exportAll(_calculateBodyLength, exports);

},{"./calculateBodyLength":"ANGDG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ANGDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBodyLength", ()=>calculateBodyLength);
var calculateBodyLength = function(body) {
    if (typeof body === "string") {
        var len = body.length;
        for(var i = len - 1; i >= 0; i--){
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error("Body Length computation failed for ".concat(body));
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"83az5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultUserAgent", ()=>defaultUserAgent);
var _tslib = require("tslib");
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var defaultUserAgent = function(_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var parsedUA, sections;
            var _a, _b, _c, _d, _e, _f, _g;
            return (0, _tslib.__generator)(this, function(_h) {
                parsedUA = typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? (0, _bowserDefault.default).parse(window.navigator.userAgent) : undefined;
                sections = [
                    [
                        "aws-sdk-js",
                        clientVersion
                    ],
                    [
                        "os/".concat(((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"),
                        (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version
                    ],
                    [
                        "lang/js"
                    ],
                    [
                        "md/browser",
                        "".concat((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown", "_").concat((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")
                    ]
                ];
                if (serviceId) sections.push([
                    "api/".concat(serviceId),
                    clientVersion
                ]);
                return [
                    2,
                    sections
                ];
            });
        });
    };
};

},{"tslib":"86BcK","bowser":"E5jm7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8dpP6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeConfig", ()=>getRuntimeConfig);
var _urlParser = require("@aws-sdk/url-parser");
var _endpoints = require("./endpoints");
var getRuntimeConfig = function(config) {
    var _a, _b, _c, _d, _e;
    return {
        apiVersion: "2020-11-19",
        disableHostPrefix: (_a = config === null || config === void 0 ? void 0 : config.disableHostPrefix) !== null && _a !== void 0 ? _a : false,
        logger: (_b = config === null || config === void 0 ? void 0 : config.logger) !== null && _b !== void 0 ? _b : {},
        regionInfoProvider: (_c = config === null || config === void 0 ? void 0 : config.regionInfoProvider) !== null && _c !== void 0 ? _c : (0, _endpoints.defaultRegionInfoProvider),
        serviceId: (_d = config === null || config === void 0 ? void 0 : config.serviceId) !== null && _d !== void 0 ? _d : "Location",
        urlParser: (_e = config === null || config === void 0 ? void 0 : config.urlParser) !== null && _e !== void 0 ? _e : (0, _urlParser.parseUrl)
    };
};

},{"@aws-sdk/url-parser":"7a0Jq","./endpoints":"6kVHH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7a0Jq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
var _querystringParser = require("@aws-sdk/querystring-parser");
var parseUrl = function(url) {
    if (typeof url === "string") return parseUrl(new URL(url));
    var _a = url, hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) query = (0, _querystringParser.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

},{"@aws-sdk/querystring-parser":"aRzPi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aRzPi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
var _tslib = require("tslib");
function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) try {
        for(var _b = (0, _tslib.__values)(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()){
            var pair = _c.value;
            var _d = (0, _tslib.__read)(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
            key = decodeURIComponent(key);
            if (value) value = decodeURIComponent(value);
            if (!(key in query)) query[key] = value;
            else if (Array.isArray(query[key])) query[key].push(value);
            else query[key] = [
                query[key],
                value
            ];
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return query;
}

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6kVHH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRegionInfoProvider", ()=>defaultRegionInfoProvider);
var _tslib = require("tslib");
var _configResolver = require("@aws-sdk/config-resolver");
var regionHash = {};
var partitionHash = {
    aws: {
        regions: [
            "af-south-1",
            "ap-east-1",
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ap-southeast-3",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-south-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "me-central-1",
            "me-south-1",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2"
        ],
        regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-cn": {
        regions: [
            "cn-north-1",
            "cn-northwest-1"
        ],
        regionRegex: "^cn\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com.cn",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com.cn",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.amazonwebservices.com.cn",
                tags: [
                    "dualstack"
                ]
            }
        ]
    },
    "aws-iso": {
        regions: [
            "us-iso-east-1",
            "us-iso-west-1"
        ],
        regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.c2s.ic.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.c2s.ic.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-iso-b": {
        regions: [
            "us-isob-east-1"
        ],
        regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.sc2s.sgov.gov",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.sc2s.sgov.gov",
                tags: [
                    "fips"
                ]
            }
        ]
    },
    "aws-us-gov": {
        regions: [
            "us-gov-east-1",
            "us-gov-west-1"
        ],
        regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
        variants: [
            {
                hostname: "geo.{region}.amazonaws.com",
                tags: []
            },
            {
                hostname: "geo-fips.{region}.amazonaws.com",
                tags: [
                    "fips"
                ]
            },
            {
                hostname: "geo-fips.{region}.api.aws",
                tags: [
                    "dualstack",
                    "fips"
                ]
            },
            {
                hostname: "geo.{region}.api.aws",
                tags: [
                    "dualstack"
                ]
            }
        ]
    }
};
var defaultRegionInfoProvider = function(region, options) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_a) {
            return [
                2,
                (0, _configResolver.getRegionInfo)(region, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    signingService: "geo",
                    regionHash: regionHash,
                    partitionHash: partitionHash
                }))
            ];
        });
    });
};

},{"tslib":"86BcK","@aws-sdk/config-resolver":"hrpyw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Rcjt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _associateTrackerConsumerCommand = require("./AssociateTrackerConsumerCommand");
parcelHelpers.exportAll(_associateTrackerConsumerCommand, exports);
var _batchDeleteDevicePositionHistoryCommand = require("./BatchDeleteDevicePositionHistoryCommand");
parcelHelpers.exportAll(_batchDeleteDevicePositionHistoryCommand, exports);
var _batchDeleteGeofenceCommand = require("./BatchDeleteGeofenceCommand");
parcelHelpers.exportAll(_batchDeleteGeofenceCommand, exports);
var _batchEvaluateGeofencesCommand = require("./BatchEvaluateGeofencesCommand");
parcelHelpers.exportAll(_batchEvaluateGeofencesCommand, exports);
var _batchGetDevicePositionCommand = require("./BatchGetDevicePositionCommand");
parcelHelpers.exportAll(_batchGetDevicePositionCommand, exports);
var _batchPutGeofenceCommand = require("./BatchPutGeofenceCommand");
parcelHelpers.exportAll(_batchPutGeofenceCommand, exports);
var _batchUpdateDevicePositionCommand = require("./BatchUpdateDevicePositionCommand");
parcelHelpers.exportAll(_batchUpdateDevicePositionCommand, exports);
var _calculateRouteCommand = require("./CalculateRouteCommand");
parcelHelpers.exportAll(_calculateRouteCommand, exports);
var _calculateRouteMatrixCommand = require("./CalculateRouteMatrixCommand");
parcelHelpers.exportAll(_calculateRouteMatrixCommand, exports);
var _createGeofenceCollectionCommand = require("./CreateGeofenceCollectionCommand");
parcelHelpers.exportAll(_createGeofenceCollectionCommand, exports);
var _createMapCommand = require("./CreateMapCommand");
parcelHelpers.exportAll(_createMapCommand, exports);
var _createPlaceIndexCommand = require("./CreatePlaceIndexCommand");
parcelHelpers.exportAll(_createPlaceIndexCommand, exports);
var _createRouteCalculatorCommand = require("./CreateRouteCalculatorCommand");
parcelHelpers.exportAll(_createRouteCalculatorCommand, exports);
var _createTrackerCommand = require("./CreateTrackerCommand");
parcelHelpers.exportAll(_createTrackerCommand, exports);
var _deleteGeofenceCollectionCommand = require("./DeleteGeofenceCollectionCommand");
parcelHelpers.exportAll(_deleteGeofenceCollectionCommand, exports);
var _deleteMapCommand = require("./DeleteMapCommand");
parcelHelpers.exportAll(_deleteMapCommand, exports);
var _deletePlaceIndexCommand = require("./DeletePlaceIndexCommand");
parcelHelpers.exportAll(_deletePlaceIndexCommand, exports);
var _deleteRouteCalculatorCommand = require("./DeleteRouteCalculatorCommand");
parcelHelpers.exportAll(_deleteRouteCalculatorCommand, exports);
var _deleteTrackerCommand = require("./DeleteTrackerCommand");
parcelHelpers.exportAll(_deleteTrackerCommand, exports);
var _describeGeofenceCollectionCommand = require("./DescribeGeofenceCollectionCommand");
parcelHelpers.exportAll(_describeGeofenceCollectionCommand, exports);
var _describeMapCommand = require("./DescribeMapCommand");
parcelHelpers.exportAll(_describeMapCommand, exports);
var _describePlaceIndexCommand = require("./DescribePlaceIndexCommand");
parcelHelpers.exportAll(_describePlaceIndexCommand, exports);
var _describeRouteCalculatorCommand = require("./DescribeRouteCalculatorCommand");
parcelHelpers.exportAll(_describeRouteCalculatorCommand, exports);
var _describeTrackerCommand = require("./DescribeTrackerCommand");
parcelHelpers.exportAll(_describeTrackerCommand, exports);
var _disassociateTrackerConsumerCommand = require("./DisassociateTrackerConsumerCommand");
parcelHelpers.exportAll(_disassociateTrackerConsumerCommand, exports);
var _getDevicePositionCommand = require("./GetDevicePositionCommand");
parcelHelpers.exportAll(_getDevicePositionCommand, exports);
var _getDevicePositionHistoryCommand = require("./GetDevicePositionHistoryCommand");
parcelHelpers.exportAll(_getDevicePositionHistoryCommand, exports);
var _getGeofenceCommand = require("./GetGeofenceCommand");
parcelHelpers.exportAll(_getGeofenceCommand, exports);
var _getMapGlyphsCommand = require("./GetMapGlyphsCommand");
parcelHelpers.exportAll(_getMapGlyphsCommand, exports);
var _getMapSpritesCommand = require("./GetMapSpritesCommand");
parcelHelpers.exportAll(_getMapSpritesCommand, exports);
var _getMapStyleDescriptorCommand = require("./GetMapStyleDescriptorCommand");
parcelHelpers.exportAll(_getMapStyleDescriptorCommand, exports);
var _getMapTileCommand = require("./GetMapTileCommand");
parcelHelpers.exportAll(_getMapTileCommand, exports);
var _getPlaceCommand = require("./GetPlaceCommand");
parcelHelpers.exportAll(_getPlaceCommand, exports);
var _listDevicePositionsCommand = require("./ListDevicePositionsCommand");
parcelHelpers.exportAll(_listDevicePositionsCommand, exports);
var _listGeofenceCollectionsCommand = require("./ListGeofenceCollectionsCommand");
parcelHelpers.exportAll(_listGeofenceCollectionsCommand, exports);
var _listGeofencesCommand = require("./ListGeofencesCommand");
parcelHelpers.exportAll(_listGeofencesCommand, exports);
var _listMapsCommand = require("./ListMapsCommand");
parcelHelpers.exportAll(_listMapsCommand, exports);
var _listPlaceIndexesCommand = require("./ListPlaceIndexesCommand");
parcelHelpers.exportAll(_listPlaceIndexesCommand, exports);
var _listRouteCalculatorsCommand = require("./ListRouteCalculatorsCommand");
parcelHelpers.exportAll(_listRouteCalculatorsCommand, exports);
var _listTagsForResourceCommand = require("./ListTagsForResourceCommand");
parcelHelpers.exportAll(_listTagsForResourceCommand, exports);
var _listTrackerConsumersCommand = require("./ListTrackerConsumersCommand");
parcelHelpers.exportAll(_listTrackerConsumersCommand, exports);
var _listTrackersCommand = require("./ListTrackersCommand");
parcelHelpers.exportAll(_listTrackersCommand, exports);
var _putGeofenceCommand = require("./PutGeofenceCommand");
parcelHelpers.exportAll(_putGeofenceCommand, exports);
var _searchPlaceIndexForPositionCommand = require("./SearchPlaceIndexForPositionCommand");
parcelHelpers.exportAll(_searchPlaceIndexForPositionCommand, exports);
var _searchPlaceIndexForSuggestionsCommand = require("./SearchPlaceIndexForSuggestionsCommand");
parcelHelpers.exportAll(_searchPlaceIndexForSuggestionsCommand, exports);
var _searchPlaceIndexForTextCommand = require("./SearchPlaceIndexForTextCommand");
parcelHelpers.exportAll(_searchPlaceIndexForTextCommand, exports);
var _tagResourceCommand = require("./TagResourceCommand");
parcelHelpers.exportAll(_tagResourceCommand, exports);
var _untagResourceCommand = require("./UntagResourceCommand");
parcelHelpers.exportAll(_untagResourceCommand, exports);
var _updateGeofenceCollectionCommand = require("./UpdateGeofenceCollectionCommand");
parcelHelpers.exportAll(_updateGeofenceCollectionCommand, exports);
var _updateMapCommand = require("./UpdateMapCommand");
parcelHelpers.exportAll(_updateMapCommand, exports);
var _updatePlaceIndexCommand = require("./UpdatePlaceIndexCommand");
parcelHelpers.exportAll(_updatePlaceIndexCommand, exports);
var _updateRouteCalculatorCommand = require("./UpdateRouteCalculatorCommand");
parcelHelpers.exportAll(_updateRouteCalculatorCommand, exports);
var _updateTrackerCommand = require("./UpdateTrackerCommand");
parcelHelpers.exportAll(_updateTrackerCommand, exports);

},{"./AssociateTrackerConsumerCommand":false,"./BatchDeleteDevicePositionHistoryCommand":false,"./BatchDeleteGeofenceCommand":"f9QbY","./BatchEvaluateGeofencesCommand":false,"./BatchGetDevicePositionCommand":false,"./BatchPutGeofenceCommand":"6G5dO","./BatchUpdateDevicePositionCommand":false,"./CalculateRouteCommand":false,"./CalculateRouteMatrixCommand":false,"./CreateGeofenceCollectionCommand":false,"./CreateMapCommand":false,"./CreatePlaceIndexCommand":false,"./CreateRouteCalculatorCommand":false,"./CreateTrackerCommand":false,"./DeleteGeofenceCollectionCommand":false,"./DeleteMapCommand":false,"./DeletePlaceIndexCommand":false,"./DeleteRouteCalculatorCommand":false,"./DeleteTrackerCommand":false,"./DescribeGeofenceCollectionCommand":false,"./DescribeMapCommand":false,"./DescribePlaceIndexCommand":false,"./DescribeRouteCalculatorCommand":false,"./DescribeTrackerCommand":false,"./DisassociateTrackerConsumerCommand":false,"./GetDevicePositionCommand":false,"./GetDevicePositionHistoryCommand":false,"./GetGeofenceCommand":"4Sb9m","./GetMapGlyphsCommand":false,"./GetMapSpritesCommand":false,"./GetMapStyleDescriptorCommand":false,"./GetMapTileCommand":false,"./GetPlaceCommand":"aCfAq","./ListDevicePositionsCommand":false,"./ListGeofenceCollectionsCommand":false,"./ListGeofencesCommand":"c6YDt","./ListMapsCommand":false,"./ListPlaceIndexesCommand":false,"./ListRouteCalculatorsCommand":false,"./ListTagsForResourceCommand":false,"./ListTrackerConsumersCommand":false,"./ListTrackersCommand":false,"./PutGeofenceCommand":false,"./SearchPlaceIndexForPositionCommand":"8uRyG","./SearchPlaceIndexForSuggestionsCommand":"gEjA4","./SearchPlaceIndexForTextCommand":"aO5IJ","./TagResourceCommand":false,"./UntagResourceCommand":false,"./UpdateGeofenceCollectionCommand":false,"./UpdateMapCommand":false,"./UpdatePlaceIndexCommand":false,"./UpdateRouteCalculatorCommand":false,"./UpdateTrackerCommand":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f9QbY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchDeleteGeofenceCommand", ()=>BatchDeleteGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchDeleteGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchDeleteGeofenceCommand, _super);
    function BatchDeleteGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchDeleteGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchDeleteGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchDeleteGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchDeleteGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchDeleteGeofenceCommand)(input, context);
    };
    BatchDeleteGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchDeleteGeofenceCommand)(output, context);
    };
    return BatchDeleteGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"el26T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deserializerMiddleware = require("./deserializerMiddleware");
parcelHelpers.exportAll(_deserializerMiddleware, exports);
var _serdePlugin = require("./serdePlugin");
parcelHelpers.exportAll(_serdePlugin, exports);
var _serializerMiddleware = require("./serializerMiddleware");
parcelHelpers.exportAll(_serializerMiddleware, exports);

},{"./deserializerMiddleware":"3LlHo","./serdePlugin":"8H2p3","./serializerMiddleware":"l5WcC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LlHo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddleware", ()=>deserializerMiddleware);
var _tslib = require("tslib");
var deserializerMiddleware = function(options, deserializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var response, parsed, error_1;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4,
                                next(args)
                            ];
                        case 1:
                            response = _a.sent().response;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                deserializer(response, options)
                            ];
                        case 3:
                            parsed = _a.sent();
                            return [
                                2,
                                {
                                    response: response,
                                    output: parsed
                                }
                            ];
                        case 4:
                            error_1 = _a.sent();
                            Object.defineProperty(error_1, "$response", {
                                value: response
                            });
                            throw error_1;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8H2p3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserializerMiddlewareOption", ()=>deserializerMiddlewareOption);
parcelHelpers.export(exports, "serializerMiddlewareOption", ()=>serializerMiddlewareOption);
parcelHelpers.export(exports, "getSerdePlugin", ()=>getSerdePlugin);
var _deserializerMiddleware = require("./deserializerMiddleware");
var _serializerMiddleware = require("./serializerMiddleware");
var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function(commandStack) {
            commandStack.add((0, _deserializerMiddleware.deserializerMiddleware)(config, deserializer), deserializerMiddlewareOption);
            commandStack.add((0, _serializerMiddleware.serializerMiddleware)(config, serializer), serializerMiddlewareOption);
        }
    };
}

},{"./deserializerMiddleware":"3LlHo","./serializerMiddleware":"l5WcC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5WcC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializerMiddleware", ()=>serializerMiddleware);
var _tslib = require("tslib");
var serializerMiddleware = function(options, serializer) {
    return function(next, context) {
        return function(args) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var endpoint, request;
                var _a;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            endpoint = ((_a = context.endpointV2) === null || _a === void 0 ? void 0 : _a.url) && options.urlParser ? function() {
                                return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        return [
                                            2,
                                            options.urlParser(context.endpointV2.url)
                                        ];
                                    });
                                });
                            } : options.endpoint;
                            if (!endpoint) throw new Error("No valid endpoint provider available.");
                            return [
                                4,
                                serializer(args.input, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    endpoint: endpoint
                                }))
                            ];
                        case 1:
                            request = _b.sent();
                            return [
                                2,
                                next((0, _tslib.__assign)((0, _tslib.__assign)({}, args), {
                                    request: request
                                }))
                            ];
                    }
                });
            });
        };
    };
};

},{"tslib":"86BcK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b7IJ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessDeniedException", ()=>AccessDeniedException);
parcelHelpers.export(exports, "ConflictException", ()=>ConflictException);
parcelHelpers.export(exports, "InternalServerException", ()=>InternalServerException);
parcelHelpers.export(exports, "ResourceNotFoundException", ()=>ResourceNotFoundException);
parcelHelpers.export(exports, "ServiceQuotaExceededException", ()=>ServiceQuotaExceededException);
parcelHelpers.export(exports, "ThrottlingException", ()=>ThrottlingException);
parcelHelpers.export(exports, "ValidationException", ()=>ValidationException);
parcelHelpers.export(exports, "AssociateTrackerConsumerRequestFilterSensitiveLog", ()=>AssociateTrackerConsumerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "AssociateTrackerConsumerResponseFilterSensitiveLog", ()=>AssociateTrackerConsumerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ValidationExceptionFieldFilterSensitiveLog", ()=>ValidationExceptionFieldFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchItemErrorFilterSensitiveLog", ()=>BatchItemErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog", ()=>BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceRequestFilterSensitiveLog", ()=>BatchDeleteGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceErrorFilterSensitiveLog", ()=>BatchDeleteGeofenceErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchDeleteGeofenceResponseFilterSensitiveLog", ()=>BatchDeleteGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PositionalAccuracyFilterSensitiveLog", ()=>PositionalAccuracyFilterSensitiveLog);
parcelHelpers.export(exports, "DevicePositionUpdateFilterSensitiveLog", ()=>DevicePositionUpdateFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesRequestFilterSensitiveLog", ()=>BatchEvaluateGeofencesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesErrorFilterSensitiveLog", ()=>BatchEvaluateGeofencesErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchEvaluateGeofencesResponseFilterSensitiveLog", ()=>BatchEvaluateGeofencesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionRequestFilterSensitiveLog", ()=>BatchGetDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DevicePositionFilterSensitiveLog", ()=>DevicePositionFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionErrorFilterSensitiveLog", ()=>BatchGetDevicePositionErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchGetDevicePositionResponseFilterSensitiveLog", ()=>BatchGetDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CircleFilterSensitiveLog", ()=>CircleFilterSensitiveLog);
parcelHelpers.export(exports, "GeofenceGeometryFilterSensitiveLog", ()=>GeofenceGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceRequestEntryFilterSensitiveLog", ()=>BatchPutGeofenceRequestEntryFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceRequestFilterSensitiveLog", ()=>BatchPutGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceErrorFilterSensitiveLog", ()=>BatchPutGeofenceErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceSuccessFilterSensitiveLog", ()=>BatchPutGeofenceSuccessFilterSensitiveLog);
parcelHelpers.export(exports, "BatchPutGeofenceResponseFilterSensitiveLog", ()=>BatchPutGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionRequestFilterSensitiveLog", ()=>BatchUpdateDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionErrorFilterSensitiveLog", ()=>BatchUpdateDevicePositionErrorFilterSensitiveLog);
parcelHelpers.export(exports, "BatchUpdateDevicePositionResponseFilterSensitiveLog", ()=>BatchUpdateDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteCarModeOptionsFilterSensitiveLog", ()=>CalculateRouteCarModeOptionsFilterSensitiveLog);
parcelHelpers.export(exports, "TruckDimensionsFilterSensitiveLog", ()=>TruckDimensionsFilterSensitiveLog);
parcelHelpers.export(exports, "TruckWeightFilterSensitiveLog", ()=>TruckWeightFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteTruckModeOptionsFilterSensitiveLog", ()=>CalculateRouteTruckModeOptionsFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteRequestFilterSensitiveLog", ()=>CalculateRouteRequestFilterSensitiveLog);
parcelHelpers.export(exports, "LegGeometryFilterSensitiveLog", ()=>LegGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "StepFilterSensitiveLog", ()=>StepFilterSensitiveLog);
parcelHelpers.export(exports, "LegFilterSensitiveLog", ()=>LegFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteSummaryFilterSensitiveLog", ()=>CalculateRouteSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteResponseFilterSensitiveLog", ()=>CalculateRouteResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixRequestFilterSensitiveLog", ()=>CalculateRouteMatrixRequestFilterSensitiveLog);
parcelHelpers.export(exports, "RouteMatrixEntryErrorFilterSensitiveLog", ()=>RouteMatrixEntryErrorFilterSensitiveLog);
parcelHelpers.export(exports, "RouteMatrixEntryFilterSensitiveLog", ()=>RouteMatrixEntryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixSummaryFilterSensitiveLog", ()=>CalculateRouteMatrixSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "CalculateRouteMatrixResponseFilterSensitiveLog", ()=>CalculateRouteMatrixResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateGeofenceCollectionRequestFilterSensitiveLog", ()=>CreateGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateGeofenceCollectionResponseFilterSensitiveLog", ()=>CreateGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "MapConfigurationFilterSensitiveLog", ()=>MapConfigurationFilterSensitiveLog);
parcelHelpers.export(exports, "CreateMapRequestFilterSensitiveLog", ()=>CreateMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateMapResponseFilterSensitiveLog", ()=>CreateMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DataSourceConfigurationFilterSensitiveLog", ()=>DataSourceConfigurationFilterSensitiveLog);
parcelHelpers.export(exports, "CreatePlaceIndexRequestFilterSensitiveLog", ()=>CreatePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreatePlaceIndexResponseFilterSensitiveLog", ()=>CreatePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateRouteCalculatorRequestFilterSensitiveLog", ()=>CreateRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateRouteCalculatorResponseFilterSensitiveLog", ()=>CreateRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "CreateTrackerRequestFilterSensitiveLog", ()=>CreateTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "CreateTrackerResponseFilterSensitiveLog", ()=>CreateTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteGeofenceCollectionRequestFilterSensitiveLog", ()=>DeleteGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteGeofenceCollectionResponseFilterSensitiveLog", ()=>DeleteGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteMapRequestFilterSensitiveLog", ()=>DeleteMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteMapResponseFilterSensitiveLog", ()=>DeleteMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeletePlaceIndexRequestFilterSensitiveLog", ()=>DeletePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeletePlaceIndexResponseFilterSensitiveLog", ()=>DeletePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteRouteCalculatorRequestFilterSensitiveLog", ()=>DeleteRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteRouteCalculatorResponseFilterSensitiveLog", ()=>DeleteRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteTrackerRequestFilterSensitiveLog", ()=>DeleteTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DeleteTrackerResponseFilterSensitiveLog", ()=>DeleteTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeGeofenceCollectionRequestFilterSensitiveLog", ()=>DescribeGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeGeofenceCollectionResponseFilterSensitiveLog", ()=>DescribeGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeMapRequestFilterSensitiveLog", ()=>DescribeMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeMapResponseFilterSensitiveLog", ()=>DescribeMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribePlaceIndexRequestFilterSensitiveLog", ()=>DescribePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribePlaceIndexResponseFilterSensitiveLog", ()=>DescribePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeRouteCalculatorRequestFilterSensitiveLog", ()=>DescribeRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeRouteCalculatorResponseFilterSensitiveLog", ()=>DescribeRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeTrackerRequestFilterSensitiveLog", ()=>DescribeTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DescribeTrackerResponseFilterSensitiveLog", ()=>DescribeTrackerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "DisassociateTrackerConsumerRequestFilterSensitiveLog", ()=>DisassociateTrackerConsumerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "DisassociateTrackerConsumerResponseFilterSensitiveLog", ()=>DisassociateTrackerConsumerResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTagsForResourceRequestFilterSensitiveLog", ()=>ListTagsForResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTagsForResourceResponseFilterSensitiveLog", ()=>ListTagsForResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "TagResourceRequestFilterSensitiveLog", ()=>TagResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "TagResourceResponseFilterSensitiveLog", ()=>TagResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UntagResourceRequestFilterSensitiveLog", ()=>UntagResourceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UntagResourceResponseFilterSensitiveLog", ()=>UntagResourceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetGeofenceRequestFilterSensitiveLog", ()=>GetGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetGeofenceResponseFilterSensitiveLog", ()=>GetGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsRequestFilterSensitiveLog", ()=>ListGeofenceCollectionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseEntryFilterSensitiveLog", ()=>ListGeofenceCollectionsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceCollectionsResponseFilterSensitiveLog", ()=>ListGeofenceCollectionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofencesRequestFilterSensitiveLog", ()=>ListGeofencesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofenceResponseEntryFilterSensitiveLog", ()=>ListGeofenceResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListGeofencesResponseFilterSensitiveLog", ()=>ListGeofencesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "PutGeofenceRequestFilterSensitiveLog", ()=>PutGeofenceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PutGeofenceResponseFilterSensitiveLog", ()=>PutGeofenceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateGeofenceCollectionRequestFilterSensitiveLog", ()=>UpdateGeofenceCollectionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateGeofenceCollectionResponseFilterSensitiveLog", ()=>UpdateGeofenceCollectionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionRequestFilterSensitiveLog", ()=>GetDevicePositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionResponseFilterSensitiveLog", ()=>GetDevicePositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionHistoryRequestFilterSensitiveLog", ()=>GetDevicePositionHistoryRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetDevicePositionHistoryResponseFilterSensitiveLog", ()=>GetDevicePositionHistoryResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapGlyphsRequestFilterSensitiveLog", ()=>GetMapGlyphsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapGlyphsResponseFilterSensitiveLog", ()=>GetMapGlyphsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapSpritesRequestFilterSensitiveLog", ()=>GetMapSpritesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapSpritesResponseFilterSensitiveLog", ()=>GetMapSpritesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapStyleDescriptorRequestFilterSensitiveLog", ()=>GetMapStyleDescriptorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapStyleDescriptorResponseFilterSensitiveLog", ()=>GetMapStyleDescriptorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapTileRequestFilterSensitiveLog", ()=>GetMapTileRequestFilterSensitiveLog);
parcelHelpers.export(exports, "GetMapTileResponseFilterSensitiveLog", ()=>GetMapTileResponseFilterSensitiveLog);
parcelHelpers.export(exports, "GetPlaceRequestFilterSensitiveLog", ()=>GetPlaceRequestFilterSensitiveLog);
parcelHelpers.export(exports, "PlaceGeometryFilterSensitiveLog", ()=>PlaceGeometryFilterSensitiveLog);
parcelHelpers.export(exports, "TimeZoneFilterSensitiveLog", ()=>TimeZoneFilterSensitiveLog);
parcelHelpers.export(exports, "PlaceFilterSensitiveLog", ()=>PlaceFilterSensitiveLog);
parcelHelpers.export(exports, "GetPlaceResponseFilterSensitiveLog", ()=>GetPlaceResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsRequestFilterSensitiveLog", ()=>ListDevicePositionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsResponseEntryFilterSensitiveLog", ()=>ListDevicePositionsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListDevicePositionsResponseFilterSensitiveLog", ()=>ListDevicePositionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsRequestFilterSensitiveLog", ()=>ListMapsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsResponseEntryFilterSensitiveLog", ()=>ListMapsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListMapsResponseFilterSensitiveLog", ()=>ListMapsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesRequestFilterSensitiveLog", ()=>ListPlaceIndexesRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesResponseEntryFilterSensitiveLog", ()=>ListPlaceIndexesResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListPlaceIndexesResponseFilterSensitiveLog", ()=>ListPlaceIndexesResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsRequestFilterSensitiveLog", ()=>ListRouteCalculatorsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsResponseEntryFilterSensitiveLog", ()=>ListRouteCalculatorsResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListRouteCalculatorsResponseFilterSensitiveLog", ()=>ListRouteCalculatorsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackerConsumersRequestFilterSensitiveLog", ()=>ListTrackerConsumersRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackerConsumersResponseFilterSensitiveLog", ()=>ListTrackerConsumersResponseFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersRequestFilterSensitiveLog", ()=>ListTrackersRequestFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersResponseEntryFilterSensitiveLog", ()=>ListTrackersResponseEntryFilterSensitiveLog);
parcelHelpers.export(exports, "ListTrackersResponseFilterSensitiveLog", ()=>ListTrackersResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateMapRequestFilterSensitiveLog", ()=>UpdateMapRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateMapResponseFilterSensitiveLog", ()=>UpdateMapResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionRequestFilterSensitiveLog", ()=>SearchPlaceIndexForPositionRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForPositionResultFilterSensitiveLog", ()=>SearchForPositionResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForPositionSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionResponseFilterSensitiveLog", ()=>SearchPlaceIndexForPositionResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForSuggestionsResultFilterSensitiveLog", ()=>SearchForSuggestionsResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog", ()=>SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextRequestFilterSensitiveLog", ()=>SearchPlaceIndexForTextRequestFilterSensitiveLog);
parcelHelpers.export(exports, "SearchForTextResultFilterSensitiveLog", ()=>SearchForTextResultFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextSummaryFilterSensitiveLog", ()=>SearchPlaceIndexForTextSummaryFilterSensitiveLog);
parcelHelpers.export(exports, "SearchPlaceIndexForTextResponseFilterSensitiveLog", ()=>SearchPlaceIndexForTextResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdatePlaceIndexRequestFilterSensitiveLog", ()=>UpdatePlaceIndexRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdatePlaceIndexResponseFilterSensitiveLog", ()=>UpdatePlaceIndexResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateRouteCalculatorRequestFilterSensitiveLog", ()=>UpdateRouteCalculatorRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateRouteCalculatorResponseFilterSensitiveLog", ()=>UpdateRouteCalculatorResponseFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateTrackerRequestFilterSensitiveLog", ()=>UpdateTrackerRequestFilterSensitiveLog);
parcelHelpers.export(exports, "UpdateTrackerResponseFilterSensitiveLog", ()=>UpdateTrackerResponseFilterSensitiveLog);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("./LocationServiceException");
var AccessDeniedException = function(_super) {
    (0, _tslib.__extends)(AccessDeniedException, _super);
    function AccessDeniedException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "AccessDeniedException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "AccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AccessDeniedException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return AccessDeniedException;
}((0, _locationServiceException.LocationServiceException));
var ConflictException = function(_super) {
    (0, _tslib.__extends)(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ConflictException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConflictException;
}((0, _locationServiceException.LocationServiceException));
var InternalServerException = function(_super) {
    (0, _tslib.__extends)(InternalServerException, _super);
    function InternalServerException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "InternalServerException",
            $fault: "server"
        }, opts)) || this;
        _this.name = "InternalServerException";
        _this.$fault = "server";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, InternalServerException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalServerException;
}((0, _locationServiceException.LocationServiceException));
var ResourceNotFoundException = function(_super) {
    (0, _tslib.__extends)(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ResourceNotFoundException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ResourceNotFoundException;
}((0, _locationServiceException.LocationServiceException));
var ServiceQuotaExceededException = function(_super) {
    (0, _tslib.__extends)(ServiceQuotaExceededException, _super);
    function ServiceQuotaExceededException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ServiceQuotaExceededException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ServiceQuotaExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ServiceQuotaExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ServiceQuotaExceededException;
}((0, _locationServiceException.LocationServiceException));
var ThrottlingException = function(_super) {
    (0, _tslib.__extends)(ThrottlingException, _super);
    function ThrottlingException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ThrottlingException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ThrottlingException";
        _this.$fault = "client";
        _this.$retryable = {};
        Object.setPrototypeOf(_this, ThrottlingException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ThrottlingException;
}((0, _locationServiceException.LocationServiceException));
var ValidationException = function(_super) {
    (0, _tslib.__extends)(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, (0, _tslib.__assign)({
            name: "ValidationException",
            $fault: "client"
        }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        _this.Reason = opts.Reason;
        _this.FieldList = opts.FieldList;
        return _this;
    }
    return ValidationException;
}((0, _locationServiceException.LocationServiceException));
var AssociateTrackerConsumerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var AssociateTrackerConsumerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ValidationExceptionFieldFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchItemErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteDevicePositionHistoryResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchDeleteGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PositionalAccuracyFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionUpdateFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchEvaluateGeofencesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositionUpdates && {
        DevicePositionUpdates: obj.DevicePositionUpdates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchEvaluateGeofencesErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchEvaluateGeofencesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DevicePositionFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchGetDevicePositionErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchGetDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var CircleFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Center && {
        Center: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GeofenceGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Polygon && {
        Polygon: obj.Polygon.map(function(item) {
            return 0, _smithyClient.SENSITIVE_STRING;
        })
    }), obj.Circle && {
        Circle: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var BatchPutGeofenceRequestEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var BatchPutGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return BatchPutGeofenceRequestEntryFilterSensitiveLog(item);
        })
    });
};
var BatchPutGeofenceErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceSuccessFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchPutGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Updates && {
        Updates: obj.Updates.map(function(item) {
            return DevicePositionUpdateFilterSensitiveLog(item);
        })
    });
};
var BatchUpdateDevicePositionErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var BatchUpdateDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteCarModeOptionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckDimensionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TruckWeightFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteTruckModeOptionsFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePosition && {
        DeparturePosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPosition && {
        DestinationPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.WaypointPositions && {
        WaypointPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.LineString && {
        LineString: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var StepFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var LegFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.StartPosition && {
        StartPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.EndPosition && {
        EndPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.Geometry && {
        Geometry: LegGeometryFilterSensitiveLog(obj.Geometry)
    }), obj.Steps && {
        Steps: obj.Steps.map(function(item) {
            return StepFilterSensitiveLog(item);
        })
    });
};
var CalculateRouteSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.RouteBBox && {
        RouteBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CalculateRouteResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Legs && {
        Legs: obj.Legs.map(function(item) {
            return LegFilterSensitiveLog(item);
        })
    }), obj.Summary && {
        Summary: CalculateRouteSummaryFilterSensitiveLog(obj.Summary)
    });
};
var CalculateRouteMatrixRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DeparturePositions && {
        DeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.DestinationPositions && {
        DestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var RouteMatrixEntryErrorFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var RouteMatrixEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CalculateRouteMatrixResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.SnappedDeparturePositions && {
        SnappedDeparturePositions: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.SnappedDestinationPositions && {
        SnappedDestinationPositions: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var CreateGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var MapConfigurationFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DataSourceConfigurationFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreatePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var CreateTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeletePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DeleteTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DescribeTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var DisassociateTrackerConsumerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTagsForResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var TagResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UntagResourceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofenceCollectionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceCollectionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofencesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListGeofenceResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var ListGeofencesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListGeofenceResponseEntryFilterSensitiveLog(item);
        })
    });
};
var PutGeofenceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: GeofenceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var PutGeofenceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateGeofenceCollectionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var GetDevicePositionHistoryRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetDevicePositionHistoryResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.DevicePositions && {
        DevicePositions: obj.DevicePositions.map(function(item) {
            return DevicePositionFilterSensitiveLog(item);
        })
    });
};
var GetMapGlyphsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapGlyphsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapSpritesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapStyleDescriptorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetMapTileResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var GetPlaceRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceGeometryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Point && {
        Point: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var TimeZoneFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var PlaceFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Geometry && {
        Geometry: PlaceGeometryFilterSensitiveLog(obj.Geometry)
    });
};
var GetPlaceResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var ListDevicePositionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListDevicePositionsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.PositionProperties && {
        PositionProperties: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var ListDevicePositionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Entries && {
        Entries: obj.Entries.map(function(item) {
            return ListDevicePositionsResponseEntryFilterSensitiveLog(item);
        })
    });
};
var ListMapsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListMapsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListPlaceIndexesResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListRouteCalculatorsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackerConsumersResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseEntryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var ListTrackersResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateMapResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForPositionRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForPositionResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForPositionSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Position && {
        Position: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForPositionResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForPositionSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForPositionResultFilterSensitiveLog(item);
        })
    });
};
var SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForSuggestionsResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForSuggestionsSummaryFilterSensitiveLog(obj.Summary)
    });
};
var SearchPlaceIndexForTextRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchForTextResultFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Place && {
        Place: PlaceFilterSensitiveLog(obj.Place)
    });
};
var SearchPlaceIndexForTextSummaryFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Text && {
        Text: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.BiasPosition && {
        BiasPosition: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.FilterBBox && {
        FilterBBox: (0, _smithyClient.SENSITIVE_STRING)
    }), obj.ResultBBox && {
        ResultBBox: (0, _smithyClient.SENSITIVE_STRING)
    });
};
var SearchPlaceIndexForTextResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, obj), obj.Summary && {
        Summary: SearchPlaceIndexForTextSummaryFilterSensitiveLog(obj.Summary)
    }), obj.Results && {
        Results: obj.Results.map(function(item) {
            return SearchForTextResultFilterSensitiveLog(item);
        })
    });
};
var UpdatePlaceIndexRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdatePlaceIndexResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateRouteCalculatorResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerRequestFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};
var UpdateTrackerResponseFilterSensitiveLog = function(obj) {
    return (0, _tslib.__assign)({}, obj);
};

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6yS5y","./LocationServiceException":"g5vja","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g5vja":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationServiceException", ()=>LocationServiceException);
var _tslib = require("tslib");
var _smithyClient = require("@aws-sdk/smithy-client");
var LocationServiceException = function(_super) {
    (0, _tslib.__extends)(LocationServiceException, _super);
    function LocationServiceException(options) {
        var _this = _super.call(this, options) || this;
        Object.setPrototypeOf(_this, LocationServiceException.prototype);
        return _this;
    }
    return LocationServiceException;
}((0, _smithyClient.ServiceException));

},{"tslib":"86BcK","@aws-sdk/smithy-client":"6yS5y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"76VEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeAws_restJson1AssociateTrackerConsumerCommand", ()=>serializeAws_restJson1AssociateTrackerConsumerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", ()=>serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchDeleteGeofenceCommand", ()=>serializeAws_restJson1BatchDeleteGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchEvaluateGeofencesCommand", ()=>serializeAws_restJson1BatchEvaluateGeofencesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchGetDevicePositionCommand", ()=>serializeAws_restJson1BatchGetDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchPutGeofenceCommand", ()=>serializeAws_restJson1BatchPutGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1BatchUpdateDevicePositionCommand", ()=>serializeAws_restJson1BatchUpdateDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteCommand", ()=>serializeAws_restJson1CalculateRouteCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CalculateRouteMatrixCommand", ()=>serializeAws_restJson1CalculateRouteMatrixCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateGeofenceCollectionCommand", ()=>serializeAws_restJson1CreateGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateMapCommand", ()=>serializeAws_restJson1CreateMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreatePlaceIndexCommand", ()=>serializeAws_restJson1CreatePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateRouteCalculatorCommand", ()=>serializeAws_restJson1CreateRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1CreateTrackerCommand", ()=>serializeAws_restJson1CreateTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteGeofenceCollectionCommand", ()=>serializeAws_restJson1DeleteGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteMapCommand", ()=>serializeAws_restJson1DeleteMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeletePlaceIndexCommand", ()=>serializeAws_restJson1DeletePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteRouteCalculatorCommand", ()=>serializeAws_restJson1DeleteRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DeleteTrackerCommand", ()=>serializeAws_restJson1DeleteTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeGeofenceCollectionCommand", ()=>serializeAws_restJson1DescribeGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeMapCommand", ()=>serializeAws_restJson1DescribeMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribePlaceIndexCommand", ()=>serializeAws_restJson1DescribePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeRouteCalculatorCommand", ()=>serializeAws_restJson1DescribeRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DescribeTrackerCommand", ()=>serializeAws_restJson1DescribeTrackerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1DisassociateTrackerConsumerCommand", ()=>serializeAws_restJson1DisassociateTrackerConsumerCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionCommand", ()=>serializeAws_restJson1GetDevicePositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetDevicePositionHistoryCommand", ()=>serializeAws_restJson1GetDevicePositionHistoryCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetGeofenceCommand", ()=>serializeAws_restJson1GetGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapGlyphsCommand", ()=>serializeAws_restJson1GetMapGlyphsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapSpritesCommand", ()=>serializeAws_restJson1GetMapSpritesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapStyleDescriptorCommand", ()=>serializeAws_restJson1GetMapStyleDescriptorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetMapTileCommand", ()=>serializeAws_restJson1GetMapTileCommand);
parcelHelpers.export(exports, "serializeAws_restJson1GetPlaceCommand", ()=>serializeAws_restJson1GetPlaceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListDevicePositionsCommand", ()=>serializeAws_restJson1ListDevicePositionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofenceCollectionsCommand", ()=>serializeAws_restJson1ListGeofenceCollectionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListGeofencesCommand", ()=>serializeAws_restJson1ListGeofencesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListMapsCommand", ()=>serializeAws_restJson1ListMapsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListPlaceIndexesCommand", ()=>serializeAws_restJson1ListPlaceIndexesCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListRouteCalculatorsCommand", ()=>serializeAws_restJson1ListRouteCalculatorsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTagsForResourceCommand", ()=>serializeAws_restJson1ListTagsForResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackerConsumersCommand", ()=>serializeAws_restJson1ListTrackerConsumersCommand);
parcelHelpers.export(exports, "serializeAws_restJson1ListTrackersCommand", ()=>serializeAws_restJson1ListTrackersCommand);
parcelHelpers.export(exports, "serializeAws_restJson1PutGeofenceCommand", ()=>serializeAws_restJson1PutGeofenceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForPositionCommand", ()=>serializeAws_restJson1SearchPlaceIndexForPositionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", ()=>serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand);
parcelHelpers.export(exports, "serializeAws_restJson1SearchPlaceIndexForTextCommand", ()=>serializeAws_restJson1SearchPlaceIndexForTextCommand);
parcelHelpers.export(exports, "serializeAws_restJson1TagResourceCommand", ()=>serializeAws_restJson1TagResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UntagResourceCommand", ()=>serializeAws_restJson1UntagResourceCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateGeofenceCollectionCommand", ()=>serializeAws_restJson1UpdateGeofenceCollectionCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateMapCommand", ()=>serializeAws_restJson1UpdateMapCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdatePlaceIndexCommand", ()=>serializeAws_restJson1UpdatePlaceIndexCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateRouteCalculatorCommand", ()=>serializeAws_restJson1UpdateRouteCalculatorCommand);
parcelHelpers.export(exports, "serializeAws_restJson1UpdateTrackerCommand", ()=>serializeAws_restJson1UpdateTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1AssociateTrackerConsumerCommand", ()=>deserializeAws_restJson1AssociateTrackerConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand", ()=>deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchDeleteGeofenceCommand", ()=>deserializeAws_restJson1BatchDeleteGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchEvaluateGeofencesCommand", ()=>deserializeAws_restJson1BatchEvaluateGeofencesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchGetDevicePositionCommand", ()=>deserializeAws_restJson1BatchGetDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchPutGeofenceCommand", ()=>deserializeAws_restJson1BatchPutGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1BatchUpdateDevicePositionCommand", ()=>deserializeAws_restJson1BatchUpdateDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteCommand", ()=>deserializeAws_restJson1CalculateRouteCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CalculateRouteMatrixCommand", ()=>deserializeAws_restJson1CalculateRouteMatrixCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateGeofenceCollectionCommand", ()=>deserializeAws_restJson1CreateGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateMapCommand", ()=>deserializeAws_restJson1CreateMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreatePlaceIndexCommand", ()=>deserializeAws_restJson1CreatePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateRouteCalculatorCommand", ()=>deserializeAws_restJson1CreateRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1CreateTrackerCommand", ()=>deserializeAws_restJson1CreateTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteGeofenceCollectionCommand", ()=>deserializeAws_restJson1DeleteGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteMapCommand", ()=>deserializeAws_restJson1DeleteMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeletePlaceIndexCommand", ()=>deserializeAws_restJson1DeletePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteRouteCalculatorCommand", ()=>deserializeAws_restJson1DeleteRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DeleteTrackerCommand", ()=>deserializeAws_restJson1DeleteTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeGeofenceCollectionCommand", ()=>deserializeAws_restJson1DescribeGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeMapCommand", ()=>deserializeAws_restJson1DescribeMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribePlaceIndexCommand", ()=>deserializeAws_restJson1DescribePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeRouteCalculatorCommand", ()=>deserializeAws_restJson1DescribeRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DescribeTrackerCommand", ()=>deserializeAws_restJson1DescribeTrackerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1DisassociateTrackerConsumerCommand", ()=>deserializeAws_restJson1DisassociateTrackerConsumerCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionCommand", ()=>deserializeAws_restJson1GetDevicePositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetDevicePositionHistoryCommand", ()=>deserializeAws_restJson1GetDevicePositionHistoryCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetGeofenceCommand", ()=>deserializeAws_restJson1GetGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapGlyphsCommand", ()=>deserializeAws_restJson1GetMapGlyphsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapSpritesCommand", ()=>deserializeAws_restJson1GetMapSpritesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapStyleDescriptorCommand", ()=>deserializeAws_restJson1GetMapStyleDescriptorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetMapTileCommand", ()=>deserializeAws_restJson1GetMapTileCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1GetPlaceCommand", ()=>deserializeAws_restJson1GetPlaceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListDevicePositionsCommand", ()=>deserializeAws_restJson1ListDevicePositionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofenceCollectionsCommand", ()=>deserializeAws_restJson1ListGeofenceCollectionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListGeofencesCommand", ()=>deserializeAws_restJson1ListGeofencesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListMapsCommand", ()=>deserializeAws_restJson1ListMapsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListPlaceIndexesCommand", ()=>deserializeAws_restJson1ListPlaceIndexesCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListRouteCalculatorsCommand", ()=>deserializeAws_restJson1ListRouteCalculatorsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTagsForResourceCommand", ()=>deserializeAws_restJson1ListTagsForResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackerConsumersCommand", ()=>deserializeAws_restJson1ListTrackerConsumersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1ListTrackersCommand", ()=>deserializeAws_restJson1ListTrackersCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1PutGeofenceCommand", ()=>deserializeAws_restJson1PutGeofenceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForPositionCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForPositionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1SearchPlaceIndexForTextCommand", ()=>deserializeAws_restJson1SearchPlaceIndexForTextCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1TagResourceCommand", ()=>deserializeAws_restJson1TagResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UntagResourceCommand", ()=>deserializeAws_restJson1UntagResourceCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateGeofenceCollectionCommand", ()=>deserializeAws_restJson1UpdateGeofenceCollectionCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateMapCommand", ()=>deserializeAws_restJson1UpdateMapCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdatePlaceIndexCommand", ()=>deserializeAws_restJson1UpdatePlaceIndexCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateRouteCalculatorCommand", ()=>deserializeAws_restJson1UpdateRouteCalculatorCommand);
parcelHelpers.export(exports, "deserializeAws_restJson1UpdateTrackerCommand", ()=>deserializeAws_restJson1UpdateTrackerCommand);
var _tslib = require("tslib");
var _protocolHttp = require("@aws-sdk/protocol-http");
var _smithyClient = require("@aws-sdk/smithy-client");
var _locationServiceException = require("../models/LocationServiceException");
var _models0 = require("../models/models_0");
var serializeAws_restJson1AssociateTrackerConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.ConsumerArn != null && {
                        ConsumerArn: input.ConsumerArn
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/delete-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1DeviceIdsList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchDeleteGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/delete-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.GeofenceIds != null && {
                        GeofenceIds: serializeAws_restJson1IdList(input.GeofenceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchEvaluateGeofencesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DevicePositionUpdates != null && {
                        DevicePositionUpdates: serializeAws_restJson1DevicePositionUpdateList(input.DevicePositionUpdates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchGetDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/get-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.DeviceIds != null && {
                        DeviceIds: serializeAws_restJson1IdList(input.DeviceIds, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/put-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Entries != null && {
                        Entries: serializeAws_restJson1BatchPutGeofenceRequestEntryList(input.Entries, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1BatchUpdateDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Updates != null && {
                        Updates: serializeAws_restJson1DevicePositionUpdateList(input.Updates, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePosition != null && {
                        DeparturePosition: serializeAws_restJson1Position(input.DeparturePosition, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPosition != null && {
                        DestinationPosition: serializeAws_restJson1Position(input.DestinationPosition, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.IncludeLegGeometry != null && {
                        IncludeLegGeometry: input.IncludeLegGeometry
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }), input.WaypointPositions != null && {
                        WaypointPositions: serializeAws_restJson1WaypointPositionList(input.WaypointPositions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CalculateRouteMatrixCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}/calculate/route-matrix";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CarModeOptions != null && {
                        CarModeOptions: serializeAws_restJson1CalculateRouteCarModeOptions(input.CarModeOptions, context)
                    }), input.DepartNow != null && {
                        DepartNow: input.DepartNow
                    }), input.DeparturePositions != null && {
                        DeparturePositions: serializeAws_restJson1PositionList(input.DeparturePositions, context)
                    }), input.DepartureTime != null && {
                        DepartureTime: input.DepartureTime.toISOString().split(".")[0] + "Z"
                    }), input.DestinationPositions != null && {
                        DestinationPositions: serializeAws_restJson1PositionList(input.DestinationPositions, context)
                    }), input.DistanceUnit != null && {
                        DistanceUnit: input.DistanceUnit
                    }), input.TravelMode != null && {
                        TravelMode: input.TravelMode
                    }), input.TruckModeOptions != null && {
                        TruckModeOptions: serializeAws_restJson1CalculateRouteTruckModeOptions(input.TruckModeOptions, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CollectionName != null && {
                        CollectionName: input.CollectionName
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Configuration != null && {
                        Configuration: serializeAws_restJson1MapConfiguration(input.Configuration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.MapName != null && {
                        MapName: input.MapName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreatePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.IndexName != null && {
                        IndexName: input.IndexName
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.CalculatorName != null && {
                        CalculatorName: input.CalculatorName
                    }), input.DataSource != null && {
                        DataSource: input.DataSource
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1CreateTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.KmsKeyId != null && {
                        KmsKeyId: input.KmsKeyId
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }), input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }), input.TrackerName != null && {
                        TrackerName: input.TrackerName
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeletePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DeleteTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DescribeTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1DisassociateTrackerConsumerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ConsumerArn", function() {
                        return input.ConsumerArn;
                    }, "{ConsumerArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetDevicePositionHistoryCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "DeviceId", function() {
                        return input.DeviceId;
                    }, "{DeviceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.EndTimeExclusive != null && {
                        EndTimeExclusive: input.EndTimeExclusive.toISOString().split(".")[0] + "Z"
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }), input.StartTimeInclusive != null && {
                        StartTimeInclusive: input.StartTimeInclusive.toISOString().split(".")[0] + "Z"
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapGlyphsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontStack", function() {
                        return input.FontStack;
                    }, "{FontStack}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FontUnicodeRange", function() {
                        return input.FontUnicodeRange;
                    }, "{FontUnicodeRange}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapSpritesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/sprites/{FileName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "FileName", function() {
                        return input.FileName;
                    }, "{FileName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapStyleDescriptorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/style-descriptor";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetMapTileCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Z", function() {
                        return input.Z;
                    }, "{Z}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "X", function() {
                        return input.X;
                    }, "{X}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "Y", function() {
                        return input.Y;
                    }, "{Y}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1GetPlaceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/places/{PlaceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "PlaceId", function() {
                        return input.PlaceId;
                    }, "{PlaceId}", false);
                    query = map({
                        language: [
                            ,
                            input.Language
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListDevicePositionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-positions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofenceCollectionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/list-collections";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListGeofencesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/list-geofences";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListMapsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/list-maps";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListPlaceIndexesCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/list-indexes";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListRouteCalculatorsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/list-calculators";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTagsForResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "GET",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackerConsumersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}/list-consumers";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1ListTrackersCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/list-trackers";
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.NextToken != null && {
                        NextToken: input.NextToken
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1PutGeofenceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "GeofenceId", function() {
                        return input.GeofenceId;
                    }, "{GeofenceId}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Geometry != null && {
                        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PUT",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForPositionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/position";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Position != null && {
                        Position: serializeAws_restJson1Position(input.Position, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/suggestions";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1SearchPlaceIndexForTextCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}/search/text";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.BiasPosition != null && {
                        BiasPosition: serializeAws_restJson1Position(input.BiasPosition, context)
                    }), input.FilterBBox != null && {
                        FilterBBox: serializeAws_restJson1BoundingBox(input.FilterBBox, context)
                    }), input.FilterCountries != null && {
                        FilterCountries: serializeAws_restJson1CountryCodeList(input.FilterCountries, context)
                    }), input.Language != null && {
                        Language: input.Language
                    }), input.MaxResults != null && {
                        MaxResults: input.MaxResults
                    }), input.Text != null && {
                        Text: input.Text
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1TagResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    body = JSON.stringify((0, _tslib.__assign)({}, input.Tags != null && {
                        Tags: serializeAws_restJson1TagMap(input.Tags, context)
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "POST",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UntagResourceCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, query, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {};
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tags/{ResourceArn}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "ResourceArn", function() {
                        return input.ResourceArn;
                    }, "{ResourceArn}", false);
                    query = map({
                        tagKeys: [
                            function() {
                                return input.TagKeys !== void 0;
                            },
                            function() {
                                return (input.TagKeys || []).map(function(_entry) {
                                    return _entry;
                                });
                            }
                        ]
                    });
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "metadata." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "DELETE",
                            headers: headers,
                            path: resolvedPath,
                            query: query,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateGeofenceCollectionCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/geofencing/v0/collections/{CollectionName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CollectionName", function() {
                        return input.CollectionName;
                    }, "{CollectionName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "geofencing." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateMapCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/maps/v0/maps/{MapName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "MapName", function() {
                        return input.MapName;
                    }, "{MapName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "maps." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdatePlaceIndexCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/places/v0/indexes/{IndexName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "IndexName", function() {
                        return input.IndexName;
                    }, "{IndexName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.DataSourceConfiguration != null && {
                        DataSourceConfiguration: serializeAws_restJson1DataSourceConfiguration(input.DataSourceConfiguration, context)
                    }), input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "places." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateRouteCalculatorCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/routes/v0/calculators/{CalculatorName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "CalculatorName", function() {
                        return input.CalculatorName;
                    }, "{CalculatorName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "routes." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var serializeAws_restJson1UpdateTrackerCommand = function(input, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a, hostname, _b, protocol, port, basePath, headers, resolvedPath, body, resolvedHostname;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    return [
                        4,
                        context.endpoint()
                    ];
                case 1:
                    _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port, basePath = _a.path;
                    headers = {
                        "content-type": "application/json"
                    };
                    resolvedPath = "".concat((basePath === null || basePath === void 0 ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || "") + "/tracking/v0/trackers/{TrackerName}";
                    resolvedPath = (0, _smithyClient.resolvedPath)(resolvedPath, input, "TrackerName", function() {
                        return input.TrackerName;
                    }, "{TrackerName}", false);
                    body = JSON.stringify((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Description != null && {
                        Description: input.Description
                    }), input.PositionFiltering != null && {
                        PositionFiltering: input.PositionFiltering
                    }), input.PricingPlan != null && {
                        PricingPlan: input.PricingPlan
                    }), input.PricingPlanDataSource != null && {
                        PricingPlanDataSource: input.PricingPlanDataSource
                    }));
                    return [
                        4,
                        context.endpoint()
                    ];
                case 2:
                    resolvedHostname = _c.sent().hostname;
                    if (context.disableHostPrefix !== true) {
                        resolvedHostname = "tracking." + resolvedHostname;
                        if (!(0, _protocolHttp.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
                    }
                    return [
                        2,
                        new (0, _protocolHttp.HttpRequest)({
                            protocol: protocol,
                            hostname: resolvedHostname,
                            port: port,
                            method: "PATCH",
                            headers: headers,
                            path: resolvedPath,
                            body: body
                        })
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1AssociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1AssociateTrackerConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ServiceQuotaExceededException":
                            return [
                                3,
                                10
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                12
                            ];
                        case "ValidationException":
                            return [
                                3,
                                14
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                14
                            ];
                    }
                    return [
                        3,
                        16
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ServiceQuotaExceededExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 15:
                    throw _d.sent();
                case 16:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 17;
                case 17:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchDeleteGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchDeleteGeofenceErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchDeleteGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchEvaluateGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchEvaluateGeofencesErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchEvaluateGeofencesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchGetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchGetDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchGetDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchPutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchPutGeofenceErrorList(data.Errors, context);
                    if (data.Successes != null) contents.Successes = deserializeAws_restJson1BatchPutGeofenceSuccessList(data.Successes, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchPutGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1BatchUpdateDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Errors != null) contents.Errors = deserializeAws_restJson1BatchUpdateDevicePositionErrorList(data.Errors, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1BatchUpdateDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Legs != null) contents.Legs = deserializeAws_restJson1LegList(data.Legs, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CalculateRouteMatrixCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.RouteMatrix != null) contents.RouteMatrix = deserializeAws_restJson1RouteMatrix(data.RouteMatrix, context);
                    if (data.SnappedDeparturePositions != null) contents.SnappedDeparturePositions = deserializeAws_restJson1PositionList(data.SnappedDeparturePositions, context);
                    if (data.SnappedDestinationPositions != null) contents.SnappedDestinationPositions = deserializeAws_restJson1PositionList(data.SnappedDestinationPositions, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1CalculateRouteMatrixSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CalculateRouteMatrixCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreatePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1CreateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1CreateTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeletePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeletePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DeleteTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DeleteTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Configuration != null) contents.Configuration = deserializeAws_restJson1MapConfiguration(data.Configuration, context);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.DataSourceConfiguration != null) contents.DataSourceConfiguration = deserializeAws_restJson1DataSourceConfiguration(data.DataSourceConfiguration, context);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.DataSource != null) contents.DataSource = (0, _smithyClient.expectString)(data.DataSource);
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DescribeTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.Description != null) contents.Description = (0, _smithyClient.expectString)(data.Description);
                    if (data.KmsKeyId != null) contents.KmsKeyId = (0, _smithyClient.expectString)(data.KmsKeyId);
                    if (data.PositionFiltering != null) contents.PositionFiltering = (0, _smithyClient.expectString)(data.PositionFiltering);
                    if (data.PricingPlan != null) contents.PricingPlan = (0, _smithyClient.expectString)(data.PricingPlan);
                    if (data.PricingPlanDataSource != null) contents.PricingPlanDataSource = (0, _smithyClient.expectString)(data.PricingPlanDataSource);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DescribeTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1DisassociateTrackerConsumerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1DisassociateTrackerConsumerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Accuracy != null) contents.Accuracy = deserializeAws_restJson1PositionalAccuracy(data.Accuracy, context);
                    if (data.DeviceId != null) contents.DeviceId = (0, _smithyClient.expectString)(data.DeviceId);
                    if (data.Position != null) contents.Position = deserializeAws_restJson1Position(data.Position, context);
                    if (data.PositionProperties != null) contents.PositionProperties = deserializeAws_restJson1PropertyMap(data.PositionProperties, context);
                    if (data.ReceivedTime != null) contents.ReceivedTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.ReceivedTime));
                    if (data.SampleTime != null) contents.SampleTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.SampleTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetDevicePositionHistoryCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.DevicePositions != null) contents.DevicePositions = deserializeAws_restJson1DevicePositionList(data.DevicePositions, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetDevicePositionHistoryCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.Geometry != null) contents.Geometry = deserializeAws_restJson1GeofenceGeometry(data.Geometry, context);
                    if (data.Status != null) contents.Status = (0, _smithyClient.expectString)(data.Status);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapGlyphsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapGlyphsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapSpritesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapSpritesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapStyleDescriptorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapStyleDescriptorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetMapTileCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output),
                        ContentType: [
                            ,
                            output.headers["content-type"]
                        ]
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    data = _a.sent();
                    contents.Blob = data;
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetMapTileCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1GetPlaceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Place != null) contents.Place = deserializeAws_restJson1Place(data.Place, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1GetPlaceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListDevicePositionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListDevicePositionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListDevicePositionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofenceCollectionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofenceCollectionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListGeofencesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListGeofenceResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListGeofencesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListMapsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListMapsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListMapsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListPlaceIndexesCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListPlaceIndexesResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListPlaceIndexesCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListRouteCalculatorsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListRouteCalculatorsResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListRouteCalculatorsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTagsForResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Tags != null) contents.Tags = deserializeAws_restJson1TagMap(data.Tags, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTagsForResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackerConsumersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.ConsumerArns != null) contents.ConsumerArns = deserializeAws_restJson1ArnList(data.ConsumerArns, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackerConsumersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1ListTrackersCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Entries != null) contents.Entries = deserializeAws_restJson1ListTrackersResponseEntryList(data.Entries, context);
                    if (data.NextToken != null) contents.NextToken = (0, _smithyClient.expectString)(data.NextToken);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1ListTrackersCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                6
                            ];
                        case "ValidationException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 11;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1PutGeofenceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CreateTime != null) contents.CreateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.CreateTime));
                    if (data.GeofenceId != null) contents.GeofenceId = (0, _smithyClient.expectString)(data.GeofenceId);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1PutGeofenceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#ConflictException":
                            return [
                                3,
                                4
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                6
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                8
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                10
                            ];
                        case "ValidationException":
                            return [
                                3,
                                12
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                12
                            ];
                    }
                    return [
                        3,
                        14
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 13:
                    throw _d.sent();
                case 14:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 15;
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForPositionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForPositionResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForPositionSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForPositionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForSuggestionsResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1SearchPlaceIndexForTextCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.Results != null) contents.Results = deserializeAws_restJson1SearchForTextResultList(data.Results, context);
                    if (data.Summary != null) contents.Summary = deserializeAws_restJson1SearchPlaceIndexForTextSummary(data.Summary, context);
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1SearchPlaceIndexForTextCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1TagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1TagResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UntagResourceCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    return [
                        4,
                        collectBody(output.body, context)
                    ];
                case 1:
                    _a.sent();
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UntagResourceCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateGeofenceCollectionCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CollectionArn != null) contents.CollectionArn = (0, _smithyClient.expectString)(data.CollectionArn);
                    if (data.CollectionName != null) contents.CollectionName = (0, _smithyClient.expectString)(data.CollectionName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateGeofenceCollectionCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateMapCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.MapArn != null) contents.MapArn = (0, _smithyClient.expectString)(data.MapArn);
                    if (data.MapName != null) contents.MapName = (0, _smithyClient.expectString)(data.MapName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateMapCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdatePlaceIndexCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.IndexArn != null) contents.IndexArn = (0, _smithyClient.expectString)(data.IndexArn);
                    if (data.IndexName != null) contents.IndexName = (0, _smithyClient.expectString)(data.IndexName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdatePlaceIndexCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateRouteCalculatorCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.CalculatorArn != null) contents.CalculatorArn = (0, _smithyClient.expectString)(data.CalculatorArn);
                    if (data.CalculatorName != null) contents.CalculatorName = (0, _smithyClient.expectString)(data.CalculatorName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateRouteCalculatorCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommand = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, _a, _b;
        return (0, _tslib.__generator)(this, function(_c) {
            switch(_c.label){
                case 0:
                    if (output.statusCode !== 200 && output.statusCode >= 300) return [
                        2,
                        deserializeAws_restJson1UpdateTrackerCommandError(output, context)
                    ];
                    contents = map({
                        $metadata: deserializeMetadata(output)
                    });
                    _a = (0, _smithyClient.expectNonNull);
                    _b = (0, _smithyClient.expectObject);
                    return [
                        4,
                        parseBody(output.body, context)
                    ];
                case 1:
                    data = _a.apply(void 0, [
                        _b.apply(void 0, [
                            _c.sent()
                        ]),
                        "body"
                    ]);
                    if (data.TrackerArn != null) contents.TrackerArn = (0, _smithyClient.expectString)(data.TrackerArn);
                    if (data.TrackerName != null) contents.TrackerName = (0, _smithyClient.expectString)(data.TrackerName);
                    if (data.UpdateTime != null) contents.UpdateTime = (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(data.UpdateTime));
                    return [
                        2,
                        contents
                    ];
            }
        });
    });
};
var deserializeAws_restJson1UpdateTrackerCommandError = function(output, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var parsedOutput, _a, errorCode, _b, parsedBody;
        var _c;
        return (0, _tslib.__generator)(this, function(_d) {
            switch(_d.label){
                case 0:
                    _a = [
                        (0, _tslib.__assign)({}, output)
                    ];
                    _c = {};
                    return [
                        4,
                        parseErrorBody(output.body, context)
                    ];
                case 1:
                    parsedOutput = (0, _tslib.__assign).apply(void 0, _a.concat([
                        (_c.body = _d.sent(), _c)
                    ]));
                    errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                    _b = errorCode;
                    switch(_b){
                        case "AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "com.amazonaws.location#AccessDeniedException":
                            return [
                                3,
                                2
                            ];
                        case "InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "com.amazonaws.location#InternalServerException":
                            return [
                                3,
                                4
                            ];
                        case "ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "com.amazonaws.location#ResourceNotFoundException":
                            return [
                                3,
                                6
                            ];
                        case "ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "com.amazonaws.location#ThrottlingException":
                            return [
                                3,
                                8
                            ];
                        case "ValidationException":
                            return [
                                3,
                                10
                            ];
                        case "com.amazonaws.location#ValidationException":
                            return [
                                3,
                                10
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context)
                    ];
                case 3:
                    throw _d.sent();
                case 4:
                    return [
                        4,
                        deserializeAws_restJson1InternalServerExceptionResponse(parsedOutput, context)
                    ];
                case 5:
                    throw _d.sent();
                case 6:
                    return [
                        4,
                        deserializeAws_restJson1ResourceNotFoundExceptionResponse(parsedOutput, context)
                    ];
                case 7:
                    throw _d.sent();
                case 8:
                    return [
                        4,
                        deserializeAws_restJson1ThrottlingExceptionResponse(parsedOutput, context)
                    ];
                case 9:
                    throw _d.sent();
                case 10:
                    return [
                        4,
                        deserializeAws_restJson1ValidationExceptionResponse(parsedOutput, context)
                    ];
                case 11:
                    throw _d.sent();
                case 12:
                    parsedBody = parsedOutput.body;
                    (0, _smithyClient.throwDefaultError)({
                        output: output,
                        parsedBody: parsedBody,
                        exceptionCtor: (0, _locationServiceException.LocationServiceException),
                        errorCode: errorCode
                    });
                    _d.label = 13;
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
};
var map = (0, _smithyClient.map);
var deserializeAws_restJson1AccessDeniedExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.AccessDeniedException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ConflictExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ConflictException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1InternalServerExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.InternalServerException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ResourceNotFoundExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ResourceNotFoundException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ServiceQuotaExceededExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ServiceQuotaExceededException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ThrottlingExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            exception = new (0, _models0.ThrottlingException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var deserializeAws_restJson1ValidationExceptionResponse = function(parsedOutput, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var contents, data, exception;
        return (0, _tslib.__generator)(this, function(_a) {
            contents = map({});
            data = parsedOutput.body;
            if (data.fieldList != null) contents.FieldList = deserializeAws_restJson1ValidationExceptionFieldList(data.fieldList, context);
            if (data.message != null) contents.Message = (0, _smithyClient.expectString)(data.message);
            if (data.reason != null) contents.Reason = (0, _smithyClient.expectString)(data.reason);
            exception = new (0, _models0.ValidationException)((0, _tslib.__assign)({
                $metadata: deserializeMetadata(parsedOutput)
            }, contents));
            return [
                2,
                (0, _smithyClient.decorateServiceException)(exception, parsedOutput.body)
            ];
        });
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.GeofenceId != null && {
        GeofenceId: input.GeofenceId
    }), input.Geometry != null && {
        Geometry: serializeAws_restJson1GeofenceGeometry(input.Geometry, context)
    });
};
var serializeAws_restJson1BatchPutGeofenceRequestEntryList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1BatchPutGeofenceRequestEntry(entry, context);
    });
};
var serializeAws_restJson1BoundingBox = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1CalculateRouteCarModeOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    });
};
var serializeAws_restJson1CalculateRouteTruckModeOptions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.AvoidFerries != null && {
        AvoidFerries: input.AvoidFerries
    }), input.AvoidTolls != null && {
        AvoidTolls: input.AvoidTolls
    }), input.Dimensions != null && {
        Dimensions: serializeAws_restJson1TruckDimensions(input.Dimensions, context)
    }), input.Weight != null && {
        Weight: serializeAws_restJson1TruckWeight(input.Weight, context)
    });
};
var serializeAws_restJson1Circle = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Center != null && {
        Center: serializeAws_restJson1Position(input.Center, context)
    }), input.Radius != null && {
        Radius: (0, _smithyClient.serializeFloat)(input.Radius)
    });
};
var serializeAws_restJson1CountryCodeList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DataSourceConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.IntendedUse != null && {
        IntendedUse: input.IntendedUse
    });
};
var serializeAws_restJson1DeviceIdsList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1DevicePositionUpdate = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Accuracy != null && {
        Accuracy: serializeAws_restJson1PositionalAccuracy(input.Accuracy, context)
    }), input.DeviceId != null && {
        DeviceId: input.DeviceId
    }), input.Position != null && {
        Position: serializeAws_restJson1Position(input.Position, context)
    }), input.PositionProperties != null && {
        PositionProperties: serializeAws_restJson1PropertyMap(input.PositionProperties, context)
    }), input.SampleTime != null && {
        SampleTime: input.SampleTime.toISOString().split(".")[0] + "Z"
    });
};
var serializeAws_restJson1DevicePositionUpdateList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1DevicePositionUpdate(entry, context);
    });
};
var serializeAws_restJson1GeofenceGeometry = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Circle != null && {
        Circle: serializeAws_restJson1Circle(input.Circle, context)
    }), input.Polygon != null && {
        Polygon: serializeAws_restJson1LinearRings(input.Polygon, context)
    });
};
var serializeAws_restJson1IdList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return entry;
    });
};
var serializeAws_restJson1LinearRing = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1LinearRings = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1LinearRing(entry, context);
    });
};
var serializeAws_restJson1MapConfiguration = function(input, context) {
    return (0, _tslib.__assign)({}, input.Style != null && {
        Style: input.Style
    });
};
var serializeAws_restJson1Position = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return (0, _smithyClient.serializeFloat)(entry);
    });
};
var serializeAws_restJson1PositionalAccuracy = function(input, context) {
    return (0, _tslib.__assign)({}, input.Horizontal != null && {
        Horizontal: (0, _smithyClient.serializeFloat)(input.Horizontal)
    });
};
var serializeAws_restJson1PositionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var serializeAws_restJson1PropertyMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TagMap = function(input, context) {
    return Object.entries(input).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_restJson1TruckDimensions = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, input.Height != null && {
        Height: (0, _smithyClient.serializeFloat)(input.Height)
    }), input.Length != null && {
        Length: (0, _smithyClient.serializeFloat)(input.Length)
    }), input.Unit != null && {
        Unit: input.Unit
    }), input.Width != null && {
        Width: (0, _smithyClient.serializeFloat)(input.Width)
    });
};
var serializeAws_restJson1TruckWeight = function(input, context) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, input.Total != null && {
        Total: (0, _smithyClient.serializeFloat)(input.Total)
    }), input.Unit != null && {
        Unit: input.Unit
    });
};
var serializeAws_restJson1WaypointPositionList = function(input, context) {
    return input.filter(function(e) {
        return e != null;
    }).map(function(entry) {
        return serializeAws_restJson1Position(entry, context);
    });
};
var deserializeAws_restJson1ArnList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchDeleteDevicePositionHistoryErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteDevicePositionHistoryError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchDeleteGeofenceError = function(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchDeleteGeofenceErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchDeleteGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchEvaluateGeofencesError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchEvaluateGeofencesErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchEvaluateGeofencesError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchGetDevicePositionError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1BatchGetDevicePositionErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchGetDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchItemError = function(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1BatchPutGeofenceError = function(output, context) {
    return {
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId)
    };
};
var deserializeAws_restJson1BatchPutGeofenceErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchPutGeofenceSuccess = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1BatchPutGeofenceSuccessList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchPutGeofenceSuccess(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BatchUpdateDevicePositionError = function(output, context) {
    return {
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Error: output.Error != null ? deserializeAws_restJson1BatchItemError(output.Error, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1BatchUpdateDevicePositionErrorList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1BatchUpdateDevicePositionError(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1BoundingBox = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1CalculateRouteMatrixSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        ErrorCount: (0, _smithyClient.expectInt32)(output.ErrorCount),
        RouteCount: (0, _smithyClient.expectInt32)(output.RouteCount)
    };
};
var deserializeAws_restJson1CalculateRouteSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DistanceUnit: (0, _smithyClient.expectString)(output.DistanceUnit),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        RouteBBox: output.RouteBBox != null ? deserializeAws_restJson1BoundingBox(output.RouteBBox, context) : undefined
    };
};
var deserializeAws_restJson1Circle = function(output, context) {
    return {
        Center: output.Center != null ? deserializeAws_restJson1Position(output.Center, context) : undefined,
        Radius: (0, _smithyClient.limitedParseDouble)(output.Radius)
    };
};
var deserializeAws_restJson1CountryCodeList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.expectString)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1DataSourceConfiguration = function(output, context) {
    return {
        IntendedUse: (0, _smithyClient.expectString)(output.IntendedUse)
    };
};
var deserializeAws_restJson1DevicePosition = function(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        ReceivedTime: output.ReceivedTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.ReceivedTime)) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1DevicePositionList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1DevicePosition(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1GeofenceGeometry = function(output, context) {
    return {
        Circle: output.Circle != null ? deserializeAws_restJson1Circle(output.Circle, context) : undefined,
        Polygon: output.Polygon != null ? deserializeAws_restJson1LinearRings(output.Polygon, context) : undefined
    };
};
var deserializeAws_restJson1Leg = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        Geometry: output.Geometry != null ? deserializeAws_restJson1LegGeometry(output.Geometry, context) : undefined,
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined,
        Steps: output.Steps != null ? deserializeAws_restJson1StepList(output.Steps, context) : undefined
    };
};
var deserializeAws_restJson1LegGeometry = function(output, context) {
    return {
        LineString: output.LineString != null ? deserializeAws_restJson1LineString(output.LineString, context) : undefined
    };
};
var deserializeAws_restJson1LegList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Leg(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRing = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LinearRings = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1LinearRing(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1LineString = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListDevicePositionsResponseEntry = function(output, context) {
    return {
        Accuracy: output.Accuracy != null ? deserializeAws_restJson1PositionalAccuracy(output.Accuracy, context) : undefined,
        DeviceId: (0, _smithyClient.expectString)(output.DeviceId),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined,
        PositionProperties: output.PositionProperties != null ? deserializeAws_restJson1PropertyMap(output.PositionProperties, context) : undefined,
        SampleTime: output.SampleTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.SampleTime)) : undefined
    };
};
var deserializeAws_restJson1ListDevicePositionsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListDevicePositionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntry = function(output, context) {
    return {
        CollectionName: (0, _smithyClient.expectString)(output.CollectionName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceCollectionsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceCollectionsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListGeofenceResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        GeofenceId: (0, _smithyClient.expectString)(output.GeofenceId),
        Geometry: output.Geometry != null ? deserializeAws_restJson1GeofenceGeometry(output.Geometry, context) : undefined,
        Status: (0, _smithyClient.expectString)(output.Status),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListGeofenceResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListGeofenceResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListMapsResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        MapName: (0, _smithyClient.expectString)(output.MapName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListMapsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListMapsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        IndexName: (0, _smithyClient.expectString)(output.IndexName),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListPlaceIndexesResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListPlaceIndexesResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntry = function(output, context) {
    return {
        CalculatorName: (0, _smithyClient.expectString)(output.CalculatorName),
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListRouteCalculatorsResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListRouteCalculatorsResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1ListTrackersResponseEntry = function(output, context) {
    return {
        CreateTime: output.CreateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.CreateTime)) : undefined,
        Description: (0, _smithyClient.expectString)(output.Description),
        PricingPlan: (0, _smithyClient.expectString)(output.PricingPlan),
        PricingPlanDataSource: (0, _smithyClient.expectString)(output.PricingPlanDataSource),
        TrackerName: (0, _smithyClient.expectString)(output.TrackerName),
        UpdateTime: output.UpdateTime != null ? (0, _smithyClient.expectNonNull)((0, _smithyClient.parseRfc3339DateTime)(output.UpdateTime)) : undefined
    };
};
var deserializeAws_restJson1ListTrackersResponseEntryList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ListTrackersResponseEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1MapConfiguration = function(output, context) {
    return {
        Style: (0, _smithyClient.expectString)(output.Style)
    };
};
var deserializeAws_restJson1Place = function(output, context) {
    return {
        AddressNumber: (0, _smithyClient.expectString)(output.AddressNumber),
        Country: (0, _smithyClient.expectString)(output.Country),
        Geometry: output.Geometry != null ? deserializeAws_restJson1PlaceGeometry(output.Geometry, context) : undefined,
        Interpolated: (0, _smithyClient.expectBoolean)(output.Interpolated),
        Label: (0, _smithyClient.expectString)(output.Label),
        Municipality: (0, _smithyClient.expectString)(output.Municipality),
        Neighborhood: (0, _smithyClient.expectString)(output.Neighborhood),
        PostalCode: (0, _smithyClient.expectString)(output.PostalCode),
        Region: (0, _smithyClient.expectString)(output.Region),
        Street: (0, _smithyClient.expectString)(output.Street),
        SubRegion: (0, _smithyClient.expectString)(output.SubRegion),
        TimeZone: output.TimeZone != null ? deserializeAws_restJson1TimeZone(output.TimeZone, context) : undefined,
        UnitNumber: (0, _smithyClient.expectString)(output.UnitNumber),
        UnitType: (0, _smithyClient.expectString)(output.UnitType)
    };
};
var deserializeAws_restJson1PlaceGeometry = function(output, context) {
    return {
        Point: output.Point != null ? deserializeAws_restJson1Position(output.Point, context) : undefined
    };
};
var deserializeAws_restJson1Position = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return (0, _smithyClient.limitedParseDouble)(entry);
    });
    return retVal;
};
var deserializeAws_restJson1PositionalAccuracy = function(output, context) {
    return {
        Horizontal: (0, _smithyClient.limitedParseDouble)(output.Horizontal)
    };
};
var deserializeAws_restJson1PositionList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Position(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1PropertyMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1RouteMatrix = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixRow(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1RouteMatrixEntry = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        Error: output.Error != null ? deserializeAws_restJson1RouteMatrixEntryError(output.Error, context) : undefined
    };
};
var deserializeAws_restJson1RouteMatrixEntryError = function(output, context) {
    return {
        Code: (0, _smithyClient.expectString)(output.Code),
        Message: (0, _smithyClient.expectString)(output.Message)
    };
};
var deserializeAws_restJson1RouteMatrixRow = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1RouteMatrixEntry(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForPositionResult = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId)
    };
};
var deserializeAws_restJson1SearchForPositionResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForPositionResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForSuggestionsResult = function(output, context) {
    return {
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchForSuggestionsResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForSuggestionsResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchForTextResult = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        Place: output.Place != null ? deserializeAws_restJson1Place(output.Place, context) : undefined,
        PlaceId: (0, _smithyClient.expectString)(output.PlaceId),
        Relevance: (0, _smithyClient.limitedParseDouble)(output.Relevance)
    };
};
var deserializeAws_restJson1SearchForTextResultList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1SearchForTextResult(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1SearchPlaceIndexForPositionSummary = function(output, context) {
    return {
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Position: output.Position != null ? deserializeAws_restJson1Position(output.Position, context) : undefined
    };
};
var deserializeAws_restJson1SearchPlaceIndexForSuggestionsSummary = function(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1SearchPlaceIndexForTextSummary = function(output, context) {
    return {
        BiasPosition: output.BiasPosition != null ? deserializeAws_restJson1Position(output.BiasPosition, context) : undefined,
        DataSource: (0, _smithyClient.expectString)(output.DataSource),
        FilterBBox: output.FilterBBox != null ? deserializeAws_restJson1BoundingBox(output.FilterBBox, context) : undefined,
        FilterCountries: output.FilterCountries != null ? deserializeAws_restJson1CountryCodeList(output.FilterCountries, context) : undefined,
        Language: (0, _smithyClient.expectString)(output.Language),
        MaxResults: (0, _smithyClient.expectInt32)(output.MaxResults),
        ResultBBox: output.ResultBBox != null ? deserializeAws_restJson1BoundingBox(output.ResultBBox, context) : undefined,
        Text: (0, _smithyClient.expectString)(output.Text)
    };
};
var deserializeAws_restJson1Step = function(output, context) {
    return {
        Distance: (0, _smithyClient.limitedParseDouble)(output.Distance),
        DurationSeconds: (0, _smithyClient.limitedParseDouble)(output.DurationSeconds),
        EndPosition: output.EndPosition != null ? deserializeAws_restJson1Position(output.EndPosition, context) : undefined,
        GeometryOffset: (0, _smithyClient.expectInt32)(output.GeometryOffset),
        StartPosition: output.StartPosition != null ? deserializeAws_restJson1Position(output.StartPosition, context) : undefined
    };
};
var deserializeAws_restJson1StepList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1Step(entry, context);
    });
    return retVal;
};
var deserializeAws_restJson1TagMap = function(output, context) {
    return Object.entries(output).reduce(function(acc, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        if (value === null) return acc;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_b = {}, _b[key] = (0, _smithyClient.expectString)(value), _b));
    }, {});
};
var deserializeAws_restJson1TimeZone = function(output, context) {
    return {
        Name: (0, _smithyClient.expectString)(output.Name),
        Offset: (0, _smithyClient.expectInt32)(output.Offset)
    };
};
var deserializeAws_restJson1ValidationExceptionField = function(output, context) {
    return {
        Message: (0, _smithyClient.expectString)(output.message),
        Name: (0, _smithyClient.expectString)(output.name)
    };
};
var deserializeAws_restJson1ValidationExceptionFieldList = function(output, context) {
    var retVal = (output || []).filter(function(e) {
        return e != null;
    }).map(function(entry) {
        if (entry === null) return null;
        return deserializeAws_restJson1ValidationExceptionField(entry, context);
    });
    return retVal;
};
var deserializeMetadata = function(output) {
    var _a, _b;
    return {
        httpStatusCode: output.statusCode,
        requestId: (_b = (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"]) !== null && _b !== void 0 ? _b : output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    };
};
var collectBody = function(streamBody, context) {
    if (streamBody === void 0) streamBody = new Uint8Array();
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
var collectBodyString = function(streamBody, context) {
    return collectBody(streamBody, context).then(function(body) {
        return context.utf8Encoder(body);
    });
};
var isSerializableHeaderValue = function(value) {
    return value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};
var parseBody = function(streamBody, context) {
    return collectBodyString(streamBody, context).then(function(encoded) {
        if (encoded.length) return JSON.parse(encoded);
        return {};
    });
};
var parseErrorBody = function(errorBody, context) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var value;
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4,
                        parseBody(errorBody, context)
                    ];
                case 1:
                    value = _b.sent();
                    value.message = (_a = value.message) !== null && _a !== void 0 ? _a : value.Message;
                    return [
                        2,
                        value
                    ];
            }
        });
    });
};
var loadRestJsonErrorCode = function(output, data) {
    var findKey = function(object, key) {
        return Object.keys(object).find(function(k) {
            return k.toLowerCase() === key.toLowerCase();
        });
    };
    var sanitizeErrorCode = function(rawValue) {
        var cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

},{"tslib":"86BcK","@aws-sdk/protocol-http":"k6jTb","@aws-sdk/smithy-client":"6yS5y","../models/LocationServiceException":"g5vja","../models/models_0":"b7IJ4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6G5dO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchPutGeofenceCommand", ()=>BatchPutGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var BatchPutGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(BatchPutGeofenceCommand, _super);
    function BatchPutGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    BatchPutGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "BatchPutGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.BatchPutGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.BatchPutGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    BatchPutGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1BatchPutGeofenceCommand)(input, context);
    };
    BatchPutGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1BatchPutGeofenceCommand)(output, context);
    };
    return BatchPutGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Sb9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetGeofenceCommand", ()=>GetGeofenceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetGeofenceCommand = function(_super) {
    (0, _tslib.__extends)(GetGeofenceCommand, _super);
    function GetGeofenceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetGeofenceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetGeofenceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetGeofenceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetGeofenceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetGeofenceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetGeofenceCommand)(input, context);
    };
    GetGeofenceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetGeofenceCommand)(output, context);
    };
    return GetGeofenceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aCfAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetPlaceCommand", ()=>GetPlaceCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var GetPlaceCommand = function(_super) {
    (0, _tslib.__extends)(GetPlaceCommand, _super);
    function GetPlaceCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    GetPlaceCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "GetPlaceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.GetPlaceRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.GetPlaceResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetPlaceCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1GetPlaceCommand)(input, context);
    };
    GetPlaceCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1GetPlaceCommand)(output, context);
    };
    return GetPlaceCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c6YDt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListGeofencesCommand", ()=>ListGeofencesCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var ListGeofencesCommand = function(_super) {
    (0, _tslib.__extends)(ListGeofencesCommand, _super);
    function ListGeofencesCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    ListGeofencesCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "ListGeofencesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.ListGeofencesRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.ListGeofencesResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListGeofencesCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1ListGeofencesCommand)(input, context);
    };
    ListGeofencesCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1ListGeofencesCommand)(output, context);
    };
    return ListGeofencesCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8uRyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForPositionCommand", ()=>SearchPlaceIndexForPositionCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForPositionCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForPositionCommand, _super);
    function SearchPlaceIndexForPositionCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForPositionCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForPositionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForPositionResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForPositionCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForPositionCommand)(input, context);
    };
    SearchPlaceIndexForPositionCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForPositionCommand)(output, context);
    };
    return SearchPlaceIndexForPositionCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gEjA4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForSuggestionsCommand", ()=>SearchPlaceIndexForSuggestionsCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForSuggestionsCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForSuggestionsCommand, _super);
    function SearchPlaceIndexForSuggestionsCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForSuggestionsCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForSuggestionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(input, context);
    };
    SearchPlaceIndexForSuggestionsCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForSuggestionsCommand)(output, context);
    };
    return SearchPlaceIndexForSuggestionsCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aO5IJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchPlaceIndexForTextCommand", ()=>SearchPlaceIndexForTextCommand);
var _tslib = require("tslib");
var _middlewareSerde = require("@aws-sdk/middleware-serde");
var _smithyClient = require("@aws-sdk/smithy-client");
var _models0 = require("../models/models_0");
var _awsRestJson1 = require("../protocols/Aws_restJson1");
var SearchPlaceIndexForTextCommand = function(_super) {
    (0, _tslib.__extends)(SearchPlaceIndexForTextCommand, _super);
    function SearchPlaceIndexForTextCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    SearchPlaceIndexForTextCommand.prototype.resolveMiddleware = function(clientStack, configuration, options) {
        this.middlewareStack.use((0, _middlewareSerde.getSerdePlugin)(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "LocationClient";
        var commandName = "SearchPlaceIndexForTextCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextRequestFilterSensitiveLog),
            outputFilterSensitiveLog: (0, _models0.SearchPlaceIndexForTextResponseFilterSensitiveLog)
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function(request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SearchPlaceIndexForTextCommand.prototype.serialize = function(input, context) {
        return (0, _awsRestJson1.serializeAws_restJson1SearchPlaceIndexForTextCommand)(input, context);
    };
    SearchPlaceIndexForTextCommand.prototype.deserialize = function(output, context) {
        return (0, _awsRestJson1.deserializeAws_restJson1SearchPlaceIndexForTextCommand)(output, context);
    };
    return SearchPlaceIndexForTextCommand;
}((0, _smithyClient.Command));

},{"tslib":"86BcK","@aws-sdk/middleware-serde":"el26T","@aws-sdk/smithy-client":"6yS5y","../models/models_0":"b7IJ4","../protocols/Aws_restJson1":"76VEP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9llQK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateCoordinates", ()=>validateCoordinates);
parcelHelpers.export(exports, "validateGeofenceId", ()=>validateGeofenceId);
parcelHelpers.export(exports, "validateLinearRing", ()=>validateLinearRing);
parcelHelpers.export(exports, "validatePolygon", ()=>validatePolygon);
parcelHelpers.export(exports, "validateGeofencesInput", ()=>validateGeofencesInput);
parcelHelpers.export(exports, "mapSearchOptions", ()=>mapSearchOptions);
var _tslib = require("tslib");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _booleanClockwise = require("@turf/boolean-clockwise");
var _booleanClockwiseDefault = parcelHelpers.interopDefault(_booleanClockwise);
function validateCoordinates(lng, lat) {
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) throw new Error("Invalid coordinates: [" + lng + "," + lat + "]");
    if (lat < -90 || 90 < lat) throw new Error("Latitude must be between -90 and 90 degrees inclusive.");
    else if (lng < -180 || 180 < lng) throw new Error("Longitude must be between -180 and 180 degrees inclusive.");
}
function validateGeofenceId(geofenceId) {
    var geofenceIdRegex = /^[-._\p{L}\p{N}]+$/iu;
    // Check if geofenceId is valid
    if (!geofenceIdRegex.test(geofenceId)) throw new Error("Invalid geofenceId: '" + geofenceId + "' - IDs can only contain alphanumeric characters, hyphens, underscores and periods.");
}
function validateLinearRing(linearRing, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : "";
    // Validate LinearRing size, must be at least 4 points
    if (linearRing.length < 4) throw new Error(errorPrefix + "LinearRing must contain 4 or more coordinates.");
    // Validate all coordinates are valid, error with which ones are bad
    var badCoordinates = [];
    linearRing.forEach(function(coordinates) {
        try {
            validateCoordinates(coordinates[0], coordinates[1]);
        } catch (error) {
            badCoordinates.push({
                coordinates: coordinates,
                error: error.message
            });
        }
    });
    if (badCoordinates.length > 0) throw new Error(errorPrefix + "One or more of the coordinates in the Polygon LinearRing are not valid: " + JSON.stringify(badCoordinates));
    // Validate first and last coordinates are the same
    var _a = (0, _tslib.__read)(linearRing[0], 2), lngA = _a[0], latA = _a[1];
    var _b = (0, _tslib.__read)(linearRing[linearRing.length - 1], 2), lngB = _b[0], latB = _b[1];
    if (lngA !== lngB || latA !== latB) throw new Error(errorPrefix + "LinearRing's first and last coordinates are not the same");
    if ((0, _booleanClockwiseDefault.default)(linearRing)) throw new Error(errorPrefix + "LinearRing coordinates must be wound counterclockwise");
}
function validatePolygon(polygon, geofenceId) {
    var errorPrefix = geofenceId ? geofenceId + ": " : "";
    if (!Array.isArray(polygon)) throw new Error(errorPrefix + "Polygon is of incorrect structure. It should be an array of LinearRings");
    if (polygon.length < 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array.");
    if (polygon.length > 1) throw new Error(errorPrefix + "Polygon must have a single LinearRing array. Note: We do not currently support polygons with holes, multipolygons, polygons that are wound clockwise, or that cross the antimeridian.");
    var verticesCount = polygon.reduce(function(prev, linearRing) {
        return prev + linearRing.length;
    }, 0);
    if (verticesCount > 1000) throw new Error(errorPrefix + "Polygon has more than the maximum 1000 vertices.");
    polygon.forEach(function(linearRing) {
        validateLinearRing(linearRing, geofenceId);
    });
}
function validateGeofencesInput(geofences) {
    var geofenceIds = {};
    geofences.forEach(function(geofence) {
        // verify all required properties are present
        // Validate geofenceId exists
        if (!geofence.geofenceId) throw new Error("Geofence '" + geofence + "' is missing geofenceId");
        var geofenceId = geofence.geofenceId;
        validateGeofenceId(geofenceId);
        // Validate geofenceId is unique
        if (geofenceIds[geofenceId]) throw new Error("Duplicate geofenceId: " + geofenceId);
        else geofenceIds[geofenceId] = true;
        // Validate geometry exists
        if (!geofence.geometry) throw new Error("Geofence '" + geofenceId + "' is missing geometry");
        var geometry = geofence.geometry;
        // Validate polygon exists
        if (!geometry.polygon) throw new Error("Geofence '" + geofenceId + "' is missing geometry.polygon");
        var polygon = geometry.polygon;
        // Validate polygon length and structure
        try {
            validatePolygon(polygon, geofenceId);
        } catch (error) {
            if (error.message.includes("Polygon has more than the maximum 1000 vertices.")) throw new Error("Geofence '" + geofenceId + "' has more than the maximum of 1000 vertices");
        }
        // Validate LinearRing length, structure, and coordinates
        var _a = (0, _tslib.__read)(polygon, 1), linearRing = _a[0];
        validateLinearRing(linearRing, geofenceId);
    });
}
function mapSearchOptions(options, locationServiceInput) {
    var locationServiceModifiedInput = (0, _tslib.__assign)({}, locationServiceInput);
    locationServiceModifiedInput.FilterCountries = options.countries;
    locationServiceModifiedInput.MaxResults = options.maxResults;
    if (options.searchIndexName) locationServiceModifiedInput.IndexName = options.searchIndexName;
    if (options["biasPosition"] && options["searchAreaConstraints"]) throw new Error("BiasPosition and SearchAreaConstraints are mutually exclusive, please remove one or the other from the options object");
    if (options["biasPosition"]) locationServiceModifiedInput.BiasPosition = options["biasPosition"];
    if (options["searchAreaConstraints"]) locationServiceModifiedInput.FilterBBox = options["searchAreaConstraints"];
    return locationServiceModifiedInput;
}

},{"tslib":"6BFzs","@turf/boolean-clockwise":"gmdhE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gmdhE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>booleanClockwise);
var _invariant = require("@turf/invariant");
function booleanClockwise(line) {
    var ring = (0, _invariant.getCoords)(line);
    var sum = 0;
    var i = 1;
    var prev;
    var cur;
    while(i < ring.length){
        prev = cur || ring[0];
        cur = ring[i];
        sum += (cur[0] - prev[0]) * (cur[1] + prev[1]);
        i++;
    }
    return sum > 0;
}

},{"@turf/invariant":"r7ipG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"r7ipG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Unwrap a coordinate from a Point Feature, Geometry or a single coordinate.
 *
 * @name getCoord
 * @param {Array<number>|Geometry<Point>|Feature<Point>} coord GeoJSON Point or an Array of numbers
 * @returns {Array<number>} coordinates
 * @example
 * var pt = turf.point([10, 10]);
 *
 * var coord = turf.getCoord(pt);
 * //= [10, 10]
 */ parcelHelpers.export(exports, "getCoord", ()=>getCoord);
/**
 * Unwrap coordinates from a Feature, Geometry Object or an Array
 *
 * @name getCoords
 * @param {Array<any>|Geometry|Feature} coords Feature, Geometry Object or an Array
 * @returns {Array<any>} coordinates
 * @example
 * var poly = turf.polygon([[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]);
 *
 * var coords = turf.getCoords(poly);
 * //= [[[119.32, -8.7], [119.55, -8.69], [119.51, -8.54], [119.32, -8.7]]]
 */ parcelHelpers.export(exports, "getCoords", ()=>getCoords);
/**
 * Checks if coordinates contains a number
 *
 * @name containsNumber
 * @param {Array<any>} coordinates GeoJSON Coordinates
 * @returns {boolean} true if Array contains a number
 */ parcelHelpers.export(exports, "containsNumber", ()=>containsNumber);
/**
 * Enforce expectations about types of GeoJSON objects for Turf.
 *
 * @name geojsonType
 * @param {GeoJSON} value any GeoJSON object
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "geojsonType", ()=>geojsonType);
/**
 * Enforce expectations about types of {@link Feature} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name featureOf
 * @param {Feature} feature a feature with an expected geometry type
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} error if value is not the expected type.
 */ parcelHelpers.export(exports, "featureOf", ()=>featureOf);
/**
 * Enforce expectations about types of {@link FeatureCollection} inputs for Turf.
 * Internally this uses {@link geojsonType} to judge geometry types.
 *
 * @name collectionOf
 * @param {FeatureCollection} featureCollection a FeatureCollection for which features will be judged
 * @param {string} type expected GeoJSON type
 * @param {string} name name of calling function
 * @throws {Error} if value is not the expected type.
 */ parcelHelpers.export(exports, "collectionOf", ()=>collectionOf);
/**
 * Get Geometry from Feature or Geometry Object
 *
 * @param {Feature|Geometry} geojson GeoJSON Feature or Geometry Object
 * @returns {Geometry|null} GeoJSON Geometry Object
 * @throws {Error} if geojson is not a Feature or Geometry Object
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getGeom(point)
 * //={"type": "Point", "coordinates": [110, 40]}
 */ parcelHelpers.export(exports, "getGeom", ()=>getGeom);
/**
 * Get GeoJSON object's type, Geometry type is prioritize.
 *
 * @param {GeoJSON} geojson GeoJSON object
 * @param {string} [name="geojson"] name of the variable to display in error message (unused)
 * @returns {string} GeoJSON type
 * @example
 * var point = {
 *   "type": "Feature",
 *   "properties": {},
 *   "geometry": {
 *     "type": "Point",
 *     "coordinates": [110, 40]
 *   }
 * }
 * var geom = turf.getType(point)
 * //="Point"
 */ parcelHelpers.export(exports, "getType", ()=>getType);
var _helpers = require("@turf/helpers");
function getCoord(coord) {
    if (!coord) throw new Error("coord is required");
    if (!Array.isArray(coord)) {
        if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") return coord.geometry.coordinates;
        if (coord.type === "Point") return coord.coordinates;
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) return coord;
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
    if (Array.isArray(coords)) return coords;
    // Feature
    if (coords.type === "Feature") {
        if (coords.geometry !== null) return coords.geometry.coordinates;
    } else {
        // Geometry
        if (coords.coordinates) return coords.coordinates;
    }
    throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber(coordinates) {
    if (coordinates.length > 1 && (0, _helpers.isNumber)(coordinates[0]) && (0, _helpers.isNumber)(coordinates[1])) return true;
    if (Array.isArray(coordinates[0]) && coordinates[0].length) return containsNumber(coordinates[0]);
    throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name) {
    if (!type || !name) throw new Error("type and name required");
    if (!value || value.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + value.type);
}
function featureOf(feature, type, name) {
    if (!feature) throw new Error("No feature passed");
    if (!name) throw new Error(".featureOf() requires a name");
    if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
    if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
}
function collectionOf(featureCollection, type, name) {
    if (!featureCollection) throw new Error("No featureCollection passed");
    if (!name) throw new Error(".collectionOf() requires a name");
    if (!featureCollection || featureCollection.type !== "FeatureCollection") throw new Error("Invalid input to " + name + ", FeatureCollection required");
    for(var _i = 0, _a = featureCollection.features; _i < _a.length; _i++){
        var feature = _a[_i];
        if (!feature || feature.type !== "Feature" || !feature.geometry) throw new Error("Invalid input to " + name + ", Feature with geometry required");
        if (!feature.geometry || feature.geometry.type !== type) throw new Error("Invalid input to " + name + ": must be a " + type + ", given " + feature.geometry.type);
    }
}
function getGeom(geojson) {
    if (geojson.type === "Feature") return geojson.geometry;
    return geojson;
}
function getType(geojson, _name) {
    if (geojson.type === "FeatureCollection") return "FeatureCollection";
    if (geojson.type === "GeometryCollection") return "GeometryCollection";
    if (geojson.type === "Feature" && geojson.geometry !== null) return geojson.geometry.type;
    return geojson.type;
}

},{"@turf/helpers":"8U0ZF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8U0ZF":[function(require,module,exports) {
/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "earthRadius", ()=>earthRadius);
parcelHelpers.export(exports, "factors", ()=>factors);
parcelHelpers.export(exports, "unitsFactors", ()=>unitsFactors);
parcelHelpers.export(exports, "areaFactors", ()=>areaFactors);
/**
 * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
 *
 * @name feature
 * @param {Geometry} geometry input geometry
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature} a GeoJSON Feature
 * @example
 * var geometry = {
 *   "type": "Point",
 *   "coordinates": [110, 50]
 * };
 *
 * var feature = turf.feature(geometry);
 *
 * //=feature
 */ parcelHelpers.export(exports, "feature", ()=>feature);
/**
 * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
 * For GeometryCollection type use `helpers.geometryCollection`
 *
 * @name geometry
 * @param {string} type Geometry Type
 * @param {Array<any>} coordinates Coordinates
 * @param {Object} [options={}] Optional Parameters
 * @returns {Geometry} a GeoJSON Geometry
 * @example
 * var type = "Point";
 * var coordinates = [110, 50];
 * var geometry = turf.geometry(type, coordinates);
 * // => geometry
 */ parcelHelpers.export(exports, "geometry", ()=>geometry);
/**
 * Creates a {@link Point} {@link Feature} from a Position.
 *
 * @name point
 * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Point>} a Point feature
 * @example
 * var point = turf.point([-75.343, 39.984]);
 *
 * //=point
 */ parcelHelpers.export(exports, "point", ()=>point);
/**
 * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
 *
 * @name points
 * @param {Array<Array<number>>} coordinates an array of Points
 * @param {Object} [properties={}] Translate these properties to each Feature
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Point>} Point Feature
 * @example
 * var points = turf.points([
 *   [-75, 39],
 *   [-80, 45],
 *   [-78, 50]
 * ]);
 *
 * //=points
 */ parcelHelpers.export(exports, "points", ()=>points);
/**
 * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
 *
 * @name polygon
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<Polygon>} Polygon Feature
 * @example
 * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
 *
 * //=polygon
 */ parcelHelpers.export(exports, "polygon", ()=>polygon);
/**
 * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
 *
 * @name polygons
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
 * @example
 * var polygons = turf.polygons([
 *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
 *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
 * ]);
 *
 * //=polygons
 */ parcelHelpers.export(exports, "polygons", ()=>polygons);
/**
 * Creates a {@link LineString} {@link Feature} from an Array of Positions.
 *
 * @name lineString
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<LineString>} LineString Feature
 * @example
 * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
 * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
 *
 * //=linestring1
 * //=linestring2
 */ parcelHelpers.export(exports, "lineString", ()=>lineString);
/**
 * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
 *
 * @name lineStrings
 * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
 * associated with the FeatureCollection
 * @param {string|number} [options.id] Identifier associated with the FeatureCollection
 * @returns {FeatureCollection<LineString>} LineString FeatureCollection
 * @example
 * var linestrings = turf.lineStrings([
 *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
 *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
 * ]);
 *
 * //=linestrings
 */ parcelHelpers.export(exports, "lineStrings", ()=>lineStrings);
/**
 * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
 *
 * @name featureCollection
 * @param {Feature[]} features input features
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {FeatureCollection} FeatureCollection of Features
 * @example
 * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
 * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
 * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
 *
 * var collection = turf.featureCollection([
 *   locationA,
 *   locationB,
 *   locationC
 * ]);
 *
 * //=collection
 */ parcelHelpers.export(exports, "featureCollection", ()=>featureCollection);
/**
 * Creates a {@link Feature<MultiLineString>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiLineString
 * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiLineString>} a MultiLineString feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
 *
 * //=multiLine
 */ parcelHelpers.export(exports, "multiLineString", ()=>multiLineString);
/**
 * Creates a {@link Feature<MultiPoint>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPoint
 * @param {Array<Array<number>>} coordinates an array of Positions
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPoint>} a MultiPoint feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPt = turf.multiPoint([[0,0],[10,10]]);
 *
 * //=multiPt
 */ parcelHelpers.export(exports, "multiPoint", ()=>multiPoint);
/**
 * Creates a {@link Feature<MultiPolygon>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name multiPolygon
 * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<MultiPolygon>} a multipolygon feature
 * @throws {Error} if no coordinates are passed
 * @example
 * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
 *
 * //=multiPoly
 *
 */ parcelHelpers.export(exports, "multiPolygon", ()=>multiPolygon);
/**
 * Creates a {@link Feature<GeometryCollection>} based on a
 * coordinate array. Properties can be added optionally.
 *
 * @name geometryCollection
 * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
 * @param {Object} [properties={}] an Object of key-value pairs to add as properties
 * @param {Object} [options={}] Optional Parameters
 * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
 * @param {string|number} [options.id] Identifier associated with the Feature
 * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
 * @example
 * var pt = turf.geometry("Point", [100, 0]);
 * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
 * var collection = turf.geometryCollection([pt, line]);
 *
 * // => collection
 */ parcelHelpers.export(exports, "geometryCollection", ()=>geometryCollection);
/**
 * Round number to precision
 *
 * @param {number} num Number
 * @param {number} [precision=0] Precision
 * @returns {number} rounded number
 * @example
 * turf.round(120.4321)
 * //=120
 *
 * turf.round(120.4321, 2)
 * //=120.43
 */ parcelHelpers.export(exports, "round", ()=>round);
/**
 * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name radiansToLength
 * @param {number} radians in radians across the sphere
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} distance
 */ parcelHelpers.export(exports, "radiansToLength", ()=>radiansToLength);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @name lengthToRadians
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} radians
 */ parcelHelpers.export(exports, "lengthToRadians", ()=>lengthToRadians);
/**
 * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
 *
 * @name lengthToDegrees
 * @param {number} distance in real units
 * @param {string} [units="kilometers"] can be degrees, radians, miles, inches, yards, metres,
 * meters, kilometres, kilometers.
 * @returns {number} degrees
 */ parcelHelpers.export(exports, "lengthToDegrees", ()=>lengthToDegrees);
/**
 * Converts any bearing angle from the north line direction (positive clockwise)
 * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
 *
 * @name bearingToAzimuth
 * @param {number} bearing angle, between -180 and +180 degrees
 * @returns {number} angle between 0 and 360 degrees
 */ parcelHelpers.export(exports, "bearingToAzimuth", ()=>bearingToAzimuth);
/**
 * Converts an angle in radians to degrees
 *
 * @name radiansToDegrees
 * @param {number} radians angle in radians
 * @returns {number} degrees between 0 and 360 degrees
 */ parcelHelpers.export(exports, "radiansToDegrees", ()=>radiansToDegrees);
/**
 * Converts an angle in degrees to radians
 *
 * @name degreesToRadians
 * @param {number} degrees angle between 0 and 360 degrees
 * @returns {number} angle in radians
 */ parcelHelpers.export(exports, "degreesToRadians", ()=>degreesToRadians);
/**
 * Converts a length to the requested unit.
 * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
 *
 * @param {number} length to be converted
 * @param {Units} [originalUnit="kilometers"] of the length
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted length
 */ parcelHelpers.export(exports, "convertLength", ()=>convertLength);
/**
 * Converts a area to the requested unit.
 * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches, hectares
 * @param {number} area to be converted
 * @param {Units} [originalUnit="meters"] of the distance
 * @param {Units} [finalUnit="kilometers"] returned unit
 * @returns {number} the converted area
 */ parcelHelpers.export(exports, "convertArea", ()=>convertArea);
/**
 * isNumber
 *
 * @param {*} num Number to validate
 * @returns {boolean} true/false
 * @example
 * turf.isNumber(123)
 * //=true
 * turf.isNumber('foo')
 * //=false
 */ parcelHelpers.export(exports, "isNumber", ()=>isNumber);
/**
 * isObject
 *
 * @param {*} input variable to validate
 * @returns {boolean} true/false
 * @example
 * turf.isObject({elevation: 10})
 * //=true
 * turf.isObject('foo')
 * //=false
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * Validate BBox
 *
 * @private
 * @param {Array<number>} bbox BBox to validate
 * @returns {void}
 * @throws Error if BBox is not valid
 * @example
 * validateBBox([-180, -40, 110, 50])
 * //=OK
 * validateBBox([-180, -40])
 * //=Error
 * validateBBox('Foo')
 * //=Error
 * validateBBox(5)
 * //=Error
 * validateBBox(null)
 * //=Error
 * validateBBox(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateBBox", ()=>validateBBox);
/**
 * Validate Id
 *
 * @private
 * @param {string|number} id Id to validate
 * @returns {void}
 * @throws Error if Id is not valid
 * @example
 * validateId([-180, -40, 110, 50])
 * //=Error
 * validateId([-180, -40])
 * //=Error
 * validateId('Foo')
 * //=OK
 * validateId(5)
 * //=OK
 * validateId(null)
 * //=Error
 * validateId(undefined)
 * //=Error
 */ parcelHelpers.export(exports, "validateId", ()=>validateId);
var earthRadius = 6371008.8;
var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: earthRadius / 111325,
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1000,
    kilometres: earthRadius / 1000,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1000,
    millimetres: earthRadius * 1000,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
};
var unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / earthRadius,
    yards: 1.0936133
};
var areaFactors = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function feature(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function geometry(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return point(coordinates).geometry;
        case "LineString":
            return lineString(coordinates).geometry;
        case "Polygon":
            return polygon(coordinates).geometry;
        case "MultiPoint":
            return multiPoint(coordinates).geometry;
        case "MultiLineString":
            return multiLineString(coordinates).geometry;
        case "MultiPolygon":
            return multiPolygon(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function point(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function points(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return point(coords, properties);
    }), options);
}
function polygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function polygons(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return polygon(coords, properties);
    }), options);
}
function lineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function lineStrings(coordinates, properties, options) {
    if (options === void 0) options = {};
    return featureCollection(coordinates.map(function(coords) {
        return lineString(coords, properties);
    }), options);
}
function featureCollection(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function multiLineString(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPoint(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function multiPolygon(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return feature(geom, properties, options);
}
function geometryCollection(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return feature(geom, properties, options);
}
function round(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function lengthToRadians(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = factors[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function lengthToDegrees(distance, units) {
    return radiansToDegrees(lengthToRadians(distance, units));
}
function bearingToAzimuth(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function radiansToDegrees(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function degreesToRadians(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function convertLength(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
}
function convertArea(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = areaFactors[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = areaFactors[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject(input) {
    return !!input && input.constructor === Object;
}
function validateBBox(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!isNumber(num)) throw new Error("bbox must only contain numbers");
    });
}
function validateId(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3IhSv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deDict", ()=>d);
parcelHelpers.export(exports, "defaultTexts", ()=>J);
parcelHelpers.export(exports, "enDict", ()=>l);
parcelHelpers.export(exports, "esDict", ()=>x);
parcelHelpers.export(exports, "frDict", ()=>k);
parcelHelpers.export(exports, "heDict", ()=>H);
parcelHelpers.export(exports, "idDict", ()=>E);
parcelHelpers.export(exports, "itDict", ()=>v);
parcelHelpers.export(exports, "jaDict", ()=>z);
parcelHelpers.export(exports, "krDict", ()=>T);
parcelHelpers.export(exports, "nbDict", ()=>q);
parcelHelpers.export(exports, "nlDict", ()=>w);
parcelHelpers.export(exports, "plDict", ()=>y);
parcelHelpers.export(exports, "ptDict", ()=>A);
parcelHelpers.export(exports, "ruDict", ()=>G);
parcelHelpers.export(exports, "svDict", ()=>C);
parcelHelpers.export(exports, "trDict", ()=>F);
parcelHelpers.export(exports, "uaDict", ()=>I);
parcelHelpers.export(exports, "zhDict", ()=>B);
var _deMjs = require("./authenticator/de.mjs");
var _enMjs = require("./authenticator/en.mjs");
var _esMjs = require("./authenticator/es.mjs");
var _frMjs = require("./authenticator/fr.mjs");
var _itMjs = require("./authenticator/it.mjs");
var _jaMjs = require("./authenticator/ja.mjs");
var _krMjs = require("./authenticator/kr.mjs");
var _nbMjs = require("./authenticator/nb.mjs");
var _nlMjs = require("./authenticator/nl.mjs");
var _plMjs = require("./authenticator/pl.mjs");
var _ptMjs = require("./authenticator/pt.mjs");
var _zhMjs = require("./authenticator/zh.mjs");
var _svMjs = require("./authenticator/sv.mjs");
var _idMjs = require("./authenticator/id.mjs");
var _trMjs = require("./authenticator/tr.mjs");
var _ruMjs = require("./authenticator/ru.mjs");
var _heMjs = require("./authenticator/he.mjs");
var _uaMjs = require("./authenticator/ua.mjs");
var _defaultTextsMjs = require("./authenticator/defaultTexts.mjs");
const d = Object.assign({}, (0, _deMjs.deDict)), l = Object.assign({}, (0, _enMjs.enDict)), x = Object.assign({}, (0, _esMjs.esDict)), k = Object.assign({}, (0, _frMjs.frDict)), v = Object.assign({}, (0, _itMjs.itDict)), z = Object.assign({}, (0, _jaMjs.jaDict)), T = Object.assign({}, (0, _krMjs.krDict)), q = Object.assign({}, (0, _nbMjs.nbDict)), w = Object.assign({}, (0, _nlMjs.nlDict)), y = Object.assign({}, (0, _plMjs.plDict)), A = Object.assign({}, (0, _ptMjs.ptDict)), B = Object.assign({}, (0, _zhMjs.zhDict)), C = Object.assign({}, (0, _svMjs.svDict)), E = Object.assign({}, (0, _idMjs.idDict)), F = Object.assign({}, (0, _trMjs.trDict)), G = Object.assign({}, (0, _ruMjs.ruDict)), H = Object.assign({}, (0, _heMjs.heDict)), I = Object.assign({}, (0, _uaMjs.uaDict)), J = Object.assign({}, (0, _defaultTextsMjs.defaultTexts));

},{"./authenticator/de.mjs":"9pn4W","./authenticator/en.mjs":"0106t","./authenticator/es.mjs":"dUHVs","./authenticator/fr.mjs":"6HxEC","./authenticator/it.mjs":"bJE9P","./authenticator/ja.mjs":"aq5iq","./authenticator/kr.mjs":"3KyEH","./authenticator/nb.mjs":"5ERW8","./authenticator/nl.mjs":"aSkRH","./authenticator/pl.mjs":"75IPP","./authenticator/pt.mjs":"h4kxi","./authenticator/zh.mjs":"1l0fH","./authenticator/sv.mjs":"h4Eb3","./authenticator/id.mjs":"fwniH","./authenticator/tr.mjs":"hO7RX","./authenticator/ru.mjs":"vNh1Z","./authenticator/he.mjs":"8Q6HT","./authenticator/ua.mjs":"ioXSi","./authenticator/defaultTexts.mjs":"9qGxO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9pn4W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Please confirm your Password": "Bitte best\xe4tigen Sie Ihr Passwort",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your Email": "Geben Sie Ihre E-Mail ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    "It may take a minute to arrive": "Es kann eine Minute dauern, bis er ankommt",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    or: "oder",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "We Sent A Code": "Wir haben einen Code gesendet",
    "We Texted You": "Wir haben Ihnen eine SMS gesendet",
    "Your code is on the way. To log in, enter the code we sent you": "Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben",
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Enter your Password": "Geben Sie Ihr Passwort ein",
    "Sign Up with Facebook": "Mit Facebook registrieren",
    "Sign Up with Google": "Mit Google registrieren",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": "Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900",
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"0106t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Add your Profile": "Add your Profile",
    "Add your Website": "Add your Website",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your Birthdate": "Enter your Birthdate",
    "Enter your code": "Enter your code",
    "Enter your Confirmation Code": "Enter your Confirmation Code",
    "Enter your Email": "Enter your Email",
    "Enter your Family Name": "Enter your Family Name",
    "Enter your Given Name": "Enter your Given Name",
    "Enter your Middle Name": "Enter your Middle Name",
    "Enter your Name": "Enter your Name",
    "Enter your Nickname": "Enter your Nickname",
    "Enter your Password": "Enter your Password",
    "Enter your phone number": "Enter your phone number",
    "Enter your Preferred Username": "Enter your Preferred Username",
    "Enter your username": "Enter your username",
    "Forgot password?": "Forgot password?",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    "It may take a minute to arrive": "It may take a minute to arrive",
    Loading: "Loading",
    "New password": "New password",
    or: "or",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Please confirm your Password": "Please confirm your Password",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify",
    "We Emailed You": "We Emailed You",
    "We Sent A Code": "We Sent A Code",
    "We Texted You": "We Texted You",
    "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to",
    "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you",
    "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dUHVs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "esDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your Email": "Escriba su Email",
    "Enter your Password": "Escriba su Contrase\xf1a",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    "It may take a minute to arrive": "Es posible que tarde un minuto en llegar",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    or: "o",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "We Emailed You": "Le hemos enviado un correo electr\xf3nico",
    "We Sent A Code": "Hemos enviado un c\xf3digo",
    "We Texted You": "Le hemos enviado un mensaje de texto",
    "Your code is on the way. To log in, enter the code we emailed to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por correo electr\xf3nico a",
    "Your code is on the way. To log in, enter the code we sent you": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que le hemos enviado",
    "Your code is on the way. To log in, enter the code we texted to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por mensaje de texto a",
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6HxEC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": "Cr\xe9ation d'un compte",
    "Dismiss alert": "Supprimer l'alerte",
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your Email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    "It may take a minute to arrive": "Cela peut prendre une minute",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    or: "ou",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "We Sent A Code": "Nous avons envoy\xe9 un code",
    "We Texted You": "Nous vous avons envoy\xe9 un SMS",
    "Your code is on the way. To log in, enter the code we sent you": "Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xe9",
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": "Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900",
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas",
    "We Emailed You": "Nous vous avons envoy\xe9 un code",
    "Your code is on the way. To log in, enter the code we emailed to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur cette adresse email",
    "Your code is on the way. To log in, enter the code we texted to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur ce num\xe9ro de t\xe9l\xe9phone",
    "Your passwords must match": "Vos mots de passe doivent \xeatre identiques",
    "It may take a minute to arrive.": "Cela peut prendre quelques minutes."
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJE9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "itDict", ()=>o);
const o = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": "Ignora l'avviso",
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your Email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    "It may take a minute to arrive": "L'arrivo potrebbe richiedere qualche minuto",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    or: "oppure",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "We Emailed You": "Ti abbiamo inviato un'e-mail",
    "We Sent A Code": "Ti abbiamo inviato un codice",
    "We Texted You": "Ti abbiamo inviato un SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Il codice \xe8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato",
    "Your code is on the way. To log in, enter the code we texted to": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS",
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password?": "Password dimenticata?",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aq5iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "jaDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    "Confirm Sign Up": "\u767B\u9332\u3059\u308B",
    "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    "Enter your Email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    "It may take a minute to arrive": "\u5230\u7740\u3059\u308B\u307E\u3067\u306B 1 \u5206\u304B\u304B\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    or: "\u53C8\u306F",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    "Phone Number": "\u96FB\u8A71\u756A\u53F7",
    "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    "We Sent A Code": "\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "We Texted You": "\u30C6\u30AD\u30B9\u30C8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we sent you": "\u30B3\u30FC\u30C9\u304C\u9014\u4E2D\u3067\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u9001\u4FE1\u3057\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    "Enter your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Please confirm your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    "Reset Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    "Sign Up": "\u767B\u9332 ",
    "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KyEH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "krDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    "Confirmation Code": "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    "Create a new account": "\uD68C\uC6D0\uAC00\uC785",
    "Create Account": "\uD68C\uC6D0\uAC00\uC785",
    "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911",
    "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Enter your Email": "\uC774\uBA54\uC77C \uC785\uB825",
    "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    "It may take a minute to arrive": "\uB3C4\uCC29\uD558\uB294 \uB370 1\uBD84 \uC815\uB3C4 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    Loading: "\uB85C\uB529\uC911",
    "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    or: "\uB610\uB294",
    Password: "\uBE44\uBC00\uBC88\uD638",
    "Phone Number": "\uC804\uD654\uBC88\uD638",
    "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    "Send Code": "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30",
    "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    "Sign in to your account": "\uB85C\uADF8\uC778",
    "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778",
    "Sign In with Apple": "Apple \uB85C\uADF8\uC778",
    "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778",
    "Sign In with Google": "Google \uB85C\uADF8\uC778",
    "Sign in": "\uB85C\uADF8\uC778",
    "Sign In": "\uB85C\uADF8\uC778",
    "Signing in": "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    Username: "\uC544\uC774\uB514",
    "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    "We Emailed You": "\uC774\uBA54\uC77C\uC744 \uBCF4\uB0C4",
    "We Sent A Code": "\uCF54\uB4DC\uB97C \uBCF4\uB0C4",
    "We Texted You": "\uBB38\uC790 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0C4",
    "Your code is on the way. To log in, enter the code we emailed to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we sent you": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we texted to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBB38\uC790 \uBA54\uC2DC\uC9C0\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    "Family Name": "\uC131",
    "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    "Given Name": "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    "Preferred Username": "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ERW8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nbDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "Gjenoppretting av konto krever verifisert kontaktinformajson",
    "Add your Profile": "Legg til profilen din",
    "Add your Website": "Legg til nettsiden din",
    "Back to Sign In": "Tilbake til innlogging",
    "Change Password": "Bytt passord",
    Changing: "Endre",
    Code: "Kode",
    "Confirm Password": "Bekreft passordet",
    "Confirm Sign Up": "Bekreft registrering",
    "Confirm SMS Code": "Bekreft SMS-kode",
    "Confirm TOTP Code": "Bekreft TOTP-kode",
    Confirm: "Bekreft",
    "Confirmation Code": "Bekreftelseskode",
    Confirming: "Bekrefter",
    "Create a new account": "Opprett en ny konto",
    "Create Account": "Opprett konto",
    "Creating Account": "Oppretter konto",
    "Dismiss alert": "Avvis varsel",
    Email: "E-post",
    "Enter your Birthdate": "Skriv inn f\xf8dselsdatoen din",
    "Enter your code": "Skriv inn koden din",
    "Enter your Confirmation Code": "Skriv inn bekreftelseskoden din",
    "Enter your Email": "Skriv inn e-postadressen din",
    "Enter your Family Name": "Skriv inn etternavnet ditt",
    "Enter your Given Name": "Skriv inn fornavnet ditt",
    "Enter your Middle Name": "Skriv inn mellomnavnet ditt",
    "Enter your Name": "Skriv inn navnet ditt",
    "Enter your Nickname": "Skriv inn kallenavnet ditt",
    "Enter your Password": "Skriv inn passordet ditt",
    "Enter your phone number": "Skriv inn telefonnummeret ditt",
    "Enter your Preferred Username": "Skriv inn det foretrukne brukernavnet ditt",
    "Enter your username": "Skriv inn brukernavnet ditt",
    "Forgot password?": "Glemt passord?",
    "Forgot your password?": "Glemt passordet ditt?",
    "Hide password": "Skjul passordet",
    "It may take a minute to arrive": "Det kan ta et minutt for \xe5 komme frem",
    Loading: "Laster inn",
    "New password": "Nytt passord",
    or: "eller",
    Password: "Passord",
    "Phone Number": "Telefonnummer",
    "Please confirm your Password": "Vennligst bekreft passordet ditt",
    "Resend Code": "Send koden p\xe5 nytt",
    "Reset your password": "Nullstill passordet ditt",
    "Reset your Password": "Nullstill passordet ditt",
    "Send code": "Send kode",
    "Send Code": "Send kode",
    Sending: "Sender",
    "Setup TOTP": "Konfigurer TOTP",
    "Show password": "Vis passordet",
    "Sign in to your account": "Logg inn p\xe5 kontoen din",
    "Sign In with Amazon": "Logg inn med Amazon",
    "Sign In with Apple": "Logg inn med Apple",
    "Sign In with Facebook": "Logg inn med Facebook",
    "Sign In with Google": "Logg inn med Google",
    "Sign in": "Logg inn",
    "Sign In": "Logg inn",
    "Signing in": "Logger inn",
    Skip: "Hopp over",
    Submit: "Send inn",
    Submitting: "Sender inn",
    Username: "Brukernavn",
    "Verify Contact": "Bekreft kontakt",
    Verify: "Bekreft",
    "We Emailed You": "Vi sendte deg en e-post",
    "We Sent A Code": "Vi sendte en kode",
    "We Texted You": "Vi sendte deg en tekstmelding",
    "Your code is on the way. To log in, enter the code we emailed to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte e-post til",
    "Your code is on the way. To log in, enter the code we sent you": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte deg",
    "Your code is on the way. To log in, enter the code we texted to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte tekstmelding til",
    "An account with the given email already exists.": "Det finnes allerede en konto med denne e-postadressen",
    "Confirm a Code": "Bekreft koden",
    "Confirm Sign In": "Bekreft innlogging",
    "Create account": "Opprett konto",
    "Enter your password": "Skriv inn passordet ditt",
    "Forgot Password": "Glemt passordet",
    "Have an account? ": "Har en konto allerede? ",
    "Incorrect username or password": "Feil brukernavn eller passord",
    "Invalid password format": "Ugyldig passordformat",
    "Invalid phone number format": "Ugyldig telefonnummerformat",
    "Lost your code? ": "Mistet koden? ",
    "New Password": "Nytt passord",
    "No account? ": "Ingen konto? ",
    "Password attempts exceeded": "For mange mislykkede passordfors\xf8k",
    "Reset password": "Nullstill passord",
    "Sign Out": "Logg ut",
    "Sign Up": "Registrering",
    "User already exists": "Brukeren finnes allerede",
    "User does not exist": "Brukeren finnes ikke",
    "Username cannot be empty": "Brukernavnet kan ikke v\xe6re tomt"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aSkRH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nlDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your Email": "Vul je e-mail in",
    "Enter your Password": "Vul je wachtwoord in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Enter your Username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    "It may take a minute to arrive": "Het kan even duren voordat deze aankomt",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    "New Password": "Nieuw Wachtwoord",
    or: "of",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Please confirm your Password": "Bevestig je wachtwoord",
    "Resend Code": "Verstuur code nogmaals",
    "Reset Password": "Wachtwoord resetten",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer",
    "We Emailed You": "We hebben u een e-mail gestuurd",
    "We Sent A Code": "We hebben een code gestuurd",
    "We Texted You": "We hebben u een sms gestuurd",
    "Your code is on the way. To log in, enter the code we emailed to": "Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar",
    "Your code is on the way. To log in, enter the code we sent you": "Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd",
    "Your code is on the way. To log in, enter the code we texted to": "Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar",
    "Your passwords must match": "Je wachtwoorden moeten overeenkomen"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75IPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "plDict", ()=>o);
const o = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmie\u0144 has\u0142o",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierd\u017A Has\u0142o",
    "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119",
    "Confirm SMS Code": "Potwierd\u017A kod SMS",
    "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzu\u0107 alert",
    Email: "E-mail",
    "Enter your code": "Wprowad\u017A sw\xf3j kod",
    "Enter your Email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ",
    "Hide password": "Ukryj has\u0142o",
    "It may take a minute to arrive": "Mo\u017Ce to chwil\u0119 potrwa\u0107",
    Loading: "\u0141adowanie",
    "New password": "Nowe has\u0142o",
    or: "albo",
    Password: "Has\u0142o",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wy\u015Blij kod ponownie",
    "Reset your password": "Zresetuj swoje has\u0142o",
    "Reset your Password": "Zresetuj swoje has\u0142o",
    "Send code": "Wy\u015Blij kod",
    "Send Code": "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Poka\u017C has\u0142o",
    "Sign in to your account": "Zaloguj si\u0119 na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    Username: "Nazwa u\u017Cytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imi\u0119",
    "Middle Name": "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa u\u017Cytkownika",
    Profile: "Profil",
    Website: "Strona internetowa",
    "We Emailed You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 e-mail",
    "We Sent A Code": "Wys\u0142ali\u015Bmy kod",
    "We Texted You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any na adres e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A wys\u0142any do Ciebie kod",
    "Your code is on the way. To log in, enter the code we texted to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any do Ciebie w wiadomo\u015Bci SMS pod numer"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h4kxi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ptDict", ()=>o);
const o = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your Email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    "It may take a minute to arrive": "Pode levar um minuto para chegar",
    Loading: "Carregando",
    "New password": "Nova Senha",
    or: "ou",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar",
    "We Emailed You": "Enviamos um e-mail para voc\xea",
    "We Sent A Code": "Enviamos um c\xf3digo",
    "We Texted You": "Enviamos um SMS para voc\xea",
    "Your code is on the way. To log in, enter the code we emailed to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos um e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo que enviamos para voc\xea",
    "Your code is on the way. To log in, enter the code we texted to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos uma mensagem de texto"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1l0fH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zhDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    "Back to Sign In": "\u56DE\u5230\u767B\u5F55",
    "Change Password": "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    "Confirm Password": "\u786E\u8BA4\u5BC6\u7801",
    "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C",
    "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    "Confirmation Code": "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "Create Account": "\u521B\u5EFA\u8D26\u6237",
    "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    "Dismiss alert": "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801",
    "Enter your Email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    "Enter your username": "\u8F93\u5165\u7528\u6237\u540D",
    "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    "Hide password": "\u9690\u85CF\u5BC6\u7801",
    "It may take a minute to arrive": "\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u80FD\u5230\u8FBE",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    "New password": "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    Password: "\u5BC6\u7801",
    "Phone Number": "\u7535\u8BDD",
    "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    "Reset your password": "\u91CD\u7F6E\u5BC6\u7801",
    "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801",
    "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801",
    "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    "Setup TOTP": "\u8BBE\u7F6E TOTP",
    "Show password": "\u663E\u793A\u5BC6\u7801",
    "Sign in to your account": "\u767B\u5F55\u8D26\u6237",
    "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55",
    "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55",
    "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55",
    "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55",
    "Sign in": "\u767B\u5F55",
    "Sign In": "\u767B\u5F55",
    "Signing in": "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    Username: "\u7528\u6237\u540D",
    "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    "We Emailed You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u7535\u5B50\u90AE\u4EF6",
    "We Sent A Code": "\u6211\u4EEC\u53D1\u9001\u4E86\u4EE3\u7801",
    "We Texted You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u77ED\u4FE1",
    "Your code is on the way. To log in, enter the code we emailed to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    "Your code is on the way. To log in, enter the code we sent you": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u7ED9\u60A8\u7684\u4EE3\u7801",
    "Your code is on the way. To log in, enter the code we texted to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    "Confirm a Code": "\u786E\u8BA4\u7801",
    "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55",
    "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801",
    "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    "New Password": "\u65B0\u5BC6\u7801",
    "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801",
    "Sign Out": "\u9000\u51FA",
    "Sign Up": "\u6CE8\u518C",
    "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h4Eb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your Email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    "It may take a minute to arrive": "Det kan ta en minut att komma fram",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    or: "eller",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "We Sent A Code": "Vi skickade en kod",
    "We Texted You": "Vi sms:ade dig",
    "Your code is on the way. To log in, enter the code we emailed to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi mejlade till",
    "Your code is on the way. To log in, enter the code we sent you": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi skickade till dig",
    "Your code is on the way. To log in, enter the code we texted to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi sms:ade till",
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": "Ogiltigt format f\xf6r telefonnummer",
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fwniH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "idDict", ()=>a);
const a = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your Email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    "It may take a minute to arrive": "Mungkin perlu waktu satu menit untuk tiba",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    or: "atau",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "We Sent A Code": "Kami Mengirim Kode",
    "We Texted You": "Kami mengirim SMS kepada Anda",
    "Your code is on the way. To log in, enter the code we sent you": "Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda",
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hO7RX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: "Kod",
    "Confirm Password": "\u015Eifreyi Do\u011Frula",
    "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    "Confirm SMS Code": "SMS Kodunu Do\u011Frula",
    "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    "Confirmation Code": "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    "Create a new account": "Yeni bir hesap olu\u015Ftur",
    "Create Account": "Hesap Olu\u015Ftur",
    "Creating Account": "Hesap Olu\u015Fturuluyor",
    "Dismiss alert": "Uyar\u0131y\u0131 reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your Email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaran\u0131z\u0131 girin",
    "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    "Forgot your password?": "\u015Eifrenizi mi unuttunuz?",
    "Hide password": "\u015Eifreyi gizle",
    "It may take a minute to arrive": "Kodun gelmesi bir dakika s\xfcrebilir",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni \u015Fifre",
    or: "veya",
    Password: "\u015Eifre",
    "Phone Number": "Telefon Numaras\u0131",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    "Show password": "\u015Eifreyi g\xf6ster",
    "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7\u0131l\u0131yor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    "Verify Contact": "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    "We Emailed You": "Size E-posta G\xf6nderdik",
    "We Sent A Code": "Bir Kod G\xf6nderdik",
    "We Texted You": "Size Mesaj G\xf6nderdik",
    "Your code is on the way. To log in, enter the code we emailed to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz e-postadaki kodu girin",
    "Your code is on the way. To log in, enter the code we sent you": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, size g\xf6nderdi\u011Fimiz kodu girin",
    "Your code is on the way. To log in, enter the code we texted to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz mesajdaki kodu girin",
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7may\u0131 Do\u011Frula",
    "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ",
    "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    "Invalid password format": "Ge\xe7ersiz parola format\u0131",
    "Invalid phone number format": "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesab\u0131n\u0131z yok mu? ",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    "Sign Out": "\xc7\u0131k\u0131\u015F yap",
    "Sign Up": "Kay\u0131t Ol",
    "User already exists": "Bu kullan\u0131c\u0131 zaten var",
    "User does not exist": "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"vNh1Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ruDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    "Enter your Email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0438\u043B\u0438",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    "Sign in": "\u0437\u043D\u0430\u043A \u0432",
    "Sign In": "\u0437\u043D\u0430\u043A \u0432",
    "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C",
    "We Emailed You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E",
    "We Sent A Code": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u0432\u0430\u043C",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Q6HT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "heDict", ()=>n);
const n = {
    "Account recovery requires verified contact information": "\u05E9\u05D7\u05D6\u05D5\u05E8 \u05DC\u05E7\u05D5\u05D7 \u05D3\u05D5\u05E8\u05E9 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05D3\u05E2",
    "Back to Sign In": "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4",
    "Change Password": "\u05E2\u05D3\u05DB\u05D5\u05DF \u05E1\u05D9\u05E1\u05DE\u05D0",
    Changing: "\u05DE\u05E2\u05D3\u05DB\u05DF",
    Code: "\u05E7\u05D5\u05D3",
    "Confirm Password": "\u05D0\u05E9\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Confirm Sign Up": "\u05D0\u05E9\u05E8 \u05D4\u05E8\u05E9\u05DE\u05D4",
    "Confirm SMS Code": "\u05D0\u05E9\u05E8 sms \u05E7\u05D5\u05D3",
    "Confirm TOTP Code": "\u05D0\u05E9\u05E8 totp \u05E7\u05D5\u05D3",
    Confirm: "\u05D0\u05D9\u05E9\u05D5\u05E8",
    "Confirmation Code": "\u05D0\u05D9\u05E9\u05D5\u05E8 \u05E7\u05D5\u05D3",
    Confirming: "\u05DE\u05D0\u05E9\u05E8",
    "Create a new account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D7\u05D3\u05E9",
    "Create Account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Creating Account": "\u05D9\u05E6\u05D9\u05E8\u05EA \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Dismiss alert": "\u05D4\u05E1\u05E8 \u05D4\u05EA\u05E8\u05D0\u05D4",
    Email: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    "Enter your code": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3",
    "Enter your Email": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
    "Enter your phone number": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Enter your username": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DE\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA",
    "Forgot your password?": "\u05E9\u05D7\u05DB\u05EA \u05E1\u05D9\u05E1\u05DE\u05D0 ?",
    "Hide password": "\u05D4\u05E1\u05EA\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    Loading: "\u05D8\u05D5\u05E2\u05DF",
    "New password": "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05D7\u05D3\u05E9\u05D4",
    or: "\u05D0\u05D5\u05B9",
    Password: "\u05E1\u05D9\u05E1\u05DE\u05D0",
    "Phone Number": "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
    "Resend Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
    "Reset your password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Reset your Password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Send code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    "Send Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    Sending: "\u05E9\u05D5\u05DC\u05D7",
    "Setup TOTP": "Setup TOTP",
    "Show password": "\u05D4\u05E6\u05D2 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Sign in to your account": "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Sign In": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Signing in": "\u05DE\u05EA\u05D7\u05D1\u05E8",
    Skip: "\u05D3\u05DC\u05D2",
    Submit: "\u05E9\u05DC\u05D7",
    Submitting: "\u05E9\u05D5\u05DC\u05D7",
    Username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Verify Contact": "\u05D0\u05DE\u05EA \u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8",
    Verify: "\u05D0\u05DE\u05EA"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ioXSi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uaDict", ()=>e);
const e = {
    "Account recovery requires verified contact information": "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443",
    "Change Password": "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0417\u043C\u0456\u043D\u044E\u0454\u043C\u043E",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Confirm Sign Up": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
    "Confirm SMS Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C SMS \u043A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C TOTP \u043A\u043E\u0434",
    Confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "Confirmation Code": "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
    Confirming: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u043C\u043E",
    "Create a new account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Create Account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Creating Account": "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u043C\u043E",
    "Dismiss alert": "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    Email: "Email",
    "Enter your code": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Enter your Email": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 email",
    "Enter your phone number": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Enter your username": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Forgot password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Forgot your password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435 \u0442\u0440\u0438\u0432\u0430\u0442\u0438 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E",
    "New password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0430\u0431\u043E",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Resend Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset your password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    "Send Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    Sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    "Setup TOTP": "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    "Sign In with Amazon": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Amazon",
    "Sign In with Apple": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Apple",
    "Sign In with Facebook": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Facebook",
    "Sign In with Google": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Google",
    "Sign in": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Sign In": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Signing in": "\u0412\u0445\u043E\u0434\u0438\u043C\u043E",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438",
    Submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    Submitting: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    Username: "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Verify Contact": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u041A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "We Emailed You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C Email",
    "We Sent A Code": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u043D\u0430 Email",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0430\u043C \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438\u043C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F\u043C",
    "An account with the given email already exists.": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437 \u0446\u0438\u043C Email \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454.",
    "Confirm a Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Confirm Sign In": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0432\u0445\u0456\u0434",
    "Forgot Password": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Incorrect username or password.": "\u041D\u0435\u0432\u0456\u0440\u043D\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C",
    "Invalid password format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0430\u0440\u043E\u043B\u044E",
    "Invalid phone number format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Loading...": "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E...",
    "New Password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Resend a Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign Out": "\u0412\u0438\u0439\u0442\u0438",
    "Sign Up with Amazon": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Amazon",
    "Sign Up with Apple": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Apple",
    "Sign Up with Facebook": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Facebook",
    "Sign Up with Google": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Google",
    "Sign Up": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "User already exists": "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    "User does not exist": "\u0422\u0430\u043A\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454",
    "Username cannot be empty": "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
    "Your passwords must match": "\u041F\u0430\u0440\u043E\u043B\u0456 \u043C\u0430\u044E\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9qGxO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTexts", ()=>E);
const E = {
    ADD_PROFILE: "Add your Profile",
    ADD_WEBSITE: "Add your Website",
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CODE_ARRIVAL: "It may take a minute to arrive",
    CODE_EMAILED: "Your code is on the way. To log in, enter the code we emailed to",
    CODE_SENT: "Your code is on the way. To log in, enter the code we sent you",
    CODE_TEXTED: "Your code is on the way. To log in, enter the code we texted to",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_PASSWORD_PLACEHOLDER: "Please confirm your Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_BIRTHDATE: "Enter your Birthdate",
    ENTER_CODE: "Enter your code",
    ENTER_CONFIRMATION_CODE: "Enter your Confirmation Code",
    ENTER_EMAIL: "Enter your Email",
    ENTER_FAMILY_NAME: "Enter your Family Name",
    ENTER_GIVEN_NAME: "Enter your Given Name",
    ENTER_MIDDLE_NAME: "Enter your Middle Name",
    ENTER_NAME: "Enter your Name",
    ENTER_NICK_NAME: "Enter your Nickname",
    ENTER_PASSWORD: "Enter your Password",
    ENTER_PHONE_NUMBER: "Enter your Phone Number",
    ENTER_PREFERRED_USERNAME: "Enter your Preferred Username",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_PASSWORD: "Forgot Password?",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    OR: "or",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    UPPERCASE_COPY: "COPY",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WE_EMAILED: "We Emailed You",
    WE_SENT_CODE: "We Sent A Code",
    WE_TEXTED: "We Texted You",
    WEBSITE: "Website"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dVV3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getErrors", ()=>s);
parcelHelpers.export(exports, "getFormDataFromEvent", ()=>t);
parcelHelpers.export(exports, "isAuthFieldWithDefaults", ()=>o);
parcelHelpers.export(exports, "setFormOrder", ()=>e);
var _userMjs = require("../../types/authenticator/user.mjs");
var _attributesMjs = require("../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../types/primitives/componentClassName.mjs");
const t = (r)=>{
    const t = new FormData(r.target);
    return Object.fromEntries(t);
}, e = (r, t)=>{
    let e = [];
    return r && (e = Object.keys(r).reduce((t, e)=>{
        var o;
        return t.push([
            e,
            null === (o = r[e]) || void 0 === o ? void 0 : o.order
        ]), t;
    }, []).sort((r, t)=>r[1] - t[1]).filter((r)=>void 0 !== r[1]).map((r)=>r[0])), Array.from(new Set([
        ...e,
        ...t
    ]));
}, o = (t)=>(0, _attributesMjs.authFieldsWithDefaults).includes(t), s = (r)=>{
    var t;
    return r ? (t = r, Array.isArray(t) ? r : [
        r
    ]) : null;
};

},{"../../types/authenticator/user.mjs":"aZbQw","../../types/authenticator/attributes.mjs":"2ngIN","../../types/primitives/componentClassName.mjs":"62ykl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l02QH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "censorAllButFirstAndLast", ()=>l);
parcelHelpers.export(exports, "censorPhoneNumber", ()=>u);
parcelHelpers.export(exports, "configureComponent", ()=>c);
parcelHelpers.export(exports, "defaultAuthHubHandler", ()=>d);
parcelHelpers.export(exports, "getTotpCodeURL", ()=>f);
parcelHelpers.export(exports, "hasSpecialChars", ()=>p);
parcelHelpers.export(exports, "isValidEmail", ()=>I);
parcelHelpers.export(exports, "listenToAuthHub", ()=>h);
parcelHelpers.export(exports, "trimValues", ()=>g);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _auth = require("@aws-amplify/auth");
var _waitForJs = require("xstate/lib/waitFor.js");
var _constantsMjs = require("./constants.mjs");
var _actorMjs = require("./actor.mjs");
var _indexMjs = require("../../utils/index.mjs");
const c = ({ packageName: t, version: e })=>{
    (0, _auth.appendToCognitoUserAgent)(`${t}/${e}`);
}, l = (t)=>{
    const e = t.trim().split("");
    for(let t = 0; t < e.length; t++)t > 0 && t < e.length - 1 && (e[t] = "*");
    return e.join("");
}, u = (t)=>{
    if (t.length < 4) return t;
    const e = t.split("");
    for(let t = 0; t < e.length - 4; t++)e[t] = "*";
    return e.join("");
}, m = (e)=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        try {
            yield (0, _waitForJs.waitFor)(e, (t)=>(0, _actorMjs.getActorState)(t).matches("autoSignIn"));
        } catch (t) {}
    }), d = ({ payload: { data: e, event: n } }, i, a)=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        const { send: t } = i, o = i.getSnapshot(), { onSignIn: c, onSignOut: l } = null != a ? a : {};
        switch(n){
            case "tokenRefresh":
                o.matches("authenticated.idle") && t("TOKEN_REFRESH");
                break;
            case "autoSignIn":
                if (!o.matches("authenticated")) {
                    yield m(i);
                    const n = (0, _actorMjs.getActorState)(i.getSnapshot());
                    (null == n ? void 0 : n.matches("autoSignIn")) && t({
                        type: "AUTO_SIGN_IN",
                        data: e
                    });
                }
                break;
            case "autoSignIn_failure":
                {
                    yield m(i);
                    const n = (0, _actorMjs.getActorState)(i.getSnapshot());
                    (null == n ? void 0 : n.matches("autoSignIn")) && t({
                        type: "AUTO_SIGN_IN_FAILURE",
                        data: e
                    });
                    break;
                }
            case "signIn":
                (0, _indexMjs.isFunction)(c) && c();
                break;
            case "signOut":
            case "tokenRefresh_failure":
                (0, _indexMjs.isFunction)(l) && l(), o.matches("authenticated.idle") && t("SIGN_OUT");
        }
    }), h = (t, n = d)=>(0, _awsAmplify.Hub).listen("auth", ((t, e)=>(n)=>{
            e(n, t);
        })(t, n), "authenticator-hub-handler"), p = (t)=>(0, _constantsMjs.ALLOWED_SPECIAL_CHARACTERS).some((e)=>t.includes(e)), f = (t, e, n)=>encodeURI(`otpauth://totp/${t}:${e}?secret=${n}&issuer=${t}`);
function g(t, ...e) {
    return Object.entries(t).reduce((t, [n, i])=>Object.assign(Object.assign({}, t), {
            [n]: e.includes(n) ? i : null == i ? void 0 : i.trim()
        }), {});
}
const I = (t)=>!!t && (0, _constantsMjs.emailRegex).test(t);

},{"tslib":"86BcK","aws-amplify":"75VoS","@aws-amplify/auth":"ilv20","xstate/lib/waitFor.js":"boJdg","./constants.mjs":"ku5eE","./actor.mjs":"b1Die","../../utils/index.mjs":"a3Yxt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boJdg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _tslib = require("bcb268717fe77a1e");
var defaultWaitForOptions = {
    timeout: 10000 // 10 seconds
};
/**
 * Subscribes to an actor ref and waits for its emitted value to satisfy
 * a predicate, and then resolves with that value.
 * Will throw if the desired state is not reached after a timeout
 * (defaults to 10 seconds).
 *
 * @example
 * ```js
 * const state = await waitFor(someService, state => {
 *   return state.hasTag('loaded');
 * });
 *
 * state.hasTag('loaded'); // true
 * ```
 *
 * @param actorRef The actor ref to subscribe to
 * @param predicate Determines if a value matches the condition to wait for
 * @param options
 * @returns A promise that eventually resolves to the emitted value
 * that matches the condition
 */ function waitFor(actorRef, predicate, options) {
    var resolvedOptions = _tslib.__assign(_tslib.__assign({}, defaultWaitForOptions), options);
    return new Promise(function(res, rej) {
        var done = false;
        var handle = resolvedOptions.timeout === Infinity ? undefined : setTimeout(function() {
            sub.unsubscribe();
            rej(new Error("Timeout of ".concat(resolvedOptions.timeout, " ms exceeded")));
        }, resolvedOptions.timeout);
        var dispose = function() {
            clearTimeout(handle);
            done = true;
            sub === null || sub === void 0 || sub.unsubscribe();
        };
        var sub = actorRef.subscribe({
            next: function(emitted) {
                if (predicate(emitted)) {
                    dispose();
                    res(emitted);
                }
            },
            error: function(err) {
                dispose();
                rej(err);
            },
            complete: function() {
                dispose();
                rej(new Error("Actor terminated without satisfying predicate"));
            }
        });
        if (done) sub.unsubscribe();
    });
}
exports.waitFor = waitFor;

},{"bcb268717fe77a1e":"05cZX"}],"05cZX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ exports.__assign = function() {
    exports.__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return exports.__assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
exports.__read = __read;
exports.__rest = __rest;
exports.__spreadArray = __spreadArray;
exports.__values = __values;

},{}],"a3Yxt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areEmptyArrays", ()=>l);
parcelHelpers.export(exports, "areEmptyObjects", ()=>p);
parcelHelpers.export(exports, "capitalize", ()=>y);
parcelHelpers.export(exports, "classNameModifier", ()=>j);
parcelHelpers.export(exports, "classNameModifierByFlag", ()=>g);
parcelHelpers.export(exports, "has", ()=>s);
parcelHelpers.export(exports, "isEmpty", ()=>i);
parcelHelpers.export(exports, "isFunction", ()=>b);
parcelHelpers.export(exports, "isMap", ()=>e);
parcelHelpers.export(exports, "isNil", ()=>c);
parcelHelpers.export(exports, "isObject", ()=>n);
parcelHelpers.export(exports, "isSet", ()=>o);
parcelHelpers.export(exports, "isString", ()=>r);
parcelHelpers.export(exports, "isTypedFunction", ()=>A);
parcelHelpers.export(exports, "isUndefined", ()=>u);
parcelHelpers.export(exports, "noop", ()=>v);
parcelHelpers.export(exports, "sanitizeNamespaceImport", ()=>t);
parcelHelpers.export(exports, "templateJoin", ()=>d);
const t = (t)=>{
    var n;
    const r = Object.assign({
        default: void 0
    }, t);
    return null !== (n = r.default) && void 0 !== n ? n : r;
};
function n(t) {
    return null != t && !Array.isArray(t) && "object" == typeof t;
}
function r(t) {
    return "string" == typeof t || "object" == typeof t && "[object String]" === Object.prototype.toString.call(t);
}
function e(t) {
    return n(t) && "[object Map]" === Object.prototype.toString.call(t);
}
function o(t) {
    return n(t) && "[object Set]" === Object.prototype.toString.call(t);
}
function u(t) {
    return void 0 === t;
}
function c(t) {
    return null == t;
}
function i(t) {
    if (null == t) return !0;
    if (n(t) && (e(t) || o(t))) return !t.size;
    if (n(t) && (r(t) || Array.isArray(t))) return !t.length;
    for(const n in t)if (s(t, n)) return !1;
    return !0;
}
function f(t) {
    return Array.isArray(t) && i(t);
}
function l(...t) {
    return t.every(f);
}
function a(t) {
    return n(t) && i(t);
}
function p(...t) {
    return t.every(a);
}
function y(t) {
    return r(t) ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}
function s(t, n) {
    return null != t && Object.prototype.hasOwnProperty.call(t, n);
}
function b(t) {
    return "function" == typeof t;
}
const j = (t, n)=>n ? `${t}--${n}` : "", g = (t, n, r)=>r ? `${t}--${n}` : "";
function A(t) {
    return b(t);
}
function d(t, n) {
    return t.reduce((t, e)=>`${t}${r(e) ? n(e) : ""}`, "");
}
function v(...t) {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1FkDX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCustomFormFields", ()=>c);
parcelHelpers.export(exports, "getDefaultFormFields", ()=>a);
parcelHelpers.export(exports, "getFormFields", ()=>m);
parcelHelpers.export(exports, "getSortedFormFields", ()=>b);
parcelHelpers.export(exports, "removeOrderKeys", ()=>j);
var _userMjs = require("../../../types/authenticator/user.mjs");
var _attributesMjs = require("../../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../../types/primitives/componentClassName.mjs");
var _actorMjs = require("../actor.mjs");
var _constantsMjs = require("../constants.mjs");
var _defaultsMjs = require("./defaults.mjs");
var _utilMjs = require("./util.mjs");
const a = (s, t)=>(0, (0, _defaultsMjs.defaultFormFieldsGetters)[s])(t), c = (r, i)=>{
    var o, a;
    const c = null === (a = null === (o = (0, _actorMjs.getActorContext)(i)) || void 0 === o ? void 0 : o.formFields) || void 0 === a ? void 0 : a[r];
    return c && 0 !== Object.keys(c).length ? Object.entries(c).reduce((t, [o, a])=>{
        if ("signIn" !== r && "resetPassword" !== r || "username" !== o) {
            if ((0, _attributesMjs.isAuthFieldsWithDefaults)(o)) {
                const s = (0, _constantsMjs.defaultFormFieldOptions)[o], r = Object.assign(Object.assign({}, s), a);
                return Object.assign(Object.assign({}, t), {
                    [o]: r
                });
            }
            return Object.assign(Object.assign({}, t), {
                [o]: a
            });
        }
        {
            const s = (0, _defaultsMjs.getAliasDefaultFormField)(i), e = Object.assign(Object.assign({}, s), a);
            return Object.assign(Object.assign({}, t), {
                [o]: e
            });
        }
    }, {}) : {};
}, m = (s, t)=>{
    const e = a(s, t), r = c(s, t), n = Object.assign(Object.assign({}, e), r);
    return delete n.QR, (0, _utilMjs.applyTranslation)(n);
}, j = (s)=>s.map((s)=>[
            s[0],
            Object.assign(Object.assign({}, s[1]), {
                order: void 0
            })
        ]), b = (s, t)=>{
    const e = m(s, t);
    return j((0, _utilMjs.sortFormFields)(e));
};

},{"../../../types/authenticator/user.mjs":"aZbQw","../../../types/authenticator/attributes.mjs":"2ngIN","../../../types/primitives/componentClassName.mjs":"62ykl","../actor.mjs":"b1Die","../constants.mjs":"ku5eE","./defaults.mjs":"a6cbS","./util.mjs":"cvLf4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a6cbS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultFormFieldsGetters", ()=>i);
parcelHelpers.export(exports, "getAliasDefaultFormField", ()=>a);
var _actorMjs = require("../actor.mjs");
var _constantsMjs = require("../constants.mjs");
var _contextMjs = require("../context.mjs");
var _formMjs = require("../form.mjs");
const n = (s, r)=>{
    const { country_code: t } = (0, _actorMjs.getActorContext)(s);
    let n = (0, _constantsMjs.defaultFormFieldOptions)[r];
    const { type: a } = n;
    return "tel" === a && (n = Object.assign(Object.assign({}, n), {
        dialCode: t
    })), n;
}, a = (o)=>{
    const s = (0, _contextMjs.getPrimaryAlias)(o);
    return Object.assign(Object.assign({}, n(o, s)), {
        autocomplete: "username"
    });
}, c = (o)=>({
        confirmation_code: Object.assign(Object.assign({}, n(o, "confirmation_code")), {
            label: "Code *",
            placeholder: "Code"
        })
    }), i = {
    signIn: (o)=>({
            username: Object.assign({}, a(o)),
            password: Object.assign(Object.assign({}, n(o, "password")), {
                autocomplete: "current-password"
            })
        }),
    signUp: (o)=>{
        const { loginMechanisms: s, signUpAttributes: e } = o.context.config, c = (0, _contextMjs.getPrimaryAlias)(o), i = Array.from(new Set([
            ...s,
            "password",
            "confirm_password",
            ...e
        ])), d = {};
        for (const s of i)if ((0, _formMjs.isAuthFieldWithDefaults)(s)) {
            const e = s === c ? a(o) : n(o, s);
            d[s] = Object.assign({}, e);
        } else console.debug(`Authenticator does not have a default implementation for ${s}. Customize SignUp FormFields to add your own.`);
        return d;
    },
    confirmSignUp: (o)=>({
            confirmation_code: Object.assign(Object.assign({}, n(o, "confirmation_code")), {
                placeholder: "Enter your code"
            })
        }),
    confirmSignIn: c,
    forceNewPassword: (o)=>{
        const e = (0, _actorMjs.getActorState)(o), { requiredAttributes: r } = e.context, a = Array.from(new Set([
            "password",
            "confirm_password",
            ...r
        ])), c = {};
        for (const s of a)(0, _formMjs.isAuthFieldWithDefaults)(s) ? c[s] = Object.assign({}, n(o, s)) : console.debug(`Authenticator does not have a default implementation for ${s}. Customize ForceNewPassword FormFields to add your own.`);
        return c;
    },
    resetPassword: (o)=>{
        const s = (0, _contextMjs.getPrimaryAlias)(o), { label: t } = (0, _constantsMjs.defaultFormFieldOptions)[s];
        return {
            username: Object.assign(Object.assign({}, a(o)), {
                label: `Enter your ${t.toLowerCase()}`,
                placeholder: `Enter your ${t.toLowerCase()}`
            })
        };
    },
    confirmResetPassword: (o)=>Object.assign(Object.assign({}, c(o)), {
            password: Object.assign(Object.assign({}, n(o, "password")), {
                label: "New Password",
                placeholder: "New Password"
            }),
            confirm_password: Object.assign(Object.assign({}, n(o, "confirm_password")), {
                label: "Confirm Password",
                placeholder: "Confirm Password"
            })
        }),
    confirmVerifyUser: c,
    setupTOTP: c
};

},{"../actor.mjs":"b1Die","../constants.mjs":"ku5eE","../context.mjs":"ksAim","../form.mjs":"dVV3Q","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cvLf4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyTranslation", ()=>r);
parcelHelpers.export(exports, "sortFormFields", ()=>o);
var _translationsMjs = require("../../../i18n/translations.mjs");
const r = (r)=>{
    const o = Object.assign({}, r);
    for (const [t, s] of Object.entries(r)){
        const { label: r, placeholder: n } = s;
        o[t] = Object.assign(Object.assign({}, s), {
            label: r ? (0, _translationsMjs.translate)(r) : void 0,
            placeholder: n ? (0, _translationsMjs.translate)(n) : void 0
        });
    }
    return o;
}, o = (e)=>Object.entries(e).sort((e, r)=>(e[1].order || Number.MAX_VALUE) - (r[1].order || Number.MAX_VALUE)).filter((e)=>void 0 !== e[1]);

},{"../../../i18n/translations.mjs":"jSmFc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c4Omk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticatorTextUtil", ()=>n);
var _translationsMjs = require("../../i18n/translations.mjs");
const T = {
    amazon: "Amazon",
    apple: "Apple",
    facebook: "Facebook",
    google: "Google"
}, n = {
    getBackToSignInText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).BACK_SIGN_IN),
    getChangePasswordText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CHANGE_PASSWORD),
    getChangingText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CHANGING_PASSWORD),
    getConfirmText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CONFIRM),
    getConfirmingText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CONFIRMING),
    getCopyText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).UPPERCASE_COPY),
    getHidePasswordText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).HIDE_PASSWORD),
    getLoadingText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).LOADING),
    getOrText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).OR),
    getResendCodeText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).RESEND_CODE),
    getSendCodeText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SEND_CODE),
    getSendingText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SENDING),
    getShowPasswordText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SHOW_PASSWORD),
    getSubmitText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SUBMIT),
    getSubmittingText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SUBMITTING),
    getSignInTabText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SIGN_IN_TAB),
    getSignUpTabText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CREATE_ACCOUNT),
    getForgotPasswordText: (T)=>(0, _translationsMjs.translate)(T ? (0, _translationsMjs.DefaultTexts).FORGOT_PASSWORD : (0, _translationsMjs.DefaultTexts).FORGOT_YOUR_PASSWORD),
    getSigningInText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SIGNING_IN_BUTTON),
    getSignInText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SIGN_IN_BUTTON),
    getCreatingAccountText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CREATING_ACCOUNT),
    getCreateAccountText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CREATE_ACCOUNT),
    getDeliveryMessageText: (T)=>{
        const { DeliveryMedium: n, Destination: g } = null != T ? T : {}, i = "EMAIL" === n, S = "SMS" === n, o = (0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CODE_ARRIVAL);
        if (!i && !S) return `${(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CODE_SENT)}. ${o}.`;
        return `${(0, _translationsMjs.translate)(i ? (0, _translationsMjs.DefaultTexts).CODE_EMAILED : (0, _translationsMjs.DefaultTexts).CODE_TEXTED)} ${g}. ${o}.`;
    },
    getDeliveryMethodText: (T)=>{
        const { DeliveryMedium: n } = null != T ? T : {}, g = "EMAIL" === n;
        return (0, _translationsMjs.translate)(g || "SMS" !== n ? g ? (0, _translationsMjs.DefaultTexts).WE_EMAILED : (0, _translationsMjs.DefaultTexts).WE_TEXTED : (0, _translationsMjs.DefaultTexts).WE_SENT_CODE);
    },
    getChallengeText: (T)=>{
        switch(T){
            case "SMS_MFA":
                return (0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CONFIRM_SMS);
            case "SOFTWARE_TOKEN_MFA":
                return (0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).CONFIRM_TOTP);
            default:
                throw new Error(`${(0, _translationsMjs.translate)("Unexpected challengeName encountered in ConfirmSignIn:")} ${T}`);
        }
    },
    getResetYourPasswordText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).RESET_PASSWORD),
    getSetupTOTPText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SETUP_TOTP),
    getSetupTOTPInstructionsText: ()=>(0, _translationsMjs.translate)("Copy and paste the secret key below into an authenticator app and then enter the code in the text field below."),
    getCopiedText: ()=>(0, _translationsMjs.translate)("COPIED"),
    getSignInWithFederationText: (t, n)=>(0, _translationsMjs.translate)(`Sign ${"signIn" === t ? "In" : "Up"} with ${T[n]}`),
    getSkipText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).SKIP),
    getVerifyText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).VERIFY),
    getVerifyContactText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).VERIFY_CONTACT),
    getAccountRecoveryInfoText: ()=>(0, _translationsMjs.translate)((0, _translationsMjs.DefaultTexts).VERIFY_HEADING),
    getInvalidEmailText: ()=>(0, _translationsMjs.translate)("Please enter a valid email"),
    getRequiredFieldText: ()=>(0, _translationsMjs.translate)("This field is required")
};

},{"../../i18n/translations.mjs":"jSmFc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2PkvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changePassword", ()=>o);
parcelHelpers.export(exports, "deleteUser", ()=>d);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _utilsMjs = require("../utils.mjs");
const t = (0, _utilsMjs.getLogger)("Auth"), o = ({ user: s, currentPassword: o, newPassword: d })=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        try {
            return t.debug("calling Auth.changePassword"), yield (0, _awsAmplify.Auth).changePassword(s, o, d), t.debug("Auth.changePassword was successful"), Promise.resolve();
        } catch (e) {
            return t.debug("Auth.changePassword failed with error", e), Promise.reject(e);
        }
    }), d = ()=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        try {
            return t.debug("calling Auth.deleteUser"), yield (0, _awsAmplify.Auth).deleteUser(), t.debug("Auth.deleteUser was successful"), Promise.resolve();
        } catch (e) {
            return t.debug("Auth.deleteUser failed with error", e), Promise.reject(e);
        }
    });

},{"tslib":"86BcK","aws-amplify":"75VoS","../utils.mjs":"5hKBo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5hKBo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLogger", ()=>o);
var _awsAmplify = require("aws-amplify");
const o = (o)=>new (0, _awsAmplify.Logger)(`AmplifyUI:${o}`);

},{"aws-amplify":"75VoS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k9HMx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultConfirmPasswordValidators", ()=>l);
parcelHelpers.export(exports, "getDefaultPasswordValidators", ()=>u);
parcelHelpers.export(exports, "getHasMinLength", ()=>t);
parcelHelpers.export(exports, "getMatchesConfirmPassword", ()=>d);
parcelHelpers.export(exports, "getPasswordRequirement", ()=>a);
parcelHelpers.export(exports, "hasLowerCase", ()=>o);
parcelHelpers.export(exports, "hasNumber", ()=>n);
parcelHelpers.export(exports, "hasSpecialChar", ()=>i);
parcelHelpers.export(exports, "hasUpperCase", ()=>r);
parcelHelpers.export(exports, "runFieldValidators", ()=>h);
parcelHelpers.export(exports, "shouldValidate", ()=>c);
var _awsAmplify = require("aws-amplify");
var _userMjs = require("../../types/authenticator/user.mjs");
var _attributesMjs = require("../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../types/primitives/componentClassName.mjs");
var _translationsMjs = require("../../i18n/translations.mjs");
var _utilsMjs = require("../authenticator/utils.mjs");
const a = ()=>{
    const s = (0, _awsAmplify.Amplify).configure(), a = null == s ? void 0 : s.aws_cognito_password_protection_settings;
    if (!a) return null;
    const { passwordPolicyCharacters: t = [], passwordPolicyMinLength: o } = a;
    return {
        minLength: o,
        needsLowerCase: t.includes("REQUIRES_LOWERCASE"),
        needsUpperCase: t.includes("REQUIRES_UPPERCASE"),
        needsNumber: t.includes("REQUIRES_NUMBERS"),
        needsSpecialChar: t.includes("REQUIRES_SYMBOLS")
    };
}, t = (e)=>({
        validationMode: "onTouched",
        validator: (s)=>s.length >= e,
        message: `Password must have at least ${e} characters`
    }), o = {
    validationMode: "onTouched",
    validator: (e)=>/[a-z]/.test(e),
    message: "Password must have lower case letters"
}, r = {
    validationMode: "onTouched",
    validator: (e)=>/[A-Z]/.test(e),
    message: "Password must have upper case letters"
}, n = {
    validationMode: "onTouched",
    validator: (e)=>/[0-9]/.test(e),
    message: "Password must have numbers"
}, i = {
    validationMode: "onTouched",
    validator: (e)=>(0, _utilsMjs.hasSpecialChars)(e),
    message: "Password must have special characters"
}, d = (e)=>({
        validationMode: "onTouched",
        validator: (s)=>e === s,
        message: "Your passwords must match"
    }), u = ()=>{
    const e = a();
    if (!e) return [];
    const s = [], { minLength: d, needsLowerCase: u, needsUpperCase: l, needsNumber: c, needsSpecialChar: h } = e;
    return d && s.push(t(d)), u && s.push(o), l && s.push(r), c && s.push(n), h && s.push(i), s;
}, l = (e)=>[
        d(e)
    ], c = ({ validationMode: e, eventType: s, hasBlurred: a })=>{
    switch(e){
        case "onBlur":
            return "blur" === s;
        case "onChange":
            return "change" === s;
        case "onTouched":
            return "blur" === s || a;
    }
}, h = ({ value: e, validators: s, eventType: a, hasBlurred: t })=>e ? s.reduce((s, o)=>{
        const { validator: r, validationMode: n, message: i } = o;
        if (c({
            validationMode: n,
            eventType: a,
            hasBlurred: t
        })) return !r(e) ? [
            ...s,
            i
        ] : s;
        return s;
    }, []) : [];

},{"aws-amplify":"75VoS","../../types/authenticator/user.mjs":"aZbQw","../../types/authenticator/attributes.mjs":"2ngIN","../../types/primitives/componentClassName.mjs":"62ykl","../../i18n/translations.mjs":"jSmFc","../authenticator/utils.mjs":"l02QH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vEul":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkMaxSize", ()=>o);
parcelHelpers.export(exports, "humanFileSize", ()=>a);
parcelHelpers.export(exports, "isValidExtension", ()=>i);
parcelHelpers.export(exports, "returnAcceptedFiles", ()=>s);
parcelHelpers.export(exports, "uploadFile", ()=>l);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _translationsMjs = require("../../../../i18n/translations.mjs");
function l(t) {
    var { file: l, fileName: a, level: o = "private", progressCallback: s, errorCallback: i, completeCallback: n, isResumable: p = !1, provider: c } = t, b = (0, _tslib.__rest)(t, [
        "file",
        "fileName",
        "level",
        "progressCallback",
        "errorCallback",
        "completeCallback",
        "isResumable",
        "provider"
    ]);
    const m = l.type || "binary/octet-stream";
    return !0 === p ? (0, _awsAmplify.Storage).put(a, l, Object.assign({
        level: o,
        resumable: p,
        progressCallback: s,
        errorCallback: i,
        completeCallback: n,
        contentType: m,
        provider: c
    }, b)) : (0, _awsAmplify.Storage).put(a, l, Object.assign({
        level: o,
        resumable: !1,
        progressCallback: s,
        contentType: m,
        provider: c
    }, b)).then(n, i);
}
function a(e, r = !1, t = 1) {
    const l = r ? 1e3 : 1024;
    if (Math.abs(e) < l) return e + " B";
    const a = r ? [
        "kB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ] : [
        "KiB",
        "MiB",
        "GiB",
        "TiB",
        "PiB",
        "EiB",
        "ZiB",
        "YiB"
    ];
    let o = -1;
    const s = Math.pow(10, t);
    do e /= l, ++o;
    while (Math.round(Math.abs(e) * s) / s >= l && o < a.length - 1);
    return e.toFixed(t) + " " + a[o];
}
const o = (e, r)=>e && r.size > e ? (0, _translationsMjs.translate)("File size must be below ") + a(e, !0) : null, s = (e, r)=>e.filter((e)=>{
        const t = e.name || "", l = (e.type || "").toLowerCase(), a = l.replace(/\/.*$/, "");
        return r.some((e)=>{
            const r = e.trim().toLowerCase();
            return "." === r.charAt(0) ? t.toLowerCase().endsWith(r) : r.endsWith("/*") ? a === r.replace(/\/.*$/, "") : l === r;
        });
    }), i = (e, r)=>{
    const t = e.split(".").pop();
    return r.split(".").pop() === t;
};

},{"tslib":"86BcK","aws-amplify":"75VoS","../../../../i18n/translations.mjs":"jSmFc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gBWIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAuthenticatorMachine", ()=>v);
var _tslib = require("tslib");
var _xstate = require("xstate");
var _actionsMjs = require("./actions.mjs");
var _signInMjs = require("./actors/signIn.mjs");
var _signOutMjs = require("./actors/signOut.mjs");
var _resetPasswordMjs = require("./actors/resetPassword.mjs");
var _defaultServicesMjs = require("./defaultServices.mjs");
var _signUpMjs = require("./signUp.mjs");
const { choose: g } = (0, _xstate.actions);
function v() {
    return (0, _xstate.createMachine)({
        id: "authenticator",
        initial: "idle",
        context: {
            user: void 0,
            config: {},
            services: (0, _defaultServicesMjs.defaultServices),
            actorRef: void 0,
            hasSetup: !1
        },
        predictableActionArguments: !0,
        states: {
            idle: {
                invoke: {
                    src: "getCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "authenticated"
                    },
                    onError: {
                        target: "setup"
                    }
                }
            },
            setup: {
                initial: "waitConfig",
                states: {
                    waitConfig: {
                        on: {
                            INIT: {
                                actions: [
                                    "configure",
                                    "setHasSetup"
                                ],
                                target: "applyConfig"
                            }
                        }
                    },
                    applyConfig: {
                        invoke: {
                            src: "getAmplifyConfig",
                            onDone: {
                                actions: "applyAmplifyConfig",
                                target: "goToInitialState"
                            }
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                target: "#authenticator.signUp",
                                cond: "isInitialStateSignUp"
                            },
                            {
                                target: "#authenticator.resetPassword",
                                cond: "isInitialStateResetPassword"
                            },
                            {
                                target: "#authenticator.signIn"
                            }
                        ]
                    }
                }
            },
            signIn: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignInActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignInActor"
                    }
                },
                on: {
                    SIGN_UP: "signUp",
                    RESET_PASSWORD: "resetPassword",
                    "done.invoke.signInActor": [
                        {
                            target: "signUp",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToSignUp"
                        },
                        {
                            target: "resetPassword",
                            actions: "setActorDoneData",
                            cond: "shouldRedirectToResetPassword"
                        },
                        {
                            target: "authenticated",
                            actions: "setActorDoneData"
                        }
                    ]
                }
            },
            signUp: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignUpActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopSignUpActor"
                    },
                    autoSignIn: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: "#authenticator.authenticated",
                            onError: "#authenticator.setup.goToInitialState"
                        }
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.signUpActor": {
                        target: "#authenticator.signIn",
                        actions: "setActorDoneData",
                        cond: "shouldAutoSignIn"
                    }
                }
            },
            resetPassword: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnResetPasswordActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: "stopResetPasswordActor"
                    }
                },
                on: {
                    SIGN_IN: "signIn",
                    "done.invoke.resetPasswordActor": {
                        target: "signIn",
                        actions: "setActorDoneData"
                    }
                }
            },
            signOut: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignOutActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: [
                            "stopSignOutActor",
                            "clearUser"
                        ]
                    }
                },
                on: {
                    "done.invoke.signOutActor": [
                        {
                            target: "setup",
                            cond: "shouldSetup"
                        },
                        {
                            target: "setup.goToInitialState"
                        }
                    ]
                }
            },
            authenticated: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: "refreshUser"
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: "getCurrentUser",
                            onDone: {
                                actions: "setUser",
                                target: "idle"
                            },
                            onError: {
                                target: "#authenticator.signOut"
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: "signOut"
                }
            }
        },
        on: {
            CHANGE: {
                actions: "forwardToActor"
            },
            BLUR: {
                actions: "forwardToActor"
            },
            SUBMIT: {
                actions: "forwardToActor"
            },
            FEDERATED_SIGN_IN: {
                actions: "forwardToActor"
            },
            AUTO_SIGN_IN: {
                actions: "forwardToActor"
            },
            RESEND: {
                actions: "forwardToActor"
            },
            SIGN_IN: {
                actions: "forwardToActor"
            },
            SKIP: {
                actions: "forwardToActor"
            }
        }
    }, {
        actions: {
            forwardToActor: g([
                {
                    cond: "hasActor",
                    actions: (0, _xstate.forwardTo)((t)=>t.actorRef)
                }
            ]),
            setUser: (0, _xstate.assign)({
                user: (t, o)=>o.data
            }),
            setActorDoneData: (0, _xstate.assign)({
                actorDoneData: (t, o)=>{
                    var i, n;
                    return {
                        authAttributes: Object.assign({}, null === (i = o.data) || void 0 === i ? void 0 : i.authAttributes),
                        intent: null === (n = o.data) || void 0 === n ? void 0 : n.intent
                    };
                },
                user: (t, o)=>{
                    var i;
                    return null === (i = o.data) || void 0 === i ? void 0 : i.user;
                }
            }),
            clearUser: (0, _xstate.assign)({
                user: void 0
            }),
            clearActorDoneData: (0, _xstate.assign)({
                actorDoneData: void 0
            }),
            applyAmplifyConfig: (0, _xstate.assign)({
                config (t, o) {
                    var i, n, e, r, s, a, c, d, u;
                    const l = null !== (n = null === (i = o.data.aws_cognito_username_attributes) || void 0 === i ? void 0 : i.map((t)=>t.toLowerCase())) && void 0 !== n ? n : [], g = null !== (r = null === (e = o.data.aws_cognito_verification_mechanisms) || void 0 === e ? void 0 : e.map((t)=>t.toLowerCase())) && void 0 !== r ? r : [], v = null !== (a = null === (s = o.data.aws_cognito_signup_attributes) || void 0 === s ? void 0 : s.map((t)=>t.toLowerCase())) && void 0 !== a ? a : [], A = null !== (d = null === (c = o.data.aws_cognito_social_providers) || void 0 === c ? void 0 : c.map((t)=>t.toLowerCase())) && void 0 !== d ? d : [], f = o.data.aws_cognito_password_protection_settings || {};
                    0 === l.length && l.push("username");
                    const { loginMechanisms: w, signUpAttributes: S, socialProviders: m, initialState: h, formFields: D } = t.config;
                    return {
                        loginMechanisms: null != w ? w : l,
                        formFields: null !== (u = p(D)) && void 0 !== u ? u : {},
                        passwordSettings: f,
                        signUpAttributes: null != S ? S : Array.from(new Set([
                            ...g,
                            ...v
                        ])),
                        socialProviders: null != m ? m : A.sort(),
                        initialState: h
                    };
                }
            }),
            spawnSignInActor: (0, _xstate.assign)({
                actorRef: (t, o)=>{
                    var i, n, r, s, c, d, u;
                    const { services: l } = t, g = (0, _signInMjs.signInActor)({
                        services: l
                    }).withContext({
                        authAttributes: null !== (n = null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.authAttributes) && void 0 !== n ? n : {},
                        user: t.user,
                        intent: null === (r = t.actorDoneData) || void 0 === r ? void 0 : r.intent,
                        country_code: "+1",
                        formValues: {},
                        touched: {},
                        validationError: {},
                        passwordSettings: null === (s = t.config) || void 0 === s ? void 0 : s.passwordSettings,
                        loginMechanisms: null === (c = t.config) || void 0 === c ? void 0 : c.loginMechanisms,
                        socialProviders: null === (d = t.config) || void 0 === d ? void 0 : d.socialProviders,
                        formFields: null === (u = t.config) || void 0 === u ? void 0 : u.formFields
                    });
                    return (0, _xstate.spawn)(g, {
                        name: "signInActor"
                    });
                }
            }),
            spawnSignUpActor: (0, _xstate.assign)({
                actorRef: (t, o)=>{
                    var i, n, r, s, a, c, d;
                    const { services: u } = t, g = (0, _signUpMjs.createSignUpMachine)({
                        services: u
                    }).withContext({
                        authAttributes: null !== (n = null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.authAttributes) && void 0 !== n ? n : {},
                        country_code: "+1",
                        intent: null === (r = t.actorDoneData) || void 0 === r ? void 0 : r.intent,
                        formValues: {},
                        touched: {},
                        validationError: {},
                        loginMechanisms: null === (s = t.config) || void 0 === s ? void 0 : s.loginMechanisms,
                        socialProviders: null === (a = t.config) || void 0 === a ? void 0 : a.socialProviders,
                        formFields: null === (c = t.config) || void 0 === c ? void 0 : c.formFields,
                        passwordSettings: null === (d = t.config) || void 0 === d ? void 0 : d.passwordSettings
                    });
                    return (0, _xstate.spawn)(g, {
                        name: "signUpActor"
                    });
                }
            }),
            spawnResetPasswordActor: (0, _xstate.assign)({
                actorRef: (t, o)=>{
                    var i, n, r, s, a;
                    const { services: c } = t, u = (0, _resetPasswordMjs.resetPasswordActor)({
                        services: c
                    }).withContext({
                        formValues: {},
                        touched: {},
                        intent: null === (i = t.actorDoneData) || void 0 === i ? void 0 : i.intent,
                        username: null === (r = null === (n = t.actorDoneData) || void 0 === n ? void 0 : n.authAttributes) || void 0 === r ? void 0 : r.username,
                        formFields: null === (s = t.config) || void 0 === s ? void 0 : s.formFields,
                        validationError: {},
                        passwordSettings: null === (a = t.config) || void 0 === a ? void 0 : a.passwordSettings
                    });
                    return (0, _xstate.spawn)(u, {
                        name: "resetPasswordActor"
                    });
                }
            }),
            spawnSignOutActor: (0, _xstate.assign)({
                actorRef: (t)=>{
                    const o = (0, _signOutMjs.signOutActor).withContext({
                        user: t.user
                    });
                    return (0, _xstate.spawn)(o, {
                        name: "signOutActor"
                    });
                }
            }),
            stopSignInActor: (0, _actionsMjs.stopActor)("signInActor"),
            stopSignUpActor: (0, _actionsMjs.stopActor)("signUpActor"),
            stopResetPasswordActor: (0, _actionsMjs.stopActor)("resetPasswordActor"),
            stopSignOutActor: (0, _actionsMjs.stopActor)("signOutActor"),
            configure: (0, _xstate.assign)((o, i)=>{
                const n = i.data, { services: e } = n, r = (0, _tslib.__rest)(n, [
                    "services"
                ]);
                return {
                    services: Object.assign(Object.assign({}, (0, _defaultServicesMjs.defaultServices)), e),
                    config: r
                };
            }),
            setHasSetup: (0, _xstate.assign)({
                hasSetup: !0
            })
        },
        guards: {
            isInitialStateSignUp: (t)=>"signUp" === t.config.initialState,
            isInitialStateResetPassword: (t)=>"resetPassword" === t.config.initialState,
            shouldRedirectToSignUp: (t, o)=>{
                var i;
                return "confirmSignUp" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent);
            },
            shouldRedirectToResetPassword: (t, o)=>{
                var i;
                return "confirmPasswordReset" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent);
            },
            shouldAutoSignIn: (t, o)=>{
                var i, n;
                return "autoSignIn" === (null === (i = o.data) || void 0 === i ? void 0 : i.intent) || "autoSignInSubmit" === (null === (n = o.data) || void 0 === n ? void 0 : n.intent);
            },
            shouldSetup: (t)=>!1 === t.hasSetup,
            hasActor: (t)=>!!t.actorRef
        },
        services: {
            getCurrentUser: (t, o)=>t.services.getCurrentUser(),
            getAmplifyConfig: (t, o)=>t.services.getAmplifyConfig()
        }
    });
}
function p(t) {
    return t && Object.keys(t).forEach((o)=>{
        Object.keys(t[o]).forEach((i)=>{
            let n = t[o][i];
            n.required = n.isRequired;
        });
    }), t;
}

},{"tslib":"86BcK","xstate":"3RMsL","./actions.mjs":"1nOrP","./actors/signIn.mjs":"2tVOq","./actors/signOut.mjs":"20SXQ","./actors/resetPassword.mjs":"kdZ2m","./defaultServices.mjs":"d5mT9","./signUp.mjs":"bdW5v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3RMsL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toActorRef", ()=>(0, _actorJs.toActorRef));
parcelHelpers.export(exports, "Interpreter", ()=>(0, _interpreterJs.Interpreter));
parcelHelpers.export(exports, "InterpreterStatus", ()=>(0, _interpreterJs.InterpreterStatus));
parcelHelpers.export(exports, "interpret", ()=>(0, _interpreterJs.interpret));
parcelHelpers.export(exports, "spawn", ()=>(0, _interpreterJs.spawn));
parcelHelpers.export(exports, "Machine", ()=>(0, _machineJs.Machine));
parcelHelpers.export(exports, "createMachine", ()=>(0, _machineJs.createMachine));
parcelHelpers.export(exports, "mapState", ()=>(0, _mapStateJs.mapState));
parcelHelpers.export(exports, "matchState", ()=>(0, _matchJs.matchState));
parcelHelpers.export(exports, "createSchema", ()=>(0, _schemaJs.createSchema));
parcelHelpers.export(exports, "t", ()=>(0, _schemaJs.t));
parcelHelpers.export(exports, "State", ()=>(0, _stateJs.State));
parcelHelpers.export(exports, "StateNode", ()=>(0, _stateNodeJs.StateNode));
parcelHelpers.export(exports, "spawnBehavior", ()=>(0, _behaviorsJs.spawnBehavior));
parcelHelpers.export(exports, "ActionTypes", ()=>(0, _typesJs.ActionTypes));
parcelHelpers.export(exports, "SpecialTargets", ()=>(0, _typesJs.SpecialTargets));
parcelHelpers.export(exports, "matchesState", ()=>(0, _utilsJs.matchesState));
parcelHelpers.export(exports, "toEventObject", ()=>(0, _utilsJs.toEventObject));
parcelHelpers.export(exports, "toObserver", ()=>(0, _utilsJs.toObserver));
parcelHelpers.export(exports, "toSCXMLEvent", ()=>(0, _utilsJs.toSCXMLEvent));
parcelHelpers.export(exports, "actions", ()=>_actionsJs);
parcelHelpers.export(exports, "assign", ()=>assign);
parcelHelpers.export(exports, "cancel", ()=>cancel);
parcelHelpers.export(exports, "choose", ()=>choose);
parcelHelpers.export(exports, "doneInvoke", ()=>doneInvoke);
parcelHelpers.export(exports, "forwardTo", ()=>forwardTo);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pure", ()=>pure);
parcelHelpers.export(exports, "raise", ()=>raise);
parcelHelpers.export(exports, "send", ()=>send);
parcelHelpers.export(exports, "sendParent", ()=>sendParent);
parcelHelpers.export(exports, "sendTo", ()=>sendTo);
parcelHelpers.export(exports, "sendUpdate", ()=>sendUpdate);
parcelHelpers.export(exports, "stop", ()=>stop);
var _actionsJs = require("./actions.js");
var _actorJs = require("./Actor.js");
var _interpreterJs = require("./interpreter.js");
var _machineJs = require("./Machine.js");
var _mapStateJs = require("./mapState.js");
var _matchJs = require("./match.js");
var _schemaJs = require("./schema.js");
var _stateJs = require("./State.js");
var _stateNodeJs = require("./StateNode.js");
var _behaviorsJs = require("./behaviors.js");
var _typesJs = require("./types.js");
var _utilsJs = require("./utils.js");
var assign = (0, _actionsJs.assign), cancel = (0, _actionsJs.cancel), send = (0, _actionsJs.send), sendTo = (0, _actionsJs.sendTo), sendParent = (0, _actionsJs.sendParent), sendUpdate = (0, _actionsJs.sendUpdate), forwardTo = (0, _actionsJs.forwardTo), doneInvoke = (0, _actionsJs.doneInvoke), raise = (0, _actionsJs.raise), log = (0, _actionsJs.log), pure = (0, _actionsJs.pure), choose = (0, _actionsJs.choose), stop = (0, _actionsJs.stop);

},{"./actions.js":"ev4Zc","./Actor.js":false,"./interpreter.js":"7gWBN","./Machine.js":"lVA6D","./mapState.js":false,"./match.js":false,"./schema.js":false,"./State.js":"gv1oM","./StateNode.js":false,"./behaviors.js":false,"./types.js":false,"./utils.js":"gdjQg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ev4Zc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actionTypes", ()=>_actionTypesJs);
parcelHelpers.export(exports, "after", ()=>after);
parcelHelpers.export(exports, "assign", ()=>assign);
parcelHelpers.export(exports, "cancel", ()=>cancel);
parcelHelpers.export(exports, "choose", ()=>choose);
parcelHelpers.export(exports, "done", ()=>done);
parcelHelpers.export(exports, "doneInvoke", ()=>doneInvoke);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "escalate", ()=>escalate);
parcelHelpers.export(exports, "forwardTo", ()=>forwardTo);
parcelHelpers.export(exports, "getActionFunction", ()=>getActionFunction);
parcelHelpers.export(exports, "initEvent", ()=>initEvent);
parcelHelpers.export(exports, "isActionObject", ()=>isActionObject);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pure", ()=>pure);
parcelHelpers.export(exports, "raise", ()=>raise);
parcelHelpers.export(exports, "resolveActions", ()=>resolveActions);
parcelHelpers.export(exports, "resolveLog", ()=>resolveLog);
parcelHelpers.export(exports, "resolveRaise", ()=>resolveRaise);
parcelHelpers.export(exports, "resolveSend", ()=>resolveSend);
parcelHelpers.export(exports, "resolveStop", ()=>resolveStop);
parcelHelpers.export(exports, "respond", ()=>respond);
parcelHelpers.export(exports, "send", ()=>send);
parcelHelpers.export(exports, "sendParent", ()=>sendParent);
parcelHelpers.export(exports, "sendTo", ()=>sendTo);
parcelHelpers.export(exports, "sendUpdate", ()=>sendUpdate);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toActionObject", ()=>toActionObject);
parcelHelpers.export(exports, "toActionObjects", ()=>toActionObjects);
parcelHelpers.export(exports, "toActivityDefinition", ()=>toActivityDefinition);
var _tslibJs = require("./_virtual/_tslib.js");
var _typesJs = require("./types.js");
var _actionTypesJs = require("./actionTypes.js");
var _utilsJs = require("./utils.js");
var _environmentJs = require("./environment.js");
var initEvent = /*#__PURE__*/ (0, _utilsJs.toSCXMLEvent)({
    type: (0, _actionTypesJs.init)
});
function getActionFunction(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function toActionObject(action, actionFunctionMap) {
    var actionObject;
    if ((0, _utilsJs.isString)(action) || typeof action === "number") {
        var exec = getActionFunction(action, actionFunctionMap);
        if ((0, _utilsJs.isFunction)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, _utilsJs.isFunction)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = getActionFunction(action.type, actionFunctionMap);
        if ((0, _utilsJs.isFunction)(exec)) actionObject = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, _tslibJs.__assign)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var toActionObjects = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, _utilsJs.isArray)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return toActionObject(subAction, actionFunctionMap);
    });
};
function toActivityDefinition(action) {
    var actionObject = toActionObject(action);
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({
        id: (0, _utilsJs.isString)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function raise(event, options) {
    return {
        type: (0, _actionTypesJs.raise),
        event: typeof event === "function" ? event : (0, _utilsJs.toEventObject)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function resolveRaise(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, _utilsJs.toSCXMLEvent)((0, _utilsJs.isFunction)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, _utilsJs.isString)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, _utilsJs.isFunction)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, _utilsJs.isFunction)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, action), {
        type: (0, _actionTypesJs.raise),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function send(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, _actionTypesJs.send),
        event: (0, _utilsJs.isFunction)(event) ? event : (0, _utilsJs.toEventObject)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, _utilsJs.isFunction)(event) ? event.name : (0, _utilsJs.getEventType)(event)
    };
}
function resolveSend(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, _utilsJs.toSCXMLEvent)((0, _utilsJs.isFunction)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, _utilsJs.isString)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, _utilsJs.isFunction)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, _utilsJs.isFunction)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, _utilsJs.isFunction)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function sendParent(event, options) {
    return send(event, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
        to: (0, _typesJs.SpecialTargets).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function sendTo(actor, event, options) {
    return send(event, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function sendUpdate() {
    return sendParent((0, _actionTypesJs.update));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function respond(event, options) {
    return send(event, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function log(expr, label) {
    if (expr === void 0) expr = defaultLogExpr;
    return {
        type: (0, _actionTypesJs.log),
        label: label,
        expr: expr
    };
}
var resolveLog = function(action, ctx, _event) {
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, action), {
        value: (0, _utilsJs.isString)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var cancel = function(sendId) {
    return {
        type: (0, _actionTypesJs.cancel),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function start(activity) {
    var activityDef = toActivityDefinition(activity);
    return {
        type: (0, _typesJs.ActionTypes).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function stop(actorRef) {
    var activity = (0, _utilsJs.isFunction)(actorRef) ? actorRef : toActivityDefinition(actorRef);
    return {
        type: (0, _typesJs.ActionTypes).Stop,
        activity: activity,
        exec: undefined
    };
}
function resolveStop(action, context, _event) {
    var actorRefOrString = (0, _utilsJs.isFunction)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, _typesJs.ActionTypes).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var assign = function(assignment) {
    return {
        type: (0, _actionTypesJs.assign),
        assignment: assignment
    };
};
function isActionObject(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function after(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, _typesJs.ActionTypes).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function done(id, data) {
    var type = "".concat((0, _typesJs.ActionTypes).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function doneInvoke(id, data) {
    var type = "".concat((0, _typesJs.ActionTypes).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function error(id, data) {
    var type = "".concat((0, _typesJs.ActionTypes).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function pure(getActions) {
    return {
        type: (0, _typesJs.ActionTypes).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function forwardTo(target, options) {
    if (!(0, _environmentJs.IS_PRODUCTION) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return send(function(_, event) {
        return event;
    }, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function escalate(errorData, options) {
    return sendParent(function(context, event, meta) {
        return {
            type: (0, _actionTypesJs.error),
            data: (0, _utilsJs.isFunction)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
        to: (0, _typesJs.SpecialTargets).Parent
    }));
}
function choose(conds) {
    return {
        type: (0, _typesJs.ActionTypes).Choose,
        conds: conds
    };
}
var pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, _tslibJs.__values)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, _actionTypesJs.assign)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, _utilsJs.updateContext)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, _actionTypesJs.raise:
                var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, _actionTypesJs.send:
                var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, _environmentJs.IS_PRODUCTION)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, _utilsJs.warn)(!(0, _utilsJs.isString)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, _typesJs.SpecialTargets).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, _actionTypesJs.log:
                var resolved = resolveLog(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, _actionTypesJs.choose:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, _utilsJs.toGuard)(condition.cond, machine.options.guards);
                    return !guard || (0, _utilsJs.evaluateGuard)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, _tslibJs.__read)(resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: toActionObjects((0, _utilsJs.toArray)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, _actionTypesJs.pure:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, _tslibJs.__read)(resolveActions(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: toActionObjects((0, _utilsJs.toArray)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, _actionTypesJs.stop:
                var resolved = resolveStop(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, _actionTypesJs.assign:
                updatedContext = (0, _utilsJs.updateContext)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, _tslibJs.__spreadArray)([
                                preservedContexts[contextIndex_1]
                            ], (0, _tslibJs.__read)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, _tslibJs.__values)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, _utilsJs.flatten)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}

},{"./_virtual/_tslib.js":"2SGBQ","./types.js":"hpbs4","./actionTypes.js":"2Jthd","./utils.js":"gdjQg","./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2SGBQ":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__values", ()=>__values);
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpbs4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "SpecialTargets", ()=>SpecialTargets);
var ActionTypes;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));
var SpecialTargets;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Jthd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "after", ()=>after);
parcelHelpers.export(exports, "assign", ()=>assign);
parcelHelpers.export(exports, "cancel", ()=>cancel);
parcelHelpers.export(exports, "choose", ()=>choose);
parcelHelpers.export(exports, "doneState", ()=>doneState);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "errorExecution", ()=>errorExecution);
parcelHelpers.export(exports, "errorPlatform", ()=>errorPlatform);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "invoke", ()=>invoke);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "nullEvent", ()=>nullEvent);
parcelHelpers.export(exports, "pure", ()=>pure);
parcelHelpers.export(exports, "raise", ()=>raise);
parcelHelpers.export(exports, "send", ()=>send);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "update", ()=>update);
var _typesJs = require("./types.js");
var start = (0, _typesJs.ActionTypes).Start;
var stop = (0, _typesJs.ActionTypes).Stop;
var raise = (0, _typesJs.ActionTypes).Raise;
var send = (0, _typesJs.ActionTypes).Send;
var cancel = (0, _typesJs.ActionTypes).Cancel;
var nullEvent = (0, _typesJs.ActionTypes).NullEvent;
var assign = (0, _typesJs.ActionTypes).Assign;
var after = (0, _typesJs.ActionTypes).After;
var doneState = (0, _typesJs.ActionTypes).DoneState;
var log = (0, _typesJs.ActionTypes).Log;
var init = (0, _typesJs.ActionTypes).Init;
var invoke = (0, _typesJs.ActionTypes).Invoke;
var errorExecution = (0, _typesJs.ActionTypes).ErrorExecution;
var errorPlatform = (0, _typesJs.ActionTypes).ErrorPlatform;
var error = (0, _typesJs.ActionTypes).ErrorCustom;
var update = (0, _typesJs.ActionTypes).Update;
var choose = (0, _typesJs.ActionTypes).Choose;
var pure = (0, _typesJs.ActionTypes).Pure;

},{"./types.js":"hpbs4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdjQg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvokeId", ()=>createInvokeId);
parcelHelpers.export(exports, "evaluateGuard", ()=>evaluateGuard);
parcelHelpers.export(exports, "flatten", ()=>flatten);
parcelHelpers.export(exports, "getActionType", ()=>getActionType);
parcelHelpers.export(exports, "getEventType", ()=>getEventType);
parcelHelpers.export(exports, "interopSymbols", ()=>interopSymbols);
parcelHelpers.export(exports, "isActor", ()=>isActor);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBehavior", ()=>isBehavior);
parcelHelpers.export(exports, "isBuiltInEvent", ()=>isBuiltInEvent);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isMachine", ()=>isMachine);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
parcelHelpers.export(exports, "isPromiseLike", ()=>isPromiseLike);
parcelHelpers.export(exports, "isRaisableAction", ()=>isRaisableAction);
parcelHelpers.export(exports, "isStateLike", ()=>isStateLike);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "mapContext", ()=>mapContext);
parcelHelpers.export(exports, "mapFilterValues", ()=>mapFilterValues);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "matchesState", ()=>matchesState);
parcelHelpers.export(exports, "nestedPath", ()=>nestedPath);
parcelHelpers.export(exports, "normalizeTarget", ()=>normalizeTarget);
parcelHelpers.export(exports, "partition", ()=>partition);
parcelHelpers.export(exports, "path", ()=>path);
parcelHelpers.export(exports, "pathToStateValue", ()=>pathToStateValue);
parcelHelpers.export(exports, "pathsToStateValue", ()=>pathsToStateValue);
parcelHelpers.export(exports, "reportUnhandledExceptionOnInvocation", ()=>reportUnhandledExceptionOnInvocation);
parcelHelpers.export(exports, "symbolObservable", ()=>symbolObservable);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "toArrayStrict", ()=>toArrayStrict);
parcelHelpers.export(exports, "toEventObject", ()=>toEventObject);
parcelHelpers.export(exports, "toGuard", ()=>toGuard);
parcelHelpers.export(exports, "toInvokeSource", ()=>toInvokeSource);
parcelHelpers.export(exports, "toObserver", ()=>toObserver);
parcelHelpers.export(exports, "toSCXMLEvent", ()=>toSCXMLEvent);
parcelHelpers.export(exports, "toStatePath", ()=>toStatePath);
parcelHelpers.export(exports, "toStatePaths", ()=>toStatePaths);
parcelHelpers.export(exports, "toStateValue", ()=>toStateValue);
parcelHelpers.export(exports, "toTransitionConfigArray", ()=>toTransitionConfigArray);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "updateContext", ()=>updateContext);
parcelHelpers.export(exports, "updateHistoryStates", ()=>updateHistoryStates);
parcelHelpers.export(exports, "updateHistoryValue", ()=>updateHistoryValue);
parcelHelpers.export(exports, "warn", ()=>warn);
var _tslibJs = require("./_virtual/_tslib.js");
var _typesJs = require("./types.js");
var _actionTypesJs = require("./actionTypes.js");
var _constantsJs = require("./constants.js");
var _environmentJs = require("./environment.js");
var _a;
function keys(value) {
    return Object.keys(value);
}
function matchesState(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, _constantsJs.STATE_DELIMITER);
    var parentStateValue = toStateValue(parentStateId, delimiter);
    var childStateValue = toStateValue(childStateId, delimiter);
    if (isString(childStateValue)) {
        if (isString(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if (isString(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return matchesState(parentStateValue[key], childStateValue[key]);
    });
}
function getEventType(event) {
    try {
        return isString(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function getActionType(action) {
    try {
        return isString(action) || typeof action === "number" ? "".concat(action) : isFunction(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function toStatePath(stateId, delimiter) {
    try {
        if (isArray(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function isStateLike(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function toStateValue(stateValue, delimiter) {
    if (isStateLike(stateValue)) return stateValue.value;
    if (isArray(stateValue)) return pathToStateValue(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = toStatePath(stateValue, delimiter);
    return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function mapValues(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function mapFilterValues(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, _tslibJs.__values)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var path = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, _tslibJs.__values)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function nestedPath(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, _tslibJs.__values)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function toStatePaths(stateValue) {
    if (!stateValue) return [
        []
    ];
    if (isString(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = flatten(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return toStatePaths(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function pathsToStateValue(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, _tslibJs.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function flatten(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(array), false));
}
function toArrayStrict(value) {
    if (isArray(value)) return value;
    return [
        value
    ];
}
function toArray(value) {
    if (value === undefined) return [];
    return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
    var e_5, _a;
    if (isFunction(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, _tslibJs.__values)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if (isFunction(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function isBuiltInEvent(eventType) {
    return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && (isFunction(value) || typeof value === "object") && isFunction(value.then)) return true;
    return false;
}
function isBehavior(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function partition(items, predicate) {
    var e_6, _a;
    var _b = (0, _tslibJs.__read)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, _tslibJs.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function updateHistoryStates(hist, stateValue) {
    return mapValues(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = (isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: updateHistoryStates(subHist, subStateValue)
        };
    });
}
function updateHistoryValue(hist, stateValue) {
    return {
        current: stateValue,
        states: updateHistoryStates(hist, stateValue)
    };
}
function updateContext(context, _event, assignActions, state) {
    if (!(0, _environmentJs.IS_PRODUCTION)) warn(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if (isFunction(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, _tslibJs.__values)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var warn = function() {};
if (!(0, _environmentJs.IS_PRODUCTION)) warn = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function isArray(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function isFunction(value) {
    return typeof value === "function";
}
function isString(value) {
    return typeof value === "string";
}
function toGuard(condition, guardMap) {
    if (!condition) return undefined;
    if (isString(condition)) return {
        type: (0, _constantsJs.DEFAULT_GUARD_TYPE),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if (isFunction(condition)) return {
        type: (0, _constantsJs.DEFAULT_GUARD_TYPE),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function isObservable(value) {
    try {
        return "subscribe" in value && isFunction(value.subscribe);
    } catch (e) {
        return false;
    }
}
var symbolObservable = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var interopSymbols = (_a = {}, _a[symbolObservable] = function() {
    return this;
}, _a[Symbol.observable] = function() {
    return this;
}, _a);
function isMachine(value) {
    return !!value && "__xstatenode" in value;
}
function isActor(value) {
    return !!value && typeof value.send === "function";
}
var uniqueId = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function toEventObject(event, payload // id?: TEvent['type']
) {
    if (isString(event) || typeof event === "number") return (0, _tslibJs.__assign)({
        type: event
    }, payload);
    return event;
}
function toSCXMLEvent(event, scxmlEvent) {
    if (!isString(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = toEventObject(event);
    return (0, _tslibJs.__assign)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
    var transitions = toArrayStrict(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || isMachine(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function normalizeTarget(target) {
    if (target === undefined || target === (0, _constantsJs.TARGETLESS_KEY)) return undefined;
    return toArray(target);
}
function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
    if (!(0, _environmentJs.IS_PRODUCTION)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function evaluateGuard(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, _constantsJs.DEFAULT_GUARD_TYPE)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function toInvokeSource(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function toObserver(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function createInvokeId(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function isRaisableAction(action) {
    return (action.type === (0, _actionTypesJs.raise) || action.type === (0, _actionTypesJs.send) && action.to === (0, _typesJs.SpecialTargets).Internal) && typeof action.delay !== "number";
}

},{"./_virtual/_tslib.js":"2SGBQ","./types.js":"hpbs4","./actionTypes.js":"2Jthd","./constants.js":"he2AG","./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"he2AG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_GUARD_TYPE", ()=>DEFAULT_GUARD_TYPE);
parcelHelpers.export(exports, "EMPTY_ACTIVITY_MAP", ()=>EMPTY_ACTIVITY_MAP);
parcelHelpers.export(exports, "STATE_DELIMITER", ()=>STATE_DELIMITER);
parcelHelpers.export(exports, "TARGETLESS_KEY", ()=>TARGETLESS_KEY);
var STATE_DELIMITER = ".";
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = "xstate.guard";
var TARGETLESS_KEY = "";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5108U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_PRODUCTION", ()=>IS_PRODUCTION);
var IS_PRODUCTION = true;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5nKRl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDeferredActor", ()=>createDeferredActor);
parcelHelpers.export(exports, "createInvocableActor", ()=>createInvocableActor);
parcelHelpers.export(exports, "createNullActor", ()=>createNullActor);
parcelHelpers.export(exports, "isActor", ()=>isActor);
parcelHelpers.export(exports, "isSpawnedActor", ()=>isSpawnedActor);
parcelHelpers.export(exports, "toActorRef", ()=>toActorRef);
var _tslibJs = require("./_virtual/_tslib.js");
var _utilsJs = require("./utils.js");
var _serviceScopeJs = require("./serviceScope.js");
function createNullActor(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, _utilsJs.symbolObservable] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function createInvocableActor(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, _utilsJs.toInvokeSource)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, _utilsJs.mapContext)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function createDeferredActor(entity, id, data) {
    var tempActor = createNullActor(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, _utilsJs.isMachine)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, _serviceScopeJs.provide)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function isActor(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function isSpawnedActor(item) {
    return isActor(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function toActorRef(actorRefLike) {
    var _a;
    return (0, _tslibJs.__assign)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, _utilsJs.symbolObservable] = function() {
        return this;
    }, _a), actorRefLike);
}

},{"./_virtual/_tslib.js":"2SGBQ","./utils.js":"gdjQg","./serviceScope.js":"6D7we","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6D7we":[function(require,module,exports) {
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "consume", ()=>consume);
parcelHelpers.export(exports, "provide", ()=>provide);
var serviceStack = [];
var provide = function(service, fn) {
    serviceStack.push(service);
    var result = fn(service);
    serviceStack.pop();
    return result;
};
var consume = function(fn) {
    return fn(serviceStack[serviceStack.length - 1]);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gWBN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interpreter", ()=>Interpreter);
parcelHelpers.export(exports, "InterpreterStatus", ()=>InterpreterStatus);
parcelHelpers.export(exports, "interpret", ()=>interpret);
parcelHelpers.export(exports, "spawn", ()=>spawn);
var _tslibJs = require("./_virtual/_tslib.js");
var _typesJs = require("./types.js");
var _stateJs = require("./State.js");
var _actionTypesJs = require("./actionTypes.js");
var _actionsJs = require("./actions.js");
var _environmentJs = require("./environment.js");
var _utilsJs = require("./utils.js");
var _schedulerJs = require("./scheduler.js");
var _actorJs = require("./Actor.js");
var _registryJs = require("./registry.js");
var _devToolsJs = require("./devTools.js");
var _serviceScopeJs = require("./serviceScope.js");
var _behaviorsJs = require("./behaviors.js");
var DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var InterpreterStatus;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));
var Interpreter = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = InterpreterStatus.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, _utilsJs.isArray)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, _utilsJs.toSCXMLEvent)((0, _utilsJs.toEventObject)(event1, payload));
            if (_this.status === InterpreterStatus.Stopped) {
                // do nothing
                if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, _typesJs.SpecialTargets).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, _utilsJs.isString)(to) ? to === (0, _typesJs.SpecialTargets).Internal ? _this : _this.children.get(to) || (0, _registryJs.registry).get(to) : (0, _utilsJs.isActor)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, event1), {
                        name: event1.name === (0, _actionTypesJs.error) ? "".concat((0, _actionsJs.error)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, _actionsJs.getActionFunction)(action.type, actionFunctionMap);
            var exec = (0, _utilsJs.isFunction)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, _actionTypesJs.raise:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, _actionTypesJs.send:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, _actionsJs.initEvent));
                    else _this.send(sendAction._event);
                    break;
                case 0, _actionTypesJs.cancel:
                    _this.cancel(action.sendId);
                    break;
                case 0, _actionTypesJs.start:
                    if (_this.status !== InterpreterStatus.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, _typesJs.ActionTypes).Invoke) {
                        var invokeSource = (0, _utilsJs.toInvokeSource)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, _utilsJs.mapContext)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, _utilsJs.isFunction)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, _utilsJs.isMachine)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, _actionTypesJs.stop:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, _actionTypesJs.log:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, _schedulerJs.Scheduler)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, _registryJs.registry).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, _serviceScopeJs.provide)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, _tslibJs.__values)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, _actionsJs.initEvent)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, _tslibJs.__values)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, _tslibJs.__values)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, _tslibJs.__values)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, _utilsJs.mapContext)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, _actionsJs.doneInvoke)(this.id, doneData);
            try {
                for(var _l = (0, _tslibJs.__values)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, _registryJs.registry).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === InterpreterStatus.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, _utilsJs.toObserver)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== InterpreterStatus.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === InterpreterStatus.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === InterpreterStatus.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === InterpreterStatus.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, _registryJs.registry).register(this.sessionId, this);
        this.initialized = true;
        this.status = InterpreterStatus.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, _serviceScopeJs.provide)(this, function() {
            return (0, _stateJs.isStateConfig)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, _stateJs.State).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, _actionsJs.initEvent));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, _utilsJs.isFunction)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, _tslibJs.__values)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, _tslibJs.__values)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, _tslibJs.__values)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, _tslibJs.__values)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = InterpreterStatus.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, _tslibJs.__values)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, _schedulerJs.Scheduler)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, _utilsJs.toSCXMLEvent)({
                type: "xstate.stop"
            });
            var nextState = (0, _serviceScopeJs.provide)(_this, function() {
                var exitActions = (0, _utilsJs.flatten)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, _actionsJs.toActionObjects)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, _tslibJs.__read)((0, _actionsJs.resolveActions)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, _stateJs.State)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, _utilsJs.isRaisableAction)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, _registryJs.registry).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== InterpreterStatus.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, _utilsJs.toSCXMLEvent)(event_1);
                _this.forward(_event);
                nextState = (0, _serviceScopeJs.provide)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, _stateJs.bindActionToState)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, _tslibJs.__values)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, _utilsJs.toSCXMLEvent)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, _utilsJs.toSCXMLEvent)(event1);
        if (_event.name.indexOf((0, _actionTypesJs.errorPlatform)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, _actionTypesJs.errorPlatform)) === 0;
        })) throw _event.data.data;
        var nextState = (0, _serviceScopeJs.provide)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, _tslibJs.__values)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, _utilsJs.isFunction)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== InterpreterStatus.Running) return (0, _actorJs.createDeferredActor)(entity, name);
        if ((0, _utilsJs.isPromiseLike)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, _utilsJs.isFunction)(entity)) return this.spawnCallback(entity, name);
        else if ((0, _actorJs.isSpawnedActor)(entity)) return this.spawnActor(entity, name);
        else if ((0, _utilsJs.isObservable)(entity)) return this.spawnObservable(entity, name);
        else if ((0, _utilsJs.isMachine)(entity)) return this.spawnMachine(entity, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, options), {
            id: name
        }));
        else if ((0, _utilsJs.isBehavior)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, _actionTypesJs.update), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, _utilsJs.toSCXMLEvent)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, _behaviorsJs.spawnBehavior)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, _utilsJs.toSCXMLEvent)((0, _actionsJs.doneInvoke)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, _actionsJs.error)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, _utilsJs.toSCXMLEvent)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, _utilsJs.reportUnhandledExceptionOnInvocation)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, _utilsJs.toObserver)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, _utilsJs.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, _utilsJs.toSCXMLEvent)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, _actionsJs.error)(id, err));
        }
        if ((0, _utilsJs.isPromiseLike)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, _utilsJs.toObserver)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, _utilsJs.isFunction)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, _utilsJs.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, _utilsJs.toSCXMLEvent)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, _utilsJs.toSCXMLEvent)((0, _actionsJs.error)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, _utilsJs.toSCXMLEvent)((0, _actionsJs.doneInvoke)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, _utilsJs.symbolObservable] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, _utilsJs.symbolObservable] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, _devToolsJs.getGlobal)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, _tslibJs.__assign)((0, _tslibJs.__assign)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, _tslibJs.__assign)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, _devToolsJs.registerService)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, _utilsJs.symbolObservable] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === InterpreterStatus.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = interpret;
    return Interpreter;
}();
var resolveSpawnOptions = function(nameOrOptions) {
    if ((0, _utilsJs.isString)(nameOrOptions)) return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, DEFAULT_SPAWN_OPTIONS), {
        name: (0, _utilsJs.uniqueId)()
    }), nameOrOptions);
};
function spawn(entity, nameOrOptions) {
    var resolvedOptions = resolveSpawnOptions(nameOrOptions);
    return (0, _serviceScopeJs.consume)(function(service) {
        if (!(0, _environmentJs.IS_PRODUCTION)) {
            var isLazyEntity = (0, _utilsJs.isMachine)(entity) || (0, _utilsJs.isFunction)(entity);
            (0, _utilsJs.warn)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, _utilsJs.isMachine)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, _actorJs.createDeferredActor)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function interpret(machine, options) {
    var interpreter = new Interpreter(machine, options);
    return interpreter;
}

},{"./_virtual/_tslib.js":"2SGBQ","./types.js":"hpbs4","./State.js":"gv1oM","./actionTypes.js":"2Jthd","./actions.js":"ev4Zc","./environment.js":"5108U","./utils.js":"gdjQg","./scheduler.js":"6ZYHd","./Actor.js":"5nKRl","./registry.js":"6CnCE","./devTools.js":"kVFqp","./serviceScope.js":"6D7we","./behaviors.js":"bOMs1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gv1oM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "State", ()=>State);
parcelHelpers.export(exports, "bindActionToState", ()=>bindActionToState);
parcelHelpers.export(exports, "isState", ()=>isState);
parcelHelpers.export(exports, "isStateConfig", ()=>isStateConfig);
parcelHelpers.export(exports, "stateValuesEqual", ()=>stateValuesEqual);
var _tslibJs = require("./_virtual/_tslib.js");
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
var _stateUtilsJs = require("./stateUtils.js");
var _actionsJs = require("./actions.js");
var _environmentJs = require("./environment.js");
function stateValuesEqual(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, _utilsJs.isString)(a) || (0, _utilsJs.isString)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return stateValuesEqual(a[key], b[key]);
    });
}
function isStateConfig(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var isState = isStateConfig;
function bindActionToState(action, state) {
    var exec = action.exec;
    var boundAction = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var State = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, _constantsJs.EMPTY_ACTIVITY_MAP);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, _constantsJs.EMPTY_ACTIVITY_MAP);
        this.meta = (0, _stateUtilsJs.getMeta)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, _stateUtilsJs.nextEvents)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, _actionsJs.initEvent);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, _actionsJs.initEvent);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, _utilsJs.isString)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, _tslibJs.__rest)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, _utilsJs.matchesState)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, _environmentJs.IS_PRODUCTION) (0, _utilsJs.warn)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();

},{"./_virtual/_tslib.js":"2SGBQ","./constants.js":"he2AG","./utils.js":"gdjQg","./stateUtils.js":"kaqzR","./actions.js":"ev4Zc","./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kaqzR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAdjList", ()=>getAdjList);
parcelHelpers.export(exports, "getAllChildren", ()=>getAllChildren);
parcelHelpers.export(exports, "getAllStateNodes", ()=>getAllStateNodes);
parcelHelpers.export(exports, "getChildren", ()=>getChildren);
parcelHelpers.export(exports, "getConfiguration", ()=>getConfiguration);
parcelHelpers.export(exports, "getMeta", ()=>getMeta);
parcelHelpers.export(exports, "getTagsFromConfiguration", ()=>getTagsFromConfiguration);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "has", ()=>has);
parcelHelpers.export(exports, "isInFinalState", ()=>isInFinalState);
parcelHelpers.export(exports, "isLeafNode", ()=>isLeafNode);
parcelHelpers.export(exports, "nextEvents", ()=>nextEvents);
var _tslibJs = require("./_virtual/_tslib.js");
var _utilsJs = require("./utils.js");
var isLeafNode = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function getAllChildren(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function getChildren(stateNode) {
    return getAllChildren(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function getAllStateNodes(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if (isLeafNode(stateNode)) return stateNodes;
    return stateNodes.concat((0, _utilsJs.flatten)(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = getAdjList(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, _tslibJs.__values)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = getAdjList(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, _tslibJs.__values)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, _tslibJs.__values)(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, _tslibJs.__values)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if (isLeafNode(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function getAdjList(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, _tslibJs.__values)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function getValue(rootNode, configuration) {
    var config = getConfiguration([
        rootNode
    ], configuration);
    return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function nextEvents(configuration) {
    return (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(new Set((0, _utilsJs.flatten)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
    if (stateNode.type === "compound") return getChildren(stateNode).some(function(s) {
        return s.type === "final" && has(configuration, s);
    });
    if (stateNode.type === "parallel") return getChildren(stateNode).every(function(sn) {
        return isInFinalState(configuration, sn);
    });
    return false;
}
function getMeta(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function getTagsFromConfiguration(configuration) {
    return new Set((0, _utilsJs.flatten)(configuration.map(function(sn) {
        return sn.tags;
    })));
}

},{"./_virtual/_tslib.js":"2SGBQ","./utils.js":"gdjQg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6ZYHd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var _tslibJs = require("./_virtual/_tslib.js");
var defaultOptions = {
    deferEvents: false
};
var Scheduler = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();

},{"./_virtual/_tslib.js":"2SGBQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6CnCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registry", ()=>registry);
var children = /*#__PURE__*/ new Map();
var sessionIdIndex = 0;
var registry = {
    bookId: function() {
        return "x:".concat(sessionIdIndex++);
    },
    register: function(id, actor) {
        children.set(id, actor);
        return id;
    },
    get: function(id) {
        return children.get(id);
    },
    free: function(id) {
        children.delete(id);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kVFqp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "registerService", ()=>registerService);
var _environmentJs = require("./environment.js");
var global = arguments[3];
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    if (!(0, _environmentJs.IS_PRODUCTION)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function getDevTools() {
    var global = getGlobal();
    if (global && "__xstate__" in global) return global.__xstate__;
    return undefined;
}
function registerService(service) {
    if (!getGlobal()) return;
    var devTools = getDevTools();
    if (devTools) devTools.register(service);
}

},{"./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bOMs1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromPromise", ()=>fromPromise);
parcelHelpers.export(exports, "fromReducer", ()=>fromReducer);
parcelHelpers.export(exports, "spawnBehavior", ()=>spawnBehavior);
var _actionsJs = require("./actions.js");
var _actorJs = require("./Actor.js");
var _utilsJs = require("./utils.js");
/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function fromReducer(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function fromPromise(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, _actionsJs.doneInvoke)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, _actionsJs.error)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function spawnBehavior(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, _actorJs.toActorRef)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, _utilsJs.toObserver)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}

},{"./actions.js":"ev4Zc","./Actor.js":"5nKRl","./utils.js":"gdjQg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lVA6D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Machine", ()=>Machine);
parcelHelpers.export(exports, "createMachine", ()=>createMachine);
var _stateNodeJs = require("./StateNode.js");
var _environmentJs = require("./environment.js");
var warned = false;
function Machine(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, _stateNodeJs.StateNode)(config, options, initialContext);
}
function createMachine(config, options) {
    if (!(0, _environmentJs.IS_PRODUCTION) && !("predictableActionArguments" in config) && !warned) {
        warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, _stateNodeJs.StateNode)(config, options);
}

},{"./StateNode.js":"9BK2G","./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9BK2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateNode", ()=>StateNode);
var _tslibJs = require("./_virtual/_tslib.js");
var _utilsJs = require("./utils.js");
var _stateJs = require("./State.js");
var _actionTypesJs = require("./actionTypes.js");
var _actionsJs = require("./actions.js");
var _environmentJs = require("./environment.js");
var _constantsJs = require("./constants.js");
var _stateUtilsJs = require("./stateUtils.js");
var _actorJs = require("./Actor.js");
var _invokeUtilsJs = require("./invokeUtils.js");
var NULL_EVENT = "";
var STATE_IDENTIFIER = "#";
var WILDCARD = "*";
var EMPTY_OBJECT = {};
var isStateId = function(str) {
    return str[0] === STATE_IDENTIFIER;
};
var createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, _utilsJs.isString)(transition.target) || (0, _utilsJs.isMachine)(transition.target));
    });
    var eventText = event === NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, _utilsJs.warn)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var StateNode = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign(createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, _constantsJs.STATE_DELIMITER));
        this.id = this.config.id || (0, _tslibJs.__spreadArray)([
            this.machine.key
        ], (0, _tslibJs.__read)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, _utilsJs.mapValues)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, _tslibJs.__assign)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, _tslibJs.__values)((0, _stateUtilsJs.getAllChildren)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === NULL_EVENT;
        }) : NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, _utilsJs.toArray)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, _actionsJs.toActionObject)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, _utilsJs.toArray)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, _actionsJs.toActionObject)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, _utilsJs.toArray)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, _utilsJs.isMachine)(invokeConfig)) {
                var invokeId = (0, _utilsJs.createInvokeId)(_this.id, i);
                _this.machine.options.services = (0, _tslibJs.__assign)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, _invokeUtilsJs.toInvokeDefinition)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, _utilsJs.isString)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, _utilsJs.createInvokeId)(_this.id, i);
                return (0, _invokeUtilsJs.toInvokeDefinition)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, _utilsJs.isMachine)(invokeConfig.src) || (0, _utilsJs.isFunction)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, _utilsJs.createInvokeId)(_this.id, i);
                _this.machine.options.services = (0, _tslibJs.__assign)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, _invokeUtilsJs.toInvokeDefinition)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, _invokeUtilsJs.toInvokeDefinition)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({
                    id: (0, _utilsJs.createInvokeId)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, _utilsJs.toArray)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, _actionsJs.toActivityDefinition)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, _utilsJs.toArray)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, _stateUtilsJs.getAllStateNodes)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, actions), options.actions),
            activities: (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, activities), options.activities),
            guards: (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, guards), options.guards),
            services: (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, services), options.services),
            delays: (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, _utilsJs.isFunction)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, _utilsJs.mapValues)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, _utilsJs.isFunction)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, _actionsJs.after)(delayRef, _this.id);
            _this.onEntry.push((0, _actionsJs.send)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, _actionsJs.cancel)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, _utilsJs.isArray)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, transition), {
                event: eventType
            });
        }) : (0, _utilsJs.flatten)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, _utilsJs.isString)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, _utilsJs.toArray)(resolvedTransition).map(function(transition) {
                return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, _stateJs.State) ? state.value : (0, _utilsJs.toStateValue)(state, this.delimiter);
        if ((0, _utilsJs.isString)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)((0, _utilsJs.flatten)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, _utilsJs.getEventType)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, _stateJs.State) ? state : (0, _stateJs.State).create(state);
        var configuration = Array.from((0, _stateUtilsJs.getConfiguration)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, _stateJs.State)((0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, _stateUtilsJs.isInFinalState)(configuration, this),
            tags: (0, _stateUtilsJs.getTagsFromConfiguration)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, _tslibJs.__values)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, _utilsJs.flatten)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, _utilsJs.flatten)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, _utilsJs.flatten)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, _utilsJs.flatten)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, _utilsJs.isString)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, _utilsJs.toSCXMLEvent)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, _tslibJs.__values)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, _utilsJs.isString)(stateIn) && isStateId(stateIn) ? state.matches((0, _utilsJs.toStateValue)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, _utilsJs.matchesState)((0, _utilsJs.toStateValue)(stateIn, this.delimiter), (0, _utilsJs.path)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, _utilsJs.evaluateGuard)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, _utilsJs.flatten)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, _utilsJs.flatten)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, _stateUtilsJs.getConfiguration)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, _tslibJs.__values)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, _stateUtilsJs.has)(prevConfig, sn) || (0, _stateUtilsJs.has)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, _tslibJs.__values)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, _stateUtilsJs.has)(resolvedConfig, sn) || (0, _stateUtilsJs.has)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, _utilsJs.flatten)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, _actionsJs.done)(sn.id, sn.doneData), (0, _actionsJs.done)(parent.id, sn.doneData ? (0, _utilsJs.mapContext)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, _stateUtilsJs.getChildren)(grandparent).every(function(parentNode) {
                    return (0, _stateUtilsJs.isInFinalState)(transition.configuration, parentNode);
                })) events.push((0, _actionsJs.done)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, _actionsJs.start)(activity);
            });
            return {
                type: "entry",
                actions: (0, _actionsJs.toActionObjects)(predictableExec ? (0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(entryActions), false), (0, _tslibJs.__read)(invokeActions), false) : (0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(invokeActions), false), (0, _tslibJs.__read)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, _actionsJs.raise)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, _actionsJs.toActionObjects)((0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(stateNode.onExit), false), (0, _tslibJs.__read)(stateNode.activities.map(function(activity) {
                    return (0, _actionsJs.stop)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, _actionsJs.toActionObjects)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, _actionsJs.toActionObjects)((0, _utilsJs.flatten)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, _utilsJs.isRaisableAction)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, _utilsJs.toSCXMLEvent)(event);
        var currentState;
        if (state instanceof (0, _stateJs.State)) currentState = context === undefined ? state : this.resolveState((0, _stateJs.State).from(state, context));
        else {
            var resolvedStateValue = (0, _utilsJs.isString)(state) ? this.resolve((0, _utilsJs.pathToStateValue)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, _stateJs.State).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, _environmentJs.IS_PRODUCTION) && _event.name === WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, _utilsJs.isBuiltInEvent)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, _stateUtilsJs.getConfiguration)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, _stateUtilsJs.getConfiguration)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, _actionsJs.initEvent);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, _stateUtilsJs.isInFinalState)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, _stateUtilsJs.getValue)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, _tslibJs.__assign)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, _tslibJs.__values)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, _tslibJs.__values)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, _actionTypesJs.start)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, _actionTypesJs.stop)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, _tslibJs.__read)((0, _actionsJs.resolveActions)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, _tslibJs.__read)((0, _utilsJs.partition)(resolvedActions, (0, _utilsJs.isRaisableAction)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, _actionTypesJs.start) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, _actionTypesJs.invoke);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, _actorJs.createInvocableActor)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, _tslibJs.__assign)({}, currentState.children) : {});
        var nextState = new (0, _stateJs.State)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, _utilsJs.updateHistoryValue)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, _stateUtilsJs.getTagsFromConfiguration)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, _actionTypesJs.update) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, _actionTypesJs.nullEvent)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, _stateJs.stateValuesEqual)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if (isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, _utilsJs.toStatePath)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, _utilsJs.mapValues)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
                });
            case "compound":
                if ((0, _utilsJs.isString)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, _utilsJs.mapValues)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
                });
            default:
                return stateValue || EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if (isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, _utilsJs.toStatePath)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, _utilsJs.mapFilterValues)(this.states, function(state) {
                return state.initialStateValue || EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, _stateUtilsJs.isLeafNode)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, _utilsJs.isString)(historyConfig.target)) target = isStateId(historyConfig.target) ? (0, _utilsJs.pathToStateValue)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, _stateUtilsJs.isLeafNode)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, _utilsJs.toStatePaths)(this.initialStateValue);
            return (0, _utilsJs.flatten)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, _tslibJs.__read)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, _utilsJs.mapFilterValues)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, _utilsJs.isString)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, _utilsJs.flatten)((0, _utilsJs.toStatePaths)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, _utilsJs.nestedPath)(parent.path, "states")(historyValue).current;
        if ((0, _utilsJs.isString)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, _utilsJs.flatten)((0, _utilsJs.toStatePaths)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, _utilsJs.flatten)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, _tslibJs.__values)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, _tslibJs.__values)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, _utilsJs.isString)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, _utilsJs.normalizeTarget)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, _utilsJs.isString)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, transitionConfig), {
            actions: (0, _actionsJs.toActionObjects)((0, _utilsJs.toArray)(transitionConfig.actions)),
            cond: (0, _utilsJs.toGuard)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, _tslibJs.__rest)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, _utilsJs.flatten)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, _environmentJs.IS_PRODUCTION) && key === NULL_EVENT) (0, _utilsJs.warn)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, _utilsJs.toTransitionConfigArray)(key, strictTransitionConfigs_1[key]);
                if (!(0, _environmentJs.IS_PRODUCTION)) validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, _utilsJs.toTransitionConfigArray)(WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, _utilsJs.toTransitionConfigArray)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, _utilsJs.toTransitionConfigArray)(String((0, _actionsJs.done)(this.id)), this.config.onDone) : [];
        if (!(0, _environmentJs.IS_PRODUCTION)) (0, _utilsJs.warn)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, _utilsJs.flatten)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)((0, _utilsJs.toTransitionConfigArray)(String((0, _actionsJs.doneInvoke)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)((0, _utilsJs.toTransitionConfigArray)(String((0, _actionsJs.error)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, _utilsJs.flatten)((0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)((0, _tslibJs.__spreadArray)([], (0, _tslibJs.__read)(doneConfig), false), (0, _tslibJs.__read)(invokeConfig), false), (0, _tslibJs.__read)(onConfig), false), (0, _tslibJs.__read)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, _utilsJs.toArray)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, _tslibJs.__values)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();

},{"./_virtual/_tslib.js":"2SGBQ","./utils.js":"gdjQg","./State.js":"gv1oM","./actionTypes.js":"2Jthd","./actions.js":"ev4Zc","./environment.js":"5108U","./constants.js":"he2AG","./stateUtils.js":"kaqzR","./Actor.js":"5nKRl","./invokeUtils.js":"3ppzD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ppzD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toInvokeDefinition", ()=>toInvokeDefinition);
parcelHelpers.export(exports, "toInvokeSource", ()=>toInvokeSource);
var _tslibJs = require("./_virtual/_tslib.js");
var _typesJs = require("./types.js");
var _actionTypesJs = require("./actionTypes.js");
var _utilsJs = require("./utils.js");
var _environmentJs = require("./environment.js");
function toInvokeSource(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function toInvokeDefinition(invokeConfig) {
    return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({
        type: (0, _actionTypesJs.invoke)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, _tslibJs.__rest)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, _tslibJs.__assign)((0, _tslibJs.__assign)({}, invokeDef), {
                type: (0, _actionTypesJs.invoke),
                src: toInvokeSource(invokeConfig.src)
            });
        }
    });
}

},{"./_virtual/_tslib.js":"2SGBQ","./types.js":"hpbs4","./actionTypes.js":"2Jthd","./utils.js":"gdjQg","./environment.js":"5108U","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nOrP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearAttributeToVerify", ()=>i);
parcelHelpers.export(exports, "clearChallengeName", ()=>u);
parcelHelpers.export(exports, "clearError", ()=>l);
parcelHelpers.export(exports, "clearFormValues", ()=>d);
parcelHelpers.export(exports, "clearRequiredAttributes", ()=>m);
parcelHelpers.export(exports, "clearTouched", ()=>c);
parcelHelpers.export(exports, "clearUnverifiedContactMethods", ()=>p);
parcelHelpers.export(exports, "clearUsername", ()=>f);
parcelHelpers.export(exports, "clearValidationError", ()=>v);
parcelHelpers.export(exports, "handleBlur", ()=>M);
parcelHelpers.export(exports, "handleInput", ()=>$);
parcelHelpers.export(exports, "handleSubmit", ()=>D);
parcelHelpers.export(exports, "parsePhoneNumber", ()=>q);
parcelHelpers.export(exports, "resendCode", ()=>P);
parcelHelpers.export(exports, "setChallengeName", ()=>g);
parcelHelpers.export(exports, "setCodeDeliveryDetails", ()=>E);
parcelHelpers.export(exports, "setConfirmResetPasswordIntent", ()=>V);
parcelHelpers.export(exports, "setConfirmSignUpIntent", ()=>j);
parcelHelpers.export(exports, "setCredentials", ()=>y);
parcelHelpers.export(exports, "setFieldErrors", ()=>O);
parcelHelpers.export(exports, "setRemoteError", ()=>_);
parcelHelpers.export(exports, "setRequiredAttributes", ()=>b);
parcelHelpers.export(exports, "setTotpSecretCode", ()=>h);
parcelHelpers.export(exports, "setUnverifiedContactMethods", ()=>w);
parcelHelpers.export(exports, "setUser", ()=>A);
parcelHelpers.export(exports, "setUsername", ()=>C);
parcelHelpers.export(exports, "setUsernameAuthAttributes", ()=>N);
parcelHelpers.export(exports, "stopActor", ()=>n);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _xstate = require("xstate");
var _userMjs = require("../../types/authenticator/user.mjs");
var _attributesMjs = require("../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../types/primitives/componentClassName.mjs");
var _translationsMjs = require("../../i18n/translations.mjs");
var _utilsMjs = require("../../helpers/authenticator/utils.mjs");
var _utilsMjs1 = require("../../helpers/accountSettings/utils.mjs");
const { assign: o, stop: s } = (0, _xstate.actions), n = (e)=>s(e), i = o({
    attributeToVerify: (e)=>{}
}), u = o({
    challengeName: (e)=>{}
}), m = o({
    requiredAttributes: (e)=>{}
}), l = o({
    remoteError: (e)=>""
}), d = o({
    formValues: (e)=>({})
}), c = o({
    touched: (e)=>({})
}), p = o({
    unverifiedContactMethods: (e)=>{}
}), f = o({
    username: (e)=>{}
}), v = o({
    validationError: (e)=>({})
}), h = o({
    totpSecretCode: (e, r)=>r.data
}), g = o({
    challengeName: (e, r)=>{
        var t;
        return null === (t = r.data) || void 0 === t ? void 0 : t.challengeName;
    }
}), b = o({
    requiredAttributes: (e, r)=>{
        var t, a;
        return null === (a = null === (t = r.data) || void 0 === t ? void 0 : t.challengeParam) || void 0 === a ? void 0 : a.requiredAttributes;
    }
}), V = o({
    redirectIntent: (e)=>"confirmPasswordReset"
}), j = o({
    redirectIntent: (e)=>"confirmSignUp"
}), y = o({
    authAttributes: (e, r)=>{
        var t, a;
        const [o] = e.loginMechanisms;
        return {
            username: null !== (t = e.formValues[o]) && void 0 !== t ? t : e.formValues.username,
            password: null === (a = e.formValues) || void 0 === a ? void 0 : a.password
        };
    }
}), O = o({
    validationError: (e, r)=>r.data
}), _ = o({
    remoteError: (e, r)=>{
        var t;
        return "NoUserPoolError" === r.data.name ? "Configuration error (see console) \u2013 please contact the administrator" : (null === (t = r.data) || void 0 === t ? void 0 : t.message) || r.data;
    }
}), w = o({
    unverifiedContactMethods: (e, r)=>r.data.unverified
}), A = o({
    user: (e, r)=>r.data.user || r.data
}), C = o({
    username: (e, r)=>{
        let { formValues: { username: t, country_code: a } } = e;
        return a && (t = `${a}${t}`), t;
    }
}), E = o({
    codeDeliveryDetails: (e, r)=>r.data.codeDeliveryDetails
}), N = o({
    authAttributes: (e, r)=>({
            username: e.formValues.username
        })
}), $ = o({
    formValues: (e, r)=>{
        const { name: t, value: a } = r.data;
        return Object.assign(Object.assign({}, e.formValues), {
            [t]: a
        });
    }
}), D = o({
    formValues: (e, r)=>{
        const t = Object.assign(Object.assign({}, e.formValues), r.data);
        return (0, _utilsMjs.trimValues)(t, "password");
    }
}), M = o({
    touched: (e, r)=>{
        const { name: t } = r.data;
        return Object.assign(Object.assign({}, e.touched), {
            [`${t}`]: !0
        });
    }
}), P = (t)=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        const { username: e } = t;
        return yield (0, _awsAmplify.Auth).forgotPassword(e);
    }), q = o({
    formValues: (e, r)=>{
        var t;
        const [a = "username"] = e.loginMechanisms;
        if (!e.formValues.phone_number && "phone_number" !== a) return e.formValues;
        const { formValues: o, country_code: s } = e, n = o.phone_number ? "phone_number" : "username", i = `${null !== (t = o.country_code) && void 0 !== t ? t : s}${o[n]}`.replace(/[^A-Z0-9+]/gi, ""), u = Object.assign(Object.assign({}, o), {
            [n]: i
        });
        return delete u.country_code, u;
    }
});

},{"tslib":"86BcK","aws-amplify":"75VoS","xstate":"3RMsL","../../types/authenticator/user.mjs":"aZbQw","../../types/authenticator/attributes.mjs":"2ngIN","../../types/primitives/componentClassName.mjs":"62ykl","../../i18n/translations.mjs":"jSmFc","../../helpers/authenticator/utils.mjs":"l02QH","../../helpers/accountSettings/utils.mjs":"2PkvP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2tVOq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signInActor", ()=>k);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _getJs = require("lodash/get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _xstate = require("xstate");
var _indexMjs = require("../../../validators/index.mjs");
var _actionsMjs = require("../actions.mjs");
var _defaultServicesMjs = require("../defaultServices.mjs");
var _indexMjs1 = require("../../../utils/index.mjs");
const _ = [
    "SMS_MFA",
    "SOFTWARE_TOKEN_MFA"
], F = (e)=>(0, _getJsDefault.default)(e, "data.challengeName"), O = (e, t)=>e === t, j = (e)=>_.includes(e);
function k({ services: n }) {
    return (0, _xstate.createMachine)({
        initial: "init",
        id: "signInActor",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "autoSignIn.submit",
                        cond: "shouldAutoSubmit"
                    },
                    {
                        target: "autoSignIn",
                        cond: "shouldAutoSignIn"
                    },
                    {
                        target: "signIn"
                    }
                ]
            },
            signIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            FEDERATED_SIGN_IN: "federatedSignIn"
                        }
                    },
                    federatedSignIn: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "federatedSignIn",
                            onError: {
                                actions: "setRemoteError"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "parsePhoneNumber",
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "verifying"
                                }
                            ],
                            onError: [
                                {
                                    cond: "shouldRedirectToConfirmSignUp",
                                    actions: [
                                        "setCredentials",
                                        "setConfirmSignUpIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    cond: "shouldRedirectToConfirmResetPassword",
                                    actions: [
                                        "setUsernameAuthAttributes",
                                        "setConfirmResetPasswordIntent"
                                    ],
                                    target: "rejected"
                                },
                                {
                                    actions: "setRemoteError",
                                    target: "edit"
                                }
                            ]
                        }
                    },
                    verifying: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "checkVerifiedContact",
                            onDone: [
                                {
                                    cond: "shouldRequestVerification",
                                    target: "#signInActor.verifyUser",
                                    actions: "setUnverifiedContactMethods"
                                },
                                {
                                    target: "resolved"
                                }
                            ],
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    },
                    resolved: {
                        always: "#signInActor.resolved"
                    },
                    rejected: {
                        always: "#signInActor.rejected"
                    }
                }
            },
            autoSignIn: {
                initial: "pending",
                states: {
                    pending: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        on: {
                            AUTO_SIGN_IN: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "#signInActor.resolved"
                                }
                            ],
                            AUTO_SIGN_IN_FAILURE: {
                                actions: "setRemoteError",
                                target: "pending"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "signIn",
                            onDone: [
                                {
                                    cond: "shouldSetupTOTP",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.setupTOTP"
                                },
                                {
                                    cond: "shouldConfirmSignIn",
                                    actions: [
                                        "setUser",
                                        "setChallengeName"
                                    ],
                                    target: "#signInActor.confirmSignIn"
                                },
                                {
                                    cond: "shouldForceChangePassword",
                                    actions: [
                                        "setUser",
                                        "setChallengeName",
                                        "setRequiredAttributes"
                                    ],
                                    target: "#signInActor.forceNewPassword"
                                },
                                {
                                    actions: "setUser",
                                    target: "#signInActor.resolved"
                                }
                            ],
                            onError: {
                                actions: "setRemoteError",
                                target: "#signInActor.signIn"
                            }
                        }
                    },
                    resolved: {
                        always: "#signInActor.resolved"
                    },
                    rejected: {
                        always: "#signInActor.rejected"
                    }
                }
            },
            confirmSignIn: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            onDone: {
                                target: "#signInActor.resolved",
                                actions: [
                                    "setUser",
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ]
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            forceNewPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submit: {
                        initial: "idle",
                        entry: "clearError",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "forceNewPassword",
                                    onDone: [
                                        {
                                            cond: "shouldConfirmSignIn",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.confirmSignIn"
                                        },
                                        {
                                            cond: "shouldSetupTOTP",
                                            actions: [
                                                "setUser",
                                                "setChallengeName"
                                            ],
                                            target: "#signInActor.setupTOTP"
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signInActor.resolved"
                            }
                        }
                    }
                }
            },
            setupTOTP: {
                initial: "getTotpSecretCode",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    getTotpSecretCode: {
                        invoke: {
                            src: "getTotpSecretCode",
                            onDone: {
                                target: "edit",
                                actions: "setTotpSecretCode"
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    },
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "verifyTotpToken",
                            onDone: {
                                actions: [
                                    "clearChallengeName",
                                    "clearRequiredAttributes"
                                ],
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            verifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "verifyUser",
                            onDone: {
                                target: "#signInActor.confirmVerifyUser"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmVerifyUser: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUnverifiedContactMethods",
                    "clearAttributeToVerify",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#signInActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: "clearError",
                        invoke: {
                            src: "confirmVerifyUser",
                            onDone: {
                                target: "#signInActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (e)=>({
                        user: e.user
                    })
            },
            rejected: {
                type: "final",
                data: (e, t)=>({
                        intent: e.redirectIntent,
                        authAttributes: e.authAttributes
                    })
            }
        }
    }, {
        actions: {
            clearAttributeToVerify: (0, _actionsMjs.clearAttributeToVerify),
            clearChallengeName: (0, _actionsMjs.clearChallengeName),
            clearRequiredAttributes: (0, _actionsMjs.clearRequiredAttributes),
            clearError: (0, _actionsMjs.clearError),
            clearFormValues: (0, _actionsMjs.clearFormValues),
            clearTouched: (0, _actionsMjs.clearTouched),
            clearUnverifiedContactMethods: (0, _actionsMjs.clearUnverifiedContactMethods),
            clearValidationError: (0, _actionsMjs.clearValidationError),
            handleInput: (0, _actionsMjs.handleInput),
            handleSubmit: (0, _actionsMjs.handleSubmit),
            handleBlur: (0, _actionsMjs.handleBlur),
            parsePhoneNumber: (0, _actionsMjs.parsePhoneNumber),
            setChallengeName: (0, _actionsMjs.setChallengeName),
            setConfirmResetPasswordIntent: (0, _actionsMjs.setConfirmResetPasswordIntent),
            setConfirmSignUpIntent: (0, _actionsMjs.setConfirmSignUpIntent),
            setRequiredAttributes: (0, _actionsMjs.setRequiredAttributes),
            setCredentials: (0, _actionsMjs.setCredentials),
            setFieldErrors: (0, _actionsMjs.setFieldErrors),
            setRemoteError: (0, _actionsMjs.setRemoteError),
            setTotpSecretCode: (0, _actionsMjs.setTotpSecretCode),
            setUnverifiedContactMethods: (0, _actionsMjs.setUnverifiedContactMethods),
            setUser: (0, _actionsMjs.setUser),
            setUsernameAuthAttributes: (0, _actionsMjs.setUsernameAuthAttributes),
            sendUpdate: (0, _xstate.sendUpdate)()
        },
        guards: {
            shouldAutoSignIn: (e)=>"autoSignIn" === (null == e ? void 0 : e.intent),
            shouldAutoSubmit: (e)=>"autoSignInSubmit" === (null == e ? void 0 : e.intent),
            shouldConfirmSignIn: (e, t)=>j(F(t)),
            shouldForceChangePassword: (e, t)=>O(F(t), "NEW_PASSWORD_REQUIRED"),
            shouldRedirectToConfirmResetPassword: (e, t)=>"PasswordResetRequiredException" === t.data.code,
            shouldRedirectToConfirmSignUp: (e, t)=>"UserNotConfirmedException" === t.data.code,
            shouldRequestVerification: (e, t)=>{
                const { unverified: r, verified: n } = t.data;
                return (0, _indexMjs1.isEmpty)(n) && !(0, _indexMjs1.isEmpty)(r);
            },
            shouldSetupTOTP: (e, t)=>O(F(t), "MFA_SETUP")
        },
        services: {
            signIn (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { authAttributes: e = {}, formValues: r = {} } = t, o = Object.assign(Object.assign({}, e), r), { username: i, password: s } = o;
                    return yield n.handleSignIn({
                        username: i,
                        password: s
                    });
                });
            },
            confirmSignIn (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { challengeName: e, user: o } = t, { confirmation_code: i } = t.formValues, s = j(e) ? e : void 0;
                    return yield n.handleConfirmSignIn({
                        user: o,
                        code: i,
                        mfaType: s
                    }), yield (0, _awsAmplify.Auth).currentAuthenticatedUser();
                });
            },
            forceNewPassword (n) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { user: e, formValues: o } = n;
                    let i, { password: s, confirm_password: a, phone_number: d, country_code: c } = o, l = (0, _tslib.__rest)(o, [
                        "password",
                        "confirm_password",
                        "phone_number",
                        "country_code"
                    ]);
                    d && (i = `${c}${d}`.replace(/[^A-Z0-9+]/gi, ""), l = Object.assign(Object.assign({}, l), {
                        phone_number: i
                    }));
                    try {
                        const t = yield (0, _awsAmplify.Auth).completeNewPassword(e, s, l);
                        return t.challengeName ? t : (0, _awsAmplify.Auth).currentAuthenticatedUser();
                    } catch (e) {
                        return Promise.reject(e);
                    }
                });
            },
            getTotpSecretCode (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { user: e } = t;
                    return (0, _awsAmplify.Auth).setupTOTP(e);
                });
            },
            verifyTotpToken (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { formValues: e, user: n } = t, { confirmation_code: o } = e;
                    return (0, _awsAmplify.Auth).verifyTotpToken(n, o);
                });
            },
            federatedSignIn (t, n) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { provider: e } = n.data;
                    return yield (0, _awsAmplify.Auth).federatedSignIn({
                        provider: e
                    });
                });
            },
            checkVerifiedContact (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { user: e } = t;
                    return yield (0, _awsAmplify.Auth).verifiedContact(e);
                });
            },
            verifyUser (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { unverifiedAttr: e } = t.formValues, n = yield (0, _awsAmplify.Auth).verifyCurrentUserAttribute(e);
                    return t.attributeToVerify = e, n;
                });
            },
            confirmVerifyUser (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { attributeToVerify: e } = t, { confirmation_code: n } = t.formValues;
                    return yield (0, _awsAmplify.Auth).verifyCurrentUserAttributeSubmit(e, n);
                });
            },
            validateFields (t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    return (0, _indexMjs.runValidators)(t.formValues, t.touched, t.passwordSettings, [
                        (0, _defaultServicesMjs.defaultServices).validateFormPassword,
                        (0, _defaultServicesMjs.defaultServices).validateConfirmPassword
                    ]);
                });
            }
        }
    });
}

},{"tslib":"86BcK","aws-amplify":"75VoS","lodash/get.js":"jeneQ","xstate":"3RMsL","../../../validators/index.mjs":"gYqUC","../actions.mjs":"1nOrP","../defaultServices.mjs":"d5mT9","../../../utils/index.mjs":"a3Yxt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gYqUC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runValidators", ()=>e);
var _tslib = require("tslib");
var _mergeJs = require("lodash/merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _indexMjs = require("../utils/index.mjs");
const e = (e, m, s, t)=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
        const o = yield Promise.all(t.map((o)=>o(e, m, s))), l = (0, _mergeJsDefault.default)({}, ...o);
        return (0, _indexMjs.isEmpty)(l) ? Promise.resolve() : Promise.reject(l);
    });

},{"tslib":"86BcK","lodash/merge.js":"do3Da","../utils/index.mjs":"a3Yxt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"do3Da":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"lI2ne","e87a09d93c0fc32d":"8LCsj"}],"lI2ne":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"hxIkB","76e9fd6386317324":"inurK","e7dca58bcfe9c669":"37PNv","4ea46d88599071ec":"h7XnX","c52c932be04280cc":"8ffGS","27adf66142f57b4b":"fCgzE","564385b2292facea":"dnC3I"}],"inurK":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"8nNdL","7d9c95e1ffdd4f16":"8Gfg3"}],"8nNdL":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"2iIpD"}],"2iIpD":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bRlM4"}],"37PNv":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"6xv8f"}],"6xv8f":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"h7XnX":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"inurK","ec8e1b90277c5e12":"4aqSG","4b1a2b5090faf247":"7r4Ii","d7675bdf0a02bffc":"cC0e6","1067a6f3f6bd5986":"jOXkx","2238139506f6727b":"jmDAu","290c774b41e416bb":"jQGs4","f481819c40e5b527":"eiZps","6532fda6a198015f":"5BMZo","7f306c94b573f977":"8ck2f","32c89e763261c579":"8ffGS","ff359d315efefc4f":"2RXyg","61ce92c01fd411fe":"cJbMf","abfa8f7e72201edb":"dnC3I","c54d414b219fa287":"hazqP"}],"4aqSG":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"cN4l5"}],"7r4Ii":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"9mu8t"}],"9mu8t":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"aHxYs"}],"cC0e6":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"jOXkx":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5hlbu","8c92276927b7c3e0":"fiIZQ","e939f15d7a0f64a5":"36IG4"}],"5hlbu":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"8ffGS"}],"fiIZQ":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"2fV7A"}],"eiZps":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"mL7I2","639a4883b097af28":"lm2eo"}],"2RXyg":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"iuqvy","2ca5b85a120835de":"fiIZQ","963b65e043435612":"lm2eo"}],"dnC3I":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"hazqP":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"hqcwa","437a3e3814017158":"fCgzE"}],"hqcwa":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"5IHI0","9cddf6ac1a092765":"8nNdL"}],"5IHI0":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"8nNdL","b62ef95b3cf1cde1":"8Gfg3"}],"fCgzE":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"vD0Yx","194eb1a802636842":"9Ymm9","ac15afdc3ddd76cd":"mL7I2"}],"9Ymm9":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"8ffGS","f7d53cd92b2b977b":"36IG4","c039208a16eb68bd":"gGURQ"}],"gGURQ":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"8LCsj":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"7EAh7","4f5832110eba92d3":"936XO"}],"7EAh7":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"6wIyV","ff7d23ff2a2ea6f8":"kFCQg","a11d545e809d14f7":"14wda"}],"6wIyV":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"kFCQg":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"fNr5H"}],"fNr5H":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"14wda":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"1uXz0","9114f59293388d49":"9ZlLb"}],"1uXz0":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"jESKB","eff1240bc0447727":"2iIpD","b00d1e57326793e1":"6wIyV"}],"jESKB":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9ZlLb":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"936XO":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"8Gfg3","616bc732534dffe0":"mL7I2","e781332a36d1bd7":"heeP8","c8548bf6929b8a5d":"8ffGS"}],"d5mT9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultServices", ()=>o);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _userMjs = require("../../types/authenticator/user.mjs");
var _attributesMjs = require("../../types/authenticator/attributes.mjs");
var _componentClassNameMjs = require("../../types/primitives/componentClassName.mjs");
var _translationsMjs = require("../../i18n/translations.mjs");
var _utilsMjs = require("../../helpers/authenticator/utils.mjs");
var _utilsMjs1 = require("../../helpers/accountSettings/utils.mjs");
const o = {
    getAmplifyConfig () {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Amplify).configure();
        });
    },
    getCurrentUser () {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).currentAuthenticatedUser();
        });
    },
    handleSignUp (t) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).signUp(Object.assign(Object.assign({}, t), {
                autoSignIn: {
                    enabled: !0
                }
            }));
        });
    },
    handleSignIn ({ username: t, password: n }) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).signIn(t, n);
        });
    },
    handleConfirmSignIn ({ user: t, code: n, mfaType: o }) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).confirmSignIn(t, n, o);
        });
    },
    handleConfirmSignUp ({ username: t, code: n }) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return yield (0, _awsAmplify.Auth).confirmSignUp(t, n);
        });
    },
    handleForgotPasswordSubmit ({ username: t, code: n, password: o }) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).forgotPasswordSubmit(t, n, o);
        });
    },
    handleForgotPassword (t) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            return (0, _awsAmplify.Auth).forgotPassword(t);
        });
    },
    validateCustomSignUp (t, s) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {});
    },
    validateFormPassword (t, s, o) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            const { password: r } = t, { password: e } = s;
            if (!e || !o) return null;
            const i = [], a = +(null == o ? void 0 : o.passwordPolicyMinLength);
            r.length < a && i.push(`Password must have at least ${a} characters`);
            const u = null == o ? void 0 : o.passwordPolicyCharacters;
            return null == u || u.forEach((t)=>{
                switch(t){
                    case "REQUIRES_LOWERCASE":
                        /[a-z]/.test(r) || i.push("Password must have lower case letters");
                        break;
                    case "REQUIRES_UPPERCASE":
                        /[A-Z]/.test(r) || i.push("Password must have upper case letters");
                        break;
                    case "REQUIRES_NUMBERS":
                        /[0-9]/.test(r) || i.push("Password must have numbers");
                        break;
                    case "REQUIRES_SYMBOLS":
                        (0, _utilsMjs.hasSpecialChars)(r) || i.push("Password must have special characters");
                }
            }), 0 !== i.length ? {
                password: i
            } : null;
        });
    },
    validateConfirmPassword (t, s) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
            const { password: r, confirm_password: n } = t, { confirm_password: o, password: e } = s;
            return r || n ? (r || n) && r !== n && (o && e || (null == r ? void 0 : r.length) >= 6 && (null == n ? void 0 : n.length) >= 6) ? {
                confirm_password: "Your passwords must match"
            } : void 0 : null;
        });
    },
    validatePreferredUsername (t, s) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {});
    }
};

},{"tslib":"86BcK","aws-amplify":"75VoS","../../types/authenticator/user.mjs":"aZbQw","../../types/authenticator/attributes.mjs":"2ngIN","../../types/primitives/componentClassName.mjs":"62ykl","../../i18n/translations.mjs":"jSmFc","../../helpers/authenticator/utils.mjs":"l02QH","../../helpers/accountSettings/utils.mjs":"2PkvP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"20SXQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signOutActor", ()=>i);
var _xstate = require("xstate");
var _awsAmplify = require("aws-amplify");
const i = (0, _xstate.createMachine)({
    initial: "pending",
    id: "signOutActor",
    predictableActionArguments: !0,
    states: {
        pending: {
            tags: [
                "pending"
            ],
            invoke: {
                src: "signOut",
                onDone: "resolved",
                onError: "rejected"
            }
        },
        resolved: {
            type: "final"
        },
        rejected: {
            type: "final"
        }
    }
}, {
    services: {
        signOut: ()=>(0, _awsAmplify.Auth).signOut()
    }
});

},{"xstate":"3RMsL","aws-amplify":"75VoS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kdZ2m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetPasswordActor", ()=>f);
var _tslib = require("tslib");
var _xstate = require("xstate");
var _indexMjs = require("../../../validators/index.mjs");
var _actionsMjs = require("../actions.mjs");
var _defaultServicesMjs = require("../defaultServices.mjs");
function f({ services: f }) {
    return (0, _xstate.createMachine)({
        id: "resetPasswordActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmResetPassword",
                        cond: "shouldAutoConfirmReset",
                        actions: "resendCode"
                    },
                    {
                        target: "resetPassword"
                    }
                ]
            },
            resetPassword: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            }
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "setUsername",
                            "clearError"
                        ],
                        invoke: {
                            src: "resetPassword",
                            onDone: {
                                target: "#resetPasswordActor.confirmResetPassword"
                            },
                            onError: {
                                actions: [
                                    "setRemoteError"
                                ],
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearUsername",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    RESEND: "resendCode",
                                    CHANGE: {
                                        actions: "handleInput"
                                    },
                                    BLUR: {
                                        actions: "handleBlur"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            resendCode: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "resetPassword",
                                    onDone: {
                                        target: "idle"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "confirmResetPassword",
                                    onDone: {
                                        actions: "clearUsername",
                                        target: "#resetPasswordActor.resolved"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final"
            }
        }
    }, {
        actions: {
            clearError: (0, _actionsMjs.clearError),
            clearFormValues: (0, _actionsMjs.clearFormValues),
            clearTouched: (0, _actionsMjs.clearTouched),
            clearUsername: (0, _actionsMjs.clearUsername),
            clearValidationError: (0, _actionsMjs.clearValidationError),
            handleInput: (0, _actionsMjs.handleInput),
            handleSubmit: (0, _actionsMjs.handleSubmit),
            handleBlur: (0, _actionsMjs.handleBlur),
            resendCode: (0, _actionsMjs.resendCode),
            setFieldErrors: (0, _actionsMjs.setFieldErrors),
            setRemoteError: (0, _actionsMjs.setRemoteError),
            setUsername: (0, _actionsMjs.setUsername),
            sendUpdate: (0, _xstate.sendUpdate)()
        },
        guards: {
            shouldAutoConfirmReset: (e, r)=>!(!e.intent || "confirmPasswordReset" !== e.intent)
        },
        services: {
            resetPassword (r) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { username: e } = r;
                    return f.handleForgotPassword(e);
                });
            },
            confirmResetPassword (r) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { username: e } = r, { confirmation_code: t, password: s } = r.formValues;
                    return f.handleForgotPasswordSubmit({
                        username: e,
                        code: t,
                        password: s
                    });
                });
            },
            validateFields (r, t) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    return (0, _indexMjs.runValidators)(r.formValues, r.touched, r.passwordSettings, [
                        (0, _defaultServicesMjs.defaultServices).validateFormPassword,
                        (0, _defaultServicesMjs.defaultServices).validateConfirmPassword
                    ]);
                });
            }
        }
    });
}

},{"tslib":"86BcK","xstate":"3RMsL","../../../validators/index.mjs":"gYqUC","../actions.mjs":"1nOrP","../defaultServices.mjs":"d5mT9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bdW5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSignUpMachine", ()=>y);
var _tslib = require("tslib");
var _awsAmplify = require("aws-amplify");
var _getJs = require("lodash/get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _pickByJs = require("lodash/pickBy.js");
var _pickByJsDefault = parcelHelpers.interopDefault(_pickByJs);
var _xstate = require("xstate");
var _indexMjs = require("../../validators/index.mjs");
var _actionsMjs = require("./actions.mjs");
function y({ services: y }) {
    return (0, _xstate.createMachine)({
        id: "signUpActor",
        initial: "init",
        predictableActionArguments: !0,
        states: {
            init: {
                always: [
                    {
                        target: "confirmSignUp",
                        cond: "shouldInitConfirmSignUp"
                    },
                    {
                        target: "signUp"
                    }
                ]
            },
            signUp: {
                type: "parallel",
                exit: [
                    "clearError",
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    FEDERATED_SIGN_IN: "federatedSignIn"
                                }
                            },
                            federatedSignIn: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "federatedSignIn",
                                    onDone: "#signUpActor.resolved",
                                    onError: {
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            pending: {
                                tags: [
                                    "pending"
                                ],
                                entry: [
                                    "parsePhoneNumber",
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "signUp",
                                    onDone: [
                                        {
                                            cond: "shouldSkipConfirm",
                                            target: "skipConfirm",
                                            actions: [
                                                "setUser",
                                                "setCredentials"
                                            ]
                                        },
                                        {
                                            target: "resolved",
                                            actions: [
                                                "setUser",
                                                "setCredentials",
                                                "setCodeDeliveryDetails"
                                            ]
                                        }
                                    ],
                                    onError: {
                                        target: "idle",
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            skipConfirm: {
                                always: {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent"
                                }
                            },
                            resolved: {
                                type: "final",
                                always: "#signUpActor.confirmSignUp"
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: "edit",
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            },
                            RESEND: "resend"
                        }
                    },
                    resend: {
                        tags: [
                            "pending"
                        ],
                        entry: "sendUpdate",
                        invoke: {
                            src: "resendConfirmationCode",
                            onDone: {
                                target: "edit"
                            },
                            onError: [
                                {
                                    target: "#signUpActor.resolved",
                                    actions: "setAutoSignInIntent",
                                    cond: "isUserAlreadyConfirmed"
                                },
                                {
                                    target: "edit",
                                    actions: "setRemoteError"
                                }
                            ]
                        }
                    },
                    submit: {
                        tags: [
                            "pending"
                        ],
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "confirmSignUp",
                            onDone: {
                                target: "#signUpActor.resolved",
                                actions: "setAutoSignInIntent"
                            },
                            onError: {
                                target: "edit",
                                actions: "setRemoteError"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (e, t)=>{
                    const { username: r, password: i } = e.authAttributes;
                    return {
                        user: (0, _getJsDefault.default)(t, "data.user") || e.user,
                        authAttributes: {
                            username: r,
                            password: i
                        },
                        intent: e.intent
                    };
                }
            }
        }
    }, {
        guards: {
            isUserAlreadyConfirmed: (e, t)=>"User is already confirmed." === t.data.message,
            shouldInitConfirmSignUp: (e)=>e.intent && "confirmSignUp" === e.intent,
            shouldSkipConfirm: (e, t)=>t.data.userConfirmed
        },
        actions: {
            clearError: (0, _actionsMjs.clearError),
            clearFormValues: (0, _actionsMjs.clearFormValues),
            clearTouched: (0, _actionsMjs.clearTouched),
            clearValidationError: (0, _actionsMjs.clearValidationError),
            handleInput: (0, _actionsMjs.handleInput),
            handleSubmit: (0, _actionsMjs.handleSubmit),
            handleBlur: (0, _actionsMjs.handleBlur),
            parsePhoneNumber: (0, _actionsMjs.parsePhoneNumber),
            setCredentials: (0, _actionsMjs.setCredentials),
            setFieldErrors: (0, _actionsMjs.setFieldErrors),
            setRemoteError: (0, _actionsMjs.setRemoteError),
            setCodeDeliveryDetails: (0, _actionsMjs.setCodeDeliveryDetails),
            setUser: (0, _actionsMjs.setUser),
            sendUpdate: (0, _xstate.sendUpdate)(),
            setAutoSignInIntent: (0, _xstate.assign)({
                intent: (e)=>"confirmSignUp" === (null == e ? void 0 : e.intent) ? "autoSignInSubmit" : "autoSignIn"
            })
        },
        services: {
            confirmSignUp (t, r) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { user: e, authAttributes: r, formValues: i } = t, { confirmation_code: a } = i, s = (0, _getJsDefault.default)(e, "username") || (0, _getJsDefault.default)(r, "username");
                    return yield y.handleConfirmSignUp({
                        username: s,
                        code: a
                    });
                });
            },
            resendConfirmationCode (r, i) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { user: e, authAttributes: i } = r, a = (0, _getJsDefault.default)(e, "username") || (0, _getJsDefault.default)(i, "username");
                    return (0, _awsAmplify.Auth).resendSignUp(a);
                });
            },
            federatedSignIn (n, r) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { provider: e } = r.data;
                    return yield (0, _awsAmplify.Auth).federatedSignIn({
                        provider: e
                    });
                });
            },
            signUp (t, n) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    const { formValues: e, loginMechanisms: n } = t, [i = "username"] = n, { [i]: a, password: s } = e, o = (0, _pickByJsDefault.default)(e, (e, t)=>{
                        switch(t){
                            case "address":
                            case "birthdate":
                            case "email":
                            case "family_name":
                            case "gender":
                            case "given_name":
                            case "locale":
                            case "middle_name":
                            case "name":
                            case "nickname":
                            case "phone_number":
                            case "picture":
                            case "preferred_username":
                            case "profile":
                            case "updated_at":
                            case "website":
                            case "zoneinfo":
                                return !0;
                            default:
                                return t.startsWith("custom:");
                        }
                    });
                    return yield y.handleSignUp({
                        username: a,
                        password: s,
                        attributes: o
                    });
                });
            },
            validateSignUp (t, n) {
                return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    return (0, _indexMjs.runValidators)(t.formValues, t.touched, t.passwordSettings, [
                        y.validateFormPassword,
                        y.validateConfirmPassword,
                        y.validatePreferredUsername,
                        y.validateCustomSignUp
                    ]);
                });
            }
        }
    });
}

},{"tslib":"86BcK","aws-amplify":"75VoS","lodash/get.js":"jeneQ","lodash/pickBy.js":"fTum2","xstate":"3RMsL","../../validators/index.mjs":"gYqUC","./actions.mjs":"1nOrP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fTum2":[function(require,module,exports) {
var arrayMap = require("6fd113b3f5002de4"), baseIteratee = require("1e32e0d8feab18e"), basePickBy = require("85ba60b03da46517"), getAllKeysIn = require("86922ee5dcf85621");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6fd113b3f5002de4":"5ZiZU","1e32e0d8feab18e":"exkHY","85ba60b03da46517":"ftzWM","86922ee5dcf85621":"7M3rF"}],"exkHY":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"kQvtM","4f010869f7b63154":"40Y25","28f06147d1eb9502":"6wIyV","3c56f88c4debf449":"jQGs4","aee920e0ef5bf111":"bqkBM"}],"kQvtM":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"6SF7t","89e9034a8071e297":"8Db3c","782598b150762386":"kQM3q"}],"6SF7t":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"hxIkB","9003c0cc8ac007b6":"aP9FI"}],"8Db3c":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"lUKa0","94ffded3a85af2f6":"kLvI9"}],"lUKa0":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"8ffGS"}],"kQM3q":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"40Y25":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"aP9FI","d5ca180f7d6f956a":"jeneQ","3462bb3f546fa1f7":"bW9UX","f5fef07966a1c4ee":"gbNmb","2a1cd212d48516":"lUKa0","885e72ee7fc6d296":"kQM3q","cd65eaf4a3af29f6":"ih6jk"}],"bW9UX":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"doFfX","b0aefd36de99e579":"9BvOi"}],"doFfX":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"9BvOi":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"cLKKN","47ffafdab3ba0d6f":"jmDAu","93ebd263ff0131c1":"jQGs4","252ef74480e01958":"heeP8","23c2f64e75e90a2":"f9Q8Z","af5ade297cb685ee":"ih6jk"}],"bqkBM":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"4T5ep","abf31da39349df22":"d0kRt","a387ef4a4373de2c":"gbNmb","9315973458389ae7":"ih6jk"}],"4T5ep":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"d0kRt":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"3bgbL"}],"ftzWM":[function(require,module,exports) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"3bgbL","b07dbab95dca4167":"dfWQP","64b51364f27b9088":"cLKKN"}],"dfWQP":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"5IHI0","56e0b8a492d56399":"cLKKN","d1eb8acc5a65dc38":"heeP8","dfb182b16ef275c0":"8ffGS","6a51dc787ca5b6e3":"ih6jk"}],"7M3rF":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"1VPsK","feede5d0a2d06427":"iT0tM","287f70f798405911":"fCgzE"}],"iT0tM":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"iS8Vi","6ccae2aa7cfa3c66":"fiIZQ","bdb501682ee9305d":"9pWhx","7641fe4ae6d2cc96":"hZ3M8"}],"9hjHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTheme", ()=>s);
var _deepExtendJs = require("style-dictionary/lib/utils/deepExtend.js");
var _deepExtendJsDefault = parcelHelpers.interopDefault(_deepExtendJs);
var _flattenPropertiesJs = require("style-dictionary/lib/utils/flattenProperties.js");
var _flattenPropertiesJsDefault = parcelHelpers.interopDefault(_flattenPropertiesJs);
var _defaultThemeMjs = require("./defaultTheme.mjs");
var _utilsMjs = require("./utils.mjs");
const r = ({ token: e, path: n })=>{
    const o = `--${(0, _utilsMjs.cssNameTransform)({
        path: n
    })}`, { value: t } = e, r = (0, _utilsMjs.cssValue)(e);
    return {
        name: o,
        original: t,
        path: n,
        value: r,
        toString: ()=>`var(${o})`
    };
};
function s(a, i = (0, _defaultThemeMjs.defaultTheme)) {
    const s = (0, _deepExtendJsDefault.default)([
        {},
        i,
        a
    ]), m = (0, _utilsMjs.setupTokens)({
        tokens: s.tokens,
        setupToken: r
    }), { breakpoints: l, name: p } = s;
    let d = `[data-amplify-theme="${p}"] {\n` + (0, _flattenPropertiesJsDefault.default)(m).map((e)=>`${e.name}: ${e.value};`).join("\n") + "\n}\n", c = [];
    return s.overrides && (c = s.overrides.map((e)=>{
        const o = (0, _utilsMjs.setupTokens)({
            tokens: e.tokens,
            setupToken: r
        }), a = (0, _flattenPropertiesJsDefault.default)(o).map((e)=>`${e.name}: ${e.value};`).join("\n");
        if ("selector" in e && (d += `\n${e.selector} {\n${a}\n}\n`), "mediaQuery" in e && (d += `\n@media (${e.mediaQuery}) {\n  [data-amplify-theme="${p}"] {\n    ${a}\n  }\n}\n`), "breakpoint" in e) {
            const n = s.breakpoints.values[e.breakpoint];
            d += `\n@media (min-width: ${n}px) {\n  [data-amplify-theme="${p}"] {\n    ${a}\n  }\n}\n`;
        }
        return "colorMode" in e && (d += `\n@media (prefers-color-scheme: ${e.colorMode}) {\n          [data-amplify-theme="${p}"][data-amplify-color-mode="system"] {\n            ${a}\n            color-scheme: ${e.colorMode};\n          }\n        }\n`, d += `\n[data-amplify-theme="${p}"][data-amplify-color-mode="${e.colorMode}"] {\n          ${a}\n          color-scheme: ${e.colorMode};\n        }\n`), Object.assign(Object.assign({}, e), {
            tokens: o
        });
    })), {
        tokens: m,
        breakpoints: l,
        name: p,
        cssText: d,
        overrides: c
    };
}

},{"style-dictionary/lib/utils/deepExtend.js":"g06QZ","style-dictionary/lib/utils/flattenProperties.js":"k1TM5","./defaultTheme.mjs":"fwsDH","./utils.mjs":"7CFl2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g06QZ":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var _ = require("2fa5696e1550b9ad");
/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function deepExtend(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object") target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!options.hasOwnProperty(name)) continue;
            if (name === "__proto__") continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && (_.isPlainObject(copy) || (copyIsArray = _.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && _.isArray(src) ? src : [];
                } else clone = src && _.isPlainObject(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = deepExtend([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == "function") collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}
module.exports = deepExtend;

},{"2fa5696e1550b9ad":"bveN6"}],"bveN6":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const ChangeCase = require("111a842de5b15e59");
const reduce = function(obj, f, accumulator_init) {
    return Object.keys(obj || {}).reduce((accumulator, key)=>{
        let value = obj[key];
        return f(accumulator, value, key, obj);
    }, accumulator_init);
};
const forEach = function(obj, f) {
    Object.keys(obj || {}).forEach((key)=>{
        let value = obj[key];
        f(value, key);
    });
};
// Note: This is a crappy version to a certain extent... don't use with Strings, for example...
const clone = function(object) {
    return Object.assign(new object.constructor(), object);
};
const cloneDeep = function(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object") return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = cloneDeep(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = cloneDeep(obj[key]);
        return cpObj;
    }, {});
};
const isObject = function(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
};
const isString = function(obj) {
    return typeof obj === "string" || obj instanceof String;
};
const isArray = function(obj) {
    return Array.isArray(obj);
};
const isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
function isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
const filter = function(arr, filter) {
    if (typeof filter !== "function") throw "filter is not a function";
    if (typeof arr === "undefined") return [];
    return arr.filter(filter);
};
const assign = function() {
    let args = Array.prototype.slice.call(arguments);
    args.unshift({});
    return Object.assign(...args);
};
/* global Set */ const pull = function(arr, ...removeList) {
    var removeSet = new Set(removeList);
    for(let i = arr.length - 1; i >= 0; i--)if (removeSet.has(arr[i])) arr.splice(i, 1);
};
const unique = function(arr) {
    return [
        ...new Set(arr)
    ];
};
const upperFirst = function(str) {
    return str ? str[0].toUpperCase() + str.substr(1) : "";
};
const matchFn = function(inputObj, testObj) {
    if (isObject(testObj)) return Object.keys(testObj).every((key)=>matchFn(inputObj[key], testObj[key]));
    else return inputObj == testObj;
};
const matches = function(matchObj) {
    let cloneObj = cloneDeep(matchObj);
    let matchesFn = (inputObj)=>matchFn(inputObj, cloneObj);
    return matchesFn;
};
const DEFAULT_OPTIONS = {
    transform: ChangeCase.camelCaseTransformMerge
};
const changeDefaultCaseTransform = function(caseFunction, default_options) {
    return (caseToChange, options)=>caseFunction(caseToChange, Object.assign({}, DEFAULT_OPTIONS, default_options, options));
};
module.exports = {
    each: forEach,
    forEach: forEach,
    forIn: forEach,
    keys: Object.keys,
    clone: clone,
    cloneDeep: cloneDeep,
    extend: Object.assign,
    isString: isString,
    isArray: isArray,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isEmpty: isEmpty,
    filter: filter,
    reduce: reduce,
    assign: assign,
    upperFirst: upperFirst,
    camelCase: changeDefaultCaseTransform(ChangeCase.camelCase),
    snakeCase: ChangeCase.snakeCase,
    kebabCase: ChangeCase.paramCase,
    pull: pull,
    matches: matches,
    unique: unique
};

},{"111a842de5b15e59":"hpCCc"}],"hpCCc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _camelCase = require("camel-case");
parcelHelpers.exportAll(_camelCase, exports);
var _capitalCase = require("capital-case");
parcelHelpers.exportAll(_capitalCase, exports);
var _constantCase = require("constant-case");
parcelHelpers.exportAll(_constantCase, exports);
var _dotCase = require("dot-case");
parcelHelpers.exportAll(_dotCase, exports);
var _headerCase = require("header-case");
parcelHelpers.exportAll(_headerCase, exports);
var _noCase = require("no-case");
parcelHelpers.exportAll(_noCase, exports);
var _paramCase = require("param-case");
parcelHelpers.exportAll(_paramCase, exports);
var _pascalCase = require("pascal-case");
parcelHelpers.exportAll(_pascalCase, exports);
var _pathCase = require("path-case");
parcelHelpers.exportAll(_pathCase, exports);
var _sentenceCase = require("sentence-case");
parcelHelpers.exportAll(_sentenceCase, exports);
var _snakeCase = require("snake-case");
parcelHelpers.exportAll(_snakeCase, exports);

},{"camel-case":"kh8nB","capital-case":"k57Vj","constant-case":"bEe6G","dot-case":"2sPM5","header-case":"2l3uy","no-case":"2bt4M","param-case":"kC7zP","pascal-case":"95KGo","path-case":"fYFkc","sentence-case":"5rMWB","snake-case":"3rTxV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kh8nB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseTransform", ()=>camelCaseTransform);
parcelHelpers.export(exports, "camelCaseTransformMerge", ()=>camelCaseTransformMerge);
parcelHelpers.export(exports, "camelCase", ()=>camelCase);
var _tslib = require("tslib");
var _pascalCase = require("pascal-case");
function camelCaseTransform(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, _pascalCase.pascalCaseTransform)(input, index);
}
function camelCaseTransformMerge(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, _pascalCase.pascalCaseTransformMerge)(input);
}
function camelCase(input, options) {
    if (options === void 0) options = {};
    return (0, _pascalCase.pascalCase)(input, (0, _tslib.__assign)({
        transform: camelCaseTransform
    }, options));
}

},{"tslib":"86BcK","pascal-case":"95KGo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"95KGo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pascalCaseTransform", ()=>pascalCaseTransform);
parcelHelpers.export(exports, "pascalCaseTransformMerge", ()=>pascalCaseTransformMerge);
parcelHelpers.export(exports, "pascalCase", ()=>pascalCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
function pascalCaseTransform(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCaseTransformMerge(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function pascalCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "",
        transform: pascalCaseTransform
    }, options));
}

},{"tslib":"86BcK","no-case":"2bt4M","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2bt4M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Normalize the string into something other libraries can manipulate easier.
 */ parcelHelpers.export(exports, "noCase", ()=>noCase);
var _lowerCase = require("lower-case");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, _lowerCase.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\x00$2"), stripRegexp, "\x00");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\x00")start++;
    while(result.charAt(end - 1) === "\x00")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\x00").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

},{"lower-case":"71jP6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"71jP6":[function(require,module,exports) {
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Localized lower case.
 */ parcelHelpers.export(exports, "localeLowerCase", ()=>localeLowerCase);
/**
 * Lower case as a function.
 */ parcelHelpers.export(exports, "lowerCase", ()=>lowerCase);
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            \u00CC: "i\u0307\u0300",
            \u00CD: "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function localeLowerCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return lowerCase(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return lowerCase(str);
}
function lowerCase(str) {
    return str.toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k57Vj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalCaseTransform", ()=>capitalCaseTransform);
parcelHelpers.export(exports, "capitalCase", ()=>capitalCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCaseFirst = require("upper-case-first");
function capitalCaseTransform(input) {
    return (0, _upperCaseFirst.upperCaseFirst)(input.toLowerCase());
}
function capitalCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: " ",
        transform: capitalCaseTransform
    }, options));
}

},{"tslib":"86BcK","no-case":"2bt4M","upper-case-first":"66vv0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"66vv0":[function(require,module,exports) {
/**
 * Upper case the first character of an input string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "upperCaseFirst", ()=>upperCaseFirst);
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bEe6G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantCase", ()=>constantCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCase = require("upper-case");
function constantCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "_",
        transform: (0, _upperCase.upperCase)
    }, options));
}

},{"tslib":"86BcK","no-case":"2bt4M","upper-case":"9YxOr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9YxOr":[function(require,module,exports) {
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Localized upper case.
 */ parcelHelpers.export(exports, "localeUpperCase", ()=>localeUpperCase);
/**
 * Upper case as a function.
 */ parcelHelpers.export(exports, "upperCase", ()=>upperCase);
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    az: {
        regexp: /[\u0069]/g,
        map: {
            i: "\u0130"
        }
    },
    lt: {
        regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
        map: {
            i\u0307: "I",
            j\u0307: "J",
            \u012F\u0307: "\u012E",
            i\u0307\u0300: "\xcc",
            i\u0307\u0301: "\xcd",
            i\u0307\u0303: "\u0128"
        }
    }
};
function localeUpperCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return upperCase(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return upperCase(str);
}
function upperCase(str) {
    return str.toUpperCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2sPM5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dotCase", ()=>dotCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
function dotCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: "."
    }, options));
}

},{"tslib":"86BcK","no-case":"2bt4M","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2l3uy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "headerCase", ()=>headerCase);
var _tslib = require("tslib");
var _capitalCase = require("capital-case");
function headerCase(input, options) {
    if (options === void 0) options = {};
    return (0, _capitalCase.capitalCase)(input, (0, _tslib.__assign)({
        delimiter: "-"
    }, options));
}

},{"tslib":"86BcK","capital-case":"k57Vj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kC7zP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paramCase", ()=>paramCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function paramCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "-"
    }, options));
}

},{"tslib":"86BcK","dot-case":"2sPM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fYFkc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pathCase", ()=>pathCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function pathCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "/"
    }, options));
}

},{"tslib":"86BcK","dot-case":"2sPM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5rMWB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sentenceCaseTransform", ()=>sentenceCaseTransform);
parcelHelpers.export(exports, "sentenceCase", ()=>sentenceCase);
var _tslib = require("tslib");
var _noCase = require("no-case");
var _upperCaseFirst = require("upper-case-first");
function sentenceCaseTransform(input, index) {
    var result = input.toLowerCase();
    if (index === 0) return (0, _upperCaseFirst.upperCaseFirst)(result);
    return result;
}
function sentenceCase(input, options) {
    if (options === void 0) options = {};
    return (0, _noCase.noCase)(input, (0, _tslib.__assign)({
        delimiter: " ",
        transform: sentenceCaseTransform
    }, options));
}

},{"tslib":"86BcK","no-case":"2bt4M","upper-case-first":"66vv0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rTxV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "snakeCase", ()=>snakeCase);
var _tslib = require("tslib");
var _dotCase = require("dot-case");
function snakeCase(input, options) {
    if (options === void 0) options = {};
    return (0, _dotCase.dotCase)(input, (0, _tslib.__assign)({
        delimiter: "_"
    }, options));
}

},{"tslib":"86BcK","dot-case":"2sPM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k1TM5":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var _ = require("d897e869287e0b63");
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function flattenProperties(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if (properties.hasOwnProperty(name)) {
        // TODO: this is a bit fragile and arbitrary to stop when we get to a 'value' property.
        if (_.isPlainObject(properties[name]) && "value" in properties[name]) to_ret.push(properties[name]);
        else if (_.isPlainObject(properties[name])) flattenProperties(properties[name], to_ret);
    }
    return to_ret;
}
module.exports = flattenProperties;

},{"d897e869287e0b63":"bveN6"}],"fwsDH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTheme", ()=>t);
var _indexMjs = require("./tokens/index.mjs");
var _breakpointsMjs = require("./breakpoints.mjs");
const t = {
    tokens: (0, _indexMjs.tokens),
    breakpoints: (0, _breakpointsMjs.breakpoints),
    name: "default-theme"
};

},{"./tokens/index.mjs":"11JYE","./breakpoints.mjs":"4QWBQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"11JYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reactNativeTokens", ()=>h);
parcelHelpers.export(exports, "tokens", ()=>c);
var _borderWidthsMjs = require("./borderWidths.mjs");
var _colorsMjs = require("./colors.mjs");
var _indexMjs = require("./components/index.mjs");
var _fontsMjs = require("./fonts.mjs");
var _fontSizesMjs = require("./fontSizes.mjs");
var _fontWeightsMjs = require("./fontWeights.mjs");
var _lineHeightsMjs = require("./lineHeights.mjs");
var _opacitiesMjs = require("./opacities.mjs");
var _outlineOffsetsMjs = require("./outlineOffsets.mjs");
var _outlineWidthsMjs = require("./outlineWidths.mjs");
var _radiiMjs = require("./radii.mjs");
var _shadowsMjs = require("./shadows.mjs");
var _spaceMjs = require("./space.mjs");
var _timeMjs = require("./time.mjs");
var _transformsMjs = require("./transforms.mjs");
const c = {
    components: (0, _indexMjs.components),
    borderWidths: (0, _borderWidthsMjs.borderWidths),
    colors: (0, _colorsMjs.colors),
    fonts: (0, _fontsMjs.fonts),
    fontSizes: (0, _fontSizesMjs.fontSizes),
    fontWeights: (0, _fontWeightsMjs.fontWeights),
    lineHeights: (0, _lineHeightsMjs.lineHeights),
    opacities: (0, _opacitiesMjs.opacities),
    outlineOffsets: (0, _outlineOffsetsMjs.outlineOffsets),
    outlineWidths: (0, _outlineWidthsMjs.outlineWidths),
    radii: (0, _radiiMjs.radii),
    shadows: (0, _shadowsMjs.shadows),
    space: (0, _spaceMjs.space),
    time: (0, _timeMjs.time),
    transforms: (0, _transformsMjs.transforms)
}, h = {
    colors: (0, _colorsMjs.colors),
    borderWidths: (0, _borderWidthsMjs.borderWidths),
    fontSizes: {
        xxs: (0, _fontSizesMjs.fontSizes).xxs,
        xs: (0, _fontSizesMjs.fontSizes).xs,
        small: (0, _fontSizesMjs.fontSizes).small,
        medium: (0, _fontSizesMjs.fontSizes).medium,
        large: (0, _fontSizesMjs.fontSizes).large,
        xl: (0, _fontSizesMjs.fontSizes).xl,
        xxl: (0, _fontSizesMjs.fontSizes).xxl,
        xxxl: (0, _fontSizesMjs.fontSizes).xxxl
    },
    fontWeights: (0, _fontWeightsMjs.fontWeights),
    opacities: (0, _opacitiesMjs.opacities),
    space: {
        xxs: (0, _spaceMjs.space).xxxs,
        xs: (0, _spaceMjs.space).xs,
        small: (0, _spaceMjs.space).small,
        medium: (0, _spaceMjs.space).medium,
        large: (0, _spaceMjs.space).large,
        xl: (0, _spaceMjs.space).xl,
        xxl: (0, _spaceMjs.space).xxl,
        xxxl: (0, _spaceMjs.space).xxxl
    },
    radii: (0, _radiiMjs.radii),
    time: (0, _timeMjs.time)
};

},{"./borderWidths.mjs":"aeFO0","./colors.mjs":"7zvq9","./components/index.mjs":"8gSGf","./fonts.mjs":"entyO","./fontSizes.mjs":"4RIty","./fontWeights.mjs":"54l4m","./lineHeights.mjs":"frjkZ","./opacities.mjs":"4Vtzt","./outlineOffsets.mjs":"htu6g","./outlineWidths.mjs":"d23me","./radii.mjs":"hC4ls","./shadows.mjs":"88Dmp","./space.mjs":"fuejH","./time.mjs":"lL4tw","./transforms.mjs":"7UMsE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aeFO0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderWidths", ()=>e);
const e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7zvq9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colors", ()=>l);
const l = {
    red: {
        10: {
            value: "hsl(0, 75%, 95%)"
        },
        20: {
            value: "hsl(0, 75%, 85%)"
        },
        40: {
            value: "hsl(0, 75%, 75%)"
        },
        60: {
            value: "hsl(0, 50%, 50%)"
        },
        80: {
            value: "hsl(0, 95%, 30%)"
        },
        90: {
            value: "hsl(0, 100%, 20%)"
        },
        100: {
            value: "hsl(0, 100%, 15%)"
        }
    },
    orange: {
        10: {
            value: "hsl(30, 75%, 95%)"
        },
        20: {
            value: "hsl(30, 75%, 85%)"
        },
        40: {
            value: "hsl(30, 75%, 75%)"
        },
        60: {
            value: "hsl(30, 50%, 50%)"
        },
        80: {
            value: "hsl(30, 95%, 30%)"
        },
        90: {
            value: "hsl(30, 100%, 20%)"
        },
        100: {
            value: "hsl(30, 100%, 15%)"
        }
    },
    yellow: {
        10: {
            value: "hsl(60, 75%, 95%)"
        },
        20: {
            value: "hsl(60, 75%, 85%)"
        },
        40: {
            value: "hsl(60, 75%, 75%)"
        },
        60: {
            value: "hsl(60, 50%, 50%)"
        },
        80: {
            value: "hsl(60, 95%, 30%)"
        },
        90: {
            value: "hsl(60, 100%, 20%)"
        },
        100: {
            value: "hsl(60, 100%, 15%)"
        }
    },
    green: {
        10: {
            value: "hsl(130, 60%, 95%)"
        },
        20: {
            value: "hsl(130, 60%, 90%)"
        },
        40: {
            value: "hsl(130, 44%, 63%)"
        },
        60: {
            value: "hsl(130, 43%, 46%)"
        },
        80: {
            value: "hsl(130, 33%, 37%)"
        },
        90: {
            value: "hsl(130, 27%, 29%)"
        },
        100: {
            value: "hsl(130, 22%, 23%)"
        }
    },
    teal: {
        10: {
            value: "hsl(190, 75%, 95%)"
        },
        20: {
            value: "hsl(190, 75%, 85%)"
        },
        40: {
            value: "hsl(190, 70%, 70%)"
        },
        60: {
            value: "hsl(190, 50%, 50%)"
        },
        80: {
            value: "hsl(190, 95%, 30%)"
        },
        90: {
            value: "hsl(190, 100%, 20%)"
        },
        100: {
            value: "hsl(190, 100%, 15%)"
        }
    },
    blue: {
        10: {
            value: "hsl(220, 95%, 95%)"
        },
        20: {
            value: "hsl(220, 85%, 85%)"
        },
        40: {
            value: "hsl(220, 70%, 70%)"
        },
        60: {
            value: "hsl(220, 50%, 50%)"
        },
        80: {
            value: "hsl(220, 95%, 30%)"
        },
        90: {
            value: "hsl(220, 100%, 20%)"
        },
        100: {
            value: "hsl(220, 100%, 15%)"
        }
    },
    purple: {
        10: {
            value: "hsl(300, 95%, 95%)"
        },
        20: {
            value: "hsl(300, 85%, 85%)"
        },
        40: {
            value: "hsl(300, 70%, 70%)"
        },
        60: {
            value: "hsl(300, 50%, 50%)"
        },
        80: {
            value: "hsl(300, 95%, 30%)"
        },
        90: {
            value: "hsl(300, 100%, 20%)"
        },
        100: {
            value: "hsl(300, 100%, 15%)"
        }
    },
    pink: {
        10: {
            value: "hsl(340, 95%, 95%)"
        },
        20: {
            value: "hsl(340, 90%, 85%)"
        },
        40: {
            value: "hsl(340, 70%, 70%)"
        },
        60: {
            value: "hsl(340, 50%, 50%)"
        },
        80: {
            value: "hsl(340, 95%, 30%)"
        },
        90: {
            value: "hsl(340, 100%, 20%)"
        },
        100: {
            value: "hsl(340, 100%, 15%)"
        }
    },
    neutral: {
        10: {
            value: "hsl(210, 5%, 98%)"
        },
        20: {
            value: "hsl(210, 5%, 94%)"
        },
        40: {
            value: "hsl(210, 5%, 87%)"
        },
        60: {
            value: "hsl(210, 10%, 58%)"
        },
        80: {
            value: "hsl(210, 10%, 40%)"
        },
        90: {
            value: "hsl(210, 25%, 25%)"
        },
        100: {
            value: "hsl(210, 50%, 10%)"
        }
    },
    brand: {
        primary: {
            10: {
                value: "{colors.teal.10.value}"
            },
            20: {
                value: "{colors.teal.20.value}"
            },
            40: {
                value: "{colors.teal.40.value}"
            },
            60: {
                value: "{colors.teal.60.value}"
            },
            80: {
                value: "{colors.teal.80.value}"
            },
            90: {
                value: "{colors.teal.90.value}"
            },
            100: {
                value: "{colors.teal.100.value}"
            }
        },
        secondary: {
            10: {
                value: "{colors.purple.10.value}"
            },
            20: {
                value: "{colors.purple.20.value}"
            },
            40: {
                value: "{colors.purple.40.value}"
            },
            60: {
                value: "{colors.purple.60.value}"
            },
            80: {
                value: "{colors.purple.80.value}"
            },
            90: {
                value: "{colors.purple.90.value}"
            },
            100: {
                value: "{colors.purple.100.value}"
            }
        }
    },
    font: {
        primary: {
            value: "{colors.neutral.100.value}"
        },
        secondary: {
            value: "{colors.neutral.90.value}"
        },
        tertiary: {
            value: "{colors.neutral.80.value}"
        },
        disabled: {
            value: "{colors.neutral.60.value}"
        },
        inverse: {
            value: "{colors.white.value}"
        },
        interactive: {
            value: "{colors.brand.primary.80.value}"
        },
        hover: {
            value: "{colors.brand.primary.90.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        active: {
            value: "{colors.brand.primary.100.value}"
        },
        info: {
            value: "{colors.blue.90.value}"
        },
        warning: {
            value: "{colors.orange.90.value}"
        },
        error: {
            value: "{colors.red.90.value}"
        },
        success: {
            value: "{colors.green.90.value}"
        }
    },
    background: {
        primary: {
            value: "{colors.white.value}"
        },
        secondary: {
            value: "{colors.neutral.10.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        quaternary: {
            value: "{colors.neutral.60.value}"
        },
        disabled: {
            value: "{colors.background.tertiary.value}"
        },
        info: {
            value: "{colors.blue.10.value}"
        },
        warning: {
            value: "{colors.orange.10.value}"
        },
        error: {
            value: "{colors.red.10.value}"
        },
        success: {
            value: "{colors.green.10.value}"
        }
    },
    border: {
        primary: {
            value: "{colors.neutral.60.value}"
        },
        secondary: {
            value: "{colors.neutral.40.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        disabled: {
            value: "{colors.border.tertiary.value}"
        },
        pressed: {
            value: "{colors.brand.primary.100.value}"
        },
        focus: {
            value: "{colors.brand.primary.100.value}"
        },
        error: {
            value: "{colors.red.80.value}"
        },
        info: {
            value: "{colors.blue.80.value}"
        },
        success: {
            value: "{colors.green.80.value}"
        },
        warning: {
            value: "{colors.orange.80.value}"
        }
    },
    shadow: {
        primary: {
            value: "hsla(210, 50%, 10%, 0.25)"
        },
        secondary: {
            value: "hsla(210, 50%, 10%, 0.15)"
        },
        tertiary: {
            value: "hsla(210, 50%, 10%, 0.05)"
        }
    },
    overlay: {
        5: {
            value: "hsla(0, 0%, 0%, 0.05)"
        },
        10: {
            value: "hsla(0, 0%, 0%, 0.1)"
        },
        20: {
            value: "hsla(0, 0%, 0%, 0.2)"
        },
        30: {
            value: "hsla(0, 0%, 0%, 0.3)"
        },
        40: {
            value: "hsla(0, 0%, 0%, 0.4)"
        },
        50: {
            value: "hsla(0, 0%, 0%, 0.5)"
        },
        60: {
            value: "hsla(0, 0%, 0%, 0.6)"
        },
        70: {
            value: "hsla(0, 0%, 0%, 0.7)"
        },
        80: {
            value: "hsla(0, 0%, 0%, 0.8)"
        },
        90: {
            value: "hsla(0, 0%, 0%, 0.9)"
        }
    },
    black: {
        value: "hsl(0, 0%, 0%)"
    },
    white: {
        value: "hsl(0, 0%, 100%)"
    },
    transparent: {
        value: "transparent"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8gSGf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "components", ()=>mm);
var _alertMjs = require("./alert.mjs");
var _autocompleteMjs = require("./autocomplete.mjs");
var _authenticatorMjs = require("./authenticator.mjs");
var _badgeMjs = require("./badge.mjs");
var _breadcrumbsMjs = require("./breadcrumbs.mjs");
var _buttonMjs = require("./button.mjs");
var _cardMjs = require("./card.mjs");
var _checkboxMjs = require("./checkbox.mjs");
var _checkboxFieldMjs = require("./checkboxField.mjs");
var _collectionMjs = require("./collection.mjs");
var _copyMjs = require("./copy.mjs");
var _dialCodeSelectMjs = require("./dialCodeSelect.mjs");
var _dividerMjs = require("./divider.mjs");
var _dropZoneMjs = require("./dropZone.mjs");
var _expanderMjs = require("./expander.mjs");
var _fieldMjs = require("./field.mjs");
var _fieldControlMjs = require("./fieldControl.mjs");
var _fieldGroupMjs = require("./fieldGroup.mjs");
var _fieldsetMjs = require("./fieldset.mjs");
var _fieldMessagesMjs = require("./fieldMessages.mjs");
var _fileUploaderMjs = require("./fileUploader.mjs");
var _flexMjs = require("./flex.mjs");
var _headingMjs = require("./heading.mjs");
var _highlightMatchMjs = require("./highlightMatch.mjs");
var _iconMjs = require("./icon.mjs");
var _inputMjs = require("./input.mjs");
var _imageMjs = require("./image.mjs");
var _inAppMessagingMjs = require("./inAppMessaging.mjs");
var _linkMjs = require("./link.mjs");
var _livenessMjs = require("./liveness.mjs");
var _loaderMjs = require("./loader.mjs");
var _menuMjs = require("./menu.mjs");
var _messageMjs = require("./message.mjs");
var _paginationMjs = require("./pagination.mjs");
var _passwordFieldMjs = require("./passwordField.mjs");
var _phoneNumberFieldMjs = require("./phoneNumberField.mjs");
var _placeholderMjs = require("./placeholder.mjs");
var _radioMjs = require("./radio.mjs");
var _radioGroupMjs = require("./radioGroup.mjs");
var _ratingMjs = require("./rating.mjs");
var _searchFieldMjs = require("./searchField.mjs");
var _selectMjs = require("./select.mjs");
var _selectFieldMjs = require("./selectField.mjs");
var _sliderFieldMjs = require("./sliderField.mjs");
var _stepperFieldMjs = require("./stepperField.mjs");
var _storagemanagerMjs = require("./storagemanager.mjs");
var _switchFieldMjs = require("./switchField.mjs");
var _tableMjs = require("./table.mjs");
var _tabsMjs = require("./tabs.mjs");
var _textMjs = require("./text.mjs");
var _textAreaFieldMjs = require("./textAreaField.mjs");
var _textFieldMjs = require("./textField.mjs");
var _toggleButtonMjs = require("./toggleButton.mjs");
var _toggleButtonGroupMjs = require("./toggleButtonGroup.mjs");
const mm = {
    alert: (0, _alertMjs.alert),
    authenticator: (0, _authenticatorMjs.authenticator),
    autocomplete: (0, _autocompleteMjs.autocomplete),
    badge: (0, _badgeMjs.badge),
    breadcrumbs: (0, _breadcrumbsMjs.breadcrumbs),
    button: (0, _buttonMjs.button),
    card: (0, _cardMjs.card),
    checkbox: (0, _checkboxMjs.checkbox),
    checkboxfield: (0, _checkboxFieldMjs.checkboxfield),
    collection: (0, _collectionMjs.collection),
    copy: (0, _copyMjs.copy),
    countrycodeselect: (0, _dialCodeSelectMjs.dialcodeselect),
    divider: (0, _dividerMjs.divider),
    dropzone: (0, _dropZoneMjs.dropzone),
    expander: (0, _expanderMjs.expander),
    field: (0, _fieldMjs.field),
    fieldcontrol: (0, _fieldControlMjs.fieldcontrol),
    fieldgroup: (0, _fieldGroupMjs.fieldgroup),
    fieldmessages: (0, _fieldMessagesMjs.fieldmessages),
    fieldset: (0, _fieldsetMjs.fieldset),
    fileuploader: (0, _fileUploaderMjs.fileuploader),
    flex: (0, _flexMjs.flex),
    heading: (0, _headingMjs.heading),
    icon: (0, _iconMjs.icon),
    highlightmatch: (0, _highlightMatchMjs.highlightmatch),
    image: (0, _imageMjs.image),
    inappmessaging: (0, _inAppMessagingMjs.inappmessaging),
    input: (0, _inputMjs.input),
    link: (0, _linkMjs.link),
    liveness: (0, _livenessMjs.liveness),
    loader: (0, _loaderMjs.loader),
    menu: (0, _menuMjs.menu),
    message: (0, _messageMjs.message),
    pagination: (0, _paginationMjs.pagination),
    passwordfield: (0, _passwordFieldMjs.passwordfield),
    phonenumberfield: (0, _phoneNumberFieldMjs.phonenumberfield),
    placeholder: (0, _placeholderMjs.placeholder),
    radio: (0, _radioMjs.radio),
    radiogroup: (0, _radioGroupMjs.radiogroup),
    rating: (0, _ratingMjs.rating),
    searchfield: (0, _searchFieldMjs.searchfield),
    select: (0, _selectMjs.select),
    selectfield: (0, _selectFieldMjs.selectfield),
    sliderfield: (0, _sliderFieldMjs.sliderfield),
    stepperfield: (0, _stepperFieldMjs.stepperfield),
    storagemanager: (0, _storagemanagerMjs.storagemanager),
    switchfield: (0, _switchFieldMjs.switchfield),
    table: (0, _tableMjs.table),
    tabs: (0, _tabsMjs.tabs),
    text: (0, _textMjs.text),
    textareafield: (0, _textAreaFieldMjs.textareafield),
    textfield: (0, _textFieldMjs.textfield),
    togglebutton: (0, _toggleButtonMjs.togglebutton),
    togglebuttongroup: (0, _toggleButtonGroupMjs.togglebuttongroup)
};

},{"./alert.mjs":"45FTq","./autocomplete.mjs":"5eHv0","./authenticator.mjs":"fxSDn","./badge.mjs":"21BDq","./breadcrumbs.mjs":"51G3i","./button.mjs":"405Gu","./card.mjs":"jrZqK","./checkbox.mjs":"kRQ0l","./checkboxField.mjs":"3Jeq6","./collection.mjs":"7Vg0y","./copy.mjs":"7QhRN","./dialCodeSelect.mjs":"kAYAt","./divider.mjs":"iUi3n","./dropZone.mjs":"cQ6m1","./expander.mjs":"9cg2h","./field.mjs":"4ap3G","./fieldControl.mjs":"jEWit","./fieldGroup.mjs":"fCMbF","./fieldset.mjs":"arkDd","./fieldMessages.mjs":"7zgg6","./fileUploader.mjs":"i0sPR","./flex.mjs":"3lX29","./heading.mjs":"4ePBU","./highlightMatch.mjs":"hNSxI","./icon.mjs":"dTTkk","./input.mjs":"2wZcE","./image.mjs":"7tw91","./inAppMessaging.mjs":"kuyO3","./link.mjs":"6EVH0","./liveness.mjs":"QHWp3","./loader.mjs":"2L7Ya","./menu.mjs":"ak8xi","./message.mjs":"dMJ54","./pagination.mjs":"j7qat","./passwordField.mjs":"3nVVZ","./phoneNumberField.mjs":"6sClw","./placeholder.mjs":"egn3M","./radio.mjs":"l0akA","./radioGroup.mjs":"4jQIP","./rating.mjs":"34BmB","./searchField.mjs":"6FJEa","./select.mjs":"7ppYG","./selectField.mjs":"dcBBC","./sliderField.mjs":"fXR9l","./stepperField.mjs":"jB2fS","./storagemanager.mjs":"lIP8U","./switchField.mjs":"lhDT8","./table.mjs":"lHoQb","./tabs.mjs":"2kXgs","./text.mjs":"ic6I1","./textAreaField.mjs":"kosnw","./textField.mjs":"6rjIO","./toggleButton.mjs":"gIksm","./toggleButtonGroup.mjs":"ksary","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"45FTq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alert", ()=>o);
const o = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "space-between"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5eHv0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autocomplete", ()=>a);
const a = {
    menu: {
        width: {
            value: "100%"
        },
        marginBlockStart: {
            value: "{space.xxxs}"
        },
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        options: {
            display: {
                value: "flex"
            },
            flexDirection: {
                value: "column"
            },
            maxHeight: {
                value: "300px"
            }
        },
        option: {
            backgroundColor: {
                value: "{colors.background.primary}"
            },
            color: {
                value: "currentcolor"
            },
            cursor: {
                value: "pointer"
            },
            transitionDuration: {
                value: "{time.short}"
            },
            transitionProperty: {
                value: "background-color, color"
            },
            transitionTimingFunction: {
                value: "ease"
            },
            _active: {
                backgroundColor: {
                    value: "{colors.brand.primary.80}"
                },
                color: {
                    value: "{colors.white}"
                }
            }
        },
        _empty: {
            display: {
                value: "flex"
            }
        },
        _loading: {
            alignItems: {
                value: "center"
            },
            display: {
                value: "flex"
            },
            gap: {
                value: "{space.xxxs}"
            }
        },
        spaceShared: {
            paddingBlock: {
                value: "{space.xs}"
            },
            paddingInline: {
                value: "{space.small}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxSDn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "authenticator", ()=>e);
const e = {
    maxWidth: {
        value: "60rem"
    },
    modal: {
        width: {
            value: "{space.relative.full}"
        },
        height: {
            value: "{space.relative.full}"
        },
        backgroundColor: {
            value: "{colors.overlay.50.value}"
        },
        top: {
            value: "{space.zero}"
        },
        left: {
            value: "{space.zero}"
        }
    },
    container: {
        widthMax: {
            value: "30rem"
        }
    },
    router: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    },
    footer: {
        paddingBottom: {
            value: "{space.medium.value}"
        }
    },
    form: {
        padding: {
            value: "{space.xl.value}"
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    orContainer: {
        color: {
            value: "{colors.neutral.80.value}"
        },
        orLine: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"21BDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "badge", ()=>a);
const a = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: "{fontWeights.semibold.value}"
    },
    fontSize: {
        value: "{fontSizes.small.value}"
    },
    textAlign: {
        value: "center"
    },
    paddingVertical: {
        value: "{space.xs.value}"
    },
    paddingHorizontal: {
        value: "{space.small.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderRadius: {
        value: "{radii.xl.value}"
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.xs.value}"
        },
        paddingVertical: {
            value: "{space.xxs.value}"
        },
        paddingHorizontal: {
            value: "{space.xs.value}"
        }
    },
    large: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"51G3i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breadcrumbs", ()=>e);
const e = {
    flexDirection: {
        value: "row"
    },
    flexWrap: {
        value: "wrap"
    },
    gap: {
        value: "0"
    },
    color: {
        value: "{colors.font.tertiary}"
    },
    item: {
        flexDirection: {
            value: "row"
        },
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        alignItems: {
            value: "center"
        },
        lineHeight: {
            value: "1"
        }
    },
    separator: {
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        paddingInline: {
            value: "{space.xxs}"
        }
    },
    link: {
        color: {
            value: "{components.link.color}"
        },
        fontSize: {
            value: "inherit"
        },
        fontWeight: {
            value: "normal"
        },
        textDecoration: {
            value: "none"
        },
        paddingInline: {
            value: "{space.xs}"
        },
        paddingBlock: {
            value: "{space.xxs}"
        },
        current: {
            color: {
                value: "inherit"
            },
            fontSize: {
                value: "inherit"
            },
            fontWeight: {
                value: "normal"
            },
            textDecoration: {
                value: "none"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"405Gu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "button", ()=>o);
const o = {
    fontWeight: {
        value: "{fontWeights.bold.value}"
    },
    transitionDuration: {
        value: "{components.fieldcontrol.transitionDuration.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    lineHeight: {
        value: "{components.fieldcontrol.lineHeight.value}"
    },
    paddingBlockStart: {
        value: "{components.fieldcontrol.paddingBlockStart.value}"
    },
    paddingBlockEnd: {
        value: "{components.fieldcontrol.paddingBlockEnd.value}"
    },
    paddingInlineStart: {
        value: "{components.fieldcontrol.paddingInlineStart.value}"
    },
    paddingInlineEnd: {
        value: "{components.fieldcontrol.paddingInlineEnd.value}"
    },
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    borderWidth: {
        value: "{components.fieldcontrol.borderWidth.value}"
    },
    borderStyle: {
        value: "{components.fieldcontrol.borderStyle.value}"
    },
    borderRadius: {
        value: "{components.fieldcontrol.borderRadius.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.60.value}"
        }
    },
    _focus: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.10.value}"
        },
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    _active: {
        color: {
            value: "{colors.font.active.value}"
        },
        backgroundColor: {
            value: "{colors.brand.primary.20.value}"
        },
        borderColor: {
            value: "{colors.brand.primary.100.value}"
        }
    },
    _loading: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    outlined: {
        info: {
            borderColor: {
                value: "{colors.blue.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.blue.60.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "{colors.orange.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.orange.60.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "{colors.green.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.green.60.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "{colors.red.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.red.60.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "{colors.overlay.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.primary.value}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.overlay.60.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.neutral.100.value}"
                }
            }
        }
    },
    primary: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.100.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.blue.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.orange.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.green.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.overlay.70}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        }
    },
    menu: {
        borderWidth: {
            value: "{space.zero.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        justifyContent: {
            value: "start"
        },
        _hover: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.brand.primary.90.value}"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    link: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.interactive.value}"
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.10.value}"
            },
            color: {
                value: "{colors.font.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.brand.primary.20.value}"
            },
            color: {
                value: "{colors.font.active.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.blue.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.orange.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.green.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.red.100.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.neutral.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.80.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "1px",
                        color: "{colors.overlay.90.value}"
                    }
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            }
        }
    },
    warning: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.red.60}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        color: {
            value: "{colors.red.60}"
        },
        _hover: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.font.error}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.red.80}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "{colors.red.100}"
            },
            backgroundColor: {
                value: "{colors.red.20}"
            },
            color: {
                value: "{colors.red.100}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        }
    },
    destructive: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.red.60}"
        },
        color: {
            value: "{colors.font.inverse}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.100}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        }
    },
    small: {
        fontSize: {
            value: "{components.fieldcontrol.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.small.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.small.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.small.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.small.paddingInlineEnd.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.fieldcontrol.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.large.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.large.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.large.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.large.paddingInlineEnd.value}"
        }
    },
    loaderWrapper: {
        alignItems: {
            value: "center"
        },
        gap: {
            value: "{space.xs.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jrZqK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "card", ()=>o);
const o = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    borderWidth: {
        value: "0"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "transparent"
    },
    boxShadow: {
        value: "none"
    },
    padding: {
        value: "{space.medium.value}"
    },
    outlined: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        boxShadow: {
            value: "{components.card.boxShadow.value}"
        }
    },
    elevated: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "0"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "transparent"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kRQ0l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkbox", ()=>e);
const e = {
    cursor: {
        value: "pointer"
    },
    alignItems: {
        value: "center"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        position: {
            value: "relative"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        before: {
            width: {
                value: "100%"
            },
            height: {
                value: "100%"
            },
            borderWidth: {
                value: "{borderWidths.medium.value}"
            },
            borderRadius: {
                value: "20%"
            },
            borderStyle: {
                value: "solid"
            },
            borderColor: {
                value: "{colors.border.primary.value}"
            }
        },
        _focus: {
            outlineColor: {
                value: "{colors.transparent.value}"
            },
            outlineStyle: {
                value: "solid"
            },
            outlineWidth: {
                value: "{outlineWidths.medium.value}"
            },
            outlineOffset: {
                value: "{outlineOffsets.medium.value}"
            },
            borderColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderColor: {
                    value: "{colors.transparent.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "0px",
                        blurRadius: "0px",
                        spreadRadius: "2px",
                        color: "{colors.border.error.value}"
                    }
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "20%"
        },
        opacity: {
            value: "{opacities.0.value}"
        },
        transform: {
            value: "scale(0)"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.short.value}"
        },
        transitionTimingFunction: {
            value: "ease-in-out"
        },
        _checked: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        }
    },
    label: {
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Jeq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkboxfield", ()=>e);
const e = {
    alignItems: {
        value: "flex-start"
    },
    alignContent: {
        value: "center"
    },
    flexDirection: {
        value: "column"
    },
    justifyContent: {
        value: "center"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Vg0y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "collection", ()=>o);
const o = {
    pagination: {
        current: {
            color: {
                value: "{components.pagination.current.color}"
            },
            backgroundColor: {
                value: "{components.pagination.current.backgroundColor}"
            }
        },
        button: {
            color: {
                value: "{components.pagination.button.color}"
            },
            _hover: {
                backgroundColor: {
                    value: "{components.pagination.button.hover.backgroundColor}"
                },
                color: {
                    value: "{components.pagination.button.hover.color}"
                }
            },
            _disabled: {
                color: {
                    value: "{components.pagination.button.disabled.color}"
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: "{components.searchfield.color}"
            }
        },
        button: {
            color: {
                value: "{components.searchfield.button.color}"
            },
            _active: {
                backgroundColor: {
                    value: "{components.searchfield.button._active.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._active.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._active.color}"
                }
            },
            _disabled: {
                backgroundColor: {
                    value: "{components.searchfield.button._disabled.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._disabled.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._disabled.color}"
                }
            },
            _focus: {
                backgroundColor: {
                    value: "{components.searchfield.button._focus.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._focus.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._focus.color}"
                }
            },
            _hover: {
                backgroundColor: {
                    value: "{components.searchfield.button._hover.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._hover.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._hover.color}"
                }
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7QhRN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>e);
const e = {
    fontSize: {
        value: "{fontSizes.xs}"
    },
    gap: {
        value: "{space.relative.medium}"
    },
    svg: {
        path: {
            fill: {
                value: "{colors.font.primary}"
            }
        }
    },
    toolTip: {
        bottom: {
            value: "{space.large}"
        },
        color: {
            value: "{colors.teal.100}"
        },
        fontSize: {
            value: "{fontSizes.xxs}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kAYAt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dialcodeselect", ()=>e);
const e = {
    height: {
        value: "{space.relative.full.value}"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iUi3n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "divider", ()=>e);
const e = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    label: {
        color: {
            value: "{colors.font.tertiary.value}"
        },
        paddingInline: {
            value: "{space.medium.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        }
    },
    small: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        }
    },
    large: {
        borderWidth: {
            value: "{borderWidths.large.value}"
        }
    },
    opacity: {
        value: "{opacities.60.value}"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQ6m1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dropzone", ()=>o);
const o = {
    backgroundColor: {
        value: "{colors.background.primary}"
    },
    borderRadius: {
        value: "{radii.small}"
    },
    borderColor: {
        value: "{colors.border.primary}"
    },
    borderStyle: {
        value: "dashed"
    },
    borderWidth: {
        value: "{borderWidths.small}"
    },
    color: {
        value: "{colors.font.primary}"
    },
    gap: {
        value: "{space.small}"
    },
    paddingBlock: {
        value: "{space.xl}"
    },
    paddingInline: {
        value: "{space.large}"
    },
    textAlign: {
        value: "center"
    },
    _active: {
        backgroundColor: {
            value: "{colors.brand.primary.10}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.primary}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.background.disabled}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.disabled}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.disabled}"
        }
    },
    accepted: {
        backgroundColor: {
            value: "{colors.background.success}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.success}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.success}"
        }
    },
    rejected: {
        backgroundColor: {
            value: "{colors.background.error}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.error}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9cg2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expander", ()=>a);
const a = {
    display: {
        value: "block"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    width: {
        value: "100%"
    },
    item: {
        marginTop: {
            value: "1px"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderBottomLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderBottomRightRadius: {
            value: "{radii.medium.value}"
        },
        borderTopLeftRadius: {
            value: "{radii.medium.value}"
        },
        borderTopRightRadius: {
            value: "{radii.medium.value}"
        },
        borderStartStartRadius: {
            value: "{radii.medium.value}"
        },
        borderStartEndRadius: {
            value: "{radii.medium.value}"
        },
        borderEndStartRadius: {
            value: "{radii.medium.value}"
        },
        borderEndEndRadius: {
            value: "{radii.medium.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    header: {
        boxShadow: {
            value: {
                offsetX: "0",
                offsetY: "1px",
                blurRadius: "0",
                color: "{colors.overlay.20.value}"
            }
        }
    },
    trigger: {
        minHeight: {
            value: "3rem"
        },
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "space-between"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            }
        }
    },
    content: {
        paddingInlineStart: {
            value: "{space.large.value}"
        },
        paddingInlineEnd: {
            value: "{space.large.value}"
        },
        text: {
            color: {
                value: "{colors.font.secondary.value}"
            },
            paddingBlockStart: {
                value: "{space.medium.value}"
            },
            paddingBlockEnd: {
                value: "{space.medium.value}"
            }
        },
        _open: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        },
        _closed: {
            animationDuration: {
                value: "{time.medium.value}"
            },
            animationTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        }
    },
    icon: {
        transitionDuration: {
            value: "{time.medium.value}"
        },
        transitionTimingFunction: {
            value: "cubic-bezier(0.87, 0, 0.13, 1)"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ap3G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "field", ()=>e);
const e = {
    gap: {
        value: "{space.xs.value}"
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    flexDirection: {
        value: "column"
    },
    small: {
        gap: {
            value: "{space.xxxs.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    large: {
        gap: {
            value: "{space.small.value}"
        },
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    label: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jEWit":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fieldcontrol", ()=>e);
const e = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.small.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    paddingBlockStart: {
        value: "{space.xs.value}"
    },
    paddingBlockEnd: {
        value: "{space.xs.value}"
    },
    paddingInlineStart: {
        value: "{space.medium.value}"
    },
    paddingInlineEnd: {
        value: "{space.medium.value}"
    },
    fontSize: {
        value: "{components.field.fontSize.value}"
    },
    lineHeight: {
        value: "{lineHeights.medium.value}"
    },
    transitionDuration: {
        value: "{time.medium.value}"
    },
    outlineColor: {
        value: "{colors.transparent.value}"
    },
    outlineStyle: {
        value: "solid"
    },
    outlineWidth: {
        value: "{outlineWidths.medium.value}"
    },
    outlineOffset: {
        value: "{outlineOffsets.medium.value}"
    },
    small: {
        fontSize: {
            value: "{components.field.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xxs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xxs.value}"
        },
        paddingInlineStart: {
            value: "{space.small.value}"
        },
        paddingInlineEnd: {
            value: "{space.small.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.field.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xs.value}"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    },
    quiet: {
        borderStyle: {
            value: "none"
        },
        borderInlineStart: {
            value: "none"
        },
        borderInlineEnd: {
            value: "none"
        },
        borderBlockStart: {
            value: "none"
        },
        borderRadius: {
            value: "0"
        },
        _focus: {
            borderBlockEndColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "1px",
                    color: "{colors.border.focus.value}",
                    blurRadius: "0px"
                }
            }
        },
        _error: {
            borderBlockEndColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: {
                        offsetX: "0px",
                        offsetY: "1px",
                        color: "{colors.border.error.value}",
                        blurRadius: "0px"
                    }
                }
            }
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "1px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        cursor: {
            value: "not-allowed"
        },
        borderColor: {
            value: "{colors.transparent.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    _error: {
        borderColor: {
            value: "{colors.border.error.value}"
        },
        color: {
            value: "{colors.font.error.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "1px",
                    color: "{colors.border.error.value}"
                }
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fCMbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fieldgroup", ()=>e);
const e = {
    gap: {
        value: "{space.zero.value}"
    },
    vertical: {
        alignItems: {
            value: "center"
        }
    },
    outer: {
        alignItems: {
            value: "center"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"arkDd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fieldset", ()=>e);
const e = {
    backgroundColor: {
        value: "transparent"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{components.field.gap.value}"
    },
    legend: {
        color: {
            value: "{colors.font.primary.value}"
        },
        fontSize: {
            value: "{components.field.fontSize.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        lineHeight: {
            value: "{lineHeights.medium.value}"
        },
        small: {
            fontSize: "{components.field.small.fontSize.value}"
        },
        large: {
            fontSize: "{components.field.large.fontSize.value}"
        }
    },
    outlined: {
        padding: "{space.medium.value}",
        borderColor: "{colors.neutral.40.value}",
        borderWidth: "{borderWidths.small.value}",
        borderStyle: "solid",
        small: {
            padding: "{space.small.value}"
        },
        large: {
            padding: "{space.large.value}"
        }
    },
    small: {
        gap: "{components.field.small.gap.value}"
    },
    large: {
        gap: "{components.field.large.gap.value}"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7zgg6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fieldmessages", ()=>o);
const o = {
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    description: {
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontStyle: {
            value: "italic"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i0sPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fileuploader", ()=>e);
const e = {
    dropzone: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "dashed"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        gap: {
            value: "{space.small}"
        },
        paddingBlock: {
            value: "{space.xl}"
        },
        paddingInline: {
            value: "{space.large}"
        },
        textAlign: {
            value: "center"
        },
        _active: {
            backgroundColor: {
                value: "{colors.brand.primary.10}"
            },
            borderRadius: {
                value: "{components.fileuploader.dropzone.borderRadius}"
            },
            borderColor: {
                value: "{colors.border.pressed}"
            },
            borderStyle: {
                value: "{components.fileuploader.dropzone.borderStyle}"
            },
            borderWidth: {
                value: "{borderWidths.medium}"
            }
        },
        icon: {
            color: {
                value: "{colors.border.primary}"
            },
            fontSize: {
                value: "{fontSizes.xxl}"
            }
        },
        text: {
            color: {
                value: "{colors.font.tertiary}"
            },
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            }
        }
    },
    file: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        paddingBlock: {
            value: "{space.xs}"
        },
        paddingInline: {
            value: "{space.small}"
        },
        gap: {
            value: "{space.small}"
        },
        alignItems: {
            value: "baseline"
        },
        name: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        size: {
            fontSize: {
                value: "{fontSizes.small}"
            },
            fontWeight: {
                value: "{fontWeights.normal}"
            },
            color: {
                value: "{colors.font.tertiary}"
            }
        },
        image: {
            width: {
                value: "{space.xxl}"
            },
            height: {
                value: "{space.xxl}"
            },
            backgroundColor: {
                value: "{colors.background.secondary}"
            },
            color: {
                value: "{colors.font.tertiary}"
            },
            borderRadius: {
                value: "{radii.small}"
            }
        }
    },
    loader: {
        strokeLinecap: {
            value: "round"
        },
        strokeEmpty: {
            value: "{colors.border.secondary}"
        },
        strokeFilled: {
            value: "{components.loader.strokeFilled}"
        },
        strokeWidth: {
            value: "{borderWidths.large}"
        }
    },
    previewer: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        paddingBlock: {
            value: "{space.zero}"
        },
        paddingInline: {
            value: "{space.zero}"
        },
        maxHeight: {
            value: "40rem"
        },
        maxWidth: {
            value: "auto"
        },
        text: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        body: {
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            gap: {
                value: "{space.small}"
            }
        },
        footer: {
            borderColor: {
                value: "{colors.border.secondary}"
            },
            borderStyle: {
                value: "solid"
            },
            borderWidth: {
                value: "{borderWidths.small}"
            },
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            justifyContent: {
                value: "space-between"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3lX29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flex", ()=>a);
const a = {
    gap: {
        value: "{space.medium.value}"
    },
    justifyContent: {
        value: "normal"
    },
    alignItems: {
        value: "stretch"
    },
    alignContent: {
        value: "normal"
    },
    flexWrap: {
        value: "nowrap"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ePBU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "heading", ()=>e);
const e = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    1: {
        fontSize: {
            value: "{fontSizes.xxxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.light.value}"
        }
    },
    2: {
        fontSize: {
            value: "{fontSizes.xxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        }
    },
    3: {
        fontSize: {
            value: "{fontSizes.xxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.medium.value}"
        }
    },
    4: {
        fontSize: {
            value: "{fontSizes.xl.value}"
        },
        fontWeight: {
            value: "{fontWeights.semibold.value}"
        }
    },
    5: {
        fontSize: {
            value: "{fontSizes.large.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    6: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hNSxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "highlightmatch", ()=>t);
const t = {
    highlighted: {
        fontWeight: {
            value: "{fontWeights.bold}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dTTkk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "icon", ()=>e);
const e = {
    lineHeight: {
        value: 1
    },
    height: {
        value: "1em"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2wZcE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "input", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7tw91":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "image", ()=>i);
const i = {
    maxWidth: {
        value: "100%"
    },
    height: {
        value: "auto"
    },
    objectFit: {
        value: "initial"
    },
    objectPosition: {
        value: "initial"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kuyO3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inappmessaging", ()=>e);
const e = {
    banner: {
        height: {
            value: "150px "
        },
        width: {
            value: "400px "
        }
    },
    button: {
        backgroundColor: {
            value: "#e8e8e8"
        },
        borderRadius: {
            value: "5px"
        },
        color: {
            value: "black"
        }
    },
    dialog: {
        height: {
            value: "50vh"
        },
        minHeight: {
            value: "400px"
        },
        minWidth: {
            value: "400px"
        },
        width: {
            value: "30vw"
        }
    },
    header: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6EVH0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "link", ()=>o);
const o = {
    active: {
        color: {
            value: "{colors.font.active.value}"
        }
    },
    color: {
        value: "{colors.font.interactive.value}"
    },
    focus: {
        color: {
            value: "{colors.font.focus.value}"
        }
    },
    hover: {
        color: {
            value: "{colors.font.hover.value}"
        }
    },
    visited: {
        color: {
            value: "{colors.font.interactive.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"QHWp3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "liveness", ()=>o);
const o = {
    cameraModule: {
        backgroundColor: {
            value: "{colors.black}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2L7Ya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loader", ()=>e);
const e = {
    width: {
        value: "{fontSizes.medium.value}"
    },
    height: {
        value: "{fontSizes.medium.value}"
    },
    fontSize: {
        value: "{fontSizes.xs.value}"
    },
    strokeEmpty: {
        value: "{colors.neutral.20.value}"
    },
    strokeFilled: {
        value: "{colors.brand.primary.80.value}"
    },
    strokeLinecap: {
        value: "round"
    },
    animationDuration: {
        value: "1s"
    },
    small: {
        width: {
            value: "{fontSizes.small.value}"
        },
        height: {
            value: "{fontSizes.small.value}"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.large.value}"
        },
        height: {
            value: "{fontSizes.large.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    linear: {
        width: {
            value: "100%"
        },
        minWidth: {
            value: "5rem"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        },
        strokeWidth: {
            value: "{fontSizes.xxs.value}"
        },
        strokeFilled: {
            value: "{colors.brand.primary.80.value}"
        },
        strokeEmpty: {
            value: "{colors.neutral.20.value}"
        },
        strokeLinecap: {
            value: "round"
        },
        animationDuration: {
            value: "1s"
        },
        small: {
            strokeWidth: {
                value: "{fontSizes.xxxs.value}"
            },
            fontSize: {
                value: "{fontSizes.xxxs.value}"
            }
        },
        large: {
            strokeWidth: {
                value: "{fontSizes.xs.value}"
            },
            fontSize: {
                value: "{fontSizes.xs.value}"
            }
        }
    },
    text: {
        fill: {
            value: "{colors.font.primary.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ak8xi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "menu", ()=>e);
const e = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{space.zero.value}"
    },
    maxWidth: {
        value: "30rem"
    },
    minWidth: {
        value: "14rem"
    },
    small: {
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.xxxl.value}"
        },
        height: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    item: {
        minHeight: {
            value: "2.5rem"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dMJ54":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "message", ()=>o);
const o = {
    alignItems: {
        value: "center"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderColor: {
        value: "transparent"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    justifyContent: {
        value: "flex-start"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    dismiss: {
        gap: {
            value: "{space.xxs.value}"
        }
    },
    plain: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    },
    outlined: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.info.value}"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.error.value}"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.success.value}"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.warning.value}"
            }
        }
    },
    filled: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.secondary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.info.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.error.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.success.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.warning.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j7qat":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pagination", ()=>e);
const e = {
    current: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.40.value}"
        }
    },
    button: {
        color: {
            value: "{colors.font.primary.value}"
        },
        paddingInlineStart: {
            value: "{space.xxs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xxs.value}"
        },
        transitionProperty: {
            value: "background-color"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: "baseline"
        },
        justifyContent: {
            value: "center"
        },
        paddingInlineStart: {
            value: "{space.xs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xs.value}"
        }
    },
    itemContainer: {
        marginLeft: {
            value: "{space.xxxs.value}"
        },
        marginRight: {
            value: "{space.xxxs.value}"
        }
    },
    itemShared: {
        height: {
            value: "{fontSizes.xxl.value}"
        },
        minWidth: {
            value: "{fontSizes.xxl.value}"
        },
        borderRadius: {
            value: "{fontSizes.medium.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3nVVZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "passwordfield", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6sClw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phonenumberfield", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"egn3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placeholder", ()=>a);
const a = {
    borderRadius: {
        value: "{radii.small.value}"
    },
    transitionDuration: {
        value: "{time.long.value}"
    },
    startColor: {
        value: "{colors.background.secondary.value}"
    },
    endColor: {
        value: "{colors.background.tertiary.value}"
    },
    small: {
        height: {
            value: "{space.small.value}"
        }
    },
    default: {
        height: {
            value: "{space.medium.value}"
        }
    },
    large: {
        height: {
            value: "{space.large.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0akA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radio", ()=>e);
const e = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    },
    gap: {
        value: "inherit"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        },
        boxSizing: {
            value: "border-box"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "50%"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        color: {
            value: "{colors.background.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        outlineColor: {
            value: "{colors.transparent.value}"
        },
        outlineStyle: {
            value: "solid"
        },
        outlineWidth: {
            value: "{outlineWidths.medium.value}"
        },
        outlineOffset: {
            value: "{outlineOffsets.medium.value}"
        },
        padding: {
            value: "{borderWidths.medium.value}"
        },
        small: {
            width: {
                value: "{fontSizes.small.value}"
            },
            height: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            width: {
                value: "{fontSizes.large.value}"
            },
            height: {
                value: "{fontSizes.large.value}"
            }
        },
        _checked: {
            color: {
                value: "{colors.brand.primary.80.value}"
            },
            _disabled: {
                color: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    },
    label: {
        color: {
            value: "{components.text.color.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4jQIP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radiogroup", ()=>o);
const o = {
    radio: {
        borderWidth: {
            value: "{components.radio.button.borderWidth}"
        },
        borderColor: {
            value: "{components.radio.button.borderColor}"
        },
        backgroundColor: {
            value: "{components.radio.button.backgroundColor}"
        },
        _checked: {
            color: {
                value: "{components.radio.button._checked.color}"
            }
        },
        label: {
            color: {
                value: "{components.radio.label.color}"
            }
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"34BmB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rating", ()=>l);
const l = {
    large: {
        size: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    default: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    small: {
        size: {
            value: "{fontSizes.small.value}"
        }
    },
    filled: {
        color: {
            value: "{colors.brand.secondary.80.value}"
        }
    },
    empty: {
        color: {
            value: "{colors.background.tertiary.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6FJEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchfield", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7ppYG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "select", ()=>a);
const a = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    paddingInlineEnd: {
        value: "{space.xxl.value}"
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    wrapper: {
        flex: {
            value: "1"
        },
        display: {
            value: "block"
        },
        position: {
            value: "relative"
        },
        cursor: {
            value: "pointer"
        }
    },
    iconWrapper: {
        alignItems: {
            value: "center"
        },
        position: {
            value: "absolute"
        },
        top: {
            value: "50%"
        },
        right: {
            value: "{space.medium.value}"
        },
        transform: {
            value: "translateY(-50%)"
        },
        pointerEvents: {
            value: "none"
        },
        small: {
            right: {
                value: "{space.xs.value}"
            }
        },
        large: {
            right: {
                value: "{space.medium.value}"
            }
        }
    },
    option: {
        backgroundColor: {
            value: "transparent"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        }
    },
    whiteSpace: {
        value: "nowrap"
    },
    minWidth: {
        value: "6.5rem"
    },
    small: {
        minWidth: {
            value: "5.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xl.value}"
        }
    },
    large: {
        minWidth: {
            value: "7.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xxl.value}"
        }
    },
    expanded: {
        paddingBlock: {
            value: "{space.xs.value}"
        },
        paddingInline: {
            value: "{space.small.value}"
        },
        option: {
            paddingBlock: {
                value: "{space.xs.value}"
            },
            paddingInline: {
                value: "{space.small.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dcBBC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectfield", ()=>o);
const o = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    color: {
        value: "{components.fieldcontrol.color}"
    },
    flexDirection: {
        value: "column"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fXR9l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sliderfield", ()=>r);
const r = {
    paddingBlock: {
        value: "{space.xs.value}"
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        height: {
            value: "0.375rem"
        },
        minWidth: {
            value: "10rem"
        }
    },
    range: {
        backgroundColor: {
            value: "{colors.brand.primary.80.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            }
        }
    },
    thumb: {
        width: {
            value: "1.25rem"
        },
        height: {
            value: "1.25rem"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderRadius: {
            value: "50%"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            borderColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "none"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0",
                    offsetY: "0",
                    blurRadius: "0",
                    spreadRadius: "2px",
                    color: "{colors.border.focus.value}"
                }
            }
        }
    },
    small: {
        track: {
            height: {
                value: "0.25rem"
            }
        },
        thumb: {
            width: {
                value: "1rem"
            },
            height: {
                value: "1rem"
            }
        }
    },
    large: {
        track: {
            height: {
                value: "0.625rem"
            }
        },
        thumb: {
            width: {
                value: "1.5rem"
            },
            height: {
                value: "1.5rem"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jB2fS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stepperfield", ()=>o);
const o = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    flexDirection: {
        value: "column"
    },
    input: {
        color: {
            value: "{components.fieldcontrol.color}"
        },
        fontSize: {
            value: "{components.fieldcontrol.fontSize}"
        },
        textAlign: {
            value: "center"
        }
    },
    button: {
        color: {
            value: "{components.button.color}"
        },
        backgroundColor: {
            value: "{colors.transparent}"
        },
        _active: {
            color: {
                value: "{components.button._active.color}"
            },
            backgroundColor: {
                value: "{components.button._active.backgroundColor}"
            }
        },
        _focus: {
            color: {
                value: "{components.button._focus.color}"
            },
            backgroundColor: {
                value: "{components.button._focus.backgroundColor}"
            }
        },
        _disabled: {
            color: {
                value: "{components.button._disabled.color}"
            },
            backgroundColor: {
                value: "{components.fieldcontrol._disabled.backgroundColor}"
            }
        },
        _hover: {
            color: {
                value: "{components.button._hover.color}"
            },
            backgroundColor: {
                value: "{components.button._hover.backgroundColor}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lIP8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storagemanager", ()=>s);
var _fileUploaderMjs = require("./fileUploader.mjs");
const s = Object.assign(Object.assign({}, (0, _fileUploaderMjs.fileuploader)), {
    filelist: {
        flexDirection: {
            value: "column"
        },
        gap: {
            value: "{space.small}"
        }
    },
    previewer: Object.assign(Object.assign({}, (0, _fileUploaderMjs.fileuploader).previewer), {
        footer: {
            justifyContent: {
                value: "flex-end"
            }
        }
    })
});

},{"./fileUploader.mjs":"i0sPR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lhDT8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchfield", ()=>e);
const e = {
    _disabled: {
        opacity: {
            value: "{opacities.60.value}"
        }
    },
    _focused: {
        shadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "2px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    large: {
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    label: {
        padding: {
            value: "{space.xs.value}"
        }
    },
    thumb: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            transform: {
                value: "{transforms.slideX.medium.value}"
            }
        },
        transition: {
            duration: {
                value: "{time.medium.value}"
            }
        },
        width: {
            value: "{space.relative.medium.value}"
        }
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            }
        },
        height: {
            value: "{space.relative.medium.value}"
        },
        padding: {
            value: "{outlineWidths.medium.value}"
        },
        transition: {
            duration: {
                value: "{time.short.value}"
            }
        },
        width: {
            value: "{space.relative.xl.value}"
        },
        _error: {
            backgroundColor: {
                value: "{colors.background.error.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lHoQb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "table", ()=>e);
const e = {
    borderCollapse: {
        value: "collapse"
    },
    display: {
        value: "table"
    },
    width: {
        value: "100%"
    },
    head: {
        display: {
            value: "table-header-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    body: {
        display: {
            value: "table-row-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    foot: {
        display: {
            value: "table-footer-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    row: {
        display: {
            value: "table-row"
        },
        verticalAlign: {
            value: "middle"
        },
        hover: {
            backgroundColor: {
                value: "{colors.background.tertiary.value}"
            }
        },
        striped: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    header: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    data: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    caption: {
        captionSide: {
            value: "bottom"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-caption"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        wordBreak: {
            value: "break-all"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2kXgs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tabs", ()=>e);
const e = {
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{colors.border.secondary.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    gap: {
        value: "0"
    },
    item: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        _hover: {
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.focus.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.interactive.value}"
            },
            borderColor: {
                value: "{colors.font.interactive.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.tertiary.value}"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ic6I1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "text", ()=>o);
const o = {
    color: {
        value: "{colors.font.primary.value}"
    },
    primary: {
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    secondary: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    },
    tertiary: {
        color: {
            value: "{colors.font.tertiary.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kosnw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textareafield", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6rjIO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textfield", ()=>o);
const o = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gIksm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "togglebutton", ()=>o);
const o = {
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        backgroundColor: {
            value: "{colors.overlay.10.value}"
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    _active: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderColor: {
            value: "{colors.border.disabled.value}"
        },
        color: {
            value: "{colors.font.disabled.value}"
        }
    },
    _pressed: {
        borderColor: {
            value: "{colors.border.pressed.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.20.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.30.value}"
            }
        }
    },
    primary: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.brand.primary.80.value}"
            },
            borderColor: {
                value: "{colors.brand.primary.80.value}"
            },
            color: {
                value: "{colors.background.primary.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.border.focus.value}"
                },
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            },
            _hover: {
                borderColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                backgroundColor: {
                    value: "{colors.brand.primary.60.value}"
                },
                boxShadow: {
                    value: "{colors.brand.primary.60.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        color: {
            value: "{colors.overlay.50.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.90.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.transparent.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            },
            _hover: {
                color: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.transparent.value}"
                }
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ksary":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "togglebuttongroup", ()=>e);
const e = {
    alignItems: {
        value: "center"
    },
    alignContent: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"entyO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fonts", ()=>e);
const e = {
    default: {
        variable: {
            value: "'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,\n        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',\n        sans-serif"
        },
        static: {
            value: "'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',\n        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4RIty":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontSizes", ()=>e);
const e = {
    xxxs: {
        value: "0.375rem"
    },
    xxs: {
        value: "0.5rem"
    },
    xs: {
        value: "0.75rem"
    },
    small: {
        value: "0.875rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.25rem"
    },
    xl: {
        value: "1.5rem"
    },
    xxl: {
        value: "2rem"
    },
    xxxl: {
        value: "2.5rem"
    },
    xxxxl: {
        value: "3rem"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"54l4m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontWeights", ()=>l);
const l = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"frjkZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineHeights", ()=>e);
const e = {
    small: {
        value: "1.25"
    },
    medium: {
        value: "1.5"
    },
    large: {
        value: "2"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Vtzt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "opacities", ()=>e);
const e = {
    0: {
        value: "0"
    },
    10: {
        value: "0.1"
    },
    20: {
        value: "0.2"
    },
    30: {
        value: "0.3"
    },
    40: {
        value: "0.4"
    },
    50: {
        value: "0.5"
    },
    60: {
        value: "0.6"
    },
    70: {
        value: "0.7"
    },
    80: {
        value: "0.8"
    },
    90: {
        value: "0.9"
    },
    100: {
        value: "1"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"htu6g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "outlineOffsets", ()=>e);
const e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d23me":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "outlineWidths", ()=>e);
const e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hC4ls":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radii", ()=>e);
const e = {
    xs: {
        value: "0.125rem"
    },
    small: {
        value: "0.25rem"
    },
    medium: {
        value: "0.5rem"
    },
    large: {
        value: "1rem"
    },
    xl: {
        value: "2rem"
    },
    xxl: {
        value: "4rem"
    },
    xxxl: {
        value: "8rem"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"88Dmp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shadows", ()=>o);
const o = {
    small: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "4px",
            color: "{colors.shadow.tertiary.value}"
        }
    },
    medium: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "6px",
            color: "{colors.shadow.secondary.value}"
        }
    },
    large: {
        value: {
            offsetX: "0px",
            offsetY: "4px",
            blurRadius: "12px",
            color: "{colors.shadow.primary.value}"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fuejH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "space", ()=>e);
const e = {
    zero: {
        value: "0"
    },
    xxxs: {
        value: "0.25rem"
    },
    xxs: {
        value: "0.375rem"
    },
    xs: {
        value: "0.5rem"
    },
    small: {
        value: "0.75rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.5rem"
    },
    xl: {
        value: "2.0rem"
    },
    xxl: {
        value: "3.0rem"
    },
    xxxl: {
        value: "4.5rem"
    },
    relative: {
        xxxs: {
            value: "0.25em"
        },
        xxs: {
            value: "0.375em"
        },
        xs: {
            value: "0.5em"
        },
        small: {
            value: "0.75em"
        },
        medium: {
            value: "1em"
        },
        large: {
            value: "1.5em"
        },
        xl: {
            value: "2.0em"
        },
        xxl: {
            value: "3.0em"
        },
        xxxl: {
            value: "4.5em"
        },
        full: {
            value: "100%"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lL4tw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "time", ()=>e);
const e = {
    short: {
        value: "100ms"
    },
    medium: {
        value: "250ms"
    },
    long: {
        value: "500ms"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7UMsE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transforms", ()=>e);
const e = {
    slideX: {
        small: {
            value: "translateX(0.5em)"
        },
        medium: {
            value: "translateX(1em)"
        },
        large: {
            value: "translateX(2em)"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4QWBQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpoints", ()=>e);
const e = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: "base"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7CFl2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSS_VARIABLE_PREFIX", ()=>u);
parcelHelpers.export(exports, "cssNameTransform", ()=>f);
parcelHelpers.export(exports, "cssValue", ()=>a);
parcelHelpers.export(exports, "isDesignToken", ()=>c);
parcelHelpers.export(exports, "isShadowTokenObject", ()=>p);
parcelHelpers.export(exports, "setupTokens", ()=>l);
var _kebabCaseJs = require("lodash/kebabCase.js");
var _kebabCaseJsDefault = parcelHelpers.interopDefault(_kebabCaseJs);
var _usesReferenceJs = require("style-dictionary/lib/utils/references/usesReference.js");
var _usesReferenceJsDefault = parcelHelpers.interopDefault(_usesReferenceJs);
var _indexMjs = require("../utils/index.mjs");
const u = "amplify", s = [
    "offsetX",
    "offsetY",
    "blurRadius",
    "spreadRadius",
    "color"
];
function i(e) {
    if (!e) return "";
    if ((0, _usesReferenceJsDefault.default)(e)) return `var(--${f({
        path: e.replace(/\{|\}/g, "").replace(".value", "").split(".")
    })})`;
    return e;
}
function a(e) {
    const { value: t } = e;
    return (0, _indexMjs.isString)(t) ? i(t) : p(t) ? s.map((n)=>i(p(e) ? e[n] : t[n])).join(" ") : t;
}
function f({ path: t = [] }) {
    return `${(0, _kebabCaseJsDefault.default)([
        u,
        ...t
    ].join(" "))}`;
}
function c(e) {
    return (0, _indexMjs.isObject)(e) && (0, _indexMjs.has)(e, "value");
}
function p(e) {
    return (0, _indexMjs.isObject)(e) && (0, _indexMjs.has)(e, "offsetX");
}
function l({ tokens: e, path: t = [], setupToken: o }) {
    if ((0, _indexMjs.has)(e, "value")) return o({
        token: e,
        path: t
    });
    const u = {};
    for(const s in e)if ((0, _indexMjs.has)(e, s)) {
        const r = e[s], i = (0, _indexMjs.isObject)(r) ? r : {
            value: r
        };
        u[s] = l({
            tokens: i,
            path: t.concat(s),
            setupToken: o
        });
    }
    return u;
}

},{"lodash/kebabCase.js":"iivxL","style-dictionary/lib/utils/references/usesReference.js":"kkaW3","../utils/index.mjs":"a3Yxt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iivxL":[function(require,module,exports) {
var createCompounder = require("ac15724842cb12b2");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var kebabCase = createCompounder(function(result, word, index) {
    return result + (index ? "-" : "") + word.toLowerCase();
});
module.exports = kebabCase;

},{"ac15724842cb12b2":"3pq26"}],"3pq26":[function(require,module,exports) {
var arrayReduce = require("cfc95c8ee08dfd6b"), deburr = require("b60ce6efa81a3cef"), words = require("40ddea9252aefad9");
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
    };
}
module.exports = createCompounder;

},{"cfc95c8ee08dfd6b":"bEGfj","b60ce6efa81a3cef":"hfdYZ","40ddea9252aefad9":"9cLXy"}],"bEGfj":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"hfdYZ":[function(require,module,exports) {
var deburrLetter = require("86c70dfa448b37ae"), toString = require("f68583105b85d455");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
module.exports = deburr;

},{"86c70dfa448b37ae":"l6pcw","f68583105b85d455":"23Zly"}],"l6pcw":[function(require,module,exports) {
var basePropertyOf = require("c95029d8b26d3cfc");
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
module.exports = deburrLetter;

},{"c95029d8b26d3cfc":"gHP3m"}],"gHP3m":[function(require,module,exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = basePropertyOf;

},{}],"9cLXy":[function(require,module,exports) {
var asciiWords = require("14a2bcc60f9c8c58"), hasUnicodeWord = require("12a5a56673332993"), toString = require("efbc56b55844c665"), unicodeWords = require("e27193a0a134859e");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = words;

},{"14a2bcc60f9c8c58":"2ttwo","12a5a56673332993":"ixhS6","efbc56b55844c665":"23Zly","e27193a0a134859e":"8Be4W"}],"2ttwo":[function(require,module,exports) {
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
module.exports = asciiWords;

},{}],"ixhS6":[function(require,module,exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
module.exports = hasUnicodeWord;

},{}],"8Be4W":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
        rsBreak,
        rsUpper,
        "$"
    ].join("|") + ")",
    rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
        rsBreak,
        rsUpper + rsMiscLower,
        "$"
    ].join("|") + ")",
    rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
    rsUpper + "+" + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
module.exports = unicodeWords;

},{}],"kkaW3":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const createRegex = require("49bbe1f67fb13ab3");
/**
 * Checks if the value uses a value reference.
 * @memberof Dictionary
 * @param {string} value
 * @param {Object|RegExp} regexOrOptions
 * @returns {boolean} - True, if the value uses a value reference
 */ function usesReference(value, regexOrOptions = {}) {
    const regex = regexOrOptions instanceof RegExp ? regexOrOptions : createRegex(regexOrOptions);
    if (typeof value === "string") return regex.test(value);
    if (typeof value === "object") {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if (value.hasOwnProperty(key)) {
            const element = value[key];
            let reference = usesReference(element, regexOrOptions);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
module.exports = usesReference;

},{"49bbe1f67fb13ab3":"8FhIh"}],"8FhIh":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const defaults = require("817c1ed3a8015f2a");
function createReferenceRegex(opts = {}) {
    const options = Object.assign({}, defaults, opts);
    return new RegExp("\\" + options.opening_character + "([^" + options.closing_character + "]+)" + "\\" + options.closing_character, "g");
}
module.exports = createReferenceRegex;

},{"817c1ed3a8015f2a":"97cJC"}],"97cJC":[function(require,module,exports) {
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const defaults = {
    opening_character: "{",
    closing_character: "}",
    separator: "."
};
module.exports = defaults;

},{}],"jZIGj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDarkModeOverride", ()=>l);
parcelHelpers.export(exports, "reactNativeDarkTokens", ()=>e);
var _indexMjs = require("./tokens/index.mjs");
const r = {
    colors: {
        red: {
            10: (0, _indexMjs.tokens).colors.red[100],
            20: (0, _indexMjs.tokens).colors.red[90],
            40: (0, _indexMjs.tokens).colors.red[80],
            80: (0, _indexMjs.tokens).colors.red[40],
            90: (0, _indexMjs.tokens).colors.red[20],
            100: (0, _indexMjs.tokens).colors.red[10]
        },
        orange: {
            10: (0, _indexMjs.tokens).colors.orange[100],
            20: (0, _indexMjs.tokens).colors.orange[90],
            40: (0, _indexMjs.tokens).colors.orange[80],
            80: (0, _indexMjs.tokens).colors.orange[40],
            90: (0, _indexMjs.tokens).colors.orange[20],
            100: (0, _indexMjs.tokens).colors.orange[10]
        },
        yellow: {
            10: (0, _indexMjs.tokens).colors.yellow[100],
            20: (0, _indexMjs.tokens).colors.yellow[90],
            40: (0, _indexMjs.tokens).colors.yellow[80],
            80: (0, _indexMjs.tokens).colors.yellow[40],
            90: (0, _indexMjs.tokens).colors.yellow[20],
            100: (0, _indexMjs.tokens).colors.yellow[10]
        },
        green: {
            10: (0, _indexMjs.tokens).colors.green[100],
            20: (0, _indexMjs.tokens).colors.green[90],
            40: (0, _indexMjs.tokens).colors.green[80],
            80: (0, _indexMjs.tokens).colors.green[40],
            90: (0, _indexMjs.tokens).colors.green[20],
            100: (0, _indexMjs.tokens).colors.green[10]
        },
        teal: {
            10: (0, _indexMjs.tokens).colors.teal[100],
            20: (0, _indexMjs.tokens).colors.teal[90],
            40: (0, _indexMjs.tokens).colors.teal[80],
            80: (0, _indexMjs.tokens).colors.teal[40],
            90: (0, _indexMjs.tokens).colors.teal[20],
            100: (0, _indexMjs.tokens).colors.teal[10]
        },
        blue: {
            10: (0, _indexMjs.tokens).colors.blue[100],
            20: (0, _indexMjs.tokens).colors.blue[90],
            40: (0, _indexMjs.tokens).colors.blue[80],
            80: (0, _indexMjs.tokens).colors.blue[40],
            90: (0, _indexMjs.tokens).colors.blue[20],
            100: (0, _indexMjs.tokens).colors.blue[10]
        },
        purple: {
            10: (0, _indexMjs.tokens).colors.purple[100],
            20: (0, _indexMjs.tokens).colors.purple[90],
            40: (0, _indexMjs.tokens).colors.purple[80],
            80: (0, _indexMjs.tokens).colors.purple[40],
            90: (0, _indexMjs.tokens).colors.purple[20],
            100: (0, _indexMjs.tokens).colors.purple[10]
        },
        pink: {
            10: (0, _indexMjs.tokens).colors.pink[100],
            20: (0, _indexMjs.tokens).colors.pink[90],
            40: (0, _indexMjs.tokens).colors.pink[80],
            80: (0, _indexMjs.tokens).colors.pink[40],
            90: (0, _indexMjs.tokens).colors.pink[20],
            100: (0, _indexMjs.tokens).colors.pink[10]
        },
        neutral: {
            10: (0, _indexMjs.tokens).colors.neutral[100],
            20: (0, _indexMjs.tokens).colors.neutral[90],
            40: (0, _indexMjs.tokens).colors.neutral[80],
            80: (0, _indexMjs.tokens).colors.neutral[40],
            90: (0, _indexMjs.tokens).colors.neutral[20],
            100: (0, _indexMjs.tokens).colors.neutral[10]
        },
        font: {
            primary: "{colors.white}",
            secondary: "{colors.neutral.100}",
            tertiary: "{colors.neutral.90}",
            inverse: "{colors.neutral.10}"
        },
        background: {
            primary: "{colors.neutral.10}",
            secondary: "{colors.neutral.20}",
            tertiary: "{colors.neutral.40}"
        },
        border: {
            primary: "{colors.neutral.60}",
            secondary: "{colors.neutral.40}",
            tertiary: "{colors.neutral.20}"
        },
        overlay: {
            5: "hsla(0, 0%, 100%, 0.05)",
            10: "hsla(0, 0%, 100%, 0.1)",
            20: "hsla(0, 0%, 100%, 0.2)",
            30: "hsla(0, 0%, 100%, 0.3)",
            40: "hsla(0, 0%, 100%, 0.4)",
            50: "hsla(0, 0%, 100%, 0.5)",
            60: "hsla(0, 0%, 100%, 0.6)",
            70: "hsla(0, 0%, 100%, 0.7)",
            80: "hsla(0, 0%, 100%, 0.8)",
            90: "hsla(0, 0%, 100%, 0.9)"
        }
    }
}, l = {
    colorMode: "dark",
    tokens: r
}, e = Object.assign({}, r);

},{"./tokens/index.mjs":"11JYE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jcjxO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnverifiedContactMethodType", ()=>o);
var _userMjs = require("./user.mjs");
const o = (o)=>Object.values((0, _userMjs.UnverifiedContactMethodType)).findIndex((e)=>e === o) >= 0;

},{"./user.mjs":"aZbQw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dXMi7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyContext", ()=>o);
var _react = require("react");
var _ui = require("@aws-amplify/ui");
const o = _react.createContext({
    theme: (0, _ui.createTheme)()
});

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"31OA9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Authenticator", ()=>j);
parcelHelpers.export(exports, "AuthenticatorInternal", ()=>w);
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _versionMjs = require("../../version.mjs");
var _useDeprecationWarningMjs = require("../../hooks/useDeprecationWarning.mjs");
var _useCustomComponentsMjs = require("./hooks/useCustomComponents/useCustomComponents.mjs");
var _viewMjs = require("../../primitives/View/View.mjs");
var _routerMjs = require("./Router/Router.mjs");
var _setupTOTPMjs = require("./SetupTOTP/SetupTOTP.mjs");
var _signInMjs = require("./SignIn/SignIn.mjs");
var _signUpMjs = require("./SignUp/SignUp.mjs");
var _forceNewPasswordMjs = require("./ForceNewPassword/ForceNewPassword.mjs");
var _confirmResetPasswordMjs = require("./ResetPassword/ConfirmResetPassword.mjs");
var _resetPasswordMjs = require("./ResetPassword/ResetPassword.mjs");
var _defaultComponentsMjs = require("./hooks/useCustomComponents/defaultComponents.mjs");
function w({ children: s, className: r, components: m, formFields: u, hideSignUp: c, initialState: l, loginMechanisms: f, passwordSettings: d, signUpAttributes: w, services: j, socialProviders: P, variation: S }) {
    (0, _useDeprecationWarningMjs.useDeprecationWarning)({
        message: "The `passwordSettings` prop has been deprecated and will be removed in a future major version of Amplify UI.",
        shouldWarn: !!d
    });
    const { route: v, signOut: h, user: O } = (0, _uiReactCore.useAuthenticator)(({ route: e, signOut: s, user: o })=>[
            e,
            s,
            o
        ]);
    (0, _uiReactCore.useAuthenticatorInitMachine)({
        initialState: l,
        loginMechanisms: f,
        services: j,
        signUpAttributes: w,
        socialProviders: P,
        formFields: u
    });
    const C = _react.useMemo(()=>({
            components: Object.assign(Object.assign({}, (0, _defaultComponentsMjs.defaultComponents)), m)
        }), [
        m
    ]);
    return "authenticated" === v || "signOut" === v ? s ? _react.createElement(_react.Fragment, null, (0, _ui.isFunction)(s) ? s({
        signOut: h,
        user: O
    }) : s) : null : _react.createElement((0, _useCustomComponentsMjs.CustomComponentsContext).Provider, {
        value: C
    }, _react.createElement((0, _routerMjs.Router), {
        className: r,
        hideSignUp: c,
        variation: S
    }));
}
function j(o) {
    return _react.useEffect(()=>{
        (0, _ui.configureComponent)({
            packageName: "@aws-amplify/ui-react",
            version: (0, _versionMjs.VERSION)
        });
    }, []), _react.createElement((0, _uiReactCore.AuthenticatorProvider), null, _react.createElement(w, Object.assign({}, o)));
}
j.Provider = (0, _uiReactCore.AuthenticatorProvider), j.ResetPassword = (0, _resetPasswordMjs.ResetPassword), j.SetupTOTP = (0, _setupTOTPMjs.SetupTOTP), j.SignIn = (0, _signInMjs.SignIn), j.SignUp = (0, _signUpMjs.SignUp), j.ForceNewPassword = (0, _forceNewPasswordMjs.ForceNewPassword);

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@aws-amplify/ui-react-core":"cZFwB","../../version.mjs":"hWqjf","../../hooks/useDeprecationWarning.mjs":"4R7UF","./hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../../primitives/View/View.mjs":"dfO6K","./Router/Router.mjs":"eXRp4","./SetupTOTP/SetupTOTP.mjs":"kz4YC","./SignIn/SignIn.mjs":"53ujc","./SignUp/SignUp.mjs":"1Erpu","./ForceNewPassword/ForceNewPassword.mjs":"wtNsH","./ResetPassword/ConfirmResetPassword.mjs":"4YMpS","./ResetPassword/ResetPassword.mjs":"klVJ1","./hooks/useCustomComponents/defaultComponents.mjs":"8mceg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZFwB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticatorProvider", ()=>(0, _authenticatorProviderMjsDefault.default));
parcelHelpers.export(exports, "useAuthenticator", ()=>(0, _useAuthenticatorMjsDefault.default));
parcelHelpers.export(exports, "useAuthenticatorRoute", ()=>(0, _useAuthenticatorRouteMjsDefault.default));
parcelHelpers.export(exports, "useAuthenticatorInitMachine", ()=>(0, _useAuthenticatorInitMachineMjsDefault.default));
parcelHelpers.export(exports, "isAuthenticatorComponentRouteKey", ()=>(0, _utilsMjs.isComponentRouteKey));
parcelHelpers.export(exports, "resolveAuthenticatorComponents", ()=>(0, _utilsMjs.resolveAuthenticatorComponents));
parcelHelpers.export(exports, "RenderNothing", ()=>(0, _renderNothingMjsDefault.default));
parcelHelpers.export(exports, "useDeprecationWarning", ()=>(0, _useDeprecationWarningMjsDefault.default));
parcelHelpers.export(exports, "useHasValueUpdated", ()=>(0, _useHasValueUpdatedMjsDefault.default));
parcelHelpers.export(exports, "usePreviousValue", ()=>(0, _usePreviousValueMjsDefault.default));
var _authenticatorProviderMjs = require("./Authenticator/context/AuthenticatorProvider.mjs");
var _authenticatorProviderMjsDefault = parcelHelpers.interopDefault(_authenticatorProviderMjs);
var _authenticatorContextMjs = require("./Authenticator/context/AuthenticatorContext.mjs");
var _useAuthenticatorMjs = require("./Authenticator/hooks/useAuthenticator/useAuthenticator.mjs");
var _useAuthenticatorMjsDefault = parcelHelpers.interopDefault(_useAuthenticatorMjs);
var _useAuthenticatorRouteMjs = require("./Authenticator/hooks/useAuthenticatorRoute/useAuthenticatorRoute.mjs");
var _useAuthenticatorRouteMjsDefault = parcelHelpers.interopDefault(_useAuthenticatorRouteMjs);
var _useAuthenticatorInitMachineMjs = require("./Authenticator/hooks/useAuthenticatorInitMachine/useAuthenticatorInitMachine.mjs");
var _useAuthenticatorInitMachineMjsDefault = parcelHelpers.interopDefault(_useAuthenticatorInitMachineMjs);
var _utilsMjs = require("./Authenticator/hooks/utils.mjs");
var _renderNothingMjs = require("./components/RenderNothing/RenderNothing.mjs");
var _renderNothingMjsDefault = parcelHelpers.interopDefault(_renderNothingMjs);
var _useDeprecationWarningMjs = require("./hooks/useDeprecationWarning.mjs");
var _useDeprecationWarningMjsDefault = parcelHelpers.interopDefault(_useDeprecationWarningMjs);
var _useHasValueUpdatedMjs = require("./hooks/useHasValueUpdated.mjs");
var _useHasValueUpdatedMjsDefault = parcelHelpers.interopDefault(_useHasValueUpdatedMjs);
var _usePreviousValueMjs = require("./hooks/usePreviousValue.mjs");
var _usePreviousValueMjsDefault = parcelHelpers.interopDefault(_usePreviousValueMjs);

},{"./Authenticator/context/AuthenticatorProvider.mjs":"6cINR","./Authenticator/context/AuthenticatorContext.mjs":"9Du3N","./Authenticator/hooks/useAuthenticator/useAuthenticator.mjs":"4tUI3","./Authenticator/hooks/useAuthenticatorRoute/useAuthenticatorRoute.mjs":false,"./Authenticator/hooks/useAuthenticatorInitMachine/useAuthenticatorInitMachine.mjs":"41ZGT","./Authenticator/hooks/utils.mjs":false,"./components/RenderNothing/RenderNothing.mjs":false,"./hooks/useDeprecationWarning.mjs":"4q6Zf","./hooks/useHasValueUpdated.mjs":false,"./hooks/usePreviousValue.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6cINR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AuthenticatorProvider);
var _tslibEs6Mjs = require("../../node_modules/tslib/tslib.es6.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@xstate/react");
var _awsAmplify = require("aws-amplify");
var _ui = require("@aws-amplify/ui");
var _authenticatorContextMjs = require("./AuthenticatorContext.mjs");
const createHubHandler = (options)=>(data, service)=>(0, _tslibEs6Mjs.__awaiter)(void 0, void 0, void 0, function*() {
            yield (0, _ui.defaultAuthHubHandler)(data, service, options);
        });
function AuthenticatorProvider({ children }) {
    // `authStatus` is exposed by `useAuthenticator` but should not be derived directly from the
    // state machine as the machine only updates on `Authenticator` initiated events, which
    // leads to scenarios where the state machine `authStatus` gets "stuck". For exmample,
    // if a user was to sign in using `Auth.signIn` directly rather than using `Authenticator`
    const [authStatus, setAuthStatus] = (0, _reactDefault.default).useState("configuring");
    // only run on first render
    (0, _reactDefault.default).useEffect(()=>{
        (0, _awsAmplify.Auth).currentAuthenticatedUser().then(()=>{
            setAuthStatus("authenticated");
        }).catch(()=>{
            setAuthStatus("unauthenticated");
        });
    }, []);
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, _react.useContext)((0, _authenticatorContextMjs.AuthenticatorContext));
    const service = (0, _react1.useInterpret)((0, _ui.createAuthenticatorMachine));
    const value = (0, _react.useMemo)(()=>!parentProviderVal ? {
            authStatus,
            service
        } : parentProviderVal, [
        authStatus,
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, _react.useEffect)(()=>{
        const onSignIn = ()=>{
            setAuthStatus("authenticated");
        };
        const onSignOut = ()=>{
            setAuthStatus("unauthenticated");
        };
        const unsubscribe = (0, _ui.listenToAuthHub)(activeService, createHubHandler({
            onSignIn,
            onSignOut
        }));
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, _reactDefault.default).createElement((0, _authenticatorContextMjs.AuthenticatorContext).Provider, {
        value: value
    }, children);
}

},{"../../node_modules/tslib/tslib.es6.mjs":"bULeW","react":"gVheC","@xstate/react":"i8Hor","aws-amplify":"75VoS","@aws-amplify/ui":"2NgwQ","./AuthenticatorContext.mjs":"9Du3N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bULeW":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__rest", ()=>__rest);
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8Hor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMachine", ()=>(0, _useMachine.useMachine));
parcelHelpers.export(exports, "useActor", ()=>(0, _useActor.useActor));
parcelHelpers.export(exports, "useInterpret", ()=>(0, _useInterpret.useInterpret));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "useSpawn", ()=>(0, _useSpawn.useSpawn));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _utils.shallowEqual));
var _useMachine = require("./useMachine");
var _useActor = require("./useActor");
var _useInterpret = require("./useInterpret");
var _useSelector = require("./useSelector");
var _useSpawn = require("./useSpawn");
var _utils = require("./utils");

},{"./useMachine":false,"./useActor":false,"./useInterpret":"8UcFw","./useSelector":"9HC2D","./useSpawn":false,"./utils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6vMZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isActorWithState", ()=>isActorWithState);
parcelHelpers.export(exports, "useActor", ()=>useActor);
var _react = require("react");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _useConstant = require("./useConstant");
var _useConstantDefault = parcelHelpers.interopDefault(_useConstant);
var _shim = require("use-sync-external-store/shim");
function isActorWithState(actorRef) {
    return "state" in actorRef;
}
function isDeferredActor(actorRef) {
    return "deferred" in actorRef;
}
function defaultGetSnapshot(actorRef) {
    return "getSnapshot" in actorRef ? actorRef.getSnapshot() : isActorWithState(actorRef) ? actorRef.state : undefined;
}
function useActor(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = defaultGetSnapshot;
    var actorRefRef = (0, _react.useRef)(actorRef);
    var deferredEventsRef = (0, _react.useRef)([]);
    var subscribe = (0, _react.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, _react.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var storeSnapshot = (0, _shim.useSyncExternalStore)(subscribe, boundGetSnapshot, boundGetSnapshot);
    var send = (0, _useConstantDefault.default)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if (isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}

},{"react":"gVheC","use-isomorphic-layout-effect":"8BuGK","./useConstant":"dURaA","use-sync-external-store/shim":"cLdhI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8BuGK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var index = (0, _react.useLayoutEffect);
exports.default = index;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dURaA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useConstant);
var _react = require("react");
function useConstant(fn) {
    var ref = _react.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cLdhI":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"bmoBS"}],"bmoBS":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"gVheC"}],"8UcFw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIdleInterpreter", ()=>useIdleInterpreter);
parcelHelpers.export(exports, "useInterpret", ()=>useInterpret);
var _react = require("react");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _xstate = require("xstate");
var _useConstant = require("./useConstant");
var _useConstantDefault = parcelHelpers.interopDefault(_useConstant);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function useIdleInterpreter(getMachine, options) {
    var machine = (0, _useConstantDefault.default)(function() {
        return typeof getMachine === "function" ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = __rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, _useConstantDefault.default)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return __assign(__assign({}, machine.context), context);
        });
        return (0, _xstate.interpret)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function useInterpret(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = __read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = useIdleInterpreter(getMachine, options);
    (0, _react.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, _xstate.toObserver)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, _react.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, _xstate.State).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, _xstate.InterpreterStatus).NotStarted;
        };
    }, []);
    return service;
}

},{"react":"gVheC","use-isomorphic-layout-effect":"8BuGK","xstate":"3RMsL","./useConstant":"dURaA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9HC2D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _useActor = require("./useActor");
var _utils = require("./utils");
function isService(actor) {
    return "state" in actor && "machine" in actor;
}
var defaultCompare = function(a, b) {
    return a === b;
};
var defaultGetSnapshot = function(a, initialStateCacheRef) {
    if (isService(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, _utils.getServiceSnapshot)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, _useActor.isActorWithState)(a) ? a.state : undefined;
};
function useSelector(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = defaultCompare;
    var initialStateCacheRef = (0, _react.useRef)(null);
    var subscribe = (0, _react.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, _react.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, _withSelector.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}

},{"react":"gVheC","use-sync-external-store/shim/with-selector":"aG3Vw","./useActor":"6vMZh","./utils":"dB7FN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aG3Vw":[function(require,module,exports) {
"use strict";
module.exports = require("646f3adc157912dd");

},{"646f3adc157912dd":"2pltz"}],"2pltz":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("2c99ce9e3cb5debf"), n = require("969be431eae4eb00");
function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if (q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = r(a, c[0], c[1]);
    u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    w(d);
    return d;
};

},{"2c99ce9e3cb5debf":"gVheC","969be431eae4eb00":"cLdhI"}],"dB7FN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
parcelHelpers.export(exports, "getServiceSnapshot", ()=>getServiceSnapshot);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function partition(items, predicate) {
    var e_1, _a;
    var _b = __read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function getServiceSnapshot(service) {
    return service.status !== 0 ? service.state : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Du3N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthenticatorContext", ()=>AuthenticatorContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * AuthenticatorContext serves static reference to the auth machine service.
 *
 * https://xstate.js.org/docs/recipes/react.html#context-provider
 */ const AuthenticatorContext = (0, _reactDefault.default).createContext(null);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tUI3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAuthenticator);
var _tslibEs6Mjs = require("../../../node_modules/tslib/tslib.es6.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@xstate/react");
var _ui = require("@aws-amplify/ui");
var _awsAmplify = require("aws-amplify");
var _authenticatorContextMjs = require("../../context/AuthenticatorContext.mjs");
var _constantsMjs = require("./constants.mjs");
var _utilsMjs = require("./utils.mjs");
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator/headless#useauthenticator-hook)
 */ function useAuthenticator(selector) {
    const context = (0, _reactDefault.default).useContext((0, _authenticatorContextMjs.AuthenticatorContext));
    if (!context) throw new Error((0, _constantsMjs.USE_AUTHENTICATOR_ERROR));
    const { service } = context;
    const { send } = service;
    const xstateSelector = (0, _react.useCallback)((state)=>Object.assign({}, (0, _ui.getServiceFacade)({
            send,
            state
        })), [
        send
    ]);
    const comparator = selector ? (0, _utilsMjs.getComparator)(selector) : (0, _utilsMjs.defaultComparator);
    // the purpose of `context.authStatus`is to intentionally override `facade.authStatus`. `facade.authStatus` does
    // not update on external sign in events (for example when a user is not using the `Authenticator`).
    const { authStatus } = context;
    const facade = (0, _react1.useSelector)(service, xstateSelector, comparator);
    const { route, totpSecretCode, unverifiedContactMethods, user } = facade, rest = (0, _tslibEs6Mjs.__rest)(facade, [
        "route",
        "totpSecretCode",
        "unverifiedContactMethods",
        "user"
    ]);
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `QRFields` values only used for SetupTOTP page to retrieve issuer information, will be removed in future
    const QRFields = route === "setupTOTP" ? (0, _utilsMjs.getQRFields)(serviceSnapshot) : null;
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, _utilsMjs.getMachineFields)(route, serviceSnapshot, unverifiedContactMethods);
    return Object.assign(Object.assign({}, rest), {
        authStatus,
        route,
        totpSecretCode,
        unverifiedContactMethods,
        user,
        /** @deprecated For internal use only */ fields,
        getTotpSecretCode: (0, _utilsMjs.getTotpSecretCodeCallback)(user),
        QRFields
    });
}

},{"../../../node_modules/tslib/tslib.es6.mjs":"bULeW","react":"gVheC","@xstate/react":"i8Hor","@aws-amplify/ui":"2NgwQ","aws-amplify":"75VoS","../../context/AuthenticatorContext.mjs":"9Du3N","./constants.mjs":"2qd15","./utils.mjs":"3mY6V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2qd15":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USE_AUTHENTICATOR_ERROR", ()=>USE_AUTHENTICATOR_ERROR);
const USE_AUTHENTICATOR_ERROR = "`useAuthenticator` must be used inside an `Authenticator.Provider`.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3mY6V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areSelectorDepsEqual", ()=>areSelectorDepsEqual);
parcelHelpers.export(exports, "defaultComparator", ()=>defaultComparator);
parcelHelpers.export(exports, "getComparator", ()=>getComparator);
parcelHelpers.export(exports, "getMachineFields", ()=>getMachineFields);
parcelHelpers.export(exports, "getQRFields", ()=>getQRFields);
parcelHelpers.export(exports, "getTotpSecretCodeCallback", ()=>getTotpSecretCodeCallback);
var _tslibEs6Mjs = require("../../../node_modules/tslib/tslib.es6.mjs");
var _awsAmplify = require("aws-amplify");
var _ui = require("@aws-amplify/ui");
var _utilsMjs = require("../utils.mjs");
const defaultComparator = ()=>false;
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */ function areSelectorDepsEqual(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, _ui.areEmptyArrays)(currentDep, nextDep) || (0, _ui.areEmptyObjects)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const getComparator = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return areSelectorDepsEqual(currentSelectorDeps, nextSelectorDeps);
    };
const getQRFields = (state)=>{
    var _a, _b, _c;
    return Object.assign({}, (_c = (_b = (_a = (0, _ui.getActorContext)(state)) === null || _a === void 0 ? void 0 : _a.formFields) === null || _b === void 0 ? void 0 : _b.setupTOTP) === null || _c === void 0 ? void 0 : _c.QR);
};
const getTotpSecretCodeCallback = (user)=>function getTotpSecretCode() {
        return (0, _tslibEs6Mjs.__awaiter)(this, void 0, void 0, function*() {
            return yield (0, _awsAmplify.Auth).setupTOTP(user);
        });
    };
const flattenFormFields = (fields)=>fields.flatMap(([name, options])=>Object.assign({
            name
        }, options));
const convertContactMethodsToFields = (unverifiedContactMethods)=>{
    return unverifiedContactMethods && Object.entries(unverifiedContactMethods).map(([name, value])=>{
        const valueIsString = (0, _ui.isString)(value);
        if (!valueIsString || !name) return {};
        return {
            name,
            label: value,
            type: "radio",
            value
        };
    });
};
/**
 * Retrieves default and custom (RWA only, to be updated) form field values from state machine
 * for subcomponent routes that render fields
 */ const getMachineFields = (route, state, unverifiedContactMethods)=>{
    if ((0, _utilsMjs.isComponentRouteKey)(route)) return route === "verifyUser" ? convertContactMethodsToFields(unverifiedContactMethods) : flattenFormFields((0, _ui.getSortedFormFields)(route, state));
    return [];
};

},{"../../../node_modules/tslib/tslib.es6.mjs":"bULeW","aws-amplify":"75VoS","@aws-amplify/ui":"2NgwQ","../utils.mjs":"l0gUA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0gUA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isComponentRouteKey", ()=>isComponentRouteKey);
parcelHelpers.export(exports, "resolveAuthenticatorComponents", ()=>resolveAuthenticatorComponents);
var _constantsMjs = require("./constants.mjs");
const isComponentRouteKey = (route)=>(0, _constantsMjs.COMPONENT_ROUTE_KEYS).some((componentRoute)=>componentRoute === route);
function resolveAuthenticatorComponents(defaults, overrides) {
    if (!overrides) return defaults;
    return (0, _constantsMjs.COMPONENT_ROUTE_NAMES).reduce((components, route)=>{
        const Default = defaults[route];
        const Override = overrides[route];
        if (typeof Override !== "function") return Object.assign(Object.assign({}, components), {
            [route]: Default
        });
        const { Footer, FormFields, Header } = Default;
        // cast to allow assigning of component slots
        const Component = Override;
        Component.Footer = Footer;
        Component.FormFields = FormFields;
        Component.Header = Header;
        return Object.assign(Object.assign({}, components), {
            [route]: Component
        });
    }, {});
}

},{"./constants.mjs":"2fCFs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2fCFs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPONENT_ROUTE_KEYS", ()=>COMPONENT_ROUTE_KEYS);
parcelHelpers.export(exports, "COMPONENT_ROUTE_NAMES", ()=>COMPONENT_ROUTE_NAMES);
const COMPONENT_ROUTE_KEYS = [
    "confirmResetPassword",
    "confirmSignIn",
    "confirmSignUp",
    "confirmVerifyUser",
    "forceNewPassword",
    "resetPassword",
    "setupTOTP",
    "signIn",
    "signUp",
    "verifyUser"
];
const COMPONENT_ROUTE_NAMES = [
    "ConfirmResetPassword",
    "ConfirmSignIn",
    "ConfirmSignUp",
    "ConfirmVerifyUser",
    "ForceNewPassword",
    "ResetPassword",
    "SetupTOTP",
    "SignIn",
    "SignUp",
    "VerifyUser"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"41ZGT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAuthenticatorInitMachine);
parcelHelpers.export(exports, "routeSelector", ()=>routeSelector);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAuthenticatorMjs = require("../useAuthenticator/useAuthenticator.mjs");
var _useAuthenticatorMjsDefault = parcelHelpers.interopDefault(_useAuthenticatorMjs);
// only select `route` from machine context
const routeSelector = ({ route })=>[
        route
    ];
function useAuthenticatorInitMachine(data) {
    const { route, initializeMachine } = (0, _useAuthenticatorMjsDefault.default)(routeSelector);
    const hasInitialized = (0, _reactDefault.default).useRef(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (!hasInitialized.current && route === "setup") {
            initializeMachine(data);
            hasInitialized.current = true;
        }
    }, [
        initializeMachine,
        route,
        data
    ]);
}

},{"react":"gVheC","../useAuthenticator/useAuthenticator.mjs":"4tUI3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4q6Zf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDeprecationWarning);
var _react = require("react");
/**
 * Logs a deprecation warning message.
 *
 * @important Please use the React/React Native specific platform implementations.
 * This version of the hook is a base implementation that the others extend from due
 * to env differences between running in RN or the browser
 */ const useDeprecationWarning = ({ shouldWarn, message })=>{
    _react.useEffect(()=>{
        if (shouldWarn) // eslint-disable-next-line no-console
        console.warn(message);
    }, [
        shouldWarn,
        message
    ]);
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hWqjf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>o);
const o = "5.3.3";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4R7UF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeprecationWarning", ()=>s);
var _uiReactCore = require("@aws-amplify/ui-react-core");
var process = require("5bc561e6589f647f");
const s = ({ message: s, shouldWarn: o })=>{
    const r = o && ("undefined" == typeof process || process && false);
    (0, _uiReactCore.useDeprecationWarning)({
        message: s,
        shouldWarn: r
    });
};

},{"5bc561e6589f647f":"4avz9","@aws-amplify/ui-react-core":"cZFwB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsuPw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomComponentsContext", ()=>t);
parcelHelpers.export(exports, "useCustomComponents", ()=>e);
var _react = require("react");
const t = _react.createContext(null), e = ()=>{
    const e = _react.useContext(t);
    if (!e) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
    return e;
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dfO6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>s);
var _tslib = require("tslib");
var _react = require("react");
var _styleUtilsMjs = require("../shared/styleUtils.mjs");
const s = _react.forwardRef((s, a)=>{
    var { as: i = "div", children: l, testId: d, ariaLabel: n, isDisabled: o, style: m, inert: b } = s, p = (0, _tslib.__rest)(s, [
        "as",
        "children",
        "testId",
        "ariaLabel",
        "isDisabled",
        "style",
        "inert"
    ]);
    const { propStyles: c, nonStyleProps: y } = (0, _styleUtilsMjs.useStyles)(p, m);
    return _react.createElement(i, Object.assign({
        "aria-label": n,
        "data-testid": d,
        disabled: o,
        ref: a,
        inert: b ? "" : null,
        style: c
    }, y), l);
});
s.displayName = "View";

},{"tslib":"86BcK","react":"gVheC","../shared/styleUtils.mjs":"2LJhG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2LJhG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertGridSpan", ()=>f);
parcelHelpers.export(exports, "convertStylePropsToStyleObj", ()=>y);
parcelHelpers.export(exports, "getGridSpan", ()=>c);
parcelHelpers.export(exports, "isSpanPrimitiveValue", ()=>u);
parcelHelpers.export(exports, "useStyles", ()=>k);
parcelHelpers.export(exports, "useTransformStyleProps", ()=>b);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _styleMjs = require("../types/style.mjs");
var _utilsMjs = require("./responsive/utils.mjs");
var _useBreakpointMjs = require("./responsive/useBreakpoint.mjs");
var _amplifyContextMjs = require("../../components/ThemeProvider/AmplifyContext.mjs");
var _useThemeMjs = require("../../hooks/useTheme.mjs");
var _getStyleValueMjs = require("./getStyleValue.mjs");
var _utilsMjs1 = require("./utils.mjs");
const u = (o)=>"auto" === o || "number" == typeof o && !isNaN(o) || "string" == typeof o && !isNaN(parseFloat(o)), c = (o)=>"auto" === o ? "auto" : `span ${o}`, f = (o)=>u(o) ? c(o) : Array.isArray(o) ? o.map((o)=>c(o)) : "object" == typeof o && null != o ? Object.entries(o).reduce((o, [e, t])=>Object.assign(Object.assign({}, o), {
            [e]: c(t)
        }), {}) : null, b = (t)=>{
    const { rowSpan: r, columnSpan: s, row: n, column: p } = t, a = (0, _tslib.__rest)(t, [
        "rowSpan",
        "columnSpan",
        "row",
        "column"
    ]), { rowFromSpanValue: m, columnFromSpanValue: l } = _react.useMemo(()=>({
            rowFromSpanValue: f(r),
            columnFromSpanValue: f(s)
        }), [
        r,
        s
    ]);
    return Object.assign({
        row: (0, _utilsMjs1.isNullOrEmptyString)(n) ? m : n,
        column: (0, _utilsMjs1.isNullOrEmptyString)(p) ? l : p
    }, a);
}, y = ({ props: o = {}, style: e = {}, breakpoint: n, breakpoints: p, tokens: i })=>{
    const u = {};
    return Object.keys(o).filter((e)=>null !== o[e]).forEach((c)=>{
        if (c in (0, _styleMjs.ComponentPropsToStylePropsMap)) {
            const u = o[c];
            if (!u || (0, _utilsMjs1.isEmptyString)(u)) return;
            const f = (0, _styleMjs.ComponentPropsToStylePropsMap)[c];
            let b = "";
            (0, _ui.isDesignToken)(u) ? b = u.toString() : "string" == typeof u ? b = (0, _utilsMjs1.getCSSVariableIfValueIsThemeKey)(c, u, i) : "number" == typeof u ? b = u : "object" == typeof u && (b = (0, _getStyleValueMjs.getStyleValue)({
                propKey: c,
                tokens: i,
                value: (0, _utilsMjs.getValueAtCurrentBreakpoint)({
                    values: u,
                    breakpoint: n,
                    breakpoints: p
                })
            })), e = Object.assign(Object.assign({}, e), {
                [f]: b
            });
        } else void 0 !== o[c] && (u[c] = o[c]);
    }), {
        propStyles: e,
        nonStyleProps: u
    };
}, k = (o, t)=>{
    const { breakpoints: { values: r, defaultBreakpoint: s }, tokens: a } = (0, _useThemeMjs.useTheme)(), i = (0, _useBreakpointMjs.useBreakpoint)({
        breakpoints: r,
        defaultBreakpoint: s
    }), m = b(o);
    return _react.useMemo(()=>y({
            props: m,
            style: t,
            breakpoint: i,
            breakpoints: r,
            tokens: a
        }), [
        m,
        t,
        r,
        i,
        a
    ]);
};

},{"tslib":"86BcK","react":"gVheC","@aws-amplify/ui":"2NgwQ","../types/style.mjs":"jP0Ex","./responsive/utils.mjs":"eT4KF","./responsive/useBreakpoint.mjs":"aUc30","../../components/ThemeProvider/AmplifyContext.mjs":"dXMi7","../../hooks/useTheme.mjs":"48i37","./getStyleValue.mjs":"5NyxQ","./utils.mjs":"aPy8a","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jP0Ex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComponentPropsToStylePropsMap", ()=>n);
parcelHelpers.export(exports, "ComponentPropsToStylePropsMapKeys", ()=>i);
const n = {
    alignContent: "alignContent",
    alignItems: "alignItems",
    alignSelf: "alignSelf",
    area: "gridArea",
    aspectRatio: "aspectRatio",
    autoColumns: "gridAutoColumns",
    autoFlow: "gridAutoFlow",
    autoRows: "gridAutoRows",
    backgroundColor: "backgroundColor",
    backgroundImage: "backgroundImage",
    basis: "flexBasis",
    border: "border",
    borderRadius: "borderRadius",
    borderColor: "borderColor",
    borderWidth: "borderWidth",
    borderStyle: "borderStyle",
    bottom: "bottom",
    boxShadow: "boxShadow",
    color: "color",
    column: "gridColumn",
    columnEnd: "gridColumnEnd",
    columnGap: "columnGap",
    columnSpan: "gridColumn",
    columnStart: "gridColumnStart",
    direction: "flexDirection",
    display: "display",
    flex: "flex",
    fontFamily: "fontFamily",
    fontSize: "fontSize",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    gap: "gap",
    grow: "flexGrow",
    height: "height",
    justifyContent: "justifyContent",
    left: "left",
    letterSpacing: "letterSpacing",
    lineHeight: "lineHeight",
    margin: "margin",
    marginBlock: "marginBlock",
    marginBlockEnd: "marginBlockEnd",
    marginBlockStart: "marginBlockStart",
    marginBottom: "marginBlockEnd",
    marginInline: "marginInline",
    marginInlineEnd: "marginInlineEnd",
    marginInlineStart: "marginInlineStart",
    marginLeft: "marginInlineStart",
    marginRight: "marginInlineEnd",
    marginTop: "marginBlockStart",
    maxHeight: "maxHeight",
    maxWidth: "maxWidth",
    minHeight: "minHeight",
    minWidth: "minWidth",
    objectFit: "objectFit",
    objectPosition: "objectPosition",
    opacity: "opacity",
    order: "order",
    overflow: "overflow",
    padding: "padding",
    paddingBlock: "paddingBlock",
    paddingBlockEnd: "paddingBlockEnd",
    paddingBlockStart: "paddingBlockStart",
    paddingBottom: "paddingBlockEnd",
    paddingInline: "paddingInline",
    paddingInlineEnd: "paddingInlineEnd",
    paddingInlineStart: "paddingInlineStart",
    paddingLeft: "paddingInlineStart",
    paddingRight: "paddingInlineEnd",
    paddingTop: "paddingBlockStart",
    position: "position",
    resize: "resize",
    right: "right",
    row: "gridRow",
    rowEnd: "gridRowEnd",
    rowGap: "rowGap",
    rowSpan: "gridRow",
    rowStart: "gridRowStart",
    shrink: "flexShrink",
    templateAreas: "gridTemplateAreas",
    templateColumns: "gridTemplateColumns",
    templateRows: "gridTemplateRows",
    textAlign: "textAlign",
    textDecoration: "textDecoration",
    textTransform: "textTransform",
    top: "top",
    transform: "transform",
    transformOrigin: "transformOrigin",
    width: "width",
    whiteSpace: "whiteSpace",
    wrap: "flexWrap"
}, i = Object.keys(n);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eT4KF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueAtCurrentBreakpoint", ()=>o);
var _ui = require("@aws-amplify/ui");
var _utilsMjs = require("../utils.mjs");
const o = ({ breakpoint: o, breakpoints: e, values: s })=>{
    let i = {};
    const n = (0, _utilsMjs.objectKeys)(e).sort((r, t)=>e[r] - e[t]);
    var a;
    return Array.isArray(s) ? s.forEach((r, t)=>{
        i[n[t]] = r;
    }) : "object" == typeof s && (i = (0, _utilsMjs.objectKeys)(a = s).reduce((t, o)=>o in (0, _ui.defaultTheme).breakpoints.values ? Object.assign(Object.assign({}, t), {
            [o]: a[o]
        }) : t, {})), (({ breakpoint: r, breakpoints: o, values: e })=>{
        const s = e[r];
        if (void 0 !== s) return s;
        const i = (0, _utilsMjs.objectKeys)(o).sort((r, t)=>o[t] - o[r]), n = i.slice(i.indexOf(r));
        for (const r of n){
            const t = e[r];
            if (void 0 !== t) return t;
        }
        return null;
    })({
        breakpoint: o,
        breakpoints: e,
        values: i
    });
};

},{"@aws-amplify/ui":"2NgwQ","../utils.mjs":"aPy8a","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPy8a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNameModifier", ()=>(0, _ui.classNameModifier));
parcelHelpers.export(exports, "classNameModifierByFlag", ()=>(0, _ui.classNameModifierByFlag));
parcelHelpers.export(exports, "getCSSVariableIfValueIsThemeKey", ()=>m);
parcelHelpers.export(exports, "getConsecutiveIntArray", ()=>f);
parcelHelpers.export(exports, "isEmptyString", ()=>s);
parcelHelpers.export(exports, "isNullOrEmptyString", ()=>n);
parcelHelpers.export(exports, "objectKeys", ()=>l);
parcelHelpers.export(exports, "strHasLength", ()=>o);
var _ui = require("@aws-amplify/ui");
var _themeMjs = require("../types/theme.mjs");
var _constantsMjs = require("./constants.mjs");
const o = (t)=>"string" == typeof t && t.length > 0, s = (t)=>"string" == typeof t && 0 === t.length, n = (t)=>null == t || s(t), f = (t, r)=>{
    const e = r - t + 1;
    return Array.from({
        length: e
    }, (r, e)=>e + t);
}, l = (t)=>Object.keys(t), m = (o, s, n)=>{
    if ("string" != typeof s) return s;
    if (s.includes(" ")) return s.split(" ").map((t)=>m(o, t, n)).join(" ");
    if ((0, _themeMjs.isThemeStylePropKey)(o)) {
        const e = s.split("."), f = (0, _constantsMjs.stylePropsToThemeKeys)[o];
        let l = n[f];
        for(let t = 0; t < e.length && l; t++)l = l[e[t]];
        return (0, _ui.isDesignToken)(l) ? `var(--${(0, _ui.cssNameTransform)({
            path: [
                (0, _constantsMjs.stylePropsToThemeKeys)[o],
                ...e
            ]
        })})` : s;
    }
    return s;
};

},{"@aws-amplify/ui":"2NgwQ","../types/theme.mjs":"6gobM","./constants.mjs":"aQd5e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gobM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isThemeStylePropKey", ()=>s);
var _constantsMjs = require("../shared/constants.mjs");
const s = (s)=>s in (0, _constantsMjs.stylePropsToThemeKeys);

},{"../shared/constants.mjs":"aQd5e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aQd5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARROW_DOWN", ()=>n);
parcelHelpers.export(exports, "ARROW_UP", ()=>r);
parcelHelpers.export(exports, "ComponentClassNames", ()=>t);
parcelHelpers.export(exports, "ComponentClassObject", ()=>a);
parcelHelpers.export(exports, "ComponentText", ()=>o);
parcelHelpers.export(exports, "ENTER_KEY", ()=>i);
parcelHelpers.export(exports, "ESCAPE_KEY", ()=>s);
parcelHelpers.export(exports, "stylePropsToThemeKeys", ()=>l);
var _ui = require("@aws-amplify/ui");
const a = {
    Alert: {
        className: (0, _ui.ComponentClassName).Alert,
        components: [
            "Alert"
        ],
        description: "Top level element that wraps the Alert primitive"
    },
    AlertIcon: {
        className: (0, _ui.ComponentClassName).AlertIcon,
        components: [
            "Alert"
        ],
        description: "Class applied to Icon component within the Alert primitive"
    },
    AlertHeading: {
        className: (0, _ui.ComponentClassName).AlertHeading,
        components: [
            "Alert"
        ],
        description: "Class applied to the heading View"
    },
    AlertBody: {
        className: (0, _ui.ComponentClassName).AlertBody,
        components: [
            "Alert"
        ],
        description: "Class applied to the body View"
    },
    AlertDismiss: {
        className: (0, _ui.ComponentClassName).AlertDismiss,
        components: [
            "Alert"
        ],
        description: "Class applied to the close Button"
    },
    Autocomplete: {
        className: (0, _ui.ComponentClassName).Autocomplete,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the Autocomplete primitive"
    },
    AutocompleteMenu: {
        className: (0, _ui.ComponentClassName).AutocompleteMenu,
        components: [
            "Autocomplete"
        ],
        description: "Top level element that wraps the dropdown menu"
    },
    AutocompleteMenuEmpty: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuEmpty,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the no options slot of menu"
    },
    AutocompleteMenuFooter: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuFooter,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu footer"
    },
    AutocompleteMenuHeader: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuHeader,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to menu header"
    },
    AutocompleteMenuLoading: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuLoading,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to the loading slot of menu"
    },
    AutocompleteMenuOption: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuOption,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to each li option"
    },
    AutocompleteMenuOptions: {
        className: (0, _ui.ComponentClassName).AutocompleteMenuOptions,
        components: [
            "Autocomplete"
        ],
        description: "Class applied to ul container element"
    },
    Badge: {
        className: (0, _ui.ComponentClassName).Badge,
        components: [
            "Badge"
        ],
        description: "Top level element that wraps the Badge component"
    },
    Breadcrumbs: {
        className: (0, _ui.ComponentClassName).Breadcrumbs,
        components: [
            "Breadcrumbs"
        ],
        description: "Top level element that wraps the Breadcrumbs component"
    },
    BreadcrumbsItem: {
        className: (0, _ui.ComponentClassName).BreadcrumbsItem,
        components: [
            "Breadcrumbs"
        ],
        description: "Each breadcrumb"
    },
    BreadcrumbsLink: {
        className: (0, _ui.ComponentClassName).BreadcrumbsLink,
        components: [
            "Breadcrumbs"
        ],
        description: "Links used within breadcrumbs"
    },
    BreadcrumbsList: {
        className: (0, _ui.ComponentClassName).BreadcrumbsList,
        components: [
            "Breadcrumbs"
        ],
        description: "List element within nav"
    },
    BreadcrumbsSeparator: {
        className: (0, _ui.ComponentClassName).BreadcrumbsSeparator,
        components: [
            "Breadcrumbs"
        ],
        description: "Separator between each breadcrumb"
    },
    Button: {
        className: (0, _ui.ComponentClassName).Button,
        components: [
            "Button"
        ],
        description: "Top level element that wraps the Button primitive"
    },
    ButtonGroup: {
        className: (0, _ui.ComponentClassName).ButtonGroup
    },
    ButtonLoaderWrapper: {
        className: (0, _ui.ComponentClassName).ButtonLoaderWrapper,
        components: [
            "Button"
        ],
        description: "Class applied to the Loader component within the Button Loading state"
    },
    Card: {
        className: (0, _ui.ComponentClassName).Card,
        components: [
            "Card"
        ],
        description: "Top level element that wraps the Card primitive"
    },
    Checkbox: {
        className: (0, _ui.ComponentClassName).Checkbox,
        components: [
            "Checkbox"
        ],
        description: "Top level element that wraps the Checkbox primitive"
    },
    CheckboxButton: {
        className: (0, _ui.ComponentClassName).CheckboxButton,
        components: [
            "Checkbox"
        ],
        description: "Wrapper for the checked icon within the Checkbox primitive"
    },
    CheckboxIcon: {
        className: (0, _ui.ComponentClassName).CheckboxIcon,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the checked icon within the Checkbox primitive"
    },
    CheckboxInput: {
        className: (0, _ui.ComponentClassName).CheckboxInput,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the visually hidden checkbox input within the Checkbox primitive"
    },
    CheckboxLabel: {
        className: (0, _ui.ComponentClassName).CheckboxLabel,
        components: [
            "Checkbox"
        ],
        description: "Class applied to the label within the Checkbox primitive"
    },
    CheckboxField: {
        className: (0, _ui.ComponentClassName).CheckboxField,
        components: [
            "CheckboxField"
        ],
        description: "Top level element that wraps the CheckboxField primitive"
    },
    Collection: {
        className: (0, _ui.ComponentClassName).Collection,
        components: [
            "Collection"
        ],
        description: "Top level element that wraps the Collection primitive"
    },
    CollectionItems: {
        className: (0, _ui.ComponentClassName).CollectionItems,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps all the items in a collection"
    },
    CollectionSearch: {
        className: (0, _ui.ComponentClassName).CollectionSearch,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the collection search box"
    },
    CollectionPagination: {
        className: (0, _ui.ComponentClassName).CollectionPagination,
        components: [
            "Collection"
        ],
        description: "Class applied to the element that wraps the pagination component in a collection"
    },
    CountryCodeSelect: {
        className: (0, _ui.ComponentClassName).CountryCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    DialCodeSelect: {
        className: (0, _ui.ComponentClassName).DialCodeSelect,
        components: [
            "PhoneNumberField"
        ],
        description: "Class applied to the Dial Code Select within the PhoneNumberField primitive"
    },
    Divider: {
        className: (0, _ui.ComponentClassName).Divider,
        components: [
            "Divider"
        ],
        description: "Top level element that wraps the Divider primitive"
    },
    DividerLabel: {
        className: (0, _ui.ComponentClassName).DividerLabel,
        components: [
            "Divider"
        ],
        description: "Class applied to the label of the Divider component"
    },
    DropZone: {
        className: (0, _ui.ComponentClassName).DropZone,
        components: [
            "DropZone"
        ],
        description: "Class applied to the DropZone component"
    },
    Expander: {
        className: (0, _ui.ComponentClassName).Expander,
        components: [
            "Expander"
        ],
        description: "Top level element that wraps the Expander primitive"
    },
    ExpanderContent: {
        className: (0, _ui.ComponentClassName).ExpanderContent,
        components: [
            "Expander"
        ],
        description: "Expander content container"
    },
    ExpanderContentText: {
        className: (0, _ui.ComponentClassName).ExpanderContentText,
        components: [
            "Expander"
        ],
        description: "Expander content text"
    },
    ExpanderHeader: {
        className: (0, _ui.ComponentClassName).ExpanderHeader,
        components: [
            "Expander"
        ],
        description: "Expander item header"
    },
    ExpanderIcon: {
        className: (0, _ui.ComponentClassName).ExpanderIcon,
        components: [
            "Expander"
        ],
        description: "Icon to indicate whether an item is expanded or collapsed"
    },
    ExpanderItem: {
        className: (0, _ui.ComponentClassName).ExpanderItem,
        components: [
            "Expander"
        ],
        description: "Expander item(containier for header, trigger, and content)"
    },
    ExpanderTrigger: {
        className: (0, _ui.ComponentClassName).ExpanderTrigger,
        components: [
            "Expander"
        ],
        description: "Expander item trigger(button)"
    },
    Field: {
        className: (0, _ui.ComponentClassName).Field
    },
    FieldDescription: {
        className: (0, _ui.ComponentClassName).FieldDescription
    },
    FieldErrorMessage: {
        className: (0, _ui.ComponentClassName).FieldErrorMessage
    },
    FieldGroup: {
        className: (0, _ui.ComponentClassName).FieldGroup
    },
    FieldGroupControl: {
        className: (0, _ui.ComponentClassName).FieldGroupControl
    },
    FieldGroupFieldWrapper: {
        className: (0, _ui.ComponentClassName).FieldGroupFieldWrapper
    },
    FieldGroupOuterEnd: {
        className: (0, _ui.ComponentClassName).FieldGroupOuterEnd
    },
    FieldGroupOuterStart: {
        className: (0, _ui.ComponentClassName).FieldGroupOuterStart
    },
    FieldGroupInnerEnd: {
        className: (0, _ui.ComponentClassName).FieldGroupInnerEnd
    },
    FieldGroupInnerStart: {
        className: (0, _ui.ComponentClassName).FieldGroupInnerStart
    },
    FieldGroupIcon: {
        className: (0, _ui.ComponentClassName).FieldGroupIcon
    },
    FieldGroupIconButton: {
        className: (0, _ui.ComponentClassName).FieldGroupIconButton
    },
    FieldGroupHasInnerEnd: {
        className: (0, _ui.ComponentClassName).FieldGroupHasInnerEnd
    },
    FieldGroupHasInnerStart: {
        className: (0, _ui.ComponentClassName).FieldGroupHasInnerStart
    },
    FieldShowPassword: {
        className: (0, _ui.ComponentClassName).FieldShowPassword
    },
    Fieldset: {
        className: (0, _ui.ComponentClassName).Fieldset,
        components: [
            "Fieldset"
        ],
        description: "Top level element that wraps the Fieldset primitive"
    },
    FieldsetLegend: {
        className: (0, _ui.ComponentClassName).FieldsetLegend,
        components: [
            "Fieldset"
        ],
        description: "Visual label for the Fieldset primitive"
    },
    FileUploaderDropZone: {
        className: (0, _ui.ComponentClassName).FileUploaderDropZone,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneIcon: {
        className: (0, _ui.ComponentClassName).FileUploaderDropZoneIcon,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneText: {
        className: (0, _ui.ComponentClassName).FileUploaderDropZoneText,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderDropZoneButton: {
        className: (0, _ui.ComponentClassName).FileUploaderDropZoneButton,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFile: {
        className: (0, _ui.ComponentClassName).FileUploaderFile,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileWrapper: {
        className: (0, _ui.ComponentClassName).FileUploaderFileWrapper,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileName: {
        className: (0, _ui.ComponentClassName).FileUploaderFileName,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderLoader: {
        className: (0, _ui.ComponentClassName).FileUploaderLoader,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileSize: {
        className: (0, _ui.ComponentClassName).FileUploaderFileSize,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileInfo: {
        className: (0, _ui.ComponentClassName).FileUploaderFileInfo,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileImage: {
        className: (0, _ui.ComponentClassName).FileUploaderFileImage,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileMain: {
        className: (0, _ui.ComponentClassName).FileUploaderFileMain,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderFileStatus: {
        className: (0, _ui.ComponentClassName).FileUploaderFileStatus,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewer: {
        className: (0, _ui.ComponentClassName).FileUploaderPreviewer,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerText: {
        className: (0, _ui.ComponentClassName).FileUploaderPreviewerText,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerBody: {
        className: (0, _ui.ComponentClassName).FileUploaderPreviewerBody,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerFooter: {
        className: (0, _ui.ComponentClassName).FileUploaderPreviewerFooter,
        components: [
            "FileUploader"
        ]
    },
    FileUploaderPreviewerFooterActions: {
        className: (0, _ui.ComponentClassName).FileUploaderPreviewerFooterActions,
        components: [
            "FileUploader"
        ]
    },
    Flex: {
        className: (0, _ui.ComponentClassName).Flex,
        components: [
            "Flex"
        ],
        description: "Top level element that wraps the Flex primitive"
    },
    Grid: {
        className: (0, _ui.ComponentClassName).Grid,
        components: [
            "Grid"
        ],
        description: "Top level element that wraps the Grid primitive"
    },
    Heading: {
        className: (0, _ui.ComponentClassName).Heading,
        components: [
            "Heading"
        ],
        description: "Top level element that wraps the Heading primitive"
    },
    HighlightMatch: {
        className: (0, _ui.ComponentClassName).HighlightMatch,
        components: [
            "HighlightMatch"
        ],
        description: "Top level element that wraps the HighlightMatch primitive"
    },
    HighlightMatchHighlighted: {
        className: (0, _ui.ComponentClassName).HighlightMatchHighlighted,
        components: [
            "HighlightMatch"
        ],
        description: "Class applied to the highlighted text of the HighlightMatch primitive"
    },
    Icon: {
        className: (0, _ui.ComponentClassName).Icon,
        components: [
            "Icon"
        ],
        description: "Top level element that wraps the Icon primitive"
    },
    Image: {
        className: (0, _ui.ComponentClassName).Image,
        components: [
            "Image"
        ],
        description: "Top level element that wraps the Image primitive"
    },
    Input: {
        className: (0, _ui.ComponentClassName).Input,
        components: [
            "Input"
        ],
        description: "Class applied to the input element"
    },
    Label: {
        className: (0, _ui.ComponentClassName).Label,
        components: [
            "Label"
        ],
        description: "Class applied to the label element"
    },
    Link: {
        className: (0, _ui.ComponentClassName).Link,
        components: [
            "Link"
        ],
        description: "Top level element that wraps the Link primitive"
    },
    Loader: {
        className: (0, _ui.ComponentClassName).Loader,
        components: [
            "Loader"
        ],
        description: "Top level element that wraps the Loader primitive"
    },
    LoaderDeterminate: {
        className: (0, _ui.ComponentClassName).LoaderDeterminate,
        components: [
            "Loader"
        ],
        description: "Class applied to a determinate loader"
    },
    LoaderPercentageText: {
        className: (0, _ui.ComponentClassName).LoaderPercentageText,
        components: [
            "Loader"
        ],
        description: "Class applied to the percentage text of loader"
    },
    MenuContent: {
        className: (0, _ui.ComponentClassName).MenuContent,
        components: [
            "Menu"
        ],
        description: "Menu content container (Flex)"
    },
    MenuContentWrapper: {
        className: (0, _ui.ComponentClassName).MenuContentWrapper,
        components: [
            "Menu"
        ],
        description: "Menu content wrapper"
    },
    MenuItem: {
        className: (0, _ui.ComponentClassName).MenuItem,
        components: [
            "Menu"
        ],
        description: "Menu item button (MenuButton, wrapped in amplify-menu-content class)"
    },
    MenuTrigger: {
        className: (0, _ui.ComponentClassName).MenuTrigger,
        components: [
            "Menu"
        ],
        description: "Menu trigger button (MenuButton, not wrapped in amplify-menu-content class)"
    },
    Message: {
        className: (0, _ui.ComponentClassName).Message,
        components: [
            "Message"
        ],
        description: "Class applied to the root element of the Message"
    },
    MessageIcon: {
        className: (0, _ui.ComponentClassName).MessageIcon,
        components: [
            "Message"
        ],
        description: "Class applied to Icon component within the Message primitive"
    },
    MessageHeading: {
        className: (0, _ui.ComponentClassName).MessageHeading,
        components: [
            "Message"
        ],
        description: "Class applied to the heading View"
    },
    MessageBody: {
        className: (0, _ui.ComponentClassName).MessageBody,
        components: [
            "Message"
        ],
        description: "Class applied to the body View"
    },
    MessageContent: {
        className: (0, _ui.ComponentClassName).MessageContent,
        components: [
            "Message"
        ],
        description: "Class applied to the wrappar around heading and children of the Message"
    },
    MessageDismiss: {
        className: (0, _ui.ComponentClassName).MessageDismiss,
        components: [
            "Message"
        ],
        description: "Class applied to the close Button"
    },
    Pagination: {
        className: (0, _ui.ComponentClassName).Pagination,
        components: [
            "Pagination"
        ],
        description: "Top level element that wraps the Pagination primitive"
    },
    PaginationItemButton: {
        className: (0, _ui.ComponentClassName).PaginationItemButton,
        components: [
            "Pagination"
        ],
        description: "Class applied to the pagination buttons"
    },
    PaginationItemCurrent: {
        className: (0, _ui.ComponentClassName).PaginationItemCurrent,
        components: [
            "Pagination"
        ],
        description: "Class applied to the currently selected pagination button"
    },
    PaginationItemEllipsis: {
        className: (0, _ui.ComponentClassName).PaginationItemEllipsis,
        components: [
            "Pagination"
        ],
        description: "Class applied to the ellipsis within the Pagination primitive"
    },
    PasswordField: {
        className: (0, _ui.ComponentClassName).PasswordField,
        components: [
            "PasswordField"
        ],
        description: "Top level element that wraps the PasswordField primitive"
    },
    PhoneNumberField: {
        className: (0, _ui.ComponentClassName).PhoneNumberField,
        components: [
            "PhoneNumberField"
        ],
        description: "Top level element that wraps the PhoneNumberField primitive"
    },
    Placeholder: {
        className: (0, _ui.ComponentClassName).Placeholder,
        components: [
            "Placeholder"
        ],
        description: "Top level element that wraps the Placeholder primitive"
    },
    Radio: {
        className: (0, _ui.ComponentClassName).Radio,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Top level element that wraps the Radio primitive"
    },
    RadioButton: {
        className: (0, _ui.ComponentClassName).RadioButton,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the displayed radio button"
    },
    RadioInput: {
        className: (0, _ui.ComponentClassName).RadioInput,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the visually hidden radio input"
    },
    RadioLabel: {
        className: (0, _ui.ComponentClassName).RadioLabel,
        components: [
            "RadioGroupField",
            "Radio"
        ],
        description: "Class applied to the radio label"
    },
    RadioGroupField: {
        className: (0, _ui.ComponentClassName).RadioGroupField,
        components: [
            "RadioGroupField"
        ],
        description: "Top level element that wraps the RadioGroupField primitive"
    },
    RadioGroup: {
        className: (0, _ui.ComponentClassName).RadioGroup,
        components: [
            "RadioGroupField"
        ],
        description: "Class applied to the radio group wrapper"
    },
    Rating: {
        className: (0, _ui.ComponentClassName).Rating,
        components: [
            "Rating"
        ],
        description: "Top level element that wraps the Rating primitive"
    },
    ScrollView: {
        className: (0, _ui.ComponentClassName).ScrollView,
        components: [
            "ScrollView"
        ],
        description: "Top level element that wraps the ScrollView primitive"
    },
    SearchField: {
        className: (0, _ui.ComponentClassName).SearchField,
        components: [
            "SearchField"
        ],
        description: "Top level element that wraps the SearchField primitive"
    },
    SearchFieldClear: {
        className: (0, _ui.ComponentClassName).SearchFieldClear,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search field clear button"
    },
    SearchFieldSearch: {
        className: (0, _ui.ComponentClassName).SearchFieldSearch,
        components: [
            "SearchField"
        ],
        description: "Class applied to the search button"
    },
    Select: {
        className: (0, _ui.ComponentClassName).Select,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select element"
    },
    SelectField: {
        className: (0, _ui.ComponentClassName).SelectField,
        components: [
            "SelectField"
        ],
        description: "Top level element that wraps the SelectField primitive"
    },
    SelectWrapper: {
        className: (0, _ui.ComponentClassName).SelectWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select wrapper"
    },
    SelectIconWrapper: {
        className: (0, _ui.ComponentClassName).SelectIconWrapper,
        components: [
            "Select",
            "SelectField"
        ],
        description: "Class applied to the select icon wrapper"
    },
    SliderField: {
        className: (0, _ui.ComponentClassName).SliderField,
        components: [
            "SliderField"
        ],
        description: "Top level element that wraps the SliderField primitive"
    },
    SliderFieldGroup: {
        className: (0, _ui.ComponentClassName).SliderFieldGroup,
        components: [
            "SliderField"
        ],
        description: "Class applied to the element that wraps the slider root"
    },
    SliderFieldLabel: {
        className: (0, _ui.ComponentClassName).SliderFieldLabel,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider label"
    },
    SliderFieldRange: {
        className: (0, _ui.ComponentClassName).SliderFieldRange,
        components: [
            "SliderField"
        ],
        description: "Class applied to the filled in portion of the slider track"
    },
    SliderFieldRoot: {
        className: (0, _ui.ComponentClassName).SliderFieldRoot,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider root which wraps the track and thumb"
    },
    SliderFieldThumb: {
        className: (0, _ui.ComponentClassName).SliderFieldThumb,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider thumb"
    },
    SliderFieldTrack: {
        className: (0, _ui.ComponentClassName).SliderFieldTrack,
        components: [
            "SliderField"
        ],
        description: "Class applied to the slider track"
    },
    StepperField: {
        className: (0, _ui.ComponentClassName).StepperField,
        components: [
            "StepperField"
        ],
        description: "Top level element that wraps the StepperField primitive"
    },
    StepperFieldButtonDecrease: {
        className: (0, _ui.ComponentClassName).StepperFieldButtonDecrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the decrease button"
    },
    StepperFieldButtonIncrease: {
        className: (0, _ui.ComponentClassName).StepperFieldButtonIncrease,
        components: [
            "StepperField"
        ],
        description: "Class applied to the increase button"
    },
    StepperFieldInput: {
        className: (0, _ui.ComponentClassName).StepperFieldInput,
        components: [
            "StepperField"
        ],
        description: "Class applied to the StepperField input"
    },
    StorageImage: {
        className: (0, _ui.ComponentClassName).StorageImage,
        components: [
            "StorageImage"
        ],
        description: "Class applied to the img tag"
    },
    StorageManager: {
        className: (0, _ui.ComponentClassName).StorageManager,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZone: {
        className: (0, _ui.ComponentClassName).StorageManagerDropZone,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZoneIcon: {
        className: (0, _ui.ComponentClassName).StorageManagerDropZoneIcon,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerDropZoneText: {
        className: (0, _ui.ComponentClassName).StorageManagerDropZoneText,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFilePicker: {
        className: (0, _ui.ComponentClassName).StorageManagerFilePicker,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFile: {
        className: (0, _ui.ComponentClassName).StorageManagerFile,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileWrapper: {
        className: (0, _ui.ComponentClassName).StorageManagerFileWrapper,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileList: {
        className: (0, _ui.ComponentClassName).StorageManagerFileList,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileName: {
        className: (0, _ui.ComponentClassName).StorageManagerFileName,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerLoader: {
        className: (0, _ui.ComponentClassName).StorageManagerLoader,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileSize: {
        className: (0, _ui.ComponentClassName).StorageManagerFileSize,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileInfo: {
        className: (0, _ui.ComponentClassName).StorageManagerFileInfo,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileImage: {
        className: (0, _ui.ComponentClassName).StorageManagerFileImage,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileMain: {
        className: (0, _ui.ComponentClassName).StorageManagerFileMain,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerFileStatus: {
        className: (0, _ui.ComponentClassName).StorageManagerFileStatus,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewer: {
        className: (0, _ui.ComponentClassName).StorageManagerPreviewer,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerText: {
        className: (0, _ui.ComponentClassName).StorageManagerPreviewerText,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerActions: {
        className: (0, _ui.ComponentClassName).StorageManagerPreviewerActions,
        components: [
            "StorageManager"
        ]
    },
    StorageManagerPreviewerFooter: {
        className: (0, _ui.ComponentClassName).StorageManagerPreviewerFooter,
        components: [
            "StorageManager"
        ]
    },
    SwitchField: {
        className: (0, _ui.ComponentClassName).SwitchField,
        components: [
            "SwitchField"
        ],
        description: "Top level element that wraps the SwitchField primitive"
    },
    SwitchLabel: {
        className: (0, _ui.ComponentClassName).SwitchLabel,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField label text"
    },
    SwitchThumb: {
        className: (0, _ui.ComponentClassName).SwitchThumb,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField thumb"
    },
    SwitchTrack: {
        className: (0, _ui.ComponentClassName).SwitchTrack,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the SwitchField track"
    },
    SwitchWrapper: {
        className: (0, _ui.ComponentClassName).SwitchWrapper,
        components: [
            "SwitchField"
        ],
        description: "Class applied to the label element that wraps the SwitchField label and track"
    },
    Table: {
        className: (0, _ui.ComponentClassName).Table,
        components: [
            "Table"
        ],
        description: "Top level element that wraps the Table primitive"
    },
    TableCaption: {
        className: (0, _ui.ComponentClassName).TableCaption,
        components: [
            "Table"
        ],
        description: "Class applied to the content provided as the caption prop"
    },
    TableBody: {
        className: (0, _ui.ComponentClassName).TableBody,
        components: [
            "Table"
        ],
        description: "Class applied to TableBody component"
    },
    TableTd: {
        className: (0, _ui.ComponentClassName).TableTd,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell component rendered as a <td> element (<TableCell as="td" />)'
    },
    TableTh: {
        className: (0, _ui.ComponentClassName).TableTh,
        components: [
            "Table"
        ],
        description: 'Class applied to TableCell comopnent rendered as a <th> element (<TableCell as="th" />)'
    },
    TableFoot: {
        className: (0, _ui.ComponentClassName).TableFoot,
        components: [
            "Table"
        ],
        description: "Class applied to TableFoot component"
    },
    TableHead: {
        className: (0, _ui.ComponentClassName).TableHead,
        components: [
            "Table"
        ],
        description: "Class applied to TableHead component"
    },
    TableRow: {
        className: (0, _ui.ComponentClassName).TableRow,
        components: [
            "Table"
        ],
        description: "Class applied to TableRow component"
    },
    Tabs: {
        className: (0, _ui.ComponentClassName).Tabs,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the Tabs primitive"
    },
    TabItems: {
        className: (0, _ui.ComponentClassName).TabItems,
        components: [
            "Tabs"
        ],
        description: "Top level element that wraps the TabItem primitive"
    },
    Text: {
        className: (0, _ui.ComponentClassName).Text,
        components: [
            "Text"
        ],
        description: "Top level element that wraps the Text primitive"
    },
    Textarea: {
        className: (0, _ui.ComponentClassName).Textarea,
        components: [
            "TextAreaField"
        ],
        description: "Class applied to the text area"
    },
    TextAreaField: {
        className: (0, _ui.ComponentClassName).TextAreaField,
        components: [
            "TextAreaField"
        ],
        description: "Top level element that wraps the TextAreaField primitive"
    },
    TextField: {
        className: (0, _ui.ComponentClassName).TextField,
        components: [
            "TextField"
        ],
        description: "Top level element that wraps the TextField primitive"
    },
    ToggleButton: {
        className: (0, _ui.ComponentClassName).ToggleButton,
        components: [
            "ToggleButton"
        ],
        description: "Top level element that wraps the ToggleButton primitive"
    },
    ToggleButtonGroup: {
        className: (0, _ui.ComponentClassName).ToggleButtonGroup,
        components: [
            "ToggleButton",
            "ToggleButtonGroup"
        ],
        description: "Top level element that wraps the ToggleButtonGroup primitive"
    },
    VisuallyHidden: {
        className: (0, _ui.ComponentClassName).VisuallyHidden,
        components: [
            "VisuallyHidden"
        ],
        description: "Top level element that wraps the VisuallyHidden primitive"
    }
}, t = {
    Alert: a.Alert.className,
    AlertIcon: a.AlertIcon.className,
    AlertHeading: a.AlertHeading.className,
    AlertBody: a.AlertBody.className,
    AlertDismiss: a.AlertDismiss.className,
    Autocomplete: a.Autocomplete.className,
    AutocompleteMenu: a.AutocompleteMenu.className,
    AutocompleteMenuEmpty: a.AutocompleteMenuEmpty.className,
    AutocompleteMenuFooter: a.AutocompleteMenuFooter.className,
    AutocompleteMenuHeader: a.AutocompleteMenuHeader.className,
    AutocompleteMenuLoading: a.AutocompleteMenuLoading.className,
    AutocompleteMenuOption: a.AutocompleteMenuOption.className,
    AutocompleteMenuOptions: a.AutocompleteMenuOptions.className,
    Badge: a.Badge.className,
    Breadcrumbs: a.Breadcrumbs.className,
    BreadcrumbsItem: a.BreadcrumbsItem.className,
    BreadcrumbsLink: a.BreadcrumbsLink.className,
    BreadcrumbsList: a.BreadcrumbsList.className,
    BreadcrumbsSeparator: a.BreadcrumbsSeparator.className,
    Button: a.Button.className,
    ButtonGroup: a.ButtonGroup.className,
    ButtonLoaderWrapper: a.ButtonLoaderWrapper.className,
    Card: a.Card.className,
    Checkbox: a.Checkbox.className,
    CheckboxButton: a.CheckboxButton.className,
    CheckboxIcon: a.CheckboxIcon.className,
    CheckboxInput: a.CheckboxInput.className,
    CheckboxLabel: a.CheckboxLabel.className,
    CheckboxField: a.CheckboxField.className,
    Collection: a.Collection.className,
    CollectionItems: a.CollectionItems.className,
    CollectionSearch: a.CollectionSearch.className,
    CollectionPagination: a.CollectionPagination.className,
    CountryCodeSelect: a.CountryCodeSelect.className,
    DialCodeSelect: a.DialCodeSelect.className,
    Divider: a.Divider.className,
    DividerLabel: a.DividerLabel.className,
    DropZone: a.DropZone.className,
    Expander: a.Expander.className,
    ExpanderContent: a.ExpanderContent.className,
    ExpanderContentText: a.ExpanderContentText.className,
    ExpanderHeader: a.ExpanderHeader.className,
    ExpanderIcon: a.ExpanderIcon.className,
    ExpanderItem: a.ExpanderItem.className,
    ExpanderTrigger: a.ExpanderTrigger.className,
    Field: a.Field.className,
    FieldDescription: a.FieldDescription.className,
    FieldErrorMessage: a.FieldErrorMessage.className,
    FieldGroup: a.FieldGroup.className,
    FieldGroupControl: a.FieldGroupControl.className,
    FieldGroupOuterEnd: a.FieldGroupOuterEnd.className,
    FieldGroupOuterStart: a.FieldGroupOuterStart.className,
    FieldGroupInnerEnd: a.FieldGroupInnerEnd.className,
    FieldGroupInnerStart: a.FieldGroupInnerStart.className,
    FieldGroupIcon: a.FieldGroupIcon.className,
    FieldGroupIconButton: a.FieldGroupIconButton.className,
    FieldGroupHasInnerEnd: a.FieldGroupHasInnerEnd.className,
    FieldGroupHasInnerStart: a.FieldGroupHasInnerStart.className,
    FieldShowPassword: a.FieldShowPassword.className,
    FieldGroupFieldWrapper: a.FieldGroupFieldWrapper.className,
    Fieldset: a.Fieldset.className,
    FieldsetLegend: a.FieldsetLegend.className,
    FileUploaderDropZone: a.FileUploaderDropZone.className,
    FileUploaderDropZoneIcon: a.FileUploaderDropZoneIcon.className,
    FileUploaderDropZoneText: a.FileUploaderDropZoneText.className,
    FileUploaderDropZoneButton: a.FileUploaderDropZoneButton.className,
    FileUploaderFile: a.FileUploaderFile.className,
    FileUploaderFileWrapper: a.FileUploaderFileWrapper.className,
    FileUploaderFileName: a.FileUploaderFileName.className,
    FileUploaderLoader: a.FileUploaderLoader.className,
    FileUploaderFileSize: a.FileUploaderFileSize.className,
    FileUploaderFileInfo: a.FileUploaderFileInfo.className,
    FileUploaderFileImage: a.FileUploaderFileImage.className,
    FileUploaderFileMain: a.FileUploaderFileMain.className,
    FileUploaderFileStatus: a.FileUploaderFileStatus.className,
    FileUploaderPreviewer: a.FileUploaderPreviewer.className,
    FileUploaderPreviewerText: a.FileUploaderPreviewerText.className,
    FileUploaderPreviewerBody: a.FileUploaderPreviewerBody.className,
    FileUploaderPreviewerFooter: a.FileUploaderPreviewerFooter.className,
    FileUploaderPreviewerFooterActions: a.FileUploaderPreviewerFooterActions.className,
    Flex: a.Flex.className,
    Grid: a.Grid.className,
    Heading: a.Heading.className,
    HighlightMatch: a.HighlightMatch.className,
    HighlightMatchHighlighted: a.HighlightMatchHighlighted.className,
    Icon: a.Icon.className,
    Image: a.Image.className,
    Input: a.Input.className,
    Label: a.Label.className,
    Link: a.Link.className,
    Loader: a.Loader.className,
    LoaderDeterminate: a.LoaderDeterminate.className,
    LoaderPercentageText: a.LoaderPercentageText.className,
    MenuContent: a.MenuContent.className,
    MenuContentWrapper: a.MenuContentWrapper.className,
    MenuItem: a.MenuItem.className,
    MenuTrigger: a.MenuTrigger.className,
    Message: a.Message.className,
    MessageIcon: a.MessageIcon.className,
    MessageHeading: a.MessageHeading.className,
    MessageBody: a.MessageBody.className,
    MessageContent: a.MessageContent.className,
    MessageDismiss: a.MessageDismiss.className,
    Pagination: a.Pagination.className,
    PaginationItemButton: a.PaginationItemButton.className,
    PaginationItemCurrent: a.PaginationItemCurrent.className,
    PaginationItemEllipsis: a.PaginationItemEllipsis.className,
    PasswordField: a.PasswordField.className,
    PhoneNumberField: a.PhoneNumberField.className,
    Placeholder: a.Placeholder.className,
    Radio: a.Radio.className,
    RadioButton: a.RadioButton.className,
    RadioInput: a.RadioInput.className,
    RadioLabel: a.RadioLabel.className,
    RadioGroupField: a.RadioGroupField.className,
    RadioGroup: a.RadioGroup.className,
    Rating: a.Rating.className,
    ScrollView: a.ScrollView.className,
    SearchField: a.SearchField.className,
    SearchFieldClear: a.SearchFieldClear.className,
    SearchFieldSearch: a.SearchFieldSearch.className,
    Select: a.Select.className,
    SelectField: a.SelectField.className,
    SelectWrapper: a.SelectWrapper.className,
    SelectIconWrapper: a.SelectIconWrapper.className,
    SliderField: a.SliderField.className,
    SliderFieldGroup: a.SliderFieldGroup.className,
    SliderFieldLabel: a.SliderFieldLabel.className,
    SliderFieldRange: a.SliderFieldRange.className,
    SliderFieldRoot: a.SliderFieldRoot.className,
    SliderFieldThumb: a.SliderFieldThumb.className,
    SliderFieldTrack: a.SliderFieldTrack.className,
    StepperField: a.StepperField.className,
    StepperFieldButtonDecrease: a.StepperFieldButtonDecrease.className,
    StepperFieldButtonIncrease: a.StepperFieldButtonIncrease.className,
    StepperFieldInput: a.StepperFieldInput.className,
    StorageImage: a.StorageImage.className,
    StorageManager: a.StorageManager.className,
    StorageManagerDropZone: a.StorageManagerDropZone.className,
    StorageManagerDropZoneIcon: a.StorageManagerDropZoneIcon.className,
    StorageManagerDropZoneText: a.StorageManagerDropZoneText.className,
    StorageManagerFilePicker: a.StorageManagerFilePicker.className,
    StorageManagerFile: a.StorageManagerFile.className,
    StorageManagerFileWrapper: a.StorageManagerFileWrapper.className,
    StorageManagerFileList: a.StorageManagerFileList.className,
    StorageManagerFileName: a.StorageManagerFileName.className,
    StorageManagerLoader: a.StorageManagerLoader.className,
    StorageManagerFileSize: a.StorageManagerFileSize.className,
    StorageManagerFileInfo: a.StorageManagerFileInfo.className,
    StorageManagerFileImage: a.StorageManagerFileImage.className,
    StorageManagerFileMain: a.StorageManagerFileMain.className,
    StorageManagerFileStatus: a.StorageManagerFileStatus.className,
    StorageManagerPreviewer: a.StorageManagerPreviewer.className,
    StorageManagerPreviewerText: a.StorageManagerPreviewerText.className,
    StorageManagerPreviewerActions: a.StorageManagerPreviewerActions.className,
    StorageManagerPreviewerFooter: a.StorageManagerPreviewerFooter.className,
    SwitchField: a.SwitchField.className,
    SwitchLabel: a.SwitchLabel.className,
    SwitchThumb: a.SwitchThumb.className,
    SwitchTrack: a.SwitchTrack.className,
    SwitchWrapper: a.SwitchWrapper.className,
    Table: a.Table.className,
    TableCaption: a.TableCaption.className,
    TableBody: a.TableBody.className,
    TableTd: a.TableTd.className,
    TableTh: a.TableTh.className,
    TableFoot: a.TableFoot.className,
    TableHead: a.TableHead.className,
    TableRow: a.TableRow.className,
    Tabs: a.Tabs.className,
    TabItems: a.TabItems.className,
    Text: a.Text.className,
    Textarea: a.Textarea.className,
    TextAreaField: a.TextAreaField.className,
    TextField: a.TextField.className,
    ToggleButton: a.ToggleButton.className,
    ToggleButtonGroup: a.ToggleButtonGroup.className,
    VisuallyHidden: a.VisuallyHidden.className
}, o = {
    Alert: {
        dismissButtonLabel: "Dismiss alert"
    },
    Autocomplete: {
        emptyText: "No options found",
        loadingText: "Loading options..."
    },
    Collection: {
        searchButtonLabel: "Search",
        searchNoResultsFound: "No results found"
    },
    Fields: {
        clearButtonLabel: "Clear input"
    },
    Message: {
        dismissLabel: "Dismiss message"
    },
    PaginationItem: {
        currentPageLabel: "Page",
        nextLabel: "Go to next page",
        pageLabel: "Go to page",
        previousLabel: "Go to previous page"
    },
    PhoneNumberField: {
        countryCodeLabel: "Country code"
    },
    SearchField: {
        searchButtonLabel: "Search"
    },
    PasswordField: {
        passwordIsHidden: "Password is hidden",
        passwordIsShown: "Password is shown",
        showPassword: "Show password"
    },
    StepperField: {
        increaseButtonLabel: "Increase to",
        decreaseButtonLabel: "Decrease to"
    }
}, l = {
    backgroundColor: "colors",
    borderColor: "colors",
    borderWidth: "borderWidths",
    color: "colors",
    borderRadius: "radii",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    fontFamily: "fonts",
    lineHeight: "lineHeights",
    opacity: "opacities",
    boxShadow: "shadows",
    transform: "transforms",
    left: "space",
    right: "space",
    top: "space",
    bottom: "space",
    height: "space",
    width: "space",
    letterSpacing: "space",
    margin: "space",
    marginBlock: "space",
    marginBlockEnd: "space",
    marginBlockStart: "space",
    marginInline: "space",
    marginInlineEnd: "space",
    marginInlineStart: "space",
    marginLeft: "space",
    marginRight: "space",
    marginTop: "space",
    marginBottom: "space",
    maxHeight: "space",
    maxWidth: "space",
    minHeight: "space",
    minWidth: "space",
    padding: "space",
    paddingBlock: "space",
    paddingBlockEnd: "space",
    paddingBlockStart: "space",
    paddingInline: "space",
    paddingInlineEnd: "space",
    paddingInlineStart: "space",
    paddingLeft: "space",
    paddingRight: "space",
    paddingTop: "space",
    paddingBottom: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space"
}, s = "Escape", i = "Enter", r = "ArrowUp", n = "ArrowDown";

},{"@aws-amplify/ui":"2NgwQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aUc30":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBreakpoint", ()=>o);
var _react = require("react");
var _getMediaQueriesMjs = require("./getMediaQueries.mjs");
const n = "undefined" == typeof window ? _react.useEffect : _react.useLayoutEffect, o = ({ breakpoints: o, defaultBreakpoint: a })=>{
    const r = "undefined" != typeof window && void 0 !== window.matchMedia ? window.matchMedia : null, i = _react.useMemo(()=>(0, _getMediaQueriesMjs.getMediaQueries)({
            breakpoints: o
        }), [
        o
    ]), [s, u] = _react.useState(a), c = _react.useCallback((e, t)=>{
        e && u(t);
    }, [
        u
    ]);
    return n(()=>{
        if (!r) return;
        const e = i.map(({ query: e, breakpoint: t })=>{
            const n = r(e);
            c(n.matches, t);
            const o = (e)=>{
                e.matches && u(t);
            };
            return n.addEventListener("change", o), ()=>n.removeEventListener("change", o);
        });
        return ()=>{
            e.forEach((e)=>e());
        };
    }, [
        o,
        u,
        r,
        i
    ]), _react.useDebugValue(s, (e)=>e), s;
};

},{"react":"gVheC","./getMediaQueries.mjs":"7YMr2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7YMr2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMediaQueries", ()=>n);
var _utilsMjs = require("../utils.mjs");
const n = ({ breakpoints: n })=>{
    const r = (0, _utilsMjs.objectKeys)(n).sort((t, r)=>n[r] - n[t]);
    return r.map((t, i)=>{
        let o = "";
        const m = n[t], e = r[i - 1], p = e ? n[e] - 1 : null;
        return m >= 0 && (o = `(min-width: ${m}px)`), null !== p && (o && (o += " and "), o += `(max-width: ${p}px)`), {
            breakpoint: t,
            query: o,
            maxWidth: p,
            minWidth: m
        };
    });
};

},{"../utils.mjs":"aPy8a","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5NyxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleValue", ()=>i);
var _ui = require("@aws-amplify/ui");
var _utilsMjs = require("./utils.mjs");
const i = ({ value: i, propKey: m, tokens: p })=>(0, _ui.isDesignToken)(i) ? i.toString() : (0, _ui.isString)(i) ? (0, _ui.isString)(m) ? (0, _utilsMjs.getCSSVariableIfValueIsThemeKey)(m, i, p) : i : null;

},{"@aws-amplify/ui":"2NgwQ","./utils.mjs":"aPy8a","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXRp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Router", ()=>l);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _confirmSignUpMjs = require("../ConfirmSignUp/ConfirmSignUp.mjs");
var _forceNewPasswordMjs = require("../ForceNewPassword/ForceNewPassword.mjs");
var _setupTOTPMjs = require("../SetupTOTP/SetupTOTP.mjs");
var _ui = require("@aws-amplify/ui");
var _textFieldMjs = require("../../../primitives/TextField/TextField.mjs");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _alertMjs = require("../../../primitives/Alert/Alert.mjs");
var _signInSignUpTabsMjs = require("../shared/SignInSignUpTabs.mjs");
var _confirmVerifyUserMjs = require("../VerifyUser/ConfirmVerifyUser.mjs");
var _verifyUserMjs = require("../VerifyUser/VerifyUser.mjs");
var _confirmSignInMjs = require("../ConfirmSignIn/ConfirmSignIn.mjs");
var _confirmResetPasswordMjs = require("../ResetPassword/ConfirmResetPassword.mjs");
var _resetPasswordMjs = require("../ResetPassword/ResetPassword.mjs");
var _utilsMjs = require("../utils.mjs");
function d() {
    return null;
}
function l({ className: l, hideSignUp: w, variation: j }) {
    const { route: U } = (0, _uiReactCore.useAuthenticator)(({ route: r })=>[
            r
        ]), g = (0, _react.useMemo)(()=>((r)=>{
            switch(r){
                case "authenticated":
                case "idle":
                case "setup":
                case "transition":
                    return d;
                case "confirmSignUp":
                    return 0, _confirmSignUpMjs.ConfirmSignUp;
                case "confirmSignIn":
                    return 0, _confirmSignInMjs.ConfirmSignIn;
                case "setupTOTP":
                    return 0, _setupTOTPMjs.SetupTOTP;
                case "signIn":
                case "signUp":
                    return 0, _signInSignUpTabsMjs.SignInSignUpTabs;
                case "forceNewPassword":
                    return 0, _forceNewPasswordMjs.ForceNewPassword;
                case "resetPassword":
                    return 0, _resetPasswordMjs.ResetPassword;
                case "confirmResetPassword":
                    return 0, _confirmResetPasswordMjs.ConfirmResetPassword;
                case "verifyUser":
                    return 0, _verifyUserMjs.VerifyUser;
                case "confirmVerifyUser":
                    return 0, _confirmVerifyUserMjs.ConfirmVerifyUser;
                default:
                    return console.warn(`Unhandled Authenticator route - please open an issue: ${r}`), d;
            }
        })(U), [
        U
    ]);
    return (0, _reactDefault.default).createElement(g, {
        className: l,
        hideSignUp: (0, _utilsMjs.isSignInOrSignUpRoute)(U) ? w : void 0,
        variation: j
    });
}

},{"react":"gVheC","@aws-amplify/ui-react-core":"cZFwB","../ConfirmSignUp/ConfirmSignUp.mjs":"WY5no","../ForceNewPassword/ForceNewPassword.mjs":"wtNsH","../SetupTOTP/SetupTOTP.mjs":"kz4YC","@aws-amplify/ui":"2NgwQ","../../../primitives/TextField/TextField.mjs":"7qkLa","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Alert/Alert.mjs":"bl1Jc","../shared/SignInSignUpTabs.mjs":"bGT5j","../VerifyUser/ConfirmVerifyUser.mjs":"5ADLu","../VerifyUser/VerifyUser.mjs":"1Cf4r","../ConfirmSignIn/ConfirmSignIn.mjs":"905Pq","../ResetPassword/ConfirmResetPassword.mjs":"4YMpS","../ResetPassword/ResetPassword.mjs":"klVJ1","../utils.mjs":"3KlLE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"WY5no":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmSignUp", ()=>h);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _textMjs = require("../../../primitives/Text/Text.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getDeliveryMessageText: u, getDeliveryMethodText: p, getConfirmingText: f, getConfirmText: g, getResendCodeText: C } = (0, _ui.authenticatorTextUtil);
function h({ className: t, variation: i }) {
    const { isPending: p, resendCode: v, codeDeliveryDetails: y } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending,
            e.resendCode,
            e.codeDeliveryDetails
        ]), { handleChange: E, handleSubmit: D } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ConfirmSignUp: { Header: x = h.Header, Footer: j = h.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: i
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: E,
        onSubmit: D
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: p
    }, (0, _reactDefault.default).createElement(x, null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _textMjs.Text), {
        className: "amplify-authenticator__subtitle"
    }, u(y)), (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        variation: "primary",
        isDisabled: p,
        type: "submit",
        loadingText: f(),
        isLoading: p,
        fontWeight: "normal"
    }, g()), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        onClick: v,
        type: "button",
        fontWeight: "normal"
    }, C())), (0, _reactDefault.default).createElement(j, null))));
}
h.Header = ()=>{
    const { codeDeliveryDetails: t } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.codeDeliveryDetails
        ]);
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 4
    }, p(t));
}, h.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","../../../primitives/Text/Text.mjs":"bYgXO","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4aRAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>u);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _useFieldsetMjs = require("../Fieldset/useFieldset.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _loaderMjs = require("../Loader/Loader.mjs");
var _viewMjs = require("../View/View.mjs");
const m = [
    "link",
    "primary",
    void 0
], u = _react.forwardRef((u, p)=>{
    var c, { className: f, children: b, colorTheme: h, isFullWidth: B = !1, isDisabled: F, isLoading: g, loadingText: v = "", size: j, type: w = "button", variation: y } = u, x = (0, _tslib.__rest)(u, [
        "className",
        "children",
        "colorTheme",
        "isFullWidth",
        "isDisabled",
        "isLoading",
        "loadingText",
        "size",
        "type",
        "variation"
    ]);
    const L = m.includes(y) && h ? `${null != y ? y : "outlined"}--${h}` : void 0, { isFieldsetDisabled: N } = (0, _useFieldsetMjs.useFieldset)(), z = N || (null !== (c = null != F ? F : g) && void 0 !== c ? c : x.disabled), D = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Button, (0, _constantsMjs.ComponentClassNames).FieldGroupControl, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Button, y), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Button, L), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Button, j), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Button, "disabled", z), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Button, "loading", g), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Button, "fullwidth", B), f);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        ref: p,
        as: "button",
        className: D,
        "data-fullwidth": B,
        "data-loading": g,
        "data-size": j,
        "data-variation": y,
        isDisabled: z,
        type: w
    }, x), g ? _react.createElement((0, _flexMjs.Flex), {
        as: "span",
        className: (0, _constantsMjs.ComponentClassNames).ButtonLoaderWrapper
    }, _react.createElement((0, _loaderMjs.Loader), {
        size: j
    }), v || null) : b);
});
u.displayName = "Button";

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Fieldset/useFieldset.mjs":"e0bLb","../Flex/Flex.mjs":"49y3m","../Loader/Loader.mjs":"Y2jKX","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6P5cq":[function(require,module,exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"e0bLb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldsetContext", ()=>t);
parcelHelpers.export(exports, "useFieldset", ()=>o);
var _react = require("react");
const t = _react.createContext({
    isFieldsetDisabled: !1
}), o = ()=>_react.useContext(t);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49y3m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flex", ()=>t);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const t = _react.forwardRef((t, o)=>{
    var { className: i, children: c } = t, l = (0, _tslib.__rest)(t, [
        "className",
        "children"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Flex, i),
        ref: o
    }, l), c);
});
t.displayName = "Flex";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Y2jKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CIRCULAR_EMPTY", ()=>o);
parcelHelpers.export(exports, "CIRCULAR_FILLED", ()=>m);
parcelHelpers.export(exports, "CIRCULAR_STROKE_WIDTH", ()=>c);
parcelHelpers.export(exports, "CIRCUMFERENCE", ()=>y);
parcelHelpers.export(exports, "LINEAR_EMPTY", ()=>s);
parcelHelpers.export(exports, "LINEAR_FILLED", ()=>n);
parcelHelpers.export(exports, "Loader", ()=>p);
parcelHelpers.export(exports, "RADIUS", ()=>d);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const s = "linear-empty", n = "linear-filled", o = "circular-empty", m = "circular-filled", c = 8, d = 42, y = 84 * Math.PI, p = _react.forwardRef((c, d)=>{
    var { className: p, filledColor: f, emptyColor: x, size: g, variation: u, isDeterminate: v = !1, isPercentageTextHidden: E = !1, percentage: h = 0 } = c, k = (0, _tslib.__rest)(c, [
        "className",
        "filledColor",
        "emptyColor",
        "size",
        "variation",
        "isDeterminate",
        "isPercentageTextHidden",
        "percentage"
    ]);
    h = Math.min(h, 100);
    const L = `${h = Math.max(h, 0)}%`, N = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Loader, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Loader, g), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Loader, u), v ? (0, _constantsMjs.ComponentClassNames).LoaderDeterminate : null, p), D = _react.createElement("g", null, _react.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(x)
        },
        "data-testid": s
    }), _react.createElement("line", {
        x1: "0",
        x2: v ? L : "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: v && 0 === h ? "none" : f ? String(f) : void 0
        },
        "data-testid": n
    }), v ? _react.createElement("text", {
        "aria-live": "polite",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).LoaderPercentageText, E ? (0, _constantsMjs.ComponentClassNames).VisuallyHidden : null),
        x: `${-1 + h}%`,
        y: "200%"
    }, L) : null), P = _react.createElement("g", null, _react.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(x)
        },
        "data-testid": o
    }), _react.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: "42%",
        strokeWidth: "8%",
        style: {
            stroke: String(f),
            strokeDasharray: v ? `${y}% ${y}%` : void 0,
            strokeDashoffset: v ? y - y * h / 100 + "%" : void 0
        },
        "data-testid": m
    }), v ? _react.createElement("text", {
        "aria-live": "polite",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).LoaderPercentageText, E ? (0, _constantsMjs.ComponentClassNames).VisuallyHidden : null),
        x: "130%",
        y: "80%"
    }, L) : null);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "svg",
        className: N,
        "data-size": g,
        "data-variation": u,
        ref: d,
        role: "img"
    }, k), "linear" === u ? D : P);
});
p.displayName = "Loader";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bQHrE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const n = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
}, o = _react.forwardRef((o, c)=>{
    var { className: l, children: d, isTruncated: f, level: h = 6 } = o, p = (0, _tslib.__rest)(o, [
        "className",
        "children",
        "isTruncated",
        "level"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: n[h],
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Heading, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Heading, h), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Heading, "truncated", f), l),
        ref: c
    }, p), d);
});
o.displayName = "Heading";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bYgXO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const o = _react.forwardRef((o, n)=>{
    var { as: c = "p", className: d, children: f, isTruncated: l, variation: p } = o, u = (0, _tslib.__rest)(o, [
        "as",
        "className",
        "children",
        "isTruncated",
        "variation"
    ]);
    const T = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Text, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Text, p), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Text, "truncated", l), d);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: c,
        className: T,
        "data-truncate": l,
        "data-variation": p,
        ref: n
    }, u), f);
});
o.displayName = "Text";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5gEf2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormHandlers", ()=>a);
var _react = require("react");
var _utilsMjs = require("../../../../helpers/utils.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
function a() {
    const { submitForm: a, updateBlur: m, updateForm: u } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.submitForm,
            e.updateBlur,
            e.updateForm
        ]);
    return {
        handleBlur: (0, _react.useCallback)(({ target: { name: e } })=>{
            m({
                name: e
            });
        }, [
            m
        ]),
        handleChange: (0, _react.useCallback)(({ target: { checked: e, name: t, type: r, value: a } })=>{
            u({
                name: t,
                value: "checkbox" === r && !e ? void 0 : a
            });
        }, [
            u
        ]),
        handleSubmit: (0, _react.useCallback)((e)=>{
            e.preventDefault(), a((0, _utilsMjs.getFormDataFromEvent)(e));
        }, [
            a
        ])
    };
}

},{"react":"gVheC","../../../../helpers/utils.mjs":"erkJf","@aws-amplify/ui-react-core":"cZFwB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"erkJf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getErrorMessage", ()=>t);
parcelHelpers.export(exports, "getFormDataFromEvent", ()=>n);
parcelHelpers.export(exports, "isErrorWithMessage", ()=>r);
parcelHelpers.export(exports, "toErrorWithMessage", ()=>e);
const r = (r)=>"object" == typeof r && null !== r && "message" in r && "string" == typeof r.message, e = (e)=>{
    if (r(e)) return e;
    try {
        return new Error(JSON.stringify(e));
    } catch (r) {
        return new Error(String(e));
    }
}, t = (r)=>e(r).message, n = (r)=>{
    const e = new FormData(r.target);
    return Object.fromEntries(e);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGudN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoteErrorMessage", ()=>m);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _alertMjs = require("../../../primitives/Alert/Alert.mjs");
const m = ()=>{
    const { error: m } = (0, _uiReactCore.useAuthenticator)((r)=>[
            r.error
        ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, m ? (0, _reactDefault.default).createElement((0, _alertMjs.Alert), {
        variation: "error",
        isDismissible: !0
    }, (0, _ui.translate)(m)) : null);
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@aws-amplify/ui-react-core":"cZFwB","../../../primitives/Alert/Alert.mjs":"bl1Jc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bl1Jc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>p);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _buttonMjs = require("../Button/Button.mjs");
var _alertIconMjs = require("./AlertIcon.mjs");
var _iconMjs = require("../Icon/Icon.mjs");
var _iconsContextMjs = require("../Icon/context/IconsContext.mjs");
var _useIconsMjs = require("../Icon/context/useIcons.mjs");
var _iconCloseMjs = require("../Icon/icons/IconClose.mjs");
const p = _react.forwardRef((p, u)=>{
    var b, { buttonRef: I, children: j, className: h, dismissButtonLabel: v = (0, _constantsMjs.ComponentText).Alert.dismissButtonLabel, hasIcon: A = !0, heading: x, isDismissible: E = !1, onDismiss: N, variation: B } = p, D = (0, _tslib.__rest)(p, [
        "buttonRef",
        "children",
        "className",
        "dismissButtonLabel",
        "hasIcon",
        "heading",
        "isDismissible",
        "onDismiss",
        "variation"
    ]);
    const [g, w] = _react.useState(!1), C = (0, _useIconsMjs.useIcons)("alert"), L = _react.useCallback(()=>{
        w(!g), (0, _ui.isFunction)(N) && N();
    }, [
        w,
        N,
        g
    ]);
    return g ? null : _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Alert, h, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Alert, B)),
        "data-variation": B,
        ref: u,
        role: "alert"
    }, D), A && _react.createElement((0, _alertIconMjs.AlertIcon), {
        variation: B,
        ariaHidden: !0
    }), _react.createElement((0, _viewMjs.View), {
        flex: "1"
    }, x && _react.createElement((0, _viewMjs.View), {
        className: (0, _constantsMjs.ComponentClassNames).AlertHeading
    }, x), _react.createElement((0, _viewMjs.View), {
        className: (0, _constantsMjs.ComponentClassNames).AlertBody
    }, j)), E && _react.createElement((0, _buttonMjs.Button), {
        ariaLabel: v,
        variation: "link",
        className: (0, _constantsMjs.ComponentClassNames).AlertDismiss,
        onClick: L,
        ref: I
    }, null !== (b = null == C ? void 0 : C.close) && void 0 !== b ? b : _react.createElement((0, _iconCloseMjs.IconClose), {
        "aria-hidden": "true"
    })));
});
p.displayName = "Alert";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","../Flex/Flex.mjs":"49y3m","../Button/Button.mjs":"4aRAq","./AlertIcon.mjs":"14ktd","../Icon/Icon.mjs":"a3e7v","../Icon/context/IconsContext.mjs":"enrlS","../Icon/context/useIcons.mjs":"awHCP","../Icon/icons/IconClose.mjs":"61r5C","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"14ktd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertIcon", ()=>s);
var _react = require("react");
var _constantsMjs = require("../shared/constants.mjs");
var _iconMjs = require("../Icon/Icon.mjs");
var _iconsContextMjs = require("../Icon/context/IconsContext.mjs");
var _useIconsMjs = require("../Icon/context/useIcons.mjs");
var _tslib = require("tslib");
var _classnames = require("classnames");
var _viewMjs = require("../View/View.mjs");
var _iconCheckCircleMjs = require("../Icon/icons/IconCheckCircle.mjs");
var _iconErrorMjs = require("../Icon/icons/IconError.mjs");
var _iconInfoMjs = require("../Icon/icons/IconInfo.mjs");
var _iconWarningMjs = require("../Icon/icons/IconWarning.mjs");
const s = ({ variation: s, ariaHidden: a })=>{
    var m, l, d, I;
    const p = (0, _useIconsMjs.useIcons)("alert");
    let u;
    switch(s){
        case "info":
            u = null !== (m = null == p ? void 0 : p.info) && void 0 !== m ? m : _react.createElement((0, _iconInfoMjs.IconInfo), {
                "aria-hidden": a
            });
            break;
        case "error":
            u = null !== (l = null == p ? void 0 : p.error) && void 0 !== l ? l : _react.createElement((0, _iconErrorMjs.IconError), {
                "aria-hidden": a
            });
            break;
        case "warning":
            u = null !== (d = null == p ? void 0 : p.warning) && void 0 !== d ? d : _react.createElement((0, _iconWarningMjs.IconWarning), {
                "aria-hidden": a
            });
            break;
        case "success":
            u = null !== (I = null == p ? void 0 : p.success) && void 0 !== I ? I : _react.createElement((0, _iconCheckCircleMjs.IconCheckCircle), {
                "aria-hidden": a
            });
    }
    return u ? _react.createElement("span", {
        className: (0, _constantsMjs.ComponentClassNames).AlertIcon
    }, u) : null;
};
s.displayName = "AlertIcon";

},{"react":"gVheC","../shared/constants.mjs":"aQd5e","../Icon/Icon.mjs":"a3e7v","../Icon/context/IconsContext.mjs":"enrlS","../Icon/context/useIcons.mjs":"awHCP","tslib":"86BcK","classnames":"6P5cq","../View/View.mjs":"dfO6K","../Icon/icons/IconCheckCircle.mjs":"dWK7t","../Icon/icons/IconError.mjs":"hCHmn","../Icon/icons/IconInfo.mjs":"gdwli","../Icon/icons/IconWarning.mjs":"i5zy1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a3e7v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", ()=>r);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const s = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
}, r = _react.forwardRef((r, n)=>{
    var { className: o, as: h = "svg", fill: l = "currentColor", pathData: c, viewBox: p = s, children: f, paths: d } = r, w = (0, _tslib.__rest)(r, [
        "className",
        "as",
        "fill",
        "pathData",
        "viewBox",
        "children",
        "paths"
    ]);
    const g = p.minX ? p.minX : s.minX, v = p.minY ? p.minY : s.minY, j = p.width ? p.width : s.width, x = p.height ? p.height : s.height;
    let N;
    return f && (N = f), d && (N = d.map((e, a)=>_react.createElement("path", Object.assign({}, e, {
            key: a
        })))), c && (N = _react.createElement("path", {
        d: c,
        fill: l
    })), _react.createElement((0, _viewMjs.View), Object.assign({
        as: h,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, o),
        ref: n,
        viewBox: `${g} ${v} ${j} ${x}`
    }, w), N);
});
r.displayName = "Icon";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"enrlS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsContext", ()=>e);
var _react = require("react");
const e = _react.createContext({});

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"awHCP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIcons", ()=>r);
var _react = require("react");
var _iconsContextMjs = require("./IconsContext.mjs");
function r(r) {
    const n = _react.useContext((0, _iconsContextMjs.IconsContext));
    if (r && n) return n[r];
}

},{"react":"gVheC","./IconsContext.mjs":"enrlS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dWK7t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconCheckCircle", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, i = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, i), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hCHmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconError", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, i = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, i), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdwli":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconInfo", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, i = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, i), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i5zy1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconWarning", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, i = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, i), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"61r5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconClose", ()=>i);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const i = (i)=>{
    const { className: o, size: a } = i, l = (0, _tslib.__rest)(i, [
        "className",
        "size"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: null != a ? a : "1em",
        height: null != a ? a : "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, o)
    }, l), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: a ? {
            width: a,
            height: a
        } : void 0
    }, _react.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Dm78":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormFields", ()=>m);
var _react = require("react");
var _formFieldMjs = require("./FormField.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
function m() {
    const { fields: m } = (0, _uiReactCore.useAuthenticator)(({ route: e })=>[
            e
        ]), o = _react.useRef(m.map((t, m)=>_react.createElement((0, _formFieldMjs.FormField), Object.assign({
            key: m
        }, t)))).current;
    return _react.createElement(_react.Fragment, null, o);
}

},{"react":"gVheC","./FormField.mjs":"5V67T","@aws-amplify/ui-react-core":"cZFwB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5V67T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormField", ()=>d);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _passwordFieldMjs = require("../../../primitives/PasswordField/PasswordField.mjs");
var _phoneNumberFieldMjs = require("../../../primitives/PhoneNumberField/PhoneNumberField.mjs");
var _textFieldMjs = require("../../../primitives/TextField/TextField.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useStableIdMjs = require("../../../primitives/utils/useStableId.mjs");
var _validationErrorsMjs = require("../../shared/ValidationErrors.mjs");
function d(d) {
    var { autocomplete: n, dialCode: p, name: c, type: u } = d, f = (0, _tslib.__rest)(d, [
        "autocomplete",
        "dialCode",
        "name",
        "type"
    ]);
    const { validationErrors: E } = (0, _uiReactCore.useAuthenticator)(({ validationErrors: e })=>[
            e
        ]), b = _react.useMemo(()=>(0, _ui.getErrors)(E[c]), [
        c,
        E
    ]), y = (null == b ? void 0 : b.length) > 0, g = (0, _useStableIdMjs.useStableId)(), v = y ? g : void 0;
    return "tel" === u ? _react.createElement(_react.Fragment, null, _react.createElement((0, _phoneNumberFieldMjs.PhoneNumberField), Object.assign({}, f, {
        name: c,
        defaultDialCode: p,
        dialCodeName: "country_code",
        autoComplete: n,
        hasError: y,
        "aria-describedby": v
    })), _react.createElement((0, _validationErrorsMjs.ValidationErrors), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    })) : "password" === u ? _react.createElement(_react.Fragment, null, _react.createElement((0, _passwordFieldMjs.PasswordField), Object.assign({}, f, {
        name: c,
        autoComplete: n,
        hasError: y,
        "aria-describedby": v
    })), _react.createElement((0, _validationErrorsMjs.ValidationErrors), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    })) : _react.createElement(_react.Fragment, null, _react.createElement((0, _textFieldMjs.TextField), Object.assign({}, f, {
        name: c,
        autoComplete: n,
        hasError: y,
        type: u,
        "aria-describedby": v
    })), _react.createElement((0, _validationErrorsMjs.ValidationErrors), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: b,
        id: g
    }));
}

},{"tslib":"86BcK","react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/PasswordField/PasswordField.mjs":"4ZVLR","../../../primitives/PhoneNumberField/PhoneNumberField.mjs":"jGezh","../../../primitives/TextField/TextField.mjs":"7qkLa","@aws-amplify/ui-react-core":"cZFwB","../../../primitives/utils/useStableId.mjs":"aArLN","../../shared/ValidationErrors.mjs":"ci7ai","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ZVLR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasswordField", ()=>d);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../shared/constants.mjs");
var _showPasswordButtonMjs = require("./ShowPasswordButton.mjs");
var _textFieldMjs = require("../TextField/TextField.mjs");
const d = _react.forwardRef((d, l)=>{
    var { autoComplete: w = "current-password", label: n, className: m, hideShowPassword: i = !1, passwordIsHiddenLabel: p, passwordIsShownLabel: h, showPasswordButtonLabel: b, showPasswordButtonRef: u, size: c, hasError: f } = d, P = (0, _tslib.__rest)(d, [
        "autoComplete",
        "label",
        "className",
        "hideShowPassword",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "showPasswordButtonRef",
        "size",
        "hasError"
    ]);
    const [L, E] = _react.useState("password"), S = _react.useCallback(()=>{
        E("password" === L ? "text" : "password");
    }, [
        E,
        L
    ]);
    return _react.createElement((0, _textFieldMjs.TextField), Object.assign({
        autoComplete: w,
        outerEndComponent: i ? null : _react.createElement((0, _showPasswordButtonMjs.ShowPasswordButton), {
            fieldType: L,
            onClick: S,
            passwordIsHiddenLabel: p,
            passwordIsShownLabel: h,
            ref: u,
            size: c,
            showPasswordButtonLabel: b,
            hasError: f
        }),
        size: c,
        type: L,
        label: n,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).PasswordField, m),
        ref: l,
        hasError: f
    }, P));
});
d.displayName = "PasswordField";

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../shared/constants.mjs":"aQd5e","./ShowPasswordButton.mjs":"4LfF7","../TextField/TextField.mjs":"7qkLa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4LfF7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShowPasswordButton", ()=>f);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _buttonMjs = require("../Button/Button.mjs");
var _visuallyHiddenMjs = require("../VisuallyHidden/VisuallyHidden.mjs");
var _constantsMjs = require("../shared/constants.mjs");
var _iconMjs = require("../Icon/Icon.mjs");
var _iconsContextMjs = require("../Icon/context/IconsContext.mjs");
var _useIconsMjs = require("../Icon/context/useIcons.mjs");
var _viewMjs = require("../View/View.mjs");
var _iconVisibilityOffMjs = require("../Icon/icons/IconVisibilityOff.mjs");
var _iconVisibilityMjs = require("../Icon/icons/IconVisibility.mjs");
var _ui = require("@aws-amplify/ui");
const { passwordIsHidden: w, passwordIsShown: p, showPassword: c } = (0, _constantsMjs.ComponentText).PasswordField, f = _react.forwardRef((t, f)=>{
    var h, u, { fieldType: I, passwordIsHiddenLabel: b = w, passwordIsShownLabel: j = p, showPasswordButtonLabel: y = c, size: v, hasError: L } = t, P = (0, _tslib.__rest)(t, [
        "fieldType",
        "passwordIsHiddenLabel",
        "passwordIsShownLabel",
        "showPasswordButtonLabel",
        "size",
        "hasError"
    ]);
    const E = (0, _useIconsMjs.useIcons)("passwordField"), S = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldShowPassword, (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).FieldShowPassword, "error", L)), V = "password" === I ? null !== (h = null == E ? void 0 : E.visibility) && void 0 !== h ? h : _react.createElement((0, _iconVisibilityMjs.IconVisibility), {
        "aria-hidden": "true"
    }) : null !== (u = null == E ? void 0 : E.visibilityOff) && void 0 !== u ? u : _react.createElement((0, _iconVisibilityOffMjs.IconVisibilityOff), {
        "aria-hidden": "true"
    });
    return _react.createElement((0, _buttonMjs.Button), Object.assign({
        "aria-checked": "password" !== I,
        ariaLabel: y,
        className: S,
        ref: f,
        role: "switch",
        size: v
    }, P), _react.createElement((0, _visuallyHiddenMjs.VisuallyHidden), {
        "aria-live": "polite"
    }, "password" === I ? b : j), V);
});
f.displayName = "ShowPasswordButton";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../Button/Button.mjs":"4aRAq","../VisuallyHidden/VisuallyHidden.mjs":"1nS3d","../shared/constants.mjs":"aQd5e","../Icon/Icon.mjs":"a3e7v","../Icon/context/IconsContext.mjs":"enrlS","../Icon/context/useIcons.mjs":"awHCP","../View/View.mjs":"dfO6K","../Icon/icons/IconVisibilityOff.mjs":"uZsS9","../Icon/icons/IconVisibility.mjs":"j2H9c","@aws-amplify/ui":"2NgwQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nS3d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisuallyHidden", ()=>i);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const i = _react.forwardRef((i, t)=>{
    var { as: o = "span", children: l, className: n } = i, c = (0, _tslib.__rest)(i, [
        "as",
        "children",
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: o,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).VisuallyHidden, n),
        ref: t
    }, c), l);
});
i.displayName = "VisuallyHidden";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"uZsS9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconVisibilityOff", ()=>r);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const r = (r)=>{
    const { className: o } = r, a = (0, _tslib.__rest)(r, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, o)
    }, a), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j2H9c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconVisibility", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, C = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, C), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7qkLa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>u);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _fieldClearButtonMjs = require("../Field/FieldClearButton.mjs");
var _fieldDescriptionMjs = require("../Field/FieldDescription.mjs");
var _fieldErrorMessageMjs = require("../Field/FieldErrorMessage.mjs");
var _fieldMjs = require("../Field/Field.mjs");
var _fieldGroupMjs = require("../FieldGroup/FieldGroup.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _inputMjs = require("../Input/Input.mjs");
var _labelMjs = require("../Label/Label.mjs");
var _splitPrimitivePropsMjs = require("../utils/splitPrimitiveProps.mjs");
var _useStableIdMjs = require("../utils/useStableId.mjs");
const u = _react.forwardRef((u, f)=>{
    const { className: E, descriptiveText: F, errorMessage: b, hasError: j = !1, id: C, innerEndComponent: v, innerStartComponent: S, label: x, labelHidden: y = !1, outerEndComponent: g, outerStartComponent: h, size: I, testId: T, variation: z, inputStyles: H } = u, M = (0, _tslib.__rest)(u, [
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "innerEndComponent",
        "innerStartComponent",
        "label",
        "labelHidden",
        "outerEndComponent",
        "outerStartComponent",
        "size",
        "testId",
        "variation",
        "inputStyles"
    ]), N = (0, _useStableIdMjs.useStableId)(C), P = (0, _useStableIdMjs.useStableId)(), w = F ? P : void 0, { styleProps: G, rest: L } = (0, _splitPrimitivePropsMjs.splitPrimitiveProps)(M);
    return _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Field, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Field, I), (0, _constantsMjs.ComponentClassNames).TextField, E),
        "data-size": I,
        testId: T
    }, G), _react.createElement((0, _labelMjs.Label), {
        htmlFor: N,
        visuallyHidden: y
    }, x), _react.createElement((0, _fieldDescriptionMjs.FieldDescription), {
        id: P,
        labelHidden: y,
        descriptiveText: F
    }), _react.createElement((0, _fieldGroupMjs.FieldGroup), {
        outerStartComponent: h,
        outerEndComponent: g,
        innerStartComponent: S,
        innerEndComponent: v,
        variation: z
    }, _react.createElement((0, _inputMjs.Input), Object.assign({
        "aria-describedby": w,
        hasError: j,
        id: N,
        ref: f,
        size: I,
        variation: z
    }, H, L))), _react.createElement((0, _fieldErrorMessageMjs.FieldErrorMessage), {
        hasError: j,
        errorMessage: b
    }));
});
u.displayName = "TextField";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Field/FieldClearButton.mjs":"hLrLW","../Field/FieldDescription.mjs":"2ewNp","../Field/FieldErrorMessage.mjs":"eFojV","../Field/Field.mjs":"8m82z","../FieldGroup/FieldGroup.mjs":"89jiH","../Flex/Flex.mjs":"49y3m","../Input/Input.mjs":"ab7IK","../Label/Label.mjs":"5r556","../utils/splitPrimitiveProps.mjs":"d2cda","../utils/useStableId.mjs":"aArLN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hLrLW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldClearButton", ()=>m);
var _tslib = require("tslib");
var _react = require("react");
var _fieldGroupIconMjs = require("../FieldGroupIcon/FieldGroupIcon.mjs");
var _fieldGroupIconButtonMjs = require("../FieldGroupIcon/FieldGroupIconButton.mjs");
var _iconMjs = require("../Icon/Icon.mjs");
var _iconsContextMjs = require("../Icon/context/IconsContext.mjs");
var _useIconsMjs = require("../Icon/context/useIcons.mjs");
var _classnames = require("classnames");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
var _iconCloseMjs = require("../Icon/icons/IconClose.mjs");
const s = (0, _constantsMjs.ComponentText).Fields.clearButtonLabel, m = _react.forwardRef((i, m)=>{
    var a, { ariaLabel: l = s, size: c } = i, p = (0, _tslib.__rest)(i, [
        "ariaLabel",
        "size"
    ]);
    const d = (0, _useIconsMjs.useIcons)("field");
    return _react.createElement((0, _fieldGroupIconButtonMjs.FieldGroupIconButton), Object.assign({
        ariaLabel: l,
        size: c,
        ref: m
    }, p), null !== (a = null == d ? void 0 : d.clear) && void 0 !== a ? a : _react.createElement((0, _iconCloseMjs.IconClose), null));
});
m.displayName = "FieldClearButton";

},{"tslib":"86BcK","react":"gVheC","../FieldGroupIcon/FieldGroupIcon.mjs":"b1VQW","../FieldGroupIcon/FieldGroupIconButton.mjs":"bFa8B","../Icon/Icon.mjs":"a3e7v","../Icon/context/IconsContext.mjs":"enrlS","../Icon/context/useIcons.mjs":"awHCP","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","../Icon/icons/IconClose.mjs":"61r5C","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b1VQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldGroupIcon", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const o = _react.forwardRef((o, m)=>{
    var { className: l, children: t, isVisible: c = !0, excludeFromTabOrder: d = !1 } = o, n = (0, _tslib.__rest)(o, [
        "className",
        "children",
        "isVisible",
        "excludeFromTabOrder"
    ]);
    return c ? _react.createElement((0, _viewMjs.View), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroupIcon, l),
        ref: m,
        tabIndex: d ? -1 : void 0
    }, n), t) : null;
});
o.displayName = "FieldGroupIcon";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bFa8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldGroupIconButton", ()=>a);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _buttonMjs = require("../Button/Button.mjs");
var _constantsMjs = require("../shared/constants.mjs");
var _fieldGroupIconMjs = require("./FieldGroupIcon.mjs");
const a = _react.forwardRef((a, n)=>{
    var { children: c, className: i } = a, l = (0, _tslib.__rest)(a, [
        "children",
        "className"
    ]);
    return _react.createElement((0, _fieldGroupIconMjs.FieldGroupIcon), Object.assign({
        as: (0, _buttonMjs.Button),
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroupIconButton, i),
        ref: n
    }, l), c);
});
a.displayName = "FieldGroupIconButton";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../Button/Button.mjs":"4aRAq","../shared/constants.mjs":"aQd5e","./FieldGroupIcon.mjs":"b1VQW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ewNp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldDescription", ()=>d);
parcelHelpers.export(exports, "QA_FIELD_DESCRIPTION", ()=>a);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _textMjs = require("../Text/Text.mjs");
var _constantsMjs = require("../shared/constants.mjs");
const a = "qa-field-description", d = (d)=>{
    var { descriptiveText: l, labelHidden: m } = d, o = (0, _tslib.__rest)(d, [
        "descriptiveText",
        "labelHidden"
    ]);
    return l ? _react.createElement((0, _textMjs.Text), Object.assign({
        "data-testid": a,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldDescription, {
            [(0, _constantsMjs.ComponentClassNames).VisuallyHidden]: m
        })
    }, o), l) : null;
};
d.displayName = "FieldDescription";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../Text/Text.mjs":"bYgXO","../shared/constants.mjs":"aQd5e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eFojV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldErrorMessage", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _textMjs = require("../Text/Text.mjs");
var _constantsMjs = require("../shared/constants.mjs");
const o = (o)=>{
    var { errorMessage: t, hasError: m } = o, i = (0, _tslib.__rest)(o, [
        "errorMessage",
        "hasError"
    ]);
    return m && t ? _react.createElement((0, _textMjs.Text), Object.assign({
        className: (0, _constantsMjs.ComponentClassNames).FieldErrorMessage
    }, i), t) : null;
};
o.displayName = "FieldErrorMessage";

},{"tslib":"86BcK","react":"gVheC","../Text/Text.mjs":"bYgXO","../shared/constants.mjs":"aQd5e","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8m82z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Field", ()=>d);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _fieldDescriptionMjs = require("./FieldDescription.mjs");
var _fieldErrorMessageMjs = require("./FieldErrorMessage.mjs");
var _labelMjs = require("../Label/Label.mjs");
const d = _react.forwardRef((d, n)=>{
    const { className: c, size: p, testId: f, children: b, label: E, labelHidden: F, errorMessage: h, hasError: j, descriptiveText: x } = d, g = (0, _tslib.__rest)(d, [
        "className",
        "size",
        "testId",
        "children",
        "label",
        "labelHidden",
        "errorMessage",
        "hasError",
        "descriptiveText"
    ]);
    return _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Field, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Field, p), c),
        "data-size": p,
        testId: f,
        ref: n
    }, g), E ? _react.createElement((0, _labelMjs.Label), {
        visuallyHidden: F
    }, E) : null, _react.createElement((0, _fieldDescriptionMjs.FieldDescription), {
        labelHidden: F,
        descriptiveText: x
    }), b, h ? _react.createElement((0, _fieldErrorMessageMjs.FieldErrorMessage), {
        hasError: j,
        errorMessage: h
    }) : null);
});
d.displayName = "Field";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Flex/Flex.mjs":"49y3m","./FieldDescription.mjs":"2ewNp","./FieldErrorMessage.mjs":"eFojV","../Label/Label.mjs":"5r556","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5r556":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>i);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const i = _react.forwardRef((i, m)=>{
    var { children: t, className: o, visuallyHidden: n } = i, c = (0, _tslib.__rest)(i, [
        "children",
        "className",
        "visuallyHidden"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "label",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Label, o, {
            [(0, _constantsMjs.ComponentClassNames).VisuallyHidden]: n
        }),
        ref: m
    }, c), t);
});
i.displayName = "Label";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"89jiH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FieldGroup", ()=>l);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _viewMjs = require("../View/View.mjs");
const l = _react.forwardRef((l, m)=>{
    var { children: p, className: s, innerEndComponent: d, innerStartComponent: u, orientation: c = "horizontal", outerEndComponent: F, outerStartComponent: E, variation: G } = l, f = (0, _tslib.__rest)(l, [
        "children",
        "className",
        "innerEndComponent",
        "innerStartComponent",
        "orientation",
        "outerEndComponent",
        "outerStartComponent",
        "variation"
    ]);
    const N = null != d, C = null != u ? (0, _constantsMjs.ComponentClassNames).FieldGroupHasInnerStart : null, S = N ? (0, _constantsMjs.ComponentClassNames).FieldGroupHasInnerEnd : null, O = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroup, C, S, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).FieldGroup, c), s);
    return _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: O,
        "data-orientation": c,
        ref: m
    }, f), E && _react.createElement((0, _viewMjs.View), {
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroupOuterStart, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).FieldGroupOuterStart, G))
    }, E), _react.createElement((0, _viewMjs.View), {
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroupFieldWrapper, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).FieldGroupFieldWrapper, c)),
        "data-orientation": c
    }, u && _react.createElement((0, _viewMjs.View), {
        className: (0, _constantsMjs.ComponentClassNames).FieldGroupInnerStart
    }, u), p, d && _react.createElement((0, _viewMjs.View), {
        className: (0, _constantsMjs.ComponentClassNames).FieldGroupInnerEnd
    }, d)), F && _react.createElement((0, _viewMjs.View), {
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).FieldGroupOuterEnd, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).FieldGroupOuterEnd, G))
    }, F));
});
l.displayName = "FieldGroup";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Flex/Flex.mjs":"49y3m","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ab7IK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>o);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
var _useFieldsetMjs = require("../Fieldset/useFieldset.mjs");
const o = _react.forwardRef((o, u)=>{
    var { autoComplete: m, checked: p, className: n, defaultChecked: c, defaultValue: f, id: h, isDisabled: v, isReadOnly: y, isRequired: C, size: b, type: k = "text", hasError: I = !1, value: R, variation: V } = o, j = (0, _tslib.__rest)(o, [
        "autoComplete",
        "checked",
        "className",
        "defaultChecked",
        "defaultValue",
        "id",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "size",
        "type",
        "hasError",
        "value",
        "variation"
    ]);
    const w = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Input, (0, _constantsMjs.ComponentClassNames).FieldGroupControl, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Input, V), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Input, "error", I), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Input, b), n), { isFieldsetDisabled: D } = (0, _useFieldsetMjs.useFieldset)();
    return _react.createElement((0, _viewMjs.View), Object.assign({
        "aria-invalid": I,
        as: "input",
        autoComplete: m,
        checked: p,
        className: w,
        "data-size": b,
        "data-variation": V,
        defaultChecked: c,
        defaultValue: f,
        isDisabled: D || v,
        id: h,
        readOnly: y,
        ref: u,
        required: C,
        type: k,
        value: R
    }, j));
});
o.displayName = "Input";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","../Fieldset/useFieldset.mjs":"e0bLb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d2cda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitPrimitiveProps", ()=>t);
var _styleMjs = require("../types/style.mjs");
const t = (t)=>{
    const e = {
        styleProps: {},
        rest: {}
    };
    return Object.keys(t).forEach((r)=>{
        ((t)=>t in (0, _styleMjs.ComponentPropsToStylePropsMap))(r) ? e.styleProps = Object.assign(Object.assign({}, e.styleProps), {
            [r]: t[r]
        }) : e.rest = Object.assign(Object.assign({}, e.rest), {
            [r]: t[r]
        });
    }), e;
};

},{"../types/style.mjs":"jP0Ex","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aArLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTO_GENERATED_ID_PREFIX", ()=>r);
parcelHelpers.export(exports, "useStableId", ()=>s);
var _react = require("react");
var _useLayoutEffectMjs = require("./useLayoutEffect.mjs");
const r = "amplify-id", e = _react["useId".toString()] || (()=>{});
let n = 0;
const s = (s)=>{
    const [u, i] = _react.useState(e());
    return (0, _useLayoutEffectMjs.useLayoutEffect)(()=>{
        s || i((t)=>null != t ? t : String(n++));
    }, [
        s
    ]), null != s ? s : u ? `${r}-${u}` : "";
};

},{"react":"gVheC","./useLayoutEffect.mjs":"512kr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"512kr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>l);
var _react = require("react");
const l = (null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? _react.useLayoutEffect : ()=>{};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jGezh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhoneNumberField", ()=>d);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _countryCodeSelectMjs = require("./CountryCodeSelect.mjs");
var _textFieldMjs = require("../TextField/TextField.mjs");
const d = _react.forwardRef((d, i)=>{
    var { autoComplete: s = "tel-national", className: C, countryCodeName: m, countryCodeLabel: u = (0, _constantsMjs.ComponentText).PhoneNumberField.countryCodeLabel, countryCodeRef: c, defaultCountryCode: f, defaultDialCode: y, dialCodeLabel: b = (0, _constantsMjs.ComponentText).PhoneNumberField.countryCodeLabel, dialCodeList: p, dialCodeName: h, dialCodeRef: N, hasError: L, isDisabled: R, isReadOnly: D, onCountryCodeChange: g, onDialCodeChange: E, onInput: F, size: v, variation: O } = d, j = (0, _tslib.__rest)(d, [
        "autoComplete",
        "className",
        "countryCodeName",
        "countryCodeLabel",
        "countryCodeRef",
        "defaultCountryCode",
        "defaultDialCode",
        "dialCodeLabel",
        "dialCodeList",
        "dialCodeName",
        "dialCodeRef",
        "hasError",
        "isDisabled",
        "isReadOnly",
        "onCountryCodeChange",
        "onDialCodeChange",
        "onInput",
        "size",
        "variation"
    ]);
    const z = null != h ? h : m, P = null != b ? b : u, x = null != y ? y : f, I = null != E ? E : g, S = null != N ? N : c;
    return _react.createElement((0, _textFieldMjs.TextField), Object.assign({
        outerStartComponent: _react.createElement((0, _countryCodeSelectMjs.CountryCodeSelect), {
            defaultValue: x,
            dialCodeList: p,
            className: C,
            hasError: L,
            isDisabled: R,
            isReadOnly: D,
            label: P,
            name: z,
            onChange: I,
            ref: S,
            size: v,
            variation: O
        }),
        autoComplete: s,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).PhoneNumberField, C),
        hasError: L,
        isDisabled: R,
        isReadOnly: D,
        onInput: F,
        ref: i,
        size: v,
        type: "tel",
        variation: O
    }, j));
});
d.displayName = "PhoneNumberField";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","./CountryCodeSelect.mjs":"2djwW","../TextField/TextField.mjs":"7qkLa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2djwW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CountryCodeSelect", ()=>r);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _selectFieldMjs = require("../SelectField/SelectField.mjs");
const r = _react.forwardRef((r, i)=>{
    var { className: m, dialCodeList: d, isReadOnly: c } = r, n = (0, _tslib.__rest)(r, [
        "className",
        "dialCodeList",
        "isReadOnly"
    ]);
    const p = null != d ? d : (0, _ui.countryDialCodes), f = _react.useMemo(()=>p.map((e)=>_react.createElement("option", {
                key: e,
                value: e,
                disabled: c
            }, e)), [
        p,
        c
    ]);
    return _react.createElement((0, _selectFieldMjs.SelectField), Object.assign({
        "aria-disabled": c,
        autoComplete: "tel-country-code",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).CountryCodeSelect, (0, _constantsMjs.ComponentClassNames).DialCodeSelect, m),
        labelHidden: !0,
        ref: i
    }, n), f);
});
r.displayName = "CountryCodeSelect";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../SelectField/SelectField.mjs":"fGhgh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGhgh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectField", ()=>c);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _fieldClearButtonMjs = require("../Field/FieldClearButton.mjs");
var _fieldDescriptionMjs = require("../Field/FieldDescription.mjs");
var _fieldErrorMessageMjs = require("../Field/FieldErrorMessage.mjs");
var _fieldMjs = require("../Field/Field.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _labelMjs = require("../Label/Label.mjs");
var _selectMjs = require("../Select/Select.mjs");
var _splitPrimitivePropsMjs = require("../utils/splitPrimitiveProps.mjs");
var _useStableIdMjs = require("../utils/useStableId.mjs");
const c = _react.forwardRef((c, f)=>{
    const { children: F, className: h, descriptiveText: b, errorMessage: u, hasError: j = !1, id: E, label: v, labelHidden: g = !1, options: y, size: S, testId: x, inputStyles: I } = c, z = (0, _tslib.__rest)(c, [
        "children",
        "className",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "label",
        "labelHidden",
        "options",
        "size",
        "testId",
        "inputStyles"
    ]), H = (0, _useStableIdMjs.useStableId)(E), M = (0, _useStableIdMjs.useStableId)(), N = b ? M : void 0, { styleProps: w, rest: P } = (0, _splitPrimitivePropsMjs.splitPrimitiveProps)(z);
    return _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Field, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Field, S), (0, _constantsMjs.ComponentClassNames).SelectField, h),
        "data-size": S,
        testId: x
    }, w), _react.createElement((0, _labelMjs.Label), {
        htmlFor: H,
        visuallyHidden: g
    }, v), _react.createElement((0, _fieldDescriptionMjs.FieldDescription), {
        id: M,
        labelHidden: g,
        descriptiveText: b
    }), _react.createElement((0, _selectMjs.Select), Object.assign({
        "aria-describedby": N,
        hasError: j,
        id: H,
        ref: f,
        size: S
    }, P, I), (({ children: e, options: i })=>e ? ((null == i ? void 0 : i.length) && console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children."), e) : null == i ? void 0 : i.map((e, i)=>_react.createElement("option", {
                label: e,
                value: e,
                key: `${e}-${i}`
            }, e)))({
        children: F,
        options: y
    })), _react.createElement((0, _fieldErrorMessageMjs.FieldErrorMessage), {
        hasError: j,
        errorMessage: u
    }));
});
c.displayName = "SelectField";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Field/FieldClearButton.mjs":"hLrLW","../Field/FieldDescription.mjs":"2ewNp","../Field/FieldErrorMessage.mjs":"eFojV","../Field/Field.mjs":"8m82z","../Flex/Flex.mjs":"49y3m","../Label/Label.mjs":"5r556","../Select/Select.mjs":"lL1B8","../utils/splitPrimitiveProps.mjs":"d2cda","../utils/useStableId.mjs":"aArLN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lL1B8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>p);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _iconMjs = require("../Icon/Icon.mjs");
var _iconsContextMjs = require("../Icon/context/IconsContext.mjs");
var _useIconsMjs = require("../Icon/context/useIcons.mjs");
var _viewMjs = require("../View/View.mjs");
var _iconExpandMoreMjs = require("../Icon/icons/IconExpandMore.mjs");
var _useFieldsetMjs = require("../Fieldset/useFieldset.mjs");
const p = _react.forwardRef((p, d)=>{
    var u, { autoComplete: f, className: v, size: S, variation: I, value: j, defaultValue: x, hasError: E, icon: h, iconColor: C, children: b, placeholder: z, isDisabled: F, isRequired: N, isMultiple: V = !1, selectSize: w = 1 } = p, D = (0, _tslib.__rest)(p, [
        "autoComplete",
        "className",
        "size",
        "variation",
        "value",
        "defaultValue",
        "hasError",
        "icon",
        "iconColor",
        "children",
        "placeholder",
        "isDisabled",
        "isRequired",
        "isMultiple",
        "selectSize"
    ]);
    const q = void 0 === j && void 0 === x && z, M = V || w > 1, R = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Select, (0, _constantsMjs.ComponentClassNames).FieldGroupControl, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Select, S), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Select, I), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Select, "error", E), (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Select, "expanded", M), v), W = (0, _useIconsMjs.useIcons)("select"), { isFieldsetDisabled: y } = (0, _useFieldsetMjs.useFieldset)();
    return _react.createElement((0, _viewMjs.View), {
        className: (0, _constantsMjs.ComponentClassNames).SelectWrapper
    }, _react.createElement((0, _viewMjs.View), Object.assign({
        "aria-invalid": E,
        as: "select",
        autoComplete: f,
        value: j,
        defaultValue: q ? "" : x,
        isDisabled: y || F,
        multiple: V,
        size: w,
        required: N,
        "data-size": S,
        "data-variation": I,
        className: R,
        ref: d
    }, D), z && _react.createElement("option", {
        value: ""
    }, z), b), M ? null : _react.createElement((0, _flexMjs.Flex), {
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).SelectIconWrapper, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).SelectIconWrapper, S)),
        color: C
    }, null !== (u = null != h ? h : null == W ? void 0 : W.expand) && void 0 !== u ? u : _react.createElement((0, _iconExpandMoreMjs.IconExpandMore), null)));
});
p.displayName = "Select";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Flex/Flex.mjs":"49y3m","../Icon/Icon.mjs":"a3e7v","../Icon/context/IconsContext.mjs":"enrlS","../Icon/context/useIcons.mjs":"awHCP","../View/View.mjs":"dfO6K","../Icon/icons/IconExpandMore.mjs":"jPWNT","../Fieldset/useFieldset.mjs":"e0bLb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jPWNT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconExpandMore", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _constantsMjs = require("../../shared/constants.mjs");
var _viewMjs = require("../../View/View.mjs");
const o = (o)=>{
    const { className: a } = o, i = (0, _tslib.__rest)(o, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Icon, a)
    }, i), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","../../shared/constants.mjs":"aQd5e","../../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ci7ai":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidationErrors", ()=>m);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _viewMjs = require("../../primitives/View/View.mjs");
var _textMjs = require("../../primitives/Text/Text.mjs");
const m = ({ errors: m, id: o, dataAttr: a })=>{
    if (!((null == m ? void 0 : m.length) > 0)) return null;
    const n = a ? {
        [a]: !0
    } : {};
    return (0, _reactDefault.default).createElement((0, _viewMjs.View), Object.assign({}, n, {
        id: o
    }), m.map((t)=>(0, _reactDefault.default).createElement((0, _textMjs.Text), {
            key: t,
            role: "alert",
            variation: "error"
        }, (0, _ui.translate)(t))));
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../primitives/View/View.mjs":"dfO6K","../../primitives/Text/Text.mjs":"bYgXO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"SZ75J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouteContainer", ()=>n);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _viewMjs = require("../../../primitives/View/View.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
const r = (e)=>"signIn" === e || "signUp";
function n({ children: n, className: m, variation: i = "default" }) {
    const { route: s } = (0, _uiReactCore.useAuthenticator)(({ route: e })=>[
            e
        ]), { components: { Header: c, Footer: l } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        className: m,
        "data-amplify-authenticator": "",
        "data-variation": i
    }, (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-container": ""
    }, (0, _reactDefault.default).createElement(c, null), (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-router": "",
        "data-amplify-router-content": r(s) ? void 0 : ""
    }, n), (0, _reactDefault.default).createElement(l, null)));
}

},{"react":"gVheC","../../../primitives/View/View.mjs":"dfO6K","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"wtNsH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForceNewPassword", ()=>f);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getChangePasswordText: d, getChangingText: c, getBackToSignInText: p } = (0, _ui.authenticatorTextUtil), f = ({ className: t, variation: n })=>{
    const { isPending: l, toSignIn: g } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending,
            e.toSignIn
        ]), { handleBlur: F, handleChange: h, handleSubmit: E } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ForceNewPassword: { FormFields: C = f.FormFields, Header: j = f.Header, Footer: v = f.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: n
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: h,
        onSubmit: E,
        onBlur: F
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: l
    }, (0, _reactDefault.default).createElement(j, null), (0, _reactDefault.default).createElement(C, null), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        isDisabled: l,
        type: "submit",
        variation: "primary",
        isLoading: l,
        loadingText: c(),
        fontWeight: "normal"
    }, d()), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        onClick: g,
        type: "button",
        fontWeight: "normal",
        variation: "link",
        size: "small"
    }, p()), (0, _reactDefault.default).createElement(v, null))));
};
f.FormFields = function() {
    return (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null);
}, f.Header = function() {
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 4
    }, d());
}, f.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","../shared/RemoteErrorMessage.mjs":"dGudN","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kz4YC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetupTOTP", ()=>v);
var _tslib = require("tslib");
var _qrcode = require("qrcode");
var _qrcodeDefault = parcelHelpers.interopDefault(_qrcode);
var _react = require("react");
var _awsAmplify = require("aws-amplify");
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _confirmSignInFooterMjs = require("../shared/ConfirmSignInFooter.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const g = new (0, _awsAmplify.Logger)("SetupTOTP-logger"), { getSetupTOTPText: h, getCopiedText: C, getLoadingText: E } = (0, _ui.authenticatorTextUtil), v = ({ className: r, variation: a })=>{
    var n;
    const { totpSecretCode: h, isPending: y, user: H, QRFields: w } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending,
            e.totpSecretCode
        ]), { handleChange: S, handleSubmit: F } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { SetupTOTP: { Header: T = v.Header, Footer: x = v.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)(), [j, V] = _react.useState(!0), [b, P] = _react.useState(), [R, k] = _react.useState("COPY"), { totpIssuer: L = "AWSCognito", totpUsername: M = null == H ? void 0 : H.username } = null !== (n = w) && void 0 !== n ? n : {}, O = _react.useCallback(()=>(0, _tslib.__awaiter)(void 0, void 0, void 0, function*() {
            try {
                const e = (0, _ui.getTotpCodeURL)(L, M, h), o = yield (0, _qrcodeDefault.default).toDataURL(e);
                P(o);
            } catch (e) {
                g.error(e);
            } finally{
                V(!1);
            }
        }), [
        L,
        M,
        h
    ]);
    _react.useEffect(()=>{
        b || O();
    }, [
        O,
        b
    ]);
    return _react.createElement((0, _routeContainerMjs.RouteContainer), {
        className: r,
        variation: a
    }, _react.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: S,
        onSubmit: F
    }, _react.createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: y
    }, _react.createElement(T, null), _react.createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, j ? _react.createElement("p", null, E(), "\u2026") : _react.createElement("img", {
        "data-amplify-qrcode": !0,
        src: b,
        alt: "qr code",
        width: "228",
        height: "228"
    }), _react.createElement((0, _flexMjs.Flex), {
        "data-amplify-copy": !0
    }, _react.createElement("div", null, h), _react.createElement((0, _flexMjs.Flex), {
        "data-amplify-copy-svg": !0,
        onClick: ()=>{
            navigator.clipboard.writeText(h), k(C());
        }
    }, _react.createElement("div", {
        "data-amplify-copy-tooltip": !0
    }, R), _react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, _react.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), _react.createElement((0, _formFieldsMjs.FormFields), null), _react.createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null)), _react.createElement((0, _confirmSignInFooterMjs.ConfirmSignInFooter), null), _react.createElement(x, null))));
};
v.Header = function() {
    return _react.createElement((0, _headingMjs.Heading), {
        level: 3
    }, h());
}, v.Footer = function() {
    return null;
};

},{"tslib":"86BcK","qrcode":"i1bqw","react":"gVheC","aws-amplify":"75VoS","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/ConfirmSignInFooter.mjs":"9OmYv","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i1bqw":[function(require,module,exports) {
const canPromise = require("da1f68cc1fc16077");
const QRCode = require("8c6cf49ef2287430");
const CanvasRenderer = require("8a60cf7722cc14ce");
const SvgRenderer = require("f6fcc816b915ba37");
function renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !canPromise()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = QRCode.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = QRCode.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
exports.create = QRCode.create;
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
// only svg for now.
exports.toString = renderCanvas.bind(null, function(data, _, opts) {
    return SvgRenderer.render(data, opts);
});

},{"da1f68cc1fc16077":"8BSdp","8c6cf49ef2287430":"a8kRW","8a60cf7722cc14ce":"l2z9L","f6fcc816b915ba37":"jfLuR"}],"8BSdp":[function(require,module,exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

},{}],"a8kRW":[function(require,module,exports) {
const Utils = require("4cf6a8173d9f3a2");
const ECLevel = require("2ad62f61c352884c");
const BitBuffer = require("87d5a6270eb1dc26");
const BitMatrix = require("91abc94f777368cc");
const AlignmentPattern = require("9737c3939ab85d95");
const FinderPattern = require("cee3d371e219e45e");
const MaskPattern = require("8700c8c682afabf3");
const ECCode = require("65ad903a6ba3e");
const ReedSolomonEncoder = require("1e8e447afb4d169c");
const Version = require("8a4a19af97836d80");
const FormatInfo = require("26720f9d94c9e268");
const Mode = require("7b6429a248ecc51f");
const Segments = require("1368d0fa14524351");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = FinderPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupAlignmentPattern(matrix, version) {
    const pos = AlignmentPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = Version.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new BitBuffer();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new ReedSolomonEncoder(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = Segments.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = Segments.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = Segments.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = Utils.getSymbolSize(version);
    const modules = new BitMatrix(moduleCount);
    // Add function modules
    setupFinderPattern(modules, version);
    setupTimingPattern(modules);
    setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) setupVersionInfo(modules, version);
    // Add data codewords
    setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules, setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    MaskPattern.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ exports.create = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = ECLevel.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
        version = Version.from(options.version);
        mask = MaskPattern.from(options.maskPattern);
        if (options.toSJISFunc) Utils.setToSJISFunction(options.toSJISFunc);
    }
    return createSymbol(data, version, errorCorrectionLevel, mask);
};

},{"4cf6a8173d9f3a2":"fEhXg","2ad62f61c352884c":"76cPY","87d5a6270eb1dc26":"fhlc4","91abc94f777368cc":"4KgaD","9737c3939ab85d95":"i5Hax","cee3d371e219e45e":"gI6e3","8700c8c682afabf3":"iuCvY","65ad903a6ba3e":"kOFiy","1e8e447afb4d169c":"k7RI4","8a4a19af97836d80":"kUSkI","26720f9d94c9e268":"J0dzX","7b6429a248ecc51f":"8p2RS","1368d0fa14524351":"3bCfJ"}],"fEhXg":[function(require,module,exports) {
let toSJISFunction;
const CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ exports.getSymbolSize = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ exports.getSymbolTotalCodewords = function getSymbolTotalCodewords(version) {
    return CODEWORDS_COUNT[version];
};
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ exports.getBCHDigit = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
exports.setToSJISFunction = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    toSJISFunction = f;
};
exports.isKanjiModeEnabled = function() {
    return typeof toSJISFunction !== "undefined";
};
exports.toSJIS = function toSJIS(kanji) {
    return toSJISFunction(kanji);
};

},{}],"76cPY":[function(require,module,exports) {
exports.L = {
    bit: 1
};
exports.M = {
    bit: 0
};
exports.Q = {
    bit: 3
};
exports.H = {
    bit: 2
};
function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return exports.L;
        case "m":
        case "medium":
            return exports.M;
        case "q":
        case "quartile":
            return exports.Q;
        case "h":
        case "high":
            return exports.H;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
exports.isValid = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{}],"fhlc4":[function(require,module,exports) {
function BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = BitBuffer;

},{}],"4KgaD":[function(require,module,exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = BitMatrix;

},{}],"i5Hax":[function(require,module,exports) {
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ const getSymbolSize = require("3fa093180e62a22a").getSymbolSize;
/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ exports.getRowColCoords = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const coords = [];
    const pos = exports.getRowColCoords(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

},{"3fa093180e62a22a":"fEhXg"}],"gI6e3":[function(require,module,exports) {
const getSymbolSize = require("6ec9ae5660047293").getSymbolSize;
const FINDER_PATTERN_SIZE = 7;
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const size = getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - FINDER_PATTERN_SIZE
        ]
    ];
};

},{"6ec9ae5660047293":"fEhXg"}],"iuCvY":[function(require,module,exports) {
/**
 * Data mask pattern reference
 * @type {Object}
 */ exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ exports.isValid = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : undefined;
};
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ exports.getPenaltyN1 = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ exports.getPenaltyN2 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * PenaltyScores.N2;
};
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ exports.getPenaltyN3 = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * PenaltyScores.N3;
};
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ exports.getPenaltyN4 = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case exports.Patterns.PATTERN000:
            return (i + j) % 2 === 0;
        case exports.Patterns.PATTERN001:
            return i % 2 === 0;
        case exports.Patterns.PATTERN010:
            return j % 3 === 0;
        case exports.Patterns.PATTERN011:
            return (i + j) % 3 === 0;
        case exports.Patterns.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case exports.Patterns.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case exports.Patterns.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case exports.Patterns.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ exports.applyMask = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
    }
};
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys(exports.Patterns).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        exports.applyMask(p, data);
        // Calculate penalty
        const penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
        // Undo previously applied mask
        exports.applyMask(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

},{}],"kOFiy":[function(require,module,exports) {
const ECLevel = require("7baaa530584d1bc4");
const EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ exports.getBlocksCount = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ exports.getTotalCodewordsCount = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

},{"7baaa530584d1bc4":"76cPY"}],"k7RI4":[function(require,module,exports) {
const Polynomial = require("742a7ee6d6a2d145");
function ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = Polynomial.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = ReedSolomonEncoder;

},{"742a7ee6d6a2d145":"ftoeA"}],"ftoeA":[function(require,module,exports) {
const GF = require("780c74029318268c");
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ exports.mul = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= GF.mul(p1[i], p2[j]);
    return coeff;
};
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ exports.mod = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= GF.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ exports.generateECPolynomial = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = exports.mul(poly, new Uint8Array([
        1,
        GF.exp(i)
    ]));
    return poly;
};

},{"780c74029318268c":"5gOQG"}],"5gOQG":[function(require,module,exports) {
const EXP_TABLE = new Uint8Array(512);
const LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        EXP_TABLE[i] = x;
        LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)EXP_TABLE[i] = EXP_TABLE[i - 255];
})();
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.log = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return LOG_TABLE[n];
};
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.exp = function exp(n) {
    return EXP_TABLE[n];
};
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ exports.mul = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]];
};

},{}],"kUSkI":[function(require,module,exports) {
const Utils = require("f67b02cdf61cb7c6");
const ECCode = require("777da0d92c463f2e");
const ECLevel = require("acd5b4fcd696edf3");
const Mode = require("5303c314c4a688d7");
const VersionCheck = require("663d0e03da8b2897");
// Generator polynomial used to encode version information
const G18 = 7973;
const G18_BCH = Utils.getBCHDigit(G18);
function getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return Mode.getCharCountIndicator(mode, version) + 4;
}
function getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) return currentVersion;
    }
    return undefined;
}
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ exports.getCapacity = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!VersionCheck.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = Mode.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === Mode.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case Mode.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case Mode.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case Mode.KANJI:
            return Math.floor(usableBits / 13);
        case Mode.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ exports.getEncodedBits = function getEncodedBits(version) {
    if (!VersionCheck.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while(Utils.getBCHDigit(d) - G18_BCH >= 0)d ^= G18 << Utils.getBCHDigit(d) - G18_BCH;
    return version << 12 | d;
};

},{"f67b02cdf61cb7c6":"fEhXg","777da0d92c463f2e":"kOFiy","acd5b4fcd696edf3":"76cPY","5303c314c4a688d7":"8p2RS","663d0e03da8b2897":"lQGYI"}],"8p2RS":[function(require,module,exports) {
const VersionCheck = require("488660fac9162579");
const Regex = require("a23fd227d32f3622");
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ exports.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ exports.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ exports.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ exports.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ exports.MIXED = {
    bit: -1
};
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ exports.getCharCountIndicator = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!VersionCheck.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr)) return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr)) return exports.KANJI;
    else return exports.BYTE;
};
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ exports.toString = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ exports.isValid = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return exports.NUMERIC;
        case "alphanumeric":
            return exports.ALPHANUMERIC;
        case "kanji":
            return exports.KANJI;
        case "byte":
            return exports.BYTE;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{"488660fac9162579":"lQGYI","a23fd227d32f3622":"jzIJ6"}],"lQGYI":[function(require,module,exports) {
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ exports.isValid = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

},{}],"jzIJ6":[function(require,module,exports) {
const numeric = "[0-9]+";
const alphanumeric = "[A-Z $%*+\\-./:]+";
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
const byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
exports.KANJI = new RegExp(kanji, "g");
exports.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
exports.BYTE = new RegExp(byte, "g");
exports.NUMERIC = new RegExp(numeric, "g");
exports.ALPHANUMERIC = new RegExp(alphanumeric, "g");
const TEST_KANJI = new RegExp("^" + kanji + "$");
const TEST_NUMERIC = new RegExp("^" + numeric + "$");
const TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
exports.testKanji = function testKanji(str) {
    return TEST_KANJI.test(str);
};
exports.testNumeric = function testNumeric(str) {
    return TEST_NUMERIC.test(str);
};
exports.testAlphanumeric = function testAlphanumeric(str) {
    return TEST_ALPHANUMERIC.test(str);
};

},{}],"J0dzX":[function(require,module,exports) {
const Utils = require("eeca831a42e85d6c");
const G15 = 1335;
const G15_MASK = 21522;
const G15_BCH = Utils.getBCHDigit(G15);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ exports.getEncodedBits = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while(Utils.getBCHDigit(d) - G15_BCH >= 0)d ^= G15 << Utils.getBCHDigit(d) - G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ G15_MASK;
};

},{"eeca831a42e85d6c":"fEhXg"}],"3bCfJ":[function(require,module,exports) {
const Mode = require("45f6d4bff9d2fc72");
const NumericData = require("73109cbf4f3c309d");
const AlphanumericData = require("5320016e34c30467");
const ByteData = require("fd16f8f25b581951");
const KanjiData = require("8a7b84039f1cf0d2");
const Regex = require("79379a3a8f3c26bb");
const Utils = require("66903ca51bd2ea1d");
const dijkstra = require("3b9f47d541e7d71f");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function getSegmentsFromString(dataStr) {
    const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
    const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if (Utils.isKanjiModeEnabled()) {
        byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
        kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
    } else {
        byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function getSegmentBitsLength(length, mode) {
    switch(mode){
        case Mode.NUMERIC:
            return NumericData.getBitsLength(length);
        case Mode.ALPHANUMERIC:
            return AlphanumericData.getBitsLength(length);
        case Mode.KANJI:
            return KanjiData.getBitsLength(length);
        case Mode.BYTE:
            return ByteData.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case Mode.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
                break;
            case Mode.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = Mode.getBestModeForData(data);
    mode = Mode.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== Mode.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + Mode.toString(mode) + ".\n Suggested mode is: " + Mode.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) mode = Mode.BYTE;
    switch(mode){
        case Mode.NUMERIC:
            return new NumericData(data);
        case Mode.ALPHANUMERIC:
            return new AlphanumericData(data);
        case Mode.KANJI:
            return new KanjiData(data);
        case Mode.BYTE:
            return new ByteData(data);
    }
}
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push(buildSingleSegment(seg, null));
        else if (seg.data) acc.push(buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ exports.fromString = function fromString(data, version) {
    const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());
    const nodes = buildNodes(segs);
    const graph = buildGraph(nodes, version);
    const path = dijkstra.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return exports.fromArray(mergeSegments(optimizedSegs));
};
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(getSegmentsFromString(data, Utils.isKanjiModeEnabled()));
};

},{"45f6d4bff9d2fc72":"8p2RS","73109cbf4f3c309d":"aRBtR","5320016e34c30467":"dZ1h7","fd16f8f25b581951":"hbINH","8a7b84039f1cf0d2":"9P4Ex","79379a3a8f3c26bb":"jzIJ6","66903ca51bd2ea1d":"fEhXg","3b9f47d541e7d71f":"c3NM9"}],"aRBtR":[function(require,module,exports) {
const Mode = require("29134b0b0820b091");
function NumericData(data) {
    this.mode = Mode.NUMERIC;
    this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength() {
    return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = NumericData;

},{"29134b0b0820b091":"8p2RS"}],"dZ1h7":[function(require,module,exports) {
const Mode = require("9c7c9b869570f846");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function AlphanumericData(data) {
    this.mode = Mode.ALPHANUMERIC;
    this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = AlphanumericData;

},{"9c7c9b869570f846":"8p2RS"}],"hbINH":[function(require,module,exports) {
const encodeUtf8 = require("1658cb836325c397");
const Mode = require("a20a51f6cd184253");
function ByteData(data) {
    this.mode = Mode.BYTE;
    this.data = new Uint8Array(encodeUtf8(data));
}
ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength() {
    return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = ByteData;

},{"1658cb836325c397":"bQqI3","a20a51f6cd184253":"8p2RS"}],"bQqI3":[function(require,module,exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

},{}],"9P4Ex":[function(require,module,exports) {
const Mode = require("b935cfd1cd03a1f6");
const Utils = require("ca4944585cc8d12d");
function KanjiData(data) {
    this.mode = Mode.KANJI;
    this.data = data;
}
KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength() {
    return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = Utils.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = KanjiData;

},{"b935cfd1cd03a1f6":"8p2RS","ca4944585cc8d12d":"fEhXg"}],"c3NM9":[function(require,module,exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
        return dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = dijkstra;

},{}],"l2z9L":[function(require,module,exports) {
const Utils = require("5b3f7c513802d6c7");
function clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
exports.render = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = getCanvasElement();
    opts = Utils.getOptions(opts);
    const size = Utils.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    Utils.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
exports.renderToDataURL = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = exports.render(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

},{"5b3f7c513802d6c7":"dy1XJ"}],"dy1XJ":[function(require,module,exports) {
function hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
exports.getOptions = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: hex2rgba(options.color.dark || "#000000ff"),
            light: hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
exports.getImageWidth = function getImageWidth(qrSize, opts) {
    const scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = exports.getScale(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

},{}],"jfLuR":[function(require,module,exports) {
const Utils = require("c36bbcf663291acc");
function getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
exports.render = function render(qrData, options, cb) {
    const opts = Utils.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

},{"c36bbcf663291acc":"dy1XJ"}],"9OmYv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmSignInFooter", ()=>l);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
const { getConfirmText: r, getConfirmingText: m, getBackToSignInText: a } = (0, _ui.authenticatorTextUtil), l = ()=>{
    const { isPending: i, toSignIn: l } = (0, _uiReactCore.useAuthenticator)((t)=>[
            t.isPending,
            t.toSignIn
        ]);
    return (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        isDisabled: i,
        type: "submit",
        variation: "primary",
        fontWeight: "normal",
        isLoading: i,
        loadingText: m()
    }, r()), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        onClick: l,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, a()));
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@aws-amplify/ui-react-core":"cZFwB","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bGT5j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignInSignUpTabs", ()=>c);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _tabsMjs = require("../../../primitives/Tabs/Tabs.mjs");
var _viewMjs = require("../../../primitives/View/View.mjs");
var _signInMjs = require("../SignIn/SignIn.mjs");
var _signUpMjs = require("../SignUp/SignUp.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getSignInTabText: p, getSignUpTabText: s } = (0, _ui.authenticatorTextUtil), c = ({ className: t, hideSignUp: c, variation: g })=>{
    const { route: u, toSignIn: f, toSignUp: S } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.route,
            e.toSignIn,
            e.toSignUp
        ]);
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: g
    }, c ? (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-router-content": ""
    }, "signIn" === u && (0, _reactDefault.default).createElement((0, _signInMjs.SignIn), null)) : (0, _reactDefault.default).createElement((0, _tabsMjs.Tabs), {
        indicatorPosition: "top",
        currentIndex: "signIn" === u ? 0 : 1,
        spacing: "equal",
        justifyContent: "center",
        onChange: ()=>"signIn" === u ? S() : f()
    }, (0, _reactDefault.default).createElement((0, _tabsMjs.TabItem), {
        title: p()
    }, (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-router-content": ""
    }, "signIn" === u && (0, _reactDefault.default).createElement((0, _signInMjs.SignIn), null))), (0, _reactDefault.default).createElement((0, _tabsMjs.TabItem), {
        title: s()
    }, (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-router-content": ""
    }, "signUp" === u && (0, _reactDefault.default).createElement((0, _signUpMjs.SignUp), null)))));
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@aws-amplify/ui-react-core":"cZFwB","../../../primitives/Tabs/Tabs.mjs":"aVhpX","../../../primitives/View/View.mjs":"dfO6K","../SignIn/SignIn.mjs":"53ujc","../SignUp/SignUp.mjs":"1Erpu","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aVhpX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabItem", ()=>u);
parcelHelpers.export(exports, "Tabs", ()=>p);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactTabs = require("@radix-ui/react-tabs");
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _viewMjs = require("../View/View.mjs");
const { Root: o, List: m, Trigger: c, Content: d } = (0, _ui.sanitizeNamespaceImport)(_reactTabs), f = (e)=>_react.isValidElement(e), p = _react.forwardRef((r, i)=>{
    var { ariaLabel: l, children: c, className: p, defaultIndex: u = 0, currentIndex: g, onChange: b, indicatorPosition: h, spacing: x } = r, N = (0, _tslib.__rest)(r, [
        "ariaLabel",
        "children",
        "className",
        "defaultIndex",
        "currentIndex",
        "onChange",
        "indicatorPosition",
        "spacing"
    ]);
    const C = {
        defaultValue: u.toString(),
        value: null != g ? g.toString() : void 0,
        onValueChange: b
    }, E = _react.Children.toArray(c).filter((e)=>!!e);
    return _react.createElement(o, Object.assign({}, C), _react.createElement(m, {
        "aria-label": l
    }, _react.createElement((0, _flexMjs.Flex), Object.assign({
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Tabs, p),
        "data-indicator-position": h,
        ref: i
    }, N), _react.Children.map(E, (e, a)=>{
        if (f(e)) return _react.cloneElement(e, {
            "data-spacing": x,
            key: a,
            value: `${a}`
        });
    }))), _react.Children.map(E, (e, a)=>{
        if (f(e)) return _react.createElement(d, {
            key: a,
            value: `${a}`
        }, e.props.children);
    }));
}), u = _react.forwardRef((r, i)=>{
    var { className: s, title: o } = r, m = (0, _tslib.__rest)(r, [
        "className",
        "title"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: c,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).TabItems, s),
        ref: i
    }, m), o);
});
p.displayName = "Tabs", u.displayName = "TabItem";

},{"tslib":"86BcK","classnames":"6P5cq","@radix-ui/react-tabs":"6yah5","react":"gVheC","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Flex/Flex.mjs":"49y3m","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6yah5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTabsScope", ()=>$69cb30bb0017df05$export$355f5bd209d7b13a);
parcelHelpers.export(exports, "Tabs", ()=>$69cb30bb0017df05$export$b2539bed5023c21c);
parcelHelpers.export(exports, "TabsList", ()=>$69cb30bb0017df05$export$9712d22edc0d78c1);
parcelHelpers.export(exports, "TabsTrigger", ()=>$69cb30bb0017df05$export$8114b9fdfdf9f3ba);
parcelHelpers.export(exports, "TabsContent", ()=>$69cb30bb0017df05$export$bd905d70e8fd2ebb);
parcelHelpers.export(exports, "Root", ()=>$69cb30bb0017df05$export$be92b6f5f03c0fe9);
parcelHelpers.export(exports, "List", ()=>$69cb30bb0017df05$export$54c2e3dc7acea9f5);
parcelHelpers.export(exports, "Trigger", ()=>$69cb30bb0017df05$export$41fb9f06171c75f4);
parcelHelpers.export(exports, "Content", ()=>$69cb30bb0017df05$export$7c6e2c02157bb7d2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactContext = require("@radix-ui/react-context");
var _reactRovingFocus = require("@radix-ui/react-roving-focus");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactDirection = require("@radix-ui/react-direction");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactId = require("@radix-ui/react-id");
/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = (0, _reactContext.createContextScope)($69cb30bb0017df05$var$TABS_NAME, [
    (0, _reactRovingFocus.createRovingFocusGroupScope)
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = (0, _reactRovingFocus.createRovingFocusGroupScope)();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, _reactDirection.useDirection)(dir);
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, _react.createElement)($69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, _reactId.useId)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).div, (0, _extendsDefault.default)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$b2539bed5023c21c, {
    displayName: $69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, _react.createElement)((0, _reactRovingFocus.Root), (0, _extendsDefault.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).div, (0, _extendsDefault.default)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$9712d22edc0d78c1, {
    displayName: $69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, _react.createElement)((0, _reactRovingFocus.Item), (0, _extendsDefault.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).button, (0, _extendsDefault.default)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$8114b9fdfdf9f3ba, {
    displayName: $69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, _react.useRef)(isSelected);
    (0, _react.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, _react.createElement)((0, _reactPresence.Presence), {
        present: forceMount || isSelected
    }, ({ present: present })=>/*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).div, (0, _extendsDefault.default)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$bd905d70e8fd2ebb, {
    displayName: $69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@radix-ui/primitive":"b3ulj","@radix-ui/react-context":"Kf2U3","@radix-ui/react-roving-focus":"dN7a7","@radix-ui/react-presence":"cy5Lt","@radix-ui/react-primitive":"8gaYR","@radix-ui/react-direction":"kpsjk","@radix-ui/react-use-controllable-state":"4vju3","@radix-ui/react-id":"l5It9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d4f7v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b3ulj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeEventHandlers", ()=>$e42e1063c40fb3ef$export$b9ecd428b558ff10);
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Kf2U3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContext", ()=>$c512c27ab02ef895$export$fd42f52fd3ae1109);
parcelHelpers.export(exports, "createContextScope", ()=>$c512c27ab02ef895$export$50c7b4e9d9f19c1);
var _react = require("react");
function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, _react.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, _react.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, _react.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, _react.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, _react.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, _react.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, _react.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, _react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, _react.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, _react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, _react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dN7a7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRovingFocusGroupScope", ()=>$d7bdfb9eb0fdf311$export$c7109489551a4f4);
parcelHelpers.export(exports, "RovingFocusGroup", ()=>$d7bdfb9eb0fdf311$export$8699f7c8af148338);
parcelHelpers.export(exports, "RovingFocusGroupItem", ()=>$d7bdfb9eb0fdf311$export$ab9df7c53fe8454);
parcelHelpers.export(exports, "Root", ()=>$d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9);
parcelHelpers.export(exports, "Item", ()=>$d7bdfb9eb0fdf311$export$6d08773d2e66f8f2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactId = require("@radix-ui/react-id");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactDirection = require("@radix-ui/react-direction");
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = (0, _reactCollection.createCollection)($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = (0, _reactContext.createContextScope)($d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, _react.createElement)($d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, _react.createElement)($d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, _react.createElement)($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, _extendsDefault.default)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$8699f7c8af148338, {
    displayName: $d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, _react.useRef)(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const direction = (0, _reactDirection.useDirection)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, _reactUseControllableState.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, _react.useState)(false);
    const handleEntryFocus = (0, _reactUseCallbackRef.useCallbackRef)(onEntryFocus);
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, _react.createElement)($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, _react.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, _react.useCallback)(()=>setIsTabbingBackOut(true), [])
    }, /*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).div, (0, _extendsDefault.default)({
        tabIndex: isTabbingBackOut ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, ...itemProps } = props;
    const id = (0, _reactId.useId)();
    const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    return /*#__PURE__*/ (0, _react.createElement)($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, _react.createElement)((0, _reactPrimitive.Primitive).span, (0, _extendsDefault.default)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($d7bdfb9eb0fdf311$export$ab9df7c53fe8454, {
    displayName: $d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@radix-ui/primitive":"b3ulj","@radix-ui/react-collection":"j9mGZ","@radix-ui/react-compose-refs":"9IC1Z","@radix-ui/react-context":"Kf2U3","@radix-ui/react-id":"l5It9","@radix-ui/react-primitive":"8gaYR","@radix-ui/react-use-callback-ref":"kzmQn","@radix-ui/react-use-controllable-state":"4vju3","@radix-ui/react-direction":"kpsjk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j9mGZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCollection", ()=>$e02a7d9cb1dc128c$export$c74125a8e3af6bb2);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactContext = require("@radix-ui/react-context");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactSlot = require("@radix-ui/react-slot");
// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const itemMap = (0, _reactDefault.default).useRef(new Map()).current;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSlot.Slot), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, _reactDefault.default).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSlot.Slot), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, _reactDefault.default).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}

},{"react":"gVheC","@radix-ui/react-context":"Kf2U3","@radix-ui/react-compose-refs":"9IC1Z","@radix-ui/react-slot":"gkFCE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9IC1Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeRefs", ()=>$6ed0406888f73fc4$export$43e446d32b3d21af);
parcelHelpers.export(exports, "useComposedRefs", ()=>$6ed0406888f73fc4$export$c7b2cbe3552a0d05);
var _react = require("react");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, _react.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gkFCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slot", ()=>$5e63c961fc1ce211$export$8c6ed5c666ac1360);
parcelHelpers.export(exports, "Slottable", ()=>$5e63c961fc1ce211$export$d9f1ccf0bdb05d45);
parcelHelpers.export(exports, "Root", ()=>$5e63c961fc1ce211$export$be92b6f5f03c0fe9);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, _react.Children).toArray(children);
    const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, _react.Children).count(newElement) > 1) return (0, _react.Children).only(null);
                return /*#__PURE__*/ (0, _react.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, _react.createElement)($5e63c961fc1ce211$var$SlotClone, (0, _extendsDefault.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, _react.isValidElement)(newElement) ? /*#__PURE__*/ (0, _react.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, _react.createElement)($5e63c961fc1ce211$var$SlotClone, (0, _extendsDefault.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(children)) return /*#__PURE__*/ (0, _react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, _reactComposeRefs.composeRefs)(forwardedRef, children.ref)
    });
    return (0, _react.Children).count(children) > 1 ? (0, _react.Children).only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, _react.createElement)((0, _react.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, _react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $5e63c961fc1ce211$export$be92b6f5f03c0fe9 = $5e63c961fc1ce211$export$8c6ed5c666ac1360;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@radix-ui/react-compose-refs":"9IC1Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5It9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>$1746a345f3d73bb7$export$f680877a34711e37);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
const $1746a345f3d73bb7$var$useReactId = _react["useId".toString()] || (()=>undefined);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
    const [id, setId] = _react.useState($1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

},{"react":"gVheC","@radix-ui/react-use-layout-effect":"9XQ43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9XQ43":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>$9f79659886946c16$export$e5c5a5f917a5871c);
var _react = require("react");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, _react.useLayoutEffect) : ()=>{};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8gaYR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Primitive", ()=>$8927f6f2acc4f386$export$250ffa63cdc0d034);
parcelHelpers.export(exports, "Root", ()=>$8927f6f2acc4f386$export$be92b6f5f03c0fe9);
parcelHelpers.export(exports, "dispatchDiscreteCustomEvent", ()=>$8927f6f2acc4f386$export$6d1a0317bde7de7f);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactSlot = require("@radix-ui/react-slot");
const $8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, _react.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, _reactSlot.Slot) : node;
        (0, _react.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, _react.createElement)(Comp, (0, _extendsDefault.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, _reactDom.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $8927f6f2acc4f386$export$be92b6f5f03c0fe9 = $8927f6f2acc4f386$export$250ffa63cdc0d034;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","react-dom":"d8jlt","@radix-ui/react-slot":"gkFCE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kzmQn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>$b1b2314f5f9a1d84$export$25bec8c6f54ee79a);
var _react = require("react");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, _react.useRef)(callback);
    (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, _react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4vju3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControllableState", ()=>$71cd76cc60e0454e$export$6f32135080cb4c3);
var _react = require("react");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, _reactUseCallbackRef.useCallbackRef)(onChange);
    const setValue = (0, _react.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, _react.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, _react.useRef)(value);
    const handleChange = (0, _reactUseCallbackRef.useCallbackRef)(onChange);
    (0, _react.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

},{"react":"gVheC","@radix-ui/react-use-callback-ref":"kzmQn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kpsjk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDirection", ()=>$f631663db3294ace$export$b39126d51d94e6f3);
parcelHelpers.export(exports, "Provider", ()=>$f631663db3294ace$export$2881499e37b75b9a);
parcelHelpers.export(exports, "DirectionProvider", ()=>$f631663db3294ace$export$c760c09fdd558351);
var _react = require("react");
const $f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f631663db3294ace$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, _react.createElement)($f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, _react.useContext)($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $f631663db3294ace$export$2881499e37b75b9a = $f631663db3294ace$export$c760c09fdd558351;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cy5Lt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Presence", ()=>$921a889cee6df7e8$export$99c2b779aa4e8b8b);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, _react.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, _react.Children).only(children);
    const ref = (0, _reactComposeRefs.useComposedRefs)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, _react.cloneElement)(child, {
        ref: ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, _react.useState)();
    const stylesRef = (0, _react.useRef)({});
    const prevPresentRef = (0, _react.useRef)(present);
    const prevAnimationNameRef = (0, _react.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, _react.useEffect)(()=>{
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, _reactDom.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, _react.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}

},{"react":"gVheC","react-dom":"d8jlt","@radix-ui/react-compose-refs":"9IC1Z","@radix-ui/react-use-layout-effect":"9XQ43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53ujc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignIn", ()=>g);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _viewMjs = require("../../../primitives/View/View.mjs");
var _visuallyHiddenMjs = require("../../../primitives/VisuallyHidden/VisuallyHidden.mjs");
var _federatedSignInMjs = require("../FederatedSignIn/FederatedSignIn.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
const { getSignInText: c, getSigningInText: p, getForgotPasswordText: f } = (0, _ui.authenticatorTextUtil);
function g() {
    const { isPending: t } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), { handleChange: f, handleSubmit: E } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { SignIn: { Header: F = g.Header, Footer: h = g.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _viewMjs.View), null, (0, _reactDefault.default).createElement(F, null), (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: E,
        onChange: f
    }, (0, _reactDefault.default).createElement((0, _federatedSignInMjs.FederatedSignIn), null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: t
    }, (0, _reactDefault.default).createElement((0, _visuallyHiddenMjs.VisuallyHidden), null, (0, _reactDefault.default).createElement("legend", null, c())), (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null)), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        isDisabled: t,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: t,
        loadingText: p()
    }, c()))), (0, _reactDefault.default).createElement(h, null));
}
g.Footer = ()=>{
    const { toResetPassword: t } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.toResetPassword
        ]);
    return (0, _reactDefault.default).createElement((0, _viewMjs.View), {
        "data-amplify-footer": ""
    }, (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        fontWeight: "normal",
        onClick: t,
        size: "small",
        variation: "link"
    }, f()));
}, g.Header = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/View/View.mjs":"dfO6K","../../../primitives/VisuallyHidden/VisuallyHidden.mjs":"1nS3d","../FederatedSignIn/FederatedSignIn.mjs":"2GxY3","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/FormFields.mjs":"9Dm78","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2GxY3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FederatedSignIn", ()=>c);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _dividerMjs = require("../../../primitives/Divider/Divider.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _federatedSignInButtonMjs = require("./FederatedSignInButtons/FederatedSignInButton.mjs");
const { getSignInWithFederationText: m, getOrText: s } = (0, _ui.authenticatorTextUtil);
function c() {
    const { route: o, socialProviders: c } = (0, _uiReactCore.useAuthenticator)(({ route: e, socialProviders: t })=>[
            e,
            t
        ]);
    return 0 === c.length ? null : (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column",
        padding: "0 0 1rem 0",
        className: "federated-sign-in-container"
    }, c.map((r)=>{
        switch(r){
            case "amazon":
                return (0, _reactDefault.default).createElement((0, _federatedSignInButtonMjs.FederatedSignInButton), {
                    icon: "amazon",
                    key: r,
                    provider: (0, _ui.FederatedIdentityProviders).Amazon,
                    text: m(o, r)
                });
            case "apple":
                return (0, _reactDefault.default).createElement((0, _federatedSignInButtonMjs.FederatedSignInButton), {
                    icon: "apple",
                    key: r,
                    provider: (0, _ui.FederatedIdentityProviders).Apple,
                    text: m(o, r)
                });
            case "facebook":
                return (0, _reactDefault.default).createElement((0, _federatedSignInButtonMjs.FederatedSignInButton), {
                    icon: "facebook",
                    key: r,
                    provider: (0, _ui.FederatedIdentityProviders).Facebook,
                    text: m(o, r)
                });
            case "google":
                return (0, _reactDefault.default).createElement((0, _federatedSignInButtonMjs.FederatedSignInButton), {
                    icon: "google",
                    key: r,
                    provider: (0, _ui.FederatedIdentityProviders).Google,
                    text: m(o, r)
                });
            default:
                console.error(`Authenticator does not support ${r}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, _reactDefault.default).createElement((0, _dividerMjs.Divider), {
        size: "small",
        label: s()
    }));
}

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Divider/Divider.mjs":"gKjLe","../../../primitives/Flex/Flex.mjs":"49y3m","@aws-amplify/ui-react-core":"cZFwB","./FederatedSignInButtons/FederatedSignInButton.mjs":"95H2p","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gKjLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Divider", ()=>o);
var _tslib = require("tslib");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const o = _react.forwardRef((o, m)=>{
    var { className: l, orientation: n = "horizontal", size: c, label: d } = o, f = (0, _tslib.__rest)(o, [
        "className",
        "orientation",
        "size",
        "label"
    ]);
    const p = (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Divider, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Divider, n), (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Divider, c), d ? (0, _constantsMjs.ComponentClassNames).DividerLabel : null, l);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        "aria-orientation": n,
        as: "hr",
        className: p,
        "data-size": c,
        "data-label": d,
        ref: m
    }, f));
});
o.displayName = "Divider";

},{"tslib":"86BcK","classnames":"6P5cq","react":"gVheC","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"95H2p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FederatedSignInButton", ()=>m);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _buttonMjs = require("../../../../primitives/Button/Button.mjs");
var _iconMjs = require("../../../../primitives/Icon/Icon.mjs");
var _iconsContextMjs = require("../../../../primitives/Icon/context/IconsContext.mjs");
var _tslib = require("tslib");
var _classnames = require("classnames");
var _constantsMjs = require("../../../../primitives/shared/constants.mjs");
var _viewMjs = require("../../../../primitives/View/View.mjs");
var _textMjs = require("../../../../primitives/Text/Text.mjs");
const n = ()=>(0, _reactDefault.default).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    })), r = ()=>(0, _reactDefault.default).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    })), o = ()=>(0, _reactDefault.default).createElement((0, _iconMjs.Icon), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    }), c = ()=>(0, _reactDefault.default).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    })), m = (l)=>{
    const { icon: m, provider: s, text: p } = l, { toFederatedSignIn: C } = (0, _uiReactCore.useAuthenticator)();
    let d;
    return "facebook" === m ? d = (0, _reactDefault.default).createElement(o, null) : "google" === m ? d = (0, _reactDefault.default).createElement(r, null) : "amazon" === m ? d = (0, _reactDefault.default).createElement(c, null) : "apple" === m && (d = (0, _reactDefault.default).createElement(n, null)), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        onClick: (e)=>{
            e.preventDefault(), C({
                provider: s
            });
        },
        className: "federated-sign-in-button",
        fontWeight: "normal",
        gap: "1rem"
    }, d, (0, _reactDefault.default).createElement((0, _textMjs.Text), {
        as: "span"
    }, p));
};

},{"react":"gVheC","@aws-amplify/ui-react-core":"cZFwB","../../../../primitives/Button/Button.mjs":"4aRAq","../../../../primitives/Icon/Icon.mjs":"a3e7v","../../../../primitives/Icon/context/IconsContext.mjs":"enrlS","tslib":"86BcK","classnames":"6P5cq","../../../../primitives/shared/constants.mjs":"aQd5e","../../../../primitives/View/View.mjs":"dfO6K","../../../../primitives/Text/Text.mjs":"bYgXO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Erpu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignUp", ()=>p);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _viewMjs = require("../../../primitives/View/View.mjs");
var _federatedSignInMjs = require("../FederatedSignIn/FederatedSignIn.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
const { getCreateAccountText: d, getCreatingAccountText: c } = (0, _ui.authenticatorTextUtil);
function p() {
    const { hasValidationErrors: t, isPending: u } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.hasValidationErrors,
            e.isPending
        ]), { handleChange: f, handleBlur: F, handleSubmit: g } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { SignUp: { Header: h = p.Header, FormFields: E = p.FormFields, Footer: j = p.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _viewMjs.View), null, (0, _reactDefault.default).createElement(h, null), (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: f,
        onSubmit: g,
        onBlur: F
    }, (0, _reactDefault.default).createElement((0, _federatedSignInMjs.FederatedSignIn), null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement(E, null), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null)), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        isDisabled: t || u,
        isFullWidth: !0,
        type: "submit",
        variation: "primary",
        isLoading: u,
        loadingText: c()
    }, d()))), (0, _reactDefault.default).createElement(j, null));
}
p.Header = function() {
    return null;
}, p.FormFields = function() {
    return (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null);
}, p.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/View/View.mjs":"dfO6K","../FederatedSignIn/FederatedSignIn.mjs":"2GxY3","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/FormFields.mjs":"9Dm78","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ADLu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmVerifyUser", ()=>p);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _twoButtonSubmitFooterMjs = require("../shared/TwoButtonSubmitFooter.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getAccountRecoveryInfoText: u, getSkipText: f } = (0, _ui.authenticatorTextUtil), p = ({ className: t, variation: r })=>{
    const { isPending: u } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), { handleChange: d, handleSubmit: h } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ConfirmVerifyUser: { Header: E = p.Header, Footer: F = p.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: r
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: d,
        onSubmit: h
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, _reactDefault.default).createElement(E, null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null)), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _twoButtonSubmitFooterMjs.TwoButtonSubmitFooter), {
        cancelButtonText: f(),
        cancelButtonSendType: "SKIP"
    }), (0, _reactDefault.default).createElement(F, null))));
};
p.Header = function() {
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 3
    }, u());
}, p.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/TwoButtonSubmitFooter.mjs":"kbW1k","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kbW1k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TwoButtonSubmitFooter", ()=>o);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _buttonMjs = require("../../../primitives/Button/Button.mjs");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
const { getSubmitText: a, getSubmittingText: m } = (0, _ui.authenticatorTextUtil), o = (t)=>{
    const { cancelButtonSendType: o, cancelButtonText: l, submitButtonText: c } = t, { isPending: s, resendCode: u, skipVerification: p, toSignIn: f } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), g = s ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, m(), "\u2026") : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, a()), b = null != c ? c : g;
    return (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        fontWeight: "normal",
        variation: "primary",
        isDisabled: s,
        type: "submit"
    }, b), (0, _reactDefault.default).createElement((0, _buttonMjs.Button), {
        onClick: ()=>{
            switch(o){
                case "SKIP":
                    p();
                    break;
                case "RESEND":
                    u();
                    break;
                case "SIGN_IN":
                    f();
                    break;
                default:
                    return;
            }
        },
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, l));
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","@aws-amplify/ui-react-core":"cZFwB","../../../primitives/Button/Button.mjs":"4aRAq","../../../primitives/Flex/Flex.mjs":"49y3m","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Cf4r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerifyUser", ()=>b);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _radioMjs = require("../../../primitives/Radio/Radio.mjs");
var _radioGroupFieldMjs = require("../../../primitives/RadioGroupField/RadioGroupField.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _twoButtonSubmitFooterMjs = require("../shared/TwoButtonSubmitFooter.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getSkipText: v, getVerifyText: E, getVerifyContactText: h, getAccountRecoveryInfoText: y } = (0, _ui.authenticatorTextUtil), F = (t)=>Object.entries(t).map(([t, m])=>(0, _reactDefault.default).createElement((0, _radioMjs.Radio), {
            name: "unverifiedAttr",
            value: t,
            key: t
        }, ((e, t)=>{
            const r = (0, _ui.translate)(e);
            let m = t;
            if ("Phone Number" === e) m = (0, _ui.censorPhoneNumber)(t);
            else if ("Email" === e) {
                const e = t.split("@");
                m = `${(0, _ui.censorAllButFirstAndLast)(e[0])}@${e[1]}`;
            }
            return `${r}: ${m}`;
        })((0, _ui.defaultFormFieldOptions)[t].label, m))), b = ({ className: t, variation: r })=>{
    const { components: { VerifyUser: { Header: o = b.Header, Footer: n = b.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)(), { isPending: i, unverifiedContactMethods: a } = (0, _uiReactCore.useAuthenticator)(({ isPending: e, unverifiedContactMethods: t })=>[
            e,
            t
        ]), { handleChange: l, handleSubmit: y } = (0, _useFormHandlersMjs.useFormHandlers)(), C = i ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "Verifying\u2026") : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, E()), j = (0, _reactDefault.default).createElement((0, _radioGroupFieldMjs.RadioGroupField), {
        label: h(),
        labelHidden: !0,
        name: "verify_context",
        isDisabled: i
    }, F(a));
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: r
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: l,
        onSubmit: y
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: i
    }, (0, _reactDefault.default).createElement(o, null), j, (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _twoButtonSubmitFooterMjs.TwoButtonSubmitFooter), {
        cancelButtonText: v(),
        cancelButtonSendType: "SKIP",
        submitButtonText: C
    }), (0, _reactDefault.default).createElement(n, null))));
};
b.Header = function() {
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 3
    }, y());
}, b.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","../../../primitives/Radio/Radio.mjs":"3904l","../../../primitives/RadioGroupField/RadioGroupField.mjs":"039Bp","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/TwoButtonSubmitFooter.mjs":"kbW1k","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3904l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radio", ()=>c);
parcelHelpers.export(exports, "RadioPrimitive", ()=>p);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _inputMjs = require("../Input/Input.mjs");
var _textMjs = require("../Text/Text.mjs");
var _contextMjs = require("../RadioGroupField/context.mjs");
var _useFieldsetMjs = require("../Fieldset/useFieldset.mjs");
const p = (p, c)=>{
    var { children: h, className: u, id: b, isDisabled: f, testId: R, value: g, labelPosition: v, height: j, width: N, bottom: x, left: y, position: E, padding: F, right: I, top: w } = p, D = (0, _tslib.__rest)(p, [
        "children",
        "className",
        "id",
        "isDisabled",
        "testId",
        "value",
        "labelPosition",
        "height",
        "width",
        "bottom",
        "left",
        "position",
        "padding",
        "right",
        "top"
    ]);
    const { currentValue: C, defaultValue: O, name: P, hasError: V, isGroupDisabled: k, isRequired: q, isReadOnly: z, onChange: B, size: G, labelPosition: T } = (0, _contextMjs.useRadioGroupContext)(), { isFieldsetDisabled: H } = (0, _useFieldsetMjs.useFieldset)(), L = H || k || f || z && O !== g, A = void 0 !== C ? g === C : void 0, J = void 0 !== O ? g === O : void 0, K = v || T;
    return _react.createElement((0, _flexMjs.Flex), {
        as: "label",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Radio, (0, _ui.classNameModifierByFlag)((0, _constantsMjs.ComponentClassNames).Radio, "disabled", L), u),
        "data-disabled": L,
        "data-label-position": K,
        height: j,
        width: N,
        bottom: x,
        top: w,
        right: I,
        left: y,
        position: E,
        padding: F
    }, h && _react.createElement((0, _textMjs.Text), {
        as: "span",
        className: (0, _constantsMjs.ComponentClassNames).RadioLabel,
        "data-disabled": L
    }, h), _react.createElement((0, _inputMjs.Input), Object.assign({
        checked: A,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).VisuallyHidden, (0, _constantsMjs.ComponentClassNames).RadioInput),
        defaultChecked: J,
        hasError: V,
        id: b,
        isDisabled: L,
        isReadOnly: z,
        isRequired: q,
        onChange: B,
        ref: c,
        type: "radio",
        name: P,
        value: g
    }, D)), _react.createElement((0, _flexMjs.Flex), {
        "aria-hidden": "true",
        as: "span",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).RadioButton, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).RadioButton, G)),
        "data-size": G,
        testId: R
    }));
}, c = _react.forwardRef(p);
c.displayName = "Radio";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Flex/Flex.mjs":"49y3m","../Input/Input.mjs":"ab7IK","../Text/Text.mjs":"bYgXO","../RadioGroupField/context.mjs":"e0coR","../Fieldset/useFieldset.mjs":"e0bLb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e0coR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupContext", ()=>o);
parcelHelpers.export(exports, "useRadioGroupContext", ()=>r);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const o = (0, _reactDefault.default).createContext({
    name: "default"
}), r = ()=>(0, _react.useContext)(o);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"039Bp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupField", ()=>c);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _ui = require("@aws-amplify/ui");
var _constantsMjs = require("../shared/constants.mjs");
var _fieldClearButtonMjs = require("../Field/FieldClearButton.mjs");
var _fieldDescriptionMjs = require("../Field/FieldDescription.mjs");
var _fieldErrorMessageMjs = require("../Field/FieldErrorMessage.mjs");
var _fieldMjs = require("../Field/Field.mjs");
var _flexMjs = require("../Flex/Flex.mjs");
var _labelMjs = require("../Label/Label.mjs");
var _visuallyHiddenMjs = require("../VisuallyHidden/VisuallyHidden.mjs");
var _contextMjs = require("./context.mjs");
var _getTestIdMjs = require("../utils/getTestId.mjs");
var _useStableIdMjs = require("../utils/useStableId.mjs");
const c = _react.forwardRef((c, f)=>{
    var { children: b, className: F, defaultValue: j, descriptiveText: E, errorMessage: g, hasError: h = !1, id: R, isDisabled: v, isRequired: y, isReadOnly: x, label: H, labelHidden: I = !1, labelPosition: V, onChange: G, name: M, size: N, testId: z, value: C } = c, D = (0, _tslib.__rest)(c, [
        "children",
        "className",
        "defaultValue",
        "descriptiveText",
        "errorMessage",
        "hasError",
        "id",
        "isDisabled",
        "isRequired",
        "isReadOnly",
        "label",
        "labelHidden",
        "labelPosition",
        "onChange",
        "name",
        "size",
        "testId",
        "value"
    ]);
    const O = (0, _useStableIdMjs.useStableId)(R), P = (0, _useStableIdMjs.useStableId)(), T = E ? P : void 0, q = (0, _getTestIdMjs.getTestId)(z, (0, _constantsMjs.ComponentClassNames).RadioGroup), w = _react.useMemo(()=>({
            currentValue: C,
            defaultValue: j,
            hasError: h,
            isRequired: y,
            isReadOnly: x,
            isGroupDisabled: v,
            onChange: G,
            size: N,
            name: M,
            labelPosition: V
        }), [
        j,
        h,
        v,
        y,
        x,
        G,
        N,
        M,
        C,
        V
    ]);
    return _react.createElement((0, _flexMjs.Flex), Object.assign({
        as: "fieldset",
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Field, (0, _ui.classNameModifier)((0, _constantsMjs.ComponentClassNames).Field, N), (0, _constantsMjs.ComponentClassNames).RadioGroupField, F),
        "data-size": N,
        ref: f,
        role: "radiogroup",
        testId: z
    }, D), _react.createElement((0, _visuallyHiddenMjs.VisuallyHidden), {
        as: "legend"
    }, H), _react.createElement((0, _labelMjs.Label), {
        "aria-hidden": !0,
        visuallyHidden: I
    }, H), _react.createElement((0, _fieldDescriptionMjs.FieldDescription), {
        id: P,
        labelHidden: I,
        descriptiveText: E
    }), _react.createElement((0, _flexMjs.Flex), {
        "aria-describedby": T,
        className: (0, _constantsMjs.ComponentClassNames).RadioGroup,
        id: O,
        testId: q
    }, _react.createElement((0, _contextMjs.RadioGroupContext).Provider, {
        value: w
    }, b)), _react.createElement((0, _fieldErrorMessageMjs.FieldErrorMessage), {
        hasError: h,
        errorMessage: g
    }));
});
c.displayName = "RadioGroupField";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","@aws-amplify/ui":"2NgwQ","../shared/constants.mjs":"aQd5e","../Field/FieldClearButton.mjs":"hLrLW","../Field/FieldDescription.mjs":"2ewNp","../Field/FieldErrorMessage.mjs":"eFojV","../Field/Field.mjs":"8m82z","../Flex/Flex.mjs":"49y3m","../Label/Label.mjs":"5r556","../VisuallyHidden/VisuallyHidden.mjs":"1nS3d","./context.mjs":"e0coR","../utils/getTestId.mjs":"foo4B","../utils/useStableId.mjs":"aArLN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"foo4B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTestId", ()=>o);
const o = (o, t)=>o && t ? `${o}-${t}` : void 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"905Pq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmSignIn", ()=>f);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _confirmSignInFooterMjs = require("../shared/ConfirmSignInFooter.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getChallengeText: u } = (0, _ui.authenticatorTextUtil), f = ({ className: r, variation: t })=>{
    const { isPending: u } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), { handleChange: d, handleSubmit: p } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ConfirmSignIn: { Header: g = f.Header, Footer: h = f.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: r,
        variation: t
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: d,
        onSubmit: p
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: u
    }, (0, _reactDefault.default).createElement(g, null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null)), (0, _reactDefault.default).createElement((0, _confirmSignInFooterMjs.ConfirmSignInFooter), null), (0, _reactDefault.default).createElement(h, null))));
};
f.Header = function() {
    const { user: { challengeName: r } } = (0, _uiReactCore.useAuthenticator)(({ user: e })=>[
            e
        ]);
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 3
    }, u(r));
}, f.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/FormFields.mjs":"9Dm78","../shared/ConfirmSignInFooter.mjs":"9OmYv","../shared/RemoteErrorMessage.mjs":"dGudN","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4YMpS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmResetPassword", ()=>p);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _twoButtonSubmitFooterMjs = require("../shared/TwoButtonSubmitFooter.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getResendCodeText: c, getResetYourPasswordText: d } = (0, _ui.authenticatorTextUtil), p = ({ className: t, variation: r })=>{
    const { isPending: d } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), { handleBlur: f, handleChange: E, handleSubmit: h } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ConfirmResetPassword: { Header: C = p.Header, Footer: F = p.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: r
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: h,
        onChange: E,
        onBlur: f
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: d
    }, (0, _reactDefault.default).createElement(C, null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null)), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _twoButtonSubmitFooterMjs.TwoButtonSubmitFooter), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: c()
    }), (0, _reactDefault.default).createElement(F, null))));
};
p.Header = function() {
    const t = d();
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 3
    }, t);
}, p.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/TwoButtonSubmitFooter.mjs":"kbW1k","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"klVJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetPassword", ()=>g);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ui = require("@aws-amplify/ui");
var _flexMjs = require("../../../primitives/Flex/Flex.mjs");
var _headingMjs = require("../../../primitives/Heading/Heading.mjs");
var _uiReactCore = require("@aws-amplify/ui-react-core");
var _useCustomComponentsMjs = require("../hooks/useCustomComponents/useCustomComponents.mjs");
var _useFormHandlersMjs = require("../hooks/useFormHandlers/useFormHandlers.mjs");
var _remoteErrorMessageMjs = require("../shared/RemoteErrorMessage.mjs");
var _twoButtonSubmitFooterMjs = require("../shared/TwoButtonSubmitFooter.mjs");
var _formFieldsMjs = require("../shared/FormFields.mjs");
var _routeContainerMjs = require("../RouteContainer/RouteContainer.mjs");
const { getBackToSignInText: c, getSendingText: d, getSendCodeText: p, getResetYourPasswordText: f } = (0, _ui.authenticatorTextUtil), g = ({ className: t, variation: r })=>{
    const { isPending: f } = (0, _uiReactCore.useAuthenticator)((e)=>[
            e.isPending
        ]), { handleChange: E, handleSubmit: F } = (0, _useFormHandlersMjs.useFormHandlers)(), { components: { ResetPassword: { Header: h = g.Header, Footer: x = g.Footer } } } = (0, _useCustomComponentsMjs.useCustomComponents)();
    return (0, _reactDefault.default).createElement((0, _routeContainerMjs.RouteContainer), {
        className: t,
        variation: r
    }, (0, _reactDefault.default).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-resetpassword": "",
        method: "post",
        onChange: E,
        onSubmit: F
    }, (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        as: "fieldset",
        direction: "column",
        isDisabled: f
    }, (0, _reactDefault.default).createElement(h, null), (0, _reactDefault.default).createElement((0, _flexMjs.Flex), {
        direction: "column"
    }, (0, _reactDefault.default).createElement((0, _formFieldsMjs.FormFields), null)), (0, _reactDefault.default).createElement((0, _remoteErrorMessageMjs.RemoteErrorMessage), null), (0, _reactDefault.default).createElement((0, _twoButtonSubmitFooterMjs.TwoButtonSubmitFooter), {
        cancelButtonText: c(),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: f ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, d(), "\u2026") : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, p())
    }), (0, _reactDefault.default).createElement(x, null))));
};
g.Header = function() {
    return (0, _reactDefault.default).createElement((0, _headingMjs.Heading), {
        level: 3
    }, f());
}, g.Footer = function() {
    return null;
};

},{"react":"gVheC","@aws-amplify/ui":"2NgwQ","../../../primitives/Flex/Flex.mjs":"49y3m","../../../primitives/Heading/Heading.mjs":"bQHrE","@aws-amplify/ui-react-core":"cZFwB","../hooks/useCustomComponents/useCustomComponents.mjs":"gsuPw","../hooks/useFormHandlers/useFormHandlers.mjs":"5gEf2","../shared/RemoteErrorMessage.mjs":"dGudN","../shared/TwoButtonSubmitFooter.mjs":"kbW1k","../shared/FormFields.mjs":"9Dm78","../RouteContainer/RouteContainer.mjs":"SZ75J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KlLE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSignInOrSignUpRoute", ()=>n);
const n = (n)=>"signIn" === n || "signUp" === n;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8mceg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultComponents", ()=>a);
var _signInMjs = require("../../SignIn/SignIn.mjs");
var _signUpMjs = require("../../SignUp/SignUp.mjs");
var _confirmSignUpMjs = require("../../ConfirmSignUp/ConfirmSignUp.mjs");
var _forceNewPasswordMjs = require("../../ForceNewPassword/ForceNewPassword.mjs");
var _setupTOTPMjs = require("../../SetupTOTP/SetupTOTP.mjs");
var _confirmSignInMjs = require("../../ConfirmSignIn/ConfirmSignIn.mjs");
var _confirmVerifyUserMjs = require("../../VerifyUser/ConfirmVerifyUser.mjs");
var _verifyUserMjs = require("../../VerifyUser/VerifyUser.mjs");
var _confirmResetPasswordMjs = require("../../ResetPassword/ConfirmResetPassword.mjs");
var _resetPasswordMjs = require("../../ResetPassword/ResetPassword.mjs");
const a = {
    Header: ()=>null,
    SignIn: {
        Header: (0, _signInMjs.SignIn).Header,
        Footer: (0, _signInMjs.SignIn).Footer
    },
    SignUp: {
        Header: (0, _signUpMjs.SignUp).Header,
        FormFields: (0, _signUpMjs.SignUp).FormFields,
        Footer: (0, _signUpMjs.SignUp).Footer
    },
    ConfirmSignUp: {
        Header: (0, _confirmSignUpMjs.ConfirmSignUp).Header,
        Footer: (0, _confirmSignUpMjs.ConfirmSignUp).Footer
    },
    SetupTOTP: {
        Header: (0, _setupTOTPMjs.SetupTOTP).Header,
        Footer: (0, _setupTOTPMjs.SetupTOTP).Footer
    },
    ConfirmResetPassword: {
        Header: (0, _confirmResetPasswordMjs.ConfirmResetPassword).Header,
        Footer: (0, _confirmResetPasswordMjs.ConfirmResetPassword).Footer
    },
    ConfirmSignIn: {
        Header: (0, _confirmSignInMjs.ConfirmSignIn).Header,
        Footer: (0, _confirmSignInMjs.ConfirmSignIn).Footer
    },
    VerifyUser: {
        Header: (0, _verifyUserMjs.VerifyUser).Header,
        Footer: (0, _verifyUserMjs.VerifyUser).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, _confirmVerifyUserMjs.ConfirmVerifyUser).Header,
        Footer: (0, _confirmVerifyUserMjs.ConfirmVerifyUser).Footer
    },
    ForceNewPassword: {
        Header: (0, _forceNewPasswordMjs.ForceNewPassword).Header,
        Footer: (0, _forceNewPasswordMjs.ForceNewPassword).Footer,
        FormFields: (0, _forceNewPasswordMjs.ForceNewPassword).FormFields
    },
    ResetPassword: {
        Header: (0, _resetPasswordMjs.ResetPassword).Header,
        Footer: (0, _resetPasswordMjs.ResetPassword).Footer
    },
    Footer: ()=>null
};

},{"../../SignIn/SignIn.mjs":"53ujc","../../SignUp/SignUp.mjs":"1Erpu","../../ConfirmSignUp/ConfirmSignUp.mjs":"WY5no","../../ForceNewPassword/ForceNewPassword.mjs":"wtNsH","../../SetupTOTP/SetupTOTP.mjs":"kz4YC","../../ConfirmSignIn/ConfirmSignIn.mjs":"905Pq","../../VerifyUser/ConfirmVerifyUser.mjs":"5ADLu","../../VerifyUser/VerifyUser.mjs":"1Cf4r","../../ResetPassword/ConfirmResetPassword.mjs":"4YMpS","../../ResetPassword/ResetPassword.mjs":"klVJ1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"726cS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplifyProvider", ()=>n);
parcelHelpers.export(exports, "ThemeProvider", ()=>a);
var _react = require("react");
var _reactDirection = require("@radix-ui/react-direction");
var _ui = require("@aws-amplify/ui");
var _amplifyContextMjs = require("./AmplifyContext.mjs");
const { DirectionProvider: m } = (0, _ui.sanitizeNamespaceImport)(_reactDirection);
function n({ children: t, colorMode: r, direction: n = "ltr", nonce: a, theme: l }) {
    const c = _react.useMemo(()=>({
            theme: (0, _ui.createTheme)(l)
        }), [
        l
    ]), { theme: { name: d, cssText: s } } = c;
    return _react.createElement((0, _amplifyContextMjs.AmplifyContext).Provider, {
        value: c
    }, _react.createElement(m, {
        dir: n
    }, _react.createElement("div", {
        "data-amplify-theme": d,
        "data-amplify-color-mode": r,
        dir: n
    }, t), void 0 === l || /<\/style/i.test(s) ? null : _react.createElement("style", {
        id: `amplify-theme-${d}`,
        dangerouslySetInnerHTML: {
            __html: s
        },
        nonce: a
    })));
}
const a = n;

},{"react":"gVheC","@radix-ui/react-direction":"kpsjk","@aws-amplify/ui":"2NgwQ","./AmplifyContext.mjs":"dXMi7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f1URh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Image", ()=>t);
var _tslib = require("tslib");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _constantsMjs = require("../shared/constants.mjs");
var _viewMjs = require("../View/View.mjs");
const t = _react.forwardRef((t, o)=>{
    var { className: i } = t, c = (0, _tslib.__rest)(t, [
        "className"
    ]);
    return _react.createElement((0, _viewMjs.View), Object.assign({
        as: "img",
        ref: o,
        className: (0, _classnamesDefault.default)((0, _constantsMjs.ComponentClassNames).Image, i)
    }, c));
});
t.displayName = "Image";

},{"tslib":"86BcK","react":"gVheC","classnames":"6P5cq","../shared/constants.mjs":"aQd5e","../View/View.mjs":"dfO6K","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7zW2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _awsAmplify = require("aws-amplify");
var _styles = require("@mui/material/styles");
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
var _notistack = require("notistack");
var _awsExportsJs = require("./aws-exports.js");
var _awsExportsJsDefault = parcelHelpers.interopDefault(_awsExportsJs);
var _components = require("./components");
var _routes = require("./routes");
var _hooks = require("./hooks");
const isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
const redirectURI = isLocalhost ? "http://localhost:1234/" : `https://${window.location.hostname}/`;
const updatedAwsConfig = {
    ...(0, _awsExportsJsDefault.default),
    oauth: {
        ...(0, _awsExportsJsDefault.default).oauth,
        redirectSignIn: redirectURI,
        redirectSignOut: redirectURI
    }
};
(0, _dateFns.setDefaultOptions)({
    locale: (0, _locale.enGB),
    weekStartsOn: 1
});
(0, _awsAmplify.Amplify).configure(updatedAwsConfig);
const theme = (0, _styles.createTheme)();
const queryClient = new (0, _reactQuery.QueryClient)();
const App = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styles.ThemeProvider), {
        theme: theme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
            client: queryClient,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hooks.UserProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notistack.SnackbarProvider), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalProvider), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routes.Routing), {})
                    })
                })
            })
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","aws-amplify":"75VoS","@mui/material/styles":"gNR9m","@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","date-fns/locale":"1QVlm","notistack":"3Lc8y","./aws-exports.js":"kAvZY","./components":"0272J","./routes":"fUo4r","./hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gNR9m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THEME_ID", ()=>(0, _identifierDefault.default));
parcelHelpers.export(exports, "adaptV4Theme", ()=>(0, _adaptV4ThemeDefault.default));
parcelHelpers.export(exports, "hexToRgb", ()=>(0, _system.hexToRgb));
parcelHelpers.export(exports, "rgbToHex", ()=>(0, _system.rgbToHex));
parcelHelpers.export(exports, "hslToRgb", ()=>(0, _system.hslToRgb));
parcelHelpers.export(exports, "decomposeColor", ()=>(0, _system.decomposeColor));
parcelHelpers.export(exports, "recomposeColor", ()=>(0, _system.recomposeColor));
parcelHelpers.export(exports, "getContrastRatio", ()=>(0, _system.getContrastRatio));
parcelHelpers.export(exports, "getLuminance", ()=>(0, _system.getLuminance));
parcelHelpers.export(exports, "emphasize", ()=>(0, _system.emphasize));
parcelHelpers.export(exports, "alpha", ()=>(0, _system.alpha));
parcelHelpers.export(exports, "darken", ()=>(0, _system.darken));
parcelHelpers.export(exports, "lighten", ()=>(0, _system.lighten));
parcelHelpers.export(exports, "css", ()=>(0, _system.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _system.keyframes));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createMuiTheme", ()=>(0, _createTheme.createMuiTheme));
parcelHelpers.export(exports, "unstable_createMuiStrictModeTheme", ()=>(0, _createMuiStrictModeThemeDefault.default));
parcelHelpers.export(exports, "createStyles", ()=>(0, _createStylesDefault.default));
parcelHelpers.export(exports, "unstable_getUnit", ()=>(0, _cssUtils.getUnit));
parcelHelpers.export(exports, "unstable_toUnitless", ()=>(0, _cssUtils.toUnitless));
parcelHelpers.export(exports, "responsiveFontSizes", ()=>(0, _responsiveFontSizesDefault.default));
parcelHelpers.export(exports, "duration", ()=>(0, _createTransitions.duration));
parcelHelpers.export(exports, "easing", ()=>(0, _createTransitions.easing));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "experimentalStyled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _system.StyledEngineProvider));
// The legacy utilities from @mui/styles
// These are just empty functions that throws when invoked
parcelHelpers.export(exports, "makeStyles", ()=>(0, _makeStylesDefault.default));
parcelHelpers.export(exports, "withStyles", ()=>(0, _withStylesDefault.default));
parcelHelpers.export(exports, "withTheme", ()=>(0, _withThemeDefault.default));
parcelHelpers.export(exports, "experimental_extendTheme", ()=>(0, _experimentalExtendThemeDefault.default));
parcelHelpers.export(exports, "getOverlayAlpha", ()=>(0, _getOverlayAlphaDefault.default));
parcelHelpers.export(exports, "shouldSkipGeneratingVar", ()=>(0, _shouldSkipGeneratingVarDefault.default));
// Private methods for creating parts of the theme
parcelHelpers.export(exports, "private_createTypography", ()=>(0, _createTypographyDefault.default));
parcelHelpers.export(exports, "private_createMixins", ()=>(0, _createMixinsDefault.default));
parcelHelpers.export(exports, "private_excludeVariablesFromRoot", ()=>(0, _excludeVariablesFromRootDefault.default));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _adaptV4Theme = require("./adaptV4Theme");
var _adaptV4ThemeDefault = parcelHelpers.interopDefault(_adaptV4Theme);
var _system = require("@mui/system");
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createMuiStrictModeTheme = require("./createMuiStrictModeTheme");
var _createMuiStrictModeThemeDefault = parcelHelpers.interopDefault(_createMuiStrictModeTheme);
var _createStyles = require("./createStyles");
var _createStylesDefault = parcelHelpers.interopDefault(_createStyles);
var _cssUtils = require("./cssUtils");
var _responsiveFontSizes = require("./responsiveFontSizes");
var _responsiveFontSizesDefault = parcelHelpers.interopDefault(_responsiveFontSizes);
var _createTransitions = require("./createTransitions");
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _makeStyles = require("./makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _withStyles = require("./withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);
var _withTheme = require("./withTheme");
var _withThemeDefault = parcelHelpers.interopDefault(_withTheme);
var _cssVarsProvider = require("./CssVarsProvider");
parcelHelpers.exportAll(_cssVarsProvider, exports);
var _experimentalExtendTheme = require("./experimental_extendTheme");
var _experimentalExtendThemeDefault = parcelHelpers.interopDefault(_experimentalExtendTheme);
var _getOverlayAlpha = require("./getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _shouldSkipGeneratingVar = require("./shouldSkipGeneratingVar");
var _shouldSkipGeneratingVarDefault = parcelHelpers.interopDefault(_shouldSkipGeneratingVar);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _excludeVariablesFromRoot = require("./excludeVariablesFromRoot");
var _excludeVariablesFromRootDefault = parcelHelpers.interopDefault(_excludeVariablesFromRoot);
"use client";
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"h4Lns","./identifier":false,"./adaptV4Theme":false,"@mui/system":"gwZXT","./createTheme":"4WEqq","./createMuiStrictModeTheme":false,"./createStyles":false,"./cssUtils":"82gdb","./responsiveFontSizes":false,"./createTransitions":false,"./useTheme":"6UMPc","./useThemeProps":"4dkr8","./styled":"jvcDu","./ThemeProvider":"3da5Z","./makeStyles":false,"./withStyles":false,"./withTheme":false,"./CssVarsProvider":false,"./experimental_extendTheme":false,"./getOverlayAlpha":false,"./shouldSkipGeneratingVar":false,"./createTypography":false,"./createMixins":false,"./excludeVariablesFromRoot":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h4Lns":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formatMuiErrorMessageDefault.default));
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);

},{"./formatMuiErrorMessage":"iyBCq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iyBCq":[function(require,module,exports) {
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatMuiErrorMessage);
function formatMuiErrorMessage(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3AQ3O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = "$$material";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gwZXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>(0, _styledEngine.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _styledEngine.keyframes));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngine.StyledEngineProvider));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "borders", ()=>(0, _bordersDefault.default));
parcelHelpers.export(exports, "breakpoints", ()=>(0, _breakpointsDefault.default));
parcelHelpers.export(exports, "handleBreakpoints", ()=>(0, _breakpoints.handleBreakpoints));
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>(0, _breakpoints.mergeBreakpointsInOrder));
parcelHelpers.export(exports, "unstable_resolveBreakpointValues", ()=>(0, _breakpoints.resolveBreakpointValues));
parcelHelpers.export(exports, "compose", ()=>(0, _composeDefault.default));
parcelHelpers.export(exports, "display", ()=>(0, _displayDefault.default));
parcelHelpers.export(exports, "flexbox", ()=>(0, _flexboxDefault.default));
parcelHelpers.export(exports, "grid", ()=>(0, _cssGridDefault.default));
parcelHelpers.export(exports, "palette", ()=>(0, _paletteDefault.default));
parcelHelpers.export(exports, "positions", ()=>(0, _positionsDefault.default));
parcelHelpers.export(exports, "shadows", ()=>(0, _shadowsDefault.default));
parcelHelpers.export(exports, "sizing", ()=>(0, _sizingDefault.default));
parcelHelpers.export(exports, "spacing", ()=>(0, _spacingDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "getPath", ()=>(0, _style.getPath));
parcelHelpers.export(exports, "getStyleValue", ()=>(0, _style.getStyleValue));
parcelHelpers.export(exports, "typography", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "unstable_styleFunctionSx", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "unstable_extendSxProp", ()=>(0, _styleFunctionSx.extendSxProp));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _styleFunctionSx.unstable_defaultSxConfig));
parcelHelpers.export(exports, "unstable_getThemeValue", ()=>(0, _getThemeValueDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "createBox", ()=>(0, _createBoxDefault.default));
parcelHelpers.export(exports, "createStyled", ()=>(0, _createStyledDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "createSpacing", ()=>(0, _createSpacingDefault.default));
parcelHelpers.export(exports, "shape", ()=>(0, _shapeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _useThemeProps.getThemeProps));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeWithoutDefault", ()=>(0, _useThemeWithoutDefaultDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsProvider", ()=>(0, _createCssVarsProviderDefault.default));
parcelHelpers.export(exports, "unstable_createGetCssVar", ()=>(0, _createGetCssVarDefault.default));
parcelHelpers.export(exports, "unstable_cssVarsParser", ()=>(0, _cssVarsParserDefault.default));
parcelHelpers.export(exports, "unstable_prepareCssVars", ()=>(0, _prepareCssVarsDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsTheme", ()=>(0, _createCssVarsThemeDefault.default));
parcelHelpers.export(exports, "responsivePropType", ()=>(0, _responsivePropTypeDefault.default));
/** ----------------- */ /** Layout components */ parcelHelpers.export(exports, "createContainer", ()=>(0, _createContainerDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Unstable_Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _styledEngine = require("@mui/styled-engine");
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _borders = require("./borders");
var _bordersDefault = parcelHelpers.interopDefault(_borders);
parcelHelpers.exportAll(_borders, exports);
var _breakpoints = require("./breakpoints");
var _breakpointsDefault = parcelHelpers.interopDefault(_breakpoints);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _display = require("./display");
var _displayDefault = parcelHelpers.interopDefault(_display);
var _flexbox = require("./flexbox");
var _flexboxDefault = parcelHelpers.interopDefault(_flexbox);
parcelHelpers.exportAll(_flexbox, exports);
var _cssGrid = require("./cssGrid");
var _cssGridDefault = parcelHelpers.interopDefault(_cssGrid);
parcelHelpers.exportAll(_cssGrid, exports);
var _palette = require("./palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
parcelHelpers.exportAll(_palette, exports);
var _positions = require("./positions");
var _positionsDefault = parcelHelpers.interopDefault(_positions);
parcelHelpers.exportAll(_positions, exports);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _sizing = require("./sizing");
var _sizingDefault = parcelHelpers.interopDefault(_sizing);
parcelHelpers.exportAll(_sizing, exports);
var _spacing = require("./spacing");
var _spacingDefault = parcelHelpers.interopDefault(_spacing);
parcelHelpers.exportAll(_spacing, exports);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _typography = require("./typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
parcelHelpers.exportAll(_typography, exports);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _getThemeValue = require("./getThemeValue");
var _getThemeValueDefault = parcelHelpers.interopDefault(_getThemeValue);
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _createBox = require("./createBox");
var _createBoxDefault = parcelHelpers.interopDefault(_createBox);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
parcelHelpers.exportAll(_createStyled, exports);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createTheme/createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _createSpacing = require("./createTheme/createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _shape = require("./createTheme/shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _colorManipulator = require("./colorManipulator");
parcelHelpers.exportAll(_colorManipulator, exports);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _createCssVarsProvider = require("./cssVars/createCssVarsProvider");
var _createCssVarsProviderDefault = parcelHelpers.interopDefault(_createCssVarsProvider);
var _createGetCssVar = require("./cssVars/createGetCssVar");
var _createGetCssVarDefault = parcelHelpers.interopDefault(_createGetCssVar);
var _cssVarsParser = require("./cssVars/cssVarsParser");
var _cssVarsParserDefault = parcelHelpers.interopDefault(_cssVarsParser);
var _prepareCssVars = require("./cssVars/prepareCssVars");
var _prepareCssVarsDefault = parcelHelpers.interopDefault(_prepareCssVars);
var _createCssVarsTheme = require("./cssVars/createCssVarsTheme");
var _createCssVarsThemeDefault = parcelHelpers.interopDefault(_createCssVarsTheme);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _createContainer = require("./Container/createContainer");
var _createContainerDefault = parcelHelpers.interopDefault(_createContainer);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
parcelHelpers.exportAll(_container, exports);
var _grid = require("./Unstable_Grid/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _unstableGrid = require("./Unstable_Grid");
parcelHelpers.exportAll(_unstableGrid, exports);
var _stack = require("./Stack/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stack1 = require("./Stack");
parcelHelpers.exportAll(_stack1, exports);
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"h4Lns","@mui/styled-engine":"lDUiA","./GlobalStyles":"crmxt","./borders":false,"./breakpoints":"k4Z23","./compose":false,"./display":false,"./flexbox":false,"./cssGrid":false,"./palette":false,"./positions":false,"./shadows":false,"./sizing":false,"./spacing":false,"./style":false,"./typography":false,"./styleFunctionSx":"5JpQH","./getThemeValue":false,"./Box":false,"./createBox":"bL8d9","./createStyled":"9aQzE","./styled":false,"./createTheme":"ddNIy","./createTheme/createBreakpoints":false,"./createTheme/createSpacing":false,"./createTheme/shape":false,"./useThemeProps":"fF9s8","./useTheme":"4Kwj6","./useThemeWithoutDefault":"91huw","./colorManipulator":"9hsNx","./ThemeProvider":"4pAad","./cssVars/createCssVarsProvider":false,"./cssVars/createGetCssVar":false,"./cssVars/cssVarsParser":false,"./cssVars/prepareCssVars":false,"./cssVars/createCssVarsTheme":false,"./responsivePropType":false,"./Container/createContainer":false,"./Container":false,"./Unstable_Grid/Grid":false,"./Unstable_Grid":false,"./Stack/Stack":false,"./Stack":"hpKov","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lDUiA":[function(require,module,exports) {
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _react.ThemeContext));
parcelHelpers.export(exports, "keyframes", ()=>(0, _react.keyframes));
parcelHelpers.export(exports, "css", ()=>(0, _react.css));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngineProviderDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "default", ()=>styled);
parcelHelpers.export(exports, "internal_processStyles", ()=>internal_processStyles);
/* eslint-disable no-underscore-dangle */ var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
"use client";
function styled(tag, options) {
    const stylesFactory = (0, _styledDefault.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const internal_processStyles = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

},{"@emotion/styled":"fcXHD","@emotion/react":"idTZv","./StyledEngineProvider":false,"./GlobalStyles":"gqY1t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fcXHD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newStyled);
var _emotionStyledBaseBrowserEsmJs = require("../base/dist/emotion-styled-base.browser.esm.js");
var _emotionStyledBaseBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseBrowserEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var newStyled = (0, _emotionStyledBaseBrowserEsmJsDefault.default).bind();
tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
});

},{"../base/dist/emotion-styled-base.browser.esm.js":"6dw8C","@babel/runtime/helpers/extends":"lKkcq","react":"gVheC","@emotion/is-prop-valid":"b6h3I","@emotion/react":"idTZv","@emotion/utils":"i7WO9","@emotion/serialize":"eJeg5","@emotion/use-insertion-effect-with-fallbacks":"j5C20","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6dw8C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, _react1.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react.useContext((0, _react1.ThemeContext));
            }
            if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ _react.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@emotion/is-prop-valid":"b6h3I","@emotion/react":"idTZv","@emotion/utils":"i7WO9","@emotion/serialize":"eJeg5","@emotion/use-insertion-effect-with-fallbacks":"j5C20","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b6h3I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"961va","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"961va":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"idTZv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementC39617D8BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementC39617D8BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementC39617D8BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementC39617D8BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementC39617D8BrowserEsmJs = require("./emotion-element-c39617d8.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElementC39617D8BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementC39617D8BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementC39617D8BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T)));
    if (!(0, _emotionElementC39617D8BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementC39617D8BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementC39617D8BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"./emotion-element-c39617d8.browser.esm.js":"gIrsN","react":"gVheC","@emotion/utils":"i7WO9","@emotion/use-insertion-effect-with-fallbacks":"j5C20","@emotion/serialize":"eJeg5","@emotion/cache":"8xTp1","@babel/runtime/helpers/extends":"lKkcq","@emotion/weak-memoize":"lX8fW","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"bclbL","hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gIrsN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwnProperty);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"gVheC","@emotion/cache":"8xTp1","@babel/runtime/helpers/esm/extends":"d4f7v","@emotion/weak-memoize":"lX8fW","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"bclbL","@emotion/utils":"i7WO9","@emotion/serialize":"eJeg5","@emotion/use-insertion-effect-with-fallbacks":"j5C20","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8xTp1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"4FXTP","stylis":"g41Db","@emotion/weak-memoize":"lX8fW","@emotion/memoize":"961va","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4FXTP":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g41Db":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lX8fW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bclbL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d2C2V":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"jLNEy"}],"jLNEy":[function(require,module,exports) {
"use strict";
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"dtOPO"}],"dtOPO":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"i7WO9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eJeg5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"99Ynz","@emotion/unitless":"2lYut","@emotion/memoize":"961va","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"99Ynz":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2lYut":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j5C20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lKkcq":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"gqY1t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
"use client";

},{"./GlobalStyles":"53AsX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53AsX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalStyles);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Global), {
        styles: globalStyles
    });
}

},{"react":"gVheC","prop-types":"3KNJy","@emotion/react":"idTZv","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3KNJy":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"lOspF"}],"lOspF":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"6Gm2l"}],"6Gm2l":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"crmxt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
parcelHelpers.exportAll(_globalStyles, exports);
"use client";

},{"./GlobalStyles":"eGHJw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eGHJw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _useThemeDefault.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
        styles: globalStyles
    });
}
exports.default = GlobalStyles;

},{"react":"gVheC","prop-types":"3KNJy","@mui/styled-engine":"lDUiA","../useTheme":"4Kwj6","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Kwj6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
"use client";
const systemDefaultTheme = (0, _createThemeDefault.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefaultDefault.default)(defaultTheme);
}
exports.default = useTheme;

},{"./createTheme":"ddNIy","./useThemeWithoutDefault":"91huw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddNIy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "private_createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "unstable_applyStyles", ()=>(0, _applyStylesDefault.default));
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);

},{"./createTheme":"gtr3X","./createBreakpoints":false,"./applyStyles":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gtr3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _shape = require("./shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _createSpacing = require("./createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _styleFunctionSx = require("../styleFunctionSx/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _defaultSxConfig = require("../styleFunctionSx/defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);
const _excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const breakpoints = (0, _createBreakpointsDefault.default)(breakpointsInput);
    const spacing = (0, _createSpacingDefault.default)(spacingInput);
    let muiTheme = (0, _utils.deepmerge)({
        breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, _extendsDefault.default)({
            mode: "light"
        }, paletteInput),
        spacing,
        shape: (0, _extendsDefault.default)({}, (0, _shapeDefault.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, _applyStylesDefault.default);
    muiTheme = args.reduce((acc, argument)=>(0, _utils.deepmerge)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _defaultSxConfigDefault.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","./createBreakpoints":"1S73q","./shape":"80ff6","./createSpacing":"9Hzyg","../styleFunctionSx/styleFunctionSx":"6qYOH","../styleFunctionSx/defaultSxConfig":"5YcCe","./applyStyles":"lI4da","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FYSI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dv12b":[function(require,module,exports) {
/**
 * @mui/utils v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainPropTypes", ()=>(0, _chainPropTypesDefault.default));
parcelHelpers.export(exports, "deepmerge", ()=>(0, _deepmergeDefault.default));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _deepmerge.isPlainObject));
parcelHelpers.export(exports, "elementAcceptingRef", ()=>(0, _elementAcceptingRefDefault.default));
parcelHelpers.export(exports, "elementTypeAcceptingRef", ()=>(0, _elementTypeAcceptingRefDefault.default));
parcelHelpers.export(exports, "exactProp", ()=>(0, _exactPropDefault.default));
parcelHelpers.export(exports, "formatMuiErrorMessage", ()=>(0, _formatMuiErrorMessageDefault.default));
parcelHelpers.export(exports, "getDisplayName", ()=>(0, _getDisplayNameDefault.default));
parcelHelpers.export(exports, "HTMLElementType", ()=>(0, _htmlelementTypeDefault.default));
parcelHelpers.export(exports, "ponyfillGlobal", ()=>(0, _ponyfillGlobalDefault.default));
parcelHelpers.export(exports, "refType", ()=>(0, _refTypeDefault.default));
parcelHelpers.export(exports, "unstable_capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "unstable_createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "unstable_debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "unstable_deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "unstable_isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "unstable_ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "unstable_ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "unstable_requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "unstable_setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unstable_unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "unstable_useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "unstable_useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "unstable_useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "unstable_useLazyRef", ()=>(0, _useLazyRefDefault.default));
parcelHelpers.export(exports, "unstable_useTimeout", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "unstable_Timeout", ()=>(0, _useTimeout.Timeout));
parcelHelpers.export(exports, "unstable_useOnMount", ()=>(0, _useOnMountDefault.default));
parcelHelpers.export(exports, "unstable_useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_getScrollbarSize", ()=>(0, _getScrollbarSizeDefault.default));
parcelHelpers.export(exports, "unstable_detectScrollType", ()=>(0, _scrollLeft.detectScrollType));
parcelHelpers.export(exports, "unstable_getNormalizedScrollLeft", ()=>(0, _scrollLeft.getNormalizedScrollLeft));
parcelHelpers.export(exports, "usePreviousProps", ()=>(0, _usePreviousPropsDefault.default));
parcelHelpers.export(exports, "getValidReactChildren", ()=>(0, _getValidReactChildrenDefault.default));
parcelHelpers.export(exports, "visuallyHidden", ()=>(0, _visuallyHiddenDefault.default));
parcelHelpers.export(exports, "integerPropType", ()=>(0, _integerPropTypeDefault.default));
parcelHelpers.export(exports, "internal_resolveProps", ()=>(0, _resolvePropsDefault.default));
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _composeClassesDefault.default));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClassDefault.default));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
parcelHelpers.export(exports, "unstable_generateUtilityClasses", ()=>(0, _generateUtilityClassesDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _classNameGeneratorDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _scrollLeft = require("./scrollLeft");
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./chainPropTypes":"7gGkw","./deepmerge":"68lM8","./elementAcceptingRef":"8u9q8","./elementTypeAcceptingRef":"avxUq","./exactProp":"e2xbT","./formatMuiErrorMessage":"h4Lns","./getDisplayName":"loecN","./HTMLElementType":"gMz3j","./ponyfillGlobal":"4NHVn","./refType":"3gi5P","./capitalize":"89fb9","./createChainedFunction":"6QAYk","./debounce":"5L8qa","./deprecatedPropType":"j8QOS","./isMuiElement":"7TqHt","./ownerDocument":"7QJNN","./ownerWindow":"5XRrN","./requirePropFactory":"9RWTA","./setRef":"dZB2p","./useEnhancedEffect":"dZc8b","./useId":"2ibXS","./unsupportedProp":"eoa7B","./useControlled":"9Cg7d","./useEventCallback":"6cuj2","./useForkRef":"2kbGA","./useLazyRef":"iXKlD","./useTimeout":"1H20F","./useOnMount":"3UQqo","./useIsFocusVisible":"a1BQD","./getScrollbarSize":"5o7Gy","./scrollLeft":"fxo90","./usePreviousProps":"gwR94","./getValidReactChildren":"4tlaR","./visuallyHidden":"1H03t","./integerPropType":"eZgMf","./resolveProps":"9SThr","./composeClasses":"58Z1p","./generateUtilityClass":"lhBx6","./generateUtilityClasses":"88HUS","./ClassNameGenerator":"8XVSt","./clamp":"7Fn0G","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7gGkw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chainPropTypesDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);

},{"./chainPropTypes":"h8VoX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h8VoX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>chainPropTypes);
function chainPropTypes(propType1, propType2) {
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"68lM8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deepmergeDefault.default));
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
parcelHelpers.exportAll(_deepmerge, exports);

},{"./deepmerge":"bAlNk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bAlNk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "default", ()=>deepmerge);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function isPlainObject(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (!isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, _extendsDefault.default)({}, target) : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8u9q8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementAcceptingRefDefault.default));
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);

},{"./elementAcceptingRef":"lNhjy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lNhjy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === "function" && !isClassComponent(elementType)) warningHint = "Did you accidentally use a plain function component for an element instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
const elementAcceptingRef = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element.isRequired, acceptingRef);
exports.default = elementAcceptingRef;

},{"prop-types":"3KNJy","../chainPropTypes":"7gGkw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"avxUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementTypeAcceptingRefDefault.default));
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);

},{"./elementTypeAcceptingRef":"jyKIA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jyKIA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === "function" && !isClassComponent(propValue)) warningHint = "Did you accidentally provide a plain function component instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
exports.default = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).elementType, elementTypeAcceptingRef);

},{"prop-types":"3KNJy","../chainPropTypes":"7gGkw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e2xbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _exactPropDefault.default));
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);

},{"./exactProp":"dnVYy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dnVYy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>exactProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"loecN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getDisplayNameDefault.default));
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
parcelHelpers.exportAll(_getDisplayName, exports);

},{"./getDisplayName":"dtzmW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dtzmW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "default", ()=>getDisplayName);
var _reactIs = require("react-is");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
    const match = `${fn}`.match(fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, "ForwardRef");
        case 0, _reactIs.Memo:
            return getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

},{"react-is":"3fr5l","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fr5l":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"78bQy"}],"78bQy":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"gMz3j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _htmlelementTypeDefault.default));
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);

},{"./HTMLElementType":"6Rwgt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Rwgt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HTMLElementType);
function HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4NHVn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ponyfillGlobalDefault.default));
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);

},{"./ponyfillGlobal":"bIaF1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bIaF1":[function(require,module,exports) {
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3gi5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _refTypeDefault.default));
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);

},{"./refType":"9y3Wc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9y3Wc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const refType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).object
]);
exports.default = refType;

},{"prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"89fb9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _capitalizeDefault.default));
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);

},{"./capitalize":"1xuz3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1xuz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>capitalize);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function capitalize(string) {
    if (typeof string !== "string") throw new Error((0, _formatMuiErrorMessageDefault.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"@mui/utils/formatMuiErrorMessage":"h4Lns","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6QAYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createChainedFunctionDefault.default));
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);

},{"./createChainedFunction":"9n9MQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9n9MQ":[function(require,module,exports) {
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createChainedFunction);
function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5L8qa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _debounceDefault.default));
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
parcelHelpers.exportAll(_debounce, exports);

},{"./debounce":"6fLUp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6fLUp":[function(require,module,exports) {
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8QOS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deprecatedPropTypeDefault.default));
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);

},{"./deprecatedPropType":"7RNbT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7RNbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deprecatedPropType);
function deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7TqHt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _isMuiElementDefault.default));
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);

},{"./isMuiElement":"7TTPN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7TTPN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMuiElement);
var _react = require("react");
function isMuiElement(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ _react.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7QJNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerDocumentDefault.default));
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);

},{"./ownerDocument":"k1jTQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k1jTQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5XRrN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerWindowDefault.default));
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);

},{"./ownerWindow":"hdqDv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hdqDv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("../ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    const doc = (0, _ownerDocumentDefault.default)(node);
    return doc.defaultView || window;
}

},{"../ownerDocument":"7QJNN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9RWTA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _requirePropFactoryDefault.default));
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);

},{"./requirePropFactory":"sVML8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"sVML8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requirePropFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dZB2p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _setRefDefault.default));
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);

},{"./setRef":"eXMnu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXMnu":[function(require,module,exports) {
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRef);
function setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dZc8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEnhancedEffectDefault.default));
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);

},{"./useEnhancedEffect":"dA8im","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dA8im":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== "undefined" ? _react.useLayoutEffect : _react.useEffect;
exports.default = useEnhancedEffect;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ibXS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIdDefault.default));
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);

},{"./useId":"giLQy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"giLQy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useId);
var _react = require("react");
"use client";
let globalId = 0;
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = _react.useState(idOverride);
    const id = idOverride || defaultId;
    _react.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = _react["useId".toString()];
function useId(idOverride) {
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eoa7B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _unsupportedPropDefault.default));
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);

},{"./unsupportedProp":"jpsk9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jpsk9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unsupportedProp);
function unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Cg7d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useControlledDefault.default));
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);

},{"./useControlled":"dzsZC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dzsZC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlled);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _react = require("react");
"use client";
function useControlled({ controlled, default: defaultProp, name, state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = _react.useRef(controlled !== undefined);
    const [valueState, setValue] = _react.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = _react.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6cuj2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEventCallbackDefault.default));
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);

},{"./useEventCallback":"i9YGG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9YGG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEnhancedEffect = require("../useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = _react.useRef(fn);
    (0, _useEnhancedEffectDefault.default)(()=>{
        ref.current = fn;
    });
    return _react.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
exports.default = useEventCallback;

},{"react":"gVheC","../useEnhancedEffect":"dZc8b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2kbGA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useForkRefDefault.default));
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);

},{"./useForkRef":"1QfEK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QfEK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForkRef);
var _react = require("react");
var _setRef = require("../setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
"use client";
function useForkRef(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return _react.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, _setRefDefault.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"react":"gVheC","../setRef":"dZB2p","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iXKlD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useLazyRefDefault.default));
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);

},{"./useLazyRef":"bJf5Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bJf5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyRef);
var _react = require("react");
"use client";
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
    const ref = _react.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1H20F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "Timeout", ()=>(0, _useTimeout.Timeout));
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);

},{"./useTimeout":"e6IQw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6IQw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeout", ()=>Timeout);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _useLazyRef = require("../useLazyRef/useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useOnMount = require("../useOnMount/useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
"use client";
class Timeout {
    static create() {
        return new Timeout();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function useTimeout() {
    const timeout = (0, _useLazyRefDefault.default)(Timeout.create).current;
    (0, _useOnMountDefault.default)(timeout.disposeEffect);
    return timeout;
}

},{"../useLazyRef/useLazyRef":"bJf5Y","../useOnMount/useOnMount":"az4TW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"az4TW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnMount);
var _react = require("react");
"use client";
const EMPTY = [];
function useOnMount(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ _react.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3UQqo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useOnMountDefault.default));
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);

},{"./useOnMount":"az4TW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a1BQD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIsFocusVisibleDefault.default));
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
parcelHelpers.exportAll(_useIsFocusVisible, exports);

},{"./useIsFocusVisible":"an417","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"an417":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teardown", ()=>teardown);
parcelHelpers.export(exports, "default", ()=>useIsFocusVisible);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var _react = require("react");
var _useTimeout = require("../useTimeout/useTimeout");
"use client";
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new (0, _useTimeout.Timeout)();
const inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function focusTriggersKeyboardModality(node) {
    const { type, tagName } = node;
    if (tagName === "INPUT" && inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function handlePointerDown() {
    hadKeyboardEvent = false;
}
function handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if (hadFocusVisibleRecently) hadKeyboardEvent = true;
    }
}
function prepare(doc) {
    doc.addEventListener("keydown", handleKeyDown, true);
    doc.addEventListener("mousedown", handlePointerDown, true);
    doc.addEventListener("pointerdown", handlePointerDown, true);
    doc.addEventListener("touchstart", handlePointerDown, true);
    doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function teardown(doc) {
    doc.removeEventListener("keydown", handleKeyDown, true);
    doc.removeEventListener("mousedown", handlePointerDown, true);
    doc.removeEventListener("pointerdown", handlePointerDown, true);
    doc.removeEventListener("touchstart", handlePointerDown, true);
    doc.removeEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
    const { target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
    const ref = _react.useCallback((node)=>{
        if (node != null) prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = _react.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if (isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref
    };
}

},{"react":"gVheC","../useTimeout/useTimeout":"e6IQw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5o7Gy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getScrollbarSizeDefault.default));
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);

},{"./getScrollbarSize":"hFGmh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hFGmh":[function(require,module,exports) {
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollbarSize);
function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fxo90":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _scrollLeft = require("./scrollLeft");
parcelHelpers.exportAll(_scrollLeft, exports);

},{"./scrollLeft":"8Ctmo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Ctmo":[function(require,module,exports) {
// Source from https://github.com/alitaheri/normalize-scroll-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */ parcelHelpers.export(exports, "detectScrollType", ()=>detectScrollType);
// Based on https://stackoverflow.com/a/24394376
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>getNormalizedScrollLeft);
let cachedType;
function detectScrollType() {
    if (cachedType) return cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    cachedType = "reverse";
    if (dummy.scrollLeft > 0) cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return cachedType;
}
function getNormalizedScrollLeft(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = detectScrollType();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gwR94":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePreviousPropsDefault.default));
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);

},{"./usePreviousProps":"g0MT6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g0MT6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const usePreviousProps = (value)=>{
    const ref = _react.useRef({});
    _react.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePreviousProps;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tlaR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getValidReactChildrenDefault.default));
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);

},{"./getValidReactChildren":"iaNvb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iaNvb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getValidReactChildren);
var _react = require("react");
function getValidReactChildren(children) {
    return _react.Children.toArray(children).filter((child)=>/*#__PURE__*/ _react.isValidElement(child));
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1H03t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _visuallyHiddenDefault.default));
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);

},{"./visuallyHidden":"49U46","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49U46":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
exports.default = visuallyHidden;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eZgMf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _integerPropTypeDefault.default));
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
parcelHelpers.exportAll(_integerPropType, exports);

},{"./integerPropType":"6PCAE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6PCAE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypeByValue", ()=>getTypeByValue);
function getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case "number":
            if (Number.isNaN(value)) return "NaN";
            if (!Number.isFinite(value)) return "Infinity";
            if (value !== Math.floor(value)) return "float";
            return "number";
        case "object":
            if (value === null) return "null";
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !isInteger(propValue)) {
        const propType = getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
    return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
exports.default = validatorNoop;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9SThr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _resolvePropsDefault.default));
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);

},{"./resolveProps":"84njx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"84njx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function resolveProps(defaultProps, props) {
    const output = (0, _extendsDefault.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, _extendsDefault.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, _extendsDefault.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"58Z1p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _composeClassesDefault.default));
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);

},{"./composeClasses":"7o7Hx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7o7Hx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeClasses);
function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lhBx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassDefault.default));
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);

},{"./generateUtilityClass":"3lnRq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3lnRq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalStateClasses", ()=>globalStateClasses);
parcelHelpers.export(exports, "default", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _classNameGenerator = require("../ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
const globalStateClasses = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, _classNameGeneratorDefault.default).generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"../ClassNameGenerator":"8XVSt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8XVSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _classNameGeneratorDefault.default));
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);

},{"./ClassNameGenerator":"l0GPf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0GPf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
exports.default = ClassNameGenerator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"88HUS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassesDefault.default));
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);

},{"./generateUtilityClasses":"eImgs","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eImgs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClassDefault.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"../generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Fn0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clampDefault.default));
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./clamp":"1sTsv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1sTsv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
exports.default = clamp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1S73q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpointKeys", ()=>breakpointKeys);
parcelHelpers.export(exports, "default", ()=>createBreakpoints);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "values",
    "unit",
    "step"
];
const breakpointKeys = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, _extendsDefault.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = "px", step = 5 } = breakpoints, other = (0, _objectWithoutPropertiesLooseDefault.default)(breakpoints, _excluded);
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, _extendsDefault.default)({
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit
    }, other);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"80ff6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shape = {
    borderRadius: 4
};
exports.default = shape;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Hzyg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSpacing);
var _spacing = require("../spacing");
function createSpacing(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, _spacing.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

},{"../spacing":"bxaiK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bxaiK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marginKeys", ()=>marginKeys);
parcelHelpers.export(exports, "paddingKeys", ()=>paddingKeys);
parcelHelpers.export(exports, "createUnaryUnit", ()=>createUnaryUnit);
parcelHelpers.export(exports, "createUnarySpacing", ()=>createUnarySpacing);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getStyleFromPropValue", ()=>getStyleFromPropValue);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "padding", ()=>padding);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
var _style = require("./style");
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _memoize = require("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
const properties = {
    m: "margin",
    p: "padding"
};
const directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoizeDefault.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = properties[a];
    const direction = directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, _style.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce((0, _mergeDefault.default), {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
exports.default = spacing;

},{"./responsivePropType":"7kilA","./breakpoints":"k4Z23","./style":"aA00K","./merge":"d7cyo","./memoize":"hqFYW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7kilA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const responsivePropType = {};
exports.default = responsivePropType;

},{"prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k4Z23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "handleBreakpoints", ()=>handleBreakpoints);
parcelHelpers.export(exports, "createEmptyBreakpointObject", ()=>createEmptyBreakpointObject);
parcelHelpers.export(exports, "removeUnusedBreakpoints", ()=>removeUnusedBreakpoints);
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>mergeBreakpointsInOrder);
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
parcelHelpers.export(exports, "computeBreakpointsBase", ()=>computeBreakpointsBase);
parcelHelpers.export(exports, "resolveBreakpointValues", ()=>resolveBreakpointValues);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, _extendsDefault.default)({
                    theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, _mergeDefault.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _utils.deepmerge)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
exports.default = breakpoints;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","prop-types":"3KNJy","@mui/utils":"dv12b","./merge":"d7cyo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d7cyo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
function merge(acc, item) {
    if (!item) return acc;
    return (0, _utils.deepmerge)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
exports.default = merge;

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aA00K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "getStyleValue", ()=>getStyleValue);
var _utils = require("@mui/utils");
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, _utils.unstable_capitalize)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
exports.default = style;

},{"@mui/utils":"dv12b","./responsivePropType":"7kilA","./breakpoints":"k4Z23","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hqFYW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6qYOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>unstable_createStyleFunctionSx);
var _utils = require("@mui/utils");
var _merge = require("../merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _style = require("../style");
var _breakpoints = require("../breakpoints");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, _utils.unstable_capitalize)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx, theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, _defaultSxConfigDefault.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme
                            });
                            else css = (0, _mergeDefault.default)(css, breakpointsValues);
                        }
                    } else css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    "sx"
];
exports.default = styleFunctionSx;

},{"@mui/utils":"dv12b","../merge":"d7cyo","../style":"aA00K","../breakpoints":"k4Z23","./defaultSxConfig":"5YcCe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5YcCe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacing = require("../spacing");
var _borders = require("../borders");
var _cssGrid = require("../cssGrid");
var _palette = require("../palette");
var _sizing = require("../sizing");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, _borders.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, _palette.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, _palette.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, _palette.paletteTransform)
    },
    // spacing
    p: {
        style: (0, _spacing.padding)
    },
    pt: {
        style: (0, _spacing.padding)
    },
    pr: {
        style: (0, _spacing.padding)
    },
    pb: {
        style: (0, _spacing.padding)
    },
    pl: {
        style: (0, _spacing.padding)
    },
    px: {
        style: (0, _spacing.padding)
    },
    py: {
        style: (0, _spacing.padding)
    },
    padding: {
        style: (0, _spacing.padding)
    },
    paddingTop: {
        style: (0, _spacing.padding)
    },
    paddingRight: {
        style: (0, _spacing.padding)
    },
    paddingBottom: {
        style: (0, _spacing.padding)
    },
    paddingLeft: {
        style: (0, _spacing.padding)
    },
    paddingX: {
        style: (0, _spacing.padding)
    },
    paddingY: {
        style: (0, _spacing.padding)
    },
    paddingInline: {
        style: (0, _spacing.padding)
    },
    paddingInlineStart: {
        style: (0, _spacing.padding)
    },
    paddingInlineEnd: {
        style: (0, _spacing.padding)
    },
    paddingBlock: {
        style: (0, _spacing.padding)
    },
    paddingBlockStart: {
        style: (0, _spacing.padding)
    },
    paddingBlockEnd: {
        style: (0, _spacing.padding)
    },
    m: {
        style: (0, _spacing.margin)
    },
    mt: {
        style: (0, _spacing.margin)
    },
    mr: {
        style: (0, _spacing.margin)
    },
    mb: {
        style: (0, _spacing.margin)
    },
    ml: {
        style: (0, _spacing.margin)
    },
    mx: {
        style: (0, _spacing.margin)
    },
    my: {
        style: (0, _spacing.margin)
    },
    margin: {
        style: (0, _spacing.margin)
    },
    marginTop: {
        style: (0, _spacing.margin)
    },
    marginRight: {
        style: (0, _spacing.margin)
    },
    marginBottom: {
        style: (0, _spacing.margin)
    },
    marginLeft: {
        style: (0, _spacing.margin)
    },
    marginX: {
        style: (0, _spacing.margin)
    },
    marginY: {
        style: (0, _spacing.margin)
    },
    marginInline: {
        style: (0, _spacing.margin)
    },
    marginInlineStart: {
        style: (0, _spacing.margin)
    },
    marginInlineEnd: {
        style: (0, _spacing.margin)
    },
    marginBlock: {
        style: (0, _spacing.margin)
    },
    marginBlockStart: {
        style: (0, _spacing.margin)
    },
    marginBlockEnd: {
        style: (0, _spacing.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, _cssGrid.gap)
    },
    rowGap: {
        style: (0, _cssGrid.rowGap)
    },
    columnGap: {
        style: (0, _cssGrid.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, _sizing.sizingTransform)
    },
    maxWidth: {
        style: (0, _sizing.maxWidth)
    },
    minWidth: {
        transform: (0, _sizing.sizingTransform)
    },
    height: {
        transform: (0, _sizing.sizingTransform)
    },
    maxHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    minHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
exports.default = defaultSxConfig;

},{"../spacing":"bxaiK","../borders":"aECcN","../cssGrid":"3OS1X","../palette":"fBQ0t","../sizing":"8wU6g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aECcN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderTransform", ()=>borderTransform);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderTop", ()=>borderTop);
parcelHelpers.export(exports, "borderRight", ()=>borderRight);
parcelHelpers.export(exports, "borderBottom", ()=>borderBottom);
parcelHelpers.export(exports, "borderLeft", ()=>borderLeft);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderTopColor", ()=>borderTopColor);
parcelHelpers.export(exports, "borderRightColor", ()=>borderRightColor);
parcelHelpers.export(exports, "borderBottomColor", ()=>borderBottomColor);
parcelHelpers.export(exports, "borderLeftColor", ()=>borderLeftColor);
parcelHelpers.export(exports, "outline", ()=>outline);
parcelHelpers.export(exports, "outlineColor", ()=>outlineColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
function borderTransform(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _styleDefault.default)({
        prop,
        themeKey: "borders",
        transform
    });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = [
    "borderRadius"
];
const borders = (0, _composeDefault.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
exports.default = borders;

},{"./responsivePropType":"7kilA","./style":"aA00K","./compose":"fw0ye","./spacing":"bxaiK","./breakpoints":"k4Z23","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fw0ye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _mergeDefault.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
exports.default = compose;

},{"./merge":"d7cyo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3OS1X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gap", ()=>gap);
parcelHelpers.export(exports, "columnGap", ()=>columnGap);
parcelHelpers.export(exports, "rowGap", ()=>rowGap);
parcelHelpers.export(exports, "gridColumn", ()=>gridColumn);
parcelHelpers.export(exports, "gridRow", ()=>gridRow);
parcelHelpers.export(exports, "gridAutoFlow", ()=>gridAutoFlow);
parcelHelpers.export(exports, "gridAutoColumns", ()=>gridAutoColumns);
parcelHelpers.export(exports, "gridAutoRows", ()=>gridAutoRows);
parcelHelpers.export(exports, "gridTemplateColumns", ()=>gridTemplateColumns);
parcelHelpers.export(exports, "gridTemplateRows", ()=>gridTemplateRows);
parcelHelpers.export(exports, "gridTemplateAreas", ()=>gridTemplateAreas);
parcelHelpers.export(exports, "gridArea", ()=>gridArea);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
gap.propTypes = {};
gap.filterProps = [
    "gap"
];
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
columnGap.propTypes = {};
columnGap.filterProps = [
    "columnGap"
];
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
rowGap.propTypes = {};
rowGap.filterProps = [
    "rowGap"
];
const gridColumn = (0, _styleDefault.default)({
    prop: "gridColumn"
});
const gridRow = (0, _styleDefault.default)({
    prop: "gridRow"
});
const gridAutoFlow = (0, _styleDefault.default)({
    prop: "gridAutoFlow"
});
const gridAutoColumns = (0, _styleDefault.default)({
    prop: "gridAutoColumns"
});
const gridAutoRows = (0, _styleDefault.default)({
    prop: "gridAutoRows"
});
const gridTemplateColumns = (0, _styleDefault.default)({
    prop: "gridTemplateColumns"
});
const gridTemplateRows = (0, _styleDefault.default)({
    prop: "gridTemplateRows"
});
const gridTemplateAreas = (0, _styleDefault.default)({
    prop: "gridTemplateAreas"
});
const gridArea = (0, _styleDefault.default)({
    prop: "gridArea"
});
const grid = (0, _composeDefault.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
exports.default = grid;

},{"./style":"aA00K","./compose":"fw0ye","./spacing":"bxaiK","./breakpoints":"k4Z23","./responsivePropType":"7kilA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBQ0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paletteTransform", ()=>paletteTransform);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "bgcolor", ()=>bgcolor);
parcelHelpers.export(exports, "backgroundColor", ()=>backgroundColor);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
function paletteTransform(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const color = (0, _styleDefault.default)({
    prop: "color",
    themeKey: "palette",
    transform: paletteTransform
});
const bgcolor = (0, _styleDefault.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: paletteTransform
});
const backgroundColor = (0, _styleDefault.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: paletteTransform
});
const palette = (0, _composeDefault.default)(color, bgcolor, backgroundColor);
exports.default = palette;

},{"./style":"aA00K","./compose":"fw0ye","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8wU6g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizingTransform", ()=>sizingTransform);
parcelHelpers.export(exports, "width", ()=>width);
parcelHelpers.export(exports, "maxWidth", ()=>maxWidth);
parcelHelpers.export(exports, "minWidth", ()=>minWidth);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "maxHeight", ()=>maxHeight);
parcelHelpers.export(exports, "minHeight", ()=>minHeight);
parcelHelpers.export(exports, "sizeWidth", ()=>sizeWidth);
parcelHelpers.export(exports, "sizeHeight", ()=>sizeHeight);
parcelHelpers.export(exports, "boxSizing", ()=>boxSizing);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _breakpoints = require("./breakpoints");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0, _styleDefault.default)({
    prop: "width",
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, _breakpoints.values)[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
maxWidth.filterProps = [
    "maxWidth"
];
const minWidth = (0, _styleDefault.default)({
    prop: "minWidth",
    transform: sizingTransform
});
const height = (0, _styleDefault.default)({
    prop: "height",
    transform: sizingTransform
});
const maxHeight = (0, _styleDefault.default)({
    prop: "maxHeight",
    transform: sizingTransform
});
const minHeight = (0, _styleDefault.default)({
    prop: "minHeight",
    transform: sizingTransform
});
const sizeWidth = (0, _styleDefault.default)({
    prop: "size",
    cssProperty: "width",
    transform: sizingTransform
});
const sizeHeight = (0, _styleDefault.default)({
    prop: "size",
    cssProperty: "height",
    transform: sizingTransform
});
const boxSizing = (0, _styleDefault.default)({
    prop: "boxSizing"
});
const sizing = (0, _composeDefault.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
exports.default = sizing;

},{"./style":"aA00K","./compose":"fw0ye","./breakpoints":"k4Z23","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lI4da":[function(require,module,exports) {
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyStyles);
function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"91huw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _styledEngine = require("@mui/styled-engine");
"use client";
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = _react.useContext((0, _styledEngine.ThemeContext));
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
exports.default = useTheme;

},{"react":"gVheC","@mui/styled-engine":"lDUiA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5JpQH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "extendSxProp", ()=>(0, _extendSxPropDefault.default));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _defaultSxConfigDefault.default));
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _extendSxProp = require("./extendSxProp");
var _extendSxPropDefault = parcelHelpers.interopDefault(_extendSxProp);
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);

},{"./styleFunctionSx":"6qYOH","./extendSxProp":"01xBe","./defaultSxConfig":"5YcCe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"01xBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extendSxProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
const _excluded = [
    "sx"
];
const splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, _defaultSxConfigDefault.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _utils.isPlainObject)(result)) return systemProps;
        return (0, _extendsDefault.default)({}, systemProps, result);
    };
    else finalSx = (0, _extendsDefault.default)({}, systemProps, inSx);
    return (0, _extendsDefault.default)({}, otherProps, {
        sx: finalSx
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","./defaultSxConfig":"5YcCe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bL8d9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBox);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = "MuiBox-root", generateClassName } = options;
    const BoxRoot = (0, _styledEngineDefault.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, _styleFunctionSxDefault.default));
    const Box = /*#__PURE__*/ _react.forwardRef(function Box(inProps, ref) {
        const theme = (0, _useThemeDefault.default)(defaultTheme);
        const _extendSxProp = (0, _styleFunctionSx.extendSxProp)(inProps), { className, component = "div" } = _extendSxProp, other = (0, _objectWithoutPropertiesLooseDefault.default)(_extendSxProp, _excluded);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, (0, _extendsDefault.default)({
            as: component,
            ref: ref,
            className: (0, _clsxDefault.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aGWRz","@mui/styled-engine":"lDUiA","./styleFunctionSx":"5JpQH","./useTheme":"4Kwj6","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGWRz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9aQzE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Update /system/styled/#api in case if this changes
parcelHelpers.export(exports, "shouldForwardProp", ()=>shouldForwardProp);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable no-underscore-dangle */ var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _utils = require("@mui/utils");
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = (0, _createThemeDefault.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, _extendsDefault.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extendsDefault.default)({
            ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLooseDefault.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, _extendsDefault.default)({
                ownerState
            }, props));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, _extendsDefault.default)({
                    ownerState
                }, props)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSxDefault.default)((0, _extendsDefault.default)({}, props, {
            theme: resolveTheme((0, _extendsDefault.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLooseDefault.default)(inputOptions, _excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngineDefault.default)(tag, (0, _extendsDefault.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, _utils.isPlainObject)(stylesArg)) return (props)=>processStyleArg(stylesArg, (0, _extendsDefault.default)({}, props, {
                    theme: resolveTheme({
                        theme: props.theme,
                        defaultTheme,
                        themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extendsDefault.default)({}, props, {
                        theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extendsDefault.default)({}, props, {
                    theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/styled-engine":"lDUiA","@mui/utils":"dv12b","./createTheme":"ddNIy","./styleFunctionSx":"5JpQH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cvWxq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
const styled = (0, _createStyledDefault.default)();
exports.default = styled;

},{"./createStyled":"9aQzE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fF9s8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _getThemePropsDefault.default));
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
"use client";

},{"./useThemeProps":"1k1Sw","./getThemeProps":"jRaK8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1k1Sw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
"use client";
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _useThemeDefault.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, _getThemePropsDefault.default)({
        theme,
        name,
        props
    });
    return mergedProps;
}

},{"./getThemeProps":"jRaK8","../useTheme":"4Kwj6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jRaK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThemeProps);
var _utils = require("@mui/utils");
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _utils.internal_resolveProps)(theme.components[name].defaultProps, props);
}

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9hsNx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ parcelHelpers.export(exports, "hexToRgb", ()=>hexToRgb);
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ parcelHelpers.export(exports, "decomposeColor", ()=>decomposeColor);
parcelHelpers.export(exports, "colorChannel", ()=>colorChannel);
parcelHelpers.export(exports, "private_safeColorChannel", ()=>private_safeColorChannel);
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ parcelHelpers.export(exports, "recomposeColor", ()=>recomposeColor);
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ parcelHelpers.export(exports, "rgbToHex", ()=>rgbToHex);
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ parcelHelpers.export(exports, "hslToRgb", ()=>hslToRgb);
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ parcelHelpers.export(exports, "getLuminance", ()=>getLuminance);
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ parcelHelpers.export(exports, "getContrastRatio", ()=>getContrastRatio);
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "private_safeAlpha", ()=>private_safeAlpha);
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "darken", ()=>darken);
parcelHelpers.export(exports, "private_safeDarken", ()=>private_safeDarken);
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "lighten", ()=>lighten);
parcelHelpers.export(exports, "private_safeLighten", ()=>private_safeLighten);
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "emphasize", ()=>emphasize);
parcelHelpers.export(exports, "private_safeEmphasize", ()=>private_safeEmphasize);
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ parcelHelpers.export(exports, "blend", ()=>blend);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
/* eslint-disable @typescript-eslint/naming-convention */ var _utils = require("@mui/utils");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _utils.clamp)(value, min, max);
}
function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return decomposeColor(hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return private_safeEmphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: "rgb",
        values: rgb
    });
}

},{"@mui/utils/formatMuiErrorMessage":"h4Lns","@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4pAad":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
"use client";

},{"./ThemeProvider":"b15Bm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b15Bm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _privateTheming = require("@mui/private-theming");
var _utils = require("@mui/utils");
var _styledEngine = require("@mui/styled-engine");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return _react.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, _extendsDefault.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, _extendsDefault.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, _extendsDefault.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefaultDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateTheming.ThemeProvider), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.ThemeContext).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/private-theming":"6O6cs","@mui/utils":"dv12b","@mui/styled-engine":"lDUiA","../useThemeWithoutDefault":"91huw","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6O6cs":[function(require,module,exports) {
/**
 * @mui/private-theming v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
parcelHelpers.exportAll(_themeProvider, exports);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./ThemeProvider":"23TOd","./useTheme":"4UY7C","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"23TOd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_nested", ()=>(0, _nestedDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);

},{"./ThemeProvider":"2KrKL","./nested":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2KrKL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _themeContext = require("../useTheme/ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);
// To support composition of theme.
var _jsxRuntime = require("react/jsx-runtime");
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _useThemeDefault.default)();
    const theme = _react.useMemo(()=>{
        const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, _nestedDefault.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContextDefault.default).Provider, {
        value: theme,
        children: children
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","../useTheme/ThemeContext":"9Cw5N","../useTheme":"4UY7C","./nested":"fDZr3","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Cw5N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const ThemeContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ThemeContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4UY7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeDefault.default));
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./useTheme":"6Pldt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Pldt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _themeContext = require("./ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
function useTheme() {
    const theme = _react.useContext((0, _themeContextDefault.default));
    return theme;
}

},{"react":"gVheC","./ThemeContext":"9Cw5N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fDZr3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const hasSymbol = typeof Symbol === "function" && Symbol.for;
exports.default = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpKov":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "createStack", ()=>(0, _createStackDefault.default));
parcelHelpers.export(exports, "stackClasses", ()=>(0, _stackClassesDefault.default));
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _createStack = require("./createStack");
var _createStackDefault = parcelHelpers.interopDefault(_createStack);
var _stackProps = require("./StackProps");
parcelHelpers.exportAll(_stackProps, exports);
var _stackClasses = require("./stackClasses");
var _stackClassesDefault = parcelHelpers.interopDefault(_stackClasses);
parcelHelpers.exportAll(_stackClasses, exports);
"use client";

},{"./Stack":false,"./createStack":"6HodW","./StackProps":false,"./stackClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6HodW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "style", ()=>style);
parcelHelpers.export(exports, "default", ()=>createStack);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _styled = require("../styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styleFunctionSx = require("../styleFunctionSx");
var _createTheme = require("../createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _breakpoints = require("../breakpoints");
var _spacing = require("../spacing");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const defaultTheme = (0, _createThemeDefault.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styledDefault.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function useThemePropsDefault(props) {
    return (0, _useThemePropsDefault.default)({
        props,
        name: "MuiStack",
        defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function joinChildren(children, separator) {
    const childrenArray = _react.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ _react.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const style = ({ ownerState, theme })=>{
    let styles = (0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, _breakpoints.handleBreakpoints)({
        theme
    }, (0, _breakpoints.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, _spacing.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.direction,
            base
        });
        const spacingValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.spacing,
            base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, _spacing.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, _spacing.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, _utils.deepmerge)(styles, (0, _breakpoints.handleBreakpoints)({
            theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, _breakpoints.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function createStack(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, _utils.unstable_composeClasses)(slots, (slot)=>(0, _utils.unstable_generateUtilityClass)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent(style);
    const Stack = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component = "div", direction = "column", spacing = 0, divider, children, className, useFlexGap = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
        const ownerState = {
            direction,
            spacing,
            useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StackRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            children: divider ? joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","../styled":"cvWxq","../useThemeProps":"fF9s8","../styleFunctionSx":"5JpQH","../createTheme":"ddNIy","../breakpoints":"k4Z23","../spacing":"bxaiK","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4WEqq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMuiTheme", ()=>createMuiTheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _utils = require("@mui/utils");
var _system = require("@mui/system");
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _createPalette = require("./createPalette");
var _createPaletteDefault = parcelHelpers.interopDefault(_createPalette);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _createTransitions = require("./createTransitions");
var _createTransitionsDefault = parcelHelpers.interopDefault(_createTransitions);
var _zIndex = require("./zIndex");
var _zIndexDefault = parcelHelpers.interopDefault(_zIndex);
const _excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    if (options.vars) throw new Error((0, _formatMuiErrorMessageDefault.default)(18));
    const palette = (0, _createPaletteDefault.default)(paletteInput);
    const systemTheme = (0, _system.createTheme)(options);
    let muiTheme = (0, _utils.deepmerge)(systemTheme, {
        mixins: (0, _createMixinsDefault.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, _shadowsDefault.default).slice(),
        typography: (0, _createTypographyDefault.default)(palette, typographyInput),
        transitions: (0, _createTransitionsDefault.default)(transitionsInput),
        zIndex: (0, _extendsDefault.default)({}, (0, _zIndexDefault.default))
    });
    muiTheme = (0, _utils.deepmerge)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _utils.deepmerge)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _system.unstable_defaultSxConfig), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _system.unstable_styleFunctionSx)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
    return createTheme(...args);
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils/formatMuiErrorMessage":"h4Lns","@mui/utils":"dv12b","@mui/system":"gwZXT","@mui/utils/generateUtilityClass":"lhBx6","./createMixins":"cF8iq","./createPalette":"4uwdL","./createTypography":"gU2mZ","./shadows":"exucl","./createTransitions":"fgf6N","./zIndex":"A1CUl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cF8iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createMixins);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function createMixins(breakpoints, mixins) {
    return (0, _extendsDefault.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4uwdL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "light", ()=>light);
parcelHelpers.export(exports, "dark", ()=>dark);
parcelHelpers.export(exports, "default", ()=>createPalette);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _utils = require("@mui/utils");
var _system = require("@mui/system");
var _common = require("../colors/common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _grey = require("../colors/grey");
var _greyDefault = parcelHelpers.interopDefault(_grey);
var _purple = require("../colors/purple");
var _purpleDefault = parcelHelpers.interopDefault(_purple);
var _red = require("../colors/red");
var _redDefault = parcelHelpers.interopDefault(_red);
var _orange = require("../colors/orange");
var _orangeDefault = parcelHelpers.interopDefault(_orange);
var _blue = require("../colors/blue");
var _blueDefault = parcelHelpers.interopDefault(_blue);
var _lightBlue = require("../colors/lightBlue");
var _lightBlueDefault = parcelHelpers.interopDefault(_lightBlue);
var _green = require("../colors/green");
var _greenDefault = parcelHelpers.interopDefault(_green);
const _excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, _commonDefault.default).white,
        default: (0, _commonDefault.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const dark = {
    text: {
        primary: (0, _commonDefault.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, _commonDefault.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, _system.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, _system.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, _blueDefault.default)[200],
        light: (0, _blueDefault.default)[50],
        dark: (0, _blueDefault.default)[400]
    };
    return {
        main: (0, _blueDefault.default)[700],
        light: (0, _blueDefault.default)[400],
        dark: (0, _blueDefault.default)[800]
    };
}
function getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, _purpleDefault.default)[200],
        light: (0, _purpleDefault.default)[50],
        dark: (0, _purpleDefault.default)[400]
    };
    return {
        main: (0, _purpleDefault.default)[500],
        light: (0, _purpleDefault.default)[300],
        dark: (0, _purpleDefault.default)[700]
    };
}
function getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, _redDefault.default)[500],
        light: (0, _redDefault.default)[300],
        dark: (0, _redDefault.default)[700]
    };
    return {
        main: (0, _redDefault.default)[700],
        light: (0, _redDefault.default)[400],
        dark: (0, _redDefault.default)[800]
    };
}
function getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, _lightBlueDefault.default)[400],
        light: (0, _lightBlueDefault.default)[300],
        dark: (0, _lightBlueDefault.default)[700]
    };
    return {
        main: (0, _lightBlueDefault.default)[700],
        light: (0, _lightBlueDefault.default)[500],
        dark: (0, _lightBlueDefault.default)[900]
    };
}
function getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, _greenDefault.default)[400],
        light: (0, _greenDefault.default)[300],
        dark: (0, _greenDefault.default)[700]
    };
    return {
        main: (0, _greenDefault.default)[800],
        light: (0, _greenDefault.default)[500],
        dark: (0, _greenDefault.default)[900]
    };
}
function getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, _orangeDefault.default)[400],
        light: (0, _orangeDefault.default)[300],
        dark: (0, _orangeDefault.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, _orangeDefault.default)[500],
        dark: (0, _orangeDefault.default)[900]
    };
}
function createPalette(palette) {
    const { mode = "light", contrastThreshold = 3, tonalOffset = 0.2 } = palette, other = (0, _objectWithoutPropertiesLooseDefault.default)(palette, _excluded);
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _system.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = (0, _extendsDefault.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, _formatMuiErrorMessageDefault.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, _formatMuiErrorMessageDefault.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        addLightOrDark(color, "light", lightShade, tonalOffset);
        addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark,
        light
    };
    const paletteOutput = (0, _utils.deepmerge)((0, _extendsDefault.default)({
        // A collection of common colors.
        common: (0, _extendsDefault.default)({}, (0, _commonDefault.default)),
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        (0, _greyDefault.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils/formatMuiErrorMessage":"h4Lns","@mui/utils":"dv12b","@mui/system":"gwZXT","../colors/common":"dx5DJ","../colors/grey":"aHiwG","../colors/purple":"1hBTw","../colors/red":"5DKVd","../colors/orange":"5ZTR9","../colors/blue":"2RARD","../colors/lightBlue":"kx6uJ","../colors/green":"bamm6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dx5DJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const common = {
    black: "#000",
    white: "#fff"
};
exports.default = common;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aHiwG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
exports.default = grey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1hBTw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
exports.default = purple;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5DKVd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
exports.default = red;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ZTR9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
exports.default = orange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2RARD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
exports.default = blue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kx6uJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
exports.default = lightBlue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bamm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
exports.default = green;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gU2mZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createTypography);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
const _excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, _extendsDefault.default)({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === defaultFontFamily ? {
            letterSpacing: `${round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, _utils.deepmerge)((0, _extendsDefault.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"exucl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    "none",
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
exports.default = shadows;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fgf6N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easing", ()=>easing);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "default", ()=>createTransitions);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "duration",
    "easing",
    "delay"
];
const easing = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    const mergedEasing = (0, _extendsDefault.default)({}, easing, inputTransitions.easing);
    const mergedDuration = (0, _extendsDefault.default)({}, duration, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0 } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
    };
    return (0, _extendsDefault.default)({
        getAutoHeightDuration,
        create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"A1CUl":[function(require,module,exports) {
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
exports.default = zIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"82gdb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnitless", ()=>isUnitless);
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
parcelHelpers.export(exports, "getUnit", ()=>getUnit);
// Emulate the sass function "unitless"
parcelHelpers.export(exports, "toUnitless", ()=>toUnitless);
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
parcelHelpers.export(exports, "convertLength", ()=>convertLength);
parcelHelpers.export(exports, "alignProperty", ()=>alignProperty);
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
parcelHelpers.export(exports, "fontGrid", ()=>fontGrid);
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ parcelHelpers.export(exports, "responsiveProperty", ()=>responsiveProperty);
function isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
    return parseFloat(length);
}
function convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = toUnitless(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = toUnitless(length) * toUnitless(baseFontSize);
            else if (fromUnit === "rem") pxLength = toUnitless(length) * toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / toUnitless(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function alignProperty({ size, grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function fontGrid({ lineHeight, pixels, htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function responsiveProperty({ cssProperty, min, max, unit = "rem", breakpoints = [
    600,
    900,
    1200
], transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6UMPc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
"use client";
function useTheme() {
    const theme = (0, _system.useTheme)((0, _defaultThemeDefault.default));
    return theme[0, _identifierDefault.default] || theme;
}

},{"react":"gVheC","@mui/system":"gwZXT","./defaultTheme":"fSMFG","./identifier":"3AQ3O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fSMFG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
"use client";
const defaultTheme = (0, _createThemeDefault.default)();
exports.default = defaultTheme;

},{"./createTheme":"4WEqq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4dkr8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
"use client";
function useThemeProps({ props, name }) {
    return (0, _system.useThemeProps)({
        props,
        name,
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    });
}

},{"@mui/system":"gwZXT","./defaultTheme":"fSMFG","./identifier":"3AQ3O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jvcDu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootShouldForwardProp", ()=>rootShouldForwardProp);
parcelHelpers.export(exports, "slotShouldForwardProp", ()=>slotShouldForwardProp);
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
"use client";
const rootShouldForwardProp = (prop)=>(0, _system.shouldForwardProp)(prop) && prop !== "classes";
const slotShouldForwardProp = (0, _system.shouldForwardProp);
const styled = (0, _system.createStyled)({
    themeId: (0, _identifierDefault.default),
    defaultTheme: (0, _defaultThemeDefault.default),
    rootShouldForwardProp
});
exports.default = styled;

},{"@mui/system":"gwZXT","./defaultTheme":"fSMFG","./identifier":"3AQ3O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3da5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ThemeProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "theme"
];
function ThemeProvider(_ref) {
    let { theme: themeInput } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const scopedTheme = themeInput[0, _identifierDefault.default];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.ThemeProvider), (0, _extendsDefault.default)({}, props, {
        themeId: scopedTheme ? (0, _identifierDefault.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/system":"gwZXT","./identifier":"3AQ3O","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f4rjK":[function(require,module,exports) {
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
exports.default = getOverlayAlpha;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j0XMv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesEsmJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryEsmJs.useQuery));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderEsmJs.QueryClientProvider));
parcelHelpers.export(exports, "defaultContext", ()=>(0, _queryClientProviderEsmJs.defaultContext));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderEsmJs.useQueryClient));
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrateEsmJs.Hydrate));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrateEsmJs.useHydrate));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingEsmJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutatingEsmJs.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationEsmJs.useMutation));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryEsmJs.useInfiniteQuery));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringEsmJs.IsRestoringProvider));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringEsmJs.useIsRestoring));
var _setBatchUpdatesFnEsmJs = require("./setBatchUpdatesFn.esm.js");
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _useQueriesEsmJs = require("./useQueries.esm.js");
var _useQueryEsmJs = require("./useQuery.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _hydrateEsmJs = require("./Hydrate.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _useIsFetchingEsmJs = require("./useIsFetching.esm.js");
var _useIsMutatingEsmJs = require("./useIsMutating.esm.js");
var _useMutationEsmJs = require("./useMutation.esm.js");
var _useInfiniteQueryEsmJs = require("./useInfiniteQuery.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");

},{"./setBatchUpdatesFn.esm.js":"7ItKi","@tanstack/query-core":"eWvjq","./useQueries.esm.js":"bTgvP","./useQuery.esm.js":"fuQr8","./QueryClientProvider.esm.js":"kQl5Z","./Hydrate.esm.js":false,"./QueryErrorResetBoundary.esm.js":false,"./useIsFetching.esm.js":false,"./useIsMutating.esm.js":false,"./useMutation.esm.js":"7AXx2","./useInfiniteQuery.esm.js":false,"./isRestoring.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7ItKi":[function(require,module,exports) {
var _queryCore = require("@tanstack/query-core");
var _reactBatchedUpdatesEsmJs = require("./reactBatchedUpdates.esm.js");
(0, _queryCore.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdatesEsmJs.unstable_batchedUpdates));

},{"@tanstack/query-core":"eWvjq","./reactBatchedUpdates.esm.js":"dqbtB"}],"eWvjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerEsmJs.CancelledError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerEsmJs.isCancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheEsmJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientEsmJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverEsmJs.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverEsmJs.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverEsmJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheEsmJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverEsmJs.MutationObserver));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerEsmJs.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerEsmJs.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerEsmJs.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utilsEsmJs.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utilsEsmJs.isError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsEsmJs.isServer));
parcelHelpers.export(exports, "matchQuery", ()=>(0, _utilsEsmJs.matchQuery));
parcelHelpers.export(exports, "parseFilterArgs", ()=>(0, _utilsEsmJs.parseFilterArgs));
parcelHelpers.export(exports, "parseMutationArgs", ()=>(0, _utilsEsmJs.parseMutationArgs));
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>(0, _utilsEsmJs.parseMutationFilterArgs));
parcelHelpers.export(exports, "parseQueryArgs", ()=>(0, _utilsEsmJs.parseQueryArgs));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsEsmJs.replaceEqualDeep));
parcelHelpers.export(exports, "defaultShouldDehydrateMutation", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateMutation));
parcelHelpers.export(exports, "defaultShouldDehydrateQuery", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateQuery));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationEsmJs.dehydrate));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationEsmJs.hydrate));
parcelHelpers.export(exports, "Query", ()=>(0, _queryEsmJs.Query));
var _retryerEsmJs = require("./retryer.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _queryClientEsmJs = require("./queryClient.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _queriesObserverEsmJs = require("./queriesObserver.esm.js");
var _infiniteQueryObserverEsmJs = require("./infiniteQueryObserver.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _mutationObserverEsmJs = require("./mutationObserver.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _hydrationEsmJs = require("./hydration.esm.js");
var _queryEsmJs = require("./query.esm.js");

},{"./retryer.esm.js":false,"./queryCache.esm.js":false,"./queryClient.esm.js":"iUxrq","./queryObserver.esm.js":"j8c61","./queriesObserver.esm.js":"4angi","./infiniteQueryObserver.esm.js":false,"./mutationCache.esm.js":false,"./mutationObserver.esm.js":"jwgeK","./notifyManager.esm.js":"ctreM","./focusManager.esm.js":false,"./onlineManager.esm.js":false,"./utils.esm.js":"780b5","./hydration.esm.js":false,"./query.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86HFe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function canFetch(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, _onlineManagerEsmJs.onlineManager).isOnline() : true;
}
class CancelledError {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new CancelledError(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, _focusManagerEsmJs.focusManager).isFocused() || config.networkMode !== "always" && !(0, _onlineManagerEsmJs.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, _utilsEsmJs.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if (canFetch(config.networkMode)) run();
    else pause().then(run);
    return {
        promise,
        cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry,
        continueRetry
    };
}

},{"./focusManager.esm.js":"4blFk","./onlineManager.esm.js":"2NTfn","./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4blFk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
class FocusManager extends (0, _subscribableEsmJs.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
}
const focusManager = new FocusManager();

},{"./subscribable.esm.js":"7pO8B","./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7pO8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
class Subscribable {
    subscribe(listener) {
        const identity = {
            listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"780b5":[function(require,module,exports) {
// TYPES
// UTILS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
const isServer = typeof window === "undefined" || "Deno" in window;
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, fetching, predicate, mutationKey } = filters;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function hashQueryKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function partialMatchKey(a, b) {
    return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!partialDeepEqual(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function isQueryKey(value) {
    return Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function scheduleMicrotask(callback) {
    sleep(0).then(callback);
}
function getAbortController() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function replaceData(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2NTfn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
const onlineEvents = [
    "online",
    "offline"
];
class OnlineManager extends (0, _subscribableEsmJs.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const onlineManager = new OnlineManager();

},{"./subscribable.esm.js":"7pO8B","./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dCPAP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _utilsEsmJs = require("./utils.esm.js");
var _queryEsmJs = require("./query.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class QueryCache extends (0, _subscribableEsmJs.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utilsEsmJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryEsmJs.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, _utilsEsmJs.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, _utilsEsmJs.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}

},{"./utils.esm.js":"780b5","./query.esm.js":"8Bd6x","./notifyManager.esm.js":"ctreM","./subscribable.esm.js":"7pO8B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Bd6x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _utilsEsmJs = require("./utils.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
var _removableEsmJs = require("./removable.esm.js");
// CLASS
class Query extends (0, _removableEsmJs.Removable) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsEsmJs.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utilsEsmJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, _utilsEsmJs.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, _retryerEsmJs.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, _retryerEsmJs.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, _retryerEsmJs.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, _retryerEsmJs.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, _retryerEsmJs.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

},{"./utils.esm.js":"780b5","./logger.esm.js":"8BH2b","./notifyManager.esm.js":"ctreM","./retryer.esm.js":"86HFe","./removable.esm.js":"16wAR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8BH2b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLogger", ()=>defaultLogger);
const defaultLogger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ctreM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utilsEsmJs = require("./utils.esm.js");
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch,
        batchCalls,
        schedule,
        setNotifyFunction,
        setBatchNotifyFunction
    };
} // SINGLETON
const notifyManager = createNotifyManager();

},{"./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"16wAR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _utilsEsmJs = require("./utils.esm.js");
class Removable {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsEsmJs.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, _utilsEsmJs.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

},{"./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iUxrq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _utilsEsmJs = require("./utils.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _infiniteQueryBehaviorEsmJs = require("./infiniteQueryBehavior.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
// CLASS
class QueryClient {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, _focusManagerEsmJs.focusManager).subscribe(()=>{
            if ((0, _focusManagerEsmJs.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManagerEsmJs.onlineManager).subscribe(()=>{
            if ((0, _onlineManagerEsmJs.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsEsmJs.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, _utilsEsmJs.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(queryKey) === (0, _utilsEsmJs.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(mutationKey) === (0, _utilsEsmJs.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utilsEsmJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, _queryCacheEsmJs.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCacheEsmJs.MutationCache)();
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}

},{"./utils.esm.js":"780b5","./queryCache.esm.js":"dCPAP","./mutationCache.esm.js":"8cG7g","./focusManager.esm.js":"4blFk","./onlineManager.esm.js":"2NTfn","./notifyManager.esm.js":"ctreM","./infiniteQueryBehavior.esm.js":"k9P6J","./logger.esm.js":"8BH2b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8cG7g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _mutationEsmJs = require("./mutation.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class MutationCache extends (0, _subscribableEsmJs.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, _mutationEsmJs.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation
        });
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, _notifyManagerEsmJs.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, _utilsEsmJs.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}

},{"./notifyManager.esm.js":"ctreM","./mutation.esm.js":"4rn5e","./utils.esm.js":"780b5","./subscribable.esm.js":"7pO8B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rn5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _removableEsmJs = require("./removable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
// CLASS
class Mutation extends (0, _removableEsmJs.Removable) {
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, _retryerEsmJs.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount,
                        error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, _retryerEsmJs.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

},{"./logger.esm.js":"8BH2b","./notifyManager.esm.js":"ctreM","./removable.esm.js":"16wAR","./retryer.esm.js":"86HFe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k9P6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
function infiniteQueryBehavior() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8c61":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
class QueryObserver extends (0, _subscribableEsmJs.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, _utilsEsmJs.isServer) || this.currentResult.isStale || !(0, _utilsEsmJs.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, _utilsEsmJs.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utilsEsmJs.isServer) || this.options.enabled === false || !(0, _utilsEsmJs.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, _focusManagerEsmJs.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state } = query;
        let { dataUpdatedAt, error, errorUpdatedAt, fetchStatus, status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, _retryerEsmJs.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status,
            fetchStatus,
            isLoading,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading && isFetching,
            data,
            dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData,
            isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, _utilsEsmJs.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, _retryerEsmJs.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, _utilsEsmJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

},{"./utils.esm.js":"780b5","./notifyManager.esm.js":"ctreM","./focusManager.esm.js":"4blFk","./subscribable.esm.js":"7pO8B","./retryer.esm.js":"86HFe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4angi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueriesObserver", ()=>QueriesObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
class QueriesObserver extends (0, _subscribableEsmJs.Subscribable) {
    onSubscribe() {
        if (this.listeners.size === 1) this.observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = new Set();
        this.observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, notifyOptions) {
        this.queries = queries;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            const prevObservers = this.observers;
            const newObserverMatches = this.findMatchingObservers(this.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newObserversMap = Object.fromEntries(newObservers.map((observer)=>[
                    observer.options.queryHash,
                    observer
                ]));
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.observers = newObservers;
            this.observersMap = newObserversMap;
            this.result = newResult;
            if (!this.hasListeners()) return;
            (0, _utilsEsmJs.difference)(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            (0, _utilsEsmJs.difference)(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.onUpdate(observer, result);
                });
            });
            this.notify();
        });
    }
    getCurrentResult() {
        return this.result;
    }
    getQueries() {
        return this.observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.observers;
    }
    getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
    }
    findMatchingObservers(queries) {
        const prevObservers = this.observers;
        const prevObserversMap = new Map(prevObservers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const defaultedQueryOptions = queries.map((options)=>this.client.defaultQueryOptions(options));
        const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
        const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
        const matchingObserversSet = new Set(matchingObservers.map((match)=>match.observer));
        const unmatchedObservers = prevObservers.filter((prevObserver)=>!matchingObserversSet.has(prevObserver));
        const getObserver = (options)=>{
            const defaultedOptions = this.client.defaultQueryOptions(options);
            const currentObserver = this.observersMap[defaultedOptions.queryHash];
            return currentObserver != null ? currentObserver : new (0, _queryObserverEsmJs.QueryObserver)(this.client, defaultedOptions);
        };
        const newOrReusedObservers = unmatchedQueries.map((options, index)=>{
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                const previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: getObserver(options)
            };
        });
        const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
    onUpdate(observer, result) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, _utilsEsmJs.replaceAt)(this.result, index, result);
            this.notify();
        }
    }
    notify() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(this.result);
            });
        });
    }
    constructor(client, queries){
        super();
        this.client = client;
        this.queries = [];
        this.result = [];
        this.observers = [];
        this.observersMap = {};
        if (queries) this.setQueries(queries);
    }
}

},{"./utils.esm.js":"780b5","./notifyManager.esm.js":"ctreM","./queryObserver.esm.js":"j8c61","./subscribable.esm.js":"7pO8B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jwgeK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _mutationEsmJs = require("./mutation.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
// CLASS
class MutationObserver extends (0, _subscribableEsmJs.Subscribable) {
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, _mutationEsmJs.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener })=>{
                listener(this.currentResult);
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
}

},{"./mutation.esm.js":"4rn5e","./notifyManager.esm.js":"ctreM","./subscribable.esm.js":"7pO8B","./utils.esm.js":"780b5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dqbtB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
"use client";
const unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

},{"react-dom":"d8jlt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bTgvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>useQueries);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
var _suspenseEsmJs = require("./suspense.esm.js");
"use client";
function useQueries({ queries, context }) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    const defaultedQueries = _react.useMemo(()=>queries.map((options)=>{
            const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        queryClient,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, _suspenseEsmJs.ensureStaleTime)(query);
        (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new (0, _queryCore.QueriesObserver)(queryClient, defaultedQueries));
    const optimisticResult = observer.getOptimisticResult(defaultedQueries);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, _suspenseEsmJs.shouldSuspend)(defaultedQueries[index], result, isRestoring));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const options = defaultedQueries[index];
        const queryObserver = observer.getObservers()[index];
        if (options && queryObserver) {
            if ((0, _suspenseEsmJs.shouldSuspend)(options, result, isRestoring)) return (0, _suspenseEsmJs.fetchOptimistic)(options, queryObserver, errorResetBoundary);
            else if ((0, _suspenseEsmJs.willFetch)(result, isRestoring)) (0, _suspenseEsmJs.fetchOptimistic)(options, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const observerQueries = observer.getQueries();
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        var _defaultedQueries$ind, _defaultedQueries$ind2;
        return (0, _errorBoundaryUtilsEsmJs.getHasError)({
            result,
            errorResetBoundary,
            useErrorBoundary: (_defaultedQueries$ind = (_defaultedQueries$ind2 = defaultedQueries[index]) == null ? void 0 : _defaultedQueries$ind2.useErrorBoundary) != null ? _defaultedQueries$ind : false,
            query: observerQueries[index]
        });
    });
    if (firstSingleResultWhichShouldThrow != null && firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return optimisticResult;
}

},{"react":"gVheC","@tanstack/query-core":"eWvjq","./useSyncExternalStore.esm.js":"fVLTl","./QueryClientProvider.esm.js":"kQl5Z","./isRestoring.esm.js":"jaxV8","./QueryErrorResetBoundary.esm.js":"kirYb","./errorBoundaryUtils.esm.js":"1nXMn","./suspense.esm.js":"hCt9z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fVLTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>useSyncExternalStore);
var _indexJs = require("use-sync-external-store/shim/index.js");
"use client";
const useSyncExternalStore = (0, _indexJs.useSyncExternalStore);

},{"use-sync-external-store/shim/index.js":"cLdhI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kQl5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "defaultContext", ()=>defaultContext);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
var _react = require("react");
"use client";
const defaultContext = /*#__PURE__*/ _react.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/ _react.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
const useQueryClient = ({ context } = {})=>{
    const queryClient = _react.useContext(getQueryClientContext(context, _react.useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const QueryClientProvider = ({ client, children, context, contextSharing = false })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ _react.createElement(QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jaxV8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
var _react = require("react");
"use client";
const IsRestoringContext = /*#__PURE__*/ _react.createContext(false);
const useIsRestoring = ()=>_react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kirYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
var _react = require("react");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const QueryErrorResetBoundaryContext = /*#__PURE__*/ _react.createContext(createValue()); // HOOK
const useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext); // COMPONENT
const QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /*#__PURE__*/ _react.createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nXMn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
var _react = require("react");
var _utilsEsmJs = require("./utils.esm.js");
"use client";
const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const getHasError = ({ result, errorResetBoundary, useErrorBoundary, query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utilsEsmJs.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

},{"react":"gVheC","./utils.esm.js":"khjUd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"khjUd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hCt9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureStaleTime", ()=>ensureStaleTime);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
const ensureStaleTime = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fuQr8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryEsmJs = require("./useBaseQuery.esm.js");
"use client";
function useQuery(arg1, arg2, arg3) {
    const parsedOptions = (0, _queryCore.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQueryEsmJs.useBaseQuery)(parsedOptions, (0, _queryCore.QueryObserver));
}

},{"@tanstack/query-core":"eWvjq","./useBaseQuery.esm.js":"ddElh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddElh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
var _suspenseEsmJs = require("./suspense.esm.js");
"use client";
function useBaseQuery(options, Observer) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, _suspenseEsmJs.ensureStaleTime)(defaultedOptions);
    (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, _suspenseEsmJs.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, _suspenseEsmJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, _errorBoundaryUtilsEsmJs.getHasError)({
        result,
        errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"gVheC","@tanstack/query-core":"eWvjq","./useSyncExternalStore.esm.js":"fVLTl","./QueryErrorResetBoundary.esm.js":"kirYb","./QueryClientProvider.esm.js":"kQl5Z","./isRestoring.esm.js":"jaxV8","./errorBoundaryUtils.esm.js":"1nXMn","./suspense.esm.js":"hCt9z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7AXx2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
"use client";
function useMutation(arg1, arg2, arg3) {
    const options = (0, _queryCore.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const [observer] = _react.useState(()=>new (0, _queryCore.MutationObserver)(queryClient, options));
    _react.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = _react.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch(noop);
    }, [
        observer
    ]);
    if (result.error && (0, _utilsEsmJs.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

},{"react":"gVheC","@tanstack/query-core":"eWvjq","./useSyncExternalStore.esm.js":"fVLTl","./QueryClientProvider.esm.js":"kQl5Z","./utils.esm.js":"khjUd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Pdd3":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "addBusinessDays", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "addDays", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "addHours", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "addISOWeekYears", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "addMilliseconds", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "addMinutes", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "addMonths", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "addQuarters", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "addSeconds", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "addWeeks", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "addYears", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "areIntervalsOverlapping", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "closestIndexTo", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "closestTo", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "compareAsc", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "compareDesc", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "daysToWeeks", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "differenceInBusinessDays", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "differenceInCalendarDays", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "differenceInCalendarQuarters", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "differenceInCalendarWeeks", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "differenceInCalendarYears", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "differenceInDays", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "differenceInHours", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "differenceInISOWeekYears", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "differenceInMilliseconds", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "differenceInMinutes", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "differenceInMonths", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "differenceInQuarters", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "differenceInSeconds", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "differenceInWeeks", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "differenceInYears", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "eachDayOfInterval", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "eachHourOfInterval", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "eachMinuteOfInterval", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "eachMonthOfInterval", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "eachQuarterOfInterval", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "eachWeekOfInterval", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "eachWeekendOfInterval", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "eachWeekendOfMonth", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "eachWeekendOfYear", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "eachYearOfInterval", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "endOfDay", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "endOfDecade", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "endOfHour", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "endOfISOWeek", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "endOfISOWeekYear", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "endOfMinute", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "endOfMonth", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "endOfQuarter", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "endOfSecond", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "endOfToday", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "endOfTomorrow", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "endOfWeek", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "endOfYear", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "endOfYesterday", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "formatDistance", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "formatDistanceStrict", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "formatDistanceToNow", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "formatDistanceToNowStrict", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "formatDuration", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "formatISO", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "formatISO9075", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "formatISODuration", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "formatRFC3339", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "formatRFC7231", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "formatRelative", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "fromUnixTime", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "getDate", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "getDay", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "getDayOfYear", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "getDaysInMonth", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "getDaysInYear", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "getDecade", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "getDefaultOptions", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "getHours", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "getISODay", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "getISOWeek", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "getISOWeekYear", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "getISOWeeksInYear", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "getMilliseconds", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "getMinutes", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "getMonth", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "getQuarter", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "getSeconds", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "getTime", ()=>(0, _indexJsDefault92.default));
parcelHelpers.export(exports, "getUnixTime", ()=>(0, _indexJsDefault93.default));
parcelHelpers.export(exports, "getWeek", ()=>(0, _indexJsDefault94.default));
parcelHelpers.export(exports, "getWeekOfMonth", ()=>(0, _indexJsDefault95.default));
parcelHelpers.export(exports, "getWeekYear", ()=>(0, _indexJsDefault96.default));
parcelHelpers.export(exports, "getWeeksInMonth", ()=>(0, _indexJsDefault97.default));
parcelHelpers.export(exports, "getYear", ()=>(0, _indexJsDefault98.default));
parcelHelpers.export(exports, "hoursToMilliseconds", ()=>(0, _indexJsDefault99.default));
parcelHelpers.export(exports, "hoursToMinutes", ()=>(0, _indexJsDefault100.default));
parcelHelpers.export(exports, "hoursToSeconds", ()=>(0, _indexJsDefault101.default));
parcelHelpers.export(exports, "intervalToDuration", ()=>(0, _indexJsDefault102.default));
parcelHelpers.export(exports, "intlFormat", ()=>(0, _indexJsDefault103.default));
parcelHelpers.export(exports, "intlFormatDistance", ()=>(0, _indexJsDefault104.default));
parcelHelpers.export(exports, "isAfter", ()=>(0, _indexJsDefault105.default));
parcelHelpers.export(exports, "isBefore", ()=>(0, _indexJsDefault106.default));
parcelHelpers.export(exports, "isDate", ()=>(0, _indexJsDefault107.default));
parcelHelpers.export(exports, "isEqual", ()=>(0, _indexJsDefault108.default));
parcelHelpers.export(exports, "isExists", ()=>(0, _indexJsDefault109.default));
parcelHelpers.export(exports, "isFirstDayOfMonth", ()=>(0, _indexJsDefault110.default));
parcelHelpers.export(exports, "isFriday", ()=>(0, _indexJsDefault111.default));
parcelHelpers.export(exports, "isFuture", ()=>(0, _indexJsDefault112.default));
parcelHelpers.export(exports, "isLastDayOfMonth", ()=>(0, _indexJsDefault113.default));
parcelHelpers.export(exports, "isLeapYear", ()=>(0, _indexJsDefault114.default));
parcelHelpers.export(exports, "isMatch", ()=>(0, _indexJsDefault115.default));
parcelHelpers.export(exports, "isMonday", ()=>(0, _indexJsDefault116.default));
parcelHelpers.export(exports, "isPast", ()=>(0, _indexJsDefault117.default));
parcelHelpers.export(exports, "isSameDay", ()=>(0, _indexJsDefault118.default));
parcelHelpers.export(exports, "isSameHour", ()=>(0, _indexJsDefault119.default));
parcelHelpers.export(exports, "isSameISOWeek", ()=>(0, _indexJsDefault120.default));
parcelHelpers.export(exports, "isSameISOWeekYear", ()=>(0, _indexJsDefault121.default));
parcelHelpers.export(exports, "isSameMinute", ()=>(0, _indexJsDefault122.default));
parcelHelpers.export(exports, "isSameMonth", ()=>(0, _indexJsDefault123.default));
parcelHelpers.export(exports, "isSameQuarter", ()=>(0, _indexJsDefault124.default));
parcelHelpers.export(exports, "isSameSecond", ()=>(0, _indexJsDefault125.default));
parcelHelpers.export(exports, "isSameWeek", ()=>(0, _indexJsDefault126.default));
parcelHelpers.export(exports, "isSameYear", ()=>(0, _indexJsDefault127.default));
parcelHelpers.export(exports, "isSaturday", ()=>(0, _indexJsDefault128.default));
parcelHelpers.export(exports, "isSunday", ()=>(0, _indexJsDefault129.default));
parcelHelpers.export(exports, "isThisHour", ()=>(0, _indexJsDefault130.default));
parcelHelpers.export(exports, "isThisISOWeek", ()=>(0, _indexJsDefault131.default));
parcelHelpers.export(exports, "isThisMinute", ()=>(0, _indexJsDefault132.default));
parcelHelpers.export(exports, "isThisMonth", ()=>(0, _indexJsDefault133.default));
parcelHelpers.export(exports, "isThisQuarter", ()=>(0, _indexJsDefault134.default));
parcelHelpers.export(exports, "isThisSecond", ()=>(0, _indexJsDefault135.default));
parcelHelpers.export(exports, "isThisWeek", ()=>(0, _indexJsDefault136.default));
parcelHelpers.export(exports, "isThisYear", ()=>(0, _indexJsDefault137.default));
parcelHelpers.export(exports, "isThursday", ()=>(0, _indexJsDefault138.default));
parcelHelpers.export(exports, "isToday", ()=>(0, _indexJsDefault139.default));
parcelHelpers.export(exports, "isTomorrow", ()=>(0, _indexJsDefault140.default));
parcelHelpers.export(exports, "isTuesday", ()=>(0, _indexJsDefault141.default));
parcelHelpers.export(exports, "isValid", ()=>(0, _indexJsDefault142.default));
parcelHelpers.export(exports, "isWednesday", ()=>(0, _indexJsDefault143.default));
parcelHelpers.export(exports, "isWeekend", ()=>(0, _indexJsDefault144.default));
parcelHelpers.export(exports, "isWithinInterval", ()=>(0, _indexJsDefault145.default));
parcelHelpers.export(exports, "isYesterday", ()=>(0, _indexJsDefault146.default));
parcelHelpers.export(exports, "lastDayOfDecade", ()=>(0, _indexJsDefault147.default));
parcelHelpers.export(exports, "lastDayOfISOWeek", ()=>(0, _indexJsDefault148.default));
parcelHelpers.export(exports, "lastDayOfISOWeekYear", ()=>(0, _indexJsDefault149.default));
parcelHelpers.export(exports, "lastDayOfMonth", ()=>(0, _indexJsDefault150.default));
parcelHelpers.export(exports, "lastDayOfQuarter", ()=>(0, _indexJsDefault151.default));
parcelHelpers.export(exports, "lastDayOfWeek", ()=>(0, _indexJsDefault152.default));
parcelHelpers.export(exports, "lastDayOfYear", ()=>(0, _indexJsDefault153.default));
parcelHelpers.export(exports, "lightFormat", ()=>(0, _indexJsDefault154.default));
parcelHelpers.export(exports, "max", ()=>(0, _indexJsDefault155.default));
parcelHelpers.export(exports, "milliseconds", ()=>(0, _indexJsDefault156.default));
parcelHelpers.export(exports, "millisecondsToHours", ()=>(0, _indexJsDefault157.default));
parcelHelpers.export(exports, "millisecondsToMinutes", ()=>(0, _indexJsDefault158.default));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _indexJsDefault159.default));
parcelHelpers.export(exports, "min", ()=>(0, _indexJsDefault160.default));
parcelHelpers.export(exports, "minutesToHours", ()=>(0, _indexJsDefault161.default));
parcelHelpers.export(exports, "minutesToMilliseconds", ()=>(0, _indexJsDefault162.default));
parcelHelpers.export(exports, "minutesToSeconds", ()=>(0, _indexJsDefault163.default));
parcelHelpers.export(exports, "monthsToQuarters", ()=>(0, _indexJsDefault164.default));
parcelHelpers.export(exports, "monthsToYears", ()=>(0, _indexJsDefault165.default));
parcelHelpers.export(exports, "nextDay", ()=>(0, _indexJsDefault166.default));
parcelHelpers.export(exports, "nextFriday", ()=>(0, _indexJsDefault167.default));
parcelHelpers.export(exports, "nextMonday", ()=>(0, _indexJsDefault168.default));
parcelHelpers.export(exports, "nextSaturday", ()=>(0, _indexJsDefault169.default));
parcelHelpers.export(exports, "nextSunday", ()=>(0, _indexJsDefault170.default));
parcelHelpers.export(exports, "nextThursday", ()=>(0, _indexJsDefault171.default));
parcelHelpers.export(exports, "nextTuesday", ()=>(0, _indexJsDefault172.default));
parcelHelpers.export(exports, "nextWednesday", ()=>(0, _indexJsDefault173.default));
parcelHelpers.export(exports, "parse", ()=>(0, _indexJsDefault174.default));
parcelHelpers.export(exports, "parseISO", ()=>(0, _indexJsDefault175.default));
parcelHelpers.export(exports, "parseJSON", ()=>(0, _indexJsDefault176.default));
parcelHelpers.export(exports, "previousDay", ()=>(0, _indexJsDefault177.default));
parcelHelpers.export(exports, "previousFriday", ()=>(0, _indexJsDefault178.default));
parcelHelpers.export(exports, "previousMonday", ()=>(0, _indexJsDefault179.default));
parcelHelpers.export(exports, "previousSaturday", ()=>(0, _indexJsDefault180.default));
parcelHelpers.export(exports, "previousSunday", ()=>(0, _indexJsDefault181.default));
parcelHelpers.export(exports, "previousThursday", ()=>(0, _indexJsDefault182.default));
parcelHelpers.export(exports, "previousTuesday", ()=>(0, _indexJsDefault183.default));
parcelHelpers.export(exports, "previousWednesday", ()=>(0, _indexJsDefault184.default));
parcelHelpers.export(exports, "quartersToMonths", ()=>(0, _indexJsDefault185.default));
parcelHelpers.export(exports, "quartersToYears", ()=>(0, _indexJsDefault186.default));
parcelHelpers.export(exports, "roundToNearestMinutes", ()=>(0, _indexJsDefault187.default));
parcelHelpers.export(exports, "secondsToHours", ()=>(0, _indexJsDefault188.default));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _indexJsDefault189.default));
parcelHelpers.export(exports, "secondsToMinutes", ()=>(0, _indexJsDefault190.default));
parcelHelpers.export(exports, "set", ()=>(0, _indexJsDefault191.default));
parcelHelpers.export(exports, "setDate", ()=>(0, _indexJsDefault192.default));
parcelHelpers.export(exports, "setDay", ()=>(0, _indexJsDefault193.default));
parcelHelpers.export(exports, "setDayOfYear", ()=>(0, _indexJsDefault194.default));
parcelHelpers.export(exports, "setDefaultOptions", ()=>(0, _indexJsDefault195.default));
parcelHelpers.export(exports, "setHours", ()=>(0, _indexJsDefault196.default));
parcelHelpers.export(exports, "setISODay", ()=>(0, _indexJsDefault197.default));
parcelHelpers.export(exports, "setISOWeek", ()=>(0, _indexJsDefault198.default));
parcelHelpers.export(exports, "setISOWeekYear", ()=>(0, _indexJsDefault199.default));
parcelHelpers.export(exports, "setMilliseconds", ()=>(0, _indexJsDefault200.default));
parcelHelpers.export(exports, "setMinutes", ()=>(0, _indexJsDefault201.default));
parcelHelpers.export(exports, "setMonth", ()=>(0, _indexJsDefault202.default));
parcelHelpers.export(exports, "setQuarter", ()=>(0, _indexJsDefault203.default));
parcelHelpers.export(exports, "setSeconds", ()=>(0, _indexJsDefault204.default));
parcelHelpers.export(exports, "setWeek", ()=>(0, _indexJsDefault205.default));
parcelHelpers.export(exports, "setWeekYear", ()=>(0, _indexJsDefault206.default));
parcelHelpers.export(exports, "setYear", ()=>(0, _indexJsDefault207.default));
parcelHelpers.export(exports, "startOfDay", ()=>(0, _indexJsDefault208.default));
parcelHelpers.export(exports, "startOfDecade", ()=>(0, _indexJsDefault209.default));
parcelHelpers.export(exports, "startOfHour", ()=>(0, _indexJsDefault210.default));
parcelHelpers.export(exports, "startOfISOWeek", ()=>(0, _indexJsDefault211.default));
parcelHelpers.export(exports, "startOfISOWeekYear", ()=>(0, _indexJsDefault212.default));
parcelHelpers.export(exports, "startOfMinute", ()=>(0, _indexJsDefault213.default));
parcelHelpers.export(exports, "startOfMonth", ()=>(0, _indexJsDefault214.default));
parcelHelpers.export(exports, "startOfQuarter", ()=>(0, _indexJsDefault215.default));
parcelHelpers.export(exports, "startOfSecond", ()=>(0, _indexJsDefault216.default));
parcelHelpers.export(exports, "startOfToday", ()=>(0, _indexJsDefault217.default));
parcelHelpers.export(exports, "startOfTomorrow", ()=>(0, _indexJsDefault218.default));
parcelHelpers.export(exports, "startOfWeek", ()=>(0, _indexJsDefault219.default));
parcelHelpers.export(exports, "startOfWeekYear", ()=>(0, _indexJsDefault220.default));
parcelHelpers.export(exports, "startOfYear", ()=>(0, _indexJsDefault221.default));
parcelHelpers.export(exports, "startOfYesterday", ()=>(0, _indexJsDefault222.default));
parcelHelpers.export(exports, "sub", ()=>(0, _indexJsDefault223.default));
parcelHelpers.export(exports, "subBusinessDays", ()=>(0, _indexJsDefault224.default));
parcelHelpers.export(exports, "subDays", ()=>(0, _indexJsDefault225.default));
parcelHelpers.export(exports, "subHours", ()=>(0, _indexJsDefault226.default));
parcelHelpers.export(exports, "subISOWeekYears", ()=>(0, _indexJsDefault227.default));
parcelHelpers.export(exports, "subMilliseconds", ()=>(0, _indexJsDefault228.default));
parcelHelpers.export(exports, "subMinutes", ()=>(0, _indexJsDefault229.default));
parcelHelpers.export(exports, "subMonths", ()=>(0, _indexJsDefault230.default));
parcelHelpers.export(exports, "subQuarters", ()=>(0, _indexJsDefault231.default));
parcelHelpers.export(exports, "subSeconds", ()=>(0, _indexJsDefault232.default));
parcelHelpers.export(exports, "subWeeks", ()=>(0, _indexJsDefault233.default));
parcelHelpers.export(exports, "subYears", ()=>(0, _indexJsDefault234.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault235.default));
parcelHelpers.export(exports, "weeksToDays", ()=>(0, _indexJsDefault236.default));
parcelHelpers.export(exports, "yearsToMonths", ()=>(0, _indexJsDefault237.default));
parcelHelpers.export(exports, "yearsToQuarters", ()=>(0, _indexJsDefault238.default));
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":false,"./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":"4X9y5","./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":false,"./addYears/index.js":false,"./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":false,"./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":false,"./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":"fEX0N","./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":"9JQf2","./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":false,"./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":"hPDZF","./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":"6JnIb","./endOfYear/index.js":"75W7d","./endOfYesterday/index.js":false,"./format/index.js":"3Acgz","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":false,"./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":false,"./getWeek/index.js":false,"./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":false,"./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":false,"./isBefore/index.js":"l0WTP","./isDate/index.js":false,"./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":"eC4tq","./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":false,"./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":false,"./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":false,"./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":"krg17","./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":"iJnnQ","./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":false,"./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":"238sx","./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":false,"./parseISO/index.js":"a9ONv","./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":"5JhAS","./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":"5bz4E","./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":false,"./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":false,"./startOfDay/index.js":"6Tgor","./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":false,"./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":"aS0k4","./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":"dDXEC","./startOfWeekYear/index.js":false,"./startOfYear/index.js":"jls7k","./startOfYesterday/index.js":false,"./sub/index.js":"baj4x","./subBusinessDays/index.js":false,"./subDays/index.js":false,"./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":"lVgGE","./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":"7Y5kD","./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6XOcT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a6DX3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Y5kD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"dC70N","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dC70N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4uMay":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"edMlQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addMilliseconds/index.js":"iccQO","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iccQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3kpVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addMilliseconds/index.js":"iccQO","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4X9y5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Dt7q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addSeconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 1000);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addMilliseconds/index.js":"iccQO","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwUCs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addDays/index.js":"6XOcT","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"as84l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addMonths/index.js":"4X9y5","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2m8gA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compareAsc);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ftY8e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"5vgj3","../startOfDay/index.js":"6Tgor","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5vgj3":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Tgor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jaQVZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a21cj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gLOot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInDays);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js"); // Like `compareAsc` but uses local time not UTC, which is needed
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"7Y5kD","../differenceInCalendarDays/index.js":"ftY8e","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2zuWO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInHours);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInHours(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInHour);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"iU3gp","../differenceInMilliseconds/index.js":"30xWu","../_lib/requiredArgs/index.js":"4uMay","../_lib/roundingMethods/index.js":"jYUgM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iU3gp":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"30xWu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMilliseconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInMilliseconds(dateLeft, dateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dateLeft).getTime() - (0, _indexJsDefault.default)(dateRight).getTime();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jYUgM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
var roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
    return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ecpcR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMinutes);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInMinutes(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInMinute);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"iU3gp","../differenceInMilliseconds/index.js":"30xWu","../_lib/requiredArgs/index.js":"4uMay","../_lib/roundingMethods/index.js":"jYUgM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3dR9p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isLastDayOfMonth/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _indexJsDefault4.default)((0, _indexJsDefault.default)(dirtyDateLeft)) && difference === 1 && (0, _indexJsDefault2.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"7Y5kD","../differenceInCalendarMonths/index.js":"jaQVZ","../compareAsc/index.js":"2m8gA","../_lib/requiredArgs/index.js":"4uMay","../isLastDayOfMonth/index.js":"gQH14","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gQH14":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLastDayOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function isLastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    return (0, _indexJsDefault1.default)(date).getTime() === (0, _indexJsDefault2.default)(date).getTime();
}

},{"../toDate/index.js":"7Y5kD","../endOfDay/index.js":"9JQf2","../endOfMonth/index.js":"hPDZF","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9JQf2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hPDZF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kJ1sT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInQuarters);
var _indexJs = require("../differenceInMonths/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInQuarters(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 3;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMonths/index.js":"3dR9p","../_lib/requiredArgs/index.js":"4uMay","../_lib/roundingMethods/index.js":"jYUgM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j294I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInSeconds);
var _indexJs = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInSeconds(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 1000;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMilliseconds/index.js":"30xWu","../_lib/requiredArgs/index.js":"4uMay","../_lib/roundingMethods/index.js":"jYUgM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b5HX5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInWeeks);
var _indexJs = require("../differenceInDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInWeeks(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 7;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInDays/index.js":"gLOot","../_lib/requiredArgs/index.js":"4uMay","../_lib/roundingMethods/index.js":"jYUgM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"btMPu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"7Y5kD","../differenceInCalendarYears/index.js":"a21cj","../compareAsc/index.js":"2m8gA","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fEX0N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>eachDayOfInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function eachDayOfInterval(dirtyInterval, options) {
    var _options$step;
    (0, _indexJsDefault1.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault.default)(interval.start);
    var endDate = (0, _indexJsDefault.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6JnIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"jLNM5","../toDate/index.js":"7Y5kD","../_lib/toInteger/index.js":"a6DX3","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jLNM5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"75W7d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Acgz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"iFULx","../subMilliseconds/index.js":"5y8iq","../toDate/index.js":"7Y5kD","../_lib/format/formatters/index.js":"7kXGS","../_lib/format/longFormatters/index.js":"crABz","../_lib/getTimezoneOffsetInMilliseconds/index.js":"5vgj3","../_lib/protectedTokens/index.js":"k1c4I","../_lib/toInteger/index.js":"a6DX3","../_lib/requiredArgs/index.js":"4uMay","../_lib/defaultOptions/index.js":"jLNM5","../_lib/defaultLocale/index.js":"hhqZM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFULx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"5iYwi","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5iYwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@babel/runtime/helpers/esm/typeof":"dC70N","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5y8iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"iccQO","../_lib/requiredArgs/index.js":"4uMay","../_lib/toInteger/index.js":"a6DX3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7kXGS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"3Iivb","../../../_lib/getUTCISOWeek/index.js":"cZxg5","../../../_lib/getUTCISOWeekYear/index.js":"b22LI","../../../_lib/getUTCWeek/index.js":"hxH1J","../../../_lib/getUTCWeekYear/index.js":"9nRD7","../../addLeadingZeros/index.js":"9xzRB","../lightFormatters/index.js":"50XEa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Iivb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZxg5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"7Y5kD","../startOfUTCISOWeek/index.js":"eg3MG","../startOfUTCISOWeekYear/index.js":"9Vfex","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eg3MG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Vfex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"b22LI","../startOfUTCISOWeek/index.js":"eg3MG","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b22LI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","../startOfUTCISOWeek/index.js":"eg3MG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hxH1J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"7Y5kD","../startOfUTCWeek/index.js":"4h6AZ","../startOfUTCWeekYear/index.js":"9S3aL","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4h6AZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","../toInteger/index.js":"a6DX3","../defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9S3aL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"9nRD7","../requiredArgs/index.js":"4uMay","../startOfUTCWeek/index.js":"4h6AZ","../toInteger/index.js":"a6DX3","../defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9nRD7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","../startOfUTCWeek/index.js":"4h6AZ","../toInteger/index.js":"a6DX3","../defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9xzRB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"50XEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"9xzRB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crABz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k1c4I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hhqZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"lwe63","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwe63":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iaksO","./_lib/formatLong/index.js":"5FqBH","./_lib/formatRelative/index.js":"1QbYl","./_lib/localize/index.js":"3R0Xy","./_lib/match/index.js":"55K8R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iaksO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5FqBH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"jvJqD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jvJqD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QbYl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3R0Xy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"iwJar","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iwJar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"55K8R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"lU2NH","../../../_lib/buildMatchPatternFn/index.js":"7Ub0R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lU2NH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Ub0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6v9Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatISO);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO(date, options) {
    var _options$format, _options$representati;
    (0, _indexJsDefault2.default)(1, arguments);
    var originalDate = (0, _indexJsDefault.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, _indexJsDefault1.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault1.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault1.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _indexJsDefault1.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, _indexJsDefault1.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, _indexJsDefault1.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault1.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault1.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"../toDate/index.js":"7Y5kD","../_lib/addLeadingZeros/index.js":"9xzRB","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8C9eO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDate);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OE50j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kagXl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4rezk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHours);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tYf0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMinutes);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9gj3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8xyG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSeconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1o5Yb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h7lRu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0WTP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5DZDY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isEqual);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eC4tq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"6Tgor","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aEVKA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameHour);
var _indexJs = require("../startOfHour/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameHour(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfHour = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

},{"../startOfHour/index.js":"exwqd","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"exwqd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfHour);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfHour(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NTIM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lLQOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"krg17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWithinInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iJnnQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"dC70N","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ZzM1Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nextDay);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../getDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function nextDay(date, day) {
    (0, _indexJsDefault2.default)(2, arguments);
    var delta = day - (0, _indexJsDefault1.default)(date);
    if (delta <= 0) delta += 7;
    return (0, _indexJsDefault.default)(date, delta);
}

},{"../addDays/index.js":"6XOcT","../getDay/index.js":"OE50j","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"238sx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nextFriday);
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextFriday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 5);
}

},{"../nextDay/index.js":"ZzM1Q","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8pqAb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"dC70N","@babel/runtime/helpers/esm/createForOfIteratorHelper":"2DKQW","../_lib/defaultLocale/index.js":"hhqZM","../subMilliseconds/index.js":"5y8iq","../toDate/index.js":"7Y5kD","../_lib/assign/index.js":"j3I0m","../_lib/format/longFormatters/index.js":"crABz","../_lib/getTimezoneOffsetInMilliseconds/index.js":"5vgj3","../_lib/protectedTokens/index.js":"k1c4I","../_lib/toInteger/index.js":"a6DX3","../_lib/requiredArgs/index.js":"4uMay","./_lib/Setter.js":"4VsAM","./_lib/parsers/index.js":"b6py2","../_lib/defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2DKQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, _unsupportedIterableToArrayJsDefault.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"cMuX5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cMuX5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
}

},{"./arrayLikeToArray.js":"3QwAN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3QwAN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j3I0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4VsAM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9WRWO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iKolg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"hyVPU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hyVPU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ItpE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJsDefault.default)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJsDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, result);
    };
}

},{"./getPrototypeOf.js":"aEj1N","./isNativeReflectConstruct.js":"OwDOk","./possibleConstructorReturn.js":"hEdY9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aEj1N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"OwDOk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hEdY9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeofJsDefault.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(self);
}

},{"./typeof.js":"dC70N","./assertThisInitialized.js":"9WRWO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gYHBu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7OgJR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _toPropertyKeyJsDefault.default)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

},{"./toPropertyKey.js":"4TadU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4TadU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : String(i);
}

},{"./typeof.js":"dC70N","./toPrimitive.js":"hDahS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hDahS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"dC70N","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5R3Vd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"4TadU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b6py2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"04WDD","./YearParser.js":"6Doly","./LocalWeekYearParser.js":"es0lm","./ISOWeekYearParser.js":"6xc39","./ExtendedYearParser.js":"bc0qZ","./QuarterParser.js":"lAyea","./StandAloneQuarterParser.js":"8qPPs","./MonthParser.js":"5EEvk","./StandAloneMonthParser.js":"e0dxt","./LocalWeekParser.js":"7jIwd","./ISOWeekParser.js":"65Tcl","./DateParser.js":"jU2Mg","./DayOfYearParser.js":"43VAx","./DayParser.js":"4OA6O","./LocalDayParser.js":"1RqBa","./StandAloneLocalDayParser.js":"hr3mP","./ISODayParser.js":"1BA6M","./AMPMParser.js":"bxqTm","./AMPMMidnightParser.js":"fF2EC","./DayPeriodParser.js":"iVW7W","./Hour1to12Parser.js":"6iiAp","./Hour0to23Parser.js":"cEXHq","./Hour0To11Parser.js":"6wGCG","./Hour1To24Parser.js":"2fpUD","./MinuteParser.js":"dRkay","./SecondParser.js":"l1bjI","./FractionOfSecondParser.js":"jXgzt","./ISOTimezoneWithZParser.js":"1JMOO","./ISOTimezoneParser.js":"6VAcl","./TimestampSecondsParser.js":"9ZDRp","./TimestampMillisecondsParser.js":"4Xx2F","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"04WDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iLcuX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","./Setter.js":"4VsAM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Doly":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdsHT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"iU3gp","./constants.js":"3EHhF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3EHhF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"es0lm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","../../../_lib/getUTCWeekYear/index.js":"9nRD7","../../../_lib/startOfUTCWeek/index.js":"4h6AZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6xc39":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","../../../_lib/startOfUTCISOWeek/index.js":"eg3MG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bc0qZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lAyea":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qPPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5EEvk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../utils.js":"gdsHT","../Parser.js":"iLcuX","../constants.js":"3EHhF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e0dxt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7jIwd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","../../../_lib/setUTCWeek/index.js":"fpFvP","../../../_lib/startOfUTCWeek/index.js":"4h6AZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fpFvP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"a6DX3","../../toDate/index.js":"7Y5kD","../getUTCWeek/index.js":"hxH1J","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"65Tcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","../../../_lib/setUTCISOWeek/index.js":"gmQZ8","../../../_lib/startOfUTCISOWeek/index.js":"eg3MG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gmQZ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"a6DX3","../../toDate/index.js":"7Y5kD","../getUTCISOWeek/index.js":"cZxg5","../requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jU2Mg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../utils.js":"gdsHT","../Parser.js":"iLcuX","../constants.js":"3EHhF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"43VAx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4OA6O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../../../_lib/setUTCDay/index.js":"eny8u","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eny8u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","../toInteger/index.js":"a6DX3","../defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1RqBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","../../../_lib/setUTCDay/index.js":"eny8u","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hr3mP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","../../../_lib/setUTCDay/index.js":"eny8u","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1BA6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","../../../_lib/setUTCISODay/index.js":"l4Ff2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l4Ff2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"7Y5kD","../requiredArgs/index.js":"4uMay","../toInteger/index.js":"a6DX3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bxqTm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fF2EC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iVW7W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6iiAp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cEXHq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6wGCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2fpUD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRkay":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l1bjI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jXgzt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1JMOO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6VAcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../constants.js":"3EHhF","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ZDRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Xx2F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"gYHBu","@babel/runtime/helpers/esm/createClass":"7OgJR","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inherits":"iKolg","@babel/runtime/helpers/esm/createSuper":"3ItpE","@babel/runtime/helpers/esm/defineProperty":"5R3Vd","../Parser.js":"iLcuX","../utils.js":"gdsHT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a9ONv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseISO);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"iU3gp","../_lib/requiredArgs/index.js":"4uMay","../_lib/toInteger/index.js":"a6DX3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"heKUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>previousDay);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../getDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../subDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function previousDay(date, day) {
    (0, _indexJsDefault.default)(2, arguments);
    var delta = (0, _indexJsDefault1.default)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, _indexJsDefault2.default)(date, delta);
}

},{"../_lib/requiredArgs/index.js":"4uMay","../getDay/index.js":"OE50j","../subDays/index.js":"8lSln","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8lSln":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"6XOcT","../_lib/requiredArgs/index.js":"4uMay","../_lib/toInteger/index.js":"a6DX3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5JhAS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>previousFriday);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousFriday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 5);
}

},{"../_lib/requiredArgs/index.js":"4uMay","../previousDay/index.js":"heKUI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"q9Izj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setDate);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setDate(dirtyDate, dirtyDayOfMonth) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var dayOfMonth = (0, _indexJsDefault.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5bz4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setDefaultOptions);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
function setDefaultOptions(newOptions) {
    (0, _indexJsDefault.default)(1, arguments);
    var result = {};
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) result[property] = defaultOptions[property];
    for(var _property in newOptions)if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
        if (newOptions[_property] === undefined) delete result[_property];
        else result[_property] = newOptions[_property];
    }
    (0, _indexJs.setDefaultOptions)(result);
}

},{"../_lib/defaultOptions/index.js":"jLNM5","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iG5Uv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fH1Fu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6F1a7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../getDaysInMonth/index.js":"kagXl","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"38SuV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3zvJC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"a6DX3","../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aS0k4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dDXEC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/toInteger/index.js":"a6DX3","../_lib/requiredArgs/index.js":"4uMay","../_lib/defaultOptions/index.js":"jLNM5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jls7k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"7Y5kD","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"baj4x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sub);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../subDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function sub(date, duration) {
    (0, _indexJsDefault2.default)(2, arguments);
    if (!duration || (0, _typeofDefault.default)(duration) !== "object") return new Date(NaN);
    var years = duration.years ? (0, _indexJsDefault3.default)(duration.years) : 0;
    var months = duration.months ? (0, _indexJsDefault3.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, _indexJsDefault3.default)(duration.weeks) : 0;
    var days = duration.days ? (0, _indexJsDefault3.default)(duration.days) : 0;
    var hours = duration.hours ? (0, _indexJsDefault3.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, _indexJsDefault3.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, _indexJsDefault3.default)(duration.seconds) : 0;
    // Subtract years and months
    var dateWithoutMonths = (0, _indexJsDefault1.default)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, _indexJsDefault.default)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

},{"@babel/runtime/helpers/esm/typeof":"dC70N","../subDays/index.js":"8lSln","../subMonths/index.js":"lVgGE","../_lib/requiredArgs/index.js":"4uMay","../_lib/toInteger/index.js":"a6DX3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lVgGE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"a6DX3","../addMonths/index.js":"4X9y5","../_lib/requiredArgs/index.js":"4uMay","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QVlm":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "ar", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "arDZ", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "arEG", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "arMA", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "arSA", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "arTN", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "az", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "be", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "beTarask", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "bg", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "bn", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "bs", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "ca", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "cs", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "cy", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "da", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "de", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "deAT", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "el", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "enAU", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "enCA", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "enGB", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "enIE", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "enIN", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "enNZ", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "enUS", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "enZA", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "eo", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "es", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "et", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "eu", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "faIR", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "fi", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "fr", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "frCA", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "frCH", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "fy", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "gd", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "gl", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "gu", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "he", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "hi", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "hr", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "ht", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "hu", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "hy", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "id", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "is", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "it", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "itCH", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "ja", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "jaHira", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "ka", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "kk", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "km", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "kn", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "ko", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "lb", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "lt", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "lv", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "mk", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "mn", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "ms", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "mt", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "nb", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "nl", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "nlBE", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "nn", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "oc", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "pl", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "pt", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "ptBR", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "ro", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "ru", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "sk", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "sl", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "sq", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "sr", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "srLatn", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "sv", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "ta", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "te", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "th", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "tr", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "ug", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "uk", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "uz", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "uzCyrl", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "vi", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "zhCN", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "zhHK", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "zhTW", ()=>(0, _indexJsDefault92.default));
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":false,"./ar/index.js":false,"./ar-DZ/index.js":false,"./ar-EG/index.js":false,"./ar-MA/index.js":false,"./ar-SA/index.js":false,"./ar-TN/index.js":false,"./az/index.js":false,"./be/index.js":false,"./be-tarask/index.js":false,"./bg/index.js":false,"./bn/index.js":false,"./bs/index.js":false,"./ca/index.js":false,"./cs/index.js":false,"./cy/index.js":false,"./da/index.js":false,"./de/index.js":false,"./de-AT/index.js":false,"./el/index.js":false,"./en-AU/index.js":false,"./en-CA/index.js":false,"./en-GB/index.js":"2rNE2","./en-IE/index.js":false,"./en-IN/index.js":false,"./en-NZ/index.js":false,"./en-US/index.js":false,"./en-ZA/index.js":false,"./eo/index.js":false,"./es/index.js":false,"./et/index.js":false,"./eu/index.js":false,"./fa-IR/index.js":false,"./fi/index.js":false,"./fr/index.js":false,"./fr-CA/index.js":false,"./fr-CH/index.js":false,"./fy/index.js":false,"./gd/index.js":false,"./gl/index.js":false,"./gu/index.js":false,"./he/index.js":false,"./hi/index.js":false,"./hr/index.js":false,"./ht/index.js":false,"./hu/index.js":false,"./hy/index.js":false,"./id/index.js":false,"./is/index.js":false,"./it/index.js":false,"./it-CH/index.js":false,"./ja/index.js":false,"./ja-Hira/index.js":false,"./ka/index.js":false,"./kk/index.js":false,"./km/index.js":false,"./kn/index.js":false,"./ko/index.js":false,"./lb/index.js":false,"./lt/index.js":false,"./lv/index.js":false,"./mk/index.js":false,"./mn/index.js":false,"./ms/index.js":false,"./mt/index.js":false,"./nb/index.js":false,"./nl/index.js":false,"./nl-BE/index.js":false,"./nn/index.js":false,"./oc/index.js":false,"./pl/index.js":false,"./pt/index.js":false,"./pt-BR/index.js":false,"./ro/index.js":false,"./ru/index.js":false,"./sk/index.js":false,"./sl/index.js":false,"./sq/index.js":false,"./sr/index.js":false,"./sr-Latn/index.js":false,"./sv/index.js":false,"./ta/index.js":false,"./te/index.js":false,"./th/index.js":false,"./tr/index.js":false,"./ug/index.js":false,"./uk/index.js":false,"./uz/index.js":false,"./uz-Cyrl/index.js":false,"./vi/index.js":false,"./zh-CN/index.js":false,"./zh-HK/index.js":false,"./zh-TW/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2rNE2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var locale = {
    code: "en-GB",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"iaksO","../en-US/_lib/formatRelative/index.js":"1QbYl","../en-US/_lib/localize/index.js":"3R0Xy","../en-US/_lib/match/index.js":"55K8R","./_lib/formatLong/index.js":"c5YsJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c5YsJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"jvJqD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Lc8y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnackbarContent", ()=>SnackbarContent);
parcelHelpers.export(exports, "SnackbarProvider", ()=>SnackbarProvider);
parcelHelpers.export(exports, "useSnackbar", ()=>useSnackbar);
parcelHelpers.export(exports, "withSnackbar", ()=>withSnackbar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _slide = require("@mui/material/Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
var _styles = require("@mui/material/styles");
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var SnackbarContext = /*#__PURE__*/ (0, _reactDefault.default).createContext();
var allClasses = {
    mui: {
        root: {},
        anchorOriginTopCenter: {},
        anchorOriginBottomCenter: {},
        anchorOriginTopRight: {},
        anchorOriginBottomRight: {},
        anchorOriginTopLeft: {},
        anchorOriginBottomLeft: {}
    },
    container: {
        containerRoot: {},
        containerAnchorOriginTopCenter: {},
        containerAnchorOriginBottomCenter: {},
        containerAnchorOriginTopRight: {},
        containerAnchorOriginBottomRight: {},
        containerAnchorOriginTopLeft: {},
        containerAnchorOriginBottomLeft: {}
    }
};
var MESSAGES = {
    NO_PERSIST_ALL: "WARNING - notistack: Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var SNACKBAR_INDENTS = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var DEFAULTS = {
    maxSnack: 3,
    dense: false,
    hideIconVariant: false,
    variant: "default",
    autoHideDuration: 5000,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    TransitionComponent: (0, _slideDefault.default),
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
var capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var omitContainerKeys = function omitContainerKeys(classes) {
    return Object.keys(classes).filter(function(key) {
        return !allClasses.container[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var REASONS = {
    TIMEOUT: "timeout",
    CLICKAWAY: "clickaway",
    MAXSNACK: "maxsnack",
    INSTRUCTED: "instructed"
};
/** Tranforms classes name */ var transformer = {
    toContainerAnchorOrigin: function toContainerAnchorOrigin(origin) {
        return "containerAnchorOrigin" + origin;
    },
    toAnchorOrigin: function toAnchorOrigin(_ref) {
        var vertical = _ref.vertical, horizontal = _ref.horizontal;
        return "anchorOrigin" + capitalise(vertical) + capitalise(horizontal);
    },
    toVariant: function toVariant(variant) {
        return "variant" + capitalise(variant);
    }
};
var isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var numberOrNull = function numberOrNull(numberish) {
    return typeof numberish === "number" || numberish === null;
}; // @ts-ignore
var merge = function merge(options, props, defaults) {
    return function(name) {
        if (name === "autoHideDuration") {
            if (numberOrNull(options.autoHideDuration)) return options.autoHideDuration;
            if (numberOrNull(props.autoHideDuration)) return props.autoHideDuration;
            return DEFAULTS.autoHideDuration;
        }
        return options[name] || props[name] || defaults[name];
    };
};
function objectMerge(options, props, defaults) {
    if (options === void 0) options = {};
    if (props === void 0) props = {};
    if (defaults === void 0) defaults = {};
    return _extends({}, defaults, {}, props, {}, options);
}
var componentName = "SnackbarContent";
var classes = {
    root: componentName + "-root"
};
var Root = /*#__PURE__*/ (0, _styles.styled)("div")(function(_ref) {
    var _ref2, _ref3;
    var theme = _ref.theme;
    return _ref3 = {}, _ref3["&." + classes.root] = (_ref2 = {
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1
    }, _ref2[theme.breakpoints.up("sm")] = {
        flexGrow: "initial",
        minWidth: 288
    }, _ref2), _ref3;
});
var SnackbarContent = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref4, ref) {
    var className = _ref4.className, props = _objectWithoutPropertiesLoose(_ref4, [
        "className"
    ]);
    return (0, _reactDefault.default).createElement(Root, Object.assign({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, props));
});
var DIRECTION = {
    right: "left",
    left: "right",
    bottom: "up",
    top: "down"
};
var getTransitionDirection = function getTransitionDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== "center") return DIRECTION[anchorOrigin.horizontal];
    return DIRECTION[anchorOrigin.vertical];
};
var CheckIcon = function CheckIcon(props) {
    return (0, _reactDefault.default).createElement((0, _svgIconDefault.default), Object.assign({}, props), (0, _reactDefault.default).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var WarningIcon = function WarningIcon(props) {
    return (0, _reactDefault.default).createElement((0, _svgIconDefault.default), Object.assign({}, props), (0, _reactDefault.default).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var ErrorIcon = function ErrorIcon(props) {
    return (0, _reactDefault.default).createElement((0, _svgIconDefault.default), Object.assign({}, props), (0, _reactDefault.default).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var InfoIcon = function InfoIcon(props) {
    return (0, _reactDefault.default).createElement((0, _svgIconDefault.default), Object.assign({}, props), (0, _reactDefault.default).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var iconStyles = {
    fontSize: 20,
    marginInlineEnd: 8
};
var defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckIcon, {
        style: iconStyles
    }),
    warning: /*#__PURE__*/ (0, _reactDefault.default).createElement(WarningIcon, {
        style: iconStyles
    }),
    error: /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorIcon, {
        style: iconStyles
    }),
    info: /*#__PURE__*/ (0, _reactDefault.default).createElement(InfoIcon, {
        style: iconStyles
    })
};
/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/createChainedFunction.js
 */ function createChainedFunction(funcs, extraArg) {
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (extraArg && argums.indexOf(extraArg) === -1) argums.push(extraArg);
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, function() {});
}
/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/useEventCallback.js
 */ var useEnhancedEffect = typeof window !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEventCallback(fn) {
    var ref = (0, _react.useRef)(fn);
    useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, _react.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
var Snackbar = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, autoHideDuration = props.autoHideDuration, ClickAwayListenerProps = props.ClickAwayListenerProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, other = _objectWithoutPropertiesLoose(props, [
        "children",
        "autoHideDuration",
        "ClickAwayListenerProps",
        "disableWindowBlurListener",
        "onClose",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration"
    ]);
    var timerAutoHide = (0, _react.useRef)();
    var handleClose = useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, REASONS.TIMEOUT);
        }, autoHideDurationParam);
    });
    (0, _react.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, _react.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, REASONS.CLICKAWAY);
    };
    (0, _react.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, _react.createElement)((0, _clickAwayListenerDefault.default), _extends({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), (0, _react.createElement)("div", _extends({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), children));
});
var componentName$1 = "SnackbarItem";
var classes$1 = {
    contentRoot: componentName$1 + "-contentRoot",
    lessPadding: componentName$1 + "-lessPadding",
    variantSuccess: componentName$1 + "-variantSuccess",
    variantError: componentName$1 + "-variantError",
    variantInfo: componentName$1 + "-variantInfo",
    variantWarning: componentName$1 + "-variantWarning",
    message: componentName$1 + "-message",
    action: componentName$1 + "-action",
    wrappedRoot: componentName$1 + "-wrappedRoot"
};
var StyledSnackbar = /*#__PURE__*/ (0, _styles.styled)(Snackbar)(function(_ref) {
    var _ref2;
    var theme = _ref.theme;
    var mode = theme.palette.mode || theme.palette.type;
    var backgroundColor = (0, _styles.emphasize)(theme.palette.background["default"], mode === "light" ? 0.8 : 0.98);
    return _ref2 = {}, _ref2["&." + classes$1.wrappedRoot] = {
        position: "relative",
        transform: "translateX(0)",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, _ref2["." + classes$1.contentRoot] = _extends({}, theme.typography.body2, {
        backgroundColor: backgroundColor,
        color: theme.palette.getContrastText(backgroundColor),
        alignItems: "center",
        padding: "6px 16px",
        borderRadius: "4px",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    }), _ref2["." + classes$1.lessPadding] = {
        paddingLeft: 20
    }, _ref2["." + classes$1.variantSuccess] = {
        backgroundColor: "#43a047",
        color: "#fff"
    }, _ref2["." + classes$1.variantError] = {
        backgroundColor: "#d32f2f",
        color: "#fff"
    }, _ref2["." + classes$1.variantInfo] = {
        backgroundColor: "#2196f3",
        color: "#fff"
    }, _ref2["." + classes$1.variantWarning] = {
        backgroundColor: "#ff9800",
        color: "#fff"
    }, _ref2["." + classes$1.message] = {
        display: "flex",
        alignItems: "center",
        padding: "8px 0"
    }, _ref2["." + classes$1.action] = {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        paddingLeft: 16,
        marginRight: -8
    }, _ref2;
});
var SnackbarItem = function SnackbarItem(_ref3) {
    var propClasses = _ref3.classes, props = _objectWithoutPropertiesLoose(_ref3, [
        "classes"
    ]);
    var timeout = (0, _react.useRef)();
    var _useState = (0, _react.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    (0, _react.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var handleClose = createChainedFunction([
        props.snack.onClose,
        props.onClose
    ], props.snack.key);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, REASONS.INSTRCUTED);
    };
    var handleExitedScreen = function handleExitedScreen() {
        timeout.current = setTimeout(function() {
            setCollapsed(!collapsed);
        }, 125);
    };
    var style = props.style, otherAriaAttributes = props.ariaAttributes, otherClassName = props.className, hideIconVariant = props.hideIconVariant, iconVariant = props.iconVariant, snack = props.snack, otherAction = props.action, otherContent = props.content, otherTranComponent = props.TransitionComponent, otherTranProps = props.TransitionProps, otherTranDuration = props.transitionDuration, other = _objectWithoutPropertiesLoose(props, [
        "style",
        "dense",
        "ariaAttributes",
        "className",
        "hideIconVariant",
        "iconVariant",
        "snack",
        "action",
        "content",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting"
    ]);
    var key = snack.key, open = snack.open, singleClassName = snack.className, variant = snack.variant, singleContent = snack.content, singleAction = snack.action, singleAriaAttributes = snack.ariaAttributes, anchorOrigin = snack.anchorOrigin, snackMessage = snack.message, singleTranComponent = snack.TransitionComponent, singleTranProps = snack.TransitionProps, singleTranDuration = snack.transitionDuration, singleSnackProps = _objectWithoutPropertiesLoose(snack, [
        "persist",
        "key",
        "open",
        "entered",
        "requestClose",
        "className",
        "variant",
        "content",
        "action",
        "ariaAttributes",
        "anchorOrigin",
        "message",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting"
    ]);
    var icon = _extends({}, defaultIconVariants, {}, iconVariant)[variant];
    var ariaAttributes = _extends({
        "aria-describedby": "notistack-snackbar"
    }, objectMerge(singleAriaAttributes, otherAriaAttributes));
    var TransitionComponent = singleTranComponent || otherTranComponent || DEFAULTS.TransitionComponent;
    var transitionDuration = objectMerge(singleTranDuration, otherTranDuration, DEFAULTS.transitionDuration);
    var transitionProps = _extends({
        direction: getTransitionDirection(anchorOrigin)
    }, objectMerge(singleTranProps, otherTranProps));
    var action = singleAction || otherAction;
    if (typeof action === "function") action = action(key);
    var content = singleContent || otherContent;
    if (typeof content === "function") content = content(key, snack.message);
     // eslint-disable-next-line operator-linebreak
    var callbacks = [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited"
    ].reduce(function(acc, cbName) {
        var _extends2;
        return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], props.snack.key), _extends2));
    }, {});
    return (0, _reactDefault.default).createElement((0, _collapseDefault.default), {
        unmountOnExit: true,
        timeout: 175,
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, _reactDefault.default).createElement(StyledSnackbar, Object.assign({}, other, singleSnackProps, {
        open: open,
        className: (0, _clsxDefault.default)(propClasses.root, classes$1.wrappedRoot, propClasses[transformer.toAnchorOrigin(anchorOrigin)]),
        onClose: handleClose
    }), (0, _reactDefault.default).createElement(TransitionComponent, Object.assign({
        appear: true,
        "in": open,
        timeout: transitionDuration
    }, transitionProps, {
        onExit: callbacks.onExit,
        onExiting: callbacks.onExiting,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        onEntering: callbacks.onEntering,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ])
    }), content || (0, _reactDefault.default).createElement(SnackbarContent, Object.assign({}, ariaAttributes, {
        role: "alert",
        style: style,
        className: (0, _clsxDefault.default)(classes$1.contentRoot, classes$1[transformer.toVariant(variant)], propClasses[transformer.toVariant(variant)], otherClassName, singleClassName, !hideIconVariant && icon && classes$1.lessPadding)
    }), (0, _reactDefault.default).createElement("div", {
        id: ariaAttributes["aria-describedby"],
        className: classes$1.message
    }, !hideIconVariant ? icon : null, snackMessage), action && (0, _reactDefault.default).createElement("div", {
        className: classes$1.action
    }, action)))));
};
var collapse = {
    // Material-UI 4.12.x and above uses MuiCollapse-root; earlier versions use
    // Mui-Collapse-container.  https://github.com/mui-org/material-ui/pull/24084
    container: "& > .MuiCollapse-container, & > .MuiCollapse-root",
    wrapper: "& > .MuiCollapse-container > .MuiCollapse-wrapper, & > .MuiCollapse-root > .MuiCollapse-wrapper"
};
var xsWidthMargin = 16;
var componentName$2 = "SnackbarContainer";
var classes$2 = {
    root: componentName$2 + "-root",
    rootDense: componentName$2 + "-rootDense",
    top: componentName$2 + "-top",
    bottom: componentName$2 + "-bottom",
    left: componentName$2 + "-left",
    right: componentName$2 + "-right",
    center: componentName$2 + "-center"
};
var Root$1 = /*#__PURE__*/ (0, _styles.styled)("div")(function(_ref) {
    var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
    var theme = _ref.theme;
    return _ref7 = {}, _ref7["&." + classes$2.root] = (_ref2 = {
        boxSizing: "border-box",
        display: "flex",
        maxHeight: "100%",
        position: "fixed",
        zIndex: theme.zIndex.snackbar,
        height: "auto",
        width: "auto",
        transition: "top 300ms ease 0ms, right 300ms ease 0ms, bottom 300ms ease 0ms, left 300ms ease 0ms, margin 300ms ease 0ms, max-width 300ms ease 0ms",
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        pointerEvents: "none"
    }, _ref2[collapse.container] = {
        pointerEvents: "all"
    }, _ref2[collapse.wrapper] = {
        padding: SNACKBAR_INDENTS.snackbar["default"] + "px 0px",
        transition: "padding 300ms ease 0ms"
    }, _ref2.maxWidth = "calc(100% - " + SNACKBAR_INDENTS.view["default"] * 2 + "px)", _ref2[theme.breakpoints.down("sm")] = {
        width: "100%",
        maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
    }, _ref2), _ref7["&." + classes$2.rootDense] = (_ref3 = {}, _ref3[collapse.wrapper] = {
        padding: SNACKBAR_INDENTS.snackbar.dense + "px 0px"
    }, _ref3), _ref7["&." + classes$2.top] = {
        top: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
        flexDirection: "column"
    }, _ref7["&." + classes$2.bottom] = {
        bottom: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
        flexDirection: "column-reverse"
    }, _ref7["&." + classes$2.left] = (_ref4 = {
        left: SNACKBAR_INDENTS.view["default"]
    }, _ref4[theme.breakpoints.up("sm")] = {
        alignItems: "flex-start"
    }, _ref4[theme.breakpoints.down("sm")] = {
        left: xsWidthMargin + "px"
    }, _ref4), _ref7["&." + classes$2.right] = (_ref5 = {
        right: SNACKBAR_INDENTS.view["default"]
    }, _ref5[theme.breakpoints.up("sm")] = {
        alignItems: "flex-end"
    }, _ref5[theme.breakpoints.down("sm")] = {
        right: xsWidthMargin + "px"
    }, _ref5), _ref7["&." + classes$2.center] = (_ref6 = {
        left: "50%",
        transform: "translateX(-50%)"
    }, _ref6[theme.breakpoints.up("sm")] = {
        alignItems: "center"
    }, _ref6), _ref7;
});
var SnackbarContainer = function SnackbarContainer(props) {
    var className = props.className, anchorOrigin = props.anchorOrigin, dense = props.dense, other = _objectWithoutPropertiesLoose(props, [
        "className",
        "anchorOrigin",
        "dense"
    ]);
    var combinedClassname = (0, _clsxDefault.default)(classes$2[anchorOrigin.vertical], classes$2[anchorOrigin.horizontal], classes$2.root, className, dense && classes$2.rootDense);
    return (0, _reactDefault.default).createElement(Root$1, Object.assign({
        className: combinedClassname
    }, other));
};
var SnackbarContainer$1 = /*#__PURE__*/ (0, _reactDefault.default).memo(SnackbarContainer);
/* eslint-disable */ var __DEV__ = false;
var warning = function(message) {
    if (!__DEV__) return;
    if (typeof console !== "undefined") console.error(message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var SnackbarProvider = /*#__PURE__*/ function(_Component) {
    _inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(message, opts) {
            if (opts === void 0) opts = {};
            var _opts = opts, key = _opts.key, preventDuplicate = _opts.preventDuplicate, options = _objectWithoutPropertiesLoose(_opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = merge(options, _this.props, DEFAULTS);
            var snack = _extends({
                key: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                variant: merger("variant"),
                anchorOrigin: merger("anchorOrigin"),
                autoHideDuration: merger("autoHideDuration")
            });
            if (options.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.key === key : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack(_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return _extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return _extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, REASONS.MAXSNACK, item.key);
                    if (_this.props.onClose) _this.props.onClose(null, REASONS.MAXSNACK, item.key);
                    return _extends({}, item, {
                        open: false
                    });
                }
                return _extends({}, item);
            });
            return _extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!isDefined(key)) throw new Error("handleEnteredSnack Cannot be called with undefined key");
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.key === key ? _extends({}, item, {
                            entered: true
                        }) : _extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            if (reason === REASONS.CLICKAWAY) return;
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.key !== key) return _extends({}, item);
                        return item.entered ? _extends({}, item, {
                            open: false
                        }) : _extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.key !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.key === key;
            });
            if (isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, REASONS.INSTRUCTED, key);
            _this.handleCloseSnack(null, REASONS.INSTRUCTED, key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ // @ts-ignore
        _this.handleExitedSnack = function(event, key1, key2) {
            var key = key1 || key2;
            if (!isDefined(key)) throw new Error("handleExitedSnack Cannot be called with undefined key");
            _this.setState(function(state) {
                var newState = _this.processQueue(_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.key !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind(_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind(_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, iconVariant = _this$props.iconVariant, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? DEFAULTS.dense : _this$props$dense, _this$props$hideIconV = _this$props.hideIconVariant, hideIconVariant = _this$props$hideIconV === void 0 ? DEFAULTS.hideIconVariant : _this$props$hideIconV, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$classes = _this$props.classes, classes = _this$props$classes === void 0 ? {} : _this$props$classes, props = _objectWithoutPropertiesLoose(_this$props, [
            "maxSnack",
            "preventDuplicate",
            "variant",
            "anchorOrigin",
            "iconVariant",
            "dense",
            "hideIconVariant",
            "domRoot",
            "children",
            "classes"
        ]);
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            return (0, _reactDefault.default).createElement(SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: snacks[0].anchorOrigin,
                className: (0, _clsxDefault.default)(classes.containerRoot, classes[transformer.toContainerAnchorOrigin(origin)])
            }, snacks.map(function(snack) {
                return (0, _reactDefault.default).createElement(SnackbarItem, Object.assign({}, props, {
                    key: snack.key,
                    snack: snack,
                    dense: dense,
                    iconVariant: iconVariant,
                    hideIconVariant: hideIconVariant,
                    classes: omitContainerKeys(classes),
                    onClose: _this2.handleCloseSnack,
                    onExited: createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ]),
                    onEntered: createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ])
                }));
            }));
        });
        return (0, _reactDefault.default).createElement(SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, _reactDom.createPortal)(snackbars, domRoot) : snackbars);
    };
    _createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || DEFAULTS.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, _react.Component));
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
var getFunctionName = function getFunctionName(fn) {
    var match = ("" + fn).match(fnNameMatchRegex);
    var name = match && match[1];
    return name || "";
};
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */ var getFunctionComponentName = function getFunctionComponentName(Component, fallback) {
    if (fallback === void 0) fallback = "";
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
};
var getWrappedName = function getWrappedName(outerType, innerType, wrapperName) {
    var functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
};
/** 
 * From react-is
 * @link https://github.com/facebook/react/blob/master/packages/shared/ReactSymbols.js
 */ var ForwardRef = function ForwardRef() {
    var symbolFor = typeof Symbol === "function" && Symbol["for"];
    return symbolFor ? symbolFor("react.forward_ref") : 0xead0;
};
/**
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */ var getDisplayName = function(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return getFunctionComponentName(Component, "Component");
    if (typeof Component === "object") switch(Component.$$typeof){
        case ForwardRef():
            return getWrappedName(Component, Component.render, "ForwardRef");
        default:
            return undefined;
    }
    return undefined;
};
var withSnackbar = function withSnackbar(Component) {
    var WrappedComponent = (0, _reactDefault.default).forwardRef(function(props, ref) {
        return (0, _reactDefault.default).createElement(SnackbarContext.Consumer, null, function(context) {
            return (0, _reactDefault.default).createElement(Component, _extends({}, props, {
                ref: ref,
                enqueueSnackbar: context.enqueueSnackbar,
                closeSnackbar: context.closeSnackbar
            }));
        });
    });
    (0, _hoistNonReactStaticsDefault.default)(WrappedComponent, Component);
    return WrappedComponent;
};
var useSnackbar = function() {
    return (0, _react.useContext)(SnackbarContext);
};

},{"react":"gVheC","react-dom":"d8jlt","clsx":"lm3jH","@mui/material/Slide":"cZeM6","@mui/material/styles":"gNR9m","@mui/material/Collapse":"bW176","@mui/material/SvgIcon":"9y2F3","@mui/material/ClickAwayListener":"j08aI","hoist-non-react-statics":"d2C2V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lm3jH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZeM6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _slideDefault.default));
var _slide = require("./Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
"use client";

},{"./Slide":"j9XQC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j9XQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTranslateValue", ()=>setTranslateValue);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("@mui/utils");
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils1 = require("../transitions/utils");
var _utils2 = require("../utils");
// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, _utils2.ownerWindow)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
    const resolvedContainer = resolveContainer(containerProp);
    const transform = getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Slide = /*#__PURE__*/ _react.forwardRef(function Slide(props, ref) {
    const theme = (0, _useThemeDefault.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, container: containerProp, direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const childrenRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        setTranslateValue(direction, node, containerProp);
        (0, _utils1.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, _utils1.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, _extendsDefault.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, _extendsDefault.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils1.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        setTranslateValue(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = _react.useCallback(()=>{
        if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    _react.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, _debounceDefault.default)(()=>{
            if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, _utils2.ownerWindow)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    _react.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                ref: handleRef,
                style: (0, _extendsDefault.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
exports.default = Slide;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","react-transition-group":"5ABiG","@mui/utils":"dv12b","../utils/debounce":"h1O4l","../utils/useForkRef":"kWp3j","../styles/useTheme":"6UMPc","../transitions/utils":"1qrTM","../utils":"ziQFX","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ABiG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"8qhYY","./ReplaceTransition":"5eUjd","./SwitchTransition":"bBDj5","./TransitionGroup":"bR9Bj","./Transition":"30G8b","./config":"DaODG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qhYY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","dom-helpers/addClass":"15llo","dom-helpers/removeClass":"kFGmR","react":"gVheC","./Transition":"30G8b","./utils/PropTypes":"4Vflm","./utils/reflow":"lXLaD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6hLbZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"hyVPU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15llo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

},{"./hasClass":"8TcJP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TcJP":[function(require,module,exports) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kFGmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"30G8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","react":"gVheC","react-dom":"d8jlt","./config":"DaODG","./utils/PropTypes":"4Vflm","./TransitionGroupContext":"boqFo","./utils/reflow":"lXLaD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"DaODG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Vflm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"3KNJy","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boqFo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lXLaD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5eUjd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) {
            var maybeNode = child.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this);
            this.props[handler](maybeNode);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = (0, _reactDefault.default).Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupDefault.default), props, inProp ? (0, _reactDefault.default).cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : (0, _reactDefault.default).cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}((0, _reactDefault.default).Component);
ReplaceTransition.propTypes = {};
exports.default = ReplaceTransition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","react":"gVheC","react-dom":"d8jlt","./TransitionGroup":"bR9Bj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bR9Bj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/assertThisInitialized":"9WRWO","@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","prop-types":"3KNJy","react":"gVheC","./TransitionGroupContext":"boqFo","./utils/ChildMapping":"bRz9r","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bRz9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bBDj5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modes", ()=>modes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _transition = require("./Transition");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
    if (oldChildren === newChildren) return false;
    if ((0, _reactDefault.default).isValidElement(oldChildren) && (0, _reactDefault.default).isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) return false;
    return true;
}
var modes = {
    out: "out-in",
    in: "in-out"
};
var callHook = function callHook(element, name, cb) {
    return function() {
        var _element$props;
        element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
        cb();
    };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
    var current = _ref.current, changeState = _ref.changeState;
    return (0, _reactDefault.default).cloneElement(current, {
        in: false,
        onExited: callHook(current, "onExited", function() {
            changeState((0, _transition.ENTERING), null);
        })
    });
}, _leaveRenders[modes.in] = function(_ref2) {
    var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
    return [
        current,
        (0, _reactDefault.default).cloneElement(children, {
            in: true,
            onEntered: callHook(children, "onEntered", function() {
                changeState((0, _transition.ENTERING));
            })
        })
    ];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
    var children = _ref3.children, changeState = _ref3.changeState;
    return (0, _reactDefault.default).cloneElement(children, {
        in: true,
        onEntered: callHook(children, "onEntered", function() {
            changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                in: true
            }));
        })
    });
}, _enterRenders[modes.in] = function(_ref4) {
    var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
    return [
        (0, _reactDefault.default).cloneElement(current, {
            in: false,
            onExited: callHook(current, "onExited", function() {
                changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                    in: true
                }));
            })
        }),
        (0, _reactDefault.default).cloneElement(children, {
            in: true
        })
    ];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */ var SwitchTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(SwitchTransition, _React$Component);
    function SwitchTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            status: (0, _transition.ENTERED),
            current: null
        };
        _this.appeared = false;
        _this.changeState = function(status, current) {
            if (current === void 0) current = _this.state.current;
            _this.setState({
                status: status,
                current: current
            });
        };
        return _this;
    }
    var _proto = SwitchTransition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
    };
    SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.children == null) return {
            current: null
        };
        if (state.status === (0, _transition.ENTERING) && props.mode === modes.in) return {
            status: (0, _transition.ENTERING)
        };
        if (state.current && areChildrenDifferent(state.current, props.children)) return {
            status: (0, _transition.EXITING)
        };
        return {
            current: (0, _reactDefault.default).cloneElement(props.children, {
                in: true
            })
        };
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, mode = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
        var data = {
            children: children,
            current: current,
            changeState: this.changeState,
            status: status
        };
        var component;
        switch(status){
            case 0, _transition.ENTERING:
                component = enterRenders[mode](data);
                break;
            case 0, _transition.EXITING:
                component = leaveRenders[mode](data);
                break;
            case 0, _transition.ENTERED:
                component = current;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: {
                isMounting: !this.appeared
            }
        }, component);
    };
    return SwitchTransition;
}((0, _reactDefault.default).Component);
SwitchTransition.propTypes = {};
SwitchTransition.defaultProps = {
    mode: modes.out
};
exports.default = SwitchTransition;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6hLbZ","react":"gVheC","prop-types":"3KNJy","./Transition":"30G8b","./TransitionGroupContext":"boqFo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h1O4l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_debounce);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kWp3j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useForkRef);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1qrTM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reflow", ()=>reflow);
parcelHelpers.export(exports, "getTransitionProps", ()=>getTransitionProps);
const reflow = (node)=>node.scrollTop;
function getTransitionProps(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout, easing, style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ziQFX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "createSvgIcon", ()=>(0, _createSvgIconDefault.default));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>unstable_ClassNameGenerator);
var _classNameGenerator = require("@mui/base/ClassNameGenerator");
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _createSvgIcon = require("./createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
"use client";
const unstable_ClassNameGenerator = {
    configure: (generator)=>{
        (0, _classNameGenerator.unstable_ClassNameGenerator).configure(generator);
    }
};

},{"@mui/base/ClassNameGenerator":"avGm3","./capitalize":"bIHYz","./createChainedFunction":"6Jmhd","./createSvgIcon":"eL1vB","./debounce":"h1O4l","./deprecatedPropType":"3NTzl","./isMuiElement":"h0Lfr","./ownerDocument":"2wE6J","./ownerWindow":"53vpz","./requirePropFactory":"kdjkX","./setRef":"eEDuC","./useEnhancedEffect":"1Zm5y","./useId":"1ZKNc","./unsupportedProp":"6LZSm","./useControlled":"hR7cg","./useEventCallback":"7Pqt8","./useForkRef":"kWp3j","./useIsFocusVisible":"6OfIY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"avGm3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _utils.unstable_ClassNameGenerator));
var _utils = require("@mui/utils");

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bIHYz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_capitalize);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Jmhd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_createChainedFunction);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eL1vB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSvgIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _svgIcon = require("../SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
/**
 * Private module reserved for @mui packages.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), (0, _extendsDefault.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, _svgIconDefault.default).muiName;
    return /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(Component));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../SvgIcon":"9y2F3","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9y2F3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _svgIconDefault.default));
parcelHelpers.export(exports, "svgIconClasses", ()=>(0, _svgIconClassesDefault.default));
var _svgIcon = require("./SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _svgIconClasses = require("./svgIconClasses");
var _svgIconClassesDefault = parcelHelpers.interopDefault(_svgIconClasses);
parcelHelpers.exportAll(_svgIconClasses, exports);
"use client";

},{"./SvgIcon":"fdFUx","./svgIconClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fdFUx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _svgIconClasses = require("./svgIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, _capitalizeDefault.default)(color)}`,
            `fontSize${(0, _capitalizeDefault.default)(fontSize)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _svgIconClasses.getSvgIconUtilityClass), classes);
};
const SvgIconRoot = (0, _styledDefault.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalizeDefault.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const SvgIcon = /*#__PURE__*/ _react.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children, className, color = "inherit", component = "svg", fontSize = "medium", htmlColor, inheritViewBox = false, titleAccess, viewBox = "0 0 24 24" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const hasSvgAsChild = /*#__PURE__*/ _react.isValidElement(children) && children.type === "svg";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
SvgIcon.muiName = "SvgIcon";
exports.default = SvgIcon;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../utils/capitalize":"bIHYz","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./svgIconClasses":"g3Awe","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icrTb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _utils.unstable_composeClasses));
var _utils = require("@mui/utils");

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g3Awe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSvgIconUtilityClass", ()=>getSvgIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSvgIcon", slot);
}
const svgIconClasses = (0, _generateUtilityClassesDefault.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
exports.default = svgIconClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3NTzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_deprecatedPropType);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h0Lfr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_isMuiElement);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2wE6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_ownerDocument);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53vpz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_ownerWindow);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kdjkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_requirePropFactory);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eEDuC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_setRef);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Zm5y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useEnhancedEffect);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ZKNc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useId);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6LZSm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_unsupportedProp);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hR7cg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useControlled);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Pqt8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useEventCallback);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6OfIY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
"use client";
exports.default = (0, _utils.unstable_useIsFocusVisible);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bW176":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "collapseClasses", ()=>(0, _collapseClassesDefault.default));
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _collapseClasses = require("./collapseClasses");
var _collapseClassesDefault = parcelHelpers.interopDefault(_collapseClasses);
parcelHelpers.exportAll(_collapseClasses, exports);
"use client";

},{"./Collapse":"fQtsW","./collapseClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fQtsW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _createTransitions = require("../styles/createTransitions");
var _utils1 = require("../transitions/utils");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils2 = require("../utils");
var _collapseClasses = require("./collapseClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const useUtilityClasses = (ownerState)=>{
    const { orientation, classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _collapseClasses.getCollapseUtilityClass), classes);
};
const CollapseRoot = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, _extendsDefault.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const CollapseWrapper = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState })=>(0, _extendsDefault.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const CollapseWrapperInner = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Collapse = /*#__PURE__*/ _react.forwardRef(function Collapse(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener, children, className, collapsedSize: collapsedSizeProp = "0px", component, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, orientation = "vertical", style, timeout = (0, _createTransitions.duration).standard, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _useThemeDefault.default)();
    const timer = (0, _utils.unstable_useTimeout)();
    const wrapperRef = _react.useRef(null);
    const autoTransitionDuration = _react.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _utils2.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseRoot, (0, _extendsDefault.default)({
                as: component,
                className: (0, _clsxDefault.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, _extendsDefault.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, _extendsDefault.default)({}, ownerState, {
                    state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapper, {
                    ownerState: (0, _extendsDefault.default)({}, ownerState, {
                        state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapperInner, {
                        ownerState: (0, _extendsDefault.default)({}, ownerState, {
                            state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
Collapse.muiSupportAuto = true;
exports.default = Collapse;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"aGWRz","prop-types":"3KNJy","react-transition-group":"5ABiG","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../styles/createTransitions":"fgf6N","../transitions/utils":"1qrTM","../styles/useTheme":"6UMPc","../utils":"ziQFX","./collapseClasses":"44flY","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"44flY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCollapseUtilityClass", ()=>getCollapseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCollapseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCollapse", slot);
}
const collapseClasses = (0, _generateUtilityClassesDefault.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
exports.default = collapseClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j08aI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clickAwayListener.ClickAwayListener));
var _clickAwayListener = require("@mui/base/ClickAwayListener");

},{"@mui/base/ClickAwayListener":"ie4wP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ie4wP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clickAwayListener = require("./ClickAwayListener");
parcelHelpers.exportAll(_clickAwayListener, exports);

},{"./ClickAwayListener":"dwIc9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dwIc9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickAwayListener", ()=>ClickAwayListener);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function ClickAwayListener(props) {
    const { children, disableReactTree = false, mouseEvent = "onClick", onClickAway, touchEvent = "onTouchEnd" } = props;
    const movedRef = _react.useRef(false);
    const nodeRef = _react.useRef(null);
    const activatedRef = _react.useRef(false);
    const syntheticEventRef = _react.useRef(false);
    _react.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, _utils.unstable_useForkRef)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _utils.unstable_useEventCallback)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    _react.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = mapEventPropToEvent(touchEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    _react.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(children, childrenProps)
    });
}

},{"react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kAvZY":[function(require,module,exports) {
/* eslint-disable */ // WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_appsync_graphqlEndpoint": "https://it2csp7w4jcxjhomtpcwxfc6yq.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-2:7a567dc0-fd68-4324-9593-5bf11ef14dd0",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_A24ROQqfq",
    "aws_user_pools_web_client_id": "5870fu6dro4lnderbog6l1d43f",
    "oauth": {
        "domain": "tds-test.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:1234/,https://master.dm6pmstqyhyh5.amplifyapp.com/,https://prod.dm6pmstqyhyh5.amplifyapp.com/,https://www.erp.testdrivensolutions.co.uk/,https://www.dev.erp.testdrivensolutions.co.uk/",
        "redirectSignOut": "http://localhost:1234/,https://master.dm6pmstqyhyh5.amplifyapp.com/,https://prod.dm6pmstqyhyh5.amplifyapp.com/,https://www.erp.testdrivensolutions.co.uk/,https://www.dev.erp.testdrivensolutions.co.uk/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};
exports.default = awsmobile;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"0272J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionBar = require("./ActionBar");
parcelHelpers.exportAll(_actionBar, exports);
var _appBarScreens = require("./AppBarScreens");
parcelHelpers.exportAll(_appBarScreens, exports);
var _buttons = require("./Buttons");
parcelHelpers.exportAll(_buttons, exports);
var _dataGrid = require("./DataGrid");
parcelHelpers.exportAll(_dataGrid, exports);
var _datePickers = require("./DatePickers");
parcelHelpers.exportAll(_datePickers, exports);
var _modal = require("./Modal");
parcelHelpers.exportAll(_modal, exports);
var _navigation = require("./Navigation");
parcelHelpers.exportAll(_navigation, exports);
var _pageLayout = require("./PageLayout");
parcelHelpers.exportAll(_pageLayout, exports);
var _pageTitle = require("./PageTitle");
parcelHelpers.exportAll(_pageTitle, exports);
var _optionField = require("./OptionField");
parcelHelpers.exportAll(_optionField, exports);
var _tdsLogo = require("./TdsLogo");
parcelHelpers.exportAll(_tdsLogo, exports);
var _textField = require("./TextField");
parcelHelpers.exportAll(_textField, exports);
var _tooltip = require("./Tooltip");
parcelHelpers.exportAll(_tooltip, exports);
var _userAvatar = require("./UserAvatar");
parcelHelpers.exportAll(_userAvatar, exports);
var _icons = require("./Icons");
parcelHelpers.exportAll(_icons, exports);
var _tiles = require("./Tiles");
parcelHelpers.exportAll(_tiles, exports);
var _checkbox = require("./Checkbox");
parcelHelpers.exportAll(_checkbox, exports);

},{"./ActionBar":"eW8gg","./AppBarScreens":"kz3Ye","./Buttons":"jEO6Z","./DataGrid":"62l75","./DatePickers":"lnhPR","./Modal":"ieR16","./Navigation":"3OVDt","./PageLayout":"aZYdx","./PageTitle":"ls1su","./OptionField":"8Mgzz","./TdsLogo":"cE4zn","./TextField":"2Pq7w","./Tooltip":"ikXCW","./UserAvatar":"anYwW","./Icons":"jH9KH","./Tiles":"gesLW","./Checkbox":"h2Hl0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eW8gg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionBar = require("./ActionBar");
parcelHelpers.exportAll(_actionBar, exports);
var _filterBar = require("./FilterBar");
parcelHelpers.exportAll(_filterBar, exports);

},{"./ActionBar":"ecQ8X","./FilterBar":"eOGvF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ecQ8X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const ActionBar = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            display: "flex",
            gap: 2,
            width: 1,
            mb: 2,
            px: 2,
            py: 1,
            bgcolor: "grey.100",
            borderRadius: 1
        },
        "data-testid": "action-bar",
        children: children
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iknXc":[function(require,module,exports) {
/**
 * @mui/material v5.15.10
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable import/export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionActions", ()=>(0, _accordionActionsDefault.default));
parcelHelpers.export(exports, "AccordionDetails", ()=>(0, _accordionDetailsDefault.default));
parcelHelpers.export(exports, "AccordionSummary", ()=>(0, _accordionSummaryDefault.default));
parcelHelpers.export(exports, "Alert", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "AlertTitle", ()=>(0, _alertTitleDefault.default));
parcelHelpers.export(exports, "AppBar", ()=>(0, _appBarDefault.default));
parcelHelpers.export(exports, "Autocomplete", ()=>(0, _autocompleteDefault.default));
parcelHelpers.export(exports, "Avatar", ()=>(0, _avatarDefault.default));
parcelHelpers.export(exports, "AvatarGroup", ()=>(0, _avatarGroupDefault.default));
parcelHelpers.export(exports, "Backdrop", ()=>(0, _backdropDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "BottomNavigation", ()=>(0, _bottomNavigationDefault.default));
parcelHelpers.export(exports, "BottomNavigationAction", ()=>(0, _bottomNavigationActionDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Breadcrumbs", ()=>(0, _breadcrumbsDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "ButtonBase", ()=>(0, _buttonBaseDefault.default));
parcelHelpers.export(exports, "ButtonGroup", ()=>(0, _buttonGroupDefault.default));
parcelHelpers.export(exports, "Card", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "CardActionArea", ()=>(0, _cardActionAreaDefault.default));
parcelHelpers.export(exports, "CardActions", ()=>(0, _cardActionsDefault.default));
parcelHelpers.export(exports, "CardContent", ()=>(0, _cardContentDefault.default));
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "CardMedia", ()=>(0, _cardMediaDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "Chip", ()=>(0, _chipDefault.default));
parcelHelpers.export(exports, "CircularProgress", ()=>(0, _circularProgressDefault.default));
parcelHelpers.export(exports, "ClickAwayListener", ()=>(0, _clickAwayListenerDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "CssBaseline", ()=>(0, _cssBaselineDefault.default));
parcelHelpers.export(exports, "darkScrollbar", ()=>(0, _darkScrollbarDefault.default));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialogDefault.default));
parcelHelpers.export(exports, "DialogActions", ()=>(0, _dialogActionsDefault.default));
parcelHelpers.export(exports, "DialogContent", ()=>(0, _dialogContentDefault.default));
parcelHelpers.export(exports, "DialogContentText", ()=>(0, _dialogContentTextDefault.default));
parcelHelpers.export(exports, "DialogTitle", ()=>(0, _dialogTitleDefault.default));
parcelHelpers.export(exports, "Divider", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "Drawer", ()=>(0, _drawerDefault.default));
parcelHelpers.export(exports, "Fab", ()=>(0, _fabDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "FilledInput", ()=>(0, _filledInputDefault.default));
parcelHelpers.export(exports, "FormControl", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "FormControlLabel", ()=>(0, _formControlLabelDefault.default));
parcelHelpers.export(exports, "FormGroup", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "FormHelperText", ()=>(0, _formHelperTextDefault.default));
parcelHelpers.export(exports, "FormLabel", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Unstable_Grid2", ()=>(0, _unstableGrid2Default.default));
parcelHelpers.export(exports, "Grow", ()=>(0, _growDefault.default));
parcelHelpers.export(exports, "Hidden", ()=>(0, _hiddenDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconDefault.default));
parcelHelpers.export(exports, "IconButton", ()=>(0, _iconButtonDefault.default));
parcelHelpers.export(exports, "ImageList", ()=>(0, _imageListDefault.default));
parcelHelpers.export(exports, "ImageListItem", ()=>(0, _imageListItemDefault.default));
parcelHelpers.export(exports, "ImageListItemBar", ()=>(0, _imageListItemBarDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "InputAdornment", ()=>(0, _inputAdornmentDefault.default));
parcelHelpers.export(exports, "InputBase", ()=>(0, _inputBaseDefault.default));
parcelHelpers.export(exports, "InputLabel", ()=>(0, _inputLabelDefault.default));
parcelHelpers.export(exports, "LinearProgress", ()=>(0, _linearProgressDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListItem", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "ListItemAvatar", ()=>(0, _listItemAvatarDefault.default));
parcelHelpers.export(exports, "ListItemButton", ()=>(0, _listItemButtonDefault.default));
parcelHelpers.export(exports, "ListItemIcon", ()=>(0, _listItemIconDefault.default));
parcelHelpers.export(exports, "ListItemSecondaryAction", ()=>(0, _listItemSecondaryActionDefault.default));
parcelHelpers.export(exports, "ListItemText", ()=>(0, _listItemTextDefault.default));
parcelHelpers.export(exports, "ListSubheader", ()=>(0, _listSubheaderDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "MenuList", ()=>(0, _menuListDefault.default));
parcelHelpers.export(exports, "MobileStepper", ()=>(0, _mobileStepperDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "NativeSelect", ()=>(0, _nativeSelectDefault.default));
parcelHelpers.export(exports, "NoSsr", ()=>(0, _noSsrDefault.default));
parcelHelpers.export(exports, "OutlinedInput", ()=>(0, _outlinedInputDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "PaginationItem", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "Paper", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "Popper", ()=>(0, _popperDefault.default));
parcelHelpers.export(exports, "Portal", ()=>(0, _portalDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroupDefault.default));
parcelHelpers.export(exports, "Rating", ()=>(0, _ratingDefault.default));
parcelHelpers.export(exports, "ScopedCssBaseline", ()=>(0, _scopedCssBaselineDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Skeleton", ()=>(0, _skeletonDefault.default));
parcelHelpers.export(exports, "Slide", ()=>(0, _slideDefault.default));
parcelHelpers.export(exports, "Slider", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "Snackbar", ()=>(0, _snackbarDefault.default));
parcelHelpers.export(exports, "SnackbarContent", ()=>(0, _snackbarContentDefault.default));
parcelHelpers.export(exports, "SpeedDial", ()=>(0, _speedDialDefault.default));
parcelHelpers.export(exports, "SpeedDialAction", ()=>(0, _speedDialActionDefault.default));
parcelHelpers.export(exports, "SpeedDialIcon", ()=>(0, _speedDialIconDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "Step", ()=>(0, _stepDefault.default));
parcelHelpers.export(exports, "StepButton", ()=>(0, _stepButtonDefault.default));
parcelHelpers.export(exports, "StepConnector", ()=>(0, _stepConnectorDefault.default));
parcelHelpers.export(exports, "StepContent", ()=>(0, _stepContentDefault.default));
parcelHelpers.export(exports, "StepIcon", ()=>(0, _stepIconDefault.default));
parcelHelpers.export(exports, "StepLabel", ()=>(0, _stepLabelDefault.default));
parcelHelpers.export(exports, "Stepper", ()=>(0, _stepperDefault.default));
parcelHelpers.export(exports, "SvgIcon", ()=>(0, _svgIconDefault.default));
parcelHelpers.export(exports, "SwipeableDrawer", ()=>(0, _swipeableDrawerDefault.default));
parcelHelpers.export(exports, "Switch", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableBodyDefault.default));
parcelHelpers.export(exports, "TableCell", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "TableContainer", ()=>(0, _tableContainerDefault.default));
parcelHelpers.export(exports, "TableFooter", ()=>(0, _tableFooterDefault.default));
parcelHelpers.export(exports, "TableHead", ()=>(0, _tableHeadDefault.default));
parcelHelpers.export(exports, "TablePagination", ()=>(0, _tablePaginationDefault.default));
parcelHelpers.export(exports, "TableRow", ()=>(0, _tableRowDefault.default));
parcelHelpers.export(exports, "TableSortLabel", ()=>(0, _tableSortLabelDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "TabScrollButton", ()=>(0, _tabScrollButtonDefault.default));
parcelHelpers.export(exports, "TextField", ()=>(0, _textFieldDefault.default));
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosizeDefault.default));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupDefault.default));
parcelHelpers.export(exports, "Toolbar", ()=>(0, _toolbarDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "Typography", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQueryDefault.default));
parcelHelpers.export(exports, "usePagination", ()=>(0, _usePaginationDefault.default));
parcelHelpers.export(exports, "useScrollTrigger", ()=>(0, _useScrollTriggerDefault.default));
parcelHelpers.export(exports, "Zoom", ()=>(0, _zoomDefault.default));
// createFilterOptions is exported from Autocomplete
parcelHelpers.export(exports, "useAutocomplete", ()=>(0, _useAutocompleteDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _composeClasses.unstable_composeClasses));
parcelHelpers.export(exports, "generateUtilityClass", ()=>(0, _generateUtilityClassDefault.default));
parcelHelpers.export(exports, "generateUtilityClasses", ()=>(0, _generateUtilityClassesDefault.default));
parcelHelpers.export(exports, "Unstable_TrapFocus", ()=>(0, _unstableTrapFocusDefault.default));
parcelHelpers.export(exports, "colors", ()=>_colors);
var _colors = require("./colors");
var _styles = require("./styles");
parcelHelpers.exportAll(_styles, exports);
// TODO remove, import directly from Base UI or create one folder per module
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _accordion = require("./Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
parcelHelpers.exportAll(_accordion, exports);
var _accordionActions = require("./AccordionActions");
var _accordionActionsDefault = parcelHelpers.interopDefault(_accordionActions);
parcelHelpers.exportAll(_accordionActions, exports);
var _accordionDetails = require("./AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
parcelHelpers.exportAll(_accordionDetails, exports);
var _accordionSummary = require("./AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
parcelHelpers.exportAll(_accordionSummary, exports);
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
parcelHelpers.exportAll(_alert, exports);
var _alertTitle = require("./AlertTitle");
var _alertTitleDefault = parcelHelpers.interopDefault(_alertTitle);
parcelHelpers.exportAll(_alertTitle, exports);
var _appBar = require("./AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
parcelHelpers.exportAll(_appBar, exports);
var _autocomplete = require("./Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
parcelHelpers.exportAll(_autocomplete, exports);
var _avatar = require("./Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
parcelHelpers.exportAll(_avatar, exports);
var _avatarGroup = require("./AvatarGroup");
var _avatarGroupDefault = parcelHelpers.interopDefault(_avatarGroup);
parcelHelpers.exportAll(_avatarGroup, exports);
var _backdrop = require("./Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
parcelHelpers.exportAll(_backdrop, exports);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
parcelHelpers.exportAll(_badge, exports);
var _bottomNavigation = require("./BottomNavigation");
var _bottomNavigationDefault = parcelHelpers.interopDefault(_bottomNavigation);
parcelHelpers.exportAll(_bottomNavigation, exports);
var _bottomNavigationAction = require("./BottomNavigationAction");
var _bottomNavigationActionDefault = parcelHelpers.interopDefault(_bottomNavigationAction);
parcelHelpers.exportAll(_bottomNavigationAction, exports);
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
parcelHelpers.exportAll(_box, exports);
var _breadcrumbs = require("./Breadcrumbs");
var _breadcrumbsDefault = parcelHelpers.interopDefault(_breadcrumbs);
parcelHelpers.exportAll(_breadcrumbs, exports);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
parcelHelpers.exportAll(_button, exports);
var _buttonBase = require("./ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
parcelHelpers.exportAll(_buttonBase, exports);
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
parcelHelpers.exportAll(_buttonGroup, exports);
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
parcelHelpers.exportAll(_card, exports);
var _cardActionArea = require("./CardActionArea");
var _cardActionAreaDefault = parcelHelpers.interopDefault(_cardActionArea);
parcelHelpers.exportAll(_cardActionArea, exports);
var _cardActions = require("./CardActions");
var _cardActionsDefault = parcelHelpers.interopDefault(_cardActions);
parcelHelpers.exportAll(_cardActions, exports);
var _cardContent = require("./CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
parcelHelpers.exportAll(_cardContent, exports);
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
parcelHelpers.exportAll(_cardHeader, exports);
var _cardMedia = require("./CardMedia");
var _cardMediaDefault = parcelHelpers.interopDefault(_cardMedia);
parcelHelpers.exportAll(_cardMedia, exports);
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
parcelHelpers.exportAll(_checkbox, exports);
var _chip = require("./Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
parcelHelpers.exportAll(_chip, exports);
var _circularProgress = require("./CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
parcelHelpers.exportAll(_circularProgress, exports);
var _clickAwayListener = require("./ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
parcelHelpers.exportAll(_clickAwayListener, exports);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
parcelHelpers.exportAll(_collapse, exports);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
parcelHelpers.exportAll(_container, exports);
var _cssBaseline = require("./CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
parcelHelpers.exportAll(_cssBaseline, exports);
var _darkScrollbar = require("./darkScrollbar");
var _darkScrollbarDefault = parcelHelpers.interopDefault(_darkScrollbar);
parcelHelpers.exportAll(_darkScrollbar, exports);
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
parcelHelpers.exportAll(_dialog, exports);
var _dialogActions = require("./DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
parcelHelpers.exportAll(_dialogActions, exports);
var _dialogContent = require("./DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
parcelHelpers.exportAll(_dialogContent, exports);
var _dialogContentText = require("./DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
parcelHelpers.exportAll(_dialogContentText, exports);
var _dialogTitle = require("./DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
parcelHelpers.exportAll(_dialogTitle, exports);
var _divider = require("./Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
parcelHelpers.exportAll(_divider, exports);
var _drawer = require("./Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
parcelHelpers.exportAll(_drawer, exports);
var _fab = require("./Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
parcelHelpers.exportAll(_fab, exports);
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
parcelHelpers.exportAll(_fade, exports);
var _filledInput = require("./FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
parcelHelpers.exportAll(_filledInput, exports);
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
parcelHelpers.exportAll(_formControl, exports);
var _formControlLabel = require("./FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
parcelHelpers.exportAll(_formControlLabel, exports);
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
parcelHelpers.exportAll(_formGroup, exports);
var _formHelperText = require("./FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
parcelHelpers.exportAll(_formHelperText, exports);
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
parcelHelpers.exportAll(_formLabel, exports);
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
parcelHelpers.exportAll(_grid, exports);
var _unstableGrid2 = require("./Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
parcelHelpers.exportAll(_unstableGrid2, exports);
var _grow = require("./Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
parcelHelpers.exportAll(_grow, exports);
var _hidden = require("./Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
parcelHelpers.exportAll(_hidden, exports);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
parcelHelpers.exportAll(_icon, exports);
var _iconButton = require("./IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
parcelHelpers.exportAll(_iconButton, exports);
var _imageList = require("./ImageList");
var _imageListDefault = parcelHelpers.interopDefault(_imageList);
parcelHelpers.exportAll(_imageList, exports);
var _imageListItem = require("./ImageListItem");
var _imageListItemDefault = parcelHelpers.interopDefault(_imageListItem);
parcelHelpers.exportAll(_imageListItem, exports);
var _imageListItemBar = require("./ImageListItemBar");
var _imageListItemBarDefault = parcelHelpers.interopDefault(_imageListItemBar);
parcelHelpers.exportAll(_imageListItemBar, exports);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
parcelHelpers.exportAll(_input, exports);
var _inputAdornment = require("./InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
parcelHelpers.exportAll(_inputAdornment, exports);
var _inputBase = require("./InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
parcelHelpers.exportAll(_inputBase, exports);
var _inputLabel = require("./InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
parcelHelpers.exportAll(_inputLabel, exports);
var _linearProgress = require("./LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
parcelHelpers.exportAll(_linearProgress, exports);
var _link = require("./Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
parcelHelpers.exportAll(_link, exports);
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
parcelHelpers.exportAll(_list, exports);
var _listItem = require("./ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
parcelHelpers.exportAll(_listItem, exports);
var _listItemAvatar = require("./ListItemAvatar");
var _listItemAvatarDefault = parcelHelpers.interopDefault(_listItemAvatar);
parcelHelpers.exportAll(_listItemAvatar, exports);
var _listItemButton = require("./ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
parcelHelpers.exportAll(_listItemButton, exports);
var _listItemIcon = require("./ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
parcelHelpers.exportAll(_listItemIcon, exports);
var _listItemSecondaryAction = require("./ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
parcelHelpers.exportAll(_listItemSecondaryAction, exports);
var _listItemText = require("./ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
parcelHelpers.exportAll(_listItemText, exports);
var _listSubheader = require("./ListSubheader");
var _listSubheaderDefault = parcelHelpers.interopDefault(_listSubheader);
parcelHelpers.exportAll(_listSubheader, exports);
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
parcelHelpers.exportAll(_menu, exports);
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
parcelHelpers.exportAll(_menuItem, exports);
var _menuList = require("./MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
parcelHelpers.exportAll(_menuList, exports);
var _mobileStepper = require("./MobileStepper");
var _mobileStepperDefault = parcelHelpers.interopDefault(_mobileStepper);
parcelHelpers.exportAll(_mobileStepper, exports);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
parcelHelpers.exportAll(_modal, exports);
var _nativeSelect = require("./NativeSelect");
var _nativeSelectDefault = parcelHelpers.interopDefault(_nativeSelect);
parcelHelpers.exportAll(_nativeSelect, exports);
var _noSsr = require("./NoSsr");
var _noSsrDefault = parcelHelpers.interopDefault(_noSsr);
parcelHelpers.exportAll(_noSsr, exports);
var _outlinedInput = require("./OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
parcelHelpers.exportAll(_outlinedInput, exports);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
parcelHelpers.exportAll(_pagination, exports);
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
parcelHelpers.exportAll(_paginationItem, exports);
var _paper = require("./Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
parcelHelpers.exportAll(_paper, exports);
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
parcelHelpers.exportAll(_popover, exports);
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
parcelHelpers.exportAll(_popper, exports);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
parcelHelpers.exportAll(_portal, exports);
var _radio = require("./Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
parcelHelpers.exportAll(_radio, exports);
var _radioGroup = require("./RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
parcelHelpers.exportAll(_radioGroup, exports);
var _rating = require("./Rating");
var _ratingDefault = parcelHelpers.interopDefault(_rating);
parcelHelpers.exportAll(_rating, exports);
var _scopedCssBaseline = require("./ScopedCssBaseline");
var _scopedCssBaselineDefault = parcelHelpers.interopDefault(_scopedCssBaseline);
parcelHelpers.exportAll(_scopedCssBaseline, exports);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
parcelHelpers.exportAll(_select, exports);
var _skeleton = require("./Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
parcelHelpers.exportAll(_skeleton, exports);
var _slide = require("./Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
parcelHelpers.exportAll(_slide, exports);
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
parcelHelpers.exportAll(_slider, exports);
var _snackbar = require("./Snackbar");
var _snackbarDefault = parcelHelpers.interopDefault(_snackbar);
parcelHelpers.exportAll(_snackbar, exports);
var _snackbarContent = require("./SnackbarContent");
var _snackbarContentDefault = parcelHelpers.interopDefault(_snackbarContent);
parcelHelpers.exportAll(_snackbarContent, exports);
var _speedDial = require("./SpeedDial");
var _speedDialDefault = parcelHelpers.interopDefault(_speedDial);
parcelHelpers.exportAll(_speedDial, exports);
var _speedDialAction = require("./SpeedDialAction");
var _speedDialActionDefault = parcelHelpers.interopDefault(_speedDialAction);
parcelHelpers.exportAll(_speedDialAction, exports);
var _speedDialIcon = require("./SpeedDialIcon");
var _speedDialIconDefault = parcelHelpers.interopDefault(_speedDialIcon);
parcelHelpers.exportAll(_speedDialIcon, exports);
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
parcelHelpers.exportAll(_stack, exports);
var _step = require("./Step");
var _stepDefault = parcelHelpers.interopDefault(_step);
parcelHelpers.exportAll(_step, exports);
var _stepButton = require("./StepButton");
var _stepButtonDefault = parcelHelpers.interopDefault(_stepButton);
parcelHelpers.exportAll(_stepButton, exports);
var _stepConnector = require("./StepConnector");
var _stepConnectorDefault = parcelHelpers.interopDefault(_stepConnector);
parcelHelpers.exportAll(_stepConnector, exports);
var _stepContent = require("./StepContent");
var _stepContentDefault = parcelHelpers.interopDefault(_stepContent);
parcelHelpers.exportAll(_stepContent, exports);
var _stepIcon = require("./StepIcon");
var _stepIconDefault = parcelHelpers.interopDefault(_stepIcon);
parcelHelpers.exportAll(_stepIcon, exports);
var _stepLabel = require("./StepLabel");
var _stepLabelDefault = parcelHelpers.interopDefault(_stepLabel);
parcelHelpers.exportAll(_stepLabel, exports);
var _stepper = require("./Stepper");
var _stepperDefault = parcelHelpers.interopDefault(_stepper);
parcelHelpers.exportAll(_stepper, exports);
var _svgIcon = require("./SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
parcelHelpers.exportAll(_svgIcon, exports);
var _swipeableDrawer = require("./SwipeableDrawer");
var _swipeableDrawerDefault = parcelHelpers.interopDefault(_swipeableDrawer);
parcelHelpers.exportAll(_swipeableDrawer, exports);
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
parcelHelpers.exportAll(_switch, exports);
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
parcelHelpers.exportAll(_tab, exports);
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
parcelHelpers.exportAll(_table, exports);
var _tableBody = require("./TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
parcelHelpers.exportAll(_tableBody, exports);
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
parcelHelpers.exportAll(_tableCell, exports);
var _tableContainer = require("./TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
parcelHelpers.exportAll(_tableContainer, exports);
var _tableFooter = require("./TableFooter");
var _tableFooterDefault = parcelHelpers.interopDefault(_tableFooter);
parcelHelpers.exportAll(_tableFooter, exports);
var _tableHead = require("./TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
parcelHelpers.exportAll(_tableHead, exports);
var _tablePagination = require("./TablePagination");
var _tablePaginationDefault = parcelHelpers.interopDefault(_tablePagination);
parcelHelpers.exportAll(_tablePagination, exports);
var _tableRow = require("./TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
parcelHelpers.exportAll(_tableRow, exports);
var _tableSortLabel = require("./TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
parcelHelpers.exportAll(_tableSortLabel, exports);
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
parcelHelpers.exportAll(_tabs, exports);
var _tabScrollButton = require("./TabScrollButton");
var _tabScrollButtonDefault = parcelHelpers.interopDefault(_tabScrollButton);
parcelHelpers.exportAll(_tabScrollButton, exports);
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
parcelHelpers.exportAll(_textField, exports);
var _textareaAutosize = require("./TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
parcelHelpers.exportAll(_textareaAutosize, exports);
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
parcelHelpers.exportAll(_toggleButton, exports);
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
parcelHelpers.exportAll(_toggleButtonGroup, exports);
var _toolbar = require("./Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
parcelHelpers.exportAll(_toolbar, exports);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
parcelHelpers.exportAll(_tooltip, exports);
var _typography = require("./Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
parcelHelpers.exportAll(_typography, exports);
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
parcelHelpers.exportAll(_useMediaQuery, exports);
var _usePagination = require("./usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
parcelHelpers.exportAll(_usePagination, exports);
var _useScrollTrigger = require("./useScrollTrigger");
var _useScrollTriggerDefault = parcelHelpers.interopDefault(_useScrollTrigger);
parcelHelpers.exportAll(_useScrollTrigger, exports);
var _zoom = require("./Zoom");
var _zoomDefault = parcelHelpers.interopDefault(_zoom);
parcelHelpers.exportAll(_zoom, exports);
var _useAutocomplete = require("./useAutocomplete");
var _useAutocompleteDefault = parcelHelpers.interopDefault(_useAutocomplete);
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
parcelHelpers.exportAll(_globalStyles, exports);
var _composeClasses = require("@mui/base/composeClasses");
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _unstableTrapFocus = require("./Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);

},{"./colors":false,"./styles":"gNR9m","./utils":"ziQFX","./Accordion":false,"./AccordionActions":false,"./AccordionDetails":false,"./AccordionSummary":false,"./Alert":false,"./AlertTitle":false,"./AppBar":"hCJE4","./Autocomplete":"3qDJc","./Avatar":"1jAfc","./AvatarGroup":false,"./Backdrop":false,"./Badge":false,"./BottomNavigation":false,"./BottomNavigationAction":false,"./Box":"52i65","./Breadcrumbs":false,"./Button":"6pu9h","./ButtonBase":false,"./ButtonGroup":false,"./Card":false,"./CardActionArea":false,"./CardActions":false,"./CardContent":false,"./CardHeader":false,"./CardMedia":false,"./Checkbox":"jMXWA","./Chip":"bwuFy","./CircularProgress":"fDo20","./ClickAwayListener":false,"./Collapse":false,"./Container":false,"./CssBaseline":"eCY2Z","./darkScrollbar":false,"./Dialog":"cziPe","./DialogActions":"2DBqh","./DialogContent":"jXMyc","./DialogContentText":false,"./DialogTitle":"2OJm8","./Divider":"1Yn32","./Drawer":"kfkBA","./Fab":false,"./Fade":false,"./FilledInput":false,"./FormControl":"6EcMm","./FormControlLabel":"c21sM","./FormGroup":false,"./FormHelperText":"FdSIA","./FormLabel":false,"./Grid":"j00I5","./Unstable_Grid2":false,"./Grow":false,"./Hidden":false,"./Icon":false,"./IconButton":"6bnps","./ImageList":false,"./ImageListItem":false,"./ImageListItemBar":false,"./Input":false,"./InputAdornment":"400VR","./InputBase":false,"./InputLabel":"i0KlN","./LinearProgress":"903dI","./Link":false,"./List":"ighTd","./ListItem":"9curq","./ListItemAvatar":false,"./ListItemButton":"6ZWii","./ListItemIcon":"ebq0R","./ListItemSecondaryAction":false,"./ListItemText":"7MfZJ","./ListSubheader":"5DWNS","./Menu":"hx0ew","./MenuItem":"dTC9Z","./MenuList":false,"./MobileStepper":false,"./Modal":false,"./NativeSelect":false,"./NoSsr":false,"./OutlinedInput":"7cXpp","./Pagination":"8YO5A","./PaginationItem":false,"./Paper":false,"./Popover":false,"./Popper":false,"./Portal":false,"./Radio":false,"./RadioGroup":false,"./Rating":false,"./ScopedCssBaseline":false,"./Select":"aiyFZ","./Skeleton":"eTJwP","./Slide":false,"./Slider":false,"./Snackbar":false,"./SnackbarContent":false,"./SpeedDial":false,"./SpeedDialAction":false,"./SpeedDialIcon":false,"./Stack":false,"./Step":false,"./StepButton":false,"./StepConnector":false,"./StepContent":false,"./StepIcon":false,"./StepLabel":false,"./Stepper":false,"./SvgIcon":false,"./SwipeableDrawer":false,"./Switch":"3POY0","./Tab":false,"./Table":false,"./TableBody":false,"./TableCell":false,"./TableContainer":false,"./TableFooter":false,"./TableHead":false,"./TablePagination":"65lFk","./TableRow":false,"./TableSortLabel":false,"./Tabs":false,"./TabScrollButton":false,"./TextField":"j02FZ","./TextareaAutosize":false,"./ToggleButton":false,"./ToggleButtonGroup":false,"./Toolbar":"8LwX6","./Tooltip":"fmb01","./Typography":"1Chqm","./useMediaQuery":"kV0D0","./usePagination":false,"./useScrollTrigger":false,"./Zoom":false,"./useAutocomplete":false,"./GlobalStyles":false,"@mui/base/composeClasses":"icrTb","./generateUtilityClass":"5CV04","./generateUtilityClasses":"6RMZu","./Unstable_TrapFocus":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gGfHv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "common", ()=>(0, _commonDefault.default));
parcelHelpers.export(exports, "red", ()=>(0, _redDefault.default));
parcelHelpers.export(exports, "pink", ()=>(0, _pinkDefault.default));
parcelHelpers.export(exports, "purple", ()=>(0, _purpleDefault.default));
parcelHelpers.export(exports, "deepPurple", ()=>(0, _deepPurpleDefault.default));
parcelHelpers.export(exports, "indigo", ()=>(0, _indigoDefault.default));
parcelHelpers.export(exports, "blue", ()=>(0, _blueDefault.default));
parcelHelpers.export(exports, "lightBlue", ()=>(0, _lightBlueDefault.default));
parcelHelpers.export(exports, "cyan", ()=>(0, _cyanDefault.default));
parcelHelpers.export(exports, "teal", ()=>(0, _tealDefault.default));
parcelHelpers.export(exports, "green", ()=>(0, _greenDefault.default));
parcelHelpers.export(exports, "lightGreen", ()=>(0, _lightGreenDefault.default));
parcelHelpers.export(exports, "lime", ()=>(0, _limeDefault.default));
parcelHelpers.export(exports, "yellow", ()=>(0, _yellowDefault.default));
parcelHelpers.export(exports, "amber", ()=>(0, _amberDefault.default));
parcelHelpers.export(exports, "orange", ()=>(0, _orangeDefault.default));
parcelHelpers.export(exports, "deepOrange", ()=>(0, _deepOrangeDefault.default));
parcelHelpers.export(exports, "brown", ()=>(0, _brownDefault.default));
parcelHelpers.export(exports, "grey", ()=>(0, _greyDefault.default));
parcelHelpers.export(exports, "blueGrey", ()=>(0, _blueGreyDefault.default));
var _common = require("./common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _red = require("./red");
var _redDefault = parcelHelpers.interopDefault(_red);
var _pink = require("./pink");
var _pinkDefault = parcelHelpers.interopDefault(_pink);
var _purple = require("./purple");
var _purpleDefault = parcelHelpers.interopDefault(_purple);
var _deepPurple = require("./deepPurple");
var _deepPurpleDefault = parcelHelpers.interopDefault(_deepPurple);
var _indigo = require("./indigo");
var _indigoDefault = parcelHelpers.interopDefault(_indigo);
var _blue = require("./blue");
var _blueDefault = parcelHelpers.interopDefault(_blue);
var _lightBlue = require("./lightBlue");
var _lightBlueDefault = parcelHelpers.interopDefault(_lightBlue);
var _cyan = require("./cyan");
var _cyanDefault = parcelHelpers.interopDefault(_cyan);
var _teal = require("./teal");
var _tealDefault = parcelHelpers.interopDefault(_teal);
var _green = require("./green");
var _greenDefault = parcelHelpers.interopDefault(_green);
var _lightGreen = require("./lightGreen");
var _lightGreenDefault = parcelHelpers.interopDefault(_lightGreen);
var _lime = require("./lime");
var _limeDefault = parcelHelpers.interopDefault(_lime);
var _yellow = require("./yellow");
var _yellowDefault = parcelHelpers.interopDefault(_yellow);
var _amber = require("./amber");
var _amberDefault = parcelHelpers.interopDefault(_amber);
var _orange = require("./orange");
var _orangeDefault = parcelHelpers.interopDefault(_orange);
var _deepOrange = require("./deepOrange");
var _deepOrangeDefault = parcelHelpers.interopDefault(_deepOrange);
var _brown = require("./brown");
var _brownDefault = parcelHelpers.interopDefault(_brown);
var _grey = require("./grey");
var _greyDefault = parcelHelpers.interopDefault(_grey);
var _blueGrey = require("./blueGrey");
var _blueGreyDefault = parcelHelpers.interopDefault(_blueGrey);

},{"./common":"dx5DJ","./red":"5DKVd","./pink":"eW6aE","./purple":"1hBTw","./deepPurple":"1Rwfw","./indigo":"kzYot","./blue":"2RARD","./lightBlue":"kx6uJ","./cyan":"5VIh7","./teal":"kVNbs","./green":"bamm6","./lightGreen":"efs72","./lime":"2WACD","./yellow":"3FhDF","./amber":"kJKCf","./orange":"5ZTR9","./deepOrange":"j196V","./brown":"gD0Mr","./grey":"aHiwG","./blueGrey":"cG4f1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eW6aE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
exports.default = pink;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Rwfw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const deepPurple = {
    50: "#ede7f6",
    100: "#d1c4e9",
    200: "#b39ddb",
    300: "#9575cd",
    400: "#7e57c2",
    500: "#673ab7",
    600: "#5e35b1",
    700: "#512da8",
    800: "#4527a0",
    900: "#311b92",
    A100: "#b388ff",
    A200: "#7c4dff",
    A400: "#651fff",
    A700: "#6200ea"
};
exports.default = deepPurple;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kzYot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
exports.default = indigo;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5VIh7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const cyan = {
    50: "#e0f7fa",
    100: "#b2ebf2",
    200: "#80deea",
    300: "#4dd0e1",
    400: "#26c6da",
    500: "#00bcd4",
    600: "#00acc1",
    700: "#0097a7",
    800: "#00838f",
    900: "#006064",
    A100: "#84ffff",
    A200: "#18ffff",
    A400: "#00e5ff",
    A700: "#00b8d4"
};
exports.default = cyan;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kVNbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const teal = {
    50: "#e0f2f1",
    100: "#b2dfdb",
    200: "#80cbc4",
    300: "#4db6ac",
    400: "#26a69a",
    500: "#009688",
    600: "#00897b",
    700: "#00796b",
    800: "#00695c",
    900: "#004d40",
    A100: "#a7ffeb",
    A200: "#64ffda",
    A400: "#1de9b6",
    A700: "#00bfa5"
};
exports.default = teal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"efs72":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lightGreen = {
    50: "#f1f8e9",
    100: "#dcedc8",
    200: "#c5e1a5",
    300: "#aed581",
    400: "#9ccc65",
    500: "#8bc34a",
    600: "#7cb342",
    700: "#689f38",
    800: "#558b2f",
    900: "#33691e",
    A100: "#ccff90",
    A200: "#b2ff59",
    A400: "#76ff03",
    A700: "#64dd17"
};
exports.default = lightGreen;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2WACD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lime = {
    50: "#f9fbe7",
    100: "#f0f4c3",
    200: "#e6ee9c",
    300: "#dce775",
    400: "#d4e157",
    500: "#cddc39",
    600: "#c0ca33",
    700: "#afb42b",
    800: "#9e9d24",
    900: "#827717",
    A100: "#f4ff81",
    A200: "#eeff41",
    A400: "#c6ff00",
    A700: "#aeea00"
};
exports.default = lime;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3FhDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const yellow = {
    50: "#fffde7",
    100: "#fff9c4",
    200: "#fff59d",
    300: "#fff176",
    400: "#ffee58",
    500: "#ffeb3b",
    600: "#fdd835",
    700: "#fbc02d",
    800: "#f9a825",
    900: "#f57f17",
    A100: "#ffff8d",
    A200: "#ffff00",
    A400: "#ffea00",
    A700: "#ffd600"
};
exports.default = yellow;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kJKCf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const amber = {
    50: "#fff8e1",
    100: "#ffecb3",
    200: "#ffe082",
    300: "#ffd54f",
    400: "#ffca28",
    500: "#ffc107",
    600: "#ffb300",
    700: "#ffa000",
    800: "#ff8f00",
    900: "#ff6f00",
    A100: "#ffe57f",
    A200: "#ffd740",
    A400: "#ffc400",
    A700: "#ffab00"
};
exports.default = amber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j196V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const deepOrange = {
    50: "#fbe9e7",
    100: "#ffccbc",
    200: "#ffab91",
    300: "#ff8a65",
    400: "#ff7043",
    500: "#ff5722",
    600: "#f4511e",
    700: "#e64a19",
    800: "#d84315",
    900: "#bf360c",
    A100: "#ff9e80",
    A200: "#ff6e40",
    A400: "#ff3d00",
    A700: "#dd2c00"
};
exports.default = deepOrange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gD0Mr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const brown = {
    50: "#efebe9",
    100: "#d7ccc8",
    200: "#bcaaa4",
    300: "#a1887f",
    400: "#8d6e63",
    500: "#795548",
    600: "#6d4c41",
    700: "#5d4037",
    800: "#4e342e",
    900: "#3e2723",
    A100: "#d7ccc8",
    A200: "#bcaaa4",
    A400: "#8d6e63",
    A700: "#5d4037"
};
exports.default = brown;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cG4f1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const blueGrey = {
    50: "#eceff1",
    100: "#cfd8dc",
    200: "#b0bec5",
    300: "#90a4ae",
    400: "#78909c",
    500: "#607d8b",
    600: "#546e7a",
    700: "#455a64",
    800: "#37474f",
    900: "#263238",
    A100: "#cfd8dc",
    A200: "#b0bec5",
    A400: "#78909c",
    A700: "#455a64"
};
exports.default = blueGrey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hCJE4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _appBarDefault.default));
parcelHelpers.export(exports, "appBarClasses", ()=>(0, _appBarClassesDefault.default));
var _appBar = require("./AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _appBarClasses = require("./appBarClasses");
var _appBarClassesDefault = parcelHelpers.interopDefault(_appBarClasses);
parcelHelpers.exportAll(_appBarClasses, exports);
"use client";

},{"./AppBar":"2xXkt","./appBarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2xXkt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _appBarClasses = require("./appBarClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const useUtilityClasses = (ownerState)=>{
    const { color, position, classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            `position${(0, _capitalizeDefault.default)(position)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _appBarClasses.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const AppBarRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`],
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, _extendsDefault.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, _extendsDefault.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, _extendsDefault.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const AppBar = /*#__PURE__*/ _react.forwardRef(function AppBar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className, color = "primary", enableColorOnDark = false, position = "fixed" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        position,
        enableColorOnDark
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppBarRoot, (0, _extendsDefault.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, _clsxDefault.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
exports.default = AppBar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","../Paper":"4qOeF","./appBarClasses":"eIrE1","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4qOeF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "paperClasses", ()=>(0, _paperClassesDefault.default));
var _paper = require("./Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _paperClasses = require("./paperClasses");
var _paperClassesDefault = parcelHelpers.interopDefault(_paperClasses);
parcelHelpers.exportAll(_paperClasses, exports);
"use client";

},{"./Paper":"l00ql","./paperClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l00ql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _getOverlayAlpha = require("../styles/getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _paperClasses = require("./paperClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _paperClasses.getPaperUtilityClass), classes);
};
const PaperRoot = (0, _styledDefault.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$vars$overlays;
    return (0, _extendsDefault.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, _extendsDefault.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, _system.alpha)("#fff", (0, _getOverlayAlphaDefault.default)(ownerState.elevation))}, ${(0, _system.alpha)("#fff", (0, _getOverlayAlphaDefault.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const Paper = /*#__PURE__*/ _react.forwardRef(function Paper(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className, component = "div", elevation = 1, square = false, variant = "elevation" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        elevation,
        square,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other));
});
exports.default = Paper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/getOverlayAlpha":"f4rjK","../styles/useThemeProps":"4dkr8","../styles/useTheme":"6UMPc","./paperClasses":"1ckZn","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ckZn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaperUtilityClass", ()=>getPaperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPaper", slot);
}
const paperClasses = (0, _generateUtilityClassesDefault.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
exports.default = paperClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eIrE1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppBarUtilityClass", ()=>getAppBarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAppBarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiAppBar", slot);
}
const appBarClasses = (0, _generateUtilityClassesDefault.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
exports.default = appBarClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3qDJc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _autocompleteDefault.default));
parcelHelpers.export(exports, "createFilterOptions", ()=>(0, _autocomplete.createFilterOptions));
parcelHelpers.export(exports, "autocompleteClasses", ()=>(0, _autocompleteClassesDefault.default));
var _autocomplete = require("./Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _autocompleteClasses = require("./autocompleteClasses");
var _autocompleteClassesDefault = parcelHelpers.interopDefault(_autocompleteClasses);
parcelHelpers.exportAll(_autocompleteClasses, exports);
"use client";

},{"./Autocomplete":"bz7v3","./autocompleteClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bz7v3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilterOptions", ()=>(0, _base.createFilterOptions));
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _base = require("@mui/base");
var _system = require("@mui/system");
var _popper = require("../Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _listSubheader = require("../ListSubheader");
var _listSubheaderDefault = parcelHelpers.interopDefault(_listSubheader);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _iconButton = require("../IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _chip = require("../Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _inputClasses = require("../Input/inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
var _inputBaseClasses = require("../InputBase/inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
var _outlinedInputClasses = require("../OutlinedInput/outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
var _filledInputClasses = require("../FilledInput/filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
var _close = require("../internal/svg-icons/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _arrowDropDown = require("../internal/svg-icons/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _autocompleteClasses = require("./autocompleteClasses");
var _autocompleteClassesDefault = parcelHelpers.interopDefault(_autocompleteClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _ClearIcon, _ArrowDropDownIcon;
const _excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], _excluded2 = [
    "ref"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePortal, expanded, focused, fullWidth, hasClearIcon, hasPopupIcon, inputFocused, popupOpen, size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, _capitalizeDefault.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _autocompleteClasses.getAutocompleteUtilityClass), classes);
};
const AutocompleteRoot = (0, _styledDefault.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { fullWidth, hasClearIcon, hasPopupIcon, inputFocused, size } = ownerState;
        return [
            {
                [`& .${(0, _autocompleteClassesDefault.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, _autocompleteClassesDefault.default).tag}`]: styles[`tagSize${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _autocompleteClassesDefault.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, _autocompleteClassesDefault.default).input}`]: styles.input
            },
            {
                [`& .${(0, _autocompleteClassesDefault.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        [`&.${(0, _autocompleteClassesDefault.default).focused} .${(0, _autocompleteClassesDefault.default).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, _autocompleteClassesDefault.default).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, _autocompleteClassesDefault.default).tag}`]: (0, _extendsDefault.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, _autocompleteClassesDefault.default).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}&, .${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}.${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, _autocompleteClassesDefault.default).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, _inputClassesDefault.default).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, _inputClassesDefault.default).root}.${(0, _inputBaseClassesDefault.default).sizeSmall}`]: {
            [`& .${(0, _inputClassesDefault.default).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, _outlinedInputClassesDefault.default).root}`]: {
            padding: 9,
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}&, .${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}.${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, _autocompleteClassesDefault.default).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, _autocompleteClassesDefault.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, _outlinedInputClassesDefault.default).root}.${(0, _inputBaseClassesDefault.default).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, _autocompleteClassesDefault.default).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, _filledInputClassesDefault.default).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}&, .${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, _autocompleteClassesDefault.default).hasPopupIcon}.${(0, _autocompleteClassesDefault.default).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, _filledInputClassesDefault.default).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, _autocompleteClassesDefault.default).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, _filledInputClassesDefault.default).root}.${(0, _inputBaseClassesDefault.default).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, _filledInputClassesDefault.default).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, _inputBaseClassesDefault.default).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, _filledInputClassesDefault.default).root}.${(0, _inputBaseClassesDefault.default).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, _autocompleteClassesDefault.default).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, _filledInputClassesDefault.default).root}.${(0, _inputBaseClassesDefault.default).hiddenLabel}.${(0, _inputBaseClassesDefault.default).sizeSmall}`]: {
            [`& .${(0, _autocompleteClassesDefault.default).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, _autocompleteClassesDefault.default).input}`]: (0, _extendsDefault.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const AutocompleteEndAdornment = (0, _styledDefault.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const AutocompleteClearIndicator = (0, _styledDefault.default)((0, _iconButtonDefault.default), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const AutocompletePopupIndicator = (0, _styledDefault.default)((0, _iconButtonDefault.default), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState }, styles)=>(0, _extendsDefault.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState })=>(0, _extendsDefault.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const AutocompletePopper = (0, _styledDefault.default)((0, _popperDefault.default), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _autocompleteClassesDefault.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const AutocompletePaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const AutocompleteLoading = (0, _styledDefault.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const AutocompleteNoOptions = (0, _styledDefault.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const AutocompleteListbox = (0, _styledDefault.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, _autocompleteClassesDefault.default).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, _autocompleteClassesDefault.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, _autocompleteClassesDefault.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, _autocompleteClassesDefault.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, _autocompleteClassesDefault.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const AutocompleteGroupLabel = (0, _styledDefault.default)((0, _listSubheaderDefault.default), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const AutocompleteGroupUl = (0, _styledDefault.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, _autocompleteClassesDefault.default).option}`]: {
        paddingLeft: 24
    }
});
const Autocomplete = /*#__PURE__*/ _react.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete = false, autoHighlight = false, autoSelect = false, blurOnSelect = false, ChipProps, className, clearIcon = _ClearIcon || (_ClearIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {
        fontSize: "small"
    })), clearOnBlur = !props.freeSolo, clearOnEscape = false, clearText = "Clear", closeText = "Close", componentsProps = {}, defaultValue = props.multiple ? [] : null, disableClearable = false, disableCloseOnSelect = false, disabled = false, disabledItemsFocusable = false, disableListWrap = false, disablePortal = false, filterSelectedOptions = false, forcePopupIcon = "auto", freeSolo = false, fullWidth = false, getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy, handleHomeEndKeys = !props.freeSolo, includeInputInList = false, limitTags = -1, ListboxComponent = "ul", ListboxProps, loading = false, loadingText = "Loading\u2026", multiple = false, noOptionsText = "No options", openOnFocus = false, openText = "Open", PaperComponent = (0, _paperDefault.default), PopperComponent = (0, _popperDefault.default), popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropDownDefault.default), {})), readOnly = false, renderGroup: renderGroupProp, renderInput, renderOption: renderOptionProp, renderTags, selectOnFocus = !props.freeSolo, size = "medium", slotProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps, getInputProps, getInputLabelProps, getPopupIndicatorProps, getClearProps, getTagProps, getListboxProps, getOptionProps, value, dirty, expanded, id, popupOpen, focused, focusedTag, anchorEl, setAnchorEl, inputValue, groupedOptions } = (0, _base.useAutocomplete)((0, _extendsDefault.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, _objectWithoutPropertiesLooseDefault.default)(_getListboxProps, _excluded2);
    const combinedListboxRef = (0, _useForkRefDefault.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disablePortal,
        expanded,
        focused,
        fullWidth,
        getOptionLabel,
        hasClearIcon,
        hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen,
        size
    });
    const classes = useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, _extendsDefault.default)({
                className: classes.tag,
                disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), (0, _extendsDefault.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        return /*#__PURE__*/ (0, _react.createElement)("li", (0, _extendsDefault.default)({}, props2, {
            key: props2.key
        }), getOptionLabel(option));
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option,
            index
        });
        return renderOption((0, _extendsDefault.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index,
            inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteRoot, (0, _extendsDefault.default)({
                ref: ref,
                className: (0, _clsxDefault.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id,
                    disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, _extendsDefault.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteClearIndicator, (0, _extendsDefault.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, _clsxDefault.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompletePopupIndicator, (0, _extendsDefault.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, _clsxDefault.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, _extendsDefault.default)({
                        className: classes.input,
                        disabled,
                        readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompletePopper, (0, _extendsDefault.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, _clsxDefault.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AutocompletePaper, (0, _extendsDefault.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, _clsxDefault.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AutocompleteListbox, (0, _extendsDefault.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
exports.default = Autocomplete;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base":"g25Dc","@mui/system":"gwZXT","../Popper":"2EAIq","../ListSubheader":"5DWNS","../Paper":"4qOeF","../IconButton":"6bnps","../Chip":"bwuFy","../Input/inputClasses":"aVvbK","../InputBase/inputBaseClasses":"ggb4X","../OutlinedInput/outlinedInputClasses":"iCEso","../FilledInput/filledInputClasses":"8Iw8v","../internal/svg-icons/Close":"hLFq1","../internal/svg-icons/ArrowDropDown":"kZF9C","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./autocompleteClasses":"1GQJE","../utils/capitalize":"bIHYz","../utils/useForkRef":"kWp3j","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g25Dc":[function(require,module,exports) {
/**
 * @mui/base v5.0.0-beta.36
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickAwayListener", ()=>(0, _clickAwayListener.ClickAwayListener));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdown.Dropdown));
parcelHelpers.export(exports, "FocusTrap", ()=>(0, _focusTrap.FocusTrap));
parcelHelpers.export(exports, "NoSsr", ()=>(0, _noSsr.NoSsr));
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper));
parcelHelpers.export(exports, "Portal", ()=>(0, _portal.Portal));
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosize.TextareaAutosize));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClass.generateUtilityClass));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _badge = require("./Badge");
parcelHelpers.exportAll(_badge, exports);
var _button = require("./Button");
parcelHelpers.exportAll(_button, exports);
var _clickAwayListener = require("./ClickAwayListener");
var _composeClasses = require("./composeClasses");
parcelHelpers.exportAll(_composeClasses, exports);
var _dropdown = require("./Dropdown");
var _focusTrap = require("./FocusTrap");
var _formControl = require("./FormControl");
parcelHelpers.exportAll(_formControl, exports);
var _input = require("./Input");
parcelHelpers.exportAll(_input, exports);
var _menu = require("./Menu");
parcelHelpers.exportAll(_menu, exports);
var _menuButton = require("./MenuButton");
parcelHelpers.exportAll(_menuButton, exports);
var _menuItem = require("./MenuItem");
parcelHelpers.exportAll(_menuItem, exports);
var _modal = require("./Modal");
parcelHelpers.exportAll(_modal, exports);
var _noSsr = require("./NoSsr");
var _unstableNumberInput = require("./Unstable_NumberInput");
parcelHelpers.exportAll(_unstableNumberInput, exports);
var _optionGroup = require("./OptionGroup");
parcelHelpers.exportAll(_optionGroup, exports);
var _option = require("./Option");
parcelHelpers.exportAll(_option, exports);
var _popper = require("./Popper");
var _unstablePopup = require("./Unstable_Popup");
parcelHelpers.exportAll(_unstablePopup, exports);
var _portal = require("./Portal");
var _select = require("./Select");
parcelHelpers.exportAll(_select, exports);
var _slider = require("./Slider");
parcelHelpers.exportAll(_slider, exports);
var _snackbar = require("./Snackbar");
parcelHelpers.exportAll(_snackbar, exports);
var _switch = require("./Switch");
parcelHelpers.exportAll(_switch, exports);
var _tablePagination = require("./TablePagination");
parcelHelpers.exportAll(_tablePagination, exports);
var _tabPanel = require("./TabPanel");
parcelHelpers.exportAll(_tabPanel, exports);
var _tabsList = require("./TabsList");
parcelHelpers.exportAll(_tabsList, exports);
var _tabs = require("./Tabs");
parcelHelpers.exportAll(_tabs, exports);
var _tab = require("./Tab");
parcelHelpers.exportAll(_tab, exports);
var _textareaAutosize = require("./TextareaAutosize");
var _transitions = require("./Transitions");
parcelHelpers.exportAll(_transitions, exports);
var _useAutocomplete = require("./useAutocomplete");
parcelHelpers.exportAll(_useAutocomplete, exports);
var _useBadge = require("./useBadge");
parcelHelpers.exportAll(_useBadge, exports);
var _useButton = require("./useButton");
parcelHelpers.exportAll(_useButton, exports);
var _useDropdown = require("./useDropdown");
parcelHelpers.exportAll(_useDropdown, exports);
var _useInput = require("./useInput");
parcelHelpers.exportAll(_useInput, exports);
var _useMenu = require("./useMenu");
parcelHelpers.exportAll(_useMenu, exports);
var _useMenuButton = require("./useMenuButton");
parcelHelpers.exportAll(_useMenuButton, exports);
var _useMenuItem = require("./useMenuItem");
parcelHelpers.exportAll(_useMenuItem, exports);
var _unstableUseNumberInput = require("./unstable_useNumberInput");
parcelHelpers.exportAll(_unstableUseNumberInput, exports);
var _useOption = require("./useOption");
parcelHelpers.exportAll(_useOption, exports);
var _useSelect = require("./useSelect");
parcelHelpers.exportAll(_useSelect, exports);
var _useSlider = require("./useSlider");
parcelHelpers.exportAll(_useSlider, exports);
var _useSnackbar = require("./useSnackbar");
parcelHelpers.exportAll(_useSnackbar, exports);
var _useSwitch = require("./useSwitch");
parcelHelpers.exportAll(_useSwitch, exports);
var _useTab = require("./useTab");
parcelHelpers.exportAll(_useTab, exports);
var _useTabPanel = require("./useTabPanel");
parcelHelpers.exportAll(_useTabPanel, exports);
var _useTabs = require("./useTabs");
parcelHelpers.exportAll(_useTabs, exports);
var _useTabsList = require("./useTabsList");
parcelHelpers.exportAll(_useTabsList, exports);
var _unstableUseModal = require("./unstable_useModal");
parcelHelpers.exportAll(_unstableUseModal, exports);
var _generateUtilityClass = require("./generateUtilityClass");

},{"./utils":"17Cv3","./Badge":false,"./Button":false,"./ClickAwayListener":false,"./composeClasses":"icrTb","./Dropdown":false,"./FocusTrap":false,"./FormControl":false,"./Input":false,"./Menu":false,"./MenuButton":false,"./MenuItem":false,"./Modal":false,"./NoSsr":false,"./Unstable_NumberInput":false,"./OptionGroup":false,"./Option":false,"./Popper":false,"./Unstable_Popup":false,"./Portal":false,"./Select":false,"./Slider":false,"./Snackbar":false,"./Switch":false,"./TablePagination":false,"./TabPanel":false,"./TabsList":false,"./Tabs":false,"./Tab":false,"./TextareaAutosize":"ToXOz","./Transitions":false,"./useAutocomplete":"5vheT","./useBadge":false,"./useButton":false,"./useDropdown":false,"./useInput":false,"./useMenu":false,"./useMenuButton":false,"./useMenuItem":false,"./unstable_useNumberInput":false,"./useOption":false,"./useSelect":false,"./useSlider":false,"./useSnackbar":false,"./useSwitch":false,"./useTab":false,"./useTabPanel":false,"./useTabs":false,"./useTabsList":false,"./unstable_useModal":false,"./generateUtilityClass":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"17Cv3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendOwnerState", ()=>(0, _appendOwnerState.appendOwnerState));
parcelHelpers.export(exports, "areArraysEqual", ()=>(0, _areArraysEqual.areArraysEqual));
parcelHelpers.export(exports, "ClassNameConfigurator", ()=>(0, _classNameConfigurator.ClassNameConfigurator));
parcelHelpers.export(exports, "extractEventHandlers", ()=>(0, _extractEventHandlers.extractEventHandlers));
parcelHelpers.export(exports, "isHostComponent", ()=>(0, _isHostComponent.isHostComponent));
parcelHelpers.export(exports, "resolveComponentProps", ()=>(0, _resolveComponentProps.resolveComponentProps));
parcelHelpers.export(exports, "useRootElementName", ()=>(0, _useRootElementName.useRootElementName));
parcelHelpers.export(exports, "useSlotProps", ()=>(0, _useSlotProps.useSlotProps));
parcelHelpers.export(exports, "mergeSlotProps", ()=>(0, _mergeSlotProps.mergeSlotProps));
parcelHelpers.export(exports, "prepareForSlot", ()=>(0, _prepareForSlot.prepareForSlot));
var _appendOwnerState = require("./appendOwnerState");
var _areArraysEqual = require("./areArraysEqual");
var _classNameConfigurator = require("./ClassNameConfigurator");
var _extractEventHandlers = require("./extractEventHandlers");
var _isHostComponent = require("./isHostComponent");
var _resolveComponentProps = require("./resolveComponentProps");
var _useRootElementName = require("./useRootElementName");
var _useSlotProps = require("./useSlotProps");
var _mergeSlotProps = require("./mergeSlotProps");
var _prepareForSlot = require("./prepareForSlot");
var _polymorphicComponent = require("./PolymorphicComponent");
parcelHelpers.exportAll(_polymorphicComponent, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
"use client";

},{"./appendOwnerState":"aoanu","./areArraysEqual":false,"./ClassNameConfigurator":false,"./extractEventHandlers":"f6rg8","./isHostComponent":"k3OGz","./resolveComponentProps":"9Shrr","./useRootElementName":false,"./useSlotProps":"2AEIQ","./mergeSlotProps":"1GAmx","./prepareForSlot":false,"./PolymorphicComponent":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aoanu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ parcelHelpers.export(exports, "appendOwnerState", ()=>appendOwnerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _isHostComponent = require("./isHostComponent");
function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponent.isHostComponent)(elementType)) return otherProps;
    return (0, _extendsDefault.default)({}, otherProps, {
        ownerState: (0, _extendsDefault.default)({}, otherProps.ownerState, ownerState)
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./isHostComponent":"k3OGz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k3OGz":[function(require,module,exports) {
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHostComponent", ()=>isHostComponent);
function isHostComponent(element) {
    return typeof element === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gKh1U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal hook.
 *
 * Wraps the `generateUtilityClass` function and controls how the classes are generated.
 * Currently it only affects whether the classes are applied or not.
 *
 * @returns Function to be called with the `generateUtilityClass` function specific to a component to generate the classes.
 */ parcelHelpers.export(exports, "useClassNamesOverride", ()=>useClassNamesOverride);
/**
 * Allows to configure the components within to not apply any built-in classes.
 */ parcelHelpers.export(exports, "ClassNameConfigurator", ()=>ClassNameConfigurator);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const defaultContextValue = {
    disableDefaultClasses: false
};
const ClassNameConfiguratorContext = /*#__PURE__*/ _react.createContext(defaultContextValue);
function useClassNamesOverride(generateUtilityClass) {
    const { disableDefaultClasses } = _react.useContext(ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function ClassNameConfigurator(props) {
    const { disableDefaultClasses, children } = props;
    const contextValue = _react.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"react":"gVheC","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f6rg8":[function(require,module,exports) {
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractEventHandlers", ()=>extractEventHandlers);
function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Shrr":[function(require,module,exports) {
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveComponentProps", ()=>resolveComponentProps);
function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2AEIQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ parcelHelpers.export(exports, "useSlotProps", ()=>useSlotProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
var _appendOwnerState = require("./appendOwnerState");
var _mergeSlotProps = require("./mergeSlotProps");
var _resolveComponentProps = require("./resolveComponentProps");
"use client";
const _excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false } = parameters, rest = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentProps.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotProps.mergeSlotProps)((0, _extendsDefault.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, _utils.unstable_useForkRef)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, _appendOwnerState.appendOwnerState)(elementType, (0, _extendsDefault.default)({}, mergedProps, {
        ref
    }), ownerState);
    return props;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","./appendOwnerState":"aoanu","./mergeSlotProps":"1GAmx","./resolveComponentProps":"9Shrr","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1GAmx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ parcelHelpers.export(exports, "mergeSlotProps", ()=>mergeSlotProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _extractEventHandlers = require("./extractEventHandlers");
var _omitEventHandlers = require("./omitEventHandlers");
function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsxDefault.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, _extendsDefault.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, _extendsDefault.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlers.extractEventHandlers)((0, _extendsDefault.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlers.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlers.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsxDefault.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, _extendsDefault.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, _extendsDefault.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","clsx":"aGWRz","./extractEventHandlers":"f6rg8","./omitEventHandlers":"fO6hw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fO6hw":[function(require,module,exports) {
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitEventHandlers", ()=>omitEventHandlers);
function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"zMuvO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>(0, _focusTrap.FocusTrap));
var _focusTrap = require("./FocusTrap");
var _focusTrapTypes = require("./FocusTrap.types");
parcelHelpers.exportAll(_focusTrapTypes, exports);

},{"./FocusTrap":"b8gUW","./FocusTrap.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b8gUW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>FocusTrap);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || isNonTabbableRadio(node)) return false;
    return true;
}
function defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function FocusTrap(props) {
    const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
    const ignoreNextEnforceFocus = _react.useRef(false);
    const sentinelStart = _react.useRef(null);
    const sentinelEnd = _react.useRef(null);
    const nodeToRestore = _react.useRef(null);
    const reactFocusEventTarget = _react.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = _react.useRef(false);
    const rootRef = _react.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, _utils.unstable_useForkRef)(children.ref, rootRef);
    const lastKeydown = _react.useRef(null);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ _react.cloneElement(children, {
                ref: handleRef,
                onFocus
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

},{"react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8YhiA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper));
parcelHelpers.export(exports, "popperClasses", ()=>(0, _popperClasses.popperClasses));
parcelHelpers.export(exports, "getPopperUtilityClass", ()=>(0, _popperClasses.getPopperUtilityClass));
var _popper = require("./Popper");
var _popperClasses = require("./popperClasses");
"use client";

},{"./Popper":"aGyZZ","./popperClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aGyZZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("@mui/utils");
var _core = require("@popperjs/core");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("../composeClasses");
var _portal = require("../Portal");
var _popperClasses = require("./popperClasses");
var _utils1 = require("../utils");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], _excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function isVirtualElement(element) {
    return !isHTMLElement(element);
}
const useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _popperClasses.getPopperUtilityClass)));
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ _react.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const tooltipRef = _react.useRef(null);
    const ownRef = (0, _utils.unstable_useForkRef)(tooltipRef, forwardedRef);
    const popperRef = _react.useRef(null);
    const handlePopperRef = (0, _utils.unstable_useForkRef)(popperRef, popperRefProp);
    const handlePopperRefRef = _react.useRef(handlePopperRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    _react.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = _react.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = _react.useState(resolveAnchorEl(anchorEl));
    _react.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    _react.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, _extendsDefault.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, _utils1.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl, children, container: containerProp, direction = "ltr", disablePortal = false, keepMounted = false, modifiers, open, placement = "bottom", popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const [exited, setExited] = _react.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _utils.unstable_ownerDocument)(resolvedAnchorEl).body : (0, _utils.unstable_ownerDocument)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portal.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperTooltip, (0, _extendsDefault.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, _extendsDefault.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/utils":"dv12b","@popperjs/core":"4hsn0","prop-types":"3KNJy","../composeClasses":"icrTb","../Portal":"lQYHN","./popperClasses":"kCl3i","../utils":"17Cv3","../utils/ClassNameConfigurator":"gKh1U","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4hsn0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"b6rlN","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b5FfS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9TNhp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"aupwF","./dom-utils/getLayoutRect.js":"4Svlc","./dom-utils/listScrollParents.js":"kkOth","./dom-utils/getOffsetParent.js":"l1PfB","./utils/orderModifiers.js":"4DHdJ","./utils/debounce.js":"gk1i2","./utils/mergeByName.js":"edQbS","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aupwF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"W6sdV","./getNodeScroll.js":"hsENS","./getNodeName.js":"03pwW","./instanceOf.js":"2VEIg","./getWindowScrollBarX.js":"izBbk","./getDocumentElement.js":"jdhv9","./isScrollParent.js":"gMMQm","../utils/math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"W6sdV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"2VEIg","../utils/math.js":"kPfYH","./getWindow.js":"fhro1","./isLayoutViewport.js":"eYgf8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2VEIg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"fhro1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fhro1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kPfYH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eYgf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"gJG6B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gJG6B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hsENS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"fBy0m","./getWindow.js":"fhro1","./instanceOf.js":"2VEIg","./getHTMLElementScroll.js":"jgi0Y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fBy0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"fhro1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jgi0Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"03pwW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"izBbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"W6sdV","./getDocumentElement.js":"jdhv9","./getWindowScroll.js":"fBy0m","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jdhv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMMQm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"7sBQe","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7sBQe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"fhro1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Svlc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"W6sdV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kkOth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"5j2bR","./getParentNode.js":"j7de1","./getWindow.js":"fhro1","./isScrollParent.js":"gMMQm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5j2bR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"j7de1","./isScrollParent.js":"gMMQm","./getNodeName.js":"03pwW","./instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j7de1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"03pwW","./getDocumentElement.js":"jdhv9","./instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l1PfB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"fhro1","./getNodeName.js":"03pwW","./getComputedStyle.js":"7sBQe","./instanceOf.js":"2VEIg","./isTableElement.js":"h6Z3m","./getParentNode.js":"j7de1","../utils/userAgent.js":"gJG6B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h6Z3m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"03pwW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4DHdJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"b5FfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gk1i2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"edQbS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kK3Bx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"fT3rw","../dom-utils/getDocumentElement.js":"jdhv9","../dom-utils/getBoundingClientRect.js":"W6sdV","./computeOffsets.js":"auVKN","./rectToClientRect.js":"dDDZH","../enums.js":"b5FfS","../dom-utils/instanceOf.js":"2VEIg","./mergePaddingObject.js":"bxyvV","./expandToHashMap.js":"dc3lT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fT3rw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"b5FfS","./getViewportRect.js":"gF8jF","./getDocumentRect.js":"dGFrK","./listScrollParents.js":"kkOth","./getOffsetParent.js":"l1PfB","./getDocumentElement.js":"jdhv9","./getComputedStyle.js":"7sBQe","./instanceOf.js":"2VEIg","./getBoundingClientRect.js":"W6sdV","./getParentNode.js":"j7de1","./contains.js":"9QzIi","./getNodeName.js":"03pwW","../utils/rectToClientRect.js":"dDDZH","../utils/math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gF8jF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"fhro1","./getDocumentElement.js":"jdhv9","./getWindowScrollBarX.js":"izBbk","./isLayoutViewport.js":"eYgf8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dGFrK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"jdhv9","./getComputedStyle.js":"7sBQe","./getWindowScrollBarX.js":"izBbk","./getWindowScroll.js":"fBy0m","../utils/math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9QzIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dDDZH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"auVKN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"60CwL","./getVariation.js":"eC0hR","./getMainAxisFromPlacement.js":"fassx","../enums.js":"b5FfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"60CwL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"b5FfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eC0hR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fassx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bxyvV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"7jlH6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7jlH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dc3lT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b6rlN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"9TNhp","./modifiers/eventListeners.js":"e6C3L","./modifiers/popperOffsets.js":"fk4v7","./modifiers/computeStyles.js":"aiagt","./modifiers/applyStyles.js":"9addq","./modifiers/offset.js":"bLK75","./modifiers/flip.js":"6NhFz","./modifiers/preventOverflow.js":"k5J9l","./modifiers/arrow.js":"jhAcq","./modifiers/hide.js":"aSHAm","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6C3L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"fhro1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fk4v7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"auVKN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aiagt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"b5FfS","../dom-utils/getOffsetParent.js":"l1PfB","../dom-utils/getWindow.js":"fhro1","../dom-utils/getDocumentElement.js":"jdhv9","../dom-utils/getComputedStyle.js":"7sBQe","../utils/getBasePlacement.js":"60CwL","../utils/getVariation.js":"eC0hR","../utils/math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9addq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"03pwW","../dom-utils/instanceOf.js":"2VEIg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bLK75":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"60CwL","../enums.js":"b5FfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6NhFz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"5xWqY","../utils/getBasePlacement.js":"60CwL","../utils/getOppositeVariationPlacement.js":"5dbB7","../utils/detectOverflow.js":"kK3Bx","../utils/computeAutoPlacement.js":"hbkdz","../enums.js":"b5FfS","../utils/getVariation.js":"eC0hR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5xWqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5dbB7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hbkdz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"eC0hR","../enums.js":"b5FfS","./detectOverflow.js":"kK3Bx","./getBasePlacement.js":"60CwL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k5J9l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"b5FfS","../utils/getBasePlacement.js":"60CwL","../utils/getMainAxisFromPlacement.js":"fassx","../utils/getAltAxis.js":"knDhE","../utils/within.js":"8Dt3l","../dom-utils/getLayoutRect.js":"4Svlc","../dom-utils/getOffsetParent.js":"l1PfB","../utils/detectOverflow.js":"kK3Bx","../utils/getVariation.js":"eC0hR","../utils/getFreshSideObject.js":"7jlH6","../utils/math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"knDhE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Dt3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"kPfYH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jhAcq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"60CwL","../dom-utils/getLayoutRect.js":"4Svlc","../dom-utils/contains.js":"9QzIi","../dom-utils/getOffsetParent.js":"l1PfB","../utils/getMainAxisFromPlacement.js":"fassx","../utils/within.js":"8Dt3l","../utils/mergePaddingObject.js":"bxyvV","../utils/expandToHashMap.js":"dc3lT","../enums.js":"b5FfS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aSHAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"b5FfS","../utils/detectOverflow.js":"kK3Bx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lQYHN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>(0, _portal.Portal));
var _portal = require("./Portal");
var _portalTypes = require("./Portal.types");
parcelHelpers.exportAll(_portalTypes, exports);
"use client";

},{"./Portal":"ex0G1","./Portal.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ex0G1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
var _react = require("react");
var _reactDom = require("react-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const Portal = /*#__PURE__*/ _react.forwardRef(function Portal(props, forwardedRef) {
    const { children, container, disablePortal = false } = props;
    const [mountNode, setMountNode] = _react.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, _utils.unstable_useForkRef)(/*#__PURE__*/ _react.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!disablePortal) setMountNode(getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (mountNode && !disablePortal) {
            (0, _utils.unstable_setRef)(forwardedRef, mountNode);
            return ()=>{
                (0, _utils.unstable_setRef)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ _react.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ _react.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: mountNode ? /*#__PURE__*/ _reactDom.createPortal(children, mountNode) : mountNode
    });
});

},{"react":"gVheC","react-dom":"d8jlt","prop-types":"3KNJy","@mui/utils":"dv12b","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kCl3i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopperUtilityClass", ()=>getPopperUtilityClass);
parcelHelpers.export(exports, "popperClasses", ()=>popperClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Popper";
function getPopperUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const popperClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root"
]);

},{"../generateUtilityClass":"eMaf5","../generateUtilityClasses":"j6cL7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eMaf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUtilityClass", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
const GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(state) {
    return `${GLOBAL_CLASS_PREFIX}--${state}`;
}
function buildSlotClass(componentName, slot) {
    return `${GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function generateUtilityClass(componentName, slot) {
    const globalStateClass = (0, _generateUtilityClass.globalStateClasses)[slot];
    return globalStateClass ? buildStateClass(globalStateClass) : buildSlotClass(componentName, slot);
}
function isGlobalState(slot) {
    return (0, _generateUtilityClass.globalStateClasses)[slot] !== undefined;
}

},{"@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j6cL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUtilityClasses", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
function generateUtilityClasses(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClass.generateUtilityClass)(componentName, slot);
    });
    return result;
}

},{"../generateUtilityClass":"eMaf5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ToXOz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosize.TextareaAutosize));
var _textareaAutosize = require("./TextareaAutosize");
var _textareaAutosizeTypes = require("./TextareaAutosize.types");
parcelHelpers.exportAll(_textareaAutosizeTypes, exports);
"use client";

},{"./TextareaAutosize":"ciI48","./TextareaAutosize.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ciI48":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextareaAutosize", ()=>TextareaAutosize);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("react-dom");
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const TextareaAutosize = /*#__PURE__*/ _react.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(forwardedRef, inputRef);
    const shadowRef = _react.useRef(null);
    const renders = _react.useRef(0);
    const [state, setState] = _react.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = _react.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle, overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow,
                outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = _react.useCallback(()=>{
        const newState = getUpdatedState();
        if (isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if (isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            _reactDom.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, _utils.unstable_debounce)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        syncHeight();
    });
    _react.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", (0, _extendsDefault.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, _extendsDefault.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, _extendsDefault.default)({}, styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","react-dom":"d8jlt","@mui/utils":"dv12b","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5vheT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useAutocomplete = require("./useAutocomplete");
parcelHelpers.exportAll(_useAutocomplete, exports);

},{"./useAutocomplete":"gFgAf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gFgAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFilterOptions", ()=>createFilterOptions);
parcelHelpers.export(exports, "useAutocomplete", ()=>useAutocomplete);
/* eslint-disable no-constant-condition */ var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function createFilterOptions(config = {}) {
    const { ignoreAccents = true, ignoreCase = true, limit, matchFrom = "any", stringify, trim = false } = config;
    return (options, { inputValue, getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const defaultFilterOptions = createFilterOptions();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const pageSize = 5;
const defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function useAutocomplete(props) {
    const { // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox, // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete = false, autoHighlight = false, autoSelect = false, blurOnSelect = false, clearOnBlur = !props.freeSolo, clearOnEscape = false, componentName = "useAutocomplete", defaultValue = props.multiple ? [] : null, disableClearable = false, disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable = false, disableListWrap = false, filterOptions = defaultFilterOptions, filterSelectedOptions = false, freeSolo = false, getOptionDisabled, getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy, handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue = (option, value)=>option === value, multiple = false, onChange, onClose, onHighlightChange, onInputChange, onOpen, open: openProp, openOnFocus = false, options, readOnly = false, selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, _utils.unstable_useId)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = _react.useRef(false);
    const firstFocus = _react.useRef(true);
    const inputRef = _react.useRef(null);
    const listboxRef = _react.useRef(null);
    const [anchorEl, setAnchorEl] = _react.useState(null);
    const [focusedTag, setFocusedTag] = _react.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = _react.useRef(defaultHighlighted);
    const [value, setValueState] = (0, _utils.unstable_useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, _utils.unstable_useControlled)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = _react.useState(false);
    const resetInputValue = _react.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, _utils.unstable_useControlled)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = _react.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel
    }) : [];
    const previousProps = (0, _utils.usePreviousProps)({
        filteredOptions,
        value,
        inputValue
    });
    _react.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, _utils.unstable_useEventCallback)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    _react.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, _utils.unstable_useEventCallback)(({ event, index, reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, _utils.unstable_useEventCallback)(({ event, diff, direction = "next", reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason,
            event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = _react.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, _utils.unstable_useEventCallback)((node)=>{
        (0, _utils.unstable_setRef)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    _react.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = _react.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event,
            index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index,
                group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, _extendsDefault.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index })=>(0, _extendsDefault.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index, option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id,
        inputValue,
        value,
        dirty,
        expanded: popupOpen && anchorEl,
        popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl,
        setAnchorEl,
        focusedTag,
        groupedOptions
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b2ivC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBadge", ()=>(0, _useBadge.useBadge));
var _useBadge = require("./useBadge");
var _useBadgeTypes = require("./useBadge.types");
parcelHelpers.exportAll(_useBadgeTypes, exports);
"use client";

},{"./useBadge":"aw1ia","./useBadge.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aw1ia":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ parcelHelpers.export(exports, "useBadge", ()=>useBadge);
var _utils = require("@mui/utils");
"use client";
function useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero = false } = parameters;
    const prevProps = (0, _utils.usePreviousProps)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent, max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent,
        invisible,
        max,
        displayValue
    };
}

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jhyvS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_useModal", ()=>(0, _useModal.useModal));
var _useModal = require("./useModal");
var _useModalTypes = require("./useModal.types");
parcelHelpers.exportAll(_useModalTypes, exports);
var _modalManager = require("./ModalManager");
parcelHelpers.exportAll(_modalManager, exports);
"use client";

},{"./useModal":"fPBiw","./useModal.types":false,"./ModalManager":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fPBiw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ parcelHelpers.export(exports, "useModal", ()=>useModal);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _utils1 = require("../utils");
var _modalManager = require("./ModalManager");
"use client";
function getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new (0, _modalManager.ModalManager)();
function useModal(parameters) {
    const { container, disableEscapeKeyDown = false, disableScrollLock = false, // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = _react.useRef({});
    const mountNodeRef = _react.useRef(null);
    const modalRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(modalRef, rootRef);
    const [exited, setExited] = _react.useState(!open);
    const hasTransition = getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, _utils.unstable_ownerDocument)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, _utils.unstable_useEventCallback)(()=>{
        const resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = _react.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, _utils.unstable_useEventCallback)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, _modalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = _react.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    _react.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    _react.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, _utils1.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, _extendsDefault.default)({}, propsEventHandlers, otherHandlers);
        return (0, _extendsDefault.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, _extendsDefault.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, _utils.unstable_createChainedFunction)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, _utils.unstable_createChainedFunction)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps,
        getBackdropProps,
        getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal,
        exited,
        hasTransition
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","../utils":"17Cv3","./ModalManager":"3J9oW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3J9oW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ariaHidden", ()=>ariaHidden);
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ parcelHelpers.export(exports, "ModalManager", ()=>ModalManager);
var _utils = require("@mui/utils");
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    const doc = (0, _utils.unstable_ownerDocument)(container);
    if (doc.body === container) return (0, _utils.unstable_ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function getPaddingRight(element) {
    return parseInt((0, _utils.unstable_ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, show);
    });
}
function findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, _utils.unstable_getScrollbarSize)((0, _utils.unstable_ownerDocument)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, _utils.unstable_ownerDocument)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, _utils.unstable_ownerDocument)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, _utils.unstable_ownerWindow)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value, el, property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class ModalManager {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) ariaHidden(modal.modalRef, false);
        const hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container,
            restore: null,
            hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, ariaHiddenState);
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2EAIq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popperDefault.default));
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
"use client";

},{"./Popper":"hUjDz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hUjDz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _popper = require("@mui/base/Popper");
var _system = require("@mui/system");
var _utils = require("@mui/utils");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _styles = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const PopperRoot = (0, _styles.styled)((0, _popper.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, _system.useThemeWithoutDefault)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl, component, components, componentsProps, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, _extendsDefault.default)({
        anchorEl,
        container,
        disablePortal,
        keepMounted,
        modifiers,
        open,
        placement,
        popperOptions,
        popperRef,
        transition
    }, other);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperRoot, (0, _extendsDefault.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
exports.default = Popper;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/base/Popper":"8YhiA","@mui/system":"gwZXT","@mui/utils":"dv12b","prop-types":"3KNJy","react":"gVheC","../styles":"gNR9m","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5DWNS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listSubheaderDefault.default));
parcelHelpers.export(exports, "listSubheaderClasses", ()=>(0, _listSubheaderClassesDefault.default));
var _listSubheader = require("./ListSubheader");
var _listSubheaderDefault = parcelHelpers.interopDefault(_listSubheader);
var _listSubheaderClasses = require("./listSubheaderClasses");
var _listSubheaderClassesDefault = parcelHelpers.interopDefault(_listSubheaderClasses);
parcelHelpers.exportAll(_listSubheaderClasses, exports);
"use client";

},{"./ListSubheader":"28fT0","./listSubheaderClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28fT0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _listSubheaderClasses = require("./listSubheaderClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disableGutters, inset, disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, _capitalizeDefault.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _listSubheaderClasses.getListSubheaderUtilityClass), classes);
};
const ListSubheaderRoot = (0, _styledDefault.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const ListSubheader = /*#__PURE__*/ _react.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className, color = "default", component = "li", disableGutters = false, disableSticky = false, inset = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disableGutters,
        disableSticky,
        inset
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListSubheaderRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
ListSubheader.muiSkipListHighlight = true;
exports.default = ListSubheader;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","./listSubheaderClasses":"gLD2Y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gLD2Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListSubheaderUtilityClass", ()=>getListSubheaderUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListSubheaderUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListSubheader", slot);
}
const listSubheaderClasses = (0, _generateUtilityClassesDefault.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
exports.default = listSubheaderClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6bnps":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _iconButtonDefault.default));
parcelHelpers.export(exports, "iconButtonClasses", ()=>(0, _iconButtonClassesDefault.default));
var _iconButton = require("./IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
parcelHelpers.exportAll(_iconButtonClasses, exports);
"use client";

},{"./IconButton":"1JBab","./iconButtonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1JBab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, color, edge, size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, _capitalizeDefault.default)(color)}`,
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _iconButtonClasses.getIconButtonUtilityClass), classes);
};
const IconButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, _capitalizeDefault.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme, ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, _extendsDefault.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, _extendsDefault.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, _extendsDefault.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, _iconButtonClassesDefault.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const IconButton = /*#__PURE__*/ _react.forwardRef(function IconButton(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge = false, children, className, color = "default", disabled = false, disableFocusRipple = false, size = "medium" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        edge,
        color,
        disabled,
        disableFocusRipple,
        size
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
exports.default = IconButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../ButtonBase":"ectWz","../utils/capitalize":"bIHYz","./iconButtonClasses":"fMEzx","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ectWz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonBaseDefault.default));
parcelHelpers.export(exports, "buttonBaseClasses", ()=>(0, _buttonBaseClassesDefault.default));
parcelHelpers.export(exports, "touchRippleClasses", ()=>(0, _touchRippleClassesDefault.default));
var _buttonBase = require("./ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
parcelHelpers.exportAll(_buttonBaseClasses, exports);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
parcelHelpers.exportAll(_touchRippleClasses, exports);
"use client";

},{"./ButtonBase":"dfTao","./buttonBaseClasses":false,"./touchRippleClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dfTao":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonBaseRoot", ()=>ButtonBaseRoot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _touchRipple = require("./TouchRipple");
var _touchRippleDefault = parcelHelpers.interopDefault(_touchRipple);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { disabled, focusVisible, focusVisibleClassName, classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _buttonBaseClasses.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const ButtonBaseRoot = (0, _styledDefault.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, _buttonBaseClassesDefault.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const ButtonBase = /*#__PURE__*/ _react.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action, centerRipple = false, children, className, component = "button", disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, LinkComponent = "a", onBlur, onClick, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const buttonRef = _react.useRef(null);
    const rippleRef = _react.useRef(null);
    const handleRippleRef = (0, _useForkRefDefault.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    const [focusVisible, setFocusVisible] = _react.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    _react.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = _react.useState(false);
    _react.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    _react.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, _useEventCallbackDefault.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, _useEventCallbackDefault.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = _react.useRef(false);
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, _useEventCallbackDefault.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, _useForkRefDefault.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        centerRipple,
        component,
        disabled,
        disableRipple,
        disableTouchRipple,
        focusRipple,
        tabIndex,
        focusVisible
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonBaseRoot, (0, _extendsDefault.default)({
        as: ComponentProp,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, _jsxRuntime.jsx)((0, _touchRippleDefault.default), (0, _extendsDefault.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
exports.default = ButtonBase;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/useForkRef":"kWp3j","../utils/useEventCallback":"7Pqt8","../utils/useIsFocusVisible":"6OfIY","./TouchRipple":"jwOYI","./buttonBaseClasses":"jD7ux","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jwOYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DELAY_RIPPLE", ()=>DELAY_RIPPLE);
parcelHelpers.export(exports, "TouchRippleRoot", ()=>TouchRippleRoot);
parcelHelpers.export(exports, "TouchRippleRipple", ()=>TouchRippleRipple);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _utils = require("@mui/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _ripple = require("./Ripple");
var _rippleDefault = parcelHelpers.interopDefault(_ripple);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
let _ = (t)=>t, t, t1, t2, t3;
const _excluded = [
    "center",
    "classes",
    "className"
];
let _1 = (t)=>t, _t, _t2, _t3, _t4;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = (0, _system.keyframes)(_t || (_t = _1(t || (t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const exitKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _1(t1 || (t1 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const pulsateKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _1(t2 || (t2 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const TouchRippleRoot = (0, _styledDefault.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const TouchRippleRipple = (0, _styledDefault.default)((0, _rippleDefault.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})(_t4 || (_t4 = _1(t3 || (t3 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, _touchRippleClassesDefault.default).rippleVisible, enterKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).ripplePulsate, ({ theme })=>theme.transitions.duration.shorter, (0, _touchRippleClassesDefault.default).child, (0, _touchRippleClassesDefault.default).childLeaving, exitKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).childPulsate, pulsateKeyframe, ({ theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const TouchRipple = /*#__PURE__*/ _react.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes = {}, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [ripples, setRipples] = _react.useState([]);
    const nextKey = _react.useRef(0);
    const rippleCallback = _react.useRef(null);
    _react.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = _react.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, _utils.unstable_useTimeout)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = _react.useRef(null);
    const container = _react.useRef(null);
    const startCommit = _react.useCallback((params)=>{
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRipple, {
                    classes: {
                        ripple: (0, _clsxDefault.default)(classes.ripple, (0, _touchRippleClassesDefault.default).ripple),
                        rippleVisible: (0, _clsxDefault.default)(classes.rippleVisible, (0, _touchRippleClassesDefault.default).rippleVisible),
                        ripplePulsate: (0, _clsxDefault.default)(classes.ripplePulsate, (0, _touchRippleClassesDefault.default).ripplePulsate),
                        child: (0, _clsxDefault.default)(classes.child, (0, _touchRippleClassesDefault.default).child),
                        childLeaving: (0, _clsxDefault.default)(classes.childLeaving, (0, _touchRippleClassesDefault.default).childLeaving),
                        childPulsate: (0, _clsxDefault.default)(classes.childPulsate, (0, _touchRippleClassesDefault.default).childPulsate)
                    },
                    timeout: DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = _react.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate,
                        rippleX,
                        rippleY,
                        rippleSize,
                        cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start(DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = _react.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = _react.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    _react.useImperativeHandle(ref, ()=>({
            pulsate,
            start,
            stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)((0, _touchRippleClassesDefault.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
exports.default = TouchRipple;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","react-transition-group":"5ABiG","clsx":"aGWRz","@mui/system":"gwZXT","@mui/utils":"dv12b","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./Ripple":"2rSxC","./touchRippleClasses":"hGaZE","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2rSxC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
function Ripple(props) {
    const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
    const [leaving, setLeaving] = _react.useState(false);
    const rippleClassName = (0, _clsxDefault.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, _clsxDefault.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    _react.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: childClassName
        })
    });
}
exports.default = Ripple;

},{"react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hGaZE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchRippleUtilityClass", ()=>getTouchRippleUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTouchRippleUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTouchRipple", slot);
}
const touchRippleClasses = (0, _generateUtilityClassesDefault.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
exports.default = touchRippleClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jD7ux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonBaseUtilityClass", ()=>getButtonBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiButtonBase", slot);
}
const buttonBaseClasses = (0, _generateUtilityClassesDefault.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
exports.default = buttonBaseClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fMEzx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconButtonUtilityClass", ()=>getIconButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getIconButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiIconButton", slot);
}
const iconButtonClasses = (0, _generateUtilityClassesDefault.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
exports.default = iconButtonClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bwuFy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chipDefault.default));
parcelHelpers.export(exports, "chipClasses", ()=>(0, _chipClassesDefault.default));
var _chip = require("./Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
parcelHelpers.exportAll(_chipClasses, exports);
"use client";

},{"./Chip":"27Gkx","./chipClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"27Gkx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _cancel = require("../internal/svg-icons/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _unsupportedProp = require("../utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, size, color, iconColor, onDelete, clickable, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, _capitalizeDefault.default)(size)}`,
            `color${(0, _capitalizeDefault.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, _capitalizeDefault.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, _capitalizeDefault.default)(color)}`,
            `${variant}${(0, _capitalizeDefault.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, _capitalizeDefault.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, _capitalizeDefault.default)(size)}`,
            `avatarColor${(0, _capitalizeDefault.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(size)}`,
            `iconColor${(0, _capitalizeDefault.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, _capitalizeDefault.default)(size)}`,
            `deleteIconColor${(0, _capitalizeDefault.default)(color)}`,
            `deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _chipClasses.getChipUtilityClass), classes);
};
const ChipRoot = (0, _styledDefault.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { color, iconColor, clickable, onDelete, size, variant } = ownerState;
        return [
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatar${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatarColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`icon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`iconColor${(0, _capitalizeDefault.default)(iconColor)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIconColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, _capitalizeDefault.default)(size)}`],
            styles[`color${(0, _capitalizeDefault.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, _capitalizeDefault.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, _capitalizeDefault.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, _capitalizeDefault.default)(color)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, _extendsDefault.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, _chipClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: (0, _extendsDefault.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, _extendsDefault.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: (0, _extendsDefault.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _system.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _system.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, _system.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, _chipClassesDefault.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _system.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _system.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const ChipLabel = (0, _styledDefault.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, _capitalizeDefault.default)(size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const Chip = /*#__PURE__*/ _react.forwardRef(function Chip(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className, clickable: clickableProp, color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = "medium", variant = "filled", tabIndex, skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const chipRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, _buttonBaseDefault.default) : ComponentProp || "div";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disabled,
        size,
        color,
        iconColor: /*#__PURE__*/ _react.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === (0, _buttonBaseDefault.default) ? (0, _extendsDefault.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ _react.isValidElement(deleteIconProp) ? /*#__PURE__*/ _react.cloneElement(deleteIconProp, {
        className: (0, _clsxDefault.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
        className: (0, _clsxDefault.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ _react.isValidElement(avatarProp)) avatar = /*#__PURE__*/ _react.cloneElement(avatarProp, {
        className: (0, _clsxDefault.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ _react.isValidElement(iconProp)) icon = /*#__PURE__*/ _react.cloneElement(iconProp, {
        className: (0, _clsxDefault.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ChipRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChipLabel, {
                className: (0, _clsxDefault.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
exports.default = Chip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../internal/svg-icons/Cancel":"gp1sm","../utils/useForkRef":"kWp3j","../utils/unsupportedProp":"6LZSm","../utils/capitalize":"bIHYz","../ButtonBase":"ectWz","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./chipClasses":"7lajk","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gp1sm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7lajk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChipUtilityClass", ()=>getChipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getChipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiChip", slot);
}
const chipClasses = (0, _generateUtilityClassesDefault.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
exports.default = chipClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aVvbK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputUtilityClass", ()=>getInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInput", slot);
}
const inputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
exports.default = inputClasses;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","../InputBase":"9Zug6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Zug6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputBaseDefault.default));
parcelHelpers.export(exports, "inputBaseClasses", ()=>(0, _inputBaseClassesDefault.default));
var _inputBase = require("./InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
parcelHelpers.exportAll(_inputBaseClasses, exports);
"use client";

},{"./InputBase":"ca0Zd","./inputBaseClasses":"ggb4X","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ca0Zd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootOverridesResolver", ()=>rootOverridesResolver);
parcelHelpers.export(exports, "inputOverridesResolver", ()=>inputOverridesResolver);
parcelHelpers.export(exports, "InputBaseRoot", ()=>InputBaseRoot);
parcelHelpers.export(exports, "InputBaseComponent", ()=>InputBaseComponent);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _base = require("@mui/base");
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _utils1 = require("./utils");
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, _capitalizeDefault.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _inputBaseClasses.getInputBaseUtilityClass), classes);
};
const InputBaseRoot = (0, _styledDefault.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: rootOverridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const InputBaseComponent = (0, _styledDefault.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: inputOverridesResolver
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, _extendsDefault.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, _extendsDefault.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, _inputBaseClassesDefault.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const inputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ _react.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete, autoFocus, className, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, fullWidth = false, id, inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, slotProps = {}, slots = {}, startAdornment, type = "text", value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef();
    const handleInputRefWarning = _react.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRefDefault.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = _react.useState(false);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    _react.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = _react.useCallback((obj)=>{
        if ((0, _utils1.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessageDefault.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    _react.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, _extendsDefault.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, _extendsDefault.default)({
            type: undefined,
            maxRows,
            minRows
        }, inputProps);
        InputComponent = (0, _base.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    _react.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    });
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseComponent;
    inputProps = (0, _extendsDefault.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            !disableInjectingGlobalStyles && inputGlobalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _base.isHostComponent)(Root) && {
                ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, _clsxDefault.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _extendsDefault.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, _base.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, _extendsDefault.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, _clsxDefault.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, _extendsDefault.default)({}, fcs, {
                        startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
exports.default = InputBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","@mui/utils/formatMuiErrorMessage":"h4Lns","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base":"g25Dc","../FormControl/formControlState":"89R3A","../FormControl/FormControlContext":"aLC94","../FormControl/useFormControl":"5VdUX","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","../utils/useForkRef":"kWp3j","../utils/useEnhancedEffect":"1Zm5y","../GlobalStyles":"j4hem","./utils":"lkbBD","./inputBaseClasses":"ggb4X","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"89R3A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formControlState);
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aLC94":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = FormControlContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5VdUX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormControl);
var _react = require("react");
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
"use client";
function useFormControl() {
    return _react.useContext((0, _formControlContextDefault.default));
}

},{"react":"gVheC","./FormControlContext":"aLC94","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j4hem":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);

},{"./GlobalStyles":"d9vcQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9vcQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _defaultTheme = require("../styles/defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.GlobalStyles), (0, _extendsDefault.default)({}, props, {
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    }));
}
exports.default = GlobalStyles;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/system":"gwZXT","../styles/defaultTheme":"fSMFG","../styles/identifier":"3AQ3O","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lkbBD":[function(require,module,exports) {
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasValue", ()=>hasValue);
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
parcelHelpers.export(exports, "isFilled", ()=>isFilled);
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
parcelHelpers.export(exports, "isAdornedStart", ()=>isAdornedStart);
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
}
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ggb4X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputBaseUtilityClass", ()=>getInputBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputBase", slot);
}
const inputBaseClasses = (0, _generateUtilityClassesDefault.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
exports.default = inputBaseClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iCEso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOutlinedInputUtilityClass", ()=>getOutlinedInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiOutlinedInput", slot);
}
const outlinedInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
exports.default = outlinedInputClasses;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","../InputBase":"9Zug6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Iw8v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilledInputUtilityClass", ()=>getFilledInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFilledInput", slot);
}
const filledInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
exports.default = filledInputClasses;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","../InputBase":"9Zug6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hLFq1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kZF9C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1GQJE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAutocompleteUtilityClass", ()=>getAutocompleteUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAutocompleteUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiAutocomplete", slot);
}
const autocompleteClasses = (0, _generateUtilityClassesDefault.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
exports.default = autocompleteClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1jAfc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _avatarDefault.default));
parcelHelpers.export(exports, "avatarClasses", ()=>(0, _avatarClassesDefault.default));
var _avatar = require("./Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _avatarClasses = require("./avatarClasses");
var _avatarClassesDefault = parcelHelpers.interopDefault(_avatarClasses);
parcelHelpers.exportAll(_avatarClasses, exports);
"use client";

},{"./Avatar":"iaBu5","./avatarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iaBu5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _person = require("../internal/svg-icons/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _avatarClasses = require("./avatarClasses");
var _useSlot = require("../utils/useSlot");
var _useSlotDefault = parcelHelpers.interopDefault(_useSlot);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _avatarClasses.getAvatarUtilityClass), classes);
};
const AvatarRoot = (0, _styledDefault.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, _extendsDefault.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, _extendsDefault.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const AvatarImg = (0, _styledDefault.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const AvatarFallback = (0, _styledDefault.default)((0, _personDefault.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function useLoaded({ crossOrigin, referrerPolicy, src, srcSet }) {
    const [loaded, setLoaded] = _react.useState(false);
    _react.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const Avatar = /*#__PURE__*/ _react.forwardRef(function Avatar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt, children: childrenProp, className, component = "div", slots = {}, slotProps = {}, imgProps, sizes, src, srcSet, variant = "circular" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = useLoaded((0, _extendsDefault.default)({}, imgProps, {
        src,
        srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, _useSlotDefault.default)("img", {
        className: classes.img,
        elementType: AvatarImg,
        externalForwardedProps: {
            slots,
            slotProps: {
                img: (0, _extendsDefault.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt,
            src,
            srcSet,
            sizes
        },
        ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImgSlot, (0, _extendsDefault.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
exports.default = Avatar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../internal/svg-icons/Person":"5zLbk","./avatarClasses":"aPu5k","../utils/useSlot":"jJpvj","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5zLbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPu5k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAvatarUtilityClass", ()=>getAvatarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAvatarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiAvatar", slot);
}
const avatarClasses = (0, _generateUtilityClassesDefault.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
exports.default = avatarClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jJpvj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSlot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
var _utils1 = require("@mui/base/utils");
"use client";
const _excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], _excluded2 = [
    "component",
    "slots",
    "slotProps"
], _excluded3 = [
    "component"
];
function useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className, elementType: initialElementType, ownerState, externalForwardedProps, getSlotOwnerState, internalForwardedProps } = parameters, useSlotPropsParams = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const { component: rootComponent, slots = {
        [name]: undefined
    }, slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(externalForwardedProps, _excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, _utils1.resolveComponentProps)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, _utils1.mergeSlotProps)((0, _extendsDefault.default)({
        className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef } = _mergeSlotProps, mergedProps = (0, _objectWithoutPropertiesLooseDefault.default)(_mergeSlotProps.props, _excluded3);
    const ref = (0, _utils.unstable_useForkRef)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, _extendsDefault.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, _utils1.appendOwnerState)(elementType, (0, _extendsDefault.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","@mui/base/utils":"17Cv3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Jt4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _backdropDefault.default));
parcelHelpers.export(exports, "backdropClasses", ()=>(0, _backdropClassesDefault.default));
var _backdrop = require("./Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _backdropClasses = require("./backdropClasses");
var _backdropClassesDefault = parcelHelpers.interopDefault(_backdropClasses);
parcelHelpers.exportAll(_backdropClasses, exports);
"use client";

},{"./Backdrop":"8sUQN","./backdropClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8sUQN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _fade = require("../Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _backdropClasses = require("./backdropClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _backdropClasses.getBackdropUtilityClass), classes);
};
const BackdropRoot = (0, _styledDefault.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const Backdrop = /*#__PURE__*/ _react.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children, className, component = "div", components = {}, componentsProps = {}, invisible = false, open, slotProps = {}, slots = {}, TransitionComponent = (0, _fadeDefault.default), transitionDuration } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        invisible
    });
    const classes = useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropRoot, (0, _extendsDefault.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, _clsxDefault.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
exports.default = Backdrop;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../Fade":"oyDsU","./backdropClasses":"blbFs","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"oyDsU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fadeDefault.default));
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
"use client";

},{"./Fade":"913s2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"913s2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _utils = require("@mui/utils");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils1 = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Fade = /*#__PURE__*/ _react.forwardRef(function Fade(props, ref) {
    const theme = (0, _useThemeDefault.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const enableStrictModeCompat = true;
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils1.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
exports.default = Fade;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","react-transition-group":"5ABiG","@mui/utils":"dv12b","../styles/useTheme":"6UMPc","../transitions/utils":"1qrTM","../utils/useForkRef":"kWp3j","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"blbFs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBackdropUtilityClass", ()=>getBackdropUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getBackdropUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiBackdrop", slot);
}
const backdropClasses = (0, _generateUtilityClassesDefault.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
exports.default = backdropClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l79LM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "badgeClasses", ()=>(0, _badgeClassesDefault.default));
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _badgeClasses = require("./badgeClasses");
var _badgeClassesDefault = parcelHelpers.interopDefault(_badgeClasses);
parcelHelpers.exportAll(_badgeClasses, exports);
"use client";

},{"./Badge":"l9TIX","./badgeClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9TIX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _useBadge = require("@mui/base/useBadge");
var _base = require("@mui/base");
var _zeroStyled = require("../zero-styled");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _badgeClasses = require("./badgeClasses");
var _badgeClassesDefault = parcelHelpers.interopDefault(_badgeClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useThemeProps = (0, _zeroStyled.createUseThemeProps)("MuiBadge");
const useUtilityClasses = (ownerState)=>{
    const { color, anchorOrigin, invisible, overlap, variant, classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, _capitalizeDefault.default)(anchorOrigin.vertical)}${(0, _capitalizeDefault.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, _capitalizeDefault.default)(anchorOrigin.vertical)}${(0, _capitalizeDefault.default)(anchorOrigin.horizontal)}${(0, _capitalizeDefault.default)(overlap)}`,
            `overlap${(0, _capitalizeDefault.default)(overlap)}`,
            color !== "default" && `color${(0, _capitalizeDefault.default)(color)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _badgeClasses.getBadgeUtilityClass), classes);
};
const BadgeRoot = (0, _zeroStyled.styled)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const BadgeBadge = (0, _zeroStyled.styled)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, _capitalizeDefault.default)(ownerState.anchorOrigin.vertical)}${(0, _capitalizeDefault.default)(ownerState.anchorOrigin.horizontal)}${(0, _capitalizeDefault.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme })=>{
    var _theme$vars;
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: RADIUS_STANDARD * 2,
        borderRadius: RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: RADIUS_DOT,
                    height: RADIUS_DOT * 2,
                    minWidth: RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, _badgeClassesDefault.default).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const Badge = /*#__PURE__*/ _react.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = useThemeProps({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className, component, components = {}, componentsProps = {}, children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots, slotProps, showZero = false, variant: variantProp = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { badgeContent, invisible: invisibleFromHook, max, displayValue: displayValueFromHook } = (0, _useBadge.useBadge)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero
    });
    const prevProps = (0, _utils.usePreviousProps)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color = colorProp, overlap = overlapProp, anchorOrigin = anchorOriginProp, variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        badgeContent,
        invisible,
        max,
        displayValue,
        showZero,
        anchorOrigin,
        color,
        overlap,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, _base.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref,
            as: component
        },
        ownerState,
        className: (0, _clsxDefault.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, _base.useSlotProps)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState,
        className: (0, _clsxDefault.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, (0, _extendsDefault.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BadgeSlot, (0, _extendsDefault.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
exports.default = Badge;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/base/useBadge":"b2ivC","@mui/base":"g25Dc","../zero-styled":"3fCYa","../utils/capitalize":"bIHYz","./badgeClasses":"34eCG","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fCYa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "createUseThemeProps", ()=>createUseThemeProps);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
function createUseThemeProps(name) {
    return 0, _useThemePropsDefault.default;
}

},{"../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"34eCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBadgeUtilityClass", ()=>getBadgeUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getBadgeUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiBadge", slot);
}
const badgeClasses = (0, _generateUtilityClassesDefault.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
exports.default = badgeClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"52i65":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "boxClasses", ()=>(0, _boxClassesDefault.default));
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
parcelHelpers.exportAll(_boxClasses, exports);
"use client";

},{"./Box":"aT7J5","./boxClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aT7J5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _system = require("@mui/system");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _className = require("../className");
var _styles = require("../styles");
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
"use client";
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: (0, _identifierDefault.default),
    defaultTheme,
    defaultClassName: (0, _boxClassesDefault.default).root,
    generateClassName: (0, _className.unstable_ClassNameGenerator).generate
});
exports.default = Box;

},{"@mui/system":"gwZXT","prop-types":"3KNJy","../className":"1IwjJ","../styles":"gNR9m","../styles/identifier":"3AQ3O","./boxClasses":"ds0CH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1IwjJ":[function(require,module,exports) {
// eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _utils.unstable_ClassNameGenerator));
var _utils = require("@mui/utils");

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ds0CH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const boxClasses = (0, _generateUtilityClassesDefault.default)("MuiBox", [
    "root"
]);
exports.default = boxClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6pu9h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "buttonClasses", ()=>(0, _buttonClassesDefault.default));
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
parcelHelpers.exportAll(_buttonClasses, exports);
"use client";

},{"./Button":"9dBBe","./buttonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9dBBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
var _buttonGroupContext = require("../ButtonGroup/ButtonGroupContext");
var _buttonGroupContextDefault = parcelHelpers.interopDefault(_buttonGroupContext);
var _buttonGroupButtonContext = require("../ButtonGroup/ButtonGroupButtonContext");
var _buttonGroupButtonContextDefault = parcelHelpers.interopDefault(_buttonGroupButtonContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { color, disableElevation, fullWidth, size, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, _capitalizeDefault.default)(color)}`,
            `size${(0, _capitalizeDefault.default)(size)}`,
            `${variant}Size${(0, _capitalizeDefault.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _buttonClasses.getButtonUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const commonIconStyles = (ownerState)=>(0, _extendsDefault.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const ButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, _extendsDefault.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, _extendsDefault.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, _extendsDefault.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: (0, _extendsDefault.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: (0, _extendsDefault.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, _system.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const ButtonStartIcon = (0, _styledDefault.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, commonIconStyles(ownerState)));
const ButtonEndIcon = (0, _styledDefault.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/ _react.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = _react.useContext((0, _buttonGroupContextDefault.default));
    const buttonGroupButtonContextPositionClassName = _react.useContext((0, _buttonGroupButtonContextDefault.default));
    const resolvedProps = (0, _utils.internal_resolveProps)(contextProps, inProps);
    const props = (0, _useThemePropsDefault.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children, color = "primary", component = "button", className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, size = "medium", startIcon: startIconProp, type, variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        fullWidth,
        size,
        type,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonRoot, (0, _extendsDefault.default)({
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
exports.default = Button;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../ButtonBase":"ectWz","../utils/capitalize":"bIHYz","./buttonClasses":"aIota","../ButtonGroup/ButtonGroupContext":"1mKyY","../ButtonGroup/ButtonGroupButtonContext":"f2vS3","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aIota":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonUtilityClass", ()=>getButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiButton", slot);
}
const buttonClasses = (0, _generateUtilityClassesDefault.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
exports.default = buttonClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1mKyY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ _react.createContext({});
exports.default = ButtonGroupContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f2vS3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = ButtonGroupButtonContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jMXWA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "checkboxClasses", ()=>(0, _checkboxClassesDefault.default));
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _checkboxClasses = require("./checkboxClasses");
var _checkboxClassesDefault = parcelHelpers.interopDefault(_checkboxClasses);
parcelHelpers.exportAll(_checkboxClasses, exports);
"use client";

},{"./Checkbox":"n7Kk0","./checkboxClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"n7Kk0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _switchBase = require("../internal/SwitchBase");
var _switchBaseDefault = parcelHelpers.interopDefault(_switchBase);
var _checkBoxOutlineBlank = require("../internal/svg-icons/CheckBoxOutlineBlank");
var _checkBoxOutlineBlankDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlank);
var _checkBox = require("../internal/svg-icons/CheckBox");
var _checkBoxDefault = parcelHelpers.interopDefault(_checkBox);
var _indeterminateCheckBox = require("../internal/svg-icons/IndeterminateCheckBox");
var _indeterminateCheckBoxDefault = parcelHelpers.interopDefault(_indeterminateCheckBox);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _checkboxClasses = require("./checkboxClasses");
var _checkboxClassesDefault = parcelHelpers.interopDefault(_checkboxClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, indeterminate, color, size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, _capitalizeDefault.default)(color)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _checkboxClasses.getCheckboxUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const CheckboxRoot = (0, _styledDefault.default)((0, _switchBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, _checkboxClassesDefault.default).checked}, &.${(0, _checkboxClassesDefault.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, _checkboxClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const defaultCheckedIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxDefault.default), {});
const defaultIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxOutlineBlankDefault.default), {});
const defaultIndeterminateIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indeterminateCheckBoxDefault.default), {});
const Checkbox = /*#__PURE__*/ _react.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon = defaultCheckedIcon, color = "primary", icon: iconProp = defaultIcon, indeterminate = false, indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon, inputProps, size = "medium", className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        indeterminate,
        size
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckboxRoot, (0, _extendsDefault.default)({
        type: "checkbox",
        inputProps: (0, _extendsDefault.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ _react.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ _react.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
exports.default = Checkbox;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../internal/SwitchBase":"3rldR","../internal/svg-icons/CheckBoxOutlineBlank":"gMIrk","../internal/svg-icons/CheckBox":"dk7P9","../internal/svg-icons/IndeterminateCheckBox":"eeHS3","../utils/capitalize":"bIHYz","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./checkboxClasses":"cZtVK","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rldR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _switchBaseClasses = require("./switchBaseClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, checked, disabled, edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _switchBaseClasses.getSwitchBaseUtilityClass), classes);
};
const SwitchBaseRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default))(({ ownerState })=>(0, _extendsDefault.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const SwitchBaseInput = (0, _styledDefault.default)("input", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const SwitchBase = /*#__PURE__*/ _react.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus, checked: checkedProp, checkedIcon, className, defaultChecked, disabled: disabledProp, disableFocusRipple = false, edge = false, icon, id, inputProps, inputRef, name, onBlur, onChange, onFocus, readOnly, required = false, tabIndex, type, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [checked, setCheckedState] = (0, _useControlledDefault.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, _useFormControlDefault.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        checked,
        disabled,
        disableFocusRipple,
        edge
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SwitchBaseRoot, (0, _extendsDefault.default)({
        component: "span",
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchBaseInput, (0, _extendsDefault.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
exports.default = SwitchBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../utils/capitalize":"bIHYz","../styles/styled":"jvcDu","../utils/useControlled":"hR7cg","../FormControl/useFormControl":"5VdUX","../ButtonBase":"ectWz","./switchBaseClasses":"lVGrO","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lVGrO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSwitchBaseUtilityClass", ()=>getSwitchBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSwitchBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("PrivateSwitchBase", slot);
}
const switchBaseClasses = (0, _generateUtilityClassesDefault.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
exports.default = switchBaseClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMIrk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dk7P9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eeHS3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cZtVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCheckboxUtilityClass", ()=>getCheckboxUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCheckboxUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCheckbox", slot);
}
const checkboxClasses = (0, _generateUtilityClassesDefault.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
exports.default = checkboxClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fDo20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _circularProgressDefault.default));
parcelHelpers.export(exports, "circularProgressClasses", ()=>(0, _circularProgressClassesDefault.default));
var _circularProgress = require("./CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _circularProgressClasses = require("./circularProgressClasses");
var _circularProgressClassesDefault = parcelHelpers.interopDefault(_circularProgressClasses);
parcelHelpers.exportAll(_circularProgressClasses, exports);
"use client";

},{"./CircularProgress":"6VdsB","./circularProgressClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6VdsB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _circularProgressClasses = require("./circularProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
let _ = (t)=>t, t, t1, t2, t3;
const _excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let _1 = (t)=>t, _t, _t2, _t3, _t4;
const SIZE = 44;
const circularRotateKeyframe = (0, _system.keyframes)(_t || (_t = _1(t || (t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const circularDashKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _1(t1 || (t1 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color, disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, _capitalizeDefault.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, _capitalizeDefault.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _circularProgressClasses.getCircularProgressUtilityClass), classes);
};
const CircularProgressRoot = (0, _styledDefault.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState })=>ownerState.variant === "indeterminate" && (0, _system.css)(_t3 || (_t3 = _1(t2 || (t2 = _`
      animation: ${0} 1.4s linear infinite;
    `), 0)), circularRotateKeyframe));
const CircularProgressSVG = (0, _styledDefault.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const CircularProgressCircle = (0, _styledDefault.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, _system.css)(_t4 || (_t4 = _1(t3 || (t3 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const CircularProgress = /*#__PURE__*/ _react.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className, color = "primary", disableShrink = false, size = 40, style, thickness = 3.6, value = 0, variant = "indeterminate" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disableShrink,
        size,
        thickness,
        value,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        style: (0, _extendsDefault.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: SIZE,
                cy: SIZE,
                r: (SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
exports.default = CircularProgress;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../utils/capitalize":"bIHYz","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./circularProgressClasses":"gsYvV","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsYvV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCircularProgressUtilityClass", ()=>getCircularProgressUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCircularProgressUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCircularProgress", slot);
}
const circularProgressClasses = (0, _generateUtilityClassesDefault.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
exports.default = circularProgressClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eCY2Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cssBaselineDefault.default));
var _cssBaseline = require("./CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
"use client";

},{"./CssBaseline":"ifs25","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ifs25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "body", ()=>body);
parcelHelpers.export(exports, "styles", ()=>styles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const html = (theme, enableColorScheme)=>(0, _extendsDefault.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const body = (theme)=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const styles = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, _extendsDefault.default)({
        html: html(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, _extendsDefault.default)({
            margin: 0
        }, body(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function CssBaseline(inProps) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children, enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
                styles: (theme)=>styles(theme, enableColorScheme)
            }),
            children
        ]
    });
}
exports.default = CssBaseline;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","../styles/useThemeProps":"4dkr8","../GlobalStyles":"j4hem","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cziPe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogDefault.default));
parcelHelpers.export(exports, "dialogClasses", ()=>(0, _dialogClassesDefault.default));
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogClasses = require("./dialogClasses");
var _dialogClassesDefault = parcelHelpers.interopDefault(_dialogClasses);
parcelHelpers.exportAll(_dialogClasses, exports);
"use client";

},{"./Dialog":"f507G","./dialogClasses":"6jAsu","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f507G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/utils");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _fade = require("../Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _dialogClasses = require("./dialogClasses");
var _dialogClassesDefault = parcelHelpers.interopDefault(_dialogClasses);
var _dialogContext = require("./DialogContext");
var _dialogContextDefault = parcelHelpers.interopDefault(_dialogContext);
var _backdrop = require("../Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const DialogBackdrop = (0, _styledDefault.default)((0, _backdropDefault.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const useUtilityClasses = (ownerState)=>{
    const { classes, scroll, maxWidth, fullWidth, fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, _capitalizeDefault.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, _capitalizeDefault.default)(scroll)}`,
            `paperWidth${(0, _capitalizeDefault.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _dialogClasses.getDialogUtilityClass), classes);
};
const DialogRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const DialogContainer = (0, _styledDefault.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, _capitalizeDefault.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const DialogPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, _capitalizeDefault.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, _capitalizeDefault.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const Dialog = /*#__PURE__*/ _react.forwardRef(function Dialog(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, _useThemeDefault.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent, BackdropProps, children, className, disableEscapeKeyDown = false, fullScreen = false, fullWidth = false, maxWidth = "sm", onBackdropClick, onClose, open, PaperComponent = (0, _paperDefault.default), PaperProps = {}, scroll = "paper", TransitionComponent = (0, _fadeDefault.default), transitionDuration = defaultTransitionDuration, TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableEscapeKeyDown,
        fullScreen,
        fullWidth,
        maxWidth,
        scroll
    });
    const classes = useUtilityClasses(ownerState);
    const backdropClick = _react.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, _utils.unstable_useId)(ariaLabelledbyProp);
    const dialogContextValue = _react.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, _extendsDefault.default)({
                transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContainer, {
                className: (0, _clsxDefault.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogPaper, (0, _extendsDefault.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, _clsxDefault.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContextDefault.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
exports.default = Dialog;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/utils":"dv12b","../utils/capitalize":"bIHYz","../Modal":"h0x3u","../Fade":"oyDsU","../Paper":"4qOeF","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./dialogClasses":"6jAsu","./DialogContext":"jzoGi","../Backdrop":"7Jt4t","../styles/useTheme":"6UMPc","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h0x3u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalManager", ()=>(0, _unstableUseModal.ModalManager));
parcelHelpers.export(exports, "default", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "modalClasses", ()=>(0, _modalClassesDefault.default));
var _unstableUseModal = require("@mui/base/unstable_useModal");
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalClasses = require("./modalClasses");
var _modalClassesDefault = parcelHelpers.interopDefault(_modalClasses);
parcelHelpers.exportAll(_modalClasses, exports);
"use client";

},{"@mui/base/unstable_useModal":false,"./Modal":"hFX7X","./modalClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hFX7X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _base = require("@mui/base");
var _unstableUseModal = require("@mui/base/unstable_useModal");
var _composeClasses = require("@mui/base/composeClasses");
var _unstableTrapFocus = require("../Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _portal = require("../Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _backdrop = require("../Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _modalClasses = require("./modalClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const useUtilityClasses = (ownerState)=>{
    const { open, exited, classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _modalClasses.getModalUtilityClass), classes);
};
const ModalRoot = (0, _styledDefault.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const ModalBackdrop = (0, _styledDefault.default)((0, _backdropDefault.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const Modal = /*#__PURE__*/ _react.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent = ModalBackdrop, BackdropProps, className, closeAfterTransition = false, children, container, component, components = {}, componentsProps = {}, disableAutoFocus = false, disableEnforceFocus = false, disableEscapeKeyDown = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onBackdropClick, open, slotProps, slots } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const propsWithDefaults = (0, _extendsDefault.default)({}, props, {
        closeAfterTransition,
        disableAutoFocus,
        disableEnforceFocus,
        disableEscapeKeyDown,
        disablePortal,
        disableRestoreFocus,
        disableScrollLock,
        hideBackdrop,
        keepMounted
    });
    const { getRootProps, getBackdropProps, getTransitionProps, portalRef, isTopModal, exited, hasTransition } = (0, _unstableUseModal.unstable_useModal)((0, _extendsDefault.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, _extendsDefault.default)({}, propsWithDefaults, {
        exited
    });
    const classes = useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter, onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, _base.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref,
            as: component
        },
        ownerState,
        className: (0, _clsxDefault.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, _base.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, _extendsDefault.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, _clsxDefault.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, (0, _extendsDefault.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropSlot, (0, _extendsDefault.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableTrapFocusDefault.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ _react.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
exports.default = Modal;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base":"g25Dc","@mui/base/unstable_useModal":"jhyvS","@mui/base/composeClasses":"icrTb","../Unstable_TrapFocus":"kxC5X","../Portal":"kqRfa","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../Backdrop":"7Jt4t","./modalClasses":"1j9Cc","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kxC5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _focusTrap.FocusTrap));
var _focusTrap = require("@mui/base/FocusTrap");

},{"@mui/base/FocusTrap":"zMuvO","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kqRfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _portal.Portal));
var _portal = require("@mui/base/Portal");

},{"@mui/base/Portal":"lQYHN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1j9Cc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModalUtilityClass", ()=>getModalUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getModalUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiModal", slot);
}
const modalClasses = (0, _generateUtilityClassesDefault.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
exports.default = modalClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6jAsu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogUtilityClass", ()=>getDialogUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDialog", slot);
}
const dialogClasses = (0, _generateUtilityClassesDefault.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
exports.default = dialogClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzoGi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const DialogContext = /*#__PURE__*/ _react.createContext({});
exports.default = DialogContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2DBqh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogActionsDefault.default));
parcelHelpers.export(exports, "dialogActionsClasses", ()=>(0, _dialogActionsClassesDefault.default));
var _dialogActions = require("./DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogActionsClasses = require("./dialogActionsClasses");
var _dialogActionsClassesDefault = parcelHelpers.interopDefault(_dialogActionsClasses);
parcelHelpers.exportAll(_dialogActionsClasses, exports);
"use client";

},{"./DialogActions":"gCWp8","./dialogActionsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCWp8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _dialogActionsClasses = require("./dialogActionsClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "disableSpacing"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _dialogActionsClasses.getDialogActionsUtilityClass), classes);
};
const DialogActionsRoot = (0, _styledDefault.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const DialogActions = /*#__PURE__*/ _react.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className, disableSpacing = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableSpacing
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogActionsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = DialogActions;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./dialogActionsClasses":"dzgVZ","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dzgVZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogActionsUtilityClass", ()=>getDialogActionsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogActionsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDialogActions", slot);
}
const dialogActionsClasses = (0, _generateUtilityClassesDefault.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
exports.default = dialogActionsClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jXMyc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogContentDefault.default));
parcelHelpers.export(exports, "dialogContentClasses", ()=>(0, _dialogContentClassesDefault.default));
var _dialogContent = require("./DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentClasses = require("./dialogContentClasses");
var _dialogContentClassesDefault = parcelHelpers.interopDefault(_dialogContentClasses);
parcelHelpers.exportAll(_dialogContentClasses, exports);
"use client";

},{"./DialogContent":"2zRaL","./dialogContentClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2zRaL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _dialogContentClasses = require("./dialogContentClasses");
var _dialogTitleClasses = require("../DialogTitle/dialogTitleClasses");
var _dialogTitleClassesDefault = parcelHelpers.interopDefault(_dialogTitleClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "dividers"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _dialogContentClasses.getDialogContentUtilityClass), classes);
};
const DialogContentRoot = (0, _styledDefault.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, _dialogTitleClassesDefault.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const DialogContent = /*#__PURE__*/ _react.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className, dividers = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        dividers
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = DialogContent;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./dialogContentClasses":"cNa3Q","../DialogTitle/dialogTitleClasses":"2orRR","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cNa3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogContentUtilityClass", ()=>getDialogContentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogContentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDialogContent", slot);
}
const dialogContentClasses = (0, _generateUtilityClassesDefault.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
exports.default = dialogContentClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2orRR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogTitleUtilityClass", ()=>getDialogTitleUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogTitleUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDialogTitle", slot);
}
const dialogTitleClasses = (0, _generateUtilityClassesDefault.default)("MuiDialogTitle", [
    "root"
]);
exports.default = dialogTitleClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2OJm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogTitleDefault.default));
parcelHelpers.export(exports, "dialogTitleClasses", ()=>(0, _dialogTitleClassesDefault.default));
var _dialogTitle = require("./DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogTitleClasses = require("./dialogTitleClasses");
var _dialogTitleClassesDefault = parcelHelpers.interopDefault(_dialogTitleClasses);
parcelHelpers.exportAll(_dialogTitleClasses, exports);
"use client";

},{"./DialogTitle":"jq6IQ","./dialogTitleClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jq6IQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _dialogTitleClasses = require("./dialogTitleClasses");
var _dialogContext = require("../Dialog/DialogContext");
var _dialogContextDefault = parcelHelpers.interopDefault(_dialogContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "id"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _dialogTitleClasses.getDialogTitleUtilityClass), classes);
};
const DialogTitleRoot = (0, _styledDefault.default)((0, _typographyDefault.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const DialogTitle = /*#__PURE__*/ _react.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className, id: idProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const { titleId = idProp } = _react.useContext((0, _dialogContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogTitleRoot, (0, _extendsDefault.default)({
        component: "h2",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
exports.default = DialogTitle;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../Typography":"1Chqm","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./dialogTitleClasses":"2orRR","../Dialog/DialogContext":"jzoGi","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Chqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "typographyClasses", ()=>(0, _typographyClassesDefault.default));
var _typography = require("./Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _typographyClasses = require("./typographyClasses");
var _typographyClassesDefault = parcelHelpers.interopDefault(_typographyClasses);
parcelHelpers.exportAll(_typographyClasses, exports);
"use client";

},{"./Typography":"53ZMo","./typographyClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"53ZMo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypographyRoot", ()=>TypographyRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typographyClasses = require("./typographyClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const useUtilityClasses = (ownerState)=>{
    const { align, gutterBottom, noWrap, paragraph, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, _capitalizeDefault.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _typographyClasses.getTypographyUtilityClass), classes);
};
const TypographyRoot = (0, _styledDefault.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const transformDeprecatedColors = (color)=>{
    return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/ _react.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = transformDeprecatedColors(themeProps.color);
    const props = (0, _system.unstable_extendSxProp)((0, _extendsDefault.default)({}, themeProps, {
        color
    }));
    const { align = "inherit", className, component, gutterBottom = false, noWrap = false, paragraph = false, variant = "body1", variantMapping = defaultVariantMapping } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        color,
        className,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographyRoot, (0, _extendsDefault.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other));
});
exports.default = Typography;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/system":"gwZXT","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","./typographyClasses":"fvz36","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fvz36":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypographyUtilityClass", ()=>getTypographyUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTypographyUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTypography", slot);
}
const typographyClasses = (0, _generateUtilityClassesDefault.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
exports.default = typographyClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Yn32":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "dividerClasses", ()=>(0, _dividerClassesDefault.default));
var _divider = require("./Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _dividerClasses = require("./dividerClasses");
var _dividerClassesDefault = parcelHelpers.interopDefault(_dividerClasses);
parcelHelpers.exportAll(_dividerClasses, exports);
"use client";

},{"./Divider":"3H01e","./dividerClasses":"i7aaH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3H01e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _dividerClasses = require("./dividerClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { absolute, children, classes, flexItem, light, orientation, textAlign, variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _dividerClasses.getDividerUtilityClass), classes);
};
const DividerRoot = (0, _styledDefault.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _system.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const DividerWrapper = (0, _styledDefault.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const Divider = /*#__PURE__*/ _react.forwardRef(function Divider(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute = false, children, className, component = children ? "div" : "hr", flexItem = false, light = false, orientation = "horizontal", role = component !== "hr" ? "separator" : undefined, textAlign = "center", variant = "fullWidth" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        absolute,
        component,
        flexItem,
        light,
        orientation,
        role,
        textAlign,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ Divider.muiSkipListHighlight = true;
exports.default = Divider;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./dividerClasses":"i7aaH","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i7aaH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDividerUtilityClass", ()=>getDividerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDividerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDivider", slot);
}
const dividerClasses = (0, _generateUtilityClassesDefault.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
exports.default = dividerClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kfkBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _drawerDefault.default));
parcelHelpers.export(exports, "drawerClasses", ()=>(0, _drawerClassesDefault.default));
var _drawer = require("./Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _drawerClasses = require("./drawerClasses");
var _drawerClassesDefault = parcelHelpers.interopDefault(_drawerClasses);
parcelHelpers.exportAll(_drawerClasses, exports);
"use client";

},{"./Drawer":"ayoPM","./drawerClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ayoPM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHorizontal", ()=>isHorizontal);
parcelHelpers.export(exports, "getAnchor", ()=>getAnchor);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _slide = require("../Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _drawerClasses = require("./drawerClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "BackdropProps"
], _excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, anchor, variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, _capitalizeDefault.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, _capitalizeDefault.default)(anchor)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _drawerClasses.getDrawerUtilityClass), classes);
};
const DrawerRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver
})(({ theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const DrawerDockedRoot = (0, _styledDefault.default)("div", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver
})({
    flex: "0 0 auto"
});
const DrawerPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, _capitalizeDefault.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, _capitalizeDefault.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function isHorizontal(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
    return theme.direction === "rtl" && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const Drawer = /*#__PURE__*/ _react.forwardRef(function Drawer(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, _useThemeDefault.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps, children, className, elevation = 16, hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose, open = false, PaperProps = {}, SlideProps, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _slideDefault.default), transitionDuration = defaultTransitionDuration, variant = "temporary" } = props, ModalProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.ModalProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = _react.useRef(false);
    _react.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = getAnchor(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchor,
        elevation,
        open,
        variant
    }, other);
    const classes = useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerPaper, (0, _extendsDefault.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, _clsxDefault.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerDockedRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: open,
        direction: oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerDockedRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerRoot, (0, _extendsDefault.default)({
        BackdropProps: (0, _extendsDefault.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration
        }),
        className: (0, _clsxDefault.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
exports.default = Drawer;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../Modal":"h0x3u","../Slide":"cZeM6","../Paper":"4qOeF","../utils/capitalize":"bIHYz","../styles/useTheme":"6UMPc","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./drawerClasses":"jv5cC","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jv5cC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDrawerUtilityClass", ()=>getDrawerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDrawerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDrawer", slot);
}
const drawerClasses = (0, _generateUtilityClassesDefault.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
exports.default = drawerClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"frONn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _filledInputDefault.default));
parcelHelpers.export(exports, "filledInputClasses", ()=>(0, _filledInputClassesDefault.default));
var _filledInput = require("./FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
parcelHelpers.exportAll(_filledInputClasses, exports);
"use client";

},{"./FilledInput":"agxaC","./filledInputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"agxaC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/base/composeClasses");
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _filledInputClasses.getFilledInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const FilledInputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, _extendsDefault.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, _filledInputClassesDefault.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _filledInputClassesDefault.default).disabled}, .${(0, _filledInputClassesDefault.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const FilledInputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const FilledInput = /*#__PURE__*/ _react.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components = {}, componentsProps: componentsPropsProp, fullWidth = false, // declare here to prevent spreading to DOM
    inputComponent = "input", multiline = false, slotProps, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        fullWidth,
        inputComponent,
        multiline,
        type
    });
    const classes = useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState
        },
        input: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _utils.deepmerge)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
FilledInput.muiName = "Input";
exports.default = FilledInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","prop-types":"3KNJy","@mui/base/composeClasses":"icrTb","../InputBase":"9Zug6","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./filledInputClasses":"8Iw8v","../InputBase/InputBase":"ca0Zd","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6EcMm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "useFormControl", ()=>(0, _useFormControlDefault.default));
parcelHelpers.export(exports, "formControlClasses", ()=>(0, _formControlClassesDefault.default));
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _useFormControl = require("./useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlClasses = require("./formControlClasses");
var _formControlClassesDefault = parcelHelpers.interopDefault(_formControlClasses);
parcelHelpers.exportAll(_formControlClasses, exports);
"use client";

},{"./FormControl":"2jYQG","./useFormControl":"5VdUX","./formControlClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2jYQG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _utils = require("../InputBase/utils");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _formControlClasses = require("./formControlClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, margin, fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, _capitalizeDefault.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _formControlClasses.getFormControlUtilityClasses), classes);
};
const FormControlRoot = (0, _styledDefault.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, styles[`margin${(0, _capitalizeDefault.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const FormControl = /*#__PURE__*/ _react.forwardRef(function FormControl(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children, className, color = "primary", component = "div", disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = "none", required = false, size = "medium", variant = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        error,
        fullWidth,
        hiddenLabel,
        margin,
        required,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, _isMuiElementDefault.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, _utils.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, _utils.isFilled)(child.props, true) || (0, _utils.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = _react.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = _react.useMemo(()=>{
        return {
            adornedStart,
            setAdornedStart,
            color,
            disabled,
            error,
            filled,
            focused,
            fullWidth,
            hiddenLabel,
            size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect,
            required,
            variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormControlRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
exports.default = FormControl;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","../InputBase/utils":"lkbBD","../utils/capitalize":"bIHYz","../utils/isMuiElement":"h0Lfr","./FormControlContext":"aLC94","./formControlClasses":"k7uip","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k7uip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormControlUtilityClasses", ()=>getFormControlUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormControlUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormControl", slot);
}
const formControlClasses = (0, _generateUtilityClassesDefault.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
exports.default = formControlClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c21sM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formControlLabelDefault.default));
parcelHelpers.export(exports, "formControlLabelClasses", ()=>(0, _formControlLabelClassesDefault.default));
var _formControlLabel = require("./FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formControlLabelClasses = require("./formControlLabelClasses");
var _formControlLabelClassesDefault = parcelHelpers.interopDefault(_formControlLabelClasses);
parcelHelpers.exportAll(_formControlLabelClasses, exports);
"use client";

},{"./FormControlLabel":"28E4p","./formControlLabelClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28E4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormControlLabelRoot", ()=>FormControlLabelRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _formControl = require("../FormControl");
var _stack = require("../Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _formControlLabelClasses = require("./formControlLabelClasses");
var _formControlLabelClassesDefault = parcelHelpers.interopDefault(_formControlLabelClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, labelPlacement, error, required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, _capitalizeDefault.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _formControlLabelClasses.getFormControlLabelUtilityClasses), classes);
};
const FormControlLabelRoot = (0, _styledDefault.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _formControlLabelClassesDefault.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, _capitalizeDefault.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, _formControlLabelClassesDefault.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, _formControlLabelClassesDefault.default).label}`]: {
            [`&.${(0, _formControlLabelClassesDefault.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const AsteriskComponent = (0, _styledDefault.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme })=>({
        [`&.${(0, _formControlLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const FormControlLabel = /*#__PURE__*/ _react.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className, componentsProps = {}, control, disabled: disabledProp, disableTypography, label: labelProp, labelPlacement = "end", required: requiredProp, slotProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _formControl.useFormControl)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled,
        required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        labelPlacement,
        required,
        error: fcs.error
    });
    const classes = useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, _typographyDefault.default) && !disableTypography) label = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, _clsxDefault.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormControlLabelRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ _react.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
exports.default = FormControlLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../FormControl":"6EcMm","../Stack":"leqLk","../Typography":"1Chqm","../utils/capitalize":"bIHYz","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./formControlLabelClasses":"dQHp3","../FormControl/formControlState":"89R3A","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"leqLk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "stackClasses", ()=>(0, _stackClassesDefault.default));
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stackClasses = require("./stackClasses");
var _stackClassesDefault = parcelHelpers.interopDefault(_stackClasses);
"use client";

},{"./Stack":"9nD0J","./stackClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9nD0J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
"use client";
const Stack = (0, _system.createStack)({
    createStyledComponent: (0, _styledDefault.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, _useThemePropsDefault.default)({
            props: inProps,
            name: "MuiStack"
        })
});
exports.default = Stack;

},{"prop-types":"3KNJy","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dQHp3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormControlLabelUtilityClasses", ()=>getFormControlLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormControlLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormControlLabel", slot);
}
const formControlLabelClasses = (0, _generateUtilityClassesDefault.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
exports.default = formControlLabelClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"FdSIA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formHelperTextDefault.default));
parcelHelpers.export(exports, "formHelperTextClasses", ()=>(0, _formHelperTextClassesDefault.default));
var _formHelperText = require("./FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
parcelHelpers.exportAll(_formHelperTextClasses, exports);
"use client";

},{"./FormHelperText":"kftgH","./formHelperTextClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kftgH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, _capitalizeDefault.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _formHelperTextClasses.getFormHelperTextUtilityClasses), classes);
};
const FormHelperTextRoot = (0, _styledDefault.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, _formHelperTextClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formHelperTextClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const FormHelperText = /*#__PURE__*/ _react.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children, className, component = "p" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
exports.default = FormHelperText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../FormControl/formControlState":"89R3A","../FormControl/useFormControl":"5VdUX","../styles/styled":"jvcDu","../utils/capitalize":"bIHYz","./formHelperTextClasses":"5YTGY","../styles/useThemeProps":"4dkr8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5YTGY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormHelperTextUtilityClasses", ()=>getFormHelperTextUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormHelperTextUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormHelperText", slot);
}
const formHelperTextClasses = (0, _generateUtilityClassesDefault.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
exports.default = formHelperTextClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iFsjp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "formLabelClasses", ()=>(0, _formLabelClassesDefault.default));
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
parcelHelpers.exportAll(_formLabel, exports);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
parcelHelpers.exportAll(_formLabelClasses, exports);
"use client";

},{"./FormLabel":"77r8x","./formLabelClasses":"4EYzT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"77r8x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormLabelRoot", ()=>FormLabelRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, color, focused, disabled, error, filled, required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _formLabelClasses.getFormLabelUtilityClasses), classes);
};
const FormLabelRoot = (0, _styledDefault.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, _formLabelClassesDefault.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, _formLabelClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const AsteriskComponent = (0, _styledDefault.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme })=>({
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const FormLabel = /*#__PURE__*/ _react.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children, className, component = "label" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormLabelRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
exports.default = FormLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../FormControl/formControlState":"89R3A","../FormControl/useFormControl":"5VdUX","../utils/capitalize":"bIHYz","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./formLabelClasses":"4EYzT","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4EYzT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormLabelUtilityClasses", ()=>getFormLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormLabel", slot);
}
const formLabelClasses = (0, _generateUtilityClassesDefault.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
exports.default = formLabelClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j00I5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "gridClasses", ()=>(0, _gridClassesDefault.default));
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
parcelHelpers.exportAll(_gridClasses, exports);
"use client";

},{"./Grid":"iuFYC","./gridClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iuFYC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateGrid", ()=>generateGrid);
parcelHelpers.export(exports, "generateDirection", ()=>generateDirection);
parcelHelpers.export(exports, "generateRowGap", ()=>generateRowGap);
parcelHelpers.export(exports, "generateColumnGap", ()=>generateColumnGap);
parcelHelpers.export(exports, "resolveSpacingStyles", ()=>resolveSpacingStyles);
parcelHelpers.export(exports, "resolveSpacingClasses", ()=>resolveSpacingClasses);
// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _composeClasses = require("@mui/base/composeClasses");
var _requirePropFactory = require("../utils/requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _gridContext = require("./GridContext");
var _gridContextDefault = parcelHelpers.interopDefault(_gridContext);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function generateGrid({ theme, ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, _system.unstable_resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, _extendsDefault.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function generateDirection({ theme, ownerState }) {
    const directionValues = (0, _system.unstable_resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, _system.handleBreakpoints)({
        theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, _gridClassesDefault.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function extractZeroValueBreakpointKeys({ breakpoints, values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function generateRowGap({ theme, ownerState }) {
    const { container, rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function generateColumnGap({ theme, ownerState }) {
    const { container, columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${getOffset(themeSpacing)})`,
                marginLeft: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function resolveSpacingStyles(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const GridRoot = (0, _styledDefault.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = resolveSpacingStyles(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), generateDirection, generateRowGap, generateColumnGap, generateGrid);
function resolveSpacingClasses(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = resolveSpacingClasses(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _gridClasses.getGridUtilityClass), classes);
};
const Grid = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints } = (0, _useThemeDefault.default)();
    const props = (0, _system.unstable_extendSxProp)(themeProps);
    const { className, columns: columnsProp, columnSpacing: columnSpacingProp, component = "div", container = false, direction = "row", item = false, rowSpacing: rowSpacingProp, spacing = 0, wrap = "wrap", zeroMinWidth = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = _react.useContext((0, _gridContextDefault.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, _extendsDefault.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        columns,
        container,
        direction,
        item,
        rowSpacing,
        columnSpacing,
        wrap,
        zeroMinWidth,
        spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridContextDefault.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, (0, _extendsDefault.default)({
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
exports.default = Grid;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/system":"gwZXT","@mui/base/composeClasses":"icrTb","../utils/requirePropFactory":"kdjkX","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../styles/useTheme":"6UMPc","./GridContext":"9ij7H","./gridClasses":"gxbzD","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ij7H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const GridContext = /*#__PURE__*/ _react.createContext();
exports.default = GridContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gxbzD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridUtilityClass", ()=>getGridUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiGrid", slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClassesDefault.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
exports.default = gridClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eBM9D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _growDefault.default));
var _grow = require("./Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
"use client";

},{"./Grow":"jUJfh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jUJfh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _reactTransitionGroup = require("react-transition-group");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils1 = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Grow = /*#__PURE__*/ _react.forwardRef(function Grow(props, ref) {
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = "auto", // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const timer = (0, _utils.unstable_useTimeout)();
    const autoTimeout = _react.useRef();
    const theme = (0, _useThemeDefault.default)();
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils1.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration,
                delay
            }),
            theme.transitions.create("transform", {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils1.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration,
                delay
            }),
            theme.transitions.create("transform", {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    transform: getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
Grow.muiSupportAuto = true;
exports.default = Grow;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","react-transition-group":"5ABiG","../styles/useTheme":"6UMPc","../transitions/utils":"1qrTM","../utils/useForkRef":"kWp3j","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bEBUE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "inputClasses", ()=>(0, _inputClassesDefault.default));
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
parcelHelpers.exportAll(_inputClasses, exports);
"use client";

},{"./Input":"8nxtI","./inputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8nxtI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/utils");
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _inputClasses.getInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, _extendsDefault.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, _inputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, _inputClassesDefault.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _inputClassesDefault.default).disabled}, .${(0, _inputClassesDefault.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, _inputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const InputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})({});
const Input = /*#__PURE__*/ _react.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline, components = {}, componentsProps: componentsPropsProp, fullWidth = false, inputComponent = "input", multiline = false, slotProps, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const ownerState = {
        disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _utils.deepmerge)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
Input.muiName = "Input";
exports.default = Input;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/base/composeClasses":"icrTb","@mui/utils":"dv12b","../InputBase":"9Zug6","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./inputClasses":"aVvbK","../InputBase/InputBase":"ca0Zd","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"400VR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputAdornmentDefault.default));
parcelHelpers.export(exports, "inputAdornmentClasses", ()=>(0, _inputAdornmentClassesDefault.default));
var _inputAdornment = require("./InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
parcelHelpers.exportAll(_inputAdornmentClasses, exports);
"use client";

},{"./InputAdornment":"9WzPK","./inputAdornmentClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9WzPK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, _capitalizeDefault.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _inputAdornmentClasses.getInputAdornmentUtilityClass), classes);
};
const InputAdornmentRoot = (0, _styledDefault.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, _inputAdornmentClassesDefault.default).positionStart}&:not(.${(0, _inputAdornmentClassesDefault.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const InputAdornment = /*#__PURE__*/ _react.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children, className, component = "div", disablePointerEvents = false, disableTypography = false, position, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents,
        position,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornmentRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
exports.default = InputAdornment;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../utils/capitalize":"bIHYz","../Typography":"1Chqm","../FormControl/FormControlContext":"aLC94","../FormControl/useFormControl":"5VdUX","../styles/styled":"jvcDu","./inputAdornmentClasses":"4u0ma","../styles/useThemeProps":"4dkr8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4u0ma":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputAdornmentUtilityClass", ()=>getInputAdornmentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputAdornmentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputAdornment", slot);
}
const inputAdornmentClasses = (0, _generateUtilityClassesDefault.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
exports.default = inputAdornmentClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i0KlN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputLabelDefault.default));
parcelHelpers.export(exports, "inputLabelClasses", ()=>(0, _inputLabelClassesDefault.default));
var _inputLabel = require("./InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _inputLabelClasses = require("./inputLabelClasses");
var _inputLabelClassesDefault = parcelHelpers.interopDefault(_inputLabelClasses);
parcelHelpers.exportAll(_inputLabelClasses, exports);
"use client";

},{"./InputLabel":"cWRCz","./inputLabelClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cWRCz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/base/composeClasses");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formLabel = require("../FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputLabelClasses = require("./inputLabelClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, formControl, size, shrink, disableAnimation, variant, required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, _capitalizeDefault.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _inputLabelClasses.getInputLabelUtilityClasses), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputLabelRoot = (0, _styledDefault.default)((0, _formLabelDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _formLabel.formLabelClasses).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, _extendsDefault.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, _extendsDefault.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, _extendsDefault.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const InputLabel = /*#__PURE__*/ _react.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation = false, shrink: shrinkProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableAnimation,
        formControl: muiFormControl,
        shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelRoot, (0, _extendsDefault.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
exports.default = InputLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/base/composeClasses":"icrTb","clsx":"aGWRz","../FormControl/formControlState":"89R3A","../FormControl/useFormControl":"5VdUX","../FormLabel":"iFsjp","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","../styles/styled":"jvcDu","./inputLabelClasses":"jAD30","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jAD30":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputLabelUtilityClasses", ()=>getInputLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputLabel", slot);
}
const inputLabelClasses = (0, _generateUtilityClassesDefault.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
exports.default = inputLabelClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"903dI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _linearProgressDefault.default));
parcelHelpers.export(exports, "linearProgressClasses", ()=>(0, _linearProgressClassesDefault.default));
var _linearProgress = require("./LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _linearProgressClasses = require("./linearProgressClasses");
var _linearProgressClassesDefault = parcelHelpers.interopDefault(_linearProgressClasses);
parcelHelpers.exportAll(_linearProgressClasses, exports);
"use client";

},{"./LinearProgress":"lG6fm","./linearProgressClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lG6fm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _linearProgressClasses = require("./linearProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
let _ = (t)=>t, t, t1, t2, t3, t4, t5;
const _excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let _1 = (t)=>t, _t, _t2, _t3, _t4, _t5, _t6;
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _system.keyframes)(_t || (_t = _1(t || (t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`))));
const indeterminate2Keyframe = (0, _system.keyframes)(_t2 || (_t2 = _1(t1 || (t1 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`))));
const bufferKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _1(t2 || (t2 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`))));
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, _capitalizeDefault.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, _capitalizeDefault.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, _capitalizeDefault.default)(color)}`,
            variant === "buffer" && `color${(0, _capitalizeDefault.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _linearProgressClasses.getLinearProgressUtilityClass), classes);
};
const getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, _system.lighten)(theme.palette[color].main, 0.62) : (0, _system.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const LinearProgressDashed = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState, theme })=>{
    const backgroundColor = getColorShade(theme, ownerState.color);
    return (0, _extendsDefault.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, _system.css)(_t4 || (_t4 = _1(t3 || (t3 = _`
    animation: ${0} 3s infinite linear;
  `), 0)), bufferKeyframe));
const LinearProgressBar1 = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, _system.css)(_t5 || (_t5 = _1(t4 || (t4 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), 0)), indeterminate1Keyframe));
const LinearProgressBar2 = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: getColorShade(theme, ownerState.color),
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, _system.css)(_t6 || (_t6 = _1(t5 || (t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), 0)), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const LinearProgress = /*#__PURE__*/ _react.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className, color = "primary", value, valueBuffer, variant = "indeterminate" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _useThemeDefault.default)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LinearProgressRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
exports.default = LinearProgress;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../utils/capitalize":"bIHYz","../styles/useTheme":"6UMPc","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./linearProgressClasses":"21xQu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"21xQu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLinearProgressUtilityClass", ()=>getLinearProgressUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getLinearProgressUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiLinearProgress", slot);
}
const linearProgressClasses = (0, _generateUtilityClassesDefault.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
exports.default = linearProgressClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ighTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "listClasses", ()=>(0, _listClassesDefault.default));
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listClasses = require("./listClasses");
var _listClassesDefault = parcelHelpers.interopDefault(_listClasses);
parcelHelpers.exportAll(_listClasses, exports);
"use client";

},{"./List":"jNVyL","./listClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNVyL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listClasses = require("./listClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePadding, dense, subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _listClasses.getListUtilityClass), classes);
};
const ListRoot = (0, _styledDefault.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const List = /*#__PURE__*/ _react.forwardRef(function List(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children, className, component = "ul", dense = false, disablePadding = false, subheader } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useMemo(()=>({
            dense
        }), [
        dense
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        dense,
        disablePadding
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListRoot, (0, _extendsDefault.default)({
            as: component,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
exports.default = List;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./ListContext":"ARZc0","./listClasses":"kRJaP","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ARZc0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const ListContext = /*#__PURE__*/ _react.createContext({});
exports.default = ListContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kRJaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListUtilityClass", ()=>getListUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiList", slot);
}
const listClasses = (0, _generateUtilityClassesDefault.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
exports.default = listClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9curq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "listItemClasses", ()=>(0, _listItemClassesDefault.default));
var _listItem = require("./ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
parcelHelpers.exportAll(_listItemClasses, exports);
"use client";

},{"./ListItem":"ffRZt","./listItemClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ffRZt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
parcelHelpers.export(exports, "ListItemRoot", ()=>ListItemRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _base = require("@mui/base");
var _utils = require("@mui/utils");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
var _listItemButton = require("../ListItemButton");
var _listItemSecondaryAction = require("../ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
], _excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { alignItems, button, classes, dense, disabled, disableGutters, disablePadding, divider, hasSecondaryAction, selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _listItemClasses.getListItemUtilityClass), classes);
};
const ListItemRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, _extendsDefault.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, _listItemButton.listItemButtonClasses).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _listItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _listItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _listItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const ListItemContainer = (0, _styledDefault.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const ListItem = /*#__PURE__*/ _react.forwardRef(function ListItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems = "center", autoFocus = false, button = false, children: childrenProp, className, component: componentProp, components = {}, componentsProps = {}, ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense = false, disabled = false, disableGutters = false, disablePadding = false, divider = false, focusVisibleClassName, secondaryAction, selected = false, slotProps = {}, slots = {} } = props, ContainerProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.ContainerProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = _react.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, _isMuiElementDefault.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems,
        autoFocus,
        button,
        dense: childContext.dense,
        disabled,
        disableGutters,
        disablePadding,
        divider,
        hasSecondaryAction,
        selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRefDefault.default)(listItemRef, ref);
    const Root = slots.root || components.Root || ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, rootProps.className, className),
        disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, _clsxDefault.default)((0, _listItemClassesDefault.default).focusVisible, focusVisibleClassName);
        Component = (0, _buttonBaseDefault.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemContainer, (0, _extendsDefault.default)({
                as: ContainerComponent,
                className: (0, _clsxDefault.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _base.isHostComponent)(Root) && {
                        as: Component,
                        ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, _base.isHostComponent)(Root) && {
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemSecondaryActionDefault.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
exports.default = ListItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base":"g25Dc","@mui/utils":"dv12b","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../ButtonBase":"ectWz","../utils/isMuiElement":"h0Lfr","../utils/useEnhancedEffect":"1Zm5y","../utils/useForkRef":"kWp3j","../List/ListContext":"ARZc0","./listItemClasses":"bOfMz","../ListItemButton":"6ZWii","../ListItemSecondaryAction":"9Or2r","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bOfMz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemUtilityClass", ()=>getListItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItem", slot);
}
const listItemClasses = (0, _generateUtilityClassesDefault.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
exports.default = listItemClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6ZWii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemButtonDefault.default));
parcelHelpers.export(exports, "listItemButtonClasses", ()=>(0, _listItemButtonClassesDefault.default));
var _listItemButton = require("./ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
var _listItemButtonClasses = require("./listItemButtonClasses");
var _listItemButtonClassesDefault = parcelHelpers.interopDefault(_listItemButtonClasses);
parcelHelpers.exportAll(_listItemButtonClasses, exports);
"use client";

},{"./ListItemButton":"kpqqb","./listItemButtonClasses":"iBpS2","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kpqqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemButtonClasses = require("./listItemButtonClasses");
var _listItemButtonClassesDefault = parcelHelpers.interopDefault(_listItemButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes, dense, disabled, disableGutters, divider, selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _listItemButtonClasses.getListItemButtonUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const ListItemButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _listItemButtonClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _listItemButtonClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _listItemButtonClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, _listItemButtonClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _listItemButtonClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const ListItemButton = /*#__PURE__*/ _react.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems = "center", autoFocus = false, component = "div", children, dense = false, disableGutters = false, divider = false, focusVisibleClassName, selected = false, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems,
        dense: childContext.dense,
        disableGutters,
        divider,
        selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRefDefault.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemButtonRoot, (0, _extendsDefault.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
exports.default = ListItemButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../ButtonBase":"ectWz","../utils/useEnhancedEffect":"1Zm5y","../utils/useForkRef":"kWp3j","../List/ListContext":"ARZc0","./listItemButtonClasses":"iBpS2","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBpS2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemButtonUtilityClass", ()=>getListItemButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemButton", slot);
}
const listItemButtonClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
exports.default = listItemButtonClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Or2r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemSecondaryActionDefault.default));
parcelHelpers.export(exports, "listItemSecondaryActionClasses", ()=>(0, _listItemSecondaryActionClassesDefault.default));
var _listItemSecondaryAction = require("./ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _listItemSecondaryActionClassesDefault = parcelHelpers.interopDefault(_listItemSecondaryActionClasses);
parcelHelpers.exportAll(_listItemSecondaryActionClasses, exports);
"use client";

},{"./ListItemSecondaryAction":"94Dsq","./listItemSecondaryActionClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"94Dsq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { disableGutters, classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass), classes);
};
const ListItemSecondaryActionRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const ListItemSecondaryAction = /*#__PURE__*/ _react.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
exports.default = ListItemSecondaryAction;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../List/ListContext":"ARZc0","./listItemSecondaryActionClasses":"1DI26","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1DI26":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemSecondaryActionClassesUtilityClass", ()=>getListItemSecondaryActionClassesUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemSecondaryAction", slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
exports.default = listItemSecondaryActionClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ebq0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemIconDefault.default));
parcelHelpers.export(exports, "listItemIconClasses", ()=>(0, _listItemIconClassesDefault.default));
var _listItemIcon = require("./ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemIconClasses = require("./listItemIconClasses");
var _listItemIconClassesDefault = parcelHelpers.interopDefault(_listItemIconClasses);
parcelHelpers.exportAll(_listItemIconClasses, exports);
"use client";

},{"./ListItemIcon":"7xEW3","./listItemIconClasses":"5hWF1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7xEW3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listItemIconClasses = require("./listItemIconClasses");
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _listItemIconClasses.getListItemIconUtilityClass), classes);
};
const ListItemIconRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const ListItemIcon = /*#__PURE__*/ _react.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemIconRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = ListItemIcon;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./listItemIconClasses":"5hWF1","../List/ListContext":"ARZc0","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5hWF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemIconUtilityClass", ()=>getListItemIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemIcon", slot);
}
const listItemIconClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
exports.default = listItemIconClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7MfZJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemTextDefault.default));
parcelHelpers.export(exports, "listItemTextClasses", ()=>(0, _listItemTextClassesDefault.default));
var _listItemText = require("./ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
parcelHelpers.exportAll(_listItemTextClasses, exports);
"use client";

},{"./ListItemText":"9abpm","./listItemTextClasses":"jq99B","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9abpm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _listItemTextClasses.getListItemTextUtilityClass), classes);
};
const ListItemTextRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _listItemTextClassesDefault.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, _listItemTextClassesDefault.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const ListItemText = /*#__PURE__*/ _react.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { dense } = _react.useContext((0, _listContextDefault.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    });
    const classes = useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, _typographyDefault.default) && !disableTypography) primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, _typographyDefault.default) && !disableTypography) secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemTextRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
exports.default = ListItemText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../Typography":"1Chqm","../List/ListContext":"ARZc0","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./listItemTextClasses":"jq99B","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jq99B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemTextUtilityClass", ()=>getListItemTextUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemTextUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemText", slot);
}
const listItemTextClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
exports.default = listItemTextClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hx0ew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "menuClasses", ()=>(0, _menuClassesDefault.default));
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuClasses = require("./menuClasses");
var _menuClassesDefault = parcelHelpers.interopDefault(_menuClasses);
parcelHelpers.exportAll(_menuClasses, exports);
"use client";

},{"./Menu":"lB8aZ","./menuClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lB8aZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPaper", ()=>MenuPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/base/utils");
var _utils1 = require("@mui/utils");
var _menuList = require("../MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _popover = require("../Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _menuClasses = require("./menuClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onEntering"
], _excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _menuClasses.getMenuUtilityClass), classes);
};
const MenuRoot = (0, _styledDefault.default)((0, _popoverDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const MenuPaper = (0, _styledDefault.default)((0, _popover.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const MenuMenuList = (0, _styledDefault.default)((0, _menuListDefault.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Menu = /*#__PURE__*/ _react.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus = true, children, className, disableAutoFocusItem = false, MenuListProps = {}, onClose, open, PaperProps = {}, PopoverClasses, transitionDuration = "auto", TransitionProps: { onEntering } = {}, variant = "selectedMenu", slots = {}, slotProps = {} } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const theme = (0, _useThemeDefault.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        disableAutoFocusItem,
        MenuListProps,
        onEntering,
        PaperProps,
        transitionDuration,
        TransitionProps,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = _react.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, _utils.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, _utils.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, (0, _extendsDefault.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, _extendsDefault.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuMenuList, (0, _extendsDefault.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, _clsxDefault.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
exports.default = Menu;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","react-is":"3fr5l","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/base/utils":"17Cv3","@mui/utils":"dv12b","../MenuList":"503OT","../Popover":"7HhsT","../styles/styled":"jvcDu","../styles/useTheme":"6UMPc","../styles/useThemeProps":"4dkr8","./menuClasses":"1WBdK","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"503OT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuListDefault.default));
var _menuList = require("./MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
"use client";

},{"./MenuList":"f2MVB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f2MVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _list = require("../List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _getScrollbarSize = require("../utils/getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const MenuList = /*#__PURE__*/ _react.forwardRef(function MenuList(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus = false, autoFocusItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = "selectedMenu" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const listRef = _react.useRef(null);
    const textCriteriaRef = _react.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, _getScrollbarSizeDefault.default)((0, _ownerDocumentDefault.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, _ownerDocumentDefault.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === "End") {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, _useForkRefDefault.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = _react.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ _react.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), (0, _extendsDefault.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
exports.default = MenuList;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","react-is":"3fr5l","prop-types":"3KNJy","../utils/ownerDocument":"2wE6J","../List":"ighTd","../utils/getScrollbarSize":"5ISO4","../utils/useForkRef":"kWp3j","../utils/useEnhancedEffect":"1Zm5y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ISO4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@mui/utils");
exports.default = (0, _utils.unstable_getScrollbarSize);

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7HhsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "popoverClasses", ()=>(0, _popoverClassesDefault.default));
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
parcelHelpers.exportAll(_popover, exports);
var _popoverClasses = require("./popoverClasses");
var _popoverClassesDefault = parcelHelpers.interopDefault(_popoverClasses);
parcelHelpers.exportAll(_popoverClasses, exports);
"use client";

},{"./Popover":"ch9vN","./popoverClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ch9vN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffsetTop", ()=>getOffsetTop);
parcelHelpers.export(exports, "getOffsetLeft", ()=>getOffsetLeft);
parcelHelpers.export(exports, "PopoverRoot", ()=>PopoverRoot);
parcelHelpers.export(exports, "PopoverPaper", ()=>PopoverPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _base = require("@mui/base");
var _utils = require("@mui/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("../utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popoverClasses = require("./popoverClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onEntering"
], _excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], _excluded3 = [
    "slotProps"
];
function getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _popoverClasses.getPopoverUtilityClass), classes);
};
const PopoverRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const PopoverPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Popover = /*#__PURE__*/ _react.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action, anchorEl, anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition, anchorReference = "anchorEl", children, className, container: containerProp, elevation = 8, marginThreshold = 16, open, PaperProps: PaperPropsProp = {}, slots, slotProps, transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent = (0, _growDefault.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering } = {}, disableScrollLock = false } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = _react.useRef();
    const handlePaperRef = (0, _useForkRefDefault.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchorOrigin,
        anchorReference,
        elevation,
        marginThreshold,
        externalPaperSlotProps,
        transformOrigin,
        TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps
    });
    const classes = useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = _react.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocumentDefault.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = _react.useCallback((elemRect)=>{
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = _react.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, _ownerWindowDefault.default)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = _react.useState(open);
    const setPositioningStyles = _react.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    _react.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    _react.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    _react.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    _react.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, _debounceDefault.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, _ownerWindowDefault.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, _ownerDocumentDefault.default)(resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
    const paperProps = (0, _base.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, _extendsDefault.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, _extendsDefault.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation,
            ref: handlePaperRef
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, _base.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container,
            open
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, (0, _extendsDefault.default)({}, rootProps, !(0, _base.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, (0, _extendsDefault.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
exports.default = Popover;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base":"g25Dc","@mui/utils":"dv12b","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../utils/debounce":"h1O4l","../utils/ownerDocument":"2wE6J","../utils/ownerWindow":"53vpz","../utils/useForkRef":"kWp3j","../Grow":"eBM9D","../Modal":"h0x3u","../Paper":"4qOeF","./popoverClasses":"54IlZ","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"54IlZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopoverUtilityClass", ()=>getPopoverUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPopoverUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPopover", slot);
}
const popoverClasses = (0, _generateUtilityClassesDefault.default)("MuiPopover", [
    "root",
    "paper"
]);
exports.default = popoverClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1WBdK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuUtilityClass", ()=>getMenuUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiMenu", slot);
}
const menuClasses = (0, _generateUtilityClassesDefault.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
exports.default = menuClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dTC9Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "menuItemClasses", ()=>(0, _menuItemClassesDefault.default));
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuItemClasses = require("./menuItemClasses");
parcelHelpers.exportAll(_menuItemClasses, exports);
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
"use client";

},{"./MenuItem":"6Avsb","./menuItemClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Avsb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _divider = require("../Divider");
var _listItemIcon = require("../ListItemIcon");
var _listItemText = require("../ListItemText");
var _menuItemClasses = require("./menuItemClasses");
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _menuItemClasses.getMenuItemUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const MenuItemRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _system.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _menuItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, _divider.dividerClasses).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, _divider.dividerClasses).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, _listItemText.listItemTextClasses).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, _listItemText.listItemTextClasses).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, _listItemIcon.listItemIconClasses).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, _extendsDefault.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, _listItemIcon.listItemIconClasses).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const MenuItem = /*#__PURE__*/ _react.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus = false, component = "li", dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = "menuitem", tabIndex: tabIndexProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        dense: childContext.dense,
        divider,
        disableGutters
    });
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRefDefault.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuItemRoot, (0, _extendsDefault.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
exports.default = MenuItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../List/ListContext":"ARZc0","../ButtonBase":"ectWz","../utils/useEnhancedEffect":"1Zm5y","../utils/useForkRef":"kWp3j","../Divider":"1Yn32","../ListItemIcon":"ebq0R","../ListItemText":"7MfZJ","./menuItemClasses":"7poiw","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7poiw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuItemUtilityClass", ()=>getMenuItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiMenuItem", slot);
}
const menuItemClasses = (0, _generateUtilityClassesDefault.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
exports.default = menuItemClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7cXpp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _outlinedInputDefault.default));
parcelHelpers.export(exports, "outlinedInputClasses", ()=>(0, _outlinedInputClassesDefault.default));
var _outlinedInput = require("./OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
parcelHelpers.exportAll(_outlinedInputClasses, exports);
"use client";

},{"./OutlinedInput":"cxsuH","./outlinedInputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cxsuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _notchedOutline = require("./NotchedOutline");
var _notchedOutlineDefault = parcelHelpers.interopDefault(_notchedOutline);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
var _inputBase = require("../InputBase/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _outlinedInputClasses.getOutlinedInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const OutlinedInputRoot = (0, _styledDefault.default)((0, _inputBase.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, _inputBase.rootOverridesResolver)
})(({ theme, ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, _extendsDefault.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, _outlinedInputClassesDefault.default).focused} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, _outlinedInputClassesDefault.default).error} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, _outlinedInputClassesDefault.default).disabled} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const NotchedOutlineRoot = (0, _styledDefault.default)((0, _notchedOutlineDefault.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlinedInputInput = (0, _styledDefault.default)((0, _inputBase.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, _inputBase.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const OutlinedInput = /*#__PURE__*/ _react.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components = {}, fullWidth = false, inputComponent = "input", label, multiline = false, notched, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, _extendsDefault.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
OutlinedInput.muiName = "Input";
exports.default = OutlinedInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","./NotchedOutline":"4nKhy","../FormControl/useFormControl":"5VdUX","../FormControl/formControlState":"89R3A","../styles/styled":"jvcDu","./outlinedInputClasses":"iCEso","../InputBase/InputBase":"ca0Zd","../styles/useThemeProps":"4dkr8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4nKhy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotchedOutline);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const NotchedOutlineRoot = (0, _styledDefault.default)("fieldset", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const NotchedOutlineLegend = (0, _styledDefault.default)("legend", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, _extendsDefault.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function NotchedOutline(props) {
    const { className, label, notched } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        notched,
        withLabel
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, (0, _extendsDefault.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }) : _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","../styles/styled":"jvcDu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8YO5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "paginationClasses", ()=>(0, _paginationClassesDefault.default));
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationClasses = require("./paginationClasses");
var _paginationClassesDefault = parcelHelpers.interopDefault(_paginationClasses);
parcelHelpers.exportAll(_paginationClasses, exports);
"use client";

},{"./Pagination":"gsarG","./paginationClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsarG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/utils");
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paginationClasses = require("./paginationClasses");
var _usePagination = require("../usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
var _paginationItem = require("../PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _paginationClasses.getPaginationUtilityClass), classes);
};
const PaginationRoot = (0, _styledDefault.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const PaginationUl = (0, _styledDefault.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/ _react.forwardRef(function Pagination(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount = 1, className, color = "standard", count = 1, defaultPage = 1, disabled = false, getItemAriaLabel = defaultGetAriaLabel, hideNextButton = false, hidePrevButton = false, renderItem = (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), (0, _extendsDefault.default)({}, item)), shape = "circular", showFirstButton = false, showLastButton = false, siblingCount = 1, size = "medium", variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { items } = (0, _usePaginationDefault.default)((0, _extendsDefault.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        boundaryCount,
        color,
        count,
        defaultPage,
        disabled,
        getItemAriaLabel,
        hideNextButton,
        hidePrevButton,
        renderItem,
        shape,
        showFirstButton,
        showLastButton,
        siblingCount,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationRoot, (0, _extendsDefault.default)({
        "aria-label": "pagination navigation",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: renderItem((0, _extendsDefault.default)({}, item, {
                        color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape,
                        size,
                        variant
                    }))
                }, index))
        })
    }));
});
exports.default = Pagination;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/utils":"dv12b","../styles/useThemeProps":"4dkr8","./paginationClasses":"c9DPs","../usePagination":"79HSf","../PaginationItem":"gRtwV","../styles/styled":"jvcDu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c9DPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationUtilityClass", ()=>getPaginationUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPagination", slot);
}
const paginationClasses = (0, _generateUtilityClassesDefault.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
exports.default = paginationClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"79HSf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePaginationDefault.default));
var _usePagination = require("./usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
"use client";

},{"./usePagination":"DwyiI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"DwyiI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePagination);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
"use client";
const _excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount = 1, componentName = "usePagination", count = 1, defaultPage = 1, disabled = false, hideNextButton = false, hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton = false, showLastButton = false, siblingCount = 1 } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [page, setPageState] = (0, _utils.unstable_useControlled)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, _extendsDefault.default)({
        items
    }, other);
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gRtwV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "paginationItemClasses", ()=>(0, _paginationItemClassesDefault.default));
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
parcelHelpers.exportAll(_paginationItemClasses, exports);
"use client";

},{"./PaginationItem":"eymHW","./paginationItemClasses":"86fmP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eymHW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _firstPage = require("../internal/svg-icons/FirstPage");
var _firstPageDefault = parcelHelpers.interopDefault(_firstPage);
var _lastPage = require("../internal/svg-icons/LastPage");
var _lastPageDefault = parcelHelpers.interopDefault(_lastPage);
var _navigateBefore = require("../internal/svg-icons/NavigateBefore");
var _navigateBeforeDefault = parcelHelpers.interopDefault(_navigateBefore);
var _navigateNext = require("../internal/svg-icons/NavigateNext");
var _navigateNextDefault = parcelHelpers.interopDefault(_navigateNext);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, selected, size, shape, type, variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, _capitalizeDefault.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, _capitalizeDefault.default)(color)}`,
            color !== "standard" && `${variant}${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _paginationItemClasses.getPaginationItemUtilityClass), classes);
};
const PaginationItemEllipsis = (0, _styledDefault.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const PaginationItemPage = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _system.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "text" && {
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, _system.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const PaginationItemPageIcon = (0, _styledDefault.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const PaginationItem = /*#__PURE__*/ _react.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className, color = "standard", component, components = {}, disabled = false, page, selected = false, shape = "circular", size = "medium", slots = {}, type = "page", variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disabled,
        selected,
        shape,
        size,
        type,
        variant
    });
    const theme = (0, _useThemeDefault.default)();
    const classes = useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
        previous: slots.next || components.next || (0, _navigateNextDefault.default),
        next: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        last: slots.first || components.first || (0, _firstPageDefault.default),
        first: slots.last || components.last || (0, _lastPageDefault.default)
    } : {
        previous: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        next: slots.next || components.next || (0, _navigateNextDefault.default),
        first: slots.first || components.first || (0, _firstPageDefault.default),
        last: slots.last || components.last || (0, _lastPageDefault.default)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationItemPage, (0, _extendsDefault.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
exports.default = PaginationItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../styles/useThemeProps":"4dkr8","./paginationItemClasses":"86fmP","../styles/useTheme":"6UMPc","../ButtonBase":"ectWz","../utils/capitalize":"bIHYz","../internal/svg-icons/FirstPage":"ewOSW","../internal/svg-icons/LastPage":"x17Wi","../internal/svg-icons/NavigateBefore":"gdCSm","../internal/svg-icons/NavigateNext":"eMdyh","../styles/styled":"jvcDu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"86fmP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationItemUtilityClass", ()=>getPaginationItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPaginationItem", slot);
}
const paginationItemClasses = (0, _generateUtilityClassesDefault.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
exports.default = paginationItemClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ewOSW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"x17Wi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gdCSm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eMdyh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aiyFZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "selectClasses", ()=>(0, _selectClassesDefault.default));
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
parcelHelpers.exportAll(_selectClasses, exports);
"use client";

},{"./Select":"jdbYy","./selectClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jdbYy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _selectInput = require("./SelectInput");
var _selectInputDefault = parcelHelpers.interopDefault(_selectInput);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _arrowDropDown = require("../internal/svg-icons/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _nativeSelectInputDefault = parcelHelpers.interopDefault(_nativeSelectInput);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], _excluded2 = [
    "root"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    return classes;
};
const styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const StyledInput = (0, _styledDefault.default)((0, _inputDefault.default), styledRootConfig)("");
const StyledOutlinedInput = (0, _styledDefault.default)((0, _outlinedInputDefault.default), styledRootConfig)("");
const StyledFilledInput = (0, _styledDefault.default)((0, _filledInputDefault.default), styledRootConfig)("");
const Select = /*#__PURE__*/ _react.forwardRef(function Select(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = (0, _arrowDropDownDefault.default), id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const inputComponent = native ? (0, _nativeSelectInputDefault.default) : (0, _selectInputDefault.default);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        classes: classesProp
    });
    const classes = useUtilityClasses(ownerState);
    const restOfClasses = (0, _objectWithoutPropertiesLooseDefault.default)(classes, _excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, _useForkRefDefault.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(InputComponent, (0, _extendsDefault.default)({
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, _extendsDefault.default)({
                children,
                error: fcs.error,
                IconComponent,
                variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id
            } : {
                autoWidth,
                defaultOpen,
                displayEmpty,
                labelId,
                MenuProps,
                onClose,
                onOpen,
                open,
                renderValue,
                SelectDisplayProps: (0, _extendsDefault.default)({
                    id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, _utils.deepmerge)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, _clsxDefault.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant
        }, other))
    });
});
Select.muiName = "Select";
exports.default = Select;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","./SelectInput":"4KxIi","../FormControl/formControlState":"89R3A","../FormControl/useFormControl":"5VdUX","../internal/svg-icons/ArrowDropDown":"kZF9C","../Input":"bEBUE","../NativeSelect/NativeSelectInput":"40bkW","../FilledInput":"frONn","../OutlinedInput":"7cXpp","../styles/useThemeProps":"4dkr8","../utils/useForkRef":"kWp3j","../styles/styled":"jvcDu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KxIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/utils");
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _menu = require("../Menu/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _utils1 = require("../InputBase/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const SelectSelect = (0, _styledDefault.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles.select
            },
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, _selectClassesDefault.default).error}`]: styles.error
            },
            {
                [`&.${(0, _selectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, _nativeSelectInput.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, _selectClassesDefault.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const SelectIcon = (0, _styledDefault.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, _nativeSelectInput.nativeSelectIconStyles));
const SelectNativeInput = (0, _styledDefault.default)("input", {
    shouldForwardProp: (prop)=>(0, _styled.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _selectClasses.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const SelectInput = /*#__PURE__*/ _react.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onOpen, open: openProp, readOnly, renderValue, SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [value, setValueState] = (0, _useControlledDefault.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = _react.useRef(null);
    const displayRef = _react.useRef(null);
    const [displayNode, setDisplayNode] = _react.useState(null);
    const { current: isOpenControlled } = _react.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = _react.useState();
    const handleRef = (0, _useForkRefDefault.default)(ref, inputRefProp);
    const handleDisplayRef = _react.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    _react.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    _react.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    _react.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, _ownerDocumentDefault.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = _react.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value,
                    name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, _utils1.isFilled)({
        value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, _formatMuiErrorMessageDefault.default)(2));
            selected = value.some((v)=>areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ _react.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        value,
        open,
        error
    });
    const classes = useUtilityClasses(ownerState);
    const paperProps = (0, _extendsDefault.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, _utils.unstable_useId)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSelect, (0, _extendsDefault.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectNativeInput, (0, _extendsDefault.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), (0, _extendsDefault.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, _extendsDefault.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, _extendsDefault.default)({}, MenuProps.slotProps, {
                    paper: (0, _extendsDefault.default)({}, paperProps, {
                        style: (0, _extendsDefault.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
exports.default = SelectInput;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@mui/utils/formatMuiErrorMessage":"h4Lns","react":"gVheC","react-is":"3fr5l","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/utils":"dv12b","../utils/ownerDocument":"2wE6J","../utils/capitalize":"bIHYz","../Menu/Menu":"lB8aZ","../NativeSelect/NativeSelectInput":"40bkW","../InputBase/utils":"lkbBD","../styles/styled":"jvcDu","../utils/useForkRef":"kWp3j","../utils/useControlled":"hR7cg","./selectClasses":"r7lXd","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"40bkW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeSelectSelectStyles", ()=>nativeSelectSelectStyles);
parcelHelpers.export(exports, "nativeSelectIconStyles", ()=>nativeSelectIconStyles);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _nativeSelectClasses = require("./nativeSelectClasses");
var _nativeSelectClassesDefault = parcelHelpers.interopDefault(_nativeSelectClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _nativeSelectClasses.getNativeSelectUtilityClasses), classes);
};
const nativeSelectSelectStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, _extendsDefault.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const NativeSelectSelect = (0, _styledDefault.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, _styled.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, _nativeSelectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const NativeSelectIcon = (0, _styledDefault.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})(nativeSelectIconStyles);
/**
 * @ignore - internal component.
 */ const NativeSelectInput = /*#__PURE__*/ _react.forwardRef(function NativeSelectInput(props, ref) {
    const { className, disabled, error, IconComponent, inputRef, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        variant,
        error
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectSelect, (0, _extendsDefault.default)({
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
exports.default = NativeSelectInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","../utils/capitalize":"bIHYz","./nativeSelectClasses":"81Vli","../styles/styled":"jvcDu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"81Vli":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNativeSelectUtilityClasses", ()=>getNativeSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getNativeSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiNativeSelect", slot);
}
const nativeSelectClasses = (0, _generateUtilityClassesDefault.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
exports.default = nativeSelectClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"r7lXd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectUtilityClasses", ()=>getSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSelect", slot);
}
const selectClasses = (0, _generateUtilityClassesDefault.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
exports.default = selectClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eTJwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _skeletonDefault.default));
parcelHelpers.export(exports, "skeletonClasses", ()=>(0, _skeletonClassesDefault.default));
var _skeleton = require("./Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _skeletonClasses = require("./skeletonClasses");
parcelHelpers.exportAll(_skeletonClasses, exports);
var _skeletonClassesDefault = parcelHelpers.interopDefault(_skeletonClasses);
"use client";

},{"./Skeleton":"3kJ4d","./skeletonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3kJ4d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _composeClasses = require("@mui/base/composeClasses");
var _styles = require("../styles");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _skeletonClasses = require("./skeletonClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
let _ = (t)=>t, t, t1, t2, t3;
const _excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let _1 = (t)=>t, _t, _t2, _t3, _t4;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, animation, hasChildren, width, height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _skeletonClasses.getSkeletonUtilityClass), classes);
};
const pulseKeyframe = (0, _system.keyframes)(_t || (_t = _1(t || (t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`))));
const waveKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _1(t1 || (t1 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`))));
const SkeletonRoot = (0, _styledDefault.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme, ownerState })=>{
    const radiusUnit = (0, _styles.unstable_getUnit)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, _styles.unstable_toUnitless)(theme.shape.borderRadius);
    return (0, _extendsDefault.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState })=>ownerState.animation === "pulse" && (0, _system.css)(_t3 || (_t3 = _1(t2 || (t2 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), 0)), pulseKeyframe), ({ ownerState, theme })=>ownerState.animation === "wave" && (0, _system.css)(_t4 || (_t4 = _1(t3 || (t3 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), 0, 0)), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/ _react.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation = "pulse", className, component = "span", height, style, variant = "text", width } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        animation,
        component,
        variant,
        hasChildren: Boolean(other.children)
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, _extendsDefault.default)({
            width,
            height
        }, style)
    }));
});
exports.default = Skeleton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"aGWRz","prop-types":"3KNJy","@mui/system":"gwZXT","@mui/base/composeClasses":"icrTb","../styles":"gNR9m","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","./skeletonClasses":"3FLXP","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3FLXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkeletonUtilityClass", ()=>getSkeletonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSkeletonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSkeleton", slot);
}
const skeletonClasses = (0, _generateUtilityClassesDefault.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
exports.default = skeletonClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3POY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "switchClasses", ()=>(0, _switchClassesDefault.default));
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _switchClasses = require("./switchClasses");
var _switchClassesDefault = parcelHelpers.interopDefault(_switchClasses);
parcelHelpers.exportAll(_switchClasses, exports);
"use client";

},{"./Switch":"jttpG","./switchClasses":"6P8QE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jttpG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @inheritedComponent IconButton
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _switchBase = require("../internal/SwitchBase");
var _switchBaseDefault = parcelHelpers.interopDefault(_switchBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _switchClasses = require("./switchClasses");
var _switchClassesDefault = parcelHelpers.interopDefault(_switchClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, edge, size, color, checked, disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, _capitalizeDefault.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClasses.unstable_composeClasses)(slots, (0, _switchClasses.getSwitchUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const SwitchRoot = (0, _styledDefault.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, _capitalizeDefault.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, _switchClassesDefault.default).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, _switchClassesDefault.default).switchBase}`]: {
            padding: 4,
            [`&.${(0, _switchClassesDefault.default).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const SwitchSwitchBase = (0, _styledDefault.default)((0, _switchBaseDefault.default), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, _switchClassesDefault.default).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, _switchClassesDefault.default).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, _switchClassesDefault.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, _switchClassesDefault.default).checked} + .${(0, _switchClassesDefault.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, _switchClassesDefault.default).disabled} + .${(0, _switchClassesDefault.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, _switchClassesDefault.default).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, _switchClassesDefault.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _system.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, _switchClassesDefault.default).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, _system.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, _system.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, _switchClassesDefault.default).checked} + .${(0, _switchClassesDefault.default).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const SwitchTrack = (0, _styledDefault.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const SwitchThumb = (0, _styledDefault.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const Switch = /*#__PURE__*/ _react.forwardRef(function Switch(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className, color = "primary", edge = false, size = "medium", sx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        edge,
        size
    });
    const classes = useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SwitchRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchSwitchBase, (0, _extendsDefault.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, _extendsDefault.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
exports.default = Switch;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../utils/capitalize":"bIHYz","../internal/SwitchBase":"3rldR","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./switchClasses":"6P8QE","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6P8QE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSwitchUtilityClass", ()=>getSwitchUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSwitchUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSwitch", slot);
}
const switchClasses = (0, _generateUtilityClassesDefault.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
exports.default = switchClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"Y15zS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "tableCellClasses", ()=>(0, _tableCellClassesDefault.default));
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
parcelHelpers.exportAll(_tableCellClasses, exports);
"use client";

},{"./TableCell":"mCyqR","./tableCellClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"mCyqR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _system = require("@mui/system");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _tableContext = require("../Table/TableContext");
var _tableContextDefault = parcelHelpers.interopDefault(_tableContext);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, align, padding, size, stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, _capitalizeDefault.default)(align)}`,
            padding !== "normal" && `padding${(0, _capitalizeDefault.default)(padding)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _tableCellClasses.getTableCellUtilityClass), classes);
};
const TableCellRoot = (0, _styledDefault.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, _capitalizeDefault.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, _system.lighten)((0, _system.alpha)(theme.palette.divider, 1), 0.88) : (0, _system.darken)((0, _system.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, _tableCellClassesDefault.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const TableCell = /*#__PURE__*/ _react.forwardRef(function TableCell(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align = "inherit", className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const table = _react.useContext((0, _tableContextDefault.default));
    const tablelvl2 = _react.useContext((0, _tablelvl2ContextDefault.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCellRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
exports.default = TableCell;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/system":"gwZXT","../utils/capitalize":"bIHYz","../Table/TableContext":"8X3wx","../Table/Tablelvl2Context":"9I25U","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./tableCellClasses":"iHo4z","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8X3wx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const TableContext = /*#__PURE__*/ _react.createContext();
exports.default = TableContext;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9I25U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const Tablelvl2Context = /*#__PURE__*/ _react.createContext();
exports.default = Tablelvl2Context;

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iHo4z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableCellUtilityClass", ()=>getTableCellUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableCellUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableCell", slot);
}
const tableCellClasses = (0, _generateUtilityClassesDefault.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
exports.default = tableCellClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"65lFk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tablePaginationDefault.default));
parcelHelpers.export(exports, "tablePaginationClasses", ()=>(0, _tablePaginationClassesDefault.default));
var _tablePagination = require("./TablePagination");
var _tablePaginationDefault = parcelHelpers.interopDefault(_tablePagination);
var _tablePaginationClasses = require("./tablePaginationClasses");
var _tablePaginationClassesDefault = parcelHelpers.interopDefault(_tablePaginationClasses);
parcelHelpers.exportAll(_tablePaginationClasses, exports);
"use client";

},{"./TablePagination":"lmoQP","./tablePaginationClasses":"ht6oY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lmoQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _base = require("@mui/base");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _menuItem = require("../MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _tableCell = require("../TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _toolbar = require("../Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _tablePaginationActions = require("./TablePaginationActions");
var _tablePaginationActionsDefault = parcelHelpers.interopDefault(_tablePaginationActions);
var _useId = require("../utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _tablePaginationClasses = require("./tablePaginationClasses");
var _tablePaginationClassesDefault = parcelHelpers.interopDefault(_tablePaginationClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _InputBase;
const _excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const TablePaginationRoot = (0, _styledDefault.default)((0, _tableCellDefault.default), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const TablePaginationToolbar = (0, _styledDefault.default)((0, _toolbarDefault.default), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, _extendsDefault.default)({
            [`& .${(0, _tablePaginationClassesDefault.default).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, _tablePaginationClassesDefault.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const TablePaginationSpacer = (0, _styledDefault.default)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const TablePaginationSelectLabel = (0, _styledDefault.default)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const TablePaginationSelect = (0, _styledDefault.default)((0, _selectDefault.default), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, _extendsDefault.default)({
            [`& .${(0, _tablePaginationClassesDefault.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, _tablePaginationClassesDefault.default).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, _tablePaginationClassesDefault.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const TablePaginationMenuItem = (0, _styledDefault.default)((0, _menuItemDefault.default), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const TablePaginationDisplayedRows = (0, _styledDefault.default)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function defaultLabelDisplayedRows({ from, to, count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _tablePaginationClasses.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const TablePagination = /*#__PURE__*/ _react.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent = (0, _tablePaginationActionsDefault.default), backIconButtonProps, className, colSpan: colSpanProp, component = (0, _tableCellDefault.default), count, disabled = false, getItemAriaLabel = defaultGetAriaLabel, labelDisplayedRows = defaultLabelDisplayedRows, labelRowsPerPage = "Rows per page:", nextIconButtonProps, onPageChange, onRowsPerPageChange, page, rowsPerPage, rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps = {}, showFirstButton = false, showLastButton = false, slotProps = {}, slots = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : TablePaginationMenuItem;
    let colSpan;
    if (component === (0, _tableCellDefault.default) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, _useIdDefault.default)(selectProps.id);
    const labelId = (0, _useIdDefault.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TablePaginationRoot, (0, _extendsDefault.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TablePaginationSelect, (0, _extendsDefault.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: _InputBase || (_InputBase = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, _extendsDefault.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, _clsxDefault.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, _clsxDefault.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, _clsxDefault.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, _react.createElement)(MenuItemComponent, (0, _extendsDefault.default)({}, !(0, _base.isHostComponent)(MenuItemComponent) && {
                            ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
exports.default = TablePagination;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base":"g25Dc","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../InputBase":"9Zug6","../MenuItem":"dTC9Z","../Select":"aiyFZ","../TableCell":"Y15zS","../Toolbar":"8LwX6","./TablePaginationActions":"cgAy1","../utils/useId":"1ZKNc","./tablePaginationClasses":"ht6oY","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8LwX6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _toolbarDefault.default));
parcelHelpers.export(exports, "toolbarClasses", ()=>(0, _toolbarClassesDefault.default));
var _toolbar = require("./Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _toolbarClasses = require("./toolbarClasses");
var _toolbarClassesDefault = parcelHelpers.interopDefault(_toolbarClasses);
parcelHelpers.exportAll(_toolbarClasses, exports);

},{"./Toolbar":"1oHFA","./toolbarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1oHFA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _toolbarClasses = require("./toolbarClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableGutters, variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _toolbarClasses.getToolbarUtilityClass), classes);
};
const ToolbarRoot = (0, _styledDefault.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme, ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const Toolbar = /*#__PURE__*/ _react.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className, component = "div", disableGutters = false, variant = "regular" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disableGutters,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolbarRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
exports.default = Toolbar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","../styles/useThemeProps":"4dkr8","../styles/styled":"jvcDu","./toolbarClasses":"efCMu","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"efCMu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getToolbarUtilityClass", ()=>getToolbarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getToolbarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiToolbar", slot);
}
const toolbarClasses = (0, _generateUtilityClassesDefault.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
exports.default = toolbarClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cgAy1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _keyboardArrowLeft = require("../internal/svg-icons/KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _keyboardArrowRight = require("../internal/svg-icons/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _iconButton = require("../IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _lastPage = require("../internal/svg-icons/LastPage");
var _lastPageDefault = parcelHelpers.interopDefault(_lastPage);
var _firstPage = require("../internal/svg-icons/FirstPage");
var _firstPageDefault = parcelHelpers.interopDefault(_firstPage);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const TablePaginationActions = /*#__PURE__*/ _react.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps, count, disabled = false, getItemAriaLabel, nextIconButtonProps, onPageChange, page, rowsPerPage, showFirstButton, showLastButton, slots = {}, slotProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const theme = (0, _useThemeDefault.default)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, _iconButtonDefault.default);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, _iconButtonDefault.default);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, _iconButtonDefault.default);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, _iconButtonDefault.default);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, _firstPageDefault.default);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, _lastPageDefault.default);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, _keyboardArrowRightDefault.default);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, _keyboardArrowLeftDefault.default);
    const FirstButtonSlot = theme.direction === "rtl" ? LastButton : FirstButton;
    const PreviousButtonSlot = theme.direction === "rtl" ? NextButton : PreviousButton;
    const NextButtonSlot = theme.direction === "rtl" ? PreviousButton : NextButton;
    const LastButtonSlot = theme.direction === "rtl" ? FirstButton : LastButton;
    const firstButtonSlotProps = theme.direction === "rtl" ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = theme.direction === "rtl" ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = theme.direction === "rtl" ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = theme.direction === "rtl" ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstButtonSlot, (0, _extendsDefault.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastButtonIcon, (0, _extendsDefault.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstButtonIcon, (0, _extendsDefault.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousButtonSlot, (0, _extendsDefault.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextButtonIcon, (0, _extendsDefault.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousButtonIcon, (0, _extendsDefault.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextButtonSlot, (0, _extendsDefault.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousButtonIcon, (0, _extendsDefault.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextButtonIcon, (0, _extendsDefault.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastButtonSlot, (0, _extendsDefault.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: theme.direction === "rtl" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(FirstButtonIcon, (0, _extendsDefault.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LastButtonIcon, (0, _extendsDefault.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
exports.default = TablePaginationActions;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","../internal/svg-icons/KeyboardArrowLeft":"n7JH6","../internal/svg-icons/KeyboardArrowRight":"hQnmv","../styles/useTheme":"6UMPc","../IconButton":"6bnps","../internal/svg-icons/LastPage":"x17Wi","../internal/svg-icons/FirstPage":"ewOSW","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"n7JH6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hQnmv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");

},{"react":"gVheC","../../utils/createSvgIcon":"eL1vB","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ht6oY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTablePaginationUtilityClass", ()=>getTablePaginationUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTablePaginationUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTablePagination", slot);
}
const tablePaginationClasses = (0, _generateUtilityClassesDefault.default)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
exports.default = tablePaginationClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j02FZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textFieldDefault.default));
parcelHelpers.export(exports, "textFieldClasses", ()=>(0, _textFieldClassesDefault.default));
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textFieldClasses = require("./textFieldClasses");
var _textFieldClassesDefault = parcelHelpers.interopDefault(_textFieldClasses);
parcelHelpers.exportAll(_textFieldClasses, exports);
"use client";

},{"./TextField":"byeiv","./textFieldClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"byeiv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/base/composeClasses");
var _utils = require("@mui/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("../InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("../FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("../FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textFieldClasses = require("./textFieldClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const variantComponent = {
    standard: (0, _inputDefault.default),
    filled: (0, _filledInputDefault.default),
    outlined: (0, _outlinedInputDefault.default)
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _textFieldClasses.getTextFieldUtilityClass), classes);
};
const TextFieldRoot = (0, _styledDefault.default)((0, _formControlDefault.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const TextField = /*#__PURE__*/ _react.forwardRef(function TextField(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete, autoFocus = false, children, className, color = "primary", defaultValue, disabled = false, error = false, FormHelperTextProps, fullWidth = false, helperText, id: idOverride, InputLabelProps, inputProps, InputProps, inputRef, label, maxRows, minRows, multiline = false, name, onBlur, onChange, onFocus, placeholder, required = false, rows, select = false, SelectProps, type, value, variant = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        color,
        disabled,
        error,
        fullWidth,
        multiline,
        required,
        select,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, _utils.unstable_useId)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputComponent, (0, _extendsDefault.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TextFieldRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), (0, _extendsDefault.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _extendsDefault.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), (0, _extendsDefault.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
exports.default = TextField;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/base/composeClasses":"icrTb","@mui/utils":"dv12b","../styles/styled":"jvcDu","../styles/useThemeProps":"4dkr8","../Input":"bEBUE","../FilledInput":"frONn","../OutlinedInput":"7cXpp","../InputLabel":"i0KlN","../FormControl":"6EcMm","../FormHelperText":"FdSIA","../Select":"aiyFZ","./textFieldClasses":"cQh86","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQh86":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTextFieldUtilityClass", ()=>getTextFieldUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTextField", slot);
}
const textFieldClasses = (0, _generateUtilityClassesDefault.default)("MuiTextField", [
    "root"
]);
exports.default = textFieldClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fmb01":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "tooltipClasses", ()=>(0, _tooltipClassesDefault.default));
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
parcelHelpers.exportAll(_tooltipClasses, exports);
"use client";

},{"./Tooltip":"eUkgN","./tooltipClasses":"lg7wk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eUkgN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testReset", ()=>testReset);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/utils");
var _base = require("@mui/base");
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _popper = require("../Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useId = require("../utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, disableInteractive, arrow, touch, placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, _capitalizeDefault.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, (0, _tooltipClasses.getTooltipUtilityClass), classes);
};
const TooltipPopper = (0, _styledDefault.default)((0, _popperDefault.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme, ownerState, open })=>(0, _extendsDefault.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const TooltipTooltip = (0, _styledDefault.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, _capitalizeDefault.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _system.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="left"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, _extendsDefault.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="right"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, _extendsDefault.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="top"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="bottom"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const TooltipArrow = (0, _styledDefault.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _system.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let hystersisOpen = false;
const hystersisTimer = new (0, _utils.unstable_Timeout)();
let cursorPosition = {
    x: 0,
    y: 0
};
function testReset() {
    hystersisOpen = false;
    hystersisTimer.clear();
}
function composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/ _react.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow = false, children: childrenProp, components = {}, componentsProps = {}, describeChild = false, disableFocusListener = false, disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener = false, enterDelay = 100, enterNextDelay = 0, enterTouchDelay = 700, followCursor = false, id: idProp, leaveDelay = 0, leaveTouchDelay = 1500, onClose, onOpen, open: openProp, placement = "bottom", PopperComponent: PopperComponentProp, PopperProps = {}, slotProps = {}, slots = {}, title, TransitionComponent: TransitionComponentProp = (0, _growDefault.default), TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ _react.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, _useThemeDefault.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = _react.useState();
    const [arrowRef, setArrowRef] = _react.useState(null);
    const ignoreNonTouchEvents = _react.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, _utils.unstable_useTimeout)();
    const enterTimer = (0, _utils.unstable_useTimeout)();
    const leaveTimer = (0, _utils.unstable_useTimeout)();
    const touchTimer = (0, _utils.unstable_useTimeout)();
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, _useIdDefault.default)(idProp);
    const prevUserSelect = _react.useRef();
    const stopTouchInteraction = (0, _useEventCallbackDefault.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    _react.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        hystersisTimer.clear();
        hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, _useEventCallbackDefault.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        hystersisTimer.start(800 + leaveDelay, ()=>{
            hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || hystersisOpen && enterNextDelay) enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = _react.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    _react.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, _useForkRefDefault.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = _react.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, _extendsDefault.default)({}, nameOrDescProps, other, children.props, {
        className: (0, _clsxDefault.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = _react.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, _extendsDefault.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        isRtl,
        arrow,
        disableInteractive,
        placement,
        PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, _growDefault.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
    const popperProps = (0, _base.appendOwnerState)(PopperComponent, (0, _extendsDefault.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, _clsxDefault.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, _base.appendOwnerState)(TransitionComponent, (0, _extendsDefault.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, _base.appendOwnerState)(TooltipComponent, (0, _extendsDefault.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, _clsxDefault.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, _base.appendOwnerState)(ArrowComponent, (0, _extendsDefault.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, _clsxDefault.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ _react.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperComponent, (0, _extendsDefault.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, _popperDefault.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: cursorPosition.y,
                            left: cursorPosition.x,
                            right: cursorPosition.x,
                            bottom: cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TooltipComponent, (0, _extendsDefault.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrowComponent, (0, _extendsDefault.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
exports.default = Tooltip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aGWRz","@mui/utils":"dv12b","@mui/base":"g25Dc","@mui/system":"gwZXT","../styles/styled":"jvcDu","../styles/useTheme":"6UMPc","../styles/useThemeProps":"4dkr8","../utils/capitalize":"bIHYz","../Grow":"eBM9D","../Popper":"2EAIq","../utils/useEventCallback":"7Pqt8","../utils/useForkRef":"kWp3j","../utils/useId":"1ZKNc","../utils/useIsFocusVisible":"6OfIY","../utils/useControlled":"hR7cg","./tooltipClasses":"lg7wk","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lg7wk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipUtilityClass", ()=>getTooltipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTooltipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTooltip", slot);
}
const tooltipClasses = (0, _generateUtilityClassesDefault.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
exports.default = tooltipClasses;

},{"@mui/utils/generateUtilityClasses":"88HUS","@mui/utils/generateUtilityClass":"lhBx6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kV0D0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryDefault.default));
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
"use client";

},{"./useMediaQuery":"3k1ML","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3k1ML":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _react = require("react");
var _system = require("@mui/system");
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = _react.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = _react["useSyncExternalStore"];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = _react.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = _react.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = _react.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function useMediaQuery(queryInput, options = {}) {
    const theme = (0, _system.useThemeWithoutDefault)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _system.getThemeProps)({
        name: "MuiUseMediaQuery",
        props: options,
        theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

},{"react":"gVheC","@mui/system":"gwZXT","../utils/useEnhancedEffect":"1Zm5y","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5CV04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _utils.unstable_generateUtilityClass));
var _utils = require("@mui/utils");

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6RMZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _utils.unstable_generateUtilityClasses));
var _utils = require("@mui/utils");

},{"@mui/utils":"dv12b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eOGvF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterBar", ()=>FilterBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _reactQuery = require("@tanstack/react-query");
var _components = require("../../components");
var _lib = require("../../lib");
var _datePickers = require("../DatePickers");
var _optionField = require("../OptionField");
var _monthPicker = require("../DatePickers/MonthPicker");
var _utils = require("../../lib/utils");
const FilterBar = ({ testID, company, employee, dates, country })=>{
    var _employees_data_listEmployees, _employees_data, _companies_data_listCompanies, _companies_data;
    const { data: companies } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listCompanies",
        vars: {
            limit: 1000
        }
    }));
    const { data: employees } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listEmployees",
        vars: {
            limit: 1000
        }
    }));
    var _employees_data_listEmployees_items;
    const employeeOptions = [
        ...((_employees_data_listEmployees_items = employees === null || employees === void 0 ? void 0 : (_employees_data = employees.data) === null || _employees_data === void 0 ? void 0 : (_employees_data_listEmployees = _employees_data.listEmployees) === null || _employees_data_listEmployees === void 0 ? void 0 : _employees_data_listEmployees.items) !== null && _employees_data_listEmployees_items !== void 0 ? _employees_data_listEmployees_items : []).map((i, index)=>{
            var _i_id, _i_id1;
            return {
                label: `${i === null || i === void 0 ? void 0 : i.firstName} ${i === null || i === void 0 ? void 0 : i.lastName}`,
                value: (_i_id = i === null || i === void 0 ? void 0 : i.id) !== null && _i_id !== void 0 ? _i_id : "",
                key: (_i_id1 = i === null || i === void 0 ? void 0 : i.id) !== null && _i_id1 !== void 0 ? _i_id1 : index
            };
        })
    ];
    var _companies_data_listCompanies_items;
    const companyOptions = [
        ...((_companies_data_listCompanies_items = companies === null || companies === void 0 ? void 0 : (_companies_data = companies.data) === null || _companies_data === void 0 ? void 0 : (_companies_data_listCompanies = _companies_data.listCompanies) === null || _companies_data_listCompanies === void 0 ? void 0 : _companies_data_listCompanies.items) !== null && _companies_data_listCompanies_items !== void 0 ? _companies_data_listCompanies_items : []).map((i, index)=>{
            var _i_name, _i_id, _i_id1;
            return {
                label: (_i_name = i === null || i === void 0 ? void 0 : i.name) !== null && _i_name !== void 0 ? _i_name : "",
                value: (_i_id = i === null || i === void 0 ? void 0 : i.id) !== null && _i_id !== void 0 ? _i_id : "",
                key: (_i_id1 = i === null || i === void 0 ? void 0 : i.id) !== null && _i_id1 !== void 0 ? _i_id1 : index
            };
        })
    ];
    const DatePicker = ({ type, ...dates })=>({
            week: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.WeekPicker), {
                ...dates,
                "data-testid": `${testID}-weekpicker`
            }),
            range: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickers.RangePicker), {
                ...dates,
                "data-testid": `${testID}-daterange-picker`
            }),
            month: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthPicker.MonthPicker), {
                ...dates,
                "data-testid": `${testID}-month-picker`
            }),
            _: null,
            year: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickers.YearPicker), {
                ...dates,
                "data-testid": `${testID}-year-picker`
            })
        })[type !== null && type !== void 0 ? type : "_"];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ActionBar), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    lg: "max-content 400px"
                },
                gap: 2
            },
            children: [
                dates && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePicker, {
                    ...dates
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)"
                        },
                        gap: 2
                    },
                    children: [
                        employee && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionField.SearchField), {
                            ...employee,
                            label: "Employee",
                            options: employeeOptions,
                            "data-testid": `${testID}-employee-dropdown`
                        }),
                        company && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionField.SearchField), {
                            ...company,
                            label: "Company",
                            options: companyOptions,
                            "data-testid": `${testID}-company-dropdown`
                        }),
                        country && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionField.SearchField), {
                            ...country,
                            label: "Country",
                            options: (0, _utils.countryOptions),
                            "data-testid": `${testID}-country-dropdown`,
                            onChange: (val)=>country.onChange(val)
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@tanstack/react-query":"j0XMv","../../components":"0272J","../../lib":"lWrCo","../DatePickers":"lnhPR","../OptionField":"8Mgzz","../DatePickers/MonthPicker":"cQ6lq","../../lib/utils":"2QLpi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lWrCo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _apiService = require("./apiService");
parcelHelpers.exportAll(_apiService, exports);
var _useEmployeeLib = require("./useEmployeeLib");
parcelHelpers.exportAll(_useEmployeeLib, exports);
var _useClientLib = require("./useClientLib");
parcelHelpers.exportAll(_useClientLib, exports);
var _useContractsLib = require("./useContractsLib");
parcelHelpers.exportAll(_useContractsLib, exports);
var _useCompanyLib = require("./useCompanyLib");
parcelHelpers.exportAll(_useCompanyLib, exports);
var _useTimelogLib = require("./useTimelogLib");
parcelHelpers.exportAll(_useTimelogLib, exports);
var _useAbsenceLib = require("./useAbsenceLib");
parcelHelpers.exportAll(_useAbsenceLib, exports);
var _useTimeInLieuLib = require("./useTimeInLieuLib");
parcelHelpers.exportAll(_useTimeInLieuLib, exports);
var _useBankHolidayLib = require("./useBankHolidayLib");
parcelHelpers.exportAll(_useBankHolidayLib, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./apiService":"8qcsE","./useEmployeeLib":"2zydk","./useClientLib":"9oWNa","./useContractsLib":"faPnz","./useCompanyLib":"j02rn","./useTimelogLib":"5pLhQ","./useAbsenceLib":"cukMv","./useTimeInLieuLib":"6lKg1","./useBankHolidayLib":"6sKQ6","./utils":"2QLpi","./types":"lRmxX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qcsE":[function(require,module,exports) {
/*eslint import/namespace: ['error', { allowComputed: true }]*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gqlQuery", ()=>gqlQuery);
parcelHelpers.export(exports, "gqlMutation", ()=>gqlMutation);
parcelHelpers.export(exports, "gqlRequest", ()=>gqlRequest);
var _api = require("@aws-amplify/api");
var _queries = require("../graphql/queries");
var _custom = require("../graphql/custom");
var _mutations = require("../graphql/mutations");
const gql = {
    ..._queries,
    ..._custom
};
const gqlQuery = ({ req, vars, headers, key = [] })=>({
        queryKey: [
            req,
            ...key
        ],
        queryFn: ()=>gqlRequest(gql[req], vars, headers)
    });
const gqlMutation = ({ req, headers })=>({
        mutationFn: (vars)=>gqlRequest(_mutations[req], vars, headers)
    });
const gqlRequest = async (query, variables, additionalHeaders)=>(0, _api.API).graphql({
        query,
        variables: variables,
        authMode: "AMAZON_COGNITO_USER_POOLS"
    }, additionalHeaders);

},{"@aws-amplify/api":"6PDaW","../graphql/queries":"h9xYO","../graphql/custom":"jzylu","../graphql/mutations":"6gCid","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h9xYO":[function(require,module,exports) {
/* tslint:disable */ /* eslint-disable */ // this is an auto generated file. This will be overwritten
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCompany", ()=>getCompany);
parcelHelpers.export(exports, "listCompanies", ()=>listCompanies);
parcelHelpers.export(exports, "getClient", ()=>getClient);
parcelHelpers.export(exports, "listClients", ()=>listClients);
parcelHelpers.export(exports, "getEmployee", ()=>getEmployee);
parcelHelpers.export(exports, "listEmployees", ()=>listEmployees);
parcelHelpers.export(exports, "getTimelog", ()=>getTimelog);
parcelHelpers.export(exports, "listTimelogs", ()=>listTimelogs);
parcelHelpers.export(exports, "getAbsence", ()=>getAbsence);
parcelHelpers.export(exports, "listAbsences", ()=>listAbsences);
parcelHelpers.export(exports, "getTimeInLieu", ()=>getTimeInLieu);
parcelHelpers.export(exports, "listTimeInLieus", ()=>listTimeInLieus);
parcelHelpers.export(exports, "getBankHoliday", ()=>getBankHoliday);
parcelHelpers.export(exports, "listBankHolidays", ()=>listBankHolidays);
parcelHelpers.export(exports, "getClientContracts", ()=>getClientContracts);
parcelHelpers.export(exports, "listClientContracts", ()=>listClientContracts);
const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      country
      inactiveAt
      clients {
        items {
          id
          firstName
          lastName
          email
          inactiveAt
          createdAt
          updatedAt
          companyClientsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        country
        inactiveAt
        clients {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      id
      company {
        id
        name
        country
        inactiveAt
        clients {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      firstName
      lastName
      email
      inactiveAt
      employees {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyClientsId
      __typename
    }
  }
`;
const listClients = /* GraphQL */ `
  query ListClients(
    $filter: ModelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        company {
          id
          name
          country
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        firstName
        lastName
        email
        inactiveAt
        employees {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyClientsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      inactiveAt
      clients {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      absences {
        items {
          id
          startDate
          endDate
          hoursTaken
          amount
          description
          notes
          type
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timeInLieus {
        items {
          id
          dateEarned
          dateTaken
          hoursTaken
          description
          notes
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getTimelog = /* GraphQL */ `
  query GetTimelog($id: ID!) {
    getTimelog(id: $id) {
      id
      date
      standard
      overtime
      sick
      holiday
      notes
      approved
      onCall
      employeeID
      clientID
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listTimelogs = /* GraphQL */ `
  query ListTimelogs(
    $filter: ModelTimelogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimelogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        date
        standard
        overtime
        sick
        holiday
        notes
        approved
        onCall
        employeeID
        clientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getAbsence = /* GraphQL */ `
  query GetAbsence($id: ID!) {
    getAbsence(id: $id) {
      id
      startDate
      endDate
      hoursTaken
      amount
      description
      notes
      type
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listAbsences = /* GraphQL */ `
  query ListAbsences(
    $filter: ModelAbsenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAbsences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        startDate
        endDate
        hoursTaken
        amount
        description
        notes
        type
        approvedByClient
        approvalStatus
        employeeID
        employee {
          id
          firstName
          lastName
          email
          country
          region
          vacationAllowance
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getTimeInLieu = /* GraphQL */ `
  query GetTimeInLieu($id: ID!) {
    getTimeInLieu(id: $id) {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listTimeInLieus = /* GraphQL */ `
  query ListTimeInLieus(
    $filter: ModelTimeInLieuFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeInLieus(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dateEarned
        dateTaken
        hoursTaken
        description
        notes
        approvedByClient
        approvalStatus
        employeeID
        employee {
          id
          firstName
          lastName
          email
          country
          region
          vacationAllowance
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getBankHoliday = /* GraphQL */ `
  query GetBankHoliday($id: ID!) {
    getBankHoliday(id: $id) {
      id
      date
      localName
      countryCode
      counties
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listBankHolidays = /* GraphQL */ `
  query ListBankHolidays(
    $filter: ModelBankHolidayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBankHolidays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        date
        localName
        countryCode
        counties
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
const getClientContracts = /* GraphQL */ `
  query GetClientContracts($id: ID!) {
    getClientContracts(id: $id) {
      id
      clientID
      employeeID
      client {
        id
        company {
          id
          name
          country
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        firstName
        lastName
        email
        inactiveAt
        employees {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyClientsId
        __typename
      }
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const listClientContracts = /* GraphQL */ `
  query ListClientContracts(
    $filter: ModelClientContractsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientContracts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientID
        employeeID
        client {
          id
          firstName
          lastName
          email
          inactiveAt
          createdAt
          updatedAt
          companyClientsId
          __typename
        }
        employee {
          id
          firstName
          lastName
          email
          country
          region
          vacationAllowance
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzylu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listCompaniesWithEmployees", ()=>listCompaniesWithEmployees);
parcelHelpers.export(exports, "listEmployeesWithCompanies", ()=>listEmployeesWithCompanies);
parcelHelpers.export(exports, "listEmployeesWithTimelogs", ()=>listEmployeesWithTimelogs);
parcelHelpers.export(exports, "getEmployeeWithCompany", ()=>getEmployeeWithCompany);
parcelHelpers.export(exports, "listClientsWithTimelogs", ()=>listClientsWithTimelogs);
parcelHelpers.export(exports, "getEmployeeWithAbsences", ()=>getEmployeeWithAbsences);
parcelHelpers.export(exports, "listAbsencesWithEmployees", ()=>listAbsencesWithEmployees);
parcelHelpers.export(exports, "getEmployeeWithTimeInLieus", ()=>getEmployeeWithTimeInLieus);
parcelHelpers.export(exports, "listTimeInLieusWithEmployees", ()=>listTimeInLieusWithEmployees);
const listCompaniesWithEmployees = /* GraphQL */ `
  query ListCompaniesWithEmployees(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        inactiveAt
        country
        clients {
          items {
            id
            firstName
            lastName
            email
            inactiveAt
            employees {
              items {
                id
                clientID
                employeeID
                employee {
                  id
                  firstName
                  lastName
                  email
                  country
                  region
                  vacationAllowance
                }
              }
              nextToken
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
const listEmployeesWithCompanies = /* GraphQL */ `
  query ListEmployeesWithCompanies(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        inactiveAt
        country
        region
        vacationAllowance
        clients {
          items {
            id
            clientID
            employeeID
            client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
            employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
const listEmployeesWithTimelogs = /* GraphQL */ `
  query ListEmployeesWithTimelogs(
    $employeeID: ID = ""
    $limit: Int
    $nextToken: String
    $dateRange: [String] = null
    $logFilter: ModelTimelogFilterInput
    $nextTokenLogs: String
  ) {
    listEmployees(filter: {id: {contains: $employeeID}}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        clients {
          items {
            id
            clientID
            employeeID
            client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
            employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        timelogs(date: {between: $dateRange}, filter: $logFilter, nextToken: $nextTokenLogs) {
          items {
            id
            approved
            onCall
            date
            standard
            overtime
            sick
            holiday
            notes
            clientID
            employeeID
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
const getEmployeeWithCompany = /* GraphQL */ `
  query GetEmployeeWithCompany(
    $id: ID!
    $dateRange: [String] = null
    $filter: ModelTimelogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getEmployee(id: $id) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      clients {
        items {
          id
          clientID
          client {
              id
              firstName
              lastName
              companyClientsId
              company {
                id
                name
                createdAt
                updatedAt
                country
              }
              email
              createdAt
              updatedAt
            }
          employeeID
          employee {
              id
              firstName
              lastName
              email
              country
              region
              vacationAllowance
              createdAt
              updatedAt
            }
          createdAt
          updatedAt
        }
        nextToken
      }
      timelogs(date: {between: $dateRange}, filter: $filter, limit: $limit, nextToken: $nextToken) {
        items {
          id
          approved
          onCall
          date
          standard
          overtime
          sick
          holiday
          notes
          employeeID
          clientID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
const listClientsWithTimelogs = /* GraphQL */ `
query ListClientsWithTimelogs(
  $filter: ModelClientFilterInput
  $employeeID: ID = ""
  $dateRange: [String] = null
) {
  listClients(filter: $filter) {
    items {
      id
      firstName
      lastName
      company {
        name
      }
      timelogs(filter: {and: {approved: {eq: true}, employeeID: {contains: $employeeID}}}, date: {between: $dateRange}) {
        items {
          id
          approved
          onCall
          date
          standard
          overtime
          sick
          holiday
          notes
          employeeID
          clientID
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
}
`;
const getEmployeeWithAbsences = /* GraphQL */ `
query GetEmployeeWithAbsences(
  $id: ID!
  $startDate: [String]!
) {
  getEmployee(id: $id) {
    id
    firstName
    lastName
    email
    country
    region
    vacationAllowance
    inactiveAt
    absences(startDate: {between: $startDate}) {
      items {
        id
        startDate
        endDate
        hoursTaken
        amount
        type
        description
        approvalStatus
        employeeID
        createdAt
        updatedAt
        approvedByClient
        notes
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
const listAbsencesWithEmployees = /* GraphQL */ `
query ListAbsencesWithEmployees(
  $filter: ModelAbsenceFilterInput
  $limit: Int
  $nextToken: String
) {
  listAbsences(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      description
      createdAt
      approvalStatus
      amount
      type
      endDate
      employeeID
      startDate
      hoursTaken
      updatedAt
      employee {
        country
        createdAt
        email
        firstName
        id
        inactiveAt
        lastName
        region
        updatedAt
        vacationAllowance
      }
    }
  }
}
`;
const getEmployeeWithTimeInLieus = /* GraphQL */ `
query GetEmployeeWithTimeInLieus(
  $id: ID!
  $dateTaken: [String]!
) {
  getEmployee(id: $id) {
    id
    firstName
    lastName
    email
    country
    region
    vacationAllowance
    inactiveAt
    timeInLieus(dateTaken: {between: $dateTaken}) {
      items {
        id
        dateEarned
        dateTaken
        hoursTaken
        description
        notes
        approvalStatus
      }
      nextToken
    }
    createdAt
    updatedAt
  }
}
`;
const listTimeInLieusWithEmployees = /* GraphQL */ `
query ListTimeInLieusWithEmployees(
  $filter: ModelTimeInLieuFilterInput
  $limit: Int
  $nextToken: String
) {
  listTimeInLieus(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvalStatus
      employeeID
      employee {
        country
        createdAt
        email
        firstName
        id
        inactiveAt
        lastName
        region
        updatedAt
        vacationAllowance
      }
    }
  }
}
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6gCid":[function(require,module,exports) {
/* tslint:disable */ /* eslint-disable */ // this is an auto generated file. This will be overwritten
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCompany", ()=>createCompany);
parcelHelpers.export(exports, "updateCompany", ()=>updateCompany);
parcelHelpers.export(exports, "deleteCompany", ()=>deleteCompany);
parcelHelpers.export(exports, "createClient", ()=>createClient);
parcelHelpers.export(exports, "updateClient", ()=>updateClient);
parcelHelpers.export(exports, "deleteClient", ()=>deleteClient);
parcelHelpers.export(exports, "createEmployee", ()=>createEmployee);
parcelHelpers.export(exports, "updateEmployee", ()=>updateEmployee);
parcelHelpers.export(exports, "deleteEmployee", ()=>deleteEmployee);
parcelHelpers.export(exports, "createTimelog", ()=>createTimelog);
parcelHelpers.export(exports, "updateTimelog", ()=>updateTimelog);
parcelHelpers.export(exports, "deleteTimelog", ()=>deleteTimelog);
parcelHelpers.export(exports, "createAbsence", ()=>createAbsence);
parcelHelpers.export(exports, "updateAbsence", ()=>updateAbsence);
parcelHelpers.export(exports, "deleteAbsence", ()=>deleteAbsence);
parcelHelpers.export(exports, "createTimeInLieu", ()=>createTimeInLieu);
parcelHelpers.export(exports, "updateTimeInLieu", ()=>updateTimeInLieu);
parcelHelpers.export(exports, "deleteTimeInLieu", ()=>deleteTimeInLieu);
parcelHelpers.export(exports, "createBankHoliday", ()=>createBankHoliday);
parcelHelpers.export(exports, "updateBankHoliday", ()=>updateBankHoliday);
parcelHelpers.export(exports, "deleteBankHoliday", ()=>deleteBankHoliday);
parcelHelpers.export(exports, "createClientContracts", ()=>createClientContracts);
parcelHelpers.export(exports, "updateClientContracts", ()=>updateClientContracts);
parcelHelpers.export(exports, "deleteClientContracts", ()=>deleteClientContracts);
const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      country
      inactiveAt
      clients {
        items {
          id
          firstName
          lastName
          email
          inactiveAt
          createdAt
          updatedAt
          companyClientsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      country
      inactiveAt
      clients {
        items {
          id
          firstName
          lastName
          email
          inactiveAt
          createdAt
          updatedAt
          companyClientsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      country
      inactiveAt
      clients {
        items {
          id
          firstName
          lastName
          email
          inactiveAt
          createdAt
          updatedAt
          companyClientsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      id
      company {
        id
        name
        country
        inactiveAt
        clients {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      firstName
      lastName
      email
      inactiveAt
      employees {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyClientsId
      __typename
    }
  }
`;
const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      id
      company {
        id
        name
        country
        inactiveAt
        clients {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      firstName
      lastName
      email
      inactiveAt
      employees {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyClientsId
      __typename
    }
  }
`;
const deleteClient = /* GraphQL */ `
  mutation DeleteClient(
    $input: DeleteClientInput!
    $condition: ModelClientConditionInput
  ) {
    deleteClient(input: $input, condition: $condition) {
      id
      company {
        id
        name
        country
        inactiveAt
        clients {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      firstName
      lastName
      email
      inactiveAt
      employees {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyClientsId
      __typename
    }
  }
`;
const createEmployee = /* GraphQL */ `
  mutation CreateEmployee(
    $input: CreateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    createEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      inactiveAt
      clients {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      absences {
        items {
          id
          startDate
          endDate
          hoursTaken
          amount
          description
          notes
          type
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timeInLieus {
        items {
          id
          dateEarned
          dateTaken
          hoursTaken
          description
          notes
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateEmployee = /* GraphQL */ `
  mutation UpdateEmployee(
    $input: UpdateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    updateEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      inactiveAt
      clients {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      absences {
        items {
          id
          startDate
          endDate
          hoursTaken
          amount
          description
          notes
          type
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timeInLieus {
        items {
          id
          dateEarned
          dateTaken
          hoursTaken
          description
          notes
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteEmployee = /* GraphQL */ `
  mutation DeleteEmployee(
    $input: DeleteEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    deleteEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      country
      region
      vacationAllowance
      inactiveAt
      clients {
        items {
          id
          clientID
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timelogs {
        items {
          id
          date
          standard
          overtime
          sick
          holiday
          notes
          approved
          onCall
          employeeID
          clientID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      absences {
        items {
          id
          startDate
          endDate
          hoursTaken
          amount
          description
          notes
          type
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      timeInLieus {
        items {
          id
          dateEarned
          dateTaken
          hoursTaken
          description
          notes
          approvedByClient
          approvalStatus
          employeeID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createTimelog = /* GraphQL */ `
  mutation CreateTimelog(
    $input: CreateTimelogInput!
    $condition: ModelTimelogConditionInput
  ) {
    createTimelog(input: $input, condition: $condition) {
      id
      date
      standard
      overtime
      sick
      holiday
      notes
      approved
      onCall
      employeeID
      clientID
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateTimelog = /* GraphQL */ `
  mutation UpdateTimelog(
    $input: UpdateTimelogInput!
    $condition: ModelTimelogConditionInput
  ) {
    updateTimelog(input: $input, condition: $condition) {
      id
      date
      standard
      overtime
      sick
      holiday
      notes
      approved
      onCall
      employeeID
      clientID
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteTimelog = /* GraphQL */ `
  mutation DeleteTimelog(
    $input: DeleteTimelogInput!
    $condition: ModelTimelogConditionInput
  ) {
    deleteTimelog(input: $input, condition: $condition) {
      id
      date
      standard
      overtime
      sick
      holiday
      notes
      approved
      onCall
      employeeID
      clientID
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createAbsence = /* GraphQL */ `
  mutation CreateAbsence(
    $input: CreateAbsenceInput!
    $condition: ModelAbsenceConditionInput
  ) {
    createAbsence(input: $input, condition: $condition) {
      id
      startDate
      endDate
      hoursTaken
      amount
      description
      notes
      type
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateAbsence = /* GraphQL */ `
  mutation UpdateAbsence(
    $input: UpdateAbsenceInput!
    $condition: ModelAbsenceConditionInput
  ) {
    updateAbsence(input: $input, condition: $condition) {
      id
      startDate
      endDate
      hoursTaken
      amount
      description
      notes
      type
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteAbsence = /* GraphQL */ `
  mutation DeleteAbsence(
    $input: DeleteAbsenceInput!
    $condition: ModelAbsenceConditionInput
  ) {
    deleteAbsence(input: $input, condition: $condition) {
      id
      startDate
      endDate
      hoursTaken
      amount
      description
      notes
      type
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createTimeInLieu = /* GraphQL */ `
  mutation CreateTimeInLieu(
    $input: CreateTimeInLieuInput!
    $condition: ModelTimeInLieuConditionInput
  ) {
    createTimeInLieu(input: $input, condition: $condition) {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateTimeInLieu = /* GraphQL */ `
  mutation UpdateTimeInLieu(
    $input: UpdateTimeInLieuInput!
    $condition: ModelTimeInLieuConditionInput
  ) {
    updateTimeInLieu(input: $input, condition: $condition) {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteTimeInLieu = /* GraphQL */ `
  mutation DeleteTimeInLieu(
    $input: DeleteTimeInLieuInput!
    $condition: ModelTimeInLieuConditionInput
  ) {
    deleteTimeInLieu(input: $input, condition: $condition) {
      id
      dateEarned
      dateTaken
      hoursTaken
      description
      notes
      approvedByClient
      approvalStatus
      employeeID
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createBankHoliday = /* GraphQL */ `
  mutation CreateBankHoliday(
    $input: CreateBankHolidayInput!
    $condition: ModelBankHolidayConditionInput
  ) {
    createBankHoliday(input: $input, condition: $condition) {
      id
      date
      localName
      countryCode
      counties
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateBankHoliday = /* GraphQL */ `
  mutation UpdateBankHoliday(
    $input: UpdateBankHolidayInput!
    $condition: ModelBankHolidayConditionInput
  ) {
    updateBankHoliday(input: $input, condition: $condition) {
      id
      date
      localName
      countryCode
      counties
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteBankHoliday = /* GraphQL */ `
  mutation DeleteBankHoliday(
    $input: DeleteBankHolidayInput!
    $condition: ModelBankHolidayConditionInput
  ) {
    deleteBankHoliday(input: $input, condition: $condition) {
      id
      date
      localName
      countryCode
      counties
      createdAt
      updatedAt
      __typename
    }
  }
`;
const createClientContracts = /* GraphQL */ `
  mutation CreateClientContracts(
    $input: CreateClientContractsInput!
    $condition: ModelClientContractsConditionInput
  ) {
    createClientContracts(input: $input, condition: $condition) {
      id
      clientID
      employeeID
      client {
        id
        company {
          id
          name
          country
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        firstName
        lastName
        email
        inactiveAt
        employees {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyClientsId
        __typename
      }
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const updateClientContracts = /* GraphQL */ `
  mutation UpdateClientContracts(
    $input: UpdateClientContractsInput!
    $condition: ModelClientContractsConditionInput
  ) {
    updateClientContracts(input: $input, condition: $condition) {
      id
      clientID
      employeeID
      client {
        id
        company {
          id
          name
          country
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        firstName
        lastName
        email
        inactiveAt
        employees {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyClientsId
        __typename
      }
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
const deleteClientContracts = /* GraphQL */ `
  mutation DeleteClientContracts(
    $input: DeleteClientContractsInput!
    $condition: ModelClientContractsConditionInput
  ) {
    deleteClientContracts(input: $input, condition: $condition) {
      id
      clientID
      employeeID
      client {
        id
        company {
          id
          name
          country
          inactiveAt
          createdAt
          updatedAt
          __typename
        }
        firstName
        lastName
        email
        inactiveAt
        employees {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyClientsId
        __typename
      }
      employee {
        id
        firstName
        lastName
        email
        country
        region
        vacationAllowance
        inactiveAt
        clients {
          nextToken
          __typename
        }
        timelogs {
          nextToken
          __typename
        }
        absences {
          nextToken
          __typename
        }
        timeInLieus {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2zydk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEmployeeLib", ()=>useEmployeeLib);
var _reactQuery = require("@tanstack/react-query");
var _ = require(".");
const useEmployeeLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onSuccess: ()=>queryClient.invalidateQueries([
                "listEmployeesWithCompanies"
            ])
    };
    const { mutateAsync: createEmployee } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createEmployee"
        }),
        ...options
    });
    const { mutateAsync: updateEmployee } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateEmployee"
        }),
        ...options,
        onSettled: (res)=>{
            var _res_data_updateEmployee, _res_data;
            queryClient.invalidateQueries([
                "getEmployeeWithCompany",
                res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : (_res_data_updateEmployee = _res_data.updateEmployee) === null || _res_data_updateEmployee === void 0 ? void 0 : _res_data_updateEmployee.id
            ]);
        }
    });
    const { mutateAsync: deleteEmployee } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteEmployee"
        }),
        ...options
    });
    const { cleanupContracts, moveContracts } = (0, _.useContractsLib)();
    const createEmployeeRecord = async (input, actions, fromRecord)=>{
        createEmployee({
            input
        }, actions);
        if (fromRecord && input.id) migrateRecord(input.id, fromRecord);
    };
    const updateEmployeeRecord = async (input, actions, contracts)=>{
        if ((contracts === null || contracts === void 0 ? void 0 : contracts.length) && !!input.inactiveAt) cleanupContracts({
            id: input.id,
            clientContracts: contracts
        });
        updateEmployee({
            input
        }, actions);
    };
    const migrateRecord = async (id, fromRecord)=>{
        const { id: baseID, clients } = fromRecord;
        const contracts = (await (0, _.filterNull)(clients === null || clients === void 0 ? void 0 : clients.items)).map(({ id })=>id);
        moveContracts(id, contracts);
        deleteEmployee({
            input: {
                id: baseID
            }
        });
    };
    const cleanupEmployeeRecords = async ({ id, clients }, actions)=>{
        var _clients_items;
        if (clients === null || clients === void 0 ? void 0 : clients.items) await cleanupContracts({
            id,
            clientContracts: (_clients_items = clients === null || clients === void 0 ? void 0 : clients.items) !== null && _clients_items !== void 0 ? _clients_items : []
        });
        deleteEmployee({
            input: {
                id
            }
        }, actions);
    };
    return {
        createEmployeeRecord,
        updateEmployeeRecord,
        cleanupEmployeeRecords
    };
};

},{"@tanstack/react-query":"j0XMv",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9oWNa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClient", ()=>useGetClient);
parcelHelpers.export(exports, "useClientLib", ()=>useClientLib);
var _reactQuery = require("@tanstack/react-query");
var _ = require(".");
const useGetClient = (clientIDs)=>{
    const ids = typeof clientIDs === "string" ? [
        clientIDs
    ] : clientIDs;
    return (0, _reactQuery.useQueries)({
        queries: ids.map((id)=>(0, _.gqlQuery)({
                req: "getClient",
                vars: {
                    id
                },
                key: [
                    id
                ]
            }))
    }).flatMap(({ data })=>{
        var _data_data;
        var _data_data_getClient;
        return (_data_data_getClient = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.getClient) !== null && _data_data_getClient !== void 0 ? _data_data_getClient : [];
    });
};
const useClientLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onMutate: async ()=>{
            await queryClient.cancelQueries([
                "listCompaniesWithEmployees"
            ]);
            await queryClient.cancelQueries([
                "listClients"
            ]);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "listCompaniesWithEmployees"
            ]);
            queryClient.invalidateQueries([
                "listClients"
            ]);
        }
    };
    const { mutateAsync: createClient } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createClient"
        }),
        ...options
    });
    const { mutateAsync: updateClient } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateClient"
        }),
        ...options
    });
    const { mutateAsync: deleteClient } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteClient"
        }),
        ...options
    });
    const { cleanupContracts } = (0, _.useContractsLib)();
    const setClientRecords = async ({ id: companyClientsId, clients, removeClients, actions })=>{
        var _actions_onSuccess, _actions_onSettled;
        removeClients.forEach((client)=>cleanupClientRecords(client));
        await Promise.all(// eslint-disable-next-line @typescript-eslint/no-unused-vars
        clients.map(({ employees, clientID: id, ...input })=>id ? updateClient({
                input: {
                    ...input,
                    id,
                    companyClientsId
                }
            }) : createClient({
                input: {
                    ...input,
                    companyClientsId
                }
            })));
        (_actions_onSuccess = actions.onSuccess) === null || _actions_onSuccess === void 0 ? void 0 : _actions_onSuccess.call(actions);
        (_actions_onSettled = actions.onSettled) === null || _actions_onSettled === void 0 ? void 0 : _actions_onSettled.call(actions);
    };
    const cleanupClientRecords = async ({ id, employees })=>{
        var _employees_items;
        await cleanupContracts({
            id,
            clientContracts: (_employees_items = employees === null || employees === void 0 ? void 0 : employees.items) !== null && _employees_items !== void 0 ? _employees_items : []
        });
        return deleteClient({
            input: {
                id
            }
        });
    };
    return {
        setClientRecords,
        cleanupClientRecords
    };
};

},{"@tanstack/react-query":"j0XMv",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"faPnz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useContractsLib", ()=>useContractsLib);
var _reactQuery = require("@tanstack/react-query");
var _ = require(".");
var ContractType;
(function(ContractType) {
    ContractType["CLIENTS"] = "Clients";
    ContractType["EMPLOYEES"] = "Employees";
})(ContractType || (ContractType = {}));
const useContractsLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onMutate: async ()=>{
            await queryClient.cancelQueries([
                "listClientContracts"
            ]);
            await queryClient.cancelQueries([
                "listCompanies"
            ]);
            await queryClient.cancelQueries([
                "listEmployeesWithCompanies"
            ]);
            await queryClient.cancelQueries([
                "listClients"
            ]);
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                "listClientContracts"
            ]);
            queryClient.invalidateQueries([
                "listCompanies"
            ]);
            queryClient.invalidateQueries([
                "listEmployeesWithCompanies"
            ]);
            queryClient.invalidateQueries([
                "listClients"
            ]);
        }
    };
    const { mutateAsync: createContract } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createClientContracts"
        }),
        ...options
    });
    const { mutateAsync: updateContract } = (0, _reactQuery.useMutation)((0, _.gqlMutation)({
        req: "updateClientContracts"
    }));
    const { mutateAsync: deleteContract } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteClientContracts"
        }),
        ...options
    });
    const moveContracts = async (employeeID, contractIDs)=>{
        contractIDs.forEach((id)=>updateContract({
                input: {
                    id,
                    employeeID
                }
            }, {
                onSettled: ()=>{
                    queryClient.invalidateQueries([
                        "getEmployeeWithCompany",
                        employeeID
                    ]);
                }
            }));
    };
    const diffContracts = async ({ assigning, contracts, selected, id })=>assigning === "Clients" ? {
            remove: contracts.filter((item)=>selected.indexOf(item.clientID) === -1),
            create: selected.filter((i)=>contracts.map(({ clientID })=>clientID).indexOf(i) === -1).map((i)=>({
                    clientID: i,
                    employeeID: id
                }))
        } : assigning === "Employees" ? {
            remove: contracts.filter((item)=>selected.indexOf(item.employeeID) === -1),
            create: selected.filter((i)=>contracts.map(({ employeeID })=>employeeID).indexOf(i) === -1).map((i)=>({
                    clientID: id,
                    employeeID: i
                }))
        } : {
            create: [],
            remove: []
        };
    const setContracts = async (data, actions)=>{
        var _actions_onSettled;
        const { create, remove } = await diffContracts(data);
        await Promise.all([
            ...remove.map(async ({ id })=>deleteContract({
                    input: {
                        id
                    }
                })),
            ...create.map(async (input)=>createContract({
                    input
                }))
        ]);
        (_actions_onSettled = actions.onSettled) === null || _actions_onSettled === void 0 ? void 0 : _actions_onSettled.call(actions);
    };
    const cleanupContracts = async ({ id, clientContracts })=>{
        const contracts = await (0, _.filterNull)(clientContracts);
        await setContracts({
            contracts,
            id,
            assigning: "Clients",
            selected: []
        }, {});
    };
    return {
        moveContracts,
        setContracts,
        cleanupContracts
    };
};

},{"@tanstack/react-query":"j0XMv",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j02rn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCompanyLib", ()=>useCompanyLib);
var _reactQuery = require("@tanstack/react-query");
var _ = require(".");
const useCompanyLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onSuccess: ()=>queryClient.invalidateQueries([
                "listCompaniesWithEmployees"
            ])
    };
    const { setClientRecords, cleanupClientRecords } = (0, _.useClientLib)();
    const { cleanupContracts } = (0, _.useContractsLib)();
    const { mutateAsync: createCompany } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createCompany"
        }),
        ...options
    });
    const { mutateAsync: updateCompany } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateCompany"
        }),
        ...options
    });
    const { mutateAsync: deleteCompany } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteCompany"
        }),
        ...options
    });
    const { mutateAsync: updateClient } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateClient"
        }),
        ...options
    });
    const setCompanyInactiveDate = async ({ id, inactiveAt = null, clients = [] }, actions)=>{
        if (!!inactiveAt && !!clients.length) {
            // remove contractors
            await Promise.all((await (0, _.filterNull)(clients)).map(({ id, employees })=>{
                var _employees_items;
                return cleanupContracts({
                    id,
                    clientContracts: (_employees_items = employees === null || employees === void 0 ? void 0 : employees.items) !== null && _employees_items !== void 0 ? _employees_items : []
                });
            }));
            // set all clients to inactive
            await Promise.all(// eslint-disable-next-line @typescript-eslint/no-unused-vars
            clients.map(({ employees, id, companyClientsId, ...input })=>updateClient({
                    input: {
                        ...input,
                        id,
                        companyClientsId,
                        inactiveAt: (0, _.toAWSDate)(inactiveAt)
                    }
                })));
        }
        // set company to active/inactive
        await updateCompany({
            input: {
                id,
                inactiveAt: (0, _.toAWSDate)(inactiveAt)
            }
        }, actions);
    };
    const setCompanyRecords = async ({ id, name, country, ...rest }, actions)=>{
        var _data_updateCompany, _data, _data_createCompany, _data1;
        id = await (id ? (_data = (await updateCompany({
            input: {
                id,
                name,
                country
            }
        })).data) === null || _data === void 0 ? void 0 : (_data_updateCompany = _data.updateCompany) === null || _data_updateCompany === void 0 ? void 0 : _data_updateCompany.id : (_data1 = (await createCompany({
            input: {
                name,
                country
            }
        })).data) === null || _data1 === void 0 ? void 0 : (_data_createCompany = _data1.createCompany) === null || _data_createCompany === void 0 ? void 0 : _data_createCompany.id);
        if (id) setClientRecords({
            ...rest,
            id,
            actions
        });
    };
    const cleanupCompanyRecords = async (company, actions)=>{
        var _company_clients;
        await Promise.all((await (0, _.filterNull)((_company_clients = company.clients) === null || _company_clients === void 0 ? void 0 : _company_clients.items)).map(cleanupClientRecords));
        return deleteCompany({
            input: {
                id: company.id
            }
        }, actions);
    };
    return {
        setCompanyRecords,
        cleanupCompanyRecords,
        setCompanyInactiveDate
    };
};

},{"@tanstack/react-query":"j0XMv",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5pLhQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimelogLib", ()=>useTimelogLib);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _ = require(".");
const useTimelogLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { mutate: createTimelog } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createTimelog"
        }),
        onMutate: async ({ input })=>{
            // Optimistic UI update while API runs
            queryClient.setQueryData([
                "getEmployeeWithCompany",
                input.employeeID,
                input.date
            ], {
                ...input,
                id: "1"
            });
            return {
                input
            };
        },
        onSettled: (res)=>{
            var _res_data_createTimelog, _res_data, _res_data_createTimelog1, _res_data1;
            if (!(res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : (_res_data_createTimelog = _res_data.createTimelog) === null || _res_data_createTimelog === void 0 ? void 0 : _res_data_createTimelog.date)) throw new Error("Interal error: date value undefined");
            const dateKey = (0, _dateFns.startOfWeek)(new Date(res.data.createTimelog.date));
            queryClient.invalidateQueries([
                "getEmployeeWithCompany",
                res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_createTimelog1 = _res_data1.createTimelog) === null || _res_data_createTimelog1 === void 0 ? void 0 : _res_data_createTimelog1.employeeID,
                dateKey
            ]);
            queryClient.invalidateQueries([
                "listTimelogs"
            ]);
        }
    });
    const { mutate: updateTimelog } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateTimelog"
        }),
        onMutate: async ({ input })=>{
            await queryClient.cancelQueries([
                "listEmployeesWithTimelogs"
            ]);
            await queryClient.cancelQueries([
                "listTimelogs"
            ]);
            await queryClient.cancelQueries([
                "getEmployeeWithCompany",
                input.employeeID
            ]);
            return queryClient.getQueryData([
                "getEmployeeWithCompany",
                input.employeeID
            ]);
        },
        onSettled: (res, err, { input }, context)=>{
            if (err) queryClient.setQueryData([
                "getEmployeeWithCompany",
                input.employeeID
            ], context);
            else {
                var _res_data_updateTimelog, _res_data, _res_data_updateTimelog1, _res_data1, _res_data_updateTimelog2, _res_data2;
                if (!(res === null || res === void 0 ? void 0 : (_res_data = res.data) === null || _res_data === void 0 ? void 0 : (_res_data_updateTimelog = _res_data.updateTimelog) === null || _res_data_updateTimelog === void 0 ? void 0 : _res_data_updateTimelog.date)) throw new Error("Interal error: date value undefined");
                const dateKey = (0, _dateFns.startOfWeek)(new Date(res === null || res === void 0 ? void 0 : (_res_data1 = res.data) === null || _res_data1 === void 0 ? void 0 : (_res_data_updateTimelog1 = _res_data1.updateTimelog) === null || _res_data_updateTimelog1 === void 0 ? void 0 : _res_data_updateTimelog1.date));
                queryClient.invalidateQueries([
                    "getEmployeeWithCompany",
                    res === null || res === void 0 ? void 0 : (_res_data2 = res.data) === null || _res_data2 === void 0 ? void 0 : (_res_data_updateTimelog2 = _res_data2.updateTimelog) === null || _res_data_updateTimelog2 === void 0 ? void 0 : _res_data_updateTimelog2.employeeID,
                    dateKey
                ]);
                queryClient.invalidateQueries([
                    "listEmployeesWithTimelogs"
                ]);
                queryClient.invalidateQueries([
                    "listTimelogs"
                ]);
                queryClient.invalidateQueries([
                    "logsByEmployee",
                    dateKey
                ]);
            }
        }
    });
    const { mutateAsync: deleteTimelog } = (0, _reactQuery.useMutation)((0, _.gqlMutation)({
        req: "deleteTimelog"
    }));
    const setTimelogApproval = (logIds, approved, actions)=>{
        logIds.forEach((id)=>updateTimelog({
                input: {
                    id,
                    approved
                }
            }), actions);
    };
    const setTimelogs = ({ id, ...input }, actions)=>{
        input = {
            ...input,
            date: input.date.replace(/\//g, "-")
        };
        id ? updateTimelog({
            input: {
                ...input,
                id,
                approved: null
            }
        }, actions) : createTimelog({
            input
        }, actions);
    };
    const deleteTimelogById = (id)=>deleteTimelog({
            input: {
                id
            }
        });
    return {
        setTimelogApproval,
        setTimelogs,
        deleteTimelogById
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cukMv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAbsenceLib", ()=>useAbsenceLib);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _api = require("../API");
var _ = require(".");
const useAbsenceLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "getEmployeeWithAbsences"
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "listAbsences"
                ]
            });
        }
    };
    const { mutateAsync: createAbsence } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createAbsence"
        }),
        ...options
    });
    const { mutateAsync: updateAbsence } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateAbsence"
        }),
        ...options
    });
    const { mutateAsync: deleteAbsence } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteAbsence"
        }),
        ...options
    });
    const createAbsenceRecord = async (input, actions)=>{
        var _toAWSDate, _toAWSDate1;
        createAbsence({
            input: {
                ...input,
                startDate: (_toAWSDate = (0, _.toAWSDate)(new Date(input.startDate))) !== null && _toAWSDate !== void 0 ? _toAWSDate : "",
                endDate: (_toAWSDate1 = (0, _.toAWSDate)(new Date(input.endDate))) !== null && _toAWSDate1 !== void 0 ? _toAWSDate1 : "",
                approvalStatus: (0, _api.ApprovalStatus).pending
            }
        }, actions);
    };
    const updateAbsenceRecord = async (input, actions)=>{
        updateAbsence({
            input: {
                ...input,
                startDate: input.startDate ? (0, _dateFns.format)((0, _dateFns.parseISO)(input.startDate), "yyyy-MM-dd") : "",
                endDate: input.endDate ? (0, _dateFns.format)((0, _dateFns.parseISO)(input.endDate), "yyyy-MM-dd") : ""
            }
        }, actions);
    };
    const deleteAbsenceRecord = async (id, actions)=>{
        deleteAbsence({
            input: {
                id
            }
        }, actions);
    };
    return {
        createAbsenceRecord,
        updateAbsenceRecord,
        deleteAbsenceRecord
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","../API":"2KRIM",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2KRIM":[function(require,module,exports) {
/* tslint:disable */ /* eslint-disable */ //  This file was automatically generated and should not be edited.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelAttributeTypes", ()=>ModelAttributeTypes);
parcelHelpers.export(exports, "Country", ()=>Country);
parcelHelpers.export(exports, "AbsenceType", ()=>AbsenceType);
parcelHelpers.export(exports, "ApprovalStatus", ()=>ApprovalStatus);
var ModelAttributeTypes;
(function(ModelAttributeTypes) {
    ModelAttributeTypes["binary"] = "binary";
    ModelAttributeTypes["binarySet"] = "binarySet";
    ModelAttributeTypes["bool"] = "bool";
    ModelAttributeTypes["list"] = "list";
    ModelAttributeTypes["map"] = "map";
    ModelAttributeTypes["number"] = "number";
    ModelAttributeTypes["numberSet"] = "numberSet";
    ModelAttributeTypes["string"] = "string";
    ModelAttributeTypes["stringSet"] = "stringSet";
    ModelAttributeTypes["_null"] = "_null";
})(ModelAttributeTypes || (ModelAttributeTypes = {}));
var Country;
(function(Country) {
    Country["GB"] = "GB";
    Country["CA"] = "CA";
    Country["PL"] = "PL";
})(Country || (Country = {}));
var AbsenceType;
(function(AbsenceType) {
    AbsenceType["holiday"] = "holiday";
    AbsenceType["sick"] = "sick";
    AbsenceType["toil"] = "toil";
    AbsenceType["bereavement"] = "bereavement";
    AbsenceType["compassionate"] = "compassionate";
    AbsenceType["emergency"] = "emergency";
    AbsenceType["maternity"] = "maternity";
    AbsenceType["paternity"] = "paternity";
    AbsenceType["timeInLieu"] = "timeInLieu";
    AbsenceType["other"] = "other";
})(AbsenceType || (AbsenceType = {}));
var ApprovalStatus;
(function(ApprovalStatus) {
    ApprovalStatus["pending"] = "pending";
    ApprovalStatus["approved"] = "approved";
    ApprovalStatus["rejected"] = "rejected";
    ApprovalStatus["expired"] = "expired";
})(ApprovalStatus || (ApprovalStatus = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6lKg1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimeInLieuLib", ()=>useTimeInLieuLib);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _api = require("../API");
var _ = require(".");
const useTimeInLieuLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "getEmployeeWithTimeInLieus"
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    "listTimeInLieus"
                ]
            });
        }
    };
    const { mutateAsync: createTimeInLieu } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createTimeInLieu"
        }),
        ...options
    });
    const { mutateAsync: updateTimeInLieu } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateTimeInLieu"
        }),
        ...options
    });
    const { mutateAsync: deleteTimeInLieu } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteTimeInLieu"
        }),
        ...options
    });
    const createTimeInLieuRecord = async (input, actions)=>{
        var _input_dateTaken;
        createTimeInLieu({
            input: {
                ...input,
                dateTaken: (0, _.toAWSDate)(new Date((_input_dateTaken = input.dateTaken) !== null && _input_dateTaken !== void 0 ? _input_dateTaken : "")),
                approvalStatus: (0, _api.ApprovalStatus).pending
            }
        }, actions);
    };
    const updateTimeInLieuRecord = async (input, actions)=>{
        updateTimeInLieu({
            input: {
                ...input,
                dateTaken: input.dateTaken ? (0, _dateFns.format)((0, _dateFns.parseISO)(input.dateTaken), "yyyy-MM-dd") : ""
            }
        }, actions);
    };
    const deleteTimeInLieuRecord = async (id, actions)=>{
        deleteTimeInLieu({
            input: {
                id
            }
        }, actions);
    };
    return {
        createTimeInLieuRecord,
        updateTimeInLieuRecord,
        deleteTimeInLieuRecord
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","../API":"2KRIM",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6sKQ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBankHolidayLib", ()=>useBankHolidayLib);
var _reactQuery = require("@tanstack/react-query");
var _ = require(".");
const useBankHolidayLib = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const options = {
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "listBankHolidays"
                ]
            });
        }
    };
    const { mutateAsync: createBankHoliday } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "createBankHoliday"
        }),
        ...options
    });
    const { mutateAsync: updateBankHoliday } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "updateBankHoliday"
        }),
        ...options
    });
    const { mutateAsync: deleteBankHoliday } = (0, _reactQuery.useMutation)({
        ...(0, _.gqlMutation)({
            req: "deleteBankHoliday"
        }),
        ...options
    });
    const createBankHolidayRecord = async (input, actions)=>{
        var _input_date;
        const awsDate = (0, _.toAWSDate)(new Date((_input_date = input.date) !== null && _input_date !== void 0 ? _input_date : ""));
        if (!awsDate) return;
        createBankHoliday({
            input: {
                ...input,
                date: awsDate
            }
        }, actions);
    };
    const updateBankHolidayRecord = async (input, actions)=>{
        var _input_date;
        const awsDate = (0, _.toAWSDate)(new Date((_input_date = input.date) !== null && _input_date !== void 0 ? _input_date : ""));
        if (!awsDate) return;
        updateBankHoliday({
            input: {
                ...input,
                date: awsDate
            }
        }, actions);
    };
    const deleteBankHolidayRecord = async (id, actions)=>{
        deleteBankHoliday({
            input: {
                id
            }
        }, actions);
    };
    return {
        createBankHolidayRecord,
        updateBankHolidayRecord,
        deleteBankHolidayRecord
    };
};

},{"@tanstack/react-query":"j0XMv",".":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2QLpi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HourCategories", ()=>HourCategories);
parcelHelpers.export(exports, "toIntervalString", ()=>toIntervalString);
parcelHelpers.export(exports, "toDbDates", ()=>toDbDates);
parcelHelpers.export(exports, "filterNull", ()=>filterNull);
parcelHelpers.export(exports, "getCompanyClientIDs", ()=>getCompanyClientIDs);
parcelHelpers.export(exports, "checkIfIsBefore", ()=>checkIfIsBefore);
parcelHelpers.export(exports, "toAWSDate", ()=>toAWSDate);
parcelHelpers.export(exports, "getBusinessDayDifference", ()=>getBusinessDayDifference);
parcelHelpers.export(exports, "mapOptions", ()=>mapOptions);
parcelHelpers.export(exports, "countryOptions", ()=>countryOptions);
parcelHelpers.export(exports, "formatHoursChange", ()=>formatHoursChange);
parcelHelpers.export(exports, "parseDate", ()=>parseDate);
var _dateFns = require("date-fns");
var _api = require("../API");
var _apiService = require("./apiService");
var HourCategories;
(function(HourCategories) {
    HourCategories["standard"] = "standard";
    HourCategories["overtime"] = "overtime";
    HourCategories["sick"] = "sick";
    HourCategories["holiday"] = "holiday";
})(HourCategories || (HourCategories = {}));
const toIntervalString = ({ start, end }, limiter = " - ")=>`${(0, _dateFns.format)(start, "dd/MM/yyyy")}${limiter}${(0, _dateFns.format)(end, "dd/MM/yyyy")}`;
const toDbDates = ({ start, end })=>[
        start,
        end
    ].map((date)=>(0, _dateFns.toDate)(date).toLocaleDateString("sv"));
const filterNull = async (arr, exFilter)=>exFilter === undefined ? (arr !== null && arr !== void 0 ? arr : []).filter((i)=>i !== null) : (arr !== null && arr !== void 0 ? arr : []).filter((i)=>i !== null).filter(exFilter);
const getCompanyClientIDs = (id)=>{
    const { queryFn: getCompany, ...rest } = (0, _apiService.gqlQuery)({
        req: "getCompany",
        vars: {
            id
        },
        key: [
            id
        ]
    });
    return {
        ...rest,
        enabled: !!id,
        queryFn: async ()=>{
            var _data_getCompany_clients, _data_getCompany, _data_getCompany1;
            const { data } = await getCompany();
            const ids = await filterNull(data === null || data === void 0 ? void 0 : (_data_getCompany = data.getCompany) === null || _data_getCompany === void 0 ? void 0 : (_data_getCompany_clients = _data_getCompany.clients) === null || _data_getCompany_clients === void 0 ? void 0 : _data_getCompany_clients.items);
            return {
                name: data === null || data === void 0 ? void 0 : (_data_getCompany1 = data.getCompany) === null || _data_getCompany1 === void 0 ? void 0 : _data_getCompany1.name,
                clientFilter: ids.length ? {
                    or: ids.map(({ id })=>({
                            clientID: {
                                contains: id
                            }
                        }))
                } : undefined
            };
        }
    };
};
const checkIfIsBefore = (inputDate, interval, duration)=>{
    // Calculate the interval to subtract from today's date
    const intervalObject = {
        [duration]: interval
    };
    const intervalAgo = (0, _dateFns.sub)(new Date(), intervalObject);
    // Check if the date is before the interval ago date
    return (0, _dateFns.isBefore)(inputDate, intervalAgo);
};
const toAWSDate = (date)=>date ? (0, _dateFns.format)(date, "yyyy-MM-dd") : null;
const getBusinessDayDifference = (startDate, endDate)=>{
    if (startDate > endDate) throw new Error("Start date must be before or equal to the end date.");
    let count = 0;
    const currentDate = new Date(startDate);
    while(currentDate <= endDate){
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) // Exclude Sundays (0) and Saturdays (6)
        count++;
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return count;
};
const mapOptions = (values)=>{
    if (values) return Object.keys(values).map((key)=>({
            label: values[key],
            value: key
        }));
    return [];
};
const countryOptions = [
    {
        label: "All Countries",
        value: "",
        disabled: true,
        key: ""
    },
    ...Object.values((0, _api.Country)).map((type)=>({
            label: type,
            value: type,
            key: type
        }))
];
const formatHoursChange = (value, limit = 24)=>{
    if (value === null || value === undefined) return 0;
    const numberValue = Number(value);
    if (isNaN(numberValue)) return 0;
    return numberValue > limit ? limit : numberValue < 0 ? 0 : numberValue;
};
const parseDate = (dateString)=>{
    const dt = new Date(dateString);
    const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60000);
    return dtDateOnly;
};

},{"date-fns":"5Pdd3","../API":"2KRIM","./apiService":"8qcsE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lRmxX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lnhPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datePicker = require("./DatePicker");
parcelHelpers.exportAll(_datePicker, exports);
var _weekPicker = require("./WeekPicker");
parcelHelpers.exportAll(_weekPicker, exports);
var _rangePicker = require("./RangePicker");
parcelHelpers.exportAll(_rangePicker, exports);
var _yearPicker = require("./YearPicker");
parcelHelpers.exportAll(_yearPicker, exports);
var _controlledRangePicker = require("./ControlledRangePicker");
parcelHelpers.exportAll(_controlledRangePicker, exports);

},{"./DatePicker":"zPeK4","./WeekPicker":"3v5JA","./RangePicker":"29HMt","./YearPicker":"7bcn1","./ControlledRangePicker":"evppP","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"zPeK4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
const DatePicker = ({ label = "Select Date", ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
            ...rest,
            label: label,
            renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TextField), {
                    ...params,
                    variant: "outlined",
                    inputProps: {
                        ...params.inputProps,
                        readOnly: true
                    },
                    InputLabelProps: {
                        shrink: true
                    },
                    margin: "dense",
                    size: "small"
                })
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/x-date-pickers":"lcIJt","@mui/x-date-pickers/AdapterDateFns":"1X56V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lcIJt":[function(require,module,exports) {
/** @license MUI X v5.0.20
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerStaticWrapper", ()=>(0, _pickerStaticWrapper.PickerStaticWrapper));
var _calendarPicker = require("./CalendarPicker");
parcelHelpers.exportAll(_calendarPicker, exports);
var _calendarPickerSkeleton = require("./CalendarPickerSkeleton");
parcelHelpers.exportAll(_calendarPickerSkeleton, exports);
var _clockPicker = require("./ClockPicker");
parcelHelpers.exportAll(_clockPicker, exports);
var _datePicker = require("./DatePicker");
parcelHelpers.exportAll(_datePicker, exports);
var _dateTimePicker = require("./DateTimePicker");
parcelHelpers.exportAll(_dateTimePicker, exports);
var _desktopDatePicker = require("./DesktopDatePicker");
parcelHelpers.exportAll(_desktopDatePicker, exports);
var _desktopDateTimePicker = require("./DesktopDateTimePicker");
parcelHelpers.exportAll(_desktopDateTimePicker, exports);
var _desktopTimePicker = require("./DesktopTimePicker");
parcelHelpers.exportAll(_desktopTimePicker, exports);
var _localizationProvider = require("./LocalizationProvider");
parcelHelpers.exportAll(_localizationProvider, exports);
var _mobileDatePicker = require("./MobileDatePicker");
parcelHelpers.exportAll(_mobileDatePicker, exports);
var _mobileDateTimePicker = require("./MobileDateTimePicker");
parcelHelpers.exportAll(_mobileDateTimePicker, exports);
var _mobileTimePicker = require("./MobileTimePicker");
parcelHelpers.exportAll(_mobileTimePicker, exports);
var _monthPicker = require("./MonthPicker");
parcelHelpers.exportAll(_monthPicker, exports);
var _pickersDay = require("./PickersDay");
parcelHelpers.exportAll(_pickersDay, exports);
var _staticDatePicker = require("./StaticDatePicker");
parcelHelpers.exportAll(_staticDatePicker, exports);
var _staticDateTimePicker = require("./StaticDateTimePicker");
parcelHelpers.exportAll(_staticDateTimePicker, exports);
var _staticTimePicker = require("./StaticTimePicker");
parcelHelpers.exportAll(_staticTimePicker, exports);
var _timePicker = require("./TimePicker");
parcelHelpers.exportAll(_timePicker, exports);
var _yearPicker = require("./YearPicker");
parcelHelpers.exportAll(_yearPicker, exports);
var _locales = require("./locales");
parcelHelpers.exportAll(_locales, exports);
var _pickerStaticWrapper = require("./internals/components/PickerStaticWrapper");

},{"./CalendarPicker":false,"./CalendarPickerSkeleton":false,"./ClockPicker":false,"./DatePicker":"e4ZBm","./DateTimePicker":false,"./DesktopDatePicker":false,"./DesktopDateTimePicker":false,"./DesktopTimePicker":false,"./LocalizationProvider":"gnhuS","./MobileDatePicker":false,"./MobileDateTimePicker":false,"./MobileTimePicker":false,"./MonthPicker":false,"./PickersDay":"dylFK","./StaticDatePicker":false,"./StaticDateTimePicker":false,"./StaticTimePicker":false,"./TimePicker":false,"./YearPicker":false,"./locales":false,"./internals/components/PickerStaticWrapper":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e4ZBm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePicker.DatePicker));
parcelHelpers.export(exports, "datePickerToolbarClasses", ()=>(0, _datePickerToolbarClasses.datePickerToolbarClasses));
var _datePicker = require("./DatePicker");
var _datePickerToolbarClasses = require("./datePickerToolbarClasses");

},{"./DatePicker":"k8jCZ","./datePickerToolbarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k8jCZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", ()=>DatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _desktopDatePicker = require("../DesktopDatePicker");
var _mobileDatePicker = require("../MobileDatePicker");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "desktopModeMediaQuery",
    "DialogProps",
    "PopperProps",
    "TransitionComponent"
];
const DatePicker = /*#__PURE__*/ _react.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiDatePicker"
    });
    const { desktopModeMediaQuery = "@media (pointer: fine)", DialogProps, PopperProps, TransitionComponent } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded); // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, _useMediaQueryDefault.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _desktopDatePicker.DesktopDatePicker), (0, _extendsDefault.default)({
        ref: ref,
        PopperProps: PopperProps,
        TransitionComponent: TransitionComponent
    }, other));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileDatePicker.MobileDatePicker), (0, _extendsDefault.default)({
        ref: ref,
        DialogProps: DialogProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/material/styles":"gNR9m","@mui/material/useMediaQuery":"kV0D0","prop-types":"3KNJy","../DesktopDatePicker":"eM4qf","../MobileDatePicker":"bpZXk","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eM4qf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDatePicker", ()=>(0, _desktopDatePicker.DesktopDatePicker));
var _desktopDatePicker = require("./DesktopDatePicker");

},{"./DesktopDatePicker":"4vzSG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4vzSG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopDatePicker", ()=>DesktopDatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _shared = require("../DatePicker/shared");
var _datePickerToolbar = require("../DatePicker/DatePickerToolbar");
var _desktopWrapper = require("../internals/components/wrappers/DesktopWrapper");
var _calendarOrClockPicker = require("../internals/components/CalendarOrClockPicker");
var _useDateValidation = require("../internals/hooks/validation/useDateValidation");
var _keyboardDateInput = require("../internals/components/KeyboardDateInput");
var _usePickerState = require("../internals/hooks/usePickerState");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onChange",
    "PopperProps",
    "PaperProps",
    "ToolbarComponent",
    "TransitionComponent",
    "value",
    "components",
    "componentsProps"
];
const DesktopDatePicker = /*#__PURE__*/ _react.forwardRef(function DesktopDatePicker(inProps, ref) {
    const props = (0, _shared.useDatePickerDefaultizedProps)(inProps, "MuiDesktopDatePicker");
    const validationError = (0, _useDateValidation.useDateValidation)(props) !== null;
    const { pickerProps, inputProps, wrapperProps } = (0, _usePickerState.usePickerState)(props, (0, _shared.datePickerValueManager));
    const { PopperProps, PaperProps, ToolbarComponent = (0, _datePickerToolbar.DatePickerToolbar), TransitionComponent, components, componentsProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const AllDateInputProps = (0, _extendsDefault.default)({}, inputProps, other, {
        components,
        componentsProps,
        ref,
        validationError
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _desktopWrapper.DesktopWrapper), (0, _extendsDefault.default)({}, wrapperProps, {
        DateInputProps: AllDateInputProps,
        KeyboardDateInputComponent: (0, _keyboardDateInput.KeyboardDateInput),
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        TransitionComponent: TransitionComponent,
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarOrClockPicker.CalendarOrClockPicker), (0, _extendsDefault.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: AllDateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","../DatePicker/shared":"fKBw7","../DatePicker/DatePickerToolbar":"1kVoE","../internals/components/wrappers/DesktopWrapper":"fmJ4o","../internals/components/CalendarOrClockPicker":"gHmss","../internals/hooks/validation/useDateValidation":"hI2Vz","../internals/components/KeyboardDateInput":"j1qIC","../internals/hooks/usePickerState":"9CIcQ","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fKBw7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isYearOnlyView", ()=>isYearOnlyView);
parcelHelpers.export(exports, "isYearAndMonthViews", ()=>isYearAndMonthViews);
parcelHelpers.export(exports, "useDatePickerDefaultizedProps", ()=>useDatePickerDefaultizedProps);
parcelHelpers.export(exports, "datePickerValueManager", ()=>datePickerValueManager);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _styles = require("@mui/material/styles");
var _useUtils = require("../internals/hooks/useUtils");
var _dateUtils = require("../internals/utils/date-utils");
const isYearOnlyView = (views)=>views.length === 1 && views[0] === "year";
const isYearAndMonthViews = (views)=>views.length === 2 && views.indexOf("month") !== -1 && views.indexOf("year") !== -1;
const getFormatAndMaskByViews = (views, utils)=>{
    if (isYearOnlyView(views)) return {
        inputFormat: utils.formats.year
    };
    if (isYearAndMonthViews(views)) return {
        disableMaskedInput: true,
        inputFormat: utils.formats.monthAndYear
    };
    return {
        inputFormat: utils.formats.keyboardDate
    };
};
function useDatePickerDefaultizedProps(props, name) {
    var _themeProps$views;
    const utils = (0, _useUtils.useUtils)();
    const defaultDates = (0, _useUtils.useDefaultDates)(); // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const views = (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
        "year",
        "day"
    ];
    return (0, _extendsDefault.default)({
        openTo: "day",
        disableFuture: false,
        disablePast: false
    }, getFormatAndMaskByViews(views, utils), themeProps, {
        views,
        minDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const datePickerValueManager = {
    emptyValue: null,
    getTodayValue: (utils)=>utils.date(),
    parseInput: (0, _dateUtils.parsePickerInputValue),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b)
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/material/styles":"gNR9m","../internals/hooks/useUtils":"8WF4c","../internals/utils/date-utils":"1bf5u","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8WF4c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocalizationContext", ()=>useLocalizationContext);
parcelHelpers.export(exports, "useUtils", ()=>useUtils);
parcelHelpers.export(exports, "useDefaultDates", ()=>useDefaultDates);
parcelHelpers.export(exports, "useLocaleText", ()=>useLocaleText);
parcelHelpers.export(exports, "useNow", ()=>useNow);
var _react = require("react");
var _localizationProvider = require("../../LocalizationProvider/LocalizationProvider");
const useLocalizationContext = ()=>{
    const localization = _react.useContext((0, _localizationProvider.MuiPickersAdapterContext));
    if (localization === null) throw new Error("MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.");
    return localization;
};
const useUtils = ()=>useLocalizationContext().utils;
const useDefaultDates = ()=>useLocalizationContext().defaultDates;
const useLocaleText = ()=>useLocalizationContext().localeText;
const useNow = ()=>{
    const utils = useUtils();
    const now = _react.useRef(utils.date());
    return now.current;
};

},{"react":"gVheC","../../LocalizationProvider/LocalizationProvider":"kngq7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kngq7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiPickersAdapterContext", ()=>MuiPickersAdapterContext);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "LocalizationProvider", ()=>LocalizationProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _locales = require("../locales");
var _jsxRuntime = require("react/jsx-runtime");
const MuiPickersAdapterContext = /*#__PURE__*/ _react.createContext(null);
let warnedOnce = false;
function LocalizationProvider(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiLocalizationProvider"
    });
    const { children, dateAdapter: Utils, dateFormats, dateLibInstance, locale, adapterLocale, localeText } = props;
    const utils = _react.useMemo(()=>new Utils({
            locale: adapterLocale != null ? adapterLocale : locale,
            formats: dateFormats,
            instance: dateLibInstance
        }), [
        Utils,
        locale,
        adapterLocale,
        dateFormats,
        dateLibInstance
    ]);
    const defaultDates = _react.useMemo(()=>{
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = _react.useMemo(()=>{
        return {
            utils,
            defaultDates,
            localeText: (0, _extendsDefault.default)({}, (0, _locales.DEFAULT_LOCALE), localeText != null ? localeText : {})
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MuiPickersAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material/styles":"gNR9m","../locales":"lA04K","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lA04K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nlNL = require("./nlNL");
parcelHelpers.exportAll(_nlNL, exports);
var _plPL = require("./plPL");
parcelHelpers.exportAll(_plPL, exports);
var _ptBR = require("./ptBR");
parcelHelpers.exportAll(_ptBR, exports);
var _trTR = require("./trTR");
parcelHelpers.exportAll(_trTR, exports);
var _deDE = require("./deDE");
parcelHelpers.exportAll(_deDE, exports);
var _esES = require("./esES");
parcelHelpers.exportAll(_esES, exports);
var _faIR = require("./faIR");
parcelHelpers.exportAll(_faIR, exports);
var _fiFI = require("./fiFI");
parcelHelpers.exportAll(_fiFI, exports);
var _csCZ = require("./csCZ");
parcelHelpers.exportAll(_csCZ, exports);
var _frFR = require("./frFR");
parcelHelpers.exportAll(_frFR, exports);
var _huHU = require("./huHU");
parcelHelpers.exportAll(_huHU, exports);
var _enUS = require("./enUS");
parcelHelpers.exportAll(_enUS, exports);
var _nbNO = require("./nbNO");
parcelHelpers.exportAll(_nbNO, exports);
var _svSE = require("./svSE");
parcelHelpers.exportAll(_svSE, exports);
var _itIT = require("./itIT");
parcelHelpers.exportAll(_itIT, exports);
var _zhCN = require("./zhCN");
parcelHelpers.exportAll(_zhCN, exports);
var _koKR = require("./koKR");
parcelHelpers.exportAll(_koKR, exports);
var _isIS = require("./isIS");
parcelHelpers.exportAll(_isIS, exports);
var _jaJP = require("./jaJP");
parcelHelpers.exportAll(_jaJP, exports);
var _ukUA = require("./ukUA");
parcelHelpers.exportAll(_ukUA, exports);
var _urPK = require("./urPK");
parcelHelpers.exportAll(_urPK, exports);
var _beBY = require("./beBY");
parcelHelpers.exportAll(_beBY, exports);
var _ruRU = require("./ruRU");
parcelHelpers.exportAll(_ruRU, exports);
var _pickersLocaleTextApi = require("./utils/pickersLocaleTextApi");
parcelHelpers.exportAll(_pickersLocaleTextApi, exports);

},{"./nlNL":false,"./plPL":false,"./ptBR":false,"./trTR":false,"./deDE":false,"./esES":false,"./faIR":false,"./fiFI":false,"./csCZ":false,"./frFR":false,"./huHU":false,"./enUS":"eR9wF","./nbNO":false,"./svSE":false,"./itIT":false,"./zhCN":false,"./koKR":false,"./isIS":false,"./jaJP":false,"./ukUA":false,"./urPK":false,"./beBY":false,"./ruRU":false,"./utils/pickersLocaleTextApi":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eR9wF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_LOCALE", ()=>DEFAULT_LOCALE);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _getPickersLocalization = require("./utils/getPickersLocalization"); // This object is not Partial<PickersLocaleText> because it is the default values
const enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "open previous view",
    openNextView: "open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    inputModeToggleButtonAriaLabel: (isKeyboardInputOpen, viewType)=>isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`,
    // DateRange placeholders
    start: "Start",
    end: "End",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerDefaultToolbarTitle: "Select date",
    dateTimePickerDefaultToolbarTitle: "Select date & time",
    timePickerDefaultToolbarTitle: "Select time",
    dateRangePickerDefaultToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Open picker labels
    openDatePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), "fullDate")}` : "Choose date",
    openTimePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose time, selected time is ${utils.format(utils.date(rawValue), "fullTime")}` : "Choose time",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date"
};
const DEFAULT_LOCALE = enUSPickers;
const enUS = (0, _getPickersLocalization.getPickersLocalization)(enUSPickers);

},{"./utils/getPickersLocalization":"l9HKB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9HKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersLocalization", ()=>getPickersLocalization);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const getPickersLocalization = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, _extendsDefault.default)({}, pickersTranslations)
                }
            }
        }
    };
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1bf5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findClosestEnabledDate", ()=>findClosestEnabledDate);
parcelHelpers.export(exports, "parsePickerInputValue", ()=>parsePickerInputValue);
parcelHelpers.export(exports, "parseNonNullablePickerDate", ()=>parseNonNullablePickerDate);
const findClosestEnabledDate = ({ date, disableFuture, disablePast, maxDate, minDate, isDateDisabled, utils })=>{
    const today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const parsePickerInputValue = (utils, value)=>{
    const parsedValue = utils.date(value);
    return utils.isValid(parsedValue) ? parsedValue : null;
};
const parseNonNullablePickerDate = (utils, value, defaultValue)=>{
    if (value == null) return defaultValue;
    const parsedValue = utils.date(value);
    const isDateValid = utils.isValid(parsedValue);
    if (isDateValid) return parsedValue;
    return defaultValue;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1kVoE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePickerToolbar", ()=>DatePickerToolbar);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _pickersToolbar = require("../internals/components/PickersToolbar");
var _useUtils = require("../internals/hooks/useUtils");
var _shared = require("./shared");
var _datePickerToolbarClasses = require("./datePickerToolbarClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "parsedValue",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "toggleMobileKeyboardView",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        title: [
            "title"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _datePickerToolbarClasses.getDatePickerToolbarUtilityClass), classes);
};
const DatePickerToolbarRoot = (0, _styles.styled)((0, _pickersToolbar.PickersToolbar), {
    name: "MuiDatePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const DatePickerToolbarTitle = (0, _styles.styled)((0, _typographyDefault.default), {
    name: "MuiDatePickerToolbar",
    slot: "Title",
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.isLandscape && {
        margin: "auto 16px auto auto"
    }));
const DatePickerToolbar = /*#__PURE__*/ _react.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiDatePickerToolbar"
    });
    const { parsedValue, isLandscape, isMobileKeyboardViewOpen, toggleMobileKeyboardView, toolbarFormat, toolbarPlaceholder = "\u2013\u2013", toolbarTitle: toolbarTitleProp, views } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const utils = (0, _useUtils.useUtils)();
    const localeText = (0, _useUtils.useLocaleText)();
    const classes = useUtilityClasses(props);
    const toolbarTitle = toolbarTitleProp != null ? toolbarTitleProp : localeText.datePickerDefaultToolbarTitle;
    const dateText = _react.useMemo(()=>{
        if (!parsedValue) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(parsedValue, toolbarFormat);
        if ((0, _shared.isYearOnlyView)(views)) return utils.format(parsedValue, "year");
        if ((0, _shared.isYearAndMonthViews)(views)) return utils.format(parsedValue, "month");
         // Little localization hack (Google is doing the same for android native pickers):
        // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
        // For other locales using strings like "June 1", without weekday.
        return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(parsedValue, "normalDateWithWeekday") : utils.format(parsedValue, "normalDate");
    }, [
        parsedValue,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarRoot, (0, _extendsDefault.default)({
        ref: ref,
        toolbarTitle: toolbarTitle,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? "left" : "center",
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/Typography":"1Chqm","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../internals/components/PickersToolbar":"36jNQ","../internals/hooks/useUtils":"8WF4c","./shared":"fKBw7","./datePickerToolbarClasses":"eWaB2","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"36jNQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersToolbar", ()=>PickersToolbar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _icons = require("./icons");
var _useUtils = require("../hooks/useUtils");
var _pickersToolbarClasses = require("./pickersToolbarClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersToolbarClasses.getPickersToolbarUtilityClass), classes);
};
const PickersToolbarRoot = (0, _styles.styled)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: "auto",
        maxWidth: 160,
        padding: 16,
        justifyContent: "flex-start",
        flexWrap: "wrap"
    }));
const PickersToolbarContent = (0, _styles.styled)((0, _gridDefault.default), {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState })=>(0, _extendsDefault.default)({
        flex: 1
    }, !ownerState.isLandscape && {
        alignItems: "center"
    }));
const PickersToolbarPenIconButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: "MuiPickersToolbar",
    slot: "PenIconButton",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, _pickersToolbarClasses.pickersToolbarClasses).penIconButtonLandscape}`]: styles.penIconButtonLandscape
            },
            styles.penIconButton
        ]
})({});
const getViewTypeIcon = (viewType)=>viewType === "clock" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.Clock), {
        color: "inherit"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.Calendar), {
        color: "inherit"
    });
const PickersToolbar = /*#__PURE__*/ _react.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children, className, getMobileKeyboardInputViewButtonText, isLandscape, isMobileKeyboardViewOpen, landscapeDirection = "column", toggleMobileKeyboardView, toolbarTitle, viewType = "calendar" } = props;
    const ownerState = props;
    const localeText = (0, _useUtils.useLocaleText)();
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersToolbarRoot, {
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "text.secondary",
                variant: "overline",
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersToolbarContent, {
                container: true,
                justifyContent: "space-between",
                className: classes.content,
                ownerState: ownerState,
                direction: isLandscape ? landscapeDirection : "row",
                alignItems: isLandscape ? "flex-start" : "flex-end",
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarPenIconButton, {
                        onClick: toggleMobileKeyboardView,
                        className: classes.penIconButton,
                        ownerState: ownerState,
                        color: "inherit",
                        "aria-label": getMobileKeyboardInputViewButtonText ? getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType) : localeText.inputModeToggleButtonAriaLabel(isMobileKeyboardViewOpen, viewType),
                        children: isMobileKeyboardViewOpen ? getViewTypeIcon(viewType) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.Pen), {
                            color: "inherit"
                        })
                    })
                ]
            })
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/Grid":"j00I5","@mui/material/Typography":"1Chqm","@mui/material/IconButton":"6bnps","@mui/material/styles":"gNR9m","@mui/material":"iknXc","./icons":"eS3zj","../hooks/useUtils":"8WF4c","./pickersToolbarClasses":"3iZ9N","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kSfZD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eS3zj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrowDropDown", ()=>ArrowDropDown);
parcelHelpers.export(exports, "ArrowLeft", ()=>ArrowLeft);
parcelHelpers.export(exports, "ArrowRight", ()=>ArrowRight);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "Clock", ()=>Clock);
parcelHelpers.export(exports, "DateRange", ()=>DateRange);
parcelHelpers.export(exports, "Pen", ()=>Pen);
parcelHelpers.export(exports, "Time", ()=>Time);
var _utils = require("@mui/material/utils");
var _react = require("react");
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
const ArrowDropDown = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const ArrowLeft = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const ArrowRight = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const Calendar = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const Clock = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const DateRange = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const Pen = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Pen");
const Time = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");

},{"@mui/material/utils":"ziQFX","react":"gVheC","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3iZ9N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersToolbarUtilityClass", ()=>getPickersToolbarUtilityClass);
parcelHelpers.export(exports, "pickersToolbarClasses", ()=>pickersToolbarClasses);
var _material = require("@mui/material");
function getPickersToolbarUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiPickersToolbar", slot);
}
const pickersToolbarClasses = (0, _material.generateUtilityClasses)("MuiPickersToolbar", [
    "root",
    "content",
    "penIconButton",
    "penIconButtonLandscape"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eWaB2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDatePickerToolbarUtilityClass", ()=>getDatePickerToolbarUtilityClass);
parcelHelpers.export(exports, "datePickerToolbarClasses", ()=>datePickerToolbarClasses);
var _material = require("@mui/material");
function getDatePickerToolbarUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiDatePickerToolbar", slot);
}
const datePickerToolbarClasses = (0, _material.generateUtilityClasses)("MuiDatePickerToolbar", [
    "root",
    "title"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fmJ4o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesktopWrapper", ()=>DesktopWrapper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _wrapperVariantContext = require("./WrapperVariantContext");
var _pickersPopper = require("../PickersPopper");
var _jsxRuntime = require("react/jsx-runtime");
function DesktopWrapper(props) {
    const { children, DateInputProps, KeyboardDateInputComponent, onClear, onDismiss, onCancel, onAccept, onSetToday, open, PopperProps, PaperProps, TransitionComponent, components, componentsProps } = props;
    const ownInputRef = _react.useRef(null);
    const inputRef = (0, _utils.useForkRef)(DateInputProps.inputRef, ownInputRef);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperVariantContext.WrapperVariantContext).Provider, {
        value: "desktop",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(KeyboardDateInputComponent, (0, _extendsDefault.default)({}, DateInputProps, {
                inputRef: inputRef
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersPopper.PickersPopper), {
                role: "dialog",
                open: open,
                anchorEl: ownInputRef.current,
                TransitionComponent: TransitionComponent,
                PopperProps: PopperProps,
                PaperProps: PaperProps,
                onClose: onDismiss,
                onCancel: onCancel,
                onClear: onClear,
                onAccept: onAccept,
                onSetToday: onSetToday,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","./WrapperVariantContext":"fM3I2","../PickersPopper":"cw16x","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fM3I2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WrapperVariantContext", ()=>WrapperVariantContext);
var _react = require("react");
const WrapperVariantContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cw16x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersPopper", ()=>PickersPopper);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _grow = require("@mui/material/Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _unstableTrapFocus = require("@mui/material/Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _pickersActionBar = require("../../PickersActionBar");
var _pickersPopperClasses = require("./pickersPopperClasses");
var _utils1 = require("../utils/utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onClick",
    "onTouchStart"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersPopperClasses.getPickersPopperUtilityClass), classes);
};
const PickersPopperRoot = (0, _styles.styled)((0, _popperDefault.default), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const PickersPopperPaper = (0, _styles.styled)((0, _paperDefault.default), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState })=>(0, _extendsDefault.default)({
        transformOrigin: "top center",
        outline: 0
    }, ownerState.placement === "top" && {
        transformOrigin: "bottom center"
    }));
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function useClickAwayListener(active, onClickAway) {
    const movedRef = _react.useRef(false);
    const syntheticEventRef = _react.useRef(false);
    const nodeRef = _react.useRef(null);
    const activatedRef = _react.useRef(false);
    _react.useEffect(()=>{
        if (!active) return undefined;
         // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _utils.useEventCallback)((event)=>{
        if (!activatedRef.current) return;
         // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _utils.ownerDocument)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    _react.useEffect(()=>{
        if (active) {
            const doc = (0, _utils.ownerDocument)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    _react.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, _utils.ownerDocument)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway); // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
function PickersPopper(inProps) {
    var _components$ActionBar;
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl, children, containerRef = null, onBlur, onClose, onClear, onAccept, onCancel, onSetToday, open, PopperProps, role, TransitionComponent = (0, _growDefault.default), TrapFocusProps, PaperProps = {}, components, componentsProps } = props;
    _react.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (open && (nativeEvent.key === "Escape" || nativeEvent.key === "Esc")) onClose();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onClose,
        open
    ]);
    const lastFocusedElementRef = _react.useRef(null);
    _react.useEffect(()=>{
        if (role === "tooltip") return;
        if (open) lastFocusedElementRef.current = (0, _utils1.getActiveElement)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, onBlur != null ? onBlur : onClose);
    const paperRef = _react.useRef(null);
    const handleRef = (0, _utils.useForkRef)(paperRef, containerRef);
    const handlePaperRef = (0, _utils.useForkRef)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const { onClick: onPaperClickProp, onTouchStart: onPaperTouchStartProp } = PaperProps, otherPaperProps = (0, _objectWithoutPropertiesLooseDefault.default)(PaperProps, _excluded);
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onClose();
        }
    };
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, _pickersActionBar.PickersActionBar);
    const PaperContent = (components == null ? void 0 : components.PaperContent) || _react.Fragment;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersPopperRoot, (0, _extendsDefault.default)({
        transition: true,
        role: role,
        open: open,
        anchorEl: anchorEl,
        onKeyDown: handleKeyDown,
        className: classes.root
    }, PopperProps, {
        children: ({ TransitionProps, placement })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableTrapFocusDefault.default), (0, _extendsDefault.default)({
                open: open,
                disableAutoFocus: true // pickers are managing focus position manually
                ,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, TrapFocusProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({}, TransitionProps, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersPopperPaper, (0, _extendsDefault.default)({
                        tabIndex: -1,
                        elevation: 8,
                        ref: handlePaperRef,
                        onClick: (event)=>{
                            onPaperClick(event);
                            if (onPaperClickProp) onPaperClickProp(event);
                        },
                        onTouchStart: (event)=>{
                            onPaperTouchStart(event);
                            if (onPaperTouchStartProp) onPaperTouchStartProp(event);
                        },
                        ownerState: (0, _extendsDefault.default)({}, ownerState, {
                            placement
                        }),
                        className: classes.paper
                    }, otherPaperProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaperContent, (0, _extendsDefault.default)({}, componentsProps == null ? void 0 : componentsProps.paperContent, {
                            children: [
                                children,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBar, (0, _extendsDefault.default)({
                                    onAccept: onAccept,
                                    onClear: onClear,
                                    onCancel: onCancel,
                                    onSetToday: onSetToday,
                                    actions: []
                                }, componentsProps == null ? void 0 : componentsProps.actionBar))
                            ]
                        }))
                    }))
                }))
            }))
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/Grow":"eBM9D","@mui/material/Paper":"4qOeF","@mui/material/Popper":"2EAIq","@mui/material/Unstable_TrapFocus":"kxC5X","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../PickersActionBar":"9eqrR","./pickersPopperClasses":"jvQpP","../utils/utils":"jDQRM","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9eqrR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersActionBar", ()=>(0, _pickersActionBar.PickersActionBar));
var _pickersActionBar = require("./PickersActionBar");

},{"./PickersActionBar":"eefi8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eefi8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersActionBar", ()=>PickersActionBar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _useUtils = require("../internals/hooks/useUtils");
var _wrapperVariantContext = require("../internals/components/wrappers/WrapperVariantContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
const PickersActionBar = (props)=>{
    const { onAccept, onClear, onCancel, onSetToday, actions } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const wrapperVariant = _react.useContext((0, _wrapperVariantContext.WrapperVariantContext));
    const localeText = (0, _useUtils.useLocaleText)();
    const actionsArray = typeof actions === "function" ? actions(wrapperVariant) : actions;
    if (actionsArray == null || actionsArray.length === 0) return null;
    const buttons = actionsArray == null ? void 0 : actionsArray.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), (0, _extendsDefault.default)({}, other, {
        children: buttons
    }));
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/material/Button":"6pu9h","@mui/material/DialogActions":"2DBqh","../internals/hooks/useUtils":"8WF4c","../internals/components/wrappers/WrapperVariantContext":"fM3I2","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jvQpP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersPopperUtilityClass", ()=>getPickersPopperUtilityClass);
parcelHelpers.export(exports, "pickersPopperClasses", ()=>pickersPopperClasses);
var _material = require("@mui/material");
function getPickersPopperUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiPickersPopper", slot);
}
const pickersPopperClasses = (0, _material.generateUtilityClasses)("MuiPickersPopper", [
    "root",
    "paper"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jDQRM":[function(require,module,exports) {
/* Use it instead of .includes method for IE support */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayIncludes", ()=>arrayIncludes);
parcelHelpers.export(exports, "onSpaceOrEnter", ()=>onSpaceOrEnter);
parcelHelpers.export(exports, "executeInTheNextEventLoopTick", ()=>executeInTheNextEventLoopTick);
parcelHelpers.export(exports, "doNothing", ()=>doNothing);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
function arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const onSpaceOrEnter = (innerFn, onFocus)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event); // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (onFocus) onFocus(event);
    };
const executeInTheNextEventLoopTick = (fn)=>{
    setTimeout(fn, 0);
};
const doNothing = ()=>{}; // https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return getActiveElement(activeEl.shadowRoot);
    return activeEl;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gHmss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarOrClockPicker", ()=>(0, _calendarOrClockPicker.CalendarOrClockPicker));
var _calendarOrClockPicker = require("./CalendarOrClockPicker");

},{"./CalendarOrClockPicker":"dtl43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dtl43":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileKeyboardInputView", ()=>MobileKeyboardInputView);
parcelHelpers.export(exports, "CalendarOrClockPicker", ()=>CalendarOrClockPicker);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _useViews = require("../../hooks/useViews");
var _clockPicker = require("../../../ClockPicker/ClockPicker");
var _calendarPicker = require("../../../CalendarPicker/CalendarPicker");
var _keyboardDateInput = require("../KeyboardDateInput");
var _useIsLandscape = require("../../hooks/useIsLandscape");
var _wrapperVariantContext = require("../wrappers/WrapperVariantContext");
var _pickerViewRoot = require("../PickerViewRoot");
var _useFocusManagement = require("./useFocusManagement");
var _calendarOrClockPickerClasses = require("./calendarOrClockPickerClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "className",
    "parsedValue",
    "DateInputProps",
    "isMobileKeyboardViewOpen",
    "onDateChange",
    "onViewChange",
    "openTo",
    "orientation",
    "showToolbar",
    "toggleMobileKeyboardView",
    "ToolbarComponent",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views",
    "dateRangeIcon",
    "timeIcon",
    "hideTabs",
    "classes"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        mobileKeyboardInputView: [
            "mobileKeyboardInputView"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _calendarOrClockPickerClasses.getCalendarOrClockPickerUtilityClass), classes);
};
const MobileKeyboardInputView = (0, _styles.styled)("div", {
    name: "MuiCalendarOrClockPicker",
    slot: "MobileKeyboardInputView",
    overridesResolver: (_, styles)=>styles.mobileKeyboardInputView
})({
    padding: "16px 24px"
});
const PickerRoot = (0, _styles.styled)("div", {
    name: "MuiCalendarOrClockPicker",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "column"
    }, ownerState.isLandscape && {
        flexDirection: "row"
    }));
const MobileKeyboardTextFieldProps = {
    fullWidth: true
};
const isDatePickerView = (view)=>view === "year" || view === "month" || view === "day";
const isTimePickerView = (view)=>view === "hours" || view === "minutes" || view === "seconds";
let warnedOnceNotValidOpenTo = false;
function CalendarOrClockPicker(inProps) {
    var _other$components, _other$componentsProp;
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiCalendarOrClockPicker"
    });
    const { autoFocus, parsedValue, DateInputProps, isMobileKeyboardViewOpen, onDateChange, onViewChange, openTo, orientation, showToolbar, toggleMobileKeyboardView, ToolbarComponent = ()=>null, toolbarFormat, toolbarPlaceholder, toolbarTitle, views, dateRangeIcon, timeIcon, hideTabs } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const TabsComponent = (_other$components = other.components) == null ? void 0 : _other$components.Tabs;
    const isLandscape = (0, _useIsLandscape.useIsLandscape)(views, orientation);
    const wrapperVariant = _react.useContext((0, _wrapperVariantContext.WrapperVariantContext));
    const classes = useUtilityClasses(props);
    const toShowToolbar = showToolbar != null ? showToolbar : wrapperVariant !== "desktop";
    const showTabs = !hideTabs && typeof window !== "undefined" && window.innerHeight > 667;
    const handleDateChange = _react.useCallback((newDate, selectionState)=>{
        onDateChange(newDate, wrapperVariant, selectionState);
    }, [
        onDateChange,
        wrapperVariant
    ]);
    const handleViewChange = _react.useCallback((newView)=>{
        if (isMobileKeyboardViewOpen) toggleMobileKeyboardView();
        if (onViewChange) onViewChange(newView);
    }, [
        isMobileKeyboardViewOpen,
        onViewChange,
        toggleMobileKeyboardView
    ]);
    const { openView, setOpenView, handleChangeAndOpenNext } = (0, _useViews.useViews)({
        view: undefined,
        views,
        openTo,
        onChange: handleDateChange,
        onViewChange: handleViewChange
    });
    const { focusedView, setFocusedView } = (0, _useFocusManagement.useFocusManagement)({
        autoFocus,
        openView
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickerRoot, {
        ownerState: {
            isLandscape
        },
        className: classes.root,
        children: [
            toShowToolbar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToolbarComponent, (0, _extendsDefault.default)({}, other, {
                views: views,
                isLandscape: isLandscape,
                parsedValue: parsedValue,
                onChange: handleDateChange,
                setOpenView: setOpenView,
                openView: openView,
                toolbarTitle: toolbarTitle,
                toolbarFormat: toolbarFormat,
                toolbarPlaceholder: toolbarPlaceholder,
                isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
                toggleMobileKeyboardView: toggleMobileKeyboardView
            })),
            showTabs && !!TabsComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsComponent, (0, _extendsDefault.default)({
                dateRangeIcon: dateRangeIcon,
                timeIcon: timeIcon,
                view: openView,
                onChange: setOpenView
            }, (_other$componentsProp = other.componentsProps) == null ? void 0 : _other$componentsProp.tabs)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickerViewRoot.PickerViewRoot), {
                children: isMobileKeyboardViewOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileKeyboardInputView, {
                    className: classes.mobileKeyboardInputView,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardDateInput.KeyboardDateInput), (0, _extendsDefault.default)({}, DateInputProps, {
                        ignoreInvalidInputs: true,
                        disableOpenPicker: true,
                        TextFieldProps: MobileKeyboardTextFieldProps
                    }))
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        isDatePickerView(openView) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPicker.CalendarPicker), (0, _extendsDefault.default)({
                            autoFocus: autoFocus,
                            date: parsedValue,
                            onViewChange: setOpenView,
                            onChange: handleChangeAndOpenNext,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter(isDatePickerView),
                            focusedView: focusedView,
                            onFocusedViewChange: setFocusedView
                        }, other)),
                        isTimePickerView(openView) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockPicker.ClockPicker), (0, _extendsDefault.default)({}, other, {
                            autoFocus: autoFocus,
                            date: parsedValue,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter(isTimePickerView),
                            onChange: handleChangeAndOpenNext,
                            onViewChange: setOpenView,
                            showViewSwitcher: wrapperVariant === "desktop"
                        }))
                    ]
                })
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../hooks/useViews":"82888","../../../ClockPicker/ClockPicker":"cDAOo","../../../CalendarPicker/CalendarPicker":"bY0fK","../KeyboardDateInput":"j1qIC","../../hooks/useIsLandscape":"4htX0","../wrappers/WrapperVariantContext":"fM3I2","../PickerViewRoot":"61D5A","./useFocusManagement":"4Hcti","./calendarOrClockPickerClasses":"aSdFm","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"82888":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useViews", ()=>useViews);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _utils1 = require("../utils/utils");
function useViews({ onChange, onViewChange, openTo, view, views }) {
    var _views, _views2;
    const [openView, setOpenView] = (0, _utils.useControlled)({
        name: "Picker",
        state: "view",
        controlled: view,
        default: openTo && (0, _utils1.arrayIncludes)(views, openTo) ? openTo : views[0]
    });
    const previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
    const nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
    const changeView = _react.useCallback((newView)=>{
        setOpenView(newView);
        if (onViewChange) onViewChange(newView);
    }, [
        setOpenView,
        onViewChange
    ]);
    const openNext = _react.useCallback(()=>{
        if (nextView) changeView(nextView);
    }, [
        nextView,
        changeView
    ]);
    const handleChangeAndOpenNext = _react.useCallback((date, currentViewSelectionState)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? "partial" : currentViewSelectionState;
        onChange(date, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) openNext();
    }, [
        nextView,
        onChange,
        openNext
    ]);
    return {
        handleChangeAndOpenNext,
        nextView,
        previousView,
        openNext,
        openView,
        setOpenView: changeView
    };
}

},{"react":"gVheC","@mui/material/utils":"ziQFX","../utils/utils":"jDQRM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cDAOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClockPicker", ()=>ClockPicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _clock = require("./Clock");
var _useUtils = require("../internals/hooks/useUtils");
var _warning = require("../internals/utils/warning");
var _clockNumbers = require("./ClockNumbers");
var _pickersArrowSwitcher = require("../internals/components/PickersArrowSwitcher");
var _timeUtils = require("../internals/utils/time-utils");
var _useViews = require("../internals/hooks/useViews");
var _dateHelpersHooks = require("../internals/hooks/date-helpers-hooks");
var _clockPickerClasses = require("./clockPickerClasses");
var _pickerViewRoot = require("../internals/components/PickerViewRoot");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _clockPickerClasses.getClockPickerUtilityClass), classes);
};
const ClockPickerRoot = (0, _styles.styled)((0, _pickerViewRoot.PickerViewRoot), {
    name: "MuiClockPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column"
});
const ClockPickerArrowSwitcher = (0, _styles.styled)((0, _pickersArrowSwitcher.PickersArrowSwitcher), {
    name: "MuiClockPicker",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const deprecatedPropsWarning = (0, _warning.buildDeprecatedPropsWarning)("Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.");
const ClockPicker = /*#__PURE__*/ _react.forwardRef(function ClockPicker(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiClockPicker"
    });
    const { ampm = false, ampmInClock = false, autoFocus, components, componentsProps, date, disableIgnoringDatePartForTimeValidation, getClockLabelText: getClockLabelTextProp, getHoursClockNumberText: getHoursClockNumberTextProp, getMinutesClockNumberText: getMinutesClockNumberTextProp, getSecondsClockNumberText: getSecondsClockNumberTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxTime, minTime, minutesStep = 1, rightArrowButtonText: rightArrowButtonTextProp, shouldDisableTime, showViewSwitcher, onChange, view, views = [
        "hours",
        "minutes"
    ], openTo, onViewChange, className, disabled, readOnly } = props;
    deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getClockLabelText: getClockLabelTextProp,
        getHoursClockNumberText: getHoursClockNumberTextProp,
        getMinutesClockNumberText: getMinutesClockNumberTextProp,
        getSecondsClockNumberText: getSecondsClockNumberTextProp
    });
    const localeText = (0, _useUtils.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.openPreviousView;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.openNextView;
    const getClockLabelText = getClockLabelTextProp != null ? getClockLabelTextProp : localeText.clockLabelText;
    const getHoursClockNumberText = getHoursClockNumberTextProp != null ? getHoursClockNumberTextProp : localeText.hoursClockNumberText;
    const getMinutesClockNumberText = getMinutesClockNumberTextProp != null ? getMinutesClockNumberTextProp : localeText.minutesClockNumberText;
    const getSecondsClockNumberText = getSecondsClockNumberTextProp != null ? getSecondsClockNumberTextProp : localeText.secondsClockNumberText;
    const { openView, setOpenView, nextView, previousView, handleChangeAndOpenNext } = (0, _useViews.useViews)({
        view,
        views,
        openTo,
        onViewChange,
        onChange
    });
    const now = (0, _useUtils.useNow)();
    const utils = (0, _useUtils.useUtils)();
    const dateOrMidnight = _react.useMemo(()=>date || utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0), [
        date,
        now,
        utils
    ]);
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooks.useMeridiemMode)(dateOrMidnight, ampm, handleChangeAndOpenNext);
    const isTimeDisabled = _react.useCallback((rawValue, viewType)=>{
        const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            return true;
        };
        const isValidValue = (value, step = 1)=>{
            if (value % step !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(value, viewType);
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const value = (0, _timeUtils.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(dateOrMidnight, value);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(value);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(dateOrMidnight, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(dateOrMidnight, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        dateOrMidnight,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils
    ]);
    const selectedId = (0, _utils.unstable_useId)();
    const viewProps = _react.useMemo(()=>{
        switch(openView){
            case "hours":
                {
                    const handleHoursChange = (value, isFinish)=>{
                        const valueWithMeridiem = (0, _timeUtils.convertValueToMeridiem)(value, meridiemMode, ampm);
                        handleChangeAndOpenNext(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        value: utils.getHours(dateOrMidnight),
                        children: (0, _clockNumbers.getHourNumbers)({
                            date,
                            utils,
                            ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: getHoursClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "hours"),
                            selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(dateOrMidnight);
                    const handleMinutesChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setMinutes(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, _clockNumbers.getMinutesNumbers)({
                            utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: getMinutesClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "minutes"),
                            selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(dateOrMidnight);
                    const handleSecondsChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setSeconds(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, _clockNumbers.getMinutesNumbers)({
                            utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: getSecondsClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, "seconds"),
                            selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        openView,
        utils,
        date,
        ampm,
        getHoursClockNumberText,
        getMinutesClockNumberText,
        getSecondsClockNumberText,
        meridiemMode,
        handleChangeAndOpenNext,
        dateOrMidnight,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockPickerRoot, {
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            showViewSwitcher && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPickerArrowSwitcher, {
                className: classes.arrowSwitcher,
                leftArrowButtonText: leftArrowButtonText,
                rightArrowButtonText: rightArrowButtonText,
                components: components,
                componentsProps: componentsProps,
                onLeftClick: ()=>setOpenView(previousView),
                onRightClick: ()=>setOpenView(nextView),
                isLeftDisabled: !previousView,
                isRightDisabled: !nextView,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clock.Clock), (0, _extendsDefault.default)({
                autoFocus: autoFocus,
                date: date,
                ampmInClock: ampmInClock,
                type: openView,
                ampm: ampm,
                getClockLabelText: getClockLabelText,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps))
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","prop-types":"3KNJy","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","@mui/material":"iknXc","./Clock":"1ORvd","../internals/hooks/useUtils":"8WF4c","../internals/utils/warning":"daxax","./ClockNumbers":"9KbN3","../internals/components/PickersArrowSwitcher":"3N38m","../internals/utils/time-utils":"3qD4h","../internals/hooks/useViews":"82888","../internals/hooks/date-helpers-hooks":"hgT9v","./clockPickerClasses":"7JBIQ","../internals/components/PickerViewRoot":"61D5A","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ORvd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "Clock", ()=>Clock);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _utils = require("@mui/utils");
var _clockPointer = require("./ClockPointer");
var _useUtils = require("../internals/hooks/useUtils");
var _wrapperVariantContext = require("../internals/components/wrappers/WrapperVariantContext");
var _shared = require("./shared");
var _clockClasses = require("./clockClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton"
        ],
        pmButton: [
            "pmButton"
        ]
    };
    return (0, _utils.unstable_composeClasses)(slots, (0, _clockClasses.getClockUtilityClass), classes);
};
const ClockRoot = (0, _styles.styled)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const ClockClock = (0, _styles.styled)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const ClockWrapper = (0, _styles.styled)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const ClockSquareMask = (0, _styles.styled)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: "100%",
        height: "100%",
        position: "absolute",
        pointerEvents: "auto",
        outline: 0,
        // Disable scroll capabilities.
        touchAction: "none",
        userSelect: "none"
    }, ownerState.disabled ? {} : {
        "@media (pointer: fine)": {
            cursor: "pointer",
            borderRadius: "50%"
        },
        "&:active": {
            cursor: "move"
        }
    }));
const ClockPin = (0, _styles.styled)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const ClockAmButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        zIndex: 1,
        position: "absolute",
        bottom: ownerState.ampmInClock ? 64 : 8,
        left: 8
    }, ownerState.meridiemMode === "am" && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        }
    }));
const ClockPmButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        zIndex: 1,
        position: "absolute",
        bottom: ownerState.ampmInClock ? 64 : 8,
        right: 8
    }, ownerState.meridiemMode === "pm" && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        }
    }));
function Clock(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm, ampmInClock, autoFocus, children, date, getClockLabelText, handleMeridiemChange, isTimeDisabled, meridiemMode, minutesStep = 1, onChange, selectedId, type, value, disabled, readOnly, className } = props;
    const ownerState = props;
    const utils = (0, _useUtils.useUtils)();
    const wrapperVariant = _react.useContext((0, _wrapperVariantContext.WrapperVariantContext));
    const isMoving = _react.useRef(false);
    const classes = useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(value, type);
    const isPointerInner = !ampm && type === "hours" && (value < 1 || value > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX, offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, _shared.getMinutes)(offsetX, offsetY, minutesStep) : (0, _shared.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = _react.useMemo(()=>{
        if (type === "hours") return true;
        return value % 5 === 0;
    }, [
        type,
        value
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = _react.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // annulate both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(value + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(value - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockRoot, {
        className: (0, _clsxDefault.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPin, {
                                className: classes.pin
                            }),
                            date && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockPointer.ClockPointer), {
                                type: type,
                                value: value,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": getClockLabelText(type, date, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && (wrapperVariant === "desktop" || ampmInClock) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "caption",
                            children: "AM"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "caption",
                            children: "PM"
                        })
                    })
                ]
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/IconButton":"6bnps","@mui/material/Typography":"1Chqm","@mui/material/styles":"gNR9m","@mui/utils":"dv12b","./ClockPointer":"2NfqJ","../internals/hooks/useUtils":"8WF4c","../internals/components/wrappers/WrapperVariantContext":"fM3I2","./shared":"bGLNm","./clockClasses":"1EfUe","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2NfqJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "ClockPointer", ()=>ClockPointer);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _shared = require("./shared");
var _clockPointerClasses = require("./clockPointerClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _clockPointerClasses.getClockPointerUtilityClass), classes);
};
const ClockPointerRoot = (0, _styles.styled)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        width: 2,
        backgroundColor: theme.palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px"
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            "transform",
            "height"
        ])
    }));
const ClockPointerThumb = (0, _styles.styled)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        width: 4,
        height: 4,
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, _shared.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, _shared.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${theme.palette.primary.main}`,
        boxSizing: "content-box"
    }, ownerState.hasSelected && {
        backgroundColor: theme.palette.primary.main
    }));
function ClockPointer(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className, isInner, type, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const previousType = _react.useRef(type);
    _react.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * value;
        if (type === "hours" && value > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, _shared.CLOCK_WIDTH)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerRoot, (0, _extendsDefault.default)({
        style: getAngleStyle(),
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/styles":"gNR9m","@mui/material":"iknXc","./shared":"bGLNm","./clockPointerClasses":"lzwH0","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bGLNm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOCK_WIDTH", ()=>CLOCK_WIDTH);
parcelHelpers.export(exports, "CLOCK_HOUR_WIDTH", ()=>CLOCK_HOUR_WIDTH);
parcelHelpers.export(exports, "getMinutes", ()=>getMinutes);
parcelHelpers.export(exports, "getHours", ()=>getHours);
const CLOCK_WIDTH = 220;
const CLOCK_HOUR_WIDTH = 36;
const clockCenter = {
    x: CLOCK_WIDTH / 2,
    y: CLOCK_WIDTH / 2
};
const baseClockPoint = {
    x: clockCenter.x,
    y: 0
};
const cx = baseClockPoint.x - clockCenter.x;
const cy = baseClockPoint.y - clockCenter.y;
const rad2deg = (rad)=>rad * (180 / Math.PI);
const getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - clockCenter.x;
    const y = offsetY - clockCenter.y;
    const atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    let deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value,
        distance
    };
};
const getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value } = getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const getHours = (offsetX, offsetY, ampm)=>{
    const { value, distance } = getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lzwH0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockPointerUtilityClass", ()=>getClockPointerUtilityClass);
parcelHelpers.export(exports, "clockPointerClasses", ()=>clockPointerClasses);
var _material = require("@mui/material");
function getClockPointerUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiClockPointer", slot);
}
const clockPointerClasses = (0, _material.generateUtilityClasses)("MuiClockPointer", [
    "root",
    "thumb"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1EfUe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockUtilityClass", ()=>getClockUtilityClass);
parcelHelpers.export(exports, "clockClasses", ()=>clockClasses);
var _material = require("@mui/material");
function getClockUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiClock", slot);
}
const clockClasses = (0, _material.generateUtilityClasses)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"daxax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildDeprecatedPropsWarning", ()=>buildDeprecatedPropsWarning);
const buildDeprecatedPropsWarning = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9KbN3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHourNumbers", ()=>getHourNumbers);
parcelHelpers.export(exports, "getMinutesNumbers", ()=>getMinutesNumbers);
var _react = require("react");
var _clockNumber = require("./ClockNumber");
var _jsxRuntime = require("react/jsx-runtime");
const getHourNumbers = ({ ampm, date, getClockNumberText, isDisabled, selectedId, utils })=>{
    const currentHours = date ? utils.getHours(date) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockNumber.ClockNumber), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const getMinutesNumbers = ({ utils, value, isDisabled, getClockNumberText, selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockNumber.ClockNumber), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

},{"react":"gVheC","./ClockNumber":"k1alG","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k1alG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal component.
 */ parcelHelpers.export(exports, "ClockNumber", ()=>ClockNumber);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _shared = require("./shared");
var _clockNumberClasses = require("./clockNumberClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, selected, disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _clockNumberClasses.getClockNumberUtilityClass), classes);
};
const ClockNumberRoot = (0, _styles.styled)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, _clockNumberClasses.clockNumberClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, _clockNumberClasses.clockNumberClasses).selected}`]: styles.selected
            }
        ]
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        height: (0, _shared.CLOCK_HOUR_WIDTH),
        width: (0, _shared.CLOCK_HOUR_WIDTH),
        position: "absolute",
        left: `calc((100% - ${(0, _shared.CLOCK_HOUR_WIDTH)}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: theme.palette.background.paper
        },
        [`&.${(0, _clockNumberClasses.clockNumberClasses).selected}`]: {
            color: theme.palette.primary.contrastText
        },
        [`&.${(0, _clockNumberClasses.clockNumberClasses).disabled}`]: {
            pointerEvents: "none",
            color: theme.palette.text.disabled
        }
    }, ownerState.inner && (0, _extendsDefault.default)({}, theme.typography.body2, {
        color: theme.palette.text.secondary
    })));
function ClockNumber(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className, disabled, index, inner, label, selected } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, _shared.CLOCK_WIDTH) - (0, _shared.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockNumberRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, _shared.CLOCK_WIDTH) - (0, _shared.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/styles":"gNR9m","@mui/material":"iknXc","./shared":"bGLNm","./clockNumberClasses":"e38IF","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e38IF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockNumberUtilityClass", ()=>getClockNumberUtilityClass);
parcelHelpers.export(exports, "clockNumberClasses", ()=>clockNumberClasses);
var _material = require("@mui/material");
function getClockNumberUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiClockNumber", slot);
}
const clockNumberClasses = (0, _material.generateUtilityClasses)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3N38m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersArrowSwitcher", ()=>PickersArrowSwitcher);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _icons = require("./icons");
var _pickersArrowSwitcherClasses = require("./pickersArrowSwitcherClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "components",
    "componentsProps",
    "isLeftDisabled",
    "isLeftHidden",
    "isRightDisabled",
    "isRightHidden",
    "leftArrowButtonText",
    "onLeftClick",
    "onRightClick",
    "rightArrowButtonText"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersArrowSwitcherClasses.getPickersArrowSwitcherUtilityClass), classes);
};
const PickersArrowSwitcherRoot = (0, _styles.styled)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const PickersArrowSwitcherSpacer = (0, _styles.styled)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme })=>({
        width: theme.spacing(3)
    }));
const PickersArrowSwitcherButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.hidden && {
        visibility: "hidden"
    }));
const PickersArrowSwitcher = /*#__PURE__*/ _react.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children, className, components, componentsProps, isLeftDisabled, isLeftHidden, isRightDisabled, isRightHidden, leftArrowButtonText, onLeftClick, onRightClick, rightArrowButtonText } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const theme = (0, _styles.useTheme)();
    const isRtl = theme.direction === "rtl";
    const leftArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.leftArrowButton) || {};
    const LeftArrowIcon = (components == null ? void 0 : components.LeftArrowIcon) || (0, _icons.ArrowLeft);
    const rightArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.rightArrowButton) || {};
    const RightArrowIcon = (components == null ? void 0 : components.RightArrowIcon) || (0, _icons.ArrowRight);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersArrowSwitcherRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersArrowSwitcherButton, (0, _extendsDefault.default)({
                as: components == null ? void 0 : components.LeftArrowButton,
                size: "small",
                "aria-label": leftArrowButtonText,
                title: leftArrowButtonText,
                disabled: isLeftDisabled,
                edge: "end",
                onClick: onLeftClick
            }, leftArrowButtonProps, {
                className: (0, _clsxDefault.default)(classes.button, leftArrowButtonProps.className),
                ownerState: (0, _extendsDefault.default)({}, ownerState, leftArrowButtonProps, {
                    hidden: isLeftHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, {})
            })),
            children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersArrowSwitcherButton, (0, _extendsDefault.default)({
                as: components == null ? void 0 : components.RightArrowButton,
                size: "small",
                "aria-label": rightArrowButtonText,
                title: rightArrowButtonText,
                edge: "start",
                disabled: isRightDisabled,
                onClick: onRightClick
            }, rightArrowButtonProps, {
                className: (0, _clsxDefault.default)(classes.button, rightArrowButtonProps.className),
                ownerState: (0, _extendsDefault.default)({}, ownerState, rightArrowButtonProps, {
                    hidden: isRightHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, {})
            }))
        ]
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/Typography":"1Chqm","@mui/material/styles":"gNR9m","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","./icons":"eS3zj","./pickersArrowSwitcherClasses":"6N4te","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6N4te":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersArrowSwitcherUtilityClass", ()=>getPickersArrowSwitcherUtilityClass);
parcelHelpers.export(exports, "pickersArrowSwitcherClasses", ()=>pickersArrowSwitcherClasses);
var _material = require("@mui/material");
function getPickersArrowSwitcherUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiPickersArrowSwitcher", slot);
}
const pickersArrowSwitcherClasses = (0, _material.generateUtilityClasses)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3qD4h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMeridiem", ()=>getMeridiem);
parcelHelpers.export(exports, "convertValueToMeridiem", ()=>convertValueToMeridiem);
parcelHelpers.export(exports, "convertToMeridiem", ()=>convertToMeridiem);
parcelHelpers.export(exports, "getSecondsInDay", ()=>getSecondsInDay);
parcelHelpers.export(exports, "createIsAfterIgnoreDatePart", ()=>createIsAfterIgnoreDatePart);
const getMeridiem = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const convertToMeridiem = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const getSecondsInDay = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation = false, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hgT9v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNextMonthDisabled", ()=>useNextMonthDisabled);
parcelHelpers.export(exports, "usePreviousMonthDisabled", ()=>usePreviousMonthDisabled);
parcelHelpers.export(exports, "useMeridiemMode", ()=>useMeridiemMode);
var _react = require("react");
var _useUtils = require("./useUtils");
var _timeUtils = require("../utils/time-utils");
function useNextMonthDisabled(month, { disableFuture, maxDate }) {
    const utils = (0, _useUtils.useUtils)();
    return _react.useMemo(()=>{
        const now = utils.date();
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils
    ]);
}
function usePreviousMonthDisabled(month, { disablePast, minDate }) {
    const utils = (0, _useUtils.useUtils)();
    return _react.useMemo(()=>{
        const now = utils.date();
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils
    ]);
}
function useMeridiemMode(date, ampm, onChange) {
    const utils = (0, _useUtils.useUtils)();
    const meridiemMode = (0, _timeUtils.getMeridiem)(date, utils);
    const handleMeridiemChange = _react.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, _timeUtils.convertToMeridiem)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, "partial");
    }, [
        ampm,
        date,
        onChange,
        utils
    ]);
    return {
        meridiemMode,
        handleMeridiemChange
    };
}

},{"react":"gVheC","./useUtils":"8WF4c","../utils/time-utils":"3qD4h","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7JBIQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClockPickerUtilityClass", ()=>getClockPickerUtilityClass);
parcelHelpers.export(exports, "clockPickerClasses", ()=>clockPickerClasses);
var _material = require("@mui/material");
function getClockPickerUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiClockPicker", slot);
}
const clockPickerClasses = (0, _material.generateUtilityClasses)("MuiClockPicker", [
    "root",
    "arrowSwitcher"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"61D5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerViewRoot", ()=>(0, _pickerViewRoot.PickerViewRoot));
var _pickerViewRoot = require("./PickerViewRoot");

},{"./PickerViewRoot":"dAv2g","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dAv2g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickerViewRoot", ()=>PickerViewRoot);
var _styles = require("@mui/material/styles");
var _dimensions = require("../../constants/dimensions");
const PickerViewRoot = (0, _styles.styled)("div")({
    overflowX: "hidden",
    width: (0, _dimensions.DIALOG_WIDTH),
    maxHeight: (0, _dimensions.VIEW_HEIGHT),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});

},{"@mui/material/styles":"gNR9m","../../constants/dimensions":"9lrdR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9lrdR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAY_SIZE", ()=>DAY_SIZE);
parcelHelpers.export(exports, "DAY_MARGIN", ()=>DAY_MARGIN);
parcelHelpers.export(exports, "DIALOG_WIDTH", ()=>DIALOG_WIDTH);
parcelHelpers.export(exports, "VIEW_HEIGHT", ()=>VIEW_HEIGHT);
const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const VIEW_HEIGHT = 358;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bY0fK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarPicker", ()=>CalendarPicker);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _monthPicker = require("../MonthPicker/MonthPicker");
var _useCalendarState = require("./useCalendarState");
var _useUtils = require("../internals/hooks/useUtils");
var _pickersFadeTransitionGroup = require("./PickersFadeTransitionGroup");
var _dayPicker = require("./DayPicker");
var _useViews = require("../internals/hooks/useViews");
var _pickersCalendarHeader = require("./PickersCalendarHeader");
var _yearPicker = require("../YearPicker/YearPicker");
var _dateUtils = require("../internals/utils/date-utils");
var _pickerViewRoot = require("../internals/components/PickerViewRoot");
var _defaultReduceAnimations = require("../internals/utils/defaultReduceAnimations");
var _calendarPickerClasses = require("./calendarPickerClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "onViewChange",
    "date",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "classes"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _calendarPickerClasses.getCalendarPickerUtilityClass), classes);
};
function useCalendarPickerDefaultizedProps(props, name) {
    const utils = (0, _useUtils.useUtils)();
    const defaultDates = (0, _useUtils.useDefaultDates)();
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    return (0, _extendsDefault.default)({
        loading: false,
        disablePast: false,
        disableFuture: false,
        openTo: "day",
        views: [
            "year",
            "day"
        ],
        reduceAnimations: (0, _defaultReduceAnimations.defaultReduceAnimations),
        renderLoading: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "..."
            })
    }, themeProps, {
        minDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const CalendarPickerRoot = (0, _styles.styled)((0, _pickerViewRoot.PickerViewRoot), {
    name: "MuiCalendarPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column"
});
const CalendarPickerViewTransitionContainer = (0, _styles.styled)((0, _pickersFadeTransitionGroup.PickersFadeTransitionGroup), {
    name: "MuiCalendarPicker",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const CalendarPicker = /*#__PURE__*/ _react.forwardRef(function CalendarPicker(inProps, ref) {
    const utils = (0, _useUtils.useUtils)();
    const id = (0, _utils.unstable_useId)();
    const props = useCalendarPickerDefaultizedProps(inProps, "MuiCalendarPicker");
    const { autoFocus, onViewChange, date, disableFuture, disablePast, defaultCalendarMonth, onChange, onYearChange, onMonthChange, reduceAnimations, shouldDisableDate, shouldDisableMonth, shouldDisableYear, view, views, openTo, className, disabled, readOnly, minDate, maxDate, disableHighlightToday, focusedView, onFocusedViewChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { openView, setOpenView, openNext } = (0, _useViews.useViews)({
        view,
        views,
        openTo,
        onChange,
        onViewChange
    });
    const { calendarState, changeFocusedDay, changeMonth, handleChangeMonth, isDateDisabled, onMonthSwitchingAnimationEnd } = (0, _useCalendarState.useCalendarState)({
        date,
        defaultCalendarMonth,
        reduceAnimations,
        onMonthChange,
        minDate,
        maxDate,
        shouldDisableDate,
        disablePast,
        disableFuture
    });
    const handleDateMonthChange = _react.useCallback((newDate, selectionState)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtils.findClosestEnabledDate)({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            openNext();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onMonthChange,
        changeMonth,
        openNext,
        utils
    ]);
    const handleDateYearChange = _react.useCallback((newDate, selectionState)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtils.findClosestEnabledDate)({
            utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            openNext();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onYearChange,
        openNext,
        utils,
        changeMonth
    ]);
    const onSelectedDayChange = _react.useCallback((day, isFinish)=>{
        if (date && day) // If there is a date already selected, then we want to keep its time
        return onChange(utils.mergeDateAndTime(day, date), isFinish);
        return onChange(day, isFinish);
    }, [
        utils,
        date,
        onChange
    ]);
    _react.useEffect(()=>{
        if (date) changeMonth(date);
    }, [
        date
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast,
        disableFuture,
        maxDate,
        minDate
    }; // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && date || minDate;
    const maxDateWithDisabled = disabled && date || maxDate;
    const commonViewProps = {
        disableHighlightToday,
        readOnly,
        disabled
    };
    const gridLabelId = `${id}-grid-label`;
    const [internalFocusedView, setInternalFocusedView] = (0, _utils.useControlled)({
        name: "DayPicker",
        state: "focusedView",
        controlled: focusedView,
        default: autoFocus ? openView : null
    });
    const hasFocus = internalFocusedView !== null;
    const handleFocusedViewChange = (0, _utils.useEventCallback)((eventView)=>(newHasFocus)=>{
            if (onFocusedViewChange) {
                // Use the calendar or clock logic
                onFocusedViewChange(eventView)(newHasFocus);
                return;
            } // If alone, do the local modifications
            if (newHasFocus) setInternalFocusedView(eventView);
            else setInternalFocusedView((prevView)=>prevView === eventView ? null : prevView);
        });
    const prevOpenViewRef = _react.useRef(openView);
    _react.useEffect(()=>{
        // Set focus to the button when switching from a view to another
        if (prevOpenViewRef.current === openView) return;
        prevOpenViewRef.current = openView;
        handleFocusedViewChange(openView)(true);
    }, [
        openView,
        handleFocusedViewChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CalendarPickerRoot, {
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersCalendarHeader.PickersCalendarHeader), (0, _extendsDefault.default)({}, other, {
                views: views,
                openView: openView,
                currentMonth: calendarState.currentMonth,
                onViewChange: setOpenView,
                onMonthChange: (newMonth, direction)=>handleChangeMonth({
                        newMonth,
                        direction
                    }),
                minDate: minDateWithDisabled,
                maxDate: maxDateWithDisabled,
                disabled: disabled,
                disablePast: disablePast,
                disableFuture: disableFuture,
                reduceAnimations: reduceAnimations,
                labelId: gridLabelId
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarPickerViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: openView,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        openView === "year" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _yearPicker.YearPicker), (0, _extendsDefault.default)({}, other, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            date: date,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange("year")
                        })),
                        openView === "month" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthPicker.MonthPicker), (0, _extendsDefault.default)({}, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            hasFocus: hasFocus,
                            className: className,
                            date: date,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: handleFocusedViewChange("month")
                        })),
                        openView === "day" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayPicker.DayPicker), (0, _extendsDefault.default)({}, other, calendarState, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: [
                                date
                            ],
                            onSelectedDaysChange: onSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange("day"),
                            gridLabelId: gridLabelId
                        }))
                    ]
                })
            })
        ]
    });
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"kSfZD","@mui/material/styles":"gNR9m","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../MonthPicker/MonthPicker":"8ZcUC","./useCalendarState":"fDqa5","../internals/hooks/useUtils":"8WF4c","./PickersFadeTransitionGroup":"8bMYk","./DayPicker":"5OB0R","../internals/hooks/useViews":"82888","./PickersCalendarHeader":"4vT9r","../YearPicker/YearPicker":"ajB93","../internals/utils/date-utils":"1bf5u","../internals/components/PickerViewRoot":"61D5A","../internals/utils/defaultReduceAnimations":"VwZly","./calendarPickerClasses":"hEA3Q","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8ZcUC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMonthPickerDefaultizedProps", ()=>useMonthPickerDefaultizedProps);
parcelHelpers.export(exports, "MonthPicker", ()=>MonthPicker);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _pickersMonth = require("./PickersMonth");
var _useUtils = require("../internals/hooks/useUtils");
var _monthPickerClasses = require("./monthPickerClasses");
var _dateUtils = require("../internals/utils/date-utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "date",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _monthPickerClasses.getMonthPickerUtilityClass), classes);
};
function useMonthPickerDefaultizedProps(props, name) {
    const utils = (0, _useUtils.useUtils)();
    const defaultDates = (0, _useUtils.useDefaultDates)();
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    return (0, _extendsDefault.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const MonthPickerRoot = (0, _styles.styled)("div", {
    name: "MuiMonthPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: 310,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    margin: "0 4px"
});
const MonthPicker = /*#__PURE__*/ _react.forwardRef(function MonthPicker(inProps, ref) {
    const utils = (0, _useUtils.useUtils)();
    const now = (0, _useUtils.useNow)();
    const props = useMonthPickerDefaultizedProps(inProps, "MuiMonthPicker");
    const { className, date, disabled, disableFuture, disablePast, maxDate, minDate, onChange, shouldDisableMonth, readOnly, disableHighlightToday, autoFocus = false, onMonthFocus, hasFocus, onFocusedViewChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _system.useTheme)();
    const selectedDateOrStartOfMonth = _react.useMemo(()=>date != null ? date : utils.startOfMonth(now), [
        now,
        utils,
        date
    ]);
    const selectedMonth = _react.useMemo(()=>{
        if (date != null) return utils.getMonth(date);
        if (disableHighlightToday) return null;
        return utils.getMonth(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const [focusedMonth, setFocusedMonth] = _react.useState(()=>selectedMonth || utils.getMonth(now));
    const isMonthDisabled = _react.useCallback((month)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        if (utils.isBefore(month, firstEnabledMonth)) return true;
        if (utils.isAfter(month, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(month);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const onMonthSelect = (month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(selectedDateOrStartOfMonth, month);
        onChange(newDate, "finish");
    };
    const [internalHasFocus, setInternalHasFocus] = (0, _material.useControlled)({
        name: "MonthPicker",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = _react.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const focusMonth = _react.useCallback((month)=>{
        if (!isMonthDisabled(utils.setMonth(selectedDateOrStartOfMonth, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    }, [
        isMonthDisabled,
        utils,
        selectedDateOrStartOfMonth,
        changeHasFocus,
        onMonthFocus
    ]);
    _react.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, _material.useEventCallback)((event)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + focusedMonth - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + focusedMonth + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + focusedMonth + (theme.direction === "ltr" ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + focusedMonth + (theme.direction === "ltr" ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = _react.useCallback((event, month)=>{
        focusMonth(month);
    }, [
        focusMonth
    ]);
    const handleMonthBlur = _react.useCallback(()=>{
        changeHasFocus(false);
    }, [
        changeHasFocus
    ]);
    const currentMonthNumber = utils.getMonth(now);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MonthPickerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        onKeyDown: handleKeyDown
    }, other, {
        children: utils.getMonthArray(selectedDateOrStartOfMonth).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersMonth.PickersMonth), {
                value: monthNumber,
                selected: monthNumber === selectedMonth,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                hasFocus: internalHasFocus && monthNumber === focusedMonth,
                onSelect: onMonthSelect,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                disabled: isDisabled,
                "aria-current": currentMonthNumber === monthNumber ? "date" : undefined,
                children: monthText
            }, monthText);
        })
    }));
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"kSfZD","@mui/system":"gwZXT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","./PickersMonth":"cjftq","../internals/hooks/useUtils":"8WF4c","./monthPickerClasses":"3Q0CF","../internals/utils/date-utils":"1bf5u","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cjftq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersMonth", ()=>PickersMonth);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _utils1 = require("../internals/utils/utils");
var _pickersMonthClasses = require("./pickersMonthClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "disabled",
    "onSelect",
    "selected",
    "value",
    "tabIndex",
    "hasFocus",
    "onFocus",
    "onBlur"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersMonthClasses.getPickersMonthUtilityClass), classes);
};
const PickersMonthRoot = (0, _styles.styled)((0, _typographyDefault.default), {
    name: "PrivatePickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, _pickersMonthClasses.pickersMonthClasses).selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extendsDefault.default)({
        flex: "1 0 33.33%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus, &:hover": {
            backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            pointerEvents: "none",
            color: theme.palette.text.secondary
        },
        [`&.${(0, _pickersMonthClasses.pickersMonthClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const noop = ()=>{};
const PickersMonth = (props)=>{
    // TODO v6 add 'useThemeProps' once the component class names are aligned
    const { disabled, onSelect, selected, value, tabIndex, hasFocus, onFocus = noop, onBlur = noop } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const handleSelection = ()=>{
        onSelect(value);
    };
    const ref = _react.useRef(null);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (hasFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersMonthRoot, (0, _extendsDefault.default)({
        ref: ref,
        component: "button",
        type: "button",
        className: classes.root,
        tabIndex: tabIndex,
        onClick: handleSelection,
        onKeyDown: (0, _utils1.onSpaceOrEnter)(handleSelection),
        color: selected ? "primary" : undefined,
        variant: selected ? "h5" : "subtitle1",
        disabled: disabled,
        onFocus: (event)=>onFocus(event, value),
        onBlur: (event)=>onBlur(event, value)
    }, other));
};

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/Typography":"1Chqm","@mui/material/styles":"gNR9m","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../internals/utils/utils":"jDQRM","./pickersMonthClasses":"1hFAo","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1hFAo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersMonthUtilityClass", ()=>getPickersMonthUtilityClass);
parcelHelpers.export(exports, "pickersMonthClasses", ()=>pickersMonthClasses);
var _material = require("@mui/material");
function getPickersMonthUtilityClass(slot) {
    // TODO v6 Rename 'PrivatePickersMonth' to 'MuiPickersMonth' to follow convention
    return (0, _material.generateUtilityClass)("PrivatePickersMonth", slot);
}
const pickersMonthClasses = (0, _material.generateUtilityClasses)("PrivatePickersMonth", [
    "root",
    "selected"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Q0CF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMonthPickerUtilityClass", ()=>getMonthPickerUtilityClass);
parcelHelpers.export(exports, "monthPickerClasses", ()=>monthPickerClasses);
var _material = require("@mui/material");
function getMonthPickerUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiMonthPicker", slot);
}
const monthPickerClasses = (0, _material.generateUtilityClasses)("MuiMonthPicker", [
    "root"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fDqa5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCalendarStateReducer", ()=>createCalendarStateReducer);
parcelHelpers.export(exports, "useCalendarState", ()=>useCalendarState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useDateValidation = require("../internals/hooks/validation/useDateValidation");
var _useUtils = require("../internals/hooks/useUtils");
const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, _extendsDefault.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "finishMonthSwitchingAnimation":
                return (0, _extendsDefault.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, _extendsDefault.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const useCalendarState = ({ date, defaultCalendarMonth, disableFuture, disablePast, disableSwitchToMonthOnDayFocus = false, maxDate, minDate, onMonthChange, reduceAnimations, shouldDisableDate })=>{
    var _ref;
    const now = (0, _useUtils.useNow)();
    const utils = (0, _useUtils.useUtils)();
    const reducerFn = _react.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const [calendarState, dispatch] = _react.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: date || now,
        currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
        slideDirection: "left"
    });
    const handleChangeMonth = _react.useCallback((payload)=>{
        dispatch((0, _extendsDefault.default)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = _react.useCallback((newDate)=>{
        const newDateRequested = newDate != null ? newDate : now;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        now,
        utils
    ]);
    const isDateDisabled = (0, _useDateValidation.useIsDayDisabled)({
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast
    });
    const onMonthSwitchingAnimationEnd = _react.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = _react.useCallback((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation
        });
    }, [
        isDateDisabled
    ]);
    return {
        calendarState,
        changeMonth,
        changeFocusedDay,
        isDateDisabled,
        onMonthSwitchingAnimationEnd,
        handleChangeMonth
    };
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../internals/hooks/validation/useDateValidation":"hI2Vz","../internals/hooks/useUtils":"8WF4c","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hI2Vz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateDate", ()=>validateDate);
parcelHelpers.export(exports, "useIsDayDisabled", ()=>useIsDayDisabled);
parcelHelpers.export(exports, "isSameDateError", ()=>isSameDateError);
parcelHelpers.export(exports, "useDateValidation", ()=>useDateValidation);
var _react = require("react");
var _useValidation = require("./useValidation");
var _useUtils = require("../useUtils");
var _dateUtils = require("../../utils/date-utils");
const validateDate = ({ props, value, adapter })=>{
    const now = adapter.utils.date();
    const date = adapter.utils.date(value);
    const minDate = (0, _dateUtils.parseNonNullablePickerDate)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, _dateUtils.parseNonNullablePickerDate)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    if (date === null) return null;
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(props.shouldDisableDate && props.shouldDisableDate(date)):
            return "shouldDisableDate";
        case Boolean(props.disableFuture && adapter.utils.isAfterDay(date, now)):
            return "disableFuture";
        case Boolean(props.disablePast && adapter.utils.isBeforeDay(date, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(date, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(date, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};
const useIsDayDisabled = ({ shouldDisableDate, minDate, maxDate, disableFuture, disablePast })=>{
    const adapter = (0, _useUtils.useLocalizationContext)();
    return _react.useCallback((day)=>validateDate({
            adapter,
            value: day,
            props: {
                shouldDisableDate,
                minDate,
                maxDate,
                disableFuture,
                disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast
    ]);
};
const isSameDateError = (a, b)=>a === b;
const useDateValidation = (props)=>(0, _useValidation.useValidation)(props, validateDate, isSameDateError);

},{"react":"gVheC","./useValidation":"jzjZx","../useUtils":"8WF4c","../../utils/date-utils":"1bf5u","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzjZx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useValidation", ()=>useValidation);
var _react = require("react");
var _useUtils = require("../useUtils");
function useValidation(props, validate, isSameError) {
    const { value, onError } = props;
    const adapter = (0, _useUtils.useLocalizationContext)();
    const previousValidationErrorRef = _react.useRef(null);
    const validationError = validate({
        adapter,
        value,
        props
    });
    _react.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}

},{"react":"gVheC","../useUtils":"8WF4c","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8bMYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "PickersFadeTransitionGroup", ()=>PickersFadeTransitionGroup);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _reactTransitionGroup = require("react-transition-group");
var _pickersFadeTransitionGroupClasses = require("./pickersFadeTransitionGroupClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersFadeTransitionGroupClasses.getPickersFadeTransitionGroupUtilityClass), classes);
};
const animationDuration = 500;
const PickersFadeTransitionGroupRoot = (0, _styles.styled)((0, _reactTransitionGroup.TransitionGroup), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function PickersFadeTransitionGroup(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children, className, reduceAnimations, transKey } = props;
    const classes = useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersFadeTransitionGroupRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: animationDuration,
                enter: animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

},{"react":"gVheC","clsx":"kSfZD","@mui/material/Fade":"oyDsU","@mui/material/styles":"gNR9m","@mui/material":"iknXc","react-transition-group":"5ABiG","./pickersFadeTransitionGroupClasses":"eTNXh","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eTNXh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersFadeTransitionGroupUtilityClass", ()=>getPickersFadeTransitionGroupUtilityClass);
parcelHelpers.export(exports, "pickersFadeTransitionGroupClasses", ()=>pickersFadeTransitionGroupClasses);
var _material = require("@mui/material");
const getPickersFadeTransitionGroupUtilityClass = (slot)=>(0, _material.generateUtilityClass)("MuiPickersFadeTransitionGroup", slot);
const pickersFadeTransitionGroupClasses = (0, _material.generateUtilityClasses)("MuiPickersFadeTransitionGroup", [
    "root"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5OB0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "DayPicker", ()=>DayPicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _pickersDay = require("../PickersDay/PickersDay");
var _useUtils = require("../internals/hooks/useUtils");
var _dimensions = require("../internals/constants/dimensions");
var _pickersSlideTransition = require("./PickersSlideTransition");
var _useDateValidation = require("../internals/hooks/validation/useDateValidation");
var _dateUtils = require("../internals/utils/date-utils");
var _dayPickerClasses = require("./dayPickerClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _dayPickerClasses.getDayPickerUtilityClass), classes);
};
const defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const weeksContainerHeight = ((0, _dimensions.DAY_SIZE) + (0, _dimensions.DAY_MARGIN) * 2) * 6;
const PickersCalendarDayHeader = (0, _styles.styled)("div", {
    name: "MuiDayPicker",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const PickersCalendarWeekDayLabel = (0, _styles.styled)((0, _typographyDefault.default), {
    name: "MuiDayPicker",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.secondary
    }));
const PickersCalendarLoadingContainer = (0, _styles.styled)("div", {
    name: "MuiDayPicker",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = (0, _styles.styled)((0, _pickersSlideTransition.PickersSlideTransition), {
    name: "MuiDayPicker",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = (0, _styles.styled)("div", {
    name: "MuiDayPicker",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const PickersCalendarWeek = (0, _styles.styled)("div", {
    name: "MuiDayPicker",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, _dimensions.DAY_MARGIN)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function DayPicker(inProps) {
    const now = (0, _useUtils.useNow)();
    const utils = (0, _useUtils.useUtils)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiDayPicker"
    });
    const classes = useUtilityClasses(props);
    const { onFocusedDayChange, className, currentMonth, selectedDays, disabled, disableHighlightToday, focusedDay, isMonthSwitchingAnimating, loading, onSelectedDaysChange, onMonthSwitchingAnimationEnd, readOnly, reduceAnimations, renderDay, renderLoading = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: "..."
        }), showDaysOutsideCurrentMonth, slideDirection, TransitionProps, disablePast, disableFuture, minDate, maxDate, shouldDisableDate, dayOfWeekFormatter = defaultDayOfWeekFormatter, hasFocus, onFocusedViewChange, gridLabelId } = props;
    const isDateDisabled = (0, _useDateValidation.useIsDayDisabled)({
        shouldDisableDate,
        minDate,
        maxDate,
        disablePast,
        disableFuture
    });
    const [internalFocusedDay, setInternalFocusedDay] = _react.useState(()=>focusedDay || now);
    const changeHasFocus = _react.useCallback((newHasFocus)=>{
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        onFocusedViewChange
    ]);
    const handleDaySelect = _react.useCallback((day, isFinish = "finish")=>{
        if (readOnly) return;
        onSelectedDaysChange(day, isFinish);
    }, [
        onSelectedDaysChange,
        readOnly
    ]);
    const focusDay = _react.useCallback((day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            changeHasFocus(true);
        }
    }, [
        isDateDisabled,
        onFocusedDayChange,
        changeHasFocus
    ]);
    const theme = (0, _styles.useTheme)();
    function handleKeyDown(event, day) {
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === "ltr" ? -1 : 1);
                    const nextAvailableMonth = theme.direction === "ltr" ? utils.getPreviousMonth(day) : utils.getNextMonth(day);
                    const closestDayToFocus = (0, _dateUtils.findClosestEnabledDate)({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === "ltr" ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: theme.direction === "ltr" ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === "ltr" ? 1 : -1);
                    const nextAvailableMonth = theme.direction === "ltr" ? utils.getNextMonth(day) : utils.getPreviousMonth(day);
                    const closestDayToFocus = (0, _dateUtils.findClosestEnabledDate)({
                        utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === "ltr" ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: theme.direction === "ltr" ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.getNextMonth(day));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.getPreviousMonth(day));
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    function handleFocus(event, day) {
        focusDay(day);
    }
    function handleBlur(event, day) {
        if (hasFocus && utils.isSameDay(internalFocusedDay, day)) changeHasFocus(false);
    }
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = _react.useMemo(()=>/*#__PURE__*/ _react.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = _react.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, _dateUtils.findClosestEnabledDate)({
            utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast,
            disableFuture,
            isDateDisabled
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: utils.getWeekdays().map((day, i)=>{
                    var _dayOfWeekFormatter;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekDayLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
                        className: classes.weekDayLabel,
                        children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                    }, day + i.toString());
                })
            }),
            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarSlideTransition, (0, _extendsDefault.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, _clsxDefault.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: utils.getWeekArray(currentMonth).map((week)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            children: week.map((day)=>{
                                const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
                                const isSelected = validSelectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
                                const isToday = utils.isSameDay(day, now);
                                const pickersDayProps = {
                                    key: day == null ? void 0 : day.toString(),
                                    day,
                                    isAnimating: isMonthSwitchingAnimating,
                                    disabled: disabled || isDateDisabled(day),
                                    autoFocus: hasFocus && isFocusableDay,
                                    today: isToday,
                                    outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                                    selected: isSelected,
                                    disableHighlightToday,
                                    showDaysOutsideCurrentMonth,
                                    onKeyDown: handleKeyDown,
                                    onFocus: handleFocus,
                                    onBlur: handleBlur,
                                    onDaySelect: handleDaySelect,
                                    tabIndex: isFocusableDay ? 0 : -1,
                                    role: "gridcell",
                                    "aria-selected": isSelected
                                };
                                if (isToday) pickersDayProps["aria-current"] = "date";
                                return renderDay ? renderDay(day, validSelectedDays, pickersDayProps) : /*#__PURE__*/ (0, _react.createElement)((0, _pickersDay.PickersDay), (0, _extendsDefault.default)({}, pickersDayProps, {
                                    key: pickersDayProps.key
                                }));
                            })
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/Typography":"1Chqm","@mui/material/styles":"gNR9m","@mui/material":"iknXc","clsx":"kSfZD","../PickersDay/PickersDay":"azu06","../internals/hooks/useUtils":"8WF4c","../internals/constants/dimensions":"9lrdR","./PickersSlideTransition":"c7uNK","../internals/hooks/validation/useDateValidation":"hI2Vz","../internals/utils/date-utils":"1bf5u","./dayPickerClasses":"6Zybp","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"azu06":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areDayPropsEqual", ()=>areDayPropsEqual);
parcelHelpers.export(exports, "PickersDay", ()=>PickersDay);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _buttonBase = require("@mui/material/ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _utils = require("@mui/utils");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _utils1 = require("@mui/material/utils");
var _useUtils = require("../internals/hooks/useUtils");
var _dimensions = require("../internals/constants/dimensions");
var _pickersDayClasses = require("./pickersDayClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today"
];
const useUtilityClasses = (ownerState)=>{
    const { selected, disableMargin, disableHighlightToday, today, disabled, outsideCurrentMonth, showDaysOutsideCurrentMonth, classes } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            outsideCurrentMonth && !showDaysOutsideCurrentMonth && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersDayClasses.getPickersDayUtilityClass), classes);
};
const styleArg = ({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.caption, {
        width: (0, _dimensions.DAY_SIZE),
        height: (0, _dimensions.DAY_SIZE),
        borderRadius: "50%",
        padding: 0,
        // background required here to prevent collides with the other days when animating with transition group
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        "&:hover": {
            backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:focus": {
            backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            [`&.${(0, _pickersDayClasses.pickersDayClasses).selected}`]: {
                willChange: "background-color",
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, _pickersDayClasses.pickersDayClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                willChange: "background-color",
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, _pickersDayClasses.pickersDayClasses).disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, _dimensions.DAY_MARGIN}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: theme.palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, _pickersDayClasses.pickersDayClasses).selected})`]: {
            border: `1px solid ${theme.palette.text.secondary}`
        }
    });
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const PickersDayRoot = (0, _styles.styled)((0, _buttonBaseDefault.default), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver
})(styleArg);
const PickersDayFiller = (0, _styles.styled)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, styleArg({
        theme,
        ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const noop = ()=>{};
const PickersDayRaw = /*#__PURE__*/ _react.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus = false, className, day, disabled = false, disableHighlightToday = false, disableMargin = false, isAnimating, onClick, onDaySelect, onFocus = noop, onBlur = noop, onKeyDown = noop, onMouseDown, outsideCurrentMonth, selected = false, showDaysOutsideCurrentMonth = false, children, today: isToday = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        disabled,
        disableHighlightToday,
        disableMargin,
        selected,
        showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = useUtilityClasses(ownerState);
    const utils = (0, _useUtils.useUtils)();
    const ref = _react.useRef(null);
    const handleRef = (0, _utils1.useForkRef)(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]); // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        if (onMouseDown) onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day, "finish");
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayFiller, {
        className: (0, _clsxDefault.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const areDayPropsEqual = (prevProps, nextProps)=>{
    return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.sx === nextProps.sx && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onFocus === nextProps.onFocus && prevProps.onBlur === nextProps.onBlur && prevProps.onDaySelect === nextProps.onDaySelect;
};
const PickersDay = /*#__PURE__*/ _react.memo(PickersDayRaw, areDayPropsEqual);

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"kSfZD","@mui/material/ButtonBase":"ectWz","@mui/utils":"dv12b","@mui/material":"iknXc","@mui/material/styles":"gNR9m","@mui/material/utils":"ziQFX","../internals/hooks/useUtils":"8WF4c","../internals/constants/dimensions":"9lrdR","./pickersDayClasses":"iBT1e","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBT1e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersDayUtilityClass", ()=>getPickersDayUtilityClass);
parcelHelpers.export(exports, "pickersDayClasses", ()=>pickersDayClasses);
var _material = require("@mui/material");
function getPickersDayUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiPickersDay", slot);
}
const pickersDayClasses = (0, _material.generateUtilityClasses)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c7uNK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slideAnimationDuration", ()=>slideAnimationDuration);
parcelHelpers.export(exports, "PickersSlideTransition", ()=>PickersSlideTransition);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _reactTransitionGroup = require("react-transition-group");
var _pickersSlideTransitionClasses = require("./pickersSlideTransitionClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersSlideTransitionClasses.getPickersSlideTransitionUtilityClass), classes);
};
const slideAnimationDuration = 350;
const PickersSlideTransitionRoot = (0, _styles.styled)((0, _reactTransitionGroup.TransitionGroup), {
    name: "PrivatePickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: slideAnimationDuration,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
const PickersSlideTransition = (props)=>{
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { children, className, reduceAnimations, slideDirection, transKey } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsxDefault.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: (0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideExit,
        enterActive: (0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses).slideEnterActive,
        enter: (0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)[`slideEnter-${slideDirection}`],
        exitActive: (0, _pickersSlideTransitionClasses.pickersSlideTransitionClasses)[`slideExitActiveLeft-${slideDirection}`]
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersSlideTransitionRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ _react.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.CSSTransition), (0, _extendsDefault.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: slideAnimationDuration,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"kSfZD","@mui/material/styles":"gNR9m","@mui/material":"iknXc","react-transition-group":"5ABiG","./pickersSlideTransitionClasses":"4d17L","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4d17L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersSlideTransitionUtilityClass", ()=>getPickersSlideTransitionUtilityClass);
parcelHelpers.export(exports, "pickersSlideTransitionClasses", ()=>pickersSlideTransitionClasses);
var _material = require("@mui/material");
const getPickersSlideTransitionUtilityClass = (slot)=>(0, _material.generateUtilityClass)("PrivatePickersSlideTransition", slot);
const pickersSlideTransitionClasses = (0, _material.generateUtilityClasses)("PrivatePickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Zybp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDayPickerUtilityClass", ()=>getDayPickerUtilityClass);
parcelHelpers.export(exports, "dayPickerClasses", ()=>dayPickerClasses);
var _material = require("@mui/material");
const getDayPickerUtilityClass = (slot)=>(0, _material.generateUtilityClass)("MuiDayPicker", slot);
const dayPickerClasses = (0, _material.generateUtilityClasses)("MuiDayPicker", [
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4vT9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "PickersCalendarHeader", ()=>PickersCalendarHeader);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _useUtils = require("../internals/hooks/useUtils");
var _pickersFadeTransitionGroup = require("./PickersFadeTransitionGroup");
var _icons = require("../internals/components/icons");
var _pickersArrowSwitcher = require("../internals/components/PickersArrowSwitcher");
var _dateHelpersHooks = require("../internals/hooks/date-helpers-hooks");
var _warning = require("../internals/utils/warning");
var _pickersCalendarHeaderClasses = require("./pickersCalendarHeaderClasses");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersCalendarHeaderClasses.getPickersCalendarHeaderUtilityClass), classes);
};
const PickersCalendarHeaderRoot = (0, _styles.styled)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const PickersCalendarHeaderLabelContainer = (0, _styles.styled)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme })=>(0, _extendsDefault.default)({
        display: "flex",
        maxHeight: 30,
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const PickersCalendarHeaderLabel = (0, _styles.styled)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = (0, _styles.styled)((0, _iconButtonDefault.default), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: "auto"
});
const PickersCalendarHeaderSwitchViewIcon = (0, _styles.styled)((0, _icons.ArrowDropDown), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }, ownerState.openView === "year" && {
        transform: "rotate(180deg)"
    }));
const deprecatedPropsWarning = (0, _warning.buildDeprecatedPropsWarning)("Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.");
function PickersCalendarHeader(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { components = {}, componentsProps = {}, currentMonth: month, disabled, disableFuture, disablePast, getViewSwitchingButtonText: getViewSwitchingButtonTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxDate, minDate, onMonthChange, onViewChange, openView: currentView, reduceAnimations, rightArrowButtonText: rightArrowButtonTextProp, views, labelId } = props;
    deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getViewSwitchingButtonText: getViewSwitchingButtonTextProp
    });
    const localeText = (0, _useUtils.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
    const getViewSwitchingButtonText = getViewSwitchingButtonTextProp != null ? getViewSwitchingButtonTextProp : localeText.calendarViewSwitchingButtonAriaLabel;
    const utils = (0, _useUtils.useUtils)();
    const classes = useUtilityClasses(props);
    const switchViewButtonProps = componentsProps.switchViewButton || {};
    const selectNextMonth = ()=>onMonthChange(utils.getNextMonth(month), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.getPreviousMonth(month), "right");
    const isNextMonthDisabled = (0, _dateHelpersHooks.useNextMonthDisabled)(month, {
        disableFuture,
        maxDate
    });
    const isPreviousMonthDisabled = (0, _dateHelpersHooks.usePreviousMonthDisabled)(month, {
        disablePast,
        minDate
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((view)=>view !== currentView) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    }; // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    const ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderRoot, {
        ownerState: ownerState,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState // putting this on the label item element below breaks when using transition
                ,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersFadeTransitionGroup.PickersFadeTransitionGroup), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, "monthAndYear"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, "monthAndYear")
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarHeaderSwitchViewButton, (0, _extendsDefault.default)({
                        size: "small",
                        as: components.SwitchViewButton,
                        "aria-label": getViewSwitchingButtonText(currentView),
                        className: classes.switchViewButton
                    }, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarHeaderSwitchViewIcon, {
                            as: components.SwitchViewIcon,
                            ownerState: ownerState,
                            className: classes.switchViewIcon
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                in: currentView === "day",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersArrowSwitcher.PickersArrowSwitcher), {
                    leftArrowButtonText: leftArrowButtonText,
                    rightArrowButtonText: rightArrowButtonText,
                    components: components,
                    componentsProps: componentsProps,
                    onLeftClick: selectPreviousMonth,
                    onRightClick: selectNextMonth,
                    isLeftDisabled: isPreviousMonthDisabled,
                    isRightDisabled: isNextMonthDisabled
                })
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/Fade":"oyDsU","@mui/material/styles":"gNR9m","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","../internals/hooks/useUtils":"8WF4c","./PickersFadeTransitionGroup":"8bMYk","../internals/components/icons":"eS3zj","../internals/components/PickersArrowSwitcher":"3N38m","../internals/hooks/date-helpers-hooks":"hgT9v","../internals/utils/warning":"daxax","./pickersCalendarHeaderClasses":"8T2PO","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8T2PO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersCalendarHeaderUtilityClass", ()=>getPickersCalendarHeaderUtilityClass);
parcelHelpers.export(exports, "pickersCalendarHeaderClasses", ()=>pickersCalendarHeaderClasses);
var _material = require("@mui/material");
const getPickersCalendarHeaderUtilityClass = (slot)=>(0, _material.generateUtilityClass)("MuiPickersCalendarHeader", slot);
const pickersCalendarHeaderClasses = (0, _material.generateUtilityClasses)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ajB93":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearPicker", ()=>YearPicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/material/utils");
var _utils1 = require("@mui/utils");
var _pickersYear = require("./PickersYear");
var _useUtils = require("../internals/hooks/useUtils");
var _wrapperVariantContext = require("../internals/components/wrappers/WrapperVariantContext");
var _yearPickerClasses = require("./yearPickerClasses");
var _dateUtils = require("../internals/utils/date-utils");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _yearPickerClasses.getYearPickerUtilityClass), classes);
};
function useYearPickerDefaultizedProps(props, name) {
    const utils = (0, _useUtils.useUtils)();
    const defaultDates = (0, _useUtils.useDefaultDates)();
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    return (0, _extendsDefault.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, _dateUtils.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const YearPickerRoot = (0, _styles.styled)("div", {
    name: "MuiYearPicker",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    maxHeight: "304px"
});
const YearPicker = /*#__PURE__*/ _react.forwardRef(function YearPicker(inProps, ref) {
    const now = (0, _useUtils.useNow)();
    const theme = (0, _styles.useTheme)();
    const utils = (0, _useUtils.useUtils)();
    const props = useYearPickerDefaultizedProps(inProps, "MuiYearPicker");
    const { autoFocus, className, date, disabled, disableFuture, disablePast, maxDate, minDate, onChange, readOnly, shouldDisableYear, disableHighlightToday, onYearFocus, hasFocus, onFocusedViewChange } = props;
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const selectedDateOrStartOfYear = _react.useMemo(()=>date != null ? date : utils.startOfYear(now), [
        now,
        utils,
        date
    ]);
    const currentYear = _react.useMemo(()=>{
        if (date != null) return utils.getYear(date);
        if (disableHighlightToday) return null;
        return utils.getYear(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const wrapperVariant = _react.useContext((0, _wrapperVariantContext.WrapperVariantContext));
    const selectedYearRef = _react.useRef(null);
    const [focusedYear, setFocusedYear] = _react.useState(()=>currentYear || utils.getYear(now));
    const [internalHasFocus, setInternalHasFocus] = (0, _utils1.unstable_useControlled)({
        name: "YearPicker",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = _react.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const isYearDisabled = _react.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (shouldDisableYear && shouldDisableYear(dateToValidate)) return true;
        return false;
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (event, year, isFinish = "finish")=>{
        if (readOnly) return;
        const newDate = utils.setYear(selectedDateOrStartOfYear, year);
        onChange(newDate, isFinish);
    };
    const focusYear = _react.useCallback((year)=>{
        if (!isYearDisabled(utils.setYear(selectedDateOrStartOfYear, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    }, [
        isYearDisabled,
        utils,
        selectedDateOrStartOfYear,
        changeHasFocus,
        onYearFocus
    ]);
    _react.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>currentYear !== null && prevFocusedYear !== currentYear ? currentYear : prevFocusedYear);
    }, [
        currentYear
    ]);
    const yearsInRow = wrapperVariant === "desktop" ? 4 : 3;
    const handleKeyDown = _react.useCallback((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - yearsInRow);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + yearsInRow);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year + (theme.direction === "ltr" ? -1 : 1));
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + (theme.direction === "ltr" ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        focusYear,
        theme.direction,
        yearsInRow
    ]);
    const handleFocus = _react.useCallback((event, year)=>{
        focusYear(year);
    }, [
        focusYear
    ]);
    const handleBlur = _react.useCallback((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    }, [
        focusedYear,
        changeHasFocus
    ]);
    const nowYear = utils.getYear(now);
    const scrollerRef = _react.useRef(null);
    const handleRef = (0, _utils.useForkRef)(ref, scrollerRef);
    _react.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
         // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(YearPickerRoot, {
        ref: handleRef,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const selected = yearNumber === currentYear;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersYear.PickersYear), {
                selected: selected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                ref: selected ? selectedYearRef : undefined,
                disabled: disabled || isYearDisabled(year),
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleFocus,
                onBlur: handleBlur,
                "aria-current": nowYear === yearNumber ? "date" : undefined,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material/styles":"gNR9m","@mui/material":"iknXc","clsx":"kSfZD","@mui/material/utils":"ziQFX","@mui/utils":"dv12b","./PickersYear":"2FYVT","../internals/hooks/useUtils":"8WF4c","../internals/components/wrappers/WrapperVariantContext":"fM3I2","./yearPickerClasses":"k4yuq","../internals/utils/date-utils":"1bf5u","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2FYVT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersYear", ()=>PickersYear);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _wrapperVariantContext = require("../internals/components/wrappers/WrapperVariantContext");
var _pickersYearClasses = require("./pickersYearClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "onClick",
    "onKeyDown",
    "value",
    "tabIndex",
    "onFocus",
    "onBlur"
];
const useUtilityClasses = (ownerState)=>{
    const { wrapperVariant, disabled, selected, classes } = ownerState;
    const slots = {
        root: [
            "root",
            wrapperVariant && `mode${(0, _utils.capitalize)(wrapperVariant)}`
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _pickersYearClasses.getPickersYearUtilityClass), classes);
};
const PickersYearRoot = (0, _styles.styled)("div", {
    name: "PrivatePickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, _pickersYearClasses.pickersYearClasses).modeDesktop}`]: styles.modeDesktop
            },
            {
                [`&.${(0, _pickersYearClasses.pickersYearClasses).modeMobile}`]: styles.modeMobile
            }
        ]
})(({ ownerState })=>(0, _extendsDefault.default)({
        flexBasis: "33.3%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === "desktop" && {
        flexBasis: "25%"
    }));
const PickersYearButton = (0, _styles.styled)("button", {
    name: "PrivatePickersYear",
    slot: "Button",
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, _pickersYearClasses.pickersYearClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, _pickersYearClasses.pickersYearClasses).selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extendsDefault.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus, &:hover": {
            backgroundColor: (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _pickersYearClasses.pickersYearClasses).disabled}`]: {
            color: theme.palette.text.secondary
        },
        [`&.${(0, _pickersYearClasses.pickersYearClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const noop = ()=>{};
const PickersYear = /*#__PURE__*/ _react.forwardRef(function PickersYear(props, forwardedRef) {
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { autoFocus, className, children, disabled, onClick, onKeyDown, value, tabIndex, onFocus = noop, onBlur = noop } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ref = _react.useRef(null);
    const refHandle = (0, _utils.useForkRef)(ref, forwardedRef);
    const wrapperVariant = _react.useContext((0, _wrapperVariantContext.WrapperVariantContext));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        wrapperVariant
    });
    const classes = useUtilityClasses(ownerState); // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    _react.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersYearRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersYearButton, (0, _extendsDefault.default)({
            ref: refHandle,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: ownerState
        }, other, {
            children: children
        }))
    });
});

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","clsx":"kSfZD","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../internals/components/wrappers/WrapperVariantContext":"fM3I2","./pickersYearClasses":"ac12x","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ac12x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPickersYearUtilityClass", ()=>getPickersYearUtilityClass) // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
;
parcelHelpers.export(exports, "pickersYearClasses", ()=>pickersYearClasses);
var _material = require("@mui/material");
function getPickersYearUtilityClass(slot) {
    // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
    return (0, _material.generateUtilityClass)("PrivatePickersYear", slot);
}
const pickersYearClasses = (0, _material.generateUtilityClasses)("PrivatePickersYear", [
    "root",
    "modeDesktop",
    "modeMobile",
    "yearButton",
    "selected",
    "disabled"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k4yuq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getYearPickerUtilityClass", ()=>getYearPickerUtilityClass);
parcelHelpers.export(exports, "yearPickerClasses", ()=>yearPickerClasses);
var _material = require("@mui/material");
function getYearPickerUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiYearPicker", slot);
}
const yearPickerClasses = (0, _material.generateUtilityClasses)("MuiYearPicker", [
    "root"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"VwZly":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultReduceAnimations", ()=>defaultReduceAnimations);
const defaultReduceAnimations = typeof navigator !== "undefined" && /(android)/i.test(navigator.userAgent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hEA3Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCalendarPickerUtilityClass", ()=>getCalendarPickerUtilityClass);
parcelHelpers.export(exports, "calendarPickerClasses", ()=>calendarPickerClasses);
var _material = require("@mui/material");
const getCalendarPickerUtilityClass = (slot)=>(0, _material.generateUtilityClass)("MuiCalendarPicker", slot);
const calendarPickerClasses = (0, _material.generateUtilityClasses)("MuiCalendarPicker", [
    "root",
    "viewTransitionContainer"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j1qIC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyboardDateInput", ()=>KeyboardDateInput);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _useUtils = require("../hooks/useUtils");
var _icons = require("./icons");
var _useMaskedInput = require("../hooks/useMaskedInput");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "components",
    "disableOpenPicker",
    "getOpenDialogAriaText",
    "InputAdornmentProps",
    "InputProps",
    "inputRef",
    "openPicker",
    "OpenPickerButtonProps",
    "renderInput"
];
const KeyboardDateInput = /*#__PURE__*/ _react.forwardRef(function KeyboardDateInput(props, ref) {
    const { className, components = {}, disableOpenPicker, getOpenDialogAriaText: getOpenDialogAriaTextProp, InputAdornmentProps, InputProps, inputRef, openPicker, OpenPickerButtonProps, renderInput } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const localeText = (0, _useUtils.useLocaleText)();
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, _useUtils.useUtils)();
    const textFieldProps = (0, _useMaskedInput.useMaskedInput)(other);
    const adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || "end";
    const OpenPickerIcon = components.OpenPickerIcon || (0, _icons.Calendar);
    return renderInput((0, _extendsDefault.default)({
        ref,
        inputRef,
        className
    }, textFieldProps, {
        InputProps: (0, _extendsDefault.default)({}, InputProps, {
            [`${adornmentPosition}Adornment`]: disableOpenPicker ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), (0, _extendsDefault.default)({
                position: adornmentPosition
            }, InputAdornmentProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), (0, _extendsDefault.default)({
                    edge: adornmentPosition,
                    disabled: other.disabled || other.readOnly,
                    "aria-label": getOpenDialogAriaText(other.rawValue, utils)
                }, OpenPickerButtonProps, {
                    onClick: openPicker,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerIcon, {})
                }))
            }))
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/material/IconButton":"6bnps","@mui/material/InputAdornment":"400VR","../hooks/useUtils":"8WF4c","./icons":"eS3zj","../hooks/useMaskedInput":"dItQl","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dItQl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMaskedInput", ()=>useMaskedInput);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _rifm = require("rifm");
var _useUtils = require("./useUtils");
var _textFieldHelper = require("../utils/text-field-helper");
const useMaskedInput = ({ acceptRegex = /[\d]/gi, disabled, disableMaskedInput, ignoreInvalidInputs, inputFormat, inputProps, label, mask, onChange, rawValue, readOnly, rifmFormatter, TextFieldProps, validationError })=>{
    const utils = (0, _useUtils.useUtils)();
    const formatHelperText = utils.getFormatHelperText(inputFormat);
    const { shouldUseMaskedInput, maskToUse } = _react.useMemo(()=>{
        // formatting of dates is a quite slow thing, so do not make useless .format calls
        if (disableMaskedInput) return {
            shouldUseMaskedInput: false,
            maskToUse: ""
        };
        const computedMaskToUse = (0, _textFieldHelper.getMaskFromCurrentFormat)(mask, inputFormat, acceptRegex, utils);
        return {
            shouldUseMaskedInput: (0, _textFieldHelper.checkMaskIsValidForCurrentFormat)(computedMaskToUse, inputFormat, acceptRegex, utils),
            maskToUse: computedMaskToUse
        };
    }, [
        acceptRegex,
        disableMaskedInput,
        inputFormat,
        mask,
        utils
    ]);
    const formatter = _react.useMemo(()=>shouldUseMaskedInput && maskToUse ? (0, _textFieldHelper.maskedDateFormatter)(maskToUse, acceptRegex) : (st)=>st, [
        acceptRegex,
        maskToUse,
        shouldUseMaskedInput
    ]); // TODO: Implement with controlled vs uncontrolled `rawValue`
    const parsedValue = rawValue === null ? null : utils.date(rawValue); // Track the value of the input
    const [innerInputValue, setInnerInputValue] = _react.useState(parsedValue); // control the input text
    const [innerDisplayedInputValue, setInnerDisplayedInputValue] = _react.useState((0, _textFieldHelper.getDisplayDate)(utils, rawValue, inputFormat)); // Inspired from autocomplete: https://github.com/mui/material-ui/blob/2c89d036dc2e16f100528f161600dffc83241768/packages/mui-base/src/AutocompleteUnstyled/useAutocomplete.js#L185:L201
    const prevRawValue = _react.useRef();
    const prevLocale = _react.useRef(utils.locale);
    const prevInputFormat = _react.useRef(inputFormat);
    _react.useEffect(()=>{
        const rawValueHasChanged = rawValue !== prevRawValue.current;
        const localeHasChanged = utils.locale !== prevLocale.current;
        const inputFormatHasChanged = inputFormat !== prevInputFormat.current;
        prevRawValue.current = rawValue;
        prevLocale.current = utils.locale;
        prevInputFormat.current = inputFormat;
        if (!rawValueHasChanged && !localeHasChanged && !inputFormatHasChanged) return;
        const newParsedValue = rawValue === null ? null : utils.date(rawValue);
        const isAcceptedValue = rawValue === null || utils.isValid(newParsedValue);
        let innerEqualsParsed = innerInputValue === null && newParsedValue === null; // equal by being both null
        if (innerInputValue !== null && newParsedValue !== null) {
            const areEqual = utils.isEqual(innerInputValue, newParsedValue);
            if (areEqual) innerEqualsParsed = true;
            else {
                const diff = Math.abs(utils.getDiff(innerInputValue, newParsedValue)); // diff in ms
                innerEqualsParsed = diff === 0 ? areEqual // if no diff, use equal to test the time-zone
                 : diff < 1000; // accept a difference bellow 1s
            }
        }
        if (!localeHasChanged && !inputFormatHasChanged && (!isAcceptedValue || innerEqualsParsed)) return;
         // When dev set a new valid value, we trust them
        const newDisplayDate = (0, _textFieldHelper.getDisplayDate)(utils, rawValue, inputFormat);
        setInnerInputValue(newParsedValue);
        setInnerDisplayedInputValue(newDisplayDate);
    }, [
        utils,
        rawValue,
        inputFormat,
        innerInputValue
    ]);
    const handleChange = (text)=>{
        const finalString = text === "" || text === mask ? "" : text;
        setInnerDisplayedInputValue(finalString);
        const date = finalString === null ? null : utils.parse(finalString, inputFormat);
        if (ignoreInvalidInputs && !utils.isValid(date)) return;
        setInnerInputValue(date);
        onChange(date, finalString || undefined);
    };
    const rifmProps = (0, _rifm.useRifm)({
        value: innerDisplayedInputValue,
        onChange: handleChange,
        format: rifmFormatter || formatter
    });
    const inputStateArgs = shouldUseMaskedInput ? rifmProps : {
        value: innerDisplayedInputValue,
        onChange: (event)=>{
            handleChange(event.currentTarget.value);
        }
    };
    return (0, _extendsDefault.default)({
        label,
        disabled,
        error: validationError,
        inputProps: (0, _extendsDefault.default)({}, inputStateArgs, {
            disabled,
            placeholder: formatHelperText,
            readOnly,
            type: shouldUseMaskedInput ? "tel" : "text"
        }, inputProps)
    }, TextFieldProps);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","rifm":"jZ98k","./useUtils":"8WF4c","../utils/text-field-helper":"ej45O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jZ98k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Rifm", ()=>Rifm);
parcelHelpers.export(exports, "useRifm", ()=>useRifm);
var _react = require("react");
const useRifm = (props)=>{
    const [, refresh] = (0, _react.useReducer)((c)=>c + 1, 0);
    const valueRef = (0, _react.useRef)(null);
    const { replace, append } = props;
    const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support
    const isDeleleteButtonDownRef = (0, _react.useRef)(false);
    const onChange = (evt)=>{
        const eventValue = evt.target.value;
        valueRef.current = [
            eventValue,
            evt.target,
            eventValue.length > userValue.length,
            isDeleleteButtonDownRef.current,
            userValue === props.format(eventValue) // isNoOperation
        ];
        // that allows us to calculate right cursor position after formatting (see getCursorPosition)
        // then we format new value and call props.onChange with masked/formatted value
        // and finally we are able to set cursor position into right place
        refresh();
    }; // React prints warn on server in non production mode about useLayoutEffect usage
    (0, _react.useLayoutEffect)(()=>{
        if (valueRef.current == null) return;
        let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, isNoOperation] = valueRef.current;
        valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
        // in case of isDeleleteButtonDown cursor should move differently vs backspace
        const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
        const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
        const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
        const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols
        const clean = (str)=>(str.match(props.accept || /\d/g) || []).join("");
        const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
        // This works because we assume that format doesn't change the order of accepted symbols.
        // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
        // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
        // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
        // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
        // so for formatting just this function to determine cursor position after formatting is enough
        // with masking we need to do some additional checks see `mask` below
        const getCursorPosition = (val)=>{
            let start = 0;
            let cleanPos = 0;
            for(let i = 0; i !== valueBeforeSelectionStart.length; ++i){
                let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
                let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
                // For example fixes edge case with fixed point numbers:
                // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
                // that order of accepted symbols is not changed after format,
                // so here we don't update start position if other accepted symbols was inbetween current and new position
                if (newCleanPos - cleanPos > 1) {
                    newPos = start;
                    newCleanPos = cleanPos;
                }
                cleanPos = Math.max(newCleanPos, cleanPos);
                start = Math.max(start, newPos);
            }
            return start;
        }; // Masking part, for masks if size of mask is above some value
        // we need to replace symbols instead of do nothing as like in format
        if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
            let start = getCursorPosition(eventValue);
            const c = clean(eventValue.substr(start))[0];
            start = eventValue.indexOf(c, start);
            eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
        }
        let formattedValue = props.format(eventValue);
        if (append != null && // cursor at the end
        input.selectionStart === eventValue.length && !isNoOperation) {
            if (isSizeIncreaseOperation) formattedValue = append(formattedValue);
            else // If after delete last char is special character and we use append
            // delete it too
            // was: "12-3|" backspace pressed, then should be "12|"
            if (clean(formattedValue.slice(-1)) === "") formattedValue = formattedValue.slice(0, -1);
        }
        const replacedValue = replace ? replace(formattedValue) : formattedValue;
        if (userValue === replacedValue) // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
        else props.onChange(replacedValue);
        return ()=>{
            let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
            // like cursor jumping over refused symbols
            // as an example date mask: was "5|1-24-3" then user pressed "6"
            // it becomes "56-|12-43" with this code, and "56|-12-43" without
            if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) while(formattedValue[start] && clean(formattedValue[start]) === "")start += 1;
            input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
        };
    });
    (0, _react.useEffect)(()=>{
        // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
        // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
        // there is no way I found to distinguish in onChange
        // backspace or delete was called in some situations
        // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
        const handleKeyDown = (evt)=>{
            if (evt.code === "Delete") isDeleleteButtonDownRef.current = true;
        };
        const handleKeyUp = (evt)=>{
            if (evt.code === "Delete") isDeleleteButtonDownRef.current = false;
        };
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return {
        value: valueRef.current != null ? valueRef.current[0] : userValue,
        onChange
    };
};
const Rifm = (props)=>{
    const renderProps = useRifm(props);
    return props.children(renderProps);
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ej45O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDisplayDate", ()=>getDisplayDate);
parcelHelpers.export(exports, "getMaskFromCurrentFormat", ()=>getMaskFromCurrentFormat);
parcelHelpers.export(exports, "checkMaskIsValidForCurrentFormat", ()=>checkMaskIsValidForCurrentFormat);
parcelHelpers.export(exports, "maskedDateFormatter", ()=>maskedDateFormatter);
const getDisplayDate = (utils, rawValue, inputFormat)=>{
    const date = utils.date(rawValue);
    const isEmpty = rawValue === null;
    if (isEmpty) return "";
    return utils.isValid(date) ? utils.formatByString(// Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    date, inputFormat) : "";
};
const MASK_USER_INPUT_SYMBOL = "_";
const staticDateWith2DigitTokens = "2019-11-21T22:30:00.000";
const staticDateWith1DigitTokens = "2019-01-01T09:00:00.000";
function getMaskFromCurrentFormat(mask, format, acceptRegex, utils) {
    if (mask) return mask;
    const formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, "_");
    if (inferredFormatPatternWith1Digits === inferredFormatPatternWith2Digits) return inferredFormatPatternWith1Digits;
    return "";
}
function checkMaskIsValidForCurrentFormat(mask, format, acceptRegex, utils) {
    if (!mask) return false;
    const formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, "_");
    const isMaskValid = inferredFormatPatternWith2Digits === inferredFormatPatternWith1Digits && mask === inferredFormatPatternWith2Digits;
    !isMaskValid && utils.lib;
    return isMaskValid;
}
const maskedDateFormatter = (mask, acceptRegexp)=>(value)=>{
        let outputCharIndex = 0;
        return value.split("").map((char, inputCharIndex)=>{
            acceptRegexp.lastIndex = 0;
            if (outputCharIndex > mask.length - 1) return "";
            const maskChar = mask[outputCharIndex];
            const nextMaskChar = mask[outputCharIndex + 1];
            const acceptedChar = acceptRegexp.test(char) ? char : "";
            const formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;
            outputCharIndex += formattedChar.length;
            const isLastCharacter = inputCharIndex === value.length - 1;
            if (isLastCharacter && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
            return formattedChar ? formattedChar + nextMaskChar : "";
            return formattedChar;
        }).join("");
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4htX0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsLandscape", ()=>useIsLandscape);
var _react = require("react");
var _utils = require("@mui/utils");
var _utils1 = require("../utils/utils");
function getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const useIsLandscape = (views, customOrientation)=>{
    const [orientation, setOrientation] = _react.useState(getOrientation);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const eventHandler = ()=>{
            setOrientation(getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, _utils1.arrayIncludes)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};

},{"react":"gVheC","@mui/utils":"dv12b","../utils/utils":"jDQRM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Hcti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusManagement", ()=>useFocusManagement);
var _react = require("react");
const useFocusManagement = ({ autoFocus, openView })=>{
    const [focusedView, setFocusedView] = _react.useState(autoFocus ? openView : null);
    const setFocusedViewCallback = _react.useCallback((view)=>(newHasFocus)=>{
            if (newHasFocus) setFocusedView(view);
            else setFocusedView((prevFocusedView)=>view === prevFocusedView ? null : prevFocusedView);
        }, []);
    return {
        focusedView,
        setFocusedView: setFocusedViewCallback
    };
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aSdFm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCalendarOrClockPickerUtilityClass", ()=>getCalendarOrClockPickerUtilityClass);
parcelHelpers.export(exports, "calendarOrClockPickerClasses", ()=>calendarOrClockPickerClasses);
var _material = require("@mui/material");
function getCalendarOrClockPickerUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiCalendarOrClockPicker", slot);
}
const calendarOrClockPickerClasses = (0, _material.generateUtilityClasses)("MuiCalendarOrClockPicker", [
    "root",
    "mobileKeyboardInputView"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9CIcQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePickerState", ()=>usePickerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useOpenState = require("./useOpenState");
var _useUtils = require("./useUtils");
const usePickerState = (props, valueManager)=>{
    const { onAccept, onChange, value, closeOnSelect } = props;
    const utils = (0, _useUtils.useUtils)();
    const { isOpen, setIsOpen } = (0, _useOpenState.useOpenState)(props);
    const parsedDateValue = _react.useMemo(()=>valueManager.parseInput(utils, value), [
        valueManager,
        utils,
        value
    ]);
    const [lastValidDateValue, setLastValidDateValue] = _react.useState(parsedDateValue);
    const [dateState, setDateState] = _react.useState(()=>({
            committed: parsedDateValue,
            draft: parsedDateValue,
            resetFallback: parsedDateValue
        }));
    const setDate = _react.useCallback((params)=>{
        setDateState((prev)=>{
            switch(params.action){
                case "setAll":
                case "acceptAndClose":
                    return {
                        draft: params.value,
                        committed: params.value,
                        resetFallback: params.value
                    };
                case "setCommitted":
                    return (0, _extendsDefault.default)({}, prev, {
                        draft: params.value,
                        committed: params.value
                    });
                case "setDraft":
                    return (0, _extendsDefault.default)({}, prev, {
                        draft: params.value
                    });
                default:
                    return prev;
            }
        });
        if (params.forceOnChangeCall || !params.skipOnChangeCall && !valueManager.areValuesEqual(utils, dateState.committed, params.value)) onChange(params.value);
        if (params.action === "acceptAndClose") {
            setIsOpen(false);
            if (onAccept && !valueManager.areValuesEqual(utils, dateState.resetFallback, params.value)) onAccept(params.value);
        }
    }, [
        onAccept,
        onChange,
        setIsOpen,
        dateState,
        utils,
        valueManager
    ]);
    _react.useEffect(()=>{
        if (utils.isValid(parsedDateValue)) setLastValidDateValue(parsedDateValue);
    }, [
        utils,
        parsedDateValue
    ]);
    _react.useEffect(()=>{
        if (isOpen) // Update all dates in state to equal the current prop value
        setDate({
            action: "setAll",
            value: parsedDateValue,
            skipOnChangeCall: true
        });
    }, [
        isOpen
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Set the draft and committed date to equal the new prop value.
    if (!valueManager.areValuesEqual(utils, dateState.committed, parsedDateValue)) setDate({
        action: "setCommitted",
        value: parsedDateValue,
        skipOnChangeCall: true
    });
    const wrapperProps = _react.useMemo(()=>({
            open: isOpen,
            onClear: ()=>{
                // Reset all date in state to the empty value and close picker.
                setDate({
                    value: valueManager.emptyValue,
                    action: "acceptAndClose",
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, valueManager.emptyValue)
                });
            },
            onAccept: ()=>{
                // Set all date in state to equal the current draft value and close picker.
                setDate({
                    value: dateState.draft,
                    action: "acceptAndClose",
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, parsedDateValue)
                });
            },
            onDismiss: ()=>{
                // Set all dates in state to equal the last committed date.
                // e.g. Reset the state to the last committed value.
                setDate({
                    value: dateState.committed,
                    action: "acceptAndClose"
                });
            },
            onCancel: ()=>{
                // Set all dates in state to equal the last accepted date and close picker.
                // e.g. Reset the state to the last accepted value
                setDate({
                    value: dateState.resetFallback,
                    action: "acceptAndClose"
                });
            },
            onSetToday: ()=>{
                // Set all dates in state to equal today and close picker.
                setDate({
                    value: valueManager.getTodayValue(utils),
                    action: "acceptAndClose"
                });
            }
        }), [
        setDate,
        isOpen,
        utils,
        dateState,
        valueManager,
        value,
        parsedDateValue
    ]); // Mobile keyboard view is a special case.
    // When it's open picker should work like closed, because we are just showing text field
    const [isMobileKeyboardViewOpen, setMobileKeyboardViewOpen] = _react.useState(false);
    const pickerProps = _react.useMemo(()=>({
            parsedValue: dateState.draft,
            isMobileKeyboardViewOpen,
            toggleMobileKeyboardView: ()=>setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen),
            onDateChange: (newDate, wrapperVariant, selectionState = "partial")=>{
                switch(selectionState){
                    case "shallow":
                        // Update the `draft` state but do not fire `onChange`
                        return setDate({
                            action: "setDraft",
                            value: newDate,
                            skipOnChangeCall: true
                        });
                    case "partial":
                        // Update the `draft` state and fire `onChange`
                        return setDate({
                            action: "setDraft",
                            value: newDate
                        });
                    case "finish":
                        if (closeOnSelect != null ? closeOnSelect : wrapperVariant === "desktop") // Set all dates in state to equal the new date and close picker.
                        return setDate({
                            value: newDate,
                            action: "acceptAndClose"
                        });
                         // Updates the `committed` state and fire `onChange`
                        return setDate({
                            value: newDate,
                            action: "setCommitted"
                        });
                    default:
                        throw new Error("MUI: Invalid selectionState passed to `onDateChange`");
                }
            }
        }), [
        setDate,
        isMobileKeyboardViewOpen,
        dateState.draft,
        closeOnSelect
    ]);
    const handleInputChange = _react.useCallback((newParsedValue, keyboardInputValue)=>{
        const cleanParsedValue = valueManager.valueReducer ? valueManager.valueReducer(utils, lastValidDateValue, newParsedValue) : newParsedValue;
        onChange(cleanParsedValue, keyboardInputValue);
    }, [
        onChange,
        valueManager,
        lastValidDateValue,
        utils
    ]);
    const inputProps = _react.useMemo(()=>({
            onChange: handleInputChange,
            open: isOpen,
            rawValue: value,
            openPicker: ()=>setIsOpen(true)
        }), [
        handleInputChange,
        isOpen,
        value,
        setIsOpen
    ]);
    const pickerState = {
        pickerProps,
        inputProps,
        wrapperProps
    };
    _react.useDebugValue(pickerState, ()=>({
            MuiPickerState: {
                dateState,
                other: pickerState
            }
        }));
    return pickerState;
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","./useOpenState":"lgfam","./useUtils":"8WF4c","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lgfam":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOpenState", ()=>useOpenState);
var _react = require("react");
const useOpenState = ({ open, onOpen, onClose })=>{
    const isControllingOpenProp = _react.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = _react.useState(false); // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    _react.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = _react.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen
    };
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bpZXk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDatePicker", ()=>(0, _mobileDatePicker.MobileDatePicker));
var _mobileDatePicker = require("./MobileDatePicker");

},{"./MobileDatePicker":"6aSsH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6aSsH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileDatePicker", ()=>MobileDatePicker);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _shared = require("../DatePicker/shared");
var _datePickerToolbar = require("../DatePicker/DatePickerToolbar");
var _mobileWrapper = require("../internals/components/wrappers/MobileWrapper");
var _calendarOrClockPicker = require("../internals/components/CalendarOrClockPicker");
var _useDateValidation = require("../internals/hooks/validation/useDateValidation");
var _pureDateInput = require("../internals/components/PureDateInput");
var _usePickerState = require("../internals/hooks/usePickerState");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "ToolbarComponent",
    "value",
    "onChange",
    "components",
    "componentsProps"
];
const MobileDatePicker = /*#__PURE__*/ _react.forwardRef(function MobileDatePicker(inProps, ref) {
    const props = (0, _shared.useDatePickerDefaultizedProps)(inProps, "MuiMobileDatePicker");
    const validationError = (0, _useDateValidation.useDateValidation)(props) !== null;
    const { pickerProps, inputProps, wrapperProps } = (0, _usePickerState.usePickerState)(props, (0, _shared.datePickerValueManager)); // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.
    const { ToolbarComponent = (0, _datePickerToolbar.DatePickerToolbar), components, componentsProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const DateInputProps = (0, _extendsDefault.default)({}, inputProps, other, {
        components,
        componentsProps,
        ref,
        validationError
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileWrapper.MobileWrapper), (0, _extendsDefault.default)({}, other, wrapperProps, {
        DateInputProps: DateInputProps,
        PureDateInputComponent: (0, _pureDateInput.PureDateInput),
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarOrClockPicker.CalendarOrClockPicker), (0, _extendsDefault.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","../DatePicker/shared":"fKBw7","../DatePicker/DatePickerToolbar":"1kVoE","../internals/components/wrappers/MobileWrapper":"e4bBG","../internals/components/CalendarOrClockPicker":"gHmss","../internals/hooks/validation/useDateValidation":"hI2Vz","../internals/components/PureDateInput":"kaWPI","../internals/hooks/usePickerState":"9CIcQ","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e4bBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileWrapper", ()=>MobileWrapper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _wrapperVariantContext = require("./WrapperVariantContext");
var _pickersModalDialog = require("../PickersModalDialog");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "DateInputProps",
    "DialogProps",
    "onAccept",
    "onClear",
    "onDismiss",
    "onCancel",
    "onSetToday",
    "open",
    "PureDateInputComponent",
    "components",
    "componentsProps"
];
function MobileWrapper(props) {
    const { children, DateInputProps, DialogProps, onAccept, onClear, onDismiss, onCancel, onSetToday, open, PureDateInputComponent, components, componentsProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wrapperVariantContext.WrapperVariantContext).Provider, {
        value: "mobile",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PureDateInputComponent, (0, _extendsDefault.default)({
                components: components
            }, other, DateInputProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pickersModalDialog.PickersModalDialog), {
                DialogProps: DialogProps,
                onAccept: onAccept,
                onClear: onClear,
                onDismiss: onDismiss,
                onCancel: onCancel,
                onSetToday: onSetToday,
                open: open,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","./WrapperVariantContext":"fM3I2","../PickersModalDialog":"jWope","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jWope":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersModalDialog", ()=>PickersModalDialog);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _styles = require("@mui/material/styles");
var _dimensions = require("../constants/dimensions");
var _pickersActionBar = require("../../PickersActionBar");
var _jsxRuntime = require("react/jsx-runtime");
const PickersModalDialogRoot = (0, _styles.styled)((0, _dialogDefault.default))({
    [`& .${(0, _dialog.dialogClasses).container}`]: {
        outline: 0
    },
    [`& .${(0, _dialog.dialogClasses).paper}`]: {
        outline: 0,
        minWidth: (0, _dimensions.DIALOG_WIDTH)
    }
});
const PickersModalDialogContent = (0, _styles.styled)((0, _dialogContentDefault.default))({
    "&:first-of-type": {
        padding: 0
    }
});
const PickersModalDialog = (props)=>{
    var _components$ActionBar;
    const { children, DialogProps = {}, onAccept, onClear, onDismiss, onCancel, onSetToday, open, components, componentsProps } = props;
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, _pickersActionBar.PickersActionBar);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersModalDialogRoot, (0, _extendsDefault.default)({
        open: open,
        onClose: onDismiss
    }, DialogProps, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersModalDialogContent, {
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBar, (0, _extendsDefault.default)({
                onAccept: onAccept,
                onClear: onClear,
                onCancel: onCancel,
                onSetToday: onSetToday,
                actions: [
                    "cancel",
                    "accept"
                ]
            }, componentsProps == null ? void 0 : componentsProps.actionBar))
        ]
    }));
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/DialogContent":"jXMyc","@mui/material/Dialog":"cziPe","@mui/material/styles":"gNR9m","../constants/dimensions":"9lrdR","../../PickersActionBar":"9eqrR","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kaWPI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PureDateInput", ()=>PureDateInput);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _utils1 = require("../utils/utils");
var _useUtils = require("../hooks/useUtils");
var _textFieldHelper = require("../utils/text-field-helper");
const PureDateInput = /*#__PURE__*/ _react.forwardRef(function PureDateInput(props, ref) {
    const { disabled, getOpenDialogAriaText: getOpenDialogAriaTextProp, inputFormat, InputProps, inputRef, label, openPicker: onOpen, rawValue, renderInput, TextFieldProps = {}, validationError, className } = props;
    const localeText = (0, _useUtils.useLocaleText)(); // The prop can not be deprecated
    // Default is "Choose date, ...", but time pickers override it with "Choose time, ..."
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, _useUtils.useUtils)();
    const PureDateInputProps = _react.useMemo(()=>(0, _extendsDefault.default)({}, InputProps, {
            readOnly: true
        }), [
        InputProps
    ]);
    const inputValue = (0, _textFieldHelper.getDisplayDate)(utils, rawValue, inputFormat);
    const handleOnClick = (0, _utils.useEventCallback)((event)=>{
        event.stopPropagation();
        onOpen();
    });
    return renderInput((0, _extendsDefault.default)({
        label,
        disabled,
        ref,
        inputRef,
        error: validationError,
        InputProps: PureDateInputProps,
        className
    }, !props.readOnly && !props.disabled && {
        onClick: handleOnClick
    }, {
        inputProps: (0, _extendsDefault.default)({
            disabled,
            readOnly: true,
            "aria-readonly": true,
            "aria-label": getOpenDialogAriaText(rawValue, utils),
            value: inputValue
        }, !props.readOnly && {
            onClick: handleOnClick
        }, {
            onKeyDown: (0, _utils1.onSpaceOrEnter)(onOpen)
        })
    }, TextFieldProps));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../utils/utils":"jDQRM","../hooks/useUtils":"8WF4c","../utils/text-field-helper":"ej45O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gnhuS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizationProvider", ()=>(0, _localizationProvider.LocalizationProvider));
parcelHelpers.export(exports, "MuiPickersAdapterContext", ()=>(0, _localizationProvider.MuiPickersAdapterContext));
var _localizationProvider = require("./LocalizationProvider");

},{"./LocalizationProvider":"kngq7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dylFK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PickersDay", ()=>(0, _pickersDay.PickersDay));
parcelHelpers.export(exports, "pickersDayClasses", ()=>(0, _pickersDayClasses.pickersDayClasses));
parcelHelpers.export(exports, "getPickersDayUtilityClass", ()=>(0, _pickersDayClasses.getPickersDayUtilityClass));
var _pickersDay = require("./PickersDay");
var _pickersDayClasses = require("./pickersDayClasses");

},{"./PickersDay":"azu06","./pickersDayClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1X56V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdapterDateFns", ()=>AdapterDateFns);
var _dateFns = require("@date-io/date-fns");
var _dateFnsDefault = parcelHelpers.interopDefault(_dateFns);
var _enUS = require("date-fns/locale/en-US"); // @ts-ignore
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _longFormatters = require("date-fns/_lib/format/longFormatters");
var _longFormattersDefault = parcelHelpers.interopDefault(_longFormatters);
const formatTokenMap = {
    y: "year",
    yy: "year",
    yyy: "year",
    yyyy: "year",
    MMMM: "month",
    MM: "month",
    DD: "day",
    d: "day",
    dd: "day",
    H: "hour",
    HH: "hour",
    h: "hour",
    hh: "hour",
    mm: "minute",
    ss: "second",
    a: "am-pm",
    aa: "am-pm",
    aaa: "am-pm"
};
class AdapterDateFns extends (0, _dateFnsDefault.default) {
    constructor(...args){
        super(...args);
        this.formatTokenMap = formatTokenMap;
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g; // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, _longFormattersDefault.default)[firstCharacter];
                    const locale = this.locale || (0, _enUSDefault.default);
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("");
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
        };
    }
}

},{"@date-io/date-fns":"4RBxT","date-fns/locale/en-US":"lwe63","date-fns/_lib/format/longFormatters":"4sS56","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4RBxT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateFnsUtils);
var _addDays = require("date-fns/addDays");
var _addDaysDefault = parcelHelpers.interopDefault(_addDays);
var _addSeconds = require("date-fns/addSeconds");
var _addSecondsDefault = parcelHelpers.interopDefault(_addSeconds);
var _addMinutes = require("date-fns/addMinutes");
var _addMinutesDefault = parcelHelpers.interopDefault(_addMinutes);
var _addHours = require("date-fns/addHours");
var _addHoursDefault = parcelHelpers.interopDefault(_addHours);
var _addWeeks = require("date-fns/addWeeks");
var _addWeeksDefault = parcelHelpers.interopDefault(_addWeeks);
var _addMonths = require("date-fns/addMonths");
var _addMonthsDefault = parcelHelpers.interopDefault(_addMonths);
var _addYears = require("date-fns/addYears");
var _addYearsDefault = parcelHelpers.interopDefault(_addYears);
var _differenceInYears = require("date-fns/differenceInYears");
var _differenceInYearsDefault = parcelHelpers.interopDefault(_differenceInYears);
var _differenceInQuarters = require("date-fns/differenceInQuarters");
var _differenceInQuartersDefault = parcelHelpers.interopDefault(_differenceInQuarters);
var _differenceInMonths = require("date-fns/differenceInMonths");
var _differenceInMonthsDefault = parcelHelpers.interopDefault(_differenceInMonths);
var _differenceInWeeks = require("date-fns/differenceInWeeks");
var _differenceInWeeksDefault = parcelHelpers.interopDefault(_differenceInWeeks);
var _differenceInDays = require("date-fns/differenceInDays");
var _differenceInDaysDefault = parcelHelpers.interopDefault(_differenceInDays);
var _differenceInHours = require("date-fns/differenceInHours");
var _differenceInHoursDefault = parcelHelpers.interopDefault(_differenceInHours);
var _differenceInMinutes = require("date-fns/differenceInMinutes");
var _differenceInMinutesDefault = parcelHelpers.interopDefault(_differenceInMinutes);
var _differenceInSeconds = require("date-fns/differenceInSeconds");
var _differenceInSecondsDefault = parcelHelpers.interopDefault(_differenceInSeconds);
var _differenceInMilliseconds = require("date-fns/differenceInMilliseconds");
var _differenceInMillisecondsDefault = parcelHelpers.interopDefault(_differenceInMilliseconds);
var _eachDayOfInterval = require("date-fns/eachDayOfInterval");
var _eachDayOfIntervalDefault = parcelHelpers.interopDefault(_eachDayOfInterval);
var _endOfDay = require("date-fns/endOfDay");
var _endOfDayDefault = parcelHelpers.interopDefault(_endOfDay);
var _endOfWeek = require("date-fns/endOfWeek");
var _endOfWeekDefault = parcelHelpers.interopDefault(_endOfWeek);
var _endOfYear = require("date-fns/endOfYear");
var _endOfYearDefault = parcelHelpers.interopDefault(_endOfYear);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _getDate = require("date-fns/getDate");
var _getDateDefault = parcelHelpers.interopDefault(_getDate);
var _getDay = require("date-fns/getDay");
var _getDayDefault = parcelHelpers.interopDefault(_getDay);
var _getDaysInMonth = require("date-fns/getDaysInMonth");
var _getDaysInMonthDefault = parcelHelpers.interopDefault(_getDaysInMonth);
var _getHours = require("date-fns/getHours");
var _getHoursDefault = parcelHelpers.interopDefault(_getHours);
var _getMinutes = require("date-fns/getMinutes");
var _getMinutesDefault = parcelHelpers.interopDefault(_getMinutes);
var _getMonth = require("date-fns/getMonth");
var _getMonthDefault = parcelHelpers.interopDefault(_getMonth);
var _getSeconds = require("date-fns/getSeconds");
var _getSecondsDefault = parcelHelpers.interopDefault(_getSeconds);
var _getYear = require("date-fns/getYear");
var _getYearDefault = parcelHelpers.interopDefault(_getYear);
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _isBefore = require("date-fns/isBefore");
var _isBeforeDefault = parcelHelpers.interopDefault(_isBefore);
var _isEqual = require("date-fns/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isSameDay = require("date-fns/isSameDay");
var _isSameDayDefault = parcelHelpers.interopDefault(_isSameDay);
var _isSameYear = require("date-fns/isSameYear");
var _isSameYearDefault = parcelHelpers.interopDefault(_isSameYear);
var _isSameMonth = require("date-fns/isSameMonth");
var _isSameMonthDefault = parcelHelpers.interopDefault(_isSameMonth);
var _isSameHour = require("date-fns/isSameHour");
var _isSameHourDefault = parcelHelpers.interopDefault(_isSameHour);
var _isValid = require("date-fns/isValid");
var _isValidDefault = parcelHelpers.interopDefault(_isValid);
var _parse = require("date-fns/parse");
var _parseDefault = parcelHelpers.interopDefault(_parse);
var _setDate = require("date-fns/setDate");
var _setDateDefault = parcelHelpers.interopDefault(_setDate);
var _setHours = require("date-fns/setHours");
var _setHoursDefault = parcelHelpers.interopDefault(_setHours);
var _setMinutes = require("date-fns/setMinutes");
var _setMinutesDefault = parcelHelpers.interopDefault(_setMinutes);
var _setMonth = require("date-fns/setMonth");
var _setMonthDefault = parcelHelpers.interopDefault(_setMonth);
var _setSeconds = require("date-fns/setSeconds");
var _setSecondsDefault = parcelHelpers.interopDefault(_setSeconds);
var _setYear = require("date-fns/setYear");
var _setYearDefault = parcelHelpers.interopDefault(_setYear);
var _startOfDay = require("date-fns/startOfDay");
var _startOfDayDefault = parcelHelpers.interopDefault(_startOfDay);
var _startOfMonth = require("date-fns/startOfMonth");
var _startOfMonthDefault = parcelHelpers.interopDefault(_startOfMonth);
var _endOfMonth = require("date-fns/endOfMonth");
var _endOfMonthDefault = parcelHelpers.interopDefault(_endOfMonth);
var _startOfWeek = require("date-fns/startOfWeek");
var _startOfWeekDefault = parcelHelpers.interopDefault(_startOfWeek);
var _startOfYear = require("date-fns/startOfYear");
var _startOfYearDefault = parcelHelpers.interopDefault(_startOfYear);
var _parseISO = require("date-fns/parseISO");
var _parseISODefault = parcelHelpers.interopDefault(_parseISO);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
var _isWithinInterval = require("date-fns/isWithinInterval");
var _isWithinIntervalDefault = parcelHelpers.interopDefault(_isWithinInterval);
var _longFormatters = require("date-fns/_lib/format/longFormatters");
var _longFormattersDefault = parcelHelpers.interopDefault(_longFormatters);
var _enUS = require("date-fns/locale/en-US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
const defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy"
};
class DateFnsUtils {
    isBeforeMonth(value, comparing) {
        return (0, _isBeforeDefault.default)(value, (0, _startOfMonthDefault.default)(comparing));
    }
    isAfterMonth(value, comparing) {
        return (0, _isAfterDefault.default)(value, (0, _startOfMonthDefault.default)(comparing));
    }
    constructor({ locale, formats } = {}){
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            var _a;
            if (this.locale) return /a/.test((_a = this.locale.formatLong) === null || _a === void 0 ? void 0 : _a.time());
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = (format)=>{
            var _a, _b;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            const locale = this.locale || (0, _enUSDefault.default);
            return (_b = (_a = format.match(longFormatRegexp)) === null || _a === void 0 ? void 0 : _a.map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, _longFormattersDefault.default)[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format;
        };
        this.parseISO = (isoString)=>{
            return (0, _parseISODefault.default)(isoString);
        };
        this.toISO = (value)=>{
            return (0, _formatISODefault.default)(value, {
                format: "extended"
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _a;
            return ((_a = this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = (value, count)=>{
            return (0, _addSecondsDefault.default)(value, count);
        };
        this.addMinutes = (value, count)=>{
            return (0, _addMinutesDefault.default)(value, count);
        };
        this.addHours = (value, count)=>{
            return (0, _addHoursDefault.default)(value, count);
        };
        this.addDays = (value, count)=>{
            return (0, _addDaysDefault.default)(value, count);
        };
        this.addWeeks = (value, count)=>{
            return (0, _addWeeksDefault.default)(value, count);
        };
        this.addMonths = (value, count)=>{
            return (0, _addMonthsDefault.default)(value, count);
        };
        this.addYears = (value, count)=>{
            return (0, _addYearsDefault.default)(value, count);
        };
        this.isValid = (value)=>{
            return (0, _isValidDefault.default)(this.date(value));
        };
        this.getDiff = (value, comparing, unit)=>{
            var _a;
            // we output 0 if the compare date is string and parsing is not valid
            const dateToCompare = (_a = this.date(comparing)) !== null && _a !== void 0 ? _a : value;
            if (!this.isValid(dateToCompare)) return 0;
            switch(unit){
                case "years":
                    return (0, _differenceInYearsDefault.default)(value, dateToCompare);
                case "quarters":
                    return (0, _differenceInQuartersDefault.default)(value, dateToCompare);
                case "months":
                    return (0, _differenceInMonthsDefault.default)(value, dateToCompare);
                case "weeks":
                    return (0, _differenceInWeeksDefault.default)(value, dateToCompare);
                case "days":
                    return (0, _differenceInDaysDefault.default)(value, dateToCompare);
                case "hours":
                    return (0, _differenceInHoursDefault.default)(value, dateToCompare);
                case "minutes":
                    return (0, _differenceInMinutesDefault.default)(value, dateToCompare);
                case "seconds":
                    return (0, _differenceInSecondsDefault.default)(value, dateToCompare);
                default:
                    return (0, _differenceInMillisecondsDefault.default)(value, dateToCompare);
            }
        };
        this.isAfter = (value, comparing)=>{
            return (0, _isAfterDefault.default)(value, comparing);
        };
        this.isBefore = (value, comparing)=>{
            return (0, _isBeforeDefault.default)(value, comparing);
        };
        this.startOfDay = (value)=>{
            return (0, _startOfDayDefault.default)(value);
        };
        this.endOfDay = (value)=>{
            return (0, _endOfDayDefault.default)(value);
        };
        this.getHours = (value)=>{
            return (0, _getHoursDefault.default)(value);
        };
        this.setHours = (value, count)=>{
            return (0, _setHoursDefault.default)(value, count);
        };
        this.setMinutes = (value, count)=>{
            return (0, _setMinutesDefault.default)(value, count);
        };
        this.getSeconds = (value)=>{
            return (0, _getSecondsDefault.default)(value);
        };
        this.setSeconds = (value, count)=>{
            return (0, _setSecondsDefault.default)(value, count);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, _isSameDayDefault.default)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, _isSameMonthDefault.default)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, _isSameYearDefault.default)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, _isSameHourDefault.default)(value, comparing);
        };
        this.startOfYear = (value)=>{
            return (0, _startOfYearDefault.default)(value);
        };
        this.endOfYear = (value)=>{
            return (0, _endOfYearDefault.default)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, _startOfMonthDefault.default)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, _endOfMonthDefault.default)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, _startOfWeekDefault.default)(value, {
                locale: this.locale
            });
        };
        this.endOfWeek = (value)=>{
            return (0, _endOfWeekDefault.default)(value, {
                locale: this.locale
            });
        };
        this.getYear = (value)=>{
            return (0, _getYearDefault.default)(value);
        };
        this.setYear = (value, count)=>{
            return (0, _setYearDefault.default)(value, count);
        };
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, _parseDefault.default)(value, formatString, new Date(), {
                locale: this.locale
            });
        };
        this.format = (date, formatKey)=>{
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString)=>{
            return (0, _formatDefault.default)(date, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (date, comparing)=>{
            if (date === null && comparing === null) return true;
            return (0, _isEqualDefault.default)(date, comparing);
        };
        this.isNull = (date)=>{
            return date === null;
        };
        this.isAfterDay = (date, value)=>{
            return (0, _isAfterDefault.default)(date, (0, _endOfDayDefault.default)(value));
        };
        this.isBeforeDay = (date, value)=>{
            return (0, _isBeforeDefault.default)(date, (0, _startOfDayDefault.default)(value));
        };
        this.isBeforeYear = (date, value)=>{
            return (0, _isBeforeDefault.default)(date, (0, _startOfYearDefault.default)(value));
        };
        this.isAfterYear = (date, value)=>{
            return (0, _isAfterDefault.default)(date, (0, _endOfYearDefault.default)(value));
        };
        this.isWithinRange = (date, [start, end])=>{
            return (0, _isWithinIntervalDefault.default)(date, {
                start,
                end
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getMinutes = (date)=>{
            return (0, _getMinutesDefault.default)(date);
        };
        this.getDate = (date)=>{
            return (0, _getDateDefault.default)(date);
        };
        this.setDate = (date, count)=>{
            return (0, _setDateDefault.default)(date, count);
        };
        this.getMonth = (date)=>{
            return (0, _getMonthDefault.default)(date);
        };
        this.getDaysInMonth = (date)=>{
            return (0, _getDaysInMonthDefault.default)(date);
        };
        this.setMonth = (date, count)=>{
            return (0, _setMonthDefault.default)(date, count);
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = (date)=>{
            return (0, _addMonthsDefault.default)(date, 1);
        };
        this.getPreviousMonth = (date)=>{
            return (0, _addMonthsDefault.default)(date, -1);
        };
        this.getMonthArray = (date)=>{
            const firstMonth = (0, _startOfYearDefault.default)(date);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (date, time)=>{
            return this.setSeconds(this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time)), this.getSeconds(time));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, _eachDayOfIntervalDefault.default)({
                start: (0, _startOfWeekDefault.default)(now, {
                    locale: this.locale
                }),
                end: (0, _endOfWeekDefault.default)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, "EEEEEE"));
        };
        this.getWeekArray = (date)=>{
            const start = (0, _startOfWeekDefault.default)((0, _startOfMonthDefault.default)(date), {
                locale: this.locale
            });
            const end = (0, _endOfWeekDefault.default)((0, _endOfMonthDefault.default)(date), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            let lastDay = null;
            while((0, _isBeforeDefault.default)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                const day = (0, _getDayDefault.default)(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = (0, _addDaysDefault.default)(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, _startOfYearDefault.default)(start);
            const endDate = (0, _endOfYearDefault.default)(end);
            const years = [];
            let current = startDate;
            while((0, _isBeforeDefault.default)(current, endDate)){
                years.push(current);
                current = (0, _addYearsDefault.default)(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
}

},{"date-fns/addDays":"6XOcT","date-fns/addSeconds":"4Dt7q","date-fns/addMinutes":"3kpVW","date-fns/addHours":"edMlQ","date-fns/addWeeks":"lwUCs","date-fns/addMonths":"4X9y5","date-fns/addYears":"as84l","date-fns/differenceInYears":"btMPu","date-fns/differenceInQuarters":"kJ1sT","date-fns/differenceInMonths":"3dR9p","date-fns/differenceInWeeks":"b5HX5","date-fns/differenceInDays":"gLOot","date-fns/differenceInHours":"2zuWO","date-fns/differenceInMinutes":"ecpcR","date-fns/differenceInSeconds":"j294I","date-fns/differenceInMilliseconds":"30xWu","date-fns/eachDayOfInterval":"fEX0N","date-fns/endOfDay":"9JQf2","date-fns/endOfWeek":"6JnIb","date-fns/endOfYear":"75W7d","date-fns/format":"3Acgz","date-fns/getDate":"8C9eO","date-fns/getDay":"OE50j","date-fns/getDaysInMonth":"kagXl","date-fns/getHours":"4rezk","date-fns/getMinutes":"tYf0L","date-fns/getMonth":"i9gj3","date-fns/getSeconds":"8xyG9","date-fns/getYear":"1o5Yb","date-fns/isAfter":"h7lRu","date-fns/isBefore":"l0WTP","date-fns/isEqual":"5DZDY","date-fns/isSameDay":"eC4tq","date-fns/isSameYear":"lLQOp","date-fns/isSameMonth":"3NTIM","date-fns/isSameHour":"aEVKA","date-fns/isValid":"iFULx","date-fns/parse":"8pqAb","date-fns/setDate":"q9Izj","date-fns/setHours":"iG5Uv","date-fns/setMinutes":"fH1Fu","date-fns/setMonth":"6F1a7","date-fns/setSeconds":"38SuV","date-fns/setYear":"3zvJC","date-fns/startOfDay":"6Tgor","date-fns/startOfMonth":"aS0k4","date-fns/endOfMonth":"hPDZF","date-fns/startOfWeek":"dDXEC","date-fns/startOfYear":"jls7k","date-fns/parseISO":"a9ONv","date-fns/formatISO":"6v9Iq","date-fns/isWithinInterval":"krg17","date-fns/_lib/format/longFormatters":"4sS56","date-fns/locale/en-US":"lwe63","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4sS56":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;

},{}],"3v5JA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeekPicker", ()=>WeekPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _dateFns = require("date-fns");
var _customPicker = require("./CustomPicker");
const WeekPicker = ({ label = "Select Week", value, onChange, InputIcon })=>{
    const [open, setOpen] = (0, _react.useState)(false);
    var _value_start;
    const selectedDate = (0, _dateFns.nextFriday)(new Date((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : ""));
    const selectedWeek = {
        start: (0, _dateFns.startOfWeek)(selectedDate),
        end: (0, _dateFns.endOfWeek)(selectedDate)
    };
    const handleOnChange = (val)=>{
        onChange(val ? {
            start: (0, _dateFns.startOfWeek)(val),
            end: (0, _dateFns.endOfWeek)(val)
        } : val);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "flex",
                gap: 1
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomButton), {
                    "aria-label": "Previous week",
                    variant: "outlined",
                    onClick: ()=>handleOnChange((0, _dateFns.previousFriday)(selectedDate)),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.ChevronLeft), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                    label: label,
                    value: selectedDate,
                    onChange: handleOnChange,
                    renderDay: (0, _customPicker.renderPickerDays)(selectedWeek),
                    open: open,
                    onOpen: ()=>setOpen(true),
                    onClose: ()=>setOpen(false),
                    renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                            ...params,
                            inputProps: {
                                ...params.inputProps,
                                readOnly: true
                            },
                            InputProps: {
                                ...params.InputProps,
                                endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.InputAdornment), {
                                    position: "end",
                                    children: InputIcon
                                })
                            },
                            variant: "outlined",
                            InputLabelProps: {
                                shrink: true
                            },
                            margin: "dense",
                            size: "small",
                            onClick: ()=>setOpen(true)
                        }),
                    inputFormat: "'W/E' do MMM",
                    showDaysOutsideCurrentMonth: true,
                    disableMaskedInput: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomButton), {
                    "aria-label": "Next week",
                    variant: "outlined",
                    onClick: ()=>handleOnChange((0, _dateFns.nextFriday)(selectedDate)),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.ChevronRight), {})
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","@mui/x-date-pickers":"lcIJt","@mui/x-date-pickers/AdapterDateFns":"1X56V","date-fns":"5Pdd3","./CustomPicker":"48tQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4DI4K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Abc", ()=>(0, _abcDefault.default));
parcelHelpers.export(exports, "AbcOutlined", ()=>(0, _abcOutlinedDefault.default));
parcelHelpers.export(exports, "AbcRounded", ()=>(0, _abcRoundedDefault.default));
parcelHelpers.export(exports, "AbcSharp", ()=>(0, _abcSharpDefault.default));
parcelHelpers.export(exports, "AbcTwoTone", ()=>(0, _abcTwoToneDefault.default));
parcelHelpers.export(exports, "AcUnit", ()=>(0, _acUnitDefault.default));
parcelHelpers.export(exports, "AcUnitOutlined", ()=>(0, _acUnitOutlinedDefault.default));
parcelHelpers.export(exports, "AcUnitRounded", ()=>(0, _acUnitRoundedDefault.default));
parcelHelpers.export(exports, "AcUnitSharp", ()=>(0, _acUnitSharpDefault.default));
parcelHelpers.export(exports, "AcUnitTwoTone", ()=>(0, _acUnitTwoToneDefault.default));
parcelHelpers.export(exports, "AccessAlarm", ()=>(0, _accessAlarmDefault.default));
parcelHelpers.export(exports, "AccessAlarmOutlined", ()=>(0, _accessAlarmOutlinedDefault.default));
parcelHelpers.export(exports, "AccessAlarmRounded", ()=>(0, _accessAlarmRoundedDefault.default));
parcelHelpers.export(exports, "AccessAlarmSharp", ()=>(0, _accessAlarmSharpDefault.default));
parcelHelpers.export(exports, "AccessAlarmTwoTone", ()=>(0, _accessAlarmTwoToneDefault.default));
parcelHelpers.export(exports, "AccessAlarms", ()=>(0, _accessAlarmsDefault.default));
parcelHelpers.export(exports, "AccessAlarmsOutlined", ()=>(0, _accessAlarmsOutlinedDefault.default));
parcelHelpers.export(exports, "AccessAlarmsRounded", ()=>(0, _accessAlarmsRoundedDefault.default));
parcelHelpers.export(exports, "AccessAlarmsSharp", ()=>(0, _accessAlarmsSharpDefault.default));
parcelHelpers.export(exports, "AccessAlarmsTwoTone", ()=>(0, _accessAlarmsTwoToneDefault.default));
parcelHelpers.export(exports, "AccessTime", ()=>(0, _accessTimeDefault.default));
parcelHelpers.export(exports, "AccessTimeFilled", ()=>(0, _accessTimeFilledDefault.default));
parcelHelpers.export(exports, "AccessTimeFilledOutlined", ()=>(0, _accessTimeFilledOutlinedDefault.default));
parcelHelpers.export(exports, "AccessTimeFilledRounded", ()=>(0, _accessTimeFilledRoundedDefault.default));
parcelHelpers.export(exports, "AccessTimeFilledSharp", ()=>(0, _accessTimeFilledSharpDefault.default));
parcelHelpers.export(exports, "AccessTimeFilledTwoTone", ()=>(0, _accessTimeFilledTwoToneDefault.default));
parcelHelpers.export(exports, "AccessTimeOutlined", ()=>(0, _accessTimeOutlinedDefault.default));
parcelHelpers.export(exports, "AccessTimeRounded", ()=>(0, _accessTimeRoundedDefault.default));
parcelHelpers.export(exports, "AccessTimeSharp", ()=>(0, _accessTimeSharpDefault.default));
parcelHelpers.export(exports, "AccessTimeTwoTone", ()=>(0, _accessTimeTwoToneDefault.default));
parcelHelpers.export(exports, "Accessibility", ()=>(0, _accessibilityDefault.default));
parcelHelpers.export(exports, "AccessibilityNew", ()=>(0, _accessibilityNewDefault.default));
parcelHelpers.export(exports, "AccessibilityNewOutlined", ()=>(0, _accessibilityNewOutlinedDefault.default));
parcelHelpers.export(exports, "AccessibilityNewRounded", ()=>(0, _accessibilityNewRoundedDefault.default));
parcelHelpers.export(exports, "AccessibilityNewSharp", ()=>(0, _accessibilityNewSharpDefault.default));
parcelHelpers.export(exports, "AccessibilityNewTwoTone", ()=>(0, _accessibilityNewTwoToneDefault.default));
parcelHelpers.export(exports, "AccessibilityOutlined", ()=>(0, _accessibilityOutlinedDefault.default));
parcelHelpers.export(exports, "AccessibilityRounded", ()=>(0, _accessibilityRoundedDefault.default));
parcelHelpers.export(exports, "AccessibilitySharp", ()=>(0, _accessibilitySharpDefault.default));
parcelHelpers.export(exports, "AccessibilityTwoTone", ()=>(0, _accessibilityTwoToneDefault.default));
parcelHelpers.export(exports, "Accessible", ()=>(0, _accessibleDefault.default));
parcelHelpers.export(exports, "AccessibleForward", ()=>(0, _accessibleForwardDefault.default));
parcelHelpers.export(exports, "AccessibleForwardOutlined", ()=>(0, _accessibleForwardOutlinedDefault.default));
parcelHelpers.export(exports, "AccessibleForwardRounded", ()=>(0, _accessibleForwardRoundedDefault.default));
parcelHelpers.export(exports, "AccessibleForwardSharp", ()=>(0, _accessibleForwardSharpDefault.default));
parcelHelpers.export(exports, "AccessibleForwardTwoTone", ()=>(0, _accessibleForwardTwoToneDefault.default));
parcelHelpers.export(exports, "AccessibleOutlined", ()=>(0, _accessibleOutlinedDefault.default));
parcelHelpers.export(exports, "AccessibleRounded", ()=>(0, _accessibleRoundedDefault.default));
parcelHelpers.export(exports, "AccessibleSharp", ()=>(0, _accessibleSharpDefault.default));
parcelHelpers.export(exports, "AccessibleTwoTone", ()=>(0, _accessibleTwoToneDefault.default));
parcelHelpers.export(exports, "AccountBalance", ()=>(0, _accountBalanceDefault.default));
parcelHelpers.export(exports, "AccountBalanceOutlined", ()=>(0, _accountBalanceOutlinedDefault.default));
parcelHelpers.export(exports, "AccountBalanceRounded", ()=>(0, _accountBalanceRoundedDefault.default));
parcelHelpers.export(exports, "AccountBalanceSharp", ()=>(0, _accountBalanceSharpDefault.default));
parcelHelpers.export(exports, "AccountBalanceTwoTone", ()=>(0, _accountBalanceTwoToneDefault.default));
parcelHelpers.export(exports, "AccountBalanceWallet", ()=>(0, _accountBalanceWalletDefault.default));
parcelHelpers.export(exports, "AccountBalanceWalletOutlined", ()=>(0, _accountBalanceWalletOutlinedDefault.default));
parcelHelpers.export(exports, "AccountBalanceWalletRounded", ()=>(0, _accountBalanceWalletRoundedDefault.default));
parcelHelpers.export(exports, "AccountBalanceWalletSharp", ()=>(0, _accountBalanceWalletSharpDefault.default));
parcelHelpers.export(exports, "AccountBalanceWalletTwoTone", ()=>(0, _accountBalanceWalletTwoToneDefault.default));
parcelHelpers.export(exports, "AccountBox", ()=>(0, _accountBoxDefault.default));
parcelHelpers.export(exports, "AccountBoxOutlined", ()=>(0, _accountBoxOutlinedDefault.default));
parcelHelpers.export(exports, "AccountBoxRounded", ()=>(0, _accountBoxRoundedDefault.default));
parcelHelpers.export(exports, "AccountBoxSharp", ()=>(0, _accountBoxSharpDefault.default));
parcelHelpers.export(exports, "AccountBoxTwoTone", ()=>(0, _accountBoxTwoToneDefault.default));
parcelHelpers.export(exports, "AccountCircle", ()=>(0, _accountCircleDefault.default));
parcelHelpers.export(exports, "AccountCircleOutlined", ()=>(0, _accountCircleOutlinedDefault.default));
parcelHelpers.export(exports, "AccountCircleRounded", ()=>(0, _accountCircleRoundedDefault.default));
parcelHelpers.export(exports, "AccountCircleSharp", ()=>(0, _accountCircleSharpDefault.default));
parcelHelpers.export(exports, "AccountCircleTwoTone", ()=>(0, _accountCircleTwoToneDefault.default));
parcelHelpers.export(exports, "AccountTree", ()=>(0, _accountTreeDefault.default));
parcelHelpers.export(exports, "AccountTreeOutlined", ()=>(0, _accountTreeOutlinedDefault.default));
parcelHelpers.export(exports, "AccountTreeRounded", ()=>(0, _accountTreeRoundedDefault.default));
parcelHelpers.export(exports, "AccountTreeSharp", ()=>(0, _accountTreeSharpDefault.default));
parcelHelpers.export(exports, "AccountTreeTwoTone", ()=>(0, _accountTreeTwoToneDefault.default));
parcelHelpers.export(exports, "AdUnits", ()=>(0, _adUnitsDefault.default));
parcelHelpers.export(exports, "AdUnitsOutlined", ()=>(0, _adUnitsOutlinedDefault.default));
parcelHelpers.export(exports, "AdUnitsRounded", ()=>(0, _adUnitsRoundedDefault.default));
parcelHelpers.export(exports, "AdUnitsSharp", ()=>(0, _adUnitsSharpDefault.default));
parcelHelpers.export(exports, "AdUnitsTwoTone", ()=>(0, _adUnitsTwoToneDefault.default));
parcelHelpers.export(exports, "Adb", ()=>(0, _adbDefault.default));
parcelHelpers.export(exports, "AdbOutlined", ()=>(0, _adbOutlinedDefault.default));
parcelHelpers.export(exports, "AdbRounded", ()=>(0, _adbRoundedDefault.default));
parcelHelpers.export(exports, "AdbSharp", ()=>(0, _adbSharpDefault.default));
parcelHelpers.export(exports, "AdbTwoTone", ()=>(0, _adbTwoToneDefault.default));
parcelHelpers.export(exports, "Add", ()=>(0, _addDefault.default));
parcelHelpers.export(exports, "AddAPhoto", ()=>(0, _addAPhotoDefault.default));
parcelHelpers.export(exports, "AddAPhotoOutlined", ()=>(0, _addAPhotoOutlinedDefault.default));
parcelHelpers.export(exports, "AddAPhotoRounded", ()=>(0, _addAPhotoRoundedDefault.default));
parcelHelpers.export(exports, "AddAPhotoSharp", ()=>(0, _addAPhotoSharpDefault.default));
parcelHelpers.export(exports, "AddAPhotoTwoTone", ()=>(0, _addAPhotoTwoToneDefault.default));
parcelHelpers.export(exports, "AddAlarm", ()=>(0, _addAlarmDefault.default));
parcelHelpers.export(exports, "AddAlarmOutlined", ()=>(0, _addAlarmOutlinedDefault.default));
parcelHelpers.export(exports, "AddAlarmRounded", ()=>(0, _addAlarmRoundedDefault.default));
parcelHelpers.export(exports, "AddAlarmSharp", ()=>(0, _addAlarmSharpDefault.default));
parcelHelpers.export(exports, "AddAlarmTwoTone", ()=>(0, _addAlarmTwoToneDefault.default));
parcelHelpers.export(exports, "AddAlert", ()=>(0, _addAlertDefault.default));
parcelHelpers.export(exports, "AddAlertOutlined", ()=>(0, _addAlertOutlinedDefault.default));
parcelHelpers.export(exports, "AddAlertRounded", ()=>(0, _addAlertRoundedDefault.default));
parcelHelpers.export(exports, "AddAlertSharp", ()=>(0, _addAlertSharpDefault.default));
parcelHelpers.export(exports, "AddAlertTwoTone", ()=>(0, _addAlertTwoToneDefault.default));
parcelHelpers.export(exports, "AddBox", ()=>(0, _addBoxDefault.default));
parcelHelpers.export(exports, "AddBoxOutlined", ()=>(0, _addBoxOutlinedDefault.default));
parcelHelpers.export(exports, "AddBoxRounded", ()=>(0, _addBoxRoundedDefault.default));
parcelHelpers.export(exports, "AddBoxSharp", ()=>(0, _addBoxSharpDefault.default));
parcelHelpers.export(exports, "AddBoxTwoTone", ()=>(0, _addBoxTwoToneDefault.default));
parcelHelpers.export(exports, "AddBusiness", ()=>(0, _addBusinessDefault.default));
parcelHelpers.export(exports, "AddBusinessOutlined", ()=>(0, _addBusinessOutlinedDefault.default));
parcelHelpers.export(exports, "AddBusinessRounded", ()=>(0, _addBusinessRoundedDefault.default));
parcelHelpers.export(exports, "AddBusinessSharp", ()=>(0, _addBusinessSharpDefault.default));
parcelHelpers.export(exports, "AddBusinessTwoTone", ()=>(0, _addBusinessTwoToneDefault.default));
parcelHelpers.export(exports, "AddCard", ()=>(0, _addCardDefault.default));
parcelHelpers.export(exports, "AddCardOutlined", ()=>(0, _addCardOutlinedDefault.default));
parcelHelpers.export(exports, "AddCardRounded", ()=>(0, _addCardRoundedDefault.default));
parcelHelpers.export(exports, "AddCardSharp", ()=>(0, _addCardSharpDefault.default));
parcelHelpers.export(exports, "AddCardTwoTone", ()=>(0, _addCardTwoToneDefault.default));
parcelHelpers.export(exports, "AddCircle", ()=>(0, _addCircleDefault.default));
parcelHelpers.export(exports, "AddCircleOutline", ()=>(0, _addCircleOutlineDefault.default));
parcelHelpers.export(exports, "AddCircleOutlineOutlined", ()=>(0, _addCircleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "AddCircleOutlineRounded", ()=>(0, _addCircleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "AddCircleOutlineSharp", ()=>(0, _addCircleOutlineSharpDefault.default));
parcelHelpers.export(exports, "AddCircleOutlineTwoTone", ()=>(0, _addCircleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "AddCircleOutlined", ()=>(0, _addCircleOutlinedDefault.default));
parcelHelpers.export(exports, "AddCircleRounded", ()=>(0, _addCircleRoundedDefault.default));
parcelHelpers.export(exports, "AddCircleSharp", ()=>(0, _addCircleSharpDefault.default));
parcelHelpers.export(exports, "AddCircleTwoTone", ()=>(0, _addCircleTwoToneDefault.default));
parcelHelpers.export(exports, "AddComment", ()=>(0, _addCommentDefault.default));
parcelHelpers.export(exports, "AddCommentOutlined", ()=>(0, _addCommentOutlinedDefault.default));
parcelHelpers.export(exports, "AddCommentRounded", ()=>(0, _addCommentRoundedDefault.default));
parcelHelpers.export(exports, "AddCommentSharp", ()=>(0, _addCommentSharpDefault.default));
parcelHelpers.export(exports, "AddCommentTwoTone", ()=>(0, _addCommentTwoToneDefault.default));
parcelHelpers.export(exports, "AddHome", ()=>(0, _addHomeDefault.default));
parcelHelpers.export(exports, "AddHomeOutlined", ()=>(0, _addHomeOutlinedDefault.default));
parcelHelpers.export(exports, "AddHomeRounded", ()=>(0, _addHomeRoundedDefault.default));
parcelHelpers.export(exports, "AddHomeSharp", ()=>(0, _addHomeSharpDefault.default));
parcelHelpers.export(exports, "AddHomeTwoTone", ()=>(0, _addHomeTwoToneDefault.default));
parcelHelpers.export(exports, "AddHomeWork", ()=>(0, _addHomeWorkDefault.default));
parcelHelpers.export(exports, "AddHomeWorkOutlined", ()=>(0, _addHomeWorkOutlinedDefault.default));
parcelHelpers.export(exports, "AddHomeWorkRounded", ()=>(0, _addHomeWorkRoundedDefault.default));
parcelHelpers.export(exports, "AddHomeWorkSharp", ()=>(0, _addHomeWorkSharpDefault.default));
parcelHelpers.export(exports, "AddHomeWorkTwoTone", ()=>(0, _addHomeWorkTwoToneDefault.default));
parcelHelpers.export(exports, "AddIcCall", ()=>(0, _addIcCallDefault.default));
parcelHelpers.export(exports, "AddIcCallOutlined", ()=>(0, _addIcCallOutlinedDefault.default));
parcelHelpers.export(exports, "AddIcCallRounded", ()=>(0, _addIcCallRoundedDefault.default));
parcelHelpers.export(exports, "AddIcCallSharp", ()=>(0, _addIcCallSharpDefault.default));
parcelHelpers.export(exports, "AddIcCallTwoTone", ()=>(0, _addIcCallTwoToneDefault.default));
parcelHelpers.export(exports, "AddLink", ()=>(0, _addLinkDefault.default));
parcelHelpers.export(exports, "AddLinkOutlined", ()=>(0, _addLinkOutlinedDefault.default));
parcelHelpers.export(exports, "AddLinkRounded", ()=>(0, _addLinkRoundedDefault.default));
parcelHelpers.export(exports, "AddLinkSharp", ()=>(0, _addLinkSharpDefault.default));
parcelHelpers.export(exports, "AddLinkTwoTone", ()=>(0, _addLinkTwoToneDefault.default));
parcelHelpers.export(exports, "AddLocation", ()=>(0, _addLocationDefault.default));
parcelHelpers.export(exports, "AddLocationAlt", ()=>(0, _addLocationAltDefault.default));
parcelHelpers.export(exports, "AddLocationAltOutlined", ()=>(0, _addLocationAltOutlinedDefault.default));
parcelHelpers.export(exports, "AddLocationAltRounded", ()=>(0, _addLocationAltRoundedDefault.default));
parcelHelpers.export(exports, "AddLocationAltSharp", ()=>(0, _addLocationAltSharpDefault.default));
parcelHelpers.export(exports, "AddLocationAltTwoTone", ()=>(0, _addLocationAltTwoToneDefault.default));
parcelHelpers.export(exports, "AddLocationOutlined", ()=>(0, _addLocationOutlinedDefault.default));
parcelHelpers.export(exports, "AddLocationRounded", ()=>(0, _addLocationRoundedDefault.default));
parcelHelpers.export(exports, "AddLocationSharp", ()=>(0, _addLocationSharpDefault.default));
parcelHelpers.export(exports, "AddLocationTwoTone", ()=>(0, _addLocationTwoToneDefault.default));
parcelHelpers.export(exports, "AddModerator", ()=>(0, _addModeratorDefault.default));
parcelHelpers.export(exports, "AddModeratorOutlined", ()=>(0, _addModeratorOutlinedDefault.default));
parcelHelpers.export(exports, "AddModeratorRounded", ()=>(0, _addModeratorRoundedDefault.default));
parcelHelpers.export(exports, "AddModeratorSharp", ()=>(0, _addModeratorSharpDefault.default));
parcelHelpers.export(exports, "AddModeratorTwoTone", ()=>(0, _addModeratorTwoToneDefault.default));
parcelHelpers.export(exports, "AddOutlined", ()=>(0, _addOutlinedDefault.default));
parcelHelpers.export(exports, "AddPhotoAlternate", ()=>(0, _addPhotoAlternateDefault.default));
parcelHelpers.export(exports, "AddPhotoAlternateOutlined", ()=>(0, _addPhotoAlternateOutlinedDefault.default));
parcelHelpers.export(exports, "AddPhotoAlternateRounded", ()=>(0, _addPhotoAlternateRoundedDefault.default));
parcelHelpers.export(exports, "AddPhotoAlternateSharp", ()=>(0, _addPhotoAlternateSharpDefault.default));
parcelHelpers.export(exports, "AddPhotoAlternateTwoTone", ()=>(0, _addPhotoAlternateTwoToneDefault.default));
parcelHelpers.export(exports, "AddReaction", ()=>(0, _addReactionDefault.default));
parcelHelpers.export(exports, "AddReactionOutlined", ()=>(0, _addReactionOutlinedDefault.default));
parcelHelpers.export(exports, "AddReactionRounded", ()=>(0, _addReactionRoundedDefault.default));
parcelHelpers.export(exports, "AddReactionSharp", ()=>(0, _addReactionSharpDefault.default));
parcelHelpers.export(exports, "AddReactionTwoTone", ()=>(0, _addReactionTwoToneDefault.default));
parcelHelpers.export(exports, "AddRoad", ()=>(0, _addRoadDefault.default));
parcelHelpers.export(exports, "AddRoadOutlined", ()=>(0, _addRoadOutlinedDefault.default));
parcelHelpers.export(exports, "AddRoadRounded", ()=>(0, _addRoadRoundedDefault.default));
parcelHelpers.export(exports, "AddRoadSharp", ()=>(0, _addRoadSharpDefault.default));
parcelHelpers.export(exports, "AddRoadTwoTone", ()=>(0, _addRoadTwoToneDefault.default));
parcelHelpers.export(exports, "AddRounded", ()=>(0, _addRoundedDefault.default));
parcelHelpers.export(exports, "AddSharp", ()=>(0, _addSharpDefault.default));
parcelHelpers.export(exports, "AddShoppingCart", ()=>(0, _addShoppingCartDefault.default));
parcelHelpers.export(exports, "AddShoppingCartOutlined", ()=>(0, _addShoppingCartOutlinedDefault.default));
parcelHelpers.export(exports, "AddShoppingCartRounded", ()=>(0, _addShoppingCartRoundedDefault.default));
parcelHelpers.export(exports, "AddShoppingCartSharp", ()=>(0, _addShoppingCartSharpDefault.default));
parcelHelpers.export(exports, "AddShoppingCartTwoTone", ()=>(0, _addShoppingCartTwoToneDefault.default));
parcelHelpers.export(exports, "AddTask", ()=>(0, _addTaskDefault.default));
parcelHelpers.export(exports, "AddTaskOutlined", ()=>(0, _addTaskOutlinedDefault.default));
parcelHelpers.export(exports, "AddTaskRounded", ()=>(0, _addTaskRoundedDefault.default));
parcelHelpers.export(exports, "AddTaskSharp", ()=>(0, _addTaskSharpDefault.default));
parcelHelpers.export(exports, "AddTaskTwoTone", ()=>(0, _addTaskTwoToneDefault.default));
parcelHelpers.export(exports, "AddToDrive", ()=>(0, _addToDriveDefault.default));
parcelHelpers.export(exports, "AddToDriveOutlined", ()=>(0, _addToDriveOutlinedDefault.default));
parcelHelpers.export(exports, "AddToDriveRounded", ()=>(0, _addToDriveRoundedDefault.default));
parcelHelpers.export(exports, "AddToDriveSharp", ()=>(0, _addToDriveSharpDefault.default));
parcelHelpers.export(exports, "AddToDriveTwoTone", ()=>(0, _addToDriveTwoToneDefault.default));
parcelHelpers.export(exports, "AddToHomeScreen", ()=>(0, _addToHomeScreenDefault.default));
parcelHelpers.export(exports, "AddToHomeScreenOutlined", ()=>(0, _addToHomeScreenOutlinedDefault.default));
parcelHelpers.export(exports, "AddToHomeScreenRounded", ()=>(0, _addToHomeScreenRoundedDefault.default));
parcelHelpers.export(exports, "AddToHomeScreenSharp", ()=>(0, _addToHomeScreenSharpDefault.default));
parcelHelpers.export(exports, "AddToHomeScreenTwoTone", ()=>(0, _addToHomeScreenTwoToneDefault.default));
parcelHelpers.export(exports, "AddToPhotos", ()=>(0, _addToPhotosDefault.default));
parcelHelpers.export(exports, "AddToPhotosOutlined", ()=>(0, _addToPhotosOutlinedDefault.default));
parcelHelpers.export(exports, "AddToPhotosRounded", ()=>(0, _addToPhotosRoundedDefault.default));
parcelHelpers.export(exports, "AddToPhotosSharp", ()=>(0, _addToPhotosSharpDefault.default));
parcelHelpers.export(exports, "AddToPhotosTwoTone", ()=>(0, _addToPhotosTwoToneDefault.default));
parcelHelpers.export(exports, "AddToQueue", ()=>(0, _addToQueueDefault.default));
parcelHelpers.export(exports, "AddToQueueOutlined", ()=>(0, _addToQueueOutlinedDefault.default));
parcelHelpers.export(exports, "AddToQueueRounded", ()=>(0, _addToQueueRoundedDefault.default));
parcelHelpers.export(exports, "AddToQueueSharp", ()=>(0, _addToQueueSharpDefault.default));
parcelHelpers.export(exports, "AddToQueueTwoTone", ()=>(0, _addToQueueTwoToneDefault.default));
parcelHelpers.export(exports, "AddTwoTone", ()=>(0, _addTwoToneDefault.default));
parcelHelpers.export(exports, "Addchart", ()=>(0, _addchartDefault.default));
parcelHelpers.export(exports, "AddchartOutlined", ()=>(0, _addchartOutlinedDefault.default));
parcelHelpers.export(exports, "AddchartRounded", ()=>(0, _addchartRoundedDefault.default));
parcelHelpers.export(exports, "AddchartSharp", ()=>(0, _addchartSharpDefault.default));
parcelHelpers.export(exports, "AddchartTwoTone", ()=>(0, _addchartTwoToneDefault.default));
parcelHelpers.export(exports, "AdfScanner", ()=>(0, _adfScannerDefault.default));
parcelHelpers.export(exports, "AdfScannerOutlined", ()=>(0, _adfScannerOutlinedDefault.default));
parcelHelpers.export(exports, "AdfScannerRounded", ()=>(0, _adfScannerRoundedDefault.default));
parcelHelpers.export(exports, "AdfScannerSharp", ()=>(0, _adfScannerSharpDefault.default));
parcelHelpers.export(exports, "AdfScannerTwoTone", ()=>(0, _adfScannerTwoToneDefault.default));
parcelHelpers.export(exports, "Adjust", ()=>(0, _adjustDefault.default));
parcelHelpers.export(exports, "AdjustOutlined", ()=>(0, _adjustOutlinedDefault.default));
parcelHelpers.export(exports, "AdjustRounded", ()=>(0, _adjustRoundedDefault.default));
parcelHelpers.export(exports, "AdjustSharp", ()=>(0, _adjustSharpDefault.default));
parcelHelpers.export(exports, "AdjustTwoTone", ()=>(0, _adjustTwoToneDefault.default));
parcelHelpers.export(exports, "AdminPanelSettings", ()=>(0, _adminPanelSettingsDefault.default));
parcelHelpers.export(exports, "AdminPanelSettingsOutlined", ()=>(0, _adminPanelSettingsOutlinedDefault.default));
parcelHelpers.export(exports, "AdminPanelSettingsRounded", ()=>(0, _adminPanelSettingsRoundedDefault.default));
parcelHelpers.export(exports, "AdminPanelSettingsSharp", ()=>(0, _adminPanelSettingsSharpDefault.default));
parcelHelpers.export(exports, "AdminPanelSettingsTwoTone", ()=>(0, _adminPanelSettingsTwoToneDefault.default));
parcelHelpers.export(exports, "AdsClick", ()=>(0, _adsClickDefault.default));
parcelHelpers.export(exports, "AdsClickOutlined", ()=>(0, _adsClickOutlinedDefault.default));
parcelHelpers.export(exports, "AdsClickRounded", ()=>(0, _adsClickRoundedDefault.default));
parcelHelpers.export(exports, "AdsClickSharp", ()=>(0, _adsClickSharpDefault.default));
parcelHelpers.export(exports, "AdsClickTwoTone", ()=>(0, _adsClickTwoToneDefault.default));
parcelHelpers.export(exports, "Agriculture", ()=>(0, _agricultureDefault.default));
parcelHelpers.export(exports, "AgricultureOutlined", ()=>(0, _agricultureOutlinedDefault.default));
parcelHelpers.export(exports, "AgricultureRounded", ()=>(0, _agricultureRoundedDefault.default));
parcelHelpers.export(exports, "AgricultureSharp", ()=>(0, _agricultureSharpDefault.default));
parcelHelpers.export(exports, "AgricultureTwoTone", ()=>(0, _agricultureTwoToneDefault.default));
parcelHelpers.export(exports, "Air", ()=>(0, _airDefault.default));
parcelHelpers.export(exports, "AirOutlined", ()=>(0, _airOutlinedDefault.default));
parcelHelpers.export(exports, "AirRounded", ()=>(0, _airRoundedDefault.default));
parcelHelpers.export(exports, "AirSharp", ()=>(0, _airSharpDefault.default));
parcelHelpers.export(exports, "AirTwoTone", ()=>(0, _airTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlat", ()=>(0, _airlineSeatFlatDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatAngled", ()=>(0, _airlineSeatFlatAngledDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatAngledOutlined", ()=>(0, _airlineSeatFlatAngledOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatAngledRounded", ()=>(0, _airlineSeatFlatAngledRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatAngledSharp", ()=>(0, _airlineSeatFlatAngledSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatAngledTwoTone", ()=>(0, _airlineSeatFlatAngledTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatOutlined", ()=>(0, _airlineSeatFlatOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatRounded", ()=>(0, _airlineSeatFlatRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatSharp", ()=>(0, _airlineSeatFlatSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatFlatTwoTone", ()=>(0, _airlineSeatFlatTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatIndividualSuite", ()=>(0, _airlineSeatIndividualSuiteDefault.default));
parcelHelpers.export(exports, "AirlineSeatIndividualSuiteOutlined", ()=>(0, _airlineSeatIndividualSuiteOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatIndividualSuiteRounded", ()=>(0, _airlineSeatIndividualSuiteRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatIndividualSuiteSharp", ()=>(0, _airlineSeatIndividualSuiteSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatIndividualSuiteTwoTone", ()=>(0, _airlineSeatIndividualSuiteTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomExtra", ()=>(0, _airlineSeatLegroomExtraDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomExtraOutlined", ()=>(0, _airlineSeatLegroomExtraOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomExtraRounded", ()=>(0, _airlineSeatLegroomExtraRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomExtraSharp", ()=>(0, _airlineSeatLegroomExtraSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomExtraTwoTone", ()=>(0, _airlineSeatLegroomExtraTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomNormal", ()=>(0, _airlineSeatLegroomNormalDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomNormalOutlined", ()=>(0, _airlineSeatLegroomNormalOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomNormalRounded", ()=>(0, _airlineSeatLegroomNormalRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomNormalSharp", ()=>(0, _airlineSeatLegroomNormalSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomNormalTwoTone", ()=>(0, _airlineSeatLegroomNormalTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomReduced", ()=>(0, _airlineSeatLegroomReducedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomReducedOutlined", ()=>(0, _airlineSeatLegroomReducedOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomReducedRounded", ()=>(0, _airlineSeatLegroomReducedRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomReducedSharp", ()=>(0, _airlineSeatLegroomReducedSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatLegroomReducedTwoTone", ()=>(0, _airlineSeatLegroomReducedTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineExtra", ()=>(0, _airlineSeatReclineExtraDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineExtraOutlined", ()=>(0, _airlineSeatReclineExtraOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineExtraRounded", ()=>(0, _airlineSeatReclineExtraRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineExtraSharp", ()=>(0, _airlineSeatReclineExtraSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineExtraTwoTone", ()=>(0, _airlineSeatReclineExtraTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineNormal", ()=>(0, _airlineSeatReclineNormalDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineNormalOutlined", ()=>(0, _airlineSeatReclineNormalOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineNormalRounded", ()=>(0, _airlineSeatReclineNormalRoundedDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineNormalSharp", ()=>(0, _airlineSeatReclineNormalSharpDefault.default));
parcelHelpers.export(exports, "AirlineSeatReclineNormalTwoTone", ()=>(0, _airlineSeatReclineNormalTwoToneDefault.default));
parcelHelpers.export(exports, "AirlineStops", ()=>(0, _airlineStopsDefault.default));
parcelHelpers.export(exports, "AirlineStopsOutlined", ()=>(0, _airlineStopsOutlinedDefault.default));
parcelHelpers.export(exports, "AirlineStopsRounded", ()=>(0, _airlineStopsRoundedDefault.default));
parcelHelpers.export(exports, "AirlineStopsSharp", ()=>(0, _airlineStopsSharpDefault.default));
parcelHelpers.export(exports, "AirlineStopsTwoTone", ()=>(0, _airlineStopsTwoToneDefault.default));
parcelHelpers.export(exports, "Airlines", ()=>(0, _airlinesDefault.default));
parcelHelpers.export(exports, "AirlinesOutlined", ()=>(0, _airlinesOutlinedDefault.default));
parcelHelpers.export(exports, "AirlinesRounded", ()=>(0, _airlinesRoundedDefault.default));
parcelHelpers.export(exports, "AirlinesSharp", ()=>(0, _airlinesSharpDefault.default));
parcelHelpers.export(exports, "AirlinesTwoTone", ()=>(0, _airlinesTwoToneDefault.default));
parcelHelpers.export(exports, "AirplaneTicket", ()=>(0, _airplaneTicketDefault.default));
parcelHelpers.export(exports, "AirplaneTicketOutlined", ()=>(0, _airplaneTicketOutlinedDefault.default));
parcelHelpers.export(exports, "AirplaneTicketRounded", ()=>(0, _airplaneTicketRoundedDefault.default));
parcelHelpers.export(exports, "AirplaneTicketSharp", ()=>(0, _airplaneTicketSharpDefault.default));
parcelHelpers.export(exports, "AirplaneTicketTwoTone", ()=>(0, _airplaneTicketTwoToneDefault.default));
parcelHelpers.export(exports, "AirplanemodeActive", ()=>(0, _airplanemodeActiveDefault.default));
parcelHelpers.export(exports, "AirplanemodeActiveOutlined", ()=>(0, _airplanemodeActiveOutlinedDefault.default));
parcelHelpers.export(exports, "AirplanemodeActiveRounded", ()=>(0, _airplanemodeActiveRoundedDefault.default));
parcelHelpers.export(exports, "AirplanemodeActiveSharp", ()=>(0, _airplanemodeActiveSharpDefault.default));
parcelHelpers.export(exports, "AirplanemodeActiveTwoTone", ()=>(0, _airplanemodeActiveTwoToneDefault.default));
parcelHelpers.export(exports, "AirplanemodeInactive", ()=>(0, _airplanemodeInactiveDefault.default));
parcelHelpers.export(exports, "AirplanemodeInactiveOutlined", ()=>(0, _airplanemodeInactiveOutlinedDefault.default));
parcelHelpers.export(exports, "AirplanemodeInactiveRounded", ()=>(0, _airplanemodeInactiveRoundedDefault.default));
parcelHelpers.export(exports, "AirplanemodeInactiveSharp", ()=>(0, _airplanemodeInactiveSharpDefault.default));
parcelHelpers.export(exports, "AirplanemodeInactiveTwoTone", ()=>(0, _airplanemodeInactiveTwoToneDefault.default));
parcelHelpers.export(exports, "Airplay", ()=>(0, _airplayDefault.default));
parcelHelpers.export(exports, "AirplayOutlined", ()=>(0, _airplayOutlinedDefault.default));
parcelHelpers.export(exports, "AirplayRounded", ()=>(0, _airplayRoundedDefault.default));
parcelHelpers.export(exports, "AirplaySharp", ()=>(0, _airplaySharpDefault.default));
parcelHelpers.export(exports, "AirplayTwoTone", ()=>(0, _airplayTwoToneDefault.default));
parcelHelpers.export(exports, "AirportShuttle", ()=>(0, _airportShuttleDefault.default));
parcelHelpers.export(exports, "AirportShuttleOutlined", ()=>(0, _airportShuttleOutlinedDefault.default));
parcelHelpers.export(exports, "AirportShuttleRounded", ()=>(0, _airportShuttleRoundedDefault.default));
parcelHelpers.export(exports, "AirportShuttleSharp", ()=>(0, _airportShuttleSharpDefault.default));
parcelHelpers.export(exports, "AirportShuttleTwoTone", ()=>(0, _airportShuttleTwoToneDefault.default));
parcelHelpers.export(exports, "Alarm", ()=>(0, _alarmDefault.default));
parcelHelpers.export(exports, "AlarmAdd", ()=>(0, _alarmAddDefault.default));
parcelHelpers.export(exports, "AlarmAddOutlined", ()=>(0, _alarmAddOutlinedDefault.default));
parcelHelpers.export(exports, "AlarmAddRounded", ()=>(0, _alarmAddRoundedDefault.default));
parcelHelpers.export(exports, "AlarmAddSharp", ()=>(0, _alarmAddSharpDefault.default));
parcelHelpers.export(exports, "AlarmAddTwoTone", ()=>(0, _alarmAddTwoToneDefault.default));
parcelHelpers.export(exports, "AlarmOff", ()=>(0, _alarmOffDefault.default));
parcelHelpers.export(exports, "AlarmOffOutlined", ()=>(0, _alarmOffOutlinedDefault.default));
parcelHelpers.export(exports, "AlarmOffRounded", ()=>(0, _alarmOffRoundedDefault.default));
parcelHelpers.export(exports, "AlarmOffSharp", ()=>(0, _alarmOffSharpDefault.default));
parcelHelpers.export(exports, "AlarmOffTwoTone", ()=>(0, _alarmOffTwoToneDefault.default));
parcelHelpers.export(exports, "AlarmOn", ()=>(0, _alarmOnDefault.default));
parcelHelpers.export(exports, "AlarmOnOutlined", ()=>(0, _alarmOnOutlinedDefault.default));
parcelHelpers.export(exports, "AlarmOnRounded", ()=>(0, _alarmOnRoundedDefault.default));
parcelHelpers.export(exports, "AlarmOnSharp", ()=>(0, _alarmOnSharpDefault.default));
parcelHelpers.export(exports, "AlarmOnTwoTone", ()=>(0, _alarmOnTwoToneDefault.default));
parcelHelpers.export(exports, "AlarmOutlined", ()=>(0, _alarmOutlinedDefault.default));
parcelHelpers.export(exports, "AlarmRounded", ()=>(0, _alarmRoundedDefault.default));
parcelHelpers.export(exports, "AlarmSharp", ()=>(0, _alarmSharpDefault.default));
parcelHelpers.export(exports, "AlarmTwoTone", ()=>(0, _alarmTwoToneDefault.default));
parcelHelpers.export(exports, "Album", ()=>(0, _albumDefault.default));
parcelHelpers.export(exports, "AlbumOutlined", ()=>(0, _albumOutlinedDefault.default));
parcelHelpers.export(exports, "AlbumRounded", ()=>(0, _albumRoundedDefault.default));
parcelHelpers.export(exports, "AlbumSharp", ()=>(0, _albumSharpDefault.default));
parcelHelpers.export(exports, "AlbumTwoTone", ()=>(0, _albumTwoToneDefault.default));
parcelHelpers.export(exports, "AlignHorizontalCenter", ()=>(0, _alignHorizontalCenterDefault.default));
parcelHelpers.export(exports, "AlignHorizontalCenterOutlined", ()=>(0, _alignHorizontalCenterOutlinedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalCenterRounded", ()=>(0, _alignHorizontalCenterRoundedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalCenterSharp", ()=>(0, _alignHorizontalCenterSharpDefault.default));
parcelHelpers.export(exports, "AlignHorizontalCenterTwoTone", ()=>(0, _alignHorizontalCenterTwoToneDefault.default));
parcelHelpers.export(exports, "AlignHorizontalLeft", ()=>(0, _alignHorizontalLeftDefault.default));
parcelHelpers.export(exports, "AlignHorizontalLeftOutlined", ()=>(0, _alignHorizontalLeftOutlinedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalLeftRounded", ()=>(0, _alignHorizontalLeftRoundedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalLeftSharp", ()=>(0, _alignHorizontalLeftSharpDefault.default));
parcelHelpers.export(exports, "AlignHorizontalLeftTwoTone", ()=>(0, _alignHorizontalLeftTwoToneDefault.default));
parcelHelpers.export(exports, "AlignHorizontalRight", ()=>(0, _alignHorizontalRightDefault.default));
parcelHelpers.export(exports, "AlignHorizontalRightOutlined", ()=>(0, _alignHorizontalRightOutlinedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalRightRounded", ()=>(0, _alignHorizontalRightRoundedDefault.default));
parcelHelpers.export(exports, "AlignHorizontalRightSharp", ()=>(0, _alignHorizontalRightSharpDefault.default));
parcelHelpers.export(exports, "AlignHorizontalRightTwoTone", ()=>(0, _alignHorizontalRightTwoToneDefault.default));
parcelHelpers.export(exports, "AlignVerticalBottom", ()=>(0, _alignVerticalBottomDefault.default));
parcelHelpers.export(exports, "AlignVerticalBottomOutlined", ()=>(0, _alignVerticalBottomOutlinedDefault.default));
parcelHelpers.export(exports, "AlignVerticalBottomRounded", ()=>(0, _alignVerticalBottomRoundedDefault.default));
parcelHelpers.export(exports, "AlignVerticalBottomSharp", ()=>(0, _alignVerticalBottomSharpDefault.default));
parcelHelpers.export(exports, "AlignVerticalBottomTwoTone", ()=>(0, _alignVerticalBottomTwoToneDefault.default));
parcelHelpers.export(exports, "AlignVerticalCenter", ()=>(0, _alignVerticalCenterDefault.default));
parcelHelpers.export(exports, "AlignVerticalCenterOutlined", ()=>(0, _alignVerticalCenterOutlinedDefault.default));
parcelHelpers.export(exports, "AlignVerticalCenterRounded", ()=>(0, _alignVerticalCenterRoundedDefault.default));
parcelHelpers.export(exports, "AlignVerticalCenterSharp", ()=>(0, _alignVerticalCenterSharpDefault.default));
parcelHelpers.export(exports, "AlignVerticalCenterTwoTone", ()=>(0, _alignVerticalCenterTwoToneDefault.default));
parcelHelpers.export(exports, "AlignVerticalTop", ()=>(0, _alignVerticalTopDefault.default));
parcelHelpers.export(exports, "AlignVerticalTopOutlined", ()=>(0, _alignVerticalTopOutlinedDefault.default));
parcelHelpers.export(exports, "AlignVerticalTopRounded", ()=>(0, _alignVerticalTopRoundedDefault.default));
parcelHelpers.export(exports, "AlignVerticalTopSharp", ()=>(0, _alignVerticalTopSharpDefault.default));
parcelHelpers.export(exports, "AlignVerticalTopTwoTone", ()=>(0, _alignVerticalTopTwoToneDefault.default));
parcelHelpers.export(exports, "AllInbox", ()=>(0, _allInboxDefault.default));
parcelHelpers.export(exports, "AllInboxOutlined", ()=>(0, _allInboxOutlinedDefault.default));
parcelHelpers.export(exports, "AllInboxRounded", ()=>(0, _allInboxRoundedDefault.default));
parcelHelpers.export(exports, "AllInboxSharp", ()=>(0, _allInboxSharpDefault.default));
parcelHelpers.export(exports, "AllInboxTwoTone", ()=>(0, _allInboxTwoToneDefault.default));
parcelHelpers.export(exports, "AllInclusive", ()=>(0, _allInclusiveDefault.default));
parcelHelpers.export(exports, "AllInclusiveOutlined", ()=>(0, _allInclusiveOutlinedDefault.default));
parcelHelpers.export(exports, "AllInclusiveRounded", ()=>(0, _allInclusiveRoundedDefault.default));
parcelHelpers.export(exports, "AllInclusiveSharp", ()=>(0, _allInclusiveSharpDefault.default));
parcelHelpers.export(exports, "AllInclusiveTwoTone", ()=>(0, _allInclusiveTwoToneDefault.default));
parcelHelpers.export(exports, "AllOut", ()=>(0, _allOutDefault.default));
parcelHelpers.export(exports, "AllOutOutlined", ()=>(0, _allOutOutlinedDefault.default));
parcelHelpers.export(exports, "AllOutRounded", ()=>(0, _allOutRoundedDefault.default));
parcelHelpers.export(exports, "AllOutSharp", ()=>(0, _allOutSharpDefault.default));
parcelHelpers.export(exports, "AllOutTwoTone", ()=>(0, _allOutTwoToneDefault.default));
parcelHelpers.export(exports, "AltRoute", ()=>(0, _altRouteDefault.default));
parcelHelpers.export(exports, "AltRouteOutlined", ()=>(0, _altRouteOutlinedDefault.default));
parcelHelpers.export(exports, "AltRouteRounded", ()=>(0, _altRouteRoundedDefault.default));
parcelHelpers.export(exports, "AltRouteSharp", ()=>(0, _altRouteSharpDefault.default));
parcelHelpers.export(exports, "AltRouteTwoTone", ()=>(0, _altRouteTwoToneDefault.default));
parcelHelpers.export(exports, "AlternateEmail", ()=>(0, _alternateEmailDefault.default));
parcelHelpers.export(exports, "AlternateEmailOutlined", ()=>(0, _alternateEmailOutlinedDefault.default));
parcelHelpers.export(exports, "AlternateEmailRounded", ()=>(0, _alternateEmailRoundedDefault.default));
parcelHelpers.export(exports, "AlternateEmailSharp", ()=>(0, _alternateEmailSharpDefault.default));
parcelHelpers.export(exports, "AlternateEmailTwoTone", ()=>(0, _alternateEmailTwoToneDefault.default));
parcelHelpers.export(exports, "Analytics", ()=>(0, _analyticsDefault.default));
parcelHelpers.export(exports, "AnalyticsOutlined", ()=>(0, _analyticsOutlinedDefault.default));
parcelHelpers.export(exports, "AnalyticsRounded", ()=>(0, _analyticsRoundedDefault.default));
parcelHelpers.export(exports, "AnalyticsSharp", ()=>(0, _analyticsSharpDefault.default));
parcelHelpers.export(exports, "AnalyticsTwoTone", ()=>(0, _analyticsTwoToneDefault.default));
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchorDefault.default));
parcelHelpers.export(exports, "AnchorOutlined", ()=>(0, _anchorOutlinedDefault.default));
parcelHelpers.export(exports, "AnchorRounded", ()=>(0, _anchorRoundedDefault.default));
parcelHelpers.export(exports, "AnchorSharp", ()=>(0, _anchorSharpDefault.default));
parcelHelpers.export(exports, "AnchorTwoTone", ()=>(0, _anchorTwoToneDefault.default));
parcelHelpers.export(exports, "Android", ()=>(0, _androidDefault.default));
parcelHelpers.export(exports, "AndroidOutlined", ()=>(0, _androidOutlinedDefault.default));
parcelHelpers.export(exports, "AndroidRounded", ()=>(0, _androidRoundedDefault.default));
parcelHelpers.export(exports, "AndroidSharp", ()=>(0, _androidSharpDefault.default));
parcelHelpers.export(exports, "AndroidTwoTone", ()=>(0, _androidTwoToneDefault.default));
parcelHelpers.export(exports, "Animation", ()=>(0, _animationDefault.default));
parcelHelpers.export(exports, "AnimationOutlined", ()=>(0, _animationOutlinedDefault.default));
parcelHelpers.export(exports, "AnimationRounded", ()=>(0, _animationRoundedDefault.default));
parcelHelpers.export(exports, "AnimationSharp", ()=>(0, _animationSharpDefault.default));
parcelHelpers.export(exports, "AnimationTwoTone", ()=>(0, _animationTwoToneDefault.default));
parcelHelpers.export(exports, "Announcement", ()=>(0, _announcementDefault.default));
parcelHelpers.export(exports, "AnnouncementOutlined", ()=>(0, _announcementOutlinedDefault.default));
parcelHelpers.export(exports, "AnnouncementRounded", ()=>(0, _announcementRoundedDefault.default));
parcelHelpers.export(exports, "AnnouncementSharp", ()=>(0, _announcementSharpDefault.default));
parcelHelpers.export(exports, "AnnouncementTwoTone", ()=>(0, _announcementTwoToneDefault.default));
parcelHelpers.export(exports, "Aod", ()=>(0, _aodDefault.default));
parcelHelpers.export(exports, "AodOutlined", ()=>(0, _aodOutlinedDefault.default));
parcelHelpers.export(exports, "AodRounded", ()=>(0, _aodRoundedDefault.default));
parcelHelpers.export(exports, "AodSharp", ()=>(0, _aodSharpDefault.default));
parcelHelpers.export(exports, "AodTwoTone", ()=>(0, _aodTwoToneDefault.default));
parcelHelpers.export(exports, "Apartment", ()=>(0, _apartmentDefault.default));
parcelHelpers.export(exports, "ApartmentOutlined", ()=>(0, _apartmentOutlinedDefault.default));
parcelHelpers.export(exports, "ApartmentRounded", ()=>(0, _apartmentRoundedDefault.default));
parcelHelpers.export(exports, "ApartmentSharp", ()=>(0, _apartmentSharpDefault.default));
parcelHelpers.export(exports, "ApartmentTwoTone", ()=>(0, _apartmentTwoToneDefault.default));
parcelHelpers.export(exports, "Api", ()=>(0, _apiDefault.default));
parcelHelpers.export(exports, "ApiOutlined", ()=>(0, _apiOutlinedDefault.default));
parcelHelpers.export(exports, "ApiRounded", ()=>(0, _apiRoundedDefault.default));
parcelHelpers.export(exports, "ApiSharp", ()=>(0, _apiSharpDefault.default));
parcelHelpers.export(exports, "ApiTwoTone", ()=>(0, _apiTwoToneDefault.default));
parcelHelpers.export(exports, "AppBlocking", ()=>(0, _appBlockingDefault.default));
parcelHelpers.export(exports, "AppBlockingOutlined", ()=>(0, _appBlockingOutlinedDefault.default));
parcelHelpers.export(exports, "AppBlockingRounded", ()=>(0, _appBlockingRoundedDefault.default));
parcelHelpers.export(exports, "AppBlockingSharp", ()=>(0, _appBlockingSharpDefault.default));
parcelHelpers.export(exports, "AppBlockingTwoTone", ()=>(0, _appBlockingTwoToneDefault.default));
parcelHelpers.export(exports, "AppRegistration", ()=>(0, _appRegistrationDefault.default));
parcelHelpers.export(exports, "AppRegistrationOutlined", ()=>(0, _appRegistrationOutlinedDefault.default));
parcelHelpers.export(exports, "AppRegistrationRounded", ()=>(0, _appRegistrationRoundedDefault.default));
parcelHelpers.export(exports, "AppRegistrationSharp", ()=>(0, _appRegistrationSharpDefault.default));
parcelHelpers.export(exports, "AppRegistrationTwoTone", ()=>(0, _appRegistrationTwoToneDefault.default));
parcelHelpers.export(exports, "AppSettingsAlt", ()=>(0, _appSettingsAltDefault.default));
parcelHelpers.export(exports, "AppSettingsAltOutlined", ()=>(0, _appSettingsAltOutlinedDefault.default));
parcelHelpers.export(exports, "AppSettingsAltRounded", ()=>(0, _appSettingsAltRoundedDefault.default));
parcelHelpers.export(exports, "AppSettingsAltSharp", ()=>(0, _appSettingsAltSharpDefault.default));
parcelHelpers.export(exports, "AppSettingsAltTwoTone", ()=>(0, _appSettingsAltTwoToneDefault.default));
parcelHelpers.export(exports, "AppShortcut", ()=>(0, _appShortcutDefault.default));
parcelHelpers.export(exports, "AppShortcutOutlined", ()=>(0, _appShortcutOutlinedDefault.default));
parcelHelpers.export(exports, "AppShortcutRounded", ()=>(0, _appShortcutRoundedDefault.default));
parcelHelpers.export(exports, "AppShortcutSharp", ()=>(0, _appShortcutSharpDefault.default));
parcelHelpers.export(exports, "AppShortcutTwoTone", ()=>(0, _appShortcutTwoToneDefault.default));
parcelHelpers.export(exports, "Apple", ()=>(0, _appleDefault.default));
parcelHelpers.export(exports, "Approval", ()=>(0, _approvalDefault.default));
parcelHelpers.export(exports, "ApprovalOutlined", ()=>(0, _approvalOutlinedDefault.default));
parcelHelpers.export(exports, "ApprovalRounded", ()=>(0, _approvalRoundedDefault.default));
parcelHelpers.export(exports, "ApprovalSharp", ()=>(0, _approvalSharpDefault.default));
parcelHelpers.export(exports, "ApprovalTwoTone", ()=>(0, _approvalTwoToneDefault.default));
parcelHelpers.export(exports, "Apps", ()=>(0, _appsDefault.default));
parcelHelpers.export(exports, "AppsOutage", ()=>(0, _appsOutageDefault.default));
parcelHelpers.export(exports, "AppsOutageOutlined", ()=>(0, _appsOutageOutlinedDefault.default));
parcelHelpers.export(exports, "AppsOutageRounded", ()=>(0, _appsOutageRoundedDefault.default));
parcelHelpers.export(exports, "AppsOutageSharp", ()=>(0, _appsOutageSharpDefault.default));
parcelHelpers.export(exports, "AppsOutageTwoTone", ()=>(0, _appsOutageTwoToneDefault.default));
parcelHelpers.export(exports, "AppsOutlined", ()=>(0, _appsOutlinedDefault.default));
parcelHelpers.export(exports, "AppsRounded", ()=>(0, _appsRoundedDefault.default));
parcelHelpers.export(exports, "AppsSharp", ()=>(0, _appsSharpDefault.default));
parcelHelpers.export(exports, "AppsTwoTone", ()=>(0, _appsTwoToneDefault.default));
parcelHelpers.export(exports, "Architecture", ()=>(0, _architectureDefault.default));
parcelHelpers.export(exports, "ArchitectureOutlined", ()=>(0, _architectureOutlinedDefault.default));
parcelHelpers.export(exports, "ArchitectureRounded", ()=>(0, _architectureRoundedDefault.default));
parcelHelpers.export(exports, "ArchitectureSharp", ()=>(0, _architectureSharpDefault.default));
parcelHelpers.export(exports, "ArchitectureTwoTone", ()=>(0, _architectureTwoToneDefault.default));
parcelHelpers.export(exports, "Archive", ()=>(0, _archiveDefault.default));
parcelHelpers.export(exports, "ArchiveOutlined", ()=>(0, _archiveOutlinedDefault.default));
parcelHelpers.export(exports, "ArchiveRounded", ()=>(0, _archiveRoundedDefault.default));
parcelHelpers.export(exports, "ArchiveSharp", ()=>(0, _archiveSharpDefault.default));
parcelHelpers.export(exports, "ArchiveTwoTone", ()=>(0, _archiveTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowBack", ()=>(0, _arrowBackDefault.default));
parcelHelpers.export(exports, "ArrowBackIos", ()=>(0, _arrowBackIosDefault.default));
parcelHelpers.export(exports, "ArrowBackIosNew", ()=>(0, _arrowBackIosNewDefault.default));
parcelHelpers.export(exports, "ArrowBackIosNewOutlined", ()=>(0, _arrowBackIosNewOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowBackIosNewRounded", ()=>(0, _arrowBackIosNewRoundedDefault.default));
parcelHelpers.export(exports, "ArrowBackIosNewSharp", ()=>(0, _arrowBackIosNewSharpDefault.default));
parcelHelpers.export(exports, "ArrowBackIosNewTwoTone", ()=>(0, _arrowBackIosNewTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowBackIosOutlined", ()=>(0, _arrowBackIosOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowBackIosRounded", ()=>(0, _arrowBackIosRoundedDefault.default));
parcelHelpers.export(exports, "ArrowBackIosSharp", ()=>(0, _arrowBackIosSharpDefault.default));
parcelHelpers.export(exports, "ArrowBackIosTwoTone", ()=>(0, _arrowBackIosTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowBackOutlined", ()=>(0, _arrowBackOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowBackRounded", ()=>(0, _arrowBackRoundedDefault.default));
parcelHelpers.export(exports, "ArrowBackSharp", ()=>(0, _arrowBackSharpDefault.default));
parcelHelpers.export(exports, "ArrowBackTwoTone", ()=>(0, _arrowBackTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowCircleDown", ()=>(0, _arrowCircleDownDefault.default));
parcelHelpers.export(exports, "ArrowCircleDownOutlined", ()=>(0, _arrowCircleDownOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowCircleDownRounded", ()=>(0, _arrowCircleDownRoundedDefault.default));
parcelHelpers.export(exports, "ArrowCircleDownSharp", ()=>(0, _arrowCircleDownSharpDefault.default));
parcelHelpers.export(exports, "ArrowCircleDownTwoTone", ()=>(0, _arrowCircleDownTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowCircleLeft", ()=>(0, _arrowCircleLeftDefault.default));
parcelHelpers.export(exports, "ArrowCircleLeftOutlined", ()=>(0, _arrowCircleLeftOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowCircleLeftRounded", ()=>(0, _arrowCircleLeftRoundedDefault.default));
parcelHelpers.export(exports, "ArrowCircleLeftSharp", ()=>(0, _arrowCircleLeftSharpDefault.default));
parcelHelpers.export(exports, "ArrowCircleLeftTwoTone", ()=>(0, _arrowCircleLeftTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowCircleRight", ()=>(0, _arrowCircleRightDefault.default));
parcelHelpers.export(exports, "ArrowCircleRightOutlined", ()=>(0, _arrowCircleRightOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowCircleRightRounded", ()=>(0, _arrowCircleRightRoundedDefault.default));
parcelHelpers.export(exports, "ArrowCircleRightSharp", ()=>(0, _arrowCircleRightSharpDefault.default));
parcelHelpers.export(exports, "ArrowCircleRightTwoTone", ()=>(0, _arrowCircleRightTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowCircleUp", ()=>(0, _arrowCircleUpDefault.default));
parcelHelpers.export(exports, "ArrowCircleUpOutlined", ()=>(0, _arrowCircleUpOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowCircleUpRounded", ()=>(0, _arrowCircleUpRoundedDefault.default));
parcelHelpers.export(exports, "ArrowCircleUpSharp", ()=>(0, _arrowCircleUpSharpDefault.default));
parcelHelpers.export(exports, "ArrowCircleUpTwoTone", ()=>(0, _arrowCircleUpTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowDownward", ()=>(0, _arrowDownwardDefault.default));
parcelHelpers.export(exports, "ArrowDownwardOutlined", ()=>(0, _arrowDownwardOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowDownwardRounded", ()=>(0, _arrowDownwardRoundedDefault.default));
parcelHelpers.export(exports, "ArrowDownwardSharp", ()=>(0, _arrowDownwardSharpDefault.default));
parcelHelpers.export(exports, "ArrowDownwardTwoTone", ()=>(0, _arrowDownwardTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowDropDown", ()=>(0, _arrowDropDownDefault.default));
parcelHelpers.export(exports, "ArrowDropDownCircle", ()=>(0, _arrowDropDownCircleDefault.default));
parcelHelpers.export(exports, "ArrowDropDownCircleOutlined", ()=>(0, _arrowDropDownCircleOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowDropDownCircleRounded", ()=>(0, _arrowDropDownCircleRoundedDefault.default));
parcelHelpers.export(exports, "ArrowDropDownCircleSharp", ()=>(0, _arrowDropDownCircleSharpDefault.default));
parcelHelpers.export(exports, "ArrowDropDownCircleTwoTone", ()=>(0, _arrowDropDownCircleTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowDropDownOutlined", ()=>(0, _arrowDropDownOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowDropDownRounded", ()=>(0, _arrowDropDownRoundedDefault.default));
parcelHelpers.export(exports, "ArrowDropDownSharp", ()=>(0, _arrowDropDownSharpDefault.default));
parcelHelpers.export(exports, "ArrowDropDownTwoTone", ()=>(0, _arrowDropDownTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowDropUp", ()=>(0, _arrowDropUpDefault.default));
parcelHelpers.export(exports, "ArrowDropUpOutlined", ()=>(0, _arrowDropUpOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowDropUpRounded", ()=>(0, _arrowDropUpRoundedDefault.default));
parcelHelpers.export(exports, "ArrowDropUpSharp", ()=>(0, _arrowDropUpSharpDefault.default));
parcelHelpers.export(exports, "ArrowDropUpTwoTone", ()=>(0, _arrowDropUpTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowForward", ()=>(0, _arrowForwardDefault.default));
parcelHelpers.export(exports, "ArrowForwardIos", ()=>(0, _arrowForwardIosDefault.default));
parcelHelpers.export(exports, "ArrowForwardIosOutlined", ()=>(0, _arrowForwardIosOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowForwardIosRounded", ()=>(0, _arrowForwardIosRoundedDefault.default));
parcelHelpers.export(exports, "ArrowForwardIosSharp", ()=>(0, _arrowForwardIosSharpDefault.default));
parcelHelpers.export(exports, "ArrowForwardIosTwoTone", ()=>(0, _arrowForwardIosTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowForwardOutlined", ()=>(0, _arrowForwardOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowForwardRounded", ()=>(0, _arrowForwardRoundedDefault.default));
parcelHelpers.export(exports, "ArrowForwardSharp", ()=>(0, _arrowForwardSharpDefault.default));
parcelHelpers.export(exports, "ArrowForwardTwoTone", ()=>(0, _arrowForwardTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowLeft", ()=>(0, _arrowLeftDefault.default));
parcelHelpers.export(exports, "ArrowLeftOutlined", ()=>(0, _arrowLeftOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowLeftRounded", ()=>(0, _arrowLeftRoundedDefault.default));
parcelHelpers.export(exports, "ArrowLeftSharp", ()=>(0, _arrowLeftSharpDefault.default));
parcelHelpers.export(exports, "ArrowLeftTwoTone", ()=>(0, _arrowLeftTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowOutward", ()=>(0, _arrowOutwardDefault.default));
parcelHelpers.export(exports, "ArrowOutwardOutlined", ()=>(0, _arrowOutwardOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowOutwardRounded", ()=>(0, _arrowOutwardRoundedDefault.default));
parcelHelpers.export(exports, "ArrowOutwardSharp", ()=>(0, _arrowOutwardSharpDefault.default));
parcelHelpers.export(exports, "ArrowOutwardTwoTone", ()=>(0, _arrowOutwardTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowRight", ()=>(0, _arrowRightDefault.default));
parcelHelpers.export(exports, "ArrowRightAlt", ()=>(0, _arrowRightAltDefault.default));
parcelHelpers.export(exports, "ArrowRightAltOutlined", ()=>(0, _arrowRightAltOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowRightAltRounded", ()=>(0, _arrowRightAltRoundedDefault.default));
parcelHelpers.export(exports, "ArrowRightAltSharp", ()=>(0, _arrowRightAltSharpDefault.default));
parcelHelpers.export(exports, "ArrowRightAltTwoTone", ()=>(0, _arrowRightAltTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowRightOutlined", ()=>(0, _arrowRightOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowRightRounded", ()=>(0, _arrowRightRoundedDefault.default));
parcelHelpers.export(exports, "ArrowRightSharp", ()=>(0, _arrowRightSharpDefault.default));
parcelHelpers.export(exports, "ArrowRightTwoTone", ()=>(0, _arrowRightTwoToneDefault.default));
parcelHelpers.export(exports, "ArrowUpward", ()=>(0, _arrowUpwardDefault.default));
parcelHelpers.export(exports, "ArrowUpwardOutlined", ()=>(0, _arrowUpwardOutlinedDefault.default));
parcelHelpers.export(exports, "ArrowUpwardRounded", ()=>(0, _arrowUpwardRoundedDefault.default));
parcelHelpers.export(exports, "ArrowUpwardSharp", ()=>(0, _arrowUpwardSharpDefault.default));
parcelHelpers.export(exports, "ArrowUpwardTwoTone", ()=>(0, _arrowUpwardTwoToneDefault.default));
parcelHelpers.export(exports, "ArtTrack", ()=>(0, _artTrackDefault.default));
parcelHelpers.export(exports, "ArtTrackOutlined", ()=>(0, _artTrackOutlinedDefault.default));
parcelHelpers.export(exports, "ArtTrackRounded", ()=>(0, _artTrackRoundedDefault.default));
parcelHelpers.export(exports, "ArtTrackSharp", ()=>(0, _artTrackSharpDefault.default));
parcelHelpers.export(exports, "ArtTrackTwoTone", ()=>(0, _artTrackTwoToneDefault.default));
parcelHelpers.export(exports, "Article", ()=>(0, _articleDefault.default));
parcelHelpers.export(exports, "ArticleOutlined", ()=>(0, _articleOutlinedDefault.default));
parcelHelpers.export(exports, "ArticleRounded", ()=>(0, _articleRoundedDefault.default));
parcelHelpers.export(exports, "ArticleSharp", ()=>(0, _articleSharpDefault.default));
parcelHelpers.export(exports, "ArticleTwoTone", ()=>(0, _articleTwoToneDefault.default));
parcelHelpers.export(exports, "AspectRatio", ()=>(0, _aspectRatioDefault.default));
parcelHelpers.export(exports, "AspectRatioOutlined", ()=>(0, _aspectRatioOutlinedDefault.default));
parcelHelpers.export(exports, "AspectRatioRounded", ()=>(0, _aspectRatioRoundedDefault.default));
parcelHelpers.export(exports, "AspectRatioSharp", ()=>(0, _aspectRatioSharpDefault.default));
parcelHelpers.export(exports, "AspectRatioTwoTone", ()=>(0, _aspectRatioTwoToneDefault.default));
parcelHelpers.export(exports, "Assessment", ()=>(0, _assessmentDefault.default));
parcelHelpers.export(exports, "AssessmentOutlined", ()=>(0, _assessmentOutlinedDefault.default));
parcelHelpers.export(exports, "AssessmentRounded", ()=>(0, _assessmentRoundedDefault.default));
parcelHelpers.export(exports, "AssessmentSharp", ()=>(0, _assessmentSharpDefault.default));
parcelHelpers.export(exports, "AssessmentTwoTone", ()=>(0, _assessmentTwoToneDefault.default));
parcelHelpers.export(exports, "Assignment", ()=>(0, _assignmentDefault.default));
parcelHelpers.export(exports, "AssignmentInd", ()=>(0, _assignmentIndDefault.default));
parcelHelpers.export(exports, "AssignmentIndOutlined", ()=>(0, _assignmentIndOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentIndRounded", ()=>(0, _assignmentIndRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentIndSharp", ()=>(0, _assignmentIndSharpDefault.default));
parcelHelpers.export(exports, "AssignmentIndTwoTone", ()=>(0, _assignmentIndTwoToneDefault.default));
parcelHelpers.export(exports, "AssignmentLate", ()=>(0, _assignmentLateDefault.default));
parcelHelpers.export(exports, "AssignmentLateOutlined", ()=>(0, _assignmentLateOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentLateRounded", ()=>(0, _assignmentLateRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentLateSharp", ()=>(0, _assignmentLateSharpDefault.default));
parcelHelpers.export(exports, "AssignmentLateTwoTone", ()=>(0, _assignmentLateTwoToneDefault.default));
parcelHelpers.export(exports, "AssignmentOutlined", ()=>(0, _assignmentOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentReturn", ()=>(0, _assignmentReturnDefault.default));
parcelHelpers.export(exports, "AssignmentReturnOutlined", ()=>(0, _assignmentReturnOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentReturnRounded", ()=>(0, _assignmentReturnRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentReturnSharp", ()=>(0, _assignmentReturnSharpDefault.default));
parcelHelpers.export(exports, "AssignmentReturnTwoTone", ()=>(0, _assignmentReturnTwoToneDefault.default));
parcelHelpers.export(exports, "AssignmentReturned", ()=>(0, _assignmentReturnedDefault.default));
parcelHelpers.export(exports, "AssignmentReturnedOutlined", ()=>(0, _assignmentReturnedOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentReturnedRounded", ()=>(0, _assignmentReturnedRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentReturnedSharp", ()=>(0, _assignmentReturnedSharpDefault.default));
parcelHelpers.export(exports, "AssignmentReturnedTwoTone", ()=>(0, _assignmentReturnedTwoToneDefault.default));
parcelHelpers.export(exports, "AssignmentRounded", ()=>(0, _assignmentRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentSharp", ()=>(0, _assignmentSharpDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedIn", ()=>(0, _assignmentTurnedInDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedInOutlined", ()=>(0, _assignmentTurnedInOutlinedDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedInRounded", ()=>(0, _assignmentTurnedInRoundedDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedInSharp", ()=>(0, _assignmentTurnedInSharpDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedInTwoTone", ()=>(0, _assignmentTurnedInTwoToneDefault.default));
parcelHelpers.export(exports, "AssignmentTwoTone", ()=>(0, _assignmentTwoToneDefault.default));
parcelHelpers.export(exports, "AssistWalker", ()=>(0, _assistWalkerDefault.default));
parcelHelpers.export(exports, "AssistWalkerOutlined", ()=>(0, _assistWalkerOutlinedDefault.default));
parcelHelpers.export(exports, "AssistWalkerRounded", ()=>(0, _assistWalkerRoundedDefault.default));
parcelHelpers.export(exports, "AssistWalkerSharp", ()=>(0, _assistWalkerSharpDefault.default));
parcelHelpers.export(exports, "AssistWalkerTwoTone", ()=>(0, _assistWalkerTwoToneDefault.default));
parcelHelpers.export(exports, "Assistant", ()=>(0, _assistantDefault.default));
parcelHelpers.export(exports, "AssistantDirection", ()=>(0, _assistantDirectionDefault.default));
parcelHelpers.export(exports, "AssistantDirectionOutlined", ()=>(0, _assistantDirectionOutlinedDefault.default));
parcelHelpers.export(exports, "AssistantDirectionRounded", ()=>(0, _assistantDirectionRoundedDefault.default));
parcelHelpers.export(exports, "AssistantDirectionSharp", ()=>(0, _assistantDirectionSharpDefault.default));
parcelHelpers.export(exports, "AssistantDirectionTwoTone", ()=>(0, _assistantDirectionTwoToneDefault.default));
parcelHelpers.export(exports, "AssistantOutlined", ()=>(0, _assistantOutlinedDefault.default));
parcelHelpers.export(exports, "AssistantPhoto", ()=>(0, _assistantPhotoDefault.default));
parcelHelpers.export(exports, "AssistantPhotoOutlined", ()=>(0, _assistantPhotoOutlinedDefault.default));
parcelHelpers.export(exports, "AssistantPhotoRounded", ()=>(0, _assistantPhotoRoundedDefault.default));
parcelHelpers.export(exports, "AssistantPhotoSharp", ()=>(0, _assistantPhotoSharpDefault.default));
parcelHelpers.export(exports, "AssistantPhotoTwoTone", ()=>(0, _assistantPhotoTwoToneDefault.default));
parcelHelpers.export(exports, "AssistantRounded", ()=>(0, _assistantRoundedDefault.default));
parcelHelpers.export(exports, "AssistantSharp", ()=>(0, _assistantSharpDefault.default));
parcelHelpers.export(exports, "AssistantTwoTone", ()=>(0, _assistantTwoToneDefault.default));
parcelHelpers.export(exports, "AssuredWorkload", ()=>(0, _assuredWorkloadDefault.default));
parcelHelpers.export(exports, "AssuredWorkloadOutlined", ()=>(0, _assuredWorkloadOutlinedDefault.default));
parcelHelpers.export(exports, "AssuredWorkloadRounded", ()=>(0, _assuredWorkloadRoundedDefault.default));
parcelHelpers.export(exports, "AssuredWorkloadSharp", ()=>(0, _assuredWorkloadSharpDefault.default));
parcelHelpers.export(exports, "AssuredWorkloadTwoTone", ()=>(0, _assuredWorkloadTwoToneDefault.default));
parcelHelpers.export(exports, "Atm", ()=>(0, _atmDefault.default));
parcelHelpers.export(exports, "AtmOutlined", ()=>(0, _atmOutlinedDefault.default));
parcelHelpers.export(exports, "AtmRounded", ()=>(0, _atmRoundedDefault.default));
parcelHelpers.export(exports, "AtmSharp", ()=>(0, _atmSharpDefault.default));
parcelHelpers.export(exports, "AtmTwoTone", ()=>(0, _atmTwoToneDefault.default));
parcelHelpers.export(exports, "AttachEmail", ()=>(0, _attachEmailDefault.default));
parcelHelpers.export(exports, "AttachEmailOutlined", ()=>(0, _attachEmailOutlinedDefault.default));
parcelHelpers.export(exports, "AttachEmailRounded", ()=>(0, _attachEmailRoundedDefault.default));
parcelHelpers.export(exports, "AttachEmailSharp", ()=>(0, _attachEmailSharpDefault.default));
parcelHelpers.export(exports, "AttachEmailTwoTone", ()=>(0, _attachEmailTwoToneDefault.default));
parcelHelpers.export(exports, "AttachFile", ()=>(0, _attachFileDefault.default));
parcelHelpers.export(exports, "AttachFileOutlined", ()=>(0, _attachFileOutlinedDefault.default));
parcelHelpers.export(exports, "AttachFileRounded", ()=>(0, _attachFileRoundedDefault.default));
parcelHelpers.export(exports, "AttachFileSharp", ()=>(0, _attachFileSharpDefault.default));
parcelHelpers.export(exports, "AttachFileTwoTone", ()=>(0, _attachFileTwoToneDefault.default));
parcelHelpers.export(exports, "AttachMoney", ()=>(0, _attachMoneyDefault.default));
parcelHelpers.export(exports, "AttachMoneyOutlined", ()=>(0, _attachMoneyOutlinedDefault.default));
parcelHelpers.export(exports, "AttachMoneyRounded", ()=>(0, _attachMoneyRoundedDefault.default));
parcelHelpers.export(exports, "AttachMoneySharp", ()=>(0, _attachMoneySharpDefault.default));
parcelHelpers.export(exports, "AttachMoneyTwoTone", ()=>(0, _attachMoneyTwoToneDefault.default));
parcelHelpers.export(exports, "Attachment", ()=>(0, _attachmentDefault.default));
parcelHelpers.export(exports, "AttachmentOutlined", ()=>(0, _attachmentOutlinedDefault.default));
parcelHelpers.export(exports, "AttachmentRounded", ()=>(0, _attachmentRoundedDefault.default));
parcelHelpers.export(exports, "AttachmentSharp", ()=>(0, _attachmentSharpDefault.default));
parcelHelpers.export(exports, "AttachmentTwoTone", ()=>(0, _attachmentTwoToneDefault.default));
parcelHelpers.export(exports, "Attractions", ()=>(0, _attractionsDefault.default));
parcelHelpers.export(exports, "AttractionsOutlined", ()=>(0, _attractionsOutlinedDefault.default));
parcelHelpers.export(exports, "AttractionsRounded", ()=>(0, _attractionsRoundedDefault.default));
parcelHelpers.export(exports, "AttractionsSharp", ()=>(0, _attractionsSharpDefault.default));
parcelHelpers.export(exports, "AttractionsTwoTone", ()=>(0, _attractionsTwoToneDefault.default));
parcelHelpers.export(exports, "Attribution", ()=>(0, _attributionDefault.default));
parcelHelpers.export(exports, "AttributionOutlined", ()=>(0, _attributionOutlinedDefault.default));
parcelHelpers.export(exports, "AttributionRounded", ()=>(0, _attributionRoundedDefault.default));
parcelHelpers.export(exports, "AttributionSharp", ()=>(0, _attributionSharpDefault.default));
parcelHelpers.export(exports, "AttributionTwoTone", ()=>(0, _attributionTwoToneDefault.default));
parcelHelpers.export(exports, "AudioFile", ()=>(0, _audioFileDefault.default));
parcelHelpers.export(exports, "AudioFileOutlined", ()=>(0, _audioFileOutlinedDefault.default));
parcelHelpers.export(exports, "AudioFileRounded", ()=>(0, _audioFileRoundedDefault.default));
parcelHelpers.export(exports, "AudioFileSharp", ()=>(0, _audioFileSharpDefault.default));
parcelHelpers.export(exports, "AudioFileTwoTone", ()=>(0, _audioFileTwoToneDefault.default));
parcelHelpers.export(exports, "Audiotrack", ()=>(0, _audiotrackDefault.default));
parcelHelpers.export(exports, "AudiotrackOutlined", ()=>(0, _audiotrackOutlinedDefault.default));
parcelHelpers.export(exports, "AudiotrackRounded", ()=>(0, _audiotrackRoundedDefault.default));
parcelHelpers.export(exports, "AudiotrackSharp", ()=>(0, _audiotrackSharpDefault.default));
parcelHelpers.export(exports, "AudiotrackTwoTone", ()=>(0, _audiotrackTwoToneDefault.default));
parcelHelpers.export(exports, "AutoAwesome", ()=>(0, _autoAwesomeDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMosaic", ()=>(0, _autoAwesomeMosaicDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMosaicOutlined", ()=>(0, _autoAwesomeMosaicOutlinedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMosaicRounded", ()=>(0, _autoAwesomeMosaicRoundedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMosaicSharp", ()=>(0, _autoAwesomeMosaicSharpDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMosaicTwoTone", ()=>(0, _autoAwesomeMosaicTwoToneDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMotion", ()=>(0, _autoAwesomeMotionDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMotionOutlined", ()=>(0, _autoAwesomeMotionOutlinedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMotionRounded", ()=>(0, _autoAwesomeMotionRoundedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMotionSharp", ()=>(0, _autoAwesomeMotionSharpDefault.default));
parcelHelpers.export(exports, "AutoAwesomeMotionTwoTone", ()=>(0, _autoAwesomeMotionTwoToneDefault.default));
parcelHelpers.export(exports, "AutoAwesomeOutlined", ()=>(0, _autoAwesomeOutlinedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeRounded", ()=>(0, _autoAwesomeRoundedDefault.default));
parcelHelpers.export(exports, "AutoAwesomeSharp", ()=>(0, _autoAwesomeSharpDefault.default));
parcelHelpers.export(exports, "AutoAwesomeTwoTone", ()=>(0, _autoAwesomeTwoToneDefault.default));
parcelHelpers.export(exports, "AutoDelete", ()=>(0, _autoDeleteDefault.default));
parcelHelpers.export(exports, "AutoDeleteOutlined", ()=>(0, _autoDeleteOutlinedDefault.default));
parcelHelpers.export(exports, "AutoDeleteRounded", ()=>(0, _autoDeleteRoundedDefault.default));
parcelHelpers.export(exports, "AutoDeleteSharp", ()=>(0, _autoDeleteSharpDefault.default));
parcelHelpers.export(exports, "AutoDeleteTwoTone", ()=>(0, _autoDeleteTwoToneDefault.default));
parcelHelpers.export(exports, "AutoFixHigh", ()=>(0, _autoFixHighDefault.default));
parcelHelpers.export(exports, "AutoFixHighOutlined", ()=>(0, _autoFixHighOutlinedDefault.default));
parcelHelpers.export(exports, "AutoFixHighRounded", ()=>(0, _autoFixHighRoundedDefault.default));
parcelHelpers.export(exports, "AutoFixHighSharp", ()=>(0, _autoFixHighSharpDefault.default));
parcelHelpers.export(exports, "AutoFixHighTwoTone", ()=>(0, _autoFixHighTwoToneDefault.default));
parcelHelpers.export(exports, "AutoFixNormal", ()=>(0, _autoFixNormalDefault.default));
parcelHelpers.export(exports, "AutoFixNormalOutlined", ()=>(0, _autoFixNormalOutlinedDefault.default));
parcelHelpers.export(exports, "AutoFixNormalRounded", ()=>(0, _autoFixNormalRoundedDefault.default));
parcelHelpers.export(exports, "AutoFixNormalSharp", ()=>(0, _autoFixNormalSharpDefault.default));
parcelHelpers.export(exports, "AutoFixNormalTwoTone", ()=>(0, _autoFixNormalTwoToneDefault.default));
parcelHelpers.export(exports, "AutoFixOff", ()=>(0, _autoFixOffDefault.default));
parcelHelpers.export(exports, "AutoFixOffOutlined", ()=>(0, _autoFixOffOutlinedDefault.default));
parcelHelpers.export(exports, "AutoFixOffRounded", ()=>(0, _autoFixOffRoundedDefault.default));
parcelHelpers.export(exports, "AutoFixOffSharp", ()=>(0, _autoFixOffSharpDefault.default));
parcelHelpers.export(exports, "AutoFixOffTwoTone", ()=>(0, _autoFixOffTwoToneDefault.default));
parcelHelpers.export(exports, "AutoGraph", ()=>(0, _autoGraphDefault.default));
parcelHelpers.export(exports, "AutoGraphOutlined", ()=>(0, _autoGraphOutlinedDefault.default));
parcelHelpers.export(exports, "AutoGraphRounded", ()=>(0, _autoGraphRoundedDefault.default));
parcelHelpers.export(exports, "AutoGraphSharp", ()=>(0, _autoGraphSharpDefault.default));
parcelHelpers.export(exports, "AutoGraphTwoTone", ()=>(0, _autoGraphTwoToneDefault.default));
parcelHelpers.export(exports, "AutoMode", ()=>(0, _autoModeDefault.default));
parcelHelpers.export(exports, "AutoModeOutlined", ()=>(0, _autoModeOutlinedDefault.default));
parcelHelpers.export(exports, "AutoModeRounded", ()=>(0, _autoModeRoundedDefault.default));
parcelHelpers.export(exports, "AutoModeSharp", ()=>(0, _autoModeSharpDefault.default));
parcelHelpers.export(exports, "AutoModeTwoTone", ()=>(0, _autoModeTwoToneDefault.default));
parcelHelpers.export(exports, "AutoStories", ()=>(0, _autoStoriesDefault.default));
parcelHelpers.export(exports, "AutoStoriesOutlined", ()=>(0, _autoStoriesOutlinedDefault.default));
parcelHelpers.export(exports, "AutoStoriesRounded", ()=>(0, _autoStoriesRoundedDefault.default));
parcelHelpers.export(exports, "AutoStoriesSharp", ()=>(0, _autoStoriesSharpDefault.default));
parcelHelpers.export(exports, "AutoStoriesTwoTone", ()=>(0, _autoStoriesTwoToneDefault.default));
parcelHelpers.export(exports, "AutofpsSelect", ()=>(0, _autofpsSelectDefault.default));
parcelHelpers.export(exports, "AutofpsSelectOutlined", ()=>(0, _autofpsSelectOutlinedDefault.default));
parcelHelpers.export(exports, "AutofpsSelectRounded", ()=>(0, _autofpsSelectRoundedDefault.default));
parcelHelpers.export(exports, "AutofpsSelectSharp", ()=>(0, _autofpsSelectSharpDefault.default));
parcelHelpers.export(exports, "AutofpsSelectTwoTone", ()=>(0, _autofpsSelectTwoToneDefault.default));
parcelHelpers.export(exports, "Autorenew", ()=>(0, _autorenewDefault.default));
parcelHelpers.export(exports, "AutorenewOutlined", ()=>(0, _autorenewOutlinedDefault.default));
parcelHelpers.export(exports, "AutorenewRounded", ()=>(0, _autorenewRoundedDefault.default));
parcelHelpers.export(exports, "AutorenewSharp", ()=>(0, _autorenewSharpDefault.default));
parcelHelpers.export(exports, "AutorenewTwoTone", ()=>(0, _autorenewTwoToneDefault.default));
parcelHelpers.export(exports, "AvTimer", ()=>(0, _avTimerDefault.default));
parcelHelpers.export(exports, "AvTimerOutlined", ()=>(0, _avTimerOutlinedDefault.default));
parcelHelpers.export(exports, "AvTimerRounded", ()=>(0, _avTimerRoundedDefault.default));
parcelHelpers.export(exports, "AvTimerSharp", ()=>(0, _avTimerSharpDefault.default));
parcelHelpers.export(exports, "AvTimerTwoTone", ()=>(0, _avTimerTwoToneDefault.default));
parcelHelpers.export(exports, "BabyChangingStation", ()=>(0, _babyChangingStationDefault.default));
parcelHelpers.export(exports, "BabyChangingStationOutlined", ()=>(0, _babyChangingStationOutlinedDefault.default));
parcelHelpers.export(exports, "BabyChangingStationRounded", ()=>(0, _babyChangingStationRoundedDefault.default));
parcelHelpers.export(exports, "BabyChangingStationSharp", ()=>(0, _babyChangingStationSharpDefault.default));
parcelHelpers.export(exports, "BabyChangingStationTwoTone", ()=>(0, _babyChangingStationTwoToneDefault.default));
parcelHelpers.export(exports, "BackHand", ()=>(0, _backHandDefault.default));
parcelHelpers.export(exports, "BackHandOutlined", ()=>(0, _backHandOutlinedDefault.default));
parcelHelpers.export(exports, "BackHandRounded", ()=>(0, _backHandRoundedDefault.default));
parcelHelpers.export(exports, "BackHandSharp", ()=>(0, _backHandSharpDefault.default));
parcelHelpers.export(exports, "BackHandTwoTone", ()=>(0, _backHandTwoToneDefault.default));
parcelHelpers.export(exports, "Backpack", ()=>(0, _backpackDefault.default));
parcelHelpers.export(exports, "BackpackOutlined", ()=>(0, _backpackOutlinedDefault.default));
parcelHelpers.export(exports, "BackpackRounded", ()=>(0, _backpackRoundedDefault.default));
parcelHelpers.export(exports, "BackpackSharp", ()=>(0, _backpackSharpDefault.default));
parcelHelpers.export(exports, "BackpackTwoTone", ()=>(0, _backpackTwoToneDefault.default));
parcelHelpers.export(exports, "Backspace", ()=>(0, _backspaceDefault.default));
parcelHelpers.export(exports, "BackspaceOutlined", ()=>(0, _backspaceOutlinedDefault.default));
parcelHelpers.export(exports, "BackspaceRounded", ()=>(0, _backspaceRoundedDefault.default));
parcelHelpers.export(exports, "BackspaceSharp", ()=>(0, _backspaceSharpDefault.default));
parcelHelpers.export(exports, "BackspaceTwoTone", ()=>(0, _backspaceTwoToneDefault.default));
parcelHelpers.export(exports, "Backup", ()=>(0, _backupDefault.default));
parcelHelpers.export(exports, "BackupOutlined", ()=>(0, _backupOutlinedDefault.default));
parcelHelpers.export(exports, "BackupRounded", ()=>(0, _backupRoundedDefault.default));
parcelHelpers.export(exports, "BackupSharp", ()=>(0, _backupSharpDefault.default));
parcelHelpers.export(exports, "BackupTable", ()=>(0, _backupTableDefault.default));
parcelHelpers.export(exports, "BackupTableOutlined", ()=>(0, _backupTableOutlinedDefault.default));
parcelHelpers.export(exports, "BackupTableRounded", ()=>(0, _backupTableRoundedDefault.default));
parcelHelpers.export(exports, "BackupTableSharp", ()=>(0, _backupTableSharpDefault.default));
parcelHelpers.export(exports, "BackupTableTwoTone", ()=>(0, _backupTableTwoToneDefault.default));
parcelHelpers.export(exports, "BackupTwoTone", ()=>(0, _backupTwoToneDefault.default));
parcelHelpers.export(exports, "Badge", ()=>(0, _badgeDefault.default));
parcelHelpers.export(exports, "BadgeOutlined", ()=>(0, _badgeOutlinedDefault.default));
parcelHelpers.export(exports, "BadgeRounded", ()=>(0, _badgeRoundedDefault.default));
parcelHelpers.export(exports, "BadgeSharp", ()=>(0, _badgeSharpDefault.default));
parcelHelpers.export(exports, "BadgeTwoTone", ()=>(0, _badgeTwoToneDefault.default));
parcelHelpers.export(exports, "BakeryDining", ()=>(0, _bakeryDiningDefault.default));
parcelHelpers.export(exports, "BakeryDiningOutlined", ()=>(0, _bakeryDiningOutlinedDefault.default));
parcelHelpers.export(exports, "BakeryDiningRounded", ()=>(0, _bakeryDiningRoundedDefault.default));
parcelHelpers.export(exports, "BakeryDiningSharp", ()=>(0, _bakeryDiningSharpDefault.default));
parcelHelpers.export(exports, "BakeryDiningTwoTone", ()=>(0, _bakeryDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Balance", ()=>(0, _balanceDefault.default));
parcelHelpers.export(exports, "BalanceOutlined", ()=>(0, _balanceOutlinedDefault.default));
parcelHelpers.export(exports, "BalanceRounded", ()=>(0, _balanceRoundedDefault.default));
parcelHelpers.export(exports, "BalanceSharp", ()=>(0, _balanceSharpDefault.default));
parcelHelpers.export(exports, "BalanceTwoTone", ()=>(0, _balanceTwoToneDefault.default));
parcelHelpers.export(exports, "Balcony", ()=>(0, _balconyDefault.default));
parcelHelpers.export(exports, "BalconyOutlined", ()=>(0, _balconyOutlinedDefault.default));
parcelHelpers.export(exports, "BalconyRounded", ()=>(0, _balconyRoundedDefault.default));
parcelHelpers.export(exports, "BalconySharp", ()=>(0, _balconySharpDefault.default));
parcelHelpers.export(exports, "BalconyTwoTone", ()=>(0, _balconyTwoToneDefault.default));
parcelHelpers.export(exports, "Ballot", ()=>(0, _ballotDefault.default));
parcelHelpers.export(exports, "BallotOutlined", ()=>(0, _ballotOutlinedDefault.default));
parcelHelpers.export(exports, "BallotRounded", ()=>(0, _ballotRoundedDefault.default));
parcelHelpers.export(exports, "BallotSharp", ()=>(0, _ballotSharpDefault.default));
parcelHelpers.export(exports, "BallotTwoTone", ()=>(0, _ballotTwoToneDefault.default));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChartDefault.default));
parcelHelpers.export(exports, "BarChartOutlined", ()=>(0, _barChartOutlinedDefault.default));
parcelHelpers.export(exports, "BarChartRounded", ()=>(0, _barChartRoundedDefault.default));
parcelHelpers.export(exports, "BarChartSharp", ()=>(0, _barChartSharpDefault.default));
parcelHelpers.export(exports, "BarChartTwoTone", ()=>(0, _barChartTwoToneDefault.default));
parcelHelpers.export(exports, "BatchPrediction", ()=>(0, _batchPredictionDefault.default));
parcelHelpers.export(exports, "BatchPredictionOutlined", ()=>(0, _batchPredictionOutlinedDefault.default));
parcelHelpers.export(exports, "BatchPredictionRounded", ()=>(0, _batchPredictionRoundedDefault.default));
parcelHelpers.export(exports, "BatchPredictionSharp", ()=>(0, _batchPredictionSharpDefault.default));
parcelHelpers.export(exports, "BatchPredictionTwoTone", ()=>(0, _batchPredictionTwoToneDefault.default));
parcelHelpers.export(exports, "Bathroom", ()=>(0, _bathroomDefault.default));
parcelHelpers.export(exports, "BathroomOutlined", ()=>(0, _bathroomOutlinedDefault.default));
parcelHelpers.export(exports, "BathroomRounded", ()=>(0, _bathroomRoundedDefault.default));
parcelHelpers.export(exports, "BathroomSharp", ()=>(0, _bathroomSharpDefault.default));
parcelHelpers.export(exports, "BathroomTwoTone", ()=>(0, _bathroomTwoToneDefault.default));
parcelHelpers.export(exports, "Bathtub", ()=>(0, _bathtubDefault.default));
parcelHelpers.export(exports, "BathtubOutlined", ()=>(0, _bathtubOutlinedDefault.default));
parcelHelpers.export(exports, "BathtubRounded", ()=>(0, _bathtubRoundedDefault.default));
parcelHelpers.export(exports, "BathtubSharp", ()=>(0, _bathtubSharpDefault.default));
parcelHelpers.export(exports, "BathtubTwoTone", ()=>(0, _bathtubTwoToneDefault.default));
parcelHelpers.export(exports, "Battery0Bar", ()=>(0, _battery0BarDefault.default));
parcelHelpers.export(exports, "Battery0BarOutlined", ()=>(0, _battery0BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery0BarRounded", ()=>(0, _battery0BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery0BarSharp", ()=>(0, _battery0BarSharpDefault.default));
parcelHelpers.export(exports, "Battery0BarTwoTone", ()=>(0, _battery0BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery1Bar", ()=>(0, _battery1BarDefault.default));
parcelHelpers.export(exports, "Battery1BarOutlined", ()=>(0, _battery1BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery1BarRounded", ()=>(0, _battery1BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery1BarSharp", ()=>(0, _battery1BarSharpDefault.default));
parcelHelpers.export(exports, "Battery1BarTwoTone", ()=>(0, _battery1BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery20", ()=>(0, _battery20Default.default));
parcelHelpers.export(exports, "Battery20Outlined", ()=>(0, _battery20OutlinedDefault.default));
parcelHelpers.export(exports, "Battery20Rounded", ()=>(0, _battery20RoundedDefault.default));
parcelHelpers.export(exports, "Battery20Sharp", ()=>(0, _battery20SharpDefault.default));
parcelHelpers.export(exports, "Battery20TwoTone", ()=>(0, _battery20TwoToneDefault.default));
parcelHelpers.export(exports, "Battery2Bar", ()=>(0, _battery2BarDefault.default));
parcelHelpers.export(exports, "Battery2BarOutlined", ()=>(0, _battery2BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery2BarRounded", ()=>(0, _battery2BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery2BarSharp", ()=>(0, _battery2BarSharpDefault.default));
parcelHelpers.export(exports, "Battery2BarTwoTone", ()=>(0, _battery2BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery30", ()=>(0, _battery30Default.default));
parcelHelpers.export(exports, "Battery30Outlined", ()=>(0, _battery30OutlinedDefault.default));
parcelHelpers.export(exports, "Battery30Rounded", ()=>(0, _battery30RoundedDefault.default));
parcelHelpers.export(exports, "Battery30Sharp", ()=>(0, _battery30SharpDefault.default));
parcelHelpers.export(exports, "Battery30TwoTone", ()=>(0, _battery30TwoToneDefault.default));
parcelHelpers.export(exports, "Battery3Bar", ()=>(0, _battery3BarDefault.default));
parcelHelpers.export(exports, "Battery3BarOutlined", ()=>(0, _battery3BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery3BarRounded", ()=>(0, _battery3BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery3BarSharp", ()=>(0, _battery3BarSharpDefault.default));
parcelHelpers.export(exports, "Battery3BarTwoTone", ()=>(0, _battery3BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery4Bar", ()=>(0, _battery4BarDefault.default));
parcelHelpers.export(exports, "Battery4BarOutlined", ()=>(0, _battery4BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery4BarRounded", ()=>(0, _battery4BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery4BarSharp", ()=>(0, _battery4BarSharpDefault.default));
parcelHelpers.export(exports, "Battery4BarTwoTone", ()=>(0, _battery4BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery50", ()=>(0, _battery50Default.default));
parcelHelpers.export(exports, "Battery50Outlined", ()=>(0, _battery50OutlinedDefault.default));
parcelHelpers.export(exports, "Battery50Rounded", ()=>(0, _battery50RoundedDefault.default));
parcelHelpers.export(exports, "Battery50Sharp", ()=>(0, _battery50SharpDefault.default));
parcelHelpers.export(exports, "Battery50TwoTone", ()=>(0, _battery50TwoToneDefault.default));
parcelHelpers.export(exports, "Battery5Bar", ()=>(0, _battery5BarDefault.default));
parcelHelpers.export(exports, "Battery5BarOutlined", ()=>(0, _battery5BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery5BarRounded", ()=>(0, _battery5BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery5BarSharp", ()=>(0, _battery5BarSharpDefault.default));
parcelHelpers.export(exports, "Battery5BarTwoTone", ()=>(0, _battery5BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery60", ()=>(0, _battery60Default.default));
parcelHelpers.export(exports, "Battery60Outlined", ()=>(0, _battery60OutlinedDefault.default));
parcelHelpers.export(exports, "Battery60Rounded", ()=>(0, _battery60RoundedDefault.default));
parcelHelpers.export(exports, "Battery60Sharp", ()=>(0, _battery60SharpDefault.default));
parcelHelpers.export(exports, "Battery60TwoTone", ()=>(0, _battery60TwoToneDefault.default));
parcelHelpers.export(exports, "Battery6Bar", ()=>(0, _battery6BarDefault.default));
parcelHelpers.export(exports, "Battery6BarOutlined", ()=>(0, _battery6BarOutlinedDefault.default));
parcelHelpers.export(exports, "Battery6BarRounded", ()=>(0, _battery6BarRoundedDefault.default));
parcelHelpers.export(exports, "Battery6BarSharp", ()=>(0, _battery6BarSharpDefault.default));
parcelHelpers.export(exports, "Battery6BarTwoTone", ()=>(0, _battery6BarTwoToneDefault.default));
parcelHelpers.export(exports, "Battery80", ()=>(0, _battery80Default.default));
parcelHelpers.export(exports, "Battery80Outlined", ()=>(0, _battery80OutlinedDefault.default));
parcelHelpers.export(exports, "Battery80Rounded", ()=>(0, _battery80RoundedDefault.default));
parcelHelpers.export(exports, "Battery80Sharp", ()=>(0, _battery80SharpDefault.default));
parcelHelpers.export(exports, "Battery80TwoTone", ()=>(0, _battery80TwoToneDefault.default));
parcelHelpers.export(exports, "Battery90", ()=>(0, _battery90Default.default));
parcelHelpers.export(exports, "Battery90Outlined", ()=>(0, _battery90OutlinedDefault.default));
parcelHelpers.export(exports, "Battery90Rounded", ()=>(0, _battery90RoundedDefault.default));
parcelHelpers.export(exports, "Battery90Sharp", ()=>(0, _battery90SharpDefault.default));
parcelHelpers.export(exports, "Battery90TwoTone", ()=>(0, _battery90TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryAlert", ()=>(0, _batteryAlertDefault.default));
parcelHelpers.export(exports, "BatteryAlertOutlined", ()=>(0, _batteryAlertOutlinedDefault.default));
parcelHelpers.export(exports, "BatteryAlertRounded", ()=>(0, _batteryAlertRoundedDefault.default));
parcelHelpers.export(exports, "BatteryAlertSharp", ()=>(0, _batteryAlertSharpDefault.default));
parcelHelpers.export(exports, "BatteryAlertTwoTone", ()=>(0, _batteryAlertTwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging20", ()=>(0, _batteryCharging20Default.default));
parcelHelpers.export(exports, "BatteryCharging20Outlined", ()=>(0, _batteryCharging20OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging20Rounded", ()=>(0, _batteryCharging20RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging20Sharp", ()=>(0, _batteryCharging20SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging20TwoTone", ()=>(0, _batteryCharging20TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging30", ()=>(0, _batteryCharging30Default.default));
parcelHelpers.export(exports, "BatteryCharging30Outlined", ()=>(0, _batteryCharging30OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging30Rounded", ()=>(0, _batteryCharging30RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging30Sharp", ()=>(0, _batteryCharging30SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging30TwoTone", ()=>(0, _batteryCharging30TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging50", ()=>(0, _batteryCharging50Default.default));
parcelHelpers.export(exports, "BatteryCharging50Outlined", ()=>(0, _batteryCharging50OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging50Rounded", ()=>(0, _batteryCharging50RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging50Sharp", ()=>(0, _batteryCharging50SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging50TwoTone", ()=>(0, _batteryCharging50TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging60", ()=>(0, _batteryCharging60Default.default));
parcelHelpers.export(exports, "BatteryCharging60Outlined", ()=>(0, _batteryCharging60OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging60Rounded", ()=>(0, _batteryCharging60RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging60Sharp", ()=>(0, _batteryCharging60SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging60TwoTone", ()=>(0, _batteryCharging60TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging80", ()=>(0, _batteryCharging80Default.default));
parcelHelpers.export(exports, "BatteryCharging80Outlined", ()=>(0, _batteryCharging80OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging80Rounded", ()=>(0, _batteryCharging80RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging80Sharp", ()=>(0, _batteryCharging80SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging80TwoTone", ()=>(0, _batteryCharging80TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryCharging90", ()=>(0, _batteryCharging90Default.default));
parcelHelpers.export(exports, "BatteryCharging90Outlined", ()=>(0, _batteryCharging90OutlinedDefault.default));
parcelHelpers.export(exports, "BatteryCharging90Rounded", ()=>(0, _batteryCharging90RoundedDefault.default));
parcelHelpers.export(exports, "BatteryCharging90Sharp", ()=>(0, _batteryCharging90SharpDefault.default));
parcelHelpers.export(exports, "BatteryCharging90TwoTone", ()=>(0, _batteryCharging90TwoToneDefault.default));
parcelHelpers.export(exports, "BatteryChargingFull", ()=>(0, _batteryChargingFullDefault.default));
parcelHelpers.export(exports, "BatteryChargingFullOutlined", ()=>(0, _batteryChargingFullOutlinedDefault.default));
parcelHelpers.export(exports, "BatteryChargingFullRounded", ()=>(0, _batteryChargingFullRoundedDefault.default));
parcelHelpers.export(exports, "BatteryChargingFullSharp", ()=>(0, _batteryChargingFullSharpDefault.default));
parcelHelpers.export(exports, "BatteryChargingFullTwoTone", ()=>(0, _batteryChargingFullTwoToneDefault.default));
parcelHelpers.export(exports, "BatteryFull", ()=>(0, _batteryFullDefault.default));
parcelHelpers.export(exports, "BatteryFullOutlined", ()=>(0, _batteryFullOutlinedDefault.default));
parcelHelpers.export(exports, "BatteryFullRounded", ()=>(0, _batteryFullRoundedDefault.default));
parcelHelpers.export(exports, "BatteryFullSharp", ()=>(0, _batteryFullSharpDefault.default));
parcelHelpers.export(exports, "BatteryFullTwoTone", ()=>(0, _batteryFullTwoToneDefault.default));
parcelHelpers.export(exports, "BatterySaver", ()=>(0, _batterySaverDefault.default));
parcelHelpers.export(exports, "BatterySaverOutlined", ()=>(0, _batterySaverOutlinedDefault.default));
parcelHelpers.export(exports, "BatterySaverRounded", ()=>(0, _batterySaverRoundedDefault.default));
parcelHelpers.export(exports, "BatterySaverSharp", ()=>(0, _batterySaverSharpDefault.default));
parcelHelpers.export(exports, "BatterySaverTwoTone", ()=>(0, _batterySaverTwoToneDefault.default));
parcelHelpers.export(exports, "BatteryStd", ()=>(0, _batteryStdDefault.default));
parcelHelpers.export(exports, "BatteryStdOutlined", ()=>(0, _batteryStdOutlinedDefault.default));
parcelHelpers.export(exports, "BatteryStdRounded", ()=>(0, _batteryStdRoundedDefault.default));
parcelHelpers.export(exports, "BatteryStdSharp", ()=>(0, _batteryStdSharpDefault.default));
parcelHelpers.export(exports, "BatteryStdTwoTone", ()=>(0, _batteryStdTwoToneDefault.default));
parcelHelpers.export(exports, "BatteryUnknown", ()=>(0, _batteryUnknownDefault.default));
parcelHelpers.export(exports, "BatteryUnknownOutlined", ()=>(0, _batteryUnknownOutlinedDefault.default));
parcelHelpers.export(exports, "BatteryUnknownRounded", ()=>(0, _batteryUnknownRoundedDefault.default));
parcelHelpers.export(exports, "BatteryUnknownSharp", ()=>(0, _batteryUnknownSharpDefault.default));
parcelHelpers.export(exports, "BatteryUnknownTwoTone", ()=>(0, _batteryUnknownTwoToneDefault.default));
parcelHelpers.export(exports, "BeachAccess", ()=>(0, _beachAccessDefault.default));
parcelHelpers.export(exports, "BeachAccessOutlined", ()=>(0, _beachAccessOutlinedDefault.default));
parcelHelpers.export(exports, "BeachAccessRounded", ()=>(0, _beachAccessRoundedDefault.default));
parcelHelpers.export(exports, "BeachAccessSharp", ()=>(0, _beachAccessSharpDefault.default));
parcelHelpers.export(exports, "BeachAccessTwoTone", ()=>(0, _beachAccessTwoToneDefault.default));
parcelHelpers.export(exports, "Bed", ()=>(0, _bedDefault.default));
parcelHelpers.export(exports, "BedOutlined", ()=>(0, _bedOutlinedDefault.default));
parcelHelpers.export(exports, "BedRounded", ()=>(0, _bedRoundedDefault.default));
parcelHelpers.export(exports, "BedSharp", ()=>(0, _bedSharpDefault.default));
parcelHelpers.export(exports, "BedTwoTone", ()=>(0, _bedTwoToneDefault.default));
parcelHelpers.export(exports, "BedroomBaby", ()=>(0, _bedroomBabyDefault.default));
parcelHelpers.export(exports, "BedroomBabyOutlined", ()=>(0, _bedroomBabyOutlinedDefault.default));
parcelHelpers.export(exports, "BedroomBabyRounded", ()=>(0, _bedroomBabyRoundedDefault.default));
parcelHelpers.export(exports, "BedroomBabySharp", ()=>(0, _bedroomBabySharpDefault.default));
parcelHelpers.export(exports, "BedroomBabyTwoTone", ()=>(0, _bedroomBabyTwoToneDefault.default));
parcelHelpers.export(exports, "BedroomChild", ()=>(0, _bedroomChildDefault.default));
parcelHelpers.export(exports, "BedroomChildOutlined", ()=>(0, _bedroomChildOutlinedDefault.default));
parcelHelpers.export(exports, "BedroomChildRounded", ()=>(0, _bedroomChildRoundedDefault.default));
parcelHelpers.export(exports, "BedroomChildSharp", ()=>(0, _bedroomChildSharpDefault.default));
parcelHelpers.export(exports, "BedroomChildTwoTone", ()=>(0, _bedroomChildTwoToneDefault.default));
parcelHelpers.export(exports, "BedroomParent", ()=>(0, _bedroomParentDefault.default));
parcelHelpers.export(exports, "BedroomParentOutlined", ()=>(0, _bedroomParentOutlinedDefault.default));
parcelHelpers.export(exports, "BedroomParentRounded", ()=>(0, _bedroomParentRoundedDefault.default));
parcelHelpers.export(exports, "BedroomParentSharp", ()=>(0, _bedroomParentSharpDefault.default));
parcelHelpers.export(exports, "BedroomParentTwoTone", ()=>(0, _bedroomParentTwoToneDefault.default));
parcelHelpers.export(exports, "Bedtime", ()=>(0, _bedtimeDefault.default));
parcelHelpers.export(exports, "BedtimeOff", ()=>(0, _bedtimeOffDefault.default));
parcelHelpers.export(exports, "BedtimeOffOutlined", ()=>(0, _bedtimeOffOutlinedDefault.default));
parcelHelpers.export(exports, "BedtimeOffRounded", ()=>(0, _bedtimeOffRoundedDefault.default));
parcelHelpers.export(exports, "BedtimeOffSharp", ()=>(0, _bedtimeOffSharpDefault.default));
parcelHelpers.export(exports, "BedtimeOffTwoTone", ()=>(0, _bedtimeOffTwoToneDefault.default));
parcelHelpers.export(exports, "BedtimeOutlined", ()=>(0, _bedtimeOutlinedDefault.default));
parcelHelpers.export(exports, "BedtimeRounded", ()=>(0, _bedtimeRoundedDefault.default));
parcelHelpers.export(exports, "BedtimeSharp", ()=>(0, _bedtimeSharpDefault.default));
parcelHelpers.export(exports, "BedtimeTwoTone", ()=>(0, _bedtimeTwoToneDefault.default));
parcelHelpers.export(exports, "Beenhere", ()=>(0, _beenhereDefault.default));
parcelHelpers.export(exports, "BeenhereOutlined", ()=>(0, _beenhereOutlinedDefault.default));
parcelHelpers.export(exports, "BeenhereRounded", ()=>(0, _beenhereRoundedDefault.default));
parcelHelpers.export(exports, "BeenhereSharp", ()=>(0, _beenhereSharpDefault.default));
parcelHelpers.export(exports, "BeenhereTwoTone", ()=>(0, _beenhereTwoToneDefault.default));
parcelHelpers.export(exports, "Bento", ()=>(0, _bentoDefault.default));
parcelHelpers.export(exports, "BentoOutlined", ()=>(0, _bentoOutlinedDefault.default));
parcelHelpers.export(exports, "BentoRounded", ()=>(0, _bentoRoundedDefault.default));
parcelHelpers.export(exports, "BentoSharp", ()=>(0, _bentoSharpDefault.default));
parcelHelpers.export(exports, "BentoTwoTone", ()=>(0, _bentoTwoToneDefault.default));
parcelHelpers.export(exports, "BikeScooter", ()=>(0, _bikeScooterDefault.default));
parcelHelpers.export(exports, "BikeScooterOutlined", ()=>(0, _bikeScooterOutlinedDefault.default));
parcelHelpers.export(exports, "BikeScooterRounded", ()=>(0, _bikeScooterRoundedDefault.default));
parcelHelpers.export(exports, "BikeScooterSharp", ()=>(0, _bikeScooterSharpDefault.default));
parcelHelpers.export(exports, "BikeScooterTwoTone", ()=>(0, _bikeScooterTwoToneDefault.default));
parcelHelpers.export(exports, "Biotech", ()=>(0, _biotechDefault.default));
parcelHelpers.export(exports, "BiotechOutlined", ()=>(0, _biotechOutlinedDefault.default));
parcelHelpers.export(exports, "BiotechRounded", ()=>(0, _biotechRoundedDefault.default));
parcelHelpers.export(exports, "BiotechSharp", ()=>(0, _biotechSharpDefault.default));
parcelHelpers.export(exports, "BiotechTwoTone", ()=>(0, _biotechTwoToneDefault.default));
parcelHelpers.export(exports, "Blender", ()=>(0, _blenderDefault.default));
parcelHelpers.export(exports, "BlenderOutlined", ()=>(0, _blenderOutlinedDefault.default));
parcelHelpers.export(exports, "BlenderRounded", ()=>(0, _blenderRoundedDefault.default));
parcelHelpers.export(exports, "BlenderSharp", ()=>(0, _blenderSharpDefault.default));
parcelHelpers.export(exports, "BlenderTwoTone", ()=>(0, _blenderTwoToneDefault.default));
parcelHelpers.export(exports, "Blind", ()=>(0, _blindDefault.default));
parcelHelpers.export(exports, "BlindOutlined", ()=>(0, _blindOutlinedDefault.default));
parcelHelpers.export(exports, "BlindRounded", ()=>(0, _blindRoundedDefault.default));
parcelHelpers.export(exports, "BlindSharp", ()=>(0, _blindSharpDefault.default));
parcelHelpers.export(exports, "BlindTwoTone", ()=>(0, _blindTwoToneDefault.default));
parcelHelpers.export(exports, "Blinds", ()=>(0, _blindsDefault.default));
parcelHelpers.export(exports, "BlindsClosed", ()=>(0, _blindsClosedDefault.default));
parcelHelpers.export(exports, "BlindsClosedOutlined", ()=>(0, _blindsClosedOutlinedDefault.default));
parcelHelpers.export(exports, "BlindsClosedRounded", ()=>(0, _blindsClosedRoundedDefault.default));
parcelHelpers.export(exports, "BlindsClosedSharp", ()=>(0, _blindsClosedSharpDefault.default));
parcelHelpers.export(exports, "BlindsClosedTwoTone", ()=>(0, _blindsClosedTwoToneDefault.default));
parcelHelpers.export(exports, "BlindsOutlined", ()=>(0, _blindsOutlinedDefault.default));
parcelHelpers.export(exports, "BlindsRounded", ()=>(0, _blindsRoundedDefault.default));
parcelHelpers.export(exports, "BlindsSharp", ()=>(0, _blindsSharpDefault.default));
parcelHelpers.export(exports, "BlindsTwoTone", ()=>(0, _blindsTwoToneDefault.default));
parcelHelpers.export(exports, "Block", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "BlockOutlined", ()=>(0, _blockOutlinedDefault.default));
parcelHelpers.export(exports, "BlockRounded", ()=>(0, _blockRoundedDefault.default));
parcelHelpers.export(exports, "BlockSharp", ()=>(0, _blockSharpDefault.default));
parcelHelpers.export(exports, "BlockTwoTone", ()=>(0, _blockTwoToneDefault.default));
parcelHelpers.export(exports, "Bloodtype", ()=>(0, _bloodtypeDefault.default));
parcelHelpers.export(exports, "BloodtypeOutlined", ()=>(0, _bloodtypeOutlinedDefault.default));
parcelHelpers.export(exports, "BloodtypeRounded", ()=>(0, _bloodtypeRoundedDefault.default));
parcelHelpers.export(exports, "BloodtypeSharp", ()=>(0, _bloodtypeSharpDefault.default));
parcelHelpers.export(exports, "BloodtypeTwoTone", ()=>(0, _bloodtypeTwoToneDefault.default));
parcelHelpers.export(exports, "Bluetooth", ()=>(0, _bluetoothDefault.default));
parcelHelpers.export(exports, "BluetoothAudio", ()=>(0, _bluetoothAudioDefault.default));
parcelHelpers.export(exports, "BluetoothAudioOutlined", ()=>(0, _bluetoothAudioOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothAudioRounded", ()=>(0, _bluetoothAudioRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothAudioSharp", ()=>(0, _bluetoothAudioSharpDefault.default));
parcelHelpers.export(exports, "BluetoothAudioTwoTone", ()=>(0, _bluetoothAudioTwoToneDefault.default));
parcelHelpers.export(exports, "BluetoothConnected", ()=>(0, _bluetoothConnectedDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedOutlined", ()=>(0, _bluetoothConnectedOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedRounded", ()=>(0, _bluetoothConnectedRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedSharp", ()=>(0, _bluetoothConnectedSharpDefault.default));
parcelHelpers.export(exports, "BluetoothConnectedTwoTone", ()=>(0, _bluetoothConnectedTwoToneDefault.default));
parcelHelpers.export(exports, "BluetoothDisabled", ()=>(0, _bluetoothDisabledDefault.default));
parcelHelpers.export(exports, "BluetoothDisabledOutlined", ()=>(0, _bluetoothDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothDisabledRounded", ()=>(0, _bluetoothDisabledRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothDisabledSharp", ()=>(0, _bluetoothDisabledSharpDefault.default));
parcelHelpers.export(exports, "BluetoothDisabledTwoTone", ()=>(0, _bluetoothDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "BluetoothDrive", ()=>(0, _bluetoothDriveDefault.default));
parcelHelpers.export(exports, "BluetoothDriveOutlined", ()=>(0, _bluetoothDriveOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothDriveRounded", ()=>(0, _bluetoothDriveRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothDriveSharp", ()=>(0, _bluetoothDriveSharpDefault.default));
parcelHelpers.export(exports, "BluetoothDriveTwoTone", ()=>(0, _bluetoothDriveTwoToneDefault.default));
parcelHelpers.export(exports, "BluetoothOutlined", ()=>(0, _bluetoothOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothRounded", ()=>(0, _bluetoothRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothSearching", ()=>(0, _bluetoothSearchingDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingOutlined", ()=>(0, _bluetoothSearchingOutlinedDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingRounded", ()=>(0, _bluetoothSearchingRoundedDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingSharp", ()=>(0, _bluetoothSearchingSharpDefault.default));
parcelHelpers.export(exports, "BluetoothSearchingTwoTone", ()=>(0, _bluetoothSearchingTwoToneDefault.default));
parcelHelpers.export(exports, "BluetoothSharp", ()=>(0, _bluetoothSharpDefault.default));
parcelHelpers.export(exports, "BluetoothTwoTone", ()=>(0, _bluetoothTwoToneDefault.default));
parcelHelpers.export(exports, "BlurCircular", ()=>(0, _blurCircularDefault.default));
parcelHelpers.export(exports, "BlurCircularOutlined", ()=>(0, _blurCircularOutlinedDefault.default));
parcelHelpers.export(exports, "BlurCircularRounded", ()=>(0, _blurCircularRoundedDefault.default));
parcelHelpers.export(exports, "BlurCircularSharp", ()=>(0, _blurCircularSharpDefault.default));
parcelHelpers.export(exports, "BlurCircularTwoTone", ()=>(0, _blurCircularTwoToneDefault.default));
parcelHelpers.export(exports, "BlurLinear", ()=>(0, _blurLinearDefault.default));
parcelHelpers.export(exports, "BlurLinearOutlined", ()=>(0, _blurLinearOutlinedDefault.default));
parcelHelpers.export(exports, "BlurLinearRounded", ()=>(0, _blurLinearRoundedDefault.default));
parcelHelpers.export(exports, "BlurLinearSharp", ()=>(0, _blurLinearSharpDefault.default));
parcelHelpers.export(exports, "BlurLinearTwoTone", ()=>(0, _blurLinearTwoToneDefault.default));
parcelHelpers.export(exports, "BlurOff", ()=>(0, _blurOffDefault.default));
parcelHelpers.export(exports, "BlurOffOutlined", ()=>(0, _blurOffOutlinedDefault.default));
parcelHelpers.export(exports, "BlurOffRounded", ()=>(0, _blurOffRoundedDefault.default));
parcelHelpers.export(exports, "BlurOffSharp", ()=>(0, _blurOffSharpDefault.default));
parcelHelpers.export(exports, "BlurOffTwoTone", ()=>(0, _blurOffTwoToneDefault.default));
parcelHelpers.export(exports, "BlurOn", ()=>(0, _blurOnDefault.default));
parcelHelpers.export(exports, "BlurOnOutlined", ()=>(0, _blurOnOutlinedDefault.default));
parcelHelpers.export(exports, "BlurOnRounded", ()=>(0, _blurOnRoundedDefault.default));
parcelHelpers.export(exports, "BlurOnSharp", ()=>(0, _blurOnSharpDefault.default));
parcelHelpers.export(exports, "BlurOnTwoTone", ()=>(0, _blurOnTwoToneDefault.default));
parcelHelpers.export(exports, "Bolt", ()=>(0, _boltDefault.default));
parcelHelpers.export(exports, "BoltOutlined", ()=>(0, _boltOutlinedDefault.default));
parcelHelpers.export(exports, "BoltRounded", ()=>(0, _boltRoundedDefault.default));
parcelHelpers.export(exports, "BoltSharp", ()=>(0, _boltSharpDefault.default));
parcelHelpers.export(exports, "BoltTwoTone", ()=>(0, _boltTwoToneDefault.default));
parcelHelpers.export(exports, "Book", ()=>(0, _bookDefault.default));
parcelHelpers.export(exports, "BookOnline", ()=>(0, _bookOnlineDefault.default));
parcelHelpers.export(exports, "BookOnlineOutlined", ()=>(0, _bookOnlineOutlinedDefault.default));
parcelHelpers.export(exports, "BookOnlineRounded", ()=>(0, _bookOnlineRoundedDefault.default));
parcelHelpers.export(exports, "BookOnlineSharp", ()=>(0, _bookOnlineSharpDefault.default));
parcelHelpers.export(exports, "BookOnlineTwoTone", ()=>(0, _bookOnlineTwoToneDefault.default));
parcelHelpers.export(exports, "BookOutlined", ()=>(0, _bookOutlinedDefault.default));
parcelHelpers.export(exports, "BookRounded", ()=>(0, _bookRoundedDefault.default));
parcelHelpers.export(exports, "BookSharp", ()=>(0, _bookSharpDefault.default));
parcelHelpers.export(exports, "BookTwoTone", ()=>(0, _bookTwoToneDefault.default));
parcelHelpers.export(exports, "Bookmark", ()=>(0, _bookmarkDefault.default));
parcelHelpers.export(exports, "BookmarkAdd", ()=>(0, _bookmarkAddDefault.default));
parcelHelpers.export(exports, "BookmarkAddOutlined", ()=>(0, _bookmarkAddOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarkAddRounded", ()=>(0, _bookmarkAddRoundedDefault.default));
parcelHelpers.export(exports, "BookmarkAddSharp", ()=>(0, _bookmarkAddSharpDefault.default));
parcelHelpers.export(exports, "BookmarkAddTwoTone", ()=>(0, _bookmarkAddTwoToneDefault.default));
parcelHelpers.export(exports, "BookmarkAdded", ()=>(0, _bookmarkAddedDefault.default));
parcelHelpers.export(exports, "BookmarkAddedOutlined", ()=>(0, _bookmarkAddedOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarkAddedRounded", ()=>(0, _bookmarkAddedRoundedDefault.default));
parcelHelpers.export(exports, "BookmarkAddedSharp", ()=>(0, _bookmarkAddedSharpDefault.default));
parcelHelpers.export(exports, "BookmarkAddedTwoTone", ()=>(0, _bookmarkAddedTwoToneDefault.default));
parcelHelpers.export(exports, "BookmarkBorder", ()=>(0, _bookmarkBorderDefault.default));
parcelHelpers.export(exports, "BookmarkBorderOutlined", ()=>(0, _bookmarkBorderOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarkBorderRounded", ()=>(0, _bookmarkBorderRoundedDefault.default));
parcelHelpers.export(exports, "BookmarkBorderSharp", ()=>(0, _bookmarkBorderSharpDefault.default));
parcelHelpers.export(exports, "BookmarkBorderTwoTone", ()=>(0, _bookmarkBorderTwoToneDefault.default));
parcelHelpers.export(exports, "BookmarkOutlined", ()=>(0, _bookmarkOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarkRemove", ()=>(0, _bookmarkRemoveDefault.default));
parcelHelpers.export(exports, "BookmarkRemoveOutlined", ()=>(0, _bookmarkRemoveOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarkRemoveRounded", ()=>(0, _bookmarkRemoveRoundedDefault.default));
parcelHelpers.export(exports, "BookmarkRemoveSharp", ()=>(0, _bookmarkRemoveSharpDefault.default));
parcelHelpers.export(exports, "BookmarkRemoveTwoTone", ()=>(0, _bookmarkRemoveTwoToneDefault.default));
parcelHelpers.export(exports, "BookmarkRounded", ()=>(0, _bookmarkRoundedDefault.default));
parcelHelpers.export(exports, "BookmarkSharp", ()=>(0, _bookmarkSharpDefault.default));
parcelHelpers.export(exports, "BookmarkTwoTone", ()=>(0, _bookmarkTwoToneDefault.default));
parcelHelpers.export(exports, "Bookmarks", ()=>(0, _bookmarksDefault.default));
parcelHelpers.export(exports, "BookmarksOutlined", ()=>(0, _bookmarksOutlinedDefault.default));
parcelHelpers.export(exports, "BookmarksRounded", ()=>(0, _bookmarksRoundedDefault.default));
parcelHelpers.export(exports, "BookmarksSharp", ()=>(0, _bookmarksSharpDefault.default));
parcelHelpers.export(exports, "BookmarksTwoTone", ()=>(0, _bookmarksTwoToneDefault.default));
parcelHelpers.export(exports, "BorderAll", ()=>(0, _borderAllDefault.default));
parcelHelpers.export(exports, "BorderAllOutlined", ()=>(0, _borderAllOutlinedDefault.default));
parcelHelpers.export(exports, "BorderAllRounded", ()=>(0, _borderAllRoundedDefault.default));
parcelHelpers.export(exports, "BorderAllSharp", ()=>(0, _borderAllSharpDefault.default));
parcelHelpers.export(exports, "BorderAllTwoTone", ()=>(0, _borderAllTwoToneDefault.default));
parcelHelpers.export(exports, "BorderBottom", ()=>(0, _borderBottomDefault.default));
parcelHelpers.export(exports, "BorderBottomOutlined", ()=>(0, _borderBottomOutlinedDefault.default));
parcelHelpers.export(exports, "BorderBottomRounded", ()=>(0, _borderBottomRoundedDefault.default));
parcelHelpers.export(exports, "BorderBottomSharp", ()=>(0, _borderBottomSharpDefault.default));
parcelHelpers.export(exports, "BorderBottomTwoTone", ()=>(0, _borderBottomTwoToneDefault.default));
parcelHelpers.export(exports, "BorderClear", ()=>(0, _borderClearDefault.default));
parcelHelpers.export(exports, "BorderClearOutlined", ()=>(0, _borderClearOutlinedDefault.default));
parcelHelpers.export(exports, "BorderClearRounded", ()=>(0, _borderClearRoundedDefault.default));
parcelHelpers.export(exports, "BorderClearSharp", ()=>(0, _borderClearSharpDefault.default));
parcelHelpers.export(exports, "BorderClearTwoTone", ()=>(0, _borderClearTwoToneDefault.default));
parcelHelpers.export(exports, "BorderColor", ()=>(0, _borderColorDefault.default));
parcelHelpers.export(exports, "BorderColorOutlined", ()=>(0, _borderColorOutlinedDefault.default));
parcelHelpers.export(exports, "BorderColorRounded", ()=>(0, _borderColorRoundedDefault.default));
parcelHelpers.export(exports, "BorderColorSharp", ()=>(0, _borderColorSharpDefault.default));
parcelHelpers.export(exports, "BorderColorTwoTone", ()=>(0, _borderColorTwoToneDefault.default));
parcelHelpers.export(exports, "BorderHorizontal", ()=>(0, _borderHorizontalDefault.default));
parcelHelpers.export(exports, "BorderHorizontalOutlined", ()=>(0, _borderHorizontalOutlinedDefault.default));
parcelHelpers.export(exports, "BorderHorizontalRounded", ()=>(0, _borderHorizontalRoundedDefault.default));
parcelHelpers.export(exports, "BorderHorizontalSharp", ()=>(0, _borderHorizontalSharpDefault.default));
parcelHelpers.export(exports, "BorderHorizontalTwoTone", ()=>(0, _borderHorizontalTwoToneDefault.default));
parcelHelpers.export(exports, "BorderInner", ()=>(0, _borderInnerDefault.default));
parcelHelpers.export(exports, "BorderInnerOutlined", ()=>(0, _borderInnerOutlinedDefault.default));
parcelHelpers.export(exports, "BorderInnerRounded", ()=>(0, _borderInnerRoundedDefault.default));
parcelHelpers.export(exports, "BorderInnerSharp", ()=>(0, _borderInnerSharpDefault.default));
parcelHelpers.export(exports, "BorderInnerTwoTone", ()=>(0, _borderInnerTwoToneDefault.default));
parcelHelpers.export(exports, "BorderLeft", ()=>(0, _borderLeftDefault.default));
parcelHelpers.export(exports, "BorderLeftOutlined", ()=>(0, _borderLeftOutlinedDefault.default));
parcelHelpers.export(exports, "BorderLeftRounded", ()=>(0, _borderLeftRoundedDefault.default));
parcelHelpers.export(exports, "BorderLeftSharp", ()=>(0, _borderLeftSharpDefault.default));
parcelHelpers.export(exports, "BorderLeftTwoTone", ()=>(0, _borderLeftTwoToneDefault.default));
parcelHelpers.export(exports, "BorderOuter", ()=>(0, _borderOuterDefault.default));
parcelHelpers.export(exports, "BorderOuterOutlined", ()=>(0, _borderOuterOutlinedDefault.default));
parcelHelpers.export(exports, "BorderOuterRounded", ()=>(0, _borderOuterRoundedDefault.default));
parcelHelpers.export(exports, "BorderOuterSharp", ()=>(0, _borderOuterSharpDefault.default));
parcelHelpers.export(exports, "BorderOuterTwoTone", ()=>(0, _borderOuterTwoToneDefault.default));
parcelHelpers.export(exports, "BorderRight", ()=>(0, _borderRightDefault.default));
parcelHelpers.export(exports, "BorderRightOutlined", ()=>(0, _borderRightOutlinedDefault.default));
parcelHelpers.export(exports, "BorderRightRounded", ()=>(0, _borderRightRoundedDefault.default));
parcelHelpers.export(exports, "BorderRightSharp", ()=>(0, _borderRightSharpDefault.default));
parcelHelpers.export(exports, "BorderRightTwoTone", ()=>(0, _borderRightTwoToneDefault.default));
parcelHelpers.export(exports, "BorderStyle", ()=>(0, _borderStyleDefault.default));
parcelHelpers.export(exports, "BorderStyleOutlined", ()=>(0, _borderStyleOutlinedDefault.default));
parcelHelpers.export(exports, "BorderStyleRounded", ()=>(0, _borderStyleRoundedDefault.default));
parcelHelpers.export(exports, "BorderStyleSharp", ()=>(0, _borderStyleSharpDefault.default));
parcelHelpers.export(exports, "BorderStyleTwoTone", ()=>(0, _borderStyleTwoToneDefault.default));
parcelHelpers.export(exports, "BorderTop", ()=>(0, _borderTopDefault.default));
parcelHelpers.export(exports, "BorderTopOutlined", ()=>(0, _borderTopOutlinedDefault.default));
parcelHelpers.export(exports, "BorderTopRounded", ()=>(0, _borderTopRoundedDefault.default));
parcelHelpers.export(exports, "BorderTopSharp", ()=>(0, _borderTopSharpDefault.default));
parcelHelpers.export(exports, "BorderTopTwoTone", ()=>(0, _borderTopTwoToneDefault.default));
parcelHelpers.export(exports, "BorderVertical", ()=>(0, _borderVerticalDefault.default));
parcelHelpers.export(exports, "BorderVerticalOutlined", ()=>(0, _borderVerticalOutlinedDefault.default));
parcelHelpers.export(exports, "BorderVerticalRounded", ()=>(0, _borderVerticalRoundedDefault.default));
parcelHelpers.export(exports, "BorderVerticalSharp", ()=>(0, _borderVerticalSharpDefault.default));
parcelHelpers.export(exports, "BorderVerticalTwoTone", ()=>(0, _borderVerticalTwoToneDefault.default));
parcelHelpers.export(exports, "Boy", ()=>(0, _boyDefault.default));
parcelHelpers.export(exports, "BoyOutlined", ()=>(0, _boyOutlinedDefault.default));
parcelHelpers.export(exports, "BoyRounded", ()=>(0, _boyRoundedDefault.default));
parcelHelpers.export(exports, "BoySharp", ()=>(0, _boySharpDefault.default));
parcelHelpers.export(exports, "BoyTwoTone", ()=>(0, _boyTwoToneDefault.default));
parcelHelpers.export(exports, "BrandingWatermark", ()=>(0, _brandingWatermarkDefault.default));
parcelHelpers.export(exports, "BrandingWatermarkOutlined", ()=>(0, _brandingWatermarkOutlinedDefault.default));
parcelHelpers.export(exports, "BrandingWatermarkRounded", ()=>(0, _brandingWatermarkRoundedDefault.default));
parcelHelpers.export(exports, "BrandingWatermarkSharp", ()=>(0, _brandingWatermarkSharpDefault.default));
parcelHelpers.export(exports, "BrandingWatermarkTwoTone", ()=>(0, _brandingWatermarkTwoToneDefault.default));
parcelHelpers.export(exports, "BreakfastDining", ()=>(0, _breakfastDiningDefault.default));
parcelHelpers.export(exports, "BreakfastDiningOutlined", ()=>(0, _breakfastDiningOutlinedDefault.default));
parcelHelpers.export(exports, "BreakfastDiningRounded", ()=>(0, _breakfastDiningRoundedDefault.default));
parcelHelpers.export(exports, "BreakfastDiningSharp", ()=>(0, _breakfastDiningSharpDefault.default));
parcelHelpers.export(exports, "BreakfastDiningTwoTone", ()=>(0, _breakfastDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Brightness1", ()=>(0, _brightness1Default.default));
parcelHelpers.export(exports, "Brightness1Outlined", ()=>(0, _brightness1OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness1Rounded", ()=>(0, _brightness1RoundedDefault.default));
parcelHelpers.export(exports, "Brightness1Sharp", ()=>(0, _brightness1SharpDefault.default));
parcelHelpers.export(exports, "Brightness1TwoTone", ()=>(0, _brightness1TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness2", ()=>(0, _brightness2Default.default));
parcelHelpers.export(exports, "Brightness2Outlined", ()=>(0, _brightness2OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness2Rounded", ()=>(0, _brightness2RoundedDefault.default));
parcelHelpers.export(exports, "Brightness2Sharp", ()=>(0, _brightness2SharpDefault.default));
parcelHelpers.export(exports, "Brightness2TwoTone", ()=>(0, _brightness2TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness3", ()=>(0, _brightness3Default.default));
parcelHelpers.export(exports, "Brightness3Outlined", ()=>(0, _brightness3OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness3Rounded", ()=>(0, _brightness3RoundedDefault.default));
parcelHelpers.export(exports, "Brightness3Sharp", ()=>(0, _brightness3SharpDefault.default));
parcelHelpers.export(exports, "Brightness3TwoTone", ()=>(0, _brightness3TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness4", ()=>(0, _brightness4Default.default));
parcelHelpers.export(exports, "Brightness4Outlined", ()=>(0, _brightness4OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness4Rounded", ()=>(0, _brightness4RoundedDefault.default));
parcelHelpers.export(exports, "Brightness4Sharp", ()=>(0, _brightness4SharpDefault.default));
parcelHelpers.export(exports, "Brightness4TwoTone", ()=>(0, _brightness4TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness5", ()=>(0, _brightness5Default.default));
parcelHelpers.export(exports, "Brightness5Outlined", ()=>(0, _brightness5OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness5Rounded", ()=>(0, _brightness5RoundedDefault.default));
parcelHelpers.export(exports, "Brightness5Sharp", ()=>(0, _brightness5SharpDefault.default));
parcelHelpers.export(exports, "Brightness5TwoTone", ()=>(0, _brightness5TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness6", ()=>(0, _brightness6Default.default));
parcelHelpers.export(exports, "Brightness6Outlined", ()=>(0, _brightness6OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness6Rounded", ()=>(0, _brightness6RoundedDefault.default));
parcelHelpers.export(exports, "Brightness6Sharp", ()=>(0, _brightness6SharpDefault.default));
parcelHelpers.export(exports, "Brightness6TwoTone", ()=>(0, _brightness6TwoToneDefault.default));
parcelHelpers.export(exports, "Brightness7", ()=>(0, _brightness7Default.default));
parcelHelpers.export(exports, "Brightness7Outlined", ()=>(0, _brightness7OutlinedDefault.default));
parcelHelpers.export(exports, "Brightness7Rounded", ()=>(0, _brightness7RoundedDefault.default));
parcelHelpers.export(exports, "Brightness7Sharp", ()=>(0, _brightness7SharpDefault.default));
parcelHelpers.export(exports, "Brightness7TwoTone", ()=>(0, _brightness7TwoToneDefault.default));
parcelHelpers.export(exports, "BrightnessAuto", ()=>(0, _brightnessAutoDefault.default));
parcelHelpers.export(exports, "BrightnessAutoOutlined", ()=>(0, _brightnessAutoOutlinedDefault.default));
parcelHelpers.export(exports, "BrightnessAutoRounded", ()=>(0, _brightnessAutoRoundedDefault.default));
parcelHelpers.export(exports, "BrightnessAutoSharp", ()=>(0, _brightnessAutoSharpDefault.default));
parcelHelpers.export(exports, "BrightnessAutoTwoTone", ()=>(0, _brightnessAutoTwoToneDefault.default));
parcelHelpers.export(exports, "BrightnessHigh", ()=>(0, _brightnessHighDefault.default));
parcelHelpers.export(exports, "BrightnessHighOutlined", ()=>(0, _brightnessHighOutlinedDefault.default));
parcelHelpers.export(exports, "BrightnessHighRounded", ()=>(0, _brightnessHighRoundedDefault.default));
parcelHelpers.export(exports, "BrightnessHighSharp", ()=>(0, _brightnessHighSharpDefault.default));
parcelHelpers.export(exports, "BrightnessHighTwoTone", ()=>(0, _brightnessHighTwoToneDefault.default));
parcelHelpers.export(exports, "BrightnessLow", ()=>(0, _brightnessLowDefault.default));
parcelHelpers.export(exports, "BrightnessLowOutlined", ()=>(0, _brightnessLowOutlinedDefault.default));
parcelHelpers.export(exports, "BrightnessLowRounded", ()=>(0, _brightnessLowRoundedDefault.default));
parcelHelpers.export(exports, "BrightnessLowSharp", ()=>(0, _brightnessLowSharpDefault.default));
parcelHelpers.export(exports, "BrightnessLowTwoTone", ()=>(0, _brightnessLowTwoToneDefault.default));
parcelHelpers.export(exports, "BrightnessMedium", ()=>(0, _brightnessMediumDefault.default));
parcelHelpers.export(exports, "BrightnessMediumOutlined", ()=>(0, _brightnessMediumOutlinedDefault.default));
parcelHelpers.export(exports, "BrightnessMediumRounded", ()=>(0, _brightnessMediumRoundedDefault.default));
parcelHelpers.export(exports, "BrightnessMediumSharp", ()=>(0, _brightnessMediumSharpDefault.default));
parcelHelpers.export(exports, "BrightnessMediumTwoTone", ()=>(0, _brightnessMediumTwoToneDefault.default));
parcelHelpers.export(exports, "BroadcastOnHome", ()=>(0, _broadcastOnHomeDefault.default));
parcelHelpers.export(exports, "BroadcastOnHomeOutlined", ()=>(0, _broadcastOnHomeOutlinedDefault.default));
parcelHelpers.export(exports, "BroadcastOnHomeRounded", ()=>(0, _broadcastOnHomeRoundedDefault.default));
parcelHelpers.export(exports, "BroadcastOnHomeSharp", ()=>(0, _broadcastOnHomeSharpDefault.default));
parcelHelpers.export(exports, "BroadcastOnHomeTwoTone", ()=>(0, _broadcastOnHomeTwoToneDefault.default));
parcelHelpers.export(exports, "BroadcastOnPersonal", ()=>(0, _broadcastOnPersonalDefault.default));
parcelHelpers.export(exports, "BroadcastOnPersonalOutlined", ()=>(0, _broadcastOnPersonalOutlinedDefault.default));
parcelHelpers.export(exports, "BroadcastOnPersonalRounded", ()=>(0, _broadcastOnPersonalRoundedDefault.default));
parcelHelpers.export(exports, "BroadcastOnPersonalSharp", ()=>(0, _broadcastOnPersonalSharpDefault.default));
parcelHelpers.export(exports, "BroadcastOnPersonalTwoTone", ()=>(0, _broadcastOnPersonalTwoToneDefault.default));
parcelHelpers.export(exports, "BrokenImage", ()=>(0, _brokenImageDefault.default));
parcelHelpers.export(exports, "BrokenImageOutlined", ()=>(0, _brokenImageOutlinedDefault.default));
parcelHelpers.export(exports, "BrokenImageRounded", ()=>(0, _brokenImageRoundedDefault.default));
parcelHelpers.export(exports, "BrokenImageSharp", ()=>(0, _brokenImageSharpDefault.default));
parcelHelpers.export(exports, "BrokenImageTwoTone", ()=>(0, _brokenImageTwoToneDefault.default));
parcelHelpers.export(exports, "BrowseGallery", ()=>(0, _browseGalleryDefault.default));
parcelHelpers.export(exports, "BrowseGalleryOutlined", ()=>(0, _browseGalleryOutlinedDefault.default));
parcelHelpers.export(exports, "BrowseGalleryRounded", ()=>(0, _browseGalleryRoundedDefault.default));
parcelHelpers.export(exports, "BrowseGallerySharp", ()=>(0, _browseGallerySharpDefault.default));
parcelHelpers.export(exports, "BrowseGalleryTwoTone", ()=>(0, _browseGalleryTwoToneDefault.default));
parcelHelpers.export(exports, "BrowserNotSupported", ()=>(0, _browserNotSupportedDefault.default));
parcelHelpers.export(exports, "BrowserNotSupportedOutlined", ()=>(0, _browserNotSupportedOutlinedDefault.default));
parcelHelpers.export(exports, "BrowserNotSupportedRounded", ()=>(0, _browserNotSupportedRoundedDefault.default));
parcelHelpers.export(exports, "BrowserNotSupportedSharp", ()=>(0, _browserNotSupportedSharpDefault.default));
parcelHelpers.export(exports, "BrowserNotSupportedTwoTone", ()=>(0, _browserNotSupportedTwoToneDefault.default));
parcelHelpers.export(exports, "BrowserUpdated", ()=>(0, _browserUpdatedDefault.default));
parcelHelpers.export(exports, "BrowserUpdatedOutlined", ()=>(0, _browserUpdatedOutlinedDefault.default));
parcelHelpers.export(exports, "BrowserUpdatedRounded", ()=>(0, _browserUpdatedRoundedDefault.default));
parcelHelpers.export(exports, "BrowserUpdatedSharp", ()=>(0, _browserUpdatedSharpDefault.default));
parcelHelpers.export(exports, "BrowserUpdatedTwoTone", ()=>(0, _browserUpdatedTwoToneDefault.default));
parcelHelpers.export(exports, "BrunchDining", ()=>(0, _brunchDiningDefault.default));
parcelHelpers.export(exports, "BrunchDiningOutlined", ()=>(0, _brunchDiningOutlinedDefault.default));
parcelHelpers.export(exports, "BrunchDiningRounded", ()=>(0, _brunchDiningRoundedDefault.default));
parcelHelpers.export(exports, "BrunchDiningSharp", ()=>(0, _brunchDiningSharpDefault.default));
parcelHelpers.export(exports, "BrunchDiningTwoTone", ()=>(0, _brunchDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Brush", ()=>(0, _brushDefault.default));
parcelHelpers.export(exports, "BrushOutlined", ()=>(0, _brushOutlinedDefault.default));
parcelHelpers.export(exports, "BrushRounded", ()=>(0, _brushRoundedDefault.default));
parcelHelpers.export(exports, "BrushSharp", ()=>(0, _brushSharpDefault.default));
parcelHelpers.export(exports, "BrushTwoTone", ()=>(0, _brushTwoToneDefault.default));
parcelHelpers.export(exports, "BubbleChart", ()=>(0, _bubbleChartDefault.default));
parcelHelpers.export(exports, "BubbleChartOutlined", ()=>(0, _bubbleChartOutlinedDefault.default));
parcelHelpers.export(exports, "BubbleChartRounded", ()=>(0, _bubbleChartRoundedDefault.default));
parcelHelpers.export(exports, "BubbleChartSharp", ()=>(0, _bubbleChartSharpDefault.default));
parcelHelpers.export(exports, "BubbleChartTwoTone", ()=>(0, _bubbleChartTwoToneDefault.default));
parcelHelpers.export(exports, "BugReport", ()=>(0, _bugReportDefault.default));
parcelHelpers.export(exports, "BugReportOutlined", ()=>(0, _bugReportOutlinedDefault.default));
parcelHelpers.export(exports, "BugReportRounded", ()=>(0, _bugReportRoundedDefault.default));
parcelHelpers.export(exports, "BugReportSharp", ()=>(0, _bugReportSharpDefault.default));
parcelHelpers.export(exports, "BugReportTwoTone", ()=>(0, _bugReportTwoToneDefault.default));
parcelHelpers.export(exports, "Build", ()=>(0, _buildDefault.default));
parcelHelpers.export(exports, "BuildCircle", ()=>(0, _buildCircleDefault.default));
parcelHelpers.export(exports, "BuildCircleOutlined", ()=>(0, _buildCircleOutlinedDefault.default));
parcelHelpers.export(exports, "BuildCircleRounded", ()=>(0, _buildCircleRoundedDefault.default));
parcelHelpers.export(exports, "BuildCircleSharp", ()=>(0, _buildCircleSharpDefault.default));
parcelHelpers.export(exports, "BuildCircleTwoTone", ()=>(0, _buildCircleTwoToneDefault.default));
parcelHelpers.export(exports, "BuildOutlined", ()=>(0, _buildOutlinedDefault.default));
parcelHelpers.export(exports, "BuildRounded", ()=>(0, _buildRoundedDefault.default));
parcelHelpers.export(exports, "BuildSharp", ()=>(0, _buildSharpDefault.default));
parcelHelpers.export(exports, "BuildTwoTone", ()=>(0, _buildTwoToneDefault.default));
parcelHelpers.export(exports, "Bungalow", ()=>(0, _bungalowDefault.default));
parcelHelpers.export(exports, "BungalowOutlined", ()=>(0, _bungalowOutlinedDefault.default));
parcelHelpers.export(exports, "BungalowRounded", ()=>(0, _bungalowRoundedDefault.default));
parcelHelpers.export(exports, "BungalowSharp", ()=>(0, _bungalowSharpDefault.default));
parcelHelpers.export(exports, "BungalowTwoTone", ()=>(0, _bungalowTwoToneDefault.default));
parcelHelpers.export(exports, "BurstMode", ()=>(0, _burstModeDefault.default));
parcelHelpers.export(exports, "BurstModeOutlined", ()=>(0, _burstModeOutlinedDefault.default));
parcelHelpers.export(exports, "BurstModeRounded", ()=>(0, _burstModeRoundedDefault.default));
parcelHelpers.export(exports, "BurstModeSharp", ()=>(0, _burstModeSharpDefault.default));
parcelHelpers.export(exports, "BurstModeTwoTone", ()=>(0, _burstModeTwoToneDefault.default));
parcelHelpers.export(exports, "BusAlert", ()=>(0, _busAlertDefault.default));
parcelHelpers.export(exports, "BusAlertOutlined", ()=>(0, _busAlertOutlinedDefault.default));
parcelHelpers.export(exports, "BusAlertRounded", ()=>(0, _busAlertRoundedDefault.default));
parcelHelpers.export(exports, "BusAlertSharp", ()=>(0, _busAlertSharpDefault.default));
parcelHelpers.export(exports, "BusAlertTwoTone", ()=>(0, _busAlertTwoToneDefault.default));
parcelHelpers.export(exports, "Business", ()=>(0, _businessDefault.default));
parcelHelpers.export(exports, "BusinessCenter", ()=>(0, _businessCenterDefault.default));
parcelHelpers.export(exports, "BusinessCenterOutlined", ()=>(0, _businessCenterOutlinedDefault.default));
parcelHelpers.export(exports, "BusinessCenterRounded", ()=>(0, _businessCenterRoundedDefault.default));
parcelHelpers.export(exports, "BusinessCenterSharp", ()=>(0, _businessCenterSharpDefault.default));
parcelHelpers.export(exports, "BusinessCenterTwoTone", ()=>(0, _businessCenterTwoToneDefault.default));
parcelHelpers.export(exports, "BusinessOutlined", ()=>(0, _businessOutlinedDefault.default));
parcelHelpers.export(exports, "BusinessRounded", ()=>(0, _businessRoundedDefault.default));
parcelHelpers.export(exports, "BusinessSharp", ()=>(0, _businessSharpDefault.default));
parcelHelpers.export(exports, "BusinessTwoTone", ()=>(0, _businessTwoToneDefault.default));
parcelHelpers.export(exports, "Cabin", ()=>(0, _cabinDefault.default));
parcelHelpers.export(exports, "CabinOutlined", ()=>(0, _cabinOutlinedDefault.default));
parcelHelpers.export(exports, "CabinRounded", ()=>(0, _cabinRoundedDefault.default));
parcelHelpers.export(exports, "CabinSharp", ()=>(0, _cabinSharpDefault.default));
parcelHelpers.export(exports, "CabinTwoTone", ()=>(0, _cabinTwoToneDefault.default));
parcelHelpers.export(exports, "Cable", ()=>(0, _cableDefault.default));
parcelHelpers.export(exports, "CableOutlined", ()=>(0, _cableOutlinedDefault.default));
parcelHelpers.export(exports, "CableRounded", ()=>(0, _cableRoundedDefault.default));
parcelHelpers.export(exports, "CableSharp", ()=>(0, _cableSharpDefault.default));
parcelHelpers.export(exports, "CableTwoTone", ()=>(0, _cableTwoToneDefault.default));
parcelHelpers.export(exports, "Cached", ()=>(0, _cachedDefault.default));
parcelHelpers.export(exports, "CachedOutlined", ()=>(0, _cachedOutlinedDefault.default));
parcelHelpers.export(exports, "CachedRounded", ()=>(0, _cachedRoundedDefault.default));
parcelHelpers.export(exports, "CachedSharp", ()=>(0, _cachedSharpDefault.default));
parcelHelpers.export(exports, "CachedTwoTone", ()=>(0, _cachedTwoToneDefault.default));
parcelHelpers.export(exports, "Cake", ()=>(0, _cakeDefault.default));
parcelHelpers.export(exports, "CakeOutlined", ()=>(0, _cakeOutlinedDefault.default));
parcelHelpers.export(exports, "CakeRounded", ()=>(0, _cakeRoundedDefault.default));
parcelHelpers.export(exports, "CakeSharp", ()=>(0, _cakeSharpDefault.default));
parcelHelpers.export(exports, "CakeTwoTone", ()=>(0, _cakeTwoToneDefault.default));
parcelHelpers.export(exports, "Calculate", ()=>(0, _calculateDefault.default));
parcelHelpers.export(exports, "CalculateOutlined", ()=>(0, _calculateOutlinedDefault.default));
parcelHelpers.export(exports, "CalculateRounded", ()=>(0, _calculateRoundedDefault.default));
parcelHelpers.export(exports, "CalculateSharp", ()=>(0, _calculateSharpDefault.default));
parcelHelpers.export(exports, "CalculateTwoTone", ()=>(0, _calculateTwoToneDefault.default));
parcelHelpers.export(exports, "CalendarMonth", ()=>(0, _calendarMonthDefault.default));
parcelHelpers.export(exports, "CalendarMonthOutlined", ()=>(0, _calendarMonthOutlinedDefault.default));
parcelHelpers.export(exports, "CalendarMonthRounded", ()=>(0, _calendarMonthRoundedDefault.default));
parcelHelpers.export(exports, "CalendarMonthSharp", ()=>(0, _calendarMonthSharpDefault.default));
parcelHelpers.export(exports, "CalendarMonthTwoTone", ()=>(0, _calendarMonthTwoToneDefault.default));
parcelHelpers.export(exports, "CalendarToday", ()=>(0, _calendarTodayDefault.default));
parcelHelpers.export(exports, "CalendarTodayOutlined", ()=>(0, _calendarTodayOutlinedDefault.default));
parcelHelpers.export(exports, "CalendarTodayRounded", ()=>(0, _calendarTodayRoundedDefault.default));
parcelHelpers.export(exports, "CalendarTodaySharp", ()=>(0, _calendarTodaySharpDefault.default));
parcelHelpers.export(exports, "CalendarTodayTwoTone", ()=>(0, _calendarTodayTwoToneDefault.default));
parcelHelpers.export(exports, "CalendarViewDay", ()=>(0, _calendarViewDayDefault.default));
parcelHelpers.export(exports, "CalendarViewDayOutlined", ()=>(0, _calendarViewDayOutlinedDefault.default));
parcelHelpers.export(exports, "CalendarViewDayRounded", ()=>(0, _calendarViewDayRoundedDefault.default));
parcelHelpers.export(exports, "CalendarViewDaySharp", ()=>(0, _calendarViewDaySharpDefault.default));
parcelHelpers.export(exports, "CalendarViewDayTwoTone", ()=>(0, _calendarViewDayTwoToneDefault.default));
parcelHelpers.export(exports, "CalendarViewMonth", ()=>(0, _calendarViewMonthDefault.default));
parcelHelpers.export(exports, "CalendarViewMonthOutlined", ()=>(0, _calendarViewMonthOutlinedDefault.default));
parcelHelpers.export(exports, "CalendarViewMonthRounded", ()=>(0, _calendarViewMonthRoundedDefault.default));
parcelHelpers.export(exports, "CalendarViewMonthSharp", ()=>(0, _calendarViewMonthSharpDefault.default));
parcelHelpers.export(exports, "CalendarViewMonthTwoTone", ()=>(0, _calendarViewMonthTwoToneDefault.default));
parcelHelpers.export(exports, "CalendarViewWeek", ()=>(0, _calendarViewWeekDefault.default));
parcelHelpers.export(exports, "CalendarViewWeekOutlined", ()=>(0, _calendarViewWeekOutlinedDefault.default));
parcelHelpers.export(exports, "CalendarViewWeekRounded", ()=>(0, _calendarViewWeekRoundedDefault.default));
parcelHelpers.export(exports, "CalendarViewWeekSharp", ()=>(0, _calendarViewWeekSharpDefault.default));
parcelHelpers.export(exports, "CalendarViewWeekTwoTone", ()=>(0, _calendarViewWeekTwoToneDefault.default));
parcelHelpers.export(exports, "Call", ()=>(0, _callDefault.default));
parcelHelpers.export(exports, "CallEnd", ()=>(0, _callEndDefault.default));
parcelHelpers.export(exports, "CallEndOutlined", ()=>(0, _callEndOutlinedDefault.default));
parcelHelpers.export(exports, "CallEndRounded", ()=>(0, _callEndRoundedDefault.default));
parcelHelpers.export(exports, "CallEndSharp", ()=>(0, _callEndSharpDefault.default));
parcelHelpers.export(exports, "CallEndTwoTone", ()=>(0, _callEndTwoToneDefault.default));
parcelHelpers.export(exports, "CallMade", ()=>(0, _callMadeDefault.default));
parcelHelpers.export(exports, "CallMadeOutlined", ()=>(0, _callMadeOutlinedDefault.default));
parcelHelpers.export(exports, "CallMadeRounded", ()=>(0, _callMadeRoundedDefault.default));
parcelHelpers.export(exports, "CallMadeSharp", ()=>(0, _callMadeSharpDefault.default));
parcelHelpers.export(exports, "CallMadeTwoTone", ()=>(0, _callMadeTwoToneDefault.default));
parcelHelpers.export(exports, "CallMerge", ()=>(0, _callMergeDefault.default));
parcelHelpers.export(exports, "CallMergeOutlined", ()=>(0, _callMergeOutlinedDefault.default));
parcelHelpers.export(exports, "CallMergeRounded", ()=>(0, _callMergeRoundedDefault.default));
parcelHelpers.export(exports, "CallMergeSharp", ()=>(0, _callMergeSharpDefault.default));
parcelHelpers.export(exports, "CallMergeTwoTone", ()=>(0, _callMergeTwoToneDefault.default));
parcelHelpers.export(exports, "CallMissed", ()=>(0, _callMissedDefault.default));
parcelHelpers.export(exports, "CallMissedOutgoing", ()=>(0, _callMissedOutgoingDefault.default));
parcelHelpers.export(exports, "CallMissedOutgoingOutlined", ()=>(0, _callMissedOutgoingOutlinedDefault.default));
parcelHelpers.export(exports, "CallMissedOutgoingRounded", ()=>(0, _callMissedOutgoingRoundedDefault.default));
parcelHelpers.export(exports, "CallMissedOutgoingSharp", ()=>(0, _callMissedOutgoingSharpDefault.default));
parcelHelpers.export(exports, "CallMissedOutgoingTwoTone", ()=>(0, _callMissedOutgoingTwoToneDefault.default));
parcelHelpers.export(exports, "CallMissedOutlined", ()=>(0, _callMissedOutlinedDefault.default));
parcelHelpers.export(exports, "CallMissedRounded", ()=>(0, _callMissedRoundedDefault.default));
parcelHelpers.export(exports, "CallMissedSharp", ()=>(0, _callMissedSharpDefault.default));
parcelHelpers.export(exports, "CallMissedTwoTone", ()=>(0, _callMissedTwoToneDefault.default));
parcelHelpers.export(exports, "CallOutlined", ()=>(0, _callOutlinedDefault.default));
parcelHelpers.export(exports, "CallReceived", ()=>(0, _callReceivedDefault.default));
parcelHelpers.export(exports, "CallReceivedOutlined", ()=>(0, _callReceivedOutlinedDefault.default));
parcelHelpers.export(exports, "CallReceivedRounded", ()=>(0, _callReceivedRoundedDefault.default));
parcelHelpers.export(exports, "CallReceivedSharp", ()=>(0, _callReceivedSharpDefault.default));
parcelHelpers.export(exports, "CallReceivedTwoTone", ()=>(0, _callReceivedTwoToneDefault.default));
parcelHelpers.export(exports, "CallRounded", ()=>(0, _callRoundedDefault.default));
parcelHelpers.export(exports, "CallSharp", ()=>(0, _callSharpDefault.default));
parcelHelpers.export(exports, "CallSplit", ()=>(0, _callSplitDefault.default));
parcelHelpers.export(exports, "CallSplitOutlined", ()=>(0, _callSplitOutlinedDefault.default));
parcelHelpers.export(exports, "CallSplitRounded", ()=>(0, _callSplitRoundedDefault.default));
parcelHelpers.export(exports, "CallSplitSharp", ()=>(0, _callSplitSharpDefault.default));
parcelHelpers.export(exports, "CallSplitTwoTone", ()=>(0, _callSplitTwoToneDefault.default));
parcelHelpers.export(exports, "CallToAction", ()=>(0, _callToActionDefault.default));
parcelHelpers.export(exports, "CallToActionOutlined", ()=>(0, _callToActionOutlinedDefault.default));
parcelHelpers.export(exports, "CallToActionRounded", ()=>(0, _callToActionRoundedDefault.default));
parcelHelpers.export(exports, "CallToActionSharp", ()=>(0, _callToActionSharpDefault.default));
parcelHelpers.export(exports, "CallToActionTwoTone", ()=>(0, _callToActionTwoToneDefault.default));
parcelHelpers.export(exports, "CallTwoTone", ()=>(0, _callTwoToneDefault.default));
parcelHelpers.export(exports, "Camera", ()=>(0, _cameraDefault.default));
parcelHelpers.export(exports, "CameraAlt", ()=>(0, _cameraAltDefault.default));
parcelHelpers.export(exports, "CameraAltOutlined", ()=>(0, _cameraAltOutlinedDefault.default));
parcelHelpers.export(exports, "CameraAltRounded", ()=>(0, _cameraAltRoundedDefault.default));
parcelHelpers.export(exports, "CameraAltSharp", ()=>(0, _cameraAltSharpDefault.default));
parcelHelpers.export(exports, "CameraAltTwoTone", ()=>(0, _cameraAltTwoToneDefault.default));
parcelHelpers.export(exports, "CameraEnhance", ()=>(0, _cameraEnhanceDefault.default));
parcelHelpers.export(exports, "CameraEnhanceOutlined", ()=>(0, _cameraEnhanceOutlinedDefault.default));
parcelHelpers.export(exports, "CameraEnhanceRounded", ()=>(0, _cameraEnhanceRoundedDefault.default));
parcelHelpers.export(exports, "CameraEnhanceSharp", ()=>(0, _cameraEnhanceSharpDefault.default));
parcelHelpers.export(exports, "CameraEnhanceTwoTone", ()=>(0, _cameraEnhanceTwoToneDefault.default));
parcelHelpers.export(exports, "CameraFront", ()=>(0, _cameraFrontDefault.default));
parcelHelpers.export(exports, "CameraFrontOutlined", ()=>(0, _cameraFrontOutlinedDefault.default));
parcelHelpers.export(exports, "CameraFrontRounded", ()=>(0, _cameraFrontRoundedDefault.default));
parcelHelpers.export(exports, "CameraFrontSharp", ()=>(0, _cameraFrontSharpDefault.default));
parcelHelpers.export(exports, "CameraFrontTwoTone", ()=>(0, _cameraFrontTwoToneDefault.default));
parcelHelpers.export(exports, "CameraIndoor", ()=>(0, _cameraIndoorDefault.default));
parcelHelpers.export(exports, "CameraIndoorOutlined", ()=>(0, _cameraIndoorOutlinedDefault.default));
parcelHelpers.export(exports, "CameraIndoorRounded", ()=>(0, _cameraIndoorRoundedDefault.default));
parcelHelpers.export(exports, "CameraIndoorSharp", ()=>(0, _cameraIndoorSharpDefault.default));
parcelHelpers.export(exports, "CameraIndoorTwoTone", ()=>(0, _cameraIndoorTwoToneDefault.default));
parcelHelpers.export(exports, "CameraOutdoor", ()=>(0, _cameraOutdoorDefault.default));
parcelHelpers.export(exports, "CameraOutdoorOutlined", ()=>(0, _cameraOutdoorOutlinedDefault.default));
parcelHelpers.export(exports, "CameraOutdoorRounded", ()=>(0, _cameraOutdoorRoundedDefault.default));
parcelHelpers.export(exports, "CameraOutdoorSharp", ()=>(0, _cameraOutdoorSharpDefault.default));
parcelHelpers.export(exports, "CameraOutdoorTwoTone", ()=>(0, _cameraOutdoorTwoToneDefault.default));
parcelHelpers.export(exports, "CameraOutlined", ()=>(0, _cameraOutlinedDefault.default));
parcelHelpers.export(exports, "CameraRear", ()=>(0, _cameraRearDefault.default));
parcelHelpers.export(exports, "CameraRearOutlined", ()=>(0, _cameraRearOutlinedDefault.default));
parcelHelpers.export(exports, "CameraRearRounded", ()=>(0, _cameraRearRoundedDefault.default));
parcelHelpers.export(exports, "CameraRearSharp", ()=>(0, _cameraRearSharpDefault.default));
parcelHelpers.export(exports, "CameraRearTwoTone", ()=>(0, _cameraRearTwoToneDefault.default));
parcelHelpers.export(exports, "CameraRoll", ()=>(0, _cameraRollDefault.default));
parcelHelpers.export(exports, "CameraRollOutlined", ()=>(0, _cameraRollOutlinedDefault.default));
parcelHelpers.export(exports, "CameraRollRounded", ()=>(0, _cameraRollRoundedDefault.default));
parcelHelpers.export(exports, "CameraRollSharp", ()=>(0, _cameraRollSharpDefault.default));
parcelHelpers.export(exports, "CameraRollTwoTone", ()=>(0, _cameraRollTwoToneDefault.default));
parcelHelpers.export(exports, "CameraRounded", ()=>(0, _cameraRoundedDefault.default));
parcelHelpers.export(exports, "CameraSharp", ()=>(0, _cameraSharpDefault.default));
parcelHelpers.export(exports, "CameraTwoTone", ()=>(0, _cameraTwoToneDefault.default));
parcelHelpers.export(exports, "Cameraswitch", ()=>(0, _cameraswitchDefault.default));
parcelHelpers.export(exports, "CameraswitchOutlined", ()=>(0, _cameraswitchOutlinedDefault.default));
parcelHelpers.export(exports, "CameraswitchRounded", ()=>(0, _cameraswitchRoundedDefault.default));
parcelHelpers.export(exports, "CameraswitchSharp", ()=>(0, _cameraswitchSharpDefault.default));
parcelHelpers.export(exports, "CameraswitchTwoTone", ()=>(0, _cameraswitchTwoToneDefault.default));
parcelHelpers.export(exports, "Campaign", ()=>(0, _campaignDefault.default));
parcelHelpers.export(exports, "CampaignOutlined", ()=>(0, _campaignOutlinedDefault.default));
parcelHelpers.export(exports, "CampaignRounded", ()=>(0, _campaignRoundedDefault.default));
parcelHelpers.export(exports, "CampaignSharp", ()=>(0, _campaignSharpDefault.default));
parcelHelpers.export(exports, "CampaignTwoTone", ()=>(0, _campaignTwoToneDefault.default));
parcelHelpers.export(exports, "Cancel", ()=>(0, _cancelDefault.default));
parcelHelpers.export(exports, "CancelOutlined", ()=>(0, _cancelOutlinedDefault.default));
parcelHelpers.export(exports, "CancelPresentation", ()=>(0, _cancelPresentationDefault.default));
parcelHelpers.export(exports, "CancelPresentationOutlined", ()=>(0, _cancelPresentationOutlinedDefault.default));
parcelHelpers.export(exports, "CancelPresentationRounded", ()=>(0, _cancelPresentationRoundedDefault.default));
parcelHelpers.export(exports, "CancelPresentationSharp", ()=>(0, _cancelPresentationSharpDefault.default));
parcelHelpers.export(exports, "CancelPresentationTwoTone", ()=>(0, _cancelPresentationTwoToneDefault.default));
parcelHelpers.export(exports, "CancelRounded", ()=>(0, _cancelRoundedDefault.default));
parcelHelpers.export(exports, "CancelScheduleSend", ()=>(0, _cancelScheduleSendDefault.default));
parcelHelpers.export(exports, "CancelScheduleSendOutlined", ()=>(0, _cancelScheduleSendOutlinedDefault.default));
parcelHelpers.export(exports, "CancelScheduleSendRounded", ()=>(0, _cancelScheduleSendRoundedDefault.default));
parcelHelpers.export(exports, "CancelScheduleSendSharp", ()=>(0, _cancelScheduleSendSharpDefault.default));
parcelHelpers.export(exports, "CancelScheduleSendTwoTone", ()=>(0, _cancelScheduleSendTwoToneDefault.default));
parcelHelpers.export(exports, "CancelSharp", ()=>(0, _cancelSharpDefault.default));
parcelHelpers.export(exports, "CancelTwoTone", ()=>(0, _cancelTwoToneDefault.default));
parcelHelpers.export(exports, "CandlestickChart", ()=>(0, _candlestickChartDefault.default));
parcelHelpers.export(exports, "CandlestickChartOutlined", ()=>(0, _candlestickChartOutlinedDefault.default));
parcelHelpers.export(exports, "CandlestickChartRounded", ()=>(0, _candlestickChartRoundedDefault.default));
parcelHelpers.export(exports, "CandlestickChartSharp", ()=>(0, _candlestickChartSharpDefault.default));
parcelHelpers.export(exports, "CandlestickChartTwoTone", ()=>(0, _candlestickChartTwoToneDefault.default));
parcelHelpers.export(exports, "CarCrash", ()=>(0, _carCrashDefault.default));
parcelHelpers.export(exports, "CarCrashOutlined", ()=>(0, _carCrashOutlinedDefault.default));
parcelHelpers.export(exports, "CarCrashRounded", ()=>(0, _carCrashRoundedDefault.default));
parcelHelpers.export(exports, "CarCrashSharp", ()=>(0, _carCrashSharpDefault.default));
parcelHelpers.export(exports, "CarCrashTwoTone", ()=>(0, _carCrashTwoToneDefault.default));
parcelHelpers.export(exports, "CarRental", ()=>(0, _carRentalDefault.default));
parcelHelpers.export(exports, "CarRentalOutlined", ()=>(0, _carRentalOutlinedDefault.default));
parcelHelpers.export(exports, "CarRentalRounded", ()=>(0, _carRentalRoundedDefault.default));
parcelHelpers.export(exports, "CarRentalSharp", ()=>(0, _carRentalSharpDefault.default));
parcelHelpers.export(exports, "CarRentalTwoTone", ()=>(0, _carRentalTwoToneDefault.default));
parcelHelpers.export(exports, "CarRepair", ()=>(0, _carRepairDefault.default));
parcelHelpers.export(exports, "CarRepairOutlined", ()=>(0, _carRepairOutlinedDefault.default));
parcelHelpers.export(exports, "CarRepairRounded", ()=>(0, _carRepairRoundedDefault.default));
parcelHelpers.export(exports, "CarRepairSharp", ()=>(0, _carRepairSharpDefault.default));
parcelHelpers.export(exports, "CarRepairTwoTone", ()=>(0, _carRepairTwoToneDefault.default));
parcelHelpers.export(exports, "CardGiftcard", ()=>(0, _cardGiftcardDefault.default));
parcelHelpers.export(exports, "CardGiftcardOutlined", ()=>(0, _cardGiftcardOutlinedDefault.default));
parcelHelpers.export(exports, "CardGiftcardRounded", ()=>(0, _cardGiftcardRoundedDefault.default));
parcelHelpers.export(exports, "CardGiftcardSharp", ()=>(0, _cardGiftcardSharpDefault.default));
parcelHelpers.export(exports, "CardGiftcardTwoTone", ()=>(0, _cardGiftcardTwoToneDefault.default));
parcelHelpers.export(exports, "CardMembership", ()=>(0, _cardMembershipDefault.default));
parcelHelpers.export(exports, "CardMembershipOutlined", ()=>(0, _cardMembershipOutlinedDefault.default));
parcelHelpers.export(exports, "CardMembershipRounded", ()=>(0, _cardMembershipRoundedDefault.default));
parcelHelpers.export(exports, "CardMembershipSharp", ()=>(0, _cardMembershipSharpDefault.default));
parcelHelpers.export(exports, "CardMembershipTwoTone", ()=>(0, _cardMembershipTwoToneDefault.default));
parcelHelpers.export(exports, "CardTravel", ()=>(0, _cardTravelDefault.default));
parcelHelpers.export(exports, "CardTravelOutlined", ()=>(0, _cardTravelOutlinedDefault.default));
parcelHelpers.export(exports, "CardTravelRounded", ()=>(0, _cardTravelRoundedDefault.default));
parcelHelpers.export(exports, "CardTravelSharp", ()=>(0, _cardTravelSharpDefault.default));
parcelHelpers.export(exports, "CardTravelTwoTone", ()=>(0, _cardTravelTwoToneDefault.default));
parcelHelpers.export(exports, "Carpenter", ()=>(0, _carpenterDefault.default));
parcelHelpers.export(exports, "CarpenterOutlined", ()=>(0, _carpenterOutlinedDefault.default));
parcelHelpers.export(exports, "CarpenterRounded", ()=>(0, _carpenterRoundedDefault.default));
parcelHelpers.export(exports, "CarpenterSharp", ()=>(0, _carpenterSharpDefault.default));
parcelHelpers.export(exports, "CarpenterTwoTone", ()=>(0, _carpenterTwoToneDefault.default));
parcelHelpers.export(exports, "Cases", ()=>(0, _casesDefault.default));
parcelHelpers.export(exports, "CasesOutlined", ()=>(0, _casesOutlinedDefault.default));
parcelHelpers.export(exports, "CasesRounded", ()=>(0, _casesRoundedDefault.default));
parcelHelpers.export(exports, "CasesSharp", ()=>(0, _casesSharpDefault.default));
parcelHelpers.export(exports, "CasesTwoTone", ()=>(0, _casesTwoToneDefault.default));
parcelHelpers.export(exports, "Casino", ()=>(0, _casinoDefault.default));
parcelHelpers.export(exports, "CasinoOutlined", ()=>(0, _casinoOutlinedDefault.default));
parcelHelpers.export(exports, "CasinoRounded", ()=>(0, _casinoRoundedDefault.default));
parcelHelpers.export(exports, "CasinoSharp", ()=>(0, _casinoSharpDefault.default));
parcelHelpers.export(exports, "CasinoTwoTone", ()=>(0, _casinoTwoToneDefault.default));
parcelHelpers.export(exports, "Cast", ()=>(0, _castDefault.default));
parcelHelpers.export(exports, "CastConnected", ()=>(0, _castConnectedDefault.default));
parcelHelpers.export(exports, "CastConnectedOutlined", ()=>(0, _castConnectedOutlinedDefault.default));
parcelHelpers.export(exports, "CastConnectedRounded", ()=>(0, _castConnectedRoundedDefault.default));
parcelHelpers.export(exports, "CastConnectedSharp", ()=>(0, _castConnectedSharpDefault.default));
parcelHelpers.export(exports, "CastConnectedTwoTone", ()=>(0, _castConnectedTwoToneDefault.default));
parcelHelpers.export(exports, "CastForEducation", ()=>(0, _castForEducationDefault.default));
parcelHelpers.export(exports, "CastForEducationOutlined", ()=>(0, _castForEducationOutlinedDefault.default));
parcelHelpers.export(exports, "CastForEducationRounded", ()=>(0, _castForEducationRoundedDefault.default));
parcelHelpers.export(exports, "CastForEducationSharp", ()=>(0, _castForEducationSharpDefault.default));
parcelHelpers.export(exports, "CastForEducationTwoTone", ()=>(0, _castForEducationTwoToneDefault.default));
parcelHelpers.export(exports, "CastOutlined", ()=>(0, _castOutlinedDefault.default));
parcelHelpers.export(exports, "CastRounded", ()=>(0, _castRoundedDefault.default));
parcelHelpers.export(exports, "CastSharp", ()=>(0, _castSharpDefault.default));
parcelHelpers.export(exports, "CastTwoTone", ()=>(0, _castTwoToneDefault.default));
parcelHelpers.export(exports, "Castle", ()=>(0, _castleDefault.default));
parcelHelpers.export(exports, "CastleOutlined", ()=>(0, _castleOutlinedDefault.default));
parcelHelpers.export(exports, "CastleRounded", ()=>(0, _castleRoundedDefault.default));
parcelHelpers.export(exports, "CastleSharp", ()=>(0, _castleSharpDefault.default));
parcelHelpers.export(exports, "CastleTwoTone", ()=>(0, _castleTwoToneDefault.default));
parcelHelpers.export(exports, "CatchingPokemon", ()=>(0, _catchingPokemonDefault.default));
parcelHelpers.export(exports, "CatchingPokemonOutlined", ()=>(0, _catchingPokemonOutlinedDefault.default));
parcelHelpers.export(exports, "CatchingPokemonRounded", ()=>(0, _catchingPokemonRoundedDefault.default));
parcelHelpers.export(exports, "CatchingPokemonSharp", ()=>(0, _catchingPokemonSharpDefault.default));
parcelHelpers.export(exports, "CatchingPokemonTwoTone", ()=>(0, _catchingPokemonTwoToneDefault.default));
parcelHelpers.export(exports, "Category", ()=>(0, _categoryDefault.default));
parcelHelpers.export(exports, "CategoryOutlined", ()=>(0, _categoryOutlinedDefault.default));
parcelHelpers.export(exports, "CategoryRounded", ()=>(0, _categoryRoundedDefault.default));
parcelHelpers.export(exports, "CategorySharp", ()=>(0, _categorySharpDefault.default));
parcelHelpers.export(exports, "CategoryTwoTone", ()=>(0, _categoryTwoToneDefault.default));
parcelHelpers.export(exports, "Celebration", ()=>(0, _celebrationDefault.default));
parcelHelpers.export(exports, "CelebrationOutlined", ()=>(0, _celebrationOutlinedDefault.default));
parcelHelpers.export(exports, "CelebrationRounded", ()=>(0, _celebrationRoundedDefault.default));
parcelHelpers.export(exports, "CelebrationSharp", ()=>(0, _celebrationSharpDefault.default));
parcelHelpers.export(exports, "CelebrationTwoTone", ()=>(0, _celebrationTwoToneDefault.default));
parcelHelpers.export(exports, "CellTower", ()=>(0, _cellTowerDefault.default));
parcelHelpers.export(exports, "CellTowerOutlined", ()=>(0, _cellTowerOutlinedDefault.default));
parcelHelpers.export(exports, "CellTowerRounded", ()=>(0, _cellTowerRoundedDefault.default));
parcelHelpers.export(exports, "CellTowerSharp", ()=>(0, _cellTowerSharpDefault.default));
parcelHelpers.export(exports, "CellTowerTwoTone", ()=>(0, _cellTowerTwoToneDefault.default));
parcelHelpers.export(exports, "CellWifi", ()=>(0, _cellWifiDefault.default));
parcelHelpers.export(exports, "CellWifiOutlined", ()=>(0, _cellWifiOutlinedDefault.default));
parcelHelpers.export(exports, "CellWifiRounded", ()=>(0, _cellWifiRoundedDefault.default));
parcelHelpers.export(exports, "CellWifiSharp", ()=>(0, _cellWifiSharpDefault.default));
parcelHelpers.export(exports, "CellWifiTwoTone", ()=>(0, _cellWifiTwoToneDefault.default));
parcelHelpers.export(exports, "CenterFocusStrong", ()=>(0, _centerFocusStrongDefault.default));
parcelHelpers.export(exports, "CenterFocusStrongOutlined", ()=>(0, _centerFocusStrongOutlinedDefault.default));
parcelHelpers.export(exports, "CenterFocusStrongRounded", ()=>(0, _centerFocusStrongRoundedDefault.default));
parcelHelpers.export(exports, "CenterFocusStrongSharp", ()=>(0, _centerFocusStrongSharpDefault.default));
parcelHelpers.export(exports, "CenterFocusStrongTwoTone", ()=>(0, _centerFocusStrongTwoToneDefault.default));
parcelHelpers.export(exports, "CenterFocusWeak", ()=>(0, _centerFocusWeakDefault.default));
parcelHelpers.export(exports, "CenterFocusWeakOutlined", ()=>(0, _centerFocusWeakOutlinedDefault.default));
parcelHelpers.export(exports, "CenterFocusWeakRounded", ()=>(0, _centerFocusWeakRoundedDefault.default));
parcelHelpers.export(exports, "CenterFocusWeakSharp", ()=>(0, _centerFocusWeakSharpDefault.default));
parcelHelpers.export(exports, "CenterFocusWeakTwoTone", ()=>(0, _centerFocusWeakTwoToneDefault.default));
parcelHelpers.export(exports, "Chair", ()=>(0, _chairDefault.default));
parcelHelpers.export(exports, "ChairAlt", ()=>(0, _chairAltDefault.default));
parcelHelpers.export(exports, "ChairAltOutlined", ()=>(0, _chairAltOutlinedDefault.default));
parcelHelpers.export(exports, "ChairAltRounded", ()=>(0, _chairAltRoundedDefault.default));
parcelHelpers.export(exports, "ChairAltSharp", ()=>(0, _chairAltSharpDefault.default));
parcelHelpers.export(exports, "ChairAltTwoTone", ()=>(0, _chairAltTwoToneDefault.default));
parcelHelpers.export(exports, "ChairOutlined", ()=>(0, _chairOutlinedDefault.default));
parcelHelpers.export(exports, "ChairRounded", ()=>(0, _chairRoundedDefault.default));
parcelHelpers.export(exports, "ChairSharp", ()=>(0, _chairSharpDefault.default));
parcelHelpers.export(exports, "ChairTwoTone", ()=>(0, _chairTwoToneDefault.default));
parcelHelpers.export(exports, "Chalet", ()=>(0, _chaletDefault.default));
parcelHelpers.export(exports, "ChaletOutlined", ()=>(0, _chaletOutlinedDefault.default));
parcelHelpers.export(exports, "ChaletRounded", ()=>(0, _chaletRoundedDefault.default));
parcelHelpers.export(exports, "ChaletSharp", ()=>(0, _chaletSharpDefault.default));
parcelHelpers.export(exports, "ChaletTwoTone", ()=>(0, _chaletTwoToneDefault.default));
parcelHelpers.export(exports, "ChangeCircle", ()=>(0, _changeCircleDefault.default));
parcelHelpers.export(exports, "ChangeCircleOutlined", ()=>(0, _changeCircleOutlinedDefault.default));
parcelHelpers.export(exports, "ChangeCircleRounded", ()=>(0, _changeCircleRoundedDefault.default));
parcelHelpers.export(exports, "ChangeCircleSharp", ()=>(0, _changeCircleSharpDefault.default));
parcelHelpers.export(exports, "ChangeCircleTwoTone", ()=>(0, _changeCircleTwoToneDefault.default));
parcelHelpers.export(exports, "ChangeHistory", ()=>(0, _changeHistoryDefault.default));
parcelHelpers.export(exports, "ChangeHistoryOutlined", ()=>(0, _changeHistoryOutlinedDefault.default));
parcelHelpers.export(exports, "ChangeHistoryRounded", ()=>(0, _changeHistoryRoundedDefault.default));
parcelHelpers.export(exports, "ChangeHistorySharp", ()=>(0, _changeHistorySharpDefault.default));
parcelHelpers.export(exports, "ChangeHistoryTwoTone", ()=>(0, _changeHistoryTwoToneDefault.default));
parcelHelpers.export(exports, "ChargingStation", ()=>(0, _chargingStationDefault.default));
parcelHelpers.export(exports, "ChargingStationOutlined", ()=>(0, _chargingStationOutlinedDefault.default));
parcelHelpers.export(exports, "ChargingStationRounded", ()=>(0, _chargingStationRoundedDefault.default));
parcelHelpers.export(exports, "ChargingStationSharp", ()=>(0, _chargingStationSharpDefault.default));
parcelHelpers.export(exports, "ChargingStationTwoTone", ()=>(0, _chargingStationTwoToneDefault.default));
parcelHelpers.export(exports, "Chat", ()=>(0, _chatDefault.default));
parcelHelpers.export(exports, "ChatBubble", ()=>(0, _chatBubbleDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutline", ()=>(0, _chatBubbleOutlineDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutlineOutlined", ()=>(0, _chatBubbleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutlineRounded", ()=>(0, _chatBubbleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutlineSharp", ()=>(0, _chatBubbleOutlineSharpDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutlineTwoTone", ()=>(0, _chatBubbleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "ChatBubbleOutlined", ()=>(0, _chatBubbleOutlinedDefault.default));
parcelHelpers.export(exports, "ChatBubbleRounded", ()=>(0, _chatBubbleRoundedDefault.default));
parcelHelpers.export(exports, "ChatBubbleSharp", ()=>(0, _chatBubbleSharpDefault.default));
parcelHelpers.export(exports, "ChatBubbleTwoTone", ()=>(0, _chatBubbleTwoToneDefault.default));
parcelHelpers.export(exports, "ChatOutlined", ()=>(0, _chatOutlinedDefault.default));
parcelHelpers.export(exports, "ChatRounded", ()=>(0, _chatRoundedDefault.default));
parcelHelpers.export(exports, "ChatSharp", ()=>(0, _chatSharpDefault.default));
parcelHelpers.export(exports, "ChatTwoTone", ()=>(0, _chatTwoToneDefault.default));
parcelHelpers.export(exports, "Check", ()=>(0, _checkDefault.default));
parcelHelpers.export(exports, "CheckBox", ()=>(0, _checkBoxDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlineBlank", ()=>(0, _checkBoxOutlineBlankDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlineBlankOutlined", ()=>(0, _checkBoxOutlineBlankOutlinedDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlineBlankRounded", ()=>(0, _checkBoxOutlineBlankRoundedDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlineBlankSharp", ()=>(0, _checkBoxOutlineBlankSharpDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlineBlankTwoTone", ()=>(0, _checkBoxOutlineBlankTwoToneDefault.default));
parcelHelpers.export(exports, "CheckBoxOutlined", ()=>(0, _checkBoxOutlinedDefault.default));
parcelHelpers.export(exports, "CheckBoxRounded", ()=>(0, _checkBoxRoundedDefault.default));
parcelHelpers.export(exports, "CheckBoxSharp", ()=>(0, _checkBoxSharpDefault.default));
parcelHelpers.export(exports, "CheckBoxTwoTone", ()=>(0, _checkBoxTwoToneDefault.default));
parcelHelpers.export(exports, "CheckCircle", ()=>(0, _checkCircleDefault.default));
parcelHelpers.export(exports, "CheckCircleOutline", ()=>(0, _checkCircleOutlineDefault.default));
parcelHelpers.export(exports, "CheckCircleOutlineOutlined", ()=>(0, _checkCircleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "CheckCircleOutlineRounded", ()=>(0, _checkCircleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "CheckCircleOutlineSharp", ()=>(0, _checkCircleOutlineSharpDefault.default));
parcelHelpers.export(exports, "CheckCircleOutlineTwoTone", ()=>(0, _checkCircleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "CheckCircleOutlined", ()=>(0, _checkCircleOutlinedDefault.default));
parcelHelpers.export(exports, "CheckCircleRounded", ()=>(0, _checkCircleRoundedDefault.default));
parcelHelpers.export(exports, "CheckCircleSharp", ()=>(0, _checkCircleSharpDefault.default));
parcelHelpers.export(exports, "CheckCircleTwoTone", ()=>(0, _checkCircleTwoToneDefault.default));
parcelHelpers.export(exports, "CheckOutlined", ()=>(0, _checkOutlinedDefault.default));
parcelHelpers.export(exports, "CheckRounded", ()=>(0, _checkRoundedDefault.default));
parcelHelpers.export(exports, "CheckSharp", ()=>(0, _checkSharpDefault.default));
parcelHelpers.export(exports, "CheckTwoTone", ()=>(0, _checkTwoToneDefault.default));
parcelHelpers.export(exports, "Checklist", ()=>(0, _checklistDefault.default));
parcelHelpers.export(exports, "ChecklistOutlined", ()=>(0, _checklistOutlinedDefault.default));
parcelHelpers.export(exports, "ChecklistRounded", ()=>(0, _checklistRoundedDefault.default));
parcelHelpers.export(exports, "ChecklistRtl", ()=>(0, _checklistRtlDefault.default));
parcelHelpers.export(exports, "ChecklistRtlOutlined", ()=>(0, _checklistRtlOutlinedDefault.default));
parcelHelpers.export(exports, "ChecklistRtlRounded", ()=>(0, _checklistRtlRoundedDefault.default));
parcelHelpers.export(exports, "ChecklistRtlSharp", ()=>(0, _checklistRtlSharpDefault.default));
parcelHelpers.export(exports, "ChecklistRtlTwoTone", ()=>(0, _checklistRtlTwoToneDefault.default));
parcelHelpers.export(exports, "ChecklistSharp", ()=>(0, _checklistSharpDefault.default));
parcelHelpers.export(exports, "ChecklistTwoTone", ()=>(0, _checklistTwoToneDefault.default));
parcelHelpers.export(exports, "Checkroom", ()=>(0, _checkroomDefault.default));
parcelHelpers.export(exports, "CheckroomOutlined", ()=>(0, _checkroomOutlinedDefault.default));
parcelHelpers.export(exports, "CheckroomRounded", ()=>(0, _checkroomRoundedDefault.default));
parcelHelpers.export(exports, "CheckroomSharp", ()=>(0, _checkroomSharpDefault.default));
parcelHelpers.export(exports, "CheckroomTwoTone", ()=>(0, _checkroomTwoToneDefault.default));
parcelHelpers.export(exports, "ChevronLeft", ()=>(0, _chevronLeftDefault.default));
parcelHelpers.export(exports, "ChevronLeftOutlined", ()=>(0, _chevronLeftOutlinedDefault.default));
parcelHelpers.export(exports, "ChevronLeftRounded", ()=>(0, _chevronLeftRoundedDefault.default));
parcelHelpers.export(exports, "ChevronLeftSharp", ()=>(0, _chevronLeftSharpDefault.default));
parcelHelpers.export(exports, "ChevronLeftTwoTone", ()=>(0, _chevronLeftTwoToneDefault.default));
parcelHelpers.export(exports, "ChevronRight", ()=>(0, _chevronRightDefault.default));
parcelHelpers.export(exports, "ChevronRightOutlined", ()=>(0, _chevronRightOutlinedDefault.default));
parcelHelpers.export(exports, "ChevronRightRounded", ()=>(0, _chevronRightRoundedDefault.default));
parcelHelpers.export(exports, "ChevronRightSharp", ()=>(0, _chevronRightSharpDefault.default));
parcelHelpers.export(exports, "ChevronRightTwoTone", ()=>(0, _chevronRightTwoToneDefault.default));
parcelHelpers.export(exports, "ChildCare", ()=>(0, _childCareDefault.default));
parcelHelpers.export(exports, "ChildCareOutlined", ()=>(0, _childCareOutlinedDefault.default));
parcelHelpers.export(exports, "ChildCareRounded", ()=>(0, _childCareRoundedDefault.default));
parcelHelpers.export(exports, "ChildCareSharp", ()=>(0, _childCareSharpDefault.default));
parcelHelpers.export(exports, "ChildCareTwoTone", ()=>(0, _childCareTwoToneDefault.default));
parcelHelpers.export(exports, "ChildFriendly", ()=>(0, _childFriendlyDefault.default));
parcelHelpers.export(exports, "ChildFriendlyOutlined", ()=>(0, _childFriendlyOutlinedDefault.default));
parcelHelpers.export(exports, "ChildFriendlyRounded", ()=>(0, _childFriendlyRoundedDefault.default));
parcelHelpers.export(exports, "ChildFriendlySharp", ()=>(0, _childFriendlySharpDefault.default));
parcelHelpers.export(exports, "ChildFriendlyTwoTone", ()=>(0, _childFriendlyTwoToneDefault.default));
parcelHelpers.export(exports, "ChromeReaderMode", ()=>(0, _chromeReaderModeDefault.default));
parcelHelpers.export(exports, "ChromeReaderModeOutlined", ()=>(0, _chromeReaderModeOutlinedDefault.default));
parcelHelpers.export(exports, "ChromeReaderModeRounded", ()=>(0, _chromeReaderModeRoundedDefault.default));
parcelHelpers.export(exports, "ChromeReaderModeSharp", ()=>(0, _chromeReaderModeSharpDefault.default));
parcelHelpers.export(exports, "ChromeReaderModeTwoTone", ()=>(0, _chromeReaderModeTwoToneDefault.default));
parcelHelpers.export(exports, "Church", ()=>(0, _churchDefault.default));
parcelHelpers.export(exports, "ChurchOutlined", ()=>(0, _churchOutlinedDefault.default));
parcelHelpers.export(exports, "ChurchRounded", ()=>(0, _churchRoundedDefault.default));
parcelHelpers.export(exports, "ChurchSharp", ()=>(0, _churchSharpDefault.default));
parcelHelpers.export(exports, "ChurchTwoTone", ()=>(0, _churchTwoToneDefault.default));
parcelHelpers.export(exports, "Circle", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "CircleNotifications", ()=>(0, _circleNotificationsDefault.default));
parcelHelpers.export(exports, "CircleNotificationsOutlined", ()=>(0, _circleNotificationsOutlinedDefault.default));
parcelHelpers.export(exports, "CircleNotificationsRounded", ()=>(0, _circleNotificationsRoundedDefault.default));
parcelHelpers.export(exports, "CircleNotificationsSharp", ()=>(0, _circleNotificationsSharpDefault.default));
parcelHelpers.export(exports, "CircleNotificationsTwoTone", ()=>(0, _circleNotificationsTwoToneDefault.default));
parcelHelpers.export(exports, "CircleOutlined", ()=>(0, _circleOutlinedDefault.default));
parcelHelpers.export(exports, "CircleRounded", ()=>(0, _circleRoundedDefault.default));
parcelHelpers.export(exports, "CircleSharp", ()=>(0, _circleSharpDefault.default));
parcelHelpers.export(exports, "CircleTwoTone", ()=>(0, _circleTwoToneDefault.default));
parcelHelpers.export(exports, "Class", ()=>(0, _classDefault.default));
parcelHelpers.export(exports, "ClassOutlined", ()=>(0, _classOutlinedDefault.default));
parcelHelpers.export(exports, "ClassRounded", ()=>(0, _classRoundedDefault.default));
parcelHelpers.export(exports, "ClassSharp", ()=>(0, _classSharpDefault.default));
parcelHelpers.export(exports, "ClassTwoTone", ()=>(0, _classTwoToneDefault.default));
parcelHelpers.export(exports, "CleanHands", ()=>(0, _cleanHandsDefault.default));
parcelHelpers.export(exports, "CleanHandsOutlined", ()=>(0, _cleanHandsOutlinedDefault.default));
parcelHelpers.export(exports, "CleanHandsRounded", ()=>(0, _cleanHandsRoundedDefault.default));
parcelHelpers.export(exports, "CleanHandsSharp", ()=>(0, _cleanHandsSharpDefault.default));
parcelHelpers.export(exports, "CleanHandsTwoTone", ()=>(0, _cleanHandsTwoToneDefault.default));
parcelHelpers.export(exports, "CleaningServices", ()=>(0, _cleaningServicesDefault.default));
parcelHelpers.export(exports, "CleaningServicesOutlined", ()=>(0, _cleaningServicesOutlinedDefault.default));
parcelHelpers.export(exports, "CleaningServicesRounded", ()=>(0, _cleaningServicesRoundedDefault.default));
parcelHelpers.export(exports, "CleaningServicesSharp", ()=>(0, _cleaningServicesSharpDefault.default));
parcelHelpers.export(exports, "CleaningServicesTwoTone", ()=>(0, _cleaningServicesTwoToneDefault.default));
parcelHelpers.export(exports, "Clear", ()=>(0, _clearDefault.default));
parcelHelpers.export(exports, "ClearAll", ()=>(0, _clearAllDefault.default));
parcelHelpers.export(exports, "ClearAllOutlined", ()=>(0, _clearAllOutlinedDefault.default));
parcelHelpers.export(exports, "ClearAllRounded", ()=>(0, _clearAllRoundedDefault.default));
parcelHelpers.export(exports, "ClearAllSharp", ()=>(0, _clearAllSharpDefault.default));
parcelHelpers.export(exports, "ClearAllTwoTone", ()=>(0, _clearAllTwoToneDefault.default));
parcelHelpers.export(exports, "ClearOutlined", ()=>(0, _clearOutlinedDefault.default));
parcelHelpers.export(exports, "ClearRounded", ()=>(0, _clearRoundedDefault.default));
parcelHelpers.export(exports, "ClearSharp", ()=>(0, _clearSharpDefault.default));
parcelHelpers.export(exports, "ClearTwoTone", ()=>(0, _clearTwoToneDefault.default));
parcelHelpers.export(exports, "Close", ()=>(0, _closeDefault.default));
parcelHelpers.export(exports, "CloseFullscreen", ()=>(0, _closeFullscreenDefault.default));
parcelHelpers.export(exports, "CloseFullscreenOutlined", ()=>(0, _closeFullscreenOutlinedDefault.default));
parcelHelpers.export(exports, "CloseFullscreenRounded", ()=>(0, _closeFullscreenRoundedDefault.default));
parcelHelpers.export(exports, "CloseFullscreenSharp", ()=>(0, _closeFullscreenSharpDefault.default));
parcelHelpers.export(exports, "CloseFullscreenTwoTone", ()=>(0, _closeFullscreenTwoToneDefault.default));
parcelHelpers.export(exports, "CloseOutlined", ()=>(0, _closeOutlinedDefault.default));
parcelHelpers.export(exports, "CloseRounded", ()=>(0, _closeRoundedDefault.default));
parcelHelpers.export(exports, "CloseSharp", ()=>(0, _closeSharpDefault.default));
parcelHelpers.export(exports, "CloseTwoTone", ()=>(0, _closeTwoToneDefault.default));
parcelHelpers.export(exports, "ClosedCaption", ()=>(0, _closedCaptionDefault.default));
parcelHelpers.export(exports, "ClosedCaptionDisabled", ()=>(0, _closedCaptionDisabledDefault.default));
parcelHelpers.export(exports, "ClosedCaptionDisabledOutlined", ()=>(0, _closedCaptionDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionDisabledRounded", ()=>(0, _closedCaptionDisabledRoundedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionDisabledSharp", ()=>(0, _closedCaptionDisabledSharpDefault.default));
parcelHelpers.export(exports, "ClosedCaptionDisabledTwoTone", ()=>(0, _closedCaptionDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOff", ()=>(0, _closedCaptionOffDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOffOutlined", ()=>(0, _closedCaptionOffOutlinedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOffRounded", ()=>(0, _closedCaptionOffRoundedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOffSharp", ()=>(0, _closedCaptionOffSharpDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOffTwoTone", ()=>(0, _closedCaptionOffTwoToneDefault.default));
parcelHelpers.export(exports, "ClosedCaptionOutlined", ()=>(0, _closedCaptionOutlinedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionRounded", ()=>(0, _closedCaptionRoundedDefault.default));
parcelHelpers.export(exports, "ClosedCaptionSharp", ()=>(0, _closedCaptionSharpDefault.default));
parcelHelpers.export(exports, "ClosedCaptionTwoTone", ()=>(0, _closedCaptionTwoToneDefault.default));
parcelHelpers.export(exports, "Cloud", ()=>(0, _cloudDefault.default));
parcelHelpers.export(exports, "CloudCircle", ()=>(0, _cloudCircleDefault.default));
parcelHelpers.export(exports, "CloudCircleOutlined", ()=>(0, _cloudCircleOutlinedDefault.default));
parcelHelpers.export(exports, "CloudCircleRounded", ()=>(0, _cloudCircleRoundedDefault.default));
parcelHelpers.export(exports, "CloudCircleSharp", ()=>(0, _cloudCircleSharpDefault.default));
parcelHelpers.export(exports, "CloudCircleTwoTone", ()=>(0, _cloudCircleTwoToneDefault.default));
parcelHelpers.export(exports, "CloudDone", ()=>(0, _cloudDoneDefault.default));
parcelHelpers.export(exports, "CloudDoneOutlined", ()=>(0, _cloudDoneOutlinedDefault.default));
parcelHelpers.export(exports, "CloudDoneRounded", ()=>(0, _cloudDoneRoundedDefault.default));
parcelHelpers.export(exports, "CloudDoneSharp", ()=>(0, _cloudDoneSharpDefault.default));
parcelHelpers.export(exports, "CloudDoneTwoTone", ()=>(0, _cloudDoneTwoToneDefault.default));
parcelHelpers.export(exports, "CloudDownload", ()=>(0, _cloudDownloadDefault.default));
parcelHelpers.export(exports, "CloudDownloadOutlined", ()=>(0, _cloudDownloadOutlinedDefault.default));
parcelHelpers.export(exports, "CloudDownloadRounded", ()=>(0, _cloudDownloadRoundedDefault.default));
parcelHelpers.export(exports, "CloudDownloadSharp", ()=>(0, _cloudDownloadSharpDefault.default));
parcelHelpers.export(exports, "CloudDownloadTwoTone", ()=>(0, _cloudDownloadTwoToneDefault.default));
parcelHelpers.export(exports, "CloudOff", ()=>(0, _cloudOffDefault.default));
parcelHelpers.export(exports, "CloudOffOutlined", ()=>(0, _cloudOffOutlinedDefault.default));
parcelHelpers.export(exports, "CloudOffRounded", ()=>(0, _cloudOffRoundedDefault.default));
parcelHelpers.export(exports, "CloudOffSharp", ()=>(0, _cloudOffSharpDefault.default));
parcelHelpers.export(exports, "CloudOffTwoTone", ()=>(0, _cloudOffTwoToneDefault.default));
parcelHelpers.export(exports, "CloudOutlined", ()=>(0, _cloudOutlinedDefault.default));
parcelHelpers.export(exports, "CloudQueue", ()=>(0, _cloudQueueDefault.default));
parcelHelpers.export(exports, "CloudQueueOutlined", ()=>(0, _cloudQueueOutlinedDefault.default));
parcelHelpers.export(exports, "CloudQueueRounded", ()=>(0, _cloudQueueRoundedDefault.default));
parcelHelpers.export(exports, "CloudQueueSharp", ()=>(0, _cloudQueueSharpDefault.default));
parcelHelpers.export(exports, "CloudQueueTwoTone", ()=>(0, _cloudQueueTwoToneDefault.default));
parcelHelpers.export(exports, "CloudRounded", ()=>(0, _cloudRoundedDefault.default));
parcelHelpers.export(exports, "CloudSharp", ()=>(0, _cloudSharpDefault.default));
parcelHelpers.export(exports, "CloudSync", ()=>(0, _cloudSyncDefault.default));
parcelHelpers.export(exports, "CloudSyncOutlined", ()=>(0, _cloudSyncOutlinedDefault.default));
parcelHelpers.export(exports, "CloudSyncRounded", ()=>(0, _cloudSyncRoundedDefault.default));
parcelHelpers.export(exports, "CloudSyncSharp", ()=>(0, _cloudSyncSharpDefault.default));
parcelHelpers.export(exports, "CloudSyncTwoTone", ()=>(0, _cloudSyncTwoToneDefault.default));
parcelHelpers.export(exports, "CloudTwoTone", ()=>(0, _cloudTwoToneDefault.default));
parcelHelpers.export(exports, "CloudUpload", ()=>(0, _cloudUploadDefault.default));
parcelHelpers.export(exports, "CloudUploadOutlined", ()=>(0, _cloudUploadOutlinedDefault.default));
parcelHelpers.export(exports, "CloudUploadRounded", ()=>(0, _cloudUploadRoundedDefault.default));
parcelHelpers.export(exports, "CloudUploadSharp", ()=>(0, _cloudUploadSharpDefault.default));
parcelHelpers.export(exports, "CloudUploadTwoTone", ()=>(0, _cloudUploadTwoToneDefault.default));
parcelHelpers.export(exports, "Co2", ()=>(0, _co2Default.default));
parcelHelpers.export(exports, "Co2Outlined", ()=>(0, _co2OutlinedDefault.default));
parcelHelpers.export(exports, "Co2Rounded", ()=>(0, _co2RoundedDefault.default));
parcelHelpers.export(exports, "Co2Sharp", ()=>(0, _co2SharpDefault.default));
parcelHelpers.export(exports, "Co2TwoTone", ()=>(0, _co2TwoToneDefault.default));
parcelHelpers.export(exports, "CoPresent", ()=>(0, _coPresentDefault.default));
parcelHelpers.export(exports, "CoPresentOutlined", ()=>(0, _coPresentOutlinedDefault.default));
parcelHelpers.export(exports, "CoPresentRounded", ()=>(0, _coPresentRoundedDefault.default));
parcelHelpers.export(exports, "CoPresentSharp", ()=>(0, _coPresentSharpDefault.default));
parcelHelpers.export(exports, "CoPresentTwoTone", ()=>(0, _coPresentTwoToneDefault.default));
parcelHelpers.export(exports, "Code", ()=>(0, _codeDefault.default));
parcelHelpers.export(exports, "CodeOff", ()=>(0, _codeOffDefault.default));
parcelHelpers.export(exports, "CodeOffOutlined", ()=>(0, _codeOffOutlinedDefault.default));
parcelHelpers.export(exports, "CodeOffRounded", ()=>(0, _codeOffRoundedDefault.default));
parcelHelpers.export(exports, "CodeOffSharp", ()=>(0, _codeOffSharpDefault.default));
parcelHelpers.export(exports, "CodeOffTwoTone", ()=>(0, _codeOffTwoToneDefault.default));
parcelHelpers.export(exports, "CodeOutlined", ()=>(0, _codeOutlinedDefault.default));
parcelHelpers.export(exports, "CodeRounded", ()=>(0, _codeRoundedDefault.default));
parcelHelpers.export(exports, "CodeSharp", ()=>(0, _codeSharpDefault.default));
parcelHelpers.export(exports, "CodeTwoTone", ()=>(0, _codeTwoToneDefault.default));
parcelHelpers.export(exports, "Coffee", ()=>(0, _coffeeDefault.default));
parcelHelpers.export(exports, "CoffeeMaker", ()=>(0, _coffeeMakerDefault.default));
parcelHelpers.export(exports, "CoffeeMakerOutlined", ()=>(0, _coffeeMakerOutlinedDefault.default));
parcelHelpers.export(exports, "CoffeeMakerRounded", ()=>(0, _coffeeMakerRoundedDefault.default));
parcelHelpers.export(exports, "CoffeeMakerSharp", ()=>(0, _coffeeMakerSharpDefault.default));
parcelHelpers.export(exports, "CoffeeMakerTwoTone", ()=>(0, _coffeeMakerTwoToneDefault.default));
parcelHelpers.export(exports, "CoffeeOutlined", ()=>(0, _coffeeOutlinedDefault.default));
parcelHelpers.export(exports, "CoffeeRounded", ()=>(0, _coffeeRoundedDefault.default));
parcelHelpers.export(exports, "CoffeeSharp", ()=>(0, _coffeeSharpDefault.default));
parcelHelpers.export(exports, "CoffeeTwoTone", ()=>(0, _coffeeTwoToneDefault.default));
parcelHelpers.export(exports, "Collections", ()=>(0, _collectionsDefault.default));
parcelHelpers.export(exports, "CollectionsBookmark", ()=>(0, _collectionsBookmarkDefault.default));
parcelHelpers.export(exports, "CollectionsBookmarkOutlined", ()=>(0, _collectionsBookmarkOutlinedDefault.default));
parcelHelpers.export(exports, "CollectionsBookmarkRounded", ()=>(0, _collectionsBookmarkRoundedDefault.default));
parcelHelpers.export(exports, "CollectionsBookmarkSharp", ()=>(0, _collectionsBookmarkSharpDefault.default));
parcelHelpers.export(exports, "CollectionsBookmarkTwoTone", ()=>(0, _collectionsBookmarkTwoToneDefault.default));
parcelHelpers.export(exports, "CollectionsOutlined", ()=>(0, _collectionsOutlinedDefault.default));
parcelHelpers.export(exports, "CollectionsRounded", ()=>(0, _collectionsRoundedDefault.default));
parcelHelpers.export(exports, "CollectionsSharp", ()=>(0, _collectionsSharpDefault.default));
parcelHelpers.export(exports, "CollectionsTwoTone", ()=>(0, _collectionsTwoToneDefault.default));
parcelHelpers.export(exports, "ColorLens", ()=>(0, _colorLensDefault.default));
parcelHelpers.export(exports, "ColorLensOutlined", ()=>(0, _colorLensOutlinedDefault.default));
parcelHelpers.export(exports, "ColorLensRounded", ()=>(0, _colorLensRoundedDefault.default));
parcelHelpers.export(exports, "ColorLensSharp", ()=>(0, _colorLensSharpDefault.default));
parcelHelpers.export(exports, "ColorLensTwoTone", ()=>(0, _colorLensTwoToneDefault.default));
parcelHelpers.export(exports, "Colorize", ()=>(0, _colorizeDefault.default));
parcelHelpers.export(exports, "ColorizeOutlined", ()=>(0, _colorizeOutlinedDefault.default));
parcelHelpers.export(exports, "ColorizeRounded", ()=>(0, _colorizeRoundedDefault.default));
parcelHelpers.export(exports, "ColorizeSharp", ()=>(0, _colorizeSharpDefault.default));
parcelHelpers.export(exports, "ColorizeTwoTone", ()=>(0, _colorizeTwoToneDefault.default));
parcelHelpers.export(exports, "Comment", ()=>(0, _commentDefault.default));
parcelHelpers.export(exports, "CommentBank", ()=>(0, _commentBankDefault.default));
parcelHelpers.export(exports, "CommentBankOutlined", ()=>(0, _commentBankOutlinedDefault.default));
parcelHelpers.export(exports, "CommentBankRounded", ()=>(0, _commentBankRoundedDefault.default));
parcelHelpers.export(exports, "CommentBankSharp", ()=>(0, _commentBankSharpDefault.default));
parcelHelpers.export(exports, "CommentBankTwoTone", ()=>(0, _commentBankTwoToneDefault.default));
parcelHelpers.export(exports, "CommentOutlined", ()=>(0, _commentOutlinedDefault.default));
parcelHelpers.export(exports, "CommentRounded", ()=>(0, _commentRoundedDefault.default));
parcelHelpers.export(exports, "CommentSharp", ()=>(0, _commentSharpDefault.default));
parcelHelpers.export(exports, "CommentTwoTone", ()=>(0, _commentTwoToneDefault.default));
parcelHelpers.export(exports, "CommentsDisabled", ()=>(0, _commentsDisabledDefault.default));
parcelHelpers.export(exports, "CommentsDisabledOutlined", ()=>(0, _commentsDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "CommentsDisabledRounded", ()=>(0, _commentsDisabledRoundedDefault.default));
parcelHelpers.export(exports, "CommentsDisabledSharp", ()=>(0, _commentsDisabledSharpDefault.default));
parcelHelpers.export(exports, "CommentsDisabledTwoTone", ()=>(0, _commentsDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "Commit", ()=>(0, _commitDefault.default));
parcelHelpers.export(exports, "CommitOutlined", ()=>(0, _commitOutlinedDefault.default));
parcelHelpers.export(exports, "CommitRounded", ()=>(0, _commitRoundedDefault.default));
parcelHelpers.export(exports, "CommitSharp", ()=>(0, _commitSharpDefault.default));
parcelHelpers.export(exports, "CommitTwoTone", ()=>(0, _commitTwoToneDefault.default));
parcelHelpers.export(exports, "Commute", ()=>(0, _commuteDefault.default));
parcelHelpers.export(exports, "CommuteOutlined", ()=>(0, _commuteOutlinedDefault.default));
parcelHelpers.export(exports, "CommuteRounded", ()=>(0, _commuteRoundedDefault.default));
parcelHelpers.export(exports, "CommuteSharp", ()=>(0, _commuteSharpDefault.default));
parcelHelpers.export(exports, "CommuteTwoTone", ()=>(0, _commuteTwoToneDefault.default));
parcelHelpers.export(exports, "Compare", ()=>(0, _compareDefault.default));
parcelHelpers.export(exports, "CompareArrows", ()=>(0, _compareArrowsDefault.default));
parcelHelpers.export(exports, "CompareArrowsOutlined", ()=>(0, _compareArrowsOutlinedDefault.default));
parcelHelpers.export(exports, "CompareArrowsRounded", ()=>(0, _compareArrowsRoundedDefault.default));
parcelHelpers.export(exports, "CompareArrowsSharp", ()=>(0, _compareArrowsSharpDefault.default));
parcelHelpers.export(exports, "CompareArrowsTwoTone", ()=>(0, _compareArrowsTwoToneDefault.default));
parcelHelpers.export(exports, "CompareOutlined", ()=>(0, _compareOutlinedDefault.default));
parcelHelpers.export(exports, "CompareRounded", ()=>(0, _compareRoundedDefault.default));
parcelHelpers.export(exports, "CompareSharp", ()=>(0, _compareSharpDefault.default));
parcelHelpers.export(exports, "CompareTwoTone", ()=>(0, _compareTwoToneDefault.default));
parcelHelpers.export(exports, "CompassCalibration", ()=>(0, _compassCalibrationDefault.default));
parcelHelpers.export(exports, "CompassCalibrationOutlined", ()=>(0, _compassCalibrationOutlinedDefault.default));
parcelHelpers.export(exports, "CompassCalibrationRounded", ()=>(0, _compassCalibrationRoundedDefault.default));
parcelHelpers.export(exports, "CompassCalibrationSharp", ()=>(0, _compassCalibrationSharpDefault.default));
parcelHelpers.export(exports, "CompassCalibrationTwoTone", ()=>(0, _compassCalibrationTwoToneDefault.default));
parcelHelpers.export(exports, "Compress", ()=>(0, _compressDefault.default));
parcelHelpers.export(exports, "CompressOutlined", ()=>(0, _compressOutlinedDefault.default));
parcelHelpers.export(exports, "CompressRounded", ()=>(0, _compressRoundedDefault.default));
parcelHelpers.export(exports, "CompressSharp", ()=>(0, _compressSharpDefault.default));
parcelHelpers.export(exports, "CompressTwoTone", ()=>(0, _compressTwoToneDefault.default));
parcelHelpers.export(exports, "Computer", ()=>(0, _computerDefault.default));
parcelHelpers.export(exports, "ComputerOutlined", ()=>(0, _computerOutlinedDefault.default));
parcelHelpers.export(exports, "ComputerRounded", ()=>(0, _computerRoundedDefault.default));
parcelHelpers.export(exports, "ComputerSharp", ()=>(0, _computerSharpDefault.default));
parcelHelpers.export(exports, "ComputerTwoTone", ()=>(0, _computerTwoToneDefault.default));
parcelHelpers.export(exports, "ConfirmationNumber", ()=>(0, _confirmationNumberDefault.default));
parcelHelpers.export(exports, "ConfirmationNumberOutlined", ()=>(0, _confirmationNumberOutlinedDefault.default));
parcelHelpers.export(exports, "ConfirmationNumberRounded", ()=>(0, _confirmationNumberRoundedDefault.default));
parcelHelpers.export(exports, "ConfirmationNumberSharp", ()=>(0, _confirmationNumberSharpDefault.default));
parcelHelpers.export(exports, "ConfirmationNumberTwoTone", ()=>(0, _confirmationNumberTwoToneDefault.default));
parcelHelpers.export(exports, "ConnectWithoutContact", ()=>(0, _connectWithoutContactDefault.default));
parcelHelpers.export(exports, "ConnectWithoutContactOutlined", ()=>(0, _connectWithoutContactOutlinedDefault.default));
parcelHelpers.export(exports, "ConnectWithoutContactRounded", ()=>(0, _connectWithoutContactRoundedDefault.default));
parcelHelpers.export(exports, "ConnectWithoutContactSharp", ()=>(0, _connectWithoutContactSharpDefault.default));
parcelHelpers.export(exports, "ConnectWithoutContactTwoTone", ()=>(0, _connectWithoutContactTwoToneDefault.default));
parcelHelpers.export(exports, "ConnectedTv", ()=>(0, _connectedTvDefault.default));
parcelHelpers.export(exports, "ConnectedTvOutlined", ()=>(0, _connectedTvOutlinedDefault.default));
parcelHelpers.export(exports, "ConnectedTvRounded", ()=>(0, _connectedTvRoundedDefault.default));
parcelHelpers.export(exports, "ConnectedTvSharp", ()=>(0, _connectedTvSharpDefault.default));
parcelHelpers.export(exports, "ConnectedTvTwoTone", ()=>(0, _connectedTvTwoToneDefault.default));
parcelHelpers.export(exports, "ConnectingAirports", ()=>(0, _connectingAirportsDefault.default));
parcelHelpers.export(exports, "ConnectingAirportsOutlined", ()=>(0, _connectingAirportsOutlinedDefault.default));
parcelHelpers.export(exports, "ConnectingAirportsRounded", ()=>(0, _connectingAirportsRoundedDefault.default));
parcelHelpers.export(exports, "ConnectingAirportsSharp", ()=>(0, _connectingAirportsSharpDefault.default));
parcelHelpers.export(exports, "ConnectingAirportsTwoTone", ()=>(0, _connectingAirportsTwoToneDefault.default));
parcelHelpers.export(exports, "Construction", ()=>(0, _constructionDefault.default));
parcelHelpers.export(exports, "ConstructionOutlined", ()=>(0, _constructionOutlinedDefault.default));
parcelHelpers.export(exports, "ConstructionRounded", ()=>(0, _constructionRoundedDefault.default));
parcelHelpers.export(exports, "ConstructionSharp", ()=>(0, _constructionSharpDefault.default));
parcelHelpers.export(exports, "ConstructionTwoTone", ()=>(0, _constructionTwoToneDefault.default));
parcelHelpers.export(exports, "ContactEmergency", ()=>(0, _contactEmergencyDefault.default));
parcelHelpers.export(exports, "ContactEmergencyOutlined", ()=>(0, _contactEmergencyOutlinedDefault.default));
parcelHelpers.export(exports, "ContactEmergencyRounded", ()=>(0, _contactEmergencyRoundedDefault.default));
parcelHelpers.export(exports, "ContactEmergencySharp", ()=>(0, _contactEmergencySharpDefault.default));
parcelHelpers.export(exports, "ContactEmergencyTwoTone", ()=>(0, _contactEmergencyTwoToneDefault.default));
parcelHelpers.export(exports, "ContactMail", ()=>(0, _contactMailDefault.default));
parcelHelpers.export(exports, "ContactMailOutlined", ()=>(0, _contactMailOutlinedDefault.default));
parcelHelpers.export(exports, "ContactMailRounded", ()=>(0, _contactMailRoundedDefault.default));
parcelHelpers.export(exports, "ContactMailSharp", ()=>(0, _contactMailSharpDefault.default));
parcelHelpers.export(exports, "ContactMailTwoTone", ()=>(0, _contactMailTwoToneDefault.default));
parcelHelpers.export(exports, "ContactPage", ()=>(0, _contactPageDefault.default));
parcelHelpers.export(exports, "ContactPageOutlined", ()=>(0, _contactPageOutlinedDefault.default));
parcelHelpers.export(exports, "ContactPageRounded", ()=>(0, _contactPageRoundedDefault.default));
parcelHelpers.export(exports, "ContactPageSharp", ()=>(0, _contactPageSharpDefault.default));
parcelHelpers.export(exports, "ContactPageTwoTone", ()=>(0, _contactPageTwoToneDefault.default));
parcelHelpers.export(exports, "ContactPhone", ()=>(0, _contactPhoneDefault.default));
parcelHelpers.export(exports, "ContactPhoneOutlined", ()=>(0, _contactPhoneOutlinedDefault.default));
parcelHelpers.export(exports, "ContactPhoneRounded", ()=>(0, _contactPhoneRoundedDefault.default));
parcelHelpers.export(exports, "ContactPhoneSharp", ()=>(0, _contactPhoneSharpDefault.default));
parcelHelpers.export(exports, "ContactPhoneTwoTone", ()=>(0, _contactPhoneTwoToneDefault.default));
parcelHelpers.export(exports, "ContactSupport", ()=>(0, _contactSupportDefault.default));
parcelHelpers.export(exports, "ContactSupportOutlined", ()=>(0, _contactSupportOutlinedDefault.default));
parcelHelpers.export(exports, "ContactSupportRounded", ()=>(0, _contactSupportRoundedDefault.default));
parcelHelpers.export(exports, "ContactSupportSharp", ()=>(0, _contactSupportSharpDefault.default));
parcelHelpers.export(exports, "ContactSupportTwoTone", ()=>(0, _contactSupportTwoToneDefault.default));
parcelHelpers.export(exports, "Contactless", ()=>(0, _contactlessDefault.default));
parcelHelpers.export(exports, "ContactlessOutlined", ()=>(0, _contactlessOutlinedDefault.default));
parcelHelpers.export(exports, "ContactlessRounded", ()=>(0, _contactlessRoundedDefault.default));
parcelHelpers.export(exports, "ContactlessSharp", ()=>(0, _contactlessSharpDefault.default));
parcelHelpers.export(exports, "ContactlessTwoTone", ()=>(0, _contactlessTwoToneDefault.default));
parcelHelpers.export(exports, "Contacts", ()=>(0, _contactsDefault.default));
parcelHelpers.export(exports, "ContactsOutlined", ()=>(0, _contactsOutlinedDefault.default));
parcelHelpers.export(exports, "ContactsRounded", ()=>(0, _contactsRoundedDefault.default));
parcelHelpers.export(exports, "ContactsSharp", ()=>(0, _contactsSharpDefault.default));
parcelHelpers.export(exports, "ContactsTwoTone", ()=>(0, _contactsTwoToneDefault.default));
parcelHelpers.export(exports, "ContentCopy", ()=>(0, _contentCopyDefault.default));
parcelHelpers.export(exports, "ContentCopyOutlined", ()=>(0, _contentCopyOutlinedDefault.default));
parcelHelpers.export(exports, "ContentCopyRounded", ()=>(0, _contentCopyRoundedDefault.default));
parcelHelpers.export(exports, "ContentCopySharp", ()=>(0, _contentCopySharpDefault.default));
parcelHelpers.export(exports, "ContentCopyTwoTone", ()=>(0, _contentCopyTwoToneDefault.default));
parcelHelpers.export(exports, "ContentCut", ()=>(0, _contentCutDefault.default));
parcelHelpers.export(exports, "ContentCutOutlined", ()=>(0, _contentCutOutlinedDefault.default));
parcelHelpers.export(exports, "ContentCutRounded", ()=>(0, _contentCutRoundedDefault.default));
parcelHelpers.export(exports, "ContentCutSharp", ()=>(0, _contentCutSharpDefault.default));
parcelHelpers.export(exports, "ContentCutTwoTone", ()=>(0, _contentCutTwoToneDefault.default));
parcelHelpers.export(exports, "ContentPaste", ()=>(0, _contentPasteDefault.default));
parcelHelpers.export(exports, "ContentPasteGo", ()=>(0, _contentPasteGoDefault.default));
parcelHelpers.export(exports, "ContentPasteGoOutlined", ()=>(0, _contentPasteGoOutlinedDefault.default));
parcelHelpers.export(exports, "ContentPasteGoRounded", ()=>(0, _contentPasteGoRoundedDefault.default));
parcelHelpers.export(exports, "ContentPasteGoSharp", ()=>(0, _contentPasteGoSharpDefault.default));
parcelHelpers.export(exports, "ContentPasteGoTwoTone", ()=>(0, _contentPasteGoTwoToneDefault.default));
parcelHelpers.export(exports, "ContentPasteOff", ()=>(0, _contentPasteOffDefault.default));
parcelHelpers.export(exports, "ContentPasteOffOutlined", ()=>(0, _contentPasteOffOutlinedDefault.default));
parcelHelpers.export(exports, "ContentPasteOffRounded", ()=>(0, _contentPasteOffRoundedDefault.default));
parcelHelpers.export(exports, "ContentPasteOffSharp", ()=>(0, _contentPasteOffSharpDefault.default));
parcelHelpers.export(exports, "ContentPasteOffTwoTone", ()=>(0, _contentPasteOffTwoToneDefault.default));
parcelHelpers.export(exports, "ContentPasteOutlined", ()=>(0, _contentPasteOutlinedDefault.default));
parcelHelpers.export(exports, "ContentPasteRounded", ()=>(0, _contentPasteRoundedDefault.default));
parcelHelpers.export(exports, "ContentPasteSearch", ()=>(0, _contentPasteSearchDefault.default));
parcelHelpers.export(exports, "ContentPasteSearchOutlined", ()=>(0, _contentPasteSearchOutlinedDefault.default));
parcelHelpers.export(exports, "ContentPasteSearchRounded", ()=>(0, _contentPasteSearchRoundedDefault.default));
parcelHelpers.export(exports, "ContentPasteSearchSharp", ()=>(0, _contentPasteSearchSharpDefault.default));
parcelHelpers.export(exports, "ContentPasteSearchTwoTone", ()=>(0, _contentPasteSearchTwoToneDefault.default));
parcelHelpers.export(exports, "ContentPasteSharp", ()=>(0, _contentPasteSharpDefault.default));
parcelHelpers.export(exports, "ContentPasteTwoTone", ()=>(0, _contentPasteTwoToneDefault.default));
parcelHelpers.export(exports, "Contrast", ()=>(0, _contrastDefault.default));
parcelHelpers.export(exports, "ContrastOutlined", ()=>(0, _contrastOutlinedDefault.default));
parcelHelpers.export(exports, "ContrastRounded", ()=>(0, _contrastRoundedDefault.default));
parcelHelpers.export(exports, "ContrastSharp", ()=>(0, _contrastSharpDefault.default));
parcelHelpers.export(exports, "ContrastTwoTone", ()=>(0, _contrastTwoToneDefault.default));
parcelHelpers.export(exports, "ControlCamera", ()=>(0, _controlCameraDefault.default));
parcelHelpers.export(exports, "ControlCameraOutlined", ()=>(0, _controlCameraOutlinedDefault.default));
parcelHelpers.export(exports, "ControlCameraRounded", ()=>(0, _controlCameraRoundedDefault.default));
parcelHelpers.export(exports, "ControlCameraSharp", ()=>(0, _controlCameraSharpDefault.default));
parcelHelpers.export(exports, "ControlCameraTwoTone", ()=>(0, _controlCameraTwoToneDefault.default));
parcelHelpers.export(exports, "ControlPoint", ()=>(0, _controlPointDefault.default));
parcelHelpers.export(exports, "ControlPointDuplicate", ()=>(0, _controlPointDuplicateDefault.default));
parcelHelpers.export(exports, "ControlPointDuplicateOutlined", ()=>(0, _controlPointDuplicateOutlinedDefault.default));
parcelHelpers.export(exports, "ControlPointDuplicateRounded", ()=>(0, _controlPointDuplicateRoundedDefault.default));
parcelHelpers.export(exports, "ControlPointDuplicateSharp", ()=>(0, _controlPointDuplicateSharpDefault.default));
parcelHelpers.export(exports, "ControlPointDuplicateTwoTone", ()=>(0, _controlPointDuplicateTwoToneDefault.default));
parcelHelpers.export(exports, "ControlPointOutlined", ()=>(0, _controlPointOutlinedDefault.default));
parcelHelpers.export(exports, "ControlPointRounded", ()=>(0, _controlPointRoundedDefault.default));
parcelHelpers.export(exports, "ControlPointSharp", ()=>(0, _controlPointSharpDefault.default));
parcelHelpers.export(exports, "ControlPointTwoTone", ()=>(0, _controlPointTwoToneDefault.default));
parcelHelpers.export(exports, "Cookie", ()=>(0, _cookieDefault.default));
parcelHelpers.export(exports, "CookieOutlined", ()=>(0, _cookieOutlinedDefault.default));
parcelHelpers.export(exports, "CookieRounded", ()=>(0, _cookieRoundedDefault.default));
parcelHelpers.export(exports, "CookieSharp", ()=>(0, _cookieSharpDefault.default));
parcelHelpers.export(exports, "CookieTwoTone", ()=>(0, _cookieTwoToneDefault.default));
parcelHelpers.export(exports, "CopyAll", ()=>(0, _copyAllDefault.default));
parcelHelpers.export(exports, "CopyAllOutlined", ()=>(0, _copyAllOutlinedDefault.default));
parcelHelpers.export(exports, "CopyAllRounded", ()=>(0, _copyAllRoundedDefault.default));
parcelHelpers.export(exports, "CopyAllSharp", ()=>(0, _copyAllSharpDefault.default));
parcelHelpers.export(exports, "CopyAllTwoTone", ()=>(0, _copyAllTwoToneDefault.default));
parcelHelpers.export(exports, "Copyright", ()=>(0, _copyrightDefault.default));
parcelHelpers.export(exports, "CopyrightOutlined", ()=>(0, _copyrightOutlinedDefault.default));
parcelHelpers.export(exports, "CopyrightRounded", ()=>(0, _copyrightRoundedDefault.default));
parcelHelpers.export(exports, "CopyrightSharp", ()=>(0, _copyrightSharpDefault.default));
parcelHelpers.export(exports, "CopyrightTwoTone", ()=>(0, _copyrightTwoToneDefault.default));
parcelHelpers.export(exports, "Coronavirus", ()=>(0, _coronavirusDefault.default));
parcelHelpers.export(exports, "CoronavirusOutlined", ()=>(0, _coronavirusOutlinedDefault.default));
parcelHelpers.export(exports, "CoronavirusRounded", ()=>(0, _coronavirusRoundedDefault.default));
parcelHelpers.export(exports, "CoronavirusSharp", ()=>(0, _coronavirusSharpDefault.default));
parcelHelpers.export(exports, "CoronavirusTwoTone", ()=>(0, _coronavirusTwoToneDefault.default));
parcelHelpers.export(exports, "CorporateFare", ()=>(0, _corporateFareDefault.default));
parcelHelpers.export(exports, "CorporateFareOutlined", ()=>(0, _corporateFareOutlinedDefault.default));
parcelHelpers.export(exports, "CorporateFareRounded", ()=>(0, _corporateFareRoundedDefault.default));
parcelHelpers.export(exports, "CorporateFareSharp", ()=>(0, _corporateFareSharpDefault.default));
parcelHelpers.export(exports, "CorporateFareTwoTone", ()=>(0, _corporateFareTwoToneDefault.default));
parcelHelpers.export(exports, "Cottage", ()=>(0, _cottageDefault.default));
parcelHelpers.export(exports, "CottageOutlined", ()=>(0, _cottageOutlinedDefault.default));
parcelHelpers.export(exports, "CottageRounded", ()=>(0, _cottageRoundedDefault.default));
parcelHelpers.export(exports, "CottageSharp", ()=>(0, _cottageSharpDefault.default));
parcelHelpers.export(exports, "CottageTwoTone", ()=>(0, _cottageTwoToneDefault.default));
parcelHelpers.export(exports, "Countertops", ()=>(0, _countertopsDefault.default));
parcelHelpers.export(exports, "CountertopsOutlined", ()=>(0, _countertopsOutlinedDefault.default));
parcelHelpers.export(exports, "CountertopsRounded", ()=>(0, _countertopsRoundedDefault.default));
parcelHelpers.export(exports, "CountertopsSharp", ()=>(0, _countertopsSharpDefault.default));
parcelHelpers.export(exports, "CountertopsTwoTone", ()=>(0, _countertopsTwoToneDefault.default));
parcelHelpers.export(exports, "Create", ()=>(0, _createDefault.default));
parcelHelpers.export(exports, "CreateNewFolder", ()=>(0, _createNewFolderDefault.default));
parcelHelpers.export(exports, "CreateNewFolderOutlined", ()=>(0, _createNewFolderOutlinedDefault.default));
parcelHelpers.export(exports, "CreateNewFolderRounded", ()=>(0, _createNewFolderRoundedDefault.default));
parcelHelpers.export(exports, "CreateNewFolderSharp", ()=>(0, _createNewFolderSharpDefault.default));
parcelHelpers.export(exports, "CreateNewFolderTwoTone", ()=>(0, _createNewFolderTwoToneDefault.default));
parcelHelpers.export(exports, "CreateOutlined", ()=>(0, _createOutlinedDefault.default));
parcelHelpers.export(exports, "CreateRounded", ()=>(0, _createRoundedDefault.default));
parcelHelpers.export(exports, "CreateSharp", ()=>(0, _createSharpDefault.default));
parcelHelpers.export(exports, "CreateTwoTone", ()=>(0, _createTwoToneDefault.default));
parcelHelpers.export(exports, "CreditCard", ()=>(0, _creditCardDefault.default));
parcelHelpers.export(exports, "CreditCardOff", ()=>(0, _creditCardOffDefault.default));
parcelHelpers.export(exports, "CreditCardOffOutlined", ()=>(0, _creditCardOffOutlinedDefault.default));
parcelHelpers.export(exports, "CreditCardOffRounded", ()=>(0, _creditCardOffRoundedDefault.default));
parcelHelpers.export(exports, "CreditCardOffSharp", ()=>(0, _creditCardOffSharpDefault.default));
parcelHelpers.export(exports, "CreditCardOffTwoTone", ()=>(0, _creditCardOffTwoToneDefault.default));
parcelHelpers.export(exports, "CreditCardOutlined", ()=>(0, _creditCardOutlinedDefault.default));
parcelHelpers.export(exports, "CreditCardRounded", ()=>(0, _creditCardRoundedDefault.default));
parcelHelpers.export(exports, "CreditCardSharp", ()=>(0, _creditCardSharpDefault.default));
parcelHelpers.export(exports, "CreditCardTwoTone", ()=>(0, _creditCardTwoToneDefault.default));
parcelHelpers.export(exports, "CreditScore", ()=>(0, _creditScoreDefault.default));
parcelHelpers.export(exports, "CreditScoreOutlined", ()=>(0, _creditScoreOutlinedDefault.default));
parcelHelpers.export(exports, "CreditScoreRounded", ()=>(0, _creditScoreRoundedDefault.default));
parcelHelpers.export(exports, "CreditScoreSharp", ()=>(0, _creditScoreSharpDefault.default));
parcelHelpers.export(exports, "CreditScoreTwoTone", ()=>(0, _creditScoreTwoToneDefault.default));
parcelHelpers.export(exports, "Crib", ()=>(0, _cribDefault.default));
parcelHelpers.export(exports, "CribOutlined", ()=>(0, _cribOutlinedDefault.default));
parcelHelpers.export(exports, "CribRounded", ()=>(0, _cribRoundedDefault.default));
parcelHelpers.export(exports, "CribSharp", ()=>(0, _cribSharpDefault.default));
parcelHelpers.export(exports, "CribTwoTone", ()=>(0, _cribTwoToneDefault.default));
parcelHelpers.export(exports, "CrisisAlert", ()=>(0, _crisisAlertDefault.default));
parcelHelpers.export(exports, "CrisisAlertOutlined", ()=>(0, _crisisAlertOutlinedDefault.default));
parcelHelpers.export(exports, "CrisisAlertRounded", ()=>(0, _crisisAlertRoundedDefault.default));
parcelHelpers.export(exports, "CrisisAlertSharp", ()=>(0, _crisisAlertSharpDefault.default));
parcelHelpers.export(exports, "CrisisAlertTwoTone", ()=>(0, _crisisAlertTwoToneDefault.default));
parcelHelpers.export(exports, "Crop", ()=>(0, _cropDefault.default));
parcelHelpers.export(exports, "Crop169", ()=>(0, _crop169Default.default));
parcelHelpers.export(exports, "Crop169Outlined", ()=>(0, _crop169OutlinedDefault.default));
parcelHelpers.export(exports, "Crop169Rounded", ()=>(0, _crop169RoundedDefault.default));
parcelHelpers.export(exports, "Crop169Sharp", ()=>(0, _crop169SharpDefault.default));
parcelHelpers.export(exports, "Crop169TwoTone", ()=>(0, _crop169TwoToneDefault.default));
parcelHelpers.export(exports, "Crop32", ()=>(0, _crop32Default.default));
parcelHelpers.export(exports, "Crop32Outlined", ()=>(0, _crop32OutlinedDefault.default));
parcelHelpers.export(exports, "Crop32Rounded", ()=>(0, _crop32RoundedDefault.default));
parcelHelpers.export(exports, "Crop32Sharp", ()=>(0, _crop32SharpDefault.default));
parcelHelpers.export(exports, "Crop32TwoTone", ()=>(0, _crop32TwoToneDefault.default));
parcelHelpers.export(exports, "Crop54", ()=>(0, _crop54Default.default));
parcelHelpers.export(exports, "Crop54Outlined", ()=>(0, _crop54OutlinedDefault.default));
parcelHelpers.export(exports, "Crop54Rounded", ()=>(0, _crop54RoundedDefault.default));
parcelHelpers.export(exports, "Crop54Sharp", ()=>(0, _crop54SharpDefault.default));
parcelHelpers.export(exports, "Crop54TwoTone", ()=>(0, _crop54TwoToneDefault.default));
parcelHelpers.export(exports, "Crop75", ()=>(0, _crop75Default.default));
parcelHelpers.export(exports, "Crop75Outlined", ()=>(0, _crop75OutlinedDefault.default));
parcelHelpers.export(exports, "Crop75Rounded", ()=>(0, _crop75RoundedDefault.default));
parcelHelpers.export(exports, "Crop75Sharp", ()=>(0, _crop75SharpDefault.default));
parcelHelpers.export(exports, "Crop75TwoTone", ()=>(0, _crop75TwoToneDefault.default));
parcelHelpers.export(exports, "CropDin", ()=>(0, _cropDinDefault.default));
parcelHelpers.export(exports, "CropDinOutlined", ()=>(0, _cropDinOutlinedDefault.default));
parcelHelpers.export(exports, "CropDinRounded", ()=>(0, _cropDinRoundedDefault.default));
parcelHelpers.export(exports, "CropDinSharp", ()=>(0, _cropDinSharpDefault.default));
parcelHelpers.export(exports, "CropDinTwoTone", ()=>(0, _cropDinTwoToneDefault.default));
parcelHelpers.export(exports, "CropFree", ()=>(0, _cropFreeDefault.default));
parcelHelpers.export(exports, "CropFreeOutlined", ()=>(0, _cropFreeOutlinedDefault.default));
parcelHelpers.export(exports, "CropFreeRounded", ()=>(0, _cropFreeRoundedDefault.default));
parcelHelpers.export(exports, "CropFreeSharp", ()=>(0, _cropFreeSharpDefault.default));
parcelHelpers.export(exports, "CropFreeTwoTone", ()=>(0, _cropFreeTwoToneDefault.default));
parcelHelpers.export(exports, "CropLandscape", ()=>(0, _cropLandscapeDefault.default));
parcelHelpers.export(exports, "CropLandscapeOutlined", ()=>(0, _cropLandscapeOutlinedDefault.default));
parcelHelpers.export(exports, "CropLandscapeRounded", ()=>(0, _cropLandscapeRoundedDefault.default));
parcelHelpers.export(exports, "CropLandscapeSharp", ()=>(0, _cropLandscapeSharpDefault.default));
parcelHelpers.export(exports, "CropLandscapeTwoTone", ()=>(0, _cropLandscapeTwoToneDefault.default));
parcelHelpers.export(exports, "CropOriginal", ()=>(0, _cropOriginalDefault.default));
parcelHelpers.export(exports, "CropOriginalOutlined", ()=>(0, _cropOriginalOutlinedDefault.default));
parcelHelpers.export(exports, "CropOriginalRounded", ()=>(0, _cropOriginalRoundedDefault.default));
parcelHelpers.export(exports, "CropOriginalSharp", ()=>(0, _cropOriginalSharpDefault.default));
parcelHelpers.export(exports, "CropOriginalTwoTone", ()=>(0, _cropOriginalTwoToneDefault.default));
parcelHelpers.export(exports, "CropOutlined", ()=>(0, _cropOutlinedDefault.default));
parcelHelpers.export(exports, "CropPortrait", ()=>(0, _cropPortraitDefault.default));
parcelHelpers.export(exports, "CropPortraitOutlined", ()=>(0, _cropPortraitOutlinedDefault.default));
parcelHelpers.export(exports, "CropPortraitRounded", ()=>(0, _cropPortraitRoundedDefault.default));
parcelHelpers.export(exports, "CropPortraitSharp", ()=>(0, _cropPortraitSharpDefault.default));
parcelHelpers.export(exports, "CropPortraitTwoTone", ()=>(0, _cropPortraitTwoToneDefault.default));
parcelHelpers.export(exports, "CropRotate", ()=>(0, _cropRotateDefault.default));
parcelHelpers.export(exports, "CropRotateOutlined", ()=>(0, _cropRotateOutlinedDefault.default));
parcelHelpers.export(exports, "CropRotateRounded", ()=>(0, _cropRotateRoundedDefault.default));
parcelHelpers.export(exports, "CropRotateSharp", ()=>(0, _cropRotateSharpDefault.default));
parcelHelpers.export(exports, "CropRotateTwoTone", ()=>(0, _cropRotateTwoToneDefault.default));
parcelHelpers.export(exports, "CropRounded", ()=>(0, _cropRoundedDefault.default));
parcelHelpers.export(exports, "CropSharp", ()=>(0, _cropSharpDefault.default));
parcelHelpers.export(exports, "CropSquare", ()=>(0, _cropSquareDefault.default));
parcelHelpers.export(exports, "CropSquareOutlined", ()=>(0, _cropSquareOutlinedDefault.default));
parcelHelpers.export(exports, "CropSquareRounded", ()=>(0, _cropSquareRoundedDefault.default));
parcelHelpers.export(exports, "CropSquareSharp", ()=>(0, _cropSquareSharpDefault.default));
parcelHelpers.export(exports, "CropSquareTwoTone", ()=>(0, _cropSquareTwoToneDefault.default));
parcelHelpers.export(exports, "CropTwoTone", ()=>(0, _cropTwoToneDefault.default));
parcelHelpers.export(exports, "Css", ()=>(0, _cssDefault.default));
parcelHelpers.export(exports, "CssOutlined", ()=>(0, _cssOutlinedDefault.default));
parcelHelpers.export(exports, "CssRounded", ()=>(0, _cssRoundedDefault.default));
parcelHelpers.export(exports, "CssSharp", ()=>(0, _cssSharpDefault.default));
parcelHelpers.export(exports, "CssTwoTone", ()=>(0, _cssTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoin", ()=>(0, _currencyBitcoinDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoinOutlined", ()=>(0, _currencyBitcoinOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoinRounded", ()=>(0, _currencyBitcoinRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoinSharp", ()=>(0, _currencyBitcoinSharpDefault.default));
parcelHelpers.export(exports, "CurrencyBitcoinTwoTone", ()=>(0, _currencyBitcoinTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyExchange", ()=>(0, _currencyExchangeDefault.default));
parcelHelpers.export(exports, "CurrencyExchangeOutlined", ()=>(0, _currencyExchangeOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyExchangeRounded", ()=>(0, _currencyExchangeRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyExchangeSharp", ()=>(0, _currencyExchangeSharpDefault.default));
parcelHelpers.export(exports, "CurrencyExchangeTwoTone", ()=>(0, _currencyExchangeTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyFranc", ()=>(0, _currencyFrancDefault.default));
parcelHelpers.export(exports, "CurrencyFrancOutlined", ()=>(0, _currencyFrancOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyFrancRounded", ()=>(0, _currencyFrancRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyFrancSharp", ()=>(0, _currencyFrancSharpDefault.default));
parcelHelpers.export(exports, "CurrencyFrancTwoTone", ()=>(0, _currencyFrancTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyLira", ()=>(0, _currencyLiraDefault.default));
parcelHelpers.export(exports, "CurrencyLiraOutlined", ()=>(0, _currencyLiraOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyLiraRounded", ()=>(0, _currencyLiraRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyLiraSharp", ()=>(0, _currencyLiraSharpDefault.default));
parcelHelpers.export(exports, "CurrencyLiraTwoTone", ()=>(0, _currencyLiraTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyPound", ()=>(0, _currencyPoundDefault.default));
parcelHelpers.export(exports, "CurrencyPoundOutlined", ()=>(0, _currencyPoundOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyPoundRounded", ()=>(0, _currencyPoundRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyPoundSharp", ()=>(0, _currencyPoundSharpDefault.default));
parcelHelpers.export(exports, "CurrencyPoundTwoTone", ()=>(0, _currencyPoundTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyRuble", ()=>(0, _currencyRubleDefault.default));
parcelHelpers.export(exports, "CurrencyRubleOutlined", ()=>(0, _currencyRubleOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyRubleRounded", ()=>(0, _currencyRubleRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyRubleSharp", ()=>(0, _currencyRubleSharpDefault.default));
parcelHelpers.export(exports, "CurrencyRubleTwoTone", ()=>(0, _currencyRubleTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyRupee", ()=>(0, _currencyRupeeDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeOutlined", ()=>(0, _currencyRupeeOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeRounded", ()=>(0, _currencyRupeeRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeSharp", ()=>(0, _currencyRupeeSharpDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeTwoTone", ()=>(0, _currencyRupeeTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyYen", ()=>(0, _currencyYenDefault.default));
parcelHelpers.export(exports, "CurrencyYenOutlined", ()=>(0, _currencyYenOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyYenRounded", ()=>(0, _currencyYenRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyYenSharp", ()=>(0, _currencyYenSharpDefault.default));
parcelHelpers.export(exports, "CurrencyYenTwoTone", ()=>(0, _currencyYenTwoToneDefault.default));
parcelHelpers.export(exports, "CurrencyYuan", ()=>(0, _currencyYuanDefault.default));
parcelHelpers.export(exports, "CurrencyYuanOutlined", ()=>(0, _currencyYuanOutlinedDefault.default));
parcelHelpers.export(exports, "CurrencyYuanRounded", ()=>(0, _currencyYuanRoundedDefault.default));
parcelHelpers.export(exports, "CurrencyYuanSharp", ()=>(0, _currencyYuanSharpDefault.default));
parcelHelpers.export(exports, "CurrencyYuanTwoTone", ()=>(0, _currencyYuanTwoToneDefault.default));
parcelHelpers.export(exports, "Curtains", ()=>(0, _curtainsDefault.default));
parcelHelpers.export(exports, "CurtainsClosed", ()=>(0, _curtainsClosedDefault.default));
parcelHelpers.export(exports, "CurtainsClosedOutlined", ()=>(0, _curtainsClosedOutlinedDefault.default));
parcelHelpers.export(exports, "CurtainsClosedRounded", ()=>(0, _curtainsClosedRoundedDefault.default));
parcelHelpers.export(exports, "CurtainsClosedSharp", ()=>(0, _curtainsClosedSharpDefault.default));
parcelHelpers.export(exports, "CurtainsClosedTwoTone", ()=>(0, _curtainsClosedTwoToneDefault.default));
parcelHelpers.export(exports, "CurtainsOutlined", ()=>(0, _curtainsOutlinedDefault.default));
parcelHelpers.export(exports, "CurtainsRounded", ()=>(0, _curtainsRoundedDefault.default));
parcelHelpers.export(exports, "CurtainsSharp", ()=>(0, _curtainsSharpDefault.default));
parcelHelpers.export(exports, "CurtainsTwoTone", ()=>(0, _curtainsTwoToneDefault.default));
parcelHelpers.export(exports, "Cyclone", ()=>(0, _cycloneDefault.default));
parcelHelpers.export(exports, "CycloneOutlined", ()=>(0, _cycloneOutlinedDefault.default));
parcelHelpers.export(exports, "CycloneRounded", ()=>(0, _cycloneRoundedDefault.default));
parcelHelpers.export(exports, "CycloneSharp", ()=>(0, _cycloneSharpDefault.default));
parcelHelpers.export(exports, "CycloneTwoTone", ()=>(0, _cycloneTwoToneDefault.default));
parcelHelpers.export(exports, "Dangerous", ()=>(0, _dangerousDefault.default));
parcelHelpers.export(exports, "DangerousOutlined", ()=>(0, _dangerousOutlinedDefault.default));
parcelHelpers.export(exports, "DangerousRounded", ()=>(0, _dangerousRoundedDefault.default));
parcelHelpers.export(exports, "DangerousSharp", ()=>(0, _dangerousSharpDefault.default));
parcelHelpers.export(exports, "DangerousTwoTone", ()=>(0, _dangerousTwoToneDefault.default));
parcelHelpers.export(exports, "DarkMode", ()=>(0, _darkModeDefault.default));
parcelHelpers.export(exports, "DarkModeOutlined", ()=>(0, _darkModeOutlinedDefault.default));
parcelHelpers.export(exports, "DarkModeRounded", ()=>(0, _darkModeRoundedDefault.default));
parcelHelpers.export(exports, "DarkModeSharp", ()=>(0, _darkModeSharpDefault.default));
parcelHelpers.export(exports, "DarkModeTwoTone", ()=>(0, _darkModeTwoToneDefault.default));
parcelHelpers.export(exports, "Dashboard", ()=>(0, _dashboardDefault.default));
parcelHelpers.export(exports, "DashboardCustomize", ()=>(0, _dashboardCustomizeDefault.default));
parcelHelpers.export(exports, "DashboardCustomizeOutlined", ()=>(0, _dashboardCustomizeOutlinedDefault.default));
parcelHelpers.export(exports, "DashboardCustomizeRounded", ()=>(0, _dashboardCustomizeRoundedDefault.default));
parcelHelpers.export(exports, "DashboardCustomizeSharp", ()=>(0, _dashboardCustomizeSharpDefault.default));
parcelHelpers.export(exports, "DashboardCustomizeTwoTone", ()=>(0, _dashboardCustomizeTwoToneDefault.default));
parcelHelpers.export(exports, "DashboardOutlined", ()=>(0, _dashboardOutlinedDefault.default));
parcelHelpers.export(exports, "DashboardRounded", ()=>(0, _dashboardRoundedDefault.default));
parcelHelpers.export(exports, "DashboardSharp", ()=>(0, _dashboardSharpDefault.default));
parcelHelpers.export(exports, "DashboardTwoTone", ()=>(0, _dashboardTwoToneDefault.default));
parcelHelpers.export(exports, "DataArray", ()=>(0, _dataArrayDefault.default));
parcelHelpers.export(exports, "DataArrayOutlined", ()=>(0, _dataArrayOutlinedDefault.default));
parcelHelpers.export(exports, "DataArrayRounded", ()=>(0, _dataArrayRoundedDefault.default));
parcelHelpers.export(exports, "DataArraySharp", ()=>(0, _dataArraySharpDefault.default));
parcelHelpers.export(exports, "DataArrayTwoTone", ()=>(0, _dataArrayTwoToneDefault.default));
parcelHelpers.export(exports, "DataObject", ()=>(0, _dataObjectDefault.default));
parcelHelpers.export(exports, "DataObjectOutlined", ()=>(0, _dataObjectOutlinedDefault.default));
parcelHelpers.export(exports, "DataObjectRounded", ()=>(0, _dataObjectRoundedDefault.default));
parcelHelpers.export(exports, "DataObjectSharp", ()=>(0, _dataObjectSharpDefault.default));
parcelHelpers.export(exports, "DataObjectTwoTone", ()=>(0, _dataObjectTwoToneDefault.default));
parcelHelpers.export(exports, "DataSaverOff", ()=>(0, _dataSaverOffDefault.default));
parcelHelpers.export(exports, "DataSaverOffOutlined", ()=>(0, _dataSaverOffOutlinedDefault.default));
parcelHelpers.export(exports, "DataSaverOffRounded", ()=>(0, _dataSaverOffRoundedDefault.default));
parcelHelpers.export(exports, "DataSaverOffSharp", ()=>(0, _dataSaverOffSharpDefault.default));
parcelHelpers.export(exports, "DataSaverOffTwoTone", ()=>(0, _dataSaverOffTwoToneDefault.default));
parcelHelpers.export(exports, "DataSaverOn", ()=>(0, _dataSaverOnDefault.default));
parcelHelpers.export(exports, "DataSaverOnOutlined", ()=>(0, _dataSaverOnOutlinedDefault.default));
parcelHelpers.export(exports, "DataSaverOnRounded", ()=>(0, _dataSaverOnRoundedDefault.default));
parcelHelpers.export(exports, "DataSaverOnSharp", ()=>(0, _dataSaverOnSharpDefault.default));
parcelHelpers.export(exports, "DataSaverOnTwoTone", ()=>(0, _dataSaverOnTwoToneDefault.default));
parcelHelpers.export(exports, "DataThresholding", ()=>(0, _dataThresholdingDefault.default));
parcelHelpers.export(exports, "DataThresholdingOutlined", ()=>(0, _dataThresholdingOutlinedDefault.default));
parcelHelpers.export(exports, "DataThresholdingRounded", ()=>(0, _dataThresholdingRoundedDefault.default));
parcelHelpers.export(exports, "DataThresholdingSharp", ()=>(0, _dataThresholdingSharpDefault.default));
parcelHelpers.export(exports, "DataThresholdingTwoTone", ()=>(0, _dataThresholdingTwoToneDefault.default));
parcelHelpers.export(exports, "DataUsage", ()=>(0, _dataUsageDefault.default));
parcelHelpers.export(exports, "DataUsageOutlined", ()=>(0, _dataUsageOutlinedDefault.default));
parcelHelpers.export(exports, "DataUsageRounded", ()=>(0, _dataUsageRoundedDefault.default));
parcelHelpers.export(exports, "DataUsageSharp", ()=>(0, _dataUsageSharpDefault.default));
parcelHelpers.export(exports, "DataUsageTwoTone", ()=>(0, _dataUsageTwoToneDefault.default));
parcelHelpers.export(exports, "Dataset", ()=>(0, _datasetDefault.default));
parcelHelpers.export(exports, "DatasetLinked", ()=>(0, _datasetLinkedDefault.default));
parcelHelpers.export(exports, "DatasetLinkedOutlined", ()=>(0, _datasetLinkedOutlinedDefault.default));
parcelHelpers.export(exports, "DatasetLinkedRounded", ()=>(0, _datasetLinkedRoundedDefault.default));
parcelHelpers.export(exports, "DatasetLinkedSharp", ()=>(0, _datasetLinkedSharpDefault.default));
parcelHelpers.export(exports, "DatasetLinkedTwoTone", ()=>(0, _datasetLinkedTwoToneDefault.default));
parcelHelpers.export(exports, "DatasetOutlined", ()=>(0, _datasetOutlinedDefault.default));
parcelHelpers.export(exports, "DatasetRounded", ()=>(0, _datasetRoundedDefault.default));
parcelHelpers.export(exports, "DatasetSharp", ()=>(0, _datasetSharpDefault.default));
parcelHelpers.export(exports, "DatasetTwoTone", ()=>(0, _datasetTwoToneDefault.default));
parcelHelpers.export(exports, "DateRange", ()=>(0, _dateRangeDefault.default));
parcelHelpers.export(exports, "DateRangeOutlined", ()=>(0, _dateRangeOutlinedDefault.default));
parcelHelpers.export(exports, "DateRangeRounded", ()=>(0, _dateRangeRoundedDefault.default));
parcelHelpers.export(exports, "DateRangeSharp", ()=>(0, _dateRangeSharpDefault.default));
parcelHelpers.export(exports, "DateRangeTwoTone", ()=>(0, _dateRangeTwoToneDefault.default));
parcelHelpers.export(exports, "Deblur", ()=>(0, _deblurDefault.default));
parcelHelpers.export(exports, "DeblurOutlined", ()=>(0, _deblurOutlinedDefault.default));
parcelHelpers.export(exports, "DeblurRounded", ()=>(0, _deblurRoundedDefault.default));
parcelHelpers.export(exports, "DeblurSharp", ()=>(0, _deblurSharpDefault.default));
parcelHelpers.export(exports, "DeblurTwoTone", ()=>(0, _deblurTwoToneDefault.default));
parcelHelpers.export(exports, "Deck", ()=>(0, _deckDefault.default));
parcelHelpers.export(exports, "DeckOutlined", ()=>(0, _deckOutlinedDefault.default));
parcelHelpers.export(exports, "DeckRounded", ()=>(0, _deckRoundedDefault.default));
parcelHelpers.export(exports, "DeckSharp", ()=>(0, _deckSharpDefault.default));
parcelHelpers.export(exports, "DeckTwoTone", ()=>(0, _deckTwoToneDefault.default));
parcelHelpers.export(exports, "Dehaze", ()=>(0, _dehazeDefault.default));
parcelHelpers.export(exports, "DehazeOutlined", ()=>(0, _dehazeOutlinedDefault.default));
parcelHelpers.export(exports, "DehazeRounded", ()=>(0, _dehazeRoundedDefault.default));
parcelHelpers.export(exports, "DehazeSharp", ()=>(0, _dehazeSharpDefault.default));
parcelHelpers.export(exports, "DehazeTwoTone", ()=>(0, _dehazeTwoToneDefault.default));
parcelHelpers.export(exports, "Delete", ()=>(0, _deleteDefault.default));
parcelHelpers.export(exports, "DeleteForever", ()=>(0, _deleteForeverDefault.default));
parcelHelpers.export(exports, "DeleteForeverOutlined", ()=>(0, _deleteForeverOutlinedDefault.default));
parcelHelpers.export(exports, "DeleteForeverRounded", ()=>(0, _deleteForeverRoundedDefault.default));
parcelHelpers.export(exports, "DeleteForeverSharp", ()=>(0, _deleteForeverSharpDefault.default));
parcelHelpers.export(exports, "DeleteForeverTwoTone", ()=>(0, _deleteForeverTwoToneDefault.default));
parcelHelpers.export(exports, "DeleteOutline", ()=>(0, _deleteOutlineDefault.default));
parcelHelpers.export(exports, "DeleteOutlineOutlined", ()=>(0, _deleteOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "DeleteOutlineRounded", ()=>(0, _deleteOutlineRoundedDefault.default));
parcelHelpers.export(exports, "DeleteOutlineSharp", ()=>(0, _deleteOutlineSharpDefault.default));
parcelHelpers.export(exports, "DeleteOutlineTwoTone", ()=>(0, _deleteOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "DeleteOutlined", ()=>(0, _deleteOutlinedDefault.default));
parcelHelpers.export(exports, "DeleteRounded", ()=>(0, _deleteRoundedDefault.default));
parcelHelpers.export(exports, "DeleteSharp", ()=>(0, _deleteSharpDefault.default));
parcelHelpers.export(exports, "DeleteSweep", ()=>(0, _deleteSweepDefault.default));
parcelHelpers.export(exports, "DeleteSweepOutlined", ()=>(0, _deleteSweepOutlinedDefault.default));
parcelHelpers.export(exports, "DeleteSweepRounded", ()=>(0, _deleteSweepRoundedDefault.default));
parcelHelpers.export(exports, "DeleteSweepSharp", ()=>(0, _deleteSweepSharpDefault.default));
parcelHelpers.export(exports, "DeleteSweepTwoTone", ()=>(0, _deleteSweepTwoToneDefault.default));
parcelHelpers.export(exports, "DeleteTwoTone", ()=>(0, _deleteTwoToneDefault.default));
parcelHelpers.export(exports, "DeliveryDining", ()=>(0, _deliveryDiningDefault.default));
parcelHelpers.export(exports, "DeliveryDiningOutlined", ()=>(0, _deliveryDiningOutlinedDefault.default));
parcelHelpers.export(exports, "DeliveryDiningRounded", ()=>(0, _deliveryDiningRoundedDefault.default));
parcelHelpers.export(exports, "DeliveryDiningSharp", ()=>(0, _deliveryDiningSharpDefault.default));
parcelHelpers.export(exports, "DeliveryDiningTwoTone", ()=>(0, _deliveryDiningTwoToneDefault.default));
parcelHelpers.export(exports, "DensityLarge", ()=>(0, _densityLargeDefault.default));
parcelHelpers.export(exports, "DensityLargeOutlined", ()=>(0, _densityLargeOutlinedDefault.default));
parcelHelpers.export(exports, "DensityLargeRounded", ()=>(0, _densityLargeRoundedDefault.default));
parcelHelpers.export(exports, "DensityLargeSharp", ()=>(0, _densityLargeSharpDefault.default));
parcelHelpers.export(exports, "DensityLargeTwoTone", ()=>(0, _densityLargeTwoToneDefault.default));
parcelHelpers.export(exports, "DensityMedium", ()=>(0, _densityMediumDefault.default));
parcelHelpers.export(exports, "DensityMediumOutlined", ()=>(0, _densityMediumOutlinedDefault.default));
parcelHelpers.export(exports, "DensityMediumRounded", ()=>(0, _densityMediumRoundedDefault.default));
parcelHelpers.export(exports, "DensityMediumSharp", ()=>(0, _densityMediumSharpDefault.default));
parcelHelpers.export(exports, "DensityMediumTwoTone", ()=>(0, _densityMediumTwoToneDefault.default));
parcelHelpers.export(exports, "DensitySmall", ()=>(0, _densitySmallDefault.default));
parcelHelpers.export(exports, "DensitySmallOutlined", ()=>(0, _densitySmallOutlinedDefault.default));
parcelHelpers.export(exports, "DensitySmallRounded", ()=>(0, _densitySmallRoundedDefault.default));
parcelHelpers.export(exports, "DensitySmallSharp", ()=>(0, _densitySmallSharpDefault.default));
parcelHelpers.export(exports, "DensitySmallTwoTone", ()=>(0, _densitySmallTwoToneDefault.default));
parcelHelpers.export(exports, "DepartureBoard", ()=>(0, _departureBoardDefault.default));
parcelHelpers.export(exports, "DepartureBoardOutlined", ()=>(0, _departureBoardOutlinedDefault.default));
parcelHelpers.export(exports, "DepartureBoardRounded", ()=>(0, _departureBoardRoundedDefault.default));
parcelHelpers.export(exports, "DepartureBoardSharp", ()=>(0, _departureBoardSharpDefault.default));
parcelHelpers.export(exports, "DepartureBoardTwoTone", ()=>(0, _departureBoardTwoToneDefault.default));
parcelHelpers.export(exports, "Description", ()=>(0, _descriptionDefault.default));
parcelHelpers.export(exports, "DescriptionOutlined", ()=>(0, _descriptionOutlinedDefault.default));
parcelHelpers.export(exports, "DescriptionRounded", ()=>(0, _descriptionRoundedDefault.default));
parcelHelpers.export(exports, "DescriptionSharp", ()=>(0, _descriptionSharpDefault.default));
parcelHelpers.export(exports, "DescriptionTwoTone", ()=>(0, _descriptionTwoToneDefault.default));
parcelHelpers.export(exports, "Deselect", ()=>(0, _deselectDefault.default));
parcelHelpers.export(exports, "DeselectOutlined", ()=>(0, _deselectOutlinedDefault.default));
parcelHelpers.export(exports, "DeselectRounded", ()=>(0, _deselectRoundedDefault.default));
parcelHelpers.export(exports, "DeselectSharp", ()=>(0, _deselectSharpDefault.default));
parcelHelpers.export(exports, "DeselectTwoTone", ()=>(0, _deselectTwoToneDefault.default));
parcelHelpers.export(exports, "DesignServices", ()=>(0, _designServicesDefault.default));
parcelHelpers.export(exports, "DesignServicesOutlined", ()=>(0, _designServicesOutlinedDefault.default));
parcelHelpers.export(exports, "DesignServicesRounded", ()=>(0, _designServicesRoundedDefault.default));
parcelHelpers.export(exports, "DesignServicesSharp", ()=>(0, _designServicesSharpDefault.default));
parcelHelpers.export(exports, "DesignServicesTwoTone", ()=>(0, _designServicesTwoToneDefault.default));
parcelHelpers.export(exports, "Desk", ()=>(0, _deskDefault.default));
parcelHelpers.export(exports, "DeskOutlined", ()=>(0, _deskOutlinedDefault.default));
parcelHelpers.export(exports, "DeskRounded", ()=>(0, _deskRoundedDefault.default));
parcelHelpers.export(exports, "DeskSharp", ()=>(0, _deskSharpDefault.default));
parcelHelpers.export(exports, "DeskTwoTone", ()=>(0, _deskTwoToneDefault.default));
parcelHelpers.export(exports, "DesktopAccessDisabled", ()=>(0, _desktopAccessDisabledDefault.default));
parcelHelpers.export(exports, "DesktopAccessDisabledOutlined", ()=>(0, _desktopAccessDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "DesktopAccessDisabledRounded", ()=>(0, _desktopAccessDisabledRoundedDefault.default));
parcelHelpers.export(exports, "DesktopAccessDisabledSharp", ()=>(0, _desktopAccessDisabledSharpDefault.default));
parcelHelpers.export(exports, "DesktopAccessDisabledTwoTone", ()=>(0, _desktopAccessDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "DesktopMac", ()=>(0, _desktopMacDefault.default));
parcelHelpers.export(exports, "DesktopMacOutlined", ()=>(0, _desktopMacOutlinedDefault.default));
parcelHelpers.export(exports, "DesktopMacRounded", ()=>(0, _desktopMacRoundedDefault.default));
parcelHelpers.export(exports, "DesktopMacSharp", ()=>(0, _desktopMacSharpDefault.default));
parcelHelpers.export(exports, "DesktopMacTwoTone", ()=>(0, _desktopMacTwoToneDefault.default));
parcelHelpers.export(exports, "DesktopWindows", ()=>(0, _desktopWindowsDefault.default));
parcelHelpers.export(exports, "DesktopWindowsOutlined", ()=>(0, _desktopWindowsOutlinedDefault.default));
parcelHelpers.export(exports, "DesktopWindowsRounded", ()=>(0, _desktopWindowsRoundedDefault.default));
parcelHelpers.export(exports, "DesktopWindowsSharp", ()=>(0, _desktopWindowsSharpDefault.default));
parcelHelpers.export(exports, "DesktopWindowsTwoTone", ()=>(0, _desktopWindowsTwoToneDefault.default));
parcelHelpers.export(exports, "Details", ()=>(0, _detailsDefault.default));
parcelHelpers.export(exports, "DetailsOutlined", ()=>(0, _detailsOutlinedDefault.default));
parcelHelpers.export(exports, "DetailsRounded", ()=>(0, _detailsRoundedDefault.default));
parcelHelpers.export(exports, "DetailsSharp", ()=>(0, _detailsSharpDefault.default));
parcelHelpers.export(exports, "DetailsTwoTone", ()=>(0, _detailsTwoToneDefault.default));
parcelHelpers.export(exports, "DeveloperBoard", ()=>(0, _developerBoardDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOff", ()=>(0, _developerBoardOffDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOffOutlined", ()=>(0, _developerBoardOffOutlinedDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOffRounded", ()=>(0, _developerBoardOffRoundedDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOffSharp", ()=>(0, _developerBoardOffSharpDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOffTwoTone", ()=>(0, _developerBoardOffTwoToneDefault.default));
parcelHelpers.export(exports, "DeveloperBoardOutlined", ()=>(0, _developerBoardOutlinedDefault.default));
parcelHelpers.export(exports, "DeveloperBoardRounded", ()=>(0, _developerBoardRoundedDefault.default));
parcelHelpers.export(exports, "DeveloperBoardSharp", ()=>(0, _developerBoardSharpDefault.default));
parcelHelpers.export(exports, "DeveloperBoardTwoTone", ()=>(0, _developerBoardTwoToneDefault.default));
parcelHelpers.export(exports, "DeveloperMode", ()=>(0, _developerModeDefault.default));
parcelHelpers.export(exports, "DeveloperModeOutlined", ()=>(0, _developerModeOutlinedDefault.default));
parcelHelpers.export(exports, "DeveloperModeRounded", ()=>(0, _developerModeRoundedDefault.default));
parcelHelpers.export(exports, "DeveloperModeSharp", ()=>(0, _developerModeSharpDefault.default));
parcelHelpers.export(exports, "DeveloperModeTwoTone", ()=>(0, _developerModeTwoToneDefault.default));
parcelHelpers.export(exports, "DeviceHub", ()=>(0, _deviceHubDefault.default));
parcelHelpers.export(exports, "DeviceHubOutlined", ()=>(0, _deviceHubOutlinedDefault.default));
parcelHelpers.export(exports, "DeviceHubRounded", ()=>(0, _deviceHubRoundedDefault.default));
parcelHelpers.export(exports, "DeviceHubSharp", ()=>(0, _deviceHubSharpDefault.default));
parcelHelpers.export(exports, "DeviceHubTwoTone", ()=>(0, _deviceHubTwoToneDefault.default));
parcelHelpers.export(exports, "DeviceThermostat", ()=>(0, _deviceThermostatDefault.default));
parcelHelpers.export(exports, "DeviceThermostatOutlined", ()=>(0, _deviceThermostatOutlinedDefault.default));
parcelHelpers.export(exports, "DeviceThermostatRounded", ()=>(0, _deviceThermostatRoundedDefault.default));
parcelHelpers.export(exports, "DeviceThermostatSharp", ()=>(0, _deviceThermostatSharpDefault.default));
parcelHelpers.export(exports, "DeviceThermostatTwoTone", ()=>(0, _deviceThermostatTwoToneDefault.default));
parcelHelpers.export(exports, "DeviceUnknown", ()=>(0, _deviceUnknownDefault.default));
parcelHelpers.export(exports, "DeviceUnknownOutlined", ()=>(0, _deviceUnknownOutlinedDefault.default));
parcelHelpers.export(exports, "DeviceUnknownRounded", ()=>(0, _deviceUnknownRoundedDefault.default));
parcelHelpers.export(exports, "DeviceUnknownSharp", ()=>(0, _deviceUnknownSharpDefault.default));
parcelHelpers.export(exports, "DeviceUnknownTwoTone", ()=>(0, _deviceUnknownTwoToneDefault.default));
parcelHelpers.export(exports, "Devices", ()=>(0, _devicesDefault.default));
parcelHelpers.export(exports, "DevicesFold", ()=>(0, _devicesFoldDefault.default));
parcelHelpers.export(exports, "DevicesFoldOutlined", ()=>(0, _devicesFoldOutlinedDefault.default));
parcelHelpers.export(exports, "DevicesFoldRounded", ()=>(0, _devicesFoldRoundedDefault.default));
parcelHelpers.export(exports, "DevicesFoldSharp", ()=>(0, _devicesFoldSharpDefault.default));
parcelHelpers.export(exports, "DevicesFoldTwoTone", ()=>(0, _devicesFoldTwoToneDefault.default));
parcelHelpers.export(exports, "DevicesOther", ()=>(0, _devicesOtherDefault.default));
parcelHelpers.export(exports, "DevicesOtherOutlined", ()=>(0, _devicesOtherOutlinedDefault.default));
parcelHelpers.export(exports, "DevicesOtherRounded", ()=>(0, _devicesOtherRoundedDefault.default));
parcelHelpers.export(exports, "DevicesOtherSharp", ()=>(0, _devicesOtherSharpDefault.default));
parcelHelpers.export(exports, "DevicesOtherTwoTone", ()=>(0, _devicesOtherTwoToneDefault.default));
parcelHelpers.export(exports, "DevicesOutlined", ()=>(0, _devicesOutlinedDefault.default));
parcelHelpers.export(exports, "DevicesRounded", ()=>(0, _devicesRoundedDefault.default));
parcelHelpers.export(exports, "DevicesSharp", ()=>(0, _devicesSharpDefault.default));
parcelHelpers.export(exports, "DevicesTwoTone", ()=>(0, _devicesTwoToneDefault.default));
parcelHelpers.export(exports, "DialerSip", ()=>(0, _dialerSipDefault.default));
parcelHelpers.export(exports, "DialerSipOutlined", ()=>(0, _dialerSipOutlinedDefault.default));
parcelHelpers.export(exports, "DialerSipRounded", ()=>(0, _dialerSipRoundedDefault.default));
parcelHelpers.export(exports, "DialerSipSharp", ()=>(0, _dialerSipSharpDefault.default));
parcelHelpers.export(exports, "DialerSipTwoTone", ()=>(0, _dialerSipTwoToneDefault.default));
parcelHelpers.export(exports, "Dialpad", ()=>(0, _dialpadDefault.default));
parcelHelpers.export(exports, "DialpadOutlined", ()=>(0, _dialpadOutlinedDefault.default));
parcelHelpers.export(exports, "DialpadRounded", ()=>(0, _dialpadRoundedDefault.default));
parcelHelpers.export(exports, "DialpadSharp", ()=>(0, _dialpadSharpDefault.default));
parcelHelpers.export(exports, "DialpadTwoTone", ()=>(0, _dialpadTwoToneDefault.default));
parcelHelpers.export(exports, "Diamond", ()=>(0, _diamondDefault.default));
parcelHelpers.export(exports, "DiamondOutlined", ()=>(0, _diamondOutlinedDefault.default));
parcelHelpers.export(exports, "DiamondRounded", ()=>(0, _diamondRoundedDefault.default));
parcelHelpers.export(exports, "DiamondSharp", ()=>(0, _diamondSharpDefault.default));
parcelHelpers.export(exports, "DiamondTwoTone", ()=>(0, _diamondTwoToneDefault.default));
parcelHelpers.export(exports, "Difference", ()=>(0, _differenceDefault.default));
parcelHelpers.export(exports, "DifferenceOutlined", ()=>(0, _differenceOutlinedDefault.default));
parcelHelpers.export(exports, "DifferenceRounded", ()=>(0, _differenceRoundedDefault.default));
parcelHelpers.export(exports, "DifferenceSharp", ()=>(0, _differenceSharpDefault.default));
parcelHelpers.export(exports, "DifferenceTwoTone", ()=>(0, _differenceTwoToneDefault.default));
parcelHelpers.export(exports, "Dining", ()=>(0, _diningDefault.default));
parcelHelpers.export(exports, "DiningOutlined", ()=>(0, _diningOutlinedDefault.default));
parcelHelpers.export(exports, "DiningRounded", ()=>(0, _diningRoundedDefault.default));
parcelHelpers.export(exports, "DiningSharp", ()=>(0, _diningSharpDefault.default));
parcelHelpers.export(exports, "DiningTwoTone", ()=>(0, _diningTwoToneDefault.default));
parcelHelpers.export(exports, "DinnerDining", ()=>(0, _dinnerDiningDefault.default));
parcelHelpers.export(exports, "DinnerDiningOutlined", ()=>(0, _dinnerDiningOutlinedDefault.default));
parcelHelpers.export(exports, "DinnerDiningRounded", ()=>(0, _dinnerDiningRoundedDefault.default));
parcelHelpers.export(exports, "DinnerDiningSharp", ()=>(0, _dinnerDiningSharpDefault.default));
parcelHelpers.export(exports, "DinnerDiningTwoTone", ()=>(0, _dinnerDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Directions", ()=>(0, _directionsDefault.default));
parcelHelpers.export(exports, "DirectionsBike", ()=>(0, _directionsBikeDefault.default));
parcelHelpers.export(exports, "DirectionsBikeOutlined", ()=>(0, _directionsBikeOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsBikeRounded", ()=>(0, _directionsBikeRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsBikeSharp", ()=>(0, _directionsBikeSharpDefault.default));
parcelHelpers.export(exports, "DirectionsBikeTwoTone", ()=>(0, _directionsBikeTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsBoat", ()=>(0, _directionsBoatDefault.default));
parcelHelpers.export(exports, "DirectionsBoatFilled", ()=>(0, _directionsBoatFilledDefault.default));
parcelHelpers.export(exports, "DirectionsBoatFilledOutlined", ()=>(0, _directionsBoatFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsBoatFilledRounded", ()=>(0, _directionsBoatFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsBoatFilledSharp", ()=>(0, _directionsBoatFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsBoatFilledTwoTone", ()=>(0, _directionsBoatFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsBoatOutlined", ()=>(0, _directionsBoatOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsBoatRounded", ()=>(0, _directionsBoatRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsBoatSharp", ()=>(0, _directionsBoatSharpDefault.default));
parcelHelpers.export(exports, "DirectionsBoatTwoTone", ()=>(0, _directionsBoatTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsBus", ()=>(0, _directionsBusDefault.default));
parcelHelpers.export(exports, "DirectionsBusFilled", ()=>(0, _directionsBusFilledDefault.default));
parcelHelpers.export(exports, "DirectionsBusFilledOutlined", ()=>(0, _directionsBusFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsBusFilledRounded", ()=>(0, _directionsBusFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsBusFilledSharp", ()=>(0, _directionsBusFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsBusFilledTwoTone", ()=>(0, _directionsBusFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsBusOutlined", ()=>(0, _directionsBusOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsBusRounded", ()=>(0, _directionsBusRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsBusSharp", ()=>(0, _directionsBusSharpDefault.default));
parcelHelpers.export(exports, "DirectionsBusTwoTone", ()=>(0, _directionsBusTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsCar", ()=>(0, _directionsCarDefault.default));
parcelHelpers.export(exports, "DirectionsCarFilled", ()=>(0, _directionsCarFilledDefault.default));
parcelHelpers.export(exports, "DirectionsCarFilledOutlined", ()=>(0, _directionsCarFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsCarFilledRounded", ()=>(0, _directionsCarFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsCarFilledSharp", ()=>(0, _directionsCarFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsCarFilledTwoTone", ()=>(0, _directionsCarFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsCarOutlined", ()=>(0, _directionsCarOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsCarRounded", ()=>(0, _directionsCarRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsCarSharp", ()=>(0, _directionsCarSharpDefault.default));
parcelHelpers.export(exports, "DirectionsCarTwoTone", ()=>(0, _directionsCarTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsOff", ()=>(0, _directionsOffDefault.default));
parcelHelpers.export(exports, "DirectionsOffOutlined", ()=>(0, _directionsOffOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsOffRounded", ()=>(0, _directionsOffRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsOffSharp", ()=>(0, _directionsOffSharpDefault.default));
parcelHelpers.export(exports, "DirectionsOffTwoTone", ()=>(0, _directionsOffTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsOutlined", ()=>(0, _directionsOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsRailway", ()=>(0, _directionsRailwayDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayFilled", ()=>(0, _directionsRailwayFilledDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayFilledOutlined", ()=>(0, _directionsRailwayFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayFilledRounded", ()=>(0, _directionsRailwayFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayFilledSharp", ()=>(0, _directionsRailwayFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayFilledTwoTone", ()=>(0, _directionsRailwayFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayOutlined", ()=>(0, _directionsRailwayOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayRounded", ()=>(0, _directionsRailwayRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsRailwaySharp", ()=>(0, _directionsRailwaySharpDefault.default));
parcelHelpers.export(exports, "DirectionsRailwayTwoTone", ()=>(0, _directionsRailwayTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsRounded", ()=>(0, _directionsRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsRun", ()=>(0, _directionsRunDefault.default));
parcelHelpers.export(exports, "DirectionsRunOutlined", ()=>(0, _directionsRunOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsRunRounded", ()=>(0, _directionsRunRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsRunSharp", ()=>(0, _directionsRunSharpDefault.default));
parcelHelpers.export(exports, "DirectionsRunTwoTone", ()=>(0, _directionsRunTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsSharp", ()=>(0, _directionsSharpDefault.default));
parcelHelpers.export(exports, "DirectionsSubway", ()=>(0, _directionsSubwayDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayFilled", ()=>(0, _directionsSubwayFilledDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayFilledOutlined", ()=>(0, _directionsSubwayFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayFilledRounded", ()=>(0, _directionsSubwayFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayFilledSharp", ()=>(0, _directionsSubwayFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayFilledTwoTone", ()=>(0, _directionsSubwayFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayOutlined", ()=>(0, _directionsSubwayOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayRounded", ()=>(0, _directionsSubwayRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsSubwaySharp", ()=>(0, _directionsSubwaySharpDefault.default));
parcelHelpers.export(exports, "DirectionsSubwayTwoTone", ()=>(0, _directionsSubwayTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsTransit", ()=>(0, _directionsTransitDefault.default));
parcelHelpers.export(exports, "DirectionsTransitFilled", ()=>(0, _directionsTransitFilledDefault.default));
parcelHelpers.export(exports, "DirectionsTransitFilledOutlined", ()=>(0, _directionsTransitFilledOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsTransitFilledRounded", ()=>(0, _directionsTransitFilledRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsTransitFilledSharp", ()=>(0, _directionsTransitFilledSharpDefault.default));
parcelHelpers.export(exports, "DirectionsTransitFilledTwoTone", ()=>(0, _directionsTransitFilledTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsTransitOutlined", ()=>(0, _directionsTransitOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsTransitRounded", ()=>(0, _directionsTransitRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsTransitSharp", ()=>(0, _directionsTransitSharpDefault.default));
parcelHelpers.export(exports, "DirectionsTransitTwoTone", ()=>(0, _directionsTransitTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsTwoTone", ()=>(0, _directionsTwoToneDefault.default));
parcelHelpers.export(exports, "DirectionsWalk", ()=>(0, _directionsWalkDefault.default));
parcelHelpers.export(exports, "DirectionsWalkOutlined", ()=>(0, _directionsWalkOutlinedDefault.default));
parcelHelpers.export(exports, "DirectionsWalkRounded", ()=>(0, _directionsWalkRoundedDefault.default));
parcelHelpers.export(exports, "DirectionsWalkSharp", ()=>(0, _directionsWalkSharpDefault.default));
parcelHelpers.export(exports, "DirectionsWalkTwoTone", ()=>(0, _directionsWalkTwoToneDefault.default));
parcelHelpers.export(exports, "DirtyLens", ()=>(0, _dirtyLensDefault.default));
parcelHelpers.export(exports, "DirtyLensOutlined", ()=>(0, _dirtyLensOutlinedDefault.default));
parcelHelpers.export(exports, "DirtyLensRounded", ()=>(0, _dirtyLensRoundedDefault.default));
parcelHelpers.export(exports, "DirtyLensSharp", ()=>(0, _dirtyLensSharpDefault.default));
parcelHelpers.export(exports, "DirtyLensTwoTone", ()=>(0, _dirtyLensTwoToneDefault.default));
parcelHelpers.export(exports, "DisabledByDefault", ()=>(0, _disabledByDefaultDefault.default));
parcelHelpers.export(exports, "DisabledByDefaultOutlined", ()=>(0, _disabledByDefaultOutlinedDefault.default));
parcelHelpers.export(exports, "DisabledByDefaultRounded", ()=>(0, _disabledByDefaultRoundedDefault.default));
parcelHelpers.export(exports, "DisabledByDefaultSharp", ()=>(0, _disabledByDefaultSharpDefault.default));
parcelHelpers.export(exports, "DisabledByDefaultTwoTone", ()=>(0, _disabledByDefaultTwoToneDefault.default));
parcelHelpers.export(exports, "DiscFull", ()=>(0, _discFullDefault.default));
parcelHelpers.export(exports, "DiscFullOutlined", ()=>(0, _discFullOutlinedDefault.default));
parcelHelpers.export(exports, "DiscFullRounded", ()=>(0, _discFullRoundedDefault.default));
parcelHelpers.export(exports, "DiscFullSharp", ()=>(0, _discFullSharpDefault.default));
parcelHelpers.export(exports, "DiscFullTwoTone", ()=>(0, _discFullTwoToneDefault.default));
parcelHelpers.export(exports, "Discount", ()=>(0, _discountDefault.default));
parcelHelpers.export(exports, "DiscountOutlined", ()=>(0, _discountOutlinedDefault.default));
parcelHelpers.export(exports, "DiscountRounded", ()=>(0, _discountRoundedDefault.default));
parcelHelpers.export(exports, "DiscountSharp", ()=>(0, _discountSharpDefault.default));
parcelHelpers.export(exports, "DiscountTwoTone", ()=>(0, _discountTwoToneDefault.default));
parcelHelpers.export(exports, "DisplaySettings", ()=>(0, _displaySettingsDefault.default));
parcelHelpers.export(exports, "DisplaySettingsOutlined", ()=>(0, _displaySettingsOutlinedDefault.default));
parcelHelpers.export(exports, "DisplaySettingsRounded", ()=>(0, _displaySettingsRoundedDefault.default));
parcelHelpers.export(exports, "DisplaySettingsSharp", ()=>(0, _displaySettingsSharpDefault.default));
parcelHelpers.export(exports, "DisplaySettingsTwoTone", ()=>(0, _displaySettingsTwoToneDefault.default));
parcelHelpers.export(exports, "Diversity1", ()=>(0, _diversity1Default.default));
parcelHelpers.export(exports, "Diversity1Outlined", ()=>(0, _diversity1OutlinedDefault.default));
parcelHelpers.export(exports, "Diversity1Rounded", ()=>(0, _diversity1RoundedDefault.default));
parcelHelpers.export(exports, "Diversity1Sharp", ()=>(0, _diversity1SharpDefault.default));
parcelHelpers.export(exports, "Diversity1TwoTone", ()=>(0, _diversity1TwoToneDefault.default));
parcelHelpers.export(exports, "Diversity2", ()=>(0, _diversity2Default.default));
parcelHelpers.export(exports, "Diversity2Outlined", ()=>(0, _diversity2OutlinedDefault.default));
parcelHelpers.export(exports, "Diversity2Rounded", ()=>(0, _diversity2RoundedDefault.default));
parcelHelpers.export(exports, "Diversity2Sharp", ()=>(0, _diversity2SharpDefault.default));
parcelHelpers.export(exports, "Diversity2TwoTone", ()=>(0, _diversity2TwoToneDefault.default));
parcelHelpers.export(exports, "Diversity3", ()=>(0, _diversity3Default.default));
parcelHelpers.export(exports, "Diversity3Outlined", ()=>(0, _diversity3OutlinedDefault.default));
parcelHelpers.export(exports, "Diversity3Rounded", ()=>(0, _diversity3RoundedDefault.default));
parcelHelpers.export(exports, "Diversity3Sharp", ()=>(0, _diversity3SharpDefault.default));
parcelHelpers.export(exports, "Diversity3TwoTone", ()=>(0, _diversity3TwoToneDefault.default));
parcelHelpers.export(exports, "Dns", ()=>(0, _dnsDefault.default));
parcelHelpers.export(exports, "DnsOutlined", ()=>(0, _dnsOutlinedDefault.default));
parcelHelpers.export(exports, "DnsRounded", ()=>(0, _dnsRoundedDefault.default));
parcelHelpers.export(exports, "DnsSharp", ()=>(0, _dnsSharpDefault.default));
parcelHelpers.export(exports, "DnsTwoTone", ()=>(0, _dnsTwoToneDefault.default));
parcelHelpers.export(exports, "DoDisturb", ()=>(0, _doDisturbDefault.default));
parcelHelpers.export(exports, "DoDisturbAlt", ()=>(0, _doDisturbAltDefault.default));
parcelHelpers.export(exports, "DoDisturbAltOutlined", ()=>(0, _doDisturbAltOutlinedDefault.default));
parcelHelpers.export(exports, "DoDisturbAltRounded", ()=>(0, _doDisturbAltRoundedDefault.default));
parcelHelpers.export(exports, "DoDisturbAltSharp", ()=>(0, _doDisturbAltSharpDefault.default));
parcelHelpers.export(exports, "DoDisturbAltTwoTone", ()=>(0, _doDisturbAltTwoToneDefault.default));
parcelHelpers.export(exports, "DoDisturbOff", ()=>(0, _doDisturbOffDefault.default));
parcelHelpers.export(exports, "DoDisturbOffOutlined", ()=>(0, _doDisturbOffOutlinedDefault.default));
parcelHelpers.export(exports, "DoDisturbOffRounded", ()=>(0, _doDisturbOffRoundedDefault.default));
parcelHelpers.export(exports, "DoDisturbOffSharp", ()=>(0, _doDisturbOffSharpDefault.default));
parcelHelpers.export(exports, "DoDisturbOffTwoTone", ()=>(0, _doDisturbOffTwoToneDefault.default));
parcelHelpers.export(exports, "DoDisturbOn", ()=>(0, _doDisturbOnDefault.default));
parcelHelpers.export(exports, "DoDisturbOnOutlined", ()=>(0, _doDisturbOnOutlinedDefault.default));
parcelHelpers.export(exports, "DoDisturbOnRounded", ()=>(0, _doDisturbOnRoundedDefault.default));
parcelHelpers.export(exports, "DoDisturbOnSharp", ()=>(0, _doDisturbOnSharpDefault.default));
parcelHelpers.export(exports, "DoDisturbOnTwoTone", ()=>(0, _doDisturbOnTwoToneDefault.default));
parcelHelpers.export(exports, "DoDisturbOutlined", ()=>(0, _doDisturbOutlinedDefault.default));
parcelHelpers.export(exports, "DoDisturbRounded", ()=>(0, _doDisturbRoundedDefault.default));
parcelHelpers.export(exports, "DoDisturbSharp", ()=>(0, _doDisturbSharpDefault.default));
parcelHelpers.export(exports, "DoDisturbTwoTone", ()=>(0, _doDisturbTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotDisturb", ()=>(0, _doNotDisturbDefault.default));
parcelHelpers.export(exports, "DoNotDisturbAlt", ()=>(0, _doNotDisturbAltDefault.default));
parcelHelpers.export(exports, "DoNotDisturbAltOutlined", ()=>(0, _doNotDisturbAltOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbAltRounded", ()=>(0, _doNotDisturbAltRoundedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbAltSharp", ()=>(0, _doNotDisturbAltSharpDefault.default));
parcelHelpers.export(exports, "DoNotDisturbAltTwoTone", ()=>(0, _doNotDisturbAltTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOff", ()=>(0, _doNotDisturbOffDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOffOutlined", ()=>(0, _doNotDisturbOffOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOffRounded", ()=>(0, _doNotDisturbOffRoundedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOffSharp", ()=>(0, _doNotDisturbOffSharpDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOffTwoTone", ()=>(0, _doNotDisturbOffTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOn", ()=>(0, _doNotDisturbOnDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnOutlined", ()=>(0, _doNotDisturbOnOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnRounded", ()=>(0, _doNotDisturbOnRoundedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnSharp", ()=>(0, _doNotDisturbOnSharpDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTotalSilence", ()=>(0, _doNotDisturbOnTotalSilenceDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTotalSilenceOutlined", ()=>(0, _doNotDisturbOnTotalSilenceOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTotalSilenceRounded", ()=>(0, _doNotDisturbOnTotalSilenceRoundedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTotalSilenceSharp", ()=>(0, _doNotDisturbOnTotalSilenceSharpDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTotalSilenceTwoTone", ()=>(0, _doNotDisturbOnTotalSilenceTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOnTwoTone", ()=>(0, _doNotDisturbOnTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotDisturbOutlined", ()=>(0, _doNotDisturbOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbRounded", ()=>(0, _doNotDisturbRoundedDefault.default));
parcelHelpers.export(exports, "DoNotDisturbSharp", ()=>(0, _doNotDisturbSharpDefault.default));
parcelHelpers.export(exports, "DoNotDisturbTwoTone", ()=>(0, _doNotDisturbTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotStep", ()=>(0, _doNotStepDefault.default));
parcelHelpers.export(exports, "DoNotStepOutlined", ()=>(0, _doNotStepOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotStepRounded", ()=>(0, _doNotStepRoundedDefault.default));
parcelHelpers.export(exports, "DoNotStepSharp", ()=>(0, _doNotStepSharpDefault.default));
parcelHelpers.export(exports, "DoNotStepTwoTone", ()=>(0, _doNotStepTwoToneDefault.default));
parcelHelpers.export(exports, "DoNotTouch", ()=>(0, _doNotTouchDefault.default));
parcelHelpers.export(exports, "DoNotTouchOutlined", ()=>(0, _doNotTouchOutlinedDefault.default));
parcelHelpers.export(exports, "DoNotTouchRounded", ()=>(0, _doNotTouchRoundedDefault.default));
parcelHelpers.export(exports, "DoNotTouchSharp", ()=>(0, _doNotTouchSharpDefault.default));
parcelHelpers.export(exports, "DoNotTouchTwoTone", ()=>(0, _doNotTouchTwoToneDefault.default));
parcelHelpers.export(exports, "Dock", ()=>(0, _dockDefault.default));
parcelHelpers.export(exports, "DockOutlined", ()=>(0, _dockOutlinedDefault.default));
parcelHelpers.export(exports, "DockRounded", ()=>(0, _dockRoundedDefault.default));
parcelHelpers.export(exports, "DockSharp", ()=>(0, _dockSharpDefault.default));
parcelHelpers.export(exports, "DockTwoTone", ()=>(0, _dockTwoToneDefault.default));
parcelHelpers.export(exports, "DocumentScanner", ()=>(0, _documentScannerDefault.default));
parcelHelpers.export(exports, "DocumentScannerOutlined", ()=>(0, _documentScannerOutlinedDefault.default));
parcelHelpers.export(exports, "DocumentScannerRounded", ()=>(0, _documentScannerRoundedDefault.default));
parcelHelpers.export(exports, "DocumentScannerSharp", ()=>(0, _documentScannerSharpDefault.default));
parcelHelpers.export(exports, "DocumentScannerTwoTone", ()=>(0, _documentScannerTwoToneDefault.default));
parcelHelpers.export(exports, "Domain", ()=>(0, _domainDefault.default));
parcelHelpers.export(exports, "DomainAdd", ()=>(0, _domainAddDefault.default));
parcelHelpers.export(exports, "DomainAddOutlined", ()=>(0, _domainAddOutlinedDefault.default));
parcelHelpers.export(exports, "DomainAddRounded", ()=>(0, _domainAddRoundedDefault.default));
parcelHelpers.export(exports, "DomainAddSharp", ()=>(0, _domainAddSharpDefault.default));
parcelHelpers.export(exports, "DomainAddTwoTone", ()=>(0, _domainAddTwoToneDefault.default));
parcelHelpers.export(exports, "DomainDisabled", ()=>(0, _domainDisabledDefault.default));
parcelHelpers.export(exports, "DomainDisabledOutlined", ()=>(0, _domainDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "DomainDisabledRounded", ()=>(0, _domainDisabledRoundedDefault.default));
parcelHelpers.export(exports, "DomainDisabledSharp", ()=>(0, _domainDisabledSharpDefault.default));
parcelHelpers.export(exports, "DomainDisabledTwoTone", ()=>(0, _domainDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "DomainOutlined", ()=>(0, _domainOutlinedDefault.default));
parcelHelpers.export(exports, "DomainRounded", ()=>(0, _domainRoundedDefault.default));
parcelHelpers.export(exports, "DomainSharp", ()=>(0, _domainSharpDefault.default));
parcelHelpers.export(exports, "DomainTwoTone", ()=>(0, _domainTwoToneDefault.default));
parcelHelpers.export(exports, "DomainVerification", ()=>(0, _domainVerificationDefault.default));
parcelHelpers.export(exports, "DomainVerificationOutlined", ()=>(0, _domainVerificationOutlinedDefault.default));
parcelHelpers.export(exports, "DomainVerificationRounded", ()=>(0, _domainVerificationRoundedDefault.default));
parcelHelpers.export(exports, "DomainVerificationSharp", ()=>(0, _domainVerificationSharpDefault.default));
parcelHelpers.export(exports, "DomainVerificationTwoTone", ()=>(0, _domainVerificationTwoToneDefault.default));
parcelHelpers.export(exports, "Done", ()=>(0, _doneDefault.default));
parcelHelpers.export(exports, "DoneAll", ()=>(0, _doneAllDefault.default));
parcelHelpers.export(exports, "DoneAllOutlined", ()=>(0, _doneAllOutlinedDefault.default));
parcelHelpers.export(exports, "DoneAllRounded", ()=>(0, _doneAllRoundedDefault.default));
parcelHelpers.export(exports, "DoneAllSharp", ()=>(0, _doneAllSharpDefault.default));
parcelHelpers.export(exports, "DoneAllTwoTone", ()=>(0, _doneAllTwoToneDefault.default));
parcelHelpers.export(exports, "DoneOutline", ()=>(0, _doneOutlineDefault.default));
parcelHelpers.export(exports, "DoneOutlineOutlined", ()=>(0, _doneOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "DoneOutlineRounded", ()=>(0, _doneOutlineRoundedDefault.default));
parcelHelpers.export(exports, "DoneOutlineSharp", ()=>(0, _doneOutlineSharpDefault.default));
parcelHelpers.export(exports, "DoneOutlineTwoTone", ()=>(0, _doneOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "DoneOutlined", ()=>(0, _doneOutlinedDefault.default));
parcelHelpers.export(exports, "DoneRounded", ()=>(0, _doneRoundedDefault.default));
parcelHelpers.export(exports, "DoneSharp", ()=>(0, _doneSharpDefault.default));
parcelHelpers.export(exports, "DoneTwoTone", ()=>(0, _doneTwoToneDefault.default));
parcelHelpers.export(exports, "DonutLarge", ()=>(0, _donutLargeDefault.default));
parcelHelpers.export(exports, "DonutLargeOutlined", ()=>(0, _donutLargeOutlinedDefault.default));
parcelHelpers.export(exports, "DonutLargeRounded", ()=>(0, _donutLargeRoundedDefault.default));
parcelHelpers.export(exports, "DonutLargeSharp", ()=>(0, _donutLargeSharpDefault.default));
parcelHelpers.export(exports, "DonutLargeTwoTone", ()=>(0, _donutLargeTwoToneDefault.default));
parcelHelpers.export(exports, "DonutSmall", ()=>(0, _donutSmallDefault.default));
parcelHelpers.export(exports, "DonutSmallOutlined", ()=>(0, _donutSmallOutlinedDefault.default));
parcelHelpers.export(exports, "DonutSmallRounded", ()=>(0, _donutSmallRoundedDefault.default));
parcelHelpers.export(exports, "DonutSmallSharp", ()=>(0, _donutSmallSharpDefault.default));
parcelHelpers.export(exports, "DonutSmallTwoTone", ()=>(0, _donutSmallTwoToneDefault.default));
parcelHelpers.export(exports, "DoorBack", ()=>(0, _doorBackDefault.default));
parcelHelpers.export(exports, "DoorBackOutlined", ()=>(0, _doorBackOutlinedDefault.default));
parcelHelpers.export(exports, "DoorBackRounded", ()=>(0, _doorBackRoundedDefault.default));
parcelHelpers.export(exports, "DoorBackSharp", ()=>(0, _doorBackSharpDefault.default));
parcelHelpers.export(exports, "DoorBackTwoTone", ()=>(0, _doorBackTwoToneDefault.default));
parcelHelpers.export(exports, "DoorFront", ()=>(0, _doorFrontDefault.default));
parcelHelpers.export(exports, "DoorFrontOutlined", ()=>(0, _doorFrontOutlinedDefault.default));
parcelHelpers.export(exports, "DoorFrontRounded", ()=>(0, _doorFrontRoundedDefault.default));
parcelHelpers.export(exports, "DoorFrontSharp", ()=>(0, _doorFrontSharpDefault.default));
parcelHelpers.export(exports, "DoorFrontTwoTone", ()=>(0, _doorFrontTwoToneDefault.default));
parcelHelpers.export(exports, "DoorSliding", ()=>(0, _doorSlidingDefault.default));
parcelHelpers.export(exports, "DoorSlidingOutlined", ()=>(0, _doorSlidingOutlinedDefault.default));
parcelHelpers.export(exports, "DoorSlidingRounded", ()=>(0, _doorSlidingRoundedDefault.default));
parcelHelpers.export(exports, "DoorSlidingSharp", ()=>(0, _doorSlidingSharpDefault.default));
parcelHelpers.export(exports, "DoorSlidingTwoTone", ()=>(0, _doorSlidingTwoToneDefault.default));
parcelHelpers.export(exports, "Doorbell", ()=>(0, _doorbellDefault.default));
parcelHelpers.export(exports, "DoorbellOutlined", ()=>(0, _doorbellOutlinedDefault.default));
parcelHelpers.export(exports, "DoorbellRounded", ()=>(0, _doorbellRoundedDefault.default));
parcelHelpers.export(exports, "DoorbellSharp", ()=>(0, _doorbellSharpDefault.default));
parcelHelpers.export(exports, "DoorbellTwoTone", ()=>(0, _doorbellTwoToneDefault.default));
parcelHelpers.export(exports, "DoubleArrow", ()=>(0, _doubleArrowDefault.default));
parcelHelpers.export(exports, "DoubleArrowOutlined", ()=>(0, _doubleArrowOutlinedDefault.default));
parcelHelpers.export(exports, "DoubleArrowRounded", ()=>(0, _doubleArrowRoundedDefault.default));
parcelHelpers.export(exports, "DoubleArrowSharp", ()=>(0, _doubleArrowSharpDefault.default));
parcelHelpers.export(exports, "DoubleArrowTwoTone", ()=>(0, _doubleArrowTwoToneDefault.default));
parcelHelpers.export(exports, "DownhillSkiing", ()=>(0, _downhillSkiingDefault.default));
parcelHelpers.export(exports, "DownhillSkiingOutlined", ()=>(0, _downhillSkiingOutlinedDefault.default));
parcelHelpers.export(exports, "DownhillSkiingRounded", ()=>(0, _downhillSkiingRoundedDefault.default));
parcelHelpers.export(exports, "DownhillSkiingSharp", ()=>(0, _downhillSkiingSharpDefault.default));
parcelHelpers.export(exports, "DownhillSkiingTwoTone", ()=>(0, _downhillSkiingTwoToneDefault.default));
parcelHelpers.export(exports, "Download", ()=>(0, _downloadDefault.default));
parcelHelpers.export(exports, "DownloadDone", ()=>(0, _downloadDoneDefault.default));
parcelHelpers.export(exports, "DownloadDoneOutlined", ()=>(0, _downloadDoneOutlinedDefault.default));
parcelHelpers.export(exports, "DownloadDoneRounded", ()=>(0, _downloadDoneRoundedDefault.default));
parcelHelpers.export(exports, "DownloadDoneSharp", ()=>(0, _downloadDoneSharpDefault.default));
parcelHelpers.export(exports, "DownloadDoneTwoTone", ()=>(0, _downloadDoneTwoToneDefault.default));
parcelHelpers.export(exports, "DownloadForOffline", ()=>(0, _downloadForOfflineDefault.default));
parcelHelpers.export(exports, "DownloadForOfflineOutlined", ()=>(0, _downloadForOfflineOutlinedDefault.default));
parcelHelpers.export(exports, "DownloadForOfflineRounded", ()=>(0, _downloadForOfflineRoundedDefault.default));
parcelHelpers.export(exports, "DownloadForOfflineSharp", ()=>(0, _downloadForOfflineSharpDefault.default));
parcelHelpers.export(exports, "DownloadForOfflineTwoTone", ()=>(0, _downloadForOfflineTwoToneDefault.default));
parcelHelpers.export(exports, "DownloadOutlined", ()=>(0, _downloadOutlinedDefault.default));
parcelHelpers.export(exports, "DownloadRounded", ()=>(0, _downloadRoundedDefault.default));
parcelHelpers.export(exports, "DownloadSharp", ()=>(0, _downloadSharpDefault.default));
parcelHelpers.export(exports, "DownloadTwoTone", ()=>(0, _downloadTwoToneDefault.default));
parcelHelpers.export(exports, "Downloading", ()=>(0, _downloadingDefault.default));
parcelHelpers.export(exports, "DownloadingOutlined", ()=>(0, _downloadingOutlinedDefault.default));
parcelHelpers.export(exports, "DownloadingRounded", ()=>(0, _downloadingRoundedDefault.default));
parcelHelpers.export(exports, "DownloadingSharp", ()=>(0, _downloadingSharpDefault.default));
parcelHelpers.export(exports, "DownloadingTwoTone", ()=>(0, _downloadingTwoToneDefault.default));
parcelHelpers.export(exports, "Drafts", ()=>(0, _draftsDefault.default));
parcelHelpers.export(exports, "DraftsOutlined", ()=>(0, _draftsOutlinedDefault.default));
parcelHelpers.export(exports, "DraftsRounded", ()=>(0, _draftsRoundedDefault.default));
parcelHelpers.export(exports, "DraftsSharp", ()=>(0, _draftsSharpDefault.default));
parcelHelpers.export(exports, "DraftsTwoTone", ()=>(0, _draftsTwoToneDefault.default));
parcelHelpers.export(exports, "DragHandle", ()=>(0, _dragHandleDefault.default));
parcelHelpers.export(exports, "DragHandleOutlined", ()=>(0, _dragHandleOutlinedDefault.default));
parcelHelpers.export(exports, "DragHandleRounded", ()=>(0, _dragHandleRoundedDefault.default));
parcelHelpers.export(exports, "DragHandleSharp", ()=>(0, _dragHandleSharpDefault.default));
parcelHelpers.export(exports, "DragHandleTwoTone", ()=>(0, _dragHandleTwoToneDefault.default));
parcelHelpers.export(exports, "DragIndicator", ()=>(0, _dragIndicatorDefault.default));
parcelHelpers.export(exports, "DragIndicatorOutlined", ()=>(0, _dragIndicatorOutlinedDefault.default));
parcelHelpers.export(exports, "DragIndicatorRounded", ()=>(0, _dragIndicatorRoundedDefault.default));
parcelHelpers.export(exports, "DragIndicatorSharp", ()=>(0, _dragIndicatorSharpDefault.default));
parcelHelpers.export(exports, "DragIndicatorTwoTone", ()=>(0, _dragIndicatorTwoToneDefault.default));
parcelHelpers.export(exports, "Draw", ()=>(0, _drawDefault.default));
parcelHelpers.export(exports, "DrawOutlined", ()=>(0, _drawOutlinedDefault.default));
parcelHelpers.export(exports, "DrawRounded", ()=>(0, _drawRoundedDefault.default));
parcelHelpers.export(exports, "DrawSharp", ()=>(0, _drawSharpDefault.default));
parcelHelpers.export(exports, "DrawTwoTone", ()=>(0, _drawTwoToneDefault.default));
parcelHelpers.export(exports, "DriveEta", ()=>(0, _driveEtaDefault.default));
parcelHelpers.export(exports, "DriveEtaOutlined", ()=>(0, _driveEtaOutlinedDefault.default));
parcelHelpers.export(exports, "DriveEtaRounded", ()=>(0, _driveEtaRoundedDefault.default));
parcelHelpers.export(exports, "DriveEtaSharp", ()=>(0, _driveEtaSharpDefault.default));
parcelHelpers.export(exports, "DriveEtaTwoTone", ()=>(0, _driveEtaTwoToneDefault.default));
parcelHelpers.export(exports, "DriveFileMove", ()=>(0, _driveFileMoveDefault.default));
parcelHelpers.export(exports, "DriveFileMoveOutlined", ()=>(0, _driveFileMoveOutlinedDefault.default));
parcelHelpers.export(exports, "DriveFileMoveRounded", ()=>(0, _driveFileMoveRoundedDefault.default));
parcelHelpers.export(exports, "DriveFileMoveSharp", ()=>(0, _driveFileMoveSharpDefault.default));
parcelHelpers.export(exports, "DriveFileMoveTwoTone", ()=>(0, _driveFileMoveTwoToneDefault.default));
parcelHelpers.export(exports, "DriveFileRenameOutline", ()=>(0, _driveFileRenameOutlineDefault.default));
parcelHelpers.export(exports, "DriveFileRenameOutlineOutlined", ()=>(0, _driveFileRenameOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "DriveFileRenameOutlineRounded", ()=>(0, _driveFileRenameOutlineRoundedDefault.default));
parcelHelpers.export(exports, "DriveFileRenameOutlineSharp", ()=>(0, _driveFileRenameOutlineSharpDefault.default));
parcelHelpers.export(exports, "DriveFileRenameOutlineTwoTone", ()=>(0, _driveFileRenameOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "DriveFolderUpload", ()=>(0, _driveFolderUploadDefault.default));
parcelHelpers.export(exports, "DriveFolderUploadOutlined", ()=>(0, _driveFolderUploadOutlinedDefault.default));
parcelHelpers.export(exports, "DriveFolderUploadRounded", ()=>(0, _driveFolderUploadRoundedDefault.default));
parcelHelpers.export(exports, "DriveFolderUploadSharp", ()=>(0, _driveFolderUploadSharpDefault.default));
parcelHelpers.export(exports, "DriveFolderUploadTwoTone", ()=>(0, _driveFolderUploadTwoToneDefault.default));
parcelHelpers.export(exports, "Dry", ()=>(0, _dryDefault.default));
parcelHelpers.export(exports, "DryCleaning", ()=>(0, _dryCleaningDefault.default));
parcelHelpers.export(exports, "DryCleaningOutlined", ()=>(0, _dryCleaningOutlinedDefault.default));
parcelHelpers.export(exports, "DryCleaningRounded", ()=>(0, _dryCleaningRoundedDefault.default));
parcelHelpers.export(exports, "DryCleaningSharp", ()=>(0, _dryCleaningSharpDefault.default));
parcelHelpers.export(exports, "DryCleaningTwoTone", ()=>(0, _dryCleaningTwoToneDefault.default));
parcelHelpers.export(exports, "DryOutlined", ()=>(0, _dryOutlinedDefault.default));
parcelHelpers.export(exports, "DryRounded", ()=>(0, _dryRoundedDefault.default));
parcelHelpers.export(exports, "DrySharp", ()=>(0, _drySharpDefault.default));
parcelHelpers.export(exports, "DryTwoTone", ()=>(0, _dryTwoToneDefault.default));
parcelHelpers.export(exports, "Duo", ()=>(0, _duoDefault.default));
parcelHelpers.export(exports, "DuoOutlined", ()=>(0, _duoOutlinedDefault.default));
parcelHelpers.export(exports, "DuoRounded", ()=>(0, _duoRoundedDefault.default));
parcelHelpers.export(exports, "DuoSharp", ()=>(0, _duoSharpDefault.default));
parcelHelpers.export(exports, "DuoTwoTone", ()=>(0, _duoTwoToneDefault.default));
parcelHelpers.export(exports, "Dvr", ()=>(0, _dvrDefault.default));
parcelHelpers.export(exports, "DvrOutlined", ()=>(0, _dvrOutlinedDefault.default));
parcelHelpers.export(exports, "DvrRounded", ()=>(0, _dvrRoundedDefault.default));
parcelHelpers.export(exports, "DvrSharp", ()=>(0, _dvrSharpDefault.default));
parcelHelpers.export(exports, "DvrTwoTone", ()=>(0, _dvrTwoToneDefault.default));
parcelHelpers.export(exports, "DynamicFeed", ()=>(0, _dynamicFeedDefault.default));
parcelHelpers.export(exports, "DynamicFeedOutlined", ()=>(0, _dynamicFeedOutlinedDefault.default));
parcelHelpers.export(exports, "DynamicFeedRounded", ()=>(0, _dynamicFeedRoundedDefault.default));
parcelHelpers.export(exports, "DynamicFeedSharp", ()=>(0, _dynamicFeedSharpDefault.default));
parcelHelpers.export(exports, "DynamicFeedTwoTone", ()=>(0, _dynamicFeedTwoToneDefault.default));
parcelHelpers.export(exports, "DynamicForm", ()=>(0, _dynamicFormDefault.default));
parcelHelpers.export(exports, "DynamicFormOutlined", ()=>(0, _dynamicFormOutlinedDefault.default));
parcelHelpers.export(exports, "DynamicFormRounded", ()=>(0, _dynamicFormRoundedDefault.default));
parcelHelpers.export(exports, "DynamicFormSharp", ()=>(0, _dynamicFormSharpDefault.default));
parcelHelpers.export(exports, "DynamicFormTwoTone", ()=>(0, _dynamicFormTwoToneDefault.default));
parcelHelpers.export(exports, "EMobiledata", ()=>(0, _emobiledataDefault.default));
parcelHelpers.export(exports, "EMobiledataOutlined", ()=>(0, _emobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "EMobiledataRounded", ()=>(0, _emobiledataRoundedDefault.default));
parcelHelpers.export(exports, "EMobiledataSharp", ()=>(0, _emobiledataSharpDefault.default));
parcelHelpers.export(exports, "EMobiledataTwoTone", ()=>(0, _emobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "Earbuds", ()=>(0, _earbudsDefault.default));
parcelHelpers.export(exports, "EarbudsBattery", ()=>(0, _earbudsBatteryDefault.default));
parcelHelpers.export(exports, "EarbudsBatteryOutlined", ()=>(0, _earbudsBatteryOutlinedDefault.default));
parcelHelpers.export(exports, "EarbudsBatteryRounded", ()=>(0, _earbudsBatteryRoundedDefault.default));
parcelHelpers.export(exports, "EarbudsBatterySharp", ()=>(0, _earbudsBatterySharpDefault.default));
parcelHelpers.export(exports, "EarbudsBatteryTwoTone", ()=>(0, _earbudsBatteryTwoToneDefault.default));
parcelHelpers.export(exports, "EarbudsOutlined", ()=>(0, _earbudsOutlinedDefault.default));
parcelHelpers.export(exports, "EarbudsRounded", ()=>(0, _earbudsRoundedDefault.default));
parcelHelpers.export(exports, "EarbudsSharp", ()=>(0, _earbudsSharpDefault.default));
parcelHelpers.export(exports, "EarbudsTwoTone", ()=>(0, _earbudsTwoToneDefault.default));
parcelHelpers.export(exports, "East", ()=>(0, _eastDefault.default));
parcelHelpers.export(exports, "EastOutlined", ()=>(0, _eastOutlinedDefault.default));
parcelHelpers.export(exports, "EastRounded", ()=>(0, _eastRoundedDefault.default));
parcelHelpers.export(exports, "EastSharp", ()=>(0, _eastSharpDefault.default));
parcelHelpers.export(exports, "EastTwoTone", ()=>(0, _eastTwoToneDefault.default));
parcelHelpers.export(exports, "EdgesensorHigh", ()=>(0, _edgesensorHighDefault.default));
parcelHelpers.export(exports, "EdgesensorHighOutlined", ()=>(0, _edgesensorHighOutlinedDefault.default));
parcelHelpers.export(exports, "EdgesensorHighRounded", ()=>(0, _edgesensorHighRoundedDefault.default));
parcelHelpers.export(exports, "EdgesensorHighSharp", ()=>(0, _edgesensorHighSharpDefault.default));
parcelHelpers.export(exports, "EdgesensorHighTwoTone", ()=>(0, _edgesensorHighTwoToneDefault.default));
parcelHelpers.export(exports, "EdgesensorLow", ()=>(0, _edgesensorLowDefault.default));
parcelHelpers.export(exports, "EdgesensorLowOutlined", ()=>(0, _edgesensorLowOutlinedDefault.default));
parcelHelpers.export(exports, "EdgesensorLowRounded", ()=>(0, _edgesensorLowRoundedDefault.default));
parcelHelpers.export(exports, "EdgesensorLowSharp", ()=>(0, _edgesensorLowSharpDefault.default));
parcelHelpers.export(exports, "EdgesensorLowTwoTone", ()=>(0, _edgesensorLowTwoToneDefault.default));
parcelHelpers.export(exports, "Edit", ()=>(0, _editDefault.default));
parcelHelpers.export(exports, "EditAttributes", ()=>(0, _editAttributesDefault.default));
parcelHelpers.export(exports, "EditAttributesOutlined", ()=>(0, _editAttributesOutlinedDefault.default));
parcelHelpers.export(exports, "EditAttributesRounded", ()=>(0, _editAttributesRoundedDefault.default));
parcelHelpers.export(exports, "EditAttributesSharp", ()=>(0, _editAttributesSharpDefault.default));
parcelHelpers.export(exports, "EditAttributesTwoTone", ()=>(0, _editAttributesTwoToneDefault.default));
parcelHelpers.export(exports, "EditCalendar", ()=>(0, _editCalendarDefault.default));
parcelHelpers.export(exports, "EditCalendarOutlined", ()=>(0, _editCalendarOutlinedDefault.default));
parcelHelpers.export(exports, "EditCalendarRounded", ()=>(0, _editCalendarRoundedDefault.default));
parcelHelpers.export(exports, "EditCalendarSharp", ()=>(0, _editCalendarSharpDefault.default));
parcelHelpers.export(exports, "EditCalendarTwoTone", ()=>(0, _editCalendarTwoToneDefault.default));
parcelHelpers.export(exports, "EditLocation", ()=>(0, _editLocationDefault.default));
parcelHelpers.export(exports, "EditLocationAlt", ()=>(0, _editLocationAltDefault.default));
parcelHelpers.export(exports, "EditLocationAltOutlined", ()=>(0, _editLocationAltOutlinedDefault.default));
parcelHelpers.export(exports, "EditLocationAltRounded", ()=>(0, _editLocationAltRoundedDefault.default));
parcelHelpers.export(exports, "EditLocationAltSharp", ()=>(0, _editLocationAltSharpDefault.default));
parcelHelpers.export(exports, "EditLocationAltTwoTone", ()=>(0, _editLocationAltTwoToneDefault.default));
parcelHelpers.export(exports, "EditLocationOutlined", ()=>(0, _editLocationOutlinedDefault.default));
parcelHelpers.export(exports, "EditLocationRounded", ()=>(0, _editLocationRoundedDefault.default));
parcelHelpers.export(exports, "EditLocationSharp", ()=>(0, _editLocationSharpDefault.default));
parcelHelpers.export(exports, "EditLocationTwoTone", ()=>(0, _editLocationTwoToneDefault.default));
parcelHelpers.export(exports, "EditNote", ()=>(0, _editNoteDefault.default));
parcelHelpers.export(exports, "EditNoteOutlined", ()=>(0, _editNoteOutlinedDefault.default));
parcelHelpers.export(exports, "EditNoteRounded", ()=>(0, _editNoteRoundedDefault.default));
parcelHelpers.export(exports, "EditNoteSharp", ()=>(0, _editNoteSharpDefault.default));
parcelHelpers.export(exports, "EditNoteTwoTone", ()=>(0, _editNoteTwoToneDefault.default));
parcelHelpers.export(exports, "EditNotifications", ()=>(0, _editNotificationsDefault.default));
parcelHelpers.export(exports, "EditNotificationsOutlined", ()=>(0, _editNotificationsOutlinedDefault.default));
parcelHelpers.export(exports, "EditNotificationsRounded", ()=>(0, _editNotificationsRoundedDefault.default));
parcelHelpers.export(exports, "EditNotificationsSharp", ()=>(0, _editNotificationsSharpDefault.default));
parcelHelpers.export(exports, "EditNotificationsTwoTone", ()=>(0, _editNotificationsTwoToneDefault.default));
parcelHelpers.export(exports, "EditOff", ()=>(0, _editOffDefault.default));
parcelHelpers.export(exports, "EditOffOutlined", ()=>(0, _editOffOutlinedDefault.default));
parcelHelpers.export(exports, "EditOffRounded", ()=>(0, _editOffRoundedDefault.default));
parcelHelpers.export(exports, "EditOffSharp", ()=>(0, _editOffSharpDefault.default));
parcelHelpers.export(exports, "EditOffTwoTone", ()=>(0, _editOffTwoToneDefault.default));
parcelHelpers.export(exports, "EditOutlined", ()=>(0, _editOutlinedDefault.default));
parcelHelpers.export(exports, "EditRoad", ()=>(0, _editRoadDefault.default));
parcelHelpers.export(exports, "EditRoadOutlined", ()=>(0, _editRoadOutlinedDefault.default));
parcelHelpers.export(exports, "EditRoadRounded", ()=>(0, _editRoadRoundedDefault.default));
parcelHelpers.export(exports, "EditRoadSharp", ()=>(0, _editRoadSharpDefault.default));
parcelHelpers.export(exports, "EditRoadTwoTone", ()=>(0, _editRoadTwoToneDefault.default));
parcelHelpers.export(exports, "EditRounded", ()=>(0, _editRoundedDefault.default));
parcelHelpers.export(exports, "EditSharp", ()=>(0, _editSharpDefault.default));
parcelHelpers.export(exports, "EditTwoTone", ()=>(0, _editTwoToneDefault.default));
parcelHelpers.export(exports, "Egg", ()=>(0, _eggDefault.default));
parcelHelpers.export(exports, "EggAlt", ()=>(0, _eggAltDefault.default));
parcelHelpers.export(exports, "EggAltOutlined", ()=>(0, _eggAltOutlinedDefault.default));
parcelHelpers.export(exports, "EggAltRounded", ()=>(0, _eggAltRoundedDefault.default));
parcelHelpers.export(exports, "EggAltSharp", ()=>(0, _eggAltSharpDefault.default));
parcelHelpers.export(exports, "EggAltTwoTone", ()=>(0, _eggAltTwoToneDefault.default));
parcelHelpers.export(exports, "EggOutlined", ()=>(0, _eggOutlinedDefault.default));
parcelHelpers.export(exports, "EggRounded", ()=>(0, _eggRoundedDefault.default));
parcelHelpers.export(exports, "EggSharp", ()=>(0, _eggSharpDefault.default));
parcelHelpers.export(exports, "EggTwoTone", ()=>(0, _eggTwoToneDefault.default));
parcelHelpers.export(exports, "EightK", ()=>(0, _eightKDefault.default));
parcelHelpers.export(exports, "EightKOutlined", ()=>(0, _eightKOutlinedDefault.default));
parcelHelpers.export(exports, "EightKPlus", ()=>(0, _eightKPlusDefault.default));
parcelHelpers.export(exports, "EightKPlusOutlined", ()=>(0, _eightKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "EightKPlusRounded", ()=>(0, _eightKPlusRoundedDefault.default));
parcelHelpers.export(exports, "EightKPlusSharp", ()=>(0, _eightKPlusSharpDefault.default));
parcelHelpers.export(exports, "EightKPlusTwoTone", ()=>(0, _eightKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "EightKRounded", ()=>(0, _eightKRoundedDefault.default));
parcelHelpers.export(exports, "EightKSharp", ()=>(0, _eightKSharpDefault.default));
parcelHelpers.export(exports, "EightKTwoTone", ()=>(0, _eightKTwoToneDefault.default));
parcelHelpers.export(exports, "EightMp", ()=>(0, _eightMpDefault.default));
parcelHelpers.export(exports, "EightMpOutlined", ()=>(0, _eightMpOutlinedDefault.default));
parcelHelpers.export(exports, "EightMpRounded", ()=>(0, _eightMpRoundedDefault.default));
parcelHelpers.export(exports, "EightMpSharp", ()=>(0, _eightMpSharpDefault.default));
parcelHelpers.export(exports, "EightMpTwoTone", ()=>(0, _eightMpTwoToneDefault.default));
parcelHelpers.export(exports, "EighteenMp", ()=>(0, _eighteenMpDefault.default));
parcelHelpers.export(exports, "EighteenMpOutlined", ()=>(0, _eighteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "EighteenMpRounded", ()=>(0, _eighteenMpRoundedDefault.default));
parcelHelpers.export(exports, "EighteenMpSharp", ()=>(0, _eighteenMpSharpDefault.default));
parcelHelpers.export(exports, "EighteenMpTwoTone", ()=>(0, _eighteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "EighteenUpRating", ()=>(0, _eighteenUpRatingDefault.default));
parcelHelpers.export(exports, "EighteenUpRatingOutlined", ()=>(0, _eighteenUpRatingOutlinedDefault.default));
parcelHelpers.export(exports, "EighteenUpRatingRounded", ()=>(0, _eighteenUpRatingRoundedDefault.default));
parcelHelpers.export(exports, "EighteenUpRatingSharp", ()=>(0, _eighteenUpRatingSharpDefault.default));
parcelHelpers.export(exports, "EighteenUpRatingTwoTone", ()=>(0, _eighteenUpRatingTwoToneDefault.default));
parcelHelpers.export(exports, "EightteenMp", ()=>(0, _eightteenMpDefault.default));
parcelHelpers.export(exports, "EightteenMpOutlined", ()=>(0, _eightteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "EightteenMpRounded", ()=>(0, _eightteenMpRoundedDefault.default));
parcelHelpers.export(exports, "EightteenMpSharp", ()=>(0, _eightteenMpSharpDefault.default));
parcelHelpers.export(exports, "EightteenMpTwoTone", ()=>(0, _eightteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "Eject", ()=>(0, _ejectDefault.default));
parcelHelpers.export(exports, "EjectOutlined", ()=>(0, _ejectOutlinedDefault.default));
parcelHelpers.export(exports, "EjectRounded", ()=>(0, _ejectRoundedDefault.default));
parcelHelpers.export(exports, "EjectSharp", ()=>(0, _ejectSharpDefault.default));
parcelHelpers.export(exports, "EjectTwoTone", ()=>(0, _ejectTwoToneDefault.default));
parcelHelpers.export(exports, "Elderly", ()=>(0, _elderlyDefault.default));
parcelHelpers.export(exports, "ElderlyOutlined", ()=>(0, _elderlyOutlinedDefault.default));
parcelHelpers.export(exports, "ElderlyRounded", ()=>(0, _elderlyRoundedDefault.default));
parcelHelpers.export(exports, "ElderlySharp", ()=>(0, _elderlySharpDefault.default));
parcelHelpers.export(exports, "ElderlyTwoTone", ()=>(0, _elderlyTwoToneDefault.default));
parcelHelpers.export(exports, "ElderlyWoman", ()=>(0, _elderlyWomanDefault.default));
parcelHelpers.export(exports, "ElderlyWomanOutlined", ()=>(0, _elderlyWomanOutlinedDefault.default));
parcelHelpers.export(exports, "ElderlyWomanRounded", ()=>(0, _elderlyWomanRoundedDefault.default));
parcelHelpers.export(exports, "ElderlyWomanSharp", ()=>(0, _elderlyWomanSharpDefault.default));
parcelHelpers.export(exports, "ElderlyWomanTwoTone", ()=>(0, _elderlyWomanTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricBike", ()=>(0, _electricBikeDefault.default));
parcelHelpers.export(exports, "ElectricBikeOutlined", ()=>(0, _electricBikeOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricBikeRounded", ()=>(0, _electricBikeRoundedDefault.default));
parcelHelpers.export(exports, "ElectricBikeSharp", ()=>(0, _electricBikeSharpDefault.default));
parcelHelpers.export(exports, "ElectricBikeTwoTone", ()=>(0, _electricBikeTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricBolt", ()=>(0, _electricBoltDefault.default));
parcelHelpers.export(exports, "ElectricBoltOutlined", ()=>(0, _electricBoltOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricBoltRounded", ()=>(0, _electricBoltRoundedDefault.default));
parcelHelpers.export(exports, "ElectricBoltSharp", ()=>(0, _electricBoltSharpDefault.default));
parcelHelpers.export(exports, "ElectricBoltTwoTone", ()=>(0, _electricBoltTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricCar", ()=>(0, _electricCarDefault.default));
parcelHelpers.export(exports, "ElectricCarOutlined", ()=>(0, _electricCarOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricCarRounded", ()=>(0, _electricCarRoundedDefault.default));
parcelHelpers.export(exports, "ElectricCarSharp", ()=>(0, _electricCarSharpDefault.default));
parcelHelpers.export(exports, "ElectricCarTwoTone", ()=>(0, _electricCarTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricMeter", ()=>(0, _electricMeterDefault.default));
parcelHelpers.export(exports, "ElectricMeterOutlined", ()=>(0, _electricMeterOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricMeterRounded", ()=>(0, _electricMeterRoundedDefault.default));
parcelHelpers.export(exports, "ElectricMeterSharp", ()=>(0, _electricMeterSharpDefault.default));
parcelHelpers.export(exports, "ElectricMeterTwoTone", ()=>(0, _electricMeterTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricMoped", ()=>(0, _electricMopedDefault.default));
parcelHelpers.export(exports, "ElectricMopedOutlined", ()=>(0, _electricMopedOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricMopedRounded", ()=>(0, _electricMopedRoundedDefault.default));
parcelHelpers.export(exports, "ElectricMopedSharp", ()=>(0, _electricMopedSharpDefault.default));
parcelHelpers.export(exports, "ElectricMopedTwoTone", ()=>(0, _electricMopedTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricRickshaw", ()=>(0, _electricRickshawDefault.default));
parcelHelpers.export(exports, "ElectricRickshawOutlined", ()=>(0, _electricRickshawOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricRickshawRounded", ()=>(0, _electricRickshawRoundedDefault.default));
parcelHelpers.export(exports, "ElectricRickshawSharp", ()=>(0, _electricRickshawSharpDefault.default));
parcelHelpers.export(exports, "ElectricRickshawTwoTone", ()=>(0, _electricRickshawTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricScooter", ()=>(0, _electricScooterDefault.default));
parcelHelpers.export(exports, "ElectricScooterOutlined", ()=>(0, _electricScooterOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricScooterRounded", ()=>(0, _electricScooterRoundedDefault.default));
parcelHelpers.export(exports, "ElectricScooterSharp", ()=>(0, _electricScooterSharpDefault.default));
parcelHelpers.export(exports, "ElectricScooterTwoTone", ()=>(0, _electricScooterTwoToneDefault.default));
parcelHelpers.export(exports, "ElectricalServices", ()=>(0, _electricalServicesDefault.default));
parcelHelpers.export(exports, "ElectricalServicesOutlined", ()=>(0, _electricalServicesOutlinedDefault.default));
parcelHelpers.export(exports, "ElectricalServicesRounded", ()=>(0, _electricalServicesRoundedDefault.default));
parcelHelpers.export(exports, "ElectricalServicesSharp", ()=>(0, _electricalServicesSharpDefault.default));
parcelHelpers.export(exports, "ElectricalServicesTwoTone", ()=>(0, _electricalServicesTwoToneDefault.default));
parcelHelpers.export(exports, "Elevator", ()=>(0, _elevatorDefault.default));
parcelHelpers.export(exports, "ElevatorOutlined", ()=>(0, _elevatorOutlinedDefault.default));
parcelHelpers.export(exports, "ElevatorRounded", ()=>(0, _elevatorRoundedDefault.default));
parcelHelpers.export(exports, "ElevatorSharp", ()=>(0, _elevatorSharpDefault.default));
parcelHelpers.export(exports, "ElevatorTwoTone", ()=>(0, _elevatorTwoToneDefault.default));
parcelHelpers.export(exports, "ElevenMp", ()=>(0, _elevenMpDefault.default));
parcelHelpers.export(exports, "ElevenMpOutlined", ()=>(0, _elevenMpOutlinedDefault.default));
parcelHelpers.export(exports, "ElevenMpRounded", ()=>(0, _elevenMpRoundedDefault.default));
parcelHelpers.export(exports, "ElevenMpSharp", ()=>(0, _elevenMpSharpDefault.default));
parcelHelpers.export(exports, "ElevenMpTwoTone", ()=>(0, _elevenMpTwoToneDefault.default));
parcelHelpers.export(exports, "Email", ()=>(0, _emailDefault.default));
parcelHelpers.export(exports, "EmailOutlined", ()=>(0, _emailOutlinedDefault.default));
parcelHelpers.export(exports, "EmailRounded", ()=>(0, _emailRoundedDefault.default));
parcelHelpers.export(exports, "EmailSharp", ()=>(0, _emailSharpDefault.default));
parcelHelpers.export(exports, "EmailTwoTone", ()=>(0, _emailTwoToneDefault.default));
parcelHelpers.export(exports, "EmergencyRecording", ()=>(0, _emergencyRecordingDefault.default));
parcelHelpers.export(exports, "EmergencyRecordingOutlined", ()=>(0, _emergencyRecordingOutlinedDefault.default));
parcelHelpers.export(exports, "EmergencyRecordingRounded", ()=>(0, _emergencyRecordingRoundedDefault.default));
parcelHelpers.export(exports, "EmergencyRecordingSharp", ()=>(0, _emergencyRecordingSharpDefault.default));
parcelHelpers.export(exports, "EmergencyRecordingTwoTone", ()=>(0, _emergencyRecordingTwoToneDefault.default));
parcelHelpers.export(exports, "EmergencyShare", ()=>(0, _emergencyShareDefault.default));
parcelHelpers.export(exports, "EmergencyShareOutlined", ()=>(0, _emergencyShareOutlinedDefault.default));
parcelHelpers.export(exports, "EmergencyShareRounded", ()=>(0, _emergencyShareRoundedDefault.default));
parcelHelpers.export(exports, "EmergencyShareSharp", ()=>(0, _emergencyShareSharpDefault.default));
parcelHelpers.export(exports, "EmergencyShareTwoTone", ()=>(0, _emergencyShareTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiEmotions", ()=>(0, _emojiEmotionsDefault.default));
parcelHelpers.export(exports, "EmojiEmotionsOutlined", ()=>(0, _emojiEmotionsOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiEmotionsRounded", ()=>(0, _emojiEmotionsRoundedDefault.default));
parcelHelpers.export(exports, "EmojiEmotionsSharp", ()=>(0, _emojiEmotionsSharpDefault.default));
parcelHelpers.export(exports, "EmojiEmotionsTwoTone", ()=>(0, _emojiEmotionsTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiEvents", ()=>(0, _emojiEventsDefault.default));
parcelHelpers.export(exports, "EmojiEventsOutlined", ()=>(0, _emojiEventsOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiEventsRounded", ()=>(0, _emojiEventsRoundedDefault.default));
parcelHelpers.export(exports, "EmojiEventsSharp", ()=>(0, _emojiEventsSharpDefault.default));
parcelHelpers.export(exports, "EmojiEventsTwoTone", ()=>(0, _emojiEventsTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiFlags", ()=>(0, _emojiFlagsDefault.default));
parcelHelpers.export(exports, "EmojiFlagsOutlined", ()=>(0, _emojiFlagsOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiFlagsRounded", ()=>(0, _emojiFlagsRoundedDefault.default));
parcelHelpers.export(exports, "EmojiFlagsSharp", ()=>(0, _emojiFlagsSharpDefault.default));
parcelHelpers.export(exports, "EmojiFlagsTwoTone", ()=>(0, _emojiFlagsTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiFoodBeverage", ()=>(0, _emojiFoodBeverageDefault.default));
parcelHelpers.export(exports, "EmojiFoodBeverageOutlined", ()=>(0, _emojiFoodBeverageOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiFoodBeverageRounded", ()=>(0, _emojiFoodBeverageRoundedDefault.default));
parcelHelpers.export(exports, "EmojiFoodBeverageSharp", ()=>(0, _emojiFoodBeverageSharpDefault.default));
parcelHelpers.export(exports, "EmojiFoodBeverageTwoTone", ()=>(0, _emojiFoodBeverageTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiNature", ()=>(0, _emojiNatureDefault.default));
parcelHelpers.export(exports, "EmojiNatureOutlined", ()=>(0, _emojiNatureOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiNatureRounded", ()=>(0, _emojiNatureRoundedDefault.default));
parcelHelpers.export(exports, "EmojiNatureSharp", ()=>(0, _emojiNatureSharpDefault.default));
parcelHelpers.export(exports, "EmojiNatureTwoTone", ()=>(0, _emojiNatureTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiObjects", ()=>(0, _emojiObjectsDefault.default));
parcelHelpers.export(exports, "EmojiObjectsOutlined", ()=>(0, _emojiObjectsOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiObjectsRounded", ()=>(0, _emojiObjectsRoundedDefault.default));
parcelHelpers.export(exports, "EmojiObjectsSharp", ()=>(0, _emojiObjectsSharpDefault.default));
parcelHelpers.export(exports, "EmojiObjectsTwoTone", ()=>(0, _emojiObjectsTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiPeople", ()=>(0, _emojiPeopleDefault.default));
parcelHelpers.export(exports, "EmojiPeopleOutlined", ()=>(0, _emojiPeopleOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiPeopleRounded", ()=>(0, _emojiPeopleRoundedDefault.default));
parcelHelpers.export(exports, "EmojiPeopleSharp", ()=>(0, _emojiPeopleSharpDefault.default));
parcelHelpers.export(exports, "EmojiPeopleTwoTone", ()=>(0, _emojiPeopleTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiSymbols", ()=>(0, _emojiSymbolsDefault.default));
parcelHelpers.export(exports, "EmojiSymbolsOutlined", ()=>(0, _emojiSymbolsOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiSymbolsRounded", ()=>(0, _emojiSymbolsRoundedDefault.default));
parcelHelpers.export(exports, "EmojiSymbolsSharp", ()=>(0, _emojiSymbolsSharpDefault.default));
parcelHelpers.export(exports, "EmojiSymbolsTwoTone", ()=>(0, _emojiSymbolsTwoToneDefault.default));
parcelHelpers.export(exports, "EmojiTransportation", ()=>(0, _emojiTransportationDefault.default));
parcelHelpers.export(exports, "EmojiTransportationOutlined", ()=>(0, _emojiTransportationOutlinedDefault.default));
parcelHelpers.export(exports, "EmojiTransportationRounded", ()=>(0, _emojiTransportationRoundedDefault.default));
parcelHelpers.export(exports, "EmojiTransportationSharp", ()=>(0, _emojiTransportationSharpDefault.default));
parcelHelpers.export(exports, "EmojiTransportationTwoTone", ()=>(0, _emojiTransportationTwoToneDefault.default));
parcelHelpers.export(exports, "EnergySavingsLeaf", ()=>(0, _energySavingsLeafDefault.default));
parcelHelpers.export(exports, "EnergySavingsLeafOutlined", ()=>(0, _energySavingsLeafOutlinedDefault.default));
parcelHelpers.export(exports, "EnergySavingsLeafRounded", ()=>(0, _energySavingsLeafRoundedDefault.default));
parcelHelpers.export(exports, "EnergySavingsLeafSharp", ()=>(0, _energySavingsLeafSharpDefault.default));
parcelHelpers.export(exports, "EnergySavingsLeafTwoTone", ()=>(0, _energySavingsLeafTwoToneDefault.default));
parcelHelpers.export(exports, "Engineering", ()=>(0, _engineeringDefault.default));
parcelHelpers.export(exports, "EngineeringOutlined", ()=>(0, _engineeringOutlinedDefault.default));
parcelHelpers.export(exports, "EngineeringRounded", ()=>(0, _engineeringRoundedDefault.default));
parcelHelpers.export(exports, "EngineeringSharp", ()=>(0, _engineeringSharpDefault.default));
parcelHelpers.export(exports, "EngineeringTwoTone", ()=>(0, _engineeringTwoToneDefault.default));
parcelHelpers.export(exports, "EnhancedEncryption", ()=>(0, _enhancedEncryptionDefault.default));
parcelHelpers.export(exports, "EnhancedEncryptionOutlined", ()=>(0, _enhancedEncryptionOutlinedDefault.default));
parcelHelpers.export(exports, "EnhancedEncryptionRounded", ()=>(0, _enhancedEncryptionRoundedDefault.default));
parcelHelpers.export(exports, "EnhancedEncryptionSharp", ()=>(0, _enhancedEncryptionSharpDefault.default));
parcelHelpers.export(exports, "EnhancedEncryptionTwoTone", ()=>(0, _enhancedEncryptionTwoToneDefault.default));
parcelHelpers.export(exports, "Equalizer", ()=>(0, _equalizerDefault.default));
parcelHelpers.export(exports, "EqualizerOutlined", ()=>(0, _equalizerOutlinedDefault.default));
parcelHelpers.export(exports, "EqualizerRounded", ()=>(0, _equalizerRoundedDefault.default));
parcelHelpers.export(exports, "EqualizerSharp", ()=>(0, _equalizerSharpDefault.default));
parcelHelpers.export(exports, "EqualizerTwoTone", ()=>(0, _equalizerTwoToneDefault.default));
parcelHelpers.export(exports, "Error", ()=>(0, _errorDefault.default));
parcelHelpers.export(exports, "ErrorOutline", ()=>(0, _errorOutlineDefault.default));
parcelHelpers.export(exports, "ErrorOutlineOutlined", ()=>(0, _errorOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "ErrorOutlineRounded", ()=>(0, _errorOutlineRoundedDefault.default));
parcelHelpers.export(exports, "ErrorOutlineSharp", ()=>(0, _errorOutlineSharpDefault.default));
parcelHelpers.export(exports, "ErrorOutlineTwoTone", ()=>(0, _errorOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "ErrorOutlined", ()=>(0, _errorOutlinedDefault.default));
parcelHelpers.export(exports, "ErrorRounded", ()=>(0, _errorRoundedDefault.default));
parcelHelpers.export(exports, "ErrorSharp", ()=>(0, _errorSharpDefault.default));
parcelHelpers.export(exports, "ErrorTwoTone", ()=>(0, _errorTwoToneDefault.default));
parcelHelpers.export(exports, "Escalator", ()=>(0, _escalatorDefault.default));
parcelHelpers.export(exports, "EscalatorOutlined", ()=>(0, _escalatorOutlinedDefault.default));
parcelHelpers.export(exports, "EscalatorRounded", ()=>(0, _escalatorRoundedDefault.default));
parcelHelpers.export(exports, "EscalatorSharp", ()=>(0, _escalatorSharpDefault.default));
parcelHelpers.export(exports, "EscalatorTwoTone", ()=>(0, _escalatorTwoToneDefault.default));
parcelHelpers.export(exports, "EscalatorWarning", ()=>(0, _escalatorWarningDefault.default));
parcelHelpers.export(exports, "EscalatorWarningOutlined", ()=>(0, _escalatorWarningOutlinedDefault.default));
parcelHelpers.export(exports, "EscalatorWarningRounded", ()=>(0, _escalatorWarningRoundedDefault.default));
parcelHelpers.export(exports, "EscalatorWarningSharp", ()=>(0, _escalatorWarningSharpDefault.default));
parcelHelpers.export(exports, "EscalatorWarningTwoTone", ()=>(0, _escalatorWarningTwoToneDefault.default));
parcelHelpers.export(exports, "Euro", ()=>(0, _euroDefault.default));
parcelHelpers.export(exports, "EuroOutlined", ()=>(0, _euroOutlinedDefault.default));
parcelHelpers.export(exports, "EuroRounded", ()=>(0, _euroRoundedDefault.default));
parcelHelpers.export(exports, "EuroSharp", ()=>(0, _euroSharpDefault.default));
parcelHelpers.export(exports, "EuroSymbol", ()=>(0, _euroSymbolDefault.default));
parcelHelpers.export(exports, "EuroSymbolOutlined", ()=>(0, _euroSymbolOutlinedDefault.default));
parcelHelpers.export(exports, "EuroSymbolRounded", ()=>(0, _euroSymbolRoundedDefault.default));
parcelHelpers.export(exports, "EuroSymbolSharp", ()=>(0, _euroSymbolSharpDefault.default));
parcelHelpers.export(exports, "EuroSymbolTwoTone", ()=>(0, _euroSymbolTwoToneDefault.default));
parcelHelpers.export(exports, "EuroTwoTone", ()=>(0, _euroTwoToneDefault.default));
parcelHelpers.export(exports, "EvStation", ()=>(0, _evStationDefault.default));
parcelHelpers.export(exports, "EvStationOutlined", ()=>(0, _evStationOutlinedDefault.default));
parcelHelpers.export(exports, "EvStationRounded", ()=>(0, _evStationRoundedDefault.default));
parcelHelpers.export(exports, "EvStationSharp", ()=>(0, _evStationSharpDefault.default));
parcelHelpers.export(exports, "EvStationTwoTone", ()=>(0, _evStationTwoToneDefault.default));
parcelHelpers.export(exports, "Event", ()=>(0, _eventDefault.default));
parcelHelpers.export(exports, "EventAvailable", ()=>(0, _eventAvailableDefault.default));
parcelHelpers.export(exports, "EventAvailableOutlined", ()=>(0, _eventAvailableOutlinedDefault.default));
parcelHelpers.export(exports, "EventAvailableRounded", ()=>(0, _eventAvailableRoundedDefault.default));
parcelHelpers.export(exports, "EventAvailableSharp", ()=>(0, _eventAvailableSharpDefault.default));
parcelHelpers.export(exports, "EventAvailableTwoTone", ()=>(0, _eventAvailableTwoToneDefault.default));
parcelHelpers.export(exports, "EventBusy", ()=>(0, _eventBusyDefault.default));
parcelHelpers.export(exports, "EventBusyOutlined", ()=>(0, _eventBusyOutlinedDefault.default));
parcelHelpers.export(exports, "EventBusyRounded", ()=>(0, _eventBusyRoundedDefault.default));
parcelHelpers.export(exports, "EventBusySharp", ()=>(0, _eventBusySharpDefault.default));
parcelHelpers.export(exports, "EventBusyTwoTone", ()=>(0, _eventBusyTwoToneDefault.default));
parcelHelpers.export(exports, "EventNote", ()=>(0, _eventNoteDefault.default));
parcelHelpers.export(exports, "EventNoteOutlined", ()=>(0, _eventNoteOutlinedDefault.default));
parcelHelpers.export(exports, "EventNoteRounded", ()=>(0, _eventNoteRoundedDefault.default));
parcelHelpers.export(exports, "EventNoteSharp", ()=>(0, _eventNoteSharpDefault.default));
parcelHelpers.export(exports, "EventNoteTwoTone", ()=>(0, _eventNoteTwoToneDefault.default));
parcelHelpers.export(exports, "EventOutlined", ()=>(0, _eventOutlinedDefault.default));
parcelHelpers.export(exports, "EventRepeat", ()=>(0, _eventRepeatDefault.default));
parcelHelpers.export(exports, "EventRepeatOutlined", ()=>(0, _eventRepeatOutlinedDefault.default));
parcelHelpers.export(exports, "EventRepeatRounded", ()=>(0, _eventRepeatRoundedDefault.default));
parcelHelpers.export(exports, "EventRepeatSharp", ()=>(0, _eventRepeatSharpDefault.default));
parcelHelpers.export(exports, "EventRepeatTwoTone", ()=>(0, _eventRepeatTwoToneDefault.default));
parcelHelpers.export(exports, "EventRounded", ()=>(0, _eventRoundedDefault.default));
parcelHelpers.export(exports, "EventSeat", ()=>(0, _eventSeatDefault.default));
parcelHelpers.export(exports, "EventSeatOutlined", ()=>(0, _eventSeatOutlinedDefault.default));
parcelHelpers.export(exports, "EventSeatRounded", ()=>(0, _eventSeatRoundedDefault.default));
parcelHelpers.export(exports, "EventSeatSharp", ()=>(0, _eventSeatSharpDefault.default));
parcelHelpers.export(exports, "EventSeatTwoTone", ()=>(0, _eventSeatTwoToneDefault.default));
parcelHelpers.export(exports, "EventSharp", ()=>(0, _eventSharpDefault.default));
parcelHelpers.export(exports, "EventTwoTone", ()=>(0, _eventTwoToneDefault.default));
parcelHelpers.export(exports, "ExitToApp", ()=>(0, _exitToAppDefault.default));
parcelHelpers.export(exports, "ExitToAppOutlined", ()=>(0, _exitToAppOutlinedDefault.default));
parcelHelpers.export(exports, "ExitToAppRounded", ()=>(0, _exitToAppRoundedDefault.default));
parcelHelpers.export(exports, "ExitToAppSharp", ()=>(0, _exitToAppSharpDefault.default));
parcelHelpers.export(exports, "ExitToAppTwoTone", ()=>(0, _exitToAppTwoToneDefault.default));
parcelHelpers.export(exports, "Expand", ()=>(0, _expandDefault.default));
parcelHelpers.export(exports, "ExpandCircleDown", ()=>(0, _expandCircleDownDefault.default));
parcelHelpers.export(exports, "ExpandCircleDownOutlined", ()=>(0, _expandCircleDownOutlinedDefault.default));
parcelHelpers.export(exports, "ExpandCircleDownRounded", ()=>(0, _expandCircleDownRoundedDefault.default));
parcelHelpers.export(exports, "ExpandCircleDownSharp", ()=>(0, _expandCircleDownSharpDefault.default));
parcelHelpers.export(exports, "ExpandCircleDownTwoTone", ()=>(0, _expandCircleDownTwoToneDefault.default));
parcelHelpers.export(exports, "ExpandLess", ()=>(0, _expandLessDefault.default));
parcelHelpers.export(exports, "ExpandLessOutlined", ()=>(0, _expandLessOutlinedDefault.default));
parcelHelpers.export(exports, "ExpandLessRounded", ()=>(0, _expandLessRoundedDefault.default));
parcelHelpers.export(exports, "ExpandLessSharp", ()=>(0, _expandLessSharpDefault.default));
parcelHelpers.export(exports, "ExpandLessTwoTone", ()=>(0, _expandLessTwoToneDefault.default));
parcelHelpers.export(exports, "ExpandMore", ()=>(0, _expandMoreDefault.default));
parcelHelpers.export(exports, "ExpandMoreOutlined", ()=>(0, _expandMoreOutlinedDefault.default));
parcelHelpers.export(exports, "ExpandMoreRounded", ()=>(0, _expandMoreRoundedDefault.default));
parcelHelpers.export(exports, "ExpandMoreSharp", ()=>(0, _expandMoreSharpDefault.default));
parcelHelpers.export(exports, "ExpandMoreTwoTone", ()=>(0, _expandMoreTwoToneDefault.default));
parcelHelpers.export(exports, "ExpandOutlined", ()=>(0, _expandOutlinedDefault.default));
parcelHelpers.export(exports, "ExpandRounded", ()=>(0, _expandRoundedDefault.default));
parcelHelpers.export(exports, "ExpandSharp", ()=>(0, _expandSharpDefault.default));
parcelHelpers.export(exports, "ExpandTwoTone", ()=>(0, _expandTwoToneDefault.default));
parcelHelpers.export(exports, "Explicit", ()=>(0, _explicitDefault.default));
parcelHelpers.export(exports, "ExplicitOutlined", ()=>(0, _explicitOutlinedDefault.default));
parcelHelpers.export(exports, "ExplicitRounded", ()=>(0, _explicitRoundedDefault.default));
parcelHelpers.export(exports, "ExplicitSharp", ()=>(0, _explicitSharpDefault.default));
parcelHelpers.export(exports, "ExplicitTwoTone", ()=>(0, _explicitTwoToneDefault.default));
parcelHelpers.export(exports, "Explore", ()=>(0, _exploreDefault.default));
parcelHelpers.export(exports, "ExploreOff", ()=>(0, _exploreOffDefault.default));
parcelHelpers.export(exports, "ExploreOffOutlined", ()=>(0, _exploreOffOutlinedDefault.default));
parcelHelpers.export(exports, "ExploreOffRounded", ()=>(0, _exploreOffRoundedDefault.default));
parcelHelpers.export(exports, "ExploreOffSharp", ()=>(0, _exploreOffSharpDefault.default));
parcelHelpers.export(exports, "ExploreOffTwoTone", ()=>(0, _exploreOffTwoToneDefault.default));
parcelHelpers.export(exports, "ExploreOutlined", ()=>(0, _exploreOutlinedDefault.default));
parcelHelpers.export(exports, "ExploreRounded", ()=>(0, _exploreRoundedDefault.default));
parcelHelpers.export(exports, "ExploreSharp", ()=>(0, _exploreSharpDefault.default));
parcelHelpers.export(exports, "ExploreTwoTone", ()=>(0, _exploreTwoToneDefault.default));
parcelHelpers.export(exports, "Exposure", ()=>(0, _exposureDefault.default));
parcelHelpers.export(exports, "ExposureOutlined", ()=>(0, _exposureOutlinedDefault.default));
parcelHelpers.export(exports, "ExposureRounded", ()=>(0, _exposureRoundedDefault.default));
parcelHelpers.export(exports, "ExposureSharp", ()=>(0, _exposureSharpDefault.default));
parcelHelpers.export(exports, "ExposureTwoTone", ()=>(0, _exposureTwoToneDefault.default));
parcelHelpers.export(exports, "Extension", ()=>(0, _extensionDefault.default));
parcelHelpers.export(exports, "ExtensionOff", ()=>(0, _extensionOffDefault.default));
parcelHelpers.export(exports, "ExtensionOffOutlined", ()=>(0, _extensionOffOutlinedDefault.default));
parcelHelpers.export(exports, "ExtensionOffRounded", ()=>(0, _extensionOffRoundedDefault.default));
parcelHelpers.export(exports, "ExtensionOffSharp", ()=>(0, _extensionOffSharpDefault.default));
parcelHelpers.export(exports, "ExtensionOffTwoTone", ()=>(0, _extensionOffTwoToneDefault.default));
parcelHelpers.export(exports, "ExtensionOutlined", ()=>(0, _extensionOutlinedDefault.default));
parcelHelpers.export(exports, "ExtensionRounded", ()=>(0, _extensionRoundedDefault.default));
parcelHelpers.export(exports, "ExtensionSharp", ()=>(0, _extensionSharpDefault.default));
parcelHelpers.export(exports, "ExtensionTwoTone", ()=>(0, _extensionTwoToneDefault.default));
parcelHelpers.export(exports, "Face", ()=>(0, _faceDefault.default));
parcelHelpers.export(exports, "Face2", ()=>(0, _face2Default.default));
parcelHelpers.export(exports, "Face2Outlined", ()=>(0, _face2OutlinedDefault.default));
parcelHelpers.export(exports, "Face2Rounded", ()=>(0, _face2RoundedDefault.default));
parcelHelpers.export(exports, "Face2Sharp", ()=>(0, _face2SharpDefault.default));
parcelHelpers.export(exports, "Face2TwoTone", ()=>(0, _face2TwoToneDefault.default));
parcelHelpers.export(exports, "Face3", ()=>(0, _face3Default.default));
parcelHelpers.export(exports, "Face3Outlined", ()=>(0, _face3OutlinedDefault.default));
parcelHelpers.export(exports, "Face3Rounded", ()=>(0, _face3RoundedDefault.default));
parcelHelpers.export(exports, "Face3Sharp", ()=>(0, _face3SharpDefault.default));
parcelHelpers.export(exports, "Face3TwoTone", ()=>(0, _face3TwoToneDefault.default));
parcelHelpers.export(exports, "Face4", ()=>(0, _face4Default.default));
parcelHelpers.export(exports, "Face4Outlined", ()=>(0, _face4OutlinedDefault.default));
parcelHelpers.export(exports, "Face4Rounded", ()=>(0, _face4RoundedDefault.default));
parcelHelpers.export(exports, "Face4Sharp", ()=>(0, _face4SharpDefault.default));
parcelHelpers.export(exports, "Face4TwoTone", ()=>(0, _face4TwoToneDefault.default));
parcelHelpers.export(exports, "Face5", ()=>(0, _face5Default.default));
parcelHelpers.export(exports, "Face5Outlined", ()=>(0, _face5OutlinedDefault.default));
parcelHelpers.export(exports, "Face5Rounded", ()=>(0, _face5RoundedDefault.default));
parcelHelpers.export(exports, "Face5Sharp", ()=>(0, _face5SharpDefault.default));
parcelHelpers.export(exports, "Face5TwoTone", ()=>(0, _face5TwoToneDefault.default));
parcelHelpers.export(exports, "Face6", ()=>(0, _face6Default.default));
parcelHelpers.export(exports, "Face6Outlined", ()=>(0, _face6OutlinedDefault.default));
parcelHelpers.export(exports, "Face6Rounded", ()=>(0, _face6RoundedDefault.default));
parcelHelpers.export(exports, "Face6Sharp", ()=>(0, _face6SharpDefault.default));
parcelHelpers.export(exports, "Face6TwoTone", ()=>(0, _face6TwoToneDefault.default));
parcelHelpers.export(exports, "FaceOutlined", ()=>(0, _faceOutlinedDefault.default));
parcelHelpers.export(exports, "FaceRetouchingNatural", ()=>(0, _faceRetouchingNaturalDefault.default));
parcelHelpers.export(exports, "FaceRetouchingNaturalOutlined", ()=>(0, _faceRetouchingNaturalOutlinedDefault.default));
parcelHelpers.export(exports, "FaceRetouchingNaturalRounded", ()=>(0, _faceRetouchingNaturalRoundedDefault.default));
parcelHelpers.export(exports, "FaceRetouchingNaturalSharp", ()=>(0, _faceRetouchingNaturalSharpDefault.default));
parcelHelpers.export(exports, "FaceRetouchingNaturalTwoTone", ()=>(0, _faceRetouchingNaturalTwoToneDefault.default));
parcelHelpers.export(exports, "FaceRetouchingOff", ()=>(0, _faceRetouchingOffDefault.default));
parcelHelpers.export(exports, "FaceRetouchingOffOutlined", ()=>(0, _faceRetouchingOffOutlinedDefault.default));
parcelHelpers.export(exports, "FaceRetouchingOffRounded", ()=>(0, _faceRetouchingOffRoundedDefault.default));
parcelHelpers.export(exports, "FaceRetouchingOffSharp", ()=>(0, _faceRetouchingOffSharpDefault.default));
parcelHelpers.export(exports, "FaceRetouchingOffTwoTone", ()=>(0, _faceRetouchingOffTwoToneDefault.default));
parcelHelpers.export(exports, "FaceRounded", ()=>(0, _faceRoundedDefault.default));
parcelHelpers.export(exports, "FaceSharp", ()=>(0, _faceSharpDefault.default));
parcelHelpers.export(exports, "FaceTwoTone", ()=>(0, _faceTwoToneDefault.default));
parcelHelpers.export(exports, "Facebook", ()=>(0, _facebookDefault.default));
parcelHelpers.export(exports, "FacebookOutlined", ()=>(0, _facebookOutlinedDefault.default));
parcelHelpers.export(exports, "FacebookRounded", ()=>(0, _facebookRoundedDefault.default));
parcelHelpers.export(exports, "FacebookSharp", ()=>(0, _facebookSharpDefault.default));
parcelHelpers.export(exports, "FacebookTwoTone", ()=>(0, _facebookTwoToneDefault.default));
parcelHelpers.export(exports, "FactCheck", ()=>(0, _factCheckDefault.default));
parcelHelpers.export(exports, "FactCheckOutlined", ()=>(0, _factCheckOutlinedDefault.default));
parcelHelpers.export(exports, "FactCheckRounded", ()=>(0, _factCheckRoundedDefault.default));
parcelHelpers.export(exports, "FactCheckSharp", ()=>(0, _factCheckSharpDefault.default));
parcelHelpers.export(exports, "FactCheckTwoTone", ()=>(0, _factCheckTwoToneDefault.default));
parcelHelpers.export(exports, "Factory", ()=>(0, _factoryDefault.default));
parcelHelpers.export(exports, "FactoryOutlined", ()=>(0, _factoryOutlinedDefault.default));
parcelHelpers.export(exports, "FactoryRounded", ()=>(0, _factoryRoundedDefault.default));
parcelHelpers.export(exports, "FactorySharp", ()=>(0, _factorySharpDefault.default));
parcelHelpers.export(exports, "FactoryTwoTone", ()=>(0, _factoryTwoToneDefault.default));
parcelHelpers.export(exports, "FamilyRestroom", ()=>(0, _familyRestroomDefault.default));
parcelHelpers.export(exports, "FamilyRestroomOutlined", ()=>(0, _familyRestroomOutlinedDefault.default));
parcelHelpers.export(exports, "FamilyRestroomRounded", ()=>(0, _familyRestroomRoundedDefault.default));
parcelHelpers.export(exports, "FamilyRestroomSharp", ()=>(0, _familyRestroomSharpDefault.default));
parcelHelpers.export(exports, "FamilyRestroomTwoTone", ()=>(0, _familyRestroomTwoToneDefault.default));
parcelHelpers.export(exports, "FastForward", ()=>(0, _fastForwardDefault.default));
parcelHelpers.export(exports, "FastForwardOutlined", ()=>(0, _fastForwardOutlinedDefault.default));
parcelHelpers.export(exports, "FastForwardRounded", ()=>(0, _fastForwardRoundedDefault.default));
parcelHelpers.export(exports, "FastForwardSharp", ()=>(0, _fastForwardSharpDefault.default));
parcelHelpers.export(exports, "FastForwardTwoTone", ()=>(0, _fastForwardTwoToneDefault.default));
parcelHelpers.export(exports, "FastRewind", ()=>(0, _fastRewindDefault.default));
parcelHelpers.export(exports, "FastRewindOutlined", ()=>(0, _fastRewindOutlinedDefault.default));
parcelHelpers.export(exports, "FastRewindRounded", ()=>(0, _fastRewindRoundedDefault.default));
parcelHelpers.export(exports, "FastRewindSharp", ()=>(0, _fastRewindSharpDefault.default));
parcelHelpers.export(exports, "FastRewindTwoTone", ()=>(0, _fastRewindTwoToneDefault.default));
parcelHelpers.export(exports, "Fastfood", ()=>(0, _fastfoodDefault.default));
parcelHelpers.export(exports, "FastfoodOutlined", ()=>(0, _fastfoodOutlinedDefault.default));
parcelHelpers.export(exports, "FastfoodRounded", ()=>(0, _fastfoodRoundedDefault.default));
parcelHelpers.export(exports, "FastfoodSharp", ()=>(0, _fastfoodSharpDefault.default));
parcelHelpers.export(exports, "FastfoodTwoTone", ()=>(0, _fastfoodTwoToneDefault.default));
parcelHelpers.export(exports, "Favorite", ()=>(0, _favoriteDefault.default));
parcelHelpers.export(exports, "FavoriteBorder", ()=>(0, _favoriteBorderDefault.default));
parcelHelpers.export(exports, "FavoriteBorderOutlined", ()=>(0, _favoriteBorderOutlinedDefault.default));
parcelHelpers.export(exports, "FavoriteBorderRounded", ()=>(0, _favoriteBorderRoundedDefault.default));
parcelHelpers.export(exports, "FavoriteBorderSharp", ()=>(0, _favoriteBorderSharpDefault.default));
parcelHelpers.export(exports, "FavoriteBorderTwoTone", ()=>(0, _favoriteBorderTwoToneDefault.default));
parcelHelpers.export(exports, "FavoriteOutlined", ()=>(0, _favoriteOutlinedDefault.default));
parcelHelpers.export(exports, "FavoriteRounded", ()=>(0, _favoriteRoundedDefault.default));
parcelHelpers.export(exports, "FavoriteSharp", ()=>(0, _favoriteSharpDefault.default));
parcelHelpers.export(exports, "FavoriteTwoTone", ()=>(0, _favoriteTwoToneDefault.default));
parcelHelpers.export(exports, "Fax", ()=>(0, _faxDefault.default));
parcelHelpers.export(exports, "FaxOutlined", ()=>(0, _faxOutlinedDefault.default));
parcelHelpers.export(exports, "FaxRounded", ()=>(0, _faxRoundedDefault.default));
parcelHelpers.export(exports, "FaxSharp", ()=>(0, _faxSharpDefault.default));
parcelHelpers.export(exports, "FaxTwoTone", ()=>(0, _faxTwoToneDefault.default));
parcelHelpers.export(exports, "FeaturedPlayList", ()=>(0, _featuredPlayListDefault.default));
parcelHelpers.export(exports, "FeaturedPlayListOutlined", ()=>(0, _featuredPlayListOutlinedDefault.default));
parcelHelpers.export(exports, "FeaturedPlayListRounded", ()=>(0, _featuredPlayListRoundedDefault.default));
parcelHelpers.export(exports, "FeaturedPlayListSharp", ()=>(0, _featuredPlayListSharpDefault.default));
parcelHelpers.export(exports, "FeaturedPlayListTwoTone", ()=>(0, _featuredPlayListTwoToneDefault.default));
parcelHelpers.export(exports, "FeaturedVideo", ()=>(0, _featuredVideoDefault.default));
parcelHelpers.export(exports, "FeaturedVideoOutlined", ()=>(0, _featuredVideoOutlinedDefault.default));
parcelHelpers.export(exports, "FeaturedVideoRounded", ()=>(0, _featuredVideoRoundedDefault.default));
parcelHelpers.export(exports, "FeaturedVideoSharp", ()=>(0, _featuredVideoSharpDefault.default));
parcelHelpers.export(exports, "FeaturedVideoTwoTone", ()=>(0, _featuredVideoTwoToneDefault.default));
parcelHelpers.export(exports, "Feed", ()=>(0, _feedDefault.default));
parcelHelpers.export(exports, "FeedOutlined", ()=>(0, _feedOutlinedDefault.default));
parcelHelpers.export(exports, "FeedRounded", ()=>(0, _feedRoundedDefault.default));
parcelHelpers.export(exports, "FeedSharp", ()=>(0, _feedSharpDefault.default));
parcelHelpers.export(exports, "FeedTwoTone", ()=>(0, _feedTwoToneDefault.default));
parcelHelpers.export(exports, "Feedback", ()=>(0, _feedbackDefault.default));
parcelHelpers.export(exports, "FeedbackOutlined", ()=>(0, _feedbackOutlinedDefault.default));
parcelHelpers.export(exports, "FeedbackRounded", ()=>(0, _feedbackRoundedDefault.default));
parcelHelpers.export(exports, "FeedbackSharp", ()=>(0, _feedbackSharpDefault.default));
parcelHelpers.export(exports, "FeedbackTwoTone", ()=>(0, _feedbackTwoToneDefault.default));
parcelHelpers.export(exports, "Female", ()=>(0, _femaleDefault.default));
parcelHelpers.export(exports, "FemaleOutlined", ()=>(0, _femaleOutlinedDefault.default));
parcelHelpers.export(exports, "FemaleRounded", ()=>(0, _femaleRoundedDefault.default));
parcelHelpers.export(exports, "FemaleSharp", ()=>(0, _femaleSharpDefault.default));
parcelHelpers.export(exports, "FemaleTwoTone", ()=>(0, _femaleTwoToneDefault.default));
parcelHelpers.export(exports, "Fence", ()=>(0, _fenceDefault.default));
parcelHelpers.export(exports, "FenceOutlined", ()=>(0, _fenceOutlinedDefault.default));
parcelHelpers.export(exports, "FenceRounded", ()=>(0, _fenceRoundedDefault.default));
parcelHelpers.export(exports, "FenceSharp", ()=>(0, _fenceSharpDefault.default));
parcelHelpers.export(exports, "FenceTwoTone", ()=>(0, _fenceTwoToneDefault.default));
parcelHelpers.export(exports, "Festival", ()=>(0, _festivalDefault.default));
parcelHelpers.export(exports, "FestivalOutlined", ()=>(0, _festivalOutlinedDefault.default));
parcelHelpers.export(exports, "FestivalRounded", ()=>(0, _festivalRoundedDefault.default));
parcelHelpers.export(exports, "FestivalSharp", ()=>(0, _festivalSharpDefault.default));
parcelHelpers.export(exports, "FestivalTwoTone", ()=>(0, _festivalTwoToneDefault.default));
parcelHelpers.export(exports, "FiberDvr", ()=>(0, _fiberDvrDefault.default));
parcelHelpers.export(exports, "FiberDvrOutlined", ()=>(0, _fiberDvrOutlinedDefault.default));
parcelHelpers.export(exports, "FiberDvrRounded", ()=>(0, _fiberDvrRoundedDefault.default));
parcelHelpers.export(exports, "FiberDvrSharp", ()=>(0, _fiberDvrSharpDefault.default));
parcelHelpers.export(exports, "FiberDvrTwoTone", ()=>(0, _fiberDvrTwoToneDefault.default));
parcelHelpers.export(exports, "FiberManualRecord", ()=>(0, _fiberManualRecordDefault.default));
parcelHelpers.export(exports, "FiberManualRecordOutlined", ()=>(0, _fiberManualRecordOutlinedDefault.default));
parcelHelpers.export(exports, "FiberManualRecordRounded", ()=>(0, _fiberManualRecordRoundedDefault.default));
parcelHelpers.export(exports, "FiberManualRecordSharp", ()=>(0, _fiberManualRecordSharpDefault.default));
parcelHelpers.export(exports, "FiberManualRecordTwoTone", ()=>(0, _fiberManualRecordTwoToneDefault.default));
parcelHelpers.export(exports, "FiberNew", ()=>(0, _fiberNewDefault.default));
parcelHelpers.export(exports, "FiberNewOutlined", ()=>(0, _fiberNewOutlinedDefault.default));
parcelHelpers.export(exports, "FiberNewRounded", ()=>(0, _fiberNewRoundedDefault.default));
parcelHelpers.export(exports, "FiberNewSharp", ()=>(0, _fiberNewSharpDefault.default));
parcelHelpers.export(exports, "FiberNewTwoTone", ()=>(0, _fiberNewTwoToneDefault.default));
parcelHelpers.export(exports, "FiberPin", ()=>(0, _fiberPinDefault.default));
parcelHelpers.export(exports, "FiberPinOutlined", ()=>(0, _fiberPinOutlinedDefault.default));
parcelHelpers.export(exports, "FiberPinRounded", ()=>(0, _fiberPinRoundedDefault.default));
parcelHelpers.export(exports, "FiberPinSharp", ()=>(0, _fiberPinSharpDefault.default));
parcelHelpers.export(exports, "FiberPinTwoTone", ()=>(0, _fiberPinTwoToneDefault.default));
parcelHelpers.export(exports, "FiberSmartRecord", ()=>(0, _fiberSmartRecordDefault.default));
parcelHelpers.export(exports, "FiberSmartRecordOutlined", ()=>(0, _fiberSmartRecordOutlinedDefault.default));
parcelHelpers.export(exports, "FiberSmartRecordRounded", ()=>(0, _fiberSmartRecordRoundedDefault.default));
parcelHelpers.export(exports, "FiberSmartRecordSharp", ()=>(0, _fiberSmartRecordSharpDefault.default));
parcelHelpers.export(exports, "FiberSmartRecordTwoTone", ()=>(0, _fiberSmartRecordTwoToneDefault.default));
parcelHelpers.export(exports, "FifteenMp", ()=>(0, _fifteenMpDefault.default));
parcelHelpers.export(exports, "FifteenMpOutlined", ()=>(0, _fifteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "FifteenMpRounded", ()=>(0, _fifteenMpRoundedDefault.default));
parcelHelpers.export(exports, "FifteenMpSharp", ()=>(0, _fifteenMpSharpDefault.default));
parcelHelpers.export(exports, "FifteenMpTwoTone", ()=>(0, _fifteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "FileCopy", ()=>(0, _fileCopyDefault.default));
parcelHelpers.export(exports, "FileCopyOutlined", ()=>(0, _fileCopyOutlinedDefault.default));
parcelHelpers.export(exports, "FileCopyRounded", ()=>(0, _fileCopyRoundedDefault.default));
parcelHelpers.export(exports, "FileCopySharp", ()=>(0, _fileCopySharpDefault.default));
parcelHelpers.export(exports, "FileCopyTwoTone", ()=>(0, _fileCopyTwoToneDefault.default));
parcelHelpers.export(exports, "FileDownload", ()=>(0, _fileDownloadDefault.default));
parcelHelpers.export(exports, "FileDownloadDone", ()=>(0, _fileDownloadDoneDefault.default));
parcelHelpers.export(exports, "FileDownloadDoneOutlined", ()=>(0, _fileDownloadDoneOutlinedDefault.default));
parcelHelpers.export(exports, "FileDownloadDoneRounded", ()=>(0, _fileDownloadDoneRoundedDefault.default));
parcelHelpers.export(exports, "FileDownloadDoneSharp", ()=>(0, _fileDownloadDoneSharpDefault.default));
parcelHelpers.export(exports, "FileDownloadDoneTwoTone", ()=>(0, _fileDownloadDoneTwoToneDefault.default));
parcelHelpers.export(exports, "FileDownloadOff", ()=>(0, _fileDownloadOffDefault.default));
parcelHelpers.export(exports, "FileDownloadOffOutlined", ()=>(0, _fileDownloadOffOutlinedDefault.default));
parcelHelpers.export(exports, "FileDownloadOffRounded", ()=>(0, _fileDownloadOffRoundedDefault.default));
parcelHelpers.export(exports, "FileDownloadOffSharp", ()=>(0, _fileDownloadOffSharpDefault.default));
parcelHelpers.export(exports, "FileDownloadOffTwoTone", ()=>(0, _fileDownloadOffTwoToneDefault.default));
parcelHelpers.export(exports, "FileDownloadOutlined", ()=>(0, _fileDownloadOutlinedDefault.default));
parcelHelpers.export(exports, "FileDownloadRounded", ()=>(0, _fileDownloadRoundedDefault.default));
parcelHelpers.export(exports, "FileDownloadSharp", ()=>(0, _fileDownloadSharpDefault.default));
parcelHelpers.export(exports, "FileDownloadTwoTone", ()=>(0, _fileDownloadTwoToneDefault.default));
parcelHelpers.export(exports, "FileOpen", ()=>(0, _fileOpenDefault.default));
parcelHelpers.export(exports, "FileOpenOutlined", ()=>(0, _fileOpenOutlinedDefault.default));
parcelHelpers.export(exports, "FileOpenRounded", ()=>(0, _fileOpenRoundedDefault.default));
parcelHelpers.export(exports, "FileOpenSharp", ()=>(0, _fileOpenSharpDefault.default));
parcelHelpers.export(exports, "FileOpenTwoTone", ()=>(0, _fileOpenTwoToneDefault.default));
parcelHelpers.export(exports, "FilePresent", ()=>(0, _filePresentDefault.default));
parcelHelpers.export(exports, "FilePresentOutlined", ()=>(0, _filePresentOutlinedDefault.default));
parcelHelpers.export(exports, "FilePresentRounded", ()=>(0, _filePresentRoundedDefault.default));
parcelHelpers.export(exports, "FilePresentSharp", ()=>(0, _filePresentSharpDefault.default));
parcelHelpers.export(exports, "FilePresentTwoTone", ()=>(0, _filePresentTwoToneDefault.default));
parcelHelpers.export(exports, "FileUpload", ()=>(0, _fileUploadDefault.default));
parcelHelpers.export(exports, "FileUploadOutlined", ()=>(0, _fileUploadOutlinedDefault.default));
parcelHelpers.export(exports, "FileUploadRounded", ()=>(0, _fileUploadRoundedDefault.default));
parcelHelpers.export(exports, "FileUploadSharp", ()=>(0, _fileUploadSharpDefault.default));
parcelHelpers.export(exports, "FileUploadTwoTone", ()=>(0, _fileUploadTwoToneDefault.default));
parcelHelpers.export(exports, "Filter", ()=>(0, _filterDefault.default));
parcelHelpers.export(exports, "Filter1", ()=>(0, _filter1Default.default));
parcelHelpers.export(exports, "Filter1Outlined", ()=>(0, _filter1OutlinedDefault.default));
parcelHelpers.export(exports, "Filter1Rounded", ()=>(0, _filter1RoundedDefault.default));
parcelHelpers.export(exports, "Filter1Sharp", ()=>(0, _filter1SharpDefault.default));
parcelHelpers.export(exports, "Filter1TwoTone", ()=>(0, _filter1TwoToneDefault.default));
parcelHelpers.export(exports, "Filter2", ()=>(0, _filter2Default.default));
parcelHelpers.export(exports, "Filter2Outlined", ()=>(0, _filter2OutlinedDefault.default));
parcelHelpers.export(exports, "Filter2Rounded", ()=>(0, _filter2RoundedDefault.default));
parcelHelpers.export(exports, "Filter2Sharp", ()=>(0, _filter2SharpDefault.default));
parcelHelpers.export(exports, "Filter2TwoTone", ()=>(0, _filter2TwoToneDefault.default));
parcelHelpers.export(exports, "Filter3", ()=>(0, _filter3Default.default));
parcelHelpers.export(exports, "Filter3Outlined", ()=>(0, _filter3OutlinedDefault.default));
parcelHelpers.export(exports, "Filter3Rounded", ()=>(0, _filter3RoundedDefault.default));
parcelHelpers.export(exports, "Filter3Sharp", ()=>(0, _filter3SharpDefault.default));
parcelHelpers.export(exports, "Filter3TwoTone", ()=>(0, _filter3TwoToneDefault.default));
parcelHelpers.export(exports, "Filter4", ()=>(0, _filter4Default.default));
parcelHelpers.export(exports, "Filter4Outlined", ()=>(0, _filter4OutlinedDefault.default));
parcelHelpers.export(exports, "Filter4Rounded", ()=>(0, _filter4RoundedDefault.default));
parcelHelpers.export(exports, "Filter4Sharp", ()=>(0, _filter4SharpDefault.default));
parcelHelpers.export(exports, "Filter4TwoTone", ()=>(0, _filter4TwoToneDefault.default));
parcelHelpers.export(exports, "Filter5", ()=>(0, _filter5Default.default));
parcelHelpers.export(exports, "Filter5Outlined", ()=>(0, _filter5OutlinedDefault.default));
parcelHelpers.export(exports, "Filter5Rounded", ()=>(0, _filter5RoundedDefault.default));
parcelHelpers.export(exports, "Filter5Sharp", ()=>(0, _filter5SharpDefault.default));
parcelHelpers.export(exports, "Filter5TwoTone", ()=>(0, _filter5TwoToneDefault.default));
parcelHelpers.export(exports, "Filter6", ()=>(0, _filter6Default.default));
parcelHelpers.export(exports, "Filter6Outlined", ()=>(0, _filter6OutlinedDefault.default));
parcelHelpers.export(exports, "Filter6Rounded", ()=>(0, _filter6RoundedDefault.default));
parcelHelpers.export(exports, "Filter6Sharp", ()=>(0, _filter6SharpDefault.default));
parcelHelpers.export(exports, "Filter6TwoTone", ()=>(0, _filter6TwoToneDefault.default));
parcelHelpers.export(exports, "Filter7", ()=>(0, _filter7Default.default));
parcelHelpers.export(exports, "Filter7Outlined", ()=>(0, _filter7OutlinedDefault.default));
parcelHelpers.export(exports, "Filter7Rounded", ()=>(0, _filter7RoundedDefault.default));
parcelHelpers.export(exports, "Filter7Sharp", ()=>(0, _filter7SharpDefault.default));
parcelHelpers.export(exports, "Filter7TwoTone", ()=>(0, _filter7TwoToneDefault.default));
parcelHelpers.export(exports, "Filter8", ()=>(0, _filter8Default.default));
parcelHelpers.export(exports, "Filter8Outlined", ()=>(0, _filter8OutlinedDefault.default));
parcelHelpers.export(exports, "Filter8Rounded", ()=>(0, _filter8RoundedDefault.default));
parcelHelpers.export(exports, "Filter8Sharp", ()=>(0, _filter8SharpDefault.default));
parcelHelpers.export(exports, "Filter8TwoTone", ()=>(0, _filter8TwoToneDefault.default));
parcelHelpers.export(exports, "Filter9", ()=>(0, _filter9Default.default));
parcelHelpers.export(exports, "Filter9Outlined", ()=>(0, _filter9OutlinedDefault.default));
parcelHelpers.export(exports, "Filter9Plus", ()=>(0, _filter9PlusDefault.default));
parcelHelpers.export(exports, "Filter9PlusOutlined", ()=>(0, _filter9PlusOutlinedDefault.default));
parcelHelpers.export(exports, "Filter9PlusRounded", ()=>(0, _filter9PlusRoundedDefault.default));
parcelHelpers.export(exports, "Filter9PlusSharp", ()=>(0, _filter9PlusSharpDefault.default));
parcelHelpers.export(exports, "Filter9PlusTwoTone", ()=>(0, _filter9PlusTwoToneDefault.default));
parcelHelpers.export(exports, "Filter9Rounded", ()=>(0, _filter9RoundedDefault.default));
parcelHelpers.export(exports, "Filter9Sharp", ()=>(0, _filter9SharpDefault.default));
parcelHelpers.export(exports, "Filter9TwoTone", ()=>(0, _filter9TwoToneDefault.default));
parcelHelpers.export(exports, "FilterAlt", ()=>(0, _filterAltDefault.default));
parcelHelpers.export(exports, "FilterAltOff", ()=>(0, _filterAltOffDefault.default));
parcelHelpers.export(exports, "FilterAltOffOutlined", ()=>(0, _filterAltOffOutlinedDefault.default));
parcelHelpers.export(exports, "FilterAltOffRounded", ()=>(0, _filterAltOffRoundedDefault.default));
parcelHelpers.export(exports, "FilterAltOffSharp", ()=>(0, _filterAltOffSharpDefault.default));
parcelHelpers.export(exports, "FilterAltOffTwoTone", ()=>(0, _filterAltOffTwoToneDefault.default));
parcelHelpers.export(exports, "FilterAltOutlined", ()=>(0, _filterAltOutlinedDefault.default));
parcelHelpers.export(exports, "FilterAltRounded", ()=>(0, _filterAltRoundedDefault.default));
parcelHelpers.export(exports, "FilterAltSharp", ()=>(0, _filterAltSharpDefault.default));
parcelHelpers.export(exports, "FilterAltTwoTone", ()=>(0, _filterAltTwoToneDefault.default));
parcelHelpers.export(exports, "FilterBAndW", ()=>(0, _filterBAndWDefault.default));
parcelHelpers.export(exports, "FilterBAndWOutlined", ()=>(0, _filterBAndWOutlinedDefault.default));
parcelHelpers.export(exports, "FilterBAndWRounded", ()=>(0, _filterBAndWRoundedDefault.default));
parcelHelpers.export(exports, "FilterBAndWSharp", ()=>(0, _filterBAndWSharpDefault.default));
parcelHelpers.export(exports, "FilterBAndWTwoTone", ()=>(0, _filterBAndWTwoToneDefault.default));
parcelHelpers.export(exports, "FilterCenterFocus", ()=>(0, _filterCenterFocusDefault.default));
parcelHelpers.export(exports, "FilterCenterFocusOutlined", ()=>(0, _filterCenterFocusOutlinedDefault.default));
parcelHelpers.export(exports, "FilterCenterFocusRounded", ()=>(0, _filterCenterFocusRoundedDefault.default));
parcelHelpers.export(exports, "FilterCenterFocusSharp", ()=>(0, _filterCenterFocusSharpDefault.default));
parcelHelpers.export(exports, "FilterCenterFocusTwoTone", ()=>(0, _filterCenterFocusTwoToneDefault.default));
parcelHelpers.export(exports, "FilterDrama", ()=>(0, _filterDramaDefault.default));
parcelHelpers.export(exports, "FilterDramaOutlined", ()=>(0, _filterDramaOutlinedDefault.default));
parcelHelpers.export(exports, "FilterDramaRounded", ()=>(0, _filterDramaRoundedDefault.default));
parcelHelpers.export(exports, "FilterDramaSharp", ()=>(0, _filterDramaSharpDefault.default));
parcelHelpers.export(exports, "FilterDramaTwoTone", ()=>(0, _filterDramaTwoToneDefault.default));
parcelHelpers.export(exports, "FilterFrames", ()=>(0, _filterFramesDefault.default));
parcelHelpers.export(exports, "FilterFramesOutlined", ()=>(0, _filterFramesOutlinedDefault.default));
parcelHelpers.export(exports, "FilterFramesRounded", ()=>(0, _filterFramesRoundedDefault.default));
parcelHelpers.export(exports, "FilterFramesSharp", ()=>(0, _filterFramesSharpDefault.default));
parcelHelpers.export(exports, "FilterFramesTwoTone", ()=>(0, _filterFramesTwoToneDefault.default));
parcelHelpers.export(exports, "FilterHdr", ()=>(0, _filterHdrDefault.default));
parcelHelpers.export(exports, "FilterHdrOutlined", ()=>(0, _filterHdrOutlinedDefault.default));
parcelHelpers.export(exports, "FilterHdrRounded", ()=>(0, _filterHdrRoundedDefault.default));
parcelHelpers.export(exports, "FilterHdrSharp", ()=>(0, _filterHdrSharpDefault.default));
parcelHelpers.export(exports, "FilterHdrTwoTone", ()=>(0, _filterHdrTwoToneDefault.default));
parcelHelpers.export(exports, "FilterList", ()=>(0, _filterListDefault.default));
parcelHelpers.export(exports, "FilterListOff", ()=>(0, _filterListOffDefault.default));
parcelHelpers.export(exports, "FilterListOffOutlined", ()=>(0, _filterListOffOutlinedDefault.default));
parcelHelpers.export(exports, "FilterListOffRounded", ()=>(0, _filterListOffRoundedDefault.default));
parcelHelpers.export(exports, "FilterListOffSharp", ()=>(0, _filterListOffSharpDefault.default));
parcelHelpers.export(exports, "FilterListOffTwoTone", ()=>(0, _filterListOffTwoToneDefault.default));
parcelHelpers.export(exports, "FilterListOutlined", ()=>(0, _filterListOutlinedDefault.default));
parcelHelpers.export(exports, "FilterListRounded", ()=>(0, _filterListRoundedDefault.default));
parcelHelpers.export(exports, "FilterListSharp", ()=>(0, _filterListSharpDefault.default));
parcelHelpers.export(exports, "FilterListTwoTone", ()=>(0, _filterListTwoToneDefault.default));
parcelHelpers.export(exports, "FilterNone", ()=>(0, _filterNoneDefault.default));
parcelHelpers.export(exports, "FilterNoneOutlined", ()=>(0, _filterNoneOutlinedDefault.default));
parcelHelpers.export(exports, "FilterNoneRounded", ()=>(0, _filterNoneRoundedDefault.default));
parcelHelpers.export(exports, "FilterNoneSharp", ()=>(0, _filterNoneSharpDefault.default));
parcelHelpers.export(exports, "FilterNoneTwoTone", ()=>(0, _filterNoneTwoToneDefault.default));
parcelHelpers.export(exports, "FilterOutlined", ()=>(0, _filterOutlinedDefault.default));
parcelHelpers.export(exports, "FilterRounded", ()=>(0, _filterRoundedDefault.default));
parcelHelpers.export(exports, "FilterSharp", ()=>(0, _filterSharpDefault.default));
parcelHelpers.export(exports, "FilterTiltShift", ()=>(0, _filterTiltShiftDefault.default));
parcelHelpers.export(exports, "FilterTiltShiftOutlined", ()=>(0, _filterTiltShiftOutlinedDefault.default));
parcelHelpers.export(exports, "FilterTiltShiftRounded", ()=>(0, _filterTiltShiftRoundedDefault.default));
parcelHelpers.export(exports, "FilterTiltShiftSharp", ()=>(0, _filterTiltShiftSharpDefault.default));
parcelHelpers.export(exports, "FilterTiltShiftTwoTone", ()=>(0, _filterTiltShiftTwoToneDefault.default));
parcelHelpers.export(exports, "FilterTwoTone", ()=>(0, _filterTwoToneDefault.default));
parcelHelpers.export(exports, "FilterVintage", ()=>(0, _filterVintageDefault.default));
parcelHelpers.export(exports, "FilterVintageOutlined", ()=>(0, _filterVintageOutlinedDefault.default));
parcelHelpers.export(exports, "FilterVintageRounded", ()=>(0, _filterVintageRoundedDefault.default));
parcelHelpers.export(exports, "FilterVintageSharp", ()=>(0, _filterVintageSharpDefault.default));
parcelHelpers.export(exports, "FilterVintageTwoTone", ()=>(0, _filterVintageTwoToneDefault.default));
parcelHelpers.export(exports, "FindInPage", ()=>(0, _findInPageDefault.default));
parcelHelpers.export(exports, "FindInPageOutlined", ()=>(0, _findInPageOutlinedDefault.default));
parcelHelpers.export(exports, "FindInPageRounded", ()=>(0, _findInPageRoundedDefault.default));
parcelHelpers.export(exports, "FindInPageSharp", ()=>(0, _findInPageSharpDefault.default));
parcelHelpers.export(exports, "FindInPageTwoTone", ()=>(0, _findInPageTwoToneDefault.default));
parcelHelpers.export(exports, "FindReplace", ()=>(0, _findReplaceDefault.default));
parcelHelpers.export(exports, "FindReplaceOutlined", ()=>(0, _findReplaceOutlinedDefault.default));
parcelHelpers.export(exports, "FindReplaceRounded", ()=>(0, _findReplaceRoundedDefault.default));
parcelHelpers.export(exports, "FindReplaceSharp", ()=>(0, _findReplaceSharpDefault.default));
parcelHelpers.export(exports, "FindReplaceTwoTone", ()=>(0, _findReplaceTwoToneDefault.default));
parcelHelpers.export(exports, "Fingerprint", ()=>(0, _fingerprintDefault.default));
parcelHelpers.export(exports, "FingerprintOutlined", ()=>(0, _fingerprintOutlinedDefault.default));
parcelHelpers.export(exports, "FingerprintRounded", ()=>(0, _fingerprintRoundedDefault.default));
parcelHelpers.export(exports, "FingerprintSharp", ()=>(0, _fingerprintSharpDefault.default));
parcelHelpers.export(exports, "FingerprintTwoTone", ()=>(0, _fingerprintTwoToneDefault.default));
parcelHelpers.export(exports, "FireExtinguisher", ()=>(0, _fireExtinguisherDefault.default));
parcelHelpers.export(exports, "FireExtinguisherOutlined", ()=>(0, _fireExtinguisherOutlinedDefault.default));
parcelHelpers.export(exports, "FireExtinguisherRounded", ()=>(0, _fireExtinguisherRoundedDefault.default));
parcelHelpers.export(exports, "FireExtinguisherSharp", ()=>(0, _fireExtinguisherSharpDefault.default));
parcelHelpers.export(exports, "FireExtinguisherTwoTone", ()=>(0, _fireExtinguisherTwoToneDefault.default));
parcelHelpers.export(exports, "FireHydrantAlt", ()=>(0, _fireHydrantAltDefault.default));
parcelHelpers.export(exports, "FireHydrantAltOutlined", ()=>(0, _fireHydrantAltOutlinedDefault.default));
parcelHelpers.export(exports, "FireHydrantAltRounded", ()=>(0, _fireHydrantAltRoundedDefault.default));
parcelHelpers.export(exports, "FireHydrantAltSharp", ()=>(0, _fireHydrantAltSharpDefault.default));
parcelHelpers.export(exports, "FireHydrantAltTwoTone", ()=>(0, _fireHydrantAltTwoToneDefault.default));
parcelHelpers.export(exports, "FireTruck", ()=>(0, _fireTruckDefault.default));
parcelHelpers.export(exports, "FireTruckOutlined", ()=>(0, _fireTruckOutlinedDefault.default));
parcelHelpers.export(exports, "FireTruckRounded", ()=>(0, _fireTruckRoundedDefault.default));
parcelHelpers.export(exports, "FireTruckSharp", ()=>(0, _fireTruckSharpDefault.default));
parcelHelpers.export(exports, "FireTruckTwoTone", ()=>(0, _fireTruckTwoToneDefault.default));
parcelHelpers.export(exports, "Fireplace", ()=>(0, _fireplaceDefault.default));
parcelHelpers.export(exports, "FireplaceOutlined", ()=>(0, _fireplaceOutlinedDefault.default));
parcelHelpers.export(exports, "FireplaceRounded", ()=>(0, _fireplaceRoundedDefault.default));
parcelHelpers.export(exports, "FireplaceSharp", ()=>(0, _fireplaceSharpDefault.default));
parcelHelpers.export(exports, "FireplaceTwoTone", ()=>(0, _fireplaceTwoToneDefault.default));
parcelHelpers.export(exports, "FirstPage", ()=>(0, _firstPageDefault.default));
parcelHelpers.export(exports, "FirstPageOutlined", ()=>(0, _firstPageOutlinedDefault.default));
parcelHelpers.export(exports, "FirstPageRounded", ()=>(0, _firstPageRoundedDefault.default));
parcelHelpers.export(exports, "FirstPageSharp", ()=>(0, _firstPageSharpDefault.default));
parcelHelpers.export(exports, "FirstPageTwoTone", ()=>(0, _firstPageTwoToneDefault.default));
parcelHelpers.export(exports, "FitScreen", ()=>(0, _fitScreenDefault.default));
parcelHelpers.export(exports, "FitScreenOutlined", ()=>(0, _fitScreenOutlinedDefault.default));
parcelHelpers.export(exports, "FitScreenRounded", ()=>(0, _fitScreenRoundedDefault.default));
parcelHelpers.export(exports, "FitScreenSharp", ()=>(0, _fitScreenSharpDefault.default));
parcelHelpers.export(exports, "FitScreenTwoTone", ()=>(0, _fitScreenTwoToneDefault.default));
parcelHelpers.export(exports, "Fitbit", ()=>(0, _fitbitDefault.default));
parcelHelpers.export(exports, "FitbitOutlined", ()=>(0, _fitbitOutlinedDefault.default));
parcelHelpers.export(exports, "FitbitRounded", ()=>(0, _fitbitRoundedDefault.default));
parcelHelpers.export(exports, "FitbitSharp", ()=>(0, _fitbitSharpDefault.default));
parcelHelpers.export(exports, "FitbitTwoTone", ()=>(0, _fitbitTwoToneDefault.default));
parcelHelpers.export(exports, "FitnessCenter", ()=>(0, _fitnessCenterDefault.default));
parcelHelpers.export(exports, "FitnessCenterOutlined", ()=>(0, _fitnessCenterOutlinedDefault.default));
parcelHelpers.export(exports, "FitnessCenterRounded", ()=>(0, _fitnessCenterRoundedDefault.default));
parcelHelpers.export(exports, "FitnessCenterSharp", ()=>(0, _fitnessCenterSharpDefault.default));
parcelHelpers.export(exports, "FitnessCenterTwoTone", ()=>(0, _fitnessCenterTwoToneDefault.default));
parcelHelpers.export(exports, "FiveG", ()=>(0, _fiveGDefault.default));
parcelHelpers.export(exports, "FiveGOutlined", ()=>(0, _fiveGOutlinedDefault.default));
parcelHelpers.export(exports, "FiveGRounded", ()=>(0, _fiveGRoundedDefault.default));
parcelHelpers.export(exports, "FiveGSharp", ()=>(0, _fiveGSharpDefault.default));
parcelHelpers.export(exports, "FiveGTwoTone", ()=>(0, _fiveGTwoToneDefault.default));
parcelHelpers.export(exports, "FiveK", ()=>(0, _fiveKDefault.default));
parcelHelpers.export(exports, "FiveKOutlined", ()=>(0, _fiveKOutlinedDefault.default));
parcelHelpers.export(exports, "FiveKPlus", ()=>(0, _fiveKPlusDefault.default));
parcelHelpers.export(exports, "FiveKPlusOutlined", ()=>(0, _fiveKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "FiveKPlusRounded", ()=>(0, _fiveKPlusRoundedDefault.default));
parcelHelpers.export(exports, "FiveKPlusSharp", ()=>(0, _fiveKPlusSharpDefault.default));
parcelHelpers.export(exports, "FiveKPlusTwoTone", ()=>(0, _fiveKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "FiveKRounded", ()=>(0, _fiveKRoundedDefault.default));
parcelHelpers.export(exports, "FiveKSharp", ()=>(0, _fiveKSharpDefault.default));
parcelHelpers.export(exports, "FiveKTwoTone", ()=>(0, _fiveKTwoToneDefault.default));
parcelHelpers.export(exports, "FiveMp", ()=>(0, _fiveMpDefault.default));
parcelHelpers.export(exports, "FiveMpOutlined", ()=>(0, _fiveMpOutlinedDefault.default));
parcelHelpers.export(exports, "FiveMpRounded", ()=>(0, _fiveMpRoundedDefault.default));
parcelHelpers.export(exports, "FiveMpSharp", ()=>(0, _fiveMpSharpDefault.default));
parcelHelpers.export(exports, "FiveMpTwoTone", ()=>(0, _fiveMpTwoToneDefault.default));
parcelHelpers.export(exports, "FivteenMp", ()=>(0, _fivteenMpDefault.default));
parcelHelpers.export(exports, "FivteenMpOutlined", ()=>(0, _fivteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "FivteenMpRounded", ()=>(0, _fivteenMpRoundedDefault.default));
parcelHelpers.export(exports, "FivteenMpSharp", ()=>(0, _fivteenMpSharpDefault.default));
parcelHelpers.export(exports, "FivteenMpTwoTone", ()=>(0, _fivteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "Flag", ()=>(0, _flagDefault.default));
parcelHelpers.export(exports, "FlagCircle", ()=>(0, _flagCircleDefault.default));
parcelHelpers.export(exports, "FlagCircleOutlined", ()=>(0, _flagCircleOutlinedDefault.default));
parcelHelpers.export(exports, "FlagCircleRounded", ()=>(0, _flagCircleRoundedDefault.default));
parcelHelpers.export(exports, "FlagCircleSharp", ()=>(0, _flagCircleSharpDefault.default));
parcelHelpers.export(exports, "FlagCircleTwoTone", ()=>(0, _flagCircleTwoToneDefault.default));
parcelHelpers.export(exports, "FlagOutlined", ()=>(0, _flagOutlinedDefault.default));
parcelHelpers.export(exports, "FlagRounded", ()=>(0, _flagRoundedDefault.default));
parcelHelpers.export(exports, "FlagSharp", ()=>(0, _flagSharpDefault.default));
parcelHelpers.export(exports, "FlagTwoTone", ()=>(0, _flagTwoToneDefault.default));
parcelHelpers.export(exports, "Flaky", ()=>(0, _flakyDefault.default));
parcelHelpers.export(exports, "FlakyOutlined", ()=>(0, _flakyOutlinedDefault.default));
parcelHelpers.export(exports, "FlakyRounded", ()=>(0, _flakyRoundedDefault.default));
parcelHelpers.export(exports, "FlakySharp", ()=>(0, _flakySharpDefault.default));
parcelHelpers.export(exports, "FlakyTwoTone", ()=>(0, _flakyTwoToneDefault.default));
parcelHelpers.export(exports, "Flare", ()=>(0, _flareDefault.default));
parcelHelpers.export(exports, "FlareOutlined", ()=>(0, _flareOutlinedDefault.default));
parcelHelpers.export(exports, "FlareRounded", ()=>(0, _flareRoundedDefault.default));
parcelHelpers.export(exports, "FlareSharp", ()=>(0, _flareSharpDefault.default));
parcelHelpers.export(exports, "FlareTwoTone", ()=>(0, _flareTwoToneDefault.default));
parcelHelpers.export(exports, "FlashAuto", ()=>(0, _flashAutoDefault.default));
parcelHelpers.export(exports, "FlashAutoOutlined", ()=>(0, _flashAutoOutlinedDefault.default));
parcelHelpers.export(exports, "FlashAutoRounded", ()=>(0, _flashAutoRoundedDefault.default));
parcelHelpers.export(exports, "FlashAutoSharp", ()=>(0, _flashAutoSharpDefault.default));
parcelHelpers.export(exports, "FlashAutoTwoTone", ()=>(0, _flashAutoTwoToneDefault.default));
parcelHelpers.export(exports, "FlashOff", ()=>(0, _flashOffDefault.default));
parcelHelpers.export(exports, "FlashOffOutlined", ()=>(0, _flashOffOutlinedDefault.default));
parcelHelpers.export(exports, "FlashOffRounded", ()=>(0, _flashOffRoundedDefault.default));
parcelHelpers.export(exports, "FlashOffSharp", ()=>(0, _flashOffSharpDefault.default));
parcelHelpers.export(exports, "FlashOffTwoTone", ()=>(0, _flashOffTwoToneDefault.default));
parcelHelpers.export(exports, "FlashOn", ()=>(0, _flashOnDefault.default));
parcelHelpers.export(exports, "FlashOnOutlined", ()=>(0, _flashOnOutlinedDefault.default));
parcelHelpers.export(exports, "FlashOnRounded", ()=>(0, _flashOnRoundedDefault.default));
parcelHelpers.export(exports, "FlashOnSharp", ()=>(0, _flashOnSharpDefault.default));
parcelHelpers.export(exports, "FlashOnTwoTone", ()=>(0, _flashOnTwoToneDefault.default));
parcelHelpers.export(exports, "FlashlightOff", ()=>(0, _flashlightOffDefault.default));
parcelHelpers.export(exports, "FlashlightOffOutlined", ()=>(0, _flashlightOffOutlinedDefault.default));
parcelHelpers.export(exports, "FlashlightOffRounded", ()=>(0, _flashlightOffRoundedDefault.default));
parcelHelpers.export(exports, "FlashlightOffSharp", ()=>(0, _flashlightOffSharpDefault.default));
parcelHelpers.export(exports, "FlashlightOffTwoTone", ()=>(0, _flashlightOffTwoToneDefault.default));
parcelHelpers.export(exports, "FlashlightOn", ()=>(0, _flashlightOnDefault.default));
parcelHelpers.export(exports, "FlashlightOnOutlined", ()=>(0, _flashlightOnOutlinedDefault.default));
parcelHelpers.export(exports, "FlashlightOnRounded", ()=>(0, _flashlightOnRoundedDefault.default));
parcelHelpers.export(exports, "FlashlightOnSharp", ()=>(0, _flashlightOnSharpDefault.default));
parcelHelpers.export(exports, "FlashlightOnTwoTone", ()=>(0, _flashlightOnTwoToneDefault.default));
parcelHelpers.export(exports, "Flatware", ()=>(0, _flatwareDefault.default));
parcelHelpers.export(exports, "FlatwareOutlined", ()=>(0, _flatwareOutlinedDefault.default));
parcelHelpers.export(exports, "FlatwareRounded", ()=>(0, _flatwareRoundedDefault.default));
parcelHelpers.export(exports, "FlatwareSharp", ()=>(0, _flatwareSharpDefault.default));
parcelHelpers.export(exports, "FlatwareTwoTone", ()=>(0, _flatwareTwoToneDefault.default));
parcelHelpers.export(exports, "Flight", ()=>(0, _flightDefault.default));
parcelHelpers.export(exports, "FlightClass", ()=>(0, _flightClassDefault.default));
parcelHelpers.export(exports, "FlightClassOutlined", ()=>(0, _flightClassOutlinedDefault.default));
parcelHelpers.export(exports, "FlightClassRounded", ()=>(0, _flightClassRoundedDefault.default));
parcelHelpers.export(exports, "FlightClassSharp", ()=>(0, _flightClassSharpDefault.default));
parcelHelpers.export(exports, "FlightClassTwoTone", ()=>(0, _flightClassTwoToneDefault.default));
parcelHelpers.export(exports, "FlightLand", ()=>(0, _flightLandDefault.default));
parcelHelpers.export(exports, "FlightLandOutlined", ()=>(0, _flightLandOutlinedDefault.default));
parcelHelpers.export(exports, "FlightLandRounded", ()=>(0, _flightLandRoundedDefault.default));
parcelHelpers.export(exports, "FlightLandSharp", ()=>(0, _flightLandSharpDefault.default));
parcelHelpers.export(exports, "FlightLandTwoTone", ()=>(0, _flightLandTwoToneDefault.default));
parcelHelpers.export(exports, "FlightOutlined", ()=>(0, _flightOutlinedDefault.default));
parcelHelpers.export(exports, "FlightRounded", ()=>(0, _flightRoundedDefault.default));
parcelHelpers.export(exports, "FlightSharp", ()=>(0, _flightSharpDefault.default));
parcelHelpers.export(exports, "FlightTakeoff", ()=>(0, _flightTakeoffDefault.default));
parcelHelpers.export(exports, "FlightTakeoffOutlined", ()=>(0, _flightTakeoffOutlinedDefault.default));
parcelHelpers.export(exports, "FlightTakeoffRounded", ()=>(0, _flightTakeoffRoundedDefault.default));
parcelHelpers.export(exports, "FlightTakeoffSharp", ()=>(0, _flightTakeoffSharpDefault.default));
parcelHelpers.export(exports, "FlightTakeoffTwoTone", ()=>(0, _flightTakeoffTwoToneDefault.default));
parcelHelpers.export(exports, "FlightTwoTone", ()=>(0, _flightTwoToneDefault.default));
parcelHelpers.export(exports, "Flip", ()=>(0, _flipDefault.default));
parcelHelpers.export(exports, "FlipCameraAndroid", ()=>(0, _flipCameraAndroidDefault.default));
parcelHelpers.export(exports, "FlipCameraAndroidOutlined", ()=>(0, _flipCameraAndroidOutlinedDefault.default));
parcelHelpers.export(exports, "FlipCameraAndroidRounded", ()=>(0, _flipCameraAndroidRoundedDefault.default));
parcelHelpers.export(exports, "FlipCameraAndroidSharp", ()=>(0, _flipCameraAndroidSharpDefault.default));
parcelHelpers.export(exports, "FlipCameraAndroidTwoTone", ()=>(0, _flipCameraAndroidTwoToneDefault.default));
parcelHelpers.export(exports, "FlipCameraIos", ()=>(0, _flipCameraIosDefault.default));
parcelHelpers.export(exports, "FlipCameraIosOutlined", ()=>(0, _flipCameraIosOutlinedDefault.default));
parcelHelpers.export(exports, "FlipCameraIosRounded", ()=>(0, _flipCameraIosRoundedDefault.default));
parcelHelpers.export(exports, "FlipCameraIosSharp", ()=>(0, _flipCameraIosSharpDefault.default));
parcelHelpers.export(exports, "FlipCameraIosTwoTone", ()=>(0, _flipCameraIosTwoToneDefault.default));
parcelHelpers.export(exports, "FlipOutlined", ()=>(0, _flipOutlinedDefault.default));
parcelHelpers.export(exports, "FlipRounded", ()=>(0, _flipRoundedDefault.default));
parcelHelpers.export(exports, "FlipSharp", ()=>(0, _flipSharpDefault.default));
parcelHelpers.export(exports, "FlipToBack", ()=>(0, _flipToBackDefault.default));
parcelHelpers.export(exports, "FlipToBackOutlined", ()=>(0, _flipToBackOutlinedDefault.default));
parcelHelpers.export(exports, "FlipToBackRounded", ()=>(0, _flipToBackRoundedDefault.default));
parcelHelpers.export(exports, "FlipToBackSharp", ()=>(0, _flipToBackSharpDefault.default));
parcelHelpers.export(exports, "FlipToBackTwoTone", ()=>(0, _flipToBackTwoToneDefault.default));
parcelHelpers.export(exports, "FlipToFront", ()=>(0, _flipToFrontDefault.default));
parcelHelpers.export(exports, "FlipToFrontOutlined", ()=>(0, _flipToFrontOutlinedDefault.default));
parcelHelpers.export(exports, "FlipToFrontRounded", ()=>(0, _flipToFrontRoundedDefault.default));
parcelHelpers.export(exports, "FlipToFrontSharp", ()=>(0, _flipToFrontSharpDefault.default));
parcelHelpers.export(exports, "FlipToFrontTwoTone", ()=>(0, _flipToFrontTwoToneDefault.default));
parcelHelpers.export(exports, "FlipTwoTone", ()=>(0, _flipTwoToneDefault.default));
parcelHelpers.export(exports, "Flood", ()=>(0, _floodDefault.default));
parcelHelpers.export(exports, "FloodOutlined", ()=>(0, _floodOutlinedDefault.default));
parcelHelpers.export(exports, "FloodRounded", ()=>(0, _floodRoundedDefault.default));
parcelHelpers.export(exports, "FloodSharp", ()=>(0, _floodSharpDefault.default));
parcelHelpers.export(exports, "FloodTwoTone", ()=>(0, _floodTwoToneDefault.default));
parcelHelpers.export(exports, "Fluorescent", ()=>(0, _fluorescentDefault.default));
parcelHelpers.export(exports, "FluorescentOutlined", ()=>(0, _fluorescentOutlinedDefault.default));
parcelHelpers.export(exports, "FluorescentRounded", ()=>(0, _fluorescentRoundedDefault.default));
parcelHelpers.export(exports, "FluorescentSharp", ()=>(0, _fluorescentSharpDefault.default));
parcelHelpers.export(exports, "FluorescentTwoTone", ()=>(0, _fluorescentTwoToneDefault.default));
parcelHelpers.export(exports, "FlutterDash", ()=>(0, _flutterDashDefault.default));
parcelHelpers.export(exports, "FlutterDashOutlined", ()=>(0, _flutterDashOutlinedDefault.default));
parcelHelpers.export(exports, "FlutterDashRounded", ()=>(0, _flutterDashRoundedDefault.default));
parcelHelpers.export(exports, "FlutterDashSharp", ()=>(0, _flutterDashSharpDefault.default));
parcelHelpers.export(exports, "FlutterDashTwoTone", ()=>(0, _flutterDashTwoToneDefault.default));
parcelHelpers.export(exports, "FmdBad", ()=>(0, _fmdBadDefault.default));
parcelHelpers.export(exports, "FmdBadOutlined", ()=>(0, _fmdBadOutlinedDefault.default));
parcelHelpers.export(exports, "FmdBadRounded", ()=>(0, _fmdBadRoundedDefault.default));
parcelHelpers.export(exports, "FmdBadSharp", ()=>(0, _fmdBadSharpDefault.default));
parcelHelpers.export(exports, "FmdBadTwoTone", ()=>(0, _fmdBadTwoToneDefault.default));
parcelHelpers.export(exports, "FmdGood", ()=>(0, _fmdGoodDefault.default));
parcelHelpers.export(exports, "FmdGoodOutlined", ()=>(0, _fmdGoodOutlinedDefault.default));
parcelHelpers.export(exports, "FmdGoodRounded", ()=>(0, _fmdGoodRoundedDefault.default));
parcelHelpers.export(exports, "FmdGoodSharp", ()=>(0, _fmdGoodSharpDefault.default));
parcelHelpers.export(exports, "FmdGoodTwoTone", ()=>(0, _fmdGoodTwoToneDefault.default));
parcelHelpers.export(exports, "Folder", ()=>(0, _folderDefault.default));
parcelHelpers.export(exports, "FolderCopy", ()=>(0, _folderCopyDefault.default));
parcelHelpers.export(exports, "FolderCopyOutlined", ()=>(0, _folderCopyOutlinedDefault.default));
parcelHelpers.export(exports, "FolderCopyRounded", ()=>(0, _folderCopyRoundedDefault.default));
parcelHelpers.export(exports, "FolderCopySharp", ()=>(0, _folderCopySharpDefault.default));
parcelHelpers.export(exports, "FolderCopyTwoTone", ()=>(0, _folderCopyTwoToneDefault.default));
parcelHelpers.export(exports, "FolderDelete", ()=>(0, _folderDeleteDefault.default));
parcelHelpers.export(exports, "FolderDeleteOutlined", ()=>(0, _folderDeleteOutlinedDefault.default));
parcelHelpers.export(exports, "FolderDeleteRounded", ()=>(0, _folderDeleteRoundedDefault.default));
parcelHelpers.export(exports, "FolderDeleteSharp", ()=>(0, _folderDeleteSharpDefault.default));
parcelHelpers.export(exports, "FolderDeleteTwoTone", ()=>(0, _folderDeleteTwoToneDefault.default));
parcelHelpers.export(exports, "FolderOff", ()=>(0, _folderOffDefault.default));
parcelHelpers.export(exports, "FolderOffOutlined", ()=>(0, _folderOffOutlinedDefault.default));
parcelHelpers.export(exports, "FolderOffRounded", ()=>(0, _folderOffRoundedDefault.default));
parcelHelpers.export(exports, "FolderOffSharp", ()=>(0, _folderOffSharpDefault.default));
parcelHelpers.export(exports, "FolderOffTwoTone", ()=>(0, _folderOffTwoToneDefault.default));
parcelHelpers.export(exports, "FolderOpen", ()=>(0, _folderOpenDefault.default));
parcelHelpers.export(exports, "FolderOpenOutlined", ()=>(0, _folderOpenOutlinedDefault.default));
parcelHelpers.export(exports, "FolderOpenRounded", ()=>(0, _folderOpenRoundedDefault.default));
parcelHelpers.export(exports, "FolderOpenSharp", ()=>(0, _folderOpenSharpDefault.default));
parcelHelpers.export(exports, "FolderOpenTwoTone", ()=>(0, _folderOpenTwoToneDefault.default));
parcelHelpers.export(exports, "FolderOutlined", ()=>(0, _folderOutlinedDefault.default));
parcelHelpers.export(exports, "FolderRounded", ()=>(0, _folderRoundedDefault.default));
parcelHelpers.export(exports, "FolderShared", ()=>(0, _folderSharedDefault.default));
parcelHelpers.export(exports, "FolderSharedOutlined", ()=>(0, _folderSharedOutlinedDefault.default));
parcelHelpers.export(exports, "FolderSharedRounded", ()=>(0, _folderSharedRoundedDefault.default));
parcelHelpers.export(exports, "FolderSharedSharp", ()=>(0, _folderSharedSharpDefault.default));
parcelHelpers.export(exports, "FolderSharedTwoTone", ()=>(0, _folderSharedTwoToneDefault.default));
parcelHelpers.export(exports, "FolderSharp", ()=>(0, _folderSharpDefault.default));
parcelHelpers.export(exports, "FolderSpecial", ()=>(0, _folderSpecialDefault.default));
parcelHelpers.export(exports, "FolderSpecialOutlined", ()=>(0, _folderSpecialOutlinedDefault.default));
parcelHelpers.export(exports, "FolderSpecialRounded", ()=>(0, _folderSpecialRoundedDefault.default));
parcelHelpers.export(exports, "FolderSpecialSharp", ()=>(0, _folderSpecialSharpDefault.default));
parcelHelpers.export(exports, "FolderSpecialTwoTone", ()=>(0, _folderSpecialTwoToneDefault.default));
parcelHelpers.export(exports, "FolderTwoTone", ()=>(0, _folderTwoToneDefault.default));
parcelHelpers.export(exports, "FolderZip", ()=>(0, _folderZipDefault.default));
parcelHelpers.export(exports, "FolderZipOutlined", ()=>(0, _folderZipOutlinedDefault.default));
parcelHelpers.export(exports, "FolderZipRounded", ()=>(0, _folderZipRoundedDefault.default));
parcelHelpers.export(exports, "FolderZipSharp", ()=>(0, _folderZipSharpDefault.default));
parcelHelpers.export(exports, "FolderZipTwoTone", ()=>(0, _folderZipTwoToneDefault.default));
parcelHelpers.export(exports, "FollowTheSigns", ()=>(0, _followTheSignsDefault.default));
parcelHelpers.export(exports, "FollowTheSignsOutlined", ()=>(0, _followTheSignsOutlinedDefault.default));
parcelHelpers.export(exports, "FollowTheSignsRounded", ()=>(0, _followTheSignsRoundedDefault.default));
parcelHelpers.export(exports, "FollowTheSignsSharp", ()=>(0, _followTheSignsSharpDefault.default));
parcelHelpers.export(exports, "FollowTheSignsTwoTone", ()=>(0, _followTheSignsTwoToneDefault.default));
parcelHelpers.export(exports, "FontDownload", ()=>(0, _fontDownloadDefault.default));
parcelHelpers.export(exports, "FontDownloadOff", ()=>(0, _fontDownloadOffDefault.default));
parcelHelpers.export(exports, "FontDownloadOffOutlined", ()=>(0, _fontDownloadOffOutlinedDefault.default));
parcelHelpers.export(exports, "FontDownloadOffRounded", ()=>(0, _fontDownloadOffRoundedDefault.default));
parcelHelpers.export(exports, "FontDownloadOffSharp", ()=>(0, _fontDownloadOffSharpDefault.default));
parcelHelpers.export(exports, "FontDownloadOffTwoTone", ()=>(0, _fontDownloadOffTwoToneDefault.default));
parcelHelpers.export(exports, "FontDownloadOutlined", ()=>(0, _fontDownloadOutlinedDefault.default));
parcelHelpers.export(exports, "FontDownloadRounded", ()=>(0, _fontDownloadRoundedDefault.default));
parcelHelpers.export(exports, "FontDownloadSharp", ()=>(0, _fontDownloadSharpDefault.default));
parcelHelpers.export(exports, "FontDownloadTwoTone", ()=>(0, _fontDownloadTwoToneDefault.default));
parcelHelpers.export(exports, "FoodBank", ()=>(0, _foodBankDefault.default));
parcelHelpers.export(exports, "FoodBankOutlined", ()=>(0, _foodBankOutlinedDefault.default));
parcelHelpers.export(exports, "FoodBankRounded", ()=>(0, _foodBankRoundedDefault.default));
parcelHelpers.export(exports, "FoodBankSharp", ()=>(0, _foodBankSharpDefault.default));
parcelHelpers.export(exports, "FoodBankTwoTone", ()=>(0, _foodBankTwoToneDefault.default));
parcelHelpers.export(exports, "Forest", ()=>(0, _forestDefault.default));
parcelHelpers.export(exports, "ForestOutlined", ()=>(0, _forestOutlinedDefault.default));
parcelHelpers.export(exports, "ForestRounded", ()=>(0, _forestRoundedDefault.default));
parcelHelpers.export(exports, "ForestSharp", ()=>(0, _forestSharpDefault.default));
parcelHelpers.export(exports, "ForestTwoTone", ()=>(0, _forestTwoToneDefault.default));
parcelHelpers.export(exports, "ForkLeft", ()=>(0, _forkLeftDefault.default));
parcelHelpers.export(exports, "ForkLeftOutlined", ()=>(0, _forkLeftOutlinedDefault.default));
parcelHelpers.export(exports, "ForkLeftRounded", ()=>(0, _forkLeftRoundedDefault.default));
parcelHelpers.export(exports, "ForkLeftSharp", ()=>(0, _forkLeftSharpDefault.default));
parcelHelpers.export(exports, "ForkLeftTwoTone", ()=>(0, _forkLeftTwoToneDefault.default));
parcelHelpers.export(exports, "ForkRight", ()=>(0, _forkRightDefault.default));
parcelHelpers.export(exports, "ForkRightOutlined", ()=>(0, _forkRightOutlinedDefault.default));
parcelHelpers.export(exports, "ForkRightRounded", ()=>(0, _forkRightRoundedDefault.default));
parcelHelpers.export(exports, "ForkRightSharp", ()=>(0, _forkRightSharpDefault.default));
parcelHelpers.export(exports, "ForkRightTwoTone", ()=>(0, _forkRightTwoToneDefault.default));
parcelHelpers.export(exports, "FormatAlignCenter", ()=>(0, _formatAlignCenterDefault.default));
parcelHelpers.export(exports, "FormatAlignCenterOutlined", ()=>(0, _formatAlignCenterOutlinedDefault.default));
parcelHelpers.export(exports, "FormatAlignCenterRounded", ()=>(0, _formatAlignCenterRoundedDefault.default));
parcelHelpers.export(exports, "FormatAlignCenterSharp", ()=>(0, _formatAlignCenterSharpDefault.default));
parcelHelpers.export(exports, "FormatAlignCenterTwoTone", ()=>(0, _formatAlignCenterTwoToneDefault.default));
parcelHelpers.export(exports, "FormatAlignJustify", ()=>(0, _formatAlignJustifyDefault.default));
parcelHelpers.export(exports, "FormatAlignJustifyOutlined", ()=>(0, _formatAlignJustifyOutlinedDefault.default));
parcelHelpers.export(exports, "FormatAlignJustifyRounded", ()=>(0, _formatAlignJustifyRoundedDefault.default));
parcelHelpers.export(exports, "FormatAlignJustifySharp", ()=>(0, _formatAlignJustifySharpDefault.default));
parcelHelpers.export(exports, "FormatAlignJustifyTwoTone", ()=>(0, _formatAlignJustifyTwoToneDefault.default));
parcelHelpers.export(exports, "FormatAlignLeft", ()=>(0, _formatAlignLeftDefault.default));
parcelHelpers.export(exports, "FormatAlignLeftOutlined", ()=>(0, _formatAlignLeftOutlinedDefault.default));
parcelHelpers.export(exports, "FormatAlignLeftRounded", ()=>(0, _formatAlignLeftRoundedDefault.default));
parcelHelpers.export(exports, "FormatAlignLeftSharp", ()=>(0, _formatAlignLeftSharpDefault.default));
parcelHelpers.export(exports, "FormatAlignLeftTwoTone", ()=>(0, _formatAlignLeftTwoToneDefault.default));
parcelHelpers.export(exports, "FormatAlignRight", ()=>(0, _formatAlignRightDefault.default));
parcelHelpers.export(exports, "FormatAlignRightOutlined", ()=>(0, _formatAlignRightOutlinedDefault.default));
parcelHelpers.export(exports, "FormatAlignRightRounded", ()=>(0, _formatAlignRightRoundedDefault.default));
parcelHelpers.export(exports, "FormatAlignRightSharp", ()=>(0, _formatAlignRightSharpDefault.default));
parcelHelpers.export(exports, "FormatAlignRightTwoTone", ()=>(0, _formatAlignRightTwoToneDefault.default));
parcelHelpers.export(exports, "FormatBold", ()=>(0, _formatBoldDefault.default));
parcelHelpers.export(exports, "FormatBoldOutlined", ()=>(0, _formatBoldOutlinedDefault.default));
parcelHelpers.export(exports, "FormatBoldRounded", ()=>(0, _formatBoldRoundedDefault.default));
parcelHelpers.export(exports, "FormatBoldSharp", ()=>(0, _formatBoldSharpDefault.default));
parcelHelpers.export(exports, "FormatBoldTwoTone", ()=>(0, _formatBoldTwoToneDefault.default));
parcelHelpers.export(exports, "FormatClear", ()=>(0, _formatClearDefault.default));
parcelHelpers.export(exports, "FormatClearOutlined", ()=>(0, _formatClearOutlinedDefault.default));
parcelHelpers.export(exports, "FormatClearRounded", ()=>(0, _formatClearRoundedDefault.default));
parcelHelpers.export(exports, "FormatClearSharp", ()=>(0, _formatClearSharpDefault.default));
parcelHelpers.export(exports, "FormatClearTwoTone", ()=>(0, _formatClearTwoToneDefault.default));
parcelHelpers.export(exports, "FormatColorFill", ()=>(0, _formatColorFillDefault.default));
parcelHelpers.export(exports, "FormatColorFillOutlined", ()=>(0, _formatColorFillOutlinedDefault.default));
parcelHelpers.export(exports, "FormatColorFillRounded", ()=>(0, _formatColorFillRoundedDefault.default));
parcelHelpers.export(exports, "FormatColorFillSharp", ()=>(0, _formatColorFillSharpDefault.default));
parcelHelpers.export(exports, "FormatColorFillTwoTone", ()=>(0, _formatColorFillTwoToneDefault.default));
parcelHelpers.export(exports, "FormatColorReset", ()=>(0, _formatColorResetDefault.default));
parcelHelpers.export(exports, "FormatColorResetOutlined", ()=>(0, _formatColorResetOutlinedDefault.default));
parcelHelpers.export(exports, "FormatColorResetRounded", ()=>(0, _formatColorResetRoundedDefault.default));
parcelHelpers.export(exports, "FormatColorResetSharp", ()=>(0, _formatColorResetSharpDefault.default));
parcelHelpers.export(exports, "FormatColorResetTwoTone", ()=>(0, _formatColorResetTwoToneDefault.default));
parcelHelpers.export(exports, "FormatColorText", ()=>(0, _formatColorTextDefault.default));
parcelHelpers.export(exports, "FormatColorTextOutlined", ()=>(0, _formatColorTextOutlinedDefault.default));
parcelHelpers.export(exports, "FormatColorTextRounded", ()=>(0, _formatColorTextRoundedDefault.default));
parcelHelpers.export(exports, "FormatColorTextSharp", ()=>(0, _formatColorTextSharpDefault.default));
parcelHelpers.export(exports, "FormatColorTextTwoTone", ()=>(0, _formatColorTextTwoToneDefault.default));
parcelHelpers.export(exports, "FormatIndentDecrease", ()=>(0, _formatIndentDecreaseDefault.default));
parcelHelpers.export(exports, "FormatIndentDecreaseOutlined", ()=>(0, _formatIndentDecreaseOutlinedDefault.default));
parcelHelpers.export(exports, "FormatIndentDecreaseRounded", ()=>(0, _formatIndentDecreaseRoundedDefault.default));
parcelHelpers.export(exports, "FormatIndentDecreaseSharp", ()=>(0, _formatIndentDecreaseSharpDefault.default));
parcelHelpers.export(exports, "FormatIndentDecreaseTwoTone", ()=>(0, _formatIndentDecreaseTwoToneDefault.default));
parcelHelpers.export(exports, "FormatIndentIncrease", ()=>(0, _formatIndentIncreaseDefault.default));
parcelHelpers.export(exports, "FormatIndentIncreaseOutlined", ()=>(0, _formatIndentIncreaseOutlinedDefault.default));
parcelHelpers.export(exports, "FormatIndentIncreaseRounded", ()=>(0, _formatIndentIncreaseRoundedDefault.default));
parcelHelpers.export(exports, "FormatIndentIncreaseSharp", ()=>(0, _formatIndentIncreaseSharpDefault.default));
parcelHelpers.export(exports, "FormatIndentIncreaseTwoTone", ()=>(0, _formatIndentIncreaseTwoToneDefault.default));
parcelHelpers.export(exports, "FormatItalic", ()=>(0, _formatItalicDefault.default));
parcelHelpers.export(exports, "FormatItalicOutlined", ()=>(0, _formatItalicOutlinedDefault.default));
parcelHelpers.export(exports, "FormatItalicRounded", ()=>(0, _formatItalicRoundedDefault.default));
parcelHelpers.export(exports, "FormatItalicSharp", ()=>(0, _formatItalicSharpDefault.default));
parcelHelpers.export(exports, "FormatItalicTwoTone", ()=>(0, _formatItalicTwoToneDefault.default));
parcelHelpers.export(exports, "FormatLineSpacing", ()=>(0, _formatLineSpacingDefault.default));
parcelHelpers.export(exports, "FormatLineSpacingOutlined", ()=>(0, _formatLineSpacingOutlinedDefault.default));
parcelHelpers.export(exports, "FormatLineSpacingRounded", ()=>(0, _formatLineSpacingRoundedDefault.default));
parcelHelpers.export(exports, "FormatLineSpacingSharp", ()=>(0, _formatLineSpacingSharpDefault.default));
parcelHelpers.export(exports, "FormatLineSpacingTwoTone", ()=>(0, _formatLineSpacingTwoToneDefault.default));
parcelHelpers.export(exports, "FormatListBulleted", ()=>(0, _formatListBulletedDefault.default));
parcelHelpers.export(exports, "FormatListBulletedOutlined", ()=>(0, _formatListBulletedOutlinedDefault.default));
parcelHelpers.export(exports, "FormatListBulletedRounded", ()=>(0, _formatListBulletedRoundedDefault.default));
parcelHelpers.export(exports, "FormatListBulletedSharp", ()=>(0, _formatListBulletedSharpDefault.default));
parcelHelpers.export(exports, "FormatListBulletedTwoTone", ()=>(0, _formatListBulletedTwoToneDefault.default));
parcelHelpers.export(exports, "FormatListNumbered", ()=>(0, _formatListNumberedDefault.default));
parcelHelpers.export(exports, "FormatListNumberedOutlined", ()=>(0, _formatListNumberedOutlinedDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRounded", ()=>(0, _formatListNumberedRoundedDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRtl", ()=>(0, _formatListNumberedRtlDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRtlOutlined", ()=>(0, _formatListNumberedRtlOutlinedDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRtlRounded", ()=>(0, _formatListNumberedRtlRoundedDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRtlSharp", ()=>(0, _formatListNumberedRtlSharpDefault.default));
parcelHelpers.export(exports, "FormatListNumberedRtlTwoTone", ()=>(0, _formatListNumberedRtlTwoToneDefault.default));
parcelHelpers.export(exports, "FormatListNumberedSharp", ()=>(0, _formatListNumberedSharpDefault.default));
parcelHelpers.export(exports, "FormatListNumberedTwoTone", ()=>(0, _formatListNumberedTwoToneDefault.default));
parcelHelpers.export(exports, "FormatOverline", ()=>(0, _formatOverlineDefault.default));
parcelHelpers.export(exports, "FormatOverlineOutlined", ()=>(0, _formatOverlineOutlinedDefault.default));
parcelHelpers.export(exports, "FormatOverlineRounded", ()=>(0, _formatOverlineRoundedDefault.default));
parcelHelpers.export(exports, "FormatOverlineSharp", ()=>(0, _formatOverlineSharpDefault.default));
parcelHelpers.export(exports, "FormatOverlineTwoTone", ()=>(0, _formatOverlineTwoToneDefault.default));
parcelHelpers.export(exports, "FormatPaint", ()=>(0, _formatPaintDefault.default));
parcelHelpers.export(exports, "FormatPaintOutlined", ()=>(0, _formatPaintOutlinedDefault.default));
parcelHelpers.export(exports, "FormatPaintRounded", ()=>(0, _formatPaintRoundedDefault.default));
parcelHelpers.export(exports, "FormatPaintSharp", ()=>(0, _formatPaintSharpDefault.default));
parcelHelpers.export(exports, "FormatPaintTwoTone", ()=>(0, _formatPaintTwoToneDefault.default));
parcelHelpers.export(exports, "FormatQuote", ()=>(0, _formatQuoteDefault.default));
parcelHelpers.export(exports, "FormatQuoteOutlined", ()=>(0, _formatQuoteOutlinedDefault.default));
parcelHelpers.export(exports, "FormatQuoteRounded", ()=>(0, _formatQuoteRoundedDefault.default));
parcelHelpers.export(exports, "FormatQuoteSharp", ()=>(0, _formatQuoteSharpDefault.default));
parcelHelpers.export(exports, "FormatQuoteTwoTone", ()=>(0, _formatQuoteTwoToneDefault.default));
parcelHelpers.export(exports, "FormatShapes", ()=>(0, _formatShapesDefault.default));
parcelHelpers.export(exports, "FormatShapesOutlined", ()=>(0, _formatShapesOutlinedDefault.default));
parcelHelpers.export(exports, "FormatShapesRounded", ()=>(0, _formatShapesRoundedDefault.default));
parcelHelpers.export(exports, "FormatShapesSharp", ()=>(0, _formatShapesSharpDefault.default));
parcelHelpers.export(exports, "FormatShapesTwoTone", ()=>(0, _formatShapesTwoToneDefault.default));
parcelHelpers.export(exports, "FormatSize", ()=>(0, _formatSizeDefault.default));
parcelHelpers.export(exports, "FormatSizeOutlined", ()=>(0, _formatSizeOutlinedDefault.default));
parcelHelpers.export(exports, "FormatSizeRounded", ()=>(0, _formatSizeRoundedDefault.default));
parcelHelpers.export(exports, "FormatSizeSharp", ()=>(0, _formatSizeSharpDefault.default));
parcelHelpers.export(exports, "FormatSizeTwoTone", ()=>(0, _formatSizeTwoToneDefault.default));
parcelHelpers.export(exports, "FormatStrikethrough", ()=>(0, _formatStrikethroughDefault.default));
parcelHelpers.export(exports, "FormatStrikethroughOutlined", ()=>(0, _formatStrikethroughOutlinedDefault.default));
parcelHelpers.export(exports, "FormatStrikethroughRounded", ()=>(0, _formatStrikethroughRoundedDefault.default));
parcelHelpers.export(exports, "FormatStrikethroughSharp", ()=>(0, _formatStrikethroughSharpDefault.default));
parcelHelpers.export(exports, "FormatStrikethroughTwoTone", ()=>(0, _formatStrikethroughTwoToneDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionLToR", ()=>(0, _formatTextdirectionLToRDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionLToROutlined", ()=>(0, _formatTextdirectionLToROutlinedDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionLToRRounded", ()=>(0, _formatTextdirectionLToRRoundedDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionLToRSharp", ()=>(0, _formatTextdirectionLToRSharpDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionLToRTwoTone", ()=>(0, _formatTextdirectionLToRTwoToneDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionRToL", ()=>(0, _formatTextdirectionRToLDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionRToLOutlined", ()=>(0, _formatTextdirectionRToLOutlinedDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionRToLRounded", ()=>(0, _formatTextdirectionRToLRoundedDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionRToLSharp", ()=>(0, _formatTextdirectionRToLSharpDefault.default));
parcelHelpers.export(exports, "FormatTextdirectionRToLTwoTone", ()=>(0, _formatTextdirectionRToLTwoToneDefault.default));
parcelHelpers.export(exports, "FormatUnderlined", ()=>(0, _formatUnderlinedDefault.default));
parcelHelpers.export(exports, "FormatUnderlinedOutlined", ()=>(0, _formatUnderlinedOutlinedDefault.default));
parcelHelpers.export(exports, "FormatUnderlinedRounded", ()=>(0, _formatUnderlinedRoundedDefault.default));
parcelHelpers.export(exports, "FormatUnderlinedSharp", ()=>(0, _formatUnderlinedSharpDefault.default));
parcelHelpers.export(exports, "FormatUnderlinedTwoTone", ()=>(0, _formatUnderlinedTwoToneDefault.default));
parcelHelpers.export(exports, "Fort", ()=>(0, _fortDefault.default));
parcelHelpers.export(exports, "FortOutlined", ()=>(0, _fortOutlinedDefault.default));
parcelHelpers.export(exports, "FortRounded", ()=>(0, _fortRoundedDefault.default));
parcelHelpers.export(exports, "FortSharp", ()=>(0, _fortSharpDefault.default));
parcelHelpers.export(exports, "FortTwoTone", ()=>(0, _fortTwoToneDefault.default));
parcelHelpers.export(exports, "Forum", ()=>(0, _forumDefault.default));
parcelHelpers.export(exports, "ForumOutlined", ()=>(0, _forumOutlinedDefault.default));
parcelHelpers.export(exports, "ForumRounded", ()=>(0, _forumRoundedDefault.default));
parcelHelpers.export(exports, "ForumSharp", ()=>(0, _forumSharpDefault.default));
parcelHelpers.export(exports, "ForumTwoTone", ()=>(0, _forumTwoToneDefault.default));
parcelHelpers.export(exports, "Forward", ()=>(0, _forwardDefault.default));
parcelHelpers.export(exports, "Forward10", ()=>(0, _forward10Default.default));
parcelHelpers.export(exports, "Forward10Outlined", ()=>(0, _forward10OutlinedDefault.default));
parcelHelpers.export(exports, "Forward10Rounded", ()=>(0, _forward10RoundedDefault.default));
parcelHelpers.export(exports, "Forward10Sharp", ()=>(0, _forward10SharpDefault.default));
parcelHelpers.export(exports, "Forward10TwoTone", ()=>(0, _forward10TwoToneDefault.default));
parcelHelpers.export(exports, "Forward30", ()=>(0, _forward30Default.default));
parcelHelpers.export(exports, "Forward30Outlined", ()=>(0, _forward30OutlinedDefault.default));
parcelHelpers.export(exports, "Forward30Rounded", ()=>(0, _forward30RoundedDefault.default));
parcelHelpers.export(exports, "Forward30Sharp", ()=>(0, _forward30SharpDefault.default));
parcelHelpers.export(exports, "Forward30TwoTone", ()=>(0, _forward30TwoToneDefault.default));
parcelHelpers.export(exports, "Forward5", ()=>(0, _forward5Default.default));
parcelHelpers.export(exports, "Forward5Outlined", ()=>(0, _forward5OutlinedDefault.default));
parcelHelpers.export(exports, "Forward5Rounded", ()=>(0, _forward5RoundedDefault.default));
parcelHelpers.export(exports, "Forward5Sharp", ()=>(0, _forward5SharpDefault.default));
parcelHelpers.export(exports, "Forward5TwoTone", ()=>(0, _forward5TwoToneDefault.default));
parcelHelpers.export(exports, "ForwardOutlined", ()=>(0, _forwardOutlinedDefault.default));
parcelHelpers.export(exports, "ForwardRounded", ()=>(0, _forwardRoundedDefault.default));
parcelHelpers.export(exports, "ForwardSharp", ()=>(0, _forwardSharpDefault.default));
parcelHelpers.export(exports, "ForwardToInbox", ()=>(0, _forwardToInboxDefault.default));
parcelHelpers.export(exports, "ForwardToInboxOutlined", ()=>(0, _forwardToInboxOutlinedDefault.default));
parcelHelpers.export(exports, "ForwardToInboxRounded", ()=>(0, _forwardToInboxRoundedDefault.default));
parcelHelpers.export(exports, "ForwardToInboxSharp", ()=>(0, _forwardToInboxSharpDefault.default));
parcelHelpers.export(exports, "ForwardToInboxTwoTone", ()=>(0, _forwardToInboxTwoToneDefault.default));
parcelHelpers.export(exports, "ForwardTwoTone", ()=>(0, _forwardTwoToneDefault.default));
parcelHelpers.export(exports, "Foundation", ()=>(0, _foundationDefault.default));
parcelHelpers.export(exports, "FoundationOutlined", ()=>(0, _foundationOutlinedDefault.default));
parcelHelpers.export(exports, "FoundationRounded", ()=>(0, _foundationRoundedDefault.default));
parcelHelpers.export(exports, "FoundationSharp", ()=>(0, _foundationSharpDefault.default));
parcelHelpers.export(exports, "FoundationTwoTone", ()=>(0, _foundationTwoToneDefault.default));
parcelHelpers.export(exports, "FourGMobiledata", ()=>(0, _fourGMobiledataDefault.default));
parcelHelpers.export(exports, "FourGMobiledataOutlined", ()=>(0, _fourGMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "FourGMobiledataRounded", ()=>(0, _fourGMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "FourGMobiledataSharp", ()=>(0, _fourGMobiledataSharpDefault.default));
parcelHelpers.export(exports, "FourGMobiledataTwoTone", ()=>(0, _fourGMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "FourGPlusMobiledata", ()=>(0, _fourGPlusMobiledataDefault.default));
parcelHelpers.export(exports, "FourGPlusMobiledataOutlined", ()=>(0, _fourGPlusMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "FourGPlusMobiledataRounded", ()=>(0, _fourGPlusMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "FourGPlusMobiledataSharp", ()=>(0, _fourGPlusMobiledataSharpDefault.default));
parcelHelpers.export(exports, "FourGPlusMobiledataTwoTone", ()=>(0, _fourGPlusMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "FourK", ()=>(0, _fourKDefault.default));
parcelHelpers.export(exports, "FourKOutlined", ()=>(0, _fourKOutlinedDefault.default));
parcelHelpers.export(exports, "FourKPlus", ()=>(0, _fourKPlusDefault.default));
parcelHelpers.export(exports, "FourKPlusOutlined", ()=>(0, _fourKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "FourKPlusRounded", ()=>(0, _fourKPlusRoundedDefault.default));
parcelHelpers.export(exports, "FourKPlusSharp", ()=>(0, _fourKPlusSharpDefault.default));
parcelHelpers.export(exports, "FourKPlusTwoTone", ()=>(0, _fourKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "FourKRounded", ()=>(0, _fourKRoundedDefault.default));
parcelHelpers.export(exports, "FourKSharp", ()=>(0, _fourKSharpDefault.default));
parcelHelpers.export(exports, "FourKTwoTone", ()=>(0, _fourKTwoToneDefault.default));
parcelHelpers.export(exports, "FourMp", ()=>(0, _fourMpDefault.default));
parcelHelpers.export(exports, "FourMpOutlined", ()=>(0, _fourMpOutlinedDefault.default));
parcelHelpers.export(exports, "FourMpRounded", ()=>(0, _fourMpRoundedDefault.default));
parcelHelpers.export(exports, "FourMpSharp", ()=>(0, _fourMpSharpDefault.default));
parcelHelpers.export(exports, "FourMpTwoTone", ()=>(0, _fourMpTwoToneDefault.default));
parcelHelpers.export(exports, "FourteenMp", ()=>(0, _fourteenMpDefault.default));
parcelHelpers.export(exports, "FourteenMpOutlined", ()=>(0, _fourteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "FourteenMpRounded", ()=>(0, _fourteenMpRoundedDefault.default));
parcelHelpers.export(exports, "FourteenMpSharp", ()=>(0, _fourteenMpSharpDefault.default));
parcelHelpers.export(exports, "FourteenMpTwoTone", ()=>(0, _fourteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "FreeBreakfast", ()=>(0, _freeBreakfastDefault.default));
parcelHelpers.export(exports, "FreeBreakfastOutlined", ()=>(0, _freeBreakfastOutlinedDefault.default));
parcelHelpers.export(exports, "FreeBreakfastRounded", ()=>(0, _freeBreakfastRoundedDefault.default));
parcelHelpers.export(exports, "FreeBreakfastSharp", ()=>(0, _freeBreakfastSharpDefault.default));
parcelHelpers.export(exports, "FreeBreakfastTwoTone", ()=>(0, _freeBreakfastTwoToneDefault.default));
parcelHelpers.export(exports, "Fullscreen", ()=>(0, _fullscreenDefault.default));
parcelHelpers.export(exports, "FullscreenExit", ()=>(0, _fullscreenExitDefault.default));
parcelHelpers.export(exports, "FullscreenExitOutlined", ()=>(0, _fullscreenExitOutlinedDefault.default));
parcelHelpers.export(exports, "FullscreenExitRounded", ()=>(0, _fullscreenExitRoundedDefault.default));
parcelHelpers.export(exports, "FullscreenExitSharp", ()=>(0, _fullscreenExitSharpDefault.default));
parcelHelpers.export(exports, "FullscreenExitTwoTone", ()=>(0, _fullscreenExitTwoToneDefault.default));
parcelHelpers.export(exports, "FullscreenOutlined", ()=>(0, _fullscreenOutlinedDefault.default));
parcelHelpers.export(exports, "FullscreenRounded", ()=>(0, _fullscreenRoundedDefault.default));
parcelHelpers.export(exports, "FullscreenSharp", ()=>(0, _fullscreenSharpDefault.default));
parcelHelpers.export(exports, "FullscreenTwoTone", ()=>(0, _fullscreenTwoToneDefault.default));
parcelHelpers.export(exports, "Functions", ()=>(0, _functionsDefault.default));
parcelHelpers.export(exports, "FunctionsOutlined", ()=>(0, _functionsOutlinedDefault.default));
parcelHelpers.export(exports, "FunctionsRounded", ()=>(0, _functionsRoundedDefault.default));
parcelHelpers.export(exports, "FunctionsSharp", ()=>(0, _functionsSharpDefault.default));
parcelHelpers.export(exports, "FunctionsTwoTone", ()=>(0, _functionsTwoToneDefault.default));
parcelHelpers.export(exports, "GMobiledata", ()=>(0, _gmobiledataDefault.default));
parcelHelpers.export(exports, "GMobiledataOutlined", ()=>(0, _gmobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "GMobiledataRounded", ()=>(0, _gmobiledataRoundedDefault.default));
parcelHelpers.export(exports, "GMobiledataSharp", ()=>(0, _gmobiledataSharpDefault.default));
parcelHelpers.export(exports, "GMobiledataTwoTone", ()=>(0, _gmobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "GTranslate", ()=>(0, _gtranslateDefault.default));
parcelHelpers.export(exports, "GTranslateOutlined", ()=>(0, _gtranslateOutlinedDefault.default));
parcelHelpers.export(exports, "GTranslateRounded", ()=>(0, _gtranslateRoundedDefault.default));
parcelHelpers.export(exports, "GTranslateSharp", ()=>(0, _gtranslateSharpDefault.default));
parcelHelpers.export(exports, "GTranslateTwoTone", ()=>(0, _gtranslateTwoToneDefault.default));
parcelHelpers.export(exports, "Gamepad", ()=>(0, _gamepadDefault.default));
parcelHelpers.export(exports, "GamepadOutlined", ()=>(0, _gamepadOutlinedDefault.default));
parcelHelpers.export(exports, "GamepadRounded", ()=>(0, _gamepadRoundedDefault.default));
parcelHelpers.export(exports, "GamepadSharp", ()=>(0, _gamepadSharpDefault.default));
parcelHelpers.export(exports, "GamepadTwoTone", ()=>(0, _gamepadTwoToneDefault.default));
parcelHelpers.export(exports, "Games", ()=>(0, _gamesDefault.default));
parcelHelpers.export(exports, "GamesOutlined", ()=>(0, _gamesOutlinedDefault.default));
parcelHelpers.export(exports, "GamesRounded", ()=>(0, _gamesRoundedDefault.default));
parcelHelpers.export(exports, "GamesSharp", ()=>(0, _gamesSharpDefault.default));
parcelHelpers.export(exports, "GamesTwoTone", ()=>(0, _gamesTwoToneDefault.default));
parcelHelpers.export(exports, "Garage", ()=>(0, _garageDefault.default));
parcelHelpers.export(exports, "GarageOutlined", ()=>(0, _garageOutlinedDefault.default));
parcelHelpers.export(exports, "GarageRounded", ()=>(0, _garageRoundedDefault.default));
parcelHelpers.export(exports, "GarageSharp", ()=>(0, _garageSharpDefault.default));
parcelHelpers.export(exports, "GarageTwoTone", ()=>(0, _garageTwoToneDefault.default));
parcelHelpers.export(exports, "GasMeter", ()=>(0, _gasMeterDefault.default));
parcelHelpers.export(exports, "GasMeterOutlined", ()=>(0, _gasMeterOutlinedDefault.default));
parcelHelpers.export(exports, "GasMeterRounded", ()=>(0, _gasMeterRoundedDefault.default));
parcelHelpers.export(exports, "GasMeterSharp", ()=>(0, _gasMeterSharpDefault.default));
parcelHelpers.export(exports, "GasMeterTwoTone", ()=>(0, _gasMeterTwoToneDefault.default));
parcelHelpers.export(exports, "Gavel", ()=>(0, _gavelDefault.default));
parcelHelpers.export(exports, "GavelOutlined", ()=>(0, _gavelOutlinedDefault.default));
parcelHelpers.export(exports, "GavelRounded", ()=>(0, _gavelRoundedDefault.default));
parcelHelpers.export(exports, "GavelSharp", ()=>(0, _gavelSharpDefault.default));
parcelHelpers.export(exports, "GavelTwoTone", ()=>(0, _gavelTwoToneDefault.default));
parcelHelpers.export(exports, "Gesture", ()=>(0, _gestureDefault.default));
parcelHelpers.export(exports, "GestureOutlined", ()=>(0, _gestureOutlinedDefault.default));
parcelHelpers.export(exports, "GestureRounded", ()=>(0, _gestureRoundedDefault.default));
parcelHelpers.export(exports, "GestureSharp", ()=>(0, _gestureSharpDefault.default));
parcelHelpers.export(exports, "GestureTwoTone", ()=>(0, _gestureTwoToneDefault.default));
parcelHelpers.export(exports, "GetApp", ()=>(0, _getAppDefault.default));
parcelHelpers.export(exports, "GetAppOutlined", ()=>(0, _getAppOutlinedDefault.default));
parcelHelpers.export(exports, "GetAppRounded", ()=>(0, _getAppRoundedDefault.default));
parcelHelpers.export(exports, "GetAppSharp", ()=>(0, _getAppSharpDefault.default));
parcelHelpers.export(exports, "GetAppTwoTone", ()=>(0, _getAppTwoToneDefault.default));
parcelHelpers.export(exports, "Gif", ()=>(0, _gifDefault.default));
parcelHelpers.export(exports, "GifBox", ()=>(0, _gifBoxDefault.default));
parcelHelpers.export(exports, "GifBoxOutlined", ()=>(0, _gifBoxOutlinedDefault.default));
parcelHelpers.export(exports, "GifBoxRounded", ()=>(0, _gifBoxRoundedDefault.default));
parcelHelpers.export(exports, "GifBoxSharp", ()=>(0, _gifBoxSharpDefault.default));
parcelHelpers.export(exports, "GifBoxTwoTone", ()=>(0, _gifBoxTwoToneDefault.default));
parcelHelpers.export(exports, "GifOutlined", ()=>(0, _gifOutlinedDefault.default));
parcelHelpers.export(exports, "GifRounded", ()=>(0, _gifRoundedDefault.default));
parcelHelpers.export(exports, "GifSharp", ()=>(0, _gifSharpDefault.default));
parcelHelpers.export(exports, "GifTwoTone", ()=>(0, _gifTwoToneDefault.default));
parcelHelpers.export(exports, "Girl", ()=>(0, _girlDefault.default));
parcelHelpers.export(exports, "GirlOutlined", ()=>(0, _girlOutlinedDefault.default));
parcelHelpers.export(exports, "GirlRounded", ()=>(0, _girlRoundedDefault.default));
parcelHelpers.export(exports, "GirlSharp", ()=>(0, _girlSharpDefault.default));
parcelHelpers.export(exports, "GirlTwoTone", ()=>(0, _girlTwoToneDefault.default));
parcelHelpers.export(exports, "GitHub", ()=>(0, _gitHubDefault.default));
parcelHelpers.export(exports, "Gite", ()=>(0, _giteDefault.default));
parcelHelpers.export(exports, "GiteOutlined", ()=>(0, _giteOutlinedDefault.default));
parcelHelpers.export(exports, "GiteRounded", ()=>(0, _giteRoundedDefault.default));
parcelHelpers.export(exports, "GiteSharp", ()=>(0, _giteSharpDefault.default));
parcelHelpers.export(exports, "GiteTwoTone", ()=>(0, _giteTwoToneDefault.default));
parcelHelpers.export(exports, "GolfCourse", ()=>(0, _golfCourseDefault.default));
parcelHelpers.export(exports, "GolfCourseOutlined", ()=>(0, _golfCourseOutlinedDefault.default));
parcelHelpers.export(exports, "GolfCourseRounded", ()=>(0, _golfCourseRoundedDefault.default));
parcelHelpers.export(exports, "GolfCourseSharp", ()=>(0, _golfCourseSharpDefault.default));
parcelHelpers.export(exports, "GolfCourseTwoTone", ()=>(0, _golfCourseTwoToneDefault.default));
parcelHelpers.export(exports, "Google", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "GppBad", ()=>(0, _gppBadDefault.default));
parcelHelpers.export(exports, "GppBadOutlined", ()=>(0, _gppBadOutlinedDefault.default));
parcelHelpers.export(exports, "GppBadRounded", ()=>(0, _gppBadRoundedDefault.default));
parcelHelpers.export(exports, "GppBadSharp", ()=>(0, _gppBadSharpDefault.default));
parcelHelpers.export(exports, "GppBadTwoTone", ()=>(0, _gppBadTwoToneDefault.default));
parcelHelpers.export(exports, "GppGood", ()=>(0, _gppGoodDefault.default));
parcelHelpers.export(exports, "GppGoodOutlined", ()=>(0, _gppGoodOutlinedDefault.default));
parcelHelpers.export(exports, "GppGoodRounded", ()=>(0, _gppGoodRoundedDefault.default));
parcelHelpers.export(exports, "GppGoodSharp", ()=>(0, _gppGoodSharpDefault.default));
parcelHelpers.export(exports, "GppGoodTwoTone", ()=>(0, _gppGoodTwoToneDefault.default));
parcelHelpers.export(exports, "GppMaybe", ()=>(0, _gppMaybeDefault.default));
parcelHelpers.export(exports, "GppMaybeOutlined", ()=>(0, _gppMaybeOutlinedDefault.default));
parcelHelpers.export(exports, "GppMaybeRounded", ()=>(0, _gppMaybeRoundedDefault.default));
parcelHelpers.export(exports, "GppMaybeSharp", ()=>(0, _gppMaybeSharpDefault.default));
parcelHelpers.export(exports, "GppMaybeTwoTone", ()=>(0, _gppMaybeTwoToneDefault.default));
parcelHelpers.export(exports, "GpsFixed", ()=>(0, _gpsFixedDefault.default));
parcelHelpers.export(exports, "GpsFixedOutlined", ()=>(0, _gpsFixedOutlinedDefault.default));
parcelHelpers.export(exports, "GpsFixedRounded", ()=>(0, _gpsFixedRoundedDefault.default));
parcelHelpers.export(exports, "GpsFixedSharp", ()=>(0, _gpsFixedSharpDefault.default));
parcelHelpers.export(exports, "GpsFixedTwoTone", ()=>(0, _gpsFixedTwoToneDefault.default));
parcelHelpers.export(exports, "GpsNotFixed", ()=>(0, _gpsNotFixedDefault.default));
parcelHelpers.export(exports, "GpsNotFixedOutlined", ()=>(0, _gpsNotFixedOutlinedDefault.default));
parcelHelpers.export(exports, "GpsNotFixedRounded", ()=>(0, _gpsNotFixedRoundedDefault.default));
parcelHelpers.export(exports, "GpsNotFixedSharp", ()=>(0, _gpsNotFixedSharpDefault.default));
parcelHelpers.export(exports, "GpsNotFixedTwoTone", ()=>(0, _gpsNotFixedTwoToneDefault.default));
parcelHelpers.export(exports, "GpsOff", ()=>(0, _gpsOffDefault.default));
parcelHelpers.export(exports, "GpsOffOutlined", ()=>(0, _gpsOffOutlinedDefault.default));
parcelHelpers.export(exports, "GpsOffRounded", ()=>(0, _gpsOffRoundedDefault.default));
parcelHelpers.export(exports, "GpsOffSharp", ()=>(0, _gpsOffSharpDefault.default));
parcelHelpers.export(exports, "GpsOffTwoTone", ()=>(0, _gpsOffTwoToneDefault.default));
parcelHelpers.export(exports, "Grade", ()=>(0, _gradeDefault.default));
parcelHelpers.export(exports, "GradeOutlined", ()=>(0, _gradeOutlinedDefault.default));
parcelHelpers.export(exports, "GradeRounded", ()=>(0, _gradeRoundedDefault.default));
parcelHelpers.export(exports, "GradeSharp", ()=>(0, _gradeSharpDefault.default));
parcelHelpers.export(exports, "GradeTwoTone", ()=>(0, _gradeTwoToneDefault.default));
parcelHelpers.export(exports, "Gradient", ()=>(0, _gradientDefault.default));
parcelHelpers.export(exports, "GradientOutlined", ()=>(0, _gradientOutlinedDefault.default));
parcelHelpers.export(exports, "GradientRounded", ()=>(0, _gradientRoundedDefault.default));
parcelHelpers.export(exports, "GradientSharp", ()=>(0, _gradientSharpDefault.default));
parcelHelpers.export(exports, "GradientTwoTone", ()=>(0, _gradientTwoToneDefault.default));
parcelHelpers.export(exports, "Grading", ()=>(0, _gradingDefault.default));
parcelHelpers.export(exports, "GradingOutlined", ()=>(0, _gradingOutlinedDefault.default));
parcelHelpers.export(exports, "GradingRounded", ()=>(0, _gradingRoundedDefault.default));
parcelHelpers.export(exports, "GradingSharp", ()=>(0, _gradingSharpDefault.default));
parcelHelpers.export(exports, "GradingTwoTone", ()=>(0, _gradingTwoToneDefault.default));
parcelHelpers.export(exports, "Grain", ()=>(0, _grainDefault.default));
parcelHelpers.export(exports, "GrainOutlined", ()=>(0, _grainOutlinedDefault.default));
parcelHelpers.export(exports, "GrainRounded", ()=>(0, _grainRoundedDefault.default));
parcelHelpers.export(exports, "GrainSharp", ()=>(0, _grainSharpDefault.default));
parcelHelpers.export(exports, "GrainTwoTone", ()=>(0, _grainTwoToneDefault.default));
parcelHelpers.export(exports, "GraphicEq", ()=>(0, _graphicEqDefault.default));
parcelHelpers.export(exports, "GraphicEqOutlined", ()=>(0, _graphicEqOutlinedDefault.default));
parcelHelpers.export(exports, "GraphicEqRounded", ()=>(0, _graphicEqRoundedDefault.default));
parcelHelpers.export(exports, "GraphicEqSharp", ()=>(0, _graphicEqSharpDefault.default));
parcelHelpers.export(exports, "GraphicEqTwoTone", ()=>(0, _graphicEqTwoToneDefault.default));
parcelHelpers.export(exports, "Grass", ()=>(0, _grassDefault.default));
parcelHelpers.export(exports, "GrassOutlined", ()=>(0, _grassOutlinedDefault.default));
parcelHelpers.export(exports, "GrassRounded", ()=>(0, _grassRoundedDefault.default));
parcelHelpers.export(exports, "GrassSharp", ()=>(0, _grassSharpDefault.default));
parcelHelpers.export(exports, "GrassTwoTone", ()=>(0, _grassTwoToneDefault.default));
parcelHelpers.export(exports, "Grid3x3", ()=>(0, _grid3X3Default.default));
parcelHelpers.export(exports, "Grid3x3Outlined", ()=>(0, _grid3X3OutlinedDefault.default));
parcelHelpers.export(exports, "Grid3x3Rounded", ()=>(0, _grid3X3RoundedDefault.default));
parcelHelpers.export(exports, "Grid3x3Sharp", ()=>(0, _grid3X3SharpDefault.default));
parcelHelpers.export(exports, "Grid3x3TwoTone", ()=>(0, _grid3X3TwoToneDefault.default));
parcelHelpers.export(exports, "Grid4x4", ()=>(0, _grid4X4Default.default));
parcelHelpers.export(exports, "Grid4x4Outlined", ()=>(0, _grid4X4OutlinedDefault.default));
parcelHelpers.export(exports, "Grid4x4Rounded", ()=>(0, _grid4X4RoundedDefault.default));
parcelHelpers.export(exports, "Grid4x4Sharp", ()=>(0, _grid4X4SharpDefault.default));
parcelHelpers.export(exports, "Grid4x4TwoTone", ()=>(0, _grid4X4TwoToneDefault.default));
parcelHelpers.export(exports, "GridGoldenratio", ()=>(0, _gridGoldenratioDefault.default));
parcelHelpers.export(exports, "GridGoldenratioOutlined", ()=>(0, _gridGoldenratioOutlinedDefault.default));
parcelHelpers.export(exports, "GridGoldenratioRounded", ()=>(0, _gridGoldenratioRoundedDefault.default));
parcelHelpers.export(exports, "GridGoldenratioSharp", ()=>(0, _gridGoldenratioSharpDefault.default));
parcelHelpers.export(exports, "GridGoldenratioTwoTone", ()=>(0, _gridGoldenratioTwoToneDefault.default));
parcelHelpers.export(exports, "GridOff", ()=>(0, _gridOffDefault.default));
parcelHelpers.export(exports, "GridOffOutlined", ()=>(0, _gridOffOutlinedDefault.default));
parcelHelpers.export(exports, "GridOffRounded", ()=>(0, _gridOffRoundedDefault.default));
parcelHelpers.export(exports, "GridOffSharp", ()=>(0, _gridOffSharpDefault.default));
parcelHelpers.export(exports, "GridOffTwoTone", ()=>(0, _gridOffTwoToneDefault.default));
parcelHelpers.export(exports, "GridOn", ()=>(0, _gridOnDefault.default));
parcelHelpers.export(exports, "GridOnOutlined", ()=>(0, _gridOnOutlinedDefault.default));
parcelHelpers.export(exports, "GridOnRounded", ()=>(0, _gridOnRoundedDefault.default));
parcelHelpers.export(exports, "GridOnSharp", ()=>(0, _gridOnSharpDefault.default));
parcelHelpers.export(exports, "GridOnTwoTone", ()=>(0, _gridOnTwoToneDefault.default));
parcelHelpers.export(exports, "GridView", ()=>(0, _gridViewDefault.default));
parcelHelpers.export(exports, "GridViewOutlined", ()=>(0, _gridViewOutlinedDefault.default));
parcelHelpers.export(exports, "GridViewRounded", ()=>(0, _gridViewRoundedDefault.default));
parcelHelpers.export(exports, "GridViewSharp", ()=>(0, _gridViewSharpDefault.default));
parcelHelpers.export(exports, "GridViewTwoTone", ()=>(0, _gridViewTwoToneDefault.default));
parcelHelpers.export(exports, "Group", ()=>(0, _groupDefault.default));
parcelHelpers.export(exports, "GroupAdd", ()=>(0, _groupAddDefault.default));
parcelHelpers.export(exports, "GroupAddOutlined", ()=>(0, _groupAddOutlinedDefault.default));
parcelHelpers.export(exports, "GroupAddRounded", ()=>(0, _groupAddRoundedDefault.default));
parcelHelpers.export(exports, "GroupAddSharp", ()=>(0, _groupAddSharpDefault.default));
parcelHelpers.export(exports, "GroupAddTwoTone", ()=>(0, _groupAddTwoToneDefault.default));
parcelHelpers.export(exports, "GroupOutlined", ()=>(0, _groupOutlinedDefault.default));
parcelHelpers.export(exports, "GroupRemove", ()=>(0, _groupRemoveDefault.default));
parcelHelpers.export(exports, "GroupRemoveOutlined", ()=>(0, _groupRemoveOutlinedDefault.default));
parcelHelpers.export(exports, "GroupRemoveRounded", ()=>(0, _groupRemoveRoundedDefault.default));
parcelHelpers.export(exports, "GroupRemoveSharp", ()=>(0, _groupRemoveSharpDefault.default));
parcelHelpers.export(exports, "GroupRemoveTwoTone", ()=>(0, _groupRemoveTwoToneDefault.default));
parcelHelpers.export(exports, "GroupRounded", ()=>(0, _groupRoundedDefault.default));
parcelHelpers.export(exports, "GroupSharp", ()=>(0, _groupSharpDefault.default));
parcelHelpers.export(exports, "GroupTwoTone", ()=>(0, _groupTwoToneDefault.default));
parcelHelpers.export(exports, "GroupWork", ()=>(0, _groupWorkDefault.default));
parcelHelpers.export(exports, "GroupWorkOutlined", ()=>(0, _groupWorkOutlinedDefault.default));
parcelHelpers.export(exports, "GroupWorkRounded", ()=>(0, _groupWorkRoundedDefault.default));
parcelHelpers.export(exports, "GroupWorkSharp", ()=>(0, _groupWorkSharpDefault.default));
parcelHelpers.export(exports, "GroupWorkTwoTone", ()=>(0, _groupWorkTwoToneDefault.default));
parcelHelpers.export(exports, "Groups", ()=>(0, _groupsDefault.default));
parcelHelpers.export(exports, "Groups2", ()=>(0, _groups2Default.default));
parcelHelpers.export(exports, "Groups2Outlined", ()=>(0, _groups2OutlinedDefault.default));
parcelHelpers.export(exports, "Groups2Rounded", ()=>(0, _groups2RoundedDefault.default));
parcelHelpers.export(exports, "Groups2Sharp", ()=>(0, _groups2SharpDefault.default));
parcelHelpers.export(exports, "Groups2TwoTone", ()=>(0, _groups2TwoToneDefault.default));
parcelHelpers.export(exports, "Groups3", ()=>(0, _groups3Default.default));
parcelHelpers.export(exports, "Groups3Outlined", ()=>(0, _groups3OutlinedDefault.default));
parcelHelpers.export(exports, "Groups3Rounded", ()=>(0, _groups3RoundedDefault.default));
parcelHelpers.export(exports, "Groups3Sharp", ()=>(0, _groups3SharpDefault.default));
parcelHelpers.export(exports, "Groups3TwoTone", ()=>(0, _groups3TwoToneDefault.default));
parcelHelpers.export(exports, "GroupsOutlined", ()=>(0, _groupsOutlinedDefault.default));
parcelHelpers.export(exports, "GroupsRounded", ()=>(0, _groupsRoundedDefault.default));
parcelHelpers.export(exports, "GroupsSharp", ()=>(0, _groupsSharpDefault.default));
parcelHelpers.export(exports, "GroupsTwoTone", ()=>(0, _groupsTwoToneDefault.default));
parcelHelpers.export(exports, "HMobiledata", ()=>(0, _hmobiledataDefault.default));
parcelHelpers.export(exports, "HMobiledataOutlined", ()=>(0, _hmobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "HMobiledataRounded", ()=>(0, _hmobiledataRoundedDefault.default));
parcelHelpers.export(exports, "HMobiledataSharp", ()=>(0, _hmobiledataSharpDefault.default));
parcelHelpers.export(exports, "HMobiledataTwoTone", ()=>(0, _hmobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "HPlusMobiledata", ()=>(0, _hplusMobiledataDefault.default));
parcelHelpers.export(exports, "HPlusMobiledataOutlined", ()=>(0, _hplusMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "HPlusMobiledataRounded", ()=>(0, _hplusMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "HPlusMobiledataSharp", ()=>(0, _hplusMobiledataSharpDefault.default));
parcelHelpers.export(exports, "HPlusMobiledataTwoTone", ()=>(0, _hplusMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "Hail", ()=>(0, _hailDefault.default));
parcelHelpers.export(exports, "HailOutlined", ()=>(0, _hailOutlinedDefault.default));
parcelHelpers.export(exports, "HailRounded", ()=>(0, _hailRoundedDefault.default));
parcelHelpers.export(exports, "HailSharp", ()=>(0, _hailSharpDefault.default));
parcelHelpers.export(exports, "HailTwoTone", ()=>(0, _hailTwoToneDefault.default));
parcelHelpers.export(exports, "Handshake", ()=>(0, _handshakeDefault.default));
parcelHelpers.export(exports, "HandshakeOutlined", ()=>(0, _handshakeOutlinedDefault.default));
parcelHelpers.export(exports, "HandshakeRounded", ()=>(0, _handshakeRoundedDefault.default));
parcelHelpers.export(exports, "HandshakeSharp", ()=>(0, _handshakeSharpDefault.default));
parcelHelpers.export(exports, "HandshakeTwoTone", ()=>(0, _handshakeTwoToneDefault.default));
parcelHelpers.export(exports, "Handyman", ()=>(0, _handymanDefault.default));
parcelHelpers.export(exports, "HandymanOutlined", ()=>(0, _handymanOutlinedDefault.default));
parcelHelpers.export(exports, "HandymanRounded", ()=>(0, _handymanRoundedDefault.default));
parcelHelpers.export(exports, "HandymanSharp", ()=>(0, _handymanSharpDefault.default));
parcelHelpers.export(exports, "HandymanTwoTone", ()=>(0, _handymanTwoToneDefault.default));
parcelHelpers.export(exports, "Hardware", ()=>(0, _hardwareDefault.default));
parcelHelpers.export(exports, "HardwareOutlined", ()=>(0, _hardwareOutlinedDefault.default));
parcelHelpers.export(exports, "HardwareRounded", ()=>(0, _hardwareRoundedDefault.default));
parcelHelpers.export(exports, "HardwareSharp", ()=>(0, _hardwareSharpDefault.default));
parcelHelpers.export(exports, "HardwareTwoTone", ()=>(0, _hardwareTwoToneDefault.default));
parcelHelpers.export(exports, "Hd", ()=>(0, _hdDefault.default));
parcelHelpers.export(exports, "HdOutlined", ()=>(0, _hdOutlinedDefault.default));
parcelHelpers.export(exports, "HdRounded", ()=>(0, _hdRoundedDefault.default));
parcelHelpers.export(exports, "HdSharp", ()=>(0, _hdSharpDefault.default));
parcelHelpers.export(exports, "HdTwoTone", ()=>(0, _hdTwoToneDefault.default));
parcelHelpers.export(exports, "HdrAuto", ()=>(0, _hdrAutoDefault.default));
parcelHelpers.export(exports, "HdrAutoOutlined", ()=>(0, _hdrAutoOutlinedDefault.default));
parcelHelpers.export(exports, "HdrAutoRounded", ()=>(0, _hdrAutoRoundedDefault.default));
parcelHelpers.export(exports, "HdrAutoSelect", ()=>(0, _hdrAutoSelectDefault.default));
parcelHelpers.export(exports, "HdrAutoSelectOutlined", ()=>(0, _hdrAutoSelectOutlinedDefault.default));
parcelHelpers.export(exports, "HdrAutoSelectRounded", ()=>(0, _hdrAutoSelectRoundedDefault.default));
parcelHelpers.export(exports, "HdrAutoSelectSharp", ()=>(0, _hdrAutoSelectSharpDefault.default));
parcelHelpers.export(exports, "HdrAutoSelectTwoTone", ()=>(0, _hdrAutoSelectTwoToneDefault.default));
parcelHelpers.export(exports, "HdrAutoSharp", ()=>(0, _hdrAutoSharpDefault.default));
parcelHelpers.export(exports, "HdrAutoTwoTone", ()=>(0, _hdrAutoTwoToneDefault.default));
parcelHelpers.export(exports, "HdrEnhancedSelect", ()=>(0, _hdrEnhancedSelectDefault.default));
parcelHelpers.export(exports, "HdrEnhancedSelectOutlined", ()=>(0, _hdrEnhancedSelectOutlinedDefault.default));
parcelHelpers.export(exports, "HdrEnhancedSelectRounded", ()=>(0, _hdrEnhancedSelectRoundedDefault.default));
parcelHelpers.export(exports, "HdrEnhancedSelectSharp", ()=>(0, _hdrEnhancedSelectSharpDefault.default));
parcelHelpers.export(exports, "HdrEnhancedSelectTwoTone", ()=>(0, _hdrEnhancedSelectTwoToneDefault.default));
parcelHelpers.export(exports, "HdrOff", ()=>(0, _hdrOffDefault.default));
parcelHelpers.export(exports, "HdrOffOutlined", ()=>(0, _hdrOffOutlinedDefault.default));
parcelHelpers.export(exports, "HdrOffRounded", ()=>(0, _hdrOffRoundedDefault.default));
parcelHelpers.export(exports, "HdrOffSelect", ()=>(0, _hdrOffSelectDefault.default));
parcelHelpers.export(exports, "HdrOffSelectOutlined", ()=>(0, _hdrOffSelectOutlinedDefault.default));
parcelHelpers.export(exports, "HdrOffSelectRounded", ()=>(0, _hdrOffSelectRoundedDefault.default));
parcelHelpers.export(exports, "HdrOffSelectSharp", ()=>(0, _hdrOffSelectSharpDefault.default));
parcelHelpers.export(exports, "HdrOffSelectTwoTone", ()=>(0, _hdrOffSelectTwoToneDefault.default));
parcelHelpers.export(exports, "HdrOffSharp", ()=>(0, _hdrOffSharpDefault.default));
parcelHelpers.export(exports, "HdrOffTwoTone", ()=>(0, _hdrOffTwoToneDefault.default));
parcelHelpers.export(exports, "HdrOn", ()=>(0, _hdrOnDefault.default));
parcelHelpers.export(exports, "HdrOnOutlined", ()=>(0, _hdrOnOutlinedDefault.default));
parcelHelpers.export(exports, "HdrOnRounded", ()=>(0, _hdrOnRoundedDefault.default));
parcelHelpers.export(exports, "HdrOnSelect", ()=>(0, _hdrOnSelectDefault.default));
parcelHelpers.export(exports, "HdrOnSelectOutlined", ()=>(0, _hdrOnSelectOutlinedDefault.default));
parcelHelpers.export(exports, "HdrOnSelectRounded", ()=>(0, _hdrOnSelectRoundedDefault.default));
parcelHelpers.export(exports, "HdrOnSelectSharp", ()=>(0, _hdrOnSelectSharpDefault.default));
parcelHelpers.export(exports, "HdrOnSelectTwoTone", ()=>(0, _hdrOnSelectTwoToneDefault.default));
parcelHelpers.export(exports, "HdrOnSharp", ()=>(0, _hdrOnSharpDefault.default));
parcelHelpers.export(exports, "HdrOnTwoTone", ()=>(0, _hdrOnTwoToneDefault.default));
parcelHelpers.export(exports, "HdrPlus", ()=>(0, _hdrPlusDefault.default));
parcelHelpers.export(exports, "HdrPlusOutlined", ()=>(0, _hdrPlusOutlinedDefault.default));
parcelHelpers.export(exports, "HdrPlusRounded", ()=>(0, _hdrPlusRoundedDefault.default));
parcelHelpers.export(exports, "HdrPlusSharp", ()=>(0, _hdrPlusSharpDefault.default));
parcelHelpers.export(exports, "HdrPlusTwoTone", ()=>(0, _hdrPlusTwoToneDefault.default));
parcelHelpers.export(exports, "HdrStrong", ()=>(0, _hdrStrongDefault.default));
parcelHelpers.export(exports, "HdrStrongOutlined", ()=>(0, _hdrStrongOutlinedDefault.default));
parcelHelpers.export(exports, "HdrStrongRounded", ()=>(0, _hdrStrongRoundedDefault.default));
parcelHelpers.export(exports, "HdrStrongSharp", ()=>(0, _hdrStrongSharpDefault.default));
parcelHelpers.export(exports, "HdrStrongTwoTone", ()=>(0, _hdrStrongTwoToneDefault.default));
parcelHelpers.export(exports, "HdrWeak", ()=>(0, _hdrWeakDefault.default));
parcelHelpers.export(exports, "HdrWeakOutlined", ()=>(0, _hdrWeakOutlinedDefault.default));
parcelHelpers.export(exports, "HdrWeakRounded", ()=>(0, _hdrWeakRoundedDefault.default));
parcelHelpers.export(exports, "HdrWeakSharp", ()=>(0, _hdrWeakSharpDefault.default));
parcelHelpers.export(exports, "HdrWeakTwoTone", ()=>(0, _hdrWeakTwoToneDefault.default));
parcelHelpers.export(exports, "Headphones", ()=>(0, _headphonesDefault.default));
parcelHelpers.export(exports, "HeadphonesBattery", ()=>(0, _headphonesBatteryDefault.default));
parcelHelpers.export(exports, "HeadphonesBatteryOutlined", ()=>(0, _headphonesBatteryOutlinedDefault.default));
parcelHelpers.export(exports, "HeadphonesBatteryRounded", ()=>(0, _headphonesBatteryRoundedDefault.default));
parcelHelpers.export(exports, "HeadphonesBatterySharp", ()=>(0, _headphonesBatterySharpDefault.default));
parcelHelpers.export(exports, "HeadphonesBatteryTwoTone", ()=>(0, _headphonesBatteryTwoToneDefault.default));
parcelHelpers.export(exports, "HeadphonesOutlined", ()=>(0, _headphonesOutlinedDefault.default));
parcelHelpers.export(exports, "HeadphonesRounded", ()=>(0, _headphonesRoundedDefault.default));
parcelHelpers.export(exports, "HeadphonesSharp", ()=>(0, _headphonesSharpDefault.default));
parcelHelpers.export(exports, "HeadphonesTwoTone", ()=>(0, _headphonesTwoToneDefault.default));
parcelHelpers.export(exports, "Headset", ()=>(0, _headsetDefault.default));
parcelHelpers.export(exports, "HeadsetMic", ()=>(0, _headsetMicDefault.default));
parcelHelpers.export(exports, "HeadsetMicOutlined", ()=>(0, _headsetMicOutlinedDefault.default));
parcelHelpers.export(exports, "HeadsetMicRounded", ()=>(0, _headsetMicRoundedDefault.default));
parcelHelpers.export(exports, "HeadsetMicSharp", ()=>(0, _headsetMicSharpDefault.default));
parcelHelpers.export(exports, "HeadsetMicTwoTone", ()=>(0, _headsetMicTwoToneDefault.default));
parcelHelpers.export(exports, "HeadsetOff", ()=>(0, _headsetOffDefault.default));
parcelHelpers.export(exports, "HeadsetOffOutlined", ()=>(0, _headsetOffOutlinedDefault.default));
parcelHelpers.export(exports, "HeadsetOffRounded", ()=>(0, _headsetOffRoundedDefault.default));
parcelHelpers.export(exports, "HeadsetOffSharp", ()=>(0, _headsetOffSharpDefault.default));
parcelHelpers.export(exports, "HeadsetOffTwoTone", ()=>(0, _headsetOffTwoToneDefault.default));
parcelHelpers.export(exports, "HeadsetOutlined", ()=>(0, _headsetOutlinedDefault.default));
parcelHelpers.export(exports, "HeadsetRounded", ()=>(0, _headsetRoundedDefault.default));
parcelHelpers.export(exports, "HeadsetSharp", ()=>(0, _headsetSharpDefault.default));
parcelHelpers.export(exports, "HeadsetTwoTone", ()=>(0, _headsetTwoToneDefault.default));
parcelHelpers.export(exports, "Healing", ()=>(0, _healingDefault.default));
parcelHelpers.export(exports, "HealingOutlined", ()=>(0, _healingOutlinedDefault.default));
parcelHelpers.export(exports, "HealingRounded", ()=>(0, _healingRoundedDefault.default));
parcelHelpers.export(exports, "HealingSharp", ()=>(0, _healingSharpDefault.default));
parcelHelpers.export(exports, "HealingTwoTone", ()=>(0, _healingTwoToneDefault.default));
parcelHelpers.export(exports, "HealthAndSafety", ()=>(0, _healthAndSafetyDefault.default));
parcelHelpers.export(exports, "HealthAndSafetyOutlined", ()=>(0, _healthAndSafetyOutlinedDefault.default));
parcelHelpers.export(exports, "HealthAndSafetyRounded", ()=>(0, _healthAndSafetyRoundedDefault.default));
parcelHelpers.export(exports, "HealthAndSafetySharp", ()=>(0, _healthAndSafetySharpDefault.default));
parcelHelpers.export(exports, "HealthAndSafetyTwoTone", ()=>(0, _healthAndSafetyTwoToneDefault.default));
parcelHelpers.export(exports, "Hearing", ()=>(0, _hearingDefault.default));
parcelHelpers.export(exports, "HearingDisabled", ()=>(0, _hearingDisabledDefault.default));
parcelHelpers.export(exports, "HearingDisabledOutlined", ()=>(0, _hearingDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "HearingDisabledRounded", ()=>(0, _hearingDisabledRoundedDefault.default));
parcelHelpers.export(exports, "HearingDisabledSharp", ()=>(0, _hearingDisabledSharpDefault.default));
parcelHelpers.export(exports, "HearingDisabledTwoTone", ()=>(0, _hearingDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "HearingOutlined", ()=>(0, _hearingOutlinedDefault.default));
parcelHelpers.export(exports, "HearingRounded", ()=>(0, _hearingRoundedDefault.default));
parcelHelpers.export(exports, "HearingSharp", ()=>(0, _hearingSharpDefault.default));
parcelHelpers.export(exports, "HearingTwoTone", ()=>(0, _hearingTwoToneDefault.default));
parcelHelpers.export(exports, "HeartBroken", ()=>(0, _heartBrokenDefault.default));
parcelHelpers.export(exports, "HeartBrokenOutlined", ()=>(0, _heartBrokenOutlinedDefault.default));
parcelHelpers.export(exports, "HeartBrokenRounded", ()=>(0, _heartBrokenRoundedDefault.default));
parcelHelpers.export(exports, "HeartBrokenSharp", ()=>(0, _heartBrokenSharpDefault.default));
parcelHelpers.export(exports, "HeartBrokenTwoTone", ()=>(0, _heartBrokenTwoToneDefault.default));
parcelHelpers.export(exports, "HeatPump", ()=>(0, _heatPumpDefault.default));
parcelHelpers.export(exports, "HeatPumpOutlined", ()=>(0, _heatPumpOutlinedDefault.default));
parcelHelpers.export(exports, "HeatPumpRounded", ()=>(0, _heatPumpRoundedDefault.default));
parcelHelpers.export(exports, "HeatPumpSharp", ()=>(0, _heatPumpSharpDefault.default));
parcelHelpers.export(exports, "HeatPumpTwoTone", ()=>(0, _heatPumpTwoToneDefault.default));
parcelHelpers.export(exports, "Height", ()=>(0, _heightDefault.default));
parcelHelpers.export(exports, "HeightOutlined", ()=>(0, _heightOutlinedDefault.default));
parcelHelpers.export(exports, "HeightRounded", ()=>(0, _heightRoundedDefault.default));
parcelHelpers.export(exports, "HeightSharp", ()=>(0, _heightSharpDefault.default));
parcelHelpers.export(exports, "HeightTwoTone", ()=>(0, _heightTwoToneDefault.default));
parcelHelpers.export(exports, "Help", ()=>(0, _helpDefault.default));
parcelHelpers.export(exports, "HelpCenter", ()=>(0, _helpCenterDefault.default));
parcelHelpers.export(exports, "HelpCenterOutlined", ()=>(0, _helpCenterOutlinedDefault.default));
parcelHelpers.export(exports, "HelpCenterRounded", ()=>(0, _helpCenterRoundedDefault.default));
parcelHelpers.export(exports, "HelpCenterSharp", ()=>(0, _helpCenterSharpDefault.default));
parcelHelpers.export(exports, "HelpCenterTwoTone", ()=>(0, _helpCenterTwoToneDefault.default));
parcelHelpers.export(exports, "HelpOutline", ()=>(0, _helpOutlineDefault.default));
parcelHelpers.export(exports, "HelpOutlineOutlined", ()=>(0, _helpOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "HelpOutlineRounded", ()=>(0, _helpOutlineRoundedDefault.default));
parcelHelpers.export(exports, "HelpOutlineSharp", ()=>(0, _helpOutlineSharpDefault.default));
parcelHelpers.export(exports, "HelpOutlineTwoTone", ()=>(0, _helpOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "HelpOutlined", ()=>(0, _helpOutlinedDefault.default));
parcelHelpers.export(exports, "HelpRounded", ()=>(0, _helpRoundedDefault.default));
parcelHelpers.export(exports, "HelpSharp", ()=>(0, _helpSharpDefault.default));
parcelHelpers.export(exports, "HelpTwoTone", ()=>(0, _helpTwoToneDefault.default));
parcelHelpers.export(exports, "Hevc", ()=>(0, _hevcDefault.default));
parcelHelpers.export(exports, "HevcOutlined", ()=>(0, _hevcOutlinedDefault.default));
parcelHelpers.export(exports, "HevcRounded", ()=>(0, _hevcRoundedDefault.default));
parcelHelpers.export(exports, "HevcSharp", ()=>(0, _hevcSharpDefault.default));
parcelHelpers.export(exports, "HevcTwoTone", ()=>(0, _hevcTwoToneDefault.default));
parcelHelpers.export(exports, "Hexagon", ()=>(0, _hexagonDefault.default));
parcelHelpers.export(exports, "HexagonOutlined", ()=>(0, _hexagonOutlinedDefault.default));
parcelHelpers.export(exports, "HexagonRounded", ()=>(0, _hexagonRoundedDefault.default));
parcelHelpers.export(exports, "HexagonSharp", ()=>(0, _hexagonSharpDefault.default));
parcelHelpers.export(exports, "HexagonTwoTone", ()=>(0, _hexagonTwoToneDefault.default));
parcelHelpers.export(exports, "HideImage", ()=>(0, _hideImageDefault.default));
parcelHelpers.export(exports, "HideImageOutlined", ()=>(0, _hideImageOutlinedDefault.default));
parcelHelpers.export(exports, "HideImageRounded", ()=>(0, _hideImageRoundedDefault.default));
parcelHelpers.export(exports, "HideImageSharp", ()=>(0, _hideImageSharpDefault.default));
parcelHelpers.export(exports, "HideImageTwoTone", ()=>(0, _hideImageTwoToneDefault.default));
parcelHelpers.export(exports, "HideSource", ()=>(0, _hideSourceDefault.default));
parcelHelpers.export(exports, "HideSourceOutlined", ()=>(0, _hideSourceOutlinedDefault.default));
parcelHelpers.export(exports, "HideSourceRounded", ()=>(0, _hideSourceRoundedDefault.default));
parcelHelpers.export(exports, "HideSourceSharp", ()=>(0, _hideSourceSharpDefault.default));
parcelHelpers.export(exports, "HideSourceTwoTone", ()=>(0, _hideSourceTwoToneDefault.default));
parcelHelpers.export(exports, "HighQuality", ()=>(0, _highQualityDefault.default));
parcelHelpers.export(exports, "HighQualityOutlined", ()=>(0, _highQualityOutlinedDefault.default));
parcelHelpers.export(exports, "HighQualityRounded", ()=>(0, _highQualityRoundedDefault.default));
parcelHelpers.export(exports, "HighQualitySharp", ()=>(0, _highQualitySharpDefault.default));
parcelHelpers.export(exports, "HighQualityTwoTone", ()=>(0, _highQualityTwoToneDefault.default));
parcelHelpers.export(exports, "Highlight", ()=>(0, _highlightDefault.default));
parcelHelpers.export(exports, "HighlightAlt", ()=>(0, _highlightAltDefault.default));
parcelHelpers.export(exports, "HighlightAltOutlined", ()=>(0, _highlightAltOutlinedDefault.default));
parcelHelpers.export(exports, "HighlightAltRounded", ()=>(0, _highlightAltRoundedDefault.default));
parcelHelpers.export(exports, "HighlightAltSharp", ()=>(0, _highlightAltSharpDefault.default));
parcelHelpers.export(exports, "HighlightAltTwoTone", ()=>(0, _highlightAltTwoToneDefault.default));
parcelHelpers.export(exports, "HighlightOff", ()=>(0, _highlightOffDefault.default));
parcelHelpers.export(exports, "HighlightOffOutlined", ()=>(0, _highlightOffOutlinedDefault.default));
parcelHelpers.export(exports, "HighlightOffRounded", ()=>(0, _highlightOffRoundedDefault.default));
parcelHelpers.export(exports, "HighlightOffSharp", ()=>(0, _highlightOffSharpDefault.default));
parcelHelpers.export(exports, "HighlightOffTwoTone", ()=>(0, _highlightOffTwoToneDefault.default));
parcelHelpers.export(exports, "HighlightOutlined", ()=>(0, _highlightOutlinedDefault.default));
parcelHelpers.export(exports, "HighlightRounded", ()=>(0, _highlightRoundedDefault.default));
parcelHelpers.export(exports, "HighlightSharp", ()=>(0, _highlightSharpDefault.default));
parcelHelpers.export(exports, "HighlightTwoTone", ()=>(0, _highlightTwoToneDefault.default));
parcelHelpers.export(exports, "Hiking", ()=>(0, _hikingDefault.default));
parcelHelpers.export(exports, "HikingOutlined", ()=>(0, _hikingOutlinedDefault.default));
parcelHelpers.export(exports, "HikingRounded", ()=>(0, _hikingRoundedDefault.default));
parcelHelpers.export(exports, "HikingSharp", ()=>(0, _hikingSharpDefault.default));
parcelHelpers.export(exports, "HikingTwoTone", ()=>(0, _hikingTwoToneDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyDefault.default));
parcelHelpers.export(exports, "HistoryEdu", ()=>(0, _historyEduDefault.default));
parcelHelpers.export(exports, "HistoryEduOutlined", ()=>(0, _historyEduOutlinedDefault.default));
parcelHelpers.export(exports, "HistoryEduRounded", ()=>(0, _historyEduRoundedDefault.default));
parcelHelpers.export(exports, "HistoryEduSharp", ()=>(0, _historyEduSharpDefault.default));
parcelHelpers.export(exports, "HistoryEduTwoTone", ()=>(0, _historyEduTwoToneDefault.default));
parcelHelpers.export(exports, "HistoryOutlined", ()=>(0, _historyOutlinedDefault.default));
parcelHelpers.export(exports, "HistoryRounded", ()=>(0, _historyRoundedDefault.default));
parcelHelpers.export(exports, "HistorySharp", ()=>(0, _historySharpDefault.default));
parcelHelpers.export(exports, "HistoryToggleOff", ()=>(0, _historyToggleOffDefault.default));
parcelHelpers.export(exports, "HistoryToggleOffOutlined", ()=>(0, _historyToggleOffOutlinedDefault.default));
parcelHelpers.export(exports, "HistoryToggleOffRounded", ()=>(0, _historyToggleOffRoundedDefault.default));
parcelHelpers.export(exports, "HistoryToggleOffSharp", ()=>(0, _historyToggleOffSharpDefault.default));
parcelHelpers.export(exports, "HistoryToggleOffTwoTone", ()=>(0, _historyToggleOffTwoToneDefault.default));
parcelHelpers.export(exports, "HistoryTwoTone", ()=>(0, _historyTwoToneDefault.default));
parcelHelpers.export(exports, "Hive", ()=>(0, _hiveDefault.default));
parcelHelpers.export(exports, "HiveOutlined", ()=>(0, _hiveOutlinedDefault.default));
parcelHelpers.export(exports, "HiveRounded", ()=>(0, _hiveRoundedDefault.default));
parcelHelpers.export(exports, "HiveSharp", ()=>(0, _hiveSharpDefault.default));
parcelHelpers.export(exports, "HiveTwoTone", ()=>(0, _hiveTwoToneDefault.default));
parcelHelpers.export(exports, "Hls", ()=>(0, _hlsDefault.default));
parcelHelpers.export(exports, "HlsOff", ()=>(0, _hlsOffDefault.default));
parcelHelpers.export(exports, "HlsOffOutlined", ()=>(0, _hlsOffOutlinedDefault.default));
parcelHelpers.export(exports, "HlsOffRounded", ()=>(0, _hlsOffRoundedDefault.default));
parcelHelpers.export(exports, "HlsOffSharp", ()=>(0, _hlsOffSharpDefault.default));
parcelHelpers.export(exports, "HlsOffTwoTone", ()=>(0, _hlsOffTwoToneDefault.default));
parcelHelpers.export(exports, "HlsOutlined", ()=>(0, _hlsOutlinedDefault.default));
parcelHelpers.export(exports, "HlsRounded", ()=>(0, _hlsRoundedDefault.default));
parcelHelpers.export(exports, "HlsSharp", ()=>(0, _hlsSharpDefault.default));
parcelHelpers.export(exports, "HlsTwoTone", ()=>(0, _hlsTwoToneDefault.default));
parcelHelpers.export(exports, "HolidayVillage", ()=>(0, _holidayVillageDefault.default));
parcelHelpers.export(exports, "HolidayVillageOutlined", ()=>(0, _holidayVillageOutlinedDefault.default));
parcelHelpers.export(exports, "HolidayVillageRounded", ()=>(0, _holidayVillageRoundedDefault.default));
parcelHelpers.export(exports, "HolidayVillageSharp", ()=>(0, _holidayVillageSharpDefault.default));
parcelHelpers.export(exports, "HolidayVillageTwoTone", ()=>(0, _holidayVillageTwoToneDefault.default));
parcelHelpers.export(exports, "Home", ()=>(0, _homeDefault.default));
parcelHelpers.export(exports, "HomeMax", ()=>(0, _homeMaxDefault.default));
parcelHelpers.export(exports, "HomeMaxOutlined", ()=>(0, _homeMaxOutlinedDefault.default));
parcelHelpers.export(exports, "HomeMaxRounded", ()=>(0, _homeMaxRoundedDefault.default));
parcelHelpers.export(exports, "HomeMaxSharp", ()=>(0, _homeMaxSharpDefault.default));
parcelHelpers.export(exports, "HomeMaxTwoTone", ()=>(0, _homeMaxTwoToneDefault.default));
parcelHelpers.export(exports, "HomeMini", ()=>(0, _homeMiniDefault.default));
parcelHelpers.export(exports, "HomeMiniOutlined", ()=>(0, _homeMiniOutlinedDefault.default));
parcelHelpers.export(exports, "HomeMiniRounded", ()=>(0, _homeMiniRoundedDefault.default));
parcelHelpers.export(exports, "HomeMiniSharp", ()=>(0, _homeMiniSharpDefault.default));
parcelHelpers.export(exports, "HomeMiniTwoTone", ()=>(0, _homeMiniTwoToneDefault.default));
parcelHelpers.export(exports, "HomeOutlined", ()=>(0, _homeOutlinedDefault.default));
parcelHelpers.export(exports, "HomeRepairService", ()=>(0, _homeRepairServiceDefault.default));
parcelHelpers.export(exports, "HomeRepairServiceOutlined", ()=>(0, _homeRepairServiceOutlinedDefault.default));
parcelHelpers.export(exports, "HomeRepairServiceRounded", ()=>(0, _homeRepairServiceRoundedDefault.default));
parcelHelpers.export(exports, "HomeRepairServiceSharp", ()=>(0, _homeRepairServiceSharpDefault.default));
parcelHelpers.export(exports, "HomeRepairServiceTwoTone", ()=>(0, _homeRepairServiceTwoToneDefault.default));
parcelHelpers.export(exports, "HomeRounded", ()=>(0, _homeRoundedDefault.default));
parcelHelpers.export(exports, "HomeSharp", ()=>(0, _homeSharpDefault.default));
parcelHelpers.export(exports, "HomeTwoTone", ()=>(0, _homeTwoToneDefault.default));
parcelHelpers.export(exports, "HomeWork", ()=>(0, _homeWorkDefault.default));
parcelHelpers.export(exports, "HomeWorkOutlined", ()=>(0, _homeWorkOutlinedDefault.default));
parcelHelpers.export(exports, "HomeWorkRounded", ()=>(0, _homeWorkRoundedDefault.default));
parcelHelpers.export(exports, "HomeWorkSharp", ()=>(0, _homeWorkSharpDefault.default));
parcelHelpers.export(exports, "HomeWorkTwoTone", ()=>(0, _homeWorkTwoToneDefault.default));
parcelHelpers.export(exports, "HorizontalRule", ()=>(0, _horizontalRuleDefault.default));
parcelHelpers.export(exports, "HorizontalRuleOutlined", ()=>(0, _horizontalRuleOutlinedDefault.default));
parcelHelpers.export(exports, "HorizontalRuleRounded", ()=>(0, _horizontalRuleRoundedDefault.default));
parcelHelpers.export(exports, "HorizontalRuleSharp", ()=>(0, _horizontalRuleSharpDefault.default));
parcelHelpers.export(exports, "HorizontalRuleTwoTone", ()=>(0, _horizontalRuleTwoToneDefault.default));
parcelHelpers.export(exports, "HorizontalSplit", ()=>(0, _horizontalSplitDefault.default));
parcelHelpers.export(exports, "HorizontalSplitOutlined", ()=>(0, _horizontalSplitOutlinedDefault.default));
parcelHelpers.export(exports, "HorizontalSplitRounded", ()=>(0, _horizontalSplitRoundedDefault.default));
parcelHelpers.export(exports, "HorizontalSplitSharp", ()=>(0, _horizontalSplitSharpDefault.default));
parcelHelpers.export(exports, "HorizontalSplitTwoTone", ()=>(0, _horizontalSplitTwoToneDefault.default));
parcelHelpers.export(exports, "HotTub", ()=>(0, _hotTubDefault.default));
parcelHelpers.export(exports, "HotTubOutlined", ()=>(0, _hotTubOutlinedDefault.default));
parcelHelpers.export(exports, "HotTubRounded", ()=>(0, _hotTubRoundedDefault.default));
parcelHelpers.export(exports, "HotTubSharp", ()=>(0, _hotTubSharpDefault.default));
parcelHelpers.export(exports, "HotTubTwoTone", ()=>(0, _hotTubTwoToneDefault.default));
parcelHelpers.export(exports, "Hotel", ()=>(0, _hotelDefault.default));
parcelHelpers.export(exports, "HotelOutlined", ()=>(0, _hotelOutlinedDefault.default));
parcelHelpers.export(exports, "HotelRounded", ()=>(0, _hotelRoundedDefault.default));
parcelHelpers.export(exports, "HotelSharp", ()=>(0, _hotelSharpDefault.default));
parcelHelpers.export(exports, "HotelTwoTone", ()=>(0, _hotelTwoToneDefault.default));
parcelHelpers.export(exports, "HourglassBottom", ()=>(0, _hourglassBottomDefault.default));
parcelHelpers.export(exports, "HourglassBottomOutlined", ()=>(0, _hourglassBottomOutlinedDefault.default));
parcelHelpers.export(exports, "HourglassBottomRounded", ()=>(0, _hourglassBottomRoundedDefault.default));
parcelHelpers.export(exports, "HourglassBottomSharp", ()=>(0, _hourglassBottomSharpDefault.default));
parcelHelpers.export(exports, "HourglassBottomTwoTone", ()=>(0, _hourglassBottomTwoToneDefault.default));
parcelHelpers.export(exports, "HourglassDisabled", ()=>(0, _hourglassDisabledDefault.default));
parcelHelpers.export(exports, "HourglassDisabledOutlined", ()=>(0, _hourglassDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "HourglassDisabledRounded", ()=>(0, _hourglassDisabledRoundedDefault.default));
parcelHelpers.export(exports, "HourglassDisabledSharp", ()=>(0, _hourglassDisabledSharpDefault.default));
parcelHelpers.export(exports, "HourglassDisabledTwoTone", ()=>(0, _hourglassDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "HourglassEmpty", ()=>(0, _hourglassEmptyDefault.default));
parcelHelpers.export(exports, "HourglassEmptyOutlined", ()=>(0, _hourglassEmptyOutlinedDefault.default));
parcelHelpers.export(exports, "HourglassEmptyRounded", ()=>(0, _hourglassEmptyRoundedDefault.default));
parcelHelpers.export(exports, "HourglassEmptySharp", ()=>(0, _hourglassEmptySharpDefault.default));
parcelHelpers.export(exports, "HourglassEmptyTwoTone", ()=>(0, _hourglassEmptyTwoToneDefault.default));
parcelHelpers.export(exports, "HourglassFull", ()=>(0, _hourglassFullDefault.default));
parcelHelpers.export(exports, "HourglassFullOutlined", ()=>(0, _hourglassFullOutlinedDefault.default));
parcelHelpers.export(exports, "HourglassFullRounded", ()=>(0, _hourglassFullRoundedDefault.default));
parcelHelpers.export(exports, "HourglassFullSharp", ()=>(0, _hourglassFullSharpDefault.default));
parcelHelpers.export(exports, "HourglassFullTwoTone", ()=>(0, _hourglassFullTwoToneDefault.default));
parcelHelpers.export(exports, "HourglassTop", ()=>(0, _hourglassTopDefault.default));
parcelHelpers.export(exports, "HourglassTopOutlined", ()=>(0, _hourglassTopOutlinedDefault.default));
parcelHelpers.export(exports, "HourglassTopRounded", ()=>(0, _hourglassTopRoundedDefault.default));
parcelHelpers.export(exports, "HourglassTopSharp", ()=>(0, _hourglassTopSharpDefault.default));
parcelHelpers.export(exports, "HourglassTopTwoTone", ()=>(0, _hourglassTopTwoToneDefault.default));
parcelHelpers.export(exports, "House", ()=>(0, _houseDefault.default));
parcelHelpers.export(exports, "HouseOutlined", ()=>(0, _houseOutlinedDefault.default));
parcelHelpers.export(exports, "HouseRounded", ()=>(0, _houseRoundedDefault.default));
parcelHelpers.export(exports, "HouseSharp", ()=>(0, _houseSharpDefault.default));
parcelHelpers.export(exports, "HouseSiding", ()=>(0, _houseSidingDefault.default));
parcelHelpers.export(exports, "HouseSidingOutlined", ()=>(0, _houseSidingOutlinedDefault.default));
parcelHelpers.export(exports, "HouseSidingRounded", ()=>(0, _houseSidingRoundedDefault.default));
parcelHelpers.export(exports, "HouseSidingSharp", ()=>(0, _houseSidingSharpDefault.default));
parcelHelpers.export(exports, "HouseSidingTwoTone", ()=>(0, _houseSidingTwoToneDefault.default));
parcelHelpers.export(exports, "HouseTwoTone", ()=>(0, _houseTwoToneDefault.default));
parcelHelpers.export(exports, "Houseboat", ()=>(0, _houseboatDefault.default));
parcelHelpers.export(exports, "HouseboatOutlined", ()=>(0, _houseboatOutlinedDefault.default));
parcelHelpers.export(exports, "HouseboatRounded", ()=>(0, _houseboatRoundedDefault.default));
parcelHelpers.export(exports, "HouseboatSharp", ()=>(0, _houseboatSharpDefault.default));
parcelHelpers.export(exports, "HouseboatTwoTone", ()=>(0, _houseboatTwoToneDefault.default));
parcelHelpers.export(exports, "HowToReg", ()=>(0, _howToRegDefault.default));
parcelHelpers.export(exports, "HowToRegOutlined", ()=>(0, _howToRegOutlinedDefault.default));
parcelHelpers.export(exports, "HowToRegRounded", ()=>(0, _howToRegRoundedDefault.default));
parcelHelpers.export(exports, "HowToRegSharp", ()=>(0, _howToRegSharpDefault.default));
parcelHelpers.export(exports, "HowToRegTwoTone", ()=>(0, _howToRegTwoToneDefault.default));
parcelHelpers.export(exports, "HowToVote", ()=>(0, _howToVoteDefault.default));
parcelHelpers.export(exports, "HowToVoteOutlined", ()=>(0, _howToVoteOutlinedDefault.default));
parcelHelpers.export(exports, "HowToVoteRounded", ()=>(0, _howToVoteRoundedDefault.default));
parcelHelpers.export(exports, "HowToVoteSharp", ()=>(0, _howToVoteSharpDefault.default));
parcelHelpers.export(exports, "HowToVoteTwoTone", ()=>(0, _howToVoteTwoToneDefault.default));
parcelHelpers.export(exports, "Html", ()=>(0, _htmlDefault.default));
parcelHelpers.export(exports, "HtmlOutlined", ()=>(0, _htmlOutlinedDefault.default));
parcelHelpers.export(exports, "HtmlRounded", ()=>(0, _htmlRoundedDefault.default));
parcelHelpers.export(exports, "HtmlSharp", ()=>(0, _htmlSharpDefault.default));
parcelHelpers.export(exports, "HtmlTwoTone", ()=>(0, _htmlTwoToneDefault.default));
parcelHelpers.export(exports, "Http", ()=>(0, _httpDefault.default));
parcelHelpers.export(exports, "HttpOutlined", ()=>(0, _httpOutlinedDefault.default));
parcelHelpers.export(exports, "HttpRounded", ()=>(0, _httpRoundedDefault.default));
parcelHelpers.export(exports, "HttpSharp", ()=>(0, _httpSharpDefault.default));
parcelHelpers.export(exports, "HttpTwoTone", ()=>(0, _httpTwoToneDefault.default));
parcelHelpers.export(exports, "Https", ()=>(0, _httpsDefault.default));
parcelHelpers.export(exports, "HttpsOutlined", ()=>(0, _httpsOutlinedDefault.default));
parcelHelpers.export(exports, "HttpsRounded", ()=>(0, _httpsRoundedDefault.default));
parcelHelpers.export(exports, "HttpsSharp", ()=>(0, _httpsSharpDefault.default));
parcelHelpers.export(exports, "HttpsTwoTone", ()=>(0, _httpsTwoToneDefault.default));
parcelHelpers.export(exports, "Hub", ()=>(0, _hubDefault.default));
parcelHelpers.export(exports, "HubOutlined", ()=>(0, _hubOutlinedDefault.default));
parcelHelpers.export(exports, "HubRounded", ()=>(0, _hubRoundedDefault.default));
parcelHelpers.export(exports, "HubSharp", ()=>(0, _hubSharpDefault.default));
parcelHelpers.export(exports, "HubTwoTone", ()=>(0, _hubTwoToneDefault.default));
parcelHelpers.export(exports, "Hvac", ()=>(0, _hvacDefault.default));
parcelHelpers.export(exports, "HvacOutlined", ()=>(0, _hvacOutlinedDefault.default));
parcelHelpers.export(exports, "HvacRounded", ()=>(0, _hvacRoundedDefault.default));
parcelHelpers.export(exports, "HvacSharp", ()=>(0, _hvacSharpDefault.default));
parcelHelpers.export(exports, "HvacTwoTone", ()=>(0, _hvacTwoToneDefault.default));
parcelHelpers.export(exports, "IceSkating", ()=>(0, _iceSkatingDefault.default));
parcelHelpers.export(exports, "IceSkatingOutlined", ()=>(0, _iceSkatingOutlinedDefault.default));
parcelHelpers.export(exports, "IceSkatingRounded", ()=>(0, _iceSkatingRoundedDefault.default));
parcelHelpers.export(exports, "IceSkatingSharp", ()=>(0, _iceSkatingSharpDefault.default));
parcelHelpers.export(exports, "IceSkatingTwoTone", ()=>(0, _iceSkatingTwoToneDefault.default));
parcelHelpers.export(exports, "Icecream", ()=>(0, _icecreamDefault.default));
parcelHelpers.export(exports, "IcecreamOutlined", ()=>(0, _icecreamOutlinedDefault.default));
parcelHelpers.export(exports, "IcecreamRounded", ()=>(0, _icecreamRoundedDefault.default));
parcelHelpers.export(exports, "IcecreamSharp", ()=>(0, _icecreamSharpDefault.default));
parcelHelpers.export(exports, "IcecreamTwoTone", ()=>(0, _icecreamTwoToneDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageDefault.default));
parcelHelpers.export(exports, "ImageAspectRatio", ()=>(0, _imageAspectRatioDefault.default));
parcelHelpers.export(exports, "ImageAspectRatioOutlined", ()=>(0, _imageAspectRatioOutlinedDefault.default));
parcelHelpers.export(exports, "ImageAspectRatioRounded", ()=>(0, _imageAspectRatioRoundedDefault.default));
parcelHelpers.export(exports, "ImageAspectRatioSharp", ()=>(0, _imageAspectRatioSharpDefault.default));
parcelHelpers.export(exports, "ImageAspectRatioTwoTone", ()=>(0, _imageAspectRatioTwoToneDefault.default));
parcelHelpers.export(exports, "ImageNotSupported", ()=>(0, _imageNotSupportedDefault.default));
parcelHelpers.export(exports, "ImageNotSupportedOutlined", ()=>(0, _imageNotSupportedOutlinedDefault.default));
parcelHelpers.export(exports, "ImageNotSupportedRounded", ()=>(0, _imageNotSupportedRoundedDefault.default));
parcelHelpers.export(exports, "ImageNotSupportedSharp", ()=>(0, _imageNotSupportedSharpDefault.default));
parcelHelpers.export(exports, "ImageNotSupportedTwoTone", ()=>(0, _imageNotSupportedTwoToneDefault.default));
parcelHelpers.export(exports, "ImageOutlined", ()=>(0, _imageOutlinedDefault.default));
parcelHelpers.export(exports, "ImageRounded", ()=>(0, _imageRoundedDefault.default));
parcelHelpers.export(exports, "ImageSearch", ()=>(0, _imageSearchDefault.default));
parcelHelpers.export(exports, "ImageSearchOutlined", ()=>(0, _imageSearchOutlinedDefault.default));
parcelHelpers.export(exports, "ImageSearchRounded", ()=>(0, _imageSearchRoundedDefault.default));
parcelHelpers.export(exports, "ImageSearchSharp", ()=>(0, _imageSearchSharpDefault.default));
parcelHelpers.export(exports, "ImageSearchTwoTone", ()=>(0, _imageSearchTwoToneDefault.default));
parcelHelpers.export(exports, "ImageSharp", ()=>(0, _imageSharpDefault.default));
parcelHelpers.export(exports, "ImageTwoTone", ()=>(0, _imageTwoToneDefault.default));
parcelHelpers.export(exports, "ImagesearchRoller", ()=>(0, _imagesearchRollerDefault.default));
parcelHelpers.export(exports, "ImagesearchRollerOutlined", ()=>(0, _imagesearchRollerOutlinedDefault.default));
parcelHelpers.export(exports, "ImagesearchRollerRounded", ()=>(0, _imagesearchRollerRoundedDefault.default));
parcelHelpers.export(exports, "ImagesearchRollerSharp", ()=>(0, _imagesearchRollerSharpDefault.default));
parcelHelpers.export(exports, "ImagesearchRollerTwoTone", ()=>(0, _imagesearchRollerTwoToneDefault.default));
parcelHelpers.export(exports, "ImportContacts", ()=>(0, _importContactsDefault.default));
parcelHelpers.export(exports, "ImportContactsOutlined", ()=>(0, _importContactsOutlinedDefault.default));
parcelHelpers.export(exports, "ImportContactsRounded", ()=>(0, _importContactsRoundedDefault.default));
parcelHelpers.export(exports, "ImportContactsSharp", ()=>(0, _importContactsSharpDefault.default));
parcelHelpers.export(exports, "ImportContactsTwoTone", ()=>(0, _importContactsTwoToneDefault.default));
parcelHelpers.export(exports, "ImportExport", ()=>(0, _importExportDefault.default));
parcelHelpers.export(exports, "ImportExportOutlined", ()=>(0, _importExportOutlinedDefault.default));
parcelHelpers.export(exports, "ImportExportRounded", ()=>(0, _importExportRoundedDefault.default));
parcelHelpers.export(exports, "ImportExportSharp", ()=>(0, _importExportSharpDefault.default));
parcelHelpers.export(exports, "ImportExportTwoTone", ()=>(0, _importExportTwoToneDefault.default));
parcelHelpers.export(exports, "ImportantDevices", ()=>(0, _importantDevicesDefault.default));
parcelHelpers.export(exports, "ImportantDevicesOutlined", ()=>(0, _importantDevicesOutlinedDefault.default));
parcelHelpers.export(exports, "ImportantDevicesRounded", ()=>(0, _importantDevicesRoundedDefault.default));
parcelHelpers.export(exports, "ImportantDevicesSharp", ()=>(0, _importantDevicesSharpDefault.default));
parcelHelpers.export(exports, "ImportantDevicesTwoTone", ()=>(0, _importantDevicesTwoToneDefault.default));
parcelHelpers.export(exports, "Inbox", ()=>(0, _inboxDefault.default));
parcelHelpers.export(exports, "InboxOutlined", ()=>(0, _inboxOutlinedDefault.default));
parcelHelpers.export(exports, "InboxRounded", ()=>(0, _inboxRoundedDefault.default));
parcelHelpers.export(exports, "InboxSharp", ()=>(0, _inboxSharpDefault.default));
parcelHelpers.export(exports, "InboxTwoTone", ()=>(0, _inboxTwoToneDefault.default));
parcelHelpers.export(exports, "IndeterminateCheckBox", ()=>(0, _indeterminateCheckBoxDefault.default));
parcelHelpers.export(exports, "IndeterminateCheckBoxOutlined", ()=>(0, _indeterminateCheckBoxOutlinedDefault.default));
parcelHelpers.export(exports, "IndeterminateCheckBoxRounded", ()=>(0, _indeterminateCheckBoxRoundedDefault.default));
parcelHelpers.export(exports, "IndeterminateCheckBoxSharp", ()=>(0, _indeterminateCheckBoxSharpDefault.default));
parcelHelpers.export(exports, "IndeterminateCheckBoxTwoTone", ()=>(0, _indeterminateCheckBoxTwoToneDefault.default));
parcelHelpers.export(exports, "Info", ()=>(0, _infoDefault.default));
parcelHelpers.export(exports, "InfoOutlined", ()=>(0, _infoOutlinedDefault.default));
parcelHelpers.export(exports, "InfoRounded", ()=>(0, _infoRoundedDefault.default));
parcelHelpers.export(exports, "InfoSharp", ()=>(0, _infoSharpDefault.default));
parcelHelpers.export(exports, "InfoTwoTone", ()=>(0, _infoTwoToneDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "InputOutlined", ()=>(0, _inputOutlinedDefault.default));
parcelHelpers.export(exports, "InputRounded", ()=>(0, _inputRoundedDefault.default));
parcelHelpers.export(exports, "InputSharp", ()=>(0, _inputSharpDefault.default));
parcelHelpers.export(exports, "InputTwoTone", ()=>(0, _inputTwoToneDefault.default));
parcelHelpers.export(exports, "InsertChart", ()=>(0, _insertChartDefault.default));
parcelHelpers.export(exports, "InsertChartOutlined", ()=>(0, _insertChartOutlinedDefault.default));
parcelHelpers.export(exports, "InsertChartOutlinedOutlined", ()=>(0, _insertChartOutlinedOutlinedDefault.default));
parcelHelpers.export(exports, "InsertChartOutlinedRounded", ()=>(0, _insertChartOutlinedRoundedDefault.default));
parcelHelpers.export(exports, "InsertChartOutlinedSharp", ()=>(0, _insertChartOutlinedSharpDefault.default));
parcelHelpers.export(exports, "InsertChartOutlinedTwoTone", ()=>(0, _insertChartOutlinedTwoToneDefault.default));
parcelHelpers.export(exports, "InsertChartRounded", ()=>(0, _insertChartRoundedDefault.default));
parcelHelpers.export(exports, "InsertChartSharp", ()=>(0, _insertChartSharpDefault.default));
parcelHelpers.export(exports, "InsertChartTwoTone", ()=>(0, _insertChartTwoToneDefault.default));
parcelHelpers.export(exports, "InsertComment", ()=>(0, _insertCommentDefault.default));
parcelHelpers.export(exports, "InsertCommentOutlined", ()=>(0, _insertCommentOutlinedDefault.default));
parcelHelpers.export(exports, "InsertCommentRounded", ()=>(0, _insertCommentRoundedDefault.default));
parcelHelpers.export(exports, "InsertCommentSharp", ()=>(0, _insertCommentSharpDefault.default));
parcelHelpers.export(exports, "InsertCommentTwoTone", ()=>(0, _insertCommentTwoToneDefault.default));
parcelHelpers.export(exports, "InsertDriveFile", ()=>(0, _insertDriveFileDefault.default));
parcelHelpers.export(exports, "InsertDriveFileOutlined", ()=>(0, _insertDriveFileOutlinedDefault.default));
parcelHelpers.export(exports, "InsertDriveFileRounded", ()=>(0, _insertDriveFileRoundedDefault.default));
parcelHelpers.export(exports, "InsertDriveFileSharp", ()=>(0, _insertDriveFileSharpDefault.default));
parcelHelpers.export(exports, "InsertDriveFileTwoTone", ()=>(0, _insertDriveFileTwoToneDefault.default));
parcelHelpers.export(exports, "InsertEmoticon", ()=>(0, _insertEmoticonDefault.default));
parcelHelpers.export(exports, "InsertEmoticonOutlined", ()=>(0, _insertEmoticonOutlinedDefault.default));
parcelHelpers.export(exports, "InsertEmoticonRounded", ()=>(0, _insertEmoticonRoundedDefault.default));
parcelHelpers.export(exports, "InsertEmoticonSharp", ()=>(0, _insertEmoticonSharpDefault.default));
parcelHelpers.export(exports, "InsertEmoticonTwoTone", ()=>(0, _insertEmoticonTwoToneDefault.default));
parcelHelpers.export(exports, "InsertInvitation", ()=>(0, _insertInvitationDefault.default));
parcelHelpers.export(exports, "InsertInvitationOutlined", ()=>(0, _insertInvitationOutlinedDefault.default));
parcelHelpers.export(exports, "InsertInvitationRounded", ()=>(0, _insertInvitationRoundedDefault.default));
parcelHelpers.export(exports, "InsertInvitationSharp", ()=>(0, _insertInvitationSharpDefault.default));
parcelHelpers.export(exports, "InsertInvitationTwoTone", ()=>(0, _insertInvitationTwoToneDefault.default));
parcelHelpers.export(exports, "InsertLink", ()=>(0, _insertLinkDefault.default));
parcelHelpers.export(exports, "InsertLinkOutlined", ()=>(0, _insertLinkOutlinedDefault.default));
parcelHelpers.export(exports, "InsertLinkRounded", ()=>(0, _insertLinkRoundedDefault.default));
parcelHelpers.export(exports, "InsertLinkSharp", ()=>(0, _insertLinkSharpDefault.default));
parcelHelpers.export(exports, "InsertLinkTwoTone", ()=>(0, _insertLinkTwoToneDefault.default));
parcelHelpers.export(exports, "InsertPageBreak", ()=>(0, _insertPageBreakDefault.default));
parcelHelpers.export(exports, "InsertPageBreakOutlined", ()=>(0, _insertPageBreakOutlinedDefault.default));
parcelHelpers.export(exports, "InsertPageBreakRounded", ()=>(0, _insertPageBreakRoundedDefault.default));
parcelHelpers.export(exports, "InsertPageBreakSharp", ()=>(0, _insertPageBreakSharpDefault.default));
parcelHelpers.export(exports, "InsertPageBreakTwoTone", ()=>(0, _insertPageBreakTwoToneDefault.default));
parcelHelpers.export(exports, "InsertPhoto", ()=>(0, _insertPhotoDefault.default));
parcelHelpers.export(exports, "InsertPhotoOutlined", ()=>(0, _insertPhotoOutlinedDefault.default));
parcelHelpers.export(exports, "InsertPhotoRounded", ()=>(0, _insertPhotoRoundedDefault.default));
parcelHelpers.export(exports, "InsertPhotoSharp", ()=>(0, _insertPhotoSharpDefault.default));
parcelHelpers.export(exports, "InsertPhotoTwoTone", ()=>(0, _insertPhotoTwoToneDefault.default));
parcelHelpers.export(exports, "Insights", ()=>(0, _insightsDefault.default));
parcelHelpers.export(exports, "InsightsOutlined", ()=>(0, _insightsOutlinedDefault.default));
parcelHelpers.export(exports, "InsightsRounded", ()=>(0, _insightsRoundedDefault.default));
parcelHelpers.export(exports, "InsightsSharp", ()=>(0, _insightsSharpDefault.default));
parcelHelpers.export(exports, "InsightsTwoTone", ()=>(0, _insightsTwoToneDefault.default));
parcelHelpers.export(exports, "Instagram", ()=>(0, _instagramDefault.default));
parcelHelpers.export(exports, "InstallDesktop", ()=>(0, _installDesktopDefault.default));
parcelHelpers.export(exports, "InstallDesktopOutlined", ()=>(0, _installDesktopOutlinedDefault.default));
parcelHelpers.export(exports, "InstallDesktopRounded", ()=>(0, _installDesktopRoundedDefault.default));
parcelHelpers.export(exports, "InstallDesktopSharp", ()=>(0, _installDesktopSharpDefault.default));
parcelHelpers.export(exports, "InstallDesktopTwoTone", ()=>(0, _installDesktopTwoToneDefault.default));
parcelHelpers.export(exports, "InstallMobile", ()=>(0, _installMobileDefault.default));
parcelHelpers.export(exports, "InstallMobileOutlined", ()=>(0, _installMobileOutlinedDefault.default));
parcelHelpers.export(exports, "InstallMobileRounded", ()=>(0, _installMobileRoundedDefault.default));
parcelHelpers.export(exports, "InstallMobileSharp", ()=>(0, _installMobileSharpDefault.default));
parcelHelpers.export(exports, "InstallMobileTwoTone", ()=>(0, _installMobileTwoToneDefault.default));
parcelHelpers.export(exports, "IntegrationInstructions", ()=>(0, _integrationInstructionsDefault.default));
parcelHelpers.export(exports, "IntegrationInstructionsOutlined", ()=>(0, _integrationInstructionsOutlinedDefault.default));
parcelHelpers.export(exports, "IntegrationInstructionsRounded", ()=>(0, _integrationInstructionsRoundedDefault.default));
parcelHelpers.export(exports, "IntegrationInstructionsSharp", ()=>(0, _integrationInstructionsSharpDefault.default));
parcelHelpers.export(exports, "IntegrationInstructionsTwoTone", ()=>(0, _integrationInstructionsTwoToneDefault.default));
parcelHelpers.export(exports, "Interests", ()=>(0, _interestsDefault.default));
parcelHelpers.export(exports, "InterestsOutlined", ()=>(0, _interestsOutlinedDefault.default));
parcelHelpers.export(exports, "InterestsRounded", ()=>(0, _interestsRoundedDefault.default));
parcelHelpers.export(exports, "InterestsSharp", ()=>(0, _interestsSharpDefault.default));
parcelHelpers.export(exports, "InterestsTwoTone", ()=>(0, _interestsTwoToneDefault.default));
parcelHelpers.export(exports, "InterpreterMode", ()=>(0, _interpreterModeDefault.default));
parcelHelpers.export(exports, "InterpreterModeOutlined", ()=>(0, _interpreterModeOutlinedDefault.default));
parcelHelpers.export(exports, "InterpreterModeRounded", ()=>(0, _interpreterModeRoundedDefault.default));
parcelHelpers.export(exports, "InterpreterModeSharp", ()=>(0, _interpreterModeSharpDefault.default));
parcelHelpers.export(exports, "InterpreterModeTwoTone", ()=>(0, _interpreterModeTwoToneDefault.default));
parcelHelpers.export(exports, "Inventory", ()=>(0, _inventoryDefault.default));
parcelHelpers.export(exports, "Inventory2", ()=>(0, _inventory2Default.default));
parcelHelpers.export(exports, "Inventory2Outlined", ()=>(0, _inventory2OutlinedDefault.default));
parcelHelpers.export(exports, "Inventory2Rounded", ()=>(0, _inventory2RoundedDefault.default));
parcelHelpers.export(exports, "Inventory2Sharp", ()=>(0, _inventory2SharpDefault.default));
parcelHelpers.export(exports, "Inventory2TwoTone", ()=>(0, _inventory2TwoToneDefault.default));
parcelHelpers.export(exports, "InventoryOutlined", ()=>(0, _inventoryOutlinedDefault.default));
parcelHelpers.export(exports, "InventoryRounded", ()=>(0, _inventoryRoundedDefault.default));
parcelHelpers.export(exports, "InventorySharp", ()=>(0, _inventorySharpDefault.default));
parcelHelpers.export(exports, "InventoryTwoTone", ()=>(0, _inventoryTwoToneDefault.default));
parcelHelpers.export(exports, "InvertColors", ()=>(0, _invertColorsDefault.default));
parcelHelpers.export(exports, "InvertColorsOff", ()=>(0, _invertColorsOffDefault.default));
parcelHelpers.export(exports, "InvertColorsOffOutlined", ()=>(0, _invertColorsOffOutlinedDefault.default));
parcelHelpers.export(exports, "InvertColorsOffRounded", ()=>(0, _invertColorsOffRoundedDefault.default));
parcelHelpers.export(exports, "InvertColorsOffSharp", ()=>(0, _invertColorsOffSharpDefault.default));
parcelHelpers.export(exports, "InvertColorsOffTwoTone", ()=>(0, _invertColorsOffTwoToneDefault.default));
parcelHelpers.export(exports, "InvertColorsOutlined", ()=>(0, _invertColorsOutlinedDefault.default));
parcelHelpers.export(exports, "InvertColorsRounded", ()=>(0, _invertColorsRoundedDefault.default));
parcelHelpers.export(exports, "InvertColorsSharp", ()=>(0, _invertColorsSharpDefault.default));
parcelHelpers.export(exports, "InvertColorsTwoTone", ()=>(0, _invertColorsTwoToneDefault.default));
parcelHelpers.export(exports, "IosShare", ()=>(0, _iosShareDefault.default));
parcelHelpers.export(exports, "IosShareOutlined", ()=>(0, _iosShareOutlinedDefault.default));
parcelHelpers.export(exports, "IosShareRounded", ()=>(0, _iosShareRoundedDefault.default));
parcelHelpers.export(exports, "IosShareSharp", ()=>(0, _iosShareSharpDefault.default));
parcelHelpers.export(exports, "IosShareTwoTone", ()=>(0, _iosShareTwoToneDefault.default));
parcelHelpers.export(exports, "Iron", ()=>(0, _ironDefault.default));
parcelHelpers.export(exports, "IronOutlined", ()=>(0, _ironOutlinedDefault.default));
parcelHelpers.export(exports, "IronRounded", ()=>(0, _ironRoundedDefault.default));
parcelHelpers.export(exports, "IronSharp", ()=>(0, _ironSharpDefault.default));
parcelHelpers.export(exports, "IronTwoTone", ()=>(0, _ironTwoToneDefault.default));
parcelHelpers.export(exports, "Iso", ()=>(0, _isoDefault.default));
parcelHelpers.export(exports, "IsoOutlined", ()=>(0, _isoOutlinedDefault.default));
parcelHelpers.export(exports, "IsoRounded", ()=>(0, _isoRoundedDefault.default));
parcelHelpers.export(exports, "IsoSharp", ()=>(0, _isoSharpDefault.default));
parcelHelpers.export(exports, "IsoTwoTone", ()=>(0, _isoTwoToneDefault.default));
parcelHelpers.export(exports, "Javascript", ()=>(0, _javascriptDefault.default));
parcelHelpers.export(exports, "JavascriptOutlined", ()=>(0, _javascriptOutlinedDefault.default));
parcelHelpers.export(exports, "JavascriptRounded", ()=>(0, _javascriptRoundedDefault.default));
parcelHelpers.export(exports, "JavascriptSharp", ()=>(0, _javascriptSharpDefault.default));
parcelHelpers.export(exports, "JavascriptTwoTone", ()=>(0, _javascriptTwoToneDefault.default));
parcelHelpers.export(exports, "JoinFull", ()=>(0, _joinFullDefault.default));
parcelHelpers.export(exports, "JoinFullOutlined", ()=>(0, _joinFullOutlinedDefault.default));
parcelHelpers.export(exports, "JoinFullRounded", ()=>(0, _joinFullRoundedDefault.default));
parcelHelpers.export(exports, "JoinFullSharp", ()=>(0, _joinFullSharpDefault.default));
parcelHelpers.export(exports, "JoinFullTwoTone", ()=>(0, _joinFullTwoToneDefault.default));
parcelHelpers.export(exports, "JoinInner", ()=>(0, _joinInnerDefault.default));
parcelHelpers.export(exports, "JoinInnerOutlined", ()=>(0, _joinInnerOutlinedDefault.default));
parcelHelpers.export(exports, "JoinInnerRounded", ()=>(0, _joinInnerRoundedDefault.default));
parcelHelpers.export(exports, "JoinInnerSharp", ()=>(0, _joinInnerSharpDefault.default));
parcelHelpers.export(exports, "JoinInnerTwoTone", ()=>(0, _joinInnerTwoToneDefault.default));
parcelHelpers.export(exports, "JoinLeft", ()=>(0, _joinLeftDefault.default));
parcelHelpers.export(exports, "JoinLeftOutlined", ()=>(0, _joinLeftOutlinedDefault.default));
parcelHelpers.export(exports, "JoinLeftRounded", ()=>(0, _joinLeftRoundedDefault.default));
parcelHelpers.export(exports, "JoinLeftSharp", ()=>(0, _joinLeftSharpDefault.default));
parcelHelpers.export(exports, "JoinLeftTwoTone", ()=>(0, _joinLeftTwoToneDefault.default));
parcelHelpers.export(exports, "JoinRight", ()=>(0, _joinRightDefault.default));
parcelHelpers.export(exports, "JoinRightOutlined", ()=>(0, _joinRightOutlinedDefault.default));
parcelHelpers.export(exports, "JoinRightRounded", ()=>(0, _joinRightRoundedDefault.default));
parcelHelpers.export(exports, "JoinRightSharp", ()=>(0, _joinRightSharpDefault.default));
parcelHelpers.export(exports, "JoinRightTwoTone", ()=>(0, _joinRightTwoToneDefault.default));
parcelHelpers.export(exports, "Kayaking", ()=>(0, _kayakingDefault.default));
parcelHelpers.export(exports, "KayakingOutlined", ()=>(0, _kayakingOutlinedDefault.default));
parcelHelpers.export(exports, "KayakingRounded", ()=>(0, _kayakingRoundedDefault.default));
parcelHelpers.export(exports, "KayakingSharp", ()=>(0, _kayakingSharpDefault.default));
parcelHelpers.export(exports, "KayakingTwoTone", ()=>(0, _kayakingTwoToneDefault.default));
parcelHelpers.export(exports, "KebabDining", ()=>(0, _kebabDiningDefault.default));
parcelHelpers.export(exports, "KebabDiningOutlined", ()=>(0, _kebabDiningOutlinedDefault.default));
parcelHelpers.export(exports, "KebabDiningRounded", ()=>(0, _kebabDiningRoundedDefault.default));
parcelHelpers.export(exports, "KebabDiningSharp", ()=>(0, _kebabDiningSharpDefault.default));
parcelHelpers.export(exports, "KebabDiningTwoTone", ()=>(0, _kebabDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Key", ()=>(0, _keyDefault.default));
parcelHelpers.export(exports, "KeyOff", ()=>(0, _keyOffDefault.default));
parcelHelpers.export(exports, "KeyOffOutlined", ()=>(0, _keyOffOutlinedDefault.default));
parcelHelpers.export(exports, "KeyOffRounded", ()=>(0, _keyOffRoundedDefault.default));
parcelHelpers.export(exports, "KeyOffSharp", ()=>(0, _keyOffSharpDefault.default));
parcelHelpers.export(exports, "KeyOffTwoTone", ()=>(0, _keyOffTwoToneDefault.default));
parcelHelpers.export(exports, "KeyOutlined", ()=>(0, _keyOutlinedDefault.default));
parcelHelpers.export(exports, "KeyRounded", ()=>(0, _keyRoundedDefault.default));
parcelHelpers.export(exports, "KeySharp", ()=>(0, _keySharpDefault.default));
parcelHelpers.export(exports, "KeyTwoTone", ()=>(0, _keyTwoToneDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardDefault.default));
parcelHelpers.export(exports, "KeyboardAlt", ()=>(0, _keyboardAltDefault.default));
parcelHelpers.export(exports, "KeyboardAltOutlined", ()=>(0, _keyboardAltOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardAltRounded", ()=>(0, _keyboardAltRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardAltSharp", ()=>(0, _keyboardAltSharpDefault.default));
parcelHelpers.export(exports, "KeyboardAltTwoTone", ()=>(0, _keyboardAltTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDown", ()=>(0, _keyboardArrowDownDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDownOutlined", ()=>(0, _keyboardArrowDownOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDownRounded", ()=>(0, _keyboardArrowDownRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDownSharp", ()=>(0, _keyboardArrowDownSharpDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDownTwoTone", ()=>(0, _keyboardArrowDownTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardArrowLeft", ()=>(0, _keyboardArrowLeftDefault.default));
parcelHelpers.export(exports, "KeyboardArrowLeftOutlined", ()=>(0, _keyboardArrowLeftOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowLeftRounded", ()=>(0, _keyboardArrowLeftRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowLeftSharp", ()=>(0, _keyboardArrowLeftSharpDefault.default));
parcelHelpers.export(exports, "KeyboardArrowLeftTwoTone", ()=>(0, _keyboardArrowLeftTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardArrowRight", ()=>(0, _keyboardArrowRightDefault.default));
parcelHelpers.export(exports, "KeyboardArrowRightOutlined", ()=>(0, _keyboardArrowRightOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowRightRounded", ()=>(0, _keyboardArrowRightRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowRightSharp", ()=>(0, _keyboardArrowRightSharpDefault.default));
parcelHelpers.export(exports, "KeyboardArrowRightTwoTone", ()=>(0, _keyboardArrowRightTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardArrowUp", ()=>(0, _keyboardArrowUpDefault.default));
parcelHelpers.export(exports, "KeyboardArrowUpOutlined", ()=>(0, _keyboardArrowUpOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowUpRounded", ()=>(0, _keyboardArrowUpRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardArrowUpSharp", ()=>(0, _keyboardArrowUpSharpDefault.default));
parcelHelpers.export(exports, "KeyboardArrowUpTwoTone", ()=>(0, _keyboardArrowUpTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardBackspace", ()=>(0, _keyboardBackspaceDefault.default));
parcelHelpers.export(exports, "KeyboardBackspaceOutlined", ()=>(0, _keyboardBackspaceOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardBackspaceRounded", ()=>(0, _keyboardBackspaceRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardBackspaceSharp", ()=>(0, _keyboardBackspaceSharpDefault.default));
parcelHelpers.export(exports, "KeyboardBackspaceTwoTone", ()=>(0, _keyboardBackspaceTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardCapslock", ()=>(0, _keyboardCapslockDefault.default));
parcelHelpers.export(exports, "KeyboardCapslockOutlined", ()=>(0, _keyboardCapslockOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardCapslockRounded", ()=>(0, _keyboardCapslockRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardCapslockSharp", ()=>(0, _keyboardCapslockSharpDefault.default));
parcelHelpers.export(exports, "KeyboardCapslockTwoTone", ()=>(0, _keyboardCapslockTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardCommandKey", ()=>(0, _keyboardCommandKeyDefault.default));
parcelHelpers.export(exports, "KeyboardCommandKeyOutlined", ()=>(0, _keyboardCommandKeyOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardCommandKeyRounded", ()=>(0, _keyboardCommandKeyRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardCommandKeySharp", ()=>(0, _keyboardCommandKeySharpDefault.default));
parcelHelpers.export(exports, "KeyboardCommandKeyTwoTone", ()=>(0, _keyboardCommandKeyTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardControlKey", ()=>(0, _keyboardControlKeyDefault.default));
parcelHelpers.export(exports, "KeyboardControlKeyOutlined", ()=>(0, _keyboardControlKeyOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardControlKeyRounded", ()=>(0, _keyboardControlKeyRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardControlKeySharp", ()=>(0, _keyboardControlKeySharpDefault.default));
parcelHelpers.export(exports, "KeyboardControlKeyTwoTone", ()=>(0, _keyboardControlKeyTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowDown", ()=>(0, _keyboardDoubleArrowDownDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowDownOutlined", ()=>(0, _keyboardDoubleArrowDownOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowDownRounded", ()=>(0, _keyboardDoubleArrowDownRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowDownSharp", ()=>(0, _keyboardDoubleArrowDownSharpDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowDownTwoTone", ()=>(0, _keyboardDoubleArrowDownTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowLeft", ()=>(0, _keyboardDoubleArrowLeftDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowLeftOutlined", ()=>(0, _keyboardDoubleArrowLeftOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowLeftRounded", ()=>(0, _keyboardDoubleArrowLeftRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowLeftSharp", ()=>(0, _keyboardDoubleArrowLeftSharpDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowLeftTwoTone", ()=>(0, _keyboardDoubleArrowLeftTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowRight", ()=>(0, _keyboardDoubleArrowRightDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowRightOutlined", ()=>(0, _keyboardDoubleArrowRightOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowRightRounded", ()=>(0, _keyboardDoubleArrowRightRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowRightSharp", ()=>(0, _keyboardDoubleArrowRightSharpDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowRightTwoTone", ()=>(0, _keyboardDoubleArrowRightTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowUp", ()=>(0, _keyboardDoubleArrowUpDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowUpOutlined", ()=>(0, _keyboardDoubleArrowUpOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowUpRounded", ()=>(0, _keyboardDoubleArrowUpRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowUpSharp", ()=>(0, _keyboardDoubleArrowUpSharpDefault.default));
parcelHelpers.export(exports, "KeyboardDoubleArrowUpTwoTone", ()=>(0, _keyboardDoubleArrowUpTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardHide", ()=>(0, _keyboardHideDefault.default));
parcelHelpers.export(exports, "KeyboardHideOutlined", ()=>(0, _keyboardHideOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardHideRounded", ()=>(0, _keyboardHideRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardHideSharp", ()=>(0, _keyboardHideSharpDefault.default));
parcelHelpers.export(exports, "KeyboardHideTwoTone", ()=>(0, _keyboardHideTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardOptionKey", ()=>(0, _keyboardOptionKeyDefault.default));
parcelHelpers.export(exports, "KeyboardOptionKeyOutlined", ()=>(0, _keyboardOptionKeyOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardOptionKeyRounded", ()=>(0, _keyboardOptionKeyRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardOptionKeySharp", ()=>(0, _keyboardOptionKeySharpDefault.default));
parcelHelpers.export(exports, "KeyboardOptionKeyTwoTone", ()=>(0, _keyboardOptionKeyTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardOutlined", ()=>(0, _keyboardOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardReturn", ()=>(0, _keyboardReturnDefault.default));
parcelHelpers.export(exports, "KeyboardReturnOutlined", ()=>(0, _keyboardReturnOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardReturnRounded", ()=>(0, _keyboardReturnRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardReturnSharp", ()=>(0, _keyboardReturnSharpDefault.default));
parcelHelpers.export(exports, "KeyboardReturnTwoTone", ()=>(0, _keyboardReturnTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardRounded", ()=>(0, _keyboardRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardSharp", ()=>(0, _keyboardSharpDefault.default));
parcelHelpers.export(exports, "KeyboardTab", ()=>(0, _keyboardTabDefault.default));
parcelHelpers.export(exports, "KeyboardTabOutlined", ()=>(0, _keyboardTabOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardTabRounded", ()=>(0, _keyboardTabRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardTabSharp", ()=>(0, _keyboardTabSharpDefault.default));
parcelHelpers.export(exports, "KeyboardTabTwoTone", ()=>(0, _keyboardTabTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardTwoTone", ()=>(0, _keyboardTwoToneDefault.default));
parcelHelpers.export(exports, "KeyboardVoice", ()=>(0, _keyboardVoiceDefault.default));
parcelHelpers.export(exports, "KeyboardVoiceOutlined", ()=>(0, _keyboardVoiceOutlinedDefault.default));
parcelHelpers.export(exports, "KeyboardVoiceRounded", ()=>(0, _keyboardVoiceRoundedDefault.default));
parcelHelpers.export(exports, "KeyboardVoiceSharp", ()=>(0, _keyboardVoiceSharpDefault.default));
parcelHelpers.export(exports, "KeyboardVoiceTwoTone", ()=>(0, _keyboardVoiceTwoToneDefault.default));
parcelHelpers.export(exports, "KingBed", ()=>(0, _kingBedDefault.default));
parcelHelpers.export(exports, "KingBedOutlined", ()=>(0, _kingBedOutlinedDefault.default));
parcelHelpers.export(exports, "KingBedRounded", ()=>(0, _kingBedRoundedDefault.default));
parcelHelpers.export(exports, "KingBedSharp", ()=>(0, _kingBedSharpDefault.default));
parcelHelpers.export(exports, "KingBedTwoTone", ()=>(0, _kingBedTwoToneDefault.default));
parcelHelpers.export(exports, "Kitchen", ()=>(0, _kitchenDefault.default));
parcelHelpers.export(exports, "KitchenOutlined", ()=>(0, _kitchenOutlinedDefault.default));
parcelHelpers.export(exports, "KitchenRounded", ()=>(0, _kitchenRoundedDefault.default));
parcelHelpers.export(exports, "KitchenSharp", ()=>(0, _kitchenSharpDefault.default));
parcelHelpers.export(exports, "KitchenTwoTone", ()=>(0, _kitchenTwoToneDefault.default));
parcelHelpers.export(exports, "Kitesurfing", ()=>(0, _kitesurfingDefault.default));
parcelHelpers.export(exports, "KitesurfingOutlined", ()=>(0, _kitesurfingOutlinedDefault.default));
parcelHelpers.export(exports, "KitesurfingRounded", ()=>(0, _kitesurfingRoundedDefault.default));
parcelHelpers.export(exports, "KitesurfingSharp", ()=>(0, _kitesurfingSharpDefault.default));
parcelHelpers.export(exports, "KitesurfingTwoTone", ()=>(0, _kitesurfingTwoToneDefault.default));
parcelHelpers.export(exports, "Label", ()=>(0, _labelDefault.default));
parcelHelpers.export(exports, "LabelImportant", ()=>(0, _labelImportantDefault.default));
parcelHelpers.export(exports, "LabelImportantOutlined", ()=>(0, _labelImportantOutlinedDefault.default));
parcelHelpers.export(exports, "LabelImportantRounded", ()=>(0, _labelImportantRoundedDefault.default));
parcelHelpers.export(exports, "LabelImportantSharp", ()=>(0, _labelImportantSharpDefault.default));
parcelHelpers.export(exports, "LabelImportantTwoTone", ()=>(0, _labelImportantTwoToneDefault.default));
parcelHelpers.export(exports, "LabelOff", ()=>(0, _labelOffDefault.default));
parcelHelpers.export(exports, "LabelOffOutlined", ()=>(0, _labelOffOutlinedDefault.default));
parcelHelpers.export(exports, "LabelOffRounded", ()=>(0, _labelOffRoundedDefault.default));
parcelHelpers.export(exports, "LabelOffSharp", ()=>(0, _labelOffSharpDefault.default));
parcelHelpers.export(exports, "LabelOffTwoTone", ()=>(0, _labelOffTwoToneDefault.default));
parcelHelpers.export(exports, "LabelOutlined", ()=>(0, _labelOutlinedDefault.default));
parcelHelpers.export(exports, "LabelRounded", ()=>(0, _labelRoundedDefault.default));
parcelHelpers.export(exports, "LabelSharp", ()=>(0, _labelSharpDefault.default));
parcelHelpers.export(exports, "LabelTwoTone", ()=>(0, _labelTwoToneDefault.default));
parcelHelpers.export(exports, "Lan", ()=>(0, _lanDefault.default));
parcelHelpers.export(exports, "LanOutlined", ()=>(0, _lanOutlinedDefault.default));
parcelHelpers.export(exports, "LanRounded", ()=>(0, _lanRoundedDefault.default));
parcelHelpers.export(exports, "LanSharp", ()=>(0, _lanSharpDefault.default));
parcelHelpers.export(exports, "LanTwoTone", ()=>(0, _lanTwoToneDefault.default));
parcelHelpers.export(exports, "Landscape", ()=>(0, _landscapeDefault.default));
parcelHelpers.export(exports, "LandscapeOutlined", ()=>(0, _landscapeOutlinedDefault.default));
parcelHelpers.export(exports, "LandscapeRounded", ()=>(0, _landscapeRoundedDefault.default));
parcelHelpers.export(exports, "LandscapeSharp", ()=>(0, _landscapeSharpDefault.default));
parcelHelpers.export(exports, "LandscapeTwoTone", ()=>(0, _landscapeTwoToneDefault.default));
parcelHelpers.export(exports, "Landslide", ()=>(0, _landslideDefault.default));
parcelHelpers.export(exports, "LandslideOutlined", ()=>(0, _landslideOutlinedDefault.default));
parcelHelpers.export(exports, "LandslideRounded", ()=>(0, _landslideRoundedDefault.default));
parcelHelpers.export(exports, "LandslideSharp", ()=>(0, _landslideSharpDefault.default));
parcelHelpers.export(exports, "LandslideTwoTone", ()=>(0, _landslideTwoToneDefault.default));
parcelHelpers.export(exports, "Language", ()=>(0, _languageDefault.default));
parcelHelpers.export(exports, "LanguageOutlined", ()=>(0, _languageOutlinedDefault.default));
parcelHelpers.export(exports, "LanguageRounded", ()=>(0, _languageRoundedDefault.default));
parcelHelpers.export(exports, "LanguageSharp", ()=>(0, _languageSharpDefault.default));
parcelHelpers.export(exports, "LanguageTwoTone", ()=>(0, _languageTwoToneDefault.default));
parcelHelpers.export(exports, "Laptop", ()=>(0, _laptopDefault.default));
parcelHelpers.export(exports, "LaptopChromebook", ()=>(0, _laptopChromebookDefault.default));
parcelHelpers.export(exports, "LaptopChromebookOutlined", ()=>(0, _laptopChromebookOutlinedDefault.default));
parcelHelpers.export(exports, "LaptopChromebookRounded", ()=>(0, _laptopChromebookRoundedDefault.default));
parcelHelpers.export(exports, "LaptopChromebookSharp", ()=>(0, _laptopChromebookSharpDefault.default));
parcelHelpers.export(exports, "LaptopChromebookTwoTone", ()=>(0, _laptopChromebookTwoToneDefault.default));
parcelHelpers.export(exports, "LaptopMac", ()=>(0, _laptopMacDefault.default));
parcelHelpers.export(exports, "LaptopMacOutlined", ()=>(0, _laptopMacOutlinedDefault.default));
parcelHelpers.export(exports, "LaptopMacRounded", ()=>(0, _laptopMacRoundedDefault.default));
parcelHelpers.export(exports, "LaptopMacSharp", ()=>(0, _laptopMacSharpDefault.default));
parcelHelpers.export(exports, "LaptopMacTwoTone", ()=>(0, _laptopMacTwoToneDefault.default));
parcelHelpers.export(exports, "LaptopOutlined", ()=>(0, _laptopOutlinedDefault.default));
parcelHelpers.export(exports, "LaptopRounded", ()=>(0, _laptopRoundedDefault.default));
parcelHelpers.export(exports, "LaptopSharp", ()=>(0, _laptopSharpDefault.default));
parcelHelpers.export(exports, "LaptopTwoTone", ()=>(0, _laptopTwoToneDefault.default));
parcelHelpers.export(exports, "LaptopWindows", ()=>(0, _laptopWindowsDefault.default));
parcelHelpers.export(exports, "LaptopWindowsOutlined", ()=>(0, _laptopWindowsOutlinedDefault.default));
parcelHelpers.export(exports, "LaptopWindowsRounded", ()=>(0, _laptopWindowsRoundedDefault.default));
parcelHelpers.export(exports, "LaptopWindowsSharp", ()=>(0, _laptopWindowsSharpDefault.default));
parcelHelpers.export(exports, "LaptopWindowsTwoTone", ()=>(0, _laptopWindowsTwoToneDefault.default));
parcelHelpers.export(exports, "LastPage", ()=>(0, _lastPageDefault.default));
parcelHelpers.export(exports, "LastPageOutlined", ()=>(0, _lastPageOutlinedDefault.default));
parcelHelpers.export(exports, "LastPageRounded", ()=>(0, _lastPageRoundedDefault.default));
parcelHelpers.export(exports, "LastPageSharp", ()=>(0, _lastPageSharpDefault.default));
parcelHelpers.export(exports, "LastPageTwoTone", ()=>(0, _lastPageTwoToneDefault.default));
parcelHelpers.export(exports, "Launch", ()=>(0, _launchDefault.default));
parcelHelpers.export(exports, "LaunchOutlined", ()=>(0, _launchOutlinedDefault.default));
parcelHelpers.export(exports, "LaunchRounded", ()=>(0, _launchRoundedDefault.default));
parcelHelpers.export(exports, "LaunchSharp", ()=>(0, _launchSharpDefault.default));
parcelHelpers.export(exports, "LaunchTwoTone", ()=>(0, _launchTwoToneDefault.default));
parcelHelpers.export(exports, "Layers", ()=>(0, _layersDefault.default));
parcelHelpers.export(exports, "LayersClear", ()=>(0, _layersClearDefault.default));
parcelHelpers.export(exports, "LayersClearOutlined", ()=>(0, _layersClearOutlinedDefault.default));
parcelHelpers.export(exports, "LayersClearRounded", ()=>(0, _layersClearRoundedDefault.default));
parcelHelpers.export(exports, "LayersClearSharp", ()=>(0, _layersClearSharpDefault.default));
parcelHelpers.export(exports, "LayersClearTwoTone", ()=>(0, _layersClearTwoToneDefault.default));
parcelHelpers.export(exports, "LayersOutlined", ()=>(0, _layersOutlinedDefault.default));
parcelHelpers.export(exports, "LayersRounded", ()=>(0, _layersRoundedDefault.default));
parcelHelpers.export(exports, "LayersSharp", ()=>(0, _layersSharpDefault.default));
parcelHelpers.export(exports, "LayersTwoTone", ()=>(0, _layersTwoToneDefault.default));
parcelHelpers.export(exports, "Leaderboard", ()=>(0, _leaderboardDefault.default));
parcelHelpers.export(exports, "LeaderboardOutlined", ()=>(0, _leaderboardOutlinedDefault.default));
parcelHelpers.export(exports, "LeaderboardRounded", ()=>(0, _leaderboardRoundedDefault.default));
parcelHelpers.export(exports, "LeaderboardSharp", ()=>(0, _leaderboardSharpDefault.default));
parcelHelpers.export(exports, "LeaderboardTwoTone", ()=>(0, _leaderboardTwoToneDefault.default));
parcelHelpers.export(exports, "LeakAdd", ()=>(0, _leakAddDefault.default));
parcelHelpers.export(exports, "LeakAddOutlined", ()=>(0, _leakAddOutlinedDefault.default));
parcelHelpers.export(exports, "LeakAddRounded", ()=>(0, _leakAddRoundedDefault.default));
parcelHelpers.export(exports, "LeakAddSharp", ()=>(0, _leakAddSharpDefault.default));
parcelHelpers.export(exports, "LeakAddTwoTone", ()=>(0, _leakAddTwoToneDefault.default));
parcelHelpers.export(exports, "LeakRemove", ()=>(0, _leakRemoveDefault.default));
parcelHelpers.export(exports, "LeakRemoveOutlined", ()=>(0, _leakRemoveOutlinedDefault.default));
parcelHelpers.export(exports, "LeakRemoveRounded", ()=>(0, _leakRemoveRoundedDefault.default));
parcelHelpers.export(exports, "LeakRemoveSharp", ()=>(0, _leakRemoveSharpDefault.default));
parcelHelpers.export(exports, "LeakRemoveTwoTone", ()=>(0, _leakRemoveTwoToneDefault.default));
parcelHelpers.export(exports, "LegendToggle", ()=>(0, _legendToggleDefault.default));
parcelHelpers.export(exports, "LegendToggleOutlined", ()=>(0, _legendToggleOutlinedDefault.default));
parcelHelpers.export(exports, "LegendToggleRounded", ()=>(0, _legendToggleRoundedDefault.default));
parcelHelpers.export(exports, "LegendToggleSharp", ()=>(0, _legendToggleSharpDefault.default));
parcelHelpers.export(exports, "LegendToggleTwoTone", ()=>(0, _legendToggleTwoToneDefault.default));
parcelHelpers.export(exports, "Lens", ()=>(0, _lensDefault.default));
parcelHelpers.export(exports, "LensBlur", ()=>(0, _lensBlurDefault.default));
parcelHelpers.export(exports, "LensBlurOutlined", ()=>(0, _lensBlurOutlinedDefault.default));
parcelHelpers.export(exports, "LensBlurRounded", ()=>(0, _lensBlurRoundedDefault.default));
parcelHelpers.export(exports, "LensBlurSharp", ()=>(0, _lensBlurSharpDefault.default));
parcelHelpers.export(exports, "LensBlurTwoTone", ()=>(0, _lensBlurTwoToneDefault.default));
parcelHelpers.export(exports, "LensOutlined", ()=>(0, _lensOutlinedDefault.default));
parcelHelpers.export(exports, "LensRounded", ()=>(0, _lensRoundedDefault.default));
parcelHelpers.export(exports, "LensSharp", ()=>(0, _lensSharpDefault.default));
parcelHelpers.export(exports, "LensTwoTone", ()=>(0, _lensTwoToneDefault.default));
parcelHelpers.export(exports, "LibraryAdd", ()=>(0, _libraryAddDefault.default));
parcelHelpers.export(exports, "LibraryAddCheck", ()=>(0, _libraryAddCheckDefault.default));
parcelHelpers.export(exports, "LibraryAddCheckOutlined", ()=>(0, _libraryAddCheckOutlinedDefault.default));
parcelHelpers.export(exports, "LibraryAddCheckRounded", ()=>(0, _libraryAddCheckRoundedDefault.default));
parcelHelpers.export(exports, "LibraryAddCheckSharp", ()=>(0, _libraryAddCheckSharpDefault.default));
parcelHelpers.export(exports, "LibraryAddCheckTwoTone", ()=>(0, _libraryAddCheckTwoToneDefault.default));
parcelHelpers.export(exports, "LibraryAddOutlined", ()=>(0, _libraryAddOutlinedDefault.default));
parcelHelpers.export(exports, "LibraryAddRounded", ()=>(0, _libraryAddRoundedDefault.default));
parcelHelpers.export(exports, "LibraryAddSharp", ()=>(0, _libraryAddSharpDefault.default));
parcelHelpers.export(exports, "LibraryAddTwoTone", ()=>(0, _libraryAddTwoToneDefault.default));
parcelHelpers.export(exports, "LibraryBooks", ()=>(0, _libraryBooksDefault.default));
parcelHelpers.export(exports, "LibraryBooksOutlined", ()=>(0, _libraryBooksOutlinedDefault.default));
parcelHelpers.export(exports, "LibraryBooksRounded", ()=>(0, _libraryBooksRoundedDefault.default));
parcelHelpers.export(exports, "LibraryBooksSharp", ()=>(0, _libraryBooksSharpDefault.default));
parcelHelpers.export(exports, "LibraryBooksTwoTone", ()=>(0, _libraryBooksTwoToneDefault.default));
parcelHelpers.export(exports, "LibraryMusic", ()=>(0, _libraryMusicDefault.default));
parcelHelpers.export(exports, "LibraryMusicOutlined", ()=>(0, _libraryMusicOutlinedDefault.default));
parcelHelpers.export(exports, "LibraryMusicRounded", ()=>(0, _libraryMusicRoundedDefault.default));
parcelHelpers.export(exports, "LibraryMusicSharp", ()=>(0, _libraryMusicSharpDefault.default));
parcelHelpers.export(exports, "LibraryMusicTwoTone", ()=>(0, _libraryMusicTwoToneDefault.default));
parcelHelpers.export(exports, "Light", ()=>(0, _lightDefault.default));
parcelHelpers.export(exports, "LightMode", ()=>(0, _lightModeDefault.default));
parcelHelpers.export(exports, "LightModeOutlined", ()=>(0, _lightModeOutlinedDefault.default));
parcelHelpers.export(exports, "LightModeRounded", ()=>(0, _lightModeRoundedDefault.default));
parcelHelpers.export(exports, "LightModeSharp", ()=>(0, _lightModeSharpDefault.default));
parcelHelpers.export(exports, "LightModeTwoTone", ()=>(0, _lightModeTwoToneDefault.default));
parcelHelpers.export(exports, "LightOutlined", ()=>(0, _lightOutlinedDefault.default));
parcelHelpers.export(exports, "LightRounded", ()=>(0, _lightRoundedDefault.default));
parcelHelpers.export(exports, "LightSharp", ()=>(0, _lightSharpDefault.default));
parcelHelpers.export(exports, "LightTwoTone", ()=>(0, _lightTwoToneDefault.default));
parcelHelpers.export(exports, "Lightbulb", ()=>(0, _lightbulbDefault.default));
parcelHelpers.export(exports, "LightbulbCircle", ()=>(0, _lightbulbCircleDefault.default));
parcelHelpers.export(exports, "LightbulbCircleOutlined", ()=>(0, _lightbulbCircleOutlinedDefault.default));
parcelHelpers.export(exports, "LightbulbCircleRounded", ()=>(0, _lightbulbCircleRoundedDefault.default));
parcelHelpers.export(exports, "LightbulbCircleSharp", ()=>(0, _lightbulbCircleSharpDefault.default));
parcelHelpers.export(exports, "LightbulbCircleTwoTone", ()=>(0, _lightbulbCircleTwoToneDefault.default));
parcelHelpers.export(exports, "LightbulbOutlined", ()=>(0, _lightbulbOutlinedDefault.default));
parcelHelpers.export(exports, "LightbulbRounded", ()=>(0, _lightbulbRoundedDefault.default));
parcelHelpers.export(exports, "LightbulbSharp", ()=>(0, _lightbulbSharpDefault.default));
parcelHelpers.export(exports, "LightbulbTwoTone", ()=>(0, _lightbulbTwoToneDefault.default));
parcelHelpers.export(exports, "LineAxis", ()=>(0, _lineAxisDefault.default));
parcelHelpers.export(exports, "LineAxisOutlined", ()=>(0, _lineAxisOutlinedDefault.default));
parcelHelpers.export(exports, "LineAxisRounded", ()=>(0, _lineAxisRoundedDefault.default));
parcelHelpers.export(exports, "LineAxisSharp", ()=>(0, _lineAxisSharpDefault.default));
parcelHelpers.export(exports, "LineAxisTwoTone", ()=>(0, _lineAxisTwoToneDefault.default));
parcelHelpers.export(exports, "LineStyle", ()=>(0, _lineStyleDefault.default));
parcelHelpers.export(exports, "LineStyleOutlined", ()=>(0, _lineStyleOutlinedDefault.default));
parcelHelpers.export(exports, "LineStyleRounded", ()=>(0, _lineStyleRoundedDefault.default));
parcelHelpers.export(exports, "LineStyleSharp", ()=>(0, _lineStyleSharpDefault.default));
parcelHelpers.export(exports, "LineStyleTwoTone", ()=>(0, _lineStyleTwoToneDefault.default));
parcelHelpers.export(exports, "LineWeight", ()=>(0, _lineWeightDefault.default));
parcelHelpers.export(exports, "LineWeightOutlined", ()=>(0, _lineWeightOutlinedDefault.default));
parcelHelpers.export(exports, "LineWeightRounded", ()=>(0, _lineWeightRoundedDefault.default));
parcelHelpers.export(exports, "LineWeightSharp", ()=>(0, _lineWeightSharpDefault.default));
parcelHelpers.export(exports, "LineWeightTwoTone", ()=>(0, _lineWeightTwoToneDefault.default));
parcelHelpers.export(exports, "LinearScale", ()=>(0, _linearScaleDefault.default));
parcelHelpers.export(exports, "LinearScaleOutlined", ()=>(0, _linearScaleOutlinedDefault.default));
parcelHelpers.export(exports, "LinearScaleRounded", ()=>(0, _linearScaleRoundedDefault.default));
parcelHelpers.export(exports, "LinearScaleSharp", ()=>(0, _linearScaleSharpDefault.default));
parcelHelpers.export(exports, "LinearScaleTwoTone", ()=>(0, _linearScaleTwoToneDefault.default));
parcelHelpers.export(exports, "Link", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "LinkOff", ()=>(0, _linkOffDefault.default));
parcelHelpers.export(exports, "LinkOffOutlined", ()=>(0, _linkOffOutlinedDefault.default));
parcelHelpers.export(exports, "LinkOffRounded", ()=>(0, _linkOffRoundedDefault.default));
parcelHelpers.export(exports, "LinkOffSharp", ()=>(0, _linkOffSharpDefault.default));
parcelHelpers.export(exports, "LinkOffTwoTone", ()=>(0, _linkOffTwoToneDefault.default));
parcelHelpers.export(exports, "LinkOutlined", ()=>(0, _linkOutlinedDefault.default));
parcelHelpers.export(exports, "LinkRounded", ()=>(0, _linkRoundedDefault.default));
parcelHelpers.export(exports, "LinkSharp", ()=>(0, _linkSharpDefault.default));
parcelHelpers.export(exports, "LinkTwoTone", ()=>(0, _linkTwoToneDefault.default));
parcelHelpers.export(exports, "LinkedCamera", ()=>(0, _linkedCameraDefault.default));
parcelHelpers.export(exports, "LinkedCameraOutlined", ()=>(0, _linkedCameraOutlinedDefault.default));
parcelHelpers.export(exports, "LinkedCameraRounded", ()=>(0, _linkedCameraRoundedDefault.default));
parcelHelpers.export(exports, "LinkedCameraSharp", ()=>(0, _linkedCameraSharpDefault.default));
parcelHelpers.export(exports, "LinkedCameraTwoTone", ()=>(0, _linkedCameraTwoToneDefault.default));
parcelHelpers.export(exports, "LinkedIn", ()=>(0, _linkedInDefault.default));
parcelHelpers.export(exports, "Liquor", ()=>(0, _liquorDefault.default));
parcelHelpers.export(exports, "LiquorOutlined", ()=>(0, _liquorOutlinedDefault.default));
parcelHelpers.export(exports, "LiquorRounded", ()=>(0, _liquorRoundedDefault.default));
parcelHelpers.export(exports, "LiquorSharp", ()=>(0, _liquorSharpDefault.default));
parcelHelpers.export(exports, "LiquorTwoTone", ()=>(0, _liquorTwoToneDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListAlt", ()=>(0, _listAltDefault.default));
parcelHelpers.export(exports, "ListAltOutlined", ()=>(0, _listAltOutlinedDefault.default));
parcelHelpers.export(exports, "ListAltRounded", ()=>(0, _listAltRoundedDefault.default));
parcelHelpers.export(exports, "ListAltSharp", ()=>(0, _listAltSharpDefault.default));
parcelHelpers.export(exports, "ListAltTwoTone", ()=>(0, _listAltTwoToneDefault.default));
parcelHelpers.export(exports, "ListOutlined", ()=>(0, _listOutlinedDefault.default));
parcelHelpers.export(exports, "ListRounded", ()=>(0, _listRoundedDefault.default));
parcelHelpers.export(exports, "ListSharp", ()=>(0, _listSharpDefault.default));
parcelHelpers.export(exports, "ListTwoTone", ()=>(0, _listTwoToneDefault.default));
parcelHelpers.export(exports, "LiveHelp", ()=>(0, _liveHelpDefault.default));
parcelHelpers.export(exports, "LiveHelpOutlined", ()=>(0, _liveHelpOutlinedDefault.default));
parcelHelpers.export(exports, "LiveHelpRounded", ()=>(0, _liveHelpRoundedDefault.default));
parcelHelpers.export(exports, "LiveHelpSharp", ()=>(0, _liveHelpSharpDefault.default));
parcelHelpers.export(exports, "LiveHelpTwoTone", ()=>(0, _liveHelpTwoToneDefault.default));
parcelHelpers.export(exports, "LiveTv", ()=>(0, _liveTvDefault.default));
parcelHelpers.export(exports, "LiveTvOutlined", ()=>(0, _liveTvOutlinedDefault.default));
parcelHelpers.export(exports, "LiveTvRounded", ()=>(0, _liveTvRoundedDefault.default));
parcelHelpers.export(exports, "LiveTvSharp", ()=>(0, _liveTvSharpDefault.default));
parcelHelpers.export(exports, "LiveTvTwoTone", ()=>(0, _liveTvTwoToneDefault.default));
parcelHelpers.export(exports, "Living", ()=>(0, _livingDefault.default));
parcelHelpers.export(exports, "LivingOutlined", ()=>(0, _livingOutlinedDefault.default));
parcelHelpers.export(exports, "LivingRounded", ()=>(0, _livingRoundedDefault.default));
parcelHelpers.export(exports, "LivingSharp", ()=>(0, _livingSharpDefault.default));
parcelHelpers.export(exports, "LivingTwoTone", ()=>(0, _livingTwoToneDefault.default));
parcelHelpers.export(exports, "LocalActivity", ()=>(0, _localActivityDefault.default));
parcelHelpers.export(exports, "LocalActivityOutlined", ()=>(0, _localActivityOutlinedDefault.default));
parcelHelpers.export(exports, "LocalActivityRounded", ()=>(0, _localActivityRoundedDefault.default));
parcelHelpers.export(exports, "LocalActivitySharp", ()=>(0, _localActivitySharpDefault.default));
parcelHelpers.export(exports, "LocalActivityTwoTone", ()=>(0, _localActivityTwoToneDefault.default));
parcelHelpers.export(exports, "LocalAirport", ()=>(0, _localAirportDefault.default));
parcelHelpers.export(exports, "LocalAirportOutlined", ()=>(0, _localAirportOutlinedDefault.default));
parcelHelpers.export(exports, "LocalAirportRounded", ()=>(0, _localAirportRoundedDefault.default));
parcelHelpers.export(exports, "LocalAirportSharp", ()=>(0, _localAirportSharpDefault.default));
parcelHelpers.export(exports, "LocalAirportTwoTone", ()=>(0, _localAirportTwoToneDefault.default));
parcelHelpers.export(exports, "LocalAtm", ()=>(0, _localAtmDefault.default));
parcelHelpers.export(exports, "LocalAtmOutlined", ()=>(0, _localAtmOutlinedDefault.default));
parcelHelpers.export(exports, "LocalAtmRounded", ()=>(0, _localAtmRoundedDefault.default));
parcelHelpers.export(exports, "LocalAtmSharp", ()=>(0, _localAtmSharpDefault.default));
parcelHelpers.export(exports, "LocalAtmTwoTone", ()=>(0, _localAtmTwoToneDefault.default));
parcelHelpers.export(exports, "LocalBar", ()=>(0, _localBarDefault.default));
parcelHelpers.export(exports, "LocalBarOutlined", ()=>(0, _localBarOutlinedDefault.default));
parcelHelpers.export(exports, "LocalBarRounded", ()=>(0, _localBarRoundedDefault.default));
parcelHelpers.export(exports, "LocalBarSharp", ()=>(0, _localBarSharpDefault.default));
parcelHelpers.export(exports, "LocalBarTwoTone", ()=>(0, _localBarTwoToneDefault.default));
parcelHelpers.export(exports, "LocalCafe", ()=>(0, _localCafeDefault.default));
parcelHelpers.export(exports, "LocalCafeOutlined", ()=>(0, _localCafeOutlinedDefault.default));
parcelHelpers.export(exports, "LocalCafeRounded", ()=>(0, _localCafeRoundedDefault.default));
parcelHelpers.export(exports, "LocalCafeSharp", ()=>(0, _localCafeSharpDefault.default));
parcelHelpers.export(exports, "LocalCafeTwoTone", ()=>(0, _localCafeTwoToneDefault.default));
parcelHelpers.export(exports, "LocalCarWash", ()=>(0, _localCarWashDefault.default));
parcelHelpers.export(exports, "LocalCarWashOutlined", ()=>(0, _localCarWashOutlinedDefault.default));
parcelHelpers.export(exports, "LocalCarWashRounded", ()=>(0, _localCarWashRoundedDefault.default));
parcelHelpers.export(exports, "LocalCarWashSharp", ()=>(0, _localCarWashSharpDefault.default));
parcelHelpers.export(exports, "LocalCarWashTwoTone", ()=>(0, _localCarWashTwoToneDefault.default));
parcelHelpers.export(exports, "LocalConvenienceStore", ()=>(0, _localConvenienceStoreDefault.default));
parcelHelpers.export(exports, "LocalConvenienceStoreOutlined", ()=>(0, _localConvenienceStoreOutlinedDefault.default));
parcelHelpers.export(exports, "LocalConvenienceStoreRounded", ()=>(0, _localConvenienceStoreRoundedDefault.default));
parcelHelpers.export(exports, "LocalConvenienceStoreSharp", ()=>(0, _localConvenienceStoreSharpDefault.default));
parcelHelpers.export(exports, "LocalConvenienceStoreTwoTone", ()=>(0, _localConvenienceStoreTwoToneDefault.default));
parcelHelpers.export(exports, "LocalDining", ()=>(0, _localDiningDefault.default));
parcelHelpers.export(exports, "LocalDiningOutlined", ()=>(0, _localDiningOutlinedDefault.default));
parcelHelpers.export(exports, "LocalDiningRounded", ()=>(0, _localDiningRoundedDefault.default));
parcelHelpers.export(exports, "LocalDiningSharp", ()=>(0, _localDiningSharpDefault.default));
parcelHelpers.export(exports, "LocalDiningTwoTone", ()=>(0, _localDiningTwoToneDefault.default));
parcelHelpers.export(exports, "LocalDrink", ()=>(0, _localDrinkDefault.default));
parcelHelpers.export(exports, "LocalDrinkOutlined", ()=>(0, _localDrinkOutlinedDefault.default));
parcelHelpers.export(exports, "LocalDrinkRounded", ()=>(0, _localDrinkRoundedDefault.default));
parcelHelpers.export(exports, "LocalDrinkSharp", ()=>(0, _localDrinkSharpDefault.default));
parcelHelpers.export(exports, "LocalDrinkTwoTone", ()=>(0, _localDrinkTwoToneDefault.default));
parcelHelpers.export(exports, "LocalFireDepartment", ()=>(0, _localFireDepartmentDefault.default));
parcelHelpers.export(exports, "LocalFireDepartmentOutlined", ()=>(0, _localFireDepartmentOutlinedDefault.default));
parcelHelpers.export(exports, "LocalFireDepartmentRounded", ()=>(0, _localFireDepartmentRoundedDefault.default));
parcelHelpers.export(exports, "LocalFireDepartmentSharp", ()=>(0, _localFireDepartmentSharpDefault.default));
parcelHelpers.export(exports, "LocalFireDepartmentTwoTone", ()=>(0, _localFireDepartmentTwoToneDefault.default));
parcelHelpers.export(exports, "LocalFlorist", ()=>(0, _localFloristDefault.default));
parcelHelpers.export(exports, "LocalFloristOutlined", ()=>(0, _localFloristOutlinedDefault.default));
parcelHelpers.export(exports, "LocalFloristRounded", ()=>(0, _localFloristRoundedDefault.default));
parcelHelpers.export(exports, "LocalFloristSharp", ()=>(0, _localFloristSharpDefault.default));
parcelHelpers.export(exports, "LocalFloristTwoTone", ()=>(0, _localFloristTwoToneDefault.default));
parcelHelpers.export(exports, "LocalGasStation", ()=>(0, _localGasStationDefault.default));
parcelHelpers.export(exports, "LocalGasStationOutlined", ()=>(0, _localGasStationOutlinedDefault.default));
parcelHelpers.export(exports, "LocalGasStationRounded", ()=>(0, _localGasStationRoundedDefault.default));
parcelHelpers.export(exports, "LocalGasStationSharp", ()=>(0, _localGasStationSharpDefault.default));
parcelHelpers.export(exports, "LocalGasStationTwoTone", ()=>(0, _localGasStationTwoToneDefault.default));
parcelHelpers.export(exports, "LocalGroceryStore", ()=>(0, _localGroceryStoreDefault.default));
parcelHelpers.export(exports, "LocalGroceryStoreOutlined", ()=>(0, _localGroceryStoreOutlinedDefault.default));
parcelHelpers.export(exports, "LocalGroceryStoreRounded", ()=>(0, _localGroceryStoreRoundedDefault.default));
parcelHelpers.export(exports, "LocalGroceryStoreSharp", ()=>(0, _localGroceryStoreSharpDefault.default));
parcelHelpers.export(exports, "LocalGroceryStoreTwoTone", ()=>(0, _localGroceryStoreTwoToneDefault.default));
parcelHelpers.export(exports, "LocalHospital", ()=>(0, _localHospitalDefault.default));
parcelHelpers.export(exports, "LocalHospitalOutlined", ()=>(0, _localHospitalOutlinedDefault.default));
parcelHelpers.export(exports, "LocalHospitalRounded", ()=>(0, _localHospitalRoundedDefault.default));
parcelHelpers.export(exports, "LocalHospitalSharp", ()=>(0, _localHospitalSharpDefault.default));
parcelHelpers.export(exports, "LocalHospitalTwoTone", ()=>(0, _localHospitalTwoToneDefault.default));
parcelHelpers.export(exports, "LocalHotel", ()=>(0, _localHotelDefault.default));
parcelHelpers.export(exports, "LocalHotelOutlined", ()=>(0, _localHotelOutlinedDefault.default));
parcelHelpers.export(exports, "LocalHotelRounded", ()=>(0, _localHotelRoundedDefault.default));
parcelHelpers.export(exports, "LocalHotelSharp", ()=>(0, _localHotelSharpDefault.default));
parcelHelpers.export(exports, "LocalHotelTwoTone", ()=>(0, _localHotelTwoToneDefault.default));
parcelHelpers.export(exports, "LocalLaundryService", ()=>(0, _localLaundryServiceDefault.default));
parcelHelpers.export(exports, "LocalLaundryServiceOutlined", ()=>(0, _localLaundryServiceOutlinedDefault.default));
parcelHelpers.export(exports, "LocalLaundryServiceRounded", ()=>(0, _localLaundryServiceRoundedDefault.default));
parcelHelpers.export(exports, "LocalLaundryServiceSharp", ()=>(0, _localLaundryServiceSharpDefault.default));
parcelHelpers.export(exports, "LocalLaundryServiceTwoTone", ()=>(0, _localLaundryServiceTwoToneDefault.default));
parcelHelpers.export(exports, "LocalLibrary", ()=>(0, _localLibraryDefault.default));
parcelHelpers.export(exports, "LocalLibraryOutlined", ()=>(0, _localLibraryOutlinedDefault.default));
parcelHelpers.export(exports, "LocalLibraryRounded", ()=>(0, _localLibraryRoundedDefault.default));
parcelHelpers.export(exports, "LocalLibrarySharp", ()=>(0, _localLibrarySharpDefault.default));
parcelHelpers.export(exports, "LocalLibraryTwoTone", ()=>(0, _localLibraryTwoToneDefault.default));
parcelHelpers.export(exports, "LocalMall", ()=>(0, _localMallDefault.default));
parcelHelpers.export(exports, "LocalMallOutlined", ()=>(0, _localMallOutlinedDefault.default));
parcelHelpers.export(exports, "LocalMallRounded", ()=>(0, _localMallRoundedDefault.default));
parcelHelpers.export(exports, "LocalMallSharp", ()=>(0, _localMallSharpDefault.default));
parcelHelpers.export(exports, "LocalMallTwoTone", ()=>(0, _localMallTwoToneDefault.default));
parcelHelpers.export(exports, "LocalMovies", ()=>(0, _localMoviesDefault.default));
parcelHelpers.export(exports, "LocalMoviesOutlined", ()=>(0, _localMoviesOutlinedDefault.default));
parcelHelpers.export(exports, "LocalMoviesRounded", ()=>(0, _localMoviesRoundedDefault.default));
parcelHelpers.export(exports, "LocalMoviesSharp", ()=>(0, _localMoviesSharpDefault.default));
parcelHelpers.export(exports, "LocalMoviesTwoTone", ()=>(0, _localMoviesTwoToneDefault.default));
parcelHelpers.export(exports, "LocalOffer", ()=>(0, _localOfferDefault.default));
parcelHelpers.export(exports, "LocalOfferOutlined", ()=>(0, _localOfferOutlinedDefault.default));
parcelHelpers.export(exports, "LocalOfferRounded", ()=>(0, _localOfferRoundedDefault.default));
parcelHelpers.export(exports, "LocalOfferSharp", ()=>(0, _localOfferSharpDefault.default));
parcelHelpers.export(exports, "LocalOfferTwoTone", ()=>(0, _localOfferTwoToneDefault.default));
parcelHelpers.export(exports, "LocalParking", ()=>(0, _localParkingDefault.default));
parcelHelpers.export(exports, "LocalParkingOutlined", ()=>(0, _localParkingOutlinedDefault.default));
parcelHelpers.export(exports, "LocalParkingRounded", ()=>(0, _localParkingRoundedDefault.default));
parcelHelpers.export(exports, "LocalParkingSharp", ()=>(0, _localParkingSharpDefault.default));
parcelHelpers.export(exports, "LocalParkingTwoTone", ()=>(0, _localParkingTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPharmacy", ()=>(0, _localPharmacyDefault.default));
parcelHelpers.export(exports, "LocalPharmacyOutlined", ()=>(0, _localPharmacyOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPharmacyRounded", ()=>(0, _localPharmacyRoundedDefault.default));
parcelHelpers.export(exports, "LocalPharmacySharp", ()=>(0, _localPharmacySharpDefault.default));
parcelHelpers.export(exports, "LocalPharmacyTwoTone", ()=>(0, _localPharmacyTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPhone", ()=>(0, _localPhoneDefault.default));
parcelHelpers.export(exports, "LocalPhoneOutlined", ()=>(0, _localPhoneOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPhoneRounded", ()=>(0, _localPhoneRoundedDefault.default));
parcelHelpers.export(exports, "LocalPhoneSharp", ()=>(0, _localPhoneSharpDefault.default));
parcelHelpers.export(exports, "LocalPhoneTwoTone", ()=>(0, _localPhoneTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPizza", ()=>(0, _localPizzaDefault.default));
parcelHelpers.export(exports, "LocalPizzaOutlined", ()=>(0, _localPizzaOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPizzaRounded", ()=>(0, _localPizzaRoundedDefault.default));
parcelHelpers.export(exports, "LocalPizzaSharp", ()=>(0, _localPizzaSharpDefault.default));
parcelHelpers.export(exports, "LocalPizzaTwoTone", ()=>(0, _localPizzaTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPlay", ()=>(0, _localPlayDefault.default));
parcelHelpers.export(exports, "LocalPlayOutlined", ()=>(0, _localPlayOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPlayRounded", ()=>(0, _localPlayRoundedDefault.default));
parcelHelpers.export(exports, "LocalPlaySharp", ()=>(0, _localPlaySharpDefault.default));
parcelHelpers.export(exports, "LocalPlayTwoTone", ()=>(0, _localPlayTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPolice", ()=>(0, _localPoliceDefault.default));
parcelHelpers.export(exports, "LocalPoliceOutlined", ()=>(0, _localPoliceOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPoliceRounded", ()=>(0, _localPoliceRoundedDefault.default));
parcelHelpers.export(exports, "LocalPoliceSharp", ()=>(0, _localPoliceSharpDefault.default));
parcelHelpers.export(exports, "LocalPoliceTwoTone", ()=>(0, _localPoliceTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPostOffice", ()=>(0, _localPostOfficeDefault.default));
parcelHelpers.export(exports, "LocalPostOfficeOutlined", ()=>(0, _localPostOfficeOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPostOfficeRounded", ()=>(0, _localPostOfficeRoundedDefault.default));
parcelHelpers.export(exports, "LocalPostOfficeSharp", ()=>(0, _localPostOfficeSharpDefault.default));
parcelHelpers.export(exports, "LocalPostOfficeTwoTone", ()=>(0, _localPostOfficeTwoToneDefault.default));
parcelHelpers.export(exports, "LocalPrintshop", ()=>(0, _localPrintshopDefault.default));
parcelHelpers.export(exports, "LocalPrintshopOutlined", ()=>(0, _localPrintshopOutlinedDefault.default));
parcelHelpers.export(exports, "LocalPrintshopRounded", ()=>(0, _localPrintshopRoundedDefault.default));
parcelHelpers.export(exports, "LocalPrintshopSharp", ()=>(0, _localPrintshopSharpDefault.default));
parcelHelpers.export(exports, "LocalPrintshopTwoTone", ()=>(0, _localPrintshopTwoToneDefault.default));
parcelHelpers.export(exports, "LocalSee", ()=>(0, _localSeeDefault.default));
parcelHelpers.export(exports, "LocalSeeOutlined", ()=>(0, _localSeeOutlinedDefault.default));
parcelHelpers.export(exports, "LocalSeeRounded", ()=>(0, _localSeeRoundedDefault.default));
parcelHelpers.export(exports, "LocalSeeSharp", ()=>(0, _localSeeSharpDefault.default));
parcelHelpers.export(exports, "LocalSeeTwoTone", ()=>(0, _localSeeTwoToneDefault.default));
parcelHelpers.export(exports, "LocalShipping", ()=>(0, _localShippingDefault.default));
parcelHelpers.export(exports, "LocalShippingOutlined", ()=>(0, _localShippingOutlinedDefault.default));
parcelHelpers.export(exports, "LocalShippingRounded", ()=>(0, _localShippingRoundedDefault.default));
parcelHelpers.export(exports, "LocalShippingSharp", ()=>(0, _localShippingSharpDefault.default));
parcelHelpers.export(exports, "LocalShippingTwoTone", ()=>(0, _localShippingTwoToneDefault.default));
parcelHelpers.export(exports, "LocalTaxi", ()=>(0, _localTaxiDefault.default));
parcelHelpers.export(exports, "LocalTaxiOutlined", ()=>(0, _localTaxiOutlinedDefault.default));
parcelHelpers.export(exports, "LocalTaxiRounded", ()=>(0, _localTaxiRoundedDefault.default));
parcelHelpers.export(exports, "LocalTaxiSharp", ()=>(0, _localTaxiSharpDefault.default));
parcelHelpers.export(exports, "LocalTaxiTwoTone", ()=>(0, _localTaxiTwoToneDefault.default));
parcelHelpers.export(exports, "LocationCity", ()=>(0, _locationCityDefault.default));
parcelHelpers.export(exports, "LocationCityOutlined", ()=>(0, _locationCityOutlinedDefault.default));
parcelHelpers.export(exports, "LocationCityRounded", ()=>(0, _locationCityRoundedDefault.default));
parcelHelpers.export(exports, "LocationCitySharp", ()=>(0, _locationCitySharpDefault.default));
parcelHelpers.export(exports, "LocationCityTwoTone", ()=>(0, _locationCityTwoToneDefault.default));
parcelHelpers.export(exports, "LocationDisabled", ()=>(0, _locationDisabledDefault.default));
parcelHelpers.export(exports, "LocationDisabledOutlined", ()=>(0, _locationDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "LocationDisabledRounded", ()=>(0, _locationDisabledRoundedDefault.default));
parcelHelpers.export(exports, "LocationDisabledSharp", ()=>(0, _locationDisabledSharpDefault.default));
parcelHelpers.export(exports, "LocationDisabledTwoTone", ()=>(0, _locationDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "LocationOff", ()=>(0, _locationOffDefault.default));
parcelHelpers.export(exports, "LocationOffOutlined", ()=>(0, _locationOffOutlinedDefault.default));
parcelHelpers.export(exports, "LocationOffRounded", ()=>(0, _locationOffRoundedDefault.default));
parcelHelpers.export(exports, "LocationOffSharp", ()=>(0, _locationOffSharpDefault.default));
parcelHelpers.export(exports, "LocationOffTwoTone", ()=>(0, _locationOffTwoToneDefault.default));
parcelHelpers.export(exports, "LocationOn", ()=>(0, _locationOnDefault.default));
parcelHelpers.export(exports, "LocationOnOutlined", ()=>(0, _locationOnOutlinedDefault.default));
parcelHelpers.export(exports, "LocationOnRounded", ()=>(0, _locationOnRoundedDefault.default));
parcelHelpers.export(exports, "LocationOnSharp", ()=>(0, _locationOnSharpDefault.default));
parcelHelpers.export(exports, "LocationOnTwoTone", ()=>(0, _locationOnTwoToneDefault.default));
parcelHelpers.export(exports, "LocationSearching", ()=>(0, _locationSearchingDefault.default));
parcelHelpers.export(exports, "LocationSearchingOutlined", ()=>(0, _locationSearchingOutlinedDefault.default));
parcelHelpers.export(exports, "LocationSearchingRounded", ()=>(0, _locationSearchingRoundedDefault.default));
parcelHelpers.export(exports, "LocationSearchingSharp", ()=>(0, _locationSearchingSharpDefault.default));
parcelHelpers.export(exports, "LocationSearchingTwoTone", ()=>(0, _locationSearchingTwoToneDefault.default));
parcelHelpers.export(exports, "Lock", ()=>(0, _lockDefault.default));
parcelHelpers.export(exports, "LockClock", ()=>(0, _lockClockDefault.default));
parcelHelpers.export(exports, "LockClockOutlined", ()=>(0, _lockClockOutlinedDefault.default));
parcelHelpers.export(exports, "LockClockRounded", ()=>(0, _lockClockRoundedDefault.default));
parcelHelpers.export(exports, "LockClockSharp", ()=>(0, _lockClockSharpDefault.default));
parcelHelpers.export(exports, "LockClockTwoTone", ()=>(0, _lockClockTwoToneDefault.default));
parcelHelpers.export(exports, "LockOpen", ()=>(0, _lockOpenDefault.default));
parcelHelpers.export(exports, "LockOpenOutlined", ()=>(0, _lockOpenOutlinedDefault.default));
parcelHelpers.export(exports, "LockOpenRounded", ()=>(0, _lockOpenRoundedDefault.default));
parcelHelpers.export(exports, "LockOpenSharp", ()=>(0, _lockOpenSharpDefault.default));
parcelHelpers.export(exports, "LockOpenTwoTone", ()=>(0, _lockOpenTwoToneDefault.default));
parcelHelpers.export(exports, "LockOutlined", ()=>(0, _lockOutlinedDefault.default));
parcelHelpers.export(exports, "LockPerson", ()=>(0, _lockPersonDefault.default));
parcelHelpers.export(exports, "LockPersonOutlined", ()=>(0, _lockPersonOutlinedDefault.default));
parcelHelpers.export(exports, "LockPersonRounded", ()=>(0, _lockPersonRoundedDefault.default));
parcelHelpers.export(exports, "LockPersonSharp", ()=>(0, _lockPersonSharpDefault.default));
parcelHelpers.export(exports, "LockPersonTwoTone", ()=>(0, _lockPersonTwoToneDefault.default));
parcelHelpers.export(exports, "LockReset", ()=>(0, _lockResetDefault.default));
parcelHelpers.export(exports, "LockResetOutlined", ()=>(0, _lockResetOutlinedDefault.default));
parcelHelpers.export(exports, "LockResetRounded", ()=>(0, _lockResetRoundedDefault.default));
parcelHelpers.export(exports, "LockResetSharp", ()=>(0, _lockResetSharpDefault.default));
parcelHelpers.export(exports, "LockResetTwoTone", ()=>(0, _lockResetTwoToneDefault.default));
parcelHelpers.export(exports, "LockRounded", ()=>(0, _lockRoundedDefault.default));
parcelHelpers.export(exports, "LockSharp", ()=>(0, _lockSharpDefault.default));
parcelHelpers.export(exports, "LockTwoTone", ()=>(0, _lockTwoToneDefault.default));
parcelHelpers.export(exports, "Login", ()=>(0, _loginDefault.default));
parcelHelpers.export(exports, "LoginOutlined", ()=>(0, _loginOutlinedDefault.default));
parcelHelpers.export(exports, "LoginRounded", ()=>(0, _loginRoundedDefault.default));
parcelHelpers.export(exports, "LoginSharp", ()=>(0, _loginSharpDefault.default));
parcelHelpers.export(exports, "LoginTwoTone", ()=>(0, _loginTwoToneDefault.default));
parcelHelpers.export(exports, "LogoDev", ()=>(0, _logoDevDefault.default));
parcelHelpers.export(exports, "LogoDevOutlined", ()=>(0, _logoDevOutlinedDefault.default));
parcelHelpers.export(exports, "LogoDevRounded", ()=>(0, _logoDevRoundedDefault.default));
parcelHelpers.export(exports, "LogoDevSharp", ()=>(0, _logoDevSharpDefault.default));
parcelHelpers.export(exports, "LogoDevTwoTone", ()=>(0, _logoDevTwoToneDefault.default));
parcelHelpers.export(exports, "Logout", ()=>(0, _logoutDefault.default));
parcelHelpers.export(exports, "LogoutOutlined", ()=>(0, _logoutOutlinedDefault.default));
parcelHelpers.export(exports, "LogoutRounded", ()=>(0, _logoutRoundedDefault.default));
parcelHelpers.export(exports, "LogoutSharp", ()=>(0, _logoutSharpDefault.default));
parcelHelpers.export(exports, "LogoutTwoTone", ()=>(0, _logoutTwoToneDefault.default));
parcelHelpers.export(exports, "Looks", ()=>(0, _looksDefault.default));
parcelHelpers.export(exports, "Looks3", ()=>(0, _looks3Default.default));
parcelHelpers.export(exports, "Looks3Outlined", ()=>(0, _looks3OutlinedDefault.default));
parcelHelpers.export(exports, "Looks3Rounded", ()=>(0, _looks3RoundedDefault.default));
parcelHelpers.export(exports, "Looks3Sharp", ()=>(0, _looks3SharpDefault.default));
parcelHelpers.export(exports, "Looks3TwoTone", ()=>(0, _looks3TwoToneDefault.default));
parcelHelpers.export(exports, "Looks4", ()=>(0, _looks4Default.default));
parcelHelpers.export(exports, "Looks4Outlined", ()=>(0, _looks4OutlinedDefault.default));
parcelHelpers.export(exports, "Looks4Rounded", ()=>(0, _looks4RoundedDefault.default));
parcelHelpers.export(exports, "Looks4Sharp", ()=>(0, _looks4SharpDefault.default));
parcelHelpers.export(exports, "Looks4TwoTone", ()=>(0, _looks4TwoToneDefault.default));
parcelHelpers.export(exports, "Looks5", ()=>(0, _looks5Default.default));
parcelHelpers.export(exports, "Looks5Outlined", ()=>(0, _looks5OutlinedDefault.default));
parcelHelpers.export(exports, "Looks5Rounded", ()=>(0, _looks5RoundedDefault.default));
parcelHelpers.export(exports, "Looks5Sharp", ()=>(0, _looks5SharpDefault.default));
parcelHelpers.export(exports, "Looks5TwoTone", ()=>(0, _looks5TwoToneDefault.default));
parcelHelpers.export(exports, "Looks6", ()=>(0, _looks6Default.default));
parcelHelpers.export(exports, "Looks6Outlined", ()=>(0, _looks6OutlinedDefault.default));
parcelHelpers.export(exports, "Looks6Rounded", ()=>(0, _looks6RoundedDefault.default));
parcelHelpers.export(exports, "Looks6Sharp", ()=>(0, _looks6SharpDefault.default));
parcelHelpers.export(exports, "Looks6TwoTone", ()=>(0, _looks6TwoToneDefault.default));
parcelHelpers.export(exports, "LooksOne", ()=>(0, _looksOneDefault.default));
parcelHelpers.export(exports, "LooksOneOutlined", ()=>(0, _looksOneOutlinedDefault.default));
parcelHelpers.export(exports, "LooksOneRounded", ()=>(0, _looksOneRoundedDefault.default));
parcelHelpers.export(exports, "LooksOneSharp", ()=>(0, _looksOneSharpDefault.default));
parcelHelpers.export(exports, "LooksOneTwoTone", ()=>(0, _looksOneTwoToneDefault.default));
parcelHelpers.export(exports, "LooksOutlined", ()=>(0, _looksOutlinedDefault.default));
parcelHelpers.export(exports, "LooksRounded", ()=>(0, _looksRoundedDefault.default));
parcelHelpers.export(exports, "LooksSharp", ()=>(0, _looksSharpDefault.default));
parcelHelpers.export(exports, "LooksTwo", ()=>(0, _looksTwoDefault.default));
parcelHelpers.export(exports, "LooksTwoOutlined", ()=>(0, _looksTwoOutlinedDefault.default));
parcelHelpers.export(exports, "LooksTwoRounded", ()=>(0, _looksTwoRoundedDefault.default));
parcelHelpers.export(exports, "LooksTwoSharp", ()=>(0, _looksTwoSharpDefault.default));
parcelHelpers.export(exports, "LooksTwoTone", ()=>(0, _looksTwoToneDefault.default));
parcelHelpers.export(exports, "LooksTwoTwoTone", ()=>(0, _looksTwoTwoToneDefault.default));
parcelHelpers.export(exports, "Loop", ()=>(0, _loopDefault.default));
parcelHelpers.export(exports, "LoopOutlined", ()=>(0, _loopOutlinedDefault.default));
parcelHelpers.export(exports, "LoopRounded", ()=>(0, _loopRoundedDefault.default));
parcelHelpers.export(exports, "LoopSharp", ()=>(0, _loopSharpDefault.default));
parcelHelpers.export(exports, "LoopTwoTone", ()=>(0, _loopTwoToneDefault.default));
parcelHelpers.export(exports, "Loupe", ()=>(0, _loupeDefault.default));
parcelHelpers.export(exports, "LoupeOutlined", ()=>(0, _loupeOutlinedDefault.default));
parcelHelpers.export(exports, "LoupeRounded", ()=>(0, _loupeRoundedDefault.default));
parcelHelpers.export(exports, "LoupeSharp", ()=>(0, _loupeSharpDefault.default));
parcelHelpers.export(exports, "LoupeTwoTone", ()=>(0, _loupeTwoToneDefault.default));
parcelHelpers.export(exports, "LowPriority", ()=>(0, _lowPriorityDefault.default));
parcelHelpers.export(exports, "LowPriorityOutlined", ()=>(0, _lowPriorityOutlinedDefault.default));
parcelHelpers.export(exports, "LowPriorityRounded", ()=>(0, _lowPriorityRoundedDefault.default));
parcelHelpers.export(exports, "LowPrioritySharp", ()=>(0, _lowPrioritySharpDefault.default));
parcelHelpers.export(exports, "LowPriorityTwoTone", ()=>(0, _lowPriorityTwoToneDefault.default));
parcelHelpers.export(exports, "Loyalty", ()=>(0, _loyaltyDefault.default));
parcelHelpers.export(exports, "LoyaltyOutlined", ()=>(0, _loyaltyOutlinedDefault.default));
parcelHelpers.export(exports, "LoyaltyRounded", ()=>(0, _loyaltyRoundedDefault.default));
parcelHelpers.export(exports, "LoyaltySharp", ()=>(0, _loyaltySharpDefault.default));
parcelHelpers.export(exports, "LoyaltyTwoTone", ()=>(0, _loyaltyTwoToneDefault.default));
parcelHelpers.export(exports, "LteMobiledata", ()=>(0, _lteMobiledataDefault.default));
parcelHelpers.export(exports, "LteMobiledataOutlined", ()=>(0, _lteMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "LteMobiledataRounded", ()=>(0, _lteMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "LteMobiledataSharp", ()=>(0, _lteMobiledataSharpDefault.default));
parcelHelpers.export(exports, "LteMobiledataTwoTone", ()=>(0, _lteMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "LtePlusMobiledata", ()=>(0, _ltePlusMobiledataDefault.default));
parcelHelpers.export(exports, "LtePlusMobiledataOutlined", ()=>(0, _ltePlusMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "LtePlusMobiledataRounded", ()=>(0, _ltePlusMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "LtePlusMobiledataSharp", ()=>(0, _ltePlusMobiledataSharpDefault.default));
parcelHelpers.export(exports, "LtePlusMobiledataTwoTone", ()=>(0, _ltePlusMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "Luggage", ()=>(0, _luggageDefault.default));
parcelHelpers.export(exports, "LuggageOutlined", ()=>(0, _luggageOutlinedDefault.default));
parcelHelpers.export(exports, "LuggageRounded", ()=>(0, _luggageRoundedDefault.default));
parcelHelpers.export(exports, "LuggageSharp", ()=>(0, _luggageSharpDefault.default));
parcelHelpers.export(exports, "LuggageTwoTone", ()=>(0, _luggageTwoToneDefault.default));
parcelHelpers.export(exports, "LunchDining", ()=>(0, _lunchDiningDefault.default));
parcelHelpers.export(exports, "LunchDiningOutlined", ()=>(0, _lunchDiningOutlinedDefault.default));
parcelHelpers.export(exports, "LunchDiningRounded", ()=>(0, _lunchDiningRoundedDefault.default));
parcelHelpers.export(exports, "LunchDiningSharp", ()=>(0, _lunchDiningSharpDefault.default));
parcelHelpers.export(exports, "LunchDiningTwoTone", ()=>(0, _lunchDiningTwoToneDefault.default));
parcelHelpers.export(exports, "Lyrics", ()=>(0, _lyricsDefault.default));
parcelHelpers.export(exports, "LyricsOutlined", ()=>(0, _lyricsOutlinedDefault.default));
parcelHelpers.export(exports, "LyricsRounded", ()=>(0, _lyricsRoundedDefault.default));
parcelHelpers.export(exports, "LyricsSharp", ()=>(0, _lyricsSharpDefault.default));
parcelHelpers.export(exports, "LyricsTwoTone", ()=>(0, _lyricsTwoToneDefault.default));
parcelHelpers.export(exports, "MacroOff", ()=>(0, _macroOffDefault.default));
parcelHelpers.export(exports, "MacroOffOutlined", ()=>(0, _macroOffOutlinedDefault.default));
parcelHelpers.export(exports, "MacroOffRounded", ()=>(0, _macroOffRoundedDefault.default));
parcelHelpers.export(exports, "MacroOffSharp", ()=>(0, _macroOffSharpDefault.default));
parcelHelpers.export(exports, "MacroOffTwoTone", ()=>(0, _macroOffTwoToneDefault.default));
parcelHelpers.export(exports, "Mail", ()=>(0, _mailDefault.default));
parcelHelpers.export(exports, "MailLock", ()=>(0, _mailLockDefault.default));
parcelHelpers.export(exports, "MailLockOutlined", ()=>(0, _mailLockOutlinedDefault.default));
parcelHelpers.export(exports, "MailLockRounded", ()=>(0, _mailLockRoundedDefault.default));
parcelHelpers.export(exports, "MailLockSharp", ()=>(0, _mailLockSharpDefault.default));
parcelHelpers.export(exports, "MailLockTwoTone", ()=>(0, _mailLockTwoToneDefault.default));
parcelHelpers.export(exports, "MailOutline", ()=>(0, _mailOutlineDefault.default));
parcelHelpers.export(exports, "MailOutlineOutlined", ()=>(0, _mailOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "MailOutlineRounded", ()=>(0, _mailOutlineRoundedDefault.default));
parcelHelpers.export(exports, "MailOutlineSharp", ()=>(0, _mailOutlineSharpDefault.default));
parcelHelpers.export(exports, "MailOutlineTwoTone", ()=>(0, _mailOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "MailOutlined", ()=>(0, _mailOutlinedDefault.default));
parcelHelpers.export(exports, "MailRounded", ()=>(0, _mailRoundedDefault.default));
parcelHelpers.export(exports, "MailSharp", ()=>(0, _mailSharpDefault.default));
parcelHelpers.export(exports, "MailTwoTone", ()=>(0, _mailTwoToneDefault.default));
parcelHelpers.export(exports, "Male", ()=>(0, _maleDefault.default));
parcelHelpers.export(exports, "MaleOutlined", ()=>(0, _maleOutlinedDefault.default));
parcelHelpers.export(exports, "MaleRounded", ()=>(0, _maleRoundedDefault.default));
parcelHelpers.export(exports, "MaleSharp", ()=>(0, _maleSharpDefault.default));
parcelHelpers.export(exports, "MaleTwoTone", ()=>(0, _maleTwoToneDefault.default));
parcelHelpers.export(exports, "Man", ()=>(0, _manDefault.default));
parcelHelpers.export(exports, "Man2", ()=>(0, _man2Default.default));
parcelHelpers.export(exports, "Man2Outlined", ()=>(0, _man2OutlinedDefault.default));
parcelHelpers.export(exports, "Man2Rounded", ()=>(0, _man2RoundedDefault.default));
parcelHelpers.export(exports, "Man2Sharp", ()=>(0, _man2SharpDefault.default));
parcelHelpers.export(exports, "Man2TwoTone", ()=>(0, _man2TwoToneDefault.default));
parcelHelpers.export(exports, "Man3", ()=>(0, _man3Default.default));
parcelHelpers.export(exports, "Man3Outlined", ()=>(0, _man3OutlinedDefault.default));
parcelHelpers.export(exports, "Man3Rounded", ()=>(0, _man3RoundedDefault.default));
parcelHelpers.export(exports, "Man3Sharp", ()=>(0, _man3SharpDefault.default));
parcelHelpers.export(exports, "Man3TwoTone", ()=>(0, _man3TwoToneDefault.default));
parcelHelpers.export(exports, "Man4", ()=>(0, _man4Default.default));
parcelHelpers.export(exports, "Man4Outlined", ()=>(0, _man4OutlinedDefault.default));
parcelHelpers.export(exports, "Man4Rounded", ()=>(0, _man4RoundedDefault.default));
parcelHelpers.export(exports, "Man4Sharp", ()=>(0, _man4SharpDefault.default));
parcelHelpers.export(exports, "Man4TwoTone", ()=>(0, _man4TwoToneDefault.default));
parcelHelpers.export(exports, "ManOutlined", ()=>(0, _manOutlinedDefault.default));
parcelHelpers.export(exports, "ManRounded", ()=>(0, _manRoundedDefault.default));
parcelHelpers.export(exports, "ManSharp", ()=>(0, _manSharpDefault.default));
parcelHelpers.export(exports, "ManTwoTone", ()=>(0, _manTwoToneDefault.default));
parcelHelpers.export(exports, "ManageAccounts", ()=>(0, _manageAccountsDefault.default));
parcelHelpers.export(exports, "ManageAccountsOutlined", ()=>(0, _manageAccountsOutlinedDefault.default));
parcelHelpers.export(exports, "ManageAccountsRounded", ()=>(0, _manageAccountsRoundedDefault.default));
parcelHelpers.export(exports, "ManageAccountsSharp", ()=>(0, _manageAccountsSharpDefault.default));
parcelHelpers.export(exports, "ManageAccountsTwoTone", ()=>(0, _manageAccountsTwoToneDefault.default));
parcelHelpers.export(exports, "ManageHistory", ()=>(0, _manageHistoryDefault.default));
parcelHelpers.export(exports, "ManageHistoryOutlined", ()=>(0, _manageHistoryOutlinedDefault.default));
parcelHelpers.export(exports, "ManageHistoryRounded", ()=>(0, _manageHistoryRoundedDefault.default));
parcelHelpers.export(exports, "ManageHistorySharp", ()=>(0, _manageHistorySharpDefault.default));
parcelHelpers.export(exports, "ManageHistoryTwoTone", ()=>(0, _manageHistoryTwoToneDefault.default));
parcelHelpers.export(exports, "ManageSearch", ()=>(0, _manageSearchDefault.default));
parcelHelpers.export(exports, "ManageSearchOutlined", ()=>(0, _manageSearchOutlinedDefault.default));
parcelHelpers.export(exports, "ManageSearchRounded", ()=>(0, _manageSearchRoundedDefault.default));
parcelHelpers.export(exports, "ManageSearchSharp", ()=>(0, _manageSearchSharpDefault.default));
parcelHelpers.export(exports, "ManageSearchTwoTone", ()=>(0, _manageSearchTwoToneDefault.default));
parcelHelpers.export(exports, "Map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "MapOutlined", ()=>(0, _mapOutlinedDefault.default));
parcelHelpers.export(exports, "MapRounded", ()=>(0, _mapRoundedDefault.default));
parcelHelpers.export(exports, "MapSharp", ()=>(0, _mapSharpDefault.default));
parcelHelpers.export(exports, "MapTwoTone", ()=>(0, _mapTwoToneDefault.default));
parcelHelpers.export(exports, "MapsHomeWork", ()=>(0, _mapsHomeWorkDefault.default));
parcelHelpers.export(exports, "MapsHomeWorkOutlined", ()=>(0, _mapsHomeWorkOutlinedDefault.default));
parcelHelpers.export(exports, "MapsHomeWorkRounded", ()=>(0, _mapsHomeWorkRoundedDefault.default));
parcelHelpers.export(exports, "MapsHomeWorkSharp", ()=>(0, _mapsHomeWorkSharpDefault.default));
parcelHelpers.export(exports, "MapsHomeWorkTwoTone", ()=>(0, _mapsHomeWorkTwoToneDefault.default));
parcelHelpers.export(exports, "MapsUgc", ()=>(0, _mapsUgcDefault.default));
parcelHelpers.export(exports, "MapsUgcOutlined", ()=>(0, _mapsUgcOutlinedDefault.default));
parcelHelpers.export(exports, "MapsUgcRounded", ()=>(0, _mapsUgcRoundedDefault.default));
parcelHelpers.export(exports, "MapsUgcSharp", ()=>(0, _mapsUgcSharpDefault.default));
parcelHelpers.export(exports, "MapsUgcTwoTone", ()=>(0, _mapsUgcTwoToneDefault.default));
parcelHelpers.export(exports, "Margin", ()=>(0, _marginDefault.default));
parcelHelpers.export(exports, "MarginOutlined", ()=>(0, _marginOutlinedDefault.default));
parcelHelpers.export(exports, "MarginRounded", ()=>(0, _marginRoundedDefault.default));
parcelHelpers.export(exports, "MarginSharp", ()=>(0, _marginSharpDefault.default));
parcelHelpers.export(exports, "MarginTwoTone", ()=>(0, _marginTwoToneDefault.default));
parcelHelpers.export(exports, "MarkAsUnread", ()=>(0, _markAsUnreadDefault.default));
parcelHelpers.export(exports, "MarkAsUnreadOutlined", ()=>(0, _markAsUnreadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkAsUnreadRounded", ()=>(0, _markAsUnreadRoundedDefault.default));
parcelHelpers.export(exports, "MarkAsUnreadSharp", ()=>(0, _markAsUnreadSharpDefault.default));
parcelHelpers.export(exports, "MarkAsUnreadTwoTone", ()=>(0, _markAsUnreadTwoToneDefault.default));
parcelHelpers.export(exports, "MarkChatRead", ()=>(0, _markChatReadDefault.default));
parcelHelpers.export(exports, "MarkChatReadOutlined", ()=>(0, _markChatReadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkChatReadRounded", ()=>(0, _markChatReadRoundedDefault.default));
parcelHelpers.export(exports, "MarkChatReadSharp", ()=>(0, _markChatReadSharpDefault.default));
parcelHelpers.export(exports, "MarkChatReadTwoTone", ()=>(0, _markChatReadTwoToneDefault.default));
parcelHelpers.export(exports, "MarkChatUnread", ()=>(0, _markChatUnreadDefault.default));
parcelHelpers.export(exports, "MarkChatUnreadOutlined", ()=>(0, _markChatUnreadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkChatUnreadRounded", ()=>(0, _markChatUnreadRoundedDefault.default));
parcelHelpers.export(exports, "MarkChatUnreadSharp", ()=>(0, _markChatUnreadSharpDefault.default));
parcelHelpers.export(exports, "MarkChatUnreadTwoTone", ()=>(0, _markChatUnreadTwoToneDefault.default));
parcelHelpers.export(exports, "MarkEmailRead", ()=>(0, _markEmailReadDefault.default));
parcelHelpers.export(exports, "MarkEmailReadOutlined", ()=>(0, _markEmailReadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkEmailReadRounded", ()=>(0, _markEmailReadRoundedDefault.default));
parcelHelpers.export(exports, "MarkEmailReadSharp", ()=>(0, _markEmailReadSharpDefault.default));
parcelHelpers.export(exports, "MarkEmailReadTwoTone", ()=>(0, _markEmailReadTwoToneDefault.default));
parcelHelpers.export(exports, "MarkEmailUnread", ()=>(0, _markEmailUnreadDefault.default));
parcelHelpers.export(exports, "MarkEmailUnreadOutlined", ()=>(0, _markEmailUnreadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkEmailUnreadRounded", ()=>(0, _markEmailUnreadRoundedDefault.default));
parcelHelpers.export(exports, "MarkEmailUnreadSharp", ()=>(0, _markEmailUnreadSharpDefault.default));
parcelHelpers.export(exports, "MarkEmailUnreadTwoTone", ()=>(0, _markEmailUnreadTwoToneDefault.default));
parcelHelpers.export(exports, "MarkUnreadChatAlt", ()=>(0, _markUnreadChatAltDefault.default));
parcelHelpers.export(exports, "MarkUnreadChatAltOutlined", ()=>(0, _markUnreadChatAltOutlinedDefault.default));
parcelHelpers.export(exports, "MarkUnreadChatAltRounded", ()=>(0, _markUnreadChatAltRoundedDefault.default));
parcelHelpers.export(exports, "MarkUnreadChatAltSharp", ()=>(0, _markUnreadChatAltSharpDefault.default));
parcelHelpers.export(exports, "MarkUnreadChatAltTwoTone", ()=>(0, _markUnreadChatAltTwoToneDefault.default));
parcelHelpers.export(exports, "Markunread", ()=>(0, _markunreadDefault.default));
parcelHelpers.export(exports, "MarkunreadMailbox", ()=>(0, _markunreadMailboxDefault.default));
parcelHelpers.export(exports, "MarkunreadMailboxOutlined", ()=>(0, _markunreadMailboxOutlinedDefault.default));
parcelHelpers.export(exports, "MarkunreadMailboxRounded", ()=>(0, _markunreadMailboxRoundedDefault.default));
parcelHelpers.export(exports, "MarkunreadMailboxSharp", ()=>(0, _markunreadMailboxSharpDefault.default));
parcelHelpers.export(exports, "MarkunreadMailboxTwoTone", ()=>(0, _markunreadMailboxTwoToneDefault.default));
parcelHelpers.export(exports, "MarkunreadOutlined", ()=>(0, _markunreadOutlinedDefault.default));
parcelHelpers.export(exports, "MarkunreadRounded", ()=>(0, _markunreadRoundedDefault.default));
parcelHelpers.export(exports, "MarkunreadSharp", ()=>(0, _markunreadSharpDefault.default));
parcelHelpers.export(exports, "MarkunreadTwoTone", ()=>(0, _markunreadTwoToneDefault.default));
parcelHelpers.export(exports, "Masks", ()=>(0, _masksDefault.default));
parcelHelpers.export(exports, "MasksOutlined", ()=>(0, _masksOutlinedDefault.default));
parcelHelpers.export(exports, "MasksRounded", ()=>(0, _masksRoundedDefault.default));
parcelHelpers.export(exports, "MasksSharp", ()=>(0, _masksSharpDefault.default));
parcelHelpers.export(exports, "MasksTwoTone", ()=>(0, _masksTwoToneDefault.default));
parcelHelpers.export(exports, "Maximize", ()=>(0, _maximizeDefault.default));
parcelHelpers.export(exports, "MaximizeOutlined", ()=>(0, _maximizeOutlinedDefault.default));
parcelHelpers.export(exports, "MaximizeRounded", ()=>(0, _maximizeRoundedDefault.default));
parcelHelpers.export(exports, "MaximizeSharp", ()=>(0, _maximizeSharpDefault.default));
parcelHelpers.export(exports, "MaximizeTwoTone", ()=>(0, _maximizeTwoToneDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOff", ()=>(0, _mediaBluetoothOffDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOffOutlined", ()=>(0, _mediaBluetoothOffOutlinedDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOffRounded", ()=>(0, _mediaBluetoothOffRoundedDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOffSharp", ()=>(0, _mediaBluetoothOffSharpDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOffTwoTone", ()=>(0, _mediaBluetoothOffTwoToneDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOn", ()=>(0, _mediaBluetoothOnDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOnOutlined", ()=>(0, _mediaBluetoothOnOutlinedDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOnRounded", ()=>(0, _mediaBluetoothOnRoundedDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOnSharp", ()=>(0, _mediaBluetoothOnSharpDefault.default));
parcelHelpers.export(exports, "MediaBluetoothOnTwoTone", ()=>(0, _mediaBluetoothOnTwoToneDefault.default));
parcelHelpers.export(exports, "Mediation", ()=>(0, _mediationDefault.default));
parcelHelpers.export(exports, "MediationOutlined", ()=>(0, _mediationOutlinedDefault.default));
parcelHelpers.export(exports, "MediationRounded", ()=>(0, _mediationRoundedDefault.default));
parcelHelpers.export(exports, "MediationSharp", ()=>(0, _mediationSharpDefault.default));
parcelHelpers.export(exports, "MediationTwoTone", ()=>(0, _mediationTwoToneDefault.default));
parcelHelpers.export(exports, "MedicalInformation", ()=>(0, _medicalInformationDefault.default));
parcelHelpers.export(exports, "MedicalInformationOutlined", ()=>(0, _medicalInformationOutlinedDefault.default));
parcelHelpers.export(exports, "MedicalInformationRounded", ()=>(0, _medicalInformationRoundedDefault.default));
parcelHelpers.export(exports, "MedicalInformationSharp", ()=>(0, _medicalInformationSharpDefault.default));
parcelHelpers.export(exports, "MedicalInformationTwoTone", ()=>(0, _medicalInformationTwoToneDefault.default));
parcelHelpers.export(exports, "MedicalServices", ()=>(0, _medicalServicesDefault.default));
parcelHelpers.export(exports, "MedicalServicesOutlined", ()=>(0, _medicalServicesOutlinedDefault.default));
parcelHelpers.export(exports, "MedicalServicesRounded", ()=>(0, _medicalServicesRoundedDefault.default));
parcelHelpers.export(exports, "MedicalServicesSharp", ()=>(0, _medicalServicesSharpDefault.default));
parcelHelpers.export(exports, "MedicalServicesTwoTone", ()=>(0, _medicalServicesTwoToneDefault.default));
parcelHelpers.export(exports, "Medication", ()=>(0, _medicationDefault.default));
parcelHelpers.export(exports, "MedicationLiquid", ()=>(0, _medicationLiquidDefault.default));
parcelHelpers.export(exports, "MedicationLiquidOutlined", ()=>(0, _medicationLiquidOutlinedDefault.default));
parcelHelpers.export(exports, "MedicationLiquidRounded", ()=>(0, _medicationLiquidRoundedDefault.default));
parcelHelpers.export(exports, "MedicationLiquidSharp", ()=>(0, _medicationLiquidSharpDefault.default));
parcelHelpers.export(exports, "MedicationLiquidTwoTone", ()=>(0, _medicationLiquidTwoToneDefault.default));
parcelHelpers.export(exports, "MedicationOutlined", ()=>(0, _medicationOutlinedDefault.default));
parcelHelpers.export(exports, "MedicationRounded", ()=>(0, _medicationRoundedDefault.default));
parcelHelpers.export(exports, "MedicationSharp", ()=>(0, _medicationSharpDefault.default));
parcelHelpers.export(exports, "MedicationTwoTone", ()=>(0, _medicationTwoToneDefault.default));
parcelHelpers.export(exports, "MeetingRoom", ()=>(0, _meetingRoomDefault.default));
parcelHelpers.export(exports, "MeetingRoomOutlined", ()=>(0, _meetingRoomOutlinedDefault.default));
parcelHelpers.export(exports, "MeetingRoomRounded", ()=>(0, _meetingRoomRoundedDefault.default));
parcelHelpers.export(exports, "MeetingRoomSharp", ()=>(0, _meetingRoomSharpDefault.default));
parcelHelpers.export(exports, "MeetingRoomTwoTone", ()=>(0, _meetingRoomTwoToneDefault.default));
parcelHelpers.export(exports, "Memory", ()=>(0, _memoryDefault.default));
parcelHelpers.export(exports, "MemoryOutlined", ()=>(0, _memoryOutlinedDefault.default));
parcelHelpers.export(exports, "MemoryRounded", ()=>(0, _memoryRoundedDefault.default));
parcelHelpers.export(exports, "MemorySharp", ()=>(0, _memorySharpDefault.default));
parcelHelpers.export(exports, "MemoryTwoTone", ()=>(0, _memoryTwoToneDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuBook", ()=>(0, _menuBookDefault.default));
parcelHelpers.export(exports, "MenuBookOutlined", ()=>(0, _menuBookOutlinedDefault.default));
parcelHelpers.export(exports, "MenuBookRounded", ()=>(0, _menuBookRoundedDefault.default));
parcelHelpers.export(exports, "MenuBookSharp", ()=>(0, _menuBookSharpDefault.default));
parcelHelpers.export(exports, "MenuBookTwoTone", ()=>(0, _menuBookTwoToneDefault.default));
parcelHelpers.export(exports, "MenuOpen", ()=>(0, _menuOpenDefault.default));
parcelHelpers.export(exports, "MenuOpenOutlined", ()=>(0, _menuOpenOutlinedDefault.default));
parcelHelpers.export(exports, "MenuOpenRounded", ()=>(0, _menuOpenRoundedDefault.default));
parcelHelpers.export(exports, "MenuOpenSharp", ()=>(0, _menuOpenSharpDefault.default));
parcelHelpers.export(exports, "MenuOpenTwoTone", ()=>(0, _menuOpenTwoToneDefault.default));
parcelHelpers.export(exports, "MenuOutlined", ()=>(0, _menuOutlinedDefault.default));
parcelHelpers.export(exports, "MenuRounded", ()=>(0, _menuRoundedDefault.default));
parcelHelpers.export(exports, "MenuSharp", ()=>(0, _menuSharpDefault.default));
parcelHelpers.export(exports, "MenuTwoTone", ()=>(0, _menuTwoToneDefault.default));
parcelHelpers.export(exports, "Merge", ()=>(0, _mergeDefault.default));
parcelHelpers.export(exports, "MergeOutlined", ()=>(0, _mergeOutlinedDefault.default));
parcelHelpers.export(exports, "MergeRounded", ()=>(0, _mergeRoundedDefault.default));
parcelHelpers.export(exports, "MergeSharp", ()=>(0, _mergeSharpDefault.default));
parcelHelpers.export(exports, "MergeTwoTone", ()=>(0, _mergeTwoToneDefault.default));
parcelHelpers.export(exports, "MergeType", ()=>(0, _mergeTypeDefault.default));
parcelHelpers.export(exports, "MergeTypeOutlined", ()=>(0, _mergeTypeOutlinedDefault.default));
parcelHelpers.export(exports, "MergeTypeRounded", ()=>(0, _mergeTypeRoundedDefault.default));
parcelHelpers.export(exports, "MergeTypeSharp", ()=>(0, _mergeTypeSharpDefault.default));
parcelHelpers.export(exports, "MergeTypeTwoTone", ()=>(0, _mergeTypeTwoToneDefault.default));
parcelHelpers.export(exports, "Message", ()=>(0, _messageDefault.default));
parcelHelpers.export(exports, "MessageOutlined", ()=>(0, _messageOutlinedDefault.default));
parcelHelpers.export(exports, "MessageRounded", ()=>(0, _messageRoundedDefault.default));
parcelHelpers.export(exports, "MessageSharp", ()=>(0, _messageSharpDefault.default));
parcelHelpers.export(exports, "MessageTwoTone", ()=>(0, _messageTwoToneDefault.default));
parcelHelpers.export(exports, "Mic", ()=>(0, _micDefault.default));
parcelHelpers.export(exports, "MicExternalOff", ()=>(0, _micExternalOffDefault.default));
parcelHelpers.export(exports, "MicExternalOffOutlined", ()=>(0, _micExternalOffOutlinedDefault.default));
parcelHelpers.export(exports, "MicExternalOffRounded", ()=>(0, _micExternalOffRoundedDefault.default));
parcelHelpers.export(exports, "MicExternalOffSharp", ()=>(0, _micExternalOffSharpDefault.default));
parcelHelpers.export(exports, "MicExternalOffTwoTone", ()=>(0, _micExternalOffTwoToneDefault.default));
parcelHelpers.export(exports, "MicExternalOn", ()=>(0, _micExternalOnDefault.default));
parcelHelpers.export(exports, "MicExternalOnOutlined", ()=>(0, _micExternalOnOutlinedDefault.default));
parcelHelpers.export(exports, "MicExternalOnRounded", ()=>(0, _micExternalOnRoundedDefault.default));
parcelHelpers.export(exports, "MicExternalOnSharp", ()=>(0, _micExternalOnSharpDefault.default));
parcelHelpers.export(exports, "MicExternalOnTwoTone", ()=>(0, _micExternalOnTwoToneDefault.default));
parcelHelpers.export(exports, "MicNone", ()=>(0, _micNoneDefault.default));
parcelHelpers.export(exports, "MicNoneOutlined", ()=>(0, _micNoneOutlinedDefault.default));
parcelHelpers.export(exports, "MicNoneRounded", ()=>(0, _micNoneRoundedDefault.default));
parcelHelpers.export(exports, "MicNoneSharp", ()=>(0, _micNoneSharpDefault.default));
parcelHelpers.export(exports, "MicNoneTwoTone", ()=>(0, _micNoneTwoToneDefault.default));
parcelHelpers.export(exports, "MicOff", ()=>(0, _micOffDefault.default));
parcelHelpers.export(exports, "MicOffOutlined", ()=>(0, _micOffOutlinedDefault.default));
parcelHelpers.export(exports, "MicOffRounded", ()=>(0, _micOffRoundedDefault.default));
parcelHelpers.export(exports, "MicOffSharp", ()=>(0, _micOffSharpDefault.default));
parcelHelpers.export(exports, "MicOffTwoTone", ()=>(0, _micOffTwoToneDefault.default));
parcelHelpers.export(exports, "MicOutlined", ()=>(0, _micOutlinedDefault.default));
parcelHelpers.export(exports, "MicRounded", ()=>(0, _micRoundedDefault.default));
parcelHelpers.export(exports, "MicSharp", ()=>(0, _micSharpDefault.default));
parcelHelpers.export(exports, "MicTwoTone", ()=>(0, _micTwoToneDefault.default));
parcelHelpers.export(exports, "Microsoft", ()=>(0, _microsoftDefault.default));
parcelHelpers.export(exports, "Microwave", ()=>(0, _microwaveDefault.default));
parcelHelpers.export(exports, "MicrowaveOutlined", ()=>(0, _microwaveOutlinedDefault.default));
parcelHelpers.export(exports, "MicrowaveRounded", ()=>(0, _microwaveRoundedDefault.default));
parcelHelpers.export(exports, "MicrowaveSharp", ()=>(0, _microwaveSharpDefault.default));
parcelHelpers.export(exports, "MicrowaveTwoTone", ()=>(0, _microwaveTwoToneDefault.default));
parcelHelpers.export(exports, "MilitaryTech", ()=>(0, _militaryTechDefault.default));
parcelHelpers.export(exports, "MilitaryTechOutlined", ()=>(0, _militaryTechOutlinedDefault.default));
parcelHelpers.export(exports, "MilitaryTechRounded", ()=>(0, _militaryTechRoundedDefault.default));
parcelHelpers.export(exports, "MilitaryTechSharp", ()=>(0, _militaryTechSharpDefault.default));
parcelHelpers.export(exports, "MilitaryTechTwoTone", ()=>(0, _militaryTechTwoToneDefault.default));
parcelHelpers.export(exports, "Minimize", ()=>(0, _minimizeDefault.default));
parcelHelpers.export(exports, "MinimizeOutlined", ()=>(0, _minimizeOutlinedDefault.default));
parcelHelpers.export(exports, "MinimizeRounded", ()=>(0, _minimizeRoundedDefault.default));
parcelHelpers.export(exports, "MinimizeSharp", ()=>(0, _minimizeSharpDefault.default));
parcelHelpers.export(exports, "MinimizeTwoTone", ()=>(0, _minimizeTwoToneDefault.default));
parcelHelpers.export(exports, "MinorCrash", ()=>(0, _minorCrashDefault.default));
parcelHelpers.export(exports, "MinorCrashOutlined", ()=>(0, _minorCrashOutlinedDefault.default));
parcelHelpers.export(exports, "MinorCrashRounded", ()=>(0, _minorCrashRoundedDefault.default));
parcelHelpers.export(exports, "MinorCrashSharp", ()=>(0, _minorCrashSharpDefault.default));
parcelHelpers.export(exports, "MinorCrashTwoTone", ()=>(0, _minorCrashTwoToneDefault.default));
parcelHelpers.export(exports, "MiscellaneousServices", ()=>(0, _miscellaneousServicesDefault.default));
parcelHelpers.export(exports, "MiscellaneousServicesOutlined", ()=>(0, _miscellaneousServicesOutlinedDefault.default));
parcelHelpers.export(exports, "MiscellaneousServicesRounded", ()=>(0, _miscellaneousServicesRoundedDefault.default));
parcelHelpers.export(exports, "MiscellaneousServicesSharp", ()=>(0, _miscellaneousServicesSharpDefault.default));
parcelHelpers.export(exports, "MiscellaneousServicesTwoTone", ()=>(0, _miscellaneousServicesTwoToneDefault.default));
parcelHelpers.export(exports, "MissedVideoCall", ()=>(0, _missedVideoCallDefault.default));
parcelHelpers.export(exports, "MissedVideoCallOutlined", ()=>(0, _missedVideoCallOutlinedDefault.default));
parcelHelpers.export(exports, "MissedVideoCallRounded", ()=>(0, _missedVideoCallRoundedDefault.default));
parcelHelpers.export(exports, "MissedVideoCallSharp", ()=>(0, _missedVideoCallSharpDefault.default));
parcelHelpers.export(exports, "MissedVideoCallTwoTone", ()=>(0, _missedVideoCallTwoToneDefault.default));
parcelHelpers.export(exports, "Mms", ()=>(0, _mmsDefault.default));
parcelHelpers.export(exports, "MmsOutlined", ()=>(0, _mmsOutlinedDefault.default));
parcelHelpers.export(exports, "MmsRounded", ()=>(0, _mmsRoundedDefault.default));
parcelHelpers.export(exports, "MmsSharp", ()=>(0, _mmsSharpDefault.default));
parcelHelpers.export(exports, "MmsTwoTone", ()=>(0, _mmsTwoToneDefault.default));
parcelHelpers.export(exports, "MobileFriendly", ()=>(0, _mobileFriendlyDefault.default));
parcelHelpers.export(exports, "MobileFriendlyOutlined", ()=>(0, _mobileFriendlyOutlinedDefault.default));
parcelHelpers.export(exports, "MobileFriendlyRounded", ()=>(0, _mobileFriendlyRoundedDefault.default));
parcelHelpers.export(exports, "MobileFriendlySharp", ()=>(0, _mobileFriendlySharpDefault.default));
parcelHelpers.export(exports, "MobileFriendlyTwoTone", ()=>(0, _mobileFriendlyTwoToneDefault.default));
parcelHelpers.export(exports, "MobileOff", ()=>(0, _mobileOffDefault.default));
parcelHelpers.export(exports, "MobileOffOutlined", ()=>(0, _mobileOffOutlinedDefault.default));
parcelHelpers.export(exports, "MobileOffRounded", ()=>(0, _mobileOffRoundedDefault.default));
parcelHelpers.export(exports, "MobileOffSharp", ()=>(0, _mobileOffSharpDefault.default));
parcelHelpers.export(exports, "MobileOffTwoTone", ()=>(0, _mobileOffTwoToneDefault.default));
parcelHelpers.export(exports, "MobileScreenShare", ()=>(0, _mobileScreenShareDefault.default));
parcelHelpers.export(exports, "MobileScreenShareOutlined", ()=>(0, _mobileScreenShareOutlinedDefault.default));
parcelHelpers.export(exports, "MobileScreenShareRounded", ()=>(0, _mobileScreenShareRoundedDefault.default));
parcelHelpers.export(exports, "MobileScreenShareSharp", ()=>(0, _mobileScreenShareSharpDefault.default));
parcelHelpers.export(exports, "MobileScreenShareTwoTone", ()=>(0, _mobileScreenShareTwoToneDefault.default));
parcelHelpers.export(exports, "MobiledataOff", ()=>(0, _mobiledataOffDefault.default));
parcelHelpers.export(exports, "MobiledataOffOutlined", ()=>(0, _mobiledataOffOutlinedDefault.default));
parcelHelpers.export(exports, "MobiledataOffRounded", ()=>(0, _mobiledataOffRoundedDefault.default));
parcelHelpers.export(exports, "MobiledataOffSharp", ()=>(0, _mobiledataOffSharpDefault.default));
parcelHelpers.export(exports, "MobiledataOffTwoTone", ()=>(0, _mobiledataOffTwoToneDefault.default));
parcelHelpers.export(exports, "Mode", ()=>(0, _modeDefault.default));
parcelHelpers.export(exports, "ModeComment", ()=>(0, _modeCommentDefault.default));
parcelHelpers.export(exports, "ModeCommentOutlined", ()=>(0, _modeCommentOutlinedDefault.default));
parcelHelpers.export(exports, "ModeCommentRounded", ()=>(0, _modeCommentRoundedDefault.default));
parcelHelpers.export(exports, "ModeCommentSharp", ()=>(0, _modeCommentSharpDefault.default));
parcelHelpers.export(exports, "ModeCommentTwoTone", ()=>(0, _modeCommentTwoToneDefault.default));
parcelHelpers.export(exports, "ModeEdit", ()=>(0, _modeEditDefault.default));
parcelHelpers.export(exports, "ModeEditOutline", ()=>(0, _modeEditOutlineDefault.default));
parcelHelpers.export(exports, "ModeEditOutlineOutlined", ()=>(0, _modeEditOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "ModeEditOutlineRounded", ()=>(0, _modeEditOutlineRoundedDefault.default));
parcelHelpers.export(exports, "ModeEditOutlineSharp", ()=>(0, _modeEditOutlineSharpDefault.default));
parcelHelpers.export(exports, "ModeEditOutlineTwoTone", ()=>(0, _modeEditOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "ModeEditOutlined", ()=>(0, _modeEditOutlinedDefault.default));
parcelHelpers.export(exports, "ModeEditRounded", ()=>(0, _modeEditRoundedDefault.default));
parcelHelpers.export(exports, "ModeEditSharp", ()=>(0, _modeEditSharpDefault.default));
parcelHelpers.export(exports, "ModeEditTwoTone", ()=>(0, _modeEditTwoToneDefault.default));
parcelHelpers.export(exports, "ModeFanOff", ()=>(0, _modeFanOffDefault.default));
parcelHelpers.export(exports, "ModeFanOffOutlined", ()=>(0, _modeFanOffOutlinedDefault.default));
parcelHelpers.export(exports, "ModeFanOffRounded", ()=>(0, _modeFanOffRoundedDefault.default));
parcelHelpers.export(exports, "ModeFanOffSharp", ()=>(0, _modeFanOffSharpDefault.default));
parcelHelpers.export(exports, "ModeFanOffTwoTone", ()=>(0, _modeFanOffTwoToneDefault.default));
parcelHelpers.export(exports, "ModeNight", ()=>(0, _modeNightDefault.default));
parcelHelpers.export(exports, "ModeNightOutlined", ()=>(0, _modeNightOutlinedDefault.default));
parcelHelpers.export(exports, "ModeNightRounded", ()=>(0, _modeNightRoundedDefault.default));
parcelHelpers.export(exports, "ModeNightSharp", ()=>(0, _modeNightSharpDefault.default));
parcelHelpers.export(exports, "ModeNightTwoTone", ()=>(0, _modeNightTwoToneDefault.default));
parcelHelpers.export(exports, "ModeOfTravel", ()=>(0, _modeOfTravelDefault.default));
parcelHelpers.export(exports, "ModeOfTravelOutlined", ()=>(0, _modeOfTravelOutlinedDefault.default));
parcelHelpers.export(exports, "ModeOfTravelRounded", ()=>(0, _modeOfTravelRoundedDefault.default));
parcelHelpers.export(exports, "ModeOfTravelSharp", ()=>(0, _modeOfTravelSharpDefault.default));
parcelHelpers.export(exports, "ModeOfTravelTwoTone", ()=>(0, _modeOfTravelTwoToneDefault.default));
parcelHelpers.export(exports, "ModeOutlined", ()=>(0, _modeOutlinedDefault.default));
parcelHelpers.export(exports, "ModeRounded", ()=>(0, _modeRoundedDefault.default));
parcelHelpers.export(exports, "ModeSharp", ()=>(0, _modeSharpDefault.default));
parcelHelpers.export(exports, "ModeStandby", ()=>(0, _modeStandbyDefault.default));
parcelHelpers.export(exports, "ModeStandbyOutlined", ()=>(0, _modeStandbyOutlinedDefault.default));
parcelHelpers.export(exports, "ModeStandbyRounded", ()=>(0, _modeStandbyRoundedDefault.default));
parcelHelpers.export(exports, "ModeStandbySharp", ()=>(0, _modeStandbySharpDefault.default));
parcelHelpers.export(exports, "ModeStandbyTwoTone", ()=>(0, _modeStandbyTwoToneDefault.default));
parcelHelpers.export(exports, "ModeTwoTone", ()=>(0, _modeTwoToneDefault.default));
parcelHelpers.export(exports, "ModelTraining", ()=>(0, _modelTrainingDefault.default));
parcelHelpers.export(exports, "ModelTrainingOutlined", ()=>(0, _modelTrainingOutlinedDefault.default));
parcelHelpers.export(exports, "ModelTrainingRounded", ()=>(0, _modelTrainingRoundedDefault.default));
parcelHelpers.export(exports, "ModelTrainingSharp", ()=>(0, _modelTrainingSharpDefault.default));
parcelHelpers.export(exports, "ModelTrainingTwoTone", ()=>(0, _modelTrainingTwoToneDefault.default));
parcelHelpers.export(exports, "MonetizationOn", ()=>(0, _monetizationOnDefault.default));
parcelHelpers.export(exports, "MonetizationOnOutlined", ()=>(0, _monetizationOnOutlinedDefault.default));
parcelHelpers.export(exports, "MonetizationOnRounded", ()=>(0, _monetizationOnRoundedDefault.default));
parcelHelpers.export(exports, "MonetizationOnSharp", ()=>(0, _monetizationOnSharpDefault.default));
parcelHelpers.export(exports, "MonetizationOnTwoTone", ()=>(0, _monetizationOnTwoToneDefault.default));
parcelHelpers.export(exports, "Money", ()=>(0, _moneyDefault.default));
parcelHelpers.export(exports, "MoneyOff", ()=>(0, _moneyOffDefault.default));
parcelHelpers.export(exports, "MoneyOffCsred", ()=>(0, _moneyOffCsredDefault.default));
parcelHelpers.export(exports, "MoneyOffCsredOutlined", ()=>(0, _moneyOffCsredOutlinedDefault.default));
parcelHelpers.export(exports, "MoneyOffCsredRounded", ()=>(0, _moneyOffCsredRoundedDefault.default));
parcelHelpers.export(exports, "MoneyOffCsredSharp", ()=>(0, _moneyOffCsredSharpDefault.default));
parcelHelpers.export(exports, "MoneyOffCsredTwoTone", ()=>(0, _moneyOffCsredTwoToneDefault.default));
parcelHelpers.export(exports, "MoneyOffOutlined", ()=>(0, _moneyOffOutlinedDefault.default));
parcelHelpers.export(exports, "MoneyOffRounded", ()=>(0, _moneyOffRoundedDefault.default));
parcelHelpers.export(exports, "MoneyOffSharp", ()=>(0, _moneyOffSharpDefault.default));
parcelHelpers.export(exports, "MoneyOffTwoTone", ()=>(0, _moneyOffTwoToneDefault.default));
parcelHelpers.export(exports, "MoneyOutlined", ()=>(0, _moneyOutlinedDefault.default));
parcelHelpers.export(exports, "MoneyRounded", ()=>(0, _moneyRoundedDefault.default));
parcelHelpers.export(exports, "MoneySharp", ()=>(0, _moneySharpDefault.default));
parcelHelpers.export(exports, "MoneyTwoTone", ()=>(0, _moneyTwoToneDefault.default));
parcelHelpers.export(exports, "Monitor", ()=>(0, _monitorDefault.default));
parcelHelpers.export(exports, "MonitorHeart", ()=>(0, _monitorHeartDefault.default));
parcelHelpers.export(exports, "MonitorHeartOutlined", ()=>(0, _monitorHeartOutlinedDefault.default));
parcelHelpers.export(exports, "MonitorHeartRounded", ()=>(0, _monitorHeartRoundedDefault.default));
parcelHelpers.export(exports, "MonitorHeartSharp", ()=>(0, _monitorHeartSharpDefault.default));
parcelHelpers.export(exports, "MonitorHeartTwoTone", ()=>(0, _monitorHeartTwoToneDefault.default));
parcelHelpers.export(exports, "MonitorOutlined", ()=>(0, _monitorOutlinedDefault.default));
parcelHelpers.export(exports, "MonitorRounded", ()=>(0, _monitorRoundedDefault.default));
parcelHelpers.export(exports, "MonitorSharp", ()=>(0, _monitorSharpDefault.default));
parcelHelpers.export(exports, "MonitorTwoTone", ()=>(0, _monitorTwoToneDefault.default));
parcelHelpers.export(exports, "MonitorWeight", ()=>(0, _monitorWeightDefault.default));
parcelHelpers.export(exports, "MonitorWeightOutlined", ()=>(0, _monitorWeightOutlinedDefault.default));
parcelHelpers.export(exports, "MonitorWeightRounded", ()=>(0, _monitorWeightRoundedDefault.default));
parcelHelpers.export(exports, "MonitorWeightSharp", ()=>(0, _monitorWeightSharpDefault.default));
parcelHelpers.export(exports, "MonitorWeightTwoTone", ()=>(0, _monitorWeightTwoToneDefault.default));
parcelHelpers.export(exports, "MonochromePhotos", ()=>(0, _monochromePhotosDefault.default));
parcelHelpers.export(exports, "MonochromePhotosOutlined", ()=>(0, _monochromePhotosOutlinedDefault.default));
parcelHelpers.export(exports, "MonochromePhotosRounded", ()=>(0, _monochromePhotosRoundedDefault.default));
parcelHelpers.export(exports, "MonochromePhotosSharp", ()=>(0, _monochromePhotosSharpDefault.default));
parcelHelpers.export(exports, "MonochromePhotosTwoTone", ()=>(0, _monochromePhotosTwoToneDefault.default));
parcelHelpers.export(exports, "Mood", ()=>(0, _moodDefault.default));
parcelHelpers.export(exports, "MoodBad", ()=>(0, _moodBadDefault.default));
parcelHelpers.export(exports, "MoodBadOutlined", ()=>(0, _moodBadOutlinedDefault.default));
parcelHelpers.export(exports, "MoodBadRounded", ()=>(0, _moodBadRoundedDefault.default));
parcelHelpers.export(exports, "MoodBadSharp", ()=>(0, _moodBadSharpDefault.default));
parcelHelpers.export(exports, "MoodBadTwoTone", ()=>(0, _moodBadTwoToneDefault.default));
parcelHelpers.export(exports, "MoodOutlined", ()=>(0, _moodOutlinedDefault.default));
parcelHelpers.export(exports, "MoodRounded", ()=>(0, _moodRoundedDefault.default));
parcelHelpers.export(exports, "MoodSharp", ()=>(0, _moodSharpDefault.default));
parcelHelpers.export(exports, "MoodTwoTone", ()=>(0, _moodTwoToneDefault.default));
parcelHelpers.export(exports, "Moped", ()=>(0, _mopedDefault.default));
parcelHelpers.export(exports, "MopedOutlined", ()=>(0, _mopedOutlinedDefault.default));
parcelHelpers.export(exports, "MopedRounded", ()=>(0, _mopedRoundedDefault.default));
parcelHelpers.export(exports, "MopedSharp", ()=>(0, _mopedSharpDefault.default));
parcelHelpers.export(exports, "MopedTwoTone", ()=>(0, _mopedTwoToneDefault.default));
parcelHelpers.export(exports, "More", ()=>(0, _moreDefault.default));
parcelHelpers.export(exports, "MoreHoriz", ()=>(0, _moreHorizDefault.default));
parcelHelpers.export(exports, "MoreHorizOutlined", ()=>(0, _moreHorizOutlinedDefault.default));
parcelHelpers.export(exports, "MoreHorizRounded", ()=>(0, _moreHorizRoundedDefault.default));
parcelHelpers.export(exports, "MoreHorizSharp", ()=>(0, _moreHorizSharpDefault.default));
parcelHelpers.export(exports, "MoreHorizTwoTone", ()=>(0, _moreHorizTwoToneDefault.default));
parcelHelpers.export(exports, "MoreOutlined", ()=>(0, _moreOutlinedDefault.default));
parcelHelpers.export(exports, "MoreRounded", ()=>(0, _moreRoundedDefault.default));
parcelHelpers.export(exports, "MoreSharp", ()=>(0, _moreSharpDefault.default));
parcelHelpers.export(exports, "MoreTime", ()=>(0, _moreTimeDefault.default));
parcelHelpers.export(exports, "MoreTimeOutlined", ()=>(0, _moreTimeOutlinedDefault.default));
parcelHelpers.export(exports, "MoreTimeRounded", ()=>(0, _moreTimeRoundedDefault.default));
parcelHelpers.export(exports, "MoreTimeSharp", ()=>(0, _moreTimeSharpDefault.default));
parcelHelpers.export(exports, "MoreTimeTwoTone", ()=>(0, _moreTimeTwoToneDefault.default));
parcelHelpers.export(exports, "MoreTwoTone", ()=>(0, _moreTwoToneDefault.default));
parcelHelpers.export(exports, "MoreVert", ()=>(0, _moreVertDefault.default));
parcelHelpers.export(exports, "MoreVertOutlined", ()=>(0, _moreVertOutlinedDefault.default));
parcelHelpers.export(exports, "MoreVertRounded", ()=>(0, _moreVertRoundedDefault.default));
parcelHelpers.export(exports, "MoreVertSharp", ()=>(0, _moreVertSharpDefault.default));
parcelHelpers.export(exports, "MoreVertTwoTone", ()=>(0, _moreVertTwoToneDefault.default));
parcelHelpers.export(exports, "Mosque", ()=>(0, _mosqueDefault.default));
parcelHelpers.export(exports, "MosqueOutlined", ()=>(0, _mosqueOutlinedDefault.default));
parcelHelpers.export(exports, "MosqueRounded", ()=>(0, _mosqueRoundedDefault.default));
parcelHelpers.export(exports, "MosqueSharp", ()=>(0, _mosqueSharpDefault.default));
parcelHelpers.export(exports, "MosqueTwoTone", ()=>(0, _mosqueTwoToneDefault.default));
parcelHelpers.export(exports, "MotionPhotosAuto", ()=>(0, _motionPhotosAutoDefault.default));
parcelHelpers.export(exports, "MotionPhotosAutoOutlined", ()=>(0, _motionPhotosAutoOutlinedDefault.default));
parcelHelpers.export(exports, "MotionPhotosAutoRounded", ()=>(0, _motionPhotosAutoRoundedDefault.default));
parcelHelpers.export(exports, "MotionPhotosAutoSharp", ()=>(0, _motionPhotosAutoSharpDefault.default));
parcelHelpers.export(exports, "MotionPhotosAutoTwoTone", ()=>(0, _motionPhotosAutoTwoToneDefault.default));
parcelHelpers.export(exports, "MotionPhotosOff", ()=>(0, _motionPhotosOffDefault.default));
parcelHelpers.export(exports, "MotionPhotosOffOutlined", ()=>(0, _motionPhotosOffOutlinedDefault.default));
parcelHelpers.export(exports, "MotionPhotosOffRounded", ()=>(0, _motionPhotosOffRoundedDefault.default));
parcelHelpers.export(exports, "MotionPhotosOffSharp", ()=>(0, _motionPhotosOffSharpDefault.default));
parcelHelpers.export(exports, "MotionPhotosOffTwoTone", ()=>(0, _motionPhotosOffTwoToneDefault.default));
parcelHelpers.export(exports, "Mouse", ()=>(0, _mouseDefault.default));
parcelHelpers.export(exports, "MouseOutlined", ()=>(0, _mouseOutlinedDefault.default));
parcelHelpers.export(exports, "MouseRounded", ()=>(0, _mouseRoundedDefault.default));
parcelHelpers.export(exports, "MouseSharp", ()=>(0, _mouseSharpDefault.default));
parcelHelpers.export(exports, "MouseTwoTone", ()=>(0, _mouseTwoToneDefault.default));
parcelHelpers.export(exports, "MoveDown", ()=>(0, _moveDownDefault.default));
parcelHelpers.export(exports, "MoveDownOutlined", ()=>(0, _moveDownOutlinedDefault.default));
parcelHelpers.export(exports, "MoveDownRounded", ()=>(0, _moveDownRoundedDefault.default));
parcelHelpers.export(exports, "MoveDownSharp", ()=>(0, _moveDownSharpDefault.default));
parcelHelpers.export(exports, "MoveDownTwoTone", ()=>(0, _moveDownTwoToneDefault.default));
parcelHelpers.export(exports, "MoveToInbox", ()=>(0, _moveToInboxDefault.default));
parcelHelpers.export(exports, "MoveToInboxOutlined", ()=>(0, _moveToInboxOutlinedDefault.default));
parcelHelpers.export(exports, "MoveToInboxRounded", ()=>(0, _moveToInboxRoundedDefault.default));
parcelHelpers.export(exports, "MoveToInboxSharp", ()=>(0, _moveToInboxSharpDefault.default));
parcelHelpers.export(exports, "MoveToInboxTwoTone", ()=>(0, _moveToInboxTwoToneDefault.default));
parcelHelpers.export(exports, "MoveUp", ()=>(0, _moveUpDefault.default));
parcelHelpers.export(exports, "MoveUpOutlined", ()=>(0, _moveUpOutlinedDefault.default));
parcelHelpers.export(exports, "MoveUpRounded", ()=>(0, _moveUpRoundedDefault.default));
parcelHelpers.export(exports, "MoveUpSharp", ()=>(0, _moveUpSharpDefault.default));
parcelHelpers.export(exports, "MoveUpTwoTone", ()=>(0, _moveUpTwoToneDefault.default));
parcelHelpers.export(exports, "Movie", ()=>(0, _movieDefault.default));
parcelHelpers.export(exports, "MovieCreation", ()=>(0, _movieCreationDefault.default));
parcelHelpers.export(exports, "MovieCreationOutlined", ()=>(0, _movieCreationOutlinedDefault.default));
parcelHelpers.export(exports, "MovieCreationRounded", ()=>(0, _movieCreationRoundedDefault.default));
parcelHelpers.export(exports, "MovieCreationSharp", ()=>(0, _movieCreationSharpDefault.default));
parcelHelpers.export(exports, "MovieCreationTwoTone", ()=>(0, _movieCreationTwoToneDefault.default));
parcelHelpers.export(exports, "MovieFilter", ()=>(0, _movieFilterDefault.default));
parcelHelpers.export(exports, "MovieFilterOutlined", ()=>(0, _movieFilterOutlinedDefault.default));
parcelHelpers.export(exports, "MovieFilterRounded", ()=>(0, _movieFilterRoundedDefault.default));
parcelHelpers.export(exports, "MovieFilterSharp", ()=>(0, _movieFilterSharpDefault.default));
parcelHelpers.export(exports, "MovieFilterTwoTone", ()=>(0, _movieFilterTwoToneDefault.default));
parcelHelpers.export(exports, "MovieOutlined", ()=>(0, _movieOutlinedDefault.default));
parcelHelpers.export(exports, "MovieRounded", ()=>(0, _movieRoundedDefault.default));
parcelHelpers.export(exports, "MovieSharp", ()=>(0, _movieSharpDefault.default));
parcelHelpers.export(exports, "MovieTwoTone", ()=>(0, _movieTwoToneDefault.default));
parcelHelpers.export(exports, "Moving", ()=>(0, _movingDefault.default));
parcelHelpers.export(exports, "MovingOutlined", ()=>(0, _movingOutlinedDefault.default));
parcelHelpers.export(exports, "MovingRounded", ()=>(0, _movingRoundedDefault.default));
parcelHelpers.export(exports, "MovingSharp", ()=>(0, _movingSharpDefault.default));
parcelHelpers.export(exports, "MovingTwoTone", ()=>(0, _movingTwoToneDefault.default));
parcelHelpers.export(exports, "Mp", ()=>(0, _mpDefault.default));
parcelHelpers.export(exports, "MpOutlined", ()=>(0, _mpOutlinedDefault.default));
parcelHelpers.export(exports, "MpRounded", ()=>(0, _mpRoundedDefault.default));
parcelHelpers.export(exports, "MpSharp", ()=>(0, _mpSharpDefault.default));
parcelHelpers.export(exports, "MpTwoTone", ()=>(0, _mpTwoToneDefault.default));
parcelHelpers.export(exports, "MultilineChart", ()=>(0, _multilineChartDefault.default));
parcelHelpers.export(exports, "MultilineChartOutlined", ()=>(0, _multilineChartOutlinedDefault.default));
parcelHelpers.export(exports, "MultilineChartRounded", ()=>(0, _multilineChartRoundedDefault.default));
parcelHelpers.export(exports, "MultilineChartSharp", ()=>(0, _multilineChartSharpDefault.default));
parcelHelpers.export(exports, "MultilineChartTwoTone", ()=>(0, _multilineChartTwoToneDefault.default));
parcelHelpers.export(exports, "MultipleStop", ()=>(0, _multipleStopDefault.default));
parcelHelpers.export(exports, "MultipleStopOutlined", ()=>(0, _multipleStopOutlinedDefault.default));
parcelHelpers.export(exports, "MultipleStopRounded", ()=>(0, _multipleStopRoundedDefault.default));
parcelHelpers.export(exports, "MultipleStopSharp", ()=>(0, _multipleStopSharpDefault.default));
parcelHelpers.export(exports, "MultipleStopTwoTone", ()=>(0, _multipleStopTwoToneDefault.default));
parcelHelpers.export(exports, "Museum", ()=>(0, _museumDefault.default));
parcelHelpers.export(exports, "MuseumOutlined", ()=>(0, _museumOutlinedDefault.default));
parcelHelpers.export(exports, "MuseumRounded", ()=>(0, _museumRoundedDefault.default));
parcelHelpers.export(exports, "MuseumSharp", ()=>(0, _museumSharpDefault.default));
parcelHelpers.export(exports, "MuseumTwoTone", ()=>(0, _museumTwoToneDefault.default));
parcelHelpers.export(exports, "MusicNote", ()=>(0, _musicNoteDefault.default));
parcelHelpers.export(exports, "MusicNoteOutlined", ()=>(0, _musicNoteOutlinedDefault.default));
parcelHelpers.export(exports, "MusicNoteRounded", ()=>(0, _musicNoteRoundedDefault.default));
parcelHelpers.export(exports, "MusicNoteSharp", ()=>(0, _musicNoteSharpDefault.default));
parcelHelpers.export(exports, "MusicNoteTwoTone", ()=>(0, _musicNoteTwoToneDefault.default));
parcelHelpers.export(exports, "MusicOff", ()=>(0, _musicOffDefault.default));
parcelHelpers.export(exports, "MusicOffOutlined", ()=>(0, _musicOffOutlinedDefault.default));
parcelHelpers.export(exports, "MusicOffRounded", ()=>(0, _musicOffRoundedDefault.default));
parcelHelpers.export(exports, "MusicOffSharp", ()=>(0, _musicOffSharpDefault.default));
parcelHelpers.export(exports, "MusicOffTwoTone", ()=>(0, _musicOffTwoToneDefault.default));
parcelHelpers.export(exports, "MusicVideo", ()=>(0, _musicVideoDefault.default));
parcelHelpers.export(exports, "MusicVideoOutlined", ()=>(0, _musicVideoOutlinedDefault.default));
parcelHelpers.export(exports, "MusicVideoRounded", ()=>(0, _musicVideoRoundedDefault.default));
parcelHelpers.export(exports, "MusicVideoSharp", ()=>(0, _musicVideoSharpDefault.default));
parcelHelpers.export(exports, "MusicVideoTwoTone", ()=>(0, _musicVideoTwoToneDefault.default));
parcelHelpers.export(exports, "MyLocation", ()=>(0, _myLocationDefault.default));
parcelHelpers.export(exports, "MyLocationOutlined", ()=>(0, _myLocationOutlinedDefault.default));
parcelHelpers.export(exports, "MyLocationRounded", ()=>(0, _myLocationRoundedDefault.default));
parcelHelpers.export(exports, "MyLocationSharp", ()=>(0, _myLocationSharpDefault.default));
parcelHelpers.export(exports, "MyLocationTwoTone", ()=>(0, _myLocationTwoToneDefault.default));
parcelHelpers.export(exports, "Nat", ()=>(0, _natDefault.default));
parcelHelpers.export(exports, "NatOutlined", ()=>(0, _natOutlinedDefault.default));
parcelHelpers.export(exports, "NatRounded", ()=>(0, _natRoundedDefault.default));
parcelHelpers.export(exports, "NatSharp", ()=>(0, _natSharpDefault.default));
parcelHelpers.export(exports, "NatTwoTone", ()=>(0, _natTwoToneDefault.default));
parcelHelpers.export(exports, "Nature", ()=>(0, _natureDefault.default));
parcelHelpers.export(exports, "NatureOutlined", ()=>(0, _natureOutlinedDefault.default));
parcelHelpers.export(exports, "NaturePeople", ()=>(0, _naturePeopleDefault.default));
parcelHelpers.export(exports, "NaturePeopleOutlined", ()=>(0, _naturePeopleOutlinedDefault.default));
parcelHelpers.export(exports, "NaturePeopleRounded", ()=>(0, _naturePeopleRoundedDefault.default));
parcelHelpers.export(exports, "NaturePeopleSharp", ()=>(0, _naturePeopleSharpDefault.default));
parcelHelpers.export(exports, "NaturePeopleTwoTone", ()=>(0, _naturePeopleTwoToneDefault.default));
parcelHelpers.export(exports, "NatureRounded", ()=>(0, _natureRoundedDefault.default));
parcelHelpers.export(exports, "NatureSharp", ()=>(0, _natureSharpDefault.default));
parcelHelpers.export(exports, "NatureTwoTone", ()=>(0, _natureTwoToneDefault.default));
parcelHelpers.export(exports, "NavigateBefore", ()=>(0, _navigateBeforeDefault.default));
parcelHelpers.export(exports, "NavigateBeforeOutlined", ()=>(0, _navigateBeforeOutlinedDefault.default));
parcelHelpers.export(exports, "NavigateBeforeRounded", ()=>(0, _navigateBeforeRoundedDefault.default));
parcelHelpers.export(exports, "NavigateBeforeSharp", ()=>(0, _navigateBeforeSharpDefault.default));
parcelHelpers.export(exports, "NavigateBeforeTwoTone", ()=>(0, _navigateBeforeTwoToneDefault.default));
parcelHelpers.export(exports, "NavigateNext", ()=>(0, _navigateNextDefault.default));
parcelHelpers.export(exports, "NavigateNextOutlined", ()=>(0, _navigateNextOutlinedDefault.default));
parcelHelpers.export(exports, "NavigateNextRounded", ()=>(0, _navigateNextRoundedDefault.default));
parcelHelpers.export(exports, "NavigateNextSharp", ()=>(0, _navigateNextSharpDefault.default));
parcelHelpers.export(exports, "NavigateNextTwoTone", ()=>(0, _navigateNextTwoToneDefault.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationDefault.default));
parcelHelpers.export(exports, "NavigationOutlined", ()=>(0, _navigationOutlinedDefault.default));
parcelHelpers.export(exports, "NavigationRounded", ()=>(0, _navigationRoundedDefault.default));
parcelHelpers.export(exports, "NavigationSharp", ()=>(0, _navigationSharpDefault.default));
parcelHelpers.export(exports, "NavigationTwoTone", ()=>(0, _navigationTwoToneDefault.default));
parcelHelpers.export(exports, "NearMe", ()=>(0, _nearMeDefault.default));
parcelHelpers.export(exports, "NearMeDisabled", ()=>(0, _nearMeDisabledDefault.default));
parcelHelpers.export(exports, "NearMeDisabledOutlined", ()=>(0, _nearMeDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "NearMeDisabledRounded", ()=>(0, _nearMeDisabledRoundedDefault.default));
parcelHelpers.export(exports, "NearMeDisabledSharp", ()=>(0, _nearMeDisabledSharpDefault.default));
parcelHelpers.export(exports, "NearMeDisabledTwoTone", ()=>(0, _nearMeDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "NearMeOutlined", ()=>(0, _nearMeOutlinedDefault.default));
parcelHelpers.export(exports, "NearMeRounded", ()=>(0, _nearMeRoundedDefault.default));
parcelHelpers.export(exports, "NearMeSharp", ()=>(0, _nearMeSharpDefault.default));
parcelHelpers.export(exports, "NearMeTwoTone", ()=>(0, _nearMeTwoToneDefault.default));
parcelHelpers.export(exports, "NearbyError", ()=>(0, _nearbyErrorDefault.default));
parcelHelpers.export(exports, "NearbyErrorOutlined", ()=>(0, _nearbyErrorOutlinedDefault.default));
parcelHelpers.export(exports, "NearbyErrorRounded", ()=>(0, _nearbyErrorRoundedDefault.default));
parcelHelpers.export(exports, "NearbyErrorSharp", ()=>(0, _nearbyErrorSharpDefault.default));
parcelHelpers.export(exports, "NearbyErrorTwoTone", ()=>(0, _nearbyErrorTwoToneDefault.default));
parcelHelpers.export(exports, "NearbyOff", ()=>(0, _nearbyOffDefault.default));
parcelHelpers.export(exports, "NearbyOffOutlined", ()=>(0, _nearbyOffOutlinedDefault.default));
parcelHelpers.export(exports, "NearbyOffRounded", ()=>(0, _nearbyOffRoundedDefault.default));
parcelHelpers.export(exports, "NearbyOffSharp", ()=>(0, _nearbyOffSharpDefault.default));
parcelHelpers.export(exports, "NearbyOffTwoTone", ()=>(0, _nearbyOffTwoToneDefault.default));
parcelHelpers.export(exports, "NestCamWiredStand", ()=>(0, _nestCamWiredStandDefault.default));
parcelHelpers.export(exports, "NestCamWiredStandOutlined", ()=>(0, _nestCamWiredStandOutlinedDefault.default));
parcelHelpers.export(exports, "NestCamWiredStandRounded", ()=>(0, _nestCamWiredStandRoundedDefault.default));
parcelHelpers.export(exports, "NestCamWiredStandSharp", ()=>(0, _nestCamWiredStandSharpDefault.default));
parcelHelpers.export(exports, "NestCamWiredStandTwoTone", ()=>(0, _nestCamWiredStandTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkCell", ()=>(0, _networkCellDefault.default));
parcelHelpers.export(exports, "NetworkCellOutlined", ()=>(0, _networkCellOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkCellRounded", ()=>(0, _networkCellRoundedDefault.default));
parcelHelpers.export(exports, "NetworkCellSharp", ()=>(0, _networkCellSharpDefault.default));
parcelHelpers.export(exports, "NetworkCellTwoTone", ()=>(0, _networkCellTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkCheck", ()=>(0, _networkCheckDefault.default));
parcelHelpers.export(exports, "NetworkCheckOutlined", ()=>(0, _networkCheckOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkCheckRounded", ()=>(0, _networkCheckRoundedDefault.default));
parcelHelpers.export(exports, "NetworkCheckSharp", ()=>(0, _networkCheckSharpDefault.default));
parcelHelpers.export(exports, "NetworkCheckTwoTone", ()=>(0, _networkCheckTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkLocked", ()=>(0, _networkLockedDefault.default));
parcelHelpers.export(exports, "NetworkLockedOutlined", ()=>(0, _networkLockedOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkLockedRounded", ()=>(0, _networkLockedRoundedDefault.default));
parcelHelpers.export(exports, "NetworkLockedSharp", ()=>(0, _networkLockedSharpDefault.default));
parcelHelpers.export(exports, "NetworkLockedTwoTone", ()=>(0, _networkLockedTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkPing", ()=>(0, _networkPingDefault.default));
parcelHelpers.export(exports, "NetworkPingOutlined", ()=>(0, _networkPingOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkPingRounded", ()=>(0, _networkPingRoundedDefault.default));
parcelHelpers.export(exports, "NetworkPingSharp", ()=>(0, _networkPingSharpDefault.default));
parcelHelpers.export(exports, "NetworkPingTwoTone", ()=>(0, _networkPingTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkWifi", ()=>(0, _networkWifiDefault.default));
parcelHelpers.export(exports, "NetworkWifi1Bar", ()=>(0, _networkWifi1BarDefault.default));
parcelHelpers.export(exports, "NetworkWifi1BarOutlined", ()=>(0, _networkWifi1BarOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkWifi1BarRounded", ()=>(0, _networkWifi1BarRoundedDefault.default));
parcelHelpers.export(exports, "NetworkWifi1BarSharp", ()=>(0, _networkWifi1BarSharpDefault.default));
parcelHelpers.export(exports, "NetworkWifi1BarTwoTone", ()=>(0, _networkWifi1BarTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkWifi2Bar", ()=>(0, _networkWifi2BarDefault.default));
parcelHelpers.export(exports, "NetworkWifi2BarOutlined", ()=>(0, _networkWifi2BarOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkWifi2BarRounded", ()=>(0, _networkWifi2BarRoundedDefault.default));
parcelHelpers.export(exports, "NetworkWifi2BarSharp", ()=>(0, _networkWifi2BarSharpDefault.default));
parcelHelpers.export(exports, "NetworkWifi2BarTwoTone", ()=>(0, _networkWifi2BarTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkWifi3Bar", ()=>(0, _networkWifi3BarDefault.default));
parcelHelpers.export(exports, "NetworkWifi3BarOutlined", ()=>(0, _networkWifi3BarOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkWifi3BarRounded", ()=>(0, _networkWifi3BarRoundedDefault.default));
parcelHelpers.export(exports, "NetworkWifi3BarSharp", ()=>(0, _networkWifi3BarSharpDefault.default));
parcelHelpers.export(exports, "NetworkWifi3BarTwoTone", ()=>(0, _networkWifi3BarTwoToneDefault.default));
parcelHelpers.export(exports, "NetworkWifiOutlined", ()=>(0, _networkWifiOutlinedDefault.default));
parcelHelpers.export(exports, "NetworkWifiRounded", ()=>(0, _networkWifiRoundedDefault.default));
parcelHelpers.export(exports, "NetworkWifiSharp", ()=>(0, _networkWifiSharpDefault.default));
parcelHelpers.export(exports, "NetworkWifiTwoTone", ()=>(0, _networkWifiTwoToneDefault.default));
parcelHelpers.export(exports, "NewReleases", ()=>(0, _newReleasesDefault.default));
parcelHelpers.export(exports, "NewReleasesOutlined", ()=>(0, _newReleasesOutlinedDefault.default));
parcelHelpers.export(exports, "NewReleasesRounded", ()=>(0, _newReleasesRoundedDefault.default));
parcelHelpers.export(exports, "NewReleasesSharp", ()=>(0, _newReleasesSharpDefault.default));
parcelHelpers.export(exports, "NewReleasesTwoTone", ()=>(0, _newReleasesTwoToneDefault.default));
parcelHelpers.export(exports, "Newspaper", ()=>(0, _newspaperDefault.default));
parcelHelpers.export(exports, "NewspaperOutlined", ()=>(0, _newspaperOutlinedDefault.default));
parcelHelpers.export(exports, "NewspaperRounded", ()=>(0, _newspaperRoundedDefault.default));
parcelHelpers.export(exports, "NewspaperSharp", ()=>(0, _newspaperSharpDefault.default));
parcelHelpers.export(exports, "NewspaperTwoTone", ()=>(0, _newspaperTwoToneDefault.default));
parcelHelpers.export(exports, "NextPlan", ()=>(0, _nextPlanDefault.default));
parcelHelpers.export(exports, "NextPlanOutlined", ()=>(0, _nextPlanOutlinedDefault.default));
parcelHelpers.export(exports, "NextPlanRounded", ()=>(0, _nextPlanRoundedDefault.default));
parcelHelpers.export(exports, "NextPlanSharp", ()=>(0, _nextPlanSharpDefault.default));
parcelHelpers.export(exports, "NextPlanTwoTone", ()=>(0, _nextPlanTwoToneDefault.default));
parcelHelpers.export(exports, "NextWeek", ()=>(0, _nextWeekDefault.default));
parcelHelpers.export(exports, "NextWeekOutlined", ()=>(0, _nextWeekOutlinedDefault.default));
parcelHelpers.export(exports, "NextWeekRounded", ()=>(0, _nextWeekRoundedDefault.default));
parcelHelpers.export(exports, "NextWeekSharp", ()=>(0, _nextWeekSharpDefault.default));
parcelHelpers.export(exports, "NextWeekTwoTone", ()=>(0, _nextWeekTwoToneDefault.default));
parcelHelpers.export(exports, "Nfc", ()=>(0, _nfcDefault.default));
parcelHelpers.export(exports, "NfcOutlined", ()=>(0, _nfcOutlinedDefault.default));
parcelHelpers.export(exports, "NfcRounded", ()=>(0, _nfcRoundedDefault.default));
parcelHelpers.export(exports, "NfcSharp", ()=>(0, _nfcSharpDefault.default));
parcelHelpers.export(exports, "NfcTwoTone", ()=>(0, _nfcTwoToneDefault.default));
parcelHelpers.export(exports, "NightShelter", ()=>(0, _nightShelterDefault.default));
parcelHelpers.export(exports, "NightShelterOutlined", ()=>(0, _nightShelterOutlinedDefault.default));
parcelHelpers.export(exports, "NightShelterRounded", ()=>(0, _nightShelterRoundedDefault.default));
parcelHelpers.export(exports, "NightShelterSharp", ()=>(0, _nightShelterSharpDefault.default));
parcelHelpers.export(exports, "NightShelterTwoTone", ()=>(0, _nightShelterTwoToneDefault.default));
parcelHelpers.export(exports, "Nightlife", ()=>(0, _nightlifeDefault.default));
parcelHelpers.export(exports, "NightlifeOutlined", ()=>(0, _nightlifeOutlinedDefault.default));
parcelHelpers.export(exports, "NightlifeRounded", ()=>(0, _nightlifeRoundedDefault.default));
parcelHelpers.export(exports, "NightlifeSharp", ()=>(0, _nightlifeSharpDefault.default));
parcelHelpers.export(exports, "NightlifeTwoTone", ()=>(0, _nightlifeTwoToneDefault.default));
parcelHelpers.export(exports, "Nightlight", ()=>(0, _nightlightDefault.default));
parcelHelpers.export(exports, "NightlightOutlined", ()=>(0, _nightlightOutlinedDefault.default));
parcelHelpers.export(exports, "NightlightRound", ()=>(0, _nightlightRoundDefault.default));
parcelHelpers.export(exports, "NightlightRoundOutlined", ()=>(0, _nightlightRoundOutlinedDefault.default));
parcelHelpers.export(exports, "NightlightRoundRounded", ()=>(0, _nightlightRoundRoundedDefault.default));
parcelHelpers.export(exports, "NightlightRoundSharp", ()=>(0, _nightlightRoundSharpDefault.default));
parcelHelpers.export(exports, "NightlightRoundTwoTone", ()=>(0, _nightlightRoundTwoToneDefault.default));
parcelHelpers.export(exports, "NightlightRounded", ()=>(0, _nightlightRoundedDefault.default));
parcelHelpers.export(exports, "NightlightSharp", ()=>(0, _nightlightSharpDefault.default));
parcelHelpers.export(exports, "NightlightTwoTone", ()=>(0, _nightlightTwoToneDefault.default));
parcelHelpers.export(exports, "NightsStay", ()=>(0, _nightsStayDefault.default));
parcelHelpers.export(exports, "NightsStayOutlined", ()=>(0, _nightsStayOutlinedDefault.default));
parcelHelpers.export(exports, "NightsStayRounded", ()=>(0, _nightsStayRoundedDefault.default));
parcelHelpers.export(exports, "NightsStaySharp", ()=>(0, _nightsStaySharpDefault.default));
parcelHelpers.export(exports, "NightsStayTwoTone", ()=>(0, _nightsStayTwoToneDefault.default));
parcelHelpers.export(exports, "NineK", ()=>(0, _nineKDefault.default));
parcelHelpers.export(exports, "NineKOutlined", ()=>(0, _nineKOutlinedDefault.default));
parcelHelpers.export(exports, "NineKPlus", ()=>(0, _nineKPlusDefault.default));
parcelHelpers.export(exports, "NineKPlusOutlined", ()=>(0, _nineKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "NineKPlusRounded", ()=>(0, _nineKPlusRoundedDefault.default));
parcelHelpers.export(exports, "NineKPlusSharp", ()=>(0, _nineKPlusSharpDefault.default));
parcelHelpers.export(exports, "NineKPlusTwoTone", ()=>(0, _nineKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "NineKRounded", ()=>(0, _nineKRoundedDefault.default));
parcelHelpers.export(exports, "NineKSharp", ()=>(0, _nineKSharpDefault.default));
parcelHelpers.export(exports, "NineKTwoTone", ()=>(0, _nineKTwoToneDefault.default));
parcelHelpers.export(exports, "NineMp", ()=>(0, _nineMpDefault.default));
parcelHelpers.export(exports, "NineMpOutlined", ()=>(0, _nineMpOutlinedDefault.default));
parcelHelpers.export(exports, "NineMpRounded", ()=>(0, _nineMpRoundedDefault.default));
parcelHelpers.export(exports, "NineMpSharp", ()=>(0, _nineMpSharpDefault.default));
parcelHelpers.export(exports, "NineMpTwoTone", ()=>(0, _nineMpTwoToneDefault.default));
parcelHelpers.export(exports, "NineteenMp", ()=>(0, _nineteenMpDefault.default));
parcelHelpers.export(exports, "NineteenMpOutlined", ()=>(0, _nineteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "NineteenMpRounded", ()=>(0, _nineteenMpRoundedDefault.default));
parcelHelpers.export(exports, "NineteenMpSharp", ()=>(0, _nineteenMpSharpDefault.default));
parcelHelpers.export(exports, "NineteenMpTwoTone", ()=>(0, _nineteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "NoAccounts", ()=>(0, _noAccountsDefault.default));
parcelHelpers.export(exports, "NoAccountsOutlined", ()=>(0, _noAccountsOutlinedDefault.default));
parcelHelpers.export(exports, "NoAccountsRounded", ()=>(0, _noAccountsRoundedDefault.default));
parcelHelpers.export(exports, "NoAccountsSharp", ()=>(0, _noAccountsSharpDefault.default));
parcelHelpers.export(exports, "NoAccountsTwoTone", ()=>(0, _noAccountsTwoToneDefault.default));
parcelHelpers.export(exports, "NoAdultContent", ()=>(0, _noAdultContentDefault.default));
parcelHelpers.export(exports, "NoAdultContentOutlined", ()=>(0, _noAdultContentOutlinedDefault.default));
parcelHelpers.export(exports, "NoAdultContentRounded", ()=>(0, _noAdultContentRoundedDefault.default));
parcelHelpers.export(exports, "NoAdultContentSharp", ()=>(0, _noAdultContentSharpDefault.default));
parcelHelpers.export(exports, "NoAdultContentTwoTone", ()=>(0, _noAdultContentTwoToneDefault.default));
parcelHelpers.export(exports, "NoBackpack", ()=>(0, _noBackpackDefault.default));
parcelHelpers.export(exports, "NoBackpackOutlined", ()=>(0, _noBackpackOutlinedDefault.default));
parcelHelpers.export(exports, "NoBackpackRounded", ()=>(0, _noBackpackRoundedDefault.default));
parcelHelpers.export(exports, "NoBackpackSharp", ()=>(0, _noBackpackSharpDefault.default));
parcelHelpers.export(exports, "NoBackpackTwoTone", ()=>(0, _noBackpackTwoToneDefault.default));
parcelHelpers.export(exports, "NoCell", ()=>(0, _noCellDefault.default));
parcelHelpers.export(exports, "NoCellOutlined", ()=>(0, _noCellOutlinedDefault.default));
parcelHelpers.export(exports, "NoCellRounded", ()=>(0, _noCellRoundedDefault.default));
parcelHelpers.export(exports, "NoCellSharp", ()=>(0, _noCellSharpDefault.default));
parcelHelpers.export(exports, "NoCellTwoTone", ()=>(0, _noCellTwoToneDefault.default));
parcelHelpers.export(exports, "NoCrash", ()=>(0, _noCrashDefault.default));
parcelHelpers.export(exports, "NoCrashOutlined", ()=>(0, _noCrashOutlinedDefault.default));
parcelHelpers.export(exports, "NoCrashRounded", ()=>(0, _noCrashRoundedDefault.default));
parcelHelpers.export(exports, "NoCrashSharp", ()=>(0, _noCrashSharpDefault.default));
parcelHelpers.export(exports, "NoCrashTwoTone", ()=>(0, _noCrashTwoToneDefault.default));
parcelHelpers.export(exports, "NoDrinks", ()=>(0, _noDrinksDefault.default));
parcelHelpers.export(exports, "NoDrinksOutlined", ()=>(0, _noDrinksOutlinedDefault.default));
parcelHelpers.export(exports, "NoDrinksRounded", ()=>(0, _noDrinksRoundedDefault.default));
parcelHelpers.export(exports, "NoDrinksSharp", ()=>(0, _noDrinksSharpDefault.default));
parcelHelpers.export(exports, "NoDrinksTwoTone", ()=>(0, _noDrinksTwoToneDefault.default));
parcelHelpers.export(exports, "NoEncryption", ()=>(0, _noEncryptionDefault.default));
parcelHelpers.export(exports, "NoEncryptionGmailerrorred", ()=>(0, _noEncryptionGmailerrorredDefault.default));
parcelHelpers.export(exports, "NoEncryptionGmailerrorredOutlined", ()=>(0, _noEncryptionGmailerrorredOutlinedDefault.default));
parcelHelpers.export(exports, "NoEncryptionGmailerrorredRounded", ()=>(0, _noEncryptionGmailerrorredRoundedDefault.default));
parcelHelpers.export(exports, "NoEncryptionGmailerrorredSharp", ()=>(0, _noEncryptionGmailerrorredSharpDefault.default));
parcelHelpers.export(exports, "NoEncryptionGmailerrorredTwoTone", ()=>(0, _noEncryptionGmailerrorredTwoToneDefault.default));
parcelHelpers.export(exports, "NoEncryptionOutlined", ()=>(0, _noEncryptionOutlinedDefault.default));
parcelHelpers.export(exports, "NoEncryptionRounded", ()=>(0, _noEncryptionRoundedDefault.default));
parcelHelpers.export(exports, "NoEncryptionSharp", ()=>(0, _noEncryptionSharpDefault.default));
parcelHelpers.export(exports, "NoEncryptionTwoTone", ()=>(0, _noEncryptionTwoToneDefault.default));
parcelHelpers.export(exports, "NoFlash", ()=>(0, _noFlashDefault.default));
parcelHelpers.export(exports, "NoFlashOutlined", ()=>(0, _noFlashOutlinedDefault.default));
parcelHelpers.export(exports, "NoFlashRounded", ()=>(0, _noFlashRoundedDefault.default));
parcelHelpers.export(exports, "NoFlashSharp", ()=>(0, _noFlashSharpDefault.default));
parcelHelpers.export(exports, "NoFlashTwoTone", ()=>(0, _noFlashTwoToneDefault.default));
parcelHelpers.export(exports, "NoFood", ()=>(0, _noFoodDefault.default));
parcelHelpers.export(exports, "NoFoodOutlined", ()=>(0, _noFoodOutlinedDefault.default));
parcelHelpers.export(exports, "NoFoodRounded", ()=>(0, _noFoodRoundedDefault.default));
parcelHelpers.export(exports, "NoFoodSharp", ()=>(0, _noFoodSharpDefault.default));
parcelHelpers.export(exports, "NoFoodTwoTone", ()=>(0, _noFoodTwoToneDefault.default));
parcelHelpers.export(exports, "NoLuggage", ()=>(0, _noLuggageDefault.default));
parcelHelpers.export(exports, "NoLuggageOutlined", ()=>(0, _noLuggageOutlinedDefault.default));
parcelHelpers.export(exports, "NoLuggageRounded", ()=>(0, _noLuggageRoundedDefault.default));
parcelHelpers.export(exports, "NoLuggageSharp", ()=>(0, _noLuggageSharpDefault.default));
parcelHelpers.export(exports, "NoLuggageTwoTone", ()=>(0, _noLuggageTwoToneDefault.default));
parcelHelpers.export(exports, "NoMeals", ()=>(0, _noMealsDefault.default));
parcelHelpers.export(exports, "NoMealsOutlined", ()=>(0, _noMealsOutlinedDefault.default));
parcelHelpers.export(exports, "NoMealsRounded", ()=>(0, _noMealsRoundedDefault.default));
parcelHelpers.export(exports, "NoMealsSharp", ()=>(0, _noMealsSharpDefault.default));
parcelHelpers.export(exports, "NoMealsTwoTone", ()=>(0, _noMealsTwoToneDefault.default));
parcelHelpers.export(exports, "NoMeetingRoom", ()=>(0, _noMeetingRoomDefault.default));
parcelHelpers.export(exports, "NoMeetingRoomOutlined", ()=>(0, _noMeetingRoomOutlinedDefault.default));
parcelHelpers.export(exports, "NoMeetingRoomRounded", ()=>(0, _noMeetingRoomRoundedDefault.default));
parcelHelpers.export(exports, "NoMeetingRoomSharp", ()=>(0, _noMeetingRoomSharpDefault.default));
parcelHelpers.export(exports, "NoMeetingRoomTwoTone", ()=>(0, _noMeetingRoomTwoToneDefault.default));
parcelHelpers.export(exports, "NoPhotography", ()=>(0, _noPhotographyDefault.default));
parcelHelpers.export(exports, "NoPhotographyOutlined", ()=>(0, _noPhotographyOutlinedDefault.default));
parcelHelpers.export(exports, "NoPhotographyRounded", ()=>(0, _noPhotographyRoundedDefault.default));
parcelHelpers.export(exports, "NoPhotographySharp", ()=>(0, _noPhotographySharpDefault.default));
parcelHelpers.export(exports, "NoPhotographyTwoTone", ()=>(0, _noPhotographyTwoToneDefault.default));
parcelHelpers.export(exports, "NoSim", ()=>(0, _noSimDefault.default));
parcelHelpers.export(exports, "NoSimOutlined", ()=>(0, _noSimOutlinedDefault.default));
parcelHelpers.export(exports, "NoSimRounded", ()=>(0, _noSimRoundedDefault.default));
parcelHelpers.export(exports, "NoSimSharp", ()=>(0, _noSimSharpDefault.default));
parcelHelpers.export(exports, "NoSimTwoTone", ()=>(0, _noSimTwoToneDefault.default));
parcelHelpers.export(exports, "NoStroller", ()=>(0, _noStrollerDefault.default));
parcelHelpers.export(exports, "NoStrollerOutlined", ()=>(0, _noStrollerOutlinedDefault.default));
parcelHelpers.export(exports, "NoStrollerRounded", ()=>(0, _noStrollerRoundedDefault.default));
parcelHelpers.export(exports, "NoStrollerSharp", ()=>(0, _noStrollerSharpDefault.default));
parcelHelpers.export(exports, "NoStrollerTwoTone", ()=>(0, _noStrollerTwoToneDefault.default));
parcelHelpers.export(exports, "NoTransfer", ()=>(0, _noTransferDefault.default));
parcelHelpers.export(exports, "NoTransferOutlined", ()=>(0, _noTransferOutlinedDefault.default));
parcelHelpers.export(exports, "NoTransferRounded", ()=>(0, _noTransferRoundedDefault.default));
parcelHelpers.export(exports, "NoTransferSharp", ()=>(0, _noTransferSharpDefault.default));
parcelHelpers.export(exports, "NoTransferTwoTone", ()=>(0, _noTransferTwoToneDefault.default));
parcelHelpers.export(exports, "NoiseAware", ()=>(0, _noiseAwareDefault.default));
parcelHelpers.export(exports, "NoiseAwareOutlined", ()=>(0, _noiseAwareOutlinedDefault.default));
parcelHelpers.export(exports, "NoiseAwareRounded", ()=>(0, _noiseAwareRoundedDefault.default));
parcelHelpers.export(exports, "NoiseAwareSharp", ()=>(0, _noiseAwareSharpDefault.default));
parcelHelpers.export(exports, "NoiseAwareTwoTone", ()=>(0, _noiseAwareTwoToneDefault.default));
parcelHelpers.export(exports, "NoiseControlOff", ()=>(0, _noiseControlOffDefault.default));
parcelHelpers.export(exports, "NoiseControlOffOutlined", ()=>(0, _noiseControlOffOutlinedDefault.default));
parcelHelpers.export(exports, "NoiseControlOffRounded", ()=>(0, _noiseControlOffRoundedDefault.default));
parcelHelpers.export(exports, "NoiseControlOffSharp", ()=>(0, _noiseControlOffSharpDefault.default));
parcelHelpers.export(exports, "NoiseControlOffTwoTone", ()=>(0, _noiseControlOffTwoToneDefault.default));
parcelHelpers.export(exports, "NordicWalking", ()=>(0, _nordicWalkingDefault.default));
parcelHelpers.export(exports, "NordicWalkingOutlined", ()=>(0, _nordicWalkingOutlinedDefault.default));
parcelHelpers.export(exports, "NordicWalkingRounded", ()=>(0, _nordicWalkingRoundedDefault.default));
parcelHelpers.export(exports, "NordicWalkingSharp", ()=>(0, _nordicWalkingSharpDefault.default));
parcelHelpers.export(exports, "NordicWalkingTwoTone", ()=>(0, _nordicWalkingTwoToneDefault.default));
parcelHelpers.export(exports, "North", ()=>(0, _northDefault.default));
parcelHelpers.export(exports, "NorthEast", ()=>(0, _northEastDefault.default));
parcelHelpers.export(exports, "NorthEastOutlined", ()=>(0, _northEastOutlinedDefault.default));
parcelHelpers.export(exports, "NorthEastRounded", ()=>(0, _northEastRoundedDefault.default));
parcelHelpers.export(exports, "NorthEastSharp", ()=>(0, _northEastSharpDefault.default));
parcelHelpers.export(exports, "NorthEastTwoTone", ()=>(0, _northEastTwoToneDefault.default));
parcelHelpers.export(exports, "NorthOutlined", ()=>(0, _northOutlinedDefault.default));
parcelHelpers.export(exports, "NorthRounded", ()=>(0, _northRoundedDefault.default));
parcelHelpers.export(exports, "NorthSharp", ()=>(0, _northSharpDefault.default));
parcelHelpers.export(exports, "NorthTwoTone", ()=>(0, _northTwoToneDefault.default));
parcelHelpers.export(exports, "NorthWest", ()=>(0, _northWestDefault.default));
parcelHelpers.export(exports, "NorthWestOutlined", ()=>(0, _northWestOutlinedDefault.default));
parcelHelpers.export(exports, "NorthWestRounded", ()=>(0, _northWestRoundedDefault.default));
parcelHelpers.export(exports, "NorthWestSharp", ()=>(0, _northWestSharpDefault.default));
parcelHelpers.export(exports, "NorthWestTwoTone", ()=>(0, _northWestTwoToneDefault.default));
parcelHelpers.export(exports, "NotAccessible", ()=>(0, _notAccessibleDefault.default));
parcelHelpers.export(exports, "NotAccessibleOutlined", ()=>(0, _notAccessibleOutlinedDefault.default));
parcelHelpers.export(exports, "NotAccessibleRounded", ()=>(0, _notAccessibleRoundedDefault.default));
parcelHelpers.export(exports, "NotAccessibleSharp", ()=>(0, _notAccessibleSharpDefault.default));
parcelHelpers.export(exports, "NotAccessibleTwoTone", ()=>(0, _notAccessibleTwoToneDefault.default));
parcelHelpers.export(exports, "NotInterested", ()=>(0, _notInterestedDefault.default));
parcelHelpers.export(exports, "NotInterestedOutlined", ()=>(0, _notInterestedOutlinedDefault.default));
parcelHelpers.export(exports, "NotInterestedRounded", ()=>(0, _notInterestedRoundedDefault.default));
parcelHelpers.export(exports, "NotInterestedSharp", ()=>(0, _notInterestedSharpDefault.default));
parcelHelpers.export(exports, "NotInterestedTwoTone", ()=>(0, _notInterestedTwoToneDefault.default));
parcelHelpers.export(exports, "NotListedLocation", ()=>(0, _notListedLocationDefault.default));
parcelHelpers.export(exports, "NotListedLocationOutlined", ()=>(0, _notListedLocationOutlinedDefault.default));
parcelHelpers.export(exports, "NotListedLocationRounded", ()=>(0, _notListedLocationRoundedDefault.default));
parcelHelpers.export(exports, "NotListedLocationSharp", ()=>(0, _notListedLocationSharpDefault.default));
parcelHelpers.export(exports, "NotListedLocationTwoTone", ()=>(0, _notListedLocationTwoToneDefault.default));
parcelHelpers.export(exports, "NotStarted", ()=>(0, _notStartedDefault.default));
parcelHelpers.export(exports, "NotStartedOutlined", ()=>(0, _notStartedOutlinedDefault.default));
parcelHelpers.export(exports, "NotStartedRounded", ()=>(0, _notStartedRoundedDefault.default));
parcelHelpers.export(exports, "NotStartedSharp", ()=>(0, _notStartedSharpDefault.default));
parcelHelpers.export(exports, "NotStartedTwoTone", ()=>(0, _notStartedTwoToneDefault.default));
parcelHelpers.export(exports, "Note", ()=>(0, _noteDefault.default));
parcelHelpers.export(exports, "NoteAdd", ()=>(0, _noteAddDefault.default));
parcelHelpers.export(exports, "NoteAddOutlined", ()=>(0, _noteAddOutlinedDefault.default));
parcelHelpers.export(exports, "NoteAddRounded", ()=>(0, _noteAddRoundedDefault.default));
parcelHelpers.export(exports, "NoteAddSharp", ()=>(0, _noteAddSharpDefault.default));
parcelHelpers.export(exports, "NoteAddTwoTone", ()=>(0, _noteAddTwoToneDefault.default));
parcelHelpers.export(exports, "NoteAlt", ()=>(0, _noteAltDefault.default));
parcelHelpers.export(exports, "NoteAltOutlined", ()=>(0, _noteAltOutlinedDefault.default));
parcelHelpers.export(exports, "NoteAltRounded", ()=>(0, _noteAltRoundedDefault.default));
parcelHelpers.export(exports, "NoteAltSharp", ()=>(0, _noteAltSharpDefault.default));
parcelHelpers.export(exports, "NoteAltTwoTone", ()=>(0, _noteAltTwoToneDefault.default));
parcelHelpers.export(exports, "NoteOutlined", ()=>(0, _noteOutlinedDefault.default));
parcelHelpers.export(exports, "NoteRounded", ()=>(0, _noteRoundedDefault.default));
parcelHelpers.export(exports, "NoteSharp", ()=>(0, _noteSharpDefault.default));
parcelHelpers.export(exports, "NoteTwoTone", ()=>(0, _noteTwoToneDefault.default));
parcelHelpers.export(exports, "Notes", ()=>(0, _notesDefault.default));
parcelHelpers.export(exports, "NotesOutlined", ()=>(0, _notesOutlinedDefault.default));
parcelHelpers.export(exports, "NotesRounded", ()=>(0, _notesRoundedDefault.default));
parcelHelpers.export(exports, "NotesSharp", ()=>(0, _notesSharpDefault.default));
parcelHelpers.export(exports, "NotesTwoTone", ()=>(0, _notesTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationAdd", ()=>(0, _notificationAddDefault.default));
parcelHelpers.export(exports, "NotificationAddOutlined", ()=>(0, _notificationAddOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationAddRounded", ()=>(0, _notificationAddRoundedDefault.default));
parcelHelpers.export(exports, "NotificationAddSharp", ()=>(0, _notificationAddSharpDefault.default));
parcelHelpers.export(exports, "NotificationAddTwoTone", ()=>(0, _notificationAddTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationImportant", ()=>(0, _notificationImportantDefault.default));
parcelHelpers.export(exports, "NotificationImportantOutlined", ()=>(0, _notificationImportantOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationImportantRounded", ()=>(0, _notificationImportantRoundedDefault.default));
parcelHelpers.export(exports, "NotificationImportantSharp", ()=>(0, _notificationImportantSharpDefault.default));
parcelHelpers.export(exports, "NotificationImportantTwoTone", ()=>(0, _notificationImportantTwoToneDefault.default));
parcelHelpers.export(exports, "Notifications", ()=>(0, _notificationsDefault.default));
parcelHelpers.export(exports, "NotificationsActive", ()=>(0, _notificationsActiveDefault.default));
parcelHelpers.export(exports, "NotificationsActiveOutlined", ()=>(0, _notificationsActiveOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationsActiveRounded", ()=>(0, _notificationsActiveRoundedDefault.default));
parcelHelpers.export(exports, "NotificationsActiveSharp", ()=>(0, _notificationsActiveSharpDefault.default));
parcelHelpers.export(exports, "NotificationsActiveTwoTone", ()=>(0, _notificationsActiveTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationsNone", ()=>(0, _notificationsNoneDefault.default));
parcelHelpers.export(exports, "NotificationsNoneOutlined", ()=>(0, _notificationsNoneOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationsNoneRounded", ()=>(0, _notificationsNoneRoundedDefault.default));
parcelHelpers.export(exports, "NotificationsNoneSharp", ()=>(0, _notificationsNoneSharpDefault.default));
parcelHelpers.export(exports, "NotificationsNoneTwoTone", ()=>(0, _notificationsNoneTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationsOff", ()=>(0, _notificationsOffDefault.default));
parcelHelpers.export(exports, "NotificationsOffOutlined", ()=>(0, _notificationsOffOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationsOffRounded", ()=>(0, _notificationsOffRoundedDefault.default));
parcelHelpers.export(exports, "NotificationsOffSharp", ()=>(0, _notificationsOffSharpDefault.default));
parcelHelpers.export(exports, "NotificationsOffTwoTone", ()=>(0, _notificationsOffTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationsOutlined", ()=>(0, _notificationsOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationsPaused", ()=>(0, _notificationsPausedDefault.default));
parcelHelpers.export(exports, "NotificationsPausedOutlined", ()=>(0, _notificationsPausedOutlinedDefault.default));
parcelHelpers.export(exports, "NotificationsPausedRounded", ()=>(0, _notificationsPausedRoundedDefault.default));
parcelHelpers.export(exports, "NotificationsPausedSharp", ()=>(0, _notificationsPausedSharpDefault.default));
parcelHelpers.export(exports, "NotificationsPausedTwoTone", ()=>(0, _notificationsPausedTwoToneDefault.default));
parcelHelpers.export(exports, "NotificationsRounded", ()=>(0, _notificationsRoundedDefault.default));
parcelHelpers.export(exports, "NotificationsSharp", ()=>(0, _notificationsSharpDefault.default));
parcelHelpers.export(exports, "NotificationsTwoTone", ()=>(0, _notificationsTwoToneDefault.default));
parcelHelpers.export(exports, "Numbers", ()=>(0, _numbersDefault.default));
parcelHelpers.export(exports, "NumbersOutlined", ()=>(0, _numbersOutlinedDefault.default));
parcelHelpers.export(exports, "NumbersRounded", ()=>(0, _numbersRoundedDefault.default));
parcelHelpers.export(exports, "NumbersSharp", ()=>(0, _numbersSharpDefault.default));
parcelHelpers.export(exports, "NumbersTwoTone", ()=>(0, _numbersTwoToneDefault.default));
parcelHelpers.export(exports, "OfflineBolt", ()=>(0, _offlineBoltDefault.default));
parcelHelpers.export(exports, "OfflineBoltOutlined", ()=>(0, _offlineBoltOutlinedDefault.default));
parcelHelpers.export(exports, "OfflineBoltRounded", ()=>(0, _offlineBoltRoundedDefault.default));
parcelHelpers.export(exports, "OfflineBoltSharp", ()=>(0, _offlineBoltSharpDefault.default));
parcelHelpers.export(exports, "OfflineBoltTwoTone", ()=>(0, _offlineBoltTwoToneDefault.default));
parcelHelpers.export(exports, "OfflinePin", ()=>(0, _offlinePinDefault.default));
parcelHelpers.export(exports, "OfflinePinOutlined", ()=>(0, _offlinePinOutlinedDefault.default));
parcelHelpers.export(exports, "OfflinePinRounded", ()=>(0, _offlinePinRoundedDefault.default));
parcelHelpers.export(exports, "OfflinePinSharp", ()=>(0, _offlinePinSharpDefault.default));
parcelHelpers.export(exports, "OfflinePinTwoTone", ()=>(0, _offlinePinTwoToneDefault.default));
parcelHelpers.export(exports, "OfflineShare", ()=>(0, _offlineShareDefault.default));
parcelHelpers.export(exports, "OfflineShareOutlined", ()=>(0, _offlineShareOutlinedDefault.default));
parcelHelpers.export(exports, "OfflineShareRounded", ()=>(0, _offlineShareRoundedDefault.default));
parcelHelpers.export(exports, "OfflineShareSharp", ()=>(0, _offlineShareSharpDefault.default));
parcelHelpers.export(exports, "OfflineShareTwoTone", ()=>(0, _offlineShareTwoToneDefault.default));
parcelHelpers.export(exports, "OilBarrel", ()=>(0, _oilBarrelDefault.default));
parcelHelpers.export(exports, "OilBarrelOutlined", ()=>(0, _oilBarrelOutlinedDefault.default));
parcelHelpers.export(exports, "OilBarrelRounded", ()=>(0, _oilBarrelRoundedDefault.default));
parcelHelpers.export(exports, "OilBarrelSharp", ()=>(0, _oilBarrelSharpDefault.default));
parcelHelpers.export(exports, "OilBarrelTwoTone", ()=>(0, _oilBarrelTwoToneDefault.default));
parcelHelpers.export(exports, "OnDeviceTraining", ()=>(0, _onDeviceTrainingDefault.default));
parcelHelpers.export(exports, "OnDeviceTrainingOutlined", ()=>(0, _onDeviceTrainingOutlinedDefault.default));
parcelHelpers.export(exports, "OnDeviceTrainingRounded", ()=>(0, _onDeviceTrainingRoundedDefault.default));
parcelHelpers.export(exports, "OnDeviceTrainingSharp", ()=>(0, _onDeviceTrainingSharpDefault.default));
parcelHelpers.export(exports, "OnDeviceTrainingTwoTone", ()=>(0, _onDeviceTrainingTwoToneDefault.default));
parcelHelpers.export(exports, "OndemandVideo", ()=>(0, _ondemandVideoDefault.default));
parcelHelpers.export(exports, "OndemandVideoOutlined", ()=>(0, _ondemandVideoOutlinedDefault.default));
parcelHelpers.export(exports, "OndemandVideoRounded", ()=>(0, _ondemandVideoRoundedDefault.default));
parcelHelpers.export(exports, "OndemandVideoSharp", ()=>(0, _ondemandVideoSharpDefault.default));
parcelHelpers.export(exports, "OndemandVideoTwoTone", ()=>(0, _ondemandVideoTwoToneDefault.default));
parcelHelpers.export(exports, "OneK", ()=>(0, _oneKDefault.default));
parcelHelpers.export(exports, "OneKOutlined", ()=>(0, _oneKOutlinedDefault.default));
parcelHelpers.export(exports, "OneKPlus", ()=>(0, _oneKPlusDefault.default));
parcelHelpers.export(exports, "OneKPlusOutlined", ()=>(0, _oneKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "OneKPlusRounded", ()=>(0, _oneKPlusRoundedDefault.default));
parcelHelpers.export(exports, "OneKPlusSharp", ()=>(0, _oneKPlusSharpDefault.default));
parcelHelpers.export(exports, "OneKPlusTwoTone", ()=>(0, _oneKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "OneKRounded", ()=>(0, _oneKRoundedDefault.default));
parcelHelpers.export(exports, "OneKSharp", ()=>(0, _oneKSharpDefault.default));
parcelHelpers.export(exports, "OneKTwoTone", ()=>(0, _oneKTwoToneDefault.default));
parcelHelpers.export(exports, "OneKk", ()=>(0, _oneKkDefault.default));
parcelHelpers.export(exports, "OneKkOutlined", ()=>(0, _oneKkOutlinedDefault.default));
parcelHelpers.export(exports, "OneKkRounded", ()=>(0, _oneKkRoundedDefault.default));
parcelHelpers.export(exports, "OneKkSharp", ()=>(0, _oneKkSharpDefault.default));
parcelHelpers.export(exports, "OneKkTwoTone", ()=>(0, _oneKkTwoToneDefault.default));
parcelHelpers.export(exports, "OnlinePrediction", ()=>(0, _onlinePredictionDefault.default));
parcelHelpers.export(exports, "OnlinePredictionOutlined", ()=>(0, _onlinePredictionOutlinedDefault.default));
parcelHelpers.export(exports, "OnlinePredictionRounded", ()=>(0, _onlinePredictionRoundedDefault.default));
parcelHelpers.export(exports, "OnlinePredictionSharp", ()=>(0, _onlinePredictionSharpDefault.default));
parcelHelpers.export(exports, "OnlinePredictionTwoTone", ()=>(0, _onlinePredictionTwoToneDefault.default));
parcelHelpers.export(exports, "Opacity", ()=>(0, _opacityDefault.default));
parcelHelpers.export(exports, "OpacityOutlined", ()=>(0, _opacityOutlinedDefault.default));
parcelHelpers.export(exports, "OpacityRounded", ()=>(0, _opacityRoundedDefault.default));
parcelHelpers.export(exports, "OpacitySharp", ()=>(0, _opacitySharpDefault.default));
parcelHelpers.export(exports, "OpacityTwoTone", ()=>(0, _opacityTwoToneDefault.default));
parcelHelpers.export(exports, "OpenInBrowser", ()=>(0, _openInBrowserDefault.default));
parcelHelpers.export(exports, "OpenInBrowserOutlined", ()=>(0, _openInBrowserOutlinedDefault.default));
parcelHelpers.export(exports, "OpenInBrowserRounded", ()=>(0, _openInBrowserRoundedDefault.default));
parcelHelpers.export(exports, "OpenInBrowserSharp", ()=>(0, _openInBrowserSharpDefault.default));
parcelHelpers.export(exports, "OpenInBrowserTwoTone", ()=>(0, _openInBrowserTwoToneDefault.default));
parcelHelpers.export(exports, "OpenInFull", ()=>(0, _openInFullDefault.default));
parcelHelpers.export(exports, "OpenInFullOutlined", ()=>(0, _openInFullOutlinedDefault.default));
parcelHelpers.export(exports, "OpenInFullRounded", ()=>(0, _openInFullRoundedDefault.default));
parcelHelpers.export(exports, "OpenInFullSharp", ()=>(0, _openInFullSharpDefault.default));
parcelHelpers.export(exports, "OpenInFullTwoTone", ()=>(0, _openInFullTwoToneDefault.default));
parcelHelpers.export(exports, "OpenInNew", ()=>(0, _openInNewDefault.default));
parcelHelpers.export(exports, "OpenInNewOff", ()=>(0, _openInNewOffDefault.default));
parcelHelpers.export(exports, "OpenInNewOffOutlined", ()=>(0, _openInNewOffOutlinedDefault.default));
parcelHelpers.export(exports, "OpenInNewOffRounded", ()=>(0, _openInNewOffRoundedDefault.default));
parcelHelpers.export(exports, "OpenInNewOffSharp", ()=>(0, _openInNewOffSharpDefault.default));
parcelHelpers.export(exports, "OpenInNewOffTwoTone", ()=>(0, _openInNewOffTwoToneDefault.default));
parcelHelpers.export(exports, "OpenInNewOutlined", ()=>(0, _openInNewOutlinedDefault.default));
parcelHelpers.export(exports, "OpenInNewRounded", ()=>(0, _openInNewRoundedDefault.default));
parcelHelpers.export(exports, "OpenInNewSharp", ()=>(0, _openInNewSharpDefault.default));
parcelHelpers.export(exports, "OpenInNewTwoTone", ()=>(0, _openInNewTwoToneDefault.default));
parcelHelpers.export(exports, "OpenWith", ()=>(0, _openWithDefault.default));
parcelHelpers.export(exports, "OpenWithOutlined", ()=>(0, _openWithOutlinedDefault.default));
parcelHelpers.export(exports, "OpenWithRounded", ()=>(0, _openWithRoundedDefault.default));
parcelHelpers.export(exports, "OpenWithSharp", ()=>(0, _openWithSharpDefault.default));
parcelHelpers.export(exports, "OpenWithTwoTone", ()=>(0, _openWithTwoToneDefault.default));
parcelHelpers.export(exports, "OtherHouses", ()=>(0, _otherHousesDefault.default));
parcelHelpers.export(exports, "OtherHousesOutlined", ()=>(0, _otherHousesOutlinedDefault.default));
parcelHelpers.export(exports, "OtherHousesRounded", ()=>(0, _otherHousesRoundedDefault.default));
parcelHelpers.export(exports, "OtherHousesSharp", ()=>(0, _otherHousesSharpDefault.default));
parcelHelpers.export(exports, "OtherHousesTwoTone", ()=>(0, _otherHousesTwoToneDefault.default));
parcelHelpers.export(exports, "Outbound", ()=>(0, _outboundDefault.default));
parcelHelpers.export(exports, "OutboundOutlined", ()=>(0, _outboundOutlinedDefault.default));
parcelHelpers.export(exports, "OutboundRounded", ()=>(0, _outboundRoundedDefault.default));
parcelHelpers.export(exports, "OutboundSharp", ()=>(0, _outboundSharpDefault.default));
parcelHelpers.export(exports, "OutboundTwoTone", ()=>(0, _outboundTwoToneDefault.default));
parcelHelpers.export(exports, "Outbox", ()=>(0, _outboxDefault.default));
parcelHelpers.export(exports, "OutboxOutlined", ()=>(0, _outboxOutlinedDefault.default));
parcelHelpers.export(exports, "OutboxRounded", ()=>(0, _outboxRoundedDefault.default));
parcelHelpers.export(exports, "OutboxSharp", ()=>(0, _outboxSharpDefault.default));
parcelHelpers.export(exports, "OutboxTwoTone", ()=>(0, _outboxTwoToneDefault.default));
parcelHelpers.export(exports, "OutdoorGrill", ()=>(0, _outdoorGrillDefault.default));
parcelHelpers.export(exports, "OutdoorGrillOutlined", ()=>(0, _outdoorGrillOutlinedDefault.default));
parcelHelpers.export(exports, "OutdoorGrillRounded", ()=>(0, _outdoorGrillRoundedDefault.default));
parcelHelpers.export(exports, "OutdoorGrillSharp", ()=>(0, _outdoorGrillSharpDefault.default));
parcelHelpers.export(exports, "OutdoorGrillTwoTone", ()=>(0, _outdoorGrillTwoToneDefault.default));
parcelHelpers.export(exports, "Outlet", ()=>(0, _outletDefault.default));
parcelHelpers.export(exports, "OutletOutlined", ()=>(0, _outletOutlinedDefault.default));
parcelHelpers.export(exports, "OutletRounded", ()=>(0, _outletRoundedDefault.default));
parcelHelpers.export(exports, "OutletSharp", ()=>(0, _outletSharpDefault.default));
parcelHelpers.export(exports, "OutletTwoTone", ()=>(0, _outletTwoToneDefault.default));
parcelHelpers.export(exports, "OutlinedFlag", ()=>(0, _outlinedFlagDefault.default));
parcelHelpers.export(exports, "OutlinedFlagOutlined", ()=>(0, _outlinedFlagOutlinedDefault.default));
parcelHelpers.export(exports, "OutlinedFlagRounded", ()=>(0, _outlinedFlagRoundedDefault.default));
parcelHelpers.export(exports, "OutlinedFlagSharp", ()=>(0, _outlinedFlagSharpDefault.default));
parcelHelpers.export(exports, "OutlinedFlagTwoTone", ()=>(0, _outlinedFlagTwoToneDefault.default));
parcelHelpers.export(exports, "Output", ()=>(0, _outputDefault.default));
parcelHelpers.export(exports, "OutputOutlined", ()=>(0, _outputOutlinedDefault.default));
parcelHelpers.export(exports, "OutputRounded", ()=>(0, _outputRoundedDefault.default));
parcelHelpers.export(exports, "OutputSharp", ()=>(0, _outputSharpDefault.default));
parcelHelpers.export(exports, "OutputTwoTone", ()=>(0, _outputTwoToneDefault.default));
parcelHelpers.export(exports, "Padding", ()=>(0, _paddingDefault.default));
parcelHelpers.export(exports, "PaddingOutlined", ()=>(0, _paddingOutlinedDefault.default));
parcelHelpers.export(exports, "PaddingRounded", ()=>(0, _paddingRoundedDefault.default));
parcelHelpers.export(exports, "PaddingSharp", ()=>(0, _paddingSharpDefault.default));
parcelHelpers.export(exports, "PaddingTwoTone", ()=>(0, _paddingTwoToneDefault.default));
parcelHelpers.export(exports, "Pages", ()=>(0, _pagesDefault.default));
parcelHelpers.export(exports, "PagesOutlined", ()=>(0, _pagesOutlinedDefault.default));
parcelHelpers.export(exports, "PagesRounded", ()=>(0, _pagesRoundedDefault.default));
parcelHelpers.export(exports, "PagesSharp", ()=>(0, _pagesSharpDefault.default));
parcelHelpers.export(exports, "PagesTwoTone", ()=>(0, _pagesTwoToneDefault.default));
parcelHelpers.export(exports, "Pageview", ()=>(0, _pageviewDefault.default));
parcelHelpers.export(exports, "PageviewOutlined", ()=>(0, _pageviewOutlinedDefault.default));
parcelHelpers.export(exports, "PageviewRounded", ()=>(0, _pageviewRoundedDefault.default));
parcelHelpers.export(exports, "PageviewSharp", ()=>(0, _pageviewSharpDefault.default));
parcelHelpers.export(exports, "PageviewTwoTone", ()=>(0, _pageviewTwoToneDefault.default));
parcelHelpers.export(exports, "Paid", ()=>(0, _paidDefault.default));
parcelHelpers.export(exports, "PaidOutlined", ()=>(0, _paidOutlinedDefault.default));
parcelHelpers.export(exports, "PaidRounded", ()=>(0, _paidRoundedDefault.default));
parcelHelpers.export(exports, "PaidSharp", ()=>(0, _paidSharpDefault.default));
parcelHelpers.export(exports, "PaidTwoTone", ()=>(0, _paidTwoToneDefault.default));
parcelHelpers.export(exports, "Palette", ()=>(0, _paletteDefault.default));
parcelHelpers.export(exports, "PaletteOutlined", ()=>(0, _paletteOutlinedDefault.default));
parcelHelpers.export(exports, "PaletteRounded", ()=>(0, _paletteRoundedDefault.default));
parcelHelpers.export(exports, "PaletteSharp", ()=>(0, _paletteSharpDefault.default));
parcelHelpers.export(exports, "PaletteTwoTone", ()=>(0, _paletteTwoToneDefault.default));
parcelHelpers.export(exports, "PanTool", ()=>(0, _panToolDefault.default));
parcelHelpers.export(exports, "PanToolAlt", ()=>(0, _panToolAltDefault.default));
parcelHelpers.export(exports, "PanToolAltOutlined", ()=>(0, _panToolAltOutlinedDefault.default));
parcelHelpers.export(exports, "PanToolAltRounded", ()=>(0, _panToolAltRoundedDefault.default));
parcelHelpers.export(exports, "PanToolAltSharp", ()=>(0, _panToolAltSharpDefault.default));
parcelHelpers.export(exports, "PanToolAltTwoTone", ()=>(0, _panToolAltTwoToneDefault.default));
parcelHelpers.export(exports, "PanToolOutlined", ()=>(0, _panToolOutlinedDefault.default));
parcelHelpers.export(exports, "PanToolRounded", ()=>(0, _panToolRoundedDefault.default));
parcelHelpers.export(exports, "PanToolSharp", ()=>(0, _panToolSharpDefault.default));
parcelHelpers.export(exports, "PanToolTwoTone", ()=>(0, _panToolTwoToneDefault.default));
parcelHelpers.export(exports, "Panorama", ()=>(0, _panoramaDefault.default));
parcelHelpers.export(exports, "PanoramaFishEye", ()=>(0, _panoramaFishEyeDefault.default));
parcelHelpers.export(exports, "PanoramaFishEyeOutlined", ()=>(0, _panoramaFishEyeOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaFishEyeRounded", ()=>(0, _panoramaFishEyeRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaFishEyeSharp", ()=>(0, _panoramaFishEyeSharpDefault.default));
parcelHelpers.export(exports, "PanoramaFishEyeTwoTone", ()=>(0, _panoramaFishEyeTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontal", ()=>(0, _panoramaHorizontalDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalOutlined", ()=>(0, _panoramaHorizontalOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalRounded", ()=>(0, _panoramaHorizontalRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSelect", ()=>(0, _panoramaHorizontalSelectDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSelectOutlined", ()=>(0, _panoramaHorizontalSelectOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSelectRounded", ()=>(0, _panoramaHorizontalSelectRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSelectSharp", ()=>(0, _panoramaHorizontalSelectSharpDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSelectTwoTone", ()=>(0, _panoramaHorizontalSelectTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalSharp", ()=>(0, _panoramaHorizontalSharpDefault.default));
parcelHelpers.export(exports, "PanoramaHorizontalTwoTone", ()=>(0, _panoramaHorizontalTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaOutlined", ()=>(0, _panoramaOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphere", ()=>(0, _panoramaPhotosphereDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereOutlined", ()=>(0, _panoramaPhotosphereOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereRounded", ()=>(0, _panoramaPhotosphereRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSelect", ()=>(0, _panoramaPhotosphereSelectDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSelectOutlined", ()=>(0, _panoramaPhotosphereSelectOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSelectRounded", ()=>(0, _panoramaPhotosphereSelectRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSelectSharp", ()=>(0, _panoramaPhotosphereSelectSharpDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSelectTwoTone", ()=>(0, _panoramaPhotosphereSelectTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereSharp", ()=>(0, _panoramaPhotosphereSharpDefault.default));
parcelHelpers.export(exports, "PanoramaPhotosphereTwoTone", ()=>(0, _panoramaPhotosphereTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaRounded", ()=>(0, _panoramaRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaSharp", ()=>(0, _panoramaSharpDefault.default));
parcelHelpers.export(exports, "PanoramaTwoTone", ()=>(0, _panoramaTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaVertical", ()=>(0, _panoramaVerticalDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalOutlined", ()=>(0, _panoramaVerticalOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalRounded", ()=>(0, _panoramaVerticalRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSelect", ()=>(0, _panoramaVerticalSelectDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSelectOutlined", ()=>(0, _panoramaVerticalSelectOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSelectRounded", ()=>(0, _panoramaVerticalSelectRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSelectSharp", ()=>(0, _panoramaVerticalSelectSharpDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSelectTwoTone", ()=>(0, _panoramaVerticalSelectTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalSharp", ()=>(0, _panoramaVerticalSharpDefault.default));
parcelHelpers.export(exports, "PanoramaVerticalTwoTone", ()=>(0, _panoramaVerticalTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngle", ()=>(0, _panoramaWideAngleDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleOutlined", ()=>(0, _panoramaWideAngleOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleRounded", ()=>(0, _panoramaWideAngleRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSelect", ()=>(0, _panoramaWideAngleSelectDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSelectOutlined", ()=>(0, _panoramaWideAngleSelectOutlinedDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSelectRounded", ()=>(0, _panoramaWideAngleSelectRoundedDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSelectSharp", ()=>(0, _panoramaWideAngleSelectSharpDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSelectTwoTone", ()=>(0, _panoramaWideAngleSelectTwoToneDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleSharp", ()=>(0, _panoramaWideAngleSharpDefault.default));
parcelHelpers.export(exports, "PanoramaWideAngleTwoTone", ()=>(0, _panoramaWideAngleTwoToneDefault.default));
parcelHelpers.export(exports, "Paragliding", ()=>(0, _paraglidingDefault.default));
parcelHelpers.export(exports, "ParaglidingOutlined", ()=>(0, _paraglidingOutlinedDefault.default));
parcelHelpers.export(exports, "ParaglidingRounded", ()=>(0, _paraglidingRoundedDefault.default));
parcelHelpers.export(exports, "ParaglidingSharp", ()=>(0, _paraglidingSharpDefault.default));
parcelHelpers.export(exports, "ParaglidingTwoTone", ()=>(0, _paraglidingTwoToneDefault.default));
parcelHelpers.export(exports, "Park", ()=>(0, _parkDefault.default));
parcelHelpers.export(exports, "ParkOutlined", ()=>(0, _parkOutlinedDefault.default));
parcelHelpers.export(exports, "ParkRounded", ()=>(0, _parkRoundedDefault.default));
parcelHelpers.export(exports, "ParkSharp", ()=>(0, _parkSharpDefault.default));
parcelHelpers.export(exports, "ParkTwoTone", ()=>(0, _parkTwoToneDefault.default));
parcelHelpers.export(exports, "PartyMode", ()=>(0, _partyModeDefault.default));
parcelHelpers.export(exports, "PartyModeOutlined", ()=>(0, _partyModeOutlinedDefault.default));
parcelHelpers.export(exports, "PartyModeRounded", ()=>(0, _partyModeRoundedDefault.default));
parcelHelpers.export(exports, "PartyModeSharp", ()=>(0, _partyModeSharpDefault.default));
parcelHelpers.export(exports, "PartyModeTwoTone", ()=>(0, _partyModeTwoToneDefault.default));
parcelHelpers.export(exports, "Password", ()=>(0, _passwordDefault.default));
parcelHelpers.export(exports, "PasswordOutlined", ()=>(0, _passwordOutlinedDefault.default));
parcelHelpers.export(exports, "PasswordRounded", ()=>(0, _passwordRoundedDefault.default));
parcelHelpers.export(exports, "PasswordSharp", ()=>(0, _passwordSharpDefault.default));
parcelHelpers.export(exports, "PasswordTwoTone", ()=>(0, _passwordTwoToneDefault.default));
parcelHelpers.export(exports, "Pattern", ()=>(0, _patternDefault.default));
parcelHelpers.export(exports, "PatternOutlined", ()=>(0, _patternOutlinedDefault.default));
parcelHelpers.export(exports, "PatternRounded", ()=>(0, _patternRoundedDefault.default));
parcelHelpers.export(exports, "PatternSharp", ()=>(0, _patternSharpDefault.default));
parcelHelpers.export(exports, "PatternTwoTone", ()=>(0, _patternTwoToneDefault.default));
parcelHelpers.export(exports, "Pause", ()=>(0, _pauseDefault.default));
parcelHelpers.export(exports, "PauseCircle", ()=>(0, _pauseCircleDefault.default));
parcelHelpers.export(exports, "PauseCircleFilled", ()=>(0, _pauseCircleFilledDefault.default));
parcelHelpers.export(exports, "PauseCircleFilledOutlined", ()=>(0, _pauseCircleFilledOutlinedDefault.default));
parcelHelpers.export(exports, "PauseCircleFilledRounded", ()=>(0, _pauseCircleFilledRoundedDefault.default));
parcelHelpers.export(exports, "PauseCircleFilledSharp", ()=>(0, _pauseCircleFilledSharpDefault.default));
parcelHelpers.export(exports, "PauseCircleFilledTwoTone", ()=>(0, _pauseCircleFilledTwoToneDefault.default));
parcelHelpers.export(exports, "PauseCircleOutline", ()=>(0, _pauseCircleOutlineDefault.default));
parcelHelpers.export(exports, "PauseCircleOutlineOutlined", ()=>(0, _pauseCircleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "PauseCircleOutlineRounded", ()=>(0, _pauseCircleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "PauseCircleOutlineSharp", ()=>(0, _pauseCircleOutlineSharpDefault.default));
parcelHelpers.export(exports, "PauseCircleOutlineTwoTone", ()=>(0, _pauseCircleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "PauseCircleOutlined", ()=>(0, _pauseCircleOutlinedDefault.default));
parcelHelpers.export(exports, "PauseCircleRounded", ()=>(0, _pauseCircleRoundedDefault.default));
parcelHelpers.export(exports, "PauseCircleSharp", ()=>(0, _pauseCircleSharpDefault.default));
parcelHelpers.export(exports, "PauseCircleTwoTone", ()=>(0, _pauseCircleTwoToneDefault.default));
parcelHelpers.export(exports, "PauseOutlined", ()=>(0, _pauseOutlinedDefault.default));
parcelHelpers.export(exports, "PausePresentation", ()=>(0, _pausePresentationDefault.default));
parcelHelpers.export(exports, "PausePresentationOutlined", ()=>(0, _pausePresentationOutlinedDefault.default));
parcelHelpers.export(exports, "PausePresentationRounded", ()=>(0, _pausePresentationRoundedDefault.default));
parcelHelpers.export(exports, "PausePresentationSharp", ()=>(0, _pausePresentationSharpDefault.default));
parcelHelpers.export(exports, "PausePresentationTwoTone", ()=>(0, _pausePresentationTwoToneDefault.default));
parcelHelpers.export(exports, "PauseRounded", ()=>(0, _pauseRoundedDefault.default));
parcelHelpers.export(exports, "PauseSharp", ()=>(0, _pauseSharpDefault.default));
parcelHelpers.export(exports, "PauseTwoTone", ()=>(0, _pauseTwoToneDefault.default));
parcelHelpers.export(exports, "Payment", ()=>(0, _paymentDefault.default));
parcelHelpers.export(exports, "PaymentOutlined", ()=>(0, _paymentOutlinedDefault.default));
parcelHelpers.export(exports, "PaymentRounded", ()=>(0, _paymentRoundedDefault.default));
parcelHelpers.export(exports, "PaymentSharp", ()=>(0, _paymentSharpDefault.default));
parcelHelpers.export(exports, "PaymentTwoTone", ()=>(0, _paymentTwoToneDefault.default));
parcelHelpers.export(exports, "Payments", ()=>(0, _paymentsDefault.default));
parcelHelpers.export(exports, "PaymentsOutlined", ()=>(0, _paymentsOutlinedDefault.default));
parcelHelpers.export(exports, "PaymentsRounded", ()=>(0, _paymentsRoundedDefault.default));
parcelHelpers.export(exports, "PaymentsSharp", ()=>(0, _paymentsSharpDefault.default));
parcelHelpers.export(exports, "PaymentsTwoTone", ()=>(0, _paymentsTwoToneDefault.default));
parcelHelpers.export(exports, "PedalBike", ()=>(0, _pedalBikeDefault.default));
parcelHelpers.export(exports, "PedalBikeOutlined", ()=>(0, _pedalBikeOutlinedDefault.default));
parcelHelpers.export(exports, "PedalBikeRounded", ()=>(0, _pedalBikeRoundedDefault.default));
parcelHelpers.export(exports, "PedalBikeSharp", ()=>(0, _pedalBikeSharpDefault.default));
parcelHelpers.export(exports, "PedalBikeTwoTone", ()=>(0, _pedalBikeTwoToneDefault.default));
parcelHelpers.export(exports, "Pending", ()=>(0, _pendingDefault.default));
parcelHelpers.export(exports, "PendingActions", ()=>(0, _pendingActionsDefault.default));
parcelHelpers.export(exports, "PendingActionsOutlined", ()=>(0, _pendingActionsOutlinedDefault.default));
parcelHelpers.export(exports, "PendingActionsRounded", ()=>(0, _pendingActionsRoundedDefault.default));
parcelHelpers.export(exports, "PendingActionsSharp", ()=>(0, _pendingActionsSharpDefault.default));
parcelHelpers.export(exports, "PendingActionsTwoTone", ()=>(0, _pendingActionsTwoToneDefault.default));
parcelHelpers.export(exports, "PendingOutlined", ()=>(0, _pendingOutlinedDefault.default));
parcelHelpers.export(exports, "PendingRounded", ()=>(0, _pendingRoundedDefault.default));
parcelHelpers.export(exports, "PendingSharp", ()=>(0, _pendingSharpDefault.default));
parcelHelpers.export(exports, "PendingTwoTone", ()=>(0, _pendingTwoToneDefault.default));
parcelHelpers.export(exports, "Pentagon", ()=>(0, _pentagonDefault.default));
parcelHelpers.export(exports, "PentagonOutlined", ()=>(0, _pentagonOutlinedDefault.default));
parcelHelpers.export(exports, "PentagonRounded", ()=>(0, _pentagonRoundedDefault.default));
parcelHelpers.export(exports, "PentagonSharp", ()=>(0, _pentagonSharpDefault.default));
parcelHelpers.export(exports, "PentagonTwoTone", ()=>(0, _pentagonTwoToneDefault.default));
parcelHelpers.export(exports, "People", ()=>(0, _peopleDefault.default));
parcelHelpers.export(exports, "PeopleAlt", ()=>(0, _peopleAltDefault.default));
parcelHelpers.export(exports, "PeopleAltOutlined", ()=>(0, _peopleAltOutlinedDefault.default));
parcelHelpers.export(exports, "PeopleAltRounded", ()=>(0, _peopleAltRoundedDefault.default));
parcelHelpers.export(exports, "PeopleAltSharp", ()=>(0, _peopleAltSharpDefault.default));
parcelHelpers.export(exports, "PeopleAltTwoTone", ()=>(0, _peopleAltTwoToneDefault.default));
parcelHelpers.export(exports, "PeopleOutline", ()=>(0, _peopleOutlineDefault.default));
parcelHelpers.export(exports, "PeopleOutlineOutlined", ()=>(0, _peopleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "PeopleOutlineRounded", ()=>(0, _peopleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "PeopleOutlineSharp", ()=>(0, _peopleOutlineSharpDefault.default));
parcelHelpers.export(exports, "PeopleOutlineTwoTone", ()=>(0, _peopleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "PeopleOutlined", ()=>(0, _peopleOutlinedDefault.default));
parcelHelpers.export(exports, "PeopleRounded", ()=>(0, _peopleRoundedDefault.default));
parcelHelpers.export(exports, "PeopleSharp", ()=>(0, _peopleSharpDefault.default));
parcelHelpers.export(exports, "PeopleTwoTone", ()=>(0, _peopleTwoToneDefault.default));
parcelHelpers.export(exports, "Percent", ()=>(0, _percentDefault.default));
parcelHelpers.export(exports, "PercentOutlined", ()=>(0, _percentOutlinedDefault.default));
parcelHelpers.export(exports, "PercentRounded", ()=>(0, _percentRoundedDefault.default));
parcelHelpers.export(exports, "PercentSharp", ()=>(0, _percentSharpDefault.default));
parcelHelpers.export(exports, "PercentTwoTone", ()=>(0, _percentTwoToneDefault.default));
parcelHelpers.export(exports, "PermCameraMic", ()=>(0, _permCameraMicDefault.default));
parcelHelpers.export(exports, "PermCameraMicOutlined", ()=>(0, _permCameraMicOutlinedDefault.default));
parcelHelpers.export(exports, "PermCameraMicRounded", ()=>(0, _permCameraMicRoundedDefault.default));
parcelHelpers.export(exports, "PermCameraMicSharp", ()=>(0, _permCameraMicSharpDefault.default));
parcelHelpers.export(exports, "PermCameraMicTwoTone", ()=>(0, _permCameraMicTwoToneDefault.default));
parcelHelpers.export(exports, "PermContactCalendar", ()=>(0, _permContactCalendarDefault.default));
parcelHelpers.export(exports, "PermContactCalendarOutlined", ()=>(0, _permContactCalendarOutlinedDefault.default));
parcelHelpers.export(exports, "PermContactCalendarRounded", ()=>(0, _permContactCalendarRoundedDefault.default));
parcelHelpers.export(exports, "PermContactCalendarSharp", ()=>(0, _permContactCalendarSharpDefault.default));
parcelHelpers.export(exports, "PermContactCalendarTwoTone", ()=>(0, _permContactCalendarTwoToneDefault.default));
parcelHelpers.export(exports, "PermDataSetting", ()=>(0, _permDataSettingDefault.default));
parcelHelpers.export(exports, "PermDataSettingOutlined", ()=>(0, _permDataSettingOutlinedDefault.default));
parcelHelpers.export(exports, "PermDataSettingRounded", ()=>(0, _permDataSettingRoundedDefault.default));
parcelHelpers.export(exports, "PermDataSettingSharp", ()=>(0, _permDataSettingSharpDefault.default));
parcelHelpers.export(exports, "PermDataSettingTwoTone", ()=>(0, _permDataSettingTwoToneDefault.default));
parcelHelpers.export(exports, "PermDeviceInformation", ()=>(0, _permDeviceInformationDefault.default));
parcelHelpers.export(exports, "PermDeviceInformationOutlined", ()=>(0, _permDeviceInformationOutlinedDefault.default));
parcelHelpers.export(exports, "PermDeviceInformationRounded", ()=>(0, _permDeviceInformationRoundedDefault.default));
parcelHelpers.export(exports, "PermDeviceInformationSharp", ()=>(0, _permDeviceInformationSharpDefault.default));
parcelHelpers.export(exports, "PermDeviceInformationTwoTone", ()=>(0, _permDeviceInformationTwoToneDefault.default));
parcelHelpers.export(exports, "PermIdentity", ()=>(0, _permIdentityDefault.default));
parcelHelpers.export(exports, "PermIdentityOutlined", ()=>(0, _permIdentityOutlinedDefault.default));
parcelHelpers.export(exports, "PermIdentityRounded", ()=>(0, _permIdentityRoundedDefault.default));
parcelHelpers.export(exports, "PermIdentitySharp", ()=>(0, _permIdentitySharpDefault.default));
parcelHelpers.export(exports, "PermIdentityTwoTone", ()=>(0, _permIdentityTwoToneDefault.default));
parcelHelpers.export(exports, "PermMedia", ()=>(0, _permMediaDefault.default));
parcelHelpers.export(exports, "PermMediaOutlined", ()=>(0, _permMediaOutlinedDefault.default));
parcelHelpers.export(exports, "PermMediaRounded", ()=>(0, _permMediaRoundedDefault.default));
parcelHelpers.export(exports, "PermMediaSharp", ()=>(0, _permMediaSharpDefault.default));
parcelHelpers.export(exports, "PermMediaTwoTone", ()=>(0, _permMediaTwoToneDefault.default));
parcelHelpers.export(exports, "PermPhoneMsg", ()=>(0, _permPhoneMsgDefault.default));
parcelHelpers.export(exports, "PermPhoneMsgOutlined", ()=>(0, _permPhoneMsgOutlinedDefault.default));
parcelHelpers.export(exports, "PermPhoneMsgRounded", ()=>(0, _permPhoneMsgRoundedDefault.default));
parcelHelpers.export(exports, "PermPhoneMsgSharp", ()=>(0, _permPhoneMsgSharpDefault.default));
parcelHelpers.export(exports, "PermPhoneMsgTwoTone", ()=>(0, _permPhoneMsgTwoToneDefault.default));
parcelHelpers.export(exports, "PermScanWifi", ()=>(0, _permScanWifiDefault.default));
parcelHelpers.export(exports, "PermScanWifiOutlined", ()=>(0, _permScanWifiOutlinedDefault.default));
parcelHelpers.export(exports, "PermScanWifiRounded", ()=>(0, _permScanWifiRoundedDefault.default));
parcelHelpers.export(exports, "PermScanWifiSharp", ()=>(0, _permScanWifiSharpDefault.default));
parcelHelpers.export(exports, "PermScanWifiTwoTone", ()=>(0, _permScanWifiTwoToneDefault.default));
parcelHelpers.export(exports, "Person", ()=>(0, _personDefault.default));
parcelHelpers.export(exports, "Person2", ()=>(0, _person2Default.default));
parcelHelpers.export(exports, "Person2Outlined", ()=>(0, _person2OutlinedDefault.default));
parcelHelpers.export(exports, "Person2Rounded", ()=>(0, _person2RoundedDefault.default));
parcelHelpers.export(exports, "Person2Sharp", ()=>(0, _person2SharpDefault.default));
parcelHelpers.export(exports, "Person2TwoTone", ()=>(0, _person2TwoToneDefault.default));
parcelHelpers.export(exports, "Person3", ()=>(0, _person3Default.default));
parcelHelpers.export(exports, "Person3Outlined", ()=>(0, _person3OutlinedDefault.default));
parcelHelpers.export(exports, "Person3Rounded", ()=>(0, _person3RoundedDefault.default));
parcelHelpers.export(exports, "Person3Sharp", ()=>(0, _person3SharpDefault.default));
parcelHelpers.export(exports, "Person3TwoTone", ()=>(0, _person3TwoToneDefault.default));
parcelHelpers.export(exports, "Person4", ()=>(0, _person4Default.default));
parcelHelpers.export(exports, "Person4Outlined", ()=>(0, _person4OutlinedDefault.default));
parcelHelpers.export(exports, "Person4Rounded", ()=>(0, _person4RoundedDefault.default));
parcelHelpers.export(exports, "Person4Sharp", ()=>(0, _person4SharpDefault.default));
parcelHelpers.export(exports, "Person4TwoTone", ()=>(0, _person4TwoToneDefault.default));
parcelHelpers.export(exports, "PersonAdd", ()=>(0, _personAddDefault.default));
parcelHelpers.export(exports, "PersonAddAlt", ()=>(0, _personAddAltDefault.default));
parcelHelpers.export(exports, "PersonAddAlt1", ()=>(0, _personAddAlt1Default.default));
parcelHelpers.export(exports, "PersonAddAlt1Outlined", ()=>(0, _personAddAlt1OutlinedDefault.default));
parcelHelpers.export(exports, "PersonAddAlt1Rounded", ()=>(0, _personAddAlt1RoundedDefault.default));
parcelHelpers.export(exports, "PersonAddAlt1Sharp", ()=>(0, _personAddAlt1SharpDefault.default));
parcelHelpers.export(exports, "PersonAddAlt1TwoTone", ()=>(0, _personAddAlt1TwoToneDefault.default));
parcelHelpers.export(exports, "PersonAddAltOutlined", ()=>(0, _personAddAltOutlinedDefault.default));
parcelHelpers.export(exports, "PersonAddAltRounded", ()=>(0, _personAddAltRoundedDefault.default));
parcelHelpers.export(exports, "PersonAddAltSharp", ()=>(0, _personAddAltSharpDefault.default));
parcelHelpers.export(exports, "PersonAddAltTwoTone", ()=>(0, _personAddAltTwoToneDefault.default));
parcelHelpers.export(exports, "PersonAddDisabled", ()=>(0, _personAddDisabledDefault.default));
parcelHelpers.export(exports, "PersonAddDisabledOutlined", ()=>(0, _personAddDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "PersonAddDisabledRounded", ()=>(0, _personAddDisabledRoundedDefault.default));
parcelHelpers.export(exports, "PersonAddDisabledSharp", ()=>(0, _personAddDisabledSharpDefault.default));
parcelHelpers.export(exports, "PersonAddDisabledTwoTone", ()=>(0, _personAddDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "PersonAddOutlined", ()=>(0, _personAddOutlinedDefault.default));
parcelHelpers.export(exports, "PersonAddRounded", ()=>(0, _personAddRoundedDefault.default));
parcelHelpers.export(exports, "PersonAddSharp", ()=>(0, _personAddSharpDefault.default));
parcelHelpers.export(exports, "PersonAddTwoTone", ()=>(0, _personAddTwoToneDefault.default));
parcelHelpers.export(exports, "PersonOff", ()=>(0, _personOffDefault.default));
parcelHelpers.export(exports, "PersonOffOutlined", ()=>(0, _personOffOutlinedDefault.default));
parcelHelpers.export(exports, "PersonOffRounded", ()=>(0, _personOffRoundedDefault.default));
parcelHelpers.export(exports, "PersonOffSharp", ()=>(0, _personOffSharpDefault.default));
parcelHelpers.export(exports, "PersonOffTwoTone", ()=>(0, _personOffTwoToneDefault.default));
parcelHelpers.export(exports, "PersonOutline", ()=>(0, _personOutlineDefault.default));
parcelHelpers.export(exports, "PersonOutlineOutlined", ()=>(0, _personOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "PersonOutlineRounded", ()=>(0, _personOutlineRoundedDefault.default));
parcelHelpers.export(exports, "PersonOutlineSharp", ()=>(0, _personOutlineSharpDefault.default));
parcelHelpers.export(exports, "PersonOutlineTwoTone", ()=>(0, _personOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "PersonOutlined", ()=>(0, _personOutlinedDefault.default));
parcelHelpers.export(exports, "PersonPin", ()=>(0, _personPinDefault.default));
parcelHelpers.export(exports, "PersonPinCircle", ()=>(0, _personPinCircleDefault.default));
parcelHelpers.export(exports, "PersonPinCircleOutlined", ()=>(0, _personPinCircleOutlinedDefault.default));
parcelHelpers.export(exports, "PersonPinCircleRounded", ()=>(0, _personPinCircleRoundedDefault.default));
parcelHelpers.export(exports, "PersonPinCircleSharp", ()=>(0, _personPinCircleSharpDefault.default));
parcelHelpers.export(exports, "PersonPinCircleTwoTone", ()=>(0, _personPinCircleTwoToneDefault.default));
parcelHelpers.export(exports, "PersonPinOutlined", ()=>(0, _personPinOutlinedDefault.default));
parcelHelpers.export(exports, "PersonPinRounded", ()=>(0, _personPinRoundedDefault.default));
parcelHelpers.export(exports, "PersonPinSharp", ()=>(0, _personPinSharpDefault.default));
parcelHelpers.export(exports, "PersonPinTwoTone", ()=>(0, _personPinTwoToneDefault.default));
parcelHelpers.export(exports, "PersonRemove", ()=>(0, _personRemoveDefault.default));
parcelHelpers.export(exports, "PersonRemoveAlt1", ()=>(0, _personRemoveAlt1Default.default));
parcelHelpers.export(exports, "PersonRemoveAlt1Outlined", ()=>(0, _personRemoveAlt1OutlinedDefault.default));
parcelHelpers.export(exports, "PersonRemoveAlt1Rounded", ()=>(0, _personRemoveAlt1RoundedDefault.default));
parcelHelpers.export(exports, "PersonRemoveAlt1Sharp", ()=>(0, _personRemoveAlt1SharpDefault.default));
parcelHelpers.export(exports, "PersonRemoveAlt1TwoTone", ()=>(0, _personRemoveAlt1TwoToneDefault.default));
parcelHelpers.export(exports, "PersonRemoveOutlined", ()=>(0, _personRemoveOutlinedDefault.default));
parcelHelpers.export(exports, "PersonRemoveRounded", ()=>(0, _personRemoveRoundedDefault.default));
parcelHelpers.export(exports, "PersonRemoveSharp", ()=>(0, _personRemoveSharpDefault.default));
parcelHelpers.export(exports, "PersonRemoveTwoTone", ()=>(0, _personRemoveTwoToneDefault.default));
parcelHelpers.export(exports, "PersonRounded", ()=>(0, _personRoundedDefault.default));
parcelHelpers.export(exports, "PersonSearch", ()=>(0, _personSearchDefault.default));
parcelHelpers.export(exports, "PersonSearchOutlined", ()=>(0, _personSearchOutlinedDefault.default));
parcelHelpers.export(exports, "PersonSearchRounded", ()=>(0, _personSearchRoundedDefault.default));
parcelHelpers.export(exports, "PersonSearchSharp", ()=>(0, _personSearchSharpDefault.default));
parcelHelpers.export(exports, "PersonSearchTwoTone", ()=>(0, _personSearchTwoToneDefault.default));
parcelHelpers.export(exports, "PersonSharp", ()=>(0, _personSharpDefault.default));
parcelHelpers.export(exports, "PersonTwoTone", ()=>(0, _personTwoToneDefault.default));
parcelHelpers.export(exports, "PersonalVideo", ()=>(0, _personalVideoDefault.default));
parcelHelpers.export(exports, "PersonalVideoOutlined", ()=>(0, _personalVideoOutlinedDefault.default));
parcelHelpers.export(exports, "PersonalVideoRounded", ()=>(0, _personalVideoRoundedDefault.default));
parcelHelpers.export(exports, "PersonalVideoSharp", ()=>(0, _personalVideoSharpDefault.default));
parcelHelpers.export(exports, "PersonalVideoTwoTone", ()=>(0, _personalVideoTwoToneDefault.default));
parcelHelpers.export(exports, "PestControl", ()=>(0, _pestControlDefault.default));
parcelHelpers.export(exports, "PestControlOutlined", ()=>(0, _pestControlOutlinedDefault.default));
parcelHelpers.export(exports, "PestControlRodent", ()=>(0, _pestControlRodentDefault.default));
parcelHelpers.export(exports, "PestControlRodentOutlined", ()=>(0, _pestControlRodentOutlinedDefault.default));
parcelHelpers.export(exports, "PestControlRodentRounded", ()=>(0, _pestControlRodentRoundedDefault.default));
parcelHelpers.export(exports, "PestControlRodentSharp", ()=>(0, _pestControlRodentSharpDefault.default));
parcelHelpers.export(exports, "PestControlRodentTwoTone", ()=>(0, _pestControlRodentTwoToneDefault.default));
parcelHelpers.export(exports, "PestControlRounded", ()=>(0, _pestControlRoundedDefault.default));
parcelHelpers.export(exports, "PestControlSharp", ()=>(0, _pestControlSharpDefault.default));
parcelHelpers.export(exports, "PestControlTwoTone", ()=>(0, _pestControlTwoToneDefault.default));
parcelHelpers.export(exports, "Pets", ()=>(0, _petsDefault.default));
parcelHelpers.export(exports, "PetsOutlined", ()=>(0, _petsOutlinedDefault.default));
parcelHelpers.export(exports, "PetsRounded", ()=>(0, _petsRoundedDefault.default));
parcelHelpers.export(exports, "PetsSharp", ()=>(0, _petsSharpDefault.default));
parcelHelpers.export(exports, "PetsTwoTone", ()=>(0, _petsTwoToneDefault.default));
parcelHelpers.export(exports, "Phishing", ()=>(0, _phishingDefault.default));
parcelHelpers.export(exports, "PhishingOutlined", ()=>(0, _phishingOutlinedDefault.default));
parcelHelpers.export(exports, "PhishingRounded", ()=>(0, _phishingRoundedDefault.default));
parcelHelpers.export(exports, "PhishingSharp", ()=>(0, _phishingSharpDefault.default));
parcelHelpers.export(exports, "PhishingTwoTone", ()=>(0, _phishingTwoToneDefault.default));
parcelHelpers.export(exports, "Phone", ()=>(0, _phoneDefault.default));
parcelHelpers.export(exports, "PhoneAndroid", ()=>(0, _phoneAndroidDefault.default));
parcelHelpers.export(exports, "PhoneAndroidOutlined", ()=>(0, _phoneAndroidOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneAndroidRounded", ()=>(0, _phoneAndroidRoundedDefault.default));
parcelHelpers.export(exports, "PhoneAndroidSharp", ()=>(0, _phoneAndroidSharpDefault.default));
parcelHelpers.export(exports, "PhoneAndroidTwoTone", ()=>(0, _phoneAndroidTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneBluetoothSpeaker", ()=>(0, _phoneBluetoothSpeakerDefault.default));
parcelHelpers.export(exports, "PhoneBluetoothSpeakerOutlined", ()=>(0, _phoneBluetoothSpeakerOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneBluetoothSpeakerRounded", ()=>(0, _phoneBluetoothSpeakerRoundedDefault.default));
parcelHelpers.export(exports, "PhoneBluetoothSpeakerSharp", ()=>(0, _phoneBluetoothSpeakerSharpDefault.default));
parcelHelpers.export(exports, "PhoneBluetoothSpeakerTwoTone", ()=>(0, _phoneBluetoothSpeakerTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneCallback", ()=>(0, _phoneCallbackDefault.default));
parcelHelpers.export(exports, "PhoneCallbackOutlined", ()=>(0, _phoneCallbackOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneCallbackRounded", ()=>(0, _phoneCallbackRoundedDefault.default));
parcelHelpers.export(exports, "PhoneCallbackSharp", ()=>(0, _phoneCallbackSharpDefault.default));
parcelHelpers.export(exports, "PhoneCallbackTwoTone", ()=>(0, _phoneCallbackTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneDisabled", ()=>(0, _phoneDisabledDefault.default));
parcelHelpers.export(exports, "PhoneDisabledOutlined", ()=>(0, _phoneDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneDisabledRounded", ()=>(0, _phoneDisabledRoundedDefault.default));
parcelHelpers.export(exports, "PhoneDisabledSharp", ()=>(0, _phoneDisabledSharpDefault.default));
parcelHelpers.export(exports, "PhoneDisabledTwoTone", ()=>(0, _phoneDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneEnabled", ()=>(0, _phoneEnabledDefault.default));
parcelHelpers.export(exports, "PhoneEnabledOutlined", ()=>(0, _phoneEnabledOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneEnabledRounded", ()=>(0, _phoneEnabledRoundedDefault.default));
parcelHelpers.export(exports, "PhoneEnabledSharp", ()=>(0, _phoneEnabledSharpDefault.default));
parcelHelpers.export(exports, "PhoneEnabledTwoTone", ()=>(0, _phoneEnabledTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneForwarded", ()=>(0, _phoneForwardedDefault.default));
parcelHelpers.export(exports, "PhoneForwardedOutlined", ()=>(0, _phoneForwardedOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneForwardedRounded", ()=>(0, _phoneForwardedRoundedDefault.default));
parcelHelpers.export(exports, "PhoneForwardedSharp", ()=>(0, _phoneForwardedSharpDefault.default));
parcelHelpers.export(exports, "PhoneForwardedTwoTone", ()=>(0, _phoneForwardedTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneInTalk", ()=>(0, _phoneInTalkDefault.default));
parcelHelpers.export(exports, "PhoneInTalkOutlined", ()=>(0, _phoneInTalkOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneInTalkRounded", ()=>(0, _phoneInTalkRoundedDefault.default));
parcelHelpers.export(exports, "PhoneInTalkSharp", ()=>(0, _phoneInTalkSharpDefault.default));
parcelHelpers.export(exports, "PhoneInTalkTwoTone", ()=>(0, _phoneInTalkTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneIphone", ()=>(0, _phoneIphoneDefault.default));
parcelHelpers.export(exports, "PhoneIphoneOutlined", ()=>(0, _phoneIphoneOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneIphoneRounded", ()=>(0, _phoneIphoneRoundedDefault.default));
parcelHelpers.export(exports, "PhoneIphoneSharp", ()=>(0, _phoneIphoneSharpDefault.default));
parcelHelpers.export(exports, "PhoneIphoneTwoTone", ()=>(0, _phoneIphoneTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneLocked", ()=>(0, _phoneLockedDefault.default));
parcelHelpers.export(exports, "PhoneLockedOutlined", ()=>(0, _phoneLockedOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneLockedRounded", ()=>(0, _phoneLockedRoundedDefault.default));
parcelHelpers.export(exports, "PhoneLockedSharp", ()=>(0, _phoneLockedSharpDefault.default));
parcelHelpers.export(exports, "PhoneLockedTwoTone", ()=>(0, _phoneLockedTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneMissed", ()=>(0, _phoneMissedDefault.default));
parcelHelpers.export(exports, "PhoneMissedOutlined", ()=>(0, _phoneMissedOutlinedDefault.default));
parcelHelpers.export(exports, "PhoneMissedRounded", ()=>(0, _phoneMissedRoundedDefault.default));
parcelHelpers.export(exports, "PhoneMissedSharp", ()=>(0, _phoneMissedSharpDefault.default));
parcelHelpers.export(exports, "PhoneMissedTwoTone", ()=>(0, _phoneMissedTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneOutlined", ()=>(0, _phoneOutlinedDefault.default));
parcelHelpers.export(exports, "PhonePaused", ()=>(0, _phonePausedDefault.default));
parcelHelpers.export(exports, "PhonePausedOutlined", ()=>(0, _phonePausedOutlinedDefault.default));
parcelHelpers.export(exports, "PhonePausedRounded", ()=>(0, _phonePausedRoundedDefault.default));
parcelHelpers.export(exports, "PhonePausedSharp", ()=>(0, _phonePausedSharpDefault.default));
parcelHelpers.export(exports, "PhonePausedTwoTone", ()=>(0, _phonePausedTwoToneDefault.default));
parcelHelpers.export(exports, "PhoneRounded", ()=>(0, _phoneRoundedDefault.default));
parcelHelpers.export(exports, "PhoneSharp", ()=>(0, _phoneSharpDefault.default));
parcelHelpers.export(exports, "PhoneTwoTone", ()=>(0, _phoneTwoToneDefault.default));
parcelHelpers.export(exports, "Phonelink", ()=>(0, _phonelinkDefault.default));
parcelHelpers.export(exports, "PhonelinkErase", ()=>(0, _phonelinkEraseDefault.default));
parcelHelpers.export(exports, "PhonelinkEraseOutlined", ()=>(0, _phonelinkEraseOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkEraseRounded", ()=>(0, _phonelinkEraseRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkEraseSharp", ()=>(0, _phonelinkEraseSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkEraseTwoTone", ()=>(0, _phonelinkEraseTwoToneDefault.default));
parcelHelpers.export(exports, "PhonelinkLock", ()=>(0, _phonelinkLockDefault.default));
parcelHelpers.export(exports, "PhonelinkLockOutlined", ()=>(0, _phonelinkLockOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkLockRounded", ()=>(0, _phonelinkLockRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkLockSharp", ()=>(0, _phonelinkLockSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkLockTwoTone", ()=>(0, _phonelinkLockTwoToneDefault.default));
parcelHelpers.export(exports, "PhonelinkOff", ()=>(0, _phonelinkOffDefault.default));
parcelHelpers.export(exports, "PhonelinkOffOutlined", ()=>(0, _phonelinkOffOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkOffRounded", ()=>(0, _phonelinkOffRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkOffSharp", ()=>(0, _phonelinkOffSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkOffTwoTone", ()=>(0, _phonelinkOffTwoToneDefault.default));
parcelHelpers.export(exports, "PhonelinkOutlined", ()=>(0, _phonelinkOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkRing", ()=>(0, _phonelinkRingDefault.default));
parcelHelpers.export(exports, "PhonelinkRingOutlined", ()=>(0, _phonelinkRingOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkRingRounded", ()=>(0, _phonelinkRingRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkRingSharp", ()=>(0, _phonelinkRingSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkRingTwoTone", ()=>(0, _phonelinkRingTwoToneDefault.default));
parcelHelpers.export(exports, "PhonelinkRounded", ()=>(0, _phonelinkRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkSetup", ()=>(0, _phonelinkSetupDefault.default));
parcelHelpers.export(exports, "PhonelinkSetupOutlined", ()=>(0, _phonelinkSetupOutlinedDefault.default));
parcelHelpers.export(exports, "PhonelinkSetupRounded", ()=>(0, _phonelinkSetupRoundedDefault.default));
parcelHelpers.export(exports, "PhonelinkSetupSharp", ()=>(0, _phonelinkSetupSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkSetupTwoTone", ()=>(0, _phonelinkSetupTwoToneDefault.default));
parcelHelpers.export(exports, "PhonelinkSharp", ()=>(0, _phonelinkSharpDefault.default));
parcelHelpers.export(exports, "PhonelinkTwoTone", ()=>(0, _phonelinkTwoToneDefault.default));
parcelHelpers.export(exports, "Photo", ()=>(0, _photoDefault.default));
parcelHelpers.export(exports, "PhotoAlbum", ()=>(0, _photoAlbumDefault.default));
parcelHelpers.export(exports, "PhotoAlbumOutlined", ()=>(0, _photoAlbumOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoAlbumRounded", ()=>(0, _photoAlbumRoundedDefault.default));
parcelHelpers.export(exports, "PhotoAlbumSharp", ()=>(0, _photoAlbumSharpDefault.default));
parcelHelpers.export(exports, "PhotoAlbumTwoTone", ()=>(0, _photoAlbumTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoCamera", ()=>(0, _photoCameraDefault.default));
parcelHelpers.export(exports, "PhotoCameraBack", ()=>(0, _photoCameraBackDefault.default));
parcelHelpers.export(exports, "PhotoCameraBackOutlined", ()=>(0, _photoCameraBackOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoCameraBackRounded", ()=>(0, _photoCameraBackRoundedDefault.default));
parcelHelpers.export(exports, "PhotoCameraBackSharp", ()=>(0, _photoCameraBackSharpDefault.default));
parcelHelpers.export(exports, "PhotoCameraBackTwoTone", ()=>(0, _photoCameraBackTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoCameraFront", ()=>(0, _photoCameraFrontDefault.default));
parcelHelpers.export(exports, "PhotoCameraFrontOutlined", ()=>(0, _photoCameraFrontOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoCameraFrontRounded", ()=>(0, _photoCameraFrontRoundedDefault.default));
parcelHelpers.export(exports, "PhotoCameraFrontSharp", ()=>(0, _photoCameraFrontSharpDefault.default));
parcelHelpers.export(exports, "PhotoCameraFrontTwoTone", ()=>(0, _photoCameraFrontTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoCameraOutlined", ()=>(0, _photoCameraOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoCameraRounded", ()=>(0, _photoCameraRoundedDefault.default));
parcelHelpers.export(exports, "PhotoCameraSharp", ()=>(0, _photoCameraSharpDefault.default));
parcelHelpers.export(exports, "PhotoCameraTwoTone", ()=>(0, _photoCameraTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoFilter", ()=>(0, _photoFilterDefault.default));
parcelHelpers.export(exports, "PhotoFilterOutlined", ()=>(0, _photoFilterOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoFilterRounded", ()=>(0, _photoFilterRoundedDefault.default));
parcelHelpers.export(exports, "PhotoFilterSharp", ()=>(0, _photoFilterSharpDefault.default));
parcelHelpers.export(exports, "PhotoFilterTwoTone", ()=>(0, _photoFilterTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoLibrary", ()=>(0, _photoLibraryDefault.default));
parcelHelpers.export(exports, "PhotoLibraryOutlined", ()=>(0, _photoLibraryOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoLibraryRounded", ()=>(0, _photoLibraryRoundedDefault.default));
parcelHelpers.export(exports, "PhotoLibrarySharp", ()=>(0, _photoLibrarySharpDefault.default));
parcelHelpers.export(exports, "PhotoLibraryTwoTone", ()=>(0, _photoLibraryTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoOutlined", ()=>(0, _photoOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoRounded", ()=>(0, _photoRoundedDefault.default));
parcelHelpers.export(exports, "PhotoSharp", ()=>(0, _photoSharpDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectActual", ()=>(0, _photoSizeSelectActualDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectActualOutlined", ()=>(0, _photoSizeSelectActualOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectActualRounded", ()=>(0, _photoSizeSelectActualRoundedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectActualSharp", ()=>(0, _photoSizeSelectActualSharpDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectActualTwoTone", ()=>(0, _photoSizeSelectActualTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectLarge", ()=>(0, _photoSizeSelectLargeDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectLargeOutlined", ()=>(0, _photoSizeSelectLargeOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectLargeRounded", ()=>(0, _photoSizeSelectLargeRoundedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectLargeSharp", ()=>(0, _photoSizeSelectLargeSharpDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectLargeTwoTone", ()=>(0, _photoSizeSelectLargeTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectSmall", ()=>(0, _photoSizeSelectSmallDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectSmallOutlined", ()=>(0, _photoSizeSelectSmallOutlinedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectSmallRounded", ()=>(0, _photoSizeSelectSmallRoundedDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectSmallSharp", ()=>(0, _photoSizeSelectSmallSharpDefault.default));
parcelHelpers.export(exports, "PhotoSizeSelectSmallTwoTone", ()=>(0, _photoSizeSelectSmallTwoToneDefault.default));
parcelHelpers.export(exports, "PhotoTwoTone", ()=>(0, _photoTwoToneDefault.default));
parcelHelpers.export(exports, "Php", ()=>(0, _phpDefault.default));
parcelHelpers.export(exports, "PhpOutlined", ()=>(0, _phpOutlinedDefault.default));
parcelHelpers.export(exports, "PhpRounded", ()=>(0, _phpRoundedDefault.default));
parcelHelpers.export(exports, "PhpSharp", ()=>(0, _phpSharpDefault.default));
parcelHelpers.export(exports, "PhpTwoTone", ()=>(0, _phpTwoToneDefault.default));
parcelHelpers.export(exports, "Piano", ()=>(0, _pianoDefault.default));
parcelHelpers.export(exports, "PianoOff", ()=>(0, _pianoOffDefault.default));
parcelHelpers.export(exports, "PianoOffOutlined", ()=>(0, _pianoOffOutlinedDefault.default));
parcelHelpers.export(exports, "PianoOffRounded", ()=>(0, _pianoOffRoundedDefault.default));
parcelHelpers.export(exports, "PianoOffSharp", ()=>(0, _pianoOffSharpDefault.default));
parcelHelpers.export(exports, "PianoOffTwoTone", ()=>(0, _pianoOffTwoToneDefault.default));
parcelHelpers.export(exports, "PianoOutlined", ()=>(0, _pianoOutlinedDefault.default));
parcelHelpers.export(exports, "PianoRounded", ()=>(0, _pianoRoundedDefault.default));
parcelHelpers.export(exports, "PianoSharp", ()=>(0, _pianoSharpDefault.default));
parcelHelpers.export(exports, "PianoTwoTone", ()=>(0, _pianoTwoToneDefault.default));
parcelHelpers.export(exports, "PictureAsPdf", ()=>(0, _pictureAsPdfDefault.default));
parcelHelpers.export(exports, "PictureAsPdfOutlined", ()=>(0, _pictureAsPdfOutlinedDefault.default));
parcelHelpers.export(exports, "PictureAsPdfRounded", ()=>(0, _pictureAsPdfRoundedDefault.default));
parcelHelpers.export(exports, "PictureAsPdfSharp", ()=>(0, _pictureAsPdfSharpDefault.default));
parcelHelpers.export(exports, "PictureAsPdfTwoTone", ()=>(0, _pictureAsPdfTwoToneDefault.default));
parcelHelpers.export(exports, "PictureInPicture", ()=>(0, _pictureInPictureDefault.default));
parcelHelpers.export(exports, "PictureInPictureAlt", ()=>(0, _pictureInPictureAltDefault.default));
parcelHelpers.export(exports, "PictureInPictureAltOutlined", ()=>(0, _pictureInPictureAltOutlinedDefault.default));
parcelHelpers.export(exports, "PictureInPictureAltRounded", ()=>(0, _pictureInPictureAltRoundedDefault.default));
parcelHelpers.export(exports, "PictureInPictureAltSharp", ()=>(0, _pictureInPictureAltSharpDefault.default));
parcelHelpers.export(exports, "PictureInPictureAltTwoTone", ()=>(0, _pictureInPictureAltTwoToneDefault.default));
parcelHelpers.export(exports, "PictureInPictureOutlined", ()=>(0, _pictureInPictureOutlinedDefault.default));
parcelHelpers.export(exports, "PictureInPictureRounded", ()=>(0, _pictureInPictureRoundedDefault.default));
parcelHelpers.export(exports, "PictureInPictureSharp", ()=>(0, _pictureInPictureSharpDefault.default));
parcelHelpers.export(exports, "PictureInPictureTwoTone", ()=>(0, _pictureInPictureTwoToneDefault.default));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChartDefault.default));
parcelHelpers.export(exports, "PieChartOutline", ()=>(0, _pieChartOutlineDefault.default));
parcelHelpers.export(exports, "PieChartOutlineOutlined", ()=>(0, _pieChartOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "PieChartOutlineRounded", ()=>(0, _pieChartOutlineRoundedDefault.default));
parcelHelpers.export(exports, "PieChartOutlineSharp", ()=>(0, _pieChartOutlineSharpDefault.default));
parcelHelpers.export(exports, "PieChartOutlineTwoTone", ()=>(0, _pieChartOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "PieChartOutlined", ()=>(0, _pieChartOutlinedDefault.default));
parcelHelpers.export(exports, "PieChartRounded", ()=>(0, _pieChartRoundedDefault.default));
parcelHelpers.export(exports, "PieChartSharp", ()=>(0, _pieChartSharpDefault.default));
parcelHelpers.export(exports, "PieChartTwoTone", ()=>(0, _pieChartTwoToneDefault.default));
parcelHelpers.export(exports, "Pin", ()=>(0, _pinDefault.default));
parcelHelpers.export(exports, "PinDrop", ()=>(0, _pinDropDefault.default));
parcelHelpers.export(exports, "PinDropOutlined", ()=>(0, _pinDropOutlinedDefault.default));
parcelHelpers.export(exports, "PinDropRounded", ()=>(0, _pinDropRoundedDefault.default));
parcelHelpers.export(exports, "PinDropSharp", ()=>(0, _pinDropSharpDefault.default));
parcelHelpers.export(exports, "PinDropTwoTone", ()=>(0, _pinDropTwoToneDefault.default));
parcelHelpers.export(exports, "PinOutlined", ()=>(0, _pinOutlinedDefault.default));
parcelHelpers.export(exports, "PinRounded", ()=>(0, _pinRoundedDefault.default));
parcelHelpers.export(exports, "PinSharp", ()=>(0, _pinSharpDefault.default));
parcelHelpers.export(exports, "PinTwoTone", ()=>(0, _pinTwoToneDefault.default));
parcelHelpers.export(exports, "Pinch", ()=>(0, _pinchDefault.default));
parcelHelpers.export(exports, "PinchOutlined", ()=>(0, _pinchOutlinedDefault.default));
parcelHelpers.export(exports, "PinchRounded", ()=>(0, _pinchRoundedDefault.default));
parcelHelpers.export(exports, "PinchSharp", ()=>(0, _pinchSharpDefault.default));
parcelHelpers.export(exports, "PinchTwoTone", ()=>(0, _pinchTwoToneDefault.default));
parcelHelpers.export(exports, "Pinterest", ()=>(0, _pinterestDefault.default));
parcelHelpers.export(exports, "PivotTableChart", ()=>(0, _pivotTableChartDefault.default));
parcelHelpers.export(exports, "PivotTableChartOutlined", ()=>(0, _pivotTableChartOutlinedDefault.default));
parcelHelpers.export(exports, "PivotTableChartRounded", ()=>(0, _pivotTableChartRoundedDefault.default));
parcelHelpers.export(exports, "PivotTableChartSharp", ()=>(0, _pivotTableChartSharpDefault.default));
parcelHelpers.export(exports, "PivotTableChartTwoTone", ()=>(0, _pivotTableChartTwoToneDefault.default));
parcelHelpers.export(exports, "Pix", ()=>(0, _pixDefault.default));
parcelHelpers.export(exports, "PixOutlined", ()=>(0, _pixOutlinedDefault.default));
parcelHelpers.export(exports, "PixRounded", ()=>(0, _pixRoundedDefault.default));
parcelHelpers.export(exports, "PixSharp", ()=>(0, _pixSharpDefault.default));
parcelHelpers.export(exports, "PixTwoTone", ()=>(0, _pixTwoToneDefault.default));
parcelHelpers.export(exports, "Place", ()=>(0, _placeDefault.default));
parcelHelpers.export(exports, "PlaceOutlined", ()=>(0, _placeOutlinedDefault.default));
parcelHelpers.export(exports, "PlaceRounded", ()=>(0, _placeRoundedDefault.default));
parcelHelpers.export(exports, "PlaceSharp", ()=>(0, _placeSharpDefault.default));
parcelHelpers.export(exports, "PlaceTwoTone", ()=>(0, _placeTwoToneDefault.default));
parcelHelpers.export(exports, "Plagiarism", ()=>(0, _plagiarismDefault.default));
parcelHelpers.export(exports, "PlagiarismOutlined", ()=>(0, _plagiarismOutlinedDefault.default));
parcelHelpers.export(exports, "PlagiarismRounded", ()=>(0, _plagiarismRoundedDefault.default));
parcelHelpers.export(exports, "PlagiarismSharp", ()=>(0, _plagiarismSharpDefault.default));
parcelHelpers.export(exports, "PlagiarismTwoTone", ()=>(0, _plagiarismTwoToneDefault.default));
parcelHelpers.export(exports, "PlayArrow", ()=>(0, _playArrowDefault.default));
parcelHelpers.export(exports, "PlayArrowOutlined", ()=>(0, _playArrowOutlinedDefault.default));
parcelHelpers.export(exports, "PlayArrowRounded", ()=>(0, _playArrowRoundedDefault.default));
parcelHelpers.export(exports, "PlayArrowSharp", ()=>(0, _playArrowSharpDefault.default));
parcelHelpers.export(exports, "PlayArrowTwoTone", ()=>(0, _playArrowTwoToneDefault.default));
parcelHelpers.export(exports, "PlayCircle", ()=>(0, _playCircleDefault.default));
parcelHelpers.export(exports, "PlayCircleFilled", ()=>(0, _playCircleFilledDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledOutlined", ()=>(0, _playCircleFilledOutlinedDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledRounded", ()=>(0, _playCircleFilledRoundedDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledSharp", ()=>(0, _playCircleFilledSharpDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledTwoTone", ()=>(0, _playCircleFilledTwoToneDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledWhite", ()=>(0, _playCircleFilledWhiteDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledWhiteOutlined", ()=>(0, _playCircleFilledWhiteOutlinedDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledWhiteRounded", ()=>(0, _playCircleFilledWhiteRoundedDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledWhiteSharp", ()=>(0, _playCircleFilledWhiteSharpDefault.default));
parcelHelpers.export(exports, "PlayCircleFilledWhiteTwoTone", ()=>(0, _playCircleFilledWhiteTwoToneDefault.default));
parcelHelpers.export(exports, "PlayCircleOutline", ()=>(0, _playCircleOutlineDefault.default));
parcelHelpers.export(exports, "PlayCircleOutlineOutlined", ()=>(0, _playCircleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "PlayCircleOutlineRounded", ()=>(0, _playCircleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "PlayCircleOutlineSharp", ()=>(0, _playCircleOutlineSharpDefault.default));
parcelHelpers.export(exports, "PlayCircleOutlineTwoTone", ()=>(0, _playCircleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "PlayCircleOutlined", ()=>(0, _playCircleOutlinedDefault.default));
parcelHelpers.export(exports, "PlayCircleRounded", ()=>(0, _playCircleRoundedDefault.default));
parcelHelpers.export(exports, "PlayCircleSharp", ()=>(0, _playCircleSharpDefault.default));
parcelHelpers.export(exports, "PlayCircleTwoTone", ()=>(0, _playCircleTwoToneDefault.default));
parcelHelpers.export(exports, "PlayDisabled", ()=>(0, _playDisabledDefault.default));
parcelHelpers.export(exports, "PlayDisabledOutlined", ()=>(0, _playDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "PlayDisabledRounded", ()=>(0, _playDisabledRoundedDefault.default));
parcelHelpers.export(exports, "PlayDisabledSharp", ()=>(0, _playDisabledSharpDefault.default));
parcelHelpers.export(exports, "PlayDisabledTwoTone", ()=>(0, _playDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "PlayForWork", ()=>(0, _playForWorkDefault.default));
parcelHelpers.export(exports, "PlayForWorkOutlined", ()=>(0, _playForWorkOutlinedDefault.default));
parcelHelpers.export(exports, "PlayForWorkRounded", ()=>(0, _playForWorkRoundedDefault.default));
parcelHelpers.export(exports, "PlayForWorkSharp", ()=>(0, _playForWorkSharpDefault.default));
parcelHelpers.export(exports, "PlayForWorkTwoTone", ()=>(0, _playForWorkTwoToneDefault.default));
parcelHelpers.export(exports, "PlayLesson", ()=>(0, _playLessonDefault.default));
parcelHelpers.export(exports, "PlayLessonOutlined", ()=>(0, _playLessonOutlinedDefault.default));
parcelHelpers.export(exports, "PlayLessonRounded", ()=>(0, _playLessonRoundedDefault.default));
parcelHelpers.export(exports, "PlayLessonSharp", ()=>(0, _playLessonSharpDefault.default));
parcelHelpers.export(exports, "PlayLessonTwoTone", ()=>(0, _playLessonTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistAdd", ()=>(0, _playlistAddDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheck", ()=>(0, _playlistAddCheckDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckCircle", ()=>(0, _playlistAddCheckCircleDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckCircleOutlined", ()=>(0, _playlistAddCheckCircleOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckCircleRounded", ()=>(0, _playlistAddCheckCircleRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckCircleSharp", ()=>(0, _playlistAddCheckCircleSharpDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckCircleTwoTone", ()=>(0, _playlistAddCheckCircleTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckOutlined", ()=>(0, _playlistAddCheckOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckRounded", ()=>(0, _playlistAddCheckRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckSharp", ()=>(0, _playlistAddCheckSharpDefault.default));
parcelHelpers.export(exports, "PlaylistAddCheckTwoTone", ()=>(0, _playlistAddCheckTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistAddCircle", ()=>(0, _playlistAddCircleDefault.default));
parcelHelpers.export(exports, "PlaylistAddCircleOutlined", ()=>(0, _playlistAddCircleOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCircleRounded", ()=>(0, _playlistAddCircleRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistAddCircleSharp", ()=>(0, _playlistAddCircleSharpDefault.default));
parcelHelpers.export(exports, "PlaylistAddCircleTwoTone", ()=>(0, _playlistAddCircleTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistAddOutlined", ()=>(0, _playlistAddOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistAddRounded", ()=>(0, _playlistAddRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistAddSharp", ()=>(0, _playlistAddSharpDefault.default));
parcelHelpers.export(exports, "PlaylistAddTwoTone", ()=>(0, _playlistAddTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistPlay", ()=>(0, _playlistPlayDefault.default));
parcelHelpers.export(exports, "PlaylistPlayOutlined", ()=>(0, _playlistPlayOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistPlayRounded", ()=>(0, _playlistPlayRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistPlaySharp", ()=>(0, _playlistPlaySharpDefault.default));
parcelHelpers.export(exports, "PlaylistPlayTwoTone", ()=>(0, _playlistPlayTwoToneDefault.default));
parcelHelpers.export(exports, "PlaylistRemove", ()=>(0, _playlistRemoveDefault.default));
parcelHelpers.export(exports, "PlaylistRemoveOutlined", ()=>(0, _playlistRemoveOutlinedDefault.default));
parcelHelpers.export(exports, "PlaylistRemoveRounded", ()=>(0, _playlistRemoveRoundedDefault.default));
parcelHelpers.export(exports, "PlaylistRemoveSharp", ()=>(0, _playlistRemoveSharpDefault.default));
parcelHelpers.export(exports, "PlaylistRemoveTwoTone", ()=>(0, _playlistRemoveTwoToneDefault.default));
parcelHelpers.export(exports, "Plumbing", ()=>(0, _plumbingDefault.default));
parcelHelpers.export(exports, "PlumbingOutlined", ()=>(0, _plumbingOutlinedDefault.default));
parcelHelpers.export(exports, "PlumbingRounded", ()=>(0, _plumbingRoundedDefault.default));
parcelHelpers.export(exports, "PlumbingSharp", ()=>(0, _plumbingSharpDefault.default));
parcelHelpers.export(exports, "PlumbingTwoTone", ()=>(0, _plumbingTwoToneDefault.default));
parcelHelpers.export(exports, "PlusOne", ()=>(0, _plusOneDefault.default));
parcelHelpers.export(exports, "PlusOneOutlined", ()=>(0, _plusOneOutlinedDefault.default));
parcelHelpers.export(exports, "PlusOneRounded", ()=>(0, _plusOneRoundedDefault.default));
parcelHelpers.export(exports, "PlusOneSharp", ()=>(0, _plusOneSharpDefault.default));
parcelHelpers.export(exports, "PlusOneTwoTone", ()=>(0, _plusOneTwoToneDefault.default));
parcelHelpers.export(exports, "Podcasts", ()=>(0, _podcastsDefault.default));
parcelHelpers.export(exports, "PodcastsOutlined", ()=>(0, _podcastsOutlinedDefault.default));
parcelHelpers.export(exports, "PodcastsRounded", ()=>(0, _podcastsRoundedDefault.default));
parcelHelpers.export(exports, "PodcastsSharp", ()=>(0, _podcastsSharpDefault.default));
parcelHelpers.export(exports, "PodcastsTwoTone", ()=>(0, _podcastsTwoToneDefault.default));
parcelHelpers.export(exports, "PointOfSale", ()=>(0, _pointOfSaleDefault.default));
parcelHelpers.export(exports, "PointOfSaleOutlined", ()=>(0, _pointOfSaleOutlinedDefault.default));
parcelHelpers.export(exports, "PointOfSaleRounded", ()=>(0, _pointOfSaleRoundedDefault.default));
parcelHelpers.export(exports, "PointOfSaleSharp", ()=>(0, _pointOfSaleSharpDefault.default));
parcelHelpers.export(exports, "PointOfSaleTwoTone", ()=>(0, _pointOfSaleTwoToneDefault.default));
parcelHelpers.export(exports, "Policy", ()=>(0, _policyDefault.default));
parcelHelpers.export(exports, "PolicyOutlined", ()=>(0, _policyOutlinedDefault.default));
parcelHelpers.export(exports, "PolicyRounded", ()=>(0, _policyRoundedDefault.default));
parcelHelpers.export(exports, "PolicySharp", ()=>(0, _policySharpDefault.default));
parcelHelpers.export(exports, "PolicyTwoTone", ()=>(0, _policyTwoToneDefault.default));
parcelHelpers.export(exports, "Poll", ()=>(0, _pollDefault.default));
parcelHelpers.export(exports, "PollOutlined", ()=>(0, _pollOutlinedDefault.default));
parcelHelpers.export(exports, "PollRounded", ()=>(0, _pollRoundedDefault.default));
parcelHelpers.export(exports, "PollSharp", ()=>(0, _pollSharpDefault.default));
parcelHelpers.export(exports, "PollTwoTone", ()=>(0, _pollTwoToneDefault.default));
parcelHelpers.export(exports, "Polyline", ()=>(0, _polylineDefault.default));
parcelHelpers.export(exports, "PolylineOutlined", ()=>(0, _polylineOutlinedDefault.default));
parcelHelpers.export(exports, "PolylineRounded", ()=>(0, _polylineRoundedDefault.default));
parcelHelpers.export(exports, "PolylineSharp", ()=>(0, _polylineSharpDefault.default));
parcelHelpers.export(exports, "PolylineTwoTone", ()=>(0, _polylineTwoToneDefault.default));
parcelHelpers.export(exports, "Pool", ()=>(0, _poolDefault.default));
parcelHelpers.export(exports, "PoolOutlined", ()=>(0, _poolOutlinedDefault.default));
parcelHelpers.export(exports, "PoolRounded", ()=>(0, _poolRoundedDefault.default));
parcelHelpers.export(exports, "PoolSharp", ()=>(0, _poolSharpDefault.default));
parcelHelpers.export(exports, "PoolTwoTone", ()=>(0, _poolTwoToneDefault.default));
parcelHelpers.export(exports, "PortableWifiOff", ()=>(0, _portableWifiOffDefault.default));
parcelHelpers.export(exports, "PortableWifiOffOutlined", ()=>(0, _portableWifiOffOutlinedDefault.default));
parcelHelpers.export(exports, "PortableWifiOffRounded", ()=>(0, _portableWifiOffRoundedDefault.default));
parcelHelpers.export(exports, "PortableWifiOffSharp", ()=>(0, _portableWifiOffSharpDefault.default));
parcelHelpers.export(exports, "PortableWifiOffTwoTone", ()=>(0, _portableWifiOffTwoToneDefault.default));
parcelHelpers.export(exports, "Portrait", ()=>(0, _portraitDefault.default));
parcelHelpers.export(exports, "PortraitOutlined", ()=>(0, _portraitOutlinedDefault.default));
parcelHelpers.export(exports, "PortraitRounded", ()=>(0, _portraitRoundedDefault.default));
parcelHelpers.export(exports, "PortraitSharp", ()=>(0, _portraitSharpDefault.default));
parcelHelpers.export(exports, "PortraitTwoTone", ()=>(0, _portraitTwoToneDefault.default));
parcelHelpers.export(exports, "PostAdd", ()=>(0, _postAddDefault.default));
parcelHelpers.export(exports, "PostAddOutlined", ()=>(0, _postAddOutlinedDefault.default));
parcelHelpers.export(exports, "PostAddRounded", ()=>(0, _postAddRoundedDefault.default));
parcelHelpers.export(exports, "PostAddSharp", ()=>(0, _postAddSharpDefault.default));
parcelHelpers.export(exports, "PostAddTwoTone", ()=>(0, _postAddTwoToneDefault.default));
parcelHelpers.export(exports, "Power", ()=>(0, _powerDefault.default));
parcelHelpers.export(exports, "PowerInput", ()=>(0, _powerInputDefault.default));
parcelHelpers.export(exports, "PowerInputOutlined", ()=>(0, _powerInputOutlinedDefault.default));
parcelHelpers.export(exports, "PowerInputRounded", ()=>(0, _powerInputRoundedDefault.default));
parcelHelpers.export(exports, "PowerInputSharp", ()=>(0, _powerInputSharpDefault.default));
parcelHelpers.export(exports, "PowerInputTwoTone", ()=>(0, _powerInputTwoToneDefault.default));
parcelHelpers.export(exports, "PowerOff", ()=>(0, _powerOffDefault.default));
parcelHelpers.export(exports, "PowerOffOutlined", ()=>(0, _powerOffOutlinedDefault.default));
parcelHelpers.export(exports, "PowerOffRounded", ()=>(0, _powerOffRoundedDefault.default));
parcelHelpers.export(exports, "PowerOffSharp", ()=>(0, _powerOffSharpDefault.default));
parcelHelpers.export(exports, "PowerOffTwoTone", ()=>(0, _powerOffTwoToneDefault.default));
parcelHelpers.export(exports, "PowerOutlined", ()=>(0, _powerOutlinedDefault.default));
parcelHelpers.export(exports, "PowerRounded", ()=>(0, _powerRoundedDefault.default));
parcelHelpers.export(exports, "PowerSettingsNew", ()=>(0, _powerSettingsNewDefault.default));
parcelHelpers.export(exports, "PowerSettingsNewOutlined", ()=>(0, _powerSettingsNewOutlinedDefault.default));
parcelHelpers.export(exports, "PowerSettingsNewRounded", ()=>(0, _powerSettingsNewRoundedDefault.default));
parcelHelpers.export(exports, "PowerSettingsNewSharp", ()=>(0, _powerSettingsNewSharpDefault.default));
parcelHelpers.export(exports, "PowerSettingsNewTwoTone", ()=>(0, _powerSettingsNewTwoToneDefault.default));
parcelHelpers.export(exports, "PowerSharp", ()=>(0, _powerSharpDefault.default));
parcelHelpers.export(exports, "PowerTwoTone", ()=>(0, _powerTwoToneDefault.default));
parcelHelpers.export(exports, "PrecisionManufacturing", ()=>(0, _precisionManufacturingDefault.default));
parcelHelpers.export(exports, "PrecisionManufacturingOutlined", ()=>(0, _precisionManufacturingOutlinedDefault.default));
parcelHelpers.export(exports, "PrecisionManufacturingRounded", ()=>(0, _precisionManufacturingRoundedDefault.default));
parcelHelpers.export(exports, "PrecisionManufacturingSharp", ()=>(0, _precisionManufacturingSharpDefault.default));
parcelHelpers.export(exports, "PrecisionManufacturingTwoTone", ()=>(0, _precisionManufacturingTwoToneDefault.default));
parcelHelpers.export(exports, "PregnantWoman", ()=>(0, _pregnantWomanDefault.default));
parcelHelpers.export(exports, "PregnantWomanOutlined", ()=>(0, _pregnantWomanOutlinedDefault.default));
parcelHelpers.export(exports, "PregnantWomanRounded", ()=>(0, _pregnantWomanRoundedDefault.default));
parcelHelpers.export(exports, "PregnantWomanSharp", ()=>(0, _pregnantWomanSharpDefault.default));
parcelHelpers.export(exports, "PregnantWomanTwoTone", ()=>(0, _pregnantWomanTwoToneDefault.default));
parcelHelpers.export(exports, "PresentToAll", ()=>(0, _presentToAllDefault.default));
parcelHelpers.export(exports, "PresentToAllOutlined", ()=>(0, _presentToAllOutlinedDefault.default));
parcelHelpers.export(exports, "PresentToAllRounded", ()=>(0, _presentToAllRoundedDefault.default));
parcelHelpers.export(exports, "PresentToAllSharp", ()=>(0, _presentToAllSharpDefault.default));
parcelHelpers.export(exports, "PresentToAllTwoTone", ()=>(0, _presentToAllTwoToneDefault.default));
parcelHelpers.export(exports, "Preview", ()=>(0, _previewDefault.default));
parcelHelpers.export(exports, "PreviewOutlined", ()=>(0, _previewOutlinedDefault.default));
parcelHelpers.export(exports, "PreviewRounded", ()=>(0, _previewRoundedDefault.default));
parcelHelpers.export(exports, "PreviewSharp", ()=>(0, _previewSharpDefault.default));
parcelHelpers.export(exports, "PreviewTwoTone", ()=>(0, _previewTwoToneDefault.default));
parcelHelpers.export(exports, "PriceChange", ()=>(0, _priceChangeDefault.default));
parcelHelpers.export(exports, "PriceChangeOutlined", ()=>(0, _priceChangeOutlinedDefault.default));
parcelHelpers.export(exports, "PriceChangeRounded", ()=>(0, _priceChangeRoundedDefault.default));
parcelHelpers.export(exports, "PriceChangeSharp", ()=>(0, _priceChangeSharpDefault.default));
parcelHelpers.export(exports, "PriceChangeTwoTone", ()=>(0, _priceChangeTwoToneDefault.default));
parcelHelpers.export(exports, "PriceCheck", ()=>(0, _priceCheckDefault.default));
parcelHelpers.export(exports, "PriceCheckOutlined", ()=>(0, _priceCheckOutlinedDefault.default));
parcelHelpers.export(exports, "PriceCheckRounded", ()=>(0, _priceCheckRoundedDefault.default));
parcelHelpers.export(exports, "PriceCheckSharp", ()=>(0, _priceCheckSharpDefault.default));
parcelHelpers.export(exports, "PriceCheckTwoTone", ()=>(0, _priceCheckTwoToneDefault.default));
parcelHelpers.export(exports, "Print", ()=>(0, _printDefault.default));
parcelHelpers.export(exports, "PrintDisabled", ()=>(0, _printDisabledDefault.default));
parcelHelpers.export(exports, "PrintDisabledOutlined", ()=>(0, _printDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "PrintDisabledRounded", ()=>(0, _printDisabledRoundedDefault.default));
parcelHelpers.export(exports, "PrintDisabledSharp", ()=>(0, _printDisabledSharpDefault.default));
parcelHelpers.export(exports, "PrintDisabledTwoTone", ()=>(0, _printDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "PrintOutlined", ()=>(0, _printOutlinedDefault.default));
parcelHelpers.export(exports, "PrintRounded", ()=>(0, _printRoundedDefault.default));
parcelHelpers.export(exports, "PrintSharp", ()=>(0, _printSharpDefault.default));
parcelHelpers.export(exports, "PrintTwoTone", ()=>(0, _printTwoToneDefault.default));
parcelHelpers.export(exports, "PriorityHigh", ()=>(0, _priorityHighDefault.default));
parcelHelpers.export(exports, "PriorityHighOutlined", ()=>(0, _priorityHighOutlinedDefault.default));
parcelHelpers.export(exports, "PriorityHighRounded", ()=>(0, _priorityHighRoundedDefault.default));
parcelHelpers.export(exports, "PriorityHighSharp", ()=>(0, _priorityHighSharpDefault.default));
parcelHelpers.export(exports, "PriorityHighTwoTone", ()=>(0, _priorityHighTwoToneDefault.default));
parcelHelpers.export(exports, "PrivacyTip", ()=>(0, _privacyTipDefault.default));
parcelHelpers.export(exports, "PrivacyTipOutlined", ()=>(0, _privacyTipOutlinedDefault.default));
parcelHelpers.export(exports, "PrivacyTipRounded", ()=>(0, _privacyTipRoundedDefault.default));
parcelHelpers.export(exports, "PrivacyTipSharp", ()=>(0, _privacyTipSharpDefault.default));
parcelHelpers.export(exports, "PrivacyTipTwoTone", ()=>(0, _privacyTipTwoToneDefault.default));
parcelHelpers.export(exports, "ProductionQuantityLimits", ()=>(0, _productionQuantityLimitsDefault.default));
parcelHelpers.export(exports, "ProductionQuantityLimitsOutlined", ()=>(0, _productionQuantityLimitsOutlinedDefault.default));
parcelHelpers.export(exports, "ProductionQuantityLimitsRounded", ()=>(0, _productionQuantityLimitsRoundedDefault.default));
parcelHelpers.export(exports, "ProductionQuantityLimitsSharp", ()=>(0, _productionQuantityLimitsSharpDefault.default));
parcelHelpers.export(exports, "ProductionQuantityLimitsTwoTone", ()=>(0, _productionQuantityLimitsTwoToneDefault.default));
parcelHelpers.export(exports, "Propane", ()=>(0, _propaneDefault.default));
parcelHelpers.export(exports, "PropaneOutlined", ()=>(0, _propaneOutlinedDefault.default));
parcelHelpers.export(exports, "PropaneRounded", ()=>(0, _propaneRoundedDefault.default));
parcelHelpers.export(exports, "PropaneSharp", ()=>(0, _propaneSharpDefault.default));
parcelHelpers.export(exports, "PropaneTank", ()=>(0, _propaneTankDefault.default));
parcelHelpers.export(exports, "PropaneTankOutlined", ()=>(0, _propaneTankOutlinedDefault.default));
parcelHelpers.export(exports, "PropaneTankRounded", ()=>(0, _propaneTankRoundedDefault.default));
parcelHelpers.export(exports, "PropaneTankSharp", ()=>(0, _propaneTankSharpDefault.default));
parcelHelpers.export(exports, "PropaneTankTwoTone", ()=>(0, _propaneTankTwoToneDefault.default));
parcelHelpers.export(exports, "PropaneTwoTone", ()=>(0, _propaneTwoToneDefault.default));
parcelHelpers.export(exports, "Psychology", ()=>(0, _psychologyDefault.default));
parcelHelpers.export(exports, "PsychologyAlt", ()=>(0, _psychologyAltDefault.default));
parcelHelpers.export(exports, "PsychologyAltOutlined", ()=>(0, _psychologyAltOutlinedDefault.default));
parcelHelpers.export(exports, "PsychologyAltRounded", ()=>(0, _psychologyAltRoundedDefault.default));
parcelHelpers.export(exports, "PsychologyAltSharp", ()=>(0, _psychologyAltSharpDefault.default));
parcelHelpers.export(exports, "PsychologyAltTwoTone", ()=>(0, _psychologyAltTwoToneDefault.default));
parcelHelpers.export(exports, "PsychologyOutlined", ()=>(0, _psychologyOutlinedDefault.default));
parcelHelpers.export(exports, "PsychologyRounded", ()=>(0, _psychologyRoundedDefault.default));
parcelHelpers.export(exports, "PsychologySharp", ()=>(0, _psychologySharpDefault.default));
parcelHelpers.export(exports, "PsychologyTwoTone", ()=>(0, _psychologyTwoToneDefault.default));
parcelHelpers.export(exports, "Public", ()=>(0, _publicDefault.default));
parcelHelpers.export(exports, "PublicOff", ()=>(0, _publicOffDefault.default));
parcelHelpers.export(exports, "PublicOffOutlined", ()=>(0, _publicOffOutlinedDefault.default));
parcelHelpers.export(exports, "PublicOffRounded", ()=>(0, _publicOffRoundedDefault.default));
parcelHelpers.export(exports, "PublicOffSharp", ()=>(0, _publicOffSharpDefault.default));
parcelHelpers.export(exports, "PublicOffTwoTone", ()=>(0, _publicOffTwoToneDefault.default));
parcelHelpers.export(exports, "PublicOutlined", ()=>(0, _publicOutlinedDefault.default));
parcelHelpers.export(exports, "PublicRounded", ()=>(0, _publicRoundedDefault.default));
parcelHelpers.export(exports, "PublicSharp", ()=>(0, _publicSharpDefault.default));
parcelHelpers.export(exports, "PublicTwoTone", ()=>(0, _publicTwoToneDefault.default));
parcelHelpers.export(exports, "Publish", ()=>(0, _publishDefault.default));
parcelHelpers.export(exports, "PublishOutlined", ()=>(0, _publishOutlinedDefault.default));
parcelHelpers.export(exports, "PublishRounded", ()=>(0, _publishRoundedDefault.default));
parcelHelpers.export(exports, "PublishSharp", ()=>(0, _publishSharpDefault.default));
parcelHelpers.export(exports, "PublishTwoTone", ()=>(0, _publishTwoToneDefault.default));
parcelHelpers.export(exports, "PublishedWithChanges", ()=>(0, _publishedWithChangesDefault.default));
parcelHelpers.export(exports, "PublishedWithChangesOutlined", ()=>(0, _publishedWithChangesOutlinedDefault.default));
parcelHelpers.export(exports, "PublishedWithChangesRounded", ()=>(0, _publishedWithChangesRoundedDefault.default));
parcelHelpers.export(exports, "PublishedWithChangesSharp", ()=>(0, _publishedWithChangesSharpDefault.default));
parcelHelpers.export(exports, "PublishedWithChangesTwoTone", ()=>(0, _publishedWithChangesTwoToneDefault.default));
parcelHelpers.export(exports, "PunchClock", ()=>(0, _punchClockDefault.default));
parcelHelpers.export(exports, "PunchClockOutlined", ()=>(0, _punchClockOutlinedDefault.default));
parcelHelpers.export(exports, "PunchClockRounded", ()=>(0, _punchClockRoundedDefault.default));
parcelHelpers.export(exports, "PunchClockSharp", ()=>(0, _punchClockSharpDefault.default));
parcelHelpers.export(exports, "PunchClockTwoTone", ()=>(0, _punchClockTwoToneDefault.default));
parcelHelpers.export(exports, "PushPin", ()=>(0, _pushPinDefault.default));
parcelHelpers.export(exports, "PushPinOutlined", ()=>(0, _pushPinOutlinedDefault.default));
parcelHelpers.export(exports, "PushPinRounded", ()=>(0, _pushPinRoundedDefault.default));
parcelHelpers.export(exports, "PushPinSharp", ()=>(0, _pushPinSharpDefault.default));
parcelHelpers.export(exports, "PushPinTwoTone", ()=>(0, _pushPinTwoToneDefault.default));
parcelHelpers.export(exports, "QrCode", ()=>(0, _qrCodeDefault.default));
parcelHelpers.export(exports, "QrCode2", ()=>(0, _qrCode2Default.default));
parcelHelpers.export(exports, "QrCode2Outlined", ()=>(0, _qrCode2OutlinedDefault.default));
parcelHelpers.export(exports, "QrCode2Rounded", ()=>(0, _qrCode2RoundedDefault.default));
parcelHelpers.export(exports, "QrCode2Sharp", ()=>(0, _qrCode2SharpDefault.default));
parcelHelpers.export(exports, "QrCode2TwoTone", ()=>(0, _qrCode2TwoToneDefault.default));
parcelHelpers.export(exports, "QrCodeOutlined", ()=>(0, _qrCodeOutlinedDefault.default));
parcelHelpers.export(exports, "QrCodeRounded", ()=>(0, _qrCodeRoundedDefault.default));
parcelHelpers.export(exports, "QrCodeScanner", ()=>(0, _qrCodeScannerDefault.default));
parcelHelpers.export(exports, "QrCodeScannerOutlined", ()=>(0, _qrCodeScannerOutlinedDefault.default));
parcelHelpers.export(exports, "QrCodeScannerRounded", ()=>(0, _qrCodeScannerRoundedDefault.default));
parcelHelpers.export(exports, "QrCodeScannerSharp", ()=>(0, _qrCodeScannerSharpDefault.default));
parcelHelpers.export(exports, "QrCodeScannerTwoTone", ()=>(0, _qrCodeScannerTwoToneDefault.default));
parcelHelpers.export(exports, "QrCodeSharp", ()=>(0, _qrCodeSharpDefault.default));
parcelHelpers.export(exports, "QrCodeTwoTone", ()=>(0, _qrCodeTwoToneDefault.default));
parcelHelpers.export(exports, "QueryBuilder", ()=>(0, _queryBuilderDefault.default));
parcelHelpers.export(exports, "QueryBuilderOutlined", ()=>(0, _queryBuilderOutlinedDefault.default));
parcelHelpers.export(exports, "QueryBuilderRounded", ()=>(0, _queryBuilderRoundedDefault.default));
parcelHelpers.export(exports, "QueryBuilderSharp", ()=>(0, _queryBuilderSharpDefault.default));
parcelHelpers.export(exports, "QueryBuilderTwoTone", ()=>(0, _queryBuilderTwoToneDefault.default));
parcelHelpers.export(exports, "QueryStats", ()=>(0, _queryStatsDefault.default));
parcelHelpers.export(exports, "QueryStatsOutlined", ()=>(0, _queryStatsOutlinedDefault.default));
parcelHelpers.export(exports, "QueryStatsRounded", ()=>(0, _queryStatsRoundedDefault.default));
parcelHelpers.export(exports, "QueryStatsSharp", ()=>(0, _queryStatsSharpDefault.default));
parcelHelpers.export(exports, "QueryStatsTwoTone", ()=>(0, _queryStatsTwoToneDefault.default));
parcelHelpers.export(exports, "QuestionAnswer", ()=>(0, _questionAnswerDefault.default));
parcelHelpers.export(exports, "QuestionAnswerOutlined", ()=>(0, _questionAnswerOutlinedDefault.default));
parcelHelpers.export(exports, "QuestionAnswerRounded", ()=>(0, _questionAnswerRoundedDefault.default));
parcelHelpers.export(exports, "QuestionAnswerSharp", ()=>(0, _questionAnswerSharpDefault.default));
parcelHelpers.export(exports, "QuestionAnswerTwoTone", ()=>(0, _questionAnswerTwoToneDefault.default));
parcelHelpers.export(exports, "QuestionMark", ()=>(0, _questionMarkDefault.default));
parcelHelpers.export(exports, "QuestionMarkOutlined", ()=>(0, _questionMarkOutlinedDefault.default));
parcelHelpers.export(exports, "QuestionMarkRounded", ()=>(0, _questionMarkRoundedDefault.default));
parcelHelpers.export(exports, "QuestionMarkSharp", ()=>(0, _questionMarkSharpDefault.default));
parcelHelpers.export(exports, "QuestionMarkTwoTone", ()=>(0, _questionMarkTwoToneDefault.default));
parcelHelpers.export(exports, "Queue", ()=>(0, _queueDefault.default));
parcelHelpers.export(exports, "QueueMusic", ()=>(0, _queueMusicDefault.default));
parcelHelpers.export(exports, "QueueMusicOutlined", ()=>(0, _queueMusicOutlinedDefault.default));
parcelHelpers.export(exports, "QueueMusicRounded", ()=>(0, _queueMusicRoundedDefault.default));
parcelHelpers.export(exports, "QueueMusicSharp", ()=>(0, _queueMusicSharpDefault.default));
parcelHelpers.export(exports, "QueueMusicTwoTone", ()=>(0, _queueMusicTwoToneDefault.default));
parcelHelpers.export(exports, "QueueOutlined", ()=>(0, _queueOutlinedDefault.default));
parcelHelpers.export(exports, "QueuePlayNext", ()=>(0, _queuePlayNextDefault.default));
parcelHelpers.export(exports, "QueuePlayNextOutlined", ()=>(0, _queuePlayNextOutlinedDefault.default));
parcelHelpers.export(exports, "QueuePlayNextRounded", ()=>(0, _queuePlayNextRoundedDefault.default));
parcelHelpers.export(exports, "QueuePlayNextSharp", ()=>(0, _queuePlayNextSharpDefault.default));
parcelHelpers.export(exports, "QueuePlayNextTwoTone", ()=>(0, _queuePlayNextTwoToneDefault.default));
parcelHelpers.export(exports, "QueueRounded", ()=>(0, _queueRoundedDefault.default));
parcelHelpers.export(exports, "QueueSharp", ()=>(0, _queueSharpDefault.default));
parcelHelpers.export(exports, "QueueTwoTone", ()=>(0, _queueTwoToneDefault.default));
parcelHelpers.export(exports, "Quickreply", ()=>(0, _quickreplyDefault.default));
parcelHelpers.export(exports, "QuickreplyOutlined", ()=>(0, _quickreplyOutlinedDefault.default));
parcelHelpers.export(exports, "QuickreplyRounded", ()=>(0, _quickreplyRoundedDefault.default));
parcelHelpers.export(exports, "QuickreplySharp", ()=>(0, _quickreplySharpDefault.default));
parcelHelpers.export(exports, "QuickreplyTwoTone", ()=>(0, _quickreplyTwoToneDefault.default));
parcelHelpers.export(exports, "Quiz", ()=>(0, _quizDefault.default));
parcelHelpers.export(exports, "QuizOutlined", ()=>(0, _quizOutlinedDefault.default));
parcelHelpers.export(exports, "QuizRounded", ()=>(0, _quizRoundedDefault.default));
parcelHelpers.export(exports, "QuizSharp", ()=>(0, _quizSharpDefault.default));
parcelHelpers.export(exports, "QuizTwoTone", ()=>(0, _quizTwoToneDefault.default));
parcelHelpers.export(exports, "RMobiledata", ()=>(0, _rmobiledataDefault.default));
parcelHelpers.export(exports, "RMobiledataOutlined", ()=>(0, _rmobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "RMobiledataRounded", ()=>(0, _rmobiledataRoundedDefault.default));
parcelHelpers.export(exports, "RMobiledataSharp", ()=>(0, _rmobiledataSharpDefault.default));
parcelHelpers.export(exports, "RMobiledataTwoTone", ()=>(0, _rmobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "Radar", ()=>(0, _radarDefault.default));
parcelHelpers.export(exports, "RadarOutlined", ()=>(0, _radarOutlinedDefault.default));
parcelHelpers.export(exports, "RadarRounded", ()=>(0, _radarRoundedDefault.default));
parcelHelpers.export(exports, "RadarSharp", ()=>(0, _radarSharpDefault.default));
parcelHelpers.export(exports, "RadarTwoTone", ()=>(0, _radarTwoToneDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "RadioButtonChecked", ()=>(0, _radioButtonCheckedDefault.default));
parcelHelpers.export(exports, "RadioButtonCheckedOutlined", ()=>(0, _radioButtonCheckedOutlinedDefault.default));
parcelHelpers.export(exports, "RadioButtonCheckedRounded", ()=>(0, _radioButtonCheckedRoundedDefault.default));
parcelHelpers.export(exports, "RadioButtonCheckedSharp", ()=>(0, _radioButtonCheckedSharpDefault.default));
parcelHelpers.export(exports, "RadioButtonCheckedTwoTone", ()=>(0, _radioButtonCheckedTwoToneDefault.default));
parcelHelpers.export(exports, "RadioButtonUnchecked", ()=>(0, _radioButtonUncheckedDefault.default));
parcelHelpers.export(exports, "RadioButtonUncheckedOutlined", ()=>(0, _radioButtonUncheckedOutlinedDefault.default));
parcelHelpers.export(exports, "RadioButtonUncheckedRounded", ()=>(0, _radioButtonUncheckedRoundedDefault.default));
parcelHelpers.export(exports, "RadioButtonUncheckedSharp", ()=>(0, _radioButtonUncheckedSharpDefault.default));
parcelHelpers.export(exports, "RadioButtonUncheckedTwoTone", ()=>(0, _radioButtonUncheckedTwoToneDefault.default));
parcelHelpers.export(exports, "RadioOutlined", ()=>(0, _radioOutlinedDefault.default));
parcelHelpers.export(exports, "RadioRounded", ()=>(0, _radioRoundedDefault.default));
parcelHelpers.export(exports, "RadioSharp", ()=>(0, _radioSharpDefault.default));
parcelHelpers.export(exports, "RadioTwoTone", ()=>(0, _radioTwoToneDefault.default));
parcelHelpers.export(exports, "RailwayAlert", ()=>(0, _railwayAlertDefault.default));
parcelHelpers.export(exports, "RailwayAlertOutlined", ()=>(0, _railwayAlertOutlinedDefault.default));
parcelHelpers.export(exports, "RailwayAlertRounded", ()=>(0, _railwayAlertRoundedDefault.default));
parcelHelpers.export(exports, "RailwayAlertSharp", ()=>(0, _railwayAlertSharpDefault.default));
parcelHelpers.export(exports, "RailwayAlertTwoTone", ()=>(0, _railwayAlertTwoToneDefault.default));
parcelHelpers.export(exports, "RamenDining", ()=>(0, _ramenDiningDefault.default));
parcelHelpers.export(exports, "RamenDiningOutlined", ()=>(0, _ramenDiningOutlinedDefault.default));
parcelHelpers.export(exports, "RamenDiningRounded", ()=>(0, _ramenDiningRoundedDefault.default));
parcelHelpers.export(exports, "RamenDiningSharp", ()=>(0, _ramenDiningSharpDefault.default));
parcelHelpers.export(exports, "RamenDiningTwoTone", ()=>(0, _ramenDiningTwoToneDefault.default));
parcelHelpers.export(exports, "RampLeft", ()=>(0, _rampLeftDefault.default));
parcelHelpers.export(exports, "RampLeftOutlined", ()=>(0, _rampLeftOutlinedDefault.default));
parcelHelpers.export(exports, "RampLeftRounded", ()=>(0, _rampLeftRoundedDefault.default));
parcelHelpers.export(exports, "RampLeftSharp", ()=>(0, _rampLeftSharpDefault.default));
parcelHelpers.export(exports, "RampLeftTwoTone", ()=>(0, _rampLeftTwoToneDefault.default));
parcelHelpers.export(exports, "RampRight", ()=>(0, _rampRightDefault.default));
parcelHelpers.export(exports, "RampRightOutlined", ()=>(0, _rampRightOutlinedDefault.default));
parcelHelpers.export(exports, "RampRightRounded", ()=>(0, _rampRightRoundedDefault.default));
parcelHelpers.export(exports, "RampRightSharp", ()=>(0, _rampRightSharpDefault.default));
parcelHelpers.export(exports, "RampRightTwoTone", ()=>(0, _rampRightTwoToneDefault.default));
parcelHelpers.export(exports, "RateReview", ()=>(0, _rateReviewDefault.default));
parcelHelpers.export(exports, "RateReviewOutlined", ()=>(0, _rateReviewOutlinedDefault.default));
parcelHelpers.export(exports, "RateReviewRounded", ()=>(0, _rateReviewRoundedDefault.default));
parcelHelpers.export(exports, "RateReviewSharp", ()=>(0, _rateReviewSharpDefault.default));
parcelHelpers.export(exports, "RateReviewTwoTone", ()=>(0, _rateReviewTwoToneDefault.default));
parcelHelpers.export(exports, "RawOff", ()=>(0, _rawOffDefault.default));
parcelHelpers.export(exports, "RawOffOutlined", ()=>(0, _rawOffOutlinedDefault.default));
parcelHelpers.export(exports, "RawOffRounded", ()=>(0, _rawOffRoundedDefault.default));
parcelHelpers.export(exports, "RawOffSharp", ()=>(0, _rawOffSharpDefault.default));
parcelHelpers.export(exports, "RawOffTwoTone", ()=>(0, _rawOffTwoToneDefault.default));
parcelHelpers.export(exports, "RawOn", ()=>(0, _rawOnDefault.default));
parcelHelpers.export(exports, "RawOnOutlined", ()=>(0, _rawOnOutlinedDefault.default));
parcelHelpers.export(exports, "RawOnRounded", ()=>(0, _rawOnRoundedDefault.default));
parcelHelpers.export(exports, "RawOnSharp", ()=>(0, _rawOnSharpDefault.default));
parcelHelpers.export(exports, "RawOnTwoTone", ()=>(0, _rawOnTwoToneDefault.default));
parcelHelpers.export(exports, "ReadMore", ()=>(0, _readMoreDefault.default));
parcelHelpers.export(exports, "ReadMoreOutlined", ()=>(0, _readMoreOutlinedDefault.default));
parcelHelpers.export(exports, "ReadMoreRounded", ()=>(0, _readMoreRoundedDefault.default));
parcelHelpers.export(exports, "ReadMoreSharp", ()=>(0, _readMoreSharpDefault.default));
parcelHelpers.export(exports, "ReadMoreTwoTone", ()=>(0, _readMoreTwoToneDefault.default));
parcelHelpers.export(exports, "Receipt", ()=>(0, _receiptDefault.default));
parcelHelpers.export(exports, "ReceiptLong", ()=>(0, _receiptLongDefault.default));
parcelHelpers.export(exports, "ReceiptLongOutlined", ()=>(0, _receiptLongOutlinedDefault.default));
parcelHelpers.export(exports, "ReceiptLongRounded", ()=>(0, _receiptLongRoundedDefault.default));
parcelHelpers.export(exports, "ReceiptLongSharp", ()=>(0, _receiptLongSharpDefault.default));
parcelHelpers.export(exports, "ReceiptLongTwoTone", ()=>(0, _receiptLongTwoToneDefault.default));
parcelHelpers.export(exports, "ReceiptOutlined", ()=>(0, _receiptOutlinedDefault.default));
parcelHelpers.export(exports, "ReceiptRounded", ()=>(0, _receiptRoundedDefault.default));
parcelHelpers.export(exports, "ReceiptSharp", ()=>(0, _receiptSharpDefault.default));
parcelHelpers.export(exports, "ReceiptTwoTone", ()=>(0, _receiptTwoToneDefault.default));
parcelHelpers.export(exports, "RecentActors", ()=>(0, _recentActorsDefault.default));
parcelHelpers.export(exports, "RecentActorsOutlined", ()=>(0, _recentActorsOutlinedDefault.default));
parcelHelpers.export(exports, "RecentActorsRounded", ()=>(0, _recentActorsRoundedDefault.default));
parcelHelpers.export(exports, "RecentActorsSharp", ()=>(0, _recentActorsSharpDefault.default));
parcelHelpers.export(exports, "RecentActorsTwoTone", ()=>(0, _recentActorsTwoToneDefault.default));
parcelHelpers.export(exports, "Recommend", ()=>(0, _recommendDefault.default));
parcelHelpers.export(exports, "RecommendOutlined", ()=>(0, _recommendOutlinedDefault.default));
parcelHelpers.export(exports, "RecommendRounded", ()=>(0, _recommendRoundedDefault.default));
parcelHelpers.export(exports, "RecommendSharp", ()=>(0, _recommendSharpDefault.default));
parcelHelpers.export(exports, "RecommendTwoTone", ()=>(0, _recommendTwoToneDefault.default));
parcelHelpers.export(exports, "RecordVoiceOver", ()=>(0, _recordVoiceOverDefault.default));
parcelHelpers.export(exports, "RecordVoiceOverOutlined", ()=>(0, _recordVoiceOverOutlinedDefault.default));
parcelHelpers.export(exports, "RecordVoiceOverRounded", ()=>(0, _recordVoiceOverRoundedDefault.default));
parcelHelpers.export(exports, "RecordVoiceOverSharp", ()=>(0, _recordVoiceOverSharpDefault.default));
parcelHelpers.export(exports, "RecordVoiceOverTwoTone", ()=>(0, _recordVoiceOverTwoToneDefault.default));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangleDefault.default));
parcelHelpers.export(exports, "RectangleOutlined", ()=>(0, _rectangleOutlinedDefault.default));
parcelHelpers.export(exports, "RectangleRounded", ()=>(0, _rectangleRoundedDefault.default));
parcelHelpers.export(exports, "RectangleSharp", ()=>(0, _rectangleSharpDefault.default));
parcelHelpers.export(exports, "RectangleTwoTone", ()=>(0, _rectangleTwoToneDefault.default));
parcelHelpers.export(exports, "Recycling", ()=>(0, _recyclingDefault.default));
parcelHelpers.export(exports, "RecyclingOutlined", ()=>(0, _recyclingOutlinedDefault.default));
parcelHelpers.export(exports, "RecyclingRounded", ()=>(0, _recyclingRoundedDefault.default));
parcelHelpers.export(exports, "RecyclingSharp", ()=>(0, _recyclingSharpDefault.default));
parcelHelpers.export(exports, "RecyclingTwoTone", ()=>(0, _recyclingTwoToneDefault.default));
parcelHelpers.export(exports, "Reddit", ()=>(0, _redditDefault.default));
parcelHelpers.export(exports, "Redeem", ()=>(0, _redeemDefault.default));
parcelHelpers.export(exports, "RedeemOutlined", ()=>(0, _redeemOutlinedDefault.default));
parcelHelpers.export(exports, "RedeemRounded", ()=>(0, _redeemRoundedDefault.default));
parcelHelpers.export(exports, "RedeemSharp", ()=>(0, _redeemSharpDefault.default));
parcelHelpers.export(exports, "RedeemTwoTone", ()=>(0, _redeemTwoToneDefault.default));
parcelHelpers.export(exports, "Redo", ()=>(0, _redoDefault.default));
parcelHelpers.export(exports, "RedoOutlined", ()=>(0, _redoOutlinedDefault.default));
parcelHelpers.export(exports, "RedoRounded", ()=>(0, _redoRoundedDefault.default));
parcelHelpers.export(exports, "RedoSharp", ()=>(0, _redoSharpDefault.default));
parcelHelpers.export(exports, "RedoTwoTone", ()=>(0, _redoTwoToneDefault.default));
parcelHelpers.export(exports, "ReduceCapacity", ()=>(0, _reduceCapacityDefault.default));
parcelHelpers.export(exports, "ReduceCapacityOutlined", ()=>(0, _reduceCapacityOutlinedDefault.default));
parcelHelpers.export(exports, "ReduceCapacityRounded", ()=>(0, _reduceCapacityRoundedDefault.default));
parcelHelpers.export(exports, "ReduceCapacitySharp", ()=>(0, _reduceCapacitySharpDefault.default));
parcelHelpers.export(exports, "ReduceCapacityTwoTone", ()=>(0, _reduceCapacityTwoToneDefault.default));
parcelHelpers.export(exports, "Refresh", ()=>(0, _refreshDefault.default));
parcelHelpers.export(exports, "RefreshOutlined", ()=>(0, _refreshOutlinedDefault.default));
parcelHelpers.export(exports, "RefreshRounded", ()=>(0, _refreshRoundedDefault.default));
parcelHelpers.export(exports, "RefreshSharp", ()=>(0, _refreshSharpDefault.default));
parcelHelpers.export(exports, "RefreshTwoTone", ()=>(0, _refreshTwoToneDefault.default));
parcelHelpers.export(exports, "RememberMe", ()=>(0, _rememberMeDefault.default));
parcelHelpers.export(exports, "RememberMeOutlined", ()=>(0, _rememberMeOutlinedDefault.default));
parcelHelpers.export(exports, "RememberMeRounded", ()=>(0, _rememberMeRoundedDefault.default));
parcelHelpers.export(exports, "RememberMeSharp", ()=>(0, _rememberMeSharpDefault.default));
parcelHelpers.export(exports, "RememberMeTwoTone", ()=>(0, _rememberMeTwoToneDefault.default));
parcelHelpers.export(exports, "Remove", ()=>(0, _removeDefault.default));
parcelHelpers.export(exports, "RemoveCircle", ()=>(0, _removeCircleDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutline", ()=>(0, _removeCircleOutlineDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutlineOutlined", ()=>(0, _removeCircleOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutlineRounded", ()=>(0, _removeCircleOutlineRoundedDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutlineSharp", ()=>(0, _removeCircleOutlineSharpDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutlineTwoTone", ()=>(0, _removeCircleOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveCircleOutlined", ()=>(0, _removeCircleOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveCircleRounded", ()=>(0, _removeCircleRoundedDefault.default));
parcelHelpers.export(exports, "RemoveCircleSharp", ()=>(0, _removeCircleSharpDefault.default));
parcelHelpers.export(exports, "RemoveCircleTwoTone", ()=>(0, _removeCircleTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveDone", ()=>(0, _removeDoneDefault.default));
parcelHelpers.export(exports, "RemoveDoneOutlined", ()=>(0, _removeDoneOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveDoneRounded", ()=>(0, _removeDoneRoundedDefault.default));
parcelHelpers.export(exports, "RemoveDoneSharp", ()=>(0, _removeDoneSharpDefault.default));
parcelHelpers.export(exports, "RemoveDoneTwoTone", ()=>(0, _removeDoneTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveFromQueue", ()=>(0, _removeFromQueueDefault.default));
parcelHelpers.export(exports, "RemoveFromQueueOutlined", ()=>(0, _removeFromQueueOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveFromQueueRounded", ()=>(0, _removeFromQueueRoundedDefault.default));
parcelHelpers.export(exports, "RemoveFromQueueSharp", ()=>(0, _removeFromQueueSharpDefault.default));
parcelHelpers.export(exports, "RemoveFromQueueTwoTone", ()=>(0, _removeFromQueueTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveModerator", ()=>(0, _removeModeratorDefault.default));
parcelHelpers.export(exports, "RemoveModeratorOutlined", ()=>(0, _removeModeratorOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveModeratorRounded", ()=>(0, _removeModeratorRoundedDefault.default));
parcelHelpers.export(exports, "RemoveModeratorSharp", ()=>(0, _removeModeratorSharpDefault.default));
parcelHelpers.export(exports, "RemoveModeratorTwoTone", ()=>(0, _removeModeratorTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveOutlined", ()=>(0, _removeOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveRedEye", ()=>(0, _removeRedEyeDefault.default));
parcelHelpers.export(exports, "RemoveRedEyeOutlined", ()=>(0, _removeRedEyeOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveRedEyeRounded", ()=>(0, _removeRedEyeRoundedDefault.default));
parcelHelpers.export(exports, "RemoveRedEyeSharp", ()=>(0, _removeRedEyeSharpDefault.default));
parcelHelpers.export(exports, "RemoveRedEyeTwoTone", ()=>(0, _removeRedEyeTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveRoad", ()=>(0, _removeRoadDefault.default));
parcelHelpers.export(exports, "RemoveRoadOutlined", ()=>(0, _removeRoadOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveRoadRounded", ()=>(0, _removeRoadRoundedDefault.default));
parcelHelpers.export(exports, "RemoveRoadSharp", ()=>(0, _removeRoadSharpDefault.default));
parcelHelpers.export(exports, "RemoveRoadTwoTone", ()=>(0, _removeRoadTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveRounded", ()=>(0, _removeRoundedDefault.default));
parcelHelpers.export(exports, "RemoveSharp", ()=>(0, _removeSharpDefault.default));
parcelHelpers.export(exports, "RemoveShoppingCart", ()=>(0, _removeShoppingCartDefault.default));
parcelHelpers.export(exports, "RemoveShoppingCartOutlined", ()=>(0, _removeShoppingCartOutlinedDefault.default));
parcelHelpers.export(exports, "RemoveShoppingCartRounded", ()=>(0, _removeShoppingCartRoundedDefault.default));
parcelHelpers.export(exports, "RemoveShoppingCartSharp", ()=>(0, _removeShoppingCartSharpDefault.default));
parcelHelpers.export(exports, "RemoveShoppingCartTwoTone", ()=>(0, _removeShoppingCartTwoToneDefault.default));
parcelHelpers.export(exports, "RemoveTwoTone", ()=>(0, _removeTwoToneDefault.default));
parcelHelpers.export(exports, "Reorder", ()=>(0, _reorderDefault.default));
parcelHelpers.export(exports, "ReorderOutlined", ()=>(0, _reorderOutlinedDefault.default));
parcelHelpers.export(exports, "ReorderRounded", ()=>(0, _reorderRoundedDefault.default));
parcelHelpers.export(exports, "ReorderSharp", ()=>(0, _reorderSharpDefault.default));
parcelHelpers.export(exports, "ReorderTwoTone", ()=>(0, _reorderTwoToneDefault.default));
parcelHelpers.export(exports, "Repartition", ()=>(0, _repartitionDefault.default));
parcelHelpers.export(exports, "RepartitionOutlined", ()=>(0, _repartitionOutlinedDefault.default));
parcelHelpers.export(exports, "RepartitionRounded", ()=>(0, _repartitionRoundedDefault.default));
parcelHelpers.export(exports, "RepartitionSharp", ()=>(0, _repartitionSharpDefault.default));
parcelHelpers.export(exports, "RepartitionTwoTone", ()=>(0, _repartitionTwoToneDefault.default));
parcelHelpers.export(exports, "Repeat", ()=>(0, _repeatDefault.default));
parcelHelpers.export(exports, "RepeatOn", ()=>(0, _repeatOnDefault.default));
parcelHelpers.export(exports, "RepeatOnOutlined", ()=>(0, _repeatOnOutlinedDefault.default));
parcelHelpers.export(exports, "RepeatOnRounded", ()=>(0, _repeatOnRoundedDefault.default));
parcelHelpers.export(exports, "RepeatOnSharp", ()=>(0, _repeatOnSharpDefault.default));
parcelHelpers.export(exports, "RepeatOnTwoTone", ()=>(0, _repeatOnTwoToneDefault.default));
parcelHelpers.export(exports, "RepeatOne", ()=>(0, _repeatOneDefault.default));
parcelHelpers.export(exports, "RepeatOneOn", ()=>(0, _repeatOneOnDefault.default));
parcelHelpers.export(exports, "RepeatOneOnOutlined", ()=>(0, _repeatOneOnOutlinedDefault.default));
parcelHelpers.export(exports, "RepeatOneOnRounded", ()=>(0, _repeatOneOnRoundedDefault.default));
parcelHelpers.export(exports, "RepeatOneOnSharp", ()=>(0, _repeatOneOnSharpDefault.default));
parcelHelpers.export(exports, "RepeatOneOnTwoTone", ()=>(0, _repeatOneOnTwoToneDefault.default));
parcelHelpers.export(exports, "RepeatOneOutlined", ()=>(0, _repeatOneOutlinedDefault.default));
parcelHelpers.export(exports, "RepeatOneRounded", ()=>(0, _repeatOneRoundedDefault.default));
parcelHelpers.export(exports, "RepeatOneSharp", ()=>(0, _repeatOneSharpDefault.default));
parcelHelpers.export(exports, "RepeatOneTwoTone", ()=>(0, _repeatOneTwoToneDefault.default));
parcelHelpers.export(exports, "RepeatOutlined", ()=>(0, _repeatOutlinedDefault.default));
parcelHelpers.export(exports, "RepeatRounded", ()=>(0, _repeatRoundedDefault.default));
parcelHelpers.export(exports, "RepeatSharp", ()=>(0, _repeatSharpDefault.default));
parcelHelpers.export(exports, "RepeatTwoTone", ()=>(0, _repeatTwoToneDefault.default));
parcelHelpers.export(exports, "Replay", ()=>(0, _replayDefault.default));
parcelHelpers.export(exports, "Replay10", ()=>(0, _replay10Default.default));
parcelHelpers.export(exports, "Replay10Outlined", ()=>(0, _replay10OutlinedDefault.default));
parcelHelpers.export(exports, "Replay10Rounded", ()=>(0, _replay10RoundedDefault.default));
parcelHelpers.export(exports, "Replay10Sharp", ()=>(0, _replay10SharpDefault.default));
parcelHelpers.export(exports, "Replay10TwoTone", ()=>(0, _replay10TwoToneDefault.default));
parcelHelpers.export(exports, "Replay30", ()=>(0, _replay30Default.default));
parcelHelpers.export(exports, "Replay30Outlined", ()=>(0, _replay30OutlinedDefault.default));
parcelHelpers.export(exports, "Replay30Rounded", ()=>(0, _replay30RoundedDefault.default));
parcelHelpers.export(exports, "Replay30Sharp", ()=>(0, _replay30SharpDefault.default));
parcelHelpers.export(exports, "Replay30TwoTone", ()=>(0, _replay30TwoToneDefault.default));
parcelHelpers.export(exports, "Replay5", ()=>(0, _replay5Default.default));
parcelHelpers.export(exports, "Replay5Outlined", ()=>(0, _replay5OutlinedDefault.default));
parcelHelpers.export(exports, "Replay5Rounded", ()=>(0, _replay5RoundedDefault.default));
parcelHelpers.export(exports, "Replay5Sharp", ()=>(0, _replay5SharpDefault.default));
parcelHelpers.export(exports, "Replay5TwoTone", ()=>(0, _replay5TwoToneDefault.default));
parcelHelpers.export(exports, "ReplayCircleFilled", ()=>(0, _replayCircleFilledDefault.default));
parcelHelpers.export(exports, "ReplayCircleFilledOutlined", ()=>(0, _replayCircleFilledOutlinedDefault.default));
parcelHelpers.export(exports, "ReplayCircleFilledRounded", ()=>(0, _replayCircleFilledRoundedDefault.default));
parcelHelpers.export(exports, "ReplayCircleFilledSharp", ()=>(0, _replayCircleFilledSharpDefault.default));
parcelHelpers.export(exports, "ReplayCircleFilledTwoTone", ()=>(0, _replayCircleFilledTwoToneDefault.default));
parcelHelpers.export(exports, "ReplayOutlined", ()=>(0, _replayOutlinedDefault.default));
parcelHelpers.export(exports, "ReplayRounded", ()=>(0, _replayRoundedDefault.default));
parcelHelpers.export(exports, "ReplaySharp", ()=>(0, _replaySharpDefault.default));
parcelHelpers.export(exports, "ReplayTwoTone", ()=>(0, _replayTwoToneDefault.default));
parcelHelpers.export(exports, "Reply", ()=>(0, _replyDefault.default));
parcelHelpers.export(exports, "ReplyAll", ()=>(0, _replyAllDefault.default));
parcelHelpers.export(exports, "ReplyAllOutlined", ()=>(0, _replyAllOutlinedDefault.default));
parcelHelpers.export(exports, "ReplyAllRounded", ()=>(0, _replyAllRoundedDefault.default));
parcelHelpers.export(exports, "ReplyAllSharp", ()=>(0, _replyAllSharpDefault.default));
parcelHelpers.export(exports, "ReplyAllTwoTone", ()=>(0, _replyAllTwoToneDefault.default));
parcelHelpers.export(exports, "ReplyOutlined", ()=>(0, _replyOutlinedDefault.default));
parcelHelpers.export(exports, "ReplyRounded", ()=>(0, _replyRoundedDefault.default));
parcelHelpers.export(exports, "ReplySharp", ()=>(0, _replySharpDefault.default));
parcelHelpers.export(exports, "ReplyTwoTone", ()=>(0, _replyTwoToneDefault.default));
parcelHelpers.export(exports, "Report", ()=>(0, _reportDefault.default));
parcelHelpers.export(exports, "ReportGmailerrorred", ()=>(0, _reportGmailerrorredDefault.default));
parcelHelpers.export(exports, "ReportGmailerrorredOutlined", ()=>(0, _reportGmailerrorredOutlinedDefault.default));
parcelHelpers.export(exports, "ReportGmailerrorredRounded", ()=>(0, _reportGmailerrorredRoundedDefault.default));
parcelHelpers.export(exports, "ReportGmailerrorredSharp", ()=>(0, _reportGmailerrorredSharpDefault.default));
parcelHelpers.export(exports, "ReportGmailerrorredTwoTone", ()=>(0, _reportGmailerrorredTwoToneDefault.default));
parcelHelpers.export(exports, "ReportOff", ()=>(0, _reportOffDefault.default));
parcelHelpers.export(exports, "ReportOffOutlined", ()=>(0, _reportOffOutlinedDefault.default));
parcelHelpers.export(exports, "ReportOffRounded", ()=>(0, _reportOffRoundedDefault.default));
parcelHelpers.export(exports, "ReportOffSharp", ()=>(0, _reportOffSharpDefault.default));
parcelHelpers.export(exports, "ReportOffTwoTone", ()=>(0, _reportOffTwoToneDefault.default));
parcelHelpers.export(exports, "ReportOutlined", ()=>(0, _reportOutlinedDefault.default));
parcelHelpers.export(exports, "ReportProblem", ()=>(0, _reportProblemDefault.default));
parcelHelpers.export(exports, "ReportProblemOutlined", ()=>(0, _reportProblemOutlinedDefault.default));
parcelHelpers.export(exports, "ReportProblemRounded", ()=>(0, _reportProblemRoundedDefault.default));
parcelHelpers.export(exports, "ReportProblemSharp", ()=>(0, _reportProblemSharpDefault.default));
parcelHelpers.export(exports, "ReportProblemTwoTone", ()=>(0, _reportProblemTwoToneDefault.default));
parcelHelpers.export(exports, "ReportRounded", ()=>(0, _reportRoundedDefault.default));
parcelHelpers.export(exports, "ReportSharp", ()=>(0, _reportSharpDefault.default));
parcelHelpers.export(exports, "ReportTwoTone", ()=>(0, _reportTwoToneDefault.default));
parcelHelpers.export(exports, "RequestPage", ()=>(0, _requestPageDefault.default));
parcelHelpers.export(exports, "RequestPageOutlined", ()=>(0, _requestPageOutlinedDefault.default));
parcelHelpers.export(exports, "RequestPageRounded", ()=>(0, _requestPageRoundedDefault.default));
parcelHelpers.export(exports, "RequestPageSharp", ()=>(0, _requestPageSharpDefault.default));
parcelHelpers.export(exports, "RequestPageTwoTone", ()=>(0, _requestPageTwoToneDefault.default));
parcelHelpers.export(exports, "RequestQuote", ()=>(0, _requestQuoteDefault.default));
parcelHelpers.export(exports, "RequestQuoteOutlined", ()=>(0, _requestQuoteOutlinedDefault.default));
parcelHelpers.export(exports, "RequestQuoteRounded", ()=>(0, _requestQuoteRoundedDefault.default));
parcelHelpers.export(exports, "RequestQuoteSharp", ()=>(0, _requestQuoteSharpDefault.default));
parcelHelpers.export(exports, "RequestQuoteTwoTone", ()=>(0, _requestQuoteTwoToneDefault.default));
parcelHelpers.export(exports, "ResetTv", ()=>(0, _resetTvDefault.default));
parcelHelpers.export(exports, "ResetTvOutlined", ()=>(0, _resetTvOutlinedDefault.default));
parcelHelpers.export(exports, "ResetTvRounded", ()=>(0, _resetTvRoundedDefault.default));
parcelHelpers.export(exports, "ResetTvSharp", ()=>(0, _resetTvSharpDefault.default));
parcelHelpers.export(exports, "ResetTvTwoTone", ()=>(0, _resetTvTwoToneDefault.default));
parcelHelpers.export(exports, "RestartAlt", ()=>(0, _restartAltDefault.default));
parcelHelpers.export(exports, "RestartAltOutlined", ()=>(0, _restartAltOutlinedDefault.default));
parcelHelpers.export(exports, "RestartAltRounded", ()=>(0, _restartAltRoundedDefault.default));
parcelHelpers.export(exports, "RestartAltSharp", ()=>(0, _restartAltSharpDefault.default));
parcelHelpers.export(exports, "RestartAltTwoTone", ()=>(0, _restartAltTwoToneDefault.default));
parcelHelpers.export(exports, "Restaurant", ()=>(0, _restaurantDefault.default));
parcelHelpers.export(exports, "RestaurantMenu", ()=>(0, _restaurantMenuDefault.default));
parcelHelpers.export(exports, "RestaurantMenuOutlined", ()=>(0, _restaurantMenuOutlinedDefault.default));
parcelHelpers.export(exports, "RestaurantMenuRounded", ()=>(0, _restaurantMenuRoundedDefault.default));
parcelHelpers.export(exports, "RestaurantMenuSharp", ()=>(0, _restaurantMenuSharpDefault.default));
parcelHelpers.export(exports, "RestaurantMenuTwoTone", ()=>(0, _restaurantMenuTwoToneDefault.default));
parcelHelpers.export(exports, "RestaurantOutlined", ()=>(0, _restaurantOutlinedDefault.default));
parcelHelpers.export(exports, "RestaurantRounded", ()=>(0, _restaurantRoundedDefault.default));
parcelHelpers.export(exports, "RestaurantSharp", ()=>(0, _restaurantSharpDefault.default));
parcelHelpers.export(exports, "RestaurantTwoTone", ()=>(0, _restaurantTwoToneDefault.default));
parcelHelpers.export(exports, "Restore", ()=>(0, _restoreDefault.default));
parcelHelpers.export(exports, "RestoreFromTrash", ()=>(0, _restoreFromTrashDefault.default));
parcelHelpers.export(exports, "RestoreFromTrashOutlined", ()=>(0, _restoreFromTrashOutlinedDefault.default));
parcelHelpers.export(exports, "RestoreFromTrashRounded", ()=>(0, _restoreFromTrashRoundedDefault.default));
parcelHelpers.export(exports, "RestoreFromTrashSharp", ()=>(0, _restoreFromTrashSharpDefault.default));
parcelHelpers.export(exports, "RestoreFromTrashTwoTone", ()=>(0, _restoreFromTrashTwoToneDefault.default));
parcelHelpers.export(exports, "RestoreOutlined", ()=>(0, _restoreOutlinedDefault.default));
parcelHelpers.export(exports, "RestorePage", ()=>(0, _restorePageDefault.default));
parcelHelpers.export(exports, "RestorePageOutlined", ()=>(0, _restorePageOutlinedDefault.default));
parcelHelpers.export(exports, "RestorePageRounded", ()=>(0, _restorePageRoundedDefault.default));
parcelHelpers.export(exports, "RestorePageSharp", ()=>(0, _restorePageSharpDefault.default));
parcelHelpers.export(exports, "RestorePageTwoTone", ()=>(0, _restorePageTwoToneDefault.default));
parcelHelpers.export(exports, "RestoreRounded", ()=>(0, _restoreRoundedDefault.default));
parcelHelpers.export(exports, "RestoreSharp", ()=>(0, _restoreSharpDefault.default));
parcelHelpers.export(exports, "RestoreTwoTone", ()=>(0, _restoreTwoToneDefault.default));
parcelHelpers.export(exports, "Reviews", ()=>(0, _reviewsDefault.default));
parcelHelpers.export(exports, "ReviewsOutlined", ()=>(0, _reviewsOutlinedDefault.default));
parcelHelpers.export(exports, "ReviewsRounded", ()=>(0, _reviewsRoundedDefault.default));
parcelHelpers.export(exports, "ReviewsSharp", ()=>(0, _reviewsSharpDefault.default));
parcelHelpers.export(exports, "ReviewsTwoTone", ()=>(0, _reviewsTwoToneDefault.default));
parcelHelpers.export(exports, "RiceBowl", ()=>(0, _riceBowlDefault.default));
parcelHelpers.export(exports, "RiceBowlOutlined", ()=>(0, _riceBowlOutlinedDefault.default));
parcelHelpers.export(exports, "RiceBowlRounded", ()=>(0, _riceBowlRoundedDefault.default));
parcelHelpers.export(exports, "RiceBowlSharp", ()=>(0, _riceBowlSharpDefault.default));
parcelHelpers.export(exports, "RiceBowlTwoTone", ()=>(0, _riceBowlTwoToneDefault.default));
parcelHelpers.export(exports, "RingVolume", ()=>(0, _ringVolumeDefault.default));
parcelHelpers.export(exports, "RingVolumeOutlined", ()=>(0, _ringVolumeOutlinedDefault.default));
parcelHelpers.export(exports, "RingVolumeRounded", ()=>(0, _ringVolumeRoundedDefault.default));
parcelHelpers.export(exports, "RingVolumeSharp", ()=>(0, _ringVolumeSharpDefault.default));
parcelHelpers.export(exports, "RingVolumeTwoTone", ()=>(0, _ringVolumeTwoToneDefault.default));
parcelHelpers.export(exports, "Rocket", ()=>(0, _rocketDefault.default));
parcelHelpers.export(exports, "RocketLaunch", ()=>(0, _rocketLaunchDefault.default));
parcelHelpers.export(exports, "RocketLaunchOutlined", ()=>(0, _rocketLaunchOutlinedDefault.default));
parcelHelpers.export(exports, "RocketLaunchRounded", ()=>(0, _rocketLaunchRoundedDefault.default));
parcelHelpers.export(exports, "RocketLaunchSharp", ()=>(0, _rocketLaunchSharpDefault.default));
parcelHelpers.export(exports, "RocketLaunchTwoTone", ()=>(0, _rocketLaunchTwoToneDefault.default));
parcelHelpers.export(exports, "RocketOutlined", ()=>(0, _rocketOutlinedDefault.default));
parcelHelpers.export(exports, "RocketRounded", ()=>(0, _rocketRoundedDefault.default));
parcelHelpers.export(exports, "RocketSharp", ()=>(0, _rocketSharpDefault.default));
parcelHelpers.export(exports, "RocketTwoTone", ()=>(0, _rocketTwoToneDefault.default));
parcelHelpers.export(exports, "RollerShades", ()=>(0, _rollerShadesDefault.default));
parcelHelpers.export(exports, "RollerShadesClosed", ()=>(0, _rollerShadesClosedDefault.default));
parcelHelpers.export(exports, "RollerShadesClosedOutlined", ()=>(0, _rollerShadesClosedOutlinedDefault.default));
parcelHelpers.export(exports, "RollerShadesClosedRounded", ()=>(0, _rollerShadesClosedRoundedDefault.default));
parcelHelpers.export(exports, "RollerShadesClosedSharp", ()=>(0, _rollerShadesClosedSharpDefault.default));
parcelHelpers.export(exports, "RollerShadesClosedTwoTone", ()=>(0, _rollerShadesClosedTwoToneDefault.default));
parcelHelpers.export(exports, "RollerShadesOutlined", ()=>(0, _rollerShadesOutlinedDefault.default));
parcelHelpers.export(exports, "RollerShadesRounded", ()=>(0, _rollerShadesRoundedDefault.default));
parcelHelpers.export(exports, "RollerShadesSharp", ()=>(0, _rollerShadesSharpDefault.default));
parcelHelpers.export(exports, "RollerShadesTwoTone", ()=>(0, _rollerShadesTwoToneDefault.default));
parcelHelpers.export(exports, "RollerSkating", ()=>(0, _rollerSkatingDefault.default));
parcelHelpers.export(exports, "RollerSkatingOutlined", ()=>(0, _rollerSkatingOutlinedDefault.default));
parcelHelpers.export(exports, "RollerSkatingRounded", ()=>(0, _rollerSkatingRoundedDefault.default));
parcelHelpers.export(exports, "RollerSkatingSharp", ()=>(0, _rollerSkatingSharpDefault.default));
parcelHelpers.export(exports, "RollerSkatingTwoTone", ()=>(0, _rollerSkatingTwoToneDefault.default));
parcelHelpers.export(exports, "Roofing", ()=>(0, _roofingDefault.default));
parcelHelpers.export(exports, "RoofingOutlined", ()=>(0, _roofingOutlinedDefault.default));
parcelHelpers.export(exports, "RoofingRounded", ()=>(0, _roofingRoundedDefault.default));
parcelHelpers.export(exports, "RoofingSharp", ()=>(0, _roofingSharpDefault.default));
parcelHelpers.export(exports, "RoofingTwoTone", ()=>(0, _roofingTwoToneDefault.default));
parcelHelpers.export(exports, "Room", ()=>(0, _roomDefault.default));
parcelHelpers.export(exports, "RoomOutlined", ()=>(0, _roomOutlinedDefault.default));
parcelHelpers.export(exports, "RoomPreferences", ()=>(0, _roomPreferencesDefault.default));
parcelHelpers.export(exports, "RoomPreferencesOutlined", ()=>(0, _roomPreferencesOutlinedDefault.default));
parcelHelpers.export(exports, "RoomPreferencesRounded", ()=>(0, _roomPreferencesRoundedDefault.default));
parcelHelpers.export(exports, "RoomPreferencesSharp", ()=>(0, _roomPreferencesSharpDefault.default));
parcelHelpers.export(exports, "RoomPreferencesTwoTone", ()=>(0, _roomPreferencesTwoToneDefault.default));
parcelHelpers.export(exports, "RoomRounded", ()=>(0, _roomRoundedDefault.default));
parcelHelpers.export(exports, "RoomService", ()=>(0, _roomServiceDefault.default));
parcelHelpers.export(exports, "RoomServiceOutlined", ()=>(0, _roomServiceOutlinedDefault.default));
parcelHelpers.export(exports, "RoomServiceRounded", ()=>(0, _roomServiceRoundedDefault.default));
parcelHelpers.export(exports, "RoomServiceSharp", ()=>(0, _roomServiceSharpDefault.default));
parcelHelpers.export(exports, "RoomServiceTwoTone", ()=>(0, _roomServiceTwoToneDefault.default));
parcelHelpers.export(exports, "RoomSharp", ()=>(0, _roomSharpDefault.default));
parcelHelpers.export(exports, "RoomTwoTone", ()=>(0, _roomTwoToneDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCcw", ()=>(0, _rotate90DegreesCcwDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCcwOutlined", ()=>(0, _rotate90DegreesCcwOutlinedDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCcwRounded", ()=>(0, _rotate90DegreesCcwRoundedDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCcwSharp", ()=>(0, _rotate90DegreesCcwSharpDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCcwTwoTone", ()=>(0, _rotate90DegreesCcwTwoToneDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCw", ()=>(0, _rotate90DegreesCwDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCwOutlined", ()=>(0, _rotate90DegreesCwOutlinedDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCwRounded", ()=>(0, _rotate90DegreesCwRoundedDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCwSharp", ()=>(0, _rotate90DegreesCwSharpDefault.default));
parcelHelpers.export(exports, "Rotate90DegreesCwTwoTone", ()=>(0, _rotate90DegreesCwTwoToneDefault.default));
parcelHelpers.export(exports, "RotateLeft", ()=>(0, _rotateLeftDefault.default));
parcelHelpers.export(exports, "RotateLeftOutlined", ()=>(0, _rotateLeftOutlinedDefault.default));
parcelHelpers.export(exports, "RotateLeftRounded", ()=>(0, _rotateLeftRoundedDefault.default));
parcelHelpers.export(exports, "RotateLeftSharp", ()=>(0, _rotateLeftSharpDefault.default));
parcelHelpers.export(exports, "RotateLeftTwoTone", ()=>(0, _rotateLeftTwoToneDefault.default));
parcelHelpers.export(exports, "RotateRight", ()=>(0, _rotateRightDefault.default));
parcelHelpers.export(exports, "RotateRightOutlined", ()=>(0, _rotateRightOutlinedDefault.default));
parcelHelpers.export(exports, "RotateRightRounded", ()=>(0, _rotateRightRoundedDefault.default));
parcelHelpers.export(exports, "RotateRightSharp", ()=>(0, _rotateRightSharpDefault.default));
parcelHelpers.export(exports, "RotateRightTwoTone", ()=>(0, _rotateRightTwoToneDefault.default));
parcelHelpers.export(exports, "RoundaboutLeft", ()=>(0, _roundaboutLeftDefault.default));
parcelHelpers.export(exports, "RoundaboutLeftOutlined", ()=>(0, _roundaboutLeftOutlinedDefault.default));
parcelHelpers.export(exports, "RoundaboutLeftRounded", ()=>(0, _roundaboutLeftRoundedDefault.default));
parcelHelpers.export(exports, "RoundaboutLeftSharp", ()=>(0, _roundaboutLeftSharpDefault.default));
parcelHelpers.export(exports, "RoundaboutLeftTwoTone", ()=>(0, _roundaboutLeftTwoToneDefault.default));
parcelHelpers.export(exports, "RoundaboutRight", ()=>(0, _roundaboutRightDefault.default));
parcelHelpers.export(exports, "RoundaboutRightOutlined", ()=>(0, _roundaboutRightOutlinedDefault.default));
parcelHelpers.export(exports, "RoundaboutRightRounded", ()=>(0, _roundaboutRightRoundedDefault.default));
parcelHelpers.export(exports, "RoundaboutRightSharp", ()=>(0, _roundaboutRightSharpDefault.default));
parcelHelpers.export(exports, "RoundaboutRightTwoTone", ()=>(0, _roundaboutRightTwoToneDefault.default));
parcelHelpers.export(exports, "RoundedCorner", ()=>(0, _roundedCornerDefault.default));
parcelHelpers.export(exports, "RoundedCornerOutlined", ()=>(0, _roundedCornerOutlinedDefault.default));
parcelHelpers.export(exports, "RoundedCornerRounded", ()=>(0, _roundedCornerRoundedDefault.default));
parcelHelpers.export(exports, "RoundedCornerSharp", ()=>(0, _roundedCornerSharpDefault.default));
parcelHelpers.export(exports, "RoundedCornerTwoTone", ()=>(0, _roundedCornerTwoToneDefault.default));
parcelHelpers.export(exports, "Route", ()=>(0, _routeDefault.default));
parcelHelpers.export(exports, "RouteOutlined", ()=>(0, _routeOutlinedDefault.default));
parcelHelpers.export(exports, "RouteRounded", ()=>(0, _routeRoundedDefault.default));
parcelHelpers.export(exports, "RouteSharp", ()=>(0, _routeSharpDefault.default));
parcelHelpers.export(exports, "RouteTwoTone", ()=>(0, _routeTwoToneDefault.default));
parcelHelpers.export(exports, "Router", ()=>(0, _routerDefault.default));
parcelHelpers.export(exports, "RouterOutlined", ()=>(0, _routerOutlinedDefault.default));
parcelHelpers.export(exports, "RouterRounded", ()=>(0, _routerRoundedDefault.default));
parcelHelpers.export(exports, "RouterSharp", ()=>(0, _routerSharpDefault.default));
parcelHelpers.export(exports, "RouterTwoTone", ()=>(0, _routerTwoToneDefault.default));
parcelHelpers.export(exports, "Rowing", ()=>(0, _rowingDefault.default));
parcelHelpers.export(exports, "RowingOutlined", ()=>(0, _rowingOutlinedDefault.default));
parcelHelpers.export(exports, "RowingRounded", ()=>(0, _rowingRoundedDefault.default));
parcelHelpers.export(exports, "RowingSharp", ()=>(0, _rowingSharpDefault.default));
parcelHelpers.export(exports, "RowingTwoTone", ()=>(0, _rowingTwoToneDefault.default));
parcelHelpers.export(exports, "RssFeed", ()=>(0, _rssFeedDefault.default));
parcelHelpers.export(exports, "RssFeedOutlined", ()=>(0, _rssFeedOutlinedDefault.default));
parcelHelpers.export(exports, "RssFeedRounded", ()=>(0, _rssFeedRoundedDefault.default));
parcelHelpers.export(exports, "RssFeedSharp", ()=>(0, _rssFeedSharpDefault.default));
parcelHelpers.export(exports, "RssFeedTwoTone", ()=>(0, _rssFeedTwoToneDefault.default));
parcelHelpers.export(exports, "Rsvp", ()=>(0, _rsvpDefault.default));
parcelHelpers.export(exports, "RsvpOutlined", ()=>(0, _rsvpOutlinedDefault.default));
parcelHelpers.export(exports, "RsvpRounded", ()=>(0, _rsvpRoundedDefault.default));
parcelHelpers.export(exports, "RsvpSharp", ()=>(0, _rsvpSharpDefault.default));
parcelHelpers.export(exports, "RsvpTwoTone", ()=>(0, _rsvpTwoToneDefault.default));
parcelHelpers.export(exports, "Rtt", ()=>(0, _rttDefault.default));
parcelHelpers.export(exports, "RttOutlined", ()=>(0, _rttOutlinedDefault.default));
parcelHelpers.export(exports, "RttRounded", ()=>(0, _rttRoundedDefault.default));
parcelHelpers.export(exports, "RttSharp", ()=>(0, _rttSharpDefault.default));
parcelHelpers.export(exports, "RttTwoTone", ()=>(0, _rttTwoToneDefault.default));
parcelHelpers.export(exports, "Rule", ()=>(0, _ruleDefault.default));
parcelHelpers.export(exports, "RuleFolder", ()=>(0, _ruleFolderDefault.default));
parcelHelpers.export(exports, "RuleFolderOutlined", ()=>(0, _ruleFolderOutlinedDefault.default));
parcelHelpers.export(exports, "RuleFolderRounded", ()=>(0, _ruleFolderRoundedDefault.default));
parcelHelpers.export(exports, "RuleFolderSharp", ()=>(0, _ruleFolderSharpDefault.default));
parcelHelpers.export(exports, "RuleFolderTwoTone", ()=>(0, _ruleFolderTwoToneDefault.default));
parcelHelpers.export(exports, "RuleOutlined", ()=>(0, _ruleOutlinedDefault.default));
parcelHelpers.export(exports, "RuleRounded", ()=>(0, _ruleRoundedDefault.default));
parcelHelpers.export(exports, "RuleSharp", ()=>(0, _ruleSharpDefault.default));
parcelHelpers.export(exports, "RuleTwoTone", ()=>(0, _ruleTwoToneDefault.default));
parcelHelpers.export(exports, "RunCircle", ()=>(0, _runCircleDefault.default));
parcelHelpers.export(exports, "RunCircleOutlined", ()=>(0, _runCircleOutlinedDefault.default));
parcelHelpers.export(exports, "RunCircleRounded", ()=>(0, _runCircleRoundedDefault.default));
parcelHelpers.export(exports, "RunCircleSharp", ()=>(0, _runCircleSharpDefault.default));
parcelHelpers.export(exports, "RunCircleTwoTone", ()=>(0, _runCircleTwoToneDefault.default));
parcelHelpers.export(exports, "RunningWithErrors", ()=>(0, _runningWithErrorsDefault.default));
parcelHelpers.export(exports, "RunningWithErrorsOutlined", ()=>(0, _runningWithErrorsOutlinedDefault.default));
parcelHelpers.export(exports, "RunningWithErrorsRounded", ()=>(0, _runningWithErrorsRoundedDefault.default));
parcelHelpers.export(exports, "RunningWithErrorsSharp", ()=>(0, _runningWithErrorsSharpDefault.default));
parcelHelpers.export(exports, "RunningWithErrorsTwoTone", ()=>(0, _runningWithErrorsTwoToneDefault.default));
parcelHelpers.export(exports, "RvHookup", ()=>(0, _rvHookupDefault.default));
parcelHelpers.export(exports, "RvHookupOutlined", ()=>(0, _rvHookupOutlinedDefault.default));
parcelHelpers.export(exports, "RvHookupRounded", ()=>(0, _rvHookupRoundedDefault.default));
parcelHelpers.export(exports, "RvHookupSharp", ()=>(0, _rvHookupSharpDefault.default));
parcelHelpers.export(exports, "RvHookupTwoTone", ()=>(0, _rvHookupTwoToneDefault.default));
parcelHelpers.export(exports, "SafetyCheck", ()=>(0, _safetyCheckDefault.default));
parcelHelpers.export(exports, "SafetyCheckOutlined", ()=>(0, _safetyCheckOutlinedDefault.default));
parcelHelpers.export(exports, "SafetyCheckRounded", ()=>(0, _safetyCheckRoundedDefault.default));
parcelHelpers.export(exports, "SafetyCheckSharp", ()=>(0, _safetyCheckSharpDefault.default));
parcelHelpers.export(exports, "SafetyCheckTwoTone", ()=>(0, _safetyCheckTwoToneDefault.default));
parcelHelpers.export(exports, "SafetyDivider", ()=>(0, _safetyDividerDefault.default));
parcelHelpers.export(exports, "SafetyDividerOutlined", ()=>(0, _safetyDividerOutlinedDefault.default));
parcelHelpers.export(exports, "SafetyDividerRounded", ()=>(0, _safetyDividerRoundedDefault.default));
parcelHelpers.export(exports, "SafetyDividerSharp", ()=>(0, _safetyDividerSharpDefault.default));
parcelHelpers.export(exports, "SafetyDividerTwoTone", ()=>(0, _safetyDividerTwoToneDefault.default));
parcelHelpers.export(exports, "Sailing", ()=>(0, _sailingDefault.default));
parcelHelpers.export(exports, "SailingOutlined", ()=>(0, _sailingOutlinedDefault.default));
parcelHelpers.export(exports, "SailingRounded", ()=>(0, _sailingRoundedDefault.default));
parcelHelpers.export(exports, "SailingSharp", ()=>(0, _sailingSharpDefault.default));
parcelHelpers.export(exports, "SailingTwoTone", ()=>(0, _sailingTwoToneDefault.default));
parcelHelpers.export(exports, "Sanitizer", ()=>(0, _sanitizerDefault.default));
parcelHelpers.export(exports, "SanitizerOutlined", ()=>(0, _sanitizerOutlinedDefault.default));
parcelHelpers.export(exports, "SanitizerRounded", ()=>(0, _sanitizerRoundedDefault.default));
parcelHelpers.export(exports, "SanitizerSharp", ()=>(0, _sanitizerSharpDefault.default));
parcelHelpers.export(exports, "SanitizerTwoTone", ()=>(0, _sanitizerTwoToneDefault.default));
parcelHelpers.export(exports, "Satellite", ()=>(0, _satelliteDefault.default));
parcelHelpers.export(exports, "SatelliteAlt", ()=>(0, _satelliteAltDefault.default));
parcelHelpers.export(exports, "SatelliteAltOutlined", ()=>(0, _satelliteAltOutlinedDefault.default));
parcelHelpers.export(exports, "SatelliteAltRounded", ()=>(0, _satelliteAltRoundedDefault.default));
parcelHelpers.export(exports, "SatelliteAltSharp", ()=>(0, _satelliteAltSharpDefault.default));
parcelHelpers.export(exports, "SatelliteAltTwoTone", ()=>(0, _satelliteAltTwoToneDefault.default));
parcelHelpers.export(exports, "SatelliteOutlined", ()=>(0, _satelliteOutlinedDefault.default));
parcelHelpers.export(exports, "SatelliteRounded", ()=>(0, _satelliteRoundedDefault.default));
parcelHelpers.export(exports, "SatelliteSharp", ()=>(0, _satelliteSharpDefault.default));
parcelHelpers.export(exports, "SatelliteTwoTone", ()=>(0, _satelliteTwoToneDefault.default));
parcelHelpers.export(exports, "Save", ()=>(0, _saveDefault.default));
parcelHelpers.export(exports, "SaveAlt", ()=>(0, _saveAltDefault.default));
parcelHelpers.export(exports, "SaveAltOutlined", ()=>(0, _saveAltOutlinedDefault.default));
parcelHelpers.export(exports, "SaveAltRounded", ()=>(0, _saveAltRoundedDefault.default));
parcelHelpers.export(exports, "SaveAltSharp", ()=>(0, _saveAltSharpDefault.default));
parcelHelpers.export(exports, "SaveAltTwoTone", ()=>(0, _saveAltTwoToneDefault.default));
parcelHelpers.export(exports, "SaveAs", ()=>(0, _saveAsDefault.default));
parcelHelpers.export(exports, "SaveAsOutlined", ()=>(0, _saveAsOutlinedDefault.default));
parcelHelpers.export(exports, "SaveAsRounded", ()=>(0, _saveAsRoundedDefault.default));
parcelHelpers.export(exports, "SaveAsSharp", ()=>(0, _saveAsSharpDefault.default));
parcelHelpers.export(exports, "SaveAsTwoTone", ()=>(0, _saveAsTwoToneDefault.default));
parcelHelpers.export(exports, "SaveOutlined", ()=>(0, _saveOutlinedDefault.default));
parcelHelpers.export(exports, "SaveRounded", ()=>(0, _saveRoundedDefault.default));
parcelHelpers.export(exports, "SaveSharp", ()=>(0, _saveSharpDefault.default));
parcelHelpers.export(exports, "SaveTwoTone", ()=>(0, _saveTwoToneDefault.default));
parcelHelpers.export(exports, "SavedSearch", ()=>(0, _savedSearchDefault.default));
parcelHelpers.export(exports, "SavedSearchOutlined", ()=>(0, _savedSearchOutlinedDefault.default));
parcelHelpers.export(exports, "SavedSearchRounded", ()=>(0, _savedSearchRoundedDefault.default));
parcelHelpers.export(exports, "SavedSearchSharp", ()=>(0, _savedSearchSharpDefault.default));
parcelHelpers.export(exports, "SavedSearchTwoTone", ()=>(0, _savedSearchTwoToneDefault.default));
parcelHelpers.export(exports, "Savings", ()=>(0, _savingsDefault.default));
parcelHelpers.export(exports, "SavingsOutlined", ()=>(0, _savingsOutlinedDefault.default));
parcelHelpers.export(exports, "SavingsRounded", ()=>(0, _savingsRoundedDefault.default));
parcelHelpers.export(exports, "SavingsSharp", ()=>(0, _savingsSharpDefault.default));
parcelHelpers.export(exports, "SavingsTwoTone", ()=>(0, _savingsTwoToneDefault.default));
parcelHelpers.export(exports, "Scale", ()=>(0, _scaleDefault.default));
parcelHelpers.export(exports, "ScaleOutlined", ()=>(0, _scaleOutlinedDefault.default));
parcelHelpers.export(exports, "ScaleRounded", ()=>(0, _scaleRoundedDefault.default));
parcelHelpers.export(exports, "ScaleSharp", ()=>(0, _scaleSharpDefault.default));
parcelHelpers.export(exports, "ScaleTwoTone", ()=>(0, _scaleTwoToneDefault.default));
parcelHelpers.export(exports, "Scanner", ()=>(0, _scannerDefault.default));
parcelHelpers.export(exports, "ScannerOutlined", ()=>(0, _scannerOutlinedDefault.default));
parcelHelpers.export(exports, "ScannerRounded", ()=>(0, _scannerRoundedDefault.default));
parcelHelpers.export(exports, "ScannerSharp", ()=>(0, _scannerSharpDefault.default));
parcelHelpers.export(exports, "ScannerTwoTone", ()=>(0, _scannerTwoToneDefault.default));
parcelHelpers.export(exports, "ScatterPlot", ()=>(0, _scatterPlotDefault.default));
parcelHelpers.export(exports, "ScatterPlotOutlined", ()=>(0, _scatterPlotOutlinedDefault.default));
parcelHelpers.export(exports, "ScatterPlotRounded", ()=>(0, _scatterPlotRoundedDefault.default));
parcelHelpers.export(exports, "ScatterPlotSharp", ()=>(0, _scatterPlotSharpDefault.default));
parcelHelpers.export(exports, "ScatterPlotTwoTone", ()=>(0, _scatterPlotTwoToneDefault.default));
parcelHelpers.export(exports, "Schedule", ()=>(0, _scheduleDefault.default));
parcelHelpers.export(exports, "ScheduleOutlined", ()=>(0, _scheduleOutlinedDefault.default));
parcelHelpers.export(exports, "ScheduleRounded", ()=>(0, _scheduleRoundedDefault.default));
parcelHelpers.export(exports, "ScheduleSend", ()=>(0, _scheduleSendDefault.default));
parcelHelpers.export(exports, "ScheduleSendOutlined", ()=>(0, _scheduleSendOutlinedDefault.default));
parcelHelpers.export(exports, "ScheduleSendRounded", ()=>(0, _scheduleSendRoundedDefault.default));
parcelHelpers.export(exports, "ScheduleSendSharp", ()=>(0, _scheduleSendSharpDefault.default));
parcelHelpers.export(exports, "ScheduleSendTwoTone", ()=>(0, _scheduleSendTwoToneDefault.default));
parcelHelpers.export(exports, "ScheduleSharp", ()=>(0, _scheduleSharpDefault.default));
parcelHelpers.export(exports, "ScheduleTwoTone", ()=>(0, _scheduleTwoToneDefault.default));
parcelHelpers.export(exports, "Schema", ()=>(0, _schemaDefault.default));
parcelHelpers.export(exports, "SchemaOutlined", ()=>(0, _schemaOutlinedDefault.default));
parcelHelpers.export(exports, "SchemaRounded", ()=>(0, _schemaRoundedDefault.default));
parcelHelpers.export(exports, "SchemaSharp", ()=>(0, _schemaSharpDefault.default));
parcelHelpers.export(exports, "SchemaTwoTone", ()=>(0, _schemaTwoToneDefault.default));
parcelHelpers.export(exports, "School", ()=>(0, _schoolDefault.default));
parcelHelpers.export(exports, "SchoolOutlined", ()=>(0, _schoolOutlinedDefault.default));
parcelHelpers.export(exports, "SchoolRounded", ()=>(0, _schoolRoundedDefault.default));
parcelHelpers.export(exports, "SchoolSharp", ()=>(0, _schoolSharpDefault.default));
parcelHelpers.export(exports, "SchoolTwoTone", ()=>(0, _schoolTwoToneDefault.default));
parcelHelpers.export(exports, "Science", ()=>(0, _scienceDefault.default));
parcelHelpers.export(exports, "ScienceOutlined", ()=>(0, _scienceOutlinedDefault.default));
parcelHelpers.export(exports, "ScienceRounded", ()=>(0, _scienceRoundedDefault.default));
parcelHelpers.export(exports, "ScienceSharp", ()=>(0, _scienceSharpDefault.default));
parcelHelpers.export(exports, "ScienceTwoTone", ()=>(0, _scienceTwoToneDefault.default));
parcelHelpers.export(exports, "Score", ()=>(0, _scoreDefault.default));
parcelHelpers.export(exports, "ScoreOutlined", ()=>(0, _scoreOutlinedDefault.default));
parcelHelpers.export(exports, "ScoreRounded", ()=>(0, _scoreRoundedDefault.default));
parcelHelpers.export(exports, "ScoreSharp", ()=>(0, _scoreSharpDefault.default));
parcelHelpers.export(exports, "ScoreTwoTone", ()=>(0, _scoreTwoToneDefault.default));
parcelHelpers.export(exports, "Scoreboard", ()=>(0, _scoreboardDefault.default));
parcelHelpers.export(exports, "ScoreboardOutlined", ()=>(0, _scoreboardOutlinedDefault.default));
parcelHelpers.export(exports, "ScoreboardRounded", ()=>(0, _scoreboardRoundedDefault.default));
parcelHelpers.export(exports, "ScoreboardSharp", ()=>(0, _scoreboardSharpDefault.default));
parcelHelpers.export(exports, "ScoreboardTwoTone", ()=>(0, _scoreboardTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenLockLandscape", ()=>(0, _screenLockLandscapeDefault.default));
parcelHelpers.export(exports, "ScreenLockLandscapeOutlined", ()=>(0, _screenLockLandscapeOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenLockLandscapeRounded", ()=>(0, _screenLockLandscapeRoundedDefault.default));
parcelHelpers.export(exports, "ScreenLockLandscapeSharp", ()=>(0, _screenLockLandscapeSharpDefault.default));
parcelHelpers.export(exports, "ScreenLockLandscapeTwoTone", ()=>(0, _screenLockLandscapeTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenLockPortrait", ()=>(0, _screenLockPortraitDefault.default));
parcelHelpers.export(exports, "ScreenLockPortraitOutlined", ()=>(0, _screenLockPortraitOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenLockPortraitRounded", ()=>(0, _screenLockPortraitRoundedDefault.default));
parcelHelpers.export(exports, "ScreenLockPortraitSharp", ()=>(0, _screenLockPortraitSharpDefault.default));
parcelHelpers.export(exports, "ScreenLockPortraitTwoTone", ()=>(0, _screenLockPortraitTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenLockRotation", ()=>(0, _screenLockRotationDefault.default));
parcelHelpers.export(exports, "ScreenLockRotationOutlined", ()=>(0, _screenLockRotationOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenLockRotationRounded", ()=>(0, _screenLockRotationRoundedDefault.default));
parcelHelpers.export(exports, "ScreenLockRotationSharp", ()=>(0, _screenLockRotationSharpDefault.default));
parcelHelpers.export(exports, "ScreenLockRotationTwoTone", ()=>(0, _screenLockRotationTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenRotation", ()=>(0, _screenRotationDefault.default));
parcelHelpers.export(exports, "ScreenRotationAlt", ()=>(0, _screenRotationAltDefault.default));
parcelHelpers.export(exports, "ScreenRotationAltOutlined", ()=>(0, _screenRotationAltOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenRotationAltRounded", ()=>(0, _screenRotationAltRoundedDefault.default));
parcelHelpers.export(exports, "ScreenRotationAltSharp", ()=>(0, _screenRotationAltSharpDefault.default));
parcelHelpers.export(exports, "ScreenRotationAltTwoTone", ()=>(0, _screenRotationAltTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenRotationOutlined", ()=>(0, _screenRotationOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenRotationRounded", ()=>(0, _screenRotationRoundedDefault.default));
parcelHelpers.export(exports, "ScreenRotationSharp", ()=>(0, _screenRotationSharpDefault.default));
parcelHelpers.export(exports, "ScreenRotationTwoTone", ()=>(0, _screenRotationTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenSearchDesktop", ()=>(0, _screenSearchDesktopDefault.default));
parcelHelpers.export(exports, "ScreenSearchDesktopOutlined", ()=>(0, _screenSearchDesktopOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenSearchDesktopRounded", ()=>(0, _screenSearchDesktopRoundedDefault.default));
parcelHelpers.export(exports, "ScreenSearchDesktopSharp", ()=>(0, _screenSearchDesktopSharpDefault.default));
parcelHelpers.export(exports, "ScreenSearchDesktopTwoTone", ()=>(0, _screenSearchDesktopTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenShare", ()=>(0, _screenShareDefault.default));
parcelHelpers.export(exports, "ScreenShareOutlined", ()=>(0, _screenShareOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenShareRounded", ()=>(0, _screenShareRoundedDefault.default));
parcelHelpers.export(exports, "ScreenShareSharp", ()=>(0, _screenShareSharpDefault.default));
parcelHelpers.export(exports, "ScreenShareTwoTone", ()=>(0, _screenShareTwoToneDefault.default));
parcelHelpers.export(exports, "Screenshot", ()=>(0, _screenshotDefault.default));
parcelHelpers.export(exports, "ScreenshotMonitor", ()=>(0, _screenshotMonitorDefault.default));
parcelHelpers.export(exports, "ScreenshotMonitorOutlined", ()=>(0, _screenshotMonitorOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenshotMonitorRounded", ()=>(0, _screenshotMonitorRoundedDefault.default));
parcelHelpers.export(exports, "ScreenshotMonitorSharp", ()=>(0, _screenshotMonitorSharpDefault.default));
parcelHelpers.export(exports, "ScreenshotMonitorTwoTone", ()=>(0, _screenshotMonitorTwoToneDefault.default));
parcelHelpers.export(exports, "ScreenshotOutlined", ()=>(0, _screenshotOutlinedDefault.default));
parcelHelpers.export(exports, "ScreenshotRounded", ()=>(0, _screenshotRoundedDefault.default));
parcelHelpers.export(exports, "ScreenshotSharp", ()=>(0, _screenshotSharpDefault.default));
parcelHelpers.export(exports, "ScreenshotTwoTone", ()=>(0, _screenshotTwoToneDefault.default));
parcelHelpers.export(exports, "ScubaDiving", ()=>(0, _scubaDivingDefault.default));
parcelHelpers.export(exports, "ScubaDivingOutlined", ()=>(0, _scubaDivingOutlinedDefault.default));
parcelHelpers.export(exports, "ScubaDivingRounded", ()=>(0, _scubaDivingRoundedDefault.default));
parcelHelpers.export(exports, "ScubaDivingSharp", ()=>(0, _scubaDivingSharpDefault.default));
parcelHelpers.export(exports, "ScubaDivingTwoTone", ()=>(0, _scubaDivingTwoToneDefault.default));
parcelHelpers.export(exports, "Sd", ()=>(0, _sdDefault.default));
parcelHelpers.export(exports, "SdCard", ()=>(0, _sdCardDefault.default));
parcelHelpers.export(exports, "SdCardAlert", ()=>(0, _sdCardAlertDefault.default));
parcelHelpers.export(exports, "SdCardAlertOutlined", ()=>(0, _sdCardAlertOutlinedDefault.default));
parcelHelpers.export(exports, "SdCardAlertRounded", ()=>(0, _sdCardAlertRoundedDefault.default));
parcelHelpers.export(exports, "SdCardAlertSharp", ()=>(0, _sdCardAlertSharpDefault.default));
parcelHelpers.export(exports, "SdCardAlertTwoTone", ()=>(0, _sdCardAlertTwoToneDefault.default));
parcelHelpers.export(exports, "SdCardOutlined", ()=>(0, _sdCardOutlinedDefault.default));
parcelHelpers.export(exports, "SdCardRounded", ()=>(0, _sdCardRoundedDefault.default));
parcelHelpers.export(exports, "SdCardSharp", ()=>(0, _sdCardSharpDefault.default));
parcelHelpers.export(exports, "SdCardTwoTone", ()=>(0, _sdCardTwoToneDefault.default));
parcelHelpers.export(exports, "SdOutlined", ()=>(0, _sdOutlinedDefault.default));
parcelHelpers.export(exports, "SdRounded", ()=>(0, _sdRoundedDefault.default));
parcelHelpers.export(exports, "SdSharp", ()=>(0, _sdSharpDefault.default));
parcelHelpers.export(exports, "SdStorage", ()=>(0, _sdStorageDefault.default));
parcelHelpers.export(exports, "SdStorageOutlined", ()=>(0, _sdStorageOutlinedDefault.default));
parcelHelpers.export(exports, "SdStorageRounded", ()=>(0, _sdStorageRoundedDefault.default));
parcelHelpers.export(exports, "SdStorageSharp", ()=>(0, _sdStorageSharpDefault.default));
parcelHelpers.export(exports, "SdStorageTwoTone", ()=>(0, _sdStorageTwoToneDefault.default));
parcelHelpers.export(exports, "SdTwoTone", ()=>(0, _sdTwoToneDefault.default));
parcelHelpers.export(exports, "Search", ()=>(0, _searchDefault.default));
parcelHelpers.export(exports, "SearchOff", ()=>(0, _searchOffDefault.default));
parcelHelpers.export(exports, "SearchOffOutlined", ()=>(0, _searchOffOutlinedDefault.default));
parcelHelpers.export(exports, "SearchOffRounded", ()=>(0, _searchOffRoundedDefault.default));
parcelHelpers.export(exports, "SearchOffSharp", ()=>(0, _searchOffSharpDefault.default));
parcelHelpers.export(exports, "SearchOffTwoTone", ()=>(0, _searchOffTwoToneDefault.default));
parcelHelpers.export(exports, "SearchOutlined", ()=>(0, _searchOutlinedDefault.default));
parcelHelpers.export(exports, "SearchRounded", ()=>(0, _searchRoundedDefault.default));
parcelHelpers.export(exports, "SearchSharp", ()=>(0, _searchSharpDefault.default));
parcelHelpers.export(exports, "SearchTwoTone", ()=>(0, _searchTwoToneDefault.default));
parcelHelpers.export(exports, "Security", ()=>(0, _securityDefault.default));
parcelHelpers.export(exports, "SecurityOutlined", ()=>(0, _securityOutlinedDefault.default));
parcelHelpers.export(exports, "SecurityRounded", ()=>(0, _securityRoundedDefault.default));
parcelHelpers.export(exports, "SecuritySharp", ()=>(0, _securitySharpDefault.default));
parcelHelpers.export(exports, "SecurityTwoTone", ()=>(0, _securityTwoToneDefault.default));
parcelHelpers.export(exports, "SecurityUpdate", ()=>(0, _securityUpdateDefault.default));
parcelHelpers.export(exports, "SecurityUpdateGood", ()=>(0, _securityUpdateGoodDefault.default));
parcelHelpers.export(exports, "SecurityUpdateGoodOutlined", ()=>(0, _securityUpdateGoodOutlinedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateGoodRounded", ()=>(0, _securityUpdateGoodRoundedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateGoodSharp", ()=>(0, _securityUpdateGoodSharpDefault.default));
parcelHelpers.export(exports, "SecurityUpdateGoodTwoTone", ()=>(0, _securityUpdateGoodTwoToneDefault.default));
parcelHelpers.export(exports, "SecurityUpdateOutlined", ()=>(0, _securityUpdateOutlinedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateRounded", ()=>(0, _securityUpdateRoundedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateSharp", ()=>(0, _securityUpdateSharpDefault.default));
parcelHelpers.export(exports, "SecurityUpdateTwoTone", ()=>(0, _securityUpdateTwoToneDefault.default));
parcelHelpers.export(exports, "SecurityUpdateWarning", ()=>(0, _securityUpdateWarningDefault.default));
parcelHelpers.export(exports, "SecurityUpdateWarningOutlined", ()=>(0, _securityUpdateWarningOutlinedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateWarningRounded", ()=>(0, _securityUpdateWarningRoundedDefault.default));
parcelHelpers.export(exports, "SecurityUpdateWarningSharp", ()=>(0, _securityUpdateWarningSharpDefault.default));
parcelHelpers.export(exports, "SecurityUpdateWarningTwoTone", ()=>(0, _securityUpdateWarningTwoToneDefault.default));
parcelHelpers.export(exports, "Segment", ()=>(0, _segmentDefault.default));
parcelHelpers.export(exports, "SegmentOutlined", ()=>(0, _segmentOutlinedDefault.default));
parcelHelpers.export(exports, "SegmentRounded", ()=>(0, _segmentRoundedDefault.default));
parcelHelpers.export(exports, "SegmentSharp", ()=>(0, _segmentSharpDefault.default));
parcelHelpers.export(exports, "SegmentTwoTone", ()=>(0, _segmentTwoToneDefault.default));
parcelHelpers.export(exports, "SelectAll", ()=>(0, _selectAllDefault.default));
parcelHelpers.export(exports, "SelectAllOutlined", ()=>(0, _selectAllOutlinedDefault.default));
parcelHelpers.export(exports, "SelectAllRounded", ()=>(0, _selectAllRoundedDefault.default));
parcelHelpers.export(exports, "SelectAllSharp", ()=>(0, _selectAllSharpDefault.default));
parcelHelpers.export(exports, "SelectAllTwoTone", ()=>(0, _selectAllTwoToneDefault.default));
parcelHelpers.export(exports, "SelfImprovement", ()=>(0, _selfImprovementDefault.default));
parcelHelpers.export(exports, "SelfImprovementOutlined", ()=>(0, _selfImprovementOutlinedDefault.default));
parcelHelpers.export(exports, "SelfImprovementRounded", ()=>(0, _selfImprovementRoundedDefault.default));
parcelHelpers.export(exports, "SelfImprovementSharp", ()=>(0, _selfImprovementSharpDefault.default));
parcelHelpers.export(exports, "SelfImprovementTwoTone", ()=>(0, _selfImprovementTwoToneDefault.default));
parcelHelpers.export(exports, "Sell", ()=>(0, _sellDefault.default));
parcelHelpers.export(exports, "SellOutlined", ()=>(0, _sellOutlinedDefault.default));
parcelHelpers.export(exports, "SellRounded", ()=>(0, _sellRoundedDefault.default));
parcelHelpers.export(exports, "SellSharp", ()=>(0, _sellSharpDefault.default));
parcelHelpers.export(exports, "SellTwoTone", ()=>(0, _sellTwoToneDefault.default));
parcelHelpers.export(exports, "Send", ()=>(0, _sendDefault.default));
parcelHelpers.export(exports, "SendAndArchive", ()=>(0, _sendAndArchiveDefault.default));
parcelHelpers.export(exports, "SendAndArchiveOutlined", ()=>(0, _sendAndArchiveOutlinedDefault.default));
parcelHelpers.export(exports, "SendAndArchiveRounded", ()=>(0, _sendAndArchiveRoundedDefault.default));
parcelHelpers.export(exports, "SendAndArchiveSharp", ()=>(0, _sendAndArchiveSharpDefault.default));
parcelHelpers.export(exports, "SendAndArchiveTwoTone", ()=>(0, _sendAndArchiveTwoToneDefault.default));
parcelHelpers.export(exports, "SendOutlined", ()=>(0, _sendOutlinedDefault.default));
parcelHelpers.export(exports, "SendRounded", ()=>(0, _sendRoundedDefault.default));
parcelHelpers.export(exports, "SendSharp", ()=>(0, _sendSharpDefault.default));
parcelHelpers.export(exports, "SendTimeExtension", ()=>(0, _sendTimeExtensionDefault.default));
parcelHelpers.export(exports, "SendTimeExtensionOutlined", ()=>(0, _sendTimeExtensionOutlinedDefault.default));
parcelHelpers.export(exports, "SendTimeExtensionRounded", ()=>(0, _sendTimeExtensionRoundedDefault.default));
parcelHelpers.export(exports, "SendTimeExtensionSharp", ()=>(0, _sendTimeExtensionSharpDefault.default));
parcelHelpers.export(exports, "SendTimeExtensionTwoTone", ()=>(0, _sendTimeExtensionTwoToneDefault.default));
parcelHelpers.export(exports, "SendToMobile", ()=>(0, _sendToMobileDefault.default));
parcelHelpers.export(exports, "SendToMobileOutlined", ()=>(0, _sendToMobileOutlinedDefault.default));
parcelHelpers.export(exports, "SendToMobileRounded", ()=>(0, _sendToMobileRoundedDefault.default));
parcelHelpers.export(exports, "SendToMobileSharp", ()=>(0, _sendToMobileSharpDefault.default));
parcelHelpers.export(exports, "SendToMobileTwoTone", ()=>(0, _sendToMobileTwoToneDefault.default));
parcelHelpers.export(exports, "SendTwoTone", ()=>(0, _sendTwoToneDefault.default));
parcelHelpers.export(exports, "SensorDoor", ()=>(0, _sensorDoorDefault.default));
parcelHelpers.export(exports, "SensorDoorOutlined", ()=>(0, _sensorDoorOutlinedDefault.default));
parcelHelpers.export(exports, "SensorDoorRounded", ()=>(0, _sensorDoorRoundedDefault.default));
parcelHelpers.export(exports, "SensorDoorSharp", ()=>(0, _sensorDoorSharpDefault.default));
parcelHelpers.export(exports, "SensorDoorTwoTone", ()=>(0, _sensorDoorTwoToneDefault.default));
parcelHelpers.export(exports, "SensorOccupied", ()=>(0, _sensorOccupiedDefault.default));
parcelHelpers.export(exports, "SensorOccupiedOutlined", ()=>(0, _sensorOccupiedOutlinedDefault.default));
parcelHelpers.export(exports, "SensorOccupiedRounded", ()=>(0, _sensorOccupiedRoundedDefault.default));
parcelHelpers.export(exports, "SensorOccupiedSharp", ()=>(0, _sensorOccupiedSharpDefault.default));
parcelHelpers.export(exports, "SensorOccupiedTwoTone", ()=>(0, _sensorOccupiedTwoToneDefault.default));
parcelHelpers.export(exports, "SensorWindow", ()=>(0, _sensorWindowDefault.default));
parcelHelpers.export(exports, "SensorWindowOutlined", ()=>(0, _sensorWindowOutlinedDefault.default));
parcelHelpers.export(exports, "SensorWindowRounded", ()=>(0, _sensorWindowRoundedDefault.default));
parcelHelpers.export(exports, "SensorWindowSharp", ()=>(0, _sensorWindowSharpDefault.default));
parcelHelpers.export(exports, "SensorWindowTwoTone", ()=>(0, _sensorWindowTwoToneDefault.default));
parcelHelpers.export(exports, "Sensors", ()=>(0, _sensorsDefault.default));
parcelHelpers.export(exports, "SensorsOff", ()=>(0, _sensorsOffDefault.default));
parcelHelpers.export(exports, "SensorsOffOutlined", ()=>(0, _sensorsOffOutlinedDefault.default));
parcelHelpers.export(exports, "SensorsOffRounded", ()=>(0, _sensorsOffRoundedDefault.default));
parcelHelpers.export(exports, "SensorsOffSharp", ()=>(0, _sensorsOffSharpDefault.default));
parcelHelpers.export(exports, "SensorsOffTwoTone", ()=>(0, _sensorsOffTwoToneDefault.default));
parcelHelpers.export(exports, "SensorsOutlined", ()=>(0, _sensorsOutlinedDefault.default));
parcelHelpers.export(exports, "SensorsRounded", ()=>(0, _sensorsRoundedDefault.default));
parcelHelpers.export(exports, "SensorsSharp", ()=>(0, _sensorsSharpDefault.default));
parcelHelpers.export(exports, "SensorsTwoTone", ()=>(0, _sensorsTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentDissatisfied", ()=>(0, _sentimentDissatisfiedDefault.default));
parcelHelpers.export(exports, "SentimentDissatisfiedOutlined", ()=>(0, _sentimentDissatisfiedOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentDissatisfiedRounded", ()=>(0, _sentimentDissatisfiedRoundedDefault.default));
parcelHelpers.export(exports, "SentimentDissatisfiedSharp", ()=>(0, _sentimentDissatisfiedSharpDefault.default));
parcelHelpers.export(exports, "SentimentDissatisfiedTwoTone", ()=>(0, _sentimentDissatisfiedTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentNeutral", ()=>(0, _sentimentNeutralDefault.default));
parcelHelpers.export(exports, "SentimentNeutralOutlined", ()=>(0, _sentimentNeutralOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentNeutralRounded", ()=>(0, _sentimentNeutralRoundedDefault.default));
parcelHelpers.export(exports, "SentimentNeutralSharp", ()=>(0, _sentimentNeutralSharpDefault.default));
parcelHelpers.export(exports, "SentimentNeutralTwoTone", ()=>(0, _sentimentNeutralTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentSatisfied", ()=>(0, _sentimentSatisfiedDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedAlt", ()=>(0, _sentimentSatisfiedAltDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedAltOutlined", ()=>(0, _sentimentSatisfiedAltOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedAltRounded", ()=>(0, _sentimentSatisfiedAltRoundedDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedAltSharp", ()=>(0, _sentimentSatisfiedAltSharpDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedAltTwoTone", ()=>(0, _sentimentSatisfiedAltTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedOutlined", ()=>(0, _sentimentSatisfiedOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedRounded", ()=>(0, _sentimentSatisfiedRoundedDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedSharp", ()=>(0, _sentimentSatisfiedSharpDefault.default));
parcelHelpers.export(exports, "SentimentSatisfiedTwoTone", ()=>(0, _sentimentSatisfiedTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentVeryDissatisfied", ()=>(0, _sentimentVeryDissatisfiedDefault.default));
parcelHelpers.export(exports, "SentimentVeryDissatisfiedOutlined", ()=>(0, _sentimentVeryDissatisfiedOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentVeryDissatisfiedRounded", ()=>(0, _sentimentVeryDissatisfiedRoundedDefault.default));
parcelHelpers.export(exports, "SentimentVeryDissatisfiedSharp", ()=>(0, _sentimentVeryDissatisfiedSharpDefault.default));
parcelHelpers.export(exports, "SentimentVeryDissatisfiedTwoTone", ()=>(0, _sentimentVeryDissatisfiedTwoToneDefault.default));
parcelHelpers.export(exports, "SentimentVerySatisfied", ()=>(0, _sentimentVerySatisfiedDefault.default));
parcelHelpers.export(exports, "SentimentVerySatisfiedOutlined", ()=>(0, _sentimentVerySatisfiedOutlinedDefault.default));
parcelHelpers.export(exports, "SentimentVerySatisfiedRounded", ()=>(0, _sentimentVerySatisfiedRoundedDefault.default));
parcelHelpers.export(exports, "SentimentVerySatisfiedSharp", ()=>(0, _sentimentVerySatisfiedSharpDefault.default));
parcelHelpers.export(exports, "SentimentVerySatisfiedTwoTone", ()=>(0, _sentimentVerySatisfiedTwoToneDefault.default));
parcelHelpers.export(exports, "SetMeal", ()=>(0, _setMealDefault.default));
parcelHelpers.export(exports, "SetMealOutlined", ()=>(0, _setMealOutlinedDefault.default));
parcelHelpers.export(exports, "SetMealRounded", ()=>(0, _setMealRoundedDefault.default));
parcelHelpers.export(exports, "SetMealSharp", ()=>(0, _setMealSharpDefault.default));
parcelHelpers.export(exports, "SetMealTwoTone", ()=>(0, _setMealTwoToneDefault.default));
parcelHelpers.export(exports, "Settings", ()=>(0, _settingsDefault.default));
parcelHelpers.export(exports, "SettingsAccessibility", ()=>(0, _settingsAccessibilityDefault.default));
parcelHelpers.export(exports, "SettingsAccessibilityOutlined", ()=>(0, _settingsAccessibilityOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsAccessibilityRounded", ()=>(0, _settingsAccessibilityRoundedDefault.default));
parcelHelpers.export(exports, "SettingsAccessibilitySharp", ()=>(0, _settingsAccessibilitySharpDefault.default));
parcelHelpers.export(exports, "SettingsAccessibilityTwoTone", ()=>(0, _settingsAccessibilityTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsApplications", ()=>(0, _settingsApplicationsDefault.default));
parcelHelpers.export(exports, "SettingsApplicationsOutlined", ()=>(0, _settingsApplicationsOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsApplicationsRounded", ()=>(0, _settingsApplicationsRoundedDefault.default));
parcelHelpers.export(exports, "SettingsApplicationsSharp", ()=>(0, _settingsApplicationsSharpDefault.default));
parcelHelpers.export(exports, "SettingsApplicationsTwoTone", ()=>(0, _settingsApplicationsTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsBackupRestore", ()=>(0, _settingsBackupRestoreDefault.default));
parcelHelpers.export(exports, "SettingsBackupRestoreOutlined", ()=>(0, _settingsBackupRestoreOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsBackupRestoreRounded", ()=>(0, _settingsBackupRestoreRoundedDefault.default));
parcelHelpers.export(exports, "SettingsBackupRestoreSharp", ()=>(0, _settingsBackupRestoreSharpDefault.default));
parcelHelpers.export(exports, "SettingsBackupRestoreTwoTone", ()=>(0, _settingsBackupRestoreTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsBluetooth", ()=>(0, _settingsBluetoothDefault.default));
parcelHelpers.export(exports, "SettingsBluetoothOutlined", ()=>(0, _settingsBluetoothOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsBluetoothRounded", ()=>(0, _settingsBluetoothRoundedDefault.default));
parcelHelpers.export(exports, "SettingsBluetoothSharp", ()=>(0, _settingsBluetoothSharpDefault.default));
parcelHelpers.export(exports, "SettingsBluetoothTwoTone", ()=>(0, _settingsBluetoothTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsBrightness", ()=>(0, _settingsBrightnessDefault.default));
parcelHelpers.export(exports, "SettingsBrightnessOutlined", ()=>(0, _settingsBrightnessOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsBrightnessRounded", ()=>(0, _settingsBrightnessRoundedDefault.default));
parcelHelpers.export(exports, "SettingsBrightnessSharp", ()=>(0, _settingsBrightnessSharpDefault.default));
parcelHelpers.export(exports, "SettingsBrightnessTwoTone", ()=>(0, _settingsBrightnessTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsCell", ()=>(0, _settingsCellDefault.default));
parcelHelpers.export(exports, "SettingsCellOutlined", ()=>(0, _settingsCellOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsCellRounded", ()=>(0, _settingsCellRoundedDefault.default));
parcelHelpers.export(exports, "SettingsCellSharp", ()=>(0, _settingsCellSharpDefault.default));
parcelHelpers.export(exports, "SettingsCellTwoTone", ()=>(0, _settingsCellTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsEthernet", ()=>(0, _settingsEthernetDefault.default));
parcelHelpers.export(exports, "SettingsEthernetOutlined", ()=>(0, _settingsEthernetOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsEthernetRounded", ()=>(0, _settingsEthernetRoundedDefault.default));
parcelHelpers.export(exports, "SettingsEthernetSharp", ()=>(0, _settingsEthernetSharpDefault.default));
parcelHelpers.export(exports, "SettingsEthernetTwoTone", ()=>(0, _settingsEthernetTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsInputAntenna", ()=>(0, _settingsInputAntennaDefault.default));
parcelHelpers.export(exports, "SettingsInputAntennaOutlined", ()=>(0, _settingsInputAntennaOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsInputAntennaRounded", ()=>(0, _settingsInputAntennaRoundedDefault.default));
parcelHelpers.export(exports, "SettingsInputAntennaSharp", ()=>(0, _settingsInputAntennaSharpDefault.default));
parcelHelpers.export(exports, "SettingsInputAntennaTwoTone", ()=>(0, _settingsInputAntennaTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsInputComponent", ()=>(0, _settingsInputComponentDefault.default));
parcelHelpers.export(exports, "SettingsInputComponentOutlined", ()=>(0, _settingsInputComponentOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsInputComponentRounded", ()=>(0, _settingsInputComponentRoundedDefault.default));
parcelHelpers.export(exports, "SettingsInputComponentSharp", ()=>(0, _settingsInputComponentSharpDefault.default));
parcelHelpers.export(exports, "SettingsInputComponentTwoTone", ()=>(0, _settingsInputComponentTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsInputComposite", ()=>(0, _settingsInputCompositeDefault.default));
parcelHelpers.export(exports, "SettingsInputCompositeOutlined", ()=>(0, _settingsInputCompositeOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsInputCompositeRounded", ()=>(0, _settingsInputCompositeRoundedDefault.default));
parcelHelpers.export(exports, "SettingsInputCompositeSharp", ()=>(0, _settingsInputCompositeSharpDefault.default));
parcelHelpers.export(exports, "SettingsInputCompositeTwoTone", ()=>(0, _settingsInputCompositeTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsInputHdmi", ()=>(0, _settingsInputHdmiDefault.default));
parcelHelpers.export(exports, "SettingsInputHdmiOutlined", ()=>(0, _settingsInputHdmiOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsInputHdmiRounded", ()=>(0, _settingsInputHdmiRoundedDefault.default));
parcelHelpers.export(exports, "SettingsInputHdmiSharp", ()=>(0, _settingsInputHdmiSharpDefault.default));
parcelHelpers.export(exports, "SettingsInputHdmiTwoTone", ()=>(0, _settingsInputHdmiTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsInputSvideo", ()=>(0, _settingsInputSvideoDefault.default));
parcelHelpers.export(exports, "SettingsInputSvideoOutlined", ()=>(0, _settingsInputSvideoOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsInputSvideoRounded", ()=>(0, _settingsInputSvideoRoundedDefault.default));
parcelHelpers.export(exports, "SettingsInputSvideoSharp", ()=>(0, _settingsInputSvideoSharpDefault.default));
parcelHelpers.export(exports, "SettingsInputSvideoTwoTone", ()=>(0, _settingsInputSvideoTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsOutlined", ()=>(0, _settingsOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsOverscan", ()=>(0, _settingsOverscanDefault.default));
parcelHelpers.export(exports, "SettingsOverscanOutlined", ()=>(0, _settingsOverscanOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsOverscanRounded", ()=>(0, _settingsOverscanRoundedDefault.default));
parcelHelpers.export(exports, "SettingsOverscanSharp", ()=>(0, _settingsOverscanSharpDefault.default));
parcelHelpers.export(exports, "SettingsOverscanTwoTone", ()=>(0, _settingsOverscanTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsPhone", ()=>(0, _settingsPhoneDefault.default));
parcelHelpers.export(exports, "SettingsPhoneOutlined", ()=>(0, _settingsPhoneOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsPhoneRounded", ()=>(0, _settingsPhoneRoundedDefault.default));
parcelHelpers.export(exports, "SettingsPhoneSharp", ()=>(0, _settingsPhoneSharpDefault.default));
parcelHelpers.export(exports, "SettingsPhoneTwoTone", ()=>(0, _settingsPhoneTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsPower", ()=>(0, _settingsPowerDefault.default));
parcelHelpers.export(exports, "SettingsPowerOutlined", ()=>(0, _settingsPowerOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsPowerRounded", ()=>(0, _settingsPowerRoundedDefault.default));
parcelHelpers.export(exports, "SettingsPowerSharp", ()=>(0, _settingsPowerSharpDefault.default));
parcelHelpers.export(exports, "SettingsPowerTwoTone", ()=>(0, _settingsPowerTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsRemote", ()=>(0, _settingsRemoteDefault.default));
parcelHelpers.export(exports, "SettingsRemoteOutlined", ()=>(0, _settingsRemoteOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsRemoteRounded", ()=>(0, _settingsRemoteRoundedDefault.default));
parcelHelpers.export(exports, "SettingsRemoteSharp", ()=>(0, _settingsRemoteSharpDefault.default));
parcelHelpers.export(exports, "SettingsRemoteTwoTone", ()=>(0, _settingsRemoteTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsRounded", ()=>(0, _settingsRoundedDefault.default));
parcelHelpers.export(exports, "SettingsSharp", ()=>(0, _settingsSharpDefault.default));
parcelHelpers.export(exports, "SettingsSuggest", ()=>(0, _settingsSuggestDefault.default));
parcelHelpers.export(exports, "SettingsSuggestOutlined", ()=>(0, _settingsSuggestOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsSuggestRounded", ()=>(0, _settingsSuggestRoundedDefault.default));
parcelHelpers.export(exports, "SettingsSuggestSharp", ()=>(0, _settingsSuggestSharpDefault.default));
parcelHelpers.export(exports, "SettingsSuggestTwoTone", ()=>(0, _settingsSuggestTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsSystemDaydream", ()=>(0, _settingsSystemDaydreamDefault.default));
parcelHelpers.export(exports, "SettingsSystemDaydreamOutlined", ()=>(0, _settingsSystemDaydreamOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsSystemDaydreamRounded", ()=>(0, _settingsSystemDaydreamRoundedDefault.default));
parcelHelpers.export(exports, "SettingsSystemDaydreamSharp", ()=>(0, _settingsSystemDaydreamSharpDefault.default));
parcelHelpers.export(exports, "SettingsSystemDaydreamTwoTone", ()=>(0, _settingsSystemDaydreamTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsTwoTone", ()=>(0, _settingsTwoToneDefault.default));
parcelHelpers.export(exports, "SettingsVoice", ()=>(0, _settingsVoiceDefault.default));
parcelHelpers.export(exports, "SettingsVoiceOutlined", ()=>(0, _settingsVoiceOutlinedDefault.default));
parcelHelpers.export(exports, "SettingsVoiceRounded", ()=>(0, _settingsVoiceRoundedDefault.default));
parcelHelpers.export(exports, "SettingsVoiceSharp", ()=>(0, _settingsVoiceSharpDefault.default));
parcelHelpers.export(exports, "SettingsVoiceTwoTone", ()=>(0, _settingsVoiceTwoToneDefault.default));
parcelHelpers.export(exports, "SevenK", ()=>(0, _sevenKDefault.default));
parcelHelpers.export(exports, "SevenKOutlined", ()=>(0, _sevenKOutlinedDefault.default));
parcelHelpers.export(exports, "SevenKPlus", ()=>(0, _sevenKPlusDefault.default));
parcelHelpers.export(exports, "SevenKPlusOutlined", ()=>(0, _sevenKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "SevenKPlusRounded", ()=>(0, _sevenKPlusRoundedDefault.default));
parcelHelpers.export(exports, "SevenKPlusSharp", ()=>(0, _sevenKPlusSharpDefault.default));
parcelHelpers.export(exports, "SevenKPlusTwoTone", ()=>(0, _sevenKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "SevenKRounded", ()=>(0, _sevenKRoundedDefault.default));
parcelHelpers.export(exports, "SevenKSharp", ()=>(0, _sevenKSharpDefault.default));
parcelHelpers.export(exports, "SevenKTwoTone", ()=>(0, _sevenKTwoToneDefault.default));
parcelHelpers.export(exports, "SevenMp", ()=>(0, _sevenMpDefault.default));
parcelHelpers.export(exports, "SevenMpOutlined", ()=>(0, _sevenMpOutlinedDefault.default));
parcelHelpers.export(exports, "SevenMpRounded", ()=>(0, _sevenMpRoundedDefault.default));
parcelHelpers.export(exports, "SevenMpSharp", ()=>(0, _sevenMpSharpDefault.default));
parcelHelpers.export(exports, "SevenMpTwoTone", ()=>(0, _sevenMpTwoToneDefault.default));
parcelHelpers.export(exports, "SeventeenMp", ()=>(0, _seventeenMpDefault.default));
parcelHelpers.export(exports, "SeventeenMpOutlined", ()=>(0, _seventeenMpOutlinedDefault.default));
parcelHelpers.export(exports, "SeventeenMpRounded", ()=>(0, _seventeenMpRoundedDefault.default));
parcelHelpers.export(exports, "SeventeenMpSharp", ()=>(0, _seventeenMpSharpDefault.default));
parcelHelpers.export(exports, "SeventeenMpTwoTone", ()=>(0, _seventeenMpTwoToneDefault.default));
parcelHelpers.export(exports, "SevereCold", ()=>(0, _severeColdDefault.default));
parcelHelpers.export(exports, "SevereColdOutlined", ()=>(0, _severeColdOutlinedDefault.default));
parcelHelpers.export(exports, "SevereColdRounded", ()=>(0, _severeColdRoundedDefault.default));
parcelHelpers.export(exports, "SevereColdSharp", ()=>(0, _severeColdSharpDefault.default));
parcelHelpers.export(exports, "SevereColdTwoTone", ()=>(0, _severeColdTwoToneDefault.default));
parcelHelpers.export(exports, "ShapeLine", ()=>(0, _shapeLineDefault.default));
parcelHelpers.export(exports, "ShapeLineOutlined", ()=>(0, _shapeLineOutlinedDefault.default));
parcelHelpers.export(exports, "ShapeLineRounded", ()=>(0, _shapeLineRoundedDefault.default));
parcelHelpers.export(exports, "ShapeLineSharp", ()=>(0, _shapeLineSharpDefault.default));
parcelHelpers.export(exports, "ShapeLineTwoTone", ()=>(0, _shapeLineTwoToneDefault.default));
parcelHelpers.export(exports, "Share", ()=>(0, _shareDefault.default));
parcelHelpers.export(exports, "ShareLocation", ()=>(0, _shareLocationDefault.default));
parcelHelpers.export(exports, "ShareLocationOutlined", ()=>(0, _shareLocationOutlinedDefault.default));
parcelHelpers.export(exports, "ShareLocationRounded", ()=>(0, _shareLocationRoundedDefault.default));
parcelHelpers.export(exports, "ShareLocationSharp", ()=>(0, _shareLocationSharpDefault.default));
parcelHelpers.export(exports, "ShareLocationTwoTone", ()=>(0, _shareLocationTwoToneDefault.default));
parcelHelpers.export(exports, "ShareOutlined", ()=>(0, _shareOutlinedDefault.default));
parcelHelpers.export(exports, "ShareRounded", ()=>(0, _shareRoundedDefault.default));
parcelHelpers.export(exports, "ShareSharp", ()=>(0, _shareSharpDefault.default));
parcelHelpers.export(exports, "ShareTwoTone", ()=>(0, _shareTwoToneDefault.default));
parcelHelpers.export(exports, "Shield", ()=>(0, _shieldDefault.default));
parcelHelpers.export(exports, "ShieldMoon", ()=>(0, _shieldMoonDefault.default));
parcelHelpers.export(exports, "ShieldMoonOutlined", ()=>(0, _shieldMoonOutlinedDefault.default));
parcelHelpers.export(exports, "ShieldMoonRounded", ()=>(0, _shieldMoonRoundedDefault.default));
parcelHelpers.export(exports, "ShieldMoonSharp", ()=>(0, _shieldMoonSharpDefault.default));
parcelHelpers.export(exports, "ShieldMoonTwoTone", ()=>(0, _shieldMoonTwoToneDefault.default));
parcelHelpers.export(exports, "ShieldOutlined", ()=>(0, _shieldOutlinedDefault.default));
parcelHelpers.export(exports, "ShieldRounded", ()=>(0, _shieldRoundedDefault.default));
parcelHelpers.export(exports, "ShieldSharp", ()=>(0, _shieldSharpDefault.default));
parcelHelpers.export(exports, "ShieldTwoTone", ()=>(0, _shieldTwoToneDefault.default));
parcelHelpers.export(exports, "Shop", ()=>(0, _shopDefault.default));
parcelHelpers.export(exports, "Shop2", ()=>(0, _shop2Default.default));
parcelHelpers.export(exports, "Shop2Outlined", ()=>(0, _shop2OutlinedDefault.default));
parcelHelpers.export(exports, "Shop2Rounded", ()=>(0, _shop2RoundedDefault.default));
parcelHelpers.export(exports, "Shop2Sharp", ()=>(0, _shop2SharpDefault.default));
parcelHelpers.export(exports, "Shop2TwoTone", ()=>(0, _shop2TwoToneDefault.default));
parcelHelpers.export(exports, "ShopOutlined", ()=>(0, _shopOutlinedDefault.default));
parcelHelpers.export(exports, "ShopRounded", ()=>(0, _shopRoundedDefault.default));
parcelHelpers.export(exports, "ShopSharp", ()=>(0, _shopSharpDefault.default));
parcelHelpers.export(exports, "ShopTwo", ()=>(0, _shopTwoDefault.default));
parcelHelpers.export(exports, "ShopTwoOutlined", ()=>(0, _shopTwoOutlinedDefault.default));
parcelHelpers.export(exports, "ShopTwoRounded", ()=>(0, _shopTwoRoundedDefault.default));
parcelHelpers.export(exports, "ShopTwoSharp", ()=>(0, _shopTwoSharpDefault.default));
parcelHelpers.export(exports, "ShopTwoTone", ()=>(0, _shopTwoToneDefault.default));
parcelHelpers.export(exports, "ShopTwoTwoTone", ()=>(0, _shopTwoTwoToneDefault.default));
parcelHelpers.export(exports, "ShoppingBag", ()=>(0, _shoppingBagDefault.default));
parcelHelpers.export(exports, "ShoppingBagOutlined", ()=>(0, _shoppingBagOutlinedDefault.default));
parcelHelpers.export(exports, "ShoppingBagRounded", ()=>(0, _shoppingBagRoundedDefault.default));
parcelHelpers.export(exports, "ShoppingBagSharp", ()=>(0, _shoppingBagSharpDefault.default));
parcelHelpers.export(exports, "ShoppingBagTwoTone", ()=>(0, _shoppingBagTwoToneDefault.default));
parcelHelpers.export(exports, "ShoppingBasket", ()=>(0, _shoppingBasketDefault.default));
parcelHelpers.export(exports, "ShoppingBasketOutlined", ()=>(0, _shoppingBasketOutlinedDefault.default));
parcelHelpers.export(exports, "ShoppingBasketRounded", ()=>(0, _shoppingBasketRoundedDefault.default));
parcelHelpers.export(exports, "ShoppingBasketSharp", ()=>(0, _shoppingBasketSharpDefault.default));
parcelHelpers.export(exports, "ShoppingBasketTwoTone", ()=>(0, _shoppingBasketTwoToneDefault.default));
parcelHelpers.export(exports, "ShoppingCart", ()=>(0, _shoppingCartDefault.default));
parcelHelpers.export(exports, "ShoppingCartCheckout", ()=>(0, _shoppingCartCheckoutDefault.default));
parcelHelpers.export(exports, "ShoppingCartCheckoutOutlined", ()=>(0, _shoppingCartCheckoutOutlinedDefault.default));
parcelHelpers.export(exports, "ShoppingCartCheckoutRounded", ()=>(0, _shoppingCartCheckoutRoundedDefault.default));
parcelHelpers.export(exports, "ShoppingCartCheckoutSharp", ()=>(0, _shoppingCartCheckoutSharpDefault.default));
parcelHelpers.export(exports, "ShoppingCartCheckoutTwoTone", ()=>(0, _shoppingCartCheckoutTwoToneDefault.default));
parcelHelpers.export(exports, "ShoppingCartOutlined", ()=>(0, _shoppingCartOutlinedDefault.default));
parcelHelpers.export(exports, "ShoppingCartRounded", ()=>(0, _shoppingCartRoundedDefault.default));
parcelHelpers.export(exports, "ShoppingCartSharp", ()=>(0, _shoppingCartSharpDefault.default));
parcelHelpers.export(exports, "ShoppingCartTwoTone", ()=>(0, _shoppingCartTwoToneDefault.default));
parcelHelpers.export(exports, "ShortText", ()=>(0, _shortTextDefault.default));
parcelHelpers.export(exports, "ShortTextOutlined", ()=>(0, _shortTextOutlinedDefault.default));
parcelHelpers.export(exports, "ShortTextRounded", ()=>(0, _shortTextRoundedDefault.default));
parcelHelpers.export(exports, "ShortTextSharp", ()=>(0, _shortTextSharpDefault.default));
parcelHelpers.export(exports, "ShortTextTwoTone", ()=>(0, _shortTextTwoToneDefault.default));
parcelHelpers.export(exports, "Shortcut", ()=>(0, _shortcutDefault.default));
parcelHelpers.export(exports, "ShortcutOutlined", ()=>(0, _shortcutOutlinedDefault.default));
parcelHelpers.export(exports, "ShortcutRounded", ()=>(0, _shortcutRoundedDefault.default));
parcelHelpers.export(exports, "ShortcutSharp", ()=>(0, _shortcutSharpDefault.default));
parcelHelpers.export(exports, "ShortcutTwoTone", ()=>(0, _shortcutTwoToneDefault.default));
parcelHelpers.export(exports, "ShowChart", ()=>(0, _showChartDefault.default));
parcelHelpers.export(exports, "ShowChartOutlined", ()=>(0, _showChartOutlinedDefault.default));
parcelHelpers.export(exports, "ShowChartRounded", ()=>(0, _showChartRoundedDefault.default));
parcelHelpers.export(exports, "ShowChartSharp", ()=>(0, _showChartSharpDefault.default));
parcelHelpers.export(exports, "ShowChartTwoTone", ()=>(0, _showChartTwoToneDefault.default));
parcelHelpers.export(exports, "Shower", ()=>(0, _showerDefault.default));
parcelHelpers.export(exports, "ShowerOutlined", ()=>(0, _showerOutlinedDefault.default));
parcelHelpers.export(exports, "ShowerRounded", ()=>(0, _showerRoundedDefault.default));
parcelHelpers.export(exports, "ShowerSharp", ()=>(0, _showerSharpDefault.default));
parcelHelpers.export(exports, "ShowerTwoTone", ()=>(0, _showerTwoToneDefault.default));
parcelHelpers.export(exports, "Shuffle", ()=>(0, _shuffleDefault.default));
parcelHelpers.export(exports, "ShuffleOn", ()=>(0, _shuffleOnDefault.default));
parcelHelpers.export(exports, "ShuffleOnOutlined", ()=>(0, _shuffleOnOutlinedDefault.default));
parcelHelpers.export(exports, "ShuffleOnRounded", ()=>(0, _shuffleOnRoundedDefault.default));
parcelHelpers.export(exports, "ShuffleOnSharp", ()=>(0, _shuffleOnSharpDefault.default));
parcelHelpers.export(exports, "ShuffleOnTwoTone", ()=>(0, _shuffleOnTwoToneDefault.default));
parcelHelpers.export(exports, "ShuffleOutlined", ()=>(0, _shuffleOutlinedDefault.default));
parcelHelpers.export(exports, "ShuffleRounded", ()=>(0, _shuffleRoundedDefault.default));
parcelHelpers.export(exports, "ShuffleSharp", ()=>(0, _shuffleSharpDefault.default));
parcelHelpers.export(exports, "ShuffleTwoTone", ()=>(0, _shuffleTwoToneDefault.default));
parcelHelpers.export(exports, "ShutterSpeed", ()=>(0, _shutterSpeedDefault.default));
parcelHelpers.export(exports, "ShutterSpeedOutlined", ()=>(0, _shutterSpeedOutlinedDefault.default));
parcelHelpers.export(exports, "ShutterSpeedRounded", ()=>(0, _shutterSpeedRoundedDefault.default));
parcelHelpers.export(exports, "ShutterSpeedSharp", ()=>(0, _shutterSpeedSharpDefault.default));
parcelHelpers.export(exports, "ShutterSpeedTwoTone", ()=>(0, _shutterSpeedTwoToneDefault.default));
parcelHelpers.export(exports, "Sick", ()=>(0, _sickDefault.default));
parcelHelpers.export(exports, "SickOutlined", ()=>(0, _sickOutlinedDefault.default));
parcelHelpers.export(exports, "SickRounded", ()=>(0, _sickRoundedDefault.default));
parcelHelpers.export(exports, "SickSharp", ()=>(0, _sickSharpDefault.default));
parcelHelpers.export(exports, "SickTwoTone", ()=>(0, _sickTwoToneDefault.default));
parcelHelpers.export(exports, "SignLanguage", ()=>(0, _signLanguageDefault.default));
parcelHelpers.export(exports, "SignLanguageOutlined", ()=>(0, _signLanguageOutlinedDefault.default));
parcelHelpers.export(exports, "SignLanguageRounded", ()=>(0, _signLanguageRoundedDefault.default));
parcelHelpers.export(exports, "SignLanguageSharp", ()=>(0, _signLanguageSharpDefault.default));
parcelHelpers.export(exports, "SignLanguageTwoTone", ()=>(0, _signLanguageTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellular0Bar", ()=>(0, _signalCellular0BarDefault.default));
parcelHelpers.export(exports, "SignalCellular0BarOutlined", ()=>(0, _signalCellular0BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellular0BarRounded", ()=>(0, _signalCellular0BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellular0BarSharp", ()=>(0, _signalCellular0BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellular0BarTwoTone", ()=>(0, _signalCellular0BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellular1Bar", ()=>(0, _signalCellular1BarDefault.default));
parcelHelpers.export(exports, "SignalCellular1BarOutlined", ()=>(0, _signalCellular1BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellular1BarRounded", ()=>(0, _signalCellular1BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellular1BarSharp", ()=>(0, _signalCellular1BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellular1BarTwoTone", ()=>(0, _signalCellular1BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellular2Bar", ()=>(0, _signalCellular2BarDefault.default));
parcelHelpers.export(exports, "SignalCellular2BarOutlined", ()=>(0, _signalCellular2BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellular2BarRounded", ()=>(0, _signalCellular2BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellular2BarSharp", ()=>(0, _signalCellular2BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellular2BarTwoTone", ()=>(0, _signalCellular2BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellular3Bar", ()=>(0, _signalCellular3BarDefault.default));
parcelHelpers.export(exports, "SignalCellular3BarOutlined", ()=>(0, _signalCellular3BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellular3BarRounded", ()=>(0, _signalCellular3BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellular3BarSharp", ()=>(0, _signalCellular3BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellular3BarTwoTone", ()=>(0, _signalCellular3BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellular4Bar", ()=>(0, _signalCellular4BarDefault.default));
parcelHelpers.export(exports, "SignalCellular4BarOutlined", ()=>(0, _signalCellular4BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellular4BarRounded", ()=>(0, _signalCellular4BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellular4BarSharp", ()=>(0, _signalCellular4BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellular4BarTwoTone", ()=>(0, _signalCellular4BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt", ()=>(0, _signalCellularAltDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt1Bar", ()=>(0, _signalCellularAlt1BarDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt1BarOutlined", ()=>(0, _signalCellularAlt1BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt1BarRounded", ()=>(0, _signalCellularAlt1BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt1BarSharp", ()=>(0, _signalCellularAlt1BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt1BarTwoTone", ()=>(0, _signalCellularAlt1BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt2Bar", ()=>(0, _signalCellularAlt2BarDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt2BarOutlined", ()=>(0, _signalCellularAlt2BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt2BarRounded", ()=>(0, _signalCellularAlt2BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt2BarSharp", ()=>(0, _signalCellularAlt2BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularAlt2BarTwoTone", ()=>(0, _signalCellularAlt2BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularAltOutlined", ()=>(0, _signalCellularAltOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularAltRounded", ()=>(0, _signalCellularAltRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularAltSharp", ()=>(0, _signalCellularAltSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularAltTwoTone", ()=>(0, _signalCellularAltTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet0Bar", ()=>(0, _signalCellularConnectedNoInternet0BarDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet0BarOutlined", ()=>(0, _signalCellularConnectedNoInternet0BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet0BarRounded", ()=>(0, _signalCellularConnectedNoInternet0BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet0BarSharp", ()=>(0, _signalCellularConnectedNoInternet0BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet0BarTwoTone", ()=>(0, _signalCellularConnectedNoInternet0BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet1Bar", ()=>(0, _signalCellularConnectedNoInternet1BarDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet1BarOutlined", ()=>(0, _signalCellularConnectedNoInternet1BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet1BarRounded", ()=>(0, _signalCellularConnectedNoInternet1BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet1BarSharp", ()=>(0, _signalCellularConnectedNoInternet1BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet1BarTwoTone", ()=>(0, _signalCellularConnectedNoInternet1BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet2Bar", ()=>(0, _signalCellularConnectedNoInternet2BarDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet2BarOutlined", ()=>(0, _signalCellularConnectedNoInternet2BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet2BarRounded", ()=>(0, _signalCellularConnectedNoInternet2BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet2BarSharp", ()=>(0, _signalCellularConnectedNoInternet2BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet2BarTwoTone", ()=>(0, _signalCellularConnectedNoInternet2BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet3Bar", ()=>(0, _signalCellularConnectedNoInternet3BarDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet3BarOutlined", ()=>(0, _signalCellularConnectedNoInternet3BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet3BarRounded", ()=>(0, _signalCellularConnectedNoInternet3BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet3BarSharp", ()=>(0, _signalCellularConnectedNoInternet3BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet3BarTwoTone", ()=>(0, _signalCellularConnectedNoInternet3BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet4Bar", ()=>(0, _signalCellularConnectedNoInternet4BarDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet4BarOutlined", ()=>(0, _signalCellularConnectedNoInternet4BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet4BarRounded", ()=>(0, _signalCellularConnectedNoInternet4BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet4BarSharp", ()=>(0, _signalCellularConnectedNoInternet4BarSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularConnectedNoInternet4BarTwoTone", ()=>(0, _signalCellularConnectedNoInternet4BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularNoSim", ()=>(0, _signalCellularNoSimDefault.default));
parcelHelpers.export(exports, "SignalCellularNoSimOutlined", ()=>(0, _signalCellularNoSimOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularNoSimRounded", ()=>(0, _signalCellularNoSimRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularNoSimSharp", ()=>(0, _signalCellularNoSimSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularNoSimTwoTone", ()=>(0, _signalCellularNoSimTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularNodata", ()=>(0, _signalCellularNodataDefault.default));
parcelHelpers.export(exports, "SignalCellularNodataOutlined", ()=>(0, _signalCellularNodataOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularNodataRounded", ()=>(0, _signalCellularNodataRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularNodataSharp", ()=>(0, _signalCellularNodataSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularNodataTwoTone", ()=>(0, _signalCellularNodataTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularNull", ()=>(0, _signalCellularNullDefault.default));
parcelHelpers.export(exports, "SignalCellularNullOutlined", ()=>(0, _signalCellularNullOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularNullRounded", ()=>(0, _signalCellularNullRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularNullSharp", ()=>(0, _signalCellularNullSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularNullTwoTone", ()=>(0, _signalCellularNullTwoToneDefault.default));
parcelHelpers.export(exports, "SignalCellularOff", ()=>(0, _signalCellularOffDefault.default));
parcelHelpers.export(exports, "SignalCellularOffOutlined", ()=>(0, _signalCellularOffOutlinedDefault.default));
parcelHelpers.export(exports, "SignalCellularOffRounded", ()=>(0, _signalCellularOffRoundedDefault.default));
parcelHelpers.export(exports, "SignalCellularOffSharp", ()=>(0, _signalCellularOffSharpDefault.default));
parcelHelpers.export(exports, "SignalCellularOffTwoTone", ()=>(0, _signalCellularOffTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi0Bar", ()=>(0, _signalWifi0BarDefault.default));
parcelHelpers.export(exports, "SignalWifi0BarOutlined", ()=>(0, _signalWifi0BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi0BarRounded", ()=>(0, _signalWifi0BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi0BarSharp", ()=>(0, _signalWifi0BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi0BarTwoTone", ()=>(0, _signalWifi0BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi1Bar", ()=>(0, _signalWifi1BarDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarLock", ()=>(0, _signalWifi1BarLockDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarLockOutlined", ()=>(0, _signalWifi1BarLockOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarLockRounded", ()=>(0, _signalWifi1BarLockRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarLockSharp", ()=>(0, _signalWifi1BarLockSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarLockTwoTone", ()=>(0, _signalWifi1BarLockTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarOutlined", ()=>(0, _signalWifi1BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarRounded", ()=>(0, _signalWifi1BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarSharp", ()=>(0, _signalWifi1BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi1BarTwoTone", ()=>(0, _signalWifi1BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi2Bar", ()=>(0, _signalWifi2BarDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarLock", ()=>(0, _signalWifi2BarLockDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarLockOutlined", ()=>(0, _signalWifi2BarLockOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarLockRounded", ()=>(0, _signalWifi2BarLockRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarLockSharp", ()=>(0, _signalWifi2BarLockSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarLockTwoTone", ()=>(0, _signalWifi2BarLockTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarOutlined", ()=>(0, _signalWifi2BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarRounded", ()=>(0, _signalWifi2BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarSharp", ()=>(0, _signalWifi2BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi2BarTwoTone", ()=>(0, _signalWifi2BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi3Bar", ()=>(0, _signalWifi3BarDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarLock", ()=>(0, _signalWifi3BarLockDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarLockOutlined", ()=>(0, _signalWifi3BarLockOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarLockRounded", ()=>(0, _signalWifi3BarLockRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarLockSharp", ()=>(0, _signalWifi3BarLockSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarLockTwoTone", ()=>(0, _signalWifi3BarLockTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarOutlined", ()=>(0, _signalWifi3BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarRounded", ()=>(0, _signalWifi3BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarSharp", ()=>(0, _signalWifi3BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi3BarTwoTone", ()=>(0, _signalWifi3BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi4Bar", ()=>(0, _signalWifi4BarDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarLock", ()=>(0, _signalWifi4BarLockDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarLockOutlined", ()=>(0, _signalWifi4BarLockOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarLockRounded", ()=>(0, _signalWifi4BarLockRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarLockSharp", ()=>(0, _signalWifi4BarLockSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarLockTwoTone", ()=>(0, _signalWifi4BarLockTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarOutlined", ()=>(0, _signalWifi4BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarRounded", ()=>(0, _signalWifi4BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarSharp", ()=>(0, _signalWifi4BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifi4BarTwoTone", ()=>(0, _signalWifi4BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiBad", ()=>(0, _signalWifiBadDefault.default));
parcelHelpers.export(exports, "SignalWifiBadOutlined", ()=>(0, _signalWifiBadOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiBadRounded", ()=>(0, _signalWifiBadRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiBadSharp", ()=>(0, _signalWifiBadSharpDefault.default));
parcelHelpers.export(exports, "SignalWifiBadTwoTone", ()=>(0, _signalWifiBadTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiConnectedNoInternet4", ()=>(0, _signalWifiConnectedNoInternet4Default.default));
parcelHelpers.export(exports, "SignalWifiConnectedNoInternet4Outlined", ()=>(0, _signalWifiConnectedNoInternet4OutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiConnectedNoInternet4Rounded", ()=>(0, _signalWifiConnectedNoInternet4RoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiConnectedNoInternet4Sharp", ()=>(0, _signalWifiConnectedNoInternet4SharpDefault.default));
parcelHelpers.export(exports, "SignalWifiConnectedNoInternet4TwoTone", ()=>(0, _signalWifiConnectedNoInternet4TwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiOff", ()=>(0, _signalWifiOffDefault.default));
parcelHelpers.export(exports, "SignalWifiOffOutlined", ()=>(0, _signalWifiOffOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiOffRounded", ()=>(0, _signalWifiOffRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiOffSharp", ()=>(0, _signalWifiOffSharpDefault.default));
parcelHelpers.export(exports, "SignalWifiOffTwoTone", ()=>(0, _signalWifiOffTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbar4Bar", ()=>(0, _signalWifiStatusbar4BarDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbar4BarOutlined", ()=>(0, _signalWifiStatusbar4BarOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbar4BarRounded", ()=>(0, _signalWifiStatusbar4BarRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbar4BarSharp", ()=>(0, _signalWifiStatusbar4BarSharpDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbar4BarTwoTone", ()=>(0, _signalWifiStatusbar4BarTwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarConnectedNoInternet4", ()=>(0, _signalWifiStatusbarConnectedNoInternet4Default.default));
parcelHelpers.export(exports, "SignalWifiStatusbarConnectedNoInternet4Outlined", ()=>(0, _signalWifiStatusbarConnectedNoInternet4OutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarConnectedNoInternet4Rounded", ()=>(0, _signalWifiStatusbarConnectedNoInternet4RoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarConnectedNoInternet4Sharp", ()=>(0, _signalWifiStatusbarConnectedNoInternet4SharpDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarConnectedNoInternet4TwoTone", ()=>(0, _signalWifiStatusbarConnectedNoInternet4TwoToneDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarNull", ()=>(0, _signalWifiStatusbarNullDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarNullOutlined", ()=>(0, _signalWifiStatusbarNullOutlinedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarNullRounded", ()=>(0, _signalWifiStatusbarNullRoundedDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarNullSharp", ()=>(0, _signalWifiStatusbarNullSharpDefault.default));
parcelHelpers.export(exports, "SignalWifiStatusbarNullTwoTone", ()=>(0, _signalWifiStatusbarNullTwoToneDefault.default));
parcelHelpers.export(exports, "Signpost", ()=>(0, _signpostDefault.default));
parcelHelpers.export(exports, "SignpostOutlined", ()=>(0, _signpostOutlinedDefault.default));
parcelHelpers.export(exports, "SignpostRounded", ()=>(0, _signpostRoundedDefault.default));
parcelHelpers.export(exports, "SignpostSharp", ()=>(0, _signpostSharpDefault.default));
parcelHelpers.export(exports, "SignpostTwoTone", ()=>(0, _signpostTwoToneDefault.default));
parcelHelpers.export(exports, "SimCard", ()=>(0, _simCardDefault.default));
parcelHelpers.export(exports, "SimCardAlert", ()=>(0, _simCardAlertDefault.default));
parcelHelpers.export(exports, "SimCardAlertOutlined", ()=>(0, _simCardAlertOutlinedDefault.default));
parcelHelpers.export(exports, "SimCardAlertRounded", ()=>(0, _simCardAlertRoundedDefault.default));
parcelHelpers.export(exports, "SimCardAlertSharp", ()=>(0, _simCardAlertSharpDefault.default));
parcelHelpers.export(exports, "SimCardAlertTwoTone", ()=>(0, _simCardAlertTwoToneDefault.default));
parcelHelpers.export(exports, "SimCardDownload", ()=>(0, _simCardDownloadDefault.default));
parcelHelpers.export(exports, "SimCardDownloadOutlined", ()=>(0, _simCardDownloadOutlinedDefault.default));
parcelHelpers.export(exports, "SimCardDownloadRounded", ()=>(0, _simCardDownloadRoundedDefault.default));
parcelHelpers.export(exports, "SimCardDownloadSharp", ()=>(0, _simCardDownloadSharpDefault.default));
parcelHelpers.export(exports, "SimCardDownloadTwoTone", ()=>(0, _simCardDownloadTwoToneDefault.default));
parcelHelpers.export(exports, "SimCardOutlined", ()=>(0, _simCardOutlinedDefault.default));
parcelHelpers.export(exports, "SimCardRounded", ()=>(0, _simCardRoundedDefault.default));
parcelHelpers.export(exports, "SimCardSharp", ()=>(0, _simCardSharpDefault.default));
parcelHelpers.export(exports, "SimCardTwoTone", ()=>(0, _simCardTwoToneDefault.default));
parcelHelpers.export(exports, "SingleBed", ()=>(0, _singleBedDefault.default));
parcelHelpers.export(exports, "SingleBedOutlined", ()=>(0, _singleBedOutlinedDefault.default));
parcelHelpers.export(exports, "SingleBedRounded", ()=>(0, _singleBedRoundedDefault.default));
parcelHelpers.export(exports, "SingleBedSharp", ()=>(0, _singleBedSharpDefault.default));
parcelHelpers.export(exports, "SingleBedTwoTone", ()=>(0, _singleBedTwoToneDefault.default));
parcelHelpers.export(exports, "Sip", ()=>(0, _sipDefault.default));
parcelHelpers.export(exports, "SipOutlined", ()=>(0, _sipOutlinedDefault.default));
parcelHelpers.export(exports, "SipRounded", ()=>(0, _sipRoundedDefault.default));
parcelHelpers.export(exports, "SipSharp", ()=>(0, _sipSharpDefault.default));
parcelHelpers.export(exports, "SipTwoTone", ()=>(0, _sipTwoToneDefault.default));
parcelHelpers.export(exports, "SixK", ()=>(0, _sixKDefault.default));
parcelHelpers.export(exports, "SixKOutlined", ()=>(0, _sixKOutlinedDefault.default));
parcelHelpers.export(exports, "SixKPlus", ()=>(0, _sixKPlusDefault.default));
parcelHelpers.export(exports, "SixKPlusOutlined", ()=>(0, _sixKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "SixKPlusRounded", ()=>(0, _sixKPlusRoundedDefault.default));
parcelHelpers.export(exports, "SixKPlusSharp", ()=>(0, _sixKPlusSharpDefault.default));
parcelHelpers.export(exports, "SixKPlusTwoTone", ()=>(0, _sixKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "SixKRounded", ()=>(0, _sixKRoundedDefault.default));
parcelHelpers.export(exports, "SixKSharp", ()=>(0, _sixKSharpDefault.default));
parcelHelpers.export(exports, "SixKTwoTone", ()=>(0, _sixKTwoToneDefault.default));
parcelHelpers.export(exports, "SixMp", ()=>(0, _sixMpDefault.default));
parcelHelpers.export(exports, "SixMpOutlined", ()=>(0, _sixMpOutlinedDefault.default));
parcelHelpers.export(exports, "SixMpRounded", ()=>(0, _sixMpRoundedDefault.default));
parcelHelpers.export(exports, "SixMpSharp", ()=>(0, _sixMpSharpDefault.default));
parcelHelpers.export(exports, "SixMpTwoTone", ()=>(0, _sixMpTwoToneDefault.default));
parcelHelpers.export(exports, "SixteenMp", ()=>(0, _sixteenMpDefault.default));
parcelHelpers.export(exports, "SixteenMpOutlined", ()=>(0, _sixteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "SixteenMpRounded", ()=>(0, _sixteenMpRoundedDefault.default));
parcelHelpers.export(exports, "SixteenMpSharp", ()=>(0, _sixteenMpSharpDefault.default));
parcelHelpers.export(exports, "SixteenMpTwoTone", ()=>(0, _sixteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "SixtyFps", ()=>(0, _sixtyFpsDefault.default));
parcelHelpers.export(exports, "SixtyFpsOutlined", ()=>(0, _sixtyFpsOutlinedDefault.default));
parcelHelpers.export(exports, "SixtyFpsRounded", ()=>(0, _sixtyFpsRoundedDefault.default));
parcelHelpers.export(exports, "SixtyFpsSelect", ()=>(0, _sixtyFpsSelectDefault.default));
parcelHelpers.export(exports, "SixtyFpsSelectOutlined", ()=>(0, _sixtyFpsSelectOutlinedDefault.default));
parcelHelpers.export(exports, "SixtyFpsSelectRounded", ()=>(0, _sixtyFpsSelectRoundedDefault.default));
parcelHelpers.export(exports, "SixtyFpsSelectSharp", ()=>(0, _sixtyFpsSelectSharpDefault.default));
parcelHelpers.export(exports, "SixtyFpsSelectTwoTone", ()=>(0, _sixtyFpsSelectTwoToneDefault.default));
parcelHelpers.export(exports, "SixtyFpsSharp", ()=>(0, _sixtyFpsSharpDefault.default));
parcelHelpers.export(exports, "SixtyFpsTwoTone", ()=>(0, _sixtyFpsTwoToneDefault.default));
parcelHelpers.export(exports, "Skateboarding", ()=>(0, _skateboardingDefault.default));
parcelHelpers.export(exports, "SkateboardingOutlined", ()=>(0, _skateboardingOutlinedDefault.default));
parcelHelpers.export(exports, "SkateboardingRounded", ()=>(0, _skateboardingRoundedDefault.default));
parcelHelpers.export(exports, "SkateboardingSharp", ()=>(0, _skateboardingSharpDefault.default));
parcelHelpers.export(exports, "SkateboardingTwoTone", ()=>(0, _skateboardingTwoToneDefault.default));
parcelHelpers.export(exports, "SkipNext", ()=>(0, _skipNextDefault.default));
parcelHelpers.export(exports, "SkipNextOutlined", ()=>(0, _skipNextOutlinedDefault.default));
parcelHelpers.export(exports, "SkipNextRounded", ()=>(0, _skipNextRoundedDefault.default));
parcelHelpers.export(exports, "SkipNextSharp", ()=>(0, _skipNextSharpDefault.default));
parcelHelpers.export(exports, "SkipNextTwoTone", ()=>(0, _skipNextTwoToneDefault.default));
parcelHelpers.export(exports, "SkipPrevious", ()=>(0, _skipPreviousDefault.default));
parcelHelpers.export(exports, "SkipPreviousOutlined", ()=>(0, _skipPreviousOutlinedDefault.default));
parcelHelpers.export(exports, "SkipPreviousRounded", ()=>(0, _skipPreviousRoundedDefault.default));
parcelHelpers.export(exports, "SkipPreviousSharp", ()=>(0, _skipPreviousSharpDefault.default));
parcelHelpers.export(exports, "SkipPreviousTwoTone", ()=>(0, _skipPreviousTwoToneDefault.default));
parcelHelpers.export(exports, "Sledding", ()=>(0, _sleddingDefault.default));
parcelHelpers.export(exports, "SleddingOutlined", ()=>(0, _sleddingOutlinedDefault.default));
parcelHelpers.export(exports, "SleddingRounded", ()=>(0, _sleddingRoundedDefault.default));
parcelHelpers.export(exports, "SleddingSharp", ()=>(0, _sleddingSharpDefault.default));
parcelHelpers.export(exports, "SleddingTwoTone", ()=>(0, _sleddingTwoToneDefault.default));
parcelHelpers.export(exports, "Slideshow", ()=>(0, _slideshowDefault.default));
parcelHelpers.export(exports, "SlideshowOutlined", ()=>(0, _slideshowOutlinedDefault.default));
parcelHelpers.export(exports, "SlideshowRounded", ()=>(0, _slideshowRoundedDefault.default));
parcelHelpers.export(exports, "SlideshowSharp", ()=>(0, _slideshowSharpDefault.default));
parcelHelpers.export(exports, "SlideshowTwoTone", ()=>(0, _slideshowTwoToneDefault.default));
parcelHelpers.export(exports, "SlowMotionVideo", ()=>(0, _slowMotionVideoDefault.default));
parcelHelpers.export(exports, "SlowMotionVideoOutlined", ()=>(0, _slowMotionVideoOutlinedDefault.default));
parcelHelpers.export(exports, "SlowMotionVideoRounded", ()=>(0, _slowMotionVideoRoundedDefault.default));
parcelHelpers.export(exports, "SlowMotionVideoSharp", ()=>(0, _slowMotionVideoSharpDefault.default));
parcelHelpers.export(exports, "SlowMotionVideoTwoTone", ()=>(0, _slowMotionVideoTwoToneDefault.default));
parcelHelpers.export(exports, "SmartButton", ()=>(0, _smartButtonDefault.default));
parcelHelpers.export(exports, "SmartButtonOutlined", ()=>(0, _smartButtonOutlinedDefault.default));
parcelHelpers.export(exports, "SmartButtonRounded", ()=>(0, _smartButtonRoundedDefault.default));
parcelHelpers.export(exports, "SmartButtonSharp", ()=>(0, _smartButtonSharpDefault.default));
parcelHelpers.export(exports, "SmartButtonTwoTone", ()=>(0, _smartButtonTwoToneDefault.default));
parcelHelpers.export(exports, "SmartDisplay", ()=>(0, _smartDisplayDefault.default));
parcelHelpers.export(exports, "SmartDisplayOutlined", ()=>(0, _smartDisplayOutlinedDefault.default));
parcelHelpers.export(exports, "SmartDisplayRounded", ()=>(0, _smartDisplayRoundedDefault.default));
parcelHelpers.export(exports, "SmartDisplaySharp", ()=>(0, _smartDisplaySharpDefault.default));
parcelHelpers.export(exports, "SmartDisplayTwoTone", ()=>(0, _smartDisplayTwoToneDefault.default));
parcelHelpers.export(exports, "SmartScreen", ()=>(0, _smartScreenDefault.default));
parcelHelpers.export(exports, "SmartScreenOutlined", ()=>(0, _smartScreenOutlinedDefault.default));
parcelHelpers.export(exports, "SmartScreenRounded", ()=>(0, _smartScreenRoundedDefault.default));
parcelHelpers.export(exports, "SmartScreenSharp", ()=>(0, _smartScreenSharpDefault.default));
parcelHelpers.export(exports, "SmartScreenTwoTone", ()=>(0, _smartScreenTwoToneDefault.default));
parcelHelpers.export(exports, "SmartToy", ()=>(0, _smartToyDefault.default));
parcelHelpers.export(exports, "SmartToyOutlined", ()=>(0, _smartToyOutlinedDefault.default));
parcelHelpers.export(exports, "SmartToyRounded", ()=>(0, _smartToyRoundedDefault.default));
parcelHelpers.export(exports, "SmartToySharp", ()=>(0, _smartToySharpDefault.default));
parcelHelpers.export(exports, "SmartToyTwoTone", ()=>(0, _smartToyTwoToneDefault.default));
parcelHelpers.export(exports, "Smartphone", ()=>(0, _smartphoneDefault.default));
parcelHelpers.export(exports, "SmartphoneOutlined", ()=>(0, _smartphoneOutlinedDefault.default));
parcelHelpers.export(exports, "SmartphoneRounded", ()=>(0, _smartphoneRoundedDefault.default));
parcelHelpers.export(exports, "SmartphoneSharp", ()=>(0, _smartphoneSharpDefault.default));
parcelHelpers.export(exports, "SmartphoneTwoTone", ()=>(0, _smartphoneTwoToneDefault.default));
parcelHelpers.export(exports, "SmokeFree", ()=>(0, _smokeFreeDefault.default));
parcelHelpers.export(exports, "SmokeFreeOutlined", ()=>(0, _smokeFreeOutlinedDefault.default));
parcelHelpers.export(exports, "SmokeFreeRounded", ()=>(0, _smokeFreeRoundedDefault.default));
parcelHelpers.export(exports, "SmokeFreeSharp", ()=>(0, _smokeFreeSharpDefault.default));
parcelHelpers.export(exports, "SmokeFreeTwoTone", ()=>(0, _smokeFreeTwoToneDefault.default));
parcelHelpers.export(exports, "SmokingRooms", ()=>(0, _smokingRoomsDefault.default));
parcelHelpers.export(exports, "SmokingRoomsOutlined", ()=>(0, _smokingRoomsOutlinedDefault.default));
parcelHelpers.export(exports, "SmokingRoomsRounded", ()=>(0, _smokingRoomsRoundedDefault.default));
parcelHelpers.export(exports, "SmokingRoomsSharp", ()=>(0, _smokingRoomsSharpDefault.default));
parcelHelpers.export(exports, "SmokingRoomsTwoTone", ()=>(0, _smokingRoomsTwoToneDefault.default));
parcelHelpers.export(exports, "Sms", ()=>(0, _smsDefault.default));
parcelHelpers.export(exports, "SmsFailed", ()=>(0, _smsFailedDefault.default));
parcelHelpers.export(exports, "SmsFailedOutlined", ()=>(0, _smsFailedOutlinedDefault.default));
parcelHelpers.export(exports, "SmsFailedRounded", ()=>(0, _smsFailedRoundedDefault.default));
parcelHelpers.export(exports, "SmsFailedSharp", ()=>(0, _smsFailedSharpDefault.default));
parcelHelpers.export(exports, "SmsFailedTwoTone", ()=>(0, _smsFailedTwoToneDefault.default));
parcelHelpers.export(exports, "SmsOutlined", ()=>(0, _smsOutlinedDefault.default));
parcelHelpers.export(exports, "SmsRounded", ()=>(0, _smsRoundedDefault.default));
parcelHelpers.export(exports, "SmsSharp", ()=>(0, _smsSharpDefault.default));
parcelHelpers.export(exports, "SmsTwoTone", ()=>(0, _smsTwoToneDefault.default));
parcelHelpers.export(exports, "SnippetFolder", ()=>(0, _snippetFolderDefault.default));
parcelHelpers.export(exports, "SnippetFolderOutlined", ()=>(0, _snippetFolderOutlinedDefault.default));
parcelHelpers.export(exports, "SnippetFolderRounded", ()=>(0, _snippetFolderRoundedDefault.default));
parcelHelpers.export(exports, "SnippetFolderSharp", ()=>(0, _snippetFolderSharpDefault.default));
parcelHelpers.export(exports, "SnippetFolderTwoTone", ()=>(0, _snippetFolderTwoToneDefault.default));
parcelHelpers.export(exports, "Snooze", ()=>(0, _snoozeDefault.default));
parcelHelpers.export(exports, "SnoozeOutlined", ()=>(0, _snoozeOutlinedDefault.default));
parcelHelpers.export(exports, "SnoozeRounded", ()=>(0, _snoozeRoundedDefault.default));
parcelHelpers.export(exports, "SnoozeSharp", ()=>(0, _snoozeSharpDefault.default));
parcelHelpers.export(exports, "SnoozeTwoTone", ()=>(0, _snoozeTwoToneDefault.default));
parcelHelpers.export(exports, "Snowboarding", ()=>(0, _snowboardingDefault.default));
parcelHelpers.export(exports, "SnowboardingOutlined", ()=>(0, _snowboardingOutlinedDefault.default));
parcelHelpers.export(exports, "SnowboardingRounded", ()=>(0, _snowboardingRoundedDefault.default));
parcelHelpers.export(exports, "SnowboardingSharp", ()=>(0, _snowboardingSharpDefault.default));
parcelHelpers.export(exports, "SnowboardingTwoTone", ()=>(0, _snowboardingTwoToneDefault.default));
parcelHelpers.export(exports, "Snowmobile", ()=>(0, _snowmobileDefault.default));
parcelHelpers.export(exports, "SnowmobileOutlined", ()=>(0, _snowmobileOutlinedDefault.default));
parcelHelpers.export(exports, "SnowmobileRounded", ()=>(0, _snowmobileRoundedDefault.default));
parcelHelpers.export(exports, "SnowmobileSharp", ()=>(0, _snowmobileSharpDefault.default));
parcelHelpers.export(exports, "SnowmobileTwoTone", ()=>(0, _snowmobileTwoToneDefault.default));
parcelHelpers.export(exports, "Snowshoeing", ()=>(0, _snowshoeingDefault.default));
parcelHelpers.export(exports, "SnowshoeingOutlined", ()=>(0, _snowshoeingOutlinedDefault.default));
parcelHelpers.export(exports, "SnowshoeingRounded", ()=>(0, _snowshoeingRoundedDefault.default));
parcelHelpers.export(exports, "SnowshoeingSharp", ()=>(0, _snowshoeingSharpDefault.default));
parcelHelpers.export(exports, "SnowshoeingTwoTone", ()=>(0, _snowshoeingTwoToneDefault.default));
parcelHelpers.export(exports, "Soap", ()=>(0, _soapDefault.default));
parcelHelpers.export(exports, "SoapOutlined", ()=>(0, _soapOutlinedDefault.default));
parcelHelpers.export(exports, "SoapRounded", ()=>(0, _soapRoundedDefault.default));
parcelHelpers.export(exports, "SoapSharp", ()=>(0, _soapSharpDefault.default));
parcelHelpers.export(exports, "SoapTwoTone", ()=>(0, _soapTwoToneDefault.default));
parcelHelpers.export(exports, "SocialDistance", ()=>(0, _socialDistanceDefault.default));
parcelHelpers.export(exports, "SocialDistanceOutlined", ()=>(0, _socialDistanceOutlinedDefault.default));
parcelHelpers.export(exports, "SocialDistanceRounded", ()=>(0, _socialDistanceRoundedDefault.default));
parcelHelpers.export(exports, "SocialDistanceSharp", ()=>(0, _socialDistanceSharpDefault.default));
parcelHelpers.export(exports, "SocialDistanceTwoTone", ()=>(0, _socialDistanceTwoToneDefault.default));
parcelHelpers.export(exports, "SolarPower", ()=>(0, _solarPowerDefault.default));
parcelHelpers.export(exports, "SolarPowerOutlined", ()=>(0, _solarPowerOutlinedDefault.default));
parcelHelpers.export(exports, "SolarPowerRounded", ()=>(0, _solarPowerRoundedDefault.default));
parcelHelpers.export(exports, "SolarPowerSharp", ()=>(0, _solarPowerSharpDefault.default));
parcelHelpers.export(exports, "SolarPowerTwoTone", ()=>(0, _solarPowerTwoToneDefault.default));
parcelHelpers.export(exports, "Sort", ()=>(0, _sortDefault.default));
parcelHelpers.export(exports, "SortByAlpha", ()=>(0, _sortByAlphaDefault.default));
parcelHelpers.export(exports, "SortByAlphaOutlined", ()=>(0, _sortByAlphaOutlinedDefault.default));
parcelHelpers.export(exports, "SortByAlphaRounded", ()=>(0, _sortByAlphaRoundedDefault.default));
parcelHelpers.export(exports, "SortByAlphaSharp", ()=>(0, _sortByAlphaSharpDefault.default));
parcelHelpers.export(exports, "SortByAlphaTwoTone", ()=>(0, _sortByAlphaTwoToneDefault.default));
parcelHelpers.export(exports, "SortOutlined", ()=>(0, _sortOutlinedDefault.default));
parcelHelpers.export(exports, "SortRounded", ()=>(0, _sortRoundedDefault.default));
parcelHelpers.export(exports, "SortSharp", ()=>(0, _sortSharpDefault.default));
parcelHelpers.export(exports, "SortTwoTone", ()=>(0, _sortTwoToneDefault.default));
parcelHelpers.export(exports, "Sos", ()=>(0, _sosDefault.default));
parcelHelpers.export(exports, "SosOutlined", ()=>(0, _sosOutlinedDefault.default));
parcelHelpers.export(exports, "SosRounded", ()=>(0, _sosRoundedDefault.default));
parcelHelpers.export(exports, "SosSharp", ()=>(0, _sosSharpDefault.default));
parcelHelpers.export(exports, "SosTwoTone", ()=>(0, _sosTwoToneDefault.default));
parcelHelpers.export(exports, "SoupKitchen", ()=>(0, _soupKitchenDefault.default));
parcelHelpers.export(exports, "SoupKitchenOutlined", ()=>(0, _soupKitchenOutlinedDefault.default));
parcelHelpers.export(exports, "SoupKitchenRounded", ()=>(0, _soupKitchenRoundedDefault.default));
parcelHelpers.export(exports, "SoupKitchenSharp", ()=>(0, _soupKitchenSharpDefault.default));
parcelHelpers.export(exports, "SoupKitchenTwoTone", ()=>(0, _soupKitchenTwoToneDefault.default));
parcelHelpers.export(exports, "Source", ()=>(0, _sourceDefault.default));
parcelHelpers.export(exports, "SourceOutlined", ()=>(0, _sourceOutlinedDefault.default));
parcelHelpers.export(exports, "SourceRounded", ()=>(0, _sourceRoundedDefault.default));
parcelHelpers.export(exports, "SourceSharp", ()=>(0, _sourceSharpDefault.default));
parcelHelpers.export(exports, "SourceTwoTone", ()=>(0, _sourceTwoToneDefault.default));
parcelHelpers.export(exports, "South", ()=>(0, _southDefault.default));
parcelHelpers.export(exports, "SouthAmerica", ()=>(0, _southAmericaDefault.default));
parcelHelpers.export(exports, "SouthAmericaOutlined", ()=>(0, _southAmericaOutlinedDefault.default));
parcelHelpers.export(exports, "SouthAmericaRounded", ()=>(0, _southAmericaRoundedDefault.default));
parcelHelpers.export(exports, "SouthAmericaSharp", ()=>(0, _southAmericaSharpDefault.default));
parcelHelpers.export(exports, "SouthAmericaTwoTone", ()=>(0, _southAmericaTwoToneDefault.default));
parcelHelpers.export(exports, "SouthEast", ()=>(0, _southEastDefault.default));
parcelHelpers.export(exports, "SouthEastOutlined", ()=>(0, _southEastOutlinedDefault.default));
parcelHelpers.export(exports, "SouthEastRounded", ()=>(0, _southEastRoundedDefault.default));
parcelHelpers.export(exports, "SouthEastSharp", ()=>(0, _southEastSharpDefault.default));
parcelHelpers.export(exports, "SouthEastTwoTone", ()=>(0, _southEastTwoToneDefault.default));
parcelHelpers.export(exports, "SouthOutlined", ()=>(0, _southOutlinedDefault.default));
parcelHelpers.export(exports, "SouthRounded", ()=>(0, _southRoundedDefault.default));
parcelHelpers.export(exports, "SouthSharp", ()=>(0, _southSharpDefault.default));
parcelHelpers.export(exports, "SouthTwoTone", ()=>(0, _southTwoToneDefault.default));
parcelHelpers.export(exports, "SouthWest", ()=>(0, _southWestDefault.default));
parcelHelpers.export(exports, "SouthWestOutlined", ()=>(0, _southWestOutlinedDefault.default));
parcelHelpers.export(exports, "SouthWestRounded", ()=>(0, _southWestRoundedDefault.default));
parcelHelpers.export(exports, "SouthWestSharp", ()=>(0, _southWestSharpDefault.default));
parcelHelpers.export(exports, "SouthWestTwoTone", ()=>(0, _southWestTwoToneDefault.default));
parcelHelpers.export(exports, "Spa", ()=>(0, _spaDefault.default));
parcelHelpers.export(exports, "SpaOutlined", ()=>(0, _spaOutlinedDefault.default));
parcelHelpers.export(exports, "SpaRounded", ()=>(0, _spaRoundedDefault.default));
parcelHelpers.export(exports, "SpaSharp", ()=>(0, _spaSharpDefault.default));
parcelHelpers.export(exports, "SpaTwoTone", ()=>(0, _spaTwoToneDefault.default));
parcelHelpers.export(exports, "SpaceBar", ()=>(0, _spaceBarDefault.default));
parcelHelpers.export(exports, "SpaceBarOutlined", ()=>(0, _spaceBarOutlinedDefault.default));
parcelHelpers.export(exports, "SpaceBarRounded", ()=>(0, _spaceBarRoundedDefault.default));
parcelHelpers.export(exports, "SpaceBarSharp", ()=>(0, _spaceBarSharpDefault.default));
parcelHelpers.export(exports, "SpaceBarTwoTone", ()=>(0, _spaceBarTwoToneDefault.default));
parcelHelpers.export(exports, "SpaceDashboard", ()=>(0, _spaceDashboardDefault.default));
parcelHelpers.export(exports, "SpaceDashboardOutlined", ()=>(0, _spaceDashboardOutlinedDefault.default));
parcelHelpers.export(exports, "SpaceDashboardRounded", ()=>(0, _spaceDashboardRoundedDefault.default));
parcelHelpers.export(exports, "SpaceDashboardSharp", ()=>(0, _spaceDashboardSharpDefault.default));
parcelHelpers.export(exports, "SpaceDashboardTwoTone", ()=>(0, _spaceDashboardTwoToneDefault.default));
parcelHelpers.export(exports, "SpatialAudio", ()=>(0, _spatialAudioDefault.default));
parcelHelpers.export(exports, "SpatialAudioOff", ()=>(0, _spatialAudioOffDefault.default));
parcelHelpers.export(exports, "SpatialAudioOffOutlined", ()=>(0, _spatialAudioOffOutlinedDefault.default));
parcelHelpers.export(exports, "SpatialAudioOffRounded", ()=>(0, _spatialAudioOffRoundedDefault.default));
parcelHelpers.export(exports, "SpatialAudioOffSharp", ()=>(0, _spatialAudioOffSharpDefault.default));
parcelHelpers.export(exports, "SpatialAudioOffTwoTone", ()=>(0, _spatialAudioOffTwoToneDefault.default));
parcelHelpers.export(exports, "SpatialAudioOutlined", ()=>(0, _spatialAudioOutlinedDefault.default));
parcelHelpers.export(exports, "SpatialAudioRounded", ()=>(0, _spatialAudioRoundedDefault.default));
parcelHelpers.export(exports, "SpatialAudioSharp", ()=>(0, _spatialAudioSharpDefault.default));
parcelHelpers.export(exports, "SpatialAudioTwoTone", ()=>(0, _spatialAudioTwoToneDefault.default));
parcelHelpers.export(exports, "SpatialTracking", ()=>(0, _spatialTrackingDefault.default));
parcelHelpers.export(exports, "SpatialTrackingOutlined", ()=>(0, _spatialTrackingOutlinedDefault.default));
parcelHelpers.export(exports, "SpatialTrackingRounded", ()=>(0, _spatialTrackingRoundedDefault.default));
parcelHelpers.export(exports, "SpatialTrackingSharp", ()=>(0, _spatialTrackingSharpDefault.default));
parcelHelpers.export(exports, "SpatialTrackingTwoTone", ()=>(0, _spatialTrackingTwoToneDefault.default));
parcelHelpers.export(exports, "Speaker", ()=>(0, _speakerDefault.default));
parcelHelpers.export(exports, "SpeakerGroup", ()=>(0, _speakerGroupDefault.default));
parcelHelpers.export(exports, "SpeakerGroupOutlined", ()=>(0, _speakerGroupOutlinedDefault.default));
parcelHelpers.export(exports, "SpeakerGroupRounded", ()=>(0, _speakerGroupRoundedDefault.default));
parcelHelpers.export(exports, "SpeakerGroupSharp", ()=>(0, _speakerGroupSharpDefault.default));
parcelHelpers.export(exports, "SpeakerGroupTwoTone", ()=>(0, _speakerGroupTwoToneDefault.default));
parcelHelpers.export(exports, "SpeakerNotes", ()=>(0, _speakerNotesDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOff", ()=>(0, _speakerNotesOffDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOffOutlined", ()=>(0, _speakerNotesOffOutlinedDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOffRounded", ()=>(0, _speakerNotesOffRoundedDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOffSharp", ()=>(0, _speakerNotesOffSharpDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOffTwoTone", ()=>(0, _speakerNotesOffTwoToneDefault.default));
parcelHelpers.export(exports, "SpeakerNotesOutlined", ()=>(0, _speakerNotesOutlinedDefault.default));
parcelHelpers.export(exports, "SpeakerNotesRounded", ()=>(0, _speakerNotesRoundedDefault.default));
parcelHelpers.export(exports, "SpeakerNotesSharp", ()=>(0, _speakerNotesSharpDefault.default));
parcelHelpers.export(exports, "SpeakerNotesTwoTone", ()=>(0, _speakerNotesTwoToneDefault.default));
parcelHelpers.export(exports, "SpeakerOutlined", ()=>(0, _speakerOutlinedDefault.default));
parcelHelpers.export(exports, "SpeakerPhone", ()=>(0, _speakerPhoneDefault.default));
parcelHelpers.export(exports, "SpeakerPhoneOutlined", ()=>(0, _speakerPhoneOutlinedDefault.default));
parcelHelpers.export(exports, "SpeakerPhoneRounded", ()=>(0, _speakerPhoneRoundedDefault.default));
parcelHelpers.export(exports, "SpeakerPhoneSharp", ()=>(0, _speakerPhoneSharpDefault.default));
parcelHelpers.export(exports, "SpeakerPhoneTwoTone", ()=>(0, _speakerPhoneTwoToneDefault.default));
parcelHelpers.export(exports, "SpeakerRounded", ()=>(0, _speakerRoundedDefault.default));
parcelHelpers.export(exports, "SpeakerSharp", ()=>(0, _speakerSharpDefault.default));
parcelHelpers.export(exports, "SpeakerTwoTone", ()=>(0, _speakerTwoToneDefault.default));
parcelHelpers.export(exports, "Speed", ()=>(0, _speedDefault.default));
parcelHelpers.export(exports, "SpeedOutlined", ()=>(0, _speedOutlinedDefault.default));
parcelHelpers.export(exports, "SpeedRounded", ()=>(0, _speedRoundedDefault.default));
parcelHelpers.export(exports, "SpeedSharp", ()=>(0, _speedSharpDefault.default));
parcelHelpers.export(exports, "SpeedTwoTone", ()=>(0, _speedTwoToneDefault.default));
parcelHelpers.export(exports, "Spellcheck", ()=>(0, _spellcheckDefault.default));
parcelHelpers.export(exports, "SpellcheckOutlined", ()=>(0, _spellcheckOutlinedDefault.default));
parcelHelpers.export(exports, "SpellcheckRounded", ()=>(0, _spellcheckRoundedDefault.default));
parcelHelpers.export(exports, "SpellcheckSharp", ()=>(0, _spellcheckSharpDefault.default));
parcelHelpers.export(exports, "SpellcheckTwoTone", ()=>(0, _spellcheckTwoToneDefault.default));
parcelHelpers.export(exports, "Splitscreen", ()=>(0, _splitscreenDefault.default));
parcelHelpers.export(exports, "SplitscreenOutlined", ()=>(0, _splitscreenOutlinedDefault.default));
parcelHelpers.export(exports, "SplitscreenRounded", ()=>(0, _splitscreenRoundedDefault.default));
parcelHelpers.export(exports, "SplitscreenSharp", ()=>(0, _splitscreenSharpDefault.default));
parcelHelpers.export(exports, "SplitscreenTwoTone", ()=>(0, _splitscreenTwoToneDefault.default));
parcelHelpers.export(exports, "Spoke", ()=>(0, _spokeDefault.default));
parcelHelpers.export(exports, "SpokeOutlined", ()=>(0, _spokeOutlinedDefault.default));
parcelHelpers.export(exports, "SpokeRounded", ()=>(0, _spokeRoundedDefault.default));
parcelHelpers.export(exports, "SpokeSharp", ()=>(0, _spokeSharpDefault.default));
parcelHelpers.export(exports, "SpokeTwoTone", ()=>(0, _spokeTwoToneDefault.default));
parcelHelpers.export(exports, "Sports", ()=>(0, _sportsDefault.default));
parcelHelpers.export(exports, "SportsBar", ()=>(0, _sportsBarDefault.default));
parcelHelpers.export(exports, "SportsBarOutlined", ()=>(0, _sportsBarOutlinedDefault.default));
parcelHelpers.export(exports, "SportsBarRounded", ()=>(0, _sportsBarRoundedDefault.default));
parcelHelpers.export(exports, "SportsBarSharp", ()=>(0, _sportsBarSharpDefault.default));
parcelHelpers.export(exports, "SportsBarTwoTone", ()=>(0, _sportsBarTwoToneDefault.default));
parcelHelpers.export(exports, "SportsBaseball", ()=>(0, _sportsBaseballDefault.default));
parcelHelpers.export(exports, "SportsBaseballOutlined", ()=>(0, _sportsBaseballOutlinedDefault.default));
parcelHelpers.export(exports, "SportsBaseballRounded", ()=>(0, _sportsBaseballRoundedDefault.default));
parcelHelpers.export(exports, "SportsBaseballSharp", ()=>(0, _sportsBaseballSharpDefault.default));
parcelHelpers.export(exports, "SportsBaseballTwoTone", ()=>(0, _sportsBaseballTwoToneDefault.default));
parcelHelpers.export(exports, "SportsBasketball", ()=>(0, _sportsBasketballDefault.default));
parcelHelpers.export(exports, "SportsBasketballOutlined", ()=>(0, _sportsBasketballOutlinedDefault.default));
parcelHelpers.export(exports, "SportsBasketballRounded", ()=>(0, _sportsBasketballRoundedDefault.default));
parcelHelpers.export(exports, "SportsBasketballSharp", ()=>(0, _sportsBasketballSharpDefault.default));
parcelHelpers.export(exports, "SportsBasketballTwoTone", ()=>(0, _sportsBasketballTwoToneDefault.default));
parcelHelpers.export(exports, "SportsCricket", ()=>(0, _sportsCricketDefault.default));
parcelHelpers.export(exports, "SportsCricketOutlined", ()=>(0, _sportsCricketOutlinedDefault.default));
parcelHelpers.export(exports, "SportsCricketRounded", ()=>(0, _sportsCricketRoundedDefault.default));
parcelHelpers.export(exports, "SportsCricketSharp", ()=>(0, _sportsCricketSharpDefault.default));
parcelHelpers.export(exports, "SportsCricketTwoTone", ()=>(0, _sportsCricketTwoToneDefault.default));
parcelHelpers.export(exports, "SportsEsports", ()=>(0, _sportsEsportsDefault.default));
parcelHelpers.export(exports, "SportsEsportsOutlined", ()=>(0, _sportsEsportsOutlinedDefault.default));
parcelHelpers.export(exports, "SportsEsportsRounded", ()=>(0, _sportsEsportsRoundedDefault.default));
parcelHelpers.export(exports, "SportsEsportsSharp", ()=>(0, _sportsEsportsSharpDefault.default));
parcelHelpers.export(exports, "SportsEsportsTwoTone", ()=>(0, _sportsEsportsTwoToneDefault.default));
parcelHelpers.export(exports, "SportsFootball", ()=>(0, _sportsFootballDefault.default));
parcelHelpers.export(exports, "SportsFootballOutlined", ()=>(0, _sportsFootballOutlinedDefault.default));
parcelHelpers.export(exports, "SportsFootballRounded", ()=>(0, _sportsFootballRoundedDefault.default));
parcelHelpers.export(exports, "SportsFootballSharp", ()=>(0, _sportsFootballSharpDefault.default));
parcelHelpers.export(exports, "SportsFootballTwoTone", ()=>(0, _sportsFootballTwoToneDefault.default));
parcelHelpers.export(exports, "SportsGolf", ()=>(0, _sportsGolfDefault.default));
parcelHelpers.export(exports, "SportsGolfOutlined", ()=>(0, _sportsGolfOutlinedDefault.default));
parcelHelpers.export(exports, "SportsGolfRounded", ()=>(0, _sportsGolfRoundedDefault.default));
parcelHelpers.export(exports, "SportsGolfSharp", ()=>(0, _sportsGolfSharpDefault.default));
parcelHelpers.export(exports, "SportsGolfTwoTone", ()=>(0, _sportsGolfTwoToneDefault.default));
parcelHelpers.export(exports, "SportsGymnastics", ()=>(0, _sportsGymnasticsDefault.default));
parcelHelpers.export(exports, "SportsGymnasticsOutlined", ()=>(0, _sportsGymnasticsOutlinedDefault.default));
parcelHelpers.export(exports, "SportsGymnasticsRounded", ()=>(0, _sportsGymnasticsRoundedDefault.default));
parcelHelpers.export(exports, "SportsGymnasticsSharp", ()=>(0, _sportsGymnasticsSharpDefault.default));
parcelHelpers.export(exports, "SportsGymnasticsTwoTone", ()=>(0, _sportsGymnasticsTwoToneDefault.default));
parcelHelpers.export(exports, "SportsHandball", ()=>(0, _sportsHandballDefault.default));
parcelHelpers.export(exports, "SportsHandballOutlined", ()=>(0, _sportsHandballOutlinedDefault.default));
parcelHelpers.export(exports, "SportsHandballRounded", ()=>(0, _sportsHandballRoundedDefault.default));
parcelHelpers.export(exports, "SportsHandballSharp", ()=>(0, _sportsHandballSharpDefault.default));
parcelHelpers.export(exports, "SportsHandballTwoTone", ()=>(0, _sportsHandballTwoToneDefault.default));
parcelHelpers.export(exports, "SportsHockey", ()=>(0, _sportsHockeyDefault.default));
parcelHelpers.export(exports, "SportsHockeyOutlined", ()=>(0, _sportsHockeyOutlinedDefault.default));
parcelHelpers.export(exports, "SportsHockeyRounded", ()=>(0, _sportsHockeyRoundedDefault.default));
parcelHelpers.export(exports, "SportsHockeySharp", ()=>(0, _sportsHockeySharpDefault.default));
parcelHelpers.export(exports, "SportsHockeyTwoTone", ()=>(0, _sportsHockeyTwoToneDefault.default));
parcelHelpers.export(exports, "SportsKabaddi", ()=>(0, _sportsKabaddiDefault.default));
parcelHelpers.export(exports, "SportsKabaddiOutlined", ()=>(0, _sportsKabaddiOutlinedDefault.default));
parcelHelpers.export(exports, "SportsKabaddiRounded", ()=>(0, _sportsKabaddiRoundedDefault.default));
parcelHelpers.export(exports, "SportsKabaddiSharp", ()=>(0, _sportsKabaddiSharpDefault.default));
parcelHelpers.export(exports, "SportsKabaddiTwoTone", ()=>(0, _sportsKabaddiTwoToneDefault.default));
parcelHelpers.export(exports, "SportsMartialArts", ()=>(0, _sportsMartialArtsDefault.default));
parcelHelpers.export(exports, "SportsMartialArtsOutlined", ()=>(0, _sportsMartialArtsOutlinedDefault.default));
parcelHelpers.export(exports, "SportsMartialArtsRounded", ()=>(0, _sportsMartialArtsRoundedDefault.default));
parcelHelpers.export(exports, "SportsMartialArtsSharp", ()=>(0, _sportsMartialArtsSharpDefault.default));
parcelHelpers.export(exports, "SportsMartialArtsTwoTone", ()=>(0, _sportsMartialArtsTwoToneDefault.default));
parcelHelpers.export(exports, "SportsMma", ()=>(0, _sportsMmaDefault.default));
parcelHelpers.export(exports, "SportsMmaOutlined", ()=>(0, _sportsMmaOutlinedDefault.default));
parcelHelpers.export(exports, "SportsMmaRounded", ()=>(0, _sportsMmaRoundedDefault.default));
parcelHelpers.export(exports, "SportsMmaSharp", ()=>(0, _sportsMmaSharpDefault.default));
parcelHelpers.export(exports, "SportsMmaTwoTone", ()=>(0, _sportsMmaTwoToneDefault.default));
parcelHelpers.export(exports, "SportsMotorsports", ()=>(0, _sportsMotorsportsDefault.default));
parcelHelpers.export(exports, "SportsMotorsportsOutlined", ()=>(0, _sportsMotorsportsOutlinedDefault.default));
parcelHelpers.export(exports, "SportsMotorsportsRounded", ()=>(0, _sportsMotorsportsRoundedDefault.default));
parcelHelpers.export(exports, "SportsMotorsportsSharp", ()=>(0, _sportsMotorsportsSharpDefault.default));
parcelHelpers.export(exports, "SportsMotorsportsTwoTone", ()=>(0, _sportsMotorsportsTwoToneDefault.default));
parcelHelpers.export(exports, "SportsOutlined", ()=>(0, _sportsOutlinedDefault.default));
parcelHelpers.export(exports, "SportsRounded", ()=>(0, _sportsRoundedDefault.default));
parcelHelpers.export(exports, "SportsRugby", ()=>(0, _sportsRugbyDefault.default));
parcelHelpers.export(exports, "SportsRugbyOutlined", ()=>(0, _sportsRugbyOutlinedDefault.default));
parcelHelpers.export(exports, "SportsRugbyRounded", ()=>(0, _sportsRugbyRoundedDefault.default));
parcelHelpers.export(exports, "SportsRugbySharp", ()=>(0, _sportsRugbySharpDefault.default));
parcelHelpers.export(exports, "SportsRugbyTwoTone", ()=>(0, _sportsRugbyTwoToneDefault.default));
parcelHelpers.export(exports, "SportsScore", ()=>(0, _sportsScoreDefault.default));
parcelHelpers.export(exports, "SportsScoreOutlined", ()=>(0, _sportsScoreOutlinedDefault.default));
parcelHelpers.export(exports, "SportsScoreRounded", ()=>(0, _sportsScoreRoundedDefault.default));
parcelHelpers.export(exports, "SportsScoreSharp", ()=>(0, _sportsScoreSharpDefault.default));
parcelHelpers.export(exports, "SportsScoreTwoTone", ()=>(0, _sportsScoreTwoToneDefault.default));
parcelHelpers.export(exports, "SportsSharp", ()=>(0, _sportsSharpDefault.default));
parcelHelpers.export(exports, "SportsSoccer", ()=>(0, _sportsSoccerDefault.default));
parcelHelpers.export(exports, "SportsSoccerOutlined", ()=>(0, _sportsSoccerOutlinedDefault.default));
parcelHelpers.export(exports, "SportsSoccerRounded", ()=>(0, _sportsSoccerRoundedDefault.default));
parcelHelpers.export(exports, "SportsSoccerSharp", ()=>(0, _sportsSoccerSharpDefault.default));
parcelHelpers.export(exports, "SportsSoccerTwoTone", ()=>(0, _sportsSoccerTwoToneDefault.default));
parcelHelpers.export(exports, "SportsTennis", ()=>(0, _sportsTennisDefault.default));
parcelHelpers.export(exports, "SportsTennisOutlined", ()=>(0, _sportsTennisOutlinedDefault.default));
parcelHelpers.export(exports, "SportsTennisRounded", ()=>(0, _sportsTennisRoundedDefault.default));
parcelHelpers.export(exports, "SportsTennisSharp", ()=>(0, _sportsTennisSharpDefault.default));
parcelHelpers.export(exports, "SportsTennisTwoTone", ()=>(0, _sportsTennisTwoToneDefault.default));
parcelHelpers.export(exports, "SportsTwoTone", ()=>(0, _sportsTwoToneDefault.default));
parcelHelpers.export(exports, "SportsVolleyball", ()=>(0, _sportsVolleyballDefault.default));
parcelHelpers.export(exports, "SportsVolleyballOutlined", ()=>(0, _sportsVolleyballOutlinedDefault.default));
parcelHelpers.export(exports, "SportsVolleyballRounded", ()=>(0, _sportsVolleyballRoundedDefault.default));
parcelHelpers.export(exports, "SportsVolleyballSharp", ()=>(0, _sportsVolleyballSharpDefault.default));
parcelHelpers.export(exports, "SportsVolleyballTwoTone", ()=>(0, _sportsVolleyballTwoToneDefault.default));
parcelHelpers.export(exports, "Square", ()=>(0, _squareDefault.default));
parcelHelpers.export(exports, "SquareFoot", ()=>(0, _squareFootDefault.default));
parcelHelpers.export(exports, "SquareFootOutlined", ()=>(0, _squareFootOutlinedDefault.default));
parcelHelpers.export(exports, "SquareFootRounded", ()=>(0, _squareFootRoundedDefault.default));
parcelHelpers.export(exports, "SquareFootSharp", ()=>(0, _squareFootSharpDefault.default));
parcelHelpers.export(exports, "SquareFootTwoTone", ()=>(0, _squareFootTwoToneDefault.default));
parcelHelpers.export(exports, "SquareOutlined", ()=>(0, _squareOutlinedDefault.default));
parcelHelpers.export(exports, "SquareRounded", ()=>(0, _squareRoundedDefault.default));
parcelHelpers.export(exports, "SquareSharp", ()=>(0, _squareSharpDefault.default));
parcelHelpers.export(exports, "SquareTwoTone", ()=>(0, _squareTwoToneDefault.default));
parcelHelpers.export(exports, "SsidChart", ()=>(0, _ssidChartDefault.default));
parcelHelpers.export(exports, "SsidChartOutlined", ()=>(0, _ssidChartOutlinedDefault.default));
parcelHelpers.export(exports, "SsidChartRounded", ()=>(0, _ssidChartRoundedDefault.default));
parcelHelpers.export(exports, "SsidChartSharp", ()=>(0, _ssidChartSharpDefault.default));
parcelHelpers.export(exports, "SsidChartTwoTone", ()=>(0, _ssidChartTwoToneDefault.default));
parcelHelpers.export(exports, "StackedBarChart", ()=>(0, _stackedBarChartDefault.default));
parcelHelpers.export(exports, "StackedBarChartOutlined", ()=>(0, _stackedBarChartOutlinedDefault.default));
parcelHelpers.export(exports, "StackedBarChartRounded", ()=>(0, _stackedBarChartRoundedDefault.default));
parcelHelpers.export(exports, "StackedBarChartSharp", ()=>(0, _stackedBarChartSharpDefault.default));
parcelHelpers.export(exports, "StackedBarChartTwoTone", ()=>(0, _stackedBarChartTwoToneDefault.default));
parcelHelpers.export(exports, "StackedLineChart", ()=>(0, _stackedLineChartDefault.default));
parcelHelpers.export(exports, "StackedLineChartOutlined", ()=>(0, _stackedLineChartOutlinedDefault.default));
parcelHelpers.export(exports, "StackedLineChartRounded", ()=>(0, _stackedLineChartRoundedDefault.default));
parcelHelpers.export(exports, "StackedLineChartSharp", ()=>(0, _stackedLineChartSharpDefault.default));
parcelHelpers.export(exports, "StackedLineChartTwoTone", ()=>(0, _stackedLineChartTwoToneDefault.default));
parcelHelpers.export(exports, "Stadium", ()=>(0, _stadiumDefault.default));
parcelHelpers.export(exports, "StadiumOutlined", ()=>(0, _stadiumOutlinedDefault.default));
parcelHelpers.export(exports, "StadiumRounded", ()=>(0, _stadiumRoundedDefault.default));
parcelHelpers.export(exports, "StadiumSharp", ()=>(0, _stadiumSharpDefault.default));
parcelHelpers.export(exports, "StadiumTwoTone", ()=>(0, _stadiumTwoToneDefault.default));
parcelHelpers.export(exports, "Stairs", ()=>(0, _stairsDefault.default));
parcelHelpers.export(exports, "StairsOutlined", ()=>(0, _stairsOutlinedDefault.default));
parcelHelpers.export(exports, "StairsRounded", ()=>(0, _stairsRoundedDefault.default));
parcelHelpers.export(exports, "StairsSharp", ()=>(0, _stairsSharpDefault.default));
parcelHelpers.export(exports, "StairsTwoTone", ()=>(0, _stairsTwoToneDefault.default));
parcelHelpers.export(exports, "Star", ()=>(0, _starDefault.default));
parcelHelpers.export(exports, "StarBorder", ()=>(0, _starBorderDefault.default));
parcelHelpers.export(exports, "StarBorderOutlined", ()=>(0, _starBorderOutlinedDefault.default));
parcelHelpers.export(exports, "StarBorderPurple500", ()=>(0, _starBorderPurple500Default.default));
parcelHelpers.export(exports, "StarBorderPurple500Outlined", ()=>(0, _starBorderPurple500OutlinedDefault.default));
parcelHelpers.export(exports, "StarBorderPurple500Rounded", ()=>(0, _starBorderPurple500RoundedDefault.default));
parcelHelpers.export(exports, "StarBorderPurple500Sharp", ()=>(0, _starBorderPurple500SharpDefault.default));
parcelHelpers.export(exports, "StarBorderPurple500TwoTone", ()=>(0, _starBorderPurple500TwoToneDefault.default));
parcelHelpers.export(exports, "StarBorderRounded", ()=>(0, _starBorderRoundedDefault.default));
parcelHelpers.export(exports, "StarBorderSharp", ()=>(0, _starBorderSharpDefault.default));
parcelHelpers.export(exports, "StarBorderTwoTone", ()=>(0, _starBorderTwoToneDefault.default));
parcelHelpers.export(exports, "StarHalf", ()=>(0, _starHalfDefault.default));
parcelHelpers.export(exports, "StarHalfOutlined", ()=>(0, _starHalfOutlinedDefault.default));
parcelHelpers.export(exports, "StarHalfRounded", ()=>(0, _starHalfRoundedDefault.default));
parcelHelpers.export(exports, "StarHalfSharp", ()=>(0, _starHalfSharpDefault.default));
parcelHelpers.export(exports, "StarHalfTwoTone", ()=>(0, _starHalfTwoToneDefault.default));
parcelHelpers.export(exports, "StarOutline", ()=>(0, _starOutlineDefault.default));
parcelHelpers.export(exports, "StarOutlineOutlined", ()=>(0, _starOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "StarOutlineRounded", ()=>(0, _starOutlineRoundedDefault.default));
parcelHelpers.export(exports, "StarOutlineSharp", ()=>(0, _starOutlineSharpDefault.default));
parcelHelpers.export(exports, "StarOutlineTwoTone", ()=>(0, _starOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "StarOutlined", ()=>(0, _starOutlinedDefault.default));
parcelHelpers.export(exports, "StarPurple500", ()=>(0, _starPurple500Default.default));
parcelHelpers.export(exports, "StarPurple500Outlined", ()=>(0, _starPurple500OutlinedDefault.default));
parcelHelpers.export(exports, "StarPurple500Rounded", ()=>(0, _starPurple500RoundedDefault.default));
parcelHelpers.export(exports, "StarPurple500Sharp", ()=>(0, _starPurple500SharpDefault.default));
parcelHelpers.export(exports, "StarPurple500TwoTone", ()=>(0, _starPurple500TwoToneDefault.default));
parcelHelpers.export(exports, "StarRate", ()=>(0, _starRateDefault.default));
parcelHelpers.export(exports, "StarRateOutlined", ()=>(0, _starRateOutlinedDefault.default));
parcelHelpers.export(exports, "StarRateRounded", ()=>(0, _starRateRoundedDefault.default));
parcelHelpers.export(exports, "StarRateSharp", ()=>(0, _starRateSharpDefault.default));
parcelHelpers.export(exports, "StarRateTwoTone", ()=>(0, _starRateTwoToneDefault.default));
parcelHelpers.export(exports, "StarRounded", ()=>(0, _starRoundedDefault.default));
parcelHelpers.export(exports, "StarSharp", ()=>(0, _starSharpDefault.default));
parcelHelpers.export(exports, "StarTwoTone", ()=>(0, _starTwoToneDefault.default));
parcelHelpers.export(exports, "Stars", ()=>(0, _starsDefault.default));
parcelHelpers.export(exports, "StarsOutlined", ()=>(0, _starsOutlinedDefault.default));
parcelHelpers.export(exports, "StarsRounded", ()=>(0, _starsRoundedDefault.default));
parcelHelpers.export(exports, "StarsSharp", ()=>(0, _starsSharpDefault.default));
parcelHelpers.export(exports, "StarsTwoTone", ()=>(0, _starsTwoToneDefault.default));
parcelHelpers.export(exports, "Start", ()=>(0, _startDefault.default));
parcelHelpers.export(exports, "StartOutlined", ()=>(0, _startOutlinedDefault.default));
parcelHelpers.export(exports, "StartRounded", ()=>(0, _startRoundedDefault.default));
parcelHelpers.export(exports, "StartSharp", ()=>(0, _startSharpDefault.default));
parcelHelpers.export(exports, "StartTwoTone", ()=>(0, _startTwoToneDefault.default));
parcelHelpers.export(exports, "StayCurrentLandscape", ()=>(0, _stayCurrentLandscapeDefault.default));
parcelHelpers.export(exports, "StayCurrentLandscapeOutlined", ()=>(0, _stayCurrentLandscapeOutlinedDefault.default));
parcelHelpers.export(exports, "StayCurrentLandscapeRounded", ()=>(0, _stayCurrentLandscapeRoundedDefault.default));
parcelHelpers.export(exports, "StayCurrentLandscapeSharp", ()=>(0, _stayCurrentLandscapeSharpDefault.default));
parcelHelpers.export(exports, "StayCurrentLandscapeTwoTone", ()=>(0, _stayCurrentLandscapeTwoToneDefault.default));
parcelHelpers.export(exports, "StayCurrentPortrait", ()=>(0, _stayCurrentPortraitDefault.default));
parcelHelpers.export(exports, "StayCurrentPortraitOutlined", ()=>(0, _stayCurrentPortraitOutlinedDefault.default));
parcelHelpers.export(exports, "StayCurrentPortraitRounded", ()=>(0, _stayCurrentPortraitRoundedDefault.default));
parcelHelpers.export(exports, "StayCurrentPortraitSharp", ()=>(0, _stayCurrentPortraitSharpDefault.default));
parcelHelpers.export(exports, "StayCurrentPortraitTwoTone", ()=>(0, _stayCurrentPortraitTwoToneDefault.default));
parcelHelpers.export(exports, "StayPrimaryLandscape", ()=>(0, _stayPrimaryLandscapeDefault.default));
parcelHelpers.export(exports, "StayPrimaryLandscapeOutlined", ()=>(0, _stayPrimaryLandscapeOutlinedDefault.default));
parcelHelpers.export(exports, "StayPrimaryLandscapeRounded", ()=>(0, _stayPrimaryLandscapeRoundedDefault.default));
parcelHelpers.export(exports, "StayPrimaryLandscapeSharp", ()=>(0, _stayPrimaryLandscapeSharpDefault.default));
parcelHelpers.export(exports, "StayPrimaryLandscapeTwoTone", ()=>(0, _stayPrimaryLandscapeTwoToneDefault.default));
parcelHelpers.export(exports, "StayPrimaryPortrait", ()=>(0, _stayPrimaryPortraitDefault.default));
parcelHelpers.export(exports, "StayPrimaryPortraitOutlined", ()=>(0, _stayPrimaryPortraitOutlinedDefault.default));
parcelHelpers.export(exports, "StayPrimaryPortraitRounded", ()=>(0, _stayPrimaryPortraitRoundedDefault.default));
parcelHelpers.export(exports, "StayPrimaryPortraitSharp", ()=>(0, _stayPrimaryPortraitSharpDefault.default));
parcelHelpers.export(exports, "StayPrimaryPortraitTwoTone", ()=>(0, _stayPrimaryPortraitTwoToneDefault.default));
parcelHelpers.export(exports, "StickyNote2", ()=>(0, _stickyNote2Default.default));
parcelHelpers.export(exports, "StickyNote2Outlined", ()=>(0, _stickyNote2OutlinedDefault.default));
parcelHelpers.export(exports, "StickyNote2Rounded", ()=>(0, _stickyNote2RoundedDefault.default));
parcelHelpers.export(exports, "StickyNote2Sharp", ()=>(0, _stickyNote2SharpDefault.default));
parcelHelpers.export(exports, "StickyNote2TwoTone", ()=>(0, _stickyNote2TwoToneDefault.default));
parcelHelpers.export(exports, "Stop", ()=>(0, _stopDefault.default));
parcelHelpers.export(exports, "StopCircle", ()=>(0, _stopCircleDefault.default));
parcelHelpers.export(exports, "StopCircleOutlined", ()=>(0, _stopCircleOutlinedDefault.default));
parcelHelpers.export(exports, "StopCircleRounded", ()=>(0, _stopCircleRoundedDefault.default));
parcelHelpers.export(exports, "StopCircleSharp", ()=>(0, _stopCircleSharpDefault.default));
parcelHelpers.export(exports, "StopCircleTwoTone", ()=>(0, _stopCircleTwoToneDefault.default));
parcelHelpers.export(exports, "StopOutlined", ()=>(0, _stopOutlinedDefault.default));
parcelHelpers.export(exports, "StopRounded", ()=>(0, _stopRoundedDefault.default));
parcelHelpers.export(exports, "StopScreenShare", ()=>(0, _stopScreenShareDefault.default));
parcelHelpers.export(exports, "StopScreenShareOutlined", ()=>(0, _stopScreenShareOutlinedDefault.default));
parcelHelpers.export(exports, "StopScreenShareRounded", ()=>(0, _stopScreenShareRoundedDefault.default));
parcelHelpers.export(exports, "StopScreenShareSharp", ()=>(0, _stopScreenShareSharpDefault.default));
parcelHelpers.export(exports, "StopScreenShareTwoTone", ()=>(0, _stopScreenShareTwoToneDefault.default));
parcelHelpers.export(exports, "StopSharp", ()=>(0, _stopSharpDefault.default));
parcelHelpers.export(exports, "StopTwoTone", ()=>(0, _stopTwoToneDefault.default));
parcelHelpers.export(exports, "Storage", ()=>(0, _storageDefault.default));
parcelHelpers.export(exports, "StorageOutlined", ()=>(0, _storageOutlinedDefault.default));
parcelHelpers.export(exports, "StorageRounded", ()=>(0, _storageRoundedDefault.default));
parcelHelpers.export(exports, "StorageSharp", ()=>(0, _storageSharpDefault.default));
parcelHelpers.export(exports, "StorageTwoTone", ()=>(0, _storageTwoToneDefault.default));
parcelHelpers.export(exports, "Store", ()=>(0, _storeDefault.default));
parcelHelpers.export(exports, "StoreMallDirectory", ()=>(0, _storeMallDirectoryDefault.default));
parcelHelpers.export(exports, "StoreMallDirectoryOutlined", ()=>(0, _storeMallDirectoryOutlinedDefault.default));
parcelHelpers.export(exports, "StoreMallDirectoryRounded", ()=>(0, _storeMallDirectoryRoundedDefault.default));
parcelHelpers.export(exports, "StoreMallDirectorySharp", ()=>(0, _storeMallDirectorySharpDefault.default));
parcelHelpers.export(exports, "StoreMallDirectoryTwoTone", ()=>(0, _storeMallDirectoryTwoToneDefault.default));
parcelHelpers.export(exports, "StoreOutlined", ()=>(0, _storeOutlinedDefault.default));
parcelHelpers.export(exports, "StoreRounded", ()=>(0, _storeRoundedDefault.default));
parcelHelpers.export(exports, "StoreSharp", ()=>(0, _storeSharpDefault.default));
parcelHelpers.export(exports, "StoreTwoTone", ()=>(0, _storeTwoToneDefault.default));
parcelHelpers.export(exports, "Storefront", ()=>(0, _storefrontDefault.default));
parcelHelpers.export(exports, "StorefrontOutlined", ()=>(0, _storefrontOutlinedDefault.default));
parcelHelpers.export(exports, "StorefrontRounded", ()=>(0, _storefrontRoundedDefault.default));
parcelHelpers.export(exports, "StorefrontSharp", ()=>(0, _storefrontSharpDefault.default));
parcelHelpers.export(exports, "StorefrontTwoTone", ()=>(0, _storefrontTwoToneDefault.default));
parcelHelpers.export(exports, "Storm", ()=>(0, _stormDefault.default));
parcelHelpers.export(exports, "StormOutlined", ()=>(0, _stormOutlinedDefault.default));
parcelHelpers.export(exports, "StormRounded", ()=>(0, _stormRoundedDefault.default));
parcelHelpers.export(exports, "StormSharp", ()=>(0, _stormSharpDefault.default));
parcelHelpers.export(exports, "StormTwoTone", ()=>(0, _stormTwoToneDefault.default));
parcelHelpers.export(exports, "Straight", ()=>(0, _straightDefault.default));
parcelHelpers.export(exports, "StraightOutlined", ()=>(0, _straightOutlinedDefault.default));
parcelHelpers.export(exports, "StraightRounded", ()=>(0, _straightRoundedDefault.default));
parcelHelpers.export(exports, "StraightSharp", ()=>(0, _straightSharpDefault.default));
parcelHelpers.export(exports, "StraightTwoTone", ()=>(0, _straightTwoToneDefault.default));
parcelHelpers.export(exports, "Straighten", ()=>(0, _straightenDefault.default));
parcelHelpers.export(exports, "StraightenOutlined", ()=>(0, _straightenOutlinedDefault.default));
parcelHelpers.export(exports, "StraightenRounded", ()=>(0, _straightenRoundedDefault.default));
parcelHelpers.export(exports, "StraightenSharp", ()=>(0, _straightenSharpDefault.default));
parcelHelpers.export(exports, "StraightenTwoTone", ()=>(0, _straightenTwoToneDefault.default));
parcelHelpers.export(exports, "Stream", ()=>(0, _streamDefault.default));
parcelHelpers.export(exports, "StreamOutlined", ()=>(0, _streamOutlinedDefault.default));
parcelHelpers.export(exports, "StreamRounded", ()=>(0, _streamRoundedDefault.default));
parcelHelpers.export(exports, "StreamSharp", ()=>(0, _streamSharpDefault.default));
parcelHelpers.export(exports, "StreamTwoTone", ()=>(0, _streamTwoToneDefault.default));
parcelHelpers.export(exports, "Streetview", ()=>(0, _streetviewDefault.default));
parcelHelpers.export(exports, "StreetviewOutlined", ()=>(0, _streetviewOutlinedDefault.default));
parcelHelpers.export(exports, "StreetviewRounded", ()=>(0, _streetviewRoundedDefault.default));
parcelHelpers.export(exports, "StreetviewSharp", ()=>(0, _streetviewSharpDefault.default));
parcelHelpers.export(exports, "StreetviewTwoTone", ()=>(0, _streetviewTwoToneDefault.default));
parcelHelpers.export(exports, "StrikethroughS", ()=>(0, _strikethroughSDefault.default));
parcelHelpers.export(exports, "StrikethroughSOutlined", ()=>(0, _strikethroughSOutlinedDefault.default));
parcelHelpers.export(exports, "StrikethroughSRounded", ()=>(0, _strikethroughSRoundedDefault.default));
parcelHelpers.export(exports, "StrikethroughSSharp", ()=>(0, _strikethroughSSharpDefault.default));
parcelHelpers.export(exports, "StrikethroughSTwoTone", ()=>(0, _strikethroughSTwoToneDefault.default));
parcelHelpers.export(exports, "Stroller", ()=>(0, _strollerDefault.default));
parcelHelpers.export(exports, "StrollerOutlined", ()=>(0, _strollerOutlinedDefault.default));
parcelHelpers.export(exports, "StrollerRounded", ()=>(0, _strollerRoundedDefault.default));
parcelHelpers.export(exports, "StrollerSharp", ()=>(0, _strollerSharpDefault.default));
parcelHelpers.export(exports, "StrollerTwoTone", ()=>(0, _strollerTwoToneDefault.default));
parcelHelpers.export(exports, "Style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "StyleOutlined", ()=>(0, _styleOutlinedDefault.default));
parcelHelpers.export(exports, "StyleRounded", ()=>(0, _styleRoundedDefault.default));
parcelHelpers.export(exports, "StyleSharp", ()=>(0, _styleSharpDefault.default));
parcelHelpers.export(exports, "StyleTwoTone", ()=>(0, _styleTwoToneDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowLeft", ()=>(0, _subdirectoryArrowLeftDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowLeftOutlined", ()=>(0, _subdirectoryArrowLeftOutlinedDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowLeftRounded", ()=>(0, _subdirectoryArrowLeftRoundedDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowLeftSharp", ()=>(0, _subdirectoryArrowLeftSharpDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowLeftTwoTone", ()=>(0, _subdirectoryArrowLeftTwoToneDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowRight", ()=>(0, _subdirectoryArrowRightDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowRightOutlined", ()=>(0, _subdirectoryArrowRightOutlinedDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowRightRounded", ()=>(0, _subdirectoryArrowRightRoundedDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowRightSharp", ()=>(0, _subdirectoryArrowRightSharpDefault.default));
parcelHelpers.export(exports, "SubdirectoryArrowRightTwoTone", ()=>(0, _subdirectoryArrowRightTwoToneDefault.default));
parcelHelpers.export(exports, "Subject", ()=>(0, _subjectDefault.default));
parcelHelpers.export(exports, "SubjectOutlined", ()=>(0, _subjectOutlinedDefault.default));
parcelHelpers.export(exports, "SubjectRounded", ()=>(0, _subjectRoundedDefault.default));
parcelHelpers.export(exports, "SubjectSharp", ()=>(0, _subjectSharpDefault.default));
parcelHelpers.export(exports, "SubjectTwoTone", ()=>(0, _subjectTwoToneDefault.default));
parcelHelpers.export(exports, "Subscript", ()=>(0, _subscriptDefault.default));
parcelHelpers.export(exports, "SubscriptOutlined", ()=>(0, _subscriptOutlinedDefault.default));
parcelHelpers.export(exports, "SubscriptRounded", ()=>(0, _subscriptRoundedDefault.default));
parcelHelpers.export(exports, "SubscriptSharp", ()=>(0, _subscriptSharpDefault.default));
parcelHelpers.export(exports, "SubscriptTwoTone", ()=>(0, _subscriptTwoToneDefault.default));
parcelHelpers.export(exports, "Subscriptions", ()=>(0, _subscriptionsDefault.default));
parcelHelpers.export(exports, "SubscriptionsOutlined", ()=>(0, _subscriptionsOutlinedDefault.default));
parcelHelpers.export(exports, "SubscriptionsRounded", ()=>(0, _subscriptionsRoundedDefault.default));
parcelHelpers.export(exports, "SubscriptionsSharp", ()=>(0, _subscriptionsSharpDefault.default));
parcelHelpers.export(exports, "SubscriptionsTwoTone", ()=>(0, _subscriptionsTwoToneDefault.default));
parcelHelpers.export(exports, "Subtitles", ()=>(0, _subtitlesDefault.default));
parcelHelpers.export(exports, "SubtitlesOff", ()=>(0, _subtitlesOffDefault.default));
parcelHelpers.export(exports, "SubtitlesOffOutlined", ()=>(0, _subtitlesOffOutlinedDefault.default));
parcelHelpers.export(exports, "SubtitlesOffRounded", ()=>(0, _subtitlesOffRoundedDefault.default));
parcelHelpers.export(exports, "SubtitlesOffSharp", ()=>(0, _subtitlesOffSharpDefault.default));
parcelHelpers.export(exports, "SubtitlesOffTwoTone", ()=>(0, _subtitlesOffTwoToneDefault.default));
parcelHelpers.export(exports, "SubtitlesOutlined", ()=>(0, _subtitlesOutlinedDefault.default));
parcelHelpers.export(exports, "SubtitlesRounded", ()=>(0, _subtitlesRoundedDefault.default));
parcelHelpers.export(exports, "SubtitlesSharp", ()=>(0, _subtitlesSharpDefault.default));
parcelHelpers.export(exports, "SubtitlesTwoTone", ()=>(0, _subtitlesTwoToneDefault.default));
parcelHelpers.export(exports, "Subway", ()=>(0, _subwayDefault.default));
parcelHelpers.export(exports, "SubwayOutlined", ()=>(0, _subwayOutlinedDefault.default));
parcelHelpers.export(exports, "SubwayRounded", ()=>(0, _subwayRoundedDefault.default));
parcelHelpers.export(exports, "SubwaySharp", ()=>(0, _subwaySharpDefault.default));
parcelHelpers.export(exports, "SubwayTwoTone", ()=>(0, _subwayTwoToneDefault.default));
parcelHelpers.export(exports, "Summarize", ()=>(0, _summarizeDefault.default));
parcelHelpers.export(exports, "SummarizeOutlined", ()=>(0, _summarizeOutlinedDefault.default));
parcelHelpers.export(exports, "SummarizeRounded", ()=>(0, _summarizeRoundedDefault.default));
parcelHelpers.export(exports, "SummarizeSharp", ()=>(0, _summarizeSharpDefault.default));
parcelHelpers.export(exports, "SummarizeTwoTone", ()=>(0, _summarizeTwoToneDefault.default));
parcelHelpers.export(exports, "Superscript", ()=>(0, _superscriptDefault.default));
parcelHelpers.export(exports, "SuperscriptOutlined", ()=>(0, _superscriptOutlinedDefault.default));
parcelHelpers.export(exports, "SuperscriptRounded", ()=>(0, _superscriptRoundedDefault.default));
parcelHelpers.export(exports, "SuperscriptSharp", ()=>(0, _superscriptSharpDefault.default));
parcelHelpers.export(exports, "SuperscriptTwoTone", ()=>(0, _superscriptTwoToneDefault.default));
parcelHelpers.export(exports, "SupervisedUserCircle", ()=>(0, _supervisedUserCircleDefault.default));
parcelHelpers.export(exports, "SupervisedUserCircleOutlined", ()=>(0, _supervisedUserCircleOutlinedDefault.default));
parcelHelpers.export(exports, "SupervisedUserCircleRounded", ()=>(0, _supervisedUserCircleRoundedDefault.default));
parcelHelpers.export(exports, "SupervisedUserCircleSharp", ()=>(0, _supervisedUserCircleSharpDefault.default));
parcelHelpers.export(exports, "SupervisedUserCircleTwoTone", ()=>(0, _supervisedUserCircleTwoToneDefault.default));
parcelHelpers.export(exports, "SupervisorAccount", ()=>(0, _supervisorAccountDefault.default));
parcelHelpers.export(exports, "SupervisorAccountOutlined", ()=>(0, _supervisorAccountOutlinedDefault.default));
parcelHelpers.export(exports, "SupervisorAccountRounded", ()=>(0, _supervisorAccountRoundedDefault.default));
parcelHelpers.export(exports, "SupervisorAccountSharp", ()=>(0, _supervisorAccountSharpDefault.default));
parcelHelpers.export(exports, "SupervisorAccountTwoTone", ()=>(0, _supervisorAccountTwoToneDefault.default));
parcelHelpers.export(exports, "Support", ()=>(0, _supportDefault.default));
parcelHelpers.export(exports, "SupportAgent", ()=>(0, _supportAgentDefault.default));
parcelHelpers.export(exports, "SupportAgentOutlined", ()=>(0, _supportAgentOutlinedDefault.default));
parcelHelpers.export(exports, "SupportAgentRounded", ()=>(0, _supportAgentRoundedDefault.default));
parcelHelpers.export(exports, "SupportAgentSharp", ()=>(0, _supportAgentSharpDefault.default));
parcelHelpers.export(exports, "SupportAgentTwoTone", ()=>(0, _supportAgentTwoToneDefault.default));
parcelHelpers.export(exports, "SupportOutlined", ()=>(0, _supportOutlinedDefault.default));
parcelHelpers.export(exports, "SupportRounded", ()=>(0, _supportRoundedDefault.default));
parcelHelpers.export(exports, "SupportSharp", ()=>(0, _supportSharpDefault.default));
parcelHelpers.export(exports, "SupportTwoTone", ()=>(0, _supportTwoToneDefault.default));
parcelHelpers.export(exports, "Surfing", ()=>(0, _surfingDefault.default));
parcelHelpers.export(exports, "SurfingOutlined", ()=>(0, _surfingOutlinedDefault.default));
parcelHelpers.export(exports, "SurfingRounded", ()=>(0, _surfingRoundedDefault.default));
parcelHelpers.export(exports, "SurfingSharp", ()=>(0, _surfingSharpDefault.default));
parcelHelpers.export(exports, "SurfingTwoTone", ()=>(0, _surfingTwoToneDefault.default));
parcelHelpers.export(exports, "SurroundSound", ()=>(0, _surroundSoundDefault.default));
parcelHelpers.export(exports, "SurroundSoundOutlined", ()=>(0, _surroundSoundOutlinedDefault.default));
parcelHelpers.export(exports, "SurroundSoundRounded", ()=>(0, _surroundSoundRoundedDefault.default));
parcelHelpers.export(exports, "SurroundSoundSharp", ()=>(0, _surroundSoundSharpDefault.default));
parcelHelpers.export(exports, "SurroundSoundTwoTone", ()=>(0, _surroundSoundTwoToneDefault.default));
parcelHelpers.export(exports, "SwapCalls", ()=>(0, _swapCallsDefault.default));
parcelHelpers.export(exports, "SwapCallsOutlined", ()=>(0, _swapCallsOutlinedDefault.default));
parcelHelpers.export(exports, "SwapCallsRounded", ()=>(0, _swapCallsRoundedDefault.default));
parcelHelpers.export(exports, "SwapCallsSharp", ()=>(0, _swapCallsSharpDefault.default));
parcelHelpers.export(exports, "SwapCallsTwoTone", ()=>(0, _swapCallsTwoToneDefault.default));
parcelHelpers.export(exports, "SwapHoriz", ()=>(0, _swapHorizDefault.default));
parcelHelpers.export(exports, "SwapHorizOutlined", ()=>(0, _swapHorizOutlinedDefault.default));
parcelHelpers.export(exports, "SwapHorizRounded", ()=>(0, _swapHorizRoundedDefault.default));
parcelHelpers.export(exports, "SwapHorizSharp", ()=>(0, _swapHorizSharpDefault.default));
parcelHelpers.export(exports, "SwapHorizTwoTone", ()=>(0, _swapHorizTwoToneDefault.default));
parcelHelpers.export(exports, "SwapHorizontalCircle", ()=>(0, _swapHorizontalCircleDefault.default));
parcelHelpers.export(exports, "SwapHorizontalCircleOutlined", ()=>(0, _swapHorizontalCircleOutlinedDefault.default));
parcelHelpers.export(exports, "SwapHorizontalCircleRounded", ()=>(0, _swapHorizontalCircleRoundedDefault.default));
parcelHelpers.export(exports, "SwapHorizontalCircleSharp", ()=>(0, _swapHorizontalCircleSharpDefault.default));
parcelHelpers.export(exports, "SwapHorizontalCircleTwoTone", ()=>(0, _swapHorizontalCircleTwoToneDefault.default));
parcelHelpers.export(exports, "SwapVert", ()=>(0, _swapVertDefault.default));
parcelHelpers.export(exports, "SwapVertOutlined", ()=>(0, _swapVertOutlinedDefault.default));
parcelHelpers.export(exports, "SwapVertRounded", ()=>(0, _swapVertRoundedDefault.default));
parcelHelpers.export(exports, "SwapVertSharp", ()=>(0, _swapVertSharpDefault.default));
parcelHelpers.export(exports, "SwapVertTwoTone", ()=>(0, _swapVertTwoToneDefault.default));
parcelHelpers.export(exports, "SwapVerticalCircle", ()=>(0, _swapVerticalCircleDefault.default));
parcelHelpers.export(exports, "SwapVerticalCircleOutlined", ()=>(0, _swapVerticalCircleOutlinedDefault.default));
parcelHelpers.export(exports, "SwapVerticalCircleRounded", ()=>(0, _swapVerticalCircleRoundedDefault.default));
parcelHelpers.export(exports, "SwapVerticalCircleSharp", ()=>(0, _swapVerticalCircleSharpDefault.default));
parcelHelpers.export(exports, "SwapVerticalCircleTwoTone", ()=>(0, _swapVerticalCircleTwoToneDefault.default));
parcelHelpers.export(exports, "Swipe", ()=>(0, _swipeDefault.default));
parcelHelpers.export(exports, "SwipeDown", ()=>(0, _swipeDownDefault.default));
parcelHelpers.export(exports, "SwipeDownAlt", ()=>(0, _swipeDownAltDefault.default));
parcelHelpers.export(exports, "SwipeDownAltOutlined", ()=>(0, _swipeDownAltOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeDownAltRounded", ()=>(0, _swipeDownAltRoundedDefault.default));
parcelHelpers.export(exports, "SwipeDownAltSharp", ()=>(0, _swipeDownAltSharpDefault.default));
parcelHelpers.export(exports, "SwipeDownAltTwoTone", ()=>(0, _swipeDownAltTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeDownOutlined", ()=>(0, _swipeDownOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeDownRounded", ()=>(0, _swipeDownRoundedDefault.default));
parcelHelpers.export(exports, "SwipeDownSharp", ()=>(0, _swipeDownSharpDefault.default));
parcelHelpers.export(exports, "SwipeDownTwoTone", ()=>(0, _swipeDownTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeLeft", ()=>(0, _swipeLeftDefault.default));
parcelHelpers.export(exports, "SwipeLeftAlt", ()=>(0, _swipeLeftAltDefault.default));
parcelHelpers.export(exports, "SwipeLeftAltOutlined", ()=>(0, _swipeLeftAltOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeLeftAltRounded", ()=>(0, _swipeLeftAltRoundedDefault.default));
parcelHelpers.export(exports, "SwipeLeftAltSharp", ()=>(0, _swipeLeftAltSharpDefault.default));
parcelHelpers.export(exports, "SwipeLeftAltTwoTone", ()=>(0, _swipeLeftAltTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeLeftOutlined", ()=>(0, _swipeLeftOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeLeftRounded", ()=>(0, _swipeLeftRoundedDefault.default));
parcelHelpers.export(exports, "SwipeLeftSharp", ()=>(0, _swipeLeftSharpDefault.default));
parcelHelpers.export(exports, "SwipeLeftTwoTone", ()=>(0, _swipeLeftTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeOutlined", ()=>(0, _swipeOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeRight", ()=>(0, _swipeRightDefault.default));
parcelHelpers.export(exports, "SwipeRightAlt", ()=>(0, _swipeRightAltDefault.default));
parcelHelpers.export(exports, "SwipeRightAltOutlined", ()=>(0, _swipeRightAltOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeRightAltRounded", ()=>(0, _swipeRightAltRoundedDefault.default));
parcelHelpers.export(exports, "SwipeRightAltSharp", ()=>(0, _swipeRightAltSharpDefault.default));
parcelHelpers.export(exports, "SwipeRightAltTwoTone", ()=>(0, _swipeRightAltTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeRightOutlined", ()=>(0, _swipeRightOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeRightRounded", ()=>(0, _swipeRightRoundedDefault.default));
parcelHelpers.export(exports, "SwipeRightSharp", ()=>(0, _swipeRightSharpDefault.default));
parcelHelpers.export(exports, "SwipeRightTwoTone", ()=>(0, _swipeRightTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeRounded", ()=>(0, _swipeRoundedDefault.default));
parcelHelpers.export(exports, "SwipeSharp", ()=>(0, _swipeSharpDefault.default));
parcelHelpers.export(exports, "SwipeTwoTone", ()=>(0, _swipeTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeUp", ()=>(0, _swipeUpDefault.default));
parcelHelpers.export(exports, "SwipeUpAlt", ()=>(0, _swipeUpAltDefault.default));
parcelHelpers.export(exports, "SwipeUpAltOutlined", ()=>(0, _swipeUpAltOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeUpAltRounded", ()=>(0, _swipeUpAltRoundedDefault.default));
parcelHelpers.export(exports, "SwipeUpAltSharp", ()=>(0, _swipeUpAltSharpDefault.default));
parcelHelpers.export(exports, "SwipeUpAltTwoTone", ()=>(0, _swipeUpAltTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeUpOutlined", ()=>(0, _swipeUpOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeUpRounded", ()=>(0, _swipeUpRoundedDefault.default));
parcelHelpers.export(exports, "SwipeUpSharp", ()=>(0, _swipeUpSharpDefault.default));
parcelHelpers.export(exports, "SwipeUpTwoTone", ()=>(0, _swipeUpTwoToneDefault.default));
parcelHelpers.export(exports, "SwipeVertical", ()=>(0, _swipeVerticalDefault.default));
parcelHelpers.export(exports, "SwipeVerticalOutlined", ()=>(0, _swipeVerticalOutlinedDefault.default));
parcelHelpers.export(exports, "SwipeVerticalRounded", ()=>(0, _swipeVerticalRoundedDefault.default));
parcelHelpers.export(exports, "SwipeVerticalSharp", ()=>(0, _swipeVerticalSharpDefault.default));
parcelHelpers.export(exports, "SwipeVerticalTwoTone", ()=>(0, _swipeVerticalTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcut", ()=>(0, _switchAccessShortcutDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutAdd", ()=>(0, _switchAccessShortcutAddDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutAddOutlined", ()=>(0, _switchAccessShortcutAddOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutAddRounded", ()=>(0, _switchAccessShortcutAddRoundedDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutAddSharp", ()=>(0, _switchAccessShortcutAddSharpDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutAddTwoTone", ()=>(0, _switchAccessShortcutAddTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutOutlined", ()=>(0, _switchAccessShortcutOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutRounded", ()=>(0, _switchAccessShortcutRoundedDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutSharp", ()=>(0, _switchAccessShortcutSharpDefault.default));
parcelHelpers.export(exports, "SwitchAccessShortcutTwoTone", ()=>(0, _switchAccessShortcutTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchAccount", ()=>(0, _switchAccountDefault.default));
parcelHelpers.export(exports, "SwitchAccountOutlined", ()=>(0, _switchAccountOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchAccountRounded", ()=>(0, _switchAccountRoundedDefault.default));
parcelHelpers.export(exports, "SwitchAccountSharp", ()=>(0, _switchAccountSharpDefault.default));
parcelHelpers.export(exports, "SwitchAccountTwoTone", ()=>(0, _switchAccountTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchCamera", ()=>(0, _switchCameraDefault.default));
parcelHelpers.export(exports, "SwitchCameraOutlined", ()=>(0, _switchCameraOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchCameraRounded", ()=>(0, _switchCameraRoundedDefault.default));
parcelHelpers.export(exports, "SwitchCameraSharp", ()=>(0, _switchCameraSharpDefault.default));
parcelHelpers.export(exports, "SwitchCameraTwoTone", ()=>(0, _switchCameraTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchLeft", ()=>(0, _switchLeftDefault.default));
parcelHelpers.export(exports, "SwitchLeftOutlined", ()=>(0, _switchLeftOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchLeftRounded", ()=>(0, _switchLeftRoundedDefault.default));
parcelHelpers.export(exports, "SwitchLeftSharp", ()=>(0, _switchLeftSharpDefault.default));
parcelHelpers.export(exports, "SwitchLeftTwoTone", ()=>(0, _switchLeftTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchRight", ()=>(0, _switchRightDefault.default));
parcelHelpers.export(exports, "SwitchRightOutlined", ()=>(0, _switchRightOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchRightRounded", ()=>(0, _switchRightRoundedDefault.default));
parcelHelpers.export(exports, "SwitchRightSharp", ()=>(0, _switchRightSharpDefault.default));
parcelHelpers.export(exports, "SwitchRightTwoTone", ()=>(0, _switchRightTwoToneDefault.default));
parcelHelpers.export(exports, "SwitchVideo", ()=>(0, _switchVideoDefault.default));
parcelHelpers.export(exports, "SwitchVideoOutlined", ()=>(0, _switchVideoOutlinedDefault.default));
parcelHelpers.export(exports, "SwitchVideoRounded", ()=>(0, _switchVideoRoundedDefault.default));
parcelHelpers.export(exports, "SwitchVideoSharp", ()=>(0, _switchVideoSharpDefault.default));
parcelHelpers.export(exports, "SwitchVideoTwoTone", ()=>(0, _switchVideoTwoToneDefault.default));
parcelHelpers.export(exports, "Synagogue", ()=>(0, _synagogueDefault.default));
parcelHelpers.export(exports, "SynagogueOutlined", ()=>(0, _synagogueOutlinedDefault.default));
parcelHelpers.export(exports, "SynagogueRounded", ()=>(0, _synagogueRoundedDefault.default));
parcelHelpers.export(exports, "SynagogueSharp", ()=>(0, _synagogueSharpDefault.default));
parcelHelpers.export(exports, "SynagogueTwoTone", ()=>(0, _synagogueTwoToneDefault.default));
parcelHelpers.export(exports, "Sync", ()=>(0, _syncDefault.default));
parcelHelpers.export(exports, "SyncAlt", ()=>(0, _syncAltDefault.default));
parcelHelpers.export(exports, "SyncAltOutlined", ()=>(0, _syncAltOutlinedDefault.default));
parcelHelpers.export(exports, "SyncAltRounded", ()=>(0, _syncAltRoundedDefault.default));
parcelHelpers.export(exports, "SyncAltSharp", ()=>(0, _syncAltSharpDefault.default));
parcelHelpers.export(exports, "SyncAltTwoTone", ()=>(0, _syncAltTwoToneDefault.default));
parcelHelpers.export(exports, "SyncDisabled", ()=>(0, _syncDisabledDefault.default));
parcelHelpers.export(exports, "SyncDisabledOutlined", ()=>(0, _syncDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "SyncDisabledRounded", ()=>(0, _syncDisabledRoundedDefault.default));
parcelHelpers.export(exports, "SyncDisabledSharp", ()=>(0, _syncDisabledSharpDefault.default));
parcelHelpers.export(exports, "SyncDisabledTwoTone", ()=>(0, _syncDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "SyncLock", ()=>(0, _syncLockDefault.default));
parcelHelpers.export(exports, "SyncLockOutlined", ()=>(0, _syncLockOutlinedDefault.default));
parcelHelpers.export(exports, "SyncLockRounded", ()=>(0, _syncLockRoundedDefault.default));
parcelHelpers.export(exports, "SyncLockSharp", ()=>(0, _syncLockSharpDefault.default));
parcelHelpers.export(exports, "SyncLockTwoTone", ()=>(0, _syncLockTwoToneDefault.default));
parcelHelpers.export(exports, "SyncOutlined", ()=>(0, _syncOutlinedDefault.default));
parcelHelpers.export(exports, "SyncProblem", ()=>(0, _syncProblemDefault.default));
parcelHelpers.export(exports, "SyncProblemOutlined", ()=>(0, _syncProblemOutlinedDefault.default));
parcelHelpers.export(exports, "SyncProblemRounded", ()=>(0, _syncProblemRoundedDefault.default));
parcelHelpers.export(exports, "SyncProblemSharp", ()=>(0, _syncProblemSharpDefault.default));
parcelHelpers.export(exports, "SyncProblemTwoTone", ()=>(0, _syncProblemTwoToneDefault.default));
parcelHelpers.export(exports, "SyncRounded", ()=>(0, _syncRoundedDefault.default));
parcelHelpers.export(exports, "SyncSharp", ()=>(0, _syncSharpDefault.default));
parcelHelpers.export(exports, "SyncTwoTone", ()=>(0, _syncTwoToneDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdate", ()=>(0, _systemSecurityUpdateDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateGood", ()=>(0, _systemSecurityUpdateGoodDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateGoodOutlined", ()=>(0, _systemSecurityUpdateGoodOutlinedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateGoodRounded", ()=>(0, _systemSecurityUpdateGoodRoundedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateGoodSharp", ()=>(0, _systemSecurityUpdateGoodSharpDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateGoodTwoTone", ()=>(0, _systemSecurityUpdateGoodTwoToneDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateOutlined", ()=>(0, _systemSecurityUpdateOutlinedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateRounded", ()=>(0, _systemSecurityUpdateRoundedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateSharp", ()=>(0, _systemSecurityUpdateSharpDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateTwoTone", ()=>(0, _systemSecurityUpdateTwoToneDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateWarning", ()=>(0, _systemSecurityUpdateWarningDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateWarningOutlined", ()=>(0, _systemSecurityUpdateWarningOutlinedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateWarningRounded", ()=>(0, _systemSecurityUpdateWarningRoundedDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateWarningSharp", ()=>(0, _systemSecurityUpdateWarningSharpDefault.default));
parcelHelpers.export(exports, "SystemSecurityUpdateWarningTwoTone", ()=>(0, _systemSecurityUpdateWarningTwoToneDefault.default));
parcelHelpers.export(exports, "SystemUpdate", ()=>(0, _systemUpdateDefault.default));
parcelHelpers.export(exports, "SystemUpdateAlt", ()=>(0, _systemUpdateAltDefault.default));
parcelHelpers.export(exports, "SystemUpdateAltOutlined", ()=>(0, _systemUpdateAltOutlinedDefault.default));
parcelHelpers.export(exports, "SystemUpdateAltRounded", ()=>(0, _systemUpdateAltRoundedDefault.default));
parcelHelpers.export(exports, "SystemUpdateAltSharp", ()=>(0, _systemUpdateAltSharpDefault.default));
parcelHelpers.export(exports, "SystemUpdateAltTwoTone", ()=>(0, _systemUpdateAltTwoToneDefault.default));
parcelHelpers.export(exports, "SystemUpdateOutlined", ()=>(0, _systemUpdateOutlinedDefault.default));
parcelHelpers.export(exports, "SystemUpdateRounded", ()=>(0, _systemUpdateRoundedDefault.default));
parcelHelpers.export(exports, "SystemUpdateSharp", ()=>(0, _systemUpdateSharpDefault.default));
parcelHelpers.export(exports, "SystemUpdateTwoTone", ()=>(0, _systemUpdateTwoToneDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "TabOutlined", ()=>(0, _tabOutlinedDefault.default));
parcelHelpers.export(exports, "TabRounded", ()=>(0, _tabRoundedDefault.default));
parcelHelpers.export(exports, "TabSharp", ()=>(0, _tabSharpDefault.default));
parcelHelpers.export(exports, "TabTwoTone", ()=>(0, _tabTwoToneDefault.default));
parcelHelpers.export(exports, "TabUnselected", ()=>(0, _tabUnselectedDefault.default));
parcelHelpers.export(exports, "TabUnselectedOutlined", ()=>(0, _tabUnselectedOutlinedDefault.default));
parcelHelpers.export(exports, "TabUnselectedRounded", ()=>(0, _tabUnselectedRoundedDefault.default));
parcelHelpers.export(exports, "TabUnselectedSharp", ()=>(0, _tabUnselectedSharpDefault.default));
parcelHelpers.export(exports, "TabUnselectedTwoTone", ()=>(0, _tabUnselectedTwoToneDefault.default));
parcelHelpers.export(exports, "TableBar", ()=>(0, _tableBarDefault.default));
parcelHelpers.export(exports, "TableBarOutlined", ()=>(0, _tableBarOutlinedDefault.default));
parcelHelpers.export(exports, "TableBarRounded", ()=>(0, _tableBarRoundedDefault.default));
parcelHelpers.export(exports, "TableBarSharp", ()=>(0, _tableBarSharpDefault.default));
parcelHelpers.export(exports, "TableBarTwoTone", ()=>(0, _tableBarTwoToneDefault.default));
parcelHelpers.export(exports, "TableChart", ()=>(0, _tableChartDefault.default));
parcelHelpers.export(exports, "TableChartOutlined", ()=>(0, _tableChartOutlinedDefault.default));
parcelHelpers.export(exports, "TableChartRounded", ()=>(0, _tableChartRoundedDefault.default));
parcelHelpers.export(exports, "TableChartSharp", ()=>(0, _tableChartSharpDefault.default));
parcelHelpers.export(exports, "TableChartTwoTone", ()=>(0, _tableChartTwoToneDefault.default));
parcelHelpers.export(exports, "TableRestaurant", ()=>(0, _tableRestaurantDefault.default));
parcelHelpers.export(exports, "TableRestaurantOutlined", ()=>(0, _tableRestaurantOutlinedDefault.default));
parcelHelpers.export(exports, "TableRestaurantRounded", ()=>(0, _tableRestaurantRoundedDefault.default));
parcelHelpers.export(exports, "TableRestaurantSharp", ()=>(0, _tableRestaurantSharpDefault.default));
parcelHelpers.export(exports, "TableRestaurantTwoTone", ()=>(0, _tableRestaurantTwoToneDefault.default));
parcelHelpers.export(exports, "TableRows", ()=>(0, _tableRowsDefault.default));
parcelHelpers.export(exports, "TableRowsOutlined", ()=>(0, _tableRowsOutlinedDefault.default));
parcelHelpers.export(exports, "TableRowsRounded", ()=>(0, _tableRowsRoundedDefault.default));
parcelHelpers.export(exports, "TableRowsSharp", ()=>(0, _tableRowsSharpDefault.default));
parcelHelpers.export(exports, "TableRowsTwoTone", ()=>(0, _tableRowsTwoToneDefault.default));
parcelHelpers.export(exports, "TableView", ()=>(0, _tableViewDefault.default));
parcelHelpers.export(exports, "TableViewOutlined", ()=>(0, _tableViewOutlinedDefault.default));
parcelHelpers.export(exports, "TableViewRounded", ()=>(0, _tableViewRoundedDefault.default));
parcelHelpers.export(exports, "TableViewSharp", ()=>(0, _tableViewSharpDefault.default));
parcelHelpers.export(exports, "TableViewTwoTone", ()=>(0, _tableViewTwoToneDefault.default));
parcelHelpers.export(exports, "Tablet", ()=>(0, _tabletDefault.default));
parcelHelpers.export(exports, "TabletAndroid", ()=>(0, _tabletAndroidDefault.default));
parcelHelpers.export(exports, "TabletAndroidOutlined", ()=>(0, _tabletAndroidOutlinedDefault.default));
parcelHelpers.export(exports, "TabletAndroidRounded", ()=>(0, _tabletAndroidRoundedDefault.default));
parcelHelpers.export(exports, "TabletAndroidSharp", ()=>(0, _tabletAndroidSharpDefault.default));
parcelHelpers.export(exports, "TabletAndroidTwoTone", ()=>(0, _tabletAndroidTwoToneDefault.default));
parcelHelpers.export(exports, "TabletMac", ()=>(0, _tabletMacDefault.default));
parcelHelpers.export(exports, "TabletMacOutlined", ()=>(0, _tabletMacOutlinedDefault.default));
parcelHelpers.export(exports, "TabletMacRounded", ()=>(0, _tabletMacRoundedDefault.default));
parcelHelpers.export(exports, "TabletMacSharp", ()=>(0, _tabletMacSharpDefault.default));
parcelHelpers.export(exports, "TabletMacTwoTone", ()=>(0, _tabletMacTwoToneDefault.default));
parcelHelpers.export(exports, "TabletOutlined", ()=>(0, _tabletOutlinedDefault.default));
parcelHelpers.export(exports, "TabletRounded", ()=>(0, _tabletRoundedDefault.default));
parcelHelpers.export(exports, "TabletSharp", ()=>(0, _tabletSharpDefault.default));
parcelHelpers.export(exports, "TabletTwoTone", ()=>(0, _tabletTwoToneDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagDefault.default));
parcelHelpers.export(exports, "TagFaces", ()=>(0, _tagFacesDefault.default));
parcelHelpers.export(exports, "TagFacesOutlined", ()=>(0, _tagFacesOutlinedDefault.default));
parcelHelpers.export(exports, "TagFacesRounded", ()=>(0, _tagFacesRoundedDefault.default));
parcelHelpers.export(exports, "TagFacesSharp", ()=>(0, _tagFacesSharpDefault.default));
parcelHelpers.export(exports, "TagFacesTwoTone", ()=>(0, _tagFacesTwoToneDefault.default));
parcelHelpers.export(exports, "TagOutlined", ()=>(0, _tagOutlinedDefault.default));
parcelHelpers.export(exports, "TagRounded", ()=>(0, _tagRoundedDefault.default));
parcelHelpers.export(exports, "TagSharp", ()=>(0, _tagSharpDefault.default));
parcelHelpers.export(exports, "TagTwoTone", ()=>(0, _tagTwoToneDefault.default));
parcelHelpers.export(exports, "TakeoutDining", ()=>(0, _takeoutDiningDefault.default));
parcelHelpers.export(exports, "TakeoutDiningOutlined", ()=>(0, _takeoutDiningOutlinedDefault.default));
parcelHelpers.export(exports, "TakeoutDiningRounded", ()=>(0, _takeoutDiningRoundedDefault.default));
parcelHelpers.export(exports, "TakeoutDiningSharp", ()=>(0, _takeoutDiningSharpDefault.default));
parcelHelpers.export(exports, "TakeoutDiningTwoTone", ()=>(0, _takeoutDiningTwoToneDefault.default));
parcelHelpers.export(exports, "TapAndPlay", ()=>(0, _tapAndPlayDefault.default));
parcelHelpers.export(exports, "TapAndPlayOutlined", ()=>(0, _tapAndPlayOutlinedDefault.default));
parcelHelpers.export(exports, "TapAndPlayRounded", ()=>(0, _tapAndPlayRoundedDefault.default));
parcelHelpers.export(exports, "TapAndPlaySharp", ()=>(0, _tapAndPlaySharpDefault.default));
parcelHelpers.export(exports, "TapAndPlayTwoTone", ()=>(0, _tapAndPlayTwoToneDefault.default));
parcelHelpers.export(exports, "Tapas", ()=>(0, _tapasDefault.default));
parcelHelpers.export(exports, "TapasOutlined", ()=>(0, _tapasOutlinedDefault.default));
parcelHelpers.export(exports, "TapasRounded", ()=>(0, _tapasRoundedDefault.default));
parcelHelpers.export(exports, "TapasSharp", ()=>(0, _tapasSharpDefault.default));
parcelHelpers.export(exports, "TapasTwoTone", ()=>(0, _tapasTwoToneDefault.default));
parcelHelpers.export(exports, "Task", ()=>(0, _taskDefault.default));
parcelHelpers.export(exports, "TaskAlt", ()=>(0, _taskAltDefault.default));
parcelHelpers.export(exports, "TaskAltOutlined", ()=>(0, _taskAltOutlinedDefault.default));
parcelHelpers.export(exports, "TaskAltRounded", ()=>(0, _taskAltRoundedDefault.default));
parcelHelpers.export(exports, "TaskAltSharp", ()=>(0, _taskAltSharpDefault.default));
parcelHelpers.export(exports, "TaskAltTwoTone", ()=>(0, _taskAltTwoToneDefault.default));
parcelHelpers.export(exports, "TaskOutlined", ()=>(0, _taskOutlinedDefault.default));
parcelHelpers.export(exports, "TaskRounded", ()=>(0, _taskRoundedDefault.default));
parcelHelpers.export(exports, "TaskSharp", ()=>(0, _taskSharpDefault.default));
parcelHelpers.export(exports, "TaskTwoTone", ()=>(0, _taskTwoToneDefault.default));
parcelHelpers.export(exports, "TaxiAlert", ()=>(0, _taxiAlertDefault.default));
parcelHelpers.export(exports, "TaxiAlertOutlined", ()=>(0, _taxiAlertOutlinedDefault.default));
parcelHelpers.export(exports, "TaxiAlertRounded", ()=>(0, _taxiAlertRoundedDefault.default));
parcelHelpers.export(exports, "TaxiAlertSharp", ()=>(0, _taxiAlertSharpDefault.default));
parcelHelpers.export(exports, "TaxiAlertTwoTone", ()=>(0, _taxiAlertTwoToneDefault.default));
parcelHelpers.export(exports, "Telegram", ()=>(0, _telegramDefault.default));
parcelHelpers.export(exports, "TempleBuddhist", ()=>(0, _templeBuddhistDefault.default));
parcelHelpers.export(exports, "TempleBuddhistOutlined", ()=>(0, _templeBuddhistOutlinedDefault.default));
parcelHelpers.export(exports, "TempleBuddhistRounded", ()=>(0, _templeBuddhistRoundedDefault.default));
parcelHelpers.export(exports, "TempleBuddhistSharp", ()=>(0, _templeBuddhistSharpDefault.default));
parcelHelpers.export(exports, "TempleBuddhistTwoTone", ()=>(0, _templeBuddhistTwoToneDefault.default));
parcelHelpers.export(exports, "TempleHindu", ()=>(0, _templeHinduDefault.default));
parcelHelpers.export(exports, "TempleHinduOutlined", ()=>(0, _templeHinduOutlinedDefault.default));
parcelHelpers.export(exports, "TempleHinduRounded", ()=>(0, _templeHinduRoundedDefault.default));
parcelHelpers.export(exports, "TempleHinduSharp", ()=>(0, _templeHinduSharpDefault.default));
parcelHelpers.export(exports, "TempleHinduTwoTone", ()=>(0, _templeHinduTwoToneDefault.default));
parcelHelpers.export(exports, "TenMp", ()=>(0, _tenMpDefault.default));
parcelHelpers.export(exports, "TenMpOutlined", ()=>(0, _tenMpOutlinedDefault.default));
parcelHelpers.export(exports, "TenMpRounded", ()=>(0, _tenMpRoundedDefault.default));
parcelHelpers.export(exports, "TenMpSharp", ()=>(0, _tenMpSharpDefault.default));
parcelHelpers.export(exports, "TenMpTwoTone", ()=>(0, _tenMpTwoToneDefault.default));
parcelHelpers.export(exports, "Terminal", ()=>(0, _terminalDefault.default));
parcelHelpers.export(exports, "TerminalOutlined", ()=>(0, _terminalOutlinedDefault.default));
parcelHelpers.export(exports, "TerminalRounded", ()=>(0, _terminalRoundedDefault.default));
parcelHelpers.export(exports, "TerminalSharp", ()=>(0, _terminalSharpDefault.default));
parcelHelpers.export(exports, "TerminalTwoTone", ()=>(0, _terminalTwoToneDefault.default));
parcelHelpers.export(exports, "Terrain", ()=>(0, _terrainDefault.default));
parcelHelpers.export(exports, "TerrainOutlined", ()=>(0, _terrainOutlinedDefault.default));
parcelHelpers.export(exports, "TerrainRounded", ()=>(0, _terrainRoundedDefault.default));
parcelHelpers.export(exports, "TerrainSharp", ()=>(0, _terrainSharpDefault.default));
parcelHelpers.export(exports, "TerrainTwoTone", ()=>(0, _terrainTwoToneDefault.default));
parcelHelpers.export(exports, "TextDecrease", ()=>(0, _textDecreaseDefault.default));
parcelHelpers.export(exports, "TextDecreaseOutlined", ()=>(0, _textDecreaseOutlinedDefault.default));
parcelHelpers.export(exports, "TextDecreaseRounded", ()=>(0, _textDecreaseRoundedDefault.default));
parcelHelpers.export(exports, "TextDecreaseSharp", ()=>(0, _textDecreaseSharpDefault.default));
parcelHelpers.export(exports, "TextDecreaseTwoTone", ()=>(0, _textDecreaseTwoToneDefault.default));
parcelHelpers.export(exports, "TextFields", ()=>(0, _textFieldsDefault.default));
parcelHelpers.export(exports, "TextFieldsOutlined", ()=>(0, _textFieldsOutlinedDefault.default));
parcelHelpers.export(exports, "TextFieldsRounded", ()=>(0, _textFieldsRoundedDefault.default));
parcelHelpers.export(exports, "TextFieldsSharp", ()=>(0, _textFieldsSharpDefault.default));
parcelHelpers.export(exports, "TextFieldsTwoTone", ()=>(0, _textFieldsTwoToneDefault.default));
parcelHelpers.export(exports, "TextFormat", ()=>(0, _textFormatDefault.default));
parcelHelpers.export(exports, "TextFormatOutlined", ()=>(0, _textFormatOutlinedDefault.default));
parcelHelpers.export(exports, "TextFormatRounded", ()=>(0, _textFormatRoundedDefault.default));
parcelHelpers.export(exports, "TextFormatSharp", ()=>(0, _textFormatSharpDefault.default));
parcelHelpers.export(exports, "TextFormatTwoTone", ()=>(0, _textFormatTwoToneDefault.default));
parcelHelpers.export(exports, "TextIncrease", ()=>(0, _textIncreaseDefault.default));
parcelHelpers.export(exports, "TextIncreaseOutlined", ()=>(0, _textIncreaseOutlinedDefault.default));
parcelHelpers.export(exports, "TextIncreaseRounded", ()=>(0, _textIncreaseRoundedDefault.default));
parcelHelpers.export(exports, "TextIncreaseSharp", ()=>(0, _textIncreaseSharpDefault.default));
parcelHelpers.export(exports, "TextIncreaseTwoTone", ()=>(0, _textIncreaseTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotateUp", ()=>(0, _textRotateUpDefault.default));
parcelHelpers.export(exports, "TextRotateUpOutlined", ()=>(0, _textRotateUpOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotateUpRounded", ()=>(0, _textRotateUpRoundedDefault.default));
parcelHelpers.export(exports, "TextRotateUpSharp", ()=>(0, _textRotateUpSharpDefault.default));
parcelHelpers.export(exports, "TextRotateUpTwoTone", ()=>(0, _textRotateUpTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotateVertical", ()=>(0, _textRotateVerticalDefault.default));
parcelHelpers.export(exports, "TextRotateVerticalOutlined", ()=>(0, _textRotateVerticalOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotateVerticalRounded", ()=>(0, _textRotateVerticalRoundedDefault.default));
parcelHelpers.export(exports, "TextRotateVerticalSharp", ()=>(0, _textRotateVerticalSharpDefault.default));
parcelHelpers.export(exports, "TextRotateVerticalTwoTone", ()=>(0, _textRotateVerticalTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotationAngledown", ()=>(0, _textRotationAngledownDefault.default));
parcelHelpers.export(exports, "TextRotationAngledownOutlined", ()=>(0, _textRotationAngledownOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotationAngledownRounded", ()=>(0, _textRotationAngledownRoundedDefault.default));
parcelHelpers.export(exports, "TextRotationAngledownSharp", ()=>(0, _textRotationAngledownSharpDefault.default));
parcelHelpers.export(exports, "TextRotationAngledownTwoTone", ()=>(0, _textRotationAngledownTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotationAngleup", ()=>(0, _textRotationAngleupDefault.default));
parcelHelpers.export(exports, "TextRotationAngleupOutlined", ()=>(0, _textRotationAngleupOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotationAngleupRounded", ()=>(0, _textRotationAngleupRoundedDefault.default));
parcelHelpers.export(exports, "TextRotationAngleupSharp", ()=>(0, _textRotationAngleupSharpDefault.default));
parcelHelpers.export(exports, "TextRotationAngleupTwoTone", ()=>(0, _textRotationAngleupTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotationDown", ()=>(0, _textRotationDownDefault.default));
parcelHelpers.export(exports, "TextRotationDownOutlined", ()=>(0, _textRotationDownOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotationDownRounded", ()=>(0, _textRotationDownRoundedDefault.default));
parcelHelpers.export(exports, "TextRotationDownSharp", ()=>(0, _textRotationDownSharpDefault.default));
parcelHelpers.export(exports, "TextRotationDownTwoTone", ()=>(0, _textRotationDownTwoToneDefault.default));
parcelHelpers.export(exports, "TextRotationNone", ()=>(0, _textRotationNoneDefault.default));
parcelHelpers.export(exports, "TextRotationNoneOutlined", ()=>(0, _textRotationNoneOutlinedDefault.default));
parcelHelpers.export(exports, "TextRotationNoneRounded", ()=>(0, _textRotationNoneRoundedDefault.default));
parcelHelpers.export(exports, "TextRotationNoneSharp", ()=>(0, _textRotationNoneSharpDefault.default));
parcelHelpers.export(exports, "TextRotationNoneTwoTone", ()=>(0, _textRotationNoneTwoToneDefault.default));
parcelHelpers.export(exports, "TextSnippet", ()=>(0, _textSnippetDefault.default));
parcelHelpers.export(exports, "TextSnippetOutlined", ()=>(0, _textSnippetOutlinedDefault.default));
parcelHelpers.export(exports, "TextSnippetRounded", ()=>(0, _textSnippetRoundedDefault.default));
parcelHelpers.export(exports, "TextSnippetSharp", ()=>(0, _textSnippetSharpDefault.default));
parcelHelpers.export(exports, "TextSnippetTwoTone", ()=>(0, _textSnippetTwoToneDefault.default));
parcelHelpers.export(exports, "Textsms", ()=>(0, _textsmsDefault.default));
parcelHelpers.export(exports, "TextsmsOutlined", ()=>(0, _textsmsOutlinedDefault.default));
parcelHelpers.export(exports, "TextsmsRounded", ()=>(0, _textsmsRoundedDefault.default));
parcelHelpers.export(exports, "TextsmsSharp", ()=>(0, _textsmsSharpDefault.default));
parcelHelpers.export(exports, "TextsmsTwoTone", ()=>(0, _textsmsTwoToneDefault.default));
parcelHelpers.export(exports, "Texture", ()=>(0, _textureDefault.default));
parcelHelpers.export(exports, "TextureOutlined", ()=>(0, _textureOutlinedDefault.default));
parcelHelpers.export(exports, "TextureRounded", ()=>(0, _textureRoundedDefault.default));
parcelHelpers.export(exports, "TextureSharp", ()=>(0, _textureSharpDefault.default));
parcelHelpers.export(exports, "TextureTwoTone", ()=>(0, _textureTwoToneDefault.default));
parcelHelpers.export(exports, "TheaterComedy", ()=>(0, _theaterComedyDefault.default));
parcelHelpers.export(exports, "TheaterComedyOutlined", ()=>(0, _theaterComedyOutlinedDefault.default));
parcelHelpers.export(exports, "TheaterComedyRounded", ()=>(0, _theaterComedyRoundedDefault.default));
parcelHelpers.export(exports, "TheaterComedySharp", ()=>(0, _theaterComedySharpDefault.default));
parcelHelpers.export(exports, "TheaterComedyTwoTone", ()=>(0, _theaterComedyTwoToneDefault.default));
parcelHelpers.export(exports, "Theaters", ()=>(0, _theatersDefault.default));
parcelHelpers.export(exports, "TheatersOutlined", ()=>(0, _theatersOutlinedDefault.default));
parcelHelpers.export(exports, "TheatersRounded", ()=>(0, _theatersRoundedDefault.default));
parcelHelpers.export(exports, "TheatersSharp", ()=>(0, _theatersSharpDefault.default));
parcelHelpers.export(exports, "TheatersTwoTone", ()=>(0, _theatersTwoToneDefault.default));
parcelHelpers.export(exports, "Thermostat", ()=>(0, _thermostatDefault.default));
parcelHelpers.export(exports, "ThermostatAuto", ()=>(0, _thermostatAutoDefault.default));
parcelHelpers.export(exports, "ThermostatAutoOutlined", ()=>(0, _thermostatAutoOutlinedDefault.default));
parcelHelpers.export(exports, "ThermostatAutoRounded", ()=>(0, _thermostatAutoRoundedDefault.default));
parcelHelpers.export(exports, "ThermostatAutoSharp", ()=>(0, _thermostatAutoSharpDefault.default));
parcelHelpers.export(exports, "ThermostatAutoTwoTone", ()=>(0, _thermostatAutoTwoToneDefault.default));
parcelHelpers.export(exports, "ThermostatOutlined", ()=>(0, _thermostatOutlinedDefault.default));
parcelHelpers.export(exports, "ThermostatRounded", ()=>(0, _thermostatRoundedDefault.default));
parcelHelpers.export(exports, "ThermostatSharp", ()=>(0, _thermostatSharpDefault.default));
parcelHelpers.export(exports, "ThermostatTwoTone", ()=>(0, _thermostatTwoToneDefault.default));
parcelHelpers.export(exports, "ThirteenMp", ()=>(0, _thirteenMpDefault.default));
parcelHelpers.export(exports, "ThirteenMpOutlined", ()=>(0, _thirteenMpOutlinedDefault.default));
parcelHelpers.export(exports, "ThirteenMpRounded", ()=>(0, _thirteenMpRoundedDefault.default));
parcelHelpers.export(exports, "ThirteenMpSharp", ()=>(0, _thirteenMpSharpDefault.default));
parcelHelpers.export(exports, "ThirteenMpTwoTone", ()=>(0, _thirteenMpTwoToneDefault.default));
parcelHelpers.export(exports, "ThirtyFps", ()=>(0, _thirtyFpsDefault.default));
parcelHelpers.export(exports, "ThirtyFpsOutlined", ()=>(0, _thirtyFpsOutlinedDefault.default));
parcelHelpers.export(exports, "ThirtyFpsRounded", ()=>(0, _thirtyFpsRoundedDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSelect", ()=>(0, _thirtyFpsSelectDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSelectOutlined", ()=>(0, _thirtyFpsSelectOutlinedDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSelectRounded", ()=>(0, _thirtyFpsSelectRoundedDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSelectSharp", ()=>(0, _thirtyFpsSelectSharpDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSelectTwoTone", ()=>(0, _thirtyFpsSelectTwoToneDefault.default));
parcelHelpers.export(exports, "ThirtyFpsSharp", ()=>(0, _thirtyFpsSharpDefault.default));
parcelHelpers.export(exports, "ThirtyFpsTwoTone", ()=>(0, _thirtyFpsTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeDRotation", ()=>(0, _threeDRotationDefault.default));
parcelHelpers.export(exports, "ThreeDRotationOutlined", ()=>(0, _threeDRotationOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeDRotationRounded", ()=>(0, _threeDRotationRoundedDefault.default));
parcelHelpers.export(exports, "ThreeDRotationSharp", ()=>(0, _threeDRotationSharpDefault.default));
parcelHelpers.export(exports, "ThreeDRotationTwoTone", ()=>(0, _threeDRotationTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeGMobiledata", ()=>(0, _threeGMobiledataDefault.default));
parcelHelpers.export(exports, "ThreeGMobiledataOutlined", ()=>(0, _threeGMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeGMobiledataRounded", ()=>(0, _threeGMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "ThreeGMobiledataSharp", ()=>(0, _threeGMobiledataSharpDefault.default));
parcelHelpers.export(exports, "ThreeGMobiledataTwoTone", ()=>(0, _threeGMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeK", ()=>(0, _threeKDefault.default));
parcelHelpers.export(exports, "ThreeKOutlined", ()=>(0, _threeKOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeKPlus", ()=>(0, _threeKPlusDefault.default));
parcelHelpers.export(exports, "ThreeKPlusOutlined", ()=>(0, _threeKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeKPlusRounded", ()=>(0, _threeKPlusRoundedDefault.default));
parcelHelpers.export(exports, "ThreeKPlusSharp", ()=>(0, _threeKPlusSharpDefault.default));
parcelHelpers.export(exports, "ThreeKPlusTwoTone", ()=>(0, _threeKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeKRounded", ()=>(0, _threeKRoundedDefault.default));
parcelHelpers.export(exports, "ThreeKSharp", ()=>(0, _threeKSharpDefault.default));
parcelHelpers.export(exports, "ThreeKTwoTone", ()=>(0, _threeKTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeMp", ()=>(0, _threeMpDefault.default));
parcelHelpers.export(exports, "ThreeMpOutlined", ()=>(0, _threeMpOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeMpRounded", ()=>(0, _threeMpRoundedDefault.default));
parcelHelpers.export(exports, "ThreeMpSharp", ()=>(0, _threeMpSharpDefault.default));
parcelHelpers.export(exports, "ThreeMpTwoTone", ()=>(0, _threeMpTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeP", ()=>(0, _threePDefault.default));
parcelHelpers.export(exports, "ThreePOutlined", ()=>(0, _threePOutlinedDefault.default));
parcelHelpers.export(exports, "ThreePRounded", ()=>(0, _threePRoundedDefault.default));
parcelHelpers.export(exports, "ThreePSharp", ()=>(0, _threePSharpDefault.default));
parcelHelpers.export(exports, "ThreePTwoTone", ()=>(0, _threePTwoToneDefault.default));
parcelHelpers.export(exports, "ThreeSixty", ()=>(0, _threeSixtyDefault.default));
parcelHelpers.export(exports, "ThreeSixtyOutlined", ()=>(0, _threeSixtyOutlinedDefault.default));
parcelHelpers.export(exports, "ThreeSixtyRounded", ()=>(0, _threeSixtyRoundedDefault.default));
parcelHelpers.export(exports, "ThreeSixtySharp", ()=>(0, _threeSixtySharpDefault.default));
parcelHelpers.export(exports, "ThreeSixtyTwoTone", ()=>(0, _threeSixtyTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbDown", ()=>(0, _thumbDownDefault.default));
parcelHelpers.export(exports, "ThumbDownAlt", ()=>(0, _thumbDownAltDefault.default));
parcelHelpers.export(exports, "ThumbDownAltOutlined", ()=>(0, _thumbDownAltOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbDownAltRounded", ()=>(0, _thumbDownAltRoundedDefault.default));
parcelHelpers.export(exports, "ThumbDownAltSharp", ()=>(0, _thumbDownAltSharpDefault.default));
parcelHelpers.export(exports, "ThumbDownAltTwoTone", ()=>(0, _thumbDownAltTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbDownOffAlt", ()=>(0, _thumbDownOffAltDefault.default));
parcelHelpers.export(exports, "ThumbDownOffAltOutlined", ()=>(0, _thumbDownOffAltOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbDownOffAltRounded", ()=>(0, _thumbDownOffAltRoundedDefault.default));
parcelHelpers.export(exports, "ThumbDownOffAltSharp", ()=>(0, _thumbDownOffAltSharpDefault.default));
parcelHelpers.export(exports, "ThumbDownOffAltTwoTone", ()=>(0, _thumbDownOffAltTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbDownOutlined", ()=>(0, _thumbDownOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbDownRounded", ()=>(0, _thumbDownRoundedDefault.default));
parcelHelpers.export(exports, "ThumbDownSharp", ()=>(0, _thumbDownSharpDefault.default));
parcelHelpers.export(exports, "ThumbDownTwoTone", ()=>(0, _thumbDownTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbUp", ()=>(0, _thumbUpDefault.default));
parcelHelpers.export(exports, "ThumbUpAlt", ()=>(0, _thumbUpAltDefault.default));
parcelHelpers.export(exports, "ThumbUpAltOutlined", ()=>(0, _thumbUpAltOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbUpAltRounded", ()=>(0, _thumbUpAltRoundedDefault.default));
parcelHelpers.export(exports, "ThumbUpAltSharp", ()=>(0, _thumbUpAltSharpDefault.default));
parcelHelpers.export(exports, "ThumbUpAltTwoTone", ()=>(0, _thumbUpAltTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbUpOffAlt", ()=>(0, _thumbUpOffAltDefault.default));
parcelHelpers.export(exports, "ThumbUpOffAltOutlined", ()=>(0, _thumbUpOffAltOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbUpOffAltRounded", ()=>(0, _thumbUpOffAltRoundedDefault.default));
parcelHelpers.export(exports, "ThumbUpOffAltSharp", ()=>(0, _thumbUpOffAltSharpDefault.default));
parcelHelpers.export(exports, "ThumbUpOffAltTwoTone", ()=>(0, _thumbUpOffAltTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbUpOutlined", ()=>(0, _thumbUpOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbUpRounded", ()=>(0, _thumbUpRoundedDefault.default));
parcelHelpers.export(exports, "ThumbUpSharp", ()=>(0, _thumbUpSharpDefault.default));
parcelHelpers.export(exports, "ThumbUpTwoTone", ()=>(0, _thumbUpTwoToneDefault.default));
parcelHelpers.export(exports, "ThumbsUpDown", ()=>(0, _thumbsUpDownDefault.default));
parcelHelpers.export(exports, "ThumbsUpDownOutlined", ()=>(0, _thumbsUpDownOutlinedDefault.default));
parcelHelpers.export(exports, "ThumbsUpDownRounded", ()=>(0, _thumbsUpDownRoundedDefault.default));
parcelHelpers.export(exports, "ThumbsUpDownSharp", ()=>(0, _thumbsUpDownSharpDefault.default));
parcelHelpers.export(exports, "ThumbsUpDownTwoTone", ()=>(0, _thumbsUpDownTwoToneDefault.default));
parcelHelpers.export(exports, "Thunderstorm", ()=>(0, _thunderstormDefault.default));
parcelHelpers.export(exports, "ThunderstormOutlined", ()=>(0, _thunderstormOutlinedDefault.default));
parcelHelpers.export(exports, "ThunderstormRounded", ()=>(0, _thunderstormRoundedDefault.default));
parcelHelpers.export(exports, "ThunderstormSharp", ()=>(0, _thunderstormSharpDefault.default));
parcelHelpers.export(exports, "ThunderstormTwoTone", ()=>(0, _thunderstormTwoToneDefault.default));
parcelHelpers.export(exports, "TimeToLeave", ()=>(0, _timeToLeaveDefault.default));
parcelHelpers.export(exports, "TimeToLeaveOutlined", ()=>(0, _timeToLeaveOutlinedDefault.default));
parcelHelpers.export(exports, "TimeToLeaveRounded", ()=>(0, _timeToLeaveRoundedDefault.default));
parcelHelpers.export(exports, "TimeToLeaveSharp", ()=>(0, _timeToLeaveSharpDefault.default));
parcelHelpers.export(exports, "TimeToLeaveTwoTone", ()=>(0, _timeToLeaveTwoToneDefault.default));
parcelHelpers.export(exports, "Timelapse", ()=>(0, _timelapseDefault.default));
parcelHelpers.export(exports, "TimelapseOutlined", ()=>(0, _timelapseOutlinedDefault.default));
parcelHelpers.export(exports, "TimelapseRounded", ()=>(0, _timelapseRoundedDefault.default));
parcelHelpers.export(exports, "TimelapseSharp", ()=>(0, _timelapseSharpDefault.default));
parcelHelpers.export(exports, "TimelapseTwoTone", ()=>(0, _timelapseTwoToneDefault.default));
parcelHelpers.export(exports, "Timeline", ()=>(0, _timelineDefault.default));
parcelHelpers.export(exports, "TimelineOutlined", ()=>(0, _timelineOutlinedDefault.default));
parcelHelpers.export(exports, "TimelineRounded", ()=>(0, _timelineRoundedDefault.default));
parcelHelpers.export(exports, "TimelineSharp", ()=>(0, _timelineSharpDefault.default));
parcelHelpers.export(exports, "TimelineTwoTone", ()=>(0, _timelineTwoToneDefault.default));
parcelHelpers.export(exports, "Timer", ()=>(0, _timerDefault.default));
parcelHelpers.export(exports, "Timer10", ()=>(0, _timer10Default.default));
parcelHelpers.export(exports, "Timer10Outlined", ()=>(0, _timer10OutlinedDefault.default));
parcelHelpers.export(exports, "Timer10Rounded", ()=>(0, _timer10RoundedDefault.default));
parcelHelpers.export(exports, "Timer10Select", ()=>(0, _timer10SelectDefault.default));
parcelHelpers.export(exports, "Timer10SelectOutlined", ()=>(0, _timer10SelectOutlinedDefault.default));
parcelHelpers.export(exports, "Timer10SelectRounded", ()=>(0, _timer10SelectRoundedDefault.default));
parcelHelpers.export(exports, "Timer10SelectSharp", ()=>(0, _timer10SelectSharpDefault.default));
parcelHelpers.export(exports, "Timer10SelectTwoTone", ()=>(0, _timer10SelectTwoToneDefault.default));
parcelHelpers.export(exports, "Timer10Sharp", ()=>(0, _timer10SharpDefault.default));
parcelHelpers.export(exports, "Timer10TwoTone", ()=>(0, _timer10TwoToneDefault.default));
parcelHelpers.export(exports, "Timer3", ()=>(0, _timer3Default.default));
parcelHelpers.export(exports, "Timer3Outlined", ()=>(0, _timer3OutlinedDefault.default));
parcelHelpers.export(exports, "Timer3Rounded", ()=>(0, _timer3RoundedDefault.default));
parcelHelpers.export(exports, "Timer3Select", ()=>(0, _timer3SelectDefault.default));
parcelHelpers.export(exports, "Timer3SelectOutlined", ()=>(0, _timer3SelectOutlinedDefault.default));
parcelHelpers.export(exports, "Timer3SelectRounded", ()=>(0, _timer3SelectRoundedDefault.default));
parcelHelpers.export(exports, "Timer3SelectSharp", ()=>(0, _timer3SelectSharpDefault.default));
parcelHelpers.export(exports, "Timer3SelectTwoTone", ()=>(0, _timer3SelectTwoToneDefault.default));
parcelHelpers.export(exports, "Timer3Sharp", ()=>(0, _timer3SharpDefault.default));
parcelHelpers.export(exports, "Timer3TwoTone", ()=>(0, _timer3TwoToneDefault.default));
parcelHelpers.export(exports, "TimerOff", ()=>(0, _timerOffDefault.default));
parcelHelpers.export(exports, "TimerOffOutlined", ()=>(0, _timerOffOutlinedDefault.default));
parcelHelpers.export(exports, "TimerOffRounded", ()=>(0, _timerOffRoundedDefault.default));
parcelHelpers.export(exports, "TimerOffSharp", ()=>(0, _timerOffSharpDefault.default));
parcelHelpers.export(exports, "TimerOffTwoTone", ()=>(0, _timerOffTwoToneDefault.default));
parcelHelpers.export(exports, "TimerOutlined", ()=>(0, _timerOutlinedDefault.default));
parcelHelpers.export(exports, "TimerRounded", ()=>(0, _timerRoundedDefault.default));
parcelHelpers.export(exports, "TimerSharp", ()=>(0, _timerSharpDefault.default));
parcelHelpers.export(exports, "TimerTwoTone", ()=>(0, _timerTwoToneDefault.default));
parcelHelpers.export(exports, "TimesOneMobiledata", ()=>(0, _timesOneMobiledataDefault.default));
parcelHelpers.export(exports, "TimesOneMobiledataOutlined", ()=>(0, _timesOneMobiledataOutlinedDefault.default));
parcelHelpers.export(exports, "TimesOneMobiledataRounded", ()=>(0, _timesOneMobiledataRoundedDefault.default));
parcelHelpers.export(exports, "TimesOneMobiledataSharp", ()=>(0, _timesOneMobiledataSharpDefault.default));
parcelHelpers.export(exports, "TimesOneMobiledataTwoTone", ()=>(0, _timesOneMobiledataTwoToneDefault.default));
parcelHelpers.export(exports, "TipsAndUpdates", ()=>(0, _tipsAndUpdatesDefault.default));
parcelHelpers.export(exports, "TipsAndUpdatesOutlined", ()=>(0, _tipsAndUpdatesOutlinedDefault.default));
parcelHelpers.export(exports, "TipsAndUpdatesRounded", ()=>(0, _tipsAndUpdatesRoundedDefault.default));
parcelHelpers.export(exports, "TipsAndUpdatesSharp", ()=>(0, _tipsAndUpdatesSharpDefault.default));
parcelHelpers.export(exports, "TipsAndUpdatesTwoTone", ()=>(0, _tipsAndUpdatesTwoToneDefault.default));
parcelHelpers.export(exports, "TireRepair", ()=>(0, _tireRepairDefault.default));
parcelHelpers.export(exports, "TireRepairOutlined", ()=>(0, _tireRepairOutlinedDefault.default));
parcelHelpers.export(exports, "TireRepairRounded", ()=>(0, _tireRepairRoundedDefault.default));
parcelHelpers.export(exports, "TireRepairSharp", ()=>(0, _tireRepairSharpDefault.default));
parcelHelpers.export(exports, "TireRepairTwoTone", ()=>(0, _tireRepairTwoToneDefault.default));
parcelHelpers.export(exports, "Title", ()=>(0, _titleDefault.default));
parcelHelpers.export(exports, "TitleOutlined", ()=>(0, _titleOutlinedDefault.default));
parcelHelpers.export(exports, "TitleRounded", ()=>(0, _titleRoundedDefault.default));
parcelHelpers.export(exports, "TitleSharp", ()=>(0, _titleSharpDefault.default));
parcelHelpers.export(exports, "TitleTwoTone", ()=>(0, _titleTwoToneDefault.default));
parcelHelpers.export(exports, "Toc", ()=>(0, _tocDefault.default));
parcelHelpers.export(exports, "TocOutlined", ()=>(0, _tocOutlinedDefault.default));
parcelHelpers.export(exports, "TocRounded", ()=>(0, _tocRoundedDefault.default));
parcelHelpers.export(exports, "TocSharp", ()=>(0, _tocSharpDefault.default));
parcelHelpers.export(exports, "TocTwoTone", ()=>(0, _tocTwoToneDefault.default));
parcelHelpers.export(exports, "Today", ()=>(0, _todayDefault.default));
parcelHelpers.export(exports, "TodayOutlined", ()=>(0, _todayOutlinedDefault.default));
parcelHelpers.export(exports, "TodayRounded", ()=>(0, _todayRoundedDefault.default));
parcelHelpers.export(exports, "TodaySharp", ()=>(0, _todaySharpDefault.default));
parcelHelpers.export(exports, "TodayTwoTone", ()=>(0, _todayTwoToneDefault.default));
parcelHelpers.export(exports, "ToggleOff", ()=>(0, _toggleOffDefault.default));
parcelHelpers.export(exports, "ToggleOffOutlined", ()=>(0, _toggleOffOutlinedDefault.default));
parcelHelpers.export(exports, "ToggleOffRounded", ()=>(0, _toggleOffRoundedDefault.default));
parcelHelpers.export(exports, "ToggleOffSharp", ()=>(0, _toggleOffSharpDefault.default));
parcelHelpers.export(exports, "ToggleOffTwoTone", ()=>(0, _toggleOffTwoToneDefault.default));
parcelHelpers.export(exports, "ToggleOn", ()=>(0, _toggleOnDefault.default));
parcelHelpers.export(exports, "ToggleOnOutlined", ()=>(0, _toggleOnOutlinedDefault.default));
parcelHelpers.export(exports, "ToggleOnRounded", ()=>(0, _toggleOnRoundedDefault.default));
parcelHelpers.export(exports, "ToggleOnSharp", ()=>(0, _toggleOnSharpDefault.default));
parcelHelpers.export(exports, "ToggleOnTwoTone", ()=>(0, _toggleOnTwoToneDefault.default));
parcelHelpers.export(exports, "Token", ()=>(0, _tokenDefault.default));
parcelHelpers.export(exports, "TokenOutlined", ()=>(0, _tokenOutlinedDefault.default));
parcelHelpers.export(exports, "TokenRounded", ()=>(0, _tokenRoundedDefault.default));
parcelHelpers.export(exports, "TokenSharp", ()=>(0, _tokenSharpDefault.default));
parcelHelpers.export(exports, "TokenTwoTone", ()=>(0, _tokenTwoToneDefault.default));
parcelHelpers.export(exports, "Toll", ()=>(0, _tollDefault.default));
parcelHelpers.export(exports, "TollOutlined", ()=>(0, _tollOutlinedDefault.default));
parcelHelpers.export(exports, "TollRounded", ()=>(0, _tollRoundedDefault.default));
parcelHelpers.export(exports, "TollSharp", ()=>(0, _tollSharpDefault.default));
parcelHelpers.export(exports, "TollTwoTone", ()=>(0, _tollTwoToneDefault.default));
parcelHelpers.export(exports, "Tonality", ()=>(0, _tonalityDefault.default));
parcelHelpers.export(exports, "TonalityOutlined", ()=>(0, _tonalityOutlinedDefault.default));
parcelHelpers.export(exports, "TonalityRounded", ()=>(0, _tonalityRoundedDefault.default));
parcelHelpers.export(exports, "TonalitySharp", ()=>(0, _tonalitySharpDefault.default));
parcelHelpers.export(exports, "TonalityTwoTone", ()=>(0, _tonalityTwoToneDefault.default));
parcelHelpers.export(exports, "Topic", ()=>(0, _topicDefault.default));
parcelHelpers.export(exports, "TopicOutlined", ()=>(0, _topicOutlinedDefault.default));
parcelHelpers.export(exports, "TopicRounded", ()=>(0, _topicRoundedDefault.default));
parcelHelpers.export(exports, "TopicSharp", ()=>(0, _topicSharpDefault.default));
parcelHelpers.export(exports, "TopicTwoTone", ()=>(0, _topicTwoToneDefault.default));
parcelHelpers.export(exports, "Tornado", ()=>(0, _tornadoDefault.default));
parcelHelpers.export(exports, "TornadoOutlined", ()=>(0, _tornadoOutlinedDefault.default));
parcelHelpers.export(exports, "TornadoRounded", ()=>(0, _tornadoRoundedDefault.default));
parcelHelpers.export(exports, "TornadoSharp", ()=>(0, _tornadoSharpDefault.default));
parcelHelpers.export(exports, "TornadoTwoTone", ()=>(0, _tornadoTwoToneDefault.default));
parcelHelpers.export(exports, "TouchApp", ()=>(0, _touchAppDefault.default));
parcelHelpers.export(exports, "TouchAppOutlined", ()=>(0, _touchAppOutlinedDefault.default));
parcelHelpers.export(exports, "TouchAppRounded", ()=>(0, _touchAppRoundedDefault.default));
parcelHelpers.export(exports, "TouchAppSharp", ()=>(0, _touchAppSharpDefault.default));
parcelHelpers.export(exports, "TouchAppTwoTone", ()=>(0, _touchAppTwoToneDefault.default));
parcelHelpers.export(exports, "Tour", ()=>(0, _tourDefault.default));
parcelHelpers.export(exports, "TourOutlined", ()=>(0, _tourOutlinedDefault.default));
parcelHelpers.export(exports, "TourRounded", ()=>(0, _tourRoundedDefault.default));
parcelHelpers.export(exports, "TourSharp", ()=>(0, _tourSharpDefault.default));
parcelHelpers.export(exports, "TourTwoTone", ()=>(0, _tourTwoToneDefault.default));
parcelHelpers.export(exports, "Toys", ()=>(0, _toysDefault.default));
parcelHelpers.export(exports, "ToysOutlined", ()=>(0, _toysOutlinedDefault.default));
parcelHelpers.export(exports, "ToysRounded", ()=>(0, _toysRoundedDefault.default));
parcelHelpers.export(exports, "ToysSharp", ()=>(0, _toysSharpDefault.default));
parcelHelpers.export(exports, "ToysTwoTone", ()=>(0, _toysTwoToneDefault.default));
parcelHelpers.export(exports, "TrackChanges", ()=>(0, _trackChangesDefault.default));
parcelHelpers.export(exports, "TrackChangesOutlined", ()=>(0, _trackChangesOutlinedDefault.default));
parcelHelpers.export(exports, "TrackChangesRounded", ()=>(0, _trackChangesRoundedDefault.default));
parcelHelpers.export(exports, "TrackChangesSharp", ()=>(0, _trackChangesSharpDefault.default));
parcelHelpers.export(exports, "TrackChangesTwoTone", ()=>(0, _trackChangesTwoToneDefault.default));
parcelHelpers.export(exports, "Traffic", ()=>(0, _trafficDefault.default));
parcelHelpers.export(exports, "TrafficOutlined", ()=>(0, _trafficOutlinedDefault.default));
parcelHelpers.export(exports, "TrafficRounded", ()=>(0, _trafficRoundedDefault.default));
parcelHelpers.export(exports, "TrafficSharp", ()=>(0, _trafficSharpDefault.default));
parcelHelpers.export(exports, "TrafficTwoTone", ()=>(0, _trafficTwoToneDefault.default));
parcelHelpers.export(exports, "Train", ()=>(0, _trainDefault.default));
parcelHelpers.export(exports, "TrainOutlined", ()=>(0, _trainOutlinedDefault.default));
parcelHelpers.export(exports, "TrainRounded", ()=>(0, _trainRoundedDefault.default));
parcelHelpers.export(exports, "TrainSharp", ()=>(0, _trainSharpDefault.default));
parcelHelpers.export(exports, "TrainTwoTone", ()=>(0, _trainTwoToneDefault.default));
parcelHelpers.export(exports, "Tram", ()=>(0, _tramDefault.default));
parcelHelpers.export(exports, "TramOutlined", ()=>(0, _tramOutlinedDefault.default));
parcelHelpers.export(exports, "TramRounded", ()=>(0, _tramRoundedDefault.default));
parcelHelpers.export(exports, "TramSharp", ()=>(0, _tramSharpDefault.default));
parcelHelpers.export(exports, "TramTwoTone", ()=>(0, _tramTwoToneDefault.default));
parcelHelpers.export(exports, "Transcribe", ()=>(0, _transcribeDefault.default));
parcelHelpers.export(exports, "TranscribeOutlined", ()=>(0, _transcribeOutlinedDefault.default));
parcelHelpers.export(exports, "TranscribeRounded", ()=>(0, _transcribeRoundedDefault.default));
parcelHelpers.export(exports, "TranscribeSharp", ()=>(0, _transcribeSharpDefault.default));
parcelHelpers.export(exports, "TranscribeTwoTone", ()=>(0, _transcribeTwoToneDefault.default));
parcelHelpers.export(exports, "TransferWithinAStation", ()=>(0, _transferWithinAStationDefault.default));
parcelHelpers.export(exports, "TransferWithinAStationOutlined", ()=>(0, _transferWithinAStationOutlinedDefault.default));
parcelHelpers.export(exports, "TransferWithinAStationRounded", ()=>(0, _transferWithinAStationRoundedDefault.default));
parcelHelpers.export(exports, "TransferWithinAStationSharp", ()=>(0, _transferWithinAStationSharpDefault.default));
parcelHelpers.export(exports, "TransferWithinAStationTwoTone", ()=>(0, _transferWithinAStationTwoToneDefault.default));
parcelHelpers.export(exports, "Transform", ()=>(0, _transformDefault.default));
parcelHelpers.export(exports, "TransformOutlined", ()=>(0, _transformOutlinedDefault.default));
parcelHelpers.export(exports, "TransformRounded", ()=>(0, _transformRoundedDefault.default));
parcelHelpers.export(exports, "TransformSharp", ()=>(0, _transformSharpDefault.default));
parcelHelpers.export(exports, "TransformTwoTone", ()=>(0, _transformTwoToneDefault.default));
parcelHelpers.export(exports, "Transgender", ()=>(0, _transgenderDefault.default));
parcelHelpers.export(exports, "TransgenderOutlined", ()=>(0, _transgenderOutlinedDefault.default));
parcelHelpers.export(exports, "TransgenderRounded", ()=>(0, _transgenderRoundedDefault.default));
parcelHelpers.export(exports, "TransgenderSharp", ()=>(0, _transgenderSharpDefault.default));
parcelHelpers.export(exports, "TransgenderTwoTone", ()=>(0, _transgenderTwoToneDefault.default));
parcelHelpers.export(exports, "TransitEnterexit", ()=>(0, _transitEnterexitDefault.default));
parcelHelpers.export(exports, "TransitEnterexitOutlined", ()=>(0, _transitEnterexitOutlinedDefault.default));
parcelHelpers.export(exports, "TransitEnterexitRounded", ()=>(0, _transitEnterexitRoundedDefault.default));
parcelHelpers.export(exports, "TransitEnterexitSharp", ()=>(0, _transitEnterexitSharpDefault.default));
parcelHelpers.export(exports, "TransitEnterexitTwoTone", ()=>(0, _transitEnterexitTwoToneDefault.default));
parcelHelpers.export(exports, "Translate", ()=>(0, _translateDefault.default));
parcelHelpers.export(exports, "TranslateOutlined", ()=>(0, _translateOutlinedDefault.default));
parcelHelpers.export(exports, "TranslateRounded", ()=>(0, _translateRoundedDefault.default));
parcelHelpers.export(exports, "TranslateSharp", ()=>(0, _translateSharpDefault.default));
parcelHelpers.export(exports, "TranslateTwoTone", ()=>(0, _translateTwoToneDefault.default));
parcelHelpers.export(exports, "TravelExplore", ()=>(0, _travelExploreDefault.default));
parcelHelpers.export(exports, "TravelExploreOutlined", ()=>(0, _travelExploreOutlinedDefault.default));
parcelHelpers.export(exports, "TravelExploreRounded", ()=>(0, _travelExploreRoundedDefault.default));
parcelHelpers.export(exports, "TravelExploreSharp", ()=>(0, _travelExploreSharpDefault.default));
parcelHelpers.export(exports, "TravelExploreTwoTone", ()=>(0, _travelExploreTwoToneDefault.default));
parcelHelpers.export(exports, "TrendingDown", ()=>(0, _trendingDownDefault.default));
parcelHelpers.export(exports, "TrendingDownOutlined", ()=>(0, _trendingDownOutlinedDefault.default));
parcelHelpers.export(exports, "TrendingDownRounded", ()=>(0, _trendingDownRoundedDefault.default));
parcelHelpers.export(exports, "TrendingDownSharp", ()=>(0, _trendingDownSharpDefault.default));
parcelHelpers.export(exports, "TrendingDownTwoTone", ()=>(0, _trendingDownTwoToneDefault.default));
parcelHelpers.export(exports, "TrendingFlat", ()=>(0, _trendingFlatDefault.default));
parcelHelpers.export(exports, "TrendingFlatOutlined", ()=>(0, _trendingFlatOutlinedDefault.default));
parcelHelpers.export(exports, "TrendingFlatRounded", ()=>(0, _trendingFlatRoundedDefault.default));
parcelHelpers.export(exports, "TrendingFlatSharp", ()=>(0, _trendingFlatSharpDefault.default));
parcelHelpers.export(exports, "TrendingFlatTwoTone", ()=>(0, _trendingFlatTwoToneDefault.default));
parcelHelpers.export(exports, "TrendingUp", ()=>(0, _trendingUpDefault.default));
parcelHelpers.export(exports, "TrendingUpOutlined", ()=>(0, _trendingUpOutlinedDefault.default));
parcelHelpers.export(exports, "TrendingUpRounded", ()=>(0, _trendingUpRoundedDefault.default));
parcelHelpers.export(exports, "TrendingUpSharp", ()=>(0, _trendingUpSharpDefault.default));
parcelHelpers.export(exports, "TrendingUpTwoTone", ()=>(0, _trendingUpTwoToneDefault.default));
parcelHelpers.export(exports, "TripOrigin", ()=>(0, _tripOriginDefault.default));
parcelHelpers.export(exports, "TripOriginOutlined", ()=>(0, _tripOriginOutlinedDefault.default));
parcelHelpers.export(exports, "TripOriginRounded", ()=>(0, _tripOriginRoundedDefault.default));
parcelHelpers.export(exports, "TripOriginSharp", ()=>(0, _tripOriginSharpDefault.default));
parcelHelpers.export(exports, "TripOriginTwoTone", ()=>(0, _tripOriginTwoToneDefault.default));
parcelHelpers.export(exports, "Troubleshoot", ()=>(0, _troubleshootDefault.default));
parcelHelpers.export(exports, "TroubleshootOutlined", ()=>(0, _troubleshootOutlinedDefault.default));
parcelHelpers.export(exports, "TroubleshootRounded", ()=>(0, _troubleshootRoundedDefault.default));
parcelHelpers.export(exports, "TroubleshootSharp", ()=>(0, _troubleshootSharpDefault.default));
parcelHelpers.export(exports, "TroubleshootTwoTone", ()=>(0, _troubleshootTwoToneDefault.default));
parcelHelpers.export(exports, "Try", ()=>(0, _tryDefault.default));
parcelHelpers.export(exports, "TryOutlined", ()=>(0, _tryOutlinedDefault.default));
parcelHelpers.export(exports, "TryRounded", ()=>(0, _tryRoundedDefault.default));
parcelHelpers.export(exports, "TrySharp", ()=>(0, _trySharpDefault.default));
parcelHelpers.export(exports, "TryTwoTone", ()=>(0, _tryTwoToneDefault.default));
parcelHelpers.export(exports, "Tsunami", ()=>(0, _tsunamiDefault.default));
parcelHelpers.export(exports, "TsunamiOutlined", ()=>(0, _tsunamiOutlinedDefault.default));
parcelHelpers.export(exports, "TsunamiRounded", ()=>(0, _tsunamiRoundedDefault.default));
parcelHelpers.export(exports, "TsunamiSharp", ()=>(0, _tsunamiSharpDefault.default));
parcelHelpers.export(exports, "TsunamiTwoTone", ()=>(0, _tsunamiTwoToneDefault.default));
parcelHelpers.export(exports, "Tty", ()=>(0, _ttyDefault.default));
parcelHelpers.export(exports, "TtyOutlined", ()=>(0, _ttyOutlinedDefault.default));
parcelHelpers.export(exports, "TtyRounded", ()=>(0, _ttyRoundedDefault.default));
parcelHelpers.export(exports, "TtySharp", ()=>(0, _ttySharpDefault.default));
parcelHelpers.export(exports, "TtyTwoTone", ()=>(0, _ttyTwoToneDefault.default));
parcelHelpers.export(exports, "Tune", ()=>(0, _tuneDefault.default));
parcelHelpers.export(exports, "TuneOutlined", ()=>(0, _tuneOutlinedDefault.default));
parcelHelpers.export(exports, "TuneRounded", ()=>(0, _tuneRoundedDefault.default));
parcelHelpers.export(exports, "TuneSharp", ()=>(0, _tuneSharpDefault.default));
parcelHelpers.export(exports, "TuneTwoTone", ()=>(0, _tuneTwoToneDefault.default));
parcelHelpers.export(exports, "Tungsten", ()=>(0, _tungstenDefault.default));
parcelHelpers.export(exports, "TungstenOutlined", ()=>(0, _tungstenOutlinedDefault.default));
parcelHelpers.export(exports, "TungstenRounded", ()=>(0, _tungstenRoundedDefault.default));
parcelHelpers.export(exports, "TungstenSharp", ()=>(0, _tungstenSharpDefault.default));
parcelHelpers.export(exports, "TungstenTwoTone", ()=>(0, _tungstenTwoToneDefault.default));
parcelHelpers.export(exports, "TurnLeft", ()=>(0, _turnLeftDefault.default));
parcelHelpers.export(exports, "TurnLeftOutlined", ()=>(0, _turnLeftOutlinedDefault.default));
parcelHelpers.export(exports, "TurnLeftRounded", ()=>(0, _turnLeftRoundedDefault.default));
parcelHelpers.export(exports, "TurnLeftSharp", ()=>(0, _turnLeftSharpDefault.default));
parcelHelpers.export(exports, "TurnLeftTwoTone", ()=>(0, _turnLeftTwoToneDefault.default));
parcelHelpers.export(exports, "TurnRight", ()=>(0, _turnRightDefault.default));
parcelHelpers.export(exports, "TurnRightOutlined", ()=>(0, _turnRightOutlinedDefault.default));
parcelHelpers.export(exports, "TurnRightRounded", ()=>(0, _turnRightRoundedDefault.default));
parcelHelpers.export(exports, "TurnRightSharp", ()=>(0, _turnRightSharpDefault.default));
parcelHelpers.export(exports, "TurnRightTwoTone", ()=>(0, _turnRightTwoToneDefault.default));
parcelHelpers.export(exports, "TurnSharpLeft", ()=>(0, _turnSharpLeftDefault.default));
parcelHelpers.export(exports, "TurnSharpLeftOutlined", ()=>(0, _turnSharpLeftOutlinedDefault.default));
parcelHelpers.export(exports, "TurnSharpLeftRounded", ()=>(0, _turnSharpLeftRoundedDefault.default));
parcelHelpers.export(exports, "TurnSharpLeftSharp", ()=>(0, _turnSharpLeftSharpDefault.default));
parcelHelpers.export(exports, "TurnSharpLeftTwoTone", ()=>(0, _turnSharpLeftTwoToneDefault.default));
parcelHelpers.export(exports, "TurnSharpRight", ()=>(0, _turnSharpRightDefault.default));
parcelHelpers.export(exports, "TurnSharpRightOutlined", ()=>(0, _turnSharpRightOutlinedDefault.default));
parcelHelpers.export(exports, "TurnSharpRightRounded", ()=>(0, _turnSharpRightRoundedDefault.default));
parcelHelpers.export(exports, "TurnSharpRightSharp", ()=>(0, _turnSharpRightSharpDefault.default));
parcelHelpers.export(exports, "TurnSharpRightTwoTone", ()=>(0, _turnSharpRightTwoToneDefault.default));
parcelHelpers.export(exports, "TurnSlightLeft", ()=>(0, _turnSlightLeftDefault.default));
parcelHelpers.export(exports, "TurnSlightLeftOutlined", ()=>(0, _turnSlightLeftOutlinedDefault.default));
parcelHelpers.export(exports, "TurnSlightLeftRounded", ()=>(0, _turnSlightLeftRoundedDefault.default));
parcelHelpers.export(exports, "TurnSlightLeftSharp", ()=>(0, _turnSlightLeftSharpDefault.default));
parcelHelpers.export(exports, "TurnSlightLeftTwoTone", ()=>(0, _turnSlightLeftTwoToneDefault.default));
parcelHelpers.export(exports, "TurnSlightRight", ()=>(0, _turnSlightRightDefault.default));
parcelHelpers.export(exports, "TurnSlightRightOutlined", ()=>(0, _turnSlightRightOutlinedDefault.default));
parcelHelpers.export(exports, "TurnSlightRightRounded", ()=>(0, _turnSlightRightRoundedDefault.default));
parcelHelpers.export(exports, "TurnSlightRightSharp", ()=>(0, _turnSlightRightSharpDefault.default));
parcelHelpers.export(exports, "TurnSlightRightTwoTone", ()=>(0, _turnSlightRightTwoToneDefault.default));
parcelHelpers.export(exports, "TurnedIn", ()=>(0, _turnedInDefault.default));
parcelHelpers.export(exports, "TurnedInNot", ()=>(0, _turnedInNotDefault.default));
parcelHelpers.export(exports, "TurnedInNotOutlined", ()=>(0, _turnedInNotOutlinedDefault.default));
parcelHelpers.export(exports, "TurnedInNotRounded", ()=>(0, _turnedInNotRoundedDefault.default));
parcelHelpers.export(exports, "TurnedInNotSharp", ()=>(0, _turnedInNotSharpDefault.default));
parcelHelpers.export(exports, "TurnedInNotTwoTone", ()=>(0, _turnedInNotTwoToneDefault.default));
parcelHelpers.export(exports, "TurnedInOutlined", ()=>(0, _turnedInOutlinedDefault.default));
parcelHelpers.export(exports, "TurnedInRounded", ()=>(0, _turnedInRoundedDefault.default));
parcelHelpers.export(exports, "TurnedInSharp", ()=>(0, _turnedInSharpDefault.default));
parcelHelpers.export(exports, "TurnedInTwoTone", ()=>(0, _turnedInTwoToneDefault.default));
parcelHelpers.export(exports, "Tv", ()=>(0, _tvDefault.default));
parcelHelpers.export(exports, "TvOff", ()=>(0, _tvOffDefault.default));
parcelHelpers.export(exports, "TvOffOutlined", ()=>(0, _tvOffOutlinedDefault.default));
parcelHelpers.export(exports, "TvOffRounded", ()=>(0, _tvOffRoundedDefault.default));
parcelHelpers.export(exports, "TvOffSharp", ()=>(0, _tvOffSharpDefault.default));
parcelHelpers.export(exports, "TvOffTwoTone", ()=>(0, _tvOffTwoToneDefault.default));
parcelHelpers.export(exports, "TvOutlined", ()=>(0, _tvOutlinedDefault.default));
parcelHelpers.export(exports, "TvRounded", ()=>(0, _tvRoundedDefault.default));
parcelHelpers.export(exports, "TvSharp", ()=>(0, _tvSharpDefault.default));
parcelHelpers.export(exports, "TvTwoTone", ()=>(0, _tvTwoToneDefault.default));
parcelHelpers.export(exports, "TwelveMp", ()=>(0, _twelveMpDefault.default));
parcelHelpers.export(exports, "TwelveMpOutlined", ()=>(0, _twelveMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwelveMpRounded", ()=>(0, _twelveMpRoundedDefault.default));
parcelHelpers.export(exports, "TwelveMpSharp", ()=>(0, _twelveMpSharpDefault.default));
parcelHelpers.export(exports, "TwelveMpTwoTone", ()=>(0, _twelveMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwentyFourMp", ()=>(0, _twentyFourMpDefault.default));
parcelHelpers.export(exports, "TwentyFourMpOutlined", ()=>(0, _twentyFourMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwentyFourMpRounded", ()=>(0, _twentyFourMpRoundedDefault.default));
parcelHelpers.export(exports, "TwentyFourMpSharp", ()=>(0, _twentyFourMpSharpDefault.default));
parcelHelpers.export(exports, "TwentyFourMpTwoTone", ()=>(0, _twentyFourMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwentyOneMp", ()=>(0, _twentyOneMpDefault.default));
parcelHelpers.export(exports, "TwentyOneMpOutlined", ()=>(0, _twentyOneMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwentyOneMpRounded", ()=>(0, _twentyOneMpRoundedDefault.default));
parcelHelpers.export(exports, "TwentyOneMpSharp", ()=>(0, _twentyOneMpSharpDefault.default));
parcelHelpers.export(exports, "TwentyOneMpTwoTone", ()=>(0, _twentyOneMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwentyThreeMp", ()=>(0, _twentyThreeMpDefault.default));
parcelHelpers.export(exports, "TwentyThreeMpOutlined", ()=>(0, _twentyThreeMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwentyThreeMpRounded", ()=>(0, _twentyThreeMpRoundedDefault.default));
parcelHelpers.export(exports, "TwentyThreeMpSharp", ()=>(0, _twentyThreeMpSharpDefault.default));
parcelHelpers.export(exports, "TwentyThreeMpTwoTone", ()=>(0, _twentyThreeMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwentyTwoMp", ()=>(0, _twentyTwoMpDefault.default));
parcelHelpers.export(exports, "TwentyTwoMpOutlined", ()=>(0, _twentyTwoMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwentyTwoMpRounded", ()=>(0, _twentyTwoMpRoundedDefault.default));
parcelHelpers.export(exports, "TwentyTwoMpSharp", ()=>(0, _twentyTwoMpSharpDefault.default));
parcelHelpers.export(exports, "TwentyTwoMpTwoTone", ()=>(0, _twentyTwoMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwentyZeroMp", ()=>(0, _twentyZeroMpDefault.default));
parcelHelpers.export(exports, "TwentyZeroMpOutlined", ()=>(0, _twentyZeroMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwentyZeroMpRounded", ()=>(0, _twentyZeroMpRoundedDefault.default));
parcelHelpers.export(exports, "TwentyZeroMpSharp", ()=>(0, _twentyZeroMpSharpDefault.default));
parcelHelpers.export(exports, "TwentyZeroMpTwoTone", ()=>(0, _twentyZeroMpTwoToneDefault.default));
parcelHelpers.export(exports, "Twitter", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "TwoK", ()=>(0, _twoKDefault.default));
parcelHelpers.export(exports, "TwoKOutlined", ()=>(0, _twoKOutlinedDefault.default));
parcelHelpers.export(exports, "TwoKPlus", ()=>(0, _twoKPlusDefault.default));
parcelHelpers.export(exports, "TwoKPlusOutlined", ()=>(0, _twoKPlusOutlinedDefault.default));
parcelHelpers.export(exports, "TwoKPlusRounded", ()=>(0, _twoKPlusRoundedDefault.default));
parcelHelpers.export(exports, "TwoKPlusSharp", ()=>(0, _twoKPlusSharpDefault.default));
parcelHelpers.export(exports, "TwoKPlusTwoTone", ()=>(0, _twoKPlusTwoToneDefault.default));
parcelHelpers.export(exports, "TwoKRounded", ()=>(0, _twoKRoundedDefault.default));
parcelHelpers.export(exports, "TwoKSharp", ()=>(0, _twoKSharpDefault.default));
parcelHelpers.export(exports, "TwoKTwoTone", ()=>(0, _twoKTwoToneDefault.default));
parcelHelpers.export(exports, "TwoMp", ()=>(0, _twoMpDefault.default));
parcelHelpers.export(exports, "TwoMpOutlined", ()=>(0, _twoMpOutlinedDefault.default));
parcelHelpers.export(exports, "TwoMpRounded", ()=>(0, _twoMpRoundedDefault.default));
parcelHelpers.export(exports, "TwoMpSharp", ()=>(0, _twoMpSharpDefault.default));
parcelHelpers.export(exports, "TwoMpTwoTone", ()=>(0, _twoMpTwoToneDefault.default));
parcelHelpers.export(exports, "TwoWheeler", ()=>(0, _twoWheelerDefault.default));
parcelHelpers.export(exports, "TwoWheelerOutlined", ()=>(0, _twoWheelerOutlinedDefault.default));
parcelHelpers.export(exports, "TwoWheelerRounded", ()=>(0, _twoWheelerRoundedDefault.default));
parcelHelpers.export(exports, "TwoWheelerSharp", ()=>(0, _twoWheelerSharpDefault.default));
parcelHelpers.export(exports, "TwoWheelerTwoTone", ()=>(0, _twoWheelerTwoToneDefault.default));
parcelHelpers.export(exports, "TypeSpecimen", ()=>(0, _typeSpecimenDefault.default));
parcelHelpers.export(exports, "TypeSpecimenOutlined", ()=>(0, _typeSpecimenOutlinedDefault.default));
parcelHelpers.export(exports, "TypeSpecimenRounded", ()=>(0, _typeSpecimenRoundedDefault.default));
parcelHelpers.export(exports, "TypeSpecimenSharp", ()=>(0, _typeSpecimenSharpDefault.default));
parcelHelpers.export(exports, "TypeSpecimenTwoTone", ()=>(0, _typeSpecimenTwoToneDefault.default));
parcelHelpers.export(exports, "UTurnLeft", ()=>(0, _uturnLeftDefault.default));
parcelHelpers.export(exports, "UTurnLeftOutlined", ()=>(0, _uturnLeftOutlinedDefault.default));
parcelHelpers.export(exports, "UTurnLeftRounded", ()=>(0, _uturnLeftRoundedDefault.default));
parcelHelpers.export(exports, "UTurnLeftSharp", ()=>(0, _uturnLeftSharpDefault.default));
parcelHelpers.export(exports, "UTurnLeftTwoTone", ()=>(0, _uturnLeftTwoToneDefault.default));
parcelHelpers.export(exports, "UTurnRight", ()=>(0, _uturnRightDefault.default));
parcelHelpers.export(exports, "UTurnRightOutlined", ()=>(0, _uturnRightOutlinedDefault.default));
parcelHelpers.export(exports, "UTurnRightRounded", ()=>(0, _uturnRightRoundedDefault.default));
parcelHelpers.export(exports, "UTurnRightSharp", ()=>(0, _uturnRightSharpDefault.default));
parcelHelpers.export(exports, "UTurnRightTwoTone", ()=>(0, _uturnRightTwoToneDefault.default));
parcelHelpers.export(exports, "Umbrella", ()=>(0, _umbrellaDefault.default));
parcelHelpers.export(exports, "UmbrellaOutlined", ()=>(0, _umbrellaOutlinedDefault.default));
parcelHelpers.export(exports, "UmbrellaRounded", ()=>(0, _umbrellaRoundedDefault.default));
parcelHelpers.export(exports, "UmbrellaSharp", ()=>(0, _umbrellaSharpDefault.default));
parcelHelpers.export(exports, "UmbrellaTwoTone", ()=>(0, _umbrellaTwoToneDefault.default));
parcelHelpers.export(exports, "Unarchive", ()=>(0, _unarchiveDefault.default));
parcelHelpers.export(exports, "UnarchiveOutlined", ()=>(0, _unarchiveOutlinedDefault.default));
parcelHelpers.export(exports, "UnarchiveRounded", ()=>(0, _unarchiveRoundedDefault.default));
parcelHelpers.export(exports, "UnarchiveSharp", ()=>(0, _unarchiveSharpDefault.default));
parcelHelpers.export(exports, "UnarchiveTwoTone", ()=>(0, _unarchiveTwoToneDefault.default));
parcelHelpers.export(exports, "Undo", ()=>(0, _undoDefault.default));
parcelHelpers.export(exports, "UndoOutlined", ()=>(0, _undoOutlinedDefault.default));
parcelHelpers.export(exports, "UndoRounded", ()=>(0, _undoRoundedDefault.default));
parcelHelpers.export(exports, "UndoSharp", ()=>(0, _undoSharpDefault.default));
parcelHelpers.export(exports, "UndoTwoTone", ()=>(0, _undoTwoToneDefault.default));
parcelHelpers.export(exports, "UnfoldLess", ()=>(0, _unfoldLessDefault.default));
parcelHelpers.export(exports, "UnfoldLessDouble", ()=>(0, _unfoldLessDoubleDefault.default));
parcelHelpers.export(exports, "UnfoldLessDoubleOutlined", ()=>(0, _unfoldLessDoubleOutlinedDefault.default));
parcelHelpers.export(exports, "UnfoldLessDoubleRounded", ()=>(0, _unfoldLessDoubleRoundedDefault.default));
parcelHelpers.export(exports, "UnfoldLessDoubleSharp", ()=>(0, _unfoldLessDoubleSharpDefault.default));
parcelHelpers.export(exports, "UnfoldLessDoubleTwoTone", ()=>(0, _unfoldLessDoubleTwoToneDefault.default));
parcelHelpers.export(exports, "UnfoldLessOutlined", ()=>(0, _unfoldLessOutlinedDefault.default));
parcelHelpers.export(exports, "UnfoldLessRounded", ()=>(0, _unfoldLessRoundedDefault.default));
parcelHelpers.export(exports, "UnfoldLessSharp", ()=>(0, _unfoldLessSharpDefault.default));
parcelHelpers.export(exports, "UnfoldLessTwoTone", ()=>(0, _unfoldLessTwoToneDefault.default));
parcelHelpers.export(exports, "UnfoldMore", ()=>(0, _unfoldMoreDefault.default));
parcelHelpers.export(exports, "UnfoldMoreDouble", ()=>(0, _unfoldMoreDoubleDefault.default));
parcelHelpers.export(exports, "UnfoldMoreDoubleOutlined", ()=>(0, _unfoldMoreDoubleOutlinedDefault.default));
parcelHelpers.export(exports, "UnfoldMoreDoubleRounded", ()=>(0, _unfoldMoreDoubleRoundedDefault.default));
parcelHelpers.export(exports, "UnfoldMoreDoubleSharp", ()=>(0, _unfoldMoreDoubleSharpDefault.default));
parcelHelpers.export(exports, "UnfoldMoreDoubleTwoTone", ()=>(0, _unfoldMoreDoubleTwoToneDefault.default));
parcelHelpers.export(exports, "UnfoldMoreOutlined", ()=>(0, _unfoldMoreOutlinedDefault.default));
parcelHelpers.export(exports, "UnfoldMoreRounded", ()=>(0, _unfoldMoreRoundedDefault.default));
parcelHelpers.export(exports, "UnfoldMoreSharp", ()=>(0, _unfoldMoreSharpDefault.default));
parcelHelpers.export(exports, "UnfoldMoreTwoTone", ()=>(0, _unfoldMoreTwoToneDefault.default));
parcelHelpers.export(exports, "Unpublished", ()=>(0, _unpublishedDefault.default));
parcelHelpers.export(exports, "UnpublishedOutlined", ()=>(0, _unpublishedOutlinedDefault.default));
parcelHelpers.export(exports, "UnpublishedRounded", ()=>(0, _unpublishedRoundedDefault.default));
parcelHelpers.export(exports, "UnpublishedSharp", ()=>(0, _unpublishedSharpDefault.default));
parcelHelpers.export(exports, "UnpublishedTwoTone", ()=>(0, _unpublishedTwoToneDefault.default));
parcelHelpers.export(exports, "Unsubscribe", ()=>(0, _unsubscribeDefault.default));
parcelHelpers.export(exports, "UnsubscribeOutlined", ()=>(0, _unsubscribeOutlinedDefault.default));
parcelHelpers.export(exports, "UnsubscribeRounded", ()=>(0, _unsubscribeRoundedDefault.default));
parcelHelpers.export(exports, "UnsubscribeSharp", ()=>(0, _unsubscribeSharpDefault.default));
parcelHelpers.export(exports, "UnsubscribeTwoTone", ()=>(0, _unsubscribeTwoToneDefault.default));
parcelHelpers.export(exports, "Upcoming", ()=>(0, _upcomingDefault.default));
parcelHelpers.export(exports, "UpcomingOutlined", ()=>(0, _upcomingOutlinedDefault.default));
parcelHelpers.export(exports, "UpcomingRounded", ()=>(0, _upcomingRoundedDefault.default));
parcelHelpers.export(exports, "UpcomingSharp", ()=>(0, _upcomingSharpDefault.default));
parcelHelpers.export(exports, "UpcomingTwoTone", ()=>(0, _upcomingTwoToneDefault.default));
parcelHelpers.export(exports, "Update", ()=>(0, _updateDefault.default));
parcelHelpers.export(exports, "UpdateDisabled", ()=>(0, _updateDisabledDefault.default));
parcelHelpers.export(exports, "UpdateDisabledOutlined", ()=>(0, _updateDisabledOutlinedDefault.default));
parcelHelpers.export(exports, "UpdateDisabledRounded", ()=>(0, _updateDisabledRoundedDefault.default));
parcelHelpers.export(exports, "UpdateDisabledSharp", ()=>(0, _updateDisabledSharpDefault.default));
parcelHelpers.export(exports, "UpdateDisabledTwoTone", ()=>(0, _updateDisabledTwoToneDefault.default));
parcelHelpers.export(exports, "UpdateOutlined", ()=>(0, _updateOutlinedDefault.default));
parcelHelpers.export(exports, "UpdateRounded", ()=>(0, _updateRoundedDefault.default));
parcelHelpers.export(exports, "UpdateSharp", ()=>(0, _updateSharpDefault.default));
parcelHelpers.export(exports, "UpdateTwoTone", ()=>(0, _updateTwoToneDefault.default));
parcelHelpers.export(exports, "Upgrade", ()=>(0, _upgradeDefault.default));
parcelHelpers.export(exports, "UpgradeOutlined", ()=>(0, _upgradeOutlinedDefault.default));
parcelHelpers.export(exports, "UpgradeRounded", ()=>(0, _upgradeRoundedDefault.default));
parcelHelpers.export(exports, "UpgradeSharp", ()=>(0, _upgradeSharpDefault.default));
parcelHelpers.export(exports, "UpgradeTwoTone", ()=>(0, _upgradeTwoToneDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadDefault.default));
parcelHelpers.export(exports, "UploadFile", ()=>(0, _uploadFileDefault.default));
parcelHelpers.export(exports, "UploadFileOutlined", ()=>(0, _uploadFileOutlinedDefault.default));
parcelHelpers.export(exports, "UploadFileRounded", ()=>(0, _uploadFileRoundedDefault.default));
parcelHelpers.export(exports, "UploadFileSharp", ()=>(0, _uploadFileSharpDefault.default));
parcelHelpers.export(exports, "UploadFileTwoTone", ()=>(0, _uploadFileTwoToneDefault.default));
parcelHelpers.export(exports, "UploadOutlined", ()=>(0, _uploadOutlinedDefault.default));
parcelHelpers.export(exports, "UploadRounded", ()=>(0, _uploadRoundedDefault.default));
parcelHelpers.export(exports, "UploadSharp", ()=>(0, _uploadSharpDefault.default));
parcelHelpers.export(exports, "UploadTwoTone", ()=>(0, _uploadTwoToneDefault.default));
parcelHelpers.export(exports, "Usb", ()=>(0, _usbDefault.default));
parcelHelpers.export(exports, "UsbOff", ()=>(0, _usbOffDefault.default));
parcelHelpers.export(exports, "UsbOffOutlined", ()=>(0, _usbOffOutlinedDefault.default));
parcelHelpers.export(exports, "UsbOffRounded", ()=>(0, _usbOffRoundedDefault.default));
parcelHelpers.export(exports, "UsbOffSharp", ()=>(0, _usbOffSharpDefault.default));
parcelHelpers.export(exports, "UsbOffTwoTone", ()=>(0, _usbOffTwoToneDefault.default));
parcelHelpers.export(exports, "UsbOutlined", ()=>(0, _usbOutlinedDefault.default));
parcelHelpers.export(exports, "UsbRounded", ()=>(0, _usbRoundedDefault.default));
parcelHelpers.export(exports, "UsbSharp", ()=>(0, _usbSharpDefault.default));
parcelHelpers.export(exports, "UsbTwoTone", ()=>(0, _usbTwoToneDefault.default));
parcelHelpers.export(exports, "Vaccines", ()=>(0, _vaccinesDefault.default));
parcelHelpers.export(exports, "VaccinesOutlined", ()=>(0, _vaccinesOutlinedDefault.default));
parcelHelpers.export(exports, "VaccinesRounded", ()=>(0, _vaccinesRoundedDefault.default));
parcelHelpers.export(exports, "VaccinesSharp", ()=>(0, _vaccinesSharpDefault.default));
parcelHelpers.export(exports, "VaccinesTwoTone", ()=>(0, _vaccinesTwoToneDefault.default));
parcelHelpers.export(exports, "VapeFree", ()=>(0, _vapeFreeDefault.default));
parcelHelpers.export(exports, "VapeFreeOutlined", ()=>(0, _vapeFreeOutlinedDefault.default));
parcelHelpers.export(exports, "VapeFreeRounded", ()=>(0, _vapeFreeRoundedDefault.default));
parcelHelpers.export(exports, "VapeFreeSharp", ()=>(0, _vapeFreeSharpDefault.default));
parcelHelpers.export(exports, "VapeFreeTwoTone", ()=>(0, _vapeFreeTwoToneDefault.default));
parcelHelpers.export(exports, "VapingRooms", ()=>(0, _vapingRoomsDefault.default));
parcelHelpers.export(exports, "VapingRoomsOutlined", ()=>(0, _vapingRoomsOutlinedDefault.default));
parcelHelpers.export(exports, "VapingRoomsRounded", ()=>(0, _vapingRoomsRoundedDefault.default));
parcelHelpers.export(exports, "VapingRoomsSharp", ()=>(0, _vapingRoomsSharpDefault.default));
parcelHelpers.export(exports, "VapingRoomsTwoTone", ()=>(0, _vapingRoomsTwoToneDefault.default));
parcelHelpers.export(exports, "Verified", ()=>(0, _verifiedDefault.default));
parcelHelpers.export(exports, "VerifiedOutlined", ()=>(0, _verifiedOutlinedDefault.default));
parcelHelpers.export(exports, "VerifiedRounded", ()=>(0, _verifiedRoundedDefault.default));
parcelHelpers.export(exports, "VerifiedSharp", ()=>(0, _verifiedSharpDefault.default));
parcelHelpers.export(exports, "VerifiedTwoTone", ()=>(0, _verifiedTwoToneDefault.default));
parcelHelpers.export(exports, "VerifiedUser", ()=>(0, _verifiedUserDefault.default));
parcelHelpers.export(exports, "VerifiedUserOutlined", ()=>(0, _verifiedUserOutlinedDefault.default));
parcelHelpers.export(exports, "VerifiedUserRounded", ()=>(0, _verifiedUserRoundedDefault.default));
parcelHelpers.export(exports, "VerifiedUserSharp", ()=>(0, _verifiedUserSharpDefault.default));
parcelHelpers.export(exports, "VerifiedUserTwoTone", ()=>(0, _verifiedUserTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalAlignBottom", ()=>(0, _verticalAlignBottomDefault.default));
parcelHelpers.export(exports, "VerticalAlignBottomOutlined", ()=>(0, _verticalAlignBottomOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalAlignBottomRounded", ()=>(0, _verticalAlignBottomRoundedDefault.default));
parcelHelpers.export(exports, "VerticalAlignBottomSharp", ()=>(0, _verticalAlignBottomSharpDefault.default));
parcelHelpers.export(exports, "VerticalAlignBottomTwoTone", ()=>(0, _verticalAlignBottomTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalAlignCenter", ()=>(0, _verticalAlignCenterDefault.default));
parcelHelpers.export(exports, "VerticalAlignCenterOutlined", ()=>(0, _verticalAlignCenterOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalAlignCenterRounded", ()=>(0, _verticalAlignCenterRoundedDefault.default));
parcelHelpers.export(exports, "VerticalAlignCenterSharp", ()=>(0, _verticalAlignCenterSharpDefault.default));
parcelHelpers.export(exports, "VerticalAlignCenterTwoTone", ()=>(0, _verticalAlignCenterTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalAlignTop", ()=>(0, _verticalAlignTopDefault.default));
parcelHelpers.export(exports, "VerticalAlignTopOutlined", ()=>(0, _verticalAlignTopOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalAlignTopRounded", ()=>(0, _verticalAlignTopRoundedDefault.default));
parcelHelpers.export(exports, "VerticalAlignTopSharp", ()=>(0, _verticalAlignTopSharpDefault.default));
parcelHelpers.export(exports, "VerticalAlignTopTwoTone", ()=>(0, _verticalAlignTopTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalShades", ()=>(0, _verticalShadesDefault.default));
parcelHelpers.export(exports, "VerticalShadesClosed", ()=>(0, _verticalShadesClosedDefault.default));
parcelHelpers.export(exports, "VerticalShadesClosedOutlined", ()=>(0, _verticalShadesClosedOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalShadesClosedRounded", ()=>(0, _verticalShadesClosedRoundedDefault.default));
parcelHelpers.export(exports, "VerticalShadesClosedSharp", ()=>(0, _verticalShadesClosedSharpDefault.default));
parcelHelpers.export(exports, "VerticalShadesClosedTwoTone", ()=>(0, _verticalShadesClosedTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalShadesOutlined", ()=>(0, _verticalShadesOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalShadesRounded", ()=>(0, _verticalShadesRoundedDefault.default));
parcelHelpers.export(exports, "VerticalShadesSharp", ()=>(0, _verticalShadesSharpDefault.default));
parcelHelpers.export(exports, "VerticalShadesTwoTone", ()=>(0, _verticalShadesTwoToneDefault.default));
parcelHelpers.export(exports, "VerticalSplit", ()=>(0, _verticalSplitDefault.default));
parcelHelpers.export(exports, "VerticalSplitOutlined", ()=>(0, _verticalSplitOutlinedDefault.default));
parcelHelpers.export(exports, "VerticalSplitRounded", ()=>(0, _verticalSplitRoundedDefault.default));
parcelHelpers.export(exports, "VerticalSplitSharp", ()=>(0, _verticalSplitSharpDefault.default));
parcelHelpers.export(exports, "VerticalSplitTwoTone", ()=>(0, _verticalSplitTwoToneDefault.default));
parcelHelpers.export(exports, "Vibration", ()=>(0, _vibrationDefault.default));
parcelHelpers.export(exports, "VibrationOutlined", ()=>(0, _vibrationOutlinedDefault.default));
parcelHelpers.export(exports, "VibrationRounded", ()=>(0, _vibrationRoundedDefault.default));
parcelHelpers.export(exports, "VibrationSharp", ()=>(0, _vibrationSharpDefault.default));
parcelHelpers.export(exports, "VibrationTwoTone", ()=>(0, _vibrationTwoToneDefault.default));
parcelHelpers.export(exports, "VideoCall", ()=>(0, _videoCallDefault.default));
parcelHelpers.export(exports, "VideoCallOutlined", ()=>(0, _videoCallOutlinedDefault.default));
parcelHelpers.export(exports, "VideoCallRounded", ()=>(0, _videoCallRoundedDefault.default));
parcelHelpers.export(exports, "VideoCallSharp", ()=>(0, _videoCallSharpDefault.default));
parcelHelpers.export(exports, "VideoCallTwoTone", ()=>(0, _videoCallTwoToneDefault.default));
parcelHelpers.export(exports, "VideoCameraBack", ()=>(0, _videoCameraBackDefault.default));
parcelHelpers.export(exports, "VideoCameraBackOutlined", ()=>(0, _videoCameraBackOutlinedDefault.default));
parcelHelpers.export(exports, "VideoCameraBackRounded", ()=>(0, _videoCameraBackRoundedDefault.default));
parcelHelpers.export(exports, "VideoCameraBackSharp", ()=>(0, _videoCameraBackSharpDefault.default));
parcelHelpers.export(exports, "VideoCameraBackTwoTone", ()=>(0, _videoCameraBackTwoToneDefault.default));
parcelHelpers.export(exports, "VideoCameraFront", ()=>(0, _videoCameraFrontDefault.default));
parcelHelpers.export(exports, "VideoCameraFrontOutlined", ()=>(0, _videoCameraFrontOutlinedDefault.default));
parcelHelpers.export(exports, "VideoCameraFrontRounded", ()=>(0, _videoCameraFrontRoundedDefault.default));
parcelHelpers.export(exports, "VideoCameraFrontSharp", ()=>(0, _videoCameraFrontSharpDefault.default));
parcelHelpers.export(exports, "VideoCameraFrontTwoTone", ()=>(0, _videoCameraFrontTwoToneDefault.default));
parcelHelpers.export(exports, "VideoChat", ()=>(0, _videoChatDefault.default));
parcelHelpers.export(exports, "VideoChatOutlined", ()=>(0, _videoChatOutlinedDefault.default));
parcelHelpers.export(exports, "VideoChatRounded", ()=>(0, _videoChatRoundedDefault.default));
parcelHelpers.export(exports, "VideoChatSharp", ()=>(0, _videoChatSharpDefault.default));
parcelHelpers.export(exports, "VideoChatTwoTone", ()=>(0, _videoChatTwoToneDefault.default));
parcelHelpers.export(exports, "VideoFile", ()=>(0, _videoFileDefault.default));
parcelHelpers.export(exports, "VideoFileOutlined", ()=>(0, _videoFileOutlinedDefault.default));
parcelHelpers.export(exports, "VideoFileRounded", ()=>(0, _videoFileRoundedDefault.default));
parcelHelpers.export(exports, "VideoFileSharp", ()=>(0, _videoFileSharpDefault.default));
parcelHelpers.export(exports, "VideoFileTwoTone", ()=>(0, _videoFileTwoToneDefault.default));
parcelHelpers.export(exports, "VideoLabel", ()=>(0, _videoLabelDefault.default));
parcelHelpers.export(exports, "VideoLabelOutlined", ()=>(0, _videoLabelOutlinedDefault.default));
parcelHelpers.export(exports, "VideoLabelRounded", ()=>(0, _videoLabelRoundedDefault.default));
parcelHelpers.export(exports, "VideoLabelSharp", ()=>(0, _videoLabelSharpDefault.default));
parcelHelpers.export(exports, "VideoLabelTwoTone", ()=>(0, _videoLabelTwoToneDefault.default));
parcelHelpers.export(exports, "VideoLibrary", ()=>(0, _videoLibraryDefault.default));
parcelHelpers.export(exports, "VideoLibraryOutlined", ()=>(0, _videoLibraryOutlinedDefault.default));
parcelHelpers.export(exports, "VideoLibraryRounded", ()=>(0, _videoLibraryRoundedDefault.default));
parcelHelpers.export(exports, "VideoLibrarySharp", ()=>(0, _videoLibrarySharpDefault.default));
parcelHelpers.export(exports, "VideoLibraryTwoTone", ()=>(0, _videoLibraryTwoToneDefault.default));
parcelHelpers.export(exports, "VideoSettings", ()=>(0, _videoSettingsDefault.default));
parcelHelpers.export(exports, "VideoSettingsOutlined", ()=>(0, _videoSettingsOutlinedDefault.default));
parcelHelpers.export(exports, "VideoSettingsRounded", ()=>(0, _videoSettingsRoundedDefault.default));
parcelHelpers.export(exports, "VideoSettingsSharp", ()=>(0, _videoSettingsSharpDefault.default));
parcelHelpers.export(exports, "VideoSettingsTwoTone", ()=>(0, _videoSettingsTwoToneDefault.default));
parcelHelpers.export(exports, "VideoStable", ()=>(0, _videoStableDefault.default));
parcelHelpers.export(exports, "VideoStableOutlined", ()=>(0, _videoStableOutlinedDefault.default));
parcelHelpers.export(exports, "VideoStableRounded", ()=>(0, _videoStableRoundedDefault.default));
parcelHelpers.export(exports, "VideoStableSharp", ()=>(0, _videoStableSharpDefault.default));
parcelHelpers.export(exports, "VideoStableTwoTone", ()=>(0, _videoStableTwoToneDefault.default));
parcelHelpers.export(exports, "Videocam", ()=>(0, _videocamDefault.default));
parcelHelpers.export(exports, "VideocamOff", ()=>(0, _videocamOffDefault.default));
parcelHelpers.export(exports, "VideocamOffOutlined", ()=>(0, _videocamOffOutlinedDefault.default));
parcelHelpers.export(exports, "VideocamOffRounded", ()=>(0, _videocamOffRoundedDefault.default));
parcelHelpers.export(exports, "VideocamOffSharp", ()=>(0, _videocamOffSharpDefault.default));
parcelHelpers.export(exports, "VideocamOffTwoTone", ()=>(0, _videocamOffTwoToneDefault.default));
parcelHelpers.export(exports, "VideocamOutlined", ()=>(0, _videocamOutlinedDefault.default));
parcelHelpers.export(exports, "VideocamRounded", ()=>(0, _videocamRoundedDefault.default));
parcelHelpers.export(exports, "VideocamSharp", ()=>(0, _videocamSharpDefault.default));
parcelHelpers.export(exports, "VideocamTwoTone", ()=>(0, _videocamTwoToneDefault.default));
parcelHelpers.export(exports, "VideogameAsset", ()=>(0, _videogameAssetDefault.default));
parcelHelpers.export(exports, "VideogameAssetOff", ()=>(0, _videogameAssetOffDefault.default));
parcelHelpers.export(exports, "VideogameAssetOffOutlined", ()=>(0, _videogameAssetOffOutlinedDefault.default));
parcelHelpers.export(exports, "VideogameAssetOffRounded", ()=>(0, _videogameAssetOffRoundedDefault.default));
parcelHelpers.export(exports, "VideogameAssetOffSharp", ()=>(0, _videogameAssetOffSharpDefault.default));
parcelHelpers.export(exports, "VideogameAssetOffTwoTone", ()=>(0, _videogameAssetOffTwoToneDefault.default));
parcelHelpers.export(exports, "VideogameAssetOutlined", ()=>(0, _videogameAssetOutlinedDefault.default));
parcelHelpers.export(exports, "VideogameAssetRounded", ()=>(0, _videogameAssetRoundedDefault.default));
parcelHelpers.export(exports, "VideogameAssetSharp", ()=>(0, _videogameAssetSharpDefault.default));
parcelHelpers.export(exports, "VideogameAssetTwoTone", ()=>(0, _videogameAssetTwoToneDefault.default));
parcelHelpers.export(exports, "ViewAgenda", ()=>(0, _viewAgendaDefault.default));
parcelHelpers.export(exports, "ViewAgendaOutlined", ()=>(0, _viewAgendaOutlinedDefault.default));
parcelHelpers.export(exports, "ViewAgendaRounded", ()=>(0, _viewAgendaRoundedDefault.default));
parcelHelpers.export(exports, "ViewAgendaSharp", ()=>(0, _viewAgendaSharpDefault.default));
parcelHelpers.export(exports, "ViewAgendaTwoTone", ()=>(0, _viewAgendaTwoToneDefault.default));
parcelHelpers.export(exports, "ViewArray", ()=>(0, _viewArrayDefault.default));
parcelHelpers.export(exports, "ViewArrayOutlined", ()=>(0, _viewArrayOutlinedDefault.default));
parcelHelpers.export(exports, "ViewArrayRounded", ()=>(0, _viewArrayRoundedDefault.default));
parcelHelpers.export(exports, "ViewArraySharp", ()=>(0, _viewArraySharpDefault.default));
parcelHelpers.export(exports, "ViewArrayTwoTone", ()=>(0, _viewArrayTwoToneDefault.default));
parcelHelpers.export(exports, "ViewCarousel", ()=>(0, _viewCarouselDefault.default));
parcelHelpers.export(exports, "ViewCarouselOutlined", ()=>(0, _viewCarouselOutlinedDefault.default));
parcelHelpers.export(exports, "ViewCarouselRounded", ()=>(0, _viewCarouselRoundedDefault.default));
parcelHelpers.export(exports, "ViewCarouselSharp", ()=>(0, _viewCarouselSharpDefault.default));
parcelHelpers.export(exports, "ViewCarouselTwoTone", ()=>(0, _viewCarouselTwoToneDefault.default));
parcelHelpers.export(exports, "ViewColumn", ()=>(0, _viewColumnDefault.default));
parcelHelpers.export(exports, "ViewColumnOutlined", ()=>(0, _viewColumnOutlinedDefault.default));
parcelHelpers.export(exports, "ViewColumnRounded", ()=>(0, _viewColumnRoundedDefault.default));
parcelHelpers.export(exports, "ViewColumnSharp", ()=>(0, _viewColumnSharpDefault.default));
parcelHelpers.export(exports, "ViewColumnTwoTone", ()=>(0, _viewColumnTwoToneDefault.default));
parcelHelpers.export(exports, "ViewComfy", ()=>(0, _viewComfyDefault.default));
parcelHelpers.export(exports, "ViewComfyAlt", ()=>(0, _viewComfyAltDefault.default));
parcelHelpers.export(exports, "ViewComfyAltOutlined", ()=>(0, _viewComfyAltOutlinedDefault.default));
parcelHelpers.export(exports, "ViewComfyAltRounded", ()=>(0, _viewComfyAltRoundedDefault.default));
parcelHelpers.export(exports, "ViewComfyAltSharp", ()=>(0, _viewComfyAltSharpDefault.default));
parcelHelpers.export(exports, "ViewComfyAltTwoTone", ()=>(0, _viewComfyAltTwoToneDefault.default));
parcelHelpers.export(exports, "ViewComfyOutlined", ()=>(0, _viewComfyOutlinedDefault.default));
parcelHelpers.export(exports, "ViewComfyRounded", ()=>(0, _viewComfyRoundedDefault.default));
parcelHelpers.export(exports, "ViewComfySharp", ()=>(0, _viewComfySharpDefault.default));
parcelHelpers.export(exports, "ViewComfyTwoTone", ()=>(0, _viewComfyTwoToneDefault.default));
parcelHelpers.export(exports, "ViewCompact", ()=>(0, _viewCompactDefault.default));
parcelHelpers.export(exports, "ViewCompactAlt", ()=>(0, _viewCompactAltDefault.default));
parcelHelpers.export(exports, "ViewCompactAltOutlined", ()=>(0, _viewCompactAltOutlinedDefault.default));
parcelHelpers.export(exports, "ViewCompactAltRounded", ()=>(0, _viewCompactAltRoundedDefault.default));
parcelHelpers.export(exports, "ViewCompactAltSharp", ()=>(0, _viewCompactAltSharpDefault.default));
parcelHelpers.export(exports, "ViewCompactAltTwoTone", ()=>(0, _viewCompactAltTwoToneDefault.default));
parcelHelpers.export(exports, "ViewCompactOutlined", ()=>(0, _viewCompactOutlinedDefault.default));
parcelHelpers.export(exports, "ViewCompactRounded", ()=>(0, _viewCompactRoundedDefault.default));
parcelHelpers.export(exports, "ViewCompactSharp", ()=>(0, _viewCompactSharpDefault.default));
parcelHelpers.export(exports, "ViewCompactTwoTone", ()=>(0, _viewCompactTwoToneDefault.default));
parcelHelpers.export(exports, "ViewCozy", ()=>(0, _viewCozyDefault.default));
parcelHelpers.export(exports, "ViewCozyOutlined", ()=>(0, _viewCozyOutlinedDefault.default));
parcelHelpers.export(exports, "ViewCozyRounded", ()=>(0, _viewCozyRoundedDefault.default));
parcelHelpers.export(exports, "ViewCozySharp", ()=>(0, _viewCozySharpDefault.default));
parcelHelpers.export(exports, "ViewCozyTwoTone", ()=>(0, _viewCozyTwoToneDefault.default));
parcelHelpers.export(exports, "ViewDay", ()=>(0, _viewDayDefault.default));
parcelHelpers.export(exports, "ViewDayOutlined", ()=>(0, _viewDayOutlinedDefault.default));
parcelHelpers.export(exports, "ViewDayRounded", ()=>(0, _viewDayRoundedDefault.default));
parcelHelpers.export(exports, "ViewDaySharp", ()=>(0, _viewDaySharpDefault.default));
parcelHelpers.export(exports, "ViewDayTwoTone", ()=>(0, _viewDayTwoToneDefault.default));
parcelHelpers.export(exports, "ViewHeadline", ()=>(0, _viewHeadlineDefault.default));
parcelHelpers.export(exports, "ViewHeadlineOutlined", ()=>(0, _viewHeadlineOutlinedDefault.default));
parcelHelpers.export(exports, "ViewHeadlineRounded", ()=>(0, _viewHeadlineRoundedDefault.default));
parcelHelpers.export(exports, "ViewHeadlineSharp", ()=>(0, _viewHeadlineSharpDefault.default));
parcelHelpers.export(exports, "ViewHeadlineTwoTone", ()=>(0, _viewHeadlineTwoToneDefault.default));
parcelHelpers.export(exports, "ViewInAr", ()=>(0, _viewInArDefault.default));
parcelHelpers.export(exports, "ViewInArOutlined", ()=>(0, _viewInArOutlinedDefault.default));
parcelHelpers.export(exports, "ViewInArRounded", ()=>(0, _viewInArRoundedDefault.default));
parcelHelpers.export(exports, "ViewInArSharp", ()=>(0, _viewInArSharpDefault.default));
parcelHelpers.export(exports, "ViewInArTwoTone", ()=>(0, _viewInArTwoToneDefault.default));
parcelHelpers.export(exports, "ViewKanban", ()=>(0, _viewKanbanDefault.default));
parcelHelpers.export(exports, "ViewKanbanOutlined", ()=>(0, _viewKanbanOutlinedDefault.default));
parcelHelpers.export(exports, "ViewKanbanRounded", ()=>(0, _viewKanbanRoundedDefault.default));
parcelHelpers.export(exports, "ViewKanbanSharp", ()=>(0, _viewKanbanSharpDefault.default));
parcelHelpers.export(exports, "ViewKanbanTwoTone", ()=>(0, _viewKanbanTwoToneDefault.default));
parcelHelpers.export(exports, "ViewList", ()=>(0, _viewListDefault.default));
parcelHelpers.export(exports, "ViewListOutlined", ()=>(0, _viewListOutlinedDefault.default));
parcelHelpers.export(exports, "ViewListRounded", ()=>(0, _viewListRoundedDefault.default));
parcelHelpers.export(exports, "ViewListSharp", ()=>(0, _viewListSharpDefault.default));
parcelHelpers.export(exports, "ViewListTwoTone", ()=>(0, _viewListTwoToneDefault.default));
parcelHelpers.export(exports, "ViewModule", ()=>(0, _viewModuleDefault.default));
parcelHelpers.export(exports, "ViewModuleOutlined", ()=>(0, _viewModuleOutlinedDefault.default));
parcelHelpers.export(exports, "ViewModuleRounded", ()=>(0, _viewModuleRoundedDefault.default));
parcelHelpers.export(exports, "ViewModuleSharp", ()=>(0, _viewModuleSharpDefault.default));
parcelHelpers.export(exports, "ViewModuleTwoTone", ()=>(0, _viewModuleTwoToneDefault.default));
parcelHelpers.export(exports, "ViewQuilt", ()=>(0, _viewQuiltDefault.default));
parcelHelpers.export(exports, "ViewQuiltOutlined", ()=>(0, _viewQuiltOutlinedDefault.default));
parcelHelpers.export(exports, "ViewQuiltRounded", ()=>(0, _viewQuiltRoundedDefault.default));
parcelHelpers.export(exports, "ViewQuiltSharp", ()=>(0, _viewQuiltSharpDefault.default));
parcelHelpers.export(exports, "ViewQuiltTwoTone", ()=>(0, _viewQuiltTwoToneDefault.default));
parcelHelpers.export(exports, "ViewSidebar", ()=>(0, _viewSidebarDefault.default));
parcelHelpers.export(exports, "ViewSidebarOutlined", ()=>(0, _viewSidebarOutlinedDefault.default));
parcelHelpers.export(exports, "ViewSidebarRounded", ()=>(0, _viewSidebarRoundedDefault.default));
parcelHelpers.export(exports, "ViewSidebarSharp", ()=>(0, _viewSidebarSharpDefault.default));
parcelHelpers.export(exports, "ViewSidebarTwoTone", ()=>(0, _viewSidebarTwoToneDefault.default));
parcelHelpers.export(exports, "ViewStream", ()=>(0, _viewStreamDefault.default));
parcelHelpers.export(exports, "ViewStreamOutlined", ()=>(0, _viewStreamOutlinedDefault.default));
parcelHelpers.export(exports, "ViewStreamRounded", ()=>(0, _viewStreamRoundedDefault.default));
parcelHelpers.export(exports, "ViewStreamSharp", ()=>(0, _viewStreamSharpDefault.default));
parcelHelpers.export(exports, "ViewStreamTwoTone", ()=>(0, _viewStreamTwoToneDefault.default));
parcelHelpers.export(exports, "ViewTimeline", ()=>(0, _viewTimelineDefault.default));
parcelHelpers.export(exports, "ViewTimelineOutlined", ()=>(0, _viewTimelineOutlinedDefault.default));
parcelHelpers.export(exports, "ViewTimelineRounded", ()=>(0, _viewTimelineRoundedDefault.default));
parcelHelpers.export(exports, "ViewTimelineSharp", ()=>(0, _viewTimelineSharpDefault.default));
parcelHelpers.export(exports, "ViewTimelineTwoTone", ()=>(0, _viewTimelineTwoToneDefault.default));
parcelHelpers.export(exports, "ViewWeek", ()=>(0, _viewWeekDefault.default));
parcelHelpers.export(exports, "ViewWeekOutlined", ()=>(0, _viewWeekOutlinedDefault.default));
parcelHelpers.export(exports, "ViewWeekRounded", ()=>(0, _viewWeekRoundedDefault.default));
parcelHelpers.export(exports, "ViewWeekSharp", ()=>(0, _viewWeekSharpDefault.default));
parcelHelpers.export(exports, "ViewWeekTwoTone", ()=>(0, _viewWeekTwoToneDefault.default));
parcelHelpers.export(exports, "Vignette", ()=>(0, _vignetteDefault.default));
parcelHelpers.export(exports, "VignetteOutlined", ()=>(0, _vignetteOutlinedDefault.default));
parcelHelpers.export(exports, "VignetteRounded", ()=>(0, _vignetteRoundedDefault.default));
parcelHelpers.export(exports, "VignetteSharp", ()=>(0, _vignetteSharpDefault.default));
parcelHelpers.export(exports, "VignetteTwoTone", ()=>(0, _vignetteTwoToneDefault.default));
parcelHelpers.export(exports, "Villa", ()=>(0, _villaDefault.default));
parcelHelpers.export(exports, "VillaOutlined", ()=>(0, _villaOutlinedDefault.default));
parcelHelpers.export(exports, "VillaRounded", ()=>(0, _villaRoundedDefault.default));
parcelHelpers.export(exports, "VillaSharp", ()=>(0, _villaSharpDefault.default));
parcelHelpers.export(exports, "VillaTwoTone", ()=>(0, _villaTwoToneDefault.default));
parcelHelpers.export(exports, "Visibility", ()=>(0, _visibilityDefault.default));
parcelHelpers.export(exports, "VisibilityOff", ()=>(0, _visibilityOffDefault.default));
parcelHelpers.export(exports, "VisibilityOffOutlined", ()=>(0, _visibilityOffOutlinedDefault.default));
parcelHelpers.export(exports, "VisibilityOffRounded", ()=>(0, _visibilityOffRoundedDefault.default));
parcelHelpers.export(exports, "VisibilityOffSharp", ()=>(0, _visibilityOffSharpDefault.default));
parcelHelpers.export(exports, "VisibilityOffTwoTone", ()=>(0, _visibilityOffTwoToneDefault.default));
parcelHelpers.export(exports, "VisibilityOutlined", ()=>(0, _visibilityOutlinedDefault.default));
parcelHelpers.export(exports, "VisibilityRounded", ()=>(0, _visibilityRoundedDefault.default));
parcelHelpers.export(exports, "VisibilitySharp", ()=>(0, _visibilitySharpDefault.default));
parcelHelpers.export(exports, "VisibilityTwoTone", ()=>(0, _visibilityTwoToneDefault.default));
parcelHelpers.export(exports, "VoiceChat", ()=>(0, _voiceChatDefault.default));
parcelHelpers.export(exports, "VoiceChatOutlined", ()=>(0, _voiceChatOutlinedDefault.default));
parcelHelpers.export(exports, "VoiceChatRounded", ()=>(0, _voiceChatRoundedDefault.default));
parcelHelpers.export(exports, "VoiceChatSharp", ()=>(0, _voiceChatSharpDefault.default));
parcelHelpers.export(exports, "VoiceChatTwoTone", ()=>(0, _voiceChatTwoToneDefault.default));
parcelHelpers.export(exports, "VoiceOverOff", ()=>(0, _voiceOverOffDefault.default));
parcelHelpers.export(exports, "VoiceOverOffOutlined", ()=>(0, _voiceOverOffOutlinedDefault.default));
parcelHelpers.export(exports, "VoiceOverOffRounded", ()=>(0, _voiceOverOffRoundedDefault.default));
parcelHelpers.export(exports, "VoiceOverOffSharp", ()=>(0, _voiceOverOffSharpDefault.default));
parcelHelpers.export(exports, "VoiceOverOffTwoTone", ()=>(0, _voiceOverOffTwoToneDefault.default));
parcelHelpers.export(exports, "Voicemail", ()=>(0, _voicemailDefault.default));
parcelHelpers.export(exports, "VoicemailOutlined", ()=>(0, _voicemailOutlinedDefault.default));
parcelHelpers.export(exports, "VoicemailRounded", ()=>(0, _voicemailRoundedDefault.default));
parcelHelpers.export(exports, "VoicemailSharp", ()=>(0, _voicemailSharpDefault.default));
parcelHelpers.export(exports, "VoicemailTwoTone", ()=>(0, _voicemailTwoToneDefault.default));
parcelHelpers.export(exports, "Volcano", ()=>(0, _volcanoDefault.default));
parcelHelpers.export(exports, "VolcanoOutlined", ()=>(0, _volcanoOutlinedDefault.default));
parcelHelpers.export(exports, "VolcanoRounded", ()=>(0, _volcanoRoundedDefault.default));
parcelHelpers.export(exports, "VolcanoSharp", ()=>(0, _volcanoSharpDefault.default));
parcelHelpers.export(exports, "VolcanoTwoTone", ()=>(0, _volcanoTwoToneDefault.default));
parcelHelpers.export(exports, "VolumeDown", ()=>(0, _volumeDownDefault.default));
parcelHelpers.export(exports, "VolumeDownOutlined", ()=>(0, _volumeDownOutlinedDefault.default));
parcelHelpers.export(exports, "VolumeDownRounded", ()=>(0, _volumeDownRoundedDefault.default));
parcelHelpers.export(exports, "VolumeDownSharp", ()=>(0, _volumeDownSharpDefault.default));
parcelHelpers.export(exports, "VolumeDownTwoTone", ()=>(0, _volumeDownTwoToneDefault.default));
parcelHelpers.export(exports, "VolumeMute", ()=>(0, _volumeMuteDefault.default));
parcelHelpers.export(exports, "VolumeMuteOutlined", ()=>(0, _volumeMuteOutlinedDefault.default));
parcelHelpers.export(exports, "VolumeMuteRounded", ()=>(0, _volumeMuteRoundedDefault.default));
parcelHelpers.export(exports, "VolumeMuteSharp", ()=>(0, _volumeMuteSharpDefault.default));
parcelHelpers.export(exports, "VolumeMuteTwoTone", ()=>(0, _volumeMuteTwoToneDefault.default));
parcelHelpers.export(exports, "VolumeOff", ()=>(0, _volumeOffDefault.default));
parcelHelpers.export(exports, "VolumeOffOutlined", ()=>(0, _volumeOffOutlinedDefault.default));
parcelHelpers.export(exports, "VolumeOffRounded", ()=>(0, _volumeOffRoundedDefault.default));
parcelHelpers.export(exports, "VolumeOffSharp", ()=>(0, _volumeOffSharpDefault.default));
parcelHelpers.export(exports, "VolumeOffTwoTone", ()=>(0, _volumeOffTwoToneDefault.default));
parcelHelpers.export(exports, "VolumeUp", ()=>(0, _volumeUpDefault.default));
parcelHelpers.export(exports, "VolumeUpOutlined", ()=>(0, _volumeUpOutlinedDefault.default));
parcelHelpers.export(exports, "VolumeUpRounded", ()=>(0, _volumeUpRoundedDefault.default));
parcelHelpers.export(exports, "VolumeUpSharp", ()=>(0, _volumeUpSharpDefault.default));
parcelHelpers.export(exports, "VolumeUpTwoTone", ()=>(0, _volumeUpTwoToneDefault.default));
parcelHelpers.export(exports, "VolunteerActivism", ()=>(0, _volunteerActivismDefault.default));
parcelHelpers.export(exports, "VolunteerActivismOutlined", ()=>(0, _volunteerActivismOutlinedDefault.default));
parcelHelpers.export(exports, "VolunteerActivismRounded", ()=>(0, _volunteerActivismRoundedDefault.default));
parcelHelpers.export(exports, "VolunteerActivismSharp", ()=>(0, _volunteerActivismSharpDefault.default));
parcelHelpers.export(exports, "VolunteerActivismTwoTone", ()=>(0, _volunteerActivismTwoToneDefault.default));
parcelHelpers.export(exports, "VpnKey", ()=>(0, _vpnKeyDefault.default));
parcelHelpers.export(exports, "VpnKeyOff", ()=>(0, _vpnKeyOffDefault.default));
parcelHelpers.export(exports, "VpnKeyOffOutlined", ()=>(0, _vpnKeyOffOutlinedDefault.default));
parcelHelpers.export(exports, "VpnKeyOffRounded", ()=>(0, _vpnKeyOffRoundedDefault.default));
parcelHelpers.export(exports, "VpnKeyOffSharp", ()=>(0, _vpnKeyOffSharpDefault.default));
parcelHelpers.export(exports, "VpnKeyOffTwoTone", ()=>(0, _vpnKeyOffTwoToneDefault.default));
parcelHelpers.export(exports, "VpnKeyOutlined", ()=>(0, _vpnKeyOutlinedDefault.default));
parcelHelpers.export(exports, "VpnKeyRounded", ()=>(0, _vpnKeyRoundedDefault.default));
parcelHelpers.export(exports, "VpnKeySharp", ()=>(0, _vpnKeySharpDefault.default));
parcelHelpers.export(exports, "VpnKeyTwoTone", ()=>(0, _vpnKeyTwoToneDefault.default));
parcelHelpers.export(exports, "VpnLock", ()=>(0, _vpnLockDefault.default));
parcelHelpers.export(exports, "VpnLockOutlined", ()=>(0, _vpnLockOutlinedDefault.default));
parcelHelpers.export(exports, "VpnLockRounded", ()=>(0, _vpnLockRoundedDefault.default));
parcelHelpers.export(exports, "VpnLockSharp", ()=>(0, _vpnLockSharpDefault.default));
parcelHelpers.export(exports, "VpnLockTwoTone", ()=>(0, _vpnLockTwoToneDefault.default));
parcelHelpers.export(exports, "Vrpano", ()=>(0, _vrpanoDefault.default));
parcelHelpers.export(exports, "VrpanoOutlined", ()=>(0, _vrpanoOutlinedDefault.default));
parcelHelpers.export(exports, "VrpanoRounded", ()=>(0, _vrpanoRoundedDefault.default));
parcelHelpers.export(exports, "VrpanoSharp", ()=>(0, _vrpanoSharpDefault.default));
parcelHelpers.export(exports, "VrpanoTwoTone", ()=>(0, _vrpanoTwoToneDefault.default));
parcelHelpers.export(exports, "Wallet", ()=>(0, _walletDefault.default));
parcelHelpers.export(exports, "WalletOutlined", ()=>(0, _walletOutlinedDefault.default));
parcelHelpers.export(exports, "WalletRounded", ()=>(0, _walletRoundedDefault.default));
parcelHelpers.export(exports, "WalletSharp", ()=>(0, _walletSharpDefault.default));
parcelHelpers.export(exports, "WalletTwoTone", ()=>(0, _walletTwoToneDefault.default));
parcelHelpers.export(exports, "Wallpaper", ()=>(0, _wallpaperDefault.default));
parcelHelpers.export(exports, "WallpaperOutlined", ()=>(0, _wallpaperOutlinedDefault.default));
parcelHelpers.export(exports, "WallpaperRounded", ()=>(0, _wallpaperRoundedDefault.default));
parcelHelpers.export(exports, "WallpaperSharp", ()=>(0, _wallpaperSharpDefault.default));
parcelHelpers.export(exports, "WallpaperTwoTone", ()=>(0, _wallpaperTwoToneDefault.default));
parcelHelpers.export(exports, "Warehouse", ()=>(0, _warehouseDefault.default));
parcelHelpers.export(exports, "WarehouseOutlined", ()=>(0, _warehouseOutlinedDefault.default));
parcelHelpers.export(exports, "WarehouseRounded", ()=>(0, _warehouseRoundedDefault.default));
parcelHelpers.export(exports, "WarehouseSharp", ()=>(0, _warehouseSharpDefault.default));
parcelHelpers.export(exports, "WarehouseTwoTone", ()=>(0, _warehouseTwoToneDefault.default));
parcelHelpers.export(exports, "Warning", ()=>(0, _warningDefault.default));
parcelHelpers.export(exports, "WarningAmber", ()=>(0, _warningAmberDefault.default));
parcelHelpers.export(exports, "WarningAmberOutlined", ()=>(0, _warningAmberOutlinedDefault.default));
parcelHelpers.export(exports, "WarningAmberRounded", ()=>(0, _warningAmberRoundedDefault.default));
parcelHelpers.export(exports, "WarningAmberSharp", ()=>(0, _warningAmberSharpDefault.default));
parcelHelpers.export(exports, "WarningAmberTwoTone", ()=>(0, _warningAmberTwoToneDefault.default));
parcelHelpers.export(exports, "WarningOutlined", ()=>(0, _warningOutlinedDefault.default));
parcelHelpers.export(exports, "WarningRounded", ()=>(0, _warningRoundedDefault.default));
parcelHelpers.export(exports, "WarningSharp", ()=>(0, _warningSharpDefault.default));
parcelHelpers.export(exports, "WarningTwoTone", ()=>(0, _warningTwoToneDefault.default));
parcelHelpers.export(exports, "Wash", ()=>(0, _washDefault.default));
parcelHelpers.export(exports, "WashOutlined", ()=>(0, _washOutlinedDefault.default));
parcelHelpers.export(exports, "WashRounded", ()=>(0, _washRoundedDefault.default));
parcelHelpers.export(exports, "WashSharp", ()=>(0, _washSharpDefault.default));
parcelHelpers.export(exports, "WashTwoTone", ()=>(0, _washTwoToneDefault.default));
parcelHelpers.export(exports, "Watch", ()=>(0, _watchDefault.default));
parcelHelpers.export(exports, "WatchLater", ()=>(0, _watchLaterDefault.default));
parcelHelpers.export(exports, "WatchLaterOutlined", ()=>(0, _watchLaterOutlinedDefault.default));
parcelHelpers.export(exports, "WatchLaterRounded", ()=>(0, _watchLaterRoundedDefault.default));
parcelHelpers.export(exports, "WatchLaterSharp", ()=>(0, _watchLaterSharpDefault.default));
parcelHelpers.export(exports, "WatchLaterTwoTone", ()=>(0, _watchLaterTwoToneDefault.default));
parcelHelpers.export(exports, "WatchOff", ()=>(0, _watchOffDefault.default));
parcelHelpers.export(exports, "WatchOffOutlined", ()=>(0, _watchOffOutlinedDefault.default));
parcelHelpers.export(exports, "WatchOffRounded", ()=>(0, _watchOffRoundedDefault.default));
parcelHelpers.export(exports, "WatchOffSharp", ()=>(0, _watchOffSharpDefault.default));
parcelHelpers.export(exports, "WatchOffTwoTone", ()=>(0, _watchOffTwoToneDefault.default));
parcelHelpers.export(exports, "WatchOutlined", ()=>(0, _watchOutlinedDefault.default));
parcelHelpers.export(exports, "WatchRounded", ()=>(0, _watchRoundedDefault.default));
parcelHelpers.export(exports, "WatchSharp", ()=>(0, _watchSharpDefault.default));
parcelHelpers.export(exports, "WatchTwoTone", ()=>(0, _watchTwoToneDefault.default));
parcelHelpers.export(exports, "Water", ()=>(0, _waterDefault.default));
parcelHelpers.export(exports, "WaterDamage", ()=>(0, _waterDamageDefault.default));
parcelHelpers.export(exports, "WaterDamageOutlined", ()=>(0, _waterDamageOutlinedDefault.default));
parcelHelpers.export(exports, "WaterDamageRounded", ()=>(0, _waterDamageRoundedDefault.default));
parcelHelpers.export(exports, "WaterDamageSharp", ()=>(0, _waterDamageSharpDefault.default));
parcelHelpers.export(exports, "WaterDamageTwoTone", ()=>(0, _waterDamageTwoToneDefault.default));
parcelHelpers.export(exports, "WaterDrop", ()=>(0, _waterDropDefault.default));
parcelHelpers.export(exports, "WaterDropOutlined", ()=>(0, _waterDropOutlinedDefault.default));
parcelHelpers.export(exports, "WaterDropRounded", ()=>(0, _waterDropRoundedDefault.default));
parcelHelpers.export(exports, "WaterDropSharp", ()=>(0, _waterDropSharpDefault.default));
parcelHelpers.export(exports, "WaterDropTwoTone", ()=>(0, _waterDropTwoToneDefault.default));
parcelHelpers.export(exports, "WaterOutlined", ()=>(0, _waterOutlinedDefault.default));
parcelHelpers.export(exports, "WaterRounded", ()=>(0, _waterRoundedDefault.default));
parcelHelpers.export(exports, "WaterSharp", ()=>(0, _waterSharpDefault.default));
parcelHelpers.export(exports, "WaterTwoTone", ()=>(0, _waterTwoToneDefault.default));
parcelHelpers.export(exports, "WaterfallChart", ()=>(0, _waterfallChartDefault.default));
parcelHelpers.export(exports, "WaterfallChartOutlined", ()=>(0, _waterfallChartOutlinedDefault.default));
parcelHelpers.export(exports, "WaterfallChartRounded", ()=>(0, _waterfallChartRoundedDefault.default));
parcelHelpers.export(exports, "WaterfallChartSharp", ()=>(0, _waterfallChartSharpDefault.default));
parcelHelpers.export(exports, "WaterfallChartTwoTone", ()=>(0, _waterfallChartTwoToneDefault.default));
parcelHelpers.export(exports, "Waves", ()=>(0, _wavesDefault.default));
parcelHelpers.export(exports, "WavesOutlined", ()=>(0, _wavesOutlinedDefault.default));
parcelHelpers.export(exports, "WavesRounded", ()=>(0, _wavesRoundedDefault.default));
parcelHelpers.export(exports, "WavesSharp", ()=>(0, _wavesSharpDefault.default));
parcelHelpers.export(exports, "WavesTwoTone", ()=>(0, _wavesTwoToneDefault.default));
parcelHelpers.export(exports, "WavingHand", ()=>(0, _wavingHandDefault.default));
parcelHelpers.export(exports, "WavingHandOutlined", ()=>(0, _wavingHandOutlinedDefault.default));
parcelHelpers.export(exports, "WavingHandRounded", ()=>(0, _wavingHandRoundedDefault.default));
parcelHelpers.export(exports, "WavingHandSharp", ()=>(0, _wavingHandSharpDefault.default));
parcelHelpers.export(exports, "WavingHandTwoTone", ()=>(0, _wavingHandTwoToneDefault.default));
parcelHelpers.export(exports, "WbAuto", ()=>(0, _wbAutoDefault.default));
parcelHelpers.export(exports, "WbAutoOutlined", ()=>(0, _wbAutoOutlinedDefault.default));
parcelHelpers.export(exports, "WbAutoRounded", ()=>(0, _wbAutoRoundedDefault.default));
parcelHelpers.export(exports, "WbAutoSharp", ()=>(0, _wbAutoSharpDefault.default));
parcelHelpers.export(exports, "WbAutoTwoTone", ()=>(0, _wbAutoTwoToneDefault.default));
parcelHelpers.export(exports, "WbCloudy", ()=>(0, _wbCloudyDefault.default));
parcelHelpers.export(exports, "WbCloudyOutlined", ()=>(0, _wbCloudyOutlinedDefault.default));
parcelHelpers.export(exports, "WbCloudyRounded", ()=>(0, _wbCloudyRoundedDefault.default));
parcelHelpers.export(exports, "WbCloudySharp", ()=>(0, _wbCloudySharpDefault.default));
parcelHelpers.export(exports, "WbCloudyTwoTone", ()=>(0, _wbCloudyTwoToneDefault.default));
parcelHelpers.export(exports, "WbIncandescent", ()=>(0, _wbIncandescentDefault.default));
parcelHelpers.export(exports, "WbIncandescentOutlined", ()=>(0, _wbIncandescentOutlinedDefault.default));
parcelHelpers.export(exports, "WbIncandescentRounded", ()=>(0, _wbIncandescentRoundedDefault.default));
parcelHelpers.export(exports, "WbIncandescentSharp", ()=>(0, _wbIncandescentSharpDefault.default));
parcelHelpers.export(exports, "WbIncandescentTwoTone", ()=>(0, _wbIncandescentTwoToneDefault.default));
parcelHelpers.export(exports, "WbIridescent", ()=>(0, _wbIridescentDefault.default));
parcelHelpers.export(exports, "WbIridescentOutlined", ()=>(0, _wbIridescentOutlinedDefault.default));
parcelHelpers.export(exports, "WbIridescentRounded", ()=>(0, _wbIridescentRoundedDefault.default));
parcelHelpers.export(exports, "WbIridescentSharp", ()=>(0, _wbIridescentSharpDefault.default));
parcelHelpers.export(exports, "WbIridescentTwoTone", ()=>(0, _wbIridescentTwoToneDefault.default));
parcelHelpers.export(exports, "WbShade", ()=>(0, _wbShadeDefault.default));
parcelHelpers.export(exports, "WbShadeOutlined", ()=>(0, _wbShadeOutlinedDefault.default));
parcelHelpers.export(exports, "WbShadeRounded", ()=>(0, _wbShadeRoundedDefault.default));
parcelHelpers.export(exports, "WbShadeSharp", ()=>(0, _wbShadeSharpDefault.default));
parcelHelpers.export(exports, "WbShadeTwoTone", ()=>(0, _wbShadeTwoToneDefault.default));
parcelHelpers.export(exports, "WbSunny", ()=>(0, _wbSunnyDefault.default));
parcelHelpers.export(exports, "WbSunnyOutlined", ()=>(0, _wbSunnyOutlinedDefault.default));
parcelHelpers.export(exports, "WbSunnyRounded", ()=>(0, _wbSunnyRoundedDefault.default));
parcelHelpers.export(exports, "WbSunnySharp", ()=>(0, _wbSunnySharpDefault.default));
parcelHelpers.export(exports, "WbSunnyTwoTone", ()=>(0, _wbSunnyTwoToneDefault.default));
parcelHelpers.export(exports, "WbTwilight", ()=>(0, _wbTwilightDefault.default));
parcelHelpers.export(exports, "WbTwilightOutlined", ()=>(0, _wbTwilightOutlinedDefault.default));
parcelHelpers.export(exports, "WbTwilightRounded", ()=>(0, _wbTwilightRoundedDefault.default));
parcelHelpers.export(exports, "WbTwilightSharp", ()=>(0, _wbTwilightSharpDefault.default));
parcelHelpers.export(exports, "WbTwilightTwoTone", ()=>(0, _wbTwilightTwoToneDefault.default));
parcelHelpers.export(exports, "Wc", ()=>(0, _wcDefault.default));
parcelHelpers.export(exports, "WcOutlined", ()=>(0, _wcOutlinedDefault.default));
parcelHelpers.export(exports, "WcRounded", ()=>(0, _wcRoundedDefault.default));
parcelHelpers.export(exports, "WcSharp", ()=>(0, _wcSharpDefault.default));
parcelHelpers.export(exports, "WcTwoTone", ()=>(0, _wcTwoToneDefault.default));
parcelHelpers.export(exports, "Web", ()=>(0, _webDefault.default));
parcelHelpers.export(exports, "WebAsset", ()=>(0, _webAssetDefault.default));
parcelHelpers.export(exports, "WebAssetOff", ()=>(0, _webAssetOffDefault.default));
parcelHelpers.export(exports, "WebAssetOffOutlined", ()=>(0, _webAssetOffOutlinedDefault.default));
parcelHelpers.export(exports, "WebAssetOffRounded", ()=>(0, _webAssetOffRoundedDefault.default));
parcelHelpers.export(exports, "WebAssetOffSharp", ()=>(0, _webAssetOffSharpDefault.default));
parcelHelpers.export(exports, "WebAssetOffTwoTone", ()=>(0, _webAssetOffTwoToneDefault.default));
parcelHelpers.export(exports, "WebAssetOutlined", ()=>(0, _webAssetOutlinedDefault.default));
parcelHelpers.export(exports, "WebAssetRounded", ()=>(0, _webAssetRoundedDefault.default));
parcelHelpers.export(exports, "WebAssetSharp", ()=>(0, _webAssetSharpDefault.default));
parcelHelpers.export(exports, "WebAssetTwoTone", ()=>(0, _webAssetTwoToneDefault.default));
parcelHelpers.export(exports, "WebOutlined", ()=>(0, _webOutlinedDefault.default));
parcelHelpers.export(exports, "WebRounded", ()=>(0, _webRoundedDefault.default));
parcelHelpers.export(exports, "WebSharp", ()=>(0, _webSharpDefault.default));
parcelHelpers.export(exports, "WebStories", ()=>(0, _webStoriesDefault.default));
parcelHelpers.export(exports, "WebStoriesOutlined", ()=>(0, _webStoriesOutlinedDefault.default));
parcelHelpers.export(exports, "WebStoriesRounded", ()=>(0, _webStoriesRoundedDefault.default));
parcelHelpers.export(exports, "WebStoriesSharp", ()=>(0, _webStoriesSharpDefault.default));
parcelHelpers.export(exports, "WebStoriesTwoTone", ()=>(0, _webStoriesTwoToneDefault.default));
parcelHelpers.export(exports, "WebTwoTone", ()=>(0, _webTwoToneDefault.default));
parcelHelpers.export(exports, "Webhook", ()=>(0, _webhookDefault.default));
parcelHelpers.export(exports, "WebhookOutlined", ()=>(0, _webhookOutlinedDefault.default));
parcelHelpers.export(exports, "WebhookRounded", ()=>(0, _webhookRoundedDefault.default));
parcelHelpers.export(exports, "WebhookSharp", ()=>(0, _webhookSharpDefault.default));
parcelHelpers.export(exports, "WebhookTwoTone", ()=>(0, _webhookTwoToneDefault.default));
parcelHelpers.export(exports, "Weekend", ()=>(0, _weekendDefault.default));
parcelHelpers.export(exports, "WeekendOutlined", ()=>(0, _weekendOutlinedDefault.default));
parcelHelpers.export(exports, "WeekendRounded", ()=>(0, _weekendRoundedDefault.default));
parcelHelpers.export(exports, "WeekendSharp", ()=>(0, _weekendSharpDefault.default));
parcelHelpers.export(exports, "WeekendTwoTone", ()=>(0, _weekendTwoToneDefault.default));
parcelHelpers.export(exports, "West", ()=>(0, _westDefault.default));
parcelHelpers.export(exports, "WestOutlined", ()=>(0, _westOutlinedDefault.default));
parcelHelpers.export(exports, "WestRounded", ()=>(0, _westRoundedDefault.default));
parcelHelpers.export(exports, "WestSharp", ()=>(0, _westSharpDefault.default));
parcelHelpers.export(exports, "WestTwoTone", ()=>(0, _westTwoToneDefault.default));
parcelHelpers.export(exports, "WhatsApp", ()=>(0, _whatsAppDefault.default));
parcelHelpers.export(exports, "Whatshot", ()=>(0, _whatshotDefault.default));
parcelHelpers.export(exports, "WhatshotOutlined", ()=>(0, _whatshotOutlinedDefault.default));
parcelHelpers.export(exports, "WhatshotRounded", ()=>(0, _whatshotRoundedDefault.default));
parcelHelpers.export(exports, "WhatshotSharp", ()=>(0, _whatshotSharpDefault.default));
parcelHelpers.export(exports, "WhatshotTwoTone", ()=>(0, _whatshotTwoToneDefault.default));
parcelHelpers.export(exports, "WheelchairPickup", ()=>(0, _wheelchairPickupDefault.default));
parcelHelpers.export(exports, "WheelchairPickupOutlined", ()=>(0, _wheelchairPickupOutlinedDefault.default));
parcelHelpers.export(exports, "WheelchairPickupRounded", ()=>(0, _wheelchairPickupRoundedDefault.default));
parcelHelpers.export(exports, "WheelchairPickupSharp", ()=>(0, _wheelchairPickupSharpDefault.default));
parcelHelpers.export(exports, "WheelchairPickupTwoTone", ()=>(0, _wheelchairPickupTwoToneDefault.default));
parcelHelpers.export(exports, "WhereToVote", ()=>(0, _whereToVoteDefault.default));
parcelHelpers.export(exports, "WhereToVoteOutlined", ()=>(0, _whereToVoteOutlinedDefault.default));
parcelHelpers.export(exports, "WhereToVoteRounded", ()=>(0, _whereToVoteRoundedDefault.default));
parcelHelpers.export(exports, "WhereToVoteSharp", ()=>(0, _whereToVoteSharpDefault.default));
parcelHelpers.export(exports, "WhereToVoteTwoTone", ()=>(0, _whereToVoteTwoToneDefault.default));
parcelHelpers.export(exports, "Widgets", ()=>(0, _widgetsDefault.default));
parcelHelpers.export(exports, "WidgetsOutlined", ()=>(0, _widgetsOutlinedDefault.default));
parcelHelpers.export(exports, "WidgetsRounded", ()=>(0, _widgetsRoundedDefault.default));
parcelHelpers.export(exports, "WidgetsSharp", ()=>(0, _widgetsSharpDefault.default));
parcelHelpers.export(exports, "WidgetsTwoTone", ()=>(0, _widgetsTwoToneDefault.default));
parcelHelpers.export(exports, "WidthFull", ()=>(0, _widthFullDefault.default));
parcelHelpers.export(exports, "WidthFullOutlined", ()=>(0, _widthFullOutlinedDefault.default));
parcelHelpers.export(exports, "WidthFullRounded", ()=>(0, _widthFullRoundedDefault.default));
parcelHelpers.export(exports, "WidthFullSharp", ()=>(0, _widthFullSharpDefault.default));
parcelHelpers.export(exports, "WidthFullTwoTone", ()=>(0, _widthFullTwoToneDefault.default));
parcelHelpers.export(exports, "WidthNormal", ()=>(0, _widthNormalDefault.default));
parcelHelpers.export(exports, "WidthNormalOutlined", ()=>(0, _widthNormalOutlinedDefault.default));
parcelHelpers.export(exports, "WidthNormalRounded", ()=>(0, _widthNormalRoundedDefault.default));
parcelHelpers.export(exports, "WidthNormalSharp", ()=>(0, _widthNormalSharpDefault.default));
parcelHelpers.export(exports, "WidthNormalTwoTone", ()=>(0, _widthNormalTwoToneDefault.default));
parcelHelpers.export(exports, "WidthWide", ()=>(0, _widthWideDefault.default));
parcelHelpers.export(exports, "WidthWideOutlined", ()=>(0, _widthWideOutlinedDefault.default));
parcelHelpers.export(exports, "WidthWideRounded", ()=>(0, _widthWideRoundedDefault.default));
parcelHelpers.export(exports, "WidthWideSharp", ()=>(0, _widthWideSharpDefault.default));
parcelHelpers.export(exports, "WidthWideTwoTone", ()=>(0, _widthWideTwoToneDefault.default));
parcelHelpers.export(exports, "Wifi", ()=>(0, _wifiDefault.default));
parcelHelpers.export(exports, "Wifi1Bar", ()=>(0, _wifi1BarDefault.default));
parcelHelpers.export(exports, "Wifi1BarOutlined", ()=>(0, _wifi1BarOutlinedDefault.default));
parcelHelpers.export(exports, "Wifi1BarRounded", ()=>(0, _wifi1BarRoundedDefault.default));
parcelHelpers.export(exports, "Wifi1BarSharp", ()=>(0, _wifi1BarSharpDefault.default));
parcelHelpers.export(exports, "Wifi1BarTwoTone", ()=>(0, _wifi1BarTwoToneDefault.default));
parcelHelpers.export(exports, "Wifi2Bar", ()=>(0, _wifi2BarDefault.default));
parcelHelpers.export(exports, "Wifi2BarOutlined", ()=>(0, _wifi2BarOutlinedDefault.default));
parcelHelpers.export(exports, "Wifi2BarRounded", ()=>(0, _wifi2BarRoundedDefault.default));
parcelHelpers.export(exports, "Wifi2BarSharp", ()=>(0, _wifi2BarSharpDefault.default));
parcelHelpers.export(exports, "Wifi2BarTwoTone", ()=>(0, _wifi2BarTwoToneDefault.default));
parcelHelpers.export(exports, "WifiCalling", ()=>(0, _wifiCallingDefault.default));
parcelHelpers.export(exports, "WifiCalling3", ()=>(0, _wifiCalling3Default.default));
parcelHelpers.export(exports, "WifiCalling3Outlined", ()=>(0, _wifiCalling3OutlinedDefault.default));
parcelHelpers.export(exports, "WifiCalling3Rounded", ()=>(0, _wifiCalling3RoundedDefault.default));
parcelHelpers.export(exports, "WifiCalling3Sharp", ()=>(0, _wifiCalling3SharpDefault.default));
parcelHelpers.export(exports, "WifiCalling3TwoTone", ()=>(0, _wifiCalling3TwoToneDefault.default));
parcelHelpers.export(exports, "WifiCallingOutlined", ()=>(0, _wifiCallingOutlinedDefault.default));
parcelHelpers.export(exports, "WifiCallingRounded", ()=>(0, _wifiCallingRoundedDefault.default));
parcelHelpers.export(exports, "WifiCallingSharp", ()=>(0, _wifiCallingSharpDefault.default));
parcelHelpers.export(exports, "WifiCallingTwoTone", ()=>(0, _wifiCallingTwoToneDefault.default));
parcelHelpers.export(exports, "WifiChannel", ()=>(0, _wifiChannelDefault.default));
parcelHelpers.export(exports, "WifiChannelOutlined", ()=>(0, _wifiChannelOutlinedDefault.default));
parcelHelpers.export(exports, "WifiChannelRounded", ()=>(0, _wifiChannelRoundedDefault.default));
parcelHelpers.export(exports, "WifiChannelSharp", ()=>(0, _wifiChannelSharpDefault.default));
parcelHelpers.export(exports, "WifiChannelTwoTone", ()=>(0, _wifiChannelTwoToneDefault.default));
parcelHelpers.export(exports, "WifiFind", ()=>(0, _wifiFindDefault.default));
parcelHelpers.export(exports, "WifiFindOutlined", ()=>(0, _wifiFindOutlinedDefault.default));
parcelHelpers.export(exports, "WifiFindRounded", ()=>(0, _wifiFindRoundedDefault.default));
parcelHelpers.export(exports, "WifiFindSharp", ()=>(0, _wifiFindSharpDefault.default));
parcelHelpers.export(exports, "WifiFindTwoTone", ()=>(0, _wifiFindTwoToneDefault.default));
parcelHelpers.export(exports, "WifiLock", ()=>(0, _wifiLockDefault.default));
parcelHelpers.export(exports, "WifiLockOutlined", ()=>(0, _wifiLockOutlinedDefault.default));
parcelHelpers.export(exports, "WifiLockRounded", ()=>(0, _wifiLockRoundedDefault.default));
parcelHelpers.export(exports, "WifiLockSharp", ()=>(0, _wifiLockSharpDefault.default));
parcelHelpers.export(exports, "WifiLockTwoTone", ()=>(0, _wifiLockTwoToneDefault.default));
parcelHelpers.export(exports, "WifiOff", ()=>(0, _wifiOffDefault.default));
parcelHelpers.export(exports, "WifiOffOutlined", ()=>(0, _wifiOffOutlinedDefault.default));
parcelHelpers.export(exports, "WifiOffRounded", ()=>(0, _wifiOffRoundedDefault.default));
parcelHelpers.export(exports, "WifiOffSharp", ()=>(0, _wifiOffSharpDefault.default));
parcelHelpers.export(exports, "WifiOffTwoTone", ()=>(0, _wifiOffTwoToneDefault.default));
parcelHelpers.export(exports, "WifiOutlined", ()=>(0, _wifiOutlinedDefault.default));
parcelHelpers.export(exports, "WifiPassword", ()=>(0, _wifiPasswordDefault.default));
parcelHelpers.export(exports, "WifiPasswordOutlined", ()=>(0, _wifiPasswordOutlinedDefault.default));
parcelHelpers.export(exports, "WifiPasswordRounded", ()=>(0, _wifiPasswordRoundedDefault.default));
parcelHelpers.export(exports, "WifiPasswordSharp", ()=>(0, _wifiPasswordSharpDefault.default));
parcelHelpers.export(exports, "WifiPasswordTwoTone", ()=>(0, _wifiPasswordTwoToneDefault.default));
parcelHelpers.export(exports, "WifiProtectedSetup", ()=>(0, _wifiProtectedSetupDefault.default));
parcelHelpers.export(exports, "WifiProtectedSetupOutlined", ()=>(0, _wifiProtectedSetupOutlinedDefault.default));
parcelHelpers.export(exports, "WifiProtectedSetupRounded", ()=>(0, _wifiProtectedSetupRoundedDefault.default));
parcelHelpers.export(exports, "WifiProtectedSetupSharp", ()=>(0, _wifiProtectedSetupSharpDefault.default));
parcelHelpers.export(exports, "WifiProtectedSetupTwoTone", ()=>(0, _wifiProtectedSetupTwoToneDefault.default));
parcelHelpers.export(exports, "WifiRounded", ()=>(0, _wifiRoundedDefault.default));
parcelHelpers.export(exports, "WifiSharp", ()=>(0, _wifiSharpDefault.default));
parcelHelpers.export(exports, "WifiTethering", ()=>(0, _wifiTetheringDefault.default));
parcelHelpers.export(exports, "WifiTetheringError", ()=>(0, _wifiTetheringErrorDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorOutlined", ()=>(0, _wifiTetheringErrorOutlinedDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorRounded", ()=>(0, _wifiTetheringErrorRoundedDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorRoundedOutlined", ()=>(0, _wifiTetheringErrorRoundedOutlinedDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorRoundedRounded", ()=>(0, _wifiTetheringErrorRoundedRoundedDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorRoundedSharp", ()=>(0, _wifiTetheringErrorRoundedSharpDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorRoundedTwoTone", ()=>(0, _wifiTetheringErrorRoundedTwoToneDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorSharp", ()=>(0, _wifiTetheringErrorSharpDefault.default));
parcelHelpers.export(exports, "WifiTetheringErrorTwoTone", ()=>(0, _wifiTetheringErrorTwoToneDefault.default));
parcelHelpers.export(exports, "WifiTetheringOff", ()=>(0, _wifiTetheringOffDefault.default));
parcelHelpers.export(exports, "WifiTetheringOffOutlined", ()=>(0, _wifiTetheringOffOutlinedDefault.default));
parcelHelpers.export(exports, "WifiTetheringOffRounded", ()=>(0, _wifiTetheringOffRoundedDefault.default));
parcelHelpers.export(exports, "WifiTetheringOffSharp", ()=>(0, _wifiTetheringOffSharpDefault.default));
parcelHelpers.export(exports, "WifiTetheringOffTwoTone", ()=>(0, _wifiTetheringOffTwoToneDefault.default));
parcelHelpers.export(exports, "WifiTetheringOutlined", ()=>(0, _wifiTetheringOutlinedDefault.default));
parcelHelpers.export(exports, "WifiTetheringRounded", ()=>(0, _wifiTetheringRoundedDefault.default));
parcelHelpers.export(exports, "WifiTetheringSharp", ()=>(0, _wifiTetheringSharpDefault.default));
parcelHelpers.export(exports, "WifiTetheringTwoTone", ()=>(0, _wifiTetheringTwoToneDefault.default));
parcelHelpers.export(exports, "WifiTwoTone", ()=>(0, _wifiTwoToneDefault.default));
parcelHelpers.export(exports, "WindPower", ()=>(0, _windPowerDefault.default));
parcelHelpers.export(exports, "WindPowerOutlined", ()=>(0, _windPowerOutlinedDefault.default));
parcelHelpers.export(exports, "WindPowerRounded", ()=>(0, _windPowerRoundedDefault.default));
parcelHelpers.export(exports, "WindPowerSharp", ()=>(0, _windPowerSharpDefault.default));
parcelHelpers.export(exports, "WindPowerTwoTone", ()=>(0, _windPowerTwoToneDefault.default));
parcelHelpers.export(exports, "Window", ()=>(0, _windowDefault.default));
parcelHelpers.export(exports, "WindowOutlined", ()=>(0, _windowOutlinedDefault.default));
parcelHelpers.export(exports, "WindowRounded", ()=>(0, _windowRoundedDefault.default));
parcelHelpers.export(exports, "WindowSharp", ()=>(0, _windowSharpDefault.default));
parcelHelpers.export(exports, "WindowTwoTone", ()=>(0, _windowTwoToneDefault.default));
parcelHelpers.export(exports, "WineBar", ()=>(0, _wineBarDefault.default));
parcelHelpers.export(exports, "WineBarOutlined", ()=>(0, _wineBarOutlinedDefault.default));
parcelHelpers.export(exports, "WineBarRounded", ()=>(0, _wineBarRoundedDefault.default));
parcelHelpers.export(exports, "WineBarSharp", ()=>(0, _wineBarSharpDefault.default));
parcelHelpers.export(exports, "WineBarTwoTone", ()=>(0, _wineBarTwoToneDefault.default));
parcelHelpers.export(exports, "Woman", ()=>(0, _womanDefault.default));
parcelHelpers.export(exports, "Woman2", ()=>(0, _woman2Default.default));
parcelHelpers.export(exports, "Woman2Outlined", ()=>(0, _woman2OutlinedDefault.default));
parcelHelpers.export(exports, "Woman2Rounded", ()=>(0, _woman2RoundedDefault.default));
parcelHelpers.export(exports, "Woman2Sharp", ()=>(0, _woman2SharpDefault.default));
parcelHelpers.export(exports, "Woman2TwoTone", ()=>(0, _woman2TwoToneDefault.default));
parcelHelpers.export(exports, "WomanOutlined", ()=>(0, _womanOutlinedDefault.default));
parcelHelpers.export(exports, "WomanRounded", ()=>(0, _womanRoundedDefault.default));
parcelHelpers.export(exports, "WomanSharp", ()=>(0, _womanSharpDefault.default));
parcelHelpers.export(exports, "WomanTwoTone", ()=>(0, _womanTwoToneDefault.default));
parcelHelpers.export(exports, "Work", ()=>(0, _workDefault.default));
parcelHelpers.export(exports, "WorkHistory", ()=>(0, _workHistoryDefault.default));
parcelHelpers.export(exports, "WorkHistoryOutlined", ()=>(0, _workHistoryOutlinedDefault.default));
parcelHelpers.export(exports, "WorkHistoryRounded", ()=>(0, _workHistoryRoundedDefault.default));
parcelHelpers.export(exports, "WorkHistorySharp", ()=>(0, _workHistorySharpDefault.default));
parcelHelpers.export(exports, "WorkHistoryTwoTone", ()=>(0, _workHistoryTwoToneDefault.default));
parcelHelpers.export(exports, "WorkOff", ()=>(0, _workOffDefault.default));
parcelHelpers.export(exports, "WorkOffOutlined", ()=>(0, _workOffOutlinedDefault.default));
parcelHelpers.export(exports, "WorkOffRounded", ()=>(0, _workOffRoundedDefault.default));
parcelHelpers.export(exports, "WorkOffSharp", ()=>(0, _workOffSharpDefault.default));
parcelHelpers.export(exports, "WorkOffTwoTone", ()=>(0, _workOffTwoToneDefault.default));
parcelHelpers.export(exports, "WorkOutline", ()=>(0, _workOutlineDefault.default));
parcelHelpers.export(exports, "WorkOutlineOutlined", ()=>(0, _workOutlineOutlinedDefault.default));
parcelHelpers.export(exports, "WorkOutlineRounded", ()=>(0, _workOutlineRoundedDefault.default));
parcelHelpers.export(exports, "WorkOutlineSharp", ()=>(0, _workOutlineSharpDefault.default));
parcelHelpers.export(exports, "WorkOutlineTwoTone", ()=>(0, _workOutlineTwoToneDefault.default));
parcelHelpers.export(exports, "WorkOutlined", ()=>(0, _workOutlinedDefault.default));
parcelHelpers.export(exports, "WorkRounded", ()=>(0, _workRoundedDefault.default));
parcelHelpers.export(exports, "WorkSharp", ()=>(0, _workSharpDefault.default));
parcelHelpers.export(exports, "WorkTwoTone", ()=>(0, _workTwoToneDefault.default));
parcelHelpers.export(exports, "WorkspacePremium", ()=>(0, _workspacePremiumDefault.default));
parcelHelpers.export(exports, "WorkspacePremiumOutlined", ()=>(0, _workspacePremiumOutlinedDefault.default));
parcelHelpers.export(exports, "WorkspacePremiumRounded", ()=>(0, _workspacePremiumRoundedDefault.default));
parcelHelpers.export(exports, "WorkspacePremiumSharp", ()=>(0, _workspacePremiumSharpDefault.default));
parcelHelpers.export(exports, "WorkspacePremiumTwoTone", ()=>(0, _workspacePremiumTwoToneDefault.default));
parcelHelpers.export(exports, "Workspaces", ()=>(0, _workspacesDefault.default));
parcelHelpers.export(exports, "WorkspacesOutlined", ()=>(0, _workspacesOutlinedDefault.default));
parcelHelpers.export(exports, "WorkspacesRounded", ()=>(0, _workspacesRoundedDefault.default));
parcelHelpers.export(exports, "WorkspacesSharp", ()=>(0, _workspacesSharpDefault.default));
parcelHelpers.export(exports, "WorkspacesTwoTone", ()=>(0, _workspacesTwoToneDefault.default));
parcelHelpers.export(exports, "WrapText", ()=>(0, _wrapTextDefault.default));
parcelHelpers.export(exports, "WrapTextOutlined", ()=>(0, _wrapTextOutlinedDefault.default));
parcelHelpers.export(exports, "WrapTextRounded", ()=>(0, _wrapTextRoundedDefault.default));
parcelHelpers.export(exports, "WrapTextSharp", ()=>(0, _wrapTextSharpDefault.default));
parcelHelpers.export(exports, "WrapTextTwoTone", ()=>(0, _wrapTextTwoToneDefault.default));
parcelHelpers.export(exports, "WrongLocation", ()=>(0, _wrongLocationDefault.default));
parcelHelpers.export(exports, "WrongLocationOutlined", ()=>(0, _wrongLocationOutlinedDefault.default));
parcelHelpers.export(exports, "WrongLocationRounded", ()=>(0, _wrongLocationRoundedDefault.default));
parcelHelpers.export(exports, "WrongLocationSharp", ()=>(0, _wrongLocationSharpDefault.default));
parcelHelpers.export(exports, "WrongLocationTwoTone", ()=>(0, _wrongLocationTwoToneDefault.default));
parcelHelpers.export(exports, "Wysiwyg", ()=>(0, _wysiwygDefault.default));
parcelHelpers.export(exports, "WysiwygOutlined", ()=>(0, _wysiwygOutlinedDefault.default));
parcelHelpers.export(exports, "WysiwygRounded", ()=>(0, _wysiwygRoundedDefault.default));
parcelHelpers.export(exports, "WysiwygSharp", ()=>(0, _wysiwygSharpDefault.default));
parcelHelpers.export(exports, "WysiwygTwoTone", ()=>(0, _wysiwygTwoToneDefault.default));
parcelHelpers.export(exports, "X", ()=>(0, _xDefault.default));
parcelHelpers.export(exports, "Yard", ()=>(0, _yardDefault.default));
parcelHelpers.export(exports, "YardOutlined", ()=>(0, _yardOutlinedDefault.default));
parcelHelpers.export(exports, "YardRounded", ()=>(0, _yardRoundedDefault.default));
parcelHelpers.export(exports, "YardSharp", ()=>(0, _yardSharpDefault.default));
parcelHelpers.export(exports, "YardTwoTone", ()=>(0, _yardTwoToneDefault.default));
parcelHelpers.export(exports, "YouTube", ()=>(0, _youTubeDefault.default));
parcelHelpers.export(exports, "YoutubeSearchedFor", ()=>(0, _youtubeSearchedForDefault.default));
parcelHelpers.export(exports, "YoutubeSearchedForOutlined", ()=>(0, _youtubeSearchedForOutlinedDefault.default));
parcelHelpers.export(exports, "YoutubeSearchedForRounded", ()=>(0, _youtubeSearchedForRoundedDefault.default));
parcelHelpers.export(exports, "YoutubeSearchedForSharp", ()=>(0, _youtubeSearchedForSharpDefault.default));
parcelHelpers.export(exports, "YoutubeSearchedForTwoTone", ()=>(0, _youtubeSearchedForTwoToneDefault.default));
parcelHelpers.export(exports, "ZoomIn", ()=>(0, _zoomInDefault.default));
parcelHelpers.export(exports, "ZoomInMap", ()=>(0, _zoomInMapDefault.default));
parcelHelpers.export(exports, "ZoomInMapOutlined", ()=>(0, _zoomInMapOutlinedDefault.default));
parcelHelpers.export(exports, "ZoomInMapRounded", ()=>(0, _zoomInMapRoundedDefault.default));
parcelHelpers.export(exports, "ZoomInMapSharp", ()=>(0, _zoomInMapSharpDefault.default));
parcelHelpers.export(exports, "ZoomInMapTwoTone", ()=>(0, _zoomInMapTwoToneDefault.default));
parcelHelpers.export(exports, "ZoomInOutlined", ()=>(0, _zoomInOutlinedDefault.default));
parcelHelpers.export(exports, "ZoomInRounded", ()=>(0, _zoomInRoundedDefault.default));
parcelHelpers.export(exports, "ZoomInSharp", ()=>(0, _zoomInSharpDefault.default));
parcelHelpers.export(exports, "ZoomInTwoTone", ()=>(0, _zoomInTwoToneDefault.default));
parcelHelpers.export(exports, "ZoomOut", ()=>(0, _zoomOutDefault.default));
parcelHelpers.export(exports, "ZoomOutMap", ()=>(0, _zoomOutMapDefault.default));
parcelHelpers.export(exports, "ZoomOutMapOutlined", ()=>(0, _zoomOutMapOutlinedDefault.default));
parcelHelpers.export(exports, "ZoomOutMapRounded", ()=>(0, _zoomOutMapRoundedDefault.default));
parcelHelpers.export(exports, "ZoomOutMapSharp", ()=>(0, _zoomOutMapSharpDefault.default));
parcelHelpers.export(exports, "ZoomOutMapTwoTone", ()=>(0, _zoomOutMapTwoToneDefault.default));
parcelHelpers.export(exports, "ZoomOutOutlined", ()=>(0, _zoomOutOutlinedDefault.default));
parcelHelpers.export(exports, "ZoomOutRounded", ()=>(0, _zoomOutRoundedDefault.default));
parcelHelpers.export(exports, "ZoomOutSharp", ()=>(0, _zoomOutSharpDefault.default));
parcelHelpers.export(exports, "ZoomOutTwoTone", ()=>(0, _zoomOutTwoToneDefault.default));
var _abc = require("./Abc");
var _abcDefault = parcelHelpers.interopDefault(_abc);
var _abcOutlined = require("./AbcOutlined");
var _abcOutlinedDefault = parcelHelpers.interopDefault(_abcOutlined);
var _abcRounded = require("./AbcRounded");
var _abcRoundedDefault = parcelHelpers.interopDefault(_abcRounded);
var _abcSharp = require("./AbcSharp");
var _abcSharpDefault = parcelHelpers.interopDefault(_abcSharp);
var _abcTwoTone = require("./AbcTwoTone");
var _abcTwoToneDefault = parcelHelpers.interopDefault(_abcTwoTone);
var _acUnit = require("./AcUnit");
var _acUnitDefault = parcelHelpers.interopDefault(_acUnit);
var _acUnitOutlined = require("./AcUnitOutlined");
var _acUnitOutlinedDefault = parcelHelpers.interopDefault(_acUnitOutlined);
var _acUnitRounded = require("./AcUnitRounded");
var _acUnitRoundedDefault = parcelHelpers.interopDefault(_acUnitRounded);
var _acUnitSharp = require("./AcUnitSharp");
var _acUnitSharpDefault = parcelHelpers.interopDefault(_acUnitSharp);
var _acUnitTwoTone = require("./AcUnitTwoTone");
var _acUnitTwoToneDefault = parcelHelpers.interopDefault(_acUnitTwoTone);
var _accessAlarm = require("./AccessAlarm");
var _accessAlarmDefault = parcelHelpers.interopDefault(_accessAlarm);
var _accessAlarmOutlined = require("./AccessAlarmOutlined");
var _accessAlarmOutlinedDefault = parcelHelpers.interopDefault(_accessAlarmOutlined);
var _accessAlarmRounded = require("./AccessAlarmRounded");
var _accessAlarmRoundedDefault = parcelHelpers.interopDefault(_accessAlarmRounded);
var _accessAlarmSharp = require("./AccessAlarmSharp");
var _accessAlarmSharpDefault = parcelHelpers.interopDefault(_accessAlarmSharp);
var _accessAlarmTwoTone = require("./AccessAlarmTwoTone");
var _accessAlarmTwoToneDefault = parcelHelpers.interopDefault(_accessAlarmTwoTone);
var _accessAlarms = require("./AccessAlarms");
var _accessAlarmsDefault = parcelHelpers.interopDefault(_accessAlarms);
var _accessAlarmsOutlined = require("./AccessAlarmsOutlined");
var _accessAlarmsOutlinedDefault = parcelHelpers.interopDefault(_accessAlarmsOutlined);
var _accessAlarmsRounded = require("./AccessAlarmsRounded");
var _accessAlarmsRoundedDefault = parcelHelpers.interopDefault(_accessAlarmsRounded);
var _accessAlarmsSharp = require("./AccessAlarmsSharp");
var _accessAlarmsSharpDefault = parcelHelpers.interopDefault(_accessAlarmsSharp);
var _accessAlarmsTwoTone = require("./AccessAlarmsTwoTone");
var _accessAlarmsTwoToneDefault = parcelHelpers.interopDefault(_accessAlarmsTwoTone);
var _accessTime = require("./AccessTime");
var _accessTimeDefault = parcelHelpers.interopDefault(_accessTime);
var _accessTimeFilled = require("./AccessTimeFilled");
var _accessTimeFilledDefault = parcelHelpers.interopDefault(_accessTimeFilled);
var _accessTimeFilledOutlined = require("./AccessTimeFilledOutlined");
var _accessTimeFilledOutlinedDefault = parcelHelpers.interopDefault(_accessTimeFilledOutlined);
var _accessTimeFilledRounded = require("./AccessTimeFilledRounded");
var _accessTimeFilledRoundedDefault = parcelHelpers.interopDefault(_accessTimeFilledRounded);
var _accessTimeFilledSharp = require("./AccessTimeFilledSharp");
var _accessTimeFilledSharpDefault = parcelHelpers.interopDefault(_accessTimeFilledSharp);
var _accessTimeFilledTwoTone = require("./AccessTimeFilledTwoTone");
var _accessTimeFilledTwoToneDefault = parcelHelpers.interopDefault(_accessTimeFilledTwoTone);
var _accessTimeOutlined = require("./AccessTimeOutlined");
var _accessTimeOutlinedDefault = parcelHelpers.interopDefault(_accessTimeOutlined);
var _accessTimeRounded = require("./AccessTimeRounded");
var _accessTimeRoundedDefault = parcelHelpers.interopDefault(_accessTimeRounded);
var _accessTimeSharp = require("./AccessTimeSharp");
var _accessTimeSharpDefault = parcelHelpers.interopDefault(_accessTimeSharp);
var _accessTimeTwoTone = require("./AccessTimeTwoTone");
var _accessTimeTwoToneDefault = parcelHelpers.interopDefault(_accessTimeTwoTone);
var _accessibility = require("./Accessibility");
var _accessibilityDefault = parcelHelpers.interopDefault(_accessibility);
var _accessibilityNew = require("./AccessibilityNew");
var _accessibilityNewDefault = parcelHelpers.interopDefault(_accessibilityNew);
var _accessibilityNewOutlined = require("./AccessibilityNewOutlined");
var _accessibilityNewOutlinedDefault = parcelHelpers.interopDefault(_accessibilityNewOutlined);
var _accessibilityNewRounded = require("./AccessibilityNewRounded");
var _accessibilityNewRoundedDefault = parcelHelpers.interopDefault(_accessibilityNewRounded);
var _accessibilityNewSharp = require("./AccessibilityNewSharp");
var _accessibilityNewSharpDefault = parcelHelpers.interopDefault(_accessibilityNewSharp);
var _accessibilityNewTwoTone = require("./AccessibilityNewTwoTone");
var _accessibilityNewTwoToneDefault = parcelHelpers.interopDefault(_accessibilityNewTwoTone);
var _accessibilityOutlined = require("./AccessibilityOutlined");
var _accessibilityOutlinedDefault = parcelHelpers.interopDefault(_accessibilityOutlined);
var _accessibilityRounded = require("./AccessibilityRounded");
var _accessibilityRoundedDefault = parcelHelpers.interopDefault(_accessibilityRounded);
var _accessibilitySharp = require("./AccessibilitySharp");
var _accessibilitySharpDefault = parcelHelpers.interopDefault(_accessibilitySharp);
var _accessibilityTwoTone = require("./AccessibilityTwoTone");
var _accessibilityTwoToneDefault = parcelHelpers.interopDefault(_accessibilityTwoTone);
var _accessible = require("./Accessible");
var _accessibleDefault = parcelHelpers.interopDefault(_accessible);
var _accessibleForward = require("./AccessibleForward");
var _accessibleForwardDefault = parcelHelpers.interopDefault(_accessibleForward);
var _accessibleForwardOutlined = require("./AccessibleForwardOutlined");
var _accessibleForwardOutlinedDefault = parcelHelpers.interopDefault(_accessibleForwardOutlined);
var _accessibleForwardRounded = require("./AccessibleForwardRounded");
var _accessibleForwardRoundedDefault = parcelHelpers.interopDefault(_accessibleForwardRounded);
var _accessibleForwardSharp = require("./AccessibleForwardSharp");
var _accessibleForwardSharpDefault = parcelHelpers.interopDefault(_accessibleForwardSharp);
var _accessibleForwardTwoTone = require("./AccessibleForwardTwoTone");
var _accessibleForwardTwoToneDefault = parcelHelpers.interopDefault(_accessibleForwardTwoTone);
var _accessibleOutlined = require("./AccessibleOutlined");
var _accessibleOutlinedDefault = parcelHelpers.interopDefault(_accessibleOutlined);
var _accessibleRounded = require("./AccessibleRounded");
var _accessibleRoundedDefault = parcelHelpers.interopDefault(_accessibleRounded);
var _accessibleSharp = require("./AccessibleSharp");
var _accessibleSharpDefault = parcelHelpers.interopDefault(_accessibleSharp);
var _accessibleTwoTone = require("./AccessibleTwoTone");
var _accessibleTwoToneDefault = parcelHelpers.interopDefault(_accessibleTwoTone);
var _accountBalance = require("./AccountBalance");
var _accountBalanceDefault = parcelHelpers.interopDefault(_accountBalance);
var _accountBalanceOutlined = require("./AccountBalanceOutlined");
var _accountBalanceOutlinedDefault = parcelHelpers.interopDefault(_accountBalanceOutlined);
var _accountBalanceRounded = require("./AccountBalanceRounded");
var _accountBalanceRoundedDefault = parcelHelpers.interopDefault(_accountBalanceRounded);
var _accountBalanceSharp = require("./AccountBalanceSharp");
var _accountBalanceSharpDefault = parcelHelpers.interopDefault(_accountBalanceSharp);
var _accountBalanceTwoTone = require("./AccountBalanceTwoTone");
var _accountBalanceTwoToneDefault = parcelHelpers.interopDefault(_accountBalanceTwoTone);
var _accountBalanceWallet = require("./AccountBalanceWallet");
var _accountBalanceWalletDefault = parcelHelpers.interopDefault(_accountBalanceWallet);
var _accountBalanceWalletOutlined = require("./AccountBalanceWalletOutlined");
var _accountBalanceWalletOutlinedDefault = parcelHelpers.interopDefault(_accountBalanceWalletOutlined);
var _accountBalanceWalletRounded = require("./AccountBalanceWalletRounded");
var _accountBalanceWalletRoundedDefault = parcelHelpers.interopDefault(_accountBalanceWalletRounded);
var _accountBalanceWalletSharp = require("./AccountBalanceWalletSharp");
var _accountBalanceWalletSharpDefault = parcelHelpers.interopDefault(_accountBalanceWalletSharp);
var _accountBalanceWalletTwoTone = require("./AccountBalanceWalletTwoTone");
var _accountBalanceWalletTwoToneDefault = parcelHelpers.interopDefault(_accountBalanceWalletTwoTone);
var _accountBox = require("./AccountBox");
var _accountBoxDefault = parcelHelpers.interopDefault(_accountBox);
var _accountBoxOutlined = require("./AccountBoxOutlined");
var _accountBoxOutlinedDefault = parcelHelpers.interopDefault(_accountBoxOutlined);
var _accountBoxRounded = require("./AccountBoxRounded");
var _accountBoxRoundedDefault = parcelHelpers.interopDefault(_accountBoxRounded);
var _accountBoxSharp = require("./AccountBoxSharp");
var _accountBoxSharpDefault = parcelHelpers.interopDefault(_accountBoxSharp);
var _accountBoxTwoTone = require("./AccountBoxTwoTone");
var _accountBoxTwoToneDefault = parcelHelpers.interopDefault(_accountBoxTwoTone);
var _accountCircle = require("./AccountCircle");
var _accountCircleDefault = parcelHelpers.interopDefault(_accountCircle);
var _accountCircleOutlined = require("./AccountCircleOutlined");
var _accountCircleOutlinedDefault = parcelHelpers.interopDefault(_accountCircleOutlined);
var _accountCircleRounded = require("./AccountCircleRounded");
var _accountCircleRoundedDefault = parcelHelpers.interopDefault(_accountCircleRounded);
var _accountCircleSharp = require("./AccountCircleSharp");
var _accountCircleSharpDefault = parcelHelpers.interopDefault(_accountCircleSharp);
var _accountCircleTwoTone = require("./AccountCircleTwoTone");
var _accountCircleTwoToneDefault = parcelHelpers.interopDefault(_accountCircleTwoTone);
var _accountTree = require("./AccountTree");
var _accountTreeDefault = parcelHelpers.interopDefault(_accountTree);
var _accountTreeOutlined = require("./AccountTreeOutlined");
var _accountTreeOutlinedDefault = parcelHelpers.interopDefault(_accountTreeOutlined);
var _accountTreeRounded = require("./AccountTreeRounded");
var _accountTreeRoundedDefault = parcelHelpers.interopDefault(_accountTreeRounded);
var _accountTreeSharp = require("./AccountTreeSharp");
var _accountTreeSharpDefault = parcelHelpers.interopDefault(_accountTreeSharp);
var _accountTreeTwoTone = require("./AccountTreeTwoTone");
var _accountTreeTwoToneDefault = parcelHelpers.interopDefault(_accountTreeTwoTone);
var _adUnits = require("./AdUnits");
var _adUnitsDefault = parcelHelpers.interopDefault(_adUnits);
var _adUnitsOutlined = require("./AdUnitsOutlined");
var _adUnitsOutlinedDefault = parcelHelpers.interopDefault(_adUnitsOutlined);
var _adUnitsRounded = require("./AdUnitsRounded");
var _adUnitsRoundedDefault = parcelHelpers.interopDefault(_adUnitsRounded);
var _adUnitsSharp = require("./AdUnitsSharp");
var _adUnitsSharpDefault = parcelHelpers.interopDefault(_adUnitsSharp);
var _adUnitsTwoTone = require("./AdUnitsTwoTone");
var _adUnitsTwoToneDefault = parcelHelpers.interopDefault(_adUnitsTwoTone);
var _adb = require("./Adb");
var _adbDefault = parcelHelpers.interopDefault(_adb);
var _adbOutlined = require("./AdbOutlined");
var _adbOutlinedDefault = parcelHelpers.interopDefault(_adbOutlined);
var _adbRounded = require("./AdbRounded");
var _adbRoundedDefault = parcelHelpers.interopDefault(_adbRounded);
var _adbSharp = require("./AdbSharp");
var _adbSharpDefault = parcelHelpers.interopDefault(_adbSharp);
var _adbTwoTone = require("./AdbTwoTone");
var _adbTwoToneDefault = parcelHelpers.interopDefault(_adbTwoTone);
var _add = require("./Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _addAPhoto = require("./AddAPhoto");
var _addAPhotoDefault = parcelHelpers.interopDefault(_addAPhoto);
var _addAPhotoOutlined = require("./AddAPhotoOutlined");
var _addAPhotoOutlinedDefault = parcelHelpers.interopDefault(_addAPhotoOutlined);
var _addAPhotoRounded = require("./AddAPhotoRounded");
var _addAPhotoRoundedDefault = parcelHelpers.interopDefault(_addAPhotoRounded);
var _addAPhotoSharp = require("./AddAPhotoSharp");
var _addAPhotoSharpDefault = parcelHelpers.interopDefault(_addAPhotoSharp);
var _addAPhotoTwoTone = require("./AddAPhotoTwoTone");
var _addAPhotoTwoToneDefault = parcelHelpers.interopDefault(_addAPhotoTwoTone);
var _addAlarm = require("./AddAlarm");
var _addAlarmDefault = parcelHelpers.interopDefault(_addAlarm);
var _addAlarmOutlined = require("./AddAlarmOutlined");
var _addAlarmOutlinedDefault = parcelHelpers.interopDefault(_addAlarmOutlined);
var _addAlarmRounded = require("./AddAlarmRounded");
var _addAlarmRoundedDefault = parcelHelpers.interopDefault(_addAlarmRounded);
var _addAlarmSharp = require("./AddAlarmSharp");
var _addAlarmSharpDefault = parcelHelpers.interopDefault(_addAlarmSharp);
var _addAlarmTwoTone = require("./AddAlarmTwoTone");
var _addAlarmTwoToneDefault = parcelHelpers.interopDefault(_addAlarmTwoTone);
var _addAlert = require("./AddAlert");
var _addAlertDefault = parcelHelpers.interopDefault(_addAlert);
var _addAlertOutlined = require("./AddAlertOutlined");
var _addAlertOutlinedDefault = parcelHelpers.interopDefault(_addAlertOutlined);
var _addAlertRounded = require("./AddAlertRounded");
var _addAlertRoundedDefault = parcelHelpers.interopDefault(_addAlertRounded);
var _addAlertSharp = require("./AddAlertSharp");
var _addAlertSharpDefault = parcelHelpers.interopDefault(_addAlertSharp);
var _addAlertTwoTone = require("./AddAlertTwoTone");
var _addAlertTwoToneDefault = parcelHelpers.interopDefault(_addAlertTwoTone);
var _addBox = require("./AddBox");
var _addBoxDefault = parcelHelpers.interopDefault(_addBox);
var _addBoxOutlined = require("./AddBoxOutlined");
var _addBoxOutlinedDefault = parcelHelpers.interopDefault(_addBoxOutlined);
var _addBoxRounded = require("./AddBoxRounded");
var _addBoxRoundedDefault = parcelHelpers.interopDefault(_addBoxRounded);
var _addBoxSharp = require("./AddBoxSharp");
var _addBoxSharpDefault = parcelHelpers.interopDefault(_addBoxSharp);
var _addBoxTwoTone = require("./AddBoxTwoTone");
var _addBoxTwoToneDefault = parcelHelpers.interopDefault(_addBoxTwoTone);
var _addBusiness = require("./AddBusiness");
var _addBusinessDefault = parcelHelpers.interopDefault(_addBusiness);
var _addBusinessOutlined = require("./AddBusinessOutlined");
var _addBusinessOutlinedDefault = parcelHelpers.interopDefault(_addBusinessOutlined);
var _addBusinessRounded = require("./AddBusinessRounded");
var _addBusinessRoundedDefault = parcelHelpers.interopDefault(_addBusinessRounded);
var _addBusinessSharp = require("./AddBusinessSharp");
var _addBusinessSharpDefault = parcelHelpers.interopDefault(_addBusinessSharp);
var _addBusinessTwoTone = require("./AddBusinessTwoTone");
var _addBusinessTwoToneDefault = parcelHelpers.interopDefault(_addBusinessTwoTone);
var _addCard = require("./AddCard");
var _addCardDefault = parcelHelpers.interopDefault(_addCard);
var _addCardOutlined = require("./AddCardOutlined");
var _addCardOutlinedDefault = parcelHelpers.interopDefault(_addCardOutlined);
var _addCardRounded = require("./AddCardRounded");
var _addCardRoundedDefault = parcelHelpers.interopDefault(_addCardRounded);
var _addCardSharp = require("./AddCardSharp");
var _addCardSharpDefault = parcelHelpers.interopDefault(_addCardSharp);
var _addCardTwoTone = require("./AddCardTwoTone");
var _addCardTwoToneDefault = parcelHelpers.interopDefault(_addCardTwoTone);
var _addCircle = require("./AddCircle");
var _addCircleDefault = parcelHelpers.interopDefault(_addCircle);
var _addCircleOutline = require("./AddCircleOutline");
var _addCircleOutlineDefault = parcelHelpers.interopDefault(_addCircleOutline);
var _addCircleOutlineOutlined = require("./AddCircleOutlineOutlined");
var _addCircleOutlineOutlinedDefault = parcelHelpers.interopDefault(_addCircleOutlineOutlined);
var _addCircleOutlineRounded = require("./AddCircleOutlineRounded");
var _addCircleOutlineRoundedDefault = parcelHelpers.interopDefault(_addCircleOutlineRounded);
var _addCircleOutlineSharp = require("./AddCircleOutlineSharp");
var _addCircleOutlineSharpDefault = parcelHelpers.interopDefault(_addCircleOutlineSharp);
var _addCircleOutlineTwoTone = require("./AddCircleOutlineTwoTone");
var _addCircleOutlineTwoToneDefault = parcelHelpers.interopDefault(_addCircleOutlineTwoTone);
var _addCircleOutlined = require("./AddCircleOutlined");
var _addCircleOutlinedDefault = parcelHelpers.interopDefault(_addCircleOutlined);
var _addCircleRounded = require("./AddCircleRounded");
var _addCircleRoundedDefault = parcelHelpers.interopDefault(_addCircleRounded);
var _addCircleSharp = require("./AddCircleSharp");
var _addCircleSharpDefault = parcelHelpers.interopDefault(_addCircleSharp);
var _addCircleTwoTone = require("./AddCircleTwoTone");
var _addCircleTwoToneDefault = parcelHelpers.interopDefault(_addCircleTwoTone);
var _addComment = require("./AddComment");
var _addCommentDefault = parcelHelpers.interopDefault(_addComment);
var _addCommentOutlined = require("./AddCommentOutlined");
var _addCommentOutlinedDefault = parcelHelpers.interopDefault(_addCommentOutlined);
var _addCommentRounded = require("./AddCommentRounded");
var _addCommentRoundedDefault = parcelHelpers.interopDefault(_addCommentRounded);
var _addCommentSharp = require("./AddCommentSharp");
var _addCommentSharpDefault = parcelHelpers.interopDefault(_addCommentSharp);
var _addCommentTwoTone = require("./AddCommentTwoTone");
var _addCommentTwoToneDefault = parcelHelpers.interopDefault(_addCommentTwoTone);
var _addHome = require("./AddHome");
var _addHomeDefault = parcelHelpers.interopDefault(_addHome);
var _addHomeOutlined = require("./AddHomeOutlined");
var _addHomeOutlinedDefault = parcelHelpers.interopDefault(_addHomeOutlined);
var _addHomeRounded = require("./AddHomeRounded");
var _addHomeRoundedDefault = parcelHelpers.interopDefault(_addHomeRounded);
var _addHomeSharp = require("./AddHomeSharp");
var _addHomeSharpDefault = parcelHelpers.interopDefault(_addHomeSharp);
var _addHomeTwoTone = require("./AddHomeTwoTone");
var _addHomeTwoToneDefault = parcelHelpers.interopDefault(_addHomeTwoTone);
var _addHomeWork = require("./AddHomeWork");
var _addHomeWorkDefault = parcelHelpers.interopDefault(_addHomeWork);
var _addHomeWorkOutlined = require("./AddHomeWorkOutlined");
var _addHomeWorkOutlinedDefault = parcelHelpers.interopDefault(_addHomeWorkOutlined);
var _addHomeWorkRounded = require("./AddHomeWorkRounded");
var _addHomeWorkRoundedDefault = parcelHelpers.interopDefault(_addHomeWorkRounded);
var _addHomeWorkSharp = require("./AddHomeWorkSharp");
var _addHomeWorkSharpDefault = parcelHelpers.interopDefault(_addHomeWorkSharp);
var _addHomeWorkTwoTone = require("./AddHomeWorkTwoTone");
var _addHomeWorkTwoToneDefault = parcelHelpers.interopDefault(_addHomeWorkTwoTone);
var _addIcCall = require("./AddIcCall");
var _addIcCallDefault = parcelHelpers.interopDefault(_addIcCall);
var _addIcCallOutlined = require("./AddIcCallOutlined");
var _addIcCallOutlinedDefault = parcelHelpers.interopDefault(_addIcCallOutlined);
var _addIcCallRounded = require("./AddIcCallRounded");
var _addIcCallRoundedDefault = parcelHelpers.interopDefault(_addIcCallRounded);
var _addIcCallSharp = require("./AddIcCallSharp");
var _addIcCallSharpDefault = parcelHelpers.interopDefault(_addIcCallSharp);
var _addIcCallTwoTone = require("./AddIcCallTwoTone");
var _addIcCallTwoToneDefault = parcelHelpers.interopDefault(_addIcCallTwoTone);
var _addLink = require("./AddLink");
var _addLinkDefault = parcelHelpers.interopDefault(_addLink);
var _addLinkOutlined = require("./AddLinkOutlined");
var _addLinkOutlinedDefault = parcelHelpers.interopDefault(_addLinkOutlined);
var _addLinkRounded = require("./AddLinkRounded");
var _addLinkRoundedDefault = parcelHelpers.interopDefault(_addLinkRounded);
var _addLinkSharp = require("./AddLinkSharp");
var _addLinkSharpDefault = parcelHelpers.interopDefault(_addLinkSharp);
var _addLinkTwoTone = require("./AddLinkTwoTone");
var _addLinkTwoToneDefault = parcelHelpers.interopDefault(_addLinkTwoTone);
var _addLocation = require("./AddLocation");
var _addLocationDefault = parcelHelpers.interopDefault(_addLocation);
var _addLocationAlt = require("./AddLocationAlt");
var _addLocationAltDefault = parcelHelpers.interopDefault(_addLocationAlt);
var _addLocationAltOutlined = require("./AddLocationAltOutlined");
var _addLocationAltOutlinedDefault = parcelHelpers.interopDefault(_addLocationAltOutlined);
var _addLocationAltRounded = require("./AddLocationAltRounded");
var _addLocationAltRoundedDefault = parcelHelpers.interopDefault(_addLocationAltRounded);
var _addLocationAltSharp = require("./AddLocationAltSharp");
var _addLocationAltSharpDefault = parcelHelpers.interopDefault(_addLocationAltSharp);
var _addLocationAltTwoTone = require("./AddLocationAltTwoTone");
var _addLocationAltTwoToneDefault = parcelHelpers.interopDefault(_addLocationAltTwoTone);
var _addLocationOutlined = require("./AddLocationOutlined");
var _addLocationOutlinedDefault = parcelHelpers.interopDefault(_addLocationOutlined);
var _addLocationRounded = require("./AddLocationRounded");
var _addLocationRoundedDefault = parcelHelpers.interopDefault(_addLocationRounded);
var _addLocationSharp = require("./AddLocationSharp");
var _addLocationSharpDefault = parcelHelpers.interopDefault(_addLocationSharp);
var _addLocationTwoTone = require("./AddLocationTwoTone");
var _addLocationTwoToneDefault = parcelHelpers.interopDefault(_addLocationTwoTone);
var _addModerator = require("./AddModerator");
var _addModeratorDefault = parcelHelpers.interopDefault(_addModerator);
var _addModeratorOutlined = require("./AddModeratorOutlined");
var _addModeratorOutlinedDefault = parcelHelpers.interopDefault(_addModeratorOutlined);
var _addModeratorRounded = require("./AddModeratorRounded");
var _addModeratorRoundedDefault = parcelHelpers.interopDefault(_addModeratorRounded);
var _addModeratorSharp = require("./AddModeratorSharp");
var _addModeratorSharpDefault = parcelHelpers.interopDefault(_addModeratorSharp);
var _addModeratorTwoTone = require("./AddModeratorTwoTone");
var _addModeratorTwoToneDefault = parcelHelpers.interopDefault(_addModeratorTwoTone);
var _addOutlined = require("./AddOutlined");
var _addOutlinedDefault = parcelHelpers.interopDefault(_addOutlined);
var _addPhotoAlternate = require("./AddPhotoAlternate");
var _addPhotoAlternateDefault = parcelHelpers.interopDefault(_addPhotoAlternate);
var _addPhotoAlternateOutlined = require("./AddPhotoAlternateOutlined");
var _addPhotoAlternateOutlinedDefault = parcelHelpers.interopDefault(_addPhotoAlternateOutlined);
var _addPhotoAlternateRounded = require("./AddPhotoAlternateRounded");
var _addPhotoAlternateRoundedDefault = parcelHelpers.interopDefault(_addPhotoAlternateRounded);
var _addPhotoAlternateSharp = require("./AddPhotoAlternateSharp");
var _addPhotoAlternateSharpDefault = parcelHelpers.interopDefault(_addPhotoAlternateSharp);
var _addPhotoAlternateTwoTone = require("./AddPhotoAlternateTwoTone");
var _addPhotoAlternateTwoToneDefault = parcelHelpers.interopDefault(_addPhotoAlternateTwoTone);
var _addReaction = require("./AddReaction");
var _addReactionDefault = parcelHelpers.interopDefault(_addReaction);
var _addReactionOutlined = require("./AddReactionOutlined");
var _addReactionOutlinedDefault = parcelHelpers.interopDefault(_addReactionOutlined);
var _addReactionRounded = require("./AddReactionRounded");
var _addReactionRoundedDefault = parcelHelpers.interopDefault(_addReactionRounded);
var _addReactionSharp = require("./AddReactionSharp");
var _addReactionSharpDefault = parcelHelpers.interopDefault(_addReactionSharp);
var _addReactionTwoTone = require("./AddReactionTwoTone");
var _addReactionTwoToneDefault = parcelHelpers.interopDefault(_addReactionTwoTone);
var _addRoad = require("./AddRoad");
var _addRoadDefault = parcelHelpers.interopDefault(_addRoad);
var _addRoadOutlined = require("./AddRoadOutlined");
var _addRoadOutlinedDefault = parcelHelpers.interopDefault(_addRoadOutlined);
var _addRoadRounded = require("./AddRoadRounded");
var _addRoadRoundedDefault = parcelHelpers.interopDefault(_addRoadRounded);
var _addRoadSharp = require("./AddRoadSharp");
var _addRoadSharpDefault = parcelHelpers.interopDefault(_addRoadSharp);
var _addRoadTwoTone = require("./AddRoadTwoTone");
var _addRoadTwoToneDefault = parcelHelpers.interopDefault(_addRoadTwoTone);
var _addRounded = require("./AddRounded");
var _addRoundedDefault = parcelHelpers.interopDefault(_addRounded);
var _addSharp = require("./AddSharp");
var _addSharpDefault = parcelHelpers.interopDefault(_addSharp);
var _addShoppingCart = require("./AddShoppingCart");
var _addShoppingCartDefault = parcelHelpers.interopDefault(_addShoppingCart);
var _addShoppingCartOutlined = require("./AddShoppingCartOutlined");
var _addShoppingCartOutlinedDefault = parcelHelpers.interopDefault(_addShoppingCartOutlined);
var _addShoppingCartRounded = require("./AddShoppingCartRounded");
var _addShoppingCartRoundedDefault = parcelHelpers.interopDefault(_addShoppingCartRounded);
var _addShoppingCartSharp = require("./AddShoppingCartSharp");
var _addShoppingCartSharpDefault = parcelHelpers.interopDefault(_addShoppingCartSharp);
var _addShoppingCartTwoTone = require("./AddShoppingCartTwoTone");
var _addShoppingCartTwoToneDefault = parcelHelpers.interopDefault(_addShoppingCartTwoTone);
var _addTask = require("./AddTask");
var _addTaskDefault = parcelHelpers.interopDefault(_addTask);
var _addTaskOutlined = require("./AddTaskOutlined");
var _addTaskOutlinedDefault = parcelHelpers.interopDefault(_addTaskOutlined);
var _addTaskRounded = require("./AddTaskRounded");
var _addTaskRoundedDefault = parcelHelpers.interopDefault(_addTaskRounded);
var _addTaskSharp = require("./AddTaskSharp");
var _addTaskSharpDefault = parcelHelpers.interopDefault(_addTaskSharp);
var _addTaskTwoTone = require("./AddTaskTwoTone");
var _addTaskTwoToneDefault = parcelHelpers.interopDefault(_addTaskTwoTone);
var _addToDrive = require("./AddToDrive");
var _addToDriveDefault = parcelHelpers.interopDefault(_addToDrive);
var _addToDriveOutlined = require("./AddToDriveOutlined");
var _addToDriveOutlinedDefault = parcelHelpers.interopDefault(_addToDriveOutlined);
var _addToDriveRounded = require("./AddToDriveRounded");
var _addToDriveRoundedDefault = parcelHelpers.interopDefault(_addToDriveRounded);
var _addToDriveSharp = require("./AddToDriveSharp");
var _addToDriveSharpDefault = parcelHelpers.interopDefault(_addToDriveSharp);
var _addToDriveTwoTone = require("./AddToDriveTwoTone");
var _addToDriveTwoToneDefault = parcelHelpers.interopDefault(_addToDriveTwoTone);
var _addToHomeScreen = require("./AddToHomeScreen");
var _addToHomeScreenDefault = parcelHelpers.interopDefault(_addToHomeScreen);
var _addToHomeScreenOutlined = require("./AddToHomeScreenOutlined");
var _addToHomeScreenOutlinedDefault = parcelHelpers.interopDefault(_addToHomeScreenOutlined);
var _addToHomeScreenRounded = require("./AddToHomeScreenRounded");
var _addToHomeScreenRoundedDefault = parcelHelpers.interopDefault(_addToHomeScreenRounded);
var _addToHomeScreenSharp = require("./AddToHomeScreenSharp");
var _addToHomeScreenSharpDefault = parcelHelpers.interopDefault(_addToHomeScreenSharp);
var _addToHomeScreenTwoTone = require("./AddToHomeScreenTwoTone");
var _addToHomeScreenTwoToneDefault = parcelHelpers.interopDefault(_addToHomeScreenTwoTone);
var _addToPhotos = require("./AddToPhotos");
var _addToPhotosDefault = parcelHelpers.interopDefault(_addToPhotos);
var _addToPhotosOutlined = require("./AddToPhotosOutlined");
var _addToPhotosOutlinedDefault = parcelHelpers.interopDefault(_addToPhotosOutlined);
var _addToPhotosRounded = require("./AddToPhotosRounded");
var _addToPhotosRoundedDefault = parcelHelpers.interopDefault(_addToPhotosRounded);
var _addToPhotosSharp = require("./AddToPhotosSharp");
var _addToPhotosSharpDefault = parcelHelpers.interopDefault(_addToPhotosSharp);
var _addToPhotosTwoTone = require("./AddToPhotosTwoTone");
var _addToPhotosTwoToneDefault = parcelHelpers.interopDefault(_addToPhotosTwoTone);
var _addToQueue = require("./AddToQueue");
var _addToQueueDefault = parcelHelpers.interopDefault(_addToQueue);
var _addToQueueOutlined = require("./AddToQueueOutlined");
var _addToQueueOutlinedDefault = parcelHelpers.interopDefault(_addToQueueOutlined);
var _addToQueueRounded = require("./AddToQueueRounded");
var _addToQueueRoundedDefault = parcelHelpers.interopDefault(_addToQueueRounded);
var _addToQueueSharp = require("./AddToQueueSharp");
var _addToQueueSharpDefault = parcelHelpers.interopDefault(_addToQueueSharp);
var _addToQueueTwoTone = require("./AddToQueueTwoTone");
var _addToQueueTwoToneDefault = parcelHelpers.interopDefault(_addToQueueTwoTone);
var _addTwoTone = require("./AddTwoTone");
var _addTwoToneDefault = parcelHelpers.interopDefault(_addTwoTone);
var _addchart = require("./Addchart");
var _addchartDefault = parcelHelpers.interopDefault(_addchart);
var _addchartOutlined = require("./AddchartOutlined");
var _addchartOutlinedDefault = parcelHelpers.interopDefault(_addchartOutlined);
var _addchartRounded = require("./AddchartRounded");
var _addchartRoundedDefault = parcelHelpers.interopDefault(_addchartRounded);
var _addchartSharp = require("./AddchartSharp");
var _addchartSharpDefault = parcelHelpers.interopDefault(_addchartSharp);
var _addchartTwoTone = require("./AddchartTwoTone");
var _addchartTwoToneDefault = parcelHelpers.interopDefault(_addchartTwoTone);
var _adfScanner = require("./AdfScanner");
var _adfScannerDefault = parcelHelpers.interopDefault(_adfScanner);
var _adfScannerOutlined = require("./AdfScannerOutlined");
var _adfScannerOutlinedDefault = parcelHelpers.interopDefault(_adfScannerOutlined);
var _adfScannerRounded = require("./AdfScannerRounded");
var _adfScannerRoundedDefault = parcelHelpers.interopDefault(_adfScannerRounded);
var _adfScannerSharp = require("./AdfScannerSharp");
var _adfScannerSharpDefault = parcelHelpers.interopDefault(_adfScannerSharp);
var _adfScannerTwoTone = require("./AdfScannerTwoTone");
var _adfScannerTwoToneDefault = parcelHelpers.interopDefault(_adfScannerTwoTone);
var _adjust = require("./Adjust");
var _adjustDefault = parcelHelpers.interopDefault(_adjust);
var _adjustOutlined = require("./AdjustOutlined");
var _adjustOutlinedDefault = parcelHelpers.interopDefault(_adjustOutlined);
var _adjustRounded = require("./AdjustRounded");
var _adjustRoundedDefault = parcelHelpers.interopDefault(_adjustRounded);
var _adjustSharp = require("./AdjustSharp");
var _adjustSharpDefault = parcelHelpers.interopDefault(_adjustSharp);
var _adjustTwoTone = require("./AdjustTwoTone");
var _adjustTwoToneDefault = parcelHelpers.interopDefault(_adjustTwoTone);
var _adminPanelSettings = require("./AdminPanelSettings");
var _adminPanelSettingsDefault = parcelHelpers.interopDefault(_adminPanelSettings);
var _adminPanelSettingsOutlined = require("./AdminPanelSettingsOutlined");
var _adminPanelSettingsOutlinedDefault = parcelHelpers.interopDefault(_adminPanelSettingsOutlined);
var _adminPanelSettingsRounded = require("./AdminPanelSettingsRounded");
var _adminPanelSettingsRoundedDefault = parcelHelpers.interopDefault(_adminPanelSettingsRounded);
var _adminPanelSettingsSharp = require("./AdminPanelSettingsSharp");
var _adminPanelSettingsSharpDefault = parcelHelpers.interopDefault(_adminPanelSettingsSharp);
var _adminPanelSettingsTwoTone = require("./AdminPanelSettingsTwoTone");
var _adminPanelSettingsTwoToneDefault = parcelHelpers.interopDefault(_adminPanelSettingsTwoTone);
var _adsClick = require("./AdsClick");
var _adsClickDefault = parcelHelpers.interopDefault(_adsClick);
var _adsClickOutlined = require("./AdsClickOutlined");
var _adsClickOutlinedDefault = parcelHelpers.interopDefault(_adsClickOutlined);
var _adsClickRounded = require("./AdsClickRounded");
var _adsClickRoundedDefault = parcelHelpers.interopDefault(_adsClickRounded);
var _adsClickSharp = require("./AdsClickSharp");
var _adsClickSharpDefault = parcelHelpers.interopDefault(_adsClickSharp);
var _adsClickTwoTone = require("./AdsClickTwoTone");
var _adsClickTwoToneDefault = parcelHelpers.interopDefault(_adsClickTwoTone);
var _agriculture = require("./Agriculture");
var _agricultureDefault = parcelHelpers.interopDefault(_agriculture);
var _agricultureOutlined = require("./AgricultureOutlined");
var _agricultureOutlinedDefault = parcelHelpers.interopDefault(_agricultureOutlined);
var _agricultureRounded = require("./AgricultureRounded");
var _agricultureRoundedDefault = parcelHelpers.interopDefault(_agricultureRounded);
var _agricultureSharp = require("./AgricultureSharp");
var _agricultureSharpDefault = parcelHelpers.interopDefault(_agricultureSharp);
var _agricultureTwoTone = require("./AgricultureTwoTone");
var _agricultureTwoToneDefault = parcelHelpers.interopDefault(_agricultureTwoTone);
var _air = require("./Air");
var _airDefault = parcelHelpers.interopDefault(_air);
var _airOutlined = require("./AirOutlined");
var _airOutlinedDefault = parcelHelpers.interopDefault(_airOutlined);
var _airRounded = require("./AirRounded");
var _airRoundedDefault = parcelHelpers.interopDefault(_airRounded);
var _airSharp = require("./AirSharp");
var _airSharpDefault = parcelHelpers.interopDefault(_airSharp);
var _airTwoTone = require("./AirTwoTone");
var _airTwoToneDefault = parcelHelpers.interopDefault(_airTwoTone);
var _airlineSeatFlat = require("./AirlineSeatFlat");
var _airlineSeatFlatDefault = parcelHelpers.interopDefault(_airlineSeatFlat);
var _airlineSeatFlatAngled = require("./AirlineSeatFlatAngled");
var _airlineSeatFlatAngledDefault = parcelHelpers.interopDefault(_airlineSeatFlatAngled);
var _airlineSeatFlatAngledOutlined = require("./AirlineSeatFlatAngledOutlined");
var _airlineSeatFlatAngledOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatFlatAngledOutlined);
var _airlineSeatFlatAngledRounded = require("./AirlineSeatFlatAngledRounded");
var _airlineSeatFlatAngledRoundedDefault = parcelHelpers.interopDefault(_airlineSeatFlatAngledRounded);
var _airlineSeatFlatAngledSharp = require("./AirlineSeatFlatAngledSharp");
var _airlineSeatFlatAngledSharpDefault = parcelHelpers.interopDefault(_airlineSeatFlatAngledSharp);
var _airlineSeatFlatAngledTwoTone = require("./AirlineSeatFlatAngledTwoTone");
var _airlineSeatFlatAngledTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatFlatAngledTwoTone);
var _airlineSeatFlatOutlined = require("./AirlineSeatFlatOutlined");
var _airlineSeatFlatOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatFlatOutlined);
var _airlineSeatFlatRounded = require("./AirlineSeatFlatRounded");
var _airlineSeatFlatRoundedDefault = parcelHelpers.interopDefault(_airlineSeatFlatRounded);
var _airlineSeatFlatSharp = require("./AirlineSeatFlatSharp");
var _airlineSeatFlatSharpDefault = parcelHelpers.interopDefault(_airlineSeatFlatSharp);
var _airlineSeatFlatTwoTone = require("./AirlineSeatFlatTwoTone");
var _airlineSeatFlatTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatFlatTwoTone);
var _airlineSeatIndividualSuite = require("./AirlineSeatIndividualSuite");
var _airlineSeatIndividualSuiteDefault = parcelHelpers.interopDefault(_airlineSeatIndividualSuite);
var _airlineSeatIndividualSuiteOutlined = require("./AirlineSeatIndividualSuiteOutlined");
var _airlineSeatIndividualSuiteOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatIndividualSuiteOutlined);
var _airlineSeatIndividualSuiteRounded = require("./AirlineSeatIndividualSuiteRounded");
var _airlineSeatIndividualSuiteRoundedDefault = parcelHelpers.interopDefault(_airlineSeatIndividualSuiteRounded);
var _airlineSeatIndividualSuiteSharp = require("./AirlineSeatIndividualSuiteSharp");
var _airlineSeatIndividualSuiteSharpDefault = parcelHelpers.interopDefault(_airlineSeatIndividualSuiteSharp);
var _airlineSeatIndividualSuiteTwoTone = require("./AirlineSeatIndividualSuiteTwoTone");
var _airlineSeatIndividualSuiteTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatIndividualSuiteTwoTone);
var _airlineSeatLegroomExtra = require("./AirlineSeatLegroomExtra");
var _airlineSeatLegroomExtraDefault = parcelHelpers.interopDefault(_airlineSeatLegroomExtra);
var _airlineSeatLegroomExtraOutlined = require("./AirlineSeatLegroomExtraOutlined");
var _airlineSeatLegroomExtraOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomExtraOutlined);
var _airlineSeatLegroomExtraRounded = require("./AirlineSeatLegroomExtraRounded");
var _airlineSeatLegroomExtraRoundedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomExtraRounded);
var _airlineSeatLegroomExtraSharp = require("./AirlineSeatLegroomExtraSharp");
var _airlineSeatLegroomExtraSharpDefault = parcelHelpers.interopDefault(_airlineSeatLegroomExtraSharp);
var _airlineSeatLegroomExtraTwoTone = require("./AirlineSeatLegroomExtraTwoTone");
var _airlineSeatLegroomExtraTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatLegroomExtraTwoTone);
var _airlineSeatLegroomNormal = require("./AirlineSeatLegroomNormal");
var _airlineSeatLegroomNormalDefault = parcelHelpers.interopDefault(_airlineSeatLegroomNormal);
var _airlineSeatLegroomNormalOutlined = require("./AirlineSeatLegroomNormalOutlined");
var _airlineSeatLegroomNormalOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomNormalOutlined);
var _airlineSeatLegroomNormalRounded = require("./AirlineSeatLegroomNormalRounded");
var _airlineSeatLegroomNormalRoundedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomNormalRounded);
var _airlineSeatLegroomNormalSharp = require("./AirlineSeatLegroomNormalSharp");
var _airlineSeatLegroomNormalSharpDefault = parcelHelpers.interopDefault(_airlineSeatLegroomNormalSharp);
var _airlineSeatLegroomNormalTwoTone = require("./AirlineSeatLegroomNormalTwoTone");
var _airlineSeatLegroomNormalTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatLegroomNormalTwoTone);
var _airlineSeatLegroomReduced = require("./AirlineSeatLegroomReduced");
var _airlineSeatLegroomReducedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomReduced);
var _airlineSeatLegroomReducedOutlined = require("./AirlineSeatLegroomReducedOutlined");
var _airlineSeatLegroomReducedOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomReducedOutlined);
var _airlineSeatLegroomReducedRounded = require("./AirlineSeatLegroomReducedRounded");
var _airlineSeatLegroomReducedRoundedDefault = parcelHelpers.interopDefault(_airlineSeatLegroomReducedRounded);
var _airlineSeatLegroomReducedSharp = require("./AirlineSeatLegroomReducedSharp");
var _airlineSeatLegroomReducedSharpDefault = parcelHelpers.interopDefault(_airlineSeatLegroomReducedSharp);
var _airlineSeatLegroomReducedTwoTone = require("./AirlineSeatLegroomReducedTwoTone");
var _airlineSeatLegroomReducedTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatLegroomReducedTwoTone);
var _airlineSeatReclineExtra = require("./AirlineSeatReclineExtra");
var _airlineSeatReclineExtraDefault = parcelHelpers.interopDefault(_airlineSeatReclineExtra);
var _airlineSeatReclineExtraOutlined = require("./AirlineSeatReclineExtraOutlined");
var _airlineSeatReclineExtraOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatReclineExtraOutlined);
var _airlineSeatReclineExtraRounded = require("./AirlineSeatReclineExtraRounded");
var _airlineSeatReclineExtraRoundedDefault = parcelHelpers.interopDefault(_airlineSeatReclineExtraRounded);
var _airlineSeatReclineExtraSharp = require("./AirlineSeatReclineExtraSharp");
var _airlineSeatReclineExtraSharpDefault = parcelHelpers.interopDefault(_airlineSeatReclineExtraSharp);
var _airlineSeatReclineExtraTwoTone = require("./AirlineSeatReclineExtraTwoTone");
var _airlineSeatReclineExtraTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatReclineExtraTwoTone);
var _airlineSeatReclineNormal = require("./AirlineSeatReclineNormal");
var _airlineSeatReclineNormalDefault = parcelHelpers.interopDefault(_airlineSeatReclineNormal);
var _airlineSeatReclineNormalOutlined = require("./AirlineSeatReclineNormalOutlined");
var _airlineSeatReclineNormalOutlinedDefault = parcelHelpers.interopDefault(_airlineSeatReclineNormalOutlined);
var _airlineSeatReclineNormalRounded = require("./AirlineSeatReclineNormalRounded");
var _airlineSeatReclineNormalRoundedDefault = parcelHelpers.interopDefault(_airlineSeatReclineNormalRounded);
var _airlineSeatReclineNormalSharp = require("./AirlineSeatReclineNormalSharp");
var _airlineSeatReclineNormalSharpDefault = parcelHelpers.interopDefault(_airlineSeatReclineNormalSharp);
var _airlineSeatReclineNormalTwoTone = require("./AirlineSeatReclineNormalTwoTone");
var _airlineSeatReclineNormalTwoToneDefault = parcelHelpers.interopDefault(_airlineSeatReclineNormalTwoTone);
var _airlineStops = require("./AirlineStops");
var _airlineStopsDefault = parcelHelpers.interopDefault(_airlineStops);
var _airlineStopsOutlined = require("./AirlineStopsOutlined");
var _airlineStopsOutlinedDefault = parcelHelpers.interopDefault(_airlineStopsOutlined);
var _airlineStopsRounded = require("./AirlineStopsRounded");
var _airlineStopsRoundedDefault = parcelHelpers.interopDefault(_airlineStopsRounded);
var _airlineStopsSharp = require("./AirlineStopsSharp");
var _airlineStopsSharpDefault = parcelHelpers.interopDefault(_airlineStopsSharp);
var _airlineStopsTwoTone = require("./AirlineStopsTwoTone");
var _airlineStopsTwoToneDefault = parcelHelpers.interopDefault(_airlineStopsTwoTone);
var _airlines = require("./Airlines");
var _airlinesDefault = parcelHelpers.interopDefault(_airlines);
var _airlinesOutlined = require("./AirlinesOutlined");
var _airlinesOutlinedDefault = parcelHelpers.interopDefault(_airlinesOutlined);
var _airlinesRounded = require("./AirlinesRounded");
var _airlinesRoundedDefault = parcelHelpers.interopDefault(_airlinesRounded);
var _airlinesSharp = require("./AirlinesSharp");
var _airlinesSharpDefault = parcelHelpers.interopDefault(_airlinesSharp);
var _airlinesTwoTone = require("./AirlinesTwoTone");
var _airlinesTwoToneDefault = parcelHelpers.interopDefault(_airlinesTwoTone);
var _airplaneTicket = require("./AirplaneTicket");
var _airplaneTicketDefault = parcelHelpers.interopDefault(_airplaneTicket);
var _airplaneTicketOutlined = require("./AirplaneTicketOutlined");
var _airplaneTicketOutlinedDefault = parcelHelpers.interopDefault(_airplaneTicketOutlined);
var _airplaneTicketRounded = require("./AirplaneTicketRounded");
var _airplaneTicketRoundedDefault = parcelHelpers.interopDefault(_airplaneTicketRounded);
var _airplaneTicketSharp = require("./AirplaneTicketSharp");
var _airplaneTicketSharpDefault = parcelHelpers.interopDefault(_airplaneTicketSharp);
var _airplaneTicketTwoTone = require("./AirplaneTicketTwoTone");
var _airplaneTicketTwoToneDefault = parcelHelpers.interopDefault(_airplaneTicketTwoTone);
var _airplanemodeActive = require("./AirplanemodeActive");
var _airplanemodeActiveDefault = parcelHelpers.interopDefault(_airplanemodeActive);
var _airplanemodeActiveOutlined = require("./AirplanemodeActiveOutlined");
var _airplanemodeActiveOutlinedDefault = parcelHelpers.interopDefault(_airplanemodeActiveOutlined);
var _airplanemodeActiveRounded = require("./AirplanemodeActiveRounded");
var _airplanemodeActiveRoundedDefault = parcelHelpers.interopDefault(_airplanemodeActiveRounded);
var _airplanemodeActiveSharp = require("./AirplanemodeActiveSharp");
var _airplanemodeActiveSharpDefault = parcelHelpers.interopDefault(_airplanemodeActiveSharp);
var _airplanemodeActiveTwoTone = require("./AirplanemodeActiveTwoTone");
var _airplanemodeActiveTwoToneDefault = parcelHelpers.interopDefault(_airplanemodeActiveTwoTone);
var _airplanemodeInactive = require("./AirplanemodeInactive");
var _airplanemodeInactiveDefault = parcelHelpers.interopDefault(_airplanemodeInactive);
var _airplanemodeInactiveOutlined = require("./AirplanemodeInactiveOutlined");
var _airplanemodeInactiveOutlinedDefault = parcelHelpers.interopDefault(_airplanemodeInactiveOutlined);
var _airplanemodeInactiveRounded = require("./AirplanemodeInactiveRounded");
var _airplanemodeInactiveRoundedDefault = parcelHelpers.interopDefault(_airplanemodeInactiveRounded);
var _airplanemodeInactiveSharp = require("./AirplanemodeInactiveSharp");
var _airplanemodeInactiveSharpDefault = parcelHelpers.interopDefault(_airplanemodeInactiveSharp);
var _airplanemodeInactiveTwoTone = require("./AirplanemodeInactiveTwoTone");
var _airplanemodeInactiveTwoToneDefault = parcelHelpers.interopDefault(_airplanemodeInactiveTwoTone);
var _airplay = require("./Airplay");
var _airplayDefault = parcelHelpers.interopDefault(_airplay);
var _airplayOutlined = require("./AirplayOutlined");
var _airplayOutlinedDefault = parcelHelpers.interopDefault(_airplayOutlined);
var _airplayRounded = require("./AirplayRounded");
var _airplayRoundedDefault = parcelHelpers.interopDefault(_airplayRounded);
var _airplaySharp = require("./AirplaySharp");
var _airplaySharpDefault = parcelHelpers.interopDefault(_airplaySharp);
var _airplayTwoTone = require("./AirplayTwoTone");
var _airplayTwoToneDefault = parcelHelpers.interopDefault(_airplayTwoTone);
var _airportShuttle = require("./AirportShuttle");
var _airportShuttleDefault = parcelHelpers.interopDefault(_airportShuttle);
var _airportShuttleOutlined = require("./AirportShuttleOutlined");
var _airportShuttleOutlinedDefault = parcelHelpers.interopDefault(_airportShuttleOutlined);
var _airportShuttleRounded = require("./AirportShuttleRounded");
var _airportShuttleRoundedDefault = parcelHelpers.interopDefault(_airportShuttleRounded);
var _airportShuttleSharp = require("./AirportShuttleSharp");
var _airportShuttleSharpDefault = parcelHelpers.interopDefault(_airportShuttleSharp);
var _airportShuttleTwoTone = require("./AirportShuttleTwoTone");
var _airportShuttleTwoToneDefault = parcelHelpers.interopDefault(_airportShuttleTwoTone);
var _alarm = require("./Alarm");
var _alarmDefault = parcelHelpers.interopDefault(_alarm);
var _alarmAdd = require("./AlarmAdd");
var _alarmAddDefault = parcelHelpers.interopDefault(_alarmAdd);
var _alarmAddOutlined = require("./AlarmAddOutlined");
var _alarmAddOutlinedDefault = parcelHelpers.interopDefault(_alarmAddOutlined);
var _alarmAddRounded = require("./AlarmAddRounded");
var _alarmAddRoundedDefault = parcelHelpers.interopDefault(_alarmAddRounded);
var _alarmAddSharp = require("./AlarmAddSharp");
var _alarmAddSharpDefault = parcelHelpers.interopDefault(_alarmAddSharp);
var _alarmAddTwoTone = require("./AlarmAddTwoTone");
var _alarmAddTwoToneDefault = parcelHelpers.interopDefault(_alarmAddTwoTone);
var _alarmOff = require("./AlarmOff");
var _alarmOffDefault = parcelHelpers.interopDefault(_alarmOff);
var _alarmOffOutlined = require("./AlarmOffOutlined");
var _alarmOffOutlinedDefault = parcelHelpers.interopDefault(_alarmOffOutlined);
var _alarmOffRounded = require("./AlarmOffRounded");
var _alarmOffRoundedDefault = parcelHelpers.interopDefault(_alarmOffRounded);
var _alarmOffSharp = require("./AlarmOffSharp");
var _alarmOffSharpDefault = parcelHelpers.interopDefault(_alarmOffSharp);
var _alarmOffTwoTone = require("./AlarmOffTwoTone");
var _alarmOffTwoToneDefault = parcelHelpers.interopDefault(_alarmOffTwoTone);
var _alarmOn = require("./AlarmOn");
var _alarmOnDefault = parcelHelpers.interopDefault(_alarmOn);
var _alarmOnOutlined = require("./AlarmOnOutlined");
var _alarmOnOutlinedDefault = parcelHelpers.interopDefault(_alarmOnOutlined);
var _alarmOnRounded = require("./AlarmOnRounded");
var _alarmOnRoundedDefault = parcelHelpers.interopDefault(_alarmOnRounded);
var _alarmOnSharp = require("./AlarmOnSharp");
var _alarmOnSharpDefault = parcelHelpers.interopDefault(_alarmOnSharp);
var _alarmOnTwoTone = require("./AlarmOnTwoTone");
var _alarmOnTwoToneDefault = parcelHelpers.interopDefault(_alarmOnTwoTone);
var _alarmOutlined = require("./AlarmOutlined");
var _alarmOutlinedDefault = parcelHelpers.interopDefault(_alarmOutlined);
var _alarmRounded = require("./AlarmRounded");
var _alarmRoundedDefault = parcelHelpers.interopDefault(_alarmRounded);
var _alarmSharp = require("./AlarmSharp");
var _alarmSharpDefault = parcelHelpers.interopDefault(_alarmSharp);
var _alarmTwoTone = require("./AlarmTwoTone");
var _alarmTwoToneDefault = parcelHelpers.interopDefault(_alarmTwoTone);
var _album = require("./Album");
var _albumDefault = parcelHelpers.interopDefault(_album);
var _albumOutlined = require("./AlbumOutlined");
var _albumOutlinedDefault = parcelHelpers.interopDefault(_albumOutlined);
var _albumRounded = require("./AlbumRounded");
var _albumRoundedDefault = parcelHelpers.interopDefault(_albumRounded);
var _albumSharp = require("./AlbumSharp");
var _albumSharpDefault = parcelHelpers.interopDefault(_albumSharp);
var _albumTwoTone = require("./AlbumTwoTone");
var _albumTwoToneDefault = parcelHelpers.interopDefault(_albumTwoTone);
var _alignHorizontalCenter = require("./AlignHorizontalCenter");
var _alignHorizontalCenterDefault = parcelHelpers.interopDefault(_alignHorizontalCenter);
var _alignHorizontalCenterOutlined = require("./AlignHorizontalCenterOutlined");
var _alignHorizontalCenterOutlinedDefault = parcelHelpers.interopDefault(_alignHorizontalCenterOutlined);
var _alignHorizontalCenterRounded = require("./AlignHorizontalCenterRounded");
var _alignHorizontalCenterRoundedDefault = parcelHelpers.interopDefault(_alignHorizontalCenterRounded);
var _alignHorizontalCenterSharp = require("./AlignHorizontalCenterSharp");
var _alignHorizontalCenterSharpDefault = parcelHelpers.interopDefault(_alignHorizontalCenterSharp);
var _alignHorizontalCenterTwoTone = require("./AlignHorizontalCenterTwoTone");
var _alignHorizontalCenterTwoToneDefault = parcelHelpers.interopDefault(_alignHorizontalCenterTwoTone);
var _alignHorizontalLeft = require("./AlignHorizontalLeft");
var _alignHorizontalLeftDefault = parcelHelpers.interopDefault(_alignHorizontalLeft);
var _alignHorizontalLeftOutlined = require("./AlignHorizontalLeftOutlined");
var _alignHorizontalLeftOutlinedDefault = parcelHelpers.interopDefault(_alignHorizontalLeftOutlined);
var _alignHorizontalLeftRounded = require("./AlignHorizontalLeftRounded");
var _alignHorizontalLeftRoundedDefault = parcelHelpers.interopDefault(_alignHorizontalLeftRounded);
var _alignHorizontalLeftSharp = require("./AlignHorizontalLeftSharp");
var _alignHorizontalLeftSharpDefault = parcelHelpers.interopDefault(_alignHorizontalLeftSharp);
var _alignHorizontalLeftTwoTone = require("./AlignHorizontalLeftTwoTone");
var _alignHorizontalLeftTwoToneDefault = parcelHelpers.interopDefault(_alignHorizontalLeftTwoTone);
var _alignHorizontalRight = require("./AlignHorizontalRight");
var _alignHorizontalRightDefault = parcelHelpers.interopDefault(_alignHorizontalRight);
var _alignHorizontalRightOutlined = require("./AlignHorizontalRightOutlined");
var _alignHorizontalRightOutlinedDefault = parcelHelpers.interopDefault(_alignHorizontalRightOutlined);
var _alignHorizontalRightRounded = require("./AlignHorizontalRightRounded");
var _alignHorizontalRightRoundedDefault = parcelHelpers.interopDefault(_alignHorizontalRightRounded);
var _alignHorizontalRightSharp = require("./AlignHorizontalRightSharp");
var _alignHorizontalRightSharpDefault = parcelHelpers.interopDefault(_alignHorizontalRightSharp);
var _alignHorizontalRightTwoTone = require("./AlignHorizontalRightTwoTone");
var _alignHorizontalRightTwoToneDefault = parcelHelpers.interopDefault(_alignHorizontalRightTwoTone);
var _alignVerticalBottom = require("./AlignVerticalBottom");
var _alignVerticalBottomDefault = parcelHelpers.interopDefault(_alignVerticalBottom);
var _alignVerticalBottomOutlined = require("./AlignVerticalBottomOutlined");
var _alignVerticalBottomOutlinedDefault = parcelHelpers.interopDefault(_alignVerticalBottomOutlined);
var _alignVerticalBottomRounded = require("./AlignVerticalBottomRounded");
var _alignVerticalBottomRoundedDefault = parcelHelpers.interopDefault(_alignVerticalBottomRounded);
var _alignVerticalBottomSharp = require("./AlignVerticalBottomSharp");
var _alignVerticalBottomSharpDefault = parcelHelpers.interopDefault(_alignVerticalBottomSharp);
var _alignVerticalBottomTwoTone = require("./AlignVerticalBottomTwoTone");
var _alignVerticalBottomTwoToneDefault = parcelHelpers.interopDefault(_alignVerticalBottomTwoTone);
var _alignVerticalCenter = require("./AlignVerticalCenter");
var _alignVerticalCenterDefault = parcelHelpers.interopDefault(_alignVerticalCenter);
var _alignVerticalCenterOutlined = require("./AlignVerticalCenterOutlined");
var _alignVerticalCenterOutlinedDefault = parcelHelpers.interopDefault(_alignVerticalCenterOutlined);
var _alignVerticalCenterRounded = require("./AlignVerticalCenterRounded");
var _alignVerticalCenterRoundedDefault = parcelHelpers.interopDefault(_alignVerticalCenterRounded);
var _alignVerticalCenterSharp = require("./AlignVerticalCenterSharp");
var _alignVerticalCenterSharpDefault = parcelHelpers.interopDefault(_alignVerticalCenterSharp);
var _alignVerticalCenterTwoTone = require("./AlignVerticalCenterTwoTone");
var _alignVerticalCenterTwoToneDefault = parcelHelpers.interopDefault(_alignVerticalCenterTwoTone);
var _alignVerticalTop = require("./AlignVerticalTop");
var _alignVerticalTopDefault = parcelHelpers.interopDefault(_alignVerticalTop);
var _alignVerticalTopOutlined = require("./AlignVerticalTopOutlined");
var _alignVerticalTopOutlinedDefault = parcelHelpers.interopDefault(_alignVerticalTopOutlined);
var _alignVerticalTopRounded = require("./AlignVerticalTopRounded");
var _alignVerticalTopRoundedDefault = parcelHelpers.interopDefault(_alignVerticalTopRounded);
var _alignVerticalTopSharp = require("./AlignVerticalTopSharp");
var _alignVerticalTopSharpDefault = parcelHelpers.interopDefault(_alignVerticalTopSharp);
var _alignVerticalTopTwoTone = require("./AlignVerticalTopTwoTone");
var _alignVerticalTopTwoToneDefault = parcelHelpers.interopDefault(_alignVerticalTopTwoTone);
var _allInbox = require("./AllInbox");
var _allInboxDefault = parcelHelpers.interopDefault(_allInbox);
var _allInboxOutlined = require("./AllInboxOutlined");
var _allInboxOutlinedDefault = parcelHelpers.interopDefault(_allInboxOutlined);
var _allInboxRounded = require("./AllInboxRounded");
var _allInboxRoundedDefault = parcelHelpers.interopDefault(_allInboxRounded);
var _allInboxSharp = require("./AllInboxSharp");
var _allInboxSharpDefault = parcelHelpers.interopDefault(_allInboxSharp);
var _allInboxTwoTone = require("./AllInboxTwoTone");
var _allInboxTwoToneDefault = parcelHelpers.interopDefault(_allInboxTwoTone);
var _allInclusive = require("./AllInclusive");
var _allInclusiveDefault = parcelHelpers.interopDefault(_allInclusive);
var _allInclusiveOutlined = require("./AllInclusiveOutlined");
var _allInclusiveOutlinedDefault = parcelHelpers.interopDefault(_allInclusiveOutlined);
var _allInclusiveRounded = require("./AllInclusiveRounded");
var _allInclusiveRoundedDefault = parcelHelpers.interopDefault(_allInclusiveRounded);
var _allInclusiveSharp = require("./AllInclusiveSharp");
var _allInclusiveSharpDefault = parcelHelpers.interopDefault(_allInclusiveSharp);
var _allInclusiveTwoTone = require("./AllInclusiveTwoTone");
var _allInclusiveTwoToneDefault = parcelHelpers.interopDefault(_allInclusiveTwoTone);
var _allOut = require("./AllOut");
var _allOutDefault = parcelHelpers.interopDefault(_allOut);
var _allOutOutlined = require("./AllOutOutlined");
var _allOutOutlinedDefault = parcelHelpers.interopDefault(_allOutOutlined);
var _allOutRounded = require("./AllOutRounded");
var _allOutRoundedDefault = parcelHelpers.interopDefault(_allOutRounded);
var _allOutSharp = require("./AllOutSharp");
var _allOutSharpDefault = parcelHelpers.interopDefault(_allOutSharp);
var _allOutTwoTone = require("./AllOutTwoTone");
var _allOutTwoToneDefault = parcelHelpers.interopDefault(_allOutTwoTone);
var _altRoute = require("./AltRoute");
var _altRouteDefault = parcelHelpers.interopDefault(_altRoute);
var _altRouteOutlined = require("./AltRouteOutlined");
var _altRouteOutlinedDefault = parcelHelpers.interopDefault(_altRouteOutlined);
var _altRouteRounded = require("./AltRouteRounded");
var _altRouteRoundedDefault = parcelHelpers.interopDefault(_altRouteRounded);
var _altRouteSharp = require("./AltRouteSharp");
var _altRouteSharpDefault = parcelHelpers.interopDefault(_altRouteSharp);
var _altRouteTwoTone = require("./AltRouteTwoTone");
var _altRouteTwoToneDefault = parcelHelpers.interopDefault(_altRouteTwoTone);
var _alternateEmail = require("./AlternateEmail");
var _alternateEmailDefault = parcelHelpers.interopDefault(_alternateEmail);
var _alternateEmailOutlined = require("./AlternateEmailOutlined");
var _alternateEmailOutlinedDefault = parcelHelpers.interopDefault(_alternateEmailOutlined);
var _alternateEmailRounded = require("./AlternateEmailRounded");
var _alternateEmailRoundedDefault = parcelHelpers.interopDefault(_alternateEmailRounded);
var _alternateEmailSharp = require("./AlternateEmailSharp");
var _alternateEmailSharpDefault = parcelHelpers.interopDefault(_alternateEmailSharp);
var _alternateEmailTwoTone = require("./AlternateEmailTwoTone");
var _alternateEmailTwoToneDefault = parcelHelpers.interopDefault(_alternateEmailTwoTone);
var _analytics = require("./Analytics");
var _analyticsDefault = parcelHelpers.interopDefault(_analytics);
var _analyticsOutlined = require("./AnalyticsOutlined");
var _analyticsOutlinedDefault = parcelHelpers.interopDefault(_analyticsOutlined);
var _analyticsRounded = require("./AnalyticsRounded");
var _analyticsRoundedDefault = parcelHelpers.interopDefault(_analyticsRounded);
var _analyticsSharp = require("./AnalyticsSharp");
var _analyticsSharpDefault = parcelHelpers.interopDefault(_analyticsSharp);
var _analyticsTwoTone = require("./AnalyticsTwoTone");
var _analyticsTwoToneDefault = parcelHelpers.interopDefault(_analyticsTwoTone);
var _anchor = require("./Anchor");
var _anchorDefault = parcelHelpers.interopDefault(_anchor);
var _anchorOutlined = require("./AnchorOutlined");
var _anchorOutlinedDefault = parcelHelpers.interopDefault(_anchorOutlined);
var _anchorRounded = require("./AnchorRounded");
var _anchorRoundedDefault = parcelHelpers.interopDefault(_anchorRounded);
var _anchorSharp = require("./AnchorSharp");
var _anchorSharpDefault = parcelHelpers.interopDefault(_anchorSharp);
var _anchorTwoTone = require("./AnchorTwoTone");
var _anchorTwoToneDefault = parcelHelpers.interopDefault(_anchorTwoTone);
var _android = require("./Android");
var _androidDefault = parcelHelpers.interopDefault(_android);
var _androidOutlined = require("./AndroidOutlined");
var _androidOutlinedDefault = parcelHelpers.interopDefault(_androidOutlined);
var _androidRounded = require("./AndroidRounded");
var _androidRoundedDefault = parcelHelpers.interopDefault(_androidRounded);
var _androidSharp = require("./AndroidSharp");
var _androidSharpDefault = parcelHelpers.interopDefault(_androidSharp);
var _androidTwoTone = require("./AndroidTwoTone");
var _androidTwoToneDefault = parcelHelpers.interopDefault(_androidTwoTone);
var _animation = require("./Animation");
var _animationDefault = parcelHelpers.interopDefault(_animation);
var _animationOutlined = require("./AnimationOutlined");
var _animationOutlinedDefault = parcelHelpers.interopDefault(_animationOutlined);
var _animationRounded = require("./AnimationRounded");
var _animationRoundedDefault = parcelHelpers.interopDefault(_animationRounded);
var _animationSharp = require("./AnimationSharp");
var _animationSharpDefault = parcelHelpers.interopDefault(_animationSharp);
var _animationTwoTone = require("./AnimationTwoTone");
var _animationTwoToneDefault = parcelHelpers.interopDefault(_animationTwoTone);
var _announcement = require("./Announcement");
var _announcementDefault = parcelHelpers.interopDefault(_announcement);
var _announcementOutlined = require("./AnnouncementOutlined");
var _announcementOutlinedDefault = parcelHelpers.interopDefault(_announcementOutlined);
var _announcementRounded = require("./AnnouncementRounded");
var _announcementRoundedDefault = parcelHelpers.interopDefault(_announcementRounded);
var _announcementSharp = require("./AnnouncementSharp");
var _announcementSharpDefault = parcelHelpers.interopDefault(_announcementSharp);
var _announcementTwoTone = require("./AnnouncementTwoTone");
var _announcementTwoToneDefault = parcelHelpers.interopDefault(_announcementTwoTone);
var _aod = require("./Aod");
var _aodDefault = parcelHelpers.interopDefault(_aod);
var _aodOutlined = require("./AodOutlined");
var _aodOutlinedDefault = parcelHelpers.interopDefault(_aodOutlined);
var _aodRounded = require("./AodRounded");
var _aodRoundedDefault = parcelHelpers.interopDefault(_aodRounded);
var _aodSharp = require("./AodSharp");
var _aodSharpDefault = parcelHelpers.interopDefault(_aodSharp);
var _aodTwoTone = require("./AodTwoTone");
var _aodTwoToneDefault = parcelHelpers.interopDefault(_aodTwoTone);
var _apartment = require("./Apartment");
var _apartmentDefault = parcelHelpers.interopDefault(_apartment);
var _apartmentOutlined = require("./ApartmentOutlined");
var _apartmentOutlinedDefault = parcelHelpers.interopDefault(_apartmentOutlined);
var _apartmentRounded = require("./ApartmentRounded");
var _apartmentRoundedDefault = parcelHelpers.interopDefault(_apartmentRounded);
var _apartmentSharp = require("./ApartmentSharp");
var _apartmentSharpDefault = parcelHelpers.interopDefault(_apartmentSharp);
var _apartmentTwoTone = require("./ApartmentTwoTone");
var _apartmentTwoToneDefault = parcelHelpers.interopDefault(_apartmentTwoTone);
var _api = require("./Api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _apiOutlined = require("./ApiOutlined");
var _apiOutlinedDefault = parcelHelpers.interopDefault(_apiOutlined);
var _apiRounded = require("./ApiRounded");
var _apiRoundedDefault = parcelHelpers.interopDefault(_apiRounded);
var _apiSharp = require("./ApiSharp");
var _apiSharpDefault = parcelHelpers.interopDefault(_apiSharp);
var _apiTwoTone = require("./ApiTwoTone");
var _apiTwoToneDefault = parcelHelpers.interopDefault(_apiTwoTone);
var _appBlocking = require("./AppBlocking");
var _appBlockingDefault = parcelHelpers.interopDefault(_appBlocking);
var _appBlockingOutlined = require("./AppBlockingOutlined");
var _appBlockingOutlinedDefault = parcelHelpers.interopDefault(_appBlockingOutlined);
var _appBlockingRounded = require("./AppBlockingRounded");
var _appBlockingRoundedDefault = parcelHelpers.interopDefault(_appBlockingRounded);
var _appBlockingSharp = require("./AppBlockingSharp");
var _appBlockingSharpDefault = parcelHelpers.interopDefault(_appBlockingSharp);
var _appBlockingTwoTone = require("./AppBlockingTwoTone");
var _appBlockingTwoToneDefault = parcelHelpers.interopDefault(_appBlockingTwoTone);
var _appRegistration = require("./AppRegistration");
var _appRegistrationDefault = parcelHelpers.interopDefault(_appRegistration);
var _appRegistrationOutlined = require("./AppRegistrationOutlined");
var _appRegistrationOutlinedDefault = parcelHelpers.interopDefault(_appRegistrationOutlined);
var _appRegistrationRounded = require("./AppRegistrationRounded");
var _appRegistrationRoundedDefault = parcelHelpers.interopDefault(_appRegistrationRounded);
var _appRegistrationSharp = require("./AppRegistrationSharp");
var _appRegistrationSharpDefault = parcelHelpers.interopDefault(_appRegistrationSharp);
var _appRegistrationTwoTone = require("./AppRegistrationTwoTone");
var _appRegistrationTwoToneDefault = parcelHelpers.interopDefault(_appRegistrationTwoTone);
var _appSettingsAlt = require("./AppSettingsAlt");
var _appSettingsAltDefault = parcelHelpers.interopDefault(_appSettingsAlt);
var _appSettingsAltOutlined = require("./AppSettingsAltOutlined");
var _appSettingsAltOutlinedDefault = parcelHelpers.interopDefault(_appSettingsAltOutlined);
var _appSettingsAltRounded = require("./AppSettingsAltRounded");
var _appSettingsAltRoundedDefault = parcelHelpers.interopDefault(_appSettingsAltRounded);
var _appSettingsAltSharp = require("./AppSettingsAltSharp");
var _appSettingsAltSharpDefault = parcelHelpers.interopDefault(_appSettingsAltSharp);
var _appSettingsAltTwoTone = require("./AppSettingsAltTwoTone");
var _appSettingsAltTwoToneDefault = parcelHelpers.interopDefault(_appSettingsAltTwoTone);
var _appShortcut = require("./AppShortcut");
var _appShortcutDefault = parcelHelpers.interopDefault(_appShortcut);
var _appShortcutOutlined = require("./AppShortcutOutlined");
var _appShortcutOutlinedDefault = parcelHelpers.interopDefault(_appShortcutOutlined);
var _appShortcutRounded = require("./AppShortcutRounded");
var _appShortcutRoundedDefault = parcelHelpers.interopDefault(_appShortcutRounded);
var _appShortcutSharp = require("./AppShortcutSharp");
var _appShortcutSharpDefault = parcelHelpers.interopDefault(_appShortcutSharp);
var _appShortcutTwoTone = require("./AppShortcutTwoTone");
var _appShortcutTwoToneDefault = parcelHelpers.interopDefault(_appShortcutTwoTone);
var _apple = require("./Apple");
var _appleDefault = parcelHelpers.interopDefault(_apple);
var _approval = require("./Approval");
var _approvalDefault = parcelHelpers.interopDefault(_approval);
var _approvalOutlined = require("./ApprovalOutlined");
var _approvalOutlinedDefault = parcelHelpers.interopDefault(_approvalOutlined);
var _approvalRounded = require("./ApprovalRounded");
var _approvalRoundedDefault = parcelHelpers.interopDefault(_approvalRounded);
var _approvalSharp = require("./ApprovalSharp");
var _approvalSharpDefault = parcelHelpers.interopDefault(_approvalSharp);
var _approvalTwoTone = require("./ApprovalTwoTone");
var _approvalTwoToneDefault = parcelHelpers.interopDefault(_approvalTwoTone);
var _apps = require("./Apps");
var _appsDefault = parcelHelpers.interopDefault(_apps);
var _appsOutage = require("./AppsOutage");
var _appsOutageDefault = parcelHelpers.interopDefault(_appsOutage);
var _appsOutageOutlined = require("./AppsOutageOutlined");
var _appsOutageOutlinedDefault = parcelHelpers.interopDefault(_appsOutageOutlined);
var _appsOutageRounded = require("./AppsOutageRounded");
var _appsOutageRoundedDefault = parcelHelpers.interopDefault(_appsOutageRounded);
var _appsOutageSharp = require("./AppsOutageSharp");
var _appsOutageSharpDefault = parcelHelpers.interopDefault(_appsOutageSharp);
var _appsOutageTwoTone = require("./AppsOutageTwoTone");
var _appsOutageTwoToneDefault = parcelHelpers.interopDefault(_appsOutageTwoTone);
var _appsOutlined = require("./AppsOutlined");
var _appsOutlinedDefault = parcelHelpers.interopDefault(_appsOutlined);
var _appsRounded = require("./AppsRounded");
var _appsRoundedDefault = parcelHelpers.interopDefault(_appsRounded);
var _appsSharp = require("./AppsSharp");
var _appsSharpDefault = parcelHelpers.interopDefault(_appsSharp);
var _appsTwoTone = require("./AppsTwoTone");
var _appsTwoToneDefault = parcelHelpers.interopDefault(_appsTwoTone);
var _architecture = require("./Architecture");
var _architectureDefault = parcelHelpers.interopDefault(_architecture);
var _architectureOutlined = require("./ArchitectureOutlined");
var _architectureOutlinedDefault = parcelHelpers.interopDefault(_architectureOutlined);
var _architectureRounded = require("./ArchitectureRounded");
var _architectureRoundedDefault = parcelHelpers.interopDefault(_architectureRounded);
var _architectureSharp = require("./ArchitectureSharp");
var _architectureSharpDefault = parcelHelpers.interopDefault(_architectureSharp);
var _architectureTwoTone = require("./ArchitectureTwoTone");
var _architectureTwoToneDefault = parcelHelpers.interopDefault(_architectureTwoTone);
var _archive = require("./Archive");
var _archiveDefault = parcelHelpers.interopDefault(_archive);
var _archiveOutlined = require("./ArchiveOutlined");
var _archiveOutlinedDefault = parcelHelpers.interopDefault(_archiveOutlined);
var _archiveRounded = require("./ArchiveRounded");
var _archiveRoundedDefault = parcelHelpers.interopDefault(_archiveRounded);
var _archiveSharp = require("./ArchiveSharp");
var _archiveSharpDefault = parcelHelpers.interopDefault(_archiveSharp);
var _archiveTwoTone = require("./ArchiveTwoTone");
var _archiveTwoToneDefault = parcelHelpers.interopDefault(_archiveTwoTone);
var _arrowBack = require("./ArrowBack");
var _arrowBackDefault = parcelHelpers.interopDefault(_arrowBack);
var _arrowBackIos = require("./ArrowBackIos");
var _arrowBackIosDefault = parcelHelpers.interopDefault(_arrowBackIos);
var _arrowBackIosNew = require("./ArrowBackIosNew");
var _arrowBackIosNewDefault = parcelHelpers.interopDefault(_arrowBackIosNew);
var _arrowBackIosNewOutlined = require("./ArrowBackIosNewOutlined");
var _arrowBackIosNewOutlinedDefault = parcelHelpers.interopDefault(_arrowBackIosNewOutlined);
var _arrowBackIosNewRounded = require("./ArrowBackIosNewRounded");
var _arrowBackIosNewRoundedDefault = parcelHelpers.interopDefault(_arrowBackIosNewRounded);
var _arrowBackIosNewSharp = require("./ArrowBackIosNewSharp");
var _arrowBackIosNewSharpDefault = parcelHelpers.interopDefault(_arrowBackIosNewSharp);
var _arrowBackIosNewTwoTone = require("./ArrowBackIosNewTwoTone");
var _arrowBackIosNewTwoToneDefault = parcelHelpers.interopDefault(_arrowBackIosNewTwoTone);
var _arrowBackIosOutlined = require("./ArrowBackIosOutlined");
var _arrowBackIosOutlinedDefault = parcelHelpers.interopDefault(_arrowBackIosOutlined);
var _arrowBackIosRounded = require("./ArrowBackIosRounded");
var _arrowBackIosRoundedDefault = parcelHelpers.interopDefault(_arrowBackIosRounded);
var _arrowBackIosSharp = require("./ArrowBackIosSharp");
var _arrowBackIosSharpDefault = parcelHelpers.interopDefault(_arrowBackIosSharp);
var _arrowBackIosTwoTone = require("./ArrowBackIosTwoTone");
var _arrowBackIosTwoToneDefault = parcelHelpers.interopDefault(_arrowBackIosTwoTone);
var _arrowBackOutlined = require("./ArrowBackOutlined");
var _arrowBackOutlinedDefault = parcelHelpers.interopDefault(_arrowBackOutlined);
var _arrowBackRounded = require("./ArrowBackRounded");
var _arrowBackRoundedDefault = parcelHelpers.interopDefault(_arrowBackRounded);
var _arrowBackSharp = require("./ArrowBackSharp");
var _arrowBackSharpDefault = parcelHelpers.interopDefault(_arrowBackSharp);
var _arrowBackTwoTone = require("./ArrowBackTwoTone");
var _arrowBackTwoToneDefault = parcelHelpers.interopDefault(_arrowBackTwoTone);
var _arrowCircleDown = require("./ArrowCircleDown");
var _arrowCircleDownDefault = parcelHelpers.interopDefault(_arrowCircleDown);
var _arrowCircleDownOutlined = require("./ArrowCircleDownOutlined");
var _arrowCircleDownOutlinedDefault = parcelHelpers.interopDefault(_arrowCircleDownOutlined);
var _arrowCircleDownRounded = require("./ArrowCircleDownRounded");
var _arrowCircleDownRoundedDefault = parcelHelpers.interopDefault(_arrowCircleDownRounded);
var _arrowCircleDownSharp = require("./ArrowCircleDownSharp");
var _arrowCircleDownSharpDefault = parcelHelpers.interopDefault(_arrowCircleDownSharp);
var _arrowCircleDownTwoTone = require("./ArrowCircleDownTwoTone");
var _arrowCircleDownTwoToneDefault = parcelHelpers.interopDefault(_arrowCircleDownTwoTone);
var _arrowCircleLeft = require("./ArrowCircleLeft");
var _arrowCircleLeftDefault = parcelHelpers.interopDefault(_arrowCircleLeft);
var _arrowCircleLeftOutlined = require("./ArrowCircleLeftOutlined");
var _arrowCircleLeftOutlinedDefault = parcelHelpers.interopDefault(_arrowCircleLeftOutlined);
var _arrowCircleLeftRounded = require("./ArrowCircleLeftRounded");
var _arrowCircleLeftRoundedDefault = parcelHelpers.interopDefault(_arrowCircleLeftRounded);
var _arrowCircleLeftSharp = require("./ArrowCircleLeftSharp");
var _arrowCircleLeftSharpDefault = parcelHelpers.interopDefault(_arrowCircleLeftSharp);
var _arrowCircleLeftTwoTone = require("./ArrowCircleLeftTwoTone");
var _arrowCircleLeftTwoToneDefault = parcelHelpers.interopDefault(_arrowCircleLeftTwoTone);
var _arrowCircleRight = require("./ArrowCircleRight");
var _arrowCircleRightDefault = parcelHelpers.interopDefault(_arrowCircleRight);
var _arrowCircleRightOutlined = require("./ArrowCircleRightOutlined");
var _arrowCircleRightOutlinedDefault = parcelHelpers.interopDefault(_arrowCircleRightOutlined);
var _arrowCircleRightRounded = require("./ArrowCircleRightRounded");
var _arrowCircleRightRoundedDefault = parcelHelpers.interopDefault(_arrowCircleRightRounded);
var _arrowCircleRightSharp = require("./ArrowCircleRightSharp");
var _arrowCircleRightSharpDefault = parcelHelpers.interopDefault(_arrowCircleRightSharp);
var _arrowCircleRightTwoTone = require("./ArrowCircleRightTwoTone");
var _arrowCircleRightTwoToneDefault = parcelHelpers.interopDefault(_arrowCircleRightTwoTone);
var _arrowCircleUp = require("./ArrowCircleUp");
var _arrowCircleUpDefault = parcelHelpers.interopDefault(_arrowCircleUp);
var _arrowCircleUpOutlined = require("./ArrowCircleUpOutlined");
var _arrowCircleUpOutlinedDefault = parcelHelpers.interopDefault(_arrowCircleUpOutlined);
var _arrowCircleUpRounded = require("./ArrowCircleUpRounded");
var _arrowCircleUpRoundedDefault = parcelHelpers.interopDefault(_arrowCircleUpRounded);
var _arrowCircleUpSharp = require("./ArrowCircleUpSharp");
var _arrowCircleUpSharpDefault = parcelHelpers.interopDefault(_arrowCircleUpSharp);
var _arrowCircleUpTwoTone = require("./ArrowCircleUpTwoTone");
var _arrowCircleUpTwoToneDefault = parcelHelpers.interopDefault(_arrowCircleUpTwoTone);
var _arrowDownward = require("./ArrowDownward");
var _arrowDownwardDefault = parcelHelpers.interopDefault(_arrowDownward);
var _arrowDownwardOutlined = require("./ArrowDownwardOutlined");
var _arrowDownwardOutlinedDefault = parcelHelpers.interopDefault(_arrowDownwardOutlined);
var _arrowDownwardRounded = require("./ArrowDownwardRounded");
var _arrowDownwardRoundedDefault = parcelHelpers.interopDefault(_arrowDownwardRounded);
var _arrowDownwardSharp = require("./ArrowDownwardSharp");
var _arrowDownwardSharpDefault = parcelHelpers.interopDefault(_arrowDownwardSharp);
var _arrowDownwardTwoTone = require("./ArrowDownwardTwoTone");
var _arrowDownwardTwoToneDefault = parcelHelpers.interopDefault(_arrowDownwardTwoTone);
var _arrowDropDown = require("./ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _arrowDropDownCircle = require("./ArrowDropDownCircle");
var _arrowDropDownCircleDefault = parcelHelpers.interopDefault(_arrowDropDownCircle);
var _arrowDropDownCircleOutlined = require("./ArrowDropDownCircleOutlined");
var _arrowDropDownCircleOutlinedDefault = parcelHelpers.interopDefault(_arrowDropDownCircleOutlined);
var _arrowDropDownCircleRounded = require("./ArrowDropDownCircleRounded");
var _arrowDropDownCircleRoundedDefault = parcelHelpers.interopDefault(_arrowDropDownCircleRounded);
var _arrowDropDownCircleSharp = require("./ArrowDropDownCircleSharp");
var _arrowDropDownCircleSharpDefault = parcelHelpers.interopDefault(_arrowDropDownCircleSharp);
var _arrowDropDownCircleTwoTone = require("./ArrowDropDownCircleTwoTone");
var _arrowDropDownCircleTwoToneDefault = parcelHelpers.interopDefault(_arrowDropDownCircleTwoTone);
var _arrowDropDownOutlined = require("./ArrowDropDownOutlined");
var _arrowDropDownOutlinedDefault = parcelHelpers.interopDefault(_arrowDropDownOutlined);
var _arrowDropDownRounded = require("./ArrowDropDownRounded");
var _arrowDropDownRoundedDefault = parcelHelpers.interopDefault(_arrowDropDownRounded);
var _arrowDropDownSharp = require("./ArrowDropDownSharp");
var _arrowDropDownSharpDefault = parcelHelpers.interopDefault(_arrowDropDownSharp);
var _arrowDropDownTwoTone = require("./ArrowDropDownTwoTone");
var _arrowDropDownTwoToneDefault = parcelHelpers.interopDefault(_arrowDropDownTwoTone);
var _arrowDropUp = require("./ArrowDropUp");
var _arrowDropUpDefault = parcelHelpers.interopDefault(_arrowDropUp);
var _arrowDropUpOutlined = require("./ArrowDropUpOutlined");
var _arrowDropUpOutlinedDefault = parcelHelpers.interopDefault(_arrowDropUpOutlined);
var _arrowDropUpRounded = require("./ArrowDropUpRounded");
var _arrowDropUpRoundedDefault = parcelHelpers.interopDefault(_arrowDropUpRounded);
var _arrowDropUpSharp = require("./ArrowDropUpSharp");
var _arrowDropUpSharpDefault = parcelHelpers.interopDefault(_arrowDropUpSharp);
var _arrowDropUpTwoTone = require("./ArrowDropUpTwoTone");
var _arrowDropUpTwoToneDefault = parcelHelpers.interopDefault(_arrowDropUpTwoTone);
var _arrowForward = require("./ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _arrowForwardIos = require("./ArrowForwardIos");
var _arrowForwardIosDefault = parcelHelpers.interopDefault(_arrowForwardIos);
var _arrowForwardIosOutlined = require("./ArrowForwardIosOutlined");
var _arrowForwardIosOutlinedDefault = parcelHelpers.interopDefault(_arrowForwardIosOutlined);
var _arrowForwardIosRounded = require("./ArrowForwardIosRounded");
var _arrowForwardIosRoundedDefault = parcelHelpers.interopDefault(_arrowForwardIosRounded);
var _arrowForwardIosSharp = require("./ArrowForwardIosSharp");
var _arrowForwardIosSharpDefault = parcelHelpers.interopDefault(_arrowForwardIosSharp);
var _arrowForwardIosTwoTone = require("./ArrowForwardIosTwoTone");
var _arrowForwardIosTwoToneDefault = parcelHelpers.interopDefault(_arrowForwardIosTwoTone);
var _arrowForwardOutlined = require("./ArrowForwardOutlined");
var _arrowForwardOutlinedDefault = parcelHelpers.interopDefault(_arrowForwardOutlined);
var _arrowForwardRounded = require("./ArrowForwardRounded");
var _arrowForwardRoundedDefault = parcelHelpers.interopDefault(_arrowForwardRounded);
var _arrowForwardSharp = require("./ArrowForwardSharp");
var _arrowForwardSharpDefault = parcelHelpers.interopDefault(_arrowForwardSharp);
var _arrowForwardTwoTone = require("./ArrowForwardTwoTone");
var _arrowForwardTwoToneDefault = parcelHelpers.interopDefault(_arrowForwardTwoTone);
var _arrowLeft = require("./ArrowLeft");
var _arrowLeftDefault = parcelHelpers.interopDefault(_arrowLeft);
var _arrowLeftOutlined = require("./ArrowLeftOutlined");
var _arrowLeftOutlinedDefault = parcelHelpers.interopDefault(_arrowLeftOutlined);
var _arrowLeftRounded = require("./ArrowLeftRounded");
var _arrowLeftRoundedDefault = parcelHelpers.interopDefault(_arrowLeftRounded);
var _arrowLeftSharp = require("./ArrowLeftSharp");
var _arrowLeftSharpDefault = parcelHelpers.interopDefault(_arrowLeftSharp);
var _arrowLeftTwoTone = require("./ArrowLeftTwoTone");
var _arrowLeftTwoToneDefault = parcelHelpers.interopDefault(_arrowLeftTwoTone);
var _arrowOutward = require("./ArrowOutward");
var _arrowOutwardDefault = parcelHelpers.interopDefault(_arrowOutward);
var _arrowOutwardOutlined = require("./ArrowOutwardOutlined");
var _arrowOutwardOutlinedDefault = parcelHelpers.interopDefault(_arrowOutwardOutlined);
var _arrowOutwardRounded = require("./ArrowOutwardRounded");
var _arrowOutwardRoundedDefault = parcelHelpers.interopDefault(_arrowOutwardRounded);
var _arrowOutwardSharp = require("./ArrowOutwardSharp");
var _arrowOutwardSharpDefault = parcelHelpers.interopDefault(_arrowOutwardSharp);
var _arrowOutwardTwoTone = require("./ArrowOutwardTwoTone");
var _arrowOutwardTwoToneDefault = parcelHelpers.interopDefault(_arrowOutwardTwoTone);
var _arrowRight = require("./ArrowRight");
var _arrowRightDefault = parcelHelpers.interopDefault(_arrowRight);
var _arrowRightAlt = require("./ArrowRightAlt");
var _arrowRightAltDefault = parcelHelpers.interopDefault(_arrowRightAlt);
var _arrowRightAltOutlined = require("./ArrowRightAltOutlined");
var _arrowRightAltOutlinedDefault = parcelHelpers.interopDefault(_arrowRightAltOutlined);
var _arrowRightAltRounded = require("./ArrowRightAltRounded");
var _arrowRightAltRoundedDefault = parcelHelpers.interopDefault(_arrowRightAltRounded);
var _arrowRightAltSharp = require("./ArrowRightAltSharp");
var _arrowRightAltSharpDefault = parcelHelpers.interopDefault(_arrowRightAltSharp);
var _arrowRightAltTwoTone = require("./ArrowRightAltTwoTone");
var _arrowRightAltTwoToneDefault = parcelHelpers.interopDefault(_arrowRightAltTwoTone);
var _arrowRightOutlined = require("./ArrowRightOutlined");
var _arrowRightOutlinedDefault = parcelHelpers.interopDefault(_arrowRightOutlined);
var _arrowRightRounded = require("./ArrowRightRounded");
var _arrowRightRoundedDefault = parcelHelpers.interopDefault(_arrowRightRounded);
var _arrowRightSharp = require("./ArrowRightSharp");
var _arrowRightSharpDefault = parcelHelpers.interopDefault(_arrowRightSharp);
var _arrowRightTwoTone = require("./ArrowRightTwoTone");
var _arrowRightTwoToneDefault = parcelHelpers.interopDefault(_arrowRightTwoTone);
var _arrowUpward = require("./ArrowUpward");
var _arrowUpwardDefault = parcelHelpers.interopDefault(_arrowUpward);
var _arrowUpwardOutlined = require("./ArrowUpwardOutlined");
var _arrowUpwardOutlinedDefault = parcelHelpers.interopDefault(_arrowUpwardOutlined);
var _arrowUpwardRounded = require("./ArrowUpwardRounded");
var _arrowUpwardRoundedDefault = parcelHelpers.interopDefault(_arrowUpwardRounded);
var _arrowUpwardSharp = require("./ArrowUpwardSharp");
var _arrowUpwardSharpDefault = parcelHelpers.interopDefault(_arrowUpwardSharp);
var _arrowUpwardTwoTone = require("./ArrowUpwardTwoTone");
var _arrowUpwardTwoToneDefault = parcelHelpers.interopDefault(_arrowUpwardTwoTone);
var _artTrack = require("./ArtTrack");
var _artTrackDefault = parcelHelpers.interopDefault(_artTrack);
var _artTrackOutlined = require("./ArtTrackOutlined");
var _artTrackOutlinedDefault = parcelHelpers.interopDefault(_artTrackOutlined);
var _artTrackRounded = require("./ArtTrackRounded");
var _artTrackRoundedDefault = parcelHelpers.interopDefault(_artTrackRounded);
var _artTrackSharp = require("./ArtTrackSharp");
var _artTrackSharpDefault = parcelHelpers.interopDefault(_artTrackSharp);
var _artTrackTwoTone = require("./ArtTrackTwoTone");
var _artTrackTwoToneDefault = parcelHelpers.interopDefault(_artTrackTwoTone);
var _article = require("./Article");
var _articleDefault = parcelHelpers.interopDefault(_article);
var _articleOutlined = require("./ArticleOutlined");
var _articleOutlinedDefault = parcelHelpers.interopDefault(_articleOutlined);
var _articleRounded = require("./ArticleRounded");
var _articleRoundedDefault = parcelHelpers.interopDefault(_articleRounded);
var _articleSharp = require("./ArticleSharp");
var _articleSharpDefault = parcelHelpers.interopDefault(_articleSharp);
var _articleTwoTone = require("./ArticleTwoTone");
var _articleTwoToneDefault = parcelHelpers.interopDefault(_articleTwoTone);
var _aspectRatio = require("./AspectRatio");
var _aspectRatioDefault = parcelHelpers.interopDefault(_aspectRatio);
var _aspectRatioOutlined = require("./AspectRatioOutlined");
var _aspectRatioOutlinedDefault = parcelHelpers.interopDefault(_aspectRatioOutlined);
var _aspectRatioRounded = require("./AspectRatioRounded");
var _aspectRatioRoundedDefault = parcelHelpers.interopDefault(_aspectRatioRounded);
var _aspectRatioSharp = require("./AspectRatioSharp");
var _aspectRatioSharpDefault = parcelHelpers.interopDefault(_aspectRatioSharp);
var _aspectRatioTwoTone = require("./AspectRatioTwoTone");
var _aspectRatioTwoToneDefault = parcelHelpers.interopDefault(_aspectRatioTwoTone);
var _assessment = require("./Assessment");
var _assessmentDefault = parcelHelpers.interopDefault(_assessment);
var _assessmentOutlined = require("./AssessmentOutlined");
var _assessmentOutlinedDefault = parcelHelpers.interopDefault(_assessmentOutlined);
var _assessmentRounded = require("./AssessmentRounded");
var _assessmentRoundedDefault = parcelHelpers.interopDefault(_assessmentRounded);
var _assessmentSharp = require("./AssessmentSharp");
var _assessmentSharpDefault = parcelHelpers.interopDefault(_assessmentSharp);
var _assessmentTwoTone = require("./AssessmentTwoTone");
var _assessmentTwoToneDefault = parcelHelpers.interopDefault(_assessmentTwoTone);
var _assignment = require("./Assignment");
var _assignmentDefault = parcelHelpers.interopDefault(_assignment);
var _assignmentInd = require("./AssignmentInd");
var _assignmentIndDefault = parcelHelpers.interopDefault(_assignmentInd);
var _assignmentIndOutlined = require("./AssignmentIndOutlined");
var _assignmentIndOutlinedDefault = parcelHelpers.interopDefault(_assignmentIndOutlined);
var _assignmentIndRounded = require("./AssignmentIndRounded");
var _assignmentIndRoundedDefault = parcelHelpers.interopDefault(_assignmentIndRounded);
var _assignmentIndSharp = require("./AssignmentIndSharp");
var _assignmentIndSharpDefault = parcelHelpers.interopDefault(_assignmentIndSharp);
var _assignmentIndTwoTone = require("./AssignmentIndTwoTone");
var _assignmentIndTwoToneDefault = parcelHelpers.interopDefault(_assignmentIndTwoTone);
var _assignmentLate = require("./AssignmentLate");
var _assignmentLateDefault = parcelHelpers.interopDefault(_assignmentLate);
var _assignmentLateOutlined = require("./AssignmentLateOutlined");
var _assignmentLateOutlinedDefault = parcelHelpers.interopDefault(_assignmentLateOutlined);
var _assignmentLateRounded = require("./AssignmentLateRounded");
var _assignmentLateRoundedDefault = parcelHelpers.interopDefault(_assignmentLateRounded);
var _assignmentLateSharp = require("./AssignmentLateSharp");
var _assignmentLateSharpDefault = parcelHelpers.interopDefault(_assignmentLateSharp);
var _assignmentLateTwoTone = require("./AssignmentLateTwoTone");
var _assignmentLateTwoToneDefault = parcelHelpers.interopDefault(_assignmentLateTwoTone);
var _assignmentOutlined = require("./AssignmentOutlined");
var _assignmentOutlinedDefault = parcelHelpers.interopDefault(_assignmentOutlined);
var _assignmentReturn = require("./AssignmentReturn");
var _assignmentReturnDefault = parcelHelpers.interopDefault(_assignmentReturn);
var _assignmentReturnOutlined = require("./AssignmentReturnOutlined");
var _assignmentReturnOutlinedDefault = parcelHelpers.interopDefault(_assignmentReturnOutlined);
var _assignmentReturnRounded = require("./AssignmentReturnRounded");
var _assignmentReturnRoundedDefault = parcelHelpers.interopDefault(_assignmentReturnRounded);
var _assignmentReturnSharp = require("./AssignmentReturnSharp");
var _assignmentReturnSharpDefault = parcelHelpers.interopDefault(_assignmentReturnSharp);
var _assignmentReturnTwoTone = require("./AssignmentReturnTwoTone");
var _assignmentReturnTwoToneDefault = parcelHelpers.interopDefault(_assignmentReturnTwoTone);
var _assignmentReturned = require("./AssignmentReturned");
var _assignmentReturnedDefault = parcelHelpers.interopDefault(_assignmentReturned);
var _assignmentReturnedOutlined = require("./AssignmentReturnedOutlined");
var _assignmentReturnedOutlinedDefault = parcelHelpers.interopDefault(_assignmentReturnedOutlined);
var _assignmentReturnedRounded = require("./AssignmentReturnedRounded");
var _assignmentReturnedRoundedDefault = parcelHelpers.interopDefault(_assignmentReturnedRounded);
var _assignmentReturnedSharp = require("./AssignmentReturnedSharp");
var _assignmentReturnedSharpDefault = parcelHelpers.interopDefault(_assignmentReturnedSharp);
var _assignmentReturnedTwoTone = require("./AssignmentReturnedTwoTone");
var _assignmentReturnedTwoToneDefault = parcelHelpers.interopDefault(_assignmentReturnedTwoTone);
var _assignmentRounded = require("./AssignmentRounded");
var _assignmentRoundedDefault = parcelHelpers.interopDefault(_assignmentRounded);
var _assignmentSharp = require("./AssignmentSharp");
var _assignmentSharpDefault = parcelHelpers.interopDefault(_assignmentSharp);
var _assignmentTurnedIn = require("./AssignmentTurnedIn");
var _assignmentTurnedInDefault = parcelHelpers.interopDefault(_assignmentTurnedIn);
var _assignmentTurnedInOutlined = require("./AssignmentTurnedInOutlined");
var _assignmentTurnedInOutlinedDefault = parcelHelpers.interopDefault(_assignmentTurnedInOutlined);
var _assignmentTurnedInRounded = require("./AssignmentTurnedInRounded");
var _assignmentTurnedInRoundedDefault = parcelHelpers.interopDefault(_assignmentTurnedInRounded);
var _assignmentTurnedInSharp = require("./AssignmentTurnedInSharp");
var _assignmentTurnedInSharpDefault = parcelHelpers.interopDefault(_assignmentTurnedInSharp);
var _assignmentTurnedInTwoTone = require("./AssignmentTurnedInTwoTone");
var _assignmentTurnedInTwoToneDefault = parcelHelpers.interopDefault(_assignmentTurnedInTwoTone);
var _assignmentTwoTone = require("./AssignmentTwoTone");
var _assignmentTwoToneDefault = parcelHelpers.interopDefault(_assignmentTwoTone);
var _assistWalker = require("./AssistWalker");
var _assistWalkerDefault = parcelHelpers.interopDefault(_assistWalker);
var _assistWalkerOutlined = require("./AssistWalkerOutlined");
var _assistWalkerOutlinedDefault = parcelHelpers.interopDefault(_assistWalkerOutlined);
var _assistWalkerRounded = require("./AssistWalkerRounded");
var _assistWalkerRoundedDefault = parcelHelpers.interopDefault(_assistWalkerRounded);
var _assistWalkerSharp = require("./AssistWalkerSharp");
var _assistWalkerSharpDefault = parcelHelpers.interopDefault(_assistWalkerSharp);
var _assistWalkerTwoTone = require("./AssistWalkerTwoTone");
var _assistWalkerTwoToneDefault = parcelHelpers.interopDefault(_assistWalkerTwoTone);
var _assistant = require("./Assistant");
var _assistantDefault = parcelHelpers.interopDefault(_assistant);
var _assistantDirection = require("./AssistantDirection");
var _assistantDirectionDefault = parcelHelpers.interopDefault(_assistantDirection);
var _assistantDirectionOutlined = require("./AssistantDirectionOutlined");
var _assistantDirectionOutlinedDefault = parcelHelpers.interopDefault(_assistantDirectionOutlined);
var _assistantDirectionRounded = require("./AssistantDirectionRounded");
var _assistantDirectionRoundedDefault = parcelHelpers.interopDefault(_assistantDirectionRounded);
var _assistantDirectionSharp = require("./AssistantDirectionSharp");
var _assistantDirectionSharpDefault = parcelHelpers.interopDefault(_assistantDirectionSharp);
var _assistantDirectionTwoTone = require("./AssistantDirectionTwoTone");
var _assistantDirectionTwoToneDefault = parcelHelpers.interopDefault(_assistantDirectionTwoTone);
var _assistantOutlined = require("./AssistantOutlined");
var _assistantOutlinedDefault = parcelHelpers.interopDefault(_assistantOutlined);
var _assistantPhoto = require("./AssistantPhoto");
var _assistantPhotoDefault = parcelHelpers.interopDefault(_assistantPhoto);
var _assistantPhotoOutlined = require("./AssistantPhotoOutlined");
var _assistantPhotoOutlinedDefault = parcelHelpers.interopDefault(_assistantPhotoOutlined);
var _assistantPhotoRounded = require("./AssistantPhotoRounded");
var _assistantPhotoRoundedDefault = parcelHelpers.interopDefault(_assistantPhotoRounded);
var _assistantPhotoSharp = require("./AssistantPhotoSharp");
var _assistantPhotoSharpDefault = parcelHelpers.interopDefault(_assistantPhotoSharp);
var _assistantPhotoTwoTone = require("./AssistantPhotoTwoTone");
var _assistantPhotoTwoToneDefault = parcelHelpers.interopDefault(_assistantPhotoTwoTone);
var _assistantRounded = require("./AssistantRounded");
var _assistantRoundedDefault = parcelHelpers.interopDefault(_assistantRounded);
var _assistantSharp = require("./AssistantSharp");
var _assistantSharpDefault = parcelHelpers.interopDefault(_assistantSharp);
var _assistantTwoTone = require("./AssistantTwoTone");
var _assistantTwoToneDefault = parcelHelpers.interopDefault(_assistantTwoTone);
var _assuredWorkload = require("./AssuredWorkload");
var _assuredWorkloadDefault = parcelHelpers.interopDefault(_assuredWorkload);
var _assuredWorkloadOutlined = require("./AssuredWorkloadOutlined");
var _assuredWorkloadOutlinedDefault = parcelHelpers.interopDefault(_assuredWorkloadOutlined);
var _assuredWorkloadRounded = require("./AssuredWorkloadRounded");
var _assuredWorkloadRoundedDefault = parcelHelpers.interopDefault(_assuredWorkloadRounded);
var _assuredWorkloadSharp = require("./AssuredWorkloadSharp");
var _assuredWorkloadSharpDefault = parcelHelpers.interopDefault(_assuredWorkloadSharp);
var _assuredWorkloadTwoTone = require("./AssuredWorkloadTwoTone");
var _assuredWorkloadTwoToneDefault = parcelHelpers.interopDefault(_assuredWorkloadTwoTone);
var _atm = require("./Atm");
var _atmDefault = parcelHelpers.interopDefault(_atm);
var _atmOutlined = require("./AtmOutlined");
var _atmOutlinedDefault = parcelHelpers.interopDefault(_atmOutlined);
var _atmRounded = require("./AtmRounded");
var _atmRoundedDefault = parcelHelpers.interopDefault(_atmRounded);
var _atmSharp = require("./AtmSharp");
var _atmSharpDefault = parcelHelpers.interopDefault(_atmSharp);
var _atmTwoTone = require("./AtmTwoTone");
var _atmTwoToneDefault = parcelHelpers.interopDefault(_atmTwoTone);
var _attachEmail = require("./AttachEmail");
var _attachEmailDefault = parcelHelpers.interopDefault(_attachEmail);
var _attachEmailOutlined = require("./AttachEmailOutlined");
var _attachEmailOutlinedDefault = parcelHelpers.interopDefault(_attachEmailOutlined);
var _attachEmailRounded = require("./AttachEmailRounded");
var _attachEmailRoundedDefault = parcelHelpers.interopDefault(_attachEmailRounded);
var _attachEmailSharp = require("./AttachEmailSharp");
var _attachEmailSharpDefault = parcelHelpers.interopDefault(_attachEmailSharp);
var _attachEmailTwoTone = require("./AttachEmailTwoTone");
var _attachEmailTwoToneDefault = parcelHelpers.interopDefault(_attachEmailTwoTone);
var _attachFile = require("./AttachFile");
var _attachFileDefault = parcelHelpers.interopDefault(_attachFile);
var _attachFileOutlined = require("./AttachFileOutlined");
var _attachFileOutlinedDefault = parcelHelpers.interopDefault(_attachFileOutlined);
var _attachFileRounded = require("./AttachFileRounded");
var _attachFileRoundedDefault = parcelHelpers.interopDefault(_attachFileRounded);
var _attachFileSharp = require("./AttachFileSharp");
var _attachFileSharpDefault = parcelHelpers.interopDefault(_attachFileSharp);
var _attachFileTwoTone = require("./AttachFileTwoTone");
var _attachFileTwoToneDefault = parcelHelpers.interopDefault(_attachFileTwoTone);
var _attachMoney = require("./AttachMoney");
var _attachMoneyDefault = parcelHelpers.interopDefault(_attachMoney);
var _attachMoneyOutlined = require("./AttachMoneyOutlined");
var _attachMoneyOutlinedDefault = parcelHelpers.interopDefault(_attachMoneyOutlined);
var _attachMoneyRounded = require("./AttachMoneyRounded");
var _attachMoneyRoundedDefault = parcelHelpers.interopDefault(_attachMoneyRounded);
var _attachMoneySharp = require("./AttachMoneySharp");
var _attachMoneySharpDefault = parcelHelpers.interopDefault(_attachMoneySharp);
var _attachMoneyTwoTone = require("./AttachMoneyTwoTone");
var _attachMoneyTwoToneDefault = parcelHelpers.interopDefault(_attachMoneyTwoTone);
var _attachment = require("./Attachment");
var _attachmentDefault = parcelHelpers.interopDefault(_attachment);
var _attachmentOutlined = require("./AttachmentOutlined");
var _attachmentOutlinedDefault = parcelHelpers.interopDefault(_attachmentOutlined);
var _attachmentRounded = require("./AttachmentRounded");
var _attachmentRoundedDefault = parcelHelpers.interopDefault(_attachmentRounded);
var _attachmentSharp = require("./AttachmentSharp");
var _attachmentSharpDefault = parcelHelpers.interopDefault(_attachmentSharp);
var _attachmentTwoTone = require("./AttachmentTwoTone");
var _attachmentTwoToneDefault = parcelHelpers.interopDefault(_attachmentTwoTone);
var _attractions = require("./Attractions");
var _attractionsDefault = parcelHelpers.interopDefault(_attractions);
var _attractionsOutlined = require("./AttractionsOutlined");
var _attractionsOutlinedDefault = parcelHelpers.interopDefault(_attractionsOutlined);
var _attractionsRounded = require("./AttractionsRounded");
var _attractionsRoundedDefault = parcelHelpers.interopDefault(_attractionsRounded);
var _attractionsSharp = require("./AttractionsSharp");
var _attractionsSharpDefault = parcelHelpers.interopDefault(_attractionsSharp);
var _attractionsTwoTone = require("./AttractionsTwoTone");
var _attractionsTwoToneDefault = parcelHelpers.interopDefault(_attractionsTwoTone);
var _attribution = require("./Attribution");
var _attributionDefault = parcelHelpers.interopDefault(_attribution);
var _attributionOutlined = require("./AttributionOutlined");
var _attributionOutlinedDefault = parcelHelpers.interopDefault(_attributionOutlined);
var _attributionRounded = require("./AttributionRounded");
var _attributionRoundedDefault = parcelHelpers.interopDefault(_attributionRounded);
var _attributionSharp = require("./AttributionSharp");
var _attributionSharpDefault = parcelHelpers.interopDefault(_attributionSharp);
var _attributionTwoTone = require("./AttributionTwoTone");
var _attributionTwoToneDefault = parcelHelpers.interopDefault(_attributionTwoTone);
var _audioFile = require("./AudioFile");
var _audioFileDefault = parcelHelpers.interopDefault(_audioFile);
var _audioFileOutlined = require("./AudioFileOutlined");
var _audioFileOutlinedDefault = parcelHelpers.interopDefault(_audioFileOutlined);
var _audioFileRounded = require("./AudioFileRounded");
var _audioFileRoundedDefault = parcelHelpers.interopDefault(_audioFileRounded);
var _audioFileSharp = require("./AudioFileSharp");
var _audioFileSharpDefault = parcelHelpers.interopDefault(_audioFileSharp);
var _audioFileTwoTone = require("./AudioFileTwoTone");
var _audioFileTwoToneDefault = parcelHelpers.interopDefault(_audioFileTwoTone);
var _audiotrack = require("./Audiotrack");
var _audiotrackDefault = parcelHelpers.interopDefault(_audiotrack);
var _audiotrackOutlined = require("./AudiotrackOutlined");
var _audiotrackOutlinedDefault = parcelHelpers.interopDefault(_audiotrackOutlined);
var _audiotrackRounded = require("./AudiotrackRounded");
var _audiotrackRoundedDefault = parcelHelpers.interopDefault(_audiotrackRounded);
var _audiotrackSharp = require("./AudiotrackSharp");
var _audiotrackSharpDefault = parcelHelpers.interopDefault(_audiotrackSharp);
var _audiotrackTwoTone = require("./AudiotrackTwoTone");
var _audiotrackTwoToneDefault = parcelHelpers.interopDefault(_audiotrackTwoTone);
var _autoAwesome = require("./AutoAwesome");
var _autoAwesomeDefault = parcelHelpers.interopDefault(_autoAwesome);
var _autoAwesomeMosaic = require("./AutoAwesomeMosaic");
var _autoAwesomeMosaicDefault = parcelHelpers.interopDefault(_autoAwesomeMosaic);
var _autoAwesomeMosaicOutlined = require("./AutoAwesomeMosaicOutlined");
var _autoAwesomeMosaicOutlinedDefault = parcelHelpers.interopDefault(_autoAwesomeMosaicOutlined);
var _autoAwesomeMosaicRounded = require("./AutoAwesomeMosaicRounded");
var _autoAwesomeMosaicRoundedDefault = parcelHelpers.interopDefault(_autoAwesomeMosaicRounded);
var _autoAwesomeMosaicSharp = require("./AutoAwesomeMosaicSharp");
var _autoAwesomeMosaicSharpDefault = parcelHelpers.interopDefault(_autoAwesomeMosaicSharp);
var _autoAwesomeMosaicTwoTone = require("./AutoAwesomeMosaicTwoTone");
var _autoAwesomeMosaicTwoToneDefault = parcelHelpers.interopDefault(_autoAwesomeMosaicTwoTone);
var _autoAwesomeMotion = require("./AutoAwesomeMotion");
var _autoAwesomeMotionDefault = parcelHelpers.interopDefault(_autoAwesomeMotion);
var _autoAwesomeMotionOutlined = require("./AutoAwesomeMotionOutlined");
var _autoAwesomeMotionOutlinedDefault = parcelHelpers.interopDefault(_autoAwesomeMotionOutlined);
var _autoAwesomeMotionRounded = require("./AutoAwesomeMotionRounded");
var _autoAwesomeMotionRoundedDefault = parcelHelpers.interopDefault(_autoAwesomeMotionRounded);
var _autoAwesomeMotionSharp = require("./AutoAwesomeMotionSharp");
var _autoAwesomeMotionSharpDefault = parcelHelpers.interopDefault(_autoAwesomeMotionSharp);
var _autoAwesomeMotionTwoTone = require("./AutoAwesomeMotionTwoTone");
var _autoAwesomeMotionTwoToneDefault = parcelHelpers.interopDefault(_autoAwesomeMotionTwoTone);
var _autoAwesomeOutlined = require("./AutoAwesomeOutlined");
var _autoAwesomeOutlinedDefault = parcelHelpers.interopDefault(_autoAwesomeOutlined);
var _autoAwesomeRounded = require("./AutoAwesomeRounded");
var _autoAwesomeRoundedDefault = parcelHelpers.interopDefault(_autoAwesomeRounded);
var _autoAwesomeSharp = require("./AutoAwesomeSharp");
var _autoAwesomeSharpDefault = parcelHelpers.interopDefault(_autoAwesomeSharp);
var _autoAwesomeTwoTone = require("./AutoAwesomeTwoTone");
var _autoAwesomeTwoToneDefault = parcelHelpers.interopDefault(_autoAwesomeTwoTone);
var _autoDelete = require("./AutoDelete");
var _autoDeleteDefault = parcelHelpers.interopDefault(_autoDelete);
var _autoDeleteOutlined = require("./AutoDeleteOutlined");
var _autoDeleteOutlinedDefault = parcelHelpers.interopDefault(_autoDeleteOutlined);
var _autoDeleteRounded = require("./AutoDeleteRounded");
var _autoDeleteRoundedDefault = parcelHelpers.interopDefault(_autoDeleteRounded);
var _autoDeleteSharp = require("./AutoDeleteSharp");
var _autoDeleteSharpDefault = parcelHelpers.interopDefault(_autoDeleteSharp);
var _autoDeleteTwoTone = require("./AutoDeleteTwoTone");
var _autoDeleteTwoToneDefault = parcelHelpers.interopDefault(_autoDeleteTwoTone);
var _autoFixHigh = require("./AutoFixHigh");
var _autoFixHighDefault = parcelHelpers.interopDefault(_autoFixHigh);
var _autoFixHighOutlined = require("./AutoFixHighOutlined");
var _autoFixHighOutlinedDefault = parcelHelpers.interopDefault(_autoFixHighOutlined);
var _autoFixHighRounded = require("./AutoFixHighRounded");
var _autoFixHighRoundedDefault = parcelHelpers.interopDefault(_autoFixHighRounded);
var _autoFixHighSharp = require("./AutoFixHighSharp");
var _autoFixHighSharpDefault = parcelHelpers.interopDefault(_autoFixHighSharp);
var _autoFixHighTwoTone = require("./AutoFixHighTwoTone");
var _autoFixHighTwoToneDefault = parcelHelpers.interopDefault(_autoFixHighTwoTone);
var _autoFixNormal = require("./AutoFixNormal");
var _autoFixNormalDefault = parcelHelpers.interopDefault(_autoFixNormal);
var _autoFixNormalOutlined = require("./AutoFixNormalOutlined");
var _autoFixNormalOutlinedDefault = parcelHelpers.interopDefault(_autoFixNormalOutlined);
var _autoFixNormalRounded = require("./AutoFixNormalRounded");
var _autoFixNormalRoundedDefault = parcelHelpers.interopDefault(_autoFixNormalRounded);
var _autoFixNormalSharp = require("./AutoFixNormalSharp");
var _autoFixNormalSharpDefault = parcelHelpers.interopDefault(_autoFixNormalSharp);
var _autoFixNormalTwoTone = require("./AutoFixNormalTwoTone");
var _autoFixNormalTwoToneDefault = parcelHelpers.interopDefault(_autoFixNormalTwoTone);
var _autoFixOff = require("./AutoFixOff");
var _autoFixOffDefault = parcelHelpers.interopDefault(_autoFixOff);
var _autoFixOffOutlined = require("./AutoFixOffOutlined");
var _autoFixOffOutlinedDefault = parcelHelpers.interopDefault(_autoFixOffOutlined);
var _autoFixOffRounded = require("./AutoFixOffRounded");
var _autoFixOffRoundedDefault = parcelHelpers.interopDefault(_autoFixOffRounded);
var _autoFixOffSharp = require("./AutoFixOffSharp");
var _autoFixOffSharpDefault = parcelHelpers.interopDefault(_autoFixOffSharp);
var _autoFixOffTwoTone = require("./AutoFixOffTwoTone");
var _autoFixOffTwoToneDefault = parcelHelpers.interopDefault(_autoFixOffTwoTone);
var _autoGraph = require("./AutoGraph");
var _autoGraphDefault = parcelHelpers.interopDefault(_autoGraph);
var _autoGraphOutlined = require("./AutoGraphOutlined");
var _autoGraphOutlinedDefault = parcelHelpers.interopDefault(_autoGraphOutlined);
var _autoGraphRounded = require("./AutoGraphRounded");
var _autoGraphRoundedDefault = parcelHelpers.interopDefault(_autoGraphRounded);
var _autoGraphSharp = require("./AutoGraphSharp");
var _autoGraphSharpDefault = parcelHelpers.interopDefault(_autoGraphSharp);
var _autoGraphTwoTone = require("./AutoGraphTwoTone");
var _autoGraphTwoToneDefault = parcelHelpers.interopDefault(_autoGraphTwoTone);
var _autoMode = require("./AutoMode");
var _autoModeDefault = parcelHelpers.interopDefault(_autoMode);
var _autoModeOutlined = require("./AutoModeOutlined");
var _autoModeOutlinedDefault = parcelHelpers.interopDefault(_autoModeOutlined);
var _autoModeRounded = require("./AutoModeRounded");
var _autoModeRoundedDefault = parcelHelpers.interopDefault(_autoModeRounded);
var _autoModeSharp = require("./AutoModeSharp");
var _autoModeSharpDefault = parcelHelpers.interopDefault(_autoModeSharp);
var _autoModeTwoTone = require("./AutoModeTwoTone");
var _autoModeTwoToneDefault = parcelHelpers.interopDefault(_autoModeTwoTone);
var _autoStories = require("./AutoStories");
var _autoStoriesDefault = parcelHelpers.interopDefault(_autoStories);
var _autoStoriesOutlined = require("./AutoStoriesOutlined");
var _autoStoriesOutlinedDefault = parcelHelpers.interopDefault(_autoStoriesOutlined);
var _autoStoriesRounded = require("./AutoStoriesRounded");
var _autoStoriesRoundedDefault = parcelHelpers.interopDefault(_autoStoriesRounded);
var _autoStoriesSharp = require("./AutoStoriesSharp");
var _autoStoriesSharpDefault = parcelHelpers.interopDefault(_autoStoriesSharp);
var _autoStoriesTwoTone = require("./AutoStoriesTwoTone");
var _autoStoriesTwoToneDefault = parcelHelpers.interopDefault(_autoStoriesTwoTone);
var _autofpsSelect = require("./AutofpsSelect");
var _autofpsSelectDefault = parcelHelpers.interopDefault(_autofpsSelect);
var _autofpsSelectOutlined = require("./AutofpsSelectOutlined");
var _autofpsSelectOutlinedDefault = parcelHelpers.interopDefault(_autofpsSelectOutlined);
var _autofpsSelectRounded = require("./AutofpsSelectRounded");
var _autofpsSelectRoundedDefault = parcelHelpers.interopDefault(_autofpsSelectRounded);
var _autofpsSelectSharp = require("./AutofpsSelectSharp");
var _autofpsSelectSharpDefault = parcelHelpers.interopDefault(_autofpsSelectSharp);
var _autofpsSelectTwoTone = require("./AutofpsSelectTwoTone");
var _autofpsSelectTwoToneDefault = parcelHelpers.interopDefault(_autofpsSelectTwoTone);
var _autorenew = require("./Autorenew");
var _autorenewDefault = parcelHelpers.interopDefault(_autorenew);
var _autorenewOutlined = require("./AutorenewOutlined");
var _autorenewOutlinedDefault = parcelHelpers.interopDefault(_autorenewOutlined);
var _autorenewRounded = require("./AutorenewRounded");
var _autorenewRoundedDefault = parcelHelpers.interopDefault(_autorenewRounded);
var _autorenewSharp = require("./AutorenewSharp");
var _autorenewSharpDefault = parcelHelpers.interopDefault(_autorenewSharp);
var _autorenewTwoTone = require("./AutorenewTwoTone");
var _autorenewTwoToneDefault = parcelHelpers.interopDefault(_autorenewTwoTone);
var _avTimer = require("./AvTimer");
var _avTimerDefault = parcelHelpers.interopDefault(_avTimer);
var _avTimerOutlined = require("./AvTimerOutlined");
var _avTimerOutlinedDefault = parcelHelpers.interopDefault(_avTimerOutlined);
var _avTimerRounded = require("./AvTimerRounded");
var _avTimerRoundedDefault = parcelHelpers.interopDefault(_avTimerRounded);
var _avTimerSharp = require("./AvTimerSharp");
var _avTimerSharpDefault = parcelHelpers.interopDefault(_avTimerSharp);
var _avTimerTwoTone = require("./AvTimerTwoTone");
var _avTimerTwoToneDefault = parcelHelpers.interopDefault(_avTimerTwoTone);
var _babyChangingStation = require("./BabyChangingStation");
var _babyChangingStationDefault = parcelHelpers.interopDefault(_babyChangingStation);
var _babyChangingStationOutlined = require("./BabyChangingStationOutlined");
var _babyChangingStationOutlinedDefault = parcelHelpers.interopDefault(_babyChangingStationOutlined);
var _babyChangingStationRounded = require("./BabyChangingStationRounded");
var _babyChangingStationRoundedDefault = parcelHelpers.interopDefault(_babyChangingStationRounded);
var _babyChangingStationSharp = require("./BabyChangingStationSharp");
var _babyChangingStationSharpDefault = parcelHelpers.interopDefault(_babyChangingStationSharp);
var _babyChangingStationTwoTone = require("./BabyChangingStationTwoTone");
var _babyChangingStationTwoToneDefault = parcelHelpers.interopDefault(_babyChangingStationTwoTone);
var _backHand = require("./BackHand");
var _backHandDefault = parcelHelpers.interopDefault(_backHand);
var _backHandOutlined = require("./BackHandOutlined");
var _backHandOutlinedDefault = parcelHelpers.interopDefault(_backHandOutlined);
var _backHandRounded = require("./BackHandRounded");
var _backHandRoundedDefault = parcelHelpers.interopDefault(_backHandRounded);
var _backHandSharp = require("./BackHandSharp");
var _backHandSharpDefault = parcelHelpers.interopDefault(_backHandSharp);
var _backHandTwoTone = require("./BackHandTwoTone");
var _backHandTwoToneDefault = parcelHelpers.interopDefault(_backHandTwoTone);
var _backpack = require("./Backpack");
var _backpackDefault = parcelHelpers.interopDefault(_backpack);
var _backpackOutlined = require("./BackpackOutlined");
var _backpackOutlinedDefault = parcelHelpers.interopDefault(_backpackOutlined);
var _backpackRounded = require("./BackpackRounded");
var _backpackRoundedDefault = parcelHelpers.interopDefault(_backpackRounded);
var _backpackSharp = require("./BackpackSharp");
var _backpackSharpDefault = parcelHelpers.interopDefault(_backpackSharp);
var _backpackTwoTone = require("./BackpackTwoTone");
var _backpackTwoToneDefault = parcelHelpers.interopDefault(_backpackTwoTone);
var _backspace = require("./Backspace");
var _backspaceDefault = parcelHelpers.interopDefault(_backspace);
var _backspaceOutlined = require("./BackspaceOutlined");
var _backspaceOutlinedDefault = parcelHelpers.interopDefault(_backspaceOutlined);
var _backspaceRounded = require("./BackspaceRounded");
var _backspaceRoundedDefault = parcelHelpers.interopDefault(_backspaceRounded);
var _backspaceSharp = require("./BackspaceSharp");
var _backspaceSharpDefault = parcelHelpers.interopDefault(_backspaceSharp);
var _backspaceTwoTone = require("./BackspaceTwoTone");
var _backspaceTwoToneDefault = parcelHelpers.interopDefault(_backspaceTwoTone);
var _backup = require("./Backup");
var _backupDefault = parcelHelpers.interopDefault(_backup);
var _backupOutlined = require("./BackupOutlined");
var _backupOutlinedDefault = parcelHelpers.interopDefault(_backupOutlined);
var _backupRounded = require("./BackupRounded");
var _backupRoundedDefault = parcelHelpers.interopDefault(_backupRounded);
var _backupSharp = require("./BackupSharp");
var _backupSharpDefault = parcelHelpers.interopDefault(_backupSharp);
var _backupTable = require("./BackupTable");
var _backupTableDefault = parcelHelpers.interopDefault(_backupTable);
var _backupTableOutlined = require("./BackupTableOutlined");
var _backupTableOutlinedDefault = parcelHelpers.interopDefault(_backupTableOutlined);
var _backupTableRounded = require("./BackupTableRounded");
var _backupTableRoundedDefault = parcelHelpers.interopDefault(_backupTableRounded);
var _backupTableSharp = require("./BackupTableSharp");
var _backupTableSharpDefault = parcelHelpers.interopDefault(_backupTableSharp);
var _backupTableTwoTone = require("./BackupTableTwoTone");
var _backupTableTwoToneDefault = parcelHelpers.interopDefault(_backupTableTwoTone);
var _backupTwoTone = require("./BackupTwoTone");
var _backupTwoToneDefault = parcelHelpers.interopDefault(_backupTwoTone);
var _badge = require("./Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _badgeOutlined = require("./BadgeOutlined");
var _badgeOutlinedDefault = parcelHelpers.interopDefault(_badgeOutlined);
var _badgeRounded = require("./BadgeRounded");
var _badgeRoundedDefault = parcelHelpers.interopDefault(_badgeRounded);
var _badgeSharp = require("./BadgeSharp");
var _badgeSharpDefault = parcelHelpers.interopDefault(_badgeSharp);
var _badgeTwoTone = require("./BadgeTwoTone");
var _badgeTwoToneDefault = parcelHelpers.interopDefault(_badgeTwoTone);
var _bakeryDining = require("./BakeryDining");
var _bakeryDiningDefault = parcelHelpers.interopDefault(_bakeryDining);
var _bakeryDiningOutlined = require("./BakeryDiningOutlined");
var _bakeryDiningOutlinedDefault = parcelHelpers.interopDefault(_bakeryDiningOutlined);
var _bakeryDiningRounded = require("./BakeryDiningRounded");
var _bakeryDiningRoundedDefault = parcelHelpers.interopDefault(_bakeryDiningRounded);
var _bakeryDiningSharp = require("./BakeryDiningSharp");
var _bakeryDiningSharpDefault = parcelHelpers.interopDefault(_bakeryDiningSharp);
var _bakeryDiningTwoTone = require("./BakeryDiningTwoTone");
var _bakeryDiningTwoToneDefault = parcelHelpers.interopDefault(_bakeryDiningTwoTone);
var _balance = require("./Balance");
var _balanceDefault = parcelHelpers.interopDefault(_balance);
var _balanceOutlined = require("./BalanceOutlined");
var _balanceOutlinedDefault = parcelHelpers.interopDefault(_balanceOutlined);
var _balanceRounded = require("./BalanceRounded");
var _balanceRoundedDefault = parcelHelpers.interopDefault(_balanceRounded);
var _balanceSharp = require("./BalanceSharp");
var _balanceSharpDefault = parcelHelpers.interopDefault(_balanceSharp);
var _balanceTwoTone = require("./BalanceTwoTone");
var _balanceTwoToneDefault = parcelHelpers.interopDefault(_balanceTwoTone);
var _balcony = require("./Balcony");
var _balconyDefault = parcelHelpers.interopDefault(_balcony);
var _balconyOutlined = require("./BalconyOutlined");
var _balconyOutlinedDefault = parcelHelpers.interopDefault(_balconyOutlined);
var _balconyRounded = require("./BalconyRounded");
var _balconyRoundedDefault = parcelHelpers.interopDefault(_balconyRounded);
var _balconySharp = require("./BalconySharp");
var _balconySharpDefault = parcelHelpers.interopDefault(_balconySharp);
var _balconyTwoTone = require("./BalconyTwoTone");
var _balconyTwoToneDefault = parcelHelpers.interopDefault(_balconyTwoTone);
var _ballot = require("./Ballot");
var _ballotDefault = parcelHelpers.interopDefault(_ballot);
var _ballotOutlined = require("./BallotOutlined");
var _ballotOutlinedDefault = parcelHelpers.interopDefault(_ballotOutlined);
var _ballotRounded = require("./BallotRounded");
var _ballotRoundedDefault = parcelHelpers.interopDefault(_ballotRounded);
var _ballotSharp = require("./BallotSharp");
var _ballotSharpDefault = parcelHelpers.interopDefault(_ballotSharp);
var _ballotTwoTone = require("./BallotTwoTone");
var _ballotTwoToneDefault = parcelHelpers.interopDefault(_ballotTwoTone);
var _barChart = require("./BarChart");
var _barChartDefault = parcelHelpers.interopDefault(_barChart);
var _barChartOutlined = require("./BarChartOutlined");
var _barChartOutlinedDefault = parcelHelpers.interopDefault(_barChartOutlined);
var _barChartRounded = require("./BarChartRounded");
var _barChartRoundedDefault = parcelHelpers.interopDefault(_barChartRounded);
var _barChartSharp = require("./BarChartSharp");
var _barChartSharpDefault = parcelHelpers.interopDefault(_barChartSharp);
var _barChartTwoTone = require("./BarChartTwoTone");
var _barChartTwoToneDefault = parcelHelpers.interopDefault(_barChartTwoTone);
var _batchPrediction = require("./BatchPrediction");
var _batchPredictionDefault = parcelHelpers.interopDefault(_batchPrediction);
var _batchPredictionOutlined = require("./BatchPredictionOutlined");
var _batchPredictionOutlinedDefault = parcelHelpers.interopDefault(_batchPredictionOutlined);
var _batchPredictionRounded = require("./BatchPredictionRounded");
var _batchPredictionRoundedDefault = parcelHelpers.interopDefault(_batchPredictionRounded);
var _batchPredictionSharp = require("./BatchPredictionSharp");
var _batchPredictionSharpDefault = parcelHelpers.interopDefault(_batchPredictionSharp);
var _batchPredictionTwoTone = require("./BatchPredictionTwoTone");
var _batchPredictionTwoToneDefault = parcelHelpers.interopDefault(_batchPredictionTwoTone);
var _bathroom = require("./Bathroom");
var _bathroomDefault = parcelHelpers.interopDefault(_bathroom);
var _bathroomOutlined = require("./BathroomOutlined");
var _bathroomOutlinedDefault = parcelHelpers.interopDefault(_bathroomOutlined);
var _bathroomRounded = require("./BathroomRounded");
var _bathroomRoundedDefault = parcelHelpers.interopDefault(_bathroomRounded);
var _bathroomSharp = require("./BathroomSharp");
var _bathroomSharpDefault = parcelHelpers.interopDefault(_bathroomSharp);
var _bathroomTwoTone = require("./BathroomTwoTone");
var _bathroomTwoToneDefault = parcelHelpers.interopDefault(_bathroomTwoTone);
var _bathtub = require("./Bathtub");
var _bathtubDefault = parcelHelpers.interopDefault(_bathtub);
var _bathtubOutlined = require("./BathtubOutlined");
var _bathtubOutlinedDefault = parcelHelpers.interopDefault(_bathtubOutlined);
var _bathtubRounded = require("./BathtubRounded");
var _bathtubRoundedDefault = parcelHelpers.interopDefault(_bathtubRounded);
var _bathtubSharp = require("./BathtubSharp");
var _bathtubSharpDefault = parcelHelpers.interopDefault(_bathtubSharp);
var _bathtubTwoTone = require("./BathtubTwoTone");
var _bathtubTwoToneDefault = parcelHelpers.interopDefault(_bathtubTwoTone);
var _battery0Bar = require("./Battery0Bar");
var _battery0BarDefault = parcelHelpers.interopDefault(_battery0Bar);
var _battery0BarOutlined = require("./Battery0BarOutlined");
var _battery0BarOutlinedDefault = parcelHelpers.interopDefault(_battery0BarOutlined);
var _battery0BarRounded = require("./Battery0BarRounded");
var _battery0BarRoundedDefault = parcelHelpers.interopDefault(_battery0BarRounded);
var _battery0BarSharp = require("./Battery0BarSharp");
var _battery0BarSharpDefault = parcelHelpers.interopDefault(_battery0BarSharp);
var _battery0BarTwoTone = require("./Battery0BarTwoTone");
var _battery0BarTwoToneDefault = parcelHelpers.interopDefault(_battery0BarTwoTone);
var _battery1Bar = require("./Battery1Bar");
var _battery1BarDefault = parcelHelpers.interopDefault(_battery1Bar);
var _battery1BarOutlined = require("./Battery1BarOutlined");
var _battery1BarOutlinedDefault = parcelHelpers.interopDefault(_battery1BarOutlined);
var _battery1BarRounded = require("./Battery1BarRounded");
var _battery1BarRoundedDefault = parcelHelpers.interopDefault(_battery1BarRounded);
var _battery1BarSharp = require("./Battery1BarSharp");
var _battery1BarSharpDefault = parcelHelpers.interopDefault(_battery1BarSharp);
var _battery1BarTwoTone = require("./Battery1BarTwoTone");
var _battery1BarTwoToneDefault = parcelHelpers.interopDefault(_battery1BarTwoTone);
var _battery20 = require("./Battery20");
var _battery20Default = parcelHelpers.interopDefault(_battery20);
var _battery20Outlined = require("./Battery20Outlined");
var _battery20OutlinedDefault = parcelHelpers.interopDefault(_battery20Outlined);
var _battery20Rounded = require("./Battery20Rounded");
var _battery20RoundedDefault = parcelHelpers.interopDefault(_battery20Rounded);
var _battery20Sharp = require("./Battery20Sharp");
var _battery20SharpDefault = parcelHelpers.interopDefault(_battery20Sharp);
var _battery20TwoTone = require("./Battery20TwoTone");
var _battery20TwoToneDefault = parcelHelpers.interopDefault(_battery20TwoTone);
var _battery2Bar = require("./Battery2Bar");
var _battery2BarDefault = parcelHelpers.interopDefault(_battery2Bar);
var _battery2BarOutlined = require("./Battery2BarOutlined");
var _battery2BarOutlinedDefault = parcelHelpers.interopDefault(_battery2BarOutlined);
var _battery2BarRounded = require("./Battery2BarRounded");
var _battery2BarRoundedDefault = parcelHelpers.interopDefault(_battery2BarRounded);
var _battery2BarSharp = require("./Battery2BarSharp");
var _battery2BarSharpDefault = parcelHelpers.interopDefault(_battery2BarSharp);
var _battery2BarTwoTone = require("./Battery2BarTwoTone");
var _battery2BarTwoToneDefault = parcelHelpers.interopDefault(_battery2BarTwoTone);
var _battery30 = require("./Battery30");
var _battery30Default = parcelHelpers.interopDefault(_battery30);
var _battery30Outlined = require("./Battery30Outlined");
var _battery30OutlinedDefault = parcelHelpers.interopDefault(_battery30Outlined);
var _battery30Rounded = require("./Battery30Rounded");
var _battery30RoundedDefault = parcelHelpers.interopDefault(_battery30Rounded);
var _battery30Sharp = require("./Battery30Sharp");
var _battery30SharpDefault = parcelHelpers.interopDefault(_battery30Sharp);
var _battery30TwoTone = require("./Battery30TwoTone");
var _battery30TwoToneDefault = parcelHelpers.interopDefault(_battery30TwoTone);
var _battery3Bar = require("./Battery3Bar");
var _battery3BarDefault = parcelHelpers.interopDefault(_battery3Bar);
var _battery3BarOutlined = require("./Battery3BarOutlined");
var _battery3BarOutlinedDefault = parcelHelpers.interopDefault(_battery3BarOutlined);
var _battery3BarRounded = require("./Battery3BarRounded");
var _battery3BarRoundedDefault = parcelHelpers.interopDefault(_battery3BarRounded);
var _battery3BarSharp = require("./Battery3BarSharp");
var _battery3BarSharpDefault = parcelHelpers.interopDefault(_battery3BarSharp);
var _battery3BarTwoTone = require("./Battery3BarTwoTone");
var _battery3BarTwoToneDefault = parcelHelpers.interopDefault(_battery3BarTwoTone);
var _battery4Bar = require("./Battery4Bar");
var _battery4BarDefault = parcelHelpers.interopDefault(_battery4Bar);
var _battery4BarOutlined = require("./Battery4BarOutlined");
var _battery4BarOutlinedDefault = parcelHelpers.interopDefault(_battery4BarOutlined);
var _battery4BarRounded = require("./Battery4BarRounded");
var _battery4BarRoundedDefault = parcelHelpers.interopDefault(_battery4BarRounded);
var _battery4BarSharp = require("./Battery4BarSharp");
var _battery4BarSharpDefault = parcelHelpers.interopDefault(_battery4BarSharp);
var _battery4BarTwoTone = require("./Battery4BarTwoTone");
var _battery4BarTwoToneDefault = parcelHelpers.interopDefault(_battery4BarTwoTone);
var _battery50 = require("./Battery50");
var _battery50Default = parcelHelpers.interopDefault(_battery50);
var _battery50Outlined = require("./Battery50Outlined");
var _battery50OutlinedDefault = parcelHelpers.interopDefault(_battery50Outlined);
var _battery50Rounded = require("./Battery50Rounded");
var _battery50RoundedDefault = parcelHelpers.interopDefault(_battery50Rounded);
var _battery50Sharp = require("./Battery50Sharp");
var _battery50SharpDefault = parcelHelpers.interopDefault(_battery50Sharp);
var _battery50TwoTone = require("./Battery50TwoTone");
var _battery50TwoToneDefault = parcelHelpers.interopDefault(_battery50TwoTone);
var _battery5Bar = require("./Battery5Bar");
var _battery5BarDefault = parcelHelpers.interopDefault(_battery5Bar);
var _battery5BarOutlined = require("./Battery5BarOutlined");
var _battery5BarOutlinedDefault = parcelHelpers.interopDefault(_battery5BarOutlined);
var _battery5BarRounded = require("./Battery5BarRounded");
var _battery5BarRoundedDefault = parcelHelpers.interopDefault(_battery5BarRounded);
var _battery5BarSharp = require("./Battery5BarSharp");
var _battery5BarSharpDefault = parcelHelpers.interopDefault(_battery5BarSharp);
var _battery5BarTwoTone = require("./Battery5BarTwoTone");
var _battery5BarTwoToneDefault = parcelHelpers.interopDefault(_battery5BarTwoTone);
var _battery60 = require("./Battery60");
var _battery60Default = parcelHelpers.interopDefault(_battery60);
var _battery60Outlined = require("./Battery60Outlined");
var _battery60OutlinedDefault = parcelHelpers.interopDefault(_battery60Outlined);
var _battery60Rounded = require("./Battery60Rounded");
var _battery60RoundedDefault = parcelHelpers.interopDefault(_battery60Rounded);
var _battery60Sharp = require("./Battery60Sharp");
var _battery60SharpDefault = parcelHelpers.interopDefault(_battery60Sharp);
var _battery60TwoTone = require("./Battery60TwoTone");
var _battery60TwoToneDefault = parcelHelpers.interopDefault(_battery60TwoTone);
var _battery6Bar = require("./Battery6Bar");
var _battery6BarDefault = parcelHelpers.interopDefault(_battery6Bar);
var _battery6BarOutlined = require("./Battery6BarOutlined");
var _battery6BarOutlinedDefault = parcelHelpers.interopDefault(_battery6BarOutlined);
var _battery6BarRounded = require("./Battery6BarRounded");
var _battery6BarRoundedDefault = parcelHelpers.interopDefault(_battery6BarRounded);
var _battery6BarSharp = require("./Battery6BarSharp");
var _battery6BarSharpDefault = parcelHelpers.interopDefault(_battery6BarSharp);
var _battery6BarTwoTone = require("./Battery6BarTwoTone");
var _battery6BarTwoToneDefault = parcelHelpers.interopDefault(_battery6BarTwoTone);
var _battery80 = require("./Battery80");
var _battery80Default = parcelHelpers.interopDefault(_battery80);
var _battery80Outlined = require("./Battery80Outlined");
var _battery80OutlinedDefault = parcelHelpers.interopDefault(_battery80Outlined);
var _battery80Rounded = require("./Battery80Rounded");
var _battery80RoundedDefault = parcelHelpers.interopDefault(_battery80Rounded);
var _battery80Sharp = require("./Battery80Sharp");
var _battery80SharpDefault = parcelHelpers.interopDefault(_battery80Sharp);
var _battery80TwoTone = require("./Battery80TwoTone");
var _battery80TwoToneDefault = parcelHelpers.interopDefault(_battery80TwoTone);
var _battery90 = require("./Battery90");
var _battery90Default = parcelHelpers.interopDefault(_battery90);
var _battery90Outlined = require("./Battery90Outlined");
var _battery90OutlinedDefault = parcelHelpers.interopDefault(_battery90Outlined);
var _battery90Rounded = require("./Battery90Rounded");
var _battery90RoundedDefault = parcelHelpers.interopDefault(_battery90Rounded);
var _battery90Sharp = require("./Battery90Sharp");
var _battery90SharpDefault = parcelHelpers.interopDefault(_battery90Sharp);
var _battery90TwoTone = require("./Battery90TwoTone");
var _battery90TwoToneDefault = parcelHelpers.interopDefault(_battery90TwoTone);
var _batteryAlert = require("./BatteryAlert");
var _batteryAlertDefault = parcelHelpers.interopDefault(_batteryAlert);
var _batteryAlertOutlined = require("./BatteryAlertOutlined");
var _batteryAlertOutlinedDefault = parcelHelpers.interopDefault(_batteryAlertOutlined);
var _batteryAlertRounded = require("./BatteryAlertRounded");
var _batteryAlertRoundedDefault = parcelHelpers.interopDefault(_batteryAlertRounded);
var _batteryAlertSharp = require("./BatteryAlertSharp");
var _batteryAlertSharpDefault = parcelHelpers.interopDefault(_batteryAlertSharp);
var _batteryAlertTwoTone = require("./BatteryAlertTwoTone");
var _batteryAlertTwoToneDefault = parcelHelpers.interopDefault(_batteryAlertTwoTone);
var _batteryCharging20 = require("./BatteryCharging20");
var _batteryCharging20Default = parcelHelpers.interopDefault(_batteryCharging20);
var _batteryCharging20Outlined = require("./BatteryCharging20Outlined");
var _batteryCharging20OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging20Outlined);
var _batteryCharging20Rounded = require("./BatteryCharging20Rounded");
var _batteryCharging20RoundedDefault = parcelHelpers.interopDefault(_batteryCharging20Rounded);
var _batteryCharging20Sharp = require("./BatteryCharging20Sharp");
var _batteryCharging20SharpDefault = parcelHelpers.interopDefault(_batteryCharging20Sharp);
var _batteryCharging20TwoTone = require("./BatteryCharging20TwoTone");
var _batteryCharging20TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging20TwoTone);
var _batteryCharging30 = require("./BatteryCharging30");
var _batteryCharging30Default = parcelHelpers.interopDefault(_batteryCharging30);
var _batteryCharging30Outlined = require("./BatteryCharging30Outlined");
var _batteryCharging30OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging30Outlined);
var _batteryCharging30Rounded = require("./BatteryCharging30Rounded");
var _batteryCharging30RoundedDefault = parcelHelpers.interopDefault(_batteryCharging30Rounded);
var _batteryCharging30Sharp = require("./BatteryCharging30Sharp");
var _batteryCharging30SharpDefault = parcelHelpers.interopDefault(_batteryCharging30Sharp);
var _batteryCharging30TwoTone = require("./BatteryCharging30TwoTone");
var _batteryCharging30TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging30TwoTone);
var _batteryCharging50 = require("./BatteryCharging50");
var _batteryCharging50Default = parcelHelpers.interopDefault(_batteryCharging50);
var _batteryCharging50Outlined = require("./BatteryCharging50Outlined");
var _batteryCharging50OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging50Outlined);
var _batteryCharging50Rounded = require("./BatteryCharging50Rounded");
var _batteryCharging50RoundedDefault = parcelHelpers.interopDefault(_batteryCharging50Rounded);
var _batteryCharging50Sharp = require("./BatteryCharging50Sharp");
var _batteryCharging50SharpDefault = parcelHelpers.interopDefault(_batteryCharging50Sharp);
var _batteryCharging50TwoTone = require("./BatteryCharging50TwoTone");
var _batteryCharging50TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging50TwoTone);
var _batteryCharging60 = require("./BatteryCharging60");
var _batteryCharging60Default = parcelHelpers.interopDefault(_batteryCharging60);
var _batteryCharging60Outlined = require("./BatteryCharging60Outlined");
var _batteryCharging60OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging60Outlined);
var _batteryCharging60Rounded = require("./BatteryCharging60Rounded");
var _batteryCharging60RoundedDefault = parcelHelpers.interopDefault(_batteryCharging60Rounded);
var _batteryCharging60Sharp = require("./BatteryCharging60Sharp");
var _batteryCharging60SharpDefault = parcelHelpers.interopDefault(_batteryCharging60Sharp);
var _batteryCharging60TwoTone = require("./BatteryCharging60TwoTone");
var _batteryCharging60TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging60TwoTone);
var _batteryCharging80 = require("./BatteryCharging80");
var _batteryCharging80Default = parcelHelpers.interopDefault(_batteryCharging80);
var _batteryCharging80Outlined = require("./BatteryCharging80Outlined");
var _batteryCharging80OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging80Outlined);
var _batteryCharging80Rounded = require("./BatteryCharging80Rounded");
var _batteryCharging80RoundedDefault = parcelHelpers.interopDefault(_batteryCharging80Rounded);
var _batteryCharging80Sharp = require("./BatteryCharging80Sharp");
var _batteryCharging80SharpDefault = parcelHelpers.interopDefault(_batteryCharging80Sharp);
var _batteryCharging80TwoTone = require("./BatteryCharging80TwoTone");
var _batteryCharging80TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging80TwoTone);
var _batteryCharging90 = require("./BatteryCharging90");
var _batteryCharging90Default = parcelHelpers.interopDefault(_batteryCharging90);
var _batteryCharging90Outlined = require("./BatteryCharging90Outlined");
var _batteryCharging90OutlinedDefault = parcelHelpers.interopDefault(_batteryCharging90Outlined);
var _batteryCharging90Rounded = require("./BatteryCharging90Rounded");
var _batteryCharging90RoundedDefault = parcelHelpers.interopDefault(_batteryCharging90Rounded);
var _batteryCharging90Sharp = require("./BatteryCharging90Sharp");
var _batteryCharging90SharpDefault = parcelHelpers.interopDefault(_batteryCharging90Sharp);
var _batteryCharging90TwoTone = require("./BatteryCharging90TwoTone");
var _batteryCharging90TwoToneDefault = parcelHelpers.interopDefault(_batteryCharging90TwoTone);
var _batteryChargingFull = require("./BatteryChargingFull");
var _batteryChargingFullDefault = parcelHelpers.interopDefault(_batteryChargingFull);
var _batteryChargingFullOutlined = require("./BatteryChargingFullOutlined");
var _batteryChargingFullOutlinedDefault = parcelHelpers.interopDefault(_batteryChargingFullOutlined);
var _batteryChargingFullRounded = require("./BatteryChargingFullRounded");
var _batteryChargingFullRoundedDefault = parcelHelpers.interopDefault(_batteryChargingFullRounded);
var _batteryChargingFullSharp = require("./BatteryChargingFullSharp");
var _batteryChargingFullSharpDefault = parcelHelpers.interopDefault(_batteryChargingFullSharp);
var _batteryChargingFullTwoTone = require("./BatteryChargingFullTwoTone");
var _batteryChargingFullTwoToneDefault = parcelHelpers.interopDefault(_batteryChargingFullTwoTone);
var _batteryFull = require("./BatteryFull");
var _batteryFullDefault = parcelHelpers.interopDefault(_batteryFull);
var _batteryFullOutlined = require("./BatteryFullOutlined");
var _batteryFullOutlinedDefault = parcelHelpers.interopDefault(_batteryFullOutlined);
var _batteryFullRounded = require("./BatteryFullRounded");
var _batteryFullRoundedDefault = parcelHelpers.interopDefault(_batteryFullRounded);
var _batteryFullSharp = require("./BatteryFullSharp");
var _batteryFullSharpDefault = parcelHelpers.interopDefault(_batteryFullSharp);
var _batteryFullTwoTone = require("./BatteryFullTwoTone");
var _batteryFullTwoToneDefault = parcelHelpers.interopDefault(_batteryFullTwoTone);
var _batterySaver = require("./BatterySaver");
var _batterySaverDefault = parcelHelpers.interopDefault(_batterySaver);
var _batterySaverOutlined = require("./BatterySaverOutlined");
var _batterySaverOutlinedDefault = parcelHelpers.interopDefault(_batterySaverOutlined);
var _batterySaverRounded = require("./BatterySaverRounded");
var _batterySaverRoundedDefault = parcelHelpers.interopDefault(_batterySaverRounded);
var _batterySaverSharp = require("./BatterySaverSharp");
var _batterySaverSharpDefault = parcelHelpers.interopDefault(_batterySaverSharp);
var _batterySaverTwoTone = require("./BatterySaverTwoTone");
var _batterySaverTwoToneDefault = parcelHelpers.interopDefault(_batterySaverTwoTone);
var _batteryStd = require("./BatteryStd");
var _batteryStdDefault = parcelHelpers.interopDefault(_batteryStd);
var _batteryStdOutlined = require("./BatteryStdOutlined");
var _batteryStdOutlinedDefault = parcelHelpers.interopDefault(_batteryStdOutlined);
var _batteryStdRounded = require("./BatteryStdRounded");
var _batteryStdRoundedDefault = parcelHelpers.interopDefault(_batteryStdRounded);
var _batteryStdSharp = require("./BatteryStdSharp");
var _batteryStdSharpDefault = parcelHelpers.interopDefault(_batteryStdSharp);
var _batteryStdTwoTone = require("./BatteryStdTwoTone");
var _batteryStdTwoToneDefault = parcelHelpers.interopDefault(_batteryStdTwoTone);
var _batteryUnknown = require("./BatteryUnknown");
var _batteryUnknownDefault = parcelHelpers.interopDefault(_batteryUnknown);
var _batteryUnknownOutlined = require("./BatteryUnknownOutlined");
var _batteryUnknownOutlinedDefault = parcelHelpers.interopDefault(_batteryUnknownOutlined);
var _batteryUnknownRounded = require("./BatteryUnknownRounded");
var _batteryUnknownRoundedDefault = parcelHelpers.interopDefault(_batteryUnknownRounded);
var _batteryUnknownSharp = require("./BatteryUnknownSharp");
var _batteryUnknownSharpDefault = parcelHelpers.interopDefault(_batteryUnknownSharp);
var _batteryUnknownTwoTone = require("./BatteryUnknownTwoTone");
var _batteryUnknownTwoToneDefault = parcelHelpers.interopDefault(_batteryUnknownTwoTone);
var _beachAccess = require("./BeachAccess");
var _beachAccessDefault = parcelHelpers.interopDefault(_beachAccess);
var _beachAccessOutlined = require("./BeachAccessOutlined");
var _beachAccessOutlinedDefault = parcelHelpers.interopDefault(_beachAccessOutlined);
var _beachAccessRounded = require("./BeachAccessRounded");
var _beachAccessRoundedDefault = parcelHelpers.interopDefault(_beachAccessRounded);
var _beachAccessSharp = require("./BeachAccessSharp");
var _beachAccessSharpDefault = parcelHelpers.interopDefault(_beachAccessSharp);
var _beachAccessTwoTone = require("./BeachAccessTwoTone");
var _beachAccessTwoToneDefault = parcelHelpers.interopDefault(_beachAccessTwoTone);
var _bed = require("./Bed");
var _bedDefault = parcelHelpers.interopDefault(_bed);
var _bedOutlined = require("./BedOutlined");
var _bedOutlinedDefault = parcelHelpers.interopDefault(_bedOutlined);
var _bedRounded = require("./BedRounded");
var _bedRoundedDefault = parcelHelpers.interopDefault(_bedRounded);
var _bedSharp = require("./BedSharp");
var _bedSharpDefault = parcelHelpers.interopDefault(_bedSharp);
var _bedTwoTone = require("./BedTwoTone");
var _bedTwoToneDefault = parcelHelpers.interopDefault(_bedTwoTone);
var _bedroomBaby = require("./BedroomBaby");
var _bedroomBabyDefault = parcelHelpers.interopDefault(_bedroomBaby);
var _bedroomBabyOutlined = require("./BedroomBabyOutlined");
var _bedroomBabyOutlinedDefault = parcelHelpers.interopDefault(_bedroomBabyOutlined);
var _bedroomBabyRounded = require("./BedroomBabyRounded");
var _bedroomBabyRoundedDefault = parcelHelpers.interopDefault(_bedroomBabyRounded);
var _bedroomBabySharp = require("./BedroomBabySharp");
var _bedroomBabySharpDefault = parcelHelpers.interopDefault(_bedroomBabySharp);
var _bedroomBabyTwoTone = require("./BedroomBabyTwoTone");
var _bedroomBabyTwoToneDefault = parcelHelpers.interopDefault(_bedroomBabyTwoTone);
var _bedroomChild = require("./BedroomChild");
var _bedroomChildDefault = parcelHelpers.interopDefault(_bedroomChild);
var _bedroomChildOutlined = require("./BedroomChildOutlined");
var _bedroomChildOutlinedDefault = parcelHelpers.interopDefault(_bedroomChildOutlined);
var _bedroomChildRounded = require("./BedroomChildRounded");
var _bedroomChildRoundedDefault = parcelHelpers.interopDefault(_bedroomChildRounded);
var _bedroomChildSharp = require("./BedroomChildSharp");
var _bedroomChildSharpDefault = parcelHelpers.interopDefault(_bedroomChildSharp);
var _bedroomChildTwoTone = require("./BedroomChildTwoTone");
var _bedroomChildTwoToneDefault = parcelHelpers.interopDefault(_bedroomChildTwoTone);
var _bedroomParent = require("./BedroomParent");
var _bedroomParentDefault = parcelHelpers.interopDefault(_bedroomParent);
var _bedroomParentOutlined = require("./BedroomParentOutlined");
var _bedroomParentOutlinedDefault = parcelHelpers.interopDefault(_bedroomParentOutlined);
var _bedroomParentRounded = require("./BedroomParentRounded");
var _bedroomParentRoundedDefault = parcelHelpers.interopDefault(_bedroomParentRounded);
var _bedroomParentSharp = require("./BedroomParentSharp");
var _bedroomParentSharpDefault = parcelHelpers.interopDefault(_bedroomParentSharp);
var _bedroomParentTwoTone = require("./BedroomParentTwoTone");
var _bedroomParentTwoToneDefault = parcelHelpers.interopDefault(_bedroomParentTwoTone);
var _bedtime = require("./Bedtime");
var _bedtimeDefault = parcelHelpers.interopDefault(_bedtime);
var _bedtimeOff = require("./BedtimeOff");
var _bedtimeOffDefault = parcelHelpers.interopDefault(_bedtimeOff);
var _bedtimeOffOutlined = require("./BedtimeOffOutlined");
var _bedtimeOffOutlinedDefault = parcelHelpers.interopDefault(_bedtimeOffOutlined);
var _bedtimeOffRounded = require("./BedtimeOffRounded");
var _bedtimeOffRoundedDefault = parcelHelpers.interopDefault(_bedtimeOffRounded);
var _bedtimeOffSharp = require("./BedtimeOffSharp");
var _bedtimeOffSharpDefault = parcelHelpers.interopDefault(_bedtimeOffSharp);
var _bedtimeOffTwoTone = require("./BedtimeOffTwoTone");
var _bedtimeOffTwoToneDefault = parcelHelpers.interopDefault(_bedtimeOffTwoTone);
var _bedtimeOutlined = require("./BedtimeOutlined");
var _bedtimeOutlinedDefault = parcelHelpers.interopDefault(_bedtimeOutlined);
var _bedtimeRounded = require("./BedtimeRounded");
var _bedtimeRoundedDefault = parcelHelpers.interopDefault(_bedtimeRounded);
var _bedtimeSharp = require("./BedtimeSharp");
var _bedtimeSharpDefault = parcelHelpers.interopDefault(_bedtimeSharp);
var _bedtimeTwoTone = require("./BedtimeTwoTone");
var _bedtimeTwoToneDefault = parcelHelpers.interopDefault(_bedtimeTwoTone);
var _beenhere = require("./Beenhere");
var _beenhereDefault = parcelHelpers.interopDefault(_beenhere);
var _beenhereOutlined = require("./BeenhereOutlined");
var _beenhereOutlinedDefault = parcelHelpers.interopDefault(_beenhereOutlined);
var _beenhereRounded = require("./BeenhereRounded");
var _beenhereRoundedDefault = parcelHelpers.interopDefault(_beenhereRounded);
var _beenhereSharp = require("./BeenhereSharp");
var _beenhereSharpDefault = parcelHelpers.interopDefault(_beenhereSharp);
var _beenhereTwoTone = require("./BeenhereTwoTone");
var _beenhereTwoToneDefault = parcelHelpers.interopDefault(_beenhereTwoTone);
var _bento = require("./Bento");
var _bentoDefault = parcelHelpers.interopDefault(_bento);
var _bentoOutlined = require("./BentoOutlined");
var _bentoOutlinedDefault = parcelHelpers.interopDefault(_bentoOutlined);
var _bentoRounded = require("./BentoRounded");
var _bentoRoundedDefault = parcelHelpers.interopDefault(_bentoRounded);
var _bentoSharp = require("./BentoSharp");
var _bentoSharpDefault = parcelHelpers.interopDefault(_bentoSharp);
var _bentoTwoTone = require("./BentoTwoTone");
var _bentoTwoToneDefault = parcelHelpers.interopDefault(_bentoTwoTone);
var _bikeScooter = require("./BikeScooter");
var _bikeScooterDefault = parcelHelpers.interopDefault(_bikeScooter);
var _bikeScooterOutlined = require("./BikeScooterOutlined");
var _bikeScooterOutlinedDefault = parcelHelpers.interopDefault(_bikeScooterOutlined);
var _bikeScooterRounded = require("./BikeScooterRounded");
var _bikeScooterRoundedDefault = parcelHelpers.interopDefault(_bikeScooterRounded);
var _bikeScooterSharp = require("./BikeScooterSharp");
var _bikeScooterSharpDefault = parcelHelpers.interopDefault(_bikeScooterSharp);
var _bikeScooterTwoTone = require("./BikeScooterTwoTone");
var _bikeScooterTwoToneDefault = parcelHelpers.interopDefault(_bikeScooterTwoTone);
var _biotech = require("./Biotech");
var _biotechDefault = parcelHelpers.interopDefault(_biotech);
var _biotechOutlined = require("./BiotechOutlined");
var _biotechOutlinedDefault = parcelHelpers.interopDefault(_biotechOutlined);
var _biotechRounded = require("./BiotechRounded");
var _biotechRoundedDefault = parcelHelpers.interopDefault(_biotechRounded);
var _biotechSharp = require("./BiotechSharp");
var _biotechSharpDefault = parcelHelpers.interopDefault(_biotechSharp);
var _biotechTwoTone = require("./BiotechTwoTone");
var _biotechTwoToneDefault = parcelHelpers.interopDefault(_biotechTwoTone);
var _blender = require("./Blender");
var _blenderDefault = parcelHelpers.interopDefault(_blender);
var _blenderOutlined = require("./BlenderOutlined");
var _blenderOutlinedDefault = parcelHelpers.interopDefault(_blenderOutlined);
var _blenderRounded = require("./BlenderRounded");
var _blenderRoundedDefault = parcelHelpers.interopDefault(_blenderRounded);
var _blenderSharp = require("./BlenderSharp");
var _blenderSharpDefault = parcelHelpers.interopDefault(_blenderSharp);
var _blenderTwoTone = require("./BlenderTwoTone");
var _blenderTwoToneDefault = parcelHelpers.interopDefault(_blenderTwoTone);
var _blind = require("./Blind");
var _blindDefault = parcelHelpers.interopDefault(_blind);
var _blindOutlined = require("./BlindOutlined");
var _blindOutlinedDefault = parcelHelpers.interopDefault(_blindOutlined);
var _blindRounded = require("./BlindRounded");
var _blindRoundedDefault = parcelHelpers.interopDefault(_blindRounded);
var _blindSharp = require("./BlindSharp");
var _blindSharpDefault = parcelHelpers.interopDefault(_blindSharp);
var _blindTwoTone = require("./BlindTwoTone");
var _blindTwoToneDefault = parcelHelpers.interopDefault(_blindTwoTone);
var _blinds = require("./Blinds");
var _blindsDefault = parcelHelpers.interopDefault(_blinds);
var _blindsClosed = require("./BlindsClosed");
var _blindsClosedDefault = parcelHelpers.interopDefault(_blindsClosed);
var _blindsClosedOutlined = require("./BlindsClosedOutlined");
var _blindsClosedOutlinedDefault = parcelHelpers.interopDefault(_blindsClosedOutlined);
var _blindsClosedRounded = require("./BlindsClosedRounded");
var _blindsClosedRoundedDefault = parcelHelpers.interopDefault(_blindsClosedRounded);
var _blindsClosedSharp = require("./BlindsClosedSharp");
var _blindsClosedSharpDefault = parcelHelpers.interopDefault(_blindsClosedSharp);
var _blindsClosedTwoTone = require("./BlindsClosedTwoTone");
var _blindsClosedTwoToneDefault = parcelHelpers.interopDefault(_blindsClosedTwoTone);
var _blindsOutlined = require("./BlindsOutlined");
var _blindsOutlinedDefault = parcelHelpers.interopDefault(_blindsOutlined);
var _blindsRounded = require("./BlindsRounded");
var _blindsRoundedDefault = parcelHelpers.interopDefault(_blindsRounded);
var _blindsSharp = require("./BlindsSharp");
var _blindsSharpDefault = parcelHelpers.interopDefault(_blindsSharp);
var _blindsTwoTone = require("./BlindsTwoTone");
var _blindsTwoToneDefault = parcelHelpers.interopDefault(_blindsTwoTone);
var _block = require("./Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _blockOutlined = require("./BlockOutlined");
var _blockOutlinedDefault = parcelHelpers.interopDefault(_blockOutlined);
var _blockRounded = require("./BlockRounded");
var _blockRoundedDefault = parcelHelpers.interopDefault(_blockRounded);
var _blockSharp = require("./BlockSharp");
var _blockSharpDefault = parcelHelpers.interopDefault(_blockSharp);
var _blockTwoTone = require("./BlockTwoTone");
var _blockTwoToneDefault = parcelHelpers.interopDefault(_blockTwoTone);
var _bloodtype = require("./Bloodtype");
var _bloodtypeDefault = parcelHelpers.interopDefault(_bloodtype);
var _bloodtypeOutlined = require("./BloodtypeOutlined");
var _bloodtypeOutlinedDefault = parcelHelpers.interopDefault(_bloodtypeOutlined);
var _bloodtypeRounded = require("./BloodtypeRounded");
var _bloodtypeRoundedDefault = parcelHelpers.interopDefault(_bloodtypeRounded);
var _bloodtypeSharp = require("./BloodtypeSharp");
var _bloodtypeSharpDefault = parcelHelpers.interopDefault(_bloodtypeSharp);
var _bloodtypeTwoTone = require("./BloodtypeTwoTone");
var _bloodtypeTwoToneDefault = parcelHelpers.interopDefault(_bloodtypeTwoTone);
var _bluetooth = require("./Bluetooth");
var _bluetoothDefault = parcelHelpers.interopDefault(_bluetooth);
var _bluetoothAudio = require("./BluetoothAudio");
var _bluetoothAudioDefault = parcelHelpers.interopDefault(_bluetoothAudio);
var _bluetoothAudioOutlined = require("./BluetoothAudioOutlined");
var _bluetoothAudioOutlinedDefault = parcelHelpers.interopDefault(_bluetoothAudioOutlined);
var _bluetoothAudioRounded = require("./BluetoothAudioRounded");
var _bluetoothAudioRoundedDefault = parcelHelpers.interopDefault(_bluetoothAudioRounded);
var _bluetoothAudioSharp = require("./BluetoothAudioSharp");
var _bluetoothAudioSharpDefault = parcelHelpers.interopDefault(_bluetoothAudioSharp);
var _bluetoothAudioTwoTone = require("./BluetoothAudioTwoTone");
var _bluetoothAudioTwoToneDefault = parcelHelpers.interopDefault(_bluetoothAudioTwoTone);
var _bluetoothConnected = require("./BluetoothConnected");
var _bluetoothConnectedDefault = parcelHelpers.interopDefault(_bluetoothConnected);
var _bluetoothConnectedOutlined = require("./BluetoothConnectedOutlined");
var _bluetoothConnectedOutlinedDefault = parcelHelpers.interopDefault(_bluetoothConnectedOutlined);
var _bluetoothConnectedRounded = require("./BluetoothConnectedRounded");
var _bluetoothConnectedRoundedDefault = parcelHelpers.interopDefault(_bluetoothConnectedRounded);
var _bluetoothConnectedSharp = require("./BluetoothConnectedSharp");
var _bluetoothConnectedSharpDefault = parcelHelpers.interopDefault(_bluetoothConnectedSharp);
var _bluetoothConnectedTwoTone = require("./BluetoothConnectedTwoTone");
var _bluetoothConnectedTwoToneDefault = parcelHelpers.interopDefault(_bluetoothConnectedTwoTone);
var _bluetoothDisabled = require("./BluetoothDisabled");
var _bluetoothDisabledDefault = parcelHelpers.interopDefault(_bluetoothDisabled);
var _bluetoothDisabledOutlined = require("./BluetoothDisabledOutlined");
var _bluetoothDisabledOutlinedDefault = parcelHelpers.interopDefault(_bluetoothDisabledOutlined);
var _bluetoothDisabledRounded = require("./BluetoothDisabledRounded");
var _bluetoothDisabledRoundedDefault = parcelHelpers.interopDefault(_bluetoothDisabledRounded);
var _bluetoothDisabledSharp = require("./BluetoothDisabledSharp");
var _bluetoothDisabledSharpDefault = parcelHelpers.interopDefault(_bluetoothDisabledSharp);
var _bluetoothDisabledTwoTone = require("./BluetoothDisabledTwoTone");
var _bluetoothDisabledTwoToneDefault = parcelHelpers.interopDefault(_bluetoothDisabledTwoTone);
var _bluetoothDrive = require("./BluetoothDrive");
var _bluetoothDriveDefault = parcelHelpers.interopDefault(_bluetoothDrive);
var _bluetoothDriveOutlined = require("./BluetoothDriveOutlined");
var _bluetoothDriveOutlinedDefault = parcelHelpers.interopDefault(_bluetoothDriveOutlined);
var _bluetoothDriveRounded = require("./BluetoothDriveRounded");
var _bluetoothDriveRoundedDefault = parcelHelpers.interopDefault(_bluetoothDriveRounded);
var _bluetoothDriveSharp = require("./BluetoothDriveSharp");
var _bluetoothDriveSharpDefault = parcelHelpers.interopDefault(_bluetoothDriveSharp);
var _bluetoothDriveTwoTone = require("./BluetoothDriveTwoTone");
var _bluetoothDriveTwoToneDefault = parcelHelpers.interopDefault(_bluetoothDriveTwoTone);
var _bluetoothOutlined = require("./BluetoothOutlined");
var _bluetoothOutlinedDefault = parcelHelpers.interopDefault(_bluetoothOutlined);
var _bluetoothRounded = require("./BluetoothRounded");
var _bluetoothRoundedDefault = parcelHelpers.interopDefault(_bluetoothRounded);
var _bluetoothSearching = require("./BluetoothSearching");
var _bluetoothSearchingDefault = parcelHelpers.interopDefault(_bluetoothSearching);
var _bluetoothSearchingOutlined = require("./BluetoothSearchingOutlined");
var _bluetoothSearchingOutlinedDefault = parcelHelpers.interopDefault(_bluetoothSearchingOutlined);
var _bluetoothSearchingRounded = require("./BluetoothSearchingRounded");
var _bluetoothSearchingRoundedDefault = parcelHelpers.interopDefault(_bluetoothSearchingRounded);
var _bluetoothSearchingSharp = require("./BluetoothSearchingSharp");
var _bluetoothSearchingSharpDefault = parcelHelpers.interopDefault(_bluetoothSearchingSharp);
var _bluetoothSearchingTwoTone = require("./BluetoothSearchingTwoTone");
var _bluetoothSearchingTwoToneDefault = parcelHelpers.interopDefault(_bluetoothSearchingTwoTone);
var _bluetoothSharp = require("./BluetoothSharp");
var _bluetoothSharpDefault = parcelHelpers.interopDefault(_bluetoothSharp);
var _bluetoothTwoTone = require("./BluetoothTwoTone");
var _bluetoothTwoToneDefault = parcelHelpers.interopDefault(_bluetoothTwoTone);
var _blurCircular = require("./BlurCircular");
var _blurCircularDefault = parcelHelpers.interopDefault(_blurCircular);
var _blurCircularOutlined = require("./BlurCircularOutlined");
var _blurCircularOutlinedDefault = parcelHelpers.interopDefault(_blurCircularOutlined);
var _blurCircularRounded = require("./BlurCircularRounded");
var _blurCircularRoundedDefault = parcelHelpers.interopDefault(_blurCircularRounded);
var _blurCircularSharp = require("./BlurCircularSharp");
var _blurCircularSharpDefault = parcelHelpers.interopDefault(_blurCircularSharp);
var _blurCircularTwoTone = require("./BlurCircularTwoTone");
var _blurCircularTwoToneDefault = parcelHelpers.interopDefault(_blurCircularTwoTone);
var _blurLinear = require("./BlurLinear");
var _blurLinearDefault = parcelHelpers.interopDefault(_blurLinear);
var _blurLinearOutlined = require("./BlurLinearOutlined");
var _blurLinearOutlinedDefault = parcelHelpers.interopDefault(_blurLinearOutlined);
var _blurLinearRounded = require("./BlurLinearRounded");
var _blurLinearRoundedDefault = parcelHelpers.interopDefault(_blurLinearRounded);
var _blurLinearSharp = require("./BlurLinearSharp");
var _blurLinearSharpDefault = parcelHelpers.interopDefault(_blurLinearSharp);
var _blurLinearTwoTone = require("./BlurLinearTwoTone");
var _blurLinearTwoToneDefault = parcelHelpers.interopDefault(_blurLinearTwoTone);
var _blurOff = require("./BlurOff");
var _blurOffDefault = parcelHelpers.interopDefault(_blurOff);
var _blurOffOutlined = require("./BlurOffOutlined");
var _blurOffOutlinedDefault = parcelHelpers.interopDefault(_blurOffOutlined);
var _blurOffRounded = require("./BlurOffRounded");
var _blurOffRoundedDefault = parcelHelpers.interopDefault(_blurOffRounded);
var _blurOffSharp = require("./BlurOffSharp");
var _blurOffSharpDefault = parcelHelpers.interopDefault(_blurOffSharp);
var _blurOffTwoTone = require("./BlurOffTwoTone");
var _blurOffTwoToneDefault = parcelHelpers.interopDefault(_blurOffTwoTone);
var _blurOn = require("./BlurOn");
var _blurOnDefault = parcelHelpers.interopDefault(_blurOn);
var _blurOnOutlined = require("./BlurOnOutlined");
var _blurOnOutlinedDefault = parcelHelpers.interopDefault(_blurOnOutlined);
var _blurOnRounded = require("./BlurOnRounded");
var _blurOnRoundedDefault = parcelHelpers.interopDefault(_blurOnRounded);
var _blurOnSharp = require("./BlurOnSharp");
var _blurOnSharpDefault = parcelHelpers.interopDefault(_blurOnSharp);
var _blurOnTwoTone = require("./BlurOnTwoTone");
var _blurOnTwoToneDefault = parcelHelpers.interopDefault(_blurOnTwoTone);
var _bolt = require("./Bolt");
var _boltDefault = parcelHelpers.interopDefault(_bolt);
var _boltOutlined = require("./BoltOutlined");
var _boltOutlinedDefault = parcelHelpers.interopDefault(_boltOutlined);
var _boltRounded = require("./BoltRounded");
var _boltRoundedDefault = parcelHelpers.interopDefault(_boltRounded);
var _boltSharp = require("./BoltSharp");
var _boltSharpDefault = parcelHelpers.interopDefault(_boltSharp);
var _boltTwoTone = require("./BoltTwoTone");
var _boltTwoToneDefault = parcelHelpers.interopDefault(_boltTwoTone);
var _book = require("./Book");
var _bookDefault = parcelHelpers.interopDefault(_book);
var _bookOnline = require("./BookOnline");
var _bookOnlineDefault = parcelHelpers.interopDefault(_bookOnline);
var _bookOnlineOutlined = require("./BookOnlineOutlined");
var _bookOnlineOutlinedDefault = parcelHelpers.interopDefault(_bookOnlineOutlined);
var _bookOnlineRounded = require("./BookOnlineRounded");
var _bookOnlineRoundedDefault = parcelHelpers.interopDefault(_bookOnlineRounded);
var _bookOnlineSharp = require("./BookOnlineSharp");
var _bookOnlineSharpDefault = parcelHelpers.interopDefault(_bookOnlineSharp);
var _bookOnlineTwoTone = require("./BookOnlineTwoTone");
var _bookOnlineTwoToneDefault = parcelHelpers.interopDefault(_bookOnlineTwoTone);
var _bookOutlined = require("./BookOutlined");
var _bookOutlinedDefault = parcelHelpers.interopDefault(_bookOutlined);
var _bookRounded = require("./BookRounded");
var _bookRoundedDefault = parcelHelpers.interopDefault(_bookRounded);
var _bookSharp = require("./BookSharp");
var _bookSharpDefault = parcelHelpers.interopDefault(_bookSharp);
var _bookTwoTone = require("./BookTwoTone");
var _bookTwoToneDefault = parcelHelpers.interopDefault(_bookTwoTone);
var _bookmark = require("./Bookmark");
var _bookmarkDefault = parcelHelpers.interopDefault(_bookmark);
var _bookmarkAdd = require("./BookmarkAdd");
var _bookmarkAddDefault = parcelHelpers.interopDefault(_bookmarkAdd);
var _bookmarkAddOutlined = require("./BookmarkAddOutlined");
var _bookmarkAddOutlinedDefault = parcelHelpers.interopDefault(_bookmarkAddOutlined);
var _bookmarkAddRounded = require("./BookmarkAddRounded");
var _bookmarkAddRoundedDefault = parcelHelpers.interopDefault(_bookmarkAddRounded);
var _bookmarkAddSharp = require("./BookmarkAddSharp");
var _bookmarkAddSharpDefault = parcelHelpers.interopDefault(_bookmarkAddSharp);
var _bookmarkAddTwoTone = require("./BookmarkAddTwoTone");
var _bookmarkAddTwoToneDefault = parcelHelpers.interopDefault(_bookmarkAddTwoTone);
var _bookmarkAdded = require("./BookmarkAdded");
var _bookmarkAddedDefault = parcelHelpers.interopDefault(_bookmarkAdded);
var _bookmarkAddedOutlined = require("./BookmarkAddedOutlined");
var _bookmarkAddedOutlinedDefault = parcelHelpers.interopDefault(_bookmarkAddedOutlined);
var _bookmarkAddedRounded = require("./BookmarkAddedRounded");
var _bookmarkAddedRoundedDefault = parcelHelpers.interopDefault(_bookmarkAddedRounded);
var _bookmarkAddedSharp = require("./BookmarkAddedSharp");
var _bookmarkAddedSharpDefault = parcelHelpers.interopDefault(_bookmarkAddedSharp);
var _bookmarkAddedTwoTone = require("./BookmarkAddedTwoTone");
var _bookmarkAddedTwoToneDefault = parcelHelpers.interopDefault(_bookmarkAddedTwoTone);
var _bookmarkBorder = require("./BookmarkBorder");
var _bookmarkBorderDefault = parcelHelpers.interopDefault(_bookmarkBorder);
var _bookmarkBorderOutlined = require("./BookmarkBorderOutlined");
var _bookmarkBorderOutlinedDefault = parcelHelpers.interopDefault(_bookmarkBorderOutlined);
var _bookmarkBorderRounded = require("./BookmarkBorderRounded");
var _bookmarkBorderRoundedDefault = parcelHelpers.interopDefault(_bookmarkBorderRounded);
var _bookmarkBorderSharp = require("./BookmarkBorderSharp");
var _bookmarkBorderSharpDefault = parcelHelpers.interopDefault(_bookmarkBorderSharp);
var _bookmarkBorderTwoTone = require("./BookmarkBorderTwoTone");
var _bookmarkBorderTwoToneDefault = parcelHelpers.interopDefault(_bookmarkBorderTwoTone);
var _bookmarkOutlined = require("./BookmarkOutlined");
var _bookmarkOutlinedDefault = parcelHelpers.interopDefault(_bookmarkOutlined);
var _bookmarkRemove = require("./BookmarkRemove");
var _bookmarkRemoveDefault = parcelHelpers.interopDefault(_bookmarkRemove);
var _bookmarkRemoveOutlined = require("./BookmarkRemoveOutlined");
var _bookmarkRemoveOutlinedDefault = parcelHelpers.interopDefault(_bookmarkRemoveOutlined);
var _bookmarkRemoveRounded = require("./BookmarkRemoveRounded");
var _bookmarkRemoveRoundedDefault = parcelHelpers.interopDefault(_bookmarkRemoveRounded);
var _bookmarkRemoveSharp = require("./BookmarkRemoveSharp");
var _bookmarkRemoveSharpDefault = parcelHelpers.interopDefault(_bookmarkRemoveSharp);
var _bookmarkRemoveTwoTone = require("./BookmarkRemoveTwoTone");
var _bookmarkRemoveTwoToneDefault = parcelHelpers.interopDefault(_bookmarkRemoveTwoTone);
var _bookmarkRounded = require("./BookmarkRounded");
var _bookmarkRoundedDefault = parcelHelpers.interopDefault(_bookmarkRounded);
var _bookmarkSharp = require("./BookmarkSharp");
var _bookmarkSharpDefault = parcelHelpers.interopDefault(_bookmarkSharp);
var _bookmarkTwoTone = require("./BookmarkTwoTone");
var _bookmarkTwoToneDefault = parcelHelpers.interopDefault(_bookmarkTwoTone);
var _bookmarks = require("./Bookmarks");
var _bookmarksDefault = parcelHelpers.interopDefault(_bookmarks);
var _bookmarksOutlined = require("./BookmarksOutlined");
var _bookmarksOutlinedDefault = parcelHelpers.interopDefault(_bookmarksOutlined);
var _bookmarksRounded = require("./BookmarksRounded");
var _bookmarksRoundedDefault = parcelHelpers.interopDefault(_bookmarksRounded);
var _bookmarksSharp = require("./BookmarksSharp");
var _bookmarksSharpDefault = parcelHelpers.interopDefault(_bookmarksSharp);
var _bookmarksTwoTone = require("./BookmarksTwoTone");
var _bookmarksTwoToneDefault = parcelHelpers.interopDefault(_bookmarksTwoTone);
var _borderAll = require("./BorderAll");
var _borderAllDefault = parcelHelpers.interopDefault(_borderAll);
var _borderAllOutlined = require("./BorderAllOutlined");
var _borderAllOutlinedDefault = parcelHelpers.interopDefault(_borderAllOutlined);
var _borderAllRounded = require("./BorderAllRounded");
var _borderAllRoundedDefault = parcelHelpers.interopDefault(_borderAllRounded);
var _borderAllSharp = require("./BorderAllSharp");
var _borderAllSharpDefault = parcelHelpers.interopDefault(_borderAllSharp);
var _borderAllTwoTone = require("./BorderAllTwoTone");
var _borderAllTwoToneDefault = parcelHelpers.interopDefault(_borderAllTwoTone);
var _borderBottom = require("./BorderBottom");
var _borderBottomDefault = parcelHelpers.interopDefault(_borderBottom);
var _borderBottomOutlined = require("./BorderBottomOutlined");
var _borderBottomOutlinedDefault = parcelHelpers.interopDefault(_borderBottomOutlined);
var _borderBottomRounded = require("./BorderBottomRounded");
var _borderBottomRoundedDefault = parcelHelpers.interopDefault(_borderBottomRounded);
var _borderBottomSharp = require("./BorderBottomSharp");
var _borderBottomSharpDefault = parcelHelpers.interopDefault(_borderBottomSharp);
var _borderBottomTwoTone = require("./BorderBottomTwoTone");
var _borderBottomTwoToneDefault = parcelHelpers.interopDefault(_borderBottomTwoTone);
var _borderClear = require("./BorderClear");
var _borderClearDefault = parcelHelpers.interopDefault(_borderClear);
var _borderClearOutlined = require("./BorderClearOutlined");
var _borderClearOutlinedDefault = parcelHelpers.interopDefault(_borderClearOutlined);
var _borderClearRounded = require("./BorderClearRounded");
var _borderClearRoundedDefault = parcelHelpers.interopDefault(_borderClearRounded);
var _borderClearSharp = require("./BorderClearSharp");
var _borderClearSharpDefault = parcelHelpers.interopDefault(_borderClearSharp);
var _borderClearTwoTone = require("./BorderClearTwoTone");
var _borderClearTwoToneDefault = parcelHelpers.interopDefault(_borderClearTwoTone);
var _borderColor = require("./BorderColor");
var _borderColorDefault = parcelHelpers.interopDefault(_borderColor);
var _borderColorOutlined = require("./BorderColorOutlined");
var _borderColorOutlinedDefault = parcelHelpers.interopDefault(_borderColorOutlined);
var _borderColorRounded = require("./BorderColorRounded");
var _borderColorRoundedDefault = parcelHelpers.interopDefault(_borderColorRounded);
var _borderColorSharp = require("./BorderColorSharp");
var _borderColorSharpDefault = parcelHelpers.interopDefault(_borderColorSharp);
var _borderColorTwoTone = require("./BorderColorTwoTone");
var _borderColorTwoToneDefault = parcelHelpers.interopDefault(_borderColorTwoTone);
var _borderHorizontal = require("./BorderHorizontal");
var _borderHorizontalDefault = parcelHelpers.interopDefault(_borderHorizontal);
var _borderHorizontalOutlined = require("./BorderHorizontalOutlined");
var _borderHorizontalOutlinedDefault = parcelHelpers.interopDefault(_borderHorizontalOutlined);
var _borderHorizontalRounded = require("./BorderHorizontalRounded");
var _borderHorizontalRoundedDefault = parcelHelpers.interopDefault(_borderHorizontalRounded);
var _borderHorizontalSharp = require("./BorderHorizontalSharp");
var _borderHorizontalSharpDefault = parcelHelpers.interopDefault(_borderHorizontalSharp);
var _borderHorizontalTwoTone = require("./BorderHorizontalTwoTone");
var _borderHorizontalTwoToneDefault = parcelHelpers.interopDefault(_borderHorizontalTwoTone);
var _borderInner = require("./BorderInner");
var _borderInnerDefault = parcelHelpers.interopDefault(_borderInner);
var _borderInnerOutlined = require("./BorderInnerOutlined");
var _borderInnerOutlinedDefault = parcelHelpers.interopDefault(_borderInnerOutlined);
var _borderInnerRounded = require("./BorderInnerRounded");
var _borderInnerRoundedDefault = parcelHelpers.interopDefault(_borderInnerRounded);
var _borderInnerSharp = require("./BorderInnerSharp");
var _borderInnerSharpDefault = parcelHelpers.interopDefault(_borderInnerSharp);
var _borderInnerTwoTone = require("./BorderInnerTwoTone");
var _borderInnerTwoToneDefault = parcelHelpers.interopDefault(_borderInnerTwoTone);
var _borderLeft = require("./BorderLeft");
var _borderLeftDefault = parcelHelpers.interopDefault(_borderLeft);
var _borderLeftOutlined = require("./BorderLeftOutlined");
var _borderLeftOutlinedDefault = parcelHelpers.interopDefault(_borderLeftOutlined);
var _borderLeftRounded = require("./BorderLeftRounded");
var _borderLeftRoundedDefault = parcelHelpers.interopDefault(_borderLeftRounded);
var _borderLeftSharp = require("./BorderLeftSharp");
var _borderLeftSharpDefault = parcelHelpers.interopDefault(_borderLeftSharp);
var _borderLeftTwoTone = require("./BorderLeftTwoTone");
var _borderLeftTwoToneDefault = parcelHelpers.interopDefault(_borderLeftTwoTone);
var _borderOuter = require("./BorderOuter");
var _borderOuterDefault = parcelHelpers.interopDefault(_borderOuter);
var _borderOuterOutlined = require("./BorderOuterOutlined");
var _borderOuterOutlinedDefault = parcelHelpers.interopDefault(_borderOuterOutlined);
var _borderOuterRounded = require("./BorderOuterRounded");
var _borderOuterRoundedDefault = parcelHelpers.interopDefault(_borderOuterRounded);
var _borderOuterSharp = require("./BorderOuterSharp");
var _borderOuterSharpDefault = parcelHelpers.interopDefault(_borderOuterSharp);
var _borderOuterTwoTone = require("./BorderOuterTwoTone");
var _borderOuterTwoToneDefault = parcelHelpers.interopDefault(_borderOuterTwoTone);
var _borderRight = require("./BorderRight");
var _borderRightDefault = parcelHelpers.interopDefault(_borderRight);
var _borderRightOutlined = require("./BorderRightOutlined");
var _borderRightOutlinedDefault = parcelHelpers.interopDefault(_borderRightOutlined);
var _borderRightRounded = require("./BorderRightRounded");
var _borderRightRoundedDefault = parcelHelpers.interopDefault(_borderRightRounded);
var _borderRightSharp = require("./BorderRightSharp");
var _borderRightSharpDefault = parcelHelpers.interopDefault(_borderRightSharp);
var _borderRightTwoTone = require("./BorderRightTwoTone");
var _borderRightTwoToneDefault = parcelHelpers.interopDefault(_borderRightTwoTone);
var _borderStyle = require("./BorderStyle");
var _borderStyleDefault = parcelHelpers.interopDefault(_borderStyle);
var _borderStyleOutlined = require("./BorderStyleOutlined");
var _borderStyleOutlinedDefault = parcelHelpers.interopDefault(_borderStyleOutlined);
var _borderStyleRounded = require("./BorderStyleRounded");
var _borderStyleRoundedDefault = parcelHelpers.interopDefault(_borderStyleRounded);
var _borderStyleSharp = require("./BorderStyleSharp");
var _borderStyleSharpDefault = parcelHelpers.interopDefault(_borderStyleSharp);
var _borderStyleTwoTone = require("./BorderStyleTwoTone");
var _borderStyleTwoToneDefault = parcelHelpers.interopDefault(_borderStyleTwoTone);
var _borderTop = require("./BorderTop");
var _borderTopDefault = parcelHelpers.interopDefault(_borderTop);
var _borderTopOutlined = require("./BorderTopOutlined");
var _borderTopOutlinedDefault = parcelHelpers.interopDefault(_borderTopOutlined);
var _borderTopRounded = require("./BorderTopRounded");
var _borderTopRoundedDefault = parcelHelpers.interopDefault(_borderTopRounded);
var _borderTopSharp = require("./BorderTopSharp");
var _borderTopSharpDefault = parcelHelpers.interopDefault(_borderTopSharp);
var _borderTopTwoTone = require("./BorderTopTwoTone");
var _borderTopTwoToneDefault = parcelHelpers.interopDefault(_borderTopTwoTone);
var _borderVertical = require("./BorderVertical");
var _borderVerticalDefault = parcelHelpers.interopDefault(_borderVertical);
var _borderVerticalOutlined = require("./BorderVerticalOutlined");
var _borderVerticalOutlinedDefault = parcelHelpers.interopDefault(_borderVerticalOutlined);
var _borderVerticalRounded = require("./BorderVerticalRounded");
var _borderVerticalRoundedDefault = parcelHelpers.interopDefault(_borderVerticalRounded);
var _borderVerticalSharp = require("./BorderVerticalSharp");
var _borderVerticalSharpDefault = parcelHelpers.interopDefault(_borderVerticalSharp);
var _borderVerticalTwoTone = require("./BorderVerticalTwoTone");
var _borderVerticalTwoToneDefault = parcelHelpers.interopDefault(_borderVerticalTwoTone);
var _boy = require("./Boy");
var _boyDefault = parcelHelpers.interopDefault(_boy);
var _boyOutlined = require("./BoyOutlined");
var _boyOutlinedDefault = parcelHelpers.interopDefault(_boyOutlined);
var _boyRounded = require("./BoyRounded");
var _boyRoundedDefault = parcelHelpers.interopDefault(_boyRounded);
var _boySharp = require("./BoySharp");
var _boySharpDefault = parcelHelpers.interopDefault(_boySharp);
var _boyTwoTone = require("./BoyTwoTone");
var _boyTwoToneDefault = parcelHelpers.interopDefault(_boyTwoTone);
var _brandingWatermark = require("./BrandingWatermark");
var _brandingWatermarkDefault = parcelHelpers.interopDefault(_brandingWatermark);
var _brandingWatermarkOutlined = require("./BrandingWatermarkOutlined");
var _brandingWatermarkOutlinedDefault = parcelHelpers.interopDefault(_brandingWatermarkOutlined);
var _brandingWatermarkRounded = require("./BrandingWatermarkRounded");
var _brandingWatermarkRoundedDefault = parcelHelpers.interopDefault(_brandingWatermarkRounded);
var _brandingWatermarkSharp = require("./BrandingWatermarkSharp");
var _brandingWatermarkSharpDefault = parcelHelpers.interopDefault(_brandingWatermarkSharp);
var _brandingWatermarkTwoTone = require("./BrandingWatermarkTwoTone");
var _brandingWatermarkTwoToneDefault = parcelHelpers.interopDefault(_brandingWatermarkTwoTone);
var _breakfastDining = require("./BreakfastDining");
var _breakfastDiningDefault = parcelHelpers.interopDefault(_breakfastDining);
var _breakfastDiningOutlined = require("./BreakfastDiningOutlined");
var _breakfastDiningOutlinedDefault = parcelHelpers.interopDefault(_breakfastDiningOutlined);
var _breakfastDiningRounded = require("./BreakfastDiningRounded");
var _breakfastDiningRoundedDefault = parcelHelpers.interopDefault(_breakfastDiningRounded);
var _breakfastDiningSharp = require("./BreakfastDiningSharp");
var _breakfastDiningSharpDefault = parcelHelpers.interopDefault(_breakfastDiningSharp);
var _breakfastDiningTwoTone = require("./BreakfastDiningTwoTone");
var _breakfastDiningTwoToneDefault = parcelHelpers.interopDefault(_breakfastDiningTwoTone);
var _brightness1 = require("./Brightness1");
var _brightness1Default = parcelHelpers.interopDefault(_brightness1);
var _brightness1Outlined = require("./Brightness1Outlined");
var _brightness1OutlinedDefault = parcelHelpers.interopDefault(_brightness1Outlined);
var _brightness1Rounded = require("./Brightness1Rounded");
var _brightness1RoundedDefault = parcelHelpers.interopDefault(_brightness1Rounded);
var _brightness1Sharp = require("./Brightness1Sharp");
var _brightness1SharpDefault = parcelHelpers.interopDefault(_brightness1Sharp);
var _brightness1TwoTone = require("./Brightness1TwoTone");
var _brightness1TwoToneDefault = parcelHelpers.interopDefault(_brightness1TwoTone);
var _brightness2 = require("./Brightness2");
var _brightness2Default = parcelHelpers.interopDefault(_brightness2);
var _brightness2Outlined = require("./Brightness2Outlined");
var _brightness2OutlinedDefault = parcelHelpers.interopDefault(_brightness2Outlined);
var _brightness2Rounded = require("./Brightness2Rounded");
var _brightness2RoundedDefault = parcelHelpers.interopDefault(_brightness2Rounded);
var _brightness2Sharp = require("./Brightness2Sharp");
var _brightness2SharpDefault = parcelHelpers.interopDefault(_brightness2Sharp);
var _brightness2TwoTone = require("./Brightness2TwoTone");
var _brightness2TwoToneDefault = parcelHelpers.interopDefault(_brightness2TwoTone);
var _brightness3 = require("./Brightness3");
var _brightness3Default = parcelHelpers.interopDefault(_brightness3);
var _brightness3Outlined = require("./Brightness3Outlined");
var _brightness3OutlinedDefault = parcelHelpers.interopDefault(_brightness3Outlined);
var _brightness3Rounded = require("./Brightness3Rounded");
var _brightness3RoundedDefault = parcelHelpers.interopDefault(_brightness3Rounded);
var _brightness3Sharp = require("./Brightness3Sharp");
var _brightness3SharpDefault = parcelHelpers.interopDefault(_brightness3Sharp);
var _brightness3TwoTone = require("./Brightness3TwoTone");
var _brightness3TwoToneDefault = parcelHelpers.interopDefault(_brightness3TwoTone);
var _brightness4 = require("./Brightness4");
var _brightness4Default = parcelHelpers.interopDefault(_brightness4);
var _brightness4Outlined = require("./Brightness4Outlined");
var _brightness4OutlinedDefault = parcelHelpers.interopDefault(_brightness4Outlined);
var _brightness4Rounded = require("./Brightness4Rounded");
var _brightness4RoundedDefault = parcelHelpers.interopDefault(_brightness4Rounded);
var _brightness4Sharp = require("./Brightness4Sharp");
var _brightness4SharpDefault = parcelHelpers.interopDefault(_brightness4Sharp);
var _brightness4TwoTone = require("./Brightness4TwoTone");
var _brightness4TwoToneDefault = parcelHelpers.interopDefault(_brightness4TwoTone);
var _brightness5 = require("./Brightness5");
var _brightness5Default = parcelHelpers.interopDefault(_brightness5);
var _brightness5Outlined = require("./Brightness5Outlined");
var _brightness5OutlinedDefault = parcelHelpers.interopDefault(_brightness5Outlined);
var _brightness5Rounded = require("./Brightness5Rounded");
var _brightness5RoundedDefault = parcelHelpers.interopDefault(_brightness5Rounded);
var _brightness5Sharp = require("./Brightness5Sharp");
var _brightness5SharpDefault = parcelHelpers.interopDefault(_brightness5Sharp);
var _brightness5TwoTone = require("./Brightness5TwoTone");
var _brightness5TwoToneDefault = parcelHelpers.interopDefault(_brightness5TwoTone);
var _brightness6 = require("./Brightness6");
var _brightness6Default = parcelHelpers.interopDefault(_brightness6);
var _brightness6Outlined = require("./Brightness6Outlined");
var _brightness6OutlinedDefault = parcelHelpers.interopDefault(_brightness6Outlined);
var _brightness6Rounded = require("./Brightness6Rounded");
var _brightness6RoundedDefault = parcelHelpers.interopDefault(_brightness6Rounded);
var _brightness6Sharp = require("./Brightness6Sharp");
var _brightness6SharpDefault = parcelHelpers.interopDefault(_brightness6Sharp);
var _brightness6TwoTone = require("./Brightness6TwoTone");
var _brightness6TwoToneDefault = parcelHelpers.interopDefault(_brightness6TwoTone);
var _brightness7 = require("./Brightness7");
var _brightness7Default = parcelHelpers.interopDefault(_brightness7);
var _brightness7Outlined = require("./Brightness7Outlined");
var _brightness7OutlinedDefault = parcelHelpers.interopDefault(_brightness7Outlined);
var _brightness7Rounded = require("./Brightness7Rounded");
var _brightness7RoundedDefault = parcelHelpers.interopDefault(_brightness7Rounded);
var _brightness7Sharp = require("./Brightness7Sharp");
var _brightness7SharpDefault = parcelHelpers.interopDefault(_brightness7Sharp);
var _brightness7TwoTone = require("./Brightness7TwoTone");
var _brightness7TwoToneDefault = parcelHelpers.interopDefault(_brightness7TwoTone);
var _brightnessAuto = require("./BrightnessAuto");
var _brightnessAutoDefault = parcelHelpers.interopDefault(_brightnessAuto);
var _brightnessAutoOutlined = require("./BrightnessAutoOutlined");
var _brightnessAutoOutlinedDefault = parcelHelpers.interopDefault(_brightnessAutoOutlined);
var _brightnessAutoRounded = require("./BrightnessAutoRounded");
var _brightnessAutoRoundedDefault = parcelHelpers.interopDefault(_brightnessAutoRounded);
var _brightnessAutoSharp = require("./BrightnessAutoSharp");
var _brightnessAutoSharpDefault = parcelHelpers.interopDefault(_brightnessAutoSharp);
var _brightnessAutoTwoTone = require("./BrightnessAutoTwoTone");
var _brightnessAutoTwoToneDefault = parcelHelpers.interopDefault(_brightnessAutoTwoTone);
var _brightnessHigh = require("./BrightnessHigh");
var _brightnessHighDefault = parcelHelpers.interopDefault(_brightnessHigh);
var _brightnessHighOutlined = require("./BrightnessHighOutlined");
var _brightnessHighOutlinedDefault = parcelHelpers.interopDefault(_brightnessHighOutlined);
var _brightnessHighRounded = require("./BrightnessHighRounded");
var _brightnessHighRoundedDefault = parcelHelpers.interopDefault(_brightnessHighRounded);
var _brightnessHighSharp = require("./BrightnessHighSharp");
var _brightnessHighSharpDefault = parcelHelpers.interopDefault(_brightnessHighSharp);
var _brightnessHighTwoTone = require("./BrightnessHighTwoTone");
var _brightnessHighTwoToneDefault = parcelHelpers.interopDefault(_brightnessHighTwoTone);
var _brightnessLow = require("./BrightnessLow");
var _brightnessLowDefault = parcelHelpers.interopDefault(_brightnessLow);
var _brightnessLowOutlined = require("./BrightnessLowOutlined");
var _brightnessLowOutlinedDefault = parcelHelpers.interopDefault(_brightnessLowOutlined);
var _brightnessLowRounded = require("./BrightnessLowRounded");
var _brightnessLowRoundedDefault = parcelHelpers.interopDefault(_brightnessLowRounded);
var _brightnessLowSharp = require("./BrightnessLowSharp");
var _brightnessLowSharpDefault = parcelHelpers.interopDefault(_brightnessLowSharp);
var _brightnessLowTwoTone = require("./BrightnessLowTwoTone");
var _brightnessLowTwoToneDefault = parcelHelpers.interopDefault(_brightnessLowTwoTone);
var _brightnessMedium = require("./BrightnessMedium");
var _brightnessMediumDefault = parcelHelpers.interopDefault(_brightnessMedium);
var _brightnessMediumOutlined = require("./BrightnessMediumOutlined");
var _brightnessMediumOutlinedDefault = parcelHelpers.interopDefault(_brightnessMediumOutlined);
var _brightnessMediumRounded = require("./BrightnessMediumRounded");
var _brightnessMediumRoundedDefault = parcelHelpers.interopDefault(_brightnessMediumRounded);
var _brightnessMediumSharp = require("./BrightnessMediumSharp");
var _brightnessMediumSharpDefault = parcelHelpers.interopDefault(_brightnessMediumSharp);
var _brightnessMediumTwoTone = require("./BrightnessMediumTwoTone");
var _brightnessMediumTwoToneDefault = parcelHelpers.interopDefault(_brightnessMediumTwoTone);
var _broadcastOnHome = require("./BroadcastOnHome");
var _broadcastOnHomeDefault = parcelHelpers.interopDefault(_broadcastOnHome);
var _broadcastOnHomeOutlined = require("./BroadcastOnHomeOutlined");
var _broadcastOnHomeOutlinedDefault = parcelHelpers.interopDefault(_broadcastOnHomeOutlined);
var _broadcastOnHomeRounded = require("./BroadcastOnHomeRounded");
var _broadcastOnHomeRoundedDefault = parcelHelpers.interopDefault(_broadcastOnHomeRounded);
var _broadcastOnHomeSharp = require("./BroadcastOnHomeSharp");
var _broadcastOnHomeSharpDefault = parcelHelpers.interopDefault(_broadcastOnHomeSharp);
var _broadcastOnHomeTwoTone = require("./BroadcastOnHomeTwoTone");
var _broadcastOnHomeTwoToneDefault = parcelHelpers.interopDefault(_broadcastOnHomeTwoTone);
var _broadcastOnPersonal = require("./BroadcastOnPersonal");
var _broadcastOnPersonalDefault = parcelHelpers.interopDefault(_broadcastOnPersonal);
var _broadcastOnPersonalOutlined = require("./BroadcastOnPersonalOutlined");
var _broadcastOnPersonalOutlinedDefault = parcelHelpers.interopDefault(_broadcastOnPersonalOutlined);
var _broadcastOnPersonalRounded = require("./BroadcastOnPersonalRounded");
var _broadcastOnPersonalRoundedDefault = parcelHelpers.interopDefault(_broadcastOnPersonalRounded);
var _broadcastOnPersonalSharp = require("./BroadcastOnPersonalSharp");
var _broadcastOnPersonalSharpDefault = parcelHelpers.interopDefault(_broadcastOnPersonalSharp);
var _broadcastOnPersonalTwoTone = require("./BroadcastOnPersonalTwoTone");
var _broadcastOnPersonalTwoToneDefault = parcelHelpers.interopDefault(_broadcastOnPersonalTwoTone);
var _brokenImage = require("./BrokenImage");
var _brokenImageDefault = parcelHelpers.interopDefault(_brokenImage);
var _brokenImageOutlined = require("./BrokenImageOutlined");
var _brokenImageOutlinedDefault = parcelHelpers.interopDefault(_brokenImageOutlined);
var _brokenImageRounded = require("./BrokenImageRounded");
var _brokenImageRoundedDefault = parcelHelpers.interopDefault(_brokenImageRounded);
var _brokenImageSharp = require("./BrokenImageSharp");
var _brokenImageSharpDefault = parcelHelpers.interopDefault(_brokenImageSharp);
var _brokenImageTwoTone = require("./BrokenImageTwoTone");
var _brokenImageTwoToneDefault = parcelHelpers.interopDefault(_brokenImageTwoTone);
var _browseGallery = require("./BrowseGallery");
var _browseGalleryDefault = parcelHelpers.interopDefault(_browseGallery);
var _browseGalleryOutlined = require("./BrowseGalleryOutlined");
var _browseGalleryOutlinedDefault = parcelHelpers.interopDefault(_browseGalleryOutlined);
var _browseGalleryRounded = require("./BrowseGalleryRounded");
var _browseGalleryRoundedDefault = parcelHelpers.interopDefault(_browseGalleryRounded);
var _browseGallerySharp = require("./BrowseGallerySharp");
var _browseGallerySharpDefault = parcelHelpers.interopDefault(_browseGallerySharp);
var _browseGalleryTwoTone = require("./BrowseGalleryTwoTone");
var _browseGalleryTwoToneDefault = parcelHelpers.interopDefault(_browseGalleryTwoTone);
var _browserNotSupported = require("./BrowserNotSupported");
var _browserNotSupportedDefault = parcelHelpers.interopDefault(_browserNotSupported);
var _browserNotSupportedOutlined = require("./BrowserNotSupportedOutlined");
var _browserNotSupportedOutlinedDefault = parcelHelpers.interopDefault(_browserNotSupportedOutlined);
var _browserNotSupportedRounded = require("./BrowserNotSupportedRounded");
var _browserNotSupportedRoundedDefault = parcelHelpers.interopDefault(_browserNotSupportedRounded);
var _browserNotSupportedSharp = require("./BrowserNotSupportedSharp");
var _browserNotSupportedSharpDefault = parcelHelpers.interopDefault(_browserNotSupportedSharp);
var _browserNotSupportedTwoTone = require("./BrowserNotSupportedTwoTone");
var _browserNotSupportedTwoToneDefault = parcelHelpers.interopDefault(_browserNotSupportedTwoTone);
var _browserUpdated = require("./BrowserUpdated");
var _browserUpdatedDefault = parcelHelpers.interopDefault(_browserUpdated);
var _browserUpdatedOutlined = require("./BrowserUpdatedOutlined");
var _browserUpdatedOutlinedDefault = parcelHelpers.interopDefault(_browserUpdatedOutlined);
var _browserUpdatedRounded = require("./BrowserUpdatedRounded");
var _browserUpdatedRoundedDefault = parcelHelpers.interopDefault(_browserUpdatedRounded);
var _browserUpdatedSharp = require("./BrowserUpdatedSharp");
var _browserUpdatedSharpDefault = parcelHelpers.interopDefault(_browserUpdatedSharp);
var _browserUpdatedTwoTone = require("./BrowserUpdatedTwoTone");
var _browserUpdatedTwoToneDefault = parcelHelpers.interopDefault(_browserUpdatedTwoTone);
var _brunchDining = require("./BrunchDining");
var _brunchDiningDefault = parcelHelpers.interopDefault(_brunchDining);
var _brunchDiningOutlined = require("./BrunchDiningOutlined");
var _brunchDiningOutlinedDefault = parcelHelpers.interopDefault(_brunchDiningOutlined);
var _brunchDiningRounded = require("./BrunchDiningRounded");
var _brunchDiningRoundedDefault = parcelHelpers.interopDefault(_brunchDiningRounded);
var _brunchDiningSharp = require("./BrunchDiningSharp");
var _brunchDiningSharpDefault = parcelHelpers.interopDefault(_brunchDiningSharp);
var _brunchDiningTwoTone = require("./BrunchDiningTwoTone");
var _brunchDiningTwoToneDefault = parcelHelpers.interopDefault(_brunchDiningTwoTone);
var _brush = require("./Brush");
var _brushDefault = parcelHelpers.interopDefault(_brush);
var _brushOutlined = require("./BrushOutlined");
var _brushOutlinedDefault = parcelHelpers.interopDefault(_brushOutlined);
var _brushRounded = require("./BrushRounded");
var _brushRoundedDefault = parcelHelpers.interopDefault(_brushRounded);
var _brushSharp = require("./BrushSharp");
var _brushSharpDefault = parcelHelpers.interopDefault(_brushSharp);
var _brushTwoTone = require("./BrushTwoTone");
var _brushTwoToneDefault = parcelHelpers.interopDefault(_brushTwoTone);
var _bubbleChart = require("./BubbleChart");
var _bubbleChartDefault = parcelHelpers.interopDefault(_bubbleChart);
var _bubbleChartOutlined = require("./BubbleChartOutlined");
var _bubbleChartOutlinedDefault = parcelHelpers.interopDefault(_bubbleChartOutlined);
var _bubbleChartRounded = require("./BubbleChartRounded");
var _bubbleChartRoundedDefault = parcelHelpers.interopDefault(_bubbleChartRounded);
var _bubbleChartSharp = require("./BubbleChartSharp");
var _bubbleChartSharpDefault = parcelHelpers.interopDefault(_bubbleChartSharp);
var _bubbleChartTwoTone = require("./BubbleChartTwoTone");
var _bubbleChartTwoToneDefault = parcelHelpers.interopDefault(_bubbleChartTwoTone);
var _bugReport = require("./BugReport");
var _bugReportDefault = parcelHelpers.interopDefault(_bugReport);
var _bugReportOutlined = require("./BugReportOutlined");
var _bugReportOutlinedDefault = parcelHelpers.interopDefault(_bugReportOutlined);
var _bugReportRounded = require("./BugReportRounded");
var _bugReportRoundedDefault = parcelHelpers.interopDefault(_bugReportRounded);
var _bugReportSharp = require("./BugReportSharp");
var _bugReportSharpDefault = parcelHelpers.interopDefault(_bugReportSharp);
var _bugReportTwoTone = require("./BugReportTwoTone");
var _bugReportTwoToneDefault = parcelHelpers.interopDefault(_bugReportTwoTone);
var _build = require("./Build");
var _buildDefault = parcelHelpers.interopDefault(_build);
var _buildCircle = require("./BuildCircle");
var _buildCircleDefault = parcelHelpers.interopDefault(_buildCircle);
var _buildCircleOutlined = require("./BuildCircleOutlined");
var _buildCircleOutlinedDefault = parcelHelpers.interopDefault(_buildCircleOutlined);
var _buildCircleRounded = require("./BuildCircleRounded");
var _buildCircleRoundedDefault = parcelHelpers.interopDefault(_buildCircleRounded);
var _buildCircleSharp = require("./BuildCircleSharp");
var _buildCircleSharpDefault = parcelHelpers.interopDefault(_buildCircleSharp);
var _buildCircleTwoTone = require("./BuildCircleTwoTone");
var _buildCircleTwoToneDefault = parcelHelpers.interopDefault(_buildCircleTwoTone);
var _buildOutlined = require("./BuildOutlined");
var _buildOutlinedDefault = parcelHelpers.interopDefault(_buildOutlined);
var _buildRounded = require("./BuildRounded");
var _buildRoundedDefault = parcelHelpers.interopDefault(_buildRounded);
var _buildSharp = require("./BuildSharp");
var _buildSharpDefault = parcelHelpers.interopDefault(_buildSharp);
var _buildTwoTone = require("./BuildTwoTone");
var _buildTwoToneDefault = parcelHelpers.interopDefault(_buildTwoTone);
var _bungalow = require("./Bungalow");
var _bungalowDefault = parcelHelpers.interopDefault(_bungalow);
var _bungalowOutlined = require("./BungalowOutlined");
var _bungalowOutlinedDefault = parcelHelpers.interopDefault(_bungalowOutlined);
var _bungalowRounded = require("./BungalowRounded");
var _bungalowRoundedDefault = parcelHelpers.interopDefault(_bungalowRounded);
var _bungalowSharp = require("./BungalowSharp");
var _bungalowSharpDefault = parcelHelpers.interopDefault(_bungalowSharp);
var _bungalowTwoTone = require("./BungalowTwoTone");
var _bungalowTwoToneDefault = parcelHelpers.interopDefault(_bungalowTwoTone);
var _burstMode = require("./BurstMode");
var _burstModeDefault = parcelHelpers.interopDefault(_burstMode);
var _burstModeOutlined = require("./BurstModeOutlined");
var _burstModeOutlinedDefault = parcelHelpers.interopDefault(_burstModeOutlined);
var _burstModeRounded = require("./BurstModeRounded");
var _burstModeRoundedDefault = parcelHelpers.interopDefault(_burstModeRounded);
var _burstModeSharp = require("./BurstModeSharp");
var _burstModeSharpDefault = parcelHelpers.interopDefault(_burstModeSharp);
var _burstModeTwoTone = require("./BurstModeTwoTone");
var _burstModeTwoToneDefault = parcelHelpers.interopDefault(_burstModeTwoTone);
var _busAlert = require("./BusAlert");
var _busAlertDefault = parcelHelpers.interopDefault(_busAlert);
var _busAlertOutlined = require("./BusAlertOutlined");
var _busAlertOutlinedDefault = parcelHelpers.interopDefault(_busAlertOutlined);
var _busAlertRounded = require("./BusAlertRounded");
var _busAlertRoundedDefault = parcelHelpers.interopDefault(_busAlertRounded);
var _busAlertSharp = require("./BusAlertSharp");
var _busAlertSharpDefault = parcelHelpers.interopDefault(_busAlertSharp);
var _busAlertTwoTone = require("./BusAlertTwoTone");
var _busAlertTwoToneDefault = parcelHelpers.interopDefault(_busAlertTwoTone);
var _business = require("./Business");
var _businessDefault = parcelHelpers.interopDefault(_business);
var _businessCenter = require("./BusinessCenter");
var _businessCenterDefault = parcelHelpers.interopDefault(_businessCenter);
var _businessCenterOutlined = require("./BusinessCenterOutlined");
var _businessCenterOutlinedDefault = parcelHelpers.interopDefault(_businessCenterOutlined);
var _businessCenterRounded = require("./BusinessCenterRounded");
var _businessCenterRoundedDefault = parcelHelpers.interopDefault(_businessCenterRounded);
var _businessCenterSharp = require("./BusinessCenterSharp");
var _businessCenterSharpDefault = parcelHelpers.interopDefault(_businessCenterSharp);
var _businessCenterTwoTone = require("./BusinessCenterTwoTone");
var _businessCenterTwoToneDefault = parcelHelpers.interopDefault(_businessCenterTwoTone);
var _businessOutlined = require("./BusinessOutlined");
var _businessOutlinedDefault = parcelHelpers.interopDefault(_businessOutlined);
var _businessRounded = require("./BusinessRounded");
var _businessRoundedDefault = parcelHelpers.interopDefault(_businessRounded);
var _businessSharp = require("./BusinessSharp");
var _businessSharpDefault = parcelHelpers.interopDefault(_businessSharp);
var _businessTwoTone = require("./BusinessTwoTone");
var _businessTwoToneDefault = parcelHelpers.interopDefault(_businessTwoTone);
var _cabin = require("./Cabin");
var _cabinDefault = parcelHelpers.interopDefault(_cabin);
var _cabinOutlined = require("./CabinOutlined");
var _cabinOutlinedDefault = parcelHelpers.interopDefault(_cabinOutlined);
var _cabinRounded = require("./CabinRounded");
var _cabinRoundedDefault = parcelHelpers.interopDefault(_cabinRounded);
var _cabinSharp = require("./CabinSharp");
var _cabinSharpDefault = parcelHelpers.interopDefault(_cabinSharp);
var _cabinTwoTone = require("./CabinTwoTone");
var _cabinTwoToneDefault = parcelHelpers.interopDefault(_cabinTwoTone);
var _cable = require("./Cable");
var _cableDefault = parcelHelpers.interopDefault(_cable);
var _cableOutlined = require("./CableOutlined");
var _cableOutlinedDefault = parcelHelpers.interopDefault(_cableOutlined);
var _cableRounded = require("./CableRounded");
var _cableRoundedDefault = parcelHelpers.interopDefault(_cableRounded);
var _cableSharp = require("./CableSharp");
var _cableSharpDefault = parcelHelpers.interopDefault(_cableSharp);
var _cableTwoTone = require("./CableTwoTone");
var _cableTwoToneDefault = parcelHelpers.interopDefault(_cableTwoTone);
var _cached = require("./Cached");
var _cachedDefault = parcelHelpers.interopDefault(_cached);
var _cachedOutlined = require("./CachedOutlined");
var _cachedOutlinedDefault = parcelHelpers.interopDefault(_cachedOutlined);
var _cachedRounded = require("./CachedRounded");
var _cachedRoundedDefault = parcelHelpers.interopDefault(_cachedRounded);
var _cachedSharp = require("./CachedSharp");
var _cachedSharpDefault = parcelHelpers.interopDefault(_cachedSharp);
var _cachedTwoTone = require("./CachedTwoTone");
var _cachedTwoToneDefault = parcelHelpers.interopDefault(_cachedTwoTone);
var _cake = require("./Cake");
var _cakeDefault = parcelHelpers.interopDefault(_cake);
var _cakeOutlined = require("./CakeOutlined");
var _cakeOutlinedDefault = parcelHelpers.interopDefault(_cakeOutlined);
var _cakeRounded = require("./CakeRounded");
var _cakeRoundedDefault = parcelHelpers.interopDefault(_cakeRounded);
var _cakeSharp = require("./CakeSharp");
var _cakeSharpDefault = parcelHelpers.interopDefault(_cakeSharp);
var _cakeTwoTone = require("./CakeTwoTone");
var _cakeTwoToneDefault = parcelHelpers.interopDefault(_cakeTwoTone);
var _calculate = require("./Calculate");
var _calculateDefault = parcelHelpers.interopDefault(_calculate);
var _calculateOutlined = require("./CalculateOutlined");
var _calculateOutlinedDefault = parcelHelpers.interopDefault(_calculateOutlined);
var _calculateRounded = require("./CalculateRounded");
var _calculateRoundedDefault = parcelHelpers.interopDefault(_calculateRounded);
var _calculateSharp = require("./CalculateSharp");
var _calculateSharpDefault = parcelHelpers.interopDefault(_calculateSharp);
var _calculateTwoTone = require("./CalculateTwoTone");
var _calculateTwoToneDefault = parcelHelpers.interopDefault(_calculateTwoTone);
var _calendarMonth = require("./CalendarMonth");
var _calendarMonthDefault = parcelHelpers.interopDefault(_calendarMonth);
var _calendarMonthOutlined = require("./CalendarMonthOutlined");
var _calendarMonthOutlinedDefault = parcelHelpers.interopDefault(_calendarMonthOutlined);
var _calendarMonthRounded = require("./CalendarMonthRounded");
var _calendarMonthRoundedDefault = parcelHelpers.interopDefault(_calendarMonthRounded);
var _calendarMonthSharp = require("./CalendarMonthSharp");
var _calendarMonthSharpDefault = parcelHelpers.interopDefault(_calendarMonthSharp);
var _calendarMonthTwoTone = require("./CalendarMonthTwoTone");
var _calendarMonthTwoToneDefault = parcelHelpers.interopDefault(_calendarMonthTwoTone);
var _calendarToday = require("./CalendarToday");
var _calendarTodayDefault = parcelHelpers.interopDefault(_calendarToday);
var _calendarTodayOutlined = require("./CalendarTodayOutlined");
var _calendarTodayOutlinedDefault = parcelHelpers.interopDefault(_calendarTodayOutlined);
var _calendarTodayRounded = require("./CalendarTodayRounded");
var _calendarTodayRoundedDefault = parcelHelpers.interopDefault(_calendarTodayRounded);
var _calendarTodaySharp = require("./CalendarTodaySharp");
var _calendarTodaySharpDefault = parcelHelpers.interopDefault(_calendarTodaySharp);
var _calendarTodayTwoTone = require("./CalendarTodayTwoTone");
var _calendarTodayTwoToneDefault = parcelHelpers.interopDefault(_calendarTodayTwoTone);
var _calendarViewDay = require("./CalendarViewDay");
var _calendarViewDayDefault = parcelHelpers.interopDefault(_calendarViewDay);
var _calendarViewDayOutlined = require("./CalendarViewDayOutlined");
var _calendarViewDayOutlinedDefault = parcelHelpers.interopDefault(_calendarViewDayOutlined);
var _calendarViewDayRounded = require("./CalendarViewDayRounded");
var _calendarViewDayRoundedDefault = parcelHelpers.interopDefault(_calendarViewDayRounded);
var _calendarViewDaySharp = require("./CalendarViewDaySharp");
var _calendarViewDaySharpDefault = parcelHelpers.interopDefault(_calendarViewDaySharp);
var _calendarViewDayTwoTone = require("./CalendarViewDayTwoTone");
var _calendarViewDayTwoToneDefault = parcelHelpers.interopDefault(_calendarViewDayTwoTone);
var _calendarViewMonth = require("./CalendarViewMonth");
var _calendarViewMonthDefault = parcelHelpers.interopDefault(_calendarViewMonth);
var _calendarViewMonthOutlined = require("./CalendarViewMonthOutlined");
var _calendarViewMonthOutlinedDefault = parcelHelpers.interopDefault(_calendarViewMonthOutlined);
var _calendarViewMonthRounded = require("./CalendarViewMonthRounded");
var _calendarViewMonthRoundedDefault = parcelHelpers.interopDefault(_calendarViewMonthRounded);
var _calendarViewMonthSharp = require("./CalendarViewMonthSharp");
var _calendarViewMonthSharpDefault = parcelHelpers.interopDefault(_calendarViewMonthSharp);
var _calendarViewMonthTwoTone = require("./CalendarViewMonthTwoTone");
var _calendarViewMonthTwoToneDefault = parcelHelpers.interopDefault(_calendarViewMonthTwoTone);
var _calendarViewWeek = require("./CalendarViewWeek");
var _calendarViewWeekDefault = parcelHelpers.interopDefault(_calendarViewWeek);
var _calendarViewWeekOutlined = require("./CalendarViewWeekOutlined");
var _calendarViewWeekOutlinedDefault = parcelHelpers.interopDefault(_calendarViewWeekOutlined);
var _calendarViewWeekRounded = require("./CalendarViewWeekRounded");
var _calendarViewWeekRoundedDefault = parcelHelpers.interopDefault(_calendarViewWeekRounded);
var _calendarViewWeekSharp = require("./CalendarViewWeekSharp");
var _calendarViewWeekSharpDefault = parcelHelpers.interopDefault(_calendarViewWeekSharp);
var _calendarViewWeekTwoTone = require("./CalendarViewWeekTwoTone");
var _calendarViewWeekTwoToneDefault = parcelHelpers.interopDefault(_calendarViewWeekTwoTone);
var _call = require("./Call");
var _callDefault = parcelHelpers.interopDefault(_call);
var _callEnd = require("./CallEnd");
var _callEndDefault = parcelHelpers.interopDefault(_callEnd);
var _callEndOutlined = require("./CallEndOutlined");
var _callEndOutlinedDefault = parcelHelpers.interopDefault(_callEndOutlined);
var _callEndRounded = require("./CallEndRounded");
var _callEndRoundedDefault = parcelHelpers.interopDefault(_callEndRounded);
var _callEndSharp = require("./CallEndSharp");
var _callEndSharpDefault = parcelHelpers.interopDefault(_callEndSharp);
var _callEndTwoTone = require("./CallEndTwoTone");
var _callEndTwoToneDefault = parcelHelpers.interopDefault(_callEndTwoTone);
var _callMade = require("./CallMade");
var _callMadeDefault = parcelHelpers.interopDefault(_callMade);
var _callMadeOutlined = require("./CallMadeOutlined");
var _callMadeOutlinedDefault = parcelHelpers.interopDefault(_callMadeOutlined);
var _callMadeRounded = require("./CallMadeRounded");
var _callMadeRoundedDefault = parcelHelpers.interopDefault(_callMadeRounded);
var _callMadeSharp = require("./CallMadeSharp");
var _callMadeSharpDefault = parcelHelpers.interopDefault(_callMadeSharp);
var _callMadeTwoTone = require("./CallMadeTwoTone");
var _callMadeTwoToneDefault = parcelHelpers.interopDefault(_callMadeTwoTone);
var _callMerge = require("./CallMerge");
var _callMergeDefault = parcelHelpers.interopDefault(_callMerge);
var _callMergeOutlined = require("./CallMergeOutlined");
var _callMergeOutlinedDefault = parcelHelpers.interopDefault(_callMergeOutlined);
var _callMergeRounded = require("./CallMergeRounded");
var _callMergeRoundedDefault = parcelHelpers.interopDefault(_callMergeRounded);
var _callMergeSharp = require("./CallMergeSharp");
var _callMergeSharpDefault = parcelHelpers.interopDefault(_callMergeSharp);
var _callMergeTwoTone = require("./CallMergeTwoTone");
var _callMergeTwoToneDefault = parcelHelpers.interopDefault(_callMergeTwoTone);
var _callMissed = require("./CallMissed");
var _callMissedDefault = parcelHelpers.interopDefault(_callMissed);
var _callMissedOutgoing = require("./CallMissedOutgoing");
var _callMissedOutgoingDefault = parcelHelpers.interopDefault(_callMissedOutgoing);
var _callMissedOutgoingOutlined = require("./CallMissedOutgoingOutlined");
var _callMissedOutgoingOutlinedDefault = parcelHelpers.interopDefault(_callMissedOutgoingOutlined);
var _callMissedOutgoingRounded = require("./CallMissedOutgoingRounded");
var _callMissedOutgoingRoundedDefault = parcelHelpers.interopDefault(_callMissedOutgoingRounded);
var _callMissedOutgoingSharp = require("./CallMissedOutgoingSharp");
var _callMissedOutgoingSharpDefault = parcelHelpers.interopDefault(_callMissedOutgoingSharp);
var _callMissedOutgoingTwoTone = require("./CallMissedOutgoingTwoTone");
var _callMissedOutgoingTwoToneDefault = parcelHelpers.interopDefault(_callMissedOutgoingTwoTone);
var _callMissedOutlined = require("./CallMissedOutlined");
var _callMissedOutlinedDefault = parcelHelpers.interopDefault(_callMissedOutlined);
var _callMissedRounded = require("./CallMissedRounded");
var _callMissedRoundedDefault = parcelHelpers.interopDefault(_callMissedRounded);
var _callMissedSharp = require("./CallMissedSharp");
var _callMissedSharpDefault = parcelHelpers.interopDefault(_callMissedSharp);
var _callMissedTwoTone = require("./CallMissedTwoTone");
var _callMissedTwoToneDefault = parcelHelpers.interopDefault(_callMissedTwoTone);
var _callOutlined = require("./CallOutlined");
var _callOutlinedDefault = parcelHelpers.interopDefault(_callOutlined);
var _callReceived = require("./CallReceived");
var _callReceivedDefault = parcelHelpers.interopDefault(_callReceived);
var _callReceivedOutlined = require("./CallReceivedOutlined");
var _callReceivedOutlinedDefault = parcelHelpers.interopDefault(_callReceivedOutlined);
var _callReceivedRounded = require("./CallReceivedRounded");
var _callReceivedRoundedDefault = parcelHelpers.interopDefault(_callReceivedRounded);
var _callReceivedSharp = require("./CallReceivedSharp");
var _callReceivedSharpDefault = parcelHelpers.interopDefault(_callReceivedSharp);
var _callReceivedTwoTone = require("./CallReceivedTwoTone");
var _callReceivedTwoToneDefault = parcelHelpers.interopDefault(_callReceivedTwoTone);
var _callRounded = require("./CallRounded");
var _callRoundedDefault = parcelHelpers.interopDefault(_callRounded);
var _callSharp = require("./CallSharp");
var _callSharpDefault = parcelHelpers.interopDefault(_callSharp);
var _callSplit = require("./CallSplit");
var _callSplitDefault = parcelHelpers.interopDefault(_callSplit);
var _callSplitOutlined = require("./CallSplitOutlined");
var _callSplitOutlinedDefault = parcelHelpers.interopDefault(_callSplitOutlined);
var _callSplitRounded = require("./CallSplitRounded");
var _callSplitRoundedDefault = parcelHelpers.interopDefault(_callSplitRounded);
var _callSplitSharp = require("./CallSplitSharp");
var _callSplitSharpDefault = parcelHelpers.interopDefault(_callSplitSharp);
var _callSplitTwoTone = require("./CallSplitTwoTone");
var _callSplitTwoToneDefault = parcelHelpers.interopDefault(_callSplitTwoTone);
var _callToAction = require("./CallToAction");
var _callToActionDefault = parcelHelpers.interopDefault(_callToAction);
var _callToActionOutlined = require("./CallToActionOutlined");
var _callToActionOutlinedDefault = parcelHelpers.interopDefault(_callToActionOutlined);
var _callToActionRounded = require("./CallToActionRounded");
var _callToActionRoundedDefault = parcelHelpers.interopDefault(_callToActionRounded);
var _callToActionSharp = require("./CallToActionSharp");
var _callToActionSharpDefault = parcelHelpers.interopDefault(_callToActionSharp);
var _callToActionTwoTone = require("./CallToActionTwoTone");
var _callToActionTwoToneDefault = parcelHelpers.interopDefault(_callToActionTwoTone);
var _callTwoTone = require("./CallTwoTone");
var _callTwoToneDefault = parcelHelpers.interopDefault(_callTwoTone);
var _camera = require("./Camera");
var _cameraDefault = parcelHelpers.interopDefault(_camera);
var _cameraAlt = require("./CameraAlt");
var _cameraAltDefault = parcelHelpers.interopDefault(_cameraAlt);
var _cameraAltOutlined = require("./CameraAltOutlined");
var _cameraAltOutlinedDefault = parcelHelpers.interopDefault(_cameraAltOutlined);
var _cameraAltRounded = require("./CameraAltRounded");
var _cameraAltRoundedDefault = parcelHelpers.interopDefault(_cameraAltRounded);
var _cameraAltSharp = require("./CameraAltSharp");
var _cameraAltSharpDefault = parcelHelpers.interopDefault(_cameraAltSharp);
var _cameraAltTwoTone = require("./CameraAltTwoTone");
var _cameraAltTwoToneDefault = parcelHelpers.interopDefault(_cameraAltTwoTone);
var _cameraEnhance = require("./CameraEnhance");
var _cameraEnhanceDefault = parcelHelpers.interopDefault(_cameraEnhance);
var _cameraEnhanceOutlined = require("./CameraEnhanceOutlined");
var _cameraEnhanceOutlinedDefault = parcelHelpers.interopDefault(_cameraEnhanceOutlined);
var _cameraEnhanceRounded = require("./CameraEnhanceRounded");
var _cameraEnhanceRoundedDefault = parcelHelpers.interopDefault(_cameraEnhanceRounded);
var _cameraEnhanceSharp = require("./CameraEnhanceSharp");
var _cameraEnhanceSharpDefault = parcelHelpers.interopDefault(_cameraEnhanceSharp);
var _cameraEnhanceTwoTone = require("./CameraEnhanceTwoTone");
var _cameraEnhanceTwoToneDefault = parcelHelpers.interopDefault(_cameraEnhanceTwoTone);
var _cameraFront = require("./CameraFront");
var _cameraFrontDefault = parcelHelpers.interopDefault(_cameraFront);
var _cameraFrontOutlined = require("./CameraFrontOutlined");
var _cameraFrontOutlinedDefault = parcelHelpers.interopDefault(_cameraFrontOutlined);
var _cameraFrontRounded = require("./CameraFrontRounded");
var _cameraFrontRoundedDefault = parcelHelpers.interopDefault(_cameraFrontRounded);
var _cameraFrontSharp = require("./CameraFrontSharp");
var _cameraFrontSharpDefault = parcelHelpers.interopDefault(_cameraFrontSharp);
var _cameraFrontTwoTone = require("./CameraFrontTwoTone");
var _cameraFrontTwoToneDefault = parcelHelpers.interopDefault(_cameraFrontTwoTone);
var _cameraIndoor = require("./CameraIndoor");
var _cameraIndoorDefault = parcelHelpers.interopDefault(_cameraIndoor);
var _cameraIndoorOutlined = require("./CameraIndoorOutlined");
var _cameraIndoorOutlinedDefault = parcelHelpers.interopDefault(_cameraIndoorOutlined);
var _cameraIndoorRounded = require("./CameraIndoorRounded");
var _cameraIndoorRoundedDefault = parcelHelpers.interopDefault(_cameraIndoorRounded);
var _cameraIndoorSharp = require("./CameraIndoorSharp");
var _cameraIndoorSharpDefault = parcelHelpers.interopDefault(_cameraIndoorSharp);
var _cameraIndoorTwoTone = require("./CameraIndoorTwoTone");
var _cameraIndoorTwoToneDefault = parcelHelpers.interopDefault(_cameraIndoorTwoTone);
var _cameraOutdoor = require("./CameraOutdoor");
var _cameraOutdoorDefault = parcelHelpers.interopDefault(_cameraOutdoor);
var _cameraOutdoorOutlined = require("./CameraOutdoorOutlined");
var _cameraOutdoorOutlinedDefault = parcelHelpers.interopDefault(_cameraOutdoorOutlined);
var _cameraOutdoorRounded = require("./CameraOutdoorRounded");
var _cameraOutdoorRoundedDefault = parcelHelpers.interopDefault(_cameraOutdoorRounded);
var _cameraOutdoorSharp = require("./CameraOutdoorSharp");
var _cameraOutdoorSharpDefault = parcelHelpers.interopDefault(_cameraOutdoorSharp);
var _cameraOutdoorTwoTone = require("./CameraOutdoorTwoTone");
var _cameraOutdoorTwoToneDefault = parcelHelpers.interopDefault(_cameraOutdoorTwoTone);
var _cameraOutlined = require("./CameraOutlined");
var _cameraOutlinedDefault = parcelHelpers.interopDefault(_cameraOutlined);
var _cameraRear = require("./CameraRear");
var _cameraRearDefault = parcelHelpers.interopDefault(_cameraRear);
var _cameraRearOutlined = require("./CameraRearOutlined");
var _cameraRearOutlinedDefault = parcelHelpers.interopDefault(_cameraRearOutlined);
var _cameraRearRounded = require("./CameraRearRounded");
var _cameraRearRoundedDefault = parcelHelpers.interopDefault(_cameraRearRounded);
var _cameraRearSharp = require("./CameraRearSharp");
var _cameraRearSharpDefault = parcelHelpers.interopDefault(_cameraRearSharp);
var _cameraRearTwoTone = require("./CameraRearTwoTone");
var _cameraRearTwoToneDefault = parcelHelpers.interopDefault(_cameraRearTwoTone);
var _cameraRoll = require("./CameraRoll");
var _cameraRollDefault = parcelHelpers.interopDefault(_cameraRoll);
var _cameraRollOutlined = require("./CameraRollOutlined");
var _cameraRollOutlinedDefault = parcelHelpers.interopDefault(_cameraRollOutlined);
var _cameraRollRounded = require("./CameraRollRounded");
var _cameraRollRoundedDefault = parcelHelpers.interopDefault(_cameraRollRounded);
var _cameraRollSharp = require("./CameraRollSharp");
var _cameraRollSharpDefault = parcelHelpers.interopDefault(_cameraRollSharp);
var _cameraRollTwoTone = require("./CameraRollTwoTone");
var _cameraRollTwoToneDefault = parcelHelpers.interopDefault(_cameraRollTwoTone);
var _cameraRounded = require("./CameraRounded");
var _cameraRoundedDefault = parcelHelpers.interopDefault(_cameraRounded);
var _cameraSharp = require("./CameraSharp");
var _cameraSharpDefault = parcelHelpers.interopDefault(_cameraSharp);
var _cameraTwoTone = require("./CameraTwoTone");
var _cameraTwoToneDefault = parcelHelpers.interopDefault(_cameraTwoTone);
var _cameraswitch = require("./Cameraswitch");
var _cameraswitchDefault = parcelHelpers.interopDefault(_cameraswitch);
var _cameraswitchOutlined = require("./CameraswitchOutlined");
var _cameraswitchOutlinedDefault = parcelHelpers.interopDefault(_cameraswitchOutlined);
var _cameraswitchRounded = require("./CameraswitchRounded");
var _cameraswitchRoundedDefault = parcelHelpers.interopDefault(_cameraswitchRounded);
var _cameraswitchSharp = require("./CameraswitchSharp");
var _cameraswitchSharpDefault = parcelHelpers.interopDefault(_cameraswitchSharp);
var _cameraswitchTwoTone = require("./CameraswitchTwoTone");
var _cameraswitchTwoToneDefault = parcelHelpers.interopDefault(_cameraswitchTwoTone);
var _campaign = require("./Campaign");
var _campaignDefault = parcelHelpers.interopDefault(_campaign);
var _campaignOutlined = require("./CampaignOutlined");
var _campaignOutlinedDefault = parcelHelpers.interopDefault(_campaignOutlined);
var _campaignRounded = require("./CampaignRounded");
var _campaignRoundedDefault = parcelHelpers.interopDefault(_campaignRounded);
var _campaignSharp = require("./CampaignSharp");
var _campaignSharpDefault = parcelHelpers.interopDefault(_campaignSharp);
var _campaignTwoTone = require("./CampaignTwoTone");
var _campaignTwoToneDefault = parcelHelpers.interopDefault(_campaignTwoTone);
var _cancel = require("./Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _cancelOutlined = require("./CancelOutlined");
var _cancelOutlinedDefault = parcelHelpers.interopDefault(_cancelOutlined);
var _cancelPresentation = require("./CancelPresentation");
var _cancelPresentationDefault = parcelHelpers.interopDefault(_cancelPresentation);
var _cancelPresentationOutlined = require("./CancelPresentationOutlined");
var _cancelPresentationOutlinedDefault = parcelHelpers.interopDefault(_cancelPresentationOutlined);
var _cancelPresentationRounded = require("./CancelPresentationRounded");
var _cancelPresentationRoundedDefault = parcelHelpers.interopDefault(_cancelPresentationRounded);
var _cancelPresentationSharp = require("./CancelPresentationSharp");
var _cancelPresentationSharpDefault = parcelHelpers.interopDefault(_cancelPresentationSharp);
var _cancelPresentationTwoTone = require("./CancelPresentationTwoTone");
var _cancelPresentationTwoToneDefault = parcelHelpers.interopDefault(_cancelPresentationTwoTone);
var _cancelRounded = require("./CancelRounded");
var _cancelRoundedDefault = parcelHelpers.interopDefault(_cancelRounded);
var _cancelScheduleSend = require("./CancelScheduleSend");
var _cancelScheduleSendDefault = parcelHelpers.interopDefault(_cancelScheduleSend);
var _cancelScheduleSendOutlined = require("./CancelScheduleSendOutlined");
var _cancelScheduleSendOutlinedDefault = parcelHelpers.interopDefault(_cancelScheduleSendOutlined);
var _cancelScheduleSendRounded = require("./CancelScheduleSendRounded");
var _cancelScheduleSendRoundedDefault = parcelHelpers.interopDefault(_cancelScheduleSendRounded);
var _cancelScheduleSendSharp = require("./CancelScheduleSendSharp");
var _cancelScheduleSendSharpDefault = parcelHelpers.interopDefault(_cancelScheduleSendSharp);
var _cancelScheduleSendTwoTone = require("./CancelScheduleSendTwoTone");
var _cancelScheduleSendTwoToneDefault = parcelHelpers.interopDefault(_cancelScheduleSendTwoTone);
var _cancelSharp = require("./CancelSharp");
var _cancelSharpDefault = parcelHelpers.interopDefault(_cancelSharp);
var _cancelTwoTone = require("./CancelTwoTone");
var _cancelTwoToneDefault = parcelHelpers.interopDefault(_cancelTwoTone);
var _candlestickChart = require("./CandlestickChart");
var _candlestickChartDefault = parcelHelpers.interopDefault(_candlestickChart);
var _candlestickChartOutlined = require("./CandlestickChartOutlined");
var _candlestickChartOutlinedDefault = parcelHelpers.interopDefault(_candlestickChartOutlined);
var _candlestickChartRounded = require("./CandlestickChartRounded");
var _candlestickChartRoundedDefault = parcelHelpers.interopDefault(_candlestickChartRounded);
var _candlestickChartSharp = require("./CandlestickChartSharp");
var _candlestickChartSharpDefault = parcelHelpers.interopDefault(_candlestickChartSharp);
var _candlestickChartTwoTone = require("./CandlestickChartTwoTone");
var _candlestickChartTwoToneDefault = parcelHelpers.interopDefault(_candlestickChartTwoTone);
var _carCrash = require("./CarCrash");
var _carCrashDefault = parcelHelpers.interopDefault(_carCrash);
var _carCrashOutlined = require("./CarCrashOutlined");
var _carCrashOutlinedDefault = parcelHelpers.interopDefault(_carCrashOutlined);
var _carCrashRounded = require("./CarCrashRounded");
var _carCrashRoundedDefault = parcelHelpers.interopDefault(_carCrashRounded);
var _carCrashSharp = require("./CarCrashSharp");
var _carCrashSharpDefault = parcelHelpers.interopDefault(_carCrashSharp);
var _carCrashTwoTone = require("./CarCrashTwoTone");
var _carCrashTwoToneDefault = parcelHelpers.interopDefault(_carCrashTwoTone);
var _carRental = require("./CarRental");
var _carRentalDefault = parcelHelpers.interopDefault(_carRental);
var _carRentalOutlined = require("./CarRentalOutlined");
var _carRentalOutlinedDefault = parcelHelpers.interopDefault(_carRentalOutlined);
var _carRentalRounded = require("./CarRentalRounded");
var _carRentalRoundedDefault = parcelHelpers.interopDefault(_carRentalRounded);
var _carRentalSharp = require("./CarRentalSharp");
var _carRentalSharpDefault = parcelHelpers.interopDefault(_carRentalSharp);
var _carRentalTwoTone = require("./CarRentalTwoTone");
var _carRentalTwoToneDefault = parcelHelpers.interopDefault(_carRentalTwoTone);
var _carRepair = require("./CarRepair");
var _carRepairDefault = parcelHelpers.interopDefault(_carRepair);
var _carRepairOutlined = require("./CarRepairOutlined");
var _carRepairOutlinedDefault = parcelHelpers.interopDefault(_carRepairOutlined);
var _carRepairRounded = require("./CarRepairRounded");
var _carRepairRoundedDefault = parcelHelpers.interopDefault(_carRepairRounded);
var _carRepairSharp = require("./CarRepairSharp");
var _carRepairSharpDefault = parcelHelpers.interopDefault(_carRepairSharp);
var _carRepairTwoTone = require("./CarRepairTwoTone");
var _carRepairTwoToneDefault = parcelHelpers.interopDefault(_carRepairTwoTone);
var _cardGiftcard = require("./CardGiftcard");
var _cardGiftcardDefault = parcelHelpers.interopDefault(_cardGiftcard);
var _cardGiftcardOutlined = require("./CardGiftcardOutlined");
var _cardGiftcardOutlinedDefault = parcelHelpers.interopDefault(_cardGiftcardOutlined);
var _cardGiftcardRounded = require("./CardGiftcardRounded");
var _cardGiftcardRoundedDefault = parcelHelpers.interopDefault(_cardGiftcardRounded);
var _cardGiftcardSharp = require("./CardGiftcardSharp");
var _cardGiftcardSharpDefault = parcelHelpers.interopDefault(_cardGiftcardSharp);
var _cardGiftcardTwoTone = require("./CardGiftcardTwoTone");
var _cardGiftcardTwoToneDefault = parcelHelpers.interopDefault(_cardGiftcardTwoTone);
var _cardMembership = require("./CardMembership");
var _cardMembershipDefault = parcelHelpers.interopDefault(_cardMembership);
var _cardMembershipOutlined = require("./CardMembershipOutlined");
var _cardMembershipOutlinedDefault = parcelHelpers.interopDefault(_cardMembershipOutlined);
var _cardMembershipRounded = require("./CardMembershipRounded");
var _cardMembershipRoundedDefault = parcelHelpers.interopDefault(_cardMembershipRounded);
var _cardMembershipSharp = require("./CardMembershipSharp");
var _cardMembershipSharpDefault = parcelHelpers.interopDefault(_cardMembershipSharp);
var _cardMembershipTwoTone = require("./CardMembershipTwoTone");
var _cardMembershipTwoToneDefault = parcelHelpers.interopDefault(_cardMembershipTwoTone);
var _cardTravel = require("./CardTravel");
var _cardTravelDefault = parcelHelpers.interopDefault(_cardTravel);
var _cardTravelOutlined = require("./CardTravelOutlined");
var _cardTravelOutlinedDefault = parcelHelpers.interopDefault(_cardTravelOutlined);
var _cardTravelRounded = require("./CardTravelRounded");
var _cardTravelRoundedDefault = parcelHelpers.interopDefault(_cardTravelRounded);
var _cardTravelSharp = require("./CardTravelSharp");
var _cardTravelSharpDefault = parcelHelpers.interopDefault(_cardTravelSharp);
var _cardTravelTwoTone = require("./CardTravelTwoTone");
var _cardTravelTwoToneDefault = parcelHelpers.interopDefault(_cardTravelTwoTone);
var _carpenter = require("./Carpenter");
var _carpenterDefault = parcelHelpers.interopDefault(_carpenter);
var _carpenterOutlined = require("./CarpenterOutlined");
var _carpenterOutlinedDefault = parcelHelpers.interopDefault(_carpenterOutlined);
var _carpenterRounded = require("./CarpenterRounded");
var _carpenterRoundedDefault = parcelHelpers.interopDefault(_carpenterRounded);
var _carpenterSharp = require("./CarpenterSharp");
var _carpenterSharpDefault = parcelHelpers.interopDefault(_carpenterSharp);
var _carpenterTwoTone = require("./CarpenterTwoTone");
var _carpenterTwoToneDefault = parcelHelpers.interopDefault(_carpenterTwoTone);
var _cases = require("./Cases");
var _casesDefault = parcelHelpers.interopDefault(_cases);
var _casesOutlined = require("./CasesOutlined");
var _casesOutlinedDefault = parcelHelpers.interopDefault(_casesOutlined);
var _casesRounded = require("./CasesRounded");
var _casesRoundedDefault = parcelHelpers.interopDefault(_casesRounded);
var _casesSharp = require("./CasesSharp");
var _casesSharpDefault = parcelHelpers.interopDefault(_casesSharp);
var _casesTwoTone = require("./CasesTwoTone");
var _casesTwoToneDefault = parcelHelpers.interopDefault(_casesTwoTone);
var _casino = require("./Casino");
var _casinoDefault = parcelHelpers.interopDefault(_casino);
var _casinoOutlined = require("./CasinoOutlined");
var _casinoOutlinedDefault = parcelHelpers.interopDefault(_casinoOutlined);
var _casinoRounded = require("./CasinoRounded");
var _casinoRoundedDefault = parcelHelpers.interopDefault(_casinoRounded);
var _casinoSharp = require("./CasinoSharp");
var _casinoSharpDefault = parcelHelpers.interopDefault(_casinoSharp);
var _casinoTwoTone = require("./CasinoTwoTone");
var _casinoTwoToneDefault = parcelHelpers.interopDefault(_casinoTwoTone);
var _cast = require("./Cast");
var _castDefault = parcelHelpers.interopDefault(_cast);
var _castConnected = require("./CastConnected");
var _castConnectedDefault = parcelHelpers.interopDefault(_castConnected);
var _castConnectedOutlined = require("./CastConnectedOutlined");
var _castConnectedOutlinedDefault = parcelHelpers.interopDefault(_castConnectedOutlined);
var _castConnectedRounded = require("./CastConnectedRounded");
var _castConnectedRoundedDefault = parcelHelpers.interopDefault(_castConnectedRounded);
var _castConnectedSharp = require("./CastConnectedSharp");
var _castConnectedSharpDefault = parcelHelpers.interopDefault(_castConnectedSharp);
var _castConnectedTwoTone = require("./CastConnectedTwoTone");
var _castConnectedTwoToneDefault = parcelHelpers.interopDefault(_castConnectedTwoTone);
var _castForEducation = require("./CastForEducation");
var _castForEducationDefault = parcelHelpers.interopDefault(_castForEducation);
var _castForEducationOutlined = require("./CastForEducationOutlined");
var _castForEducationOutlinedDefault = parcelHelpers.interopDefault(_castForEducationOutlined);
var _castForEducationRounded = require("./CastForEducationRounded");
var _castForEducationRoundedDefault = parcelHelpers.interopDefault(_castForEducationRounded);
var _castForEducationSharp = require("./CastForEducationSharp");
var _castForEducationSharpDefault = parcelHelpers.interopDefault(_castForEducationSharp);
var _castForEducationTwoTone = require("./CastForEducationTwoTone");
var _castForEducationTwoToneDefault = parcelHelpers.interopDefault(_castForEducationTwoTone);
var _castOutlined = require("./CastOutlined");
var _castOutlinedDefault = parcelHelpers.interopDefault(_castOutlined);
var _castRounded = require("./CastRounded");
var _castRoundedDefault = parcelHelpers.interopDefault(_castRounded);
var _castSharp = require("./CastSharp");
var _castSharpDefault = parcelHelpers.interopDefault(_castSharp);
var _castTwoTone = require("./CastTwoTone");
var _castTwoToneDefault = parcelHelpers.interopDefault(_castTwoTone);
var _castle = require("./Castle");
var _castleDefault = parcelHelpers.interopDefault(_castle);
var _castleOutlined = require("./CastleOutlined");
var _castleOutlinedDefault = parcelHelpers.interopDefault(_castleOutlined);
var _castleRounded = require("./CastleRounded");
var _castleRoundedDefault = parcelHelpers.interopDefault(_castleRounded);
var _castleSharp = require("./CastleSharp");
var _castleSharpDefault = parcelHelpers.interopDefault(_castleSharp);
var _castleTwoTone = require("./CastleTwoTone");
var _castleTwoToneDefault = parcelHelpers.interopDefault(_castleTwoTone);
var _catchingPokemon = require("./CatchingPokemon");
var _catchingPokemonDefault = parcelHelpers.interopDefault(_catchingPokemon);
var _catchingPokemonOutlined = require("./CatchingPokemonOutlined");
var _catchingPokemonOutlinedDefault = parcelHelpers.interopDefault(_catchingPokemonOutlined);
var _catchingPokemonRounded = require("./CatchingPokemonRounded");
var _catchingPokemonRoundedDefault = parcelHelpers.interopDefault(_catchingPokemonRounded);
var _catchingPokemonSharp = require("./CatchingPokemonSharp");
var _catchingPokemonSharpDefault = parcelHelpers.interopDefault(_catchingPokemonSharp);
var _catchingPokemonTwoTone = require("./CatchingPokemonTwoTone");
var _catchingPokemonTwoToneDefault = parcelHelpers.interopDefault(_catchingPokemonTwoTone);
var _category = require("./Category");
var _categoryDefault = parcelHelpers.interopDefault(_category);
var _categoryOutlined = require("./CategoryOutlined");
var _categoryOutlinedDefault = parcelHelpers.interopDefault(_categoryOutlined);
var _categoryRounded = require("./CategoryRounded");
var _categoryRoundedDefault = parcelHelpers.interopDefault(_categoryRounded);
var _categorySharp = require("./CategorySharp");
var _categorySharpDefault = parcelHelpers.interopDefault(_categorySharp);
var _categoryTwoTone = require("./CategoryTwoTone");
var _categoryTwoToneDefault = parcelHelpers.interopDefault(_categoryTwoTone);
var _celebration = require("./Celebration");
var _celebrationDefault = parcelHelpers.interopDefault(_celebration);
var _celebrationOutlined = require("./CelebrationOutlined");
var _celebrationOutlinedDefault = parcelHelpers.interopDefault(_celebrationOutlined);
var _celebrationRounded = require("./CelebrationRounded");
var _celebrationRoundedDefault = parcelHelpers.interopDefault(_celebrationRounded);
var _celebrationSharp = require("./CelebrationSharp");
var _celebrationSharpDefault = parcelHelpers.interopDefault(_celebrationSharp);
var _celebrationTwoTone = require("./CelebrationTwoTone");
var _celebrationTwoToneDefault = parcelHelpers.interopDefault(_celebrationTwoTone);
var _cellTower = require("./CellTower");
var _cellTowerDefault = parcelHelpers.interopDefault(_cellTower);
var _cellTowerOutlined = require("./CellTowerOutlined");
var _cellTowerOutlinedDefault = parcelHelpers.interopDefault(_cellTowerOutlined);
var _cellTowerRounded = require("./CellTowerRounded");
var _cellTowerRoundedDefault = parcelHelpers.interopDefault(_cellTowerRounded);
var _cellTowerSharp = require("./CellTowerSharp");
var _cellTowerSharpDefault = parcelHelpers.interopDefault(_cellTowerSharp);
var _cellTowerTwoTone = require("./CellTowerTwoTone");
var _cellTowerTwoToneDefault = parcelHelpers.interopDefault(_cellTowerTwoTone);
var _cellWifi = require("./CellWifi");
var _cellWifiDefault = parcelHelpers.interopDefault(_cellWifi);
var _cellWifiOutlined = require("./CellWifiOutlined");
var _cellWifiOutlinedDefault = parcelHelpers.interopDefault(_cellWifiOutlined);
var _cellWifiRounded = require("./CellWifiRounded");
var _cellWifiRoundedDefault = parcelHelpers.interopDefault(_cellWifiRounded);
var _cellWifiSharp = require("./CellWifiSharp");
var _cellWifiSharpDefault = parcelHelpers.interopDefault(_cellWifiSharp);
var _cellWifiTwoTone = require("./CellWifiTwoTone");
var _cellWifiTwoToneDefault = parcelHelpers.interopDefault(_cellWifiTwoTone);
var _centerFocusStrong = require("./CenterFocusStrong");
var _centerFocusStrongDefault = parcelHelpers.interopDefault(_centerFocusStrong);
var _centerFocusStrongOutlined = require("./CenterFocusStrongOutlined");
var _centerFocusStrongOutlinedDefault = parcelHelpers.interopDefault(_centerFocusStrongOutlined);
var _centerFocusStrongRounded = require("./CenterFocusStrongRounded");
var _centerFocusStrongRoundedDefault = parcelHelpers.interopDefault(_centerFocusStrongRounded);
var _centerFocusStrongSharp = require("./CenterFocusStrongSharp");
var _centerFocusStrongSharpDefault = parcelHelpers.interopDefault(_centerFocusStrongSharp);
var _centerFocusStrongTwoTone = require("./CenterFocusStrongTwoTone");
var _centerFocusStrongTwoToneDefault = parcelHelpers.interopDefault(_centerFocusStrongTwoTone);
var _centerFocusWeak = require("./CenterFocusWeak");
var _centerFocusWeakDefault = parcelHelpers.interopDefault(_centerFocusWeak);
var _centerFocusWeakOutlined = require("./CenterFocusWeakOutlined");
var _centerFocusWeakOutlinedDefault = parcelHelpers.interopDefault(_centerFocusWeakOutlined);
var _centerFocusWeakRounded = require("./CenterFocusWeakRounded");
var _centerFocusWeakRoundedDefault = parcelHelpers.interopDefault(_centerFocusWeakRounded);
var _centerFocusWeakSharp = require("./CenterFocusWeakSharp");
var _centerFocusWeakSharpDefault = parcelHelpers.interopDefault(_centerFocusWeakSharp);
var _centerFocusWeakTwoTone = require("./CenterFocusWeakTwoTone");
var _centerFocusWeakTwoToneDefault = parcelHelpers.interopDefault(_centerFocusWeakTwoTone);
var _chair = require("./Chair");
var _chairDefault = parcelHelpers.interopDefault(_chair);
var _chairAlt = require("./ChairAlt");
var _chairAltDefault = parcelHelpers.interopDefault(_chairAlt);
var _chairAltOutlined = require("./ChairAltOutlined");
var _chairAltOutlinedDefault = parcelHelpers.interopDefault(_chairAltOutlined);
var _chairAltRounded = require("./ChairAltRounded");
var _chairAltRoundedDefault = parcelHelpers.interopDefault(_chairAltRounded);
var _chairAltSharp = require("./ChairAltSharp");
var _chairAltSharpDefault = parcelHelpers.interopDefault(_chairAltSharp);
var _chairAltTwoTone = require("./ChairAltTwoTone");
var _chairAltTwoToneDefault = parcelHelpers.interopDefault(_chairAltTwoTone);
var _chairOutlined = require("./ChairOutlined");
var _chairOutlinedDefault = parcelHelpers.interopDefault(_chairOutlined);
var _chairRounded = require("./ChairRounded");
var _chairRoundedDefault = parcelHelpers.interopDefault(_chairRounded);
var _chairSharp = require("./ChairSharp");
var _chairSharpDefault = parcelHelpers.interopDefault(_chairSharp);
var _chairTwoTone = require("./ChairTwoTone");
var _chairTwoToneDefault = parcelHelpers.interopDefault(_chairTwoTone);
var _chalet = require("./Chalet");
var _chaletDefault = parcelHelpers.interopDefault(_chalet);
var _chaletOutlined = require("./ChaletOutlined");
var _chaletOutlinedDefault = parcelHelpers.interopDefault(_chaletOutlined);
var _chaletRounded = require("./ChaletRounded");
var _chaletRoundedDefault = parcelHelpers.interopDefault(_chaletRounded);
var _chaletSharp = require("./ChaletSharp");
var _chaletSharpDefault = parcelHelpers.interopDefault(_chaletSharp);
var _chaletTwoTone = require("./ChaletTwoTone");
var _chaletTwoToneDefault = parcelHelpers.interopDefault(_chaletTwoTone);
var _changeCircle = require("./ChangeCircle");
var _changeCircleDefault = parcelHelpers.interopDefault(_changeCircle);
var _changeCircleOutlined = require("./ChangeCircleOutlined");
var _changeCircleOutlinedDefault = parcelHelpers.interopDefault(_changeCircleOutlined);
var _changeCircleRounded = require("./ChangeCircleRounded");
var _changeCircleRoundedDefault = parcelHelpers.interopDefault(_changeCircleRounded);
var _changeCircleSharp = require("./ChangeCircleSharp");
var _changeCircleSharpDefault = parcelHelpers.interopDefault(_changeCircleSharp);
var _changeCircleTwoTone = require("./ChangeCircleTwoTone");
var _changeCircleTwoToneDefault = parcelHelpers.interopDefault(_changeCircleTwoTone);
var _changeHistory = require("./ChangeHistory");
var _changeHistoryDefault = parcelHelpers.interopDefault(_changeHistory);
var _changeHistoryOutlined = require("./ChangeHistoryOutlined");
var _changeHistoryOutlinedDefault = parcelHelpers.interopDefault(_changeHistoryOutlined);
var _changeHistoryRounded = require("./ChangeHistoryRounded");
var _changeHistoryRoundedDefault = parcelHelpers.interopDefault(_changeHistoryRounded);
var _changeHistorySharp = require("./ChangeHistorySharp");
var _changeHistorySharpDefault = parcelHelpers.interopDefault(_changeHistorySharp);
var _changeHistoryTwoTone = require("./ChangeHistoryTwoTone");
var _changeHistoryTwoToneDefault = parcelHelpers.interopDefault(_changeHistoryTwoTone);
var _chargingStation = require("./ChargingStation");
var _chargingStationDefault = parcelHelpers.interopDefault(_chargingStation);
var _chargingStationOutlined = require("./ChargingStationOutlined");
var _chargingStationOutlinedDefault = parcelHelpers.interopDefault(_chargingStationOutlined);
var _chargingStationRounded = require("./ChargingStationRounded");
var _chargingStationRoundedDefault = parcelHelpers.interopDefault(_chargingStationRounded);
var _chargingStationSharp = require("./ChargingStationSharp");
var _chargingStationSharpDefault = parcelHelpers.interopDefault(_chargingStationSharp);
var _chargingStationTwoTone = require("./ChargingStationTwoTone");
var _chargingStationTwoToneDefault = parcelHelpers.interopDefault(_chargingStationTwoTone);
var _chat = require("./Chat");
var _chatDefault = parcelHelpers.interopDefault(_chat);
var _chatBubble = require("./ChatBubble");
var _chatBubbleDefault = parcelHelpers.interopDefault(_chatBubble);
var _chatBubbleOutline = require("./ChatBubbleOutline");
var _chatBubbleOutlineDefault = parcelHelpers.interopDefault(_chatBubbleOutline);
var _chatBubbleOutlineOutlined = require("./ChatBubbleOutlineOutlined");
var _chatBubbleOutlineOutlinedDefault = parcelHelpers.interopDefault(_chatBubbleOutlineOutlined);
var _chatBubbleOutlineRounded = require("./ChatBubbleOutlineRounded");
var _chatBubbleOutlineRoundedDefault = parcelHelpers.interopDefault(_chatBubbleOutlineRounded);
var _chatBubbleOutlineSharp = require("./ChatBubbleOutlineSharp");
var _chatBubbleOutlineSharpDefault = parcelHelpers.interopDefault(_chatBubbleOutlineSharp);
var _chatBubbleOutlineTwoTone = require("./ChatBubbleOutlineTwoTone");
var _chatBubbleOutlineTwoToneDefault = parcelHelpers.interopDefault(_chatBubbleOutlineTwoTone);
var _chatBubbleOutlined = require("./ChatBubbleOutlined");
var _chatBubbleOutlinedDefault = parcelHelpers.interopDefault(_chatBubbleOutlined);
var _chatBubbleRounded = require("./ChatBubbleRounded");
var _chatBubbleRoundedDefault = parcelHelpers.interopDefault(_chatBubbleRounded);
var _chatBubbleSharp = require("./ChatBubbleSharp");
var _chatBubbleSharpDefault = parcelHelpers.interopDefault(_chatBubbleSharp);
var _chatBubbleTwoTone = require("./ChatBubbleTwoTone");
var _chatBubbleTwoToneDefault = parcelHelpers.interopDefault(_chatBubbleTwoTone);
var _chatOutlined = require("./ChatOutlined");
var _chatOutlinedDefault = parcelHelpers.interopDefault(_chatOutlined);
var _chatRounded = require("./ChatRounded");
var _chatRoundedDefault = parcelHelpers.interopDefault(_chatRounded);
var _chatSharp = require("./ChatSharp");
var _chatSharpDefault = parcelHelpers.interopDefault(_chatSharp);
var _chatTwoTone = require("./ChatTwoTone");
var _chatTwoToneDefault = parcelHelpers.interopDefault(_chatTwoTone);
var _check = require("./Check");
var _checkDefault = parcelHelpers.interopDefault(_check);
var _checkBox = require("./CheckBox");
var _checkBoxDefault = parcelHelpers.interopDefault(_checkBox);
var _checkBoxOutlineBlank = require("./CheckBoxOutlineBlank");
var _checkBoxOutlineBlankDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlank);
var _checkBoxOutlineBlankOutlined = require("./CheckBoxOutlineBlankOutlined");
var _checkBoxOutlineBlankOutlinedDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlankOutlined);
var _checkBoxOutlineBlankRounded = require("./CheckBoxOutlineBlankRounded");
var _checkBoxOutlineBlankRoundedDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlankRounded);
var _checkBoxOutlineBlankSharp = require("./CheckBoxOutlineBlankSharp");
var _checkBoxOutlineBlankSharpDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlankSharp);
var _checkBoxOutlineBlankTwoTone = require("./CheckBoxOutlineBlankTwoTone");
var _checkBoxOutlineBlankTwoToneDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlankTwoTone);
var _checkBoxOutlined = require("./CheckBoxOutlined");
var _checkBoxOutlinedDefault = parcelHelpers.interopDefault(_checkBoxOutlined);
var _checkBoxRounded = require("./CheckBoxRounded");
var _checkBoxRoundedDefault = parcelHelpers.interopDefault(_checkBoxRounded);
var _checkBoxSharp = require("./CheckBoxSharp");
var _checkBoxSharpDefault = parcelHelpers.interopDefault(_checkBoxSharp);
var _checkBoxTwoTone = require("./CheckBoxTwoTone");
var _checkBoxTwoToneDefault = parcelHelpers.interopDefault(_checkBoxTwoTone);
var _checkCircle = require("./CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _checkCircleOutline = require("./CheckCircleOutline");
var _checkCircleOutlineDefault = parcelHelpers.interopDefault(_checkCircleOutline);
var _checkCircleOutlineOutlined = require("./CheckCircleOutlineOutlined");
var _checkCircleOutlineOutlinedDefault = parcelHelpers.interopDefault(_checkCircleOutlineOutlined);
var _checkCircleOutlineRounded = require("./CheckCircleOutlineRounded");
var _checkCircleOutlineRoundedDefault = parcelHelpers.interopDefault(_checkCircleOutlineRounded);
var _checkCircleOutlineSharp = require("./CheckCircleOutlineSharp");
var _checkCircleOutlineSharpDefault = parcelHelpers.interopDefault(_checkCircleOutlineSharp);
var _checkCircleOutlineTwoTone = require("./CheckCircleOutlineTwoTone");
var _checkCircleOutlineTwoToneDefault = parcelHelpers.interopDefault(_checkCircleOutlineTwoTone);
var _checkCircleOutlined = require("./CheckCircleOutlined");
var _checkCircleOutlinedDefault = parcelHelpers.interopDefault(_checkCircleOutlined);
var _checkCircleRounded = require("./CheckCircleRounded");
var _checkCircleRoundedDefault = parcelHelpers.interopDefault(_checkCircleRounded);
var _checkCircleSharp = require("./CheckCircleSharp");
var _checkCircleSharpDefault = parcelHelpers.interopDefault(_checkCircleSharp);
var _checkCircleTwoTone = require("./CheckCircleTwoTone");
var _checkCircleTwoToneDefault = parcelHelpers.interopDefault(_checkCircleTwoTone);
var _checkOutlined = require("./CheckOutlined");
var _checkOutlinedDefault = parcelHelpers.interopDefault(_checkOutlined);
var _checkRounded = require("./CheckRounded");
var _checkRoundedDefault = parcelHelpers.interopDefault(_checkRounded);
var _checkSharp = require("./CheckSharp");
var _checkSharpDefault = parcelHelpers.interopDefault(_checkSharp);
var _checkTwoTone = require("./CheckTwoTone");
var _checkTwoToneDefault = parcelHelpers.interopDefault(_checkTwoTone);
var _checklist = require("./Checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
var _checklistOutlined = require("./ChecklistOutlined");
var _checklistOutlinedDefault = parcelHelpers.interopDefault(_checklistOutlined);
var _checklistRounded = require("./ChecklistRounded");
var _checklistRoundedDefault = parcelHelpers.interopDefault(_checklistRounded);
var _checklistRtl = require("./ChecklistRtl");
var _checklistRtlDefault = parcelHelpers.interopDefault(_checklistRtl);
var _checklistRtlOutlined = require("./ChecklistRtlOutlined");
var _checklistRtlOutlinedDefault = parcelHelpers.interopDefault(_checklistRtlOutlined);
var _checklistRtlRounded = require("./ChecklistRtlRounded");
var _checklistRtlRoundedDefault = parcelHelpers.interopDefault(_checklistRtlRounded);
var _checklistRtlSharp = require("./ChecklistRtlSharp");
var _checklistRtlSharpDefault = parcelHelpers.interopDefault(_checklistRtlSharp);
var _checklistRtlTwoTone = require("./ChecklistRtlTwoTone");
var _checklistRtlTwoToneDefault = parcelHelpers.interopDefault(_checklistRtlTwoTone);
var _checklistSharp = require("./ChecklistSharp");
var _checklistSharpDefault = parcelHelpers.interopDefault(_checklistSharp);
var _checklistTwoTone = require("./ChecklistTwoTone");
var _checklistTwoToneDefault = parcelHelpers.interopDefault(_checklistTwoTone);
var _checkroom = require("./Checkroom");
var _checkroomDefault = parcelHelpers.interopDefault(_checkroom);
var _checkroomOutlined = require("./CheckroomOutlined");
var _checkroomOutlinedDefault = parcelHelpers.interopDefault(_checkroomOutlined);
var _checkroomRounded = require("./CheckroomRounded");
var _checkroomRoundedDefault = parcelHelpers.interopDefault(_checkroomRounded);
var _checkroomSharp = require("./CheckroomSharp");
var _checkroomSharpDefault = parcelHelpers.interopDefault(_checkroomSharp);
var _checkroomTwoTone = require("./CheckroomTwoTone");
var _checkroomTwoToneDefault = parcelHelpers.interopDefault(_checkroomTwoTone);
var _chevronLeft = require("./ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronLeftOutlined = require("./ChevronLeftOutlined");
var _chevronLeftOutlinedDefault = parcelHelpers.interopDefault(_chevronLeftOutlined);
var _chevronLeftRounded = require("./ChevronLeftRounded");
var _chevronLeftRoundedDefault = parcelHelpers.interopDefault(_chevronLeftRounded);
var _chevronLeftSharp = require("./ChevronLeftSharp");
var _chevronLeftSharpDefault = parcelHelpers.interopDefault(_chevronLeftSharp);
var _chevronLeftTwoTone = require("./ChevronLeftTwoTone");
var _chevronLeftTwoToneDefault = parcelHelpers.interopDefault(_chevronLeftTwoTone);
var _chevronRight = require("./ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _chevronRightOutlined = require("./ChevronRightOutlined");
var _chevronRightOutlinedDefault = parcelHelpers.interopDefault(_chevronRightOutlined);
var _chevronRightRounded = require("./ChevronRightRounded");
var _chevronRightRoundedDefault = parcelHelpers.interopDefault(_chevronRightRounded);
var _chevronRightSharp = require("./ChevronRightSharp");
var _chevronRightSharpDefault = parcelHelpers.interopDefault(_chevronRightSharp);
var _chevronRightTwoTone = require("./ChevronRightTwoTone");
var _chevronRightTwoToneDefault = parcelHelpers.interopDefault(_chevronRightTwoTone);
var _childCare = require("./ChildCare");
var _childCareDefault = parcelHelpers.interopDefault(_childCare);
var _childCareOutlined = require("./ChildCareOutlined");
var _childCareOutlinedDefault = parcelHelpers.interopDefault(_childCareOutlined);
var _childCareRounded = require("./ChildCareRounded");
var _childCareRoundedDefault = parcelHelpers.interopDefault(_childCareRounded);
var _childCareSharp = require("./ChildCareSharp");
var _childCareSharpDefault = parcelHelpers.interopDefault(_childCareSharp);
var _childCareTwoTone = require("./ChildCareTwoTone");
var _childCareTwoToneDefault = parcelHelpers.interopDefault(_childCareTwoTone);
var _childFriendly = require("./ChildFriendly");
var _childFriendlyDefault = parcelHelpers.interopDefault(_childFriendly);
var _childFriendlyOutlined = require("./ChildFriendlyOutlined");
var _childFriendlyOutlinedDefault = parcelHelpers.interopDefault(_childFriendlyOutlined);
var _childFriendlyRounded = require("./ChildFriendlyRounded");
var _childFriendlyRoundedDefault = parcelHelpers.interopDefault(_childFriendlyRounded);
var _childFriendlySharp = require("./ChildFriendlySharp");
var _childFriendlySharpDefault = parcelHelpers.interopDefault(_childFriendlySharp);
var _childFriendlyTwoTone = require("./ChildFriendlyTwoTone");
var _childFriendlyTwoToneDefault = parcelHelpers.interopDefault(_childFriendlyTwoTone);
var _chromeReaderMode = require("./ChromeReaderMode");
var _chromeReaderModeDefault = parcelHelpers.interopDefault(_chromeReaderMode);
var _chromeReaderModeOutlined = require("./ChromeReaderModeOutlined");
var _chromeReaderModeOutlinedDefault = parcelHelpers.interopDefault(_chromeReaderModeOutlined);
var _chromeReaderModeRounded = require("./ChromeReaderModeRounded");
var _chromeReaderModeRoundedDefault = parcelHelpers.interopDefault(_chromeReaderModeRounded);
var _chromeReaderModeSharp = require("./ChromeReaderModeSharp");
var _chromeReaderModeSharpDefault = parcelHelpers.interopDefault(_chromeReaderModeSharp);
var _chromeReaderModeTwoTone = require("./ChromeReaderModeTwoTone");
var _chromeReaderModeTwoToneDefault = parcelHelpers.interopDefault(_chromeReaderModeTwoTone);
var _church = require("./Church");
var _churchDefault = parcelHelpers.interopDefault(_church);
var _churchOutlined = require("./ChurchOutlined");
var _churchOutlinedDefault = parcelHelpers.interopDefault(_churchOutlined);
var _churchRounded = require("./ChurchRounded");
var _churchRoundedDefault = parcelHelpers.interopDefault(_churchRounded);
var _churchSharp = require("./ChurchSharp");
var _churchSharpDefault = parcelHelpers.interopDefault(_churchSharp);
var _churchTwoTone = require("./ChurchTwoTone");
var _churchTwoToneDefault = parcelHelpers.interopDefault(_churchTwoTone);
var _circle = require("./Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _circleNotifications = require("./CircleNotifications");
var _circleNotificationsDefault = parcelHelpers.interopDefault(_circleNotifications);
var _circleNotificationsOutlined = require("./CircleNotificationsOutlined");
var _circleNotificationsOutlinedDefault = parcelHelpers.interopDefault(_circleNotificationsOutlined);
var _circleNotificationsRounded = require("./CircleNotificationsRounded");
var _circleNotificationsRoundedDefault = parcelHelpers.interopDefault(_circleNotificationsRounded);
var _circleNotificationsSharp = require("./CircleNotificationsSharp");
var _circleNotificationsSharpDefault = parcelHelpers.interopDefault(_circleNotificationsSharp);
var _circleNotificationsTwoTone = require("./CircleNotificationsTwoTone");
var _circleNotificationsTwoToneDefault = parcelHelpers.interopDefault(_circleNotificationsTwoTone);
var _circleOutlined = require("./CircleOutlined");
var _circleOutlinedDefault = parcelHelpers.interopDefault(_circleOutlined);
var _circleRounded = require("./CircleRounded");
var _circleRoundedDefault = parcelHelpers.interopDefault(_circleRounded);
var _circleSharp = require("./CircleSharp");
var _circleSharpDefault = parcelHelpers.interopDefault(_circleSharp);
var _circleTwoTone = require("./CircleTwoTone");
var _circleTwoToneDefault = parcelHelpers.interopDefault(_circleTwoTone);
var _class = require("./Class");
var _classDefault = parcelHelpers.interopDefault(_class);
var _classOutlined = require("./ClassOutlined");
var _classOutlinedDefault = parcelHelpers.interopDefault(_classOutlined);
var _classRounded = require("./ClassRounded");
var _classRoundedDefault = parcelHelpers.interopDefault(_classRounded);
var _classSharp = require("./ClassSharp");
var _classSharpDefault = parcelHelpers.interopDefault(_classSharp);
var _classTwoTone = require("./ClassTwoTone");
var _classTwoToneDefault = parcelHelpers.interopDefault(_classTwoTone);
var _cleanHands = require("./CleanHands");
var _cleanHandsDefault = parcelHelpers.interopDefault(_cleanHands);
var _cleanHandsOutlined = require("./CleanHandsOutlined");
var _cleanHandsOutlinedDefault = parcelHelpers.interopDefault(_cleanHandsOutlined);
var _cleanHandsRounded = require("./CleanHandsRounded");
var _cleanHandsRoundedDefault = parcelHelpers.interopDefault(_cleanHandsRounded);
var _cleanHandsSharp = require("./CleanHandsSharp");
var _cleanHandsSharpDefault = parcelHelpers.interopDefault(_cleanHandsSharp);
var _cleanHandsTwoTone = require("./CleanHandsTwoTone");
var _cleanHandsTwoToneDefault = parcelHelpers.interopDefault(_cleanHandsTwoTone);
var _cleaningServices = require("./CleaningServices");
var _cleaningServicesDefault = parcelHelpers.interopDefault(_cleaningServices);
var _cleaningServicesOutlined = require("./CleaningServicesOutlined");
var _cleaningServicesOutlinedDefault = parcelHelpers.interopDefault(_cleaningServicesOutlined);
var _cleaningServicesRounded = require("./CleaningServicesRounded");
var _cleaningServicesRoundedDefault = parcelHelpers.interopDefault(_cleaningServicesRounded);
var _cleaningServicesSharp = require("./CleaningServicesSharp");
var _cleaningServicesSharpDefault = parcelHelpers.interopDefault(_cleaningServicesSharp);
var _cleaningServicesTwoTone = require("./CleaningServicesTwoTone");
var _cleaningServicesTwoToneDefault = parcelHelpers.interopDefault(_cleaningServicesTwoTone);
var _clear = require("./Clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
var _clearAll = require("./ClearAll");
var _clearAllDefault = parcelHelpers.interopDefault(_clearAll);
var _clearAllOutlined = require("./ClearAllOutlined");
var _clearAllOutlinedDefault = parcelHelpers.interopDefault(_clearAllOutlined);
var _clearAllRounded = require("./ClearAllRounded");
var _clearAllRoundedDefault = parcelHelpers.interopDefault(_clearAllRounded);
var _clearAllSharp = require("./ClearAllSharp");
var _clearAllSharpDefault = parcelHelpers.interopDefault(_clearAllSharp);
var _clearAllTwoTone = require("./ClearAllTwoTone");
var _clearAllTwoToneDefault = parcelHelpers.interopDefault(_clearAllTwoTone);
var _clearOutlined = require("./ClearOutlined");
var _clearOutlinedDefault = parcelHelpers.interopDefault(_clearOutlined);
var _clearRounded = require("./ClearRounded");
var _clearRoundedDefault = parcelHelpers.interopDefault(_clearRounded);
var _clearSharp = require("./ClearSharp");
var _clearSharpDefault = parcelHelpers.interopDefault(_clearSharp);
var _clearTwoTone = require("./ClearTwoTone");
var _clearTwoToneDefault = parcelHelpers.interopDefault(_clearTwoTone);
var _close = require("./Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _closeFullscreen = require("./CloseFullscreen");
var _closeFullscreenDefault = parcelHelpers.interopDefault(_closeFullscreen);
var _closeFullscreenOutlined = require("./CloseFullscreenOutlined");
var _closeFullscreenOutlinedDefault = parcelHelpers.interopDefault(_closeFullscreenOutlined);
var _closeFullscreenRounded = require("./CloseFullscreenRounded");
var _closeFullscreenRoundedDefault = parcelHelpers.interopDefault(_closeFullscreenRounded);
var _closeFullscreenSharp = require("./CloseFullscreenSharp");
var _closeFullscreenSharpDefault = parcelHelpers.interopDefault(_closeFullscreenSharp);
var _closeFullscreenTwoTone = require("./CloseFullscreenTwoTone");
var _closeFullscreenTwoToneDefault = parcelHelpers.interopDefault(_closeFullscreenTwoTone);
var _closeOutlined = require("./CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _closeRounded = require("./CloseRounded");
var _closeRoundedDefault = parcelHelpers.interopDefault(_closeRounded);
var _closeSharp = require("./CloseSharp");
var _closeSharpDefault = parcelHelpers.interopDefault(_closeSharp);
var _closeTwoTone = require("./CloseTwoTone");
var _closeTwoToneDefault = parcelHelpers.interopDefault(_closeTwoTone);
var _closedCaption = require("./ClosedCaption");
var _closedCaptionDefault = parcelHelpers.interopDefault(_closedCaption);
var _closedCaptionDisabled = require("./ClosedCaptionDisabled");
var _closedCaptionDisabledDefault = parcelHelpers.interopDefault(_closedCaptionDisabled);
var _closedCaptionDisabledOutlined = require("./ClosedCaptionDisabledOutlined");
var _closedCaptionDisabledOutlinedDefault = parcelHelpers.interopDefault(_closedCaptionDisabledOutlined);
var _closedCaptionDisabledRounded = require("./ClosedCaptionDisabledRounded");
var _closedCaptionDisabledRoundedDefault = parcelHelpers.interopDefault(_closedCaptionDisabledRounded);
var _closedCaptionDisabledSharp = require("./ClosedCaptionDisabledSharp");
var _closedCaptionDisabledSharpDefault = parcelHelpers.interopDefault(_closedCaptionDisabledSharp);
var _closedCaptionDisabledTwoTone = require("./ClosedCaptionDisabledTwoTone");
var _closedCaptionDisabledTwoToneDefault = parcelHelpers.interopDefault(_closedCaptionDisabledTwoTone);
var _closedCaptionOff = require("./ClosedCaptionOff");
var _closedCaptionOffDefault = parcelHelpers.interopDefault(_closedCaptionOff);
var _closedCaptionOffOutlined = require("./ClosedCaptionOffOutlined");
var _closedCaptionOffOutlinedDefault = parcelHelpers.interopDefault(_closedCaptionOffOutlined);
var _closedCaptionOffRounded = require("./ClosedCaptionOffRounded");
var _closedCaptionOffRoundedDefault = parcelHelpers.interopDefault(_closedCaptionOffRounded);
var _closedCaptionOffSharp = require("./ClosedCaptionOffSharp");
var _closedCaptionOffSharpDefault = parcelHelpers.interopDefault(_closedCaptionOffSharp);
var _closedCaptionOffTwoTone = require("./ClosedCaptionOffTwoTone");
var _closedCaptionOffTwoToneDefault = parcelHelpers.interopDefault(_closedCaptionOffTwoTone);
var _closedCaptionOutlined = require("./ClosedCaptionOutlined");
var _closedCaptionOutlinedDefault = parcelHelpers.interopDefault(_closedCaptionOutlined);
var _closedCaptionRounded = require("./ClosedCaptionRounded");
var _closedCaptionRoundedDefault = parcelHelpers.interopDefault(_closedCaptionRounded);
var _closedCaptionSharp = require("./ClosedCaptionSharp");
var _closedCaptionSharpDefault = parcelHelpers.interopDefault(_closedCaptionSharp);
var _closedCaptionTwoTone = require("./ClosedCaptionTwoTone");
var _closedCaptionTwoToneDefault = parcelHelpers.interopDefault(_closedCaptionTwoTone);
var _cloud = require("./Cloud");
var _cloudDefault = parcelHelpers.interopDefault(_cloud);
var _cloudCircle = require("./CloudCircle");
var _cloudCircleDefault = parcelHelpers.interopDefault(_cloudCircle);
var _cloudCircleOutlined = require("./CloudCircleOutlined");
var _cloudCircleOutlinedDefault = parcelHelpers.interopDefault(_cloudCircleOutlined);
var _cloudCircleRounded = require("./CloudCircleRounded");
var _cloudCircleRoundedDefault = parcelHelpers.interopDefault(_cloudCircleRounded);
var _cloudCircleSharp = require("./CloudCircleSharp");
var _cloudCircleSharpDefault = parcelHelpers.interopDefault(_cloudCircleSharp);
var _cloudCircleTwoTone = require("./CloudCircleTwoTone");
var _cloudCircleTwoToneDefault = parcelHelpers.interopDefault(_cloudCircleTwoTone);
var _cloudDone = require("./CloudDone");
var _cloudDoneDefault = parcelHelpers.interopDefault(_cloudDone);
var _cloudDoneOutlined = require("./CloudDoneOutlined");
var _cloudDoneOutlinedDefault = parcelHelpers.interopDefault(_cloudDoneOutlined);
var _cloudDoneRounded = require("./CloudDoneRounded");
var _cloudDoneRoundedDefault = parcelHelpers.interopDefault(_cloudDoneRounded);
var _cloudDoneSharp = require("./CloudDoneSharp");
var _cloudDoneSharpDefault = parcelHelpers.interopDefault(_cloudDoneSharp);
var _cloudDoneTwoTone = require("./CloudDoneTwoTone");
var _cloudDoneTwoToneDefault = parcelHelpers.interopDefault(_cloudDoneTwoTone);
var _cloudDownload = require("./CloudDownload");
var _cloudDownloadDefault = parcelHelpers.interopDefault(_cloudDownload);
var _cloudDownloadOutlined = require("./CloudDownloadOutlined");
var _cloudDownloadOutlinedDefault = parcelHelpers.interopDefault(_cloudDownloadOutlined);
var _cloudDownloadRounded = require("./CloudDownloadRounded");
var _cloudDownloadRoundedDefault = parcelHelpers.interopDefault(_cloudDownloadRounded);
var _cloudDownloadSharp = require("./CloudDownloadSharp");
var _cloudDownloadSharpDefault = parcelHelpers.interopDefault(_cloudDownloadSharp);
var _cloudDownloadTwoTone = require("./CloudDownloadTwoTone");
var _cloudDownloadTwoToneDefault = parcelHelpers.interopDefault(_cloudDownloadTwoTone);
var _cloudOff = require("./CloudOff");
var _cloudOffDefault = parcelHelpers.interopDefault(_cloudOff);
var _cloudOffOutlined = require("./CloudOffOutlined");
var _cloudOffOutlinedDefault = parcelHelpers.interopDefault(_cloudOffOutlined);
var _cloudOffRounded = require("./CloudOffRounded");
var _cloudOffRoundedDefault = parcelHelpers.interopDefault(_cloudOffRounded);
var _cloudOffSharp = require("./CloudOffSharp");
var _cloudOffSharpDefault = parcelHelpers.interopDefault(_cloudOffSharp);
var _cloudOffTwoTone = require("./CloudOffTwoTone");
var _cloudOffTwoToneDefault = parcelHelpers.interopDefault(_cloudOffTwoTone);
var _cloudOutlined = require("./CloudOutlined");
var _cloudOutlinedDefault = parcelHelpers.interopDefault(_cloudOutlined);
var _cloudQueue = require("./CloudQueue");
var _cloudQueueDefault = parcelHelpers.interopDefault(_cloudQueue);
var _cloudQueueOutlined = require("./CloudQueueOutlined");
var _cloudQueueOutlinedDefault = parcelHelpers.interopDefault(_cloudQueueOutlined);
var _cloudQueueRounded = require("./CloudQueueRounded");
var _cloudQueueRoundedDefault = parcelHelpers.interopDefault(_cloudQueueRounded);
var _cloudQueueSharp = require("./CloudQueueSharp");
var _cloudQueueSharpDefault = parcelHelpers.interopDefault(_cloudQueueSharp);
var _cloudQueueTwoTone = require("./CloudQueueTwoTone");
var _cloudQueueTwoToneDefault = parcelHelpers.interopDefault(_cloudQueueTwoTone);
var _cloudRounded = require("./CloudRounded");
var _cloudRoundedDefault = parcelHelpers.interopDefault(_cloudRounded);
var _cloudSharp = require("./CloudSharp");
var _cloudSharpDefault = parcelHelpers.interopDefault(_cloudSharp);
var _cloudSync = require("./CloudSync");
var _cloudSyncDefault = parcelHelpers.interopDefault(_cloudSync);
var _cloudSyncOutlined = require("./CloudSyncOutlined");
var _cloudSyncOutlinedDefault = parcelHelpers.interopDefault(_cloudSyncOutlined);
var _cloudSyncRounded = require("./CloudSyncRounded");
var _cloudSyncRoundedDefault = parcelHelpers.interopDefault(_cloudSyncRounded);
var _cloudSyncSharp = require("./CloudSyncSharp");
var _cloudSyncSharpDefault = parcelHelpers.interopDefault(_cloudSyncSharp);
var _cloudSyncTwoTone = require("./CloudSyncTwoTone");
var _cloudSyncTwoToneDefault = parcelHelpers.interopDefault(_cloudSyncTwoTone);
var _cloudTwoTone = require("./CloudTwoTone");
var _cloudTwoToneDefault = parcelHelpers.interopDefault(_cloudTwoTone);
var _cloudUpload = require("./CloudUpload");
var _cloudUploadDefault = parcelHelpers.interopDefault(_cloudUpload);
var _cloudUploadOutlined = require("./CloudUploadOutlined");
var _cloudUploadOutlinedDefault = parcelHelpers.interopDefault(_cloudUploadOutlined);
var _cloudUploadRounded = require("./CloudUploadRounded");
var _cloudUploadRoundedDefault = parcelHelpers.interopDefault(_cloudUploadRounded);
var _cloudUploadSharp = require("./CloudUploadSharp");
var _cloudUploadSharpDefault = parcelHelpers.interopDefault(_cloudUploadSharp);
var _cloudUploadTwoTone = require("./CloudUploadTwoTone");
var _cloudUploadTwoToneDefault = parcelHelpers.interopDefault(_cloudUploadTwoTone);
var _co2 = require("./Co2");
var _co2Default = parcelHelpers.interopDefault(_co2);
var _co2Outlined = require("./Co2Outlined");
var _co2OutlinedDefault = parcelHelpers.interopDefault(_co2Outlined);
var _co2Rounded = require("./Co2Rounded");
var _co2RoundedDefault = parcelHelpers.interopDefault(_co2Rounded);
var _co2Sharp = require("./Co2Sharp");
var _co2SharpDefault = parcelHelpers.interopDefault(_co2Sharp);
var _co2TwoTone = require("./Co2TwoTone");
var _co2TwoToneDefault = parcelHelpers.interopDefault(_co2TwoTone);
var _coPresent = require("./CoPresent");
var _coPresentDefault = parcelHelpers.interopDefault(_coPresent);
var _coPresentOutlined = require("./CoPresentOutlined");
var _coPresentOutlinedDefault = parcelHelpers.interopDefault(_coPresentOutlined);
var _coPresentRounded = require("./CoPresentRounded");
var _coPresentRoundedDefault = parcelHelpers.interopDefault(_coPresentRounded);
var _coPresentSharp = require("./CoPresentSharp");
var _coPresentSharpDefault = parcelHelpers.interopDefault(_coPresentSharp);
var _coPresentTwoTone = require("./CoPresentTwoTone");
var _coPresentTwoToneDefault = parcelHelpers.interopDefault(_coPresentTwoTone);
var _code = require("./Code");
var _codeDefault = parcelHelpers.interopDefault(_code);
var _codeOff = require("./CodeOff");
var _codeOffDefault = parcelHelpers.interopDefault(_codeOff);
var _codeOffOutlined = require("./CodeOffOutlined");
var _codeOffOutlinedDefault = parcelHelpers.interopDefault(_codeOffOutlined);
var _codeOffRounded = require("./CodeOffRounded");
var _codeOffRoundedDefault = parcelHelpers.interopDefault(_codeOffRounded);
var _codeOffSharp = require("./CodeOffSharp");
var _codeOffSharpDefault = parcelHelpers.interopDefault(_codeOffSharp);
var _codeOffTwoTone = require("./CodeOffTwoTone");
var _codeOffTwoToneDefault = parcelHelpers.interopDefault(_codeOffTwoTone);
var _codeOutlined = require("./CodeOutlined");
var _codeOutlinedDefault = parcelHelpers.interopDefault(_codeOutlined);
var _codeRounded = require("./CodeRounded");
var _codeRoundedDefault = parcelHelpers.interopDefault(_codeRounded);
var _codeSharp = require("./CodeSharp");
var _codeSharpDefault = parcelHelpers.interopDefault(_codeSharp);
var _codeTwoTone = require("./CodeTwoTone");
var _codeTwoToneDefault = parcelHelpers.interopDefault(_codeTwoTone);
var _coffee = require("./Coffee");
var _coffeeDefault = parcelHelpers.interopDefault(_coffee);
var _coffeeMaker = require("./CoffeeMaker");
var _coffeeMakerDefault = parcelHelpers.interopDefault(_coffeeMaker);
var _coffeeMakerOutlined = require("./CoffeeMakerOutlined");
var _coffeeMakerOutlinedDefault = parcelHelpers.interopDefault(_coffeeMakerOutlined);
var _coffeeMakerRounded = require("./CoffeeMakerRounded");
var _coffeeMakerRoundedDefault = parcelHelpers.interopDefault(_coffeeMakerRounded);
var _coffeeMakerSharp = require("./CoffeeMakerSharp");
var _coffeeMakerSharpDefault = parcelHelpers.interopDefault(_coffeeMakerSharp);
var _coffeeMakerTwoTone = require("./CoffeeMakerTwoTone");
var _coffeeMakerTwoToneDefault = parcelHelpers.interopDefault(_coffeeMakerTwoTone);
var _coffeeOutlined = require("./CoffeeOutlined");
var _coffeeOutlinedDefault = parcelHelpers.interopDefault(_coffeeOutlined);
var _coffeeRounded = require("./CoffeeRounded");
var _coffeeRoundedDefault = parcelHelpers.interopDefault(_coffeeRounded);
var _coffeeSharp = require("./CoffeeSharp");
var _coffeeSharpDefault = parcelHelpers.interopDefault(_coffeeSharp);
var _coffeeTwoTone = require("./CoffeeTwoTone");
var _coffeeTwoToneDefault = parcelHelpers.interopDefault(_coffeeTwoTone);
var _collections = require("./Collections");
var _collectionsDefault = parcelHelpers.interopDefault(_collections);
var _collectionsBookmark = require("./CollectionsBookmark");
var _collectionsBookmarkDefault = parcelHelpers.interopDefault(_collectionsBookmark);
var _collectionsBookmarkOutlined = require("./CollectionsBookmarkOutlined");
var _collectionsBookmarkOutlinedDefault = parcelHelpers.interopDefault(_collectionsBookmarkOutlined);
var _collectionsBookmarkRounded = require("./CollectionsBookmarkRounded");
var _collectionsBookmarkRoundedDefault = parcelHelpers.interopDefault(_collectionsBookmarkRounded);
var _collectionsBookmarkSharp = require("./CollectionsBookmarkSharp");
var _collectionsBookmarkSharpDefault = parcelHelpers.interopDefault(_collectionsBookmarkSharp);
var _collectionsBookmarkTwoTone = require("./CollectionsBookmarkTwoTone");
var _collectionsBookmarkTwoToneDefault = parcelHelpers.interopDefault(_collectionsBookmarkTwoTone);
var _collectionsOutlined = require("./CollectionsOutlined");
var _collectionsOutlinedDefault = parcelHelpers.interopDefault(_collectionsOutlined);
var _collectionsRounded = require("./CollectionsRounded");
var _collectionsRoundedDefault = parcelHelpers.interopDefault(_collectionsRounded);
var _collectionsSharp = require("./CollectionsSharp");
var _collectionsSharpDefault = parcelHelpers.interopDefault(_collectionsSharp);
var _collectionsTwoTone = require("./CollectionsTwoTone");
var _collectionsTwoToneDefault = parcelHelpers.interopDefault(_collectionsTwoTone);
var _colorLens = require("./ColorLens");
var _colorLensDefault = parcelHelpers.interopDefault(_colorLens);
var _colorLensOutlined = require("./ColorLensOutlined");
var _colorLensOutlinedDefault = parcelHelpers.interopDefault(_colorLensOutlined);
var _colorLensRounded = require("./ColorLensRounded");
var _colorLensRoundedDefault = parcelHelpers.interopDefault(_colorLensRounded);
var _colorLensSharp = require("./ColorLensSharp");
var _colorLensSharpDefault = parcelHelpers.interopDefault(_colorLensSharp);
var _colorLensTwoTone = require("./ColorLensTwoTone");
var _colorLensTwoToneDefault = parcelHelpers.interopDefault(_colorLensTwoTone);
var _colorize = require("./Colorize");
var _colorizeDefault = parcelHelpers.interopDefault(_colorize);
var _colorizeOutlined = require("./ColorizeOutlined");
var _colorizeOutlinedDefault = parcelHelpers.interopDefault(_colorizeOutlined);
var _colorizeRounded = require("./ColorizeRounded");
var _colorizeRoundedDefault = parcelHelpers.interopDefault(_colorizeRounded);
var _colorizeSharp = require("./ColorizeSharp");
var _colorizeSharpDefault = parcelHelpers.interopDefault(_colorizeSharp);
var _colorizeTwoTone = require("./ColorizeTwoTone");
var _colorizeTwoToneDefault = parcelHelpers.interopDefault(_colorizeTwoTone);
var _comment = require("./Comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _commentBank = require("./CommentBank");
var _commentBankDefault = parcelHelpers.interopDefault(_commentBank);
var _commentBankOutlined = require("./CommentBankOutlined");
var _commentBankOutlinedDefault = parcelHelpers.interopDefault(_commentBankOutlined);
var _commentBankRounded = require("./CommentBankRounded");
var _commentBankRoundedDefault = parcelHelpers.interopDefault(_commentBankRounded);
var _commentBankSharp = require("./CommentBankSharp");
var _commentBankSharpDefault = parcelHelpers.interopDefault(_commentBankSharp);
var _commentBankTwoTone = require("./CommentBankTwoTone");
var _commentBankTwoToneDefault = parcelHelpers.interopDefault(_commentBankTwoTone);
var _commentOutlined = require("./CommentOutlined");
var _commentOutlinedDefault = parcelHelpers.interopDefault(_commentOutlined);
var _commentRounded = require("./CommentRounded");
var _commentRoundedDefault = parcelHelpers.interopDefault(_commentRounded);
var _commentSharp = require("./CommentSharp");
var _commentSharpDefault = parcelHelpers.interopDefault(_commentSharp);
var _commentTwoTone = require("./CommentTwoTone");
var _commentTwoToneDefault = parcelHelpers.interopDefault(_commentTwoTone);
var _commentsDisabled = require("./CommentsDisabled");
var _commentsDisabledDefault = parcelHelpers.interopDefault(_commentsDisabled);
var _commentsDisabledOutlined = require("./CommentsDisabledOutlined");
var _commentsDisabledOutlinedDefault = parcelHelpers.interopDefault(_commentsDisabledOutlined);
var _commentsDisabledRounded = require("./CommentsDisabledRounded");
var _commentsDisabledRoundedDefault = parcelHelpers.interopDefault(_commentsDisabledRounded);
var _commentsDisabledSharp = require("./CommentsDisabledSharp");
var _commentsDisabledSharpDefault = parcelHelpers.interopDefault(_commentsDisabledSharp);
var _commentsDisabledTwoTone = require("./CommentsDisabledTwoTone");
var _commentsDisabledTwoToneDefault = parcelHelpers.interopDefault(_commentsDisabledTwoTone);
var _commit = require("./Commit");
var _commitDefault = parcelHelpers.interopDefault(_commit);
var _commitOutlined = require("./CommitOutlined");
var _commitOutlinedDefault = parcelHelpers.interopDefault(_commitOutlined);
var _commitRounded = require("./CommitRounded");
var _commitRoundedDefault = parcelHelpers.interopDefault(_commitRounded);
var _commitSharp = require("./CommitSharp");
var _commitSharpDefault = parcelHelpers.interopDefault(_commitSharp);
var _commitTwoTone = require("./CommitTwoTone");
var _commitTwoToneDefault = parcelHelpers.interopDefault(_commitTwoTone);
var _commute = require("./Commute");
var _commuteDefault = parcelHelpers.interopDefault(_commute);
var _commuteOutlined = require("./CommuteOutlined");
var _commuteOutlinedDefault = parcelHelpers.interopDefault(_commuteOutlined);
var _commuteRounded = require("./CommuteRounded");
var _commuteRoundedDefault = parcelHelpers.interopDefault(_commuteRounded);
var _commuteSharp = require("./CommuteSharp");
var _commuteSharpDefault = parcelHelpers.interopDefault(_commuteSharp);
var _commuteTwoTone = require("./CommuteTwoTone");
var _commuteTwoToneDefault = parcelHelpers.interopDefault(_commuteTwoTone);
var _compare = require("./Compare");
var _compareDefault = parcelHelpers.interopDefault(_compare);
var _compareArrows = require("./CompareArrows");
var _compareArrowsDefault = parcelHelpers.interopDefault(_compareArrows);
var _compareArrowsOutlined = require("./CompareArrowsOutlined");
var _compareArrowsOutlinedDefault = parcelHelpers.interopDefault(_compareArrowsOutlined);
var _compareArrowsRounded = require("./CompareArrowsRounded");
var _compareArrowsRoundedDefault = parcelHelpers.interopDefault(_compareArrowsRounded);
var _compareArrowsSharp = require("./CompareArrowsSharp");
var _compareArrowsSharpDefault = parcelHelpers.interopDefault(_compareArrowsSharp);
var _compareArrowsTwoTone = require("./CompareArrowsTwoTone");
var _compareArrowsTwoToneDefault = parcelHelpers.interopDefault(_compareArrowsTwoTone);
var _compareOutlined = require("./CompareOutlined");
var _compareOutlinedDefault = parcelHelpers.interopDefault(_compareOutlined);
var _compareRounded = require("./CompareRounded");
var _compareRoundedDefault = parcelHelpers.interopDefault(_compareRounded);
var _compareSharp = require("./CompareSharp");
var _compareSharpDefault = parcelHelpers.interopDefault(_compareSharp);
var _compareTwoTone = require("./CompareTwoTone");
var _compareTwoToneDefault = parcelHelpers.interopDefault(_compareTwoTone);
var _compassCalibration = require("./CompassCalibration");
var _compassCalibrationDefault = parcelHelpers.interopDefault(_compassCalibration);
var _compassCalibrationOutlined = require("./CompassCalibrationOutlined");
var _compassCalibrationOutlinedDefault = parcelHelpers.interopDefault(_compassCalibrationOutlined);
var _compassCalibrationRounded = require("./CompassCalibrationRounded");
var _compassCalibrationRoundedDefault = parcelHelpers.interopDefault(_compassCalibrationRounded);
var _compassCalibrationSharp = require("./CompassCalibrationSharp");
var _compassCalibrationSharpDefault = parcelHelpers.interopDefault(_compassCalibrationSharp);
var _compassCalibrationTwoTone = require("./CompassCalibrationTwoTone");
var _compassCalibrationTwoToneDefault = parcelHelpers.interopDefault(_compassCalibrationTwoTone);
var _compress = require("./Compress");
var _compressDefault = parcelHelpers.interopDefault(_compress);
var _compressOutlined = require("./CompressOutlined");
var _compressOutlinedDefault = parcelHelpers.interopDefault(_compressOutlined);
var _compressRounded = require("./CompressRounded");
var _compressRoundedDefault = parcelHelpers.interopDefault(_compressRounded);
var _compressSharp = require("./CompressSharp");
var _compressSharpDefault = parcelHelpers.interopDefault(_compressSharp);
var _compressTwoTone = require("./CompressTwoTone");
var _compressTwoToneDefault = parcelHelpers.interopDefault(_compressTwoTone);
var _computer = require("./Computer");
var _computerDefault = parcelHelpers.interopDefault(_computer);
var _computerOutlined = require("./ComputerOutlined");
var _computerOutlinedDefault = parcelHelpers.interopDefault(_computerOutlined);
var _computerRounded = require("./ComputerRounded");
var _computerRoundedDefault = parcelHelpers.interopDefault(_computerRounded);
var _computerSharp = require("./ComputerSharp");
var _computerSharpDefault = parcelHelpers.interopDefault(_computerSharp);
var _computerTwoTone = require("./ComputerTwoTone");
var _computerTwoToneDefault = parcelHelpers.interopDefault(_computerTwoTone);
var _confirmationNumber = require("./ConfirmationNumber");
var _confirmationNumberDefault = parcelHelpers.interopDefault(_confirmationNumber);
var _confirmationNumberOutlined = require("./ConfirmationNumberOutlined");
var _confirmationNumberOutlinedDefault = parcelHelpers.interopDefault(_confirmationNumberOutlined);
var _confirmationNumberRounded = require("./ConfirmationNumberRounded");
var _confirmationNumberRoundedDefault = parcelHelpers.interopDefault(_confirmationNumberRounded);
var _confirmationNumberSharp = require("./ConfirmationNumberSharp");
var _confirmationNumberSharpDefault = parcelHelpers.interopDefault(_confirmationNumberSharp);
var _confirmationNumberTwoTone = require("./ConfirmationNumberTwoTone");
var _confirmationNumberTwoToneDefault = parcelHelpers.interopDefault(_confirmationNumberTwoTone);
var _connectWithoutContact = require("./ConnectWithoutContact");
var _connectWithoutContactDefault = parcelHelpers.interopDefault(_connectWithoutContact);
var _connectWithoutContactOutlined = require("./ConnectWithoutContactOutlined");
var _connectWithoutContactOutlinedDefault = parcelHelpers.interopDefault(_connectWithoutContactOutlined);
var _connectWithoutContactRounded = require("./ConnectWithoutContactRounded");
var _connectWithoutContactRoundedDefault = parcelHelpers.interopDefault(_connectWithoutContactRounded);
var _connectWithoutContactSharp = require("./ConnectWithoutContactSharp");
var _connectWithoutContactSharpDefault = parcelHelpers.interopDefault(_connectWithoutContactSharp);
var _connectWithoutContactTwoTone = require("./ConnectWithoutContactTwoTone");
var _connectWithoutContactTwoToneDefault = parcelHelpers.interopDefault(_connectWithoutContactTwoTone);
var _connectedTv = require("./ConnectedTv");
var _connectedTvDefault = parcelHelpers.interopDefault(_connectedTv);
var _connectedTvOutlined = require("./ConnectedTvOutlined");
var _connectedTvOutlinedDefault = parcelHelpers.interopDefault(_connectedTvOutlined);
var _connectedTvRounded = require("./ConnectedTvRounded");
var _connectedTvRoundedDefault = parcelHelpers.interopDefault(_connectedTvRounded);
var _connectedTvSharp = require("./ConnectedTvSharp");
var _connectedTvSharpDefault = parcelHelpers.interopDefault(_connectedTvSharp);
var _connectedTvTwoTone = require("./ConnectedTvTwoTone");
var _connectedTvTwoToneDefault = parcelHelpers.interopDefault(_connectedTvTwoTone);
var _connectingAirports = require("./ConnectingAirports");
var _connectingAirportsDefault = parcelHelpers.interopDefault(_connectingAirports);
var _connectingAirportsOutlined = require("./ConnectingAirportsOutlined");
var _connectingAirportsOutlinedDefault = parcelHelpers.interopDefault(_connectingAirportsOutlined);
var _connectingAirportsRounded = require("./ConnectingAirportsRounded");
var _connectingAirportsRoundedDefault = parcelHelpers.interopDefault(_connectingAirportsRounded);
var _connectingAirportsSharp = require("./ConnectingAirportsSharp");
var _connectingAirportsSharpDefault = parcelHelpers.interopDefault(_connectingAirportsSharp);
var _connectingAirportsTwoTone = require("./ConnectingAirportsTwoTone");
var _connectingAirportsTwoToneDefault = parcelHelpers.interopDefault(_connectingAirportsTwoTone);
var _construction = require("./Construction");
var _constructionDefault = parcelHelpers.interopDefault(_construction);
var _constructionOutlined = require("./ConstructionOutlined");
var _constructionOutlinedDefault = parcelHelpers.interopDefault(_constructionOutlined);
var _constructionRounded = require("./ConstructionRounded");
var _constructionRoundedDefault = parcelHelpers.interopDefault(_constructionRounded);
var _constructionSharp = require("./ConstructionSharp");
var _constructionSharpDefault = parcelHelpers.interopDefault(_constructionSharp);
var _constructionTwoTone = require("./ConstructionTwoTone");
var _constructionTwoToneDefault = parcelHelpers.interopDefault(_constructionTwoTone);
var _contactEmergency = require("./ContactEmergency");
var _contactEmergencyDefault = parcelHelpers.interopDefault(_contactEmergency);
var _contactEmergencyOutlined = require("./ContactEmergencyOutlined");
var _contactEmergencyOutlinedDefault = parcelHelpers.interopDefault(_contactEmergencyOutlined);
var _contactEmergencyRounded = require("./ContactEmergencyRounded");
var _contactEmergencyRoundedDefault = parcelHelpers.interopDefault(_contactEmergencyRounded);
var _contactEmergencySharp = require("./ContactEmergencySharp");
var _contactEmergencySharpDefault = parcelHelpers.interopDefault(_contactEmergencySharp);
var _contactEmergencyTwoTone = require("./ContactEmergencyTwoTone");
var _contactEmergencyTwoToneDefault = parcelHelpers.interopDefault(_contactEmergencyTwoTone);
var _contactMail = require("./ContactMail");
var _contactMailDefault = parcelHelpers.interopDefault(_contactMail);
var _contactMailOutlined = require("./ContactMailOutlined");
var _contactMailOutlinedDefault = parcelHelpers.interopDefault(_contactMailOutlined);
var _contactMailRounded = require("./ContactMailRounded");
var _contactMailRoundedDefault = parcelHelpers.interopDefault(_contactMailRounded);
var _contactMailSharp = require("./ContactMailSharp");
var _contactMailSharpDefault = parcelHelpers.interopDefault(_contactMailSharp);
var _contactMailTwoTone = require("./ContactMailTwoTone");
var _contactMailTwoToneDefault = parcelHelpers.interopDefault(_contactMailTwoTone);
var _contactPage = require("./ContactPage");
var _contactPageDefault = parcelHelpers.interopDefault(_contactPage);
var _contactPageOutlined = require("./ContactPageOutlined");
var _contactPageOutlinedDefault = parcelHelpers.interopDefault(_contactPageOutlined);
var _contactPageRounded = require("./ContactPageRounded");
var _contactPageRoundedDefault = parcelHelpers.interopDefault(_contactPageRounded);
var _contactPageSharp = require("./ContactPageSharp");
var _contactPageSharpDefault = parcelHelpers.interopDefault(_contactPageSharp);
var _contactPageTwoTone = require("./ContactPageTwoTone");
var _contactPageTwoToneDefault = parcelHelpers.interopDefault(_contactPageTwoTone);
var _contactPhone = require("./ContactPhone");
var _contactPhoneDefault = parcelHelpers.interopDefault(_contactPhone);
var _contactPhoneOutlined = require("./ContactPhoneOutlined");
var _contactPhoneOutlinedDefault = parcelHelpers.interopDefault(_contactPhoneOutlined);
var _contactPhoneRounded = require("./ContactPhoneRounded");
var _contactPhoneRoundedDefault = parcelHelpers.interopDefault(_contactPhoneRounded);
var _contactPhoneSharp = require("./ContactPhoneSharp");
var _contactPhoneSharpDefault = parcelHelpers.interopDefault(_contactPhoneSharp);
var _contactPhoneTwoTone = require("./ContactPhoneTwoTone");
var _contactPhoneTwoToneDefault = parcelHelpers.interopDefault(_contactPhoneTwoTone);
var _contactSupport = require("./ContactSupport");
var _contactSupportDefault = parcelHelpers.interopDefault(_contactSupport);
var _contactSupportOutlined = require("./ContactSupportOutlined");
var _contactSupportOutlinedDefault = parcelHelpers.interopDefault(_contactSupportOutlined);
var _contactSupportRounded = require("./ContactSupportRounded");
var _contactSupportRoundedDefault = parcelHelpers.interopDefault(_contactSupportRounded);
var _contactSupportSharp = require("./ContactSupportSharp");
var _contactSupportSharpDefault = parcelHelpers.interopDefault(_contactSupportSharp);
var _contactSupportTwoTone = require("./ContactSupportTwoTone");
var _contactSupportTwoToneDefault = parcelHelpers.interopDefault(_contactSupportTwoTone);
var _contactless = require("./Contactless");
var _contactlessDefault = parcelHelpers.interopDefault(_contactless);
var _contactlessOutlined = require("./ContactlessOutlined");
var _contactlessOutlinedDefault = parcelHelpers.interopDefault(_contactlessOutlined);
var _contactlessRounded = require("./ContactlessRounded");
var _contactlessRoundedDefault = parcelHelpers.interopDefault(_contactlessRounded);
var _contactlessSharp = require("./ContactlessSharp");
var _contactlessSharpDefault = parcelHelpers.interopDefault(_contactlessSharp);
var _contactlessTwoTone = require("./ContactlessTwoTone");
var _contactlessTwoToneDefault = parcelHelpers.interopDefault(_contactlessTwoTone);
var _contacts = require("./Contacts");
var _contactsDefault = parcelHelpers.interopDefault(_contacts);
var _contactsOutlined = require("./ContactsOutlined");
var _contactsOutlinedDefault = parcelHelpers.interopDefault(_contactsOutlined);
var _contactsRounded = require("./ContactsRounded");
var _contactsRoundedDefault = parcelHelpers.interopDefault(_contactsRounded);
var _contactsSharp = require("./ContactsSharp");
var _contactsSharpDefault = parcelHelpers.interopDefault(_contactsSharp);
var _contactsTwoTone = require("./ContactsTwoTone");
var _contactsTwoToneDefault = parcelHelpers.interopDefault(_contactsTwoTone);
var _contentCopy = require("./ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _contentCopyOutlined = require("./ContentCopyOutlined");
var _contentCopyOutlinedDefault = parcelHelpers.interopDefault(_contentCopyOutlined);
var _contentCopyRounded = require("./ContentCopyRounded");
var _contentCopyRoundedDefault = parcelHelpers.interopDefault(_contentCopyRounded);
var _contentCopySharp = require("./ContentCopySharp");
var _contentCopySharpDefault = parcelHelpers.interopDefault(_contentCopySharp);
var _contentCopyTwoTone = require("./ContentCopyTwoTone");
var _contentCopyTwoToneDefault = parcelHelpers.interopDefault(_contentCopyTwoTone);
var _contentCut = require("./ContentCut");
var _contentCutDefault = parcelHelpers.interopDefault(_contentCut);
var _contentCutOutlined = require("./ContentCutOutlined");
var _contentCutOutlinedDefault = parcelHelpers.interopDefault(_contentCutOutlined);
var _contentCutRounded = require("./ContentCutRounded");
var _contentCutRoundedDefault = parcelHelpers.interopDefault(_contentCutRounded);
var _contentCutSharp = require("./ContentCutSharp");
var _contentCutSharpDefault = parcelHelpers.interopDefault(_contentCutSharp);
var _contentCutTwoTone = require("./ContentCutTwoTone");
var _contentCutTwoToneDefault = parcelHelpers.interopDefault(_contentCutTwoTone);
var _contentPaste = require("./ContentPaste");
var _contentPasteDefault = parcelHelpers.interopDefault(_contentPaste);
var _contentPasteGo = require("./ContentPasteGo");
var _contentPasteGoDefault = parcelHelpers.interopDefault(_contentPasteGo);
var _contentPasteGoOutlined = require("./ContentPasteGoOutlined");
var _contentPasteGoOutlinedDefault = parcelHelpers.interopDefault(_contentPasteGoOutlined);
var _contentPasteGoRounded = require("./ContentPasteGoRounded");
var _contentPasteGoRoundedDefault = parcelHelpers.interopDefault(_contentPasteGoRounded);
var _contentPasteGoSharp = require("./ContentPasteGoSharp");
var _contentPasteGoSharpDefault = parcelHelpers.interopDefault(_contentPasteGoSharp);
var _contentPasteGoTwoTone = require("./ContentPasteGoTwoTone");
var _contentPasteGoTwoToneDefault = parcelHelpers.interopDefault(_contentPasteGoTwoTone);
var _contentPasteOff = require("./ContentPasteOff");
var _contentPasteOffDefault = parcelHelpers.interopDefault(_contentPasteOff);
var _contentPasteOffOutlined = require("./ContentPasteOffOutlined");
var _contentPasteOffOutlinedDefault = parcelHelpers.interopDefault(_contentPasteOffOutlined);
var _contentPasteOffRounded = require("./ContentPasteOffRounded");
var _contentPasteOffRoundedDefault = parcelHelpers.interopDefault(_contentPasteOffRounded);
var _contentPasteOffSharp = require("./ContentPasteOffSharp");
var _contentPasteOffSharpDefault = parcelHelpers.interopDefault(_contentPasteOffSharp);
var _contentPasteOffTwoTone = require("./ContentPasteOffTwoTone");
var _contentPasteOffTwoToneDefault = parcelHelpers.interopDefault(_contentPasteOffTwoTone);
var _contentPasteOutlined = require("./ContentPasteOutlined");
var _contentPasteOutlinedDefault = parcelHelpers.interopDefault(_contentPasteOutlined);
var _contentPasteRounded = require("./ContentPasteRounded");
var _contentPasteRoundedDefault = parcelHelpers.interopDefault(_contentPasteRounded);
var _contentPasteSearch = require("./ContentPasteSearch");
var _contentPasteSearchDefault = parcelHelpers.interopDefault(_contentPasteSearch);
var _contentPasteSearchOutlined = require("./ContentPasteSearchOutlined");
var _contentPasteSearchOutlinedDefault = parcelHelpers.interopDefault(_contentPasteSearchOutlined);
var _contentPasteSearchRounded = require("./ContentPasteSearchRounded");
var _contentPasteSearchRoundedDefault = parcelHelpers.interopDefault(_contentPasteSearchRounded);
var _contentPasteSearchSharp = require("./ContentPasteSearchSharp");
var _contentPasteSearchSharpDefault = parcelHelpers.interopDefault(_contentPasteSearchSharp);
var _contentPasteSearchTwoTone = require("./ContentPasteSearchTwoTone");
var _contentPasteSearchTwoToneDefault = parcelHelpers.interopDefault(_contentPasteSearchTwoTone);
var _contentPasteSharp = require("./ContentPasteSharp");
var _contentPasteSharpDefault = parcelHelpers.interopDefault(_contentPasteSharp);
var _contentPasteTwoTone = require("./ContentPasteTwoTone");
var _contentPasteTwoToneDefault = parcelHelpers.interopDefault(_contentPasteTwoTone);
var _contrast = require("./Contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _contrastOutlined = require("./ContrastOutlined");
var _contrastOutlinedDefault = parcelHelpers.interopDefault(_contrastOutlined);
var _contrastRounded = require("./ContrastRounded");
var _contrastRoundedDefault = parcelHelpers.interopDefault(_contrastRounded);
var _contrastSharp = require("./ContrastSharp");
var _contrastSharpDefault = parcelHelpers.interopDefault(_contrastSharp);
var _contrastTwoTone = require("./ContrastTwoTone");
var _contrastTwoToneDefault = parcelHelpers.interopDefault(_contrastTwoTone);
var _controlCamera = require("./ControlCamera");
var _controlCameraDefault = parcelHelpers.interopDefault(_controlCamera);
var _controlCameraOutlined = require("./ControlCameraOutlined");
var _controlCameraOutlinedDefault = parcelHelpers.interopDefault(_controlCameraOutlined);
var _controlCameraRounded = require("./ControlCameraRounded");
var _controlCameraRoundedDefault = parcelHelpers.interopDefault(_controlCameraRounded);
var _controlCameraSharp = require("./ControlCameraSharp");
var _controlCameraSharpDefault = parcelHelpers.interopDefault(_controlCameraSharp);
var _controlCameraTwoTone = require("./ControlCameraTwoTone");
var _controlCameraTwoToneDefault = parcelHelpers.interopDefault(_controlCameraTwoTone);
var _controlPoint = require("./ControlPoint");
var _controlPointDefault = parcelHelpers.interopDefault(_controlPoint);
var _controlPointDuplicate = require("./ControlPointDuplicate");
var _controlPointDuplicateDefault = parcelHelpers.interopDefault(_controlPointDuplicate);
var _controlPointDuplicateOutlined = require("./ControlPointDuplicateOutlined");
var _controlPointDuplicateOutlinedDefault = parcelHelpers.interopDefault(_controlPointDuplicateOutlined);
var _controlPointDuplicateRounded = require("./ControlPointDuplicateRounded");
var _controlPointDuplicateRoundedDefault = parcelHelpers.interopDefault(_controlPointDuplicateRounded);
var _controlPointDuplicateSharp = require("./ControlPointDuplicateSharp");
var _controlPointDuplicateSharpDefault = parcelHelpers.interopDefault(_controlPointDuplicateSharp);
var _controlPointDuplicateTwoTone = require("./ControlPointDuplicateTwoTone");
var _controlPointDuplicateTwoToneDefault = parcelHelpers.interopDefault(_controlPointDuplicateTwoTone);
var _controlPointOutlined = require("./ControlPointOutlined");
var _controlPointOutlinedDefault = parcelHelpers.interopDefault(_controlPointOutlined);
var _controlPointRounded = require("./ControlPointRounded");
var _controlPointRoundedDefault = parcelHelpers.interopDefault(_controlPointRounded);
var _controlPointSharp = require("./ControlPointSharp");
var _controlPointSharpDefault = parcelHelpers.interopDefault(_controlPointSharp);
var _controlPointTwoTone = require("./ControlPointTwoTone");
var _controlPointTwoToneDefault = parcelHelpers.interopDefault(_controlPointTwoTone);
var _cookie = require("./Cookie");
var _cookieDefault = parcelHelpers.interopDefault(_cookie);
var _cookieOutlined = require("./CookieOutlined");
var _cookieOutlinedDefault = parcelHelpers.interopDefault(_cookieOutlined);
var _cookieRounded = require("./CookieRounded");
var _cookieRoundedDefault = parcelHelpers.interopDefault(_cookieRounded);
var _cookieSharp = require("./CookieSharp");
var _cookieSharpDefault = parcelHelpers.interopDefault(_cookieSharp);
var _cookieTwoTone = require("./CookieTwoTone");
var _cookieTwoToneDefault = parcelHelpers.interopDefault(_cookieTwoTone);
var _copyAll = require("./CopyAll");
var _copyAllDefault = parcelHelpers.interopDefault(_copyAll);
var _copyAllOutlined = require("./CopyAllOutlined");
var _copyAllOutlinedDefault = parcelHelpers.interopDefault(_copyAllOutlined);
var _copyAllRounded = require("./CopyAllRounded");
var _copyAllRoundedDefault = parcelHelpers.interopDefault(_copyAllRounded);
var _copyAllSharp = require("./CopyAllSharp");
var _copyAllSharpDefault = parcelHelpers.interopDefault(_copyAllSharp);
var _copyAllTwoTone = require("./CopyAllTwoTone");
var _copyAllTwoToneDefault = parcelHelpers.interopDefault(_copyAllTwoTone);
var _copyright = require("./Copyright");
var _copyrightDefault = parcelHelpers.interopDefault(_copyright);
var _copyrightOutlined = require("./CopyrightOutlined");
var _copyrightOutlinedDefault = parcelHelpers.interopDefault(_copyrightOutlined);
var _copyrightRounded = require("./CopyrightRounded");
var _copyrightRoundedDefault = parcelHelpers.interopDefault(_copyrightRounded);
var _copyrightSharp = require("./CopyrightSharp");
var _copyrightSharpDefault = parcelHelpers.interopDefault(_copyrightSharp);
var _copyrightTwoTone = require("./CopyrightTwoTone");
var _copyrightTwoToneDefault = parcelHelpers.interopDefault(_copyrightTwoTone);
var _coronavirus = require("./Coronavirus");
var _coronavirusDefault = parcelHelpers.interopDefault(_coronavirus);
var _coronavirusOutlined = require("./CoronavirusOutlined");
var _coronavirusOutlinedDefault = parcelHelpers.interopDefault(_coronavirusOutlined);
var _coronavirusRounded = require("./CoronavirusRounded");
var _coronavirusRoundedDefault = parcelHelpers.interopDefault(_coronavirusRounded);
var _coronavirusSharp = require("./CoronavirusSharp");
var _coronavirusSharpDefault = parcelHelpers.interopDefault(_coronavirusSharp);
var _coronavirusTwoTone = require("./CoronavirusTwoTone");
var _coronavirusTwoToneDefault = parcelHelpers.interopDefault(_coronavirusTwoTone);
var _corporateFare = require("./CorporateFare");
var _corporateFareDefault = parcelHelpers.interopDefault(_corporateFare);
var _corporateFareOutlined = require("./CorporateFareOutlined");
var _corporateFareOutlinedDefault = parcelHelpers.interopDefault(_corporateFareOutlined);
var _corporateFareRounded = require("./CorporateFareRounded");
var _corporateFareRoundedDefault = parcelHelpers.interopDefault(_corporateFareRounded);
var _corporateFareSharp = require("./CorporateFareSharp");
var _corporateFareSharpDefault = parcelHelpers.interopDefault(_corporateFareSharp);
var _corporateFareTwoTone = require("./CorporateFareTwoTone");
var _corporateFareTwoToneDefault = parcelHelpers.interopDefault(_corporateFareTwoTone);
var _cottage = require("./Cottage");
var _cottageDefault = parcelHelpers.interopDefault(_cottage);
var _cottageOutlined = require("./CottageOutlined");
var _cottageOutlinedDefault = parcelHelpers.interopDefault(_cottageOutlined);
var _cottageRounded = require("./CottageRounded");
var _cottageRoundedDefault = parcelHelpers.interopDefault(_cottageRounded);
var _cottageSharp = require("./CottageSharp");
var _cottageSharpDefault = parcelHelpers.interopDefault(_cottageSharp);
var _cottageTwoTone = require("./CottageTwoTone");
var _cottageTwoToneDefault = parcelHelpers.interopDefault(_cottageTwoTone);
var _countertops = require("./Countertops");
var _countertopsDefault = parcelHelpers.interopDefault(_countertops);
var _countertopsOutlined = require("./CountertopsOutlined");
var _countertopsOutlinedDefault = parcelHelpers.interopDefault(_countertopsOutlined);
var _countertopsRounded = require("./CountertopsRounded");
var _countertopsRoundedDefault = parcelHelpers.interopDefault(_countertopsRounded);
var _countertopsSharp = require("./CountertopsSharp");
var _countertopsSharpDefault = parcelHelpers.interopDefault(_countertopsSharp);
var _countertopsTwoTone = require("./CountertopsTwoTone");
var _countertopsTwoToneDefault = parcelHelpers.interopDefault(_countertopsTwoTone);
var _create = require("./Create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _createNewFolder = require("./CreateNewFolder");
var _createNewFolderDefault = parcelHelpers.interopDefault(_createNewFolder);
var _createNewFolderOutlined = require("./CreateNewFolderOutlined");
var _createNewFolderOutlinedDefault = parcelHelpers.interopDefault(_createNewFolderOutlined);
var _createNewFolderRounded = require("./CreateNewFolderRounded");
var _createNewFolderRoundedDefault = parcelHelpers.interopDefault(_createNewFolderRounded);
var _createNewFolderSharp = require("./CreateNewFolderSharp");
var _createNewFolderSharpDefault = parcelHelpers.interopDefault(_createNewFolderSharp);
var _createNewFolderTwoTone = require("./CreateNewFolderTwoTone");
var _createNewFolderTwoToneDefault = parcelHelpers.interopDefault(_createNewFolderTwoTone);
var _createOutlined = require("./CreateOutlined");
var _createOutlinedDefault = parcelHelpers.interopDefault(_createOutlined);
var _createRounded = require("./CreateRounded");
var _createRoundedDefault = parcelHelpers.interopDefault(_createRounded);
var _createSharp = require("./CreateSharp");
var _createSharpDefault = parcelHelpers.interopDefault(_createSharp);
var _createTwoTone = require("./CreateTwoTone");
var _createTwoToneDefault = parcelHelpers.interopDefault(_createTwoTone);
var _creditCard = require("./CreditCard");
var _creditCardDefault = parcelHelpers.interopDefault(_creditCard);
var _creditCardOff = require("./CreditCardOff");
var _creditCardOffDefault = parcelHelpers.interopDefault(_creditCardOff);
var _creditCardOffOutlined = require("./CreditCardOffOutlined");
var _creditCardOffOutlinedDefault = parcelHelpers.interopDefault(_creditCardOffOutlined);
var _creditCardOffRounded = require("./CreditCardOffRounded");
var _creditCardOffRoundedDefault = parcelHelpers.interopDefault(_creditCardOffRounded);
var _creditCardOffSharp = require("./CreditCardOffSharp");
var _creditCardOffSharpDefault = parcelHelpers.interopDefault(_creditCardOffSharp);
var _creditCardOffTwoTone = require("./CreditCardOffTwoTone");
var _creditCardOffTwoToneDefault = parcelHelpers.interopDefault(_creditCardOffTwoTone);
var _creditCardOutlined = require("./CreditCardOutlined");
var _creditCardOutlinedDefault = parcelHelpers.interopDefault(_creditCardOutlined);
var _creditCardRounded = require("./CreditCardRounded");
var _creditCardRoundedDefault = parcelHelpers.interopDefault(_creditCardRounded);
var _creditCardSharp = require("./CreditCardSharp");
var _creditCardSharpDefault = parcelHelpers.interopDefault(_creditCardSharp);
var _creditCardTwoTone = require("./CreditCardTwoTone");
var _creditCardTwoToneDefault = parcelHelpers.interopDefault(_creditCardTwoTone);
var _creditScore = require("./CreditScore");
var _creditScoreDefault = parcelHelpers.interopDefault(_creditScore);
var _creditScoreOutlined = require("./CreditScoreOutlined");
var _creditScoreOutlinedDefault = parcelHelpers.interopDefault(_creditScoreOutlined);
var _creditScoreRounded = require("./CreditScoreRounded");
var _creditScoreRoundedDefault = parcelHelpers.interopDefault(_creditScoreRounded);
var _creditScoreSharp = require("./CreditScoreSharp");
var _creditScoreSharpDefault = parcelHelpers.interopDefault(_creditScoreSharp);
var _creditScoreTwoTone = require("./CreditScoreTwoTone");
var _creditScoreTwoToneDefault = parcelHelpers.interopDefault(_creditScoreTwoTone);
var _crib = require("./Crib");
var _cribDefault = parcelHelpers.interopDefault(_crib);
var _cribOutlined = require("./CribOutlined");
var _cribOutlinedDefault = parcelHelpers.interopDefault(_cribOutlined);
var _cribRounded = require("./CribRounded");
var _cribRoundedDefault = parcelHelpers.interopDefault(_cribRounded);
var _cribSharp = require("./CribSharp");
var _cribSharpDefault = parcelHelpers.interopDefault(_cribSharp);
var _cribTwoTone = require("./CribTwoTone");
var _cribTwoToneDefault = parcelHelpers.interopDefault(_cribTwoTone);
var _crisisAlert = require("./CrisisAlert");
var _crisisAlertDefault = parcelHelpers.interopDefault(_crisisAlert);
var _crisisAlertOutlined = require("./CrisisAlertOutlined");
var _crisisAlertOutlinedDefault = parcelHelpers.interopDefault(_crisisAlertOutlined);
var _crisisAlertRounded = require("./CrisisAlertRounded");
var _crisisAlertRoundedDefault = parcelHelpers.interopDefault(_crisisAlertRounded);
var _crisisAlertSharp = require("./CrisisAlertSharp");
var _crisisAlertSharpDefault = parcelHelpers.interopDefault(_crisisAlertSharp);
var _crisisAlertTwoTone = require("./CrisisAlertTwoTone");
var _crisisAlertTwoToneDefault = parcelHelpers.interopDefault(_crisisAlertTwoTone);
var _crop = require("./Crop");
var _cropDefault = parcelHelpers.interopDefault(_crop);
var _crop169 = require("./Crop169");
var _crop169Default = parcelHelpers.interopDefault(_crop169);
var _crop169Outlined = require("./Crop169Outlined");
var _crop169OutlinedDefault = parcelHelpers.interopDefault(_crop169Outlined);
var _crop169Rounded = require("./Crop169Rounded");
var _crop169RoundedDefault = parcelHelpers.interopDefault(_crop169Rounded);
var _crop169Sharp = require("./Crop169Sharp");
var _crop169SharpDefault = parcelHelpers.interopDefault(_crop169Sharp);
var _crop169TwoTone = require("./Crop169TwoTone");
var _crop169TwoToneDefault = parcelHelpers.interopDefault(_crop169TwoTone);
var _crop32 = require("./Crop32");
var _crop32Default = parcelHelpers.interopDefault(_crop32);
var _crop32Outlined = require("./Crop32Outlined");
var _crop32OutlinedDefault = parcelHelpers.interopDefault(_crop32Outlined);
var _crop32Rounded = require("./Crop32Rounded");
var _crop32RoundedDefault = parcelHelpers.interopDefault(_crop32Rounded);
var _crop32Sharp = require("./Crop32Sharp");
var _crop32SharpDefault = parcelHelpers.interopDefault(_crop32Sharp);
var _crop32TwoTone = require("./Crop32TwoTone");
var _crop32TwoToneDefault = parcelHelpers.interopDefault(_crop32TwoTone);
var _crop54 = require("./Crop54");
var _crop54Default = parcelHelpers.interopDefault(_crop54);
var _crop54Outlined = require("./Crop54Outlined");
var _crop54OutlinedDefault = parcelHelpers.interopDefault(_crop54Outlined);
var _crop54Rounded = require("./Crop54Rounded");
var _crop54RoundedDefault = parcelHelpers.interopDefault(_crop54Rounded);
var _crop54Sharp = require("./Crop54Sharp");
var _crop54SharpDefault = parcelHelpers.interopDefault(_crop54Sharp);
var _crop54TwoTone = require("./Crop54TwoTone");
var _crop54TwoToneDefault = parcelHelpers.interopDefault(_crop54TwoTone);
var _crop75 = require("./Crop75");
var _crop75Default = parcelHelpers.interopDefault(_crop75);
var _crop75Outlined = require("./Crop75Outlined");
var _crop75OutlinedDefault = parcelHelpers.interopDefault(_crop75Outlined);
var _crop75Rounded = require("./Crop75Rounded");
var _crop75RoundedDefault = parcelHelpers.interopDefault(_crop75Rounded);
var _crop75Sharp = require("./Crop75Sharp");
var _crop75SharpDefault = parcelHelpers.interopDefault(_crop75Sharp);
var _crop75TwoTone = require("./Crop75TwoTone");
var _crop75TwoToneDefault = parcelHelpers.interopDefault(_crop75TwoTone);
var _cropDin = require("./CropDin");
var _cropDinDefault = parcelHelpers.interopDefault(_cropDin);
var _cropDinOutlined = require("./CropDinOutlined");
var _cropDinOutlinedDefault = parcelHelpers.interopDefault(_cropDinOutlined);
var _cropDinRounded = require("./CropDinRounded");
var _cropDinRoundedDefault = parcelHelpers.interopDefault(_cropDinRounded);
var _cropDinSharp = require("./CropDinSharp");
var _cropDinSharpDefault = parcelHelpers.interopDefault(_cropDinSharp);
var _cropDinTwoTone = require("./CropDinTwoTone");
var _cropDinTwoToneDefault = parcelHelpers.interopDefault(_cropDinTwoTone);
var _cropFree = require("./CropFree");
var _cropFreeDefault = parcelHelpers.interopDefault(_cropFree);
var _cropFreeOutlined = require("./CropFreeOutlined");
var _cropFreeOutlinedDefault = parcelHelpers.interopDefault(_cropFreeOutlined);
var _cropFreeRounded = require("./CropFreeRounded");
var _cropFreeRoundedDefault = parcelHelpers.interopDefault(_cropFreeRounded);
var _cropFreeSharp = require("./CropFreeSharp");
var _cropFreeSharpDefault = parcelHelpers.interopDefault(_cropFreeSharp);
var _cropFreeTwoTone = require("./CropFreeTwoTone");
var _cropFreeTwoToneDefault = parcelHelpers.interopDefault(_cropFreeTwoTone);
var _cropLandscape = require("./CropLandscape");
var _cropLandscapeDefault = parcelHelpers.interopDefault(_cropLandscape);
var _cropLandscapeOutlined = require("./CropLandscapeOutlined");
var _cropLandscapeOutlinedDefault = parcelHelpers.interopDefault(_cropLandscapeOutlined);
var _cropLandscapeRounded = require("./CropLandscapeRounded");
var _cropLandscapeRoundedDefault = parcelHelpers.interopDefault(_cropLandscapeRounded);
var _cropLandscapeSharp = require("./CropLandscapeSharp");
var _cropLandscapeSharpDefault = parcelHelpers.interopDefault(_cropLandscapeSharp);
var _cropLandscapeTwoTone = require("./CropLandscapeTwoTone");
var _cropLandscapeTwoToneDefault = parcelHelpers.interopDefault(_cropLandscapeTwoTone);
var _cropOriginal = require("./CropOriginal");
var _cropOriginalDefault = parcelHelpers.interopDefault(_cropOriginal);
var _cropOriginalOutlined = require("./CropOriginalOutlined");
var _cropOriginalOutlinedDefault = parcelHelpers.interopDefault(_cropOriginalOutlined);
var _cropOriginalRounded = require("./CropOriginalRounded");
var _cropOriginalRoundedDefault = parcelHelpers.interopDefault(_cropOriginalRounded);
var _cropOriginalSharp = require("./CropOriginalSharp");
var _cropOriginalSharpDefault = parcelHelpers.interopDefault(_cropOriginalSharp);
var _cropOriginalTwoTone = require("./CropOriginalTwoTone");
var _cropOriginalTwoToneDefault = parcelHelpers.interopDefault(_cropOriginalTwoTone);
var _cropOutlined = require("./CropOutlined");
var _cropOutlinedDefault = parcelHelpers.interopDefault(_cropOutlined);
var _cropPortrait = require("./CropPortrait");
var _cropPortraitDefault = parcelHelpers.interopDefault(_cropPortrait);
var _cropPortraitOutlined = require("./CropPortraitOutlined");
var _cropPortraitOutlinedDefault = parcelHelpers.interopDefault(_cropPortraitOutlined);
var _cropPortraitRounded = require("./CropPortraitRounded");
var _cropPortraitRoundedDefault = parcelHelpers.interopDefault(_cropPortraitRounded);
var _cropPortraitSharp = require("./CropPortraitSharp");
var _cropPortraitSharpDefault = parcelHelpers.interopDefault(_cropPortraitSharp);
var _cropPortraitTwoTone = require("./CropPortraitTwoTone");
var _cropPortraitTwoToneDefault = parcelHelpers.interopDefault(_cropPortraitTwoTone);
var _cropRotate = require("./CropRotate");
var _cropRotateDefault = parcelHelpers.interopDefault(_cropRotate);
var _cropRotateOutlined = require("./CropRotateOutlined");
var _cropRotateOutlinedDefault = parcelHelpers.interopDefault(_cropRotateOutlined);
var _cropRotateRounded = require("./CropRotateRounded");
var _cropRotateRoundedDefault = parcelHelpers.interopDefault(_cropRotateRounded);
var _cropRotateSharp = require("./CropRotateSharp");
var _cropRotateSharpDefault = parcelHelpers.interopDefault(_cropRotateSharp);
var _cropRotateTwoTone = require("./CropRotateTwoTone");
var _cropRotateTwoToneDefault = parcelHelpers.interopDefault(_cropRotateTwoTone);
var _cropRounded = require("./CropRounded");
var _cropRoundedDefault = parcelHelpers.interopDefault(_cropRounded);
var _cropSharp = require("./CropSharp");
var _cropSharpDefault = parcelHelpers.interopDefault(_cropSharp);
var _cropSquare = require("./CropSquare");
var _cropSquareDefault = parcelHelpers.interopDefault(_cropSquare);
var _cropSquareOutlined = require("./CropSquareOutlined");
var _cropSquareOutlinedDefault = parcelHelpers.interopDefault(_cropSquareOutlined);
var _cropSquareRounded = require("./CropSquareRounded");
var _cropSquareRoundedDefault = parcelHelpers.interopDefault(_cropSquareRounded);
var _cropSquareSharp = require("./CropSquareSharp");
var _cropSquareSharpDefault = parcelHelpers.interopDefault(_cropSquareSharp);
var _cropSquareTwoTone = require("./CropSquareTwoTone");
var _cropSquareTwoToneDefault = parcelHelpers.interopDefault(_cropSquareTwoTone);
var _cropTwoTone = require("./CropTwoTone");
var _cropTwoToneDefault = parcelHelpers.interopDefault(_cropTwoTone);
var _css = require("./Css");
var _cssDefault = parcelHelpers.interopDefault(_css);
var _cssOutlined = require("./CssOutlined");
var _cssOutlinedDefault = parcelHelpers.interopDefault(_cssOutlined);
var _cssRounded = require("./CssRounded");
var _cssRoundedDefault = parcelHelpers.interopDefault(_cssRounded);
var _cssSharp = require("./CssSharp");
var _cssSharpDefault = parcelHelpers.interopDefault(_cssSharp);
var _cssTwoTone = require("./CssTwoTone");
var _cssTwoToneDefault = parcelHelpers.interopDefault(_cssTwoTone);
var _currencyBitcoin = require("./CurrencyBitcoin");
var _currencyBitcoinDefault = parcelHelpers.interopDefault(_currencyBitcoin);
var _currencyBitcoinOutlined = require("./CurrencyBitcoinOutlined");
var _currencyBitcoinOutlinedDefault = parcelHelpers.interopDefault(_currencyBitcoinOutlined);
var _currencyBitcoinRounded = require("./CurrencyBitcoinRounded");
var _currencyBitcoinRoundedDefault = parcelHelpers.interopDefault(_currencyBitcoinRounded);
var _currencyBitcoinSharp = require("./CurrencyBitcoinSharp");
var _currencyBitcoinSharpDefault = parcelHelpers.interopDefault(_currencyBitcoinSharp);
var _currencyBitcoinTwoTone = require("./CurrencyBitcoinTwoTone");
var _currencyBitcoinTwoToneDefault = parcelHelpers.interopDefault(_currencyBitcoinTwoTone);
var _currencyExchange = require("./CurrencyExchange");
var _currencyExchangeDefault = parcelHelpers.interopDefault(_currencyExchange);
var _currencyExchangeOutlined = require("./CurrencyExchangeOutlined");
var _currencyExchangeOutlinedDefault = parcelHelpers.interopDefault(_currencyExchangeOutlined);
var _currencyExchangeRounded = require("./CurrencyExchangeRounded");
var _currencyExchangeRoundedDefault = parcelHelpers.interopDefault(_currencyExchangeRounded);
var _currencyExchangeSharp = require("./CurrencyExchangeSharp");
var _currencyExchangeSharpDefault = parcelHelpers.interopDefault(_currencyExchangeSharp);
var _currencyExchangeTwoTone = require("./CurrencyExchangeTwoTone");
var _currencyExchangeTwoToneDefault = parcelHelpers.interopDefault(_currencyExchangeTwoTone);
var _currencyFranc = require("./CurrencyFranc");
var _currencyFrancDefault = parcelHelpers.interopDefault(_currencyFranc);
var _currencyFrancOutlined = require("./CurrencyFrancOutlined");
var _currencyFrancOutlinedDefault = parcelHelpers.interopDefault(_currencyFrancOutlined);
var _currencyFrancRounded = require("./CurrencyFrancRounded");
var _currencyFrancRoundedDefault = parcelHelpers.interopDefault(_currencyFrancRounded);
var _currencyFrancSharp = require("./CurrencyFrancSharp");
var _currencyFrancSharpDefault = parcelHelpers.interopDefault(_currencyFrancSharp);
var _currencyFrancTwoTone = require("./CurrencyFrancTwoTone");
var _currencyFrancTwoToneDefault = parcelHelpers.interopDefault(_currencyFrancTwoTone);
var _currencyLira = require("./CurrencyLira");
var _currencyLiraDefault = parcelHelpers.interopDefault(_currencyLira);
var _currencyLiraOutlined = require("./CurrencyLiraOutlined");
var _currencyLiraOutlinedDefault = parcelHelpers.interopDefault(_currencyLiraOutlined);
var _currencyLiraRounded = require("./CurrencyLiraRounded");
var _currencyLiraRoundedDefault = parcelHelpers.interopDefault(_currencyLiraRounded);
var _currencyLiraSharp = require("./CurrencyLiraSharp");
var _currencyLiraSharpDefault = parcelHelpers.interopDefault(_currencyLiraSharp);
var _currencyLiraTwoTone = require("./CurrencyLiraTwoTone");
var _currencyLiraTwoToneDefault = parcelHelpers.interopDefault(_currencyLiraTwoTone);
var _currencyPound = require("./CurrencyPound");
var _currencyPoundDefault = parcelHelpers.interopDefault(_currencyPound);
var _currencyPoundOutlined = require("./CurrencyPoundOutlined");
var _currencyPoundOutlinedDefault = parcelHelpers.interopDefault(_currencyPoundOutlined);
var _currencyPoundRounded = require("./CurrencyPoundRounded");
var _currencyPoundRoundedDefault = parcelHelpers.interopDefault(_currencyPoundRounded);
var _currencyPoundSharp = require("./CurrencyPoundSharp");
var _currencyPoundSharpDefault = parcelHelpers.interopDefault(_currencyPoundSharp);
var _currencyPoundTwoTone = require("./CurrencyPoundTwoTone");
var _currencyPoundTwoToneDefault = parcelHelpers.interopDefault(_currencyPoundTwoTone);
var _currencyRuble = require("./CurrencyRuble");
var _currencyRubleDefault = parcelHelpers.interopDefault(_currencyRuble);
var _currencyRubleOutlined = require("./CurrencyRubleOutlined");
var _currencyRubleOutlinedDefault = parcelHelpers.interopDefault(_currencyRubleOutlined);
var _currencyRubleRounded = require("./CurrencyRubleRounded");
var _currencyRubleRoundedDefault = parcelHelpers.interopDefault(_currencyRubleRounded);
var _currencyRubleSharp = require("./CurrencyRubleSharp");
var _currencyRubleSharpDefault = parcelHelpers.interopDefault(_currencyRubleSharp);
var _currencyRubleTwoTone = require("./CurrencyRubleTwoTone");
var _currencyRubleTwoToneDefault = parcelHelpers.interopDefault(_currencyRubleTwoTone);
var _currencyRupee = require("./CurrencyRupee");
var _currencyRupeeDefault = parcelHelpers.interopDefault(_currencyRupee);
var _currencyRupeeOutlined = require("./CurrencyRupeeOutlined");
var _currencyRupeeOutlinedDefault = parcelHelpers.interopDefault(_currencyRupeeOutlined);
var _currencyRupeeRounded = require("./CurrencyRupeeRounded");
var _currencyRupeeRoundedDefault = parcelHelpers.interopDefault(_currencyRupeeRounded);
var _currencyRupeeSharp = require("./CurrencyRupeeSharp");
var _currencyRupeeSharpDefault = parcelHelpers.interopDefault(_currencyRupeeSharp);
var _currencyRupeeTwoTone = require("./CurrencyRupeeTwoTone");
var _currencyRupeeTwoToneDefault = parcelHelpers.interopDefault(_currencyRupeeTwoTone);
var _currencyYen = require("./CurrencyYen");
var _currencyYenDefault = parcelHelpers.interopDefault(_currencyYen);
var _currencyYenOutlined = require("./CurrencyYenOutlined");
var _currencyYenOutlinedDefault = parcelHelpers.interopDefault(_currencyYenOutlined);
var _currencyYenRounded = require("./CurrencyYenRounded");
var _currencyYenRoundedDefault = parcelHelpers.interopDefault(_currencyYenRounded);
var _currencyYenSharp = require("./CurrencyYenSharp");
var _currencyYenSharpDefault = parcelHelpers.interopDefault(_currencyYenSharp);
var _currencyYenTwoTone = require("./CurrencyYenTwoTone");
var _currencyYenTwoToneDefault = parcelHelpers.interopDefault(_currencyYenTwoTone);
var _currencyYuan = require("./CurrencyYuan");
var _currencyYuanDefault = parcelHelpers.interopDefault(_currencyYuan);
var _currencyYuanOutlined = require("./CurrencyYuanOutlined");
var _currencyYuanOutlinedDefault = parcelHelpers.interopDefault(_currencyYuanOutlined);
var _currencyYuanRounded = require("./CurrencyYuanRounded");
var _currencyYuanRoundedDefault = parcelHelpers.interopDefault(_currencyYuanRounded);
var _currencyYuanSharp = require("./CurrencyYuanSharp");
var _currencyYuanSharpDefault = parcelHelpers.interopDefault(_currencyYuanSharp);
var _currencyYuanTwoTone = require("./CurrencyYuanTwoTone");
var _currencyYuanTwoToneDefault = parcelHelpers.interopDefault(_currencyYuanTwoTone);
var _curtains = require("./Curtains");
var _curtainsDefault = parcelHelpers.interopDefault(_curtains);
var _curtainsClosed = require("./CurtainsClosed");
var _curtainsClosedDefault = parcelHelpers.interopDefault(_curtainsClosed);
var _curtainsClosedOutlined = require("./CurtainsClosedOutlined");
var _curtainsClosedOutlinedDefault = parcelHelpers.interopDefault(_curtainsClosedOutlined);
var _curtainsClosedRounded = require("./CurtainsClosedRounded");
var _curtainsClosedRoundedDefault = parcelHelpers.interopDefault(_curtainsClosedRounded);
var _curtainsClosedSharp = require("./CurtainsClosedSharp");
var _curtainsClosedSharpDefault = parcelHelpers.interopDefault(_curtainsClosedSharp);
var _curtainsClosedTwoTone = require("./CurtainsClosedTwoTone");
var _curtainsClosedTwoToneDefault = parcelHelpers.interopDefault(_curtainsClosedTwoTone);
var _curtainsOutlined = require("./CurtainsOutlined");
var _curtainsOutlinedDefault = parcelHelpers.interopDefault(_curtainsOutlined);
var _curtainsRounded = require("./CurtainsRounded");
var _curtainsRoundedDefault = parcelHelpers.interopDefault(_curtainsRounded);
var _curtainsSharp = require("./CurtainsSharp");
var _curtainsSharpDefault = parcelHelpers.interopDefault(_curtainsSharp);
var _curtainsTwoTone = require("./CurtainsTwoTone");
var _curtainsTwoToneDefault = parcelHelpers.interopDefault(_curtainsTwoTone);
var _cyclone = require("./Cyclone");
var _cycloneDefault = parcelHelpers.interopDefault(_cyclone);
var _cycloneOutlined = require("./CycloneOutlined");
var _cycloneOutlinedDefault = parcelHelpers.interopDefault(_cycloneOutlined);
var _cycloneRounded = require("./CycloneRounded");
var _cycloneRoundedDefault = parcelHelpers.interopDefault(_cycloneRounded);
var _cycloneSharp = require("./CycloneSharp");
var _cycloneSharpDefault = parcelHelpers.interopDefault(_cycloneSharp);
var _cycloneTwoTone = require("./CycloneTwoTone");
var _cycloneTwoToneDefault = parcelHelpers.interopDefault(_cycloneTwoTone);
var _dangerous = require("./Dangerous");
var _dangerousDefault = parcelHelpers.interopDefault(_dangerous);
var _dangerousOutlined = require("./DangerousOutlined");
var _dangerousOutlinedDefault = parcelHelpers.interopDefault(_dangerousOutlined);
var _dangerousRounded = require("./DangerousRounded");
var _dangerousRoundedDefault = parcelHelpers.interopDefault(_dangerousRounded);
var _dangerousSharp = require("./DangerousSharp");
var _dangerousSharpDefault = parcelHelpers.interopDefault(_dangerousSharp);
var _dangerousTwoTone = require("./DangerousTwoTone");
var _dangerousTwoToneDefault = parcelHelpers.interopDefault(_dangerousTwoTone);
var _darkMode = require("./DarkMode");
var _darkModeDefault = parcelHelpers.interopDefault(_darkMode);
var _darkModeOutlined = require("./DarkModeOutlined");
var _darkModeOutlinedDefault = parcelHelpers.interopDefault(_darkModeOutlined);
var _darkModeRounded = require("./DarkModeRounded");
var _darkModeRoundedDefault = parcelHelpers.interopDefault(_darkModeRounded);
var _darkModeSharp = require("./DarkModeSharp");
var _darkModeSharpDefault = parcelHelpers.interopDefault(_darkModeSharp);
var _darkModeTwoTone = require("./DarkModeTwoTone");
var _darkModeTwoToneDefault = parcelHelpers.interopDefault(_darkModeTwoTone);
var _dashboard = require("./Dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _dashboardCustomize = require("./DashboardCustomize");
var _dashboardCustomizeDefault = parcelHelpers.interopDefault(_dashboardCustomize);
var _dashboardCustomizeOutlined = require("./DashboardCustomizeOutlined");
var _dashboardCustomizeOutlinedDefault = parcelHelpers.interopDefault(_dashboardCustomizeOutlined);
var _dashboardCustomizeRounded = require("./DashboardCustomizeRounded");
var _dashboardCustomizeRoundedDefault = parcelHelpers.interopDefault(_dashboardCustomizeRounded);
var _dashboardCustomizeSharp = require("./DashboardCustomizeSharp");
var _dashboardCustomizeSharpDefault = parcelHelpers.interopDefault(_dashboardCustomizeSharp);
var _dashboardCustomizeTwoTone = require("./DashboardCustomizeTwoTone");
var _dashboardCustomizeTwoToneDefault = parcelHelpers.interopDefault(_dashboardCustomizeTwoTone);
var _dashboardOutlined = require("./DashboardOutlined");
var _dashboardOutlinedDefault = parcelHelpers.interopDefault(_dashboardOutlined);
var _dashboardRounded = require("./DashboardRounded");
var _dashboardRoundedDefault = parcelHelpers.interopDefault(_dashboardRounded);
var _dashboardSharp = require("./DashboardSharp");
var _dashboardSharpDefault = parcelHelpers.interopDefault(_dashboardSharp);
var _dashboardTwoTone = require("./DashboardTwoTone");
var _dashboardTwoToneDefault = parcelHelpers.interopDefault(_dashboardTwoTone);
var _dataArray = require("./DataArray");
var _dataArrayDefault = parcelHelpers.interopDefault(_dataArray);
var _dataArrayOutlined = require("./DataArrayOutlined");
var _dataArrayOutlinedDefault = parcelHelpers.interopDefault(_dataArrayOutlined);
var _dataArrayRounded = require("./DataArrayRounded");
var _dataArrayRoundedDefault = parcelHelpers.interopDefault(_dataArrayRounded);
var _dataArraySharp = require("./DataArraySharp");
var _dataArraySharpDefault = parcelHelpers.interopDefault(_dataArraySharp);
var _dataArrayTwoTone = require("./DataArrayTwoTone");
var _dataArrayTwoToneDefault = parcelHelpers.interopDefault(_dataArrayTwoTone);
var _dataObject = require("./DataObject");
var _dataObjectDefault = parcelHelpers.interopDefault(_dataObject);
var _dataObjectOutlined = require("./DataObjectOutlined");
var _dataObjectOutlinedDefault = parcelHelpers.interopDefault(_dataObjectOutlined);
var _dataObjectRounded = require("./DataObjectRounded");
var _dataObjectRoundedDefault = parcelHelpers.interopDefault(_dataObjectRounded);
var _dataObjectSharp = require("./DataObjectSharp");
var _dataObjectSharpDefault = parcelHelpers.interopDefault(_dataObjectSharp);
var _dataObjectTwoTone = require("./DataObjectTwoTone");
var _dataObjectTwoToneDefault = parcelHelpers.interopDefault(_dataObjectTwoTone);
var _dataSaverOff = require("./DataSaverOff");
var _dataSaverOffDefault = parcelHelpers.interopDefault(_dataSaverOff);
var _dataSaverOffOutlined = require("./DataSaverOffOutlined");
var _dataSaverOffOutlinedDefault = parcelHelpers.interopDefault(_dataSaverOffOutlined);
var _dataSaverOffRounded = require("./DataSaverOffRounded");
var _dataSaverOffRoundedDefault = parcelHelpers.interopDefault(_dataSaverOffRounded);
var _dataSaverOffSharp = require("./DataSaverOffSharp");
var _dataSaverOffSharpDefault = parcelHelpers.interopDefault(_dataSaverOffSharp);
var _dataSaverOffTwoTone = require("./DataSaverOffTwoTone");
var _dataSaverOffTwoToneDefault = parcelHelpers.interopDefault(_dataSaverOffTwoTone);
var _dataSaverOn = require("./DataSaverOn");
var _dataSaverOnDefault = parcelHelpers.interopDefault(_dataSaverOn);
var _dataSaverOnOutlined = require("./DataSaverOnOutlined");
var _dataSaverOnOutlinedDefault = parcelHelpers.interopDefault(_dataSaverOnOutlined);
var _dataSaverOnRounded = require("./DataSaverOnRounded");
var _dataSaverOnRoundedDefault = parcelHelpers.interopDefault(_dataSaverOnRounded);
var _dataSaverOnSharp = require("./DataSaverOnSharp");
var _dataSaverOnSharpDefault = parcelHelpers.interopDefault(_dataSaverOnSharp);
var _dataSaverOnTwoTone = require("./DataSaverOnTwoTone");
var _dataSaverOnTwoToneDefault = parcelHelpers.interopDefault(_dataSaverOnTwoTone);
var _dataThresholding = require("./DataThresholding");
var _dataThresholdingDefault = parcelHelpers.interopDefault(_dataThresholding);
var _dataThresholdingOutlined = require("./DataThresholdingOutlined");
var _dataThresholdingOutlinedDefault = parcelHelpers.interopDefault(_dataThresholdingOutlined);
var _dataThresholdingRounded = require("./DataThresholdingRounded");
var _dataThresholdingRoundedDefault = parcelHelpers.interopDefault(_dataThresholdingRounded);
var _dataThresholdingSharp = require("./DataThresholdingSharp");
var _dataThresholdingSharpDefault = parcelHelpers.interopDefault(_dataThresholdingSharp);
var _dataThresholdingTwoTone = require("./DataThresholdingTwoTone");
var _dataThresholdingTwoToneDefault = parcelHelpers.interopDefault(_dataThresholdingTwoTone);
var _dataUsage = require("./DataUsage");
var _dataUsageDefault = parcelHelpers.interopDefault(_dataUsage);
var _dataUsageOutlined = require("./DataUsageOutlined");
var _dataUsageOutlinedDefault = parcelHelpers.interopDefault(_dataUsageOutlined);
var _dataUsageRounded = require("./DataUsageRounded");
var _dataUsageRoundedDefault = parcelHelpers.interopDefault(_dataUsageRounded);
var _dataUsageSharp = require("./DataUsageSharp");
var _dataUsageSharpDefault = parcelHelpers.interopDefault(_dataUsageSharp);
var _dataUsageTwoTone = require("./DataUsageTwoTone");
var _dataUsageTwoToneDefault = parcelHelpers.interopDefault(_dataUsageTwoTone);
var _dataset = require("./Dataset");
var _datasetDefault = parcelHelpers.interopDefault(_dataset);
var _datasetLinked = require("./DatasetLinked");
var _datasetLinkedDefault = parcelHelpers.interopDefault(_datasetLinked);
var _datasetLinkedOutlined = require("./DatasetLinkedOutlined");
var _datasetLinkedOutlinedDefault = parcelHelpers.interopDefault(_datasetLinkedOutlined);
var _datasetLinkedRounded = require("./DatasetLinkedRounded");
var _datasetLinkedRoundedDefault = parcelHelpers.interopDefault(_datasetLinkedRounded);
var _datasetLinkedSharp = require("./DatasetLinkedSharp");
var _datasetLinkedSharpDefault = parcelHelpers.interopDefault(_datasetLinkedSharp);
var _datasetLinkedTwoTone = require("./DatasetLinkedTwoTone");
var _datasetLinkedTwoToneDefault = parcelHelpers.interopDefault(_datasetLinkedTwoTone);
var _datasetOutlined = require("./DatasetOutlined");
var _datasetOutlinedDefault = parcelHelpers.interopDefault(_datasetOutlined);
var _datasetRounded = require("./DatasetRounded");
var _datasetRoundedDefault = parcelHelpers.interopDefault(_datasetRounded);
var _datasetSharp = require("./DatasetSharp");
var _datasetSharpDefault = parcelHelpers.interopDefault(_datasetSharp);
var _datasetTwoTone = require("./DatasetTwoTone");
var _datasetTwoToneDefault = parcelHelpers.interopDefault(_datasetTwoTone);
var _dateRange = require("./DateRange");
var _dateRangeDefault = parcelHelpers.interopDefault(_dateRange);
var _dateRangeOutlined = require("./DateRangeOutlined");
var _dateRangeOutlinedDefault = parcelHelpers.interopDefault(_dateRangeOutlined);
var _dateRangeRounded = require("./DateRangeRounded");
var _dateRangeRoundedDefault = parcelHelpers.interopDefault(_dateRangeRounded);
var _dateRangeSharp = require("./DateRangeSharp");
var _dateRangeSharpDefault = parcelHelpers.interopDefault(_dateRangeSharp);
var _dateRangeTwoTone = require("./DateRangeTwoTone");
var _dateRangeTwoToneDefault = parcelHelpers.interopDefault(_dateRangeTwoTone);
var _deblur = require("./Deblur");
var _deblurDefault = parcelHelpers.interopDefault(_deblur);
var _deblurOutlined = require("./DeblurOutlined");
var _deblurOutlinedDefault = parcelHelpers.interopDefault(_deblurOutlined);
var _deblurRounded = require("./DeblurRounded");
var _deblurRoundedDefault = parcelHelpers.interopDefault(_deblurRounded);
var _deblurSharp = require("./DeblurSharp");
var _deblurSharpDefault = parcelHelpers.interopDefault(_deblurSharp);
var _deblurTwoTone = require("./DeblurTwoTone");
var _deblurTwoToneDefault = parcelHelpers.interopDefault(_deblurTwoTone);
var _deck = require("./Deck");
var _deckDefault = parcelHelpers.interopDefault(_deck);
var _deckOutlined = require("./DeckOutlined");
var _deckOutlinedDefault = parcelHelpers.interopDefault(_deckOutlined);
var _deckRounded = require("./DeckRounded");
var _deckRoundedDefault = parcelHelpers.interopDefault(_deckRounded);
var _deckSharp = require("./DeckSharp");
var _deckSharpDefault = parcelHelpers.interopDefault(_deckSharp);
var _deckTwoTone = require("./DeckTwoTone");
var _deckTwoToneDefault = parcelHelpers.interopDefault(_deckTwoTone);
var _dehaze = require("./Dehaze");
var _dehazeDefault = parcelHelpers.interopDefault(_dehaze);
var _dehazeOutlined = require("./DehazeOutlined");
var _dehazeOutlinedDefault = parcelHelpers.interopDefault(_dehazeOutlined);
var _dehazeRounded = require("./DehazeRounded");
var _dehazeRoundedDefault = parcelHelpers.interopDefault(_dehazeRounded);
var _dehazeSharp = require("./DehazeSharp");
var _dehazeSharpDefault = parcelHelpers.interopDefault(_dehazeSharp);
var _dehazeTwoTone = require("./DehazeTwoTone");
var _dehazeTwoToneDefault = parcelHelpers.interopDefault(_dehazeTwoTone);
var _delete = require("./Delete");
var _deleteDefault = parcelHelpers.interopDefault(_delete);
var _deleteForever = require("./DeleteForever");
var _deleteForeverDefault = parcelHelpers.interopDefault(_deleteForever);
var _deleteForeverOutlined = require("./DeleteForeverOutlined");
var _deleteForeverOutlinedDefault = parcelHelpers.interopDefault(_deleteForeverOutlined);
var _deleteForeverRounded = require("./DeleteForeverRounded");
var _deleteForeverRoundedDefault = parcelHelpers.interopDefault(_deleteForeverRounded);
var _deleteForeverSharp = require("./DeleteForeverSharp");
var _deleteForeverSharpDefault = parcelHelpers.interopDefault(_deleteForeverSharp);
var _deleteForeverTwoTone = require("./DeleteForeverTwoTone");
var _deleteForeverTwoToneDefault = parcelHelpers.interopDefault(_deleteForeverTwoTone);
var _deleteOutline = require("./DeleteOutline");
var _deleteOutlineDefault = parcelHelpers.interopDefault(_deleteOutline);
var _deleteOutlineOutlined = require("./DeleteOutlineOutlined");
var _deleteOutlineOutlinedDefault = parcelHelpers.interopDefault(_deleteOutlineOutlined);
var _deleteOutlineRounded = require("./DeleteOutlineRounded");
var _deleteOutlineRoundedDefault = parcelHelpers.interopDefault(_deleteOutlineRounded);
var _deleteOutlineSharp = require("./DeleteOutlineSharp");
var _deleteOutlineSharpDefault = parcelHelpers.interopDefault(_deleteOutlineSharp);
var _deleteOutlineTwoTone = require("./DeleteOutlineTwoTone");
var _deleteOutlineTwoToneDefault = parcelHelpers.interopDefault(_deleteOutlineTwoTone);
var _deleteOutlined = require("./DeleteOutlined");
var _deleteOutlinedDefault = parcelHelpers.interopDefault(_deleteOutlined);
var _deleteRounded = require("./DeleteRounded");
var _deleteRoundedDefault = parcelHelpers.interopDefault(_deleteRounded);
var _deleteSharp = require("./DeleteSharp");
var _deleteSharpDefault = parcelHelpers.interopDefault(_deleteSharp);
var _deleteSweep = require("./DeleteSweep");
var _deleteSweepDefault = parcelHelpers.interopDefault(_deleteSweep);
var _deleteSweepOutlined = require("./DeleteSweepOutlined");
var _deleteSweepOutlinedDefault = parcelHelpers.interopDefault(_deleteSweepOutlined);
var _deleteSweepRounded = require("./DeleteSweepRounded");
var _deleteSweepRoundedDefault = parcelHelpers.interopDefault(_deleteSweepRounded);
var _deleteSweepSharp = require("./DeleteSweepSharp");
var _deleteSweepSharpDefault = parcelHelpers.interopDefault(_deleteSweepSharp);
var _deleteSweepTwoTone = require("./DeleteSweepTwoTone");
var _deleteSweepTwoToneDefault = parcelHelpers.interopDefault(_deleteSweepTwoTone);
var _deleteTwoTone = require("./DeleteTwoTone");
var _deleteTwoToneDefault = parcelHelpers.interopDefault(_deleteTwoTone);
var _deliveryDining = require("./DeliveryDining");
var _deliveryDiningDefault = parcelHelpers.interopDefault(_deliveryDining);
var _deliveryDiningOutlined = require("./DeliveryDiningOutlined");
var _deliveryDiningOutlinedDefault = parcelHelpers.interopDefault(_deliveryDiningOutlined);
var _deliveryDiningRounded = require("./DeliveryDiningRounded");
var _deliveryDiningRoundedDefault = parcelHelpers.interopDefault(_deliveryDiningRounded);
var _deliveryDiningSharp = require("./DeliveryDiningSharp");
var _deliveryDiningSharpDefault = parcelHelpers.interopDefault(_deliveryDiningSharp);
var _deliveryDiningTwoTone = require("./DeliveryDiningTwoTone");
var _deliveryDiningTwoToneDefault = parcelHelpers.interopDefault(_deliveryDiningTwoTone);
var _densityLarge = require("./DensityLarge");
var _densityLargeDefault = parcelHelpers.interopDefault(_densityLarge);
var _densityLargeOutlined = require("./DensityLargeOutlined");
var _densityLargeOutlinedDefault = parcelHelpers.interopDefault(_densityLargeOutlined);
var _densityLargeRounded = require("./DensityLargeRounded");
var _densityLargeRoundedDefault = parcelHelpers.interopDefault(_densityLargeRounded);
var _densityLargeSharp = require("./DensityLargeSharp");
var _densityLargeSharpDefault = parcelHelpers.interopDefault(_densityLargeSharp);
var _densityLargeTwoTone = require("./DensityLargeTwoTone");
var _densityLargeTwoToneDefault = parcelHelpers.interopDefault(_densityLargeTwoTone);
var _densityMedium = require("./DensityMedium");
var _densityMediumDefault = parcelHelpers.interopDefault(_densityMedium);
var _densityMediumOutlined = require("./DensityMediumOutlined");
var _densityMediumOutlinedDefault = parcelHelpers.interopDefault(_densityMediumOutlined);
var _densityMediumRounded = require("./DensityMediumRounded");
var _densityMediumRoundedDefault = parcelHelpers.interopDefault(_densityMediumRounded);
var _densityMediumSharp = require("./DensityMediumSharp");
var _densityMediumSharpDefault = parcelHelpers.interopDefault(_densityMediumSharp);
var _densityMediumTwoTone = require("./DensityMediumTwoTone");
var _densityMediumTwoToneDefault = parcelHelpers.interopDefault(_densityMediumTwoTone);
var _densitySmall = require("./DensitySmall");
var _densitySmallDefault = parcelHelpers.interopDefault(_densitySmall);
var _densitySmallOutlined = require("./DensitySmallOutlined");
var _densitySmallOutlinedDefault = parcelHelpers.interopDefault(_densitySmallOutlined);
var _densitySmallRounded = require("./DensitySmallRounded");
var _densitySmallRoundedDefault = parcelHelpers.interopDefault(_densitySmallRounded);
var _densitySmallSharp = require("./DensitySmallSharp");
var _densitySmallSharpDefault = parcelHelpers.interopDefault(_densitySmallSharp);
var _densitySmallTwoTone = require("./DensitySmallTwoTone");
var _densitySmallTwoToneDefault = parcelHelpers.interopDefault(_densitySmallTwoTone);
var _departureBoard = require("./DepartureBoard");
var _departureBoardDefault = parcelHelpers.interopDefault(_departureBoard);
var _departureBoardOutlined = require("./DepartureBoardOutlined");
var _departureBoardOutlinedDefault = parcelHelpers.interopDefault(_departureBoardOutlined);
var _departureBoardRounded = require("./DepartureBoardRounded");
var _departureBoardRoundedDefault = parcelHelpers.interopDefault(_departureBoardRounded);
var _departureBoardSharp = require("./DepartureBoardSharp");
var _departureBoardSharpDefault = parcelHelpers.interopDefault(_departureBoardSharp);
var _departureBoardTwoTone = require("./DepartureBoardTwoTone");
var _departureBoardTwoToneDefault = parcelHelpers.interopDefault(_departureBoardTwoTone);
var _description = require("./Description");
var _descriptionDefault = parcelHelpers.interopDefault(_description);
var _descriptionOutlined = require("./DescriptionOutlined");
var _descriptionOutlinedDefault = parcelHelpers.interopDefault(_descriptionOutlined);
var _descriptionRounded = require("./DescriptionRounded");
var _descriptionRoundedDefault = parcelHelpers.interopDefault(_descriptionRounded);
var _descriptionSharp = require("./DescriptionSharp");
var _descriptionSharpDefault = parcelHelpers.interopDefault(_descriptionSharp);
var _descriptionTwoTone = require("./DescriptionTwoTone");
var _descriptionTwoToneDefault = parcelHelpers.interopDefault(_descriptionTwoTone);
var _deselect = require("./Deselect");
var _deselectDefault = parcelHelpers.interopDefault(_deselect);
var _deselectOutlined = require("./DeselectOutlined");
var _deselectOutlinedDefault = parcelHelpers.interopDefault(_deselectOutlined);
var _deselectRounded = require("./DeselectRounded");
var _deselectRoundedDefault = parcelHelpers.interopDefault(_deselectRounded);
var _deselectSharp = require("./DeselectSharp");
var _deselectSharpDefault = parcelHelpers.interopDefault(_deselectSharp);
var _deselectTwoTone = require("./DeselectTwoTone");
var _deselectTwoToneDefault = parcelHelpers.interopDefault(_deselectTwoTone);
var _designServices = require("./DesignServices");
var _designServicesDefault = parcelHelpers.interopDefault(_designServices);
var _designServicesOutlined = require("./DesignServicesOutlined");
var _designServicesOutlinedDefault = parcelHelpers.interopDefault(_designServicesOutlined);
var _designServicesRounded = require("./DesignServicesRounded");
var _designServicesRoundedDefault = parcelHelpers.interopDefault(_designServicesRounded);
var _designServicesSharp = require("./DesignServicesSharp");
var _designServicesSharpDefault = parcelHelpers.interopDefault(_designServicesSharp);
var _designServicesTwoTone = require("./DesignServicesTwoTone");
var _designServicesTwoToneDefault = parcelHelpers.interopDefault(_designServicesTwoTone);
var _desk = require("./Desk");
var _deskDefault = parcelHelpers.interopDefault(_desk);
var _deskOutlined = require("./DeskOutlined");
var _deskOutlinedDefault = parcelHelpers.interopDefault(_deskOutlined);
var _deskRounded = require("./DeskRounded");
var _deskRoundedDefault = parcelHelpers.interopDefault(_deskRounded);
var _deskSharp = require("./DeskSharp");
var _deskSharpDefault = parcelHelpers.interopDefault(_deskSharp);
var _deskTwoTone = require("./DeskTwoTone");
var _deskTwoToneDefault = parcelHelpers.interopDefault(_deskTwoTone);
var _desktopAccessDisabled = require("./DesktopAccessDisabled");
var _desktopAccessDisabledDefault = parcelHelpers.interopDefault(_desktopAccessDisabled);
var _desktopAccessDisabledOutlined = require("./DesktopAccessDisabledOutlined");
var _desktopAccessDisabledOutlinedDefault = parcelHelpers.interopDefault(_desktopAccessDisabledOutlined);
var _desktopAccessDisabledRounded = require("./DesktopAccessDisabledRounded");
var _desktopAccessDisabledRoundedDefault = parcelHelpers.interopDefault(_desktopAccessDisabledRounded);
var _desktopAccessDisabledSharp = require("./DesktopAccessDisabledSharp");
var _desktopAccessDisabledSharpDefault = parcelHelpers.interopDefault(_desktopAccessDisabledSharp);
var _desktopAccessDisabledTwoTone = require("./DesktopAccessDisabledTwoTone");
var _desktopAccessDisabledTwoToneDefault = parcelHelpers.interopDefault(_desktopAccessDisabledTwoTone);
var _desktopMac = require("./DesktopMac");
var _desktopMacDefault = parcelHelpers.interopDefault(_desktopMac);
var _desktopMacOutlined = require("./DesktopMacOutlined");
var _desktopMacOutlinedDefault = parcelHelpers.interopDefault(_desktopMacOutlined);
var _desktopMacRounded = require("./DesktopMacRounded");
var _desktopMacRoundedDefault = parcelHelpers.interopDefault(_desktopMacRounded);
var _desktopMacSharp = require("./DesktopMacSharp");
var _desktopMacSharpDefault = parcelHelpers.interopDefault(_desktopMacSharp);
var _desktopMacTwoTone = require("./DesktopMacTwoTone");
var _desktopMacTwoToneDefault = parcelHelpers.interopDefault(_desktopMacTwoTone);
var _desktopWindows = require("./DesktopWindows");
var _desktopWindowsDefault = parcelHelpers.interopDefault(_desktopWindows);
var _desktopWindowsOutlined = require("./DesktopWindowsOutlined");
var _desktopWindowsOutlinedDefault = parcelHelpers.interopDefault(_desktopWindowsOutlined);
var _desktopWindowsRounded = require("./DesktopWindowsRounded");
var _desktopWindowsRoundedDefault = parcelHelpers.interopDefault(_desktopWindowsRounded);
var _desktopWindowsSharp = require("./DesktopWindowsSharp");
var _desktopWindowsSharpDefault = parcelHelpers.interopDefault(_desktopWindowsSharp);
var _desktopWindowsTwoTone = require("./DesktopWindowsTwoTone");
var _desktopWindowsTwoToneDefault = parcelHelpers.interopDefault(_desktopWindowsTwoTone);
var _details = require("./Details");
var _detailsDefault = parcelHelpers.interopDefault(_details);
var _detailsOutlined = require("./DetailsOutlined");
var _detailsOutlinedDefault = parcelHelpers.interopDefault(_detailsOutlined);
var _detailsRounded = require("./DetailsRounded");
var _detailsRoundedDefault = parcelHelpers.interopDefault(_detailsRounded);
var _detailsSharp = require("./DetailsSharp");
var _detailsSharpDefault = parcelHelpers.interopDefault(_detailsSharp);
var _detailsTwoTone = require("./DetailsTwoTone");
var _detailsTwoToneDefault = parcelHelpers.interopDefault(_detailsTwoTone);
var _developerBoard = require("./DeveloperBoard");
var _developerBoardDefault = parcelHelpers.interopDefault(_developerBoard);
var _developerBoardOff = require("./DeveloperBoardOff");
var _developerBoardOffDefault = parcelHelpers.interopDefault(_developerBoardOff);
var _developerBoardOffOutlined = require("./DeveloperBoardOffOutlined");
var _developerBoardOffOutlinedDefault = parcelHelpers.interopDefault(_developerBoardOffOutlined);
var _developerBoardOffRounded = require("./DeveloperBoardOffRounded");
var _developerBoardOffRoundedDefault = parcelHelpers.interopDefault(_developerBoardOffRounded);
var _developerBoardOffSharp = require("./DeveloperBoardOffSharp");
var _developerBoardOffSharpDefault = parcelHelpers.interopDefault(_developerBoardOffSharp);
var _developerBoardOffTwoTone = require("./DeveloperBoardOffTwoTone");
var _developerBoardOffTwoToneDefault = parcelHelpers.interopDefault(_developerBoardOffTwoTone);
var _developerBoardOutlined = require("./DeveloperBoardOutlined");
var _developerBoardOutlinedDefault = parcelHelpers.interopDefault(_developerBoardOutlined);
var _developerBoardRounded = require("./DeveloperBoardRounded");
var _developerBoardRoundedDefault = parcelHelpers.interopDefault(_developerBoardRounded);
var _developerBoardSharp = require("./DeveloperBoardSharp");
var _developerBoardSharpDefault = parcelHelpers.interopDefault(_developerBoardSharp);
var _developerBoardTwoTone = require("./DeveloperBoardTwoTone");
var _developerBoardTwoToneDefault = parcelHelpers.interopDefault(_developerBoardTwoTone);
var _developerMode = require("./DeveloperMode");
var _developerModeDefault = parcelHelpers.interopDefault(_developerMode);
var _developerModeOutlined = require("./DeveloperModeOutlined");
var _developerModeOutlinedDefault = parcelHelpers.interopDefault(_developerModeOutlined);
var _developerModeRounded = require("./DeveloperModeRounded");
var _developerModeRoundedDefault = parcelHelpers.interopDefault(_developerModeRounded);
var _developerModeSharp = require("./DeveloperModeSharp");
var _developerModeSharpDefault = parcelHelpers.interopDefault(_developerModeSharp);
var _developerModeTwoTone = require("./DeveloperModeTwoTone");
var _developerModeTwoToneDefault = parcelHelpers.interopDefault(_developerModeTwoTone);
var _deviceHub = require("./DeviceHub");
var _deviceHubDefault = parcelHelpers.interopDefault(_deviceHub);
var _deviceHubOutlined = require("./DeviceHubOutlined");
var _deviceHubOutlinedDefault = parcelHelpers.interopDefault(_deviceHubOutlined);
var _deviceHubRounded = require("./DeviceHubRounded");
var _deviceHubRoundedDefault = parcelHelpers.interopDefault(_deviceHubRounded);
var _deviceHubSharp = require("./DeviceHubSharp");
var _deviceHubSharpDefault = parcelHelpers.interopDefault(_deviceHubSharp);
var _deviceHubTwoTone = require("./DeviceHubTwoTone");
var _deviceHubTwoToneDefault = parcelHelpers.interopDefault(_deviceHubTwoTone);
var _deviceThermostat = require("./DeviceThermostat");
var _deviceThermostatDefault = parcelHelpers.interopDefault(_deviceThermostat);
var _deviceThermostatOutlined = require("./DeviceThermostatOutlined");
var _deviceThermostatOutlinedDefault = parcelHelpers.interopDefault(_deviceThermostatOutlined);
var _deviceThermostatRounded = require("./DeviceThermostatRounded");
var _deviceThermostatRoundedDefault = parcelHelpers.interopDefault(_deviceThermostatRounded);
var _deviceThermostatSharp = require("./DeviceThermostatSharp");
var _deviceThermostatSharpDefault = parcelHelpers.interopDefault(_deviceThermostatSharp);
var _deviceThermostatTwoTone = require("./DeviceThermostatTwoTone");
var _deviceThermostatTwoToneDefault = parcelHelpers.interopDefault(_deviceThermostatTwoTone);
var _deviceUnknown = require("./DeviceUnknown");
var _deviceUnknownDefault = parcelHelpers.interopDefault(_deviceUnknown);
var _deviceUnknownOutlined = require("./DeviceUnknownOutlined");
var _deviceUnknownOutlinedDefault = parcelHelpers.interopDefault(_deviceUnknownOutlined);
var _deviceUnknownRounded = require("./DeviceUnknownRounded");
var _deviceUnknownRoundedDefault = parcelHelpers.interopDefault(_deviceUnknownRounded);
var _deviceUnknownSharp = require("./DeviceUnknownSharp");
var _deviceUnknownSharpDefault = parcelHelpers.interopDefault(_deviceUnknownSharp);
var _deviceUnknownTwoTone = require("./DeviceUnknownTwoTone");
var _deviceUnknownTwoToneDefault = parcelHelpers.interopDefault(_deviceUnknownTwoTone);
var _devices = require("./Devices");
var _devicesDefault = parcelHelpers.interopDefault(_devices);
var _devicesFold = require("./DevicesFold");
var _devicesFoldDefault = parcelHelpers.interopDefault(_devicesFold);
var _devicesFoldOutlined = require("./DevicesFoldOutlined");
var _devicesFoldOutlinedDefault = parcelHelpers.interopDefault(_devicesFoldOutlined);
var _devicesFoldRounded = require("./DevicesFoldRounded");
var _devicesFoldRoundedDefault = parcelHelpers.interopDefault(_devicesFoldRounded);
var _devicesFoldSharp = require("./DevicesFoldSharp");
var _devicesFoldSharpDefault = parcelHelpers.interopDefault(_devicesFoldSharp);
var _devicesFoldTwoTone = require("./DevicesFoldTwoTone");
var _devicesFoldTwoToneDefault = parcelHelpers.interopDefault(_devicesFoldTwoTone);
var _devicesOther = require("./DevicesOther");
var _devicesOtherDefault = parcelHelpers.interopDefault(_devicesOther);
var _devicesOtherOutlined = require("./DevicesOtherOutlined");
var _devicesOtherOutlinedDefault = parcelHelpers.interopDefault(_devicesOtherOutlined);
var _devicesOtherRounded = require("./DevicesOtherRounded");
var _devicesOtherRoundedDefault = parcelHelpers.interopDefault(_devicesOtherRounded);
var _devicesOtherSharp = require("./DevicesOtherSharp");
var _devicesOtherSharpDefault = parcelHelpers.interopDefault(_devicesOtherSharp);
var _devicesOtherTwoTone = require("./DevicesOtherTwoTone");
var _devicesOtherTwoToneDefault = parcelHelpers.interopDefault(_devicesOtherTwoTone);
var _devicesOutlined = require("./DevicesOutlined");
var _devicesOutlinedDefault = parcelHelpers.interopDefault(_devicesOutlined);
var _devicesRounded = require("./DevicesRounded");
var _devicesRoundedDefault = parcelHelpers.interopDefault(_devicesRounded);
var _devicesSharp = require("./DevicesSharp");
var _devicesSharpDefault = parcelHelpers.interopDefault(_devicesSharp);
var _devicesTwoTone = require("./DevicesTwoTone");
var _devicesTwoToneDefault = parcelHelpers.interopDefault(_devicesTwoTone);
var _dialerSip = require("./DialerSip");
var _dialerSipDefault = parcelHelpers.interopDefault(_dialerSip);
var _dialerSipOutlined = require("./DialerSipOutlined");
var _dialerSipOutlinedDefault = parcelHelpers.interopDefault(_dialerSipOutlined);
var _dialerSipRounded = require("./DialerSipRounded");
var _dialerSipRoundedDefault = parcelHelpers.interopDefault(_dialerSipRounded);
var _dialerSipSharp = require("./DialerSipSharp");
var _dialerSipSharpDefault = parcelHelpers.interopDefault(_dialerSipSharp);
var _dialerSipTwoTone = require("./DialerSipTwoTone");
var _dialerSipTwoToneDefault = parcelHelpers.interopDefault(_dialerSipTwoTone);
var _dialpad = require("./Dialpad");
var _dialpadDefault = parcelHelpers.interopDefault(_dialpad);
var _dialpadOutlined = require("./DialpadOutlined");
var _dialpadOutlinedDefault = parcelHelpers.interopDefault(_dialpadOutlined);
var _dialpadRounded = require("./DialpadRounded");
var _dialpadRoundedDefault = parcelHelpers.interopDefault(_dialpadRounded);
var _dialpadSharp = require("./DialpadSharp");
var _dialpadSharpDefault = parcelHelpers.interopDefault(_dialpadSharp);
var _dialpadTwoTone = require("./DialpadTwoTone");
var _dialpadTwoToneDefault = parcelHelpers.interopDefault(_dialpadTwoTone);
var _diamond = require("./Diamond");
var _diamondDefault = parcelHelpers.interopDefault(_diamond);
var _diamondOutlined = require("./DiamondOutlined");
var _diamondOutlinedDefault = parcelHelpers.interopDefault(_diamondOutlined);
var _diamondRounded = require("./DiamondRounded");
var _diamondRoundedDefault = parcelHelpers.interopDefault(_diamondRounded);
var _diamondSharp = require("./DiamondSharp");
var _diamondSharpDefault = parcelHelpers.interopDefault(_diamondSharp);
var _diamondTwoTone = require("./DiamondTwoTone");
var _diamondTwoToneDefault = parcelHelpers.interopDefault(_diamondTwoTone);
var _difference = require("./Difference");
var _differenceDefault = parcelHelpers.interopDefault(_difference);
var _differenceOutlined = require("./DifferenceOutlined");
var _differenceOutlinedDefault = parcelHelpers.interopDefault(_differenceOutlined);
var _differenceRounded = require("./DifferenceRounded");
var _differenceRoundedDefault = parcelHelpers.interopDefault(_differenceRounded);
var _differenceSharp = require("./DifferenceSharp");
var _differenceSharpDefault = parcelHelpers.interopDefault(_differenceSharp);
var _differenceTwoTone = require("./DifferenceTwoTone");
var _differenceTwoToneDefault = parcelHelpers.interopDefault(_differenceTwoTone);
var _dining = require("./Dining");
var _diningDefault = parcelHelpers.interopDefault(_dining);
var _diningOutlined = require("./DiningOutlined");
var _diningOutlinedDefault = parcelHelpers.interopDefault(_diningOutlined);
var _diningRounded = require("./DiningRounded");
var _diningRoundedDefault = parcelHelpers.interopDefault(_diningRounded);
var _diningSharp = require("./DiningSharp");
var _diningSharpDefault = parcelHelpers.interopDefault(_diningSharp);
var _diningTwoTone = require("./DiningTwoTone");
var _diningTwoToneDefault = parcelHelpers.interopDefault(_diningTwoTone);
var _dinnerDining = require("./DinnerDining");
var _dinnerDiningDefault = parcelHelpers.interopDefault(_dinnerDining);
var _dinnerDiningOutlined = require("./DinnerDiningOutlined");
var _dinnerDiningOutlinedDefault = parcelHelpers.interopDefault(_dinnerDiningOutlined);
var _dinnerDiningRounded = require("./DinnerDiningRounded");
var _dinnerDiningRoundedDefault = parcelHelpers.interopDefault(_dinnerDiningRounded);
var _dinnerDiningSharp = require("./DinnerDiningSharp");
var _dinnerDiningSharpDefault = parcelHelpers.interopDefault(_dinnerDiningSharp);
var _dinnerDiningTwoTone = require("./DinnerDiningTwoTone");
var _dinnerDiningTwoToneDefault = parcelHelpers.interopDefault(_dinnerDiningTwoTone);
var _directions = require("./Directions");
var _directionsDefault = parcelHelpers.interopDefault(_directions);
var _directionsBike = require("./DirectionsBike");
var _directionsBikeDefault = parcelHelpers.interopDefault(_directionsBike);
var _directionsBikeOutlined = require("./DirectionsBikeOutlined");
var _directionsBikeOutlinedDefault = parcelHelpers.interopDefault(_directionsBikeOutlined);
var _directionsBikeRounded = require("./DirectionsBikeRounded");
var _directionsBikeRoundedDefault = parcelHelpers.interopDefault(_directionsBikeRounded);
var _directionsBikeSharp = require("./DirectionsBikeSharp");
var _directionsBikeSharpDefault = parcelHelpers.interopDefault(_directionsBikeSharp);
var _directionsBikeTwoTone = require("./DirectionsBikeTwoTone");
var _directionsBikeTwoToneDefault = parcelHelpers.interopDefault(_directionsBikeTwoTone);
var _directionsBoat = require("./DirectionsBoat");
var _directionsBoatDefault = parcelHelpers.interopDefault(_directionsBoat);
var _directionsBoatFilled = require("./DirectionsBoatFilled");
var _directionsBoatFilledDefault = parcelHelpers.interopDefault(_directionsBoatFilled);
var _directionsBoatFilledOutlined = require("./DirectionsBoatFilledOutlined");
var _directionsBoatFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsBoatFilledOutlined);
var _directionsBoatFilledRounded = require("./DirectionsBoatFilledRounded");
var _directionsBoatFilledRoundedDefault = parcelHelpers.interopDefault(_directionsBoatFilledRounded);
var _directionsBoatFilledSharp = require("./DirectionsBoatFilledSharp");
var _directionsBoatFilledSharpDefault = parcelHelpers.interopDefault(_directionsBoatFilledSharp);
var _directionsBoatFilledTwoTone = require("./DirectionsBoatFilledTwoTone");
var _directionsBoatFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsBoatFilledTwoTone);
var _directionsBoatOutlined = require("./DirectionsBoatOutlined");
var _directionsBoatOutlinedDefault = parcelHelpers.interopDefault(_directionsBoatOutlined);
var _directionsBoatRounded = require("./DirectionsBoatRounded");
var _directionsBoatRoundedDefault = parcelHelpers.interopDefault(_directionsBoatRounded);
var _directionsBoatSharp = require("./DirectionsBoatSharp");
var _directionsBoatSharpDefault = parcelHelpers.interopDefault(_directionsBoatSharp);
var _directionsBoatTwoTone = require("./DirectionsBoatTwoTone");
var _directionsBoatTwoToneDefault = parcelHelpers.interopDefault(_directionsBoatTwoTone);
var _directionsBus = require("./DirectionsBus");
var _directionsBusDefault = parcelHelpers.interopDefault(_directionsBus);
var _directionsBusFilled = require("./DirectionsBusFilled");
var _directionsBusFilledDefault = parcelHelpers.interopDefault(_directionsBusFilled);
var _directionsBusFilledOutlined = require("./DirectionsBusFilledOutlined");
var _directionsBusFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsBusFilledOutlined);
var _directionsBusFilledRounded = require("./DirectionsBusFilledRounded");
var _directionsBusFilledRoundedDefault = parcelHelpers.interopDefault(_directionsBusFilledRounded);
var _directionsBusFilledSharp = require("./DirectionsBusFilledSharp");
var _directionsBusFilledSharpDefault = parcelHelpers.interopDefault(_directionsBusFilledSharp);
var _directionsBusFilledTwoTone = require("./DirectionsBusFilledTwoTone");
var _directionsBusFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsBusFilledTwoTone);
var _directionsBusOutlined = require("./DirectionsBusOutlined");
var _directionsBusOutlinedDefault = parcelHelpers.interopDefault(_directionsBusOutlined);
var _directionsBusRounded = require("./DirectionsBusRounded");
var _directionsBusRoundedDefault = parcelHelpers.interopDefault(_directionsBusRounded);
var _directionsBusSharp = require("./DirectionsBusSharp");
var _directionsBusSharpDefault = parcelHelpers.interopDefault(_directionsBusSharp);
var _directionsBusTwoTone = require("./DirectionsBusTwoTone");
var _directionsBusTwoToneDefault = parcelHelpers.interopDefault(_directionsBusTwoTone);
var _directionsCar = require("./DirectionsCar");
var _directionsCarDefault = parcelHelpers.interopDefault(_directionsCar);
var _directionsCarFilled = require("./DirectionsCarFilled");
var _directionsCarFilledDefault = parcelHelpers.interopDefault(_directionsCarFilled);
var _directionsCarFilledOutlined = require("./DirectionsCarFilledOutlined");
var _directionsCarFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsCarFilledOutlined);
var _directionsCarFilledRounded = require("./DirectionsCarFilledRounded");
var _directionsCarFilledRoundedDefault = parcelHelpers.interopDefault(_directionsCarFilledRounded);
var _directionsCarFilledSharp = require("./DirectionsCarFilledSharp");
var _directionsCarFilledSharpDefault = parcelHelpers.interopDefault(_directionsCarFilledSharp);
var _directionsCarFilledTwoTone = require("./DirectionsCarFilledTwoTone");
var _directionsCarFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsCarFilledTwoTone);
var _directionsCarOutlined = require("./DirectionsCarOutlined");
var _directionsCarOutlinedDefault = parcelHelpers.interopDefault(_directionsCarOutlined);
var _directionsCarRounded = require("./DirectionsCarRounded");
var _directionsCarRoundedDefault = parcelHelpers.interopDefault(_directionsCarRounded);
var _directionsCarSharp = require("./DirectionsCarSharp");
var _directionsCarSharpDefault = parcelHelpers.interopDefault(_directionsCarSharp);
var _directionsCarTwoTone = require("./DirectionsCarTwoTone");
var _directionsCarTwoToneDefault = parcelHelpers.interopDefault(_directionsCarTwoTone);
var _directionsOff = require("./DirectionsOff");
var _directionsOffDefault = parcelHelpers.interopDefault(_directionsOff);
var _directionsOffOutlined = require("./DirectionsOffOutlined");
var _directionsOffOutlinedDefault = parcelHelpers.interopDefault(_directionsOffOutlined);
var _directionsOffRounded = require("./DirectionsOffRounded");
var _directionsOffRoundedDefault = parcelHelpers.interopDefault(_directionsOffRounded);
var _directionsOffSharp = require("./DirectionsOffSharp");
var _directionsOffSharpDefault = parcelHelpers.interopDefault(_directionsOffSharp);
var _directionsOffTwoTone = require("./DirectionsOffTwoTone");
var _directionsOffTwoToneDefault = parcelHelpers.interopDefault(_directionsOffTwoTone);
var _directionsOutlined = require("./DirectionsOutlined");
var _directionsOutlinedDefault = parcelHelpers.interopDefault(_directionsOutlined);
var _directionsRailway = require("./DirectionsRailway");
var _directionsRailwayDefault = parcelHelpers.interopDefault(_directionsRailway);
var _directionsRailwayFilled = require("./DirectionsRailwayFilled");
var _directionsRailwayFilledDefault = parcelHelpers.interopDefault(_directionsRailwayFilled);
var _directionsRailwayFilledOutlined = require("./DirectionsRailwayFilledOutlined");
var _directionsRailwayFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsRailwayFilledOutlined);
var _directionsRailwayFilledRounded = require("./DirectionsRailwayFilledRounded");
var _directionsRailwayFilledRoundedDefault = parcelHelpers.interopDefault(_directionsRailwayFilledRounded);
var _directionsRailwayFilledSharp = require("./DirectionsRailwayFilledSharp");
var _directionsRailwayFilledSharpDefault = parcelHelpers.interopDefault(_directionsRailwayFilledSharp);
var _directionsRailwayFilledTwoTone = require("./DirectionsRailwayFilledTwoTone");
var _directionsRailwayFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsRailwayFilledTwoTone);
var _directionsRailwayOutlined = require("./DirectionsRailwayOutlined");
var _directionsRailwayOutlinedDefault = parcelHelpers.interopDefault(_directionsRailwayOutlined);
var _directionsRailwayRounded = require("./DirectionsRailwayRounded");
var _directionsRailwayRoundedDefault = parcelHelpers.interopDefault(_directionsRailwayRounded);
var _directionsRailwaySharp = require("./DirectionsRailwaySharp");
var _directionsRailwaySharpDefault = parcelHelpers.interopDefault(_directionsRailwaySharp);
var _directionsRailwayTwoTone = require("./DirectionsRailwayTwoTone");
var _directionsRailwayTwoToneDefault = parcelHelpers.interopDefault(_directionsRailwayTwoTone);
var _directionsRounded = require("./DirectionsRounded");
var _directionsRoundedDefault = parcelHelpers.interopDefault(_directionsRounded);
var _directionsRun = require("./DirectionsRun");
var _directionsRunDefault = parcelHelpers.interopDefault(_directionsRun);
var _directionsRunOutlined = require("./DirectionsRunOutlined");
var _directionsRunOutlinedDefault = parcelHelpers.interopDefault(_directionsRunOutlined);
var _directionsRunRounded = require("./DirectionsRunRounded");
var _directionsRunRoundedDefault = parcelHelpers.interopDefault(_directionsRunRounded);
var _directionsRunSharp = require("./DirectionsRunSharp");
var _directionsRunSharpDefault = parcelHelpers.interopDefault(_directionsRunSharp);
var _directionsRunTwoTone = require("./DirectionsRunTwoTone");
var _directionsRunTwoToneDefault = parcelHelpers.interopDefault(_directionsRunTwoTone);
var _directionsSharp = require("./DirectionsSharp");
var _directionsSharpDefault = parcelHelpers.interopDefault(_directionsSharp);
var _directionsSubway = require("./DirectionsSubway");
var _directionsSubwayDefault = parcelHelpers.interopDefault(_directionsSubway);
var _directionsSubwayFilled = require("./DirectionsSubwayFilled");
var _directionsSubwayFilledDefault = parcelHelpers.interopDefault(_directionsSubwayFilled);
var _directionsSubwayFilledOutlined = require("./DirectionsSubwayFilledOutlined");
var _directionsSubwayFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsSubwayFilledOutlined);
var _directionsSubwayFilledRounded = require("./DirectionsSubwayFilledRounded");
var _directionsSubwayFilledRoundedDefault = parcelHelpers.interopDefault(_directionsSubwayFilledRounded);
var _directionsSubwayFilledSharp = require("./DirectionsSubwayFilledSharp");
var _directionsSubwayFilledSharpDefault = parcelHelpers.interopDefault(_directionsSubwayFilledSharp);
var _directionsSubwayFilledTwoTone = require("./DirectionsSubwayFilledTwoTone");
var _directionsSubwayFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsSubwayFilledTwoTone);
var _directionsSubwayOutlined = require("./DirectionsSubwayOutlined");
var _directionsSubwayOutlinedDefault = parcelHelpers.interopDefault(_directionsSubwayOutlined);
var _directionsSubwayRounded = require("./DirectionsSubwayRounded");
var _directionsSubwayRoundedDefault = parcelHelpers.interopDefault(_directionsSubwayRounded);
var _directionsSubwaySharp = require("./DirectionsSubwaySharp");
var _directionsSubwaySharpDefault = parcelHelpers.interopDefault(_directionsSubwaySharp);
var _directionsSubwayTwoTone = require("./DirectionsSubwayTwoTone");
var _directionsSubwayTwoToneDefault = parcelHelpers.interopDefault(_directionsSubwayTwoTone);
var _directionsTransit = require("./DirectionsTransit");
var _directionsTransitDefault = parcelHelpers.interopDefault(_directionsTransit);
var _directionsTransitFilled = require("./DirectionsTransitFilled");
var _directionsTransitFilledDefault = parcelHelpers.interopDefault(_directionsTransitFilled);
var _directionsTransitFilledOutlined = require("./DirectionsTransitFilledOutlined");
var _directionsTransitFilledOutlinedDefault = parcelHelpers.interopDefault(_directionsTransitFilledOutlined);
var _directionsTransitFilledRounded = require("./DirectionsTransitFilledRounded");
var _directionsTransitFilledRoundedDefault = parcelHelpers.interopDefault(_directionsTransitFilledRounded);
var _directionsTransitFilledSharp = require("./DirectionsTransitFilledSharp");
var _directionsTransitFilledSharpDefault = parcelHelpers.interopDefault(_directionsTransitFilledSharp);
var _directionsTransitFilledTwoTone = require("./DirectionsTransitFilledTwoTone");
var _directionsTransitFilledTwoToneDefault = parcelHelpers.interopDefault(_directionsTransitFilledTwoTone);
var _directionsTransitOutlined = require("./DirectionsTransitOutlined");
var _directionsTransitOutlinedDefault = parcelHelpers.interopDefault(_directionsTransitOutlined);
var _directionsTransitRounded = require("./DirectionsTransitRounded");
var _directionsTransitRoundedDefault = parcelHelpers.interopDefault(_directionsTransitRounded);
var _directionsTransitSharp = require("./DirectionsTransitSharp");
var _directionsTransitSharpDefault = parcelHelpers.interopDefault(_directionsTransitSharp);
var _directionsTransitTwoTone = require("./DirectionsTransitTwoTone");
var _directionsTransitTwoToneDefault = parcelHelpers.interopDefault(_directionsTransitTwoTone);
var _directionsTwoTone = require("./DirectionsTwoTone");
var _directionsTwoToneDefault = parcelHelpers.interopDefault(_directionsTwoTone);
var _directionsWalk = require("./DirectionsWalk");
var _directionsWalkDefault = parcelHelpers.interopDefault(_directionsWalk);
var _directionsWalkOutlined = require("./DirectionsWalkOutlined");
var _directionsWalkOutlinedDefault = parcelHelpers.interopDefault(_directionsWalkOutlined);
var _directionsWalkRounded = require("./DirectionsWalkRounded");
var _directionsWalkRoundedDefault = parcelHelpers.interopDefault(_directionsWalkRounded);
var _directionsWalkSharp = require("./DirectionsWalkSharp");
var _directionsWalkSharpDefault = parcelHelpers.interopDefault(_directionsWalkSharp);
var _directionsWalkTwoTone = require("./DirectionsWalkTwoTone");
var _directionsWalkTwoToneDefault = parcelHelpers.interopDefault(_directionsWalkTwoTone);
var _dirtyLens = require("./DirtyLens");
var _dirtyLensDefault = parcelHelpers.interopDefault(_dirtyLens);
var _dirtyLensOutlined = require("./DirtyLensOutlined");
var _dirtyLensOutlinedDefault = parcelHelpers.interopDefault(_dirtyLensOutlined);
var _dirtyLensRounded = require("./DirtyLensRounded");
var _dirtyLensRoundedDefault = parcelHelpers.interopDefault(_dirtyLensRounded);
var _dirtyLensSharp = require("./DirtyLensSharp");
var _dirtyLensSharpDefault = parcelHelpers.interopDefault(_dirtyLensSharp);
var _dirtyLensTwoTone = require("./DirtyLensTwoTone");
var _dirtyLensTwoToneDefault = parcelHelpers.interopDefault(_dirtyLensTwoTone);
var _disabledByDefault = require("./DisabledByDefault");
var _disabledByDefaultDefault = parcelHelpers.interopDefault(_disabledByDefault);
var _disabledByDefaultOutlined = require("./DisabledByDefaultOutlined");
var _disabledByDefaultOutlinedDefault = parcelHelpers.interopDefault(_disabledByDefaultOutlined);
var _disabledByDefaultRounded = require("./DisabledByDefaultRounded");
var _disabledByDefaultRoundedDefault = parcelHelpers.interopDefault(_disabledByDefaultRounded);
var _disabledByDefaultSharp = require("./DisabledByDefaultSharp");
var _disabledByDefaultSharpDefault = parcelHelpers.interopDefault(_disabledByDefaultSharp);
var _disabledByDefaultTwoTone = require("./DisabledByDefaultTwoTone");
var _disabledByDefaultTwoToneDefault = parcelHelpers.interopDefault(_disabledByDefaultTwoTone);
var _discFull = require("./DiscFull");
var _discFullDefault = parcelHelpers.interopDefault(_discFull);
var _discFullOutlined = require("./DiscFullOutlined");
var _discFullOutlinedDefault = parcelHelpers.interopDefault(_discFullOutlined);
var _discFullRounded = require("./DiscFullRounded");
var _discFullRoundedDefault = parcelHelpers.interopDefault(_discFullRounded);
var _discFullSharp = require("./DiscFullSharp");
var _discFullSharpDefault = parcelHelpers.interopDefault(_discFullSharp);
var _discFullTwoTone = require("./DiscFullTwoTone");
var _discFullTwoToneDefault = parcelHelpers.interopDefault(_discFullTwoTone);
var _discount = require("./Discount");
var _discountDefault = parcelHelpers.interopDefault(_discount);
var _discountOutlined = require("./DiscountOutlined");
var _discountOutlinedDefault = parcelHelpers.interopDefault(_discountOutlined);
var _discountRounded = require("./DiscountRounded");
var _discountRoundedDefault = parcelHelpers.interopDefault(_discountRounded);
var _discountSharp = require("./DiscountSharp");
var _discountSharpDefault = parcelHelpers.interopDefault(_discountSharp);
var _discountTwoTone = require("./DiscountTwoTone");
var _discountTwoToneDefault = parcelHelpers.interopDefault(_discountTwoTone);
var _displaySettings = require("./DisplaySettings");
var _displaySettingsDefault = parcelHelpers.interopDefault(_displaySettings);
var _displaySettingsOutlined = require("./DisplaySettingsOutlined");
var _displaySettingsOutlinedDefault = parcelHelpers.interopDefault(_displaySettingsOutlined);
var _displaySettingsRounded = require("./DisplaySettingsRounded");
var _displaySettingsRoundedDefault = parcelHelpers.interopDefault(_displaySettingsRounded);
var _displaySettingsSharp = require("./DisplaySettingsSharp");
var _displaySettingsSharpDefault = parcelHelpers.interopDefault(_displaySettingsSharp);
var _displaySettingsTwoTone = require("./DisplaySettingsTwoTone");
var _displaySettingsTwoToneDefault = parcelHelpers.interopDefault(_displaySettingsTwoTone);
var _diversity1 = require("./Diversity1");
var _diversity1Default = parcelHelpers.interopDefault(_diversity1);
var _diversity1Outlined = require("./Diversity1Outlined");
var _diversity1OutlinedDefault = parcelHelpers.interopDefault(_diversity1Outlined);
var _diversity1Rounded = require("./Diversity1Rounded");
var _diversity1RoundedDefault = parcelHelpers.interopDefault(_diversity1Rounded);
var _diversity1Sharp = require("./Diversity1Sharp");
var _diversity1SharpDefault = parcelHelpers.interopDefault(_diversity1Sharp);
var _diversity1TwoTone = require("./Diversity1TwoTone");
var _diversity1TwoToneDefault = parcelHelpers.interopDefault(_diversity1TwoTone);
var _diversity2 = require("./Diversity2");
var _diversity2Default = parcelHelpers.interopDefault(_diversity2);
var _diversity2Outlined = require("./Diversity2Outlined");
var _diversity2OutlinedDefault = parcelHelpers.interopDefault(_diversity2Outlined);
var _diversity2Rounded = require("./Diversity2Rounded");
var _diversity2RoundedDefault = parcelHelpers.interopDefault(_diversity2Rounded);
var _diversity2Sharp = require("./Diversity2Sharp");
var _diversity2SharpDefault = parcelHelpers.interopDefault(_diversity2Sharp);
var _diversity2TwoTone = require("./Diversity2TwoTone");
var _diversity2TwoToneDefault = parcelHelpers.interopDefault(_diversity2TwoTone);
var _diversity3 = require("./Diversity3");
var _diversity3Default = parcelHelpers.interopDefault(_diversity3);
var _diversity3Outlined = require("./Diversity3Outlined");
var _diversity3OutlinedDefault = parcelHelpers.interopDefault(_diversity3Outlined);
var _diversity3Rounded = require("./Diversity3Rounded");
var _diversity3RoundedDefault = parcelHelpers.interopDefault(_diversity3Rounded);
var _diversity3Sharp = require("./Diversity3Sharp");
var _diversity3SharpDefault = parcelHelpers.interopDefault(_diversity3Sharp);
var _diversity3TwoTone = require("./Diversity3TwoTone");
var _diversity3TwoToneDefault = parcelHelpers.interopDefault(_diversity3TwoTone);
var _dns = require("./Dns");
var _dnsDefault = parcelHelpers.interopDefault(_dns);
var _dnsOutlined = require("./DnsOutlined");
var _dnsOutlinedDefault = parcelHelpers.interopDefault(_dnsOutlined);
var _dnsRounded = require("./DnsRounded");
var _dnsRoundedDefault = parcelHelpers.interopDefault(_dnsRounded);
var _dnsSharp = require("./DnsSharp");
var _dnsSharpDefault = parcelHelpers.interopDefault(_dnsSharp);
var _dnsTwoTone = require("./DnsTwoTone");
var _dnsTwoToneDefault = parcelHelpers.interopDefault(_dnsTwoTone);
var _doDisturb = require("./DoDisturb");
var _doDisturbDefault = parcelHelpers.interopDefault(_doDisturb);
var _doDisturbAlt = require("./DoDisturbAlt");
var _doDisturbAltDefault = parcelHelpers.interopDefault(_doDisturbAlt);
var _doDisturbAltOutlined = require("./DoDisturbAltOutlined");
var _doDisturbAltOutlinedDefault = parcelHelpers.interopDefault(_doDisturbAltOutlined);
var _doDisturbAltRounded = require("./DoDisturbAltRounded");
var _doDisturbAltRoundedDefault = parcelHelpers.interopDefault(_doDisturbAltRounded);
var _doDisturbAltSharp = require("./DoDisturbAltSharp");
var _doDisturbAltSharpDefault = parcelHelpers.interopDefault(_doDisturbAltSharp);
var _doDisturbAltTwoTone = require("./DoDisturbAltTwoTone");
var _doDisturbAltTwoToneDefault = parcelHelpers.interopDefault(_doDisturbAltTwoTone);
var _doDisturbOff = require("./DoDisturbOff");
var _doDisturbOffDefault = parcelHelpers.interopDefault(_doDisturbOff);
var _doDisturbOffOutlined = require("./DoDisturbOffOutlined");
var _doDisturbOffOutlinedDefault = parcelHelpers.interopDefault(_doDisturbOffOutlined);
var _doDisturbOffRounded = require("./DoDisturbOffRounded");
var _doDisturbOffRoundedDefault = parcelHelpers.interopDefault(_doDisturbOffRounded);
var _doDisturbOffSharp = require("./DoDisturbOffSharp");
var _doDisturbOffSharpDefault = parcelHelpers.interopDefault(_doDisturbOffSharp);
var _doDisturbOffTwoTone = require("./DoDisturbOffTwoTone");
var _doDisturbOffTwoToneDefault = parcelHelpers.interopDefault(_doDisturbOffTwoTone);
var _doDisturbOn = require("./DoDisturbOn");
var _doDisturbOnDefault = parcelHelpers.interopDefault(_doDisturbOn);
var _doDisturbOnOutlined = require("./DoDisturbOnOutlined");
var _doDisturbOnOutlinedDefault = parcelHelpers.interopDefault(_doDisturbOnOutlined);
var _doDisturbOnRounded = require("./DoDisturbOnRounded");
var _doDisturbOnRoundedDefault = parcelHelpers.interopDefault(_doDisturbOnRounded);
var _doDisturbOnSharp = require("./DoDisturbOnSharp");
var _doDisturbOnSharpDefault = parcelHelpers.interopDefault(_doDisturbOnSharp);
var _doDisturbOnTwoTone = require("./DoDisturbOnTwoTone");
var _doDisturbOnTwoToneDefault = parcelHelpers.interopDefault(_doDisturbOnTwoTone);
var _doDisturbOutlined = require("./DoDisturbOutlined");
var _doDisturbOutlinedDefault = parcelHelpers.interopDefault(_doDisturbOutlined);
var _doDisturbRounded = require("./DoDisturbRounded");
var _doDisturbRoundedDefault = parcelHelpers.interopDefault(_doDisturbRounded);
var _doDisturbSharp = require("./DoDisturbSharp");
var _doDisturbSharpDefault = parcelHelpers.interopDefault(_doDisturbSharp);
var _doDisturbTwoTone = require("./DoDisturbTwoTone");
var _doDisturbTwoToneDefault = parcelHelpers.interopDefault(_doDisturbTwoTone);
var _doNotDisturb = require("./DoNotDisturb");
var _doNotDisturbDefault = parcelHelpers.interopDefault(_doNotDisturb);
var _doNotDisturbAlt = require("./DoNotDisturbAlt");
var _doNotDisturbAltDefault = parcelHelpers.interopDefault(_doNotDisturbAlt);
var _doNotDisturbAltOutlined = require("./DoNotDisturbAltOutlined");
var _doNotDisturbAltOutlinedDefault = parcelHelpers.interopDefault(_doNotDisturbAltOutlined);
var _doNotDisturbAltRounded = require("./DoNotDisturbAltRounded");
var _doNotDisturbAltRoundedDefault = parcelHelpers.interopDefault(_doNotDisturbAltRounded);
var _doNotDisturbAltSharp = require("./DoNotDisturbAltSharp");
var _doNotDisturbAltSharpDefault = parcelHelpers.interopDefault(_doNotDisturbAltSharp);
var _doNotDisturbAltTwoTone = require("./DoNotDisturbAltTwoTone");
var _doNotDisturbAltTwoToneDefault = parcelHelpers.interopDefault(_doNotDisturbAltTwoTone);
var _doNotDisturbOff = require("./DoNotDisturbOff");
var _doNotDisturbOffDefault = parcelHelpers.interopDefault(_doNotDisturbOff);
var _doNotDisturbOffOutlined = require("./DoNotDisturbOffOutlined");
var _doNotDisturbOffOutlinedDefault = parcelHelpers.interopDefault(_doNotDisturbOffOutlined);
var _doNotDisturbOffRounded = require("./DoNotDisturbOffRounded");
var _doNotDisturbOffRoundedDefault = parcelHelpers.interopDefault(_doNotDisturbOffRounded);
var _doNotDisturbOffSharp = require("./DoNotDisturbOffSharp");
var _doNotDisturbOffSharpDefault = parcelHelpers.interopDefault(_doNotDisturbOffSharp);
var _doNotDisturbOffTwoTone = require("./DoNotDisturbOffTwoTone");
var _doNotDisturbOffTwoToneDefault = parcelHelpers.interopDefault(_doNotDisturbOffTwoTone);
var _doNotDisturbOn = require("./DoNotDisturbOn");
var _doNotDisturbOnDefault = parcelHelpers.interopDefault(_doNotDisturbOn);
var _doNotDisturbOnOutlined = require("./DoNotDisturbOnOutlined");
var _doNotDisturbOnOutlinedDefault = parcelHelpers.interopDefault(_doNotDisturbOnOutlined);
var _doNotDisturbOnRounded = require("./DoNotDisturbOnRounded");
var _doNotDisturbOnRoundedDefault = parcelHelpers.interopDefault(_doNotDisturbOnRounded);
var _doNotDisturbOnSharp = require("./DoNotDisturbOnSharp");
var _doNotDisturbOnSharpDefault = parcelHelpers.interopDefault(_doNotDisturbOnSharp);
var _doNotDisturbOnTotalSilence = require("./DoNotDisturbOnTotalSilence");
var _doNotDisturbOnTotalSilenceDefault = parcelHelpers.interopDefault(_doNotDisturbOnTotalSilence);
var _doNotDisturbOnTotalSilenceOutlined = require("./DoNotDisturbOnTotalSilenceOutlined");
var _doNotDisturbOnTotalSilenceOutlinedDefault = parcelHelpers.interopDefault(_doNotDisturbOnTotalSilenceOutlined);
var _doNotDisturbOnTotalSilenceRounded = require("./DoNotDisturbOnTotalSilenceRounded");
var _doNotDisturbOnTotalSilenceRoundedDefault = parcelHelpers.interopDefault(_doNotDisturbOnTotalSilenceRounded);
var _doNotDisturbOnTotalSilenceSharp = require("./DoNotDisturbOnTotalSilenceSharp");
var _doNotDisturbOnTotalSilenceSharpDefault = parcelHelpers.interopDefault(_doNotDisturbOnTotalSilenceSharp);
var _doNotDisturbOnTotalSilenceTwoTone = require("./DoNotDisturbOnTotalSilenceTwoTone");
var _doNotDisturbOnTotalSilenceTwoToneDefault = parcelHelpers.interopDefault(_doNotDisturbOnTotalSilenceTwoTone);
var _doNotDisturbOnTwoTone = require("./DoNotDisturbOnTwoTone");
var _doNotDisturbOnTwoToneDefault = parcelHelpers.interopDefault(_doNotDisturbOnTwoTone);
var _doNotDisturbOutlined = require("./DoNotDisturbOutlined");
var _doNotDisturbOutlinedDefault = parcelHelpers.interopDefault(_doNotDisturbOutlined);
var _doNotDisturbRounded = require("./DoNotDisturbRounded");
var _doNotDisturbRoundedDefault = parcelHelpers.interopDefault(_doNotDisturbRounded);
var _doNotDisturbSharp = require("./DoNotDisturbSharp");
var _doNotDisturbSharpDefault = parcelHelpers.interopDefault(_doNotDisturbSharp);
var _doNotDisturbTwoTone = require("./DoNotDisturbTwoTone");
var _doNotDisturbTwoToneDefault = parcelHelpers.interopDefault(_doNotDisturbTwoTone);
var _doNotStep = require("./DoNotStep");
var _doNotStepDefault = parcelHelpers.interopDefault(_doNotStep);
var _doNotStepOutlined = require("./DoNotStepOutlined");
var _doNotStepOutlinedDefault = parcelHelpers.interopDefault(_doNotStepOutlined);
var _doNotStepRounded = require("./DoNotStepRounded");
var _doNotStepRoundedDefault = parcelHelpers.interopDefault(_doNotStepRounded);
var _doNotStepSharp = require("./DoNotStepSharp");
var _doNotStepSharpDefault = parcelHelpers.interopDefault(_doNotStepSharp);
var _doNotStepTwoTone = require("./DoNotStepTwoTone");
var _doNotStepTwoToneDefault = parcelHelpers.interopDefault(_doNotStepTwoTone);
var _doNotTouch = require("./DoNotTouch");
var _doNotTouchDefault = parcelHelpers.interopDefault(_doNotTouch);
var _doNotTouchOutlined = require("./DoNotTouchOutlined");
var _doNotTouchOutlinedDefault = parcelHelpers.interopDefault(_doNotTouchOutlined);
var _doNotTouchRounded = require("./DoNotTouchRounded");
var _doNotTouchRoundedDefault = parcelHelpers.interopDefault(_doNotTouchRounded);
var _doNotTouchSharp = require("./DoNotTouchSharp");
var _doNotTouchSharpDefault = parcelHelpers.interopDefault(_doNotTouchSharp);
var _doNotTouchTwoTone = require("./DoNotTouchTwoTone");
var _doNotTouchTwoToneDefault = parcelHelpers.interopDefault(_doNotTouchTwoTone);
var _dock = require("./Dock");
var _dockDefault = parcelHelpers.interopDefault(_dock);
var _dockOutlined = require("./DockOutlined");
var _dockOutlinedDefault = parcelHelpers.interopDefault(_dockOutlined);
var _dockRounded = require("./DockRounded");
var _dockRoundedDefault = parcelHelpers.interopDefault(_dockRounded);
var _dockSharp = require("./DockSharp");
var _dockSharpDefault = parcelHelpers.interopDefault(_dockSharp);
var _dockTwoTone = require("./DockTwoTone");
var _dockTwoToneDefault = parcelHelpers.interopDefault(_dockTwoTone);
var _documentScanner = require("./DocumentScanner");
var _documentScannerDefault = parcelHelpers.interopDefault(_documentScanner);
var _documentScannerOutlined = require("./DocumentScannerOutlined");
var _documentScannerOutlinedDefault = parcelHelpers.interopDefault(_documentScannerOutlined);
var _documentScannerRounded = require("./DocumentScannerRounded");
var _documentScannerRoundedDefault = parcelHelpers.interopDefault(_documentScannerRounded);
var _documentScannerSharp = require("./DocumentScannerSharp");
var _documentScannerSharpDefault = parcelHelpers.interopDefault(_documentScannerSharp);
var _documentScannerTwoTone = require("./DocumentScannerTwoTone");
var _documentScannerTwoToneDefault = parcelHelpers.interopDefault(_documentScannerTwoTone);
var _domain = require("./Domain");
var _domainDefault = parcelHelpers.interopDefault(_domain);
var _domainAdd = require("./DomainAdd");
var _domainAddDefault = parcelHelpers.interopDefault(_domainAdd);
var _domainAddOutlined = require("./DomainAddOutlined");
var _domainAddOutlinedDefault = parcelHelpers.interopDefault(_domainAddOutlined);
var _domainAddRounded = require("./DomainAddRounded");
var _domainAddRoundedDefault = parcelHelpers.interopDefault(_domainAddRounded);
var _domainAddSharp = require("./DomainAddSharp");
var _domainAddSharpDefault = parcelHelpers.interopDefault(_domainAddSharp);
var _domainAddTwoTone = require("./DomainAddTwoTone");
var _domainAddTwoToneDefault = parcelHelpers.interopDefault(_domainAddTwoTone);
var _domainDisabled = require("./DomainDisabled");
var _domainDisabledDefault = parcelHelpers.interopDefault(_domainDisabled);
var _domainDisabledOutlined = require("./DomainDisabledOutlined");
var _domainDisabledOutlinedDefault = parcelHelpers.interopDefault(_domainDisabledOutlined);
var _domainDisabledRounded = require("./DomainDisabledRounded");
var _domainDisabledRoundedDefault = parcelHelpers.interopDefault(_domainDisabledRounded);
var _domainDisabledSharp = require("./DomainDisabledSharp");
var _domainDisabledSharpDefault = parcelHelpers.interopDefault(_domainDisabledSharp);
var _domainDisabledTwoTone = require("./DomainDisabledTwoTone");
var _domainDisabledTwoToneDefault = parcelHelpers.interopDefault(_domainDisabledTwoTone);
var _domainOutlined = require("./DomainOutlined");
var _domainOutlinedDefault = parcelHelpers.interopDefault(_domainOutlined);
var _domainRounded = require("./DomainRounded");
var _domainRoundedDefault = parcelHelpers.interopDefault(_domainRounded);
var _domainSharp = require("./DomainSharp");
var _domainSharpDefault = parcelHelpers.interopDefault(_domainSharp);
var _domainTwoTone = require("./DomainTwoTone");
var _domainTwoToneDefault = parcelHelpers.interopDefault(_domainTwoTone);
var _domainVerification = require("./DomainVerification");
var _domainVerificationDefault = parcelHelpers.interopDefault(_domainVerification);
var _domainVerificationOutlined = require("./DomainVerificationOutlined");
var _domainVerificationOutlinedDefault = parcelHelpers.interopDefault(_domainVerificationOutlined);
var _domainVerificationRounded = require("./DomainVerificationRounded");
var _domainVerificationRoundedDefault = parcelHelpers.interopDefault(_domainVerificationRounded);
var _domainVerificationSharp = require("./DomainVerificationSharp");
var _domainVerificationSharpDefault = parcelHelpers.interopDefault(_domainVerificationSharp);
var _domainVerificationTwoTone = require("./DomainVerificationTwoTone");
var _domainVerificationTwoToneDefault = parcelHelpers.interopDefault(_domainVerificationTwoTone);
var _done = require("./Done");
var _doneDefault = parcelHelpers.interopDefault(_done);
var _doneAll = require("./DoneAll");
var _doneAllDefault = parcelHelpers.interopDefault(_doneAll);
var _doneAllOutlined = require("./DoneAllOutlined");
var _doneAllOutlinedDefault = parcelHelpers.interopDefault(_doneAllOutlined);
var _doneAllRounded = require("./DoneAllRounded");
var _doneAllRoundedDefault = parcelHelpers.interopDefault(_doneAllRounded);
var _doneAllSharp = require("./DoneAllSharp");
var _doneAllSharpDefault = parcelHelpers.interopDefault(_doneAllSharp);
var _doneAllTwoTone = require("./DoneAllTwoTone");
var _doneAllTwoToneDefault = parcelHelpers.interopDefault(_doneAllTwoTone);
var _doneOutline = require("./DoneOutline");
var _doneOutlineDefault = parcelHelpers.interopDefault(_doneOutline);
var _doneOutlineOutlined = require("./DoneOutlineOutlined");
var _doneOutlineOutlinedDefault = parcelHelpers.interopDefault(_doneOutlineOutlined);
var _doneOutlineRounded = require("./DoneOutlineRounded");
var _doneOutlineRoundedDefault = parcelHelpers.interopDefault(_doneOutlineRounded);
var _doneOutlineSharp = require("./DoneOutlineSharp");
var _doneOutlineSharpDefault = parcelHelpers.interopDefault(_doneOutlineSharp);
var _doneOutlineTwoTone = require("./DoneOutlineTwoTone");
var _doneOutlineTwoToneDefault = parcelHelpers.interopDefault(_doneOutlineTwoTone);
var _doneOutlined = require("./DoneOutlined");
var _doneOutlinedDefault = parcelHelpers.interopDefault(_doneOutlined);
var _doneRounded = require("./DoneRounded");
var _doneRoundedDefault = parcelHelpers.interopDefault(_doneRounded);
var _doneSharp = require("./DoneSharp");
var _doneSharpDefault = parcelHelpers.interopDefault(_doneSharp);
var _doneTwoTone = require("./DoneTwoTone");
var _doneTwoToneDefault = parcelHelpers.interopDefault(_doneTwoTone);
var _donutLarge = require("./DonutLarge");
var _donutLargeDefault = parcelHelpers.interopDefault(_donutLarge);
var _donutLargeOutlined = require("./DonutLargeOutlined");
var _donutLargeOutlinedDefault = parcelHelpers.interopDefault(_donutLargeOutlined);
var _donutLargeRounded = require("./DonutLargeRounded");
var _donutLargeRoundedDefault = parcelHelpers.interopDefault(_donutLargeRounded);
var _donutLargeSharp = require("./DonutLargeSharp");
var _donutLargeSharpDefault = parcelHelpers.interopDefault(_donutLargeSharp);
var _donutLargeTwoTone = require("./DonutLargeTwoTone");
var _donutLargeTwoToneDefault = parcelHelpers.interopDefault(_donutLargeTwoTone);
var _donutSmall = require("./DonutSmall");
var _donutSmallDefault = parcelHelpers.interopDefault(_donutSmall);
var _donutSmallOutlined = require("./DonutSmallOutlined");
var _donutSmallOutlinedDefault = parcelHelpers.interopDefault(_donutSmallOutlined);
var _donutSmallRounded = require("./DonutSmallRounded");
var _donutSmallRoundedDefault = parcelHelpers.interopDefault(_donutSmallRounded);
var _donutSmallSharp = require("./DonutSmallSharp");
var _donutSmallSharpDefault = parcelHelpers.interopDefault(_donutSmallSharp);
var _donutSmallTwoTone = require("./DonutSmallTwoTone");
var _donutSmallTwoToneDefault = parcelHelpers.interopDefault(_donutSmallTwoTone);
var _doorBack = require("./DoorBack");
var _doorBackDefault = parcelHelpers.interopDefault(_doorBack);
var _doorBackOutlined = require("./DoorBackOutlined");
var _doorBackOutlinedDefault = parcelHelpers.interopDefault(_doorBackOutlined);
var _doorBackRounded = require("./DoorBackRounded");
var _doorBackRoundedDefault = parcelHelpers.interopDefault(_doorBackRounded);
var _doorBackSharp = require("./DoorBackSharp");
var _doorBackSharpDefault = parcelHelpers.interopDefault(_doorBackSharp);
var _doorBackTwoTone = require("./DoorBackTwoTone");
var _doorBackTwoToneDefault = parcelHelpers.interopDefault(_doorBackTwoTone);
var _doorFront = require("./DoorFront");
var _doorFrontDefault = parcelHelpers.interopDefault(_doorFront);
var _doorFrontOutlined = require("./DoorFrontOutlined");
var _doorFrontOutlinedDefault = parcelHelpers.interopDefault(_doorFrontOutlined);
var _doorFrontRounded = require("./DoorFrontRounded");
var _doorFrontRoundedDefault = parcelHelpers.interopDefault(_doorFrontRounded);
var _doorFrontSharp = require("./DoorFrontSharp");
var _doorFrontSharpDefault = parcelHelpers.interopDefault(_doorFrontSharp);
var _doorFrontTwoTone = require("./DoorFrontTwoTone");
var _doorFrontTwoToneDefault = parcelHelpers.interopDefault(_doorFrontTwoTone);
var _doorSliding = require("./DoorSliding");
var _doorSlidingDefault = parcelHelpers.interopDefault(_doorSliding);
var _doorSlidingOutlined = require("./DoorSlidingOutlined");
var _doorSlidingOutlinedDefault = parcelHelpers.interopDefault(_doorSlidingOutlined);
var _doorSlidingRounded = require("./DoorSlidingRounded");
var _doorSlidingRoundedDefault = parcelHelpers.interopDefault(_doorSlidingRounded);
var _doorSlidingSharp = require("./DoorSlidingSharp");
var _doorSlidingSharpDefault = parcelHelpers.interopDefault(_doorSlidingSharp);
var _doorSlidingTwoTone = require("./DoorSlidingTwoTone");
var _doorSlidingTwoToneDefault = parcelHelpers.interopDefault(_doorSlidingTwoTone);
var _doorbell = require("./Doorbell");
var _doorbellDefault = parcelHelpers.interopDefault(_doorbell);
var _doorbellOutlined = require("./DoorbellOutlined");
var _doorbellOutlinedDefault = parcelHelpers.interopDefault(_doorbellOutlined);
var _doorbellRounded = require("./DoorbellRounded");
var _doorbellRoundedDefault = parcelHelpers.interopDefault(_doorbellRounded);
var _doorbellSharp = require("./DoorbellSharp");
var _doorbellSharpDefault = parcelHelpers.interopDefault(_doorbellSharp);
var _doorbellTwoTone = require("./DoorbellTwoTone");
var _doorbellTwoToneDefault = parcelHelpers.interopDefault(_doorbellTwoTone);
var _doubleArrow = require("./DoubleArrow");
var _doubleArrowDefault = parcelHelpers.interopDefault(_doubleArrow);
var _doubleArrowOutlined = require("./DoubleArrowOutlined");
var _doubleArrowOutlinedDefault = parcelHelpers.interopDefault(_doubleArrowOutlined);
var _doubleArrowRounded = require("./DoubleArrowRounded");
var _doubleArrowRoundedDefault = parcelHelpers.interopDefault(_doubleArrowRounded);
var _doubleArrowSharp = require("./DoubleArrowSharp");
var _doubleArrowSharpDefault = parcelHelpers.interopDefault(_doubleArrowSharp);
var _doubleArrowTwoTone = require("./DoubleArrowTwoTone");
var _doubleArrowTwoToneDefault = parcelHelpers.interopDefault(_doubleArrowTwoTone);
var _downhillSkiing = require("./DownhillSkiing");
var _downhillSkiingDefault = parcelHelpers.interopDefault(_downhillSkiing);
var _downhillSkiingOutlined = require("./DownhillSkiingOutlined");
var _downhillSkiingOutlinedDefault = parcelHelpers.interopDefault(_downhillSkiingOutlined);
var _downhillSkiingRounded = require("./DownhillSkiingRounded");
var _downhillSkiingRoundedDefault = parcelHelpers.interopDefault(_downhillSkiingRounded);
var _downhillSkiingSharp = require("./DownhillSkiingSharp");
var _downhillSkiingSharpDefault = parcelHelpers.interopDefault(_downhillSkiingSharp);
var _downhillSkiingTwoTone = require("./DownhillSkiingTwoTone");
var _downhillSkiingTwoToneDefault = parcelHelpers.interopDefault(_downhillSkiingTwoTone);
var _download = require("./Download");
var _downloadDefault = parcelHelpers.interopDefault(_download);
var _downloadDone = require("./DownloadDone");
var _downloadDoneDefault = parcelHelpers.interopDefault(_downloadDone);
var _downloadDoneOutlined = require("./DownloadDoneOutlined");
var _downloadDoneOutlinedDefault = parcelHelpers.interopDefault(_downloadDoneOutlined);
var _downloadDoneRounded = require("./DownloadDoneRounded");
var _downloadDoneRoundedDefault = parcelHelpers.interopDefault(_downloadDoneRounded);
var _downloadDoneSharp = require("./DownloadDoneSharp");
var _downloadDoneSharpDefault = parcelHelpers.interopDefault(_downloadDoneSharp);
var _downloadDoneTwoTone = require("./DownloadDoneTwoTone");
var _downloadDoneTwoToneDefault = parcelHelpers.interopDefault(_downloadDoneTwoTone);
var _downloadForOffline = require("./DownloadForOffline");
var _downloadForOfflineDefault = parcelHelpers.interopDefault(_downloadForOffline);
var _downloadForOfflineOutlined = require("./DownloadForOfflineOutlined");
var _downloadForOfflineOutlinedDefault = parcelHelpers.interopDefault(_downloadForOfflineOutlined);
var _downloadForOfflineRounded = require("./DownloadForOfflineRounded");
var _downloadForOfflineRoundedDefault = parcelHelpers.interopDefault(_downloadForOfflineRounded);
var _downloadForOfflineSharp = require("./DownloadForOfflineSharp");
var _downloadForOfflineSharpDefault = parcelHelpers.interopDefault(_downloadForOfflineSharp);
var _downloadForOfflineTwoTone = require("./DownloadForOfflineTwoTone");
var _downloadForOfflineTwoToneDefault = parcelHelpers.interopDefault(_downloadForOfflineTwoTone);
var _downloadOutlined = require("./DownloadOutlined");
var _downloadOutlinedDefault = parcelHelpers.interopDefault(_downloadOutlined);
var _downloadRounded = require("./DownloadRounded");
var _downloadRoundedDefault = parcelHelpers.interopDefault(_downloadRounded);
var _downloadSharp = require("./DownloadSharp");
var _downloadSharpDefault = parcelHelpers.interopDefault(_downloadSharp);
var _downloadTwoTone = require("./DownloadTwoTone");
var _downloadTwoToneDefault = parcelHelpers.interopDefault(_downloadTwoTone);
var _downloading = require("./Downloading");
var _downloadingDefault = parcelHelpers.interopDefault(_downloading);
var _downloadingOutlined = require("./DownloadingOutlined");
var _downloadingOutlinedDefault = parcelHelpers.interopDefault(_downloadingOutlined);
var _downloadingRounded = require("./DownloadingRounded");
var _downloadingRoundedDefault = parcelHelpers.interopDefault(_downloadingRounded);
var _downloadingSharp = require("./DownloadingSharp");
var _downloadingSharpDefault = parcelHelpers.interopDefault(_downloadingSharp);
var _downloadingTwoTone = require("./DownloadingTwoTone");
var _downloadingTwoToneDefault = parcelHelpers.interopDefault(_downloadingTwoTone);
var _drafts = require("./Drafts");
var _draftsDefault = parcelHelpers.interopDefault(_drafts);
var _draftsOutlined = require("./DraftsOutlined");
var _draftsOutlinedDefault = parcelHelpers.interopDefault(_draftsOutlined);
var _draftsRounded = require("./DraftsRounded");
var _draftsRoundedDefault = parcelHelpers.interopDefault(_draftsRounded);
var _draftsSharp = require("./DraftsSharp");
var _draftsSharpDefault = parcelHelpers.interopDefault(_draftsSharp);
var _draftsTwoTone = require("./DraftsTwoTone");
var _draftsTwoToneDefault = parcelHelpers.interopDefault(_draftsTwoTone);
var _dragHandle = require("./DragHandle");
var _dragHandleDefault = parcelHelpers.interopDefault(_dragHandle);
var _dragHandleOutlined = require("./DragHandleOutlined");
var _dragHandleOutlinedDefault = parcelHelpers.interopDefault(_dragHandleOutlined);
var _dragHandleRounded = require("./DragHandleRounded");
var _dragHandleRoundedDefault = parcelHelpers.interopDefault(_dragHandleRounded);
var _dragHandleSharp = require("./DragHandleSharp");
var _dragHandleSharpDefault = parcelHelpers.interopDefault(_dragHandleSharp);
var _dragHandleTwoTone = require("./DragHandleTwoTone");
var _dragHandleTwoToneDefault = parcelHelpers.interopDefault(_dragHandleTwoTone);
var _dragIndicator = require("./DragIndicator");
var _dragIndicatorDefault = parcelHelpers.interopDefault(_dragIndicator);
var _dragIndicatorOutlined = require("./DragIndicatorOutlined");
var _dragIndicatorOutlinedDefault = parcelHelpers.interopDefault(_dragIndicatorOutlined);
var _dragIndicatorRounded = require("./DragIndicatorRounded");
var _dragIndicatorRoundedDefault = parcelHelpers.interopDefault(_dragIndicatorRounded);
var _dragIndicatorSharp = require("./DragIndicatorSharp");
var _dragIndicatorSharpDefault = parcelHelpers.interopDefault(_dragIndicatorSharp);
var _dragIndicatorTwoTone = require("./DragIndicatorTwoTone");
var _dragIndicatorTwoToneDefault = parcelHelpers.interopDefault(_dragIndicatorTwoTone);
var _draw = require("./Draw");
var _drawDefault = parcelHelpers.interopDefault(_draw);
var _drawOutlined = require("./DrawOutlined");
var _drawOutlinedDefault = parcelHelpers.interopDefault(_drawOutlined);
var _drawRounded = require("./DrawRounded");
var _drawRoundedDefault = parcelHelpers.interopDefault(_drawRounded);
var _drawSharp = require("./DrawSharp");
var _drawSharpDefault = parcelHelpers.interopDefault(_drawSharp);
var _drawTwoTone = require("./DrawTwoTone");
var _drawTwoToneDefault = parcelHelpers.interopDefault(_drawTwoTone);
var _driveEta = require("./DriveEta");
var _driveEtaDefault = parcelHelpers.interopDefault(_driveEta);
var _driveEtaOutlined = require("./DriveEtaOutlined");
var _driveEtaOutlinedDefault = parcelHelpers.interopDefault(_driveEtaOutlined);
var _driveEtaRounded = require("./DriveEtaRounded");
var _driveEtaRoundedDefault = parcelHelpers.interopDefault(_driveEtaRounded);
var _driveEtaSharp = require("./DriveEtaSharp");
var _driveEtaSharpDefault = parcelHelpers.interopDefault(_driveEtaSharp);
var _driveEtaTwoTone = require("./DriveEtaTwoTone");
var _driveEtaTwoToneDefault = parcelHelpers.interopDefault(_driveEtaTwoTone);
var _driveFileMove = require("./DriveFileMove");
var _driveFileMoveDefault = parcelHelpers.interopDefault(_driveFileMove);
var _driveFileMoveOutlined = require("./DriveFileMoveOutlined");
var _driveFileMoveOutlinedDefault = parcelHelpers.interopDefault(_driveFileMoveOutlined);
var _driveFileMoveRounded = require("./DriveFileMoveRounded");
var _driveFileMoveRoundedDefault = parcelHelpers.interopDefault(_driveFileMoveRounded);
var _driveFileMoveSharp = require("./DriveFileMoveSharp");
var _driveFileMoveSharpDefault = parcelHelpers.interopDefault(_driveFileMoveSharp);
var _driveFileMoveTwoTone = require("./DriveFileMoveTwoTone");
var _driveFileMoveTwoToneDefault = parcelHelpers.interopDefault(_driveFileMoveTwoTone);
var _driveFileRenameOutline = require("./DriveFileRenameOutline");
var _driveFileRenameOutlineDefault = parcelHelpers.interopDefault(_driveFileRenameOutline);
var _driveFileRenameOutlineOutlined = require("./DriveFileRenameOutlineOutlined");
var _driveFileRenameOutlineOutlinedDefault = parcelHelpers.interopDefault(_driveFileRenameOutlineOutlined);
var _driveFileRenameOutlineRounded = require("./DriveFileRenameOutlineRounded");
var _driveFileRenameOutlineRoundedDefault = parcelHelpers.interopDefault(_driveFileRenameOutlineRounded);
var _driveFileRenameOutlineSharp = require("./DriveFileRenameOutlineSharp");
var _driveFileRenameOutlineSharpDefault = parcelHelpers.interopDefault(_driveFileRenameOutlineSharp);
var _driveFileRenameOutlineTwoTone = require("./DriveFileRenameOutlineTwoTone");
var _driveFileRenameOutlineTwoToneDefault = parcelHelpers.interopDefault(_driveFileRenameOutlineTwoTone);
var _driveFolderUpload = require("./DriveFolderUpload");
var _driveFolderUploadDefault = parcelHelpers.interopDefault(_driveFolderUpload);
var _driveFolderUploadOutlined = require("./DriveFolderUploadOutlined");
var _driveFolderUploadOutlinedDefault = parcelHelpers.interopDefault(_driveFolderUploadOutlined);
var _driveFolderUploadRounded = require("./DriveFolderUploadRounded");
var _driveFolderUploadRoundedDefault = parcelHelpers.interopDefault(_driveFolderUploadRounded);
var _driveFolderUploadSharp = require("./DriveFolderUploadSharp");
var _driveFolderUploadSharpDefault = parcelHelpers.interopDefault(_driveFolderUploadSharp);
var _driveFolderUploadTwoTone = require("./DriveFolderUploadTwoTone");
var _driveFolderUploadTwoToneDefault = parcelHelpers.interopDefault(_driveFolderUploadTwoTone);
var _dry = require("./Dry");
var _dryDefault = parcelHelpers.interopDefault(_dry);
var _dryCleaning = require("./DryCleaning");
var _dryCleaningDefault = parcelHelpers.interopDefault(_dryCleaning);
var _dryCleaningOutlined = require("./DryCleaningOutlined");
var _dryCleaningOutlinedDefault = parcelHelpers.interopDefault(_dryCleaningOutlined);
var _dryCleaningRounded = require("./DryCleaningRounded");
var _dryCleaningRoundedDefault = parcelHelpers.interopDefault(_dryCleaningRounded);
var _dryCleaningSharp = require("./DryCleaningSharp");
var _dryCleaningSharpDefault = parcelHelpers.interopDefault(_dryCleaningSharp);
var _dryCleaningTwoTone = require("./DryCleaningTwoTone");
var _dryCleaningTwoToneDefault = parcelHelpers.interopDefault(_dryCleaningTwoTone);
var _dryOutlined = require("./DryOutlined");
var _dryOutlinedDefault = parcelHelpers.interopDefault(_dryOutlined);
var _dryRounded = require("./DryRounded");
var _dryRoundedDefault = parcelHelpers.interopDefault(_dryRounded);
var _drySharp = require("./DrySharp");
var _drySharpDefault = parcelHelpers.interopDefault(_drySharp);
var _dryTwoTone = require("./DryTwoTone");
var _dryTwoToneDefault = parcelHelpers.interopDefault(_dryTwoTone);
var _duo = require("./Duo");
var _duoDefault = parcelHelpers.interopDefault(_duo);
var _duoOutlined = require("./DuoOutlined");
var _duoOutlinedDefault = parcelHelpers.interopDefault(_duoOutlined);
var _duoRounded = require("./DuoRounded");
var _duoRoundedDefault = parcelHelpers.interopDefault(_duoRounded);
var _duoSharp = require("./DuoSharp");
var _duoSharpDefault = parcelHelpers.interopDefault(_duoSharp);
var _duoTwoTone = require("./DuoTwoTone");
var _duoTwoToneDefault = parcelHelpers.interopDefault(_duoTwoTone);
var _dvr = require("./Dvr");
var _dvrDefault = parcelHelpers.interopDefault(_dvr);
var _dvrOutlined = require("./DvrOutlined");
var _dvrOutlinedDefault = parcelHelpers.interopDefault(_dvrOutlined);
var _dvrRounded = require("./DvrRounded");
var _dvrRoundedDefault = parcelHelpers.interopDefault(_dvrRounded);
var _dvrSharp = require("./DvrSharp");
var _dvrSharpDefault = parcelHelpers.interopDefault(_dvrSharp);
var _dvrTwoTone = require("./DvrTwoTone");
var _dvrTwoToneDefault = parcelHelpers.interopDefault(_dvrTwoTone);
var _dynamicFeed = require("./DynamicFeed");
var _dynamicFeedDefault = parcelHelpers.interopDefault(_dynamicFeed);
var _dynamicFeedOutlined = require("./DynamicFeedOutlined");
var _dynamicFeedOutlinedDefault = parcelHelpers.interopDefault(_dynamicFeedOutlined);
var _dynamicFeedRounded = require("./DynamicFeedRounded");
var _dynamicFeedRoundedDefault = parcelHelpers.interopDefault(_dynamicFeedRounded);
var _dynamicFeedSharp = require("./DynamicFeedSharp");
var _dynamicFeedSharpDefault = parcelHelpers.interopDefault(_dynamicFeedSharp);
var _dynamicFeedTwoTone = require("./DynamicFeedTwoTone");
var _dynamicFeedTwoToneDefault = parcelHelpers.interopDefault(_dynamicFeedTwoTone);
var _dynamicForm = require("./DynamicForm");
var _dynamicFormDefault = parcelHelpers.interopDefault(_dynamicForm);
var _dynamicFormOutlined = require("./DynamicFormOutlined");
var _dynamicFormOutlinedDefault = parcelHelpers.interopDefault(_dynamicFormOutlined);
var _dynamicFormRounded = require("./DynamicFormRounded");
var _dynamicFormRoundedDefault = parcelHelpers.interopDefault(_dynamicFormRounded);
var _dynamicFormSharp = require("./DynamicFormSharp");
var _dynamicFormSharpDefault = parcelHelpers.interopDefault(_dynamicFormSharp);
var _dynamicFormTwoTone = require("./DynamicFormTwoTone");
var _dynamicFormTwoToneDefault = parcelHelpers.interopDefault(_dynamicFormTwoTone);
var _emobiledata = require("./EMobiledata");
var _emobiledataDefault = parcelHelpers.interopDefault(_emobiledata);
var _emobiledataOutlined = require("./EMobiledataOutlined");
var _emobiledataOutlinedDefault = parcelHelpers.interopDefault(_emobiledataOutlined);
var _emobiledataRounded = require("./EMobiledataRounded");
var _emobiledataRoundedDefault = parcelHelpers.interopDefault(_emobiledataRounded);
var _emobiledataSharp = require("./EMobiledataSharp");
var _emobiledataSharpDefault = parcelHelpers.interopDefault(_emobiledataSharp);
var _emobiledataTwoTone = require("./EMobiledataTwoTone");
var _emobiledataTwoToneDefault = parcelHelpers.interopDefault(_emobiledataTwoTone);
var _earbuds = require("./Earbuds");
var _earbudsDefault = parcelHelpers.interopDefault(_earbuds);
var _earbudsBattery = require("./EarbudsBattery");
var _earbudsBatteryDefault = parcelHelpers.interopDefault(_earbudsBattery);
var _earbudsBatteryOutlined = require("./EarbudsBatteryOutlined");
var _earbudsBatteryOutlinedDefault = parcelHelpers.interopDefault(_earbudsBatteryOutlined);
var _earbudsBatteryRounded = require("./EarbudsBatteryRounded");
var _earbudsBatteryRoundedDefault = parcelHelpers.interopDefault(_earbudsBatteryRounded);
var _earbudsBatterySharp = require("./EarbudsBatterySharp");
var _earbudsBatterySharpDefault = parcelHelpers.interopDefault(_earbudsBatterySharp);
var _earbudsBatteryTwoTone = require("./EarbudsBatteryTwoTone");
var _earbudsBatteryTwoToneDefault = parcelHelpers.interopDefault(_earbudsBatteryTwoTone);
var _earbudsOutlined = require("./EarbudsOutlined");
var _earbudsOutlinedDefault = parcelHelpers.interopDefault(_earbudsOutlined);
var _earbudsRounded = require("./EarbudsRounded");
var _earbudsRoundedDefault = parcelHelpers.interopDefault(_earbudsRounded);
var _earbudsSharp = require("./EarbudsSharp");
var _earbudsSharpDefault = parcelHelpers.interopDefault(_earbudsSharp);
var _earbudsTwoTone = require("./EarbudsTwoTone");
var _earbudsTwoToneDefault = parcelHelpers.interopDefault(_earbudsTwoTone);
var _east = require("./East");
var _eastDefault = parcelHelpers.interopDefault(_east);
var _eastOutlined = require("./EastOutlined");
var _eastOutlinedDefault = parcelHelpers.interopDefault(_eastOutlined);
var _eastRounded = require("./EastRounded");
var _eastRoundedDefault = parcelHelpers.interopDefault(_eastRounded);
var _eastSharp = require("./EastSharp");
var _eastSharpDefault = parcelHelpers.interopDefault(_eastSharp);
var _eastTwoTone = require("./EastTwoTone");
var _eastTwoToneDefault = parcelHelpers.interopDefault(_eastTwoTone);
var _edgesensorHigh = require("./EdgesensorHigh");
var _edgesensorHighDefault = parcelHelpers.interopDefault(_edgesensorHigh);
var _edgesensorHighOutlined = require("./EdgesensorHighOutlined");
var _edgesensorHighOutlinedDefault = parcelHelpers.interopDefault(_edgesensorHighOutlined);
var _edgesensorHighRounded = require("./EdgesensorHighRounded");
var _edgesensorHighRoundedDefault = parcelHelpers.interopDefault(_edgesensorHighRounded);
var _edgesensorHighSharp = require("./EdgesensorHighSharp");
var _edgesensorHighSharpDefault = parcelHelpers.interopDefault(_edgesensorHighSharp);
var _edgesensorHighTwoTone = require("./EdgesensorHighTwoTone");
var _edgesensorHighTwoToneDefault = parcelHelpers.interopDefault(_edgesensorHighTwoTone);
var _edgesensorLow = require("./EdgesensorLow");
var _edgesensorLowDefault = parcelHelpers.interopDefault(_edgesensorLow);
var _edgesensorLowOutlined = require("./EdgesensorLowOutlined");
var _edgesensorLowOutlinedDefault = parcelHelpers.interopDefault(_edgesensorLowOutlined);
var _edgesensorLowRounded = require("./EdgesensorLowRounded");
var _edgesensorLowRoundedDefault = parcelHelpers.interopDefault(_edgesensorLowRounded);
var _edgesensorLowSharp = require("./EdgesensorLowSharp");
var _edgesensorLowSharpDefault = parcelHelpers.interopDefault(_edgesensorLowSharp);
var _edgesensorLowTwoTone = require("./EdgesensorLowTwoTone");
var _edgesensorLowTwoToneDefault = parcelHelpers.interopDefault(_edgesensorLowTwoTone);
var _edit = require("./Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _editAttributes = require("./EditAttributes");
var _editAttributesDefault = parcelHelpers.interopDefault(_editAttributes);
var _editAttributesOutlined = require("./EditAttributesOutlined");
var _editAttributesOutlinedDefault = parcelHelpers.interopDefault(_editAttributesOutlined);
var _editAttributesRounded = require("./EditAttributesRounded");
var _editAttributesRoundedDefault = parcelHelpers.interopDefault(_editAttributesRounded);
var _editAttributesSharp = require("./EditAttributesSharp");
var _editAttributesSharpDefault = parcelHelpers.interopDefault(_editAttributesSharp);
var _editAttributesTwoTone = require("./EditAttributesTwoTone");
var _editAttributesTwoToneDefault = parcelHelpers.interopDefault(_editAttributesTwoTone);
var _editCalendar = require("./EditCalendar");
var _editCalendarDefault = parcelHelpers.interopDefault(_editCalendar);
var _editCalendarOutlined = require("./EditCalendarOutlined");
var _editCalendarOutlinedDefault = parcelHelpers.interopDefault(_editCalendarOutlined);
var _editCalendarRounded = require("./EditCalendarRounded");
var _editCalendarRoundedDefault = parcelHelpers.interopDefault(_editCalendarRounded);
var _editCalendarSharp = require("./EditCalendarSharp");
var _editCalendarSharpDefault = parcelHelpers.interopDefault(_editCalendarSharp);
var _editCalendarTwoTone = require("./EditCalendarTwoTone");
var _editCalendarTwoToneDefault = parcelHelpers.interopDefault(_editCalendarTwoTone);
var _editLocation = require("./EditLocation");
var _editLocationDefault = parcelHelpers.interopDefault(_editLocation);
var _editLocationAlt = require("./EditLocationAlt");
var _editLocationAltDefault = parcelHelpers.interopDefault(_editLocationAlt);
var _editLocationAltOutlined = require("./EditLocationAltOutlined");
var _editLocationAltOutlinedDefault = parcelHelpers.interopDefault(_editLocationAltOutlined);
var _editLocationAltRounded = require("./EditLocationAltRounded");
var _editLocationAltRoundedDefault = parcelHelpers.interopDefault(_editLocationAltRounded);
var _editLocationAltSharp = require("./EditLocationAltSharp");
var _editLocationAltSharpDefault = parcelHelpers.interopDefault(_editLocationAltSharp);
var _editLocationAltTwoTone = require("./EditLocationAltTwoTone");
var _editLocationAltTwoToneDefault = parcelHelpers.interopDefault(_editLocationAltTwoTone);
var _editLocationOutlined = require("./EditLocationOutlined");
var _editLocationOutlinedDefault = parcelHelpers.interopDefault(_editLocationOutlined);
var _editLocationRounded = require("./EditLocationRounded");
var _editLocationRoundedDefault = parcelHelpers.interopDefault(_editLocationRounded);
var _editLocationSharp = require("./EditLocationSharp");
var _editLocationSharpDefault = parcelHelpers.interopDefault(_editLocationSharp);
var _editLocationTwoTone = require("./EditLocationTwoTone");
var _editLocationTwoToneDefault = parcelHelpers.interopDefault(_editLocationTwoTone);
var _editNote = require("./EditNote");
var _editNoteDefault = parcelHelpers.interopDefault(_editNote);
var _editNoteOutlined = require("./EditNoteOutlined");
var _editNoteOutlinedDefault = parcelHelpers.interopDefault(_editNoteOutlined);
var _editNoteRounded = require("./EditNoteRounded");
var _editNoteRoundedDefault = parcelHelpers.interopDefault(_editNoteRounded);
var _editNoteSharp = require("./EditNoteSharp");
var _editNoteSharpDefault = parcelHelpers.interopDefault(_editNoteSharp);
var _editNoteTwoTone = require("./EditNoteTwoTone");
var _editNoteTwoToneDefault = parcelHelpers.interopDefault(_editNoteTwoTone);
var _editNotifications = require("./EditNotifications");
var _editNotificationsDefault = parcelHelpers.interopDefault(_editNotifications);
var _editNotificationsOutlined = require("./EditNotificationsOutlined");
var _editNotificationsOutlinedDefault = parcelHelpers.interopDefault(_editNotificationsOutlined);
var _editNotificationsRounded = require("./EditNotificationsRounded");
var _editNotificationsRoundedDefault = parcelHelpers.interopDefault(_editNotificationsRounded);
var _editNotificationsSharp = require("./EditNotificationsSharp");
var _editNotificationsSharpDefault = parcelHelpers.interopDefault(_editNotificationsSharp);
var _editNotificationsTwoTone = require("./EditNotificationsTwoTone");
var _editNotificationsTwoToneDefault = parcelHelpers.interopDefault(_editNotificationsTwoTone);
var _editOff = require("./EditOff");
var _editOffDefault = parcelHelpers.interopDefault(_editOff);
var _editOffOutlined = require("./EditOffOutlined");
var _editOffOutlinedDefault = parcelHelpers.interopDefault(_editOffOutlined);
var _editOffRounded = require("./EditOffRounded");
var _editOffRoundedDefault = parcelHelpers.interopDefault(_editOffRounded);
var _editOffSharp = require("./EditOffSharp");
var _editOffSharpDefault = parcelHelpers.interopDefault(_editOffSharp);
var _editOffTwoTone = require("./EditOffTwoTone");
var _editOffTwoToneDefault = parcelHelpers.interopDefault(_editOffTwoTone);
var _editOutlined = require("./EditOutlined");
var _editOutlinedDefault = parcelHelpers.interopDefault(_editOutlined);
var _editRoad = require("./EditRoad");
var _editRoadDefault = parcelHelpers.interopDefault(_editRoad);
var _editRoadOutlined = require("./EditRoadOutlined");
var _editRoadOutlinedDefault = parcelHelpers.interopDefault(_editRoadOutlined);
var _editRoadRounded = require("./EditRoadRounded");
var _editRoadRoundedDefault = parcelHelpers.interopDefault(_editRoadRounded);
var _editRoadSharp = require("./EditRoadSharp");
var _editRoadSharpDefault = parcelHelpers.interopDefault(_editRoadSharp);
var _editRoadTwoTone = require("./EditRoadTwoTone");
var _editRoadTwoToneDefault = parcelHelpers.interopDefault(_editRoadTwoTone);
var _editRounded = require("./EditRounded");
var _editRoundedDefault = parcelHelpers.interopDefault(_editRounded);
var _editSharp = require("./EditSharp");
var _editSharpDefault = parcelHelpers.interopDefault(_editSharp);
var _editTwoTone = require("./EditTwoTone");
var _editTwoToneDefault = parcelHelpers.interopDefault(_editTwoTone);
var _egg = require("./Egg");
var _eggDefault = parcelHelpers.interopDefault(_egg);
var _eggAlt = require("./EggAlt");
var _eggAltDefault = parcelHelpers.interopDefault(_eggAlt);
var _eggAltOutlined = require("./EggAltOutlined");
var _eggAltOutlinedDefault = parcelHelpers.interopDefault(_eggAltOutlined);
var _eggAltRounded = require("./EggAltRounded");
var _eggAltRoundedDefault = parcelHelpers.interopDefault(_eggAltRounded);
var _eggAltSharp = require("./EggAltSharp");
var _eggAltSharpDefault = parcelHelpers.interopDefault(_eggAltSharp);
var _eggAltTwoTone = require("./EggAltTwoTone");
var _eggAltTwoToneDefault = parcelHelpers.interopDefault(_eggAltTwoTone);
var _eggOutlined = require("./EggOutlined");
var _eggOutlinedDefault = parcelHelpers.interopDefault(_eggOutlined);
var _eggRounded = require("./EggRounded");
var _eggRoundedDefault = parcelHelpers.interopDefault(_eggRounded);
var _eggSharp = require("./EggSharp");
var _eggSharpDefault = parcelHelpers.interopDefault(_eggSharp);
var _eggTwoTone = require("./EggTwoTone");
var _eggTwoToneDefault = parcelHelpers.interopDefault(_eggTwoTone);
var _eightK = require("./EightK");
var _eightKDefault = parcelHelpers.interopDefault(_eightK);
var _eightKOutlined = require("./EightKOutlined");
var _eightKOutlinedDefault = parcelHelpers.interopDefault(_eightKOutlined);
var _eightKPlus = require("./EightKPlus");
var _eightKPlusDefault = parcelHelpers.interopDefault(_eightKPlus);
var _eightKPlusOutlined = require("./EightKPlusOutlined");
var _eightKPlusOutlinedDefault = parcelHelpers.interopDefault(_eightKPlusOutlined);
var _eightKPlusRounded = require("./EightKPlusRounded");
var _eightKPlusRoundedDefault = parcelHelpers.interopDefault(_eightKPlusRounded);
var _eightKPlusSharp = require("./EightKPlusSharp");
var _eightKPlusSharpDefault = parcelHelpers.interopDefault(_eightKPlusSharp);
var _eightKPlusTwoTone = require("./EightKPlusTwoTone");
var _eightKPlusTwoToneDefault = parcelHelpers.interopDefault(_eightKPlusTwoTone);
var _eightKRounded = require("./EightKRounded");
var _eightKRoundedDefault = parcelHelpers.interopDefault(_eightKRounded);
var _eightKSharp = require("./EightKSharp");
var _eightKSharpDefault = parcelHelpers.interopDefault(_eightKSharp);
var _eightKTwoTone = require("./EightKTwoTone");
var _eightKTwoToneDefault = parcelHelpers.interopDefault(_eightKTwoTone);
var _eightMp = require("./EightMp");
var _eightMpDefault = parcelHelpers.interopDefault(_eightMp);
var _eightMpOutlined = require("./EightMpOutlined");
var _eightMpOutlinedDefault = parcelHelpers.interopDefault(_eightMpOutlined);
var _eightMpRounded = require("./EightMpRounded");
var _eightMpRoundedDefault = parcelHelpers.interopDefault(_eightMpRounded);
var _eightMpSharp = require("./EightMpSharp");
var _eightMpSharpDefault = parcelHelpers.interopDefault(_eightMpSharp);
var _eightMpTwoTone = require("./EightMpTwoTone");
var _eightMpTwoToneDefault = parcelHelpers.interopDefault(_eightMpTwoTone);
var _eighteenMp = require("./EighteenMp");
var _eighteenMpDefault = parcelHelpers.interopDefault(_eighteenMp);
var _eighteenMpOutlined = require("./EighteenMpOutlined");
var _eighteenMpOutlinedDefault = parcelHelpers.interopDefault(_eighteenMpOutlined);
var _eighteenMpRounded = require("./EighteenMpRounded");
var _eighteenMpRoundedDefault = parcelHelpers.interopDefault(_eighteenMpRounded);
var _eighteenMpSharp = require("./EighteenMpSharp");
var _eighteenMpSharpDefault = parcelHelpers.interopDefault(_eighteenMpSharp);
var _eighteenMpTwoTone = require("./EighteenMpTwoTone");
var _eighteenMpTwoToneDefault = parcelHelpers.interopDefault(_eighteenMpTwoTone);
var _eighteenUpRating = require("./EighteenUpRating");
var _eighteenUpRatingDefault = parcelHelpers.interopDefault(_eighteenUpRating);
var _eighteenUpRatingOutlined = require("./EighteenUpRatingOutlined");
var _eighteenUpRatingOutlinedDefault = parcelHelpers.interopDefault(_eighteenUpRatingOutlined);
var _eighteenUpRatingRounded = require("./EighteenUpRatingRounded");
var _eighteenUpRatingRoundedDefault = parcelHelpers.interopDefault(_eighteenUpRatingRounded);
var _eighteenUpRatingSharp = require("./EighteenUpRatingSharp");
var _eighteenUpRatingSharpDefault = parcelHelpers.interopDefault(_eighteenUpRatingSharp);
var _eighteenUpRatingTwoTone = require("./EighteenUpRatingTwoTone");
var _eighteenUpRatingTwoToneDefault = parcelHelpers.interopDefault(_eighteenUpRatingTwoTone);
var _eightteenMp = require("./EightteenMp");
var _eightteenMpDefault = parcelHelpers.interopDefault(_eightteenMp);
var _eightteenMpOutlined = require("./EightteenMpOutlined");
var _eightteenMpOutlinedDefault = parcelHelpers.interopDefault(_eightteenMpOutlined);
var _eightteenMpRounded = require("./EightteenMpRounded");
var _eightteenMpRoundedDefault = parcelHelpers.interopDefault(_eightteenMpRounded);
var _eightteenMpSharp = require("./EightteenMpSharp");
var _eightteenMpSharpDefault = parcelHelpers.interopDefault(_eightteenMpSharp);
var _eightteenMpTwoTone = require("./EightteenMpTwoTone");
var _eightteenMpTwoToneDefault = parcelHelpers.interopDefault(_eightteenMpTwoTone);
var _eject = require("./Eject");
var _ejectDefault = parcelHelpers.interopDefault(_eject);
var _ejectOutlined = require("./EjectOutlined");
var _ejectOutlinedDefault = parcelHelpers.interopDefault(_ejectOutlined);
var _ejectRounded = require("./EjectRounded");
var _ejectRoundedDefault = parcelHelpers.interopDefault(_ejectRounded);
var _ejectSharp = require("./EjectSharp");
var _ejectSharpDefault = parcelHelpers.interopDefault(_ejectSharp);
var _ejectTwoTone = require("./EjectTwoTone");
var _ejectTwoToneDefault = parcelHelpers.interopDefault(_ejectTwoTone);
var _elderly = require("./Elderly");
var _elderlyDefault = parcelHelpers.interopDefault(_elderly);
var _elderlyOutlined = require("./ElderlyOutlined");
var _elderlyOutlinedDefault = parcelHelpers.interopDefault(_elderlyOutlined);
var _elderlyRounded = require("./ElderlyRounded");
var _elderlyRoundedDefault = parcelHelpers.interopDefault(_elderlyRounded);
var _elderlySharp = require("./ElderlySharp");
var _elderlySharpDefault = parcelHelpers.interopDefault(_elderlySharp);
var _elderlyTwoTone = require("./ElderlyTwoTone");
var _elderlyTwoToneDefault = parcelHelpers.interopDefault(_elderlyTwoTone);
var _elderlyWoman = require("./ElderlyWoman");
var _elderlyWomanDefault = parcelHelpers.interopDefault(_elderlyWoman);
var _elderlyWomanOutlined = require("./ElderlyWomanOutlined");
var _elderlyWomanOutlinedDefault = parcelHelpers.interopDefault(_elderlyWomanOutlined);
var _elderlyWomanRounded = require("./ElderlyWomanRounded");
var _elderlyWomanRoundedDefault = parcelHelpers.interopDefault(_elderlyWomanRounded);
var _elderlyWomanSharp = require("./ElderlyWomanSharp");
var _elderlyWomanSharpDefault = parcelHelpers.interopDefault(_elderlyWomanSharp);
var _elderlyWomanTwoTone = require("./ElderlyWomanTwoTone");
var _elderlyWomanTwoToneDefault = parcelHelpers.interopDefault(_elderlyWomanTwoTone);
var _electricBike = require("./ElectricBike");
var _electricBikeDefault = parcelHelpers.interopDefault(_electricBike);
var _electricBikeOutlined = require("./ElectricBikeOutlined");
var _electricBikeOutlinedDefault = parcelHelpers.interopDefault(_electricBikeOutlined);
var _electricBikeRounded = require("./ElectricBikeRounded");
var _electricBikeRoundedDefault = parcelHelpers.interopDefault(_electricBikeRounded);
var _electricBikeSharp = require("./ElectricBikeSharp");
var _electricBikeSharpDefault = parcelHelpers.interopDefault(_electricBikeSharp);
var _electricBikeTwoTone = require("./ElectricBikeTwoTone");
var _electricBikeTwoToneDefault = parcelHelpers.interopDefault(_electricBikeTwoTone);
var _electricBolt = require("./ElectricBolt");
var _electricBoltDefault = parcelHelpers.interopDefault(_electricBolt);
var _electricBoltOutlined = require("./ElectricBoltOutlined");
var _electricBoltOutlinedDefault = parcelHelpers.interopDefault(_electricBoltOutlined);
var _electricBoltRounded = require("./ElectricBoltRounded");
var _electricBoltRoundedDefault = parcelHelpers.interopDefault(_electricBoltRounded);
var _electricBoltSharp = require("./ElectricBoltSharp");
var _electricBoltSharpDefault = parcelHelpers.interopDefault(_electricBoltSharp);
var _electricBoltTwoTone = require("./ElectricBoltTwoTone");
var _electricBoltTwoToneDefault = parcelHelpers.interopDefault(_electricBoltTwoTone);
var _electricCar = require("./ElectricCar");
var _electricCarDefault = parcelHelpers.interopDefault(_electricCar);
var _electricCarOutlined = require("./ElectricCarOutlined");
var _electricCarOutlinedDefault = parcelHelpers.interopDefault(_electricCarOutlined);
var _electricCarRounded = require("./ElectricCarRounded");
var _electricCarRoundedDefault = parcelHelpers.interopDefault(_electricCarRounded);
var _electricCarSharp = require("./ElectricCarSharp");
var _electricCarSharpDefault = parcelHelpers.interopDefault(_electricCarSharp);
var _electricCarTwoTone = require("./ElectricCarTwoTone");
var _electricCarTwoToneDefault = parcelHelpers.interopDefault(_electricCarTwoTone);
var _electricMeter = require("./ElectricMeter");
var _electricMeterDefault = parcelHelpers.interopDefault(_electricMeter);
var _electricMeterOutlined = require("./ElectricMeterOutlined");
var _electricMeterOutlinedDefault = parcelHelpers.interopDefault(_electricMeterOutlined);
var _electricMeterRounded = require("./ElectricMeterRounded");
var _electricMeterRoundedDefault = parcelHelpers.interopDefault(_electricMeterRounded);
var _electricMeterSharp = require("./ElectricMeterSharp");
var _electricMeterSharpDefault = parcelHelpers.interopDefault(_electricMeterSharp);
var _electricMeterTwoTone = require("./ElectricMeterTwoTone");
var _electricMeterTwoToneDefault = parcelHelpers.interopDefault(_electricMeterTwoTone);
var _electricMoped = require("./ElectricMoped");
var _electricMopedDefault = parcelHelpers.interopDefault(_electricMoped);
var _electricMopedOutlined = require("./ElectricMopedOutlined");
var _electricMopedOutlinedDefault = parcelHelpers.interopDefault(_electricMopedOutlined);
var _electricMopedRounded = require("./ElectricMopedRounded");
var _electricMopedRoundedDefault = parcelHelpers.interopDefault(_electricMopedRounded);
var _electricMopedSharp = require("./ElectricMopedSharp");
var _electricMopedSharpDefault = parcelHelpers.interopDefault(_electricMopedSharp);
var _electricMopedTwoTone = require("./ElectricMopedTwoTone");
var _electricMopedTwoToneDefault = parcelHelpers.interopDefault(_electricMopedTwoTone);
var _electricRickshaw = require("./ElectricRickshaw");
var _electricRickshawDefault = parcelHelpers.interopDefault(_electricRickshaw);
var _electricRickshawOutlined = require("./ElectricRickshawOutlined");
var _electricRickshawOutlinedDefault = parcelHelpers.interopDefault(_electricRickshawOutlined);
var _electricRickshawRounded = require("./ElectricRickshawRounded");
var _electricRickshawRoundedDefault = parcelHelpers.interopDefault(_electricRickshawRounded);
var _electricRickshawSharp = require("./ElectricRickshawSharp");
var _electricRickshawSharpDefault = parcelHelpers.interopDefault(_electricRickshawSharp);
var _electricRickshawTwoTone = require("./ElectricRickshawTwoTone");
var _electricRickshawTwoToneDefault = parcelHelpers.interopDefault(_electricRickshawTwoTone);
var _electricScooter = require("./ElectricScooter");
var _electricScooterDefault = parcelHelpers.interopDefault(_electricScooter);
var _electricScooterOutlined = require("./ElectricScooterOutlined");
var _electricScooterOutlinedDefault = parcelHelpers.interopDefault(_electricScooterOutlined);
var _electricScooterRounded = require("./ElectricScooterRounded");
var _electricScooterRoundedDefault = parcelHelpers.interopDefault(_electricScooterRounded);
var _electricScooterSharp = require("./ElectricScooterSharp");
var _electricScooterSharpDefault = parcelHelpers.interopDefault(_electricScooterSharp);
var _electricScooterTwoTone = require("./ElectricScooterTwoTone");
var _electricScooterTwoToneDefault = parcelHelpers.interopDefault(_electricScooterTwoTone);
var _electricalServices = require("./ElectricalServices");
var _electricalServicesDefault = parcelHelpers.interopDefault(_electricalServices);
var _electricalServicesOutlined = require("./ElectricalServicesOutlined");
var _electricalServicesOutlinedDefault = parcelHelpers.interopDefault(_electricalServicesOutlined);
var _electricalServicesRounded = require("./ElectricalServicesRounded");
var _electricalServicesRoundedDefault = parcelHelpers.interopDefault(_electricalServicesRounded);
var _electricalServicesSharp = require("./ElectricalServicesSharp");
var _electricalServicesSharpDefault = parcelHelpers.interopDefault(_electricalServicesSharp);
var _electricalServicesTwoTone = require("./ElectricalServicesTwoTone");
var _electricalServicesTwoToneDefault = parcelHelpers.interopDefault(_electricalServicesTwoTone);
var _elevator = require("./Elevator");
var _elevatorDefault = parcelHelpers.interopDefault(_elevator);
var _elevatorOutlined = require("./ElevatorOutlined");
var _elevatorOutlinedDefault = parcelHelpers.interopDefault(_elevatorOutlined);
var _elevatorRounded = require("./ElevatorRounded");
var _elevatorRoundedDefault = parcelHelpers.interopDefault(_elevatorRounded);
var _elevatorSharp = require("./ElevatorSharp");
var _elevatorSharpDefault = parcelHelpers.interopDefault(_elevatorSharp);
var _elevatorTwoTone = require("./ElevatorTwoTone");
var _elevatorTwoToneDefault = parcelHelpers.interopDefault(_elevatorTwoTone);
var _elevenMp = require("./ElevenMp");
var _elevenMpDefault = parcelHelpers.interopDefault(_elevenMp);
var _elevenMpOutlined = require("./ElevenMpOutlined");
var _elevenMpOutlinedDefault = parcelHelpers.interopDefault(_elevenMpOutlined);
var _elevenMpRounded = require("./ElevenMpRounded");
var _elevenMpRoundedDefault = parcelHelpers.interopDefault(_elevenMpRounded);
var _elevenMpSharp = require("./ElevenMpSharp");
var _elevenMpSharpDefault = parcelHelpers.interopDefault(_elevenMpSharp);
var _elevenMpTwoTone = require("./ElevenMpTwoTone");
var _elevenMpTwoToneDefault = parcelHelpers.interopDefault(_elevenMpTwoTone);
var _email = require("./Email");
var _emailDefault = parcelHelpers.interopDefault(_email);
var _emailOutlined = require("./EmailOutlined");
var _emailOutlinedDefault = parcelHelpers.interopDefault(_emailOutlined);
var _emailRounded = require("./EmailRounded");
var _emailRoundedDefault = parcelHelpers.interopDefault(_emailRounded);
var _emailSharp = require("./EmailSharp");
var _emailSharpDefault = parcelHelpers.interopDefault(_emailSharp);
var _emailTwoTone = require("./EmailTwoTone");
var _emailTwoToneDefault = parcelHelpers.interopDefault(_emailTwoTone);
var _emergencyRecording = require("./EmergencyRecording");
var _emergencyRecordingDefault = parcelHelpers.interopDefault(_emergencyRecording);
var _emergencyRecordingOutlined = require("./EmergencyRecordingOutlined");
var _emergencyRecordingOutlinedDefault = parcelHelpers.interopDefault(_emergencyRecordingOutlined);
var _emergencyRecordingRounded = require("./EmergencyRecordingRounded");
var _emergencyRecordingRoundedDefault = parcelHelpers.interopDefault(_emergencyRecordingRounded);
var _emergencyRecordingSharp = require("./EmergencyRecordingSharp");
var _emergencyRecordingSharpDefault = parcelHelpers.interopDefault(_emergencyRecordingSharp);
var _emergencyRecordingTwoTone = require("./EmergencyRecordingTwoTone");
var _emergencyRecordingTwoToneDefault = parcelHelpers.interopDefault(_emergencyRecordingTwoTone);
var _emergencyShare = require("./EmergencyShare");
var _emergencyShareDefault = parcelHelpers.interopDefault(_emergencyShare);
var _emergencyShareOutlined = require("./EmergencyShareOutlined");
var _emergencyShareOutlinedDefault = parcelHelpers.interopDefault(_emergencyShareOutlined);
var _emergencyShareRounded = require("./EmergencyShareRounded");
var _emergencyShareRoundedDefault = parcelHelpers.interopDefault(_emergencyShareRounded);
var _emergencyShareSharp = require("./EmergencyShareSharp");
var _emergencyShareSharpDefault = parcelHelpers.interopDefault(_emergencyShareSharp);
var _emergencyShareTwoTone = require("./EmergencyShareTwoTone");
var _emergencyShareTwoToneDefault = parcelHelpers.interopDefault(_emergencyShareTwoTone);
var _emojiEmotions = require("./EmojiEmotions");
var _emojiEmotionsDefault = parcelHelpers.interopDefault(_emojiEmotions);
var _emojiEmotionsOutlined = require("./EmojiEmotionsOutlined");
var _emojiEmotionsOutlinedDefault = parcelHelpers.interopDefault(_emojiEmotionsOutlined);
var _emojiEmotionsRounded = require("./EmojiEmotionsRounded");
var _emojiEmotionsRoundedDefault = parcelHelpers.interopDefault(_emojiEmotionsRounded);
var _emojiEmotionsSharp = require("./EmojiEmotionsSharp");
var _emojiEmotionsSharpDefault = parcelHelpers.interopDefault(_emojiEmotionsSharp);
var _emojiEmotionsTwoTone = require("./EmojiEmotionsTwoTone");
var _emojiEmotionsTwoToneDefault = parcelHelpers.interopDefault(_emojiEmotionsTwoTone);
var _emojiEvents = require("./EmojiEvents");
var _emojiEventsDefault = parcelHelpers.interopDefault(_emojiEvents);
var _emojiEventsOutlined = require("./EmojiEventsOutlined");
var _emojiEventsOutlinedDefault = parcelHelpers.interopDefault(_emojiEventsOutlined);
var _emojiEventsRounded = require("./EmojiEventsRounded");
var _emojiEventsRoundedDefault = parcelHelpers.interopDefault(_emojiEventsRounded);
var _emojiEventsSharp = require("./EmojiEventsSharp");
var _emojiEventsSharpDefault = parcelHelpers.interopDefault(_emojiEventsSharp);
var _emojiEventsTwoTone = require("./EmojiEventsTwoTone");
var _emojiEventsTwoToneDefault = parcelHelpers.interopDefault(_emojiEventsTwoTone);
var _emojiFlags = require("./EmojiFlags");
var _emojiFlagsDefault = parcelHelpers.interopDefault(_emojiFlags);
var _emojiFlagsOutlined = require("./EmojiFlagsOutlined");
var _emojiFlagsOutlinedDefault = parcelHelpers.interopDefault(_emojiFlagsOutlined);
var _emojiFlagsRounded = require("./EmojiFlagsRounded");
var _emojiFlagsRoundedDefault = parcelHelpers.interopDefault(_emojiFlagsRounded);
var _emojiFlagsSharp = require("./EmojiFlagsSharp");
var _emojiFlagsSharpDefault = parcelHelpers.interopDefault(_emojiFlagsSharp);
var _emojiFlagsTwoTone = require("./EmojiFlagsTwoTone");
var _emojiFlagsTwoToneDefault = parcelHelpers.interopDefault(_emojiFlagsTwoTone);
var _emojiFoodBeverage = require("./EmojiFoodBeverage");
var _emojiFoodBeverageDefault = parcelHelpers.interopDefault(_emojiFoodBeverage);
var _emojiFoodBeverageOutlined = require("./EmojiFoodBeverageOutlined");
var _emojiFoodBeverageOutlinedDefault = parcelHelpers.interopDefault(_emojiFoodBeverageOutlined);
var _emojiFoodBeverageRounded = require("./EmojiFoodBeverageRounded");
var _emojiFoodBeverageRoundedDefault = parcelHelpers.interopDefault(_emojiFoodBeverageRounded);
var _emojiFoodBeverageSharp = require("./EmojiFoodBeverageSharp");
var _emojiFoodBeverageSharpDefault = parcelHelpers.interopDefault(_emojiFoodBeverageSharp);
var _emojiFoodBeverageTwoTone = require("./EmojiFoodBeverageTwoTone");
var _emojiFoodBeverageTwoToneDefault = parcelHelpers.interopDefault(_emojiFoodBeverageTwoTone);
var _emojiNature = require("./EmojiNature");
var _emojiNatureDefault = parcelHelpers.interopDefault(_emojiNature);
var _emojiNatureOutlined = require("./EmojiNatureOutlined");
var _emojiNatureOutlinedDefault = parcelHelpers.interopDefault(_emojiNatureOutlined);
var _emojiNatureRounded = require("./EmojiNatureRounded");
var _emojiNatureRoundedDefault = parcelHelpers.interopDefault(_emojiNatureRounded);
var _emojiNatureSharp = require("./EmojiNatureSharp");
var _emojiNatureSharpDefault = parcelHelpers.interopDefault(_emojiNatureSharp);
var _emojiNatureTwoTone = require("./EmojiNatureTwoTone");
var _emojiNatureTwoToneDefault = parcelHelpers.interopDefault(_emojiNatureTwoTone);
var _emojiObjects = require("./EmojiObjects");
var _emojiObjectsDefault = parcelHelpers.interopDefault(_emojiObjects);
var _emojiObjectsOutlined = require("./EmojiObjectsOutlined");
var _emojiObjectsOutlinedDefault = parcelHelpers.interopDefault(_emojiObjectsOutlined);
var _emojiObjectsRounded = require("./EmojiObjectsRounded");
var _emojiObjectsRoundedDefault = parcelHelpers.interopDefault(_emojiObjectsRounded);
var _emojiObjectsSharp = require("./EmojiObjectsSharp");
var _emojiObjectsSharpDefault = parcelHelpers.interopDefault(_emojiObjectsSharp);
var _emojiObjectsTwoTone = require("./EmojiObjectsTwoTone");
var _emojiObjectsTwoToneDefault = parcelHelpers.interopDefault(_emojiObjectsTwoTone);
var _emojiPeople = require("./EmojiPeople");
var _emojiPeopleDefault = parcelHelpers.interopDefault(_emojiPeople);
var _emojiPeopleOutlined = require("./EmojiPeopleOutlined");
var _emojiPeopleOutlinedDefault = parcelHelpers.interopDefault(_emojiPeopleOutlined);
var _emojiPeopleRounded = require("./EmojiPeopleRounded");
var _emojiPeopleRoundedDefault = parcelHelpers.interopDefault(_emojiPeopleRounded);
var _emojiPeopleSharp = require("./EmojiPeopleSharp");
var _emojiPeopleSharpDefault = parcelHelpers.interopDefault(_emojiPeopleSharp);
var _emojiPeopleTwoTone = require("./EmojiPeopleTwoTone");
var _emojiPeopleTwoToneDefault = parcelHelpers.interopDefault(_emojiPeopleTwoTone);
var _emojiSymbols = require("./EmojiSymbols");
var _emojiSymbolsDefault = parcelHelpers.interopDefault(_emojiSymbols);
var _emojiSymbolsOutlined = require("./EmojiSymbolsOutlined");
var _emojiSymbolsOutlinedDefault = parcelHelpers.interopDefault(_emojiSymbolsOutlined);
var _emojiSymbolsRounded = require("./EmojiSymbolsRounded");
var _emojiSymbolsRoundedDefault = parcelHelpers.interopDefault(_emojiSymbolsRounded);
var _emojiSymbolsSharp = require("./EmojiSymbolsSharp");
var _emojiSymbolsSharpDefault = parcelHelpers.interopDefault(_emojiSymbolsSharp);
var _emojiSymbolsTwoTone = require("./EmojiSymbolsTwoTone");
var _emojiSymbolsTwoToneDefault = parcelHelpers.interopDefault(_emojiSymbolsTwoTone);
var _emojiTransportation = require("./EmojiTransportation");
var _emojiTransportationDefault = parcelHelpers.interopDefault(_emojiTransportation);
var _emojiTransportationOutlined = require("./EmojiTransportationOutlined");
var _emojiTransportationOutlinedDefault = parcelHelpers.interopDefault(_emojiTransportationOutlined);
var _emojiTransportationRounded = require("./EmojiTransportationRounded");
var _emojiTransportationRoundedDefault = parcelHelpers.interopDefault(_emojiTransportationRounded);
var _emojiTransportationSharp = require("./EmojiTransportationSharp");
var _emojiTransportationSharpDefault = parcelHelpers.interopDefault(_emojiTransportationSharp);
var _emojiTransportationTwoTone = require("./EmojiTransportationTwoTone");
var _emojiTransportationTwoToneDefault = parcelHelpers.interopDefault(_emojiTransportationTwoTone);
var _energySavingsLeaf = require("./EnergySavingsLeaf");
var _energySavingsLeafDefault = parcelHelpers.interopDefault(_energySavingsLeaf);
var _energySavingsLeafOutlined = require("./EnergySavingsLeafOutlined");
var _energySavingsLeafOutlinedDefault = parcelHelpers.interopDefault(_energySavingsLeafOutlined);
var _energySavingsLeafRounded = require("./EnergySavingsLeafRounded");
var _energySavingsLeafRoundedDefault = parcelHelpers.interopDefault(_energySavingsLeafRounded);
var _energySavingsLeafSharp = require("./EnergySavingsLeafSharp");
var _energySavingsLeafSharpDefault = parcelHelpers.interopDefault(_energySavingsLeafSharp);
var _energySavingsLeafTwoTone = require("./EnergySavingsLeafTwoTone");
var _energySavingsLeafTwoToneDefault = parcelHelpers.interopDefault(_energySavingsLeafTwoTone);
var _engineering = require("./Engineering");
var _engineeringDefault = parcelHelpers.interopDefault(_engineering);
var _engineeringOutlined = require("./EngineeringOutlined");
var _engineeringOutlinedDefault = parcelHelpers.interopDefault(_engineeringOutlined);
var _engineeringRounded = require("./EngineeringRounded");
var _engineeringRoundedDefault = parcelHelpers.interopDefault(_engineeringRounded);
var _engineeringSharp = require("./EngineeringSharp");
var _engineeringSharpDefault = parcelHelpers.interopDefault(_engineeringSharp);
var _engineeringTwoTone = require("./EngineeringTwoTone");
var _engineeringTwoToneDefault = parcelHelpers.interopDefault(_engineeringTwoTone);
var _enhancedEncryption = require("./EnhancedEncryption");
var _enhancedEncryptionDefault = parcelHelpers.interopDefault(_enhancedEncryption);
var _enhancedEncryptionOutlined = require("./EnhancedEncryptionOutlined");
var _enhancedEncryptionOutlinedDefault = parcelHelpers.interopDefault(_enhancedEncryptionOutlined);
var _enhancedEncryptionRounded = require("./EnhancedEncryptionRounded");
var _enhancedEncryptionRoundedDefault = parcelHelpers.interopDefault(_enhancedEncryptionRounded);
var _enhancedEncryptionSharp = require("./EnhancedEncryptionSharp");
var _enhancedEncryptionSharpDefault = parcelHelpers.interopDefault(_enhancedEncryptionSharp);
var _enhancedEncryptionTwoTone = require("./EnhancedEncryptionTwoTone");
var _enhancedEncryptionTwoToneDefault = parcelHelpers.interopDefault(_enhancedEncryptionTwoTone);
var _equalizer = require("./Equalizer");
var _equalizerDefault = parcelHelpers.interopDefault(_equalizer);
var _equalizerOutlined = require("./EqualizerOutlined");
var _equalizerOutlinedDefault = parcelHelpers.interopDefault(_equalizerOutlined);
var _equalizerRounded = require("./EqualizerRounded");
var _equalizerRoundedDefault = parcelHelpers.interopDefault(_equalizerRounded);
var _equalizerSharp = require("./EqualizerSharp");
var _equalizerSharpDefault = parcelHelpers.interopDefault(_equalizerSharp);
var _equalizerTwoTone = require("./EqualizerTwoTone");
var _equalizerTwoToneDefault = parcelHelpers.interopDefault(_equalizerTwoTone);
var _error = require("./Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _errorOutline = require("./ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _errorOutlineOutlined = require("./ErrorOutlineOutlined");
var _errorOutlineOutlinedDefault = parcelHelpers.interopDefault(_errorOutlineOutlined);
var _errorOutlineRounded = require("./ErrorOutlineRounded");
var _errorOutlineRoundedDefault = parcelHelpers.interopDefault(_errorOutlineRounded);
var _errorOutlineSharp = require("./ErrorOutlineSharp");
var _errorOutlineSharpDefault = parcelHelpers.interopDefault(_errorOutlineSharp);
var _errorOutlineTwoTone = require("./ErrorOutlineTwoTone");
var _errorOutlineTwoToneDefault = parcelHelpers.interopDefault(_errorOutlineTwoTone);
var _errorOutlined = require("./ErrorOutlined");
var _errorOutlinedDefault = parcelHelpers.interopDefault(_errorOutlined);
var _errorRounded = require("./ErrorRounded");
var _errorRoundedDefault = parcelHelpers.interopDefault(_errorRounded);
var _errorSharp = require("./ErrorSharp");
var _errorSharpDefault = parcelHelpers.interopDefault(_errorSharp);
var _errorTwoTone = require("./ErrorTwoTone");
var _errorTwoToneDefault = parcelHelpers.interopDefault(_errorTwoTone);
var _escalator = require("./Escalator");
var _escalatorDefault = parcelHelpers.interopDefault(_escalator);
var _escalatorOutlined = require("./EscalatorOutlined");
var _escalatorOutlinedDefault = parcelHelpers.interopDefault(_escalatorOutlined);
var _escalatorRounded = require("./EscalatorRounded");
var _escalatorRoundedDefault = parcelHelpers.interopDefault(_escalatorRounded);
var _escalatorSharp = require("./EscalatorSharp");
var _escalatorSharpDefault = parcelHelpers.interopDefault(_escalatorSharp);
var _escalatorTwoTone = require("./EscalatorTwoTone");
var _escalatorTwoToneDefault = parcelHelpers.interopDefault(_escalatorTwoTone);
var _escalatorWarning = require("./EscalatorWarning");
var _escalatorWarningDefault = parcelHelpers.interopDefault(_escalatorWarning);
var _escalatorWarningOutlined = require("./EscalatorWarningOutlined");
var _escalatorWarningOutlinedDefault = parcelHelpers.interopDefault(_escalatorWarningOutlined);
var _escalatorWarningRounded = require("./EscalatorWarningRounded");
var _escalatorWarningRoundedDefault = parcelHelpers.interopDefault(_escalatorWarningRounded);
var _escalatorWarningSharp = require("./EscalatorWarningSharp");
var _escalatorWarningSharpDefault = parcelHelpers.interopDefault(_escalatorWarningSharp);
var _escalatorWarningTwoTone = require("./EscalatorWarningTwoTone");
var _escalatorWarningTwoToneDefault = parcelHelpers.interopDefault(_escalatorWarningTwoTone);
var _euro = require("./Euro");
var _euroDefault = parcelHelpers.interopDefault(_euro);
var _euroOutlined = require("./EuroOutlined");
var _euroOutlinedDefault = parcelHelpers.interopDefault(_euroOutlined);
var _euroRounded = require("./EuroRounded");
var _euroRoundedDefault = parcelHelpers.interopDefault(_euroRounded);
var _euroSharp = require("./EuroSharp");
var _euroSharpDefault = parcelHelpers.interopDefault(_euroSharp);
var _euroSymbol = require("./EuroSymbol");
var _euroSymbolDefault = parcelHelpers.interopDefault(_euroSymbol);
var _euroSymbolOutlined = require("./EuroSymbolOutlined");
var _euroSymbolOutlinedDefault = parcelHelpers.interopDefault(_euroSymbolOutlined);
var _euroSymbolRounded = require("./EuroSymbolRounded");
var _euroSymbolRoundedDefault = parcelHelpers.interopDefault(_euroSymbolRounded);
var _euroSymbolSharp = require("./EuroSymbolSharp");
var _euroSymbolSharpDefault = parcelHelpers.interopDefault(_euroSymbolSharp);
var _euroSymbolTwoTone = require("./EuroSymbolTwoTone");
var _euroSymbolTwoToneDefault = parcelHelpers.interopDefault(_euroSymbolTwoTone);
var _euroTwoTone = require("./EuroTwoTone");
var _euroTwoToneDefault = parcelHelpers.interopDefault(_euroTwoTone);
var _evStation = require("./EvStation");
var _evStationDefault = parcelHelpers.interopDefault(_evStation);
var _evStationOutlined = require("./EvStationOutlined");
var _evStationOutlinedDefault = parcelHelpers.interopDefault(_evStationOutlined);
var _evStationRounded = require("./EvStationRounded");
var _evStationRoundedDefault = parcelHelpers.interopDefault(_evStationRounded);
var _evStationSharp = require("./EvStationSharp");
var _evStationSharpDefault = parcelHelpers.interopDefault(_evStationSharp);
var _evStationTwoTone = require("./EvStationTwoTone");
var _evStationTwoToneDefault = parcelHelpers.interopDefault(_evStationTwoTone);
var _event = require("./Event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _eventAvailable = require("./EventAvailable");
var _eventAvailableDefault = parcelHelpers.interopDefault(_eventAvailable);
var _eventAvailableOutlined = require("./EventAvailableOutlined");
var _eventAvailableOutlinedDefault = parcelHelpers.interopDefault(_eventAvailableOutlined);
var _eventAvailableRounded = require("./EventAvailableRounded");
var _eventAvailableRoundedDefault = parcelHelpers.interopDefault(_eventAvailableRounded);
var _eventAvailableSharp = require("./EventAvailableSharp");
var _eventAvailableSharpDefault = parcelHelpers.interopDefault(_eventAvailableSharp);
var _eventAvailableTwoTone = require("./EventAvailableTwoTone");
var _eventAvailableTwoToneDefault = parcelHelpers.interopDefault(_eventAvailableTwoTone);
var _eventBusy = require("./EventBusy");
var _eventBusyDefault = parcelHelpers.interopDefault(_eventBusy);
var _eventBusyOutlined = require("./EventBusyOutlined");
var _eventBusyOutlinedDefault = parcelHelpers.interopDefault(_eventBusyOutlined);
var _eventBusyRounded = require("./EventBusyRounded");
var _eventBusyRoundedDefault = parcelHelpers.interopDefault(_eventBusyRounded);
var _eventBusySharp = require("./EventBusySharp");
var _eventBusySharpDefault = parcelHelpers.interopDefault(_eventBusySharp);
var _eventBusyTwoTone = require("./EventBusyTwoTone");
var _eventBusyTwoToneDefault = parcelHelpers.interopDefault(_eventBusyTwoTone);
var _eventNote = require("./EventNote");
var _eventNoteDefault = parcelHelpers.interopDefault(_eventNote);
var _eventNoteOutlined = require("./EventNoteOutlined");
var _eventNoteOutlinedDefault = parcelHelpers.interopDefault(_eventNoteOutlined);
var _eventNoteRounded = require("./EventNoteRounded");
var _eventNoteRoundedDefault = parcelHelpers.interopDefault(_eventNoteRounded);
var _eventNoteSharp = require("./EventNoteSharp");
var _eventNoteSharpDefault = parcelHelpers.interopDefault(_eventNoteSharp);
var _eventNoteTwoTone = require("./EventNoteTwoTone");
var _eventNoteTwoToneDefault = parcelHelpers.interopDefault(_eventNoteTwoTone);
var _eventOutlined = require("./EventOutlined");
var _eventOutlinedDefault = parcelHelpers.interopDefault(_eventOutlined);
var _eventRepeat = require("./EventRepeat");
var _eventRepeatDefault = parcelHelpers.interopDefault(_eventRepeat);
var _eventRepeatOutlined = require("./EventRepeatOutlined");
var _eventRepeatOutlinedDefault = parcelHelpers.interopDefault(_eventRepeatOutlined);
var _eventRepeatRounded = require("./EventRepeatRounded");
var _eventRepeatRoundedDefault = parcelHelpers.interopDefault(_eventRepeatRounded);
var _eventRepeatSharp = require("./EventRepeatSharp");
var _eventRepeatSharpDefault = parcelHelpers.interopDefault(_eventRepeatSharp);
var _eventRepeatTwoTone = require("./EventRepeatTwoTone");
var _eventRepeatTwoToneDefault = parcelHelpers.interopDefault(_eventRepeatTwoTone);
var _eventRounded = require("./EventRounded");
var _eventRoundedDefault = parcelHelpers.interopDefault(_eventRounded);
var _eventSeat = require("./EventSeat");
var _eventSeatDefault = parcelHelpers.interopDefault(_eventSeat);
var _eventSeatOutlined = require("./EventSeatOutlined");
var _eventSeatOutlinedDefault = parcelHelpers.interopDefault(_eventSeatOutlined);
var _eventSeatRounded = require("./EventSeatRounded");
var _eventSeatRoundedDefault = parcelHelpers.interopDefault(_eventSeatRounded);
var _eventSeatSharp = require("./EventSeatSharp");
var _eventSeatSharpDefault = parcelHelpers.interopDefault(_eventSeatSharp);
var _eventSeatTwoTone = require("./EventSeatTwoTone");
var _eventSeatTwoToneDefault = parcelHelpers.interopDefault(_eventSeatTwoTone);
var _eventSharp = require("./EventSharp");
var _eventSharpDefault = parcelHelpers.interopDefault(_eventSharp);
var _eventTwoTone = require("./EventTwoTone");
var _eventTwoToneDefault = parcelHelpers.interopDefault(_eventTwoTone);
var _exitToApp = require("./ExitToApp");
var _exitToAppDefault = parcelHelpers.interopDefault(_exitToApp);
var _exitToAppOutlined = require("./ExitToAppOutlined");
var _exitToAppOutlinedDefault = parcelHelpers.interopDefault(_exitToAppOutlined);
var _exitToAppRounded = require("./ExitToAppRounded");
var _exitToAppRoundedDefault = parcelHelpers.interopDefault(_exitToAppRounded);
var _exitToAppSharp = require("./ExitToAppSharp");
var _exitToAppSharpDefault = parcelHelpers.interopDefault(_exitToAppSharp);
var _exitToAppTwoTone = require("./ExitToAppTwoTone");
var _exitToAppTwoToneDefault = parcelHelpers.interopDefault(_exitToAppTwoTone);
var _expand = require("./Expand");
var _expandDefault = parcelHelpers.interopDefault(_expand);
var _expandCircleDown = require("./ExpandCircleDown");
var _expandCircleDownDefault = parcelHelpers.interopDefault(_expandCircleDown);
var _expandCircleDownOutlined = require("./ExpandCircleDownOutlined");
var _expandCircleDownOutlinedDefault = parcelHelpers.interopDefault(_expandCircleDownOutlined);
var _expandCircleDownRounded = require("./ExpandCircleDownRounded");
var _expandCircleDownRoundedDefault = parcelHelpers.interopDefault(_expandCircleDownRounded);
var _expandCircleDownSharp = require("./ExpandCircleDownSharp");
var _expandCircleDownSharpDefault = parcelHelpers.interopDefault(_expandCircleDownSharp);
var _expandCircleDownTwoTone = require("./ExpandCircleDownTwoTone");
var _expandCircleDownTwoToneDefault = parcelHelpers.interopDefault(_expandCircleDownTwoTone);
var _expandLess = require("./ExpandLess");
var _expandLessDefault = parcelHelpers.interopDefault(_expandLess);
var _expandLessOutlined = require("./ExpandLessOutlined");
var _expandLessOutlinedDefault = parcelHelpers.interopDefault(_expandLessOutlined);
var _expandLessRounded = require("./ExpandLessRounded");
var _expandLessRoundedDefault = parcelHelpers.interopDefault(_expandLessRounded);
var _expandLessSharp = require("./ExpandLessSharp");
var _expandLessSharpDefault = parcelHelpers.interopDefault(_expandLessSharp);
var _expandLessTwoTone = require("./ExpandLessTwoTone");
var _expandLessTwoToneDefault = parcelHelpers.interopDefault(_expandLessTwoTone);
var _expandMore = require("./ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _expandMoreOutlined = require("./ExpandMoreOutlined");
var _expandMoreOutlinedDefault = parcelHelpers.interopDefault(_expandMoreOutlined);
var _expandMoreRounded = require("./ExpandMoreRounded");
var _expandMoreRoundedDefault = parcelHelpers.interopDefault(_expandMoreRounded);
var _expandMoreSharp = require("./ExpandMoreSharp");
var _expandMoreSharpDefault = parcelHelpers.interopDefault(_expandMoreSharp);
var _expandMoreTwoTone = require("./ExpandMoreTwoTone");
var _expandMoreTwoToneDefault = parcelHelpers.interopDefault(_expandMoreTwoTone);
var _expandOutlined = require("./ExpandOutlined");
var _expandOutlinedDefault = parcelHelpers.interopDefault(_expandOutlined);
var _expandRounded = require("./ExpandRounded");
var _expandRoundedDefault = parcelHelpers.interopDefault(_expandRounded);
var _expandSharp = require("./ExpandSharp");
var _expandSharpDefault = parcelHelpers.interopDefault(_expandSharp);
var _expandTwoTone = require("./ExpandTwoTone");
var _expandTwoToneDefault = parcelHelpers.interopDefault(_expandTwoTone);
var _explicit = require("./Explicit");
var _explicitDefault = parcelHelpers.interopDefault(_explicit);
var _explicitOutlined = require("./ExplicitOutlined");
var _explicitOutlinedDefault = parcelHelpers.interopDefault(_explicitOutlined);
var _explicitRounded = require("./ExplicitRounded");
var _explicitRoundedDefault = parcelHelpers.interopDefault(_explicitRounded);
var _explicitSharp = require("./ExplicitSharp");
var _explicitSharpDefault = parcelHelpers.interopDefault(_explicitSharp);
var _explicitTwoTone = require("./ExplicitTwoTone");
var _explicitTwoToneDefault = parcelHelpers.interopDefault(_explicitTwoTone);
var _explore = require("./Explore");
var _exploreDefault = parcelHelpers.interopDefault(_explore);
var _exploreOff = require("./ExploreOff");
var _exploreOffDefault = parcelHelpers.interopDefault(_exploreOff);
var _exploreOffOutlined = require("./ExploreOffOutlined");
var _exploreOffOutlinedDefault = parcelHelpers.interopDefault(_exploreOffOutlined);
var _exploreOffRounded = require("./ExploreOffRounded");
var _exploreOffRoundedDefault = parcelHelpers.interopDefault(_exploreOffRounded);
var _exploreOffSharp = require("./ExploreOffSharp");
var _exploreOffSharpDefault = parcelHelpers.interopDefault(_exploreOffSharp);
var _exploreOffTwoTone = require("./ExploreOffTwoTone");
var _exploreOffTwoToneDefault = parcelHelpers.interopDefault(_exploreOffTwoTone);
var _exploreOutlined = require("./ExploreOutlined");
var _exploreOutlinedDefault = parcelHelpers.interopDefault(_exploreOutlined);
var _exploreRounded = require("./ExploreRounded");
var _exploreRoundedDefault = parcelHelpers.interopDefault(_exploreRounded);
var _exploreSharp = require("./ExploreSharp");
var _exploreSharpDefault = parcelHelpers.interopDefault(_exploreSharp);
var _exploreTwoTone = require("./ExploreTwoTone");
var _exploreTwoToneDefault = parcelHelpers.interopDefault(_exploreTwoTone);
var _exposure = require("./Exposure");
var _exposureDefault = parcelHelpers.interopDefault(_exposure);
var _exposureOutlined = require("./ExposureOutlined");
var _exposureOutlinedDefault = parcelHelpers.interopDefault(_exposureOutlined);
var _exposureRounded = require("./ExposureRounded");
var _exposureRoundedDefault = parcelHelpers.interopDefault(_exposureRounded);
var _exposureSharp = require("./ExposureSharp");
var _exposureSharpDefault = parcelHelpers.interopDefault(_exposureSharp);
var _exposureTwoTone = require("./ExposureTwoTone");
var _exposureTwoToneDefault = parcelHelpers.interopDefault(_exposureTwoTone);
var _extension = require("./Extension");
var _extensionDefault = parcelHelpers.interopDefault(_extension);
var _extensionOff = require("./ExtensionOff");
var _extensionOffDefault = parcelHelpers.interopDefault(_extensionOff);
var _extensionOffOutlined = require("./ExtensionOffOutlined");
var _extensionOffOutlinedDefault = parcelHelpers.interopDefault(_extensionOffOutlined);
var _extensionOffRounded = require("./ExtensionOffRounded");
var _extensionOffRoundedDefault = parcelHelpers.interopDefault(_extensionOffRounded);
var _extensionOffSharp = require("./ExtensionOffSharp");
var _extensionOffSharpDefault = parcelHelpers.interopDefault(_extensionOffSharp);
var _extensionOffTwoTone = require("./ExtensionOffTwoTone");
var _extensionOffTwoToneDefault = parcelHelpers.interopDefault(_extensionOffTwoTone);
var _extensionOutlined = require("./ExtensionOutlined");
var _extensionOutlinedDefault = parcelHelpers.interopDefault(_extensionOutlined);
var _extensionRounded = require("./ExtensionRounded");
var _extensionRoundedDefault = parcelHelpers.interopDefault(_extensionRounded);
var _extensionSharp = require("./ExtensionSharp");
var _extensionSharpDefault = parcelHelpers.interopDefault(_extensionSharp);
var _extensionTwoTone = require("./ExtensionTwoTone");
var _extensionTwoToneDefault = parcelHelpers.interopDefault(_extensionTwoTone);
var _face = require("./Face");
var _faceDefault = parcelHelpers.interopDefault(_face);
var _face2 = require("./Face2");
var _face2Default = parcelHelpers.interopDefault(_face2);
var _face2Outlined = require("./Face2Outlined");
var _face2OutlinedDefault = parcelHelpers.interopDefault(_face2Outlined);
var _face2Rounded = require("./Face2Rounded");
var _face2RoundedDefault = parcelHelpers.interopDefault(_face2Rounded);
var _face2Sharp = require("./Face2Sharp");
var _face2SharpDefault = parcelHelpers.interopDefault(_face2Sharp);
var _face2TwoTone = require("./Face2TwoTone");
var _face2TwoToneDefault = parcelHelpers.interopDefault(_face2TwoTone);
var _face3 = require("./Face3");
var _face3Default = parcelHelpers.interopDefault(_face3);
var _face3Outlined = require("./Face3Outlined");
var _face3OutlinedDefault = parcelHelpers.interopDefault(_face3Outlined);
var _face3Rounded = require("./Face3Rounded");
var _face3RoundedDefault = parcelHelpers.interopDefault(_face3Rounded);
var _face3Sharp = require("./Face3Sharp");
var _face3SharpDefault = parcelHelpers.interopDefault(_face3Sharp);
var _face3TwoTone = require("./Face3TwoTone");
var _face3TwoToneDefault = parcelHelpers.interopDefault(_face3TwoTone);
var _face4 = require("./Face4");
var _face4Default = parcelHelpers.interopDefault(_face4);
var _face4Outlined = require("./Face4Outlined");
var _face4OutlinedDefault = parcelHelpers.interopDefault(_face4Outlined);
var _face4Rounded = require("./Face4Rounded");
var _face4RoundedDefault = parcelHelpers.interopDefault(_face4Rounded);
var _face4Sharp = require("./Face4Sharp");
var _face4SharpDefault = parcelHelpers.interopDefault(_face4Sharp);
var _face4TwoTone = require("./Face4TwoTone");
var _face4TwoToneDefault = parcelHelpers.interopDefault(_face4TwoTone);
var _face5 = require("./Face5");
var _face5Default = parcelHelpers.interopDefault(_face5);
var _face5Outlined = require("./Face5Outlined");
var _face5OutlinedDefault = parcelHelpers.interopDefault(_face5Outlined);
var _face5Rounded = require("./Face5Rounded");
var _face5RoundedDefault = parcelHelpers.interopDefault(_face5Rounded);
var _face5Sharp = require("./Face5Sharp");
var _face5SharpDefault = parcelHelpers.interopDefault(_face5Sharp);
var _face5TwoTone = require("./Face5TwoTone");
var _face5TwoToneDefault = parcelHelpers.interopDefault(_face5TwoTone);
var _face6 = require("./Face6");
var _face6Default = parcelHelpers.interopDefault(_face6);
var _face6Outlined = require("./Face6Outlined");
var _face6OutlinedDefault = parcelHelpers.interopDefault(_face6Outlined);
var _face6Rounded = require("./Face6Rounded");
var _face6RoundedDefault = parcelHelpers.interopDefault(_face6Rounded);
var _face6Sharp = require("./Face6Sharp");
var _face6SharpDefault = parcelHelpers.interopDefault(_face6Sharp);
var _face6TwoTone = require("./Face6TwoTone");
var _face6TwoToneDefault = parcelHelpers.interopDefault(_face6TwoTone);
var _faceOutlined = require("./FaceOutlined");
var _faceOutlinedDefault = parcelHelpers.interopDefault(_faceOutlined);
var _faceRetouchingNatural = require("./FaceRetouchingNatural");
var _faceRetouchingNaturalDefault = parcelHelpers.interopDefault(_faceRetouchingNatural);
var _faceRetouchingNaturalOutlined = require("./FaceRetouchingNaturalOutlined");
var _faceRetouchingNaturalOutlinedDefault = parcelHelpers.interopDefault(_faceRetouchingNaturalOutlined);
var _faceRetouchingNaturalRounded = require("./FaceRetouchingNaturalRounded");
var _faceRetouchingNaturalRoundedDefault = parcelHelpers.interopDefault(_faceRetouchingNaturalRounded);
var _faceRetouchingNaturalSharp = require("./FaceRetouchingNaturalSharp");
var _faceRetouchingNaturalSharpDefault = parcelHelpers.interopDefault(_faceRetouchingNaturalSharp);
var _faceRetouchingNaturalTwoTone = require("./FaceRetouchingNaturalTwoTone");
var _faceRetouchingNaturalTwoToneDefault = parcelHelpers.interopDefault(_faceRetouchingNaturalTwoTone);
var _faceRetouchingOff = require("./FaceRetouchingOff");
var _faceRetouchingOffDefault = parcelHelpers.interopDefault(_faceRetouchingOff);
var _faceRetouchingOffOutlined = require("./FaceRetouchingOffOutlined");
var _faceRetouchingOffOutlinedDefault = parcelHelpers.interopDefault(_faceRetouchingOffOutlined);
var _faceRetouchingOffRounded = require("./FaceRetouchingOffRounded");
var _faceRetouchingOffRoundedDefault = parcelHelpers.interopDefault(_faceRetouchingOffRounded);
var _faceRetouchingOffSharp = require("./FaceRetouchingOffSharp");
var _faceRetouchingOffSharpDefault = parcelHelpers.interopDefault(_faceRetouchingOffSharp);
var _faceRetouchingOffTwoTone = require("./FaceRetouchingOffTwoTone");
var _faceRetouchingOffTwoToneDefault = parcelHelpers.interopDefault(_faceRetouchingOffTwoTone);
var _faceRounded = require("./FaceRounded");
var _faceRoundedDefault = parcelHelpers.interopDefault(_faceRounded);
var _faceSharp = require("./FaceSharp");
var _faceSharpDefault = parcelHelpers.interopDefault(_faceSharp);
var _faceTwoTone = require("./FaceTwoTone");
var _faceTwoToneDefault = parcelHelpers.interopDefault(_faceTwoTone);
var _facebook = require("./Facebook");
var _facebookDefault = parcelHelpers.interopDefault(_facebook);
var _facebookOutlined = require("./FacebookOutlined");
var _facebookOutlinedDefault = parcelHelpers.interopDefault(_facebookOutlined);
var _facebookRounded = require("./FacebookRounded");
var _facebookRoundedDefault = parcelHelpers.interopDefault(_facebookRounded);
var _facebookSharp = require("./FacebookSharp");
var _facebookSharpDefault = parcelHelpers.interopDefault(_facebookSharp);
var _facebookTwoTone = require("./FacebookTwoTone");
var _facebookTwoToneDefault = parcelHelpers.interopDefault(_facebookTwoTone);
var _factCheck = require("./FactCheck");
var _factCheckDefault = parcelHelpers.interopDefault(_factCheck);
var _factCheckOutlined = require("./FactCheckOutlined");
var _factCheckOutlinedDefault = parcelHelpers.interopDefault(_factCheckOutlined);
var _factCheckRounded = require("./FactCheckRounded");
var _factCheckRoundedDefault = parcelHelpers.interopDefault(_factCheckRounded);
var _factCheckSharp = require("./FactCheckSharp");
var _factCheckSharpDefault = parcelHelpers.interopDefault(_factCheckSharp);
var _factCheckTwoTone = require("./FactCheckTwoTone");
var _factCheckTwoToneDefault = parcelHelpers.interopDefault(_factCheckTwoTone);
var _factory = require("./Factory");
var _factoryDefault = parcelHelpers.interopDefault(_factory);
var _factoryOutlined = require("./FactoryOutlined");
var _factoryOutlinedDefault = parcelHelpers.interopDefault(_factoryOutlined);
var _factoryRounded = require("./FactoryRounded");
var _factoryRoundedDefault = parcelHelpers.interopDefault(_factoryRounded);
var _factorySharp = require("./FactorySharp");
var _factorySharpDefault = parcelHelpers.interopDefault(_factorySharp);
var _factoryTwoTone = require("./FactoryTwoTone");
var _factoryTwoToneDefault = parcelHelpers.interopDefault(_factoryTwoTone);
var _familyRestroom = require("./FamilyRestroom");
var _familyRestroomDefault = parcelHelpers.interopDefault(_familyRestroom);
var _familyRestroomOutlined = require("./FamilyRestroomOutlined");
var _familyRestroomOutlinedDefault = parcelHelpers.interopDefault(_familyRestroomOutlined);
var _familyRestroomRounded = require("./FamilyRestroomRounded");
var _familyRestroomRoundedDefault = parcelHelpers.interopDefault(_familyRestroomRounded);
var _familyRestroomSharp = require("./FamilyRestroomSharp");
var _familyRestroomSharpDefault = parcelHelpers.interopDefault(_familyRestroomSharp);
var _familyRestroomTwoTone = require("./FamilyRestroomTwoTone");
var _familyRestroomTwoToneDefault = parcelHelpers.interopDefault(_familyRestroomTwoTone);
var _fastForward = require("./FastForward");
var _fastForwardDefault = parcelHelpers.interopDefault(_fastForward);
var _fastForwardOutlined = require("./FastForwardOutlined");
var _fastForwardOutlinedDefault = parcelHelpers.interopDefault(_fastForwardOutlined);
var _fastForwardRounded = require("./FastForwardRounded");
var _fastForwardRoundedDefault = parcelHelpers.interopDefault(_fastForwardRounded);
var _fastForwardSharp = require("./FastForwardSharp");
var _fastForwardSharpDefault = parcelHelpers.interopDefault(_fastForwardSharp);
var _fastForwardTwoTone = require("./FastForwardTwoTone");
var _fastForwardTwoToneDefault = parcelHelpers.interopDefault(_fastForwardTwoTone);
var _fastRewind = require("./FastRewind");
var _fastRewindDefault = parcelHelpers.interopDefault(_fastRewind);
var _fastRewindOutlined = require("./FastRewindOutlined");
var _fastRewindOutlinedDefault = parcelHelpers.interopDefault(_fastRewindOutlined);
var _fastRewindRounded = require("./FastRewindRounded");
var _fastRewindRoundedDefault = parcelHelpers.interopDefault(_fastRewindRounded);
var _fastRewindSharp = require("./FastRewindSharp");
var _fastRewindSharpDefault = parcelHelpers.interopDefault(_fastRewindSharp);
var _fastRewindTwoTone = require("./FastRewindTwoTone");
var _fastRewindTwoToneDefault = parcelHelpers.interopDefault(_fastRewindTwoTone);
var _fastfood = require("./Fastfood");
var _fastfoodDefault = parcelHelpers.interopDefault(_fastfood);
var _fastfoodOutlined = require("./FastfoodOutlined");
var _fastfoodOutlinedDefault = parcelHelpers.interopDefault(_fastfoodOutlined);
var _fastfoodRounded = require("./FastfoodRounded");
var _fastfoodRoundedDefault = parcelHelpers.interopDefault(_fastfoodRounded);
var _fastfoodSharp = require("./FastfoodSharp");
var _fastfoodSharpDefault = parcelHelpers.interopDefault(_fastfoodSharp);
var _fastfoodTwoTone = require("./FastfoodTwoTone");
var _fastfoodTwoToneDefault = parcelHelpers.interopDefault(_fastfoodTwoTone);
var _favorite = require("./Favorite");
var _favoriteDefault = parcelHelpers.interopDefault(_favorite);
var _favoriteBorder = require("./FavoriteBorder");
var _favoriteBorderDefault = parcelHelpers.interopDefault(_favoriteBorder);
var _favoriteBorderOutlined = require("./FavoriteBorderOutlined");
var _favoriteBorderOutlinedDefault = parcelHelpers.interopDefault(_favoriteBorderOutlined);
var _favoriteBorderRounded = require("./FavoriteBorderRounded");
var _favoriteBorderRoundedDefault = parcelHelpers.interopDefault(_favoriteBorderRounded);
var _favoriteBorderSharp = require("./FavoriteBorderSharp");
var _favoriteBorderSharpDefault = parcelHelpers.interopDefault(_favoriteBorderSharp);
var _favoriteBorderTwoTone = require("./FavoriteBorderTwoTone");
var _favoriteBorderTwoToneDefault = parcelHelpers.interopDefault(_favoriteBorderTwoTone);
var _favoriteOutlined = require("./FavoriteOutlined");
var _favoriteOutlinedDefault = parcelHelpers.interopDefault(_favoriteOutlined);
var _favoriteRounded = require("./FavoriteRounded");
var _favoriteRoundedDefault = parcelHelpers.interopDefault(_favoriteRounded);
var _favoriteSharp = require("./FavoriteSharp");
var _favoriteSharpDefault = parcelHelpers.interopDefault(_favoriteSharp);
var _favoriteTwoTone = require("./FavoriteTwoTone");
var _favoriteTwoToneDefault = parcelHelpers.interopDefault(_favoriteTwoTone);
var _fax = require("./Fax");
var _faxDefault = parcelHelpers.interopDefault(_fax);
var _faxOutlined = require("./FaxOutlined");
var _faxOutlinedDefault = parcelHelpers.interopDefault(_faxOutlined);
var _faxRounded = require("./FaxRounded");
var _faxRoundedDefault = parcelHelpers.interopDefault(_faxRounded);
var _faxSharp = require("./FaxSharp");
var _faxSharpDefault = parcelHelpers.interopDefault(_faxSharp);
var _faxTwoTone = require("./FaxTwoTone");
var _faxTwoToneDefault = parcelHelpers.interopDefault(_faxTwoTone);
var _featuredPlayList = require("./FeaturedPlayList");
var _featuredPlayListDefault = parcelHelpers.interopDefault(_featuredPlayList);
var _featuredPlayListOutlined = require("./FeaturedPlayListOutlined");
var _featuredPlayListOutlinedDefault = parcelHelpers.interopDefault(_featuredPlayListOutlined);
var _featuredPlayListRounded = require("./FeaturedPlayListRounded");
var _featuredPlayListRoundedDefault = parcelHelpers.interopDefault(_featuredPlayListRounded);
var _featuredPlayListSharp = require("./FeaturedPlayListSharp");
var _featuredPlayListSharpDefault = parcelHelpers.interopDefault(_featuredPlayListSharp);
var _featuredPlayListTwoTone = require("./FeaturedPlayListTwoTone");
var _featuredPlayListTwoToneDefault = parcelHelpers.interopDefault(_featuredPlayListTwoTone);
var _featuredVideo = require("./FeaturedVideo");
var _featuredVideoDefault = parcelHelpers.interopDefault(_featuredVideo);
var _featuredVideoOutlined = require("./FeaturedVideoOutlined");
var _featuredVideoOutlinedDefault = parcelHelpers.interopDefault(_featuredVideoOutlined);
var _featuredVideoRounded = require("./FeaturedVideoRounded");
var _featuredVideoRoundedDefault = parcelHelpers.interopDefault(_featuredVideoRounded);
var _featuredVideoSharp = require("./FeaturedVideoSharp");
var _featuredVideoSharpDefault = parcelHelpers.interopDefault(_featuredVideoSharp);
var _featuredVideoTwoTone = require("./FeaturedVideoTwoTone");
var _featuredVideoTwoToneDefault = parcelHelpers.interopDefault(_featuredVideoTwoTone);
var _feed = require("./Feed");
var _feedDefault = parcelHelpers.interopDefault(_feed);
var _feedOutlined = require("./FeedOutlined");
var _feedOutlinedDefault = parcelHelpers.interopDefault(_feedOutlined);
var _feedRounded = require("./FeedRounded");
var _feedRoundedDefault = parcelHelpers.interopDefault(_feedRounded);
var _feedSharp = require("./FeedSharp");
var _feedSharpDefault = parcelHelpers.interopDefault(_feedSharp);
var _feedTwoTone = require("./FeedTwoTone");
var _feedTwoToneDefault = parcelHelpers.interopDefault(_feedTwoTone);
var _feedback = require("./Feedback");
var _feedbackDefault = parcelHelpers.interopDefault(_feedback);
var _feedbackOutlined = require("./FeedbackOutlined");
var _feedbackOutlinedDefault = parcelHelpers.interopDefault(_feedbackOutlined);
var _feedbackRounded = require("./FeedbackRounded");
var _feedbackRoundedDefault = parcelHelpers.interopDefault(_feedbackRounded);
var _feedbackSharp = require("./FeedbackSharp");
var _feedbackSharpDefault = parcelHelpers.interopDefault(_feedbackSharp);
var _feedbackTwoTone = require("./FeedbackTwoTone");
var _feedbackTwoToneDefault = parcelHelpers.interopDefault(_feedbackTwoTone);
var _female = require("./Female");
var _femaleDefault = parcelHelpers.interopDefault(_female);
var _femaleOutlined = require("./FemaleOutlined");
var _femaleOutlinedDefault = parcelHelpers.interopDefault(_femaleOutlined);
var _femaleRounded = require("./FemaleRounded");
var _femaleRoundedDefault = parcelHelpers.interopDefault(_femaleRounded);
var _femaleSharp = require("./FemaleSharp");
var _femaleSharpDefault = parcelHelpers.interopDefault(_femaleSharp);
var _femaleTwoTone = require("./FemaleTwoTone");
var _femaleTwoToneDefault = parcelHelpers.interopDefault(_femaleTwoTone);
var _fence = require("./Fence");
var _fenceDefault = parcelHelpers.interopDefault(_fence);
var _fenceOutlined = require("./FenceOutlined");
var _fenceOutlinedDefault = parcelHelpers.interopDefault(_fenceOutlined);
var _fenceRounded = require("./FenceRounded");
var _fenceRoundedDefault = parcelHelpers.interopDefault(_fenceRounded);
var _fenceSharp = require("./FenceSharp");
var _fenceSharpDefault = parcelHelpers.interopDefault(_fenceSharp);
var _fenceTwoTone = require("./FenceTwoTone");
var _fenceTwoToneDefault = parcelHelpers.interopDefault(_fenceTwoTone);
var _festival = require("./Festival");
var _festivalDefault = parcelHelpers.interopDefault(_festival);
var _festivalOutlined = require("./FestivalOutlined");
var _festivalOutlinedDefault = parcelHelpers.interopDefault(_festivalOutlined);
var _festivalRounded = require("./FestivalRounded");
var _festivalRoundedDefault = parcelHelpers.interopDefault(_festivalRounded);
var _festivalSharp = require("./FestivalSharp");
var _festivalSharpDefault = parcelHelpers.interopDefault(_festivalSharp);
var _festivalTwoTone = require("./FestivalTwoTone");
var _festivalTwoToneDefault = parcelHelpers.interopDefault(_festivalTwoTone);
var _fiberDvr = require("./FiberDvr");
var _fiberDvrDefault = parcelHelpers.interopDefault(_fiberDvr);
var _fiberDvrOutlined = require("./FiberDvrOutlined");
var _fiberDvrOutlinedDefault = parcelHelpers.interopDefault(_fiberDvrOutlined);
var _fiberDvrRounded = require("./FiberDvrRounded");
var _fiberDvrRoundedDefault = parcelHelpers.interopDefault(_fiberDvrRounded);
var _fiberDvrSharp = require("./FiberDvrSharp");
var _fiberDvrSharpDefault = parcelHelpers.interopDefault(_fiberDvrSharp);
var _fiberDvrTwoTone = require("./FiberDvrTwoTone");
var _fiberDvrTwoToneDefault = parcelHelpers.interopDefault(_fiberDvrTwoTone);
var _fiberManualRecord = require("./FiberManualRecord");
var _fiberManualRecordDefault = parcelHelpers.interopDefault(_fiberManualRecord);
var _fiberManualRecordOutlined = require("./FiberManualRecordOutlined");
var _fiberManualRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberManualRecordOutlined);
var _fiberManualRecordRounded = require("./FiberManualRecordRounded");
var _fiberManualRecordRoundedDefault = parcelHelpers.interopDefault(_fiberManualRecordRounded);
var _fiberManualRecordSharp = require("./FiberManualRecordSharp");
var _fiberManualRecordSharpDefault = parcelHelpers.interopDefault(_fiberManualRecordSharp);
var _fiberManualRecordTwoTone = require("./FiberManualRecordTwoTone");
var _fiberManualRecordTwoToneDefault = parcelHelpers.interopDefault(_fiberManualRecordTwoTone);
var _fiberNew = require("./FiberNew");
var _fiberNewDefault = parcelHelpers.interopDefault(_fiberNew);
var _fiberNewOutlined = require("./FiberNewOutlined");
var _fiberNewOutlinedDefault = parcelHelpers.interopDefault(_fiberNewOutlined);
var _fiberNewRounded = require("./FiberNewRounded");
var _fiberNewRoundedDefault = parcelHelpers.interopDefault(_fiberNewRounded);
var _fiberNewSharp = require("./FiberNewSharp");
var _fiberNewSharpDefault = parcelHelpers.interopDefault(_fiberNewSharp);
var _fiberNewTwoTone = require("./FiberNewTwoTone");
var _fiberNewTwoToneDefault = parcelHelpers.interopDefault(_fiberNewTwoTone);
var _fiberPin = require("./FiberPin");
var _fiberPinDefault = parcelHelpers.interopDefault(_fiberPin);
var _fiberPinOutlined = require("./FiberPinOutlined");
var _fiberPinOutlinedDefault = parcelHelpers.interopDefault(_fiberPinOutlined);
var _fiberPinRounded = require("./FiberPinRounded");
var _fiberPinRoundedDefault = parcelHelpers.interopDefault(_fiberPinRounded);
var _fiberPinSharp = require("./FiberPinSharp");
var _fiberPinSharpDefault = parcelHelpers.interopDefault(_fiberPinSharp);
var _fiberPinTwoTone = require("./FiberPinTwoTone");
var _fiberPinTwoToneDefault = parcelHelpers.interopDefault(_fiberPinTwoTone);
var _fiberSmartRecord = require("./FiberSmartRecord");
var _fiberSmartRecordDefault = parcelHelpers.interopDefault(_fiberSmartRecord);
var _fiberSmartRecordOutlined = require("./FiberSmartRecordOutlined");
var _fiberSmartRecordOutlinedDefault = parcelHelpers.interopDefault(_fiberSmartRecordOutlined);
var _fiberSmartRecordRounded = require("./FiberSmartRecordRounded");
var _fiberSmartRecordRoundedDefault = parcelHelpers.interopDefault(_fiberSmartRecordRounded);
var _fiberSmartRecordSharp = require("./FiberSmartRecordSharp");
var _fiberSmartRecordSharpDefault = parcelHelpers.interopDefault(_fiberSmartRecordSharp);
var _fiberSmartRecordTwoTone = require("./FiberSmartRecordTwoTone");
var _fiberSmartRecordTwoToneDefault = parcelHelpers.interopDefault(_fiberSmartRecordTwoTone);
var _fifteenMp = require("./FifteenMp");
var _fifteenMpDefault = parcelHelpers.interopDefault(_fifteenMp);
var _fifteenMpOutlined = require("./FifteenMpOutlined");
var _fifteenMpOutlinedDefault = parcelHelpers.interopDefault(_fifteenMpOutlined);
var _fifteenMpRounded = require("./FifteenMpRounded");
var _fifteenMpRoundedDefault = parcelHelpers.interopDefault(_fifteenMpRounded);
var _fifteenMpSharp = require("./FifteenMpSharp");
var _fifteenMpSharpDefault = parcelHelpers.interopDefault(_fifteenMpSharp);
var _fifteenMpTwoTone = require("./FifteenMpTwoTone");
var _fifteenMpTwoToneDefault = parcelHelpers.interopDefault(_fifteenMpTwoTone);
var _fileCopy = require("./FileCopy");
var _fileCopyDefault = parcelHelpers.interopDefault(_fileCopy);
var _fileCopyOutlined = require("./FileCopyOutlined");
var _fileCopyOutlinedDefault = parcelHelpers.interopDefault(_fileCopyOutlined);
var _fileCopyRounded = require("./FileCopyRounded");
var _fileCopyRoundedDefault = parcelHelpers.interopDefault(_fileCopyRounded);
var _fileCopySharp = require("./FileCopySharp");
var _fileCopySharpDefault = parcelHelpers.interopDefault(_fileCopySharp);
var _fileCopyTwoTone = require("./FileCopyTwoTone");
var _fileCopyTwoToneDefault = parcelHelpers.interopDefault(_fileCopyTwoTone);
var _fileDownload = require("./FileDownload");
var _fileDownloadDefault = parcelHelpers.interopDefault(_fileDownload);
var _fileDownloadDone = require("./FileDownloadDone");
var _fileDownloadDoneDefault = parcelHelpers.interopDefault(_fileDownloadDone);
var _fileDownloadDoneOutlined = require("./FileDownloadDoneOutlined");
var _fileDownloadDoneOutlinedDefault = parcelHelpers.interopDefault(_fileDownloadDoneOutlined);
var _fileDownloadDoneRounded = require("./FileDownloadDoneRounded");
var _fileDownloadDoneRoundedDefault = parcelHelpers.interopDefault(_fileDownloadDoneRounded);
var _fileDownloadDoneSharp = require("./FileDownloadDoneSharp");
var _fileDownloadDoneSharpDefault = parcelHelpers.interopDefault(_fileDownloadDoneSharp);
var _fileDownloadDoneTwoTone = require("./FileDownloadDoneTwoTone");
var _fileDownloadDoneTwoToneDefault = parcelHelpers.interopDefault(_fileDownloadDoneTwoTone);
var _fileDownloadOff = require("./FileDownloadOff");
var _fileDownloadOffDefault = parcelHelpers.interopDefault(_fileDownloadOff);
var _fileDownloadOffOutlined = require("./FileDownloadOffOutlined");
var _fileDownloadOffOutlinedDefault = parcelHelpers.interopDefault(_fileDownloadOffOutlined);
var _fileDownloadOffRounded = require("./FileDownloadOffRounded");
var _fileDownloadOffRoundedDefault = parcelHelpers.interopDefault(_fileDownloadOffRounded);
var _fileDownloadOffSharp = require("./FileDownloadOffSharp");
var _fileDownloadOffSharpDefault = parcelHelpers.interopDefault(_fileDownloadOffSharp);
var _fileDownloadOffTwoTone = require("./FileDownloadOffTwoTone");
var _fileDownloadOffTwoToneDefault = parcelHelpers.interopDefault(_fileDownloadOffTwoTone);
var _fileDownloadOutlined = require("./FileDownloadOutlined");
var _fileDownloadOutlinedDefault = parcelHelpers.interopDefault(_fileDownloadOutlined);
var _fileDownloadRounded = require("./FileDownloadRounded");
var _fileDownloadRoundedDefault = parcelHelpers.interopDefault(_fileDownloadRounded);
var _fileDownloadSharp = require("./FileDownloadSharp");
var _fileDownloadSharpDefault = parcelHelpers.interopDefault(_fileDownloadSharp);
var _fileDownloadTwoTone = require("./FileDownloadTwoTone");
var _fileDownloadTwoToneDefault = parcelHelpers.interopDefault(_fileDownloadTwoTone);
var _fileOpen = require("./FileOpen");
var _fileOpenDefault = parcelHelpers.interopDefault(_fileOpen);
var _fileOpenOutlined = require("./FileOpenOutlined");
var _fileOpenOutlinedDefault = parcelHelpers.interopDefault(_fileOpenOutlined);
var _fileOpenRounded = require("./FileOpenRounded");
var _fileOpenRoundedDefault = parcelHelpers.interopDefault(_fileOpenRounded);
var _fileOpenSharp = require("./FileOpenSharp");
var _fileOpenSharpDefault = parcelHelpers.interopDefault(_fileOpenSharp);
var _fileOpenTwoTone = require("./FileOpenTwoTone");
var _fileOpenTwoToneDefault = parcelHelpers.interopDefault(_fileOpenTwoTone);
var _filePresent = require("./FilePresent");
var _filePresentDefault = parcelHelpers.interopDefault(_filePresent);
var _filePresentOutlined = require("./FilePresentOutlined");
var _filePresentOutlinedDefault = parcelHelpers.interopDefault(_filePresentOutlined);
var _filePresentRounded = require("./FilePresentRounded");
var _filePresentRoundedDefault = parcelHelpers.interopDefault(_filePresentRounded);
var _filePresentSharp = require("./FilePresentSharp");
var _filePresentSharpDefault = parcelHelpers.interopDefault(_filePresentSharp);
var _filePresentTwoTone = require("./FilePresentTwoTone");
var _filePresentTwoToneDefault = parcelHelpers.interopDefault(_filePresentTwoTone);
var _fileUpload = require("./FileUpload");
var _fileUploadDefault = parcelHelpers.interopDefault(_fileUpload);
var _fileUploadOutlined = require("./FileUploadOutlined");
var _fileUploadOutlinedDefault = parcelHelpers.interopDefault(_fileUploadOutlined);
var _fileUploadRounded = require("./FileUploadRounded");
var _fileUploadRoundedDefault = parcelHelpers.interopDefault(_fileUploadRounded);
var _fileUploadSharp = require("./FileUploadSharp");
var _fileUploadSharpDefault = parcelHelpers.interopDefault(_fileUploadSharp);
var _fileUploadTwoTone = require("./FileUploadTwoTone");
var _fileUploadTwoToneDefault = parcelHelpers.interopDefault(_fileUploadTwoTone);
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _filter1 = require("./Filter1");
var _filter1Default = parcelHelpers.interopDefault(_filter1);
var _filter1Outlined = require("./Filter1Outlined");
var _filter1OutlinedDefault = parcelHelpers.interopDefault(_filter1Outlined);
var _filter1Rounded = require("./Filter1Rounded");
var _filter1RoundedDefault = parcelHelpers.interopDefault(_filter1Rounded);
var _filter1Sharp = require("./Filter1Sharp");
var _filter1SharpDefault = parcelHelpers.interopDefault(_filter1Sharp);
var _filter1TwoTone = require("./Filter1TwoTone");
var _filter1TwoToneDefault = parcelHelpers.interopDefault(_filter1TwoTone);
var _filter2 = require("./Filter2");
var _filter2Default = parcelHelpers.interopDefault(_filter2);
var _filter2Outlined = require("./Filter2Outlined");
var _filter2OutlinedDefault = parcelHelpers.interopDefault(_filter2Outlined);
var _filter2Rounded = require("./Filter2Rounded");
var _filter2RoundedDefault = parcelHelpers.interopDefault(_filter2Rounded);
var _filter2Sharp = require("./Filter2Sharp");
var _filter2SharpDefault = parcelHelpers.interopDefault(_filter2Sharp);
var _filter2TwoTone = require("./Filter2TwoTone");
var _filter2TwoToneDefault = parcelHelpers.interopDefault(_filter2TwoTone);
var _filter3 = require("./Filter3");
var _filter3Default = parcelHelpers.interopDefault(_filter3);
var _filter3Outlined = require("./Filter3Outlined");
var _filter3OutlinedDefault = parcelHelpers.interopDefault(_filter3Outlined);
var _filter3Rounded = require("./Filter3Rounded");
var _filter3RoundedDefault = parcelHelpers.interopDefault(_filter3Rounded);
var _filter3Sharp = require("./Filter3Sharp");
var _filter3SharpDefault = parcelHelpers.interopDefault(_filter3Sharp);
var _filter3TwoTone = require("./Filter3TwoTone");
var _filter3TwoToneDefault = parcelHelpers.interopDefault(_filter3TwoTone);
var _filter4 = require("./Filter4");
var _filter4Default = parcelHelpers.interopDefault(_filter4);
var _filter4Outlined = require("./Filter4Outlined");
var _filter4OutlinedDefault = parcelHelpers.interopDefault(_filter4Outlined);
var _filter4Rounded = require("./Filter4Rounded");
var _filter4RoundedDefault = parcelHelpers.interopDefault(_filter4Rounded);
var _filter4Sharp = require("./Filter4Sharp");
var _filter4SharpDefault = parcelHelpers.interopDefault(_filter4Sharp);
var _filter4TwoTone = require("./Filter4TwoTone");
var _filter4TwoToneDefault = parcelHelpers.interopDefault(_filter4TwoTone);
var _filter5 = require("./Filter5");
var _filter5Default = parcelHelpers.interopDefault(_filter5);
var _filter5Outlined = require("./Filter5Outlined");
var _filter5OutlinedDefault = parcelHelpers.interopDefault(_filter5Outlined);
var _filter5Rounded = require("./Filter5Rounded");
var _filter5RoundedDefault = parcelHelpers.interopDefault(_filter5Rounded);
var _filter5Sharp = require("./Filter5Sharp");
var _filter5SharpDefault = parcelHelpers.interopDefault(_filter5Sharp);
var _filter5TwoTone = require("./Filter5TwoTone");
var _filter5TwoToneDefault = parcelHelpers.interopDefault(_filter5TwoTone);
var _filter6 = require("./Filter6");
var _filter6Default = parcelHelpers.interopDefault(_filter6);
var _filter6Outlined = require("./Filter6Outlined");
var _filter6OutlinedDefault = parcelHelpers.interopDefault(_filter6Outlined);
var _filter6Rounded = require("./Filter6Rounded");
var _filter6RoundedDefault = parcelHelpers.interopDefault(_filter6Rounded);
var _filter6Sharp = require("./Filter6Sharp");
var _filter6SharpDefault = parcelHelpers.interopDefault(_filter6Sharp);
var _filter6TwoTone = require("./Filter6TwoTone");
var _filter6TwoToneDefault = parcelHelpers.interopDefault(_filter6TwoTone);
var _filter7 = require("./Filter7");
var _filter7Default = parcelHelpers.interopDefault(_filter7);
var _filter7Outlined = require("./Filter7Outlined");
var _filter7OutlinedDefault = parcelHelpers.interopDefault(_filter7Outlined);
var _filter7Rounded = require("./Filter7Rounded");
var _filter7RoundedDefault = parcelHelpers.interopDefault(_filter7Rounded);
var _filter7Sharp = require("./Filter7Sharp");
var _filter7SharpDefault = parcelHelpers.interopDefault(_filter7Sharp);
var _filter7TwoTone = require("./Filter7TwoTone");
var _filter7TwoToneDefault = parcelHelpers.interopDefault(_filter7TwoTone);
var _filter8 = require("./Filter8");
var _filter8Default = parcelHelpers.interopDefault(_filter8);
var _filter8Outlined = require("./Filter8Outlined");
var _filter8OutlinedDefault = parcelHelpers.interopDefault(_filter8Outlined);
var _filter8Rounded = require("./Filter8Rounded");
var _filter8RoundedDefault = parcelHelpers.interopDefault(_filter8Rounded);
var _filter8Sharp = require("./Filter8Sharp");
var _filter8SharpDefault = parcelHelpers.interopDefault(_filter8Sharp);
var _filter8TwoTone = require("./Filter8TwoTone");
var _filter8TwoToneDefault = parcelHelpers.interopDefault(_filter8TwoTone);
var _filter9 = require("./Filter9");
var _filter9Default = parcelHelpers.interopDefault(_filter9);
var _filter9Outlined = require("./Filter9Outlined");
var _filter9OutlinedDefault = parcelHelpers.interopDefault(_filter9Outlined);
var _filter9Plus = require("./Filter9Plus");
var _filter9PlusDefault = parcelHelpers.interopDefault(_filter9Plus);
var _filter9PlusOutlined = require("./Filter9PlusOutlined");
var _filter9PlusOutlinedDefault = parcelHelpers.interopDefault(_filter9PlusOutlined);
var _filter9PlusRounded = require("./Filter9PlusRounded");
var _filter9PlusRoundedDefault = parcelHelpers.interopDefault(_filter9PlusRounded);
var _filter9PlusSharp = require("./Filter9PlusSharp");
var _filter9PlusSharpDefault = parcelHelpers.interopDefault(_filter9PlusSharp);
var _filter9PlusTwoTone = require("./Filter9PlusTwoTone");
var _filter9PlusTwoToneDefault = parcelHelpers.interopDefault(_filter9PlusTwoTone);
var _filter9Rounded = require("./Filter9Rounded");
var _filter9RoundedDefault = parcelHelpers.interopDefault(_filter9Rounded);
var _filter9Sharp = require("./Filter9Sharp");
var _filter9SharpDefault = parcelHelpers.interopDefault(_filter9Sharp);
var _filter9TwoTone = require("./Filter9TwoTone");
var _filter9TwoToneDefault = parcelHelpers.interopDefault(_filter9TwoTone);
var _filterAlt = require("./FilterAlt");
var _filterAltDefault = parcelHelpers.interopDefault(_filterAlt);
var _filterAltOff = require("./FilterAltOff");
var _filterAltOffDefault = parcelHelpers.interopDefault(_filterAltOff);
var _filterAltOffOutlined = require("./FilterAltOffOutlined");
var _filterAltOffOutlinedDefault = parcelHelpers.interopDefault(_filterAltOffOutlined);
var _filterAltOffRounded = require("./FilterAltOffRounded");
var _filterAltOffRoundedDefault = parcelHelpers.interopDefault(_filterAltOffRounded);
var _filterAltOffSharp = require("./FilterAltOffSharp");
var _filterAltOffSharpDefault = parcelHelpers.interopDefault(_filterAltOffSharp);
var _filterAltOffTwoTone = require("./FilterAltOffTwoTone");
var _filterAltOffTwoToneDefault = parcelHelpers.interopDefault(_filterAltOffTwoTone);
var _filterAltOutlined = require("./FilterAltOutlined");
var _filterAltOutlinedDefault = parcelHelpers.interopDefault(_filterAltOutlined);
var _filterAltRounded = require("./FilterAltRounded");
var _filterAltRoundedDefault = parcelHelpers.interopDefault(_filterAltRounded);
var _filterAltSharp = require("./FilterAltSharp");
var _filterAltSharpDefault = parcelHelpers.interopDefault(_filterAltSharp);
var _filterAltTwoTone = require("./FilterAltTwoTone");
var _filterAltTwoToneDefault = parcelHelpers.interopDefault(_filterAltTwoTone);
var _filterBAndW = require("./FilterBAndW");
var _filterBAndWDefault = parcelHelpers.interopDefault(_filterBAndW);
var _filterBAndWOutlined = require("./FilterBAndWOutlined");
var _filterBAndWOutlinedDefault = parcelHelpers.interopDefault(_filterBAndWOutlined);
var _filterBAndWRounded = require("./FilterBAndWRounded");
var _filterBAndWRoundedDefault = parcelHelpers.interopDefault(_filterBAndWRounded);
var _filterBAndWSharp = require("./FilterBAndWSharp");
var _filterBAndWSharpDefault = parcelHelpers.interopDefault(_filterBAndWSharp);
var _filterBAndWTwoTone = require("./FilterBAndWTwoTone");
var _filterBAndWTwoToneDefault = parcelHelpers.interopDefault(_filterBAndWTwoTone);
var _filterCenterFocus = require("./FilterCenterFocus");
var _filterCenterFocusDefault = parcelHelpers.interopDefault(_filterCenterFocus);
var _filterCenterFocusOutlined = require("./FilterCenterFocusOutlined");
var _filterCenterFocusOutlinedDefault = parcelHelpers.interopDefault(_filterCenterFocusOutlined);
var _filterCenterFocusRounded = require("./FilterCenterFocusRounded");
var _filterCenterFocusRoundedDefault = parcelHelpers.interopDefault(_filterCenterFocusRounded);
var _filterCenterFocusSharp = require("./FilterCenterFocusSharp");
var _filterCenterFocusSharpDefault = parcelHelpers.interopDefault(_filterCenterFocusSharp);
var _filterCenterFocusTwoTone = require("./FilterCenterFocusTwoTone");
var _filterCenterFocusTwoToneDefault = parcelHelpers.interopDefault(_filterCenterFocusTwoTone);
var _filterDrama = require("./FilterDrama");
var _filterDramaDefault = parcelHelpers.interopDefault(_filterDrama);
var _filterDramaOutlined = require("./FilterDramaOutlined");
var _filterDramaOutlinedDefault = parcelHelpers.interopDefault(_filterDramaOutlined);
var _filterDramaRounded = require("./FilterDramaRounded");
var _filterDramaRoundedDefault = parcelHelpers.interopDefault(_filterDramaRounded);
var _filterDramaSharp = require("./FilterDramaSharp");
var _filterDramaSharpDefault = parcelHelpers.interopDefault(_filterDramaSharp);
var _filterDramaTwoTone = require("./FilterDramaTwoTone");
var _filterDramaTwoToneDefault = parcelHelpers.interopDefault(_filterDramaTwoTone);
var _filterFrames = require("./FilterFrames");
var _filterFramesDefault = parcelHelpers.interopDefault(_filterFrames);
var _filterFramesOutlined = require("./FilterFramesOutlined");
var _filterFramesOutlinedDefault = parcelHelpers.interopDefault(_filterFramesOutlined);
var _filterFramesRounded = require("./FilterFramesRounded");
var _filterFramesRoundedDefault = parcelHelpers.interopDefault(_filterFramesRounded);
var _filterFramesSharp = require("./FilterFramesSharp");
var _filterFramesSharpDefault = parcelHelpers.interopDefault(_filterFramesSharp);
var _filterFramesTwoTone = require("./FilterFramesTwoTone");
var _filterFramesTwoToneDefault = parcelHelpers.interopDefault(_filterFramesTwoTone);
var _filterHdr = require("./FilterHdr");
var _filterHdrDefault = parcelHelpers.interopDefault(_filterHdr);
var _filterHdrOutlined = require("./FilterHdrOutlined");
var _filterHdrOutlinedDefault = parcelHelpers.interopDefault(_filterHdrOutlined);
var _filterHdrRounded = require("./FilterHdrRounded");
var _filterHdrRoundedDefault = parcelHelpers.interopDefault(_filterHdrRounded);
var _filterHdrSharp = require("./FilterHdrSharp");
var _filterHdrSharpDefault = parcelHelpers.interopDefault(_filterHdrSharp);
var _filterHdrTwoTone = require("./FilterHdrTwoTone");
var _filterHdrTwoToneDefault = parcelHelpers.interopDefault(_filterHdrTwoTone);
var _filterList = require("./FilterList");
var _filterListDefault = parcelHelpers.interopDefault(_filterList);
var _filterListOff = require("./FilterListOff");
var _filterListOffDefault = parcelHelpers.interopDefault(_filterListOff);
var _filterListOffOutlined = require("./FilterListOffOutlined");
var _filterListOffOutlinedDefault = parcelHelpers.interopDefault(_filterListOffOutlined);
var _filterListOffRounded = require("./FilterListOffRounded");
var _filterListOffRoundedDefault = parcelHelpers.interopDefault(_filterListOffRounded);
var _filterListOffSharp = require("./FilterListOffSharp");
var _filterListOffSharpDefault = parcelHelpers.interopDefault(_filterListOffSharp);
var _filterListOffTwoTone = require("./FilterListOffTwoTone");
var _filterListOffTwoToneDefault = parcelHelpers.interopDefault(_filterListOffTwoTone);
var _filterListOutlined = require("./FilterListOutlined");
var _filterListOutlinedDefault = parcelHelpers.interopDefault(_filterListOutlined);
var _filterListRounded = require("./FilterListRounded");
var _filterListRoundedDefault = parcelHelpers.interopDefault(_filterListRounded);
var _filterListSharp = require("./FilterListSharp");
var _filterListSharpDefault = parcelHelpers.interopDefault(_filterListSharp);
var _filterListTwoTone = require("./FilterListTwoTone");
var _filterListTwoToneDefault = parcelHelpers.interopDefault(_filterListTwoTone);
var _filterNone = require("./FilterNone");
var _filterNoneDefault = parcelHelpers.interopDefault(_filterNone);
var _filterNoneOutlined = require("./FilterNoneOutlined");
var _filterNoneOutlinedDefault = parcelHelpers.interopDefault(_filterNoneOutlined);
var _filterNoneRounded = require("./FilterNoneRounded");
var _filterNoneRoundedDefault = parcelHelpers.interopDefault(_filterNoneRounded);
var _filterNoneSharp = require("./FilterNoneSharp");
var _filterNoneSharpDefault = parcelHelpers.interopDefault(_filterNoneSharp);
var _filterNoneTwoTone = require("./FilterNoneTwoTone");
var _filterNoneTwoToneDefault = parcelHelpers.interopDefault(_filterNoneTwoTone);
var _filterOutlined = require("./FilterOutlined");
var _filterOutlinedDefault = parcelHelpers.interopDefault(_filterOutlined);
var _filterRounded = require("./FilterRounded");
var _filterRoundedDefault = parcelHelpers.interopDefault(_filterRounded);
var _filterSharp = require("./FilterSharp");
var _filterSharpDefault = parcelHelpers.interopDefault(_filterSharp);
var _filterTiltShift = require("./FilterTiltShift");
var _filterTiltShiftDefault = parcelHelpers.interopDefault(_filterTiltShift);
var _filterTiltShiftOutlined = require("./FilterTiltShiftOutlined");
var _filterTiltShiftOutlinedDefault = parcelHelpers.interopDefault(_filterTiltShiftOutlined);
var _filterTiltShiftRounded = require("./FilterTiltShiftRounded");
var _filterTiltShiftRoundedDefault = parcelHelpers.interopDefault(_filterTiltShiftRounded);
var _filterTiltShiftSharp = require("./FilterTiltShiftSharp");
var _filterTiltShiftSharpDefault = parcelHelpers.interopDefault(_filterTiltShiftSharp);
var _filterTiltShiftTwoTone = require("./FilterTiltShiftTwoTone");
var _filterTiltShiftTwoToneDefault = parcelHelpers.interopDefault(_filterTiltShiftTwoTone);
var _filterTwoTone = require("./FilterTwoTone");
var _filterTwoToneDefault = parcelHelpers.interopDefault(_filterTwoTone);
var _filterVintage = require("./FilterVintage");
var _filterVintageDefault = parcelHelpers.interopDefault(_filterVintage);
var _filterVintageOutlined = require("./FilterVintageOutlined");
var _filterVintageOutlinedDefault = parcelHelpers.interopDefault(_filterVintageOutlined);
var _filterVintageRounded = require("./FilterVintageRounded");
var _filterVintageRoundedDefault = parcelHelpers.interopDefault(_filterVintageRounded);
var _filterVintageSharp = require("./FilterVintageSharp");
var _filterVintageSharpDefault = parcelHelpers.interopDefault(_filterVintageSharp);
var _filterVintageTwoTone = require("./FilterVintageTwoTone");
var _filterVintageTwoToneDefault = parcelHelpers.interopDefault(_filterVintageTwoTone);
var _findInPage = require("./FindInPage");
var _findInPageDefault = parcelHelpers.interopDefault(_findInPage);
var _findInPageOutlined = require("./FindInPageOutlined");
var _findInPageOutlinedDefault = parcelHelpers.interopDefault(_findInPageOutlined);
var _findInPageRounded = require("./FindInPageRounded");
var _findInPageRoundedDefault = parcelHelpers.interopDefault(_findInPageRounded);
var _findInPageSharp = require("./FindInPageSharp");
var _findInPageSharpDefault = parcelHelpers.interopDefault(_findInPageSharp);
var _findInPageTwoTone = require("./FindInPageTwoTone");
var _findInPageTwoToneDefault = parcelHelpers.interopDefault(_findInPageTwoTone);
var _findReplace = require("./FindReplace");
var _findReplaceDefault = parcelHelpers.interopDefault(_findReplace);
var _findReplaceOutlined = require("./FindReplaceOutlined");
var _findReplaceOutlinedDefault = parcelHelpers.interopDefault(_findReplaceOutlined);
var _findReplaceRounded = require("./FindReplaceRounded");
var _findReplaceRoundedDefault = parcelHelpers.interopDefault(_findReplaceRounded);
var _findReplaceSharp = require("./FindReplaceSharp");
var _findReplaceSharpDefault = parcelHelpers.interopDefault(_findReplaceSharp);
var _findReplaceTwoTone = require("./FindReplaceTwoTone");
var _findReplaceTwoToneDefault = parcelHelpers.interopDefault(_findReplaceTwoTone);
var _fingerprint = require("./Fingerprint");
var _fingerprintDefault = parcelHelpers.interopDefault(_fingerprint);
var _fingerprintOutlined = require("./FingerprintOutlined");
var _fingerprintOutlinedDefault = parcelHelpers.interopDefault(_fingerprintOutlined);
var _fingerprintRounded = require("./FingerprintRounded");
var _fingerprintRoundedDefault = parcelHelpers.interopDefault(_fingerprintRounded);
var _fingerprintSharp = require("./FingerprintSharp");
var _fingerprintSharpDefault = parcelHelpers.interopDefault(_fingerprintSharp);
var _fingerprintTwoTone = require("./FingerprintTwoTone");
var _fingerprintTwoToneDefault = parcelHelpers.interopDefault(_fingerprintTwoTone);
var _fireExtinguisher = require("./FireExtinguisher");
var _fireExtinguisherDefault = parcelHelpers.interopDefault(_fireExtinguisher);
var _fireExtinguisherOutlined = require("./FireExtinguisherOutlined");
var _fireExtinguisherOutlinedDefault = parcelHelpers.interopDefault(_fireExtinguisherOutlined);
var _fireExtinguisherRounded = require("./FireExtinguisherRounded");
var _fireExtinguisherRoundedDefault = parcelHelpers.interopDefault(_fireExtinguisherRounded);
var _fireExtinguisherSharp = require("./FireExtinguisherSharp");
var _fireExtinguisherSharpDefault = parcelHelpers.interopDefault(_fireExtinguisherSharp);
var _fireExtinguisherTwoTone = require("./FireExtinguisherTwoTone");
var _fireExtinguisherTwoToneDefault = parcelHelpers.interopDefault(_fireExtinguisherTwoTone);
var _fireHydrantAlt = require("./FireHydrantAlt");
var _fireHydrantAltDefault = parcelHelpers.interopDefault(_fireHydrantAlt);
var _fireHydrantAltOutlined = require("./FireHydrantAltOutlined");
var _fireHydrantAltOutlinedDefault = parcelHelpers.interopDefault(_fireHydrantAltOutlined);
var _fireHydrantAltRounded = require("./FireHydrantAltRounded");
var _fireHydrantAltRoundedDefault = parcelHelpers.interopDefault(_fireHydrantAltRounded);
var _fireHydrantAltSharp = require("./FireHydrantAltSharp");
var _fireHydrantAltSharpDefault = parcelHelpers.interopDefault(_fireHydrantAltSharp);
var _fireHydrantAltTwoTone = require("./FireHydrantAltTwoTone");
var _fireHydrantAltTwoToneDefault = parcelHelpers.interopDefault(_fireHydrantAltTwoTone);
var _fireTruck = require("./FireTruck");
var _fireTruckDefault = parcelHelpers.interopDefault(_fireTruck);
var _fireTruckOutlined = require("./FireTruckOutlined");
var _fireTruckOutlinedDefault = parcelHelpers.interopDefault(_fireTruckOutlined);
var _fireTruckRounded = require("./FireTruckRounded");
var _fireTruckRoundedDefault = parcelHelpers.interopDefault(_fireTruckRounded);
var _fireTruckSharp = require("./FireTruckSharp");
var _fireTruckSharpDefault = parcelHelpers.interopDefault(_fireTruckSharp);
var _fireTruckTwoTone = require("./FireTruckTwoTone");
var _fireTruckTwoToneDefault = parcelHelpers.interopDefault(_fireTruckTwoTone);
var _fireplace = require("./Fireplace");
var _fireplaceDefault = parcelHelpers.interopDefault(_fireplace);
var _fireplaceOutlined = require("./FireplaceOutlined");
var _fireplaceOutlinedDefault = parcelHelpers.interopDefault(_fireplaceOutlined);
var _fireplaceRounded = require("./FireplaceRounded");
var _fireplaceRoundedDefault = parcelHelpers.interopDefault(_fireplaceRounded);
var _fireplaceSharp = require("./FireplaceSharp");
var _fireplaceSharpDefault = parcelHelpers.interopDefault(_fireplaceSharp);
var _fireplaceTwoTone = require("./FireplaceTwoTone");
var _fireplaceTwoToneDefault = parcelHelpers.interopDefault(_fireplaceTwoTone);
var _firstPage = require("./FirstPage");
var _firstPageDefault = parcelHelpers.interopDefault(_firstPage);
var _firstPageOutlined = require("./FirstPageOutlined");
var _firstPageOutlinedDefault = parcelHelpers.interopDefault(_firstPageOutlined);
var _firstPageRounded = require("./FirstPageRounded");
var _firstPageRoundedDefault = parcelHelpers.interopDefault(_firstPageRounded);
var _firstPageSharp = require("./FirstPageSharp");
var _firstPageSharpDefault = parcelHelpers.interopDefault(_firstPageSharp);
var _firstPageTwoTone = require("./FirstPageTwoTone");
var _firstPageTwoToneDefault = parcelHelpers.interopDefault(_firstPageTwoTone);
var _fitScreen = require("./FitScreen");
var _fitScreenDefault = parcelHelpers.interopDefault(_fitScreen);
var _fitScreenOutlined = require("./FitScreenOutlined");
var _fitScreenOutlinedDefault = parcelHelpers.interopDefault(_fitScreenOutlined);
var _fitScreenRounded = require("./FitScreenRounded");
var _fitScreenRoundedDefault = parcelHelpers.interopDefault(_fitScreenRounded);
var _fitScreenSharp = require("./FitScreenSharp");
var _fitScreenSharpDefault = parcelHelpers.interopDefault(_fitScreenSharp);
var _fitScreenTwoTone = require("./FitScreenTwoTone");
var _fitScreenTwoToneDefault = parcelHelpers.interopDefault(_fitScreenTwoTone);
var _fitbit = require("./Fitbit");
var _fitbitDefault = parcelHelpers.interopDefault(_fitbit);
var _fitbitOutlined = require("./FitbitOutlined");
var _fitbitOutlinedDefault = parcelHelpers.interopDefault(_fitbitOutlined);
var _fitbitRounded = require("./FitbitRounded");
var _fitbitRoundedDefault = parcelHelpers.interopDefault(_fitbitRounded);
var _fitbitSharp = require("./FitbitSharp");
var _fitbitSharpDefault = parcelHelpers.interopDefault(_fitbitSharp);
var _fitbitTwoTone = require("./FitbitTwoTone");
var _fitbitTwoToneDefault = parcelHelpers.interopDefault(_fitbitTwoTone);
var _fitnessCenter = require("./FitnessCenter");
var _fitnessCenterDefault = parcelHelpers.interopDefault(_fitnessCenter);
var _fitnessCenterOutlined = require("./FitnessCenterOutlined");
var _fitnessCenterOutlinedDefault = parcelHelpers.interopDefault(_fitnessCenterOutlined);
var _fitnessCenterRounded = require("./FitnessCenterRounded");
var _fitnessCenterRoundedDefault = parcelHelpers.interopDefault(_fitnessCenterRounded);
var _fitnessCenterSharp = require("./FitnessCenterSharp");
var _fitnessCenterSharpDefault = parcelHelpers.interopDefault(_fitnessCenterSharp);
var _fitnessCenterTwoTone = require("./FitnessCenterTwoTone");
var _fitnessCenterTwoToneDefault = parcelHelpers.interopDefault(_fitnessCenterTwoTone);
var _fiveG = require("./FiveG");
var _fiveGDefault = parcelHelpers.interopDefault(_fiveG);
var _fiveGOutlined = require("./FiveGOutlined");
var _fiveGOutlinedDefault = parcelHelpers.interopDefault(_fiveGOutlined);
var _fiveGRounded = require("./FiveGRounded");
var _fiveGRoundedDefault = parcelHelpers.interopDefault(_fiveGRounded);
var _fiveGSharp = require("./FiveGSharp");
var _fiveGSharpDefault = parcelHelpers.interopDefault(_fiveGSharp);
var _fiveGTwoTone = require("./FiveGTwoTone");
var _fiveGTwoToneDefault = parcelHelpers.interopDefault(_fiveGTwoTone);
var _fiveK = require("./FiveK");
var _fiveKDefault = parcelHelpers.interopDefault(_fiveK);
var _fiveKOutlined = require("./FiveKOutlined");
var _fiveKOutlinedDefault = parcelHelpers.interopDefault(_fiveKOutlined);
var _fiveKPlus = require("./FiveKPlus");
var _fiveKPlusDefault = parcelHelpers.interopDefault(_fiveKPlus);
var _fiveKPlusOutlined = require("./FiveKPlusOutlined");
var _fiveKPlusOutlinedDefault = parcelHelpers.interopDefault(_fiveKPlusOutlined);
var _fiveKPlusRounded = require("./FiveKPlusRounded");
var _fiveKPlusRoundedDefault = parcelHelpers.interopDefault(_fiveKPlusRounded);
var _fiveKPlusSharp = require("./FiveKPlusSharp");
var _fiveKPlusSharpDefault = parcelHelpers.interopDefault(_fiveKPlusSharp);
var _fiveKPlusTwoTone = require("./FiveKPlusTwoTone");
var _fiveKPlusTwoToneDefault = parcelHelpers.interopDefault(_fiveKPlusTwoTone);
var _fiveKRounded = require("./FiveKRounded");
var _fiveKRoundedDefault = parcelHelpers.interopDefault(_fiveKRounded);
var _fiveKSharp = require("./FiveKSharp");
var _fiveKSharpDefault = parcelHelpers.interopDefault(_fiveKSharp);
var _fiveKTwoTone = require("./FiveKTwoTone");
var _fiveKTwoToneDefault = parcelHelpers.interopDefault(_fiveKTwoTone);
var _fiveMp = require("./FiveMp");
var _fiveMpDefault = parcelHelpers.interopDefault(_fiveMp);
var _fiveMpOutlined = require("./FiveMpOutlined");
var _fiveMpOutlinedDefault = parcelHelpers.interopDefault(_fiveMpOutlined);
var _fiveMpRounded = require("./FiveMpRounded");
var _fiveMpRoundedDefault = parcelHelpers.interopDefault(_fiveMpRounded);
var _fiveMpSharp = require("./FiveMpSharp");
var _fiveMpSharpDefault = parcelHelpers.interopDefault(_fiveMpSharp);
var _fiveMpTwoTone = require("./FiveMpTwoTone");
var _fiveMpTwoToneDefault = parcelHelpers.interopDefault(_fiveMpTwoTone);
var _fivteenMp = require("./FivteenMp");
var _fivteenMpDefault = parcelHelpers.interopDefault(_fivteenMp);
var _fivteenMpOutlined = require("./FivteenMpOutlined");
var _fivteenMpOutlinedDefault = parcelHelpers.interopDefault(_fivteenMpOutlined);
var _fivteenMpRounded = require("./FivteenMpRounded");
var _fivteenMpRoundedDefault = parcelHelpers.interopDefault(_fivteenMpRounded);
var _fivteenMpSharp = require("./FivteenMpSharp");
var _fivteenMpSharpDefault = parcelHelpers.interopDefault(_fivteenMpSharp);
var _fivteenMpTwoTone = require("./FivteenMpTwoTone");
var _fivteenMpTwoToneDefault = parcelHelpers.interopDefault(_fivteenMpTwoTone);
var _flag = require("./Flag");
var _flagDefault = parcelHelpers.interopDefault(_flag);
var _flagCircle = require("./FlagCircle");
var _flagCircleDefault = parcelHelpers.interopDefault(_flagCircle);
var _flagCircleOutlined = require("./FlagCircleOutlined");
var _flagCircleOutlinedDefault = parcelHelpers.interopDefault(_flagCircleOutlined);
var _flagCircleRounded = require("./FlagCircleRounded");
var _flagCircleRoundedDefault = parcelHelpers.interopDefault(_flagCircleRounded);
var _flagCircleSharp = require("./FlagCircleSharp");
var _flagCircleSharpDefault = parcelHelpers.interopDefault(_flagCircleSharp);
var _flagCircleTwoTone = require("./FlagCircleTwoTone");
var _flagCircleTwoToneDefault = parcelHelpers.interopDefault(_flagCircleTwoTone);
var _flagOutlined = require("./FlagOutlined");
var _flagOutlinedDefault = parcelHelpers.interopDefault(_flagOutlined);
var _flagRounded = require("./FlagRounded");
var _flagRoundedDefault = parcelHelpers.interopDefault(_flagRounded);
var _flagSharp = require("./FlagSharp");
var _flagSharpDefault = parcelHelpers.interopDefault(_flagSharp);
var _flagTwoTone = require("./FlagTwoTone");
var _flagTwoToneDefault = parcelHelpers.interopDefault(_flagTwoTone);
var _flaky = require("./Flaky");
var _flakyDefault = parcelHelpers.interopDefault(_flaky);
var _flakyOutlined = require("./FlakyOutlined");
var _flakyOutlinedDefault = parcelHelpers.interopDefault(_flakyOutlined);
var _flakyRounded = require("./FlakyRounded");
var _flakyRoundedDefault = parcelHelpers.interopDefault(_flakyRounded);
var _flakySharp = require("./FlakySharp");
var _flakySharpDefault = parcelHelpers.interopDefault(_flakySharp);
var _flakyTwoTone = require("./FlakyTwoTone");
var _flakyTwoToneDefault = parcelHelpers.interopDefault(_flakyTwoTone);
var _flare = require("./Flare");
var _flareDefault = parcelHelpers.interopDefault(_flare);
var _flareOutlined = require("./FlareOutlined");
var _flareOutlinedDefault = parcelHelpers.interopDefault(_flareOutlined);
var _flareRounded = require("./FlareRounded");
var _flareRoundedDefault = parcelHelpers.interopDefault(_flareRounded);
var _flareSharp = require("./FlareSharp");
var _flareSharpDefault = parcelHelpers.interopDefault(_flareSharp);
var _flareTwoTone = require("./FlareTwoTone");
var _flareTwoToneDefault = parcelHelpers.interopDefault(_flareTwoTone);
var _flashAuto = require("./FlashAuto");
var _flashAutoDefault = parcelHelpers.interopDefault(_flashAuto);
var _flashAutoOutlined = require("./FlashAutoOutlined");
var _flashAutoOutlinedDefault = parcelHelpers.interopDefault(_flashAutoOutlined);
var _flashAutoRounded = require("./FlashAutoRounded");
var _flashAutoRoundedDefault = parcelHelpers.interopDefault(_flashAutoRounded);
var _flashAutoSharp = require("./FlashAutoSharp");
var _flashAutoSharpDefault = parcelHelpers.interopDefault(_flashAutoSharp);
var _flashAutoTwoTone = require("./FlashAutoTwoTone");
var _flashAutoTwoToneDefault = parcelHelpers.interopDefault(_flashAutoTwoTone);
var _flashOff = require("./FlashOff");
var _flashOffDefault = parcelHelpers.interopDefault(_flashOff);
var _flashOffOutlined = require("./FlashOffOutlined");
var _flashOffOutlinedDefault = parcelHelpers.interopDefault(_flashOffOutlined);
var _flashOffRounded = require("./FlashOffRounded");
var _flashOffRoundedDefault = parcelHelpers.interopDefault(_flashOffRounded);
var _flashOffSharp = require("./FlashOffSharp");
var _flashOffSharpDefault = parcelHelpers.interopDefault(_flashOffSharp);
var _flashOffTwoTone = require("./FlashOffTwoTone");
var _flashOffTwoToneDefault = parcelHelpers.interopDefault(_flashOffTwoTone);
var _flashOn = require("./FlashOn");
var _flashOnDefault = parcelHelpers.interopDefault(_flashOn);
var _flashOnOutlined = require("./FlashOnOutlined");
var _flashOnOutlinedDefault = parcelHelpers.interopDefault(_flashOnOutlined);
var _flashOnRounded = require("./FlashOnRounded");
var _flashOnRoundedDefault = parcelHelpers.interopDefault(_flashOnRounded);
var _flashOnSharp = require("./FlashOnSharp");
var _flashOnSharpDefault = parcelHelpers.interopDefault(_flashOnSharp);
var _flashOnTwoTone = require("./FlashOnTwoTone");
var _flashOnTwoToneDefault = parcelHelpers.interopDefault(_flashOnTwoTone);
var _flashlightOff = require("./FlashlightOff");
var _flashlightOffDefault = parcelHelpers.interopDefault(_flashlightOff);
var _flashlightOffOutlined = require("./FlashlightOffOutlined");
var _flashlightOffOutlinedDefault = parcelHelpers.interopDefault(_flashlightOffOutlined);
var _flashlightOffRounded = require("./FlashlightOffRounded");
var _flashlightOffRoundedDefault = parcelHelpers.interopDefault(_flashlightOffRounded);
var _flashlightOffSharp = require("./FlashlightOffSharp");
var _flashlightOffSharpDefault = parcelHelpers.interopDefault(_flashlightOffSharp);
var _flashlightOffTwoTone = require("./FlashlightOffTwoTone");
var _flashlightOffTwoToneDefault = parcelHelpers.interopDefault(_flashlightOffTwoTone);
var _flashlightOn = require("./FlashlightOn");
var _flashlightOnDefault = parcelHelpers.interopDefault(_flashlightOn);
var _flashlightOnOutlined = require("./FlashlightOnOutlined");
var _flashlightOnOutlinedDefault = parcelHelpers.interopDefault(_flashlightOnOutlined);
var _flashlightOnRounded = require("./FlashlightOnRounded");
var _flashlightOnRoundedDefault = parcelHelpers.interopDefault(_flashlightOnRounded);
var _flashlightOnSharp = require("./FlashlightOnSharp");
var _flashlightOnSharpDefault = parcelHelpers.interopDefault(_flashlightOnSharp);
var _flashlightOnTwoTone = require("./FlashlightOnTwoTone");
var _flashlightOnTwoToneDefault = parcelHelpers.interopDefault(_flashlightOnTwoTone);
var _flatware = require("./Flatware");
var _flatwareDefault = parcelHelpers.interopDefault(_flatware);
var _flatwareOutlined = require("./FlatwareOutlined");
var _flatwareOutlinedDefault = parcelHelpers.interopDefault(_flatwareOutlined);
var _flatwareRounded = require("./FlatwareRounded");
var _flatwareRoundedDefault = parcelHelpers.interopDefault(_flatwareRounded);
var _flatwareSharp = require("./FlatwareSharp");
var _flatwareSharpDefault = parcelHelpers.interopDefault(_flatwareSharp);
var _flatwareTwoTone = require("./FlatwareTwoTone");
var _flatwareTwoToneDefault = parcelHelpers.interopDefault(_flatwareTwoTone);
var _flight = require("./Flight");
var _flightDefault = parcelHelpers.interopDefault(_flight);
var _flightClass = require("./FlightClass");
var _flightClassDefault = parcelHelpers.interopDefault(_flightClass);
var _flightClassOutlined = require("./FlightClassOutlined");
var _flightClassOutlinedDefault = parcelHelpers.interopDefault(_flightClassOutlined);
var _flightClassRounded = require("./FlightClassRounded");
var _flightClassRoundedDefault = parcelHelpers.interopDefault(_flightClassRounded);
var _flightClassSharp = require("./FlightClassSharp");
var _flightClassSharpDefault = parcelHelpers.interopDefault(_flightClassSharp);
var _flightClassTwoTone = require("./FlightClassTwoTone");
var _flightClassTwoToneDefault = parcelHelpers.interopDefault(_flightClassTwoTone);
var _flightLand = require("./FlightLand");
var _flightLandDefault = parcelHelpers.interopDefault(_flightLand);
var _flightLandOutlined = require("./FlightLandOutlined");
var _flightLandOutlinedDefault = parcelHelpers.interopDefault(_flightLandOutlined);
var _flightLandRounded = require("./FlightLandRounded");
var _flightLandRoundedDefault = parcelHelpers.interopDefault(_flightLandRounded);
var _flightLandSharp = require("./FlightLandSharp");
var _flightLandSharpDefault = parcelHelpers.interopDefault(_flightLandSharp);
var _flightLandTwoTone = require("./FlightLandTwoTone");
var _flightLandTwoToneDefault = parcelHelpers.interopDefault(_flightLandTwoTone);
var _flightOutlined = require("./FlightOutlined");
var _flightOutlinedDefault = parcelHelpers.interopDefault(_flightOutlined);
var _flightRounded = require("./FlightRounded");
var _flightRoundedDefault = parcelHelpers.interopDefault(_flightRounded);
var _flightSharp = require("./FlightSharp");
var _flightSharpDefault = parcelHelpers.interopDefault(_flightSharp);
var _flightTakeoff = require("./FlightTakeoff");
var _flightTakeoffDefault = parcelHelpers.interopDefault(_flightTakeoff);
var _flightTakeoffOutlined = require("./FlightTakeoffOutlined");
var _flightTakeoffOutlinedDefault = parcelHelpers.interopDefault(_flightTakeoffOutlined);
var _flightTakeoffRounded = require("./FlightTakeoffRounded");
var _flightTakeoffRoundedDefault = parcelHelpers.interopDefault(_flightTakeoffRounded);
var _flightTakeoffSharp = require("./FlightTakeoffSharp");
var _flightTakeoffSharpDefault = parcelHelpers.interopDefault(_flightTakeoffSharp);
var _flightTakeoffTwoTone = require("./FlightTakeoffTwoTone");
var _flightTakeoffTwoToneDefault = parcelHelpers.interopDefault(_flightTakeoffTwoTone);
var _flightTwoTone = require("./FlightTwoTone");
var _flightTwoToneDefault = parcelHelpers.interopDefault(_flightTwoTone);
var _flip = require("./Flip");
var _flipDefault = parcelHelpers.interopDefault(_flip);
var _flipCameraAndroid = require("./FlipCameraAndroid");
var _flipCameraAndroidDefault = parcelHelpers.interopDefault(_flipCameraAndroid);
var _flipCameraAndroidOutlined = require("./FlipCameraAndroidOutlined");
var _flipCameraAndroidOutlinedDefault = parcelHelpers.interopDefault(_flipCameraAndroidOutlined);
var _flipCameraAndroidRounded = require("./FlipCameraAndroidRounded");
var _flipCameraAndroidRoundedDefault = parcelHelpers.interopDefault(_flipCameraAndroidRounded);
var _flipCameraAndroidSharp = require("./FlipCameraAndroidSharp");
var _flipCameraAndroidSharpDefault = parcelHelpers.interopDefault(_flipCameraAndroidSharp);
var _flipCameraAndroidTwoTone = require("./FlipCameraAndroidTwoTone");
var _flipCameraAndroidTwoToneDefault = parcelHelpers.interopDefault(_flipCameraAndroidTwoTone);
var _flipCameraIos = require("./FlipCameraIos");
var _flipCameraIosDefault = parcelHelpers.interopDefault(_flipCameraIos);
var _flipCameraIosOutlined = require("./FlipCameraIosOutlined");
var _flipCameraIosOutlinedDefault = parcelHelpers.interopDefault(_flipCameraIosOutlined);
var _flipCameraIosRounded = require("./FlipCameraIosRounded");
var _flipCameraIosRoundedDefault = parcelHelpers.interopDefault(_flipCameraIosRounded);
var _flipCameraIosSharp = require("./FlipCameraIosSharp");
var _flipCameraIosSharpDefault = parcelHelpers.interopDefault(_flipCameraIosSharp);
var _flipCameraIosTwoTone = require("./FlipCameraIosTwoTone");
var _flipCameraIosTwoToneDefault = parcelHelpers.interopDefault(_flipCameraIosTwoTone);
var _flipOutlined = require("./FlipOutlined");
var _flipOutlinedDefault = parcelHelpers.interopDefault(_flipOutlined);
var _flipRounded = require("./FlipRounded");
var _flipRoundedDefault = parcelHelpers.interopDefault(_flipRounded);
var _flipSharp = require("./FlipSharp");
var _flipSharpDefault = parcelHelpers.interopDefault(_flipSharp);
var _flipToBack = require("./FlipToBack");
var _flipToBackDefault = parcelHelpers.interopDefault(_flipToBack);
var _flipToBackOutlined = require("./FlipToBackOutlined");
var _flipToBackOutlinedDefault = parcelHelpers.interopDefault(_flipToBackOutlined);
var _flipToBackRounded = require("./FlipToBackRounded");
var _flipToBackRoundedDefault = parcelHelpers.interopDefault(_flipToBackRounded);
var _flipToBackSharp = require("./FlipToBackSharp");
var _flipToBackSharpDefault = parcelHelpers.interopDefault(_flipToBackSharp);
var _flipToBackTwoTone = require("./FlipToBackTwoTone");
var _flipToBackTwoToneDefault = parcelHelpers.interopDefault(_flipToBackTwoTone);
var _flipToFront = require("./FlipToFront");
var _flipToFrontDefault = parcelHelpers.interopDefault(_flipToFront);
var _flipToFrontOutlined = require("./FlipToFrontOutlined");
var _flipToFrontOutlinedDefault = parcelHelpers.interopDefault(_flipToFrontOutlined);
var _flipToFrontRounded = require("./FlipToFrontRounded");
var _flipToFrontRoundedDefault = parcelHelpers.interopDefault(_flipToFrontRounded);
var _flipToFrontSharp = require("./FlipToFrontSharp");
var _flipToFrontSharpDefault = parcelHelpers.interopDefault(_flipToFrontSharp);
var _flipToFrontTwoTone = require("./FlipToFrontTwoTone");
var _flipToFrontTwoToneDefault = parcelHelpers.interopDefault(_flipToFrontTwoTone);
var _flipTwoTone = require("./FlipTwoTone");
var _flipTwoToneDefault = parcelHelpers.interopDefault(_flipTwoTone);
var _flood = require("./Flood");
var _floodDefault = parcelHelpers.interopDefault(_flood);
var _floodOutlined = require("./FloodOutlined");
var _floodOutlinedDefault = parcelHelpers.interopDefault(_floodOutlined);
var _floodRounded = require("./FloodRounded");
var _floodRoundedDefault = parcelHelpers.interopDefault(_floodRounded);
var _floodSharp = require("./FloodSharp");
var _floodSharpDefault = parcelHelpers.interopDefault(_floodSharp);
var _floodTwoTone = require("./FloodTwoTone");
var _floodTwoToneDefault = parcelHelpers.interopDefault(_floodTwoTone);
var _fluorescent = require("./Fluorescent");
var _fluorescentDefault = parcelHelpers.interopDefault(_fluorescent);
var _fluorescentOutlined = require("./FluorescentOutlined");
var _fluorescentOutlinedDefault = parcelHelpers.interopDefault(_fluorescentOutlined);
var _fluorescentRounded = require("./FluorescentRounded");
var _fluorescentRoundedDefault = parcelHelpers.interopDefault(_fluorescentRounded);
var _fluorescentSharp = require("./FluorescentSharp");
var _fluorescentSharpDefault = parcelHelpers.interopDefault(_fluorescentSharp);
var _fluorescentTwoTone = require("./FluorescentTwoTone");
var _fluorescentTwoToneDefault = parcelHelpers.interopDefault(_fluorescentTwoTone);
var _flutterDash = require("./FlutterDash");
var _flutterDashDefault = parcelHelpers.interopDefault(_flutterDash);
var _flutterDashOutlined = require("./FlutterDashOutlined");
var _flutterDashOutlinedDefault = parcelHelpers.interopDefault(_flutterDashOutlined);
var _flutterDashRounded = require("./FlutterDashRounded");
var _flutterDashRoundedDefault = parcelHelpers.interopDefault(_flutterDashRounded);
var _flutterDashSharp = require("./FlutterDashSharp");
var _flutterDashSharpDefault = parcelHelpers.interopDefault(_flutterDashSharp);
var _flutterDashTwoTone = require("./FlutterDashTwoTone");
var _flutterDashTwoToneDefault = parcelHelpers.interopDefault(_flutterDashTwoTone);
var _fmdBad = require("./FmdBad");
var _fmdBadDefault = parcelHelpers.interopDefault(_fmdBad);
var _fmdBadOutlined = require("./FmdBadOutlined");
var _fmdBadOutlinedDefault = parcelHelpers.interopDefault(_fmdBadOutlined);
var _fmdBadRounded = require("./FmdBadRounded");
var _fmdBadRoundedDefault = parcelHelpers.interopDefault(_fmdBadRounded);
var _fmdBadSharp = require("./FmdBadSharp");
var _fmdBadSharpDefault = parcelHelpers.interopDefault(_fmdBadSharp);
var _fmdBadTwoTone = require("./FmdBadTwoTone");
var _fmdBadTwoToneDefault = parcelHelpers.interopDefault(_fmdBadTwoTone);
var _fmdGood = require("./FmdGood");
var _fmdGoodDefault = parcelHelpers.interopDefault(_fmdGood);
var _fmdGoodOutlined = require("./FmdGoodOutlined");
var _fmdGoodOutlinedDefault = parcelHelpers.interopDefault(_fmdGoodOutlined);
var _fmdGoodRounded = require("./FmdGoodRounded");
var _fmdGoodRoundedDefault = parcelHelpers.interopDefault(_fmdGoodRounded);
var _fmdGoodSharp = require("./FmdGoodSharp");
var _fmdGoodSharpDefault = parcelHelpers.interopDefault(_fmdGoodSharp);
var _fmdGoodTwoTone = require("./FmdGoodTwoTone");
var _fmdGoodTwoToneDefault = parcelHelpers.interopDefault(_fmdGoodTwoTone);
var _folder = require("./Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _folderCopy = require("./FolderCopy");
var _folderCopyDefault = parcelHelpers.interopDefault(_folderCopy);
var _folderCopyOutlined = require("./FolderCopyOutlined");
var _folderCopyOutlinedDefault = parcelHelpers.interopDefault(_folderCopyOutlined);
var _folderCopyRounded = require("./FolderCopyRounded");
var _folderCopyRoundedDefault = parcelHelpers.interopDefault(_folderCopyRounded);
var _folderCopySharp = require("./FolderCopySharp");
var _folderCopySharpDefault = parcelHelpers.interopDefault(_folderCopySharp);
var _folderCopyTwoTone = require("./FolderCopyTwoTone");
var _folderCopyTwoToneDefault = parcelHelpers.interopDefault(_folderCopyTwoTone);
var _folderDelete = require("./FolderDelete");
var _folderDeleteDefault = parcelHelpers.interopDefault(_folderDelete);
var _folderDeleteOutlined = require("./FolderDeleteOutlined");
var _folderDeleteOutlinedDefault = parcelHelpers.interopDefault(_folderDeleteOutlined);
var _folderDeleteRounded = require("./FolderDeleteRounded");
var _folderDeleteRoundedDefault = parcelHelpers.interopDefault(_folderDeleteRounded);
var _folderDeleteSharp = require("./FolderDeleteSharp");
var _folderDeleteSharpDefault = parcelHelpers.interopDefault(_folderDeleteSharp);
var _folderDeleteTwoTone = require("./FolderDeleteTwoTone");
var _folderDeleteTwoToneDefault = parcelHelpers.interopDefault(_folderDeleteTwoTone);
var _folderOff = require("./FolderOff");
var _folderOffDefault = parcelHelpers.interopDefault(_folderOff);
var _folderOffOutlined = require("./FolderOffOutlined");
var _folderOffOutlinedDefault = parcelHelpers.interopDefault(_folderOffOutlined);
var _folderOffRounded = require("./FolderOffRounded");
var _folderOffRoundedDefault = parcelHelpers.interopDefault(_folderOffRounded);
var _folderOffSharp = require("./FolderOffSharp");
var _folderOffSharpDefault = parcelHelpers.interopDefault(_folderOffSharp);
var _folderOffTwoTone = require("./FolderOffTwoTone");
var _folderOffTwoToneDefault = parcelHelpers.interopDefault(_folderOffTwoTone);
var _folderOpen = require("./FolderOpen");
var _folderOpenDefault = parcelHelpers.interopDefault(_folderOpen);
var _folderOpenOutlined = require("./FolderOpenOutlined");
var _folderOpenOutlinedDefault = parcelHelpers.interopDefault(_folderOpenOutlined);
var _folderOpenRounded = require("./FolderOpenRounded");
var _folderOpenRoundedDefault = parcelHelpers.interopDefault(_folderOpenRounded);
var _folderOpenSharp = require("./FolderOpenSharp");
var _folderOpenSharpDefault = parcelHelpers.interopDefault(_folderOpenSharp);
var _folderOpenTwoTone = require("./FolderOpenTwoTone");
var _folderOpenTwoToneDefault = parcelHelpers.interopDefault(_folderOpenTwoTone);
var _folderOutlined = require("./FolderOutlined");
var _folderOutlinedDefault = parcelHelpers.interopDefault(_folderOutlined);
var _folderRounded = require("./FolderRounded");
var _folderRoundedDefault = parcelHelpers.interopDefault(_folderRounded);
var _folderShared = require("./FolderShared");
var _folderSharedDefault = parcelHelpers.interopDefault(_folderShared);
var _folderSharedOutlined = require("./FolderSharedOutlined");
var _folderSharedOutlinedDefault = parcelHelpers.interopDefault(_folderSharedOutlined);
var _folderSharedRounded = require("./FolderSharedRounded");
var _folderSharedRoundedDefault = parcelHelpers.interopDefault(_folderSharedRounded);
var _folderSharedSharp = require("./FolderSharedSharp");
var _folderSharedSharpDefault = parcelHelpers.interopDefault(_folderSharedSharp);
var _folderSharedTwoTone = require("./FolderSharedTwoTone");
var _folderSharedTwoToneDefault = parcelHelpers.interopDefault(_folderSharedTwoTone);
var _folderSharp = require("./FolderSharp");
var _folderSharpDefault = parcelHelpers.interopDefault(_folderSharp);
var _folderSpecial = require("./FolderSpecial");
var _folderSpecialDefault = parcelHelpers.interopDefault(_folderSpecial);
var _folderSpecialOutlined = require("./FolderSpecialOutlined");
var _folderSpecialOutlinedDefault = parcelHelpers.interopDefault(_folderSpecialOutlined);
var _folderSpecialRounded = require("./FolderSpecialRounded");
var _folderSpecialRoundedDefault = parcelHelpers.interopDefault(_folderSpecialRounded);
var _folderSpecialSharp = require("./FolderSpecialSharp");
var _folderSpecialSharpDefault = parcelHelpers.interopDefault(_folderSpecialSharp);
var _folderSpecialTwoTone = require("./FolderSpecialTwoTone");
var _folderSpecialTwoToneDefault = parcelHelpers.interopDefault(_folderSpecialTwoTone);
var _folderTwoTone = require("./FolderTwoTone");
var _folderTwoToneDefault = parcelHelpers.interopDefault(_folderTwoTone);
var _folderZip = require("./FolderZip");
var _folderZipDefault = parcelHelpers.interopDefault(_folderZip);
var _folderZipOutlined = require("./FolderZipOutlined");
var _folderZipOutlinedDefault = parcelHelpers.interopDefault(_folderZipOutlined);
var _folderZipRounded = require("./FolderZipRounded");
var _folderZipRoundedDefault = parcelHelpers.interopDefault(_folderZipRounded);
var _folderZipSharp = require("./FolderZipSharp");
var _folderZipSharpDefault = parcelHelpers.interopDefault(_folderZipSharp);
var _folderZipTwoTone = require("./FolderZipTwoTone");
var _folderZipTwoToneDefault = parcelHelpers.interopDefault(_folderZipTwoTone);
var _followTheSigns = require("./FollowTheSigns");
var _followTheSignsDefault = parcelHelpers.interopDefault(_followTheSigns);
var _followTheSignsOutlined = require("./FollowTheSignsOutlined");
var _followTheSignsOutlinedDefault = parcelHelpers.interopDefault(_followTheSignsOutlined);
var _followTheSignsRounded = require("./FollowTheSignsRounded");
var _followTheSignsRoundedDefault = parcelHelpers.interopDefault(_followTheSignsRounded);
var _followTheSignsSharp = require("./FollowTheSignsSharp");
var _followTheSignsSharpDefault = parcelHelpers.interopDefault(_followTheSignsSharp);
var _followTheSignsTwoTone = require("./FollowTheSignsTwoTone");
var _followTheSignsTwoToneDefault = parcelHelpers.interopDefault(_followTheSignsTwoTone);
var _fontDownload = require("./FontDownload");
var _fontDownloadDefault = parcelHelpers.interopDefault(_fontDownload);
var _fontDownloadOff = require("./FontDownloadOff");
var _fontDownloadOffDefault = parcelHelpers.interopDefault(_fontDownloadOff);
var _fontDownloadOffOutlined = require("./FontDownloadOffOutlined");
var _fontDownloadOffOutlinedDefault = parcelHelpers.interopDefault(_fontDownloadOffOutlined);
var _fontDownloadOffRounded = require("./FontDownloadOffRounded");
var _fontDownloadOffRoundedDefault = parcelHelpers.interopDefault(_fontDownloadOffRounded);
var _fontDownloadOffSharp = require("./FontDownloadOffSharp");
var _fontDownloadOffSharpDefault = parcelHelpers.interopDefault(_fontDownloadOffSharp);
var _fontDownloadOffTwoTone = require("./FontDownloadOffTwoTone");
var _fontDownloadOffTwoToneDefault = parcelHelpers.interopDefault(_fontDownloadOffTwoTone);
var _fontDownloadOutlined = require("./FontDownloadOutlined");
var _fontDownloadOutlinedDefault = parcelHelpers.interopDefault(_fontDownloadOutlined);
var _fontDownloadRounded = require("./FontDownloadRounded");
var _fontDownloadRoundedDefault = parcelHelpers.interopDefault(_fontDownloadRounded);
var _fontDownloadSharp = require("./FontDownloadSharp");
var _fontDownloadSharpDefault = parcelHelpers.interopDefault(_fontDownloadSharp);
var _fontDownloadTwoTone = require("./FontDownloadTwoTone");
var _fontDownloadTwoToneDefault = parcelHelpers.interopDefault(_fontDownloadTwoTone);
var _foodBank = require("./FoodBank");
var _foodBankDefault = parcelHelpers.interopDefault(_foodBank);
var _foodBankOutlined = require("./FoodBankOutlined");
var _foodBankOutlinedDefault = parcelHelpers.interopDefault(_foodBankOutlined);
var _foodBankRounded = require("./FoodBankRounded");
var _foodBankRoundedDefault = parcelHelpers.interopDefault(_foodBankRounded);
var _foodBankSharp = require("./FoodBankSharp");
var _foodBankSharpDefault = parcelHelpers.interopDefault(_foodBankSharp);
var _foodBankTwoTone = require("./FoodBankTwoTone");
var _foodBankTwoToneDefault = parcelHelpers.interopDefault(_foodBankTwoTone);
var _forest = require("./Forest");
var _forestDefault = parcelHelpers.interopDefault(_forest);
var _forestOutlined = require("./ForestOutlined");
var _forestOutlinedDefault = parcelHelpers.interopDefault(_forestOutlined);
var _forestRounded = require("./ForestRounded");
var _forestRoundedDefault = parcelHelpers.interopDefault(_forestRounded);
var _forestSharp = require("./ForestSharp");
var _forestSharpDefault = parcelHelpers.interopDefault(_forestSharp);
var _forestTwoTone = require("./ForestTwoTone");
var _forestTwoToneDefault = parcelHelpers.interopDefault(_forestTwoTone);
var _forkLeft = require("./ForkLeft");
var _forkLeftDefault = parcelHelpers.interopDefault(_forkLeft);
var _forkLeftOutlined = require("./ForkLeftOutlined");
var _forkLeftOutlinedDefault = parcelHelpers.interopDefault(_forkLeftOutlined);
var _forkLeftRounded = require("./ForkLeftRounded");
var _forkLeftRoundedDefault = parcelHelpers.interopDefault(_forkLeftRounded);
var _forkLeftSharp = require("./ForkLeftSharp");
var _forkLeftSharpDefault = parcelHelpers.interopDefault(_forkLeftSharp);
var _forkLeftTwoTone = require("./ForkLeftTwoTone");
var _forkLeftTwoToneDefault = parcelHelpers.interopDefault(_forkLeftTwoTone);
var _forkRight = require("./ForkRight");
var _forkRightDefault = parcelHelpers.interopDefault(_forkRight);
var _forkRightOutlined = require("./ForkRightOutlined");
var _forkRightOutlinedDefault = parcelHelpers.interopDefault(_forkRightOutlined);
var _forkRightRounded = require("./ForkRightRounded");
var _forkRightRoundedDefault = parcelHelpers.interopDefault(_forkRightRounded);
var _forkRightSharp = require("./ForkRightSharp");
var _forkRightSharpDefault = parcelHelpers.interopDefault(_forkRightSharp);
var _forkRightTwoTone = require("./ForkRightTwoTone");
var _forkRightTwoToneDefault = parcelHelpers.interopDefault(_forkRightTwoTone);
var _formatAlignCenter = require("./FormatAlignCenter");
var _formatAlignCenterDefault = parcelHelpers.interopDefault(_formatAlignCenter);
var _formatAlignCenterOutlined = require("./FormatAlignCenterOutlined");
var _formatAlignCenterOutlinedDefault = parcelHelpers.interopDefault(_formatAlignCenterOutlined);
var _formatAlignCenterRounded = require("./FormatAlignCenterRounded");
var _formatAlignCenterRoundedDefault = parcelHelpers.interopDefault(_formatAlignCenterRounded);
var _formatAlignCenterSharp = require("./FormatAlignCenterSharp");
var _formatAlignCenterSharpDefault = parcelHelpers.interopDefault(_formatAlignCenterSharp);
var _formatAlignCenterTwoTone = require("./FormatAlignCenterTwoTone");
var _formatAlignCenterTwoToneDefault = parcelHelpers.interopDefault(_formatAlignCenterTwoTone);
var _formatAlignJustify = require("./FormatAlignJustify");
var _formatAlignJustifyDefault = parcelHelpers.interopDefault(_formatAlignJustify);
var _formatAlignJustifyOutlined = require("./FormatAlignJustifyOutlined");
var _formatAlignJustifyOutlinedDefault = parcelHelpers.interopDefault(_formatAlignJustifyOutlined);
var _formatAlignJustifyRounded = require("./FormatAlignJustifyRounded");
var _formatAlignJustifyRoundedDefault = parcelHelpers.interopDefault(_formatAlignJustifyRounded);
var _formatAlignJustifySharp = require("./FormatAlignJustifySharp");
var _formatAlignJustifySharpDefault = parcelHelpers.interopDefault(_formatAlignJustifySharp);
var _formatAlignJustifyTwoTone = require("./FormatAlignJustifyTwoTone");
var _formatAlignJustifyTwoToneDefault = parcelHelpers.interopDefault(_formatAlignJustifyTwoTone);
var _formatAlignLeft = require("./FormatAlignLeft");
var _formatAlignLeftDefault = parcelHelpers.interopDefault(_formatAlignLeft);
var _formatAlignLeftOutlined = require("./FormatAlignLeftOutlined");
var _formatAlignLeftOutlinedDefault = parcelHelpers.interopDefault(_formatAlignLeftOutlined);
var _formatAlignLeftRounded = require("./FormatAlignLeftRounded");
var _formatAlignLeftRoundedDefault = parcelHelpers.interopDefault(_formatAlignLeftRounded);
var _formatAlignLeftSharp = require("./FormatAlignLeftSharp");
var _formatAlignLeftSharpDefault = parcelHelpers.interopDefault(_formatAlignLeftSharp);
var _formatAlignLeftTwoTone = require("./FormatAlignLeftTwoTone");
var _formatAlignLeftTwoToneDefault = parcelHelpers.interopDefault(_formatAlignLeftTwoTone);
var _formatAlignRight = require("./FormatAlignRight");
var _formatAlignRightDefault = parcelHelpers.interopDefault(_formatAlignRight);
var _formatAlignRightOutlined = require("./FormatAlignRightOutlined");
var _formatAlignRightOutlinedDefault = parcelHelpers.interopDefault(_formatAlignRightOutlined);
var _formatAlignRightRounded = require("./FormatAlignRightRounded");
var _formatAlignRightRoundedDefault = parcelHelpers.interopDefault(_formatAlignRightRounded);
var _formatAlignRightSharp = require("./FormatAlignRightSharp");
var _formatAlignRightSharpDefault = parcelHelpers.interopDefault(_formatAlignRightSharp);
var _formatAlignRightTwoTone = require("./FormatAlignRightTwoTone");
var _formatAlignRightTwoToneDefault = parcelHelpers.interopDefault(_formatAlignRightTwoTone);
var _formatBold = require("./FormatBold");
var _formatBoldDefault = parcelHelpers.interopDefault(_formatBold);
var _formatBoldOutlined = require("./FormatBoldOutlined");
var _formatBoldOutlinedDefault = parcelHelpers.interopDefault(_formatBoldOutlined);
var _formatBoldRounded = require("./FormatBoldRounded");
var _formatBoldRoundedDefault = parcelHelpers.interopDefault(_formatBoldRounded);
var _formatBoldSharp = require("./FormatBoldSharp");
var _formatBoldSharpDefault = parcelHelpers.interopDefault(_formatBoldSharp);
var _formatBoldTwoTone = require("./FormatBoldTwoTone");
var _formatBoldTwoToneDefault = parcelHelpers.interopDefault(_formatBoldTwoTone);
var _formatClear = require("./FormatClear");
var _formatClearDefault = parcelHelpers.interopDefault(_formatClear);
var _formatClearOutlined = require("./FormatClearOutlined");
var _formatClearOutlinedDefault = parcelHelpers.interopDefault(_formatClearOutlined);
var _formatClearRounded = require("./FormatClearRounded");
var _formatClearRoundedDefault = parcelHelpers.interopDefault(_formatClearRounded);
var _formatClearSharp = require("./FormatClearSharp");
var _formatClearSharpDefault = parcelHelpers.interopDefault(_formatClearSharp);
var _formatClearTwoTone = require("./FormatClearTwoTone");
var _formatClearTwoToneDefault = parcelHelpers.interopDefault(_formatClearTwoTone);
var _formatColorFill = require("./FormatColorFill");
var _formatColorFillDefault = parcelHelpers.interopDefault(_formatColorFill);
var _formatColorFillOutlined = require("./FormatColorFillOutlined");
var _formatColorFillOutlinedDefault = parcelHelpers.interopDefault(_formatColorFillOutlined);
var _formatColorFillRounded = require("./FormatColorFillRounded");
var _formatColorFillRoundedDefault = parcelHelpers.interopDefault(_formatColorFillRounded);
var _formatColorFillSharp = require("./FormatColorFillSharp");
var _formatColorFillSharpDefault = parcelHelpers.interopDefault(_formatColorFillSharp);
var _formatColorFillTwoTone = require("./FormatColorFillTwoTone");
var _formatColorFillTwoToneDefault = parcelHelpers.interopDefault(_formatColorFillTwoTone);
var _formatColorReset = require("./FormatColorReset");
var _formatColorResetDefault = parcelHelpers.interopDefault(_formatColorReset);
var _formatColorResetOutlined = require("./FormatColorResetOutlined");
var _formatColorResetOutlinedDefault = parcelHelpers.interopDefault(_formatColorResetOutlined);
var _formatColorResetRounded = require("./FormatColorResetRounded");
var _formatColorResetRoundedDefault = parcelHelpers.interopDefault(_formatColorResetRounded);
var _formatColorResetSharp = require("./FormatColorResetSharp");
var _formatColorResetSharpDefault = parcelHelpers.interopDefault(_formatColorResetSharp);
var _formatColorResetTwoTone = require("./FormatColorResetTwoTone");
var _formatColorResetTwoToneDefault = parcelHelpers.interopDefault(_formatColorResetTwoTone);
var _formatColorText = require("./FormatColorText");
var _formatColorTextDefault = parcelHelpers.interopDefault(_formatColorText);
var _formatColorTextOutlined = require("./FormatColorTextOutlined");
var _formatColorTextOutlinedDefault = parcelHelpers.interopDefault(_formatColorTextOutlined);
var _formatColorTextRounded = require("./FormatColorTextRounded");
var _formatColorTextRoundedDefault = parcelHelpers.interopDefault(_formatColorTextRounded);
var _formatColorTextSharp = require("./FormatColorTextSharp");
var _formatColorTextSharpDefault = parcelHelpers.interopDefault(_formatColorTextSharp);
var _formatColorTextTwoTone = require("./FormatColorTextTwoTone");
var _formatColorTextTwoToneDefault = parcelHelpers.interopDefault(_formatColorTextTwoTone);
var _formatIndentDecrease = require("./FormatIndentDecrease");
var _formatIndentDecreaseDefault = parcelHelpers.interopDefault(_formatIndentDecrease);
var _formatIndentDecreaseOutlined = require("./FormatIndentDecreaseOutlined");
var _formatIndentDecreaseOutlinedDefault = parcelHelpers.interopDefault(_formatIndentDecreaseOutlined);
var _formatIndentDecreaseRounded = require("./FormatIndentDecreaseRounded");
var _formatIndentDecreaseRoundedDefault = parcelHelpers.interopDefault(_formatIndentDecreaseRounded);
var _formatIndentDecreaseSharp = require("./FormatIndentDecreaseSharp");
var _formatIndentDecreaseSharpDefault = parcelHelpers.interopDefault(_formatIndentDecreaseSharp);
var _formatIndentDecreaseTwoTone = require("./FormatIndentDecreaseTwoTone");
var _formatIndentDecreaseTwoToneDefault = parcelHelpers.interopDefault(_formatIndentDecreaseTwoTone);
var _formatIndentIncrease = require("./FormatIndentIncrease");
var _formatIndentIncreaseDefault = parcelHelpers.interopDefault(_formatIndentIncrease);
var _formatIndentIncreaseOutlined = require("./FormatIndentIncreaseOutlined");
var _formatIndentIncreaseOutlinedDefault = parcelHelpers.interopDefault(_formatIndentIncreaseOutlined);
var _formatIndentIncreaseRounded = require("./FormatIndentIncreaseRounded");
var _formatIndentIncreaseRoundedDefault = parcelHelpers.interopDefault(_formatIndentIncreaseRounded);
var _formatIndentIncreaseSharp = require("./FormatIndentIncreaseSharp");
var _formatIndentIncreaseSharpDefault = parcelHelpers.interopDefault(_formatIndentIncreaseSharp);
var _formatIndentIncreaseTwoTone = require("./FormatIndentIncreaseTwoTone");
var _formatIndentIncreaseTwoToneDefault = parcelHelpers.interopDefault(_formatIndentIncreaseTwoTone);
var _formatItalic = require("./FormatItalic");
var _formatItalicDefault = parcelHelpers.interopDefault(_formatItalic);
var _formatItalicOutlined = require("./FormatItalicOutlined");
var _formatItalicOutlinedDefault = parcelHelpers.interopDefault(_formatItalicOutlined);
var _formatItalicRounded = require("./FormatItalicRounded");
var _formatItalicRoundedDefault = parcelHelpers.interopDefault(_formatItalicRounded);
var _formatItalicSharp = require("./FormatItalicSharp");
var _formatItalicSharpDefault = parcelHelpers.interopDefault(_formatItalicSharp);
var _formatItalicTwoTone = require("./FormatItalicTwoTone");
var _formatItalicTwoToneDefault = parcelHelpers.interopDefault(_formatItalicTwoTone);
var _formatLineSpacing = require("./FormatLineSpacing");
var _formatLineSpacingDefault = parcelHelpers.interopDefault(_formatLineSpacing);
var _formatLineSpacingOutlined = require("./FormatLineSpacingOutlined");
var _formatLineSpacingOutlinedDefault = parcelHelpers.interopDefault(_formatLineSpacingOutlined);
var _formatLineSpacingRounded = require("./FormatLineSpacingRounded");
var _formatLineSpacingRoundedDefault = parcelHelpers.interopDefault(_formatLineSpacingRounded);
var _formatLineSpacingSharp = require("./FormatLineSpacingSharp");
var _formatLineSpacingSharpDefault = parcelHelpers.interopDefault(_formatLineSpacingSharp);
var _formatLineSpacingTwoTone = require("./FormatLineSpacingTwoTone");
var _formatLineSpacingTwoToneDefault = parcelHelpers.interopDefault(_formatLineSpacingTwoTone);
var _formatListBulleted = require("./FormatListBulleted");
var _formatListBulletedDefault = parcelHelpers.interopDefault(_formatListBulleted);
var _formatListBulletedOutlined = require("./FormatListBulletedOutlined");
var _formatListBulletedOutlinedDefault = parcelHelpers.interopDefault(_formatListBulletedOutlined);
var _formatListBulletedRounded = require("./FormatListBulletedRounded");
var _formatListBulletedRoundedDefault = parcelHelpers.interopDefault(_formatListBulletedRounded);
var _formatListBulletedSharp = require("./FormatListBulletedSharp");
var _formatListBulletedSharpDefault = parcelHelpers.interopDefault(_formatListBulletedSharp);
var _formatListBulletedTwoTone = require("./FormatListBulletedTwoTone");
var _formatListBulletedTwoToneDefault = parcelHelpers.interopDefault(_formatListBulletedTwoTone);
var _formatListNumbered = require("./FormatListNumbered");
var _formatListNumberedDefault = parcelHelpers.interopDefault(_formatListNumbered);
var _formatListNumberedOutlined = require("./FormatListNumberedOutlined");
var _formatListNumberedOutlinedDefault = parcelHelpers.interopDefault(_formatListNumberedOutlined);
var _formatListNumberedRounded = require("./FormatListNumberedRounded");
var _formatListNumberedRoundedDefault = parcelHelpers.interopDefault(_formatListNumberedRounded);
var _formatListNumberedRtl = require("./FormatListNumberedRtl");
var _formatListNumberedRtlDefault = parcelHelpers.interopDefault(_formatListNumberedRtl);
var _formatListNumberedRtlOutlined = require("./FormatListNumberedRtlOutlined");
var _formatListNumberedRtlOutlinedDefault = parcelHelpers.interopDefault(_formatListNumberedRtlOutlined);
var _formatListNumberedRtlRounded = require("./FormatListNumberedRtlRounded");
var _formatListNumberedRtlRoundedDefault = parcelHelpers.interopDefault(_formatListNumberedRtlRounded);
var _formatListNumberedRtlSharp = require("./FormatListNumberedRtlSharp");
var _formatListNumberedRtlSharpDefault = parcelHelpers.interopDefault(_formatListNumberedRtlSharp);
var _formatListNumberedRtlTwoTone = require("./FormatListNumberedRtlTwoTone");
var _formatListNumberedRtlTwoToneDefault = parcelHelpers.interopDefault(_formatListNumberedRtlTwoTone);
var _formatListNumberedSharp = require("./FormatListNumberedSharp");
var _formatListNumberedSharpDefault = parcelHelpers.interopDefault(_formatListNumberedSharp);
var _formatListNumberedTwoTone = require("./FormatListNumberedTwoTone");
var _formatListNumberedTwoToneDefault = parcelHelpers.interopDefault(_formatListNumberedTwoTone);
var _formatOverline = require("./FormatOverline");
var _formatOverlineDefault = parcelHelpers.interopDefault(_formatOverline);
var _formatOverlineOutlined = require("./FormatOverlineOutlined");
var _formatOverlineOutlinedDefault = parcelHelpers.interopDefault(_formatOverlineOutlined);
var _formatOverlineRounded = require("./FormatOverlineRounded");
var _formatOverlineRoundedDefault = parcelHelpers.interopDefault(_formatOverlineRounded);
var _formatOverlineSharp = require("./FormatOverlineSharp");
var _formatOverlineSharpDefault = parcelHelpers.interopDefault(_formatOverlineSharp);
var _formatOverlineTwoTone = require("./FormatOverlineTwoTone");
var _formatOverlineTwoToneDefault = parcelHelpers.interopDefault(_formatOverlineTwoTone);
var _formatPaint = require("./FormatPaint");
var _formatPaintDefault = parcelHelpers.interopDefault(_formatPaint);
var _formatPaintOutlined = require("./FormatPaintOutlined");
var _formatPaintOutlinedDefault = parcelHelpers.interopDefault(_formatPaintOutlined);
var _formatPaintRounded = require("./FormatPaintRounded");
var _formatPaintRoundedDefault = parcelHelpers.interopDefault(_formatPaintRounded);
var _formatPaintSharp = require("./FormatPaintSharp");
var _formatPaintSharpDefault = parcelHelpers.interopDefault(_formatPaintSharp);
var _formatPaintTwoTone = require("./FormatPaintTwoTone");
var _formatPaintTwoToneDefault = parcelHelpers.interopDefault(_formatPaintTwoTone);
var _formatQuote = require("./FormatQuote");
var _formatQuoteDefault = parcelHelpers.interopDefault(_formatQuote);
var _formatQuoteOutlined = require("./FormatQuoteOutlined");
var _formatQuoteOutlinedDefault = parcelHelpers.interopDefault(_formatQuoteOutlined);
var _formatQuoteRounded = require("./FormatQuoteRounded");
var _formatQuoteRoundedDefault = parcelHelpers.interopDefault(_formatQuoteRounded);
var _formatQuoteSharp = require("./FormatQuoteSharp");
var _formatQuoteSharpDefault = parcelHelpers.interopDefault(_formatQuoteSharp);
var _formatQuoteTwoTone = require("./FormatQuoteTwoTone");
var _formatQuoteTwoToneDefault = parcelHelpers.interopDefault(_formatQuoteTwoTone);
var _formatShapes = require("./FormatShapes");
var _formatShapesDefault = parcelHelpers.interopDefault(_formatShapes);
var _formatShapesOutlined = require("./FormatShapesOutlined");
var _formatShapesOutlinedDefault = parcelHelpers.interopDefault(_formatShapesOutlined);
var _formatShapesRounded = require("./FormatShapesRounded");
var _formatShapesRoundedDefault = parcelHelpers.interopDefault(_formatShapesRounded);
var _formatShapesSharp = require("./FormatShapesSharp");
var _formatShapesSharpDefault = parcelHelpers.interopDefault(_formatShapesSharp);
var _formatShapesTwoTone = require("./FormatShapesTwoTone");
var _formatShapesTwoToneDefault = parcelHelpers.interopDefault(_formatShapesTwoTone);
var _formatSize = require("./FormatSize");
var _formatSizeDefault = parcelHelpers.interopDefault(_formatSize);
var _formatSizeOutlined = require("./FormatSizeOutlined");
var _formatSizeOutlinedDefault = parcelHelpers.interopDefault(_formatSizeOutlined);
var _formatSizeRounded = require("./FormatSizeRounded");
var _formatSizeRoundedDefault = parcelHelpers.interopDefault(_formatSizeRounded);
var _formatSizeSharp = require("./FormatSizeSharp");
var _formatSizeSharpDefault = parcelHelpers.interopDefault(_formatSizeSharp);
var _formatSizeTwoTone = require("./FormatSizeTwoTone");
var _formatSizeTwoToneDefault = parcelHelpers.interopDefault(_formatSizeTwoTone);
var _formatStrikethrough = require("./FormatStrikethrough");
var _formatStrikethroughDefault = parcelHelpers.interopDefault(_formatStrikethrough);
var _formatStrikethroughOutlined = require("./FormatStrikethroughOutlined");
var _formatStrikethroughOutlinedDefault = parcelHelpers.interopDefault(_formatStrikethroughOutlined);
var _formatStrikethroughRounded = require("./FormatStrikethroughRounded");
var _formatStrikethroughRoundedDefault = parcelHelpers.interopDefault(_formatStrikethroughRounded);
var _formatStrikethroughSharp = require("./FormatStrikethroughSharp");
var _formatStrikethroughSharpDefault = parcelHelpers.interopDefault(_formatStrikethroughSharp);
var _formatStrikethroughTwoTone = require("./FormatStrikethroughTwoTone");
var _formatStrikethroughTwoToneDefault = parcelHelpers.interopDefault(_formatStrikethroughTwoTone);
var _formatTextdirectionLToR = require("./FormatTextdirectionLToR");
var _formatTextdirectionLToRDefault = parcelHelpers.interopDefault(_formatTextdirectionLToR);
var _formatTextdirectionLToROutlined = require("./FormatTextdirectionLToROutlined");
var _formatTextdirectionLToROutlinedDefault = parcelHelpers.interopDefault(_formatTextdirectionLToROutlined);
var _formatTextdirectionLToRRounded = require("./FormatTextdirectionLToRRounded");
var _formatTextdirectionLToRRoundedDefault = parcelHelpers.interopDefault(_formatTextdirectionLToRRounded);
var _formatTextdirectionLToRSharp = require("./FormatTextdirectionLToRSharp");
var _formatTextdirectionLToRSharpDefault = parcelHelpers.interopDefault(_formatTextdirectionLToRSharp);
var _formatTextdirectionLToRTwoTone = require("./FormatTextdirectionLToRTwoTone");
var _formatTextdirectionLToRTwoToneDefault = parcelHelpers.interopDefault(_formatTextdirectionLToRTwoTone);
var _formatTextdirectionRToL = require("./FormatTextdirectionRToL");
var _formatTextdirectionRToLDefault = parcelHelpers.interopDefault(_formatTextdirectionRToL);
var _formatTextdirectionRToLOutlined = require("./FormatTextdirectionRToLOutlined");
var _formatTextdirectionRToLOutlinedDefault = parcelHelpers.interopDefault(_formatTextdirectionRToLOutlined);
var _formatTextdirectionRToLRounded = require("./FormatTextdirectionRToLRounded");
var _formatTextdirectionRToLRoundedDefault = parcelHelpers.interopDefault(_formatTextdirectionRToLRounded);
var _formatTextdirectionRToLSharp = require("./FormatTextdirectionRToLSharp");
var _formatTextdirectionRToLSharpDefault = parcelHelpers.interopDefault(_formatTextdirectionRToLSharp);
var _formatTextdirectionRToLTwoTone = require("./FormatTextdirectionRToLTwoTone");
var _formatTextdirectionRToLTwoToneDefault = parcelHelpers.interopDefault(_formatTextdirectionRToLTwoTone);
var _formatUnderlined = require("./FormatUnderlined");
var _formatUnderlinedDefault = parcelHelpers.interopDefault(_formatUnderlined);
var _formatUnderlinedOutlined = require("./FormatUnderlinedOutlined");
var _formatUnderlinedOutlinedDefault = parcelHelpers.interopDefault(_formatUnderlinedOutlined);
var _formatUnderlinedRounded = require("./FormatUnderlinedRounded");
var _formatUnderlinedRoundedDefault = parcelHelpers.interopDefault(_formatUnderlinedRounded);
var _formatUnderlinedSharp = require("./FormatUnderlinedSharp");
var _formatUnderlinedSharpDefault = parcelHelpers.interopDefault(_formatUnderlinedSharp);
var _formatUnderlinedTwoTone = require("./FormatUnderlinedTwoTone");
var _formatUnderlinedTwoToneDefault = parcelHelpers.interopDefault(_formatUnderlinedTwoTone);
var _fort = require("./Fort");
var _fortDefault = parcelHelpers.interopDefault(_fort);
var _fortOutlined = require("./FortOutlined");
var _fortOutlinedDefault = parcelHelpers.interopDefault(_fortOutlined);
var _fortRounded = require("./FortRounded");
var _fortRoundedDefault = parcelHelpers.interopDefault(_fortRounded);
var _fortSharp = require("./FortSharp");
var _fortSharpDefault = parcelHelpers.interopDefault(_fortSharp);
var _fortTwoTone = require("./FortTwoTone");
var _fortTwoToneDefault = parcelHelpers.interopDefault(_fortTwoTone);
var _forum = require("./Forum");
var _forumDefault = parcelHelpers.interopDefault(_forum);
var _forumOutlined = require("./ForumOutlined");
var _forumOutlinedDefault = parcelHelpers.interopDefault(_forumOutlined);
var _forumRounded = require("./ForumRounded");
var _forumRoundedDefault = parcelHelpers.interopDefault(_forumRounded);
var _forumSharp = require("./ForumSharp");
var _forumSharpDefault = parcelHelpers.interopDefault(_forumSharp);
var _forumTwoTone = require("./ForumTwoTone");
var _forumTwoToneDefault = parcelHelpers.interopDefault(_forumTwoTone);
var _forward = require("./Forward");
var _forwardDefault = parcelHelpers.interopDefault(_forward);
var _forward10 = require("./Forward10");
var _forward10Default = parcelHelpers.interopDefault(_forward10);
var _forward10Outlined = require("./Forward10Outlined");
var _forward10OutlinedDefault = parcelHelpers.interopDefault(_forward10Outlined);
var _forward10Rounded = require("./Forward10Rounded");
var _forward10RoundedDefault = parcelHelpers.interopDefault(_forward10Rounded);
var _forward10Sharp = require("./Forward10Sharp");
var _forward10SharpDefault = parcelHelpers.interopDefault(_forward10Sharp);
var _forward10TwoTone = require("./Forward10TwoTone");
var _forward10TwoToneDefault = parcelHelpers.interopDefault(_forward10TwoTone);
var _forward30 = require("./Forward30");
var _forward30Default = parcelHelpers.interopDefault(_forward30);
var _forward30Outlined = require("./Forward30Outlined");
var _forward30OutlinedDefault = parcelHelpers.interopDefault(_forward30Outlined);
var _forward30Rounded = require("./Forward30Rounded");
var _forward30RoundedDefault = parcelHelpers.interopDefault(_forward30Rounded);
var _forward30Sharp = require("./Forward30Sharp");
var _forward30SharpDefault = parcelHelpers.interopDefault(_forward30Sharp);
var _forward30TwoTone = require("./Forward30TwoTone");
var _forward30TwoToneDefault = parcelHelpers.interopDefault(_forward30TwoTone);
var _forward5 = require("./Forward5");
var _forward5Default = parcelHelpers.interopDefault(_forward5);
var _forward5Outlined = require("./Forward5Outlined");
var _forward5OutlinedDefault = parcelHelpers.interopDefault(_forward5Outlined);
var _forward5Rounded = require("./Forward5Rounded");
var _forward5RoundedDefault = parcelHelpers.interopDefault(_forward5Rounded);
var _forward5Sharp = require("./Forward5Sharp");
var _forward5SharpDefault = parcelHelpers.interopDefault(_forward5Sharp);
var _forward5TwoTone = require("./Forward5TwoTone");
var _forward5TwoToneDefault = parcelHelpers.interopDefault(_forward5TwoTone);
var _forwardOutlined = require("./ForwardOutlined");
var _forwardOutlinedDefault = parcelHelpers.interopDefault(_forwardOutlined);
var _forwardRounded = require("./ForwardRounded");
var _forwardRoundedDefault = parcelHelpers.interopDefault(_forwardRounded);
var _forwardSharp = require("./ForwardSharp");
var _forwardSharpDefault = parcelHelpers.interopDefault(_forwardSharp);
var _forwardToInbox = require("./ForwardToInbox");
var _forwardToInboxDefault = parcelHelpers.interopDefault(_forwardToInbox);
var _forwardToInboxOutlined = require("./ForwardToInboxOutlined");
var _forwardToInboxOutlinedDefault = parcelHelpers.interopDefault(_forwardToInboxOutlined);
var _forwardToInboxRounded = require("./ForwardToInboxRounded");
var _forwardToInboxRoundedDefault = parcelHelpers.interopDefault(_forwardToInboxRounded);
var _forwardToInboxSharp = require("./ForwardToInboxSharp");
var _forwardToInboxSharpDefault = parcelHelpers.interopDefault(_forwardToInboxSharp);
var _forwardToInboxTwoTone = require("./ForwardToInboxTwoTone");
var _forwardToInboxTwoToneDefault = parcelHelpers.interopDefault(_forwardToInboxTwoTone);
var _forwardTwoTone = require("./ForwardTwoTone");
var _forwardTwoToneDefault = parcelHelpers.interopDefault(_forwardTwoTone);
var _foundation = require("./Foundation");
var _foundationDefault = parcelHelpers.interopDefault(_foundation);
var _foundationOutlined = require("./FoundationOutlined");
var _foundationOutlinedDefault = parcelHelpers.interopDefault(_foundationOutlined);
var _foundationRounded = require("./FoundationRounded");
var _foundationRoundedDefault = parcelHelpers.interopDefault(_foundationRounded);
var _foundationSharp = require("./FoundationSharp");
var _foundationSharpDefault = parcelHelpers.interopDefault(_foundationSharp);
var _foundationTwoTone = require("./FoundationTwoTone");
var _foundationTwoToneDefault = parcelHelpers.interopDefault(_foundationTwoTone);
var _fourGMobiledata = require("./FourGMobiledata");
var _fourGMobiledataDefault = parcelHelpers.interopDefault(_fourGMobiledata);
var _fourGMobiledataOutlined = require("./FourGMobiledataOutlined");
var _fourGMobiledataOutlinedDefault = parcelHelpers.interopDefault(_fourGMobiledataOutlined);
var _fourGMobiledataRounded = require("./FourGMobiledataRounded");
var _fourGMobiledataRoundedDefault = parcelHelpers.interopDefault(_fourGMobiledataRounded);
var _fourGMobiledataSharp = require("./FourGMobiledataSharp");
var _fourGMobiledataSharpDefault = parcelHelpers.interopDefault(_fourGMobiledataSharp);
var _fourGMobiledataTwoTone = require("./FourGMobiledataTwoTone");
var _fourGMobiledataTwoToneDefault = parcelHelpers.interopDefault(_fourGMobiledataTwoTone);
var _fourGPlusMobiledata = require("./FourGPlusMobiledata");
var _fourGPlusMobiledataDefault = parcelHelpers.interopDefault(_fourGPlusMobiledata);
var _fourGPlusMobiledataOutlined = require("./FourGPlusMobiledataOutlined");
var _fourGPlusMobiledataOutlinedDefault = parcelHelpers.interopDefault(_fourGPlusMobiledataOutlined);
var _fourGPlusMobiledataRounded = require("./FourGPlusMobiledataRounded");
var _fourGPlusMobiledataRoundedDefault = parcelHelpers.interopDefault(_fourGPlusMobiledataRounded);
var _fourGPlusMobiledataSharp = require("./FourGPlusMobiledataSharp");
var _fourGPlusMobiledataSharpDefault = parcelHelpers.interopDefault(_fourGPlusMobiledataSharp);
var _fourGPlusMobiledataTwoTone = require("./FourGPlusMobiledataTwoTone");
var _fourGPlusMobiledataTwoToneDefault = parcelHelpers.interopDefault(_fourGPlusMobiledataTwoTone);
var _fourK = require("./FourK");
var _fourKDefault = parcelHelpers.interopDefault(_fourK);
var _fourKOutlined = require("./FourKOutlined");
var _fourKOutlinedDefault = parcelHelpers.interopDefault(_fourKOutlined);
var _fourKPlus = require("./FourKPlus");
var _fourKPlusDefault = parcelHelpers.interopDefault(_fourKPlus);
var _fourKPlusOutlined = require("./FourKPlusOutlined");
var _fourKPlusOutlinedDefault = parcelHelpers.interopDefault(_fourKPlusOutlined);
var _fourKPlusRounded = require("./FourKPlusRounded");
var _fourKPlusRoundedDefault = parcelHelpers.interopDefault(_fourKPlusRounded);
var _fourKPlusSharp = require("./FourKPlusSharp");
var _fourKPlusSharpDefault = parcelHelpers.interopDefault(_fourKPlusSharp);
var _fourKPlusTwoTone = require("./FourKPlusTwoTone");
var _fourKPlusTwoToneDefault = parcelHelpers.interopDefault(_fourKPlusTwoTone);
var _fourKRounded = require("./FourKRounded");
var _fourKRoundedDefault = parcelHelpers.interopDefault(_fourKRounded);
var _fourKSharp = require("./FourKSharp");
var _fourKSharpDefault = parcelHelpers.interopDefault(_fourKSharp);
var _fourKTwoTone = require("./FourKTwoTone");
var _fourKTwoToneDefault = parcelHelpers.interopDefault(_fourKTwoTone);
var _fourMp = require("./FourMp");
var _fourMpDefault = parcelHelpers.interopDefault(_fourMp);
var _fourMpOutlined = require("./FourMpOutlined");
var _fourMpOutlinedDefault = parcelHelpers.interopDefault(_fourMpOutlined);
var _fourMpRounded = require("./FourMpRounded");
var _fourMpRoundedDefault = parcelHelpers.interopDefault(_fourMpRounded);
var _fourMpSharp = require("./FourMpSharp");
var _fourMpSharpDefault = parcelHelpers.interopDefault(_fourMpSharp);
var _fourMpTwoTone = require("./FourMpTwoTone");
var _fourMpTwoToneDefault = parcelHelpers.interopDefault(_fourMpTwoTone);
var _fourteenMp = require("./FourteenMp");
var _fourteenMpDefault = parcelHelpers.interopDefault(_fourteenMp);
var _fourteenMpOutlined = require("./FourteenMpOutlined");
var _fourteenMpOutlinedDefault = parcelHelpers.interopDefault(_fourteenMpOutlined);
var _fourteenMpRounded = require("./FourteenMpRounded");
var _fourteenMpRoundedDefault = parcelHelpers.interopDefault(_fourteenMpRounded);
var _fourteenMpSharp = require("./FourteenMpSharp");
var _fourteenMpSharpDefault = parcelHelpers.interopDefault(_fourteenMpSharp);
var _fourteenMpTwoTone = require("./FourteenMpTwoTone");
var _fourteenMpTwoToneDefault = parcelHelpers.interopDefault(_fourteenMpTwoTone);
var _freeBreakfast = require("./FreeBreakfast");
var _freeBreakfastDefault = parcelHelpers.interopDefault(_freeBreakfast);
var _freeBreakfastOutlined = require("./FreeBreakfastOutlined");
var _freeBreakfastOutlinedDefault = parcelHelpers.interopDefault(_freeBreakfastOutlined);
var _freeBreakfastRounded = require("./FreeBreakfastRounded");
var _freeBreakfastRoundedDefault = parcelHelpers.interopDefault(_freeBreakfastRounded);
var _freeBreakfastSharp = require("./FreeBreakfastSharp");
var _freeBreakfastSharpDefault = parcelHelpers.interopDefault(_freeBreakfastSharp);
var _freeBreakfastTwoTone = require("./FreeBreakfastTwoTone");
var _freeBreakfastTwoToneDefault = parcelHelpers.interopDefault(_freeBreakfastTwoTone);
var _fullscreen = require("./Fullscreen");
var _fullscreenDefault = parcelHelpers.interopDefault(_fullscreen);
var _fullscreenExit = require("./FullscreenExit");
var _fullscreenExitDefault = parcelHelpers.interopDefault(_fullscreenExit);
var _fullscreenExitOutlined = require("./FullscreenExitOutlined");
var _fullscreenExitOutlinedDefault = parcelHelpers.interopDefault(_fullscreenExitOutlined);
var _fullscreenExitRounded = require("./FullscreenExitRounded");
var _fullscreenExitRoundedDefault = parcelHelpers.interopDefault(_fullscreenExitRounded);
var _fullscreenExitSharp = require("./FullscreenExitSharp");
var _fullscreenExitSharpDefault = parcelHelpers.interopDefault(_fullscreenExitSharp);
var _fullscreenExitTwoTone = require("./FullscreenExitTwoTone");
var _fullscreenExitTwoToneDefault = parcelHelpers.interopDefault(_fullscreenExitTwoTone);
var _fullscreenOutlined = require("./FullscreenOutlined");
var _fullscreenOutlinedDefault = parcelHelpers.interopDefault(_fullscreenOutlined);
var _fullscreenRounded = require("./FullscreenRounded");
var _fullscreenRoundedDefault = parcelHelpers.interopDefault(_fullscreenRounded);
var _fullscreenSharp = require("./FullscreenSharp");
var _fullscreenSharpDefault = parcelHelpers.interopDefault(_fullscreenSharp);
var _fullscreenTwoTone = require("./FullscreenTwoTone");
var _fullscreenTwoToneDefault = parcelHelpers.interopDefault(_fullscreenTwoTone);
var _functions = require("./Functions");
var _functionsDefault = parcelHelpers.interopDefault(_functions);
var _functionsOutlined = require("./FunctionsOutlined");
var _functionsOutlinedDefault = parcelHelpers.interopDefault(_functionsOutlined);
var _functionsRounded = require("./FunctionsRounded");
var _functionsRoundedDefault = parcelHelpers.interopDefault(_functionsRounded);
var _functionsSharp = require("./FunctionsSharp");
var _functionsSharpDefault = parcelHelpers.interopDefault(_functionsSharp);
var _functionsTwoTone = require("./FunctionsTwoTone");
var _functionsTwoToneDefault = parcelHelpers.interopDefault(_functionsTwoTone);
var _gmobiledata = require("./GMobiledata");
var _gmobiledataDefault = parcelHelpers.interopDefault(_gmobiledata);
var _gmobiledataOutlined = require("./GMobiledataOutlined");
var _gmobiledataOutlinedDefault = parcelHelpers.interopDefault(_gmobiledataOutlined);
var _gmobiledataRounded = require("./GMobiledataRounded");
var _gmobiledataRoundedDefault = parcelHelpers.interopDefault(_gmobiledataRounded);
var _gmobiledataSharp = require("./GMobiledataSharp");
var _gmobiledataSharpDefault = parcelHelpers.interopDefault(_gmobiledataSharp);
var _gmobiledataTwoTone = require("./GMobiledataTwoTone");
var _gmobiledataTwoToneDefault = parcelHelpers.interopDefault(_gmobiledataTwoTone);
var _gtranslate = require("./GTranslate");
var _gtranslateDefault = parcelHelpers.interopDefault(_gtranslate);
var _gtranslateOutlined = require("./GTranslateOutlined");
var _gtranslateOutlinedDefault = parcelHelpers.interopDefault(_gtranslateOutlined);
var _gtranslateRounded = require("./GTranslateRounded");
var _gtranslateRoundedDefault = parcelHelpers.interopDefault(_gtranslateRounded);
var _gtranslateSharp = require("./GTranslateSharp");
var _gtranslateSharpDefault = parcelHelpers.interopDefault(_gtranslateSharp);
var _gtranslateTwoTone = require("./GTranslateTwoTone");
var _gtranslateTwoToneDefault = parcelHelpers.interopDefault(_gtranslateTwoTone);
var _gamepad = require("./Gamepad");
var _gamepadDefault = parcelHelpers.interopDefault(_gamepad);
var _gamepadOutlined = require("./GamepadOutlined");
var _gamepadOutlinedDefault = parcelHelpers.interopDefault(_gamepadOutlined);
var _gamepadRounded = require("./GamepadRounded");
var _gamepadRoundedDefault = parcelHelpers.interopDefault(_gamepadRounded);
var _gamepadSharp = require("./GamepadSharp");
var _gamepadSharpDefault = parcelHelpers.interopDefault(_gamepadSharp);
var _gamepadTwoTone = require("./GamepadTwoTone");
var _gamepadTwoToneDefault = parcelHelpers.interopDefault(_gamepadTwoTone);
var _games = require("./Games");
var _gamesDefault = parcelHelpers.interopDefault(_games);
var _gamesOutlined = require("./GamesOutlined");
var _gamesOutlinedDefault = parcelHelpers.interopDefault(_gamesOutlined);
var _gamesRounded = require("./GamesRounded");
var _gamesRoundedDefault = parcelHelpers.interopDefault(_gamesRounded);
var _gamesSharp = require("./GamesSharp");
var _gamesSharpDefault = parcelHelpers.interopDefault(_gamesSharp);
var _gamesTwoTone = require("./GamesTwoTone");
var _gamesTwoToneDefault = parcelHelpers.interopDefault(_gamesTwoTone);
var _garage = require("./Garage");
var _garageDefault = parcelHelpers.interopDefault(_garage);
var _garageOutlined = require("./GarageOutlined");
var _garageOutlinedDefault = parcelHelpers.interopDefault(_garageOutlined);
var _garageRounded = require("./GarageRounded");
var _garageRoundedDefault = parcelHelpers.interopDefault(_garageRounded);
var _garageSharp = require("./GarageSharp");
var _garageSharpDefault = parcelHelpers.interopDefault(_garageSharp);
var _garageTwoTone = require("./GarageTwoTone");
var _garageTwoToneDefault = parcelHelpers.interopDefault(_garageTwoTone);
var _gasMeter = require("./GasMeter");
var _gasMeterDefault = parcelHelpers.interopDefault(_gasMeter);
var _gasMeterOutlined = require("./GasMeterOutlined");
var _gasMeterOutlinedDefault = parcelHelpers.interopDefault(_gasMeterOutlined);
var _gasMeterRounded = require("./GasMeterRounded");
var _gasMeterRoundedDefault = parcelHelpers.interopDefault(_gasMeterRounded);
var _gasMeterSharp = require("./GasMeterSharp");
var _gasMeterSharpDefault = parcelHelpers.interopDefault(_gasMeterSharp);
var _gasMeterTwoTone = require("./GasMeterTwoTone");
var _gasMeterTwoToneDefault = parcelHelpers.interopDefault(_gasMeterTwoTone);
var _gavel = require("./Gavel");
var _gavelDefault = parcelHelpers.interopDefault(_gavel);
var _gavelOutlined = require("./GavelOutlined");
var _gavelOutlinedDefault = parcelHelpers.interopDefault(_gavelOutlined);
var _gavelRounded = require("./GavelRounded");
var _gavelRoundedDefault = parcelHelpers.interopDefault(_gavelRounded);
var _gavelSharp = require("./GavelSharp");
var _gavelSharpDefault = parcelHelpers.interopDefault(_gavelSharp);
var _gavelTwoTone = require("./GavelTwoTone");
var _gavelTwoToneDefault = parcelHelpers.interopDefault(_gavelTwoTone);
var _gesture = require("./Gesture");
var _gestureDefault = parcelHelpers.interopDefault(_gesture);
var _gestureOutlined = require("./GestureOutlined");
var _gestureOutlinedDefault = parcelHelpers.interopDefault(_gestureOutlined);
var _gestureRounded = require("./GestureRounded");
var _gestureRoundedDefault = parcelHelpers.interopDefault(_gestureRounded);
var _gestureSharp = require("./GestureSharp");
var _gestureSharpDefault = parcelHelpers.interopDefault(_gestureSharp);
var _gestureTwoTone = require("./GestureTwoTone");
var _gestureTwoToneDefault = parcelHelpers.interopDefault(_gestureTwoTone);
var _getApp = require("./GetApp");
var _getAppDefault = parcelHelpers.interopDefault(_getApp);
var _getAppOutlined = require("./GetAppOutlined");
var _getAppOutlinedDefault = parcelHelpers.interopDefault(_getAppOutlined);
var _getAppRounded = require("./GetAppRounded");
var _getAppRoundedDefault = parcelHelpers.interopDefault(_getAppRounded);
var _getAppSharp = require("./GetAppSharp");
var _getAppSharpDefault = parcelHelpers.interopDefault(_getAppSharp);
var _getAppTwoTone = require("./GetAppTwoTone");
var _getAppTwoToneDefault = parcelHelpers.interopDefault(_getAppTwoTone);
var _gif = require("./Gif");
var _gifDefault = parcelHelpers.interopDefault(_gif);
var _gifBox = require("./GifBox");
var _gifBoxDefault = parcelHelpers.interopDefault(_gifBox);
var _gifBoxOutlined = require("./GifBoxOutlined");
var _gifBoxOutlinedDefault = parcelHelpers.interopDefault(_gifBoxOutlined);
var _gifBoxRounded = require("./GifBoxRounded");
var _gifBoxRoundedDefault = parcelHelpers.interopDefault(_gifBoxRounded);
var _gifBoxSharp = require("./GifBoxSharp");
var _gifBoxSharpDefault = parcelHelpers.interopDefault(_gifBoxSharp);
var _gifBoxTwoTone = require("./GifBoxTwoTone");
var _gifBoxTwoToneDefault = parcelHelpers.interopDefault(_gifBoxTwoTone);
var _gifOutlined = require("./GifOutlined");
var _gifOutlinedDefault = parcelHelpers.interopDefault(_gifOutlined);
var _gifRounded = require("./GifRounded");
var _gifRoundedDefault = parcelHelpers.interopDefault(_gifRounded);
var _gifSharp = require("./GifSharp");
var _gifSharpDefault = parcelHelpers.interopDefault(_gifSharp);
var _gifTwoTone = require("./GifTwoTone");
var _gifTwoToneDefault = parcelHelpers.interopDefault(_gifTwoTone);
var _girl = require("./Girl");
var _girlDefault = parcelHelpers.interopDefault(_girl);
var _girlOutlined = require("./GirlOutlined");
var _girlOutlinedDefault = parcelHelpers.interopDefault(_girlOutlined);
var _girlRounded = require("./GirlRounded");
var _girlRoundedDefault = parcelHelpers.interopDefault(_girlRounded);
var _girlSharp = require("./GirlSharp");
var _girlSharpDefault = parcelHelpers.interopDefault(_girlSharp);
var _girlTwoTone = require("./GirlTwoTone");
var _girlTwoToneDefault = parcelHelpers.interopDefault(_girlTwoTone);
var _gitHub = require("./GitHub");
var _gitHubDefault = parcelHelpers.interopDefault(_gitHub);
var _gite = require("./Gite");
var _giteDefault = parcelHelpers.interopDefault(_gite);
var _giteOutlined = require("./GiteOutlined");
var _giteOutlinedDefault = parcelHelpers.interopDefault(_giteOutlined);
var _giteRounded = require("./GiteRounded");
var _giteRoundedDefault = parcelHelpers.interopDefault(_giteRounded);
var _giteSharp = require("./GiteSharp");
var _giteSharpDefault = parcelHelpers.interopDefault(_giteSharp);
var _giteTwoTone = require("./GiteTwoTone");
var _giteTwoToneDefault = parcelHelpers.interopDefault(_giteTwoTone);
var _golfCourse = require("./GolfCourse");
var _golfCourseDefault = parcelHelpers.interopDefault(_golfCourse);
var _golfCourseOutlined = require("./GolfCourseOutlined");
var _golfCourseOutlinedDefault = parcelHelpers.interopDefault(_golfCourseOutlined);
var _golfCourseRounded = require("./GolfCourseRounded");
var _golfCourseRoundedDefault = parcelHelpers.interopDefault(_golfCourseRounded);
var _golfCourseSharp = require("./GolfCourseSharp");
var _golfCourseSharpDefault = parcelHelpers.interopDefault(_golfCourseSharp);
var _golfCourseTwoTone = require("./GolfCourseTwoTone");
var _golfCourseTwoToneDefault = parcelHelpers.interopDefault(_golfCourseTwoTone);
var _google = require("./Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _gppBad = require("./GppBad");
var _gppBadDefault = parcelHelpers.interopDefault(_gppBad);
var _gppBadOutlined = require("./GppBadOutlined");
var _gppBadOutlinedDefault = parcelHelpers.interopDefault(_gppBadOutlined);
var _gppBadRounded = require("./GppBadRounded");
var _gppBadRoundedDefault = parcelHelpers.interopDefault(_gppBadRounded);
var _gppBadSharp = require("./GppBadSharp");
var _gppBadSharpDefault = parcelHelpers.interopDefault(_gppBadSharp);
var _gppBadTwoTone = require("./GppBadTwoTone");
var _gppBadTwoToneDefault = parcelHelpers.interopDefault(_gppBadTwoTone);
var _gppGood = require("./GppGood");
var _gppGoodDefault = parcelHelpers.interopDefault(_gppGood);
var _gppGoodOutlined = require("./GppGoodOutlined");
var _gppGoodOutlinedDefault = parcelHelpers.interopDefault(_gppGoodOutlined);
var _gppGoodRounded = require("./GppGoodRounded");
var _gppGoodRoundedDefault = parcelHelpers.interopDefault(_gppGoodRounded);
var _gppGoodSharp = require("./GppGoodSharp");
var _gppGoodSharpDefault = parcelHelpers.interopDefault(_gppGoodSharp);
var _gppGoodTwoTone = require("./GppGoodTwoTone");
var _gppGoodTwoToneDefault = parcelHelpers.interopDefault(_gppGoodTwoTone);
var _gppMaybe = require("./GppMaybe");
var _gppMaybeDefault = parcelHelpers.interopDefault(_gppMaybe);
var _gppMaybeOutlined = require("./GppMaybeOutlined");
var _gppMaybeOutlinedDefault = parcelHelpers.interopDefault(_gppMaybeOutlined);
var _gppMaybeRounded = require("./GppMaybeRounded");
var _gppMaybeRoundedDefault = parcelHelpers.interopDefault(_gppMaybeRounded);
var _gppMaybeSharp = require("./GppMaybeSharp");
var _gppMaybeSharpDefault = parcelHelpers.interopDefault(_gppMaybeSharp);
var _gppMaybeTwoTone = require("./GppMaybeTwoTone");
var _gppMaybeTwoToneDefault = parcelHelpers.interopDefault(_gppMaybeTwoTone);
var _gpsFixed = require("./GpsFixed");
var _gpsFixedDefault = parcelHelpers.interopDefault(_gpsFixed);
var _gpsFixedOutlined = require("./GpsFixedOutlined");
var _gpsFixedOutlinedDefault = parcelHelpers.interopDefault(_gpsFixedOutlined);
var _gpsFixedRounded = require("./GpsFixedRounded");
var _gpsFixedRoundedDefault = parcelHelpers.interopDefault(_gpsFixedRounded);
var _gpsFixedSharp = require("./GpsFixedSharp");
var _gpsFixedSharpDefault = parcelHelpers.interopDefault(_gpsFixedSharp);
var _gpsFixedTwoTone = require("./GpsFixedTwoTone");
var _gpsFixedTwoToneDefault = parcelHelpers.interopDefault(_gpsFixedTwoTone);
var _gpsNotFixed = require("./GpsNotFixed");
var _gpsNotFixedDefault = parcelHelpers.interopDefault(_gpsNotFixed);
var _gpsNotFixedOutlined = require("./GpsNotFixedOutlined");
var _gpsNotFixedOutlinedDefault = parcelHelpers.interopDefault(_gpsNotFixedOutlined);
var _gpsNotFixedRounded = require("./GpsNotFixedRounded");
var _gpsNotFixedRoundedDefault = parcelHelpers.interopDefault(_gpsNotFixedRounded);
var _gpsNotFixedSharp = require("./GpsNotFixedSharp");
var _gpsNotFixedSharpDefault = parcelHelpers.interopDefault(_gpsNotFixedSharp);
var _gpsNotFixedTwoTone = require("./GpsNotFixedTwoTone");
var _gpsNotFixedTwoToneDefault = parcelHelpers.interopDefault(_gpsNotFixedTwoTone);
var _gpsOff = require("./GpsOff");
var _gpsOffDefault = parcelHelpers.interopDefault(_gpsOff);
var _gpsOffOutlined = require("./GpsOffOutlined");
var _gpsOffOutlinedDefault = parcelHelpers.interopDefault(_gpsOffOutlined);
var _gpsOffRounded = require("./GpsOffRounded");
var _gpsOffRoundedDefault = parcelHelpers.interopDefault(_gpsOffRounded);
var _gpsOffSharp = require("./GpsOffSharp");
var _gpsOffSharpDefault = parcelHelpers.interopDefault(_gpsOffSharp);
var _gpsOffTwoTone = require("./GpsOffTwoTone");
var _gpsOffTwoToneDefault = parcelHelpers.interopDefault(_gpsOffTwoTone);
var _grade = require("./Grade");
var _gradeDefault = parcelHelpers.interopDefault(_grade);
var _gradeOutlined = require("./GradeOutlined");
var _gradeOutlinedDefault = parcelHelpers.interopDefault(_gradeOutlined);
var _gradeRounded = require("./GradeRounded");
var _gradeRoundedDefault = parcelHelpers.interopDefault(_gradeRounded);
var _gradeSharp = require("./GradeSharp");
var _gradeSharpDefault = parcelHelpers.interopDefault(_gradeSharp);
var _gradeTwoTone = require("./GradeTwoTone");
var _gradeTwoToneDefault = parcelHelpers.interopDefault(_gradeTwoTone);
var _gradient = require("./Gradient");
var _gradientDefault = parcelHelpers.interopDefault(_gradient);
var _gradientOutlined = require("./GradientOutlined");
var _gradientOutlinedDefault = parcelHelpers.interopDefault(_gradientOutlined);
var _gradientRounded = require("./GradientRounded");
var _gradientRoundedDefault = parcelHelpers.interopDefault(_gradientRounded);
var _gradientSharp = require("./GradientSharp");
var _gradientSharpDefault = parcelHelpers.interopDefault(_gradientSharp);
var _gradientTwoTone = require("./GradientTwoTone");
var _gradientTwoToneDefault = parcelHelpers.interopDefault(_gradientTwoTone);
var _grading = require("./Grading");
var _gradingDefault = parcelHelpers.interopDefault(_grading);
var _gradingOutlined = require("./GradingOutlined");
var _gradingOutlinedDefault = parcelHelpers.interopDefault(_gradingOutlined);
var _gradingRounded = require("./GradingRounded");
var _gradingRoundedDefault = parcelHelpers.interopDefault(_gradingRounded);
var _gradingSharp = require("./GradingSharp");
var _gradingSharpDefault = parcelHelpers.interopDefault(_gradingSharp);
var _gradingTwoTone = require("./GradingTwoTone");
var _gradingTwoToneDefault = parcelHelpers.interopDefault(_gradingTwoTone);
var _grain = require("./Grain");
var _grainDefault = parcelHelpers.interopDefault(_grain);
var _grainOutlined = require("./GrainOutlined");
var _grainOutlinedDefault = parcelHelpers.interopDefault(_grainOutlined);
var _grainRounded = require("./GrainRounded");
var _grainRoundedDefault = parcelHelpers.interopDefault(_grainRounded);
var _grainSharp = require("./GrainSharp");
var _grainSharpDefault = parcelHelpers.interopDefault(_grainSharp);
var _grainTwoTone = require("./GrainTwoTone");
var _grainTwoToneDefault = parcelHelpers.interopDefault(_grainTwoTone);
var _graphicEq = require("./GraphicEq");
var _graphicEqDefault = parcelHelpers.interopDefault(_graphicEq);
var _graphicEqOutlined = require("./GraphicEqOutlined");
var _graphicEqOutlinedDefault = parcelHelpers.interopDefault(_graphicEqOutlined);
var _graphicEqRounded = require("./GraphicEqRounded");
var _graphicEqRoundedDefault = parcelHelpers.interopDefault(_graphicEqRounded);
var _graphicEqSharp = require("./GraphicEqSharp");
var _graphicEqSharpDefault = parcelHelpers.interopDefault(_graphicEqSharp);
var _graphicEqTwoTone = require("./GraphicEqTwoTone");
var _graphicEqTwoToneDefault = parcelHelpers.interopDefault(_graphicEqTwoTone);
var _grass = require("./Grass");
var _grassDefault = parcelHelpers.interopDefault(_grass);
var _grassOutlined = require("./GrassOutlined");
var _grassOutlinedDefault = parcelHelpers.interopDefault(_grassOutlined);
var _grassRounded = require("./GrassRounded");
var _grassRoundedDefault = parcelHelpers.interopDefault(_grassRounded);
var _grassSharp = require("./GrassSharp");
var _grassSharpDefault = parcelHelpers.interopDefault(_grassSharp);
var _grassTwoTone = require("./GrassTwoTone");
var _grassTwoToneDefault = parcelHelpers.interopDefault(_grassTwoTone);
var _grid3X3 = require("./Grid3x3");
var _grid3X3Default = parcelHelpers.interopDefault(_grid3X3);
var _grid3X3Outlined = require("./Grid3x3Outlined");
var _grid3X3OutlinedDefault = parcelHelpers.interopDefault(_grid3X3Outlined);
var _grid3X3Rounded = require("./Grid3x3Rounded");
var _grid3X3RoundedDefault = parcelHelpers.interopDefault(_grid3X3Rounded);
var _grid3X3Sharp = require("./Grid3x3Sharp");
var _grid3X3SharpDefault = parcelHelpers.interopDefault(_grid3X3Sharp);
var _grid3X3TwoTone = require("./Grid3x3TwoTone");
var _grid3X3TwoToneDefault = parcelHelpers.interopDefault(_grid3X3TwoTone);
var _grid4X4 = require("./Grid4x4");
var _grid4X4Default = parcelHelpers.interopDefault(_grid4X4);
var _grid4X4Outlined = require("./Grid4x4Outlined");
var _grid4X4OutlinedDefault = parcelHelpers.interopDefault(_grid4X4Outlined);
var _grid4X4Rounded = require("./Grid4x4Rounded");
var _grid4X4RoundedDefault = parcelHelpers.interopDefault(_grid4X4Rounded);
var _grid4X4Sharp = require("./Grid4x4Sharp");
var _grid4X4SharpDefault = parcelHelpers.interopDefault(_grid4X4Sharp);
var _grid4X4TwoTone = require("./Grid4x4TwoTone");
var _grid4X4TwoToneDefault = parcelHelpers.interopDefault(_grid4X4TwoTone);
var _gridGoldenratio = require("./GridGoldenratio");
var _gridGoldenratioDefault = parcelHelpers.interopDefault(_gridGoldenratio);
var _gridGoldenratioOutlined = require("./GridGoldenratioOutlined");
var _gridGoldenratioOutlinedDefault = parcelHelpers.interopDefault(_gridGoldenratioOutlined);
var _gridGoldenratioRounded = require("./GridGoldenratioRounded");
var _gridGoldenratioRoundedDefault = parcelHelpers.interopDefault(_gridGoldenratioRounded);
var _gridGoldenratioSharp = require("./GridGoldenratioSharp");
var _gridGoldenratioSharpDefault = parcelHelpers.interopDefault(_gridGoldenratioSharp);
var _gridGoldenratioTwoTone = require("./GridGoldenratioTwoTone");
var _gridGoldenratioTwoToneDefault = parcelHelpers.interopDefault(_gridGoldenratioTwoTone);
var _gridOff = require("./GridOff");
var _gridOffDefault = parcelHelpers.interopDefault(_gridOff);
var _gridOffOutlined = require("./GridOffOutlined");
var _gridOffOutlinedDefault = parcelHelpers.interopDefault(_gridOffOutlined);
var _gridOffRounded = require("./GridOffRounded");
var _gridOffRoundedDefault = parcelHelpers.interopDefault(_gridOffRounded);
var _gridOffSharp = require("./GridOffSharp");
var _gridOffSharpDefault = parcelHelpers.interopDefault(_gridOffSharp);
var _gridOffTwoTone = require("./GridOffTwoTone");
var _gridOffTwoToneDefault = parcelHelpers.interopDefault(_gridOffTwoTone);
var _gridOn = require("./GridOn");
var _gridOnDefault = parcelHelpers.interopDefault(_gridOn);
var _gridOnOutlined = require("./GridOnOutlined");
var _gridOnOutlinedDefault = parcelHelpers.interopDefault(_gridOnOutlined);
var _gridOnRounded = require("./GridOnRounded");
var _gridOnRoundedDefault = parcelHelpers.interopDefault(_gridOnRounded);
var _gridOnSharp = require("./GridOnSharp");
var _gridOnSharpDefault = parcelHelpers.interopDefault(_gridOnSharp);
var _gridOnTwoTone = require("./GridOnTwoTone");
var _gridOnTwoToneDefault = parcelHelpers.interopDefault(_gridOnTwoTone);
var _gridView = require("./GridView");
var _gridViewDefault = parcelHelpers.interopDefault(_gridView);
var _gridViewOutlined = require("./GridViewOutlined");
var _gridViewOutlinedDefault = parcelHelpers.interopDefault(_gridViewOutlined);
var _gridViewRounded = require("./GridViewRounded");
var _gridViewRoundedDefault = parcelHelpers.interopDefault(_gridViewRounded);
var _gridViewSharp = require("./GridViewSharp");
var _gridViewSharpDefault = parcelHelpers.interopDefault(_gridViewSharp);
var _gridViewTwoTone = require("./GridViewTwoTone");
var _gridViewTwoToneDefault = parcelHelpers.interopDefault(_gridViewTwoTone);
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _groupAdd = require("./GroupAdd");
var _groupAddDefault = parcelHelpers.interopDefault(_groupAdd);
var _groupAddOutlined = require("./GroupAddOutlined");
var _groupAddOutlinedDefault = parcelHelpers.interopDefault(_groupAddOutlined);
var _groupAddRounded = require("./GroupAddRounded");
var _groupAddRoundedDefault = parcelHelpers.interopDefault(_groupAddRounded);
var _groupAddSharp = require("./GroupAddSharp");
var _groupAddSharpDefault = parcelHelpers.interopDefault(_groupAddSharp);
var _groupAddTwoTone = require("./GroupAddTwoTone");
var _groupAddTwoToneDefault = parcelHelpers.interopDefault(_groupAddTwoTone);
var _groupOutlined = require("./GroupOutlined");
var _groupOutlinedDefault = parcelHelpers.interopDefault(_groupOutlined);
var _groupRemove = require("./GroupRemove");
var _groupRemoveDefault = parcelHelpers.interopDefault(_groupRemove);
var _groupRemoveOutlined = require("./GroupRemoveOutlined");
var _groupRemoveOutlinedDefault = parcelHelpers.interopDefault(_groupRemoveOutlined);
var _groupRemoveRounded = require("./GroupRemoveRounded");
var _groupRemoveRoundedDefault = parcelHelpers.interopDefault(_groupRemoveRounded);
var _groupRemoveSharp = require("./GroupRemoveSharp");
var _groupRemoveSharpDefault = parcelHelpers.interopDefault(_groupRemoveSharp);
var _groupRemoveTwoTone = require("./GroupRemoveTwoTone");
var _groupRemoveTwoToneDefault = parcelHelpers.interopDefault(_groupRemoveTwoTone);
var _groupRounded = require("./GroupRounded");
var _groupRoundedDefault = parcelHelpers.interopDefault(_groupRounded);
var _groupSharp = require("./GroupSharp");
var _groupSharpDefault = parcelHelpers.interopDefault(_groupSharp);
var _groupTwoTone = require("./GroupTwoTone");
var _groupTwoToneDefault = parcelHelpers.interopDefault(_groupTwoTone);
var _groupWork = require("./GroupWork");
var _groupWorkDefault = parcelHelpers.interopDefault(_groupWork);
var _groupWorkOutlined = require("./GroupWorkOutlined");
var _groupWorkOutlinedDefault = parcelHelpers.interopDefault(_groupWorkOutlined);
var _groupWorkRounded = require("./GroupWorkRounded");
var _groupWorkRoundedDefault = parcelHelpers.interopDefault(_groupWorkRounded);
var _groupWorkSharp = require("./GroupWorkSharp");
var _groupWorkSharpDefault = parcelHelpers.interopDefault(_groupWorkSharp);
var _groupWorkTwoTone = require("./GroupWorkTwoTone");
var _groupWorkTwoToneDefault = parcelHelpers.interopDefault(_groupWorkTwoTone);
var _groups = require("./Groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
var _groups2 = require("./Groups2");
var _groups2Default = parcelHelpers.interopDefault(_groups2);
var _groups2Outlined = require("./Groups2Outlined");
var _groups2OutlinedDefault = parcelHelpers.interopDefault(_groups2Outlined);
var _groups2Rounded = require("./Groups2Rounded");
var _groups2RoundedDefault = parcelHelpers.interopDefault(_groups2Rounded);
var _groups2Sharp = require("./Groups2Sharp");
var _groups2SharpDefault = parcelHelpers.interopDefault(_groups2Sharp);
var _groups2TwoTone = require("./Groups2TwoTone");
var _groups2TwoToneDefault = parcelHelpers.interopDefault(_groups2TwoTone);
var _groups3 = require("./Groups3");
var _groups3Default = parcelHelpers.interopDefault(_groups3);
var _groups3Outlined = require("./Groups3Outlined");
var _groups3OutlinedDefault = parcelHelpers.interopDefault(_groups3Outlined);
var _groups3Rounded = require("./Groups3Rounded");
var _groups3RoundedDefault = parcelHelpers.interopDefault(_groups3Rounded);
var _groups3Sharp = require("./Groups3Sharp");
var _groups3SharpDefault = parcelHelpers.interopDefault(_groups3Sharp);
var _groups3TwoTone = require("./Groups3TwoTone");
var _groups3TwoToneDefault = parcelHelpers.interopDefault(_groups3TwoTone);
var _groupsOutlined = require("./GroupsOutlined");
var _groupsOutlinedDefault = parcelHelpers.interopDefault(_groupsOutlined);
var _groupsRounded = require("./GroupsRounded");
var _groupsRoundedDefault = parcelHelpers.interopDefault(_groupsRounded);
var _groupsSharp = require("./GroupsSharp");
var _groupsSharpDefault = parcelHelpers.interopDefault(_groupsSharp);
var _groupsTwoTone = require("./GroupsTwoTone");
var _groupsTwoToneDefault = parcelHelpers.interopDefault(_groupsTwoTone);
var _hmobiledata = require("./HMobiledata");
var _hmobiledataDefault = parcelHelpers.interopDefault(_hmobiledata);
var _hmobiledataOutlined = require("./HMobiledataOutlined");
var _hmobiledataOutlinedDefault = parcelHelpers.interopDefault(_hmobiledataOutlined);
var _hmobiledataRounded = require("./HMobiledataRounded");
var _hmobiledataRoundedDefault = parcelHelpers.interopDefault(_hmobiledataRounded);
var _hmobiledataSharp = require("./HMobiledataSharp");
var _hmobiledataSharpDefault = parcelHelpers.interopDefault(_hmobiledataSharp);
var _hmobiledataTwoTone = require("./HMobiledataTwoTone");
var _hmobiledataTwoToneDefault = parcelHelpers.interopDefault(_hmobiledataTwoTone);
var _hplusMobiledata = require("./HPlusMobiledata");
var _hplusMobiledataDefault = parcelHelpers.interopDefault(_hplusMobiledata);
var _hplusMobiledataOutlined = require("./HPlusMobiledataOutlined");
var _hplusMobiledataOutlinedDefault = parcelHelpers.interopDefault(_hplusMobiledataOutlined);
var _hplusMobiledataRounded = require("./HPlusMobiledataRounded");
var _hplusMobiledataRoundedDefault = parcelHelpers.interopDefault(_hplusMobiledataRounded);
var _hplusMobiledataSharp = require("./HPlusMobiledataSharp");
var _hplusMobiledataSharpDefault = parcelHelpers.interopDefault(_hplusMobiledataSharp);
var _hplusMobiledataTwoTone = require("./HPlusMobiledataTwoTone");
var _hplusMobiledataTwoToneDefault = parcelHelpers.interopDefault(_hplusMobiledataTwoTone);
var _hail = require("./Hail");
var _hailDefault = parcelHelpers.interopDefault(_hail);
var _hailOutlined = require("./HailOutlined");
var _hailOutlinedDefault = parcelHelpers.interopDefault(_hailOutlined);
var _hailRounded = require("./HailRounded");
var _hailRoundedDefault = parcelHelpers.interopDefault(_hailRounded);
var _hailSharp = require("./HailSharp");
var _hailSharpDefault = parcelHelpers.interopDefault(_hailSharp);
var _hailTwoTone = require("./HailTwoTone");
var _hailTwoToneDefault = parcelHelpers.interopDefault(_hailTwoTone);
var _handshake = require("./Handshake");
var _handshakeDefault = parcelHelpers.interopDefault(_handshake);
var _handshakeOutlined = require("./HandshakeOutlined");
var _handshakeOutlinedDefault = parcelHelpers.interopDefault(_handshakeOutlined);
var _handshakeRounded = require("./HandshakeRounded");
var _handshakeRoundedDefault = parcelHelpers.interopDefault(_handshakeRounded);
var _handshakeSharp = require("./HandshakeSharp");
var _handshakeSharpDefault = parcelHelpers.interopDefault(_handshakeSharp);
var _handshakeTwoTone = require("./HandshakeTwoTone");
var _handshakeTwoToneDefault = parcelHelpers.interopDefault(_handshakeTwoTone);
var _handyman = require("./Handyman");
var _handymanDefault = parcelHelpers.interopDefault(_handyman);
var _handymanOutlined = require("./HandymanOutlined");
var _handymanOutlinedDefault = parcelHelpers.interopDefault(_handymanOutlined);
var _handymanRounded = require("./HandymanRounded");
var _handymanRoundedDefault = parcelHelpers.interopDefault(_handymanRounded);
var _handymanSharp = require("./HandymanSharp");
var _handymanSharpDefault = parcelHelpers.interopDefault(_handymanSharp);
var _handymanTwoTone = require("./HandymanTwoTone");
var _handymanTwoToneDefault = parcelHelpers.interopDefault(_handymanTwoTone);
var _hardware = require("./Hardware");
var _hardwareDefault = parcelHelpers.interopDefault(_hardware);
var _hardwareOutlined = require("./HardwareOutlined");
var _hardwareOutlinedDefault = parcelHelpers.interopDefault(_hardwareOutlined);
var _hardwareRounded = require("./HardwareRounded");
var _hardwareRoundedDefault = parcelHelpers.interopDefault(_hardwareRounded);
var _hardwareSharp = require("./HardwareSharp");
var _hardwareSharpDefault = parcelHelpers.interopDefault(_hardwareSharp);
var _hardwareTwoTone = require("./HardwareTwoTone");
var _hardwareTwoToneDefault = parcelHelpers.interopDefault(_hardwareTwoTone);
var _hd = require("./Hd");
var _hdDefault = parcelHelpers.interopDefault(_hd);
var _hdOutlined = require("./HdOutlined");
var _hdOutlinedDefault = parcelHelpers.interopDefault(_hdOutlined);
var _hdRounded = require("./HdRounded");
var _hdRoundedDefault = parcelHelpers.interopDefault(_hdRounded);
var _hdSharp = require("./HdSharp");
var _hdSharpDefault = parcelHelpers.interopDefault(_hdSharp);
var _hdTwoTone = require("./HdTwoTone");
var _hdTwoToneDefault = parcelHelpers.interopDefault(_hdTwoTone);
var _hdrAuto = require("./HdrAuto");
var _hdrAutoDefault = parcelHelpers.interopDefault(_hdrAuto);
var _hdrAutoOutlined = require("./HdrAutoOutlined");
var _hdrAutoOutlinedDefault = parcelHelpers.interopDefault(_hdrAutoOutlined);
var _hdrAutoRounded = require("./HdrAutoRounded");
var _hdrAutoRoundedDefault = parcelHelpers.interopDefault(_hdrAutoRounded);
var _hdrAutoSelect = require("./HdrAutoSelect");
var _hdrAutoSelectDefault = parcelHelpers.interopDefault(_hdrAutoSelect);
var _hdrAutoSelectOutlined = require("./HdrAutoSelectOutlined");
var _hdrAutoSelectOutlinedDefault = parcelHelpers.interopDefault(_hdrAutoSelectOutlined);
var _hdrAutoSelectRounded = require("./HdrAutoSelectRounded");
var _hdrAutoSelectRoundedDefault = parcelHelpers.interopDefault(_hdrAutoSelectRounded);
var _hdrAutoSelectSharp = require("./HdrAutoSelectSharp");
var _hdrAutoSelectSharpDefault = parcelHelpers.interopDefault(_hdrAutoSelectSharp);
var _hdrAutoSelectTwoTone = require("./HdrAutoSelectTwoTone");
var _hdrAutoSelectTwoToneDefault = parcelHelpers.interopDefault(_hdrAutoSelectTwoTone);
var _hdrAutoSharp = require("./HdrAutoSharp");
var _hdrAutoSharpDefault = parcelHelpers.interopDefault(_hdrAutoSharp);
var _hdrAutoTwoTone = require("./HdrAutoTwoTone");
var _hdrAutoTwoToneDefault = parcelHelpers.interopDefault(_hdrAutoTwoTone);
var _hdrEnhancedSelect = require("./HdrEnhancedSelect");
var _hdrEnhancedSelectDefault = parcelHelpers.interopDefault(_hdrEnhancedSelect);
var _hdrEnhancedSelectOutlined = require("./HdrEnhancedSelectOutlined");
var _hdrEnhancedSelectOutlinedDefault = parcelHelpers.interopDefault(_hdrEnhancedSelectOutlined);
var _hdrEnhancedSelectRounded = require("./HdrEnhancedSelectRounded");
var _hdrEnhancedSelectRoundedDefault = parcelHelpers.interopDefault(_hdrEnhancedSelectRounded);
var _hdrEnhancedSelectSharp = require("./HdrEnhancedSelectSharp");
var _hdrEnhancedSelectSharpDefault = parcelHelpers.interopDefault(_hdrEnhancedSelectSharp);
var _hdrEnhancedSelectTwoTone = require("./HdrEnhancedSelectTwoTone");
var _hdrEnhancedSelectTwoToneDefault = parcelHelpers.interopDefault(_hdrEnhancedSelectTwoTone);
var _hdrOff = require("./HdrOff");
var _hdrOffDefault = parcelHelpers.interopDefault(_hdrOff);
var _hdrOffOutlined = require("./HdrOffOutlined");
var _hdrOffOutlinedDefault = parcelHelpers.interopDefault(_hdrOffOutlined);
var _hdrOffRounded = require("./HdrOffRounded");
var _hdrOffRoundedDefault = parcelHelpers.interopDefault(_hdrOffRounded);
var _hdrOffSelect = require("./HdrOffSelect");
var _hdrOffSelectDefault = parcelHelpers.interopDefault(_hdrOffSelect);
var _hdrOffSelectOutlined = require("./HdrOffSelectOutlined");
var _hdrOffSelectOutlinedDefault = parcelHelpers.interopDefault(_hdrOffSelectOutlined);
var _hdrOffSelectRounded = require("./HdrOffSelectRounded");
var _hdrOffSelectRoundedDefault = parcelHelpers.interopDefault(_hdrOffSelectRounded);
var _hdrOffSelectSharp = require("./HdrOffSelectSharp");
var _hdrOffSelectSharpDefault = parcelHelpers.interopDefault(_hdrOffSelectSharp);
var _hdrOffSelectTwoTone = require("./HdrOffSelectTwoTone");
var _hdrOffSelectTwoToneDefault = parcelHelpers.interopDefault(_hdrOffSelectTwoTone);
var _hdrOffSharp = require("./HdrOffSharp");
var _hdrOffSharpDefault = parcelHelpers.interopDefault(_hdrOffSharp);
var _hdrOffTwoTone = require("./HdrOffTwoTone");
var _hdrOffTwoToneDefault = parcelHelpers.interopDefault(_hdrOffTwoTone);
var _hdrOn = require("./HdrOn");
var _hdrOnDefault = parcelHelpers.interopDefault(_hdrOn);
var _hdrOnOutlined = require("./HdrOnOutlined");
var _hdrOnOutlinedDefault = parcelHelpers.interopDefault(_hdrOnOutlined);
var _hdrOnRounded = require("./HdrOnRounded");
var _hdrOnRoundedDefault = parcelHelpers.interopDefault(_hdrOnRounded);
var _hdrOnSelect = require("./HdrOnSelect");
var _hdrOnSelectDefault = parcelHelpers.interopDefault(_hdrOnSelect);
var _hdrOnSelectOutlined = require("./HdrOnSelectOutlined");
var _hdrOnSelectOutlinedDefault = parcelHelpers.interopDefault(_hdrOnSelectOutlined);
var _hdrOnSelectRounded = require("./HdrOnSelectRounded");
var _hdrOnSelectRoundedDefault = parcelHelpers.interopDefault(_hdrOnSelectRounded);
var _hdrOnSelectSharp = require("./HdrOnSelectSharp");
var _hdrOnSelectSharpDefault = parcelHelpers.interopDefault(_hdrOnSelectSharp);
var _hdrOnSelectTwoTone = require("./HdrOnSelectTwoTone");
var _hdrOnSelectTwoToneDefault = parcelHelpers.interopDefault(_hdrOnSelectTwoTone);
var _hdrOnSharp = require("./HdrOnSharp");
var _hdrOnSharpDefault = parcelHelpers.interopDefault(_hdrOnSharp);
var _hdrOnTwoTone = require("./HdrOnTwoTone");
var _hdrOnTwoToneDefault = parcelHelpers.interopDefault(_hdrOnTwoTone);
var _hdrPlus = require("./HdrPlus");
var _hdrPlusDefault = parcelHelpers.interopDefault(_hdrPlus);
var _hdrPlusOutlined = require("./HdrPlusOutlined");
var _hdrPlusOutlinedDefault = parcelHelpers.interopDefault(_hdrPlusOutlined);
var _hdrPlusRounded = require("./HdrPlusRounded");
var _hdrPlusRoundedDefault = parcelHelpers.interopDefault(_hdrPlusRounded);
var _hdrPlusSharp = require("./HdrPlusSharp");
var _hdrPlusSharpDefault = parcelHelpers.interopDefault(_hdrPlusSharp);
var _hdrPlusTwoTone = require("./HdrPlusTwoTone");
var _hdrPlusTwoToneDefault = parcelHelpers.interopDefault(_hdrPlusTwoTone);
var _hdrStrong = require("./HdrStrong");
var _hdrStrongDefault = parcelHelpers.interopDefault(_hdrStrong);
var _hdrStrongOutlined = require("./HdrStrongOutlined");
var _hdrStrongOutlinedDefault = parcelHelpers.interopDefault(_hdrStrongOutlined);
var _hdrStrongRounded = require("./HdrStrongRounded");
var _hdrStrongRoundedDefault = parcelHelpers.interopDefault(_hdrStrongRounded);
var _hdrStrongSharp = require("./HdrStrongSharp");
var _hdrStrongSharpDefault = parcelHelpers.interopDefault(_hdrStrongSharp);
var _hdrStrongTwoTone = require("./HdrStrongTwoTone");
var _hdrStrongTwoToneDefault = parcelHelpers.interopDefault(_hdrStrongTwoTone);
var _hdrWeak = require("./HdrWeak");
var _hdrWeakDefault = parcelHelpers.interopDefault(_hdrWeak);
var _hdrWeakOutlined = require("./HdrWeakOutlined");
var _hdrWeakOutlinedDefault = parcelHelpers.interopDefault(_hdrWeakOutlined);
var _hdrWeakRounded = require("./HdrWeakRounded");
var _hdrWeakRoundedDefault = parcelHelpers.interopDefault(_hdrWeakRounded);
var _hdrWeakSharp = require("./HdrWeakSharp");
var _hdrWeakSharpDefault = parcelHelpers.interopDefault(_hdrWeakSharp);
var _hdrWeakTwoTone = require("./HdrWeakTwoTone");
var _hdrWeakTwoToneDefault = parcelHelpers.interopDefault(_hdrWeakTwoTone);
var _headphones = require("./Headphones");
var _headphonesDefault = parcelHelpers.interopDefault(_headphones);
var _headphonesBattery = require("./HeadphonesBattery");
var _headphonesBatteryDefault = parcelHelpers.interopDefault(_headphonesBattery);
var _headphonesBatteryOutlined = require("./HeadphonesBatteryOutlined");
var _headphonesBatteryOutlinedDefault = parcelHelpers.interopDefault(_headphonesBatteryOutlined);
var _headphonesBatteryRounded = require("./HeadphonesBatteryRounded");
var _headphonesBatteryRoundedDefault = parcelHelpers.interopDefault(_headphonesBatteryRounded);
var _headphonesBatterySharp = require("./HeadphonesBatterySharp");
var _headphonesBatterySharpDefault = parcelHelpers.interopDefault(_headphonesBatterySharp);
var _headphonesBatteryTwoTone = require("./HeadphonesBatteryTwoTone");
var _headphonesBatteryTwoToneDefault = parcelHelpers.interopDefault(_headphonesBatteryTwoTone);
var _headphonesOutlined = require("./HeadphonesOutlined");
var _headphonesOutlinedDefault = parcelHelpers.interopDefault(_headphonesOutlined);
var _headphonesRounded = require("./HeadphonesRounded");
var _headphonesRoundedDefault = parcelHelpers.interopDefault(_headphonesRounded);
var _headphonesSharp = require("./HeadphonesSharp");
var _headphonesSharpDefault = parcelHelpers.interopDefault(_headphonesSharp);
var _headphonesTwoTone = require("./HeadphonesTwoTone");
var _headphonesTwoToneDefault = parcelHelpers.interopDefault(_headphonesTwoTone);
var _headset = require("./Headset");
var _headsetDefault = parcelHelpers.interopDefault(_headset);
var _headsetMic = require("./HeadsetMic");
var _headsetMicDefault = parcelHelpers.interopDefault(_headsetMic);
var _headsetMicOutlined = require("./HeadsetMicOutlined");
var _headsetMicOutlinedDefault = parcelHelpers.interopDefault(_headsetMicOutlined);
var _headsetMicRounded = require("./HeadsetMicRounded");
var _headsetMicRoundedDefault = parcelHelpers.interopDefault(_headsetMicRounded);
var _headsetMicSharp = require("./HeadsetMicSharp");
var _headsetMicSharpDefault = parcelHelpers.interopDefault(_headsetMicSharp);
var _headsetMicTwoTone = require("./HeadsetMicTwoTone");
var _headsetMicTwoToneDefault = parcelHelpers.interopDefault(_headsetMicTwoTone);
var _headsetOff = require("./HeadsetOff");
var _headsetOffDefault = parcelHelpers.interopDefault(_headsetOff);
var _headsetOffOutlined = require("./HeadsetOffOutlined");
var _headsetOffOutlinedDefault = parcelHelpers.interopDefault(_headsetOffOutlined);
var _headsetOffRounded = require("./HeadsetOffRounded");
var _headsetOffRoundedDefault = parcelHelpers.interopDefault(_headsetOffRounded);
var _headsetOffSharp = require("./HeadsetOffSharp");
var _headsetOffSharpDefault = parcelHelpers.interopDefault(_headsetOffSharp);
var _headsetOffTwoTone = require("./HeadsetOffTwoTone");
var _headsetOffTwoToneDefault = parcelHelpers.interopDefault(_headsetOffTwoTone);
var _headsetOutlined = require("./HeadsetOutlined");
var _headsetOutlinedDefault = parcelHelpers.interopDefault(_headsetOutlined);
var _headsetRounded = require("./HeadsetRounded");
var _headsetRoundedDefault = parcelHelpers.interopDefault(_headsetRounded);
var _headsetSharp = require("./HeadsetSharp");
var _headsetSharpDefault = parcelHelpers.interopDefault(_headsetSharp);
var _headsetTwoTone = require("./HeadsetTwoTone");
var _headsetTwoToneDefault = parcelHelpers.interopDefault(_headsetTwoTone);
var _healing = require("./Healing");
var _healingDefault = parcelHelpers.interopDefault(_healing);
var _healingOutlined = require("./HealingOutlined");
var _healingOutlinedDefault = parcelHelpers.interopDefault(_healingOutlined);
var _healingRounded = require("./HealingRounded");
var _healingRoundedDefault = parcelHelpers.interopDefault(_healingRounded);
var _healingSharp = require("./HealingSharp");
var _healingSharpDefault = parcelHelpers.interopDefault(_healingSharp);
var _healingTwoTone = require("./HealingTwoTone");
var _healingTwoToneDefault = parcelHelpers.interopDefault(_healingTwoTone);
var _healthAndSafety = require("./HealthAndSafety");
var _healthAndSafetyDefault = parcelHelpers.interopDefault(_healthAndSafety);
var _healthAndSafetyOutlined = require("./HealthAndSafetyOutlined");
var _healthAndSafetyOutlinedDefault = parcelHelpers.interopDefault(_healthAndSafetyOutlined);
var _healthAndSafetyRounded = require("./HealthAndSafetyRounded");
var _healthAndSafetyRoundedDefault = parcelHelpers.interopDefault(_healthAndSafetyRounded);
var _healthAndSafetySharp = require("./HealthAndSafetySharp");
var _healthAndSafetySharpDefault = parcelHelpers.interopDefault(_healthAndSafetySharp);
var _healthAndSafetyTwoTone = require("./HealthAndSafetyTwoTone");
var _healthAndSafetyTwoToneDefault = parcelHelpers.interopDefault(_healthAndSafetyTwoTone);
var _hearing = require("./Hearing");
var _hearingDefault = parcelHelpers.interopDefault(_hearing);
var _hearingDisabled = require("./HearingDisabled");
var _hearingDisabledDefault = parcelHelpers.interopDefault(_hearingDisabled);
var _hearingDisabledOutlined = require("./HearingDisabledOutlined");
var _hearingDisabledOutlinedDefault = parcelHelpers.interopDefault(_hearingDisabledOutlined);
var _hearingDisabledRounded = require("./HearingDisabledRounded");
var _hearingDisabledRoundedDefault = parcelHelpers.interopDefault(_hearingDisabledRounded);
var _hearingDisabledSharp = require("./HearingDisabledSharp");
var _hearingDisabledSharpDefault = parcelHelpers.interopDefault(_hearingDisabledSharp);
var _hearingDisabledTwoTone = require("./HearingDisabledTwoTone");
var _hearingDisabledTwoToneDefault = parcelHelpers.interopDefault(_hearingDisabledTwoTone);
var _hearingOutlined = require("./HearingOutlined");
var _hearingOutlinedDefault = parcelHelpers.interopDefault(_hearingOutlined);
var _hearingRounded = require("./HearingRounded");
var _hearingRoundedDefault = parcelHelpers.interopDefault(_hearingRounded);
var _hearingSharp = require("./HearingSharp");
var _hearingSharpDefault = parcelHelpers.interopDefault(_hearingSharp);
var _hearingTwoTone = require("./HearingTwoTone");
var _hearingTwoToneDefault = parcelHelpers.interopDefault(_hearingTwoTone);
var _heartBroken = require("./HeartBroken");
var _heartBrokenDefault = parcelHelpers.interopDefault(_heartBroken);
var _heartBrokenOutlined = require("./HeartBrokenOutlined");
var _heartBrokenOutlinedDefault = parcelHelpers.interopDefault(_heartBrokenOutlined);
var _heartBrokenRounded = require("./HeartBrokenRounded");
var _heartBrokenRoundedDefault = parcelHelpers.interopDefault(_heartBrokenRounded);
var _heartBrokenSharp = require("./HeartBrokenSharp");
var _heartBrokenSharpDefault = parcelHelpers.interopDefault(_heartBrokenSharp);
var _heartBrokenTwoTone = require("./HeartBrokenTwoTone");
var _heartBrokenTwoToneDefault = parcelHelpers.interopDefault(_heartBrokenTwoTone);
var _heatPump = require("./HeatPump");
var _heatPumpDefault = parcelHelpers.interopDefault(_heatPump);
var _heatPumpOutlined = require("./HeatPumpOutlined");
var _heatPumpOutlinedDefault = parcelHelpers.interopDefault(_heatPumpOutlined);
var _heatPumpRounded = require("./HeatPumpRounded");
var _heatPumpRoundedDefault = parcelHelpers.interopDefault(_heatPumpRounded);
var _heatPumpSharp = require("./HeatPumpSharp");
var _heatPumpSharpDefault = parcelHelpers.interopDefault(_heatPumpSharp);
var _heatPumpTwoTone = require("./HeatPumpTwoTone");
var _heatPumpTwoToneDefault = parcelHelpers.interopDefault(_heatPumpTwoTone);
var _height = require("./Height");
var _heightDefault = parcelHelpers.interopDefault(_height);
var _heightOutlined = require("./HeightOutlined");
var _heightOutlinedDefault = parcelHelpers.interopDefault(_heightOutlined);
var _heightRounded = require("./HeightRounded");
var _heightRoundedDefault = parcelHelpers.interopDefault(_heightRounded);
var _heightSharp = require("./HeightSharp");
var _heightSharpDefault = parcelHelpers.interopDefault(_heightSharp);
var _heightTwoTone = require("./HeightTwoTone");
var _heightTwoToneDefault = parcelHelpers.interopDefault(_heightTwoTone);
var _help = require("./Help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _helpCenter = require("./HelpCenter");
var _helpCenterDefault = parcelHelpers.interopDefault(_helpCenter);
var _helpCenterOutlined = require("./HelpCenterOutlined");
var _helpCenterOutlinedDefault = parcelHelpers.interopDefault(_helpCenterOutlined);
var _helpCenterRounded = require("./HelpCenterRounded");
var _helpCenterRoundedDefault = parcelHelpers.interopDefault(_helpCenterRounded);
var _helpCenterSharp = require("./HelpCenterSharp");
var _helpCenterSharpDefault = parcelHelpers.interopDefault(_helpCenterSharp);
var _helpCenterTwoTone = require("./HelpCenterTwoTone");
var _helpCenterTwoToneDefault = parcelHelpers.interopDefault(_helpCenterTwoTone);
var _helpOutline = require("./HelpOutline");
var _helpOutlineDefault = parcelHelpers.interopDefault(_helpOutline);
var _helpOutlineOutlined = require("./HelpOutlineOutlined");
var _helpOutlineOutlinedDefault = parcelHelpers.interopDefault(_helpOutlineOutlined);
var _helpOutlineRounded = require("./HelpOutlineRounded");
var _helpOutlineRoundedDefault = parcelHelpers.interopDefault(_helpOutlineRounded);
var _helpOutlineSharp = require("./HelpOutlineSharp");
var _helpOutlineSharpDefault = parcelHelpers.interopDefault(_helpOutlineSharp);
var _helpOutlineTwoTone = require("./HelpOutlineTwoTone");
var _helpOutlineTwoToneDefault = parcelHelpers.interopDefault(_helpOutlineTwoTone);
var _helpOutlined = require("./HelpOutlined");
var _helpOutlinedDefault = parcelHelpers.interopDefault(_helpOutlined);
var _helpRounded = require("./HelpRounded");
var _helpRoundedDefault = parcelHelpers.interopDefault(_helpRounded);
var _helpSharp = require("./HelpSharp");
var _helpSharpDefault = parcelHelpers.interopDefault(_helpSharp);
var _helpTwoTone = require("./HelpTwoTone");
var _helpTwoToneDefault = parcelHelpers.interopDefault(_helpTwoTone);
var _hevc = require("./Hevc");
var _hevcDefault = parcelHelpers.interopDefault(_hevc);
var _hevcOutlined = require("./HevcOutlined");
var _hevcOutlinedDefault = parcelHelpers.interopDefault(_hevcOutlined);
var _hevcRounded = require("./HevcRounded");
var _hevcRoundedDefault = parcelHelpers.interopDefault(_hevcRounded);
var _hevcSharp = require("./HevcSharp");
var _hevcSharpDefault = parcelHelpers.interopDefault(_hevcSharp);
var _hevcTwoTone = require("./HevcTwoTone");
var _hevcTwoToneDefault = parcelHelpers.interopDefault(_hevcTwoTone);
var _hexagon = require("./Hexagon");
var _hexagonDefault = parcelHelpers.interopDefault(_hexagon);
var _hexagonOutlined = require("./HexagonOutlined");
var _hexagonOutlinedDefault = parcelHelpers.interopDefault(_hexagonOutlined);
var _hexagonRounded = require("./HexagonRounded");
var _hexagonRoundedDefault = parcelHelpers.interopDefault(_hexagonRounded);
var _hexagonSharp = require("./HexagonSharp");
var _hexagonSharpDefault = parcelHelpers.interopDefault(_hexagonSharp);
var _hexagonTwoTone = require("./HexagonTwoTone");
var _hexagonTwoToneDefault = parcelHelpers.interopDefault(_hexagonTwoTone);
var _hideImage = require("./HideImage");
var _hideImageDefault = parcelHelpers.interopDefault(_hideImage);
var _hideImageOutlined = require("./HideImageOutlined");
var _hideImageOutlinedDefault = parcelHelpers.interopDefault(_hideImageOutlined);
var _hideImageRounded = require("./HideImageRounded");
var _hideImageRoundedDefault = parcelHelpers.interopDefault(_hideImageRounded);
var _hideImageSharp = require("./HideImageSharp");
var _hideImageSharpDefault = parcelHelpers.interopDefault(_hideImageSharp);
var _hideImageTwoTone = require("./HideImageTwoTone");
var _hideImageTwoToneDefault = parcelHelpers.interopDefault(_hideImageTwoTone);
var _hideSource = require("./HideSource");
var _hideSourceDefault = parcelHelpers.interopDefault(_hideSource);
var _hideSourceOutlined = require("./HideSourceOutlined");
var _hideSourceOutlinedDefault = parcelHelpers.interopDefault(_hideSourceOutlined);
var _hideSourceRounded = require("./HideSourceRounded");
var _hideSourceRoundedDefault = parcelHelpers.interopDefault(_hideSourceRounded);
var _hideSourceSharp = require("./HideSourceSharp");
var _hideSourceSharpDefault = parcelHelpers.interopDefault(_hideSourceSharp);
var _hideSourceTwoTone = require("./HideSourceTwoTone");
var _hideSourceTwoToneDefault = parcelHelpers.interopDefault(_hideSourceTwoTone);
var _highQuality = require("./HighQuality");
var _highQualityDefault = parcelHelpers.interopDefault(_highQuality);
var _highQualityOutlined = require("./HighQualityOutlined");
var _highQualityOutlinedDefault = parcelHelpers.interopDefault(_highQualityOutlined);
var _highQualityRounded = require("./HighQualityRounded");
var _highQualityRoundedDefault = parcelHelpers.interopDefault(_highQualityRounded);
var _highQualitySharp = require("./HighQualitySharp");
var _highQualitySharpDefault = parcelHelpers.interopDefault(_highQualitySharp);
var _highQualityTwoTone = require("./HighQualityTwoTone");
var _highQualityTwoToneDefault = parcelHelpers.interopDefault(_highQualityTwoTone);
var _highlight = require("./Highlight");
var _highlightDefault = parcelHelpers.interopDefault(_highlight);
var _highlightAlt = require("./HighlightAlt");
var _highlightAltDefault = parcelHelpers.interopDefault(_highlightAlt);
var _highlightAltOutlined = require("./HighlightAltOutlined");
var _highlightAltOutlinedDefault = parcelHelpers.interopDefault(_highlightAltOutlined);
var _highlightAltRounded = require("./HighlightAltRounded");
var _highlightAltRoundedDefault = parcelHelpers.interopDefault(_highlightAltRounded);
var _highlightAltSharp = require("./HighlightAltSharp");
var _highlightAltSharpDefault = parcelHelpers.interopDefault(_highlightAltSharp);
var _highlightAltTwoTone = require("./HighlightAltTwoTone");
var _highlightAltTwoToneDefault = parcelHelpers.interopDefault(_highlightAltTwoTone);
var _highlightOff = require("./HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _highlightOffOutlined = require("./HighlightOffOutlined");
var _highlightOffOutlinedDefault = parcelHelpers.interopDefault(_highlightOffOutlined);
var _highlightOffRounded = require("./HighlightOffRounded");
var _highlightOffRoundedDefault = parcelHelpers.interopDefault(_highlightOffRounded);
var _highlightOffSharp = require("./HighlightOffSharp");
var _highlightOffSharpDefault = parcelHelpers.interopDefault(_highlightOffSharp);
var _highlightOffTwoTone = require("./HighlightOffTwoTone");
var _highlightOffTwoToneDefault = parcelHelpers.interopDefault(_highlightOffTwoTone);
var _highlightOutlined = require("./HighlightOutlined");
var _highlightOutlinedDefault = parcelHelpers.interopDefault(_highlightOutlined);
var _highlightRounded = require("./HighlightRounded");
var _highlightRoundedDefault = parcelHelpers.interopDefault(_highlightRounded);
var _highlightSharp = require("./HighlightSharp");
var _highlightSharpDefault = parcelHelpers.interopDefault(_highlightSharp);
var _highlightTwoTone = require("./HighlightTwoTone");
var _highlightTwoToneDefault = parcelHelpers.interopDefault(_highlightTwoTone);
var _hiking = require("./Hiking");
var _hikingDefault = parcelHelpers.interopDefault(_hiking);
var _hikingOutlined = require("./HikingOutlined");
var _hikingOutlinedDefault = parcelHelpers.interopDefault(_hikingOutlined);
var _hikingRounded = require("./HikingRounded");
var _hikingRoundedDefault = parcelHelpers.interopDefault(_hikingRounded);
var _hikingSharp = require("./HikingSharp");
var _hikingSharpDefault = parcelHelpers.interopDefault(_hikingSharp);
var _hikingTwoTone = require("./HikingTwoTone");
var _hikingTwoToneDefault = parcelHelpers.interopDefault(_hikingTwoTone);
var _history = require("./History");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _historyEdu = require("./HistoryEdu");
var _historyEduDefault = parcelHelpers.interopDefault(_historyEdu);
var _historyEduOutlined = require("./HistoryEduOutlined");
var _historyEduOutlinedDefault = parcelHelpers.interopDefault(_historyEduOutlined);
var _historyEduRounded = require("./HistoryEduRounded");
var _historyEduRoundedDefault = parcelHelpers.interopDefault(_historyEduRounded);
var _historyEduSharp = require("./HistoryEduSharp");
var _historyEduSharpDefault = parcelHelpers.interopDefault(_historyEduSharp);
var _historyEduTwoTone = require("./HistoryEduTwoTone");
var _historyEduTwoToneDefault = parcelHelpers.interopDefault(_historyEduTwoTone);
var _historyOutlined = require("./HistoryOutlined");
var _historyOutlinedDefault = parcelHelpers.interopDefault(_historyOutlined);
var _historyRounded = require("./HistoryRounded");
var _historyRoundedDefault = parcelHelpers.interopDefault(_historyRounded);
var _historySharp = require("./HistorySharp");
var _historySharpDefault = parcelHelpers.interopDefault(_historySharp);
var _historyToggleOff = require("./HistoryToggleOff");
var _historyToggleOffDefault = parcelHelpers.interopDefault(_historyToggleOff);
var _historyToggleOffOutlined = require("./HistoryToggleOffOutlined");
var _historyToggleOffOutlinedDefault = parcelHelpers.interopDefault(_historyToggleOffOutlined);
var _historyToggleOffRounded = require("./HistoryToggleOffRounded");
var _historyToggleOffRoundedDefault = parcelHelpers.interopDefault(_historyToggleOffRounded);
var _historyToggleOffSharp = require("./HistoryToggleOffSharp");
var _historyToggleOffSharpDefault = parcelHelpers.interopDefault(_historyToggleOffSharp);
var _historyToggleOffTwoTone = require("./HistoryToggleOffTwoTone");
var _historyToggleOffTwoToneDefault = parcelHelpers.interopDefault(_historyToggleOffTwoTone);
var _historyTwoTone = require("./HistoryTwoTone");
var _historyTwoToneDefault = parcelHelpers.interopDefault(_historyTwoTone);
var _hive = require("./Hive");
var _hiveDefault = parcelHelpers.interopDefault(_hive);
var _hiveOutlined = require("./HiveOutlined");
var _hiveOutlinedDefault = parcelHelpers.interopDefault(_hiveOutlined);
var _hiveRounded = require("./HiveRounded");
var _hiveRoundedDefault = parcelHelpers.interopDefault(_hiveRounded);
var _hiveSharp = require("./HiveSharp");
var _hiveSharpDefault = parcelHelpers.interopDefault(_hiveSharp);
var _hiveTwoTone = require("./HiveTwoTone");
var _hiveTwoToneDefault = parcelHelpers.interopDefault(_hiveTwoTone);
var _hls = require("./Hls");
var _hlsDefault = parcelHelpers.interopDefault(_hls);
var _hlsOff = require("./HlsOff");
var _hlsOffDefault = parcelHelpers.interopDefault(_hlsOff);
var _hlsOffOutlined = require("./HlsOffOutlined");
var _hlsOffOutlinedDefault = parcelHelpers.interopDefault(_hlsOffOutlined);
var _hlsOffRounded = require("./HlsOffRounded");
var _hlsOffRoundedDefault = parcelHelpers.interopDefault(_hlsOffRounded);
var _hlsOffSharp = require("./HlsOffSharp");
var _hlsOffSharpDefault = parcelHelpers.interopDefault(_hlsOffSharp);
var _hlsOffTwoTone = require("./HlsOffTwoTone");
var _hlsOffTwoToneDefault = parcelHelpers.interopDefault(_hlsOffTwoTone);
var _hlsOutlined = require("./HlsOutlined");
var _hlsOutlinedDefault = parcelHelpers.interopDefault(_hlsOutlined);
var _hlsRounded = require("./HlsRounded");
var _hlsRoundedDefault = parcelHelpers.interopDefault(_hlsRounded);
var _hlsSharp = require("./HlsSharp");
var _hlsSharpDefault = parcelHelpers.interopDefault(_hlsSharp);
var _hlsTwoTone = require("./HlsTwoTone");
var _hlsTwoToneDefault = parcelHelpers.interopDefault(_hlsTwoTone);
var _holidayVillage = require("./HolidayVillage");
var _holidayVillageDefault = parcelHelpers.interopDefault(_holidayVillage);
var _holidayVillageOutlined = require("./HolidayVillageOutlined");
var _holidayVillageOutlinedDefault = parcelHelpers.interopDefault(_holidayVillageOutlined);
var _holidayVillageRounded = require("./HolidayVillageRounded");
var _holidayVillageRoundedDefault = parcelHelpers.interopDefault(_holidayVillageRounded);
var _holidayVillageSharp = require("./HolidayVillageSharp");
var _holidayVillageSharpDefault = parcelHelpers.interopDefault(_holidayVillageSharp);
var _holidayVillageTwoTone = require("./HolidayVillageTwoTone");
var _holidayVillageTwoToneDefault = parcelHelpers.interopDefault(_holidayVillageTwoTone);
var _home = require("./Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _homeMax = require("./HomeMax");
var _homeMaxDefault = parcelHelpers.interopDefault(_homeMax);
var _homeMaxOutlined = require("./HomeMaxOutlined");
var _homeMaxOutlinedDefault = parcelHelpers.interopDefault(_homeMaxOutlined);
var _homeMaxRounded = require("./HomeMaxRounded");
var _homeMaxRoundedDefault = parcelHelpers.interopDefault(_homeMaxRounded);
var _homeMaxSharp = require("./HomeMaxSharp");
var _homeMaxSharpDefault = parcelHelpers.interopDefault(_homeMaxSharp);
var _homeMaxTwoTone = require("./HomeMaxTwoTone");
var _homeMaxTwoToneDefault = parcelHelpers.interopDefault(_homeMaxTwoTone);
var _homeMini = require("./HomeMini");
var _homeMiniDefault = parcelHelpers.interopDefault(_homeMini);
var _homeMiniOutlined = require("./HomeMiniOutlined");
var _homeMiniOutlinedDefault = parcelHelpers.interopDefault(_homeMiniOutlined);
var _homeMiniRounded = require("./HomeMiniRounded");
var _homeMiniRoundedDefault = parcelHelpers.interopDefault(_homeMiniRounded);
var _homeMiniSharp = require("./HomeMiniSharp");
var _homeMiniSharpDefault = parcelHelpers.interopDefault(_homeMiniSharp);
var _homeMiniTwoTone = require("./HomeMiniTwoTone");
var _homeMiniTwoToneDefault = parcelHelpers.interopDefault(_homeMiniTwoTone);
var _homeOutlined = require("./HomeOutlined");
var _homeOutlinedDefault = parcelHelpers.interopDefault(_homeOutlined);
var _homeRepairService = require("./HomeRepairService");
var _homeRepairServiceDefault = parcelHelpers.interopDefault(_homeRepairService);
var _homeRepairServiceOutlined = require("./HomeRepairServiceOutlined");
var _homeRepairServiceOutlinedDefault = parcelHelpers.interopDefault(_homeRepairServiceOutlined);
var _homeRepairServiceRounded = require("./HomeRepairServiceRounded");
var _homeRepairServiceRoundedDefault = parcelHelpers.interopDefault(_homeRepairServiceRounded);
var _homeRepairServiceSharp = require("./HomeRepairServiceSharp");
var _homeRepairServiceSharpDefault = parcelHelpers.interopDefault(_homeRepairServiceSharp);
var _homeRepairServiceTwoTone = require("./HomeRepairServiceTwoTone");
var _homeRepairServiceTwoToneDefault = parcelHelpers.interopDefault(_homeRepairServiceTwoTone);
var _homeRounded = require("./HomeRounded");
var _homeRoundedDefault = parcelHelpers.interopDefault(_homeRounded);
var _homeSharp = require("./HomeSharp");
var _homeSharpDefault = parcelHelpers.interopDefault(_homeSharp);
var _homeTwoTone = require("./HomeTwoTone");
var _homeTwoToneDefault = parcelHelpers.interopDefault(_homeTwoTone);
var _homeWork = require("./HomeWork");
var _homeWorkDefault = parcelHelpers.interopDefault(_homeWork);
var _homeWorkOutlined = require("./HomeWorkOutlined");
var _homeWorkOutlinedDefault = parcelHelpers.interopDefault(_homeWorkOutlined);
var _homeWorkRounded = require("./HomeWorkRounded");
var _homeWorkRoundedDefault = parcelHelpers.interopDefault(_homeWorkRounded);
var _homeWorkSharp = require("./HomeWorkSharp");
var _homeWorkSharpDefault = parcelHelpers.interopDefault(_homeWorkSharp);
var _homeWorkTwoTone = require("./HomeWorkTwoTone");
var _homeWorkTwoToneDefault = parcelHelpers.interopDefault(_homeWorkTwoTone);
var _horizontalRule = require("./HorizontalRule");
var _horizontalRuleDefault = parcelHelpers.interopDefault(_horizontalRule);
var _horizontalRuleOutlined = require("./HorizontalRuleOutlined");
var _horizontalRuleOutlinedDefault = parcelHelpers.interopDefault(_horizontalRuleOutlined);
var _horizontalRuleRounded = require("./HorizontalRuleRounded");
var _horizontalRuleRoundedDefault = parcelHelpers.interopDefault(_horizontalRuleRounded);
var _horizontalRuleSharp = require("./HorizontalRuleSharp");
var _horizontalRuleSharpDefault = parcelHelpers.interopDefault(_horizontalRuleSharp);
var _horizontalRuleTwoTone = require("./HorizontalRuleTwoTone");
var _horizontalRuleTwoToneDefault = parcelHelpers.interopDefault(_horizontalRuleTwoTone);
var _horizontalSplit = require("./HorizontalSplit");
var _horizontalSplitDefault = parcelHelpers.interopDefault(_horizontalSplit);
var _horizontalSplitOutlined = require("./HorizontalSplitOutlined");
var _horizontalSplitOutlinedDefault = parcelHelpers.interopDefault(_horizontalSplitOutlined);
var _horizontalSplitRounded = require("./HorizontalSplitRounded");
var _horizontalSplitRoundedDefault = parcelHelpers.interopDefault(_horizontalSplitRounded);
var _horizontalSplitSharp = require("./HorizontalSplitSharp");
var _horizontalSplitSharpDefault = parcelHelpers.interopDefault(_horizontalSplitSharp);
var _horizontalSplitTwoTone = require("./HorizontalSplitTwoTone");
var _horizontalSplitTwoToneDefault = parcelHelpers.interopDefault(_horizontalSplitTwoTone);
var _hotTub = require("./HotTub");
var _hotTubDefault = parcelHelpers.interopDefault(_hotTub);
var _hotTubOutlined = require("./HotTubOutlined");
var _hotTubOutlinedDefault = parcelHelpers.interopDefault(_hotTubOutlined);
var _hotTubRounded = require("./HotTubRounded");
var _hotTubRoundedDefault = parcelHelpers.interopDefault(_hotTubRounded);
var _hotTubSharp = require("./HotTubSharp");
var _hotTubSharpDefault = parcelHelpers.interopDefault(_hotTubSharp);
var _hotTubTwoTone = require("./HotTubTwoTone");
var _hotTubTwoToneDefault = parcelHelpers.interopDefault(_hotTubTwoTone);
var _hotel = require("./Hotel");
var _hotelDefault = parcelHelpers.interopDefault(_hotel);
var _hotelOutlined = require("./HotelOutlined");
var _hotelOutlinedDefault = parcelHelpers.interopDefault(_hotelOutlined);
var _hotelRounded = require("./HotelRounded");
var _hotelRoundedDefault = parcelHelpers.interopDefault(_hotelRounded);
var _hotelSharp = require("./HotelSharp");
var _hotelSharpDefault = parcelHelpers.interopDefault(_hotelSharp);
var _hotelTwoTone = require("./HotelTwoTone");
var _hotelTwoToneDefault = parcelHelpers.interopDefault(_hotelTwoTone);
var _hourglassBottom = require("./HourglassBottom");
var _hourglassBottomDefault = parcelHelpers.interopDefault(_hourglassBottom);
var _hourglassBottomOutlined = require("./HourglassBottomOutlined");
var _hourglassBottomOutlinedDefault = parcelHelpers.interopDefault(_hourglassBottomOutlined);
var _hourglassBottomRounded = require("./HourglassBottomRounded");
var _hourglassBottomRoundedDefault = parcelHelpers.interopDefault(_hourglassBottomRounded);
var _hourglassBottomSharp = require("./HourglassBottomSharp");
var _hourglassBottomSharpDefault = parcelHelpers.interopDefault(_hourglassBottomSharp);
var _hourglassBottomTwoTone = require("./HourglassBottomTwoTone");
var _hourglassBottomTwoToneDefault = parcelHelpers.interopDefault(_hourglassBottomTwoTone);
var _hourglassDisabled = require("./HourglassDisabled");
var _hourglassDisabledDefault = parcelHelpers.interopDefault(_hourglassDisabled);
var _hourglassDisabledOutlined = require("./HourglassDisabledOutlined");
var _hourglassDisabledOutlinedDefault = parcelHelpers.interopDefault(_hourglassDisabledOutlined);
var _hourglassDisabledRounded = require("./HourglassDisabledRounded");
var _hourglassDisabledRoundedDefault = parcelHelpers.interopDefault(_hourglassDisabledRounded);
var _hourglassDisabledSharp = require("./HourglassDisabledSharp");
var _hourglassDisabledSharpDefault = parcelHelpers.interopDefault(_hourglassDisabledSharp);
var _hourglassDisabledTwoTone = require("./HourglassDisabledTwoTone");
var _hourglassDisabledTwoToneDefault = parcelHelpers.interopDefault(_hourglassDisabledTwoTone);
var _hourglassEmpty = require("./HourglassEmpty");
var _hourglassEmptyDefault = parcelHelpers.interopDefault(_hourglassEmpty);
var _hourglassEmptyOutlined = require("./HourglassEmptyOutlined");
var _hourglassEmptyOutlinedDefault = parcelHelpers.interopDefault(_hourglassEmptyOutlined);
var _hourglassEmptyRounded = require("./HourglassEmptyRounded");
var _hourglassEmptyRoundedDefault = parcelHelpers.interopDefault(_hourglassEmptyRounded);
var _hourglassEmptySharp = require("./HourglassEmptySharp");
var _hourglassEmptySharpDefault = parcelHelpers.interopDefault(_hourglassEmptySharp);
var _hourglassEmptyTwoTone = require("./HourglassEmptyTwoTone");
var _hourglassEmptyTwoToneDefault = parcelHelpers.interopDefault(_hourglassEmptyTwoTone);
var _hourglassFull = require("./HourglassFull");
var _hourglassFullDefault = parcelHelpers.interopDefault(_hourglassFull);
var _hourglassFullOutlined = require("./HourglassFullOutlined");
var _hourglassFullOutlinedDefault = parcelHelpers.interopDefault(_hourglassFullOutlined);
var _hourglassFullRounded = require("./HourglassFullRounded");
var _hourglassFullRoundedDefault = parcelHelpers.interopDefault(_hourglassFullRounded);
var _hourglassFullSharp = require("./HourglassFullSharp");
var _hourglassFullSharpDefault = parcelHelpers.interopDefault(_hourglassFullSharp);
var _hourglassFullTwoTone = require("./HourglassFullTwoTone");
var _hourglassFullTwoToneDefault = parcelHelpers.interopDefault(_hourglassFullTwoTone);
var _hourglassTop = require("./HourglassTop");
var _hourglassTopDefault = parcelHelpers.interopDefault(_hourglassTop);
var _hourglassTopOutlined = require("./HourglassTopOutlined");
var _hourglassTopOutlinedDefault = parcelHelpers.interopDefault(_hourglassTopOutlined);
var _hourglassTopRounded = require("./HourglassTopRounded");
var _hourglassTopRoundedDefault = parcelHelpers.interopDefault(_hourglassTopRounded);
var _hourglassTopSharp = require("./HourglassTopSharp");
var _hourglassTopSharpDefault = parcelHelpers.interopDefault(_hourglassTopSharp);
var _hourglassTopTwoTone = require("./HourglassTopTwoTone");
var _hourglassTopTwoToneDefault = parcelHelpers.interopDefault(_hourglassTopTwoTone);
var _house = require("./House");
var _houseDefault = parcelHelpers.interopDefault(_house);
var _houseOutlined = require("./HouseOutlined");
var _houseOutlinedDefault = parcelHelpers.interopDefault(_houseOutlined);
var _houseRounded = require("./HouseRounded");
var _houseRoundedDefault = parcelHelpers.interopDefault(_houseRounded);
var _houseSharp = require("./HouseSharp");
var _houseSharpDefault = parcelHelpers.interopDefault(_houseSharp);
var _houseSiding = require("./HouseSiding");
var _houseSidingDefault = parcelHelpers.interopDefault(_houseSiding);
var _houseSidingOutlined = require("./HouseSidingOutlined");
var _houseSidingOutlinedDefault = parcelHelpers.interopDefault(_houseSidingOutlined);
var _houseSidingRounded = require("./HouseSidingRounded");
var _houseSidingRoundedDefault = parcelHelpers.interopDefault(_houseSidingRounded);
var _houseSidingSharp = require("./HouseSidingSharp");
var _houseSidingSharpDefault = parcelHelpers.interopDefault(_houseSidingSharp);
var _houseSidingTwoTone = require("./HouseSidingTwoTone");
var _houseSidingTwoToneDefault = parcelHelpers.interopDefault(_houseSidingTwoTone);
var _houseTwoTone = require("./HouseTwoTone");
var _houseTwoToneDefault = parcelHelpers.interopDefault(_houseTwoTone);
var _houseboat = require("./Houseboat");
var _houseboatDefault = parcelHelpers.interopDefault(_houseboat);
var _houseboatOutlined = require("./HouseboatOutlined");
var _houseboatOutlinedDefault = parcelHelpers.interopDefault(_houseboatOutlined);
var _houseboatRounded = require("./HouseboatRounded");
var _houseboatRoundedDefault = parcelHelpers.interopDefault(_houseboatRounded);
var _houseboatSharp = require("./HouseboatSharp");
var _houseboatSharpDefault = parcelHelpers.interopDefault(_houseboatSharp);
var _houseboatTwoTone = require("./HouseboatTwoTone");
var _houseboatTwoToneDefault = parcelHelpers.interopDefault(_houseboatTwoTone);
var _howToReg = require("./HowToReg");
var _howToRegDefault = parcelHelpers.interopDefault(_howToReg);
var _howToRegOutlined = require("./HowToRegOutlined");
var _howToRegOutlinedDefault = parcelHelpers.interopDefault(_howToRegOutlined);
var _howToRegRounded = require("./HowToRegRounded");
var _howToRegRoundedDefault = parcelHelpers.interopDefault(_howToRegRounded);
var _howToRegSharp = require("./HowToRegSharp");
var _howToRegSharpDefault = parcelHelpers.interopDefault(_howToRegSharp);
var _howToRegTwoTone = require("./HowToRegTwoTone");
var _howToRegTwoToneDefault = parcelHelpers.interopDefault(_howToRegTwoTone);
var _howToVote = require("./HowToVote");
var _howToVoteDefault = parcelHelpers.interopDefault(_howToVote);
var _howToVoteOutlined = require("./HowToVoteOutlined");
var _howToVoteOutlinedDefault = parcelHelpers.interopDefault(_howToVoteOutlined);
var _howToVoteRounded = require("./HowToVoteRounded");
var _howToVoteRoundedDefault = parcelHelpers.interopDefault(_howToVoteRounded);
var _howToVoteSharp = require("./HowToVoteSharp");
var _howToVoteSharpDefault = parcelHelpers.interopDefault(_howToVoteSharp);
var _howToVoteTwoTone = require("./HowToVoteTwoTone");
var _howToVoteTwoToneDefault = parcelHelpers.interopDefault(_howToVoteTwoTone);
var _html = require("./Html");
var _htmlDefault = parcelHelpers.interopDefault(_html);
var _htmlOutlined = require("./HtmlOutlined");
var _htmlOutlinedDefault = parcelHelpers.interopDefault(_htmlOutlined);
var _htmlRounded = require("./HtmlRounded");
var _htmlRoundedDefault = parcelHelpers.interopDefault(_htmlRounded);
var _htmlSharp = require("./HtmlSharp");
var _htmlSharpDefault = parcelHelpers.interopDefault(_htmlSharp);
var _htmlTwoTone = require("./HtmlTwoTone");
var _htmlTwoToneDefault = parcelHelpers.interopDefault(_htmlTwoTone);
var _http = require("./Http");
var _httpDefault = parcelHelpers.interopDefault(_http);
var _httpOutlined = require("./HttpOutlined");
var _httpOutlinedDefault = parcelHelpers.interopDefault(_httpOutlined);
var _httpRounded = require("./HttpRounded");
var _httpRoundedDefault = parcelHelpers.interopDefault(_httpRounded);
var _httpSharp = require("./HttpSharp");
var _httpSharpDefault = parcelHelpers.interopDefault(_httpSharp);
var _httpTwoTone = require("./HttpTwoTone");
var _httpTwoToneDefault = parcelHelpers.interopDefault(_httpTwoTone);
var _https = require("./Https");
var _httpsDefault = parcelHelpers.interopDefault(_https);
var _httpsOutlined = require("./HttpsOutlined");
var _httpsOutlinedDefault = parcelHelpers.interopDefault(_httpsOutlined);
var _httpsRounded = require("./HttpsRounded");
var _httpsRoundedDefault = parcelHelpers.interopDefault(_httpsRounded);
var _httpsSharp = require("./HttpsSharp");
var _httpsSharpDefault = parcelHelpers.interopDefault(_httpsSharp);
var _httpsTwoTone = require("./HttpsTwoTone");
var _httpsTwoToneDefault = parcelHelpers.interopDefault(_httpsTwoTone);
var _hub = require("./Hub");
var _hubDefault = parcelHelpers.interopDefault(_hub);
var _hubOutlined = require("./HubOutlined");
var _hubOutlinedDefault = parcelHelpers.interopDefault(_hubOutlined);
var _hubRounded = require("./HubRounded");
var _hubRoundedDefault = parcelHelpers.interopDefault(_hubRounded);
var _hubSharp = require("./HubSharp");
var _hubSharpDefault = parcelHelpers.interopDefault(_hubSharp);
var _hubTwoTone = require("./HubTwoTone");
var _hubTwoToneDefault = parcelHelpers.interopDefault(_hubTwoTone);
var _hvac = require("./Hvac");
var _hvacDefault = parcelHelpers.interopDefault(_hvac);
var _hvacOutlined = require("./HvacOutlined");
var _hvacOutlinedDefault = parcelHelpers.interopDefault(_hvacOutlined);
var _hvacRounded = require("./HvacRounded");
var _hvacRoundedDefault = parcelHelpers.interopDefault(_hvacRounded);
var _hvacSharp = require("./HvacSharp");
var _hvacSharpDefault = parcelHelpers.interopDefault(_hvacSharp);
var _hvacTwoTone = require("./HvacTwoTone");
var _hvacTwoToneDefault = parcelHelpers.interopDefault(_hvacTwoTone);
var _iceSkating = require("./IceSkating");
var _iceSkatingDefault = parcelHelpers.interopDefault(_iceSkating);
var _iceSkatingOutlined = require("./IceSkatingOutlined");
var _iceSkatingOutlinedDefault = parcelHelpers.interopDefault(_iceSkatingOutlined);
var _iceSkatingRounded = require("./IceSkatingRounded");
var _iceSkatingRoundedDefault = parcelHelpers.interopDefault(_iceSkatingRounded);
var _iceSkatingSharp = require("./IceSkatingSharp");
var _iceSkatingSharpDefault = parcelHelpers.interopDefault(_iceSkatingSharp);
var _iceSkatingTwoTone = require("./IceSkatingTwoTone");
var _iceSkatingTwoToneDefault = parcelHelpers.interopDefault(_iceSkatingTwoTone);
var _icecream = require("./Icecream");
var _icecreamDefault = parcelHelpers.interopDefault(_icecream);
var _icecreamOutlined = require("./IcecreamOutlined");
var _icecreamOutlinedDefault = parcelHelpers.interopDefault(_icecreamOutlined);
var _icecreamRounded = require("./IcecreamRounded");
var _icecreamRoundedDefault = parcelHelpers.interopDefault(_icecreamRounded);
var _icecreamSharp = require("./IcecreamSharp");
var _icecreamSharpDefault = parcelHelpers.interopDefault(_icecreamSharp);
var _icecreamTwoTone = require("./IcecreamTwoTone");
var _icecreamTwoToneDefault = parcelHelpers.interopDefault(_icecreamTwoTone);
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _imageAspectRatio = require("./ImageAspectRatio");
var _imageAspectRatioDefault = parcelHelpers.interopDefault(_imageAspectRatio);
var _imageAspectRatioOutlined = require("./ImageAspectRatioOutlined");
var _imageAspectRatioOutlinedDefault = parcelHelpers.interopDefault(_imageAspectRatioOutlined);
var _imageAspectRatioRounded = require("./ImageAspectRatioRounded");
var _imageAspectRatioRoundedDefault = parcelHelpers.interopDefault(_imageAspectRatioRounded);
var _imageAspectRatioSharp = require("./ImageAspectRatioSharp");
var _imageAspectRatioSharpDefault = parcelHelpers.interopDefault(_imageAspectRatioSharp);
var _imageAspectRatioTwoTone = require("./ImageAspectRatioTwoTone");
var _imageAspectRatioTwoToneDefault = parcelHelpers.interopDefault(_imageAspectRatioTwoTone);
var _imageNotSupported = require("./ImageNotSupported");
var _imageNotSupportedDefault = parcelHelpers.interopDefault(_imageNotSupported);
var _imageNotSupportedOutlined = require("./ImageNotSupportedOutlined");
var _imageNotSupportedOutlinedDefault = parcelHelpers.interopDefault(_imageNotSupportedOutlined);
var _imageNotSupportedRounded = require("./ImageNotSupportedRounded");
var _imageNotSupportedRoundedDefault = parcelHelpers.interopDefault(_imageNotSupportedRounded);
var _imageNotSupportedSharp = require("./ImageNotSupportedSharp");
var _imageNotSupportedSharpDefault = parcelHelpers.interopDefault(_imageNotSupportedSharp);
var _imageNotSupportedTwoTone = require("./ImageNotSupportedTwoTone");
var _imageNotSupportedTwoToneDefault = parcelHelpers.interopDefault(_imageNotSupportedTwoTone);
var _imageOutlined = require("./ImageOutlined");
var _imageOutlinedDefault = parcelHelpers.interopDefault(_imageOutlined);
var _imageRounded = require("./ImageRounded");
var _imageRoundedDefault = parcelHelpers.interopDefault(_imageRounded);
var _imageSearch = require("./ImageSearch");
var _imageSearchDefault = parcelHelpers.interopDefault(_imageSearch);
var _imageSearchOutlined = require("./ImageSearchOutlined");
var _imageSearchOutlinedDefault = parcelHelpers.interopDefault(_imageSearchOutlined);
var _imageSearchRounded = require("./ImageSearchRounded");
var _imageSearchRoundedDefault = parcelHelpers.interopDefault(_imageSearchRounded);
var _imageSearchSharp = require("./ImageSearchSharp");
var _imageSearchSharpDefault = parcelHelpers.interopDefault(_imageSearchSharp);
var _imageSearchTwoTone = require("./ImageSearchTwoTone");
var _imageSearchTwoToneDefault = parcelHelpers.interopDefault(_imageSearchTwoTone);
var _imageSharp = require("./ImageSharp");
var _imageSharpDefault = parcelHelpers.interopDefault(_imageSharp);
var _imageTwoTone = require("./ImageTwoTone");
var _imageTwoToneDefault = parcelHelpers.interopDefault(_imageTwoTone);
var _imagesearchRoller = require("./ImagesearchRoller");
var _imagesearchRollerDefault = parcelHelpers.interopDefault(_imagesearchRoller);
var _imagesearchRollerOutlined = require("./ImagesearchRollerOutlined");
var _imagesearchRollerOutlinedDefault = parcelHelpers.interopDefault(_imagesearchRollerOutlined);
var _imagesearchRollerRounded = require("./ImagesearchRollerRounded");
var _imagesearchRollerRoundedDefault = parcelHelpers.interopDefault(_imagesearchRollerRounded);
var _imagesearchRollerSharp = require("./ImagesearchRollerSharp");
var _imagesearchRollerSharpDefault = parcelHelpers.interopDefault(_imagesearchRollerSharp);
var _imagesearchRollerTwoTone = require("./ImagesearchRollerTwoTone");
var _imagesearchRollerTwoToneDefault = parcelHelpers.interopDefault(_imagesearchRollerTwoTone);
var _importContacts = require("./ImportContacts");
var _importContactsDefault = parcelHelpers.interopDefault(_importContacts);
var _importContactsOutlined = require("./ImportContactsOutlined");
var _importContactsOutlinedDefault = parcelHelpers.interopDefault(_importContactsOutlined);
var _importContactsRounded = require("./ImportContactsRounded");
var _importContactsRoundedDefault = parcelHelpers.interopDefault(_importContactsRounded);
var _importContactsSharp = require("./ImportContactsSharp");
var _importContactsSharpDefault = parcelHelpers.interopDefault(_importContactsSharp);
var _importContactsTwoTone = require("./ImportContactsTwoTone");
var _importContactsTwoToneDefault = parcelHelpers.interopDefault(_importContactsTwoTone);
var _importExport = require("./ImportExport");
var _importExportDefault = parcelHelpers.interopDefault(_importExport);
var _importExportOutlined = require("./ImportExportOutlined");
var _importExportOutlinedDefault = parcelHelpers.interopDefault(_importExportOutlined);
var _importExportRounded = require("./ImportExportRounded");
var _importExportRoundedDefault = parcelHelpers.interopDefault(_importExportRounded);
var _importExportSharp = require("./ImportExportSharp");
var _importExportSharpDefault = parcelHelpers.interopDefault(_importExportSharp);
var _importExportTwoTone = require("./ImportExportTwoTone");
var _importExportTwoToneDefault = parcelHelpers.interopDefault(_importExportTwoTone);
var _importantDevices = require("./ImportantDevices");
var _importantDevicesDefault = parcelHelpers.interopDefault(_importantDevices);
var _importantDevicesOutlined = require("./ImportantDevicesOutlined");
var _importantDevicesOutlinedDefault = parcelHelpers.interopDefault(_importantDevicesOutlined);
var _importantDevicesRounded = require("./ImportantDevicesRounded");
var _importantDevicesRoundedDefault = parcelHelpers.interopDefault(_importantDevicesRounded);
var _importantDevicesSharp = require("./ImportantDevicesSharp");
var _importantDevicesSharpDefault = parcelHelpers.interopDefault(_importantDevicesSharp);
var _importantDevicesTwoTone = require("./ImportantDevicesTwoTone");
var _importantDevicesTwoToneDefault = parcelHelpers.interopDefault(_importantDevicesTwoTone);
var _inbox = require("./Inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _inboxOutlined = require("./InboxOutlined");
var _inboxOutlinedDefault = parcelHelpers.interopDefault(_inboxOutlined);
var _inboxRounded = require("./InboxRounded");
var _inboxRoundedDefault = parcelHelpers.interopDefault(_inboxRounded);
var _inboxSharp = require("./InboxSharp");
var _inboxSharpDefault = parcelHelpers.interopDefault(_inboxSharp);
var _inboxTwoTone = require("./InboxTwoTone");
var _inboxTwoToneDefault = parcelHelpers.interopDefault(_inboxTwoTone);
var _indeterminateCheckBox = require("./IndeterminateCheckBox");
var _indeterminateCheckBoxDefault = parcelHelpers.interopDefault(_indeterminateCheckBox);
var _indeterminateCheckBoxOutlined = require("./IndeterminateCheckBoxOutlined");
var _indeterminateCheckBoxOutlinedDefault = parcelHelpers.interopDefault(_indeterminateCheckBoxOutlined);
var _indeterminateCheckBoxRounded = require("./IndeterminateCheckBoxRounded");
var _indeterminateCheckBoxRoundedDefault = parcelHelpers.interopDefault(_indeterminateCheckBoxRounded);
var _indeterminateCheckBoxSharp = require("./IndeterminateCheckBoxSharp");
var _indeterminateCheckBoxSharpDefault = parcelHelpers.interopDefault(_indeterminateCheckBoxSharp);
var _indeterminateCheckBoxTwoTone = require("./IndeterminateCheckBoxTwoTone");
var _indeterminateCheckBoxTwoToneDefault = parcelHelpers.interopDefault(_indeterminateCheckBoxTwoTone);
var _info = require("./Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _infoOutlined = require("./InfoOutlined");
var _infoOutlinedDefault = parcelHelpers.interopDefault(_infoOutlined);
var _infoRounded = require("./InfoRounded");
var _infoRoundedDefault = parcelHelpers.interopDefault(_infoRounded);
var _infoSharp = require("./InfoSharp");
var _infoSharpDefault = parcelHelpers.interopDefault(_infoSharp);
var _infoTwoTone = require("./InfoTwoTone");
var _infoTwoToneDefault = parcelHelpers.interopDefault(_infoTwoTone);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputOutlined = require("./InputOutlined");
var _inputOutlinedDefault = parcelHelpers.interopDefault(_inputOutlined);
var _inputRounded = require("./InputRounded");
var _inputRoundedDefault = parcelHelpers.interopDefault(_inputRounded);
var _inputSharp = require("./InputSharp");
var _inputSharpDefault = parcelHelpers.interopDefault(_inputSharp);
var _inputTwoTone = require("./InputTwoTone");
var _inputTwoToneDefault = parcelHelpers.interopDefault(_inputTwoTone);
var _insertChart = require("./InsertChart");
var _insertChartDefault = parcelHelpers.interopDefault(_insertChart);
var _insertChartOutlined = require("./InsertChartOutlined");
var _insertChartOutlinedDefault = parcelHelpers.interopDefault(_insertChartOutlined);
var _insertChartOutlinedOutlined = require("./InsertChartOutlinedOutlined");
var _insertChartOutlinedOutlinedDefault = parcelHelpers.interopDefault(_insertChartOutlinedOutlined);
var _insertChartOutlinedRounded = require("./InsertChartOutlinedRounded");
var _insertChartOutlinedRoundedDefault = parcelHelpers.interopDefault(_insertChartOutlinedRounded);
var _insertChartOutlinedSharp = require("./InsertChartOutlinedSharp");
var _insertChartOutlinedSharpDefault = parcelHelpers.interopDefault(_insertChartOutlinedSharp);
var _insertChartOutlinedTwoTone = require("./InsertChartOutlinedTwoTone");
var _insertChartOutlinedTwoToneDefault = parcelHelpers.interopDefault(_insertChartOutlinedTwoTone);
var _insertChartRounded = require("./InsertChartRounded");
var _insertChartRoundedDefault = parcelHelpers.interopDefault(_insertChartRounded);
var _insertChartSharp = require("./InsertChartSharp");
var _insertChartSharpDefault = parcelHelpers.interopDefault(_insertChartSharp);
var _insertChartTwoTone = require("./InsertChartTwoTone");
var _insertChartTwoToneDefault = parcelHelpers.interopDefault(_insertChartTwoTone);
var _insertComment = require("./InsertComment");
var _insertCommentDefault = parcelHelpers.interopDefault(_insertComment);
var _insertCommentOutlined = require("./InsertCommentOutlined");
var _insertCommentOutlinedDefault = parcelHelpers.interopDefault(_insertCommentOutlined);
var _insertCommentRounded = require("./InsertCommentRounded");
var _insertCommentRoundedDefault = parcelHelpers.interopDefault(_insertCommentRounded);
var _insertCommentSharp = require("./InsertCommentSharp");
var _insertCommentSharpDefault = parcelHelpers.interopDefault(_insertCommentSharp);
var _insertCommentTwoTone = require("./InsertCommentTwoTone");
var _insertCommentTwoToneDefault = parcelHelpers.interopDefault(_insertCommentTwoTone);
var _insertDriveFile = require("./InsertDriveFile");
var _insertDriveFileDefault = parcelHelpers.interopDefault(_insertDriveFile);
var _insertDriveFileOutlined = require("./InsertDriveFileOutlined");
var _insertDriveFileOutlinedDefault = parcelHelpers.interopDefault(_insertDriveFileOutlined);
var _insertDriveFileRounded = require("./InsertDriveFileRounded");
var _insertDriveFileRoundedDefault = parcelHelpers.interopDefault(_insertDriveFileRounded);
var _insertDriveFileSharp = require("./InsertDriveFileSharp");
var _insertDriveFileSharpDefault = parcelHelpers.interopDefault(_insertDriveFileSharp);
var _insertDriveFileTwoTone = require("./InsertDriveFileTwoTone");
var _insertDriveFileTwoToneDefault = parcelHelpers.interopDefault(_insertDriveFileTwoTone);
var _insertEmoticon = require("./InsertEmoticon");
var _insertEmoticonDefault = parcelHelpers.interopDefault(_insertEmoticon);
var _insertEmoticonOutlined = require("./InsertEmoticonOutlined");
var _insertEmoticonOutlinedDefault = parcelHelpers.interopDefault(_insertEmoticonOutlined);
var _insertEmoticonRounded = require("./InsertEmoticonRounded");
var _insertEmoticonRoundedDefault = parcelHelpers.interopDefault(_insertEmoticonRounded);
var _insertEmoticonSharp = require("./InsertEmoticonSharp");
var _insertEmoticonSharpDefault = parcelHelpers.interopDefault(_insertEmoticonSharp);
var _insertEmoticonTwoTone = require("./InsertEmoticonTwoTone");
var _insertEmoticonTwoToneDefault = parcelHelpers.interopDefault(_insertEmoticonTwoTone);
var _insertInvitation = require("./InsertInvitation");
var _insertInvitationDefault = parcelHelpers.interopDefault(_insertInvitation);
var _insertInvitationOutlined = require("./InsertInvitationOutlined");
var _insertInvitationOutlinedDefault = parcelHelpers.interopDefault(_insertInvitationOutlined);
var _insertInvitationRounded = require("./InsertInvitationRounded");
var _insertInvitationRoundedDefault = parcelHelpers.interopDefault(_insertInvitationRounded);
var _insertInvitationSharp = require("./InsertInvitationSharp");
var _insertInvitationSharpDefault = parcelHelpers.interopDefault(_insertInvitationSharp);
var _insertInvitationTwoTone = require("./InsertInvitationTwoTone");
var _insertInvitationTwoToneDefault = parcelHelpers.interopDefault(_insertInvitationTwoTone);
var _insertLink = require("./InsertLink");
var _insertLinkDefault = parcelHelpers.interopDefault(_insertLink);
var _insertLinkOutlined = require("./InsertLinkOutlined");
var _insertLinkOutlinedDefault = parcelHelpers.interopDefault(_insertLinkOutlined);
var _insertLinkRounded = require("./InsertLinkRounded");
var _insertLinkRoundedDefault = parcelHelpers.interopDefault(_insertLinkRounded);
var _insertLinkSharp = require("./InsertLinkSharp");
var _insertLinkSharpDefault = parcelHelpers.interopDefault(_insertLinkSharp);
var _insertLinkTwoTone = require("./InsertLinkTwoTone");
var _insertLinkTwoToneDefault = parcelHelpers.interopDefault(_insertLinkTwoTone);
var _insertPageBreak = require("./InsertPageBreak");
var _insertPageBreakDefault = parcelHelpers.interopDefault(_insertPageBreak);
var _insertPageBreakOutlined = require("./InsertPageBreakOutlined");
var _insertPageBreakOutlinedDefault = parcelHelpers.interopDefault(_insertPageBreakOutlined);
var _insertPageBreakRounded = require("./InsertPageBreakRounded");
var _insertPageBreakRoundedDefault = parcelHelpers.interopDefault(_insertPageBreakRounded);
var _insertPageBreakSharp = require("./InsertPageBreakSharp");
var _insertPageBreakSharpDefault = parcelHelpers.interopDefault(_insertPageBreakSharp);
var _insertPageBreakTwoTone = require("./InsertPageBreakTwoTone");
var _insertPageBreakTwoToneDefault = parcelHelpers.interopDefault(_insertPageBreakTwoTone);
var _insertPhoto = require("./InsertPhoto");
var _insertPhotoDefault = parcelHelpers.interopDefault(_insertPhoto);
var _insertPhotoOutlined = require("./InsertPhotoOutlined");
var _insertPhotoOutlinedDefault = parcelHelpers.interopDefault(_insertPhotoOutlined);
var _insertPhotoRounded = require("./InsertPhotoRounded");
var _insertPhotoRoundedDefault = parcelHelpers.interopDefault(_insertPhotoRounded);
var _insertPhotoSharp = require("./InsertPhotoSharp");
var _insertPhotoSharpDefault = parcelHelpers.interopDefault(_insertPhotoSharp);
var _insertPhotoTwoTone = require("./InsertPhotoTwoTone");
var _insertPhotoTwoToneDefault = parcelHelpers.interopDefault(_insertPhotoTwoTone);
var _insights = require("./Insights");
var _insightsDefault = parcelHelpers.interopDefault(_insights);
var _insightsOutlined = require("./InsightsOutlined");
var _insightsOutlinedDefault = parcelHelpers.interopDefault(_insightsOutlined);
var _insightsRounded = require("./InsightsRounded");
var _insightsRoundedDefault = parcelHelpers.interopDefault(_insightsRounded);
var _insightsSharp = require("./InsightsSharp");
var _insightsSharpDefault = parcelHelpers.interopDefault(_insightsSharp);
var _insightsTwoTone = require("./InsightsTwoTone");
var _insightsTwoToneDefault = parcelHelpers.interopDefault(_insightsTwoTone);
var _instagram = require("./Instagram");
var _instagramDefault = parcelHelpers.interopDefault(_instagram);
var _installDesktop = require("./InstallDesktop");
var _installDesktopDefault = parcelHelpers.interopDefault(_installDesktop);
var _installDesktopOutlined = require("./InstallDesktopOutlined");
var _installDesktopOutlinedDefault = parcelHelpers.interopDefault(_installDesktopOutlined);
var _installDesktopRounded = require("./InstallDesktopRounded");
var _installDesktopRoundedDefault = parcelHelpers.interopDefault(_installDesktopRounded);
var _installDesktopSharp = require("./InstallDesktopSharp");
var _installDesktopSharpDefault = parcelHelpers.interopDefault(_installDesktopSharp);
var _installDesktopTwoTone = require("./InstallDesktopTwoTone");
var _installDesktopTwoToneDefault = parcelHelpers.interopDefault(_installDesktopTwoTone);
var _installMobile = require("./InstallMobile");
var _installMobileDefault = parcelHelpers.interopDefault(_installMobile);
var _installMobileOutlined = require("./InstallMobileOutlined");
var _installMobileOutlinedDefault = parcelHelpers.interopDefault(_installMobileOutlined);
var _installMobileRounded = require("./InstallMobileRounded");
var _installMobileRoundedDefault = parcelHelpers.interopDefault(_installMobileRounded);
var _installMobileSharp = require("./InstallMobileSharp");
var _installMobileSharpDefault = parcelHelpers.interopDefault(_installMobileSharp);
var _installMobileTwoTone = require("./InstallMobileTwoTone");
var _installMobileTwoToneDefault = parcelHelpers.interopDefault(_installMobileTwoTone);
var _integrationInstructions = require("./IntegrationInstructions");
var _integrationInstructionsDefault = parcelHelpers.interopDefault(_integrationInstructions);
var _integrationInstructionsOutlined = require("./IntegrationInstructionsOutlined");
var _integrationInstructionsOutlinedDefault = parcelHelpers.interopDefault(_integrationInstructionsOutlined);
var _integrationInstructionsRounded = require("./IntegrationInstructionsRounded");
var _integrationInstructionsRoundedDefault = parcelHelpers.interopDefault(_integrationInstructionsRounded);
var _integrationInstructionsSharp = require("./IntegrationInstructionsSharp");
var _integrationInstructionsSharpDefault = parcelHelpers.interopDefault(_integrationInstructionsSharp);
var _integrationInstructionsTwoTone = require("./IntegrationInstructionsTwoTone");
var _integrationInstructionsTwoToneDefault = parcelHelpers.interopDefault(_integrationInstructionsTwoTone);
var _interests = require("./Interests");
var _interestsDefault = parcelHelpers.interopDefault(_interests);
var _interestsOutlined = require("./InterestsOutlined");
var _interestsOutlinedDefault = parcelHelpers.interopDefault(_interestsOutlined);
var _interestsRounded = require("./InterestsRounded");
var _interestsRoundedDefault = parcelHelpers.interopDefault(_interestsRounded);
var _interestsSharp = require("./InterestsSharp");
var _interestsSharpDefault = parcelHelpers.interopDefault(_interestsSharp);
var _interestsTwoTone = require("./InterestsTwoTone");
var _interestsTwoToneDefault = parcelHelpers.interopDefault(_interestsTwoTone);
var _interpreterMode = require("./InterpreterMode");
var _interpreterModeDefault = parcelHelpers.interopDefault(_interpreterMode);
var _interpreterModeOutlined = require("./InterpreterModeOutlined");
var _interpreterModeOutlinedDefault = parcelHelpers.interopDefault(_interpreterModeOutlined);
var _interpreterModeRounded = require("./InterpreterModeRounded");
var _interpreterModeRoundedDefault = parcelHelpers.interopDefault(_interpreterModeRounded);
var _interpreterModeSharp = require("./InterpreterModeSharp");
var _interpreterModeSharpDefault = parcelHelpers.interopDefault(_interpreterModeSharp);
var _interpreterModeTwoTone = require("./InterpreterModeTwoTone");
var _interpreterModeTwoToneDefault = parcelHelpers.interopDefault(_interpreterModeTwoTone);
var _inventory = require("./Inventory");
var _inventoryDefault = parcelHelpers.interopDefault(_inventory);
var _inventory2 = require("./Inventory2");
var _inventory2Default = parcelHelpers.interopDefault(_inventory2);
var _inventory2Outlined = require("./Inventory2Outlined");
var _inventory2OutlinedDefault = parcelHelpers.interopDefault(_inventory2Outlined);
var _inventory2Rounded = require("./Inventory2Rounded");
var _inventory2RoundedDefault = parcelHelpers.interopDefault(_inventory2Rounded);
var _inventory2Sharp = require("./Inventory2Sharp");
var _inventory2SharpDefault = parcelHelpers.interopDefault(_inventory2Sharp);
var _inventory2TwoTone = require("./Inventory2TwoTone");
var _inventory2TwoToneDefault = parcelHelpers.interopDefault(_inventory2TwoTone);
var _inventoryOutlined = require("./InventoryOutlined");
var _inventoryOutlinedDefault = parcelHelpers.interopDefault(_inventoryOutlined);
var _inventoryRounded = require("./InventoryRounded");
var _inventoryRoundedDefault = parcelHelpers.interopDefault(_inventoryRounded);
var _inventorySharp = require("./InventorySharp");
var _inventorySharpDefault = parcelHelpers.interopDefault(_inventorySharp);
var _inventoryTwoTone = require("./InventoryTwoTone");
var _inventoryTwoToneDefault = parcelHelpers.interopDefault(_inventoryTwoTone);
var _invertColors = require("./InvertColors");
var _invertColorsDefault = parcelHelpers.interopDefault(_invertColors);
var _invertColorsOff = require("./InvertColorsOff");
var _invertColorsOffDefault = parcelHelpers.interopDefault(_invertColorsOff);
var _invertColorsOffOutlined = require("./InvertColorsOffOutlined");
var _invertColorsOffOutlinedDefault = parcelHelpers.interopDefault(_invertColorsOffOutlined);
var _invertColorsOffRounded = require("./InvertColorsOffRounded");
var _invertColorsOffRoundedDefault = parcelHelpers.interopDefault(_invertColorsOffRounded);
var _invertColorsOffSharp = require("./InvertColorsOffSharp");
var _invertColorsOffSharpDefault = parcelHelpers.interopDefault(_invertColorsOffSharp);
var _invertColorsOffTwoTone = require("./InvertColorsOffTwoTone");
var _invertColorsOffTwoToneDefault = parcelHelpers.interopDefault(_invertColorsOffTwoTone);
var _invertColorsOutlined = require("./InvertColorsOutlined");
var _invertColorsOutlinedDefault = parcelHelpers.interopDefault(_invertColorsOutlined);
var _invertColorsRounded = require("./InvertColorsRounded");
var _invertColorsRoundedDefault = parcelHelpers.interopDefault(_invertColorsRounded);
var _invertColorsSharp = require("./InvertColorsSharp");
var _invertColorsSharpDefault = parcelHelpers.interopDefault(_invertColorsSharp);
var _invertColorsTwoTone = require("./InvertColorsTwoTone");
var _invertColorsTwoToneDefault = parcelHelpers.interopDefault(_invertColorsTwoTone);
var _iosShare = require("./IosShare");
var _iosShareDefault = parcelHelpers.interopDefault(_iosShare);
var _iosShareOutlined = require("./IosShareOutlined");
var _iosShareOutlinedDefault = parcelHelpers.interopDefault(_iosShareOutlined);
var _iosShareRounded = require("./IosShareRounded");
var _iosShareRoundedDefault = parcelHelpers.interopDefault(_iosShareRounded);
var _iosShareSharp = require("./IosShareSharp");
var _iosShareSharpDefault = parcelHelpers.interopDefault(_iosShareSharp);
var _iosShareTwoTone = require("./IosShareTwoTone");
var _iosShareTwoToneDefault = parcelHelpers.interopDefault(_iosShareTwoTone);
var _iron = require("./Iron");
var _ironDefault = parcelHelpers.interopDefault(_iron);
var _ironOutlined = require("./IronOutlined");
var _ironOutlinedDefault = parcelHelpers.interopDefault(_ironOutlined);
var _ironRounded = require("./IronRounded");
var _ironRoundedDefault = parcelHelpers.interopDefault(_ironRounded);
var _ironSharp = require("./IronSharp");
var _ironSharpDefault = parcelHelpers.interopDefault(_ironSharp);
var _ironTwoTone = require("./IronTwoTone");
var _ironTwoToneDefault = parcelHelpers.interopDefault(_ironTwoTone);
var _iso = require("./Iso");
var _isoDefault = parcelHelpers.interopDefault(_iso);
var _isoOutlined = require("./IsoOutlined");
var _isoOutlinedDefault = parcelHelpers.interopDefault(_isoOutlined);
var _isoRounded = require("./IsoRounded");
var _isoRoundedDefault = parcelHelpers.interopDefault(_isoRounded);
var _isoSharp = require("./IsoSharp");
var _isoSharpDefault = parcelHelpers.interopDefault(_isoSharp);
var _isoTwoTone = require("./IsoTwoTone");
var _isoTwoToneDefault = parcelHelpers.interopDefault(_isoTwoTone);
var _javascript = require("./Javascript");
var _javascriptDefault = parcelHelpers.interopDefault(_javascript);
var _javascriptOutlined = require("./JavascriptOutlined");
var _javascriptOutlinedDefault = parcelHelpers.interopDefault(_javascriptOutlined);
var _javascriptRounded = require("./JavascriptRounded");
var _javascriptRoundedDefault = parcelHelpers.interopDefault(_javascriptRounded);
var _javascriptSharp = require("./JavascriptSharp");
var _javascriptSharpDefault = parcelHelpers.interopDefault(_javascriptSharp);
var _javascriptTwoTone = require("./JavascriptTwoTone");
var _javascriptTwoToneDefault = parcelHelpers.interopDefault(_javascriptTwoTone);
var _joinFull = require("./JoinFull");
var _joinFullDefault = parcelHelpers.interopDefault(_joinFull);
var _joinFullOutlined = require("./JoinFullOutlined");
var _joinFullOutlinedDefault = parcelHelpers.interopDefault(_joinFullOutlined);
var _joinFullRounded = require("./JoinFullRounded");
var _joinFullRoundedDefault = parcelHelpers.interopDefault(_joinFullRounded);
var _joinFullSharp = require("./JoinFullSharp");
var _joinFullSharpDefault = parcelHelpers.interopDefault(_joinFullSharp);
var _joinFullTwoTone = require("./JoinFullTwoTone");
var _joinFullTwoToneDefault = parcelHelpers.interopDefault(_joinFullTwoTone);
var _joinInner = require("./JoinInner");
var _joinInnerDefault = parcelHelpers.interopDefault(_joinInner);
var _joinInnerOutlined = require("./JoinInnerOutlined");
var _joinInnerOutlinedDefault = parcelHelpers.interopDefault(_joinInnerOutlined);
var _joinInnerRounded = require("./JoinInnerRounded");
var _joinInnerRoundedDefault = parcelHelpers.interopDefault(_joinInnerRounded);
var _joinInnerSharp = require("./JoinInnerSharp");
var _joinInnerSharpDefault = parcelHelpers.interopDefault(_joinInnerSharp);
var _joinInnerTwoTone = require("./JoinInnerTwoTone");
var _joinInnerTwoToneDefault = parcelHelpers.interopDefault(_joinInnerTwoTone);
var _joinLeft = require("./JoinLeft");
var _joinLeftDefault = parcelHelpers.interopDefault(_joinLeft);
var _joinLeftOutlined = require("./JoinLeftOutlined");
var _joinLeftOutlinedDefault = parcelHelpers.interopDefault(_joinLeftOutlined);
var _joinLeftRounded = require("./JoinLeftRounded");
var _joinLeftRoundedDefault = parcelHelpers.interopDefault(_joinLeftRounded);
var _joinLeftSharp = require("./JoinLeftSharp");
var _joinLeftSharpDefault = parcelHelpers.interopDefault(_joinLeftSharp);
var _joinLeftTwoTone = require("./JoinLeftTwoTone");
var _joinLeftTwoToneDefault = parcelHelpers.interopDefault(_joinLeftTwoTone);
var _joinRight = require("./JoinRight");
var _joinRightDefault = parcelHelpers.interopDefault(_joinRight);
var _joinRightOutlined = require("./JoinRightOutlined");
var _joinRightOutlinedDefault = parcelHelpers.interopDefault(_joinRightOutlined);
var _joinRightRounded = require("./JoinRightRounded");
var _joinRightRoundedDefault = parcelHelpers.interopDefault(_joinRightRounded);
var _joinRightSharp = require("./JoinRightSharp");
var _joinRightSharpDefault = parcelHelpers.interopDefault(_joinRightSharp);
var _joinRightTwoTone = require("./JoinRightTwoTone");
var _joinRightTwoToneDefault = parcelHelpers.interopDefault(_joinRightTwoTone);
var _kayaking = require("./Kayaking");
var _kayakingDefault = parcelHelpers.interopDefault(_kayaking);
var _kayakingOutlined = require("./KayakingOutlined");
var _kayakingOutlinedDefault = parcelHelpers.interopDefault(_kayakingOutlined);
var _kayakingRounded = require("./KayakingRounded");
var _kayakingRoundedDefault = parcelHelpers.interopDefault(_kayakingRounded);
var _kayakingSharp = require("./KayakingSharp");
var _kayakingSharpDefault = parcelHelpers.interopDefault(_kayakingSharp);
var _kayakingTwoTone = require("./KayakingTwoTone");
var _kayakingTwoToneDefault = parcelHelpers.interopDefault(_kayakingTwoTone);
var _kebabDining = require("./KebabDining");
var _kebabDiningDefault = parcelHelpers.interopDefault(_kebabDining);
var _kebabDiningOutlined = require("./KebabDiningOutlined");
var _kebabDiningOutlinedDefault = parcelHelpers.interopDefault(_kebabDiningOutlined);
var _kebabDiningRounded = require("./KebabDiningRounded");
var _kebabDiningRoundedDefault = parcelHelpers.interopDefault(_kebabDiningRounded);
var _kebabDiningSharp = require("./KebabDiningSharp");
var _kebabDiningSharpDefault = parcelHelpers.interopDefault(_kebabDiningSharp);
var _kebabDiningTwoTone = require("./KebabDiningTwoTone");
var _kebabDiningTwoToneDefault = parcelHelpers.interopDefault(_kebabDiningTwoTone);
var _key = require("./Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _keyOff = require("./KeyOff");
var _keyOffDefault = parcelHelpers.interopDefault(_keyOff);
var _keyOffOutlined = require("./KeyOffOutlined");
var _keyOffOutlinedDefault = parcelHelpers.interopDefault(_keyOffOutlined);
var _keyOffRounded = require("./KeyOffRounded");
var _keyOffRoundedDefault = parcelHelpers.interopDefault(_keyOffRounded);
var _keyOffSharp = require("./KeyOffSharp");
var _keyOffSharpDefault = parcelHelpers.interopDefault(_keyOffSharp);
var _keyOffTwoTone = require("./KeyOffTwoTone");
var _keyOffTwoToneDefault = parcelHelpers.interopDefault(_keyOffTwoTone);
var _keyOutlined = require("./KeyOutlined");
var _keyOutlinedDefault = parcelHelpers.interopDefault(_keyOutlined);
var _keyRounded = require("./KeyRounded");
var _keyRoundedDefault = parcelHelpers.interopDefault(_keyRounded);
var _keySharp = require("./KeySharp");
var _keySharpDefault = parcelHelpers.interopDefault(_keySharp);
var _keyTwoTone = require("./KeyTwoTone");
var _keyTwoToneDefault = parcelHelpers.interopDefault(_keyTwoTone);
var _keyboard = require("./Keyboard");
var _keyboardDefault = parcelHelpers.interopDefault(_keyboard);
var _keyboardAlt = require("./KeyboardAlt");
var _keyboardAltDefault = parcelHelpers.interopDefault(_keyboardAlt);
var _keyboardAltOutlined = require("./KeyboardAltOutlined");
var _keyboardAltOutlinedDefault = parcelHelpers.interopDefault(_keyboardAltOutlined);
var _keyboardAltRounded = require("./KeyboardAltRounded");
var _keyboardAltRoundedDefault = parcelHelpers.interopDefault(_keyboardAltRounded);
var _keyboardAltSharp = require("./KeyboardAltSharp");
var _keyboardAltSharpDefault = parcelHelpers.interopDefault(_keyboardAltSharp);
var _keyboardAltTwoTone = require("./KeyboardAltTwoTone");
var _keyboardAltTwoToneDefault = parcelHelpers.interopDefault(_keyboardAltTwoTone);
var _keyboardArrowDown = require("./KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _keyboardArrowDownOutlined = require("./KeyboardArrowDownOutlined");
var _keyboardArrowDownOutlinedDefault = parcelHelpers.interopDefault(_keyboardArrowDownOutlined);
var _keyboardArrowDownRounded = require("./KeyboardArrowDownRounded");
var _keyboardArrowDownRoundedDefault = parcelHelpers.interopDefault(_keyboardArrowDownRounded);
var _keyboardArrowDownSharp = require("./KeyboardArrowDownSharp");
var _keyboardArrowDownSharpDefault = parcelHelpers.interopDefault(_keyboardArrowDownSharp);
var _keyboardArrowDownTwoTone = require("./KeyboardArrowDownTwoTone");
var _keyboardArrowDownTwoToneDefault = parcelHelpers.interopDefault(_keyboardArrowDownTwoTone);
var _keyboardArrowLeft = require("./KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _keyboardArrowLeftOutlined = require("./KeyboardArrowLeftOutlined");
var _keyboardArrowLeftOutlinedDefault = parcelHelpers.interopDefault(_keyboardArrowLeftOutlined);
var _keyboardArrowLeftRounded = require("./KeyboardArrowLeftRounded");
var _keyboardArrowLeftRoundedDefault = parcelHelpers.interopDefault(_keyboardArrowLeftRounded);
var _keyboardArrowLeftSharp = require("./KeyboardArrowLeftSharp");
var _keyboardArrowLeftSharpDefault = parcelHelpers.interopDefault(_keyboardArrowLeftSharp);
var _keyboardArrowLeftTwoTone = require("./KeyboardArrowLeftTwoTone");
var _keyboardArrowLeftTwoToneDefault = parcelHelpers.interopDefault(_keyboardArrowLeftTwoTone);
var _keyboardArrowRight = require("./KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _keyboardArrowRightOutlined = require("./KeyboardArrowRightOutlined");
var _keyboardArrowRightOutlinedDefault = parcelHelpers.interopDefault(_keyboardArrowRightOutlined);
var _keyboardArrowRightRounded = require("./KeyboardArrowRightRounded");
var _keyboardArrowRightRoundedDefault = parcelHelpers.interopDefault(_keyboardArrowRightRounded);
var _keyboardArrowRightSharp = require("./KeyboardArrowRightSharp");
var _keyboardArrowRightSharpDefault = parcelHelpers.interopDefault(_keyboardArrowRightSharp);
var _keyboardArrowRightTwoTone = require("./KeyboardArrowRightTwoTone");
var _keyboardArrowRightTwoToneDefault = parcelHelpers.interopDefault(_keyboardArrowRightTwoTone);
var _keyboardArrowUp = require("./KeyboardArrowUp");
var _keyboardArrowUpDefault = parcelHelpers.interopDefault(_keyboardArrowUp);
var _keyboardArrowUpOutlined = require("./KeyboardArrowUpOutlined");
var _keyboardArrowUpOutlinedDefault = parcelHelpers.interopDefault(_keyboardArrowUpOutlined);
var _keyboardArrowUpRounded = require("./KeyboardArrowUpRounded");
var _keyboardArrowUpRoundedDefault = parcelHelpers.interopDefault(_keyboardArrowUpRounded);
var _keyboardArrowUpSharp = require("./KeyboardArrowUpSharp");
var _keyboardArrowUpSharpDefault = parcelHelpers.interopDefault(_keyboardArrowUpSharp);
var _keyboardArrowUpTwoTone = require("./KeyboardArrowUpTwoTone");
var _keyboardArrowUpTwoToneDefault = parcelHelpers.interopDefault(_keyboardArrowUpTwoTone);
var _keyboardBackspace = require("./KeyboardBackspace");
var _keyboardBackspaceDefault = parcelHelpers.interopDefault(_keyboardBackspace);
var _keyboardBackspaceOutlined = require("./KeyboardBackspaceOutlined");
var _keyboardBackspaceOutlinedDefault = parcelHelpers.interopDefault(_keyboardBackspaceOutlined);
var _keyboardBackspaceRounded = require("./KeyboardBackspaceRounded");
var _keyboardBackspaceRoundedDefault = parcelHelpers.interopDefault(_keyboardBackspaceRounded);
var _keyboardBackspaceSharp = require("./KeyboardBackspaceSharp");
var _keyboardBackspaceSharpDefault = parcelHelpers.interopDefault(_keyboardBackspaceSharp);
var _keyboardBackspaceTwoTone = require("./KeyboardBackspaceTwoTone");
var _keyboardBackspaceTwoToneDefault = parcelHelpers.interopDefault(_keyboardBackspaceTwoTone);
var _keyboardCapslock = require("./KeyboardCapslock");
var _keyboardCapslockDefault = parcelHelpers.interopDefault(_keyboardCapslock);
var _keyboardCapslockOutlined = require("./KeyboardCapslockOutlined");
var _keyboardCapslockOutlinedDefault = parcelHelpers.interopDefault(_keyboardCapslockOutlined);
var _keyboardCapslockRounded = require("./KeyboardCapslockRounded");
var _keyboardCapslockRoundedDefault = parcelHelpers.interopDefault(_keyboardCapslockRounded);
var _keyboardCapslockSharp = require("./KeyboardCapslockSharp");
var _keyboardCapslockSharpDefault = parcelHelpers.interopDefault(_keyboardCapslockSharp);
var _keyboardCapslockTwoTone = require("./KeyboardCapslockTwoTone");
var _keyboardCapslockTwoToneDefault = parcelHelpers.interopDefault(_keyboardCapslockTwoTone);
var _keyboardCommandKey = require("./KeyboardCommandKey");
var _keyboardCommandKeyDefault = parcelHelpers.interopDefault(_keyboardCommandKey);
var _keyboardCommandKeyOutlined = require("./KeyboardCommandKeyOutlined");
var _keyboardCommandKeyOutlinedDefault = parcelHelpers.interopDefault(_keyboardCommandKeyOutlined);
var _keyboardCommandKeyRounded = require("./KeyboardCommandKeyRounded");
var _keyboardCommandKeyRoundedDefault = parcelHelpers.interopDefault(_keyboardCommandKeyRounded);
var _keyboardCommandKeySharp = require("./KeyboardCommandKeySharp");
var _keyboardCommandKeySharpDefault = parcelHelpers.interopDefault(_keyboardCommandKeySharp);
var _keyboardCommandKeyTwoTone = require("./KeyboardCommandKeyTwoTone");
var _keyboardCommandKeyTwoToneDefault = parcelHelpers.interopDefault(_keyboardCommandKeyTwoTone);
var _keyboardControlKey = require("./KeyboardControlKey");
var _keyboardControlKeyDefault = parcelHelpers.interopDefault(_keyboardControlKey);
var _keyboardControlKeyOutlined = require("./KeyboardControlKeyOutlined");
var _keyboardControlKeyOutlinedDefault = parcelHelpers.interopDefault(_keyboardControlKeyOutlined);
var _keyboardControlKeyRounded = require("./KeyboardControlKeyRounded");
var _keyboardControlKeyRoundedDefault = parcelHelpers.interopDefault(_keyboardControlKeyRounded);
var _keyboardControlKeySharp = require("./KeyboardControlKeySharp");
var _keyboardControlKeySharpDefault = parcelHelpers.interopDefault(_keyboardControlKeySharp);
var _keyboardControlKeyTwoTone = require("./KeyboardControlKeyTwoTone");
var _keyboardControlKeyTwoToneDefault = parcelHelpers.interopDefault(_keyboardControlKeyTwoTone);
var _keyboardDoubleArrowDown = require("./KeyboardDoubleArrowDown");
var _keyboardDoubleArrowDownDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowDown);
var _keyboardDoubleArrowDownOutlined = require("./KeyboardDoubleArrowDownOutlined");
var _keyboardDoubleArrowDownOutlinedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowDownOutlined);
var _keyboardDoubleArrowDownRounded = require("./KeyboardDoubleArrowDownRounded");
var _keyboardDoubleArrowDownRoundedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowDownRounded);
var _keyboardDoubleArrowDownSharp = require("./KeyboardDoubleArrowDownSharp");
var _keyboardDoubleArrowDownSharpDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowDownSharp);
var _keyboardDoubleArrowDownTwoTone = require("./KeyboardDoubleArrowDownTwoTone");
var _keyboardDoubleArrowDownTwoToneDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowDownTwoTone);
var _keyboardDoubleArrowLeft = require("./KeyboardDoubleArrowLeft");
var _keyboardDoubleArrowLeftDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowLeft);
var _keyboardDoubleArrowLeftOutlined = require("./KeyboardDoubleArrowLeftOutlined");
var _keyboardDoubleArrowLeftOutlinedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowLeftOutlined);
var _keyboardDoubleArrowLeftRounded = require("./KeyboardDoubleArrowLeftRounded");
var _keyboardDoubleArrowLeftRoundedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowLeftRounded);
var _keyboardDoubleArrowLeftSharp = require("./KeyboardDoubleArrowLeftSharp");
var _keyboardDoubleArrowLeftSharpDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowLeftSharp);
var _keyboardDoubleArrowLeftTwoTone = require("./KeyboardDoubleArrowLeftTwoTone");
var _keyboardDoubleArrowLeftTwoToneDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowLeftTwoTone);
var _keyboardDoubleArrowRight = require("./KeyboardDoubleArrowRight");
var _keyboardDoubleArrowRightDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowRight);
var _keyboardDoubleArrowRightOutlined = require("./KeyboardDoubleArrowRightOutlined");
var _keyboardDoubleArrowRightOutlinedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowRightOutlined);
var _keyboardDoubleArrowRightRounded = require("./KeyboardDoubleArrowRightRounded");
var _keyboardDoubleArrowRightRoundedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowRightRounded);
var _keyboardDoubleArrowRightSharp = require("./KeyboardDoubleArrowRightSharp");
var _keyboardDoubleArrowRightSharpDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowRightSharp);
var _keyboardDoubleArrowRightTwoTone = require("./KeyboardDoubleArrowRightTwoTone");
var _keyboardDoubleArrowRightTwoToneDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowRightTwoTone);
var _keyboardDoubleArrowUp = require("./KeyboardDoubleArrowUp");
var _keyboardDoubleArrowUpDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowUp);
var _keyboardDoubleArrowUpOutlined = require("./KeyboardDoubleArrowUpOutlined");
var _keyboardDoubleArrowUpOutlinedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowUpOutlined);
var _keyboardDoubleArrowUpRounded = require("./KeyboardDoubleArrowUpRounded");
var _keyboardDoubleArrowUpRoundedDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowUpRounded);
var _keyboardDoubleArrowUpSharp = require("./KeyboardDoubleArrowUpSharp");
var _keyboardDoubleArrowUpSharpDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowUpSharp);
var _keyboardDoubleArrowUpTwoTone = require("./KeyboardDoubleArrowUpTwoTone");
var _keyboardDoubleArrowUpTwoToneDefault = parcelHelpers.interopDefault(_keyboardDoubleArrowUpTwoTone);
var _keyboardHide = require("./KeyboardHide");
var _keyboardHideDefault = parcelHelpers.interopDefault(_keyboardHide);
var _keyboardHideOutlined = require("./KeyboardHideOutlined");
var _keyboardHideOutlinedDefault = parcelHelpers.interopDefault(_keyboardHideOutlined);
var _keyboardHideRounded = require("./KeyboardHideRounded");
var _keyboardHideRoundedDefault = parcelHelpers.interopDefault(_keyboardHideRounded);
var _keyboardHideSharp = require("./KeyboardHideSharp");
var _keyboardHideSharpDefault = parcelHelpers.interopDefault(_keyboardHideSharp);
var _keyboardHideTwoTone = require("./KeyboardHideTwoTone");
var _keyboardHideTwoToneDefault = parcelHelpers.interopDefault(_keyboardHideTwoTone);
var _keyboardOptionKey = require("./KeyboardOptionKey");
var _keyboardOptionKeyDefault = parcelHelpers.interopDefault(_keyboardOptionKey);
var _keyboardOptionKeyOutlined = require("./KeyboardOptionKeyOutlined");
var _keyboardOptionKeyOutlinedDefault = parcelHelpers.interopDefault(_keyboardOptionKeyOutlined);
var _keyboardOptionKeyRounded = require("./KeyboardOptionKeyRounded");
var _keyboardOptionKeyRoundedDefault = parcelHelpers.interopDefault(_keyboardOptionKeyRounded);
var _keyboardOptionKeySharp = require("./KeyboardOptionKeySharp");
var _keyboardOptionKeySharpDefault = parcelHelpers.interopDefault(_keyboardOptionKeySharp);
var _keyboardOptionKeyTwoTone = require("./KeyboardOptionKeyTwoTone");
var _keyboardOptionKeyTwoToneDefault = parcelHelpers.interopDefault(_keyboardOptionKeyTwoTone);
var _keyboardOutlined = require("./KeyboardOutlined");
var _keyboardOutlinedDefault = parcelHelpers.interopDefault(_keyboardOutlined);
var _keyboardReturn = require("./KeyboardReturn");
var _keyboardReturnDefault = parcelHelpers.interopDefault(_keyboardReturn);
var _keyboardReturnOutlined = require("./KeyboardReturnOutlined");
var _keyboardReturnOutlinedDefault = parcelHelpers.interopDefault(_keyboardReturnOutlined);
var _keyboardReturnRounded = require("./KeyboardReturnRounded");
var _keyboardReturnRoundedDefault = parcelHelpers.interopDefault(_keyboardReturnRounded);
var _keyboardReturnSharp = require("./KeyboardReturnSharp");
var _keyboardReturnSharpDefault = parcelHelpers.interopDefault(_keyboardReturnSharp);
var _keyboardReturnTwoTone = require("./KeyboardReturnTwoTone");
var _keyboardReturnTwoToneDefault = parcelHelpers.interopDefault(_keyboardReturnTwoTone);
var _keyboardRounded = require("./KeyboardRounded");
var _keyboardRoundedDefault = parcelHelpers.interopDefault(_keyboardRounded);
var _keyboardSharp = require("./KeyboardSharp");
var _keyboardSharpDefault = parcelHelpers.interopDefault(_keyboardSharp);
var _keyboardTab = require("./KeyboardTab");
var _keyboardTabDefault = parcelHelpers.interopDefault(_keyboardTab);
var _keyboardTabOutlined = require("./KeyboardTabOutlined");
var _keyboardTabOutlinedDefault = parcelHelpers.interopDefault(_keyboardTabOutlined);
var _keyboardTabRounded = require("./KeyboardTabRounded");
var _keyboardTabRoundedDefault = parcelHelpers.interopDefault(_keyboardTabRounded);
var _keyboardTabSharp = require("./KeyboardTabSharp");
var _keyboardTabSharpDefault = parcelHelpers.interopDefault(_keyboardTabSharp);
var _keyboardTabTwoTone = require("./KeyboardTabTwoTone");
var _keyboardTabTwoToneDefault = parcelHelpers.interopDefault(_keyboardTabTwoTone);
var _keyboardTwoTone = require("./KeyboardTwoTone");
var _keyboardTwoToneDefault = parcelHelpers.interopDefault(_keyboardTwoTone);
var _keyboardVoice = require("./KeyboardVoice");
var _keyboardVoiceDefault = parcelHelpers.interopDefault(_keyboardVoice);
var _keyboardVoiceOutlined = require("./KeyboardVoiceOutlined");
var _keyboardVoiceOutlinedDefault = parcelHelpers.interopDefault(_keyboardVoiceOutlined);
var _keyboardVoiceRounded = require("./KeyboardVoiceRounded");
var _keyboardVoiceRoundedDefault = parcelHelpers.interopDefault(_keyboardVoiceRounded);
var _keyboardVoiceSharp = require("./KeyboardVoiceSharp");
var _keyboardVoiceSharpDefault = parcelHelpers.interopDefault(_keyboardVoiceSharp);
var _keyboardVoiceTwoTone = require("./KeyboardVoiceTwoTone");
var _keyboardVoiceTwoToneDefault = parcelHelpers.interopDefault(_keyboardVoiceTwoTone);
var _kingBed = require("./KingBed");
var _kingBedDefault = parcelHelpers.interopDefault(_kingBed);
var _kingBedOutlined = require("./KingBedOutlined");
var _kingBedOutlinedDefault = parcelHelpers.interopDefault(_kingBedOutlined);
var _kingBedRounded = require("./KingBedRounded");
var _kingBedRoundedDefault = parcelHelpers.interopDefault(_kingBedRounded);
var _kingBedSharp = require("./KingBedSharp");
var _kingBedSharpDefault = parcelHelpers.interopDefault(_kingBedSharp);
var _kingBedTwoTone = require("./KingBedTwoTone");
var _kingBedTwoToneDefault = parcelHelpers.interopDefault(_kingBedTwoTone);
var _kitchen = require("./Kitchen");
var _kitchenDefault = parcelHelpers.interopDefault(_kitchen);
var _kitchenOutlined = require("./KitchenOutlined");
var _kitchenOutlinedDefault = parcelHelpers.interopDefault(_kitchenOutlined);
var _kitchenRounded = require("./KitchenRounded");
var _kitchenRoundedDefault = parcelHelpers.interopDefault(_kitchenRounded);
var _kitchenSharp = require("./KitchenSharp");
var _kitchenSharpDefault = parcelHelpers.interopDefault(_kitchenSharp);
var _kitchenTwoTone = require("./KitchenTwoTone");
var _kitchenTwoToneDefault = parcelHelpers.interopDefault(_kitchenTwoTone);
var _kitesurfing = require("./Kitesurfing");
var _kitesurfingDefault = parcelHelpers.interopDefault(_kitesurfing);
var _kitesurfingOutlined = require("./KitesurfingOutlined");
var _kitesurfingOutlinedDefault = parcelHelpers.interopDefault(_kitesurfingOutlined);
var _kitesurfingRounded = require("./KitesurfingRounded");
var _kitesurfingRoundedDefault = parcelHelpers.interopDefault(_kitesurfingRounded);
var _kitesurfingSharp = require("./KitesurfingSharp");
var _kitesurfingSharpDefault = parcelHelpers.interopDefault(_kitesurfingSharp);
var _kitesurfingTwoTone = require("./KitesurfingTwoTone");
var _kitesurfingTwoToneDefault = parcelHelpers.interopDefault(_kitesurfingTwoTone);
var _label = require("./Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _labelImportant = require("./LabelImportant");
var _labelImportantDefault = parcelHelpers.interopDefault(_labelImportant);
var _labelImportantOutlined = require("./LabelImportantOutlined");
var _labelImportantOutlinedDefault = parcelHelpers.interopDefault(_labelImportantOutlined);
var _labelImportantRounded = require("./LabelImportantRounded");
var _labelImportantRoundedDefault = parcelHelpers.interopDefault(_labelImportantRounded);
var _labelImportantSharp = require("./LabelImportantSharp");
var _labelImportantSharpDefault = parcelHelpers.interopDefault(_labelImportantSharp);
var _labelImportantTwoTone = require("./LabelImportantTwoTone");
var _labelImportantTwoToneDefault = parcelHelpers.interopDefault(_labelImportantTwoTone);
var _labelOff = require("./LabelOff");
var _labelOffDefault = parcelHelpers.interopDefault(_labelOff);
var _labelOffOutlined = require("./LabelOffOutlined");
var _labelOffOutlinedDefault = parcelHelpers.interopDefault(_labelOffOutlined);
var _labelOffRounded = require("./LabelOffRounded");
var _labelOffRoundedDefault = parcelHelpers.interopDefault(_labelOffRounded);
var _labelOffSharp = require("./LabelOffSharp");
var _labelOffSharpDefault = parcelHelpers.interopDefault(_labelOffSharp);
var _labelOffTwoTone = require("./LabelOffTwoTone");
var _labelOffTwoToneDefault = parcelHelpers.interopDefault(_labelOffTwoTone);
var _labelOutlined = require("./LabelOutlined");
var _labelOutlinedDefault = parcelHelpers.interopDefault(_labelOutlined);
var _labelRounded = require("./LabelRounded");
var _labelRoundedDefault = parcelHelpers.interopDefault(_labelRounded);
var _labelSharp = require("./LabelSharp");
var _labelSharpDefault = parcelHelpers.interopDefault(_labelSharp);
var _labelTwoTone = require("./LabelTwoTone");
var _labelTwoToneDefault = parcelHelpers.interopDefault(_labelTwoTone);
var _lan = require("./Lan");
var _lanDefault = parcelHelpers.interopDefault(_lan);
var _lanOutlined = require("./LanOutlined");
var _lanOutlinedDefault = parcelHelpers.interopDefault(_lanOutlined);
var _lanRounded = require("./LanRounded");
var _lanRoundedDefault = parcelHelpers.interopDefault(_lanRounded);
var _lanSharp = require("./LanSharp");
var _lanSharpDefault = parcelHelpers.interopDefault(_lanSharp);
var _lanTwoTone = require("./LanTwoTone");
var _lanTwoToneDefault = parcelHelpers.interopDefault(_lanTwoTone);
var _landscape = require("./Landscape");
var _landscapeDefault = parcelHelpers.interopDefault(_landscape);
var _landscapeOutlined = require("./LandscapeOutlined");
var _landscapeOutlinedDefault = parcelHelpers.interopDefault(_landscapeOutlined);
var _landscapeRounded = require("./LandscapeRounded");
var _landscapeRoundedDefault = parcelHelpers.interopDefault(_landscapeRounded);
var _landscapeSharp = require("./LandscapeSharp");
var _landscapeSharpDefault = parcelHelpers.interopDefault(_landscapeSharp);
var _landscapeTwoTone = require("./LandscapeTwoTone");
var _landscapeTwoToneDefault = parcelHelpers.interopDefault(_landscapeTwoTone);
var _landslide = require("./Landslide");
var _landslideDefault = parcelHelpers.interopDefault(_landslide);
var _landslideOutlined = require("./LandslideOutlined");
var _landslideOutlinedDefault = parcelHelpers.interopDefault(_landslideOutlined);
var _landslideRounded = require("./LandslideRounded");
var _landslideRoundedDefault = parcelHelpers.interopDefault(_landslideRounded);
var _landslideSharp = require("./LandslideSharp");
var _landslideSharpDefault = parcelHelpers.interopDefault(_landslideSharp);
var _landslideTwoTone = require("./LandslideTwoTone");
var _landslideTwoToneDefault = parcelHelpers.interopDefault(_landslideTwoTone);
var _language = require("./Language");
var _languageDefault = parcelHelpers.interopDefault(_language);
var _languageOutlined = require("./LanguageOutlined");
var _languageOutlinedDefault = parcelHelpers.interopDefault(_languageOutlined);
var _languageRounded = require("./LanguageRounded");
var _languageRoundedDefault = parcelHelpers.interopDefault(_languageRounded);
var _languageSharp = require("./LanguageSharp");
var _languageSharpDefault = parcelHelpers.interopDefault(_languageSharp);
var _languageTwoTone = require("./LanguageTwoTone");
var _languageTwoToneDefault = parcelHelpers.interopDefault(_languageTwoTone);
var _laptop = require("./Laptop");
var _laptopDefault = parcelHelpers.interopDefault(_laptop);
var _laptopChromebook = require("./LaptopChromebook");
var _laptopChromebookDefault = parcelHelpers.interopDefault(_laptopChromebook);
var _laptopChromebookOutlined = require("./LaptopChromebookOutlined");
var _laptopChromebookOutlinedDefault = parcelHelpers.interopDefault(_laptopChromebookOutlined);
var _laptopChromebookRounded = require("./LaptopChromebookRounded");
var _laptopChromebookRoundedDefault = parcelHelpers.interopDefault(_laptopChromebookRounded);
var _laptopChromebookSharp = require("./LaptopChromebookSharp");
var _laptopChromebookSharpDefault = parcelHelpers.interopDefault(_laptopChromebookSharp);
var _laptopChromebookTwoTone = require("./LaptopChromebookTwoTone");
var _laptopChromebookTwoToneDefault = parcelHelpers.interopDefault(_laptopChromebookTwoTone);
var _laptopMac = require("./LaptopMac");
var _laptopMacDefault = parcelHelpers.interopDefault(_laptopMac);
var _laptopMacOutlined = require("./LaptopMacOutlined");
var _laptopMacOutlinedDefault = parcelHelpers.interopDefault(_laptopMacOutlined);
var _laptopMacRounded = require("./LaptopMacRounded");
var _laptopMacRoundedDefault = parcelHelpers.interopDefault(_laptopMacRounded);
var _laptopMacSharp = require("./LaptopMacSharp");
var _laptopMacSharpDefault = parcelHelpers.interopDefault(_laptopMacSharp);
var _laptopMacTwoTone = require("./LaptopMacTwoTone");
var _laptopMacTwoToneDefault = parcelHelpers.interopDefault(_laptopMacTwoTone);
var _laptopOutlined = require("./LaptopOutlined");
var _laptopOutlinedDefault = parcelHelpers.interopDefault(_laptopOutlined);
var _laptopRounded = require("./LaptopRounded");
var _laptopRoundedDefault = parcelHelpers.interopDefault(_laptopRounded);
var _laptopSharp = require("./LaptopSharp");
var _laptopSharpDefault = parcelHelpers.interopDefault(_laptopSharp);
var _laptopTwoTone = require("./LaptopTwoTone");
var _laptopTwoToneDefault = parcelHelpers.interopDefault(_laptopTwoTone);
var _laptopWindows = require("./LaptopWindows");
var _laptopWindowsDefault = parcelHelpers.interopDefault(_laptopWindows);
var _laptopWindowsOutlined = require("./LaptopWindowsOutlined");
var _laptopWindowsOutlinedDefault = parcelHelpers.interopDefault(_laptopWindowsOutlined);
var _laptopWindowsRounded = require("./LaptopWindowsRounded");
var _laptopWindowsRoundedDefault = parcelHelpers.interopDefault(_laptopWindowsRounded);
var _laptopWindowsSharp = require("./LaptopWindowsSharp");
var _laptopWindowsSharpDefault = parcelHelpers.interopDefault(_laptopWindowsSharp);
var _laptopWindowsTwoTone = require("./LaptopWindowsTwoTone");
var _laptopWindowsTwoToneDefault = parcelHelpers.interopDefault(_laptopWindowsTwoTone);
var _lastPage = require("./LastPage");
var _lastPageDefault = parcelHelpers.interopDefault(_lastPage);
var _lastPageOutlined = require("./LastPageOutlined");
var _lastPageOutlinedDefault = parcelHelpers.interopDefault(_lastPageOutlined);
var _lastPageRounded = require("./LastPageRounded");
var _lastPageRoundedDefault = parcelHelpers.interopDefault(_lastPageRounded);
var _lastPageSharp = require("./LastPageSharp");
var _lastPageSharpDefault = parcelHelpers.interopDefault(_lastPageSharp);
var _lastPageTwoTone = require("./LastPageTwoTone");
var _lastPageTwoToneDefault = parcelHelpers.interopDefault(_lastPageTwoTone);
var _launch = require("./Launch");
var _launchDefault = parcelHelpers.interopDefault(_launch);
var _launchOutlined = require("./LaunchOutlined");
var _launchOutlinedDefault = parcelHelpers.interopDefault(_launchOutlined);
var _launchRounded = require("./LaunchRounded");
var _launchRoundedDefault = parcelHelpers.interopDefault(_launchRounded);
var _launchSharp = require("./LaunchSharp");
var _launchSharpDefault = parcelHelpers.interopDefault(_launchSharp);
var _launchTwoTone = require("./LaunchTwoTone");
var _launchTwoToneDefault = parcelHelpers.interopDefault(_launchTwoTone);
var _layers = require("./Layers");
var _layersDefault = parcelHelpers.interopDefault(_layers);
var _layersClear = require("./LayersClear");
var _layersClearDefault = parcelHelpers.interopDefault(_layersClear);
var _layersClearOutlined = require("./LayersClearOutlined");
var _layersClearOutlinedDefault = parcelHelpers.interopDefault(_layersClearOutlined);
var _layersClearRounded = require("./LayersClearRounded");
var _layersClearRoundedDefault = parcelHelpers.interopDefault(_layersClearRounded);
var _layersClearSharp = require("./LayersClearSharp");
var _layersClearSharpDefault = parcelHelpers.interopDefault(_layersClearSharp);
var _layersClearTwoTone = require("./LayersClearTwoTone");
var _layersClearTwoToneDefault = parcelHelpers.interopDefault(_layersClearTwoTone);
var _layersOutlined = require("./LayersOutlined");
var _layersOutlinedDefault = parcelHelpers.interopDefault(_layersOutlined);
var _layersRounded = require("./LayersRounded");
var _layersRoundedDefault = parcelHelpers.interopDefault(_layersRounded);
var _layersSharp = require("./LayersSharp");
var _layersSharpDefault = parcelHelpers.interopDefault(_layersSharp);
var _layersTwoTone = require("./LayersTwoTone");
var _layersTwoToneDefault = parcelHelpers.interopDefault(_layersTwoTone);
var _leaderboard = require("./Leaderboard");
var _leaderboardDefault = parcelHelpers.interopDefault(_leaderboard);
var _leaderboardOutlined = require("./LeaderboardOutlined");
var _leaderboardOutlinedDefault = parcelHelpers.interopDefault(_leaderboardOutlined);
var _leaderboardRounded = require("./LeaderboardRounded");
var _leaderboardRoundedDefault = parcelHelpers.interopDefault(_leaderboardRounded);
var _leaderboardSharp = require("./LeaderboardSharp");
var _leaderboardSharpDefault = parcelHelpers.interopDefault(_leaderboardSharp);
var _leaderboardTwoTone = require("./LeaderboardTwoTone");
var _leaderboardTwoToneDefault = parcelHelpers.interopDefault(_leaderboardTwoTone);
var _leakAdd = require("./LeakAdd");
var _leakAddDefault = parcelHelpers.interopDefault(_leakAdd);
var _leakAddOutlined = require("./LeakAddOutlined");
var _leakAddOutlinedDefault = parcelHelpers.interopDefault(_leakAddOutlined);
var _leakAddRounded = require("./LeakAddRounded");
var _leakAddRoundedDefault = parcelHelpers.interopDefault(_leakAddRounded);
var _leakAddSharp = require("./LeakAddSharp");
var _leakAddSharpDefault = parcelHelpers.interopDefault(_leakAddSharp);
var _leakAddTwoTone = require("./LeakAddTwoTone");
var _leakAddTwoToneDefault = parcelHelpers.interopDefault(_leakAddTwoTone);
var _leakRemove = require("./LeakRemove");
var _leakRemoveDefault = parcelHelpers.interopDefault(_leakRemove);
var _leakRemoveOutlined = require("./LeakRemoveOutlined");
var _leakRemoveOutlinedDefault = parcelHelpers.interopDefault(_leakRemoveOutlined);
var _leakRemoveRounded = require("./LeakRemoveRounded");
var _leakRemoveRoundedDefault = parcelHelpers.interopDefault(_leakRemoveRounded);
var _leakRemoveSharp = require("./LeakRemoveSharp");
var _leakRemoveSharpDefault = parcelHelpers.interopDefault(_leakRemoveSharp);
var _leakRemoveTwoTone = require("./LeakRemoveTwoTone");
var _leakRemoveTwoToneDefault = parcelHelpers.interopDefault(_leakRemoveTwoTone);
var _legendToggle = require("./LegendToggle");
var _legendToggleDefault = parcelHelpers.interopDefault(_legendToggle);
var _legendToggleOutlined = require("./LegendToggleOutlined");
var _legendToggleOutlinedDefault = parcelHelpers.interopDefault(_legendToggleOutlined);
var _legendToggleRounded = require("./LegendToggleRounded");
var _legendToggleRoundedDefault = parcelHelpers.interopDefault(_legendToggleRounded);
var _legendToggleSharp = require("./LegendToggleSharp");
var _legendToggleSharpDefault = parcelHelpers.interopDefault(_legendToggleSharp);
var _legendToggleTwoTone = require("./LegendToggleTwoTone");
var _legendToggleTwoToneDefault = parcelHelpers.interopDefault(_legendToggleTwoTone);
var _lens = require("./Lens");
var _lensDefault = parcelHelpers.interopDefault(_lens);
var _lensBlur = require("./LensBlur");
var _lensBlurDefault = parcelHelpers.interopDefault(_lensBlur);
var _lensBlurOutlined = require("./LensBlurOutlined");
var _lensBlurOutlinedDefault = parcelHelpers.interopDefault(_lensBlurOutlined);
var _lensBlurRounded = require("./LensBlurRounded");
var _lensBlurRoundedDefault = parcelHelpers.interopDefault(_lensBlurRounded);
var _lensBlurSharp = require("./LensBlurSharp");
var _lensBlurSharpDefault = parcelHelpers.interopDefault(_lensBlurSharp);
var _lensBlurTwoTone = require("./LensBlurTwoTone");
var _lensBlurTwoToneDefault = parcelHelpers.interopDefault(_lensBlurTwoTone);
var _lensOutlined = require("./LensOutlined");
var _lensOutlinedDefault = parcelHelpers.interopDefault(_lensOutlined);
var _lensRounded = require("./LensRounded");
var _lensRoundedDefault = parcelHelpers.interopDefault(_lensRounded);
var _lensSharp = require("./LensSharp");
var _lensSharpDefault = parcelHelpers.interopDefault(_lensSharp);
var _lensTwoTone = require("./LensTwoTone");
var _lensTwoToneDefault = parcelHelpers.interopDefault(_lensTwoTone);
var _libraryAdd = require("./LibraryAdd");
var _libraryAddDefault = parcelHelpers.interopDefault(_libraryAdd);
var _libraryAddCheck = require("./LibraryAddCheck");
var _libraryAddCheckDefault = parcelHelpers.interopDefault(_libraryAddCheck);
var _libraryAddCheckOutlined = require("./LibraryAddCheckOutlined");
var _libraryAddCheckOutlinedDefault = parcelHelpers.interopDefault(_libraryAddCheckOutlined);
var _libraryAddCheckRounded = require("./LibraryAddCheckRounded");
var _libraryAddCheckRoundedDefault = parcelHelpers.interopDefault(_libraryAddCheckRounded);
var _libraryAddCheckSharp = require("./LibraryAddCheckSharp");
var _libraryAddCheckSharpDefault = parcelHelpers.interopDefault(_libraryAddCheckSharp);
var _libraryAddCheckTwoTone = require("./LibraryAddCheckTwoTone");
var _libraryAddCheckTwoToneDefault = parcelHelpers.interopDefault(_libraryAddCheckTwoTone);
var _libraryAddOutlined = require("./LibraryAddOutlined");
var _libraryAddOutlinedDefault = parcelHelpers.interopDefault(_libraryAddOutlined);
var _libraryAddRounded = require("./LibraryAddRounded");
var _libraryAddRoundedDefault = parcelHelpers.interopDefault(_libraryAddRounded);
var _libraryAddSharp = require("./LibraryAddSharp");
var _libraryAddSharpDefault = parcelHelpers.interopDefault(_libraryAddSharp);
var _libraryAddTwoTone = require("./LibraryAddTwoTone");
var _libraryAddTwoToneDefault = parcelHelpers.interopDefault(_libraryAddTwoTone);
var _libraryBooks = require("./LibraryBooks");
var _libraryBooksDefault = parcelHelpers.interopDefault(_libraryBooks);
var _libraryBooksOutlined = require("./LibraryBooksOutlined");
var _libraryBooksOutlinedDefault = parcelHelpers.interopDefault(_libraryBooksOutlined);
var _libraryBooksRounded = require("./LibraryBooksRounded");
var _libraryBooksRoundedDefault = parcelHelpers.interopDefault(_libraryBooksRounded);
var _libraryBooksSharp = require("./LibraryBooksSharp");
var _libraryBooksSharpDefault = parcelHelpers.interopDefault(_libraryBooksSharp);
var _libraryBooksTwoTone = require("./LibraryBooksTwoTone");
var _libraryBooksTwoToneDefault = parcelHelpers.interopDefault(_libraryBooksTwoTone);
var _libraryMusic = require("./LibraryMusic");
var _libraryMusicDefault = parcelHelpers.interopDefault(_libraryMusic);
var _libraryMusicOutlined = require("./LibraryMusicOutlined");
var _libraryMusicOutlinedDefault = parcelHelpers.interopDefault(_libraryMusicOutlined);
var _libraryMusicRounded = require("./LibraryMusicRounded");
var _libraryMusicRoundedDefault = parcelHelpers.interopDefault(_libraryMusicRounded);
var _libraryMusicSharp = require("./LibraryMusicSharp");
var _libraryMusicSharpDefault = parcelHelpers.interopDefault(_libraryMusicSharp);
var _libraryMusicTwoTone = require("./LibraryMusicTwoTone");
var _libraryMusicTwoToneDefault = parcelHelpers.interopDefault(_libraryMusicTwoTone);
var _light = require("./Light");
var _lightDefault = parcelHelpers.interopDefault(_light);
var _lightMode = require("./LightMode");
var _lightModeDefault = parcelHelpers.interopDefault(_lightMode);
var _lightModeOutlined = require("./LightModeOutlined");
var _lightModeOutlinedDefault = parcelHelpers.interopDefault(_lightModeOutlined);
var _lightModeRounded = require("./LightModeRounded");
var _lightModeRoundedDefault = parcelHelpers.interopDefault(_lightModeRounded);
var _lightModeSharp = require("./LightModeSharp");
var _lightModeSharpDefault = parcelHelpers.interopDefault(_lightModeSharp);
var _lightModeTwoTone = require("./LightModeTwoTone");
var _lightModeTwoToneDefault = parcelHelpers.interopDefault(_lightModeTwoTone);
var _lightOutlined = require("./LightOutlined");
var _lightOutlinedDefault = parcelHelpers.interopDefault(_lightOutlined);
var _lightRounded = require("./LightRounded");
var _lightRoundedDefault = parcelHelpers.interopDefault(_lightRounded);
var _lightSharp = require("./LightSharp");
var _lightSharpDefault = parcelHelpers.interopDefault(_lightSharp);
var _lightTwoTone = require("./LightTwoTone");
var _lightTwoToneDefault = parcelHelpers.interopDefault(_lightTwoTone);
var _lightbulb = require("./Lightbulb");
var _lightbulbDefault = parcelHelpers.interopDefault(_lightbulb);
var _lightbulbCircle = require("./LightbulbCircle");
var _lightbulbCircleDefault = parcelHelpers.interopDefault(_lightbulbCircle);
var _lightbulbCircleOutlined = require("./LightbulbCircleOutlined");
var _lightbulbCircleOutlinedDefault = parcelHelpers.interopDefault(_lightbulbCircleOutlined);
var _lightbulbCircleRounded = require("./LightbulbCircleRounded");
var _lightbulbCircleRoundedDefault = parcelHelpers.interopDefault(_lightbulbCircleRounded);
var _lightbulbCircleSharp = require("./LightbulbCircleSharp");
var _lightbulbCircleSharpDefault = parcelHelpers.interopDefault(_lightbulbCircleSharp);
var _lightbulbCircleTwoTone = require("./LightbulbCircleTwoTone");
var _lightbulbCircleTwoToneDefault = parcelHelpers.interopDefault(_lightbulbCircleTwoTone);
var _lightbulbOutlined = require("./LightbulbOutlined");
var _lightbulbOutlinedDefault = parcelHelpers.interopDefault(_lightbulbOutlined);
var _lightbulbRounded = require("./LightbulbRounded");
var _lightbulbRoundedDefault = parcelHelpers.interopDefault(_lightbulbRounded);
var _lightbulbSharp = require("./LightbulbSharp");
var _lightbulbSharpDefault = parcelHelpers.interopDefault(_lightbulbSharp);
var _lightbulbTwoTone = require("./LightbulbTwoTone");
var _lightbulbTwoToneDefault = parcelHelpers.interopDefault(_lightbulbTwoTone);
var _lineAxis = require("./LineAxis");
var _lineAxisDefault = parcelHelpers.interopDefault(_lineAxis);
var _lineAxisOutlined = require("./LineAxisOutlined");
var _lineAxisOutlinedDefault = parcelHelpers.interopDefault(_lineAxisOutlined);
var _lineAxisRounded = require("./LineAxisRounded");
var _lineAxisRoundedDefault = parcelHelpers.interopDefault(_lineAxisRounded);
var _lineAxisSharp = require("./LineAxisSharp");
var _lineAxisSharpDefault = parcelHelpers.interopDefault(_lineAxisSharp);
var _lineAxisTwoTone = require("./LineAxisTwoTone");
var _lineAxisTwoToneDefault = parcelHelpers.interopDefault(_lineAxisTwoTone);
var _lineStyle = require("./LineStyle");
var _lineStyleDefault = parcelHelpers.interopDefault(_lineStyle);
var _lineStyleOutlined = require("./LineStyleOutlined");
var _lineStyleOutlinedDefault = parcelHelpers.interopDefault(_lineStyleOutlined);
var _lineStyleRounded = require("./LineStyleRounded");
var _lineStyleRoundedDefault = parcelHelpers.interopDefault(_lineStyleRounded);
var _lineStyleSharp = require("./LineStyleSharp");
var _lineStyleSharpDefault = parcelHelpers.interopDefault(_lineStyleSharp);
var _lineStyleTwoTone = require("./LineStyleTwoTone");
var _lineStyleTwoToneDefault = parcelHelpers.interopDefault(_lineStyleTwoTone);
var _lineWeight = require("./LineWeight");
var _lineWeightDefault = parcelHelpers.interopDefault(_lineWeight);
var _lineWeightOutlined = require("./LineWeightOutlined");
var _lineWeightOutlinedDefault = parcelHelpers.interopDefault(_lineWeightOutlined);
var _lineWeightRounded = require("./LineWeightRounded");
var _lineWeightRoundedDefault = parcelHelpers.interopDefault(_lineWeightRounded);
var _lineWeightSharp = require("./LineWeightSharp");
var _lineWeightSharpDefault = parcelHelpers.interopDefault(_lineWeightSharp);
var _lineWeightTwoTone = require("./LineWeightTwoTone");
var _lineWeightTwoToneDefault = parcelHelpers.interopDefault(_lineWeightTwoTone);
var _linearScale = require("./LinearScale");
var _linearScaleDefault = parcelHelpers.interopDefault(_linearScale);
var _linearScaleOutlined = require("./LinearScaleOutlined");
var _linearScaleOutlinedDefault = parcelHelpers.interopDefault(_linearScaleOutlined);
var _linearScaleRounded = require("./LinearScaleRounded");
var _linearScaleRoundedDefault = parcelHelpers.interopDefault(_linearScaleRounded);
var _linearScaleSharp = require("./LinearScaleSharp");
var _linearScaleSharpDefault = parcelHelpers.interopDefault(_linearScaleSharp);
var _linearScaleTwoTone = require("./LinearScaleTwoTone");
var _linearScaleTwoToneDefault = parcelHelpers.interopDefault(_linearScaleTwoTone);
var _link = require("./Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkOff = require("./LinkOff");
var _linkOffDefault = parcelHelpers.interopDefault(_linkOff);
var _linkOffOutlined = require("./LinkOffOutlined");
var _linkOffOutlinedDefault = parcelHelpers.interopDefault(_linkOffOutlined);
var _linkOffRounded = require("./LinkOffRounded");
var _linkOffRoundedDefault = parcelHelpers.interopDefault(_linkOffRounded);
var _linkOffSharp = require("./LinkOffSharp");
var _linkOffSharpDefault = parcelHelpers.interopDefault(_linkOffSharp);
var _linkOffTwoTone = require("./LinkOffTwoTone");
var _linkOffTwoToneDefault = parcelHelpers.interopDefault(_linkOffTwoTone);
var _linkOutlined = require("./LinkOutlined");
var _linkOutlinedDefault = parcelHelpers.interopDefault(_linkOutlined);
var _linkRounded = require("./LinkRounded");
var _linkRoundedDefault = parcelHelpers.interopDefault(_linkRounded);
var _linkSharp = require("./LinkSharp");
var _linkSharpDefault = parcelHelpers.interopDefault(_linkSharp);
var _linkTwoTone = require("./LinkTwoTone");
var _linkTwoToneDefault = parcelHelpers.interopDefault(_linkTwoTone);
var _linkedCamera = require("./LinkedCamera");
var _linkedCameraDefault = parcelHelpers.interopDefault(_linkedCamera);
var _linkedCameraOutlined = require("./LinkedCameraOutlined");
var _linkedCameraOutlinedDefault = parcelHelpers.interopDefault(_linkedCameraOutlined);
var _linkedCameraRounded = require("./LinkedCameraRounded");
var _linkedCameraRoundedDefault = parcelHelpers.interopDefault(_linkedCameraRounded);
var _linkedCameraSharp = require("./LinkedCameraSharp");
var _linkedCameraSharpDefault = parcelHelpers.interopDefault(_linkedCameraSharp);
var _linkedCameraTwoTone = require("./LinkedCameraTwoTone");
var _linkedCameraTwoToneDefault = parcelHelpers.interopDefault(_linkedCameraTwoTone);
var _linkedIn = require("./LinkedIn");
var _linkedInDefault = parcelHelpers.interopDefault(_linkedIn);
var _liquor = require("./Liquor");
var _liquorDefault = parcelHelpers.interopDefault(_liquor);
var _liquorOutlined = require("./LiquorOutlined");
var _liquorOutlinedDefault = parcelHelpers.interopDefault(_liquorOutlined);
var _liquorRounded = require("./LiquorRounded");
var _liquorRoundedDefault = parcelHelpers.interopDefault(_liquorRounded);
var _liquorSharp = require("./LiquorSharp");
var _liquorSharpDefault = parcelHelpers.interopDefault(_liquorSharp);
var _liquorTwoTone = require("./LiquorTwoTone");
var _liquorTwoToneDefault = parcelHelpers.interopDefault(_liquorTwoTone);
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listAlt = require("./ListAlt");
var _listAltDefault = parcelHelpers.interopDefault(_listAlt);
var _listAltOutlined = require("./ListAltOutlined");
var _listAltOutlinedDefault = parcelHelpers.interopDefault(_listAltOutlined);
var _listAltRounded = require("./ListAltRounded");
var _listAltRoundedDefault = parcelHelpers.interopDefault(_listAltRounded);
var _listAltSharp = require("./ListAltSharp");
var _listAltSharpDefault = parcelHelpers.interopDefault(_listAltSharp);
var _listAltTwoTone = require("./ListAltTwoTone");
var _listAltTwoToneDefault = parcelHelpers.interopDefault(_listAltTwoTone);
var _listOutlined = require("./ListOutlined");
var _listOutlinedDefault = parcelHelpers.interopDefault(_listOutlined);
var _listRounded = require("./ListRounded");
var _listRoundedDefault = parcelHelpers.interopDefault(_listRounded);
var _listSharp = require("./ListSharp");
var _listSharpDefault = parcelHelpers.interopDefault(_listSharp);
var _listTwoTone = require("./ListTwoTone");
var _listTwoToneDefault = parcelHelpers.interopDefault(_listTwoTone);
var _liveHelp = require("./LiveHelp");
var _liveHelpDefault = parcelHelpers.interopDefault(_liveHelp);
var _liveHelpOutlined = require("./LiveHelpOutlined");
var _liveHelpOutlinedDefault = parcelHelpers.interopDefault(_liveHelpOutlined);
var _liveHelpRounded = require("./LiveHelpRounded");
var _liveHelpRoundedDefault = parcelHelpers.interopDefault(_liveHelpRounded);
var _liveHelpSharp = require("./LiveHelpSharp");
var _liveHelpSharpDefault = parcelHelpers.interopDefault(_liveHelpSharp);
var _liveHelpTwoTone = require("./LiveHelpTwoTone");
var _liveHelpTwoToneDefault = parcelHelpers.interopDefault(_liveHelpTwoTone);
var _liveTv = require("./LiveTv");
var _liveTvDefault = parcelHelpers.interopDefault(_liveTv);
var _liveTvOutlined = require("./LiveTvOutlined");
var _liveTvOutlinedDefault = parcelHelpers.interopDefault(_liveTvOutlined);
var _liveTvRounded = require("./LiveTvRounded");
var _liveTvRoundedDefault = parcelHelpers.interopDefault(_liveTvRounded);
var _liveTvSharp = require("./LiveTvSharp");
var _liveTvSharpDefault = parcelHelpers.interopDefault(_liveTvSharp);
var _liveTvTwoTone = require("./LiveTvTwoTone");
var _liveTvTwoToneDefault = parcelHelpers.interopDefault(_liveTvTwoTone);
var _living = require("./Living");
var _livingDefault = parcelHelpers.interopDefault(_living);
var _livingOutlined = require("./LivingOutlined");
var _livingOutlinedDefault = parcelHelpers.interopDefault(_livingOutlined);
var _livingRounded = require("./LivingRounded");
var _livingRoundedDefault = parcelHelpers.interopDefault(_livingRounded);
var _livingSharp = require("./LivingSharp");
var _livingSharpDefault = parcelHelpers.interopDefault(_livingSharp);
var _livingTwoTone = require("./LivingTwoTone");
var _livingTwoToneDefault = parcelHelpers.interopDefault(_livingTwoTone);
var _localActivity = require("./LocalActivity");
var _localActivityDefault = parcelHelpers.interopDefault(_localActivity);
var _localActivityOutlined = require("./LocalActivityOutlined");
var _localActivityOutlinedDefault = parcelHelpers.interopDefault(_localActivityOutlined);
var _localActivityRounded = require("./LocalActivityRounded");
var _localActivityRoundedDefault = parcelHelpers.interopDefault(_localActivityRounded);
var _localActivitySharp = require("./LocalActivitySharp");
var _localActivitySharpDefault = parcelHelpers.interopDefault(_localActivitySharp);
var _localActivityTwoTone = require("./LocalActivityTwoTone");
var _localActivityTwoToneDefault = parcelHelpers.interopDefault(_localActivityTwoTone);
var _localAirport = require("./LocalAirport");
var _localAirportDefault = parcelHelpers.interopDefault(_localAirport);
var _localAirportOutlined = require("./LocalAirportOutlined");
var _localAirportOutlinedDefault = parcelHelpers.interopDefault(_localAirportOutlined);
var _localAirportRounded = require("./LocalAirportRounded");
var _localAirportRoundedDefault = parcelHelpers.interopDefault(_localAirportRounded);
var _localAirportSharp = require("./LocalAirportSharp");
var _localAirportSharpDefault = parcelHelpers.interopDefault(_localAirportSharp);
var _localAirportTwoTone = require("./LocalAirportTwoTone");
var _localAirportTwoToneDefault = parcelHelpers.interopDefault(_localAirportTwoTone);
var _localAtm = require("./LocalAtm");
var _localAtmDefault = parcelHelpers.interopDefault(_localAtm);
var _localAtmOutlined = require("./LocalAtmOutlined");
var _localAtmOutlinedDefault = parcelHelpers.interopDefault(_localAtmOutlined);
var _localAtmRounded = require("./LocalAtmRounded");
var _localAtmRoundedDefault = parcelHelpers.interopDefault(_localAtmRounded);
var _localAtmSharp = require("./LocalAtmSharp");
var _localAtmSharpDefault = parcelHelpers.interopDefault(_localAtmSharp);
var _localAtmTwoTone = require("./LocalAtmTwoTone");
var _localAtmTwoToneDefault = parcelHelpers.interopDefault(_localAtmTwoTone);
var _localBar = require("./LocalBar");
var _localBarDefault = parcelHelpers.interopDefault(_localBar);
var _localBarOutlined = require("./LocalBarOutlined");
var _localBarOutlinedDefault = parcelHelpers.interopDefault(_localBarOutlined);
var _localBarRounded = require("./LocalBarRounded");
var _localBarRoundedDefault = parcelHelpers.interopDefault(_localBarRounded);
var _localBarSharp = require("./LocalBarSharp");
var _localBarSharpDefault = parcelHelpers.interopDefault(_localBarSharp);
var _localBarTwoTone = require("./LocalBarTwoTone");
var _localBarTwoToneDefault = parcelHelpers.interopDefault(_localBarTwoTone);
var _localCafe = require("./LocalCafe");
var _localCafeDefault = parcelHelpers.interopDefault(_localCafe);
var _localCafeOutlined = require("./LocalCafeOutlined");
var _localCafeOutlinedDefault = parcelHelpers.interopDefault(_localCafeOutlined);
var _localCafeRounded = require("./LocalCafeRounded");
var _localCafeRoundedDefault = parcelHelpers.interopDefault(_localCafeRounded);
var _localCafeSharp = require("./LocalCafeSharp");
var _localCafeSharpDefault = parcelHelpers.interopDefault(_localCafeSharp);
var _localCafeTwoTone = require("./LocalCafeTwoTone");
var _localCafeTwoToneDefault = parcelHelpers.interopDefault(_localCafeTwoTone);
var _localCarWash = require("./LocalCarWash");
var _localCarWashDefault = parcelHelpers.interopDefault(_localCarWash);
var _localCarWashOutlined = require("./LocalCarWashOutlined");
var _localCarWashOutlinedDefault = parcelHelpers.interopDefault(_localCarWashOutlined);
var _localCarWashRounded = require("./LocalCarWashRounded");
var _localCarWashRoundedDefault = parcelHelpers.interopDefault(_localCarWashRounded);
var _localCarWashSharp = require("./LocalCarWashSharp");
var _localCarWashSharpDefault = parcelHelpers.interopDefault(_localCarWashSharp);
var _localCarWashTwoTone = require("./LocalCarWashTwoTone");
var _localCarWashTwoToneDefault = parcelHelpers.interopDefault(_localCarWashTwoTone);
var _localConvenienceStore = require("./LocalConvenienceStore");
var _localConvenienceStoreDefault = parcelHelpers.interopDefault(_localConvenienceStore);
var _localConvenienceStoreOutlined = require("./LocalConvenienceStoreOutlined");
var _localConvenienceStoreOutlinedDefault = parcelHelpers.interopDefault(_localConvenienceStoreOutlined);
var _localConvenienceStoreRounded = require("./LocalConvenienceStoreRounded");
var _localConvenienceStoreRoundedDefault = parcelHelpers.interopDefault(_localConvenienceStoreRounded);
var _localConvenienceStoreSharp = require("./LocalConvenienceStoreSharp");
var _localConvenienceStoreSharpDefault = parcelHelpers.interopDefault(_localConvenienceStoreSharp);
var _localConvenienceStoreTwoTone = require("./LocalConvenienceStoreTwoTone");
var _localConvenienceStoreTwoToneDefault = parcelHelpers.interopDefault(_localConvenienceStoreTwoTone);
var _localDining = require("./LocalDining");
var _localDiningDefault = parcelHelpers.interopDefault(_localDining);
var _localDiningOutlined = require("./LocalDiningOutlined");
var _localDiningOutlinedDefault = parcelHelpers.interopDefault(_localDiningOutlined);
var _localDiningRounded = require("./LocalDiningRounded");
var _localDiningRoundedDefault = parcelHelpers.interopDefault(_localDiningRounded);
var _localDiningSharp = require("./LocalDiningSharp");
var _localDiningSharpDefault = parcelHelpers.interopDefault(_localDiningSharp);
var _localDiningTwoTone = require("./LocalDiningTwoTone");
var _localDiningTwoToneDefault = parcelHelpers.interopDefault(_localDiningTwoTone);
var _localDrink = require("./LocalDrink");
var _localDrinkDefault = parcelHelpers.interopDefault(_localDrink);
var _localDrinkOutlined = require("./LocalDrinkOutlined");
var _localDrinkOutlinedDefault = parcelHelpers.interopDefault(_localDrinkOutlined);
var _localDrinkRounded = require("./LocalDrinkRounded");
var _localDrinkRoundedDefault = parcelHelpers.interopDefault(_localDrinkRounded);
var _localDrinkSharp = require("./LocalDrinkSharp");
var _localDrinkSharpDefault = parcelHelpers.interopDefault(_localDrinkSharp);
var _localDrinkTwoTone = require("./LocalDrinkTwoTone");
var _localDrinkTwoToneDefault = parcelHelpers.interopDefault(_localDrinkTwoTone);
var _localFireDepartment = require("./LocalFireDepartment");
var _localFireDepartmentDefault = parcelHelpers.interopDefault(_localFireDepartment);
var _localFireDepartmentOutlined = require("./LocalFireDepartmentOutlined");
var _localFireDepartmentOutlinedDefault = parcelHelpers.interopDefault(_localFireDepartmentOutlined);
var _localFireDepartmentRounded = require("./LocalFireDepartmentRounded");
var _localFireDepartmentRoundedDefault = parcelHelpers.interopDefault(_localFireDepartmentRounded);
var _localFireDepartmentSharp = require("./LocalFireDepartmentSharp");
var _localFireDepartmentSharpDefault = parcelHelpers.interopDefault(_localFireDepartmentSharp);
var _localFireDepartmentTwoTone = require("./LocalFireDepartmentTwoTone");
var _localFireDepartmentTwoToneDefault = parcelHelpers.interopDefault(_localFireDepartmentTwoTone);
var _localFlorist = require("./LocalFlorist");
var _localFloristDefault = parcelHelpers.interopDefault(_localFlorist);
var _localFloristOutlined = require("./LocalFloristOutlined");
var _localFloristOutlinedDefault = parcelHelpers.interopDefault(_localFloristOutlined);
var _localFloristRounded = require("./LocalFloristRounded");
var _localFloristRoundedDefault = parcelHelpers.interopDefault(_localFloristRounded);
var _localFloristSharp = require("./LocalFloristSharp");
var _localFloristSharpDefault = parcelHelpers.interopDefault(_localFloristSharp);
var _localFloristTwoTone = require("./LocalFloristTwoTone");
var _localFloristTwoToneDefault = parcelHelpers.interopDefault(_localFloristTwoTone);
var _localGasStation = require("./LocalGasStation");
var _localGasStationDefault = parcelHelpers.interopDefault(_localGasStation);
var _localGasStationOutlined = require("./LocalGasStationOutlined");
var _localGasStationOutlinedDefault = parcelHelpers.interopDefault(_localGasStationOutlined);
var _localGasStationRounded = require("./LocalGasStationRounded");
var _localGasStationRoundedDefault = parcelHelpers.interopDefault(_localGasStationRounded);
var _localGasStationSharp = require("./LocalGasStationSharp");
var _localGasStationSharpDefault = parcelHelpers.interopDefault(_localGasStationSharp);
var _localGasStationTwoTone = require("./LocalGasStationTwoTone");
var _localGasStationTwoToneDefault = parcelHelpers.interopDefault(_localGasStationTwoTone);
var _localGroceryStore = require("./LocalGroceryStore");
var _localGroceryStoreDefault = parcelHelpers.interopDefault(_localGroceryStore);
var _localGroceryStoreOutlined = require("./LocalGroceryStoreOutlined");
var _localGroceryStoreOutlinedDefault = parcelHelpers.interopDefault(_localGroceryStoreOutlined);
var _localGroceryStoreRounded = require("./LocalGroceryStoreRounded");
var _localGroceryStoreRoundedDefault = parcelHelpers.interopDefault(_localGroceryStoreRounded);
var _localGroceryStoreSharp = require("./LocalGroceryStoreSharp");
var _localGroceryStoreSharpDefault = parcelHelpers.interopDefault(_localGroceryStoreSharp);
var _localGroceryStoreTwoTone = require("./LocalGroceryStoreTwoTone");
var _localGroceryStoreTwoToneDefault = parcelHelpers.interopDefault(_localGroceryStoreTwoTone);
var _localHospital = require("./LocalHospital");
var _localHospitalDefault = parcelHelpers.interopDefault(_localHospital);
var _localHospitalOutlined = require("./LocalHospitalOutlined");
var _localHospitalOutlinedDefault = parcelHelpers.interopDefault(_localHospitalOutlined);
var _localHospitalRounded = require("./LocalHospitalRounded");
var _localHospitalRoundedDefault = parcelHelpers.interopDefault(_localHospitalRounded);
var _localHospitalSharp = require("./LocalHospitalSharp");
var _localHospitalSharpDefault = parcelHelpers.interopDefault(_localHospitalSharp);
var _localHospitalTwoTone = require("./LocalHospitalTwoTone");
var _localHospitalTwoToneDefault = parcelHelpers.interopDefault(_localHospitalTwoTone);
var _localHotel = require("./LocalHotel");
var _localHotelDefault = parcelHelpers.interopDefault(_localHotel);
var _localHotelOutlined = require("./LocalHotelOutlined");
var _localHotelOutlinedDefault = parcelHelpers.interopDefault(_localHotelOutlined);
var _localHotelRounded = require("./LocalHotelRounded");
var _localHotelRoundedDefault = parcelHelpers.interopDefault(_localHotelRounded);
var _localHotelSharp = require("./LocalHotelSharp");
var _localHotelSharpDefault = parcelHelpers.interopDefault(_localHotelSharp);
var _localHotelTwoTone = require("./LocalHotelTwoTone");
var _localHotelTwoToneDefault = parcelHelpers.interopDefault(_localHotelTwoTone);
var _localLaundryService = require("./LocalLaundryService");
var _localLaundryServiceDefault = parcelHelpers.interopDefault(_localLaundryService);
var _localLaundryServiceOutlined = require("./LocalLaundryServiceOutlined");
var _localLaundryServiceOutlinedDefault = parcelHelpers.interopDefault(_localLaundryServiceOutlined);
var _localLaundryServiceRounded = require("./LocalLaundryServiceRounded");
var _localLaundryServiceRoundedDefault = parcelHelpers.interopDefault(_localLaundryServiceRounded);
var _localLaundryServiceSharp = require("./LocalLaundryServiceSharp");
var _localLaundryServiceSharpDefault = parcelHelpers.interopDefault(_localLaundryServiceSharp);
var _localLaundryServiceTwoTone = require("./LocalLaundryServiceTwoTone");
var _localLaundryServiceTwoToneDefault = parcelHelpers.interopDefault(_localLaundryServiceTwoTone);
var _localLibrary = require("./LocalLibrary");
var _localLibraryDefault = parcelHelpers.interopDefault(_localLibrary);
var _localLibraryOutlined = require("./LocalLibraryOutlined");
var _localLibraryOutlinedDefault = parcelHelpers.interopDefault(_localLibraryOutlined);
var _localLibraryRounded = require("./LocalLibraryRounded");
var _localLibraryRoundedDefault = parcelHelpers.interopDefault(_localLibraryRounded);
var _localLibrarySharp = require("./LocalLibrarySharp");
var _localLibrarySharpDefault = parcelHelpers.interopDefault(_localLibrarySharp);
var _localLibraryTwoTone = require("./LocalLibraryTwoTone");
var _localLibraryTwoToneDefault = parcelHelpers.interopDefault(_localLibraryTwoTone);
var _localMall = require("./LocalMall");
var _localMallDefault = parcelHelpers.interopDefault(_localMall);
var _localMallOutlined = require("./LocalMallOutlined");
var _localMallOutlinedDefault = parcelHelpers.interopDefault(_localMallOutlined);
var _localMallRounded = require("./LocalMallRounded");
var _localMallRoundedDefault = parcelHelpers.interopDefault(_localMallRounded);
var _localMallSharp = require("./LocalMallSharp");
var _localMallSharpDefault = parcelHelpers.interopDefault(_localMallSharp);
var _localMallTwoTone = require("./LocalMallTwoTone");
var _localMallTwoToneDefault = parcelHelpers.interopDefault(_localMallTwoTone);
var _localMovies = require("./LocalMovies");
var _localMoviesDefault = parcelHelpers.interopDefault(_localMovies);
var _localMoviesOutlined = require("./LocalMoviesOutlined");
var _localMoviesOutlinedDefault = parcelHelpers.interopDefault(_localMoviesOutlined);
var _localMoviesRounded = require("./LocalMoviesRounded");
var _localMoviesRoundedDefault = parcelHelpers.interopDefault(_localMoviesRounded);
var _localMoviesSharp = require("./LocalMoviesSharp");
var _localMoviesSharpDefault = parcelHelpers.interopDefault(_localMoviesSharp);
var _localMoviesTwoTone = require("./LocalMoviesTwoTone");
var _localMoviesTwoToneDefault = parcelHelpers.interopDefault(_localMoviesTwoTone);
var _localOffer = require("./LocalOffer");
var _localOfferDefault = parcelHelpers.interopDefault(_localOffer);
var _localOfferOutlined = require("./LocalOfferOutlined");
var _localOfferOutlinedDefault = parcelHelpers.interopDefault(_localOfferOutlined);
var _localOfferRounded = require("./LocalOfferRounded");
var _localOfferRoundedDefault = parcelHelpers.interopDefault(_localOfferRounded);
var _localOfferSharp = require("./LocalOfferSharp");
var _localOfferSharpDefault = parcelHelpers.interopDefault(_localOfferSharp);
var _localOfferTwoTone = require("./LocalOfferTwoTone");
var _localOfferTwoToneDefault = parcelHelpers.interopDefault(_localOfferTwoTone);
var _localParking = require("./LocalParking");
var _localParkingDefault = parcelHelpers.interopDefault(_localParking);
var _localParkingOutlined = require("./LocalParkingOutlined");
var _localParkingOutlinedDefault = parcelHelpers.interopDefault(_localParkingOutlined);
var _localParkingRounded = require("./LocalParkingRounded");
var _localParkingRoundedDefault = parcelHelpers.interopDefault(_localParkingRounded);
var _localParkingSharp = require("./LocalParkingSharp");
var _localParkingSharpDefault = parcelHelpers.interopDefault(_localParkingSharp);
var _localParkingTwoTone = require("./LocalParkingTwoTone");
var _localParkingTwoToneDefault = parcelHelpers.interopDefault(_localParkingTwoTone);
var _localPharmacy = require("./LocalPharmacy");
var _localPharmacyDefault = parcelHelpers.interopDefault(_localPharmacy);
var _localPharmacyOutlined = require("./LocalPharmacyOutlined");
var _localPharmacyOutlinedDefault = parcelHelpers.interopDefault(_localPharmacyOutlined);
var _localPharmacyRounded = require("./LocalPharmacyRounded");
var _localPharmacyRoundedDefault = parcelHelpers.interopDefault(_localPharmacyRounded);
var _localPharmacySharp = require("./LocalPharmacySharp");
var _localPharmacySharpDefault = parcelHelpers.interopDefault(_localPharmacySharp);
var _localPharmacyTwoTone = require("./LocalPharmacyTwoTone");
var _localPharmacyTwoToneDefault = parcelHelpers.interopDefault(_localPharmacyTwoTone);
var _localPhone = require("./LocalPhone");
var _localPhoneDefault = parcelHelpers.interopDefault(_localPhone);
var _localPhoneOutlined = require("./LocalPhoneOutlined");
var _localPhoneOutlinedDefault = parcelHelpers.interopDefault(_localPhoneOutlined);
var _localPhoneRounded = require("./LocalPhoneRounded");
var _localPhoneRoundedDefault = parcelHelpers.interopDefault(_localPhoneRounded);
var _localPhoneSharp = require("./LocalPhoneSharp");
var _localPhoneSharpDefault = parcelHelpers.interopDefault(_localPhoneSharp);
var _localPhoneTwoTone = require("./LocalPhoneTwoTone");
var _localPhoneTwoToneDefault = parcelHelpers.interopDefault(_localPhoneTwoTone);
var _localPizza = require("./LocalPizza");
var _localPizzaDefault = parcelHelpers.interopDefault(_localPizza);
var _localPizzaOutlined = require("./LocalPizzaOutlined");
var _localPizzaOutlinedDefault = parcelHelpers.interopDefault(_localPizzaOutlined);
var _localPizzaRounded = require("./LocalPizzaRounded");
var _localPizzaRoundedDefault = parcelHelpers.interopDefault(_localPizzaRounded);
var _localPizzaSharp = require("./LocalPizzaSharp");
var _localPizzaSharpDefault = parcelHelpers.interopDefault(_localPizzaSharp);
var _localPizzaTwoTone = require("./LocalPizzaTwoTone");
var _localPizzaTwoToneDefault = parcelHelpers.interopDefault(_localPizzaTwoTone);
var _localPlay = require("./LocalPlay");
var _localPlayDefault = parcelHelpers.interopDefault(_localPlay);
var _localPlayOutlined = require("./LocalPlayOutlined");
var _localPlayOutlinedDefault = parcelHelpers.interopDefault(_localPlayOutlined);
var _localPlayRounded = require("./LocalPlayRounded");
var _localPlayRoundedDefault = parcelHelpers.interopDefault(_localPlayRounded);
var _localPlaySharp = require("./LocalPlaySharp");
var _localPlaySharpDefault = parcelHelpers.interopDefault(_localPlaySharp);
var _localPlayTwoTone = require("./LocalPlayTwoTone");
var _localPlayTwoToneDefault = parcelHelpers.interopDefault(_localPlayTwoTone);
var _localPolice = require("./LocalPolice");
var _localPoliceDefault = parcelHelpers.interopDefault(_localPolice);
var _localPoliceOutlined = require("./LocalPoliceOutlined");
var _localPoliceOutlinedDefault = parcelHelpers.interopDefault(_localPoliceOutlined);
var _localPoliceRounded = require("./LocalPoliceRounded");
var _localPoliceRoundedDefault = parcelHelpers.interopDefault(_localPoliceRounded);
var _localPoliceSharp = require("./LocalPoliceSharp");
var _localPoliceSharpDefault = parcelHelpers.interopDefault(_localPoliceSharp);
var _localPoliceTwoTone = require("./LocalPoliceTwoTone");
var _localPoliceTwoToneDefault = parcelHelpers.interopDefault(_localPoliceTwoTone);
var _localPostOffice = require("./LocalPostOffice");
var _localPostOfficeDefault = parcelHelpers.interopDefault(_localPostOffice);
var _localPostOfficeOutlined = require("./LocalPostOfficeOutlined");
var _localPostOfficeOutlinedDefault = parcelHelpers.interopDefault(_localPostOfficeOutlined);
var _localPostOfficeRounded = require("./LocalPostOfficeRounded");
var _localPostOfficeRoundedDefault = parcelHelpers.interopDefault(_localPostOfficeRounded);
var _localPostOfficeSharp = require("./LocalPostOfficeSharp");
var _localPostOfficeSharpDefault = parcelHelpers.interopDefault(_localPostOfficeSharp);
var _localPostOfficeTwoTone = require("./LocalPostOfficeTwoTone");
var _localPostOfficeTwoToneDefault = parcelHelpers.interopDefault(_localPostOfficeTwoTone);
var _localPrintshop = require("./LocalPrintshop");
var _localPrintshopDefault = parcelHelpers.interopDefault(_localPrintshop);
var _localPrintshopOutlined = require("./LocalPrintshopOutlined");
var _localPrintshopOutlinedDefault = parcelHelpers.interopDefault(_localPrintshopOutlined);
var _localPrintshopRounded = require("./LocalPrintshopRounded");
var _localPrintshopRoundedDefault = parcelHelpers.interopDefault(_localPrintshopRounded);
var _localPrintshopSharp = require("./LocalPrintshopSharp");
var _localPrintshopSharpDefault = parcelHelpers.interopDefault(_localPrintshopSharp);
var _localPrintshopTwoTone = require("./LocalPrintshopTwoTone");
var _localPrintshopTwoToneDefault = parcelHelpers.interopDefault(_localPrintshopTwoTone);
var _localSee = require("./LocalSee");
var _localSeeDefault = parcelHelpers.interopDefault(_localSee);
var _localSeeOutlined = require("./LocalSeeOutlined");
var _localSeeOutlinedDefault = parcelHelpers.interopDefault(_localSeeOutlined);
var _localSeeRounded = require("./LocalSeeRounded");
var _localSeeRoundedDefault = parcelHelpers.interopDefault(_localSeeRounded);
var _localSeeSharp = require("./LocalSeeSharp");
var _localSeeSharpDefault = parcelHelpers.interopDefault(_localSeeSharp);
var _localSeeTwoTone = require("./LocalSeeTwoTone");
var _localSeeTwoToneDefault = parcelHelpers.interopDefault(_localSeeTwoTone);
var _localShipping = require("./LocalShipping");
var _localShippingDefault = parcelHelpers.interopDefault(_localShipping);
var _localShippingOutlined = require("./LocalShippingOutlined");
var _localShippingOutlinedDefault = parcelHelpers.interopDefault(_localShippingOutlined);
var _localShippingRounded = require("./LocalShippingRounded");
var _localShippingRoundedDefault = parcelHelpers.interopDefault(_localShippingRounded);
var _localShippingSharp = require("./LocalShippingSharp");
var _localShippingSharpDefault = parcelHelpers.interopDefault(_localShippingSharp);
var _localShippingTwoTone = require("./LocalShippingTwoTone");
var _localShippingTwoToneDefault = parcelHelpers.interopDefault(_localShippingTwoTone);
var _localTaxi = require("./LocalTaxi");
var _localTaxiDefault = parcelHelpers.interopDefault(_localTaxi);
var _localTaxiOutlined = require("./LocalTaxiOutlined");
var _localTaxiOutlinedDefault = parcelHelpers.interopDefault(_localTaxiOutlined);
var _localTaxiRounded = require("./LocalTaxiRounded");
var _localTaxiRoundedDefault = parcelHelpers.interopDefault(_localTaxiRounded);
var _localTaxiSharp = require("./LocalTaxiSharp");
var _localTaxiSharpDefault = parcelHelpers.interopDefault(_localTaxiSharp);
var _localTaxiTwoTone = require("./LocalTaxiTwoTone");
var _localTaxiTwoToneDefault = parcelHelpers.interopDefault(_localTaxiTwoTone);
var _locationCity = require("./LocationCity");
var _locationCityDefault = parcelHelpers.interopDefault(_locationCity);
var _locationCityOutlined = require("./LocationCityOutlined");
var _locationCityOutlinedDefault = parcelHelpers.interopDefault(_locationCityOutlined);
var _locationCityRounded = require("./LocationCityRounded");
var _locationCityRoundedDefault = parcelHelpers.interopDefault(_locationCityRounded);
var _locationCitySharp = require("./LocationCitySharp");
var _locationCitySharpDefault = parcelHelpers.interopDefault(_locationCitySharp);
var _locationCityTwoTone = require("./LocationCityTwoTone");
var _locationCityTwoToneDefault = parcelHelpers.interopDefault(_locationCityTwoTone);
var _locationDisabled = require("./LocationDisabled");
var _locationDisabledDefault = parcelHelpers.interopDefault(_locationDisabled);
var _locationDisabledOutlined = require("./LocationDisabledOutlined");
var _locationDisabledOutlinedDefault = parcelHelpers.interopDefault(_locationDisabledOutlined);
var _locationDisabledRounded = require("./LocationDisabledRounded");
var _locationDisabledRoundedDefault = parcelHelpers.interopDefault(_locationDisabledRounded);
var _locationDisabledSharp = require("./LocationDisabledSharp");
var _locationDisabledSharpDefault = parcelHelpers.interopDefault(_locationDisabledSharp);
var _locationDisabledTwoTone = require("./LocationDisabledTwoTone");
var _locationDisabledTwoToneDefault = parcelHelpers.interopDefault(_locationDisabledTwoTone);
var _locationOff = require("./LocationOff");
var _locationOffDefault = parcelHelpers.interopDefault(_locationOff);
var _locationOffOutlined = require("./LocationOffOutlined");
var _locationOffOutlinedDefault = parcelHelpers.interopDefault(_locationOffOutlined);
var _locationOffRounded = require("./LocationOffRounded");
var _locationOffRoundedDefault = parcelHelpers.interopDefault(_locationOffRounded);
var _locationOffSharp = require("./LocationOffSharp");
var _locationOffSharpDefault = parcelHelpers.interopDefault(_locationOffSharp);
var _locationOffTwoTone = require("./LocationOffTwoTone");
var _locationOffTwoToneDefault = parcelHelpers.interopDefault(_locationOffTwoTone);
var _locationOn = require("./LocationOn");
var _locationOnDefault = parcelHelpers.interopDefault(_locationOn);
var _locationOnOutlined = require("./LocationOnOutlined");
var _locationOnOutlinedDefault = parcelHelpers.interopDefault(_locationOnOutlined);
var _locationOnRounded = require("./LocationOnRounded");
var _locationOnRoundedDefault = parcelHelpers.interopDefault(_locationOnRounded);
var _locationOnSharp = require("./LocationOnSharp");
var _locationOnSharpDefault = parcelHelpers.interopDefault(_locationOnSharp);
var _locationOnTwoTone = require("./LocationOnTwoTone");
var _locationOnTwoToneDefault = parcelHelpers.interopDefault(_locationOnTwoTone);
var _locationSearching = require("./LocationSearching");
var _locationSearchingDefault = parcelHelpers.interopDefault(_locationSearching);
var _locationSearchingOutlined = require("./LocationSearchingOutlined");
var _locationSearchingOutlinedDefault = parcelHelpers.interopDefault(_locationSearchingOutlined);
var _locationSearchingRounded = require("./LocationSearchingRounded");
var _locationSearchingRoundedDefault = parcelHelpers.interopDefault(_locationSearchingRounded);
var _locationSearchingSharp = require("./LocationSearchingSharp");
var _locationSearchingSharpDefault = parcelHelpers.interopDefault(_locationSearchingSharp);
var _locationSearchingTwoTone = require("./LocationSearchingTwoTone");
var _locationSearchingTwoToneDefault = parcelHelpers.interopDefault(_locationSearchingTwoTone);
var _lock = require("./Lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _lockClock = require("./LockClock");
var _lockClockDefault = parcelHelpers.interopDefault(_lockClock);
var _lockClockOutlined = require("./LockClockOutlined");
var _lockClockOutlinedDefault = parcelHelpers.interopDefault(_lockClockOutlined);
var _lockClockRounded = require("./LockClockRounded");
var _lockClockRoundedDefault = parcelHelpers.interopDefault(_lockClockRounded);
var _lockClockSharp = require("./LockClockSharp");
var _lockClockSharpDefault = parcelHelpers.interopDefault(_lockClockSharp);
var _lockClockTwoTone = require("./LockClockTwoTone");
var _lockClockTwoToneDefault = parcelHelpers.interopDefault(_lockClockTwoTone);
var _lockOpen = require("./LockOpen");
var _lockOpenDefault = parcelHelpers.interopDefault(_lockOpen);
var _lockOpenOutlined = require("./LockOpenOutlined");
var _lockOpenOutlinedDefault = parcelHelpers.interopDefault(_lockOpenOutlined);
var _lockOpenRounded = require("./LockOpenRounded");
var _lockOpenRoundedDefault = parcelHelpers.interopDefault(_lockOpenRounded);
var _lockOpenSharp = require("./LockOpenSharp");
var _lockOpenSharpDefault = parcelHelpers.interopDefault(_lockOpenSharp);
var _lockOpenTwoTone = require("./LockOpenTwoTone");
var _lockOpenTwoToneDefault = parcelHelpers.interopDefault(_lockOpenTwoTone);
var _lockOutlined = require("./LockOutlined");
var _lockOutlinedDefault = parcelHelpers.interopDefault(_lockOutlined);
var _lockPerson = require("./LockPerson");
var _lockPersonDefault = parcelHelpers.interopDefault(_lockPerson);
var _lockPersonOutlined = require("./LockPersonOutlined");
var _lockPersonOutlinedDefault = parcelHelpers.interopDefault(_lockPersonOutlined);
var _lockPersonRounded = require("./LockPersonRounded");
var _lockPersonRoundedDefault = parcelHelpers.interopDefault(_lockPersonRounded);
var _lockPersonSharp = require("./LockPersonSharp");
var _lockPersonSharpDefault = parcelHelpers.interopDefault(_lockPersonSharp);
var _lockPersonTwoTone = require("./LockPersonTwoTone");
var _lockPersonTwoToneDefault = parcelHelpers.interopDefault(_lockPersonTwoTone);
var _lockReset = require("./LockReset");
var _lockResetDefault = parcelHelpers.interopDefault(_lockReset);
var _lockResetOutlined = require("./LockResetOutlined");
var _lockResetOutlinedDefault = parcelHelpers.interopDefault(_lockResetOutlined);
var _lockResetRounded = require("./LockResetRounded");
var _lockResetRoundedDefault = parcelHelpers.interopDefault(_lockResetRounded);
var _lockResetSharp = require("./LockResetSharp");
var _lockResetSharpDefault = parcelHelpers.interopDefault(_lockResetSharp);
var _lockResetTwoTone = require("./LockResetTwoTone");
var _lockResetTwoToneDefault = parcelHelpers.interopDefault(_lockResetTwoTone);
var _lockRounded = require("./LockRounded");
var _lockRoundedDefault = parcelHelpers.interopDefault(_lockRounded);
var _lockSharp = require("./LockSharp");
var _lockSharpDefault = parcelHelpers.interopDefault(_lockSharp);
var _lockTwoTone = require("./LockTwoTone");
var _lockTwoToneDefault = parcelHelpers.interopDefault(_lockTwoTone);
var _login = require("./Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _loginOutlined = require("./LoginOutlined");
var _loginOutlinedDefault = parcelHelpers.interopDefault(_loginOutlined);
var _loginRounded = require("./LoginRounded");
var _loginRoundedDefault = parcelHelpers.interopDefault(_loginRounded);
var _loginSharp = require("./LoginSharp");
var _loginSharpDefault = parcelHelpers.interopDefault(_loginSharp);
var _loginTwoTone = require("./LoginTwoTone");
var _loginTwoToneDefault = parcelHelpers.interopDefault(_loginTwoTone);
var _logoDev = require("./LogoDev");
var _logoDevDefault = parcelHelpers.interopDefault(_logoDev);
var _logoDevOutlined = require("./LogoDevOutlined");
var _logoDevOutlinedDefault = parcelHelpers.interopDefault(_logoDevOutlined);
var _logoDevRounded = require("./LogoDevRounded");
var _logoDevRoundedDefault = parcelHelpers.interopDefault(_logoDevRounded);
var _logoDevSharp = require("./LogoDevSharp");
var _logoDevSharpDefault = parcelHelpers.interopDefault(_logoDevSharp);
var _logoDevTwoTone = require("./LogoDevTwoTone");
var _logoDevTwoToneDefault = parcelHelpers.interopDefault(_logoDevTwoTone);
var _logout = require("./Logout");
var _logoutDefault = parcelHelpers.interopDefault(_logout);
var _logoutOutlined = require("./LogoutOutlined");
var _logoutOutlinedDefault = parcelHelpers.interopDefault(_logoutOutlined);
var _logoutRounded = require("./LogoutRounded");
var _logoutRoundedDefault = parcelHelpers.interopDefault(_logoutRounded);
var _logoutSharp = require("./LogoutSharp");
var _logoutSharpDefault = parcelHelpers.interopDefault(_logoutSharp);
var _logoutTwoTone = require("./LogoutTwoTone");
var _logoutTwoToneDefault = parcelHelpers.interopDefault(_logoutTwoTone);
var _looks = require("./Looks");
var _looksDefault = parcelHelpers.interopDefault(_looks);
var _looks3 = require("./Looks3");
var _looks3Default = parcelHelpers.interopDefault(_looks3);
var _looks3Outlined = require("./Looks3Outlined");
var _looks3OutlinedDefault = parcelHelpers.interopDefault(_looks3Outlined);
var _looks3Rounded = require("./Looks3Rounded");
var _looks3RoundedDefault = parcelHelpers.interopDefault(_looks3Rounded);
var _looks3Sharp = require("./Looks3Sharp");
var _looks3SharpDefault = parcelHelpers.interopDefault(_looks3Sharp);
var _looks3TwoTone = require("./Looks3TwoTone");
var _looks3TwoToneDefault = parcelHelpers.interopDefault(_looks3TwoTone);
var _looks4 = require("./Looks4");
var _looks4Default = parcelHelpers.interopDefault(_looks4);
var _looks4Outlined = require("./Looks4Outlined");
var _looks4OutlinedDefault = parcelHelpers.interopDefault(_looks4Outlined);
var _looks4Rounded = require("./Looks4Rounded");
var _looks4RoundedDefault = parcelHelpers.interopDefault(_looks4Rounded);
var _looks4Sharp = require("./Looks4Sharp");
var _looks4SharpDefault = parcelHelpers.interopDefault(_looks4Sharp);
var _looks4TwoTone = require("./Looks4TwoTone");
var _looks4TwoToneDefault = parcelHelpers.interopDefault(_looks4TwoTone);
var _looks5 = require("./Looks5");
var _looks5Default = parcelHelpers.interopDefault(_looks5);
var _looks5Outlined = require("./Looks5Outlined");
var _looks5OutlinedDefault = parcelHelpers.interopDefault(_looks5Outlined);
var _looks5Rounded = require("./Looks5Rounded");
var _looks5RoundedDefault = parcelHelpers.interopDefault(_looks5Rounded);
var _looks5Sharp = require("./Looks5Sharp");
var _looks5SharpDefault = parcelHelpers.interopDefault(_looks5Sharp);
var _looks5TwoTone = require("./Looks5TwoTone");
var _looks5TwoToneDefault = parcelHelpers.interopDefault(_looks5TwoTone);
var _looks6 = require("./Looks6");
var _looks6Default = parcelHelpers.interopDefault(_looks6);
var _looks6Outlined = require("./Looks6Outlined");
var _looks6OutlinedDefault = parcelHelpers.interopDefault(_looks6Outlined);
var _looks6Rounded = require("./Looks6Rounded");
var _looks6RoundedDefault = parcelHelpers.interopDefault(_looks6Rounded);
var _looks6Sharp = require("./Looks6Sharp");
var _looks6SharpDefault = parcelHelpers.interopDefault(_looks6Sharp);
var _looks6TwoTone = require("./Looks6TwoTone");
var _looks6TwoToneDefault = parcelHelpers.interopDefault(_looks6TwoTone);
var _looksOne = require("./LooksOne");
var _looksOneDefault = parcelHelpers.interopDefault(_looksOne);
var _looksOneOutlined = require("./LooksOneOutlined");
var _looksOneOutlinedDefault = parcelHelpers.interopDefault(_looksOneOutlined);
var _looksOneRounded = require("./LooksOneRounded");
var _looksOneRoundedDefault = parcelHelpers.interopDefault(_looksOneRounded);
var _looksOneSharp = require("./LooksOneSharp");
var _looksOneSharpDefault = parcelHelpers.interopDefault(_looksOneSharp);
var _looksOneTwoTone = require("./LooksOneTwoTone");
var _looksOneTwoToneDefault = parcelHelpers.interopDefault(_looksOneTwoTone);
var _looksOutlined = require("./LooksOutlined");
var _looksOutlinedDefault = parcelHelpers.interopDefault(_looksOutlined);
var _looksRounded = require("./LooksRounded");
var _looksRoundedDefault = parcelHelpers.interopDefault(_looksRounded);
var _looksSharp = require("./LooksSharp");
var _looksSharpDefault = parcelHelpers.interopDefault(_looksSharp);
var _looksTwo = require("./LooksTwo");
var _looksTwoDefault = parcelHelpers.interopDefault(_looksTwo);
var _looksTwoOutlined = require("./LooksTwoOutlined");
var _looksTwoOutlinedDefault = parcelHelpers.interopDefault(_looksTwoOutlined);
var _looksTwoRounded = require("./LooksTwoRounded");
var _looksTwoRoundedDefault = parcelHelpers.interopDefault(_looksTwoRounded);
var _looksTwoSharp = require("./LooksTwoSharp");
var _looksTwoSharpDefault = parcelHelpers.interopDefault(_looksTwoSharp);
var _looksTwoTone = require("./LooksTwoTone");
var _looksTwoToneDefault = parcelHelpers.interopDefault(_looksTwoTone);
var _looksTwoTwoTone = require("./LooksTwoTwoTone");
var _looksTwoTwoToneDefault = parcelHelpers.interopDefault(_looksTwoTwoTone);
var _loop = require("./Loop");
var _loopDefault = parcelHelpers.interopDefault(_loop);
var _loopOutlined = require("./LoopOutlined");
var _loopOutlinedDefault = parcelHelpers.interopDefault(_loopOutlined);
var _loopRounded = require("./LoopRounded");
var _loopRoundedDefault = parcelHelpers.interopDefault(_loopRounded);
var _loopSharp = require("./LoopSharp");
var _loopSharpDefault = parcelHelpers.interopDefault(_loopSharp);
var _loopTwoTone = require("./LoopTwoTone");
var _loopTwoToneDefault = parcelHelpers.interopDefault(_loopTwoTone);
var _loupe = require("./Loupe");
var _loupeDefault = parcelHelpers.interopDefault(_loupe);
var _loupeOutlined = require("./LoupeOutlined");
var _loupeOutlinedDefault = parcelHelpers.interopDefault(_loupeOutlined);
var _loupeRounded = require("./LoupeRounded");
var _loupeRoundedDefault = parcelHelpers.interopDefault(_loupeRounded);
var _loupeSharp = require("./LoupeSharp");
var _loupeSharpDefault = parcelHelpers.interopDefault(_loupeSharp);
var _loupeTwoTone = require("./LoupeTwoTone");
var _loupeTwoToneDefault = parcelHelpers.interopDefault(_loupeTwoTone);
var _lowPriority = require("./LowPriority");
var _lowPriorityDefault = parcelHelpers.interopDefault(_lowPriority);
var _lowPriorityOutlined = require("./LowPriorityOutlined");
var _lowPriorityOutlinedDefault = parcelHelpers.interopDefault(_lowPriorityOutlined);
var _lowPriorityRounded = require("./LowPriorityRounded");
var _lowPriorityRoundedDefault = parcelHelpers.interopDefault(_lowPriorityRounded);
var _lowPrioritySharp = require("./LowPrioritySharp");
var _lowPrioritySharpDefault = parcelHelpers.interopDefault(_lowPrioritySharp);
var _lowPriorityTwoTone = require("./LowPriorityTwoTone");
var _lowPriorityTwoToneDefault = parcelHelpers.interopDefault(_lowPriorityTwoTone);
var _loyalty = require("./Loyalty");
var _loyaltyDefault = parcelHelpers.interopDefault(_loyalty);
var _loyaltyOutlined = require("./LoyaltyOutlined");
var _loyaltyOutlinedDefault = parcelHelpers.interopDefault(_loyaltyOutlined);
var _loyaltyRounded = require("./LoyaltyRounded");
var _loyaltyRoundedDefault = parcelHelpers.interopDefault(_loyaltyRounded);
var _loyaltySharp = require("./LoyaltySharp");
var _loyaltySharpDefault = parcelHelpers.interopDefault(_loyaltySharp);
var _loyaltyTwoTone = require("./LoyaltyTwoTone");
var _loyaltyTwoToneDefault = parcelHelpers.interopDefault(_loyaltyTwoTone);
var _lteMobiledata = require("./LteMobiledata");
var _lteMobiledataDefault = parcelHelpers.interopDefault(_lteMobiledata);
var _lteMobiledataOutlined = require("./LteMobiledataOutlined");
var _lteMobiledataOutlinedDefault = parcelHelpers.interopDefault(_lteMobiledataOutlined);
var _lteMobiledataRounded = require("./LteMobiledataRounded");
var _lteMobiledataRoundedDefault = parcelHelpers.interopDefault(_lteMobiledataRounded);
var _lteMobiledataSharp = require("./LteMobiledataSharp");
var _lteMobiledataSharpDefault = parcelHelpers.interopDefault(_lteMobiledataSharp);
var _lteMobiledataTwoTone = require("./LteMobiledataTwoTone");
var _lteMobiledataTwoToneDefault = parcelHelpers.interopDefault(_lteMobiledataTwoTone);
var _ltePlusMobiledata = require("./LtePlusMobiledata");
var _ltePlusMobiledataDefault = parcelHelpers.interopDefault(_ltePlusMobiledata);
var _ltePlusMobiledataOutlined = require("./LtePlusMobiledataOutlined");
var _ltePlusMobiledataOutlinedDefault = parcelHelpers.interopDefault(_ltePlusMobiledataOutlined);
var _ltePlusMobiledataRounded = require("./LtePlusMobiledataRounded");
var _ltePlusMobiledataRoundedDefault = parcelHelpers.interopDefault(_ltePlusMobiledataRounded);
var _ltePlusMobiledataSharp = require("./LtePlusMobiledataSharp");
var _ltePlusMobiledataSharpDefault = parcelHelpers.interopDefault(_ltePlusMobiledataSharp);
var _ltePlusMobiledataTwoTone = require("./LtePlusMobiledataTwoTone");
var _ltePlusMobiledataTwoToneDefault = parcelHelpers.interopDefault(_ltePlusMobiledataTwoTone);
var _luggage = require("./Luggage");
var _luggageDefault = parcelHelpers.interopDefault(_luggage);
var _luggageOutlined = require("./LuggageOutlined");
var _luggageOutlinedDefault = parcelHelpers.interopDefault(_luggageOutlined);
var _luggageRounded = require("./LuggageRounded");
var _luggageRoundedDefault = parcelHelpers.interopDefault(_luggageRounded);
var _luggageSharp = require("./LuggageSharp");
var _luggageSharpDefault = parcelHelpers.interopDefault(_luggageSharp);
var _luggageTwoTone = require("./LuggageTwoTone");
var _luggageTwoToneDefault = parcelHelpers.interopDefault(_luggageTwoTone);
var _lunchDining = require("./LunchDining");
var _lunchDiningDefault = parcelHelpers.interopDefault(_lunchDining);
var _lunchDiningOutlined = require("./LunchDiningOutlined");
var _lunchDiningOutlinedDefault = parcelHelpers.interopDefault(_lunchDiningOutlined);
var _lunchDiningRounded = require("./LunchDiningRounded");
var _lunchDiningRoundedDefault = parcelHelpers.interopDefault(_lunchDiningRounded);
var _lunchDiningSharp = require("./LunchDiningSharp");
var _lunchDiningSharpDefault = parcelHelpers.interopDefault(_lunchDiningSharp);
var _lunchDiningTwoTone = require("./LunchDiningTwoTone");
var _lunchDiningTwoToneDefault = parcelHelpers.interopDefault(_lunchDiningTwoTone);
var _lyrics = require("./Lyrics");
var _lyricsDefault = parcelHelpers.interopDefault(_lyrics);
var _lyricsOutlined = require("./LyricsOutlined");
var _lyricsOutlinedDefault = parcelHelpers.interopDefault(_lyricsOutlined);
var _lyricsRounded = require("./LyricsRounded");
var _lyricsRoundedDefault = parcelHelpers.interopDefault(_lyricsRounded);
var _lyricsSharp = require("./LyricsSharp");
var _lyricsSharpDefault = parcelHelpers.interopDefault(_lyricsSharp);
var _lyricsTwoTone = require("./LyricsTwoTone");
var _lyricsTwoToneDefault = parcelHelpers.interopDefault(_lyricsTwoTone);
var _macroOff = require("./MacroOff");
var _macroOffDefault = parcelHelpers.interopDefault(_macroOff);
var _macroOffOutlined = require("./MacroOffOutlined");
var _macroOffOutlinedDefault = parcelHelpers.interopDefault(_macroOffOutlined);
var _macroOffRounded = require("./MacroOffRounded");
var _macroOffRoundedDefault = parcelHelpers.interopDefault(_macroOffRounded);
var _macroOffSharp = require("./MacroOffSharp");
var _macroOffSharpDefault = parcelHelpers.interopDefault(_macroOffSharp);
var _macroOffTwoTone = require("./MacroOffTwoTone");
var _macroOffTwoToneDefault = parcelHelpers.interopDefault(_macroOffTwoTone);
var _mail = require("./Mail");
var _mailDefault = parcelHelpers.interopDefault(_mail);
var _mailLock = require("./MailLock");
var _mailLockDefault = parcelHelpers.interopDefault(_mailLock);
var _mailLockOutlined = require("./MailLockOutlined");
var _mailLockOutlinedDefault = parcelHelpers.interopDefault(_mailLockOutlined);
var _mailLockRounded = require("./MailLockRounded");
var _mailLockRoundedDefault = parcelHelpers.interopDefault(_mailLockRounded);
var _mailLockSharp = require("./MailLockSharp");
var _mailLockSharpDefault = parcelHelpers.interopDefault(_mailLockSharp);
var _mailLockTwoTone = require("./MailLockTwoTone");
var _mailLockTwoToneDefault = parcelHelpers.interopDefault(_mailLockTwoTone);
var _mailOutline = require("./MailOutline");
var _mailOutlineDefault = parcelHelpers.interopDefault(_mailOutline);
var _mailOutlineOutlined = require("./MailOutlineOutlined");
var _mailOutlineOutlinedDefault = parcelHelpers.interopDefault(_mailOutlineOutlined);
var _mailOutlineRounded = require("./MailOutlineRounded");
var _mailOutlineRoundedDefault = parcelHelpers.interopDefault(_mailOutlineRounded);
var _mailOutlineSharp = require("./MailOutlineSharp");
var _mailOutlineSharpDefault = parcelHelpers.interopDefault(_mailOutlineSharp);
var _mailOutlineTwoTone = require("./MailOutlineTwoTone");
var _mailOutlineTwoToneDefault = parcelHelpers.interopDefault(_mailOutlineTwoTone);
var _mailOutlined = require("./MailOutlined");
var _mailOutlinedDefault = parcelHelpers.interopDefault(_mailOutlined);
var _mailRounded = require("./MailRounded");
var _mailRoundedDefault = parcelHelpers.interopDefault(_mailRounded);
var _mailSharp = require("./MailSharp");
var _mailSharpDefault = parcelHelpers.interopDefault(_mailSharp);
var _mailTwoTone = require("./MailTwoTone");
var _mailTwoToneDefault = parcelHelpers.interopDefault(_mailTwoTone);
var _male = require("./Male");
var _maleDefault = parcelHelpers.interopDefault(_male);
var _maleOutlined = require("./MaleOutlined");
var _maleOutlinedDefault = parcelHelpers.interopDefault(_maleOutlined);
var _maleRounded = require("./MaleRounded");
var _maleRoundedDefault = parcelHelpers.interopDefault(_maleRounded);
var _maleSharp = require("./MaleSharp");
var _maleSharpDefault = parcelHelpers.interopDefault(_maleSharp);
var _maleTwoTone = require("./MaleTwoTone");
var _maleTwoToneDefault = parcelHelpers.interopDefault(_maleTwoTone);
var _man = require("./Man");
var _manDefault = parcelHelpers.interopDefault(_man);
var _man2 = require("./Man2");
var _man2Default = parcelHelpers.interopDefault(_man2);
var _man2Outlined = require("./Man2Outlined");
var _man2OutlinedDefault = parcelHelpers.interopDefault(_man2Outlined);
var _man2Rounded = require("./Man2Rounded");
var _man2RoundedDefault = parcelHelpers.interopDefault(_man2Rounded);
var _man2Sharp = require("./Man2Sharp");
var _man2SharpDefault = parcelHelpers.interopDefault(_man2Sharp);
var _man2TwoTone = require("./Man2TwoTone");
var _man2TwoToneDefault = parcelHelpers.interopDefault(_man2TwoTone);
var _man3 = require("./Man3");
var _man3Default = parcelHelpers.interopDefault(_man3);
var _man3Outlined = require("./Man3Outlined");
var _man3OutlinedDefault = parcelHelpers.interopDefault(_man3Outlined);
var _man3Rounded = require("./Man3Rounded");
var _man3RoundedDefault = parcelHelpers.interopDefault(_man3Rounded);
var _man3Sharp = require("./Man3Sharp");
var _man3SharpDefault = parcelHelpers.interopDefault(_man3Sharp);
var _man3TwoTone = require("./Man3TwoTone");
var _man3TwoToneDefault = parcelHelpers.interopDefault(_man3TwoTone);
var _man4 = require("./Man4");
var _man4Default = parcelHelpers.interopDefault(_man4);
var _man4Outlined = require("./Man4Outlined");
var _man4OutlinedDefault = parcelHelpers.interopDefault(_man4Outlined);
var _man4Rounded = require("./Man4Rounded");
var _man4RoundedDefault = parcelHelpers.interopDefault(_man4Rounded);
var _man4Sharp = require("./Man4Sharp");
var _man4SharpDefault = parcelHelpers.interopDefault(_man4Sharp);
var _man4TwoTone = require("./Man4TwoTone");
var _man4TwoToneDefault = parcelHelpers.interopDefault(_man4TwoTone);
var _manOutlined = require("./ManOutlined");
var _manOutlinedDefault = parcelHelpers.interopDefault(_manOutlined);
var _manRounded = require("./ManRounded");
var _manRoundedDefault = parcelHelpers.interopDefault(_manRounded);
var _manSharp = require("./ManSharp");
var _manSharpDefault = parcelHelpers.interopDefault(_manSharp);
var _manTwoTone = require("./ManTwoTone");
var _manTwoToneDefault = parcelHelpers.interopDefault(_manTwoTone);
var _manageAccounts = require("./ManageAccounts");
var _manageAccountsDefault = parcelHelpers.interopDefault(_manageAccounts);
var _manageAccountsOutlined = require("./ManageAccountsOutlined");
var _manageAccountsOutlinedDefault = parcelHelpers.interopDefault(_manageAccountsOutlined);
var _manageAccountsRounded = require("./ManageAccountsRounded");
var _manageAccountsRoundedDefault = parcelHelpers.interopDefault(_manageAccountsRounded);
var _manageAccountsSharp = require("./ManageAccountsSharp");
var _manageAccountsSharpDefault = parcelHelpers.interopDefault(_manageAccountsSharp);
var _manageAccountsTwoTone = require("./ManageAccountsTwoTone");
var _manageAccountsTwoToneDefault = parcelHelpers.interopDefault(_manageAccountsTwoTone);
var _manageHistory = require("./ManageHistory");
var _manageHistoryDefault = parcelHelpers.interopDefault(_manageHistory);
var _manageHistoryOutlined = require("./ManageHistoryOutlined");
var _manageHistoryOutlinedDefault = parcelHelpers.interopDefault(_manageHistoryOutlined);
var _manageHistoryRounded = require("./ManageHistoryRounded");
var _manageHistoryRoundedDefault = parcelHelpers.interopDefault(_manageHistoryRounded);
var _manageHistorySharp = require("./ManageHistorySharp");
var _manageHistorySharpDefault = parcelHelpers.interopDefault(_manageHistorySharp);
var _manageHistoryTwoTone = require("./ManageHistoryTwoTone");
var _manageHistoryTwoToneDefault = parcelHelpers.interopDefault(_manageHistoryTwoTone);
var _manageSearch = require("./ManageSearch");
var _manageSearchDefault = parcelHelpers.interopDefault(_manageSearch);
var _manageSearchOutlined = require("./ManageSearchOutlined");
var _manageSearchOutlinedDefault = parcelHelpers.interopDefault(_manageSearchOutlined);
var _manageSearchRounded = require("./ManageSearchRounded");
var _manageSearchRoundedDefault = parcelHelpers.interopDefault(_manageSearchRounded);
var _manageSearchSharp = require("./ManageSearchSharp");
var _manageSearchSharpDefault = parcelHelpers.interopDefault(_manageSearchSharp);
var _manageSearchTwoTone = require("./ManageSearchTwoTone");
var _manageSearchTwoToneDefault = parcelHelpers.interopDefault(_manageSearchTwoTone);
var _map = require("./Map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _mapOutlined = require("./MapOutlined");
var _mapOutlinedDefault = parcelHelpers.interopDefault(_mapOutlined);
var _mapRounded = require("./MapRounded");
var _mapRoundedDefault = parcelHelpers.interopDefault(_mapRounded);
var _mapSharp = require("./MapSharp");
var _mapSharpDefault = parcelHelpers.interopDefault(_mapSharp);
var _mapTwoTone = require("./MapTwoTone");
var _mapTwoToneDefault = parcelHelpers.interopDefault(_mapTwoTone);
var _mapsHomeWork = require("./MapsHomeWork");
var _mapsHomeWorkDefault = parcelHelpers.interopDefault(_mapsHomeWork);
var _mapsHomeWorkOutlined = require("./MapsHomeWorkOutlined");
var _mapsHomeWorkOutlinedDefault = parcelHelpers.interopDefault(_mapsHomeWorkOutlined);
var _mapsHomeWorkRounded = require("./MapsHomeWorkRounded");
var _mapsHomeWorkRoundedDefault = parcelHelpers.interopDefault(_mapsHomeWorkRounded);
var _mapsHomeWorkSharp = require("./MapsHomeWorkSharp");
var _mapsHomeWorkSharpDefault = parcelHelpers.interopDefault(_mapsHomeWorkSharp);
var _mapsHomeWorkTwoTone = require("./MapsHomeWorkTwoTone");
var _mapsHomeWorkTwoToneDefault = parcelHelpers.interopDefault(_mapsHomeWorkTwoTone);
var _mapsUgc = require("./MapsUgc");
var _mapsUgcDefault = parcelHelpers.interopDefault(_mapsUgc);
var _mapsUgcOutlined = require("./MapsUgcOutlined");
var _mapsUgcOutlinedDefault = parcelHelpers.interopDefault(_mapsUgcOutlined);
var _mapsUgcRounded = require("./MapsUgcRounded");
var _mapsUgcRoundedDefault = parcelHelpers.interopDefault(_mapsUgcRounded);
var _mapsUgcSharp = require("./MapsUgcSharp");
var _mapsUgcSharpDefault = parcelHelpers.interopDefault(_mapsUgcSharp);
var _mapsUgcTwoTone = require("./MapsUgcTwoTone");
var _mapsUgcTwoToneDefault = parcelHelpers.interopDefault(_mapsUgcTwoTone);
var _margin = require("./Margin");
var _marginDefault = parcelHelpers.interopDefault(_margin);
var _marginOutlined = require("./MarginOutlined");
var _marginOutlinedDefault = parcelHelpers.interopDefault(_marginOutlined);
var _marginRounded = require("./MarginRounded");
var _marginRoundedDefault = parcelHelpers.interopDefault(_marginRounded);
var _marginSharp = require("./MarginSharp");
var _marginSharpDefault = parcelHelpers.interopDefault(_marginSharp);
var _marginTwoTone = require("./MarginTwoTone");
var _marginTwoToneDefault = parcelHelpers.interopDefault(_marginTwoTone);
var _markAsUnread = require("./MarkAsUnread");
var _markAsUnreadDefault = parcelHelpers.interopDefault(_markAsUnread);
var _markAsUnreadOutlined = require("./MarkAsUnreadOutlined");
var _markAsUnreadOutlinedDefault = parcelHelpers.interopDefault(_markAsUnreadOutlined);
var _markAsUnreadRounded = require("./MarkAsUnreadRounded");
var _markAsUnreadRoundedDefault = parcelHelpers.interopDefault(_markAsUnreadRounded);
var _markAsUnreadSharp = require("./MarkAsUnreadSharp");
var _markAsUnreadSharpDefault = parcelHelpers.interopDefault(_markAsUnreadSharp);
var _markAsUnreadTwoTone = require("./MarkAsUnreadTwoTone");
var _markAsUnreadTwoToneDefault = parcelHelpers.interopDefault(_markAsUnreadTwoTone);
var _markChatRead = require("./MarkChatRead");
var _markChatReadDefault = parcelHelpers.interopDefault(_markChatRead);
var _markChatReadOutlined = require("./MarkChatReadOutlined");
var _markChatReadOutlinedDefault = parcelHelpers.interopDefault(_markChatReadOutlined);
var _markChatReadRounded = require("./MarkChatReadRounded");
var _markChatReadRoundedDefault = parcelHelpers.interopDefault(_markChatReadRounded);
var _markChatReadSharp = require("./MarkChatReadSharp");
var _markChatReadSharpDefault = parcelHelpers.interopDefault(_markChatReadSharp);
var _markChatReadTwoTone = require("./MarkChatReadTwoTone");
var _markChatReadTwoToneDefault = parcelHelpers.interopDefault(_markChatReadTwoTone);
var _markChatUnread = require("./MarkChatUnread");
var _markChatUnreadDefault = parcelHelpers.interopDefault(_markChatUnread);
var _markChatUnreadOutlined = require("./MarkChatUnreadOutlined");
var _markChatUnreadOutlinedDefault = parcelHelpers.interopDefault(_markChatUnreadOutlined);
var _markChatUnreadRounded = require("./MarkChatUnreadRounded");
var _markChatUnreadRoundedDefault = parcelHelpers.interopDefault(_markChatUnreadRounded);
var _markChatUnreadSharp = require("./MarkChatUnreadSharp");
var _markChatUnreadSharpDefault = parcelHelpers.interopDefault(_markChatUnreadSharp);
var _markChatUnreadTwoTone = require("./MarkChatUnreadTwoTone");
var _markChatUnreadTwoToneDefault = parcelHelpers.interopDefault(_markChatUnreadTwoTone);
var _markEmailRead = require("./MarkEmailRead");
var _markEmailReadDefault = parcelHelpers.interopDefault(_markEmailRead);
var _markEmailReadOutlined = require("./MarkEmailReadOutlined");
var _markEmailReadOutlinedDefault = parcelHelpers.interopDefault(_markEmailReadOutlined);
var _markEmailReadRounded = require("./MarkEmailReadRounded");
var _markEmailReadRoundedDefault = parcelHelpers.interopDefault(_markEmailReadRounded);
var _markEmailReadSharp = require("./MarkEmailReadSharp");
var _markEmailReadSharpDefault = parcelHelpers.interopDefault(_markEmailReadSharp);
var _markEmailReadTwoTone = require("./MarkEmailReadTwoTone");
var _markEmailReadTwoToneDefault = parcelHelpers.interopDefault(_markEmailReadTwoTone);
var _markEmailUnread = require("./MarkEmailUnread");
var _markEmailUnreadDefault = parcelHelpers.interopDefault(_markEmailUnread);
var _markEmailUnreadOutlined = require("./MarkEmailUnreadOutlined");
var _markEmailUnreadOutlinedDefault = parcelHelpers.interopDefault(_markEmailUnreadOutlined);
var _markEmailUnreadRounded = require("./MarkEmailUnreadRounded");
var _markEmailUnreadRoundedDefault = parcelHelpers.interopDefault(_markEmailUnreadRounded);
var _markEmailUnreadSharp = require("./MarkEmailUnreadSharp");
var _markEmailUnreadSharpDefault = parcelHelpers.interopDefault(_markEmailUnreadSharp);
var _markEmailUnreadTwoTone = require("./MarkEmailUnreadTwoTone");
var _markEmailUnreadTwoToneDefault = parcelHelpers.interopDefault(_markEmailUnreadTwoTone);
var _markUnreadChatAlt = require("./MarkUnreadChatAlt");
var _markUnreadChatAltDefault = parcelHelpers.interopDefault(_markUnreadChatAlt);
var _markUnreadChatAltOutlined = require("./MarkUnreadChatAltOutlined");
var _markUnreadChatAltOutlinedDefault = parcelHelpers.interopDefault(_markUnreadChatAltOutlined);
var _markUnreadChatAltRounded = require("./MarkUnreadChatAltRounded");
var _markUnreadChatAltRoundedDefault = parcelHelpers.interopDefault(_markUnreadChatAltRounded);
var _markUnreadChatAltSharp = require("./MarkUnreadChatAltSharp");
var _markUnreadChatAltSharpDefault = parcelHelpers.interopDefault(_markUnreadChatAltSharp);
var _markUnreadChatAltTwoTone = require("./MarkUnreadChatAltTwoTone");
var _markUnreadChatAltTwoToneDefault = parcelHelpers.interopDefault(_markUnreadChatAltTwoTone);
var _markunread = require("./Markunread");
var _markunreadDefault = parcelHelpers.interopDefault(_markunread);
var _markunreadMailbox = require("./MarkunreadMailbox");
var _markunreadMailboxDefault = parcelHelpers.interopDefault(_markunreadMailbox);
var _markunreadMailboxOutlined = require("./MarkunreadMailboxOutlined");
var _markunreadMailboxOutlinedDefault = parcelHelpers.interopDefault(_markunreadMailboxOutlined);
var _markunreadMailboxRounded = require("./MarkunreadMailboxRounded");
var _markunreadMailboxRoundedDefault = parcelHelpers.interopDefault(_markunreadMailboxRounded);
var _markunreadMailboxSharp = require("./MarkunreadMailboxSharp");
var _markunreadMailboxSharpDefault = parcelHelpers.interopDefault(_markunreadMailboxSharp);
var _markunreadMailboxTwoTone = require("./MarkunreadMailboxTwoTone");
var _markunreadMailboxTwoToneDefault = parcelHelpers.interopDefault(_markunreadMailboxTwoTone);
var _markunreadOutlined = require("./MarkunreadOutlined");
var _markunreadOutlinedDefault = parcelHelpers.interopDefault(_markunreadOutlined);
var _markunreadRounded = require("./MarkunreadRounded");
var _markunreadRoundedDefault = parcelHelpers.interopDefault(_markunreadRounded);
var _markunreadSharp = require("./MarkunreadSharp");
var _markunreadSharpDefault = parcelHelpers.interopDefault(_markunreadSharp);
var _markunreadTwoTone = require("./MarkunreadTwoTone");
var _markunreadTwoToneDefault = parcelHelpers.interopDefault(_markunreadTwoTone);
var _masks = require("./Masks");
var _masksDefault = parcelHelpers.interopDefault(_masks);
var _masksOutlined = require("./MasksOutlined");
var _masksOutlinedDefault = parcelHelpers.interopDefault(_masksOutlined);
var _masksRounded = require("./MasksRounded");
var _masksRoundedDefault = parcelHelpers.interopDefault(_masksRounded);
var _masksSharp = require("./MasksSharp");
var _masksSharpDefault = parcelHelpers.interopDefault(_masksSharp);
var _masksTwoTone = require("./MasksTwoTone");
var _masksTwoToneDefault = parcelHelpers.interopDefault(_masksTwoTone);
var _maximize = require("./Maximize");
var _maximizeDefault = parcelHelpers.interopDefault(_maximize);
var _maximizeOutlined = require("./MaximizeOutlined");
var _maximizeOutlinedDefault = parcelHelpers.interopDefault(_maximizeOutlined);
var _maximizeRounded = require("./MaximizeRounded");
var _maximizeRoundedDefault = parcelHelpers.interopDefault(_maximizeRounded);
var _maximizeSharp = require("./MaximizeSharp");
var _maximizeSharpDefault = parcelHelpers.interopDefault(_maximizeSharp);
var _maximizeTwoTone = require("./MaximizeTwoTone");
var _maximizeTwoToneDefault = parcelHelpers.interopDefault(_maximizeTwoTone);
var _mediaBluetoothOff = require("./MediaBluetoothOff");
var _mediaBluetoothOffDefault = parcelHelpers.interopDefault(_mediaBluetoothOff);
var _mediaBluetoothOffOutlined = require("./MediaBluetoothOffOutlined");
var _mediaBluetoothOffOutlinedDefault = parcelHelpers.interopDefault(_mediaBluetoothOffOutlined);
var _mediaBluetoothOffRounded = require("./MediaBluetoothOffRounded");
var _mediaBluetoothOffRoundedDefault = parcelHelpers.interopDefault(_mediaBluetoothOffRounded);
var _mediaBluetoothOffSharp = require("./MediaBluetoothOffSharp");
var _mediaBluetoothOffSharpDefault = parcelHelpers.interopDefault(_mediaBluetoothOffSharp);
var _mediaBluetoothOffTwoTone = require("./MediaBluetoothOffTwoTone");
var _mediaBluetoothOffTwoToneDefault = parcelHelpers.interopDefault(_mediaBluetoothOffTwoTone);
var _mediaBluetoothOn = require("./MediaBluetoothOn");
var _mediaBluetoothOnDefault = parcelHelpers.interopDefault(_mediaBluetoothOn);
var _mediaBluetoothOnOutlined = require("./MediaBluetoothOnOutlined");
var _mediaBluetoothOnOutlinedDefault = parcelHelpers.interopDefault(_mediaBluetoothOnOutlined);
var _mediaBluetoothOnRounded = require("./MediaBluetoothOnRounded");
var _mediaBluetoothOnRoundedDefault = parcelHelpers.interopDefault(_mediaBluetoothOnRounded);
var _mediaBluetoothOnSharp = require("./MediaBluetoothOnSharp");
var _mediaBluetoothOnSharpDefault = parcelHelpers.interopDefault(_mediaBluetoothOnSharp);
var _mediaBluetoothOnTwoTone = require("./MediaBluetoothOnTwoTone");
var _mediaBluetoothOnTwoToneDefault = parcelHelpers.interopDefault(_mediaBluetoothOnTwoTone);
var _mediation = require("./Mediation");
var _mediationDefault = parcelHelpers.interopDefault(_mediation);
var _mediationOutlined = require("./MediationOutlined");
var _mediationOutlinedDefault = parcelHelpers.interopDefault(_mediationOutlined);
var _mediationRounded = require("./MediationRounded");
var _mediationRoundedDefault = parcelHelpers.interopDefault(_mediationRounded);
var _mediationSharp = require("./MediationSharp");
var _mediationSharpDefault = parcelHelpers.interopDefault(_mediationSharp);
var _mediationTwoTone = require("./MediationTwoTone");
var _mediationTwoToneDefault = parcelHelpers.interopDefault(_mediationTwoTone);
var _medicalInformation = require("./MedicalInformation");
var _medicalInformationDefault = parcelHelpers.interopDefault(_medicalInformation);
var _medicalInformationOutlined = require("./MedicalInformationOutlined");
var _medicalInformationOutlinedDefault = parcelHelpers.interopDefault(_medicalInformationOutlined);
var _medicalInformationRounded = require("./MedicalInformationRounded");
var _medicalInformationRoundedDefault = parcelHelpers.interopDefault(_medicalInformationRounded);
var _medicalInformationSharp = require("./MedicalInformationSharp");
var _medicalInformationSharpDefault = parcelHelpers.interopDefault(_medicalInformationSharp);
var _medicalInformationTwoTone = require("./MedicalInformationTwoTone");
var _medicalInformationTwoToneDefault = parcelHelpers.interopDefault(_medicalInformationTwoTone);
var _medicalServices = require("./MedicalServices");
var _medicalServicesDefault = parcelHelpers.interopDefault(_medicalServices);
var _medicalServicesOutlined = require("./MedicalServicesOutlined");
var _medicalServicesOutlinedDefault = parcelHelpers.interopDefault(_medicalServicesOutlined);
var _medicalServicesRounded = require("./MedicalServicesRounded");
var _medicalServicesRoundedDefault = parcelHelpers.interopDefault(_medicalServicesRounded);
var _medicalServicesSharp = require("./MedicalServicesSharp");
var _medicalServicesSharpDefault = parcelHelpers.interopDefault(_medicalServicesSharp);
var _medicalServicesTwoTone = require("./MedicalServicesTwoTone");
var _medicalServicesTwoToneDefault = parcelHelpers.interopDefault(_medicalServicesTwoTone);
var _medication = require("./Medication");
var _medicationDefault = parcelHelpers.interopDefault(_medication);
var _medicationLiquid = require("./MedicationLiquid");
var _medicationLiquidDefault = parcelHelpers.interopDefault(_medicationLiquid);
var _medicationLiquidOutlined = require("./MedicationLiquidOutlined");
var _medicationLiquidOutlinedDefault = parcelHelpers.interopDefault(_medicationLiquidOutlined);
var _medicationLiquidRounded = require("./MedicationLiquidRounded");
var _medicationLiquidRoundedDefault = parcelHelpers.interopDefault(_medicationLiquidRounded);
var _medicationLiquidSharp = require("./MedicationLiquidSharp");
var _medicationLiquidSharpDefault = parcelHelpers.interopDefault(_medicationLiquidSharp);
var _medicationLiquidTwoTone = require("./MedicationLiquidTwoTone");
var _medicationLiquidTwoToneDefault = parcelHelpers.interopDefault(_medicationLiquidTwoTone);
var _medicationOutlined = require("./MedicationOutlined");
var _medicationOutlinedDefault = parcelHelpers.interopDefault(_medicationOutlined);
var _medicationRounded = require("./MedicationRounded");
var _medicationRoundedDefault = parcelHelpers.interopDefault(_medicationRounded);
var _medicationSharp = require("./MedicationSharp");
var _medicationSharpDefault = parcelHelpers.interopDefault(_medicationSharp);
var _medicationTwoTone = require("./MedicationTwoTone");
var _medicationTwoToneDefault = parcelHelpers.interopDefault(_medicationTwoTone);
var _meetingRoom = require("./MeetingRoom");
var _meetingRoomDefault = parcelHelpers.interopDefault(_meetingRoom);
var _meetingRoomOutlined = require("./MeetingRoomOutlined");
var _meetingRoomOutlinedDefault = parcelHelpers.interopDefault(_meetingRoomOutlined);
var _meetingRoomRounded = require("./MeetingRoomRounded");
var _meetingRoomRoundedDefault = parcelHelpers.interopDefault(_meetingRoomRounded);
var _meetingRoomSharp = require("./MeetingRoomSharp");
var _meetingRoomSharpDefault = parcelHelpers.interopDefault(_meetingRoomSharp);
var _meetingRoomTwoTone = require("./MeetingRoomTwoTone");
var _meetingRoomTwoToneDefault = parcelHelpers.interopDefault(_meetingRoomTwoTone);
var _memory = require("./Memory");
var _memoryDefault = parcelHelpers.interopDefault(_memory);
var _memoryOutlined = require("./MemoryOutlined");
var _memoryOutlinedDefault = parcelHelpers.interopDefault(_memoryOutlined);
var _memoryRounded = require("./MemoryRounded");
var _memoryRoundedDefault = parcelHelpers.interopDefault(_memoryRounded);
var _memorySharp = require("./MemorySharp");
var _memorySharpDefault = parcelHelpers.interopDefault(_memorySharp);
var _memoryTwoTone = require("./MemoryTwoTone");
var _memoryTwoToneDefault = parcelHelpers.interopDefault(_memoryTwoTone);
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuBook = require("./MenuBook");
var _menuBookDefault = parcelHelpers.interopDefault(_menuBook);
var _menuBookOutlined = require("./MenuBookOutlined");
var _menuBookOutlinedDefault = parcelHelpers.interopDefault(_menuBookOutlined);
var _menuBookRounded = require("./MenuBookRounded");
var _menuBookRoundedDefault = parcelHelpers.interopDefault(_menuBookRounded);
var _menuBookSharp = require("./MenuBookSharp");
var _menuBookSharpDefault = parcelHelpers.interopDefault(_menuBookSharp);
var _menuBookTwoTone = require("./MenuBookTwoTone");
var _menuBookTwoToneDefault = parcelHelpers.interopDefault(_menuBookTwoTone);
var _menuOpen = require("./MenuOpen");
var _menuOpenDefault = parcelHelpers.interopDefault(_menuOpen);
var _menuOpenOutlined = require("./MenuOpenOutlined");
var _menuOpenOutlinedDefault = parcelHelpers.interopDefault(_menuOpenOutlined);
var _menuOpenRounded = require("./MenuOpenRounded");
var _menuOpenRoundedDefault = parcelHelpers.interopDefault(_menuOpenRounded);
var _menuOpenSharp = require("./MenuOpenSharp");
var _menuOpenSharpDefault = parcelHelpers.interopDefault(_menuOpenSharp);
var _menuOpenTwoTone = require("./MenuOpenTwoTone");
var _menuOpenTwoToneDefault = parcelHelpers.interopDefault(_menuOpenTwoTone);
var _menuOutlined = require("./MenuOutlined");
var _menuOutlinedDefault = parcelHelpers.interopDefault(_menuOutlined);
var _menuRounded = require("./MenuRounded");
var _menuRoundedDefault = parcelHelpers.interopDefault(_menuRounded);
var _menuSharp = require("./MenuSharp");
var _menuSharpDefault = parcelHelpers.interopDefault(_menuSharp);
var _menuTwoTone = require("./MenuTwoTone");
var _menuTwoToneDefault = parcelHelpers.interopDefault(_menuTwoTone);
var _merge = require("./Merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _mergeOutlined = require("./MergeOutlined");
var _mergeOutlinedDefault = parcelHelpers.interopDefault(_mergeOutlined);
var _mergeRounded = require("./MergeRounded");
var _mergeRoundedDefault = parcelHelpers.interopDefault(_mergeRounded);
var _mergeSharp = require("./MergeSharp");
var _mergeSharpDefault = parcelHelpers.interopDefault(_mergeSharp);
var _mergeTwoTone = require("./MergeTwoTone");
var _mergeTwoToneDefault = parcelHelpers.interopDefault(_mergeTwoTone);
var _mergeType = require("./MergeType");
var _mergeTypeDefault = parcelHelpers.interopDefault(_mergeType);
var _mergeTypeOutlined = require("./MergeTypeOutlined");
var _mergeTypeOutlinedDefault = parcelHelpers.interopDefault(_mergeTypeOutlined);
var _mergeTypeRounded = require("./MergeTypeRounded");
var _mergeTypeRoundedDefault = parcelHelpers.interopDefault(_mergeTypeRounded);
var _mergeTypeSharp = require("./MergeTypeSharp");
var _mergeTypeSharpDefault = parcelHelpers.interopDefault(_mergeTypeSharp);
var _mergeTypeTwoTone = require("./MergeTypeTwoTone");
var _mergeTypeTwoToneDefault = parcelHelpers.interopDefault(_mergeTypeTwoTone);
var _message = require("./Message");
var _messageDefault = parcelHelpers.interopDefault(_message);
var _messageOutlined = require("./MessageOutlined");
var _messageOutlinedDefault = parcelHelpers.interopDefault(_messageOutlined);
var _messageRounded = require("./MessageRounded");
var _messageRoundedDefault = parcelHelpers.interopDefault(_messageRounded);
var _messageSharp = require("./MessageSharp");
var _messageSharpDefault = parcelHelpers.interopDefault(_messageSharp);
var _messageTwoTone = require("./MessageTwoTone");
var _messageTwoToneDefault = parcelHelpers.interopDefault(_messageTwoTone);
var _mic = require("./Mic");
var _micDefault = parcelHelpers.interopDefault(_mic);
var _micExternalOff = require("./MicExternalOff");
var _micExternalOffDefault = parcelHelpers.interopDefault(_micExternalOff);
var _micExternalOffOutlined = require("./MicExternalOffOutlined");
var _micExternalOffOutlinedDefault = parcelHelpers.interopDefault(_micExternalOffOutlined);
var _micExternalOffRounded = require("./MicExternalOffRounded");
var _micExternalOffRoundedDefault = parcelHelpers.interopDefault(_micExternalOffRounded);
var _micExternalOffSharp = require("./MicExternalOffSharp");
var _micExternalOffSharpDefault = parcelHelpers.interopDefault(_micExternalOffSharp);
var _micExternalOffTwoTone = require("./MicExternalOffTwoTone");
var _micExternalOffTwoToneDefault = parcelHelpers.interopDefault(_micExternalOffTwoTone);
var _micExternalOn = require("./MicExternalOn");
var _micExternalOnDefault = parcelHelpers.interopDefault(_micExternalOn);
var _micExternalOnOutlined = require("./MicExternalOnOutlined");
var _micExternalOnOutlinedDefault = parcelHelpers.interopDefault(_micExternalOnOutlined);
var _micExternalOnRounded = require("./MicExternalOnRounded");
var _micExternalOnRoundedDefault = parcelHelpers.interopDefault(_micExternalOnRounded);
var _micExternalOnSharp = require("./MicExternalOnSharp");
var _micExternalOnSharpDefault = parcelHelpers.interopDefault(_micExternalOnSharp);
var _micExternalOnTwoTone = require("./MicExternalOnTwoTone");
var _micExternalOnTwoToneDefault = parcelHelpers.interopDefault(_micExternalOnTwoTone);
var _micNone = require("./MicNone");
var _micNoneDefault = parcelHelpers.interopDefault(_micNone);
var _micNoneOutlined = require("./MicNoneOutlined");
var _micNoneOutlinedDefault = parcelHelpers.interopDefault(_micNoneOutlined);
var _micNoneRounded = require("./MicNoneRounded");
var _micNoneRoundedDefault = parcelHelpers.interopDefault(_micNoneRounded);
var _micNoneSharp = require("./MicNoneSharp");
var _micNoneSharpDefault = parcelHelpers.interopDefault(_micNoneSharp);
var _micNoneTwoTone = require("./MicNoneTwoTone");
var _micNoneTwoToneDefault = parcelHelpers.interopDefault(_micNoneTwoTone);
var _micOff = require("./MicOff");
var _micOffDefault = parcelHelpers.interopDefault(_micOff);
var _micOffOutlined = require("./MicOffOutlined");
var _micOffOutlinedDefault = parcelHelpers.interopDefault(_micOffOutlined);
var _micOffRounded = require("./MicOffRounded");
var _micOffRoundedDefault = parcelHelpers.interopDefault(_micOffRounded);
var _micOffSharp = require("./MicOffSharp");
var _micOffSharpDefault = parcelHelpers.interopDefault(_micOffSharp);
var _micOffTwoTone = require("./MicOffTwoTone");
var _micOffTwoToneDefault = parcelHelpers.interopDefault(_micOffTwoTone);
var _micOutlined = require("./MicOutlined");
var _micOutlinedDefault = parcelHelpers.interopDefault(_micOutlined);
var _micRounded = require("./MicRounded");
var _micRoundedDefault = parcelHelpers.interopDefault(_micRounded);
var _micSharp = require("./MicSharp");
var _micSharpDefault = parcelHelpers.interopDefault(_micSharp);
var _micTwoTone = require("./MicTwoTone");
var _micTwoToneDefault = parcelHelpers.interopDefault(_micTwoTone);
var _microsoft = require("./Microsoft");
var _microsoftDefault = parcelHelpers.interopDefault(_microsoft);
var _microwave = require("./Microwave");
var _microwaveDefault = parcelHelpers.interopDefault(_microwave);
var _microwaveOutlined = require("./MicrowaveOutlined");
var _microwaveOutlinedDefault = parcelHelpers.interopDefault(_microwaveOutlined);
var _microwaveRounded = require("./MicrowaveRounded");
var _microwaveRoundedDefault = parcelHelpers.interopDefault(_microwaveRounded);
var _microwaveSharp = require("./MicrowaveSharp");
var _microwaveSharpDefault = parcelHelpers.interopDefault(_microwaveSharp);
var _microwaveTwoTone = require("./MicrowaveTwoTone");
var _microwaveTwoToneDefault = parcelHelpers.interopDefault(_microwaveTwoTone);
var _militaryTech = require("./MilitaryTech");
var _militaryTechDefault = parcelHelpers.interopDefault(_militaryTech);
var _militaryTechOutlined = require("./MilitaryTechOutlined");
var _militaryTechOutlinedDefault = parcelHelpers.interopDefault(_militaryTechOutlined);
var _militaryTechRounded = require("./MilitaryTechRounded");
var _militaryTechRoundedDefault = parcelHelpers.interopDefault(_militaryTechRounded);
var _militaryTechSharp = require("./MilitaryTechSharp");
var _militaryTechSharpDefault = parcelHelpers.interopDefault(_militaryTechSharp);
var _militaryTechTwoTone = require("./MilitaryTechTwoTone");
var _militaryTechTwoToneDefault = parcelHelpers.interopDefault(_militaryTechTwoTone);
var _minimize = require("./Minimize");
var _minimizeDefault = parcelHelpers.interopDefault(_minimize);
var _minimizeOutlined = require("./MinimizeOutlined");
var _minimizeOutlinedDefault = parcelHelpers.interopDefault(_minimizeOutlined);
var _minimizeRounded = require("./MinimizeRounded");
var _minimizeRoundedDefault = parcelHelpers.interopDefault(_minimizeRounded);
var _minimizeSharp = require("./MinimizeSharp");
var _minimizeSharpDefault = parcelHelpers.interopDefault(_minimizeSharp);
var _minimizeTwoTone = require("./MinimizeTwoTone");
var _minimizeTwoToneDefault = parcelHelpers.interopDefault(_minimizeTwoTone);
var _minorCrash = require("./MinorCrash");
var _minorCrashDefault = parcelHelpers.interopDefault(_minorCrash);
var _minorCrashOutlined = require("./MinorCrashOutlined");
var _minorCrashOutlinedDefault = parcelHelpers.interopDefault(_minorCrashOutlined);
var _minorCrashRounded = require("./MinorCrashRounded");
var _minorCrashRoundedDefault = parcelHelpers.interopDefault(_minorCrashRounded);
var _minorCrashSharp = require("./MinorCrashSharp");
var _minorCrashSharpDefault = parcelHelpers.interopDefault(_minorCrashSharp);
var _minorCrashTwoTone = require("./MinorCrashTwoTone");
var _minorCrashTwoToneDefault = parcelHelpers.interopDefault(_minorCrashTwoTone);
var _miscellaneousServices = require("./MiscellaneousServices");
var _miscellaneousServicesDefault = parcelHelpers.interopDefault(_miscellaneousServices);
var _miscellaneousServicesOutlined = require("./MiscellaneousServicesOutlined");
var _miscellaneousServicesOutlinedDefault = parcelHelpers.interopDefault(_miscellaneousServicesOutlined);
var _miscellaneousServicesRounded = require("./MiscellaneousServicesRounded");
var _miscellaneousServicesRoundedDefault = parcelHelpers.interopDefault(_miscellaneousServicesRounded);
var _miscellaneousServicesSharp = require("./MiscellaneousServicesSharp");
var _miscellaneousServicesSharpDefault = parcelHelpers.interopDefault(_miscellaneousServicesSharp);
var _miscellaneousServicesTwoTone = require("./MiscellaneousServicesTwoTone");
var _miscellaneousServicesTwoToneDefault = parcelHelpers.interopDefault(_miscellaneousServicesTwoTone);
var _missedVideoCall = require("./MissedVideoCall");
var _missedVideoCallDefault = parcelHelpers.interopDefault(_missedVideoCall);
var _missedVideoCallOutlined = require("./MissedVideoCallOutlined");
var _missedVideoCallOutlinedDefault = parcelHelpers.interopDefault(_missedVideoCallOutlined);
var _missedVideoCallRounded = require("./MissedVideoCallRounded");
var _missedVideoCallRoundedDefault = parcelHelpers.interopDefault(_missedVideoCallRounded);
var _missedVideoCallSharp = require("./MissedVideoCallSharp");
var _missedVideoCallSharpDefault = parcelHelpers.interopDefault(_missedVideoCallSharp);
var _missedVideoCallTwoTone = require("./MissedVideoCallTwoTone");
var _missedVideoCallTwoToneDefault = parcelHelpers.interopDefault(_missedVideoCallTwoTone);
var _mms = require("./Mms");
var _mmsDefault = parcelHelpers.interopDefault(_mms);
var _mmsOutlined = require("./MmsOutlined");
var _mmsOutlinedDefault = parcelHelpers.interopDefault(_mmsOutlined);
var _mmsRounded = require("./MmsRounded");
var _mmsRoundedDefault = parcelHelpers.interopDefault(_mmsRounded);
var _mmsSharp = require("./MmsSharp");
var _mmsSharpDefault = parcelHelpers.interopDefault(_mmsSharp);
var _mmsTwoTone = require("./MmsTwoTone");
var _mmsTwoToneDefault = parcelHelpers.interopDefault(_mmsTwoTone);
var _mobileFriendly = require("./MobileFriendly");
var _mobileFriendlyDefault = parcelHelpers.interopDefault(_mobileFriendly);
var _mobileFriendlyOutlined = require("./MobileFriendlyOutlined");
var _mobileFriendlyOutlinedDefault = parcelHelpers.interopDefault(_mobileFriendlyOutlined);
var _mobileFriendlyRounded = require("./MobileFriendlyRounded");
var _mobileFriendlyRoundedDefault = parcelHelpers.interopDefault(_mobileFriendlyRounded);
var _mobileFriendlySharp = require("./MobileFriendlySharp");
var _mobileFriendlySharpDefault = parcelHelpers.interopDefault(_mobileFriendlySharp);
var _mobileFriendlyTwoTone = require("./MobileFriendlyTwoTone");
var _mobileFriendlyTwoToneDefault = parcelHelpers.interopDefault(_mobileFriendlyTwoTone);
var _mobileOff = require("./MobileOff");
var _mobileOffDefault = parcelHelpers.interopDefault(_mobileOff);
var _mobileOffOutlined = require("./MobileOffOutlined");
var _mobileOffOutlinedDefault = parcelHelpers.interopDefault(_mobileOffOutlined);
var _mobileOffRounded = require("./MobileOffRounded");
var _mobileOffRoundedDefault = parcelHelpers.interopDefault(_mobileOffRounded);
var _mobileOffSharp = require("./MobileOffSharp");
var _mobileOffSharpDefault = parcelHelpers.interopDefault(_mobileOffSharp);
var _mobileOffTwoTone = require("./MobileOffTwoTone");
var _mobileOffTwoToneDefault = parcelHelpers.interopDefault(_mobileOffTwoTone);
var _mobileScreenShare = require("./MobileScreenShare");
var _mobileScreenShareDefault = parcelHelpers.interopDefault(_mobileScreenShare);
var _mobileScreenShareOutlined = require("./MobileScreenShareOutlined");
var _mobileScreenShareOutlinedDefault = parcelHelpers.interopDefault(_mobileScreenShareOutlined);
var _mobileScreenShareRounded = require("./MobileScreenShareRounded");
var _mobileScreenShareRoundedDefault = parcelHelpers.interopDefault(_mobileScreenShareRounded);
var _mobileScreenShareSharp = require("./MobileScreenShareSharp");
var _mobileScreenShareSharpDefault = parcelHelpers.interopDefault(_mobileScreenShareSharp);
var _mobileScreenShareTwoTone = require("./MobileScreenShareTwoTone");
var _mobileScreenShareTwoToneDefault = parcelHelpers.interopDefault(_mobileScreenShareTwoTone);
var _mobiledataOff = require("./MobiledataOff");
var _mobiledataOffDefault = parcelHelpers.interopDefault(_mobiledataOff);
var _mobiledataOffOutlined = require("./MobiledataOffOutlined");
var _mobiledataOffOutlinedDefault = parcelHelpers.interopDefault(_mobiledataOffOutlined);
var _mobiledataOffRounded = require("./MobiledataOffRounded");
var _mobiledataOffRoundedDefault = parcelHelpers.interopDefault(_mobiledataOffRounded);
var _mobiledataOffSharp = require("./MobiledataOffSharp");
var _mobiledataOffSharpDefault = parcelHelpers.interopDefault(_mobiledataOffSharp);
var _mobiledataOffTwoTone = require("./MobiledataOffTwoTone");
var _mobiledataOffTwoToneDefault = parcelHelpers.interopDefault(_mobiledataOffTwoTone);
var _mode = require("./Mode");
var _modeDefault = parcelHelpers.interopDefault(_mode);
var _modeComment = require("./ModeComment");
var _modeCommentDefault = parcelHelpers.interopDefault(_modeComment);
var _modeCommentOutlined = require("./ModeCommentOutlined");
var _modeCommentOutlinedDefault = parcelHelpers.interopDefault(_modeCommentOutlined);
var _modeCommentRounded = require("./ModeCommentRounded");
var _modeCommentRoundedDefault = parcelHelpers.interopDefault(_modeCommentRounded);
var _modeCommentSharp = require("./ModeCommentSharp");
var _modeCommentSharpDefault = parcelHelpers.interopDefault(_modeCommentSharp);
var _modeCommentTwoTone = require("./ModeCommentTwoTone");
var _modeCommentTwoToneDefault = parcelHelpers.interopDefault(_modeCommentTwoTone);
var _modeEdit = require("./ModeEdit");
var _modeEditDefault = parcelHelpers.interopDefault(_modeEdit);
var _modeEditOutline = require("./ModeEditOutline");
var _modeEditOutlineDefault = parcelHelpers.interopDefault(_modeEditOutline);
var _modeEditOutlineOutlined = require("./ModeEditOutlineOutlined");
var _modeEditOutlineOutlinedDefault = parcelHelpers.interopDefault(_modeEditOutlineOutlined);
var _modeEditOutlineRounded = require("./ModeEditOutlineRounded");
var _modeEditOutlineRoundedDefault = parcelHelpers.interopDefault(_modeEditOutlineRounded);
var _modeEditOutlineSharp = require("./ModeEditOutlineSharp");
var _modeEditOutlineSharpDefault = parcelHelpers.interopDefault(_modeEditOutlineSharp);
var _modeEditOutlineTwoTone = require("./ModeEditOutlineTwoTone");
var _modeEditOutlineTwoToneDefault = parcelHelpers.interopDefault(_modeEditOutlineTwoTone);
var _modeEditOutlined = require("./ModeEditOutlined");
var _modeEditOutlinedDefault = parcelHelpers.interopDefault(_modeEditOutlined);
var _modeEditRounded = require("./ModeEditRounded");
var _modeEditRoundedDefault = parcelHelpers.interopDefault(_modeEditRounded);
var _modeEditSharp = require("./ModeEditSharp");
var _modeEditSharpDefault = parcelHelpers.interopDefault(_modeEditSharp);
var _modeEditTwoTone = require("./ModeEditTwoTone");
var _modeEditTwoToneDefault = parcelHelpers.interopDefault(_modeEditTwoTone);
var _modeFanOff = require("./ModeFanOff");
var _modeFanOffDefault = parcelHelpers.interopDefault(_modeFanOff);
var _modeFanOffOutlined = require("./ModeFanOffOutlined");
var _modeFanOffOutlinedDefault = parcelHelpers.interopDefault(_modeFanOffOutlined);
var _modeFanOffRounded = require("./ModeFanOffRounded");
var _modeFanOffRoundedDefault = parcelHelpers.interopDefault(_modeFanOffRounded);
var _modeFanOffSharp = require("./ModeFanOffSharp");
var _modeFanOffSharpDefault = parcelHelpers.interopDefault(_modeFanOffSharp);
var _modeFanOffTwoTone = require("./ModeFanOffTwoTone");
var _modeFanOffTwoToneDefault = parcelHelpers.interopDefault(_modeFanOffTwoTone);
var _modeNight = require("./ModeNight");
var _modeNightDefault = parcelHelpers.interopDefault(_modeNight);
var _modeNightOutlined = require("./ModeNightOutlined");
var _modeNightOutlinedDefault = parcelHelpers.interopDefault(_modeNightOutlined);
var _modeNightRounded = require("./ModeNightRounded");
var _modeNightRoundedDefault = parcelHelpers.interopDefault(_modeNightRounded);
var _modeNightSharp = require("./ModeNightSharp");
var _modeNightSharpDefault = parcelHelpers.interopDefault(_modeNightSharp);
var _modeNightTwoTone = require("./ModeNightTwoTone");
var _modeNightTwoToneDefault = parcelHelpers.interopDefault(_modeNightTwoTone);
var _modeOfTravel = require("./ModeOfTravel");
var _modeOfTravelDefault = parcelHelpers.interopDefault(_modeOfTravel);
var _modeOfTravelOutlined = require("./ModeOfTravelOutlined");
var _modeOfTravelOutlinedDefault = parcelHelpers.interopDefault(_modeOfTravelOutlined);
var _modeOfTravelRounded = require("./ModeOfTravelRounded");
var _modeOfTravelRoundedDefault = parcelHelpers.interopDefault(_modeOfTravelRounded);
var _modeOfTravelSharp = require("./ModeOfTravelSharp");
var _modeOfTravelSharpDefault = parcelHelpers.interopDefault(_modeOfTravelSharp);
var _modeOfTravelTwoTone = require("./ModeOfTravelTwoTone");
var _modeOfTravelTwoToneDefault = parcelHelpers.interopDefault(_modeOfTravelTwoTone);
var _modeOutlined = require("./ModeOutlined");
var _modeOutlinedDefault = parcelHelpers.interopDefault(_modeOutlined);
var _modeRounded = require("./ModeRounded");
var _modeRoundedDefault = parcelHelpers.interopDefault(_modeRounded);
var _modeSharp = require("./ModeSharp");
var _modeSharpDefault = parcelHelpers.interopDefault(_modeSharp);
var _modeStandby = require("./ModeStandby");
var _modeStandbyDefault = parcelHelpers.interopDefault(_modeStandby);
var _modeStandbyOutlined = require("./ModeStandbyOutlined");
var _modeStandbyOutlinedDefault = parcelHelpers.interopDefault(_modeStandbyOutlined);
var _modeStandbyRounded = require("./ModeStandbyRounded");
var _modeStandbyRoundedDefault = parcelHelpers.interopDefault(_modeStandbyRounded);
var _modeStandbySharp = require("./ModeStandbySharp");
var _modeStandbySharpDefault = parcelHelpers.interopDefault(_modeStandbySharp);
var _modeStandbyTwoTone = require("./ModeStandbyTwoTone");
var _modeStandbyTwoToneDefault = parcelHelpers.interopDefault(_modeStandbyTwoTone);
var _modeTwoTone = require("./ModeTwoTone");
var _modeTwoToneDefault = parcelHelpers.interopDefault(_modeTwoTone);
var _modelTraining = require("./ModelTraining");
var _modelTrainingDefault = parcelHelpers.interopDefault(_modelTraining);
var _modelTrainingOutlined = require("./ModelTrainingOutlined");
var _modelTrainingOutlinedDefault = parcelHelpers.interopDefault(_modelTrainingOutlined);
var _modelTrainingRounded = require("./ModelTrainingRounded");
var _modelTrainingRoundedDefault = parcelHelpers.interopDefault(_modelTrainingRounded);
var _modelTrainingSharp = require("./ModelTrainingSharp");
var _modelTrainingSharpDefault = parcelHelpers.interopDefault(_modelTrainingSharp);
var _modelTrainingTwoTone = require("./ModelTrainingTwoTone");
var _modelTrainingTwoToneDefault = parcelHelpers.interopDefault(_modelTrainingTwoTone);
var _monetizationOn = require("./MonetizationOn");
var _monetizationOnDefault = parcelHelpers.interopDefault(_monetizationOn);
var _monetizationOnOutlined = require("./MonetizationOnOutlined");
var _monetizationOnOutlinedDefault = parcelHelpers.interopDefault(_monetizationOnOutlined);
var _monetizationOnRounded = require("./MonetizationOnRounded");
var _monetizationOnRoundedDefault = parcelHelpers.interopDefault(_monetizationOnRounded);
var _monetizationOnSharp = require("./MonetizationOnSharp");
var _monetizationOnSharpDefault = parcelHelpers.interopDefault(_monetizationOnSharp);
var _monetizationOnTwoTone = require("./MonetizationOnTwoTone");
var _monetizationOnTwoToneDefault = parcelHelpers.interopDefault(_monetizationOnTwoTone);
var _money = require("./Money");
var _moneyDefault = parcelHelpers.interopDefault(_money);
var _moneyOff = require("./MoneyOff");
var _moneyOffDefault = parcelHelpers.interopDefault(_moneyOff);
var _moneyOffCsred = require("./MoneyOffCsred");
var _moneyOffCsredDefault = parcelHelpers.interopDefault(_moneyOffCsred);
var _moneyOffCsredOutlined = require("./MoneyOffCsredOutlined");
var _moneyOffCsredOutlinedDefault = parcelHelpers.interopDefault(_moneyOffCsredOutlined);
var _moneyOffCsredRounded = require("./MoneyOffCsredRounded");
var _moneyOffCsredRoundedDefault = parcelHelpers.interopDefault(_moneyOffCsredRounded);
var _moneyOffCsredSharp = require("./MoneyOffCsredSharp");
var _moneyOffCsredSharpDefault = parcelHelpers.interopDefault(_moneyOffCsredSharp);
var _moneyOffCsredTwoTone = require("./MoneyOffCsredTwoTone");
var _moneyOffCsredTwoToneDefault = parcelHelpers.interopDefault(_moneyOffCsredTwoTone);
var _moneyOffOutlined = require("./MoneyOffOutlined");
var _moneyOffOutlinedDefault = parcelHelpers.interopDefault(_moneyOffOutlined);
var _moneyOffRounded = require("./MoneyOffRounded");
var _moneyOffRoundedDefault = parcelHelpers.interopDefault(_moneyOffRounded);
var _moneyOffSharp = require("./MoneyOffSharp");
var _moneyOffSharpDefault = parcelHelpers.interopDefault(_moneyOffSharp);
var _moneyOffTwoTone = require("./MoneyOffTwoTone");
var _moneyOffTwoToneDefault = parcelHelpers.interopDefault(_moneyOffTwoTone);
var _moneyOutlined = require("./MoneyOutlined");
var _moneyOutlinedDefault = parcelHelpers.interopDefault(_moneyOutlined);
var _moneyRounded = require("./MoneyRounded");
var _moneyRoundedDefault = parcelHelpers.interopDefault(_moneyRounded);
var _moneySharp = require("./MoneySharp");
var _moneySharpDefault = parcelHelpers.interopDefault(_moneySharp);
var _moneyTwoTone = require("./MoneyTwoTone");
var _moneyTwoToneDefault = parcelHelpers.interopDefault(_moneyTwoTone);
var _monitor = require("./Monitor");
var _monitorDefault = parcelHelpers.interopDefault(_monitor);
var _monitorHeart = require("./MonitorHeart");
var _monitorHeartDefault = parcelHelpers.interopDefault(_monitorHeart);
var _monitorHeartOutlined = require("./MonitorHeartOutlined");
var _monitorHeartOutlinedDefault = parcelHelpers.interopDefault(_monitorHeartOutlined);
var _monitorHeartRounded = require("./MonitorHeartRounded");
var _monitorHeartRoundedDefault = parcelHelpers.interopDefault(_monitorHeartRounded);
var _monitorHeartSharp = require("./MonitorHeartSharp");
var _monitorHeartSharpDefault = parcelHelpers.interopDefault(_monitorHeartSharp);
var _monitorHeartTwoTone = require("./MonitorHeartTwoTone");
var _monitorHeartTwoToneDefault = parcelHelpers.interopDefault(_monitorHeartTwoTone);
var _monitorOutlined = require("./MonitorOutlined");
var _monitorOutlinedDefault = parcelHelpers.interopDefault(_monitorOutlined);
var _monitorRounded = require("./MonitorRounded");
var _monitorRoundedDefault = parcelHelpers.interopDefault(_monitorRounded);
var _monitorSharp = require("./MonitorSharp");
var _monitorSharpDefault = parcelHelpers.interopDefault(_monitorSharp);
var _monitorTwoTone = require("./MonitorTwoTone");
var _monitorTwoToneDefault = parcelHelpers.interopDefault(_monitorTwoTone);
var _monitorWeight = require("./MonitorWeight");
var _monitorWeightDefault = parcelHelpers.interopDefault(_monitorWeight);
var _monitorWeightOutlined = require("./MonitorWeightOutlined");
var _monitorWeightOutlinedDefault = parcelHelpers.interopDefault(_monitorWeightOutlined);
var _monitorWeightRounded = require("./MonitorWeightRounded");
var _monitorWeightRoundedDefault = parcelHelpers.interopDefault(_monitorWeightRounded);
var _monitorWeightSharp = require("./MonitorWeightSharp");
var _monitorWeightSharpDefault = parcelHelpers.interopDefault(_monitorWeightSharp);
var _monitorWeightTwoTone = require("./MonitorWeightTwoTone");
var _monitorWeightTwoToneDefault = parcelHelpers.interopDefault(_monitorWeightTwoTone);
var _monochromePhotos = require("./MonochromePhotos");
var _monochromePhotosDefault = parcelHelpers.interopDefault(_monochromePhotos);
var _monochromePhotosOutlined = require("./MonochromePhotosOutlined");
var _monochromePhotosOutlinedDefault = parcelHelpers.interopDefault(_monochromePhotosOutlined);
var _monochromePhotosRounded = require("./MonochromePhotosRounded");
var _monochromePhotosRoundedDefault = parcelHelpers.interopDefault(_monochromePhotosRounded);
var _monochromePhotosSharp = require("./MonochromePhotosSharp");
var _monochromePhotosSharpDefault = parcelHelpers.interopDefault(_monochromePhotosSharp);
var _monochromePhotosTwoTone = require("./MonochromePhotosTwoTone");
var _monochromePhotosTwoToneDefault = parcelHelpers.interopDefault(_monochromePhotosTwoTone);
var _mood = require("./Mood");
var _moodDefault = parcelHelpers.interopDefault(_mood);
var _moodBad = require("./MoodBad");
var _moodBadDefault = parcelHelpers.interopDefault(_moodBad);
var _moodBadOutlined = require("./MoodBadOutlined");
var _moodBadOutlinedDefault = parcelHelpers.interopDefault(_moodBadOutlined);
var _moodBadRounded = require("./MoodBadRounded");
var _moodBadRoundedDefault = parcelHelpers.interopDefault(_moodBadRounded);
var _moodBadSharp = require("./MoodBadSharp");
var _moodBadSharpDefault = parcelHelpers.interopDefault(_moodBadSharp);
var _moodBadTwoTone = require("./MoodBadTwoTone");
var _moodBadTwoToneDefault = parcelHelpers.interopDefault(_moodBadTwoTone);
var _moodOutlined = require("./MoodOutlined");
var _moodOutlinedDefault = parcelHelpers.interopDefault(_moodOutlined);
var _moodRounded = require("./MoodRounded");
var _moodRoundedDefault = parcelHelpers.interopDefault(_moodRounded);
var _moodSharp = require("./MoodSharp");
var _moodSharpDefault = parcelHelpers.interopDefault(_moodSharp);
var _moodTwoTone = require("./MoodTwoTone");
var _moodTwoToneDefault = parcelHelpers.interopDefault(_moodTwoTone);
var _moped = require("./Moped");
var _mopedDefault = parcelHelpers.interopDefault(_moped);
var _mopedOutlined = require("./MopedOutlined");
var _mopedOutlinedDefault = parcelHelpers.interopDefault(_mopedOutlined);
var _mopedRounded = require("./MopedRounded");
var _mopedRoundedDefault = parcelHelpers.interopDefault(_mopedRounded);
var _mopedSharp = require("./MopedSharp");
var _mopedSharpDefault = parcelHelpers.interopDefault(_mopedSharp);
var _mopedTwoTone = require("./MopedTwoTone");
var _mopedTwoToneDefault = parcelHelpers.interopDefault(_mopedTwoTone);
var _more = require("./More");
var _moreDefault = parcelHelpers.interopDefault(_more);
var _moreHoriz = require("./MoreHoriz");
var _moreHorizDefault = parcelHelpers.interopDefault(_moreHoriz);
var _moreHorizOutlined = require("./MoreHorizOutlined");
var _moreHorizOutlinedDefault = parcelHelpers.interopDefault(_moreHorizOutlined);
var _moreHorizRounded = require("./MoreHorizRounded");
var _moreHorizRoundedDefault = parcelHelpers.interopDefault(_moreHorizRounded);
var _moreHorizSharp = require("./MoreHorizSharp");
var _moreHorizSharpDefault = parcelHelpers.interopDefault(_moreHorizSharp);
var _moreHorizTwoTone = require("./MoreHorizTwoTone");
var _moreHorizTwoToneDefault = parcelHelpers.interopDefault(_moreHorizTwoTone);
var _moreOutlined = require("./MoreOutlined");
var _moreOutlinedDefault = parcelHelpers.interopDefault(_moreOutlined);
var _moreRounded = require("./MoreRounded");
var _moreRoundedDefault = parcelHelpers.interopDefault(_moreRounded);
var _moreSharp = require("./MoreSharp");
var _moreSharpDefault = parcelHelpers.interopDefault(_moreSharp);
var _moreTime = require("./MoreTime");
var _moreTimeDefault = parcelHelpers.interopDefault(_moreTime);
var _moreTimeOutlined = require("./MoreTimeOutlined");
var _moreTimeOutlinedDefault = parcelHelpers.interopDefault(_moreTimeOutlined);
var _moreTimeRounded = require("./MoreTimeRounded");
var _moreTimeRoundedDefault = parcelHelpers.interopDefault(_moreTimeRounded);
var _moreTimeSharp = require("./MoreTimeSharp");
var _moreTimeSharpDefault = parcelHelpers.interopDefault(_moreTimeSharp);
var _moreTimeTwoTone = require("./MoreTimeTwoTone");
var _moreTimeTwoToneDefault = parcelHelpers.interopDefault(_moreTimeTwoTone);
var _moreTwoTone = require("./MoreTwoTone");
var _moreTwoToneDefault = parcelHelpers.interopDefault(_moreTwoTone);
var _moreVert = require("./MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _moreVertOutlined = require("./MoreVertOutlined");
var _moreVertOutlinedDefault = parcelHelpers.interopDefault(_moreVertOutlined);
var _moreVertRounded = require("./MoreVertRounded");
var _moreVertRoundedDefault = parcelHelpers.interopDefault(_moreVertRounded);
var _moreVertSharp = require("./MoreVertSharp");
var _moreVertSharpDefault = parcelHelpers.interopDefault(_moreVertSharp);
var _moreVertTwoTone = require("./MoreVertTwoTone");
var _moreVertTwoToneDefault = parcelHelpers.interopDefault(_moreVertTwoTone);
var _mosque = require("./Mosque");
var _mosqueDefault = parcelHelpers.interopDefault(_mosque);
var _mosqueOutlined = require("./MosqueOutlined");
var _mosqueOutlinedDefault = parcelHelpers.interopDefault(_mosqueOutlined);
var _mosqueRounded = require("./MosqueRounded");
var _mosqueRoundedDefault = parcelHelpers.interopDefault(_mosqueRounded);
var _mosqueSharp = require("./MosqueSharp");
var _mosqueSharpDefault = parcelHelpers.interopDefault(_mosqueSharp);
var _mosqueTwoTone = require("./MosqueTwoTone");
var _mosqueTwoToneDefault = parcelHelpers.interopDefault(_mosqueTwoTone);
var _motionPhotosAuto = require("./MotionPhotosAuto");
var _motionPhotosAutoDefault = parcelHelpers.interopDefault(_motionPhotosAuto);
var _motionPhotosAutoOutlined = require("./MotionPhotosAutoOutlined");
var _motionPhotosAutoOutlinedDefault = parcelHelpers.interopDefault(_motionPhotosAutoOutlined);
var _motionPhotosAutoRounded = require("./MotionPhotosAutoRounded");
var _motionPhotosAutoRoundedDefault = parcelHelpers.interopDefault(_motionPhotosAutoRounded);
var _motionPhotosAutoSharp = require("./MotionPhotosAutoSharp");
var _motionPhotosAutoSharpDefault = parcelHelpers.interopDefault(_motionPhotosAutoSharp);
var _motionPhotosAutoTwoTone = require("./MotionPhotosAutoTwoTone");
var _motionPhotosAutoTwoToneDefault = parcelHelpers.interopDefault(_motionPhotosAutoTwoTone);
var _motionPhotosOff = require("./MotionPhotosOff");
var _motionPhotosOffDefault = parcelHelpers.interopDefault(_motionPhotosOff);
var _motionPhotosOffOutlined = require("./MotionPhotosOffOutlined");
var _motionPhotosOffOutlinedDefault = parcelHelpers.interopDefault(_motionPhotosOffOutlined);
var _motionPhotosOffRounded = require("./MotionPhotosOffRounded");
var _motionPhotosOffRoundedDefault = parcelHelpers.interopDefault(_motionPhotosOffRounded);
var _motionPhotosOffSharp = require("./MotionPhotosOffSharp");
var _motionPhotosOffSharpDefault = parcelHelpers.interopDefault(_motionPhotosOffSharp);
var _motionPhotosOffTwoTone = require("./MotionPhotosOffTwoTone");
var _motionPhotosOffTwoToneDefault = parcelHelpers.interopDefault(_motionPhotosOffTwoTone);
var _mouse = require("./Mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _mouseOutlined = require("./MouseOutlined");
var _mouseOutlinedDefault = parcelHelpers.interopDefault(_mouseOutlined);
var _mouseRounded = require("./MouseRounded");
var _mouseRoundedDefault = parcelHelpers.interopDefault(_mouseRounded);
var _mouseSharp = require("./MouseSharp");
var _mouseSharpDefault = parcelHelpers.interopDefault(_mouseSharp);
var _mouseTwoTone = require("./MouseTwoTone");
var _mouseTwoToneDefault = parcelHelpers.interopDefault(_mouseTwoTone);
var _moveDown = require("./MoveDown");
var _moveDownDefault = parcelHelpers.interopDefault(_moveDown);
var _moveDownOutlined = require("./MoveDownOutlined");
var _moveDownOutlinedDefault = parcelHelpers.interopDefault(_moveDownOutlined);
var _moveDownRounded = require("./MoveDownRounded");
var _moveDownRoundedDefault = parcelHelpers.interopDefault(_moveDownRounded);
var _moveDownSharp = require("./MoveDownSharp");
var _moveDownSharpDefault = parcelHelpers.interopDefault(_moveDownSharp);
var _moveDownTwoTone = require("./MoveDownTwoTone");
var _moveDownTwoToneDefault = parcelHelpers.interopDefault(_moveDownTwoTone);
var _moveToInbox = require("./MoveToInbox");
var _moveToInboxDefault = parcelHelpers.interopDefault(_moveToInbox);
var _moveToInboxOutlined = require("./MoveToInboxOutlined");
var _moveToInboxOutlinedDefault = parcelHelpers.interopDefault(_moveToInboxOutlined);
var _moveToInboxRounded = require("./MoveToInboxRounded");
var _moveToInboxRoundedDefault = parcelHelpers.interopDefault(_moveToInboxRounded);
var _moveToInboxSharp = require("./MoveToInboxSharp");
var _moveToInboxSharpDefault = parcelHelpers.interopDefault(_moveToInboxSharp);
var _moveToInboxTwoTone = require("./MoveToInboxTwoTone");
var _moveToInboxTwoToneDefault = parcelHelpers.interopDefault(_moveToInboxTwoTone);
var _moveUp = require("./MoveUp");
var _moveUpDefault = parcelHelpers.interopDefault(_moveUp);
var _moveUpOutlined = require("./MoveUpOutlined");
var _moveUpOutlinedDefault = parcelHelpers.interopDefault(_moveUpOutlined);
var _moveUpRounded = require("./MoveUpRounded");
var _moveUpRoundedDefault = parcelHelpers.interopDefault(_moveUpRounded);
var _moveUpSharp = require("./MoveUpSharp");
var _moveUpSharpDefault = parcelHelpers.interopDefault(_moveUpSharp);
var _moveUpTwoTone = require("./MoveUpTwoTone");
var _moveUpTwoToneDefault = parcelHelpers.interopDefault(_moveUpTwoTone);
var _movie = require("./Movie");
var _movieDefault = parcelHelpers.interopDefault(_movie);
var _movieCreation = require("./MovieCreation");
var _movieCreationDefault = parcelHelpers.interopDefault(_movieCreation);
var _movieCreationOutlined = require("./MovieCreationOutlined");
var _movieCreationOutlinedDefault = parcelHelpers.interopDefault(_movieCreationOutlined);
var _movieCreationRounded = require("./MovieCreationRounded");
var _movieCreationRoundedDefault = parcelHelpers.interopDefault(_movieCreationRounded);
var _movieCreationSharp = require("./MovieCreationSharp");
var _movieCreationSharpDefault = parcelHelpers.interopDefault(_movieCreationSharp);
var _movieCreationTwoTone = require("./MovieCreationTwoTone");
var _movieCreationTwoToneDefault = parcelHelpers.interopDefault(_movieCreationTwoTone);
var _movieFilter = require("./MovieFilter");
var _movieFilterDefault = parcelHelpers.interopDefault(_movieFilter);
var _movieFilterOutlined = require("./MovieFilterOutlined");
var _movieFilterOutlinedDefault = parcelHelpers.interopDefault(_movieFilterOutlined);
var _movieFilterRounded = require("./MovieFilterRounded");
var _movieFilterRoundedDefault = parcelHelpers.interopDefault(_movieFilterRounded);
var _movieFilterSharp = require("./MovieFilterSharp");
var _movieFilterSharpDefault = parcelHelpers.interopDefault(_movieFilterSharp);
var _movieFilterTwoTone = require("./MovieFilterTwoTone");
var _movieFilterTwoToneDefault = parcelHelpers.interopDefault(_movieFilterTwoTone);
var _movieOutlined = require("./MovieOutlined");
var _movieOutlinedDefault = parcelHelpers.interopDefault(_movieOutlined);
var _movieRounded = require("./MovieRounded");
var _movieRoundedDefault = parcelHelpers.interopDefault(_movieRounded);
var _movieSharp = require("./MovieSharp");
var _movieSharpDefault = parcelHelpers.interopDefault(_movieSharp);
var _movieTwoTone = require("./MovieTwoTone");
var _movieTwoToneDefault = parcelHelpers.interopDefault(_movieTwoTone);
var _moving = require("./Moving");
var _movingDefault = parcelHelpers.interopDefault(_moving);
var _movingOutlined = require("./MovingOutlined");
var _movingOutlinedDefault = parcelHelpers.interopDefault(_movingOutlined);
var _movingRounded = require("./MovingRounded");
var _movingRoundedDefault = parcelHelpers.interopDefault(_movingRounded);
var _movingSharp = require("./MovingSharp");
var _movingSharpDefault = parcelHelpers.interopDefault(_movingSharp);
var _movingTwoTone = require("./MovingTwoTone");
var _movingTwoToneDefault = parcelHelpers.interopDefault(_movingTwoTone);
var _mp = require("./Mp");
var _mpDefault = parcelHelpers.interopDefault(_mp);
var _mpOutlined = require("./MpOutlined");
var _mpOutlinedDefault = parcelHelpers.interopDefault(_mpOutlined);
var _mpRounded = require("./MpRounded");
var _mpRoundedDefault = parcelHelpers.interopDefault(_mpRounded);
var _mpSharp = require("./MpSharp");
var _mpSharpDefault = parcelHelpers.interopDefault(_mpSharp);
var _mpTwoTone = require("./MpTwoTone");
var _mpTwoToneDefault = parcelHelpers.interopDefault(_mpTwoTone);
var _multilineChart = require("./MultilineChart");
var _multilineChartDefault = parcelHelpers.interopDefault(_multilineChart);
var _multilineChartOutlined = require("./MultilineChartOutlined");
var _multilineChartOutlinedDefault = parcelHelpers.interopDefault(_multilineChartOutlined);
var _multilineChartRounded = require("./MultilineChartRounded");
var _multilineChartRoundedDefault = parcelHelpers.interopDefault(_multilineChartRounded);
var _multilineChartSharp = require("./MultilineChartSharp");
var _multilineChartSharpDefault = parcelHelpers.interopDefault(_multilineChartSharp);
var _multilineChartTwoTone = require("./MultilineChartTwoTone");
var _multilineChartTwoToneDefault = parcelHelpers.interopDefault(_multilineChartTwoTone);
var _multipleStop = require("./MultipleStop");
var _multipleStopDefault = parcelHelpers.interopDefault(_multipleStop);
var _multipleStopOutlined = require("./MultipleStopOutlined");
var _multipleStopOutlinedDefault = parcelHelpers.interopDefault(_multipleStopOutlined);
var _multipleStopRounded = require("./MultipleStopRounded");
var _multipleStopRoundedDefault = parcelHelpers.interopDefault(_multipleStopRounded);
var _multipleStopSharp = require("./MultipleStopSharp");
var _multipleStopSharpDefault = parcelHelpers.interopDefault(_multipleStopSharp);
var _multipleStopTwoTone = require("./MultipleStopTwoTone");
var _multipleStopTwoToneDefault = parcelHelpers.interopDefault(_multipleStopTwoTone);
var _museum = require("./Museum");
var _museumDefault = parcelHelpers.interopDefault(_museum);
var _museumOutlined = require("./MuseumOutlined");
var _museumOutlinedDefault = parcelHelpers.interopDefault(_museumOutlined);
var _museumRounded = require("./MuseumRounded");
var _museumRoundedDefault = parcelHelpers.interopDefault(_museumRounded);
var _museumSharp = require("./MuseumSharp");
var _museumSharpDefault = parcelHelpers.interopDefault(_museumSharp);
var _museumTwoTone = require("./MuseumTwoTone");
var _museumTwoToneDefault = parcelHelpers.interopDefault(_museumTwoTone);
var _musicNote = require("./MusicNote");
var _musicNoteDefault = parcelHelpers.interopDefault(_musicNote);
var _musicNoteOutlined = require("./MusicNoteOutlined");
var _musicNoteOutlinedDefault = parcelHelpers.interopDefault(_musicNoteOutlined);
var _musicNoteRounded = require("./MusicNoteRounded");
var _musicNoteRoundedDefault = parcelHelpers.interopDefault(_musicNoteRounded);
var _musicNoteSharp = require("./MusicNoteSharp");
var _musicNoteSharpDefault = parcelHelpers.interopDefault(_musicNoteSharp);
var _musicNoteTwoTone = require("./MusicNoteTwoTone");
var _musicNoteTwoToneDefault = parcelHelpers.interopDefault(_musicNoteTwoTone);
var _musicOff = require("./MusicOff");
var _musicOffDefault = parcelHelpers.interopDefault(_musicOff);
var _musicOffOutlined = require("./MusicOffOutlined");
var _musicOffOutlinedDefault = parcelHelpers.interopDefault(_musicOffOutlined);
var _musicOffRounded = require("./MusicOffRounded");
var _musicOffRoundedDefault = parcelHelpers.interopDefault(_musicOffRounded);
var _musicOffSharp = require("./MusicOffSharp");
var _musicOffSharpDefault = parcelHelpers.interopDefault(_musicOffSharp);
var _musicOffTwoTone = require("./MusicOffTwoTone");
var _musicOffTwoToneDefault = parcelHelpers.interopDefault(_musicOffTwoTone);
var _musicVideo = require("./MusicVideo");
var _musicVideoDefault = parcelHelpers.interopDefault(_musicVideo);
var _musicVideoOutlined = require("./MusicVideoOutlined");
var _musicVideoOutlinedDefault = parcelHelpers.interopDefault(_musicVideoOutlined);
var _musicVideoRounded = require("./MusicVideoRounded");
var _musicVideoRoundedDefault = parcelHelpers.interopDefault(_musicVideoRounded);
var _musicVideoSharp = require("./MusicVideoSharp");
var _musicVideoSharpDefault = parcelHelpers.interopDefault(_musicVideoSharp);
var _musicVideoTwoTone = require("./MusicVideoTwoTone");
var _musicVideoTwoToneDefault = parcelHelpers.interopDefault(_musicVideoTwoTone);
var _myLocation = require("./MyLocation");
var _myLocationDefault = parcelHelpers.interopDefault(_myLocation);
var _myLocationOutlined = require("./MyLocationOutlined");
var _myLocationOutlinedDefault = parcelHelpers.interopDefault(_myLocationOutlined);
var _myLocationRounded = require("./MyLocationRounded");
var _myLocationRoundedDefault = parcelHelpers.interopDefault(_myLocationRounded);
var _myLocationSharp = require("./MyLocationSharp");
var _myLocationSharpDefault = parcelHelpers.interopDefault(_myLocationSharp);
var _myLocationTwoTone = require("./MyLocationTwoTone");
var _myLocationTwoToneDefault = parcelHelpers.interopDefault(_myLocationTwoTone);
var _nat = require("./Nat");
var _natDefault = parcelHelpers.interopDefault(_nat);
var _natOutlined = require("./NatOutlined");
var _natOutlinedDefault = parcelHelpers.interopDefault(_natOutlined);
var _natRounded = require("./NatRounded");
var _natRoundedDefault = parcelHelpers.interopDefault(_natRounded);
var _natSharp = require("./NatSharp");
var _natSharpDefault = parcelHelpers.interopDefault(_natSharp);
var _natTwoTone = require("./NatTwoTone");
var _natTwoToneDefault = parcelHelpers.interopDefault(_natTwoTone);
var _nature = require("./Nature");
var _natureDefault = parcelHelpers.interopDefault(_nature);
var _natureOutlined = require("./NatureOutlined");
var _natureOutlinedDefault = parcelHelpers.interopDefault(_natureOutlined);
var _naturePeople = require("./NaturePeople");
var _naturePeopleDefault = parcelHelpers.interopDefault(_naturePeople);
var _naturePeopleOutlined = require("./NaturePeopleOutlined");
var _naturePeopleOutlinedDefault = parcelHelpers.interopDefault(_naturePeopleOutlined);
var _naturePeopleRounded = require("./NaturePeopleRounded");
var _naturePeopleRoundedDefault = parcelHelpers.interopDefault(_naturePeopleRounded);
var _naturePeopleSharp = require("./NaturePeopleSharp");
var _naturePeopleSharpDefault = parcelHelpers.interopDefault(_naturePeopleSharp);
var _naturePeopleTwoTone = require("./NaturePeopleTwoTone");
var _naturePeopleTwoToneDefault = parcelHelpers.interopDefault(_naturePeopleTwoTone);
var _natureRounded = require("./NatureRounded");
var _natureRoundedDefault = parcelHelpers.interopDefault(_natureRounded);
var _natureSharp = require("./NatureSharp");
var _natureSharpDefault = parcelHelpers.interopDefault(_natureSharp);
var _natureTwoTone = require("./NatureTwoTone");
var _natureTwoToneDefault = parcelHelpers.interopDefault(_natureTwoTone);
var _navigateBefore = require("./NavigateBefore");
var _navigateBeforeDefault = parcelHelpers.interopDefault(_navigateBefore);
var _navigateBeforeOutlined = require("./NavigateBeforeOutlined");
var _navigateBeforeOutlinedDefault = parcelHelpers.interopDefault(_navigateBeforeOutlined);
var _navigateBeforeRounded = require("./NavigateBeforeRounded");
var _navigateBeforeRoundedDefault = parcelHelpers.interopDefault(_navigateBeforeRounded);
var _navigateBeforeSharp = require("./NavigateBeforeSharp");
var _navigateBeforeSharpDefault = parcelHelpers.interopDefault(_navigateBeforeSharp);
var _navigateBeforeTwoTone = require("./NavigateBeforeTwoTone");
var _navigateBeforeTwoToneDefault = parcelHelpers.interopDefault(_navigateBeforeTwoTone);
var _navigateNext = require("./NavigateNext");
var _navigateNextDefault = parcelHelpers.interopDefault(_navigateNext);
var _navigateNextOutlined = require("./NavigateNextOutlined");
var _navigateNextOutlinedDefault = parcelHelpers.interopDefault(_navigateNextOutlined);
var _navigateNextRounded = require("./NavigateNextRounded");
var _navigateNextRoundedDefault = parcelHelpers.interopDefault(_navigateNextRounded);
var _navigateNextSharp = require("./NavigateNextSharp");
var _navigateNextSharpDefault = parcelHelpers.interopDefault(_navigateNextSharp);
var _navigateNextTwoTone = require("./NavigateNextTwoTone");
var _navigateNextTwoToneDefault = parcelHelpers.interopDefault(_navigateNextTwoTone);
var _navigation = require("./Navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _navigationOutlined = require("./NavigationOutlined");
var _navigationOutlinedDefault = parcelHelpers.interopDefault(_navigationOutlined);
var _navigationRounded = require("./NavigationRounded");
var _navigationRoundedDefault = parcelHelpers.interopDefault(_navigationRounded);
var _navigationSharp = require("./NavigationSharp");
var _navigationSharpDefault = parcelHelpers.interopDefault(_navigationSharp);
var _navigationTwoTone = require("./NavigationTwoTone");
var _navigationTwoToneDefault = parcelHelpers.interopDefault(_navigationTwoTone);
var _nearMe = require("./NearMe");
var _nearMeDefault = parcelHelpers.interopDefault(_nearMe);
var _nearMeDisabled = require("./NearMeDisabled");
var _nearMeDisabledDefault = parcelHelpers.interopDefault(_nearMeDisabled);
var _nearMeDisabledOutlined = require("./NearMeDisabledOutlined");
var _nearMeDisabledOutlinedDefault = parcelHelpers.interopDefault(_nearMeDisabledOutlined);
var _nearMeDisabledRounded = require("./NearMeDisabledRounded");
var _nearMeDisabledRoundedDefault = parcelHelpers.interopDefault(_nearMeDisabledRounded);
var _nearMeDisabledSharp = require("./NearMeDisabledSharp");
var _nearMeDisabledSharpDefault = parcelHelpers.interopDefault(_nearMeDisabledSharp);
var _nearMeDisabledTwoTone = require("./NearMeDisabledTwoTone");
var _nearMeDisabledTwoToneDefault = parcelHelpers.interopDefault(_nearMeDisabledTwoTone);
var _nearMeOutlined = require("./NearMeOutlined");
var _nearMeOutlinedDefault = parcelHelpers.interopDefault(_nearMeOutlined);
var _nearMeRounded = require("./NearMeRounded");
var _nearMeRoundedDefault = parcelHelpers.interopDefault(_nearMeRounded);
var _nearMeSharp = require("./NearMeSharp");
var _nearMeSharpDefault = parcelHelpers.interopDefault(_nearMeSharp);
var _nearMeTwoTone = require("./NearMeTwoTone");
var _nearMeTwoToneDefault = parcelHelpers.interopDefault(_nearMeTwoTone);
var _nearbyError = require("./NearbyError");
var _nearbyErrorDefault = parcelHelpers.interopDefault(_nearbyError);
var _nearbyErrorOutlined = require("./NearbyErrorOutlined");
var _nearbyErrorOutlinedDefault = parcelHelpers.interopDefault(_nearbyErrorOutlined);
var _nearbyErrorRounded = require("./NearbyErrorRounded");
var _nearbyErrorRoundedDefault = parcelHelpers.interopDefault(_nearbyErrorRounded);
var _nearbyErrorSharp = require("./NearbyErrorSharp");
var _nearbyErrorSharpDefault = parcelHelpers.interopDefault(_nearbyErrorSharp);
var _nearbyErrorTwoTone = require("./NearbyErrorTwoTone");
var _nearbyErrorTwoToneDefault = parcelHelpers.interopDefault(_nearbyErrorTwoTone);
var _nearbyOff = require("./NearbyOff");
var _nearbyOffDefault = parcelHelpers.interopDefault(_nearbyOff);
var _nearbyOffOutlined = require("./NearbyOffOutlined");
var _nearbyOffOutlinedDefault = parcelHelpers.interopDefault(_nearbyOffOutlined);
var _nearbyOffRounded = require("./NearbyOffRounded");
var _nearbyOffRoundedDefault = parcelHelpers.interopDefault(_nearbyOffRounded);
var _nearbyOffSharp = require("./NearbyOffSharp");
var _nearbyOffSharpDefault = parcelHelpers.interopDefault(_nearbyOffSharp);
var _nearbyOffTwoTone = require("./NearbyOffTwoTone");
var _nearbyOffTwoToneDefault = parcelHelpers.interopDefault(_nearbyOffTwoTone);
var _nestCamWiredStand = require("./NestCamWiredStand");
var _nestCamWiredStandDefault = parcelHelpers.interopDefault(_nestCamWiredStand);
var _nestCamWiredStandOutlined = require("./NestCamWiredStandOutlined");
var _nestCamWiredStandOutlinedDefault = parcelHelpers.interopDefault(_nestCamWiredStandOutlined);
var _nestCamWiredStandRounded = require("./NestCamWiredStandRounded");
var _nestCamWiredStandRoundedDefault = parcelHelpers.interopDefault(_nestCamWiredStandRounded);
var _nestCamWiredStandSharp = require("./NestCamWiredStandSharp");
var _nestCamWiredStandSharpDefault = parcelHelpers.interopDefault(_nestCamWiredStandSharp);
var _nestCamWiredStandTwoTone = require("./NestCamWiredStandTwoTone");
var _nestCamWiredStandTwoToneDefault = parcelHelpers.interopDefault(_nestCamWiredStandTwoTone);
var _networkCell = require("./NetworkCell");
var _networkCellDefault = parcelHelpers.interopDefault(_networkCell);
var _networkCellOutlined = require("./NetworkCellOutlined");
var _networkCellOutlinedDefault = parcelHelpers.interopDefault(_networkCellOutlined);
var _networkCellRounded = require("./NetworkCellRounded");
var _networkCellRoundedDefault = parcelHelpers.interopDefault(_networkCellRounded);
var _networkCellSharp = require("./NetworkCellSharp");
var _networkCellSharpDefault = parcelHelpers.interopDefault(_networkCellSharp);
var _networkCellTwoTone = require("./NetworkCellTwoTone");
var _networkCellTwoToneDefault = parcelHelpers.interopDefault(_networkCellTwoTone);
var _networkCheck = require("./NetworkCheck");
var _networkCheckDefault = parcelHelpers.interopDefault(_networkCheck);
var _networkCheckOutlined = require("./NetworkCheckOutlined");
var _networkCheckOutlinedDefault = parcelHelpers.interopDefault(_networkCheckOutlined);
var _networkCheckRounded = require("./NetworkCheckRounded");
var _networkCheckRoundedDefault = parcelHelpers.interopDefault(_networkCheckRounded);
var _networkCheckSharp = require("./NetworkCheckSharp");
var _networkCheckSharpDefault = parcelHelpers.interopDefault(_networkCheckSharp);
var _networkCheckTwoTone = require("./NetworkCheckTwoTone");
var _networkCheckTwoToneDefault = parcelHelpers.interopDefault(_networkCheckTwoTone);
var _networkLocked = require("./NetworkLocked");
var _networkLockedDefault = parcelHelpers.interopDefault(_networkLocked);
var _networkLockedOutlined = require("./NetworkLockedOutlined");
var _networkLockedOutlinedDefault = parcelHelpers.interopDefault(_networkLockedOutlined);
var _networkLockedRounded = require("./NetworkLockedRounded");
var _networkLockedRoundedDefault = parcelHelpers.interopDefault(_networkLockedRounded);
var _networkLockedSharp = require("./NetworkLockedSharp");
var _networkLockedSharpDefault = parcelHelpers.interopDefault(_networkLockedSharp);
var _networkLockedTwoTone = require("./NetworkLockedTwoTone");
var _networkLockedTwoToneDefault = parcelHelpers.interopDefault(_networkLockedTwoTone);
var _networkPing = require("./NetworkPing");
var _networkPingDefault = parcelHelpers.interopDefault(_networkPing);
var _networkPingOutlined = require("./NetworkPingOutlined");
var _networkPingOutlinedDefault = parcelHelpers.interopDefault(_networkPingOutlined);
var _networkPingRounded = require("./NetworkPingRounded");
var _networkPingRoundedDefault = parcelHelpers.interopDefault(_networkPingRounded);
var _networkPingSharp = require("./NetworkPingSharp");
var _networkPingSharpDefault = parcelHelpers.interopDefault(_networkPingSharp);
var _networkPingTwoTone = require("./NetworkPingTwoTone");
var _networkPingTwoToneDefault = parcelHelpers.interopDefault(_networkPingTwoTone);
var _networkWifi = require("./NetworkWifi");
var _networkWifiDefault = parcelHelpers.interopDefault(_networkWifi);
var _networkWifi1Bar = require("./NetworkWifi1Bar");
var _networkWifi1BarDefault = parcelHelpers.interopDefault(_networkWifi1Bar);
var _networkWifi1BarOutlined = require("./NetworkWifi1BarOutlined");
var _networkWifi1BarOutlinedDefault = parcelHelpers.interopDefault(_networkWifi1BarOutlined);
var _networkWifi1BarRounded = require("./NetworkWifi1BarRounded");
var _networkWifi1BarRoundedDefault = parcelHelpers.interopDefault(_networkWifi1BarRounded);
var _networkWifi1BarSharp = require("./NetworkWifi1BarSharp");
var _networkWifi1BarSharpDefault = parcelHelpers.interopDefault(_networkWifi1BarSharp);
var _networkWifi1BarTwoTone = require("./NetworkWifi1BarTwoTone");
var _networkWifi1BarTwoToneDefault = parcelHelpers.interopDefault(_networkWifi1BarTwoTone);
var _networkWifi2Bar = require("./NetworkWifi2Bar");
var _networkWifi2BarDefault = parcelHelpers.interopDefault(_networkWifi2Bar);
var _networkWifi2BarOutlined = require("./NetworkWifi2BarOutlined");
var _networkWifi2BarOutlinedDefault = parcelHelpers.interopDefault(_networkWifi2BarOutlined);
var _networkWifi2BarRounded = require("./NetworkWifi2BarRounded");
var _networkWifi2BarRoundedDefault = parcelHelpers.interopDefault(_networkWifi2BarRounded);
var _networkWifi2BarSharp = require("./NetworkWifi2BarSharp");
var _networkWifi2BarSharpDefault = parcelHelpers.interopDefault(_networkWifi2BarSharp);
var _networkWifi2BarTwoTone = require("./NetworkWifi2BarTwoTone");
var _networkWifi2BarTwoToneDefault = parcelHelpers.interopDefault(_networkWifi2BarTwoTone);
var _networkWifi3Bar = require("./NetworkWifi3Bar");
var _networkWifi3BarDefault = parcelHelpers.interopDefault(_networkWifi3Bar);
var _networkWifi3BarOutlined = require("./NetworkWifi3BarOutlined");
var _networkWifi3BarOutlinedDefault = parcelHelpers.interopDefault(_networkWifi3BarOutlined);
var _networkWifi3BarRounded = require("./NetworkWifi3BarRounded");
var _networkWifi3BarRoundedDefault = parcelHelpers.interopDefault(_networkWifi3BarRounded);
var _networkWifi3BarSharp = require("./NetworkWifi3BarSharp");
var _networkWifi3BarSharpDefault = parcelHelpers.interopDefault(_networkWifi3BarSharp);
var _networkWifi3BarTwoTone = require("./NetworkWifi3BarTwoTone");
var _networkWifi3BarTwoToneDefault = parcelHelpers.interopDefault(_networkWifi3BarTwoTone);
var _networkWifiOutlined = require("./NetworkWifiOutlined");
var _networkWifiOutlinedDefault = parcelHelpers.interopDefault(_networkWifiOutlined);
var _networkWifiRounded = require("./NetworkWifiRounded");
var _networkWifiRoundedDefault = parcelHelpers.interopDefault(_networkWifiRounded);
var _networkWifiSharp = require("./NetworkWifiSharp");
var _networkWifiSharpDefault = parcelHelpers.interopDefault(_networkWifiSharp);
var _networkWifiTwoTone = require("./NetworkWifiTwoTone");
var _networkWifiTwoToneDefault = parcelHelpers.interopDefault(_networkWifiTwoTone);
var _newReleases = require("./NewReleases");
var _newReleasesDefault = parcelHelpers.interopDefault(_newReleases);
var _newReleasesOutlined = require("./NewReleasesOutlined");
var _newReleasesOutlinedDefault = parcelHelpers.interopDefault(_newReleasesOutlined);
var _newReleasesRounded = require("./NewReleasesRounded");
var _newReleasesRoundedDefault = parcelHelpers.interopDefault(_newReleasesRounded);
var _newReleasesSharp = require("./NewReleasesSharp");
var _newReleasesSharpDefault = parcelHelpers.interopDefault(_newReleasesSharp);
var _newReleasesTwoTone = require("./NewReleasesTwoTone");
var _newReleasesTwoToneDefault = parcelHelpers.interopDefault(_newReleasesTwoTone);
var _newspaper = require("./Newspaper");
var _newspaperDefault = parcelHelpers.interopDefault(_newspaper);
var _newspaperOutlined = require("./NewspaperOutlined");
var _newspaperOutlinedDefault = parcelHelpers.interopDefault(_newspaperOutlined);
var _newspaperRounded = require("./NewspaperRounded");
var _newspaperRoundedDefault = parcelHelpers.interopDefault(_newspaperRounded);
var _newspaperSharp = require("./NewspaperSharp");
var _newspaperSharpDefault = parcelHelpers.interopDefault(_newspaperSharp);
var _newspaperTwoTone = require("./NewspaperTwoTone");
var _newspaperTwoToneDefault = parcelHelpers.interopDefault(_newspaperTwoTone);
var _nextPlan = require("./NextPlan");
var _nextPlanDefault = parcelHelpers.interopDefault(_nextPlan);
var _nextPlanOutlined = require("./NextPlanOutlined");
var _nextPlanOutlinedDefault = parcelHelpers.interopDefault(_nextPlanOutlined);
var _nextPlanRounded = require("./NextPlanRounded");
var _nextPlanRoundedDefault = parcelHelpers.interopDefault(_nextPlanRounded);
var _nextPlanSharp = require("./NextPlanSharp");
var _nextPlanSharpDefault = parcelHelpers.interopDefault(_nextPlanSharp);
var _nextPlanTwoTone = require("./NextPlanTwoTone");
var _nextPlanTwoToneDefault = parcelHelpers.interopDefault(_nextPlanTwoTone);
var _nextWeek = require("./NextWeek");
var _nextWeekDefault = parcelHelpers.interopDefault(_nextWeek);
var _nextWeekOutlined = require("./NextWeekOutlined");
var _nextWeekOutlinedDefault = parcelHelpers.interopDefault(_nextWeekOutlined);
var _nextWeekRounded = require("./NextWeekRounded");
var _nextWeekRoundedDefault = parcelHelpers.interopDefault(_nextWeekRounded);
var _nextWeekSharp = require("./NextWeekSharp");
var _nextWeekSharpDefault = parcelHelpers.interopDefault(_nextWeekSharp);
var _nextWeekTwoTone = require("./NextWeekTwoTone");
var _nextWeekTwoToneDefault = parcelHelpers.interopDefault(_nextWeekTwoTone);
var _nfc = require("./Nfc");
var _nfcDefault = parcelHelpers.interopDefault(_nfc);
var _nfcOutlined = require("./NfcOutlined");
var _nfcOutlinedDefault = parcelHelpers.interopDefault(_nfcOutlined);
var _nfcRounded = require("./NfcRounded");
var _nfcRoundedDefault = parcelHelpers.interopDefault(_nfcRounded);
var _nfcSharp = require("./NfcSharp");
var _nfcSharpDefault = parcelHelpers.interopDefault(_nfcSharp);
var _nfcTwoTone = require("./NfcTwoTone");
var _nfcTwoToneDefault = parcelHelpers.interopDefault(_nfcTwoTone);
var _nightShelter = require("./NightShelter");
var _nightShelterDefault = parcelHelpers.interopDefault(_nightShelter);
var _nightShelterOutlined = require("./NightShelterOutlined");
var _nightShelterOutlinedDefault = parcelHelpers.interopDefault(_nightShelterOutlined);
var _nightShelterRounded = require("./NightShelterRounded");
var _nightShelterRoundedDefault = parcelHelpers.interopDefault(_nightShelterRounded);
var _nightShelterSharp = require("./NightShelterSharp");
var _nightShelterSharpDefault = parcelHelpers.interopDefault(_nightShelterSharp);
var _nightShelterTwoTone = require("./NightShelterTwoTone");
var _nightShelterTwoToneDefault = parcelHelpers.interopDefault(_nightShelterTwoTone);
var _nightlife = require("./Nightlife");
var _nightlifeDefault = parcelHelpers.interopDefault(_nightlife);
var _nightlifeOutlined = require("./NightlifeOutlined");
var _nightlifeOutlinedDefault = parcelHelpers.interopDefault(_nightlifeOutlined);
var _nightlifeRounded = require("./NightlifeRounded");
var _nightlifeRoundedDefault = parcelHelpers.interopDefault(_nightlifeRounded);
var _nightlifeSharp = require("./NightlifeSharp");
var _nightlifeSharpDefault = parcelHelpers.interopDefault(_nightlifeSharp);
var _nightlifeTwoTone = require("./NightlifeTwoTone");
var _nightlifeTwoToneDefault = parcelHelpers.interopDefault(_nightlifeTwoTone);
var _nightlight = require("./Nightlight");
var _nightlightDefault = parcelHelpers.interopDefault(_nightlight);
var _nightlightOutlined = require("./NightlightOutlined");
var _nightlightOutlinedDefault = parcelHelpers.interopDefault(_nightlightOutlined);
var _nightlightRound = require("./NightlightRound");
var _nightlightRoundDefault = parcelHelpers.interopDefault(_nightlightRound);
var _nightlightRoundOutlined = require("./NightlightRoundOutlined");
var _nightlightRoundOutlinedDefault = parcelHelpers.interopDefault(_nightlightRoundOutlined);
var _nightlightRoundRounded = require("./NightlightRoundRounded");
var _nightlightRoundRoundedDefault = parcelHelpers.interopDefault(_nightlightRoundRounded);
var _nightlightRoundSharp = require("./NightlightRoundSharp");
var _nightlightRoundSharpDefault = parcelHelpers.interopDefault(_nightlightRoundSharp);
var _nightlightRoundTwoTone = require("./NightlightRoundTwoTone");
var _nightlightRoundTwoToneDefault = parcelHelpers.interopDefault(_nightlightRoundTwoTone);
var _nightlightRounded = require("./NightlightRounded");
var _nightlightRoundedDefault = parcelHelpers.interopDefault(_nightlightRounded);
var _nightlightSharp = require("./NightlightSharp");
var _nightlightSharpDefault = parcelHelpers.interopDefault(_nightlightSharp);
var _nightlightTwoTone = require("./NightlightTwoTone");
var _nightlightTwoToneDefault = parcelHelpers.interopDefault(_nightlightTwoTone);
var _nightsStay = require("./NightsStay");
var _nightsStayDefault = parcelHelpers.interopDefault(_nightsStay);
var _nightsStayOutlined = require("./NightsStayOutlined");
var _nightsStayOutlinedDefault = parcelHelpers.interopDefault(_nightsStayOutlined);
var _nightsStayRounded = require("./NightsStayRounded");
var _nightsStayRoundedDefault = parcelHelpers.interopDefault(_nightsStayRounded);
var _nightsStaySharp = require("./NightsStaySharp");
var _nightsStaySharpDefault = parcelHelpers.interopDefault(_nightsStaySharp);
var _nightsStayTwoTone = require("./NightsStayTwoTone");
var _nightsStayTwoToneDefault = parcelHelpers.interopDefault(_nightsStayTwoTone);
var _nineK = require("./NineK");
var _nineKDefault = parcelHelpers.interopDefault(_nineK);
var _nineKOutlined = require("./NineKOutlined");
var _nineKOutlinedDefault = parcelHelpers.interopDefault(_nineKOutlined);
var _nineKPlus = require("./NineKPlus");
var _nineKPlusDefault = parcelHelpers.interopDefault(_nineKPlus);
var _nineKPlusOutlined = require("./NineKPlusOutlined");
var _nineKPlusOutlinedDefault = parcelHelpers.interopDefault(_nineKPlusOutlined);
var _nineKPlusRounded = require("./NineKPlusRounded");
var _nineKPlusRoundedDefault = parcelHelpers.interopDefault(_nineKPlusRounded);
var _nineKPlusSharp = require("./NineKPlusSharp");
var _nineKPlusSharpDefault = parcelHelpers.interopDefault(_nineKPlusSharp);
var _nineKPlusTwoTone = require("./NineKPlusTwoTone");
var _nineKPlusTwoToneDefault = parcelHelpers.interopDefault(_nineKPlusTwoTone);
var _nineKRounded = require("./NineKRounded");
var _nineKRoundedDefault = parcelHelpers.interopDefault(_nineKRounded);
var _nineKSharp = require("./NineKSharp");
var _nineKSharpDefault = parcelHelpers.interopDefault(_nineKSharp);
var _nineKTwoTone = require("./NineKTwoTone");
var _nineKTwoToneDefault = parcelHelpers.interopDefault(_nineKTwoTone);
var _nineMp = require("./NineMp");
var _nineMpDefault = parcelHelpers.interopDefault(_nineMp);
var _nineMpOutlined = require("./NineMpOutlined");
var _nineMpOutlinedDefault = parcelHelpers.interopDefault(_nineMpOutlined);
var _nineMpRounded = require("./NineMpRounded");
var _nineMpRoundedDefault = parcelHelpers.interopDefault(_nineMpRounded);
var _nineMpSharp = require("./NineMpSharp");
var _nineMpSharpDefault = parcelHelpers.interopDefault(_nineMpSharp);
var _nineMpTwoTone = require("./NineMpTwoTone");
var _nineMpTwoToneDefault = parcelHelpers.interopDefault(_nineMpTwoTone);
var _nineteenMp = require("./NineteenMp");
var _nineteenMpDefault = parcelHelpers.interopDefault(_nineteenMp);
var _nineteenMpOutlined = require("./NineteenMpOutlined");
var _nineteenMpOutlinedDefault = parcelHelpers.interopDefault(_nineteenMpOutlined);
var _nineteenMpRounded = require("./NineteenMpRounded");
var _nineteenMpRoundedDefault = parcelHelpers.interopDefault(_nineteenMpRounded);
var _nineteenMpSharp = require("./NineteenMpSharp");
var _nineteenMpSharpDefault = parcelHelpers.interopDefault(_nineteenMpSharp);
var _nineteenMpTwoTone = require("./NineteenMpTwoTone");
var _nineteenMpTwoToneDefault = parcelHelpers.interopDefault(_nineteenMpTwoTone);
var _noAccounts = require("./NoAccounts");
var _noAccountsDefault = parcelHelpers.interopDefault(_noAccounts);
var _noAccountsOutlined = require("./NoAccountsOutlined");
var _noAccountsOutlinedDefault = parcelHelpers.interopDefault(_noAccountsOutlined);
var _noAccountsRounded = require("./NoAccountsRounded");
var _noAccountsRoundedDefault = parcelHelpers.interopDefault(_noAccountsRounded);
var _noAccountsSharp = require("./NoAccountsSharp");
var _noAccountsSharpDefault = parcelHelpers.interopDefault(_noAccountsSharp);
var _noAccountsTwoTone = require("./NoAccountsTwoTone");
var _noAccountsTwoToneDefault = parcelHelpers.interopDefault(_noAccountsTwoTone);
var _noAdultContent = require("./NoAdultContent");
var _noAdultContentDefault = parcelHelpers.interopDefault(_noAdultContent);
var _noAdultContentOutlined = require("./NoAdultContentOutlined");
var _noAdultContentOutlinedDefault = parcelHelpers.interopDefault(_noAdultContentOutlined);
var _noAdultContentRounded = require("./NoAdultContentRounded");
var _noAdultContentRoundedDefault = parcelHelpers.interopDefault(_noAdultContentRounded);
var _noAdultContentSharp = require("./NoAdultContentSharp");
var _noAdultContentSharpDefault = parcelHelpers.interopDefault(_noAdultContentSharp);
var _noAdultContentTwoTone = require("./NoAdultContentTwoTone");
var _noAdultContentTwoToneDefault = parcelHelpers.interopDefault(_noAdultContentTwoTone);
var _noBackpack = require("./NoBackpack");
var _noBackpackDefault = parcelHelpers.interopDefault(_noBackpack);
var _noBackpackOutlined = require("./NoBackpackOutlined");
var _noBackpackOutlinedDefault = parcelHelpers.interopDefault(_noBackpackOutlined);
var _noBackpackRounded = require("./NoBackpackRounded");
var _noBackpackRoundedDefault = parcelHelpers.interopDefault(_noBackpackRounded);
var _noBackpackSharp = require("./NoBackpackSharp");
var _noBackpackSharpDefault = parcelHelpers.interopDefault(_noBackpackSharp);
var _noBackpackTwoTone = require("./NoBackpackTwoTone");
var _noBackpackTwoToneDefault = parcelHelpers.interopDefault(_noBackpackTwoTone);
var _noCell = require("./NoCell");
var _noCellDefault = parcelHelpers.interopDefault(_noCell);
var _noCellOutlined = require("./NoCellOutlined");
var _noCellOutlinedDefault = parcelHelpers.interopDefault(_noCellOutlined);
var _noCellRounded = require("./NoCellRounded");
var _noCellRoundedDefault = parcelHelpers.interopDefault(_noCellRounded);
var _noCellSharp = require("./NoCellSharp");
var _noCellSharpDefault = parcelHelpers.interopDefault(_noCellSharp);
var _noCellTwoTone = require("./NoCellTwoTone");
var _noCellTwoToneDefault = parcelHelpers.interopDefault(_noCellTwoTone);
var _noCrash = require("./NoCrash");
var _noCrashDefault = parcelHelpers.interopDefault(_noCrash);
var _noCrashOutlined = require("./NoCrashOutlined");
var _noCrashOutlinedDefault = parcelHelpers.interopDefault(_noCrashOutlined);
var _noCrashRounded = require("./NoCrashRounded");
var _noCrashRoundedDefault = parcelHelpers.interopDefault(_noCrashRounded);
var _noCrashSharp = require("./NoCrashSharp");
var _noCrashSharpDefault = parcelHelpers.interopDefault(_noCrashSharp);
var _noCrashTwoTone = require("./NoCrashTwoTone");
var _noCrashTwoToneDefault = parcelHelpers.interopDefault(_noCrashTwoTone);
var _noDrinks = require("./NoDrinks");
var _noDrinksDefault = parcelHelpers.interopDefault(_noDrinks);
var _noDrinksOutlined = require("./NoDrinksOutlined");
var _noDrinksOutlinedDefault = parcelHelpers.interopDefault(_noDrinksOutlined);
var _noDrinksRounded = require("./NoDrinksRounded");
var _noDrinksRoundedDefault = parcelHelpers.interopDefault(_noDrinksRounded);
var _noDrinksSharp = require("./NoDrinksSharp");
var _noDrinksSharpDefault = parcelHelpers.interopDefault(_noDrinksSharp);
var _noDrinksTwoTone = require("./NoDrinksTwoTone");
var _noDrinksTwoToneDefault = parcelHelpers.interopDefault(_noDrinksTwoTone);
var _noEncryption = require("./NoEncryption");
var _noEncryptionDefault = parcelHelpers.interopDefault(_noEncryption);
var _noEncryptionGmailerrorred = require("./NoEncryptionGmailerrorred");
var _noEncryptionGmailerrorredDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorred);
var _noEncryptionGmailerrorredOutlined = require("./NoEncryptionGmailerrorredOutlined");
var _noEncryptionGmailerrorredOutlinedDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorredOutlined);
var _noEncryptionGmailerrorredRounded = require("./NoEncryptionGmailerrorredRounded");
var _noEncryptionGmailerrorredRoundedDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorredRounded);
var _noEncryptionGmailerrorredSharp = require("./NoEncryptionGmailerrorredSharp");
var _noEncryptionGmailerrorredSharpDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorredSharp);
var _noEncryptionGmailerrorredTwoTone = require("./NoEncryptionGmailerrorredTwoTone");
var _noEncryptionGmailerrorredTwoToneDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorredTwoTone);
var _noEncryptionOutlined = require("./NoEncryptionOutlined");
var _noEncryptionOutlinedDefault = parcelHelpers.interopDefault(_noEncryptionOutlined);
var _noEncryptionRounded = require("./NoEncryptionRounded");
var _noEncryptionRoundedDefault = parcelHelpers.interopDefault(_noEncryptionRounded);
var _noEncryptionSharp = require("./NoEncryptionSharp");
var _noEncryptionSharpDefault = parcelHelpers.interopDefault(_noEncryptionSharp);
var _noEncryptionTwoTone = require("./NoEncryptionTwoTone");
var _noEncryptionTwoToneDefault = parcelHelpers.interopDefault(_noEncryptionTwoTone);
var _noFlash = require("./NoFlash");
var _noFlashDefault = parcelHelpers.interopDefault(_noFlash);
var _noFlashOutlined = require("./NoFlashOutlined");
var _noFlashOutlinedDefault = parcelHelpers.interopDefault(_noFlashOutlined);
var _noFlashRounded = require("./NoFlashRounded");
var _noFlashRoundedDefault = parcelHelpers.interopDefault(_noFlashRounded);
var _noFlashSharp = require("./NoFlashSharp");
var _noFlashSharpDefault = parcelHelpers.interopDefault(_noFlashSharp);
var _noFlashTwoTone = require("./NoFlashTwoTone");
var _noFlashTwoToneDefault = parcelHelpers.interopDefault(_noFlashTwoTone);
var _noFood = require("./NoFood");
var _noFoodDefault = parcelHelpers.interopDefault(_noFood);
var _noFoodOutlined = require("./NoFoodOutlined");
var _noFoodOutlinedDefault = parcelHelpers.interopDefault(_noFoodOutlined);
var _noFoodRounded = require("./NoFoodRounded");
var _noFoodRoundedDefault = parcelHelpers.interopDefault(_noFoodRounded);
var _noFoodSharp = require("./NoFoodSharp");
var _noFoodSharpDefault = parcelHelpers.interopDefault(_noFoodSharp);
var _noFoodTwoTone = require("./NoFoodTwoTone");
var _noFoodTwoToneDefault = parcelHelpers.interopDefault(_noFoodTwoTone);
var _noLuggage = require("./NoLuggage");
var _noLuggageDefault = parcelHelpers.interopDefault(_noLuggage);
var _noLuggageOutlined = require("./NoLuggageOutlined");
var _noLuggageOutlinedDefault = parcelHelpers.interopDefault(_noLuggageOutlined);
var _noLuggageRounded = require("./NoLuggageRounded");
var _noLuggageRoundedDefault = parcelHelpers.interopDefault(_noLuggageRounded);
var _noLuggageSharp = require("./NoLuggageSharp");
var _noLuggageSharpDefault = parcelHelpers.interopDefault(_noLuggageSharp);
var _noLuggageTwoTone = require("./NoLuggageTwoTone");
var _noLuggageTwoToneDefault = parcelHelpers.interopDefault(_noLuggageTwoTone);
var _noMeals = require("./NoMeals");
var _noMealsDefault = parcelHelpers.interopDefault(_noMeals);
var _noMealsOutlined = require("./NoMealsOutlined");
var _noMealsOutlinedDefault = parcelHelpers.interopDefault(_noMealsOutlined);
var _noMealsRounded = require("./NoMealsRounded");
var _noMealsRoundedDefault = parcelHelpers.interopDefault(_noMealsRounded);
var _noMealsSharp = require("./NoMealsSharp");
var _noMealsSharpDefault = parcelHelpers.interopDefault(_noMealsSharp);
var _noMealsTwoTone = require("./NoMealsTwoTone");
var _noMealsTwoToneDefault = parcelHelpers.interopDefault(_noMealsTwoTone);
var _noMeetingRoom = require("./NoMeetingRoom");
var _noMeetingRoomDefault = parcelHelpers.interopDefault(_noMeetingRoom);
var _noMeetingRoomOutlined = require("./NoMeetingRoomOutlined");
var _noMeetingRoomOutlinedDefault = parcelHelpers.interopDefault(_noMeetingRoomOutlined);
var _noMeetingRoomRounded = require("./NoMeetingRoomRounded");
var _noMeetingRoomRoundedDefault = parcelHelpers.interopDefault(_noMeetingRoomRounded);
var _noMeetingRoomSharp = require("./NoMeetingRoomSharp");
var _noMeetingRoomSharpDefault = parcelHelpers.interopDefault(_noMeetingRoomSharp);
var _noMeetingRoomTwoTone = require("./NoMeetingRoomTwoTone");
var _noMeetingRoomTwoToneDefault = parcelHelpers.interopDefault(_noMeetingRoomTwoTone);
var _noPhotography = require("./NoPhotography");
var _noPhotographyDefault = parcelHelpers.interopDefault(_noPhotography);
var _noPhotographyOutlined = require("./NoPhotographyOutlined");
var _noPhotographyOutlinedDefault = parcelHelpers.interopDefault(_noPhotographyOutlined);
var _noPhotographyRounded = require("./NoPhotographyRounded");
var _noPhotographyRoundedDefault = parcelHelpers.interopDefault(_noPhotographyRounded);
var _noPhotographySharp = require("./NoPhotographySharp");
var _noPhotographySharpDefault = parcelHelpers.interopDefault(_noPhotographySharp);
var _noPhotographyTwoTone = require("./NoPhotographyTwoTone");
var _noPhotographyTwoToneDefault = parcelHelpers.interopDefault(_noPhotographyTwoTone);
var _noSim = require("./NoSim");
var _noSimDefault = parcelHelpers.interopDefault(_noSim);
var _noSimOutlined = require("./NoSimOutlined");
var _noSimOutlinedDefault = parcelHelpers.interopDefault(_noSimOutlined);
var _noSimRounded = require("./NoSimRounded");
var _noSimRoundedDefault = parcelHelpers.interopDefault(_noSimRounded);
var _noSimSharp = require("./NoSimSharp");
var _noSimSharpDefault = parcelHelpers.interopDefault(_noSimSharp);
var _noSimTwoTone = require("./NoSimTwoTone");
var _noSimTwoToneDefault = parcelHelpers.interopDefault(_noSimTwoTone);
var _noStroller = require("./NoStroller");
var _noStrollerDefault = parcelHelpers.interopDefault(_noStroller);
var _noStrollerOutlined = require("./NoStrollerOutlined");
var _noStrollerOutlinedDefault = parcelHelpers.interopDefault(_noStrollerOutlined);
var _noStrollerRounded = require("./NoStrollerRounded");
var _noStrollerRoundedDefault = parcelHelpers.interopDefault(_noStrollerRounded);
var _noStrollerSharp = require("./NoStrollerSharp");
var _noStrollerSharpDefault = parcelHelpers.interopDefault(_noStrollerSharp);
var _noStrollerTwoTone = require("./NoStrollerTwoTone");
var _noStrollerTwoToneDefault = parcelHelpers.interopDefault(_noStrollerTwoTone);
var _noTransfer = require("./NoTransfer");
var _noTransferDefault = parcelHelpers.interopDefault(_noTransfer);
var _noTransferOutlined = require("./NoTransferOutlined");
var _noTransferOutlinedDefault = parcelHelpers.interopDefault(_noTransferOutlined);
var _noTransferRounded = require("./NoTransferRounded");
var _noTransferRoundedDefault = parcelHelpers.interopDefault(_noTransferRounded);
var _noTransferSharp = require("./NoTransferSharp");
var _noTransferSharpDefault = parcelHelpers.interopDefault(_noTransferSharp);
var _noTransferTwoTone = require("./NoTransferTwoTone");
var _noTransferTwoToneDefault = parcelHelpers.interopDefault(_noTransferTwoTone);
var _noiseAware = require("./NoiseAware");
var _noiseAwareDefault = parcelHelpers.interopDefault(_noiseAware);
var _noiseAwareOutlined = require("./NoiseAwareOutlined");
var _noiseAwareOutlinedDefault = parcelHelpers.interopDefault(_noiseAwareOutlined);
var _noiseAwareRounded = require("./NoiseAwareRounded");
var _noiseAwareRoundedDefault = parcelHelpers.interopDefault(_noiseAwareRounded);
var _noiseAwareSharp = require("./NoiseAwareSharp");
var _noiseAwareSharpDefault = parcelHelpers.interopDefault(_noiseAwareSharp);
var _noiseAwareTwoTone = require("./NoiseAwareTwoTone");
var _noiseAwareTwoToneDefault = parcelHelpers.interopDefault(_noiseAwareTwoTone);
var _noiseControlOff = require("./NoiseControlOff");
var _noiseControlOffDefault = parcelHelpers.interopDefault(_noiseControlOff);
var _noiseControlOffOutlined = require("./NoiseControlOffOutlined");
var _noiseControlOffOutlinedDefault = parcelHelpers.interopDefault(_noiseControlOffOutlined);
var _noiseControlOffRounded = require("./NoiseControlOffRounded");
var _noiseControlOffRoundedDefault = parcelHelpers.interopDefault(_noiseControlOffRounded);
var _noiseControlOffSharp = require("./NoiseControlOffSharp");
var _noiseControlOffSharpDefault = parcelHelpers.interopDefault(_noiseControlOffSharp);
var _noiseControlOffTwoTone = require("./NoiseControlOffTwoTone");
var _noiseControlOffTwoToneDefault = parcelHelpers.interopDefault(_noiseControlOffTwoTone);
var _nordicWalking = require("./NordicWalking");
var _nordicWalkingDefault = parcelHelpers.interopDefault(_nordicWalking);
var _nordicWalkingOutlined = require("./NordicWalkingOutlined");
var _nordicWalkingOutlinedDefault = parcelHelpers.interopDefault(_nordicWalkingOutlined);
var _nordicWalkingRounded = require("./NordicWalkingRounded");
var _nordicWalkingRoundedDefault = parcelHelpers.interopDefault(_nordicWalkingRounded);
var _nordicWalkingSharp = require("./NordicWalkingSharp");
var _nordicWalkingSharpDefault = parcelHelpers.interopDefault(_nordicWalkingSharp);
var _nordicWalkingTwoTone = require("./NordicWalkingTwoTone");
var _nordicWalkingTwoToneDefault = parcelHelpers.interopDefault(_nordicWalkingTwoTone);
var _north = require("./North");
var _northDefault = parcelHelpers.interopDefault(_north);
var _northEast = require("./NorthEast");
var _northEastDefault = parcelHelpers.interopDefault(_northEast);
var _northEastOutlined = require("./NorthEastOutlined");
var _northEastOutlinedDefault = parcelHelpers.interopDefault(_northEastOutlined);
var _northEastRounded = require("./NorthEastRounded");
var _northEastRoundedDefault = parcelHelpers.interopDefault(_northEastRounded);
var _northEastSharp = require("./NorthEastSharp");
var _northEastSharpDefault = parcelHelpers.interopDefault(_northEastSharp);
var _northEastTwoTone = require("./NorthEastTwoTone");
var _northEastTwoToneDefault = parcelHelpers.interopDefault(_northEastTwoTone);
var _northOutlined = require("./NorthOutlined");
var _northOutlinedDefault = parcelHelpers.interopDefault(_northOutlined);
var _northRounded = require("./NorthRounded");
var _northRoundedDefault = parcelHelpers.interopDefault(_northRounded);
var _northSharp = require("./NorthSharp");
var _northSharpDefault = parcelHelpers.interopDefault(_northSharp);
var _northTwoTone = require("./NorthTwoTone");
var _northTwoToneDefault = parcelHelpers.interopDefault(_northTwoTone);
var _northWest = require("./NorthWest");
var _northWestDefault = parcelHelpers.interopDefault(_northWest);
var _northWestOutlined = require("./NorthWestOutlined");
var _northWestOutlinedDefault = parcelHelpers.interopDefault(_northWestOutlined);
var _northWestRounded = require("./NorthWestRounded");
var _northWestRoundedDefault = parcelHelpers.interopDefault(_northWestRounded);
var _northWestSharp = require("./NorthWestSharp");
var _northWestSharpDefault = parcelHelpers.interopDefault(_northWestSharp);
var _northWestTwoTone = require("./NorthWestTwoTone");
var _northWestTwoToneDefault = parcelHelpers.interopDefault(_northWestTwoTone);
var _notAccessible = require("./NotAccessible");
var _notAccessibleDefault = parcelHelpers.interopDefault(_notAccessible);
var _notAccessibleOutlined = require("./NotAccessibleOutlined");
var _notAccessibleOutlinedDefault = parcelHelpers.interopDefault(_notAccessibleOutlined);
var _notAccessibleRounded = require("./NotAccessibleRounded");
var _notAccessibleRoundedDefault = parcelHelpers.interopDefault(_notAccessibleRounded);
var _notAccessibleSharp = require("./NotAccessibleSharp");
var _notAccessibleSharpDefault = parcelHelpers.interopDefault(_notAccessibleSharp);
var _notAccessibleTwoTone = require("./NotAccessibleTwoTone");
var _notAccessibleTwoToneDefault = parcelHelpers.interopDefault(_notAccessibleTwoTone);
var _notInterested = require("./NotInterested");
var _notInterestedDefault = parcelHelpers.interopDefault(_notInterested);
var _notInterestedOutlined = require("./NotInterestedOutlined");
var _notInterestedOutlinedDefault = parcelHelpers.interopDefault(_notInterestedOutlined);
var _notInterestedRounded = require("./NotInterestedRounded");
var _notInterestedRoundedDefault = parcelHelpers.interopDefault(_notInterestedRounded);
var _notInterestedSharp = require("./NotInterestedSharp");
var _notInterestedSharpDefault = parcelHelpers.interopDefault(_notInterestedSharp);
var _notInterestedTwoTone = require("./NotInterestedTwoTone");
var _notInterestedTwoToneDefault = parcelHelpers.interopDefault(_notInterestedTwoTone);
var _notListedLocation = require("./NotListedLocation");
var _notListedLocationDefault = parcelHelpers.interopDefault(_notListedLocation);
var _notListedLocationOutlined = require("./NotListedLocationOutlined");
var _notListedLocationOutlinedDefault = parcelHelpers.interopDefault(_notListedLocationOutlined);
var _notListedLocationRounded = require("./NotListedLocationRounded");
var _notListedLocationRoundedDefault = parcelHelpers.interopDefault(_notListedLocationRounded);
var _notListedLocationSharp = require("./NotListedLocationSharp");
var _notListedLocationSharpDefault = parcelHelpers.interopDefault(_notListedLocationSharp);
var _notListedLocationTwoTone = require("./NotListedLocationTwoTone");
var _notListedLocationTwoToneDefault = parcelHelpers.interopDefault(_notListedLocationTwoTone);
var _notStarted = require("./NotStarted");
var _notStartedDefault = parcelHelpers.interopDefault(_notStarted);
var _notStartedOutlined = require("./NotStartedOutlined");
var _notStartedOutlinedDefault = parcelHelpers.interopDefault(_notStartedOutlined);
var _notStartedRounded = require("./NotStartedRounded");
var _notStartedRoundedDefault = parcelHelpers.interopDefault(_notStartedRounded);
var _notStartedSharp = require("./NotStartedSharp");
var _notStartedSharpDefault = parcelHelpers.interopDefault(_notStartedSharp);
var _notStartedTwoTone = require("./NotStartedTwoTone");
var _notStartedTwoToneDefault = parcelHelpers.interopDefault(_notStartedTwoTone);
var _note = require("./Note");
var _noteDefault = parcelHelpers.interopDefault(_note);
var _noteAdd = require("./NoteAdd");
var _noteAddDefault = parcelHelpers.interopDefault(_noteAdd);
var _noteAddOutlined = require("./NoteAddOutlined");
var _noteAddOutlinedDefault = parcelHelpers.interopDefault(_noteAddOutlined);
var _noteAddRounded = require("./NoteAddRounded");
var _noteAddRoundedDefault = parcelHelpers.interopDefault(_noteAddRounded);
var _noteAddSharp = require("./NoteAddSharp");
var _noteAddSharpDefault = parcelHelpers.interopDefault(_noteAddSharp);
var _noteAddTwoTone = require("./NoteAddTwoTone");
var _noteAddTwoToneDefault = parcelHelpers.interopDefault(_noteAddTwoTone);
var _noteAlt = require("./NoteAlt");
var _noteAltDefault = parcelHelpers.interopDefault(_noteAlt);
var _noteAltOutlined = require("./NoteAltOutlined");
var _noteAltOutlinedDefault = parcelHelpers.interopDefault(_noteAltOutlined);
var _noteAltRounded = require("./NoteAltRounded");
var _noteAltRoundedDefault = parcelHelpers.interopDefault(_noteAltRounded);
var _noteAltSharp = require("./NoteAltSharp");
var _noteAltSharpDefault = parcelHelpers.interopDefault(_noteAltSharp);
var _noteAltTwoTone = require("./NoteAltTwoTone");
var _noteAltTwoToneDefault = parcelHelpers.interopDefault(_noteAltTwoTone);
var _noteOutlined = require("./NoteOutlined");
var _noteOutlinedDefault = parcelHelpers.interopDefault(_noteOutlined);
var _noteRounded = require("./NoteRounded");
var _noteRoundedDefault = parcelHelpers.interopDefault(_noteRounded);
var _noteSharp = require("./NoteSharp");
var _noteSharpDefault = parcelHelpers.interopDefault(_noteSharp);
var _noteTwoTone = require("./NoteTwoTone");
var _noteTwoToneDefault = parcelHelpers.interopDefault(_noteTwoTone);
var _notes = require("./Notes");
var _notesDefault = parcelHelpers.interopDefault(_notes);
var _notesOutlined = require("./NotesOutlined");
var _notesOutlinedDefault = parcelHelpers.interopDefault(_notesOutlined);
var _notesRounded = require("./NotesRounded");
var _notesRoundedDefault = parcelHelpers.interopDefault(_notesRounded);
var _notesSharp = require("./NotesSharp");
var _notesSharpDefault = parcelHelpers.interopDefault(_notesSharp);
var _notesTwoTone = require("./NotesTwoTone");
var _notesTwoToneDefault = parcelHelpers.interopDefault(_notesTwoTone);
var _notificationAdd = require("./NotificationAdd");
var _notificationAddDefault = parcelHelpers.interopDefault(_notificationAdd);
var _notificationAddOutlined = require("./NotificationAddOutlined");
var _notificationAddOutlinedDefault = parcelHelpers.interopDefault(_notificationAddOutlined);
var _notificationAddRounded = require("./NotificationAddRounded");
var _notificationAddRoundedDefault = parcelHelpers.interopDefault(_notificationAddRounded);
var _notificationAddSharp = require("./NotificationAddSharp");
var _notificationAddSharpDefault = parcelHelpers.interopDefault(_notificationAddSharp);
var _notificationAddTwoTone = require("./NotificationAddTwoTone");
var _notificationAddTwoToneDefault = parcelHelpers.interopDefault(_notificationAddTwoTone);
var _notificationImportant = require("./NotificationImportant");
var _notificationImportantDefault = parcelHelpers.interopDefault(_notificationImportant);
var _notificationImportantOutlined = require("./NotificationImportantOutlined");
var _notificationImportantOutlinedDefault = parcelHelpers.interopDefault(_notificationImportantOutlined);
var _notificationImportantRounded = require("./NotificationImportantRounded");
var _notificationImportantRoundedDefault = parcelHelpers.interopDefault(_notificationImportantRounded);
var _notificationImportantSharp = require("./NotificationImportantSharp");
var _notificationImportantSharpDefault = parcelHelpers.interopDefault(_notificationImportantSharp);
var _notificationImportantTwoTone = require("./NotificationImportantTwoTone");
var _notificationImportantTwoToneDefault = parcelHelpers.interopDefault(_notificationImportantTwoTone);
var _notifications = require("./Notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _notificationsActive = require("./NotificationsActive");
var _notificationsActiveDefault = parcelHelpers.interopDefault(_notificationsActive);
var _notificationsActiveOutlined = require("./NotificationsActiveOutlined");
var _notificationsActiveOutlinedDefault = parcelHelpers.interopDefault(_notificationsActiveOutlined);
var _notificationsActiveRounded = require("./NotificationsActiveRounded");
var _notificationsActiveRoundedDefault = parcelHelpers.interopDefault(_notificationsActiveRounded);
var _notificationsActiveSharp = require("./NotificationsActiveSharp");
var _notificationsActiveSharpDefault = parcelHelpers.interopDefault(_notificationsActiveSharp);
var _notificationsActiveTwoTone = require("./NotificationsActiveTwoTone");
var _notificationsActiveTwoToneDefault = parcelHelpers.interopDefault(_notificationsActiveTwoTone);
var _notificationsNone = require("./NotificationsNone");
var _notificationsNoneDefault = parcelHelpers.interopDefault(_notificationsNone);
var _notificationsNoneOutlined = require("./NotificationsNoneOutlined");
var _notificationsNoneOutlinedDefault = parcelHelpers.interopDefault(_notificationsNoneOutlined);
var _notificationsNoneRounded = require("./NotificationsNoneRounded");
var _notificationsNoneRoundedDefault = parcelHelpers.interopDefault(_notificationsNoneRounded);
var _notificationsNoneSharp = require("./NotificationsNoneSharp");
var _notificationsNoneSharpDefault = parcelHelpers.interopDefault(_notificationsNoneSharp);
var _notificationsNoneTwoTone = require("./NotificationsNoneTwoTone");
var _notificationsNoneTwoToneDefault = parcelHelpers.interopDefault(_notificationsNoneTwoTone);
var _notificationsOff = require("./NotificationsOff");
var _notificationsOffDefault = parcelHelpers.interopDefault(_notificationsOff);
var _notificationsOffOutlined = require("./NotificationsOffOutlined");
var _notificationsOffOutlinedDefault = parcelHelpers.interopDefault(_notificationsOffOutlined);
var _notificationsOffRounded = require("./NotificationsOffRounded");
var _notificationsOffRoundedDefault = parcelHelpers.interopDefault(_notificationsOffRounded);
var _notificationsOffSharp = require("./NotificationsOffSharp");
var _notificationsOffSharpDefault = parcelHelpers.interopDefault(_notificationsOffSharp);
var _notificationsOffTwoTone = require("./NotificationsOffTwoTone");
var _notificationsOffTwoToneDefault = parcelHelpers.interopDefault(_notificationsOffTwoTone);
var _notificationsOutlined = require("./NotificationsOutlined");
var _notificationsOutlinedDefault = parcelHelpers.interopDefault(_notificationsOutlined);
var _notificationsPaused = require("./NotificationsPaused");
var _notificationsPausedDefault = parcelHelpers.interopDefault(_notificationsPaused);
var _notificationsPausedOutlined = require("./NotificationsPausedOutlined");
var _notificationsPausedOutlinedDefault = parcelHelpers.interopDefault(_notificationsPausedOutlined);
var _notificationsPausedRounded = require("./NotificationsPausedRounded");
var _notificationsPausedRoundedDefault = parcelHelpers.interopDefault(_notificationsPausedRounded);
var _notificationsPausedSharp = require("./NotificationsPausedSharp");
var _notificationsPausedSharpDefault = parcelHelpers.interopDefault(_notificationsPausedSharp);
var _notificationsPausedTwoTone = require("./NotificationsPausedTwoTone");
var _notificationsPausedTwoToneDefault = parcelHelpers.interopDefault(_notificationsPausedTwoTone);
var _notificationsRounded = require("./NotificationsRounded");
var _notificationsRoundedDefault = parcelHelpers.interopDefault(_notificationsRounded);
var _notificationsSharp = require("./NotificationsSharp");
var _notificationsSharpDefault = parcelHelpers.interopDefault(_notificationsSharp);
var _notificationsTwoTone = require("./NotificationsTwoTone");
var _notificationsTwoToneDefault = parcelHelpers.interopDefault(_notificationsTwoTone);
var _numbers = require("./Numbers");
var _numbersDefault = parcelHelpers.interopDefault(_numbers);
var _numbersOutlined = require("./NumbersOutlined");
var _numbersOutlinedDefault = parcelHelpers.interopDefault(_numbersOutlined);
var _numbersRounded = require("./NumbersRounded");
var _numbersRoundedDefault = parcelHelpers.interopDefault(_numbersRounded);
var _numbersSharp = require("./NumbersSharp");
var _numbersSharpDefault = parcelHelpers.interopDefault(_numbersSharp);
var _numbersTwoTone = require("./NumbersTwoTone");
var _numbersTwoToneDefault = parcelHelpers.interopDefault(_numbersTwoTone);
var _offlineBolt = require("./OfflineBolt");
var _offlineBoltDefault = parcelHelpers.interopDefault(_offlineBolt);
var _offlineBoltOutlined = require("./OfflineBoltOutlined");
var _offlineBoltOutlinedDefault = parcelHelpers.interopDefault(_offlineBoltOutlined);
var _offlineBoltRounded = require("./OfflineBoltRounded");
var _offlineBoltRoundedDefault = parcelHelpers.interopDefault(_offlineBoltRounded);
var _offlineBoltSharp = require("./OfflineBoltSharp");
var _offlineBoltSharpDefault = parcelHelpers.interopDefault(_offlineBoltSharp);
var _offlineBoltTwoTone = require("./OfflineBoltTwoTone");
var _offlineBoltTwoToneDefault = parcelHelpers.interopDefault(_offlineBoltTwoTone);
var _offlinePin = require("./OfflinePin");
var _offlinePinDefault = parcelHelpers.interopDefault(_offlinePin);
var _offlinePinOutlined = require("./OfflinePinOutlined");
var _offlinePinOutlinedDefault = parcelHelpers.interopDefault(_offlinePinOutlined);
var _offlinePinRounded = require("./OfflinePinRounded");
var _offlinePinRoundedDefault = parcelHelpers.interopDefault(_offlinePinRounded);
var _offlinePinSharp = require("./OfflinePinSharp");
var _offlinePinSharpDefault = parcelHelpers.interopDefault(_offlinePinSharp);
var _offlinePinTwoTone = require("./OfflinePinTwoTone");
var _offlinePinTwoToneDefault = parcelHelpers.interopDefault(_offlinePinTwoTone);
var _offlineShare = require("./OfflineShare");
var _offlineShareDefault = parcelHelpers.interopDefault(_offlineShare);
var _offlineShareOutlined = require("./OfflineShareOutlined");
var _offlineShareOutlinedDefault = parcelHelpers.interopDefault(_offlineShareOutlined);
var _offlineShareRounded = require("./OfflineShareRounded");
var _offlineShareRoundedDefault = parcelHelpers.interopDefault(_offlineShareRounded);
var _offlineShareSharp = require("./OfflineShareSharp");
var _offlineShareSharpDefault = parcelHelpers.interopDefault(_offlineShareSharp);
var _offlineShareTwoTone = require("./OfflineShareTwoTone");
var _offlineShareTwoToneDefault = parcelHelpers.interopDefault(_offlineShareTwoTone);
var _oilBarrel = require("./OilBarrel");
var _oilBarrelDefault = parcelHelpers.interopDefault(_oilBarrel);
var _oilBarrelOutlined = require("./OilBarrelOutlined");
var _oilBarrelOutlinedDefault = parcelHelpers.interopDefault(_oilBarrelOutlined);
var _oilBarrelRounded = require("./OilBarrelRounded");
var _oilBarrelRoundedDefault = parcelHelpers.interopDefault(_oilBarrelRounded);
var _oilBarrelSharp = require("./OilBarrelSharp");
var _oilBarrelSharpDefault = parcelHelpers.interopDefault(_oilBarrelSharp);
var _oilBarrelTwoTone = require("./OilBarrelTwoTone");
var _oilBarrelTwoToneDefault = parcelHelpers.interopDefault(_oilBarrelTwoTone);
var _onDeviceTraining = require("./OnDeviceTraining");
var _onDeviceTrainingDefault = parcelHelpers.interopDefault(_onDeviceTraining);
var _onDeviceTrainingOutlined = require("./OnDeviceTrainingOutlined");
var _onDeviceTrainingOutlinedDefault = parcelHelpers.interopDefault(_onDeviceTrainingOutlined);
var _onDeviceTrainingRounded = require("./OnDeviceTrainingRounded");
var _onDeviceTrainingRoundedDefault = parcelHelpers.interopDefault(_onDeviceTrainingRounded);
var _onDeviceTrainingSharp = require("./OnDeviceTrainingSharp");
var _onDeviceTrainingSharpDefault = parcelHelpers.interopDefault(_onDeviceTrainingSharp);
var _onDeviceTrainingTwoTone = require("./OnDeviceTrainingTwoTone");
var _onDeviceTrainingTwoToneDefault = parcelHelpers.interopDefault(_onDeviceTrainingTwoTone);
var _ondemandVideo = require("./OndemandVideo");
var _ondemandVideoDefault = parcelHelpers.interopDefault(_ondemandVideo);
var _ondemandVideoOutlined = require("./OndemandVideoOutlined");
var _ondemandVideoOutlinedDefault = parcelHelpers.interopDefault(_ondemandVideoOutlined);
var _ondemandVideoRounded = require("./OndemandVideoRounded");
var _ondemandVideoRoundedDefault = parcelHelpers.interopDefault(_ondemandVideoRounded);
var _ondemandVideoSharp = require("./OndemandVideoSharp");
var _ondemandVideoSharpDefault = parcelHelpers.interopDefault(_ondemandVideoSharp);
var _ondemandVideoTwoTone = require("./OndemandVideoTwoTone");
var _ondemandVideoTwoToneDefault = parcelHelpers.interopDefault(_ondemandVideoTwoTone);
var _oneK = require("./OneK");
var _oneKDefault = parcelHelpers.interopDefault(_oneK);
var _oneKOutlined = require("./OneKOutlined");
var _oneKOutlinedDefault = parcelHelpers.interopDefault(_oneKOutlined);
var _oneKPlus = require("./OneKPlus");
var _oneKPlusDefault = parcelHelpers.interopDefault(_oneKPlus);
var _oneKPlusOutlined = require("./OneKPlusOutlined");
var _oneKPlusOutlinedDefault = parcelHelpers.interopDefault(_oneKPlusOutlined);
var _oneKPlusRounded = require("./OneKPlusRounded");
var _oneKPlusRoundedDefault = parcelHelpers.interopDefault(_oneKPlusRounded);
var _oneKPlusSharp = require("./OneKPlusSharp");
var _oneKPlusSharpDefault = parcelHelpers.interopDefault(_oneKPlusSharp);
var _oneKPlusTwoTone = require("./OneKPlusTwoTone");
var _oneKPlusTwoToneDefault = parcelHelpers.interopDefault(_oneKPlusTwoTone);
var _oneKRounded = require("./OneKRounded");
var _oneKRoundedDefault = parcelHelpers.interopDefault(_oneKRounded);
var _oneKSharp = require("./OneKSharp");
var _oneKSharpDefault = parcelHelpers.interopDefault(_oneKSharp);
var _oneKTwoTone = require("./OneKTwoTone");
var _oneKTwoToneDefault = parcelHelpers.interopDefault(_oneKTwoTone);
var _oneKk = require("./OneKk");
var _oneKkDefault = parcelHelpers.interopDefault(_oneKk);
var _oneKkOutlined = require("./OneKkOutlined");
var _oneKkOutlinedDefault = parcelHelpers.interopDefault(_oneKkOutlined);
var _oneKkRounded = require("./OneKkRounded");
var _oneKkRoundedDefault = parcelHelpers.interopDefault(_oneKkRounded);
var _oneKkSharp = require("./OneKkSharp");
var _oneKkSharpDefault = parcelHelpers.interopDefault(_oneKkSharp);
var _oneKkTwoTone = require("./OneKkTwoTone");
var _oneKkTwoToneDefault = parcelHelpers.interopDefault(_oneKkTwoTone);
var _onlinePrediction = require("./OnlinePrediction");
var _onlinePredictionDefault = parcelHelpers.interopDefault(_onlinePrediction);
var _onlinePredictionOutlined = require("./OnlinePredictionOutlined");
var _onlinePredictionOutlinedDefault = parcelHelpers.interopDefault(_onlinePredictionOutlined);
var _onlinePredictionRounded = require("./OnlinePredictionRounded");
var _onlinePredictionRoundedDefault = parcelHelpers.interopDefault(_onlinePredictionRounded);
var _onlinePredictionSharp = require("./OnlinePredictionSharp");
var _onlinePredictionSharpDefault = parcelHelpers.interopDefault(_onlinePredictionSharp);
var _onlinePredictionTwoTone = require("./OnlinePredictionTwoTone");
var _onlinePredictionTwoToneDefault = parcelHelpers.interopDefault(_onlinePredictionTwoTone);
var _opacity = require("./Opacity");
var _opacityDefault = parcelHelpers.interopDefault(_opacity);
var _opacityOutlined = require("./OpacityOutlined");
var _opacityOutlinedDefault = parcelHelpers.interopDefault(_opacityOutlined);
var _opacityRounded = require("./OpacityRounded");
var _opacityRoundedDefault = parcelHelpers.interopDefault(_opacityRounded);
var _opacitySharp = require("./OpacitySharp");
var _opacitySharpDefault = parcelHelpers.interopDefault(_opacitySharp);
var _opacityTwoTone = require("./OpacityTwoTone");
var _opacityTwoToneDefault = parcelHelpers.interopDefault(_opacityTwoTone);
var _openInBrowser = require("./OpenInBrowser");
var _openInBrowserDefault = parcelHelpers.interopDefault(_openInBrowser);
var _openInBrowserOutlined = require("./OpenInBrowserOutlined");
var _openInBrowserOutlinedDefault = parcelHelpers.interopDefault(_openInBrowserOutlined);
var _openInBrowserRounded = require("./OpenInBrowserRounded");
var _openInBrowserRoundedDefault = parcelHelpers.interopDefault(_openInBrowserRounded);
var _openInBrowserSharp = require("./OpenInBrowserSharp");
var _openInBrowserSharpDefault = parcelHelpers.interopDefault(_openInBrowserSharp);
var _openInBrowserTwoTone = require("./OpenInBrowserTwoTone");
var _openInBrowserTwoToneDefault = parcelHelpers.interopDefault(_openInBrowserTwoTone);
var _openInFull = require("./OpenInFull");
var _openInFullDefault = parcelHelpers.interopDefault(_openInFull);
var _openInFullOutlined = require("./OpenInFullOutlined");
var _openInFullOutlinedDefault = parcelHelpers.interopDefault(_openInFullOutlined);
var _openInFullRounded = require("./OpenInFullRounded");
var _openInFullRoundedDefault = parcelHelpers.interopDefault(_openInFullRounded);
var _openInFullSharp = require("./OpenInFullSharp");
var _openInFullSharpDefault = parcelHelpers.interopDefault(_openInFullSharp);
var _openInFullTwoTone = require("./OpenInFullTwoTone");
var _openInFullTwoToneDefault = parcelHelpers.interopDefault(_openInFullTwoTone);
var _openInNew = require("./OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _openInNewOff = require("./OpenInNewOff");
var _openInNewOffDefault = parcelHelpers.interopDefault(_openInNewOff);
var _openInNewOffOutlined = require("./OpenInNewOffOutlined");
var _openInNewOffOutlinedDefault = parcelHelpers.interopDefault(_openInNewOffOutlined);
var _openInNewOffRounded = require("./OpenInNewOffRounded");
var _openInNewOffRoundedDefault = parcelHelpers.interopDefault(_openInNewOffRounded);
var _openInNewOffSharp = require("./OpenInNewOffSharp");
var _openInNewOffSharpDefault = parcelHelpers.interopDefault(_openInNewOffSharp);
var _openInNewOffTwoTone = require("./OpenInNewOffTwoTone");
var _openInNewOffTwoToneDefault = parcelHelpers.interopDefault(_openInNewOffTwoTone);
var _openInNewOutlined = require("./OpenInNewOutlined");
var _openInNewOutlinedDefault = parcelHelpers.interopDefault(_openInNewOutlined);
var _openInNewRounded = require("./OpenInNewRounded");
var _openInNewRoundedDefault = parcelHelpers.interopDefault(_openInNewRounded);
var _openInNewSharp = require("./OpenInNewSharp");
var _openInNewSharpDefault = parcelHelpers.interopDefault(_openInNewSharp);
var _openInNewTwoTone = require("./OpenInNewTwoTone");
var _openInNewTwoToneDefault = parcelHelpers.interopDefault(_openInNewTwoTone);
var _openWith = require("./OpenWith");
var _openWithDefault = parcelHelpers.interopDefault(_openWith);
var _openWithOutlined = require("./OpenWithOutlined");
var _openWithOutlinedDefault = parcelHelpers.interopDefault(_openWithOutlined);
var _openWithRounded = require("./OpenWithRounded");
var _openWithRoundedDefault = parcelHelpers.interopDefault(_openWithRounded);
var _openWithSharp = require("./OpenWithSharp");
var _openWithSharpDefault = parcelHelpers.interopDefault(_openWithSharp);
var _openWithTwoTone = require("./OpenWithTwoTone");
var _openWithTwoToneDefault = parcelHelpers.interopDefault(_openWithTwoTone);
var _otherHouses = require("./OtherHouses");
var _otherHousesDefault = parcelHelpers.interopDefault(_otherHouses);
var _otherHousesOutlined = require("./OtherHousesOutlined");
var _otherHousesOutlinedDefault = parcelHelpers.interopDefault(_otherHousesOutlined);
var _otherHousesRounded = require("./OtherHousesRounded");
var _otherHousesRoundedDefault = parcelHelpers.interopDefault(_otherHousesRounded);
var _otherHousesSharp = require("./OtherHousesSharp");
var _otherHousesSharpDefault = parcelHelpers.interopDefault(_otherHousesSharp);
var _otherHousesTwoTone = require("./OtherHousesTwoTone");
var _otherHousesTwoToneDefault = parcelHelpers.interopDefault(_otherHousesTwoTone);
var _outbound = require("./Outbound");
var _outboundDefault = parcelHelpers.interopDefault(_outbound);
var _outboundOutlined = require("./OutboundOutlined");
var _outboundOutlinedDefault = parcelHelpers.interopDefault(_outboundOutlined);
var _outboundRounded = require("./OutboundRounded");
var _outboundRoundedDefault = parcelHelpers.interopDefault(_outboundRounded);
var _outboundSharp = require("./OutboundSharp");
var _outboundSharpDefault = parcelHelpers.interopDefault(_outboundSharp);
var _outboundTwoTone = require("./OutboundTwoTone");
var _outboundTwoToneDefault = parcelHelpers.interopDefault(_outboundTwoTone);
var _outbox = require("./Outbox");
var _outboxDefault = parcelHelpers.interopDefault(_outbox);
var _outboxOutlined = require("./OutboxOutlined");
var _outboxOutlinedDefault = parcelHelpers.interopDefault(_outboxOutlined);
var _outboxRounded = require("./OutboxRounded");
var _outboxRoundedDefault = parcelHelpers.interopDefault(_outboxRounded);
var _outboxSharp = require("./OutboxSharp");
var _outboxSharpDefault = parcelHelpers.interopDefault(_outboxSharp);
var _outboxTwoTone = require("./OutboxTwoTone");
var _outboxTwoToneDefault = parcelHelpers.interopDefault(_outboxTwoTone);
var _outdoorGrill = require("./OutdoorGrill");
var _outdoorGrillDefault = parcelHelpers.interopDefault(_outdoorGrill);
var _outdoorGrillOutlined = require("./OutdoorGrillOutlined");
var _outdoorGrillOutlinedDefault = parcelHelpers.interopDefault(_outdoorGrillOutlined);
var _outdoorGrillRounded = require("./OutdoorGrillRounded");
var _outdoorGrillRoundedDefault = parcelHelpers.interopDefault(_outdoorGrillRounded);
var _outdoorGrillSharp = require("./OutdoorGrillSharp");
var _outdoorGrillSharpDefault = parcelHelpers.interopDefault(_outdoorGrillSharp);
var _outdoorGrillTwoTone = require("./OutdoorGrillTwoTone");
var _outdoorGrillTwoToneDefault = parcelHelpers.interopDefault(_outdoorGrillTwoTone);
var _outlet = require("./Outlet");
var _outletDefault = parcelHelpers.interopDefault(_outlet);
var _outletOutlined = require("./OutletOutlined");
var _outletOutlinedDefault = parcelHelpers.interopDefault(_outletOutlined);
var _outletRounded = require("./OutletRounded");
var _outletRoundedDefault = parcelHelpers.interopDefault(_outletRounded);
var _outletSharp = require("./OutletSharp");
var _outletSharpDefault = parcelHelpers.interopDefault(_outletSharp);
var _outletTwoTone = require("./OutletTwoTone");
var _outletTwoToneDefault = parcelHelpers.interopDefault(_outletTwoTone);
var _outlinedFlag = require("./OutlinedFlag");
var _outlinedFlagDefault = parcelHelpers.interopDefault(_outlinedFlag);
var _outlinedFlagOutlined = require("./OutlinedFlagOutlined");
var _outlinedFlagOutlinedDefault = parcelHelpers.interopDefault(_outlinedFlagOutlined);
var _outlinedFlagRounded = require("./OutlinedFlagRounded");
var _outlinedFlagRoundedDefault = parcelHelpers.interopDefault(_outlinedFlagRounded);
var _outlinedFlagSharp = require("./OutlinedFlagSharp");
var _outlinedFlagSharpDefault = parcelHelpers.interopDefault(_outlinedFlagSharp);
var _outlinedFlagTwoTone = require("./OutlinedFlagTwoTone");
var _outlinedFlagTwoToneDefault = parcelHelpers.interopDefault(_outlinedFlagTwoTone);
var _output = require("./Output");
var _outputDefault = parcelHelpers.interopDefault(_output);
var _outputOutlined = require("./OutputOutlined");
var _outputOutlinedDefault = parcelHelpers.interopDefault(_outputOutlined);
var _outputRounded = require("./OutputRounded");
var _outputRoundedDefault = parcelHelpers.interopDefault(_outputRounded);
var _outputSharp = require("./OutputSharp");
var _outputSharpDefault = parcelHelpers.interopDefault(_outputSharp);
var _outputTwoTone = require("./OutputTwoTone");
var _outputTwoToneDefault = parcelHelpers.interopDefault(_outputTwoTone);
var _padding = require("./Padding");
var _paddingDefault = parcelHelpers.interopDefault(_padding);
var _paddingOutlined = require("./PaddingOutlined");
var _paddingOutlinedDefault = parcelHelpers.interopDefault(_paddingOutlined);
var _paddingRounded = require("./PaddingRounded");
var _paddingRoundedDefault = parcelHelpers.interopDefault(_paddingRounded);
var _paddingSharp = require("./PaddingSharp");
var _paddingSharpDefault = parcelHelpers.interopDefault(_paddingSharp);
var _paddingTwoTone = require("./PaddingTwoTone");
var _paddingTwoToneDefault = parcelHelpers.interopDefault(_paddingTwoTone);
var _pages = require("./Pages");
var _pagesDefault = parcelHelpers.interopDefault(_pages);
var _pagesOutlined = require("./PagesOutlined");
var _pagesOutlinedDefault = parcelHelpers.interopDefault(_pagesOutlined);
var _pagesRounded = require("./PagesRounded");
var _pagesRoundedDefault = parcelHelpers.interopDefault(_pagesRounded);
var _pagesSharp = require("./PagesSharp");
var _pagesSharpDefault = parcelHelpers.interopDefault(_pagesSharp);
var _pagesTwoTone = require("./PagesTwoTone");
var _pagesTwoToneDefault = parcelHelpers.interopDefault(_pagesTwoTone);
var _pageview = require("./Pageview");
var _pageviewDefault = parcelHelpers.interopDefault(_pageview);
var _pageviewOutlined = require("./PageviewOutlined");
var _pageviewOutlinedDefault = parcelHelpers.interopDefault(_pageviewOutlined);
var _pageviewRounded = require("./PageviewRounded");
var _pageviewRoundedDefault = parcelHelpers.interopDefault(_pageviewRounded);
var _pageviewSharp = require("./PageviewSharp");
var _pageviewSharpDefault = parcelHelpers.interopDefault(_pageviewSharp);
var _pageviewTwoTone = require("./PageviewTwoTone");
var _pageviewTwoToneDefault = parcelHelpers.interopDefault(_pageviewTwoTone);
var _paid = require("./Paid");
var _paidDefault = parcelHelpers.interopDefault(_paid);
var _paidOutlined = require("./PaidOutlined");
var _paidOutlinedDefault = parcelHelpers.interopDefault(_paidOutlined);
var _paidRounded = require("./PaidRounded");
var _paidRoundedDefault = parcelHelpers.interopDefault(_paidRounded);
var _paidSharp = require("./PaidSharp");
var _paidSharpDefault = parcelHelpers.interopDefault(_paidSharp);
var _paidTwoTone = require("./PaidTwoTone");
var _paidTwoToneDefault = parcelHelpers.interopDefault(_paidTwoTone);
var _palette = require("./Palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _paletteOutlined = require("./PaletteOutlined");
var _paletteOutlinedDefault = parcelHelpers.interopDefault(_paletteOutlined);
var _paletteRounded = require("./PaletteRounded");
var _paletteRoundedDefault = parcelHelpers.interopDefault(_paletteRounded);
var _paletteSharp = require("./PaletteSharp");
var _paletteSharpDefault = parcelHelpers.interopDefault(_paletteSharp);
var _paletteTwoTone = require("./PaletteTwoTone");
var _paletteTwoToneDefault = parcelHelpers.interopDefault(_paletteTwoTone);
var _panTool = require("./PanTool");
var _panToolDefault = parcelHelpers.interopDefault(_panTool);
var _panToolAlt = require("./PanToolAlt");
var _panToolAltDefault = parcelHelpers.interopDefault(_panToolAlt);
var _panToolAltOutlined = require("./PanToolAltOutlined");
var _panToolAltOutlinedDefault = parcelHelpers.interopDefault(_panToolAltOutlined);
var _panToolAltRounded = require("./PanToolAltRounded");
var _panToolAltRoundedDefault = parcelHelpers.interopDefault(_panToolAltRounded);
var _panToolAltSharp = require("./PanToolAltSharp");
var _panToolAltSharpDefault = parcelHelpers.interopDefault(_panToolAltSharp);
var _panToolAltTwoTone = require("./PanToolAltTwoTone");
var _panToolAltTwoToneDefault = parcelHelpers.interopDefault(_panToolAltTwoTone);
var _panToolOutlined = require("./PanToolOutlined");
var _panToolOutlinedDefault = parcelHelpers.interopDefault(_panToolOutlined);
var _panToolRounded = require("./PanToolRounded");
var _panToolRoundedDefault = parcelHelpers.interopDefault(_panToolRounded);
var _panToolSharp = require("./PanToolSharp");
var _panToolSharpDefault = parcelHelpers.interopDefault(_panToolSharp);
var _panToolTwoTone = require("./PanToolTwoTone");
var _panToolTwoToneDefault = parcelHelpers.interopDefault(_panToolTwoTone);
var _panorama = require("./Panorama");
var _panoramaDefault = parcelHelpers.interopDefault(_panorama);
var _panoramaFishEye = require("./PanoramaFishEye");
var _panoramaFishEyeDefault = parcelHelpers.interopDefault(_panoramaFishEye);
var _panoramaFishEyeOutlined = require("./PanoramaFishEyeOutlined");
var _panoramaFishEyeOutlinedDefault = parcelHelpers.interopDefault(_panoramaFishEyeOutlined);
var _panoramaFishEyeRounded = require("./PanoramaFishEyeRounded");
var _panoramaFishEyeRoundedDefault = parcelHelpers.interopDefault(_panoramaFishEyeRounded);
var _panoramaFishEyeSharp = require("./PanoramaFishEyeSharp");
var _panoramaFishEyeSharpDefault = parcelHelpers.interopDefault(_panoramaFishEyeSharp);
var _panoramaFishEyeTwoTone = require("./PanoramaFishEyeTwoTone");
var _panoramaFishEyeTwoToneDefault = parcelHelpers.interopDefault(_panoramaFishEyeTwoTone);
var _panoramaHorizontal = require("./PanoramaHorizontal");
var _panoramaHorizontalDefault = parcelHelpers.interopDefault(_panoramaHorizontal);
var _panoramaHorizontalOutlined = require("./PanoramaHorizontalOutlined");
var _panoramaHorizontalOutlinedDefault = parcelHelpers.interopDefault(_panoramaHorizontalOutlined);
var _panoramaHorizontalRounded = require("./PanoramaHorizontalRounded");
var _panoramaHorizontalRoundedDefault = parcelHelpers.interopDefault(_panoramaHorizontalRounded);
var _panoramaHorizontalSelect = require("./PanoramaHorizontalSelect");
var _panoramaHorizontalSelectDefault = parcelHelpers.interopDefault(_panoramaHorizontalSelect);
var _panoramaHorizontalSelectOutlined = require("./PanoramaHorizontalSelectOutlined");
var _panoramaHorizontalSelectOutlinedDefault = parcelHelpers.interopDefault(_panoramaHorizontalSelectOutlined);
var _panoramaHorizontalSelectRounded = require("./PanoramaHorizontalSelectRounded");
var _panoramaHorizontalSelectRoundedDefault = parcelHelpers.interopDefault(_panoramaHorizontalSelectRounded);
var _panoramaHorizontalSelectSharp = require("./PanoramaHorizontalSelectSharp");
var _panoramaHorizontalSelectSharpDefault = parcelHelpers.interopDefault(_panoramaHorizontalSelectSharp);
var _panoramaHorizontalSelectTwoTone = require("./PanoramaHorizontalSelectTwoTone");
var _panoramaHorizontalSelectTwoToneDefault = parcelHelpers.interopDefault(_panoramaHorizontalSelectTwoTone);
var _panoramaHorizontalSharp = require("./PanoramaHorizontalSharp");
var _panoramaHorizontalSharpDefault = parcelHelpers.interopDefault(_panoramaHorizontalSharp);
var _panoramaHorizontalTwoTone = require("./PanoramaHorizontalTwoTone");
var _panoramaHorizontalTwoToneDefault = parcelHelpers.interopDefault(_panoramaHorizontalTwoTone);
var _panoramaOutlined = require("./PanoramaOutlined");
var _panoramaOutlinedDefault = parcelHelpers.interopDefault(_panoramaOutlined);
var _panoramaPhotosphere = require("./PanoramaPhotosphere");
var _panoramaPhotosphereDefault = parcelHelpers.interopDefault(_panoramaPhotosphere);
var _panoramaPhotosphereOutlined = require("./PanoramaPhotosphereOutlined");
var _panoramaPhotosphereOutlinedDefault = parcelHelpers.interopDefault(_panoramaPhotosphereOutlined);
var _panoramaPhotosphereRounded = require("./PanoramaPhotosphereRounded");
var _panoramaPhotosphereRoundedDefault = parcelHelpers.interopDefault(_panoramaPhotosphereRounded);
var _panoramaPhotosphereSelect = require("./PanoramaPhotosphereSelect");
var _panoramaPhotosphereSelectDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSelect);
var _panoramaPhotosphereSelectOutlined = require("./PanoramaPhotosphereSelectOutlined");
var _panoramaPhotosphereSelectOutlinedDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSelectOutlined);
var _panoramaPhotosphereSelectRounded = require("./PanoramaPhotosphereSelectRounded");
var _panoramaPhotosphereSelectRoundedDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSelectRounded);
var _panoramaPhotosphereSelectSharp = require("./PanoramaPhotosphereSelectSharp");
var _panoramaPhotosphereSelectSharpDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSelectSharp);
var _panoramaPhotosphereSelectTwoTone = require("./PanoramaPhotosphereSelectTwoTone");
var _panoramaPhotosphereSelectTwoToneDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSelectTwoTone);
var _panoramaPhotosphereSharp = require("./PanoramaPhotosphereSharp");
var _panoramaPhotosphereSharpDefault = parcelHelpers.interopDefault(_panoramaPhotosphereSharp);
var _panoramaPhotosphereTwoTone = require("./PanoramaPhotosphereTwoTone");
var _panoramaPhotosphereTwoToneDefault = parcelHelpers.interopDefault(_panoramaPhotosphereTwoTone);
var _panoramaRounded = require("./PanoramaRounded");
var _panoramaRoundedDefault = parcelHelpers.interopDefault(_panoramaRounded);
var _panoramaSharp = require("./PanoramaSharp");
var _panoramaSharpDefault = parcelHelpers.interopDefault(_panoramaSharp);
var _panoramaTwoTone = require("./PanoramaTwoTone");
var _panoramaTwoToneDefault = parcelHelpers.interopDefault(_panoramaTwoTone);
var _panoramaVertical = require("./PanoramaVertical");
var _panoramaVerticalDefault = parcelHelpers.interopDefault(_panoramaVertical);
var _panoramaVerticalOutlined = require("./PanoramaVerticalOutlined");
var _panoramaVerticalOutlinedDefault = parcelHelpers.interopDefault(_panoramaVerticalOutlined);
var _panoramaVerticalRounded = require("./PanoramaVerticalRounded");
var _panoramaVerticalRoundedDefault = parcelHelpers.interopDefault(_panoramaVerticalRounded);
var _panoramaVerticalSelect = require("./PanoramaVerticalSelect");
var _panoramaVerticalSelectDefault = parcelHelpers.interopDefault(_panoramaVerticalSelect);
var _panoramaVerticalSelectOutlined = require("./PanoramaVerticalSelectOutlined");
var _panoramaVerticalSelectOutlinedDefault = parcelHelpers.interopDefault(_panoramaVerticalSelectOutlined);
var _panoramaVerticalSelectRounded = require("./PanoramaVerticalSelectRounded");
var _panoramaVerticalSelectRoundedDefault = parcelHelpers.interopDefault(_panoramaVerticalSelectRounded);
var _panoramaVerticalSelectSharp = require("./PanoramaVerticalSelectSharp");
var _panoramaVerticalSelectSharpDefault = parcelHelpers.interopDefault(_panoramaVerticalSelectSharp);
var _panoramaVerticalSelectTwoTone = require("./PanoramaVerticalSelectTwoTone");
var _panoramaVerticalSelectTwoToneDefault = parcelHelpers.interopDefault(_panoramaVerticalSelectTwoTone);
var _panoramaVerticalSharp = require("./PanoramaVerticalSharp");
var _panoramaVerticalSharpDefault = parcelHelpers.interopDefault(_panoramaVerticalSharp);
var _panoramaVerticalTwoTone = require("./PanoramaVerticalTwoTone");
var _panoramaVerticalTwoToneDefault = parcelHelpers.interopDefault(_panoramaVerticalTwoTone);
var _panoramaWideAngle = require("./PanoramaWideAngle");
var _panoramaWideAngleDefault = parcelHelpers.interopDefault(_panoramaWideAngle);
var _panoramaWideAngleOutlined = require("./PanoramaWideAngleOutlined");
var _panoramaWideAngleOutlinedDefault = parcelHelpers.interopDefault(_panoramaWideAngleOutlined);
var _panoramaWideAngleRounded = require("./PanoramaWideAngleRounded");
var _panoramaWideAngleRoundedDefault = parcelHelpers.interopDefault(_panoramaWideAngleRounded);
var _panoramaWideAngleSelect = require("./PanoramaWideAngleSelect");
var _panoramaWideAngleSelectDefault = parcelHelpers.interopDefault(_panoramaWideAngleSelect);
var _panoramaWideAngleSelectOutlined = require("./PanoramaWideAngleSelectOutlined");
var _panoramaWideAngleSelectOutlinedDefault = parcelHelpers.interopDefault(_panoramaWideAngleSelectOutlined);
var _panoramaWideAngleSelectRounded = require("./PanoramaWideAngleSelectRounded");
var _panoramaWideAngleSelectRoundedDefault = parcelHelpers.interopDefault(_panoramaWideAngleSelectRounded);
var _panoramaWideAngleSelectSharp = require("./PanoramaWideAngleSelectSharp");
var _panoramaWideAngleSelectSharpDefault = parcelHelpers.interopDefault(_panoramaWideAngleSelectSharp);
var _panoramaWideAngleSelectTwoTone = require("./PanoramaWideAngleSelectTwoTone");
var _panoramaWideAngleSelectTwoToneDefault = parcelHelpers.interopDefault(_panoramaWideAngleSelectTwoTone);
var _panoramaWideAngleSharp = require("./PanoramaWideAngleSharp");
var _panoramaWideAngleSharpDefault = parcelHelpers.interopDefault(_panoramaWideAngleSharp);
var _panoramaWideAngleTwoTone = require("./PanoramaWideAngleTwoTone");
var _panoramaWideAngleTwoToneDefault = parcelHelpers.interopDefault(_panoramaWideAngleTwoTone);
var _paragliding = require("./Paragliding");
var _paraglidingDefault = parcelHelpers.interopDefault(_paragliding);
var _paraglidingOutlined = require("./ParaglidingOutlined");
var _paraglidingOutlinedDefault = parcelHelpers.interopDefault(_paraglidingOutlined);
var _paraglidingRounded = require("./ParaglidingRounded");
var _paraglidingRoundedDefault = parcelHelpers.interopDefault(_paraglidingRounded);
var _paraglidingSharp = require("./ParaglidingSharp");
var _paraglidingSharpDefault = parcelHelpers.interopDefault(_paraglidingSharp);
var _paraglidingTwoTone = require("./ParaglidingTwoTone");
var _paraglidingTwoToneDefault = parcelHelpers.interopDefault(_paraglidingTwoTone);
var _park = require("./Park");
var _parkDefault = parcelHelpers.interopDefault(_park);
var _parkOutlined = require("./ParkOutlined");
var _parkOutlinedDefault = parcelHelpers.interopDefault(_parkOutlined);
var _parkRounded = require("./ParkRounded");
var _parkRoundedDefault = parcelHelpers.interopDefault(_parkRounded);
var _parkSharp = require("./ParkSharp");
var _parkSharpDefault = parcelHelpers.interopDefault(_parkSharp);
var _parkTwoTone = require("./ParkTwoTone");
var _parkTwoToneDefault = parcelHelpers.interopDefault(_parkTwoTone);
var _partyMode = require("./PartyMode");
var _partyModeDefault = parcelHelpers.interopDefault(_partyMode);
var _partyModeOutlined = require("./PartyModeOutlined");
var _partyModeOutlinedDefault = parcelHelpers.interopDefault(_partyModeOutlined);
var _partyModeRounded = require("./PartyModeRounded");
var _partyModeRoundedDefault = parcelHelpers.interopDefault(_partyModeRounded);
var _partyModeSharp = require("./PartyModeSharp");
var _partyModeSharpDefault = parcelHelpers.interopDefault(_partyModeSharp);
var _partyModeTwoTone = require("./PartyModeTwoTone");
var _partyModeTwoToneDefault = parcelHelpers.interopDefault(_partyModeTwoTone);
var _password = require("./Password");
var _passwordDefault = parcelHelpers.interopDefault(_password);
var _passwordOutlined = require("./PasswordOutlined");
var _passwordOutlinedDefault = parcelHelpers.interopDefault(_passwordOutlined);
var _passwordRounded = require("./PasswordRounded");
var _passwordRoundedDefault = parcelHelpers.interopDefault(_passwordRounded);
var _passwordSharp = require("./PasswordSharp");
var _passwordSharpDefault = parcelHelpers.interopDefault(_passwordSharp);
var _passwordTwoTone = require("./PasswordTwoTone");
var _passwordTwoToneDefault = parcelHelpers.interopDefault(_passwordTwoTone);
var _pattern = require("./Pattern");
var _patternDefault = parcelHelpers.interopDefault(_pattern);
var _patternOutlined = require("./PatternOutlined");
var _patternOutlinedDefault = parcelHelpers.interopDefault(_patternOutlined);
var _patternRounded = require("./PatternRounded");
var _patternRoundedDefault = parcelHelpers.interopDefault(_patternRounded);
var _patternSharp = require("./PatternSharp");
var _patternSharpDefault = parcelHelpers.interopDefault(_patternSharp);
var _patternTwoTone = require("./PatternTwoTone");
var _patternTwoToneDefault = parcelHelpers.interopDefault(_patternTwoTone);
var _pause = require("./Pause");
var _pauseDefault = parcelHelpers.interopDefault(_pause);
var _pauseCircle = require("./PauseCircle");
var _pauseCircleDefault = parcelHelpers.interopDefault(_pauseCircle);
var _pauseCircleFilled = require("./PauseCircleFilled");
var _pauseCircleFilledDefault = parcelHelpers.interopDefault(_pauseCircleFilled);
var _pauseCircleFilledOutlined = require("./PauseCircleFilledOutlined");
var _pauseCircleFilledOutlinedDefault = parcelHelpers.interopDefault(_pauseCircleFilledOutlined);
var _pauseCircleFilledRounded = require("./PauseCircleFilledRounded");
var _pauseCircleFilledRoundedDefault = parcelHelpers.interopDefault(_pauseCircleFilledRounded);
var _pauseCircleFilledSharp = require("./PauseCircleFilledSharp");
var _pauseCircleFilledSharpDefault = parcelHelpers.interopDefault(_pauseCircleFilledSharp);
var _pauseCircleFilledTwoTone = require("./PauseCircleFilledTwoTone");
var _pauseCircleFilledTwoToneDefault = parcelHelpers.interopDefault(_pauseCircleFilledTwoTone);
var _pauseCircleOutline = require("./PauseCircleOutline");
var _pauseCircleOutlineDefault = parcelHelpers.interopDefault(_pauseCircleOutline);
var _pauseCircleOutlineOutlined = require("./PauseCircleOutlineOutlined");
var _pauseCircleOutlineOutlinedDefault = parcelHelpers.interopDefault(_pauseCircleOutlineOutlined);
var _pauseCircleOutlineRounded = require("./PauseCircleOutlineRounded");
var _pauseCircleOutlineRoundedDefault = parcelHelpers.interopDefault(_pauseCircleOutlineRounded);
var _pauseCircleOutlineSharp = require("./PauseCircleOutlineSharp");
var _pauseCircleOutlineSharpDefault = parcelHelpers.interopDefault(_pauseCircleOutlineSharp);
var _pauseCircleOutlineTwoTone = require("./PauseCircleOutlineTwoTone");
var _pauseCircleOutlineTwoToneDefault = parcelHelpers.interopDefault(_pauseCircleOutlineTwoTone);
var _pauseCircleOutlined = require("./PauseCircleOutlined");
var _pauseCircleOutlinedDefault = parcelHelpers.interopDefault(_pauseCircleOutlined);
var _pauseCircleRounded = require("./PauseCircleRounded");
var _pauseCircleRoundedDefault = parcelHelpers.interopDefault(_pauseCircleRounded);
var _pauseCircleSharp = require("./PauseCircleSharp");
var _pauseCircleSharpDefault = parcelHelpers.interopDefault(_pauseCircleSharp);
var _pauseCircleTwoTone = require("./PauseCircleTwoTone");
var _pauseCircleTwoToneDefault = parcelHelpers.interopDefault(_pauseCircleTwoTone);
var _pauseOutlined = require("./PauseOutlined");
var _pauseOutlinedDefault = parcelHelpers.interopDefault(_pauseOutlined);
var _pausePresentation = require("./PausePresentation");
var _pausePresentationDefault = parcelHelpers.interopDefault(_pausePresentation);
var _pausePresentationOutlined = require("./PausePresentationOutlined");
var _pausePresentationOutlinedDefault = parcelHelpers.interopDefault(_pausePresentationOutlined);
var _pausePresentationRounded = require("./PausePresentationRounded");
var _pausePresentationRoundedDefault = parcelHelpers.interopDefault(_pausePresentationRounded);
var _pausePresentationSharp = require("./PausePresentationSharp");
var _pausePresentationSharpDefault = parcelHelpers.interopDefault(_pausePresentationSharp);
var _pausePresentationTwoTone = require("./PausePresentationTwoTone");
var _pausePresentationTwoToneDefault = parcelHelpers.interopDefault(_pausePresentationTwoTone);
var _pauseRounded = require("./PauseRounded");
var _pauseRoundedDefault = parcelHelpers.interopDefault(_pauseRounded);
var _pauseSharp = require("./PauseSharp");
var _pauseSharpDefault = parcelHelpers.interopDefault(_pauseSharp);
var _pauseTwoTone = require("./PauseTwoTone");
var _pauseTwoToneDefault = parcelHelpers.interopDefault(_pauseTwoTone);
var _payment = require("./Payment");
var _paymentDefault = parcelHelpers.interopDefault(_payment);
var _paymentOutlined = require("./PaymentOutlined");
var _paymentOutlinedDefault = parcelHelpers.interopDefault(_paymentOutlined);
var _paymentRounded = require("./PaymentRounded");
var _paymentRoundedDefault = parcelHelpers.interopDefault(_paymentRounded);
var _paymentSharp = require("./PaymentSharp");
var _paymentSharpDefault = parcelHelpers.interopDefault(_paymentSharp);
var _paymentTwoTone = require("./PaymentTwoTone");
var _paymentTwoToneDefault = parcelHelpers.interopDefault(_paymentTwoTone);
var _payments = require("./Payments");
var _paymentsDefault = parcelHelpers.interopDefault(_payments);
var _paymentsOutlined = require("./PaymentsOutlined");
var _paymentsOutlinedDefault = parcelHelpers.interopDefault(_paymentsOutlined);
var _paymentsRounded = require("./PaymentsRounded");
var _paymentsRoundedDefault = parcelHelpers.interopDefault(_paymentsRounded);
var _paymentsSharp = require("./PaymentsSharp");
var _paymentsSharpDefault = parcelHelpers.interopDefault(_paymentsSharp);
var _paymentsTwoTone = require("./PaymentsTwoTone");
var _paymentsTwoToneDefault = parcelHelpers.interopDefault(_paymentsTwoTone);
var _pedalBike = require("./PedalBike");
var _pedalBikeDefault = parcelHelpers.interopDefault(_pedalBike);
var _pedalBikeOutlined = require("./PedalBikeOutlined");
var _pedalBikeOutlinedDefault = parcelHelpers.interopDefault(_pedalBikeOutlined);
var _pedalBikeRounded = require("./PedalBikeRounded");
var _pedalBikeRoundedDefault = parcelHelpers.interopDefault(_pedalBikeRounded);
var _pedalBikeSharp = require("./PedalBikeSharp");
var _pedalBikeSharpDefault = parcelHelpers.interopDefault(_pedalBikeSharp);
var _pedalBikeTwoTone = require("./PedalBikeTwoTone");
var _pedalBikeTwoToneDefault = parcelHelpers.interopDefault(_pedalBikeTwoTone);
var _pending = require("./Pending");
var _pendingDefault = parcelHelpers.interopDefault(_pending);
var _pendingActions = require("./PendingActions");
var _pendingActionsDefault = parcelHelpers.interopDefault(_pendingActions);
var _pendingActionsOutlined = require("./PendingActionsOutlined");
var _pendingActionsOutlinedDefault = parcelHelpers.interopDefault(_pendingActionsOutlined);
var _pendingActionsRounded = require("./PendingActionsRounded");
var _pendingActionsRoundedDefault = parcelHelpers.interopDefault(_pendingActionsRounded);
var _pendingActionsSharp = require("./PendingActionsSharp");
var _pendingActionsSharpDefault = parcelHelpers.interopDefault(_pendingActionsSharp);
var _pendingActionsTwoTone = require("./PendingActionsTwoTone");
var _pendingActionsTwoToneDefault = parcelHelpers.interopDefault(_pendingActionsTwoTone);
var _pendingOutlined = require("./PendingOutlined");
var _pendingOutlinedDefault = parcelHelpers.interopDefault(_pendingOutlined);
var _pendingRounded = require("./PendingRounded");
var _pendingRoundedDefault = parcelHelpers.interopDefault(_pendingRounded);
var _pendingSharp = require("./PendingSharp");
var _pendingSharpDefault = parcelHelpers.interopDefault(_pendingSharp);
var _pendingTwoTone = require("./PendingTwoTone");
var _pendingTwoToneDefault = parcelHelpers.interopDefault(_pendingTwoTone);
var _pentagon = require("./Pentagon");
var _pentagonDefault = parcelHelpers.interopDefault(_pentagon);
var _pentagonOutlined = require("./PentagonOutlined");
var _pentagonOutlinedDefault = parcelHelpers.interopDefault(_pentagonOutlined);
var _pentagonRounded = require("./PentagonRounded");
var _pentagonRoundedDefault = parcelHelpers.interopDefault(_pentagonRounded);
var _pentagonSharp = require("./PentagonSharp");
var _pentagonSharpDefault = parcelHelpers.interopDefault(_pentagonSharp);
var _pentagonTwoTone = require("./PentagonTwoTone");
var _pentagonTwoToneDefault = parcelHelpers.interopDefault(_pentagonTwoTone);
var _people = require("./People");
var _peopleDefault = parcelHelpers.interopDefault(_people);
var _peopleAlt = require("./PeopleAlt");
var _peopleAltDefault = parcelHelpers.interopDefault(_peopleAlt);
var _peopleAltOutlined = require("./PeopleAltOutlined");
var _peopleAltOutlinedDefault = parcelHelpers.interopDefault(_peopleAltOutlined);
var _peopleAltRounded = require("./PeopleAltRounded");
var _peopleAltRoundedDefault = parcelHelpers.interopDefault(_peopleAltRounded);
var _peopleAltSharp = require("./PeopleAltSharp");
var _peopleAltSharpDefault = parcelHelpers.interopDefault(_peopleAltSharp);
var _peopleAltTwoTone = require("./PeopleAltTwoTone");
var _peopleAltTwoToneDefault = parcelHelpers.interopDefault(_peopleAltTwoTone);
var _peopleOutline = require("./PeopleOutline");
var _peopleOutlineDefault = parcelHelpers.interopDefault(_peopleOutline);
var _peopleOutlineOutlined = require("./PeopleOutlineOutlined");
var _peopleOutlineOutlinedDefault = parcelHelpers.interopDefault(_peopleOutlineOutlined);
var _peopleOutlineRounded = require("./PeopleOutlineRounded");
var _peopleOutlineRoundedDefault = parcelHelpers.interopDefault(_peopleOutlineRounded);
var _peopleOutlineSharp = require("./PeopleOutlineSharp");
var _peopleOutlineSharpDefault = parcelHelpers.interopDefault(_peopleOutlineSharp);
var _peopleOutlineTwoTone = require("./PeopleOutlineTwoTone");
var _peopleOutlineTwoToneDefault = parcelHelpers.interopDefault(_peopleOutlineTwoTone);
var _peopleOutlined = require("./PeopleOutlined");
var _peopleOutlinedDefault = parcelHelpers.interopDefault(_peopleOutlined);
var _peopleRounded = require("./PeopleRounded");
var _peopleRoundedDefault = parcelHelpers.interopDefault(_peopleRounded);
var _peopleSharp = require("./PeopleSharp");
var _peopleSharpDefault = parcelHelpers.interopDefault(_peopleSharp);
var _peopleTwoTone = require("./PeopleTwoTone");
var _peopleTwoToneDefault = parcelHelpers.interopDefault(_peopleTwoTone);
var _percent = require("./Percent");
var _percentDefault = parcelHelpers.interopDefault(_percent);
var _percentOutlined = require("./PercentOutlined");
var _percentOutlinedDefault = parcelHelpers.interopDefault(_percentOutlined);
var _percentRounded = require("./PercentRounded");
var _percentRoundedDefault = parcelHelpers.interopDefault(_percentRounded);
var _percentSharp = require("./PercentSharp");
var _percentSharpDefault = parcelHelpers.interopDefault(_percentSharp);
var _percentTwoTone = require("./PercentTwoTone");
var _percentTwoToneDefault = parcelHelpers.interopDefault(_percentTwoTone);
var _permCameraMic = require("./PermCameraMic");
var _permCameraMicDefault = parcelHelpers.interopDefault(_permCameraMic);
var _permCameraMicOutlined = require("./PermCameraMicOutlined");
var _permCameraMicOutlinedDefault = parcelHelpers.interopDefault(_permCameraMicOutlined);
var _permCameraMicRounded = require("./PermCameraMicRounded");
var _permCameraMicRoundedDefault = parcelHelpers.interopDefault(_permCameraMicRounded);
var _permCameraMicSharp = require("./PermCameraMicSharp");
var _permCameraMicSharpDefault = parcelHelpers.interopDefault(_permCameraMicSharp);
var _permCameraMicTwoTone = require("./PermCameraMicTwoTone");
var _permCameraMicTwoToneDefault = parcelHelpers.interopDefault(_permCameraMicTwoTone);
var _permContactCalendar = require("./PermContactCalendar");
var _permContactCalendarDefault = parcelHelpers.interopDefault(_permContactCalendar);
var _permContactCalendarOutlined = require("./PermContactCalendarOutlined");
var _permContactCalendarOutlinedDefault = parcelHelpers.interopDefault(_permContactCalendarOutlined);
var _permContactCalendarRounded = require("./PermContactCalendarRounded");
var _permContactCalendarRoundedDefault = parcelHelpers.interopDefault(_permContactCalendarRounded);
var _permContactCalendarSharp = require("./PermContactCalendarSharp");
var _permContactCalendarSharpDefault = parcelHelpers.interopDefault(_permContactCalendarSharp);
var _permContactCalendarTwoTone = require("./PermContactCalendarTwoTone");
var _permContactCalendarTwoToneDefault = parcelHelpers.interopDefault(_permContactCalendarTwoTone);
var _permDataSetting = require("./PermDataSetting");
var _permDataSettingDefault = parcelHelpers.interopDefault(_permDataSetting);
var _permDataSettingOutlined = require("./PermDataSettingOutlined");
var _permDataSettingOutlinedDefault = parcelHelpers.interopDefault(_permDataSettingOutlined);
var _permDataSettingRounded = require("./PermDataSettingRounded");
var _permDataSettingRoundedDefault = parcelHelpers.interopDefault(_permDataSettingRounded);
var _permDataSettingSharp = require("./PermDataSettingSharp");
var _permDataSettingSharpDefault = parcelHelpers.interopDefault(_permDataSettingSharp);
var _permDataSettingTwoTone = require("./PermDataSettingTwoTone");
var _permDataSettingTwoToneDefault = parcelHelpers.interopDefault(_permDataSettingTwoTone);
var _permDeviceInformation = require("./PermDeviceInformation");
var _permDeviceInformationDefault = parcelHelpers.interopDefault(_permDeviceInformation);
var _permDeviceInformationOutlined = require("./PermDeviceInformationOutlined");
var _permDeviceInformationOutlinedDefault = parcelHelpers.interopDefault(_permDeviceInformationOutlined);
var _permDeviceInformationRounded = require("./PermDeviceInformationRounded");
var _permDeviceInformationRoundedDefault = parcelHelpers.interopDefault(_permDeviceInformationRounded);
var _permDeviceInformationSharp = require("./PermDeviceInformationSharp");
var _permDeviceInformationSharpDefault = parcelHelpers.interopDefault(_permDeviceInformationSharp);
var _permDeviceInformationTwoTone = require("./PermDeviceInformationTwoTone");
var _permDeviceInformationTwoToneDefault = parcelHelpers.interopDefault(_permDeviceInformationTwoTone);
var _permIdentity = require("./PermIdentity");
var _permIdentityDefault = parcelHelpers.interopDefault(_permIdentity);
var _permIdentityOutlined = require("./PermIdentityOutlined");
var _permIdentityOutlinedDefault = parcelHelpers.interopDefault(_permIdentityOutlined);
var _permIdentityRounded = require("./PermIdentityRounded");
var _permIdentityRoundedDefault = parcelHelpers.interopDefault(_permIdentityRounded);
var _permIdentitySharp = require("./PermIdentitySharp");
var _permIdentitySharpDefault = parcelHelpers.interopDefault(_permIdentitySharp);
var _permIdentityTwoTone = require("./PermIdentityTwoTone");
var _permIdentityTwoToneDefault = parcelHelpers.interopDefault(_permIdentityTwoTone);
var _permMedia = require("./PermMedia");
var _permMediaDefault = parcelHelpers.interopDefault(_permMedia);
var _permMediaOutlined = require("./PermMediaOutlined");
var _permMediaOutlinedDefault = parcelHelpers.interopDefault(_permMediaOutlined);
var _permMediaRounded = require("./PermMediaRounded");
var _permMediaRoundedDefault = parcelHelpers.interopDefault(_permMediaRounded);
var _permMediaSharp = require("./PermMediaSharp");
var _permMediaSharpDefault = parcelHelpers.interopDefault(_permMediaSharp);
var _permMediaTwoTone = require("./PermMediaTwoTone");
var _permMediaTwoToneDefault = parcelHelpers.interopDefault(_permMediaTwoTone);
var _permPhoneMsg = require("./PermPhoneMsg");
var _permPhoneMsgDefault = parcelHelpers.interopDefault(_permPhoneMsg);
var _permPhoneMsgOutlined = require("./PermPhoneMsgOutlined");
var _permPhoneMsgOutlinedDefault = parcelHelpers.interopDefault(_permPhoneMsgOutlined);
var _permPhoneMsgRounded = require("./PermPhoneMsgRounded");
var _permPhoneMsgRoundedDefault = parcelHelpers.interopDefault(_permPhoneMsgRounded);
var _permPhoneMsgSharp = require("./PermPhoneMsgSharp");
var _permPhoneMsgSharpDefault = parcelHelpers.interopDefault(_permPhoneMsgSharp);
var _permPhoneMsgTwoTone = require("./PermPhoneMsgTwoTone");
var _permPhoneMsgTwoToneDefault = parcelHelpers.interopDefault(_permPhoneMsgTwoTone);
var _permScanWifi = require("./PermScanWifi");
var _permScanWifiDefault = parcelHelpers.interopDefault(_permScanWifi);
var _permScanWifiOutlined = require("./PermScanWifiOutlined");
var _permScanWifiOutlinedDefault = parcelHelpers.interopDefault(_permScanWifiOutlined);
var _permScanWifiRounded = require("./PermScanWifiRounded");
var _permScanWifiRoundedDefault = parcelHelpers.interopDefault(_permScanWifiRounded);
var _permScanWifiSharp = require("./PermScanWifiSharp");
var _permScanWifiSharpDefault = parcelHelpers.interopDefault(_permScanWifiSharp);
var _permScanWifiTwoTone = require("./PermScanWifiTwoTone");
var _permScanWifiTwoToneDefault = parcelHelpers.interopDefault(_permScanWifiTwoTone);
var _person = require("./Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _person2 = require("./Person2");
var _person2Default = parcelHelpers.interopDefault(_person2);
var _person2Outlined = require("./Person2Outlined");
var _person2OutlinedDefault = parcelHelpers.interopDefault(_person2Outlined);
var _person2Rounded = require("./Person2Rounded");
var _person2RoundedDefault = parcelHelpers.interopDefault(_person2Rounded);
var _person2Sharp = require("./Person2Sharp");
var _person2SharpDefault = parcelHelpers.interopDefault(_person2Sharp);
var _person2TwoTone = require("./Person2TwoTone");
var _person2TwoToneDefault = parcelHelpers.interopDefault(_person2TwoTone);
var _person3 = require("./Person3");
var _person3Default = parcelHelpers.interopDefault(_person3);
var _person3Outlined = require("./Person3Outlined");
var _person3OutlinedDefault = parcelHelpers.interopDefault(_person3Outlined);
var _person3Rounded = require("./Person3Rounded");
var _person3RoundedDefault = parcelHelpers.interopDefault(_person3Rounded);
var _person3Sharp = require("./Person3Sharp");
var _person3SharpDefault = parcelHelpers.interopDefault(_person3Sharp);
var _person3TwoTone = require("./Person3TwoTone");
var _person3TwoToneDefault = parcelHelpers.interopDefault(_person3TwoTone);
var _person4 = require("./Person4");
var _person4Default = parcelHelpers.interopDefault(_person4);
var _person4Outlined = require("./Person4Outlined");
var _person4OutlinedDefault = parcelHelpers.interopDefault(_person4Outlined);
var _person4Rounded = require("./Person4Rounded");
var _person4RoundedDefault = parcelHelpers.interopDefault(_person4Rounded);
var _person4Sharp = require("./Person4Sharp");
var _person4SharpDefault = parcelHelpers.interopDefault(_person4Sharp);
var _person4TwoTone = require("./Person4TwoTone");
var _person4TwoToneDefault = parcelHelpers.interopDefault(_person4TwoTone);
var _personAdd = require("./PersonAdd");
var _personAddDefault = parcelHelpers.interopDefault(_personAdd);
var _personAddAlt = require("./PersonAddAlt");
var _personAddAltDefault = parcelHelpers.interopDefault(_personAddAlt);
var _personAddAlt1 = require("./PersonAddAlt1");
var _personAddAlt1Default = parcelHelpers.interopDefault(_personAddAlt1);
var _personAddAlt1Outlined = require("./PersonAddAlt1Outlined");
var _personAddAlt1OutlinedDefault = parcelHelpers.interopDefault(_personAddAlt1Outlined);
var _personAddAlt1Rounded = require("./PersonAddAlt1Rounded");
var _personAddAlt1RoundedDefault = parcelHelpers.interopDefault(_personAddAlt1Rounded);
var _personAddAlt1Sharp = require("./PersonAddAlt1Sharp");
var _personAddAlt1SharpDefault = parcelHelpers.interopDefault(_personAddAlt1Sharp);
var _personAddAlt1TwoTone = require("./PersonAddAlt1TwoTone");
var _personAddAlt1TwoToneDefault = parcelHelpers.interopDefault(_personAddAlt1TwoTone);
var _personAddAltOutlined = require("./PersonAddAltOutlined");
var _personAddAltOutlinedDefault = parcelHelpers.interopDefault(_personAddAltOutlined);
var _personAddAltRounded = require("./PersonAddAltRounded");
var _personAddAltRoundedDefault = parcelHelpers.interopDefault(_personAddAltRounded);
var _personAddAltSharp = require("./PersonAddAltSharp");
var _personAddAltSharpDefault = parcelHelpers.interopDefault(_personAddAltSharp);
var _personAddAltTwoTone = require("./PersonAddAltTwoTone");
var _personAddAltTwoToneDefault = parcelHelpers.interopDefault(_personAddAltTwoTone);
var _personAddDisabled = require("./PersonAddDisabled");
var _personAddDisabledDefault = parcelHelpers.interopDefault(_personAddDisabled);
var _personAddDisabledOutlined = require("./PersonAddDisabledOutlined");
var _personAddDisabledOutlinedDefault = parcelHelpers.interopDefault(_personAddDisabledOutlined);
var _personAddDisabledRounded = require("./PersonAddDisabledRounded");
var _personAddDisabledRoundedDefault = parcelHelpers.interopDefault(_personAddDisabledRounded);
var _personAddDisabledSharp = require("./PersonAddDisabledSharp");
var _personAddDisabledSharpDefault = parcelHelpers.interopDefault(_personAddDisabledSharp);
var _personAddDisabledTwoTone = require("./PersonAddDisabledTwoTone");
var _personAddDisabledTwoToneDefault = parcelHelpers.interopDefault(_personAddDisabledTwoTone);
var _personAddOutlined = require("./PersonAddOutlined");
var _personAddOutlinedDefault = parcelHelpers.interopDefault(_personAddOutlined);
var _personAddRounded = require("./PersonAddRounded");
var _personAddRoundedDefault = parcelHelpers.interopDefault(_personAddRounded);
var _personAddSharp = require("./PersonAddSharp");
var _personAddSharpDefault = parcelHelpers.interopDefault(_personAddSharp);
var _personAddTwoTone = require("./PersonAddTwoTone");
var _personAddTwoToneDefault = parcelHelpers.interopDefault(_personAddTwoTone);
var _personOff = require("./PersonOff");
var _personOffDefault = parcelHelpers.interopDefault(_personOff);
var _personOffOutlined = require("./PersonOffOutlined");
var _personOffOutlinedDefault = parcelHelpers.interopDefault(_personOffOutlined);
var _personOffRounded = require("./PersonOffRounded");
var _personOffRoundedDefault = parcelHelpers.interopDefault(_personOffRounded);
var _personOffSharp = require("./PersonOffSharp");
var _personOffSharpDefault = parcelHelpers.interopDefault(_personOffSharp);
var _personOffTwoTone = require("./PersonOffTwoTone");
var _personOffTwoToneDefault = parcelHelpers.interopDefault(_personOffTwoTone);
var _personOutline = require("./PersonOutline");
var _personOutlineDefault = parcelHelpers.interopDefault(_personOutline);
var _personOutlineOutlined = require("./PersonOutlineOutlined");
var _personOutlineOutlinedDefault = parcelHelpers.interopDefault(_personOutlineOutlined);
var _personOutlineRounded = require("./PersonOutlineRounded");
var _personOutlineRoundedDefault = parcelHelpers.interopDefault(_personOutlineRounded);
var _personOutlineSharp = require("./PersonOutlineSharp");
var _personOutlineSharpDefault = parcelHelpers.interopDefault(_personOutlineSharp);
var _personOutlineTwoTone = require("./PersonOutlineTwoTone");
var _personOutlineTwoToneDefault = parcelHelpers.interopDefault(_personOutlineTwoTone);
var _personOutlined = require("./PersonOutlined");
var _personOutlinedDefault = parcelHelpers.interopDefault(_personOutlined);
var _personPin = require("./PersonPin");
var _personPinDefault = parcelHelpers.interopDefault(_personPin);
var _personPinCircle = require("./PersonPinCircle");
var _personPinCircleDefault = parcelHelpers.interopDefault(_personPinCircle);
var _personPinCircleOutlined = require("./PersonPinCircleOutlined");
var _personPinCircleOutlinedDefault = parcelHelpers.interopDefault(_personPinCircleOutlined);
var _personPinCircleRounded = require("./PersonPinCircleRounded");
var _personPinCircleRoundedDefault = parcelHelpers.interopDefault(_personPinCircleRounded);
var _personPinCircleSharp = require("./PersonPinCircleSharp");
var _personPinCircleSharpDefault = parcelHelpers.interopDefault(_personPinCircleSharp);
var _personPinCircleTwoTone = require("./PersonPinCircleTwoTone");
var _personPinCircleTwoToneDefault = parcelHelpers.interopDefault(_personPinCircleTwoTone);
var _personPinOutlined = require("./PersonPinOutlined");
var _personPinOutlinedDefault = parcelHelpers.interopDefault(_personPinOutlined);
var _personPinRounded = require("./PersonPinRounded");
var _personPinRoundedDefault = parcelHelpers.interopDefault(_personPinRounded);
var _personPinSharp = require("./PersonPinSharp");
var _personPinSharpDefault = parcelHelpers.interopDefault(_personPinSharp);
var _personPinTwoTone = require("./PersonPinTwoTone");
var _personPinTwoToneDefault = parcelHelpers.interopDefault(_personPinTwoTone);
var _personRemove = require("./PersonRemove");
var _personRemoveDefault = parcelHelpers.interopDefault(_personRemove);
var _personRemoveAlt1 = require("./PersonRemoveAlt1");
var _personRemoveAlt1Default = parcelHelpers.interopDefault(_personRemoveAlt1);
var _personRemoveAlt1Outlined = require("./PersonRemoveAlt1Outlined");
var _personRemoveAlt1OutlinedDefault = parcelHelpers.interopDefault(_personRemoveAlt1Outlined);
var _personRemoveAlt1Rounded = require("./PersonRemoveAlt1Rounded");
var _personRemoveAlt1RoundedDefault = parcelHelpers.interopDefault(_personRemoveAlt1Rounded);
var _personRemoveAlt1Sharp = require("./PersonRemoveAlt1Sharp");
var _personRemoveAlt1SharpDefault = parcelHelpers.interopDefault(_personRemoveAlt1Sharp);
var _personRemoveAlt1TwoTone = require("./PersonRemoveAlt1TwoTone");
var _personRemoveAlt1TwoToneDefault = parcelHelpers.interopDefault(_personRemoveAlt1TwoTone);
var _personRemoveOutlined = require("./PersonRemoveOutlined");
var _personRemoveOutlinedDefault = parcelHelpers.interopDefault(_personRemoveOutlined);
var _personRemoveRounded = require("./PersonRemoveRounded");
var _personRemoveRoundedDefault = parcelHelpers.interopDefault(_personRemoveRounded);
var _personRemoveSharp = require("./PersonRemoveSharp");
var _personRemoveSharpDefault = parcelHelpers.interopDefault(_personRemoveSharp);
var _personRemoveTwoTone = require("./PersonRemoveTwoTone");
var _personRemoveTwoToneDefault = parcelHelpers.interopDefault(_personRemoveTwoTone);
var _personRounded = require("./PersonRounded");
var _personRoundedDefault = parcelHelpers.interopDefault(_personRounded);
var _personSearch = require("./PersonSearch");
var _personSearchDefault = parcelHelpers.interopDefault(_personSearch);
var _personSearchOutlined = require("./PersonSearchOutlined");
var _personSearchOutlinedDefault = parcelHelpers.interopDefault(_personSearchOutlined);
var _personSearchRounded = require("./PersonSearchRounded");
var _personSearchRoundedDefault = parcelHelpers.interopDefault(_personSearchRounded);
var _personSearchSharp = require("./PersonSearchSharp");
var _personSearchSharpDefault = parcelHelpers.interopDefault(_personSearchSharp);
var _personSearchTwoTone = require("./PersonSearchTwoTone");
var _personSearchTwoToneDefault = parcelHelpers.interopDefault(_personSearchTwoTone);
var _personSharp = require("./PersonSharp");
var _personSharpDefault = parcelHelpers.interopDefault(_personSharp);
var _personTwoTone = require("./PersonTwoTone");
var _personTwoToneDefault = parcelHelpers.interopDefault(_personTwoTone);
var _personalVideo = require("./PersonalVideo");
var _personalVideoDefault = parcelHelpers.interopDefault(_personalVideo);
var _personalVideoOutlined = require("./PersonalVideoOutlined");
var _personalVideoOutlinedDefault = parcelHelpers.interopDefault(_personalVideoOutlined);
var _personalVideoRounded = require("./PersonalVideoRounded");
var _personalVideoRoundedDefault = parcelHelpers.interopDefault(_personalVideoRounded);
var _personalVideoSharp = require("./PersonalVideoSharp");
var _personalVideoSharpDefault = parcelHelpers.interopDefault(_personalVideoSharp);
var _personalVideoTwoTone = require("./PersonalVideoTwoTone");
var _personalVideoTwoToneDefault = parcelHelpers.interopDefault(_personalVideoTwoTone);
var _pestControl = require("./PestControl");
var _pestControlDefault = parcelHelpers.interopDefault(_pestControl);
var _pestControlOutlined = require("./PestControlOutlined");
var _pestControlOutlinedDefault = parcelHelpers.interopDefault(_pestControlOutlined);
var _pestControlRodent = require("./PestControlRodent");
var _pestControlRodentDefault = parcelHelpers.interopDefault(_pestControlRodent);
var _pestControlRodentOutlined = require("./PestControlRodentOutlined");
var _pestControlRodentOutlinedDefault = parcelHelpers.interopDefault(_pestControlRodentOutlined);
var _pestControlRodentRounded = require("./PestControlRodentRounded");
var _pestControlRodentRoundedDefault = parcelHelpers.interopDefault(_pestControlRodentRounded);
var _pestControlRodentSharp = require("./PestControlRodentSharp");
var _pestControlRodentSharpDefault = parcelHelpers.interopDefault(_pestControlRodentSharp);
var _pestControlRodentTwoTone = require("./PestControlRodentTwoTone");
var _pestControlRodentTwoToneDefault = parcelHelpers.interopDefault(_pestControlRodentTwoTone);
var _pestControlRounded = require("./PestControlRounded");
var _pestControlRoundedDefault = parcelHelpers.interopDefault(_pestControlRounded);
var _pestControlSharp = require("./PestControlSharp");
var _pestControlSharpDefault = parcelHelpers.interopDefault(_pestControlSharp);
var _pestControlTwoTone = require("./PestControlTwoTone");
var _pestControlTwoToneDefault = parcelHelpers.interopDefault(_pestControlTwoTone);
var _pets = require("./Pets");
var _petsDefault = parcelHelpers.interopDefault(_pets);
var _petsOutlined = require("./PetsOutlined");
var _petsOutlinedDefault = parcelHelpers.interopDefault(_petsOutlined);
var _petsRounded = require("./PetsRounded");
var _petsRoundedDefault = parcelHelpers.interopDefault(_petsRounded);
var _petsSharp = require("./PetsSharp");
var _petsSharpDefault = parcelHelpers.interopDefault(_petsSharp);
var _petsTwoTone = require("./PetsTwoTone");
var _petsTwoToneDefault = parcelHelpers.interopDefault(_petsTwoTone);
var _phishing = require("./Phishing");
var _phishingDefault = parcelHelpers.interopDefault(_phishing);
var _phishingOutlined = require("./PhishingOutlined");
var _phishingOutlinedDefault = parcelHelpers.interopDefault(_phishingOutlined);
var _phishingRounded = require("./PhishingRounded");
var _phishingRoundedDefault = parcelHelpers.interopDefault(_phishingRounded);
var _phishingSharp = require("./PhishingSharp");
var _phishingSharpDefault = parcelHelpers.interopDefault(_phishingSharp);
var _phishingTwoTone = require("./PhishingTwoTone");
var _phishingTwoToneDefault = parcelHelpers.interopDefault(_phishingTwoTone);
var _phone = require("./Phone");
var _phoneDefault = parcelHelpers.interopDefault(_phone);
var _phoneAndroid = require("./PhoneAndroid");
var _phoneAndroidDefault = parcelHelpers.interopDefault(_phoneAndroid);
var _phoneAndroidOutlined = require("./PhoneAndroidOutlined");
var _phoneAndroidOutlinedDefault = parcelHelpers.interopDefault(_phoneAndroidOutlined);
var _phoneAndroidRounded = require("./PhoneAndroidRounded");
var _phoneAndroidRoundedDefault = parcelHelpers.interopDefault(_phoneAndroidRounded);
var _phoneAndroidSharp = require("./PhoneAndroidSharp");
var _phoneAndroidSharpDefault = parcelHelpers.interopDefault(_phoneAndroidSharp);
var _phoneAndroidTwoTone = require("./PhoneAndroidTwoTone");
var _phoneAndroidTwoToneDefault = parcelHelpers.interopDefault(_phoneAndroidTwoTone);
var _phoneBluetoothSpeaker = require("./PhoneBluetoothSpeaker");
var _phoneBluetoothSpeakerDefault = parcelHelpers.interopDefault(_phoneBluetoothSpeaker);
var _phoneBluetoothSpeakerOutlined = require("./PhoneBluetoothSpeakerOutlined");
var _phoneBluetoothSpeakerOutlinedDefault = parcelHelpers.interopDefault(_phoneBluetoothSpeakerOutlined);
var _phoneBluetoothSpeakerRounded = require("./PhoneBluetoothSpeakerRounded");
var _phoneBluetoothSpeakerRoundedDefault = parcelHelpers.interopDefault(_phoneBluetoothSpeakerRounded);
var _phoneBluetoothSpeakerSharp = require("./PhoneBluetoothSpeakerSharp");
var _phoneBluetoothSpeakerSharpDefault = parcelHelpers.interopDefault(_phoneBluetoothSpeakerSharp);
var _phoneBluetoothSpeakerTwoTone = require("./PhoneBluetoothSpeakerTwoTone");
var _phoneBluetoothSpeakerTwoToneDefault = parcelHelpers.interopDefault(_phoneBluetoothSpeakerTwoTone);
var _phoneCallback = require("./PhoneCallback");
var _phoneCallbackDefault = parcelHelpers.interopDefault(_phoneCallback);
var _phoneCallbackOutlined = require("./PhoneCallbackOutlined");
var _phoneCallbackOutlinedDefault = parcelHelpers.interopDefault(_phoneCallbackOutlined);
var _phoneCallbackRounded = require("./PhoneCallbackRounded");
var _phoneCallbackRoundedDefault = parcelHelpers.interopDefault(_phoneCallbackRounded);
var _phoneCallbackSharp = require("./PhoneCallbackSharp");
var _phoneCallbackSharpDefault = parcelHelpers.interopDefault(_phoneCallbackSharp);
var _phoneCallbackTwoTone = require("./PhoneCallbackTwoTone");
var _phoneCallbackTwoToneDefault = parcelHelpers.interopDefault(_phoneCallbackTwoTone);
var _phoneDisabled = require("./PhoneDisabled");
var _phoneDisabledDefault = parcelHelpers.interopDefault(_phoneDisabled);
var _phoneDisabledOutlined = require("./PhoneDisabledOutlined");
var _phoneDisabledOutlinedDefault = parcelHelpers.interopDefault(_phoneDisabledOutlined);
var _phoneDisabledRounded = require("./PhoneDisabledRounded");
var _phoneDisabledRoundedDefault = parcelHelpers.interopDefault(_phoneDisabledRounded);
var _phoneDisabledSharp = require("./PhoneDisabledSharp");
var _phoneDisabledSharpDefault = parcelHelpers.interopDefault(_phoneDisabledSharp);
var _phoneDisabledTwoTone = require("./PhoneDisabledTwoTone");
var _phoneDisabledTwoToneDefault = parcelHelpers.interopDefault(_phoneDisabledTwoTone);
var _phoneEnabled = require("./PhoneEnabled");
var _phoneEnabledDefault = parcelHelpers.interopDefault(_phoneEnabled);
var _phoneEnabledOutlined = require("./PhoneEnabledOutlined");
var _phoneEnabledOutlinedDefault = parcelHelpers.interopDefault(_phoneEnabledOutlined);
var _phoneEnabledRounded = require("./PhoneEnabledRounded");
var _phoneEnabledRoundedDefault = parcelHelpers.interopDefault(_phoneEnabledRounded);
var _phoneEnabledSharp = require("./PhoneEnabledSharp");
var _phoneEnabledSharpDefault = parcelHelpers.interopDefault(_phoneEnabledSharp);
var _phoneEnabledTwoTone = require("./PhoneEnabledTwoTone");
var _phoneEnabledTwoToneDefault = parcelHelpers.interopDefault(_phoneEnabledTwoTone);
var _phoneForwarded = require("./PhoneForwarded");
var _phoneForwardedDefault = parcelHelpers.interopDefault(_phoneForwarded);
var _phoneForwardedOutlined = require("./PhoneForwardedOutlined");
var _phoneForwardedOutlinedDefault = parcelHelpers.interopDefault(_phoneForwardedOutlined);
var _phoneForwardedRounded = require("./PhoneForwardedRounded");
var _phoneForwardedRoundedDefault = parcelHelpers.interopDefault(_phoneForwardedRounded);
var _phoneForwardedSharp = require("./PhoneForwardedSharp");
var _phoneForwardedSharpDefault = parcelHelpers.interopDefault(_phoneForwardedSharp);
var _phoneForwardedTwoTone = require("./PhoneForwardedTwoTone");
var _phoneForwardedTwoToneDefault = parcelHelpers.interopDefault(_phoneForwardedTwoTone);
var _phoneInTalk = require("./PhoneInTalk");
var _phoneInTalkDefault = parcelHelpers.interopDefault(_phoneInTalk);
var _phoneInTalkOutlined = require("./PhoneInTalkOutlined");
var _phoneInTalkOutlinedDefault = parcelHelpers.interopDefault(_phoneInTalkOutlined);
var _phoneInTalkRounded = require("./PhoneInTalkRounded");
var _phoneInTalkRoundedDefault = parcelHelpers.interopDefault(_phoneInTalkRounded);
var _phoneInTalkSharp = require("./PhoneInTalkSharp");
var _phoneInTalkSharpDefault = parcelHelpers.interopDefault(_phoneInTalkSharp);
var _phoneInTalkTwoTone = require("./PhoneInTalkTwoTone");
var _phoneInTalkTwoToneDefault = parcelHelpers.interopDefault(_phoneInTalkTwoTone);
var _phoneIphone = require("./PhoneIphone");
var _phoneIphoneDefault = parcelHelpers.interopDefault(_phoneIphone);
var _phoneIphoneOutlined = require("./PhoneIphoneOutlined");
var _phoneIphoneOutlinedDefault = parcelHelpers.interopDefault(_phoneIphoneOutlined);
var _phoneIphoneRounded = require("./PhoneIphoneRounded");
var _phoneIphoneRoundedDefault = parcelHelpers.interopDefault(_phoneIphoneRounded);
var _phoneIphoneSharp = require("./PhoneIphoneSharp");
var _phoneIphoneSharpDefault = parcelHelpers.interopDefault(_phoneIphoneSharp);
var _phoneIphoneTwoTone = require("./PhoneIphoneTwoTone");
var _phoneIphoneTwoToneDefault = parcelHelpers.interopDefault(_phoneIphoneTwoTone);
var _phoneLocked = require("./PhoneLocked");
var _phoneLockedDefault = parcelHelpers.interopDefault(_phoneLocked);
var _phoneLockedOutlined = require("./PhoneLockedOutlined");
var _phoneLockedOutlinedDefault = parcelHelpers.interopDefault(_phoneLockedOutlined);
var _phoneLockedRounded = require("./PhoneLockedRounded");
var _phoneLockedRoundedDefault = parcelHelpers.interopDefault(_phoneLockedRounded);
var _phoneLockedSharp = require("./PhoneLockedSharp");
var _phoneLockedSharpDefault = parcelHelpers.interopDefault(_phoneLockedSharp);
var _phoneLockedTwoTone = require("./PhoneLockedTwoTone");
var _phoneLockedTwoToneDefault = parcelHelpers.interopDefault(_phoneLockedTwoTone);
var _phoneMissed = require("./PhoneMissed");
var _phoneMissedDefault = parcelHelpers.interopDefault(_phoneMissed);
var _phoneMissedOutlined = require("./PhoneMissedOutlined");
var _phoneMissedOutlinedDefault = parcelHelpers.interopDefault(_phoneMissedOutlined);
var _phoneMissedRounded = require("./PhoneMissedRounded");
var _phoneMissedRoundedDefault = parcelHelpers.interopDefault(_phoneMissedRounded);
var _phoneMissedSharp = require("./PhoneMissedSharp");
var _phoneMissedSharpDefault = parcelHelpers.interopDefault(_phoneMissedSharp);
var _phoneMissedTwoTone = require("./PhoneMissedTwoTone");
var _phoneMissedTwoToneDefault = parcelHelpers.interopDefault(_phoneMissedTwoTone);
var _phoneOutlined = require("./PhoneOutlined");
var _phoneOutlinedDefault = parcelHelpers.interopDefault(_phoneOutlined);
var _phonePaused = require("./PhonePaused");
var _phonePausedDefault = parcelHelpers.interopDefault(_phonePaused);
var _phonePausedOutlined = require("./PhonePausedOutlined");
var _phonePausedOutlinedDefault = parcelHelpers.interopDefault(_phonePausedOutlined);
var _phonePausedRounded = require("./PhonePausedRounded");
var _phonePausedRoundedDefault = parcelHelpers.interopDefault(_phonePausedRounded);
var _phonePausedSharp = require("./PhonePausedSharp");
var _phonePausedSharpDefault = parcelHelpers.interopDefault(_phonePausedSharp);
var _phonePausedTwoTone = require("./PhonePausedTwoTone");
var _phonePausedTwoToneDefault = parcelHelpers.interopDefault(_phonePausedTwoTone);
var _phoneRounded = require("./PhoneRounded");
var _phoneRoundedDefault = parcelHelpers.interopDefault(_phoneRounded);
var _phoneSharp = require("./PhoneSharp");
var _phoneSharpDefault = parcelHelpers.interopDefault(_phoneSharp);
var _phoneTwoTone = require("./PhoneTwoTone");
var _phoneTwoToneDefault = parcelHelpers.interopDefault(_phoneTwoTone);
var _phonelink = require("./Phonelink");
var _phonelinkDefault = parcelHelpers.interopDefault(_phonelink);
var _phonelinkErase = require("./PhonelinkErase");
var _phonelinkEraseDefault = parcelHelpers.interopDefault(_phonelinkErase);
var _phonelinkEraseOutlined = require("./PhonelinkEraseOutlined");
var _phonelinkEraseOutlinedDefault = parcelHelpers.interopDefault(_phonelinkEraseOutlined);
var _phonelinkEraseRounded = require("./PhonelinkEraseRounded");
var _phonelinkEraseRoundedDefault = parcelHelpers.interopDefault(_phonelinkEraseRounded);
var _phonelinkEraseSharp = require("./PhonelinkEraseSharp");
var _phonelinkEraseSharpDefault = parcelHelpers.interopDefault(_phonelinkEraseSharp);
var _phonelinkEraseTwoTone = require("./PhonelinkEraseTwoTone");
var _phonelinkEraseTwoToneDefault = parcelHelpers.interopDefault(_phonelinkEraseTwoTone);
var _phonelinkLock = require("./PhonelinkLock");
var _phonelinkLockDefault = parcelHelpers.interopDefault(_phonelinkLock);
var _phonelinkLockOutlined = require("./PhonelinkLockOutlined");
var _phonelinkLockOutlinedDefault = parcelHelpers.interopDefault(_phonelinkLockOutlined);
var _phonelinkLockRounded = require("./PhonelinkLockRounded");
var _phonelinkLockRoundedDefault = parcelHelpers.interopDefault(_phonelinkLockRounded);
var _phonelinkLockSharp = require("./PhonelinkLockSharp");
var _phonelinkLockSharpDefault = parcelHelpers.interopDefault(_phonelinkLockSharp);
var _phonelinkLockTwoTone = require("./PhonelinkLockTwoTone");
var _phonelinkLockTwoToneDefault = parcelHelpers.interopDefault(_phonelinkLockTwoTone);
var _phonelinkOff = require("./PhonelinkOff");
var _phonelinkOffDefault = parcelHelpers.interopDefault(_phonelinkOff);
var _phonelinkOffOutlined = require("./PhonelinkOffOutlined");
var _phonelinkOffOutlinedDefault = parcelHelpers.interopDefault(_phonelinkOffOutlined);
var _phonelinkOffRounded = require("./PhonelinkOffRounded");
var _phonelinkOffRoundedDefault = parcelHelpers.interopDefault(_phonelinkOffRounded);
var _phonelinkOffSharp = require("./PhonelinkOffSharp");
var _phonelinkOffSharpDefault = parcelHelpers.interopDefault(_phonelinkOffSharp);
var _phonelinkOffTwoTone = require("./PhonelinkOffTwoTone");
var _phonelinkOffTwoToneDefault = parcelHelpers.interopDefault(_phonelinkOffTwoTone);
var _phonelinkOutlined = require("./PhonelinkOutlined");
var _phonelinkOutlinedDefault = parcelHelpers.interopDefault(_phonelinkOutlined);
var _phonelinkRing = require("./PhonelinkRing");
var _phonelinkRingDefault = parcelHelpers.interopDefault(_phonelinkRing);
var _phonelinkRingOutlined = require("./PhonelinkRingOutlined");
var _phonelinkRingOutlinedDefault = parcelHelpers.interopDefault(_phonelinkRingOutlined);
var _phonelinkRingRounded = require("./PhonelinkRingRounded");
var _phonelinkRingRoundedDefault = parcelHelpers.interopDefault(_phonelinkRingRounded);
var _phonelinkRingSharp = require("./PhonelinkRingSharp");
var _phonelinkRingSharpDefault = parcelHelpers.interopDefault(_phonelinkRingSharp);
var _phonelinkRingTwoTone = require("./PhonelinkRingTwoTone");
var _phonelinkRingTwoToneDefault = parcelHelpers.interopDefault(_phonelinkRingTwoTone);
var _phonelinkRounded = require("./PhonelinkRounded");
var _phonelinkRoundedDefault = parcelHelpers.interopDefault(_phonelinkRounded);
var _phonelinkSetup = require("./PhonelinkSetup");
var _phonelinkSetupDefault = parcelHelpers.interopDefault(_phonelinkSetup);
var _phonelinkSetupOutlined = require("./PhonelinkSetupOutlined");
var _phonelinkSetupOutlinedDefault = parcelHelpers.interopDefault(_phonelinkSetupOutlined);
var _phonelinkSetupRounded = require("./PhonelinkSetupRounded");
var _phonelinkSetupRoundedDefault = parcelHelpers.interopDefault(_phonelinkSetupRounded);
var _phonelinkSetupSharp = require("./PhonelinkSetupSharp");
var _phonelinkSetupSharpDefault = parcelHelpers.interopDefault(_phonelinkSetupSharp);
var _phonelinkSetupTwoTone = require("./PhonelinkSetupTwoTone");
var _phonelinkSetupTwoToneDefault = parcelHelpers.interopDefault(_phonelinkSetupTwoTone);
var _phonelinkSharp = require("./PhonelinkSharp");
var _phonelinkSharpDefault = parcelHelpers.interopDefault(_phonelinkSharp);
var _phonelinkTwoTone = require("./PhonelinkTwoTone");
var _phonelinkTwoToneDefault = parcelHelpers.interopDefault(_phonelinkTwoTone);
var _photo = require("./Photo");
var _photoDefault = parcelHelpers.interopDefault(_photo);
var _photoAlbum = require("./PhotoAlbum");
var _photoAlbumDefault = parcelHelpers.interopDefault(_photoAlbum);
var _photoAlbumOutlined = require("./PhotoAlbumOutlined");
var _photoAlbumOutlinedDefault = parcelHelpers.interopDefault(_photoAlbumOutlined);
var _photoAlbumRounded = require("./PhotoAlbumRounded");
var _photoAlbumRoundedDefault = parcelHelpers.interopDefault(_photoAlbumRounded);
var _photoAlbumSharp = require("./PhotoAlbumSharp");
var _photoAlbumSharpDefault = parcelHelpers.interopDefault(_photoAlbumSharp);
var _photoAlbumTwoTone = require("./PhotoAlbumTwoTone");
var _photoAlbumTwoToneDefault = parcelHelpers.interopDefault(_photoAlbumTwoTone);
var _photoCamera = require("./PhotoCamera");
var _photoCameraDefault = parcelHelpers.interopDefault(_photoCamera);
var _photoCameraBack = require("./PhotoCameraBack");
var _photoCameraBackDefault = parcelHelpers.interopDefault(_photoCameraBack);
var _photoCameraBackOutlined = require("./PhotoCameraBackOutlined");
var _photoCameraBackOutlinedDefault = parcelHelpers.interopDefault(_photoCameraBackOutlined);
var _photoCameraBackRounded = require("./PhotoCameraBackRounded");
var _photoCameraBackRoundedDefault = parcelHelpers.interopDefault(_photoCameraBackRounded);
var _photoCameraBackSharp = require("./PhotoCameraBackSharp");
var _photoCameraBackSharpDefault = parcelHelpers.interopDefault(_photoCameraBackSharp);
var _photoCameraBackTwoTone = require("./PhotoCameraBackTwoTone");
var _photoCameraBackTwoToneDefault = parcelHelpers.interopDefault(_photoCameraBackTwoTone);
var _photoCameraFront = require("./PhotoCameraFront");
var _photoCameraFrontDefault = parcelHelpers.interopDefault(_photoCameraFront);
var _photoCameraFrontOutlined = require("./PhotoCameraFrontOutlined");
var _photoCameraFrontOutlinedDefault = parcelHelpers.interopDefault(_photoCameraFrontOutlined);
var _photoCameraFrontRounded = require("./PhotoCameraFrontRounded");
var _photoCameraFrontRoundedDefault = parcelHelpers.interopDefault(_photoCameraFrontRounded);
var _photoCameraFrontSharp = require("./PhotoCameraFrontSharp");
var _photoCameraFrontSharpDefault = parcelHelpers.interopDefault(_photoCameraFrontSharp);
var _photoCameraFrontTwoTone = require("./PhotoCameraFrontTwoTone");
var _photoCameraFrontTwoToneDefault = parcelHelpers.interopDefault(_photoCameraFrontTwoTone);
var _photoCameraOutlined = require("./PhotoCameraOutlined");
var _photoCameraOutlinedDefault = parcelHelpers.interopDefault(_photoCameraOutlined);
var _photoCameraRounded = require("./PhotoCameraRounded");
var _photoCameraRoundedDefault = parcelHelpers.interopDefault(_photoCameraRounded);
var _photoCameraSharp = require("./PhotoCameraSharp");
var _photoCameraSharpDefault = parcelHelpers.interopDefault(_photoCameraSharp);
var _photoCameraTwoTone = require("./PhotoCameraTwoTone");
var _photoCameraTwoToneDefault = parcelHelpers.interopDefault(_photoCameraTwoTone);
var _photoFilter = require("./PhotoFilter");
var _photoFilterDefault = parcelHelpers.interopDefault(_photoFilter);
var _photoFilterOutlined = require("./PhotoFilterOutlined");
var _photoFilterOutlinedDefault = parcelHelpers.interopDefault(_photoFilterOutlined);
var _photoFilterRounded = require("./PhotoFilterRounded");
var _photoFilterRoundedDefault = parcelHelpers.interopDefault(_photoFilterRounded);
var _photoFilterSharp = require("./PhotoFilterSharp");
var _photoFilterSharpDefault = parcelHelpers.interopDefault(_photoFilterSharp);
var _photoFilterTwoTone = require("./PhotoFilterTwoTone");
var _photoFilterTwoToneDefault = parcelHelpers.interopDefault(_photoFilterTwoTone);
var _photoLibrary = require("./PhotoLibrary");
var _photoLibraryDefault = parcelHelpers.interopDefault(_photoLibrary);
var _photoLibraryOutlined = require("./PhotoLibraryOutlined");
var _photoLibraryOutlinedDefault = parcelHelpers.interopDefault(_photoLibraryOutlined);
var _photoLibraryRounded = require("./PhotoLibraryRounded");
var _photoLibraryRoundedDefault = parcelHelpers.interopDefault(_photoLibraryRounded);
var _photoLibrarySharp = require("./PhotoLibrarySharp");
var _photoLibrarySharpDefault = parcelHelpers.interopDefault(_photoLibrarySharp);
var _photoLibraryTwoTone = require("./PhotoLibraryTwoTone");
var _photoLibraryTwoToneDefault = parcelHelpers.interopDefault(_photoLibraryTwoTone);
var _photoOutlined = require("./PhotoOutlined");
var _photoOutlinedDefault = parcelHelpers.interopDefault(_photoOutlined);
var _photoRounded = require("./PhotoRounded");
var _photoRoundedDefault = parcelHelpers.interopDefault(_photoRounded);
var _photoSharp = require("./PhotoSharp");
var _photoSharpDefault = parcelHelpers.interopDefault(_photoSharp);
var _photoSizeSelectActual = require("./PhotoSizeSelectActual");
var _photoSizeSelectActualDefault = parcelHelpers.interopDefault(_photoSizeSelectActual);
var _photoSizeSelectActualOutlined = require("./PhotoSizeSelectActualOutlined");
var _photoSizeSelectActualOutlinedDefault = parcelHelpers.interopDefault(_photoSizeSelectActualOutlined);
var _photoSizeSelectActualRounded = require("./PhotoSizeSelectActualRounded");
var _photoSizeSelectActualRoundedDefault = parcelHelpers.interopDefault(_photoSizeSelectActualRounded);
var _photoSizeSelectActualSharp = require("./PhotoSizeSelectActualSharp");
var _photoSizeSelectActualSharpDefault = parcelHelpers.interopDefault(_photoSizeSelectActualSharp);
var _photoSizeSelectActualTwoTone = require("./PhotoSizeSelectActualTwoTone");
var _photoSizeSelectActualTwoToneDefault = parcelHelpers.interopDefault(_photoSizeSelectActualTwoTone);
var _photoSizeSelectLarge = require("./PhotoSizeSelectLarge");
var _photoSizeSelectLargeDefault = parcelHelpers.interopDefault(_photoSizeSelectLarge);
var _photoSizeSelectLargeOutlined = require("./PhotoSizeSelectLargeOutlined");
var _photoSizeSelectLargeOutlinedDefault = parcelHelpers.interopDefault(_photoSizeSelectLargeOutlined);
var _photoSizeSelectLargeRounded = require("./PhotoSizeSelectLargeRounded");
var _photoSizeSelectLargeRoundedDefault = parcelHelpers.interopDefault(_photoSizeSelectLargeRounded);
var _photoSizeSelectLargeSharp = require("./PhotoSizeSelectLargeSharp");
var _photoSizeSelectLargeSharpDefault = parcelHelpers.interopDefault(_photoSizeSelectLargeSharp);
var _photoSizeSelectLargeTwoTone = require("./PhotoSizeSelectLargeTwoTone");
var _photoSizeSelectLargeTwoToneDefault = parcelHelpers.interopDefault(_photoSizeSelectLargeTwoTone);
var _photoSizeSelectSmall = require("./PhotoSizeSelectSmall");
var _photoSizeSelectSmallDefault = parcelHelpers.interopDefault(_photoSizeSelectSmall);
var _photoSizeSelectSmallOutlined = require("./PhotoSizeSelectSmallOutlined");
var _photoSizeSelectSmallOutlinedDefault = parcelHelpers.interopDefault(_photoSizeSelectSmallOutlined);
var _photoSizeSelectSmallRounded = require("./PhotoSizeSelectSmallRounded");
var _photoSizeSelectSmallRoundedDefault = parcelHelpers.interopDefault(_photoSizeSelectSmallRounded);
var _photoSizeSelectSmallSharp = require("./PhotoSizeSelectSmallSharp");
var _photoSizeSelectSmallSharpDefault = parcelHelpers.interopDefault(_photoSizeSelectSmallSharp);
var _photoSizeSelectSmallTwoTone = require("./PhotoSizeSelectSmallTwoTone");
var _photoSizeSelectSmallTwoToneDefault = parcelHelpers.interopDefault(_photoSizeSelectSmallTwoTone);
var _photoTwoTone = require("./PhotoTwoTone");
var _photoTwoToneDefault = parcelHelpers.interopDefault(_photoTwoTone);
var _php = require("./Php");
var _phpDefault = parcelHelpers.interopDefault(_php);
var _phpOutlined = require("./PhpOutlined");
var _phpOutlinedDefault = parcelHelpers.interopDefault(_phpOutlined);
var _phpRounded = require("./PhpRounded");
var _phpRoundedDefault = parcelHelpers.interopDefault(_phpRounded);
var _phpSharp = require("./PhpSharp");
var _phpSharpDefault = parcelHelpers.interopDefault(_phpSharp);
var _phpTwoTone = require("./PhpTwoTone");
var _phpTwoToneDefault = parcelHelpers.interopDefault(_phpTwoTone);
var _piano = require("./Piano");
var _pianoDefault = parcelHelpers.interopDefault(_piano);
var _pianoOff = require("./PianoOff");
var _pianoOffDefault = parcelHelpers.interopDefault(_pianoOff);
var _pianoOffOutlined = require("./PianoOffOutlined");
var _pianoOffOutlinedDefault = parcelHelpers.interopDefault(_pianoOffOutlined);
var _pianoOffRounded = require("./PianoOffRounded");
var _pianoOffRoundedDefault = parcelHelpers.interopDefault(_pianoOffRounded);
var _pianoOffSharp = require("./PianoOffSharp");
var _pianoOffSharpDefault = parcelHelpers.interopDefault(_pianoOffSharp);
var _pianoOffTwoTone = require("./PianoOffTwoTone");
var _pianoOffTwoToneDefault = parcelHelpers.interopDefault(_pianoOffTwoTone);
var _pianoOutlined = require("./PianoOutlined");
var _pianoOutlinedDefault = parcelHelpers.interopDefault(_pianoOutlined);
var _pianoRounded = require("./PianoRounded");
var _pianoRoundedDefault = parcelHelpers.interopDefault(_pianoRounded);
var _pianoSharp = require("./PianoSharp");
var _pianoSharpDefault = parcelHelpers.interopDefault(_pianoSharp);
var _pianoTwoTone = require("./PianoTwoTone");
var _pianoTwoToneDefault = parcelHelpers.interopDefault(_pianoTwoTone);
var _pictureAsPdf = require("./PictureAsPdf");
var _pictureAsPdfDefault = parcelHelpers.interopDefault(_pictureAsPdf);
var _pictureAsPdfOutlined = require("./PictureAsPdfOutlined");
var _pictureAsPdfOutlinedDefault = parcelHelpers.interopDefault(_pictureAsPdfOutlined);
var _pictureAsPdfRounded = require("./PictureAsPdfRounded");
var _pictureAsPdfRoundedDefault = parcelHelpers.interopDefault(_pictureAsPdfRounded);
var _pictureAsPdfSharp = require("./PictureAsPdfSharp");
var _pictureAsPdfSharpDefault = parcelHelpers.interopDefault(_pictureAsPdfSharp);
var _pictureAsPdfTwoTone = require("./PictureAsPdfTwoTone");
var _pictureAsPdfTwoToneDefault = parcelHelpers.interopDefault(_pictureAsPdfTwoTone);
var _pictureInPicture = require("./PictureInPicture");
var _pictureInPictureDefault = parcelHelpers.interopDefault(_pictureInPicture);
var _pictureInPictureAlt = require("./PictureInPictureAlt");
var _pictureInPictureAltDefault = parcelHelpers.interopDefault(_pictureInPictureAlt);
var _pictureInPictureAltOutlined = require("./PictureInPictureAltOutlined");
var _pictureInPictureAltOutlinedDefault = parcelHelpers.interopDefault(_pictureInPictureAltOutlined);
var _pictureInPictureAltRounded = require("./PictureInPictureAltRounded");
var _pictureInPictureAltRoundedDefault = parcelHelpers.interopDefault(_pictureInPictureAltRounded);
var _pictureInPictureAltSharp = require("./PictureInPictureAltSharp");
var _pictureInPictureAltSharpDefault = parcelHelpers.interopDefault(_pictureInPictureAltSharp);
var _pictureInPictureAltTwoTone = require("./PictureInPictureAltTwoTone");
var _pictureInPictureAltTwoToneDefault = parcelHelpers.interopDefault(_pictureInPictureAltTwoTone);
var _pictureInPictureOutlined = require("./PictureInPictureOutlined");
var _pictureInPictureOutlinedDefault = parcelHelpers.interopDefault(_pictureInPictureOutlined);
var _pictureInPictureRounded = require("./PictureInPictureRounded");
var _pictureInPictureRoundedDefault = parcelHelpers.interopDefault(_pictureInPictureRounded);
var _pictureInPictureSharp = require("./PictureInPictureSharp");
var _pictureInPictureSharpDefault = parcelHelpers.interopDefault(_pictureInPictureSharp);
var _pictureInPictureTwoTone = require("./PictureInPictureTwoTone");
var _pictureInPictureTwoToneDefault = parcelHelpers.interopDefault(_pictureInPictureTwoTone);
var _pieChart = require("./PieChart");
var _pieChartDefault = parcelHelpers.interopDefault(_pieChart);
var _pieChartOutline = require("./PieChartOutline");
var _pieChartOutlineDefault = parcelHelpers.interopDefault(_pieChartOutline);
var _pieChartOutlineOutlined = require("./PieChartOutlineOutlined");
var _pieChartOutlineOutlinedDefault = parcelHelpers.interopDefault(_pieChartOutlineOutlined);
var _pieChartOutlineRounded = require("./PieChartOutlineRounded");
var _pieChartOutlineRoundedDefault = parcelHelpers.interopDefault(_pieChartOutlineRounded);
var _pieChartOutlineSharp = require("./PieChartOutlineSharp");
var _pieChartOutlineSharpDefault = parcelHelpers.interopDefault(_pieChartOutlineSharp);
var _pieChartOutlineTwoTone = require("./PieChartOutlineTwoTone");
var _pieChartOutlineTwoToneDefault = parcelHelpers.interopDefault(_pieChartOutlineTwoTone);
var _pieChartOutlined = require("./PieChartOutlined");
var _pieChartOutlinedDefault = parcelHelpers.interopDefault(_pieChartOutlined);
var _pieChartRounded = require("./PieChartRounded");
var _pieChartRoundedDefault = parcelHelpers.interopDefault(_pieChartRounded);
var _pieChartSharp = require("./PieChartSharp");
var _pieChartSharpDefault = parcelHelpers.interopDefault(_pieChartSharp);
var _pieChartTwoTone = require("./PieChartTwoTone");
var _pieChartTwoToneDefault = parcelHelpers.interopDefault(_pieChartTwoTone);
var _pin = require("./Pin");
var _pinDefault = parcelHelpers.interopDefault(_pin);
var _pinDrop = require("./PinDrop");
var _pinDropDefault = parcelHelpers.interopDefault(_pinDrop);
var _pinDropOutlined = require("./PinDropOutlined");
var _pinDropOutlinedDefault = parcelHelpers.interopDefault(_pinDropOutlined);
var _pinDropRounded = require("./PinDropRounded");
var _pinDropRoundedDefault = parcelHelpers.interopDefault(_pinDropRounded);
var _pinDropSharp = require("./PinDropSharp");
var _pinDropSharpDefault = parcelHelpers.interopDefault(_pinDropSharp);
var _pinDropTwoTone = require("./PinDropTwoTone");
var _pinDropTwoToneDefault = parcelHelpers.interopDefault(_pinDropTwoTone);
var _pinOutlined = require("./PinOutlined");
var _pinOutlinedDefault = parcelHelpers.interopDefault(_pinOutlined);
var _pinRounded = require("./PinRounded");
var _pinRoundedDefault = parcelHelpers.interopDefault(_pinRounded);
var _pinSharp = require("./PinSharp");
var _pinSharpDefault = parcelHelpers.interopDefault(_pinSharp);
var _pinTwoTone = require("./PinTwoTone");
var _pinTwoToneDefault = parcelHelpers.interopDefault(_pinTwoTone);
var _pinch = require("./Pinch");
var _pinchDefault = parcelHelpers.interopDefault(_pinch);
var _pinchOutlined = require("./PinchOutlined");
var _pinchOutlinedDefault = parcelHelpers.interopDefault(_pinchOutlined);
var _pinchRounded = require("./PinchRounded");
var _pinchRoundedDefault = parcelHelpers.interopDefault(_pinchRounded);
var _pinchSharp = require("./PinchSharp");
var _pinchSharpDefault = parcelHelpers.interopDefault(_pinchSharp);
var _pinchTwoTone = require("./PinchTwoTone");
var _pinchTwoToneDefault = parcelHelpers.interopDefault(_pinchTwoTone);
var _pinterest = require("./Pinterest");
var _pinterestDefault = parcelHelpers.interopDefault(_pinterest);
var _pivotTableChart = require("./PivotTableChart");
var _pivotTableChartDefault = parcelHelpers.interopDefault(_pivotTableChart);
var _pivotTableChartOutlined = require("./PivotTableChartOutlined");
var _pivotTableChartOutlinedDefault = parcelHelpers.interopDefault(_pivotTableChartOutlined);
var _pivotTableChartRounded = require("./PivotTableChartRounded");
var _pivotTableChartRoundedDefault = parcelHelpers.interopDefault(_pivotTableChartRounded);
var _pivotTableChartSharp = require("./PivotTableChartSharp");
var _pivotTableChartSharpDefault = parcelHelpers.interopDefault(_pivotTableChartSharp);
var _pivotTableChartTwoTone = require("./PivotTableChartTwoTone");
var _pivotTableChartTwoToneDefault = parcelHelpers.interopDefault(_pivotTableChartTwoTone);
var _pix = require("./Pix");
var _pixDefault = parcelHelpers.interopDefault(_pix);
var _pixOutlined = require("./PixOutlined");
var _pixOutlinedDefault = parcelHelpers.interopDefault(_pixOutlined);
var _pixRounded = require("./PixRounded");
var _pixRoundedDefault = parcelHelpers.interopDefault(_pixRounded);
var _pixSharp = require("./PixSharp");
var _pixSharpDefault = parcelHelpers.interopDefault(_pixSharp);
var _pixTwoTone = require("./PixTwoTone");
var _pixTwoToneDefault = parcelHelpers.interopDefault(_pixTwoTone);
var _place = require("./Place");
var _placeDefault = parcelHelpers.interopDefault(_place);
var _placeOutlined = require("./PlaceOutlined");
var _placeOutlinedDefault = parcelHelpers.interopDefault(_placeOutlined);
var _placeRounded = require("./PlaceRounded");
var _placeRoundedDefault = parcelHelpers.interopDefault(_placeRounded);
var _placeSharp = require("./PlaceSharp");
var _placeSharpDefault = parcelHelpers.interopDefault(_placeSharp);
var _placeTwoTone = require("./PlaceTwoTone");
var _placeTwoToneDefault = parcelHelpers.interopDefault(_placeTwoTone);
var _plagiarism = require("./Plagiarism");
var _plagiarismDefault = parcelHelpers.interopDefault(_plagiarism);
var _plagiarismOutlined = require("./PlagiarismOutlined");
var _plagiarismOutlinedDefault = parcelHelpers.interopDefault(_plagiarismOutlined);
var _plagiarismRounded = require("./PlagiarismRounded");
var _plagiarismRoundedDefault = parcelHelpers.interopDefault(_plagiarismRounded);
var _plagiarismSharp = require("./PlagiarismSharp");
var _plagiarismSharpDefault = parcelHelpers.interopDefault(_plagiarismSharp);
var _plagiarismTwoTone = require("./PlagiarismTwoTone");
var _plagiarismTwoToneDefault = parcelHelpers.interopDefault(_plagiarismTwoTone);
var _playArrow = require("./PlayArrow");
var _playArrowDefault = parcelHelpers.interopDefault(_playArrow);
var _playArrowOutlined = require("./PlayArrowOutlined");
var _playArrowOutlinedDefault = parcelHelpers.interopDefault(_playArrowOutlined);
var _playArrowRounded = require("./PlayArrowRounded");
var _playArrowRoundedDefault = parcelHelpers.interopDefault(_playArrowRounded);
var _playArrowSharp = require("./PlayArrowSharp");
var _playArrowSharpDefault = parcelHelpers.interopDefault(_playArrowSharp);
var _playArrowTwoTone = require("./PlayArrowTwoTone");
var _playArrowTwoToneDefault = parcelHelpers.interopDefault(_playArrowTwoTone);
var _playCircle = require("./PlayCircle");
var _playCircleDefault = parcelHelpers.interopDefault(_playCircle);
var _playCircleFilled = require("./PlayCircleFilled");
var _playCircleFilledDefault = parcelHelpers.interopDefault(_playCircleFilled);
var _playCircleFilledOutlined = require("./PlayCircleFilledOutlined");
var _playCircleFilledOutlinedDefault = parcelHelpers.interopDefault(_playCircleFilledOutlined);
var _playCircleFilledRounded = require("./PlayCircleFilledRounded");
var _playCircleFilledRoundedDefault = parcelHelpers.interopDefault(_playCircleFilledRounded);
var _playCircleFilledSharp = require("./PlayCircleFilledSharp");
var _playCircleFilledSharpDefault = parcelHelpers.interopDefault(_playCircleFilledSharp);
var _playCircleFilledTwoTone = require("./PlayCircleFilledTwoTone");
var _playCircleFilledTwoToneDefault = parcelHelpers.interopDefault(_playCircleFilledTwoTone);
var _playCircleFilledWhite = require("./PlayCircleFilledWhite");
var _playCircleFilledWhiteDefault = parcelHelpers.interopDefault(_playCircleFilledWhite);
var _playCircleFilledWhiteOutlined = require("./PlayCircleFilledWhiteOutlined");
var _playCircleFilledWhiteOutlinedDefault = parcelHelpers.interopDefault(_playCircleFilledWhiteOutlined);
var _playCircleFilledWhiteRounded = require("./PlayCircleFilledWhiteRounded");
var _playCircleFilledWhiteRoundedDefault = parcelHelpers.interopDefault(_playCircleFilledWhiteRounded);
var _playCircleFilledWhiteSharp = require("./PlayCircleFilledWhiteSharp");
var _playCircleFilledWhiteSharpDefault = parcelHelpers.interopDefault(_playCircleFilledWhiteSharp);
var _playCircleFilledWhiteTwoTone = require("./PlayCircleFilledWhiteTwoTone");
var _playCircleFilledWhiteTwoToneDefault = parcelHelpers.interopDefault(_playCircleFilledWhiteTwoTone);
var _playCircleOutline = require("./PlayCircleOutline");
var _playCircleOutlineDefault = parcelHelpers.interopDefault(_playCircleOutline);
var _playCircleOutlineOutlined = require("./PlayCircleOutlineOutlined");
var _playCircleOutlineOutlinedDefault = parcelHelpers.interopDefault(_playCircleOutlineOutlined);
var _playCircleOutlineRounded = require("./PlayCircleOutlineRounded");
var _playCircleOutlineRoundedDefault = parcelHelpers.interopDefault(_playCircleOutlineRounded);
var _playCircleOutlineSharp = require("./PlayCircleOutlineSharp");
var _playCircleOutlineSharpDefault = parcelHelpers.interopDefault(_playCircleOutlineSharp);
var _playCircleOutlineTwoTone = require("./PlayCircleOutlineTwoTone");
var _playCircleOutlineTwoToneDefault = parcelHelpers.interopDefault(_playCircleOutlineTwoTone);
var _playCircleOutlined = require("./PlayCircleOutlined");
var _playCircleOutlinedDefault = parcelHelpers.interopDefault(_playCircleOutlined);
var _playCircleRounded = require("./PlayCircleRounded");
var _playCircleRoundedDefault = parcelHelpers.interopDefault(_playCircleRounded);
var _playCircleSharp = require("./PlayCircleSharp");
var _playCircleSharpDefault = parcelHelpers.interopDefault(_playCircleSharp);
var _playCircleTwoTone = require("./PlayCircleTwoTone");
var _playCircleTwoToneDefault = parcelHelpers.interopDefault(_playCircleTwoTone);
var _playDisabled = require("./PlayDisabled");
var _playDisabledDefault = parcelHelpers.interopDefault(_playDisabled);
var _playDisabledOutlined = require("./PlayDisabledOutlined");
var _playDisabledOutlinedDefault = parcelHelpers.interopDefault(_playDisabledOutlined);
var _playDisabledRounded = require("./PlayDisabledRounded");
var _playDisabledRoundedDefault = parcelHelpers.interopDefault(_playDisabledRounded);
var _playDisabledSharp = require("./PlayDisabledSharp");
var _playDisabledSharpDefault = parcelHelpers.interopDefault(_playDisabledSharp);
var _playDisabledTwoTone = require("./PlayDisabledTwoTone");
var _playDisabledTwoToneDefault = parcelHelpers.interopDefault(_playDisabledTwoTone);
var _playForWork = require("./PlayForWork");
var _playForWorkDefault = parcelHelpers.interopDefault(_playForWork);
var _playForWorkOutlined = require("./PlayForWorkOutlined");
var _playForWorkOutlinedDefault = parcelHelpers.interopDefault(_playForWorkOutlined);
var _playForWorkRounded = require("./PlayForWorkRounded");
var _playForWorkRoundedDefault = parcelHelpers.interopDefault(_playForWorkRounded);
var _playForWorkSharp = require("./PlayForWorkSharp");
var _playForWorkSharpDefault = parcelHelpers.interopDefault(_playForWorkSharp);
var _playForWorkTwoTone = require("./PlayForWorkTwoTone");
var _playForWorkTwoToneDefault = parcelHelpers.interopDefault(_playForWorkTwoTone);
var _playLesson = require("./PlayLesson");
var _playLessonDefault = parcelHelpers.interopDefault(_playLesson);
var _playLessonOutlined = require("./PlayLessonOutlined");
var _playLessonOutlinedDefault = parcelHelpers.interopDefault(_playLessonOutlined);
var _playLessonRounded = require("./PlayLessonRounded");
var _playLessonRoundedDefault = parcelHelpers.interopDefault(_playLessonRounded);
var _playLessonSharp = require("./PlayLessonSharp");
var _playLessonSharpDefault = parcelHelpers.interopDefault(_playLessonSharp);
var _playLessonTwoTone = require("./PlayLessonTwoTone");
var _playLessonTwoToneDefault = parcelHelpers.interopDefault(_playLessonTwoTone);
var _playlistAdd = require("./PlaylistAdd");
var _playlistAddDefault = parcelHelpers.interopDefault(_playlistAdd);
var _playlistAddCheck = require("./PlaylistAddCheck");
var _playlistAddCheckDefault = parcelHelpers.interopDefault(_playlistAddCheck);
var _playlistAddCheckCircle = require("./PlaylistAddCheckCircle");
var _playlistAddCheckCircleDefault = parcelHelpers.interopDefault(_playlistAddCheckCircle);
var _playlistAddCheckCircleOutlined = require("./PlaylistAddCheckCircleOutlined");
var _playlistAddCheckCircleOutlinedDefault = parcelHelpers.interopDefault(_playlistAddCheckCircleOutlined);
var _playlistAddCheckCircleRounded = require("./PlaylistAddCheckCircleRounded");
var _playlistAddCheckCircleRoundedDefault = parcelHelpers.interopDefault(_playlistAddCheckCircleRounded);
var _playlistAddCheckCircleSharp = require("./PlaylistAddCheckCircleSharp");
var _playlistAddCheckCircleSharpDefault = parcelHelpers.interopDefault(_playlistAddCheckCircleSharp);
var _playlistAddCheckCircleTwoTone = require("./PlaylistAddCheckCircleTwoTone");
var _playlistAddCheckCircleTwoToneDefault = parcelHelpers.interopDefault(_playlistAddCheckCircleTwoTone);
var _playlistAddCheckOutlined = require("./PlaylistAddCheckOutlined");
var _playlistAddCheckOutlinedDefault = parcelHelpers.interopDefault(_playlistAddCheckOutlined);
var _playlistAddCheckRounded = require("./PlaylistAddCheckRounded");
var _playlistAddCheckRoundedDefault = parcelHelpers.interopDefault(_playlistAddCheckRounded);
var _playlistAddCheckSharp = require("./PlaylistAddCheckSharp");
var _playlistAddCheckSharpDefault = parcelHelpers.interopDefault(_playlistAddCheckSharp);
var _playlistAddCheckTwoTone = require("./PlaylistAddCheckTwoTone");
var _playlistAddCheckTwoToneDefault = parcelHelpers.interopDefault(_playlistAddCheckTwoTone);
var _playlistAddCircle = require("./PlaylistAddCircle");
var _playlistAddCircleDefault = parcelHelpers.interopDefault(_playlistAddCircle);
var _playlistAddCircleOutlined = require("./PlaylistAddCircleOutlined");
var _playlistAddCircleOutlinedDefault = parcelHelpers.interopDefault(_playlistAddCircleOutlined);
var _playlistAddCircleRounded = require("./PlaylistAddCircleRounded");
var _playlistAddCircleRoundedDefault = parcelHelpers.interopDefault(_playlistAddCircleRounded);
var _playlistAddCircleSharp = require("./PlaylistAddCircleSharp");
var _playlistAddCircleSharpDefault = parcelHelpers.interopDefault(_playlistAddCircleSharp);
var _playlistAddCircleTwoTone = require("./PlaylistAddCircleTwoTone");
var _playlistAddCircleTwoToneDefault = parcelHelpers.interopDefault(_playlistAddCircleTwoTone);
var _playlistAddOutlined = require("./PlaylistAddOutlined");
var _playlistAddOutlinedDefault = parcelHelpers.interopDefault(_playlistAddOutlined);
var _playlistAddRounded = require("./PlaylistAddRounded");
var _playlistAddRoundedDefault = parcelHelpers.interopDefault(_playlistAddRounded);
var _playlistAddSharp = require("./PlaylistAddSharp");
var _playlistAddSharpDefault = parcelHelpers.interopDefault(_playlistAddSharp);
var _playlistAddTwoTone = require("./PlaylistAddTwoTone");
var _playlistAddTwoToneDefault = parcelHelpers.interopDefault(_playlistAddTwoTone);
var _playlistPlay = require("./PlaylistPlay");
var _playlistPlayDefault = parcelHelpers.interopDefault(_playlistPlay);
var _playlistPlayOutlined = require("./PlaylistPlayOutlined");
var _playlistPlayOutlinedDefault = parcelHelpers.interopDefault(_playlistPlayOutlined);
var _playlistPlayRounded = require("./PlaylistPlayRounded");
var _playlistPlayRoundedDefault = parcelHelpers.interopDefault(_playlistPlayRounded);
var _playlistPlaySharp = require("./PlaylistPlaySharp");
var _playlistPlaySharpDefault = parcelHelpers.interopDefault(_playlistPlaySharp);
var _playlistPlayTwoTone = require("./PlaylistPlayTwoTone");
var _playlistPlayTwoToneDefault = parcelHelpers.interopDefault(_playlistPlayTwoTone);
var _playlistRemove = require("./PlaylistRemove");
var _playlistRemoveDefault = parcelHelpers.interopDefault(_playlistRemove);
var _playlistRemoveOutlined = require("./PlaylistRemoveOutlined");
var _playlistRemoveOutlinedDefault = parcelHelpers.interopDefault(_playlistRemoveOutlined);
var _playlistRemoveRounded = require("./PlaylistRemoveRounded");
var _playlistRemoveRoundedDefault = parcelHelpers.interopDefault(_playlistRemoveRounded);
var _playlistRemoveSharp = require("./PlaylistRemoveSharp");
var _playlistRemoveSharpDefault = parcelHelpers.interopDefault(_playlistRemoveSharp);
var _playlistRemoveTwoTone = require("./PlaylistRemoveTwoTone");
var _playlistRemoveTwoToneDefault = parcelHelpers.interopDefault(_playlistRemoveTwoTone);
var _plumbing = require("./Plumbing");
var _plumbingDefault = parcelHelpers.interopDefault(_plumbing);
var _plumbingOutlined = require("./PlumbingOutlined");
var _plumbingOutlinedDefault = parcelHelpers.interopDefault(_plumbingOutlined);
var _plumbingRounded = require("./PlumbingRounded");
var _plumbingRoundedDefault = parcelHelpers.interopDefault(_plumbingRounded);
var _plumbingSharp = require("./PlumbingSharp");
var _plumbingSharpDefault = parcelHelpers.interopDefault(_plumbingSharp);
var _plumbingTwoTone = require("./PlumbingTwoTone");
var _plumbingTwoToneDefault = parcelHelpers.interopDefault(_plumbingTwoTone);
var _plusOne = require("./PlusOne");
var _plusOneDefault = parcelHelpers.interopDefault(_plusOne);
var _plusOneOutlined = require("./PlusOneOutlined");
var _plusOneOutlinedDefault = parcelHelpers.interopDefault(_plusOneOutlined);
var _plusOneRounded = require("./PlusOneRounded");
var _plusOneRoundedDefault = parcelHelpers.interopDefault(_plusOneRounded);
var _plusOneSharp = require("./PlusOneSharp");
var _plusOneSharpDefault = parcelHelpers.interopDefault(_plusOneSharp);
var _plusOneTwoTone = require("./PlusOneTwoTone");
var _plusOneTwoToneDefault = parcelHelpers.interopDefault(_plusOneTwoTone);
var _podcasts = require("./Podcasts");
var _podcastsDefault = parcelHelpers.interopDefault(_podcasts);
var _podcastsOutlined = require("./PodcastsOutlined");
var _podcastsOutlinedDefault = parcelHelpers.interopDefault(_podcastsOutlined);
var _podcastsRounded = require("./PodcastsRounded");
var _podcastsRoundedDefault = parcelHelpers.interopDefault(_podcastsRounded);
var _podcastsSharp = require("./PodcastsSharp");
var _podcastsSharpDefault = parcelHelpers.interopDefault(_podcastsSharp);
var _podcastsTwoTone = require("./PodcastsTwoTone");
var _podcastsTwoToneDefault = parcelHelpers.interopDefault(_podcastsTwoTone);
var _pointOfSale = require("./PointOfSale");
var _pointOfSaleDefault = parcelHelpers.interopDefault(_pointOfSale);
var _pointOfSaleOutlined = require("./PointOfSaleOutlined");
var _pointOfSaleOutlinedDefault = parcelHelpers.interopDefault(_pointOfSaleOutlined);
var _pointOfSaleRounded = require("./PointOfSaleRounded");
var _pointOfSaleRoundedDefault = parcelHelpers.interopDefault(_pointOfSaleRounded);
var _pointOfSaleSharp = require("./PointOfSaleSharp");
var _pointOfSaleSharpDefault = parcelHelpers.interopDefault(_pointOfSaleSharp);
var _pointOfSaleTwoTone = require("./PointOfSaleTwoTone");
var _pointOfSaleTwoToneDefault = parcelHelpers.interopDefault(_pointOfSaleTwoTone);
var _policy = require("./Policy");
var _policyDefault = parcelHelpers.interopDefault(_policy);
var _policyOutlined = require("./PolicyOutlined");
var _policyOutlinedDefault = parcelHelpers.interopDefault(_policyOutlined);
var _policyRounded = require("./PolicyRounded");
var _policyRoundedDefault = parcelHelpers.interopDefault(_policyRounded);
var _policySharp = require("./PolicySharp");
var _policySharpDefault = parcelHelpers.interopDefault(_policySharp);
var _policyTwoTone = require("./PolicyTwoTone");
var _policyTwoToneDefault = parcelHelpers.interopDefault(_policyTwoTone);
var _poll = require("./Poll");
var _pollDefault = parcelHelpers.interopDefault(_poll);
var _pollOutlined = require("./PollOutlined");
var _pollOutlinedDefault = parcelHelpers.interopDefault(_pollOutlined);
var _pollRounded = require("./PollRounded");
var _pollRoundedDefault = parcelHelpers.interopDefault(_pollRounded);
var _pollSharp = require("./PollSharp");
var _pollSharpDefault = parcelHelpers.interopDefault(_pollSharp);
var _pollTwoTone = require("./PollTwoTone");
var _pollTwoToneDefault = parcelHelpers.interopDefault(_pollTwoTone);
var _polyline = require("./Polyline");
var _polylineDefault = parcelHelpers.interopDefault(_polyline);
var _polylineOutlined = require("./PolylineOutlined");
var _polylineOutlinedDefault = parcelHelpers.interopDefault(_polylineOutlined);
var _polylineRounded = require("./PolylineRounded");
var _polylineRoundedDefault = parcelHelpers.interopDefault(_polylineRounded);
var _polylineSharp = require("./PolylineSharp");
var _polylineSharpDefault = parcelHelpers.interopDefault(_polylineSharp);
var _polylineTwoTone = require("./PolylineTwoTone");
var _polylineTwoToneDefault = parcelHelpers.interopDefault(_polylineTwoTone);
var _pool = require("./Pool");
var _poolDefault = parcelHelpers.interopDefault(_pool);
var _poolOutlined = require("./PoolOutlined");
var _poolOutlinedDefault = parcelHelpers.interopDefault(_poolOutlined);
var _poolRounded = require("./PoolRounded");
var _poolRoundedDefault = parcelHelpers.interopDefault(_poolRounded);
var _poolSharp = require("./PoolSharp");
var _poolSharpDefault = parcelHelpers.interopDefault(_poolSharp);
var _poolTwoTone = require("./PoolTwoTone");
var _poolTwoToneDefault = parcelHelpers.interopDefault(_poolTwoTone);
var _portableWifiOff = require("./PortableWifiOff");
var _portableWifiOffDefault = parcelHelpers.interopDefault(_portableWifiOff);
var _portableWifiOffOutlined = require("./PortableWifiOffOutlined");
var _portableWifiOffOutlinedDefault = parcelHelpers.interopDefault(_portableWifiOffOutlined);
var _portableWifiOffRounded = require("./PortableWifiOffRounded");
var _portableWifiOffRoundedDefault = parcelHelpers.interopDefault(_portableWifiOffRounded);
var _portableWifiOffSharp = require("./PortableWifiOffSharp");
var _portableWifiOffSharpDefault = parcelHelpers.interopDefault(_portableWifiOffSharp);
var _portableWifiOffTwoTone = require("./PortableWifiOffTwoTone");
var _portableWifiOffTwoToneDefault = parcelHelpers.interopDefault(_portableWifiOffTwoTone);
var _portrait = require("./Portrait");
var _portraitDefault = parcelHelpers.interopDefault(_portrait);
var _portraitOutlined = require("./PortraitOutlined");
var _portraitOutlinedDefault = parcelHelpers.interopDefault(_portraitOutlined);
var _portraitRounded = require("./PortraitRounded");
var _portraitRoundedDefault = parcelHelpers.interopDefault(_portraitRounded);
var _portraitSharp = require("./PortraitSharp");
var _portraitSharpDefault = parcelHelpers.interopDefault(_portraitSharp);
var _portraitTwoTone = require("./PortraitTwoTone");
var _portraitTwoToneDefault = parcelHelpers.interopDefault(_portraitTwoTone);
var _postAdd = require("./PostAdd");
var _postAddDefault = parcelHelpers.interopDefault(_postAdd);
var _postAddOutlined = require("./PostAddOutlined");
var _postAddOutlinedDefault = parcelHelpers.interopDefault(_postAddOutlined);
var _postAddRounded = require("./PostAddRounded");
var _postAddRoundedDefault = parcelHelpers.interopDefault(_postAddRounded);
var _postAddSharp = require("./PostAddSharp");
var _postAddSharpDefault = parcelHelpers.interopDefault(_postAddSharp);
var _postAddTwoTone = require("./PostAddTwoTone");
var _postAddTwoToneDefault = parcelHelpers.interopDefault(_postAddTwoTone);
var _power = require("./Power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _powerInput = require("./PowerInput");
var _powerInputDefault = parcelHelpers.interopDefault(_powerInput);
var _powerInputOutlined = require("./PowerInputOutlined");
var _powerInputOutlinedDefault = parcelHelpers.interopDefault(_powerInputOutlined);
var _powerInputRounded = require("./PowerInputRounded");
var _powerInputRoundedDefault = parcelHelpers.interopDefault(_powerInputRounded);
var _powerInputSharp = require("./PowerInputSharp");
var _powerInputSharpDefault = parcelHelpers.interopDefault(_powerInputSharp);
var _powerInputTwoTone = require("./PowerInputTwoTone");
var _powerInputTwoToneDefault = parcelHelpers.interopDefault(_powerInputTwoTone);
var _powerOff = require("./PowerOff");
var _powerOffDefault = parcelHelpers.interopDefault(_powerOff);
var _powerOffOutlined = require("./PowerOffOutlined");
var _powerOffOutlinedDefault = parcelHelpers.interopDefault(_powerOffOutlined);
var _powerOffRounded = require("./PowerOffRounded");
var _powerOffRoundedDefault = parcelHelpers.interopDefault(_powerOffRounded);
var _powerOffSharp = require("./PowerOffSharp");
var _powerOffSharpDefault = parcelHelpers.interopDefault(_powerOffSharp);
var _powerOffTwoTone = require("./PowerOffTwoTone");
var _powerOffTwoToneDefault = parcelHelpers.interopDefault(_powerOffTwoTone);
var _powerOutlined = require("./PowerOutlined");
var _powerOutlinedDefault = parcelHelpers.interopDefault(_powerOutlined);
var _powerRounded = require("./PowerRounded");
var _powerRoundedDefault = parcelHelpers.interopDefault(_powerRounded);
var _powerSettingsNew = require("./PowerSettingsNew");
var _powerSettingsNewDefault = parcelHelpers.interopDefault(_powerSettingsNew);
var _powerSettingsNewOutlined = require("./PowerSettingsNewOutlined");
var _powerSettingsNewOutlinedDefault = parcelHelpers.interopDefault(_powerSettingsNewOutlined);
var _powerSettingsNewRounded = require("./PowerSettingsNewRounded");
var _powerSettingsNewRoundedDefault = parcelHelpers.interopDefault(_powerSettingsNewRounded);
var _powerSettingsNewSharp = require("./PowerSettingsNewSharp");
var _powerSettingsNewSharpDefault = parcelHelpers.interopDefault(_powerSettingsNewSharp);
var _powerSettingsNewTwoTone = require("./PowerSettingsNewTwoTone");
var _powerSettingsNewTwoToneDefault = parcelHelpers.interopDefault(_powerSettingsNewTwoTone);
var _powerSharp = require("./PowerSharp");
var _powerSharpDefault = parcelHelpers.interopDefault(_powerSharp);
var _powerTwoTone = require("./PowerTwoTone");
var _powerTwoToneDefault = parcelHelpers.interopDefault(_powerTwoTone);
var _precisionManufacturing = require("./PrecisionManufacturing");
var _precisionManufacturingDefault = parcelHelpers.interopDefault(_precisionManufacturing);
var _precisionManufacturingOutlined = require("./PrecisionManufacturingOutlined");
var _precisionManufacturingOutlinedDefault = parcelHelpers.interopDefault(_precisionManufacturingOutlined);
var _precisionManufacturingRounded = require("./PrecisionManufacturingRounded");
var _precisionManufacturingRoundedDefault = parcelHelpers.interopDefault(_precisionManufacturingRounded);
var _precisionManufacturingSharp = require("./PrecisionManufacturingSharp");
var _precisionManufacturingSharpDefault = parcelHelpers.interopDefault(_precisionManufacturingSharp);
var _precisionManufacturingTwoTone = require("./PrecisionManufacturingTwoTone");
var _precisionManufacturingTwoToneDefault = parcelHelpers.interopDefault(_precisionManufacturingTwoTone);
var _pregnantWoman = require("./PregnantWoman");
var _pregnantWomanDefault = parcelHelpers.interopDefault(_pregnantWoman);
var _pregnantWomanOutlined = require("./PregnantWomanOutlined");
var _pregnantWomanOutlinedDefault = parcelHelpers.interopDefault(_pregnantWomanOutlined);
var _pregnantWomanRounded = require("./PregnantWomanRounded");
var _pregnantWomanRoundedDefault = parcelHelpers.interopDefault(_pregnantWomanRounded);
var _pregnantWomanSharp = require("./PregnantWomanSharp");
var _pregnantWomanSharpDefault = parcelHelpers.interopDefault(_pregnantWomanSharp);
var _pregnantWomanTwoTone = require("./PregnantWomanTwoTone");
var _pregnantWomanTwoToneDefault = parcelHelpers.interopDefault(_pregnantWomanTwoTone);
var _presentToAll = require("./PresentToAll");
var _presentToAllDefault = parcelHelpers.interopDefault(_presentToAll);
var _presentToAllOutlined = require("./PresentToAllOutlined");
var _presentToAllOutlinedDefault = parcelHelpers.interopDefault(_presentToAllOutlined);
var _presentToAllRounded = require("./PresentToAllRounded");
var _presentToAllRoundedDefault = parcelHelpers.interopDefault(_presentToAllRounded);
var _presentToAllSharp = require("./PresentToAllSharp");
var _presentToAllSharpDefault = parcelHelpers.interopDefault(_presentToAllSharp);
var _presentToAllTwoTone = require("./PresentToAllTwoTone");
var _presentToAllTwoToneDefault = parcelHelpers.interopDefault(_presentToAllTwoTone);
var _preview = require("./Preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _previewOutlined = require("./PreviewOutlined");
var _previewOutlinedDefault = parcelHelpers.interopDefault(_previewOutlined);
var _previewRounded = require("./PreviewRounded");
var _previewRoundedDefault = parcelHelpers.interopDefault(_previewRounded);
var _previewSharp = require("./PreviewSharp");
var _previewSharpDefault = parcelHelpers.interopDefault(_previewSharp);
var _previewTwoTone = require("./PreviewTwoTone");
var _previewTwoToneDefault = parcelHelpers.interopDefault(_previewTwoTone);
var _priceChange = require("./PriceChange");
var _priceChangeDefault = parcelHelpers.interopDefault(_priceChange);
var _priceChangeOutlined = require("./PriceChangeOutlined");
var _priceChangeOutlinedDefault = parcelHelpers.interopDefault(_priceChangeOutlined);
var _priceChangeRounded = require("./PriceChangeRounded");
var _priceChangeRoundedDefault = parcelHelpers.interopDefault(_priceChangeRounded);
var _priceChangeSharp = require("./PriceChangeSharp");
var _priceChangeSharpDefault = parcelHelpers.interopDefault(_priceChangeSharp);
var _priceChangeTwoTone = require("./PriceChangeTwoTone");
var _priceChangeTwoToneDefault = parcelHelpers.interopDefault(_priceChangeTwoTone);
var _priceCheck = require("./PriceCheck");
var _priceCheckDefault = parcelHelpers.interopDefault(_priceCheck);
var _priceCheckOutlined = require("./PriceCheckOutlined");
var _priceCheckOutlinedDefault = parcelHelpers.interopDefault(_priceCheckOutlined);
var _priceCheckRounded = require("./PriceCheckRounded");
var _priceCheckRoundedDefault = parcelHelpers.interopDefault(_priceCheckRounded);
var _priceCheckSharp = require("./PriceCheckSharp");
var _priceCheckSharpDefault = parcelHelpers.interopDefault(_priceCheckSharp);
var _priceCheckTwoTone = require("./PriceCheckTwoTone");
var _priceCheckTwoToneDefault = parcelHelpers.interopDefault(_priceCheckTwoTone);
var _print = require("./Print");
var _printDefault = parcelHelpers.interopDefault(_print);
var _printDisabled = require("./PrintDisabled");
var _printDisabledDefault = parcelHelpers.interopDefault(_printDisabled);
var _printDisabledOutlined = require("./PrintDisabledOutlined");
var _printDisabledOutlinedDefault = parcelHelpers.interopDefault(_printDisabledOutlined);
var _printDisabledRounded = require("./PrintDisabledRounded");
var _printDisabledRoundedDefault = parcelHelpers.interopDefault(_printDisabledRounded);
var _printDisabledSharp = require("./PrintDisabledSharp");
var _printDisabledSharpDefault = parcelHelpers.interopDefault(_printDisabledSharp);
var _printDisabledTwoTone = require("./PrintDisabledTwoTone");
var _printDisabledTwoToneDefault = parcelHelpers.interopDefault(_printDisabledTwoTone);
var _printOutlined = require("./PrintOutlined");
var _printOutlinedDefault = parcelHelpers.interopDefault(_printOutlined);
var _printRounded = require("./PrintRounded");
var _printRoundedDefault = parcelHelpers.interopDefault(_printRounded);
var _printSharp = require("./PrintSharp");
var _printSharpDefault = parcelHelpers.interopDefault(_printSharp);
var _printTwoTone = require("./PrintTwoTone");
var _printTwoToneDefault = parcelHelpers.interopDefault(_printTwoTone);
var _priorityHigh = require("./PriorityHigh");
var _priorityHighDefault = parcelHelpers.interopDefault(_priorityHigh);
var _priorityHighOutlined = require("./PriorityHighOutlined");
var _priorityHighOutlinedDefault = parcelHelpers.interopDefault(_priorityHighOutlined);
var _priorityHighRounded = require("./PriorityHighRounded");
var _priorityHighRoundedDefault = parcelHelpers.interopDefault(_priorityHighRounded);
var _priorityHighSharp = require("./PriorityHighSharp");
var _priorityHighSharpDefault = parcelHelpers.interopDefault(_priorityHighSharp);
var _priorityHighTwoTone = require("./PriorityHighTwoTone");
var _priorityHighTwoToneDefault = parcelHelpers.interopDefault(_priorityHighTwoTone);
var _privacyTip = require("./PrivacyTip");
var _privacyTipDefault = parcelHelpers.interopDefault(_privacyTip);
var _privacyTipOutlined = require("./PrivacyTipOutlined");
var _privacyTipOutlinedDefault = parcelHelpers.interopDefault(_privacyTipOutlined);
var _privacyTipRounded = require("./PrivacyTipRounded");
var _privacyTipRoundedDefault = parcelHelpers.interopDefault(_privacyTipRounded);
var _privacyTipSharp = require("./PrivacyTipSharp");
var _privacyTipSharpDefault = parcelHelpers.interopDefault(_privacyTipSharp);
var _privacyTipTwoTone = require("./PrivacyTipTwoTone");
var _privacyTipTwoToneDefault = parcelHelpers.interopDefault(_privacyTipTwoTone);
var _productionQuantityLimits = require("./ProductionQuantityLimits");
var _productionQuantityLimitsDefault = parcelHelpers.interopDefault(_productionQuantityLimits);
var _productionQuantityLimitsOutlined = require("./ProductionQuantityLimitsOutlined");
var _productionQuantityLimitsOutlinedDefault = parcelHelpers.interopDefault(_productionQuantityLimitsOutlined);
var _productionQuantityLimitsRounded = require("./ProductionQuantityLimitsRounded");
var _productionQuantityLimitsRoundedDefault = parcelHelpers.interopDefault(_productionQuantityLimitsRounded);
var _productionQuantityLimitsSharp = require("./ProductionQuantityLimitsSharp");
var _productionQuantityLimitsSharpDefault = parcelHelpers.interopDefault(_productionQuantityLimitsSharp);
var _productionQuantityLimitsTwoTone = require("./ProductionQuantityLimitsTwoTone");
var _productionQuantityLimitsTwoToneDefault = parcelHelpers.interopDefault(_productionQuantityLimitsTwoTone);
var _propane = require("./Propane");
var _propaneDefault = parcelHelpers.interopDefault(_propane);
var _propaneOutlined = require("./PropaneOutlined");
var _propaneOutlinedDefault = parcelHelpers.interopDefault(_propaneOutlined);
var _propaneRounded = require("./PropaneRounded");
var _propaneRoundedDefault = parcelHelpers.interopDefault(_propaneRounded);
var _propaneSharp = require("./PropaneSharp");
var _propaneSharpDefault = parcelHelpers.interopDefault(_propaneSharp);
var _propaneTank = require("./PropaneTank");
var _propaneTankDefault = parcelHelpers.interopDefault(_propaneTank);
var _propaneTankOutlined = require("./PropaneTankOutlined");
var _propaneTankOutlinedDefault = parcelHelpers.interopDefault(_propaneTankOutlined);
var _propaneTankRounded = require("./PropaneTankRounded");
var _propaneTankRoundedDefault = parcelHelpers.interopDefault(_propaneTankRounded);
var _propaneTankSharp = require("./PropaneTankSharp");
var _propaneTankSharpDefault = parcelHelpers.interopDefault(_propaneTankSharp);
var _propaneTankTwoTone = require("./PropaneTankTwoTone");
var _propaneTankTwoToneDefault = parcelHelpers.interopDefault(_propaneTankTwoTone);
var _propaneTwoTone = require("./PropaneTwoTone");
var _propaneTwoToneDefault = parcelHelpers.interopDefault(_propaneTwoTone);
var _psychology = require("./Psychology");
var _psychologyDefault = parcelHelpers.interopDefault(_psychology);
var _psychologyAlt = require("./PsychologyAlt");
var _psychologyAltDefault = parcelHelpers.interopDefault(_psychologyAlt);
var _psychologyAltOutlined = require("./PsychologyAltOutlined");
var _psychologyAltOutlinedDefault = parcelHelpers.interopDefault(_psychologyAltOutlined);
var _psychologyAltRounded = require("./PsychologyAltRounded");
var _psychologyAltRoundedDefault = parcelHelpers.interopDefault(_psychologyAltRounded);
var _psychologyAltSharp = require("./PsychologyAltSharp");
var _psychologyAltSharpDefault = parcelHelpers.interopDefault(_psychologyAltSharp);
var _psychologyAltTwoTone = require("./PsychologyAltTwoTone");
var _psychologyAltTwoToneDefault = parcelHelpers.interopDefault(_psychologyAltTwoTone);
var _psychologyOutlined = require("./PsychologyOutlined");
var _psychologyOutlinedDefault = parcelHelpers.interopDefault(_psychologyOutlined);
var _psychologyRounded = require("./PsychologyRounded");
var _psychologyRoundedDefault = parcelHelpers.interopDefault(_psychologyRounded);
var _psychologySharp = require("./PsychologySharp");
var _psychologySharpDefault = parcelHelpers.interopDefault(_psychologySharp);
var _psychologyTwoTone = require("./PsychologyTwoTone");
var _psychologyTwoToneDefault = parcelHelpers.interopDefault(_psychologyTwoTone);
var _public = require("./Public");
var _publicDefault = parcelHelpers.interopDefault(_public);
var _publicOff = require("./PublicOff");
var _publicOffDefault = parcelHelpers.interopDefault(_publicOff);
var _publicOffOutlined = require("./PublicOffOutlined");
var _publicOffOutlinedDefault = parcelHelpers.interopDefault(_publicOffOutlined);
var _publicOffRounded = require("./PublicOffRounded");
var _publicOffRoundedDefault = parcelHelpers.interopDefault(_publicOffRounded);
var _publicOffSharp = require("./PublicOffSharp");
var _publicOffSharpDefault = parcelHelpers.interopDefault(_publicOffSharp);
var _publicOffTwoTone = require("./PublicOffTwoTone");
var _publicOffTwoToneDefault = parcelHelpers.interopDefault(_publicOffTwoTone);
var _publicOutlined = require("./PublicOutlined");
var _publicOutlinedDefault = parcelHelpers.interopDefault(_publicOutlined);
var _publicRounded = require("./PublicRounded");
var _publicRoundedDefault = parcelHelpers.interopDefault(_publicRounded);
var _publicSharp = require("./PublicSharp");
var _publicSharpDefault = parcelHelpers.interopDefault(_publicSharp);
var _publicTwoTone = require("./PublicTwoTone");
var _publicTwoToneDefault = parcelHelpers.interopDefault(_publicTwoTone);
var _publish = require("./Publish");
var _publishDefault = parcelHelpers.interopDefault(_publish);
var _publishOutlined = require("./PublishOutlined");
var _publishOutlinedDefault = parcelHelpers.interopDefault(_publishOutlined);
var _publishRounded = require("./PublishRounded");
var _publishRoundedDefault = parcelHelpers.interopDefault(_publishRounded);
var _publishSharp = require("./PublishSharp");
var _publishSharpDefault = parcelHelpers.interopDefault(_publishSharp);
var _publishTwoTone = require("./PublishTwoTone");
var _publishTwoToneDefault = parcelHelpers.interopDefault(_publishTwoTone);
var _publishedWithChanges = require("./PublishedWithChanges");
var _publishedWithChangesDefault = parcelHelpers.interopDefault(_publishedWithChanges);
var _publishedWithChangesOutlined = require("./PublishedWithChangesOutlined");
var _publishedWithChangesOutlinedDefault = parcelHelpers.interopDefault(_publishedWithChangesOutlined);
var _publishedWithChangesRounded = require("./PublishedWithChangesRounded");
var _publishedWithChangesRoundedDefault = parcelHelpers.interopDefault(_publishedWithChangesRounded);
var _publishedWithChangesSharp = require("./PublishedWithChangesSharp");
var _publishedWithChangesSharpDefault = parcelHelpers.interopDefault(_publishedWithChangesSharp);
var _publishedWithChangesTwoTone = require("./PublishedWithChangesTwoTone");
var _publishedWithChangesTwoToneDefault = parcelHelpers.interopDefault(_publishedWithChangesTwoTone);
var _punchClock = require("./PunchClock");
var _punchClockDefault = parcelHelpers.interopDefault(_punchClock);
var _punchClockOutlined = require("./PunchClockOutlined");
var _punchClockOutlinedDefault = parcelHelpers.interopDefault(_punchClockOutlined);
var _punchClockRounded = require("./PunchClockRounded");
var _punchClockRoundedDefault = parcelHelpers.interopDefault(_punchClockRounded);
var _punchClockSharp = require("./PunchClockSharp");
var _punchClockSharpDefault = parcelHelpers.interopDefault(_punchClockSharp);
var _punchClockTwoTone = require("./PunchClockTwoTone");
var _punchClockTwoToneDefault = parcelHelpers.interopDefault(_punchClockTwoTone);
var _pushPin = require("./PushPin");
var _pushPinDefault = parcelHelpers.interopDefault(_pushPin);
var _pushPinOutlined = require("./PushPinOutlined");
var _pushPinOutlinedDefault = parcelHelpers.interopDefault(_pushPinOutlined);
var _pushPinRounded = require("./PushPinRounded");
var _pushPinRoundedDefault = parcelHelpers.interopDefault(_pushPinRounded);
var _pushPinSharp = require("./PushPinSharp");
var _pushPinSharpDefault = parcelHelpers.interopDefault(_pushPinSharp);
var _pushPinTwoTone = require("./PushPinTwoTone");
var _pushPinTwoToneDefault = parcelHelpers.interopDefault(_pushPinTwoTone);
var _qrCode = require("./QrCode");
var _qrCodeDefault = parcelHelpers.interopDefault(_qrCode);
var _qrCode2 = require("./QrCode2");
var _qrCode2Default = parcelHelpers.interopDefault(_qrCode2);
var _qrCode2Outlined = require("./QrCode2Outlined");
var _qrCode2OutlinedDefault = parcelHelpers.interopDefault(_qrCode2Outlined);
var _qrCode2Rounded = require("./QrCode2Rounded");
var _qrCode2RoundedDefault = parcelHelpers.interopDefault(_qrCode2Rounded);
var _qrCode2Sharp = require("./QrCode2Sharp");
var _qrCode2SharpDefault = parcelHelpers.interopDefault(_qrCode2Sharp);
var _qrCode2TwoTone = require("./QrCode2TwoTone");
var _qrCode2TwoToneDefault = parcelHelpers.interopDefault(_qrCode2TwoTone);
var _qrCodeOutlined = require("./QrCodeOutlined");
var _qrCodeOutlinedDefault = parcelHelpers.interopDefault(_qrCodeOutlined);
var _qrCodeRounded = require("./QrCodeRounded");
var _qrCodeRoundedDefault = parcelHelpers.interopDefault(_qrCodeRounded);
var _qrCodeScanner = require("./QrCodeScanner");
var _qrCodeScannerDefault = parcelHelpers.interopDefault(_qrCodeScanner);
var _qrCodeScannerOutlined = require("./QrCodeScannerOutlined");
var _qrCodeScannerOutlinedDefault = parcelHelpers.interopDefault(_qrCodeScannerOutlined);
var _qrCodeScannerRounded = require("./QrCodeScannerRounded");
var _qrCodeScannerRoundedDefault = parcelHelpers.interopDefault(_qrCodeScannerRounded);
var _qrCodeScannerSharp = require("./QrCodeScannerSharp");
var _qrCodeScannerSharpDefault = parcelHelpers.interopDefault(_qrCodeScannerSharp);
var _qrCodeScannerTwoTone = require("./QrCodeScannerTwoTone");
var _qrCodeScannerTwoToneDefault = parcelHelpers.interopDefault(_qrCodeScannerTwoTone);
var _qrCodeSharp = require("./QrCodeSharp");
var _qrCodeSharpDefault = parcelHelpers.interopDefault(_qrCodeSharp);
var _qrCodeTwoTone = require("./QrCodeTwoTone");
var _qrCodeTwoToneDefault = parcelHelpers.interopDefault(_qrCodeTwoTone);
var _queryBuilder = require("./QueryBuilder");
var _queryBuilderDefault = parcelHelpers.interopDefault(_queryBuilder);
var _queryBuilderOutlined = require("./QueryBuilderOutlined");
var _queryBuilderOutlinedDefault = parcelHelpers.interopDefault(_queryBuilderOutlined);
var _queryBuilderRounded = require("./QueryBuilderRounded");
var _queryBuilderRoundedDefault = parcelHelpers.interopDefault(_queryBuilderRounded);
var _queryBuilderSharp = require("./QueryBuilderSharp");
var _queryBuilderSharpDefault = parcelHelpers.interopDefault(_queryBuilderSharp);
var _queryBuilderTwoTone = require("./QueryBuilderTwoTone");
var _queryBuilderTwoToneDefault = parcelHelpers.interopDefault(_queryBuilderTwoTone);
var _queryStats = require("./QueryStats");
var _queryStatsDefault = parcelHelpers.interopDefault(_queryStats);
var _queryStatsOutlined = require("./QueryStatsOutlined");
var _queryStatsOutlinedDefault = parcelHelpers.interopDefault(_queryStatsOutlined);
var _queryStatsRounded = require("./QueryStatsRounded");
var _queryStatsRoundedDefault = parcelHelpers.interopDefault(_queryStatsRounded);
var _queryStatsSharp = require("./QueryStatsSharp");
var _queryStatsSharpDefault = parcelHelpers.interopDefault(_queryStatsSharp);
var _queryStatsTwoTone = require("./QueryStatsTwoTone");
var _queryStatsTwoToneDefault = parcelHelpers.interopDefault(_queryStatsTwoTone);
var _questionAnswer = require("./QuestionAnswer");
var _questionAnswerDefault = parcelHelpers.interopDefault(_questionAnswer);
var _questionAnswerOutlined = require("./QuestionAnswerOutlined");
var _questionAnswerOutlinedDefault = parcelHelpers.interopDefault(_questionAnswerOutlined);
var _questionAnswerRounded = require("./QuestionAnswerRounded");
var _questionAnswerRoundedDefault = parcelHelpers.interopDefault(_questionAnswerRounded);
var _questionAnswerSharp = require("./QuestionAnswerSharp");
var _questionAnswerSharpDefault = parcelHelpers.interopDefault(_questionAnswerSharp);
var _questionAnswerTwoTone = require("./QuestionAnswerTwoTone");
var _questionAnswerTwoToneDefault = parcelHelpers.interopDefault(_questionAnswerTwoTone);
var _questionMark = require("./QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _questionMarkOutlined = require("./QuestionMarkOutlined");
var _questionMarkOutlinedDefault = parcelHelpers.interopDefault(_questionMarkOutlined);
var _questionMarkRounded = require("./QuestionMarkRounded");
var _questionMarkRoundedDefault = parcelHelpers.interopDefault(_questionMarkRounded);
var _questionMarkSharp = require("./QuestionMarkSharp");
var _questionMarkSharpDefault = parcelHelpers.interopDefault(_questionMarkSharp);
var _questionMarkTwoTone = require("./QuestionMarkTwoTone");
var _questionMarkTwoToneDefault = parcelHelpers.interopDefault(_questionMarkTwoTone);
var _queue = require("./Queue");
var _queueDefault = parcelHelpers.interopDefault(_queue);
var _queueMusic = require("./QueueMusic");
var _queueMusicDefault = parcelHelpers.interopDefault(_queueMusic);
var _queueMusicOutlined = require("./QueueMusicOutlined");
var _queueMusicOutlinedDefault = parcelHelpers.interopDefault(_queueMusicOutlined);
var _queueMusicRounded = require("./QueueMusicRounded");
var _queueMusicRoundedDefault = parcelHelpers.interopDefault(_queueMusicRounded);
var _queueMusicSharp = require("./QueueMusicSharp");
var _queueMusicSharpDefault = parcelHelpers.interopDefault(_queueMusicSharp);
var _queueMusicTwoTone = require("./QueueMusicTwoTone");
var _queueMusicTwoToneDefault = parcelHelpers.interopDefault(_queueMusicTwoTone);
var _queueOutlined = require("./QueueOutlined");
var _queueOutlinedDefault = parcelHelpers.interopDefault(_queueOutlined);
var _queuePlayNext = require("./QueuePlayNext");
var _queuePlayNextDefault = parcelHelpers.interopDefault(_queuePlayNext);
var _queuePlayNextOutlined = require("./QueuePlayNextOutlined");
var _queuePlayNextOutlinedDefault = parcelHelpers.interopDefault(_queuePlayNextOutlined);
var _queuePlayNextRounded = require("./QueuePlayNextRounded");
var _queuePlayNextRoundedDefault = parcelHelpers.interopDefault(_queuePlayNextRounded);
var _queuePlayNextSharp = require("./QueuePlayNextSharp");
var _queuePlayNextSharpDefault = parcelHelpers.interopDefault(_queuePlayNextSharp);
var _queuePlayNextTwoTone = require("./QueuePlayNextTwoTone");
var _queuePlayNextTwoToneDefault = parcelHelpers.interopDefault(_queuePlayNextTwoTone);
var _queueRounded = require("./QueueRounded");
var _queueRoundedDefault = parcelHelpers.interopDefault(_queueRounded);
var _queueSharp = require("./QueueSharp");
var _queueSharpDefault = parcelHelpers.interopDefault(_queueSharp);
var _queueTwoTone = require("./QueueTwoTone");
var _queueTwoToneDefault = parcelHelpers.interopDefault(_queueTwoTone);
var _quickreply = require("./Quickreply");
var _quickreplyDefault = parcelHelpers.interopDefault(_quickreply);
var _quickreplyOutlined = require("./QuickreplyOutlined");
var _quickreplyOutlinedDefault = parcelHelpers.interopDefault(_quickreplyOutlined);
var _quickreplyRounded = require("./QuickreplyRounded");
var _quickreplyRoundedDefault = parcelHelpers.interopDefault(_quickreplyRounded);
var _quickreplySharp = require("./QuickreplySharp");
var _quickreplySharpDefault = parcelHelpers.interopDefault(_quickreplySharp);
var _quickreplyTwoTone = require("./QuickreplyTwoTone");
var _quickreplyTwoToneDefault = parcelHelpers.interopDefault(_quickreplyTwoTone);
var _quiz = require("./Quiz");
var _quizDefault = parcelHelpers.interopDefault(_quiz);
var _quizOutlined = require("./QuizOutlined");
var _quizOutlinedDefault = parcelHelpers.interopDefault(_quizOutlined);
var _quizRounded = require("./QuizRounded");
var _quizRoundedDefault = parcelHelpers.interopDefault(_quizRounded);
var _quizSharp = require("./QuizSharp");
var _quizSharpDefault = parcelHelpers.interopDefault(_quizSharp);
var _quizTwoTone = require("./QuizTwoTone");
var _quizTwoToneDefault = parcelHelpers.interopDefault(_quizTwoTone);
var _rmobiledata = require("./RMobiledata");
var _rmobiledataDefault = parcelHelpers.interopDefault(_rmobiledata);
var _rmobiledataOutlined = require("./RMobiledataOutlined");
var _rmobiledataOutlinedDefault = parcelHelpers.interopDefault(_rmobiledataOutlined);
var _rmobiledataRounded = require("./RMobiledataRounded");
var _rmobiledataRoundedDefault = parcelHelpers.interopDefault(_rmobiledataRounded);
var _rmobiledataSharp = require("./RMobiledataSharp");
var _rmobiledataSharpDefault = parcelHelpers.interopDefault(_rmobiledataSharp);
var _rmobiledataTwoTone = require("./RMobiledataTwoTone");
var _rmobiledataTwoToneDefault = parcelHelpers.interopDefault(_rmobiledataTwoTone);
var _radar = require("./Radar");
var _radarDefault = parcelHelpers.interopDefault(_radar);
var _radarOutlined = require("./RadarOutlined");
var _radarOutlinedDefault = parcelHelpers.interopDefault(_radarOutlined);
var _radarRounded = require("./RadarRounded");
var _radarRoundedDefault = parcelHelpers.interopDefault(_radarRounded);
var _radarSharp = require("./RadarSharp");
var _radarSharpDefault = parcelHelpers.interopDefault(_radarSharp);
var _radarTwoTone = require("./RadarTwoTone");
var _radarTwoToneDefault = parcelHelpers.interopDefault(_radarTwoTone);
var _radio = require("./Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioButtonChecked = require("./RadioButtonChecked");
var _radioButtonCheckedDefault = parcelHelpers.interopDefault(_radioButtonChecked);
var _radioButtonCheckedOutlined = require("./RadioButtonCheckedOutlined");
var _radioButtonCheckedOutlinedDefault = parcelHelpers.interopDefault(_radioButtonCheckedOutlined);
var _radioButtonCheckedRounded = require("./RadioButtonCheckedRounded");
var _radioButtonCheckedRoundedDefault = parcelHelpers.interopDefault(_radioButtonCheckedRounded);
var _radioButtonCheckedSharp = require("./RadioButtonCheckedSharp");
var _radioButtonCheckedSharpDefault = parcelHelpers.interopDefault(_radioButtonCheckedSharp);
var _radioButtonCheckedTwoTone = require("./RadioButtonCheckedTwoTone");
var _radioButtonCheckedTwoToneDefault = parcelHelpers.interopDefault(_radioButtonCheckedTwoTone);
var _radioButtonUnchecked = require("./RadioButtonUnchecked");
var _radioButtonUncheckedDefault = parcelHelpers.interopDefault(_radioButtonUnchecked);
var _radioButtonUncheckedOutlined = require("./RadioButtonUncheckedOutlined");
var _radioButtonUncheckedOutlinedDefault = parcelHelpers.interopDefault(_radioButtonUncheckedOutlined);
var _radioButtonUncheckedRounded = require("./RadioButtonUncheckedRounded");
var _radioButtonUncheckedRoundedDefault = parcelHelpers.interopDefault(_radioButtonUncheckedRounded);
var _radioButtonUncheckedSharp = require("./RadioButtonUncheckedSharp");
var _radioButtonUncheckedSharpDefault = parcelHelpers.interopDefault(_radioButtonUncheckedSharp);
var _radioButtonUncheckedTwoTone = require("./RadioButtonUncheckedTwoTone");
var _radioButtonUncheckedTwoToneDefault = parcelHelpers.interopDefault(_radioButtonUncheckedTwoTone);
var _radioOutlined = require("./RadioOutlined");
var _radioOutlinedDefault = parcelHelpers.interopDefault(_radioOutlined);
var _radioRounded = require("./RadioRounded");
var _radioRoundedDefault = parcelHelpers.interopDefault(_radioRounded);
var _radioSharp = require("./RadioSharp");
var _radioSharpDefault = parcelHelpers.interopDefault(_radioSharp);
var _radioTwoTone = require("./RadioTwoTone");
var _radioTwoToneDefault = parcelHelpers.interopDefault(_radioTwoTone);
var _railwayAlert = require("./RailwayAlert");
var _railwayAlertDefault = parcelHelpers.interopDefault(_railwayAlert);
var _railwayAlertOutlined = require("./RailwayAlertOutlined");
var _railwayAlertOutlinedDefault = parcelHelpers.interopDefault(_railwayAlertOutlined);
var _railwayAlertRounded = require("./RailwayAlertRounded");
var _railwayAlertRoundedDefault = parcelHelpers.interopDefault(_railwayAlertRounded);
var _railwayAlertSharp = require("./RailwayAlertSharp");
var _railwayAlertSharpDefault = parcelHelpers.interopDefault(_railwayAlertSharp);
var _railwayAlertTwoTone = require("./RailwayAlertTwoTone");
var _railwayAlertTwoToneDefault = parcelHelpers.interopDefault(_railwayAlertTwoTone);
var _ramenDining = require("./RamenDining");
var _ramenDiningDefault = parcelHelpers.interopDefault(_ramenDining);
var _ramenDiningOutlined = require("./RamenDiningOutlined");
var _ramenDiningOutlinedDefault = parcelHelpers.interopDefault(_ramenDiningOutlined);
var _ramenDiningRounded = require("./RamenDiningRounded");
var _ramenDiningRoundedDefault = parcelHelpers.interopDefault(_ramenDiningRounded);
var _ramenDiningSharp = require("./RamenDiningSharp");
var _ramenDiningSharpDefault = parcelHelpers.interopDefault(_ramenDiningSharp);
var _ramenDiningTwoTone = require("./RamenDiningTwoTone");
var _ramenDiningTwoToneDefault = parcelHelpers.interopDefault(_ramenDiningTwoTone);
var _rampLeft = require("./RampLeft");
var _rampLeftDefault = parcelHelpers.interopDefault(_rampLeft);
var _rampLeftOutlined = require("./RampLeftOutlined");
var _rampLeftOutlinedDefault = parcelHelpers.interopDefault(_rampLeftOutlined);
var _rampLeftRounded = require("./RampLeftRounded");
var _rampLeftRoundedDefault = parcelHelpers.interopDefault(_rampLeftRounded);
var _rampLeftSharp = require("./RampLeftSharp");
var _rampLeftSharpDefault = parcelHelpers.interopDefault(_rampLeftSharp);
var _rampLeftTwoTone = require("./RampLeftTwoTone");
var _rampLeftTwoToneDefault = parcelHelpers.interopDefault(_rampLeftTwoTone);
var _rampRight = require("./RampRight");
var _rampRightDefault = parcelHelpers.interopDefault(_rampRight);
var _rampRightOutlined = require("./RampRightOutlined");
var _rampRightOutlinedDefault = parcelHelpers.interopDefault(_rampRightOutlined);
var _rampRightRounded = require("./RampRightRounded");
var _rampRightRoundedDefault = parcelHelpers.interopDefault(_rampRightRounded);
var _rampRightSharp = require("./RampRightSharp");
var _rampRightSharpDefault = parcelHelpers.interopDefault(_rampRightSharp);
var _rampRightTwoTone = require("./RampRightTwoTone");
var _rampRightTwoToneDefault = parcelHelpers.interopDefault(_rampRightTwoTone);
var _rateReview = require("./RateReview");
var _rateReviewDefault = parcelHelpers.interopDefault(_rateReview);
var _rateReviewOutlined = require("./RateReviewOutlined");
var _rateReviewOutlinedDefault = parcelHelpers.interopDefault(_rateReviewOutlined);
var _rateReviewRounded = require("./RateReviewRounded");
var _rateReviewRoundedDefault = parcelHelpers.interopDefault(_rateReviewRounded);
var _rateReviewSharp = require("./RateReviewSharp");
var _rateReviewSharpDefault = parcelHelpers.interopDefault(_rateReviewSharp);
var _rateReviewTwoTone = require("./RateReviewTwoTone");
var _rateReviewTwoToneDefault = parcelHelpers.interopDefault(_rateReviewTwoTone);
var _rawOff = require("./RawOff");
var _rawOffDefault = parcelHelpers.interopDefault(_rawOff);
var _rawOffOutlined = require("./RawOffOutlined");
var _rawOffOutlinedDefault = parcelHelpers.interopDefault(_rawOffOutlined);
var _rawOffRounded = require("./RawOffRounded");
var _rawOffRoundedDefault = parcelHelpers.interopDefault(_rawOffRounded);
var _rawOffSharp = require("./RawOffSharp");
var _rawOffSharpDefault = parcelHelpers.interopDefault(_rawOffSharp);
var _rawOffTwoTone = require("./RawOffTwoTone");
var _rawOffTwoToneDefault = parcelHelpers.interopDefault(_rawOffTwoTone);
var _rawOn = require("./RawOn");
var _rawOnDefault = parcelHelpers.interopDefault(_rawOn);
var _rawOnOutlined = require("./RawOnOutlined");
var _rawOnOutlinedDefault = parcelHelpers.interopDefault(_rawOnOutlined);
var _rawOnRounded = require("./RawOnRounded");
var _rawOnRoundedDefault = parcelHelpers.interopDefault(_rawOnRounded);
var _rawOnSharp = require("./RawOnSharp");
var _rawOnSharpDefault = parcelHelpers.interopDefault(_rawOnSharp);
var _rawOnTwoTone = require("./RawOnTwoTone");
var _rawOnTwoToneDefault = parcelHelpers.interopDefault(_rawOnTwoTone);
var _readMore = require("./ReadMore");
var _readMoreDefault = parcelHelpers.interopDefault(_readMore);
var _readMoreOutlined = require("./ReadMoreOutlined");
var _readMoreOutlinedDefault = parcelHelpers.interopDefault(_readMoreOutlined);
var _readMoreRounded = require("./ReadMoreRounded");
var _readMoreRoundedDefault = parcelHelpers.interopDefault(_readMoreRounded);
var _readMoreSharp = require("./ReadMoreSharp");
var _readMoreSharpDefault = parcelHelpers.interopDefault(_readMoreSharp);
var _readMoreTwoTone = require("./ReadMoreTwoTone");
var _readMoreTwoToneDefault = parcelHelpers.interopDefault(_readMoreTwoTone);
var _receipt = require("./Receipt");
var _receiptDefault = parcelHelpers.interopDefault(_receipt);
var _receiptLong = require("./ReceiptLong");
var _receiptLongDefault = parcelHelpers.interopDefault(_receiptLong);
var _receiptLongOutlined = require("./ReceiptLongOutlined");
var _receiptLongOutlinedDefault = parcelHelpers.interopDefault(_receiptLongOutlined);
var _receiptLongRounded = require("./ReceiptLongRounded");
var _receiptLongRoundedDefault = parcelHelpers.interopDefault(_receiptLongRounded);
var _receiptLongSharp = require("./ReceiptLongSharp");
var _receiptLongSharpDefault = parcelHelpers.interopDefault(_receiptLongSharp);
var _receiptLongTwoTone = require("./ReceiptLongTwoTone");
var _receiptLongTwoToneDefault = parcelHelpers.interopDefault(_receiptLongTwoTone);
var _receiptOutlined = require("./ReceiptOutlined");
var _receiptOutlinedDefault = parcelHelpers.interopDefault(_receiptOutlined);
var _receiptRounded = require("./ReceiptRounded");
var _receiptRoundedDefault = parcelHelpers.interopDefault(_receiptRounded);
var _receiptSharp = require("./ReceiptSharp");
var _receiptSharpDefault = parcelHelpers.interopDefault(_receiptSharp);
var _receiptTwoTone = require("./ReceiptTwoTone");
var _receiptTwoToneDefault = parcelHelpers.interopDefault(_receiptTwoTone);
var _recentActors = require("./RecentActors");
var _recentActorsDefault = parcelHelpers.interopDefault(_recentActors);
var _recentActorsOutlined = require("./RecentActorsOutlined");
var _recentActorsOutlinedDefault = parcelHelpers.interopDefault(_recentActorsOutlined);
var _recentActorsRounded = require("./RecentActorsRounded");
var _recentActorsRoundedDefault = parcelHelpers.interopDefault(_recentActorsRounded);
var _recentActorsSharp = require("./RecentActorsSharp");
var _recentActorsSharpDefault = parcelHelpers.interopDefault(_recentActorsSharp);
var _recentActorsTwoTone = require("./RecentActorsTwoTone");
var _recentActorsTwoToneDefault = parcelHelpers.interopDefault(_recentActorsTwoTone);
var _recommend = require("./Recommend");
var _recommendDefault = parcelHelpers.interopDefault(_recommend);
var _recommendOutlined = require("./RecommendOutlined");
var _recommendOutlinedDefault = parcelHelpers.interopDefault(_recommendOutlined);
var _recommendRounded = require("./RecommendRounded");
var _recommendRoundedDefault = parcelHelpers.interopDefault(_recommendRounded);
var _recommendSharp = require("./RecommendSharp");
var _recommendSharpDefault = parcelHelpers.interopDefault(_recommendSharp);
var _recommendTwoTone = require("./RecommendTwoTone");
var _recommendTwoToneDefault = parcelHelpers.interopDefault(_recommendTwoTone);
var _recordVoiceOver = require("./RecordVoiceOver");
var _recordVoiceOverDefault = parcelHelpers.interopDefault(_recordVoiceOver);
var _recordVoiceOverOutlined = require("./RecordVoiceOverOutlined");
var _recordVoiceOverOutlinedDefault = parcelHelpers.interopDefault(_recordVoiceOverOutlined);
var _recordVoiceOverRounded = require("./RecordVoiceOverRounded");
var _recordVoiceOverRoundedDefault = parcelHelpers.interopDefault(_recordVoiceOverRounded);
var _recordVoiceOverSharp = require("./RecordVoiceOverSharp");
var _recordVoiceOverSharpDefault = parcelHelpers.interopDefault(_recordVoiceOverSharp);
var _recordVoiceOverTwoTone = require("./RecordVoiceOverTwoTone");
var _recordVoiceOverTwoToneDefault = parcelHelpers.interopDefault(_recordVoiceOverTwoTone);
var _rectangle = require("./Rectangle");
var _rectangleDefault = parcelHelpers.interopDefault(_rectangle);
var _rectangleOutlined = require("./RectangleOutlined");
var _rectangleOutlinedDefault = parcelHelpers.interopDefault(_rectangleOutlined);
var _rectangleRounded = require("./RectangleRounded");
var _rectangleRoundedDefault = parcelHelpers.interopDefault(_rectangleRounded);
var _rectangleSharp = require("./RectangleSharp");
var _rectangleSharpDefault = parcelHelpers.interopDefault(_rectangleSharp);
var _rectangleTwoTone = require("./RectangleTwoTone");
var _rectangleTwoToneDefault = parcelHelpers.interopDefault(_rectangleTwoTone);
var _recycling = require("./Recycling");
var _recyclingDefault = parcelHelpers.interopDefault(_recycling);
var _recyclingOutlined = require("./RecyclingOutlined");
var _recyclingOutlinedDefault = parcelHelpers.interopDefault(_recyclingOutlined);
var _recyclingRounded = require("./RecyclingRounded");
var _recyclingRoundedDefault = parcelHelpers.interopDefault(_recyclingRounded);
var _recyclingSharp = require("./RecyclingSharp");
var _recyclingSharpDefault = parcelHelpers.interopDefault(_recyclingSharp);
var _recyclingTwoTone = require("./RecyclingTwoTone");
var _recyclingTwoToneDefault = parcelHelpers.interopDefault(_recyclingTwoTone);
var _reddit = require("./Reddit");
var _redditDefault = parcelHelpers.interopDefault(_reddit);
var _redeem = require("./Redeem");
var _redeemDefault = parcelHelpers.interopDefault(_redeem);
var _redeemOutlined = require("./RedeemOutlined");
var _redeemOutlinedDefault = parcelHelpers.interopDefault(_redeemOutlined);
var _redeemRounded = require("./RedeemRounded");
var _redeemRoundedDefault = parcelHelpers.interopDefault(_redeemRounded);
var _redeemSharp = require("./RedeemSharp");
var _redeemSharpDefault = parcelHelpers.interopDefault(_redeemSharp);
var _redeemTwoTone = require("./RedeemTwoTone");
var _redeemTwoToneDefault = parcelHelpers.interopDefault(_redeemTwoTone);
var _redo = require("./Redo");
var _redoDefault = parcelHelpers.interopDefault(_redo);
var _redoOutlined = require("./RedoOutlined");
var _redoOutlinedDefault = parcelHelpers.interopDefault(_redoOutlined);
var _redoRounded = require("./RedoRounded");
var _redoRoundedDefault = parcelHelpers.interopDefault(_redoRounded);
var _redoSharp = require("./RedoSharp");
var _redoSharpDefault = parcelHelpers.interopDefault(_redoSharp);
var _redoTwoTone = require("./RedoTwoTone");
var _redoTwoToneDefault = parcelHelpers.interopDefault(_redoTwoTone);
var _reduceCapacity = require("./ReduceCapacity");
var _reduceCapacityDefault = parcelHelpers.interopDefault(_reduceCapacity);
var _reduceCapacityOutlined = require("./ReduceCapacityOutlined");
var _reduceCapacityOutlinedDefault = parcelHelpers.interopDefault(_reduceCapacityOutlined);
var _reduceCapacityRounded = require("./ReduceCapacityRounded");
var _reduceCapacityRoundedDefault = parcelHelpers.interopDefault(_reduceCapacityRounded);
var _reduceCapacitySharp = require("./ReduceCapacitySharp");
var _reduceCapacitySharpDefault = parcelHelpers.interopDefault(_reduceCapacitySharp);
var _reduceCapacityTwoTone = require("./ReduceCapacityTwoTone");
var _reduceCapacityTwoToneDefault = parcelHelpers.interopDefault(_reduceCapacityTwoTone);
var _refresh = require("./Refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
var _refreshOutlined = require("./RefreshOutlined");
var _refreshOutlinedDefault = parcelHelpers.interopDefault(_refreshOutlined);
var _refreshRounded = require("./RefreshRounded");
var _refreshRoundedDefault = parcelHelpers.interopDefault(_refreshRounded);
var _refreshSharp = require("./RefreshSharp");
var _refreshSharpDefault = parcelHelpers.interopDefault(_refreshSharp);
var _refreshTwoTone = require("./RefreshTwoTone");
var _refreshTwoToneDefault = parcelHelpers.interopDefault(_refreshTwoTone);
var _rememberMe = require("./RememberMe");
var _rememberMeDefault = parcelHelpers.interopDefault(_rememberMe);
var _rememberMeOutlined = require("./RememberMeOutlined");
var _rememberMeOutlinedDefault = parcelHelpers.interopDefault(_rememberMeOutlined);
var _rememberMeRounded = require("./RememberMeRounded");
var _rememberMeRoundedDefault = parcelHelpers.interopDefault(_rememberMeRounded);
var _rememberMeSharp = require("./RememberMeSharp");
var _rememberMeSharpDefault = parcelHelpers.interopDefault(_rememberMeSharp);
var _rememberMeTwoTone = require("./RememberMeTwoTone");
var _rememberMeTwoToneDefault = parcelHelpers.interopDefault(_rememberMeTwoTone);
var _remove = require("./Remove");
var _removeDefault = parcelHelpers.interopDefault(_remove);
var _removeCircle = require("./RemoveCircle");
var _removeCircleDefault = parcelHelpers.interopDefault(_removeCircle);
var _removeCircleOutline = require("./RemoveCircleOutline");
var _removeCircleOutlineDefault = parcelHelpers.interopDefault(_removeCircleOutline);
var _removeCircleOutlineOutlined = require("./RemoveCircleOutlineOutlined");
var _removeCircleOutlineOutlinedDefault = parcelHelpers.interopDefault(_removeCircleOutlineOutlined);
var _removeCircleOutlineRounded = require("./RemoveCircleOutlineRounded");
var _removeCircleOutlineRoundedDefault = parcelHelpers.interopDefault(_removeCircleOutlineRounded);
var _removeCircleOutlineSharp = require("./RemoveCircleOutlineSharp");
var _removeCircleOutlineSharpDefault = parcelHelpers.interopDefault(_removeCircleOutlineSharp);
var _removeCircleOutlineTwoTone = require("./RemoveCircleOutlineTwoTone");
var _removeCircleOutlineTwoToneDefault = parcelHelpers.interopDefault(_removeCircleOutlineTwoTone);
var _removeCircleOutlined = require("./RemoveCircleOutlined");
var _removeCircleOutlinedDefault = parcelHelpers.interopDefault(_removeCircleOutlined);
var _removeCircleRounded = require("./RemoveCircleRounded");
var _removeCircleRoundedDefault = parcelHelpers.interopDefault(_removeCircleRounded);
var _removeCircleSharp = require("./RemoveCircleSharp");
var _removeCircleSharpDefault = parcelHelpers.interopDefault(_removeCircleSharp);
var _removeCircleTwoTone = require("./RemoveCircleTwoTone");
var _removeCircleTwoToneDefault = parcelHelpers.interopDefault(_removeCircleTwoTone);
var _removeDone = require("./RemoveDone");
var _removeDoneDefault = parcelHelpers.interopDefault(_removeDone);
var _removeDoneOutlined = require("./RemoveDoneOutlined");
var _removeDoneOutlinedDefault = parcelHelpers.interopDefault(_removeDoneOutlined);
var _removeDoneRounded = require("./RemoveDoneRounded");
var _removeDoneRoundedDefault = parcelHelpers.interopDefault(_removeDoneRounded);
var _removeDoneSharp = require("./RemoveDoneSharp");
var _removeDoneSharpDefault = parcelHelpers.interopDefault(_removeDoneSharp);
var _removeDoneTwoTone = require("./RemoveDoneTwoTone");
var _removeDoneTwoToneDefault = parcelHelpers.interopDefault(_removeDoneTwoTone);
var _removeFromQueue = require("./RemoveFromQueue");
var _removeFromQueueDefault = parcelHelpers.interopDefault(_removeFromQueue);
var _removeFromQueueOutlined = require("./RemoveFromQueueOutlined");
var _removeFromQueueOutlinedDefault = parcelHelpers.interopDefault(_removeFromQueueOutlined);
var _removeFromQueueRounded = require("./RemoveFromQueueRounded");
var _removeFromQueueRoundedDefault = parcelHelpers.interopDefault(_removeFromQueueRounded);
var _removeFromQueueSharp = require("./RemoveFromQueueSharp");
var _removeFromQueueSharpDefault = parcelHelpers.interopDefault(_removeFromQueueSharp);
var _removeFromQueueTwoTone = require("./RemoveFromQueueTwoTone");
var _removeFromQueueTwoToneDefault = parcelHelpers.interopDefault(_removeFromQueueTwoTone);
var _removeModerator = require("./RemoveModerator");
var _removeModeratorDefault = parcelHelpers.interopDefault(_removeModerator);
var _removeModeratorOutlined = require("./RemoveModeratorOutlined");
var _removeModeratorOutlinedDefault = parcelHelpers.interopDefault(_removeModeratorOutlined);
var _removeModeratorRounded = require("./RemoveModeratorRounded");
var _removeModeratorRoundedDefault = parcelHelpers.interopDefault(_removeModeratorRounded);
var _removeModeratorSharp = require("./RemoveModeratorSharp");
var _removeModeratorSharpDefault = parcelHelpers.interopDefault(_removeModeratorSharp);
var _removeModeratorTwoTone = require("./RemoveModeratorTwoTone");
var _removeModeratorTwoToneDefault = parcelHelpers.interopDefault(_removeModeratorTwoTone);
var _removeOutlined = require("./RemoveOutlined");
var _removeOutlinedDefault = parcelHelpers.interopDefault(_removeOutlined);
var _removeRedEye = require("./RemoveRedEye");
var _removeRedEyeDefault = parcelHelpers.interopDefault(_removeRedEye);
var _removeRedEyeOutlined = require("./RemoveRedEyeOutlined");
var _removeRedEyeOutlinedDefault = parcelHelpers.interopDefault(_removeRedEyeOutlined);
var _removeRedEyeRounded = require("./RemoveRedEyeRounded");
var _removeRedEyeRoundedDefault = parcelHelpers.interopDefault(_removeRedEyeRounded);
var _removeRedEyeSharp = require("./RemoveRedEyeSharp");
var _removeRedEyeSharpDefault = parcelHelpers.interopDefault(_removeRedEyeSharp);
var _removeRedEyeTwoTone = require("./RemoveRedEyeTwoTone");
var _removeRedEyeTwoToneDefault = parcelHelpers.interopDefault(_removeRedEyeTwoTone);
var _removeRoad = require("./RemoveRoad");
var _removeRoadDefault = parcelHelpers.interopDefault(_removeRoad);
var _removeRoadOutlined = require("./RemoveRoadOutlined");
var _removeRoadOutlinedDefault = parcelHelpers.interopDefault(_removeRoadOutlined);
var _removeRoadRounded = require("./RemoveRoadRounded");
var _removeRoadRoundedDefault = parcelHelpers.interopDefault(_removeRoadRounded);
var _removeRoadSharp = require("./RemoveRoadSharp");
var _removeRoadSharpDefault = parcelHelpers.interopDefault(_removeRoadSharp);
var _removeRoadTwoTone = require("./RemoveRoadTwoTone");
var _removeRoadTwoToneDefault = parcelHelpers.interopDefault(_removeRoadTwoTone);
var _removeRounded = require("./RemoveRounded");
var _removeRoundedDefault = parcelHelpers.interopDefault(_removeRounded);
var _removeSharp = require("./RemoveSharp");
var _removeSharpDefault = parcelHelpers.interopDefault(_removeSharp);
var _removeShoppingCart = require("./RemoveShoppingCart");
var _removeShoppingCartDefault = parcelHelpers.interopDefault(_removeShoppingCart);
var _removeShoppingCartOutlined = require("./RemoveShoppingCartOutlined");
var _removeShoppingCartOutlinedDefault = parcelHelpers.interopDefault(_removeShoppingCartOutlined);
var _removeShoppingCartRounded = require("./RemoveShoppingCartRounded");
var _removeShoppingCartRoundedDefault = parcelHelpers.interopDefault(_removeShoppingCartRounded);
var _removeShoppingCartSharp = require("./RemoveShoppingCartSharp");
var _removeShoppingCartSharpDefault = parcelHelpers.interopDefault(_removeShoppingCartSharp);
var _removeShoppingCartTwoTone = require("./RemoveShoppingCartTwoTone");
var _removeShoppingCartTwoToneDefault = parcelHelpers.interopDefault(_removeShoppingCartTwoTone);
var _removeTwoTone = require("./RemoveTwoTone");
var _removeTwoToneDefault = parcelHelpers.interopDefault(_removeTwoTone);
var _reorder = require("./Reorder");
var _reorderDefault = parcelHelpers.interopDefault(_reorder);
var _reorderOutlined = require("./ReorderOutlined");
var _reorderOutlinedDefault = parcelHelpers.interopDefault(_reorderOutlined);
var _reorderRounded = require("./ReorderRounded");
var _reorderRoundedDefault = parcelHelpers.interopDefault(_reorderRounded);
var _reorderSharp = require("./ReorderSharp");
var _reorderSharpDefault = parcelHelpers.interopDefault(_reorderSharp);
var _reorderTwoTone = require("./ReorderTwoTone");
var _reorderTwoToneDefault = parcelHelpers.interopDefault(_reorderTwoTone);
var _repartition = require("./Repartition");
var _repartitionDefault = parcelHelpers.interopDefault(_repartition);
var _repartitionOutlined = require("./RepartitionOutlined");
var _repartitionOutlinedDefault = parcelHelpers.interopDefault(_repartitionOutlined);
var _repartitionRounded = require("./RepartitionRounded");
var _repartitionRoundedDefault = parcelHelpers.interopDefault(_repartitionRounded);
var _repartitionSharp = require("./RepartitionSharp");
var _repartitionSharpDefault = parcelHelpers.interopDefault(_repartitionSharp);
var _repartitionTwoTone = require("./RepartitionTwoTone");
var _repartitionTwoToneDefault = parcelHelpers.interopDefault(_repartitionTwoTone);
var _repeat = require("./Repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _repeatOn = require("./RepeatOn");
var _repeatOnDefault = parcelHelpers.interopDefault(_repeatOn);
var _repeatOnOutlined = require("./RepeatOnOutlined");
var _repeatOnOutlinedDefault = parcelHelpers.interopDefault(_repeatOnOutlined);
var _repeatOnRounded = require("./RepeatOnRounded");
var _repeatOnRoundedDefault = parcelHelpers.interopDefault(_repeatOnRounded);
var _repeatOnSharp = require("./RepeatOnSharp");
var _repeatOnSharpDefault = parcelHelpers.interopDefault(_repeatOnSharp);
var _repeatOnTwoTone = require("./RepeatOnTwoTone");
var _repeatOnTwoToneDefault = parcelHelpers.interopDefault(_repeatOnTwoTone);
var _repeatOne = require("./RepeatOne");
var _repeatOneDefault = parcelHelpers.interopDefault(_repeatOne);
var _repeatOneOn = require("./RepeatOneOn");
var _repeatOneOnDefault = parcelHelpers.interopDefault(_repeatOneOn);
var _repeatOneOnOutlined = require("./RepeatOneOnOutlined");
var _repeatOneOnOutlinedDefault = parcelHelpers.interopDefault(_repeatOneOnOutlined);
var _repeatOneOnRounded = require("./RepeatOneOnRounded");
var _repeatOneOnRoundedDefault = parcelHelpers.interopDefault(_repeatOneOnRounded);
var _repeatOneOnSharp = require("./RepeatOneOnSharp");
var _repeatOneOnSharpDefault = parcelHelpers.interopDefault(_repeatOneOnSharp);
var _repeatOneOnTwoTone = require("./RepeatOneOnTwoTone");
var _repeatOneOnTwoToneDefault = parcelHelpers.interopDefault(_repeatOneOnTwoTone);
var _repeatOneOutlined = require("./RepeatOneOutlined");
var _repeatOneOutlinedDefault = parcelHelpers.interopDefault(_repeatOneOutlined);
var _repeatOneRounded = require("./RepeatOneRounded");
var _repeatOneRoundedDefault = parcelHelpers.interopDefault(_repeatOneRounded);
var _repeatOneSharp = require("./RepeatOneSharp");
var _repeatOneSharpDefault = parcelHelpers.interopDefault(_repeatOneSharp);
var _repeatOneTwoTone = require("./RepeatOneTwoTone");
var _repeatOneTwoToneDefault = parcelHelpers.interopDefault(_repeatOneTwoTone);
var _repeatOutlined = require("./RepeatOutlined");
var _repeatOutlinedDefault = parcelHelpers.interopDefault(_repeatOutlined);
var _repeatRounded = require("./RepeatRounded");
var _repeatRoundedDefault = parcelHelpers.interopDefault(_repeatRounded);
var _repeatSharp = require("./RepeatSharp");
var _repeatSharpDefault = parcelHelpers.interopDefault(_repeatSharp);
var _repeatTwoTone = require("./RepeatTwoTone");
var _repeatTwoToneDefault = parcelHelpers.interopDefault(_repeatTwoTone);
var _replay = require("./Replay");
var _replayDefault = parcelHelpers.interopDefault(_replay);
var _replay10 = require("./Replay10");
var _replay10Default = parcelHelpers.interopDefault(_replay10);
var _replay10Outlined = require("./Replay10Outlined");
var _replay10OutlinedDefault = parcelHelpers.interopDefault(_replay10Outlined);
var _replay10Rounded = require("./Replay10Rounded");
var _replay10RoundedDefault = parcelHelpers.interopDefault(_replay10Rounded);
var _replay10Sharp = require("./Replay10Sharp");
var _replay10SharpDefault = parcelHelpers.interopDefault(_replay10Sharp);
var _replay10TwoTone = require("./Replay10TwoTone");
var _replay10TwoToneDefault = parcelHelpers.interopDefault(_replay10TwoTone);
var _replay30 = require("./Replay30");
var _replay30Default = parcelHelpers.interopDefault(_replay30);
var _replay30Outlined = require("./Replay30Outlined");
var _replay30OutlinedDefault = parcelHelpers.interopDefault(_replay30Outlined);
var _replay30Rounded = require("./Replay30Rounded");
var _replay30RoundedDefault = parcelHelpers.interopDefault(_replay30Rounded);
var _replay30Sharp = require("./Replay30Sharp");
var _replay30SharpDefault = parcelHelpers.interopDefault(_replay30Sharp);
var _replay30TwoTone = require("./Replay30TwoTone");
var _replay30TwoToneDefault = parcelHelpers.interopDefault(_replay30TwoTone);
var _replay5 = require("./Replay5");
var _replay5Default = parcelHelpers.interopDefault(_replay5);
var _replay5Outlined = require("./Replay5Outlined");
var _replay5OutlinedDefault = parcelHelpers.interopDefault(_replay5Outlined);
var _replay5Rounded = require("./Replay5Rounded");
var _replay5RoundedDefault = parcelHelpers.interopDefault(_replay5Rounded);
var _replay5Sharp = require("./Replay5Sharp");
var _replay5SharpDefault = parcelHelpers.interopDefault(_replay5Sharp);
var _replay5TwoTone = require("./Replay5TwoTone");
var _replay5TwoToneDefault = parcelHelpers.interopDefault(_replay5TwoTone);
var _replayCircleFilled = require("./ReplayCircleFilled");
var _replayCircleFilledDefault = parcelHelpers.interopDefault(_replayCircleFilled);
var _replayCircleFilledOutlined = require("./ReplayCircleFilledOutlined");
var _replayCircleFilledOutlinedDefault = parcelHelpers.interopDefault(_replayCircleFilledOutlined);
var _replayCircleFilledRounded = require("./ReplayCircleFilledRounded");
var _replayCircleFilledRoundedDefault = parcelHelpers.interopDefault(_replayCircleFilledRounded);
var _replayCircleFilledSharp = require("./ReplayCircleFilledSharp");
var _replayCircleFilledSharpDefault = parcelHelpers.interopDefault(_replayCircleFilledSharp);
var _replayCircleFilledTwoTone = require("./ReplayCircleFilledTwoTone");
var _replayCircleFilledTwoToneDefault = parcelHelpers.interopDefault(_replayCircleFilledTwoTone);
var _replayOutlined = require("./ReplayOutlined");
var _replayOutlinedDefault = parcelHelpers.interopDefault(_replayOutlined);
var _replayRounded = require("./ReplayRounded");
var _replayRoundedDefault = parcelHelpers.interopDefault(_replayRounded);
var _replaySharp = require("./ReplaySharp");
var _replaySharpDefault = parcelHelpers.interopDefault(_replaySharp);
var _replayTwoTone = require("./ReplayTwoTone");
var _replayTwoToneDefault = parcelHelpers.interopDefault(_replayTwoTone);
var _reply = require("./Reply");
var _replyDefault = parcelHelpers.interopDefault(_reply);
var _replyAll = require("./ReplyAll");
var _replyAllDefault = parcelHelpers.interopDefault(_replyAll);
var _replyAllOutlined = require("./ReplyAllOutlined");
var _replyAllOutlinedDefault = parcelHelpers.interopDefault(_replyAllOutlined);
var _replyAllRounded = require("./ReplyAllRounded");
var _replyAllRoundedDefault = parcelHelpers.interopDefault(_replyAllRounded);
var _replyAllSharp = require("./ReplyAllSharp");
var _replyAllSharpDefault = parcelHelpers.interopDefault(_replyAllSharp);
var _replyAllTwoTone = require("./ReplyAllTwoTone");
var _replyAllTwoToneDefault = parcelHelpers.interopDefault(_replyAllTwoTone);
var _replyOutlined = require("./ReplyOutlined");
var _replyOutlinedDefault = parcelHelpers.interopDefault(_replyOutlined);
var _replyRounded = require("./ReplyRounded");
var _replyRoundedDefault = parcelHelpers.interopDefault(_replyRounded);
var _replySharp = require("./ReplySharp");
var _replySharpDefault = parcelHelpers.interopDefault(_replySharp);
var _replyTwoTone = require("./ReplyTwoTone");
var _replyTwoToneDefault = parcelHelpers.interopDefault(_replyTwoTone);
var _report = require("./Report");
var _reportDefault = parcelHelpers.interopDefault(_report);
var _reportGmailerrorred = require("./ReportGmailerrorred");
var _reportGmailerrorredDefault = parcelHelpers.interopDefault(_reportGmailerrorred);
var _reportGmailerrorredOutlined = require("./ReportGmailerrorredOutlined");
var _reportGmailerrorredOutlinedDefault = parcelHelpers.interopDefault(_reportGmailerrorredOutlined);
var _reportGmailerrorredRounded = require("./ReportGmailerrorredRounded");
var _reportGmailerrorredRoundedDefault = parcelHelpers.interopDefault(_reportGmailerrorredRounded);
var _reportGmailerrorredSharp = require("./ReportGmailerrorredSharp");
var _reportGmailerrorredSharpDefault = parcelHelpers.interopDefault(_reportGmailerrorredSharp);
var _reportGmailerrorredTwoTone = require("./ReportGmailerrorredTwoTone");
var _reportGmailerrorredTwoToneDefault = parcelHelpers.interopDefault(_reportGmailerrorredTwoTone);
var _reportOff = require("./ReportOff");
var _reportOffDefault = parcelHelpers.interopDefault(_reportOff);
var _reportOffOutlined = require("./ReportOffOutlined");
var _reportOffOutlinedDefault = parcelHelpers.interopDefault(_reportOffOutlined);
var _reportOffRounded = require("./ReportOffRounded");
var _reportOffRoundedDefault = parcelHelpers.interopDefault(_reportOffRounded);
var _reportOffSharp = require("./ReportOffSharp");
var _reportOffSharpDefault = parcelHelpers.interopDefault(_reportOffSharp);
var _reportOffTwoTone = require("./ReportOffTwoTone");
var _reportOffTwoToneDefault = parcelHelpers.interopDefault(_reportOffTwoTone);
var _reportOutlined = require("./ReportOutlined");
var _reportOutlinedDefault = parcelHelpers.interopDefault(_reportOutlined);
var _reportProblem = require("./ReportProblem");
var _reportProblemDefault = parcelHelpers.interopDefault(_reportProblem);
var _reportProblemOutlined = require("./ReportProblemOutlined");
var _reportProblemOutlinedDefault = parcelHelpers.interopDefault(_reportProblemOutlined);
var _reportProblemRounded = require("./ReportProblemRounded");
var _reportProblemRoundedDefault = parcelHelpers.interopDefault(_reportProblemRounded);
var _reportProblemSharp = require("./ReportProblemSharp");
var _reportProblemSharpDefault = parcelHelpers.interopDefault(_reportProblemSharp);
var _reportProblemTwoTone = require("./ReportProblemTwoTone");
var _reportProblemTwoToneDefault = parcelHelpers.interopDefault(_reportProblemTwoTone);
var _reportRounded = require("./ReportRounded");
var _reportRoundedDefault = parcelHelpers.interopDefault(_reportRounded);
var _reportSharp = require("./ReportSharp");
var _reportSharpDefault = parcelHelpers.interopDefault(_reportSharp);
var _reportTwoTone = require("./ReportTwoTone");
var _reportTwoToneDefault = parcelHelpers.interopDefault(_reportTwoTone);
var _requestPage = require("./RequestPage");
var _requestPageDefault = parcelHelpers.interopDefault(_requestPage);
var _requestPageOutlined = require("./RequestPageOutlined");
var _requestPageOutlinedDefault = parcelHelpers.interopDefault(_requestPageOutlined);
var _requestPageRounded = require("./RequestPageRounded");
var _requestPageRoundedDefault = parcelHelpers.interopDefault(_requestPageRounded);
var _requestPageSharp = require("./RequestPageSharp");
var _requestPageSharpDefault = parcelHelpers.interopDefault(_requestPageSharp);
var _requestPageTwoTone = require("./RequestPageTwoTone");
var _requestPageTwoToneDefault = parcelHelpers.interopDefault(_requestPageTwoTone);
var _requestQuote = require("./RequestQuote");
var _requestQuoteDefault = parcelHelpers.interopDefault(_requestQuote);
var _requestQuoteOutlined = require("./RequestQuoteOutlined");
var _requestQuoteOutlinedDefault = parcelHelpers.interopDefault(_requestQuoteOutlined);
var _requestQuoteRounded = require("./RequestQuoteRounded");
var _requestQuoteRoundedDefault = parcelHelpers.interopDefault(_requestQuoteRounded);
var _requestQuoteSharp = require("./RequestQuoteSharp");
var _requestQuoteSharpDefault = parcelHelpers.interopDefault(_requestQuoteSharp);
var _requestQuoteTwoTone = require("./RequestQuoteTwoTone");
var _requestQuoteTwoToneDefault = parcelHelpers.interopDefault(_requestQuoteTwoTone);
var _resetTv = require("./ResetTv");
var _resetTvDefault = parcelHelpers.interopDefault(_resetTv);
var _resetTvOutlined = require("./ResetTvOutlined");
var _resetTvOutlinedDefault = parcelHelpers.interopDefault(_resetTvOutlined);
var _resetTvRounded = require("./ResetTvRounded");
var _resetTvRoundedDefault = parcelHelpers.interopDefault(_resetTvRounded);
var _resetTvSharp = require("./ResetTvSharp");
var _resetTvSharpDefault = parcelHelpers.interopDefault(_resetTvSharp);
var _resetTvTwoTone = require("./ResetTvTwoTone");
var _resetTvTwoToneDefault = parcelHelpers.interopDefault(_resetTvTwoTone);
var _restartAlt = require("./RestartAlt");
var _restartAltDefault = parcelHelpers.interopDefault(_restartAlt);
var _restartAltOutlined = require("./RestartAltOutlined");
var _restartAltOutlinedDefault = parcelHelpers.interopDefault(_restartAltOutlined);
var _restartAltRounded = require("./RestartAltRounded");
var _restartAltRoundedDefault = parcelHelpers.interopDefault(_restartAltRounded);
var _restartAltSharp = require("./RestartAltSharp");
var _restartAltSharpDefault = parcelHelpers.interopDefault(_restartAltSharp);
var _restartAltTwoTone = require("./RestartAltTwoTone");
var _restartAltTwoToneDefault = parcelHelpers.interopDefault(_restartAltTwoTone);
var _restaurant = require("./Restaurant");
var _restaurantDefault = parcelHelpers.interopDefault(_restaurant);
var _restaurantMenu = require("./RestaurantMenu");
var _restaurantMenuDefault = parcelHelpers.interopDefault(_restaurantMenu);
var _restaurantMenuOutlined = require("./RestaurantMenuOutlined");
var _restaurantMenuOutlinedDefault = parcelHelpers.interopDefault(_restaurantMenuOutlined);
var _restaurantMenuRounded = require("./RestaurantMenuRounded");
var _restaurantMenuRoundedDefault = parcelHelpers.interopDefault(_restaurantMenuRounded);
var _restaurantMenuSharp = require("./RestaurantMenuSharp");
var _restaurantMenuSharpDefault = parcelHelpers.interopDefault(_restaurantMenuSharp);
var _restaurantMenuTwoTone = require("./RestaurantMenuTwoTone");
var _restaurantMenuTwoToneDefault = parcelHelpers.interopDefault(_restaurantMenuTwoTone);
var _restaurantOutlined = require("./RestaurantOutlined");
var _restaurantOutlinedDefault = parcelHelpers.interopDefault(_restaurantOutlined);
var _restaurantRounded = require("./RestaurantRounded");
var _restaurantRoundedDefault = parcelHelpers.interopDefault(_restaurantRounded);
var _restaurantSharp = require("./RestaurantSharp");
var _restaurantSharpDefault = parcelHelpers.interopDefault(_restaurantSharp);
var _restaurantTwoTone = require("./RestaurantTwoTone");
var _restaurantTwoToneDefault = parcelHelpers.interopDefault(_restaurantTwoTone);
var _restore = require("./Restore");
var _restoreDefault = parcelHelpers.interopDefault(_restore);
var _restoreFromTrash = require("./RestoreFromTrash");
var _restoreFromTrashDefault = parcelHelpers.interopDefault(_restoreFromTrash);
var _restoreFromTrashOutlined = require("./RestoreFromTrashOutlined");
var _restoreFromTrashOutlinedDefault = parcelHelpers.interopDefault(_restoreFromTrashOutlined);
var _restoreFromTrashRounded = require("./RestoreFromTrashRounded");
var _restoreFromTrashRoundedDefault = parcelHelpers.interopDefault(_restoreFromTrashRounded);
var _restoreFromTrashSharp = require("./RestoreFromTrashSharp");
var _restoreFromTrashSharpDefault = parcelHelpers.interopDefault(_restoreFromTrashSharp);
var _restoreFromTrashTwoTone = require("./RestoreFromTrashTwoTone");
var _restoreFromTrashTwoToneDefault = parcelHelpers.interopDefault(_restoreFromTrashTwoTone);
var _restoreOutlined = require("./RestoreOutlined");
var _restoreOutlinedDefault = parcelHelpers.interopDefault(_restoreOutlined);
var _restorePage = require("./RestorePage");
var _restorePageDefault = parcelHelpers.interopDefault(_restorePage);
var _restorePageOutlined = require("./RestorePageOutlined");
var _restorePageOutlinedDefault = parcelHelpers.interopDefault(_restorePageOutlined);
var _restorePageRounded = require("./RestorePageRounded");
var _restorePageRoundedDefault = parcelHelpers.interopDefault(_restorePageRounded);
var _restorePageSharp = require("./RestorePageSharp");
var _restorePageSharpDefault = parcelHelpers.interopDefault(_restorePageSharp);
var _restorePageTwoTone = require("./RestorePageTwoTone");
var _restorePageTwoToneDefault = parcelHelpers.interopDefault(_restorePageTwoTone);
var _restoreRounded = require("./RestoreRounded");
var _restoreRoundedDefault = parcelHelpers.interopDefault(_restoreRounded);
var _restoreSharp = require("./RestoreSharp");
var _restoreSharpDefault = parcelHelpers.interopDefault(_restoreSharp);
var _restoreTwoTone = require("./RestoreTwoTone");
var _restoreTwoToneDefault = parcelHelpers.interopDefault(_restoreTwoTone);
var _reviews = require("./Reviews");
var _reviewsDefault = parcelHelpers.interopDefault(_reviews);
var _reviewsOutlined = require("./ReviewsOutlined");
var _reviewsOutlinedDefault = parcelHelpers.interopDefault(_reviewsOutlined);
var _reviewsRounded = require("./ReviewsRounded");
var _reviewsRoundedDefault = parcelHelpers.interopDefault(_reviewsRounded);
var _reviewsSharp = require("./ReviewsSharp");
var _reviewsSharpDefault = parcelHelpers.interopDefault(_reviewsSharp);
var _reviewsTwoTone = require("./ReviewsTwoTone");
var _reviewsTwoToneDefault = parcelHelpers.interopDefault(_reviewsTwoTone);
var _riceBowl = require("./RiceBowl");
var _riceBowlDefault = parcelHelpers.interopDefault(_riceBowl);
var _riceBowlOutlined = require("./RiceBowlOutlined");
var _riceBowlOutlinedDefault = parcelHelpers.interopDefault(_riceBowlOutlined);
var _riceBowlRounded = require("./RiceBowlRounded");
var _riceBowlRoundedDefault = parcelHelpers.interopDefault(_riceBowlRounded);
var _riceBowlSharp = require("./RiceBowlSharp");
var _riceBowlSharpDefault = parcelHelpers.interopDefault(_riceBowlSharp);
var _riceBowlTwoTone = require("./RiceBowlTwoTone");
var _riceBowlTwoToneDefault = parcelHelpers.interopDefault(_riceBowlTwoTone);
var _ringVolume = require("./RingVolume");
var _ringVolumeDefault = parcelHelpers.interopDefault(_ringVolume);
var _ringVolumeOutlined = require("./RingVolumeOutlined");
var _ringVolumeOutlinedDefault = parcelHelpers.interopDefault(_ringVolumeOutlined);
var _ringVolumeRounded = require("./RingVolumeRounded");
var _ringVolumeRoundedDefault = parcelHelpers.interopDefault(_ringVolumeRounded);
var _ringVolumeSharp = require("./RingVolumeSharp");
var _ringVolumeSharpDefault = parcelHelpers.interopDefault(_ringVolumeSharp);
var _ringVolumeTwoTone = require("./RingVolumeTwoTone");
var _ringVolumeTwoToneDefault = parcelHelpers.interopDefault(_ringVolumeTwoTone);
var _rocket = require("./Rocket");
var _rocketDefault = parcelHelpers.interopDefault(_rocket);
var _rocketLaunch = require("./RocketLaunch");
var _rocketLaunchDefault = parcelHelpers.interopDefault(_rocketLaunch);
var _rocketLaunchOutlined = require("./RocketLaunchOutlined");
var _rocketLaunchOutlinedDefault = parcelHelpers.interopDefault(_rocketLaunchOutlined);
var _rocketLaunchRounded = require("./RocketLaunchRounded");
var _rocketLaunchRoundedDefault = parcelHelpers.interopDefault(_rocketLaunchRounded);
var _rocketLaunchSharp = require("./RocketLaunchSharp");
var _rocketLaunchSharpDefault = parcelHelpers.interopDefault(_rocketLaunchSharp);
var _rocketLaunchTwoTone = require("./RocketLaunchTwoTone");
var _rocketLaunchTwoToneDefault = parcelHelpers.interopDefault(_rocketLaunchTwoTone);
var _rocketOutlined = require("./RocketOutlined");
var _rocketOutlinedDefault = parcelHelpers.interopDefault(_rocketOutlined);
var _rocketRounded = require("./RocketRounded");
var _rocketRoundedDefault = parcelHelpers.interopDefault(_rocketRounded);
var _rocketSharp = require("./RocketSharp");
var _rocketSharpDefault = parcelHelpers.interopDefault(_rocketSharp);
var _rocketTwoTone = require("./RocketTwoTone");
var _rocketTwoToneDefault = parcelHelpers.interopDefault(_rocketTwoTone);
var _rollerShades = require("./RollerShades");
var _rollerShadesDefault = parcelHelpers.interopDefault(_rollerShades);
var _rollerShadesClosed = require("./RollerShadesClosed");
var _rollerShadesClosedDefault = parcelHelpers.interopDefault(_rollerShadesClosed);
var _rollerShadesClosedOutlined = require("./RollerShadesClosedOutlined");
var _rollerShadesClosedOutlinedDefault = parcelHelpers.interopDefault(_rollerShadesClosedOutlined);
var _rollerShadesClosedRounded = require("./RollerShadesClosedRounded");
var _rollerShadesClosedRoundedDefault = parcelHelpers.interopDefault(_rollerShadesClosedRounded);
var _rollerShadesClosedSharp = require("./RollerShadesClosedSharp");
var _rollerShadesClosedSharpDefault = parcelHelpers.interopDefault(_rollerShadesClosedSharp);
var _rollerShadesClosedTwoTone = require("./RollerShadesClosedTwoTone");
var _rollerShadesClosedTwoToneDefault = parcelHelpers.interopDefault(_rollerShadesClosedTwoTone);
var _rollerShadesOutlined = require("./RollerShadesOutlined");
var _rollerShadesOutlinedDefault = parcelHelpers.interopDefault(_rollerShadesOutlined);
var _rollerShadesRounded = require("./RollerShadesRounded");
var _rollerShadesRoundedDefault = parcelHelpers.interopDefault(_rollerShadesRounded);
var _rollerShadesSharp = require("./RollerShadesSharp");
var _rollerShadesSharpDefault = parcelHelpers.interopDefault(_rollerShadesSharp);
var _rollerShadesTwoTone = require("./RollerShadesTwoTone");
var _rollerShadesTwoToneDefault = parcelHelpers.interopDefault(_rollerShadesTwoTone);
var _rollerSkating = require("./RollerSkating");
var _rollerSkatingDefault = parcelHelpers.interopDefault(_rollerSkating);
var _rollerSkatingOutlined = require("./RollerSkatingOutlined");
var _rollerSkatingOutlinedDefault = parcelHelpers.interopDefault(_rollerSkatingOutlined);
var _rollerSkatingRounded = require("./RollerSkatingRounded");
var _rollerSkatingRoundedDefault = parcelHelpers.interopDefault(_rollerSkatingRounded);
var _rollerSkatingSharp = require("./RollerSkatingSharp");
var _rollerSkatingSharpDefault = parcelHelpers.interopDefault(_rollerSkatingSharp);
var _rollerSkatingTwoTone = require("./RollerSkatingTwoTone");
var _rollerSkatingTwoToneDefault = parcelHelpers.interopDefault(_rollerSkatingTwoTone);
var _roofing = require("./Roofing");
var _roofingDefault = parcelHelpers.interopDefault(_roofing);
var _roofingOutlined = require("./RoofingOutlined");
var _roofingOutlinedDefault = parcelHelpers.interopDefault(_roofingOutlined);
var _roofingRounded = require("./RoofingRounded");
var _roofingRoundedDefault = parcelHelpers.interopDefault(_roofingRounded);
var _roofingSharp = require("./RoofingSharp");
var _roofingSharpDefault = parcelHelpers.interopDefault(_roofingSharp);
var _roofingTwoTone = require("./RoofingTwoTone");
var _roofingTwoToneDefault = parcelHelpers.interopDefault(_roofingTwoTone);
var _room = require("./Room");
var _roomDefault = parcelHelpers.interopDefault(_room);
var _roomOutlined = require("./RoomOutlined");
var _roomOutlinedDefault = parcelHelpers.interopDefault(_roomOutlined);
var _roomPreferences = require("./RoomPreferences");
var _roomPreferencesDefault = parcelHelpers.interopDefault(_roomPreferences);
var _roomPreferencesOutlined = require("./RoomPreferencesOutlined");
var _roomPreferencesOutlinedDefault = parcelHelpers.interopDefault(_roomPreferencesOutlined);
var _roomPreferencesRounded = require("./RoomPreferencesRounded");
var _roomPreferencesRoundedDefault = parcelHelpers.interopDefault(_roomPreferencesRounded);
var _roomPreferencesSharp = require("./RoomPreferencesSharp");
var _roomPreferencesSharpDefault = parcelHelpers.interopDefault(_roomPreferencesSharp);
var _roomPreferencesTwoTone = require("./RoomPreferencesTwoTone");
var _roomPreferencesTwoToneDefault = parcelHelpers.interopDefault(_roomPreferencesTwoTone);
var _roomRounded = require("./RoomRounded");
var _roomRoundedDefault = parcelHelpers.interopDefault(_roomRounded);
var _roomService = require("./RoomService");
var _roomServiceDefault = parcelHelpers.interopDefault(_roomService);
var _roomServiceOutlined = require("./RoomServiceOutlined");
var _roomServiceOutlinedDefault = parcelHelpers.interopDefault(_roomServiceOutlined);
var _roomServiceRounded = require("./RoomServiceRounded");
var _roomServiceRoundedDefault = parcelHelpers.interopDefault(_roomServiceRounded);
var _roomServiceSharp = require("./RoomServiceSharp");
var _roomServiceSharpDefault = parcelHelpers.interopDefault(_roomServiceSharp);
var _roomServiceTwoTone = require("./RoomServiceTwoTone");
var _roomServiceTwoToneDefault = parcelHelpers.interopDefault(_roomServiceTwoTone);
var _roomSharp = require("./RoomSharp");
var _roomSharpDefault = parcelHelpers.interopDefault(_roomSharp);
var _roomTwoTone = require("./RoomTwoTone");
var _roomTwoToneDefault = parcelHelpers.interopDefault(_roomTwoTone);
var _rotate90DegreesCcw = require("./Rotate90DegreesCcw");
var _rotate90DegreesCcwDefault = parcelHelpers.interopDefault(_rotate90DegreesCcw);
var _rotate90DegreesCcwOutlined = require("./Rotate90DegreesCcwOutlined");
var _rotate90DegreesCcwOutlinedDefault = parcelHelpers.interopDefault(_rotate90DegreesCcwOutlined);
var _rotate90DegreesCcwRounded = require("./Rotate90DegreesCcwRounded");
var _rotate90DegreesCcwRoundedDefault = parcelHelpers.interopDefault(_rotate90DegreesCcwRounded);
var _rotate90DegreesCcwSharp = require("./Rotate90DegreesCcwSharp");
var _rotate90DegreesCcwSharpDefault = parcelHelpers.interopDefault(_rotate90DegreesCcwSharp);
var _rotate90DegreesCcwTwoTone = require("./Rotate90DegreesCcwTwoTone");
var _rotate90DegreesCcwTwoToneDefault = parcelHelpers.interopDefault(_rotate90DegreesCcwTwoTone);
var _rotate90DegreesCw = require("./Rotate90DegreesCw");
var _rotate90DegreesCwDefault = parcelHelpers.interopDefault(_rotate90DegreesCw);
var _rotate90DegreesCwOutlined = require("./Rotate90DegreesCwOutlined");
var _rotate90DegreesCwOutlinedDefault = parcelHelpers.interopDefault(_rotate90DegreesCwOutlined);
var _rotate90DegreesCwRounded = require("./Rotate90DegreesCwRounded");
var _rotate90DegreesCwRoundedDefault = parcelHelpers.interopDefault(_rotate90DegreesCwRounded);
var _rotate90DegreesCwSharp = require("./Rotate90DegreesCwSharp");
var _rotate90DegreesCwSharpDefault = parcelHelpers.interopDefault(_rotate90DegreesCwSharp);
var _rotate90DegreesCwTwoTone = require("./Rotate90DegreesCwTwoTone");
var _rotate90DegreesCwTwoToneDefault = parcelHelpers.interopDefault(_rotate90DegreesCwTwoTone);
var _rotateLeft = require("./RotateLeft");
var _rotateLeftDefault = parcelHelpers.interopDefault(_rotateLeft);
var _rotateLeftOutlined = require("./RotateLeftOutlined");
var _rotateLeftOutlinedDefault = parcelHelpers.interopDefault(_rotateLeftOutlined);
var _rotateLeftRounded = require("./RotateLeftRounded");
var _rotateLeftRoundedDefault = parcelHelpers.interopDefault(_rotateLeftRounded);
var _rotateLeftSharp = require("./RotateLeftSharp");
var _rotateLeftSharpDefault = parcelHelpers.interopDefault(_rotateLeftSharp);
var _rotateLeftTwoTone = require("./RotateLeftTwoTone");
var _rotateLeftTwoToneDefault = parcelHelpers.interopDefault(_rotateLeftTwoTone);
var _rotateRight = require("./RotateRight");
var _rotateRightDefault = parcelHelpers.interopDefault(_rotateRight);
var _rotateRightOutlined = require("./RotateRightOutlined");
var _rotateRightOutlinedDefault = parcelHelpers.interopDefault(_rotateRightOutlined);
var _rotateRightRounded = require("./RotateRightRounded");
var _rotateRightRoundedDefault = parcelHelpers.interopDefault(_rotateRightRounded);
var _rotateRightSharp = require("./RotateRightSharp");
var _rotateRightSharpDefault = parcelHelpers.interopDefault(_rotateRightSharp);
var _rotateRightTwoTone = require("./RotateRightTwoTone");
var _rotateRightTwoToneDefault = parcelHelpers.interopDefault(_rotateRightTwoTone);
var _roundaboutLeft = require("./RoundaboutLeft");
var _roundaboutLeftDefault = parcelHelpers.interopDefault(_roundaboutLeft);
var _roundaboutLeftOutlined = require("./RoundaboutLeftOutlined");
var _roundaboutLeftOutlinedDefault = parcelHelpers.interopDefault(_roundaboutLeftOutlined);
var _roundaboutLeftRounded = require("./RoundaboutLeftRounded");
var _roundaboutLeftRoundedDefault = parcelHelpers.interopDefault(_roundaboutLeftRounded);
var _roundaboutLeftSharp = require("./RoundaboutLeftSharp");
var _roundaboutLeftSharpDefault = parcelHelpers.interopDefault(_roundaboutLeftSharp);
var _roundaboutLeftTwoTone = require("./RoundaboutLeftTwoTone");
var _roundaboutLeftTwoToneDefault = parcelHelpers.interopDefault(_roundaboutLeftTwoTone);
var _roundaboutRight = require("./RoundaboutRight");
var _roundaboutRightDefault = parcelHelpers.interopDefault(_roundaboutRight);
var _roundaboutRightOutlined = require("./RoundaboutRightOutlined");
var _roundaboutRightOutlinedDefault = parcelHelpers.interopDefault(_roundaboutRightOutlined);
var _roundaboutRightRounded = require("./RoundaboutRightRounded");
var _roundaboutRightRoundedDefault = parcelHelpers.interopDefault(_roundaboutRightRounded);
var _roundaboutRightSharp = require("./RoundaboutRightSharp");
var _roundaboutRightSharpDefault = parcelHelpers.interopDefault(_roundaboutRightSharp);
var _roundaboutRightTwoTone = require("./RoundaboutRightTwoTone");
var _roundaboutRightTwoToneDefault = parcelHelpers.interopDefault(_roundaboutRightTwoTone);
var _roundedCorner = require("./RoundedCorner");
var _roundedCornerDefault = parcelHelpers.interopDefault(_roundedCorner);
var _roundedCornerOutlined = require("./RoundedCornerOutlined");
var _roundedCornerOutlinedDefault = parcelHelpers.interopDefault(_roundedCornerOutlined);
var _roundedCornerRounded = require("./RoundedCornerRounded");
var _roundedCornerRoundedDefault = parcelHelpers.interopDefault(_roundedCornerRounded);
var _roundedCornerSharp = require("./RoundedCornerSharp");
var _roundedCornerSharpDefault = parcelHelpers.interopDefault(_roundedCornerSharp);
var _roundedCornerTwoTone = require("./RoundedCornerTwoTone");
var _roundedCornerTwoToneDefault = parcelHelpers.interopDefault(_roundedCornerTwoTone);
var _route = require("./Route");
var _routeDefault = parcelHelpers.interopDefault(_route);
var _routeOutlined = require("./RouteOutlined");
var _routeOutlinedDefault = parcelHelpers.interopDefault(_routeOutlined);
var _routeRounded = require("./RouteRounded");
var _routeRoundedDefault = parcelHelpers.interopDefault(_routeRounded);
var _routeSharp = require("./RouteSharp");
var _routeSharpDefault = parcelHelpers.interopDefault(_routeSharp);
var _routeTwoTone = require("./RouteTwoTone");
var _routeTwoToneDefault = parcelHelpers.interopDefault(_routeTwoTone);
var _router = require("./Router");
var _routerDefault = parcelHelpers.interopDefault(_router);
var _routerOutlined = require("./RouterOutlined");
var _routerOutlinedDefault = parcelHelpers.interopDefault(_routerOutlined);
var _routerRounded = require("./RouterRounded");
var _routerRoundedDefault = parcelHelpers.interopDefault(_routerRounded);
var _routerSharp = require("./RouterSharp");
var _routerSharpDefault = parcelHelpers.interopDefault(_routerSharp);
var _routerTwoTone = require("./RouterTwoTone");
var _routerTwoToneDefault = parcelHelpers.interopDefault(_routerTwoTone);
var _rowing = require("./Rowing");
var _rowingDefault = parcelHelpers.interopDefault(_rowing);
var _rowingOutlined = require("./RowingOutlined");
var _rowingOutlinedDefault = parcelHelpers.interopDefault(_rowingOutlined);
var _rowingRounded = require("./RowingRounded");
var _rowingRoundedDefault = parcelHelpers.interopDefault(_rowingRounded);
var _rowingSharp = require("./RowingSharp");
var _rowingSharpDefault = parcelHelpers.interopDefault(_rowingSharp);
var _rowingTwoTone = require("./RowingTwoTone");
var _rowingTwoToneDefault = parcelHelpers.interopDefault(_rowingTwoTone);
var _rssFeed = require("./RssFeed");
var _rssFeedDefault = parcelHelpers.interopDefault(_rssFeed);
var _rssFeedOutlined = require("./RssFeedOutlined");
var _rssFeedOutlinedDefault = parcelHelpers.interopDefault(_rssFeedOutlined);
var _rssFeedRounded = require("./RssFeedRounded");
var _rssFeedRoundedDefault = parcelHelpers.interopDefault(_rssFeedRounded);
var _rssFeedSharp = require("./RssFeedSharp");
var _rssFeedSharpDefault = parcelHelpers.interopDefault(_rssFeedSharp);
var _rssFeedTwoTone = require("./RssFeedTwoTone");
var _rssFeedTwoToneDefault = parcelHelpers.interopDefault(_rssFeedTwoTone);
var _rsvp = require("./Rsvp");
var _rsvpDefault = parcelHelpers.interopDefault(_rsvp);
var _rsvpOutlined = require("./RsvpOutlined");
var _rsvpOutlinedDefault = parcelHelpers.interopDefault(_rsvpOutlined);
var _rsvpRounded = require("./RsvpRounded");
var _rsvpRoundedDefault = parcelHelpers.interopDefault(_rsvpRounded);
var _rsvpSharp = require("./RsvpSharp");
var _rsvpSharpDefault = parcelHelpers.interopDefault(_rsvpSharp);
var _rsvpTwoTone = require("./RsvpTwoTone");
var _rsvpTwoToneDefault = parcelHelpers.interopDefault(_rsvpTwoTone);
var _rtt = require("./Rtt");
var _rttDefault = parcelHelpers.interopDefault(_rtt);
var _rttOutlined = require("./RttOutlined");
var _rttOutlinedDefault = parcelHelpers.interopDefault(_rttOutlined);
var _rttRounded = require("./RttRounded");
var _rttRoundedDefault = parcelHelpers.interopDefault(_rttRounded);
var _rttSharp = require("./RttSharp");
var _rttSharpDefault = parcelHelpers.interopDefault(_rttSharp);
var _rttTwoTone = require("./RttTwoTone");
var _rttTwoToneDefault = parcelHelpers.interopDefault(_rttTwoTone);
var _rule = require("./Rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _ruleFolder = require("./RuleFolder");
var _ruleFolderDefault = parcelHelpers.interopDefault(_ruleFolder);
var _ruleFolderOutlined = require("./RuleFolderOutlined");
var _ruleFolderOutlinedDefault = parcelHelpers.interopDefault(_ruleFolderOutlined);
var _ruleFolderRounded = require("./RuleFolderRounded");
var _ruleFolderRoundedDefault = parcelHelpers.interopDefault(_ruleFolderRounded);
var _ruleFolderSharp = require("./RuleFolderSharp");
var _ruleFolderSharpDefault = parcelHelpers.interopDefault(_ruleFolderSharp);
var _ruleFolderTwoTone = require("./RuleFolderTwoTone");
var _ruleFolderTwoToneDefault = parcelHelpers.interopDefault(_ruleFolderTwoTone);
var _ruleOutlined = require("./RuleOutlined");
var _ruleOutlinedDefault = parcelHelpers.interopDefault(_ruleOutlined);
var _ruleRounded = require("./RuleRounded");
var _ruleRoundedDefault = parcelHelpers.interopDefault(_ruleRounded);
var _ruleSharp = require("./RuleSharp");
var _ruleSharpDefault = parcelHelpers.interopDefault(_ruleSharp);
var _ruleTwoTone = require("./RuleTwoTone");
var _ruleTwoToneDefault = parcelHelpers.interopDefault(_ruleTwoTone);
var _runCircle = require("./RunCircle");
var _runCircleDefault = parcelHelpers.interopDefault(_runCircle);
var _runCircleOutlined = require("./RunCircleOutlined");
var _runCircleOutlinedDefault = parcelHelpers.interopDefault(_runCircleOutlined);
var _runCircleRounded = require("./RunCircleRounded");
var _runCircleRoundedDefault = parcelHelpers.interopDefault(_runCircleRounded);
var _runCircleSharp = require("./RunCircleSharp");
var _runCircleSharpDefault = parcelHelpers.interopDefault(_runCircleSharp);
var _runCircleTwoTone = require("./RunCircleTwoTone");
var _runCircleTwoToneDefault = parcelHelpers.interopDefault(_runCircleTwoTone);
var _runningWithErrors = require("./RunningWithErrors");
var _runningWithErrorsDefault = parcelHelpers.interopDefault(_runningWithErrors);
var _runningWithErrorsOutlined = require("./RunningWithErrorsOutlined");
var _runningWithErrorsOutlinedDefault = parcelHelpers.interopDefault(_runningWithErrorsOutlined);
var _runningWithErrorsRounded = require("./RunningWithErrorsRounded");
var _runningWithErrorsRoundedDefault = parcelHelpers.interopDefault(_runningWithErrorsRounded);
var _runningWithErrorsSharp = require("./RunningWithErrorsSharp");
var _runningWithErrorsSharpDefault = parcelHelpers.interopDefault(_runningWithErrorsSharp);
var _runningWithErrorsTwoTone = require("./RunningWithErrorsTwoTone");
var _runningWithErrorsTwoToneDefault = parcelHelpers.interopDefault(_runningWithErrorsTwoTone);
var _rvHookup = require("./RvHookup");
var _rvHookupDefault = parcelHelpers.interopDefault(_rvHookup);
var _rvHookupOutlined = require("./RvHookupOutlined");
var _rvHookupOutlinedDefault = parcelHelpers.interopDefault(_rvHookupOutlined);
var _rvHookupRounded = require("./RvHookupRounded");
var _rvHookupRoundedDefault = parcelHelpers.interopDefault(_rvHookupRounded);
var _rvHookupSharp = require("./RvHookupSharp");
var _rvHookupSharpDefault = parcelHelpers.interopDefault(_rvHookupSharp);
var _rvHookupTwoTone = require("./RvHookupTwoTone");
var _rvHookupTwoToneDefault = parcelHelpers.interopDefault(_rvHookupTwoTone);
var _safetyCheck = require("./SafetyCheck");
var _safetyCheckDefault = parcelHelpers.interopDefault(_safetyCheck);
var _safetyCheckOutlined = require("./SafetyCheckOutlined");
var _safetyCheckOutlinedDefault = parcelHelpers.interopDefault(_safetyCheckOutlined);
var _safetyCheckRounded = require("./SafetyCheckRounded");
var _safetyCheckRoundedDefault = parcelHelpers.interopDefault(_safetyCheckRounded);
var _safetyCheckSharp = require("./SafetyCheckSharp");
var _safetyCheckSharpDefault = parcelHelpers.interopDefault(_safetyCheckSharp);
var _safetyCheckTwoTone = require("./SafetyCheckTwoTone");
var _safetyCheckTwoToneDefault = parcelHelpers.interopDefault(_safetyCheckTwoTone);
var _safetyDivider = require("./SafetyDivider");
var _safetyDividerDefault = parcelHelpers.interopDefault(_safetyDivider);
var _safetyDividerOutlined = require("./SafetyDividerOutlined");
var _safetyDividerOutlinedDefault = parcelHelpers.interopDefault(_safetyDividerOutlined);
var _safetyDividerRounded = require("./SafetyDividerRounded");
var _safetyDividerRoundedDefault = parcelHelpers.interopDefault(_safetyDividerRounded);
var _safetyDividerSharp = require("./SafetyDividerSharp");
var _safetyDividerSharpDefault = parcelHelpers.interopDefault(_safetyDividerSharp);
var _safetyDividerTwoTone = require("./SafetyDividerTwoTone");
var _safetyDividerTwoToneDefault = parcelHelpers.interopDefault(_safetyDividerTwoTone);
var _sailing = require("./Sailing");
var _sailingDefault = parcelHelpers.interopDefault(_sailing);
var _sailingOutlined = require("./SailingOutlined");
var _sailingOutlinedDefault = parcelHelpers.interopDefault(_sailingOutlined);
var _sailingRounded = require("./SailingRounded");
var _sailingRoundedDefault = parcelHelpers.interopDefault(_sailingRounded);
var _sailingSharp = require("./SailingSharp");
var _sailingSharpDefault = parcelHelpers.interopDefault(_sailingSharp);
var _sailingTwoTone = require("./SailingTwoTone");
var _sailingTwoToneDefault = parcelHelpers.interopDefault(_sailingTwoTone);
var _sanitizer = require("./Sanitizer");
var _sanitizerDefault = parcelHelpers.interopDefault(_sanitizer);
var _sanitizerOutlined = require("./SanitizerOutlined");
var _sanitizerOutlinedDefault = parcelHelpers.interopDefault(_sanitizerOutlined);
var _sanitizerRounded = require("./SanitizerRounded");
var _sanitizerRoundedDefault = parcelHelpers.interopDefault(_sanitizerRounded);
var _sanitizerSharp = require("./SanitizerSharp");
var _sanitizerSharpDefault = parcelHelpers.interopDefault(_sanitizerSharp);
var _sanitizerTwoTone = require("./SanitizerTwoTone");
var _sanitizerTwoToneDefault = parcelHelpers.interopDefault(_sanitizerTwoTone);
var _satellite = require("./Satellite");
var _satelliteDefault = parcelHelpers.interopDefault(_satellite);
var _satelliteAlt = require("./SatelliteAlt");
var _satelliteAltDefault = parcelHelpers.interopDefault(_satelliteAlt);
var _satelliteAltOutlined = require("./SatelliteAltOutlined");
var _satelliteAltOutlinedDefault = parcelHelpers.interopDefault(_satelliteAltOutlined);
var _satelliteAltRounded = require("./SatelliteAltRounded");
var _satelliteAltRoundedDefault = parcelHelpers.interopDefault(_satelliteAltRounded);
var _satelliteAltSharp = require("./SatelliteAltSharp");
var _satelliteAltSharpDefault = parcelHelpers.interopDefault(_satelliteAltSharp);
var _satelliteAltTwoTone = require("./SatelliteAltTwoTone");
var _satelliteAltTwoToneDefault = parcelHelpers.interopDefault(_satelliteAltTwoTone);
var _satelliteOutlined = require("./SatelliteOutlined");
var _satelliteOutlinedDefault = parcelHelpers.interopDefault(_satelliteOutlined);
var _satelliteRounded = require("./SatelliteRounded");
var _satelliteRoundedDefault = parcelHelpers.interopDefault(_satelliteRounded);
var _satelliteSharp = require("./SatelliteSharp");
var _satelliteSharpDefault = parcelHelpers.interopDefault(_satelliteSharp);
var _satelliteTwoTone = require("./SatelliteTwoTone");
var _satelliteTwoToneDefault = parcelHelpers.interopDefault(_satelliteTwoTone);
var _save = require("./Save");
var _saveDefault = parcelHelpers.interopDefault(_save);
var _saveAlt = require("./SaveAlt");
var _saveAltDefault = parcelHelpers.interopDefault(_saveAlt);
var _saveAltOutlined = require("./SaveAltOutlined");
var _saveAltOutlinedDefault = parcelHelpers.interopDefault(_saveAltOutlined);
var _saveAltRounded = require("./SaveAltRounded");
var _saveAltRoundedDefault = parcelHelpers.interopDefault(_saveAltRounded);
var _saveAltSharp = require("./SaveAltSharp");
var _saveAltSharpDefault = parcelHelpers.interopDefault(_saveAltSharp);
var _saveAltTwoTone = require("./SaveAltTwoTone");
var _saveAltTwoToneDefault = parcelHelpers.interopDefault(_saveAltTwoTone);
var _saveAs = require("./SaveAs");
var _saveAsDefault = parcelHelpers.interopDefault(_saveAs);
var _saveAsOutlined = require("./SaveAsOutlined");
var _saveAsOutlinedDefault = parcelHelpers.interopDefault(_saveAsOutlined);
var _saveAsRounded = require("./SaveAsRounded");
var _saveAsRoundedDefault = parcelHelpers.interopDefault(_saveAsRounded);
var _saveAsSharp = require("./SaveAsSharp");
var _saveAsSharpDefault = parcelHelpers.interopDefault(_saveAsSharp);
var _saveAsTwoTone = require("./SaveAsTwoTone");
var _saveAsTwoToneDefault = parcelHelpers.interopDefault(_saveAsTwoTone);
var _saveOutlined = require("./SaveOutlined");
var _saveOutlinedDefault = parcelHelpers.interopDefault(_saveOutlined);
var _saveRounded = require("./SaveRounded");
var _saveRoundedDefault = parcelHelpers.interopDefault(_saveRounded);
var _saveSharp = require("./SaveSharp");
var _saveSharpDefault = parcelHelpers.interopDefault(_saveSharp);
var _saveTwoTone = require("./SaveTwoTone");
var _saveTwoToneDefault = parcelHelpers.interopDefault(_saveTwoTone);
var _savedSearch = require("./SavedSearch");
var _savedSearchDefault = parcelHelpers.interopDefault(_savedSearch);
var _savedSearchOutlined = require("./SavedSearchOutlined");
var _savedSearchOutlinedDefault = parcelHelpers.interopDefault(_savedSearchOutlined);
var _savedSearchRounded = require("./SavedSearchRounded");
var _savedSearchRoundedDefault = parcelHelpers.interopDefault(_savedSearchRounded);
var _savedSearchSharp = require("./SavedSearchSharp");
var _savedSearchSharpDefault = parcelHelpers.interopDefault(_savedSearchSharp);
var _savedSearchTwoTone = require("./SavedSearchTwoTone");
var _savedSearchTwoToneDefault = parcelHelpers.interopDefault(_savedSearchTwoTone);
var _savings = require("./Savings");
var _savingsDefault = parcelHelpers.interopDefault(_savings);
var _savingsOutlined = require("./SavingsOutlined");
var _savingsOutlinedDefault = parcelHelpers.interopDefault(_savingsOutlined);
var _savingsRounded = require("./SavingsRounded");
var _savingsRoundedDefault = parcelHelpers.interopDefault(_savingsRounded);
var _savingsSharp = require("./SavingsSharp");
var _savingsSharpDefault = parcelHelpers.interopDefault(_savingsSharp);
var _savingsTwoTone = require("./SavingsTwoTone");
var _savingsTwoToneDefault = parcelHelpers.interopDefault(_savingsTwoTone);
var _scale = require("./Scale");
var _scaleDefault = parcelHelpers.interopDefault(_scale);
var _scaleOutlined = require("./ScaleOutlined");
var _scaleOutlinedDefault = parcelHelpers.interopDefault(_scaleOutlined);
var _scaleRounded = require("./ScaleRounded");
var _scaleRoundedDefault = parcelHelpers.interopDefault(_scaleRounded);
var _scaleSharp = require("./ScaleSharp");
var _scaleSharpDefault = parcelHelpers.interopDefault(_scaleSharp);
var _scaleTwoTone = require("./ScaleTwoTone");
var _scaleTwoToneDefault = parcelHelpers.interopDefault(_scaleTwoTone);
var _scanner = require("./Scanner");
var _scannerDefault = parcelHelpers.interopDefault(_scanner);
var _scannerOutlined = require("./ScannerOutlined");
var _scannerOutlinedDefault = parcelHelpers.interopDefault(_scannerOutlined);
var _scannerRounded = require("./ScannerRounded");
var _scannerRoundedDefault = parcelHelpers.interopDefault(_scannerRounded);
var _scannerSharp = require("./ScannerSharp");
var _scannerSharpDefault = parcelHelpers.interopDefault(_scannerSharp);
var _scannerTwoTone = require("./ScannerTwoTone");
var _scannerTwoToneDefault = parcelHelpers.interopDefault(_scannerTwoTone);
var _scatterPlot = require("./ScatterPlot");
var _scatterPlotDefault = parcelHelpers.interopDefault(_scatterPlot);
var _scatterPlotOutlined = require("./ScatterPlotOutlined");
var _scatterPlotOutlinedDefault = parcelHelpers.interopDefault(_scatterPlotOutlined);
var _scatterPlotRounded = require("./ScatterPlotRounded");
var _scatterPlotRoundedDefault = parcelHelpers.interopDefault(_scatterPlotRounded);
var _scatterPlotSharp = require("./ScatterPlotSharp");
var _scatterPlotSharpDefault = parcelHelpers.interopDefault(_scatterPlotSharp);
var _scatterPlotTwoTone = require("./ScatterPlotTwoTone");
var _scatterPlotTwoToneDefault = parcelHelpers.interopDefault(_scatterPlotTwoTone);
var _schedule = require("./Schedule");
var _scheduleDefault = parcelHelpers.interopDefault(_schedule);
var _scheduleOutlined = require("./ScheduleOutlined");
var _scheduleOutlinedDefault = parcelHelpers.interopDefault(_scheduleOutlined);
var _scheduleRounded = require("./ScheduleRounded");
var _scheduleRoundedDefault = parcelHelpers.interopDefault(_scheduleRounded);
var _scheduleSend = require("./ScheduleSend");
var _scheduleSendDefault = parcelHelpers.interopDefault(_scheduleSend);
var _scheduleSendOutlined = require("./ScheduleSendOutlined");
var _scheduleSendOutlinedDefault = parcelHelpers.interopDefault(_scheduleSendOutlined);
var _scheduleSendRounded = require("./ScheduleSendRounded");
var _scheduleSendRoundedDefault = parcelHelpers.interopDefault(_scheduleSendRounded);
var _scheduleSendSharp = require("./ScheduleSendSharp");
var _scheduleSendSharpDefault = parcelHelpers.interopDefault(_scheduleSendSharp);
var _scheduleSendTwoTone = require("./ScheduleSendTwoTone");
var _scheduleSendTwoToneDefault = parcelHelpers.interopDefault(_scheduleSendTwoTone);
var _scheduleSharp = require("./ScheduleSharp");
var _scheduleSharpDefault = parcelHelpers.interopDefault(_scheduleSharp);
var _scheduleTwoTone = require("./ScheduleTwoTone");
var _scheduleTwoToneDefault = parcelHelpers.interopDefault(_scheduleTwoTone);
var _schema = require("./Schema");
var _schemaDefault = parcelHelpers.interopDefault(_schema);
var _schemaOutlined = require("./SchemaOutlined");
var _schemaOutlinedDefault = parcelHelpers.interopDefault(_schemaOutlined);
var _schemaRounded = require("./SchemaRounded");
var _schemaRoundedDefault = parcelHelpers.interopDefault(_schemaRounded);
var _schemaSharp = require("./SchemaSharp");
var _schemaSharpDefault = parcelHelpers.interopDefault(_schemaSharp);
var _schemaTwoTone = require("./SchemaTwoTone");
var _schemaTwoToneDefault = parcelHelpers.interopDefault(_schemaTwoTone);
var _school = require("./School");
var _schoolDefault = parcelHelpers.interopDefault(_school);
var _schoolOutlined = require("./SchoolOutlined");
var _schoolOutlinedDefault = parcelHelpers.interopDefault(_schoolOutlined);
var _schoolRounded = require("./SchoolRounded");
var _schoolRoundedDefault = parcelHelpers.interopDefault(_schoolRounded);
var _schoolSharp = require("./SchoolSharp");
var _schoolSharpDefault = parcelHelpers.interopDefault(_schoolSharp);
var _schoolTwoTone = require("./SchoolTwoTone");
var _schoolTwoToneDefault = parcelHelpers.interopDefault(_schoolTwoTone);
var _science = require("./Science");
var _scienceDefault = parcelHelpers.interopDefault(_science);
var _scienceOutlined = require("./ScienceOutlined");
var _scienceOutlinedDefault = parcelHelpers.interopDefault(_scienceOutlined);
var _scienceRounded = require("./ScienceRounded");
var _scienceRoundedDefault = parcelHelpers.interopDefault(_scienceRounded);
var _scienceSharp = require("./ScienceSharp");
var _scienceSharpDefault = parcelHelpers.interopDefault(_scienceSharp);
var _scienceTwoTone = require("./ScienceTwoTone");
var _scienceTwoToneDefault = parcelHelpers.interopDefault(_scienceTwoTone);
var _score = require("./Score");
var _scoreDefault = parcelHelpers.interopDefault(_score);
var _scoreOutlined = require("./ScoreOutlined");
var _scoreOutlinedDefault = parcelHelpers.interopDefault(_scoreOutlined);
var _scoreRounded = require("./ScoreRounded");
var _scoreRoundedDefault = parcelHelpers.interopDefault(_scoreRounded);
var _scoreSharp = require("./ScoreSharp");
var _scoreSharpDefault = parcelHelpers.interopDefault(_scoreSharp);
var _scoreTwoTone = require("./ScoreTwoTone");
var _scoreTwoToneDefault = parcelHelpers.interopDefault(_scoreTwoTone);
var _scoreboard = require("./Scoreboard");
var _scoreboardDefault = parcelHelpers.interopDefault(_scoreboard);
var _scoreboardOutlined = require("./ScoreboardOutlined");
var _scoreboardOutlinedDefault = parcelHelpers.interopDefault(_scoreboardOutlined);
var _scoreboardRounded = require("./ScoreboardRounded");
var _scoreboardRoundedDefault = parcelHelpers.interopDefault(_scoreboardRounded);
var _scoreboardSharp = require("./ScoreboardSharp");
var _scoreboardSharpDefault = parcelHelpers.interopDefault(_scoreboardSharp);
var _scoreboardTwoTone = require("./ScoreboardTwoTone");
var _scoreboardTwoToneDefault = parcelHelpers.interopDefault(_scoreboardTwoTone);
var _screenLockLandscape = require("./ScreenLockLandscape");
var _screenLockLandscapeDefault = parcelHelpers.interopDefault(_screenLockLandscape);
var _screenLockLandscapeOutlined = require("./ScreenLockLandscapeOutlined");
var _screenLockLandscapeOutlinedDefault = parcelHelpers.interopDefault(_screenLockLandscapeOutlined);
var _screenLockLandscapeRounded = require("./ScreenLockLandscapeRounded");
var _screenLockLandscapeRoundedDefault = parcelHelpers.interopDefault(_screenLockLandscapeRounded);
var _screenLockLandscapeSharp = require("./ScreenLockLandscapeSharp");
var _screenLockLandscapeSharpDefault = parcelHelpers.interopDefault(_screenLockLandscapeSharp);
var _screenLockLandscapeTwoTone = require("./ScreenLockLandscapeTwoTone");
var _screenLockLandscapeTwoToneDefault = parcelHelpers.interopDefault(_screenLockLandscapeTwoTone);
var _screenLockPortrait = require("./ScreenLockPortrait");
var _screenLockPortraitDefault = parcelHelpers.interopDefault(_screenLockPortrait);
var _screenLockPortraitOutlined = require("./ScreenLockPortraitOutlined");
var _screenLockPortraitOutlinedDefault = parcelHelpers.interopDefault(_screenLockPortraitOutlined);
var _screenLockPortraitRounded = require("./ScreenLockPortraitRounded");
var _screenLockPortraitRoundedDefault = parcelHelpers.interopDefault(_screenLockPortraitRounded);
var _screenLockPortraitSharp = require("./ScreenLockPortraitSharp");
var _screenLockPortraitSharpDefault = parcelHelpers.interopDefault(_screenLockPortraitSharp);
var _screenLockPortraitTwoTone = require("./ScreenLockPortraitTwoTone");
var _screenLockPortraitTwoToneDefault = parcelHelpers.interopDefault(_screenLockPortraitTwoTone);
var _screenLockRotation = require("./ScreenLockRotation");
var _screenLockRotationDefault = parcelHelpers.interopDefault(_screenLockRotation);
var _screenLockRotationOutlined = require("./ScreenLockRotationOutlined");
var _screenLockRotationOutlinedDefault = parcelHelpers.interopDefault(_screenLockRotationOutlined);
var _screenLockRotationRounded = require("./ScreenLockRotationRounded");
var _screenLockRotationRoundedDefault = parcelHelpers.interopDefault(_screenLockRotationRounded);
var _screenLockRotationSharp = require("./ScreenLockRotationSharp");
var _screenLockRotationSharpDefault = parcelHelpers.interopDefault(_screenLockRotationSharp);
var _screenLockRotationTwoTone = require("./ScreenLockRotationTwoTone");
var _screenLockRotationTwoToneDefault = parcelHelpers.interopDefault(_screenLockRotationTwoTone);
var _screenRotation = require("./ScreenRotation");
var _screenRotationDefault = parcelHelpers.interopDefault(_screenRotation);
var _screenRotationAlt = require("./ScreenRotationAlt");
var _screenRotationAltDefault = parcelHelpers.interopDefault(_screenRotationAlt);
var _screenRotationAltOutlined = require("./ScreenRotationAltOutlined");
var _screenRotationAltOutlinedDefault = parcelHelpers.interopDefault(_screenRotationAltOutlined);
var _screenRotationAltRounded = require("./ScreenRotationAltRounded");
var _screenRotationAltRoundedDefault = parcelHelpers.interopDefault(_screenRotationAltRounded);
var _screenRotationAltSharp = require("./ScreenRotationAltSharp");
var _screenRotationAltSharpDefault = parcelHelpers.interopDefault(_screenRotationAltSharp);
var _screenRotationAltTwoTone = require("./ScreenRotationAltTwoTone");
var _screenRotationAltTwoToneDefault = parcelHelpers.interopDefault(_screenRotationAltTwoTone);
var _screenRotationOutlined = require("./ScreenRotationOutlined");
var _screenRotationOutlinedDefault = parcelHelpers.interopDefault(_screenRotationOutlined);
var _screenRotationRounded = require("./ScreenRotationRounded");
var _screenRotationRoundedDefault = parcelHelpers.interopDefault(_screenRotationRounded);
var _screenRotationSharp = require("./ScreenRotationSharp");
var _screenRotationSharpDefault = parcelHelpers.interopDefault(_screenRotationSharp);
var _screenRotationTwoTone = require("./ScreenRotationTwoTone");
var _screenRotationTwoToneDefault = parcelHelpers.interopDefault(_screenRotationTwoTone);
var _screenSearchDesktop = require("./ScreenSearchDesktop");
var _screenSearchDesktopDefault = parcelHelpers.interopDefault(_screenSearchDesktop);
var _screenSearchDesktopOutlined = require("./ScreenSearchDesktopOutlined");
var _screenSearchDesktopOutlinedDefault = parcelHelpers.interopDefault(_screenSearchDesktopOutlined);
var _screenSearchDesktopRounded = require("./ScreenSearchDesktopRounded");
var _screenSearchDesktopRoundedDefault = parcelHelpers.interopDefault(_screenSearchDesktopRounded);
var _screenSearchDesktopSharp = require("./ScreenSearchDesktopSharp");
var _screenSearchDesktopSharpDefault = parcelHelpers.interopDefault(_screenSearchDesktopSharp);
var _screenSearchDesktopTwoTone = require("./ScreenSearchDesktopTwoTone");
var _screenSearchDesktopTwoToneDefault = parcelHelpers.interopDefault(_screenSearchDesktopTwoTone);
var _screenShare = require("./ScreenShare");
var _screenShareDefault = parcelHelpers.interopDefault(_screenShare);
var _screenShareOutlined = require("./ScreenShareOutlined");
var _screenShareOutlinedDefault = parcelHelpers.interopDefault(_screenShareOutlined);
var _screenShareRounded = require("./ScreenShareRounded");
var _screenShareRoundedDefault = parcelHelpers.interopDefault(_screenShareRounded);
var _screenShareSharp = require("./ScreenShareSharp");
var _screenShareSharpDefault = parcelHelpers.interopDefault(_screenShareSharp);
var _screenShareTwoTone = require("./ScreenShareTwoTone");
var _screenShareTwoToneDefault = parcelHelpers.interopDefault(_screenShareTwoTone);
var _screenshot = require("./Screenshot");
var _screenshotDefault = parcelHelpers.interopDefault(_screenshot);
var _screenshotMonitor = require("./ScreenshotMonitor");
var _screenshotMonitorDefault = parcelHelpers.interopDefault(_screenshotMonitor);
var _screenshotMonitorOutlined = require("./ScreenshotMonitorOutlined");
var _screenshotMonitorOutlinedDefault = parcelHelpers.interopDefault(_screenshotMonitorOutlined);
var _screenshotMonitorRounded = require("./ScreenshotMonitorRounded");
var _screenshotMonitorRoundedDefault = parcelHelpers.interopDefault(_screenshotMonitorRounded);
var _screenshotMonitorSharp = require("./ScreenshotMonitorSharp");
var _screenshotMonitorSharpDefault = parcelHelpers.interopDefault(_screenshotMonitorSharp);
var _screenshotMonitorTwoTone = require("./ScreenshotMonitorTwoTone");
var _screenshotMonitorTwoToneDefault = parcelHelpers.interopDefault(_screenshotMonitorTwoTone);
var _screenshotOutlined = require("./ScreenshotOutlined");
var _screenshotOutlinedDefault = parcelHelpers.interopDefault(_screenshotOutlined);
var _screenshotRounded = require("./ScreenshotRounded");
var _screenshotRoundedDefault = parcelHelpers.interopDefault(_screenshotRounded);
var _screenshotSharp = require("./ScreenshotSharp");
var _screenshotSharpDefault = parcelHelpers.interopDefault(_screenshotSharp);
var _screenshotTwoTone = require("./ScreenshotTwoTone");
var _screenshotTwoToneDefault = parcelHelpers.interopDefault(_screenshotTwoTone);
var _scubaDiving = require("./ScubaDiving");
var _scubaDivingDefault = parcelHelpers.interopDefault(_scubaDiving);
var _scubaDivingOutlined = require("./ScubaDivingOutlined");
var _scubaDivingOutlinedDefault = parcelHelpers.interopDefault(_scubaDivingOutlined);
var _scubaDivingRounded = require("./ScubaDivingRounded");
var _scubaDivingRoundedDefault = parcelHelpers.interopDefault(_scubaDivingRounded);
var _scubaDivingSharp = require("./ScubaDivingSharp");
var _scubaDivingSharpDefault = parcelHelpers.interopDefault(_scubaDivingSharp);
var _scubaDivingTwoTone = require("./ScubaDivingTwoTone");
var _scubaDivingTwoToneDefault = parcelHelpers.interopDefault(_scubaDivingTwoTone);
var _sd = require("./Sd");
var _sdDefault = parcelHelpers.interopDefault(_sd);
var _sdCard = require("./SdCard");
var _sdCardDefault = parcelHelpers.interopDefault(_sdCard);
var _sdCardAlert = require("./SdCardAlert");
var _sdCardAlertDefault = parcelHelpers.interopDefault(_sdCardAlert);
var _sdCardAlertOutlined = require("./SdCardAlertOutlined");
var _sdCardAlertOutlinedDefault = parcelHelpers.interopDefault(_sdCardAlertOutlined);
var _sdCardAlertRounded = require("./SdCardAlertRounded");
var _sdCardAlertRoundedDefault = parcelHelpers.interopDefault(_sdCardAlertRounded);
var _sdCardAlertSharp = require("./SdCardAlertSharp");
var _sdCardAlertSharpDefault = parcelHelpers.interopDefault(_sdCardAlertSharp);
var _sdCardAlertTwoTone = require("./SdCardAlertTwoTone");
var _sdCardAlertTwoToneDefault = parcelHelpers.interopDefault(_sdCardAlertTwoTone);
var _sdCardOutlined = require("./SdCardOutlined");
var _sdCardOutlinedDefault = parcelHelpers.interopDefault(_sdCardOutlined);
var _sdCardRounded = require("./SdCardRounded");
var _sdCardRoundedDefault = parcelHelpers.interopDefault(_sdCardRounded);
var _sdCardSharp = require("./SdCardSharp");
var _sdCardSharpDefault = parcelHelpers.interopDefault(_sdCardSharp);
var _sdCardTwoTone = require("./SdCardTwoTone");
var _sdCardTwoToneDefault = parcelHelpers.interopDefault(_sdCardTwoTone);
var _sdOutlined = require("./SdOutlined");
var _sdOutlinedDefault = parcelHelpers.interopDefault(_sdOutlined);
var _sdRounded = require("./SdRounded");
var _sdRoundedDefault = parcelHelpers.interopDefault(_sdRounded);
var _sdSharp = require("./SdSharp");
var _sdSharpDefault = parcelHelpers.interopDefault(_sdSharp);
var _sdStorage = require("./SdStorage");
var _sdStorageDefault = parcelHelpers.interopDefault(_sdStorage);
var _sdStorageOutlined = require("./SdStorageOutlined");
var _sdStorageOutlinedDefault = parcelHelpers.interopDefault(_sdStorageOutlined);
var _sdStorageRounded = require("./SdStorageRounded");
var _sdStorageRoundedDefault = parcelHelpers.interopDefault(_sdStorageRounded);
var _sdStorageSharp = require("./SdStorageSharp");
var _sdStorageSharpDefault = parcelHelpers.interopDefault(_sdStorageSharp);
var _sdStorageTwoTone = require("./SdStorageTwoTone");
var _sdStorageTwoToneDefault = parcelHelpers.interopDefault(_sdStorageTwoTone);
var _sdTwoTone = require("./SdTwoTone");
var _sdTwoToneDefault = parcelHelpers.interopDefault(_sdTwoTone);
var _search = require("./Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _searchOff = require("./SearchOff");
var _searchOffDefault = parcelHelpers.interopDefault(_searchOff);
var _searchOffOutlined = require("./SearchOffOutlined");
var _searchOffOutlinedDefault = parcelHelpers.interopDefault(_searchOffOutlined);
var _searchOffRounded = require("./SearchOffRounded");
var _searchOffRoundedDefault = parcelHelpers.interopDefault(_searchOffRounded);
var _searchOffSharp = require("./SearchOffSharp");
var _searchOffSharpDefault = parcelHelpers.interopDefault(_searchOffSharp);
var _searchOffTwoTone = require("./SearchOffTwoTone");
var _searchOffTwoToneDefault = parcelHelpers.interopDefault(_searchOffTwoTone);
var _searchOutlined = require("./SearchOutlined");
var _searchOutlinedDefault = parcelHelpers.interopDefault(_searchOutlined);
var _searchRounded = require("./SearchRounded");
var _searchRoundedDefault = parcelHelpers.interopDefault(_searchRounded);
var _searchSharp = require("./SearchSharp");
var _searchSharpDefault = parcelHelpers.interopDefault(_searchSharp);
var _searchTwoTone = require("./SearchTwoTone");
var _searchTwoToneDefault = parcelHelpers.interopDefault(_searchTwoTone);
var _security = require("./Security");
var _securityDefault = parcelHelpers.interopDefault(_security);
var _securityOutlined = require("./SecurityOutlined");
var _securityOutlinedDefault = parcelHelpers.interopDefault(_securityOutlined);
var _securityRounded = require("./SecurityRounded");
var _securityRoundedDefault = parcelHelpers.interopDefault(_securityRounded);
var _securitySharp = require("./SecuritySharp");
var _securitySharpDefault = parcelHelpers.interopDefault(_securitySharp);
var _securityTwoTone = require("./SecurityTwoTone");
var _securityTwoToneDefault = parcelHelpers.interopDefault(_securityTwoTone);
var _securityUpdate = require("./SecurityUpdate");
var _securityUpdateDefault = parcelHelpers.interopDefault(_securityUpdate);
var _securityUpdateGood = require("./SecurityUpdateGood");
var _securityUpdateGoodDefault = parcelHelpers.interopDefault(_securityUpdateGood);
var _securityUpdateGoodOutlined = require("./SecurityUpdateGoodOutlined");
var _securityUpdateGoodOutlinedDefault = parcelHelpers.interopDefault(_securityUpdateGoodOutlined);
var _securityUpdateGoodRounded = require("./SecurityUpdateGoodRounded");
var _securityUpdateGoodRoundedDefault = parcelHelpers.interopDefault(_securityUpdateGoodRounded);
var _securityUpdateGoodSharp = require("./SecurityUpdateGoodSharp");
var _securityUpdateGoodSharpDefault = parcelHelpers.interopDefault(_securityUpdateGoodSharp);
var _securityUpdateGoodTwoTone = require("./SecurityUpdateGoodTwoTone");
var _securityUpdateGoodTwoToneDefault = parcelHelpers.interopDefault(_securityUpdateGoodTwoTone);
var _securityUpdateOutlined = require("./SecurityUpdateOutlined");
var _securityUpdateOutlinedDefault = parcelHelpers.interopDefault(_securityUpdateOutlined);
var _securityUpdateRounded = require("./SecurityUpdateRounded");
var _securityUpdateRoundedDefault = parcelHelpers.interopDefault(_securityUpdateRounded);
var _securityUpdateSharp = require("./SecurityUpdateSharp");
var _securityUpdateSharpDefault = parcelHelpers.interopDefault(_securityUpdateSharp);
var _securityUpdateTwoTone = require("./SecurityUpdateTwoTone");
var _securityUpdateTwoToneDefault = parcelHelpers.interopDefault(_securityUpdateTwoTone);
var _securityUpdateWarning = require("./SecurityUpdateWarning");
var _securityUpdateWarningDefault = parcelHelpers.interopDefault(_securityUpdateWarning);
var _securityUpdateWarningOutlined = require("./SecurityUpdateWarningOutlined");
var _securityUpdateWarningOutlinedDefault = parcelHelpers.interopDefault(_securityUpdateWarningOutlined);
var _securityUpdateWarningRounded = require("./SecurityUpdateWarningRounded");
var _securityUpdateWarningRoundedDefault = parcelHelpers.interopDefault(_securityUpdateWarningRounded);
var _securityUpdateWarningSharp = require("./SecurityUpdateWarningSharp");
var _securityUpdateWarningSharpDefault = parcelHelpers.interopDefault(_securityUpdateWarningSharp);
var _securityUpdateWarningTwoTone = require("./SecurityUpdateWarningTwoTone");
var _securityUpdateWarningTwoToneDefault = parcelHelpers.interopDefault(_securityUpdateWarningTwoTone);
var _segment = require("./Segment");
var _segmentDefault = parcelHelpers.interopDefault(_segment);
var _segmentOutlined = require("./SegmentOutlined");
var _segmentOutlinedDefault = parcelHelpers.interopDefault(_segmentOutlined);
var _segmentRounded = require("./SegmentRounded");
var _segmentRoundedDefault = parcelHelpers.interopDefault(_segmentRounded);
var _segmentSharp = require("./SegmentSharp");
var _segmentSharpDefault = parcelHelpers.interopDefault(_segmentSharp);
var _segmentTwoTone = require("./SegmentTwoTone");
var _segmentTwoToneDefault = parcelHelpers.interopDefault(_segmentTwoTone);
var _selectAll = require("./SelectAll");
var _selectAllDefault = parcelHelpers.interopDefault(_selectAll);
var _selectAllOutlined = require("./SelectAllOutlined");
var _selectAllOutlinedDefault = parcelHelpers.interopDefault(_selectAllOutlined);
var _selectAllRounded = require("./SelectAllRounded");
var _selectAllRoundedDefault = parcelHelpers.interopDefault(_selectAllRounded);
var _selectAllSharp = require("./SelectAllSharp");
var _selectAllSharpDefault = parcelHelpers.interopDefault(_selectAllSharp);
var _selectAllTwoTone = require("./SelectAllTwoTone");
var _selectAllTwoToneDefault = parcelHelpers.interopDefault(_selectAllTwoTone);
var _selfImprovement = require("./SelfImprovement");
var _selfImprovementDefault = parcelHelpers.interopDefault(_selfImprovement);
var _selfImprovementOutlined = require("./SelfImprovementOutlined");
var _selfImprovementOutlinedDefault = parcelHelpers.interopDefault(_selfImprovementOutlined);
var _selfImprovementRounded = require("./SelfImprovementRounded");
var _selfImprovementRoundedDefault = parcelHelpers.interopDefault(_selfImprovementRounded);
var _selfImprovementSharp = require("./SelfImprovementSharp");
var _selfImprovementSharpDefault = parcelHelpers.interopDefault(_selfImprovementSharp);
var _selfImprovementTwoTone = require("./SelfImprovementTwoTone");
var _selfImprovementTwoToneDefault = parcelHelpers.interopDefault(_selfImprovementTwoTone);
var _sell = require("./Sell");
var _sellDefault = parcelHelpers.interopDefault(_sell);
var _sellOutlined = require("./SellOutlined");
var _sellOutlinedDefault = parcelHelpers.interopDefault(_sellOutlined);
var _sellRounded = require("./SellRounded");
var _sellRoundedDefault = parcelHelpers.interopDefault(_sellRounded);
var _sellSharp = require("./SellSharp");
var _sellSharpDefault = parcelHelpers.interopDefault(_sellSharp);
var _sellTwoTone = require("./SellTwoTone");
var _sellTwoToneDefault = parcelHelpers.interopDefault(_sellTwoTone);
var _send = require("./Send");
var _sendDefault = parcelHelpers.interopDefault(_send);
var _sendAndArchive = require("./SendAndArchive");
var _sendAndArchiveDefault = parcelHelpers.interopDefault(_sendAndArchive);
var _sendAndArchiveOutlined = require("./SendAndArchiveOutlined");
var _sendAndArchiveOutlinedDefault = parcelHelpers.interopDefault(_sendAndArchiveOutlined);
var _sendAndArchiveRounded = require("./SendAndArchiveRounded");
var _sendAndArchiveRoundedDefault = parcelHelpers.interopDefault(_sendAndArchiveRounded);
var _sendAndArchiveSharp = require("./SendAndArchiveSharp");
var _sendAndArchiveSharpDefault = parcelHelpers.interopDefault(_sendAndArchiveSharp);
var _sendAndArchiveTwoTone = require("./SendAndArchiveTwoTone");
var _sendAndArchiveTwoToneDefault = parcelHelpers.interopDefault(_sendAndArchiveTwoTone);
var _sendOutlined = require("./SendOutlined");
var _sendOutlinedDefault = parcelHelpers.interopDefault(_sendOutlined);
var _sendRounded = require("./SendRounded");
var _sendRoundedDefault = parcelHelpers.interopDefault(_sendRounded);
var _sendSharp = require("./SendSharp");
var _sendSharpDefault = parcelHelpers.interopDefault(_sendSharp);
var _sendTimeExtension = require("./SendTimeExtension");
var _sendTimeExtensionDefault = parcelHelpers.interopDefault(_sendTimeExtension);
var _sendTimeExtensionOutlined = require("./SendTimeExtensionOutlined");
var _sendTimeExtensionOutlinedDefault = parcelHelpers.interopDefault(_sendTimeExtensionOutlined);
var _sendTimeExtensionRounded = require("./SendTimeExtensionRounded");
var _sendTimeExtensionRoundedDefault = parcelHelpers.interopDefault(_sendTimeExtensionRounded);
var _sendTimeExtensionSharp = require("./SendTimeExtensionSharp");
var _sendTimeExtensionSharpDefault = parcelHelpers.interopDefault(_sendTimeExtensionSharp);
var _sendTimeExtensionTwoTone = require("./SendTimeExtensionTwoTone");
var _sendTimeExtensionTwoToneDefault = parcelHelpers.interopDefault(_sendTimeExtensionTwoTone);
var _sendToMobile = require("./SendToMobile");
var _sendToMobileDefault = parcelHelpers.interopDefault(_sendToMobile);
var _sendToMobileOutlined = require("./SendToMobileOutlined");
var _sendToMobileOutlinedDefault = parcelHelpers.interopDefault(_sendToMobileOutlined);
var _sendToMobileRounded = require("./SendToMobileRounded");
var _sendToMobileRoundedDefault = parcelHelpers.interopDefault(_sendToMobileRounded);
var _sendToMobileSharp = require("./SendToMobileSharp");
var _sendToMobileSharpDefault = parcelHelpers.interopDefault(_sendToMobileSharp);
var _sendToMobileTwoTone = require("./SendToMobileTwoTone");
var _sendToMobileTwoToneDefault = parcelHelpers.interopDefault(_sendToMobileTwoTone);
var _sendTwoTone = require("./SendTwoTone");
var _sendTwoToneDefault = parcelHelpers.interopDefault(_sendTwoTone);
var _sensorDoor = require("./SensorDoor");
var _sensorDoorDefault = parcelHelpers.interopDefault(_sensorDoor);
var _sensorDoorOutlined = require("./SensorDoorOutlined");
var _sensorDoorOutlinedDefault = parcelHelpers.interopDefault(_sensorDoorOutlined);
var _sensorDoorRounded = require("./SensorDoorRounded");
var _sensorDoorRoundedDefault = parcelHelpers.interopDefault(_sensorDoorRounded);
var _sensorDoorSharp = require("./SensorDoorSharp");
var _sensorDoorSharpDefault = parcelHelpers.interopDefault(_sensorDoorSharp);
var _sensorDoorTwoTone = require("./SensorDoorTwoTone");
var _sensorDoorTwoToneDefault = parcelHelpers.interopDefault(_sensorDoorTwoTone);
var _sensorOccupied = require("./SensorOccupied");
var _sensorOccupiedDefault = parcelHelpers.interopDefault(_sensorOccupied);
var _sensorOccupiedOutlined = require("./SensorOccupiedOutlined");
var _sensorOccupiedOutlinedDefault = parcelHelpers.interopDefault(_sensorOccupiedOutlined);
var _sensorOccupiedRounded = require("./SensorOccupiedRounded");
var _sensorOccupiedRoundedDefault = parcelHelpers.interopDefault(_sensorOccupiedRounded);
var _sensorOccupiedSharp = require("./SensorOccupiedSharp");
var _sensorOccupiedSharpDefault = parcelHelpers.interopDefault(_sensorOccupiedSharp);
var _sensorOccupiedTwoTone = require("./SensorOccupiedTwoTone");
var _sensorOccupiedTwoToneDefault = parcelHelpers.interopDefault(_sensorOccupiedTwoTone);
var _sensorWindow = require("./SensorWindow");
var _sensorWindowDefault = parcelHelpers.interopDefault(_sensorWindow);
var _sensorWindowOutlined = require("./SensorWindowOutlined");
var _sensorWindowOutlinedDefault = parcelHelpers.interopDefault(_sensorWindowOutlined);
var _sensorWindowRounded = require("./SensorWindowRounded");
var _sensorWindowRoundedDefault = parcelHelpers.interopDefault(_sensorWindowRounded);
var _sensorWindowSharp = require("./SensorWindowSharp");
var _sensorWindowSharpDefault = parcelHelpers.interopDefault(_sensorWindowSharp);
var _sensorWindowTwoTone = require("./SensorWindowTwoTone");
var _sensorWindowTwoToneDefault = parcelHelpers.interopDefault(_sensorWindowTwoTone);
var _sensors = require("./Sensors");
var _sensorsDefault = parcelHelpers.interopDefault(_sensors);
var _sensorsOff = require("./SensorsOff");
var _sensorsOffDefault = parcelHelpers.interopDefault(_sensorsOff);
var _sensorsOffOutlined = require("./SensorsOffOutlined");
var _sensorsOffOutlinedDefault = parcelHelpers.interopDefault(_sensorsOffOutlined);
var _sensorsOffRounded = require("./SensorsOffRounded");
var _sensorsOffRoundedDefault = parcelHelpers.interopDefault(_sensorsOffRounded);
var _sensorsOffSharp = require("./SensorsOffSharp");
var _sensorsOffSharpDefault = parcelHelpers.interopDefault(_sensorsOffSharp);
var _sensorsOffTwoTone = require("./SensorsOffTwoTone");
var _sensorsOffTwoToneDefault = parcelHelpers.interopDefault(_sensorsOffTwoTone);
var _sensorsOutlined = require("./SensorsOutlined");
var _sensorsOutlinedDefault = parcelHelpers.interopDefault(_sensorsOutlined);
var _sensorsRounded = require("./SensorsRounded");
var _sensorsRoundedDefault = parcelHelpers.interopDefault(_sensorsRounded);
var _sensorsSharp = require("./SensorsSharp");
var _sensorsSharpDefault = parcelHelpers.interopDefault(_sensorsSharp);
var _sensorsTwoTone = require("./SensorsTwoTone");
var _sensorsTwoToneDefault = parcelHelpers.interopDefault(_sensorsTwoTone);
var _sentimentDissatisfied = require("./SentimentDissatisfied");
var _sentimentDissatisfiedDefault = parcelHelpers.interopDefault(_sentimentDissatisfied);
var _sentimentDissatisfiedOutlined = require("./SentimentDissatisfiedOutlined");
var _sentimentDissatisfiedOutlinedDefault = parcelHelpers.interopDefault(_sentimentDissatisfiedOutlined);
var _sentimentDissatisfiedRounded = require("./SentimentDissatisfiedRounded");
var _sentimentDissatisfiedRoundedDefault = parcelHelpers.interopDefault(_sentimentDissatisfiedRounded);
var _sentimentDissatisfiedSharp = require("./SentimentDissatisfiedSharp");
var _sentimentDissatisfiedSharpDefault = parcelHelpers.interopDefault(_sentimentDissatisfiedSharp);
var _sentimentDissatisfiedTwoTone = require("./SentimentDissatisfiedTwoTone");
var _sentimentDissatisfiedTwoToneDefault = parcelHelpers.interopDefault(_sentimentDissatisfiedTwoTone);
var _sentimentNeutral = require("./SentimentNeutral");
var _sentimentNeutralDefault = parcelHelpers.interopDefault(_sentimentNeutral);
var _sentimentNeutralOutlined = require("./SentimentNeutralOutlined");
var _sentimentNeutralOutlinedDefault = parcelHelpers.interopDefault(_sentimentNeutralOutlined);
var _sentimentNeutralRounded = require("./SentimentNeutralRounded");
var _sentimentNeutralRoundedDefault = parcelHelpers.interopDefault(_sentimentNeutralRounded);
var _sentimentNeutralSharp = require("./SentimentNeutralSharp");
var _sentimentNeutralSharpDefault = parcelHelpers.interopDefault(_sentimentNeutralSharp);
var _sentimentNeutralTwoTone = require("./SentimentNeutralTwoTone");
var _sentimentNeutralTwoToneDefault = parcelHelpers.interopDefault(_sentimentNeutralTwoTone);
var _sentimentSatisfied = require("./SentimentSatisfied");
var _sentimentSatisfiedDefault = parcelHelpers.interopDefault(_sentimentSatisfied);
var _sentimentSatisfiedAlt = require("./SentimentSatisfiedAlt");
var _sentimentSatisfiedAltDefault = parcelHelpers.interopDefault(_sentimentSatisfiedAlt);
var _sentimentSatisfiedAltOutlined = require("./SentimentSatisfiedAltOutlined");
var _sentimentSatisfiedAltOutlinedDefault = parcelHelpers.interopDefault(_sentimentSatisfiedAltOutlined);
var _sentimentSatisfiedAltRounded = require("./SentimentSatisfiedAltRounded");
var _sentimentSatisfiedAltRoundedDefault = parcelHelpers.interopDefault(_sentimentSatisfiedAltRounded);
var _sentimentSatisfiedAltSharp = require("./SentimentSatisfiedAltSharp");
var _sentimentSatisfiedAltSharpDefault = parcelHelpers.interopDefault(_sentimentSatisfiedAltSharp);
var _sentimentSatisfiedAltTwoTone = require("./SentimentSatisfiedAltTwoTone");
var _sentimentSatisfiedAltTwoToneDefault = parcelHelpers.interopDefault(_sentimentSatisfiedAltTwoTone);
var _sentimentSatisfiedOutlined = require("./SentimentSatisfiedOutlined");
var _sentimentSatisfiedOutlinedDefault = parcelHelpers.interopDefault(_sentimentSatisfiedOutlined);
var _sentimentSatisfiedRounded = require("./SentimentSatisfiedRounded");
var _sentimentSatisfiedRoundedDefault = parcelHelpers.interopDefault(_sentimentSatisfiedRounded);
var _sentimentSatisfiedSharp = require("./SentimentSatisfiedSharp");
var _sentimentSatisfiedSharpDefault = parcelHelpers.interopDefault(_sentimentSatisfiedSharp);
var _sentimentSatisfiedTwoTone = require("./SentimentSatisfiedTwoTone");
var _sentimentSatisfiedTwoToneDefault = parcelHelpers.interopDefault(_sentimentSatisfiedTwoTone);
var _sentimentVeryDissatisfied = require("./SentimentVeryDissatisfied");
var _sentimentVeryDissatisfiedDefault = parcelHelpers.interopDefault(_sentimentVeryDissatisfied);
var _sentimentVeryDissatisfiedOutlined = require("./SentimentVeryDissatisfiedOutlined");
var _sentimentVeryDissatisfiedOutlinedDefault = parcelHelpers.interopDefault(_sentimentVeryDissatisfiedOutlined);
var _sentimentVeryDissatisfiedRounded = require("./SentimentVeryDissatisfiedRounded");
var _sentimentVeryDissatisfiedRoundedDefault = parcelHelpers.interopDefault(_sentimentVeryDissatisfiedRounded);
var _sentimentVeryDissatisfiedSharp = require("./SentimentVeryDissatisfiedSharp");
var _sentimentVeryDissatisfiedSharpDefault = parcelHelpers.interopDefault(_sentimentVeryDissatisfiedSharp);
var _sentimentVeryDissatisfiedTwoTone = require("./SentimentVeryDissatisfiedTwoTone");
var _sentimentVeryDissatisfiedTwoToneDefault = parcelHelpers.interopDefault(_sentimentVeryDissatisfiedTwoTone);
var _sentimentVerySatisfied = require("./SentimentVerySatisfied");
var _sentimentVerySatisfiedDefault = parcelHelpers.interopDefault(_sentimentVerySatisfied);
var _sentimentVerySatisfiedOutlined = require("./SentimentVerySatisfiedOutlined");
var _sentimentVerySatisfiedOutlinedDefault = parcelHelpers.interopDefault(_sentimentVerySatisfiedOutlined);
var _sentimentVerySatisfiedRounded = require("./SentimentVerySatisfiedRounded");
var _sentimentVerySatisfiedRoundedDefault = parcelHelpers.interopDefault(_sentimentVerySatisfiedRounded);
var _sentimentVerySatisfiedSharp = require("./SentimentVerySatisfiedSharp");
var _sentimentVerySatisfiedSharpDefault = parcelHelpers.interopDefault(_sentimentVerySatisfiedSharp);
var _sentimentVerySatisfiedTwoTone = require("./SentimentVerySatisfiedTwoTone");
var _sentimentVerySatisfiedTwoToneDefault = parcelHelpers.interopDefault(_sentimentVerySatisfiedTwoTone);
var _setMeal = require("./SetMeal");
var _setMealDefault = parcelHelpers.interopDefault(_setMeal);
var _setMealOutlined = require("./SetMealOutlined");
var _setMealOutlinedDefault = parcelHelpers.interopDefault(_setMealOutlined);
var _setMealRounded = require("./SetMealRounded");
var _setMealRoundedDefault = parcelHelpers.interopDefault(_setMealRounded);
var _setMealSharp = require("./SetMealSharp");
var _setMealSharpDefault = parcelHelpers.interopDefault(_setMealSharp);
var _setMealTwoTone = require("./SetMealTwoTone");
var _setMealTwoToneDefault = parcelHelpers.interopDefault(_setMealTwoTone);
var _settings = require("./Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _settingsAccessibility = require("./SettingsAccessibility");
var _settingsAccessibilityDefault = parcelHelpers.interopDefault(_settingsAccessibility);
var _settingsAccessibilityOutlined = require("./SettingsAccessibilityOutlined");
var _settingsAccessibilityOutlinedDefault = parcelHelpers.interopDefault(_settingsAccessibilityOutlined);
var _settingsAccessibilityRounded = require("./SettingsAccessibilityRounded");
var _settingsAccessibilityRoundedDefault = parcelHelpers.interopDefault(_settingsAccessibilityRounded);
var _settingsAccessibilitySharp = require("./SettingsAccessibilitySharp");
var _settingsAccessibilitySharpDefault = parcelHelpers.interopDefault(_settingsAccessibilitySharp);
var _settingsAccessibilityTwoTone = require("./SettingsAccessibilityTwoTone");
var _settingsAccessibilityTwoToneDefault = parcelHelpers.interopDefault(_settingsAccessibilityTwoTone);
var _settingsApplications = require("./SettingsApplications");
var _settingsApplicationsDefault = parcelHelpers.interopDefault(_settingsApplications);
var _settingsApplicationsOutlined = require("./SettingsApplicationsOutlined");
var _settingsApplicationsOutlinedDefault = parcelHelpers.interopDefault(_settingsApplicationsOutlined);
var _settingsApplicationsRounded = require("./SettingsApplicationsRounded");
var _settingsApplicationsRoundedDefault = parcelHelpers.interopDefault(_settingsApplicationsRounded);
var _settingsApplicationsSharp = require("./SettingsApplicationsSharp");
var _settingsApplicationsSharpDefault = parcelHelpers.interopDefault(_settingsApplicationsSharp);
var _settingsApplicationsTwoTone = require("./SettingsApplicationsTwoTone");
var _settingsApplicationsTwoToneDefault = parcelHelpers.interopDefault(_settingsApplicationsTwoTone);
var _settingsBackupRestore = require("./SettingsBackupRestore");
var _settingsBackupRestoreDefault = parcelHelpers.interopDefault(_settingsBackupRestore);
var _settingsBackupRestoreOutlined = require("./SettingsBackupRestoreOutlined");
var _settingsBackupRestoreOutlinedDefault = parcelHelpers.interopDefault(_settingsBackupRestoreOutlined);
var _settingsBackupRestoreRounded = require("./SettingsBackupRestoreRounded");
var _settingsBackupRestoreRoundedDefault = parcelHelpers.interopDefault(_settingsBackupRestoreRounded);
var _settingsBackupRestoreSharp = require("./SettingsBackupRestoreSharp");
var _settingsBackupRestoreSharpDefault = parcelHelpers.interopDefault(_settingsBackupRestoreSharp);
var _settingsBackupRestoreTwoTone = require("./SettingsBackupRestoreTwoTone");
var _settingsBackupRestoreTwoToneDefault = parcelHelpers.interopDefault(_settingsBackupRestoreTwoTone);
var _settingsBluetooth = require("./SettingsBluetooth");
var _settingsBluetoothDefault = parcelHelpers.interopDefault(_settingsBluetooth);
var _settingsBluetoothOutlined = require("./SettingsBluetoothOutlined");
var _settingsBluetoothOutlinedDefault = parcelHelpers.interopDefault(_settingsBluetoothOutlined);
var _settingsBluetoothRounded = require("./SettingsBluetoothRounded");
var _settingsBluetoothRoundedDefault = parcelHelpers.interopDefault(_settingsBluetoothRounded);
var _settingsBluetoothSharp = require("./SettingsBluetoothSharp");
var _settingsBluetoothSharpDefault = parcelHelpers.interopDefault(_settingsBluetoothSharp);
var _settingsBluetoothTwoTone = require("./SettingsBluetoothTwoTone");
var _settingsBluetoothTwoToneDefault = parcelHelpers.interopDefault(_settingsBluetoothTwoTone);
var _settingsBrightness = require("./SettingsBrightness");
var _settingsBrightnessDefault = parcelHelpers.interopDefault(_settingsBrightness);
var _settingsBrightnessOutlined = require("./SettingsBrightnessOutlined");
var _settingsBrightnessOutlinedDefault = parcelHelpers.interopDefault(_settingsBrightnessOutlined);
var _settingsBrightnessRounded = require("./SettingsBrightnessRounded");
var _settingsBrightnessRoundedDefault = parcelHelpers.interopDefault(_settingsBrightnessRounded);
var _settingsBrightnessSharp = require("./SettingsBrightnessSharp");
var _settingsBrightnessSharpDefault = parcelHelpers.interopDefault(_settingsBrightnessSharp);
var _settingsBrightnessTwoTone = require("./SettingsBrightnessTwoTone");
var _settingsBrightnessTwoToneDefault = parcelHelpers.interopDefault(_settingsBrightnessTwoTone);
var _settingsCell = require("./SettingsCell");
var _settingsCellDefault = parcelHelpers.interopDefault(_settingsCell);
var _settingsCellOutlined = require("./SettingsCellOutlined");
var _settingsCellOutlinedDefault = parcelHelpers.interopDefault(_settingsCellOutlined);
var _settingsCellRounded = require("./SettingsCellRounded");
var _settingsCellRoundedDefault = parcelHelpers.interopDefault(_settingsCellRounded);
var _settingsCellSharp = require("./SettingsCellSharp");
var _settingsCellSharpDefault = parcelHelpers.interopDefault(_settingsCellSharp);
var _settingsCellTwoTone = require("./SettingsCellTwoTone");
var _settingsCellTwoToneDefault = parcelHelpers.interopDefault(_settingsCellTwoTone);
var _settingsEthernet = require("./SettingsEthernet");
var _settingsEthernetDefault = parcelHelpers.interopDefault(_settingsEthernet);
var _settingsEthernetOutlined = require("./SettingsEthernetOutlined");
var _settingsEthernetOutlinedDefault = parcelHelpers.interopDefault(_settingsEthernetOutlined);
var _settingsEthernetRounded = require("./SettingsEthernetRounded");
var _settingsEthernetRoundedDefault = parcelHelpers.interopDefault(_settingsEthernetRounded);
var _settingsEthernetSharp = require("./SettingsEthernetSharp");
var _settingsEthernetSharpDefault = parcelHelpers.interopDefault(_settingsEthernetSharp);
var _settingsEthernetTwoTone = require("./SettingsEthernetTwoTone");
var _settingsEthernetTwoToneDefault = parcelHelpers.interopDefault(_settingsEthernetTwoTone);
var _settingsInputAntenna = require("./SettingsInputAntenna");
var _settingsInputAntennaDefault = parcelHelpers.interopDefault(_settingsInputAntenna);
var _settingsInputAntennaOutlined = require("./SettingsInputAntennaOutlined");
var _settingsInputAntennaOutlinedDefault = parcelHelpers.interopDefault(_settingsInputAntennaOutlined);
var _settingsInputAntennaRounded = require("./SettingsInputAntennaRounded");
var _settingsInputAntennaRoundedDefault = parcelHelpers.interopDefault(_settingsInputAntennaRounded);
var _settingsInputAntennaSharp = require("./SettingsInputAntennaSharp");
var _settingsInputAntennaSharpDefault = parcelHelpers.interopDefault(_settingsInputAntennaSharp);
var _settingsInputAntennaTwoTone = require("./SettingsInputAntennaTwoTone");
var _settingsInputAntennaTwoToneDefault = parcelHelpers.interopDefault(_settingsInputAntennaTwoTone);
var _settingsInputComponent = require("./SettingsInputComponent");
var _settingsInputComponentDefault = parcelHelpers.interopDefault(_settingsInputComponent);
var _settingsInputComponentOutlined = require("./SettingsInputComponentOutlined");
var _settingsInputComponentOutlinedDefault = parcelHelpers.interopDefault(_settingsInputComponentOutlined);
var _settingsInputComponentRounded = require("./SettingsInputComponentRounded");
var _settingsInputComponentRoundedDefault = parcelHelpers.interopDefault(_settingsInputComponentRounded);
var _settingsInputComponentSharp = require("./SettingsInputComponentSharp");
var _settingsInputComponentSharpDefault = parcelHelpers.interopDefault(_settingsInputComponentSharp);
var _settingsInputComponentTwoTone = require("./SettingsInputComponentTwoTone");
var _settingsInputComponentTwoToneDefault = parcelHelpers.interopDefault(_settingsInputComponentTwoTone);
var _settingsInputComposite = require("./SettingsInputComposite");
var _settingsInputCompositeDefault = parcelHelpers.interopDefault(_settingsInputComposite);
var _settingsInputCompositeOutlined = require("./SettingsInputCompositeOutlined");
var _settingsInputCompositeOutlinedDefault = parcelHelpers.interopDefault(_settingsInputCompositeOutlined);
var _settingsInputCompositeRounded = require("./SettingsInputCompositeRounded");
var _settingsInputCompositeRoundedDefault = parcelHelpers.interopDefault(_settingsInputCompositeRounded);
var _settingsInputCompositeSharp = require("./SettingsInputCompositeSharp");
var _settingsInputCompositeSharpDefault = parcelHelpers.interopDefault(_settingsInputCompositeSharp);
var _settingsInputCompositeTwoTone = require("./SettingsInputCompositeTwoTone");
var _settingsInputCompositeTwoToneDefault = parcelHelpers.interopDefault(_settingsInputCompositeTwoTone);
var _settingsInputHdmi = require("./SettingsInputHdmi");
var _settingsInputHdmiDefault = parcelHelpers.interopDefault(_settingsInputHdmi);
var _settingsInputHdmiOutlined = require("./SettingsInputHdmiOutlined");
var _settingsInputHdmiOutlinedDefault = parcelHelpers.interopDefault(_settingsInputHdmiOutlined);
var _settingsInputHdmiRounded = require("./SettingsInputHdmiRounded");
var _settingsInputHdmiRoundedDefault = parcelHelpers.interopDefault(_settingsInputHdmiRounded);
var _settingsInputHdmiSharp = require("./SettingsInputHdmiSharp");
var _settingsInputHdmiSharpDefault = parcelHelpers.interopDefault(_settingsInputHdmiSharp);
var _settingsInputHdmiTwoTone = require("./SettingsInputHdmiTwoTone");
var _settingsInputHdmiTwoToneDefault = parcelHelpers.interopDefault(_settingsInputHdmiTwoTone);
var _settingsInputSvideo = require("./SettingsInputSvideo");
var _settingsInputSvideoDefault = parcelHelpers.interopDefault(_settingsInputSvideo);
var _settingsInputSvideoOutlined = require("./SettingsInputSvideoOutlined");
var _settingsInputSvideoOutlinedDefault = parcelHelpers.interopDefault(_settingsInputSvideoOutlined);
var _settingsInputSvideoRounded = require("./SettingsInputSvideoRounded");
var _settingsInputSvideoRoundedDefault = parcelHelpers.interopDefault(_settingsInputSvideoRounded);
var _settingsInputSvideoSharp = require("./SettingsInputSvideoSharp");
var _settingsInputSvideoSharpDefault = parcelHelpers.interopDefault(_settingsInputSvideoSharp);
var _settingsInputSvideoTwoTone = require("./SettingsInputSvideoTwoTone");
var _settingsInputSvideoTwoToneDefault = parcelHelpers.interopDefault(_settingsInputSvideoTwoTone);
var _settingsOutlined = require("./SettingsOutlined");
var _settingsOutlinedDefault = parcelHelpers.interopDefault(_settingsOutlined);
var _settingsOverscan = require("./SettingsOverscan");
var _settingsOverscanDefault = parcelHelpers.interopDefault(_settingsOverscan);
var _settingsOverscanOutlined = require("./SettingsOverscanOutlined");
var _settingsOverscanOutlinedDefault = parcelHelpers.interopDefault(_settingsOverscanOutlined);
var _settingsOverscanRounded = require("./SettingsOverscanRounded");
var _settingsOverscanRoundedDefault = parcelHelpers.interopDefault(_settingsOverscanRounded);
var _settingsOverscanSharp = require("./SettingsOverscanSharp");
var _settingsOverscanSharpDefault = parcelHelpers.interopDefault(_settingsOverscanSharp);
var _settingsOverscanTwoTone = require("./SettingsOverscanTwoTone");
var _settingsOverscanTwoToneDefault = parcelHelpers.interopDefault(_settingsOverscanTwoTone);
var _settingsPhone = require("./SettingsPhone");
var _settingsPhoneDefault = parcelHelpers.interopDefault(_settingsPhone);
var _settingsPhoneOutlined = require("./SettingsPhoneOutlined");
var _settingsPhoneOutlinedDefault = parcelHelpers.interopDefault(_settingsPhoneOutlined);
var _settingsPhoneRounded = require("./SettingsPhoneRounded");
var _settingsPhoneRoundedDefault = parcelHelpers.interopDefault(_settingsPhoneRounded);
var _settingsPhoneSharp = require("./SettingsPhoneSharp");
var _settingsPhoneSharpDefault = parcelHelpers.interopDefault(_settingsPhoneSharp);
var _settingsPhoneTwoTone = require("./SettingsPhoneTwoTone");
var _settingsPhoneTwoToneDefault = parcelHelpers.interopDefault(_settingsPhoneTwoTone);
var _settingsPower = require("./SettingsPower");
var _settingsPowerDefault = parcelHelpers.interopDefault(_settingsPower);
var _settingsPowerOutlined = require("./SettingsPowerOutlined");
var _settingsPowerOutlinedDefault = parcelHelpers.interopDefault(_settingsPowerOutlined);
var _settingsPowerRounded = require("./SettingsPowerRounded");
var _settingsPowerRoundedDefault = parcelHelpers.interopDefault(_settingsPowerRounded);
var _settingsPowerSharp = require("./SettingsPowerSharp");
var _settingsPowerSharpDefault = parcelHelpers.interopDefault(_settingsPowerSharp);
var _settingsPowerTwoTone = require("./SettingsPowerTwoTone");
var _settingsPowerTwoToneDefault = parcelHelpers.interopDefault(_settingsPowerTwoTone);
var _settingsRemote = require("./SettingsRemote");
var _settingsRemoteDefault = parcelHelpers.interopDefault(_settingsRemote);
var _settingsRemoteOutlined = require("./SettingsRemoteOutlined");
var _settingsRemoteOutlinedDefault = parcelHelpers.interopDefault(_settingsRemoteOutlined);
var _settingsRemoteRounded = require("./SettingsRemoteRounded");
var _settingsRemoteRoundedDefault = parcelHelpers.interopDefault(_settingsRemoteRounded);
var _settingsRemoteSharp = require("./SettingsRemoteSharp");
var _settingsRemoteSharpDefault = parcelHelpers.interopDefault(_settingsRemoteSharp);
var _settingsRemoteTwoTone = require("./SettingsRemoteTwoTone");
var _settingsRemoteTwoToneDefault = parcelHelpers.interopDefault(_settingsRemoteTwoTone);
var _settingsRounded = require("./SettingsRounded");
var _settingsRoundedDefault = parcelHelpers.interopDefault(_settingsRounded);
var _settingsSharp = require("./SettingsSharp");
var _settingsSharpDefault = parcelHelpers.interopDefault(_settingsSharp);
var _settingsSuggest = require("./SettingsSuggest");
var _settingsSuggestDefault = parcelHelpers.interopDefault(_settingsSuggest);
var _settingsSuggestOutlined = require("./SettingsSuggestOutlined");
var _settingsSuggestOutlinedDefault = parcelHelpers.interopDefault(_settingsSuggestOutlined);
var _settingsSuggestRounded = require("./SettingsSuggestRounded");
var _settingsSuggestRoundedDefault = parcelHelpers.interopDefault(_settingsSuggestRounded);
var _settingsSuggestSharp = require("./SettingsSuggestSharp");
var _settingsSuggestSharpDefault = parcelHelpers.interopDefault(_settingsSuggestSharp);
var _settingsSuggestTwoTone = require("./SettingsSuggestTwoTone");
var _settingsSuggestTwoToneDefault = parcelHelpers.interopDefault(_settingsSuggestTwoTone);
var _settingsSystemDaydream = require("./SettingsSystemDaydream");
var _settingsSystemDaydreamDefault = parcelHelpers.interopDefault(_settingsSystemDaydream);
var _settingsSystemDaydreamOutlined = require("./SettingsSystemDaydreamOutlined");
var _settingsSystemDaydreamOutlinedDefault = parcelHelpers.interopDefault(_settingsSystemDaydreamOutlined);
var _settingsSystemDaydreamRounded = require("./SettingsSystemDaydreamRounded");
var _settingsSystemDaydreamRoundedDefault = parcelHelpers.interopDefault(_settingsSystemDaydreamRounded);
var _settingsSystemDaydreamSharp = require("./SettingsSystemDaydreamSharp");
var _settingsSystemDaydreamSharpDefault = parcelHelpers.interopDefault(_settingsSystemDaydreamSharp);
var _settingsSystemDaydreamTwoTone = require("./SettingsSystemDaydreamTwoTone");
var _settingsSystemDaydreamTwoToneDefault = parcelHelpers.interopDefault(_settingsSystemDaydreamTwoTone);
var _settingsTwoTone = require("./SettingsTwoTone");
var _settingsTwoToneDefault = parcelHelpers.interopDefault(_settingsTwoTone);
var _settingsVoice = require("./SettingsVoice");
var _settingsVoiceDefault = parcelHelpers.interopDefault(_settingsVoice);
var _settingsVoiceOutlined = require("./SettingsVoiceOutlined");
var _settingsVoiceOutlinedDefault = parcelHelpers.interopDefault(_settingsVoiceOutlined);
var _settingsVoiceRounded = require("./SettingsVoiceRounded");
var _settingsVoiceRoundedDefault = parcelHelpers.interopDefault(_settingsVoiceRounded);
var _settingsVoiceSharp = require("./SettingsVoiceSharp");
var _settingsVoiceSharpDefault = parcelHelpers.interopDefault(_settingsVoiceSharp);
var _settingsVoiceTwoTone = require("./SettingsVoiceTwoTone");
var _settingsVoiceTwoToneDefault = parcelHelpers.interopDefault(_settingsVoiceTwoTone);
var _sevenK = require("./SevenK");
var _sevenKDefault = parcelHelpers.interopDefault(_sevenK);
var _sevenKOutlined = require("./SevenKOutlined");
var _sevenKOutlinedDefault = parcelHelpers.interopDefault(_sevenKOutlined);
var _sevenKPlus = require("./SevenKPlus");
var _sevenKPlusDefault = parcelHelpers.interopDefault(_sevenKPlus);
var _sevenKPlusOutlined = require("./SevenKPlusOutlined");
var _sevenKPlusOutlinedDefault = parcelHelpers.interopDefault(_sevenKPlusOutlined);
var _sevenKPlusRounded = require("./SevenKPlusRounded");
var _sevenKPlusRoundedDefault = parcelHelpers.interopDefault(_sevenKPlusRounded);
var _sevenKPlusSharp = require("./SevenKPlusSharp");
var _sevenKPlusSharpDefault = parcelHelpers.interopDefault(_sevenKPlusSharp);
var _sevenKPlusTwoTone = require("./SevenKPlusTwoTone");
var _sevenKPlusTwoToneDefault = parcelHelpers.interopDefault(_sevenKPlusTwoTone);
var _sevenKRounded = require("./SevenKRounded");
var _sevenKRoundedDefault = parcelHelpers.interopDefault(_sevenKRounded);
var _sevenKSharp = require("./SevenKSharp");
var _sevenKSharpDefault = parcelHelpers.interopDefault(_sevenKSharp);
var _sevenKTwoTone = require("./SevenKTwoTone");
var _sevenKTwoToneDefault = parcelHelpers.interopDefault(_sevenKTwoTone);
var _sevenMp = require("./SevenMp");
var _sevenMpDefault = parcelHelpers.interopDefault(_sevenMp);
var _sevenMpOutlined = require("./SevenMpOutlined");
var _sevenMpOutlinedDefault = parcelHelpers.interopDefault(_sevenMpOutlined);
var _sevenMpRounded = require("./SevenMpRounded");
var _sevenMpRoundedDefault = parcelHelpers.interopDefault(_sevenMpRounded);
var _sevenMpSharp = require("./SevenMpSharp");
var _sevenMpSharpDefault = parcelHelpers.interopDefault(_sevenMpSharp);
var _sevenMpTwoTone = require("./SevenMpTwoTone");
var _sevenMpTwoToneDefault = parcelHelpers.interopDefault(_sevenMpTwoTone);
var _seventeenMp = require("./SeventeenMp");
var _seventeenMpDefault = parcelHelpers.interopDefault(_seventeenMp);
var _seventeenMpOutlined = require("./SeventeenMpOutlined");
var _seventeenMpOutlinedDefault = parcelHelpers.interopDefault(_seventeenMpOutlined);
var _seventeenMpRounded = require("./SeventeenMpRounded");
var _seventeenMpRoundedDefault = parcelHelpers.interopDefault(_seventeenMpRounded);
var _seventeenMpSharp = require("./SeventeenMpSharp");
var _seventeenMpSharpDefault = parcelHelpers.interopDefault(_seventeenMpSharp);
var _seventeenMpTwoTone = require("./SeventeenMpTwoTone");
var _seventeenMpTwoToneDefault = parcelHelpers.interopDefault(_seventeenMpTwoTone);
var _severeCold = require("./SevereCold");
var _severeColdDefault = parcelHelpers.interopDefault(_severeCold);
var _severeColdOutlined = require("./SevereColdOutlined");
var _severeColdOutlinedDefault = parcelHelpers.interopDefault(_severeColdOutlined);
var _severeColdRounded = require("./SevereColdRounded");
var _severeColdRoundedDefault = parcelHelpers.interopDefault(_severeColdRounded);
var _severeColdSharp = require("./SevereColdSharp");
var _severeColdSharpDefault = parcelHelpers.interopDefault(_severeColdSharp);
var _severeColdTwoTone = require("./SevereColdTwoTone");
var _severeColdTwoToneDefault = parcelHelpers.interopDefault(_severeColdTwoTone);
var _shapeLine = require("./ShapeLine");
var _shapeLineDefault = parcelHelpers.interopDefault(_shapeLine);
var _shapeLineOutlined = require("./ShapeLineOutlined");
var _shapeLineOutlinedDefault = parcelHelpers.interopDefault(_shapeLineOutlined);
var _shapeLineRounded = require("./ShapeLineRounded");
var _shapeLineRoundedDefault = parcelHelpers.interopDefault(_shapeLineRounded);
var _shapeLineSharp = require("./ShapeLineSharp");
var _shapeLineSharpDefault = parcelHelpers.interopDefault(_shapeLineSharp);
var _shapeLineTwoTone = require("./ShapeLineTwoTone");
var _shapeLineTwoToneDefault = parcelHelpers.interopDefault(_shapeLineTwoTone);
var _share = require("./Share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _shareLocation = require("./ShareLocation");
var _shareLocationDefault = parcelHelpers.interopDefault(_shareLocation);
var _shareLocationOutlined = require("./ShareLocationOutlined");
var _shareLocationOutlinedDefault = parcelHelpers.interopDefault(_shareLocationOutlined);
var _shareLocationRounded = require("./ShareLocationRounded");
var _shareLocationRoundedDefault = parcelHelpers.interopDefault(_shareLocationRounded);
var _shareLocationSharp = require("./ShareLocationSharp");
var _shareLocationSharpDefault = parcelHelpers.interopDefault(_shareLocationSharp);
var _shareLocationTwoTone = require("./ShareLocationTwoTone");
var _shareLocationTwoToneDefault = parcelHelpers.interopDefault(_shareLocationTwoTone);
var _shareOutlined = require("./ShareOutlined");
var _shareOutlinedDefault = parcelHelpers.interopDefault(_shareOutlined);
var _shareRounded = require("./ShareRounded");
var _shareRoundedDefault = parcelHelpers.interopDefault(_shareRounded);
var _shareSharp = require("./ShareSharp");
var _shareSharpDefault = parcelHelpers.interopDefault(_shareSharp);
var _shareTwoTone = require("./ShareTwoTone");
var _shareTwoToneDefault = parcelHelpers.interopDefault(_shareTwoTone);
var _shield = require("./Shield");
var _shieldDefault = parcelHelpers.interopDefault(_shield);
var _shieldMoon = require("./ShieldMoon");
var _shieldMoonDefault = parcelHelpers.interopDefault(_shieldMoon);
var _shieldMoonOutlined = require("./ShieldMoonOutlined");
var _shieldMoonOutlinedDefault = parcelHelpers.interopDefault(_shieldMoonOutlined);
var _shieldMoonRounded = require("./ShieldMoonRounded");
var _shieldMoonRoundedDefault = parcelHelpers.interopDefault(_shieldMoonRounded);
var _shieldMoonSharp = require("./ShieldMoonSharp");
var _shieldMoonSharpDefault = parcelHelpers.interopDefault(_shieldMoonSharp);
var _shieldMoonTwoTone = require("./ShieldMoonTwoTone");
var _shieldMoonTwoToneDefault = parcelHelpers.interopDefault(_shieldMoonTwoTone);
var _shieldOutlined = require("./ShieldOutlined");
var _shieldOutlinedDefault = parcelHelpers.interopDefault(_shieldOutlined);
var _shieldRounded = require("./ShieldRounded");
var _shieldRoundedDefault = parcelHelpers.interopDefault(_shieldRounded);
var _shieldSharp = require("./ShieldSharp");
var _shieldSharpDefault = parcelHelpers.interopDefault(_shieldSharp);
var _shieldTwoTone = require("./ShieldTwoTone");
var _shieldTwoToneDefault = parcelHelpers.interopDefault(_shieldTwoTone);
var _shop = require("./Shop");
var _shopDefault = parcelHelpers.interopDefault(_shop);
var _shop2 = require("./Shop2");
var _shop2Default = parcelHelpers.interopDefault(_shop2);
var _shop2Outlined = require("./Shop2Outlined");
var _shop2OutlinedDefault = parcelHelpers.interopDefault(_shop2Outlined);
var _shop2Rounded = require("./Shop2Rounded");
var _shop2RoundedDefault = parcelHelpers.interopDefault(_shop2Rounded);
var _shop2Sharp = require("./Shop2Sharp");
var _shop2SharpDefault = parcelHelpers.interopDefault(_shop2Sharp);
var _shop2TwoTone = require("./Shop2TwoTone");
var _shop2TwoToneDefault = parcelHelpers.interopDefault(_shop2TwoTone);
var _shopOutlined = require("./ShopOutlined");
var _shopOutlinedDefault = parcelHelpers.interopDefault(_shopOutlined);
var _shopRounded = require("./ShopRounded");
var _shopRoundedDefault = parcelHelpers.interopDefault(_shopRounded);
var _shopSharp = require("./ShopSharp");
var _shopSharpDefault = parcelHelpers.interopDefault(_shopSharp);
var _shopTwo = require("./ShopTwo");
var _shopTwoDefault = parcelHelpers.interopDefault(_shopTwo);
var _shopTwoOutlined = require("./ShopTwoOutlined");
var _shopTwoOutlinedDefault = parcelHelpers.interopDefault(_shopTwoOutlined);
var _shopTwoRounded = require("./ShopTwoRounded");
var _shopTwoRoundedDefault = parcelHelpers.interopDefault(_shopTwoRounded);
var _shopTwoSharp = require("./ShopTwoSharp");
var _shopTwoSharpDefault = parcelHelpers.interopDefault(_shopTwoSharp);
var _shopTwoTone = require("./ShopTwoTone");
var _shopTwoToneDefault = parcelHelpers.interopDefault(_shopTwoTone);
var _shopTwoTwoTone = require("./ShopTwoTwoTone");
var _shopTwoTwoToneDefault = parcelHelpers.interopDefault(_shopTwoTwoTone);
var _shoppingBag = require("./ShoppingBag");
var _shoppingBagDefault = parcelHelpers.interopDefault(_shoppingBag);
var _shoppingBagOutlined = require("./ShoppingBagOutlined");
var _shoppingBagOutlinedDefault = parcelHelpers.interopDefault(_shoppingBagOutlined);
var _shoppingBagRounded = require("./ShoppingBagRounded");
var _shoppingBagRoundedDefault = parcelHelpers.interopDefault(_shoppingBagRounded);
var _shoppingBagSharp = require("./ShoppingBagSharp");
var _shoppingBagSharpDefault = parcelHelpers.interopDefault(_shoppingBagSharp);
var _shoppingBagTwoTone = require("./ShoppingBagTwoTone");
var _shoppingBagTwoToneDefault = parcelHelpers.interopDefault(_shoppingBagTwoTone);
var _shoppingBasket = require("./ShoppingBasket");
var _shoppingBasketDefault = parcelHelpers.interopDefault(_shoppingBasket);
var _shoppingBasketOutlined = require("./ShoppingBasketOutlined");
var _shoppingBasketOutlinedDefault = parcelHelpers.interopDefault(_shoppingBasketOutlined);
var _shoppingBasketRounded = require("./ShoppingBasketRounded");
var _shoppingBasketRoundedDefault = parcelHelpers.interopDefault(_shoppingBasketRounded);
var _shoppingBasketSharp = require("./ShoppingBasketSharp");
var _shoppingBasketSharpDefault = parcelHelpers.interopDefault(_shoppingBasketSharp);
var _shoppingBasketTwoTone = require("./ShoppingBasketTwoTone");
var _shoppingBasketTwoToneDefault = parcelHelpers.interopDefault(_shoppingBasketTwoTone);
var _shoppingCart = require("./ShoppingCart");
var _shoppingCartDefault = parcelHelpers.interopDefault(_shoppingCart);
var _shoppingCartCheckout = require("./ShoppingCartCheckout");
var _shoppingCartCheckoutDefault = parcelHelpers.interopDefault(_shoppingCartCheckout);
var _shoppingCartCheckoutOutlined = require("./ShoppingCartCheckoutOutlined");
var _shoppingCartCheckoutOutlinedDefault = parcelHelpers.interopDefault(_shoppingCartCheckoutOutlined);
var _shoppingCartCheckoutRounded = require("./ShoppingCartCheckoutRounded");
var _shoppingCartCheckoutRoundedDefault = parcelHelpers.interopDefault(_shoppingCartCheckoutRounded);
var _shoppingCartCheckoutSharp = require("./ShoppingCartCheckoutSharp");
var _shoppingCartCheckoutSharpDefault = parcelHelpers.interopDefault(_shoppingCartCheckoutSharp);
var _shoppingCartCheckoutTwoTone = require("./ShoppingCartCheckoutTwoTone");
var _shoppingCartCheckoutTwoToneDefault = parcelHelpers.interopDefault(_shoppingCartCheckoutTwoTone);
var _shoppingCartOutlined = require("./ShoppingCartOutlined");
var _shoppingCartOutlinedDefault = parcelHelpers.interopDefault(_shoppingCartOutlined);
var _shoppingCartRounded = require("./ShoppingCartRounded");
var _shoppingCartRoundedDefault = parcelHelpers.interopDefault(_shoppingCartRounded);
var _shoppingCartSharp = require("./ShoppingCartSharp");
var _shoppingCartSharpDefault = parcelHelpers.interopDefault(_shoppingCartSharp);
var _shoppingCartTwoTone = require("./ShoppingCartTwoTone");
var _shoppingCartTwoToneDefault = parcelHelpers.interopDefault(_shoppingCartTwoTone);
var _shortText = require("./ShortText");
var _shortTextDefault = parcelHelpers.interopDefault(_shortText);
var _shortTextOutlined = require("./ShortTextOutlined");
var _shortTextOutlinedDefault = parcelHelpers.interopDefault(_shortTextOutlined);
var _shortTextRounded = require("./ShortTextRounded");
var _shortTextRoundedDefault = parcelHelpers.interopDefault(_shortTextRounded);
var _shortTextSharp = require("./ShortTextSharp");
var _shortTextSharpDefault = parcelHelpers.interopDefault(_shortTextSharp);
var _shortTextTwoTone = require("./ShortTextTwoTone");
var _shortTextTwoToneDefault = parcelHelpers.interopDefault(_shortTextTwoTone);
var _shortcut = require("./Shortcut");
var _shortcutDefault = parcelHelpers.interopDefault(_shortcut);
var _shortcutOutlined = require("./ShortcutOutlined");
var _shortcutOutlinedDefault = parcelHelpers.interopDefault(_shortcutOutlined);
var _shortcutRounded = require("./ShortcutRounded");
var _shortcutRoundedDefault = parcelHelpers.interopDefault(_shortcutRounded);
var _shortcutSharp = require("./ShortcutSharp");
var _shortcutSharpDefault = parcelHelpers.interopDefault(_shortcutSharp);
var _shortcutTwoTone = require("./ShortcutTwoTone");
var _shortcutTwoToneDefault = parcelHelpers.interopDefault(_shortcutTwoTone);
var _showChart = require("./ShowChart");
var _showChartDefault = parcelHelpers.interopDefault(_showChart);
var _showChartOutlined = require("./ShowChartOutlined");
var _showChartOutlinedDefault = parcelHelpers.interopDefault(_showChartOutlined);
var _showChartRounded = require("./ShowChartRounded");
var _showChartRoundedDefault = parcelHelpers.interopDefault(_showChartRounded);
var _showChartSharp = require("./ShowChartSharp");
var _showChartSharpDefault = parcelHelpers.interopDefault(_showChartSharp);
var _showChartTwoTone = require("./ShowChartTwoTone");
var _showChartTwoToneDefault = parcelHelpers.interopDefault(_showChartTwoTone);
var _shower = require("./Shower");
var _showerDefault = parcelHelpers.interopDefault(_shower);
var _showerOutlined = require("./ShowerOutlined");
var _showerOutlinedDefault = parcelHelpers.interopDefault(_showerOutlined);
var _showerRounded = require("./ShowerRounded");
var _showerRoundedDefault = parcelHelpers.interopDefault(_showerRounded);
var _showerSharp = require("./ShowerSharp");
var _showerSharpDefault = parcelHelpers.interopDefault(_showerSharp);
var _showerTwoTone = require("./ShowerTwoTone");
var _showerTwoToneDefault = parcelHelpers.interopDefault(_showerTwoTone);
var _shuffle = require("./Shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _shuffleOn = require("./ShuffleOn");
var _shuffleOnDefault = parcelHelpers.interopDefault(_shuffleOn);
var _shuffleOnOutlined = require("./ShuffleOnOutlined");
var _shuffleOnOutlinedDefault = parcelHelpers.interopDefault(_shuffleOnOutlined);
var _shuffleOnRounded = require("./ShuffleOnRounded");
var _shuffleOnRoundedDefault = parcelHelpers.interopDefault(_shuffleOnRounded);
var _shuffleOnSharp = require("./ShuffleOnSharp");
var _shuffleOnSharpDefault = parcelHelpers.interopDefault(_shuffleOnSharp);
var _shuffleOnTwoTone = require("./ShuffleOnTwoTone");
var _shuffleOnTwoToneDefault = parcelHelpers.interopDefault(_shuffleOnTwoTone);
var _shuffleOutlined = require("./ShuffleOutlined");
var _shuffleOutlinedDefault = parcelHelpers.interopDefault(_shuffleOutlined);
var _shuffleRounded = require("./ShuffleRounded");
var _shuffleRoundedDefault = parcelHelpers.interopDefault(_shuffleRounded);
var _shuffleSharp = require("./ShuffleSharp");
var _shuffleSharpDefault = parcelHelpers.interopDefault(_shuffleSharp);
var _shuffleTwoTone = require("./ShuffleTwoTone");
var _shuffleTwoToneDefault = parcelHelpers.interopDefault(_shuffleTwoTone);
var _shutterSpeed = require("./ShutterSpeed");
var _shutterSpeedDefault = parcelHelpers.interopDefault(_shutterSpeed);
var _shutterSpeedOutlined = require("./ShutterSpeedOutlined");
var _shutterSpeedOutlinedDefault = parcelHelpers.interopDefault(_shutterSpeedOutlined);
var _shutterSpeedRounded = require("./ShutterSpeedRounded");
var _shutterSpeedRoundedDefault = parcelHelpers.interopDefault(_shutterSpeedRounded);
var _shutterSpeedSharp = require("./ShutterSpeedSharp");
var _shutterSpeedSharpDefault = parcelHelpers.interopDefault(_shutterSpeedSharp);
var _shutterSpeedTwoTone = require("./ShutterSpeedTwoTone");
var _shutterSpeedTwoToneDefault = parcelHelpers.interopDefault(_shutterSpeedTwoTone);
var _sick = require("./Sick");
var _sickDefault = parcelHelpers.interopDefault(_sick);
var _sickOutlined = require("./SickOutlined");
var _sickOutlinedDefault = parcelHelpers.interopDefault(_sickOutlined);
var _sickRounded = require("./SickRounded");
var _sickRoundedDefault = parcelHelpers.interopDefault(_sickRounded);
var _sickSharp = require("./SickSharp");
var _sickSharpDefault = parcelHelpers.interopDefault(_sickSharp);
var _sickTwoTone = require("./SickTwoTone");
var _sickTwoToneDefault = parcelHelpers.interopDefault(_sickTwoTone);
var _signLanguage = require("./SignLanguage");
var _signLanguageDefault = parcelHelpers.interopDefault(_signLanguage);
var _signLanguageOutlined = require("./SignLanguageOutlined");
var _signLanguageOutlinedDefault = parcelHelpers.interopDefault(_signLanguageOutlined);
var _signLanguageRounded = require("./SignLanguageRounded");
var _signLanguageRoundedDefault = parcelHelpers.interopDefault(_signLanguageRounded);
var _signLanguageSharp = require("./SignLanguageSharp");
var _signLanguageSharpDefault = parcelHelpers.interopDefault(_signLanguageSharp);
var _signLanguageTwoTone = require("./SignLanguageTwoTone");
var _signLanguageTwoToneDefault = parcelHelpers.interopDefault(_signLanguageTwoTone);
var _signalCellular0Bar = require("./SignalCellular0Bar");
var _signalCellular0BarDefault = parcelHelpers.interopDefault(_signalCellular0Bar);
var _signalCellular0BarOutlined = require("./SignalCellular0BarOutlined");
var _signalCellular0BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellular0BarOutlined);
var _signalCellular0BarRounded = require("./SignalCellular0BarRounded");
var _signalCellular0BarRoundedDefault = parcelHelpers.interopDefault(_signalCellular0BarRounded);
var _signalCellular0BarSharp = require("./SignalCellular0BarSharp");
var _signalCellular0BarSharpDefault = parcelHelpers.interopDefault(_signalCellular0BarSharp);
var _signalCellular0BarTwoTone = require("./SignalCellular0BarTwoTone");
var _signalCellular0BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellular0BarTwoTone);
var _signalCellular1Bar = require("./SignalCellular1Bar");
var _signalCellular1BarDefault = parcelHelpers.interopDefault(_signalCellular1Bar);
var _signalCellular1BarOutlined = require("./SignalCellular1BarOutlined");
var _signalCellular1BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellular1BarOutlined);
var _signalCellular1BarRounded = require("./SignalCellular1BarRounded");
var _signalCellular1BarRoundedDefault = parcelHelpers.interopDefault(_signalCellular1BarRounded);
var _signalCellular1BarSharp = require("./SignalCellular1BarSharp");
var _signalCellular1BarSharpDefault = parcelHelpers.interopDefault(_signalCellular1BarSharp);
var _signalCellular1BarTwoTone = require("./SignalCellular1BarTwoTone");
var _signalCellular1BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellular1BarTwoTone);
var _signalCellular2Bar = require("./SignalCellular2Bar");
var _signalCellular2BarDefault = parcelHelpers.interopDefault(_signalCellular2Bar);
var _signalCellular2BarOutlined = require("./SignalCellular2BarOutlined");
var _signalCellular2BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellular2BarOutlined);
var _signalCellular2BarRounded = require("./SignalCellular2BarRounded");
var _signalCellular2BarRoundedDefault = parcelHelpers.interopDefault(_signalCellular2BarRounded);
var _signalCellular2BarSharp = require("./SignalCellular2BarSharp");
var _signalCellular2BarSharpDefault = parcelHelpers.interopDefault(_signalCellular2BarSharp);
var _signalCellular2BarTwoTone = require("./SignalCellular2BarTwoTone");
var _signalCellular2BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellular2BarTwoTone);
var _signalCellular3Bar = require("./SignalCellular3Bar");
var _signalCellular3BarDefault = parcelHelpers.interopDefault(_signalCellular3Bar);
var _signalCellular3BarOutlined = require("./SignalCellular3BarOutlined");
var _signalCellular3BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellular3BarOutlined);
var _signalCellular3BarRounded = require("./SignalCellular3BarRounded");
var _signalCellular3BarRoundedDefault = parcelHelpers.interopDefault(_signalCellular3BarRounded);
var _signalCellular3BarSharp = require("./SignalCellular3BarSharp");
var _signalCellular3BarSharpDefault = parcelHelpers.interopDefault(_signalCellular3BarSharp);
var _signalCellular3BarTwoTone = require("./SignalCellular3BarTwoTone");
var _signalCellular3BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellular3BarTwoTone);
var _signalCellular4Bar = require("./SignalCellular4Bar");
var _signalCellular4BarDefault = parcelHelpers.interopDefault(_signalCellular4Bar);
var _signalCellular4BarOutlined = require("./SignalCellular4BarOutlined");
var _signalCellular4BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellular4BarOutlined);
var _signalCellular4BarRounded = require("./SignalCellular4BarRounded");
var _signalCellular4BarRoundedDefault = parcelHelpers.interopDefault(_signalCellular4BarRounded);
var _signalCellular4BarSharp = require("./SignalCellular4BarSharp");
var _signalCellular4BarSharpDefault = parcelHelpers.interopDefault(_signalCellular4BarSharp);
var _signalCellular4BarTwoTone = require("./SignalCellular4BarTwoTone");
var _signalCellular4BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellular4BarTwoTone);
var _signalCellularAlt = require("./SignalCellularAlt");
var _signalCellularAltDefault = parcelHelpers.interopDefault(_signalCellularAlt);
var _signalCellularAlt1Bar = require("./SignalCellularAlt1Bar");
var _signalCellularAlt1BarDefault = parcelHelpers.interopDefault(_signalCellularAlt1Bar);
var _signalCellularAlt1BarOutlined = require("./SignalCellularAlt1BarOutlined");
var _signalCellularAlt1BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularAlt1BarOutlined);
var _signalCellularAlt1BarRounded = require("./SignalCellularAlt1BarRounded");
var _signalCellularAlt1BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularAlt1BarRounded);
var _signalCellularAlt1BarSharp = require("./SignalCellularAlt1BarSharp");
var _signalCellularAlt1BarSharpDefault = parcelHelpers.interopDefault(_signalCellularAlt1BarSharp);
var _signalCellularAlt1BarTwoTone = require("./SignalCellularAlt1BarTwoTone");
var _signalCellularAlt1BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularAlt1BarTwoTone);
var _signalCellularAlt2Bar = require("./SignalCellularAlt2Bar");
var _signalCellularAlt2BarDefault = parcelHelpers.interopDefault(_signalCellularAlt2Bar);
var _signalCellularAlt2BarOutlined = require("./SignalCellularAlt2BarOutlined");
var _signalCellularAlt2BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularAlt2BarOutlined);
var _signalCellularAlt2BarRounded = require("./SignalCellularAlt2BarRounded");
var _signalCellularAlt2BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularAlt2BarRounded);
var _signalCellularAlt2BarSharp = require("./SignalCellularAlt2BarSharp");
var _signalCellularAlt2BarSharpDefault = parcelHelpers.interopDefault(_signalCellularAlt2BarSharp);
var _signalCellularAlt2BarTwoTone = require("./SignalCellularAlt2BarTwoTone");
var _signalCellularAlt2BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularAlt2BarTwoTone);
var _signalCellularAltOutlined = require("./SignalCellularAltOutlined");
var _signalCellularAltOutlinedDefault = parcelHelpers.interopDefault(_signalCellularAltOutlined);
var _signalCellularAltRounded = require("./SignalCellularAltRounded");
var _signalCellularAltRoundedDefault = parcelHelpers.interopDefault(_signalCellularAltRounded);
var _signalCellularAltSharp = require("./SignalCellularAltSharp");
var _signalCellularAltSharpDefault = parcelHelpers.interopDefault(_signalCellularAltSharp);
var _signalCellularAltTwoTone = require("./SignalCellularAltTwoTone");
var _signalCellularAltTwoToneDefault = parcelHelpers.interopDefault(_signalCellularAltTwoTone);
var _signalCellularConnectedNoInternet0Bar = require("./SignalCellularConnectedNoInternet0Bar");
var _signalCellularConnectedNoInternet0BarDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet0Bar);
var _signalCellularConnectedNoInternet0BarOutlined = require("./SignalCellularConnectedNoInternet0BarOutlined");
var _signalCellularConnectedNoInternet0BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet0BarOutlined);
var _signalCellularConnectedNoInternet0BarRounded = require("./SignalCellularConnectedNoInternet0BarRounded");
var _signalCellularConnectedNoInternet0BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet0BarRounded);
var _signalCellularConnectedNoInternet0BarSharp = require("./SignalCellularConnectedNoInternet0BarSharp");
var _signalCellularConnectedNoInternet0BarSharpDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet0BarSharp);
var _signalCellularConnectedNoInternet0BarTwoTone = require("./SignalCellularConnectedNoInternet0BarTwoTone");
var _signalCellularConnectedNoInternet0BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet0BarTwoTone);
var _signalCellularConnectedNoInternet1Bar = require("./SignalCellularConnectedNoInternet1Bar");
var _signalCellularConnectedNoInternet1BarDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet1Bar);
var _signalCellularConnectedNoInternet1BarOutlined = require("./SignalCellularConnectedNoInternet1BarOutlined");
var _signalCellularConnectedNoInternet1BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet1BarOutlined);
var _signalCellularConnectedNoInternet1BarRounded = require("./SignalCellularConnectedNoInternet1BarRounded");
var _signalCellularConnectedNoInternet1BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet1BarRounded);
var _signalCellularConnectedNoInternet1BarSharp = require("./SignalCellularConnectedNoInternet1BarSharp");
var _signalCellularConnectedNoInternet1BarSharpDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet1BarSharp);
var _signalCellularConnectedNoInternet1BarTwoTone = require("./SignalCellularConnectedNoInternet1BarTwoTone");
var _signalCellularConnectedNoInternet1BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet1BarTwoTone);
var _signalCellularConnectedNoInternet2Bar = require("./SignalCellularConnectedNoInternet2Bar");
var _signalCellularConnectedNoInternet2BarDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet2Bar);
var _signalCellularConnectedNoInternet2BarOutlined = require("./SignalCellularConnectedNoInternet2BarOutlined");
var _signalCellularConnectedNoInternet2BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet2BarOutlined);
var _signalCellularConnectedNoInternet2BarRounded = require("./SignalCellularConnectedNoInternet2BarRounded");
var _signalCellularConnectedNoInternet2BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet2BarRounded);
var _signalCellularConnectedNoInternet2BarSharp = require("./SignalCellularConnectedNoInternet2BarSharp");
var _signalCellularConnectedNoInternet2BarSharpDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet2BarSharp);
var _signalCellularConnectedNoInternet2BarTwoTone = require("./SignalCellularConnectedNoInternet2BarTwoTone");
var _signalCellularConnectedNoInternet2BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet2BarTwoTone);
var _signalCellularConnectedNoInternet3Bar = require("./SignalCellularConnectedNoInternet3Bar");
var _signalCellularConnectedNoInternet3BarDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet3Bar);
var _signalCellularConnectedNoInternet3BarOutlined = require("./SignalCellularConnectedNoInternet3BarOutlined");
var _signalCellularConnectedNoInternet3BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet3BarOutlined);
var _signalCellularConnectedNoInternet3BarRounded = require("./SignalCellularConnectedNoInternet3BarRounded");
var _signalCellularConnectedNoInternet3BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet3BarRounded);
var _signalCellularConnectedNoInternet3BarSharp = require("./SignalCellularConnectedNoInternet3BarSharp");
var _signalCellularConnectedNoInternet3BarSharpDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet3BarSharp);
var _signalCellularConnectedNoInternet3BarTwoTone = require("./SignalCellularConnectedNoInternet3BarTwoTone");
var _signalCellularConnectedNoInternet3BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet3BarTwoTone);
var _signalCellularConnectedNoInternet4Bar = require("./SignalCellularConnectedNoInternet4Bar");
var _signalCellularConnectedNoInternet4BarDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet4Bar);
var _signalCellularConnectedNoInternet4BarOutlined = require("./SignalCellularConnectedNoInternet4BarOutlined");
var _signalCellularConnectedNoInternet4BarOutlinedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet4BarOutlined);
var _signalCellularConnectedNoInternet4BarRounded = require("./SignalCellularConnectedNoInternet4BarRounded");
var _signalCellularConnectedNoInternet4BarRoundedDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet4BarRounded);
var _signalCellularConnectedNoInternet4BarSharp = require("./SignalCellularConnectedNoInternet4BarSharp");
var _signalCellularConnectedNoInternet4BarSharpDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet4BarSharp);
var _signalCellularConnectedNoInternet4BarTwoTone = require("./SignalCellularConnectedNoInternet4BarTwoTone");
var _signalCellularConnectedNoInternet4BarTwoToneDefault = parcelHelpers.interopDefault(_signalCellularConnectedNoInternet4BarTwoTone);
var _signalCellularNoSim = require("./SignalCellularNoSim");
var _signalCellularNoSimDefault = parcelHelpers.interopDefault(_signalCellularNoSim);
var _signalCellularNoSimOutlined = require("./SignalCellularNoSimOutlined");
var _signalCellularNoSimOutlinedDefault = parcelHelpers.interopDefault(_signalCellularNoSimOutlined);
var _signalCellularNoSimRounded = require("./SignalCellularNoSimRounded");
var _signalCellularNoSimRoundedDefault = parcelHelpers.interopDefault(_signalCellularNoSimRounded);
var _signalCellularNoSimSharp = require("./SignalCellularNoSimSharp");
var _signalCellularNoSimSharpDefault = parcelHelpers.interopDefault(_signalCellularNoSimSharp);
var _signalCellularNoSimTwoTone = require("./SignalCellularNoSimTwoTone");
var _signalCellularNoSimTwoToneDefault = parcelHelpers.interopDefault(_signalCellularNoSimTwoTone);
var _signalCellularNodata = require("./SignalCellularNodata");
var _signalCellularNodataDefault = parcelHelpers.interopDefault(_signalCellularNodata);
var _signalCellularNodataOutlined = require("./SignalCellularNodataOutlined");
var _signalCellularNodataOutlinedDefault = parcelHelpers.interopDefault(_signalCellularNodataOutlined);
var _signalCellularNodataRounded = require("./SignalCellularNodataRounded");
var _signalCellularNodataRoundedDefault = parcelHelpers.interopDefault(_signalCellularNodataRounded);
var _signalCellularNodataSharp = require("./SignalCellularNodataSharp");
var _signalCellularNodataSharpDefault = parcelHelpers.interopDefault(_signalCellularNodataSharp);
var _signalCellularNodataTwoTone = require("./SignalCellularNodataTwoTone");
var _signalCellularNodataTwoToneDefault = parcelHelpers.interopDefault(_signalCellularNodataTwoTone);
var _signalCellularNull = require("./SignalCellularNull");
var _signalCellularNullDefault = parcelHelpers.interopDefault(_signalCellularNull);
var _signalCellularNullOutlined = require("./SignalCellularNullOutlined");
var _signalCellularNullOutlinedDefault = parcelHelpers.interopDefault(_signalCellularNullOutlined);
var _signalCellularNullRounded = require("./SignalCellularNullRounded");
var _signalCellularNullRoundedDefault = parcelHelpers.interopDefault(_signalCellularNullRounded);
var _signalCellularNullSharp = require("./SignalCellularNullSharp");
var _signalCellularNullSharpDefault = parcelHelpers.interopDefault(_signalCellularNullSharp);
var _signalCellularNullTwoTone = require("./SignalCellularNullTwoTone");
var _signalCellularNullTwoToneDefault = parcelHelpers.interopDefault(_signalCellularNullTwoTone);
var _signalCellularOff = require("./SignalCellularOff");
var _signalCellularOffDefault = parcelHelpers.interopDefault(_signalCellularOff);
var _signalCellularOffOutlined = require("./SignalCellularOffOutlined");
var _signalCellularOffOutlinedDefault = parcelHelpers.interopDefault(_signalCellularOffOutlined);
var _signalCellularOffRounded = require("./SignalCellularOffRounded");
var _signalCellularOffRoundedDefault = parcelHelpers.interopDefault(_signalCellularOffRounded);
var _signalCellularOffSharp = require("./SignalCellularOffSharp");
var _signalCellularOffSharpDefault = parcelHelpers.interopDefault(_signalCellularOffSharp);
var _signalCellularOffTwoTone = require("./SignalCellularOffTwoTone");
var _signalCellularOffTwoToneDefault = parcelHelpers.interopDefault(_signalCellularOffTwoTone);
var _signalWifi0Bar = require("./SignalWifi0Bar");
var _signalWifi0BarDefault = parcelHelpers.interopDefault(_signalWifi0Bar);
var _signalWifi0BarOutlined = require("./SignalWifi0BarOutlined");
var _signalWifi0BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifi0BarOutlined);
var _signalWifi0BarRounded = require("./SignalWifi0BarRounded");
var _signalWifi0BarRoundedDefault = parcelHelpers.interopDefault(_signalWifi0BarRounded);
var _signalWifi0BarSharp = require("./SignalWifi0BarSharp");
var _signalWifi0BarSharpDefault = parcelHelpers.interopDefault(_signalWifi0BarSharp);
var _signalWifi0BarTwoTone = require("./SignalWifi0BarTwoTone");
var _signalWifi0BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifi0BarTwoTone);
var _signalWifi1Bar = require("./SignalWifi1Bar");
var _signalWifi1BarDefault = parcelHelpers.interopDefault(_signalWifi1Bar);
var _signalWifi1BarLock = require("./SignalWifi1BarLock");
var _signalWifi1BarLockDefault = parcelHelpers.interopDefault(_signalWifi1BarLock);
var _signalWifi1BarLockOutlined = require("./SignalWifi1BarLockOutlined");
var _signalWifi1BarLockOutlinedDefault = parcelHelpers.interopDefault(_signalWifi1BarLockOutlined);
var _signalWifi1BarLockRounded = require("./SignalWifi1BarLockRounded");
var _signalWifi1BarLockRoundedDefault = parcelHelpers.interopDefault(_signalWifi1BarLockRounded);
var _signalWifi1BarLockSharp = require("./SignalWifi1BarLockSharp");
var _signalWifi1BarLockSharpDefault = parcelHelpers.interopDefault(_signalWifi1BarLockSharp);
var _signalWifi1BarLockTwoTone = require("./SignalWifi1BarLockTwoTone");
var _signalWifi1BarLockTwoToneDefault = parcelHelpers.interopDefault(_signalWifi1BarLockTwoTone);
var _signalWifi1BarOutlined = require("./SignalWifi1BarOutlined");
var _signalWifi1BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifi1BarOutlined);
var _signalWifi1BarRounded = require("./SignalWifi1BarRounded");
var _signalWifi1BarRoundedDefault = parcelHelpers.interopDefault(_signalWifi1BarRounded);
var _signalWifi1BarSharp = require("./SignalWifi1BarSharp");
var _signalWifi1BarSharpDefault = parcelHelpers.interopDefault(_signalWifi1BarSharp);
var _signalWifi1BarTwoTone = require("./SignalWifi1BarTwoTone");
var _signalWifi1BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifi1BarTwoTone);
var _signalWifi2Bar = require("./SignalWifi2Bar");
var _signalWifi2BarDefault = parcelHelpers.interopDefault(_signalWifi2Bar);
var _signalWifi2BarLock = require("./SignalWifi2BarLock");
var _signalWifi2BarLockDefault = parcelHelpers.interopDefault(_signalWifi2BarLock);
var _signalWifi2BarLockOutlined = require("./SignalWifi2BarLockOutlined");
var _signalWifi2BarLockOutlinedDefault = parcelHelpers.interopDefault(_signalWifi2BarLockOutlined);
var _signalWifi2BarLockRounded = require("./SignalWifi2BarLockRounded");
var _signalWifi2BarLockRoundedDefault = parcelHelpers.interopDefault(_signalWifi2BarLockRounded);
var _signalWifi2BarLockSharp = require("./SignalWifi2BarLockSharp");
var _signalWifi2BarLockSharpDefault = parcelHelpers.interopDefault(_signalWifi2BarLockSharp);
var _signalWifi2BarLockTwoTone = require("./SignalWifi2BarLockTwoTone");
var _signalWifi2BarLockTwoToneDefault = parcelHelpers.interopDefault(_signalWifi2BarLockTwoTone);
var _signalWifi2BarOutlined = require("./SignalWifi2BarOutlined");
var _signalWifi2BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifi2BarOutlined);
var _signalWifi2BarRounded = require("./SignalWifi2BarRounded");
var _signalWifi2BarRoundedDefault = parcelHelpers.interopDefault(_signalWifi2BarRounded);
var _signalWifi2BarSharp = require("./SignalWifi2BarSharp");
var _signalWifi2BarSharpDefault = parcelHelpers.interopDefault(_signalWifi2BarSharp);
var _signalWifi2BarTwoTone = require("./SignalWifi2BarTwoTone");
var _signalWifi2BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifi2BarTwoTone);
var _signalWifi3Bar = require("./SignalWifi3Bar");
var _signalWifi3BarDefault = parcelHelpers.interopDefault(_signalWifi3Bar);
var _signalWifi3BarLock = require("./SignalWifi3BarLock");
var _signalWifi3BarLockDefault = parcelHelpers.interopDefault(_signalWifi3BarLock);
var _signalWifi3BarLockOutlined = require("./SignalWifi3BarLockOutlined");
var _signalWifi3BarLockOutlinedDefault = parcelHelpers.interopDefault(_signalWifi3BarLockOutlined);
var _signalWifi3BarLockRounded = require("./SignalWifi3BarLockRounded");
var _signalWifi3BarLockRoundedDefault = parcelHelpers.interopDefault(_signalWifi3BarLockRounded);
var _signalWifi3BarLockSharp = require("./SignalWifi3BarLockSharp");
var _signalWifi3BarLockSharpDefault = parcelHelpers.interopDefault(_signalWifi3BarLockSharp);
var _signalWifi3BarLockTwoTone = require("./SignalWifi3BarLockTwoTone");
var _signalWifi3BarLockTwoToneDefault = parcelHelpers.interopDefault(_signalWifi3BarLockTwoTone);
var _signalWifi3BarOutlined = require("./SignalWifi3BarOutlined");
var _signalWifi3BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifi3BarOutlined);
var _signalWifi3BarRounded = require("./SignalWifi3BarRounded");
var _signalWifi3BarRoundedDefault = parcelHelpers.interopDefault(_signalWifi3BarRounded);
var _signalWifi3BarSharp = require("./SignalWifi3BarSharp");
var _signalWifi3BarSharpDefault = parcelHelpers.interopDefault(_signalWifi3BarSharp);
var _signalWifi3BarTwoTone = require("./SignalWifi3BarTwoTone");
var _signalWifi3BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifi3BarTwoTone);
var _signalWifi4Bar = require("./SignalWifi4Bar");
var _signalWifi4BarDefault = parcelHelpers.interopDefault(_signalWifi4Bar);
var _signalWifi4BarLock = require("./SignalWifi4BarLock");
var _signalWifi4BarLockDefault = parcelHelpers.interopDefault(_signalWifi4BarLock);
var _signalWifi4BarLockOutlined = require("./SignalWifi4BarLockOutlined");
var _signalWifi4BarLockOutlinedDefault = parcelHelpers.interopDefault(_signalWifi4BarLockOutlined);
var _signalWifi4BarLockRounded = require("./SignalWifi4BarLockRounded");
var _signalWifi4BarLockRoundedDefault = parcelHelpers.interopDefault(_signalWifi4BarLockRounded);
var _signalWifi4BarLockSharp = require("./SignalWifi4BarLockSharp");
var _signalWifi4BarLockSharpDefault = parcelHelpers.interopDefault(_signalWifi4BarLockSharp);
var _signalWifi4BarLockTwoTone = require("./SignalWifi4BarLockTwoTone");
var _signalWifi4BarLockTwoToneDefault = parcelHelpers.interopDefault(_signalWifi4BarLockTwoTone);
var _signalWifi4BarOutlined = require("./SignalWifi4BarOutlined");
var _signalWifi4BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifi4BarOutlined);
var _signalWifi4BarRounded = require("./SignalWifi4BarRounded");
var _signalWifi4BarRoundedDefault = parcelHelpers.interopDefault(_signalWifi4BarRounded);
var _signalWifi4BarSharp = require("./SignalWifi4BarSharp");
var _signalWifi4BarSharpDefault = parcelHelpers.interopDefault(_signalWifi4BarSharp);
var _signalWifi4BarTwoTone = require("./SignalWifi4BarTwoTone");
var _signalWifi4BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifi4BarTwoTone);
var _signalWifiBad = require("./SignalWifiBad");
var _signalWifiBadDefault = parcelHelpers.interopDefault(_signalWifiBad);
var _signalWifiBadOutlined = require("./SignalWifiBadOutlined");
var _signalWifiBadOutlinedDefault = parcelHelpers.interopDefault(_signalWifiBadOutlined);
var _signalWifiBadRounded = require("./SignalWifiBadRounded");
var _signalWifiBadRoundedDefault = parcelHelpers.interopDefault(_signalWifiBadRounded);
var _signalWifiBadSharp = require("./SignalWifiBadSharp");
var _signalWifiBadSharpDefault = parcelHelpers.interopDefault(_signalWifiBadSharp);
var _signalWifiBadTwoTone = require("./SignalWifiBadTwoTone");
var _signalWifiBadTwoToneDefault = parcelHelpers.interopDefault(_signalWifiBadTwoTone);
var _signalWifiConnectedNoInternet4 = require("./SignalWifiConnectedNoInternet4");
var _signalWifiConnectedNoInternet4Default = parcelHelpers.interopDefault(_signalWifiConnectedNoInternet4);
var _signalWifiConnectedNoInternet4Outlined = require("./SignalWifiConnectedNoInternet4Outlined");
var _signalWifiConnectedNoInternet4OutlinedDefault = parcelHelpers.interopDefault(_signalWifiConnectedNoInternet4Outlined);
var _signalWifiConnectedNoInternet4Rounded = require("./SignalWifiConnectedNoInternet4Rounded");
var _signalWifiConnectedNoInternet4RoundedDefault = parcelHelpers.interopDefault(_signalWifiConnectedNoInternet4Rounded);
var _signalWifiConnectedNoInternet4Sharp = require("./SignalWifiConnectedNoInternet4Sharp");
var _signalWifiConnectedNoInternet4SharpDefault = parcelHelpers.interopDefault(_signalWifiConnectedNoInternet4Sharp);
var _signalWifiConnectedNoInternet4TwoTone = require("./SignalWifiConnectedNoInternet4TwoTone");
var _signalWifiConnectedNoInternet4TwoToneDefault = parcelHelpers.interopDefault(_signalWifiConnectedNoInternet4TwoTone);
var _signalWifiOff = require("./SignalWifiOff");
var _signalWifiOffDefault = parcelHelpers.interopDefault(_signalWifiOff);
var _signalWifiOffOutlined = require("./SignalWifiOffOutlined");
var _signalWifiOffOutlinedDefault = parcelHelpers.interopDefault(_signalWifiOffOutlined);
var _signalWifiOffRounded = require("./SignalWifiOffRounded");
var _signalWifiOffRoundedDefault = parcelHelpers.interopDefault(_signalWifiOffRounded);
var _signalWifiOffSharp = require("./SignalWifiOffSharp");
var _signalWifiOffSharpDefault = parcelHelpers.interopDefault(_signalWifiOffSharp);
var _signalWifiOffTwoTone = require("./SignalWifiOffTwoTone");
var _signalWifiOffTwoToneDefault = parcelHelpers.interopDefault(_signalWifiOffTwoTone);
var _signalWifiStatusbar4Bar = require("./SignalWifiStatusbar4Bar");
var _signalWifiStatusbar4BarDefault = parcelHelpers.interopDefault(_signalWifiStatusbar4Bar);
var _signalWifiStatusbar4BarOutlined = require("./SignalWifiStatusbar4BarOutlined");
var _signalWifiStatusbar4BarOutlinedDefault = parcelHelpers.interopDefault(_signalWifiStatusbar4BarOutlined);
var _signalWifiStatusbar4BarRounded = require("./SignalWifiStatusbar4BarRounded");
var _signalWifiStatusbar4BarRoundedDefault = parcelHelpers.interopDefault(_signalWifiStatusbar4BarRounded);
var _signalWifiStatusbar4BarSharp = require("./SignalWifiStatusbar4BarSharp");
var _signalWifiStatusbar4BarSharpDefault = parcelHelpers.interopDefault(_signalWifiStatusbar4BarSharp);
var _signalWifiStatusbar4BarTwoTone = require("./SignalWifiStatusbar4BarTwoTone");
var _signalWifiStatusbar4BarTwoToneDefault = parcelHelpers.interopDefault(_signalWifiStatusbar4BarTwoTone);
var _signalWifiStatusbarConnectedNoInternet4 = require("./SignalWifiStatusbarConnectedNoInternet4");
var _signalWifiStatusbarConnectedNoInternet4Default = parcelHelpers.interopDefault(_signalWifiStatusbarConnectedNoInternet4);
var _signalWifiStatusbarConnectedNoInternet4Outlined = require("./SignalWifiStatusbarConnectedNoInternet4Outlined");
var _signalWifiStatusbarConnectedNoInternet4OutlinedDefault = parcelHelpers.interopDefault(_signalWifiStatusbarConnectedNoInternet4Outlined);
var _signalWifiStatusbarConnectedNoInternet4Rounded = require("./SignalWifiStatusbarConnectedNoInternet4Rounded");
var _signalWifiStatusbarConnectedNoInternet4RoundedDefault = parcelHelpers.interopDefault(_signalWifiStatusbarConnectedNoInternet4Rounded);
var _signalWifiStatusbarConnectedNoInternet4Sharp = require("./SignalWifiStatusbarConnectedNoInternet4Sharp");
var _signalWifiStatusbarConnectedNoInternet4SharpDefault = parcelHelpers.interopDefault(_signalWifiStatusbarConnectedNoInternet4Sharp);
var _signalWifiStatusbarConnectedNoInternet4TwoTone = require("./SignalWifiStatusbarConnectedNoInternet4TwoTone");
var _signalWifiStatusbarConnectedNoInternet4TwoToneDefault = parcelHelpers.interopDefault(_signalWifiStatusbarConnectedNoInternet4TwoTone);
var _signalWifiStatusbarNull = require("./SignalWifiStatusbarNull");
var _signalWifiStatusbarNullDefault = parcelHelpers.interopDefault(_signalWifiStatusbarNull);
var _signalWifiStatusbarNullOutlined = require("./SignalWifiStatusbarNullOutlined");
var _signalWifiStatusbarNullOutlinedDefault = parcelHelpers.interopDefault(_signalWifiStatusbarNullOutlined);
var _signalWifiStatusbarNullRounded = require("./SignalWifiStatusbarNullRounded");
var _signalWifiStatusbarNullRoundedDefault = parcelHelpers.interopDefault(_signalWifiStatusbarNullRounded);
var _signalWifiStatusbarNullSharp = require("./SignalWifiStatusbarNullSharp");
var _signalWifiStatusbarNullSharpDefault = parcelHelpers.interopDefault(_signalWifiStatusbarNullSharp);
var _signalWifiStatusbarNullTwoTone = require("./SignalWifiStatusbarNullTwoTone");
var _signalWifiStatusbarNullTwoToneDefault = parcelHelpers.interopDefault(_signalWifiStatusbarNullTwoTone);
var _signpost = require("./Signpost");
var _signpostDefault = parcelHelpers.interopDefault(_signpost);
var _signpostOutlined = require("./SignpostOutlined");
var _signpostOutlinedDefault = parcelHelpers.interopDefault(_signpostOutlined);
var _signpostRounded = require("./SignpostRounded");
var _signpostRoundedDefault = parcelHelpers.interopDefault(_signpostRounded);
var _signpostSharp = require("./SignpostSharp");
var _signpostSharpDefault = parcelHelpers.interopDefault(_signpostSharp);
var _signpostTwoTone = require("./SignpostTwoTone");
var _signpostTwoToneDefault = parcelHelpers.interopDefault(_signpostTwoTone);
var _simCard = require("./SimCard");
var _simCardDefault = parcelHelpers.interopDefault(_simCard);
var _simCardAlert = require("./SimCardAlert");
var _simCardAlertDefault = parcelHelpers.interopDefault(_simCardAlert);
var _simCardAlertOutlined = require("./SimCardAlertOutlined");
var _simCardAlertOutlinedDefault = parcelHelpers.interopDefault(_simCardAlertOutlined);
var _simCardAlertRounded = require("./SimCardAlertRounded");
var _simCardAlertRoundedDefault = parcelHelpers.interopDefault(_simCardAlertRounded);
var _simCardAlertSharp = require("./SimCardAlertSharp");
var _simCardAlertSharpDefault = parcelHelpers.interopDefault(_simCardAlertSharp);
var _simCardAlertTwoTone = require("./SimCardAlertTwoTone");
var _simCardAlertTwoToneDefault = parcelHelpers.interopDefault(_simCardAlertTwoTone);
var _simCardDownload = require("./SimCardDownload");
var _simCardDownloadDefault = parcelHelpers.interopDefault(_simCardDownload);
var _simCardDownloadOutlined = require("./SimCardDownloadOutlined");
var _simCardDownloadOutlinedDefault = parcelHelpers.interopDefault(_simCardDownloadOutlined);
var _simCardDownloadRounded = require("./SimCardDownloadRounded");
var _simCardDownloadRoundedDefault = parcelHelpers.interopDefault(_simCardDownloadRounded);
var _simCardDownloadSharp = require("./SimCardDownloadSharp");
var _simCardDownloadSharpDefault = parcelHelpers.interopDefault(_simCardDownloadSharp);
var _simCardDownloadTwoTone = require("./SimCardDownloadTwoTone");
var _simCardDownloadTwoToneDefault = parcelHelpers.interopDefault(_simCardDownloadTwoTone);
var _simCardOutlined = require("./SimCardOutlined");
var _simCardOutlinedDefault = parcelHelpers.interopDefault(_simCardOutlined);
var _simCardRounded = require("./SimCardRounded");
var _simCardRoundedDefault = parcelHelpers.interopDefault(_simCardRounded);
var _simCardSharp = require("./SimCardSharp");
var _simCardSharpDefault = parcelHelpers.interopDefault(_simCardSharp);
var _simCardTwoTone = require("./SimCardTwoTone");
var _simCardTwoToneDefault = parcelHelpers.interopDefault(_simCardTwoTone);
var _singleBed = require("./SingleBed");
var _singleBedDefault = parcelHelpers.interopDefault(_singleBed);
var _singleBedOutlined = require("./SingleBedOutlined");
var _singleBedOutlinedDefault = parcelHelpers.interopDefault(_singleBedOutlined);
var _singleBedRounded = require("./SingleBedRounded");
var _singleBedRoundedDefault = parcelHelpers.interopDefault(_singleBedRounded);
var _singleBedSharp = require("./SingleBedSharp");
var _singleBedSharpDefault = parcelHelpers.interopDefault(_singleBedSharp);
var _singleBedTwoTone = require("./SingleBedTwoTone");
var _singleBedTwoToneDefault = parcelHelpers.interopDefault(_singleBedTwoTone);
var _sip = require("./Sip");
var _sipDefault = parcelHelpers.interopDefault(_sip);
var _sipOutlined = require("./SipOutlined");
var _sipOutlinedDefault = parcelHelpers.interopDefault(_sipOutlined);
var _sipRounded = require("./SipRounded");
var _sipRoundedDefault = parcelHelpers.interopDefault(_sipRounded);
var _sipSharp = require("./SipSharp");
var _sipSharpDefault = parcelHelpers.interopDefault(_sipSharp);
var _sipTwoTone = require("./SipTwoTone");
var _sipTwoToneDefault = parcelHelpers.interopDefault(_sipTwoTone);
var _sixK = require("./SixK");
var _sixKDefault = parcelHelpers.interopDefault(_sixK);
var _sixKOutlined = require("./SixKOutlined");
var _sixKOutlinedDefault = parcelHelpers.interopDefault(_sixKOutlined);
var _sixKPlus = require("./SixKPlus");
var _sixKPlusDefault = parcelHelpers.interopDefault(_sixKPlus);
var _sixKPlusOutlined = require("./SixKPlusOutlined");
var _sixKPlusOutlinedDefault = parcelHelpers.interopDefault(_sixKPlusOutlined);
var _sixKPlusRounded = require("./SixKPlusRounded");
var _sixKPlusRoundedDefault = parcelHelpers.interopDefault(_sixKPlusRounded);
var _sixKPlusSharp = require("./SixKPlusSharp");
var _sixKPlusSharpDefault = parcelHelpers.interopDefault(_sixKPlusSharp);
var _sixKPlusTwoTone = require("./SixKPlusTwoTone");
var _sixKPlusTwoToneDefault = parcelHelpers.interopDefault(_sixKPlusTwoTone);
var _sixKRounded = require("./SixKRounded");
var _sixKRoundedDefault = parcelHelpers.interopDefault(_sixKRounded);
var _sixKSharp = require("./SixKSharp");
var _sixKSharpDefault = parcelHelpers.interopDefault(_sixKSharp);
var _sixKTwoTone = require("./SixKTwoTone");
var _sixKTwoToneDefault = parcelHelpers.interopDefault(_sixKTwoTone);
var _sixMp = require("./SixMp");
var _sixMpDefault = parcelHelpers.interopDefault(_sixMp);
var _sixMpOutlined = require("./SixMpOutlined");
var _sixMpOutlinedDefault = parcelHelpers.interopDefault(_sixMpOutlined);
var _sixMpRounded = require("./SixMpRounded");
var _sixMpRoundedDefault = parcelHelpers.interopDefault(_sixMpRounded);
var _sixMpSharp = require("./SixMpSharp");
var _sixMpSharpDefault = parcelHelpers.interopDefault(_sixMpSharp);
var _sixMpTwoTone = require("./SixMpTwoTone");
var _sixMpTwoToneDefault = parcelHelpers.interopDefault(_sixMpTwoTone);
var _sixteenMp = require("./SixteenMp");
var _sixteenMpDefault = parcelHelpers.interopDefault(_sixteenMp);
var _sixteenMpOutlined = require("./SixteenMpOutlined");
var _sixteenMpOutlinedDefault = parcelHelpers.interopDefault(_sixteenMpOutlined);
var _sixteenMpRounded = require("./SixteenMpRounded");
var _sixteenMpRoundedDefault = parcelHelpers.interopDefault(_sixteenMpRounded);
var _sixteenMpSharp = require("./SixteenMpSharp");
var _sixteenMpSharpDefault = parcelHelpers.interopDefault(_sixteenMpSharp);
var _sixteenMpTwoTone = require("./SixteenMpTwoTone");
var _sixteenMpTwoToneDefault = parcelHelpers.interopDefault(_sixteenMpTwoTone);
var _sixtyFps = require("./SixtyFps");
var _sixtyFpsDefault = parcelHelpers.interopDefault(_sixtyFps);
var _sixtyFpsOutlined = require("./SixtyFpsOutlined");
var _sixtyFpsOutlinedDefault = parcelHelpers.interopDefault(_sixtyFpsOutlined);
var _sixtyFpsRounded = require("./SixtyFpsRounded");
var _sixtyFpsRoundedDefault = parcelHelpers.interopDefault(_sixtyFpsRounded);
var _sixtyFpsSelect = require("./SixtyFpsSelect");
var _sixtyFpsSelectDefault = parcelHelpers.interopDefault(_sixtyFpsSelect);
var _sixtyFpsSelectOutlined = require("./SixtyFpsSelectOutlined");
var _sixtyFpsSelectOutlinedDefault = parcelHelpers.interopDefault(_sixtyFpsSelectOutlined);
var _sixtyFpsSelectRounded = require("./SixtyFpsSelectRounded");
var _sixtyFpsSelectRoundedDefault = parcelHelpers.interopDefault(_sixtyFpsSelectRounded);
var _sixtyFpsSelectSharp = require("./SixtyFpsSelectSharp");
var _sixtyFpsSelectSharpDefault = parcelHelpers.interopDefault(_sixtyFpsSelectSharp);
var _sixtyFpsSelectTwoTone = require("./SixtyFpsSelectTwoTone");
var _sixtyFpsSelectTwoToneDefault = parcelHelpers.interopDefault(_sixtyFpsSelectTwoTone);
var _sixtyFpsSharp = require("./SixtyFpsSharp");
var _sixtyFpsSharpDefault = parcelHelpers.interopDefault(_sixtyFpsSharp);
var _sixtyFpsTwoTone = require("./SixtyFpsTwoTone");
var _sixtyFpsTwoToneDefault = parcelHelpers.interopDefault(_sixtyFpsTwoTone);
var _skateboarding = require("./Skateboarding");
var _skateboardingDefault = parcelHelpers.interopDefault(_skateboarding);
var _skateboardingOutlined = require("./SkateboardingOutlined");
var _skateboardingOutlinedDefault = parcelHelpers.interopDefault(_skateboardingOutlined);
var _skateboardingRounded = require("./SkateboardingRounded");
var _skateboardingRoundedDefault = parcelHelpers.interopDefault(_skateboardingRounded);
var _skateboardingSharp = require("./SkateboardingSharp");
var _skateboardingSharpDefault = parcelHelpers.interopDefault(_skateboardingSharp);
var _skateboardingTwoTone = require("./SkateboardingTwoTone");
var _skateboardingTwoToneDefault = parcelHelpers.interopDefault(_skateboardingTwoTone);
var _skipNext = require("./SkipNext");
var _skipNextDefault = parcelHelpers.interopDefault(_skipNext);
var _skipNextOutlined = require("./SkipNextOutlined");
var _skipNextOutlinedDefault = parcelHelpers.interopDefault(_skipNextOutlined);
var _skipNextRounded = require("./SkipNextRounded");
var _skipNextRoundedDefault = parcelHelpers.interopDefault(_skipNextRounded);
var _skipNextSharp = require("./SkipNextSharp");
var _skipNextSharpDefault = parcelHelpers.interopDefault(_skipNextSharp);
var _skipNextTwoTone = require("./SkipNextTwoTone");
var _skipNextTwoToneDefault = parcelHelpers.interopDefault(_skipNextTwoTone);
var _skipPrevious = require("./SkipPrevious");
var _skipPreviousDefault = parcelHelpers.interopDefault(_skipPrevious);
var _skipPreviousOutlined = require("./SkipPreviousOutlined");
var _skipPreviousOutlinedDefault = parcelHelpers.interopDefault(_skipPreviousOutlined);
var _skipPreviousRounded = require("./SkipPreviousRounded");
var _skipPreviousRoundedDefault = parcelHelpers.interopDefault(_skipPreviousRounded);
var _skipPreviousSharp = require("./SkipPreviousSharp");
var _skipPreviousSharpDefault = parcelHelpers.interopDefault(_skipPreviousSharp);
var _skipPreviousTwoTone = require("./SkipPreviousTwoTone");
var _skipPreviousTwoToneDefault = parcelHelpers.interopDefault(_skipPreviousTwoTone);
var _sledding = require("./Sledding");
var _sleddingDefault = parcelHelpers.interopDefault(_sledding);
var _sleddingOutlined = require("./SleddingOutlined");
var _sleddingOutlinedDefault = parcelHelpers.interopDefault(_sleddingOutlined);
var _sleddingRounded = require("./SleddingRounded");
var _sleddingRoundedDefault = parcelHelpers.interopDefault(_sleddingRounded);
var _sleddingSharp = require("./SleddingSharp");
var _sleddingSharpDefault = parcelHelpers.interopDefault(_sleddingSharp);
var _sleddingTwoTone = require("./SleddingTwoTone");
var _sleddingTwoToneDefault = parcelHelpers.interopDefault(_sleddingTwoTone);
var _slideshow = require("./Slideshow");
var _slideshowDefault = parcelHelpers.interopDefault(_slideshow);
var _slideshowOutlined = require("./SlideshowOutlined");
var _slideshowOutlinedDefault = parcelHelpers.interopDefault(_slideshowOutlined);
var _slideshowRounded = require("./SlideshowRounded");
var _slideshowRoundedDefault = parcelHelpers.interopDefault(_slideshowRounded);
var _slideshowSharp = require("./SlideshowSharp");
var _slideshowSharpDefault = parcelHelpers.interopDefault(_slideshowSharp);
var _slideshowTwoTone = require("./SlideshowTwoTone");
var _slideshowTwoToneDefault = parcelHelpers.interopDefault(_slideshowTwoTone);
var _slowMotionVideo = require("./SlowMotionVideo");
var _slowMotionVideoDefault = parcelHelpers.interopDefault(_slowMotionVideo);
var _slowMotionVideoOutlined = require("./SlowMotionVideoOutlined");
var _slowMotionVideoOutlinedDefault = parcelHelpers.interopDefault(_slowMotionVideoOutlined);
var _slowMotionVideoRounded = require("./SlowMotionVideoRounded");
var _slowMotionVideoRoundedDefault = parcelHelpers.interopDefault(_slowMotionVideoRounded);
var _slowMotionVideoSharp = require("./SlowMotionVideoSharp");
var _slowMotionVideoSharpDefault = parcelHelpers.interopDefault(_slowMotionVideoSharp);
var _slowMotionVideoTwoTone = require("./SlowMotionVideoTwoTone");
var _slowMotionVideoTwoToneDefault = parcelHelpers.interopDefault(_slowMotionVideoTwoTone);
var _smartButton = require("./SmartButton");
var _smartButtonDefault = parcelHelpers.interopDefault(_smartButton);
var _smartButtonOutlined = require("./SmartButtonOutlined");
var _smartButtonOutlinedDefault = parcelHelpers.interopDefault(_smartButtonOutlined);
var _smartButtonRounded = require("./SmartButtonRounded");
var _smartButtonRoundedDefault = parcelHelpers.interopDefault(_smartButtonRounded);
var _smartButtonSharp = require("./SmartButtonSharp");
var _smartButtonSharpDefault = parcelHelpers.interopDefault(_smartButtonSharp);
var _smartButtonTwoTone = require("./SmartButtonTwoTone");
var _smartButtonTwoToneDefault = parcelHelpers.interopDefault(_smartButtonTwoTone);
var _smartDisplay = require("./SmartDisplay");
var _smartDisplayDefault = parcelHelpers.interopDefault(_smartDisplay);
var _smartDisplayOutlined = require("./SmartDisplayOutlined");
var _smartDisplayOutlinedDefault = parcelHelpers.interopDefault(_smartDisplayOutlined);
var _smartDisplayRounded = require("./SmartDisplayRounded");
var _smartDisplayRoundedDefault = parcelHelpers.interopDefault(_smartDisplayRounded);
var _smartDisplaySharp = require("./SmartDisplaySharp");
var _smartDisplaySharpDefault = parcelHelpers.interopDefault(_smartDisplaySharp);
var _smartDisplayTwoTone = require("./SmartDisplayTwoTone");
var _smartDisplayTwoToneDefault = parcelHelpers.interopDefault(_smartDisplayTwoTone);
var _smartScreen = require("./SmartScreen");
var _smartScreenDefault = parcelHelpers.interopDefault(_smartScreen);
var _smartScreenOutlined = require("./SmartScreenOutlined");
var _smartScreenOutlinedDefault = parcelHelpers.interopDefault(_smartScreenOutlined);
var _smartScreenRounded = require("./SmartScreenRounded");
var _smartScreenRoundedDefault = parcelHelpers.interopDefault(_smartScreenRounded);
var _smartScreenSharp = require("./SmartScreenSharp");
var _smartScreenSharpDefault = parcelHelpers.interopDefault(_smartScreenSharp);
var _smartScreenTwoTone = require("./SmartScreenTwoTone");
var _smartScreenTwoToneDefault = parcelHelpers.interopDefault(_smartScreenTwoTone);
var _smartToy = require("./SmartToy");
var _smartToyDefault = parcelHelpers.interopDefault(_smartToy);
var _smartToyOutlined = require("./SmartToyOutlined");
var _smartToyOutlinedDefault = parcelHelpers.interopDefault(_smartToyOutlined);
var _smartToyRounded = require("./SmartToyRounded");
var _smartToyRoundedDefault = parcelHelpers.interopDefault(_smartToyRounded);
var _smartToySharp = require("./SmartToySharp");
var _smartToySharpDefault = parcelHelpers.interopDefault(_smartToySharp);
var _smartToyTwoTone = require("./SmartToyTwoTone");
var _smartToyTwoToneDefault = parcelHelpers.interopDefault(_smartToyTwoTone);
var _smartphone = require("./Smartphone");
var _smartphoneDefault = parcelHelpers.interopDefault(_smartphone);
var _smartphoneOutlined = require("./SmartphoneOutlined");
var _smartphoneOutlinedDefault = parcelHelpers.interopDefault(_smartphoneOutlined);
var _smartphoneRounded = require("./SmartphoneRounded");
var _smartphoneRoundedDefault = parcelHelpers.interopDefault(_smartphoneRounded);
var _smartphoneSharp = require("./SmartphoneSharp");
var _smartphoneSharpDefault = parcelHelpers.interopDefault(_smartphoneSharp);
var _smartphoneTwoTone = require("./SmartphoneTwoTone");
var _smartphoneTwoToneDefault = parcelHelpers.interopDefault(_smartphoneTwoTone);
var _smokeFree = require("./SmokeFree");
var _smokeFreeDefault = parcelHelpers.interopDefault(_smokeFree);
var _smokeFreeOutlined = require("./SmokeFreeOutlined");
var _smokeFreeOutlinedDefault = parcelHelpers.interopDefault(_smokeFreeOutlined);
var _smokeFreeRounded = require("./SmokeFreeRounded");
var _smokeFreeRoundedDefault = parcelHelpers.interopDefault(_smokeFreeRounded);
var _smokeFreeSharp = require("./SmokeFreeSharp");
var _smokeFreeSharpDefault = parcelHelpers.interopDefault(_smokeFreeSharp);
var _smokeFreeTwoTone = require("./SmokeFreeTwoTone");
var _smokeFreeTwoToneDefault = parcelHelpers.interopDefault(_smokeFreeTwoTone);
var _smokingRooms = require("./SmokingRooms");
var _smokingRoomsDefault = parcelHelpers.interopDefault(_smokingRooms);
var _smokingRoomsOutlined = require("./SmokingRoomsOutlined");
var _smokingRoomsOutlinedDefault = parcelHelpers.interopDefault(_smokingRoomsOutlined);
var _smokingRoomsRounded = require("./SmokingRoomsRounded");
var _smokingRoomsRoundedDefault = parcelHelpers.interopDefault(_smokingRoomsRounded);
var _smokingRoomsSharp = require("./SmokingRoomsSharp");
var _smokingRoomsSharpDefault = parcelHelpers.interopDefault(_smokingRoomsSharp);
var _smokingRoomsTwoTone = require("./SmokingRoomsTwoTone");
var _smokingRoomsTwoToneDefault = parcelHelpers.interopDefault(_smokingRoomsTwoTone);
var _sms = require("./Sms");
var _smsDefault = parcelHelpers.interopDefault(_sms);
var _smsFailed = require("./SmsFailed");
var _smsFailedDefault = parcelHelpers.interopDefault(_smsFailed);
var _smsFailedOutlined = require("./SmsFailedOutlined");
var _smsFailedOutlinedDefault = parcelHelpers.interopDefault(_smsFailedOutlined);
var _smsFailedRounded = require("./SmsFailedRounded");
var _smsFailedRoundedDefault = parcelHelpers.interopDefault(_smsFailedRounded);
var _smsFailedSharp = require("./SmsFailedSharp");
var _smsFailedSharpDefault = parcelHelpers.interopDefault(_smsFailedSharp);
var _smsFailedTwoTone = require("./SmsFailedTwoTone");
var _smsFailedTwoToneDefault = parcelHelpers.interopDefault(_smsFailedTwoTone);
var _smsOutlined = require("./SmsOutlined");
var _smsOutlinedDefault = parcelHelpers.interopDefault(_smsOutlined);
var _smsRounded = require("./SmsRounded");
var _smsRoundedDefault = parcelHelpers.interopDefault(_smsRounded);
var _smsSharp = require("./SmsSharp");
var _smsSharpDefault = parcelHelpers.interopDefault(_smsSharp);
var _smsTwoTone = require("./SmsTwoTone");
var _smsTwoToneDefault = parcelHelpers.interopDefault(_smsTwoTone);
var _snippetFolder = require("./SnippetFolder");
var _snippetFolderDefault = parcelHelpers.interopDefault(_snippetFolder);
var _snippetFolderOutlined = require("./SnippetFolderOutlined");
var _snippetFolderOutlinedDefault = parcelHelpers.interopDefault(_snippetFolderOutlined);
var _snippetFolderRounded = require("./SnippetFolderRounded");
var _snippetFolderRoundedDefault = parcelHelpers.interopDefault(_snippetFolderRounded);
var _snippetFolderSharp = require("./SnippetFolderSharp");
var _snippetFolderSharpDefault = parcelHelpers.interopDefault(_snippetFolderSharp);
var _snippetFolderTwoTone = require("./SnippetFolderTwoTone");
var _snippetFolderTwoToneDefault = parcelHelpers.interopDefault(_snippetFolderTwoTone);
var _snooze = require("./Snooze");
var _snoozeDefault = parcelHelpers.interopDefault(_snooze);
var _snoozeOutlined = require("./SnoozeOutlined");
var _snoozeOutlinedDefault = parcelHelpers.interopDefault(_snoozeOutlined);
var _snoozeRounded = require("./SnoozeRounded");
var _snoozeRoundedDefault = parcelHelpers.interopDefault(_snoozeRounded);
var _snoozeSharp = require("./SnoozeSharp");
var _snoozeSharpDefault = parcelHelpers.interopDefault(_snoozeSharp);
var _snoozeTwoTone = require("./SnoozeTwoTone");
var _snoozeTwoToneDefault = parcelHelpers.interopDefault(_snoozeTwoTone);
var _snowboarding = require("./Snowboarding");
var _snowboardingDefault = parcelHelpers.interopDefault(_snowboarding);
var _snowboardingOutlined = require("./SnowboardingOutlined");
var _snowboardingOutlinedDefault = parcelHelpers.interopDefault(_snowboardingOutlined);
var _snowboardingRounded = require("./SnowboardingRounded");
var _snowboardingRoundedDefault = parcelHelpers.interopDefault(_snowboardingRounded);
var _snowboardingSharp = require("./SnowboardingSharp");
var _snowboardingSharpDefault = parcelHelpers.interopDefault(_snowboardingSharp);
var _snowboardingTwoTone = require("./SnowboardingTwoTone");
var _snowboardingTwoToneDefault = parcelHelpers.interopDefault(_snowboardingTwoTone);
var _snowmobile = require("./Snowmobile");
var _snowmobileDefault = parcelHelpers.interopDefault(_snowmobile);
var _snowmobileOutlined = require("./SnowmobileOutlined");
var _snowmobileOutlinedDefault = parcelHelpers.interopDefault(_snowmobileOutlined);
var _snowmobileRounded = require("./SnowmobileRounded");
var _snowmobileRoundedDefault = parcelHelpers.interopDefault(_snowmobileRounded);
var _snowmobileSharp = require("./SnowmobileSharp");
var _snowmobileSharpDefault = parcelHelpers.interopDefault(_snowmobileSharp);
var _snowmobileTwoTone = require("./SnowmobileTwoTone");
var _snowmobileTwoToneDefault = parcelHelpers.interopDefault(_snowmobileTwoTone);
var _snowshoeing = require("./Snowshoeing");
var _snowshoeingDefault = parcelHelpers.interopDefault(_snowshoeing);
var _snowshoeingOutlined = require("./SnowshoeingOutlined");
var _snowshoeingOutlinedDefault = parcelHelpers.interopDefault(_snowshoeingOutlined);
var _snowshoeingRounded = require("./SnowshoeingRounded");
var _snowshoeingRoundedDefault = parcelHelpers.interopDefault(_snowshoeingRounded);
var _snowshoeingSharp = require("./SnowshoeingSharp");
var _snowshoeingSharpDefault = parcelHelpers.interopDefault(_snowshoeingSharp);
var _snowshoeingTwoTone = require("./SnowshoeingTwoTone");
var _snowshoeingTwoToneDefault = parcelHelpers.interopDefault(_snowshoeingTwoTone);
var _soap = require("./Soap");
var _soapDefault = parcelHelpers.interopDefault(_soap);
var _soapOutlined = require("./SoapOutlined");
var _soapOutlinedDefault = parcelHelpers.interopDefault(_soapOutlined);
var _soapRounded = require("./SoapRounded");
var _soapRoundedDefault = parcelHelpers.interopDefault(_soapRounded);
var _soapSharp = require("./SoapSharp");
var _soapSharpDefault = parcelHelpers.interopDefault(_soapSharp);
var _soapTwoTone = require("./SoapTwoTone");
var _soapTwoToneDefault = parcelHelpers.interopDefault(_soapTwoTone);
var _socialDistance = require("./SocialDistance");
var _socialDistanceDefault = parcelHelpers.interopDefault(_socialDistance);
var _socialDistanceOutlined = require("./SocialDistanceOutlined");
var _socialDistanceOutlinedDefault = parcelHelpers.interopDefault(_socialDistanceOutlined);
var _socialDistanceRounded = require("./SocialDistanceRounded");
var _socialDistanceRoundedDefault = parcelHelpers.interopDefault(_socialDistanceRounded);
var _socialDistanceSharp = require("./SocialDistanceSharp");
var _socialDistanceSharpDefault = parcelHelpers.interopDefault(_socialDistanceSharp);
var _socialDistanceTwoTone = require("./SocialDistanceTwoTone");
var _socialDistanceTwoToneDefault = parcelHelpers.interopDefault(_socialDistanceTwoTone);
var _solarPower = require("./SolarPower");
var _solarPowerDefault = parcelHelpers.interopDefault(_solarPower);
var _solarPowerOutlined = require("./SolarPowerOutlined");
var _solarPowerOutlinedDefault = parcelHelpers.interopDefault(_solarPowerOutlined);
var _solarPowerRounded = require("./SolarPowerRounded");
var _solarPowerRoundedDefault = parcelHelpers.interopDefault(_solarPowerRounded);
var _solarPowerSharp = require("./SolarPowerSharp");
var _solarPowerSharpDefault = parcelHelpers.interopDefault(_solarPowerSharp);
var _solarPowerTwoTone = require("./SolarPowerTwoTone");
var _solarPowerTwoToneDefault = parcelHelpers.interopDefault(_solarPowerTwoTone);
var _sort = require("./Sort");
var _sortDefault = parcelHelpers.interopDefault(_sort);
var _sortByAlpha = require("./SortByAlpha");
var _sortByAlphaDefault = parcelHelpers.interopDefault(_sortByAlpha);
var _sortByAlphaOutlined = require("./SortByAlphaOutlined");
var _sortByAlphaOutlinedDefault = parcelHelpers.interopDefault(_sortByAlphaOutlined);
var _sortByAlphaRounded = require("./SortByAlphaRounded");
var _sortByAlphaRoundedDefault = parcelHelpers.interopDefault(_sortByAlphaRounded);
var _sortByAlphaSharp = require("./SortByAlphaSharp");
var _sortByAlphaSharpDefault = parcelHelpers.interopDefault(_sortByAlphaSharp);
var _sortByAlphaTwoTone = require("./SortByAlphaTwoTone");
var _sortByAlphaTwoToneDefault = parcelHelpers.interopDefault(_sortByAlphaTwoTone);
var _sortOutlined = require("./SortOutlined");
var _sortOutlinedDefault = parcelHelpers.interopDefault(_sortOutlined);
var _sortRounded = require("./SortRounded");
var _sortRoundedDefault = parcelHelpers.interopDefault(_sortRounded);
var _sortSharp = require("./SortSharp");
var _sortSharpDefault = parcelHelpers.interopDefault(_sortSharp);
var _sortTwoTone = require("./SortTwoTone");
var _sortTwoToneDefault = parcelHelpers.interopDefault(_sortTwoTone);
var _sos = require("./Sos");
var _sosDefault = parcelHelpers.interopDefault(_sos);
var _sosOutlined = require("./SosOutlined");
var _sosOutlinedDefault = parcelHelpers.interopDefault(_sosOutlined);
var _sosRounded = require("./SosRounded");
var _sosRoundedDefault = parcelHelpers.interopDefault(_sosRounded);
var _sosSharp = require("./SosSharp");
var _sosSharpDefault = parcelHelpers.interopDefault(_sosSharp);
var _sosTwoTone = require("./SosTwoTone");
var _sosTwoToneDefault = parcelHelpers.interopDefault(_sosTwoTone);
var _soupKitchen = require("./SoupKitchen");
var _soupKitchenDefault = parcelHelpers.interopDefault(_soupKitchen);
var _soupKitchenOutlined = require("./SoupKitchenOutlined");
var _soupKitchenOutlinedDefault = parcelHelpers.interopDefault(_soupKitchenOutlined);
var _soupKitchenRounded = require("./SoupKitchenRounded");
var _soupKitchenRoundedDefault = parcelHelpers.interopDefault(_soupKitchenRounded);
var _soupKitchenSharp = require("./SoupKitchenSharp");
var _soupKitchenSharpDefault = parcelHelpers.interopDefault(_soupKitchenSharp);
var _soupKitchenTwoTone = require("./SoupKitchenTwoTone");
var _soupKitchenTwoToneDefault = parcelHelpers.interopDefault(_soupKitchenTwoTone);
var _source = require("./Source");
var _sourceDefault = parcelHelpers.interopDefault(_source);
var _sourceOutlined = require("./SourceOutlined");
var _sourceOutlinedDefault = parcelHelpers.interopDefault(_sourceOutlined);
var _sourceRounded = require("./SourceRounded");
var _sourceRoundedDefault = parcelHelpers.interopDefault(_sourceRounded);
var _sourceSharp = require("./SourceSharp");
var _sourceSharpDefault = parcelHelpers.interopDefault(_sourceSharp);
var _sourceTwoTone = require("./SourceTwoTone");
var _sourceTwoToneDefault = parcelHelpers.interopDefault(_sourceTwoTone);
var _south = require("./South");
var _southDefault = parcelHelpers.interopDefault(_south);
var _southAmerica = require("./SouthAmerica");
var _southAmericaDefault = parcelHelpers.interopDefault(_southAmerica);
var _southAmericaOutlined = require("./SouthAmericaOutlined");
var _southAmericaOutlinedDefault = parcelHelpers.interopDefault(_southAmericaOutlined);
var _southAmericaRounded = require("./SouthAmericaRounded");
var _southAmericaRoundedDefault = parcelHelpers.interopDefault(_southAmericaRounded);
var _southAmericaSharp = require("./SouthAmericaSharp");
var _southAmericaSharpDefault = parcelHelpers.interopDefault(_southAmericaSharp);
var _southAmericaTwoTone = require("./SouthAmericaTwoTone");
var _southAmericaTwoToneDefault = parcelHelpers.interopDefault(_southAmericaTwoTone);
var _southEast = require("./SouthEast");
var _southEastDefault = parcelHelpers.interopDefault(_southEast);
var _southEastOutlined = require("./SouthEastOutlined");
var _southEastOutlinedDefault = parcelHelpers.interopDefault(_southEastOutlined);
var _southEastRounded = require("./SouthEastRounded");
var _southEastRoundedDefault = parcelHelpers.interopDefault(_southEastRounded);
var _southEastSharp = require("./SouthEastSharp");
var _southEastSharpDefault = parcelHelpers.interopDefault(_southEastSharp);
var _southEastTwoTone = require("./SouthEastTwoTone");
var _southEastTwoToneDefault = parcelHelpers.interopDefault(_southEastTwoTone);
var _southOutlined = require("./SouthOutlined");
var _southOutlinedDefault = parcelHelpers.interopDefault(_southOutlined);
var _southRounded = require("./SouthRounded");
var _southRoundedDefault = parcelHelpers.interopDefault(_southRounded);
var _southSharp = require("./SouthSharp");
var _southSharpDefault = parcelHelpers.interopDefault(_southSharp);
var _southTwoTone = require("./SouthTwoTone");
var _southTwoToneDefault = parcelHelpers.interopDefault(_southTwoTone);
var _southWest = require("./SouthWest");
var _southWestDefault = parcelHelpers.interopDefault(_southWest);
var _southWestOutlined = require("./SouthWestOutlined");
var _southWestOutlinedDefault = parcelHelpers.interopDefault(_southWestOutlined);
var _southWestRounded = require("./SouthWestRounded");
var _southWestRoundedDefault = parcelHelpers.interopDefault(_southWestRounded);
var _southWestSharp = require("./SouthWestSharp");
var _southWestSharpDefault = parcelHelpers.interopDefault(_southWestSharp);
var _southWestTwoTone = require("./SouthWestTwoTone");
var _southWestTwoToneDefault = parcelHelpers.interopDefault(_southWestTwoTone);
var _spa = require("./Spa");
var _spaDefault = parcelHelpers.interopDefault(_spa);
var _spaOutlined = require("./SpaOutlined");
var _spaOutlinedDefault = parcelHelpers.interopDefault(_spaOutlined);
var _spaRounded = require("./SpaRounded");
var _spaRoundedDefault = parcelHelpers.interopDefault(_spaRounded);
var _spaSharp = require("./SpaSharp");
var _spaSharpDefault = parcelHelpers.interopDefault(_spaSharp);
var _spaTwoTone = require("./SpaTwoTone");
var _spaTwoToneDefault = parcelHelpers.interopDefault(_spaTwoTone);
var _spaceBar = require("./SpaceBar");
var _spaceBarDefault = parcelHelpers.interopDefault(_spaceBar);
var _spaceBarOutlined = require("./SpaceBarOutlined");
var _spaceBarOutlinedDefault = parcelHelpers.interopDefault(_spaceBarOutlined);
var _spaceBarRounded = require("./SpaceBarRounded");
var _spaceBarRoundedDefault = parcelHelpers.interopDefault(_spaceBarRounded);
var _spaceBarSharp = require("./SpaceBarSharp");
var _spaceBarSharpDefault = parcelHelpers.interopDefault(_spaceBarSharp);
var _spaceBarTwoTone = require("./SpaceBarTwoTone");
var _spaceBarTwoToneDefault = parcelHelpers.interopDefault(_spaceBarTwoTone);
var _spaceDashboard = require("./SpaceDashboard");
var _spaceDashboardDefault = parcelHelpers.interopDefault(_spaceDashboard);
var _spaceDashboardOutlined = require("./SpaceDashboardOutlined");
var _spaceDashboardOutlinedDefault = parcelHelpers.interopDefault(_spaceDashboardOutlined);
var _spaceDashboardRounded = require("./SpaceDashboardRounded");
var _spaceDashboardRoundedDefault = parcelHelpers.interopDefault(_spaceDashboardRounded);
var _spaceDashboardSharp = require("./SpaceDashboardSharp");
var _spaceDashboardSharpDefault = parcelHelpers.interopDefault(_spaceDashboardSharp);
var _spaceDashboardTwoTone = require("./SpaceDashboardTwoTone");
var _spaceDashboardTwoToneDefault = parcelHelpers.interopDefault(_spaceDashboardTwoTone);
var _spatialAudio = require("./SpatialAudio");
var _spatialAudioDefault = parcelHelpers.interopDefault(_spatialAudio);
var _spatialAudioOff = require("./SpatialAudioOff");
var _spatialAudioOffDefault = parcelHelpers.interopDefault(_spatialAudioOff);
var _spatialAudioOffOutlined = require("./SpatialAudioOffOutlined");
var _spatialAudioOffOutlinedDefault = parcelHelpers.interopDefault(_spatialAudioOffOutlined);
var _spatialAudioOffRounded = require("./SpatialAudioOffRounded");
var _spatialAudioOffRoundedDefault = parcelHelpers.interopDefault(_spatialAudioOffRounded);
var _spatialAudioOffSharp = require("./SpatialAudioOffSharp");
var _spatialAudioOffSharpDefault = parcelHelpers.interopDefault(_spatialAudioOffSharp);
var _spatialAudioOffTwoTone = require("./SpatialAudioOffTwoTone");
var _spatialAudioOffTwoToneDefault = parcelHelpers.interopDefault(_spatialAudioOffTwoTone);
var _spatialAudioOutlined = require("./SpatialAudioOutlined");
var _spatialAudioOutlinedDefault = parcelHelpers.interopDefault(_spatialAudioOutlined);
var _spatialAudioRounded = require("./SpatialAudioRounded");
var _spatialAudioRoundedDefault = parcelHelpers.interopDefault(_spatialAudioRounded);
var _spatialAudioSharp = require("./SpatialAudioSharp");
var _spatialAudioSharpDefault = parcelHelpers.interopDefault(_spatialAudioSharp);
var _spatialAudioTwoTone = require("./SpatialAudioTwoTone");
var _spatialAudioTwoToneDefault = parcelHelpers.interopDefault(_spatialAudioTwoTone);
var _spatialTracking = require("./SpatialTracking");
var _spatialTrackingDefault = parcelHelpers.interopDefault(_spatialTracking);
var _spatialTrackingOutlined = require("./SpatialTrackingOutlined");
var _spatialTrackingOutlinedDefault = parcelHelpers.interopDefault(_spatialTrackingOutlined);
var _spatialTrackingRounded = require("./SpatialTrackingRounded");
var _spatialTrackingRoundedDefault = parcelHelpers.interopDefault(_spatialTrackingRounded);
var _spatialTrackingSharp = require("./SpatialTrackingSharp");
var _spatialTrackingSharpDefault = parcelHelpers.interopDefault(_spatialTrackingSharp);
var _spatialTrackingTwoTone = require("./SpatialTrackingTwoTone");
var _spatialTrackingTwoToneDefault = parcelHelpers.interopDefault(_spatialTrackingTwoTone);
var _speaker = require("./Speaker");
var _speakerDefault = parcelHelpers.interopDefault(_speaker);
var _speakerGroup = require("./SpeakerGroup");
var _speakerGroupDefault = parcelHelpers.interopDefault(_speakerGroup);
var _speakerGroupOutlined = require("./SpeakerGroupOutlined");
var _speakerGroupOutlinedDefault = parcelHelpers.interopDefault(_speakerGroupOutlined);
var _speakerGroupRounded = require("./SpeakerGroupRounded");
var _speakerGroupRoundedDefault = parcelHelpers.interopDefault(_speakerGroupRounded);
var _speakerGroupSharp = require("./SpeakerGroupSharp");
var _speakerGroupSharpDefault = parcelHelpers.interopDefault(_speakerGroupSharp);
var _speakerGroupTwoTone = require("./SpeakerGroupTwoTone");
var _speakerGroupTwoToneDefault = parcelHelpers.interopDefault(_speakerGroupTwoTone);
var _speakerNotes = require("./SpeakerNotes");
var _speakerNotesDefault = parcelHelpers.interopDefault(_speakerNotes);
var _speakerNotesOff = require("./SpeakerNotesOff");
var _speakerNotesOffDefault = parcelHelpers.interopDefault(_speakerNotesOff);
var _speakerNotesOffOutlined = require("./SpeakerNotesOffOutlined");
var _speakerNotesOffOutlinedDefault = parcelHelpers.interopDefault(_speakerNotesOffOutlined);
var _speakerNotesOffRounded = require("./SpeakerNotesOffRounded");
var _speakerNotesOffRoundedDefault = parcelHelpers.interopDefault(_speakerNotesOffRounded);
var _speakerNotesOffSharp = require("./SpeakerNotesOffSharp");
var _speakerNotesOffSharpDefault = parcelHelpers.interopDefault(_speakerNotesOffSharp);
var _speakerNotesOffTwoTone = require("./SpeakerNotesOffTwoTone");
var _speakerNotesOffTwoToneDefault = parcelHelpers.interopDefault(_speakerNotesOffTwoTone);
var _speakerNotesOutlined = require("./SpeakerNotesOutlined");
var _speakerNotesOutlinedDefault = parcelHelpers.interopDefault(_speakerNotesOutlined);
var _speakerNotesRounded = require("./SpeakerNotesRounded");
var _speakerNotesRoundedDefault = parcelHelpers.interopDefault(_speakerNotesRounded);
var _speakerNotesSharp = require("./SpeakerNotesSharp");
var _speakerNotesSharpDefault = parcelHelpers.interopDefault(_speakerNotesSharp);
var _speakerNotesTwoTone = require("./SpeakerNotesTwoTone");
var _speakerNotesTwoToneDefault = parcelHelpers.interopDefault(_speakerNotesTwoTone);
var _speakerOutlined = require("./SpeakerOutlined");
var _speakerOutlinedDefault = parcelHelpers.interopDefault(_speakerOutlined);
var _speakerPhone = require("./SpeakerPhone");
var _speakerPhoneDefault = parcelHelpers.interopDefault(_speakerPhone);
var _speakerPhoneOutlined = require("./SpeakerPhoneOutlined");
var _speakerPhoneOutlinedDefault = parcelHelpers.interopDefault(_speakerPhoneOutlined);
var _speakerPhoneRounded = require("./SpeakerPhoneRounded");
var _speakerPhoneRoundedDefault = parcelHelpers.interopDefault(_speakerPhoneRounded);
var _speakerPhoneSharp = require("./SpeakerPhoneSharp");
var _speakerPhoneSharpDefault = parcelHelpers.interopDefault(_speakerPhoneSharp);
var _speakerPhoneTwoTone = require("./SpeakerPhoneTwoTone");
var _speakerPhoneTwoToneDefault = parcelHelpers.interopDefault(_speakerPhoneTwoTone);
var _speakerRounded = require("./SpeakerRounded");
var _speakerRoundedDefault = parcelHelpers.interopDefault(_speakerRounded);
var _speakerSharp = require("./SpeakerSharp");
var _speakerSharpDefault = parcelHelpers.interopDefault(_speakerSharp);
var _speakerTwoTone = require("./SpeakerTwoTone");
var _speakerTwoToneDefault = parcelHelpers.interopDefault(_speakerTwoTone);
var _speed = require("./Speed");
var _speedDefault = parcelHelpers.interopDefault(_speed);
var _speedOutlined = require("./SpeedOutlined");
var _speedOutlinedDefault = parcelHelpers.interopDefault(_speedOutlined);
var _speedRounded = require("./SpeedRounded");
var _speedRoundedDefault = parcelHelpers.interopDefault(_speedRounded);
var _speedSharp = require("./SpeedSharp");
var _speedSharpDefault = parcelHelpers.interopDefault(_speedSharp);
var _speedTwoTone = require("./SpeedTwoTone");
var _speedTwoToneDefault = parcelHelpers.interopDefault(_speedTwoTone);
var _spellcheck = require("./Spellcheck");
var _spellcheckDefault = parcelHelpers.interopDefault(_spellcheck);
var _spellcheckOutlined = require("./SpellcheckOutlined");
var _spellcheckOutlinedDefault = parcelHelpers.interopDefault(_spellcheckOutlined);
var _spellcheckRounded = require("./SpellcheckRounded");
var _spellcheckRoundedDefault = parcelHelpers.interopDefault(_spellcheckRounded);
var _spellcheckSharp = require("./SpellcheckSharp");
var _spellcheckSharpDefault = parcelHelpers.interopDefault(_spellcheckSharp);
var _spellcheckTwoTone = require("./SpellcheckTwoTone");
var _spellcheckTwoToneDefault = parcelHelpers.interopDefault(_spellcheckTwoTone);
var _splitscreen = require("./Splitscreen");
var _splitscreenDefault = parcelHelpers.interopDefault(_splitscreen);
var _splitscreenOutlined = require("./SplitscreenOutlined");
var _splitscreenOutlinedDefault = parcelHelpers.interopDefault(_splitscreenOutlined);
var _splitscreenRounded = require("./SplitscreenRounded");
var _splitscreenRoundedDefault = parcelHelpers.interopDefault(_splitscreenRounded);
var _splitscreenSharp = require("./SplitscreenSharp");
var _splitscreenSharpDefault = parcelHelpers.interopDefault(_splitscreenSharp);
var _splitscreenTwoTone = require("./SplitscreenTwoTone");
var _splitscreenTwoToneDefault = parcelHelpers.interopDefault(_splitscreenTwoTone);
var _spoke = require("./Spoke");
var _spokeDefault = parcelHelpers.interopDefault(_spoke);
var _spokeOutlined = require("./SpokeOutlined");
var _spokeOutlinedDefault = parcelHelpers.interopDefault(_spokeOutlined);
var _spokeRounded = require("./SpokeRounded");
var _spokeRoundedDefault = parcelHelpers.interopDefault(_spokeRounded);
var _spokeSharp = require("./SpokeSharp");
var _spokeSharpDefault = parcelHelpers.interopDefault(_spokeSharp);
var _spokeTwoTone = require("./SpokeTwoTone");
var _spokeTwoToneDefault = parcelHelpers.interopDefault(_spokeTwoTone);
var _sports = require("./Sports");
var _sportsDefault = parcelHelpers.interopDefault(_sports);
var _sportsBar = require("./SportsBar");
var _sportsBarDefault = parcelHelpers.interopDefault(_sportsBar);
var _sportsBarOutlined = require("./SportsBarOutlined");
var _sportsBarOutlinedDefault = parcelHelpers.interopDefault(_sportsBarOutlined);
var _sportsBarRounded = require("./SportsBarRounded");
var _sportsBarRoundedDefault = parcelHelpers.interopDefault(_sportsBarRounded);
var _sportsBarSharp = require("./SportsBarSharp");
var _sportsBarSharpDefault = parcelHelpers.interopDefault(_sportsBarSharp);
var _sportsBarTwoTone = require("./SportsBarTwoTone");
var _sportsBarTwoToneDefault = parcelHelpers.interopDefault(_sportsBarTwoTone);
var _sportsBaseball = require("./SportsBaseball");
var _sportsBaseballDefault = parcelHelpers.interopDefault(_sportsBaseball);
var _sportsBaseballOutlined = require("./SportsBaseballOutlined");
var _sportsBaseballOutlinedDefault = parcelHelpers.interopDefault(_sportsBaseballOutlined);
var _sportsBaseballRounded = require("./SportsBaseballRounded");
var _sportsBaseballRoundedDefault = parcelHelpers.interopDefault(_sportsBaseballRounded);
var _sportsBaseballSharp = require("./SportsBaseballSharp");
var _sportsBaseballSharpDefault = parcelHelpers.interopDefault(_sportsBaseballSharp);
var _sportsBaseballTwoTone = require("./SportsBaseballTwoTone");
var _sportsBaseballTwoToneDefault = parcelHelpers.interopDefault(_sportsBaseballTwoTone);
var _sportsBasketball = require("./SportsBasketball");
var _sportsBasketballDefault = parcelHelpers.interopDefault(_sportsBasketball);
var _sportsBasketballOutlined = require("./SportsBasketballOutlined");
var _sportsBasketballOutlinedDefault = parcelHelpers.interopDefault(_sportsBasketballOutlined);
var _sportsBasketballRounded = require("./SportsBasketballRounded");
var _sportsBasketballRoundedDefault = parcelHelpers.interopDefault(_sportsBasketballRounded);
var _sportsBasketballSharp = require("./SportsBasketballSharp");
var _sportsBasketballSharpDefault = parcelHelpers.interopDefault(_sportsBasketballSharp);
var _sportsBasketballTwoTone = require("./SportsBasketballTwoTone");
var _sportsBasketballTwoToneDefault = parcelHelpers.interopDefault(_sportsBasketballTwoTone);
var _sportsCricket = require("./SportsCricket");
var _sportsCricketDefault = parcelHelpers.interopDefault(_sportsCricket);
var _sportsCricketOutlined = require("./SportsCricketOutlined");
var _sportsCricketOutlinedDefault = parcelHelpers.interopDefault(_sportsCricketOutlined);
var _sportsCricketRounded = require("./SportsCricketRounded");
var _sportsCricketRoundedDefault = parcelHelpers.interopDefault(_sportsCricketRounded);
var _sportsCricketSharp = require("./SportsCricketSharp");
var _sportsCricketSharpDefault = parcelHelpers.interopDefault(_sportsCricketSharp);
var _sportsCricketTwoTone = require("./SportsCricketTwoTone");
var _sportsCricketTwoToneDefault = parcelHelpers.interopDefault(_sportsCricketTwoTone);
var _sportsEsports = require("./SportsEsports");
var _sportsEsportsDefault = parcelHelpers.interopDefault(_sportsEsports);
var _sportsEsportsOutlined = require("./SportsEsportsOutlined");
var _sportsEsportsOutlinedDefault = parcelHelpers.interopDefault(_sportsEsportsOutlined);
var _sportsEsportsRounded = require("./SportsEsportsRounded");
var _sportsEsportsRoundedDefault = parcelHelpers.interopDefault(_sportsEsportsRounded);
var _sportsEsportsSharp = require("./SportsEsportsSharp");
var _sportsEsportsSharpDefault = parcelHelpers.interopDefault(_sportsEsportsSharp);
var _sportsEsportsTwoTone = require("./SportsEsportsTwoTone");
var _sportsEsportsTwoToneDefault = parcelHelpers.interopDefault(_sportsEsportsTwoTone);
var _sportsFootball = require("./SportsFootball");
var _sportsFootballDefault = parcelHelpers.interopDefault(_sportsFootball);
var _sportsFootballOutlined = require("./SportsFootballOutlined");
var _sportsFootballOutlinedDefault = parcelHelpers.interopDefault(_sportsFootballOutlined);
var _sportsFootballRounded = require("./SportsFootballRounded");
var _sportsFootballRoundedDefault = parcelHelpers.interopDefault(_sportsFootballRounded);
var _sportsFootballSharp = require("./SportsFootballSharp");
var _sportsFootballSharpDefault = parcelHelpers.interopDefault(_sportsFootballSharp);
var _sportsFootballTwoTone = require("./SportsFootballTwoTone");
var _sportsFootballTwoToneDefault = parcelHelpers.interopDefault(_sportsFootballTwoTone);
var _sportsGolf = require("./SportsGolf");
var _sportsGolfDefault = parcelHelpers.interopDefault(_sportsGolf);
var _sportsGolfOutlined = require("./SportsGolfOutlined");
var _sportsGolfOutlinedDefault = parcelHelpers.interopDefault(_sportsGolfOutlined);
var _sportsGolfRounded = require("./SportsGolfRounded");
var _sportsGolfRoundedDefault = parcelHelpers.interopDefault(_sportsGolfRounded);
var _sportsGolfSharp = require("./SportsGolfSharp");
var _sportsGolfSharpDefault = parcelHelpers.interopDefault(_sportsGolfSharp);
var _sportsGolfTwoTone = require("./SportsGolfTwoTone");
var _sportsGolfTwoToneDefault = parcelHelpers.interopDefault(_sportsGolfTwoTone);
var _sportsGymnastics = require("./SportsGymnastics");
var _sportsGymnasticsDefault = parcelHelpers.interopDefault(_sportsGymnastics);
var _sportsGymnasticsOutlined = require("./SportsGymnasticsOutlined");
var _sportsGymnasticsOutlinedDefault = parcelHelpers.interopDefault(_sportsGymnasticsOutlined);
var _sportsGymnasticsRounded = require("./SportsGymnasticsRounded");
var _sportsGymnasticsRoundedDefault = parcelHelpers.interopDefault(_sportsGymnasticsRounded);
var _sportsGymnasticsSharp = require("./SportsGymnasticsSharp");
var _sportsGymnasticsSharpDefault = parcelHelpers.interopDefault(_sportsGymnasticsSharp);
var _sportsGymnasticsTwoTone = require("./SportsGymnasticsTwoTone");
var _sportsGymnasticsTwoToneDefault = parcelHelpers.interopDefault(_sportsGymnasticsTwoTone);
var _sportsHandball = require("./SportsHandball");
var _sportsHandballDefault = parcelHelpers.interopDefault(_sportsHandball);
var _sportsHandballOutlined = require("./SportsHandballOutlined");
var _sportsHandballOutlinedDefault = parcelHelpers.interopDefault(_sportsHandballOutlined);
var _sportsHandballRounded = require("./SportsHandballRounded");
var _sportsHandballRoundedDefault = parcelHelpers.interopDefault(_sportsHandballRounded);
var _sportsHandballSharp = require("./SportsHandballSharp");
var _sportsHandballSharpDefault = parcelHelpers.interopDefault(_sportsHandballSharp);
var _sportsHandballTwoTone = require("./SportsHandballTwoTone");
var _sportsHandballTwoToneDefault = parcelHelpers.interopDefault(_sportsHandballTwoTone);
var _sportsHockey = require("./SportsHockey");
var _sportsHockeyDefault = parcelHelpers.interopDefault(_sportsHockey);
var _sportsHockeyOutlined = require("./SportsHockeyOutlined");
var _sportsHockeyOutlinedDefault = parcelHelpers.interopDefault(_sportsHockeyOutlined);
var _sportsHockeyRounded = require("./SportsHockeyRounded");
var _sportsHockeyRoundedDefault = parcelHelpers.interopDefault(_sportsHockeyRounded);
var _sportsHockeySharp = require("./SportsHockeySharp");
var _sportsHockeySharpDefault = parcelHelpers.interopDefault(_sportsHockeySharp);
var _sportsHockeyTwoTone = require("./SportsHockeyTwoTone");
var _sportsHockeyTwoToneDefault = parcelHelpers.interopDefault(_sportsHockeyTwoTone);
var _sportsKabaddi = require("./SportsKabaddi");
var _sportsKabaddiDefault = parcelHelpers.interopDefault(_sportsKabaddi);
var _sportsKabaddiOutlined = require("./SportsKabaddiOutlined");
var _sportsKabaddiOutlinedDefault = parcelHelpers.interopDefault(_sportsKabaddiOutlined);
var _sportsKabaddiRounded = require("./SportsKabaddiRounded");
var _sportsKabaddiRoundedDefault = parcelHelpers.interopDefault(_sportsKabaddiRounded);
var _sportsKabaddiSharp = require("./SportsKabaddiSharp");
var _sportsKabaddiSharpDefault = parcelHelpers.interopDefault(_sportsKabaddiSharp);
var _sportsKabaddiTwoTone = require("./SportsKabaddiTwoTone");
var _sportsKabaddiTwoToneDefault = parcelHelpers.interopDefault(_sportsKabaddiTwoTone);
var _sportsMartialArts = require("./SportsMartialArts");
var _sportsMartialArtsDefault = parcelHelpers.interopDefault(_sportsMartialArts);
var _sportsMartialArtsOutlined = require("./SportsMartialArtsOutlined");
var _sportsMartialArtsOutlinedDefault = parcelHelpers.interopDefault(_sportsMartialArtsOutlined);
var _sportsMartialArtsRounded = require("./SportsMartialArtsRounded");
var _sportsMartialArtsRoundedDefault = parcelHelpers.interopDefault(_sportsMartialArtsRounded);
var _sportsMartialArtsSharp = require("./SportsMartialArtsSharp");
var _sportsMartialArtsSharpDefault = parcelHelpers.interopDefault(_sportsMartialArtsSharp);
var _sportsMartialArtsTwoTone = require("./SportsMartialArtsTwoTone");
var _sportsMartialArtsTwoToneDefault = parcelHelpers.interopDefault(_sportsMartialArtsTwoTone);
var _sportsMma = require("./SportsMma");
var _sportsMmaDefault = parcelHelpers.interopDefault(_sportsMma);
var _sportsMmaOutlined = require("./SportsMmaOutlined");
var _sportsMmaOutlinedDefault = parcelHelpers.interopDefault(_sportsMmaOutlined);
var _sportsMmaRounded = require("./SportsMmaRounded");
var _sportsMmaRoundedDefault = parcelHelpers.interopDefault(_sportsMmaRounded);
var _sportsMmaSharp = require("./SportsMmaSharp");
var _sportsMmaSharpDefault = parcelHelpers.interopDefault(_sportsMmaSharp);
var _sportsMmaTwoTone = require("./SportsMmaTwoTone");
var _sportsMmaTwoToneDefault = parcelHelpers.interopDefault(_sportsMmaTwoTone);
var _sportsMotorsports = require("./SportsMotorsports");
var _sportsMotorsportsDefault = parcelHelpers.interopDefault(_sportsMotorsports);
var _sportsMotorsportsOutlined = require("./SportsMotorsportsOutlined");
var _sportsMotorsportsOutlinedDefault = parcelHelpers.interopDefault(_sportsMotorsportsOutlined);
var _sportsMotorsportsRounded = require("./SportsMotorsportsRounded");
var _sportsMotorsportsRoundedDefault = parcelHelpers.interopDefault(_sportsMotorsportsRounded);
var _sportsMotorsportsSharp = require("./SportsMotorsportsSharp");
var _sportsMotorsportsSharpDefault = parcelHelpers.interopDefault(_sportsMotorsportsSharp);
var _sportsMotorsportsTwoTone = require("./SportsMotorsportsTwoTone");
var _sportsMotorsportsTwoToneDefault = parcelHelpers.interopDefault(_sportsMotorsportsTwoTone);
var _sportsOutlined = require("./SportsOutlined");
var _sportsOutlinedDefault = parcelHelpers.interopDefault(_sportsOutlined);
var _sportsRounded = require("./SportsRounded");
var _sportsRoundedDefault = parcelHelpers.interopDefault(_sportsRounded);
var _sportsRugby = require("./SportsRugby");
var _sportsRugbyDefault = parcelHelpers.interopDefault(_sportsRugby);
var _sportsRugbyOutlined = require("./SportsRugbyOutlined");
var _sportsRugbyOutlinedDefault = parcelHelpers.interopDefault(_sportsRugbyOutlined);
var _sportsRugbyRounded = require("./SportsRugbyRounded");
var _sportsRugbyRoundedDefault = parcelHelpers.interopDefault(_sportsRugbyRounded);
var _sportsRugbySharp = require("./SportsRugbySharp");
var _sportsRugbySharpDefault = parcelHelpers.interopDefault(_sportsRugbySharp);
var _sportsRugbyTwoTone = require("./SportsRugbyTwoTone");
var _sportsRugbyTwoToneDefault = parcelHelpers.interopDefault(_sportsRugbyTwoTone);
var _sportsScore = require("./SportsScore");
var _sportsScoreDefault = parcelHelpers.interopDefault(_sportsScore);
var _sportsScoreOutlined = require("./SportsScoreOutlined");
var _sportsScoreOutlinedDefault = parcelHelpers.interopDefault(_sportsScoreOutlined);
var _sportsScoreRounded = require("./SportsScoreRounded");
var _sportsScoreRoundedDefault = parcelHelpers.interopDefault(_sportsScoreRounded);
var _sportsScoreSharp = require("./SportsScoreSharp");
var _sportsScoreSharpDefault = parcelHelpers.interopDefault(_sportsScoreSharp);
var _sportsScoreTwoTone = require("./SportsScoreTwoTone");
var _sportsScoreTwoToneDefault = parcelHelpers.interopDefault(_sportsScoreTwoTone);
var _sportsSharp = require("./SportsSharp");
var _sportsSharpDefault = parcelHelpers.interopDefault(_sportsSharp);
var _sportsSoccer = require("./SportsSoccer");
var _sportsSoccerDefault = parcelHelpers.interopDefault(_sportsSoccer);
var _sportsSoccerOutlined = require("./SportsSoccerOutlined");
var _sportsSoccerOutlinedDefault = parcelHelpers.interopDefault(_sportsSoccerOutlined);
var _sportsSoccerRounded = require("./SportsSoccerRounded");
var _sportsSoccerRoundedDefault = parcelHelpers.interopDefault(_sportsSoccerRounded);
var _sportsSoccerSharp = require("./SportsSoccerSharp");
var _sportsSoccerSharpDefault = parcelHelpers.interopDefault(_sportsSoccerSharp);
var _sportsSoccerTwoTone = require("./SportsSoccerTwoTone");
var _sportsSoccerTwoToneDefault = parcelHelpers.interopDefault(_sportsSoccerTwoTone);
var _sportsTennis = require("./SportsTennis");
var _sportsTennisDefault = parcelHelpers.interopDefault(_sportsTennis);
var _sportsTennisOutlined = require("./SportsTennisOutlined");
var _sportsTennisOutlinedDefault = parcelHelpers.interopDefault(_sportsTennisOutlined);
var _sportsTennisRounded = require("./SportsTennisRounded");
var _sportsTennisRoundedDefault = parcelHelpers.interopDefault(_sportsTennisRounded);
var _sportsTennisSharp = require("./SportsTennisSharp");
var _sportsTennisSharpDefault = parcelHelpers.interopDefault(_sportsTennisSharp);
var _sportsTennisTwoTone = require("./SportsTennisTwoTone");
var _sportsTennisTwoToneDefault = parcelHelpers.interopDefault(_sportsTennisTwoTone);
var _sportsTwoTone = require("./SportsTwoTone");
var _sportsTwoToneDefault = parcelHelpers.interopDefault(_sportsTwoTone);
var _sportsVolleyball = require("./SportsVolleyball");
var _sportsVolleyballDefault = parcelHelpers.interopDefault(_sportsVolleyball);
var _sportsVolleyballOutlined = require("./SportsVolleyballOutlined");
var _sportsVolleyballOutlinedDefault = parcelHelpers.interopDefault(_sportsVolleyballOutlined);
var _sportsVolleyballRounded = require("./SportsVolleyballRounded");
var _sportsVolleyballRoundedDefault = parcelHelpers.interopDefault(_sportsVolleyballRounded);
var _sportsVolleyballSharp = require("./SportsVolleyballSharp");
var _sportsVolleyballSharpDefault = parcelHelpers.interopDefault(_sportsVolleyballSharp);
var _sportsVolleyballTwoTone = require("./SportsVolleyballTwoTone");
var _sportsVolleyballTwoToneDefault = parcelHelpers.interopDefault(_sportsVolleyballTwoTone);
var _square = require("./Square");
var _squareDefault = parcelHelpers.interopDefault(_square);
var _squareFoot = require("./SquareFoot");
var _squareFootDefault = parcelHelpers.interopDefault(_squareFoot);
var _squareFootOutlined = require("./SquareFootOutlined");
var _squareFootOutlinedDefault = parcelHelpers.interopDefault(_squareFootOutlined);
var _squareFootRounded = require("./SquareFootRounded");
var _squareFootRoundedDefault = parcelHelpers.interopDefault(_squareFootRounded);
var _squareFootSharp = require("./SquareFootSharp");
var _squareFootSharpDefault = parcelHelpers.interopDefault(_squareFootSharp);
var _squareFootTwoTone = require("./SquareFootTwoTone");
var _squareFootTwoToneDefault = parcelHelpers.interopDefault(_squareFootTwoTone);
var _squareOutlined = require("./SquareOutlined");
var _squareOutlinedDefault = parcelHelpers.interopDefault(_squareOutlined);
var _squareRounded = require("./SquareRounded");
var _squareRoundedDefault = parcelHelpers.interopDefault(_squareRounded);
var _squareSharp = require("./SquareSharp");
var _squareSharpDefault = parcelHelpers.interopDefault(_squareSharp);
var _squareTwoTone = require("./SquareTwoTone");
var _squareTwoToneDefault = parcelHelpers.interopDefault(_squareTwoTone);
var _ssidChart = require("./SsidChart");
var _ssidChartDefault = parcelHelpers.interopDefault(_ssidChart);
var _ssidChartOutlined = require("./SsidChartOutlined");
var _ssidChartOutlinedDefault = parcelHelpers.interopDefault(_ssidChartOutlined);
var _ssidChartRounded = require("./SsidChartRounded");
var _ssidChartRoundedDefault = parcelHelpers.interopDefault(_ssidChartRounded);
var _ssidChartSharp = require("./SsidChartSharp");
var _ssidChartSharpDefault = parcelHelpers.interopDefault(_ssidChartSharp);
var _ssidChartTwoTone = require("./SsidChartTwoTone");
var _ssidChartTwoToneDefault = parcelHelpers.interopDefault(_ssidChartTwoTone);
var _stackedBarChart = require("./StackedBarChart");
var _stackedBarChartDefault = parcelHelpers.interopDefault(_stackedBarChart);
var _stackedBarChartOutlined = require("./StackedBarChartOutlined");
var _stackedBarChartOutlinedDefault = parcelHelpers.interopDefault(_stackedBarChartOutlined);
var _stackedBarChartRounded = require("./StackedBarChartRounded");
var _stackedBarChartRoundedDefault = parcelHelpers.interopDefault(_stackedBarChartRounded);
var _stackedBarChartSharp = require("./StackedBarChartSharp");
var _stackedBarChartSharpDefault = parcelHelpers.interopDefault(_stackedBarChartSharp);
var _stackedBarChartTwoTone = require("./StackedBarChartTwoTone");
var _stackedBarChartTwoToneDefault = parcelHelpers.interopDefault(_stackedBarChartTwoTone);
var _stackedLineChart = require("./StackedLineChart");
var _stackedLineChartDefault = parcelHelpers.interopDefault(_stackedLineChart);
var _stackedLineChartOutlined = require("./StackedLineChartOutlined");
var _stackedLineChartOutlinedDefault = parcelHelpers.interopDefault(_stackedLineChartOutlined);
var _stackedLineChartRounded = require("./StackedLineChartRounded");
var _stackedLineChartRoundedDefault = parcelHelpers.interopDefault(_stackedLineChartRounded);
var _stackedLineChartSharp = require("./StackedLineChartSharp");
var _stackedLineChartSharpDefault = parcelHelpers.interopDefault(_stackedLineChartSharp);
var _stackedLineChartTwoTone = require("./StackedLineChartTwoTone");
var _stackedLineChartTwoToneDefault = parcelHelpers.interopDefault(_stackedLineChartTwoTone);
var _stadium = require("./Stadium");
var _stadiumDefault = parcelHelpers.interopDefault(_stadium);
var _stadiumOutlined = require("./StadiumOutlined");
var _stadiumOutlinedDefault = parcelHelpers.interopDefault(_stadiumOutlined);
var _stadiumRounded = require("./StadiumRounded");
var _stadiumRoundedDefault = parcelHelpers.interopDefault(_stadiumRounded);
var _stadiumSharp = require("./StadiumSharp");
var _stadiumSharpDefault = parcelHelpers.interopDefault(_stadiumSharp);
var _stadiumTwoTone = require("./StadiumTwoTone");
var _stadiumTwoToneDefault = parcelHelpers.interopDefault(_stadiumTwoTone);
var _stairs = require("./Stairs");
var _stairsDefault = parcelHelpers.interopDefault(_stairs);
var _stairsOutlined = require("./StairsOutlined");
var _stairsOutlinedDefault = parcelHelpers.interopDefault(_stairsOutlined);
var _stairsRounded = require("./StairsRounded");
var _stairsRoundedDefault = parcelHelpers.interopDefault(_stairsRounded);
var _stairsSharp = require("./StairsSharp");
var _stairsSharpDefault = parcelHelpers.interopDefault(_stairsSharp);
var _stairsTwoTone = require("./StairsTwoTone");
var _stairsTwoToneDefault = parcelHelpers.interopDefault(_stairsTwoTone);
var _star = require("./Star");
var _starDefault = parcelHelpers.interopDefault(_star);
var _starBorder = require("./StarBorder");
var _starBorderDefault = parcelHelpers.interopDefault(_starBorder);
var _starBorderOutlined = require("./StarBorderOutlined");
var _starBorderOutlinedDefault = parcelHelpers.interopDefault(_starBorderOutlined);
var _starBorderPurple500 = require("./StarBorderPurple500");
var _starBorderPurple500Default = parcelHelpers.interopDefault(_starBorderPurple500);
var _starBorderPurple500Outlined = require("./StarBorderPurple500Outlined");
var _starBorderPurple500OutlinedDefault = parcelHelpers.interopDefault(_starBorderPurple500Outlined);
var _starBorderPurple500Rounded = require("./StarBorderPurple500Rounded");
var _starBorderPurple500RoundedDefault = parcelHelpers.interopDefault(_starBorderPurple500Rounded);
var _starBorderPurple500Sharp = require("./StarBorderPurple500Sharp");
var _starBorderPurple500SharpDefault = parcelHelpers.interopDefault(_starBorderPurple500Sharp);
var _starBorderPurple500TwoTone = require("./StarBorderPurple500TwoTone");
var _starBorderPurple500TwoToneDefault = parcelHelpers.interopDefault(_starBorderPurple500TwoTone);
var _starBorderRounded = require("./StarBorderRounded");
var _starBorderRoundedDefault = parcelHelpers.interopDefault(_starBorderRounded);
var _starBorderSharp = require("./StarBorderSharp");
var _starBorderSharpDefault = parcelHelpers.interopDefault(_starBorderSharp);
var _starBorderTwoTone = require("./StarBorderTwoTone");
var _starBorderTwoToneDefault = parcelHelpers.interopDefault(_starBorderTwoTone);
var _starHalf = require("./StarHalf");
var _starHalfDefault = parcelHelpers.interopDefault(_starHalf);
var _starHalfOutlined = require("./StarHalfOutlined");
var _starHalfOutlinedDefault = parcelHelpers.interopDefault(_starHalfOutlined);
var _starHalfRounded = require("./StarHalfRounded");
var _starHalfRoundedDefault = parcelHelpers.interopDefault(_starHalfRounded);
var _starHalfSharp = require("./StarHalfSharp");
var _starHalfSharpDefault = parcelHelpers.interopDefault(_starHalfSharp);
var _starHalfTwoTone = require("./StarHalfTwoTone");
var _starHalfTwoToneDefault = parcelHelpers.interopDefault(_starHalfTwoTone);
var _starOutline = require("./StarOutline");
var _starOutlineDefault = parcelHelpers.interopDefault(_starOutline);
var _starOutlineOutlined = require("./StarOutlineOutlined");
var _starOutlineOutlinedDefault = parcelHelpers.interopDefault(_starOutlineOutlined);
var _starOutlineRounded = require("./StarOutlineRounded");
var _starOutlineRoundedDefault = parcelHelpers.interopDefault(_starOutlineRounded);
var _starOutlineSharp = require("./StarOutlineSharp");
var _starOutlineSharpDefault = parcelHelpers.interopDefault(_starOutlineSharp);
var _starOutlineTwoTone = require("./StarOutlineTwoTone");
var _starOutlineTwoToneDefault = parcelHelpers.interopDefault(_starOutlineTwoTone);
var _starOutlined = require("./StarOutlined");
var _starOutlinedDefault = parcelHelpers.interopDefault(_starOutlined);
var _starPurple500 = require("./StarPurple500");
var _starPurple500Default = parcelHelpers.interopDefault(_starPurple500);
var _starPurple500Outlined = require("./StarPurple500Outlined");
var _starPurple500OutlinedDefault = parcelHelpers.interopDefault(_starPurple500Outlined);
var _starPurple500Rounded = require("./StarPurple500Rounded");
var _starPurple500RoundedDefault = parcelHelpers.interopDefault(_starPurple500Rounded);
var _starPurple500Sharp = require("./StarPurple500Sharp");
var _starPurple500SharpDefault = parcelHelpers.interopDefault(_starPurple500Sharp);
var _starPurple500TwoTone = require("./StarPurple500TwoTone");
var _starPurple500TwoToneDefault = parcelHelpers.interopDefault(_starPurple500TwoTone);
var _starRate = require("./StarRate");
var _starRateDefault = parcelHelpers.interopDefault(_starRate);
var _starRateOutlined = require("./StarRateOutlined");
var _starRateOutlinedDefault = parcelHelpers.interopDefault(_starRateOutlined);
var _starRateRounded = require("./StarRateRounded");
var _starRateRoundedDefault = parcelHelpers.interopDefault(_starRateRounded);
var _starRateSharp = require("./StarRateSharp");
var _starRateSharpDefault = parcelHelpers.interopDefault(_starRateSharp);
var _starRateTwoTone = require("./StarRateTwoTone");
var _starRateTwoToneDefault = parcelHelpers.interopDefault(_starRateTwoTone);
var _starRounded = require("./StarRounded");
var _starRoundedDefault = parcelHelpers.interopDefault(_starRounded);
var _starSharp = require("./StarSharp");
var _starSharpDefault = parcelHelpers.interopDefault(_starSharp);
var _starTwoTone = require("./StarTwoTone");
var _starTwoToneDefault = parcelHelpers.interopDefault(_starTwoTone);
var _stars = require("./Stars");
var _starsDefault = parcelHelpers.interopDefault(_stars);
var _starsOutlined = require("./StarsOutlined");
var _starsOutlinedDefault = parcelHelpers.interopDefault(_starsOutlined);
var _starsRounded = require("./StarsRounded");
var _starsRoundedDefault = parcelHelpers.interopDefault(_starsRounded);
var _starsSharp = require("./StarsSharp");
var _starsSharpDefault = parcelHelpers.interopDefault(_starsSharp);
var _starsTwoTone = require("./StarsTwoTone");
var _starsTwoToneDefault = parcelHelpers.interopDefault(_starsTwoTone);
var _start = require("./Start");
var _startDefault = parcelHelpers.interopDefault(_start);
var _startOutlined = require("./StartOutlined");
var _startOutlinedDefault = parcelHelpers.interopDefault(_startOutlined);
var _startRounded = require("./StartRounded");
var _startRoundedDefault = parcelHelpers.interopDefault(_startRounded);
var _startSharp = require("./StartSharp");
var _startSharpDefault = parcelHelpers.interopDefault(_startSharp);
var _startTwoTone = require("./StartTwoTone");
var _startTwoToneDefault = parcelHelpers.interopDefault(_startTwoTone);
var _stayCurrentLandscape = require("./StayCurrentLandscape");
var _stayCurrentLandscapeDefault = parcelHelpers.interopDefault(_stayCurrentLandscape);
var _stayCurrentLandscapeOutlined = require("./StayCurrentLandscapeOutlined");
var _stayCurrentLandscapeOutlinedDefault = parcelHelpers.interopDefault(_stayCurrentLandscapeOutlined);
var _stayCurrentLandscapeRounded = require("./StayCurrentLandscapeRounded");
var _stayCurrentLandscapeRoundedDefault = parcelHelpers.interopDefault(_stayCurrentLandscapeRounded);
var _stayCurrentLandscapeSharp = require("./StayCurrentLandscapeSharp");
var _stayCurrentLandscapeSharpDefault = parcelHelpers.interopDefault(_stayCurrentLandscapeSharp);
var _stayCurrentLandscapeTwoTone = require("./StayCurrentLandscapeTwoTone");
var _stayCurrentLandscapeTwoToneDefault = parcelHelpers.interopDefault(_stayCurrentLandscapeTwoTone);
var _stayCurrentPortrait = require("./StayCurrentPortrait");
var _stayCurrentPortraitDefault = parcelHelpers.interopDefault(_stayCurrentPortrait);
var _stayCurrentPortraitOutlined = require("./StayCurrentPortraitOutlined");
var _stayCurrentPortraitOutlinedDefault = parcelHelpers.interopDefault(_stayCurrentPortraitOutlined);
var _stayCurrentPortraitRounded = require("./StayCurrentPortraitRounded");
var _stayCurrentPortraitRoundedDefault = parcelHelpers.interopDefault(_stayCurrentPortraitRounded);
var _stayCurrentPortraitSharp = require("./StayCurrentPortraitSharp");
var _stayCurrentPortraitSharpDefault = parcelHelpers.interopDefault(_stayCurrentPortraitSharp);
var _stayCurrentPortraitTwoTone = require("./StayCurrentPortraitTwoTone");
var _stayCurrentPortraitTwoToneDefault = parcelHelpers.interopDefault(_stayCurrentPortraitTwoTone);
var _stayPrimaryLandscape = require("./StayPrimaryLandscape");
var _stayPrimaryLandscapeDefault = parcelHelpers.interopDefault(_stayPrimaryLandscape);
var _stayPrimaryLandscapeOutlined = require("./StayPrimaryLandscapeOutlined");
var _stayPrimaryLandscapeOutlinedDefault = parcelHelpers.interopDefault(_stayPrimaryLandscapeOutlined);
var _stayPrimaryLandscapeRounded = require("./StayPrimaryLandscapeRounded");
var _stayPrimaryLandscapeRoundedDefault = parcelHelpers.interopDefault(_stayPrimaryLandscapeRounded);
var _stayPrimaryLandscapeSharp = require("./StayPrimaryLandscapeSharp");
var _stayPrimaryLandscapeSharpDefault = parcelHelpers.interopDefault(_stayPrimaryLandscapeSharp);
var _stayPrimaryLandscapeTwoTone = require("./StayPrimaryLandscapeTwoTone");
var _stayPrimaryLandscapeTwoToneDefault = parcelHelpers.interopDefault(_stayPrimaryLandscapeTwoTone);
var _stayPrimaryPortrait = require("./StayPrimaryPortrait");
var _stayPrimaryPortraitDefault = parcelHelpers.interopDefault(_stayPrimaryPortrait);
var _stayPrimaryPortraitOutlined = require("./StayPrimaryPortraitOutlined");
var _stayPrimaryPortraitOutlinedDefault = parcelHelpers.interopDefault(_stayPrimaryPortraitOutlined);
var _stayPrimaryPortraitRounded = require("./StayPrimaryPortraitRounded");
var _stayPrimaryPortraitRoundedDefault = parcelHelpers.interopDefault(_stayPrimaryPortraitRounded);
var _stayPrimaryPortraitSharp = require("./StayPrimaryPortraitSharp");
var _stayPrimaryPortraitSharpDefault = parcelHelpers.interopDefault(_stayPrimaryPortraitSharp);
var _stayPrimaryPortraitTwoTone = require("./StayPrimaryPortraitTwoTone");
var _stayPrimaryPortraitTwoToneDefault = parcelHelpers.interopDefault(_stayPrimaryPortraitTwoTone);
var _stickyNote2 = require("./StickyNote2");
var _stickyNote2Default = parcelHelpers.interopDefault(_stickyNote2);
var _stickyNote2Outlined = require("./StickyNote2Outlined");
var _stickyNote2OutlinedDefault = parcelHelpers.interopDefault(_stickyNote2Outlined);
var _stickyNote2Rounded = require("./StickyNote2Rounded");
var _stickyNote2RoundedDefault = parcelHelpers.interopDefault(_stickyNote2Rounded);
var _stickyNote2Sharp = require("./StickyNote2Sharp");
var _stickyNote2SharpDefault = parcelHelpers.interopDefault(_stickyNote2Sharp);
var _stickyNote2TwoTone = require("./StickyNote2TwoTone");
var _stickyNote2TwoToneDefault = parcelHelpers.interopDefault(_stickyNote2TwoTone);
var _stop = require("./Stop");
var _stopDefault = parcelHelpers.interopDefault(_stop);
var _stopCircle = require("./StopCircle");
var _stopCircleDefault = parcelHelpers.interopDefault(_stopCircle);
var _stopCircleOutlined = require("./StopCircleOutlined");
var _stopCircleOutlinedDefault = parcelHelpers.interopDefault(_stopCircleOutlined);
var _stopCircleRounded = require("./StopCircleRounded");
var _stopCircleRoundedDefault = parcelHelpers.interopDefault(_stopCircleRounded);
var _stopCircleSharp = require("./StopCircleSharp");
var _stopCircleSharpDefault = parcelHelpers.interopDefault(_stopCircleSharp);
var _stopCircleTwoTone = require("./StopCircleTwoTone");
var _stopCircleTwoToneDefault = parcelHelpers.interopDefault(_stopCircleTwoTone);
var _stopOutlined = require("./StopOutlined");
var _stopOutlinedDefault = parcelHelpers.interopDefault(_stopOutlined);
var _stopRounded = require("./StopRounded");
var _stopRoundedDefault = parcelHelpers.interopDefault(_stopRounded);
var _stopScreenShare = require("./StopScreenShare");
var _stopScreenShareDefault = parcelHelpers.interopDefault(_stopScreenShare);
var _stopScreenShareOutlined = require("./StopScreenShareOutlined");
var _stopScreenShareOutlinedDefault = parcelHelpers.interopDefault(_stopScreenShareOutlined);
var _stopScreenShareRounded = require("./StopScreenShareRounded");
var _stopScreenShareRoundedDefault = parcelHelpers.interopDefault(_stopScreenShareRounded);
var _stopScreenShareSharp = require("./StopScreenShareSharp");
var _stopScreenShareSharpDefault = parcelHelpers.interopDefault(_stopScreenShareSharp);
var _stopScreenShareTwoTone = require("./StopScreenShareTwoTone");
var _stopScreenShareTwoToneDefault = parcelHelpers.interopDefault(_stopScreenShareTwoTone);
var _stopSharp = require("./StopSharp");
var _stopSharpDefault = parcelHelpers.interopDefault(_stopSharp);
var _stopTwoTone = require("./StopTwoTone");
var _stopTwoToneDefault = parcelHelpers.interopDefault(_stopTwoTone);
var _storage = require("./Storage");
var _storageDefault = parcelHelpers.interopDefault(_storage);
var _storageOutlined = require("./StorageOutlined");
var _storageOutlinedDefault = parcelHelpers.interopDefault(_storageOutlined);
var _storageRounded = require("./StorageRounded");
var _storageRoundedDefault = parcelHelpers.interopDefault(_storageRounded);
var _storageSharp = require("./StorageSharp");
var _storageSharpDefault = parcelHelpers.interopDefault(_storageSharp);
var _storageTwoTone = require("./StorageTwoTone");
var _storageTwoToneDefault = parcelHelpers.interopDefault(_storageTwoTone);
var _store = require("./Store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _storeMallDirectory = require("./StoreMallDirectory");
var _storeMallDirectoryDefault = parcelHelpers.interopDefault(_storeMallDirectory);
var _storeMallDirectoryOutlined = require("./StoreMallDirectoryOutlined");
var _storeMallDirectoryOutlinedDefault = parcelHelpers.interopDefault(_storeMallDirectoryOutlined);
var _storeMallDirectoryRounded = require("./StoreMallDirectoryRounded");
var _storeMallDirectoryRoundedDefault = parcelHelpers.interopDefault(_storeMallDirectoryRounded);
var _storeMallDirectorySharp = require("./StoreMallDirectorySharp");
var _storeMallDirectorySharpDefault = parcelHelpers.interopDefault(_storeMallDirectorySharp);
var _storeMallDirectoryTwoTone = require("./StoreMallDirectoryTwoTone");
var _storeMallDirectoryTwoToneDefault = parcelHelpers.interopDefault(_storeMallDirectoryTwoTone);
var _storeOutlined = require("./StoreOutlined");
var _storeOutlinedDefault = parcelHelpers.interopDefault(_storeOutlined);
var _storeRounded = require("./StoreRounded");
var _storeRoundedDefault = parcelHelpers.interopDefault(_storeRounded);
var _storeSharp = require("./StoreSharp");
var _storeSharpDefault = parcelHelpers.interopDefault(_storeSharp);
var _storeTwoTone = require("./StoreTwoTone");
var _storeTwoToneDefault = parcelHelpers.interopDefault(_storeTwoTone);
var _storefront = require("./Storefront");
var _storefrontDefault = parcelHelpers.interopDefault(_storefront);
var _storefrontOutlined = require("./StorefrontOutlined");
var _storefrontOutlinedDefault = parcelHelpers.interopDefault(_storefrontOutlined);
var _storefrontRounded = require("./StorefrontRounded");
var _storefrontRoundedDefault = parcelHelpers.interopDefault(_storefrontRounded);
var _storefrontSharp = require("./StorefrontSharp");
var _storefrontSharpDefault = parcelHelpers.interopDefault(_storefrontSharp);
var _storefrontTwoTone = require("./StorefrontTwoTone");
var _storefrontTwoToneDefault = parcelHelpers.interopDefault(_storefrontTwoTone);
var _storm = require("./Storm");
var _stormDefault = parcelHelpers.interopDefault(_storm);
var _stormOutlined = require("./StormOutlined");
var _stormOutlinedDefault = parcelHelpers.interopDefault(_stormOutlined);
var _stormRounded = require("./StormRounded");
var _stormRoundedDefault = parcelHelpers.interopDefault(_stormRounded);
var _stormSharp = require("./StormSharp");
var _stormSharpDefault = parcelHelpers.interopDefault(_stormSharp);
var _stormTwoTone = require("./StormTwoTone");
var _stormTwoToneDefault = parcelHelpers.interopDefault(_stormTwoTone);
var _straight = require("./Straight");
var _straightDefault = parcelHelpers.interopDefault(_straight);
var _straightOutlined = require("./StraightOutlined");
var _straightOutlinedDefault = parcelHelpers.interopDefault(_straightOutlined);
var _straightRounded = require("./StraightRounded");
var _straightRoundedDefault = parcelHelpers.interopDefault(_straightRounded);
var _straightSharp = require("./StraightSharp");
var _straightSharpDefault = parcelHelpers.interopDefault(_straightSharp);
var _straightTwoTone = require("./StraightTwoTone");
var _straightTwoToneDefault = parcelHelpers.interopDefault(_straightTwoTone);
var _straighten = require("./Straighten");
var _straightenDefault = parcelHelpers.interopDefault(_straighten);
var _straightenOutlined = require("./StraightenOutlined");
var _straightenOutlinedDefault = parcelHelpers.interopDefault(_straightenOutlined);
var _straightenRounded = require("./StraightenRounded");
var _straightenRoundedDefault = parcelHelpers.interopDefault(_straightenRounded);
var _straightenSharp = require("./StraightenSharp");
var _straightenSharpDefault = parcelHelpers.interopDefault(_straightenSharp);
var _straightenTwoTone = require("./StraightenTwoTone");
var _straightenTwoToneDefault = parcelHelpers.interopDefault(_straightenTwoTone);
var _stream = require("./Stream");
var _streamDefault = parcelHelpers.interopDefault(_stream);
var _streamOutlined = require("./StreamOutlined");
var _streamOutlinedDefault = parcelHelpers.interopDefault(_streamOutlined);
var _streamRounded = require("./StreamRounded");
var _streamRoundedDefault = parcelHelpers.interopDefault(_streamRounded);
var _streamSharp = require("./StreamSharp");
var _streamSharpDefault = parcelHelpers.interopDefault(_streamSharp);
var _streamTwoTone = require("./StreamTwoTone");
var _streamTwoToneDefault = parcelHelpers.interopDefault(_streamTwoTone);
var _streetview = require("./Streetview");
var _streetviewDefault = parcelHelpers.interopDefault(_streetview);
var _streetviewOutlined = require("./StreetviewOutlined");
var _streetviewOutlinedDefault = parcelHelpers.interopDefault(_streetviewOutlined);
var _streetviewRounded = require("./StreetviewRounded");
var _streetviewRoundedDefault = parcelHelpers.interopDefault(_streetviewRounded);
var _streetviewSharp = require("./StreetviewSharp");
var _streetviewSharpDefault = parcelHelpers.interopDefault(_streetviewSharp);
var _streetviewTwoTone = require("./StreetviewTwoTone");
var _streetviewTwoToneDefault = parcelHelpers.interopDefault(_streetviewTwoTone);
var _strikethroughS = require("./StrikethroughS");
var _strikethroughSDefault = parcelHelpers.interopDefault(_strikethroughS);
var _strikethroughSOutlined = require("./StrikethroughSOutlined");
var _strikethroughSOutlinedDefault = parcelHelpers.interopDefault(_strikethroughSOutlined);
var _strikethroughSRounded = require("./StrikethroughSRounded");
var _strikethroughSRoundedDefault = parcelHelpers.interopDefault(_strikethroughSRounded);
var _strikethroughSSharp = require("./StrikethroughSSharp");
var _strikethroughSSharpDefault = parcelHelpers.interopDefault(_strikethroughSSharp);
var _strikethroughSTwoTone = require("./StrikethroughSTwoTone");
var _strikethroughSTwoToneDefault = parcelHelpers.interopDefault(_strikethroughSTwoTone);
var _stroller = require("./Stroller");
var _strollerDefault = parcelHelpers.interopDefault(_stroller);
var _strollerOutlined = require("./StrollerOutlined");
var _strollerOutlinedDefault = parcelHelpers.interopDefault(_strollerOutlined);
var _strollerRounded = require("./StrollerRounded");
var _strollerRoundedDefault = parcelHelpers.interopDefault(_strollerRounded);
var _strollerSharp = require("./StrollerSharp");
var _strollerSharpDefault = parcelHelpers.interopDefault(_strollerSharp);
var _strollerTwoTone = require("./StrollerTwoTone");
var _strollerTwoToneDefault = parcelHelpers.interopDefault(_strollerTwoTone);
var _style = require("./Style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _styleOutlined = require("./StyleOutlined");
var _styleOutlinedDefault = parcelHelpers.interopDefault(_styleOutlined);
var _styleRounded = require("./StyleRounded");
var _styleRoundedDefault = parcelHelpers.interopDefault(_styleRounded);
var _styleSharp = require("./StyleSharp");
var _styleSharpDefault = parcelHelpers.interopDefault(_styleSharp);
var _styleTwoTone = require("./StyleTwoTone");
var _styleTwoToneDefault = parcelHelpers.interopDefault(_styleTwoTone);
var _subdirectoryArrowLeft = require("./SubdirectoryArrowLeft");
var _subdirectoryArrowLeftDefault = parcelHelpers.interopDefault(_subdirectoryArrowLeft);
var _subdirectoryArrowLeftOutlined = require("./SubdirectoryArrowLeftOutlined");
var _subdirectoryArrowLeftOutlinedDefault = parcelHelpers.interopDefault(_subdirectoryArrowLeftOutlined);
var _subdirectoryArrowLeftRounded = require("./SubdirectoryArrowLeftRounded");
var _subdirectoryArrowLeftRoundedDefault = parcelHelpers.interopDefault(_subdirectoryArrowLeftRounded);
var _subdirectoryArrowLeftSharp = require("./SubdirectoryArrowLeftSharp");
var _subdirectoryArrowLeftSharpDefault = parcelHelpers.interopDefault(_subdirectoryArrowLeftSharp);
var _subdirectoryArrowLeftTwoTone = require("./SubdirectoryArrowLeftTwoTone");
var _subdirectoryArrowLeftTwoToneDefault = parcelHelpers.interopDefault(_subdirectoryArrowLeftTwoTone);
var _subdirectoryArrowRight = require("./SubdirectoryArrowRight");
var _subdirectoryArrowRightDefault = parcelHelpers.interopDefault(_subdirectoryArrowRight);
var _subdirectoryArrowRightOutlined = require("./SubdirectoryArrowRightOutlined");
var _subdirectoryArrowRightOutlinedDefault = parcelHelpers.interopDefault(_subdirectoryArrowRightOutlined);
var _subdirectoryArrowRightRounded = require("./SubdirectoryArrowRightRounded");
var _subdirectoryArrowRightRoundedDefault = parcelHelpers.interopDefault(_subdirectoryArrowRightRounded);
var _subdirectoryArrowRightSharp = require("./SubdirectoryArrowRightSharp");
var _subdirectoryArrowRightSharpDefault = parcelHelpers.interopDefault(_subdirectoryArrowRightSharp);
var _subdirectoryArrowRightTwoTone = require("./SubdirectoryArrowRightTwoTone");
var _subdirectoryArrowRightTwoToneDefault = parcelHelpers.interopDefault(_subdirectoryArrowRightTwoTone);
var _subject = require("./Subject");
var _subjectDefault = parcelHelpers.interopDefault(_subject);
var _subjectOutlined = require("./SubjectOutlined");
var _subjectOutlinedDefault = parcelHelpers.interopDefault(_subjectOutlined);
var _subjectRounded = require("./SubjectRounded");
var _subjectRoundedDefault = parcelHelpers.interopDefault(_subjectRounded);
var _subjectSharp = require("./SubjectSharp");
var _subjectSharpDefault = parcelHelpers.interopDefault(_subjectSharp);
var _subjectTwoTone = require("./SubjectTwoTone");
var _subjectTwoToneDefault = parcelHelpers.interopDefault(_subjectTwoTone);
var _subscript = require("./Subscript");
var _subscriptDefault = parcelHelpers.interopDefault(_subscript);
var _subscriptOutlined = require("./SubscriptOutlined");
var _subscriptOutlinedDefault = parcelHelpers.interopDefault(_subscriptOutlined);
var _subscriptRounded = require("./SubscriptRounded");
var _subscriptRoundedDefault = parcelHelpers.interopDefault(_subscriptRounded);
var _subscriptSharp = require("./SubscriptSharp");
var _subscriptSharpDefault = parcelHelpers.interopDefault(_subscriptSharp);
var _subscriptTwoTone = require("./SubscriptTwoTone");
var _subscriptTwoToneDefault = parcelHelpers.interopDefault(_subscriptTwoTone);
var _subscriptions = require("./Subscriptions");
var _subscriptionsDefault = parcelHelpers.interopDefault(_subscriptions);
var _subscriptionsOutlined = require("./SubscriptionsOutlined");
var _subscriptionsOutlinedDefault = parcelHelpers.interopDefault(_subscriptionsOutlined);
var _subscriptionsRounded = require("./SubscriptionsRounded");
var _subscriptionsRoundedDefault = parcelHelpers.interopDefault(_subscriptionsRounded);
var _subscriptionsSharp = require("./SubscriptionsSharp");
var _subscriptionsSharpDefault = parcelHelpers.interopDefault(_subscriptionsSharp);
var _subscriptionsTwoTone = require("./SubscriptionsTwoTone");
var _subscriptionsTwoToneDefault = parcelHelpers.interopDefault(_subscriptionsTwoTone);
var _subtitles = require("./Subtitles");
var _subtitlesDefault = parcelHelpers.interopDefault(_subtitles);
var _subtitlesOff = require("./SubtitlesOff");
var _subtitlesOffDefault = parcelHelpers.interopDefault(_subtitlesOff);
var _subtitlesOffOutlined = require("./SubtitlesOffOutlined");
var _subtitlesOffOutlinedDefault = parcelHelpers.interopDefault(_subtitlesOffOutlined);
var _subtitlesOffRounded = require("./SubtitlesOffRounded");
var _subtitlesOffRoundedDefault = parcelHelpers.interopDefault(_subtitlesOffRounded);
var _subtitlesOffSharp = require("./SubtitlesOffSharp");
var _subtitlesOffSharpDefault = parcelHelpers.interopDefault(_subtitlesOffSharp);
var _subtitlesOffTwoTone = require("./SubtitlesOffTwoTone");
var _subtitlesOffTwoToneDefault = parcelHelpers.interopDefault(_subtitlesOffTwoTone);
var _subtitlesOutlined = require("./SubtitlesOutlined");
var _subtitlesOutlinedDefault = parcelHelpers.interopDefault(_subtitlesOutlined);
var _subtitlesRounded = require("./SubtitlesRounded");
var _subtitlesRoundedDefault = parcelHelpers.interopDefault(_subtitlesRounded);
var _subtitlesSharp = require("./SubtitlesSharp");
var _subtitlesSharpDefault = parcelHelpers.interopDefault(_subtitlesSharp);
var _subtitlesTwoTone = require("./SubtitlesTwoTone");
var _subtitlesTwoToneDefault = parcelHelpers.interopDefault(_subtitlesTwoTone);
var _subway = require("./Subway");
var _subwayDefault = parcelHelpers.interopDefault(_subway);
var _subwayOutlined = require("./SubwayOutlined");
var _subwayOutlinedDefault = parcelHelpers.interopDefault(_subwayOutlined);
var _subwayRounded = require("./SubwayRounded");
var _subwayRoundedDefault = parcelHelpers.interopDefault(_subwayRounded);
var _subwaySharp = require("./SubwaySharp");
var _subwaySharpDefault = parcelHelpers.interopDefault(_subwaySharp);
var _subwayTwoTone = require("./SubwayTwoTone");
var _subwayTwoToneDefault = parcelHelpers.interopDefault(_subwayTwoTone);
var _summarize = require("./Summarize");
var _summarizeDefault = parcelHelpers.interopDefault(_summarize);
var _summarizeOutlined = require("./SummarizeOutlined");
var _summarizeOutlinedDefault = parcelHelpers.interopDefault(_summarizeOutlined);
var _summarizeRounded = require("./SummarizeRounded");
var _summarizeRoundedDefault = parcelHelpers.interopDefault(_summarizeRounded);
var _summarizeSharp = require("./SummarizeSharp");
var _summarizeSharpDefault = parcelHelpers.interopDefault(_summarizeSharp);
var _summarizeTwoTone = require("./SummarizeTwoTone");
var _summarizeTwoToneDefault = parcelHelpers.interopDefault(_summarizeTwoTone);
var _superscript = require("./Superscript");
var _superscriptDefault = parcelHelpers.interopDefault(_superscript);
var _superscriptOutlined = require("./SuperscriptOutlined");
var _superscriptOutlinedDefault = parcelHelpers.interopDefault(_superscriptOutlined);
var _superscriptRounded = require("./SuperscriptRounded");
var _superscriptRoundedDefault = parcelHelpers.interopDefault(_superscriptRounded);
var _superscriptSharp = require("./SuperscriptSharp");
var _superscriptSharpDefault = parcelHelpers.interopDefault(_superscriptSharp);
var _superscriptTwoTone = require("./SuperscriptTwoTone");
var _superscriptTwoToneDefault = parcelHelpers.interopDefault(_superscriptTwoTone);
var _supervisedUserCircle = require("./SupervisedUserCircle");
var _supervisedUserCircleDefault = parcelHelpers.interopDefault(_supervisedUserCircle);
var _supervisedUserCircleOutlined = require("./SupervisedUserCircleOutlined");
var _supervisedUserCircleOutlinedDefault = parcelHelpers.interopDefault(_supervisedUserCircleOutlined);
var _supervisedUserCircleRounded = require("./SupervisedUserCircleRounded");
var _supervisedUserCircleRoundedDefault = parcelHelpers.interopDefault(_supervisedUserCircleRounded);
var _supervisedUserCircleSharp = require("./SupervisedUserCircleSharp");
var _supervisedUserCircleSharpDefault = parcelHelpers.interopDefault(_supervisedUserCircleSharp);
var _supervisedUserCircleTwoTone = require("./SupervisedUserCircleTwoTone");
var _supervisedUserCircleTwoToneDefault = parcelHelpers.interopDefault(_supervisedUserCircleTwoTone);
var _supervisorAccount = require("./SupervisorAccount");
var _supervisorAccountDefault = parcelHelpers.interopDefault(_supervisorAccount);
var _supervisorAccountOutlined = require("./SupervisorAccountOutlined");
var _supervisorAccountOutlinedDefault = parcelHelpers.interopDefault(_supervisorAccountOutlined);
var _supervisorAccountRounded = require("./SupervisorAccountRounded");
var _supervisorAccountRoundedDefault = parcelHelpers.interopDefault(_supervisorAccountRounded);
var _supervisorAccountSharp = require("./SupervisorAccountSharp");
var _supervisorAccountSharpDefault = parcelHelpers.interopDefault(_supervisorAccountSharp);
var _supervisorAccountTwoTone = require("./SupervisorAccountTwoTone");
var _supervisorAccountTwoToneDefault = parcelHelpers.interopDefault(_supervisorAccountTwoTone);
var _support = require("./Support");
var _supportDefault = parcelHelpers.interopDefault(_support);
var _supportAgent = require("./SupportAgent");
var _supportAgentDefault = parcelHelpers.interopDefault(_supportAgent);
var _supportAgentOutlined = require("./SupportAgentOutlined");
var _supportAgentOutlinedDefault = parcelHelpers.interopDefault(_supportAgentOutlined);
var _supportAgentRounded = require("./SupportAgentRounded");
var _supportAgentRoundedDefault = parcelHelpers.interopDefault(_supportAgentRounded);
var _supportAgentSharp = require("./SupportAgentSharp");
var _supportAgentSharpDefault = parcelHelpers.interopDefault(_supportAgentSharp);
var _supportAgentTwoTone = require("./SupportAgentTwoTone");
var _supportAgentTwoToneDefault = parcelHelpers.interopDefault(_supportAgentTwoTone);
var _supportOutlined = require("./SupportOutlined");
var _supportOutlinedDefault = parcelHelpers.interopDefault(_supportOutlined);
var _supportRounded = require("./SupportRounded");
var _supportRoundedDefault = parcelHelpers.interopDefault(_supportRounded);
var _supportSharp = require("./SupportSharp");
var _supportSharpDefault = parcelHelpers.interopDefault(_supportSharp);
var _supportTwoTone = require("./SupportTwoTone");
var _supportTwoToneDefault = parcelHelpers.interopDefault(_supportTwoTone);
var _surfing = require("./Surfing");
var _surfingDefault = parcelHelpers.interopDefault(_surfing);
var _surfingOutlined = require("./SurfingOutlined");
var _surfingOutlinedDefault = parcelHelpers.interopDefault(_surfingOutlined);
var _surfingRounded = require("./SurfingRounded");
var _surfingRoundedDefault = parcelHelpers.interopDefault(_surfingRounded);
var _surfingSharp = require("./SurfingSharp");
var _surfingSharpDefault = parcelHelpers.interopDefault(_surfingSharp);
var _surfingTwoTone = require("./SurfingTwoTone");
var _surfingTwoToneDefault = parcelHelpers.interopDefault(_surfingTwoTone);
var _surroundSound = require("./SurroundSound");
var _surroundSoundDefault = parcelHelpers.interopDefault(_surroundSound);
var _surroundSoundOutlined = require("./SurroundSoundOutlined");
var _surroundSoundOutlinedDefault = parcelHelpers.interopDefault(_surroundSoundOutlined);
var _surroundSoundRounded = require("./SurroundSoundRounded");
var _surroundSoundRoundedDefault = parcelHelpers.interopDefault(_surroundSoundRounded);
var _surroundSoundSharp = require("./SurroundSoundSharp");
var _surroundSoundSharpDefault = parcelHelpers.interopDefault(_surroundSoundSharp);
var _surroundSoundTwoTone = require("./SurroundSoundTwoTone");
var _surroundSoundTwoToneDefault = parcelHelpers.interopDefault(_surroundSoundTwoTone);
var _swapCalls = require("./SwapCalls");
var _swapCallsDefault = parcelHelpers.interopDefault(_swapCalls);
var _swapCallsOutlined = require("./SwapCallsOutlined");
var _swapCallsOutlinedDefault = parcelHelpers.interopDefault(_swapCallsOutlined);
var _swapCallsRounded = require("./SwapCallsRounded");
var _swapCallsRoundedDefault = parcelHelpers.interopDefault(_swapCallsRounded);
var _swapCallsSharp = require("./SwapCallsSharp");
var _swapCallsSharpDefault = parcelHelpers.interopDefault(_swapCallsSharp);
var _swapCallsTwoTone = require("./SwapCallsTwoTone");
var _swapCallsTwoToneDefault = parcelHelpers.interopDefault(_swapCallsTwoTone);
var _swapHoriz = require("./SwapHoriz");
var _swapHorizDefault = parcelHelpers.interopDefault(_swapHoriz);
var _swapHorizOutlined = require("./SwapHorizOutlined");
var _swapHorizOutlinedDefault = parcelHelpers.interopDefault(_swapHorizOutlined);
var _swapHorizRounded = require("./SwapHorizRounded");
var _swapHorizRoundedDefault = parcelHelpers.interopDefault(_swapHorizRounded);
var _swapHorizSharp = require("./SwapHorizSharp");
var _swapHorizSharpDefault = parcelHelpers.interopDefault(_swapHorizSharp);
var _swapHorizTwoTone = require("./SwapHorizTwoTone");
var _swapHorizTwoToneDefault = parcelHelpers.interopDefault(_swapHorizTwoTone);
var _swapHorizontalCircle = require("./SwapHorizontalCircle");
var _swapHorizontalCircleDefault = parcelHelpers.interopDefault(_swapHorizontalCircle);
var _swapHorizontalCircleOutlined = require("./SwapHorizontalCircleOutlined");
var _swapHorizontalCircleOutlinedDefault = parcelHelpers.interopDefault(_swapHorizontalCircleOutlined);
var _swapHorizontalCircleRounded = require("./SwapHorizontalCircleRounded");
var _swapHorizontalCircleRoundedDefault = parcelHelpers.interopDefault(_swapHorizontalCircleRounded);
var _swapHorizontalCircleSharp = require("./SwapHorizontalCircleSharp");
var _swapHorizontalCircleSharpDefault = parcelHelpers.interopDefault(_swapHorizontalCircleSharp);
var _swapHorizontalCircleTwoTone = require("./SwapHorizontalCircleTwoTone");
var _swapHorizontalCircleTwoToneDefault = parcelHelpers.interopDefault(_swapHorizontalCircleTwoTone);
var _swapVert = require("./SwapVert");
var _swapVertDefault = parcelHelpers.interopDefault(_swapVert);
var _swapVertOutlined = require("./SwapVertOutlined");
var _swapVertOutlinedDefault = parcelHelpers.interopDefault(_swapVertOutlined);
var _swapVertRounded = require("./SwapVertRounded");
var _swapVertRoundedDefault = parcelHelpers.interopDefault(_swapVertRounded);
var _swapVertSharp = require("./SwapVertSharp");
var _swapVertSharpDefault = parcelHelpers.interopDefault(_swapVertSharp);
var _swapVertTwoTone = require("./SwapVertTwoTone");
var _swapVertTwoToneDefault = parcelHelpers.interopDefault(_swapVertTwoTone);
var _swapVerticalCircle = require("./SwapVerticalCircle");
var _swapVerticalCircleDefault = parcelHelpers.interopDefault(_swapVerticalCircle);
var _swapVerticalCircleOutlined = require("./SwapVerticalCircleOutlined");
var _swapVerticalCircleOutlinedDefault = parcelHelpers.interopDefault(_swapVerticalCircleOutlined);
var _swapVerticalCircleRounded = require("./SwapVerticalCircleRounded");
var _swapVerticalCircleRoundedDefault = parcelHelpers.interopDefault(_swapVerticalCircleRounded);
var _swapVerticalCircleSharp = require("./SwapVerticalCircleSharp");
var _swapVerticalCircleSharpDefault = parcelHelpers.interopDefault(_swapVerticalCircleSharp);
var _swapVerticalCircleTwoTone = require("./SwapVerticalCircleTwoTone");
var _swapVerticalCircleTwoToneDefault = parcelHelpers.interopDefault(_swapVerticalCircleTwoTone);
var _swipe = require("./Swipe");
var _swipeDefault = parcelHelpers.interopDefault(_swipe);
var _swipeDown = require("./SwipeDown");
var _swipeDownDefault = parcelHelpers.interopDefault(_swipeDown);
var _swipeDownAlt = require("./SwipeDownAlt");
var _swipeDownAltDefault = parcelHelpers.interopDefault(_swipeDownAlt);
var _swipeDownAltOutlined = require("./SwipeDownAltOutlined");
var _swipeDownAltOutlinedDefault = parcelHelpers.interopDefault(_swipeDownAltOutlined);
var _swipeDownAltRounded = require("./SwipeDownAltRounded");
var _swipeDownAltRoundedDefault = parcelHelpers.interopDefault(_swipeDownAltRounded);
var _swipeDownAltSharp = require("./SwipeDownAltSharp");
var _swipeDownAltSharpDefault = parcelHelpers.interopDefault(_swipeDownAltSharp);
var _swipeDownAltTwoTone = require("./SwipeDownAltTwoTone");
var _swipeDownAltTwoToneDefault = parcelHelpers.interopDefault(_swipeDownAltTwoTone);
var _swipeDownOutlined = require("./SwipeDownOutlined");
var _swipeDownOutlinedDefault = parcelHelpers.interopDefault(_swipeDownOutlined);
var _swipeDownRounded = require("./SwipeDownRounded");
var _swipeDownRoundedDefault = parcelHelpers.interopDefault(_swipeDownRounded);
var _swipeDownSharp = require("./SwipeDownSharp");
var _swipeDownSharpDefault = parcelHelpers.interopDefault(_swipeDownSharp);
var _swipeDownTwoTone = require("./SwipeDownTwoTone");
var _swipeDownTwoToneDefault = parcelHelpers.interopDefault(_swipeDownTwoTone);
var _swipeLeft = require("./SwipeLeft");
var _swipeLeftDefault = parcelHelpers.interopDefault(_swipeLeft);
var _swipeLeftAlt = require("./SwipeLeftAlt");
var _swipeLeftAltDefault = parcelHelpers.interopDefault(_swipeLeftAlt);
var _swipeLeftAltOutlined = require("./SwipeLeftAltOutlined");
var _swipeLeftAltOutlinedDefault = parcelHelpers.interopDefault(_swipeLeftAltOutlined);
var _swipeLeftAltRounded = require("./SwipeLeftAltRounded");
var _swipeLeftAltRoundedDefault = parcelHelpers.interopDefault(_swipeLeftAltRounded);
var _swipeLeftAltSharp = require("./SwipeLeftAltSharp");
var _swipeLeftAltSharpDefault = parcelHelpers.interopDefault(_swipeLeftAltSharp);
var _swipeLeftAltTwoTone = require("./SwipeLeftAltTwoTone");
var _swipeLeftAltTwoToneDefault = parcelHelpers.interopDefault(_swipeLeftAltTwoTone);
var _swipeLeftOutlined = require("./SwipeLeftOutlined");
var _swipeLeftOutlinedDefault = parcelHelpers.interopDefault(_swipeLeftOutlined);
var _swipeLeftRounded = require("./SwipeLeftRounded");
var _swipeLeftRoundedDefault = parcelHelpers.interopDefault(_swipeLeftRounded);
var _swipeLeftSharp = require("./SwipeLeftSharp");
var _swipeLeftSharpDefault = parcelHelpers.interopDefault(_swipeLeftSharp);
var _swipeLeftTwoTone = require("./SwipeLeftTwoTone");
var _swipeLeftTwoToneDefault = parcelHelpers.interopDefault(_swipeLeftTwoTone);
var _swipeOutlined = require("./SwipeOutlined");
var _swipeOutlinedDefault = parcelHelpers.interopDefault(_swipeOutlined);
var _swipeRight = require("./SwipeRight");
var _swipeRightDefault = parcelHelpers.interopDefault(_swipeRight);
var _swipeRightAlt = require("./SwipeRightAlt");
var _swipeRightAltDefault = parcelHelpers.interopDefault(_swipeRightAlt);
var _swipeRightAltOutlined = require("./SwipeRightAltOutlined");
var _swipeRightAltOutlinedDefault = parcelHelpers.interopDefault(_swipeRightAltOutlined);
var _swipeRightAltRounded = require("./SwipeRightAltRounded");
var _swipeRightAltRoundedDefault = parcelHelpers.interopDefault(_swipeRightAltRounded);
var _swipeRightAltSharp = require("./SwipeRightAltSharp");
var _swipeRightAltSharpDefault = parcelHelpers.interopDefault(_swipeRightAltSharp);
var _swipeRightAltTwoTone = require("./SwipeRightAltTwoTone");
var _swipeRightAltTwoToneDefault = parcelHelpers.interopDefault(_swipeRightAltTwoTone);
var _swipeRightOutlined = require("./SwipeRightOutlined");
var _swipeRightOutlinedDefault = parcelHelpers.interopDefault(_swipeRightOutlined);
var _swipeRightRounded = require("./SwipeRightRounded");
var _swipeRightRoundedDefault = parcelHelpers.interopDefault(_swipeRightRounded);
var _swipeRightSharp = require("./SwipeRightSharp");
var _swipeRightSharpDefault = parcelHelpers.interopDefault(_swipeRightSharp);
var _swipeRightTwoTone = require("./SwipeRightTwoTone");
var _swipeRightTwoToneDefault = parcelHelpers.interopDefault(_swipeRightTwoTone);
var _swipeRounded = require("./SwipeRounded");
var _swipeRoundedDefault = parcelHelpers.interopDefault(_swipeRounded);
var _swipeSharp = require("./SwipeSharp");
var _swipeSharpDefault = parcelHelpers.interopDefault(_swipeSharp);
var _swipeTwoTone = require("./SwipeTwoTone");
var _swipeTwoToneDefault = parcelHelpers.interopDefault(_swipeTwoTone);
var _swipeUp = require("./SwipeUp");
var _swipeUpDefault = parcelHelpers.interopDefault(_swipeUp);
var _swipeUpAlt = require("./SwipeUpAlt");
var _swipeUpAltDefault = parcelHelpers.interopDefault(_swipeUpAlt);
var _swipeUpAltOutlined = require("./SwipeUpAltOutlined");
var _swipeUpAltOutlinedDefault = parcelHelpers.interopDefault(_swipeUpAltOutlined);
var _swipeUpAltRounded = require("./SwipeUpAltRounded");
var _swipeUpAltRoundedDefault = parcelHelpers.interopDefault(_swipeUpAltRounded);
var _swipeUpAltSharp = require("./SwipeUpAltSharp");
var _swipeUpAltSharpDefault = parcelHelpers.interopDefault(_swipeUpAltSharp);
var _swipeUpAltTwoTone = require("./SwipeUpAltTwoTone");
var _swipeUpAltTwoToneDefault = parcelHelpers.interopDefault(_swipeUpAltTwoTone);
var _swipeUpOutlined = require("./SwipeUpOutlined");
var _swipeUpOutlinedDefault = parcelHelpers.interopDefault(_swipeUpOutlined);
var _swipeUpRounded = require("./SwipeUpRounded");
var _swipeUpRoundedDefault = parcelHelpers.interopDefault(_swipeUpRounded);
var _swipeUpSharp = require("./SwipeUpSharp");
var _swipeUpSharpDefault = parcelHelpers.interopDefault(_swipeUpSharp);
var _swipeUpTwoTone = require("./SwipeUpTwoTone");
var _swipeUpTwoToneDefault = parcelHelpers.interopDefault(_swipeUpTwoTone);
var _swipeVertical = require("./SwipeVertical");
var _swipeVerticalDefault = parcelHelpers.interopDefault(_swipeVertical);
var _swipeVerticalOutlined = require("./SwipeVerticalOutlined");
var _swipeVerticalOutlinedDefault = parcelHelpers.interopDefault(_swipeVerticalOutlined);
var _swipeVerticalRounded = require("./SwipeVerticalRounded");
var _swipeVerticalRoundedDefault = parcelHelpers.interopDefault(_swipeVerticalRounded);
var _swipeVerticalSharp = require("./SwipeVerticalSharp");
var _swipeVerticalSharpDefault = parcelHelpers.interopDefault(_swipeVerticalSharp);
var _swipeVerticalTwoTone = require("./SwipeVerticalTwoTone");
var _swipeVerticalTwoToneDefault = parcelHelpers.interopDefault(_swipeVerticalTwoTone);
var _switchAccessShortcut = require("./SwitchAccessShortcut");
var _switchAccessShortcutDefault = parcelHelpers.interopDefault(_switchAccessShortcut);
var _switchAccessShortcutAdd = require("./SwitchAccessShortcutAdd");
var _switchAccessShortcutAddDefault = parcelHelpers.interopDefault(_switchAccessShortcutAdd);
var _switchAccessShortcutAddOutlined = require("./SwitchAccessShortcutAddOutlined");
var _switchAccessShortcutAddOutlinedDefault = parcelHelpers.interopDefault(_switchAccessShortcutAddOutlined);
var _switchAccessShortcutAddRounded = require("./SwitchAccessShortcutAddRounded");
var _switchAccessShortcutAddRoundedDefault = parcelHelpers.interopDefault(_switchAccessShortcutAddRounded);
var _switchAccessShortcutAddSharp = require("./SwitchAccessShortcutAddSharp");
var _switchAccessShortcutAddSharpDefault = parcelHelpers.interopDefault(_switchAccessShortcutAddSharp);
var _switchAccessShortcutAddTwoTone = require("./SwitchAccessShortcutAddTwoTone");
var _switchAccessShortcutAddTwoToneDefault = parcelHelpers.interopDefault(_switchAccessShortcutAddTwoTone);
var _switchAccessShortcutOutlined = require("./SwitchAccessShortcutOutlined");
var _switchAccessShortcutOutlinedDefault = parcelHelpers.interopDefault(_switchAccessShortcutOutlined);
var _switchAccessShortcutRounded = require("./SwitchAccessShortcutRounded");
var _switchAccessShortcutRoundedDefault = parcelHelpers.interopDefault(_switchAccessShortcutRounded);
var _switchAccessShortcutSharp = require("./SwitchAccessShortcutSharp");
var _switchAccessShortcutSharpDefault = parcelHelpers.interopDefault(_switchAccessShortcutSharp);
var _switchAccessShortcutTwoTone = require("./SwitchAccessShortcutTwoTone");
var _switchAccessShortcutTwoToneDefault = parcelHelpers.interopDefault(_switchAccessShortcutTwoTone);
var _switchAccount = require("./SwitchAccount");
var _switchAccountDefault = parcelHelpers.interopDefault(_switchAccount);
var _switchAccountOutlined = require("./SwitchAccountOutlined");
var _switchAccountOutlinedDefault = parcelHelpers.interopDefault(_switchAccountOutlined);
var _switchAccountRounded = require("./SwitchAccountRounded");
var _switchAccountRoundedDefault = parcelHelpers.interopDefault(_switchAccountRounded);
var _switchAccountSharp = require("./SwitchAccountSharp");
var _switchAccountSharpDefault = parcelHelpers.interopDefault(_switchAccountSharp);
var _switchAccountTwoTone = require("./SwitchAccountTwoTone");
var _switchAccountTwoToneDefault = parcelHelpers.interopDefault(_switchAccountTwoTone);
var _switchCamera = require("./SwitchCamera");
var _switchCameraDefault = parcelHelpers.interopDefault(_switchCamera);
var _switchCameraOutlined = require("./SwitchCameraOutlined");
var _switchCameraOutlinedDefault = parcelHelpers.interopDefault(_switchCameraOutlined);
var _switchCameraRounded = require("./SwitchCameraRounded");
var _switchCameraRoundedDefault = parcelHelpers.interopDefault(_switchCameraRounded);
var _switchCameraSharp = require("./SwitchCameraSharp");
var _switchCameraSharpDefault = parcelHelpers.interopDefault(_switchCameraSharp);
var _switchCameraTwoTone = require("./SwitchCameraTwoTone");
var _switchCameraTwoToneDefault = parcelHelpers.interopDefault(_switchCameraTwoTone);
var _switchLeft = require("./SwitchLeft");
var _switchLeftDefault = parcelHelpers.interopDefault(_switchLeft);
var _switchLeftOutlined = require("./SwitchLeftOutlined");
var _switchLeftOutlinedDefault = parcelHelpers.interopDefault(_switchLeftOutlined);
var _switchLeftRounded = require("./SwitchLeftRounded");
var _switchLeftRoundedDefault = parcelHelpers.interopDefault(_switchLeftRounded);
var _switchLeftSharp = require("./SwitchLeftSharp");
var _switchLeftSharpDefault = parcelHelpers.interopDefault(_switchLeftSharp);
var _switchLeftTwoTone = require("./SwitchLeftTwoTone");
var _switchLeftTwoToneDefault = parcelHelpers.interopDefault(_switchLeftTwoTone);
var _switchRight = require("./SwitchRight");
var _switchRightDefault = parcelHelpers.interopDefault(_switchRight);
var _switchRightOutlined = require("./SwitchRightOutlined");
var _switchRightOutlinedDefault = parcelHelpers.interopDefault(_switchRightOutlined);
var _switchRightRounded = require("./SwitchRightRounded");
var _switchRightRoundedDefault = parcelHelpers.interopDefault(_switchRightRounded);
var _switchRightSharp = require("./SwitchRightSharp");
var _switchRightSharpDefault = parcelHelpers.interopDefault(_switchRightSharp);
var _switchRightTwoTone = require("./SwitchRightTwoTone");
var _switchRightTwoToneDefault = parcelHelpers.interopDefault(_switchRightTwoTone);
var _switchVideo = require("./SwitchVideo");
var _switchVideoDefault = parcelHelpers.interopDefault(_switchVideo);
var _switchVideoOutlined = require("./SwitchVideoOutlined");
var _switchVideoOutlinedDefault = parcelHelpers.interopDefault(_switchVideoOutlined);
var _switchVideoRounded = require("./SwitchVideoRounded");
var _switchVideoRoundedDefault = parcelHelpers.interopDefault(_switchVideoRounded);
var _switchVideoSharp = require("./SwitchVideoSharp");
var _switchVideoSharpDefault = parcelHelpers.interopDefault(_switchVideoSharp);
var _switchVideoTwoTone = require("./SwitchVideoTwoTone");
var _switchVideoTwoToneDefault = parcelHelpers.interopDefault(_switchVideoTwoTone);
var _synagogue = require("./Synagogue");
var _synagogueDefault = parcelHelpers.interopDefault(_synagogue);
var _synagogueOutlined = require("./SynagogueOutlined");
var _synagogueOutlinedDefault = parcelHelpers.interopDefault(_synagogueOutlined);
var _synagogueRounded = require("./SynagogueRounded");
var _synagogueRoundedDefault = parcelHelpers.interopDefault(_synagogueRounded);
var _synagogueSharp = require("./SynagogueSharp");
var _synagogueSharpDefault = parcelHelpers.interopDefault(_synagogueSharp);
var _synagogueTwoTone = require("./SynagogueTwoTone");
var _synagogueTwoToneDefault = parcelHelpers.interopDefault(_synagogueTwoTone);
var _sync = require("./Sync");
var _syncDefault = parcelHelpers.interopDefault(_sync);
var _syncAlt = require("./SyncAlt");
var _syncAltDefault = parcelHelpers.interopDefault(_syncAlt);
var _syncAltOutlined = require("./SyncAltOutlined");
var _syncAltOutlinedDefault = parcelHelpers.interopDefault(_syncAltOutlined);
var _syncAltRounded = require("./SyncAltRounded");
var _syncAltRoundedDefault = parcelHelpers.interopDefault(_syncAltRounded);
var _syncAltSharp = require("./SyncAltSharp");
var _syncAltSharpDefault = parcelHelpers.interopDefault(_syncAltSharp);
var _syncAltTwoTone = require("./SyncAltTwoTone");
var _syncAltTwoToneDefault = parcelHelpers.interopDefault(_syncAltTwoTone);
var _syncDisabled = require("./SyncDisabled");
var _syncDisabledDefault = parcelHelpers.interopDefault(_syncDisabled);
var _syncDisabledOutlined = require("./SyncDisabledOutlined");
var _syncDisabledOutlinedDefault = parcelHelpers.interopDefault(_syncDisabledOutlined);
var _syncDisabledRounded = require("./SyncDisabledRounded");
var _syncDisabledRoundedDefault = parcelHelpers.interopDefault(_syncDisabledRounded);
var _syncDisabledSharp = require("./SyncDisabledSharp");
var _syncDisabledSharpDefault = parcelHelpers.interopDefault(_syncDisabledSharp);
var _syncDisabledTwoTone = require("./SyncDisabledTwoTone");
var _syncDisabledTwoToneDefault = parcelHelpers.interopDefault(_syncDisabledTwoTone);
var _syncLock = require("./SyncLock");
var _syncLockDefault = parcelHelpers.interopDefault(_syncLock);
var _syncLockOutlined = require("./SyncLockOutlined");
var _syncLockOutlinedDefault = parcelHelpers.interopDefault(_syncLockOutlined);
var _syncLockRounded = require("./SyncLockRounded");
var _syncLockRoundedDefault = parcelHelpers.interopDefault(_syncLockRounded);
var _syncLockSharp = require("./SyncLockSharp");
var _syncLockSharpDefault = parcelHelpers.interopDefault(_syncLockSharp);
var _syncLockTwoTone = require("./SyncLockTwoTone");
var _syncLockTwoToneDefault = parcelHelpers.interopDefault(_syncLockTwoTone);
var _syncOutlined = require("./SyncOutlined");
var _syncOutlinedDefault = parcelHelpers.interopDefault(_syncOutlined);
var _syncProblem = require("./SyncProblem");
var _syncProblemDefault = parcelHelpers.interopDefault(_syncProblem);
var _syncProblemOutlined = require("./SyncProblemOutlined");
var _syncProblemOutlinedDefault = parcelHelpers.interopDefault(_syncProblemOutlined);
var _syncProblemRounded = require("./SyncProblemRounded");
var _syncProblemRoundedDefault = parcelHelpers.interopDefault(_syncProblemRounded);
var _syncProblemSharp = require("./SyncProblemSharp");
var _syncProblemSharpDefault = parcelHelpers.interopDefault(_syncProblemSharp);
var _syncProblemTwoTone = require("./SyncProblemTwoTone");
var _syncProblemTwoToneDefault = parcelHelpers.interopDefault(_syncProblemTwoTone);
var _syncRounded = require("./SyncRounded");
var _syncRoundedDefault = parcelHelpers.interopDefault(_syncRounded);
var _syncSharp = require("./SyncSharp");
var _syncSharpDefault = parcelHelpers.interopDefault(_syncSharp);
var _syncTwoTone = require("./SyncTwoTone");
var _syncTwoToneDefault = parcelHelpers.interopDefault(_syncTwoTone);
var _systemSecurityUpdate = require("./SystemSecurityUpdate");
var _systemSecurityUpdateDefault = parcelHelpers.interopDefault(_systemSecurityUpdate);
var _systemSecurityUpdateGood = require("./SystemSecurityUpdateGood");
var _systemSecurityUpdateGoodDefault = parcelHelpers.interopDefault(_systemSecurityUpdateGood);
var _systemSecurityUpdateGoodOutlined = require("./SystemSecurityUpdateGoodOutlined");
var _systemSecurityUpdateGoodOutlinedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateGoodOutlined);
var _systemSecurityUpdateGoodRounded = require("./SystemSecurityUpdateGoodRounded");
var _systemSecurityUpdateGoodRoundedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateGoodRounded);
var _systemSecurityUpdateGoodSharp = require("./SystemSecurityUpdateGoodSharp");
var _systemSecurityUpdateGoodSharpDefault = parcelHelpers.interopDefault(_systemSecurityUpdateGoodSharp);
var _systemSecurityUpdateGoodTwoTone = require("./SystemSecurityUpdateGoodTwoTone");
var _systemSecurityUpdateGoodTwoToneDefault = parcelHelpers.interopDefault(_systemSecurityUpdateGoodTwoTone);
var _systemSecurityUpdateOutlined = require("./SystemSecurityUpdateOutlined");
var _systemSecurityUpdateOutlinedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateOutlined);
var _systemSecurityUpdateRounded = require("./SystemSecurityUpdateRounded");
var _systemSecurityUpdateRoundedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateRounded);
var _systemSecurityUpdateSharp = require("./SystemSecurityUpdateSharp");
var _systemSecurityUpdateSharpDefault = parcelHelpers.interopDefault(_systemSecurityUpdateSharp);
var _systemSecurityUpdateTwoTone = require("./SystemSecurityUpdateTwoTone");
var _systemSecurityUpdateTwoToneDefault = parcelHelpers.interopDefault(_systemSecurityUpdateTwoTone);
var _systemSecurityUpdateWarning = require("./SystemSecurityUpdateWarning");
var _systemSecurityUpdateWarningDefault = parcelHelpers.interopDefault(_systemSecurityUpdateWarning);
var _systemSecurityUpdateWarningOutlined = require("./SystemSecurityUpdateWarningOutlined");
var _systemSecurityUpdateWarningOutlinedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateWarningOutlined);
var _systemSecurityUpdateWarningRounded = require("./SystemSecurityUpdateWarningRounded");
var _systemSecurityUpdateWarningRoundedDefault = parcelHelpers.interopDefault(_systemSecurityUpdateWarningRounded);
var _systemSecurityUpdateWarningSharp = require("./SystemSecurityUpdateWarningSharp");
var _systemSecurityUpdateWarningSharpDefault = parcelHelpers.interopDefault(_systemSecurityUpdateWarningSharp);
var _systemSecurityUpdateWarningTwoTone = require("./SystemSecurityUpdateWarningTwoTone");
var _systemSecurityUpdateWarningTwoToneDefault = parcelHelpers.interopDefault(_systemSecurityUpdateWarningTwoTone);
var _systemUpdate = require("./SystemUpdate");
var _systemUpdateDefault = parcelHelpers.interopDefault(_systemUpdate);
var _systemUpdateAlt = require("./SystemUpdateAlt");
var _systemUpdateAltDefault = parcelHelpers.interopDefault(_systemUpdateAlt);
var _systemUpdateAltOutlined = require("./SystemUpdateAltOutlined");
var _systemUpdateAltOutlinedDefault = parcelHelpers.interopDefault(_systemUpdateAltOutlined);
var _systemUpdateAltRounded = require("./SystemUpdateAltRounded");
var _systemUpdateAltRoundedDefault = parcelHelpers.interopDefault(_systemUpdateAltRounded);
var _systemUpdateAltSharp = require("./SystemUpdateAltSharp");
var _systemUpdateAltSharpDefault = parcelHelpers.interopDefault(_systemUpdateAltSharp);
var _systemUpdateAltTwoTone = require("./SystemUpdateAltTwoTone");
var _systemUpdateAltTwoToneDefault = parcelHelpers.interopDefault(_systemUpdateAltTwoTone);
var _systemUpdateOutlined = require("./SystemUpdateOutlined");
var _systemUpdateOutlinedDefault = parcelHelpers.interopDefault(_systemUpdateOutlined);
var _systemUpdateRounded = require("./SystemUpdateRounded");
var _systemUpdateRoundedDefault = parcelHelpers.interopDefault(_systemUpdateRounded);
var _systemUpdateSharp = require("./SystemUpdateSharp");
var _systemUpdateSharpDefault = parcelHelpers.interopDefault(_systemUpdateSharp);
var _systemUpdateTwoTone = require("./SystemUpdateTwoTone");
var _systemUpdateTwoToneDefault = parcelHelpers.interopDefault(_systemUpdateTwoTone);
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabOutlined = require("./TabOutlined");
var _tabOutlinedDefault = parcelHelpers.interopDefault(_tabOutlined);
var _tabRounded = require("./TabRounded");
var _tabRoundedDefault = parcelHelpers.interopDefault(_tabRounded);
var _tabSharp = require("./TabSharp");
var _tabSharpDefault = parcelHelpers.interopDefault(_tabSharp);
var _tabTwoTone = require("./TabTwoTone");
var _tabTwoToneDefault = parcelHelpers.interopDefault(_tabTwoTone);
var _tabUnselected = require("./TabUnselected");
var _tabUnselectedDefault = parcelHelpers.interopDefault(_tabUnselected);
var _tabUnselectedOutlined = require("./TabUnselectedOutlined");
var _tabUnselectedOutlinedDefault = parcelHelpers.interopDefault(_tabUnselectedOutlined);
var _tabUnselectedRounded = require("./TabUnselectedRounded");
var _tabUnselectedRoundedDefault = parcelHelpers.interopDefault(_tabUnselectedRounded);
var _tabUnselectedSharp = require("./TabUnselectedSharp");
var _tabUnselectedSharpDefault = parcelHelpers.interopDefault(_tabUnselectedSharp);
var _tabUnselectedTwoTone = require("./TabUnselectedTwoTone");
var _tabUnselectedTwoToneDefault = parcelHelpers.interopDefault(_tabUnselectedTwoTone);
var _tableBar = require("./TableBar");
var _tableBarDefault = parcelHelpers.interopDefault(_tableBar);
var _tableBarOutlined = require("./TableBarOutlined");
var _tableBarOutlinedDefault = parcelHelpers.interopDefault(_tableBarOutlined);
var _tableBarRounded = require("./TableBarRounded");
var _tableBarRoundedDefault = parcelHelpers.interopDefault(_tableBarRounded);
var _tableBarSharp = require("./TableBarSharp");
var _tableBarSharpDefault = parcelHelpers.interopDefault(_tableBarSharp);
var _tableBarTwoTone = require("./TableBarTwoTone");
var _tableBarTwoToneDefault = parcelHelpers.interopDefault(_tableBarTwoTone);
var _tableChart = require("./TableChart");
var _tableChartDefault = parcelHelpers.interopDefault(_tableChart);
var _tableChartOutlined = require("./TableChartOutlined");
var _tableChartOutlinedDefault = parcelHelpers.interopDefault(_tableChartOutlined);
var _tableChartRounded = require("./TableChartRounded");
var _tableChartRoundedDefault = parcelHelpers.interopDefault(_tableChartRounded);
var _tableChartSharp = require("./TableChartSharp");
var _tableChartSharpDefault = parcelHelpers.interopDefault(_tableChartSharp);
var _tableChartTwoTone = require("./TableChartTwoTone");
var _tableChartTwoToneDefault = parcelHelpers.interopDefault(_tableChartTwoTone);
var _tableRestaurant = require("./TableRestaurant");
var _tableRestaurantDefault = parcelHelpers.interopDefault(_tableRestaurant);
var _tableRestaurantOutlined = require("./TableRestaurantOutlined");
var _tableRestaurantOutlinedDefault = parcelHelpers.interopDefault(_tableRestaurantOutlined);
var _tableRestaurantRounded = require("./TableRestaurantRounded");
var _tableRestaurantRoundedDefault = parcelHelpers.interopDefault(_tableRestaurantRounded);
var _tableRestaurantSharp = require("./TableRestaurantSharp");
var _tableRestaurantSharpDefault = parcelHelpers.interopDefault(_tableRestaurantSharp);
var _tableRestaurantTwoTone = require("./TableRestaurantTwoTone");
var _tableRestaurantTwoToneDefault = parcelHelpers.interopDefault(_tableRestaurantTwoTone);
var _tableRows = require("./TableRows");
var _tableRowsDefault = parcelHelpers.interopDefault(_tableRows);
var _tableRowsOutlined = require("./TableRowsOutlined");
var _tableRowsOutlinedDefault = parcelHelpers.interopDefault(_tableRowsOutlined);
var _tableRowsRounded = require("./TableRowsRounded");
var _tableRowsRoundedDefault = parcelHelpers.interopDefault(_tableRowsRounded);
var _tableRowsSharp = require("./TableRowsSharp");
var _tableRowsSharpDefault = parcelHelpers.interopDefault(_tableRowsSharp);
var _tableRowsTwoTone = require("./TableRowsTwoTone");
var _tableRowsTwoToneDefault = parcelHelpers.interopDefault(_tableRowsTwoTone);
var _tableView = require("./TableView");
var _tableViewDefault = parcelHelpers.interopDefault(_tableView);
var _tableViewOutlined = require("./TableViewOutlined");
var _tableViewOutlinedDefault = parcelHelpers.interopDefault(_tableViewOutlined);
var _tableViewRounded = require("./TableViewRounded");
var _tableViewRoundedDefault = parcelHelpers.interopDefault(_tableViewRounded);
var _tableViewSharp = require("./TableViewSharp");
var _tableViewSharpDefault = parcelHelpers.interopDefault(_tableViewSharp);
var _tableViewTwoTone = require("./TableViewTwoTone");
var _tableViewTwoToneDefault = parcelHelpers.interopDefault(_tableViewTwoTone);
var _tablet = require("./Tablet");
var _tabletDefault = parcelHelpers.interopDefault(_tablet);
var _tabletAndroid = require("./TabletAndroid");
var _tabletAndroidDefault = parcelHelpers.interopDefault(_tabletAndroid);
var _tabletAndroidOutlined = require("./TabletAndroidOutlined");
var _tabletAndroidOutlinedDefault = parcelHelpers.interopDefault(_tabletAndroidOutlined);
var _tabletAndroidRounded = require("./TabletAndroidRounded");
var _tabletAndroidRoundedDefault = parcelHelpers.interopDefault(_tabletAndroidRounded);
var _tabletAndroidSharp = require("./TabletAndroidSharp");
var _tabletAndroidSharpDefault = parcelHelpers.interopDefault(_tabletAndroidSharp);
var _tabletAndroidTwoTone = require("./TabletAndroidTwoTone");
var _tabletAndroidTwoToneDefault = parcelHelpers.interopDefault(_tabletAndroidTwoTone);
var _tabletMac = require("./TabletMac");
var _tabletMacDefault = parcelHelpers.interopDefault(_tabletMac);
var _tabletMacOutlined = require("./TabletMacOutlined");
var _tabletMacOutlinedDefault = parcelHelpers.interopDefault(_tabletMacOutlined);
var _tabletMacRounded = require("./TabletMacRounded");
var _tabletMacRoundedDefault = parcelHelpers.interopDefault(_tabletMacRounded);
var _tabletMacSharp = require("./TabletMacSharp");
var _tabletMacSharpDefault = parcelHelpers.interopDefault(_tabletMacSharp);
var _tabletMacTwoTone = require("./TabletMacTwoTone");
var _tabletMacTwoToneDefault = parcelHelpers.interopDefault(_tabletMacTwoTone);
var _tabletOutlined = require("./TabletOutlined");
var _tabletOutlinedDefault = parcelHelpers.interopDefault(_tabletOutlined);
var _tabletRounded = require("./TabletRounded");
var _tabletRoundedDefault = parcelHelpers.interopDefault(_tabletRounded);
var _tabletSharp = require("./TabletSharp");
var _tabletSharpDefault = parcelHelpers.interopDefault(_tabletSharp);
var _tabletTwoTone = require("./TabletTwoTone");
var _tabletTwoToneDefault = parcelHelpers.interopDefault(_tabletTwoTone);
var _tag = require("./Tag");
var _tagDefault = parcelHelpers.interopDefault(_tag);
var _tagFaces = require("./TagFaces");
var _tagFacesDefault = parcelHelpers.interopDefault(_tagFaces);
var _tagFacesOutlined = require("./TagFacesOutlined");
var _tagFacesOutlinedDefault = parcelHelpers.interopDefault(_tagFacesOutlined);
var _tagFacesRounded = require("./TagFacesRounded");
var _tagFacesRoundedDefault = parcelHelpers.interopDefault(_tagFacesRounded);
var _tagFacesSharp = require("./TagFacesSharp");
var _tagFacesSharpDefault = parcelHelpers.interopDefault(_tagFacesSharp);
var _tagFacesTwoTone = require("./TagFacesTwoTone");
var _tagFacesTwoToneDefault = parcelHelpers.interopDefault(_tagFacesTwoTone);
var _tagOutlined = require("./TagOutlined");
var _tagOutlinedDefault = parcelHelpers.interopDefault(_tagOutlined);
var _tagRounded = require("./TagRounded");
var _tagRoundedDefault = parcelHelpers.interopDefault(_tagRounded);
var _tagSharp = require("./TagSharp");
var _tagSharpDefault = parcelHelpers.interopDefault(_tagSharp);
var _tagTwoTone = require("./TagTwoTone");
var _tagTwoToneDefault = parcelHelpers.interopDefault(_tagTwoTone);
var _takeoutDining = require("./TakeoutDining");
var _takeoutDiningDefault = parcelHelpers.interopDefault(_takeoutDining);
var _takeoutDiningOutlined = require("./TakeoutDiningOutlined");
var _takeoutDiningOutlinedDefault = parcelHelpers.interopDefault(_takeoutDiningOutlined);
var _takeoutDiningRounded = require("./TakeoutDiningRounded");
var _takeoutDiningRoundedDefault = parcelHelpers.interopDefault(_takeoutDiningRounded);
var _takeoutDiningSharp = require("./TakeoutDiningSharp");
var _takeoutDiningSharpDefault = parcelHelpers.interopDefault(_takeoutDiningSharp);
var _takeoutDiningTwoTone = require("./TakeoutDiningTwoTone");
var _takeoutDiningTwoToneDefault = parcelHelpers.interopDefault(_takeoutDiningTwoTone);
var _tapAndPlay = require("./TapAndPlay");
var _tapAndPlayDefault = parcelHelpers.interopDefault(_tapAndPlay);
var _tapAndPlayOutlined = require("./TapAndPlayOutlined");
var _tapAndPlayOutlinedDefault = parcelHelpers.interopDefault(_tapAndPlayOutlined);
var _tapAndPlayRounded = require("./TapAndPlayRounded");
var _tapAndPlayRoundedDefault = parcelHelpers.interopDefault(_tapAndPlayRounded);
var _tapAndPlaySharp = require("./TapAndPlaySharp");
var _tapAndPlaySharpDefault = parcelHelpers.interopDefault(_tapAndPlaySharp);
var _tapAndPlayTwoTone = require("./TapAndPlayTwoTone");
var _tapAndPlayTwoToneDefault = parcelHelpers.interopDefault(_tapAndPlayTwoTone);
var _tapas = require("./Tapas");
var _tapasDefault = parcelHelpers.interopDefault(_tapas);
var _tapasOutlined = require("./TapasOutlined");
var _tapasOutlinedDefault = parcelHelpers.interopDefault(_tapasOutlined);
var _tapasRounded = require("./TapasRounded");
var _tapasRoundedDefault = parcelHelpers.interopDefault(_tapasRounded);
var _tapasSharp = require("./TapasSharp");
var _tapasSharpDefault = parcelHelpers.interopDefault(_tapasSharp);
var _tapasTwoTone = require("./TapasTwoTone");
var _tapasTwoToneDefault = parcelHelpers.interopDefault(_tapasTwoTone);
var _task = require("./Task");
var _taskDefault = parcelHelpers.interopDefault(_task);
var _taskAlt = require("./TaskAlt");
var _taskAltDefault = parcelHelpers.interopDefault(_taskAlt);
var _taskAltOutlined = require("./TaskAltOutlined");
var _taskAltOutlinedDefault = parcelHelpers.interopDefault(_taskAltOutlined);
var _taskAltRounded = require("./TaskAltRounded");
var _taskAltRoundedDefault = parcelHelpers.interopDefault(_taskAltRounded);
var _taskAltSharp = require("./TaskAltSharp");
var _taskAltSharpDefault = parcelHelpers.interopDefault(_taskAltSharp);
var _taskAltTwoTone = require("./TaskAltTwoTone");
var _taskAltTwoToneDefault = parcelHelpers.interopDefault(_taskAltTwoTone);
var _taskOutlined = require("./TaskOutlined");
var _taskOutlinedDefault = parcelHelpers.interopDefault(_taskOutlined);
var _taskRounded = require("./TaskRounded");
var _taskRoundedDefault = parcelHelpers.interopDefault(_taskRounded);
var _taskSharp = require("./TaskSharp");
var _taskSharpDefault = parcelHelpers.interopDefault(_taskSharp);
var _taskTwoTone = require("./TaskTwoTone");
var _taskTwoToneDefault = parcelHelpers.interopDefault(_taskTwoTone);
var _taxiAlert = require("./TaxiAlert");
var _taxiAlertDefault = parcelHelpers.interopDefault(_taxiAlert);
var _taxiAlertOutlined = require("./TaxiAlertOutlined");
var _taxiAlertOutlinedDefault = parcelHelpers.interopDefault(_taxiAlertOutlined);
var _taxiAlertRounded = require("./TaxiAlertRounded");
var _taxiAlertRoundedDefault = parcelHelpers.interopDefault(_taxiAlertRounded);
var _taxiAlertSharp = require("./TaxiAlertSharp");
var _taxiAlertSharpDefault = parcelHelpers.interopDefault(_taxiAlertSharp);
var _taxiAlertTwoTone = require("./TaxiAlertTwoTone");
var _taxiAlertTwoToneDefault = parcelHelpers.interopDefault(_taxiAlertTwoTone);
var _telegram = require("./Telegram");
var _telegramDefault = parcelHelpers.interopDefault(_telegram);
var _templeBuddhist = require("./TempleBuddhist");
var _templeBuddhistDefault = parcelHelpers.interopDefault(_templeBuddhist);
var _templeBuddhistOutlined = require("./TempleBuddhistOutlined");
var _templeBuddhistOutlinedDefault = parcelHelpers.interopDefault(_templeBuddhistOutlined);
var _templeBuddhistRounded = require("./TempleBuddhistRounded");
var _templeBuddhistRoundedDefault = parcelHelpers.interopDefault(_templeBuddhistRounded);
var _templeBuddhistSharp = require("./TempleBuddhistSharp");
var _templeBuddhistSharpDefault = parcelHelpers.interopDefault(_templeBuddhistSharp);
var _templeBuddhistTwoTone = require("./TempleBuddhistTwoTone");
var _templeBuddhistTwoToneDefault = parcelHelpers.interopDefault(_templeBuddhistTwoTone);
var _templeHindu = require("./TempleHindu");
var _templeHinduDefault = parcelHelpers.interopDefault(_templeHindu);
var _templeHinduOutlined = require("./TempleHinduOutlined");
var _templeHinduOutlinedDefault = parcelHelpers.interopDefault(_templeHinduOutlined);
var _templeHinduRounded = require("./TempleHinduRounded");
var _templeHinduRoundedDefault = parcelHelpers.interopDefault(_templeHinduRounded);
var _templeHinduSharp = require("./TempleHinduSharp");
var _templeHinduSharpDefault = parcelHelpers.interopDefault(_templeHinduSharp);
var _templeHinduTwoTone = require("./TempleHinduTwoTone");
var _templeHinduTwoToneDefault = parcelHelpers.interopDefault(_templeHinduTwoTone);
var _tenMp = require("./TenMp");
var _tenMpDefault = parcelHelpers.interopDefault(_tenMp);
var _tenMpOutlined = require("./TenMpOutlined");
var _tenMpOutlinedDefault = parcelHelpers.interopDefault(_tenMpOutlined);
var _tenMpRounded = require("./TenMpRounded");
var _tenMpRoundedDefault = parcelHelpers.interopDefault(_tenMpRounded);
var _tenMpSharp = require("./TenMpSharp");
var _tenMpSharpDefault = parcelHelpers.interopDefault(_tenMpSharp);
var _tenMpTwoTone = require("./TenMpTwoTone");
var _tenMpTwoToneDefault = parcelHelpers.interopDefault(_tenMpTwoTone);
var _terminal = require("./Terminal");
var _terminalDefault = parcelHelpers.interopDefault(_terminal);
var _terminalOutlined = require("./TerminalOutlined");
var _terminalOutlinedDefault = parcelHelpers.interopDefault(_terminalOutlined);
var _terminalRounded = require("./TerminalRounded");
var _terminalRoundedDefault = parcelHelpers.interopDefault(_terminalRounded);
var _terminalSharp = require("./TerminalSharp");
var _terminalSharpDefault = parcelHelpers.interopDefault(_terminalSharp);
var _terminalTwoTone = require("./TerminalTwoTone");
var _terminalTwoToneDefault = parcelHelpers.interopDefault(_terminalTwoTone);
var _terrain = require("./Terrain");
var _terrainDefault = parcelHelpers.interopDefault(_terrain);
var _terrainOutlined = require("./TerrainOutlined");
var _terrainOutlinedDefault = parcelHelpers.interopDefault(_terrainOutlined);
var _terrainRounded = require("./TerrainRounded");
var _terrainRoundedDefault = parcelHelpers.interopDefault(_terrainRounded);
var _terrainSharp = require("./TerrainSharp");
var _terrainSharpDefault = parcelHelpers.interopDefault(_terrainSharp);
var _terrainTwoTone = require("./TerrainTwoTone");
var _terrainTwoToneDefault = parcelHelpers.interopDefault(_terrainTwoTone);
var _textDecrease = require("./TextDecrease");
var _textDecreaseDefault = parcelHelpers.interopDefault(_textDecrease);
var _textDecreaseOutlined = require("./TextDecreaseOutlined");
var _textDecreaseOutlinedDefault = parcelHelpers.interopDefault(_textDecreaseOutlined);
var _textDecreaseRounded = require("./TextDecreaseRounded");
var _textDecreaseRoundedDefault = parcelHelpers.interopDefault(_textDecreaseRounded);
var _textDecreaseSharp = require("./TextDecreaseSharp");
var _textDecreaseSharpDefault = parcelHelpers.interopDefault(_textDecreaseSharp);
var _textDecreaseTwoTone = require("./TextDecreaseTwoTone");
var _textDecreaseTwoToneDefault = parcelHelpers.interopDefault(_textDecreaseTwoTone);
var _textFields = require("./TextFields");
var _textFieldsDefault = parcelHelpers.interopDefault(_textFields);
var _textFieldsOutlined = require("./TextFieldsOutlined");
var _textFieldsOutlinedDefault = parcelHelpers.interopDefault(_textFieldsOutlined);
var _textFieldsRounded = require("./TextFieldsRounded");
var _textFieldsRoundedDefault = parcelHelpers.interopDefault(_textFieldsRounded);
var _textFieldsSharp = require("./TextFieldsSharp");
var _textFieldsSharpDefault = parcelHelpers.interopDefault(_textFieldsSharp);
var _textFieldsTwoTone = require("./TextFieldsTwoTone");
var _textFieldsTwoToneDefault = parcelHelpers.interopDefault(_textFieldsTwoTone);
var _textFormat = require("./TextFormat");
var _textFormatDefault = parcelHelpers.interopDefault(_textFormat);
var _textFormatOutlined = require("./TextFormatOutlined");
var _textFormatOutlinedDefault = parcelHelpers.interopDefault(_textFormatOutlined);
var _textFormatRounded = require("./TextFormatRounded");
var _textFormatRoundedDefault = parcelHelpers.interopDefault(_textFormatRounded);
var _textFormatSharp = require("./TextFormatSharp");
var _textFormatSharpDefault = parcelHelpers.interopDefault(_textFormatSharp);
var _textFormatTwoTone = require("./TextFormatTwoTone");
var _textFormatTwoToneDefault = parcelHelpers.interopDefault(_textFormatTwoTone);
var _textIncrease = require("./TextIncrease");
var _textIncreaseDefault = parcelHelpers.interopDefault(_textIncrease);
var _textIncreaseOutlined = require("./TextIncreaseOutlined");
var _textIncreaseOutlinedDefault = parcelHelpers.interopDefault(_textIncreaseOutlined);
var _textIncreaseRounded = require("./TextIncreaseRounded");
var _textIncreaseRoundedDefault = parcelHelpers.interopDefault(_textIncreaseRounded);
var _textIncreaseSharp = require("./TextIncreaseSharp");
var _textIncreaseSharpDefault = parcelHelpers.interopDefault(_textIncreaseSharp);
var _textIncreaseTwoTone = require("./TextIncreaseTwoTone");
var _textIncreaseTwoToneDefault = parcelHelpers.interopDefault(_textIncreaseTwoTone);
var _textRotateUp = require("./TextRotateUp");
var _textRotateUpDefault = parcelHelpers.interopDefault(_textRotateUp);
var _textRotateUpOutlined = require("./TextRotateUpOutlined");
var _textRotateUpOutlinedDefault = parcelHelpers.interopDefault(_textRotateUpOutlined);
var _textRotateUpRounded = require("./TextRotateUpRounded");
var _textRotateUpRoundedDefault = parcelHelpers.interopDefault(_textRotateUpRounded);
var _textRotateUpSharp = require("./TextRotateUpSharp");
var _textRotateUpSharpDefault = parcelHelpers.interopDefault(_textRotateUpSharp);
var _textRotateUpTwoTone = require("./TextRotateUpTwoTone");
var _textRotateUpTwoToneDefault = parcelHelpers.interopDefault(_textRotateUpTwoTone);
var _textRotateVertical = require("./TextRotateVertical");
var _textRotateVerticalDefault = parcelHelpers.interopDefault(_textRotateVertical);
var _textRotateVerticalOutlined = require("./TextRotateVerticalOutlined");
var _textRotateVerticalOutlinedDefault = parcelHelpers.interopDefault(_textRotateVerticalOutlined);
var _textRotateVerticalRounded = require("./TextRotateVerticalRounded");
var _textRotateVerticalRoundedDefault = parcelHelpers.interopDefault(_textRotateVerticalRounded);
var _textRotateVerticalSharp = require("./TextRotateVerticalSharp");
var _textRotateVerticalSharpDefault = parcelHelpers.interopDefault(_textRotateVerticalSharp);
var _textRotateVerticalTwoTone = require("./TextRotateVerticalTwoTone");
var _textRotateVerticalTwoToneDefault = parcelHelpers.interopDefault(_textRotateVerticalTwoTone);
var _textRotationAngledown = require("./TextRotationAngledown");
var _textRotationAngledownDefault = parcelHelpers.interopDefault(_textRotationAngledown);
var _textRotationAngledownOutlined = require("./TextRotationAngledownOutlined");
var _textRotationAngledownOutlinedDefault = parcelHelpers.interopDefault(_textRotationAngledownOutlined);
var _textRotationAngledownRounded = require("./TextRotationAngledownRounded");
var _textRotationAngledownRoundedDefault = parcelHelpers.interopDefault(_textRotationAngledownRounded);
var _textRotationAngledownSharp = require("./TextRotationAngledownSharp");
var _textRotationAngledownSharpDefault = parcelHelpers.interopDefault(_textRotationAngledownSharp);
var _textRotationAngledownTwoTone = require("./TextRotationAngledownTwoTone");
var _textRotationAngledownTwoToneDefault = parcelHelpers.interopDefault(_textRotationAngledownTwoTone);
var _textRotationAngleup = require("./TextRotationAngleup");
var _textRotationAngleupDefault = parcelHelpers.interopDefault(_textRotationAngleup);
var _textRotationAngleupOutlined = require("./TextRotationAngleupOutlined");
var _textRotationAngleupOutlinedDefault = parcelHelpers.interopDefault(_textRotationAngleupOutlined);
var _textRotationAngleupRounded = require("./TextRotationAngleupRounded");
var _textRotationAngleupRoundedDefault = parcelHelpers.interopDefault(_textRotationAngleupRounded);
var _textRotationAngleupSharp = require("./TextRotationAngleupSharp");
var _textRotationAngleupSharpDefault = parcelHelpers.interopDefault(_textRotationAngleupSharp);
var _textRotationAngleupTwoTone = require("./TextRotationAngleupTwoTone");
var _textRotationAngleupTwoToneDefault = parcelHelpers.interopDefault(_textRotationAngleupTwoTone);
var _textRotationDown = require("./TextRotationDown");
var _textRotationDownDefault = parcelHelpers.interopDefault(_textRotationDown);
var _textRotationDownOutlined = require("./TextRotationDownOutlined");
var _textRotationDownOutlinedDefault = parcelHelpers.interopDefault(_textRotationDownOutlined);
var _textRotationDownRounded = require("./TextRotationDownRounded");
var _textRotationDownRoundedDefault = parcelHelpers.interopDefault(_textRotationDownRounded);
var _textRotationDownSharp = require("./TextRotationDownSharp");
var _textRotationDownSharpDefault = parcelHelpers.interopDefault(_textRotationDownSharp);
var _textRotationDownTwoTone = require("./TextRotationDownTwoTone");
var _textRotationDownTwoToneDefault = parcelHelpers.interopDefault(_textRotationDownTwoTone);
var _textRotationNone = require("./TextRotationNone");
var _textRotationNoneDefault = parcelHelpers.interopDefault(_textRotationNone);
var _textRotationNoneOutlined = require("./TextRotationNoneOutlined");
var _textRotationNoneOutlinedDefault = parcelHelpers.interopDefault(_textRotationNoneOutlined);
var _textRotationNoneRounded = require("./TextRotationNoneRounded");
var _textRotationNoneRoundedDefault = parcelHelpers.interopDefault(_textRotationNoneRounded);
var _textRotationNoneSharp = require("./TextRotationNoneSharp");
var _textRotationNoneSharpDefault = parcelHelpers.interopDefault(_textRotationNoneSharp);
var _textRotationNoneTwoTone = require("./TextRotationNoneTwoTone");
var _textRotationNoneTwoToneDefault = parcelHelpers.interopDefault(_textRotationNoneTwoTone);
var _textSnippet = require("./TextSnippet");
var _textSnippetDefault = parcelHelpers.interopDefault(_textSnippet);
var _textSnippetOutlined = require("./TextSnippetOutlined");
var _textSnippetOutlinedDefault = parcelHelpers.interopDefault(_textSnippetOutlined);
var _textSnippetRounded = require("./TextSnippetRounded");
var _textSnippetRoundedDefault = parcelHelpers.interopDefault(_textSnippetRounded);
var _textSnippetSharp = require("./TextSnippetSharp");
var _textSnippetSharpDefault = parcelHelpers.interopDefault(_textSnippetSharp);
var _textSnippetTwoTone = require("./TextSnippetTwoTone");
var _textSnippetTwoToneDefault = parcelHelpers.interopDefault(_textSnippetTwoTone);
var _textsms = require("./Textsms");
var _textsmsDefault = parcelHelpers.interopDefault(_textsms);
var _textsmsOutlined = require("./TextsmsOutlined");
var _textsmsOutlinedDefault = parcelHelpers.interopDefault(_textsmsOutlined);
var _textsmsRounded = require("./TextsmsRounded");
var _textsmsRoundedDefault = parcelHelpers.interopDefault(_textsmsRounded);
var _textsmsSharp = require("./TextsmsSharp");
var _textsmsSharpDefault = parcelHelpers.interopDefault(_textsmsSharp);
var _textsmsTwoTone = require("./TextsmsTwoTone");
var _textsmsTwoToneDefault = parcelHelpers.interopDefault(_textsmsTwoTone);
var _texture = require("./Texture");
var _textureDefault = parcelHelpers.interopDefault(_texture);
var _textureOutlined = require("./TextureOutlined");
var _textureOutlinedDefault = parcelHelpers.interopDefault(_textureOutlined);
var _textureRounded = require("./TextureRounded");
var _textureRoundedDefault = parcelHelpers.interopDefault(_textureRounded);
var _textureSharp = require("./TextureSharp");
var _textureSharpDefault = parcelHelpers.interopDefault(_textureSharp);
var _textureTwoTone = require("./TextureTwoTone");
var _textureTwoToneDefault = parcelHelpers.interopDefault(_textureTwoTone);
var _theaterComedy = require("./TheaterComedy");
var _theaterComedyDefault = parcelHelpers.interopDefault(_theaterComedy);
var _theaterComedyOutlined = require("./TheaterComedyOutlined");
var _theaterComedyOutlinedDefault = parcelHelpers.interopDefault(_theaterComedyOutlined);
var _theaterComedyRounded = require("./TheaterComedyRounded");
var _theaterComedyRoundedDefault = parcelHelpers.interopDefault(_theaterComedyRounded);
var _theaterComedySharp = require("./TheaterComedySharp");
var _theaterComedySharpDefault = parcelHelpers.interopDefault(_theaterComedySharp);
var _theaterComedyTwoTone = require("./TheaterComedyTwoTone");
var _theaterComedyTwoToneDefault = parcelHelpers.interopDefault(_theaterComedyTwoTone);
var _theaters = require("./Theaters");
var _theatersDefault = parcelHelpers.interopDefault(_theaters);
var _theatersOutlined = require("./TheatersOutlined");
var _theatersOutlinedDefault = parcelHelpers.interopDefault(_theatersOutlined);
var _theatersRounded = require("./TheatersRounded");
var _theatersRoundedDefault = parcelHelpers.interopDefault(_theatersRounded);
var _theatersSharp = require("./TheatersSharp");
var _theatersSharpDefault = parcelHelpers.interopDefault(_theatersSharp);
var _theatersTwoTone = require("./TheatersTwoTone");
var _theatersTwoToneDefault = parcelHelpers.interopDefault(_theatersTwoTone);
var _thermostat = require("./Thermostat");
var _thermostatDefault = parcelHelpers.interopDefault(_thermostat);
var _thermostatAuto = require("./ThermostatAuto");
var _thermostatAutoDefault = parcelHelpers.interopDefault(_thermostatAuto);
var _thermostatAutoOutlined = require("./ThermostatAutoOutlined");
var _thermostatAutoOutlinedDefault = parcelHelpers.interopDefault(_thermostatAutoOutlined);
var _thermostatAutoRounded = require("./ThermostatAutoRounded");
var _thermostatAutoRoundedDefault = parcelHelpers.interopDefault(_thermostatAutoRounded);
var _thermostatAutoSharp = require("./ThermostatAutoSharp");
var _thermostatAutoSharpDefault = parcelHelpers.interopDefault(_thermostatAutoSharp);
var _thermostatAutoTwoTone = require("./ThermostatAutoTwoTone");
var _thermostatAutoTwoToneDefault = parcelHelpers.interopDefault(_thermostatAutoTwoTone);
var _thermostatOutlined = require("./ThermostatOutlined");
var _thermostatOutlinedDefault = parcelHelpers.interopDefault(_thermostatOutlined);
var _thermostatRounded = require("./ThermostatRounded");
var _thermostatRoundedDefault = parcelHelpers.interopDefault(_thermostatRounded);
var _thermostatSharp = require("./ThermostatSharp");
var _thermostatSharpDefault = parcelHelpers.interopDefault(_thermostatSharp);
var _thermostatTwoTone = require("./ThermostatTwoTone");
var _thermostatTwoToneDefault = parcelHelpers.interopDefault(_thermostatTwoTone);
var _thirteenMp = require("./ThirteenMp");
var _thirteenMpDefault = parcelHelpers.interopDefault(_thirteenMp);
var _thirteenMpOutlined = require("./ThirteenMpOutlined");
var _thirteenMpOutlinedDefault = parcelHelpers.interopDefault(_thirteenMpOutlined);
var _thirteenMpRounded = require("./ThirteenMpRounded");
var _thirteenMpRoundedDefault = parcelHelpers.interopDefault(_thirteenMpRounded);
var _thirteenMpSharp = require("./ThirteenMpSharp");
var _thirteenMpSharpDefault = parcelHelpers.interopDefault(_thirteenMpSharp);
var _thirteenMpTwoTone = require("./ThirteenMpTwoTone");
var _thirteenMpTwoToneDefault = parcelHelpers.interopDefault(_thirteenMpTwoTone);
var _thirtyFps = require("./ThirtyFps");
var _thirtyFpsDefault = parcelHelpers.interopDefault(_thirtyFps);
var _thirtyFpsOutlined = require("./ThirtyFpsOutlined");
var _thirtyFpsOutlinedDefault = parcelHelpers.interopDefault(_thirtyFpsOutlined);
var _thirtyFpsRounded = require("./ThirtyFpsRounded");
var _thirtyFpsRoundedDefault = parcelHelpers.interopDefault(_thirtyFpsRounded);
var _thirtyFpsSelect = require("./ThirtyFpsSelect");
var _thirtyFpsSelectDefault = parcelHelpers.interopDefault(_thirtyFpsSelect);
var _thirtyFpsSelectOutlined = require("./ThirtyFpsSelectOutlined");
var _thirtyFpsSelectOutlinedDefault = parcelHelpers.interopDefault(_thirtyFpsSelectOutlined);
var _thirtyFpsSelectRounded = require("./ThirtyFpsSelectRounded");
var _thirtyFpsSelectRoundedDefault = parcelHelpers.interopDefault(_thirtyFpsSelectRounded);
var _thirtyFpsSelectSharp = require("./ThirtyFpsSelectSharp");
var _thirtyFpsSelectSharpDefault = parcelHelpers.interopDefault(_thirtyFpsSelectSharp);
var _thirtyFpsSelectTwoTone = require("./ThirtyFpsSelectTwoTone");
var _thirtyFpsSelectTwoToneDefault = parcelHelpers.interopDefault(_thirtyFpsSelectTwoTone);
var _thirtyFpsSharp = require("./ThirtyFpsSharp");
var _thirtyFpsSharpDefault = parcelHelpers.interopDefault(_thirtyFpsSharp);
var _thirtyFpsTwoTone = require("./ThirtyFpsTwoTone");
var _thirtyFpsTwoToneDefault = parcelHelpers.interopDefault(_thirtyFpsTwoTone);
var _threeDRotation = require("./ThreeDRotation");
var _threeDRotationDefault = parcelHelpers.interopDefault(_threeDRotation);
var _threeDRotationOutlined = require("./ThreeDRotationOutlined");
var _threeDRotationOutlinedDefault = parcelHelpers.interopDefault(_threeDRotationOutlined);
var _threeDRotationRounded = require("./ThreeDRotationRounded");
var _threeDRotationRoundedDefault = parcelHelpers.interopDefault(_threeDRotationRounded);
var _threeDRotationSharp = require("./ThreeDRotationSharp");
var _threeDRotationSharpDefault = parcelHelpers.interopDefault(_threeDRotationSharp);
var _threeDRotationTwoTone = require("./ThreeDRotationTwoTone");
var _threeDRotationTwoToneDefault = parcelHelpers.interopDefault(_threeDRotationTwoTone);
var _threeGMobiledata = require("./ThreeGMobiledata");
var _threeGMobiledataDefault = parcelHelpers.interopDefault(_threeGMobiledata);
var _threeGMobiledataOutlined = require("./ThreeGMobiledataOutlined");
var _threeGMobiledataOutlinedDefault = parcelHelpers.interopDefault(_threeGMobiledataOutlined);
var _threeGMobiledataRounded = require("./ThreeGMobiledataRounded");
var _threeGMobiledataRoundedDefault = parcelHelpers.interopDefault(_threeGMobiledataRounded);
var _threeGMobiledataSharp = require("./ThreeGMobiledataSharp");
var _threeGMobiledataSharpDefault = parcelHelpers.interopDefault(_threeGMobiledataSharp);
var _threeGMobiledataTwoTone = require("./ThreeGMobiledataTwoTone");
var _threeGMobiledataTwoToneDefault = parcelHelpers.interopDefault(_threeGMobiledataTwoTone);
var _threeK = require("./ThreeK");
var _threeKDefault = parcelHelpers.interopDefault(_threeK);
var _threeKOutlined = require("./ThreeKOutlined");
var _threeKOutlinedDefault = parcelHelpers.interopDefault(_threeKOutlined);
var _threeKPlus = require("./ThreeKPlus");
var _threeKPlusDefault = parcelHelpers.interopDefault(_threeKPlus);
var _threeKPlusOutlined = require("./ThreeKPlusOutlined");
var _threeKPlusOutlinedDefault = parcelHelpers.interopDefault(_threeKPlusOutlined);
var _threeKPlusRounded = require("./ThreeKPlusRounded");
var _threeKPlusRoundedDefault = parcelHelpers.interopDefault(_threeKPlusRounded);
var _threeKPlusSharp = require("./ThreeKPlusSharp");
var _threeKPlusSharpDefault = parcelHelpers.interopDefault(_threeKPlusSharp);
var _threeKPlusTwoTone = require("./ThreeKPlusTwoTone");
var _threeKPlusTwoToneDefault = parcelHelpers.interopDefault(_threeKPlusTwoTone);
var _threeKRounded = require("./ThreeKRounded");
var _threeKRoundedDefault = parcelHelpers.interopDefault(_threeKRounded);
var _threeKSharp = require("./ThreeKSharp");
var _threeKSharpDefault = parcelHelpers.interopDefault(_threeKSharp);
var _threeKTwoTone = require("./ThreeKTwoTone");
var _threeKTwoToneDefault = parcelHelpers.interopDefault(_threeKTwoTone);
var _threeMp = require("./ThreeMp");
var _threeMpDefault = parcelHelpers.interopDefault(_threeMp);
var _threeMpOutlined = require("./ThreeMpOutlined");
var _threeMpOutlinedDefault = parcelHelpers.interopDefault(_threeMpOutlined);
var _threeMpRounded = require("./ThreeMpRounded");
var _threeMpRoundedDefault = parcelHelpers.interopDefault(_threeMpRounded);
var _threeMpSharp = require("./ThreeMpSharp");
var _threeMpSharpDefault = parcelHelpers.interopDefault(_threeMpSharp);
var _threeMpTwoTone = require("./ThreeMpTwoTone");
var _threeMpTwoToneDefault = parcelHelpers.interopDefault(_threeMpTwoTone);
var _threeP = require("./ThreeP");
var _threePDefault = parcelHelpers.interopDefault(_threeP);
var _threePOutlined = require("./ThreePOutlined");
var _threePOutlinedDefault = parcelHelpers.interopDefault(_threePOutlined);
var _threePRounded = require("./ThreePRounded");
var _threePRoundedDefault = parcelHelpers.interopDefault(_threePRounded);
var _threePSharp = require("./ThreePSharp");
var _threePSharpDefault = parcelHelpers.interopDefault(_threePSharp);
var _threePTwoTone = require("./ThreePTwoTone");
var _threePTwoToneDefault = parcelHelpers.interopDefault(_threePTwoTone);
var _threeSixty = require("./ThreeSixty");
var _threeSixtyDefault = parcelHelpers.interopDefault(_threeSixty);
var _threeSixtyOutlined = require("./ThreeSixtyOutlined");
var _threeSixtyOutlinedDefault = parcelHelpers.interopDefault(_threeSixtyOutlined);
var _threeSixtyRounded = require("./ThreeSixtyRounded");
var _threeSixtyRoundedDefault = parcelHelpers.interopDefault(_threeSixtyRounded);
var _threeSixtySharp = require("./ThreeSixtySharp");
var _threeSixtySharpDefault = parcelHelpers.interopDefault(_threeSixtySharp);
var _threeSixtyTwoTone = require("./ThreeSixtyTwoTone");
var _threeSixtyTwoToneDefault = parcelHelpers.interopDefault(_threeSixtyTwoTone);
var _thumbDown = require("./ThumbDown");
var _thumbDownDefault = parcelHelpers.interopDefault(_thumbDown);
var _thumbDownAlt = require("./ThumbDownAlt");
var _thumbDownAltDefault = parcelHelpers.interopDefault(_thumbDownAlt);
var _thumbDownAltOutlined = require("./ThumbDownAltOutlined");
var _thumbDownAltOutlinedDefault = parcelHelpers.interopDefault(_thumbDownAltOutlined);
var _thumbDownAltRounded = require("./ThumbDownAltRounded");
var _thumbDownAltRoundedDefault = parcelHelpers.interopDefault(_thumbDownAltRounded);
var _thumbDownAltSharp = require("./ThumbDownAltSharp");
var _thumbDownAltSharpDefault = parcelHelpers.interopDefault(_thumbDownAltSharp);
var _thumbDownAltTwoTone = require("./ThumbDownAltTwoTone");
var _thumbDownAltTwoToneDefault = parcelHelpers.interopDefault(_thumbDownAltTwoTone);
var _thumbDownOffAlt = require("./ThumbDownOffAlt");
var _thumbDownOffAltDefault = parcelHelpers.interopDefault(_thumbDownOffAlt);
var _thumbDownOffAltOutlined = require("./ThumbDownOffAltOutlined");
var _thumbDownOffAltOutlinedDefault = parcelHelpers.interopDefault(_thumbDownOffAltOutlined);
var _thumbDownOffAltRounded = require("./ThumbDownOffAltRounded");
var _thumbDownOffAltRoundedDefault = parcelHelpers.interopDefault(_thumbDownOffAltRounded);
var _thumbDownOffAltSharp = require("./ThumbDownOffAltSharp");
var _thumbDownOffAltSharpDefault = parcelHelpers.interopDefault(_thumbDownOffAltSharp);
var _thumbDownOffAltTwoTone = require("./ThumbDownOffAltTwoTone");
var _thumbDownOffAltTwoToneDefault = parcelHelpers.interopDefault(_thumbDownOffAltTwoTone);
var _thumbDownOutlined = require("./ThumbDownOutlined");
var _thumbDownOutlinedDefault = parcelHelpers.interopDefault(_thumbDownOutlined);
var _thumbDownRounded = require("./ThumbDownRounded");
var _thumbDownRoundedDefault = parcelHelpers.interopDefault(_thumbDownRounded);
var _thumbDownSharp = require("./ThumbDownSharp");
var _thumbDownSharpDefault = parcelHelpers.interopDefault(_thumbDownSharp);
var _thumbDownTwoTone = require("./ThumbDownTwoTone");
var _thumbDownTwoToneDefault = parcelHelpers.interopDefault(_thumbDownTwoTone);
var _thumbUp = require("./ThumbUp");
var _thumbUpDefault = parcelHelpers.interopDefault(_thumbUp);
var _thumbUpAlt = require("./ThumbUpAlt");
var _thumbUpAltDefault = parcelHelpers.interopDefault(_thumbUpAlt);
var _thumbUpAltOutlined = require("./ThumbUpAltOutlined");
var _thumbUpAltOutlinedDefault = parcelHelpers.interopDefault(_thumbUpAltOutlined);
var _thumbUpAltRounded = require("./ThumbUpAltRounded");
var _thumbUpAltRoundedDefault = parcelHelpers.interopDefault(_thumbUpAltRounded);
var _thumbUpAltSharp = require("./ThumbUpAltSharp");
var _thumbUpAltSharpDefault = parcelHelpers.interopDefault(_thumbUpAltSharp);
var _thumbUpAltTwoTone = require("./ThumbUpAltTwoTone");
var _thumbUpAltTwoToneDefault = parcelHelpers.interopDefault(_thumbUpAltTwoTone);
var _thumbUpOffAlt = require("./ThumbUpOffAlt");
var _thumbUpOffAltDefault = parcelHelpers.interopDefault(_thumbUpOffAlt);
var _thumbUpOffAltOutlined = require("./ThumbUpOffAltOutlined");
var _thumbUpOffAltOutlinedDefault = parcelHelpers.interopDefault(_thumbUpOffAltOutlined);
var _thumbUpOffAltRounded = require("./ThumbUpOffAltRounded");
var _thumbUpOffAltRoundedDefault = parcelHelpers.interopDefault(_thumbUpOffAltRounded);
var _thumbUpOffAltSharp = require("./ThumbUpOffAltSharp");
var _thumbUpOffAltSharpDefault = parcelHelpers.interopDefault(_thumbUpOffAltSharp);
var _thumbUpOffAltTwoTone = require("./ThumbUpOffAltTwoTone");
var _thumbUpOffAltTwoToneDefault = parcelHelpers.interopDefault(_thumbUpOffAltTwoTone);
var _thumbUpOutlined = require("./ThumbUpOutlined");
var _thumbUpOutlinedDefault = parcelHelpers.interopDefault(_thumbUpOutlined);
var _thumbUpRounded = require("./ThumbUpRounded");
var _thumbUpRoundedDefault = parcelHelpers.interopDefault(_thumbUpRounded);
var _thumbUpSharp = require("./ThumbUpSharp");
var _thumbUpSharpDefault = parcelHelpers.interopDefault(_thumbUpSharp);
var _thumbUpTwoTone = require("./ThumbUpTwoTone");
var _thumbUpTwoToneDefault = parcelHelpers.interopDefault(_thumbUpTwoTone);
var _thumbsUpDown = require("./ThumbsUpDown");
var _thumbsUpDownDefault = parcelHelpers.interopDefault(_thumbsUpDown);
var _thumbsUpDownOutlined = require("./ThumbsUpDownOutlined");
var _thumbsUpDownOutlinedDefault = parcelHelpers.interopDefault(_thumbsUpDownOutlined);
var _thumbsUpDownRounded = require("./ThumbsUpDownRounded");
var _thumbsUpDownRoundedDefault = parcelHelpers.interopDefault(_thumbsUpDownRounded);
var _thumbsUpDownSharp = require("./ThumbsUpDownSharp");
var _thumbsUpDownSharpDefault = parcelHelpers.interopDefault(_thumbsUpDownSharp);
var _thumbsUpDownTwoTone = require("./ThumbsUpDownTwoTone");
var _thumbsUpDownTwoToneDefault = parcelHelpers.interopDefault(_thumbsUpDownTwoTone);
var _thunderstorm = require("./Thunderstorm");
var _thunderstormDefault = parcelHelpers.interopDefault(_thunderstorm);
var _thunderstormOutlined = require("./ThunderstormOutlined");
var _thunderstormOutlinedDefault = parcelHelpers.interopDefault(_thunderstormOutlined);
var _thunderstormRounded = require("./ThunderstormRounded");
var _thunderstormRoundedDefault = parcelHelpers.interopDefault(_thunderstormRounded);
var _thunderstormSharp = require("./ThunderstormSharp");
var _thunderstormSharpDefault = parcelHelpers.interopDefault(_thunderstormSharp);
var _thunderstormTwoTone = require("./ThunderstormTwoTone");
var _thunderstormTwoToneDefault = parcelHelpers.interopDefault(_thunderstormTwoTone);
var _timeToLeave = require("./TimeToLeave");
var _timeToLeaveDefault = parcelHelpers.interopDefault(_timeToLeave);
var _timeToLeaveOutlined = require("./TimeToLeaveOutlined");
var _timeToLeaveOutlinedDefault = parcelHelpers.interopDefault(_timeToLeaveOutlined);
var _timeToLeaveRounded = require("./TimeToLeaveRounded");
var _timeToLeaveRoundedDefault = parcelHelpers.interopDefault(_timeToLeaveRounded);
var _timeToLeaveSharp = require("./TimeToLeaveSharp");
var _timeToLeaveSharpDefault = parcelHelpers.interopDefault(_timeToLeaveSharp);
var _timeToLeaveTwoTone = require("./TimeToLeaveTwoTone");
var _timeToLeaveTwoToneDefault = parcelHelpers.interopDefault(_timeToLeaveTwoTone);
var _timelapse = require("./Timelapse");
var _timelapseDefault = parcelHelpers.interopDefault(_timelapse);
var _timelapseOutlined = require("./TimelapseOutlined");
var _timelapseOutlinedDefault = parcelHelpers.interopDefault(_timelapseOutlined);
var _timelapseRounded = require("./TimelapseRounded");
var _timelapseRoundedDefault = parcelHelpers.interopDefault(_timelapseRounded);
var _timelapseSharp = require("./TimelapseSharp");
var _timelapseSharpDefault = parcelHelpers.interopDefault(_timelapseSharp);
var _timelapseTwoTone = require("./TimelapseTwoTone");
var _timelapseTwoToneDefault = parcelHelpers.interopDefault(_timelapseTwoTone);
var _timeline = require("./Timeline");
var _timelineDefault = parcelHelpers.interopDefault(_timeline);
var _timelineOutlined = require("./TimelineOutlined");
var _timelineOutlinedDefault = parcelHelpers.interopDefault(_timelineOutlined);
var _timelineRounded = require("./TimelineRounded");
var _timelineRoundedDefault = parcelHelpers.interopDefault(_timelineRounded);
var _timelineSharp = require("./TimelineSharp");
var _timelineSharpDefault = parcelHelpers.interopDefault(_timelineSharp);
var _timelineTwoTone = require("./TimelineTwoTone");
var _timelineTwoToneDefault = parcelHelpers.interopDefault(_timelineTwoTone);
var _timer = require("./Timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _timer10 = require("./Timer10");
var _timer10Default = parcelHelpers.interopDefault(_timer10);
var _timer10Outlined = require("./Timer10Outlined");
var _timer10OutlinedDefault = parcelHelpers.interopDefault(_timer10Outlined);
var _timer10Rounded = require("./Timer10Rounded");
var _timer10RoundedDefault = parcelHelpers.interopDefault(_timer10Rounded);
var _timer10Select = require("./Timer10Select");
var _timer10SelectDefault = parcelHelpers.interopDefault(_timer10Select);
var _timer10SelectOutlined = require("./Timer10SelectOutlined");
var _timer10SelectOutlinedDefault = parcelHelpers.interopDefault(_timer10SelectOutlined);
var _timer10SelectRounded = require("./Timer10SelectRounded");
var _timer10SelectRoundedDefault = parcelHelpers.interopDefault(_timer10SelectRounded);
var _timer10SelectSharp = require("./Timer10SelectSharp");
var _timer10SelectSharpDefault = parcelHelpers.interopDefault(_timer10SelectSharp);
var _timer10SelectTwoTone = require("./Timer10SelectTwoTone");
var _timer10SelectTwoToneDefault = parcelHelpers.interopDefault(_timer10SelectTwoTone);
var _timer10Sharp = require("./Timer10Sharp");
var _timer10SharpDefault = parcelHelpers.interopDefault(_timer10Sharp);
var _timer10TwoTone = require("./Timer10TwoTone");
var _timer10TwoToneDefault = parcelHelpers.interopDefault(_timer10TwoTone);
var _timer3 = require("./Timer3");
var _timer3Default = parcelHelpers.interopDefault(_timer3);
var _timer3Outlined = require("./Timer3Outlined");
var _timer3OutlinedDefault = parcelHelpers.interopDefault(_timer3Outlined);
var _timer3Rounded = require("./Timer3Rounded");
var _timer3RoundedDefault = parcelHelpers.interopDefault(_timer3Rounded);
var _timer3Select = require("./Timer3Select");
var _timer3SelectDefault = parcelHelpers.interopDefault(_timer3Select);
var _timer3SelectOutlined = require("./Timer3SelectOutlined");
var _timer3SelectOutlinedDefault = parcelHelpers.interopDefault(_timer3SelectOutlined);
var _timer3SelectRounded = require("./Timer3SelectRounded");
var _timer3SelectRoundedDefault = parcelHelpers.interopDefault(_timer3SelectRounded);
var _timer3SelectSharp = require("./Timer3SelectSharp");
var _timer3SelectSharpDefault = parcelHelpers.interopDefault(_timer3SelectSharp);
var _timer3SelectTwoTone = require("./Timer3SelectTwoTone");
var _timer3SelectTwoToneDefault = parcelHelpers.interopDefault(_timer3SelectTwoTone);
var _timer3Sharp = require("./Timer3Sharp");
var _timer3SharpDefault = parcelHelpers.interopDefault(_timer3Sharp);
var _timer3TwoTone = require("./Timer3TwoTone");
var _timer3TwoToneDefault = parcelHelpers.interopDefault(_timer3TwoTone);
var _timerOff = require("./TimerOff");
var _timerOffDefault = parcelHelpers.interopDefault(_timerOff);
var _timerOffOutlined = require("./TimerOffOutlined");
var _timerOffOutlinedDefault = parcelHelpers.interopDefault(_timerOffOutlined);
var _timerOffRounded = require("./TimerOffRounded");
var _timerOffRoundedDefault = parcelHelpers.interopDefault(_timerOffRounded);
var _timerOffSharp = require("./TimerOffSharp");
var _timerOffSharpDefault = parcelHelpers.interopDefault(_timerOffSharp);
var _timerOffTwoTone = require("./TimerOffTwoTone");
var _timerOffTwoToneDefault = parcelHelpers.interopDefault(_timerOffTwoTone);
var _timerOutlined = require("./TimerOutlined");
var _timerOutlinedDefault = parcelHelpers.interopDefault(_timerOutlined);
var _timerRounded = require("./TimerRounded");
var _timerRoundedDefault = parcelHelpers.interopDefault(_timerRounded);
var _timerSharp = require("./TimerSharp");
var _timerSharpDefault = parcelHelpers.interopDefault(_timerSharp);
var _timerTwoTone = require("./TimerTwoTone");
var _timerTwoToneDefault = parcelHelpers.interopDefault(_timerTwoTone);
var _timesOneMobiledata = require("./TimesOneMobiledata");
var _timesOneMobiledataDefault = parcelHelpers.interopDefault(_timesOneMobiledata);
var _timesOneMobiledataOutlined = require("./TimesOneMobiledataOutlined");
var _timesOneMobiledataOutlinedDefault = parcelHelpers.interopDefault(_timesOneMobiledataOutlined);
var _timesOneMobiledataRounded = require("./TimesOneMobiledataRounded");
var _timesOneMobiledataRoundedDefault = parcelHelpers.interopDefault(_timesOneMobiledataRounded);
var _timesOneMobiledataSharp = require("./TimesOneMobiledataSharp");
var _timesOneMobiledataSharpDefault = parcelHelpers.interopDefault(_timesOneMobiledataSharp);
var _timesOneMobiledataTwoTone = require("./TimesOneMobiledataTwoTone");
var _timesOneMobiledataTwoToneDefault = parcelHelpers.interopDefault(_timesOneMobiledataTwoTone);
var _tipsAndUpdates = require("./TipsAndUpdates");
var _tipsAndUpdatesDefault = parcelHelpers.interopDefault(_tipsAndUpdates);
var _tipsAndUpdatesOutlined = require("./TipsAndUpdatesOutlined");
var _tipsAndUpdatesOutlinedDefault = parcelHelpers.interopDefault(_tipsAndUpdatesOutlined);
var _tipsAndUpdatesRounded = require("./TipsAndUpdatesRounded");
var _tipsAndUpdatesRoundedDefault = parcelHelpers.interopDefault(_tipsAndUpdatesRounded);
var _tipsAndUpdatesSharp = require("./TipsAndUpdatesSharp");
var _tipsAndUpdatesSharpDefault = parcelHelpers.interopDefault(_tipsAndUpdatesSharp);
var _tipsAndUpdatesTwoTone = require("./TipsAndUpdatesTwoTone");
var _tipsAndUpdatesTwoToneDefault = parcelHelpers.interopDefault(_tipsAndUpdatesTwoTone);
var _tireRepair = require("./TireRepair");
var _tireRepairDefault = parcelHelpers.interopDefault(_tireRepair);
var _tireRepairOutlined = require("./TireRepairOutlined");
var _tireRepairOutlinedDefault = parcelHelpers.interopDefault(_tireRepairOutlined);
var _tireRepairRounded = require("./TireRepairRounded");
var _tireRepairRoundedDefault = parcelHelpers.interopDefault(_tireRepairRounded);
var _tireRepairSharp = require("./TireRepairSharp");
var _tireRepairSharpDefault = parcelHelpers.interopDefault(_tireRepairSharp);
var _tireRepairTwoTone = require("./TireRepairTwoTone");
var _tireRepairTwoToneDefault = parcelHelpers.interopDefault(_tireRepairTwoTone);
var _title = require("./Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _titleOutlined = require("./TitleOutlined");
var _titleOutlinedDefault = parcelHelpers.interopDefault(_titleOutlined);
var _titleRounded = require("./TitleRounded");
var _titleRoundedDefault = parcelHelpers.interopDefault(_titleRounded);
var _titleSharp = require("./TitleSharp");
var _titleSharpDefault = parcelHelpers.interopDefault(_titleSharp);
var _titleTwoTone = require("./TitleTwoTone");
var _titleTwoToneDefault = parcelHelpers.interopDefault(_titleTwoTone);
var _toc = require("./Toc");
var _tocDefault = parcelHelpers.interopDefault(_toc);
var _tocOutlined = require("./TocOutlined");
var _tocOutlinedDefault = parcelHelpers.interopDefault(_tocOutlined);
var _tocRounded = require("./TocRounded");
var _tocRoundedDefault = parcelHelpers.interopDefault(_tocRounded);
var _tocSharp = require("./TocSharp");
var _tocSharpDefault = parcelHelpers.interopDefault(_tocSharp);
var _tocTwoTone = require("./TocTwoTone");
var _tocTwoToneDefault = parcelHelpers.interopDefault(_tocTwoTone);
var _today = require("./Today");
var _todayDefault = parcelHelpers.interopDefault(_today);
var _todayOutlined = require("./TodayOutlined");
var _todayOutlinedDefault = parcelHelpers.interopDefault(_todayOutlined);
var _todayRounded = require("./TodayRounded");
var _todayRoundedDefault = parcelHelpers.interopDefault(_todayRounded);
var _todaySharp = require("./TodaySharp");
var _todaySharpDefault = parcelHelpers.interopDefault(_todaySharp);
var _todayTwoTone = require("./TodayTwoTone");
var _todayTwoToneDefault = parcelHelpers.interopDefault(_todayTwoTone);
var _toggleOff = require("./ToggleOff");
var _toggleOffDefault = parcelHelpers.interopDefault(_toggleOff);
var _toggleOffOutlined = require("./ToggleOffOutlined");
var _toggleOffOutlinedDefault = parcelHelpers.interopDefault(_toggleOffOutlined);
var _toggleOffRounded = require("./ToggleOffRounded");
var _toggleOffRoundedDefault = parcelHelpers.interopDefault(_toggleOffRounded);
var _toggleOffSharp = require("./ToggleOffSharp");
var _toggleOffSharpDefault = parcelHelpers.interopDefault(_toggleOffSharp);
var _toggleOffTwoTone = require("./ToggleOffTwoTone");
var _toggleOffTwoToneDefault = parcelHelpers.interopDefault(_toggleOffTwoTone);
var _toggleOn = require("./ToggleOn");
var _toggleOnDefault = parcelHelpers.interopDefault(_toggleOn);
var _toggleOnOutlined = require("./ToggleOnOutlined");
var _toggleOnOutlinedDefault = parcelHelpers.interopDefault(_toggleOnOutlined);
var _toggleOnRounded = require("./ToggleOnRounded");
var _toggleOnRoundedDefault = parcelHelpers.interopDefault(_toggleOnRounded);
var _toggleOnSharp = require("./ToggleOnSharp");
var _toggleOnSharpDefault = parcelHelpers.interopDefault(_toggleOnSharp);
var _toggleOnTwoTone = require("./ToggleOnTwoTone");
var _toggleOnTwoToneDefault = parcelHelpers.interopDefault(_toggleOnTwoTone);
var _token = require("./Token");
var _tokenDefault = parcelHelpers.interopDefault(_token);
var _tokenOutlined = require("./TokenOutlined");
var _tokenOutlinedDefault = parcelHelpers.interopDefault(_tokenOutlined);
var _tokenRounded = require("./TokenRounded");
var _tokenRoundedDefault = parcelHelpers.interopDefault(_tokenRounded);
var _tokenSharp = require("./TokenSharp");
var _tokenSharpDefault = parcelHelpers.interopDefault(_tokenSharp);
var _tokenTwoTone = require("./TokenTwoTone");
var _tokenTwoToneDefault = parcelHelpers.interopDefault(_tokenTwoTone);
var _toll = require("./Toll");
var _tollDefault = parcelHelpers.interopDefault(_toll);
var _tollOutlined = require("./TollOutlined");
var _tollOutlinedDefault = parcelHelpers.interopDefault(_tollOutlined);
var _tollRounded = require("./TollRounded");
var _tollRoundedDefault = parcelHelpers.interopDefault(_tollRounded);
var _tollSharp = require("./TollSharp");
var _tollSharpDefault = parcelHelpers.interopDefault(_tollSharp);
var _tollTwoTone = require("./TollTwoTone");
var _tollTwoToneDefault = parcelHelpers.interopDefault(_tollTwoTone);
var _tonality = require("./Tonality");
var _tonalityDefault = parcelHelpers.interopDefault(_tonality);
var _tonalityOutlined = require("./TonalityOutlined");
var _tonalityOutlinedDefault = parcelHelpers.interopDefault(_tonalityOutlined);
var _tonalityRounded = require("./TonalityRounded");
var _tonalityRoundedDefault = parcelHelpers.interopDefault(_tonalityRounded);
var _tonalitySharp = require("./TonalitySharp");
var _tonalitySharpDefault = parcelHelpers.interopDefault(_tonalitySharp);
var _tonalityTwoTone = require("./TonalityTwoTone");
var _tonalityTwoToneDefault = parcelHelpers.interopDefault(_tonalityTwoTone);
var _topic = require("./Topic");
var _topicDefault = parcelHelpers.interopDefault(_topic);
var _topicOutlined = require("./TopicOutlined");
var _topicOutlinedDefault = parcelHelpers.interopDefault(_topicOutlined);
var _topicRounded = require("./TopicRounded");
var _topicRoundedDefault = parcelHelpers.interopDefault(_topicRounded);
var _topicSharp = require("./TopicSharp");
var _topicSharpDefault = parcelHelpers.interopDefault(_topicSharp);
var _topicTwoTone = require("./TopicTwoTone");
var _topicTwoToneDefault = parcelHelpers.interopDefault(_topicTwoTone);
var _tornado = require("./Tornado");
var _tornadoDefault = parcelHelpers.interopDefault(_tornado);
var _tornadoOutlined = require("./TornadoOutlined");
var _tornadoOutlinedDefault = parcelHelpers.interopDefault(_tornadoOutlined);
var _tornadoRounded = require("./TornadoRounded");
var _tornadoRoundedDefault = parcelHelpers.interopDefault(_tornadoRounded);
var _tornadoSharp = require("./TornadoSharp");
var _tornadoSharpDefault = parcelHelpers.interopDefault(_tornadoSharp);
var _tornadoTwoTone = require("./TornadoTwoTone");
var _tornadoTwoToneDefault = parcelHelpers.interopDefault(_tornadoTwoTone);
var _touchApp = require("./TouchApp");
var _touchAppDefault = parcelHelpers.interopDefault(_touchApp);
var _touchAppOutlined = require("./TouchAppOutlined");
var _touchAppOutlinedDefault = parcelHelpers.interopDefault(_touchAppOutlined);
var _touchAppRounded = require("./TouchAppRounded");
var _touchAppRoundedDefault = parcelHelpers.interopDefault(_touchAppRounded);
var _touchAppSharp = require("./TouchAppSharp");
var _touchAppSharpDefault = parcelHelpers.interopDefault(_touchAppSharp);
var _touchAppTwoTone = require("./TouchAppTwoTone");
var _touchAppTwoToneDefault = parcelHelpers.interopDefault(_touchAppTwoTone);
var _tour = require("./Tour");
var _tourDefault = parcelHelpers.interopDefault(_tour);
var _tourOutlined = require("./TourOutlined");
var _tourOutlinedDefault = parcelHelpers.interopDefault(_tourOutlined);
var _tourRounded = require("./TourRounded");
var _tourRoundedDefault = parcelHelpers.interopDefault(_tourRounded);
var _tourSharp = require("./TourSharp");
var _tourSharpDefault = parcelHelpers.interopDefault(_tourSharp);
var _tourTwoTone = require("./TourTwoTone");
var _tourTwoToneDefault = parcelHelpers.interopDefault(_tourTwoTone);
var _toys = require("./Toys");
var _toysDefault = parcelHelpers.interopDefault(_toys);
var _toysOutlined = require("./ToysOutlined");
var _toysOutlinedDefault = parcelHelpers.interopDefault(_toysOutlined);
var _toysRounded = require("./ToysRounded");
var _toysRoundedDefault = parcelHelpers.interopDefault(_toysRounded);
var _toysSharp = require("./ToysSharp");
var _toysSharpDefault = parcelHelpers.interopDefault(_toysSharp);
var _toysTwoTone = require("./ToysTwoTone");
var _toysTwoToneDefault = parcelHelpers.interopDefault(_toysTwoTone);
var _trackChanges = require("./TrackChanges");
var _trackChangesDefault = parcelHelpers.interopDefault(_trackChanges);
var _trackChangesOutlined = require("./TrackChangesOutlined");
var _trackChangesOutlinedDefault = parcelHelpers.interopDefault(_trackChangesOutlined);
var _trackChangesRounded = require("./TrackChangesRounded");
var _trackChangesRoundedDefault = parcelHelpers.interopDefault(_trackChangesRounded);
var _trackChangesSharp = require("./TrackChangesSharp");
var _trackChangesSharpDefault = parcelHelpers.interopDefault(_trackChangesSharp);
var _trackChangesTwoTone = require("./TrackChangesTwoTone");
var _trackChangesTwoToneDefault = parcelHelpers.interopDefault(_trackChangesTwoTone);
var _traffic = require("./Traffic");
var _trafficDefault = parcelHelpers.interopDefault(_traffic);
var _trafficOutlined = require("./TrafficOutlined");
var _trafficOutlinedDefault = parcelHelpers.interopDefault(_trafficOutlined);
var _trafficRounded = require("./TrafficRounded");
var _trafficRoundedDefault = parcelHelpers.interopDefault(_trafficRounded);
var _trafficSharp = require("./TrafficSharp");
var _trafficSharpDefault = parcelHelpers.interopDefault(_trafficSharp);
var _trafficTwoTone = require("./TrafficTwoTone");
var _trafficTwoToneDefault = parcelHelpers.interopDefault(_trafficTwoTone);
var _train = require("./Train");
var _trainDefault = parcelHelpers.interopDefault(_train);
var _trainOutlined = require("./TrainOutlined");
var _trainOutlinedDefault = parcelHelpers.interopDefault(_trainOutlined);
var _trainRounded = require("./TrainRounded");
var _trainRoundedDefault = parcelHelpers.interopDefault(_trainRounded);
var _trainSharp = require("./TrainSharp");
var _trainSharpDefault = parcelHelpers.interopDefault(_trainSharp);
var _trainTwoTone = require("./TrainTwoTone");
var _trainTwoToneDefault = parcelHelpers.interopDefault(_trainTwoTone);
var _tram = require("./Tram");
var _tramDefault = parcelHelpers.interopDefault(_tram);
var _tramOutlined = require("./TramOutlined");
var _tramOutlinedDefault = parcelHelpers.interopDefault(_tramOutlined);
var _tramRounded = require("./TramRounded");
var _tramRoundedDefault = parcelHelpers.interopDefault(_tramRounded);
var _tramSharp = require("./TramSharp");
var _tramSharpDefault = parcelHelpers.interopDefault(_tramSharp);
var _tramTwoTone = require("./TramTwoTone");
var _tramTwoToneDefault = parcelHelpers.interopDefault(_tramTwoTone);
var _transcribe = require("./Transcribe");
var _transcribeDefault = parcelHelpers.interopDefault(_transcribe);
var _transcribeOutlined = require("./TranscribeOutlined");
var _transcribeOutlinedDefault = parcelHelpers.interopDefault(_transcribeOutlined);
var _transcribeRounded = require("./TranscribeRounded");
var _transcribeRoundedDefault = parcelHelpers.interopDefault(_transcribeRounded);
var _transcribeSharp = require("./TranscribeSharp");
var _transcribeSharpDefault = parcelHelpers.interopDefault(_transcribeSharp);
var _transcribeTwoTone = require("./TranscribeTwoTone");
var _transcribeTwoToneDefault = parcelHelpers.interopDefault(_transcribeTwoTone);
var _transferWithinAStation = require("./TransferWithinAStation");
var _transferWithinAStationDefault = parcelHelpers.interopDefault(_transferWithinAStation);
var _transferWithinAStationOutlined = require("./TransferWithinAStationOutlined");
var _transferWithinAStationOutlinedDefault = parcelHelpers.interopDefault(_transferWithinAStationOutlined);
var _transferWithinAStationRounded = require("./TransferWithinAStationRounded");
var _transferWithinAStationRoundedDefault = parcelHelpers.interopDefault(_transferWithinAStationRounded);
var _transferWithinAStationSharp = require("./TransferWithinAStationSharp");
var _transferWithinAStationSharpDefault = parcelHelpers.interopDefault(_transferWithinAStationSharp);
var _transferWithinAStationTwoTone = require("./TransferWithinAStationTwoTone");
var _transferWithinAStationTwoToneDefault = parcelHelpers.interopDefault(_transferWithinAStationTwoTone);
var _transform = require("./Transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
var _transformOutlined = require("./TransformOutlined");
var _transformOutlinedDefault = parcelHelpers.interopDefault(_transformOutlined);
var _transformRounded = require("./TransformRounded");
var _transformRoundedDefault = parcelHelpers.interopDefault(_transformRounded);
var _transformSharp = require("./TransformSharp");
var _transformSharpDefault = parcelHelpers.interopDefault(_transformSharp);
var _transformTwoTone = require("./TransformTwoTone");
var _transformTwoToneDefault = parcelHelpers.interopDefault(_transformTwoTone);
var _transgender = require("./Transgender");
var _transgenderDefault = parcelHelpers.interopDefault(_transgender);
var _transgenderOutlined = require("./TransgenderOutlined");
var _transgenderOutlinedDefault = parcelHelpers.interopDefault(_transgenderOutlined);
var _transgenderRounded = require("./TransgenderRounded");
var _transgenderRoundedDefault = parcelHelpers.interopDefault(_transgenderRounded);
var _transgenderSharp = require("./TransgenderSharp");
var _transgenderSharpDefault = parcelHelpers.interopDefault(_transgenderSharp);
var _transgenderTwoTone = require("./TransgenderTwoTone");
var _transgenderTwoToneDefault = parcelHelpers.interopDefault(_transgenderTwoTone);
var _transitEnterexit = require("./TransitEnterexit");
var _transitEnterexitDefault = parcelHelpers.interopDefault(_transitEnterexit);
var _transitEnterexitOutlined = require("./TransitEnterexitOutlined");
var _transitEnterexitOutlinedDefault = parcelHelpers.interopDefault(_transitEnterexitOutlined);
var _transitEnterexitRounded = require("./TransitEnterexitRounded");
var _transitEnterexitRoundedDefault = parcelHelpers.interopDefault(_transitEnterexitRounded);
var _transitEnterexitSharp = require("./TransitEnterexitSharp");
var _transitEnterexitSharpDefault = parcelHelpers.interopDefault(_transitEnterexitSharp);
var _transitEnterexitTwoTone = require("./TransitEnterexitTwoTone");
var _transitEnterexitTwoToneDefault = parcelHelpers.interopDefault(_transitEnterexitTwoTone);
var _translate = require("./Translate");
var _translateDefault = parcelHelpers.interopDefault(_translate);
var _translateOutlined = require("./TranslateOutlined");
var _translateOutlinedDefault = parcelHelpers.interopDefault(_translateOutlined);
var _translateRounded = require("./TranslateRounded");
var _translateRoundedDefault = parcelHelpers.interopDefault(_translateRounded);
var _translateSharp = require("./TranslateSharp");
var _translateSharpDefault = parcelHelpers.interopDefault(_translateSharp);
var _translateTwoTone = require("./TranslateTwoTone");
var _translateTwoToneDefault = parcelHelpers.interopDefault(_translateTwoTone);
var _travelExplore = require("./TravelExplore");
var _travelExploreDefault = parcelHelpers.interopDefault(_travelExplore);
var _travelExploreOutlined = require("./TravelExploreOutlined");
var _travelExploreOutlinedDefault = parcelHelpers.interopDefault(_travelExploreOutlined);
var _travelExploreRounded = require("./TravelExploreRounded");
var _travelExploreRoundedDefault = parcelHelpers.interopDefault(_travelExploreRounded);
var _travelExploreSharp = require("./TravelExploreSharp");
var _travelExploreSharpDefault = parcelHelpers.interopDefault(_travelExploreSharp);
var _travelExploreTwoTone = require("./TravelExploreTwoTone");
var _travelExploreTwoToneDefault = parcelHelpers.interopDefault(_travelExploreTwoTone);
var _trendingDown = require("./TrendingDown");
var _trendingDownDefault = parcelHelpers.interopDefault(_trendingDown);
var _trendingDownOutlined = require("./TrendingDownOutlined");
var _trendingDownOutlinedDefault = parcelHelpers.interopDefault(_trendingDownOutlined);
var _trendingDownRounded = require("./TrendingDownRounded");
var _trendingDownRoundedDefault = parcelHelpers.interopDefault(_trendingDownRounded);
var _trendingDownSharp = require("./TrendingDownSharp");
var _trendingDownSharpDefault = parcelHelpers.interopDefault(_trendingDownSharp);
var _trendingDownTwoTone = require("./TrendingDownTwoTone");
var _trendingDownTwoToneDefault = parcelHelpers.interopDefault(_trendingDownTwoTone);
var _trendingFlat = require("./TrendingFlat");
var _trendingFlatDefault = parcelHelpers.interopDefault(_trendingFlat);
var _trendingFlatOutlined = require("./TrendingFlatOutlined");
var _trendingFlatOutlinedDefault = parcelHelpers.interopDefault(_trendingFlatOutlined);
var _trendingFlatRounded = require("./TrendingFlatRounded");
var _trendingFlatRoundedDefault = parcelHelpers.interopDefault(_trendingFlatRounded);
var _trendingFlatSharp = require("./TrendingFlatSharp");
var _trendingFlatSharpDefault = parcelHelpers.interopDefault(_trendingFlatSharp);
var _trendingFlatTwoTone = require("./TrendingFlatTwoTone");
var _trendingFlatTwoToneDefault = parcelHelpers.interopDefault(_trendingFlatTwoTone);
var _trendingUp = require("./TrendingUp");
var _trendingUpDefault = parcelHelpers.interopDefault(_trendingUp);
var _trendingUpOutlined = require("./TrendingUpOutlined");
var _trendingUpOutlinedDefault = parcelHelpers.interopDefault(_trendingUpOutlined);
var _trendingUpRounded = require("./TrendingUpRounded");
var _trendingUpRoundedDefault = parcelHelpers.interopDefault(_trendingUpRounded);
var _trendingUpSharp = require("./TrendingUpSharp");
var _trendingUpSharpDefault = parcelHelpers.interopDefault(_trendingUpSharp);
var _trendingUpTwoTone = require("./TrendingUpTwoTone");
var _trendingUpTwoToneDefault = parcelHelpers.interopDefault(_trendingUpTwoTone);
var _tripOrigin = require("./TripOrigin");
var _tripOriginDefault = parcelHelpers.interopDefault(_tripOrigin);
var _tripOriginOutlined = require("./TripOriginOutlined");
var _tripOriginOutlinedDefault = parcelHelpers.interopDefault(_tripOriginOutlined);
var _tripOriginRounded = require("./TripOriginRounded");
var _tripOriginRoundedDefault = parcelHelpers.interopDefault(_tripOriginRounded);
var _tripOriginSharp = require("./TripOriginSharp");
var _tripOriginSharpDefault = parcelHelpers.interopDefault(_tripOriginSharp);
var _tripOriginTwoTone = require("./TripOriginTwoTone");
var _tripOriginTwoToneDefault = parcelHelpers.interopDefault(_tripOriginTwoTone);
var _troubleshoot = require("./Troubleshoot");
var _troubleshootDefault = parcelHelpers.interopDefault(_troubleshoot);
var _troubleshootOutlined = require("./TroubleshootOutlined");
var _troubleshootOutlinedDefault = parcelHelpers.interopDefault(_troubleshootOutlined);
var _troubleshootRounded = require("./TroubleshootRounded");
var _troubleshootRoundedDefault = parcelHelpers.interopDefault(_troubleshootRounded);
var _troubleshootSharp = require("./TroubleshootSharp");
var _troubleshootSharpDefault = parcelHelpers.interopDefault(_troubleshootSharp);
var _troubleshootTwoTone = require("./TroubleshootTwoTone");
var _troubleshootTwoToneDefault = parcelHelpers.interopDefault(_troubleshootTwoTone);
var _try = require("./Try");
var _tryDefault = parcelHelpers.interopDefault(_try);
var _tryOutlined = require("./TryOutlined");
var _tryOutlinedDefault = parcelHelpers.interopDefault(_tryOutlined);
var _tryRounded = require("./TryRounded");
var _tryRoundedDefault = parcelHelpers.interopDefault(_tryRounded);
var _trySharp = require("./TrySharp");
var _trySharpDefault = parcelHelpers.interopDefault(_trySharp);
var _tryTwoTone = require("./TryTwoTone");
var _tryTwoToneDefault = parcelHelpers.interopDefault(_tryTwoTone);
var _tsunami = require("./Tsunami");
var _tsunamiDefault = parcelHelpers.interopDefault(_tsunami);
var _tsunamiOutlined = require("./TsunamiOutlined");
var _tsunamiOutlinedDefault = parcelHelpers.interopDefault(_tsunamiOutlined);
var _tsunamiRounded = require("./TsunamiRounded");
var _tsunamiRoundedDefault = parcelHelpers.interopDefault(_tsunamiRounded);
var _tsunamiSharp = require("./TsunamiSharp");
var _tsunamiSharpDefault = parcelHelpers.interopDefault(_tsunamiSharp);
var _tsunamiTwoTone = require("./TsunamiTwoTone");
var _tsunamiTwoToneDefault = parcelHelpers.interopDefault(_tsunamiTwoTone);
var _tty = require("./Tty");
var _ttyDefault = parcelHelpers.interopDefault(_tty);
var _ttyOutlined = require("./TtyOutlined");
var _ttyOutlinedDefault = parcelHelpers.interopDefault(_ttyOutlined);
var _ttyRounded = require("./TtyRounded");
var _ttyRoundedDefault = parcelHelpers.interopDefault(_ttyRounded);
var _ttySharp = require("./TtySharp");
var _ttySharpDefault = parcelHelpers.interopDefault(_ttySharp);
var _ttyTwoTone = require("./TtyTwoTone");
var _ttyTwoToneDefault = parcelHelpers.interopDefault(_ttyTwoTone);
var _tune = require("./Tune");
var _tuneDefault = parcelHelpers.interopDefault(_tune);
var _tuneOutlined = require("./TuneOutlined");
var _tuneOutlinedDefault = parcelHelpers.interopDefault(_tuneOutlined);
var _tuneRounded = require("./TuneRounded");
var _tuneRoundedDefault = parcelHelpers.interopDefault(_tuneRounded);
var _tuneSharp = require("./TuneSharp");
var _tuneSharpDefault = parcelHelpers.interopDefault(_tuneSharp);
var _tuneTwoTone = require("./TuneTwoTone");
var _tuneTwoToneDefault = parcelHelpers.interopDefault(_tuneTwoTone);
var _tungsten = require("./Tungsten");
var _tungstenDefault = parcelHelpers.interopDefault(_tungsten);
var _tungstenOutlined = require("./TungstenOutlined");
var _tungstenOutlinedDefault = parcelHelpers.interopDefault(_tungstenOutlined);
var _tungstenRounded = require("./TungstenRounded");
var _tungstenRoundedDefault = parcelHelpers.interopDefault(_tungstenRounded);
var _tungstenSharp = require("./TungstenSharp");
var _tungstenSharpDefault = parcelHelpers.interopDefault(_tungstenSharp);
var _tungstenTwoTone = require("./TungstenTwoTone");
var _tungstenTwoToneDefault = parcelHelpers.interopDefault(_tungstenTwoTone);
var _turnLeft = require("./TurnLeft");
var _turnLeftDefault = parcelHelpers.interopDefault(_turnLeft);
var _turnLeftOutlined = require("./TurnLeftOutlined");
var _turnLeftOutlinedDefault = parcelHelpers.interopDefault(_turnLeftOutlined);
var _turnLeftRounded = require("./TurnLeftRounded");
var _turnLeftRoundedDefault = parcelHelpers.interopDefault(_turnLeftRounded);
var _turnLeftSharp = require("./TurnLeftSharp");
var _turnLeftSharpDefault = parcelHelpers.interopDefault(_turnLeftSharp);
var _turnLeftTwoTone = require("./TurnLeftTwoTone");
var _turnLeftTwoToneDefault = parcelHelpers.interopDefault(_turnLeftTwoTone);
var _turnRight = require("./TurnRight");
var _turnRightDefault = parcelHelpers.interopDefault(_turnRight);
var _turnRightOutlined = require("./TurnRightOutlined");
var _turnRightOutlinedDefault = parcelHelpers.interopDefault(_turnRightOutlined);
var _turnRightRounded = require("./TurnRightRounded");
var _turnRightRoundedDefault = parcelHelpers.interopDefault(_turnRightRounded);
var _turnRightSharp = require("./TurnRightSharp");
var _turnRightSharpDefault = parcelHelpers.interopDefault(_turnRightSharp);
var _turnRightTwoTone = require("./TurnRightTwoTone");
var _turnRightTwoToneDefault = parcelHelpers.interopDefault(_turnRightTwoTone);
var _turnSharpLeft = require("./TurnSharpLeft");
var _turnSharpLeftDefault = parcelHelpers.interopDefault(_turnSharpLeft);
var _turnSharpLeftOutlined = require("./TurnSharpLeftOutlined");
var _turnSharpLeftOutlinedDefault = parcelHelpers.interopDefault(_turnSharpLeftOutlined);
var _turnSharpLeftRounded = require("./TurnSharpLeftRounded");
var _turnSharpLeftRoundedDefault = parcelHelpers.interopDefault(_turnSharpLeftRounded);
var _turnSharpLeftSharp = require("./TurnSharpLeftSharp");
var _turnSharpLeftSharpDefault = parcelHelpers.interopDefault(_turnSharpLeftSharp);
var _turnSharpLeftTwoTone = require("./TurnSharpLeftTwoTone");
var _turnSharpLeftTwoToneDefault = parcelHelpers.interopDefault(_turnSharpLeftTwoTone);
var _turnSharpRight = require("./TurnSharpRight");
var _turnSharpRightDefault = parcelHelpers.interopDefault(_turnSharpRight);
var _turnSharpRightOutlined = require("./TurnSharpRightOutlined");
var _turnSharpRightOutlinedDefault = parcelHelpers.interopDefault(_turnSharpRightOutlined);
var _turnSharpRightRounded = require("./TurnSharpRightRounded");
var _turnSharpRightRoundedDefault = parcelHelpers.interopDefault(_turnSharpRightRounded);
var _turnSharpRightSharp = require("./TurnSharpRightSharp");
var _turnSharpRightSharpDefault = parcelHelpers.interopDefault(_turnSharpRightSharp);
var _turnSharpRightTwoTone = require("./TurnSharpRightTwoTone");
var _turnSharpRightTwoToneDefault = parcelHelpers.interopDefault(_turnSharpRightTwoTone);
var _turnSlightLeft = require("./TurnSlightLeft");
var _turnSlightLeftDefault = parcelHelpers.interopDefault(_turnSlightLeft);
var _turnSlightLeftOutlined = require("./TurnSlightLeftOutlined");
var _turnSlightLeftOutlinedDefault = parcelHelpers.interopDefault(_turnSlightLeftOutlined);
var _turnSlightLeftRounded = require("./TurnSlightLeftRounded");
var _turnSlightLeftRoundedDefault = parcelHelpers.interopDefault(_turnSlightLeftRounded);
var _turnSlightLeftSharp = require("./TurnSlightLeftSharp");
var _turnSlightLeftSharpDefault = parcelHelpers.interopDefault(_turnSlightLeftSharp);
var _turnSlightLeftTwoTone = require("./TurnSlightLeftTwoTone");
var _turnSlightLeftTwoToneDefault = parcelHelpers.interopDefault(_turnSlightLeftTwoTone);
var _turnSlightRight = require("./TurnSlightRight");
var _turnSlightRightDefault = parcelHelpers.interopDefault(_turnSlightRight);
var _turnSlightRightOutlined = require("./TurnSlightRightOutlined");
var _turnSlightRightOutlinedDefault = parcelHelpers.interopDefault(_turnSlightRightOutlined);
var _turnSlightRightRounded = require("./TurnSlightRightRounded");
var _turnSlightRightRoundedDefault = parcelHelpers.interopDefault(_turnSlightRightRounded);
var _turnSlightRightSharp = require("./TurnSlightRightSharp");
var _turnSlightRightSharpDefault = parcelHelpers.interopDefault(_turnSlightRightSharp);
var _turnSlightRightTwoTone = require("./TurnSlightRightTwoTone");
var _turnSlightRightTwoToneDefault = parcelHelpers.interopDefault(_turnSlightRightTwoTone);
var _turnedIn = require("./TurnedIn");
var _turnedInDefault = parcelHelpers.interopDefault(_turnedIn);
var _turnedInNot = require("./TurnedInNot");
var _turnedInNotDefault = parcelHelpers.interopDefault(_turnedInNot);
var _turnedInNotOutlined = require("./TurnedInNotOutlined");
var _turnedInNotOutlinedDefault = parcelHelpers.interopDefault(_turnedInNotOutlined);
var _turnedInNotRounded = require("./TurnedInNotRounded");
var _turnedInNotRoundedDefault = parcelHelpers.interopDefault(_turnedInNotRounded);
var _turnedInNotSharp = require("./TurnedInNotSharp");
var _turnedInNotSharpDefault = parcelHelpers.interopDefault(_turnedInNotSharp);
var _turnedInNotTwoTone = require("./TurnedInNotTwoTone");
var _turnedInNotTwoToneDefault = parcelHelpers.interopDefault(_turnedInNotTwoTone);
var _turnedInOutlined = require("./TurnedInOutlined");
var _turnedInOutlinedDefault = parcelHelpers.interopDefault(_turnedInOutlined);
var _turnedInRounded = require("./TurnedInRounded");
var _turnedInRoundedDefault = parcelHelpers.interopDefault(_turnedInRounded);
var _turnedInSharp = require("./TurnedInSharp");
var _turnedInSharpDefault = parcelHelpers.interopDefault(_turnedInSharp);
var _turnedInTwoTone = require("./TurnedInTwoTone");
var _turnedInTwoToneDefault = parcelHelpers.interopDefault(_turnedInTwoTone);
var _tv = require("./Tv");
var _tvDefault = parcelHelpers.interopDefault(_tv);
var _tvOff = require("./TvOff");
var _tvOffDefault = parcelHelpers.interopDefault(_tvOff);
var _tvOffOutlined = require("./TvOffOutlined");
var _tvOffOutlinedDefault = parcelHelpers.interopDefault(_tvOffOutlined);
var _tvOffRounded = require("./TvOffRounded");
var _tvOffRoundedDefault = parcelHelpers.interopDefault(_tvOffRounded);
var _tvOffSharp = require("./TvOffSharp");
var _tvOffSharpDefault = parcelHelpers.interopDefault(_tvOffSharp);
var _tvOffTwoTone = require("./TvOffTwoTone");
var _tvOffTwoToneDefault = parcelHelpers.interopDefault(_tvOffTwoTone);
var _tvOutlined = require("./TvOutlined");
var _tvOutlinedDefault = parcelHelpers.interopDefault(_tvOutlined);
var _tvRounded = require("./TvRounded");
var _tvRoundedDefault = parcelHelpers.interopDefault(_tvRounded);
var _tvSharp = require("./TvSharp");
var _tvSharpDefault = parcelHelpers.interopDefault(_tvSharp);
var _tvTwoTone = require("./TvTwoTone");
var _tvTwoToneDefault = parcelHelpers.interopDefault(_tvTwoTone);
var _twelveMp = require("./TwelveMp");
var _twelveMpDefault = parcelHelpers.interopDefault(_twelveMp);
var _twelveMpOutlined = require("./TwelveMpOutlined");
var _twelveMpOutlinedDefault = parcelHelpers.interopDefault(_twelveMpOutlined);
var _twelveMpRounded = require("./TwelveMpRounded");
var _twelveMpRoundedDefault = parcelHelpers.interopDefault(_twelveMpRounded);
var _twelveMpSharp = require("./TwelveMpSharp");
var _twelveMpSharpDefault = parcelHelpers.interopDefault(_twelveMpSharp);
var _twelveMpTwoTone = require("./TwelveMpTwoTone");
var _twelveMpTwoToneDefault = parcelHelpers.interopDefault(_twelveMpTwoTone);
var _twentyFourMp = require("./TwentyFourMp");
var _twentyFourMpDefault = parcelHelpers.interopDefault(_twentyFourMp);
var _twentyFourMpOutlined = require("./TwentyFourMpOutlined");
var _twentyFourMpOutlinedDefault = parcelHelpers.interopDefault(_twentyFourMpOutlined);
var _twentyFourMpRounded = require("./TwentyFourMpRounded");
var _twentyFourMpRoundedDefault = parcelHelpers.interopDefault(_twentyFourMpRounded);
var _twentyFourMpSharp = require("./TwentyFourMpSharp");
var _twentyFourMpSharpDefault = parcelHelpers.interopDefault(_twentyFourMpSharp);
var _twentyFourMpTwoTone = require("./TwentyFourMpTwoTone");
var _twentyFourMpTwoToneDefault = parcelHelpers.interopDefault(_twentyFourMpTwoTone);
var _twentyOneMp = require("./TwentyOneMp");
var _twentyOneMpDefault = parcelHelpers.interopDefault(_twentyOneMp);
var _twentyOneMpOutlined = require("./TwentyOneMpOutlined");
var _twentyOneMpOutlinedDefault = parcelHelpers.interopDefault(_twentyOneMpOutlined);
var _twentyOneMpRounded = require("./TwentyOneMpRounded");
var _twentyOneMpRoundedDefault = parcelHelpers.interopDefault(_twentyOneMpRounded);
var _twentyOneMpSharp = require("./TwentyOneMpSharp");
var _twentyOneMpSharpDefault = parcelHelpers.interopDefault(_twentyOneMpSharp);
var _twentyOneMpTwoTone = require("./TwentyOneMpTwoTone");
var _twentyOneMpTwoToneDefault = parcelHelpers.interopDefault(_twentyOneMpTwoTone);
var _twentyThreeMp = require("./TwentyThreeMp");
var _twentyThreeMpDefault = parcelHelpers.interopDefault(_twentyThreeMp);
var _twentyThreeMpOutlined = require("./TwentyThreeMpOutlined");
var _twentyThreeMpOutlinedDefault = parcelHelpers.interopDefault(_twentyThreeMpOutlined);
var _twentyThreeMpRounded = require("./TwentyThreeMpRounded");
var _twentyThreeMpRoundedDefault = parcelHelpers.interopDefault(_twentyThreeMpRounded);
var _twentyThreeMpSharp = require("./TwentyThreeMpSharp");
var _twentyThreeMpSharpDefault = parcelHelpers.interopDefault(_twentyThreeMpSharp);
var _twentyThreeMpTwoTone = require("./TwentyThreeMpTwoTone");
var _twentyThreeMpTwoToneDefault = parcelHelpers.interopDefault(_twentyThreeMpTwoTone);
var _twentyTwoMp = require("./TwentyTwoMp");
var _twentyTwoMpDefault = parcelHelpers.interopDefault(_twentyTwoMp);
var _twentyTwoMpOutlined = require("./TwentyTwoMpOutlined");
var _twentyTwoMpOutlinedDefault = parcelHelpers.interopDefault(_twentyTwoMpOutlined);
var _twentyTwoMpRounded = require("./TwentyTwoMpRounded");
var _twentyTwoMpRoundedDefault = parcelHelpers.interopDefault(_twentyTwoMpRounded);
var _twentyTwoMpSharp = require("./TwentyTwoMpSharp");
var _twentyTwoMpSharpDefault = parcelHelpers.interopDefault(_twentyTwoMpSharp);
var _twentyTwoMpTwoTone = require("./TwentyTwoMpTwoTone");
var _twentyTwoMpTwoToneDefault = parcelHelpers.interopDefault(_twentyTwoMpTwoTone);
var _twentyZeroMp = require("./TwentyZeroMp");
var _twentyZeroMpDefault = parcelHelpers.interopDefault(_twentyZeroMp);
var _twentyZeroMpOutlined = require("./TwentyZeroMpOutlined");
var _twentyZeroMpOutlinedDefault = parcelHelpers.interopDefault(_twentyZeroMpOutlined);
var _twentyZeroMpRounded = require("./TwentyZeroMpRounded");
var _twentyZeroMpRoundedDefault = parcelHelpers.interopDefault(_twentyZeroMpRounded);
var _twentyZeroMpSharp = require("./TwentyZeroMpSharp");
var _twentyZeroMpSharpDefault = parcelHelpers.interopDefault(_twentyZeroMpSharp);
var _twentyZeroMpTwoTone = require("./TwentyZeroMpTwoTone");
var _twentyZeroMpTwoToneDefault = parcelHelpers.interopDefault(_twentyZeroMpTwoTone);
var _twitter = require("./Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _twoK = require("./TwoK");
var _twoKDefault = parcelHelpers.interopDefault(_twoK);
var _twoKOutlined = require("./TwoKOutlined");
var _twoKOutlinedDefault = parcelHelpers.interopDefault(_twoKOutlined);
var _twoKPlus = require("./TwoKPlus");
var _twoKPlusDefault = parcelHelpers.interopDefault(_twoKPlus);
var _twoKPlusOutlined = require("./TwoKPlusOutlined");
var _twoKPlusOutlinedDefault = parcelHelpers.interopDefault(_twoKPlusOutlined);
var _twoKPlusRounded = require("./TwoKPlusRounded");
var _twoKPlusRoundedDefault = parcelHelpers.interopDefault(_twoKPlusRounded);
var _twoKPlusSharp = require("./TwoKPlusSharp");
var _twoKPlusSharpDefault = parcelHelpers.interopDefault(_twoKPlusSharp);
var _twoKPlusTwoTone = require("./TwoKPlusTwoTone");
var _twoKPlusTwoToneDefault = parcelHelpers.interopDefault(_twoKPlusTwoTone);
var _twoKRounded = require("./TwoKRounded");
var _twoKRoundedDefault = parcelHelpers.interopDefault(_twoKRounded);
var _twoKSharp = require("./TwoKSharp");
var _twoKSharpDefault = parcelHelpers.interopDefault(_twoKSharp);
var _twoKTwoTone = require("./TwoKTwoTone");
var _twoKTwoToneDefault = parcelHelpers.interopDefault(_twoKTwoTone);
var _twoMp = require("./TwoMp");
var _twoMpDefault = parcelHelpers.interopDefault(_twoMp);
var _twoMpOutlined = require("./TwoMpOutlined");
var _twoMpOutlinedDefault = parcelHelpers.interopDefault(_twoMpOutlined);
var _twoMpRounded = require("./TwoMpRounded");
var _twoMpRoundedDefault = parcelHelpers.interopDefault(_twoMpRounded);
var _twoMpSharp = require("./TwoMpSharp");
var _twoMpSharpDefault = parcelHelpers.interopDefault(_twoMpSharp);
var _twoMpTwoTone = require("./TwoMpTwoTone");
var _twoMpTwoToneDefault = parcelHelpers.interopDefault(_twoMpTwoTone);
var _twoWheeler = require("./TwoWheeler");
var _twoWheelerDefault = parcelHelpers.interopDefault(_twoWheeler);
var _twoWheelerOutlined = require("./TwoWheelerOutlined");
var _twoWheelerOutlinedDefault = parcelHelpers.interopDefault(_twoWheelerOutlined);
var _twoWheelerRounded = require("./TwoWheelerRounded");
var _twoWheelerRoundedDefault = parcelHelpers.interopDefault(_twoWheelerRounded);
var _twoWheelerSharp = require("./TwoWheelerSharp");
var _twoWheelerSharpDefault = parcelHelpers.interopDefault(_twoWheelerSharp);
var _twoWheelerTwoTone = require("./TwoWheelerTwoTone");
var _twoWheelerTwoToneDefault = parcelHelpers.interopDefault(_twoWheelerTwoTone);
var _typeSpecimen = require("./TypeSpecimen");
var _typeSpecimenDefault = parcelHelpers.interopDefault(_typeSpecimen);
var _typeSpecimenOutlined = require("./TypeSpecimenOutlined");
var _typeSpecimenOutlinedDefault = parcelHelpers.interopDefault(_typeSpecimenOutlined);
var _typeSpecimenRounded = require("./TypeSpecimenRounded");
var _typeSpecimenRoundedDefault = parcelHelpers.interopDefault(_typeSpecimenRounded);
var _typeSpecimenSharp = require("./TypeSpecimenSharp");
var _typeSpecimenSharpDefault = parcelHelpers.interopDefault(_typeSpecimenSharp);
var _typeSpecimenTwoTone = require("./TypeSpecimenTwoTone");
var _typeSpecimenTwoToneDefault = parcelHelpers.interopDefault(_typeSpecimenTwoTone);
var _uturnLeft = require("./UTurnLeft");
var _uturnLeftDefault = parcelHelpers.interopDefault(_uturnLeft);
var _uturnLeftOutlined = require("./UTurnLeftOutlined");
var _uturnLeftOutlinedDefault = parcelHelpers.interopDefault(_uturnLeftOutlined);
var _uturnLeftRounded = require("./UTurnLeftRounded");
var _uturnLeftRoundedDefault = parcelHelpers.interopDefault(_uturnLeftRounded);
var _uturnLeftSharp = require("./UTurnLeftSharp");
var _uturnLeftSharpDefault = parcelHelpers.interopDefault(_uturnLeftSharp);
var _uturnLeftTwoTone = require("./UTurnLeftTwoTone");
var _uturnLeftTwoToneDefault = parcelHelpers.interopDefault(_uturnLeftTwoTone);
var _uturnRight = require("./UTurnRight");
var _uturnRightDefault = parcelHelpers.interopDefault(_uturnRight);
var _uturnRightOutlined = require("./UTurnRightOutlined");
var _uturnRightOutlinedDefault = parcelHelpers.interopDefault(_uturnRightOutlined);
var _uturnRightRounded = require("./UTurnRightRounded");
var _uturnRightRoundedDefault = parcelHelpers.interopDefault(_uturnRightRounded);
var _uturnRightSharp = require("./UTurnRightSharp");
var _uturnRightSharpDefault = parcelHelpers.interopDefault(_uturnRightSharp);
var _uturnRightTwoTone = require("./UTurnRightTwoTone");
var _uturnRightTwoToneDefault = parcelHelpers.interopDefault(_uturnRightTwoTone);
var _umbrella = require("./Umbrella");
var _umbrellaDefault = parcelHelpers.interopDefault(_umbrella);
var _umbrellaOutlined = require("./UmbrellaOutlined");
var _umbrellaOutlinedDefault = parcelHelpers.interopDefault(_umbrellaOutlined);
var _umbrellaRounded = require("./UmbrellaRounded");
var _umbrellaRoundedDefault = parcelHelpers.interopDefault(_umbrellaRounded);
var _umbrellaSharp = require("./UmbrellaSharp");
var _umbrellaSharpDefault = parcelHelpers.interopDefault(_umbrellaSharp);
var _umbrellaTwoTone = require("./UmbrellaTwoTone");
var _umbrellaTwoToneDefault = parcelHelpers.interopDefault(_umbrellaTwoTone);
var _unarchive = require("./Unarchive");
var _unarchiveDefault = parcelHelpers.interopDefault(_unarchive);
var _unarchiveOutlined = require("./UnarchiveOutlined");
var _unarchiveOutlinedDefault = parcelHelpers.interopDefault(_unarchiveOutlined);
var _unarchiveRounded = require("./UnarchiveRounded");
var _unarchiveRoundedDefault = parcelHelpers.interopDefault(_unarchiveRounded);
var _unarchiveSharp = require("./UnarchiveSharp");
var _unarchiveSharpDefault = parcelHelpers.interopDefault(_unarchiveSharp);
var _unarchiveTwoTone = require("./UnarchiveTwoTone");
var _unarchiveTwoToneDefault = parcelHelpers.interopDefault(_unarchiveTwoTone);
var _undo = require("./Undo");
var _undoDefault = parcelHelpers.interopDefault(_undo);
var _undoOutlined = require("./UndoOutlined");
var _undoOutlinedDefault = parcelHelpers.interopDefault(_undoOutlined);
var _undoRounded = require("./UndoRounded");
var _undoRoundedDefault = parcelHelpers.interopDefault(_undoRounded);
var _undoSharp = require("./UndoSharp");
var _undoSharpDefault = parcelHelpers.interopDefault(_undoSharp);
var _undoTwoTone = require("./UndoTwoTone");
var _undoTwoToneDefault = parcelHelpers.interopDefault(_undoTwoTone);
var _unfoldLess = require("./UnfoldLess");
var _unfoldLessDefault = parcelHelpers.interopDefault(_unfoldLess);
var _unfoldLessDouble = require("./UnfoldLessDouble");
var _unfoldLessDoubleDefault = parcelHelpers.interopDefault(_unfoldLessDouble);
var _unfoldLessDoubleOutlined = require("./UnfoldLessDoubleOutlined");
var _unfoldLessDoubleOutlinedDefault = parcelHelpers.interopDefault(_unfoldLessDoubleOutlined);
var _unfoldLessDoubleRounded = require("./UnfoldLessDoubleRounded");
var _unfoldLessDoubleRoundedDefault = parcelHelpers.interopDefault(_unfoldLessDoubleRounded);
var _unfoldLessDoubleSharp = require("./UnfoldLessDoubleSharp");
var _unfoldLessDoubleSharpDefault = parcelHelpers.interopDefault(_unfoldLessDoubleSharp);
var _unfoldLessDoubleTwoTone = require("./UnfoldLessDoubleTwoTone");
var _unfoldLessDoubleTwoToneDefault = parcelHelpers.interopDefault(_unfoldLessDoubleTwoTone);
var _unfoldLessOutlined = require("./UnfoldLessOutlined");
var _unfoldLessOutlinedDefault = parcelHelpers.interopDefault(_unfoldLessOutlined);
var _unfoldLessRounded = require("./UnfoldLessRounded");
var _unfoldLessRoundedDefault = parcelHelpers.interopDefault(_unfoldLessRounded);
var _unfoldLessSharp = require("./UnfoldLessSharp");
var _unfoldLessSharpDefault = parcelHelpers.interopDefault(_unfoldLessSharp);
var _unfoldLessTwoTone = require("./UnfoldLessTwoTone");
var _unfoldLessTwoToneDefault = parcelHelpers.interopDefault(_unfoldLessTwoTone);
var _unfoldMore = require("./UnfoldMore");
var _unfoldMoreDefault = parcelHelpers.interopDefault(_unfoldMore);
var _unfoldMoreDouble = require("./UnfoldMoreDouble");
var _unfoldMoreDoubleDefault = parcelHelpers.interopDefault(_unfoldMoreDouble);
var _unfoldMoreDoubleOutlined = require("./UnfoldMoreDoubleOutlined");
var _unfoldMoreDoubleOutlinedDefault = parcelHelpers.interopDefault(_unfoldMoreDoubleOutlined);
var _unfoldMoreDoubleRounded = require("./UnfoldMoreDoubleRounded");
var _unfoldMoreDoubleRoundedDefault = parcelHelpers.interopDefault(_unfoldMoreDoubleRounded);
var _unfoldMoreDoubleSharp = require("./UnfoldMoreDoubleSharp");
var _unfoldMoreDoubleSharpDefault = parcelHelpers.interopDefault(_unfoldMoreDoubleSharp);
var _unfoldMoreDoubleTwoTone = require("./UnfoldMoreDoubleTwoTone");
var _unfoldMoreDoubleTwoToneDefault = parcelHelpers.interopDefault(_unfoldMoreDoubleTwoTone);
var _unfoldMoreOutlined = require("./UnfoldMoreOutlined");
var _unfoldMoreOutlinedDefault = parcelHelpers.interopDefault(_unfoldMoreOutlined);
var _unfoldMoreRounded = require("./UnfoldMoreRounded");
var _unfoldMoreRoundedDefault = parcelHelpers.interopDefault(_unfoldMoreRounded);
var _unfoldMoreSharp = require("./UnfoldMoreSharp");
var _unfoldMoreSharpDefault = parcelHelpers.interopDefault(_unfoldMoreSharp);
var _unfoldMoreTwoTone = require("./UnfoldMoreTwoTone");
var _unfoldMoreTwoToneDefault = parcelHelpers.interopDefault(_unfoldMoreTwoTone);
var _unpublished = require("./Unpublished");
var _unpublishedDefault = parcelHelpers.interopDefault(_unpublished);
var _unpublishedOutlined = require("./UnpublishedOutlined");
var _unpublishedOutlinedDefault = parcelHelpers.interopDefault(_unpublishedOutlined);
var _unpublishedRounded = require("./UnpublishedRounded");
var _unpublishedRoundedDefault = parcelHelpers.interopDefault(_unpublishedRounded);
var _unpublishedSharp = require("./UnpublishedSharp");
var _unpublishedSharpDefault = parcelHelpers.interopDefault(_unpublishedSharp);
var _unpublishedTwoTone = require("./UnpublishedTwoTone");
var _unpublishedTwoToneDefault = parcelHelpers.interopDefault(_unpublishedTwoTone);
var _unsubscribe = require("./Unsubscribe");
var _unsubscribeDefault = parcelHelpers.interopDefault(_unsubscribe);
var _unsubscribeOutlined = require("./UnsubscribeOutlined");
var _unsubscribeOutlinedDefault = parcelHelpers.interopDefault(_unsubscribeOutlined);
var _unsubscribeRounded = require("./UnsubscribeRounded");
var _unsubscribeRoundedDefault = parcelHelpers.interopDefault(_unsubscribeRounded);
var _unsubscribeSharp = require("./UnsubscribeSharp");
var _unsubscribeSharpDefault = parcelHelpers.interopDefault(_unsubscribeSharp);
var _unsubscribeTwoTone = require("./UnsubscribeTwoTone");
var _unsubscribeTwoToneDefault = parcelHelpers.interopDefault(_unsubscribeTwoTone);
var _upcoming = require("./Upcoming");
var _upcomingDefault = parcelHelpers.interopDefault(_upcoming);
var _upcomingOutlined = require("./UpcomingOutlined");
var _upcomingOutlinedDefault = parcelHelpers.interopDefault(_upcomingOutlined);
var _upcomingRounded = require("./UpcomingRounded");
var _upcomingRoundedDefault = parcelHelpers.interopDefault(_upcomingRounded);
var _upcomingSharp = require("./UpcomingSharp");
var _upcomingSharpDefault = parcelHelpers.interopDefault(_upcomingSharp);
var _upcomingTwoTone = require("./UpcomingTwoTone");
var _upcomingTwoToneDefault = parcelHelpers.interopDefault(_upcomingTwoTone);
var _update = require("./Update");
var _updateDefault = parcelHelpers.interopDefault(_update);
var _updateDisabled = require("./UpdateDisabled");
var _updateDisabledDefault = parcelHelpers.interopDefault(_updateDisabled);
var _updateDisabledOutlined = require("./UpdateDisabledOutlined");
var _updateDisabledOutlinedDefault = parcelHelpers.interopDefault(_updateDisabledOutlined);
var _updateDisabledRounded = require("./UpdateDisabledRounded");
var _updateDisabledRoundedDefault = parcelHelpers.interopDefault(_updateDisabledRounded);
var _updateDisabledSharp = require("./UpdateDisabledSharp");
var _updateDisabledSharpDefault = parcelHelpers.interopDefault(_updateDisabledSharp);
var _updateDisabledTwoTone = require("./UpdateDisabledTwoTone");
var _updateDisabledTwoToneDefault = parcelHelpers.interopDefault(_updateDisabledTwoTone);
var _updateOutlined = require("./UpdateOutlined");
var _updateOutlinedDefault = parcelHelpers.interopDefault(_updateOutlined);
var _updateRounded = require("./UpdateRounded");
var _updateRoundedDefault = parcelHelpers.interopDefault(_updateRounded);
var _updateSharp = require("./UpdateSharp");
var _updateSharpDefault = parcelHelpers.interopDefault(_updateSharp);
var _updateTwoTone = require("./UpdateTwoTone");
var _updateTwoToneDefault = parcelHelpers.interopDefault(_updateTwoTone);
var _upgrade = require("./Upgrade");
var _upgradeDefault = parcelHelpers.interopDefault(_upgrade);
var _upgradeOutlined = require("./UpgradeOutlined");
var _upgradeOutlinedDefault = parcelHelpers.interopDefault(_upgradeOutlined);
var _upgradeRounded = require("./UpgradeRounded");
var _upgradeRoundedDefault = parcelHelpers.interopDefault(_upgradeRounded);
var _upgradeSharp = require("./UpgradeSharp");
var _upgradeSharpDefault = parcelHelpers.interopDefault(_upgradeSharp);
var _upgradeTwoTone = require("./UpgradeTwoTone");
var _upgradeTwoToneDefault = parcelHelpers.interopDefault(_upgradeTwoTone);
var _upload = require("./Upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _uploadFile = require("./UploadFile");
var _uploadFileDefault = parcelHelpers.interopDefault(_uploadFile);
var _uploadFileOutlined = require("./UploadFileOutlined");
var _uploadFileOutlinedDefault = parcelHelpers.interopDefault(_uploadFileOutlined);
var _uploadFileRounded = require("./UploadFileRounded");
var _uploadFileRoundedDefault = parcelHelpers.interopDefault(_uploadFileRounded);
var _uploadFileSharp = require("./UploadFileSharp");
var _uploadFileSharpDefault = parcelHelpers.interopDefault(_uploadFileSharp);
var _uploadFileTwoTone = require("./UploadFileTwoTone");
var _uploadFileTwoToneDefault = parcelHelpers.interopDefault(_uploadFileTwoTone);
var _uploadOutlined = require("./UploadOutlined");
var _uploadOutlinedDefault = parcelHelpers.interopDefault(_uploadOutlined);
var _uploadRounded = require("./UploadRounded");
var _uploadRoundedDefault = parcelHelpers.interopDefault(_uploadRounded);
var _uploadSharp = require("./UploadSharp");
var _uploadSharpDefault = parcelHelpers.interopDefault(_uploadSharp);
var _uploadTwoTone = require("./UploadTwoTone");
var _uploadTwoToneDefault = parcelHelpers.interopDefault(_uploadTwoTone);
var _usb = require("./Usb");
var _usbDefault = parcelHelpers.interopDefault(_usb);
var _usbOff = require("./UsbOff");
var _usbOffDefault = parcelHelpers.interopDefault(_usbOff);
var _usbOffOutlined = require("./UsbOffOutlined");
var _usbOffOutlinedDefault = parcelHelpers.interopDefault(_usbOffOutlined);
var _usbOffRounded = require("./UsbOffRounded");
var _usbOffRoundedDefault = parcelHelpers.interopDefault(_usbOffRounded);
var _usbOffSharp = require("./UsbOffSharp");
var _usbOffSharpDefault = parcelHelpers.interopDefault(_usbOffSharp);
var _usbOffTwoTone = require("./UsbOffTwoTone");
var _usbOffTwoToneDefault = parcelHelpers.interopDefault(_usbOffTwoTone);
var _usbOutlined = require("./UsbOutlined");
var _usbOutlinedDefault = parcelHelpers.interopDefault(_usbOutlined);
var _usbRounded = require("./UsbRounded");
var _usbRoundedDefault = parcelHelpers.interopDefault(_usbRounded);
var _usbSharp = require("./UsbSharp");
var _usbSharpDefault = parcelHelpers.interopDefault(_usbSharp);
var _usbTwoTone = require("./UsbTwoTone");
var _usbTwoToneDefault = parcelHelpers.interopDefault(_usbTwoTone);
var _vaccines = require("./Vaccines");
var _vaccinesDefault = parcelHelpers.interopDefault(_vaccines);
var _vaccinesOutlined = require("./VaccinesOutlined");
var _vaccinesOutlinedDefault = parcelHelpers.interopDefault(_vaccinesOutlined);
var _vaccinesRounded = require("./VaccinesRounded");
var _vaccinesRoundedDefault = parcelHelpers.interopDefault(_vaccinesRounded);
var _vaccinesSharp = require("./VaccinesSharp");
var _vaccinesSharpDefault = parcelHelpers.interopDefault(_vaccinesSharp);
var _vaccinesTwoTone = require("./VaccinesTwoTone");
var _vaccinesTwoToneDefault = parcelHelpers.interopDefault(_vaccinesTwoTone);
var _vapeFree = require("./VapeFree");
var _vapeFreeDefault = parcelHelpers.interopDefault(_vapeFree);
var _vapeFreeOutlined = require("./VapeFreeOutlined");
var _vapeFreeOutlinedDefault = parcelHelpers.interopDefault(_vapeFreeOutlined);
var _vapeFreeRounded = require("./VapeFreeRounded");
var _vapeFreeRoundedDefault = parcelHelpers.interopDefault(_vapeFreeRounded);
var _vapeFreeSharp = require("./VapeFreeSharp");
var _vapeFreeSharpDefault = parcelHelpers.interopDefault(_vapeFreeSharp);
var _vapeFreeTwoTone = require("./VapeFreeTwoTone");
var _vapeFreeTwoToneDefault = parcelHelpers.interopDefault(_vapeFreeTwoTone);
var _vapingRooms = require("./VapingRooms");
var _vapingRoomsDefault = parcelHelpers.interopDefault(_vapingRooms);
var _vapingRoomsOutlined = require("./VapingRoomsOutlined");
var _vapingRoomsOutlinedDefault = parcelHelpers.interopDefault(_vapingRoomsOutlined);
var _vapingRoomsRounded = require("./VapingRoomsRounded");
var _vapingRoomsRoundedDefault = parcelHelpers.interopDefault(_vapingRoomsRounded);
var _vapingRoomsSharp = require("./VapingRoomsSharp");
var _vapingRoomsSharpDefault = parcelHelpers.interopDefault(_vapingRoomsSharp);
var _vapingRoomsTwoTone = require("./VapingRoomsTwoTone");
var _vapingRoomsTwoToneDefault = parcelHelpers.interopDefault(_vapingRoomsTwoTone);
var _verified = require("./Verified");
var _verifiedDefault = parcelHelpers.interopDefault(_verified);
var _verifiedOutlined = require("./VerifiedOutlined");
var _verifiedOutlinedDefault = parcelHelpers.interopDefault(_verifiedOutlined);
var _verifiedRounded = require("./VerifiedRounded");
var _verifiedRoundedDefault = parcelHelpers.interopDefault(_verifiedRounded);
var _verifiedSharp = require("./VerifiedSharp");
var _verifiedSharpDefault = parcelHelpers.interopDefault(_verifiedSharp);
var _verifiedTwoTone = require("./VerifiedTwoTone");
var _verifiedTwoToneDefault = parcelHelpers.interopDefault(_verifiedTwoTone);
var _verifiedUser = require("./VerifiedUser");
var _verifiedUserDefault = parcelHelpers.interopDefault(_verifiedUser);
var _verifiedUserOutlined = require("./VerifiedUserOutlined");
var _verifiedUserOutlinedDefault = parcelHelpers.interopDefault(_verifiedUserOutlined);
var _verifiedUserRounded = require("./VerifiedUserRounded");
var _verifiedUserRoundedDefault = parcelHelpers.interopDefault(_verifiedUserRounded);
var _verifiedUserSharp = require("./VerifiedUserSharp");
var _verifiedUserSharpDefault = parcelHelpers.interopDefault(_verifiedUserSharp);
var _verifiedUserTwoTone = require("./VerifiedUserTwoTone");
var _verifiedUserTwoToneDefault = parcelHelpers.interopDefault(_verifiedUserTwoTone);
var _verticalAlignBottom = require("./VerticalAlignBottom");
var _verticalAlignBottomDefault = parcelHelpers.interopDefault(_verticalAlignBottom);
var _verticalAlignBottomOutlined = require("./VerticalAlignBottomOutlined");
var _verticalAlignBottomOutlinedDefault = parcelHelpers.interopDefault(_verticalAlignBottomOutlined);
var _verticalAlignBottomRounded = require("./VerticalAlignBottomRounded");
var _verticalAlignBottomRoundedDefault = parcelHelpers.interopDefault(_verticalAlignBottomRounded);
var _verticalAlignBottomSharp = require("./VerticalAlignBottomSharp");
var _verticalAlignBottomSharpDefault = parcelHelpers.interopDefault(_verticalAlignBottomSharp);
var _verticalAlignBottomTwoTone = require("./VerticalAlignBottomTwoTone");
var _verticalAlignBottomTwoToneDefault = parcelHelpers.interopDefault(_verticalAlignBottomTwoTone);
var _verticalAlignCenter = require("./VerticalAlignCenter");
var _verticalAlignCenterDefault = parcelHelpers.interopDefault(_verticalAlignCenter);
var _verticalAlignCenterOutlined = require("./VerticalAlignCenterOutlined");
var _verticalAlignCenterOutlinedDefault = parcelHelpers.interopDefault(_verticalAlignCenterOutlined);
var _verticalAlignCenterRounded = require("./VerticalAlignCenterRounded");
var _verticalAlignCenterRoundedDefault = parcelHelpers.interopDefault(_verticalAlignCenterRounded);
var _verticalAlignCenterSharp = require("./VerticalAlignCenterSharp");
var _verticalAlignCenterSharpDefault = parcelHelpers.interopDefault(_verticalAlignCenterSharp);
var _verticalAlignCenterTwoTone = require("./VerticalAlignCenterTwoTone");
var _verticalAlignCenterTwoToneDefault = parcelHelpers.interopDefault(_verticalAlignCenterTwoTone);
var _verticalAlignTop = require("./VerticalAlignTop");
var _verticalAlignTopDefault = parcelHelpers.interopDefault(_verticalAlignTop);
var _verticalAlignTopOutlined = require("./VerticalAlignTopOutlined");
var _verticalAlignTopOutlinedDefault = parcelHelpers.interopDefault(_verticalAlignTopOutlined);
var _verticalAlignTopRounded = require("./VerticalAlignTopRounded");
var _verticalAlignTopRoundedDefault = parcelHelpers.interopDefault(_verticalAlignTopRounded);
var _verticalAlignTopSharp = require("./VerticalAlignTopSharp");
var _verticalAlignTopSharpDefault = parcelHelpers.interopDefault(_verticalAlignTopSharp);
var _verticalAlignTopTwoTone = require("./VerticalAlignTopTwoTone");
var _verticalAlignTopTwoToneDefault = parcelHelpers.interopDefault(_verticalAlignTopTwoTone);
var _verticalShades = require("./VerticalShades");
var _verticalShadesDefault = parcelHelpers.interopDefault(_verticalShades);
var _verticalShadesClosed = require("./VerticalShadesClosed");
var _verticalShadesClosedDefault = parcelHelpers.interopDefault(_verticalShadesClosed);
var _verticalShadesClosedOutlined = require("./VerticalShadesClosedOutlined");
var _verticalShadesClosedOutlinedDefault = parcelHelpers.interopDefault(_verticalShadesClosedOutlined);
var _verticalShadesClosedRounded = require("./VerticalShadesClosedRounded");
var _verticalShadesClosedRoundedDefault = parcelHelpers.interopDefault(_verticalShadesClosedRounded);
var _verticalShadesClosedSharp = require("./VerticalShadesClosedSharp");
var _verticalShadesClosedSharpDefault = parcelHelpers.interopDefault(_verticalShadesClosedSharp);
var _verticalShadesClosedTwoTone = require("./VerticalShadesClosedTwoTone");
var _verticalShadesClosedTwoToneDefault = parcelHelpers.interopDefault(_verticalShadesClosedTwoTone);
var _verticalShadesOutlined = require("./VerticalShadesOutlined");
var _verticalShadesOutlinedDefault = parcelHelpers.interopDefault(_verticalShadesOutlined);
var _verticalShadesRounded = require("./VerticalShadesRounded");
var _verticalShadesRoundedDefault = parcelHelpers.interopDefault(_verticalShadesRounded);
var _verticalShadesSharp = require("./VerticalShadesSharp");
var _verticalShadesSharpDefault = parcelHelpers.interopDefault(_verticalShadesSharp);
var _verticalShadesTwoTone = require("./VerticalShadesTwoTone");
var _verticalShadesTwoToneDefault = parcelHelpers.interopDefault(_verticalShadesTwoTone);
var _verticalSplit = require("./VerticalSplit");
var _verticalSplitDefault = parcelHelpers.interopDefault(_verticalSplit);
var _verticalSplitOutlined = require("./VerticalSplitOutlined");
var _verticalSplitOutlinedDefault = parcelHelpers.interopDefault(_verticalSplitOutlined);
var _verticalSplitRounded = require("./VerticalSplitRounded");
var _verticalSplitRoundedDefault = parcelHelpers.interopDefault(_verticalSplitRounded);
var _verticalSplitSharp = require("./VerticalSplitSharp");
var _verticalSplitSharpDefault = parcelHelpers.interopDefault(_verticalSplitSharp);
var _verticalSplitTwoTone = require("./VerticalSplitTwoTone");
var _verticalSplitTwoToneDefault = parcelHelpers.interopDefault(_verticalSplitTwoTone);
var _vibration = require("./Vibration");
var _vibrationDefault = parcelHelpers.interopDefault(_vibration);
var _vibrationOutlined = require("./VibrationOutlined");
var _vibrationOutlinedDefault = parcelHelpers.interopDefault(_vibrationOutlined);
var _vibrationRounded = require("./VibrationRounded");
var _vibrationRoundedDefault = parcelHelpers.interopDefault(_vibrationRounded);
var _vibrationSharp = require("./VibrationSharp");
var _vibrationSharpDefault = parcelHelpers.interopDefault(_vibrationSharp);
var _vibrationTwoTone = require("./VibrationTwoTone");
var _vibrationTwoToneDefault = parcelHelpers.interopDefault(_vibrationTwoTone);
var _videoCall = require("./VideoCall");
var _videoCallDefault = parcelHelpers.interopDefault(_videoCall);
var _videoCallOutlined = require("./VideoCallOutlined");
var _videoCallOutlinedDefault = parcelHelpers.interopDefault(_videoCallOutlined);
var _videoCallRounded = require("./VideoCallRounded");
var _videoCallRoundedDefault = parcelHelpers.interopDefault(_videoCallRounded);
var _videoCallSharp = require("./VideoCallSharp");
var _videoCallSharpDefault = parcelHelpers.interopDefault(_videoCallSharp);
var _videoCallTwoTone = require("./VideoCallTwoTone");
var _videoCallTwoToneDefault = parcelHelpers.interopDefault(_videoCallTwoTone);
var _videoCameraBack = require("./VideoCameraBack");
var _videoCameraBackDefault = parcelHelpers.interopDefault(_videoCameraBack);
var _videoCameraBackOutlined = require("./VideoCameraBackOutlined");
var _videoCameraBackOutlinedDefault = parcelHelpers.interopDefault(_videoCameraBackOutlined);
var _videoCameraBackRounded = require("./VideoCameraBackRounded");
var _videoCameraBackRoundedDefault = parcelHelpers.interopDefault(_videoCameraBackRounded);
var _videoCameraBackSharp = require("./VideoCameraBackSharp");
var _videoCameraBackSharpDefault = parcelHelpers.interopDefault(_videoCameraBackSharp);
var _videoCameraBackTwoTone = require("./VideoCameraBackTwoTone");
var _videoCameraBackTwoToneDefault = parcelHelpers.interopDefault(_videoCameraBackTwoTone);
var _videoCameraFront = require("./VideoCameraFront");
var _videoCameraFrontDefault = parcelHelpers.interopDefault(_videoCameraFront);
var _videoCameraFrontOutlined = require("./VideoCameraFrontOutlined");
var _videoCameraFrontOutlinedDefault = parcelHelpers.interopDefault(_videoCameraFrontOutlined);
var _videoCameraFrontRounded = require("./VideoCameraFrontRounded");
var _videoCameraFrontRoundedDefault = parcelHelpers.interopDefault(_videoCameraFrontRounded);
var _videoCameraFrontSharp = require("./VideoCameraFrontSharp");
var _videoCameraFrontSharpDefault = parcelHelpers.interopDefault(_videoCameraFrontSharp);
var _videoCameraFrontTwoTone = require("./VideoCameraFrontTwoTone");
var _videoCameraFrontTwoToneDefault = parcelHelpers.interopDefault(_videoCameraFrontTwoTone);
var _videoChat = require("./VideoChat");
var _videoChatDefault = parcelHelpers.interopDefault(_videoChat);
var _videoChatOutlined = require("./VideoChatOutlined");
var _videoChatOutlinedDefault = parcelHelpers.interopDefault(_videoChatOutlined);
var _videoChatRounded = require("./VideoChatRounded");
var _videoChatRoundedDefault = parcelHelpers.interopDefault(_videoChatRounded);
var _videoChatSharp = require("./VideoChatSharp");
var _videoChatSharpDefault = parcelHelpers.interopDefault(_videoChatSharp);
var _videoChatTwoTone = require("./VideoChatTwoTone");
var _videoChatTwoToneDefault = parcelHelpers.interopDefault(_videoChatTwoTone);
var _videoFile = require("./VideoFile");
var _videoFileDefault = parcelHelpers.interopDefault(_videoFile);
var _videoFileOutlined = require("./VideoFileOutlined");
var _videoFileOutlinedDefault = parcelHelpers.interopDefault(_videoFileOutlined);
var _videoFileRounded = require("./VideoFileRounded");
var _videoFileRoundedDefault = parcelHelpers.interopDefault(_videoFileRounded);
var _videoFileSharp = require("./VideoFileSharp");
var _videoFileSharpDefault = parcelHelpers.interopDefault(_videoFileSharp);
var _videoFileTwoTone = require("./VideoFileTwoTone");
var _videoFileTwoToneDefault = parcelHelpers.interopDefault(_videoFileTwoTone);
var _videoLabel = require("./VideoLabel");
var _videoLabelDefault = parcelHelpers.interopDefault(_videoLabel);
var _videoLabelOutlined = require("./VideoLabelOutlined");
var _videoLabelOutlinedDefault = parcelHelpers.interopDefault(_videoLabelOutlined);
var _videoLabelRounded = require("./VideoLabelRounded");
var _videoLabelRoundedDefault = parcelHelpers.interopDefault(_videoLabelRounded);
var _videoLabelSharp = require("./VideoLabelSharp");
var _videoLabelSharpDefault = parcelHelpers.interopDefault(_videoLabelSharp);
var _videoLabelTwoTone = require("./VideoLabelTwoTone");
var _videoLabelTwoToneDefault = parcelHelpers.interopDefault(_videoLabelTwoTone);
var _videoLibrary = require("./VideoLibrary");
var _videoLibraryDefault = parcelHelpers.interopDefault(_videoLibrary);
var _videoLibraryOutlined = require("./VideoLibraryOutlined");
var _videoLibraryOutlinedDefault = parcelHelpers.interopDefault(_videoLibraryOutlined);
var _videoLibraryRounded = require("./VideoLibraryRounded");
var _videoLibraryRoundedDefault = parcelHelpers.interopDefault(_videoLibraryRounded);
var _videoLibrarySharp = require("./VideoLibrarySharp");
var _videoLibrarySharpDefault = parcelHelpers.interopDefault(_videoLibrarySharp);
var _videoLibraryTwoTone = require("./VideoLibraryTwoTone");
var _videoLibraryTwoToneDefault = parcelHelpers.interopDefault(_videoLibraryTwoTone);
var _videoSettings = require("./VideoSettings");
var _videoSettingsDefault = parcelHelpers.interopDefault(_videoSettings);
var _videoSettingsOutlined = require("./VideoSettingsOutlined");
var _videoSettingsOutlinedDefault = parcelHelpers.interopDefault(_videoSettingsOutlined);
var _videoSettingsRounded = require("./VideoSettingsRounded");
var _videoSettingsRoundedDefault = parcelHelpers.interopDefault(_videoSettingsRounded);
var _videoSettingsSharp = require("./VideoSettingsSharp");
var _videoSettingsSharpDefault = parcelHelpers.interopDefault(_videoSettingsSharp);
var _videoSettingsTwoTone = require("./VideoSettingsTwoTone");
var _videoSettingsTwoToneDefault = parcelHelpers.interopDefault(_videoSettingsTwoTone);
var _videoStable = require("./VideoStable");
var _videoStableDefault = parcelHelpers.interopDefault(_videoStable);
var _videoStableOutlined = require("./VideoStableOutlined");
var _videoStableOutlinedDefault = parcelHelpers.interopDefault(_videoStableOutlined);
var _videoStableRounded = require("./VideoStableRounded");
var _videoStableRoundedDefault = parcelHelpers.interopDefault(_videoStableRounded);
var _videoStableSharp = require("./VideoStableSharp");
var _videoStableSharpDefault = parcelHelpers.interopDefault(_videoStableSharp);
var _videoStableTwoTone = require("./VideoStableTwoTone");
var _videoStableTwoToneDefault = parcelHelpers.interopDefault(_videoStableTwoTone);
var _videocam = require("./Videocam");
var _videocamDefault = parcelHelpers.interopDefault(_videocam);
var _videocamOff = require("./VideocamOff");
var _videocamOffDefault = parcelHelpers.interopDefault(_videocamOff);
var _videocamOffOutlined = require("./VideocamOffOutlined");
var _videocamOffOutlinedDefault = parcelHelpers.interopDefault(_videocamOffOutlined);
var _videocamOffRounded = require("./VideocamOffRounded");
var _videocamOffRoundedDefault = parcelHelpers.interopDefault(_videocamOffRounded);
var _videocamOffSharp = require("./VideocamOffSharp");
var _videocamOffSharpDefault = parcelHelpers.interopDefault(_videocamOffSharp);
var _videocamOffTwoTone = require("./VideocamOffTwoTone");
var _videocamOffTwoToneDefault = parcelHelpers.interopDefault(_videocamOffTwoTone);
var _videocamOutlined = require("./VideocamOutlined");
var _videocamOutlinedDefault = parcelHelpers.interopDefault(_videocamOutlined);
var _videocamRounded = require("./VideocamRounded");
var _videocamRoundedDefault = parcelHelpers.interopDefault(_videocamRounded);
var _videocamSharp = require("./VideocamSharp");
var _videocamSharpDefault = parcelHelpers.interopDefault(_videocamSharp);
var _videocamTwoTone = require("./VideocamTwoTone");
var _videocamTwoToneDefault = parcelHelpers.interopDefault(_videocamTwoTone);
var _videogameAsset = require("./VideogameAsset");
var _videogameAssetDefault = parcelHelpers.interopDefault(_videogameAsset);
var _videogameAssetOff = require("./VideogameAssetOff");
var _videogameAssetOffDefault = parcelHelpers.interopDefault(_videogameAssetOff);
var _videogameAssetOffOutlined = require("./VideogameAssetOffOutlined");
var _videogameAssetOffOutlinedDefault = parcelHelpers.interopDefault(_videogameAssetOffOutlined);
var _videogameAssetOffRounded = require("./VideogameAssetOffRounded");
var _videogameAssetOffRoundedDefault = parcelHelpers.interopDefault(_videogameAssetOffRounded);
var _videogameAssetOffSharp = require("./VideogameAssetOffSharp");
var _videogameAssetOffSharpDefault = parcelHelpers.interopDefault(_videogameAssetOffSharp);
var _videogameAssetOffTwoTone = require("./VideogameAssetOffTwoTone");
var _videogameAssetOffTwoToneDefault = parcelHelpers.interopDefault(_videogameAssetOffTwoTone);
var _videogameAssetOutlined = require("./VideogameAssetOutlined");
var _videogameAssetOutlinedDefault = parcelHelpers.interopDefault(_videogameAssetOutlined);
var _videogameAssetRounded = require("./VideogameAssetRounded");
var _videogameAssetRoundedDefault = parcelHelpers.interopDefault(_videogameAssetRounded);
var _videogameAssetSharp = require("./VideogameAssetSharp");
var _videogameAssetSharpDefault = parcelHelpers.interopDefault(_videogameAssetSharp);
var _videogameAssetTwoTone = require("./VideogameAssetTwoTone");
var _videogameAssetTwoToneDefault = parcelHelpers.interopDefault(_videogameAssetTwoTone);
var _viewAgenda = require("./ViewAgenda");
var _viewAgendaDefault = parcelHelpers.interopDefault(_viewAgenda);
var _viewAgendaOutlined = require("./ViewAgendaOutlined");
var _viewAgendaOutlinedDefault = parcelHelpers.interopDefault(_viewAgendaOutlined);
var _viewAgendaRounded = require("./ViewAgendaRounded");
var _viewAgendaRoundedDefault = parcelHelpers.interopDefault(_viewAgendaRounded);
var _viewAgendaSharp = require("./ViewAgendaSharp");
var _viewAgendaSharpDefault = parcelHelpers.interopDefault(_viewAgendaSharp);
var _viewAgendaTwoTone = require("./ViewAgendaTwoTone");
var _viewAgendaTwoToneDefault = parcelHelpers.interopDefault(_viewAgendaTwoTone);
var _viewArray = require("./ViewArray");
var _viewArrayDefault = parcelHelpers.interopDefault(_viewArray);
var _viewArrayOutlined = require("./ViewArrayOutlined");
var _viewArrayOutlinedDefault = parcelHelpers.interopDefault(_viewArrayOutlined);
var _viewArrayRounded = require("./ViewArrayRounded");
var _viewArrayRoundedDefault = parcelHelpers.interopDefault(_viewArrayRounded);
var _viewArraySharp = require("./ViewArraySharp");
var _viewArraySharpDefault = parcelHelpers.interopDefault(_viewArraySharp);
var _viewArrayTwoTone = require("./ViewArrayTwoTone");
var _viewArrayTwoToneDefault = parcelHelpers.interopDefault(_viewArrayTwoTone);
var _viewCarousel = require("./ViewCarousel");
var _viewCarouselDefault = parcelHelpers.interopDefault(_viewCarousel);
var _viewCarouselOutlined = require("./ViewCarouselOutlined");
var _viewCarouselOutlinedDefault = parcelHelpers.interopDefault(_viewCarouselOutlined);
var _viewCarouselRounded = require("./ViewCarouselRounded");
var _viewCarouselRoundedDefault = parcelHelpers.interopDefault(_viewCarouselRounded);
var _viewCarouselSharp = require("./ViewCarouselSharp");
var _viewCarouselSharpDefault = parcelHelpers.interopDefault(_viewCarouselSharp);
var _viewCarouselTwoTone = require("./ViewCarouselTwoTone");
var _viewCarouselTwoToneDefault = parcelHelpers.interopDefault(_viewCarouselTwoTone);
var _viewColumn = require("./ViewColumn");
var _viewColumnDefault = parcelHelpers.interopDefault(_viewColumn);
var _viewColumnOutlined = require("./ViewColumnOutlined");
var _viewColumnOutlinedDefault = parcelHelpers.interopDefault(_viewColumnOutlined);
var _viewColumnRounded = require("./ViewColumnRounded");
var _viewColumnRoundedDefault = parcelHelpers.interopDefault(_viewColumnRounded);
var _viewColumnSharp = require("./ViewColumnSharp");
var _viewColumnSharpDefault = parcelHelpers.interopDefault(_viewColumnSharp);
var _viewColumnTwoTone = require("./ViewColumnTwoTone");
var _viewColumnTwoToneDefault = parcelHelpers.interopDefault(_viewColumnTwoTone);
var _viewComfy = require("./ViewComfy");
var _viewComfyDefault = parcelHelpers.interopDefault(_viewComfy);
var _viewComfyAlt = require("./ViewComfyAlt");
var _viewComfyAltDefault = parcelHelpers.interopDefault(_viewComfyAlt);
var _viewComfyAltOutlined = require("./ViewComfyAltOutlined");
var _viewComfyAltOutlinedDefault = parcelHelpers.interopDefault(_viewComfyAltOutlined);
var _viewComfyAltRounded = require("./ViewComfyAltRounded");
var _viewComfyAltRoundedDefault = parcelHelpers.interopDefault(_viewComfyAltRounded);
var _viewComfyAltSharp = require("./ViewComfyAltSharp");
var _viewComfyAltSharpDefault = parcelHelpers.interopDefault(_viewComfyAltSharp);
var _viewComfyAltTwoTone = require("./ViewComfyAltTwoTone");
var _viewComfyAltTwoToneDefault = parcelHelpers.interopDefault(_viewComfyAltTwoTone);
var _viewComfyOutlined = require("./ViewComfyOutlined");
var _viewComfyOutlinedDefault = parcelHelpers.interopDefault(_viewComfyOutlined);
var _viewComfyRounded = require("./ViewComfyRounded");
var _viewComfyRoundedDefault = parcelHelpers.interopDefault(_viewComfyRounded);
var _viewComfySharp = require("./ViewComfySharp");
var _viewComfySharpDefault = parcelHelpers.interopDefault(_viewComfySharp);
var _viewComfyTwoTone = require("./ViewComfyTwoTone");
var _viewComfyTwoToneDefault = parcelHelpers.interopDefault(_viewComfyTwoTone);
var _viewCompact = require("./ViewCompact");
var _viewCompactDefault = parcelHelpers.interopDefault(_viewCompact);
var _viewCompactAlt = require("./ViewCompactAlt");
var _viewCompactAltDefault = parcelHelpers.interopDefault(_viewCompactAlt);
var _viewCompactAltOutlined = require("./ViewCompactAltOutlined");
var _viewCompactAltOutlinedDefault = parcelHelpers.interopDefault(_viewCompactAltOutlined);
var _viewCompactAltRounded = require("./ViewCompactAltRounded");
var _viewCompactAltRoundedDefault = parcelHelpers.interopDefault(_viewCompactAltRounded);
var _viewCompactAltSharp = require("./ViewCompactAltSharp");
var _viewCompactAltSharpDefault = parcelHelpers.interopDefault(_viewCompactAltSharp);
var _viewCompactAltTwoTone = require("./ViewCompactAltTwoTone");
var _viewCompactAltTwoToneDefault = parcelHelpers.interopDefault(_viewCompactAltTwoTone);
var _viewCompactOutlined = require("./ViewCompactOutlined");
var _viewCompactOutlinedDefault = parcelHelpers.interopDefault(_viewCompactOutlined);
var _viewCompactRounded = require("./ViewCompactRounded");
var _viewCompactRoundedDefault = parcelHelpers.interopDefault(_viewCompactRounded);
var _viewCompactSharp = require("./ViewCompactSharp");
var _viewCompactSharpDefault = parcelHelpers.interopDefault(_viewCompactSharp);
var _viewCompactTwoTone = require("./ViewCompactTwoTone");
var _viewCompactTwoToneDefault = parcelHelpers.interopDefault(_viewCompactTwoTone);
var _viewCozy = require("./ViewCozy");
var _viewCozyDefault = parcelHelpers.interopDefault(_viewCozy);
var _viewCozyOutlined = require("./ViewCozyOutlined");
var _viewCozyOutlinedDefault = parcelHelpers.interopDefault(_viewCozyOutlined);
var _viewCozyRounded = require("./ViewCozyRounded");
var _viewCozyRoundedDefault = parcelHelpers.interopDefault(_viewCozyRounded);
var _viewCozySharp = require("./ViewCozySharp");
var _viewCozySharpDefault = parcelHelpers.interopDefault(_viewCozySharp);
var _viewCozyTwoTone = require("./ViewCozyTwoTone");
var _viewCozyTwoToneDefault = parcelHelpers.interopDefault(_viewCozyTwoTone);
var _viewDay = require("./ViewDay");
var _viewDayDefault = parcelHelpers.interopDefault(_viewDay);
var _viewDayOutlined = require("./ViewDayOutlined");
var _viewDayOutlinedDefault = parcelHelpers.interopDefault(_viewDayOutlined);
var _viewDayRounded = require("./ViewDayRounded");
var _viewDayRoundedDefault = parcelHelpers.interopDefault(_viewDayRounded);
var _viewDaySharp = require("./ViewDaySharp");
var _viewDaySharpDefault = parcelHelpers.interopDefault(_viewDaySharp);
var _viewDayTwoTone = require("./ViewDayTwoTone");
var _viewDayTwoToneDefault = parcelHelpers.interopDefault(_viewDayTwoTone);
var _viewHeadline = require("./ViewHeadline");
var _viewHeadlineDefault = parcelHelpers.interopDefault(_viewHeadline);
var _viewHeadlineOutlined = require("./ViewHeadlineOutlined");
var _viewHeadlineOutlinedDefault = parcelHelpers.interopDefault(_viewHeadlineOutlined);
var _viewHeadlineRounded = require("./ViewHeadlineRounded");
var _viewHeadlineRoundedDefault = parcelHelpers.interopDefault(_viewHeadlineRounded);
var _viewHeadlineSharp = require("./ViewHeadlineSharp");
var _viewHeadlineSharpDefault = parcelHelpers.interopDefault(_viewHeadlineSharp);
var _viewHeadlineTwoTone = require("./ViewHeadlineTwoTone");
var _viewHeadlineTwoToneDefault = parcelHelpers.interopDefault(_viewHeadlineTwoTone);
var _viewInAr = require("./ViewInAr");
var _viewInArDefault = parcelHelpers.interopDefault(_viewInAr);
var _viewInArOutlined = require("./ViewInArOutlined");
var _viewInArOutlinedDefault = parcelHelpers.interopDefault(_viewInArOutlined);
var _viewInArRounded = require("./ViewInArRounded");
var _viewInArRoundedDefault = parcelHelpers.interopDefault(_viewInArRounded);
var _viewInArSharp = require("./ViewInArSharp");
var _viewInArSharpDefault = parcelHelpers.interopDefault(_viewInArSharp);
var _viewInArTwoTone = require("./ViewInArTwoTone");
var _viewInArTwoToneDefault = parcelHelpers.interopDefault(_viewInArTwoTone);
var _viewKanban = require("./ViewKanban");
var _viewKanbanDefault = parcelHelpers.interopDefault(_viewKanban);
var _viewKanbanOutlined = require("./ViewKanbanOutlined");
var _viewKanbanOutlinedDefault = parcelHelpers.interopDefault(_viewKanbanOutlined);
var _viewKanbanRounded = require("./ViewKanbanRounded");
var _viewKanbanRoundedDefault = parcelHelpers.interopDefault(_viewKanbanRounded);
var _viewKanbanSharp = require("./ViewKanbanSharp");
var _viewKanbanSharpDefault = parcelHelpers.interopDefault(_viewKanbanSharp);
var _viewKanbanTwoTone = require("./ViewKanbanTwoTone");
var _viewKanbanTwoToneDefault = parcelHelpers.interopDefault(_viewKanbanTwoTone);
var _viewList = require("./ViewList");
var _viewListDefault = parcelHelpers.interopDefault(_viewList);
var _viewListOutlined = require("./ViewListOutlined");
var _viewListOutlinedDefault = parcelHelpers.interopDefault(_viewListOutlined);
var _viewListRounded = require("./ViewListRounded");
var _viewListRoundedDefault = parcelHelpers.interopDefault(_viewListRounded);
var _viewListSharp = require("./ViewListSharp");
var _viewListSharpDefault = parcelHelpers.interopDefault(_viewListSharp);
var _viewListTwoTone = require("./ViewListTwoTone");
var _viewListTwoToneDefault = parcelHelpers.interopDefault(_viewListTwoTone);
var _viewModule = require("./ViewModule");
var _viewModuleDefault = parcelHelpers.interopDefault(_viewModule);
var _viewModuleOutlined = require("./ViewModuleOutlined");
var _viewModuleOutlinedDefault = parcelHelpers.interopDefault(_viewModuleOutlined);
var _viewModuleRounded = require("./ViewModuleRounded");
var _viewModuleRoundedDefault = parcelHelpers.interopDefault(_viewModuleRounded);
var _viewModuleSharp = require("./ViewModuleSharp");
var _viewModuleSharpDefault = parcelHelpers.interopDefault(_viewModuleSharp);
var _viewModuleTwoTone = require("./ViewModuleTwoTone");
var _viewModuleTwoToneDefault = parcelHelpers.interopDefault(_viewModuleTwoTone);
var _viewQuilt = require("./ViewQuilt");
var _viewQuiltDefault = parcelHelpers.interopDefault(_viewQuilt);
var _viewQuiltOutlined = require("./ViewQuiltOutlined");
var _viewQuiltOutlinedDefault = parcelHelpers.interopDefault(_viewQuiltOutlined);
var _viewQuiltRounded = require("./ViewQuiltRounded");
var _viewQuiltRoundedDefault = parcelHelpers.interopDefault(_viewQuiltRounded);
var _viewQuiltSharp = require("./ViewQuiltSharp");
var _viewQuiltSharpDefault = parcelHelpers.interopDefault(_viewQuiltSharp);
var _viewQuiltTwoTone = require("./ViewQuiltTwoTone");
var _viewQuiltTwoToneDefault = parcelHelpers.interopDefault(_viewQuiltTwoTone);
var _viewSidebar = require("./ViewSidebar");
var _viewSidebarDefault = parcelHelpers.interopDefault(_viewSidebar);
var _viewSidebarOutlined = require("./ViewSidebarOutlined");
var _viewSidebarOutlinedDefault = parcelHelpers.interopDefault(_viewSidebarOutlined);
var _viewSidebarRounded = require("./ViewSidebarRounded");
var _viewSidebarRoundedDefault = parcelHelpers.interopDefault(_viewSidebarRounded);
var _viewSidebarSharp = require("./ViewSidebarSharp");
var _viewSidebarSharpDefault = parcelHelpers.interopDefault(_viewSidebarSharp);
var _viewSidebarTwoTone = require("./ViewSidebarTwoTone");
var _viewSidebarTwoToneDefault = parcelHelpers.interopDefault(_viewSidebarTwoTone);
var _viewStream = require("./ViewStream");
var _viewStreamDefault = parcelHelpers.interopDefault(_viewStream);
var _viewStreamOutlined = require("./ViewStreamOutlined");
var _viewStreamOutlinedDefault = parcelHelpers.interopDefault(_viewStreamOutlined);
var _viewStreamRounded = require("./ViewStreamRounded");
var _viewStreamRoundedDefault = parcelHelpers.interopDefault(_viewStreamRounded);
var _viewStreamSharp = require("./ViewStreamSharp");
var _viewStreamSharpDefault = parcelHelpers.interopDefault(_viewStreamSharp);
var _viewStreamTwoTone = require("./ViewStreamTwoTone");
var _viewStreamTwoToneDefault = parcelHelpers.interopDefault(_viewStreamTwoTone);
var _viewTimeline = require("./ViewTimeline");
var _viewTimelineDefault = parcelHelpers.interopDefault(_viewTimeline);
var _viewTimelineOutlined = require("./ViewTimelineOutlined");
var _viewTimelineOutlinedDefault = parcelHelpers.interopDefault(_viewTimelineOutlined);
var _viewTimelineRounded = require("./ViewTimelineRounded");
var _viewTimelineRoundedDefault = parcelHelpers.interopDefault(_viewTimelineRounded);
var _viewTimelineSharp = require("./ViewTimelineSharp");
var _viewTimelineSharpDefault = parcelHelpers.interopDefault(_viewTimelineSharp);
var _viewTimelineTwoTone = require("./ViewTimelineTwoTone");
var _viewTimelineTwoToneDefault = parcelHelpers.interopDefault(_viewTimelineTwoTone);
var _viewWeek = require("./ViewWeek");
var _viewWeekDefault = parcelHelpers.interopDefault(_viewWeek);
var _viewWeekOutlined = require("./ViewWeekOutlined");
var _viewWeekOutlinedDefault = parcelHelpers.interopDefault(_viewWeekOutlined);
var _viewWeekRounded = require("./ViewWeekRounded");
var _viewWeekRoundedDefault = parcelHelpers.interopDefault(_viewWeekRounded);
var _viewWeekSharp = require("./ViewWeekSharp");
var _viewWeekSharpDefault = parcelHelpers.interopDefault(_viewWeekSharp);
var _viewWeekTwoTone = require("./ViewWeekTwoTone");
var _viewWeekTwoToneDefault = parcelHelpers.interopDefault(_viewWeekTwoTone);
var _vignette = require("./Vignette");
var _vignetteDefault = parcelHelpers.interopDefault(_vignette);
var _vignetteOutlined = require("./VignetteOutlined");
var _vignetteOutlinedDefault = parcelHelpers.interopDefault(_vignetteOutlined);
var _vignetteRounded = require("./VignetteRounded");
var _vignetteRoundedDefault = parcelHelpers.interopDefault(_vignetteRounded);
var _vignetteSharp = require("./VignetteSharp");
var _vignetteSharpDefault = parcelHelpers.interopDefault(_vignetteSharp);
var _vignetteTwoTone = require("./VignetteTwoTone");
var _vignetteTwoToneDefault = parcelHelpers.interopDefault(_vignetteTwoTone);
var _villa = require("./Villa");
var _villaDefault = parcelHelpers.interopDefault(_villa);
var _villaOutlined = require("./VillaOutlined");
var _villaOutlinedDefault = parcelHelpers.interopDefault(_villaOutlined);
var _villaRounded = require("./VillaRounded");
var _villaRoundedDefault = parcelHelpers.interopDefault(_villaRounded);
var _villaSharp = require("./VillaSharp");
var _villaSharpDefault = parcelHelpers.interopDefault(_villaSharp);
var _villaTwoTone = require("./VillaTwoTone");
var _villaTwoToneDefault = parcelHelpers.interopDefault(_villaTwoTone);
var _visibility = require("./Visibility");
var _visibilityDefault = parcelHelpers.interopDefault(_visibility);
var _visibilityOff = require("./VisibilityOff");
var _visibilityOffDefault = parcelHelpers.interopDefault(_visibilityOff);
var _visibilityOffOutlined = require("./VisibilityOffOutlined");
var _visibilityOffOutlinedDefault = parcelHelpers.interopDefault(_visibilityOffOutlined);
var _visibilityOffRounded = require("./VisibilityOffRounded");
var _visibilityOffRoundedDefault = parcelHelpers.interopDefault(_visibilityOffRounded);
var _visibilityOffSharp = require("./VisibilityOffSharp");
var _visibilityOffSharpDefault = parcelHelpers.interopDefault(_visibilityOffSharp);
var _visibilityOffTwoTone = require("./VisibilityOffTwoTone");
var _visibilityOffTwoToneDefault = parcelHelpers.interopDefault(_visibilityOffTwoTone);
var _visibilityOutlined = require("./VisibilityOutlined");
var _visibilityOutlinedDefault = parcelHelpers.interopDefault(_visibilityOutlined);
var _visibilityRounded = require("./VisibilityRounded");
var _visibilityRoundedDefault = parcelHelpers.interopDefault(_visibilityRounded);
var _visibilitySharp = require("./VisibilitySharp");
var _visibilitySharpDefault = parcelHelpers.interopDefault(_visibilitySharp);
var _visibilityTwoTone = require("./VisibilityTwoTone");
var _visibilityTwoToneDefault = parcelHelpers.interopDefault(_visibilityTwoTone);
var _voiceChat = require("./VoiceChat");
var _voiceChatDefault = parcelHelpers.interopDefault(_voiceChat);
var _voiceChatOutlined = require("./VoiceChatOutlined");
var _voiceChatOutlinedDefault = parcelHelpers.interopDefault(_voiceChatOutlined);
var _voiceChatRounded = require("./VoiceChatRounded");
var _voiceChatRoundedDefault = parcelHelpers.interopDefault(_voiceChatRounded);
var _voiceChatSharp = require("./VoiceChatSharp");
var _voiceChatSharpDefault = parcelHelpers.interopDefault(_voiceChatSharp);
var _voiceChatTwoTone = require("./VoiceChatTwoTone");
var _voiceChatTwoToneDefault = parcelHelpers.interopDefault(_voiceChatTwoTone);
var _voiceOverOff = require("./VoiceOverOff");
var _voiceOverOffDefault = parcelHelpers.interopDefault(_voiceOverOff);
var _voiceOverOffOutlined = require("./VoiceOverOffOutlined");
var _voiceOverOffOutlinedDefault = parcelHelpers.interopDefault(_voiceOverOffOutlined);
var _voiceOverOffRounded = require("./VoiceOverOffRounded");
var _voiceOverOffRoundedDefault = parcelHelpers.interopDefault(_voiceOverOffRounded);
var _voiceOverOffSharp = require("./VoiceOverOffSharp");
var _voiceOverOffSharpDefault = parcelHelpers.interopDefault(_voiceOverOffSharp);
var _voiceOverOffTwoTone = require("./VoiceOverOffTwoTone");
var _voiceOverOffTwoToneDefault = parcelHelpers.interopDefault(_voiceOverOffTwoTone);
var _voicemail = require("./Voicemail");
var _voicemailDefault = parcelHelpers.interopDefault(_voicemail);
var _voicemailOutlined = require("./VoicemailOutlined");
var _voicemailOutlinedDefault = parcelHelpers.interopDefault(_voicemailOutlined);
var _voicemailRounded = require("./VoicemailRounded");
var _voicemailRoundedDefault = parcelHelpers.interopDefault(_voicemailRounded);
var _voicemailSharp = require("./VoicemailSharp");
var _voicemailSharpDefault = parcelHelpers.interopDefault(_voicemailSharp);
var _voicemailTwoTone = require("./VoicemailTwoTone");
var _voicemailTwoToneDefault = parcelHelpers.interopDefault(_voicemailTwoTone);
var _volcano = require("./Volcano");
var _volcanoDefault = parcelHelpers.interopDefault(_volcano);
var _volcanoOutlined = require("./VolcanoOutlined");
var _volcanoOutlinedDefault = parcelHelpers.interopDefault(_volcanoOutlined);
var _volcanoRounded = require("./VolcanoRounded");
var _volcanoRoundedDefault = parcelHelpers.interopDefault(_volcanoRounded);
var _volcanoSharp = require("./VolcanoSharp");
var _volcanoSharpDefault = parcelHelpers.interopDefault(_volcanoSharp);
var _volcanoTwoTone = require("./VolcanoTwoTone");
var _volcanoTwoToneDefault = parcelHelpers.interopDefault(_volcanoTwoTone);
var _volumeDown = require("./VolumeDown");
var _volumeDownDefault = parcelHelpers.interopDefault(_volumeDown);
var _volumeDownOutlined = require("./VolumeDownOutlined");
var _volumeDownOutlinedDefault = parcelHelpers.interopDefault(_volumeDownOutlined);
var _volumeDownRounded = require("./VolumeDownRounded");
var _volumeDownRoundedDefault = parcelHelpers.interopDefault(_volumeDownRounded);
var _volumeDownSharp = require("./VolumeDownSharp");
var _volumeDownSharpDefault = parcelHelpers.interopDefault(_volumeDownSharp);
var _volumeDownTwoTone = require("./VolumeDownTwoTone");
var _volumeDownTwoToneDefault = parcelHelpers.interopDefault(_volumeDownTwoTone);
var _volumeMute = require("./VolumeMute");
var _volumeMuteDefault = parcelHelpers.interopDefault(_volumeMute);
var _volumeMuteOutlined = require("./VolumeMuteOutlined");
var _volumeMuteOutlinedDefault = parcelHelpers.interopDefault(_volumeMuteOutlined);
var _volumeMuteRounded = require("./VolumeMuteRounded");
var _volumeMuteRoundedDefault = parcelHelpers.interopDefault(_volumeMuteRounded);
var _volumeMuteSharp = require("./VolumeMuteSharp");
var _volumeMuteSharpDefault = parcelHelpers.interopDefault(_volumeMuteSharp);
var _volumeMuteTwoTone = require("./VolumeMuteTwoTone");
var _volumeMuteTwoToneDefault = parcelHelpers.interopDefault(_volumeMuteTwoTone);
var _volumeOff = require("./VolumeOff");
var _volumeOffDefault = parcelHelpers.interopDefault(_volumeOff);
var _volumeOffOutlined = require("./VolumeOffOutlined");
var _volumeOffOutlinedDefault = parcelHelpers.interopDefault(_volumeOffOutlined);
var _volumeOffRounded = require("./VolumeOffRounded");
var _volumeOffRoundedDefault = parcelHelpers.interopDefault(_volumeOffRounded);
var _volumeOffSharp = require("./VolumeOffSharp");
var _volumeOffSharpDefault = parcelHelpers.interopDefault(_volumeOffSharp);
var _volumeOffTwoTone = require("./VolumeOffTwoTone");
var _volumeOffTwoToneDefault = parcelHelpers.interopDefault(_volumeOffTwoTone);
var _volumeUp = require("./VolumeUp");
var _volumeUpDefault = parcelHelpers.interopDefault(_volumeUp);
var _volumeUpOutlined = require("./VolumeUpOutlined");
var _volumeUpOutlinedDefault = parcelHelpers.interopDefault(_volumeUpOutlined);
var _volumeUpRounded = require("./VolumeUpRounded");
var _volumeUpRoundedDefault = parcelHelpers.interopDefault(_volumeUpRounded);
var _volumeUpSharp = require("./VolumeUpSharp");
var _volumeUpSharpDefault = parcelHelpers.interopDefault(_volumeUpSharp);
var _volumeUpTwoTone = require("./VolumeUpTwoTone");
var _volumeUpTwoToneDefault = parcelHelpers.interopDefault(_volumeUpTwoTone);
var _volunteerActivism = require("./VolunteerActivism");
var _volunteerActivismDefault = parcelHelpers.interopDefault(_volunteerActivism);
var _volunteerActivismOutlined = require("./VolunteerActivismOutlined");
var _volunteerActivismOutlinedDefault = parcelHelpers.interopDefault(_volunteerActivismOutlined);
var _volunteerActivismRounded = require("./VolunteerActivismRounded");
var _volunteerActivismRoundedDefault = parcelHelpers.interopDefault(_volunteerActivismRounded);
var _volunteerActivismSharp = require("./VolunteerActivismSharp");
var _volunteerActivismSharpDefault = parcelHelpers.interopDefault(_volunteerActivismSharp);
var _volunteerActivismTwoTone = require("./VolunteerActivismTwoTone");
var _volunteerActivismTwoToneDefault = parcelHelpers.interopDefault(_volunteerActivismTwoTone);
var _vpnKey = require("./VpnKey");
var _vpnKeyDefault = parcelHelpers.interopDefault(_vpnKey);
var _vpnKeyOff = require("./VpnKeyOff");
var _vpnKeyOffDefault = parcelHelpers.interopDefault(_vpnKeyOff);
var _vpnKeyOffOutlined = require("./VpnKeyOffOutlined");
var _vpnKeyOffOutlinedDefault = parcelHelpers.interopDefault(_vpnKeyOffOutlined);
var _vpnKeyOffRounded = require("./VpnKeyOffRounded");
var _vpnKeyOffRoundedDefault = parcelHelpers.interopDefault(_vpnKeyOffRounded);
var _vpnKeyOffSharp = require("./VpnKeyOffSharp");
var _vpnKeyOffSharpDefault = parcelHelpers.interopDefault(_vpnKeyOffSharp);
var _vpnKeyOffTwoTone = require("./VpnKeyOffTwoTone");
var _vpnKeyOffTwoToneDefault = parcelHelpers.interopDefault(_vpnKeyOffTwoTone);
var _vpnKeyOutlined = require("./VpnKeyOutlined");
var _vpnKeyOutlinedDefault = parcelHelpers.interopDefault(_vpnKeyOutlined);
var _vpnKeyRounded = require("./VpnKeyRounded");
var _vpnKeyRoundedDefault = parcelHelpers.interopDefault(_vpnKeyRounded);
var _vpnKeySharp = require("./VpnKeySharp");
var _vpnKeySharpDefault = parcelHelpers.interopDefault(_vpnKeySharp);
var _vpnKeyTwoTone = require("./VpnKeyTwoTone");
var _vpnKeyTwoToneDefault = parcelHelpers.interopDefault(_vpnKeyTwoTone);
var _vpnLock = require("./VpnLock");
var _vpnLockDefault = parcelHelpers.interopDefault(_vpnLock);
var _vpnLockOutlined = require("./VpnLockOutlined");
var _vpnLockOutlinedDefault = parcelHelpers.interopDefault(_vpnLockOutlined);
var _vpnLockRounded = require("./VpnLockRounded");
var _vpnLockRoundedDefault = parcelHelpers.interopDefault(_vpnLockRounded);
var _vpnLockSharp = require("./VpnLockSharp");
var _vpnLockSharpDefault = parcelHelpers.interopDefault(_vpnLockSharp);
var _vpnLockTwoTone = require("./VpnLockTwoTone");
var _vpnLockTwoToneDefault = parcelHelpers.interopDefault(_vpnLockTwoTone);
var _vrpano = require("./Vrpano");
var _vrpanoDefault = parcelHelpers.interopDefault(_vrpano);
var _vrpanoOutlined = require("./VrpanoOutlined");
var _vrpanoOutlinedDefault = parcelHelpers.interopDefault(_vrpanoOutlined);
var _vrpanoRounded = require("./VrpanoRounded");
var _vrpanoRoundedDefault = parcelHelpers.interopDefault(_vrpanoRounded);
var _vrpanoSharp = require("./VrpanoSharp");
var _vrpanoSharpDefault = parcelHelpers.interopDefault(_vrpanoSharp);
var _vrpanoTwoTone = require("./VrpanoTwoTone");
var _vrpanoTwoToneDefault = parcelHelpers.interopDefault(_vrpanoTwoTone);
var _wallet = require("./Wallet");
var _walletDefault = parcelHelpers.interopDefault(_wallet);
var _walletOutlined = require("./WalletOutlined");
var _walletOutlinedDefault = parcelHelpers.interopDefault(_walletOutlined);
var _walletRounded = require("./WalletRounded");
var _walletRoundedDefault = parcelHelpers.interopDefault(_walletRounded);
var _walletSharp = require("./WalletSharp");
var _walletSharpDefault = parcelHelpers.interopDefault(_walletSharp);
var _walletTwoTone = require("./WalletTwoTone");
var _walletTwoToneDefault = parcelHelpers.interopDefault(_walletTwoTone);
var _wallpaper = require("./Wallpaper");
var _wallpaperDefault = parcelHelpers.interopDefault(_wallpaper);
var _wallpaperOutlined = require("./WallpaperOutlined");
var _wallpaperOutlinedDefault = parcelHelpers.interopDefault(_wallpaperOutlined);
var _wallpaperRounded = require("./WallpaperRounded");
var _wallpaperRoundedDefault = parcelHelpers.interopDefault(_wallpaperRounded);
var _wallpaperSharp = require("./WallpaperSharp");
var _wallpaperSharpDefault = parcelHelpers.interopDefault(_wallpaperSharp);
var _wallpaperTwoTone = require("./WallpaperTwoTone");
var _wallpaperTwoToneDefault = parcelHelpers.interopDefault(_wallpaperTwoTone);
var _warehouse = require("./Warehouse");
var _warehouseDefault = parcelHelpers.interopDefault(_warehouse);
var _warehouseOutlined = require("./WarehouseOutlined");
var _warehouseOutlinedDefault = parcelHelpers.interopDefault(_warehouseOutlined);
var _warehouseRounded = require("./WarehouseRounded");
var _warehouseRoundedDefault = parcelHelpers.interopDefault(_warehouseRounded);
var _warehouseSharp = require("./WarehouseSharp");
var _warehouseSharpDefault = parcelHelpers.interopDefault(_warehouseSharp);
var _warehouseTwoTone = require("./WarehouseTwoTone");
var _warehouseTwoToneDefault = parcelHelpers.interopDefault(_warehouseTwoTone);
var _warning = require("./Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _warningAmber = require("./WarningAmber");
var _warningAmberDefault = parcelHelpers.interopDefault(_warningAmber);
var _warningAmberOutlined = require("./WarningAmberOutlined");
var _warningAmberOutlinedDefault = parcelHelpers.interopDefault(_warningAmberOutlined);
var _warningAmberRounded = require("./WarningAmberRounded");
var _warningAmberRoundedDefault = parcelHelpers.interopDefault(_warningAmberRounded);
var _warningAmberSharp = require("./WarningAmberSharp");
var _warningAmberSharpDefault = parcelHelpers.interopDefault(_warningAmberSharp);
var _warningAmberTwoTone = require("./WarningAmberTwoTone");
var _warningAmberTwoToneDefault = parcelHelpers.interopDefault(_warningAmberTwoTone);
var _warningOutlined = require("./WarningOutlined");
var _warningOutlinedDefault = parcelHelpers.interopDefault(_warningOutlined);
var _warningRounded = require("./WarningRounded");
var _warningRoundedDefault = parcelHelpers.interopDefault(_warningRounded);
var _warningSharp = require("./WarningSharp");
var _warningSharpDefault = parcelHelpers.interopDefault(_warningSharp);
var _warningTwoTone = require("./WarningTwoTone");
var _warningTwoToneDefault = parcelHelpers.interopDefault(_warningTwoTone);
var _wash = require("./Wash");
var _washDefault = parcelHelpers.interopDefault(_wash);
var _washOutlined = require("./WashOutlined");
var _washOutlinedDefault = parcelHelpers.interopDefault(_washOutlined);
var _washRounded = require("./WashRounded");
var _washRoundedDefault = parcelHelpers.interopDefault(_washRounded);
var _washSharp = require("./WashSharp");
var _washSharpDefault = parcelHelpers.interopDefault(_washSharp);
var _washTwoTone = require("./WashTwoTone");
var _washTwoToneDefault = parcelHelpers.interopDefault(_washTwoTone);
var _watch = require("./Watch");
var _watchDefault = parcelHelpers.interopDefault(_watch);
var _watchLater = require("./WatchLater");
var _watchLaterDefault = parcelHelpers.interopDefault(_watchLater);
var _watchLaterOutlined = require("./WatchLaterOutlined");
var _watchLaterOutlinedDefault = parcelHelpers.interopDefault(_watchLaterOutlined);
var _watchLaterRounded = require("./WatchLaterRounded");
var _watchLaterRoundedDefault = parcelHelpers.interopDefault(_watchLaterRounded);
var _watchLaterSharp = require("./WatchLaterSharp");
var _watchLaterSharpDefault = parcelHelpers.interopDefault(_watchLaterSharp);
var _watchLaterTwoTone = require("./WatchLaterTwoTone");
var _watchLaterTwoToneDefault = parcelHelpers.interopDefault(_watchLaterTwoTone);
var _watchOff = require("./WatchOff");
var _watchOffDefault = parcelHelpers.interopDefault(_watchOff);
var _watchOffOutlined = require("./WatchOffOutlined");
var _watchOffOutlinedDefault = parcelHelpers.interopDefault(_watchOffOutlined);
var _watchOffRounded = require("./WatchOffRounded");
var _watchOffRoundedDefault = parcelHelpers.interopDefault(_watchOffRounded);
var _watchOffSharp = require("./WatchOffSharp");
var _watchOffSharpDefault = parcelHelpers.interopDefault(_watchOffSharp);
var _watchOffTwoTone = require("./WatchOffTwoTone");
var _watchOffTwoToneDefault = parcelHelpers.interopDefault(_watchOffTwoTone);
var _watchOutlined = require("./WatchOutlined");
var _watchOutlinedDefault = parcelHelpers.interopDefault(_watchOutlined);
var _watchRounded = require("./WatchRounded");
var _watchRoundedDefault = parcelHelpers.interopDefault(_watchRounded);
var _watchSharp = require("./WatchSharp");
var _watchSharpDefault = parcelHelpers.interopDefault(_watchSharp);
var _watchTwoTone = require("./WatchTwoTone");
var _watchTwoToneDefault = parcelHelpers.interopDefault(_watchTwoTone);
var _water = require("./Water");
var _waterDefault = parcelHelpers.interopDefault(_water);
var _waterDamage = require("./WaterDamage");
var _waterDamageDefault = parcelHelpers.interopDefault(_waterDamage);
var _waterDamageOutlined = require("./WaterDamageOutlined");
var _waterDamageOutlinedDefault = parcelHelpers.interopDefault(_waterDamageOutlined);
var _waterDamageRounded = require("./WaterDamageRounded");
var _waterDamageRoundedDefault = parcelHelpers.interopDefault(_waterDamageRounded);
var _waterDamageSharp = require("./WaterDamageSharp");
var _waterDamageSharpDefault = parcelHelpers.interopDefault(_waterDamageSharp);
var _waterDamageTwoTone = require("./WaterDamageTwoTone");
var _waterDamageTwoToneDefault = parcelHelpers.interopDefault(_waterDamageTwoTone);
var _waterDrop = require("./WaterDrop");
var _waterDropDefault = parcelHelpers.interopDefault(_waterDrop);
var _waterDropOutlined = require("./WaterDropOutlined");
var _waterDropOutlinedDefault = parcelHelpers.interopDefault(_waterDropOutlined);
var _waterDropRounded = require("./WaterDropRounded");
var _waterDropRoundedDefault = parcelHelpers.interopDefault(_waterDropRounded);
var _waterDropSharp = require("./WaterDropSharp");
var _waterDropSharpDefault = parcelHelpers.interopDefault(_waterDropSharp);
var _waterDropTwoTone = require("./WaterDropTwoTone");
var _waterDropTwoToneDefault = parcelHelpers.interopDefault(_waterDropTwoTone);
var _waterOutlined = require("./WaterOutlined");
var _waterOutlinedDefault = parcelHelpers.interopDefault(_waterOutlined);
var _waterRounded = require("./WaterRounded");
var _waterRoundedDefault = parcelHelpers.interopDefault(_waterRounded);
var _waterSharp = require("./WaterSharp");
var _waterSharpDefault = parcelHelpers.interopDefault(_waterSharp);
var _waterTwoTone = require("./WaterTwoTone");
var _waterTwoToneDefault = parcelHelpers.interopDefault(_waterTwoTone);
var _waterfallChart = require("./WaterfallChart");
var _waterfallChartDefault = parcelHelpers.interopDefault(_waterfallChart);
var _waterfallChartOutlined = require("./WaterfallChartOutlined");
var _waterfallChartOutlinedDefault = parcelHelpers.interopDefault(_waterfallChartOutlined);
var _waterfallChartRounded = require("./WaterfallChartRounded");
var _waterfallChartRoundedDefault = parcelHelpers.interopDefault(_waterfallChartRounded);
var _waterfallChartSharp = require("./WaterfallChartSharp");
var _waterfallChartSharpDefault = parcelHelpers.interopDefault(_waterfallChartSharp);
var _waterfallChartTwoTone = require("./WaterfallChartTwoTone");
var _waterfallChartTwoToneDefault = parcelHelpers.interopDefault(_waterfallChartTwoTone);
var _waves = require("./Waves");
var _wavesDefault = parcelHelpers.interopDefault(_waves);
var _wavesOutlined = require("./WavesOutlined");
var _wavesOutlinedDefault = parcelHelpers.interopDefault(_wavesOutlined);
var _wavesRounded = require("./WavesRounded");
var _wavesRoundedDefault = parcelHelpers.interopDefault(_wavesRounded);
var _wavesSharp = require("./WavesSharp");
var _wavesSharpDefault = parcelHelpers.interopDefault(_wavesSharp);
var _wavesTwoTone = require("./WavesTwoTone");
var _wavesTwoToneDefault = parcelHelpers.interopDefault(_wavesTwoTone);
var _wavingHand = require("./WavingHand");
var _wavingHandDefault = parcelHelpers.interopDefault(_wavingHand);
var _wavingHandOutlined = require("./WavingHandOutlined");
var _wavingHandOutlinedDefault = parcelHelpers.interopDefault(_wavingHandOutlined);
var _wavingHandRounded = require("./WavingHandRounded");
var _wavingHandRoundedDefault = parcelHelpers.interopDefault(_wavingHandRounded);
var _wavingHandSharp = require("./WavingHandSharp");
var _wavingHandSharpDefault = parcelHelpers.interopDefault(_wavingHandSharp);
var _wavingHandTwoTone = require("./WavingHandTwoTone");
var _wavingHandTwoToneDefault = parcelHelpers.interopDefault(_wavingHandTwoTone);
var _wbAuto = require("./WbAuto");
var _wbAutoDefault = parcelHelpers.interopDefault(_wbAuto);
var _wbAutoOutlined = require("./WbAutoOutlined");
var _wbAutoOutlinedDefault = parcelHelpers.interopDefault(_wbAutoOutlined);
var _wbAutoRounded = require("./WbAutoRounded");
var _wbAutoRoundedDefault = parcelHelpers.interopDefault(_wbAutoRounded);
var _wbAutoSharp = require("./WbAutoSharp");
var _wbAutoSharpDefault = parcelHelpers.interopDefault(_wbAutoSharp);
var _wbAutoTwoTone = require("./WbAutoTwoTone");
var _wbAutoTwoToneDefault = parcelHelpers.interopDefault(_wbAutoTwoTone);
var _wbCloudy = require("./WbCloudy");
var _wbCloudyDefault = parcelHelpers.interopDefault(_wbCloudy);
var _wbCloudyOutlined = require("./WbCloudyOutlined");
var _wbCloudyOutlinedDefault = parcelHelpers.interopDefault(_wbCloudyOutlined);
var _wbCloudyRounded = require("./WbCloudyRounded");
var _wbCloudyRoundedDefault = parcelHelpers.interopDefault(_wbCloudyRounded);
var _wbCloudySharp = require("./WbCloudySharp");
var _wbCloudySharpDefault = parcelHelpers.interopDefault(_wbCloudySharp);
var _wbCloudyTwoTone = require("./WbCloudyTwoTone");
var _wbCloudyTwoToneDefault = parcelHelpers.interopDefault(_wbCloudyTwoTone);
var _wbIncandescent = require("./WbIncandescent");
var _wbIncandescentDefault = parcelHelpers.interopDefault(_wbIncandescent);
var _wbIncandescentOutlined = require("./WbIncandescentOutlined");
var _wbIncandescentOutlinedDefault = parcelHelpers.interopDefault(_wbIncandescentOutlined);
var _wbIncandescentRounded = require("./WbIncandescentRounded");
var _wbIncandescentRoundedDefault = parcelHelpers.interopDefault(_wbIncandescentRounded);
var _wbIncandescentSharp = require("./WbIncandescentSharp");
var _wbIncandescentSharpDefault = parcelHelpers.interopDefault(_wbIncandescentSharp);
var _wbIncandescentTwoTone = require("./WbIncandescentTwoTone");
var _wbIncandescentTwoToneDefault = parcelHelpers.interopDefault(_wbIncandescentTwoTone);
var _wbIridescent = require("./WbIridescent");
var _wbIridescentDefault = parcelHelpers.interopDefault(_wbIridescent);
var _wbIridescentOutlined = require("./WbIridescentOutlined");
var _wbIridescentOutlinedDefault = parcelHelpers.interopDefault(_wbIridescentOutlined);
var _wbIridescentRounded = require("./WbIridescentRounded");
var _wbIridescentRoundedDefault = parcelHelpers.interopDefault(_wbIridescentRounded);
var _wbIridescentSharp = require("./WbIridescentSharp");
var _wbIridescentSharpDefault = parcelHelpers.interopDefault(_wbIridescentSharp);
var _wbIridescentTwoTone = require("./WbIridescentTwoTone");
var _wbIridescentTwoToneDefault = parcelHelpers.interopDefault(_wbIridescentTwoTone);
var _wbShade = require("./WbShade");
var _wbShadeDefault = parcelHelpers.interopDefault(_wbShade);
var _wbShadeOutlined = require("./WbShadeOutlined");
var _wbShadeOutlinedDefault = parcelHelpers.interopDefault(_wbShadeOutlined);
var _wbShadeRounded = require("./WbShadeRounded");
var _wbShadeRoundedDefault = parcelHelpers.interopDefault(_wbShadeRounded);
var _wbShadeSharp = require("./WbShadeSharp");
var _wbShadeSharpDefault = parcelHelpers.interopDefault(_wbShadeSharp);
var _wbShadeTwoTone = require("./WbShadeTwoTone");
var _wbShadeTwoToneDefault = parcelHelpers.interopDefault(_wbShadeTwoTone);
var _wbSunny = require("./WbSunny");
var _wbSunnyDefault = parcelHelpers.interopDefault(_wbSunny);
var _wbSunnyOutlined = require("./WbSunnyOutlined");
var _wbSunnyOutlinedDefault = parcelHelpers.interopDefault(_wbSunnyOutlined);
var _wbSunnyRounded = require("./WbSunnyRounded");
var _wbSunnyRoundedDefault = parcelHelpers.interopDefault(_wbSunnyRounded);
var _wbSunnySharp = require("./WbSunnySharp");
var _wbSunnySharpDefault = parcelHelpers.interopDefault(_wbSunnySharp);
var _wbSunnyTwoTone = require("./WbSunnyTwoTone");
var _wbSunnyTwoToneDefault = parcelHelpers.interopDefault(_wbSunnyTwoTone);
var _wbTwilight = require("./WbTwilight");
var _wbTwilightDefault = parcelHelpers.interopDefault(_wbTwilight);
var _wbTwilightOutlined = require("./WbTwilightOutlined");
var _wbTwilightOutlinedDefault = parcelHelpers.interopDefault(_wbTwilightOutlined);
var _wbTwilightRounded = require("./WbTwilightRounded");
var _wbTwilightRoundedDefault = parcelHelpers.interopDefault(_wbTwilightRounded);
var _wbTwilightSharp = require("./WbTwilightSharp");
var _wbTwilightSharpDefault = parcelHelpers.interopDefault(_wbTwilightSharp);
var _wbTwilightTwoTone = require("./WbTwilightTwoTone");
var _wbTwilightTwoToneDefault = parcelHelpers.interopDefault(_wbTwilightTwoTone);
var _wc = require("./Wc");
var _wcDefault = parcelHelpers.interopDefault(_wc);
var _wcOutlined = require("./WcOutlined");
var _wcOutlinedDefault = parcelHelpers.interopDefault(_wcOutlined);
var _wcRounded = require("./WcRounded");
var _wcRoundedDefault = parcelHelpers.interopDefault(_wcRounded);
var _wcSharp = require("./WcSharp");
var _wcSharpDefault = parcelHelpers.interopDefault(_wcSharp);
var _wcTwoTone = require("./WcTwoTone");
var _wcTwoToneDefault = parcelHelpers.interopDefault(_wcTwoTone);
var _web = require("./Web");
var _webDefault = parcelHelpers.interopDefault(_web);
var _webAsset = require("./WebAsset");
var _webAssetDefault = parcelHelpers.interopDefault(_webAsset);
var _webAssetOff = require("./WebAssetOff");
var _webAssetOffDefault = parcelHelpers.interopDefault(_webAssetOff);
var _webAssetOffOutlined = require("./WebAssetOffOutlined");
var _webAssetOffOutlinedDefault = parcelHelpers.interopDefault(_webAssetOffOutlined);
var _webAssetOffRounded = require("./WebAssetOffRounded");
var _webAssetOffRoundedDefault = parcelHelpers.interopDefault(_webAssetOffRounded);
var _webAssetOffSharp = require("./WebAssetOffSharp");
var _webAssetOffSharpDefault = parcelHelpers.interopDefault(_webAssetOffSharp);
var _webAssetOffTwoTone = require("./WebAssetOffTwoTone");
var _webAssetOffTwoToneDefault = parcelHelpers.interopDefault(_webAssetOffTwoTone);
var _webAssetOutlined = require("./WebAssetOutlined");
var _webAssetOutlinedDefault = parcelHelpers.interopDefault(_webAssetOutlined);
var _webAssetRounded = require("./WebAssetRounded");
var _webAssetRoundedDefault = parcelHelpers.interopDefault(_webAssetRounded);
var _webAssetSharp = require("./WebAssetSharp");
var _webAssetSharpDefault = parcelHelpers.interopDefault(_webAssetSharp);
var _webAssetTwoTone = require("./WebAssetTwoTone");
var _webAssetTwoToneDefault = parcelHelpers.interopDefault(_webAssetTwoTone);
var _webOutlined = require("./WebOutlined");
var _webOutlinedDefault = parcelHelpers.interopDefault(_webOutlined);
var _webRounded = require("./WebRounded");
var _webRoundedDefault = parcelHelpers.interopDefault(_webRounded);
var _webSharp = require("./WebSharp");
var _webSharpDefault = parcelHelpers.interopDefault(_webSharp);
var _webStories = require("./WebStories");
var _webStoriesDefault = parcelHelpers.interopDefault(_webStories);
var _webStoriesOutlined = require("./WebStoriesOutlined");
var _webStoriesOutlinedDefault = parcelHelpers.interopDefault(_webStoriesOutlined);
var _webStoriesRounded = require("./WebStoriesRounded");
var _webStoriesRoundedDefault = parcelHelpers.interopDefault(_webStoriesRounded);
var _webStoriesSharp = require("./WebStoriesSharp");
var _webStoriesSharpDefault = parcelHelpers.interopDefault(_webStoriesSharp);
var _webStoriesTwoTone = require("./WebStoriesTwoTone");
var _webStoriesTwoToneDefault = parcelHelpers.interopDefault(_webStoriesTwoTone);
var _webTwoTone = require("./WebTwoTone");
var _webTwoToneDefault = parcelHelpers.interopDefault(_webTwoTone);
var _webhook = require("./Webhook");
var _webhookDefault = parcelHelpers.interopDefault(_webhook);
var _webhookOutlined = require("./WebhookOutlined");
var _webhookOutlinedDefault = parcelHelpers.interopDefault(_webhookOutlined);
var _webhookRounded = require("./WebhookRounded");
var _webhookRoundedDefault = parcelHelpers.interopDefault(_webhookRounded);
var _webhookSharp = require("./WebhookSharp");
var _webhookSharpDefault = parcelHelpers.interopDefault(_webhookSharp);
var _webhookTwoTone = require("./WebhookTwoTone");
var _webhookTwoToneDefault = parcelHelpers.interopDefault(_webhookTwoTone);
var _weekend = require("./Weekend");
var _weekendDefault = parcelHelpers.interopDefault(_weekend);
var _weekendOutlined = require("./WeekendOutlined");
var _weekendOutlinedDefault = parcelHelpers.interopDefault(_weekendOutlined);
var _weekendRounded = require("./WeekendRounded");
var _weekendRoundedDefault = parcelHelpers.interopDefault(_weekendRounded);
var _weekendSharp = require("./WeekendSharp");
var _weekendSharpDefault = parcelHelpers.interopDefault(_weekendSharp);
var _weekendTwoTone = require("./WeekendTwoTone");
var _weekendTwoToneDefault = parcelHelpers.interopDefault(_weekendTwoTone);
var _west = require("./West");
var _westDefault = parcelHelpers.interopDefault(_west);
var _westOutlined = require("./WestOutlined");
var _westOutlinedDefault = parcelHelpers.interopDefault(_westOutlined);
var _westRounded = require("./WestRounded");
var _westRoundedDefault = parcelHelpers.interopDefault(_westRounded);
var _westSharp = require("./WestSharp");
var _westSharpDefault = parcelHelpers.interopDefault(_westSharp);
var _westTwoTone = require("./WestTwoTone");
var _westTwoToneDefault = parcelHelpers.interopDefault(_westTwoTone);
var _whatsApp = require("./WhatsApp");
var _whatsAppDefault = parcelHelpers.interopDefault(_whatsApp);
var _whatshot = require("./Whatshot");
var _whatshotDefault = parcelHelpers.interopDefault(_whatshot);
var _whatshotOutlined = require("./WhatshotOutlined");
var _whatshotOutlinedDefault = parcelHelpers.interopDefault(_whatshotOutlined);
var _whatshotRounded = require("./WhatshotRounded");
var _whatshotRoundedDefault = parcelHelpers.interopDefault(_whatshotRounded);
var _whatshotSharp = require("./WhatshotSharp");
var _whatshotSharpDefault = parcelHelpers.interopDefault(_whatshotSharp);
var _whatshotTwoTone = require("./WhatshotTwoTone");
var _whatshotTwoToneDefault = parcelHelpers.interopDefault(_whatshotTwoTone);
var _wheelchairPickup = require("./WheelchairPickup");
var _wheelchairPickupDefault = parcelHelpers.interopDefault(_wheelchairPickup);
var _wheelchairPickupOutlined = require("./WheelchairPickupOutlined");
var _wheelchairPickupOutlinedDefault = parcelHelpers.interopDefault(_wheelchairPickupOutlined);
var _wheelchairPickupRounded = require("./WheelchairPickupRounded");
var _wheelchairPickupRoundedDefault = parcelHelpers.interopDefault(_wheelchairPickupRounded);
var _wheelchairPickupSharp = require("./WheelchairPickupSharp");
var _wheelchairPickupSharpDefault = parcelHelpers.interopDefault(_wheelchairPickupSharp);
var _wheelchairPickupTwoTone = require("./WheelchairPickupTwoTone");
var _wheelchairPickupTwoToneDefault = parcelHelpers.interopDefault(_wheelchairPickupTwoTone);
var _whereToVote = require("./WhereToVote");
var _whereToVoteDefault = parcelHelpers.interopDefault(_whereToVote);
var _whereToVoteOutlined = require("./WhereToVoteOutlined");
var _whereToVoteOutlinedDefault = parcelHelpers.interopDefault(_whereToVoteOutlined);
var _whereToVoteRounded = require("./WhereToVoteRounded");
var _whereToVoteRoundedDefault = parcelHelpers.interopDefault(_whereToVoteRounded);
var _whereToVoteSharp = require("./WhereToVoteSharp");
var _whereToVoteSharpDefault = parcelHelpers.interopDefault(_whereToVoteSharp);
var _whereToVoteTwoTone = require("./WhereToVoteTwoTone");
var _whereToVoteTwoToneDefault = parcelHelpers.interopDefault(_whereToVoteTwoTone);
var _widgets = require("./Widgets");
var _widgetsDefault = parcelHelpers.interopDefault(_widgets);
var _widgetsOutlined = require("./WidgetsOutlined");
var _widgetsOutlinedDefault = parcelHelpers.interopDefault(_widgetsOutlined);
var _widgetsRounded = require("./WidgetsRounded");
var _widgetsRoundedDefault = parcelHelpers.interopDefault(_widgetsRounded);
var _widgetsSharp = require("./WidgetsSharp");
var _widgetsSharpDefault = parcelHelpers.interopDefault(_widgetsSharp);
var _widgetsTwoTone = require("./WidgetsTwoTone");
var _widgetsTwoToneDefault = parcelHelpers.interopDefault(_widgetsTwoTone);
var _widthFull = require("./WidthFull");
var _widthFullDefault = parcelHelpers.interopDefault(_widthFull);
var _widthFullOutlined = require("./WidthFullOutlined");
var _widthFullOutlinedDefault = parcelHelpers.interopDefault(_widthFullOutlined);
var _widthFullRounded = require("./WidthFullRounded");
var _widthFullRoundedDefault = parcelHelpers.interopDefault(_widthFullRounded);
var _widthFullSharp = require("./WidthFullSharp");
var _widthFullSharpDefault = parcelHelpers.interopDefault(_widthFullSharp);
var _widthFullTwoTone = require("./WidthFullTwoTone");
var _widthFullTwoToneDefault = parcelHelpers.interopDefault(_widthFullTwoTone);
var _widthNormal = require("./WidthNormal");
var _widthNormalDefault = parcelHelpers.interopDefault(_widthNormal);
var _widthNormalOutlined = require("./WidthNormalOutlined");
var _widthNormalOutlinedDefault = parcelHelpers.interopDefault(_widthNormalOutlined);
var _widthNormalRounded = require("./WidthNormalRounded");
var _widthNormalRoundedDefault = parcelHelpers.interopDefault(_widthNormalRounded);
var _widthNormalSharp = require("./WidthNormalSharp");
var _widthNormalSharpDefault = parcelHelpers.interopDefault(_widthNormalSharp);
var _widthNormalTwoTone = require("./WidthNormalTwoTone");
var _widthNormalTwoToneDefault = parcelHelpers.interopDefault(_widthNormalTwoTone);
var _widthWide = require("./WidthWide");
var _widthWideDefault = parcelHelpers.interopDefault(_widthWide);
var _widthWideOutlined = require("./WidthWideOutlined");
var _widthWideOutlinedDefault = parcelHelpers.interopDefault(_widthWideOutlined);
var _widthWideRounded = require("./WidthWideRounded");
var _widthWideRoundedDefault = parcelHelpers.interopDefault(_widthWideRounded);
var _widthWideSharp = require("./WidthWideSharp");
var _widthWideSharpDefault = parcelHelpers.interopDefault(_widthWideSharp);
var _widthWideTwoTone = require("./WidthWideTwoTone");
var _widthWideTwoToneDefault = parcelHelpers.interopDefault(_widthWideTwoTone);
var _wifi = require("./Wifi");
var _wifiDefault = parcelHelpers.interopDefault(_wifi);
var _wifi1Bar = require("./Wifi1Bar");
var _wifi1BarDefault = parcelHelpers.interopDefault(_wifi1Bar);
var _wifi1BarOutlined = require("./Wifi1BarOutlined");
var _wifi1BarOutlinedDefault = parcelHelpers.interopDefault(_wifi1BarOutlined);
var _wifi1BarRounded = require("./Wifi1BarRounded");
var _wifi1BarRoundedDefault = parcelHelpers.interopDefault(_wifi1BarRounded);
var _wifi1BarSharp = require("./Wifi1BarSharp");
var _wifi1BarSharpDefault = parcelHelpers.interopDefault(_wifi1BarSharp);
var _wifi1BarTwoTone = require("./Wifi1BarTwoTone");
var _wifi1BarTwoToneDefault = parcelHelpers.interopDefault(_wifi1BarTwoTone);
var _wifi2Bar = require("./Wifi2Bar");
var _wifi2BarDefault = parcelHelpers.interopDefault(_wifi2Bar);
var _wifi2BarOutlined = require("./Wifi2BarOutlined");
var _wifi2BarOutlinedDefault = parcelHelpers.interopDefault(_wifi2BarOutlined);
var _wifi2BarRounded = require("./Wifi2BarRounded");
var _wifi2BarRoundedDefault = parcelHelpers.interopDefault(_wifi2BarRounded);
var _wifi2BarSharp = require("./Wifi2BarSharp");
var _wifi2BarSharpDefault = parcelHelpers.interopDefault(_wifi2BarSharp);
var _wifi2BarTwoTone = require("./Wifi2BarTwoTone");
var _wifi2BarTwoToneDefault = parcelHelpers.interopDefault(_wifi2BarTwoTone);
var _wifiCalling = require("./WifiCalling");
var _wifiCallingDefault = parcelHelpers.interopDefault(_wifiCalling);
var _wifiCalling3 = require("./WifiCalling3");
var _wifiCalling3Default = parcelHelpers.interopDefault(_wifiCalling3);
var _wifiCalling3Outlined = require("./WifiCalling3Outlined");
var _wifiCalling3OutlinedDefault = parcelHelpers.interopDefault(_wifiCalling3Outlined);
var _wifiCalling3Rounded = require("./WifiCalling3Rounded");
var _wifiCalling3RoundedDefault = parcelHelpers.interopDefault(_wifiCalling3Rounded);
var _wifiCalling3Sharp = require("./WifiCalling3Sharp");
var _wifiCalling3SharpDefault = parcelHelpers.interopDefault(_wifiCalling3Sharp);
var _wifiCalling3TwoTone = require("./WifiCalling3TwoTone");
var _wifiCalling3TwoToneDefault = parcelHelpers.interopDefault(_wifiCalling3TwoTone);
var _wifiCallingOutlined = require("./WifiCallingOutlined");
var _wifiCallingOutlinedDefault = parcelHelpers.interopDefault(_wifiCallingOutlined);
var _wifiCallingRounded = require("./WifiCallingRounded");
var _wifiCallingRoundedDefault = parcelHelpers.interopDefault(_wifiCallingRounded);
var _wifiCallingSharp = require("./WifiCallingSharp");
var _wifiCallingSharpDefault = parcelHelpers.interopDefault(_wifiCallingSharp);
var _wifiCallingTwoTone = require("./WifiCallingTwoTone");
var _wifiCallingTwoToneDefault = parcelHelpers.interopDefault(_wifiCallingTwoTone);
var _wifiChannel = require("./WifiChannel");
var _wifiChannelDefault = parcelHelpers.interopDefault(_wifiChannel);
var _wifiChannelOutlined = require("./WifiChannelOutlined");
var _wifiChannelOutlinedDefault = parcelHelpers.interopDefault(_wifiChannelOutlined);
var _wifiChannelRounded = require("./WifiChannelRounded");
var _wifiChannelRoundedDefault = parcelHelpers.interopDefault(_wifiChannelRounded);
var _wifiChannelSharp = require("./WifiChannelSharp");
var _wifiChannelSharpDefault = parcelHelpers.interopDefault(_wifiChannelSharp);
var _wifiChannelTwoTone = require("./WifiChannelTwoTone");
var _wifiChannelTwoToneDefault = parcelHelpers.interopDefault(_wifiChannelTwoTone);
var _wifiFind = require("./WifiFind");
var _wifiFindDefault = parcelHelpers.interopDefault(_wifiFind);
var _wifiFindOutlined = require("./WifiFindOutlined");
var _wifiFindOutlinedDefault = parcelHelpers.interopDefault(_wifiFindOutlined);
var _wifiFindRounded = require("./WifiFindRounded");
var _wifiFindRoundedDefault = parcelHelpers.interopDefault(_wifiFindRounded);
var _wifiFindSharp = require("./WifiFindSharp");
var _wifiFindSharpDefault = parcelHelpers.interopDefault(_wifiFindSharp);
var _wifiFindTwoTone = require("./WifiFindTwoTone");
var _wifiFindTwoToneDefault = parcelHelpers.interopDefault(_wifiFindTwoTone);
var _wifiLock = require("./WifiLock");
var _wifiLockDefault = parcelHelpers.interopDefault(_wifiLock);
var _wifiLockOutlined = require("./WifiLockOutlined");
var _wifiLockOutlinedDefault = parcelHelpers.interopDefault(_wifiLockOutlined);
var _wifiLockRounded = require("./WifiLockRounded");
var _wifiLockRoundedDefault = parcelHelpers.interopDefault(_wifiLockRounded);
var _wifiLockSharp = require("./WifiLockSharp");
var _wifiLockSharpDefault = parcelHelpers.interopDefault(_wifiLockSharp);
var _wifiLockTwoTone = require("./WifiLockTwoTone");
var _wifiLockTwoToneDefault = parcelHelpers.interopDefault(_wifiLockTwoTone);
var _wifiOff = require("./WifiOff");
var _wifiOffDefault = parcelHelpers.interopDefault(_wifiOff);
var _wifiOffOutlined = require("./WifiOffOutlined");
var _wifiOffOutlinedDefault = parcelHelpers.interopDefault(_wifiOffOutlined);
var _wifiOffRounded = require("./WifiOffRounded");
var _wifiOffRoundedDefault = parcelHelpers.interopDefault(_wifiOffRounded);
var _wifiOffSharp = require("./WifiOffSharp");
var _wifiOffSharpDefault = parcelHelpers.interopDefault(_wifiOffSharp);
var _wifiOffTwoTone = require("./WifiOffTwoTone");
var _wifiOffTwoToneDefault = parcelHelpers.interopDefault(_wifiOffTwoTone);
var _wifiOutlined = require("./WifiOutlined");
var _wifiOutlinedDefault = parcelHelpers.interopDefault(_wifiOutlined);
var _wifiPassword = require("./WifiPassword");
var _wifiPasswordDefault = parcelHelpers.interopDefault(_wifiPassword);
var _wifiPasswordOutlined = require("./WifiPasswordOutlined");
var _wifiPasswordOutlinedDefault = parcelHelpers.interopDefault(_wifiPasswordOutlined);
var _wifiPasswordRounded = require("./WifiPasswordRounded");
var _wifiPasswordRoundedDefault = parcelHelpers.interopDefault(_wifiPasswordRounded);
var _wifiPasswordSharp = require("./WifiPasswordSharp");
var _wifiPasswordSharpDefault = parcelHelpers.interopDefault(_wifiPasswordSharp);
var _wifiPasswordTwoTone = require("./WifiPasswordTwoTone");
var _wifiPasswordTwoToneDefault = parcelHelpers.interopDefault(_wifiPasswordTwoTone);
var _wifiProtectedSetup = require("./WifiProtectedSetup");
var _wifiProtectedSetupDefault = parcelHelpers.interopDefault(_wifiProtectedSetup);
var _wifiProtectedSetupOutlined = require("./WifiProtectedSetupOutlined");
var _wifiProtectedSetupOutlinedDefault = parcelHelpers.interopDefault(_wifiProtectedSetupOutlined);
var _wifiProtectedSetupRounded = require("./WifiProtectedSetupRounded");
var _wifiProtectedSetupRoundedDefault = parcelHelpers.interopDefault(_wifiProtectedSetupRounded);
var _wifiProtectedSetupSharp = require("./WifiProtectedSetupSharp");
var _wifiProtectedSetupSharpDefault = parcelHelpers.interopDefault(_wifiProtectedSetupSharp);
var _wifiProtectedSetupTwoTone = require("./WifiProtectedSetupTwoTone");
var _wifiProtectedSetupTwoToneDefault = parcelHelpers.interopDefault(_wifiProtectedSetupTwoTone);
var _wifiRounded = require("./WifiRounded");
var _wifiRoundedDefault = parcelHelpers.interopDefault(_wifiRounded);
var _wifiSharp = require("./WifiSharp");
var _wifiSharpDefault = parcelHelpers.interopDefault(_wifiSharp);
var _wifiTethering = require("./WifiTethering");
var _wifiTetheringDefault = parcelHelpers.interopDefault(_wifiTethering);
var _wifiTetheringError = require("./WifiTetheringError");
var _wifiTetheringErrorDefault = parcelHelpers.interopDefault(_wifiTetheringError);
var _wifiTetheringErrorOutlined = require("./WifiTetheringErrorOutlined");
var _wifiTetheringErrorOutlinedDefault = parcelHelpers.interopDefault(_wifiTetheringErrorOutlined);
var _wifiTetheringErrorRounded = require("./WifiTetheringErrorRounded");
var _wifiTetheringErrorRoundedDefault = parcelHelpers.interopDefault(_wifiTetheringErrorRounded);
var _wifiTetheringErrorRoundedOutlined = require("./WifiTetheringErrorRoundedOutlined");
var _wifiTetheringErrorRoundedOutlinedDefault = parcelHelpers.interopDefault(_wifiTetheringErrorRoundedOutlined);
var _wifiTetheringErrorRoundedRounded = require("./WifiTetheringErrorRoundedRounded");
var _wifiTetheringErrorRoundedRoundedDefault = parcelHelpers.interopDefault(_wifiTetheringErrorRoundedRounded);
var _wifiTetheringErrorRoundedSharp = require("./WifiTetheringErrorRoundedSharp");
var _wifiTetheringErrorRoundedSharpDefault = parcelHelpers.interopDefault(_wifiTetheringErrorRoundedSharp);
var _wifiTetheringErrorRoundedTwoTone = require("./WifiTetheringErrorRoundedTwoTone");
var _wifiTetheringErrorRoundedTwoToneDefault = parcelHelpers.interopDefault(_wifiTetheringErrorRoundedTwoTone);
var _wifiTetheringErrorSharp = require("./WifiTetheringErrorSharp");
var _wifiTetheringErrorSharpDefault = parcelHelpers.interopDefault(_wifiTetheringErrorSharp);
var _wifiTetheringErrorTwoTone = require("./WifiTetheringErrorTwoTone");
var _wifiTetheringErrorTwoToneDefault = parcelHelpers.interopDefault(_wifiTetheringErrorTwoTone);
var _wifiTetheringOff = require("./WifiTetheringOff");
var _wifiTetheringOffDefault = parcelHelpers.interopDefault(_wifiTetheringOff);
var _wifiTetheringOffOutlined = require("./WifiTetheringOffOutlined");
var _wifiTetheringOffOutlinedDefault = parcelHelpers.interopDefault(_wifiTetheringOffOutlined);
var _wifiTetheringOffRounded = require("./WifiTetheringOffRounded");
var _wifiTetheringOffRoundedDefault = parcelHelpers.interopDefault(_wifiTetheringOffRounded);
var _wifiTetheringOffSharp = require("./WifiTetheringOffSharp");
var _wifiTetheringOffSharpDefault = parcelHelpers.interopDefault(_wifiTetheringOffSharp);
var _wifiTetheringOffTwoTone = require("./WifiTetheringOffTwoTone");
var _wifiTetheringOffTwoToneDefault = parcelHelpers.interopDefault(_wifiTetheringOffTwoTone);
var _wifiTetheringOutlined = require("./WifiTetheringOutlined");
var _wifiTetheringOutlinedDefault = parcelHelpers.interopDefault(_wifiTetheringOutlined);
var _wifiTetheringRounded = require("./WifiTetheringRounded");
var _wifiTetheringRoundedDefault = parcelHelpers.interopDefault(_wifiTetheringRounded);
var _wifiTetheringSharp = require("./WifiTetheringSharp");
var _wifiTetheringSharpDefault = parcelHelpers.interopDefault(_wifiTetheringSharp);
var _wifiTetheringTwoTone = require("./WifiTetheringTwoTone");
var _wifiTetheringTwoToneDefault = parcelHelpers.interopDefault(_wifiTetheringTwoTone);
var _wifiTwoTone = require("./WifiTwoTone");
var _wifiTwoToneDefault = parcelHelpers.interopDefault(_wifiTwoTone);
var _windPower = require("./WindPower");
var _windPowerDefault = parcelHelpers.interopDefault(_windPower);
var _windPowerOutlined = require("./WindPowerOutlined");
var _windPowerOutlinedDefault = parcelHelpers.interopDefault(_windPowerOutlined);
var _windPowerRounded = require("./WindPowerRounded");
var _windPowerRoundedDefault = parcelHelpers.interopDefault(_windPowerRounded);
var _windPowerSharp = require("./WindPowerSharp");
var _windPowerSharpDefault = parcelHelpers.interopDefault(_windPowerSharp);
var _windPowerTwoTone = require("./WindPowerTwoTone");
var _windPowerTwoToneDefault = parcelHelpers.interopDefault(_windPowerTwoTone);
var _window = require("./Window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var _windowOutlined = require("./WindowOutlined");
var _windowOutlinedDefault = parcelHelpers.interopDefault(_windowOutlined);
var _windowRounded = require("./WindowRounded");
var _windowRoundedDefault = parcelHelpers.interopDefault(_windowRounded);
var _windowSharp = require("./WindowSharp");
var _windowSharpDefault = parcelHelpers.interopDefault(_windowSharp);
var _windowTwoTone = require("./WindowTwoTone");
var _windowTwoToneDefault = parcelHelpers.interopDefault(_windowTwoTone);
var _wineBar = require("./WineBar");
var _wineBarDefault = parcelHelpers.interopDefault(_wineBar);
var _wineBarOutlined = require("./WineBarOutlined");
var _wineBarOutlinedDefault = parcelHelpers.interopDefault(_wineBarOutlined);
var _wineBarRounded = require("./WineBarRounded");
var _wineBarRoundedDefault = parcelHelpers.interopDefault(_wineBarRounded);
var _wineBarSharp = require("./WineBarSharp");
var _wineBarSharpDefault = parcelHelpers.interopDefault(_wineBarSharp);
var _wineBarTwoTone = require("./WineBarTwoTone");
var _wineBarTwoToneDefault = parcelHelpers.interopDefault(_wineBarTwoTone);
var _woman = require("./Woman");
var _womanDefault = parcelHelpers.interopDefault(_woman);
var _woman2 = require("./Woman2");
var _woman2Default = parcelHelpers.interopDefault(_woman2);
var _woman2Outlined = require("./Woman2Outlined");
var _woman2OutlinedDefault = parcelHelpers.interopDefault(_woman2Outlined);
var _woman2Rounded = require("./Woman2Rounded");
var _woman2RoundedDefault = parcelHelpers.interopDefault(_woman2Rounded);
var _woman2Sharp = require("./Woman2Sharp");
var _woman2SharpDefault = parcelHelpers.interopDefault(_woman2Sharp);
var _woman2TwoTone = require("./Woman2TwoTone");
var _woman2TwoToneDefault = parcelHelpers.interopDefault(_woman2TwoTone);
var _womanOutlined = require("./WomanOutlined");
var _womanOutlinedDefault = parcelHelpers.interopDefault(_womanOutlined);
var _womanRounded = require("./WomanRounded");
var _womanRoundedDefault = parcelHelpers.interopDefault(_womanRounded);
var _womanSharp = require("./WomanSharp");
var _womanSharpDefault = parcelHelpers.interopDefault(_womanSharp);
var _womanTwoTone = require("./WomanTwoTone");
var _womanTwoToneDefault = parcelHelpers.interopDefault(_womanTwoTone);
var _work = require("./Work");
var _workDefault = parcelHelpers.interopDefault(_work);
var _workHistory = require("./WorkHistory");
var _workHistoryDefault = parcelHelpers.interopDefault(_workHistory);
var _workHistoryOutlined = require("./WorkHistoryOutlined");
var _workHistoryOutlinedDefault = parcelHelpers.interopDefault(_workHistoryOutlined);
var _workHistoryRounded = require("./WorkHistoryRounded");
var _workHistoryRoundedDefault = parcelHelpers.interopDefault(_workHistoryRounded);
var _workHistorySharp = require("./WorkHistorySharp");
var _workHistorySharpDefault = parcelHelpers.interopDefault(_workHistorySharp);
var _workHistoryTwoTone = require("./WorkHistoryTwoTone");
var _workHistoryTwoToneDefault = parcelHelpers.interopDefault(_workHistoryTwoTone);
var _workOff = require("./WorkOff");
var _workOffDefault = parcelHelpers.interopDefault(_workOff);
var _workOffOutlined = require("./WorkOffOutlined");
var _workOffOutlinedDefault = parcelHelpers.interopDefault(_workOffOutlined);
var _workOffRounded = require("./WorkOffRounded");
var _workOffRoundedDefault = parcelHelpers.interopDefault(_workOffRounded);
var _workOffSharp = require("./WorkOffSharp");
var _workOffSharpDefault = parcelHelpers.interopDefault(_workOffSharp);
var _workOffTwoTone = require("./WorkOffTwoTone");
var _workOffTwoToneDefault = parcelHelpers.interopDefault(_workOffTwoTone);
var _workOutline = require("./WorkOutline");
var _workOutlineDefault = parcelHelpers.interopDefault(_workOutline);
var _workOutlineOutlined = require("./WorkOutlineOutlined");
var _workOutlineOutlinedDefault = parcelHelpers.interopDefault(_workOutlineOutlined);
var _workOutlineRounded = require("./WorkOutlineRounded");
var _workOutlineRoundedDefault = parcelHelpers.interopDefault(_workOutlineRounded);
var _workOutlineSharp = require("./WorkOutlineSharp");
var _workOutlineSharpDefault = parcelHelpers.interopDefault(_workOutlineSharp);
var _workOutlineTwoTone = require("./WorkOutlineTwoTone");
var _workOutlineTwoToneDefault = parcelHelpers.interopDefault(_workOutlineTwoTone);
var _workOutlined = require("./WorkOutlined");
var _workOutlinedDefault = parcelHelpers.interopDefault(_workOutlined);
var _workRounded = require("./WorkRounded");
var _workRoundedDefault = parcelHelpers.interopDefault(_workRounded);
var _workSharp = require("./WorkSharp");
var _workSharpDefault = parcelHelpers.interopDefault(_workSharp);
var _workTwoTone = require("./WorkTwoTone");
var _workTwoToneDefault = parcelHelpers.interopDefault(_workTwoTone);
var _workspacePremium = require("./WorkspacePremium");
var _workspacePremiumDefault = parcelHelpers.interopDefault(_workspacePremium);
var _workspacePremiumOutlined = require("./WorkspacePremiumOutlined");
var _workspacePremiumOutlinedDefault = parcelHelpers.interopDefault(_workspacePremiumOutlined);
var _workspacePremiumRounded = require("./WorkspacePremiumRounded");
var _workspacePremiumRoundedDefault = parcelHelpers.interopDefault(_workspacePremiumRounded);
var _workspacePremiumSharp = require("./WorkspacePremiumSharp");
var _workspacePremiumSharpDefault = parcelHelpers.interopDefault(_workspacePremiumSharp);
var _workspacePremiumTwoTone = require("./WorkspacePremiumTwoTone");
var _workspacePremiumTwoToneDefault = parcelHelpers.interopDefault(_workspacePremiumTwoTone);
var _workspaces = require("./Workspaces");
var _workspacesDefault = parcelHelpers.interopDefault(_workspaces);
var _workspacesOutlined = require("./WorkspacesOutlined");
var _workspacesOutlinedDefault = parcelHelpers.interopDefault(_workspacesOutlined);
var _workspacesRounded = require("./WorkspacesRounded");
var _workspacesRoundedDefault = parcelHelpers.interopDefault(_workspacesRounded);
var _workspacesSharp = require("./WorkspacesSharp");
var _workspacesSharpDefault = parcelHelpers.interopDefault(_workspacesSharp);
var _workspacesTwoTone = require("./WorkspacesTwoTone");
var _workspacesTwoToneDefault = parcelHelpers.interopDefault(_workspacesTwoTone);
var _wrapText = require("./WrapText");
var _wrapTextDefault = parcelHelpers.interopDefault(_wrapText);
var _wrapTextOutlined = require("./WrapTextOutlined");
var _wrapTextOutlinedDefault = parcelHelpers.interopDefault(_wrapTextOutlined);
var _wrapTextRounded = require("./WrapTextRounded");
var _wrapTextRoundedDefault = parcelHelpers.interopDefault(_wrapTextRounded);
var _wrapTextSharp = require("./WrapTextSharp");
var _wrapTextSharpDefault = parcelHelpers.interopDefault(_wrapTextSharp);
var _wrapTextTwoTone = require("./WrapTextTwoTone");
var _wrapTextTwoToneDefault = parcelHelpers.interopDefault(_wrapTextTwoTone);
var _wrongLocation = require("./WrongLocation");
var _wrongLocationDefault = parcelHelpers.interopDefault(_wrongLocation);
var _wrongLocationOutlined = require("./WrongLocationOutlined");
var _wrongLocationOutlinedDefault = parcelHelpers.interopDefault(_wrongLocationOutlined);
var _wrongLocationRounded = require("./WrongLocationRounded");
var _wrongLocationRoundedDefault = parcelHelpers.interopDefault(_wrongLocationRounded);
var _wrongLocationSharp = require("./WrongLocationSharp");
var _wrongLocationSharpDefault = parcelHelpers.interopDefault(_wrongLocationSharp);
var _wrongLocationTwoTone = require("./WrongLocationTwoTone");
var _wrongLocationTwoToneDefault = parcelHelpers.interopDefault(_wrongLocationTwoTone);
var _wysiwyg = require("./Wysiwyg");
var _wysiwygDefault = parcelHelpers.interopDefault(_wysiwyg);
var _wysiwygOutlined = require("./WysiwygOutlined");
var _wysiwygOutlinedDefault = parcelHelpers.interopDefault(_wysiwygOutlined);
var _wysiwygRounded = require("./WysiwygRounded");
var _wysiwygRoundedDefault = parcelHelpers.interopDefault(_wysiwygRounded);
var _wysiwygSharp = require("./WysiwygSharp");
var _wysiwygSharpDefault = parcelHelpers.interopDefault(_wysiwygSharp);
var _wysiwygTwoTone = require("./WysiwygTwoTone");
var _wysiwygTwoToneDefault = parcelHelpers.interopDefault(_wysiwygTwoTone);
var _x = require("./X");
var _xDefault = parcelHelpers.interopDefault(_x);
var _yard = require("./Yard");
var _yardDefault = parcelHelpers.interopDefault(_yard);
var _yardOutlined = require("./YardOutlined");
var _yardOutlinedDefault = parcelHelpers.interopDefault(_yardOutlined);
var _yardRounded = require("./YardRounded");
var _yardRoundedDefault = parcelHelpers.interopDefault(_yardRounded);
var _yardSharp = require("./YardSharp");
var _yardSharpDefault = parcelHelpers.interopDefault(_yardSharp);
var _yardTwoTone = require("./YardTwoTone");
var _yardTwoToneDefault = parcelHelpers.interopDefault(_yardTwoTone);
var _youTube = require("./YouTube");
var _youTubeDefault = parcelHelpers.interopDefault(_youTube);
var _youtubeSearchedFor = require("./YoutubeSearchedFor");
var _youtubeSearchedForDefault = parcelHelpers.interopDefault(_youtubeSearchedFor);
var _youtubeSearchedForOutlined = require("./YoutubeSearchedForOutlined");
var _youtubeSearchedForOutlinedDefault = parcelHelpers.interopDefault(_youtubeSearchedForOutlined);
var _youtubeSearchedForRounded = require("./YoutubeSearchedForRounded");
var _youtubeSearchedForRoundedDefault = parcelHelpers.interopDefault(_youtubeSearchedForRounded);
var _youtubeSearchedForSharp = require("./YoutubeSearchedForSharp");
var _youtubeSearchedForSharpDefault = parcelHelpers.interopDefault(_youtubeSearchedForSharp);
var _youtubeSearchedForTwoTone = require("./YoutubeSearchedForTwoTone");
var _youtubeSearchedForTwoToneDefault = parcelHelpers.interopDefault(_youtubeSearchedForTwoTone);
var _zoomIn = require("./ZoomIn");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
var _zoomInMap = require("./ZoomInMap");
var _zoomInMapDefault = parcelHelpers.interopDefault(_zoomInMap);
var _zoomInMapOutlined = require("./ZoomInMapOutlined");
var _zoomInMapOutlinedDefault = parcelHelpers.interopDefault(_zoomInMapOutlined);
var _zoomInMapRounded = require("./ZoomInMapRounded");
var _zoomInMapRoundedDefault = parcelHelpers.interopDefault(_zoomInMapRounded);
var _zoomInMapSharp = require("./ZoomInMapSharp");
var _zoomInMapSharpDefault = parcelHelpers.interopDefault(_zoomInMapSharp);
var _zoomInMapTwoTone = require("./ZoomInMapTwoTone");
var _zoomInMapTwoToneDefault = parcelHelpers.interopDefault(_zoomInMapTwoTone);
var _zoomInOutlined = require("./ZoomInOutlined");
var _zoomInOutlinedDefault = parcelHelpers.interopDefault(_zoomInOutlined);
var _zoomInRounded = require("./ZoomInRounded");
var _zoomInRoundedDefault = parcelHelpers.interopDefault(_zoomInRounded);
var _zoomInSharp = require("./ZoomInSharp");
var _zoomInSharpDefault = parcelHelpers.interopDefault(_zoomInSharp);
var _zoomInTwoTone = require("./ZoomInTwoTone");
var _zoomInTwoToneDefault = parcelHelpers.interopDefault(_zoomInTwoTone);
var _zoomOut = require("./ZoomOut");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);
var _zoomOutMap = require("./ZoomOutMap");
var _zoomOutMapDefault = parcelHelpers.interopDefault(_zoomOutMap);
var _zoomOutMapOutlined = require("./ZoomOutMapOutlined");
var _zoomOutMapOutlinedDefault = parcelHelpers.interopDefault(_zoomOutMapOutlined);
var _zoomOutMapRounded = require("./ZoomOutMapRounded");
var _zoomOutMapRoundedDefault = parcelHelpers.interopDefault(_zoomOutMapRounded);
var _zoomOutMapSharp = require("./ZoomOutMapSharp");
var _zoomOutMapSharpDefault = parcelHelpers.interopDefault(_zoomOutMapSharp);
var _zoomOutMapTwoTone = require("./ZoomOutMapTwoTone");
var _zoomOutMapTwoToneDefault = parcelHelpers.interopDefault(_zoomOutMapTwoTone);
var _zoomOutOutlined = require("./ZoomOutOutlined");
var _zoomOutOutlinedDefault = parcelHelpers.interopDefault(_zoomOutOutlined);
var _zoomOutRounded = require("./ZoomOutRounded");
var _zoomOutRoundedDefault = parcelHelpers.interopDefault(_zoomOutRounded);
var _zoomOutSharp = require("./ZoomOutSharp");
var _zoomOutSharpDefault = parcelHelpers.interopDefault(_zoomOutSharp);
var _zoomOutTwoTone = require("./ZoomOutTwoTone");
var _zoomOutTwoToneDefault = parcelHelpers.interopDefault(_zoomOutTwoTone);

},{"./Abc":false,"./AbcOutlined":false,"./AbcRounded":false,"./AbcSharp":false,"./AbcTwoTone":false,"./AcUnit":false,"./AcUnitOutlined":false,"./AcUnitRounded":false,"./AcUnitSharp":false,"./AcUnitTwoTone":false,"./AccessAlarm":"aTO0P","./AccessAlarmOutlined":false,"./AccessAlarmRounded":false,"./AccessAlarmSharp":false,"./AccessAlarmTwoTone":false,"./AccessAlarms":false,"./AccessAlarmsOutlined":false,"./AccessAlarmsRounded":false,"./AccessAlarmsSharp":false,"./AccessAlarmsTwoTone":false,"./AccessTime":false,"./AccessTimeFilled":false,"./AccessTimeFilledOutlined":false,"./AccessTimeFilledRounded":false,"./AccessTimeFilledSharp":false,"./AccessTimeFilledTwoTone":false,"./AccessTimeOutlined":false,"./AccessTimeRounded":false,"./AccessTimeSharp":false,"./AccessTimeTwoTone":false,"./Accessibility":false,"./AccessibilityNew":false,"./AccessibilityNewOutlined":false,"./AccessibilityNewRounded":false,"./AccessibilityNewSharp":false,"./AccessibilityNewTwoTone":false,"./AccessibilityOutlined":false,"./AccessibilityRounded":false,"./AccessibilitySharp":false,"./AccessibilityTwoTone":false,"./Accessible":false,"./AccessibleForward":false,"./AccessibleForwardOutlined":false,"./AccessibleForwardRounded":false,"./AccessibleForwardSharp":false,"./AccessibleForwardTwoTone":false,"./AccessibleOutlined":false,"./AccessibleRounded":false,"./AccessibleSharp":false,"./AccessibleTwoTone":false,"./AccountBalance":false,"./AccountBalanceOutlined":false,"./AccountBalanceRounded":false,"./AccountBalanceSharp":false,"./AccountBalanceTwoTone":false,"./AccountBalanceWallet":false,"./AccountBalanceWalletOutlined":false,"./AccountBalanceWalletRounded":false,"./AccountBalanceWalletSharp":false,"./AccountBalanceWalletTwoTone":false,"./AccountBox":false,"./AccountBoxOutlined":false,"./AccountBoxRounded":false,"./AccountBoxSharp":false,"./AccountBoxTwoTone":false,"./AccountCircle":false,"./AccountCircleOutlined":false,"./AccountCircleRounded":false,"./AccountCircleSharp":false,"./AccountCircleTwoTone":false,"./AccountTree":false,"./AccountTreeOutlined":false,"./AccountTreeRounded":false,"./AccountTreeSharp":false,"./AccountTreeTwoTone":false,"./AdUnits":false,"./AdUnitsOutlined":false,"./AdUnitsRounded":false,"./AdUnitsSharp":false,"./AdUnitsTwoTone":false,"./Adb":false,"./AdbOutlined":false,"./AdbRounded":false,"./AdbSharp":false,"./AdbTwoTone":false,"./Add":"5lKug","./AddAPhoto":false,"./AddAPhotoOutlined":false,"./AddAPhotoRounded":false,"./AddAPhotoSharp":false,"./AddAPhotoTwoTone":false,"./AddAlarm":false,"./AddAlarmOutlined":false,"./AddAlarmRounded":false,"./AddAlarmSharp":false,"./AddAlarmTwoTone":false,"./AddAlert":false,"./AddAlertOutlined":false,"./AddAlertRounded":false,"./AddAlertSharp":false,"./AddAlertTwoTone":false,"./AddBox":false,"./AddBoxOutlined":false,"./AddBoxRounded":false,"./AddBoxSharp":false,"./AddBoxTwoTone":false,"./AddBusiness":"9fzQo","./AddBusinessOutlined":false,"./AddBusinessRounded":false,"./AddBusinessSharp":false,"./AddBusinessTwoTone":false,"./AddCard":false,"./AddCardOutlined":false,"./AddCardRounded":false,"./AddCardSharp":false,"./AddCardTwoTone":false,"./AddCircle":false,"./AddCircleOutline":false,"./AddCircleOutlineOutlined":false,"./AddCircleOutlineRounded":false,"./AddCircleOutlineSharp":false,"./AddCircleOutlineTwoTone":false,"./AddCircleOutlined":false,"./AddCircleRounded":false,"./AddCircleSharp":false,"./AddCircleTwoTone":false,"./AddComment":false,"./AddCommentOutlined":false,"./AddCommentRounded":false,"./AddCommentSharp":false,"./AddCommentTwoTone":false,"./AddHome":false,"./AddHomeOutlined":false,"./AddHomeRounded":false,"./AddHomeSharp":false,"./AddHomeTwoTone":false,"./AddHomeWork":false,"./AddHomeWorkOutlined":false,"./AddHomeWorkRounded":false,"./AddHomeWorkSharp":false,"./AddHomeWorkTwoTone":false,"./AddIcCall":false,"./AddIcCallOutlined":false,"./AddIcCallRounded":false,"./AddIcCallSharp":false,"./AddIcCallTwoTone":false,"./AddLink":false,"./AddLinkOutlined":false,"./AddLinkRounded":false,"./AddLinkSharp":false,"./AddLinkTwoTone":false,"./AddLocation":false,"./AddLocationAlt":false,"./AddLocationAltOutlined":false,"./AddLocationAltRounded":false,"./AddLocationAltSharp":false,"./AddLocationAltTwoTone":false,"./AddLocationOutlined":false,"./AddLocationRounded":false,"./AddLocationSharp":false,"./AddLocationTwoTone":false,"./AddModerator":false,"./AddModeratorOutlined":false,"./AddModeratorRounded":false,"./AddModeratorSharp":false,"./AddModeratorTwoTone":false,"./AddOutlined":false,"./AddPhotoAlternate":false,"./AddPhotoAlternateOutlined":false,"./AddPhotoAlternateRounded":false,"./AddPhotoAlternateSharp":false,"./AddPhotoAlternateTwoTone":false,"./AddReaction":false,"./AddReactionOutlined":false,"./AddReactionRounded":false,"./AddReactionSharp":false,"./AddReactionTwoTone":false,"./AddRoad":false,"./AddRoadOutlined":false,"./AddRoadRounded":false,"./AddRoadSharp":false,"./AddRoadTwoTone":false,"./AddRounded":false,"./AddSharp":false,"./AddShoppingCart":false,"./AddShoppingCartOutlined":false,"./AddShoppingCartRounded":false,"./AddShoppingCartSharp":false,"./AddShoppingCartTwoTone":false,"./AddTask":false,"./AddTaskOutlined":false,"./AddTaskRounded":false,"./AddTaskSharp":false,"./AddTaskTwoTone":false,"./AddToDrive":false,"./AddToDriveOutlined":false,"./AddToDriveRounded":false,"./AddToDriveSharp":false,"./AddToDriveTwoTone":false,"./AddToHomeScreen":false,"./AddToHomeScreenOutlined":false,"./AddToHomeScreenRounded":false,"./AddToHomeScreenSharp":false,"./AddToHomeScreenTwoTone":false,"./AddToPhotos":false,"./AddToPhotosOutlined":false,"./AddToPhotosRounded":false,"./AddToPhotosSharp":false,"./AddToPhotosTwoTone":false,"./AddToQueue":false,"./AddToQueueOutlined":false,"./AddToQueueRounded":false,"./AddToQueueSharp":false,"./AddToQueueTwoTone":false,"./AddTwoTone":false,"./Addchart":false,"./AddchartOutlined":false,"./AddchartRounded":false,"./AddchartSharp":false,"./AddchartTwoTone":false,"./AdfScanner":false,"./AdfScannerOutlined":false,"./AdfScannerRounded":false,"./AdfScannerSharp":false,"./AdfScannerTwoTone":false,"./Adjust":false,"./AdjustOutlined":false,"./AdjustRounded":false,"./AdjustSharp":false,"./AdjustTwoTone":false,"./AdminPanelSettings":false,"./AdminPanelSettingsOutlined":false,"./AdminPanelSettingsRounded":false,"./AdminPanelSettingsSharp":false,"./AdminPanelSettingsTwoTone":false,"./AdsClick":false,"./AdsClickOutlined":false,"./AdsClickRounded":false,"./AdsClickSharp":false,"./AdsClickTwoTone":false,"./Agriculture":false,"./AgricultureOutlined":false,"./AgricultureRounded":false,"./AgricultureSharp":false,"./AgricultureTwoTone":false,"./Air":false,"./AirOutlined":false,"./AirRounded":false,"./AirSharp":false,"./AirTwoTone":false,"./AirlineSeatFlat":false,"./AirlineSeatFlatAngled":false,"./AirlineSeatFlatAngledOutlined":false,"./AirlineSeatFlatAngledRounded":false,"./AirlineSeatFlatAngledSharp":false,"./AirlineSeatFlatAngledTwoTone":false,"./AirlineSeatFlatOutlined":false,"./AirlineSeatFlatRounded":false,"./AirlineSeatFlatSharp":false,"./AirlineSeatFlatTwoTone":false,"./AirlineSeatIndividualSuite":false,"./AirlineSeatIndividualSuiteOutlined":false,"./AirlineSeatIndividualSuiteRounded":false,"./AirlineSeatIndividualSuiteSharp":false,"./AirlineSeatIndividualSuiteTwoTone":false,"./AirlineSeatLegroomExtra":false,"./AirlineSeatLegroomExtraOutlined":false,"./AirlineSeatLegroomExtraRounded":false,"./AirlineSeatLegroomExtraSharp":false,"./AirlineSeatLegroomExtraTwoTone":false,"./AirlineSeatLegroomNormal":false,"./AirlineSeatLegroomNormalOutlined":false,"./AirlineSeatLegroomNormalRounded":false,"./AirlineSeatLegroomNormalSharp":false,"./AirlineSeatLegroomNormalTwoTone":false,"./AirlineSeatLegroomReduced":false,"./AirlineSeatLegroomReducedOutlined":false,"./AirlineSeatLegroomReducedRounded":false,"./AirlineSeatLegroomReducedSharp":false,"./AirlineSeatLegroomReducedTwoTone":false,"./AirlineSeatReclineExtra":false,"./AirlineSeatReclineExtraOutlined":false,"./AirlineSeatReclineExtraRounded":false,"./AirlineSeatReclineExtraSharp":false,"./AirlineSeatReclineExtraTwoTone":false,"./AirlineSeatReclineNormal":false,"./AirlineSeatReclineNormalOutlined":false,"./AirlineSeatReclineNormalRounded":false,"./AirlineSeatReclineNormalSharp":false,"./AirlineSeatReclineNormalTwoTone":false,"./AirlineStops":false,"./AirlineStopsOutlined":false,"./AirlineStopsRounded":false,"./AirlineStopsSharp":false,"./AirlineStopsTwoTone":false,"./Airlines":false,"./AirlinesOutlined":false,"./AirlinesRounded":false,"./AirlinesSharp":false,"./AirlinesTwoTone":false,"./AirplaneTicket":false,"./AirplaneTicketOutlined":false,"./AirplaneTicketRounded":false,"./AirplaneTicketSharp":false,"./AirplaneTicketTwoTone":false,"./AirplanemodeActive":false,"./AirplanemodeActiveOutlined":false,"./AirplanemodeActiveRounded":false,"./AirplanemodeActiveSharp":false,"./AirplanemodeActiveTwoTone":false,"./AirplanemodeInactive":false,"./AirplanemodeInactiveOutlined":false,"./AirplanemodeInactiveRounded":false,"./AirplanemodeInactiveSharp":false,"./AirplanemodeInactiveTwoTone":false,"./Airplay":false,"./AirplayOutlined":false,"./AirplayRounded":false,"./AirplaySharp":false,"./AirplayTwoTone":false,"./AirportShuttle":false,"./AirportShuttleOutlined":false,"./AirportShuttleRounded":false,"./AirportShuttleSharp":false,"./AirportShuttleTwoTone":false,"./Alarm":false,"./AlarmAdd":false,"./AlarmAddOutlined":false,"./AlarmAddRounded":false,"./AlarmAddSharp":false,"./AlarmAddTwoTone":false,"./AlarmOff":"65ssb","./AlarmOffOutlined":false,"./AlarmOffRounded":false,"./AlarmOffSharp":false,"./AlarmOffTwoTone":false,"./AlarmOn":false,"./AlarmOnOutlined":false,"./AlarmOnRounded":false,"./AlarmOnSharp":false,"./AlarmOnTwoTone":false,"./AlarmOutlined":false,"./AlarmRounded":false,"./AlarmSharp":false,"./AlarmTwoTone":false,"./Album":false,"./AlbumOutlined":false,"./AlbumRounded":false,"./AlbumSharp":false,"./AlbumTwoTone":false,"./AlignHorizontalCenter":false,"./AlignHorizontalCenterOutlined":false,"./AlignHorizontalCenterRounded":false,"./AlignHorizontalCenterSharp":false,"./AlignHorizontalCenterTwoTone":false,"./AlignHorizontalLeft":false,"./AlignHorizontalLeftOutlined":false,"./AlignHorizontalLeftRounded":false,"./AlignHorizontalLeftSharp":false,"./AlignHorizontalLeftTwoTone":false,"./AlignHorizontalRight":false,"./AlignHorizontalRightOutlined":false,"./AlignHorizontalRightRounded":false,"./AlignHorizontalRightSharp":false,"./AlignHorizontalRightTwoTone":false,"./AlignVerticalBottom":false,"./AlignVerticalBottomOutlined":false,"./AlignVerticalBottomRounded":false,"./AlignVerticalBottomSharp":false,"./AlignVerticalBottomTwoTone":false,"./AlignVerticalCenter":false,"./AlignVerticalCenterOutlined":false,"./AlignVerticalCenterRounded":false,"./AlignVerticalCenterSharp":false,"./AlignVerticalCenterTwoTone":false,"./AlignVerticalTop":false,"./AlignVerticalTopOutlined":false,"./AlignVerticalTopRounded":false,"./AlignVerticalTopSharp":false,"./AlignVerticalTopTwoTone":false,"./AllInbox":false,"./AllInboxOutlined":false,"./AllInboxRounded":false,"./AllInboxSharp":false,"./AllInboxTwoTone":false,"./AllInclusive":false,"./AllInclusiveOutlined":false,"./AllInclusiveRounded":false,"./AllInclusiveSharp":false,"./AllInclusiveTwoTone":false,"./AllOut":false,"./AllOutOutlined":false,"./AllOutRounded":false,"./AllOutSharp":false,"./AllOutTwoTone":false,"./AltRoute":false,"./AltRouteOutlined":false,"./AltRouteRounded":false,"./AltRouteSharp":false,"./AltRouteTwoTone":false,"./AlternateEmail":false,"./AlternateEmailOutlined":false,"./AlternateEmailRounded":false,"./AlternateEmailSharp":false,"./AlternateEmailTwoTone":false,"./Analytics":false,"./AnalyticsOutlined":false,"./AnalyticsRounded":false,"./AnalyticsSharp":false,"./AnalyticsTwoTone":false,"./Anchor":false,"./AnchorOutlined":false,"./AnchorRounded":false,"./AnchorSharp":false,"./AnchorTwoTone":false,"./Android":false,"./AndroidOutlined":false,"./AndroidRounded":false,"./AndroidSharp":false,"./AndroidTwoTone":false,"./Animation":false,"./AnimationOutlined":false,"./AnimationRounded":false,"./AnimationSharp":false,"./AnimationTwoTone":false,"./Announcement":false,"./AnnouncementOutlined":false,"./AnnouncementRounded":false,"./AnnouncementSharp":false,"./AnnouncementTwoTone":false,"./Aod":false,"./AodOutlined":false,"./AodRounded":false,"./AodSharp":false,"./AodTwoTone":false,"./Apartment":false,"./ApartmentOutlined":false,"./ApartmentRounded":false,"./ApartmentSharp":false,"./ApartmentTwoTone":false,"./Api":false,"./ApiOutlined":false,"./ApiRounded":false,"./ApiSharp":false,"./ApiTwoTone":false,"./AppBlocking":false,"./AppBlockingOutlined":false,"./AppBlockingRounded":false,"./AppBlockingSharp":false,"./AppBlockingTwoTone":false,"./AppRegistration":false,"./AppRegistrationOutlined":false,"./AppRegistrationRounded":false,"./AppRegistrationSharp":false,"./AppRegistrationTwoTone":false,"./AppSettingsAlt":false,"./AppSettingsAltOutlined":false,"./AppSettingsAltRounded":false,"./AppSettingsAltSharp":false,"./AppSettingsAltTwoTone":false,"./AppShortcut":false,"./AppShortcutOutlined":false,"./AppShortcutRounded":false,"./AppShortcutSharp":false,"./AppShortcutTwoTone":false,"./Apple":false,"./Approval":false,"./ApprovalOutlined":false,"./ApprovalRounded":false,"./ApprovalSharp":false,"./ApprovalTwoTone":false,"./Apps":false,"./AppsOutage":false,"./AppsOutageOutlined":false,"./AppsOutageRounded":false,"./AppsOutageSharp":false,"./AppsOutageTwoTone":false,"./AppsOutlined":false,"./AppsRounded":false,"./AppsSharp":false,"./AppsTwoTone":false,"./Architecture":false,"./ArchitectureOutlined":false,"./ArchitectureRounded":false,"./ArchitectureSharp":false,"./ArchitectureTwoTone":false,"./Archive":"6A0Pl","./ArchiveOutlined":false,"./ArchiveRounded":false,"./ArchiveSharp":false,"./ArchiveTwoTone":false,"./ArrowBack":false,"./ArrowBackIos":false,"./ArrowBackIosNew":false,"./ArrowBackIosNewOutlined":false,"./ArrowBackIosNewRounded":false,"./ArrowBackIosNewSharp":false,"./ArrowBackIosNewTwoTone":false,"./ArrowBackIosOutlined":false,"./ArrowBackIosRounded":false,"./ArrowBackIosSharp":false,"./ArrowBackIosTwoTone":false,"./ArrowBackOutlined":false,"./ArrowBackRounded":false,"./ArrowBackSharp":false,"./ArrowBackTwoTone":false,"./ArrowCircleDown":false,"./ArrowCircleDownOutlined":false,"./ArrowCircleDownRounded":false,"./ArrowCircleDownSharp":false,"./ArrowCircleDownTwoTone":false,"./ArrowCircleLeft":false,"./ArrowCircleLeftOutlined":false,"./ArrowCircleLeftRounded":false,"./ArrowCircleLeftSharp":false,"./ArrowCircleLeftTwoTone":false,"./ArrowCircleRight":false,"./ArrowCircleRightOutlined":false,"./ArrowCircleRightRounded":false,"./ArrowCircleRightSharp":false,"./ArrowCircleRightTwoTone":false,"./ArrowCircleUp":false,"./ArrowCircleUpOutlined":false,"./ArrowCircleUpRounded":false,"./ArrowCircleUpSharp":false,"./ArrowCircleUpTwoTone":false,"./ArrowDownward":false,"./ArrowDownwardOutlined":false,"./ArrowDownwardRounded":false,"./ArrowDownwardSharp":false,"./ArrowDownwardTwoTone":false,"./ArrowDropDown":false,"./ArrowDropDownCircle":false,"./ArrowDropDownCircleOutlined":false,"./ArrowDropDownCircleRounded":false,"./ArrowDropDownCircleSharp":false,"./ArrowDropDownCircleTwoTone":false,"./ArrowDropDownOutlined":false,"./ArrowDropDownRounded":false,"./ArrowDropDownSharp":false,"./ArrowDropDownTwoTone":false,"./ArrowDropUp":false,"./ArrowDropUpOutlined":false,"./ArrowDropUpRounded":false,"./ArrowDropUpSharp":false,"./ArrowDropUpTwoTone":false,"./ArrowForward":false,"./ArrowForwardIos":false,"./ArrowForwardIosOutlined":false,"./ArrowForwardIosRounded":false,"./ArrowForwardIosSharp":false,"./ArrowForwardIosTwoTone":false,"./ArrowForwardOutlined":false,"./ArrowForwardRounded":false,"./ArrowForwardSharp":false,"./ArrowForwardTwoTone":false,"./ArrowLeft":false,"./ArrowLeftOutlined":false,"./ArrowLeftRounded":false,"./ArrowLeftSharp":false,"./ArrowLeftTwoTone":false,"./ArrowOutward":false,"./ArrowOutwardOutlined":false,"./ArrowOutwardRounded":false,"./ArrowOutwardSharp":false,"./ArrowOutwardTwoTone":false,"./ArrowRight":false,"./ArrowRightAlt":false,"./ArrowRightAltOutlined":false,"./ArrowRightAltRounded":false,"./ArrowRightAltSharp":false,"./ArrowRightAltTwoTone":false,"./ArrowRightOutlined":false,"./ArrowRightRounded":false,"./ArrowRightSharp":false,"./ArrowRightTwoTone":false,"./ArrowUpward":false,"./ArrowUpwardOutlined":false,"./ArrowUpwardRounded":false,"./ArrowUpwardSharp":false,"./ArrowUpwardTwoTone":false,"./ArtTrack":false,"./ArtTrackOutlined":false,"./ArtTrackRounded":false,"./ArtTrackSharp":false,"./ArtTrackTwoTone":false,"./Article":false,"./ArticleOutlined":false,"./ArticleRounded":false,"./ArticleSharp":false,"./ArticleTwoTone":false,"./AspectRatio":false,"./AspectRatioOutlined":false,"./AspectRatioRounded":false,"./AspectRatioSharp":false,"./AspectRatioTwoTone":false,"./Assessment":false,"./AssessmentOutlined":false,"./AssessmentRounded":false,"./AssessmentSharp":false,"./AssessmentTwoTone":false,"./Assignment":false,"./AssignmentInd":false,"./AssignmentIndOutlined":false,"./AssignmentIndRounded":false,"./AssignmentIndSharp":false,"./AssignmentIndTwoTone":false,"./AssignmentLate":false,"./AssignmentLateOutlined":false,"./AssignmentLateRounded":false,"./AssignmentLateSharp":false,"./AssignmentLateTwoTone":false,"./AssignmentOutlined":false,"./AssignmentReturn":false,"./AssignmentReturnOutlined":false,"./AssignmentReturnRounded":false,"./AssignmentReturnSharp":false,"./AssignmentReturnTwoTone":false,"./AssignmentReturned":false,"./AssignmentReturnedOutlined":false,"./AssignmentReturnedRounded":false,"./AssignmentReturnedSharp":false,"./AssignmentReturnedTwoTone":false,"./AssignmentRounded":false,"./AssignmentSharp":false,"./AssignmentTurnedIn":false,"./AssignmentTurnedInOutlined":false,"./AssignmentTurnedInRounded":false,"./AssignmentTurnedInSharp":false,"./AssignmentTurnedInTwoTone":false,"./AssignmentTwoTone":false,"./AssistWalker":false,"./AssistWalkerOutlined":false,"./AssistWalkerRounded":false,"./AssistWalkerSharp":false,"./AssistWalkerTwoTone":false,"./Assistant":false,"./AssistantDirection":false,"./AssistantDirectionOutlined":false,"./AssistantDirectionRounded":false,"./AssistantDirectionSharp":false,"./AssistantDirectionTwoTone":false,"./AssistantOutlined":false,"./AssistantPhoto":false,"./AssistantPhotoOutlined":false,"./AssistantPhotoRounded":false,"./AssistantPhotoSharp":false,"./AssistantPhotoTwoTone":false,"./AssistantRounded":false,"./AssistantSharp":false,"./AssistantTwoTone":false,"./AssuredWorkload":false,"./AssuredWorkloadOutlined":false,"./AssuredWorkloadRounded":false,"./AssuredWorkloadSharp":false,"./AssuredWorkloadTwoTone":false,"./Atm":false,"./AtmOutlined":false,"./AtmRounded":false,"./AtmSharp":false,"./AtmTwoTone":false,"./AttachEmail":false,"./AttachEmailOutlined":false,"./AttachEmailRounded":false,"./AttachEmailSharp":false,"./AttachEmailTwoTone":false,"./AttachFile":false,"./AttachFileOutlined":false,"./AttachFileRounded":false,"./AttachFileSharp":false,"./AttachFileTwoTone":false,"./AttachMoney":false,"./AttachMoneyOutlined":false,"./AttachMoneyRounded":false,"./AttachMoneySharp":false,"./AttachMoneyTwoTone":false,"./Attachment":false,"./AttachmentOutlined":false,"./AttachmentRounded":false,"./AttachmentSharp":false,"./AttachmentTwoTone":false,"./Attractions":false,"./AttractionsOutlined":false,"./AttractionsRounded":false,"./AttractionsSharp":false,"./AttractionsTwoTone":false,"./Attribution":false,"./AttributionOutlined":false,"./AttributionRounded":false,"./AttributionSharp":false,"./AttributionTwoTone":false,"./AudioFile":false,"./AudioFileOutlined":false,"./AudioFileRounded":false,"./AudioFileSharp":false,"./AudioFileTwoTone":false,"./Audiotrack":false,"./AudiotrackOutlined":false,"./AudiotrackRounded":false,"./AudiotrackSharp":false,"./AudiotrackTwoTone":false,"./AutoAwesome":false,"./AutoAwesomeMosaic":false,"./AutoAwesomeMosaicOutlined":false,"./AutoAwesomeMosaicRounded":false,"./AutoAwesomeMosaicSharp":false,"./AutoAwesomeMosaicTwoTone":false,"./AutoAwesomeMotion":false,"./AutoAwesomeMotionOutlined":false,"./AutoAwesomeMotionRounded":false,"./AutoAwesomeMotionSharp":false,"./AutoAwesomeMotionTwoTone":false,"./AutoAwesomeOutlined":false,"./AutoAwesomeRounded":false,"./AutoAwesomeSharp":false,"./AutoAwesomeTwoTone":false,"./AutoDelete":false,"./AutoDeleteOutlined":false,"./AutoDeleteRounded":false,"./AutoDeleteSharp":false,"./AutoDeleteTwoTone":false,"./AutoFixHigh":false,"./AutoFixHighOutlined":false,"./AutoFixHighRounded":false,"./AutoFixHighSharp":false,"./AutoFixHighTwoTone":false,"./AutoFixNormal":false,"./AutoFixNormalOutlined":false,"./AutoFixNormalRounded":false,"./AutoFixNormalSharp":false,"./AutoFixNormalTwoTone":false,"./AutoFixOff":false,"./AutoFixOffOutlined":false,"./AutoFixOffRounded":false,"./AutoFixOffSharp":false,"./AutoFixOffTwoTone":false,"./AutoGraph":false,"./AutoGraphOutlined":false,"./AutoGraphRounded":false,"./AutoGraphSharp":false,"./AutoGraphTwoTone":false,"./AutoMode":false,"./AutoModeOutlined":false,"./AutoModeRounded":false,"./AutoModeSharp":false,"./AutoModeTwoTone":false,"./AutoStories":false,"./AutoStoriesOutlined":false,"./AutoStoriesRounded":false,"./AutoStoriesSharp":false,"./AutoStoriesTwoTone":false,"./AutofpsSelect":false,"./AutofpsSelectOutlined":false,"./AutofpsSelectRounded":false,"./AutofpsSelectSharp":false,"./AutofpsSelectTwoTone":false,"./Autorenew":false,"./AutorenewOutlined":false,"./AutorenewRounded":false,"./AutorenewSharp":false,"./AutorenewTwoTone":false,"./AvTimer":false,"./AvTimerOutlined":false,"./AvTimerRounded":false,"./AvTimerSharp":false,"./AvTimerTwoTone":false,"./BabyChangingStation":false,"./BabyChangingStationOutlined":false,"./BabyChangingStationRounded":false,"./BabyChangingStationSharp":false,"./BabyChangingStationTwoTone":false,"./BackHand":false,"./BackHandOutlined":false,"./BackHandRounded":false,"./BackHandSharp":false,"./BackHandTwoTone":false,"./Backpack":false,"./BackpackOutlined":false,"./BackpackRounded":false,"./BackpackSharp":false,"./BackpackTwoTone":false,"./Backspace":false,"./BackspaceOutlined":false,"./BackspaceRounded":false,"./BackspaceSharp":false,"./BackspaceTwoTone":false,"./Backup":false,"./BackupOutlined":false,"./BackupRounded":false,"./BackupSharp":false,"./BackupTable":false,"./BackupTableOutlined":false,"./BackupTableRounded":false,"./BackupTableSharp":false,"./BackupTableTwoTone":false,"./BackupTwoTone":false,"./Badge":false,"./BadgeOutlined":false,"./BadgeRounded":false,"./BadgeSharp":false,"./BadgeTwoTone":false,"./BakeryDining":false,"./BakeryDiningOutlined":false,"./BakeryDiningRounded":false,"./BakeryDiningSharp":false,"./BakeryDiningTwoTone":false,"./Balance":false,"./BalanceOutlined":false,"./BalanceRounded":false,"./BalanceSharp":false,"./BalanceTwoTone":false,"./Balcony":false,"./BalconyOutlined":false,"./BalconyRounded":false,"./BalconySharp":false,"./BalconyTwoTone":false,"./Ballot":false,"./BallotOutlined":false,"./BallotRounded":false,"./BallotSharp":false,"./BallotTwoTone":false,"./BarChart":false,"./BarChartOutlined":false,"./BarChartRounded":false,"./BarChartSharp":false,"./BarChartTwoTone":false,"./BatchPrediction":false,"./BatchPredictionOutlined":false,"./BatchPredictionRounded":false,"./BatchPredictionSharp":false,"./BatchPredictionTwoTone":false,"./Bathroom":false,"./BathroomOutlined":false,"./BathroomRounded":false,"./BathroomSharp":false,"./BathroomTwoTone":false,"./Bathtub":false,"./BathtubOutlined":false,"./BathtubRounded":false,"./BathtubSharp":false,"./BathtubTwoTone":false,"./Battery0Bar":false,"./Battery0BarOutlined":false,"./Battery0BarRounded":false,"./Battery0BarSharp":false,"./Battery0BarTwoTone":false,"./Battery1Bar":false,"./Battery1BarOutlined":false,"./Battery1BarRounded":false,"./Battery1BarSharp":false,"./Battery1BarTwoTone":false,"./Battery20":false,"./Battery20Outlined":false,"./Battery20Rounded":false,"./Battery20Sharp":false,"./Battery20TwoTone":false,"./Battery2Bar":false,"./Battery2BarOutlined":false,"./Battery2BarRounded":false,"./Battery2BarSharp":false,"./Battery2BarTwoTone":false,"./Battery30":false,"./Battery30Outlined":false,"./Battery30Rounded":false,"./Battery30Sharp":false,"./Battery30TwoTone":false,"./Battery3Bar":false,"./Battery3BarOutlined":false,"./Battery3BarRounded":false,"./Battery3BarSharp":false,"./Battery3BarTwoTone":false,"./Battery4Bar":false,"./Battery4BarOutlined":false,"./Battery4BarRounded":false,"./Battery4BarSharp":false,"./Battery4BarTwoTone":false,"./Battery50":false,"./Battery50Outlined":false,"./Battery50Rounded":false,"./Battery50Sharp":false,"./Battery50TwoTone":false,"./Battery5Bar":false,"./Battery5BarOutlined":false,"./Battery5BarRounded":false,"./Battery5BarSharp":false,"./Battery5BarTwoTone":false,"./Battery60":false,"./Battery60Outlined":false,"./Battery60Rounded":false,"./Battery60Sharp":false,"./Battery60TwoTone":false,"./Battery6Bar":false,"./Battery6BarOutlined":false,"./Battery6BarRounded":false,"./Battery6BarSharp":false,"./Battery6BarTwoTone":false,"./Battery80":false,"./Battery80Outlined":false,"./Battery80Rounded":false,"./Battery80Sharp":false,"./Battery80TwoTone":false,"./Battery90":false,"./Battery90Outlined":false,"./Battery90Rounded":false,"./Battery90Sharp":false,"./Battery90TwoTone":false,"./BatteryAlert":false,"./BatteryAlertOutlined":false,"./BatteryAlertRounded":false,"./BatteryAlertSharp":false,"./BatteryAlertTwoTone":false,"./BatteryCharging20":false,"./BatteryCharging20Outlined":false,"./BatteryCharging20Rounded":false,"./BatteryCharging20Sharp":false,"./BatteryCharging20TwoTone":false,"./BatteryCharging30":false,"./BatteryCharging30Outlined":false,"./BatteryCharging30Rounded":false,"./BatteryCharging30Sharp":false,"./BatteryCharging30TwoTone":false,"./BatteryCharging50":false,"./BatteryCharging50Outlined":false,"./BatteryCharging50Rounded":false,"./BatteryCharging50Sharp":false,"./BatteryCharging50TwoTone":false,"./BatteryCharging60":false,"./BatteryCharging60Outlined":false,"./BatteryCharging60Rounded":false,"./BatteryCharging60Sharp":false,"./BatteryCharging60TwoTone":false,"./BatteryCharging80":false,"./BatteryCharging80Outlined":false,"./BatteryCharging80Rounded":false,"./BatteryCharging80Sharp":false,"./BatteryCharging80TwoTone":false,"./BatteryCharging90":false,"./BatteryCharging90Outlined":false,"./BatteryCharging90Rounded":false,"./BatteryCharging90Sharp":false,"./BatteryCharging90TwoTone":false,"./BatteryChargingFull":false,"./BatteryChargingFullOutlined":false,"./BatteryChargingFullRounded":false,"./BatteryChargingFullSharp":false,"./BatteryChargingFullTwoTone":false,"./BatteryFull":false,"./BatteryFullOutlined":false,"./BatteryFullRounded":false,"./BatteryFullSharp":false,"./BatteryFullTwoTone":false,"./BatterySaver":false,"./BatterySaverOutlined":false,"./BatterySaverRounded":false,"./BatterySaverSharp":false,"./BatterySaverTwoTone":false,"./BatteryStd":false,"./BatteryStdOutlined":false,"./BatteryStdRounded":false,"./BatteryStdSharp":false,"./BatteryStdTwoTone":false,"./BatteryUnknown":false,"./BatteryUnknownOutlined":false,"./BatteryUnknownRounded":false,"./BatteryUnknownSharp":false,"./BatteryUnknownTwoTone":false,"./BeachAccess":false,"./BeachAccessOutlined":false,"./BeachAccessRounded":false,"./BeachAccessSharp":false,"./BeachAccessTwoTone":false,"./Bed":false,"./BedOutlined":false,"./BedRounded":false,"./BedSharp":false,"./BedTwoTone":false,"./BedroomBaby":false,"./BedroomBabyOutlined":false,"./BedroomBabyRounded":false,"./BedroomBabySharp":false,"./BedroomBabyTwoTone":false,"./BedroomChild":false,"./BedroomChildOutlined":false,"./BedroomChildRounded":false,"./BedroomChildSharp":false,"./BedroomChildTwoTone":false,"./BedroomParent":false,"./BedroomParentOutlined":false,"./BedroomParentRounded":false,"./BedroomParentSharp":false,"./BedroomParentTwoTone":false,"./Bedtime":false,"./BedtimeOff":false,"./BedtimeOffOutlined":false,"./BedtimeOffRounded":false,"./BedtimeOffSharp":false,"./BedtimeOffTwoTone":false,"./BedtimeOutlined":false,"./BedtimeRounded":false,"./BedtimeSharp":false,"./BedtimeTwoTone":false,"./Beenhere":false,"./BeenhereOutlined":false,"./BeenhereRounded":false,"./BeenhereSharp":false,"./BeenhereTwoTone":false,"./Bento":false,"./BentoOutlined":false,"./BentoRounded":false,"./BentoSharp":false,"./BentoTwoTone":false,"./BikeScooter":false,"./BikeScooterOutlined":false,"./BikeScooterRounded":false,"./BikeScooterSharp":false,"./BikeScooterTwoTone":false,"./Biotech":false,"./BiotechOutlined":false,"./BiotechRounded":false,"./BiotechSharp":false,"./BiotechTwoTone":false,"./Blender":false,"./BlenderOutlined":false,"./BlenderRounded":false,"./BlenderSharp":false,"./BlenderTwoTone":false,"./Blind":false,"./BlindOutlined":false,"./BlindRounded":false,"./BlindSharp":false,"./BlindTwoTone":false,"./Blinds":false,"./BlindsClosed":false,"./BlindsClosedOutlined":false,"./BlindsClosedRounded":false,"./BlindsClosedSharp":false,"./BlindsClosedTwoTone":false,"./BlindsOutlined":false,"./BlindsRounded":false,"./BlindsSharp":false,"./BlindsTwoTone":false,"./Block":false,"./BlockOutlined":false,"./BlockRounded":false,"./BlockSharp":false,"./BlockTwoTone":false,"./Bloodtype":false,"./BloodtypeOutlined":false,"./BloodtypeRounded":false,"./BloodtypeSharp":false,"./BloodtypeTwoTone":false,"./Bluetooth":false,"./BluetoothAudio":false,"./BluetoothAudioOutlined":false,"./BluetoothAudioRounded":false,"./BluetoothAudioSharp":false,"./BluetoothAudioTwoTone":false,"./BluetoothConnected":false,"./BluetoothConnectedOutlined":false,"./BluetoothConnectedRounded":false,"./BluetoothConnectedSharp":false,"./BluetoothConnectedTwoTone":false,"./BluetoothDisabled":false,"./BluetoothDisabledOutlined":false,"./BluetoothDisabledRounded":false,"./BluetoothDisabledSharp":false,"./BluetoothDisabledTwoTone":false,"./BluetoothDrive":false,"./BluetoothDriveOutlined":false,"./BluetoothDriveRounded":false,"./BluetoothDriveSharp":false,"./BluetoothDriveTwoTone":false,"./BluetoothOutlined":false,"./BluetoothRounded":false,"./BluetoothSearching":false,"./BluetoothSearchingOutlined":false,"./BluetoothSearchingRounded":false,"./BluetoothSearchingSharp":false,"./BluetoothSearchingTwoTone":false,"./BluetoothSharp":false,"./BluetoothTwoTone":false,"./BlurCircular":false,"./BlurCircularOutlined":false,"./BlurCircularRounded":false,"./BlurCircularSharp":false,"./BlurCircularTwoTone":false,"./BlurLinear":false,"./BlurLinearOutlined":false,"./BlurLinearRounded":false,"./BlurLinearSharp":false,"./BlurLinearTwoTone":false,"./BlurOff":false,"./BlurOffOutlined":false,"./BlurOffRounded":false,"./BlurOffSharp":false,"./BlurOffTwoTone":false,"./BlurOn":false,"./BlurOnOutlined":false,"./BlurOnRounded":false,"./BlurOnSharp":false,"./BlurOnTwoTone":false,"./Bolt":false,"./BoltOutlined":false,"./BoltRounded":false,"./BoltSharp":false,"./BoltTwoTone":false,"./Book":false,"./BookOnline":false,"./BookOnlineOutlined":false,"./BookOnlineRounded":false,"./BookOnlineSharp":false,"./BookOnlineTwoTone":false,"./BookOutlined":false,"./BookRounded":false,"./BookSharp":false,"./BookTwoTone":false,"./Bookmark":false,"./BookmarkAdd":false,"./BookmarkAddOutlined":false,"./BookmarkAddRounded":false,"./BookmarkAddSharp":false,"./BookmarkAddTwoTone":false,"./BookmarkAdded":false,"./BookmarkAddedOutlined":false,"./BookmarkAddedRounded":false,"./BookmarkAddedSharp":false,"./BookmarkAddedTwoTone":false,"./BookmarkBorder":false,"./BookmarkBorderOutlined":false,"./BookmarkBorderRounded":false,"./BookmarkBorderSharp":false,"./BookmarkBorderTwoTone":false,"./BookmarkOutlined":false,"./BookmarkRemove":false,"./BookmarkRemoveOutlined":false,"./BookmarkRemoveRounded":false,"./BookmarkRemoveSharp":false,"./BookmarkRemoveTwoTone":false,"./BookmarkRounded":false,"./BookmarkSharp":false,"./BookmarkTwoTone":false,"./Bookmarks":false,"./BookmarksOutlined":false,"./BookmarksRounded":false,"./BookmarksSharp":false,"./BookmarksTwoTone":false,"./BorderAll":false,"./BorderAllOutlined":false,"./BorderAllRounded":false,"./BorderAllSharp":false,"./BorderAllTwoTone":false,"./BorderBottom":false,"./BorderBottomOutlined":false,"./BorderBottomRounded":false,"./BorderBottomSharp":false,"./BorderBottomTwoTone":false,"./BorderClear":false,"./BorderClearOutlined":false,"./BorderClearRounded":false,"./BorderClearSharp":false,"./BorderClearTwoTone":false,"./BorderColor":false,"./BorderColorOutlined":false,"./BorderColorRounded":false,"./BorderColorSharp":false,"./BorderColorTwoTone":false,"./BorderHorizontal":false,"./BorderHorizontalOutlined":false,"./BorderHorizontalRounded":false,"./BorderHorizontalSharp":false,"./BorderHorizontalTwoTone":false,"./BorderInner":false,"./BorderInnerOutlined":false,"./BorderInnerRounded":false,"./BorderInnerSharp":false,"./BorderInnerTwoTone":false,"./BorderLeft":false,"./BorderLeftOutlined":false,"./BorderLeftRounded":false,"./BorderLeftSharp":false,"./BorderLeftTwoTone":false,"./BorderOuter":false,"./BorderOuterOutlined":false,"./BorderOuterRounded":false,"./BorderOuterSharp":false,"./BorderOuterTwoTone":false,"./BorderRight":false,"./BorderRightOutlined":false,"./BorderRightRounded":false,"./BorderRightSharp":false,"./BorderRightTwoTone":false,"./BorderStyle":false,"./BorderStyleOutlined":false,"./BorderStyleRounded":false,"./BorderStyleSharp":false,"./BorderStyleTwoTone":false,"./BorderTop":false,"./BorderTopOutlined":false,"./BorderTopRounded":false,"./BorderTopSharp":false,"./BorderTopTwoTone":false,"./BorderVertical":false,"./BorderVerticalOutlined":false,"./BorderVerticalRounded":false,"./BorderVerticalSharp":false,"./BorderVerticalTwoTone":false,"./Boy":false,"./BoyOutlined":false,"./BoyRounded":false,"./BoySharp":false,"./BoyTwoTone":false,"./BrandingWatermark":false,"./BrandingWatermarkOutlined":false,"./BrandingWatermarkRounded":false,"./BrandingWatermarkSharp":false,"./BrandingWatermarkTwoTone":false,"./BreakfastDining":false,"./BreakfastDiningOutlined":false,"./BreakfastDiningRounded":false,"./BreakfastDiningSharp":false,"./BreakfastDiningTwoTone":false,"./Brightness1":false,"./Brightness1Outlined":false,"./Brightness1Rounded":false,"./Brightness1Sharp":false,"./Brightness1TwoTone":false,"./Brightness2":false,"./Brightness2Outlined":false,"./Brightness2Rounded":false,"./Brightness2Sharp":false,"./Brightness2TwoTone":false,"./Brightness3":false,"./Brightness3Outlined":false,"./Brightness3Rounded":false,"./Brightness3Sharp":false,"./Brightness3TwoTone":false,"./Brightness4":false,"./Brightness4Outlined":false,"./Brightness4Rounded":false,"./Brightness4Sharp":false,"./Brightness4TwoTone":false,"./Brightness5":false,"./Brightness5Outlined":false,"./Brightness5Rounded":false,"./Brightness5Sharp":false,"./Brightness5TwoTone":false,"./Brightness6":false,"./Brightness6Outlined":false,"./Brightness6Rounded":false,"./Brightness6Sharp":false,"./Brightness6TwoTone":false,"./Brightness7":false,"./Brightness7Outlined":false,"./Brightness7Rounded":false,"./Brightness7Sharp":false,"./Brightness7TwoTone":false,"./BrightnessAuto":false,"./BrightnessAutoOutlined":false,"./BrightnessAutoRounded":false,"./BrightnessAutoSharp":false,"./BrightnessAutoTwoTone":false,"./BrightnessHigh":false,"./BrightnessHighOutlined":false,"./BrightnessHighRounded":false,"./BrightnessHighSharp":false,"./BrightnessHighTwoTone":false,"./BrightnessLow":false,"./BrightnessLowOutlined":false,"./BrightnessLowRounded":false,"./BrightnessLowSharp":false,"./BrightnessLowTwoTone":false,"./BrightnessMedium":false,"./BrightnessMediumOutlined":false,"./BrightnessMediumRounded":false,"./BrightnessMediumSharp":false,"./BrightnessMediumTwoTone":false,"./BroadcastOnHome":false,"./BroadcastOnHomeOutlined":false,"./BroadcastOnHomeRounded":false,"./BroadcastOnHomeSharp":false,"./BroadcastOnHomeTwoTone":false,"./BroadcastOnPersonal":false,"./BroadcastOnPersonalOutlined":false,"./BroadcastOnPersonalRounded":false,"./BroadcastOnPersonalSharp":false,"./BroadcastOnPersonalTwoTone":false,"./BrokenImage":false,"./BrokenImageOutlined":false,"./BrokenImageRounded":false,"./BrokenImageSharp":false,"./BrokenImageTwoTone":false,"./BrowseGallery":false,"./BrowseGalleryOutlined":false,"./BrowseGalleryRounded":false,"./BrowseGallerySharp":false,"./BrowseGalleryTwoTone":false,"./BrowserNotSupported":false,"./BrowserNotSupportedOutlined":false,"./BrowserNotSupportedRounded":false,"./BrowserNotSupportedSharp":false,"./BrowserNotSupportedTwoTone":false,"./BrowserUpdated":false,"./BrowserUpdatedOutlined":false,"./BrowserUpdatedRounded":false,"./BrowserUpdatedSharp":false,"./BrowserUpdatedTwoTone":false,"./BrunchDining":false,"./BrunchDiningOutlined":false,"./BrunchDiningRounded":false,"./BrunchDiningSharp":false,"./BrunchDiningTwoTone":false,"./Brush":false,"./BrushOutlined":false,"./BrushRounded":false,"./BrushSharp":false,"./BrushTwoTone":false,"./BubbleChart":false,"./BubbleChartOutlined":false,"./BubbleChartRounded":false,"./BubbleChartSharp":false,"./BubbleChartTwoTone":false,"./BugReport":false,"./BugReportOutlined":false,"./BugReportRounded":false,"./BugReportSharp":false,"./BugReportTwoTone":false,"./Build":false,"./BuildCircle":false,"./BuildCircleOutlined":false,"./BuildCircleRounded":false,"./BuildCircleSharp":false,"./BuildCircleTwoTone":false,"./BuildOutlined":false,"./BuildRounded":false,"./BuildSharp":false,"./BuildTwoTone":false,"./Bungalow":false,"./BungalowOutlined":false,"./BungalowRounded":false,"./BungalowSharp":false,"./BungalowTwoTone":false,"./BurstMode":false,"./BurstModeOutlined":false,"./BurstModeRounded":false,"./BurstModeSharp":false,"./BurstModeTwoTone":false,"./BusAlert":false,"./BusAlertOutlined":false,"./BusAlertRounded":false,"./BusAlertSharp":false,"./BusAlertTwoTone":false,"./Business":"bjJxR","./BusinessCenter":false,"./BusinessCenterOutlined":false,"./BusinessCenterRounded":false,"./BusinessCenterSharp":false,"./BusinessCenterTwoTone":false,"./BusinessOutlined":false,"./BusinessRounded":false,"./BusinessSharp":false,"./BusinessTwoTone":false,"./Cabin":false,"./CabinOutlined":false,"./CabinRounded":false,"./CabinSharp":false,"./CabinTwoTone":false,"./Cable":false,"./CableOutlined":false,"./CableRounded":false,"./CableSharp":false,"./CableTwoTone":false,"./Cached":"cB1KF","./CachedOutlined":false,"./CachedRounded":false,"./CachedSharp":false,"./CachedTwoTone":false,"./Cake":false,"./CakeOutlined":false,"./CakeRounded":false,"./CakeSharp":false,"./CakeTwoTone":false,"./Calculate":false,"./CalculateOutlined":false,"./CalculateRounded":false,"./CalculateSharp":false,"./CalculateTwoTone":false,"./CalendarMonth":"1Obm4","./CalendarMonthOutlined":false,"./CalendarMonthRounded":false,"./CalendarMonthSharp":false,"./CalendarMonthTwoTone":false,"./CalendarToday":false,"./CalendarTodayOutlined":false,"./CalendarTodayRounded":false,"./CalendarTodaySharp":false,"./CalendarTodayTwoTone":false,"./CalendarViewDay":false,"./CalendarViewDayOutlined":false,"./CalendarViewDayRounded":false,"./CalendarViewDaySharp":false,"./CalendarViewDayTwoTone":false,"./CalendarViewMonth":false,"./CalendarViewMonthOutlined":false,"./CalendarViewMonthRounded":false,"./CalendarViewMonthSharp":false,"./CalendarViewMonthTwoTone":false,"./CalendarViewWeek":false,"./CalendarViewWeekOutlined":false,"./CalendarViewWeekRounded":false,"./CalendarViewWeekSharp":false,"./CalendarViewWeekTwoTone":false,"./Call":false,"./CallEnd":false,"./CallEndOutlined":false,"./CallEndRounded":false,"./CallEndSharp":false,"./CallEndTwoTone":false,"./CallMade":false,"./CallMadeOutlined":false,"./CallMadeRounded":false,"./CallMadeSharp":false,"./CallMadeTwoTone":false,"./CallMerge":false,"./CallMergeOutlined":false,"./CallMergeRounded":false,"./CallMergeSharp":false,"./CallMergeTwoTone":false,"./CallMissed":false,"./CallMissedOutgoing":false,"./CallMissedOutgoingOutlined":false,"./CallMissedOutgoingRounded":false,"./CallMissedOutgoingSharp":false,"./CallMissedOutgoingTwoTone":false,"./CallMissedOutlined":false,"./CallMissedRounded":false,"./CallMissedSharp":false,"./CallMissedTwoTone":false,"./CallOutlined":false,"./CallReceived":false,"./CallReceivedOutlined":false,"./CallReceivedRounded":false,"./CallReceivedSharp":false,"./CallReceivedTwoTone":false,"./CallRounded":false,"./CallSharp":false,"./CallSplit":false,"./CallSplitOutlined":false,"./CallSplitRounded":false,"./CallSplitSharp":false,"./CallSplitTwoTone":false,"./CallToAction":false,"./CallToActionOutlined":false,"./CallToActionRounded":false,"./CallToActionSharp":false,"./CallToActionTwoTone":false,"./CallTwoTone":false,"./Camera":false,"./CameraAlt":false,"./CameraAltOutlined":false,"./CameraAltRounded":false,"./CameraAltSharp":false,"./CameraAltTwoTone":false,"./CameraEnhance":false,"./CameraEnhanceOutlined":false,"./CameraEnhanceRounded":false,"./CameraEnhanceSharp":false,"./CameraEnhanceTwoTone":false,"./CameraFront":false,"./CameraFrontOutlined":false,"./CameraFrontRounded":false,"./CameraFrontSharp":false,"./CameraFrontTwoTone":false,"./CameraIndoor":false,"./CameraIndoorOutlined":false,"./CameraIndoorRounded":false,"./CameraIndoorSharp":false,"./CameraIndoorTwoTone":false,"./CameraOutdoor":false,"./CameraOutdoorOutlined":false,"./CameraOutdoorRounded":false,"./CameraOutdoorSharp":false,"./CameraOutdoorTwoTone":false,"./CameraOutlined":false,"./CameraRear":false,"./CameraRearOutlined":false,"./CameraRearRounded":false,"./CameraRearSharp":false,"./CameraRearTwoTone":false,"./CameraRoll":false,"./CameraRollOutlined":false,"./CameraRollRounded":false,"./CameraRollSharp":false,"./CameraRollTwoTone":false,"./CameraRounded":false,"./CameraSharp":false,"./CameraTwoTone":false,"./Cameraswitch":false,"./CameraswitchOutlined":false,"./CameraswitchRounded":false,"./CameraswitchSharp":false,"./CameraswitchTwoTone":false,"./Campaign":false,"./CampaignOutlined":false,"./CampaignRounded":false,"./CampaignSharp":false,"./CampaignTwoTone":false,"./Cancel":false,"./CancelOutlined":false,"./CancelPresentation":false,"./CancelPresentationOutlined":false,"./CancelPresentationRounded":false,"./CancelPresentationSharp":false,"./CancelPresentationTwoTone":false,"./CancelRounded":false,"./CancelScheduleSend":false,"./CancelScheduleSendOutlined":false,"./CancelScheduleSendRounded":false,"./CancelScheduleSendSharp":false,"./CancelScheduleSendTwoTone":false,"./CancelSharp":false,"./CancelTwoTone":false,"./CandlestickChart":false,"./CandlestickChartOutlined":false,"./CandlestickChartRounded":false,"./CandlestickChartSharp":false,"./CandlestickChartTwoTone":false,"./CarCrash":false,"./CarCrashOutlined":false,"./CarCrashRounded":false,"./CarCrashSharp":false,"./CarCrashTwoTone":false,"./CarRental":false,"./CarRentalOutlined":false,"./CarRentalRounded":false,"./CarRentalSharp":false,"./CarRentalTwoTone":false,"./CarRepair":false,"./CarRepairOutlined":false,"./CarRepairRounded":false,"./CarRepairSharp":false,"./CarRepairTwoTone":false,"./CardGiftcard":false,"./CardGiftcardOutlined":false,"./CardGiftcardRounded":false,"./CardGiftcardSharp":false,"./CardGiftcardTwoTone":false,"./CardMembership":false,"./CardMembershipOutlined":false,"./CardMembershipRounded":false,"./CardMembershipSharp":false,"./CardMembershipTwoTone":false,"./CardTravel":false,"./CardTravelOutlined":false,"./CardTravelRounded":false,"./CardTravelSharp":false,"./CardTravelTwoTone":false,"./Carpenter":false,"./CarpenterOutlined":false,"./CarpenterRounded":false,"./CarpenterSharp":false,"./CarpenterTwoTone":false,"./Cases":false,"./CasesOutlined":false,"./CasesRounded":false,"./CasesSharp":false,"./CasesTwoTone":false,"./Casino":false,"./CasinoOutlined":false,"./CasinoRounded":false,"./CasinoSharp":false,"./CasinoTwoTone":false,"./Cast":false,"./CastConnected":false,"./CastConnectedOutlined":false,"./CastConnectedRounded":false,"./CastConnectedSharp":false,"./CastConnectedTwoTone":false,"./CastForEducation":false,"./CastForEducationOutlined":false,"./CastForEducationRounded":false,"./CastForEducationSharp":false,"./CastForEducationTwoTone":false,"./CastOutlined":false,"./CastRounded":false,"./CastSharp":false,"./CastTwoTone":false,"./Castle":false,"./CastleOutlined":false,"./CastleRounded":false,"./CastleSharp":false,"./CastleTwoTone":false,"./CatchingPokemon":false,"./CatchingPokemonOutlined":false,"./CatchingPokemonRounded":false,"./CatchingPokemonSharp":false,"./CatchingPokemonTwoTone":false,"./Category":false,"./CategoryOutlined":false,"./CategoryRounded":false,"./CategorySharp":false,"./CategoryTwoTone":false,"./Celebration":"rx18K","./CelebrationOutlined":false,"./CelebrationRounded":false,"./CelebrationSharp":false,"./CelebrationTwoTone":false,"./CellTower":false,"./CellTowerOutlined":false,"./CellTowerRounded":false,"./CellTowerSharp":false,"./CellTowerTwoTone":false,"./CellWifi":false,"./CellWifiOutlined":false,"./CellWifiRounded":false,"./CellWifiSharp":false,"./CellWifiTwoTone":false,"./CenterFocusStrong":false,"./CenterFocusStrongOutlined":false,"./CenterFocusStrongRounded":false,"./CenterFocusStrongSharp":false,"./CenterFocusStrongTwoTone":false,"./CenterFocusWeak":false,"./CenterFocusWeakOutlined":false,"./CenterFocusWeakRounded":false,"./CenterFocusWeakSharp":false,"./CenterFocusWeakTwoTone":false,"./Chair":false,"./ChairAlt":false,"./ChairAltOutlined":false,"./ChairAltRounded":false,"./ChairAltSharp":false,"./ChairAltTwoTone":false,"./ChairOutlined":false,"./ChairRounded":false,"./ChairSharp":false,"./ChairTwoTone":false,"./Chalet":false,"./ChaletOutlined":false,"./ChaletRounded":false,"./ChaletSharp":false,"./ChaletTwoTone":false,"./ChangeCircle":false,"./ChangeCircleOutlined":false,"./ChangeCircleRounded":false,"./ChangeCircleSharp":false,"./ChangeCircleTwoTone":false,"./ChangeHistory":false,"./ChangeHistoryOutlined":false,"./ChangeHistoryRounded":false,"./ChangeHistorySharp":false,"./ChangeHistoryTwoTone":false,"./ChargingStation":false,"./ChargingStationOutlined":false,"./ChargingStationRounded":false,"./ChargingStationSharp":false,"./ChargingStationTwoTone":false,"./Chat":false,"./ChatBubble":false,"./ChatBubbleOutline":false,"./ChatBubbleOutlineOutlined":false,"./ChatBubbleOutlineRounded":false,"./ChatBubbleOutlineSharp":false,"./ChatBubbleOutlineTwoTone":false,"./ChatBubbleOutlined":false,"./ChatBubbleRounded":false,"./ChatBubbleSharp":false,"./ChatBubbleTwoTone":false,"./ChatOutlined":false,"./ChatRounded":false,"./ChatSharp":false,"./ChatTwoTone":false,"./Check":false,"./CheckBox":"fDmww","./CheckBoxOutlineBlank":false,"./CheckBoxOutlineBlankOutlined":"3lYD8","./CheckBoxOutlineBlankRounded":false,"./CheckBoxOutlineBlankSharp":false,"./CheckBoxOutlineBlankTwoTone":false,"./CheckBoxOutlined":false,"./CheckBoxRounded":false,"./CheckBoxSharp":false,"./CheckBoxTwoTone":false,"./CheckCircle":false,"./CheckCircleOutline":"1nmnS","./CheckCircleOutlineOutlined":false,"./CheckCircleOutlineRounded":false,"./CheckCircleOutlineSharp":false,"./CheckCircleOutlineTwoTone":false,"./CheckCircleOutlined":false,"./CheckCircleRounded":false,"./CheckCircleSharp":false,"./CheckCircleTwoTone":false,"./CheckOutlined":false,"./CheckRounded":false,"./CheckSharp":false,"./CheckTwoTone":false,"./Checklist":false,"./ChecklistOutlined":false,"./ChecklistRounded":false,"./ChecklistRtl":false,"./ChecklistRtlOutlined":false,"./ChecklistRtlRounded":false,"./ChecklistRtlSharp":false,"./ChecklistRtlTwoTone":false,"./ChecklistSharp":false,"./ChecklistTwoTone":false,"./Checkroom":false,"./CheckroomOutlined":false,"./CheckroomRounded":false,"./CheckroomSharp":false,"./CheckroomTwoTone":false,"./ChevronLeft":"3OkW5","./ChevronLeftOutlined":false,"./ChevronLeftRounded":false,"./ChevronLeftSharp":false,"./ChevronLeftTwoTone":false,"./ChevronRight":"cIcfY","./ChevronRightOutlined":false,"./ChevronRightRounded":false,"./ChevronRightSharp":false,"./ChevronRightTwoTone":false,"./ChildCare":false,"./ChildCareOutlined":false,"./ChildCareRounded":false,"./ChildCareSharp":false,"./ChildCareTwoTone":false,"./ChildFriendly":false,"./ChildFriendlyOutlined":false,"./ChildFriendlyRounded":false,"./ChildFriendlySharp":false,"./ChildFriendlyTwoTone":false,"./ChromeReaderMode":false,"./ChromeReaderModeOutlined":false,"./ChromeReaderModeRounded":false,"./ChromeReaderModeSharp":false,"./ChromeReaderModeTwoTone":false,"./Church":false,"./ChurchOutlined":false,"./ChurchRounded":false,"./ChurchSharp":false,"./ChurchTwoTone":false,"./Circle":false,"./CircleNotifications":false,"./CircleNotificationsOutlined":false,"./CircleNotificationsRounded":false,"./CircleNotificationsSharp":false,"./CircleNotificationsTwoTone":false,"./CircleOutlined":false,"./CircleRounded":false,"./CircleSharp":false,"./CircleTwoTone":false,"./Class":false,"./ClassOutlined":false,"./ClassRounded":false,"./ClassSharp":false,"./ClassTwoTone":false,"./CleanHands":false,"./CleanHandsOutlined":false,"./CleanHandsRounded":false,"./CleanHandsSharp":false,"./CleanHandsTwoTone":false,"./CleaningServices":false,"./CleaningServicesOutlined":false,"./CleaningServicesRounded":false,"./CleaningServicesSharp":false,"./CleaningServicesTwoTone":false,"./Clear":false,"./ClearAll":false,"./ClearAllOutlined":false,"./ClearAllRounded":false,"./ClearAllSharp":false,"./ClearAllTwoTone":false,"./ClearOutlined":false,"./ClearRounded":false,"./ClearSharp":false,"./ClearTwoTone":false,"./Close":false,"./CloseFullscreen":false,"./CloseFullscreenOutlined":false,"./CloseFullscreenRounded":false,"./CloseFullscreenSharp":false,"./CloseFullscreenTwoTone":false,"./CloseOutlined":false,"./CloseRounded":false,"./CloseSharp":false,"./CloseTwoTone":false,"./ClosedCaption":false,"./ClosedCaptionDisabled":false,"./ClosedCaptionDisabledOutlined":false,"./ClosedCaptionDisabledRounded":false,"./ClosedCaptionDisabledSharp":false,"./ClosedCaptionDisabledTwoTone":false,"./ClosedCaptionOff":false,"./ClosedCaptionOffOutlined":false,"./ClosedCaptionOffRounded":false,"./ClosedCaptionOffSharp":false,"./ClosedCaptionOffTwoTone":false,"./ClosedCaptionOutlined":false,"./ClosedCaptionRounded":false,"./ClosedCaptionSharp":false,"./ClosedCaptionTwoTone":false,"./Cloud":false,"./CloudCircle":false,"./CloudCircleOutlined":false,"./CloudCircleRounded":false,"./CloudCircleSharp":false,"./CloudCircleTwoTone":false,"./CloudDone":false,"./CloudDoneOutlined":"pcYnT","./CloudDoneRounded":false,"./CloudDoneSharp":false,"./CloudDoneTwoTone":false,"./CloudDownload":false,"./CloudDownloadOutlined":false,"./CloudDownloadRounded":false,"./CloudDownloadSharp":false,"./CloudDownloadTwoTone":false,"./CloudOff":false,"./CloudOffOutlined":"1mNMk","./CloudOffRounded":false,"./CloudOffSharp":false,"./CloudOffTwoTone":false,"./CloudOutlined":false,"./CloudQueue":false,"./CloudQueueOutlined":false,"./CloudQueueRounded":false,"./CloudQueueSharp":false,"./CloudQueueTwoTone":false,"./CloudRounded":false,"./CloudSharp":false,"./CloudSync":false,"./CloudSyncOutlined":false,"./CloudSyncRounded":false,"./CloudSyncSharp":false,"./CloudSyncTwoTone":false,"./CloudTwoTone":false,"./CloudUpload":false,"./CloudUploadOutlined":"czYlv","./CloudUploadRounded":false,"./CloudUploadSharp":false,"./CloudUploadTwoTone":false,"./Co2":false,"./Co2Outlined":false,"./Co2Rounded":false,"./Co2Sharp":false,"./Co2TwoTone":false,"./CoPresent":false,"./CoPresentOutlined":false,"./CoPresentRounded":false,"./CoPresentSharp":false,"./CoPresentTwoTone":false,"./Code":false,"./CodeOff":false,"./CodeOffOutlined":false,"./CodeOffRounded":false,"./CodeOffSharp":false,"./CodeOffTwoTone":false,"./CodeOutlined":false,"./CodeRounded":false,"./CodeSharp":false,"./CodeTwoTone":false,"./Coffee":false,"./CoffeeMaker":false,"./CoffeeMakerOutlined":false,"./CoffeeMakerRounded":false,"./CoffeeMakerSharp":false,"./CoffeeMakerTwoTone":false,"./CoffeeOutlined":false,"./CoffeeRounded":false,"./CoffeeSharp":false,"./CoffeeTwoTone":false,"./Collections":false,"./CollectionsBookmark":false,"./CollectionsBookmarkOutlined":false,"./CollectionsBookmarkRounded":false,"./CollectionsBookmarkSharp":false,"./CollectionsBookmarkTwoTone":false,"./CollectionsOutlined":false,"./CollectionsRounded":false,"./CollectionsSharp":false,"./CollectionsTwoTone":false,"./ColorLens":false,"./ColorLensOutlined":false,"./ColorLensRounded":false,"./ColorLensSharp":false,"./ColorLensTwoTone":false,"./Colorize":false,"./ColorizeOutlined":false,"./ColorizeRounded":false,"./ColorizeSharp":false,"./ColorizeTwoTone":false,"./Comment":false,"./CommentBank":false,"./CommentBankOutlined":false,"./CommentBankRounded":false,"./CommentBankSharp":false,"./CommentBankTwoTone":false,"./CommentOutlined":false,"./CommentRounded":false,"./CommentSharp":false,"./CommentTwoTone":false,"./CommentsDisabled":false,"./CommentsDisabledOutlined":false,"./CommentsDisabledRounded":false,"./CommentsDisabledSharp":false,"./CommentsDisabledTwoTone":false,"./Commit":false,"./CommitOutlined":false,"./CommitRounded":false,"./CommitSharp":false,"./CommitTwoTone":false,"./Commute":false,"./CommuteOutlined":false,"./CommuteRounded":false,"./CommuteSharp":false,"./CommuteTwoTone":false,"./Compare":false,"./CompareArrows":false,"./CompareArrowsOutlined":false,"./CompareArrowsRounded":false,"./CompareArrowsSharp":false,"./CompareArrowsTwoTone":false,"./CompareOutlined":false,"./CompareRounded":false,"./CompareSharp":false,"./CompareTwoTone":false,"./CompassCalibration":false,"./CompassCalibrationOutlined":false,"./CompassCalibrationRounded":false,"./CompassCalibrationSharp":false,"./CompassCalibrationTwoTone":false,"./Compress":false,"./CompressOutlined":false,"./CompressRounded":false,"./CompressSharp":false,"./CompressTwoTone":false,"./Computer":false,"./ComputerOutlined":false,"./ComputerRounded":false,"./ComputerSharp":false,"./ComputerTwoTone":false,"./ConfirmationNumber":false,"./ConfirmationNumberOutlined":false,"./ConfirmationNumberRounded":false,"./ConfirmationNumberSharp":false,"./ConfirmationNumberTwoTone":false,"./ConnectWithoutContact":false,"./ConnectWithoutContactOutlined":false,"./ConnectWithoutContactRounded":false,"./ConnectWithoutContactSharp":false,"./ConnectWithoutContactTwoTone":false,"./ConnectedTv":false,"./ConnectedTvOutlined":false,"./ConnectedTvRounded":false,"./ConnectedTvSharp":false,"./ConnectedTvTwoTone":false,"./ConnectingAirports":false,"./ConnectingAirportsOutlined":false,"./ConnectingAirportsRounded":false,"./ConnectingAirportsSharp":false,"./ConnectingAirportsTwoTone":false,"./Construction":false,"./ConstructionOutlined":false,"./ConstructionRounded":false,"./ConstructionSharp":false,"./ConstructionTwoTone":false,"./ContactEmergency":false,"./ContactEmergencyOutlined":false,"./ContactEmergencyRounded":false,"./ContactEmergencySharp":false,"./ContactEmergencyTwoTone":false,"./ContactMail":false,"./ContactMailOutlined":false,"./ContactMailRounded":false,"./ContactMailSharp":false,"./ContactMailTwoTone":false,"./ContactPage":false,"./ContactPageOutlined":false,"./ContactPageRounded":false,"./ContactPageSharp":false,"./ContactPageTwoTone":false,"./ContactPhone":false,"./ContactPhoneOutlined":false,"./ContactPhoneRounded":false,"./ContactPhoneSharp":false,"./ContactPhoneTwoTone":false,"./ContactSupport":false,"./ContactSupportOutlined":false,"./ContactSupportRounded":false,"./ContactSupportSharp":false,"./ContactSupportTwoTone":false,"./Contactless":false,"./ContactlessOutlined":false,"./ContactlessRounded":false,"./ContactlessSharp":false,"./ContactlessTwoTone":false,"./Contacts":false,"./ContactsOutlined":false,"./ContactsRounded":false,"./ContactsSharp":false,"./ContactsTwoTone":false,"./ContentCopy":false,"./ContentCopyOutlined":false,"./ContentCopyRounded":false,"./ContentCopySharp":false,"./ContentCopyTwoTone":false,"./ContentCut":false,"./ContentCutOutlined":false,"./ContentCutRounded":false,"./ContentCutSharp":false,"./ContentCutTwoTone":false,"./ContentPaste":false,"./ContentPasteGo":false,"./ContentPasteGoOutlined":false,"./ContentPasteGoRounded":false,"./ContentPasteGoSharp":false,"./ContentPasteGoTwoTone":false,"./ContentPasteOff":false,"./ContentPasteOffOutlined":false,"./ContentPasteOffRounded":false,"./ContentPasteOffSharp":false,"./ContentPasteOffTwoTone":false,"./ContentPasteOutlined":false,"./ContentPasteRounded":false,"./ContentPasteSearch":false,"./ContentPasteSearchOutlined":false,"./ContentPasteSearchRounded":false,"./ContentPasteSearchSharp":false,"./ContentPasteSearchTwoTone":false,"./ContentPasteSharp":false,"./ContentPasteTwoTone":false,"./Contrast":false,"./ContrastOutlined":false,"./ContrastRounded":false,"./ContrastSharp":false,"./ContrastTwoTone":false,"./ControlCamera":false,"./ControlCameraOutlined":false,"./ControlCameraRounded":false,"./ControlCameraSharp":false,"./ControlCameraTwoTone":false,"./ControlPoint":false,"./ControlPointDuplicate":false,"./ControlPointDuplicateOutlined":false,"./ControlPointDuplicateRounded":false,"./ControlPointDuplicateSharp":false,"./ControlPointDuplicateTwoTone":false,"./ControlPointOutlined":false,"./ControlPointRounded":false,"./ControlPointSharp":false,"./ControlPointTwoTone":false,"./Cookie":false,"./CookieOutlined":false,"./CookieRounded":false,"./CookieSharp":false,"./CookieTwoTone":false,"./CopyAll":false,"./CopyAllOutlined":false,"./CopyAllRounded":false,"./CopyAllSharp":false,"./CopyAllTwoTone":false,"./Copyright":false,"./CopyrightOutlined":false,"./CopyrightRounded":false,"./CopyrightSharp":false,"./CopyrightTwoTone":false,"./Coronavirus":false,"./CoronavirusOutlined":false,"./CoronavirusRounded":false,"./CoronavirusSharp":false,"./CoronavirusTwoTone":false,"./CorporateFare":false,"./CorporateFareOutlined":false,"./CorporateFareRounded":false,"./CorporateFareSharp":false,"./CorporateFareTwoTone":false,"./Cottage":false,"./CottageOutlined":false,"./CottageRounded":false,"./CottageSharp":false,"./CottageTwoTone":false,"./Countertops":false,"./CountertopsOutlined":false,"./CountertopsRounded":false,"./CountertopsSharp":false,"./CountertopsTwoTone":false,"./Create":false,"./CreateNewFolder":false,"./CreateNewFolderOutlined":false,"./CreateNewFolderRounded":false,"./CreateNewFolderSharp":false,"./CreateNewFolderTwoTone":false,"./CreateOutlined":false,"./CreateRounded":false,"./CreateSharp":false,"./CreateTwoTone":false,"./CreditCard":false,"./CreditCardOff":false,"./CreditCardOffOutlined":false,"./CreditCardOffRounded":false,"./CreditCardOffSharp":false,"./CreditCardOffTwoTone":false,"./CreditCardOutlined":false,"./CreditCardRounded":false,"./CreditCardSharp":false,"./CreditCardTwoTone":false,"./CreditScore":false,"./CreditScoreOutlined":false,"./CreditScoreRounded":false,"./CreditScoreSharp":false,"./CreditScoreTwoTone":false,"./Crib":false,"./CribOutlined":false,"./CribRounded":false,"./CribSharp":false,"./CribTwoTone":false,"./CrisisAlert":false,"./CrisisAlertOutlined":false,"./CrisisAlertRounded":false,"./CrisisAlertSharp":false,"./CrisisAlertTwoTone":false,"./Crop":false,"./Crop169":false,"./Crop169Outlined":false,"./Crop169Rounded":false,"./Crop169Sharp":false,"./Crop169TwoTone":false,"./Crop32":false,"./Crop32Outlined":false,"./Crop32Rounded":false,"./Crop32Sharp":false,"./Crop32TwoTone":false,"./Crop54":false,"./Crop54Outlined":false,"./Crop54Rounded":false,"./Crop54Sharp":false,"./Crop54TwoTone":false,"./Crop75":false,"./Crop75Outlined":false,"./Crop75Rounded":false,"./Crop75Sharp":false,"./Crop75TwoTone":false,"./CropDin":false,"./CropDinOutlined":false,"./CropDinRounded":false,"./CropDinSharp":false,"./CropDinTwoTone":false,"./CropFree":false,"./CropFreeOutlined":false,"./CropFreeRounded":false,"./CropFreeSharp":false,"./CropFreeTwoTone":false,"./CropLandscape":false,"./CropLandscapeOutlined":false,"./CropLandscapeRounded":false,"./CropLandscapeSharp":false,"./CropLandscapeTwoTone":false,"./CropOriginal":false,"./CropOriginalOutlined":false,"./CropOriginalRounded":false,"./CropOriginalSharp":false,"./CropOriginalTwoTone":false,"./CropOutlined":false,"./CropPortrait":false,"./CropPortraitOutlined":false,"./CropPortraitRounded":false,"./CropPortraitSharp":false,"./CropPortraitTwoTone":false,"./CropRotate":false,"./CropRotateOutlined":false,"./CropRotateRounded":false,"./CropRotateSharp":false,"./CropRotateTwoTone":false,"./CropRounded":false,"./CropSharp":false,"./CropSquare":false,"./CropSquareOutlined":false,"./CropSquareRounded":false,"./CropSquareSharp":false,"./CropSquareTwoTone":false,"./CropTwoTone":false,"./Css":false,"./CssOutlined":false,"./CssRounded":false,"./CssSharp":false,"./CssTwoTone":false,"./CurrencyBitcoin":false,"./CurrencyBitcoinOutlined":false,"./CurrencyBitcoinRounded":false,"./CurrencyBitcoinSharp":false,"./CurrencyBitcoinTwoTone":false,"./CurrencyExchange":false,"./CurrencyExchangeOutlined":false,"./CurrencyExchangeRounded":false,"./CurrencyExchangeSharp":false,"./CurrencyExchangeTwoTone":false,"./CurrencyFranc":false,"./CurrencyFrancOutlined":false,"./CurrencyFrancRounded":false,"./CurrencyFrancSharp":false,"./CurrencyFrancTwoTone":false,"./CurrencyLira":false,"./CurrencyLiraOutlined":false,"./CurrencyLiraRounded":false,"./CurrencyLiraSharp":false,"./CurrencyLiraTwoTone":false,"./CurrencyPound":false,"./CurrencyPoundOutlined":false,"./CurrencyPoundRounded":false,"./CurrencyPoundSharp":false,"./CurrencyPoundTwoTone":false,"./CurrencyRuble":false,"./CurrencyRubleOutlined":false,"./CurrencyRubleRounded":false,"./CurrencyRubleSharp":false,"./CurrencyRubleTwoTone":false,"./CurrencyRupee":false,"./CurrencyRupeeOutlined":false,"./CurrencyRupeeRounded":false,"./CurrencyRupeeSharp":false,"./CurrencyRupeeTwoTone":false,"./CurrencyYen":false,"./CurrencyYenOutlined":false,"./CurrencyYenRounded":false,"./CurrencyYenSharp":false,"./CurrencyYenTwoTone":false,"./CurrencyYuan":false,"./CurrencyYuanOutlined":false,"./CurrencyYuanRounded":false,"./CurrencyYuanSharp":false,"./CurrencyYuanTwoTone":false,"./Curtains":false,"./CurtainsClosed":false,"./CurtainsClosedOutlined":false,"./CurtainsClosedRounded":false,"./CurtainsClosedSharp":false,"./CurtainsClosedTwoTone":false,"./CurtainsOutlined":false,"./CurtainsRounded":false,"./CurtainsSharp":false,"./CurtainsTwoTone":false,"./Cyclone":false,"./CycloneOutlined":false,"./CycloneRounded":false,"./CycloneSharp":false,"./CycloneTwoTone":false,"./Dangerous":false,"./DangerousOutlined":false,"./DangerousRounded":false,"./DangerousSharp":false,"./DangerousTwoTone":false,"./DarkMode":false,"./DarkModeOutlined":false,"./DarkModeRounded":false,"./DarkModeSharp":false,"./DarkModeTwoTone":false,"./Dashboard":"fQiGE","./DashboardCustomize":false,"./DashboardCustomizeOutlined":false,"./DashboardCustomizeRounded":false,"./DashboardCustomizeSharp":false,"./DashboardCustomizeTwoTone":false,"./DashboardOutlined":false,"./DashboardRounded":false,"./DashboardSharp":false,"./DashboardTwoTone":false,"./DataArray":false,"./DataArrayOutlined":false,"./DataArrayRounded":false,"./DataArraySharp":false,"./DataArrayTwoTone":false,"./DataObject":false,"./DataObjectOutlined":false,"./DataObjectRounded":false,"./DataObjectSharp":false,"./DataObjectTwoTone":false,"./DataSaverOff":false,"./DataSaverOffOutlined":false,"./DataSaverOffRounded":false,"./DataSaverOffSharp":false,"./DataSaverOffTwoTone":false,"./DataSaverOn":false,"./DataSaverOnOutlined":false,"./DataSaverOnRounded":false,"./DataSaverOnSharp":false,"./DataSaverOnTwoTone":false,"./DataThresholding":false,"./DataThresholdingOutlined":false,"./DataThresholdingRounded":false,"./DataThresholdingSharp":false,"./DataThresholdingTwoTone":false,"./DataUsage":false,"./DataUsageOutlined":false,"./DataUsageRounded":false,"./DataUsageSharp":false,"./DataUsageTwoTone":false,"./Dataset":false,"./DatasetLinked":false,"./DatasetLinkedOutlined":false,"./DatasetLinkedRounded":false,"./DatasetLinkedSharp":false,"./DatasetLinkedTwoTone":false,"./DatasetOutlined":false,"./DatasetRounded":false,"./DatasetSharp":false,"./DatasetTwoTone":false,"./DateRange":false,"./DateRangeOutlined":false,"./DateRangeRounded":false,"./DateRangeSharp":false,"./DateRangeTwoTone":false,"./Deblur":false,"./DeblurOutlined":false,"./DeblurRounded":false,"./DeblurSharp":false,"./DeblurTwoTone":false,"./Deck":false,"./DeckOutlined":false,"./DeckRounded":false,"./DeckSharp":false,"./DeckTwoTone":false,"./Dehaze":false,"./DehazeOutlined":false,"./DehazeRounded":false,"./DehazeSharp":false,"./DehazeTwoTone":false,"./Delete":"iPOcA","./DeleteForever":false,"./DeleteForeverOutlined":false,"./DeleteForeverRounded":false,"./DeleteForeverSharp":false,"./DeleteForeverTwoTone":false,"./DeleteOutline":false,"./DeleteOutlineOutlined":false,"./DeleteOutlineRounded":false,"./DeleteOutlineSharp":false,"./DeleteOutlineTwoTone":false,"./DeleteOutlined":false,"./DeleteRounded":false,"./DeleteSharp":false,"./DeleteSweep":false,"./DeleteSweepOutlined":false,"./DeleteSweepRounded":false,"./DeleteSweepSharp":false,"./DeleteSweepTwoTone":false,"./DeleteTwoTone":false,"./DeliveryDining":false,"./DeliveryDiningOutlined":false,"./DeliveryDiningRounded":false,"./DeliveryDiningSharp":false,"./DeliveryDiningTwoTone":false,"./DensityLarge":false,"./DensityLargeOutlined":false,"./DensityLargeRounded":false,"./DensityLargeSharp":false,"./DensityLargeTwoTone":false,"./DensityMedium":false,"./DensityMediumOutlined":false,"./DensityMediumRounded":false,"./DensityMediumSharp":false,"./DensityMediumTwoTone":false,"./DensitySmall":false,"./DensitySmallOutlined":false,"./DensitySmallRounded":false,"./DensitySmallSharp":false,"./DensitySmallTwoTone":false,"./DepartureBoard":false,"./DepartureBoardOutlined":false,"./DepartureBoardRounded":false,"./DepartureBoardSharp":false,"./DepartureBoardTwoTone":false,"./Description":false,"./DescriptionOutlined":false,"./DescriptionRounded":false,"./DescriptionSharp":false,"./DescriptionTwoTone":false,"./Deselect":false,"./DeselectOutlined":false,"./DeselectRounded":false,"./DeselectSharp":false,"./DeselectTwoTone":false,"./DesignServices":false,"./DesignServicesOutlined":false,"./DesignServicesRounded":false,"./DesignServicesSharp":false,"./DesignServicesTwoTone":false,"./Desk":false,"./DeskOutlined":false,"./DeskRounded":false,"./DeskSharp":false,"./DeskTwoTone":false,"./DesktopAccessDisabled":false,"./DesktopAccessDisabledOutlined":false,"./DesktopAccessDisabledRounded":false,"./DesktopAccessDisabledSharp":false,"./DesktopAccessDisabledTwoTone":false,"./DesktopMac":false,"./DesktopMacOutlined":false,"./DesktopMacRounded":false,"./DesktopMacSharp":false,"./DesktopMacTwoTone":false,"./DesktopWindows":false,"./DesktopWindowsOutlined":false,"./DesktopWindowsRounded":false,"./DesktopWindowsSharp":false,"./DesktopWindowsTwoTone":false,"./Details":false,"./DetailsOutlined":false,"./DetailsRounded":false,"./DetailsSharp":false,"./DetailsTwoTone":false,"./DeveloperBoard":false,"./DeveloperBoardOff":false,"./DeveloperBoardOffOutlined":false,"./DeveloperBoardOffRounded":false,"./DeveloperBoardOffSharp":false,"./DeveloperBoardOffTwoTone":false,"./DeveloperBoardOutlined":false,"./DeveloperBoardRounded":false,"./DeveloperBoardSharp":false,"./DeveloperBoardTwoTone":false,"./DeveloperMode":false,"./DeveloperModeOutlined":false,"./DeveloperModeRounded":false,"./DeveloperModeSharp":false,"./DeveloperModeTwoTone":false,"./DeviceHub":false,"./DeviceHubOutlined":false,"./DeviceHubRounded":false,"./DeviceHubSharp":false,"./DeviceHubTwoTone":false,"./DeviceThermostat":false,"./DeviceThermostatOutlined":false,"./DeviceThermostatRounded":false,"./DeviceThermostatSharp":false,"./DeviceThermostatTwoTone":false,"./DeviceUnknown":false,"./DeviceUnknownOutlined":false,"./DeviceUnknownRounded":false,"./DeviceUnknownSharp":false,"./DeviceUnknownTwoTone":false,"./Devices":false,"./DevicesFold":false,"./DevicesFoldOutlined":false,"./DevicesFoldRounded":false,"./DevicesFoldSharp":false,"./DevicesFoldTwoTone":false,"./DevicesOther":false,"./DevicesOtherOutlined":false,"./DevicesOtherRounded":false,"./DevicesOtherSharp":false,"./DevicesOtherTwoTone":false,"./DevicesOutlined":false,"./DevicesRounded":false,"./DevicesSharp":false,"./DevicesTwoTone":false,"./DialerSip":false,"./DialerSipOutlined":false,"./DialerSipRounded":false,"./DialerSipSharp":false,"./DialerSipTwoTone":false,"./Dialpad":false,"./DialpadOutlined":false,"./DialpadRounded":false,"./DialpadSharp":false,"./DialpadTwoTone":false,"./Diamond":false,"./DiamondOutlined":false,"./DiamondRounded":false,"./DiamondSharp":false,"./DiamondTwoTone":false,"./Difference":false,"./DifferenceOutlined":false,"./DifferenceRounded":false,"./DifferenceSharp":false,"./DifferenceTwoTone":false,"./Dining":false,"./DiningOutlined":false,"./DiningRounded":false,"./DiningSharp":false,"./DiningTwoTone":false,"./DinnerDining":false,"./DinnerDiningOutlined":false,"./DinnerDiningRounded":false,"./DinnerDiningSharp":false,"./DinnerDiningTwoTone":false,"./Directions":false,"./DirectionsBike":false,"./DirectionsBikeOutlined":false,"./DirectionsBikeRounded":false,"./DirectionsBikeSharp":false,"./DirectionsBikeTwoTone":false,"./DirectionsBoat":false,"./DirectionsBoatFilled":false,"./DirectionsBoatFilledOutlined":false,"./DirectionsBoatFilledRounded":false,"./DirectionsBoatFilledSharp":false,"./DirectionsBoatFilledTwoTone":false,"./DirectionsBoatOutlined":false,"./DirectionsBoatRounded":false,"./DirectionsBoatSharp":false,"./DirectionsBoatTwoTone":false,"./DirectionsBus":false,"./DirectionsBusFilled":false,"./DirectionsBusFilledOutlined":false,"./DirectionsBusFilledRounded":false,"./DirectionsBusFilledSharp":false,"./DirectionsBusFilledTwoTone":false,"./DirectionsBusOutlined":false,"./DirectionsBusRounded":false,"./DirectionsBusSharp":false,"./DirectionsBusTwoTone":false,"./DirectionsCar":false,"./DirectionsCarFilled":false,"./DirectionsCarFilledOutlined":false,"./DirectionsCarFilledRounded":false,"./DirectionsCarFilledSharp":false,"./DirectionsCarFilledTwoTone":false,"./DirectionsCarOutlined":false,"./DirectionsCarRounded":false,"./DirectionsCarSharp":false,"./DirectionsCarTwoTone":false,"./DirectionsOff":false,"./DirectionsOffOutlined":false,"./DirectionsOffRounded":false,"./DirectionsOffSharp":false,"./DirectionsOffTwoTone":false,"./DirectionsOutlined":false,"./DirectionsRailway":false,"./DirectionsRailwayFilled":false,"./DirectionsRailwayFilledOutlined":false,"./DirectionsRailwayFilledRounded":false,"./DirectionsRailwayFilledSharp":false,"./DirectionsRailwayFilledTwoTone":false,"./DirectionsRailwayOutlined":false,"./DirectionsRailwayRounded":false,"./DirectionsRailwaySharp":false,"./DirectionsRailwayTwoTone":false,"./DirectionsRounded":false,"./DirectionsRun":false,"./DirectionsRunOutlined":false,"./DirectionsRunRounded":false,"./DirectionsRunSharp":false,"./DirectionsRunTwoTone":false,"./DirectionsSharp":false,"./DirectionsSubway":false,"./DirectionsSubwayFilled":false,"./DirectionsSubwayFilledOutlined":false,"./DirectionsSubwayFilledRounded":false,"./DirectionsSubwayFilledSharp":false,"./DirectionsSubwayFilledTwoTone":false,"./DirectionsSubwayOutlined":false,"./DirectionsSubwayRounded":false,"./DirectionsSubwaySharp":false,"./DirectionsSubwayTwoTone":false,"./DirectionsTransit":false,"./DirectionsTransitFilled":false,"./DirectionsTransitFilledOutlined":false,"./DirectionsTransitFilledRounded":false,"./DirectionsTransitFilledSharp":false,"./DirectionsTransitFilledTwoTone":false,"./DirectionsTransitOutlined":false,"./DirectionsTransitRounded":false,"./DirectionsTransitSharp":false,"./DirectionsTransitTwoTone":false,"./DirectionsTwoTone":false,"./DirectionsWalk":false,"./DirectionsWalkOutlined":false,"./DirectionsWalkRounded":false,"./DirectionsWalkSharp":false,"./DirectionsWalkTwoTone":false,"./DirtyLens":false,"./DirtyLensOutlined":false,"./DirtyLensRounded":false,"./DirtyLensSharp":false,"./DirtyLensTwoTone":false,"./DisabledByDefault":false,"./DisabledByDefaultOutlined":false,"./DisabledByDefaultRounded":false,"./DisabledByDefaultSharp":false,"./DisabledByDefaultTwoTone":false,"./DiscFull":false,"./DiscFullOutlined":false,"./DiscFullRounded":false,"./DiscFullSharp":false,"./DiscFullTwoTone":false,"./Discount":false,"./DiscountOutlined":false,"./DiscountRounded":false,"./DiscountSharp":false,"./DiscountTwoTone":false,"./DisplaySettings":false,"./DisplaySettingsOutlined":false,"./DisplaySettingsRounded":false,"./DisplaySettingsSharp":false,"./DisplaySettingsTwoTone":false,"./Diversity1":false,"./Diversity1Outlined":false,"./Diversity1Rounded":false,"./Diversity1Sharp":false,"./Diversity1TwoTone":false,"./Diversity2":false,"./Diversity2Outlined":false,"./Diversity2Rounded":false,"./Diversity2Sharp":false,"./Diversity2TwoTone":false,"./Diversity3":false,"./Diversity3Outlined":false,"./Diversity3Rounded":false,"./Diversity3Sharp":false,"./Diversity3TwoTone":false,"./Dns":false,"./DnsOutlined":false,"./DnsRounded":false,"./DnsSharp":false,"./DnsTwoTone":false,"./DoDisturb":false,"./DoDisturbAlt":false,"./DoDisturbAltOutlined":false,"./DoDisturbAltRounded":false,"./DoDisturbAltSharp":false,"./DoDisturbAltTwoTone":false,"./DoDisturbOff":false,"./DoDisturbOffOutlined":false,"./DoDisturbOffRounded":false,"./DoDisturbOffSharp":false,"./DoDisturbOffTwoTone":false,"./DoDisturbOn":false,"./DoDisturbOnOutlined":false,"./DoDisturbOnRounded":false,"./DoDisturbOnSharp":false,"./DoDisturbOnTwoTone":false,"./DoDisturbOutlined":false,"./DoDisturbRounded":false,"./DoDisturbSharp":false,"./DoDisturbTwoTone":false,"./DoNotDisturb":false,"./DoNotDisturbAlt":false,"./DoNotDisturbAltOutlined":false,"./DoNotDisturbAltRounded":false,"./DoNotDisturbAltSharp":false,"./DoNotDisturbAltTwoTone":false,"./DoNotDisturbOff":false,"./DoNotDisturbOffOutlined":false,"./DoNotDisturbOffRounded":false,"./DoNotDisturbOffSharp":false,"./DoNotDisturbOffTwoTone":false,"./DoNotDisturbOn":false,"./DoNotDisturbOnOutlined":false,"./DoNotDisturbOnRounded":false,"./DoNotDisturbOnSharp":false,"./DoNotDisturbOnTotalSilence":false,"./DoNotDisturbOnTotalSilenceOutlined":false,"./DoNotDisturbOnTotalSilenceRounded":false,"./DoNotDisturbOnTotalSilenceSharp":false,"./DoNotDisturbOnTotalSilenceTwoTone":false,"./DoNotDisturbOnTwoTone":false,"./DoNotDisturbOutlined":false,"./DoNotDisturbRounded":false,"./DoNotDisturbSharp":false,"./DoNotDisturbTwoTone":false,"./DoNotStep":false,"./DoNotStepOutlined":false,"./DoNotStepRounded":false,"./DoNotStepSharp":false,"./DoNotStepTwoTone":false,"./DoNotTouch":false,"./DoNotTouchOutlined":false,"./DoNotTouchRounded":false,"./DoNotTouchSharp":false,"./DoNotTouchTwoTone":false,"./Dock":false,"./DockOutlined":false,"./DockRounded":false,"./DockSharp":false,"./DockTwoTone":false,"./DocumentScanner":false,"./DocumentScannerOutlined":false,"./DocumentScannerRounded":false,"./DocumentScannerSharp":false,"./DocumentScannerTwoTone":false,"./Domain":false,"./DomainAdd":false,"./DomainAddOutlined":false,"./DomainAddRounded":false,"./DomainAddSharp":false,"./DomainAddTwoTone":false,"./DomainDisabled":false,"./DomainDisabledOutlined":false,"./DomainDisabledRounded":false,"./DomainDisabledSharp":false,"./DomainDisabledTwoTone":false,"./DomainOutlined":false,"./DomainRounded":false,"./DomainSharp":false,"./DomainTwoTone":false,"./DomainVerification":false,"./DomainVerificationOutlined":false,"./DomainVerificationRounded":false,"./DomainVerificationSharp":false,"./DomainVerificationTwoTone":false,"./Done":false,"./DoneAll":false,"./DoneAllOutlined":false,"./DoneAllRounded":false,"./DoneAllSharp":false,"./DoneAllTwoTone":false,"./DoneOutline":false,"./DoneOutlineOutlined":false,"./DoneOutlineRounded":false,"./DoneOutlineSharp":false,"./DoneOutlineTwoTone":false,"./DoneOutlined":false,"./DoneRounded":false,"./DoneSharp":false,"./DoneTwoTone":false,"./DonutLarge":false,"./DonutLargeOutlined":false,"./DonutLargeRounded":false,"./DonutLargeSharp":false,"./DonutLargeTwoTone":false,"./DonutSmall":false,"./DonutSmallOutlined":false,"./DonutSmallRounded":false,"./DonutSmallSharp":false,"./DonutSmallTwoTone":false,"./DoorBack":false,"./DoorBackOutlined":false,"./DoorBackRounded":false,"./DoorBackSharp":false,"./DoorBackTwoTone":false,"./DoorFront":false,"./DoorFrontOutlined":false,"./DoorFrontRounded":false,"./DoorFrontSharp":false,"./DoorFrontTwoTone":false,"./DoorSliding":false,"./DoorSlidingOutlined":false,"./DoorSlidingRounded":false,"./DoorSlidingSharp":false,"./DoorSlidingTwoTone":false,"./Doorbell":false,"./DoorbellOutlined":false,"./DoorbellRounded":false,"./DoorbellSharp":false,"./DoorbellTwoTone":false,"./DoubleArrow":false,"./DoubleArrowOutlined":false,"./DoubleArrowRounded":false,"./DoubleArrowSharp":false,"./DoubleArrowTwoTone":false,"./DownhillSkiing":false,"./DownhillSkiingOutlined":false,"./DownhillSkiingRounded":false,"./DownhillSkiingSharp":false,"./DownhillSkiingTwoTone":false,"./Download":false,"./DownloadDone":false,"./DownloadDoneOutlined":false,"./DownloadDoneRounded":false,"./DownloadDoneSharp":false,"./DownloadDoneTwoTone":false,"./DownloadForOffline":false,"./DownloadForOfflineOutlined":false,"./DownloadForOfflineRounded":false,"./DownloadForOfflineSharp":false,"./DownloadForOfflineTwoTone":false,"./DownloadOutlined":false,"./DownloadRounded":false,"./DownloadSharp":false,"./DownloadTwoTone":false,"./Downloading":false,"./DownloadingOutlined":false,"./DownloadingRounded":false,"./DownloadingSharp":false,"./DownloadingTwoTone":false,"./Drafts":false,"./DraftsOutlined":false,"./DraftsRounded":false,"./DraftsSharp":false,"./DraftsTwoTone":false,"./DragHandle":false,"./DragHandleOutlined":false,"./DragHandleRounded":false,"./DragHandleSharp":false,"./DragHandleTwoTone":false,"./DragIndicator":false,"./DragIndicatorOutlined":false,"./DragIndicatorRounded":false,"./DragIndicatorSharp":false,"./DragIndicatorTwoTone":false,"./Draw":false,"./DrawOutlined":false,"./DrawRounded":false,"./DrawSharp":false,"./DrawTwoTone":false,"./DriveEta":false,"./DriveEtaOutlined":false,"./DriveEtaRounded":false,"./DriveEtaSharp":false,"./DriveEtaTwoTone":false,"./DriveFileMove":false,"./DriveFileMoveOutlined":false,"./DriveFileMoveRounded":false,"./DriveFileMoveSharp":false,"./DriveFileMoveTwoTone":false,"./DriveFileRenameOutline":false,"./DriveFileRenameOutlineOutlined":false,"./DriveFileRenameOutlineRounded":false,"./DriveFileRenameOutlineSharp":false,"./DriveFileRenameOutlineTwoTone":false,"./DriveFolderUpload":false,"./DriveFolderUploadOutlined":false,"./DriveFolderUploadRounded":false,"./DriveFolderUploadSharp":false,"./DriveFolderUploadTwoTone":false,"./Dry":false,"./DryCleaning":false,"./DryCleaningOutlined":false,"./DryCleaningRounded":false,"./DryCleaningSharp":false,"./DryCleaningTwoTone":false,"./DryOutlined":false,"./DryRounded":false,"./DrySharp":false,"./DryTwoTone":false,"./Duo":false,"./DuoOutlined":false,"./DuoRounded":false,"./DuoSharp":false,"./DuoTwoTone":false,"./Dvr":false,"./DvrOutlined":false,"./DvrRounded":false,"./DvrSharp":false,"./DvrTwoTone":false,"./DynamicFeed":false,"./DynamicFeedOutlined":false,"./DynamicFeedRounded":false,"./DynamicFeedSharp":false,"./DynamicFeedTwoTone":false,"./DynamicForm":false,"./DynamicFormOutlined":false,"./DynamicFormRounded":false,"./DynamicFormSharp":false,"./DynamicFormTwoTone":false,"./EMobiledata":false,"./EMobiledataOutlined":false,"./EMobiledataRounded":false,"./EMobiledataSharp":false,"./EMobiledataTwoTone":false,"./Earbuds":false,"./EarbudsBattery":false,"./EarbudsBatteryOutlined":false,"./EarbudsBatteryRounded":false,"./EarbudsBatterySharp":false,"./EarbudsBatteryTwoTone":false,"./EarbudsOutlined":false,"./EarbudsRounded":false,"./EarbudsSharp":false,"./EarbudsTwoTone":false,"./East":false,"./EastOutlined":false,"./EastRounded":false,"./EastSharp":false,"./EastTwoTone":false,"./EdgesensorHigh":false,"./EdgesensorHighOutlined":false,"./EdgesensorHighRounded":false,"./EdgesensorHighSharp":false,"./EdgesensorHighTwoTone":false,"./EdgesensorLow":false,"./EdgesensorLowOutlined":false,"./EdgesensorLowRounded":false,"./EdgesensorLowSharp":false,"./EdgesensorLowTwoTone":false,"./Edit":"10UuU","./EditAttributes":false,"./EditAttributesOutlined":false,"./EditAttributesRounded":false,"./EditAttributesSharp":false,"./EditAttributesTwoTone":false,"./EditCalendar":false,"./EditCalendarOutlined":false,"./EditCalendarRounded":false,"./EditCalendarSharp":false,"./EditCalendarTwoTone":false,"./EditLocation":false,"./EditLocationAlt":false,"./EditLocationAltOutlined":false,"./EditLocationAltRounded":false,"./EditLocationAltSharp":false,"./EditLocationAltTwoTone":false,"./EditLocationOutlined":false,"./EditLocationRounded":false,"./EditLocationSharp":false,"./EditLocationTwoTone":false,"./EditNote":false,"./EditNoteOutlined":false,"./EditNoteRounded":false,"./EditNoteSharp":false,"./EditNoteTwoTone":false,"./EditNotifications":false,"./EditNotificationsOutlined":false,"./EditNotificationsRounded":false,"./EditNotificationsSharp":false,"./EditNotificationsTwoTone":false,"./EditOff":false,"./EditOffOutlined":false,"./EditOffRounded":false,"./EditOffSharp":false,"./EditOffTwoTone":false,"./EditOutlined":false,"./EditRoad":false,"./EditRoadOutlined":false,"./EditRoadRounded":false,"./EditRoadSharp":false,"./EditRoadTwoTone":false,"./EditRounded":false,"./EditSharp":false,"./EditTwoTone":false,"./Egg":false,"./EggAlt":false,"./EggAltOutlined":false,"./EggAltRounded":false,"./EggAltSharp":false,"./EggAltTwoTone":false,"./EggOutlined":false,"./EggRounded":false,"./EggSharp":false,"./EggTwoTone":false,"./EightK":false,"./EightKOutlined":false,"./EightKPlus":false,"./EightKPlusOutlined":false,"./EightKPlusRounded":false,"./EightKPlusSharp":false,"./EightKPlusTwoTone":false,"./EightKRounded":false,"./EightKSharp":false,"./EightKTwoTone":false,"./EightMp":false,"./EightMpOutlined":false,"./EightMpRounded":false,"./EightMpSharp":false,"./EightMpTwoTone":false,"./EighteenMp":false,"./EighteenMpOutlined":false,"./EighteenMpRounded":false,"./EighteenMpSharp":false,"./EighteenMpTwoTone":false,"./EighteenUpRating":false,"./EighteenUpRatingOutlined":false,"./EighteenUpRatingRounded":false,"./EighteenUpRatingSharp":false,"./EighteenUpRatingTwoTone":false,"./EightteenMp":false,"./EightteenMpOutlined":false,"./EightteenMpRounded":false,"./EightteenMpSharp":false,"./EightteenMpTwoTone":false,"./Eject":false,"./EjectOutlined":false,"./EjectRounded":false,"./EjectSharp":false,"./EjectTwoTone":false,"./Elderly":false,"./ElderlyOutlined":false,"./ElderlyRounded":false,"./ElderlySharp":false,"./ElderlyTwoTone":false,"./ElderlyWoman":false,"./ElderlyWomanOutlined":false,"./ElderlyWomanRounded":false,"./ElderlyWomanSharp":false,"./ElderlyWomanTwoTone":false,"./ElectricBike":false,"./ElectricBikeOutlined":false,"./ElectricBikeRounded":false,"./ElectricBikeSharp":false,"./ElectricBikeTwoTone":false,"./ElectricBolt":false,"./ElectricBoltOutlined":false,"./ElectricBoltRounded":false,"./ElectricBoltSharp":false,"./ElectricBoltTwoTone":false,"./ElectricCar":false,"./ElectricCarOutlined":false,"./ElectricCarRounded":false,"./ElectricCarSharp":false,"./ElectricCarTwoTone":false,"./ElectricMeter":false,"./ElectricMeterOutlined":false,"./ElectricMeterRounded":false,"./ElectricMeterSharp":false,"./ElectricMeterTwoTone":false,"./ElectricMoped":false,"./ElectricMopedOutlined":false,"./ElectricMopedRounded":false,"./ElectricMopedSharp":false,"./ElectricMopedTwoTone":false,"./ElectricRickshaw":false,"./ElectricRickshawOutlined":false,"./ElectricRickshawRounded":false,"./ElectricRickshawSharp":false,"./ElectricRickshawTwoTone":false,"./ElectricScooter":false,"./ElectricScooterOutlined":false,"./ElectricScooterRounded":false,"./ElectricScooterSharp":false,"./ElectricScooterTwoTone":false,"./ElectricalServices":false,"./ElectricalServicesOutlined":false,"./ElectricalServicesRounded":false,"./ElectricalServicesSharp":false,"./ElectricalServicesTwoTone":false,"./Elevator":false,"./ElevatorOutlined":false,"./ElevatorRounded":false,"./ElevatorSharp":false,"./ElevatorTwoTone":false,"./ElevenMp":false,"./ElevenMpOutlined":false,"./ElevenMpRounded":false,"./ElevenMpSharp":false,"./ElevenMpTwoTone":false,"./Email":false,"./EmailOutlined":false,"./EmailRounded":false,"./EmailSharp":false,"./EmailTwoTone":false,"./EmergencyRecording":false,"./EmergencyRecordingOutlined":false,"./EmergencyRecordingRounded":false,"./EmergencyRecordingSharp":false,"./EmergencyRecordingTwoTone":false,"./EmergencyShare":false,"./EmergencyShareOutlined":false,"./EmergencyShareRounded":false,"./EmergencyShareSharp":false,"./EmergencyShareTwoTone":false,"./EmojiEmotions":false,"./EmojiEmotionsOutlined":false,"./EmojiEmotionsRounded":false,"./EmojiEmotionsSharp":false,"./EmojiEmotionsTwoTone":false,"./EmojiEvents":false,"./EmojiEventsOutlined":false,"./EmojiEventsRounded":false,"./EmojiEventsSharp":false,"./EmojiEventsTwoTone":false,"./EmojiFlags":false,"./EmojiFlagsOutlined":false,"./EmojiFlagsRounded":false,"./EmojiFlagsSharp":false,"./EmojiFlagsTwoTone":false,"./EmojiFoodBeverage":false,"./EmojiFoodBeverageOutlined":false,"./EmojiFoodBeverageRounded":false,"./EmojiFoodBeverageSharp":false,"./EmojiFoodBeverageTwoTone":false,"./EmojiNature":false,"./EmojiNatureOutlined":false,"./EmojiNatureRounded":false,"./EmojiNatureSharp":false,"./EmojiNatureTwoTone":false,"./EmojiObjects":false,"./EmojiObjectsOutlined":false,"./EmojiObjectsRounded":false,"./EmojiObjectsSharp":false,"./EmojiObjectsTwoTone":false,"./EmojiPeople":false,"./EmojiPeopleOutlined":false,"./EmojiPeopleRounded":false,"./EmojiPeopleSharp":false,"./EmojiPeopleTwoTone":false,"./EmojiSymbols":false,"./EmojiSymbolsOutlined":false,"./EmojiSymbolsRounded":false,"./EmojiSymbolsSharp":false,"./EmojiSymbolsTwoTone":false,"./EmojiTransportation":false,"./EmojiTransportationOutlined":false,"./EmojiTransportationRounded":false,"./EmojiTransportationSharp":false,"./EmojiTransportationTwoTone":false,"./EnergySavingsLeaf":false,"./EnergySavingsLeafOutlined":false,"./EnergySavingsLeafRounded":false,"./EnergySavingsLeafSharp":false,"./EnergySavingsLeafTwoTone":false,"./Engineering":false,"./EngineeringOutlined":false,"./EngineeringRounded":false,"./EngineeringSharp":false,"./EngineeringTwoTone":false,"./EnhancedEncryption":false,"./EnhancedEncryptionOutlined":false,"./EnhancedEncryptionRounded":false,"./EnhancedEncryptionSharp":false,"./EnhancedEncryptionTwoTone":false,"./Equalizer":false,"./EqualizerOutlined":false,"./EqualizerRounded":false,"./EqualizerSharp":false,"./EqualizerTwoTone":false,"./Error":false,"./ErrorOutline":"i9RDV","./ErrorOutlineOutlined":false,"./ErrorOutlineRounded":false,"./ErrorOutlineSharp":false,"./ErrorOutlineTwoTone":false,"./ErrorOutlined":false,"./ErrorRounded":false,"./ErrorSharp":false,"./ErrorTwoTone":false,"./Escalator":false,"./EscalatorOutlined":false,"./EscalatorRounded":false,"./EscalatorSharp":false,"./EscalatorTwoTone":false,"./EscalatorWarning":false,"./EscalatorWarningOutlined":false,"./EscalatorWarningRounded":false,"./EscalatorWarningSharp":false,"./EscalatorWarningTwoTone":false,"./Euro":false,"./EuroOutlined":false,"./EuroRounded":false,"./EuroSharp":false,"./EuroSymbol":false,"./EuroSymbolOutlined":false,"./EuroSymbolRounded":false,"./EuroSymbolSharp":false,"./EuroSymbolTwoTone":false,"./EuroTwoTone":false,"./EvStation":false,"./EvStationOutlined":false,"./EvStationRounded":false,"./EvStationSharp":false,"./EvStationTwoTone":false,"./Event":false,"./EventAvailable":false,"./EventAvailableOutlined":false,"./EventAvailableRounded":false,"./EventAvailableSharp":false,"./EventAvailableTwoTone":false,"./EventBusy":"47nSb","./EventBusyOutlined":false,"./EventBusyRounded":false,"./EventBusySharp":false,"./EventBusyTwoTone":false,"./EventNote":false,"./EventNoteOutlined":false,"./EventNoteRounded":false,"./EventNoteSharp":false,"./EventNoteTwoTone":false,"./EventOutlined":false,"./EventRepeat":false,"./EventRepeatOutlined":false,"./EventRepeatRounded":false,"./EventRepeatSharp":false,"./EventRepeatTwoTone":false,"./EventRounded":false,"./EventSeat":false,"./EventSeatOutlined":false,"./EventSeatRounded":false,"./EventSeatSharp":false,"./EventSeatTwoTone":false,"./EventSharp":false,"./EventTwoTone":false,"./ExitToApp":false,"./ExitToAppOutlined":false,"./ExitToAppRounded":false,"./ExitToAppSharp":false,"./ExitToAppTwoTone":false,"./Expand":false,"./ExpandCircleDown":false,"./ExpandCircleDownOutlined":false,"./ExpandCircleDownRounded":false,"./ExpandCircleDownSharp":false,"./ExpandCircleDownTwoTone":false,"./ExpandLess":false,"./ExpandLessOutlined":false,"./ExpandLessRounded":false,"./ExpandLessSharp":false,"./ExpandLessTwoTone":false,"./ExpandMore":false,"./ExpandMoreOutlined":false,"./ExpandMoreRounded":false,"./ExpandMoreSharp":false,"./ExpandMoreTwoTone":false,"./ExpandOutlined":false,"./ExpandRounded":false,"./ExpandSharp":false,"./ExpandTwoTone":false,"./Explicit":false,"./ExplicitOutlined":false,"./ExplicitRounded":false,"./ExplicitSharp":false,"./ExplicitTwoTone":false,"./Explore":false,"./ExploreOff":false,"./ExploreOffOutlined":false,"./ExploreOffRounded":false,"./ExploreOffSharp":false,"./ExploreOffTwoTone":false,"./ExploreOutlined":false,"./ExploreRounded":false,"./ExploreSharp":false,"./ExploreTwoTone":false,"./Exposure":false,"./ExposureOutlined":false,"./ExposureRounded":false,"./ExposureSharp":false,"./ExposureTwoTone":false,"./Extension":false,"./ExtensionOff":false,"./ExtensionOffOutlined":false,"./ExtensionOffRounded":false,"./ExtensionOffSharp":false,"./ExtensionOffTwoTone":false,"./ExtensionOutlined":false,"./ExtensionRounded":false,"./ExtensionSharp":false,"./ExtensionTwoTone":false,"./Face":false,"./Face2":false,"./Face2Outlined":false,"./Face2Rounded":false,"./Face2Sharp":false,"./Face2TwoTone":false,"./Face3":false,"./Face3Outlined":false,"./Face3Rounded":false,"./Face3Sharp":false,"./Face3TwoTone":false,"./Face4":false,"./Face4Outlined":false,"./Face4Rounded":false,"./Face4Sharp":false,"./Face4TwoTone":false,"./Face5":false,"./Face5Outlined":false,"./Face5Rounded":false,"./Face5Sharp":false,"./Face5TwoTone":false,"./Face6":false,"./Face6Outlined":false,"./Face6Rounded":false,"./Face6Sharp":false,"./Face6TwoTone":false,"./FaceOutlined":false,"./FaceRetouchingNatural":false,"./FaceRetouchingNaturalOutlined":false,"./FaceRetouchingNaturalRounded":false,"./FaceRetouchingNaturalSharp":false,"./FaceRetouchingNaturalTwoTone":false,"./FaceRetouchingOff":false,"./FaceRetouchingOffOutlined":false,"./FaceRetouchingOffRounded":false,"./FaceRetouchingOffSharp":false,"./FaceRetouchingOffTwoTone":false,"./FaceRounded":false,"./FaceSharp":false,"./FaceTwoTone":false,"./Facebook":false,"./FacebookOutlined":false,"./FacebookRounded":false,"./FacebookSharp":false,"./FacebookTwoTone":false,"./FactCheck":false,"./FactCheckOutlined":false,"./FactCheckRounded":false,"./FactCheckSharp":false,"./FactCheckTwoTone":false,"./Factory":false,"./FactoryOutlined":false,"./FactoryRounded":false,"./FactorySharp":false,"./FactoryTwoTone":false,"./FamilyRestroom":false,"./FamilyRestroomOutlined":false,"./FamilyRestroomRounded":false,"./FamilyRestroomSharp":false,"./FamilyRestroomTwoTone":false,"./FastForward":false,"./FastForwardOutlined":false,"./FastForwardRounded":false,"./FastForwardSharp":false,"./FastForwardTwoTone":false,"./FastRewind":false,"./FastRewindOutlined":false,"./FastRewindRounded":false,"./FastRewindSharp":false,"./FastRewindTwoTone":false,"./Fastfood":false,"./FastfoodOutlined":false,"./FastfoodRounded":false,"./FastfoodSharp":false,"./FastfoodTwoTone":false,"./Favorite":false,"./FavoriteBorder":false,"./FavoriteBorderOutlined":false,"./FavoriteBorderRounded":false,"./FavoriteBorderSharp":false,"./FavoriteBorderTwoTone":false,"./FavoriteOutlined":false,"./FavoriteRounded":false,"./FavoriteSharp":false,"./FavoriteTwoTone":false,"./Fax":false,"./FaxOutlined":false,"./FaxRounded":false,"./FaxSharp":false,"./FaxTwoTone":false,"./FeaturedPlayList":false,"./FeaturedPlayListOutlined":false,"./FeaturedPlayListRounded":false,"./FeaturedPlayListSharp":false,"./FeaturedPlayListTwoTone":false,"./FeaturedVideo":false,"./FeaturedVideoOutlined":false,"./FeaturedVideoRounded":false,"./FeaturedVideoSharp":false,"./FeaturedVideoTwoTone":false,"./Feed":false,"./FeedOutlined":false,"./FeedRounded":false,"./FeedSharp":false,"./FeedTwoTone":false,"./Feedback":false,"./FeedbackOutlined":false,"./FeedbackRounded":false,"./FeedbackSharp":false,"./FeedbackTwoTone":false,"./Female":false,"./FemaleOutlined":false,"./FemaleRounded":false,"./FemaleSharp":false,"./FemaleTwoTone":false,"./Fence":false,"./FenceOutlined":false,"./FenceRounded":false,"./FenceSharp":false,"./FenceTwoTone":false,"./Festival":false,"./FestivalOutlined":false,"./FestivalRounded":false,"./FestivalSharp":false,"./FestivalTwoTone":false,"./FiberDvr":false,"./FiberDvrOutlined":false,"./FiberDvrRounded":false,"./FiberDvrSharp":false,"./FiberDvrTwoTone":false,"./FiberManualRecord":false,"./FiberManualRecordOutlined":false,"./FiberManualRecordRounded":false,"./FiberManualRecordSharp":false,"./FiberManualRecordTwoTone":false,"./FiberNew":false,"./FiberNewOutlined":false,"./FiberNewRounded":false,"./FiberNewSharp":false,"./FiberNewTwoTone":false,"./FiberPin":false,"./FiberPinOutlined":false,"./FiberPinRounded":false,"./FiberPinSharp":false,"./FiberPinTwoTone":false,"./FiberSmartRecord":false,"./FiberSmartRecordOutlined":false,"./FiberSmartRecordRounded":false,"./FiberSmartRecordSharp":false,"./FiberSmartRecordTwoTone":false,"./FifteenMp":false,"./FifteenMpOutlined":false,"./FifteenMpRounded":false,"./FifteenMpSharp":false,"./FifteenMpTwoTone":false,"./FileCopy":false,"./FileCopyOutlined":false,"./FileCopyRounded":false,"./FileCopySharp":false,"./FileCopyTwoTone":false,"./FileDownload":false,"./FileDownloadDone":false,"./FileDownloadDoneOutlined":false,"./FileDownloadDoneRounded":false,"./FileDownloadDoneSharp":false,"./FileDownloadDoneTwoTone":false,"./FileDownloadOff":false,"./FileDownloadOffOutlined":false,"./FileDownloadOffRounded":false,"./FileDownloadOffSharp":false,"./FileDownloadOffTwoTone":false,"./FileDownloadOutlined":"bB47I","./FileDownloadRounded":false,"./FileDownloadSharp":false,"./FileDownloadTwoTone":false,"./FileOpen":false,"./FileOpenOutlined":false,"./FileOpenRounded":false,"./FileOpenSharp":false,"./FileOpenTwoTone":false,"./FilePresent":false,"./FilePresentOutlined":false,"./FilePresentRounded":false,"./FilePresentSharp":false,"./FilePresentTwoTone":false,"./FileUpload":false,"./FileUploadOutlined":false,"./FileUploadRounded":false,"./FileUploadSharp":false,"./FileUploadTwoTone":false,"./Filter":false,"./Filter1":false,"./Filter1Outlined":false,"./Filter1Rounded":false,"./Filter1Sharp":false,"./Filter1TwoTone":false,"./Filter2":false,"./Filter2Outlined":false,"./Filter2Rounded":false,"./Filter2Sharp":false,"./Filter2TwoTone":false,"./Filter3":false,"./Filter3Outlined":false,"./Filter3Rounded":false,"./Filter3Sharp":false,"./Filter3TwoTone":false,"./Filter4":false,"./Filter4Outlined":false,"./Filter4Rounded":false,"./Filter4Sharp":false,"./Filter4TwoTone":false,"./Filter5":false,"./Filter5Outlined":false,"./Filter5Rounded":false,"./Filter5Sharp":false,"./Filter5TwoTone":false,"./Filter6":false,"./Filter6Outlined":false,"./Filter6Rounded":false,"./Filter6Sharp":false,"./Filter6TwoTone":false,"./Filter7":false,"./Filter7Outlined":false,"./Filter7Rounded":false,"./Filter7Sharp":false,"./Filter7TwoTone":false,"./Filter8":false,"./Filter8Outlined":false,"./Filter8Rounded":false,"./Filter8Sharp":false,"./Filter8TwoTone":false,"./Filter9":false,"./Filter9Outlined":false,"./Filter9Plus":false,"./Filter9PlusOutlined":false,"./Filter9PlusRounded":false,"./Filter9PlusSharp":false,"./Filter9PlusTwoTone":false,"./Filter9Rounded":false,"./Filter9Sharp":false,"./Filter9TwoTone":false,"./FilterAlt":false,"./FilterAltOff":false,"./FilterAltOffOutlined":false,"./FilterAltOffRounded":false,"./FilterAltOffSharp":false,"./FilterAltOffTwoTone":false,"./FilterAltOutlined":false,"./FilterAltRounded":false,"./FilterAltSharp":false,"./FilterAltTwoTone":false,"./FilterBAndW":false,"./FilterBAndWOutlined":false,"./FilterBAndWRounded":false,"./FilterBAndWSharp":false,"./FilterBAndWTwoTone":false,"./FilterCenterFocus":false,"./FilterCenterFocusOutlined":false,"./FilterCenterFocusRounded":false,"./FilterCenterFocusSharp":false,"./FilterCenterFocusTwoTone":false,"./FilterDrama":false,"./FilterDramaOutlined":false,"./FilterDramaRounded":false,"./FilterDramaSharp":false,"./FilterDramaTwoTone":false,"./FilterFrames":false,"./FilterFramesOutlined":false,"./FilterFramesRounded":false,"./FilterFramesSharp":false,"./FilterFramesTwoTone":false,"./FilterHdr":false,"./FilterHdrOutlined":false,"./FilterHdrRounded":false,"./FilterHdrSharp":false,"./FilterHdrTwoTone":false,"./FilterList":false,"./FilterListOff":false,"./FilterListOffOutlined":false,"./FilterListOffRounded":false,"./FilterListOffSharp":false,"./FilterListOffTwoTone":false,"./FilterListOutlined":false,"./FilterListRounded":false,"./FilterListSharp":false,"./FilterListTwoTone":false,"./FilterNone":false,"./FilterNoneOutlined":false,"./FilterNoneRounded":false,"./FilterNoneSharp":false,"./FilterNoneTwoTone":false,"./FilterOutlined":false,"./FilterRounded":false,"./FilterSharp":false,"./FilterTiltShift":false,"./FilterTiltShiftOutlined":false,"./FilterTiltShiftRounded":false,"./FilterTiltShiftSharp":false,"./FilterTiltShiftTwoTone":false,"./FilterTwoTone":false,"./FilterVintage":false,"./FilterVintageOutlined":false,"./FilterVintageRounded":false,"./FilterVintageSharp":false,"./FilterVintageTwoTone":false,"./FindInPage":false,"./FindInPageOutlined":false,"./FindInPageRounded":false,"./FindInPageSharp":false,"./FindInPageTwoTone":false,"./FindReplace":false,"./FindReplaceOutlined":false,"./FindReplaceRounded":false,"./FindReplaceSharp":false,"./FindReplaceTwoTone":false,"./Fingerprint":false,"./FingerprintOutlined":false,"./FingerprintRounded":false,"./FingerprintSharp":false,"./FingerprintTwoTone":false,"./FireExtinguisher":false,"./FireExtinguisherOutlined":false,"./FireExtinguisherRounded":false,"./FireExtinguisherSharp":false,"./FireExtinguisherTwoTone":false,"./FireHydrantAlt":false,"./FireHydrantAltOutlined":false,"./FireHydrantAltRounded":false,"./FireHydrantAltSharp":false,"./FireHydrantAltTwoTone":false,"./FireTruck":false,"./FireTruckOutlined":false,"./FireTruckRounded":false,"./FireTruckSharp":false,"./FireTruckTwoTone":false,"./Fireplace":false,"./FireplaceOutlined":false,"./FireplaceRounded":false,"./FireplaceSharp":false,"./FireplaceTwoTone":false,"./FirstPage":false,"./FirstPageOutlined":false,"./FirstPageRounded":false,"./FirstPageSharp":false,"./FirstPageTwoTone":false,"./FitScreen":false,"./FitScreenOutlined":false,"./FitScreenRounded":false,"./FitScreenSharp":false,"./FitScreenTwoTone":false,"./Fitbit":false,"./FitbitOutlined":false,"./FitbitRounded":false,"./FitbitSharp":false,"./FitbitTwoTone":false,"./FitnessCenter":false,"./FitnessCenterOutlined":false,"./FitnessCenterRounded":false,"./FitnessCenterSharp":false,"./FitnessCenterTwoTone":false,"./FiveG":false,"./FiveGOutlined":false,"./FiveGRounded":false,"./FiveGSharp":false,"./FiveGTwoTone":false,"./FiveK":false,"./FiveKOutlined":false,"./FiveKPlus":false,"./FiveKPlusOutlined":false,"./FiveKPlusRounded":false,"./FiveKPlusSharp":false,"./FiveKPlusTwoTone":false,"./FiveKRounded":false,"./FiveKSharp":false,"./FiveKTwoTone":false,"./FiveMp":false,"./FiveMpOutlined":false,"./FiveMpRounded":false,"./FiveMpSharp":false,"./FiveMpTwoTone":false,"./FivteenMp":false,"./FivteenMpOutlined":false,"./FivteenMpRounded":false,"./FivteenMpSharp":false,"./FivteenMpTwoTone":false,"./Flag":false,"./FlagCircle":false,"./FlagCircleOutlined":false,"./FlagCircleRounded":false,"./FlagCircleSharp":false,"./FlagCircleTwoTone":false,"./FlagOutlined":false,"./FlagRounded":false,"./FlagSharp":false,"./FlagTwoTone":false,"./Flaky":false,"./FlakyOutlined":false,"./FlakyRounded":false,"./FlakySharp":false,"./FlakyTwoTone":false,"./Flare":false,"./FlareOutlined":false,"./FlareRounded":false,"./FlareSharp":false,"./FlareTwoTone":false,"./FlashAuto":false,"./FlashAutoOutlined":false,"./FlashAutoRounded":false,"./FlashAutoSharp":false,"./FlashAutoTwoTone":false,"./FlashOff":false,"./FlashOffOutlined":false,"./FlashOffRounded":false,"./FlashOffSharp":false,"./FlashOffTwoTone":false,"./FlashOn":false,"./FlashOnOutlined":false,"./FlashOnRounded":false,"./FlashOnSharp":false,"./FlashOnTwoTone":false,"./FlashlightOff":false,"./FlashlightOffOutlined":false,"./FlashlightOffRounded":false,"./FlashlightOffSharp":false,"./FlashlightOffTwoTone":false,"./FlashlightOn":false,"./FlashlightOnOutlined":false,"./FlashlightOnRounded":false,"./FlashlightOnSharp":false,"./FlashlightOnTwoTone":false,"./Flatware":false,"./FlatwareOutlined":false,"./FlatwareRounded":false,"./FlatwareSharp":false,"./FlatwareTwoTone":false,"./Flight":false,"./FlightClass":false,"./FlightClassOutlined":false,"./FlightClassRounded":false,"./FlightClassSharp":false,"./FlightClassTwoTone":false,"./FlightLand":false,"./FlightLandOutlined":false,"./FlightLandRounded":false,"./FlightLandSharp":false,"./FlightLandTwoTone":false,"./FlightOutlined":false,"./FlightRounded":false,"./FlightSharp":false,"./FlightTakeoff":false,"./FlightTakeoffOutlined":false,"./FlightTakeoffRounded":false,"./FlightTakeoffSharp":false,"./FlightTakeoffTwoTone":false,"./FlightTwoTone":false,"./Flip":false,"./FlipCameraAndroid":false,"./FlipCameraAndroidOutlined":false,"./FlipCameraAndroidRounded":false,"./FlipCameraAndroidSharp":false,"./FlipCameraAndroidTwoTone":false,"./FlipCameraIos":false,"./FlipCameraIosOutlined":false,"./FlipCameraIosRounded":false,"./FlipCameraIosSharp":false,"./FlipCameraIosTwoTone":false,"./FlipOutlined":false,"./FlipRounded":false,"./FlipSharp":false,"./FlipToBack":false,"./FlipToBackOutlined":false,"./FlipToBackRounded":false,"./FlipToBackSharp":false,"./FlipToBackTwoTone":false,"./FlipToFront":false,"./FlipToFrontOutlined":false,"./FlipToFrontRounded":false,"./FlipToFrontSharp":false,"./FlipToFrontTwoTone":false,"./FlipTwoTone":false,"./Flood":false,"./FloodOutlined":false,"./FloodRounded":false,"./FloodSharp":false,"./FloodTwoTone":false,"./Fluorescent":false,"./FluorescentOutlined":false,"./FluorescentRounded":false,"./FluorescentSharp":false,"./FluorescentTwoTone":false,"./FlutterDash":false,"./FlutterDashOutlined":false,"./FlutterDashRounded":false,"./FlutterDashSharp":false,"./FlutterDashTwoTone":false,"./FmdBad":false,"./FmdBadOutlined":false,"./FmdBadRounded":false,"./FmdBadSharp":false,"./FmdBadTwoTone":false,"./FmdGood":false,"./FmdGoodOutlined":false,"./FmdGoodRounded":false,"./FmdGoodSharp":false,"./FmdGoodTwoTone":false,"./Folder":false,"./FolderCopy":false,"./FolderCopyOutlined":false,"./FolderCopyRounded":false,"./FolderCopySharp":false,"./FolderCopyTwoTone":false,"./FolderDelete":false,"./FolderDeleteOutlined":false,"./FolderDeleteRounded":false,"./FolderDeleteSharp":false,"./FolderDeleteTwoTone":false,"./FolderOff":false,"./FolderOffOutlined":false,"./FolderOffRounded":false,"./FolderOffSharp":false,"./FolderOffTwoTone":false,"./FolderOpen":false,"./FolderOpenOutlined":false,"./FolderOpenRounded":false,"./FolderOpenSharp":false,"./FolderOpenTwoTone":false,"./FolderOutlined":false,"./FolderRounded":false,"./FolderShared":false,"./FolderSharedOutlined":false,"./FolderSharedRounded":false,"./FolderSharedSharp":false,"./FolderSharedTwoTone":false,"./FolderSharp":false,"./FolderSpecial":false,"./FolderSpecialOutlined":false,"./FolderSpecialRounded":false,"./FolderSpecialSharp":false,"./FolderSpecialTwoTone":false,"./FolderTwoTone":false,"./FolderZip":false,"./FolderZipOutlined":false,"./FolderZipRounded":false,"./FolderZipSharp":false,"./FolderZipTwoTone":false,"./FollowTheSigns":false,"./FollowTheSignsOutlined":false,"./FollowTheSignsRounded":false,"./FollowTheSignsSharp":false,"./FollowTheSignsTwoTone":false,"./FontDownload":false,"./FontDownloadOff":false,"./FontDownloadOffOutlined":false,"./FontDownloadOffRounded":false,"./FontDownloadOffSharp":false,"./FontDownloadOffTwoTone":false,"./FontDownloadOutlined":false,"./FontDownloadRounded":false,"./FontDownloadSharp":false,"./FontDownloadTwoTone":false,"./FoodBank":false,"./FoodBankOutlined":false,"./FoodBankRounded":false,"./FoodBankSharp":false,"./FoodBankTwoTone":false,"./Forest":false,"./ForestOutlined":false,"./ForestRounded":false,"./ForestSharp":false,"./ForestTwoTone":false,"./ForkLeft":false,"./ForkLeftOutlined":false,"./ForkLeftRounded":false,"./ForkLeftSharp":false,"./ForkLeftTwoTone":false,"./ForkRight":false,"./ForkRightOutlined":false,"./ForkRightRounded":false,"./ForkRightSharp":false,"./ForkRightTwoTone":false,"./FormatAlignCenter":false,"./FormatAlignCenterOutlined":false,"./FormatAlignCenterRounded":false,"./FormatAlignCenterSharp":false,"./FormatAlignCenterTwoTone":false,"./FormatAlignJustify":false,"./FormatAlignJustifyOutlined":false,"./FormatAlignJustifyRounded":false,"./FormatAlignJustifySharp":false,"./FormatAlignJustifyTwoTone":false,"./FormatAlignLeft":false,"./FormatAlignLeftOutlined":false,"./FormatAlignLeftRounded":false,"./FormatAlignLeftSharp":false,"./FormatAlignLeftTwoTone":false,"./FormatAlignRight":false,"./FormatAlignRightOutlined":false,"./FormatAlignRightRounded":false,"./FormatAlignRightSharp":false,"./FormatAlignRightTwoTone":false,"./FormatBold":false,"./FormatBoldOutlined":false,"./FormatBoldRounded":false,"./FormatBoldSharp":false,"./FormatBoldTwoTone":false,"./FormatClear":false,"./FormatClearOutlined":false,"./FormatClearRounded":false,"./FormatClearSharp":false,"./FormatClearTwoTone":false,"./FormatColorFill":false,"./FormatColorFillOutlined":false,"./FormatColorFillRounded":false,"./FormatColorFillSharp":false,"./FormatColorFillTwoTone":false,"./FormatColorReset":false,"./FormatColorResetOutlined":false,"./FormatColorResetRounded":false,"./FormatColorResetSharp":false,"./FormatColorResetTwoTone":false,"./FormatColorText":false,"./FormatColorTextOutlined":false,"./FormatColorTextRounded":false,"./FormatColorTextSharp":false,"./FormatColorTextTwoTone":false,"./FormatIndentDecrease":false,"./FormatIndentDecreaseOutlined":false,"./FormatIndentDecreaseRounded":false,"./FormatIndentDecreaseSharp":false,"./FormatIndentDecreaseTwoTone":false,"./FormatIndentIncrease":false,"./FormatIndentIncreaseOutlined":false,"./FormatIndentIncreaseRounded":false,"./FormatIndentIncreaseSharp":false,"./FormatIndentIncreaseTwoTone":false,"./FormatItalic":false,"./FormatItalicOutlined":false,"./FormatItalicRounded":false,"./FormatItalicSharp":false,"./FormatItalicTwoTone":false,"./FormatLineSpacing":false,"./FormatLineSpacingOutlined":false,"./FormatLineSpacingRounded":false,"./FormatLineSpacingSharp":false,"./FormatLineSpacingTwoTone":false,"./FormatListBulleted":false,"./FormatListBulletedOutlined":false,"./FormatListBulletedRounded":false,"./FormatListBulletedSharp":false,"./FormatListBulletedTwoTone":false,"./FormatListNumbered":false,"./FormatListNumberedOutlined":false,"./FormatListNumberedRounded":false,"./FormatListNumberedRtl":false,"./FormatListNumberedRtlOutlined":false,"./FormatListNumberedRtlRounded":false,"./FormatListNumberedRtlSharp":false,"./FormatListNumberedRtlTwoTone":false,"./FormatListNumberedSharp":false,"./FormatListNumberedTwoTone":false,"./FormatOverline":false,"./FormatOverlineOutlined":false,"./FormatOverlineRounded":false,"./FormatOverlineSharp":false,"./FormatOverlineTwoTone":false,"./FormatPaint":false,"./FormatPaintOutlined":false,"./FormatPaintRounded":false,"./FormatPaintSharp":false,"./FormatPaintTwoTone":false,"./FormatQuote":false,"./FormatQuoteOutlined":false,"./FormatQuoteRounded":false,"./FormatQuoteSharp":false,"./FormatQuoteTwoTone":false,"./FormatShapes":false,"./FormatShapesOutlined":false,"./FormatShapesRounded":false,"./FormatShapesSharp":false,"./FormatShapesTwoTone":false,"./FormatSize":false,"./FormatSizeOutlined":false,"./FormatSizeRounded":false,"./FormatSizeSharp":false,"./FormatSizeTwoTone":false,"./FormatStrikethrough":false,"./FormatStrikethroughOutlined":false,"./FormatStrikethroughRounded":false,"./FormatStrikethroughSharp":false,"./FormatStrikethroughTwoTone":false,"./FormatTextdirectionLToR":false,"./FormatTextdirectionLToROutlined":false,"./FormatTextdirectionLToRRounded":false,"./FormatTextdirectionLToRSharp":false,"./FormatTextdirectionLToRTwoTone":false,"./FormatTextdirectionRToL":false,"./FormatTextdirectionRToLOutlined":false,"./FormatTextdirectionRToLRounded":false,"./FormatTextdirectionRToLSharp":false,"./FormatTextdirectionRToLTwoTone":false,"./FormatUnderlined":false,"./FormatUnderlinedOutlined":false,"./FormatUnderlinedRounded":false,"./FormatUnderlinedSharp":false,"./FormatUnderlinedTwoTone":false,"./Fort":false,"./FortOutlined":false,"./FortRounded":false,"./FortSharp":false,"./FortTwoTone":false,"./Forum":false,"./ForumOutlined":false,"./ForumRounded":false,"./ForumSharp":false,"./ForumTwoTone":false,"./Forward":false,"./Forward10":false,"./Forward10Outlined":false,"./Forward10Rounded":false,"./Forward10Sharp":false,"./Forward10TwoTone":false,"./Forward30":false,"./Forward30Outlined":false,"./Forward30Rounded":false,"./Forward30Sharp":false,"./Forward30TwoTone":false,"./Forward5":false,"./Forward5Outlined":false,"./Forward5Rounded":false,"./Forward5Sharp":false,"./Forward5TwoTone":false,"./ForwardOutlined":false,"./ForwardRounded":false,"./ForwardSharp":false,"./ForwardToInbox":false,"./ForwardToInboxOutlined":false,"./ForwardToInboxRounded":false,"./ForwardToInboxSharp":false,"./ForwardToInboxTwoTone":false,"./ForwardTwoTone":false,"./Foundation":false,"./FoundationOutlined":false,"./FoundationRounded":false,"./FoundationSharp":false,"./FoundationTwoTone":false,"./FourGMobiledata":false,"./FourGMobiledataOutlined":false,"./FourGMobiledataRounded":false,"./FourGMobiledataSharp":false,"./FourGMobiledataTwoTone":false,"./FourGPlusMobiledata":false,"./FourGPlusMobiledataOutlined":false,"./FourGPlusMobiledataRounded":false,"./FourGPlusMobiledataSharp":false,"./FourGPlusMobiledataTwoTone":false,"./FourK":false,"./FourKOutlined":false,"./FourKPlus":false,"./FourKPlusOutlined":false,"./FourKPlusRounded":false,"./FourKPlusSharp":false,"./FourKPlusTwoTone":false,"./FourKRounded":false,"./FourKSharp":false,"./FourKTwoTone":false,"./FourMp":false,"./FourMpOutlined":false,"./FourMpRounded":false,"./FourMpSharp":false,"./FourMpTwoTone":false,"./FourteenMp":false,"./FourteenMpOutlined":false,"./FourteenMpRounded":false,"./FourteenMpSharp":false,"./FourteenMpTwoTone":false,"./FreeBreakfast":false,"./FreeBreakfastOutlined":false,"./FreeBreakfastRounded":false,"./FreeBreakfastSharp":false,"./FreeBreakfastTwoTone":false,"./Fullscreen":false,"./FullscreenExit":false,"./FullscreenExitOutlined":false,"./FullscreenExitRounded":false,"./FullscreenExitSharp":false,"./FullscreenExitTwoTone":false,"./FullscreenOutlined":false,"./FullscreenRounded":false,"./FullscreenSharp":false,"./FullscreenTwoTone":false,"./Functions":false,"./FunctionsOutlined":false,"./FunctionsRounded":false,"./FunctionsSharp":false,"./FunctionsTwoTone":false,"./GMobiledata":false,"./GMobiledataOutlined":false,"./GMobiledataRounded":false,"./GMobiledataSharp":false,"./GMobiledataTwoTone":false,"./GTranslate":false,"./GTranslateOutlined":false,"./GTranslateRounded":false,"./GTranslateSharp":false,"./GTranslateTwoTone":false,"./Gamepad":false,"./GamepadOutlined":false,"./GamepadRounded":false,"./GamepadSharp":false,"./GamepadTwoTone":false,"./Games":false,"./GamesOutlined":false,"./GamesRounded":false,"./GamesSharp":false,"./GamesTwoTone":false,"./Garage":false,"./GarageOutlined":false,"./GarageRounded":false,"./GarageSharp":false,"./GarageTwoTone":false,"./GasMeter":false,"./GasMeterOutlined":false,"./GasMeterRounded":false,"./GasMeterSharp":false,"./GasMeterTwoTone":false,"./Gavel":false,"./GavelOutlined":false,"./GavelRounded":false,"./GavelSharp":false,"./GavelTwoTone":false,"./Gesture":false,"./GestureOutlined":false,"./GestureRounded":false,"./GestureSharp":false,"./GestureTwoTone":false,"./GetApp":false,"./GetAppOutlined":false,"./GetAppRounded":false,"./GetAppSharp":false,"./GetAppTwoTone":false,"./Gif":false,"./GifBox":false,"./GifBoxOutlined":false,"./GifBoxRounded":false,"./GifBoxSharp":false,"./GifBoxTwoTone":false,"./GifOutlined":false,"./GifRounded":false,"./GifSharp":false,"./GifTwoTone":false,"./Girl":false,"./GirlOutlined":false,"./GirlRounded":false,"./GirlSharp":false,"./GirlTwoTone":false,"./GitHub":false,"./Gite":false,"./GiteOutlined":false,"./GiteRounded":false,"./GiteSharp":false,"./GiteTwoTone":false,"./GolfCourse":false,"./GolfCourseOutlined":false,"./GolfCourseRounded":false,"./GolfCourseSharp":false,"./GolfCourseTwoTone":false,"./Google":false,"./GppBad":false,"./GppBadOutlined":false,"./GppBadRounded":false,"./GppBadSharp":false,"./GppBadTwoTone":false,"./GppGood":false,"./GppGoodOutlined":false,"./GppGoodRounded":false,"./GppGoodSharp":false,"./GppGoodTwoTone":false,"./GppMaybe":false,"./GppMaybeOutlined":false,"./GppMaybeRounded":false,"./GppMaybeSharp":false,"./GppMaybeTwoTone":false,"./GpsFixed":false,"./GpsFixedOutlined":false,"./GpsFixedRounded":false,"./GpsFixedSharp":false,"./GpsFixedTwoTone":false,"./GpsNotFixed":false,"./GpsNotFixedOutlined":false,"./GpsNotFixedRounded":false,"./GpsNotFixedSharp":false,"./GpsNotFixedTwoTone":false,"./GpsOff":false,"./GpsOffOutlined":false,"./GpsOffRounded":false,"./GpsOffSharp":false,"./GpsOffTwoTone":false,"./Grade":false,"./GradeOutlined":false,"./GradeRounded":false,"./GradeSharp":false,"./GradeTwoTone":false,"./Gradient":false,"./GradientOutlined":false,"./GradientRounded":false,"./GradientSharp":false,"./GradientTwoTone":false,"./Grading":false,"./GradingOutlined":false,"./GradingRounded":false,"./GradingSharp":false,"./GradingTwoTone":false,"./Grain":false,"./GrainOutlined":false,"./GrainRounded":false,"./GrainSharp":false,"./GrainTwoTone":false,"./GraphicEq":false,"./GraphicEqOutlined":false,"./GraphicEqRounded":false,"./GraphicEqSharp":false,"./GraphicEqTwoTone":false,"./Grass":false,"./GrassOutlined":false,"./GrassRounded":false,"./GrassSharp":false,"./GrassTwoTone":false,"./Grid3x3":false,"./Grid3x3Outlined":false,"./Grid3x3Rounded":false,"./Grid3x3Sharp":false,"./Grid3x3TwoTone":false,"./Grid4x4":false,"./Grid4x4Outlined":false,"./Grid4x4Rounded":false,"./Grid4x4Sharp":false,"./Grid4x4TwoTone":false,"./GridGoldenratio":false,"./GridGoldenratioOutlined":false,"./GridGoldenratioRounded":false,"./GridGoldenratioSharp":false,"./GridGoldenratioTwoTone":false,"./GridOff":false,"./GridOffOutlined":false,"./GridOffRounded":false,"./GridOffSharp":false,"./GridOffTwoTone":false,"./GridOn":false,"./GridOnOutlined":false,"./GridOnRounded":false,"./GridOnSharp":false,"./GridOnTwoTone":false,"./GridView":false,"./GridViewOutlined":false,"./GridViewRounded":false,"./GridViewSharp":false,"./GridViewTwoTone":false,"./Group":"aL4xz","./GroupAdd":false,"./GroupAddOutlined":false,"./GroupAddRounded":false,"./GroupAddSharp":false,"./GroupAddTwoTone":false,"./GroupOutlined":false,"./GroupRemove":false,"./GroupRemoveOutlined":false,"./GroupRemoveRounded":false,"./GroupRemoveSharp":false,"./GroupRemoveTwoTone":false,"./GroupRounded":false,"./GroupSharp":false,"./GroupTwoTone":false,"./GroupWork":false,"./GroupWorkOutlined":false,"./GroupWorkRounded":false,"./GroupWorkSharp":false,"./GroupWorkTwoTone":false,"./Groups":false,"./Groups2":false,"./Groups2Outlined":false,"./Groups2Rounded":false,"./Groups2Sharp":false,"./Groups2TwoTone":false,"./Groups3":false,"./Groups3Outlined":false,"./Groups3Rounded":false,"./Groups3Sharp":false,"./Groups3TwoTone":false,"./GroupsOutlined":false,"./GroupsRounded":false,"./GroupsSharp":false,"./GroupsTwoTone":false,"./HMobiledata":false,"./HMobiledataOutlined":false,"./HMobiledataRounded":false,"./HMobiledataSharp":false,"./HMobiledataTwoTone":false,"./HPlusMobiledata":false,"./HPlusMobiledataOutlined":false,"./HPlusMobiledataRounded":false,"./HPlusMobiledataSharp":false,"./HPlusMobiledataTwoTone":false,"./Hail":false,"./HailOutlined":false,"./HailRounded":false,"./HailSharp":false,"./HailTwoTone":false,"./Handshake":false,"./HandshakeOutlined":false,"./HandshakeRounded":false,"./HandshakeSharp":false,"./HandshakeTwoTone":false,"./Handyman":false,"./HandymanOutlined":false,"./HandymanRounded":false,"./HandymanSharp":false,"./HandymanTwoTone":false,"./Hardware":false,"./HardwareOutlined":false,"./HardwareRounded":false,"./HardwareSharp":false,"./HardwareTwoTone":false,"./Hd":false,"./HdOutlined":false,"./HdRounded":false,"./HdSharp":false,"./HdTwoTone":false,"./HdrAuto":false,"./HdrAutoOutlined":false,"./HdrAutoRounded":false,"./HdrAutoSelect":false,"./HdrAutoSelectOutlined":false,"./HdrAutoSelectRounded":false,"./HdrAutoSelectSharp":false,"./HdrAutoSelectTwoTone":false,"./HdrAutoSharp":false,"./HdrAutoTwoTone":false,"./HdrEnhancedSelect":false,"./HdrEnhancedSelectOutlined":false,"./HdrEnhancedSelectRounded":false,"./HdrEnhancedSelectSharp":false,"./HdrEnhancedSelectTwoTone":false,"./HdrOff":false,"./HdrOffOutlined":false,"./HdrOffRounded":false,"./HdrOffSelect":false,"./HdrOffSelectOutlined":false,"./HdrOffSelectRounded":false,"./HdrOffSelectSharp":false,"./HdrOffSelectTwoTone":false,"./HdrOffSharp":false,"./HdrOffTwoTone":false,"./HdrOn":false,"./HdrOnOutlined":false,"./HdrOnRounded":false,"./HdrOnSelect":false,"./HdrOnSelectOutlined":false,"./HdrOnSelectRounded":false,"./HdrOnSelectSharp":false,"./HdrOnSelectTwoTone":false,"./HdrOnSharp":false,"./HdrOnTwoTone":false,"./HdrPlus":false,"./HdrPlusOutlined":false,"./HdrPlusRounded":false,"./HdrPlusSharp":false,"./HdrPlusTwoTone":false,"./HdrStrong":false,"./HdrStrongOutlined":false,"./HdrStrongRounded":false,"./HdrStrongSharp":false,"./HdrStrongTwoTone":false,"./HdrWeak":false,"./HdrWeakOutlined":false,"./HdrWeakRounded":false,"./HdrWeakSharp":false,"./HdrWeakTwoTone":false,"./Headphones":false,"./HeadphonesBattery":false,"./HeadphonesBatteryOutlined":false,"./HeadphonesBatteryRounded":false,"./HeadphonesBatterySharp":false,"./HeadphonesBatteryTwoTone":false,"./HeadphonesOutlined":false,"./HeadphonesRounded":false,"./HeadphonesSharp":false,"./HeadphonesTwoTone":false,"./Headset":false,"./HeadsetMic":false,"./HeadsetMicOutlined":false,"./HeadsetMicRounded":false,"./HeadsetMicSharp":false,"./HeadsetMicTwoTone":false,"./HeadsetOff":false,"./HeadsetOffOutlined":false,"./HeadsetOffRounded":false,"./HeadsetOffSharp":false,"./HeadsetOffTwoTone":false,"./HeadsetOutlined":false,"./HeadsetRounded":false,"./HeadsetSharp":false,"./HeadsetTwoTone":false,"./Healing":false,"./HealingOutlined":false,"./HealingRounded":false,"./HealingSharp":false,"./HealingTwoTone":false,"./HealthAndSafety":false,"./HealthAndSafetyOutlined":false,"./HealthAndSafetyRounded":false,"./HealthAndSafetySharp":false,"./HealthAndSafetyTwoTone":false,"./Hearing":false,"./HearingDisabled":false,"./HearingDisabledOutlined":false,"./HearingDisabledRounded":false,"./HearingDisabledSharp":false,"./HearingDisabledTwoTone":false,"./HearingOutlined":false,"./HearingRounded":false,"./HearingSharp":false,"./HearingTwoTone":false,"./HeartBroken":false,"./HeartBrokenOutlined":false,"./HeartBrokenRounded":false,"./HeartBrokenSharp":false,"./HeartBrokenTwoTone":false,"./HeatPump":false,"./HeatPumpOutlined":false,"./HeatPumpRounded":false,"./HeatPumpSharp":false,"./HeatPumpTwoTone":false,"./Height":false,"./HeightOutlined":false,"./HeightRounded":false,"./HeightSharp":false,"./HeightTwoTone":false,"./Help":false,"./HelpCenter":false,"./HelpCenterOutlined":false,"./HelpCenterRounded":false,"./HelpCenterSharp":false,"./HelpCenterTwoTone":false,"./HelpOutline":false,"./HelpOutlineOutlined":false,"./HelpOutlineRounded":false,"./HelpOutlineSharp":false,"./HelpOutlineTwoTone":false,"./HelpOutlined":false,"./HelpRounded":false,"./HelpSharp":false,"./HelpTwoTone":false,"./Hevc":false,"./HevcOutlined":false,"./HevcRounded":false,"./HevcSharp":false,"./HevcTwoTone":false,"./Hexagon":false,"./HexagonOutlined":false,"./HexagonRounded":false,"./HexagonSharp":false,"./HexagonTwoTone":false,"./HideImage":false,"./HideImageOutlined":false,"./HideImageRounded":false,"./HideImageSharp":false,"./HideImageTwoTone":false,"./HideSource":false,"./HideSourceOutlined":false,"./HideSourceRounded":false,"./HideSourceSharp":false,"./HideSourceTwoTone":false,"./HighQuality":false,"./HighQualityOutlined":false,"./HighQualityRounded":false,"./HighQualitySharp":false,"./HighQualityTwoTone":false,"./Highlight":false,"./HighlightAlt":false,"./HighlightAltOutlined":false,"./HighlightAltRounded":false,"./HighlightAltSharp":false,"./HighlightAltTwoTone":false,"./HighlightOff":false,"./HighlightOffOutlined":false,"./HighlightOffRounded":false,"./HighlightOffSharp":false,"./HighlightOffTwoTone":false,"./HighlightOutlined":false,"./HighlightRounded":false,"./HighlightSharp":false,"./HighlightTwoTone":false,"./Hiking":false,"./HikingOutlined":false,"./HikingRounded":false,"./HikingSharp":false,"./HikingTwoTone":false,"./History":false,"./HistoryEdu":false,"./HistoryEduOutlined":false,"./HistoryEduRounded":false,"./HistoryEduSharp":false,"./HistoryEduTwoTone":false,"./HistoryOutlined":false,"./HistoryRounded":false,"./HistorySharp":false,"./HistoryToggleOff":false,"./HistoryToggleOffOutlined":false,"./HistoryToggleOffRounded":false,"./HistoryToggleOffSharp":false,"./HistoryToggleOffTwoTone":false,"./HistoryTwoTone":false,"./Hive":false,"./HiveOutlined":false,"./HiveRounded":false,"./HiveSharp":false,"./HiveTwoTone":false,"./Hls":false,"./HlsOff":false,"./HlsOffOutlined":false,"./HlsOffRounded":false,"./HlsOffSharp":false,"./HlsOffTwoTone":false,"./HlsOutlined":false,"./HlsRounded":false,"./HlsSharp":false,"./HlsTwoTone":false,"./HolidayVillage":"aSDgb","./HolidayVillageOutlined":false,"./HolidayVillageRounded":false,"./HolidayVillageSharp":false,"./HolidayVillageTwoTone":false,"./Home":false,"./HomeMax":false,"./HomeMaxOutlined":false,"./HomeMaxRounded":false,"./HomeMaxSharp":false,"./HomeMaxTwoTone":false,"./HomeMini":false,"./HomeMiniOutlined":false,"./HomeMiniRounded":false,"./HomeMiniSharp":false,"./HomeMiniTwoTone":false,"./HomeOutlined":false,"./HomeRepairService":false,"./HomeRepairServiceOutlined":false,"./HomeRepairServiceRounded":false,"./HomeRepairServiceSharp":false,"./HomeRepairServiceTwoTone":false,"./HomeRounded":false,"./HomeSharp":false,"./HomeTwoTone":false,"./HomeWork":false,"./HomeWorkOutlined":false,"./HomeWorkRounded":false,"./HomeWorkSharp":false,"./HomeWorkTwoTone":false,"./HorizontalRule":false,"./HorizontalRuleOutlined":false,"./HorizontalRuleRounded":false,"./HorizontalRuleSharp":false,"./HorizontalRuleTwoTone":false,"./HorizontalSplit":false,"./HorizontalSplitOutlined":false,"./HorizontalSplitRounded":false,"./HorizontalSplitSharp":false,"./HorizontalSplitTwoTone":false,"./HotTub":false,"./HotTubOutlined":false,"./HotTubRounded":false,"./HotTubSharp":false,"./HotTubTwoTone":false,"./Hotel":false,"./HotelOutlined":false,"./HotelRounded":false,"./HotelSharp":false,"./HotelTwoTone":false,"./HourglassBottom":false,"./HourglassBottomOutlined":false,"./HourglassBottomRounded":false,"./HourglassBottomSharp":false,"./HourglassBottomTwoTone":false,"./HourglassDisabled":false,"./HourglassDisabledOutlined":false,"./HourglassDisabledRounded":false,"./HourglassDisabledSharp":false,"./HourglassDisabledTwoTone":false,"./HourglassEmpty":false,"./HourglassEmptyOutlined":false,"./HourglassEmptyRounded":false,"./HourglassEmptySharp":false,"./HourglassEmptyTwoTone":false,"./HourglassFull":false,"./HourglassFullOutlined":false,"./HourglassFullRounded":false,"./HourglassFullSharp":false,"./HourglassFullTwoTone":false,"./HourglassTop":false,"./HourglassTopOutlined":false,"./HourglassTopRounded":false,"./HourglassTopSharp":false,"./HourglassTopTwoTone":false,"./House":false,"./HouseOutlined":false,"./HouseRounded":false,"./HouseSharp":false,"./HouseSiding":false,"./HouseSidingOutlined":false,"./HouseSidingRounded":false,"./HouseSidingSharp":false,"./HouseSidingTwoTone":false,"./HouseTwoTone":false,"./Houseboat":false,"./HouseboatOutlined":false,"./HouseboatRounded":false,"./HouseboatSharp":false,"./HouseboatTwoTone":false,"./HowToReg":false,"./HowToRegOutlined":false,"./HowToRegRounded":false,"./HowToRegSharp":false,"./HowToRegTwoTone":false,"./HowToVote":false,"./HowToVoteOutlined":false,"./HowToVoteRounded":false,"./HowToVoteSharp":false,"./HowToVoteTwoTone":false,"./Html":false,"./HtmlOutlined":false,"./HtmlRounded":false,"./HtmlSharp":false,"./HtmlTwoTone":false,"./Http":false,"./HttpOutlined":false,"./HttpRounded":false,"./HttpSharp":false,"./HttpTwoTone":false,"./Https":false,"./HttpsOutlined":false,"./HttpsRounded":false,"./HttpsSharp":false,"./HttpsTwoTone":false,"./Hub":false,"./HubOutlined":false,"./HubRounded":false,"./HubSharp":false,"./HubTwoTone":false,"./Hvac":false,"./HvacOutlined":false,"./HvacRounded":false,"./HvacSharp":false,"./HvacTwoTone":false,"./IceSkating":false,"./IceSkatingOutlined":false,"./IceSkatingRounded":false,"./IceSkatingSharp":false,"./IceSkatingTwoTone":false,"./Icecream":false,"./IcecreamOutlined":false,"./IcecreamRounded":false,"./IcecreamSharp":false,"./IcecreamTwoTone":false,"./Image":false,"./ImageAspectRatio":false,"./ImageAspectRatioOutlined":false,"./ImageAspectRatioRounded":false,"./ImageAspectRatioSharp":false,"./ImageAspectRatioTwoTone":false,"./ImageNotSupported":false,"./ImageNotSupportedOutlined":false,"./ImageNotSupportedRounded":false,"./ImageNotSupportedSharp":false,"./ImageNotSupportedTwoTone":false,"./ImageOutlined":false,"./ImageRounded":false,"./ImageSearch":false,"./ImageSearchOutlined":false,"./ImageSearchRounded":false,"./ImageSearchSharp":false,"./ImageSearchTwoTone":false,"./ImageSharp":false,"./ImageTwoTone":false,"./ImagesearchRoller":false,"./ImagesearchRollerOutlined":false,"./ImagesearchRollerRounded":false,"./ImagesearchRollerSharp":false,"./ImagesearchRollerTwoTone":false,"./ImportContacts":false,"./ImportContactsOutlined":false,"./ImportContactsRounded":false,"./ImportContactsSharp":false,"./ImportContactsTwoTone":false,"./ImportExport":false,"./ImportExportOutlined":false,"./ImportExportRounded":false,"./ImportExportSharp":false,"./ImportExportTwoTone":false,"./ImportantDevices":false,"./ImportantDevicesOutlined":false,"./ImportantDevicesRounded":false,"./ImportantDevicesSharp":false,"./ImportantDevicesTwoTone":false,"./Inbox":false,"./InboxOutlined":false,"./InboxRounded":false,"./InboxSharp":false,"./InboxTwoTone":false,"./IndeterminateCheckBox":false,"./IndeterminateCheckBoxOutlined":false,"./IndeterminateCheckBoxRounded":false,"./IndeterminateCheckBoxSharp":false,"./IndeterminateCheckBoxTwoTone":false,"./Info":false,"./InfoOutlined":false,"./InfoRounded":false,"./InfoSharp":false,"./InfoTwoTone":false,"./Input":false,"./InputOutlined":false,"./InputRounded":false,"./InputSharp":false,"./InputTwoTone":false,"./InsertChart":false,"./InsertChartOutlined":false,"./InsertChartOutlinedOutlined":false,"./InsertChartOutlinedRounded":false,"./InsertChartOutlinedSharp":false,"./InsertChartOutlinedTwoTone":false,"./InsertChartRounded":false,"./InsertChartSharp":false,"./InsertChartTwoTone":false,"./InsertComment":false,"./InsertCommentOutlined":false,"./InsertCommentRounded":false,"./InsertCommentSharp":false,"./InsertCommentTwoTone":false,"./InsertDriveFile":false,"./InsertDriveFileOutlined":false,"./InsertDriveFileRounded":false,"./InsertDriveFileSharp":false,"./InsertDriveFileTwoTone":false,"./InsertEmoticon":false,"./InsertEmoticonOutlined":false,"./InsertEmoticonRounded":false,"./InsertEmoticonSharp":false,"./InsertEmoticonTwoTone":false,"./InsertInvitation":false,"./InsertInvitationOutlined":false,"./InsertInvitationRounded":false,"./InsertInvitationSharp":false,"./InsertInvitationTwoTone":false,"./InsertLink":false,"./InsertLinkOutlined":false,"./InsertLinkRounded":false,"./InsertLinkSharp":false,"./InsertLinkTwoTone":false,"./InsertPageBreak":false,"./InsertPageBreakOutlined":false,"./InsertPageBreakRounded":false,"./InsertPageBreakSharp":false,"./InsertPageBreakTwoTone":false,"./InsertPhoto":false,"./InsertPhotoOutlined":false,"./InsertPhotoRounded":false,"./InsertPhotoSharp":false,"./InsertPhotoTwoTone":false,"./Insights":false,"./InsightsOutlined":false,"./InsightsRounded":false,"./InsightsSharp":false,"./InsightsTwoTone":false,"./Instagram":false,"./InstallDesktop":false,"./InstallDesktopOutlined":false,"./InstallDesktopRounded":false,"./InstallDesktopSharp":false,"./InstallDesktopTwoTone":false,"./InstallMobile":false,"./InstallMobileOutlined":false,"./InstallMobileRounded":false,"./InstallMobileSharp":false,"./InstallMobileTwoTone":false,"./IntegrationInstructions":false,"./IntegrationInstructionsOutlined":false,"./IntegrationInstructionsRounded":false,"./IntegrationInstructionsSharp":false,"./IntegrationInstructionsTwoTone":false,"./Interests":false,"./InterestsOutlined":false,"./InterestsRounded":false,"./InterestsSharp":false,"./InterestsTwoTone":false,"./InterpreterMode":false,"./InterpreterModeOutlined":false,"./InterpreterModeRounded":false,"./InterpreterModeSharp":false,"./InterpreterModeTwoTone":false,"./Inventory":false,"./Inventory2":false,"./Inventory2Outlined":false,"./Inventory2Rounded":false,"./Inventory2Sharp":false,"./Inventory2TwoTone":false,"./InventoryOutlined":false,"./InventoryRounded":false,"./InventorySharp":false,"./InventoryTwoTone":false,"./InvertColors":false,"./InvertColorsOff":false,"./InvertColorsOffOutlined":false,"./InvertColorsOffRounded":false,"./InvertColorsOffSharp":false,"./InvertColorsOffTwoTone":false,"./InvertColorsOutlined":false,"./InvertColorsRounded":false,"./InvertColorsSharp":false,"./InvertColorsTwoTone":false,"./IosShare":false,"./IosShareOutlined":false,"./IosShareRounded":false,"./IosShareSharp":false,"./IosShareTwoTone":false,"./Iron":false,"./IronOutlined":false,"./IronRounded":false,"./IronSharp":false,"./IronTwoTone":false,"./Iso":false,"./IsoOutlined":false,"./IsoRounded":false,"./IsoSharp":false,"./IsoTwoTone":false,"./Javascript":false,"./JavascriptOutlined":false,"./JavascriptRounded":false,"./JavascriptSharp":false,"./JavascriptTwoTone":false,"./JoinFull":false,"./JoinFullOutlined":false,"./JoinFullRounded":false,"./JoinFullSharp":false,"./JoinFullTwoTone":false,"./JoinInner":false,"./JoinInnerOutlined":false,"./JoinInnerRounded":false,"./JoinInnerSharp":false,"./JoinInnerTwoTone":false,"./JoinLeft":false,"./JoinLeftOutlined":false,"./JoinLeftRounded":false,"./JoinLeftSharp":false,"./JoinLeftTwoTone":false,"./JoinRight":false,"./JoinRightOutlined":false,"./JoinRightRounded":false,"./JoinRightSharp":false,"./JoinRightTwoTone":false,"./Kayaking":false,"./KayakingOutlined":false,"./KayakingRounded":false,"./KayakingSharp":false,"./KayakingTwoTone":false,"./KebabDining":false,"./KebabDiningOutlined":false,"./KebabDiningRounded":false,"./KebabDiningSharp":false,"./KebabDiningTwoTone":false,"./Key":false,"./KeyOff":false,"./KeyOffOutlined":false,"./KeyOffRounded":false,"./KeyOffSharp":false,"./KeyOffTwoTone":false,"./KeyOutlined":false,"./KeyRounded":false,"./KeySharp":false,"./KeyTwoTone":false,"./Keyboard":false,"./KeyboardAlt":false,"./KeyboardAltOutlined":false,"./KeyboardAltRounded":false,"./KeyboardAltSharp":false,"./KeyboardAltTwoTone":false,"./KeyboardArrowDown":false,"./KeyboardArrowDownOutlined":false,"./KeyboardArrowDownRounded":false,"./KeyboardArrowDownSharp":false,"./KeyboardArrowDownTwoTone":false,"./KeyboardArrowLeft":false,"./KeyboardArrowLeftOutlined":false,"./KeyboardArrowLeftRounded":false,"./KeyboardArrowLeftSharp":false,"./KeyboardArrowLeftTwoTone":false,"./KeyboardArrowRight":false,"./KeyboardArrowRightOutlined":false,"./KeyboardArrowRightRounded":false,"./KeyboardArrowRightSharp":false,"./KeyboardArrowRightTwoTone":false,"./KeyboardArrowUp":false,"./KeyboardArrowUpOutlined":false,"./KeyboardArrowUpRounded":false,"./KeyboardArrowUpSharp":false,"./KeyboardArrowUpTwoTone":false,"./KeyboardBackspace":false,"./KeyboardBackspaceOutlined":false,"./KeyboardBackspaceRounded":false,"./KeyboardBackspaceSharp":false,"./KeyboardBackspaceTwoTone":false,"./KeyboardCapslock":false,"./KeyboardCapslockOutlined":false,"./KeyboardCapslockRounded":false,"./KeyboardCapslockSharp":false,"./KeyboardCapslockTwoTone":false,"./KeyboardCommandKey":false,"./KeyboardCommandKeyOutlined":false,"./KeyboardCommandKeyRounded":false,"./KeyboardCommandKeySharp":false,"./KeyboardCommandKeyTwoTone":false,"./KeyboardControlKey":false,"./KeyboardControlKeyOutlined":false,"./KeyboardControlKeyRounded":false,"./KeyboardControlKeySharp":false,"./KeyboardControlKeyTwoTone":false,"./KeyboardDoubleArrowDown":false,"./KeyboardDoubleArrowDownOutlined":false,"./KeyboardDoubleArrowDownRounded":false,"./KeyboardDoubleArrowDownSharp":false,"./KeyboardDoubleArrowDownTwoTone":false,"./KeyboardDoubleArrowLeft":false,"./KeyboardDoubleArrowLeftOutlined":false,"./KeyboardDoubleArrowLeftRounded":false,"./KeyboardDoubleArrowLeftSharp":false,"./KeyboardDoubleArrowLeftTwoTone":false,"./KeyboardDoubleArrowRight":false,"./KeyboardDoubleArrowRightOutlined":false,"./KeyboardDoubleArrowRightRounded":false,"./KeyboardDoubleArrowRightSharp":false,"./KeyboardDoubleArrowRightTwoTone":false,"./KeyboardDoubleArrowUp":false,"./KeyboardDoubleArrowUpOutlined":false,"./KeyboardDoubleArrowUpRounded":false,"./KeyboardDoubleArrowUpSharp":false,"./KeyboardDoubleArrowUpTwoTone":false,"./KeyboardHide":false,"./KeyboardHideOutlined":false,"./KeyboardHideRounded":false,"./KeyboardHideSharp":false,"./KeyboardHideTwoTone":false,"./KeyboardOptionKey":false,"./KeyboardOptionKeyOutlined":false,"./KeyboardOptionKeyRounded":false,"./KeyboardOptionKeySharp":false,"./KeyboardOptionKeyTwoTone":false,"./KeyboardOutlined":false,"./KeyboardReturn":false,"./KeyboardReturnOutlined":false,"./KeyboardReturnRounded":false,"./KeyboardReturnSharp":false,"./KeyboardReturnTwoTone":false,"./KeyboardRounded":false,"./KeyboardSharp":false,"./KeyboardTab":false,"./KeyboardTabOutlined":false,"./KeyboardTabRounded":false,"./KeyboardTabSharp":false,"./KeyboardTabTwoTone":false,"./KeyboardTwoTone":false,"./KeyboardVoice":false,"./KeyboardVoiceOutlined":false,"./KeyboardVoiceRounded":false,"./KeyboardVoiceSharp":false,"./KeyboardVoiceTwoTone":false,"./KingBed":false,"./KingBedOutlined":false,"./KingBedRounded":false,"./KingBedSharp":false,"./KingBedTwoTone":false,"./Kitchen":false,"./KitchenOutlined":false,"./KitchenRounded":false,"./KitchenSharp":false,"./KitchenTwoTone":false,"./Kitesurfing":false,"./KitesurfingOutlined":false,"./KitesurfingRounded":false,"./KitesurfingSharp":false,"./KitesurfingTwoTone":false,"./Label":false,"./LabelImportant":false,"./LabelImportantOutlined":false,"./LabelImportantRounded":false,"./LabelImportantSharp":false,"./LabelImportantTwoTone":false,"./LabelOff":false,"./LabelOffOutlined":false,"./LabelOffRounded":false,"./LabelOffSharp":false,"./LabelOffTwoTone":false,"./LabelOutlined":false,"./LabelRounded":false,"./LabelSharp":false,"./LabelTwoTone":false,"./Lan":false,"./LanOutlined":false,"./LanRounded":false,"./LanSharp":false,"./LanTwoTone":false,"./Landscape":false,"./LandscapeOutlined":false,"./LandscapeRounded":false,"./LandscapeSharp":false,"./LandscapeTwoTone":false,"./Landslide":false,"./LandslideOutlined":false,"./LandslideRounded":false,"./LandslideSharp":false,"./LandslideTwoTone":false,"./Language":false,"./LanguageOutlined":false,"./LanguageRounded":false,"./LanguageSharp":false,"./LanguageTwoTone":false,"./Laptop":false,"./LaptopChromebook":false,"./LaptopChromebookOutlined":false,"./LaptopChromebookRounded":false,"./LaptopChromebookSharp":false,"./LaptopChromebookTwoTone":false,"./LaptopMac":false,"./LaptopMacOutlined":false,"./LaptopMacRounded":false,"./LaptopMacSharp":false,"./LaptopMacTwoTone":false,"./LaptopOutlined":false,"./LaptopRounded":false,"./LaptopSharp":false,"./LaptopTwoTone":false,"./LaptopWindows":false,"./LaptopWindowsOutlined":false,"./LaptopWindowsRounded":false,"./LaptopWindowsSharp":false,"./LaptopWindowsTwoTone":false,"./LastPage":false,"./LastPageOutlined":false,"./LastPageRounded":false,"./LastPageSharp":false,"./LastPageTwoTone":false,"./Launch":false,"./LaunchOutlined":false,"./LaunchRounded":false,"./LaunchSharp":false,"./LaunchTwoTone":false,"./Layers":false,"./LayersClear":false,"./LayersClearOutlined":false,"./LayersClearRounded":false,"./LayersClearSharp":false,"./LayersClearTwoTone":false,"./LayersOutlined":false,"./LayersRounded":false,"./LayersSharp":false,"./LayersTwoTone":false,"./Leaderboard":false,"./LeaderboardOutlined":false,"./LeaderboardRounded":false,"./LeaderboardSharp":false,"./LeaderboardTwoTone":false,"./LeakAdd":false,"./LeakAddOutlined":false,"./LeakAddRounded":false,"./LeakAddSharp":false,"./LeakAddTwoTone":false,"./LeakRemove":false,"./LeakRemoveOutlined":false,"./LeakRemoveRounded":false,"./LeakRemoveSharp":false,"./LeakRemoveTwoTone":false,"./LegendToggle":false,"./LegendToggleOutlined":false,"./LegendToggleRounded":false,"./LegendToggleSharp":false,"./LegendToggleTwoTone":false,"./Lens":false,"./LensBlur":false,"./LensBlurOutlined":false,"./LensBlurRounded":false,"./LensBlurSharp":false,"./LensBlurTwoTone":false,"./LensOutlined":false,"./LensRounded":false,"./LensSharp":false,"./LensTwoTone":false,"./LibraryAdd":false,"./LibraryAddCheck":false,"./LibraryAddCheckOutlined":false,"./LibraryAddCheckRounded":false,"./LibraryAddCheckSharp":false,"./LibraryAddCheckTwoTone":false,"./LibraryAddOutlined":false,"./LibraryAddRounded":false,"./LibraryAddSharp":false,"./LibraryAddTwoTone":false,"./LibraryBooks":false,"./LibraryBooksOutlined":false,"./LibraryBooksRounded":false,"./LibraryBooksSharp":false,"./LibraryBooksTwoTone":false,"./LibraryMusic":false,"./LibraryMusicOutlined":false,"./LibraryMusicRounded":false,"./LibraryMusicSharp":false,"./LibraryMusicTwoTone":false,"./Light":false,"./LightMode":false,"./LightModeOutlined":false,"./LightModeRounded":false,"./LightModeSharp":false,"./LightModeTwoTone":false,"./LightOutlined":false,"./LightRounded":false,"./LightSharp":false,"./LightTwoTone":false,"./Lightbulb":false,"./LightbulbCircle":false,"./LightbulbCircleOutlined":false,"./LightbulbCircleRounded":false,"./LightbulbCircleSharp":false,"./LightbulbCircleTwoTone":false,"./LightbulbOutlined":false,"./LightbulbRounded":false,"./LightbulbSharp":false,"./LightbulbTwoTone":false,"./LineAxis":false,"./LineAxisOutlined":false,"./LineAxisRounded":false,"./LineAxisSharp":false,"./LineAxisTwoTone":false,"./LineStyle":false,"./LineStyleOutlined":false,"./LineStyleRounded":false,"./LineStyleSharp":false,"./LineStyleTwoTone":false,"./LineWeight":false,"./LineWeightOutlined":false,"./LineWeightRounded":false,"./LineWeightSharp":false,"./LineWeightTwoTone":false,"./LinearScale":false,"./LinearScaleOutlined":false,"./LinearScaleRounded":false,"./LinearScaleSharp":false,"./LinearScaleTwoTone":false,"./Link":false,"./LinkOff":false,"./LinkOffOutlined":false,"./LinkOffRounded":false,"./LinkOffSharp":false,"./LinkOffTwoTone":false,"./LinkOutlined":false,"./LinkRounded":false,"./LinkSharp":false,"./LinkTwoTone":false,"./LinkedCamera":false,"./LinkedCameraOutlined":false,"./LinkedCameraRounded":false,"./LinkedCameraSharp":false,"./LinkedCameraTwoTone":false,"./LinkedIn":false,"./Liquor":false,"./LiquorOutlined":false,"./LiquorRounded":false,"./LiquorSharp":false,"./LiquorTwoTone":false,"./List":false,"./ListAlt":false,"./ListAltOutlined":false,"./ListAltRounded":false,"./ListAltSharp":false,"./ListAltTwoTone":false,"./ListOutlined":false,"./ListRounded":false,"./ListSharp":false,"./ListTwoTone":false,"./LiveHelp":false,"./LiveHelpOutlined":false,"./LiveHelpRounded":false,"./LiveHelpSharp":false,"./LiveHelpTwoTone":false,"./LiveTv":false,"./LiveTvOutlined":false,"./LiveTvRounded":false,"./LiveTvSharp":false,"./LiveTvTwoTone":false,"./Living":false,"./LivingOutlined":false,"./LivingRounded":false,"./LivingSharp":false,"./LivingTwoTone":false,"./LocalActivity":false,"./LocalActivityOutlined":false,"./LocalActivityRounded":false,"./LocalActivitySharp":false,"./LocalActivityTwoTone":false,"./LocalAirport":false,"./LocalAirportOutlined":false,"./LocalAirportRounded":false,"./LocalAirportSharp":false,"./LocalAirportTwoTone":false,"./LocalAtm":false,"./LocalAtmOutlined":false,"./LocalAtmRounded":false,"./LocalAtmSharp":false,"./LocalAtmTwoTone":false,"./LocalBar":false,"./LocalBarOutlined":false,"./LocalBarRounded":false,"./LocalBarSharp":false,"./LocalBarTwoTone":false,"./LocalCafe":false,"./LocalCafeOutlined":false,"./LocalCafeRounded":false,"./LocalCafeSharp":false,"./LocalCafeTwoTone":false,"./LocalCarWash":false,"./LocalCarWashOutlined":false,"./LocalCarWashRounded":false,"./LocalCarWashSharp":false,"./LocalCarWashTwoTone":false,"./LocalConvenienceStore":false,"./LocalConvenienceStoreOutlined":false,"./LocalConvenienceStoreRounded":false,"./LocalConvenienceStoreSharp":false,"./LocalConvenienceStoreTwoTone":false,"./LocalDining":false,"./LocalDiningOutlined":false,"./LocalDiningRounded":false,"./LocalDiningSharp":false,"./LocalDiningTwoTone":false,"./LocalDrink":false,"./LocalDrinkOutlined":false,"./LocalDrinkRounded":false,"./LocalDrinkSharp":false,"./LocalDrinkTwoTone":false,"./LocalFireDepartment":false,"./LocalFireDepartmentOutlined":false,"./LocalFireDepartmentRounded":false,"./LocalFireDepartmentSharp":false,"./LocalFireDepartmentTwoTone":false,"./LocalFlorist":false,"./LocalFloristOutlined":false,"./LocalFloristRounded":false,"./LocalFloristSharp":false,"./LocalFloristTwoTone":false,"./LocalGasStation":false,"./LocalGasStationOutlined":false,"./LocalGasStationRounded":false,"./LocalGasStationSharp":false,"./LocalGasStationTwoTone":false,"./LocalGroceryStore":false,"./LocalGroceryStoreOutlined":false,"./LocalGroceryStoreRounded":false,"./LocalGroceryStoreSharp":false,"./LocalGroceryStoreTwoTone":false,"./LocalHospital":false,"./LocalHospitalOutlined":false,"./LocalHospitalRounded":false,"./LocalHospitalSharp":false,"./LocalHospitalTwoTone":false,"./LocalHotel":false,"./LocalHotelOutlined":false,"./LocalHotelRounded":false,"./LocalHotelSharp":false,"./LocalHotelTwoTone":false,"./LocalLaundryService":false,"./LocalLaundryServiceOutlined":false,"./LocalLaundryServiceRounded":false,"./LocalLaundryServiceSharp":false,"./LocalLaundryServiceTwoTone":false,"./LocalLibrary":false,"./LocalLibraryOutlined":false,"./LocalLibraryRounded":false,"./LocalLibrarySharp":false,"./LocalLibraryTwoTone":false,"./LocalMall":false,"./LocalMallOutlined":false,"./LocalMallRounded":false,"./LocalMallSharp":false,"./LocalMallTwoTone":false,"./LocalMovies":false,"./LocalMoviesOutlined":false,"./LocalMoviesRounded":false,"./LocalMoviesSharp":false,"./LocalMoviesTwoTone":false,"./LocalOffer":false,"./LocalOfferOutlined":false,"./LocalOfferRounded":false,"./LocalOfferSharp":false,"./LocalOfferTwoTone":false,"./LocalParking":false,"./LocalParkingOutlined":false,"./LocalParkingRounded":false,"./LocalParkingSharp":false,"./LocalParkingTwoTone":false,"./LocalPharmacy":false,"./LocalPharmacyOutlined":false,"./LocalPharmacyRounded":false,"./LocalPharmacySharp":false,"./LocalPharmacyTwoTone":false,"./LocalPhone":false,"./LocalPhoneOutlined":false,"./LocalPhoneRounded":false,"./LocalPhoneSharp":false,"./LocalPhoneTwoTone":false,"./LocalPizza":false,"./LocalPizzaOutlined":false,"./LocalPizzaRounded":false,"./LocalPizzaSharp":false,"./LocalPizzaTwoTone":false,"./LocalPlay":false,"./LocalPlayOutlined":false,"./LocalPlayRounded":false,"./LocalPlaySharp":false,"./LocalPlayTwoTone":false,"./LocalPolice":false,"./LocalPoliceOutlined":false,"./LocalPoliceRounded":false,"./LocalPoliceSharp":false,"./LocalPoliceTwoTone":false,"./LocalPostOffice":false,"./LocalPostOfficeOutlined":false,"./LocalPostOfficeRounded":false,"./LocalPostOfficeSharp":false,"./LocalPostOfficeTwoTone":false,"./LocalPrintshop":false,"./LocalPrintshopOutlined":false,"./LocalPrintshopRounded":false,"./LocalPrintshopSharp":false,"./LocalPrintshopTwoTone":false,"./LocalSee":false,"./LocalSeeOutlined":false,"./LocalSeeRounded":false,"./LocalSeeSharp":false,"./LocalSeeTwoTone":false,"./LocalShipping":false,"./LocalShippingOutlined":false,"./LocalShippingRounded":false,"./LocalShippingSharp":false,"./LocalShippingTwoTone":false,"./LocalTaxi":false,"./LocalTaxiOutlined":false,"./LocalTaxiRounded":false,"./LocalTaxiSharp":false,"./LocalTaxiTwoTone":false,"./LocationCity":false,"./LocationCityOutlined":false,"./LocationCityRounded":false,"./LocationCitySharp":false,"./LocationCityTwoTone":false,"./LocationDisabled":false,"./LocationDisabledOutlined":false,"./LocationDisabledRounded":false,"./LocationDisabledSharp":false,"./LocationDisabledTwoTone":false,"./LocationOff":false,"./LocationOffOutlined":false,"./LocationOffRounded":false,"./LocationOffSharp":false,"./LocationOffTwoTone":false,"./LocationOn":false,"./LocationOnOutlined":false,"./LocationOnRounded":false,"./LocationOnSharp":false,"./LocationOnTwoTone":false,"./LocationSearching":false,"./LocationSearchingOutlined":false,"./LocationSearchingRounded":false,"./LocationSearchingSharp":false,"./LocationSearchingTwoTone":false,"./Lock":false,"./LockClock":false,"./LockClockOutlined":false,"./LockClockRounded":false,"./LockClockSharp":false,"./LockClockTwoTone":false,"./LockOpen":false,"./LockOpenOutlined":false,"./LockOpenRounded":false,"./LockOpenSharp":false,"./LockOpenTwoTone":false,"./LockOutlined":false,"./LockPerson":false,"./LockPersonOutlined":false,"./LockPersonRounded":false,"./LockPersonSharp":false,"./LockPersonTwoTone":false,"./LockReset":false,"./LockResetOutlined":false,"./LockResetRounded":false,"./LockResetSharp":false,"./LockResetTwoTone":false,"./LockRounded":false,"./LockSharp":false,"./LockTwoTone":false,"./Login":false,"./LoginOutlined":false,"./LoginRounded":false,"./LoginSharp":false,"./LoginTwoTone":false,"./LogoDev":false,"./LogoDevOutlined":false,"./LogoDevRounded":false,"./LogoDevSharp":false,"./LogoDevTwoTone":false,"./Logout":"6cDAR","./LogoutOutlined":false,"./LogoutRounded":false,"./LogoutSharp":false,"./LogoutTwoTone":false,"./Looks":false,"./Looks3":false,"./Looks3Outlined":false,"./Looks3Rounded":false,"./Looks3Sharp":false,"./Looks3TwoTone":false,"./Looks4":false,"./Looks4Outlined":false,"./Looks4Rounded":false,"./Looks4Sharp":false,"./Looks4TwoTone":false,"./Looks5":false,"./Looks5Outlined":false,"./Looks5Rounded":false,"./Looks5Sharp":false,"./Looks5TwoTone":false,"./Looks6":false,"./Looks6Outlined":false,"./Looks6Rounded":false,"./Looks6Sharp":false,"./Looks6TwoTone":false,"./LooksOne":false,"./LooksOneOutlined":false,"./LooksOneRounded":false,"./LooksOneSharp":false,"./LooksOneTwoTone":false,"./LooksOutlined":false,"./LooksRounded":false,"./LooksSharp":false,"./LooksTwo":false,"./LooksTwoOutlined":false,"./LooksTwoRounded":false,"./LooksTwoSharp":false,"./LooksTwoTone":false,"./LooksTwoTwoTone":false,"./Loop":"g83B2","./LoopOutlined":false,"./LoopRounded":false,"./LoopSharp":false,"./LoopTwoTone":false,"./Loupe":false,"./LoupeOutlined":false,"./LoupeRounded":false,"./LoupeSharp":false,"./LoupeTwoTone":false,"./LowPriority":false,"./LowPriorityOutlined":false,"./LowPriorityRounded":false,"./LowPrioritySharp":false,"./LowPriorityTwoTone":false,"./Loyalty":false,"./LoyaltyOutlined":false,"./LoyaltyRounded":false,"./LoyaltySharp":false,"./LoyaltyTwoTone":false,"./LteMobiledata":false,"./LteMobiledataOutlined":false,"./LteMobiledataRounded":false,"./LteMobiledataSharp":false,"./LteMobiledataTwoTone":false,"./LtePlusMobiledata":false,"./LtePlusMobiledataOutlined":false,"./LtePlusMobiledataRounded":false,"./LtePlusMobiledataSharp":false,"./LtePlusMobiledataTwoTone":false,"./Luggage":false,"./LuggageOutlined":false,"./LuggageRounded":false,"./LuggageSharp":false,"./LuggageTwoTone":false,"./LunchDining":false,"./LunchDiningOutlined":false,"./LunchDiningRounded":false,"./LunchDiningSharp":false,"./LunchDiningTwoTone":false,"./Lyrics":false,"./LyricsOutlined":false,"./LyricsRounded":false,"./LyricsSharp":false,"./LyricsTwoTone":false,"./MacroOff":false,"./MacroOffOutlined":false,"./MacroOffRounded":false,"./MacroOffSharp":false,"./MacroOffTwoTone":false,"./Mail":false,"./MailLock":false,"./MailLockOutlined":false,"./MailLockRounded":false,"./MailLockSharp":false,"./MailLockTwoTone":false,"./MailOutline":false,"./MailOutlineOutlined":false,"./MailOutlineRounded":false,"./MailOutlineSharp":false,"./MailOutlineTwoTone":false,"./MailOutlined":false,"./MailRounded":false,"./MailSharp":false,"./MailTwoTone":false,"./Male":false,"./MaleOutlined":false,"./MaleRounded":false,"./MaleSharp":false,"./MaleTwoTone":false,"./Man":false,"./Man2":false,"./Man2Outlined":false,"./Man2Rounded":false,"./Man2Sharp":false,"./Man2TwoTone":false,"./Man3":false,"./Man3Outlined":false,"./Man3Rounded":false,"./Man3Sharp":false,"./Man3TwoTone":false,"./Man4":false,"./Man4Outlined":false,"./Man4Rounded":false,"./Man4Sharp":false,"./Man4TwoTone":false,"./ManOutlined":false,"./ManRounded":false,"./ManSharp":false,"./ManTwoTone":false,"./ManageAccounts":false,"./ManageAccountsOutlined":false,"./ManageAccountsRounded":false,"./ManageAccountsSharp":false,"./ManageAccountsTwoTone":false,"./ManageHistory":false,"./ManageHistoryOutlined":false,"./ManageHistoryRounded":false,"./ManageHistorySharp":false,"./ManageHistoryTwoTone":false,"./ManageSearch":false,"./ManageSearchOutlined":false,"./ManageSearchRounded":false,"./ManageSearchSharp":false,"./ManageSearchTwoTone":false,"./Map":false,"./MapOutlined":false,"./MapRounded":false,"./MapSharp":false,"./MapTwoTone":false,"./MapsHomeWork":false,"./MapsHomeWorkOutlined":false,"./MapsHomeWorkRounded":false,"./MapsHomeWorkSharp":false,"./MapsHomeWorkTwoTone":false,"./MapsUgc":false,"./MapsUgcOutlined":false,"./MapsUgcRounded":false,"./MapsUgcSharp":false,"./MapsUgcTwoTone":false,"./Margin":false,"./MarginOutlined":false,"./MarginRounded":false,"./MarginSharp":false,"./MarginTwoTone":false,"./MarkAsUnread":false,"./MarkAsUnreadOutlined":false,"./MarkAsUnreadRounded":false,"./MarkAsUnreadSharp":false,"./MarkAsUnreadTwoTone":false,"./MarkChatRead":false,"./MarkChatReadOutlined":false,"./MarkChatReadRounded":false,"./MarkChatReadSharp":false,"./MarkChatReadTwoTone":false,"./MarkChatUnread":false,"./MarkChatUnreadOutlined":false,"./MarkChatUnreadRounded":false,"./MarkChatUnreadSharp":false,"./MarkChatUnreadTwoTone":false,"./MarkEmailRead":false,"./MarkEmailReadOutlined":false,"./MarkEmailReadRounded":false,"./MarkEmailReadSharp":false,"./MarkEmailReadTwoTone":false,"./MarkEmailUnread":false,"./MarkEmailUnreadOutlined":false,"./MarkEmailUnreadRounded":false,"./MarkEmailUnreadSharp":false,"./MarkEmailUnreadTwoTone":false,"./MarkUnreadChatAlt":false,"./MarkUnreadChatAltOutlined":false,"./MarkUnreadChatAltRounded":false,"./MarkUnreadChatAltSharp":false,"./MarkUnreadChatAltTwoTone":false,"./Markunread":false,"./MarkunreadMailbox":false,"./MarkunreadMailboxOutlined":false,"./MarkunreadMailboxRounded":false,"./MarkunreadMailboxSharp":false,"./MarkunreadMailboxTwoTone":false,"./MarkunreadOutlined":false,"./MarkunreadRounded":false,"./MarkunreadSharp":false,"./MarkunreadTwoTone":false,"./Masks":false,"./MasksOutlined":false,"./MasksRounded":false,"./MasksSharp":false,"./MasksTwoTone":false,"./Maximize":false,"./MaximizeOutlined":false,"./MaximizeRounded":false,"./MaximizeSharp":false,"./MaximizeTwoTone":false,"./MediaBluetoothOff":false,"./MediaBluetoothOffOutlined":false,"./MediaBluetoothOffRounded":false,"./MediaBluetoothOffSharp":false,"./MediaBluetoothOffTwoTone":false,"./MediaBluetoothOn":false,"./MediaBluetoothOnOutlined":false,"./MediaBluetoothOnRounded":false,"./MediaBluetoothOnSharp":false,"./MediaBluetoothOnTwoTone":false,"./Mediation":false,"./MediationOutlined":false,"./MediationRounded":false,"./MediationSharp":false,"./MediationTwoTone":false,"./MedicalInformation":false,"./MedicalInformationOutlined":false,"./MedicalInformationRounded":false,"./MedicalInformationSharp":false,"./MedicalInformationTwoTone":false,"./MedicalServices":false,"./MedicalServicesOutlined":false,"./MedicalServicesRounded":false,"./MedicalServicesSharp":false,"./MedicalServicesTwoTone":false,"./Medication":false,"./MedicationLiquid":false,"./MedicationLiquidOutlined":false,"./MedicationLiquidRounded":false,"./MedicationLiquidSharp":false,"./MedicationLiquidTwoTone":false,"./MedicationOutlined":false,"./MedicationRounded":false,"./MedicationSharp":false,"./MedicationTwoTone":false,"./MeetingRoom":false,"./MeetingRoomOutlined":false,"./MeetingRoomRounded":false,"./MeetingRoomSharp":false,"./MeetingRoomTwoTone":false,"./Memory":false,"./MemoryOutlined":false,"./MemoryRounded":false,"./MemorySharp":false,"./MemoryTwoTone":false,"./Menu":"g5ZCU","./MenuBook":false,"./MenuBookOutlined":false,"./MenuBookRounded":false,"./MenuBookSharp":false,"./MenuBookTwoTone":false,"./MenuOpen":false,"./MenuOpenOutlined":false,"./MenuOpenRounded":false,"./MenuOpenSharp":false,"./MenuOpenTwoTone":false,"./MenuOutlined":false,"./MenuRounded":false,"./MenuSharp":false,"./MenuTwoTone":false,"./Merge":false,"./MergeOutlined":false,"./MergeRounded":false,"./MergeSharp":false,"./MergeTwoTone":false,"./MergeType":false,"./MergeTypeOutlined":false,"./MergeTypeRounded":false,"./MergeTypeSharp":false,"./MergeTypeTwoTone":false,"./Message":false,"./MessageOutlined":false,"./MessageRounded":false,"./MessageSharp":false,"./MessageTwoTone":false,"./Mic":false,"./MicExternalOff":false,"./MicExternalOffOutlined":false,"./MicExternalOffRounded":false,"./MicExternalOffSharp":false,"./MicExternalOffTwoTone":false,"./MicExternalOn":false,"./MicExternalOnOutlined":false,"./MicExternalOnRounded":false,"./MicExternalOnSharp":false,"./MicExternalOnTwoTone":false,"./MicNone":false,"./MicNoneOutlined":false,"./MicNoneRounded":false,"./MicNoneSharp":false,"./MicNoneTwoTone":false,"./MicOff":false,"./MicOffOutlined":false,"./MicOffRounded":false,"./MicOffSharp":false,"./MicOffTwoTone":false,"./MicOutlined":false,"./MicRounded":false,"./MicSharp":false,"./MicTwoTone":false,"./Microsoft":false,"./Microwave":false,"./MicrowaveOutlined":false,"./MicrowaveRounded":false,"./MicrowaveSharp":false,"./MicrowaveTwoTone":false,"./MilitaryTech":false,"./MilitaryTechOutlined":false,"./MilitaryTechRounded":false,"./MilitaryTechSharp":false,"./MilitaryTechTwoTone":false,"./Minimize":false,"./MinimizeOutlined":false,"./MinimizeRounded":false,"./MinimizeSharp":false,"./MinimizeTwoTone":false,"./MinorCrash":false,"./MinorCrashOutlined":false,"./MinorCrashRounded":false,"./MinorCrashSharp":false,"./MinorCrashTwoTone":false,"./MiscellaneousServices":false,"./MiscellaneousServicesOutlined":false,"./MiscellaneousServicesRounded":false,"./MiscellaneousServicesSharp":false,"./MiscellaneousServicesTwoTone":false,"./MissedVideoCall":false,"./MissedVideoCallOutlined":false,"./MissedVideoCallRounded":false,"./MissedVideoCallSharp":false,"./MissedVideoCallTwoTone":false,"./Mms":false,"./MmsOutlined":false,"./MmsRounded":false,"./MmsSharp":false,"./MmsTwoTone":false,"./MobileFriendly":false,"./MobileFriendlyOutlined":false,"./MobileFriendlyRounded":false,"./MobileFriendlySharp":false,"./MobileFriendlyTwoTone":false,"./MobileOff":false,"./MobileOffOutlined":false,"./MobileOffRounded":false,"./MobileOffSharp":false,"./MobileOffTwoTone":false,"./MobileScreenShare":false,"./MobileScreenShareOutlined":false,"./MobileScreenShareRounded":false,"./MobileScreenShareSharp":false,"./MobileScreenShareTwoTone":false,"./MobiledataOff":false,"./MobiledataOffOutlined":false,"./MobiledataOffRounded":false,"./MobiledataOffSharp":false,"./MobiledataOffTwoTone":false,"./Mode":false,"./ModeComment":false,"./ModeCommentOutlined":false,"./ModeCommentRounded":false,"./ModeCommentSharp":false,"./ModeCommentTwoTone":false,"./ModeEdit":false,"./ModeEditOutline":false,"./ModeEditOutlineOutlined":false,"./ModeEditOutlineRounded":false,"./ModeEditOutlineSharp":false,"./ModeEditOutlineTwoTone":false,"./ModeEditOutlined":false,"./ModeEditRounded":false,"./ModeEditSharp":false,"./ModeEditTwoTone":false,"./ModeFanOff":false,"./ModeFanOffOutlined":false,"./ModeFanOffRounded":false,"./ModeFanOffSharp":false,"./ModeFanOffTwoTone":false,"./ModeNight":false,"./ModeNightOutlined":false,"./ModeNightRounded":false,"./ModeNightSharp":false,"./ModeNightTwoTone":false,"./ModeOfTravel":false,"./ModeOfTravelOutlined":false,"./ModeOfTravelRounded":false,"./ModeOfTravelSharp":false,"./ModeOfTravelTwoTone":false,"./ModeOutlined":false,"./ModeRounded":false,"./ModeSharp":false,"./ModeStandby":false,"./ModeStandbyOutlined":false,"./ModeStandbyRounded":false,"./ModeStandbySharp":false,"./ModeStandbyTwoTone":false,"./ModeTwoTone":false,"./ModelTraining":false,"./ModelTrainingOutlined":false,"./ModelTrainingRounded":false,"./ModelTrainingSharp":false,"./ModelTrainingTwoTone":false,"./MonetizationOn":false,"./MonetizationOnOutlined":false,"./MonetizationOnRounded":false,"./MonetizationOnSharp":false,"./MonetizationOnTwoTone":false,"./Money":false,"./MoneyOff":false,"./MoneyOffCsred":false,"./MoneyOffCsredOutlined":false,"./MoneyOffCsredRounded":false,"./MoneyOffCsredSharp":false,"./MoneyOffCsredTwoTone":false,"./MoneyOffOutlined":false,"./MoneyOffRounded":false,"./MoneyOffSharp":false,"./MoneyOffTwoTone":false,"./MoneyOutlined":false,"./MoneyRounded":false,"./MoneySharp":false,"./MoneyTwoTone":false,"./Monitor":false,"./MonitorHeart":false,"./MonitorHeartOutlined":false,"./MonitorHeartRounded":false,"./MonitorHeartSharp":false,"./MonitorHeartTwoTone":false,"./MonitorOutlined":false,"./MonitorRounded":false,"./MonitorSharp":false,"./MonitorTwoTone":false,"./MonitorWeight":false,"./MonitorWeightOutlined":false,"./MonitorWeightRounded":false,"./MonitorWeightSharp":false,"./MonitorWeightTwoTone":false,"./MonochromePhotos":false,"./MonochromePhotosOutlined":false,"./MonochromePhotosRounded":false,"./MonochromePhotosSharp":false,"./MonochromePhotosTwoTone":false,"./Mood":false,"./MoodBad":false,"./MoodBadOutlined":false,"./MoodBadRounded":false,"./MoodBadSharp":false,"./MoodBadTwoTone":false,"./MoodOutlined":false,"./MoodRounded":false,"./MoodSharp":false,"./MoodTwoTone":false,"./Moped":false,"./MopedOutlined":false,"./MopedRounded":false,"./MopedSharp":false,"./MopedTwoTone":false,"./More":false,"./MoreHoriz":false,"./MoreHorizOutlined":false,"./MoreHorizRounded":false,"./MoreHorizSharp":false,"./MoreHorizTwoTone":false,"./MoreOutlined":false,"./MoreRounded":false,"./MoreSharp":false,"./MoreTime":false,"./MoreTimeOutlined":false,"./MoreTimeRounded":false,"./MoreTimeSharp":false,"./MoreTimeTwoTone":false,"./MoreTwoTone":false,"./MoreVert":false,"./MoreVertOutlined":false,"./MoreVertRounded":false,"./MoreVertSharp":false,"./MoreVertTwoTone":false,"./Mosque":false,"./MosqueOutlined":false,"./MosqueRounded":false,"./MosqueSharp":false,"./MosqueTwoTone":false,"./MotionPhotosAuto":false,"./MotionPhotosAutoOutlined":false,"./MotionPhotosAutoRounded":false,"./MotionPhotosAutoSharp":false,"./MotionPhotosAutoTwoTone":false,"./MotionPhotosOff":false,"./MotionPhotosOffOutlined":false,"./MotionPhotosOffRounded":false,"./MotionPhotosOffSharp":false,"./MotionPhotosOffTwoTone":false,"./Mouse":false,"./MouseOutlined":false,"./MouseRounded":false,"./MouseSharp":false,"./MouseTwoTone":false,"./MoveDown":false,"./MoveDownOutlined":false,"./MoveDownRounded":false,"./MoveDownSharp":false,"./MoveDownTwoTone":false,"./MoveToInbox":false,"./MoveToInboxOutlined":false,"./MoveToInboxRounded":false,"./MoveToInboxSharp":false,"./MoveToInboxTwoTone":false,"./MoveUp":false,"./MoveUpOutlined":false,"./MoveUpRounded":false,"./MoveUpSharp":false,"./MoveUpTwoTone":false,"./Movie":false,"./MovieCreation":false,"./MovieCreationOutlined":false,"./MovieCreationRounded":false,"./MovieCreationSharp":false,"./MovieCreationTwoTone":false,"./MovieFilter":false,"./MovieFilterOutlined":false,"./MovieFilterRounded":false,"./MovieFilterSharp":false,"./MovieFilterTwoTone":false,"./MovieOutlined":false,"./MovieRounded":false,"./MovieSharp":false,"./MovieTwoTone":false,"./Moving":false,"./MovingOutlined":false,"./MovingRounded":false,"./MovingSharp":false,"./MovingTwoTone":false,"./Mp":false,"./MpOutlined":false,"./MpRounded":false,"./MpSharp":false,"./MpTwoTone":false,"./MultilineChart":false,"./MultilineChartOutlined":false,"./MultilineChartRounded":false,"./MultilineChartSharp":false,"./MultilineChartTwoTone":false,"./MultipleStop":false,"./MultipleStopOutlined":false,"./MultipleStopRounded":false,"./MultipleStopSharp":false,"./MultipleStopTwoTone":false,"./Museum":false,"./MuseumOutlined":false,"./MuseumRounded":false,"./MuseumSharp":false,"./MuseumTwoTone":false,"./MusicNote":false,"./MusicNoteOutlined":false,"./MusicNoteRounded":false,"./MusicNoteSharp":false,"./MusicNoteTwoTone":false,"./MusicOff":false,"./MusicOffOutlined":false,"./MusicOffRounded":false,"./MusicOffSharp":false,"./MusicOffTwoTone":false,"./MusicVideo":false,"./MusicVideoOutlined":false,"./MusicVideoRounded":false,"./MusicVideoSharp":false,"./MusicVideoTwoTone":false,"./MyLocation":false,"./MyLocationOutlined":false,"./MyLocationRounded":false,"./MyLocationSharp":false,"./MyLocationTwoTone":false,"./Nat":false,"./NatOutlined":false,"./NatRounded":false,"./NatSharp":false,"./NatTwoTone":false,"./Nature":false,"./NatureOutlined":false,"./NaturePeople":false,"./NaturePeopleOutlined":false,"./NaturePeopleRounded":false,"./NaturePeopleSharp":false,"./NaturePeopleTwoTone":false,"./NatureRounded":false,"./NatureSharp":false,"./NatureTwoTone":false,"./NavigateBefore":false,"./NavigateBeforeOutlined":false,"./NavigateBeforeRounded":false,"./NavigateBeforeSharp":false,"./NavigateBeforeTwoTone":false,"./NavigateNext":false,"./NavigateNextOutlined":false,"./NavigateNextRounded":false,"./NavigateNextSharp":false,"./NavigateNextTwoTone":false,"./Navigation":false,"./NavigationOutlined":false,"./NavigationRounded":false,"./NavigationSharp":false,"./NavigationTwoTone":false,"./NearMe":false,"./NearMeDisabled":false,"./NearMeDisabledOutlined":false,"./NearMeDisabledRounded":false,"./NearMeDisabledSharp":false,"./NearMeDisabledTwoTone":false,"./NearMeOutlined":false,"./NearMeRounded":false,"./NearMeSharp":false,"./NearMeTwoTone":false,"./NearbyError":false,"./NearbyErrorOutlined":false,"./NearbyErrorRounded":false,"./NearbyErrorSharp":false,"./NearbyErrorTwoTone":false,"./NearbyOff":false,"./NearbyOffOutlined":false,"./NearbyOffRounded":false,"./NearbyOffSharp":false,"./NearbyOffTwoTone":false,"./NestCamWiredStand":false,"./NestCamWiredStandOutlined":false,"./NestCamWiredStandRounded":false,"./NestCamWiredStandSharp":false,"./NestCamWiredStandTwoTone":false,"./NetworkCell":false,"./NetworkCellOutlined":false,"./NetworkCellRounded":false,"./NetworkCellSharp":false,"./NetworkCellTwoTone":false,"./NetworkCheck":false,"./NetworkCheckOutlined":false,"./NetworkCheckRounded":false,"./NetworkCheckSharp":false,"./NetworkCheckTwoTone":false,"./NetworkLocked":false,"./NetworkLockedOutlined":false,"./NetworkLockedRounded":false,"./NetworkLockedSharp":false,"./NetworkLockedTwoTone":false,"./NetworkPing":false,"./NetworkPingOutlined":false,"./NetworkPingRounded":false,"./NetworkPingSharp":false,"./NetworkPingTwoTone":false,"./NetworkWifi":false,"./NetworkWifi1Bar":false,"./NetworkWifi1BarOutlined":false,"./NetworkWifi1BarRounded":false,"./NetworkWifi1BarSharp":false,"./NetworkWifi1BarTwoTone":false,"./NetworkWifi2Bar":false,"./NetworkWifi2BarOutlined":false,"./NetworkWifi2BarRounded":false,"./NetworkWifi2BarSharp":false,"./NetworkWifi2BarTwoTone":false,"./NetworkWifi3Bar":false,"./NetworkWifi3BarOutlined":false,"./NetworkWifi3BarRounded":false,"./NetworkWifi3BarSharp":false,"./NetworkWifi3BarTwoTone":false,"./NetworkWifiOutlined":false,"./NetworkWifiRounded":false,"./NetworkWifiSharp":false,"./NetworkWifiTwoTone":false,"./NewReleases":false,"./NewReleasesOutlined":false,"./NewReleasesRounded":false,"./NewReleasesSharp":false,"./NewReleasesTwoTone":false,"./Newspaper":false,"./NewspaperOutlined":false,"./NewspaperRounded":false,"./NewspaperSharp":false,"./NewspaperTwoTone":false,"./NextPlan":false,"./NextPlanOutlined":false,"./NextPlanRounded":false,"./NextPlanSharp":false,"./NextPlanTwoTone":false,"./NextWeek":false,"./NextWeekOutlined":false,"./NextWeekRounded":false,"./NextWeekSharp":false,"./NextWeekTwoTone":false,"./Nfc":false,"./NfcOutlined":false,"./NfcRounded":false,"./NfcSharp":false,"./NfcTwoTone":false,"./NightShelter":false,"./NightShelterOutlined":false,"./NightShelterRounded":false,"./NightShelterSharp":false,"./NightShelterTwoTone":false,"./Nightlife":false,"./NightlifeOutlined":false,"./NightlifeRounded":false,"./NightlifeSharp":false,"./NightlifeTwoTone":false,"./Nightlight":false,"./NightlightOutlined":false,"./NightlightRound":false,"./NightlightRoundOutlined":false,"./NightlightRoundRounded":false,"./NightlightRoundSharp":false,"./NightlightRoundTwoTone":false,"./NightlightRounded":false,"./NightlightSharp":false,"./NightlightTwoTone":false,"./NightsStay":false,"./NightsStayOutlined":false,"./NightsStayRounded":false,"./NightsStaySharp":false,"./NightsStayTwoTone":false,"./NineK":false,"./NineKOutlined":false,"./NineKPlus":false,"./NineKPlusOutlined":false,"./NineKPlusRounded":false,"./NineKPlusSharp":false,"./NineKPlusTwoTone":false,"./NineKRounded":false,"./NineKSharp":false,"./NineKTwoTone":false,"./NineMp":false,"./NineMpOutlined":false,"./NineMpRounded":false,"./NineMpSharp":false,"./NineMpTwoTone":false,"./NineteenMp":false,"./NineteenMpOutlined":false,"./NineteenMpRounded":false,"./NineteenMpSharp":false,"./NineteenMpTwoTone":false,"./NoAccounts":false,"./NoAccountsOutlined":false,"./NoAccountsRounded":false,"./NoAccountsSharp":false,"./NoAccountsTwoTone":false,"./NoAdultContent":false,"./NoAdultContentOutlined":false,"./NoAdultContentRounded":false,"./NoAdultContentSharp":false,"./NoAdultContentTwoTone":false,"./NoBackpack":false,"./NoBackpackOutlined":false,"./NoBackpackRounded":false,"./NoBackpackSharp":false,"./NoBackpackTwoTone":false,"./NoCell":false,"./NoCellOutlined":false,"./NoCellRounded":false,"./NoCellSharp":false,"./NoCellTwoTone":false,"./NoCrash":false,"./NoCrashOutlined":false,"./NoCrashRounded":false,"./NoCrashSharp":false,"./NoCrashTwoTone":false,"./NoDrinks":false,"./NoDrinksOutlined":false,"./NoDrinksRounded":false,"./NoDrinksSharp":false,"./NoDrinksTwoTone":false,"./NoEncryption":false,"./NoEncryptionGmailerrorred":false,"./NoEncryptionGmailerrorredOutlined":false,"./NoEncryptionGmailerrorredRounded":false,"./NoEncryptionGmailerrorredSharp":false,"./NoEncryptionGmailerrorredTwoTone":false,"./NoEncryptionOutlined":false,"./NoEncryptionRounded":false,"./NoEncryptionSharp":false,"./NoEncryptionTwoTone":false,"./NoFlash":false,"./NoFlashOutlined":false,"./NoFlashRounded":false,"./NoFlashSharp":false,"./NoFlashTwoTone":false,"./NoFood":false,"./NoFoodOutlined":false,"./NoFoodRounded":false,"./NoFoodSharp":false,"./NoFoodTwoTone":false,"./NoLuggage":false,"./NoLuggageOutlined":false,"./NoLuggageRounded":false,"./NoLuggageSharp":false,"./NoLuggageTwoTone":false,"./NoMeals":false,"./NoMealsOutlined":false,"./NoMealsRounded":false,"./NoMealsSharp":false,"./NoMealsTwoTone":false,"./NoMeetingRoom":false,"./NoMeetingRoomOutlined":false,"./NoMeetingRoomRounded":false,"./NoMeetingRoomSharp":false,"./NoMeetingRoomTwoTone":false,"./NoPhotography":false,"./NoPhotographyOutlined":false,"./NoPhotographyRounded":false,"./NoPhotographySharp":false,"./NoPhotographyTwoTone":false,"./NoSim":false,"./NoSimOutlined":false,"./NoSimRounded":false,"./NoSimSharp":false,"./NoSimTwoTone":false,"./NoStroller":false,"./NoStrollerOutlined":false,"./NoStrollerRounded":false,"./NoStrollerSharp":false,"./NoStrollerTwoTone":false,"./NoTransfer":false,"./NoTransferOutlined":false,"./NoTransferRounded":false,"./NoTransferSharp":false,"./NoTransferTwoTone":false,"./NoiseAware":false,"./NoiseAwareOutlined":false,"./NoiseAwareRounded":false,"./NoiseAwareSharp":false,"./NoiseAwareTwoTone":false,"./NoiseControlOff":false,"./NoiseControlOffOutlined":false,"./NoiseControlOffRounded":false,"./NoiseControlOffSharp":false,"./NoiseControlOffTwoTone":false,"./NordicWalking":false,"./NordicWalkingOutlined":false,"./NordicWalkingRounded":false,"./NordicWalkingSharp":false,"./NordicWalkingTwoTone":false,"./North":false,"./NorthEast":false,"./NorthEastOutlined":false,"./NorthEastRounded":false,"./NorthEastSharp":false,"./NorthEastTwoTone":false,"./NorthOutlined":false,"./NorthRounded":false,"./NorthSharp":false,"./NorthTwoTone":false,"./NorthWest":false,"./NorthWestOutlined":false,"./NorthWestRounded":false,"./NorthWestSharp":false,"./NorthWestTwoTone":false,"./NotAccessible":false,"./NotAccessibleOutlined":false,"./NotAccessibleRounded":false,"./NotAccessibleSharp":false,"./NotAccessibleTwoTone":false,"./NotInterested":false,"./NotInterestedOutlined":false,"./NotInterestedRounded":false,"./NotInterestedSharp":false,"./NotInterestedTwoTone":false,"./NotListedLocation":false,"./NotListedLocationOutlined":false,"./NotListedLocationRounded":false,"./NotListedLocationSharp":false,"./NotListedLocationTwoTone":false,"./NotStarted":false,"./NotStartedOutlined":false,"./NotStartedRounded":false,"./NotStartedSharp":false,"./NotStartedTwoTone":false,"./Note":false,"./NoteAdd":false,"./NoteAddOutlined":false,"./NoteAddRounded":false,"./NoteAddSharp":false,"./NoteAddTwoTone":false,"./NoteAlt":false,"./NoteAltOutlined":false,"./NoteAltRounded":false,"./NoteAltSharp":false,"./NoteAltTwoTone":false,"./NoteOutlined":false,"./NoteRounded":false,"./NoteSharp":false,"./NoteTwoTone":false,"./Notes":false,"./NotesOutlined":false,"./NotesRounded":false,"./NotesSharp":false,"./NotesTwoTone":false,"./NotificationAdd":false,"./NotificationAddOutlined":false,"./NotificationAddRounded":false,"./NotificationAddSharp":false,"./NotificationAddTwoTone":false,"./NotificationImportant":false,"./NotificationImportantOutlined":false,"./NotificationImportantRounded":false,"./NotificationImportantSharp":false,"./NotificationImportantTwoTone":false,"./Notifications":false,"./NotificationsActive":false,"./NotificationsActiveOutlined":false,"./NotificationsActiveRounded":false,"./NotificationsActiveSharp":false,"./NotificationsActiveTwoTone":false,"./NotificationsNone":false,"./NotificationsNoneOutlined":false,"./NotificationsNoneRounded":false,"./NotificationsNoneSharp":false,"./NotificationsNoneTwoTone":false,"./NotificationsOff":false,"./NotificationsOffOutlined":false,"./NotificationsOffRounded":false,"./NotificationsOffSharp":false,"./NotificationsOffTwoTone":false,"./NotificationsOutlined":false,"./NotificationsPaused":false,"./NotificationsPausedOutlined":false,"./NotificationsPausedRounded":false,"./NotificationsPausedSharp":false,"./NotificationsPausedTwoTone":false,"./NotificationsRounded":false,"./NotificationsSharp":false,"./NotificationsTwoTone":false,"./Numbers":false,"./NumbersOutlined":false,"./NumbersRounded":false,"./NumbersSharp":false,"./NumbersTwoTone":false,"./OfflineBolt":false,"./OfflineBoltOutlined":false,"./OfflineBoltRounded":false,"./OfflineBoltSharp":false,"./OfflineBoltTwoTone":false,"./OfflinePin":false,"./OfflinePinOutlined":false,"./OfflinePinRounded":false,"./OfflinePinSharp":false,"./OfflinePinTwoTone":false,"./OfflineShare":false,"./OfflineShareOutlined":false,"./OfflineShareRounded":false,"./OfflineShareSharp":false,"./OfflineShareTwoTone":false,"./OilBarrel":false,"./OilBarrelOutlined":false,"./OilBarrelRounded":false,"./OilBarrelSharp":false,"./OilBarrelTwoTone":false,"./OnDeviceTraining":false,"./OnDeviceTrainingOutlined":false,"./OnDeviceTrainingRounded":false,"./OnDeviceTrainingSharp":false,"./OnDeviceTrainingTwoTone":false,"./OndemandVideo":false,"./OndemandVideoOutlined":false,"./OndemandVideoRounded":false,"./OndemandVideoSharp":false,"./OndemandVideoTwoTone":false,"./OneK":false,"./OneKOutlined":false,"./OneKPlus":false,"./OneKPlusOutlined":false,"./OneKPlusRounded":false,"./OneKPlusSharp":false,"./OneKPlusTwoTone":false,"./OneKRounded":false,"./OneKSharp":false,"./OneKTwoTone":false,"./OneKk":false,"./OneKkOutlined":false,"./OneKkRounded":false,"./OneKkSharp":false,"./OneKkTwoTone":false,"./OnlinePrediction":false,"./OnlinePredictionOutlined":false,"./OnlinePredictionRounded":false,"./OnlinePredictionSharp":false,"./OnlinePredictionTwoTone":false,"./Opacity":false,"./OpacityOutlined":false,"./OpacityRounded":false,"./OpacitySharp":false,"./OpacityTwoTone":false,"./OpenInBrowser":false,"./OpenInBrowserOutlined":false,"./OpenInBrowserRounded":false,"./OpenInBrowserSharp":false,"./OpenInBrowserTwoTone":false,"./OpenInFull":false,"./OpenInFullOutlined":false,"./OpenInFullRounded":false,"./OpenInFullSharp":false,"./OpenInFullTwoTone":false,"./OpenInNew":"ijXDC","./OpenInNewOff":false,"./OpenInNewOffOutlined":false,"./OpenInNewOffRounded":false,"./OpenInNewOffSharp":false,"./OpenInNewOffTwoTone":false,"./OpenInNewOutlined":false,"./OpenInNewRounded":false,"./OpenInNewSharp":false,"./OpenInNewTwoTone":false,"./OpenWith":false,"./OpenWithOutlined":false,"./OpenWithRounded":false,"./OpenWithSharp":false,"./OpenWithTwoTone":false,"./OtherHouses":false,"./OtherHousesOutlined":false,"./OtherHousesRounded":false,"./OtherHousesSharp":false,"./OtherHousesTwoTone":false,"./Outbound":false,"./OutboundOutlined":false,"./OutboundRounded":false,"./OutboundSharp":false,"./OutboundTwoTone":false,"./Outbox":false,"./OutboxOutlined":false,"./OutboxRounded":false,"./OutboxSharp":false,"./OutboxTwoTone":false,"./OutdoorGrill":false,"./OutdoorGrillOutlined":false,"./OutdoorGrillRounded":false,"./OutdoorGrillSharp":false,"./OutdoorGrillTwoTone":false,"./Outlet":false,"./OutletOutlined":false,"./OutletRounded":false,"./OutletSharp":false,"./OutletTwoTone":false,"./OutlinedFlag":false,"./OutlinedFlagOutlined":false,"./OutlinedFlagRounded":false,"./OutlinedFlagSharp":false,"./OutlinedFlagTwoTone":false,"./Output":false,"./OutputOutlined":false,"./OutputRounded":false,"./OutputSharp":false,"./OutputTwoTone":false,"./Padding":false,"./PaddingOutlined":false,"./PaddingRounded":false,"./PaddingSharp":false,"./PaddingTwoTone":false,"./Pages":false,"./PagesOutlined":false,"./PagesRounded":false,"./PagesSharp":false,"./PagesTwoTone":false,"./Pageview":false,"./PageviewOutlined":false,"./PageviewRounded":false,"./PageviewSharp":false,"./PageviewTwoTone":false,"./Paid":false,"./PaidOutlined":false,"./PaidRounded":false,"./PaidSharp":false,"./PaidTwoTone":false,"./Palette":false,"./PaletteOutlined":false,"./PaletteRounded":false,"./PaletteSharp":false,"./PaletteTwoTone":false,"./PanTool":false,"./PanToolAlt":false,"./PanToolAltOutlined":false,"./PanToolAltRounded":false,"./PanToolAltSharp":false,"./PanToolAltTwoTone":false,"./PanToolOutlined":false,"./PanToolRounded":false,"./PanToolSharp":false,"./PanToolTwoTone":false,"./Panorama":false,"./PanoramaFishEye":false,"./PanoramaFishEyeOutlined":false,"./PanoramaFishEyeRounded":false,"./PanoramaFishEyeSharp":false,"./PanoramaFishEyeTwoTone":false,"./PanoramaHorizontal":false,"./PanoramaHorizontalOutlined":false,"./PanoramaHorizontalRounded":false,"./PanoramaHorizontalSelect":false,"./PanoramaHorizontalSelectOutlined":false,"./PanoramaHorizontalSelectRounded":false,"./PanoramaHorizontalSelectSharp":false,"./PanoramaHorizontalSelectTwoTone":false,"./PanoramaHorizontalSharp":false,"./PanoramaHorizontalTwoTone":false,"./PanoramaOutlined":false,"./PanoramaPhotosphere":false,"./PanoramaPhotosphereOutlined":false,"./PanoramaPhotosphereRounded":false,"./PanoramaPhotosphereSelect":false,"./PanoramaPhotosphereSelectOutlined":false,"./PanoramaPhotosphereSelectRounded":false,"./PanoramaPhotosphereSelectSharp":false,"./PanoramaPhotosphereSelectTwoTone":false,"./PanoramaPhotosphereSharp":false,"./PanoramaPhotosphereTwoTone":false,"./PanoramaRounded":false,"./PanoramaSharp":false,"./PanoramaTwoTone":false,"./PanoramaVertical":false,"./PanoramaVerticalOutlined":false,"./PanoramaVerticalRounded":false,"./PanoramaVerticalSelect":false,"./PanoramaVerticalSelectOutlined":false,"./PanoramaVerticalSelectRounded":false,"./PanoramaVerticalSelectSharp":false,"./PanoramaVerticalSelectTwoTone":false,"./PanoramaVerticalSharp":false,"./PanoramaVerticalTwoTone":false,"./PanoramaWideAngle":false,"./PanoramaWideAngleOutlined":false,"./PanoramaWideAngleRounded":false,"./PanoramaWideAngleSelect":false,"./PanoramaWideAngleSelectOutlined":false,"./PanoramaWideAngleSelectRounded":false,"./PanoramaWideAngleSelectSharp":false,"./PanoramaWideAngleSelectTwoTone":false,"./PanoramaWideAngleSharp":false,"./PanoramaWideAngleTwoTone":false,"./Paragliding":false,"./ParaglidingOutlined":false,"./ParaglidingRounded":false,"./ParaglidingSharp":false,"./ParaglidingTwoTone":false,"./Park":false,"./ParkOutlined":false,"./ParkRounded":false,"./ParkSharp":false,"./ParkTwoTone":false,"./PartyMode":false,"./PartyModeOutlined":false,"./PartyModeRounded":false,"./PartyModeSharp":false,"./PartyModeTwoTone":false,"./Password":false,"./PasswordOutlined":false,"./PasswordRounded":false,"./PasswordSharp":false,"./PasswordTwoTone":false,"./Pattern":false,"./PatternOutlined":false,"./PatternRounded":false,"./PatternSharp":false,"./PatternTwoTone":false,"./Pause":false,"./PauseCircle":false,"./PauseCircleFilled":false,"./PauseCircleFilledOutlined":false,"./PauseCircleFilledRounded":false,"./PauseCircleFilledSharp":false,"./PauseCircleFilledTwoTone":false,"./PauseCircleOutline":"jcTow","./PauseCircleOutlineOutlined":false,"./PauseCircleOutlineRounded":false,"./PauseCircleOutlineSharp":false,"./PauseCircleOutlineTwoTone":false,"./PauseCircleOutlined":false,"./PauseCircleRounded":false,"./PauseCircleSharp":false,"./PauseCircleTwoTone":false,"./PauseOutlined":false,"./PausePresentation":false,"./PausePresentationOutlined":false,"./PausePresentationRounded":false,"./PausePresentationSharp":false,"./PausePresentationTwoTone":false,"./PauseRounded":false,"./PauseSharp":false,"./PauseTwoTone":false,"./Payment":false,"./PaymentOutlined":false,"./PaymentRounded":false,"./PaymentSharp":false,"./PaymentTwoTone":false,"./Payments":false,"./PaymentsOutlined":false,"./PaymentsRounded":false,"./PaymentsSharp":false,"./PaymentsTwoTone":false,"./PedalBike":false,"./PedalBikeOutlined":false,"./PedalBikeRounded":false,"./PedalBikeSharp":false,"./PedalBikeTwoTone":false,"./Pending":false,"./PendingActions":false,"./PendingActionsOutlined":false,"./PendingActionsRounded":false,"./PendingActionsSharp":false,"./PendingActionsTwoTone":false,"./PendingOutlined":false,"./PendingRounded":false,"./PendingSharp":false,"./PendingTwoTone":false,"./Pentagon":false,"./PentagonOutlined":false,"./PentagonRounded":false,"./PentagonSharp":false,"./PentagonTwoTone":false,"./People":false,"./PeopleAlt":false,"./PeopleAltOutlined":false,"./PeopleAltRounded":false,"./PeopleAltSharp":false,"./PeopleAltTwoTone":false,"./PeopleOutline":false,"./PeopleOutlineOutlined":false,"./PeopleOutlineRounded":false,"./PeopleOutlineSharp":false,"./PeopleOutlineTwoTone":false,"./PeopleOutlined":false,"./PeopleRounded":false,"./PeopleSharp":false,"./PeopleTwoTone":false,"./Percent":false,"./PercentOutlined":false,"./PercentRounded":false,"./PercentSharp":false,"./PercentTwoTone":false,"./PermCameraMic":false,"./PermCameraMicOutlined":false,"./PermCameraMicRounded":false,"./PermCameraMicSharp":false,"./PermCameraMicTwoTone":false,"./PermContactCalendar":false,"./PermContactCalendarOutlined":false,"./PermContactCalendarRounded":false,"./PermContactCalendarSharp":false,"./PermContactCalendarTwoTone":false,"./PermDataSetting":false,"./PermDataSettingOutlined":false,"./PermDataSettingRounded":false,"./PermDataSettingSharp":false,"./PermDataSettingTwoTone":false,"./PermDeviceInformation":false,"./PermDeviceInformationOutlined":false,"./PermDeviceInformationRounded":false,"./PermDeviceInformationSharp":false,"./PermDeviceInformationTwoTone":false,"./PermIdentity":false,"./PermIdentityOutlined":false,"./PermIdentityRounded":false,"./PermIdentitySharp":false,"./PermIdentityTwoTone":false,"./PermMedia":false,"./PermMediaOutlined":false,"./PermMediaRounded":false,"./PermMediaSharp":false,"./PermMediaTwoTone":false,"./PermPhoneMsg":false,"./PermPhoneMsgOutlined":false,"./PermPhoneMsgRounded":false,"./PermPhoneMsgSharp":false,"./PermPhoneMsgTwoTone":false,"./PermScanWifi":false,"./PermScanWifiOutlined":false,"./PermScanWifiRounded":false,"./PermScanWifiSharp":false,"./PermScanWifiTwoTone":false,"./Person":false,"./Person2":false,"./Person2Outlined":false,"./Person2Rounded":false,"./Person2Sharp":false,"./Person2TwoTone":false,"./Person3":false,"./Person3Outlined":false,"./Person3Rounded":false,"./Person3Sharp":false,"./Person3TwoTone":false,"./Person4":false,"./Person4Outlined":false,"./Person4Rounded":false,"./Person4Sharp":false,"./Person4TwoTone":false,"./PersonAdd":false,"./PersonAddAlt":false,"./PersonAddAlt1":false,"./PersonAddAlt1Outlined":false,"./PersonAddAlt1Rounded":false,"./PersonAddAlt1Sharp":false,"./PersonAddAlt1TwoTone":false,"./PersonAddAltOutlined":false,"./PersonAddAltRounded":false,"./PersonAddAltSharp":false,"./PersonAddAltTwoTone":false,"./PersonAddDisabled":false,"./PersonAddDisabledOutlined":false,"./PersonAddDisabledRounded":false,"./PersonAddDisabledSharp":false,"./PersonAddDisabledTwoTone":false,"./PersonAddOutlined":false,"./PersonAddRounded":false,"./PersonAddSharp":false,"./PersonAddTwoTone":false,"./PersonOff":false,"./PersonOffOutlined":false,"./PersonOffRounded":false,"./PersonOffSharp":false,"./PersonOffTwoTone":false,"./PersonOutline":false,"./PersonOutlineOutlined":false,"./PersonOutlineRounded":false,"./PersonOutlineSharp":false,"./PersonOutlineTwoTone":false,"./PersonOutlined":false,"./PersonPin":false,"./PersonPinCircle":false,"./PersonPinCircleOutlined":false,"./PersonPinCircleRounded":false,"./PersonPinCircleSharp":false,"./PersonPinCircleTwoTone":false,"./PersonPinOutlined":false,"./PersonPinRounded":false,"./PersonPinSharp":false,"./PersonPinTwoTone":false,"./PersonRemove":false,"./PersonRemoveAlt1":false,"./PersonRemoveAlt1Outlined":false,"./PersonRemoveAlt1Rounded":false,"./PersonRemoveAlt1Sharp":false,"./PersonRemoveAlt1TwoTone":false,"./PersonRemoveOutlined":false,"./PersonRemoveRounded":false,"./PersonRemoveSharp":false,"./PersonRemoveTwoTone":false,"./PersonRounded":false,"./PersonSearch":false,"./PersonSearchOutlined":false,"./PersonSearchRounded":false,"./PersonSearchSharp":false,"./PersonSearchTwoTone":false,"./PersonSharp":false,"./PersonTwoTone":false,"./PersonalVideo":false,"./PersonalVideoOutlined":false,"./PersonalVideoRounded":false,"./PersonalVideoSharp":false,"./PersonalVideoTwoTone":false,"./PestControl":false,"./PestControlOutlined":false,"./PestControlRodent":false,"./PestControlRodentOutlined":false,"./PestControlRodentRounded":false,"./PestControlRodentSharp":false,"./PestControlRodentTwoTone":false,"./PestControlRounded":false,"./PestControlSharp":false,"./PestControlTwoTone":false,"./Pets":false,"./PetsOutlined":false,"./PetsRounded":false,"./PetsSharp":false,"./PetsTwoTone":false,"./Phishing":false,"./PhishingOutlined":false,"./PhishingRounded":false,"./PhishingSharp":false,"./PhishingTwoTone":false,"./Phone":false,"./PhoneAndroid":false,"./PhoneAndroidOutlined":false,"./PhoneAndroidRounded":false,"./PhoneAndroidSharp":false,"./PhoneAndroidTwoTone":false,"./PhoneBluetoothSpeaker":false,"./PhoneBluetoothSpeakerOutlined":false,"./PhoneBluetoothSpeakerRounded":false,"./PhoneBluetoothSpeakerSharp":false,"./PhoneBluetoothSpeakerTwoTone":false,"./PhoneCallback":false,"./PhoneCallbackOutlined":false,"./PhoneCallbackRounded":false,"./PhoneCallbackSharp":false,"./PhoneCallbackTwoTone":false,"./PhoneDisabled":false,"./PhoneDisabledOutlined":false,"./PhoneDisabledRounded":false,"./PhoneDisabledSharp":false,"./PhoneDisabledTwoTone":false,"./PhoneEnabled":false,"./PhoneEnabledOutlined":false,"./PhoneEnabledRounded":false,"./PhoneEnabledSharp":false,"./PhoneEnabledTwoTone":false,"./PhoneForwarded":false,"./PhoneForwardedOutlined":false,"./PhoneForwardedRounded":false,"./PhoneForwardedSharp":false,"./PhoneForwardedTwoTone":false,"./PhoneInTalk":false,"./PhoneInTalkOutlined":false,"./PhoneInTalkRounded":false,"./PhoneInTalkSharp":false,"./PhoneInTalkTwoTone":false,"./PhoneIphone":false,"./PhoneIphoneOutlined":false,"./PhoneIphoneRounded":false,"./PhoneIphoneSharp":false,"./PhoneIphoneTwoTone":false,"./PhoneLocked":false,"./PhoneLockedOutlined":false,"./PhoneLockedRounded":false,"./PhoneLockedSharp":false,"./PhoneLockedTwoTone":false,"./PhoneMissed":false,"./PhoneMissedOutlined":false,"./PhoneMissedRounded":false,"./PhoneMissedSharp":false,"./PhoneMissedTwoTone":false,"./PhoneOutlined":false,"./PhonePaused":false,"./PhonePausedOutlined":false,"./PhonePausedRounded":false,"./PhonePausedSharp":false,"./PhonePausedTwoTone":false,"./PhoneRounded":false,"./PhoneSharp":false,"./PhoneTwoTone":false,"./Phonelink":false,"./PhonelinkErase":false,"./PhonelinkEraseOutlined":false,"./PhonelinkEraseRounded":false,"./PhonelinkEraseSharp":false,"./PhonelinkEraseTwoTone":false,"./PhonelinkLock":false,"./PhonelinkLockOutlined":false,"./PhonelinkLockRounded":false,"./PhonelinkLockSharp":false,"./PhonelinkLockTwoTone":false,"./PhonelinkOff":false,"./PhonelinkOffOutlined":false,"./PhonelinkOffRounded":false,"./PhonelinkOffSharp":false,"./PhonelinkOffTwoTone":false,"./PhonelinkOutlined":false,"./PhonelinkRing":false,"./PhonelinkRingOutlined":false,"./PhonelinkRingRounded":false,"./PhonelinkRingSharp":false,"./PhonelinkRingTwoTone":false,"./PhonelinkRounded":false,"./PhonelinkSetup":false,"./PhonelinkSetupOutlined":false,"./PhonelinkSetupRounded":false,"./PhonelinkSetupSharp":false,"./PhonelinkSetupTwoTone":false,"./PhonelinkSharp":false,"./PhonelinkTwoTone":false,"./Photo":false,"./PhotoAlbum":false,"./PhotoAlbumOutlined":false,"./PhotoAlbumRounded":false,"./PhotoAlbumSharp":false,"./PhotoAlbumTwoTone":false,"./PhotoCamera":false,"./PhotoCameraBack":false,"./PhotoCameraBackOutlined":false,"./PhotoCameraBackRounded":false,"./PhotoCameraBackSharp":false,"./PhotoCameraBackTwoTone":false,"./PhotoCameraFront":false,"./PhotoCameraFrontOutlined":false,"./PhotoCameraFrontRounded":false,"./PhotoCameraFrontSharp":false,"./PhotoCameraFrontTwoTone":false,"./PhotoCameraOutlined":false,"./PhotoCameraRounded":false,"./PhotoCameraSharp":false,"./PhotoCameraTwoTone":false,"./PhotoFilter":false,"./PhotoFilterOutlined":false,"./PhotoFilterRounded":false,"./PhotoFilterSharp":false,"./PhotoFilterTwoTone":false,"./PhotoLibrary":false,"./PhotoLibraryOutlined":false,"./PhotoLibraryRounded":false,"./PhotoLibrarySharp":false,"./PhotoLibraryTwoTone":false,"./PhotoOutlined":false,"./PhotoRounded":false,"./PhotoSharp":false,"./PhotoSizeSelectActual":false,"./PhotoSizeSelectActualOutlined":false,"./PhotoSizeSelectActualRounded":false,"./PhotoSizeSelectActualSharp":false,"./PhotoSizeSelectActualTwoTone":false,"./PhotoSizeSelectLarge":false,"./PhotoSizeSelectLargeOutlined":false,"./PhotoSizeSelectLargeRounded":false,"./PhotoSizeSelectLargeSharp":false,"./PhotoSizeSelectLargeTwoTone":false,"./PhotoSizeSelectSmall":false,"./PhotoSizeSelectSmallOutlined":false,"./PhotoSizeSelectSmallRounded":false,"./PhotoSizeSelectSmallSharp":false,"./PhotoSizeSelectSmallTwoTone":false,"./PhotoTwoTone":false,"./Php":false,"./PhpOutlined":false,"./PhpRounded":false,"./PhpSharp":false,"./PhpTwoTone":false,"./Piano":false,"./PianoOff":false,"./PianoOffOutlined":false,"./PianoOffRounded":false,"./PianoOffSharp":false,"./PianoOffTwoTone":false,"./PianoOutlined":false,"./PianoRounded":false,"./PianoSharp":false,"./PianoTwoTone":false,"./PictureAsPdf":false,"./PictureAsPdfOutlined":false,"./PictureAsPdfRounded":false,"./PictureAsPdfSharp":false,"./PictureAsPdfTwoTone":false,"./PictureInPicture":false,"./PictureInPictureAlt":false,"./PictureInPictureAltOutlined":false,"./PictureInPictureAltRounded":false,"./PictureInPictureAltSharp":false,"./PictureInPictureAltTwoTone":false,"./PictureInPictureOutlined":false,"./PictureInPictureRounded":false,"./PictureInPictureSharp":false,"./PictureInPictureTwoTone":false,"./PieChart":false,"./PieChartOutline":false,"./PieChartOutlineOutlined":false,"./PieChartOutlineRounded":false,"./PieChartOutlineSharp":false,"./PieChartOutlineTwoTone":false,"./PieChartOutlined":false,"./PieChartRounded":false,"./PieChartSharp":false,"./PieChartTwoTone":false,"./Pin":false,"./PinDrop":false,"./PinDropOutlined":false,"./PinDropRounded":false,"./PinDropSharp":false,"./PinDropTwoTone":false,"./PinOutlined":false,"./PinRounded":false,"./PinSharp":false,"./PinTwoTone":false,"./Pinch":false,"./PinchOutlined":false,"./PinchRounded":false,"./PinchSharp":false,"./PinchTwoTone":false,"./Pinterest":false,"./PivotTableChart":false,"./PivotTableChartOutlined":false,"./PivotTableChartRounded":false,"./PivotTableChartSharp":false,"./PivotTableChartTwoTone":false,"./Pix":false,"./PixOutlined":false,"./PixRounded":false,"./PixSharp":false,"./PixTwoTone":false,"./Place":false,"./PlaceOutlined":false,"./PlaceRounded":false,"./PlaceSharp":false,"./PlaceTwoTone":false,"./Plagiarism":false,"./PlagiarismOutlined":false,"./PlagiarismRounded":false,"./PlagiarismSharp":false,"./PlagiarismTwoTone":false,"./PlayArrow":false,"./PlayArrowOutlined":false,"./PlayArrowRounded":false,"./PlayArrowSharp":false,"./PlayArrowTwoTone":false,"./PlayCircle":false,"./PlayCircleFilled":false,"./PlayCircleFilledOutlined":false,"./PlayCircleFilledRounded":false,"./PlayCircleFilledSharp":false,"./PlayCircleFilledTwoTone":false,"./PlayCircleFilledWhite":false,"./PlayCircleFilledWhiteOutlined":false,"./PlayCircleFilledWhiteRounded":false,"./PlayCircleFilledWhiteSharp":false,"./PlayCircleFilledWhiteTwoTone":false,"./PlayCircleOutline":false,"./PlayCircleOutlineOutlined":false,"./PlayCircleOutlineRounded":false,"./PlayCircleOutlineSharp":false,"./PlayCircleOutlineTwoTone":false,"./PlayCircleOutlined":false,"./PlayCircleRounded":false,"./PlayCircleSharp":false,"./PlayCircleTwoTone":false,"./PlayDisabled":false,"./PlayDisabledOutlined":false,"./PlayDisabledRounded":false,"./PlayDisabledSharp":false,"./PlayDisabledTwoTone":false,"./PlayForWork":false,"./PlayForWorkOutlined":false,"./PlayForWorkRounded":false,"./PlayForWorkSharp":false,"./PlayForWorkTwoTone":false,"./PlayLesson":false,"./PlayLessonOutlined":false,"./PlayLessonRounded":false,"./PlayLessonSharp":false,"./PlayLessonTwoTone":false,"./PlaylistAdd":false,"./PlaylistAddCheck":false,"./PlaylistAddCheckCircle":false,"./PlaylistAddCheckCircleOutlined":false,"./PlaylistAddCheckCircleRounded":false,"./PlaylistAddCheckCircleSharp":false,"./PlaylistAddCheckCircleTwoTone":false,"./PlaylistAddCheckOutlined":false,"./PlaylistAddCheckRounded":false,"./PlaylistAddCheckSharp":false,"./PlaylistAddCheckTwoTone":false,"./PlaylistAddCircle":false,"./PlaylistAddCircleOutlined":false,"./PlaylistAddCircleRounded":false,"./PlaylistAddCircleSharp":false,"./PlaylistAddCircleTwoTone":false,"./PlaylistAddOutlined":false,"./PlaylistAddRounded":false,"./PlaylistAddSharp":false,"./PlaylistAddTwoTone":false,"./PlaylistPlay":false,"./PlaylistPlayOutlined":false,"./PlaylistPlayRounded":false,"./PlaylistPlaySharp":false,"./PlaylistPlayTwoTone":false,"./PlaylistRemove":false,"./PlaylistRemoveOutlined":false,"./PlaylistRemoveRounded":false,"./PlaylistRemoveSharp":false,"./PlaylistRemoveTwoTone":false,"./Plumbing":false,"./PlumbingOutlined":false,"./PlumbingRounded":false,"./PlumbingSharp":false,"./PlumbingTwoTone":false,"./PlusOne":false,"./PlusOneOutlined":false,"./PlusOneRounded":false,"./PlusOneSharp":false,"./PlusOneTwoTone":false,"./Podcasts":false,"./PodcastsOutlined":false,"./PodcastsRounded":false,"./PodcastsSharp":false,"./PodcastsTwoTone":false,"./PointOfSale":false,"./PointOfSaleOutlined":false,"./PointOfSaleRounded":false,"./PointOfSaleSharp":false,"./PointOfSaleTwoTone":false,"./Policy":false,"./PolicyOutlined":false,"./PolicyRounded":false,"./PolicySharp":false,"./PolicyTwoTone":false,"./Poll":false,"./PollOutlined":false,"./PollRounded":false,"./PollSharp":false,"./PollTwoTone":false,"./Polyline":false,"./PolylineOutlined":false,"./PolylineRounded":false,"./PolylineSharp":false,"./PolylineTwoTone":false,"./Pool":false,"./PoolOutlined":false,"./PoolRounded":false,"./PoolSharp":false,"./PoolTwoTone":false,"./PortableWifiOff":false,"./PortableWifiOffOutlined":false,"./PortableWifiOffRounded":false,"./PortableWifiOffSharp":false,"./PortableWifiOffTwoTone":false,"./Portrait":false,"./PortraitOutlined":false,"./PortraitRounded":false,"./PortraitSharp":false,"./PortraitTwoTone":false,"./PostAdd":false,"./PostAddOutlined":false,"./PostAddRounded":false,"./PostAddSharp":false,"./PostAddTwoTone":false,"./Power":false,"./PowerInput":false,"./PowerInputOutlined":false,"./PowerInputRounded":false,"./PowerInputSharp":false,"./PowerInputTwoTone":false,"./PowerOff":false,"./PowerOffOutlined":false,"./PowerOffRounded":false,"./PowerOffSharp":false,"./PowerOffTwoTone":false,"./PowerOutlined":false,"./PowerRounded":false,"./PowerSettingsNew":false,"./PowerSettingsNewOutlined":false,"./PowerSettingsNewRounded":false,"./PowerSettingsNewSharp":false,"./PowerSettingsNewTwoTone":false,"./PowerSharp":false,"./PowerTwoTone":false,"./PrecisionManufacturing":false,"./PrecisionManufacturingOutlined":false,"./PrecisionManufacturingRounded":false,"./PrecisionManufacturingSharp":false,"./PrecisionManufacturingTwoTone":false,"./PregnantWoman":false,"./PregnantWomanOutlined":false,"./PregnantWomanRounded":false,"./PregnantWomanSharp":false,"./PregnantWomanTwoTone":false,"./PresentToAll":false,"./PresentToAllOutlined":false,"./PresentToAllRounded":false,"./PresentToAllSharp":false,"./PresentToAllTwoTone":false,"./Preview":false,"./PreviewOutlined":false,"./PreviewRounded":false,"./PreviewSharp":false,"./PreviewTwoTone":false,"./PriceChange":false,"./PriceChangeOutlined":false,"./PriceChangeRounded":false,"./PriceChangeSharp":false,"./PriceChangeTwoTone":false,"./PriceCheck":false,"./PriceCheckOutlined":false,"./PriceCheckRounded":false,"./PriceCheckSharp":false,"./PriceCheckTwoTone":false,"./Print":false,"./PrintDisabled":false,"./PrintDisabledOutlined":false,"./PrintDisabledRounded":false,"./PrintDisabledSharp":false,"./PrintDisabledTwoTone":false,"./PrintOutlined":false,"./PrintRounded":false,"./PrintSharp":false,"./PrintTwoTone":false,"./PriorityHigh":false,"./PriorityHighOutlined":false,"./PriorityHighRounded":false,"./PriorityHighSharp":false,"./PriorityHighTwoTone":false,"./PrivacyTip":false,"./PrivacyTipOutlined":false,"./PrivacyTipRounded":false,"./PrivacyTipSharp":false,"./PrivacyTipTwoTone":false,"./ProductionQuantityLimits":false,"./ProductionQuantityLimitsOutlined":false,"./ProductionQuantityLimitsRounded":false,"./ProductionQuantityLimitsSharp":false,"./ProductionQuantityLimitsTwoTone":false,"./Propane":false,"./PropaneOutlined":false,"./PropaneRounded":false,"./PropaneSharp":false,"./PropaneTank":false,"./PropaneTankOutlined":false,"./PropaneTankRounded":false,"./PropaneTankSharp":false,"./PropaneTankTwoTone":false,"./PropaneTwoTone":false,"./Psychology":false,"./PsychologyAlt":false,"./PsychologyAltOutlined":false,"./PsychologyAltRounded":false,"./PsychologyAltSharp":false,"./PsychologyAltTwoTone":false,"./PsychologyOutlined":false,"./PsychologyRounded":false,"./PsychologySharp":false,"./PsychologyTwoTone":false,"./Public":false,"./PublicOff":false,"./PublicOffOutlined":false,"./PublicOffRounded":false,"./PublicOffSharp":false,"./PublicOffTwoTone":false,"./PublicOutlined":false,"./PublicRounded":false,"./PublicSharp":false,"./PublicTwoTone":false,"./Publish":false,"./PublishOutlined":false,"./PublishRounded":false,"./PublishSharp":false,"./PublishTwoTone":false,"./PublishedWithChanges":false,"./PublishedWithChangesOutlined":false,"./PublishedWithChangesRounded":false,"./PublishedWithChangesSharp":false,"./PublishedWithChangesTwoTone":false,"./PunchClock":false,"./PunchClockOutlined":false,"./PunchClockRounded":false,"./PunchClockSharp":false,"./PunchClockTwoTone":false,"./PushPin":false,"./PushPinOutlined":false,"./PushPinRounded":false,"./PushPinSharp":false,"./PushPinTwoTone":false,"./QrCode":false,"./QrCode2":false,"./QrCode2Outlined":false,"./QrCode2Rounded":false,"./QrCode2Sharp":false,"./QrCode2TwoTone":false,"./QrCodeOutlined":false,"./QrCodeRounded":false,"./QrCodeScanner":false,"./QrCodeScannerOutlined":false,"./QrCodeScannerRounded":false,"./QrCodeScannerSharp":false,"./QrCodeScannerTwoTone":false,"./QrCodeSharp":false,"./QrCodeTwoTone":false,"./QueryBuilder":false,"./QueryBuilderOutlined":false,"./QueryBuilderRounded":false,"./QueryBuilderSharp":false,"./QueryBuilderTwoTone":false,"./QueryStats":false,"./QueryStatsOutlined":false,"./QueryStatsRounded":false,"./QueryStatsSharp":false,"./QueryStatsTwoTone":false,"./QuestionAnswer":false,"./QuestionAnswerOutlined":false,"./QuestionAnswerRounded":false,"./QuestionAnswerSharp":false,"./QuestionAnswerTwoTone":false,"./QuestionMark":false,"./QuestionMarkOutlined":false,"./QuestionMarkRounded":false,"./QuestionMarkSharp":false,"./QuestionMarkTwoTone":false,"./Queue":false,"./QueueMusic":false,"./QueueMusicOutlined":false,"./QueueMusicRounded":false,"./QueueMusicSharp":false,"./QueueMusicTwoTone":false,"./QueueOutlined":false,"./QueuePlayNext":false,"./QueuePlayNextOutlined":false,"./QueuePlayNextRounded":false,"./QueuePlayNextSharp":false,"./QueuePlayNextTwoTone":false,"./QueueRounded":false,"./QueueSharp":false,"./QueueTwoTone":false,"./Quickreply":false,"./QuickreplyOutlined":false,"./QuickreplyRounded":false,"./QuickreplySharp":false,"./QuickreplyTwoTone":false,"./Quiz":false,"./QuizOutlined":false,"./QuizRounded":false,"./QuizSharp":false,"./QuizTwoTone":false,"./RMobiledata":false,"./RMobiledataOutlined":false,"./RMobiledataRounded":false,"./RMobiledataSharp":false,"./RMobiledataTwoTone":false,"./Radar":false,"./RadarOutlined":false,"./RadarRounded":false,"./RadarSharp":false,"./RadarTwoTone":false,"./Radio":false,"./RadioButtonChecked":false,"./RadioButtonCheckedOutlined":false,"./RadioButtonCheckedRounded":false,"./RadioButtonCheckedSharp":false,"./RadioButtonCheckedTwoTone":false,"./RadioButtonUnchecked":"5Ld2w","./RadioButtonUncheckedOutlined":false,"./RadioButtonUncheckedRounded":false,"./RadioButtonUncheckedSharp":false,"./RadioButtonUncheckedTwoTone":false,"./RadioOutlined":false,"./RadioRounded":false,"./RadioSharp":false,"./RadioTwoTone":false,"./RailwayAlert":false,"./RailwayAlertOutlined":false,"./RailwayAlertRounded":false,"./RailwayAlertSharp":false,"./RailwayAlertTwoTone":false,"./RamenDining":false,"./RamenDiningOutlined":false,"./RamenDiningRounded":false,"./RamenDiningSharp":false,"./RamenDiningTwoTone":false,"./RampLeft":false,"./RampLeftOutlined":false,"./RampLeftRounded":false,"./RampLeftSharp":false,"./RampLeftTwoTone":false,"./RampRight":false,"./RampRightOutlined":false,"./RampRightRounded":false,"./RampRightSharp":false,"./RampRightTwoTone":false,"./RateReview":false,"./RateReviewOutlined":false,"./RateReviewRounded":false,"./RateReviewSharp":false,"./RateReviewTwoTone":false,"./RawOff":false,"./RawOffOutlined":false,"./RawOffRounded":false,"./RawOffSharp":false,"./RawOffTwoTone":false,"./RawOn":false,"./RawOnOutlined":false,"./RawOnRounded":false,"./RawOnSharp":false,"./RawOnTwoTone":false,"./ReadMore":false,"./ReadMoreOutlined":false,"./ReadMoreRounded":false,"./ReadMoreSharp":false,"./ReadMoreTwoTone":false,"./Receipt":false,"./ReceiptLong":false,"./ReceiptLongOutlined":false,"./ReceiptLongRounded":false,"./ReceiptLongSharp":false,"./ReceiptLongTwoTone":false,"./ReceiptOutlined":false,"./ReceiptRounded":false,"./ReceiptSharp":false,"./ReceiptTwoTone":false,"./RecentActors":false,"./RecentActorsOutlined":false,"./RecentActorsRounded":false,"./RecentActorsSharp":false,"./RecentActorsTwoTone":false,"./Recommend":false,"./RecommendOutlined":false,"./RecommendRounded":false,"./RecommendSharp":false,"./RecommendTwoTone":false,"./RecordVoiceOver":false,"./RecordVoiceOverOutlined":false,"./RecordVoiceOverRounded":false,"./RecordVoiceOverSharp":false,"./RecordVoiceOverTwoTone":false,"./Rectangle":false,"./RectangleOutlined":false,"./RectangleRounded":false,"./RectangleSharp":false,"./RectangleTwoTone":false,"./Recycling":false,"./RecyclingOutlined":false,"./RecyclingRounded":false,"./RecyclingSharp":false,"./RecyclingTwoTone":false,"./Reddit":false,"./Redeem":false,"./RedeemOutlined":false,"./RedeemRounded":false,"./RedeemSharp":false,"./RedeemTwoTone":false,"./Redo":false,"./RedoOutlined":false,"./RedoRounded":false,"./RedoSharp":false,"./RedoTwoTone":false,"./ReduceCapacity":false,"./ReduceCapacityOutlined":false,"./ReduceCapacityRounded":false,"./ReduceCapacitySharp":false,"./ReduceCapacityTwoTone":false,"./Refresh":false,"./RefreshOutlined":false,"./RefreshRounded":false,"./RefreshSharp":false,"./RefreshTwoTone":false,"./RememberMe":false,"./RememberMeOutlined":false,"./RememberMeRounded":false,"./RememberMeSharp":false,"./RememberMeTwoTone":false,"./Remove":false,"./RemoveCircle":false,"./RemoveCircleOutline":false,"./RemoveCircleOutlineOutlined":false,"./RemoveCircleOutlineRounded":false,"./RemoveCircleOutlineSharp":false,"./RemoveCircleOutlineTwoTone":false,"./RemoveCircleOutlined":false,"./RemoveCircleRounded":false,"./RemoveCircleSharp":false,"./RemoveCircleTwoTone":false,"./RemoveDone":false,"./RemoveDoneOutlined":false,"./RemoveDoneRounded":false,"./RemoveDoneSharp":false,"./RemoveDoneTwoTone":false,"./RemoveFromQueue":false,"./RemoveFromQueueOutlined":false,"./RemoveFromQueueRounded":false,"./RemoveFromQueueSharp":false,"./RemoveFromQueueTwoTone":false,"./RemoveModerator":false,"./RemoveModeratorOutlined":false,"./RemoveModeratorRounded":false,"./RemoveModeratorSharp":false,"./RemoveModeratorTwoTone":false,"./RemoveOutlined":false,"./RemoveRedEye":false,"./RemoveRedEyeOutlined":false,"./RemoveRedEyeRounded":false,"./RemoveRedEyeSharp":false,"./RemoveRedEyeTwoTone":false,"./RemoveRoad":false,"./RemoveRoadOutlined":false,"./RemoveRoadRounded":false,"./RemoveRoadSharp":false,"./RemoveRoadTwoTone":false,"./RemoveRounded":false,"./RemoveSharp":false,"./RemoveShoppingCart":false,"./RemoveShoppingCartOutlined":false,"./RemoveShoppingCartRounded":false,"./RemoveShoppingCartSharp":false,"./RemoveShoppingCartTwoTone":false,"./RemoveTwoTone":false,"./Reorder":false,"./ReorderOutlined":false,"./ReorderRounded":false,"./ReorderSharp":false,"./ReorderTwoTone":false,"./Repartition":false,"./RepartitionOutlined":false,"./RepartitionRounded":false,"./RepartitionSharp":false,"./RepartitionTwoTone":false,"./Repeat":false,"./RepeatOn":false,"./RepeatOnOutlined":false,"./RepeatOnRounded":false,"./RepeatOnSharp":false,"./RepeatOnTwoTone":false,"./RepeatOne":false,"./RepeatOneOn":false,"./RepeatOneOnOutlined":false,"./RepeatOneOnRounded":false,"./RepeatOneOnSharp":false,"./RepeatOneOnTwoTone":false,"./RepeatOneOutlined":false,"./RepeatOneRounded":false,"./RepeatOneSharp":false,"./RepeatOneTwoTone":false,"./RepeatOutlined":false,"./RepeatRounded":false,"./RepeatSharp":false,"./RepeatTwoTone":false,"./Replay":false,"./Replay10":false,"./Replay10Outlined":false,"./Replay10Rounded":false,"./Replay10Sharp":false,"./Replay10TwoTone":false,"./Replay30":false,"./Replay30Outlined":false,"./Replay30Rounded":false,"./Replay30Sharp":false,"./Replay30TwoTone":false,"./Replay5":false,"./Replay5Outlined":false,"./Replay5Rounded":false,"./Replay5Sharp":false,"./Replay5TwoTone":false,"./ReplayCircleFilled":false,"./ReplayCircleFilledOutlined":false,"./ReplayCircleFilledRounded":false,"./ReplayCircleFilledSharp":false,"./ReplayCircleFilledTwoTone":false,"./ReplayOutlined":false,"./ReplayRounded":false,"./ReplaySharp":false,"./ReplayTwoTone":false,"./Reply":false,"./ReplyAll":false,"./ReplyAllOutlined":false,"./ReplyAllRounded":false,"./ReplyAllSharp":false,"./ReplyAllTwoTone":false,"./ReplyOutlined":false,"./ReplyRounded":false,"./ReplySharp":false,"./ReplyTwoTone":false,"./Report":false,"./ReportGmailerrorred":false,"./ReportGmailerrorredOutlined":false,"./ReportGmailerrorredRounded":false,"./ReportGmailerrorredSharp":false,"./ReportGmailerrorredTwoTone":false,"./ReportOff":false,"./ReportOffOutlined":false,"./ReportOffRounded":false,"./ReportOffSharp":false,"./ReportOffTwoTone":false,"./ReportOutlined":false,"./ReportProblem":false,"./ReportProblemOutlined":false,"./ReportProblemRounded":false,"./ReportProblemSharp":false,"./ReportProblemTwoTone":false,"./ReportRounded":false,"./ReportSharp":false,"./ReportTwoTone":false,"./RequestPage":false,"./RequestPageOutlined":false,"./RequestPageRounded":false,"./RequestPageSharp":false,"./RequestPageTwoTone":false,"./RequestQuote":false,"./RequestQuoteOutlined":false,"./RequestQuoteRounded":false,"./RequestQuoteSharp":false,"./RequestQuoteTwoTone":false,"./ResetTv":false,"./ResetTvOutlined":false,"./ResetTvRounded":false,"./ResetTvSharp":false,"./ResetTvTwoTone":false,"./RestartAlt":false,"./RestartAltOutlined":false,"./RestartAltRounded":false,"./RestartAltSharp":false,"./RestartAltTwoTone":false,"./Restaurant":false,"./RestaurantMenu":false,"./RestaurantMenuOutlined":false,"./RestaurantMenuRounded":false,"./RestaurantMenuSharp":false,"./RestaurantMenuTwoTone":false,"./RestaurantOutlined":false,"./RestaurantRounded":false,"./RestaurantSharp":false,"./RestaurantTwoTone":false,"./Restore":false,"./RestoreFromTrash":false,"./RestoreFromTrashOutlined":false,"./RestoreFromTrashRounded":false,"./RestoreFromTrashSharp":false,"./RestoreFromTrashTwoTone":false,"./RestoreOutlined":false,"./RestorePage":false,"./RestorePageOutlined":false,"./RestorePageRounded":false,"./RestorePageSharp":false,"./RestorePageTwoTone":false,"./RestoreRounded":false,"./RestoreSharp":false,"./RestoreTwoTone":false,"./Reviews":false,"./ReviewsOutlined":false,"./ReviewsRounded":false,"./ReviewsSharp":false,"./ReviewsTwoTone":false,"./RiceBowl":false,"./RiceBowlOutlined":false,"./RiceBowlRounded":false,"./RiceBowlSharp":false,"./RiceBowlTwoTone":false,"./RingVolume":false,"./RingVolumeOutlined":false,"./RingVolumeRounded":false,"./RingVolumeSharp":false,"./RingVolumeTwoTone":false,"./Rocket":false,"./RocketLaunch":false,"./RocketLaunchOutlined":false,"./RocketLaunchRounded":false,"./RocketLaunchSharp":false,"./RocketLaunchTwoTone":false,"./RocketOutlined":false,"./RocketRounded":false,"./RocketSharp":false,"./RocketTwoTone":false,"./RollerShades":false,"./RollerShadesClosed":false,"./RollerShadesClosedOutlined":false,"./RollerShadesClosedRounded":false,"./RollerShadesClosedSharp":false,"./RollerShadesClosedTwoTone":false,"./RollerShadesOutlined":false,"./RollerShadesRounded":false,"./RollerShadesSharp":false,"./RollerShadesTwoTone":false,"./RollerSkating":false,"./RollerSkatingOutlined":false,"./RollerSkatingRounded":false,"./RollerSkatingSharp":false,"./RollerSkatingTwoTone":false,"./Roofing":false,"./RoofingOutlined":false,"./RoofingRounded":false,"./RoofingSharp":false,"./RoofingTwoTone":false,"./Room":false,"./RoomOutlined":false,"./RoomPreferences":false,"./RoomPreferencesOutlined":false,"./RoomPreferencesRounded":false,"./RoomPreferencesSharp":false,"./RoomPreferencesTwoTone":false,"./RoomRounded":false,"./RoomService":false,"./RoomServiceOutlined":false,"./RoomServiceRounded":false,"./RoomServiceSharp":false,"./RoomServiceTwoTone":false,"./RoomSharp":false,"./RoomTwoTone":false,"./Rotate90DegreesCcw":false,"./Rotate90DegreesCcwOutlined":false,"./Rotate90DegreesCcwRounded":false,"./Rotate90DegreesCcwSharp":false,"./Rotate90DegreesCcwTwoTone":false,"./Rotate90DegreesCw":false,"./Rotate90DegreesCwOutlined":false,"./Rotate90DegreesCwRounded":false,"./Rotate90DegreesCwSharp":false,"./Rotate90DegreesCwTwoTone":false,"./RotateLeft":false,"./RotateLeftOutlined":false,"./RotateLeftRounded":false,"./RotateLeftSharp":false,"./RotateLeftTwoTone":false,"./RotateRight":false,"./RotateRightOutlined":false,"./RotateRightRounded":false,"./RotateRightSharp":false,"./RotateRightTwoTone":false,"./RoundaboutLeft":false,"./RoundaboutLeftOutlined":false,"./RoundaboutLeftRounded":false,"./RoundaboutLeftSharp":false,"./RoundaboutLeftTwoTone":false,"./RoundaboutRight":false,"./RoundaboutRightOutlined":false,"./RoundaboutRightRounded":false,"./RoundaboutRightSharp":false,"./RoundaboutRightTwoTone":false,"./RoundedCorner":false,"./RoundedCornerOutlined":false,"./RoundedCornerRounded":false,"./RoundedCornerSharp":false,"./RoundedCornerTwoTone":false,"./Route":false,"./RouteOutlined":false,"./RouteRounded":false,"./RouteSharp":false,"./RouteTwoTone":false,"./Router":false,"./RouterOutlined":false,"./RouterRounded":false,"./RouterSharp":false,"./RouterTwoTone":false,"./Rowing":false,"./RowingOutlined":false,"./RowingRounded":false,"./RowingSharp":false,"./RowingTwoTone":false,"./RssFeed":false,"./RssFeedOutlined":false,"./RssFeedRounded":false,"./RssFeedSharp":false,"./RssFeedTwoTone":false,"./Rsvp":false,"./RsvpOutlined":false,"./RsvpRounded":false,"./RsvpSharp":false,"./RsvpTwoTone":false,"./Rtt":false,"./RttOutlined":false,"./RttRounded":false,"./RttSharp":false,"./RttTwoTone":false,"./Rule":"kNirw","./RuleFolder":false,"./RuleFolderOutlined":false,"./RuleFolderRounded":false,"./RuleFolderSharp":false,"./RuleFolderTwoTone":false,"./RuleOutlined":false,"./RuleRounded":false,"./RuleSharp":false,"./RuleTwoTone":false,"./RunCircle":false,"./RunCircleOutlined":false,"./RunCircleRounded":false,"./RunCircleSharp":false,"./RunCircleTwoTone":false,"./RunningWithErrors":"5wbuk","./RunningWithErrorsOutlined":false,"./RunningWithErrorsRounded":false,"./RunningWithErrorsSharp":false,"./RunningWithErrorsTwoTone":false,"./RvHookup":false,"./RvHookupOutlined":false,"./RvHookupRounded":false,"./RvHookupSharp":false,"./RvHookupTwoTone":false,"./SafetyCheck":false,"./SafetyCheckOutlined":false,"./SafetyCheckRounded":false,"./SafetyCheckSharp":false,"./SafetyCheckTwoTone":false,"./SafetyDivider":false,"./SafetyDividerOutlined":false,"./SafetyDividerRounded":false,"./SafetyDividerSharp":false,"./SafetyDividerTwoTone":false,"./Sailing":false,"./SailingOutlined":false,"./SailingRounded":false,"./SailingSharp":false,"./SailingTwoTone":false,"./Sanitizer":false,"./SanitizerOutlined":false,"./SanitizerRounded":false,"./SanitizerSharp":false,"./SanitizerTwoTone":false,"./Satellite":false,"./SatelliteAlt":false,"./SatelliteAltOutlined":false,"./SatelliteAltRounded":false,"./SatelliteAltSharp":false,"./SatelliteAltTwoTone":false,"./SatelliteOutlined":false,"./SatelliteRounded":false,"./SatelliteSharp":false,"./SatelliteTwoTone":false,"./Save":false,"./SaveAlt":false,"./SaveAltOutlined":false,"./SaveAltRounded":false,"./SaveAltSharp":false,"./SaveAltTwoTone":false,"./SaveAs":false,"./SaveAsOutlined":false,"./SaveAsRounded":false,"./SaveAsSharp":false,"./SaveAsTwoTone":false,"./SaveOutlined":false,"./SaveRounded":false,"./SaveSharp":false,"./SaveTwoTone":false,"./SavedSearch":false,"./SavedSearchOutlined":false,"./SavedSearchRounded":false,"./SavedSearchSharp":false,"./SavedSearchTwoTone":false,"./Savings":false,"./SavingsOutlined":false,"./SavingsRounded":false,"./SavingsSharp":false,"./SavingsTwoTone":false,"./Scale":false,"./ScaleOutlined":false,"./ScaleRounded":false,"./ScaleSharp":false,"./ScaleTwoTone":false,"./Scanner":false,"./ScannerOutlined":false,"./ScannerRounded":false,"./ScannerSharp":false,"./ScannerTwoTone":false,"./ScatterPlot":false,"./ScatterPlotOutlined":false,"./ScatterPlotRounded":false,"./ScatterPlotSharp":false,"./ScatterPlotTwoTone":false,"./Schedule":false,"./ScheduleOutlined":false,"./ScheduleRounded":false,"./ScheduleSend":false,"./ScheduleSendOutlined":false,"./ScheduleSendRounded":false,"./ScheduleSendSharp":false,"./ScheduleSendTwoTone":false,"./ScheduleSharp":false,"./ScheduleTwoTone":false,"./Schema":false,"./SchemaOutlined":false,"./SchemaRounded":false,"./SchemaSharp":false,"./SchemaTwoTone":false,"./School":false,"./SchoolOutlined":false,"./SchoolRounded":false,"./SchoolSharp":false,"./SchoolTwoTone":false,"./Science":false,"./ScienceOutlined":false,"./ScienceRounded":false,"./ScienceSharp":false,"./ScienceTwoTone":false,"./Score":false,"./ScoreOutlined":false,"./ScoreRounded":false,"./ScoreSharp":false,"./ScoreTwoTone":false,"./Scoreboard":false,"./ScoreboardOutlined":false,"./ScoreboardRounded":false,"./ScoreboardSharp":false,"./ScoreboardTwoTone":false,"./ScreenLockLandscape":false,"./ScreenLockLandscapeOutlined":false,"./ScreenLockLandscapeRounded":false,"./ScreenLockLandscapeSharp":false,"./ScreenLockLandscapeTwoTone":false,"./ScreenLockPortrait":false,"./ScreenLockPortraitOutlined":false,"./ScreenLockPortraitRounded":false,"./ScreenLockPortraitSharp":false,"./ScreenLockPortraitTwoTone":false,"./ScreenLockRotation":false,"./ScreenLockRotationOutlined":false,"./ScreenLockRotationRounded":false,"./ScreenLockRotationSharp":false,"./ScreenLockRotationTwoTone":false,"./ScreenRotation":false,"./ScreenRotationAlt":false,"./ScreenRotationAltOutlined":false,"./ScreenRotationAltRounded":false,"./ScreenRotationAltSharp":false,"./ScreenRotationAltTwoTone":false,"./ScreenRotationOutlined":false,"./ScreenRotationRounded":false,"./ScreenRotationSharp":false,"./ScreenRotationTwoTone":false,"./ScreenSearchDesktop":false,"./ScreenSearchDesktopOutlined":false,"./ScreenSearchDesktopRounded":false,"./ScreenSearchDesktopSharp":false,"./ScreenSearchDesktopTwoTone":false,"./ScreenShare":false,"./ScreenShareOutlined":false,"./ScreenShareRounded":false,"./ScreenShareSharp":false,"./ScreenShareTwoTone":false,"./Screenshot":false,"./ScreenshotMonitor":false,"./ScreenshotMonitorOutlined":false,"./ScreenshotMonitorRounded":false,"./ScreenshotMonitorSharp":false,"./ScreenshotMonitorTwoTone":false,"./ScreenshotOutlined":false,"./ScreenshotRounded":false,"./ScreenshotSharp":false,"./ScreenshotTwoTone":false,"./ScubaDiving":false,"./ScubaDivingOutlined":false,"./ScubaDivingRounded":false,"./ScubaDivingSharp":false,"./ScubaDivingTwoTone":false,"./Sd":false,"./SdCard":false,"./SdCardAlert":false,"./SdCardAlertOutlined":false,"./SdCardAlertRounded":false,"./SdCardAlertSharp":false,"./SdCardAlertTwoTone":false,"./SdCardOutlined":false,"./SdCardRounded":false,"./SdCardSharp":false,"./SdCardTwoTone":false,"./SdOutlined":false,"./SdRounded":false,"./SdSharp":false,"./SdStorage":false,"./SdStorageOutlined":false,"./SdStorageRounded":false,"./SdStorageSharp":false,"./SdStorageTwoTone":false,"./SdTwoTone":false,"./Search":false,"./SearchOff":false,"./SearchOffOutlined":false,"./SearchOffRounded":false,"./SearchOffSharp":false,"./SearchOffTwoTone":false,"./SearchOutlined":false,"./SearchRounded":false,"./SearchSharp":false,"./SearchTwoTone":false,"./Security":false,"./SecurityOutlined":false,"./SecurityRounded":false,"./SecuritySharp":false,"./SecurityTwoTone":false,"./SecurityUpdate":false,"./SecurityUpdateGood":false,"./SecurityUpdateGoodOutlined":false,"./SecurityUpdateGoodRounded":false,"./SecurityUpdateGoodSharp":false,"./SecurityUpdateGoodTwoTone":false,"./SecurityUpdateOutlined":false,"./SecurityUpdateRounded":false,"./SecurityUpdateSharp":false,"./SecurityUpdateTwoTone":false,"./SecurityUpdateWarning":false,"./SecurityUpdateWarningOutlined":false,"./SecurityUpdateWarningRounded":false,"./SecurityUpdateWarningSharp":false,"./SecurityUpdateWarningTwoTone":false,"./Segment":false,"./SegmentOutlined":false,"./SegmentRounded":false,"./SegmentSharp":false,"./SegmentTwoTone":false,"./SelectAll":false,"./SelectAllOutlined":false,"./SelectAllRounded":false,"./SelectAllSharp":false,"./SelectAllTwoTone":false,"./SelfImprovement":false,"./SelfImprovementOutlined":false,"./SelfImprovementRounded":false,"./SelfImprovementSharp":false,"./SelfImprovementTwoTone":false,"./Sell":false,"./SellOutlined":false,"./SellRounded":false,"./SellSharp":false,"./SellTwoTone":false,"./Send":false,"./SendAndArchive":false,"./SendAndArchiveOutlined":false,"./SendAndArchiveRounded":false,"./SendAndArchiveSharp":false,"./SendAndArchiveTwoTone":false,"./SendOutlined":false,"./SendRounded":false,"./SendSharp":false,"./SendTimeExtension":false,"./SendTimeExtensionOutlined":false,"./SendTimeExtensionRounded":false,"./SendTimeExtensionSharp":false,"./SendTimeExtensionTwoTone":false,"./SendToMobile":false,"./SendToMobileOutlined":false,"./SendToMobileRounded":false,"./SendToMobileSharp":false,"./SendToMobileTwoTone":false,"./SendTwoTone":false,"./SensorDoor":false,"./SensorDoorOutlined":false,"./SensorDoorRounded":false,"./SensorDoorSharp":false,"./SensorDoorTwoTone":false,"./SensorOccupied":false,"./SensorOccupiedOutlined":false,"./SensorOccupiedRounded":false,"./SensorOccupiedSharp":false,"./SensorOccupiedTwoTone":false,"./SensorWindow":false,"./SensorWindowOutlined":false,"./SensorWindowRounded":false,"./SensorWindowSharp":false,"./SensorWindowTwoTone":false,"./Sensors":false,"./SensorsOff":false,"./SensorsOffOutlined":false,"./SensorsOffRounded":false,"./SensorsOffSharp":false,"./SensorsOffTwoTone":false,"./SensorsOutlined":false,"./SensorsRounded":false,"./SensorsSharp":false,"./SensorsTwoTone":false,"./SentimentDissatisfied":false,"./SentimentDissatisfiedOutlined":false,"./SentimentDissatisfiedRounded":false,"./SentimentDissatisfiedSharp":false,"./SentimentDissatisfiedTwoTone":false,"./SentimentNeutral":false,"./SentimentNeutralOutlined":false,"./SentimentNeutralRounded":false,"./SentimentNeutralSharp":false,"./SentimentNeutralTwoTone":false,"./SentimentSatisfied":false,"./SentimentSatisfiedAlt":false,"./SentimentSatisfiedAltOutlined":false,"./SentimentSatisfiedAltRounded":false,"./SentimentSatisfiedAltSharp":false,"./SentimentSatisfiedAltTwoTone":false,"./SentimentSatisfiedOutlined":false,"./SentimentSatisfiedRounded":false,"./SentimentSatisfiedSharp":false,"./SentimentSatisfiedTwoTone":false,"./SentimentVeryDissatisfied":false,"./SentimentVeryDissatisfiedOutlined":false,"./SentimentVeryDissatisfiedRounded":false,"./SentimentVeryDissatisfiedSharp":false,"./SentimentVeryDissatisfiedTwoTone":false,"./SentimentVerySatisfied":false,"./SentimentVerySatisfiedOutlined":false,"./SentimentVerySatisfiedRounded":false,"./SentimentVerySatisfiedSharp":false,"./SentimentVerySatisfiedTwoTone":false,"./SetMeal":false,"./SetMealOutlined":false,"./SetMealRounded":false,"./SetMealSharp":false,"./SetMealTwoTone":false,"./Settings":false,"./SettingsAccessibility":false,"./SettingsAccessibilityOutlined":false,"./SettingsAccessibilityRounded":false,"./SettingsAccessibilitySharp":false,"./SettingsAccessibilityTwoTone":false,"./SettingsApplications":false,"./SettingsApplicationsOutlined":false,"./SettingsApplicationsRounded":false,"./SettingsApplicationsSharp":false,"./SettingsApplicationsTwoTone":false,"./SettingsBackupRestore":false,"./SettingsBackupRestoreOutlined":false,"./SettingsBackupRestoreRounded":false,"./SettingsBackupRestoreSharp":false,"./SettingsBackupRestoreTwoTone":false,"./SettingsBluetooth":false,"./SettingsBluetoothOutlined":false,"./SettingsBluetoothRounded":false,"./SettingsBluetoothSharp":false,"./SettingsBluetoothTwoTone":false,"./SettingsBrightness":false,"./SettingsBrightnessOutlined":false,"./SettingsBrightnessRounded":false,"./SettingsBrightnessSharp":false,"./SettingsBrightnessTwoTone":false,"./SettingsCell":false,"./SettingsCellOutlined":false,"./SettingsCellRounded":false,"./SettingsCellSharp":false,"./SettingsCellTwoTone":false,"./SettingsEthernet":false,"./SettingsEthernetOutlined":false,"./SettingsEthernetRounded":false,"./SettingsEthernetSharp":false,"./SettingsEthernetTwoTone":false,"./SettingsInputAntenna":false,"./SettingsInputAntennaOutlined":false,"./SettingsInputAntennaRounded":false,"./SettingsInputAntennaSharp":false,"./SettingsInputAntennaTwoTone":false,"./SettingsInputComponent":false,"./SettingsInputComponentOutlined":false,"./SettingsInputComponentRounded":false,"./SettingsInputComponentSharp":false,"./SettingsInputComponentTwoTone":false,"./SettingsInputComposite":false,"./SettingsInputCompositeOutlined":false,"./SettingsInputCompositeRounded":false,"./SettingsInputCompositeSharp":false,"./SettingsInputCompositeTwoTone":false,"./SettingsInputHdmi":false,"./SettingsInputHdmiOutlined":false,"./SettingsInputHdmiRounded":false,"./SettingsInputHdmiSharp":false,"./SettingsInputHdmiTwoTone":false,"./SettingsInputSvideo":false,"./SettingsInputSvideoOutlined":false,"./SettingsInputSvideoRounded":false,"./SettingsInputSvideoSharp":false,"./SettingsInputSvideoTwoTone":false,"./SettingsOutlined":false,"./SettingsOverscan":false,"./SettingsOverscanOutlined":false,"./SettingsOverscanRounded":false,"./SettingsOverscanSharp":false,"./SettingsOverscanTwoTone":false,"./SettingsPhone":false,"./SettingsPhoneOutlined":false,"./SettingsPhoneRounded":false,"./SettingsPhoneSharp":false,"./SettingsPhoneTwoTone":false,"./SettingsPower":false,"./SettingsPowerOutlined":false,"./SettingsPowerRounded":false,"./SettingsPowerSharp":false,"./SettingsPowerTwoTone":false,"./SettingsRemote":false,"./SettingsRemoteOutlined":false,"./SettingsRemoteRounded":false,"./SettingsRemoteSharp":false,"./SettingsRemoteTwoTone":false,"./SettingsRounded":false,"./SettingsSharp":false,"./SettingsSuggest":false,"./SettingsSuggestOutlined":false,"./SettingsSuggestRounded":false,"./SettingsSuggestSharp":false,"./SettingsSuggestTwoTone":false,"./SettingsSystemDaydream":false,"./SettingsSystemDaydreamOutlined":false,"./SettingsSystemDaydreamRounded":false,"./SettingsSystemDaydreamSharp":false,"./SettingsSystemDaydreamTwoTone":false,"./SettingsTwoTone":false,"./SettingsVoice":false,"./SettingsVoiceOutlined":false,"./SettingsVoiceRounded":false,"./SettingsVoiceSharp":false,"./SettingsVoiceTwoTone":false,"./SevenK":false,"./SevenKOutlined":false,"./SevenKPlus":false,"./SevenKPlusOutlined":false,"./SevenKPlusRounded":false,"./SevenKPlusSharp":false,"./SevenKPlusTwoTone":false,"./SevenKRounded":false,"./SevenKSharp":false,"./SevenKTwoTone":false,"./SevenMp":false,"./SevenMpOutlined":false,"./SevenMpRounded":false,"./SevenMpSharp":false,"./SevenMpTwoTone":false,"./SeventeenMp":false,"./SeventeenMpOutlined":false,"./SeventeenMpRounded":false,"./SeventeenMpSharp":false,"./SeventeenMpTwoTone":false,"./SevereCold":false,"./SevereColdOutlined":false,"./SevereColdRounded":false,"./SevereColdSharp":false,"./SevereColdTwoTone":false,"./ShapeLine":false,"./ShapeLineOutlined":false,"./ShapeLineRounded":false,"./ShapeLineSharp":false,"./ShapeLineTwoTone":false,"./Share":false,"./ShareLocation":false,"./ShareLocationOutlined":false,"./ShareLocationRounded":false,"./ShareLocationSharp":false,"./ShareLocationTwoTone":false,"./ShareOutlined":false,"./ShareRounded":false,"./ShareSharp":false,"./ShareTwoTone":false,"./Shield":false,"./ShieldMoon":false,"./ShieldMoonOutlined":false,"./ShieldMoonRounded":false,"./ShieldMoonSharp":false,"./ShieldMoonTwoTone":false,"./ShieldOutlined":false,"./ShieldRounded":false,"./ShieldSharp":false,"./ShieldTwoTone":false,"./Shop":false,"./Shop2":false,"./Shop2Outlined":false,"./Shop2Rounded":false,"./Shop2Sharp":false,"./Shop2TwoTone":false,"./ShopOutlined":false,"./ShopRounded":false,"./ShopSharp":false,"./ShopTwo":false,"./ShopTwoOutlined":false,"./ShopTwoRounded":false,"./ShopTwoSharp":false,"./ShopTwoTone":false,"./ShopTwoTwoTone":false,"./ShoppingBag":false,"./ShoppingBagOutlined":false,"./ShoppingBagRounded":false,"./ShoppingBagSharp":false,"./ShoppingBagTwoTone":false,"./ShoppingBasket":false,"./ShoppingBasketOutlined":false,"./ShoppingBasketRounded":false,"./ShoppingBasketSharp":false,"./ShoppingBasketTwoTone":false,"./ShoppingCart":false,"./ShoppingCartCheckout":false,"./ShoppingCartCheckoutOutlined":false,"./ShoppingCartCheckoutRounded":false,"./ShoppingCartCheckoutSharp":false,"./ShoppingCartCheckoutTwoTone":false,"./ShoppingCartOutlined":false,"./ShoppingCartRounded":false,"./ShoppingCartSharp":false,"./ShoppingCartTwoTone":false,"./ShortText":false,"./ShortTextOutlined":false,"./ShortTextRounded":false,"./ShortTextSharp":false,"./ShortTextTwoTone":false,"./Shortcut":false,"./ShortcutOutlined":false,"./ShortcutRounded":false,"./ShortcutSharp":false,"./ShortcutTwoTone":false,"./ShowChart":false,"./ShowChartOutlined":false,"./ShowChartRounded":false,"./ShowChartSharp":false,"./ShowChartTwoTone":false,"./Shower":false,"./ShowerOutlined":false,"./ShowerRounded":false,"./ShowerSharp":false,"./ShowerTwoTone":false,"./Shuffle":false,"./ShuffleOn":false,"./ShuffleOnOutlined":false,"./ShuffleOnRounded":false,"./ShuffleOnSharp":false,"./ShuffleOnTwoTone":false,"./ShuffleOutlined":false,"./ShuffleRounded":false,"./ShuffleSharp":false,"./ShuffleTwoTone":false,"./ShutterSpeed":false,"./ShutterSpeedOutlined":false,"./ShutterSpeedRounded":false,"./ShutterSpeedSharp":false,"./ShutterSpeedTwoTone":false,"./Sick":false,"./SickOutlined":false,"./SickRounded":false,"./SickSharp":false,"./SickTwoTone":false,"./SignLanguage":false,"./SignLanguageOutlined":false,"./SignLanguageRounded":false,"./SignLanguageSharp":false,"./SignLanguageTwoTone":false,"./SignalCellular0Bar":false,"./SignalCellular0BarOutlined":false,"./SignalCellular0BarRounded":false,"./SignalCellular0BarSharp":false,"./SignalCellular0BarTwoTone":false,"./SignalCellular1Bar":false,"./SignalCellular1BarOutlined":false,"./SignalCellular1BarRounded":false,"./SignalCellular1BarSharp":false,"./SignalCellular1BarTwoTone":false,"./SignalCellular2Bar":false,"./SignalCellular2BarOutlined":false,"./SignalCellular2BarRounded":false,"./SignalCellular2BarSharp":false,"./SignalCellular2BarTwoTone":false,"./SignalCellular3Bar":false,"./SignalCellular3BarOutlined":false,"./SignalCellular3BarRounded":false,"./SignalCellular3BarSharp":false,"./SignalCellular3BarTwoTone":false,"./SignalCellular4Bar":false,"./SignalCellular4BarOutlined":false,"./SignalCellular4BarRounded":false,"./SignalCellular4BarSharp":false,"./SignalCellular4BarTwoTone":false,"./SignalCellularAlt":false,"./SignalCellularAlt1Bar":false,"./SignalCellularAlt1BarOutlined":false,"./SignalCellularAlt1BarRounded":false,"./SignalCellularAlt1BarSharp":false,"./SignalCellularAlt1BarTwoTone":false,"./SignalCellularAlt2Bar":false,"./SignalCellularAlt2BarOutlined":false,"./SignalCellularAlt2BarRounded":false,"./SignalCellularAlt2BarSharp":false,"./SignalCellularAlt2BarTwoTone":false,"./SignalCellularAltOutlined":false,"./SignalCellularAltRounded":false,"./SignalCellularAltSharp":false,"./SignalCellularAltTwoTone":false,"./SignalCellularConnectedNoInternet0Bar":false,"./SignalCellularConnectedNoInternet0BarOutlined":false,"./SignalCellularConnectedNoInternet0BarRounded":false,"./SignalCellularConnectedNoInternet0BarSharp":false,"./SignalCellularConnectedNoInternet0BarTwoTone":false,"./SignalCellularConnectedNoInternet1Bar":false,"./SignalCellularConnectedNoInternet1BarOutlined":false,"./SignalCellularConnectedNoInternet1BarRounded":false,"./SignalCellularConnectedNoInternet1BarSharp":false,"./SignalCellularConnectedNoInternet1BarTwoTone":false,"./SignalCellularConnectedNoInternet2Bar":false,"./SignalCellularConnectedNoInternet2BarOutlined":false,"./SignalCellularConnectedNoInternet2BarRounded":false,"./SignalCellularConnectedNoInternet2BarSharp":false,"./SignalCellularConnectedNoInternet2BarTwoTone":false,"./SignalCellularConnectedNoInternet3Bar":false,"./SignalCellularConnectedNoInternet3BarOutlined":false,"./SignalCellularConnectedNoInternet3BarRounded":false,"./SignalCellularConnectedNoInternet3BarSharp":false,"./SignalCellularConnectedNoInternet3BarTwoTone":false,"./SignalCellularConnectedNoInternet4Bar":false,"./SignalCellularConnectedNoInternet4BarOutlined":false,"./SignalCellularConnectedNoInternet4BarRounded":false,"./SignalCellularConnectedNoInternet4BarSharp":false,"./SignalCellularConnectedNoInternet4BarTwoTone":false,"./SignalCellularNoSim":false,"./SignalCellularNoSimOutlined":false,"./SignalCellularNoSimRounded":false,"./SignalCellularNoSimSharp":false,"./SignalCellularNoSimTwoTone":false,"./SignalCellularNodata":false,"./SignalCellularNodataOutlined":false,"./SignalCellularNodataRounded":false,"./SignalCellularNodataSharp":false,"./SignalCellularNodataTwoTone":false,"./SignalCellularNull":false,"./SignalCellularNullOutlined":false,"./SignalCellularNullRounded":false,"./SignalCellularNullSharp":false,"./SignalCellularNullTwoTone":false,"./SignalCellularOff":false,"./SignalCellularOffOutlined":false,"./SignalCellularOffRounded":false,"./SignalCellularOffSharp":false,"./SignalCellularOffTwoTone":false,"./SignalWifi0Bar":false,"./SignalWifi0BarOutlined":false,"./SignalWifi0BarRounded":false,"./SignalWifi0BarSharp":false,"./SignalWifi0BarTwoTone":false,"./SignalWifi1Bar":false,"./SignalWifi1BarLock":false,"./SignalWifi1BarLockOutlined":false,"./SignalWifi1BarLockRounded":false,"./SignalWifi1BarLockSharp":false,"./SignalWifi1BarLockTwoTone":false,"./SignalWifi1BarOutlined":false,"./SignalWifi1BarRounded":false,"./SignalWifi1BarSharp":false,"./SignalWifi1BarTwoTone":false,"./SignalWifi2Bar":false,"./SignalWifi2BarLock":false,"./SignalWifi2BarLockOutlined":false,"./SignalWifi2BarLockRounded":false,"./SignalWifi2BarLockSharp":false,"./SignalWifi2BarLockTwoTone":false,"./SignalWifi2BarOutlined":false,"./SignalWifi2BarRounded":false,"./SignalWifi2BarSharp":false,"./SignalWifi2BarTwoTone":false,"./SignalWifi3Bar":false,"./SignalWifi3BarLock":false,"./SignalWifi3BarLockOutlined":false,"./SignalWifi3BarLockRounded":false,"./SignalWifi3BarLockSharp":false,"./SignalWifi3BarLockTwoTone":false,"./SignalWifi3BarOutlined":false,"./SignalWifi3BarRounded":false,"./SignalWifi3BarSharp":false,"./SignalWifi3BarTwoTone":false,"./SignalWifi4Bar":false,"./SignalWifi4BarLock":false,"./SignalWifi4BarLockOutlined":false,"./SignalWifi4BarLockRounded":false,"./SignalWifi4BarLockSharp":false,"./SignalWifi4BarLockTwoTone":false,"./SignalWifi4BarOutlined":false,"./SignalWifi4BarRounded":false,"./SignalWifi4BarSharp":false,"./SignalWifi4BarTwoTone":false,"./SignalWifiBad":false,"./SignalWifiBadOutlined":false,"./SignalWifiBadRounded":false,"./SignalWifiBadSharp":false,"./SignalWifiBadTwoTone":false,"./SignalWifiConnectedNoInternet4":false,"./SignalWifiConnectedNoInternet4Outlined":false,"./SignalWifiConnectedNoInternet4Rounded":false,"./SignalWifiConnectedNoInternet4Sharp":false,"./SignalWifiConnectedNoInternet4TwoTone":false,"./SignalWifiOff":false,"./SignalWifiOffOutlined":false,"./SignalWifiOffRounded":false,"./SignalWifiOffSharp":false,"./SignalWifiOffTwoTone":false,"./SignalWifiStatusbar4Bar":false,"./SignalWifiStatusbar4BarOutlined":false,"./SignalWifiStatusbar4BarRounded":false,"./SignalWifiStatusbar4BarSharp":false,"./SignalWifiStatusbar4BarTwoTone":false,"./SignalWifiStatusbarConnectedNoInternet4":false,"./SignalWifiStatusbarConnectedNoInternet4Outlined":false,"./SignalWifiStatusbarConnectedNoInternet4Rounded":false,"./SignalWifiStatusbarConnectedNoInternet4Sharp":false,"./SignalWifiStatusbarConnectedNoInternet4TwoTone":false,"./SignalWifiStatusbarNull":false,"./SignalWifiStatusbarNullOutlined":false,"./SignalWifiStatusbarNullRounded":false,"./SignalWifiStatusbarNullSharp":false,"./SignalWifiStatusbarNullTwoTone":false,"./Signpost":false,"./SignpostOutlined":false,"./SignpostRounded":false,"./SignpostSharp":false,"./SignpostTwoTone":false,"./SimCard":false,"./SimCardAlert":false,"./SimCardAlertOutlined":false,"./SimCardAlertRounded":false,"./SimCardAlertSharp":false,"./SimCardAlertTwoTone":false,"./SimCardDownload":false,"./SimCardDownloadOutlined":false,"./SimCardDownloadRounded":false,"./SimCardDownloadSharp":false,"./SimCardDownloadTwoTone":false,"./SimCardOutlined":false,"./SimCardRounded":false,"./SimCardSharp":false,"./SimCardTwoTone":false,"./SingleBed":false,"./SingleBedOutlined":false,"./SingleBedRounded":false,"./SingleBedSharp":false,"./SingleBedTwoTone":false,"./Sip":false,"./SipOutlined":false,"./SipRounded":false,"./SipSharp":false,"./SipTwoTone":false,"./SixK":false,"./SixKOutlined":false,"./SixKPlus":false,"./SixKPlusOutlined":false,"./SixKPlusRounded":false,"./SixKPlusSharp":false,"./SixKPlusTwoTone":false,"./SixKRounded":false,"./SixKSharp":false,"./SixKTwoTone":false,"./SixMp":false,"./SixMpOutlined":false,"./SixMpRounded":false,"./SixMpSharp":false,"./SixMpTwoTone":false,"./SixteenMp":false,"./SixteenMpOutlined":false,"./SixteenMpRounded":false,"./SixteenMpSharp":false,"./SixteenMpTwoTone":false,"./SixtyFps":false,"./SixtyFpsOutlined":false,"./SixtyFpsRounded":false,"./SixtyFpsSelect":false,"./SixtyFpsSelectOutlined":false,"./SixtyFpsSelectRounded":false,"./SixtyFpsSelectSharp":false,"./SixtyFpsSelectTwoTone":false,"./SixtyFpsSharp":false,"./SixtyFpsTwoTone":false,"./Skateboarding":false,"./SkateboardingOutlined":false,"./SkateboardingRounded":false,"./SkateboardingSharp":false,"./SkateboardingTwoTone":false,"./SkipNext":false,"./SkipNextOutlined":false,"./SkipNextRounded":false,"./SkipNextSharp":false,"./SkipNextTwoTone":false,"./SkipPrevious":false,"./SkipPreviousOutlined":false,"./SkipPreviousRounded":false,"./SkipPreviousSharp":false,"./SkipPreviousTwoTone":false,"./Sledding":false,"./SleddingOutlined":false,"./SleddingRounded":false,"./SleddingSharp":false,"./SleddingTwoTone":false,"./Slideshow":false,"./SlideshowOutlined":false,"./SlideshowRounded":false,"./SlideshowSharp":false,"./SlideshowTwoTone":false,"./SlowMotionVideo":false,"./SlowMotionVideoOutlined":false,"./SlowMotionVideoRounded":false,"./SlowMotionVideoSharp":false,"./SlowMotionVideoTwoTone":false,"./SmartButton":false,"./SmartButtonOutlined":false,"./SmartButtonRounded":false,"./SmartButtonSharp":false,"./SmartButtonTwoTone":false,"./SmartDisplay":false,"./SmartDisplayOutlined":false,"./SmartDisplayRounded":false,"./SmartDisplaySharp":false,"./SmartDisplayTwoTone":false,"./SmartScreen":false,"./SmartScreenOutlined":false,"./SmartScreenRounded":false,"./SmartScreenSharp":false,"./SmartScreenTwoTone":false,"./SmartToy":false,"./SmartToyOutlined":false,"./SmartToyRounded":false,"./SmartToySharp":false,"./SmartToyTwoTone":false,"./Smartphone":false,"./SmartphoneOutlined":false,"./SmartphoneRounded":false,"./SmartphoneSharp":false,"./SmartphoneTwoTone":false,"./SmokeFree":false,"./SmokeFreeOutlined":false,"./SmokeFreeRounded":false,"./SmokeFreeSharp":false,"./SmokeFreeTwoTone":false,"./SmokingRooms":false,"./SmokingRoomsOutlined":false,"./SmokingRoomsRounded":false,"./SmokingRoomsSharp":false,"./SmokingRoomsTwoTone":false,"./Sms":false,"./SmsFailed":false,"./SmsFailedOutlined":false,"./SmsFailedRounded":false,"./SmsFailedSharp":false,"./SmsFailedTwoTone":false,"./SmsOutlined":false,"./SmsRounded":false,"./SmsSharp":false,"./SmsTwoTone":false,"./SnippetFolder":false,"./SnippetFolderOutlined":false,"./SnippetFolderRounded":false,"./SnippetFolderSharp":false,"./SnippetFolderTwoTone":false,"./Snooze":false,"./SnoozeOutlined":false,"./SnoozeRounded":false,"./SnoozeSharp":false,"./SnoozeTwoTone":false,"./Snowboarding":false,"./SnowboardingOutlined":false,"./SnowboardingRounded":false,"./SnowboardingSharp":false,"./SnowboardingTwoTone":false,"./Snowmobile":false,"./SnowmobileOutlined":false,"./SnowmobileRounded":false,"./SnowmobileSharp":false,"./SnowmobileTwoTone":false,"./Snowshoeing":false,"./SnowshoeingOutlined":false,"./SnowshoeingRounded":false,"./SnowshoeingSharp":false,"./SnowshoeingTwoTone":false,"./Soap":false,"./SoapOutlined":false,"./SoapRounded":false,"./SoapSharp":false,"./SoapTwoTone":false,"./SocialDistance":false,"./SocialDistanceOutlined":false,"./SocialDistanceRounded":false,"./SocialDistanceSharp":false,"./SocialDistanceTwoTone":false,"./SolarPower":false,"./SolarPowerOutlined":false,"./SolarPowerRounded":false,"./SolarPowerSharp":false,"./SolarPowerTwoTone":false,"./Sort":false,"./SortByAlpha":false,"./SortByAlphaOutlined":false,"./SortByAlphaRounded":false,"./SortByAlphaSharp":false,"./SortByAlphaTwoTone":false,"./SortOutlined":false,"./SortRounded":false,"./SortSharp":false,"./SortTwoTone":false,"./Sos":false,"./SosOutlined":false,"./SosRounded":false,"./SosSharp":false,"./SosTwoTone":false,"./SoupKitchen":false,"./SoupKitchenOutlined":false,"./SoupKitchenRounded":false,"./SoupKitchenSharp":false,"./SoupKitchenTwoTone":false,"./Source":false,"./SourceOutlined":false,"./SourceRounded":false,"./SourceSharp":false,"./SourceTwoTone":false,"./South":false,"./SouthAmerica":false,"./SouthAmericaOutlined":false,"./SouthAmericaRounded":false,"./SouthAmericaSharp":false,"./SouthAmericaTwoTone":false,"./SouthEast":false,"./SouthEastOutlined":false,"./SouthEastRounded":false,"./SouthEastSharp":false,"./SouthEastTwoTone":false,"./SouthOutlined":false,"./SouthRounded":false,"./SouthSharp":false,"./SouthTwoTone":false,"./SouthWest":false,"./SouthWestOutlined":false,"./SouthWestRounded":false,"./SouthWestSharp":false,"./SouthWestTwoTone":false,"./Spa":false,"./SpaOutlined":false,"./SpaRounded":false,"./SpaSharp":false,"./SpaTwoTone":false,"./SpaceBar":false,"./SpaceBarOutlined":false,"./SpaceBarRounded":false,"./SpaceBarSharp":false,"./SpaceBarTwoTone":false,"./SpaceDashboard":false,"./SpaceDashboardOutlined":false,"./SpaceDashboardRounded":false,"./SpaceDashboardSharp":false,"./SpaceDashboardTwoTone":false,"./SpatialAudio":false,"./SpatialAudioOff":false,"./SpatialAudioOffOutlined":false,"./SpatialAudioOffRounded":false,"./SpatialAudioOffSharp":false,"./SpatialAudioOffTwoTone":false,"./SpatialAudioOutlined":false,"./SpatialAudioRounded":false,"./SpatialAudioSharp":false,"./SpatialAudioTwoTone":false,"./SpatialTracking":false,"./SpatialTrackingOutlined":false,"./SpatialTrackingRounded":false,"./SpatialTrackingSharp":false,"./SpatialTrackingTwoTone":false,"./Speaker":false,"./SpeakerGroup":false,"./SpeakerGroupOutlined":false,"./SpeakerGroupRounded":false,"./SpeakerGroupSharp":false,"./SpeakerGroupTwoTone":false,"./SpeakerNotes":false,"./SpeakerNotesOff":false,"./SpeakerNotesOffOutlined":false,"./SpeakerNotesOffRounded":false,"./SpeakerNotesOffSharp":false,"./SpeakerNotesOffTwoTone":false,"./SpeakerNotesOutlined":false,"./SpeakerNotesRounded":false,"./SpeakerNotesSharp":false,"./SpeakerNotesTwoTone":false,"./SpeakerOutlined":false,"./SpeakerPhone":false,"./SpeakerPhoneOutlined":false,"./SpeakerPhoneRounded":false,"./SpeakerPhoneSharp":false,"./SpeakerPhoneTwoTone":false,"./SpeakerRounded":false,"./SpeakerSharp":false,"./SpeakerTwoTone":false,"./Speed":false,"./SpeedOutlined":false,"./SpeedRounded":false,"./SpeedSharp":false,"./SpeedTwoTone":false,"./Spellcheck":false,"./SpellcheckOutlined":false,"./SpellcheckRounded":false,"./SpellcheckSharp":false,"./SpellcheckTwoTone":false,"./Splitscreen":false,"./SplitscreenOutlined":false,"./SplitscreenRounded":false,"./SplitscreenSharp":false,"./SplitscreenTwoTone":false,"./Spoke":false,"./SpokeOutlined":false,"./SpokeRounded":false,"./SpokeSharp":false,"./SpokeTwoTone":false,"./Sports":false,"./SportsBar":false,"./SportsBarOutlined":false,"./SportsBarRounded":false,"./SportsBarSharp":false,"./SportsBarTwoTone":false,"./SportsBaseball":false,"./SportsBaseballOutlined":false,"./SportsBaseballRounded":false,"./SportsBaseballSharp":false,"./SportsBaseballTwoTone":false,"./SportsBasketball":false,"./SportsBasketballOutlined":false,"./SportsBasketballRounded":false,"./SportsBasketballSharp":false,"./SportsBasketballTwoTone":false,"./SportsCricket":false,"./SportsCricketOutlined":false,"./SportsCricketRounded":false,"./SportsCricketSharp":false,"./SportsCricketTwoTone":false,"./SportsEsports":false,"./SportsEsportsOutlined":false,"./SportsEsportsRounded":false,"./SportsEsportsSharp":false,"./SportsEsportsTwoTone":false,"./SportsFootball":false,"./SportsFootballOutlined":false,"./SportsFootballRounded":false,"./SportsFootballSharp":false,"./SportsFootballTwoTone":false,"./SportsGolf":false,"./SportsGolfOutlined":false,"./SportsGolfRounded":false,"./SportsGolfSharp":false,"./SportsGolfTwoTone":false,"./SportsGymnastics":false,"./SportsGymnasticsOutlined":false,"./SportsGymnasticsRounded":false,"./SportsGymnasticsSharp":false,"./SportsGymnasticsTwoTone":false,"./SportsHandball":false,"./SportsHandballOutlined":false,"./SportsHandballRounded":false,"./SportsHandballSharp":false,"./SportsHandballTwoTone":false,"./SportsHockey":false,"./SportsHockeyOutlined":false,"./SportsHockeyRounded":false,"./SportsHockeySharp":false,"./SportsHockeyTwoTone":false,"./SportsKabaddi":false,"./SportsKabaddiOutlined":false,"./SportsKabaddiRounded":false,"./SportsKabaddiSharp":false,"./SportsKabaddiTwoTone":false,"./SportsMartialArts":false,"./SportsMartialArtsOutlined":false,"./SportsMartialArtsRounded":false,"./SportsMartialArtsSharp":false,"./SportsMartialArtsTwoTone":false,"./SportsMma":false,"./SportsMmaOutlined":false,"./SportsMmaRounded":false,"./SportsMmaSharp":false,"./SportsMmaTwoTone":false,"./SportsMotorsports":false,"./SportsMotorsportsOutlined":false,"./SportsMotorsportsRounded":false,"./SportsMotorsportsSharp":false,"./SportsMotorsportsTwoTone":false,"./SportsOutlined":false,"./SportsRounded":false,"./SportsRugby":false,"./SportsRugbyOutlined":false,"./SportsRugbyRounded":false,"./SportsRugbySharp":false,"./SportsRugbyTwoTone":false,"./SportsScore":false,"./SportsScoreOutlined":false,"./SportsScoreRounded":false,"./SportsScoreSharp":false,"./SportsScoreTwoTone":false,"./SportsSharp":false,"./SportsSoccer":false,"./SportsSoccerOutlined":false,"./SportsSoccerRounded":false,"./SportsSoccerSharp":false,"./SportsSoccerTwoTone":false,"./SportsTennis":false,"./SportsTennisOutlined":false,"./SportsTennisRounded":false,"./SportsTennisSharp":false,"./SportsTennisTwoTone":false,"./SportsTwoTone":false,"./SportsVolleyball":false,"./SportsVolleyballOutlined":false,"./SportsVolleyballRounded":false,"./SportsVolleyballSharp":false,"./SportsVolleyballTwoTone":false,"./Square":false,"./SquareFoot":false,"./SquareFootOutlined":false,"./SquareFootRounded":false,"./SquareFootSharp":false,"./SquareFootTwoTone":false,"./SquareOutlined":false,"./SquareRounded":false,"./SquareSharp":false,"./SquareTwoTone":false,"./SsidChart":false,"./SsidChartOutlined":false,"./SsidChartRounded":false,"./SsidChartSharp":false,"./SsidChartTwoTone":false,"./StackedBarChart":false,"./StackedBarChartOutlined":false,"./StackedBarChartRounded":false,"./StackedBarChartSharp":false,"./StackedBarChartTwoTone":false,"./StackedLineChart":"1rAOp","./StackedLineChartOutlined":false,"./StackedLineChartRounded":false,"./StackedLineChartSharp":false,"./StackedLineChartTwoTone":false,"./Stadium":false,"./StadiumOutlined":false,"./StadiumRounded":false,"./StadiumSharp":false,"./StadiumTwoTone":false,"./Stairs":false,"./StairsOutlined":false,"./StairsRounded":false,"./StairsSharp":false,"./StairsTwoTone":false,"./Star":false,"./StarBorder":false,"./StarBorderOutlined":false,"./StarBorderPurple500":false,"./StarBorderPurple500Outlined":false,"./StarBorderPurple500Rounded":false,"./StarBorderPurple500Sharp":false,"./StarBorderPurple500TwoTone":false,"./StarBorderRounded":false,"./StarBorderSharp":false,"./StarBorderTwoTone":false,"./StarHalf":false,"./StarHalfOutlined":false,"./StarHalfRounded":false,"./StarHalfSharp":false,"./StarHalfTwoTone":false,"./StarOutline":false,"./StarOutlineOutlined":false,"./StarOutlineRounded":false,"./StarOutlineSharp":false,"./StarOutlineTwoTone":false,"./StarOutlined":false,"./StarPurple500":false,"./StarPurple500Outlined":false,"./StarPurple500Rounded":false,"./StarPurple500Sharp":false,"./StarPurple500TwoTone":false,"./StarRate":false,"./StarRateOutlined":false,"./StarRateRounded":false,"./StarRateSharp":false,"./StarRateTwoTone":false,"./StarRounded":false,"./StarSharp":false,"./StarTwoTone":false,"./Stars":false,"./StarsOutlined":false,"./StarsRounded":false,"./StarsSharp":false,"./StarsTwoTone":false,"./Start":false,"./StartOutlined":false,"./StartRounded":false,"./StartSharp":false,"./StartTwoTone":false,"./StayCurrentLandscape":false,"./StayCurrentLandscapeOutlined":false,"./StayCurrentLandscapeRounded":false,"./StayCurrentLandscapeSharp":false,"./StayCurrentLandscapeTwoTone":false,"./StayCurrentPortrait":false,"./StayCurrentPortraitOutlined":false,"./StayCurrentPortraitRounded":false,"./StayCurrentPortraitSharp":false,"./StayCurrentPortraitTwoTone":false,"./StayPrimaryLandscape":false,"./StayPrimaryLandscapeOutlined":false,"./StayPrimaryLandscapeRounded":false,"./StayPrimaryLandscapeSharp":false,"./StayPrimaryLandscapeTwoTone":false,"./StayPrimaryPortrait":false,"./StayPrimaryPortraitOutlined":false,"./StayPrimaryPortraitRounded":false,"./StayPrimaryPortraitSharp":false,"./StayPrimaryPortraitTwoTone":false,"./StickyNote2":false,"./StickyNote2Outlined":false,"./StickyNote2Rounded":false,"./StickyNote2Sharp":false,"./StickyNote2TwoTone":false,"./Stop":false,"./StopCircle":false,"./StopCircleOutlined":false,"./StopCircleRounded":false,"./StopCircleSharp":false,"./StopCircleTwoTone":false,"./StopOutlined":false,"./StopRounded":false,"./StopScreenShare":false,"./StopScreenShareOutlined":false,"./StopScreenShareRounded":false,"./StopScreenShareSharp":false,"./StopScreenShareTwoTone":false,"./StopSharp":false,"./StopTwoTone":false,"./Storage":false,"./StorageOutlined":false,"./StorageRounded":false,"./StorageSharp":false,"./StorageTwoTone":false,"./Store":false,"./StoreMallDirectory":false,"./StoreMallDirectoryOutlined":false,"./StoreMallDirectoryRounded":false,"./StoreMallDirectorySharp":false,"./StoreMallDirectoryTwoTone":false,"./StoreOutlined":false,"./StoreRounded":false,"./StoreSharp":false,"./StoreTwoTone":false,"./Storefront":false,"./StorefrontOutlined":false,"./StorefrontRounded":false,"./StorefrontSharp":false,"./StorefrontTwoTone":false,"./Storm":false,"./StormOutlined":false,"./StormRounded":false,"./StormSharp":false,"./StormTwoTone":false,"./Straight":false,"./StraightOutlined":false,"./StraightRounded":false,"./StraightSharp":false,"./StraightTwoTone":false,"./Straighten":false,"./StraightenOutlined":false,"./StraightenRounded":false,"./StraightenSharp":false,"./StraightenTwoTone":false,"./Stream":false,"./StreamOutlined":false,"./StreamRounded":false,"./StreamSharp":false,"./StreamTwoTone":false,"./Streetview":false,"./StreetviewOutlined":false,"./StreetviewRounded":false,"./StreetviewSharp":false,"./StreetviewTwoTone":false,"./StrikethroughS":false,"./StrikethroughSOutlined":false,"./StrikethroughSRounded":false,"./StrikethroughSSharp":false,"./StrikethroughSTwoTone":false,"./Stroller":false,"./StrollerOutlined":false,"./StrollerRounded":false,"./StrollerSharp":false,"./StrollerTwoTone":false,"./Style":false,"./StyleOutlined":false,"./StyleRounded":false,"./StyleSharp":false,"./StyleTwoTone":false,"./SubdirectoryArrowLeft":false,"./SubdirectoryArrowLeftOutlined":false,"./SubdirectoryArrowLeftRounded":false,"./SubdirectoryArrowLeftSharp":false,"./SubdirectoryArrowLeftTwoTone":false,"./SubdirectoryArrowRight":false,"./SubdirectoryArrowRightOutlined":false,"./SubdirectoryArrowRightRounded":false,"./SubdirectoryArrowRightSharp":false,"./SubdirectoryArrowRightTwoTone":false,"./Subject":false,"./SubjectOutlined":false,"./SubjectRounded":false,"./SubjectSharp":false,"./SubjectTwoTone":false,"./Subscript":false,"./SubscriptOutlined":false,"./SubscriptRounded":false,"./SubscriptSharp":false,"./SubscriptTwoTone":false,"./Subscriptions":false,"./SubscriptionsOutlined":false,"./SubscriptionsRounded":false,"./SubscriptionsSharp":false,"./SubscriptionsTwoTone":false,"./Subtitles":false,"./SubtitlesOff":false,"./SubtitlesOffOutlined":false,"./SubtitlesOffRounded":false,"./SubtitlesOffSharp":false,"./SubtitlesOffTwoTone":false,"./SubtitlesOutlined":false,"./SubtitlesRounded":false,"./SubtitlesSharp":false,"./SubtitlesTwoTone":false,"./Subway":false,"./SubwayOutlined":false,"./SubwayRounded":false,"./SubwaySharp":false,"./SubwayTwoTone":false,"./Summarize":false,"./SummarizeOutlined":false,"./SummarizeRounded":false,"./SummarizeSharp":false,"./SummarizeTwoTone":false,"./Superscript":false,"./SuperscriptOutlined":false,"./SuperscriptRounded":false,"./SuperscriptSharp":false,"./SuperscriptTwoTone":false,"./SupervisedUserCircle":false,"./SupervisedUserCircleOutlined":false,"./SupervisedUserCircleRounded":false,"./SupervisedUserCircleSharp":false,"./SupervisedUserCircleTwoTone":false,"./SupervisorAccount":false,"./SupervisorAccountOutlined":false,"./SupervisorAccountRounded":false,"./SupervisorAccountSharp":false,"./SupervisorAccountTwoTone":false,"./Support":false,"./SupportAgent":false,"./SupportAgentOutlined":false,"./SupportAgentRounded":false,"./SupportAgentSharp":false,"./SupportAgentTwoTone":false,"./SupportOutlined":false,"./SupportRounded":false,"./SupportSharp":false,"./SupportTwoTone":false,"./Surfing":false,"./SurfingOutlined":false,"./SurfingRounded":false,"./SurfingSharp":false,"./SurfingTwoTone":false,"./SurroundSound":false,"./SurroundSoundOutlined":false,"./SurroundSoundRounded":false,"./SurroundSoundSharp":false,"./SurroundSoundTwoTone":false,"./SwapCalls":false,"./SwapCallsOutlined":false,"./SwapCallsRounded":false,"./SwapCallsSharp":false,"./SwapCallsTwoTone":false,"./SwapHoriz":false,"./SwapHorizOutlined":false,"./SwapHorizRounded":false,"./SwapHorizSharp":false,"./SwapHorizTwoTone":false,"./SwapHorizontalCircle":false,"./SwapHorizontalCircleOutlined":false,"./SwapHorizontalCircleRounded":false,"./SwapHorizontalCircleSharp":false,"./SwapHorizontalCircleTwoTone":false,"./SwapVert":false,"./SwapVertOutlined":false,"./SwapVertRounded":false,"./SwapVertSharp":false,"./SwapVertTwoTone":false,"./SwapVerticalCircle":false,"./SwapVerticalCircleOutlined":false,"./SwapVerticalCircleRounded":false,"./SwapVerticalCircleSharp":false,"./SwapVerticalCircleTwoTone":false,"./Swipe":false,"./SwipeDown":false,"./SwipeDownAlt":false,"./SwipeDownAltOutlined":false,"./SwipeDownAltRounded":false,"./SwipeDownAltSharp":false,"./SwipeDownAltTwoTone":false,"./SwipeDownOutlined":false,"./SwipeDownRounded":false,"./SwipeDownSharp":false,"./SwipeDownTwoTone":false,"./SwipeLeft":false,"./SwipeLeftAlt":false,"./SwipeLeftAltOutlined":false,"./SwipeLeftAltRounded":false,"./SwipeLeftAltSharp":false,"./SwipeLeftAltTwoTone":false,"./SwipeLeftOutlined":false,"./SwipeLeftRounded":false,"./SwipeLeftSharp":false,"./SwipeLeftTwoTone":false,"./SwipeOutlined":false,"./SwipeRight":false,"./SwipeRightAlt":false,"./SwipeRightAltOutlined":false,"./SwipeRightAltRounded":false,"./SwipeRightAltSharp":false,"./SwipeRightAltTwoTone":false,"./SwipeRightOutlined":false,"./SwipeRightRounded":false,"./SwipeRightSharp":false,"./SwipeRightTwoTone":false,"./SwipeRounded":false,"./SwipeSharp":false,"./SwipeTwoTone":false,"./SwipeUp":false,"./SwipeUpAlt":false,"./SwipeUpAltOutlined":false,"./SwipeUpAltRounded":false,"./SwipeUpAltSharp":false,"./SwipeUpAltTwoTone":false,"./SwipeUpOutlined":false,"./SwipeUpRounded":false,"./SwipeUpSharp":false,"./SwipeUpTwoTone":false,"./SwipeVertical":false,"./SwipeVerticalOutlined":false,"./SwipeVerticalRounded":false,"./SwipeVerticalSharp":false,"./SwipeVerticalTwoTone":false,"./SwitchAccessShortcut":false,"./SwitchAccessShortcutAdd":false,"./SwitchAccessShortcutAddOutlined":false,"./SwitchAccessShortcutAddRounded":false,"./SwitchAccessShortcutAddSharp":false,"./SwitchAccessShortcutAddTwoTone":false,"./SwitchAccessShortcutOutlined":false,"./SwitchAccessShortcutRounded":false,"./SwitchAccessShortcutSharp":false,"./SwitchAccessShortcutTwoTone":false,"./SwitchAccount":false,"./SwitchAccountOutlined":false,"./SwitchAccountRounded":false,"./SwitchAccountSharp":false,"./SwitchAccountTwoTone":false,"./SwitchCamera":false,"./SwitchCameraOutlined":false,"./SwitchCameraRounded":false,"./SwitchCameraSharp":false,"./SwitchCameraTwoTone":false,"./SwitchLeft":false,"./SwitchLeftOutlined":false,"./SwitchLeftRounded":false,"./SwitchLeftSharp":false,"./SwitchLeftTwoTone":false,"./SwitchRight":false,"./SwitchRightOutlined":false,"./SwitchRightRounded":false,"./SwitchRightSharp":false,"./SwitchRightTwoTone":false,"./SwitchVideo":false,"./SwitchVideoOutlined":false,"./SwitchVideoRounded":false,"./SwitchVideoSharp":false,"./SwitchVideoTwoTone":false,"./Synagogue":false,"./SynagogueOutlined":false,"./SynagogueRounded":false,"./SynagogueSharp":false,"./SynagogueTwoTone":false,"./Sync":false,"./SyncAlt":false,"./SyncAltOutlined":false,"./SyncAltRounded":false,"./SyncAltSharp":false,"./SyncAltTwoTone":false,"./SyncDisabled":false,"./SyncDisabledOutlined":false,"./SyncDisabledRounded":false,"./SyncDisabledSharp":false,"./SyncDisabledTwoTone":false,"./SyncLock":false,"./SyncLockOutlined":false,"./SyncLockRounded":false,"./SyncLockSharp":false,"./SyncLockTwoTone":false,"./SyncOutlined":false,"./SyncProblem":false,"./SyncProblemOutlined":false,"./SyncProblemRounded":false,"./SyncProblemSharp":false,"./SyncProblemTwoTone":false,"./SyncRounded":false,"./SyncSharp":false,"./SyncTwoTone":false,"./SystemSecurityUpdate":false,"./SystemSecurityUpdateGood":false,"./SystemSecurityUpdateGoodOutlined":false,"./SystemSecurityUpdateGoodRounded":false,"./SystemSecurityUpdateGoodSharp":false,"./SystemSecurityUpdateGoodTwoTone":false,"./SystemSecurityUpdateOutlined":false,"./SystemSecurityUpdateRounded":false,"./SystemSecurityUpdateSharp":false,"./SystemSecurityUpdateTwoTone":false,"./SystemSecurityUpdateWarning":false,"./SystemSecurityUpdateWarningOutlined":false,"./SystemSecurityUpdateWarningRounded":false,"./SystemSecurityUpdateWarningSharp":false,"./SystemSecurityUpdateWarningTwoTone":false,"./SystemUpdate":false,"./SystemUpdateAlt":false,"./SystemUpdateAltOutlined":false,"./SystemUpdateAltRounded":false,"./SystemUpdateAltSharp":false,"./SystemUpdateAltTwoTone":false,"./SystemUpdateOutlined":false,"./SystemUpdateRounded":false,"./SystemUpdateSharp":false,"./SystemUpdateTwoTone":false,"./Tab":false,"./TabOutlined":false,"./TabRounded":false,"./TabSharp":false,"./TabTwoTone":false,"./TabUnselected":false,"./TabUnselectedOutlined":false,"./TabUnselectedRounded":false,"./TabUnselectedSharp":false,"./TabUnselectedTwoTone":false,"./TableBar":false,"./TableBarOutlined":false,"./TableBarRounded":false,"./TableBarSharp":false,"./TableBarTwoTone":false,"./TableChart":false,"./TableChartOutlined":false,"./TableChartRounded":false,"./TableChartSharp":false,"./TableChartTwoTone":false,"./TableRestaurant":false,"./TableRestaurantOutlined":false,"./TableRestaurantRounded":false,"./TableRestaurantSharp":false,"./TableRestaurantTwoTone":false,"./TableRows":false,"./TableRowsOutlined":false,"./TableRowsRounded":false,"./TableRowsSharp":false,"./TableRowsTwoTone":false,"./TableView":false,"./TableViewOutlined":false,"./TableViewRounded":false,"./TableViewSharp":false,"./TableViewTwoTone":false,"./Tablet":false,"./TabletAndroid":false,"./TabletAndroidOutlined":false,"./TabletAndroidRounded":false,"./TabletAndroidSharp":false,"./TabletAndroidTwoTone":false,"./TabletMac":false,"./TabletMacOutlined":false,"./TabletMacRounded":false,"./TabletMacSharp":false,"./TabletMacTwoTone":false,"./TabletOutlined":false,"./TabletRounded":false,"./TabletSharp":false,"./TabletTwoTone":false,"./Tag":false,"./TagFaces":false,"./TagFacesOutlined":false,"./TagFacesRounded":false,"./TagFacesSharp":false,"./TagFacesTwoTone":false,"./TagOutlined":false,"./TagRounded":false,"./TagSharp":false,"./TagTwoTone":false,"./TakeoutDining":false,"./TakeoutDiningOutlined":false,"./TakeoutDiningRounded":false,"./TakeoutDiningSharp":false,"./TakeoutDiningTwoTone":false,"./TapAndPlay":false,"./TapAndPlayOutlined":false,"./TapAndPlayRounded":false,"./TapAndPlaySharp":false,"./TapAndPlayTwoTone":false,"./Tapas":false,"./TapasOutlined":false,"./TapasRounded":false,"./TapasSharp":false,"./TapasTwoTone":false,"./Task":false,"./TaskAlt":false,"./TaskAltOutlined":false,"./TaskAltRounded":false,"./TaskAltSharp":false,"./TaskAltTwoTone":false,"./TaskOutlined":false,"./TaskRounded":false,"./TaskSharp":false,"./TaskTwoTone":false,"./TaxiAlert":false,"./TaxiAlertOutlined":false,"./TaxiAlertRounded":false,"./TaxiAlertSharp":false,"./TaxiAlertTwoTone":false,"./Telegram":false,"./TempleBuddhist":false,"./TempleBuddhistOutlined":false,"./TempleBuddhistRounded":false,"./TempleBuddhistSharp":false,"./TempleBuddhistTwoTone":false,"./TempleHindu":false,"./TempleHinduOutlined":false,"./TempleHinduRounded":false,"./TempleHinduSharp":false,"./TempleHinduTwoTone":false,"./TenMp":false,"./TenMpOutlined":false,"./TenMpRounded":false,"./TenMpSharp":false,"./TenMpTwoTone":false,"./Terminal":false,"./TerminalOutlined":false,"./TerminalRounded":false,"./TerminalSharp":false,"./TerminalTwoTone":false,"./Terrain":false,"./TerrainOutlined":false,"./TerrainRounded":false,"./TerrainSharp":false,"./TerrainTwoTone":false,"./TextDecrease":false,"./TextDecreaseOutlined":false,"./TextDecreaseRounded":false,"./TextDecreaseSharp":false,"./TextDecreaseTwoTone":false,"./TextFields":false,"./TextFieldsOutlined":false,"./TextFieldsRounded":false,"./TextFieldsSharp":false,"./TextFieldsTwoTone":false,"./TextFormat":false,"./TextFormatOutlined":false,"./TextFormatRounded":false,"./TextFormatSharp":false,"./TextFormatTwoTone":false,"./TextIncrease":false,"./TextIncreaseOutlined":false,"./TextIncreaseRounded":false,"./TextIncreaseSharp":false,"./TextIncreaseTwoTone":false,"./TextRotateUp":false,"./TextRotateUpOutlined":false,"./TextRotateUpRounded":false,"./TextRotateUpSharp":false,"./TextRotateUpTwoTone":false,"./TextRotateVertical":false,"./TextRotateVerticalOutlined":false,"./TextRotateVerticalRounded":false,"./TextRotateVerticalSharp":false,"./TextRotateVerticalTwoTone":false,"./TextRotationAngledown":false,"./TextRotationAngledownOutlined":false,"./TextRotationAngledownRounded":false,"./TextRotationAngledownSharp":false,"./TextRotationAngledownTwoTone":false,"./TextRotationAngleup":false,"./TextRotationAngleupOutlined":false,"./TextRotationAngleupRounded":false,"./TextRotationAngleupSharp":false,"./TextRotationAngleupTwoTone":false,"./TextRotationDown":false,"./TextRotationDownOutlined":false,"./TextRotationDownRounded":false,"./TextRotationDownSharp":false,"./TextRotationDownTwoTone":false,"./TextRotationNone":false,"./TextRotationNoneOutlined":false,"./TextRotationNoneRounded":false,"./TextRotationNoneSharp":false,"./TextRotationNoneTwoTone":false,"./TextSnippet":false,"./TextSnippetOutlined":false,"./TextSnippetRounded":false,"./TextSnippetSharp":false,"./TextSnippetTwoTone":false,"./Textsms":false,"./TextsmsOutlined":false,"./TextsmsRounded":false,"./TextsmsSharp":false,"./TextsmsTwoTone":false,"./Texture":false,"./TextureOutlined":false,"./TextureRounded":false,"./TextureSharp":false,"./TextureTwoTone":false,"./TheaterComedy":false,"./TheaterComedyOutlined":false,"./TheaterComedyRounded":false,"./TheaterComedySharp":false,"./TheaterComedyTwoTone":false,"./Theaters":false,"./TheatersOutlined":false,"./TheatersRounded":false,"./TheatersSharp":false,"./TheatersTwoTone":false,"./Thermostat":false,"./ThermostatAuto":false,"./ThermostatAutoOutlined":false,"./ThermostatAutoRounded":false,"./ThermostatAutoSharp":false,"./ThermostatAutoTwoTone":false,"./ThermostatOutlined":false,"./ThermostatRounded":false,"./ThermostatSharp":false,"./ThermostatTwoTone":false,"./ThirteenMp":false,"./ThirteenMpOutlined":false,"./ThirteenMpRounded":false,"./ThirteenMpSharp":false,"./ThirteenMpTwoTone":false,"./ThirtyFps":false,"./ThirtyFpsOutlined":false,"./ThirtyFpsRounded":false,"./ThirtyFpsSelect":false,"./ThirtyFpsSelectOutlined":false,"./ThirtyFpsSelectRounded":false,"./ThirtyFpsSelectSharp":false,"./ThirtyFpsSelectTwoTone":false,"./ThirtyFpsSharp":false,"./ThirtyFpsTwoTone":false,"./ThreeDRotation":false,"./ThreeDRotationOutlined":false,"./ThreeDRotationRounded":false,"./ThreeDRotationSharp":false,"./ThreeDRotationTwoTone":false,"./ThreeGMobiledata":false,"./ThreeGMobiledataOutlined":false,"./ThreeGMobiledataRounded":false,"./ThreeGMobiledataSharp":false,"./ThreeGMobiledataTwoTone":false,"./ThreeK":false,"./ThreeKOutlined":false,"./ThreeKPlus":false,"./ThreeKPlusOutlined":false,"./ThreeKPlusRounded":false,"./ThreeKPlusSharp":false,"./ThreeKPlusTwoTone":false,"./ThreeKRounded":false,"./ThreeKSharp":false,"./ThreeKTwoTone":false,"./ThreeMp":false,"./ThreeMpOutlined":false,"./ThreeMpRounded":false,"./ThreeMpSharp":false,"./ThreeMpTwoTone":false,"./ThreeP":false,"./ThreePOutlined":false,"./ThreePRounded":false,"./ThreePSharp":false,"./ThreePTwoTone":false,"./ThreeSixty":false,"./ThreeSixtyOutlined":false,"./ThreeSixtyRounded":false,"./ThreeSixtySharp":false,"./ThreeSixtyTwoTone":false,"./ThumbDown":false,"./ThumbDownAlt":false,"./ThumbDownAltOutlined":false,"./ThumbDownAltRounded":false,"./ThumbDownAltSharp":false,"./ThumbDownAltTwoTone":false,"./ThumbDownOffAlt":false,"./ThumbDownOffAltOutlined":false,"./ThumbDownOffAltRounded":false,"./ThumbDownOffAltSharp":false,"./ThumbDownOffAltTwoTone":false,"./ThumbDownOutlined":false,"./ThumbDownRounded":false,"./ThumbDownSharp":false,"./ThumbDownTwoTone":false,"./ThumbUp":false,"./ThumbUpAlt":false,"./ThumbUpAltOutlined":false,"./ThumbUpAltRounded":false,"./ThumbUpAltSharp":false,"./ThumbUpAltTwoTone":false,"./ThumbUpOffAlt":false,"./ThumbUpOffAltOutlined":false,"./ThumbUpOffAltRounded":false,"./ThumbUpOffAltSharp":false,"./ThumbUpOffAltTwoTone":false,"./ThumbUpOutlined":false,"./ThumbUpRounded":false,"./ThumbUpSharp":false,"./ThumbUpTwoTone":false,"./ThumbsUpDown":false,"./ThumbsUpDownOutlined":false,"./ThumbsUpDownRounded":false,"./ThumbsUpDownSharp":false,"./ThumbsUpDownTwoTone":false,"./Thunderstorm":false,"./ThunderstormOutlined":false,"./ThunderstormRounded":false,"./ThunderstormSharp":false,"./ThunderstormTwoTone":false,"./TimeToLeave":false,"./TimeToLeaveOutlined":false,"./TimeToLeaveRounded":false,"./TimeToLeaveSharp":false,"./TimeToLeaveTwoTone":false,"./Timelapse":false,"./TimelapseOutlined":false,"./TimelapseRounded":false,"./TimelapseSharp":false,"./TimelapseTwoTone":false,"./Timeline":false,"./TimelineOutlined":false,"./TimelineRounded":false,"./TimelineSharp":false,"./TimelineTwoTone":false,"./Timer":false,"./Timer10":false,"./Timer10Outlined":false,"./Timer10Rounded":false,"./Timer10Select":false,"./Timer10SelectOutlined":false,"./Timer10SelectRounded":false,"./Timer10SelectSharp":false,"./Timer10SelectTwoTone":false,"./Timer10Sharp":false,"./Timer10TwoTone":false,"./Timer3":false,"./Timer3Outlined":false,"./Timer3Rounded":false,"./Timer3Select":false,"./Timer3SelectOutlined":false,"./Timer3SelectRounded":false,"./Timer3SelectSharp":false,"./Timer3SelectTwoTone":false,"./Timer3Sharp":false,"./Timer3TwoTone":false,"./TimerOff":false,"./TimerOffOutlined":false,"./TimerOffRounded":false,"./TimerOffSharp":false,"./TimerOffTwoTone":false,"./TimerOutlined":false,"./TimerRounded":false,"./TimerSharp":false,"./TimerTwoTone":false,"./TimesOneMobiledata":false,"./TimesOneMobiledataOutlined":false,"./TimesOneMobiledataRounded":false,"./TimesOneMobiledataSharp":false,"./TimesOneMobiledataTwoTone":false,"./TipsAndUpdates":false,"./TipsAndUpdatesOutlined":false,"./TipsAndUpdatesRounded":false,"./TipsAndUpdatesSharp":false,"./TipsAndUpdatesTwoTone":false,"./TireRepair":false,"./TireRepairOutlined":false,"./TireRepairRounded":false,"./TireRepairSharp":false,"./TireRepairTwoTone":false,"./Title":false,"./TitleOutlined":false,"./TitleRounded":false,"./TitleSharp":false,"./TitleTwoTone":false,"./Toc":false,"./TocOutlined":false,"./TocRounded":false,"./TocSharp":false,"./TocTwoTone":false,"./Today":false,"./TodayOutlined":false,"./TodayRounded":false,"./TodaySharp":false,"./TodayTwoTone":false,"./ToggleOff":false,"./ToggleOffOutlined":false,"./ToggleOffRounded":false,"./ToggleOffSharp":false,"./ToggleOffTwoTone":false,"./ToggleOn":false,"./ToggleOnOutlined":false,"./ToggleOnRounded":false,"./ToggleOnSharp":false,"./ToggleOnTwoTone":false,"./Token":false,"./TokenOutlined":false,"./TokenRounded":false,"./TokenSharp":false,"./TokenTwoTone":false,"./Toll":false,"./TollOutlined":false,"./TollRounded":false,"./TollSharp":false,"./TollTwoTone":false,"./Tonality":false,"./TonalityOutlined":false,"./TonalityRounded":false,"./TonalitySharp":false,"./TonalityTwoTone":false,"./Topic":false,"./TopicOutlined":false,"./TopicRounded":false,"./TopicSharp":false,"./TopicTwoTone":false,"./Tornado":false,"./TornadoOutlined":false,"./TornadoRounded":false,"./TornadoSharp":false,"./TornadoTwoTone":false,"./TouchApp":false,"./TouchAppOutlined":false,"./TouchAppRounded":false,"./TouchAppSharp":false,"./TouchAppTwoTone":false,"./Tour":false,"./TourOutlined":false,"./TourRounded":false,"./TourSharp":false,"./TourTwoTone":false,"./Toys":false,"./ToysOutlined":false,"./ToysRounded":false,"./ToysSharp":false,"./ToysTwoTone":false,"./TrackChanges":false,"./TrackChangesOutlined":false,"./TrackChangesRounded":false,"./TrackChangesSharp":false,"./TrackChangesTwoTone":false,"./Traffic":false,"./TrafficOutlined":false,"./TrafficRounded":false,"./TrafficSharp":false,"./TrafficTwoTone":false,"./Train":false,"./TrainOutlined":false,"./TrainRounded":false,"./TrainSharp":false,"./TrainTwoTone":false,"./Tram":false,"./TramOutlined":false,"./TramRounded":false,"./TramSharp":false,"./TramTwoTone":false,"./Transcribe":false,"./TranscribeOutlined":false,"./TranscribeRounded":false,"./TranscribeSharp":false,"./TranscribeTwoTone":false,"./TransferWithinAStation":false,"./TransferWithinAStationOutlined":false,"./TransferWithinAStationRounded":false,"./TransferWithinAStationSharp":false,"./TransferWithinAStationTwoTone":false,"./Transform":false,"./TransformOutlined":false,"./TransformRounded":false,"./TransformSharp":false,"./TransformTwoTone":false,"./Transgender":false,"./TransgenderOutlined":false,"./TransgenderRounded":false,"./TransgenderSharp":false,"./TransgenderTwoTone":false,"./TransitEnterexit":false,"./TransitEnterexitOutlined":false,"./TransitEnterexitRounded":false,"./TransitEnterexitSharp":false,"./TransitEnterexitTwoTone":false,"./Translate":false,"./TranslateOutlined":false,"./TranslateRounded":false,"./TranslateSharp":false,"./TranslateTwoTone":false,"./TravelExplore":false,"./TravelExploreOutlined":false,"./TravelExploreRounded":false,"./TravelExploreSharp":false,"./TravelExploreTwoTone":false,"./TrendingDown":false,"./TrendingDownOutlined":false,"./TrendingDownRounded":false,"./TrendingDownSharp":false,"./TrendingDownTwoTone":false,"./TrendingFlat":false,"./TrendingFlatOutlined":false,"./TrendingFlatRounded":false,"./TrendingFlatSharp":false,"./TrendingFlatTwoTone":false,"./TrendingUp":false,"./TrendingUpOutlined":false,"./TrendingUpRounded":false,"./TrendingUpSharp":false,"./TrendingUpTwoTone":false,"./TripOrigin":false,"./TripOriginOutlined":false,"./TripOriginRounded":false,"./TripOriginSharp":false,"./TripOriginTwoTone":false,"./Troubleshoot":false,"./TroubleshootOutlined":false,"./TroubleshootRounded":false,"./TroubleshootSharp":false,"./TroubleshootTwoTone":false,"./Try":false,"./TryOutlined":false,"./TryRounded":false,"./TrySharp":false,"./TryTwoTone":false,"./Tsunami":false,"./TsunamiOutlined":false,"./TsunamiRounded":false,"./TsunamiSharp":false,"./TsunamiTwoTone":false,"./Tty":false,"./TtyOutlined":false,"./TtyRounded":false,"./TtySharp":false,"./TtyTwoTone":false,"./Tune":false,"./TuneOutlined":false,"./TuneRounded":false,"./TuneSharp":false,"./TuneTwoTone":false,"./Tungsten":false,"./TungstenOutlined":false,"./TungstenRounded":false,"./TungstenSharp":false,"./TungstenTwoTone":false,"./TurnLeft":false,"./TurnLeftOutlined":false,"./TurnLeftRounded":false,"./TurnLeftSharp":false,"./TurnLeftTwoTone":false,"./TurnRight":false,"./TurnRightOutlined":false,"./TurnRightRounded":false,"./TurnRightSharp":false,"./TurnRightTwoTone":false,"./TurnSharpLeft":false,"./TurnSharpLeftOutlined":false,"./TurnSharpLeftRounded":false,"./TurnSharpLeftSharp":false,"./TurnSharpLeftTwoTone":false,"./TurnSharpRight":false,"./TurnSharpRightOutlined":false,"./TurnSharpRightRounded":false,"./TurnSharpRightSharp":false,"./TurnSharpRightTwoTone":false,"./TurnSlightLeft":false,"./TurnSlightLeftOutlined":false,"./TurnSlightLeftRounded":false,"./TurnSlightLeftSharp":false,"./TurnSlightLeftTwoTone":false,"./TurnSlightRight":false,"./TurnSlightRightOutlined":false,"./TurnSlightRightRounded":false,"./TurnSlightRightSharp":false,"./TurnSlightRightTwoTone":false,"./TurnedIn":false,"./TurnedInNot":false,"./TurnedInNotOutlined":false,"./TurnedInNotRounded":false,"./TurnedInNotSharp":false,"./TurnedInNotTwoTone":false,"./TurnedInOutlined":false,"./TurnedInRounded":false,"./TurnedInSharp":false,"./TurnedInTwoTone":false,"./Tv":false,"./TvOff":false,"./TvOffOutlined":false,"./TvOffRounded":false,"./TvOffSharp":false,"./TvOffTwoTone":false,"./TvOutlined":false,"./TvRounded":false,"./TvSharp":false,"./TvTwoTone":false,"./TwelveMp":false,"./TwelveMpOutlined":false,"./TwelveMpRounded":false,"./TwelveMpSharp":false,"./TwelveMpTwoTone":false,"./TwentyFourMp":false,"./TwentyFourMpOutlined":false,"./TwentyFourMpRounded":false,"./TwentyFourMpSharp":false,"./TwentyFourMpTwoTone":false,"./TwentyOneMp":false,"./TwentyOneMpOutlined":false,"./TwentyOneMpRounded":false,"./TwentyOneMpSharp":false,"./TwentyOneMpTwoTone":false,"./TwentyThreeMp":false,"./TwentyThreeMpOutlined":false,"./TwentyThreeMpRounded":false,"./TwentyThreeMpSharp":false,"./TwentyThreeMpTwoTone":false,"./TwentyTwoMp":false,"./TwentyTwoMpOutlined":false,"./TwentyTwoMpRounded":false,"./TwentyTwoMpSharp":false,"./TwentyTwoMpTwoTone":false,"./TwentyZeroMp":false,"./TwentyZeroMpOutlined":false,"./TwentyZeroMpRounded":false,"./TwentyZeroMpSharp":false,"./TwentyZeroMpTwoTone":false,"./Twitter":false,"./TwoK":false,"./TwoKOutlined":false,"./TwoKPlus":false,"./TwoKPlusOutlined":false,"./TwoKPlusRounded":false,"./TwoKPlusSharp":false,"./TwoKPlusTwoTone":false,"./TwoKRounded":false,"./TwoKSharp":false,"./TwoKTwoTone":false,"./TwoMp":false,"./TwoMpOutlined":false,"./TwoMpRounded":false,"./TwoMpSharp":false,"./TwoMpTwoTone":false,"./TwoWheeler":false,"./TwoWheelerOutlined":false,"./TwoWheelerRounded":false,"./TwoWheelerSharp":false,"./TwoWheelerTwoTone":false,"./TypeSpecimen":false,"./TypeSpecimenOutlined":false,"./TypeSpecimenRounded":false,"./TypeSpecimenSharp":false,"./TypeSpecimenTwoTone":false,"./UTurnLeft":false,"./UTurnLeftOutlined":false,"./UTurnLeftRounded":false,"./UTurnLeftSharp":false,"./UTurnLeftTwoTone":false,"./UTurnRight":false,"./UTurnRightOutlined":false,"./UTurnRightRounded":false,"./UTurnRightSharp":false,"./UTurnRightTwoTone":false,"./Umbrella":false,"./UmbrellaOutlined":false,"./UmbrellaRounded":false,"./UmbrellaSharp":false,"./UmbrellaTwoTone":false,"./Unarchive":"jd6Fo","./UnarchiveOutlined":false,"./UnarchiveRounded":false,"./UnarchiveSharp":false,"./UnarchiveTwoTone":false,"./Undo":false,"./UndoOutlined":false,"./UndoRounded":false,"./UndoSharp":false,"./UndoTwoTone":false,"./UnfoldLess":false,"./UnfoldLessDouble":false,"./UnfoldLessDoubleOutlined":false,"./UnfoldLessDoubleRounded":false,"./UnfoldLessDoubleSharp":false,"./UnfoldLessDoubleTwoTone":false,"./UnfoldLessOutlined":false,"./UnfoldLessRounded":false,"./UnfoldLessSharp":false,"./UnfoldLessTwoTone":false,"./UnfoldMore":false,"./UnfoldMoreDouble":false,"./UnfoldMoreDoubleOutlined":false,"./UnfoldMoreDoubleRounded":false,"./UnfoldMoreDoubleSharp":false,"./UnfoldMoreDoubleTwoTone":false,"./UnfoldMoreOutlined":false,"./UnfoldMoreRounded":false,"./UnfoldMoreSharp":false,"./UnfoldMoreTwoTone":false,"./Unpublished":false,"./UnpublishedOutlined":false,"./UnpublishedRounded":false,"./UnpublishedSharp":false,"./UnpublishedTwoTone":false,"./Unsubscribe":false,"./UnsubscribeOutlined":false,"./UnsubscribeRounded":false,"./UnsubscribeSharp":false,"./UnsubscribeTwoTone":false,"./Upcoming":false,"./UpcomingOutlined":false,"./UpcomingRounded":false,"./UpcomingSharp":false,"./UpcomingTwoTone":false,"./Update":false,"./UpdateDisabled":false,"./UpdateDisabledOutlined":false,"./UpdateDisabledRounded":false,"./UpdateDisabledSharp":false,"./UpdateDisabledTwoTone":false,"./UpdateOutlined":false,"./UpdateRounded":false,"./UpdateSharp":false,"./UpdateTwoTone":false,"./Upgrade":false,"./UpgradeOutlined":false,"./UpgradeRounded":false,"./UpgradeSharp":false,"./UpgradeTwoTone":false,"./Upload":false,"./UploadFile":false,"./UploadFileOutlined":false,"./UploadFileRounded":false,"./UploadFileSharp":false,"./UploadFileTwoTone":false,"./UploadOutlined":false,"./UploadRounded":false,"./UploadSharp":false,"./UploadTwoTone":false,"./Usb":false,"./UsbOff":false,"./UsbOffOutlined":false,"./UsbOffRounded":false,"./UsbOffSharp":false,"./UsbOffTwoTone":false,"./UsbOutlined":false,"./UsbRounded":false,"./UsbSharp":false,"./UsbTwoTone":false,"./Vaccines":false,"./VaccinesOutlined":false,"./VaccinesRounded":false,"./VaccinesSharp":false,"./VaccinesTwoTone":false,"./VapeFree":false,"./VapeFreeOutlined":false,"./VapeFreeRounded":false,"./VapeFreeSharp":false,"./VapeFreeTwoTone":false,"./VapingRooms":false,"./VapingRoomsOutlined":false,"./VapingRoomsRounded":false,"./VapingRoomsSharp":false,"./VapingRoomsTwoTone":false,"./Verified":false,"./VerifiedOutlined":false,"./VerifiedRounded":false,"./VerifiedSharp":false,"./VerifiedTwoTone":false,"./VerifiedUser":false,"./VerifiedUserOutlined":false,"./VerifiedUserRounded":false,"./VerifiedUserSharp":false,"./VerifiedUserTwoTone":false,"./VerticalAlignBottom":false,"./VerticalAlignBottomOutlined":false,"./VerticalAlignBottomRounded":false,"./VerticalAlignBottomSharp":false,"./VerticalAlignBottomTwoTone":false,"./VerticalAlignCenter":false,"./VerticalAlignCenterOutlined":false,"./VerticalAlignCenterRounded":false,"./VerticalAlignCenterSharp":false,"./VerticalAlignCenterTwoTone":false,"./VerticalAlignTop":false,"./VerticalAlignTopOutlined":false,"./VerticalAlignTopRounded":false,"./VerticalAlignTopSharp":false,"./VerticalAlignTopTwoTone":false,"./VerticalShades":false,"./VerticalShadesClosed":false,"./VerticalShadesClosedOutlined":false,"./VerticalShadesClosedRounded":false,"./VerticalShadesClosedSharp":false,"./VerticalShadesClosedTwoTone":false,"./VerticalShadesOutlined":false,"./VerticalShadesRounded":false,"./VerticalShadesSharp":false,"./VerticalShadesTwoTone":false,"./VerticalSplit":false,"./VerticalSplitOutlined":false,"./VerticalSplitRounded":false,"./VerticalSplitSharp":false,"./VerticalSplitTwoTone":false,"./Vibration":false,"./VibrationOutlined":false,"./VibrationRounded":false,"./VibrationSharp":false,"./VibrationTwoTone":false,"./VideoCall":false,"./VideoCallOutlined":false,"./VideoCallRounded":false,"./VideoCallSharp":false,"./VideoCallTwoTone":false,"./VideoCameraBack":false,"./VideoCameraBackOutlined":false,"./VideoCameraBackRounded":false,"./VideoCameraBackSharp":false,"./VideoCameraBackTwoTone":false,"./VideoCameraFront":false,"./VideoCameraFrontOutlined":false,"./VideoCameraFrontRounded":false,"./VideoCameraFrontSharp":false,"./VideoCameraFrontTwoTone":false,"./VideoChat":false,"./VideoChatOutlined":false,"./VideoChatRounded":false,"./VideoChatSharp":false,"./VideoChatTwoTone":false,"./VideoFile":false,"./VideoFileOutlined":false,"./VideoFileRounded":false,"./VideoFileSharp":false,"./VideoFileTwoTone":false,"./VideoLabel":false,"./VideoLabelOutlined":false,"./VideoLabelRounded":false,"./VideoLabelSharp":false,"./VideoLabelTwoTone":false,"./VideoLibrary":false,"./VideoLibraryOutlined":false,"./VideoLibraryRounded":false,"./VideoLibrarySharp":false,"./VideoLibraryTwoTone":false,"./VideoSettings":false,"./VideoSettingsOutlined":false,"./VideoSettingsRounded":false,"./VideoSettingsSharp":false,"./VideoSettingsTwoTone":false,"./VideoStable":false,"./VideoStableOutlined":false,"./VideoStableRounded":false,"./VideoStableSharp":false,"./VideoStableTwoTone":false,"./Videocam":false,"./VideocamOff":false,"./VideocamOffOutlined":false,"./VideocamOffRounded":false,"./VideocamOffSharp":false,"./VideocamOffTwoTone":false,"./VideocamOutlined":false,"./VideocamRounded":false,"./VideocamSharp":false,"./VideocamTwoTone":false,"./VideogameAsset":false,"./VideogameAssetOff":false,"./VideogameAssetOffOutlined":false,"./VideogameAssetOffRounded":false,"./VideogameAssetOffSharp":false,"./VideogameAssetOffTwoTone":false,"./VideogameAssetOutlined":false,"./VideogameAssetRounded":false,"./VideogameAssetSharp":false,"./VideogameAssetTwoTone":false,"./ViewAgenda":false,"./ViewAgendaOutlined":false,"./ViewAgendaRounded":false,"./ViewAgendaSharp":false,"./ViewAgendaTwoTone":false,"./ViewArray":false,"./ViewArrayOutlined":false,"./ViewArrayRounded":false,"./ViewArraySharp":false,"./ViewArrayTwoTone":false,"./ViewCarousel":false,"./ViewCarouselOutlined":false,"./ViewCarouselRounded":false,"./ViewCarouselSharp":false,"./ViewCarouselTwoTone":false,"./ViewColumn":false,"./ViewColumnOutlined":false,"./ViewColumnRounded":false,"./ViewColumnSharp":false,"./ViewColumnTwoTone":false,"./ViewComfy":false,"./ViewComfyAlt":false,"./ViewComfyAltOutlined":false,"./ViewComfyAltRounded":false,"./ViewComfyAltSharp":false,"./ViewComfyAltTwoTone":false,"./ViewComfyOutlined":false,"./ViewComfyRounded":false,"./ViewComfySharp":false,"./ViewComfyTwoTone":false,"./ViewCompact":false,"./ViewCompactAlt":false,"./ViewCompactAltOutlined":false,"./ViewCompactAltRounded":false,"./ViewCompactAltSharp":false,"./ViewCompactAltTwoTone":false,"./ViewCompactOutlined":false,"./ViewCompactRounded":false,"./ViewCompactSharp":false,"./ViewCompactTwoTone":false,"./ViewCozy":false,"./ViewCozyOutlined":false,"./ViewCozyRounded":false,"./ViewCozySharp":false,"./ViewCozyTwoTone":false,"./ViewDay":false,"./ViewDayOutlined":false,"./ViewDayRounded":false,"./ViewDaySharp":false,"./ViewDayTwoTone":false,"./ViewHeadline":false,"./ViewHeadlineOutlined":false,"./ViewHeadlineRounded":false,"./ViewHeadlineSharp":false,"./ViewHeadlineTwoTone":false,"./ViewInAr":false,"./ViewInArOutlined":false,"./ViewInArRounded":false,"./ViewInArSharp":false,"./ViewInArTwoTone":false,"./ViewKanban":false,"./ViewKanbanOutlined":false,"./ViewKanbanRounded":false,"./ViewKanbanSharp":false,"./ViewKanbanTwoTone":false,"./ViewList":false,"./ViewListOutlined":false,"./ViewListRounded":false,"./ViewListSharp":false,"./ViewListTwoTone":false,"./ViewModule":false,"./ViewModuleOutlined":false,"./ViewModuleRounded":false,"./ViewModuleSharp":false,"./ViewModuleTwoTone":false,"./ViewQuilt":false,"./ViewQuiltOutlined":false,"./ViewQuiltRounded":false,"./ViewQuiltSharp":false,"./ViewQuiltTwoTone":false,"./ViewSidebar":false,"./ViewSidebarOutlined":false,"./ViewSidebarRounded":false,"./ViewSidebarSharp":false,"./ViewSidebarTwoTone":false,"./ViewStream":false,"./ViewStreamOutlined":false,"./ViewStreamRounded":false,"./ViewStreamSharp":false,"./ViewStreamTwoTone":false,"./ViewTimeline":false,"./ViewTimelineOutlined":false,"./ViewTimelineRounded":false,"./ViewTimelineSharp":false,"./ViewTimelineTwoTone":false,"./ViewWeek":false,"./ViewWeekOutlined":false,"./ViewWeekRounded":false,"./ViewWeekSharp":false,"./ViewWeekTwoTone":false,"./Vignette":false,"./VignetteOutlined":false,"./VignetteRounded":false,"./VignetteSharp":false,"./VignetteTwoTone":false,"./Villa":false,"./VillaOutlined":false,"./VillaRounded":false,"./VillaSharp":false,"./VillaTwoTone":false,"./Visibility":false,"./VisibilityOff":false,"./VisibilityOffOutlined":false,"./VisibilityOffRounded":false,"./VisibilityOffSharp":false,"./VisibilityOffTwoTone":false,"./VisibilityOutlined":false,"./VisibilityRounded":false,"./VisibilitySharp":false,"./VisibilityTwoTone":false,"./VoiceChat":false,"./VoiceChatOutlined":false,"./VoiceChatRounded":false,"./VoiceChatSharp":false,"./VoiceChatTwoTone":false,"./VoiceOverOff":false,"./VoiceOverOffOutlined":false,"./VoiceOverOffRounded":false,"./VoiceOverOffSharp":false,"./VoiceOverOffTwoTone":false,"./Voicemail":false,"./VoicemailOutlined":false,"./VoicemailRounded":false,"./VoicemailSharp":false,"./VoicemailTwoTone":false,"./Volcano":false,"./VolcanoOutlined":false,"./VolcanoRounded":false,"./VolcanoSharp":false,"./VolcanoTwoTone":false,"./VolumeDown":false,"./VolumeDownOutlined":false,"./VolumeDownRounded":false,"./VolumeDownSharp":false,"./VolumeDownTwoTone":false,"./VolumeMute":false,"./VolumeMuteOutlined":false,"./VolumeMuteRounded":false,"./VolumeMuteSharp":false,"./VolumeMuteTwoTone":false,"./VolumeOff":false,"./VolumeOffOutlined":false,"./VolumeOffRounded":false,"./VolumeOffSharp":false,"./VolumeOffTwoTone":false,"./VolumeUp":false,"./VolumeUpOutlined":false,"./VolumeUpRounded":false,"./VolumeUpSharp":false,"./VolumeUpTwoTone":false,"./VolunteerActivism":false,"./VolunteerActivismOutlined":false,"./VolunteerActivismRounded":false,"./VolunteerActivismSharp":false,"./VolunteerActivismTwoTone":false,"./VpnKey":false,"./VpnKeyOff":false,"./VpnKeyOffOutlined":false,"./VpnKeyOffRounded":false,"./VpnKeyOffSharp":false,"./VpnKeyOffTwoTone":false,"./VpnKeyOutlined":false,"./VpnKeyRounded":false,"./VpnKeySharp":false,"./VpnKeyTwoTone":false,"./VpnLock":false,"./VpnLockOutlined":false,"./VpnLockRounded":false,"./VpnLockSharp":false,"./VpnLockTwoTone":false,"./Vrpano":false,"./VrpanoOutlined":false,"./VrpanoRounded":false,"./VrpanoSharp":false,"./VrpanoTwoTone":false,"./Wallet":false,"./WalletOutlined":false,"./WalletRounded":false,"./WalletSharp":false,"./WalletTwoTone":false,"./Wallpaper":false,"./WallpaperOutlined":false,"./WallpaperRounded":false,"./WallpaperSharp":false,"./WallpaperTwoTone":false,"./Warehouse":false,"./WarehouseOutlined":false,"./WarehouseRounded":false,"./WarehouseSharp":false,"./WarehouseTwoTone":false,"./Warning":false,"./WarningAmber":"bPxq0","./WarningAmberOutlined":false,"./WarningAmberRounded":false,"./WarningAmberSharp":false,"./WarningAmberTwoTone":false,"./WarningOutlined":false,"./WarningRounded":false,"./WarningSharp":false,"./WarningTwoTone":false,"./Wash":false,"./WashOutlined":false,"./WashRounded":false,"./WashSharp":false,"./WashTwoTone":false,"./Watch":false,"./WatchLater":false,"./WatchLaterOutlined":false,"./WatchLaterRounded":false,"./WatchLaterSharp":false,"./WatchLaterTwoTone":false,"./WatchOff":false,"./WatchOffOutlined":false,"./WatchOffRounded":false,"./WatchOffSharp":false,"./WatchOffTwoTone":false,"./WatchOutlined":false,"./WatchRounded":false,"./WatchSharp":false,"./WatchTwoTone":false,"./Water":false,"./WaterDamage":false,"./WaterDamageOutlined":false,"./WaterDamageRounded":false,"./WaterDamageSharp":false,"./WaterDamageTwoTone":false,"./WaterDrop":false,"./WaterDropOutlined":false,"./WaterDropRounded":false,"./WaterDropSharp":false,"./WaterDropTwoTone":false,"./WaterOutlined":false,"./WaterRounded":false,"./WaterSharp":false,"./WaterTwoTone":false,"./WaterfallChart":false,"./WaterfallChartOutlined":false,"./WaterfallChartRounded":false,"./WaterfallChartSharp":false,"./WaterfallChartTwoTone":false,"./Waves":false,"./WavesOutlined":false,"./WavesRounded":false,"./WavesSharp":false,"./WavesTwoTone":false,"./WavingHand":false,"./WavingHandOutlined":false,"./WavingHandRounded":false,"./WavingHandSharp":false,"./WavingHandTwoTone":false,"./WbAuto":false,"./WbAutoOutlined":false,"./WbAutoRounded":false,"./WbAutoSharp":false,"./WbAutoTwoTone":false,"./WbCloudy":false,"./WbCloudyOutlined":false,"./WbCloudyRounded":false,"./WbCloudySharp":false,"./WbCloudyTwoTone":false,"./WbIncandescent":false,"./WbIncandescentOutlined":false,"./WbIncandescentRounded":false,"./WbIncandescentSharp":false,"./WbIncandescentTwoTone":false,"./WbIridescent":false,"./WbIridescentOutlined":false,"./WbIridescentRounded":false,"./WbIridescentSharp":false,"./WbIridescentTwoTone":false,"./WbShade":false,"./WbShadeOutlined":false,"./WbShadeRounded":false,"./WbShadeSharp":false,"./WbShadeTwoTone":false,"./WbSunny":false,"./WbSunnyOutlined":false,"./WbSunnyRounded":false,"./WbSunnySharp":false,"./WbSunnyTwoTone":false,"./WbTwilight":false,"./WbTwilightOutlined":false,"./WbTwilightRounded":false,"./WbTwilightSharp":false,"./WbTwilightTwoTone":false,"./Wc":false,"./WcOutlined":false,"./WcRounded":false,"./WcSharp":false,"./WcTwoTone":false,"./Web":false,"./WebAsset":false,"./WebAssetOff":false,"./WebAssetOffOutlined":false,"./WebAssetOffRounded":false,"./WebAssetOffSharp":false,"./WebAssetOffTwoTone":false,"./WebAssetOutlined":false,"./WebAssetRounded":false,"./WebAssetSharp":false,"./WebAssetTwoTone":false,"./WebOutlined":false,"./WebRounded":false,"./WebSharp":false,"./WebStories":false,"./WebStoriesOutlined":false,"./WebStoriesRounded":false,"./WebStoriesSharp":false,"./WebStoriesTwoTone":false,"./WebTwoTone":false,"./Webhook":false,"./WebhookOutlined":false,"./WebhookRounded":false,"./WebhookSharp":false,"./WebhookTwoTone":false,"./Weekend":false,"./WeekendOutlined":false,"./WeekendRounded":false,"./WeekendSharp":false,"./WeekendTwoTone":false,"./West":false,"./WestOutlined":false,"./WestRounded":false,"./WestSharp":false,"./WestTwoTone":false,"./WhatsApp":false,"./Whatshot":false,"./WhatshotOutlined":false,"./WhatshotRounded":false,"./WhatshotSharp":false,"./WhatshotTwoTone":false,"./WheelchairPickup":false,"./WheelchairPickupOutlined":false,"./WheelchairPickupRounded":false,"./WheelchairPickupSharp":false,"./WheelchairPickupTwoTone":false,"./WhereToVote":false,"./WhereToVoteOutlined":false,"./WhereToVoteRounded":false,"./WhereToVoteSharp":false,"./WhereToVoteTwoTone":false,"./Widgets":false,"./WidgetsOutlined":false,"./WidgetsRounded":false,"./WidgetsSharp":false,"./WidgetsTwoTone":false,"./WidthFull":false,"./WidthFullOutlined":false,"./WidthFullRounded":false,"./WidthFullSharp":false,"./WidthFullTwoTone":false,"./WidthNormal":false,"./WidthNormalOutlined":false,"./WidthNormalRounded":false,"./WidthNormalSharp":false,"./WidthNormalTwoTone":false,"./WidthWide":false,"./WidthWideOutlined":false,"./WidthWideRounded":false,"./WidthWideSharp":false,"./WidthWideTwoTone":false,"./Wifi":false,"./Wifi1Bar":false,"./Wifi1BarOutlined":false,"./Wifi1BarRounded":false,"./Wifi1BarSharp":false,"./Wifi1BarTwoTone":false,"./Wifi2Bar":false,"./Wifi2BarOutlined":false,"./Wifi2BarRounded":false,"./Wifi2BarSharp":false,"./Wifi2BarTwoTone":false,"./WifiCalling":false,"./WifiCalling3":false,"./WifiCalling3Outlined":false,"./WifiCalling3Rounded":false,"./WifiCalling3Sharp":false,"./WifiCalling3TwoTone":false,"./WifiCallingOutlined":false,"./WifiCallingRounded":false,"./WifiCallingSharp":false,"./WifiCallingTwoTone":false,"./WifiChannel":false,"./WifiChannelOutlined":false,"./WifiChannelRounded":false,"./WifiChannelSharp":false,"./WifiChannelTwoTone":false,"./WifiFind":false,"./WifiFindOutlined":false,"./WifiFindRounded":false,"./WifiFindSharp":false,"./WifiFindTwoTone":false,"./WifiLock":false,"./WifiLockOutlined":false,"./WifiLockRounded":false,"./WifiLockSharp":false,"./WifiLockTwoTone":false,"./WifiOff":false,"./WifiOffOutlined":false,"./WifiOffRounded":false,"./WifiOffSharp":false,"./WifiOffTwoTone":false,"./WifiOutlined":false,"./WifiPassword":false,"./WifiPasswordOutlined":false,"./WifiPasswordRounded":false,"./WifiPasswordSharp":false,"./WifiPasswordTwoTone":false,"./WifiProtectedSetup":false,"./WifiProtectedSetupOutlined":false,"./WifiProtectedSetupRounded":false,"./WifiProtectedSetupSharp":false,"./WifiProtectedSetupTwoTone":false,"./WifiRounded":false,"./WifiSharp":false,"./WifiTethering":false,"./WifiTetheringError":false,"./WifiTetheringErrorOutlined":false,"./WifiTetheringErrorRounded":false,"./WifiTetheringErrorRoundedOutlined":false,"./WifiTetheringErrorRoundedRounded":false,"./WifiTetheringErrorRoundedSharp":false,"./WifiTetheringErrorRoundedTwoTone":false,"./WifiTetheringErrorSharp":false,"./WifiTetheringErrorTwoTone":false,"./WifiTetheringOff":false,"./WifiTetheringOffOutlined":false,"./WifiTetheringOffRounded":false,"./WifiTetheringOffSharp":false,"./WifiTetheringOffTwoTone":false,"./WifiTetheringOutlined":false,"./WifiTetheringRounded":false,"./WifiTetheringSharp":false,"./WifiTetheringTwoTone":false,"./WifiTwoTone":false,"./WindPower":false,"./WindPowerOutlined":false,"./WindPowerRounded":false,"./WindPowerSharp":false,"./WindPowerTwoTone":false,"./Window":false,"./WindowOutlined":false,"./WindowRounded":false,"./WindowSharp":false,"./WindowTwoTone":false,"./WineBar":false,"./WineBarOutlined":false,"./WineBarRounded":false,"./WineBarSharp":false,"./WineBarTwoTone":false,"./Woman":false,"./Woman2":false,"./Woman2Outlined":false,"./Woman2Rounded":false,"./Woman2Sharp":false,"./Woman2TwoTone":false,"./WomanOutlined":false,"./WomanRounded":false,"./WomanSharp":false,"./WomanTwoTone":false,"./Work":false,"./WorkHistory":false,"./WorkHistoryOutlined":false,"./WorkHistoryRounded":false,"./WorkHistorySharp":false,"./WorkHistoryTwoTone":false,"./WorkOff":false,"./WorkOffOutlined":false,"./WorkOffRounded":false,"./WorkOffSharp":false,"./WorkOffTwoTone":false,"./WorkOutline":false,"./WorkOutlineOutlined":false,"./WorkOutlineRounded":false,"./WorkOutlineSharp":false,"./WorkOutlineTwoTone":false,"./WorkOutlined":false,"./WorkRounded":false,"./WorkSharp":false,"./WorkTwoTone":false,"./WorkspacePremium":false,"./WorkspacePremiumOutlined":false,"./WorkspacePremiumRounded":false,"./WorkspacePremiumSharp":false,"./WorkspacePremiumTwoTone":false,"./Workspaces":false,"./WorkspacesOutlined":false,"./WorkspacesRounded":false,"./WorkspacesSharp":false,"./WorkspacesTwoTone":false,"./WrapText":false,"./WrapTextOutlined":false,"./WrapTextRounded":false,"./WrapTextSharp":false,"./WrapTextTwoTone":false,"./WrongLocation":false,"./WrongLocationOutlined":false,"./WrongLocationRounded":false,"./WrongLocationSharp":false,"./WrongLocationTwoTone":false,"./Wysiwyg":false,"./WysiwygOutlined":false,"./WysiwygRounded":false,"./WysiwygSharp":false,"./WysiwygTwoTone":false,"./X":false,"./Yard":false,"./YardOutlined":false,"./YardRounded":false,"./YardSharp":false,"./YardTwoTone":false,"./YouTube":false,"./YoutubeSearchedFor":false,"./YoutubeSearchedForOutlined":false,"./YoutubeSearchedForRounded":false,"./YoutubeSearchedForSharp":false,"./YoutubeSearchedForTwoTone":false,"./ZoomIn":false,"./ZoomInMap":false,"./ZoomInMapOutlined":false,"./ZoomInMapRounded":false,"./ZoomInMapSharp":false,"./ZoomInMapTwoTone":false,"./ZoomInOutlined":false,"./ZoomInRounded":false,"./ZoomInSharp":false,"./ZoomInTwoTone":false,"./ZoomOut":false,"./ZoomOutMap":false,"./ZoomOutMapOutlined":false,"./ZoomOutMapRounded":false,"./ZoomOutMapSharp":false,"./ZoomOutMapTwoTone":false,"./ZoomOutOutlined":false,"./ZoomOutRounded":false,"./ZoomOutSharp":false,"./ZoomOutTwoTone":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aTO0P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m22 5.72-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9m0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), "AccessAlarm");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dTsZr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _utils.createSvgIcon));
var _utils = require("@mui/material/utils");
"use client";

},{"@mui/material/utils":"ziQFX","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5lKug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9fzQo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4zm-6 1H4v-4h5zM2 4h15v2H2z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
    }, "1")
], "AddBusiness");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"65ssb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6m10-.28-4.6-3.86-1.29 1.53 4.6 3.86zM2.92 2.29 1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47zM8.02 3.28 6.6 1.86l-.86.71 1.42 1.42z"
}), "AlarmOff");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6A0Pl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27M12 17.5 6.5 12H10v-2h4v2h3.5zM5.12 5l.81-1h12l.94 1z"
}), "Archive");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bjJxR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"
}), "Business");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cB1KF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
}), "Cached");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Obm4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), "CalendarMonth");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"rx18K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m2 22 14-5-9-9zm12.53-9.47 5.59-5.59c.49-.49 1.28-.49 1.77 0l.59.59 1.06-1.06-.59-.59c-1.07-1.07-2.82-1.07-3.89 0l-5.59 5.59zm-4.47-5.65-.59.59 1.06 1.06.59-.59c1.07-1.07 1.07-2.82 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76m7 5-1.59 1.59 1.06 1.06 1.59-1.59c.49-.49 1.28-.49 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61c-1.08-1.07-2.82-1.07-3.89 0m-2-6-3.59 3.59 1.06 1.06 3.59-3.59c1.07-1.07 1.07-2.82 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77"
}), "Celebration");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fDmww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckBox");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3lYD8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "CheckBoxOutlineBlankOutlined");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nmnS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "CheckCircleOutline");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3OkW5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cIcfY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"pcYnT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3m-9-3.82-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
}), "CloudDoneOutlined");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1mNMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81M4.41 3.86 3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8z"
}), "CloudOffOutlined");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"czYlv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3M8 13h2.55v3h2.9v-3H16l-4-4z"
}), "CloudUploadOutlined");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fQiGE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 13h8V3H3zm0 8h8v-6H3zm10 0h8V11h-8zm0-18v6h8V3z"
}), "Dashboard");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iPOcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"10UuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i9RDV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"47nSb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m9.31 17 2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V8h14z"
}), "EventBusy");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bB47I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5z"
}), "FileDownloadOutlined");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aL4xz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), "Group");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aSDgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18 20V8.35L13.65 4h-2.83L16 9.18V20zm4 0V6.69L19.31 4h-2.83L20 7.52V20zM8 4l-6 6v10h5v-5h2v5h5V10zm1 9H7v-2h2z"
}), "HolidayVillage");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6cDAR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"
}), "Logout");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g83B2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), "Loop");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g5ZCU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ijXDC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jcTow":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 16h2V8H9zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m1-4h2V8h-2z"
}), "PauseCircleOutline");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Ld2w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonUnchecked");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kNirw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.54 11 13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41zM11 7H2v2h9zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16zM11 15H2v2h9z"
}), "Rule");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5wbuk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M22 10v8h-2v-8zm-2 10v2h2v-2zm-2-2.71C16.53 18.95 14.39 20 12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8v9l7.55-7.55C17.72 3.34 15.02 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10c2.25 0 4.33-.74 6-2z"
}), "RunningWithErrors");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1rAOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m2 19.99 7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01zm1.5-4.5 6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99z"
}), "StackedLineChart");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jd6Fo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m20.55 5.22-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28M12 9.5l5.5 5.5H14v2h-4v-2H6.5zM5.12 5l.82-1h12l.93 1z"
}), "Unarchive");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bPxq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createSvgIcon = require("./utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], "WarningAmber");

},{"./utils/createSvgIcon":"dTsZr","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"48tQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderPickerDays", ()=>renderPickerDays);
parcelHelpers.export(exports, "CustomTextField", ()=>CustomTextField);
parcelHelpers.export(exports, "CustomButton", ()=>CustomButton);
parcelHelpers.export(exports, "CustomPickersDay", ()=>CustomPickersDay);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDatePickers = require("@mui/x-date-pickers");
var _dateFns = require("date-fns");
const renderPickerDays = ({ start, end })=>{
    start = (0, _dateFns.startOfDay)(start);
    end = (0, _dateFns.endOfDay)(end);
    const renderDay = (date, _selectedDates, pickersDayProps)=>{
        const dayIsBetween = (0, _dateFns.isWithinInterval)(date, {
            start,
            end
        });
        const isFirstDay = (0, _dateFns.isSameDay)(date, start);
        const isLastDay = (0, _dateFns.isSameDay)(date, end);
        return /*#__PURE__*/ (0, _react.createElement)(CustomPickersDay, {
            ...pickersDayProps,
            key: date.toISOString(),
            isFirstDay: isFirstDay,
            isLastDay: isLastDay,
            dayIsBetween: dayIsBetween,
            disableMargin: true
        });
    };
    return renderDay;
};
const CustomTextField = (0, _material.styled)((0, _material.TextField))(({ theme })=>({
        "& .MuiInputBase-root": {
            backgroundColor: theme.palette.common.white
        }
    }));
const CustomButton = (0, _material.styled)((0, _material.Button))(({ theme })=>({
        height: 40,
        minWidth: 30,
        marginTop: 8,
        backgroundColor: theme.palette.common.white,
        borderColor: "rgb(0 0 0 / 23%)",
        "&:hover": {
            borderColor: "rgb(0 0 0 / 87%)"
        }
    }));
const CustomPickersDay = (0, _material.styled)((0, _xDatePickers.PickersDay), {
    shouldForwardProp: (prop)=>!(prop === "dayIsBetween" || prop === "isFirstDay" || prop === "isLastDay")
})(({ theme, dayIsBetween, isFirstDay, isLastDay })=>({
        ...dayIsBetween && {
            borderRadius: 0,
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.common.white,
            "&:hover, &:focus": {
                backgroundColor: theme.palette.primary.dark
            }
        },
        ...isFirstDay && {
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: "50%",
            borderBottomLeftRadius: "50%"
        },
        ...isLastDay && {
            backgroundColor: theme.palette.primary.main,
            borderTopRightRadius: "50%",
            borderBottomRightRadius: "50%"
        }
    }));

},{"react":"gVheC","@mui/material":"iknXc","@mui/x-date-pickers":"lcIJt","date-fns":"5Pdd3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"29HMt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RangePicker", ()=>RangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _customPicker = require("./CustomPicker");
const RangePicker = ({ value, onChange, inputFormat = "do MMM" })=>{
    const { start, end } = value !== null && value !== void 0 ? value : {
        start: new Date(),
        end: new Date()
    };
    const handleOnChangeStart = (val)=>{
        onChange(val !== null ? {
            start: val,
            end: val > end ? val : end
        } : val);
    };
    const handleOnChangeEnd = (val)=>{
        onChange(val !== null ? {
            start: val > start ? start : val,
            end: val
        } : val);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "flex",
                gap: 1
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                    label: "Start Date",
                    value: start,
                    onChange: handleOnChangeStart,
                    renderDay: (0, _customPicker.renderPickerDays)({
                        start,
                        end
                    }),
                    renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                            ...params,
                            variant: "outlined",
                            inputProps: {
                                ...params.inputProps,
                                readOnly: true
                            },
                            InputLabelProps: {
                                shrink: true
                            },
                            margin: "dense",
                            size: "small"
                        }),
                    inputFormat: inputFormat,
                    showDaysOutsideCurrentMonth: true,
                    disableMaskedInput: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                    label: "End Date",
                    value: end,
                    onChange: handleOnChangeEnd,
                    renderDay: (0, _customPicker.renderPickerDays)({
                        start,
                        end
                    }),
                    renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                            ...params,
                            variant: "outlined",
                            inputProps: {
                                ...params.inputProps,
                                readOnly: true
                            },
                            InputLabelProps: {
                                shrink: true
                            },
                            margin: "dense",
                            size: "small"
                        }),
                    inputFormat: inputFormat,
                    showDaysOutsideCurrentMonth: true,
                    disableMaskedInput: true
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/x-date-pickers":"lcIJt","@mui/x-date-pickers/AdapterDateFns":"1X56V","./CustomPicker":"48tQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7bcn1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearPicker", ()=>YearPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _dateFns = require("date-fns");
var _customPicker = require("./CustomPicker");
const YearPicker = ({ label = "Select Year", value, onChange })=>{
    var _value_start;
    const [selectedDate, setSelectedDate] = (0, _react.useState)(new Date((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : ""));
    const handleDateChange = (date)=>{
        setSelectedDate(date);
        const interval = {
            start: (0, _dateFns.startOfYear)(date),
            end: (0, _dateFns.endOfYear)(date)
        };
        onChange(interval);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
            value: selectedDate,
            label: label,
            views: [
                "year"
            ],
            openTo: "year",
            inputFormat: "yyyy",
            renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                    ...params,
                    variant: "outlined",
                    inputProps: {
                        ...params.inputProps,
                        readOnly: true
                    },
                    InputLabelProps: {
                        shrink: true
                    },
                    margin: "dense",
                    size: "small"
                }),
            onChange: (e)=>handleDateChange(e)
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/x-date-pickers":"lcIJt","@mui/x-date-pickers/AdapterDateFns":"1X56V","date-fns":"5Pdd3","./CustomPicker":"48tQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"evppP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlledRangePicker", ()=>ControlledRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _xDatePickers = require("@mui/x-date-pickers");
var _dateFns = require("date-fns");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _customPicker = require("./CustomPicker");
const ControlledRangePicker = ({ name, label, control, onChange, pickerDays: { start, end }, minDate, maxDate, disablePast, views })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
            name: name,
            control: control,
            render: ({ field: { value } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                    label: label,
                    value: (0, _dateFns.endOfDay)((0, _dateFns.parseISO)(value)),
                    onChange: onChange,
                    renderDay: (0, _customPicker.renderPickerDays)({
                        start,
                        end
                    }),
                    views: views,
                    renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                            ...params,
                            variant: "outlined",
                            inputProps: {
                                ...params.inputProps,
                                readOnly: true
                            },
                            InputLabelProps: {
                                shrink: true
                            },
                            margin: "dense",
                            size: "small"
                        }),
                    inputFormat: "do MMM",
                    minDate: minDate,
                    maxDate: maxDate,
                    showDaysOutsideCurrentMonth: true,
                    disableMaskedInput: true,
                    disablePast: disablePast
                })
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/x-date-pickers":"lcIJt","date-fns":"5Pdd3","@mui/x-date-pickers/AdapterDateFns":"1X56V","./CustomPicker":"48tQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a5Zq3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "appendErrors", ()=>appendErrors);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "useController", ()=>useController);
parcelHelpers.export(exports, "useFieldArray", ()=>useFieldArray);
parcelHelpers.export(exports, "useForm", ()=>useForm);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
parcelHelpers.export(exports, "useWatch", ()=>useWatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var isCheckBoxInput = (element)=>element.type === "checkbox";
var isDateObject = (value1)=>value1 instanceof Date;
var isNullOrUndefined = (value1)=>value1 == null;
const isObjectType = (value1)=>typeof value1 === "object";
var isObject = (value1)=>!isNullOrUndefined(value1) && !Array.isArray(value1) && isObjectType(value1) && !isDateObject(value1);
var getEventValue = (event)=>isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var isNameInFieldArray = (names, name)=>names.has(getNodeParentName(name));
var isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var isUndefined = (val)=>val === undefined;
var get = (object, path, defaultValue)=>{
    if (!path || !isObject(object)) return defaultValue;
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key)=>isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value1)=>typeof value1 === "boolean";
const EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const HookFormContext = (0, _reactDefault.default).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const useFormContext = ()=>(0, _reactDefault.default).useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const FormProvider = (props)=>{
    const { children, ...data } = props;
    return (0, _reactDefault.default).createElement(HookFormContext.Provider, {
        value: data
    }, children);
};
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var isEmptyObject = (value1)=>isObject(value1) && !Object.keys(value1).length;
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function useSubscribe(props) {
    const _props = (0, _reactDefault.default).useRef(props);
    _props.current = props;
    (0, _reactDefault.default).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = (0, _reactDefault.default).useState(control._formState);
    const _mounted = (0, _reactDefault.default).useRef(true);
    const _localProxyFormState = (0, _reactDefault.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value1)=>_mounted.current && shouldSubscribeByName(_name.current, value1.name, exact) && shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, _reactDefault.default).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var isString = (value1)=>typeof value1 === "string";
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact } = props || {};
    const _name = (0, _reactDefault.default).useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if (shouldSubscribeByName(_name.current, formState.name, exact)) updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, _reactDefault.default).useState(control._getWatch(name, defaultValue));
    (0, _reactDefault.default).useEffect(()=>control._removeUnmounted());
    return value1;
}
var isKey = (value1)=>/^\w*$/.test(value1);
var stringToPath = (input)=>compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var set = (object, path, value1)=>{
    let index = -1;
    const tempPath = isKey(path) ? [
        path
    ] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value1 = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = useFormState({
        control,
        name
    });
    const _registerProps = (0, _reactDefault.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, _reactDefault.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = get(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value1);
            if (isUndefined(get(control._formValues, name))) set(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (get(control._fields, name)) control._updateDisabledField({
            disabled,
            fields: control._fields,
            name,
            value: get(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name,
            value: value1,
            ...isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, _reactDefault.default).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: getEventValue(event),
                        name: name
                    },
                    type: EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, _reactDefault.default).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: get(control._formValues, name),
                        name: name
                    },
                    type: EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = get(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!get(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!get(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!get(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>get(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const Controller = (props)=>props.render(useController(props));
const POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = (0, _reactDefault.default).useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, get(data, name));
            if (onSubmit) await onSubmit({
                data,
                event,
                method,
                formData,
                formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type
            });
        }
    };
    (0, _reactDefault.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        submit
    })) : (0, _reactDefault.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var appendErrors = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var getFocusFieldName = (name, index, options = {})=>options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    });
var isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else iterateFieldsByAction(currentField, action);
            } else if (isObject(currentField)) iterateFieldsByAction(currentField, action);
        }
    }
};
var updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, "root", error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};
var isFileInput = (element)=>element.type === "file";
var isFunction = (value1)=>typeof value1 === "function";
var isHTMLElement = (value1)=>{
    if (!isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMessage = (value1)=>isString(value1);
var isRadioInput = (element)=>element.type === "radio";
var isRegex = (value1)=>value1 instanceof RegExp;
const defaultResult = {
    value: false,
    isValid: false
};
const validResult = {
    value: true,
    isValid: true
};
var getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === "" ? validResult : {
            value: options[0].value,
            isValid: true
        } : validResult : defaultResult;
    }
    return defaultResult;
};
const defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, defaultReturn) : defaultReturn;
function getValidateError(result, ref, type = "validate") {
    if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) return {
        type,
        message: isMessage(result) ? result : "",
        ref
    };
}
var getValueAndMessage = (validationData)=>isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
        const { value: value1, message } = isMessage(required) ? {
            value: !!required,
            message: required
        } : getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if (isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if (isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if (isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var appendAt = (data, value1)=>[
        ...data,
        ...convertToArrayPayload(value1)
    ];
var fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if (isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var prependAt = (data, value1)=>[
        ...convertToArrayPayload(value1),
        ...convertToArrayPayload(data)
    ];
function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index)=>isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b)=>a - b));
var swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) return false;
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path) ? path : isKey(path) ? [
        path
    ] : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) unset(object, paths.slice(0, -1));
    return object;
}
var updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = "id", shouldUnregister } = props;
    const [fields, setFields] = (0, _reactDefault.default).useState(control._getFieldArray(name));
    const ids = (0, _reactDefault.default).useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = (0, _reactDefault.default).useRef(fields);
    const _name = (0, _reactDefault.default).useRef(name);
    const _actioned = (0, _reactDefault.default).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, _reactDefault.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = cloneObject(value1);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value1));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        control._state.action = false;
        isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = get(result.errors, name);
                const existingError = get(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = get(control._fields, name);
                if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!isEmptyObject(error) && control._subjects.state.next({
                        errors: updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        !get(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, _reactDefault.default).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, _reactDefault.default).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, _reactDefault.default).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, _reactDefault.default).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, _reactDefault.default).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, _reactDefault.default).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, _reactDefault.default).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, _reactDefault.default).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, _reactDefault.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe
    };
};
var isPrimitive = (value1)=>isNullOrUndefined(value1) || !isObjectType(value1);
function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) return object1 === object2;
    if (isDateObject(object1) && isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if (isDateObject(val1) && isDateObject(val2) || isObject(val1) && isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var isMultipleSelect = (element)=>element.type === `select-multiple`;
var isRadioOrCheckbox = (ref)=>isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref)=>isHTMLElement(ref) && ref.isConnected;
var objectHasFunction = (data)=>{
    for(const key in data){
        if (isFunction(data[key])) return true;
    }
    return false;
};
function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            markFieldsDirty(data[key], fields[key]);
        } else if (!isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || isObject(data[key]) && !objectHasFunction(data[key])) {
            if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : {
                ...markFieldsDirty(data[key])
            };
            else getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues)=>getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
var getFieldValueAs = (value1, { valueAsNumber, valueAsDate, setValueAs })=>isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if (isFileInput(ref)) return ref.files;
    if (isRadioInput(ref)) return getRadioValue(_f.refs).value;
    if (isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if (isCheckBoxInput(ref)) return getCheckboxValue(_f.refs).value;
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields,
        shouldUseNativeValidation
    };
};
var getRuleValue = (rule)=>isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) return {
        error,
        name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name
    };
}
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var unsetEmptyArray = (ref, name)=>!compact(get(ref, name)).length && unset(ref, name);
const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = isObject(_options.values) || isObject(_options.defaultValues) ? cloneObject(_options.values || _options.defaultValues) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject()
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else set(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value1) ? get(_defaultValues, name) : value1);
            isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name
        };
        const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && isBoolean(isValid) ? {
                    isValid
                } : {},
                errors: _formState.errors,
                name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = get(errors, name);
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = get(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!live(ref)) : !live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && set(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value1, fieldReference));
                fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value1) ? "" : value1;
                if (isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if (isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) || !isPrimitive(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value1);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name,
                dirtyFields: getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === get(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !get(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            } else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>get(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name
            },
            ..._options.resolver || !name ? {
                isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name)=>get(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!get((formState || _formState).errors, name),
            isDirty: !!get((formState || _formState).dirtyFields, name),
            isTouched: !!get((formState || _formState).touchedFields, name),
            error: get((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && convertToArrayPayload(name).forEach((inputName)=>unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = (get(_fields, name, {
            _f: {}
        })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value: value1 })=>{
        if (isBoolean(disabled)) {
            const inputValue = disabled ? undefined : isUndefined(value1) ? getFieldValue(field ? field._f : get(fields, name)._f) : value1;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name
                    }
                },
                name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field,
            disabled: options.disabled,
            name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern)
            } : {},
            name,
            onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter(live),
                                    fieldRef,
                                    ...Array.isArray(get(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = get(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if (isBoolean(disabled)) {
            _subjects.state.next({
                disabled
            });
            iterateFieldsByAction(_fields, (ref, name)=>{
                let requiredDisabledState = disabled;
                const currentField = get(_fields, name);
                if (currentField && isBoolean(currentField._f.disabled)) requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors, values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            unset(_formState.errors, "root");
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) setValue(name, cloneObject(get(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)get(_formState.dirtyFields, fieldName) ? set(values, fieldName, get(_formValues, fieldName)) : setValue(fieldName, get(values, fieldName));
            else {
                if (isWeb && isUndefined(formValues)) for (const name of _names.mount){
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if (isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {} : cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset(isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function useForm(props = {}) {
    const _formControl = (0, _reactDefault.default).useRef();
    const _values = (0, _reactDefault.default).useRef();
    const [formState, updateFormState] = (0, _reactDefault.default).useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState
    };
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if (shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, _reactDefault.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, _reactDefault.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Mgzz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _selectField = require("./SelectField");
parcelHelpers.exportAll(_selectField, exports);
var _searchField = require("./SearchField");
parcelHelpers.exportAll(_searchField, exports);
var _countryField = require("./CountryField");
parcelHelpers.exportAll(_countryField, exports);

},{"./SelectField":"3yglx","./SearchField":"8BsEZ","./CountryField":"3WdNW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3yglx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectField", ()=>SelectField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
const genLabel = ()=>Math.random().toString(36).substring(2, 9);
const findOption = (options, value)=>options.find((option)=>option.value === value);
const SelectField = ({ control, name, label, options, optional = false, multiple, placeholder, ...rest })=>{
    const labelId = genLabel();
    options = multiple || findOption(options, "") ? options : [
        {
            label: "None",
            value: ""
        },
        ...options
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
        control: control,
        name: name,
        rules: {
            required: !optional
        },
        render: ({ field, fieldState: { error } })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.FormControl), {
                variant: "outlined",
                margin: "dense",
                size: "small",
                required: !optional,
                error: !!error,
                sx: {
                    bgcolor: "common.white"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.InputLabel), {
                        shrink: true,
                        id: labelId,
                        required: !optional,
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Select), {
                        ...field,
                        ...rest,
                        multiple: multiple,
                        labelId: labelId,
                        value: options.length > 1 ? field.value : "",
                        input: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.OutlinedInput), {
                            notched: true,
                            label: label
                        }),
                        renderValue: (value)=>{
                            var _findOption;
                            const selected = multiple ? value : value;
                            if (!selected || !(selected === null || selected === void 0 ? void 0 : selected.length)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                                variant: "caption",
                                color: "gray",
                                children: placeholder ? placeholder : "Please select..."
                            });
                            if (multiple) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                sx: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                    marginBottom: "-1px"
                                },
                                children: selected.map((item)=>{
                                    var _findOption;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Chip), {
                                        label: (_findOption = findOption(options, item)) === null || _findOption === void 0 ? void 0 : _findOption.label,
                                        size: "small"
                                    }, item);
                                })
                            });
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                                children: (_findOption = findOption(options, selected)) === null || _findOption === void 0 ? void 0 : _findOption.label
                            });
                        },
                        displayEmpty: true,
                        children: options.map((option)=>option.header ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListSubheader), {
                                children: option.label
                            }, option.value) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                                value: option.value,
                                disabled: option.disabled,
                                children: multiple ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                            checked: field.value.indexOf(option.value) > -1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                                            primary: option.label
                                        })
                                    ]
                                }) : option.value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                                    primary: option.label
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                                    secondary: option.label
                                })
                            }, option.value))
                    }),
                    (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormHelperText), {
                        error: true,
                        children: error === null || error === void 0 ? void 0 : error.message
                    })
                ]
            })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8BsEZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", ()=>SearchField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const findOption = (options, value)=>options.find((option)=>option.value === value);
const SearchField = ({ onChange, label, options, value, multiple, grouped, width })=>{
    const selected = (0, _react.useMemo)(()=>(typeof value === "string" ? [
            value
        ] : value).flatMap((v)=>{
            var _findOption;
            return (_findOption = findOption(options, v)) !== null && _findOption !== void 0 ? _findOption : [];
        }), [
        options,
        value
    ]);
    const group = {
        ...grouped && {
            groupBy: ({ group })=>group !== null && group !== void 0 ? group : ""
        }
    };
    return multiple ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Autocomplete), {
        fullWidth: true,
        size: "small",
        onChange: (_, val)=>{
            onChange(val.map((v)=>{
                var _v_value;
                return typeof v === "string" ? v : (_v_value = v === null || v === void 0 ? void 0 : v.value) !== null && _v_value !== void 0 ? _v_value : "";
            }));
        },
        value: selected,
        options: options,
        ...group,
        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TextField), {
                ...params,
                sx: {
                    bgcolor: "common.white",
                    width: width
                },
                variant: "outlined",
                margin: "dense",
                label: label
            }),
        multiple: true,
        freeSolo: true
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Autocomplete), {
        size: "small",
        onChange: (_, val)=>{
            var _val_value;
            onChange(typeof val === "string" ? val : (_val_value = val === null || val === void 0 ? void 0 : val.value) !== null && _val_value !== void 0 ? _val_value : "");
        },
        value: selected[0] || "",
        options: options,
        ...group,
        renderOption: (props, option)=>/*#__PURE__*/ (0, _react.createElement)("li", {
                ...props,
                key: option.key
            }, option.label),
        renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TextField), {
                ...params,
                sx: {
                    bgcolor: "common.white",
                    width: width
                },
                variant: "outlined",
                margin: "dense",
                label: label
            }),
        freeSolo: true,
        selectOnFocus: true,
        clearOnBlur: true
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3WdNW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CountryField", ()=>CountryField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _addresses = require("../../addresses");
var _selectField = require("./SelectField");
const CountryField = ({ control, name, label, onChange })=>{
    var _Object_keys;
    const countryOptions = ((_Object_keys = Object.keys((0, _addresses.OFFICES))) !== null && _Object_keys !== void 0 ? _Object_keys : []).map((key)=>({
            label: (0, _addresses.OFFICES)[key].country,
            value: key
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectField.SelectField), {
        control: control,
        name: name,
        label: label,
        options: countryOptions,
        onChange: (e)=>onChange(e.target.value),
        variant: "outlined"
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","../../addresses":"3Mw7F","./SelectField":"3yglx","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Mw7F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OFFICES", ()=>OFFICES);
const OFFICES = {
    GB: {
        country: "United Kingdom",
        line1: "Suite 14, 2nd Floor, The Spire",
        line2: "Pilgrim Street",
        line3: "Newcastle Upon Tyne, NE1 2DS"
    },
    CA: {
        country: "Canada",
        line1: "Suite 1004, Bankers Hall West Tower",
        line2: "888 3rd Street SW",
        line3: "Calgary, Alberta, T2P 5C5"
    },
    PL: {
        country: "Poland",
        line1: "Loftmill, Sagittarius Business House",
        line2: "Sucha Street 2",
        line3: "Wroclaw, 50-086"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQ6lq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthPicker", ()=>MonthPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _xDatePickers = require("@mui/x-date-pickers");
var _adapterDateFns = require("@mui/x-date-pickers/AdapterDateFns");
var _dateFns = require("date-fns");
var _customPicker = require("./CustomPicker");
const MonthPicker = ({ label = "Select Month", value, onChange })=>{
    var _value_start;
    const [selectedDate, setSelectedDate] = (0, _react.useState)((0, _dateFns.startOfMonth)(new Date((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : "")));
    const handleDateChange = (date)=>{
        setSelectedDate(date);
        const interval = {
            start: (0, _dateFns.startOfMonth)(date),
            end: (0, _dateFns.endOfMonth)(date)
        };
        onChange(interval);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.LocalizationProvider), {
        dateAdapter: (0, _adapterDateFns.AdapterDateFns),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "flex",
                gap: 1
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomButton), {
                    "aria-label": "Previous month",
                    variant: "outlined",
                    onClick: ()=>handleDateChange((0, _dateFns.subMonths)(selectedDate, 1)),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.ChevronLeft), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDatePickers.DatePicker), {
                    value: selectedDate,
                    label: label,
                    views: [
                        "year",
                        "month"
                    ],
                    openTo: "month",
                    renderInput: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomTextField), {
                            ...params,
                            variant: "outlined",
                            inputProps: {
                                ...params.inputProps,
                                readOnly: true
                            },
                            InputLabelProps: {
                                shrink: true
                            },
                            margin: "dense",
                            size: "small"
                        }),
                    onChange: (e)=>handleDateChange(e)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customPicker.CustomButton), {
                    "aria-label": "Next month",
                    variant: "outlined",
                    onClick: ()=>handleDateChange((0, _dateFns.addMonths)(selectedDate, 1)),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.ChevronRight), {})
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","@mui/x-date-pickers":"lcIJt","@mui/x-date-pickers/AdapterDateFns":"1X56V","date-fns":"5Pdd3","./CustomPicker":"48tQY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kz3Ye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _desktop = require("./Desktop");
parcelHelpers.exportAll(_desktop, exports);
var _mobile = require("./Mobile");
parcelHelpers.exportAll(_mobile, exports);

},{"./Desktop":"6dcwD","./Mobile":"dYpdn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6dcwD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Desktop", ()=>Desktop);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _userAvatar = require("../UserAvatar");
const Desktop = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: {
                xs: "none",
                md: "flex"
            },
            width: 1,
            justifyContent: "space-between",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                component: "h1",
                variant: "h6",
                children: "TDS ERP"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {})
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../UserAvatar":"anYwW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"anYwW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _userAvatar = require("./UserAvatar");
parcelHelpers.exportAll(_userAvatar, exports);

},{"./UserAvatar":"ghoad","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ghoad":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAvatar", ()=>UserAvatar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _hooks = require("../../hooks");
var _menu = require("./Menu");
const UserAvatar = ()=>{
    const user = (0, _hooks.useUser)();
    const avatar = {
        alt: user === null || user === void 0 ? void 0 : user.fullName,
        src: user === null || user === void 0 ? void 0 : user.imgURL
    };
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>setAnchorEl(event.currentTarget);
    const handleClose = ()=>setAnchorEl(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    display: {
                        xs: "flex",
                        md: "none"
                    }
                },
                "data-testid": "mobile",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Avatar), {
                    sx: {
                        width: 56,
                        height: 56
                    },
                    ...avatar
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: {
                        xs: "none",
                        md: "flex"
                    }
                },
                "data-testid": "desktop",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Tooltip), {
                        title: "Account settings",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                            onClick: handleClick,
                            size: "small",
                            sx: {
                                ml: 2
                            },
                            "aria-controls": open ? "account-menu" : undefined,
                            "aria-haspopup": "true",
                            "aria-expanded": open ? "true" : undefined,
                            "data-testid": "dt-account-menu-button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Avatar), {
                                sx: {
                                    width: 32,
                                    height: 32
                                },
                                ...avatar
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                        anchorEl: anchorEl,
                        open: open,
                        close: handleClose
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../../hooks":"9Pg07","./Menu":"4qXre","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Pg07":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useResponsive = require("./useResponsive");
parcelHelpers.exportAll(_useResponsive, exports);
var _user = require("./User");
parcelHelpers.exportAll(_user, exports);

},{"./useResponsive":"kMepn","./User":"hPC0H","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kMepn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResponsive", ()=>useResponsive);
var _material = require("@mui/material");
const useResponsive = ()=>{
    const isLg = (0, _material.useMediaQuery)((theme)=>theme.breakpoints.down("lg"));
    const isMd = (0, _material.useMediaQuery)((theme)=>theme.breakpoints.down("md"));
    const isSm = (0, _material.useMediaQuery)((theme)=>theme.breakpoints.down("sm"));
    return {
        isLg,
        isMd,
        isSm
    };
};

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hPC0H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _userProvider = require("./UserProvider");
parcelHelpers.exportAll(_userProvider, exports);
var _useUser = require("./useUser");
parcelHelpers.exportAll(_useUser, exports);
var _userContext = require("./UserContext");
parcelHelpers.exportAll(_userContext, exports);

},{"./UserProvider":"3SeDS","./useUser":"gbwib","./UserContext":"hpqBq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3SeDS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserProvider", ()=>UserProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uiReact = require("@aws-amplify/ui-react");
var _userContext = require("./UserContext");
const UserProvider = ({ children, value })=>{
    const { user } = (0, _uiReact.useAuthenticator)((context)=>[
            context.user
        ]);
    const checkRoles = (0, _react.useCallback)((role)=>{
        var _this, _user_getSignInUserSession;
        return (_this = user === null || user === void 0 ? void 0 : (_user_getSignInUserSession = user.getSignInUserSession()) === null || _user_getSignInUserSession === void 0 ? void 0 : _user_getSignInUserSession.getAccessToken().payload["cognito:groups"]) === null || _this === void 0 ? void 0 : _this.includes(role);
    }, [
        user
    ]);
    const newValue = (0, _react.useMemo)(()=>{
        const a = user === null || user === void 0 ? void 0 : user.attributes;
        const id = user === null || user === void 0 ? void 0 : user.username;
        if (a && id) {
            const { fullName, ...names } = getName(a);
            const input = {
                id,
                email: a.email,
                ...names
            };
            return {
                ...input,
                fullName,
                imgURL: createImageElement(a.picture).src,
                isAdmin: checkRoles("admin"),
                isBeta: checkRoles("beta"),
                isGoogle: id.slice(0, 6) === "google",
                input
            };
        }
    }, [
        checkRoles,
        user
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userContext.UserContext).Provider, {
        value: value !== null && value !== void 0 ? value : newValue,
        children: children
    });
};
const createImageElement = (imageURL = "")=>{
    const ele = document.createElement("img");
    ele.referrerPolicy = "no-referrer";
    ele.src = imageURL;
    return ele;
};
const getName = (a)=>{
    if (a.given_name && a.family_name) return {
        firstName: a.given_name,
        lastName: a.family_name,
        fullName: `${a.given_name} ${a.family_name}`
    };
    else {
        const [firstName, lastName] = a.email.split(/[.@_]+/, 2).map((name)=>`${name[0].toUpperCase()}${name.slice(1)}`);
        return {
            firstName,
            lastName,
            fullName: `${firstName} ${lastName}`
        };
    }
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@aws-amplify/ui-react":"40VMD","./UserContext":"hpqBq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hpqBq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContext", ()=>UserContext);
var _react = require("react");
const UserContext = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gbwib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUser", ()=>useUser);
var _react = require("react");
var _userContext = require("./UserContext");
const useUser = ()=>(0, _react.useContext)((0, _userContext.UserContext));

},{"react":"gVheC","./UserContext":"hpqBq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4qXre":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _uiReact = require("@aws-amplify/ui-react");
const Menu = ({ anchorEl, open, close })=>{
    const { signOut } = (0, _uiReact.useAuthenticator)((context)=>[
            context.user
        ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Menu), {
        anchorEl: anchorEl,
        id: "account-menu",
        open: open,
        onClose: close,
        onClick: close,
        PaperProps: {
            elevation: 3,
            sx: {
                overflow: "visible",
                mt: 1.5,
                "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1
                },
                "&:before": {
                    content: "''",
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0
                }
            }
        },
        transformOrigin: {
            horizontal: "right",
            vertical: "top"
        },
        anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.MenuItem), {
            onClick: ()=>{
                close();
                signOut();
            },
            "data-testid": "dt-logout-link",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemIcon), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Logout), {
                        fontSize: "small"
                    })
                }),
                "Logout"
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","@aws-amplify/ui-react":"40VMD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dYpdn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mobile", ()=>Mobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _tdsLogo = require("../TdsLogo");
const Mobile = ({ onClick })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: {
                xs: "flex",
                md: "none"
            },
            width: 1,
            justifyContent: "space-between"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tdsLogo.TdsLogo), {
                testID: "mob"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                "aria-label": "Navigation",
                edge: "end",
                onClick: onClick,
                "data-testid": "mob-nav-menu-button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Menu), {})
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","../TdsLogo":"cE4zn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cE4zn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tdsLogo = require("./TdsLogo");
parcelHelpers.exportAll(_tdsLogo, exports);

},{"./TdsLogo":"4GsAk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4GsAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TdsLogo", ()=>TdsLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
const TdsLogo = ({ testID })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
        onClick: ()=>navigate("/"),
        sx: {
            p: 0
        },
        "data-testid": `${testID}-tds-logo`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Avatar), {
            alt: "TDS Logo",
            src: "/tds_logo.png",
            sx: {
                width: 70,
                height: 30,
                mr: 1
            },
            variant: "square"
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jEO6Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _buttons = require("./Buttons");
parcelHelpers.exportAll(_buttons, exports);

},{"./Buttons":"bua06","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bua06":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrimaryButton", ()=>PrimaryButton);
parcelHelpers.export(exports, "SecondaryButton", ()=>SecondaryButton);
parcelHelpers.export(exports, "TextButton", ()=>TextButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const PrimaryButton = ({ ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
        disableElevation: true,
        variant: "contained",
        color: "primary",
        ...props
    });
const SecondaryButton = ({ ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
        disableElevation: true,
        variant: "outlined",
        ...props
    });
const TextButton = ({ ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
        disableElevation: true,
        variant: "text",
        ...props
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"62l75":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cells = require("./Cells");
parcelHelpers.exportAll(_cells, exports);
var _dataGrid = require("./DataGrid");
parcelHelpers.exportAll(_dataGrid, exports);
var _useQueryPagination = require("./useQueryPagination");
parcelHelpers.exportAll(_useQueryPagination, exports);

},{"./Cells":"cuW2I","./DataGrid":"a4AIy","./useQueryPagination":"8z13E","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cuW2I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionCell = require("./ActionCell");
parcelHelpers.exportAll(_actionCell, exports);
var _approvalCell = require("./ApprovalCell");
parcelHelpers.exportAll(_approvalCell, exports);
var _chipListCell = require("./ChipListCell");
parcelHelpers.exportAll(_chipListCell, exports);
var _tooltipCell = require("./TooltipCell");
parcelHelpers.exportAll(_tooltipCell, exports);
var _userCell = require("./UserCell");
parcelHelpers.exportAll(_userCell, exports);
var _summaryCell = require("./SummaryCell");
parcelHelpers.exportAll(_summaryCell, exports);

},{"./ActionCell":"2Nk8N","./ApprovalCell":"3vxu0","./ChipListCell":"hIVf2","./TooltipCell":"lBmgq","./UserCell":"2Wjkb","./SummaryCell":"xpOCB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Nk8N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCell", ()=>ActionCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttons = require("../../Buttons");
var _tooltipCell = require("./TooltipCell");
const ActionCell = ({ children, onClick, disabled })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.TextButton), {
        onClick: onClick,
        disableFocusRipple: true,
        sx: {
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: "auto"
        },
        disabled: disabled,
        "data-testid": "grid-action-cell-button",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipCell.TooltipCell), {
            children: children
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","../../Buttons":"jEO6Z","./TooltipCell":"lBmgq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lBmgq":[function(require,module,exports) {
/**
 * Util Cell for wrapping a tooltip around the cell content.
 * Useful for when the cell content is too long to fit the cell.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useContainerDimensions", ()=>useContainerDimensions);
parcelHelpers.export(exports, "TooltipCell", ()=>TooltipCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _tooltip = require("../../Tooltip");
const useContainerDimensions = (ref)=>{
    const [dimensions, setDimensions] = (0, _react.useState)({
        scrollWidth: 0,
        clientWidth: 0
    });
    const getDimensions = (0, _react.useCallback)(()=>{
        var _ref_current, _ref_current1;
        var _ref_current_scrollWidth, _ref_current_clientWidth;
        return {
            scrollWidth: (_ref_current_scrollWidth = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.scrollWidth) !== null && _ref_current_scrollWidth !== void 0 ? _ref_current_scrollWidth : 0,
            clientWidth: (_ref_current_clientWidth = ref === null || ref === void 0 ? void 0 : (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.clientWidth) !== null && _ref_current_clientWidth !== void 0 ? _ref_current_clientWidth : 0
        };
    }, [
        ref
    ]);
    (0, _react.useEffect)(()=>{
        if (ref.current) setDimensions(getDimensions());
        const handleResize = ()=>setDimensions(getDimensions());
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        ref,
        getDimensions
    ]);
    return dimensions;
};
const TooltipCell = ({ children })=>{
    const [isOverflowed, setIsOverflow] = (0, _react.useState)(false);
    const ref = (0, _react.useRef)(null);
    const { scrollWidth, clientWidth } = useContainerDimensions(ref);
    (0, _react.useEffect)(()=>{
        setIsOverflow(scrollWidth > clientWidth);
    }, [
        scrollWidth,
        clientWidth
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
        title: children || "",
        placement: "top",
        disableHoverListener: !isOverflowed,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            ref: ref,
            sx: {
                display: "inherit",
                flex: "inherit",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            },
            children: children
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../../Tooltip":"ikXCW","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ikXCW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tooltip = require("./Tooltip");
parcelHelpers.exportAll(_tooltip, exports);

},{"./Tooltip":"5tfS4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5tfS4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const Tooltip = (0, _material.styled)(({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Tooltip), {
        ...props,
        classes: {
            popper: className
        },
        "data-testid": "tooltip"
    }))(({ theme })=>({
        [`& .${(0, _material.tooltipClasses).tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.grey[300]}`,
            color: theme.palette.common.black,
            fontSize: ".85rem",
            fontWeight: "400"
        }
    }));

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vxu0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApprovalCell", ()=>ApprovalCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const ApprovalCell = ({ onApprove, onReject, disable })=>/*#__PURE__*/ {
    var _disable_reject, _disable_approve;
    return (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: "flex",
            gap: 1
        },
        children: [
            onReject && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                variant: "contained",
                size: "small",
                color: "error",
                disableElevation: true,
                disabled: (_disable_reject = disable === null || disable === void 0 ? void 0 : disable.reject) !== null && _disable_reject !== void 0 ? _disable_reject : false,
                onClick: onReject,
                children: "Reject"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                variant: "contained",
                size: "small",
                color: "success",
                disableElevation: true,
                onClick: onApprove,
                disabled: (_disable_approve = disable === null || disable === void 0 ? void 0 : disable.approve) !== null && _disable_approve !== void 0 ? _disable_approve : false,
                children: "Approve"
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hIVf2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChipListCell", ()=>ChipListCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _tooltipCell = require("./TooltipCell");
const ChipListCell = ({ data })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipCell.TooltipCell), {
        children: buildChips(data)
    });
const buildChips = (data)=>data.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Chip), {
            label: item,
            sx: {
                m: 0.5
            }
        }, `${item}-${idx}`));

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","./TooltipCell":"lBmgq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Wjkb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserCell", ()=>UserCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _infoOutlined = require("@mui/icons-material/InfoOutlined");
var _infoOutlinedDefault = parcelHelpers.interopDefault(_infoOutlined);
var _lib = require("../../../lib");
const SubText = ({ info })=>info ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Typography), {
        variant: "overline",
        sx: {
            display: "flex",
            lineHeight: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoOutlinedDefault.default), {
                color: "inherit",
                fontSize: "inherit",
                sx: {
                    mr: 0.25
                }
            }),
            info
        ]
    }) : null;
const TextArea = ({ name, info })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 0.5
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                variant: "button",
                sx: {
                    lineHeight: 1
                },
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SubText, {
                info: info
            })
        ]
    });
const UserComponent = ({ name, info, clientIDs = [], image = "/", ...rest }, ref)=>{
    const companies = (0, _lib.useGetClient)(clientIDs).map(({ company })=>company.name);
    const props = {
        name,
        info: info !== null && info !== void 0 ? info : companies.join()
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        ...rest,
        ref: ref,
        sx: {
            display: "flex",
            gap: 1,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Avatar), {
                sx: {
                    width: 24,
                    height: 24
                },
                alt: name.toUpperCase(),
                srcSet: image
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextArea, {
                ...props
            })
        ]
    });
};
const UserCell = /*#__PURE__*/ (0, _react.forwardRef)(UserComponent);

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material/InfoOutlined":"KLPlh","../../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"KLPlh":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("3b5d7c2ea44001b0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("d3d5c866dbbb50ce"));
var _jsxRuntime = require("ac0cd8199b29c59");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined");

},{"3b5d7c2ea44001b0":"6zI5d","d3d5c866dbbb50ce":"fp1As","ac0cd8199b29c59":"1elNt"}],"6zI5d":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fp1As":[function(require,module,exports) {
"use strict";
"use client";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.createSvgIcon;
    }
});
var _utils = require("21f2d1dcc9f0020d");

},{"21f2d1dcc9f0020d":"ziQFX"}],"xpOCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SummaryCell", ()=>SummaryCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _dateFns = require("date-fns");
var _tooltip = require("../../Tooltip");
var _lib = require("../../../lib");
const toDay = (date)=>(0, _dateFns.format)(new Date(date), "dd/MM/yyyy");
const FormRow = ({ date, hours })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            px: 1,
            py: 0.5,
            textAlign: "center",
            borderBlockEnd: "solid",
            backgroundColor: ({ palette })=>hours === 8 ? (0, _material.alpha)(palette.success.light, 0.5) : hours === 0 ? (0, _material.alpha)(palette.error.light, 0.3) : (0, _material.alpha)(palette.warning.light, 0.1)
        },
        children: hours === undefined ? `${toDay(date)}:` : hours
    }, date);
const SummaryCell = ({ children, data })=>data.total > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
        title: GridBox(data),
        placement: "right-end",
        children: children
    }) : children;
const GridBox = (data)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            flexGrow: 1
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Grid), {
            container: true,
            spacing: 0.25,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Grid), {
                    children: data["standard"].dates.map(({ date })=>({
                            date
                        })).map(FormRow)
                }),
                Object.values((0, _lib.HourCategories)).map((cat)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Grid), {
                        children: [
                            data[cat].dates.map(FormRow),
                            (cat[0] + cat[1]).toUpperCase()
                        ]
                    }, cat))
            ]
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","date-fns":"5Pdd3","../../Tooltip":"ikXCW","../../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a4AIy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationMode", ()=>PaginationMode);
parcelHelpers.export(exports, "DataGrid", ()=>DataGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDataGrid = require("@mui/x-data-grid");
var _components = require("./components");
var _styles = require("./styles");
var _useColumns = require("./useColumns");
var _footer = require("./components/Footer");
var PaginationMode;
(function(PaginationMode) {
    PaginationMode["CLIENT"] = "client";
    PaginationMode["SERVER"] = "server";
})(PaginationMode || (PaginationMode = {}));
const DEFAULT_ROWS_PER_PAGE_OPTIONS = [
    100
];
const DataGrid = ({ columns, data, rowActions, loading, emptyState, errorState, columnVisibility, pagination, processRowUpdate, hideColumnSelector, hideExport, header, checkboxSelection, selectionModel, onSelectionModelChange, csvOptions, testID, disableColumnMenu, hideFooterPagination, customFooterContent, disableSelectionOnClick, sortModel })=>{
    const cols = (0, _useColumns.useColumns)({
        columns,
        rowActions
    });
    const { page, onPageChange, pageSize, onPageSizeChange, rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS, paginationMode = "client", rowCount } = pagination || {};
    const { isError } = errorState || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            display: "flex",
            height: 1
        },
        "data-testid": `${testID}-grid`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styles.StyledDataGrid), {
            columns: cols,
            rows: data,
            loading: loading,
            error: isError ? true : undefined,
            page: page,
            onPageChange: onPageChange,
            pageSize: pageSize,
            onPageSizeChange: onPageSizeChange,
            rowsPerPageOptions: rowsPerPageOptions,
            paginationMode: paginationMode,
            hideFooterPagination: hideFooterPagination,
            rowCount: rowCount,
            components: {
                Footer: customFooterContent ? (0, _footer.Footer) : (0, _xDataGrid.GridFooter),
                Toolbar: (0, _components.Toolbar),
                ErrorOverlay: (0, _components.ErrorState),
                NoRowsOverlay: (0, _components.EmptyState),
                LoadingOverlay: (0, _components.LoadingState)
            },
            componentsProps: {
                footer: {
                    content: customFooterContent
                },
                toolbar: {
                    hideColumnSelector,
                    hideExport,
                    header,
                    csvOptions
                },
                errorOverlay: {
                    ...errorState
                },
                noRowsOverlay: {
                    ...emptyState
                },
                loadingOverlay: {
                    data
                }
            },
            getRowClassName: (data)=>`${data.row.warning ? "warning" : ""} ${data.row.danger ? "danger" : ""} ${data.indexRelativeToCurrentPage % 2 ? "even" : "odd"}`,
            initialState: {
                columns: {
                    columnVisibilityModel: columnVisibility
                },
                sorting: {
                    sortModel: sortModel || [
                        {
                            field: "fullName",
                            sort: "asc"
                        }
                    ]
                }
            },
            experimentalFeatures: {
                newEditingApi: true
            },
            processRowUpdate: processRowUpdate,
            checkboxSelection: checkboxSelection,
            selectionModel: selectionModel,
            onSelectionModelChange: onSelectionModelChange,
            disableColumnMenu: disableColumnMenu,
            onProcessRowUpdateError: (e)=>console.error(e.message),
            disableSelectionOnClick: disableSelectionOnClick
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/x-data-grid":"1d1Aj","./components":"1X9gG","./styles":"8O41m","./useColumns":"9bzsl","./components/Footer":"lQwbK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1d1Aj":[function(require,module,exports) {
/** @license MUI X v5.17.26
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridApiContext", ()=>(0, _useGridApiContext.useGridApiContext));
parcelHelpers.export(exports, "useGridApiRef", ()=>(0, _useGridApiRef.useGridApiRef));
parcelHelpers.export(exports, "useGridRootProps", ()=>(0, _useGridRootProps.useGridRootProps));
var _useGridApiContext = require("./hooks/utils/useGridApiContext");
var _useGridApiRef = require("./hooks/utils/useGridApiRef");
var _useGridRootProps = require("./hooks/utils/useGridRootProps");
var _dataGrid = require("./DataGrid");
parcelHelpers.exportAll(_dataGrid, exports);
var _components = require("./components");
parcelHelpers.exportAll(_components, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
var _locales = require("./locales");
parcelHelpers.exportAll(_locales, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);
var _context = require("./context");
parcelHelpers.exportAll(_context, exports);
var _colDef = require("./colDef");
parcelHelpers.exportAll(_colDef, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./hooks/utils/useGridApiContext":"cn3M8","./hooks/utils/useGridApiRef":false,"./hooks/utils/useGridRootProps":false,"./DataGrid":"2foSE","./components":"6eLWA","./constants":"bDcEB","./hooks":"2xQfa","./locales":false,"./models":false,"./context":false,"./colDef":false,"./utils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cn3M8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridApiContext", ()=>useGridApiContext);
var _react = require("react");
var _gridApiContext = require("../../components/GridApiContext");
function useGridApiContext() {
    const apiRef = _react.useContext((0, _gridApiContext.GridApiContext));
    if (apiRef === undefined) throw new Error([
        "MUI: Could not find the data grid context.",
        "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.",
        "This can also happen if you are bundling multiple versions of the data grid."
    ].join("\n"));
    return apiRef;
}

},{"react":"gVheC","../../components/GridApiContext":"7jUSD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7jUSD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridApiContext", ()=>GridApiContext);
var _react = require("react");
const GridApiContext = /*#__PURE__*/ _react.createContext(undefined);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cdy2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRootProps", ()=>useGridRootProps);
var _react = require("react");
var _gridRootPropsContext = require("../../context/GridRootPropsContext");
const useGridRootProps = ()=>{
    const contextValue = _react.useContext((0, _gridRootPropsContext.GridRootPropsContext));
    if (!contextValue) throw new Error("MUI: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
    return contextValue;
};

},{"react":"gVheC","../../context/GridRootPropsContext":"gVCkj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gVCkj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRootPropsContext", ()=>GridRootPropsContext);
var _react = require("react");
const GridRootPropsContext = /*#__PURE__*/ _react.createContext(undefined);

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2foSE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_PAGE_SIZE", ()=>(0, _useDataGridProps.MAX_PAGE_SIZE));
parcelHelpers.export(exports, "DATA_GRID_PROPS_DEFAULT_VALUES", ()=>(0, _useDataGridProps.DATA_GRID_PROPS_DEFAULT_VALUES));
var _dataGrid = require("./DataGrid");
parcelHelpers.exportAll(_dataGrid, exports);
var _useDataGridProps = require("./useDataGridProps");

},{"./DataGrid":"3U6h8","./useDataGridProps":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3U6h8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataGrid", ()=>DataGrid);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _components = require("../components");
var _gridContextProvider = require("../context/GridContextProvider");
var _useDataGridComponent = require("./useDataGridComponent");
var _useDataGridProps = require("./useDataGridProps");
var _dataGridVirtualScroller = require("../components/DataGridVirtualScroller");
var _dataGridColumnHeaders = require("../components/DataGridColumnHeaders");
var _jsxRuntime = require("react/jsx-runtime");
const DataGridRaw = /*#__PURE__*/ _react.forwardRef(function DataGrid(inProps, ref) {
    const props = (0, _useDataGridProps.useDataGridProps)(inProps);
    const apiRef = (0, _useDataGridComponent.useDataGridComponent)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridContextProvider.GridContextProvider), {
        apiRef: apiRef,
        props: props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GridRoot), {
            className: props.className,
            style: props.style,
            sx: props.sx,
            ref: ref,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.GridErrorHandler), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GridHeaderPlaceholder), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GridBody), {
                        ColumnHeadersComponent: (0, _dataGridColumnHeaders.DataGridColumnHeaders),
                        VirtualScrollerComponent: (0, _dataGridVirtualScroller.DataGridVirtualScroller)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GridFooterPlaceholder), {})
                ]
            })
        })
    });
});
const DataGrid = /*#__PURE__*/ _react.memo(DataGridRaw);
DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The label of the grid.
   */ "aria-label": (0, _propTypesDefault.default).string,
    /**
   * The id of the element containing a label for the grid.
   */ "aria-labelledby": (0, _propTypesDefault.default).string,
    /**
   * If `true`, the grid height is dynamic and follow the number of rows in the grid.
   * @default false
   */ autoHeight: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, _propTypesDefault.default).bool,
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, _propTypesDefault.default).object,
    /**
   * If `true`, the grid get a first column with a checkbox that allows to select rows.
   * @default false
   */ checkboxSelection: (0, _propTypesDefault.default).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, _propTypesDefault.default).object,
    /**
   * Number of extra columns to be rendered before/after the visible slice.
   * @default 3
   */ columnBuffer: (0, _propTypesDefault.default).number,
    columnGroupingModel: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    /**
   * Set of columns of type [[GridColumns]].
   */ columns: (0, _utils.chainPropTypes)((0, _propTypesDefault.default).array.isRequired, (props)=>{
        // @ts-ignore because otherwise `build:api` doesn't work
        if (props.columns && props.columns.some((column)=>column.resizable)) return new Error([
            `MUI: \`column.resizable = true\` is not a valid prop.`,
            "Column resizing is not available in the MIT version.",
            "",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
        return null;
    }),
    /**
   * Number of rows from the `columnBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ columnThreshold: (0, _propTypesDefault.default).number,
    /**
   * Extend native column types with your new column types.
   */ columnTypes: (0, _propTypesDefault.default).object,
    /**
   * Set the column visibility model of the grid.
   * If defined, the grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, _propTypesDefault.default).object,
    /**
   * Overrideable components.
   */ components: (0, _propTypesDefault.default).object,
    /**
   * Overrideable components props dynamically passed to the component at rendering.
   */ componentsProps: (0, _propTypesDefault.default).object,
    /**
   * Set the density of the grid.
   * @default "standard"
   */ density: (0, _propTypesDefault.default).oneOf([
        "comfortable",
        "compact",
        "standard"
    ]),
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, rows will not be extended to fill the full width of the grid container.
   * @default false
   */ disableExtendRowFullWidth: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, modification to a cell will not be discarded if the mode is changed from "edit" to "view" while processing props.
   * @default false
   */ disableIgnoreModificationsIfProcessingProps: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableSelectionOnClick: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, _propTypesDefault.default).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, _propTypesDefault.default).oneOf([
        "cell",
        "row"
    ]),
    /**
   * Set the edit rows model of the grid.
   */ editRowsModel: (0, _propTypesDefault.default).object,
    /**
   * An error that will turn the grid into its error state and display the error component.
   */ error: (0, _propTypesDefault.default).any,
    /**
   * Features under development.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, _propTypesDefault.default).shape({
        columnGrouping: (0, _propTypesDefault.default).bool,
        newEditingApi: (0, _propTypesDefault.default).bool,
        preventCommitWhileValidating: (0, _propTypesDefault.default).bool,
        warnIfFocusStateIsNotSynced: (0, _propTypesDefault.default).bool
    }),
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, _propTypesDefault.default).oneOf([
        "client",
        "server"
    ]),
    /**
   * Set the filter model of the grid.
   */ filterModel: (0, _propTypesDefault.default).shape({
        items: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
            columnField: (0, _propTypesDefault.default).string.isRequired,
            id: (0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).number,
                (0, _propTypesDefault.default).string
            ]),
            operatorValue: (0, _propTypesDefault.default).string,
            value: (0, _propTypesDefault.default).any
        })).isRequired,
        linkOperator: (0, _propTypesDefault.default).oneOf([
            "and",
            "or"
        ]),
        quickFilterLogicOperator: (0, _propTypesDefault.default).oneOf([
            "and",
            "or"
        ]),
        quickFilterValues: (0, _propTypesDefault.default).array
    }),
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, _propTypesDefault.default).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, _propTypesDefault.default).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, _propTypesDefault.default).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, _propTypesDefault.default).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, _propTypesDefault.default).func,
    /**
   * Return the id of a given [[GridRowModel]].
   */ getRowId: (0, _propTypesDefault.default).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, _propTypesDefault.default).func,
    /**
   * Set the height in pixel of the column headers in the grid.
   * @default 56
   */ headerHeight: (0, _propTypesDefault.default).number,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, _propTypesDefault.default).bool,
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, _propTypesDefault.default).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, _propTypesDefault.default).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the cell is selectable.
   */ isRowSelectable: (0, _propTypesDefault.default).func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, a  loading overlay is displayed.
   */ loading: (0, _propTypesDefault.default).bool,
    /**
   * Set the locale text of the grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/grid/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, _propTypesDefault.default).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, _propTypesDefault.default).shape({
        debug: (0, _propTypesDefault.default).func.isRequired,
        error: (0, _propTypesDefault.default).func.isRequired,
        info: (0, _propTypesDefault.default).func.isRequired,
        warn: (0, _propTypesDefault.default).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, _propTypesDefault.default).oneOf([
        "debug",
        "error",
        "info",
        "warn",
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, _propTypesDefault.default).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the cell changes are committed.
   * @param {GridCellEditCommitParams} params With all properties from [[GridCellEditCommitParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellEditCommit: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a cell loses focus.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellFocusOut: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containig which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a column visibility changes.
   * Only works when no `columnVisibilityModel` is provided and if we change the visibility of a single column at a time.
   * @param {GridColumnVisibilityChangeParams} params With all properties from [[GridColumnVisibilityChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @deprecated Use `onColumnVisibilityModelChange` instead.
   */ onColumnVisibilityChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the edit cell value changes.
   * @param {GridEditCellPropsParams} params With all properties from [[GridEditCellPropsParams]].
   * @param {MuiEvent<React.SyntheticEvent>} event The event that caused this prop to be called.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @deprecated use `preProcessEditCellProps` from the [`GridColDef`](/x/api/data-grid/grid-col-def/)
   */ onEditCellPropsChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the `editRowsModel` changes.
   * @param {GridEditRowsModel} editRowsModel With all properties from [[GridEditRowsModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onEditRowsModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when an exception is thrown in the grid.
   * @param {any} args The arguments passed to the `showError` call.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the current page has changed.
   * @param {number} page Index of the page displayed on the Grid.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPageChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the page size has changed.
   * @param {number} pageSize Size of the page displayed on the Grid.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPageSizeChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, _propTypesDefault.default).func,
    /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the row changes are committed.
   * @param {GridRowId} id The row id.
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditCommit: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containig which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridSelectionModel} selectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSelectionModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, _propTypesDefault.default).func,
    /**
   * Callback fired when the state of the grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, _propTypesDefault.default).func,
    /**
   * The zero-based index of the current page.
   * @default 0
   */ page: (0, _propTypesDefault.default).number,
    /**
   * Set the number of rows in one page.
   * If some of the rows have children (for instance in the tree data), this number represents the amount of top level rows wanted on each page.
   * @default 100
   */ pageSize: (0, _utils.chainPropTypes)((0, _propTypesDefault.default).number, (props)=>{
        if (props.pageSize && props.pageSize > (0, _useDataGridProps.MAX_PAGE_SIZE)) return new Error([
            `MUI: \`<DataGrid pageSize={${props.pageSize}} />\` is not a valid prop.`,
            `Only page size below ${(0, _useDataGridProps.MAX_PAGE_SIZE)} is available in the MIT version.`,
            "",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
        return null;
    }),
    pagination: (props)=>{
        if (props.pagination === false) return new Error([
            "MUI: `<DataGrid pagination={false} />` is not a valid prop.",
            "Infinite scrolling is not available in the MIT version.",
            "",
            "You need to upgrade to DataGridPro or DataGridPremium component to disable the pagination."
        ].join("\n"));
        return null;
    },
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, _propTypesDefault.default).oneOf([
        "client",
        "server"
    ]),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * Only applied if `props.experimentalFeatures.newEditingApi: true`.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, _propTypesDefault.default).func,
    /**
   * Number of extra rows to be rendered before/after the visible slice.
   * @default 3
   */ rowBuffer: (0, _propTypesDefault.default).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   */ rowCount: (0, _propTypesDefault.default).number,
    /**
   * Set the height in pixel of a row in the grid.
   * @default 52
   */ rowHeight: (0, _propTypesDefault.default).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, _propTypesDefault.default).object,
    /**
   * Set of rows of type [[GridRowsProp]].
   */ rows: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object).isRequired,
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, _propTypesDefault.default).oneOf([
        "border",
        "margin"
    ]),
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ rowsPerPageOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    /**
   * Number of rows from the `rowBuffer` that can be visible before a new slice is rendered.
   * @default 3
   */ rowThreshold: (0, _propTypesDefault.default).number,
    /**
   * Override the height/width of the grid inner scrollbar.
   */ scrollbarSize: (0, _propTypesDefault.default).number,
    /**
   * Set the selection model of the grid.
   */ selectionModel: (0, _utils.chainPropTypes)((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).array
    ]), (props)=>{
        if (!props.checkboxSelection && Array.isArray(props.selectionModel) && props.selectionModel.length > 1) return new Error([
            `MUI: \`<DataGrid selectionModel={${JSON.stringify(props.selectionModel)}} />\` is not a valid prop.`,
            "selectionModel can only be of 1 item in DataGrid.",
            "",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."
        ].join("\n"));
        return null;
    }),
    /**
   * If `true`, the right border of the cells are displayed.
   * @default false
   */ showCellRightBorder: (0, _propTypesDefault.default).bool,
    /**
   * If `true`, the right border of the column headers are displayed.
   * @default false
   */ showColumnRightBorder: (0, _propTypesDefault.default).bool,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, _propTypesDefault.default).oneOf([
        "client",
        "server"
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOf([
        "asc",
        "desc"
    ])),
    /**
   * Set the sort model of the grid.
   */ sortModel: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        field: (0, _propTypesDefault.default).string.isRequired,
        sort: (0, _propTypesDefault.default).oneOf([
            "asc",
            "desc"
        ])
    })),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).bool
        ])),
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ])
};

},{"react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","../components":"6eLWA","../context/GridContextProvider":"klaaX","./useDataGridComponent":"1JiBL","./useDataGridProps":"e5PtH","../components/DataGridVirtualScroller":"ee75N","../components/DataGridColumnHeaders":"lK1RY","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6eLWA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _base = require("./base");
parcelHelpers.exportAll(_base, exports);
var _cell = require("./cell");
parcelHelpers.exportAll(_cell, exports);
var _containers = require("./containers");
parcelHelpers.exportAll(_containers, exports);
var _columnHeaders = require("./columnHeaders");
parcelHelpers.exportAll(_columnHeaders, exports);
var _columnSelection = require("./columnSelection");
parcelHelpers.exportAll(_columnSelection, exports);
var _icons = require("./icons");
parcelHelpers.exportAll(_icons, exports);
var _menu = require("./menu");
parcelHelpers.exportAll(_menu, exports);
var _panel = require("./panel");
parcelHelpers.exportAll(_panel, exports);
var _toolbar = require("./toolbar");
parcelHelpers.exportAll(_toolbar, exports);
var _gridApiContext = require("./GridApiContext");
parcelHelpers.exportAll(_gridApiContext, exports);
var _gridAutoSizer = require("./GridAutoSizer");
parcelHelpers.exportAll(_gridAutoSizer, exports);
var _gridFooter = require("./GridFooter");
parcelHelpers.exportAll(_gridFooter, exports);
var _gridHeader = require("./GridHeader");
parcelHelpers.exportAll(_gridHeader, exports);
var _gridLoadingOverlay = require("./GridLoadingOverlay");
parcelHelpers.exportAll(_gridLoadingOverlay, exports);
var _gridNoRowsOverlay = require("./GridNoRowsOverlay");
parcelHelpers.exportAll(_gridNoRowsOverlay, exports);
var _gridPagination = require("./GridPagination");
parcelHelpers.exportAll(_gridPagination, exports);
var _gridRowCount = require("./GridRowCount");
parcelHelpers.exportAll(_gridRowCount, exports);
var _gridRow = require("./GridRow");
parcelHelpers.exportAll(_gridRow, exports);
var _gridSelectedRowCount = require("./GridSelectedRowCount");
parcelHelpers.exportAll(_gridSelectedRowCount, exports);
var _gridScrollArea = require("./GridScrollArea");
parcelHelpers.exportAll(_gridScrollArea, exports);

},{"./base":"kPtU8","./cell":"lNc24","./containers":"eaVgS","./columnHeaders":"6qDRe","./columnSelection":false,"./icons":"kOLOm","./menu":"dRJQi","./panel":"kUCv9","./toolbar":"eYUmj","./GridApiContext":false,"./GridAutoSizer":false,"./GridFooter":"3ObsZ","./GridHeader":"6qkGi","./GridLoadingOverlay":"fGDBs","./GridNoRowsOverlay":"aSPpB","./GridPagination":"4SChv","./GridRowCount":false,"./GridRow":"3dYSa","./GridSelectedRowCount":false,"./GridScrollArea":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kPtU8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridBody = require("./GridBody");
parcelHelpers.exportAll(_gridBody, exports);
var _gridErrorHandler = require("./GridErrorHandler");
parcelHelpers.exportAll(_gridErrorHandler, exports);
var _gridFooterPlaceholder = require("./GridFooterPlaceholder");
parcelHelpers.exportAll(_gridFooterPlaceholder, exports);
var _gridHeaderPlaceholder = require("./GridHeaderPlaceholder");
parcelHelpers.exportAll(_gridHeaderPlaceholder, exports);
var _gridOverlays = require("./GridOverlays");
parcelHelpers.exportAll(_gridOverlays, exports);

},{"./GridBody":"7xj1M","./GridErrorHandler":"cQxk1","./GridFooterPlaceholder":"1BQbt","./GridHeaderPlaceholder":"8Xnxn","./GridOverlays":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7xj1M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridBody", ()=>GridBody);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridMainContainer = require("../containers/GridMainContainer");
var _gridAutoSizer = require("../GridAutoSizer");
var _gridOverlays = require("./GridOverlays");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _densitySelector = require("../../hooks/features/density/densitySelector");
var _jsxRuntime = require("react/jsx-runtime");
function GridBody(props) {
    const { children, VirtualScrollerComponent, ColumnHeadersComponent } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const totalHeaderHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityTotalHeaderHeightSelector));
    const [isVirtualizationDisabled, setIsVirtualizationDisabled] = _react.useState(rootProps.disableVirtualization);
    const disableVirtualization = _react.useCallback(()=>{
        setIsVirtualizationDisabled(true);
    }, []);
    const enableVirtualization = _react.useCallback(()=>{
        setIsVirtualizationDisabled(false);
    }, []);
    _react.useEffect(()=>{
        setIsVirtualizationDisabled(rootProps.disableVirtualization);
    }, [
        rootProps.disableVirtualization
    ]); // The `useGridApiMethod` hook can't be used here, because it only installs the
    // method if it doesn't exist yet. Once installed, it's never updated again.
    // This break the methods above, since their closure comes from the first time
    // they were installed. Which means that calling `setIsVirtualizationDisabled`
    // will trigger a re-render, but it won't update the state. That can be solved
    // by migrating the virtualization status to the global state.
    apiRef.current.unstable_disableVirtualization = disableVirtualization;
    apiRef.current.unstable_enableVirtualization = enableVirtualization;
    const columnHeadersRef = _react.useRef(null);
    const columnsContainerRef = _react.useRef(null);
    const windowRef = _react.useRef(null);
    const renderingZoneRef = _react.useRef(null);
    apiRef.current.columnHeadersContainerElementRef = columnsContainerRef;
    apiRef.current.columnHeadersElementRef = columnHeadersRef;
    apiRef.current.windowRef = windowRef; // TODO rename, it's not attached to the window anymore
    apiRef.current.renderingZoneRef = renderingZoneRef; // TODO remove, nobody should have access to internal parts of the virtualization
    const handleResize = _react.useCallback((size)=>{
        apiRef.current.publishEvent("resize", size);
    }, [
        apiRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridMainContainer.GridMainContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridOverlays.GridOverlays), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnHeadersComponent, {
                ref: columnsContainerRef,
                innerRef: columnHeadersRef
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridAutoSizer.GridAutoSizer), {
                nonce: rootProps.nonce,
                disableHeight: rootProps.autoHeight,
                onResize: handleResize,
                children: (size)=>{
                    const style = {
                        width: size.width,
                        // If `autoHeight` is on, there will be no height value.
                        // In this case, let the container to grow whatever it needs.
                        height: size.height ? size.height - totalHeaderHeight : "auto",
                        marginTop: totalHeaderHeight
                    };
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VirtualScrollerComponent, {
                        ref: windowRef,
                        style: style,
                        disableVirtualization: isVirtualizationDisabled
                    });
                }
            }),
            children
        ]
    });
}

},{"react":"gVheC","prop-types":"3KNJy","../../hooks/utils/useGridApiContext":"cn3M8","../containers/GridMainContainer":"7HE6a","../GridAutoSizer":"35oFT","./GridOverlays":"drAF1","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridSelector":"96gNX","../../hooks/features/density/densitySelector":"chMex","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7HE6a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridMainContainer", ()=>GridMainContainer);
var _react = require("react");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "main"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridMainContainerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "Main",
    overridesResolver: (props, styles)=>styles.main
})(()=>({
        position: "relative",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
    }));
function GridMainContainer(props) {
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridMainContainerRoot, {
        className: classes.root,
        ownerState: rootProps,
        children: props.children
    });
}

},{"react":"gVheC","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5U0ME":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataGridUtilityClass", ()=>getDataGridUtilityClass);
parcelHelpers.export(exports, "gridClasses", ()=>gridClasses);
var _material = require("@mui/material");
function getDataGridUtilityClass(slot) {
    return (0, _material.generateUtilityClass)("MuiDataGrid", slot);
}
const gridClasses = (0, _material.generateUtilityClasses)("MuiDataGrid", [
    "actionsCell",
    "aggregationColumnHeader",
    "aggregationColumnHeader--alignLeft",
    "aggregationColumnHeader--alignCenter",
    "aggregationColumnHeader--alignRight",
    "autoHeight",
    "booleanCell",
    "cell--editable",
    "cell--editing",
    "cell--textCenter",
    "cell--textLeft",
    "cell--textRight",
    "cell--withRenderer",
    "cell",
    "cellContent",
    "cellCheckbox",
    "cellSkeleton",
    "checkboxInput",
    "columnHeader--alignCenter",
    "columnHeader--alignLeft",
    "columnHeader--alignRight",
    "columnHeader--dragging",
    "columnHeader--moving",
    "columnHeader--numeric",
    "columnHeader--sortable",
    "columnHeader--sorted",
    "columnHeader--filtered",
    "columnHeader",
    "columnHeaderCheckbox",
    "columnHeaderDraggableContainer",
    "columnHeaderDropZone",
    "columnHeaderTitle",
    "columnHeaderTitleContainer",
    "columnHeaderTitleContainerContent",
    "columnGroupHeader",
    "columnHeader--filledGroup",
    "columnHeader--emptyGroup",
    "columnHeader--showColumnBorder",
    "columnHeaders",
    "columnHeadersInner",
    "columnHeadersInner--scrollable",
    "columnSeparator--resizable",
    "columnSeparator--resizing",
    "columnSeparator--sideLeft",
    "columnSeparator--sideRight",
    "columnSeparator",
    "columnsPanel",
    "columnsPanelRow",
    "detailPanel",
    "detailPanels",
    "detailPanelToggleCell",
    "detailPanelToggleCell--expanded",
    "footerCell",
    "panel",
    "panelHeader",
    "panelWrapper",
    "panelContent",
    "panelFooter",
    "paper",
    "editBooleanCell",
    "editInputCell",
    "filterForm",
    "filterFormDeleteIcon",
    "filterFormLinkOperatorInput",
    "filterFormColumnInput",
    "filterFormOperatorInput",
    "filterFormValueInput",
    "filterIcon",
    "footerContainer",
    "iconButtonContainer",
    "iconSeparator",
    "main",
    "menu",
    "menuIcon",
    "menuIconButton",
    "menuOpen",
    "menuList",
    "overlay",
    "root",
    "root--densityStandard",
    "root--densityComfortable",
    "root--densityCompact",
    "row",
    "row--editable",
    "row--editing",
    "row--lastVisible",
    "row--dragging",
    "row--dynamicHeight",
    "row--detailPanelExpanded",
    "rowReorderCellPlaceholder",
    "rowCount",
    "rowReorderCellContainer",
    "rowReorderCell",
    "rowReorderCell--draggable",
    "scrollArea--left",
    "scrollArea--right",
    "scrollArea",
    "selectedRowCount",
    "sortIcon",
    "toolbarContainer",
    "toolbarFilterList",
    "virtualScroller",
    "virtualScrollerContent",
    "virtualScrollerContent--overflowed",
    "virtualScrollerRenderZone",
    "pinnedColumns",
    "pinnedColumns--left",
    "pinnedColumns--right",
    "pinnedColumnHeaders",
    "pinnedColumnHeaders--left",
    "pinnedColumnHeaders--right",
    "withBorder",
    "treeDataGroupingCell",
    "treeDataGroupingCellToggle",
    "groupingCriteriaCell",
    "groupingCriteriaCellToggle",
    "pinnedRows",
    "pinnedRows--top",
    "pinnedRows--bottom",
    "pinnedRowsRenderZone"
]);

},{"@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"35oFT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridAutoSizer", ()=>GridAutoSizer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _createDetectElementResize = require("../lib/createDetectElementResize"); // TODO replace with https://caniuse.com/resizeobserver.
var _createDetectElementResizeDefault = parcelHelpers.interopDefault(_createDetectElementResize);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "defaultHeight",
    "defaultWidth",
    "disableHeight",
    "disableWidth",
    "nonce",
    "onResize",
    "style"
];
const GridAutoSizer = /*#__PURE__*/ _react.forwardRef(function AutoSizer(props, ref) {
    const { children, defaultHeight = null, defaultWidth = null, disableHeight = false, disableWidth = false, nonce, onResize, style } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [state, setState] = _react.useState({
        height: defaultHeight,
        width: defaultWidth
    });
    const rootRef = _react.useRef(null);
    const parentElement = _react.useRef(null);
    const handleResize = (0, _utils.useEventCallback)(()=>{
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        if (parentElement.current) {
            const height = parentElement.current.offsetHeight || 0;
            const width = parentElement.current.offsetWidth || 0;
            const win = (0, _utils.ownerWindow)(parentElement.current);
            const computedStyle = win.getComputedStyle(parentElement.current);
            const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
            const paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
            const paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
            const paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
            const newHeight = height - paddingTop - paddingBottom;
            const newWidth = width - paddingLeft - paddingRight;
            if (!disableHeight && state.height !== newHeight || !disableWidth && state.width !== newWidth) {
                setState({
                    height: newHeight,
                    width: newWidth
                });
                if (onResize) onResize({
                    height: newHeight,
                    width: newWidth
                });
            }
        }
    });
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        var _parentElement$curren;
        parentElement.current = rootRef.current.parentElement;
        if (!parentElement) return undefined;
        const win = (0, _utils.ownerWindow)((_parentElement$curren = parentElement.current) != null ? _parentElement$curren : undefined);
        const detectElementResize = (0, _createDetectElementResizeDefault.default)(nonce, win);
        detectElementResize.addResizeListener(parentElement.current, handleResize);
        handleResize();
        return ()=>{
            detectElementResize.removeResizeListener(parentElement.current, handleResize);
        };
    }, [
        nonce,
        handleResize
    ]); // Outer div should not force width/height since that may prevent containers from shrinking.
    // Inner component should overflow and use calculated width/height.
    // See issue #68 for more information.
    const outerStyle = {
        overflow: "visible"
    };
    const childParams = {};
    if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = state.height;
    }
    if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = state.width;
    }
    const handleRef = (0, _utils.useForkRef)(rootRef, ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        ref: handleRef,
        style: (0, _extendsDefault.default)({}, outerStyle, style)
    }, other, {
        children: state.height === null && state.width === null ? null : children(childParams)
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/utils":"ziQFX","../lib/createDetectElementResize":"2Ukod","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Ukod":[function(require,module,exports) {
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 *
 * TODO replace with https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 * once browser support allows it.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createDetectElementResize);
function createDetectElementResize(nonce, hostWindow) {
    var resetTriggers = function resetTriggers(element) {
        var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
        contract.scrollLeft = contract.scrollWidth;
        contract.scrollTop = contract.scrollHeight;
        expandChild.style.width = expand.offsetWidth + 1 + "px";
        expandChild.style.height = expand.offsetHeight + 1 + "px";
        expand.scrollLeft = expand.scrollWidth;
        expand.scrollTop = expand.scrollHeight;
    };
    var checkTriggers = function checkTriggers(element) {
        return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };
    var scrollListener = function scrollListener(e) {
        // Don't measure (which forces) reflow for scrolls that happen inside of children!
        if (e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
        var element = this;
        resetTriggers(this);
        if (this.__resizeRAF__) hostWindow.cancelAnimationFrame(this.__resizeRAF__);
        this.__resizeRAF__ = hostWindow.requestAnimationFrame(function() {
            if (checkTriggers(element)) {
                element.__resizeLast__.width = element.offsetWidth;
                element.__resizeLast__.height = element.offsetHeight;
                element.__resizeListeners__.forEach(function(fn) {
                    fn.call(element, e);
                });
            }
        });
    };
    /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = "", animationstartevent = "animationstart", domPrefixes = "Webkit Moz O ms".split(" "), startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), pfx = "";
    var elm = document.createElement("fakeelement");
    if (elm.style.animationName !== undefined) animation = true;
    if (animation === false) {
        for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = "-" + pfx.toLowerCase() + "-";
            animationstartevent = startEvents[i];
            animation = true;
            break;
        }
    }
    var animationName = "resizeanim";
    var animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
    var animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    var createStyles = function createStyles(doc, root) {
        if (!root.getElementById("muiDetectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : "") + ".Mui-resizeTriggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.Mui-resizeTriggers, .Mui-resizeTriggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .Mui-resizeTriggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', container = root.constructor.name === "ShadowRoot" ? root : doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "muiDetectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            container.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (!element.__resizeTriggers__) {
            var doc = element.ownerDocument;
            var elementStyle = hostWindow.getComputedStyle(element);
            if (elementStyle && elementStyle.position == "static") element.style.position = "relative";
            createStyles(doc, element.getRootNode());
            element.__resizeLast__ = {};
            element.__resizeListeners__ = [];
            (element.__resizeTriggers__ = doc.createElement("div")).className = "Mui-resizeTriggers";
            element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
            element.appendChild(element.__resizeTriggers__);
            resetTriggers(element);
            element.addEventListener("scroll", scrollListener, true);
            /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                    if (e.animationName == animationName) resetTriggers(element);
                };
                element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
            }
        }
        element.__resizeListeners__.push(fn);
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
        if (!element.__resizeListeners__.length) {
            element.removeEventListener("scroll", scrollListener, true);
            if (element.__resizeTriggers__.__animationListener__) {
                element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                element.__resizeTriggers__.__animationListener__ = null;
            }
            try {
                element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
            } catch (e) {}
        }
    };
    return {
        addResizeListener,
        removeResizeListener
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"drAF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridOverlays", ()=>GridOverlays);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _gridFilterSelector = require("../../hooks/features/filter/gridFilterSelector");
var _gridRowsSelector = require("../../hooks/features/rows/gridRowsSelector");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _densitySelector = require("../../hooks/features/density/densitySelector");
var _jsxRuntime = require("react/jsx-runtime");
function GridOverlayWrapper(props) {
    var _viewportInnerSize$he, _viewportInnerSize$wi;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const totalHeaderHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityTotalHeaderHeightSelector));
    const [viewportInnerSize, setViewportInnerSize] = _react.useState(()=>{
        var _apiRef$current$getRo, _apiRef$current$getRo2;
        return (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.viewportInnerSize) != null ? _apiRef$current$getRo : null;
    });
    const handleViewportSizeChange = _react.useCallback(()=>{
        var _apiRef$current$getRo3, _apiRef$current$getRo4;
        setViewportInnerSize((_apiRef$current$getRo3 = (_apiRef$current$getRo4 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo4.viewportInnerSize) != null ? _apiRef$current$getRo3 : null);
    }, [
        apiRef
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        return apiRef.current.subscribeEvent("viewportInnerSizeChange", handleViewportSizeChange);
    }, [
        apiRef,
        handleViewportSizeChange
    ]);
    let height = (_viewportInnerSize$he = viewportInnerSize == null ? void 0 : viewportInnerSize.height) != null ? _viewportInnerSize$he : 0;
    if (rootProps.autoHeight && height === 0) height = "auto";
    if (!viewportInnerSize) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        style: {
            height,
            width: (_viewportInnerSize$wi = viewportInnerSize == null ? void 0 : viewportInnerSize.width) != null ? _viewportInnerSize$wi : 0,
            position: "absolute",
            top: totalHeaderHeight,
            bottom: height === "auto" ? 0 : undefined
        }
    }, props));
}
function GridOverlays() {
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const totalRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridRowCountSelector));
    const visibleRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridVisibleRowCountSelector));
    const loading = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridRowsLoadingSelector));
    const showNoRowsOverlay = !loading && totalRowCount === 0;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    let overlay = null;
    if (showNoRowsOverlay) {
        var _rootProps$components;
        overlay = /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.NoRowsOverlay, (0, _extendsDefault.default)({}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.noRowsOverlay));
    }
    if (showNoResultsOverlay) {
        var _rootProps$components2;
        overlay = /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.NoResultsOverlay, (0, _extendsDefault.default)({}, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.noResultsOverlay));
    }
    if (loading) {
        var _rootProps$components3;
        overlay = /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.LoadingOverlay, (0, _extendsDefault.default)({}, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.loadingOverlay));
    }
    if (overlay === null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridOverlayWrapper, {
        children: overlay
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../hooks/utils/useGridSelector":"96gNX","../../hooks/features/filter/gridFilterSelector":"lndlA","../../hooks/features/rows/gridRowsSelector":"fCZaq","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/features/density/densitySelector":"chMex","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"96gNX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelector", ()=>useGridSelector);
var _warning = require("../../utils/warning");
function isOutputSelector(selector) {
    return selector.acceptsApiRef;
}
const stateNotInitializedWarning = (0, _warning.buildWarning)([
    "MUI: `useGridSelector` has been called before the initialization of the state.",
    "This hook can only be used inside the context of the grid."
]);
const useGridSelector = (apiRef, selector)=>{
    if (isOutputSelector(selector)) return selector(apiRef);
    return selector(apiRef.current.state);
};

},{"../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cfes8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildWarning", ()=>buildWarning);
parcelHelpers.export(exports, "wrapWithWarningOnCall", ()=>wrapWithWarningOnCall);
const buildWarning = (message, gravity = "warning")=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === "error") console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};
const wrapWithWarningOnCall = (method, message)=>{
    var args;
    return method;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lndlA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridFilterStateSelector", ()=>gridFilterStateSelector);
parcelHelpers.export(exports, "gridFilterModelSelector", ()=>gridFilterModelSelector);
parcelHelpers.export(exports, "gridQuickFilterValuesSelector", ()=>gridQuickFilterValuesSelector);
parcelHelpers.export(exports, "gridVisibleRowsLookupSelector", ()=>gridVisibleRowsLookupSelector);
parcelHelpers.export(exports, "gridFilteredRowsLookupSelector", ()=>gridFilteredRowsLookupSelector);
parcelHelpers.export(exports, "gridFilteredDescendantCountLookupSelector", ()=>gridFilteredDescendantCountLookupSelector);
parcelHelpers.export(exports, "gridVisibleSortedRowEntriesSelector", ()=>gridVisibleSortedRowEntriesSelector);
parcelHelpers.export(exports, "gridVisibleSortedRowIdsSelector", ()=>gridVisibleSortedRowIdsSelector);
parcelHelpers.export(exports, "gridFilteredSortedRowEntriesSelector", ()=>gridFilteredSortedRowEntriesSelector);
parcelHelpers.export(exports, "gridFilteredSortedRowIdsSelector", ()=>gridFilteredSortedRowIdsSelector);
parcelHelpers.export(exports, "gridVisibleRowsSelector", ()=>gridVisibleRowsSelector);
parcelHelpers.export(exports, "gridVisibleSortedTopLevelRowEntriesSelector", ()=>gridVisibleSortedTopLevelRowEntriesSelector);
parcelHelpers.export(exports, "gridVisibleRowCountSelector", ()=>gridVisibleRowCountSelector);
parcelHelpers.export(exports, "gridVisibleTopLevelRowCountSelector", ()=>gridVisibleTopLevelRowCountSelector);
parcelHelpers.export(exports, "gridFilterActiveItemsSelector", ()=>gridFilterActiveItemsSelector);
parcelHelpers.export(exports, "gridFilterActiveItemsLookupSelector", ()=>gridFilterActiveItemsLookupSelector);
var _createSelector = require("../../../utils/createSelector");
var _gridSortingSelector = require("../sorting/gridSortingSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _gridRowsSelector = require("../rows/gridRowsSelector");
const gridFilterStateSelector = (state)=>state.filter;
const gridFilterModelSelector = (0, _createSelector.createSelector)(gridFilterStateSelector, (filterState)=>filterState.filterModel);
const gridQuickFilterValuesSelector = (0, _createSelector.createSelector)(gridFilterModelSelector, (filterModel)=>filterModel.quickFilterValues);
const gridVisibleRowsLookupSelector = (0, _createSelector.createSelector)(gridFilterStateSelector, (filterState)=>filterState.visibleRowsLookup);
const gridFilteredRowsLookupSelector = (0, _createSelector.createSelector)(gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const gridFilteredDescendantCountLookupSelector = (0, _createSelector.createSelector)(gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const gridVisibleSortedRowEntriesSelector = (0, _createSelector.createSelector)(gridVisibleRowsLookupSelector, (0, _gridSortingSelector.gridSortedRowEntriesSelector), (visibleRowsLookup, sortedRows)=>sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false));
const gridVisibleSortedRowIdsSelector = (0, _createSelector.createSelector)(gridVisibleSortedRowEntriesSelector, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const gridFilteredSortedRowEntriesSelector = (0, _createSelector.createSelector)(gridFilteredRowsLookupSelector, (0, _gridSortingSelector.gridSortedRowEntriesSelector), (filteredRowsLookup, sortedRows)=>sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const gridFilteredSortedRowIdsSelector = (0, _createSelector.createSelector)(gridFilteredSortedRowEntriesSelector, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const gridVisibleRowsSelector = gridVisibleSortedRowIdsSelector;
const gridVisibleSortedTopLevelRowEntriesSelector = (0, _createSelector.createSelector)(gridVisibleSortedRowEntriesSelector, (0, _gridRowsSelector.gridRowTreeSelector), (0, _gridRowsSelector.gridRowTreeDepthSelector), (visibleSortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return visibleSortedRows;
    return visibleSortedRows.filter((row)=>{
        var _rowTree$row$id;
        return ((_rowTree$row$id = rowTree[row.id]) == null ? void 0 : _rowTree$row$id.depth) === 0;
    });
});
const gridVisibleRowCountSelector = (0, _createSelector.createSelector)(gridVisibleSortedRowEntriesSelector, (visibleSortedRows)=>visibleSortedRows.length);
const gridVisibleTopLevelRowCountSelector = (0, _createSelector.createSelector)(gridVisibleSortedTopLevelRowEntriesSelector, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const gridFilterActiveItemsSelector = (0, _createSelector.createSelector)(gridFilterModelSelector, (0, _gridColumnsSelector.gridColumnLookupSelector), (filterModel, columnLookup)=>{
    var _filterModel$items;
    return (_filterModel$items = filterModel.items) == null ? void 0 : _filterModel$items.filter((item)=>{
        var _column$filterOperato, _item$value;
        if (!item.columnField) return false;
        const column = columnLookup[item.columnField];
        if (!(column != null && column.filterOperators) || (column == null ? void 0 : (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.length) === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operatorValue);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && ((_item$value = item.value) == null ? void 0 : _item$value.toString()) !== "";
    });
});
const gridFilterActiveItemsLookupSelector = (0, _createSelector.createSelector)(gridFilterActiveItemsSelector, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.columnField]) res[filterItem.columnField] = [
            filterItem
        ];
        else res[filterItem.columnField].push(filterItem);
        return res;
    }, {});
    return result;
});

},{"../../../utils/createSelector":"4xqAC","../sorting/gridSortingSelector":"1g9b1","../columns/gridColumnsSelector":"aeHtc","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4xqAC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "unstable_resetCreateSelectorCache", ()=>unstable_resetCreateSelectorCache);
var _reselect = require("reselect");
var _warning = require("./warning");
const cacheContainer = {
    cache: null
};
const missingInstanceIdWarning = (0, _warning.buildWarning)([
    "MUI: A selector was called without passing the instance ID, which may impact the performance of the grid.",
    "To fix, call it with `apiRef`, e.g. `mySelector(apiRef)`, or pass the instance ID explicitly, e.g `mySelector(state, apiRef.current.instanceId)`."
]);
const createSelector = (...args)=>{
    if (cacheContainer.cache === null) cacheContainer.cache = {};
    const selector = (...selectorArgs)=>{
        const [stateOrApiRef, instanceId] = selectorArgs;
        const isApiRef = !!stateOrApiRef.current;
        const cacheKey = isApiRef ? stateOrApiRef.current.instanceId : instanceId != null ? instanceId : "default";
        const state = isApiRef ? stateOrApiRef.current.state : stateOrApiRef;
        if (cacheContainer.cache === null) cacheContainer.cache = {};
        const { cache } = cacheContainer;
        if (cache[cacheKey] && cache[cacheKey].get(args)) // We pass the cache key because the called selector might have as
        // dependency another selector created with this `createSelector`.
        return cache[cacheKey].get(args)(state, cacheKey);
        const newSelector = (0, _reselect.createSelector)(...args);
        if (!cache[cacheKey]) cache[cacheKey] = new Map();
        cache[cacheKey].set(args, newSelector);
        return newSelector(state, cacheKey);
    }; // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
}; // eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_resetCreateSelectorCache = (cacheKey)=>{
    if (typeof cacheKey !== "undefined") {
        if (cacheContainer.cache && cacheContainer.cache[cacheKey]) delete cacheContainer.cache[cacheKey];
    } else cacheContainer.cache = null;
};

},{"reselect":"iYtdg","./warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iYtdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"bfPHl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bfPHl":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1g9b1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridSortingStateSelector", ()=>gridSortingStateSelector);
parcelHelpers.export(exports, "gridSortedRowIdsSelector", ()=>gridSortedRowIdsSelector);
parcelHelpers.export(exports, "gridSortedRowEntriesSelector", ()=>gridSortedRowEntriesSelector);
parcelHelpers.export(exports, "gridSortModelSelector", ()=>gridSortModelSelector);
parcelHelpers.export(exports, "gridSortColumnLookupSelector", ()=>gridSortColumnLookupSelector);
var _createSelector = require("../../../utils/createSelector");
var _gridRowsSelector = require("../rows/gridRowsSelector");
const gridSortingStateSelector = (state)=>state.sorting;
const gridSortedRowIdsSelector = (0, _createSelector.createSelector)(gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const gridSortedRowEntriesSelector = (0, _createSelector.createSelector)(gridSortedRowIdsSelector, (0, _gridRowsSelector.gridRowsLookupSelector), (sortedIds, idRowsLookup)=>sortedIds.map((id)=>({
            id,
            model: idRowsLookup[id]
        })));
const gridSortModelSelector = (0, _createSelector.createSelector)(gridSortingStateSelector, (sorting)=>sorting.sortModel);
const gridSortColumnLookupSelector = (0, _createSelector.createSelector)(gridSortModelSelector, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});

},{"../../../utils/createSelector":"4xqAC","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fCZaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridRowsStateSelector", ()=>gridRowsStateSelector);
parcelHelpers.export(exports, "gridRowCountSelector", ()=>gridRowCountSelector);
parcelHelpers.export(exports, "gridRowsLoadingSelector", ()=>gridRowsLoadingSelector);
parcelHelpers.export(exports, "gridTopLevelRowCountSelector", ()=>gridTopLevelRowCountSelector);
parcelHelpers.export(exports, "gridRowsLookupSelector", ()=>gridRowsLookupSelector);
parcelHelpers.export(exports, "gridRowsIdToIdLookupSelector", ()=>gridRowsIdToIdLookupSelector);
parcelHelpers.export(exports, "gridRowTreeSelector", ()=>gridRowTreeSelector);
parcelHelpers.export(exports, "gridRowGroupingNameSelector", ()=>gridRowGroupingNameSelector);
parcelHelpers.export(exports, "gridRowTreeDepthSelector", ()=>gridRowTreeDepthSelector);
parcelHelpers.export(exports, "gridRowIdsSelector", ()=>gridRowIdsSelector);
parcelHelpers.export(exports, "gridAdditionalRowGroupsSelector", ()=>gridAdditionalRowGroupsSelector);
parcelHelpers.export(exports, "gridPinnedRowsSelector", ()=>gridPinnedRowsSelector);
parcelHelpers.export(exports, "gridPinnedRowsCountSelector", ()=>gridPinnedRowsCountSelector);
var _createSelector = require("../../../utils/createSelector");
const gridRowsStateSelector = (state)=>state.rows;
const gridRowCountSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.totalRowCount);
const gridRowsLoadingSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.loading);
const gridTopLevelRowCountSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.totalTopLevelRowCount);
const gridRowsLookupSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.idRowsLookup);
const gridRowsIdToIdLookupSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.idToIdLookup);
const gridRowTreeSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.tree);
const gridRowGroupingNameSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.groupingName);
const gridRowTreeDepthSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.treeDepth);
const gridRowIdsSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows.ids);
const gridAdditionalRowGroupsSelector = (0, _createSelector.createSelector)(gridRowsStateSelector, (rows)=>rows == null ? void 0 : rows.additionalRowGroups);
const gridPinnedRowsSelector = (0, _createSelector.createSelector)(gridAdditionalRowGroupsSelector, (additionalRowGroups)=>additionalRowGroups == null ? void 0 : additionalRowGroups.pinnedRows);
const gridPinnedRowsCountSelector = (0, _createSelector.createSelector)(gridPinnedRowsSelector, (pinnedRows)=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    return ((pinnedRows == null ? void 0 : (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.length) || 0) + ((pinnedRows == null ? void 0 : (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.length) || 0);
});

},{"../../../utils/createSelector":"4xqAC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aeHtc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridColumnsSelector", ()=>gridColumnsSelector);
parcelHelpers.export(exports, "gridColumnFieldsSelector", ()=>gridColumnFieldsSelector);
parcelHelpers.export(exports, "gridColumnLookupSelector", ()=>gridColumnLookupSelector);
parcelHelpers.export(exports, "gridColumnDefinitionsSelector", ()=>gridColumnDefinitionsSelector);
parcelHelpers.export(exports, "gridColumnVisibilityModelSelector", ()=>gridColumnVisibilityModelSelector);
parcelHelpers.export(exports, "gridVisibleColumnDefinitionsSelector", ()=>gridVisibleColumnDefinitionsSelector);
parcelHelpers.export(exports, "gridVisibleColumnFieldsSelector", ()=>gridVisibleColumnFieldsSelector);
parcelHelpers.export(exports, "gridColumnPositionsSelector", ()=>gridColumnPositionsSelector);
parcelHelpers.export(exports, "gridColumnsTotalWidthSelector", ()=>gridColumnsTotalWidthSelector);
parcelHelpers.export(exports, "gridFilterableColumnDefinitionsSelector", ()=>gridFilterableColumnDefinitionsSelector);
parcelHelpers.export(exports, "gridFilterableColumnLookupSelector", ()=>gridFilterableColumnLookupSelector);
parcelHelpers.export(exports, "allGridColumnsFieldsSelector", ()=>allGridColumnsFieldsSelector);
parcelHelpers.export(exports, "allGridColumnsSelector", ()=>allGridColumnsSelector);
parcelHelpers.export(exports, "visibleGridColumnsSelector", ()=>visibleGridColumnsSelector);
parcelHelpers.export(exports, "filterableGridColumnsSelector", ()=>filterableGridColumnsSelector);
parcelHelpers.export(exports, "filterableGridColumnsIdsSelector", ()=>filterableGridColumnsIdsSelector);
parcelHelpers.export(exports, "visibleGridColumnsLengthSelector", ()=>visibleGridColumnsLengthSelector);
parcelHelpers.export(exports, "gridColumnsMetaSelector", ()=>gridColumnsMetaSelector);
var _createSelector = require("../../../utils/createSelector");
var _warning = require("../../../utils/warning");
const gridColumnsSelector = (state)=>state.columns;
const gridColumnFieldsSelector = (0, _createSelector.createSelector)(gridColumnsSelector, (columnsState)=>columnsState.all);
const gridColumnLookupSelector = (0, _createSelector.createSelector)(gridColumnsSelector, (columnsState)=>columnsState.lookup);
const gridColumnDefinitionsSelector = (0, _createSelector.createSelector)(gridColumnFieldsSelector, gridColumnLookupSelector, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const gridColumnVisibilityModelSelector = (0, _createSelector.createSelector)(gridColumnsSelector, (columnsState)=>columnsState.columnVisibilityModel);
const gridVisibleColumnDefinitionsSelector = (0, _createSelector.createSelector)(gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector, (columns, columnVisibilityModel)=>columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const gridVisibleColumnFieldsSelector = (0, _createSelector.createSelector)(gridVisibleColumnDefinitionsSelector, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const gridColumnPositionsSelector = (0, _createSelector.createSelector)(gridVisibleColumnDefinitionsSelector, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const gridColumnsTotalWidthSelector = (0, _createSelector.createSelector)(gridVisibleColumnDefinitionsSelector, gridColumnPositionsSelector, (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth;
});
const gridFilterableColumnDefinitionsSelector = (0, _createSelector.createSelector)(gridColumnDefinitionsSelector, (columns)=>columns.filter((col)=>col.filterable));
const gridFilterableColumnLookupSelector = (0, _createSelector.createSelector)(gridColumnDefinitionsSelector, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const allGridColumnsFieldsSelector = (0, _warning.wrapWithWarningOnCall)(gridColumnFieldsSelector, [
    "MUI: The method allGridColumnsFieldsSelector is deprecated and will be removed in the next major version.",
    "Use gridColumnFieldsSelector instead"
]);
const allGridColumnsSelector = (0, _warning.wrapWithWarningOnCall)(gridColumnDefinitionsSelector, [
    "MUI: The method allGridColumnsSelector is deprecated and will be removed in the next major version.",
    "Use gridColumnDefinitionsSelector instead"
]);
const visibleGridColumnsSelector = (0, _warning.wrapWithWarningOnCall)(gridVisibleColumnDefinitionsSelector, [
    "MUI: The method visibleGridColumnsSelector is deprecated and will be removed in the next major version.",
    "Use gridVisibleColumnDefinitionsSelector instead"
]);
const filterableGridColumnsSelector = (0, _warning.wrapWithWarningOnCall)(gridFilterableColumnDefinitionsSelector, [
    "MUI: The method filterableGridColumnsSelector is deprecated and will be removed in the next major version.",
    "Use gridFilterableColumnDefinitionsSelector instead"
]);
const filterableGridColumnsIdsSelector = (0, _warning.wrapWithWarningOnCall)((0, _createSelector.createSelector)(gridFilterableColumnDefinitionsSelector, (columns)=>columns.map((col)=>col.field)), [
    "MUI: The method filterableGridColumnsIdsSelector is deprecated and will be removed in the next major version.",
    "Use gridFilterableColumnDefinitionsSelector instead.",
    "The return format is now a lookup, if you want to get the same output as before, use the following code:",
    "",
    "const lookup = gridFilterableColumnLookupSelector(apiRef);",
    "const fields = gridColumnFieldsSelector(apiRef).filter(field => lookup[field]);"
]);
const visibleGridColumnsLengthSelector = (0, _warning.wrapWithWarningOnCall)((0, _createSelector.createSelector)(gridVisibleColumnDefinitionsSelector, (visibleColumns)=>visibleColumns.length), [
    "MUI: The method visibleGridColumnsLengthSelector is deprecated and will be removed in the next major version.",
    "Use the length of the array returned by gridVisibleColumnDefinitionsSelector instead."
]);
const gridColumnsMetaSelector = (0, _warning.wrapWithWarningOnCall)((0, _createSelector.createSelector)(gridColumnPositionsSelector, gridColumnsTotalWidthSelector, (positions, totalWidth)=>({
        totalWidth,
        positions
    })), [
    "MUI: The method gridColumnsMetaSelector is deprecated and will be removed in the next major version.",
    "Use gridColumnsTotalWidthSelector or gridColumnPositionsSelector instead"
]);

},{"../../../utils/createSelector":"4xqAC","../../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"chMex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridDensitySelector", ()=>gridDensitySelector);
parcelHelpers.export(exports, "gridDensityValueSelector", ()=>gridDensityValueSelector);
parcelHelpers.export(exports, "gridDensityRowHeightSelector", ()=>gridDensityRowHeightSelector);
parcelHelpers.export(exports, "gridDensityHeaderHeightSelector", ()=>gridDensityHeaderHeightSelector);
parcelHelpers.export(exports, "gridDensityHeaderGroupingMaxDepthSelector", ()=>gridDensityHeaderGroupingMaxDepthSelector);
parcelHelpers.export(exports, "gridDensityFactorSelector", ()=>gridDensityFactorSelector);
parcelHelpers.export(exports, "gridDensityTotalHeaderHeightSelector", ()=>gridDensityTotalHeaderHeightSelector);
var _createSelector = require("../../../utils/createSelector");
const gridDensitySelector = (state)=>state.density;
const gridDensityValueSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.value);
const gridDensityRowHeightSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.rowHeight);
const gridDensityHeaderHeightSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.headerHeight);
const gridDensityHeaderGroupingMaxDepthSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.headerGroupingMaxDepth);
const gridDensityFactorSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.factor);
const gridDensityTotalHeaderHeightSelector = (0, _createSelector.createSelector)(gridDensitySelector, (density)=>density.headerHeight * (1 + density.headerGroupingMaxDepth));

},{"../../../utils/createSelector":"4xqAC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cQxk1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridErrorHandler", ()=>GridErrorHandler);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridLogger = require("../../hooks/utils/useGridLogger");
var _gridMainContainer = require("../containers/GridMainContainer");
var _errorBoundary = require("../ErrorBoundary");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
function GridErrorHandler(props) {
    const { children } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "GridErrorHandler");
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const errorState = apiRef.current.state.error;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
        hasError: errorState != null,
        api: apiRef,
        logger: logger,
        render: (errorProps)=>{
            var _rootProps$components;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridMainContainer.GridMainContainer), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ErrorOverlay, (0, _extendsDefault.default)({}, errorProps, errorState, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.errorOverlay))
            });
        },
        children: children
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridLogger":"6dTTN","../containers/GridMainContainer":"7HE6a","../ErrorBoundary":"fozzI","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6dTTN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridLogger", ()=>useGridLogger);
var _react = require("react");
function useGridLogger(apiRef, name) {
    const logger = _react.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = apiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fozzI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _react = require("react");
class ErrorBoundary extends _react.Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.api.current) {
            this.logError(error); // Allows to trigger the Error event and all listener can run on Error
            this.props.api.current.showError({
                error,
                errorInfo
            });
        }
    }
    logError(error, errorInfo) {
        this.props.logger.error(`An unexpected error occurred. Error: ${error && error.message}. `, error, errorInfo);
    }
    render() {
        var _this$state;
        if (this.props.hasError || (_this$state = this.state) != null && _this$state.hasError) // You can render any custom fallback UI
        return this.props.render(this.state);
        return this.props.children;
    }
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1BQbt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFooterPlaceholder", ()=>GridFooterPlaceholder);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
function GridFooterPlaceholder() {
    var _rootProps$components;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const footerRef = _react.useRef(null);
    apiRef.current.footerRef = footerRef;
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: footerRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Footer, (0, _extendsDefault.default)({}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.footer))
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Xnxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridHeaderPlaceholder", ()=>GridHeaderPlaceholder);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
function GridHeaderPlaceholder() {
    var _rootProps$components;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const headerRef = _react.useRef(null);
    apiRef.current.headerRef = headerRef;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: headerRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Header, (0, _extendsDefault.default)({}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.header))
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lNc24":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridCell = require("./GridCell");
parcelHelpers.exportAll(_gridCell, exports);
var _gridBooleanCell = require("./GridBooleanCell");
parcelHelpers.exportAll(_gridBooleanCell, exports);
var _gridEditBooleanCell = require("./GridEditBooleanCell");
parcelHelpers.exportAll(_gridEditBooleanCell, exports);
var _gridEditDateCell = require("./GridEditDateCell");
parcelHelpers.exportAll(_gridEditDateCell, exports);
var _gridEditInputCell = require("./GridEditInputCell");
parcelHelpers.exportAll(_gridEditInputCell, exports);
var _gridEditSingleSelectCell = require("./GridEditSingleSelectCell");
parcelHelpers.exportAll(_gridEditSingleSelectCell, exports);
var _gridActionsCell = require("./GridActionsCell");
parcelHelpers.exportAll(_gridActionsCell, exports);
var _gridActionsCellItem = require("./GridActionsCellItem");
parcelHelpers.exportAll(_gridActionsCellItem, exports);
var _gridSkeletonCell = require("./GridSkeletonCell");
parcelHelpers.exportAll(_gridSkeletonCell, exports);

},{"./GridCell":"bhKZM","./GridBooleanCell":false,"./GridEditBooleanCell":false,"./GridEditDateCell":false,"./GridEditInputCell":false,"./GridEditSingleSelectCell":false,"./GridActionsCell":false,"./GridActionsCellItem":"8Jh4U","./GridSkeletonCell":"j4Pq9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bhKZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridCell", ()=>GridCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _gridClasses = require("../../constants/gridClasses");
var _models = require("../../models");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridFocusStateSelector = require("../../hooks/features/focus/gridFocusStateSelector");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "align",
    "children",
    "colIndex",
    "colDef",
    "cellMode",
    "field",
    "formattedValue",
    "hasFocus",
    "height",
    "isEditable",
    "rowId",
    "tabIndex",
    "value",
    "width",
    "className",
    "showRightBorder",
    "extendRowFullWidth",
    "row",
    "colSpan",
    "disableDragEvents",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onKeyDown",
    "onDragEnter",
    "onDragOver"
];
// Based on https://stackoverflow.com/a/59518678
let cachedSupportsPreventScroll;
function doesSupportPreventScroll() {
    if (cachedSupportsPreventScroll === undefined) document.createElement("div").focus({
        get preventScroll () {
            cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return cachedSupportsPreventScroll;
}
const useUtilityClasses = (ownerState)=>{
    const { align, showRightBorder, isEditable, classes } = ownerState;
    const slots = {
        root: [
            "cell",
            `cell--text${(0, _utils.capitalize)(align)}`,
            isEditable && "cell--editable",
            showRightBorder && "withBorder"
        ],
        content: [
            "cellContent"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
let warnedOnce = false;
function GridCell(props) {
    var _rootProps$experiment;
    const { align, children, colIndex, cellMode, field, formattedValue, hasFocus, height, isEditable, rowId, tabIndex, value, width, className, showRightBorder, colSpan, disableDragEvents, onClick, onDoubleClick, onMouseDown, onMouseUp, onKeyDown, onDragEnter, onDragOver } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const valueToRender = formattedValue == null ? value : formattedValue;
    const cellRef = _react.useRef(null);
    const focusElementRef = _react.useRef(null);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        align,
        showRightBorder,
        isEditable,
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const publishMouseUp = _react.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = _react.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = _react.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if (!event.currentTarget.contains(event.target)) return;
             // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || "");
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const style = {
        minWidth: width,
        maxWidth: width,
        minHeight: height,
        maxHeight: height === "auto" ? "none" : height // max-height doesn't support "auto"
    };
    _react.useEffect(()=>{
        if (!hasFocus || cellMode === (0, _models.GridCellModes).Edit) return;
        const doc = (0, _utils.ownerDocument)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if (doesSupportPreventScroll()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    let handleFocus = other.onFocus;
    var event;
    const column = apiRef.current.getColumn(field);
    const managesOwnFocus = column.type === "actions";
    const renderChildren = ()=>{
        if (children == null) {
            const valueString = valueToRender == null ? void 0 : valueToRender.toString();
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                title: valueString,
                className: classes.content,
                children: valueString
            });
        }
        if (/*#__PURE__*/ _react.isValidElement(children) && managesOwnFocus) return /*#__PURE__*/ _react.cloneElement(children, {
            focusElementRef
        });
        return children;
    };
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish("cellDragEnter", onDragEnter),
        onDragOver: publish("cellDragOver", onDragOver)
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        ref: cellRef,
        className: (0, _clsxDefault.default)(className, classes.root),
        role: "cell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        style: style,
        tabIndex: (cellMode === "view" || !isEditable) && !managesOwnFocus ? tabIndex : -1,
        onClick: publish("cellClick", onClick),
        onDoubleClick: publish("cellDoubleClick", onDoubleClick),
        onMouseDown: publishMouseDown("cellMouseDown"),
        onMouseUp: publishMouseUp("cellMouseUp"),
        onKeyDown: publish("cellKeyDown", onKeyDown)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        children: renderChildren()
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../../constants/gridClasses":"5U0ME","../../models":"15Dm5","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/features/focus/gridFocusStateSelector":"7pS2P","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aaPMT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"15Dm5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colDef = require("./colDef");
parcelHelpers.exportAll(_colDef, exports);
var _cursorCoordinates = require("./cursorCoordinates");
parcelHelpers.exportAll(_cursorCoordinates, exports);
var _elementSize = require("./elementSize");
parcelHelpers.exportAll(_elementSize, exports);
var _gridEditRowModel = require("./gridEditRowModel");
parcelHelpers.exportAll(_gridEditRowModel, exports);
var _gridFeatureMode = require("./gridFeatureMode");
parcelHelpers.exportAll(_gridFeatureMode, exports);
var _gridFilterItem = require("./gridFilterItem");
parcelHelpers.exportAll(_gridFilterItem, exports);
var _gridFilterModel = require("./gridFilterModel");
parcelHelpers.exportAll(_gridFilterModel, exports);
var _gridRootContainerRef = require("./gridRootContainerRef");
parcelHelpers.exportAll(_gridRootContainerRef, exports);
var _gridRenderContextProps = require("./gridRenderContextProps");
parcelHelpers.exportAll(_gridRenderContextProps, exports);
var _gridRows = require("./gridRows");
parcelHelpers.exportAll(_gridRows, exports);
var _gridSelectionModel = require("./gridSelectionModel");
parcelHelpers.exportAll(_gridSelectionModel, exports);
var _params = require("./params");
parcelHelpers.exportAll(_params, exports);
var _gridCellClass = require("./gridCellClass");
parcelHelpers.exportAll(_gridCellClass, exports);
var _gridCell = require("./gridCell");
parcelHelpers.exportAll(_gridCell, exports);
var _gridColumnHeaderClass = require("./gridColumnHeaderClass");
parcelHelpers.exportAll(_gridColumnHeaderClass, exports);
var _api = require("./api");
parcelHelpers.exportAll(_api, exports);
var _gridIconSlotsComponent = require("./gridIconSlotsComponent");
parcelHelpers.exportAll(_gridIconSlotsComponent, exports);
var _gridSlotsComponent = require("./gridSlotsComponent");
parcelHelpers.exportAll(_gridSlotsComponent, exports);
var _gridSlotsComponentsProps = require("./gridSlotsComponentsProps");
parcelHelpers.exportAll(_gridSlotsComponentsProps, exports);
var _gridDensity = require("./gridDensity");
parcelHelpers.exportAll(_gridDensity, exports);
var _logger = require("./logger");
parcelHelpers.exportAll(_logger, exports);
var _muiEvent = require("./muiEvent");
parcelHelpers.exportAll(_muiEvent, exports);
var _events = require("./events");
parcelHelpers.exportAll(_events, exports);
var _gridSortModel = require("./gridSortModel");
parcelHelpers.exportAll(_gridSortModel, exports);
var _gridColumnGrouping = require("./gridColumnGrouping"); // Do not export GridExportFormat and GridExportExtension which are override in pro package
parcelHelpers.exportAll(_gridColumnGrouping, exports);
var _gridFilterOperator = require("./gridFilterOperator");
parcelHelpers.exportAll(_gridFilterOperator, exports);

},{"./colDef":false,"./cursorCoordinates":false,"./elementSize":false,"./gridEditRowModel":"5QORb","./gridFeatureMode":"l5iiY","./gridFilterItem":"j8Skw","./gridFilterModel":false,"./gridRootContainerRef":false,"./gridRenderContextProps":false,"./gridRows":false,"./gridSelectionModel":false,"./params":false,"./gridCellClass":false,"./gridCell":false,"./gridColumnHeaderClass":false,"./api":false,"./gridIconSlotsComponent":false,"./gridSlotsComponent":false,"./gridSlotsComponentsProps":false,"./gridDensity":"6Ls1v","./logger":false,"./muiEvent":false,"./events":false,"./gridSortModel":false,"./gridColumnGrouping":false,"./gridFilterOperator":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5QORb":[function(require,module,exports) {
// TODO v6: rename to GridEditingState
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridEditModes", ()=>GridEditModes);
parcelHelpers.export(exports, "GridCellModes", ()=>GridCellModes);
parcelHelpers.export(exports, "GridRowModes", ()=>GridRowModes);
var GridEditModes;
(function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
})(GridEditModes || (GridEditModes = {}));
var GridCellModes;
(function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
})(GridCellModes || (GridCellModes = {}));
var GridRowModes;
(function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
})(GridRowModes || (GridRowModes = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l5iiY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFeatureModeConstant", ()=>GridFeatureModeConstant);
const GridFeatureModeConstant = {
    client: "client",
    server: "server"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j8Skw":[function(require,module,exports) {
/**
 * Filter item definition interface.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridLinkOperator", ()=>GridLinkOperator);
var GridLinkOperator;
(function(GridLinkOperator) {
    GridLinkOperator["And"] = "and";
    GridLinkOperator["Or"] = "or";
})(GridLinkOperator || (GridLinkOperator = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Ls1v":[function(require,module,exports) {
/**
 * Available densities.
 */ /**
 * Density enum.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridDensityTypes", ()=>GridDensityTypes);
var GridDensityTypes;
(function(GridDensityTypes) {
    GridDensityTypes["Compact"] = "compact";
    GridDensityTypes["Standard"] = "standard";
    GridDensityTypes["Comfortable"] = "comfortable";
})(GridDensityTypes || (GridDensityTypes = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8r3d8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLeaf", ()=>isLeaf) /**
 * A function used to process headerClassName params.
 */ ;
function isLeaf(node) {
    return node.field !== undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7pS2P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridFocusStateSelector", ()=>gridFocusStateSelector);
parcelHelpers.export(exports, "gridFocusCellSelector", ()=>gridFocusCellSelector);
parcelHelpers.export(exports, "gridFocusColumnHeaderSelector", ()=>gridFocusColumnHeaderSelector);
parcelHelpers.export(exports, "gridTabIndexStateSelector", ()=>gridTabIndexStateSelector);
parcelHelpers.export(exports, "gridTabIndexCellSelector", ()=>gridTabIndexCellSelector);
parcelHelpers.export(exports, "gridTabIndexColumnHeaderSelector", ()=>gridTabIndexColumnHeaderSelector);
var _createSelector = require("../../../utils/createSelector");
const gridFocusStateSelector = (state)=>state.focus;
const gridFocusCellSelector = (0, _createSelector.createSelector)(gridFocusStateSelector, (focusState)=>focusState.cell);
const gridFocusColumnHeaderSelector = (0, _createSelector.createSelector)(gridFocusStateSelector, (focusState)=>focusState.columnHeader);
const gridTabIndexStateSelector = (state)=>state.tabIndex;
const gridTabIndexCellSelector = (0, _createSelector.createSelector)(gridTabIndexStateSelector, (state)=>state.cell);
const gridTabIndexColumnHeaderSelector = (0, _createSelector.createSelector)(gridTabIndexStateSelector, (state)=>state.columnHeader);

},{"../../../utils/createSelector":"4xqAC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1PRia":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridBooleanCell", ()=>GridBooleanCell);
parcelHelpers.export(exports, "renderBooleanCell", ()=>renderBooleanCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "getValue"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "booleanCell"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridBooleanCellRaw = (props)=>{
    const { value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const Icon = _react.useMemo(()=>value ? rootProps.components.BooleanCellTrueIcon : rootProps.components.BooleanCellFalseIcon, [
        rootProps.components.BooleanCellFalseIcon,
        rootProps.components.BooleanCellTrueIcon,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, (0, _extendsDefault.default)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
        "data-value": Boolean(value)
    }, other));
};
const GridBooleanCell = /*#__PURE__*/ _react.memo(GridBooleanCellRaw);
const renderBooleanCell = (params)=>{
    if (params.rowNode.isAutoGenerated) return "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridBooleanCell, (0, _extendsDefault.default)({}, params));
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bNTpw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridEditBooleanCell", ()=>GridEditBooleanCell);
parcelHelpers.export(exports, "renderEditBooleanCell", ()=>renderEditBooleanCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "getValue",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "editBooleanCell"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridEditBooleanCell(props) {
    var _rootProps$components;
    const { id: idProp, value, field, className, hasFocus, onValueChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const inputRef = _react.useRef(null);
    const id = (0, _utils.unstable_useId)();
    const [valueState, setValueState] = _react.useState(value);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const handleChange = _react.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    _react.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", (0, _extendsDefault.default)({
        htmlFor: id,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseCheckbox, (0, _extendsDefault.default)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseCheckbox))
    }));
}
const renderEditBooleanCell = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridEditBooleanCell, (0, _extendsDefault.default)({}, params));

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6jzYL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridEditDateCell", ()=>GridEditDateCell);
parcelHelpers.export(exports, "renderEditDateCell", ()=>renderEditDateCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _inputBase = require("@mui/material/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "getValue",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange"
];
const StyledInputBase = (0, _styles.styled)((0, _inputBaseDefault.default))({
    fontSize: "inherit"
});
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "editInputCell"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridEditDateCell(props) {
    const { id, value: valueProp, field, colDef, hasFocus, inputProps, onValueChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const isDateTime = colDef.type === "dateTime";
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const inputRef = _react.useRef();
    const valueTransformed = _react.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp != null ? valueProp : "").toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = "";
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = _react.useState(valueTransformed);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const handleChange = _react.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        let newParsedDate;
        if (newFormattedDate === "") newParsedDate = null;
        else {
            const [date, time] = newFormattedDate.split("T");
            const [year, month, day] = date.split("-");
            newParsedDate = new Date();
            newParsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
            newParsedDate.setHours(0, 0, 0, 0);
            if (time) {
                const [hours, minutes] = time.split(":");
                newParsedDate.setHours(Number(hours), Number(minutes), 0, 0);
            }
        }
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id,
            field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange
    ]);
    _react.useEffect(()=>{
        setValueState((state)=>{
            var _valueTransformed$par, _state$parsed;
            if (valueTransformed.parsed !== state.parsed && ((_valueTransformed$par = valueTransformed.parsed) == null ? void 0 : _valueTransformed$par.getTime()) !== ((_state$parsed = state.parsed) == null ? void 0 : _state$parsed.getTime())) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInputBase, (0, _extendsDefault.default)({
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? "datetime-local" : "date",
        inputProps: (0, _extendsDefault.default)({
            max: isDateTime ? "9999-12-31T23:59" : "9999-12-31"
        }, inputProps),
        value: valueState.formatted,
        onChange: handleChange
    }, other));
}
const renderEditDateCell = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridEditDateCell, (0, _extendsDefault.default)({}, params));

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/utils":"ziQFX","@mui/material/InputBase":"9Zug6","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5jONo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridEditInputCell", ()=>GridEditInputCell);
parcelHelpers.export(exports, "renderEditInputCell", ()=>renderEditInputCell);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _inputBase = require("@mui/material/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _index = require("../icons/index");
var _gridFilterInputValue = require("../panel/filterPanel/GridFilterInputValue");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "getValue",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "editInputCell"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridEditInputCellRoot = (0, _styles.styled)((0, _inputBaseDefault.default), {
    name: "MuiDataGrid",
    slot: "EditInputCell",
    overridesResolver: (props, styles)=>styles.editInputCell
})(({ theme })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        padding: "1px 0",
        "& input": {
            padding: "0 16px",
            height: "100%"
        }
    }));
const GridEditInputCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    var _rootProps$experiment, _rootProps$experiment3;
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const { id, value, field, colDef, hasFocus, debounceMs = (_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.newEditingApi ? 200 : (0, _gridFilterInputValue.SUBMIT_FILTER_STROKE_TIME), isProcessingProps, onValueChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const inputRef = _react.useRef();
    const [valueState, setValueState] = _react.useState(value);
    const classes = useUtilityClasses(rootProps);
    const handleChange = _react.useCallback(async (event)=>{
        var _rootProps$experiment2;
        const newValue = event.target.value;
        if (onValueChange) await onValueChange(event, newValue);
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser && (_rootProps$experiment2 = rootProps.experimentalFeatures) != null && _rootProps$experiment2.newEditingApi) parsedValue = column.valueParser(newValue, apiRef.current.getCellParams(id, field));
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id,
            field,
            value: parsedValue,
            debounceMs,
            unstable_skipValueParser: true
        }, event);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange,
        (_rootProps$experiment3 = rootProps.experimentalFeatures) == null ? void 0 : _rootProps$experiment3.newEditingApi
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta ? apiRef.current.unstable_getEditCellMeta(id, field) : {};
    _react.useEffect(()=>{
        if (meta.changeReason !== "debouncedSetEditCellValue") setValueState(value);
    }, [
        meta.changeReason,
        value
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridEditInputCellRoot, (0, _extendsDefault.default)({
        ref: ref,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === "number" ? colDef.type : "text",
        value: valueState != null ? valueState : "",
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.GridLoadIcon), {}) : undefined
    }, other));
});
const renderEditInputCell = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridEditInputCell, (0, _extendsDefault.default)({}, params));

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","@mui/material/InputBase":"9Zug6","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../icons/index":"kOLOm","../panel/filterPanel/GridFilterInputValue":"gCTz4","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kOLOm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridArrowUpwardIcon", ()=>GridArrowUpwardIcon);
parcelHelpers.export(exports, "GridArrowDownwardIcon", ()=>GridArrowDownwardIcon);
parcelHelpers.export(exports, "GridKeyboardArrowRight", ()=>GridKeyboardArrowRight);
parcelHelpers.export(exports, "GridExpandMoreIcon", ()=>GridExpandMoreIcon);
parcelHelpers.export(exports, "GridFilterListIcon", ()=>GridFilterListIcon);
parcelHelpers.export(exports, "GridFilterAltIcon", ()=>GridFilterAltIcon);
parcelHelpers.export(exports, "GridSearchIcon", ()=>GridSearchIcon);
parcelHelpers.export(exports, "GridMenuIcon", ()=>GridMenuIcon);
parcelHelpers.export(exports, "GridCheckCircleIcon", ()=>GridCheckCircleIcon);
parcelHelpers.export(exports, "GridColumnIcon", ()=>GridColumnIcon);
parcelHelpers.export(exports, "GridSeparatorIcon", ()=>GridSeparatorIcon);
parcelHelpers.export(exports, "GridViewHeadlineIcon", ()=>GridViewHeadlineIcon);
parcelHelpers.export(exports, "GridTableRowsIcon", ()=>GridTableRowsIcon);
parcelHelpers.export(exports, "GridViewStreamIcon", ()=>GridViewStreamIcon);
parcelHelpers.export(exports, "GridTripleDotsVerticalIcon", ()=>GridTripleDotsVerticalIcon);
parcelHelpers.export(exports, "GridCloseIcon", ()=>GridCloseIcon);
parcelHelpers.export(exports, "GridAddIcon", ()=>GridAddIcon);
parcelHelpers.export(exports, "GridRemoveIcon", ()=>GridRemoveIcon);
parcelHelpers.export(exports, "GridLoadIcon", ()=>GridLoadIcon);
parcelHelpers.export(exports, "GridDragIcon", ()=>GridDragIcon);
parcelHelpers.export(exports, "GridSaveAltIcon", ()=>GridSaveAltIcon);
parcelHelpers.export(exports, "GridCheckIcon", ()=>GridCheckIcon);
parcelHelpers.export(exports, "GridMoreVertIcon", ()=>GridMoreVertIcon);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
const GridArrowUpwardIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward");
const GridArrowDownwardIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
const GridKeyboardArrowRight = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight");
const GridExpandMoreIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const GridFilterListIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList");
const GridFilterAltIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt");
const GridSearchIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
const GridMenuIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
const GridCheckCircleIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const GridColumnIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon");
const GridSeparatorIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 19V5h2v14z"
}), "Separator");
const GridViewHeadlineIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline");
const GridTableRowsIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows");
const GridViewStreamIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream");
const GridTripleDotsVerticalIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical");
const GridCloseIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const GridAddIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");
const GridRemoveIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), "Remove");
const GridLoadIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load");
const GridDragIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag");
const GridSaveAltIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt");
const GridCheckIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
const GridMoreVertIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert");

},{"react":"gVheC","@mui/material/utils":"ziQFX","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gCTz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUBMIT_FILTER_STROKE_TIME", ()=>SUBMIT_FILTER_STROKE_TIME);
parcelHelpers.export(exports, "GridFilterInputValue", ()=>GridFilterInputValue);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _icons = require("../../icons");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _filterPanelUtils = require("./filterPanelUtils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef"
];
const warnedOnce = {};
function warnDeprecatedTypeSupport(type) {
    console.warn([
        `MUI: Using GridFilterInputValue with a "${type}" column is deprecated.`,
        "Use GridFilterInputSingleSelect instead."
    ].join("\n"));
    warnedOnce[type] = true;
}
const renderSingleSelectOptions = ({ valueOptions, valueFormatter, field }, api, OptionComponent)=>{
    const iterableColumnValues = typeof valueOptions === "function" ? [
        "",
        ...valueOptions({
            field
        })
    ] : [
        "",
        ...valueOptions || []
    ];
    return iterableColumnValues.map((option)=>{
        const isOptionTypeObject = typeof option === "object";
        const key = isOptionTypeObject ? option.value : option;
        const value = isOptionTypeObject ? option.value : option;
        const formattedValue = valueFormatter && option !== "" ? valueFormatter({
            value: option,
            field,
            api
        }) : option;
        const content = isOptionTypeObject ? option.label : formattedValue;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
            value: value,
            children: content
        }, key);
    });
};
const SUBMIT_FILTER_STROKE_TIME = 500;
function GridFilterInputValue(props) {
    var _item$value, _rootProps$components, _baseSelectProps$nati, _rootProps$components2, _rootProps$components3;
    const { item, applyValue, type, apiRef, focusElementRef } = props, others = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const filterTimeout = _react.useRef();
    const [filterValueState, setFilterValueState] = _react.useState((_item$value = item.value) != null ? _item$value : "");
    const [applying, setIsApplying] = _react.useState(false);
    const id = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const baseSelectProps = ((_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const singleSelectProps = type === "singleSelect" ? {
        select: true,
        SelectProps: (0, _extendsDefault.default)({
            native: isSelectNative
        }, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSelect),
        children: renderSingleSelectOptions(apiRef.current.getColumn(item.columnField), apiRef.current, isSelectNative ? "option" : (0, _menuItemDefault.default))
    } : {};
    const onFilterChange = _react.useCallback((event)=>{
        let value = event.target.value; // NativeSelect casts the value to a string.
        if (type === "singleSelect") {
            const column = apiRef.current.getColumn(item.columnField);
            const columnValueOptions = typeof column.valueOptions === "function" ? column.valueOptions({
                field: column.field
            }) : column.valueOptions;
            value = (0, _filterPanelUtils.getValueFromValueOptions)(value, columnValueOptions);
        }
        clearTimeout(filterTimeout.current);
        setFilterValueState(String(value));
        setIsApplying(true); // TODO singleSelect doesn't debounce
        filterTimeout.current = setTimeout(()=>{
            applyValue((0, _extendsDefault.default)({}, item, {
                value
            }));
            setIsApplying(false);
        }, SUBMIT_FILTER_STROKE_TIME);
    }, [
        apiRef,
        applyValue,
        item,
        type
    ]);
    _react.useEffect(()=>{
        return ()=>{
            clearTimeout(filterTimeout.current);
        };
    }, []);
    _react.useEffect(()=>{
        var _item$value2;
        const itemValue = (_item$value2 = item.value) != null ? _item$value2 : "";
        setFilterValueState(String(itemValue));
    }, [
        item.value
    ]);
    const InputProps = applying ? {
        endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.GridLoadIcon), {})
    } : others.InputProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({
        id: id,
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || "text",
        InputProps: InputProps,
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, singleSelectProps, others, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.baseTextField));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/utils":"ziQFX","@mui/material/MenuItem":"dTC9Z","../../icons":"kOLOm","../../../hooks/utils/useGridRootProps":"cdy2y","./filterPanelUtils":"kGvsb","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kGvsb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueFromOption", ()=>getValueFromOption);
parcelHelpers.export(exports, "getValueFromValueOptions", ()=>getValueFromValueOptions);
function getValueFromOption(option) {
    if (typeof option === "object" && option !== null) return option.value;
    return option;
}
function getValueFromValueOptions(value, valueOptions) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getValueFromOption(option);
        return String(optionValue) === String(value);
    });
    return getValueFromOption(result);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"anoTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridEditSingleSelectCell", ()=>GridEditSingleSelectCell);
parcelHelpers.export(exports, "renderEditSingleSelectCell", ()=>renderEditSingleSelectCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _keyboardUtils = require("../../utils/keyboardUtils");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridEditRowModel = require("../../models/gridEditRowModel");
var _filterPanelUtils = require("../panel/filterPanel/filterPanelUtils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "getValue",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen"
];
const renderSingleSelectOptions = (option, OptionComponent)=>{
    const isOptionTypeObject = typeof option === "object";
    const key = isOptionTypeObject ? option.value : option;
    const value = isOptionTypeObject ? option.value : option;
    const content = isOptionTypeObject ? option.label : option;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
        value: value,
        children: content
    }, key);
};
function isKeyboardEvent(event) {
    return !!event.key;
}
function GridEditSingleSelectCell(props) {
    var _rootProps$components, _baseSelectProps$nati, _rootProps$components2;
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const { id, value, api, field, row, colDef, hasFocus, error, onValueChange, initialOpen = rootProps.editMode === (0, _gridEditRowModel.GridEditModes).Cell } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const ref = _react.useRef();
    const inputRef = _react.useRef();
    const [open, setOpen] = _react.useState(initialOpen);
    const baseSelectProps = ((_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : false;
    let valueOptionsFormatted;
    if (typeof colDef.valueOptions === "function") valueOptionsFormatted = colDef.valueOptions({
        id,
        row,
        field
    });
    else valueOptionsFormatted = colDef.valueOptions;
    if (colDef.valueFormatter) valueOptionsFormatted = valueOptionsFormatted.map((option)=>{
        if (typeof option === "object") return option;
        const params = {
            field,
            api,
            value: option
        };
        return {
            value: option,
            label: String(colDef.valueFormatter(params))
        };
    });
    const handleChange = async (event)=>{
        var _rootProps$experiment;
        setOpen(false);
        const target = event.target; // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, _filterPanelUtils.getValueFromValueOptions)(target.value, valueOptionsFormatted);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        const isValid = await apiRef.current.setEditCellValue({
            id,
            field,
            value: formattedTargetValue
        }, event);
        if ((_rootProps$experiment = rootProps.experimentalFeatures) != null && _rootProps$experiment.newEditingApi) return;
         // We use isValid === false because the default return is undefined which evaluates to true with !isValid
        if (rootProps.editMode === (0, _gridEditRowModel.GridEditModes).Row || isValid === false) return;
        const canCommit = await Promise.resolve(apiRef.current.commitCellChange({
            id,
            field
        }, event));
        if (canCommit) {
            apiRef.current.setCellMode(id, field, "view");
            if (event.key) {
                // TODO v6: remove once we stop ignoring events fired from portals
                const params = apiRef.current.getCellParams(id, field);
                apiRef.current.publishEvent("cellNavigationKeyDown", params, event);
            }
        }
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, _gridEditRowModel.GridEditModes).Row) {
            setOpen(false);
            return;
        }
        if (reason === "backdropClick" || (0, _keyboardUtils.isEscapeKey)(event.key)) {
            var _rootProps$experiment2;
            if ((_rootProps$experiment2 = rootProps.experimentalFeatures) != null && _rootProps$experiment2.newEditingApi) apiRef.current.stopCellEditMode({
                id,
                field,
                ignoreModifications: true
            });
            else apiRef.current.setCellMode(id, field, "view");
        }
    };
    const handleOpen = (event)=>{
        if (isKeyboardEvent(event) && event.key === "Enter") return;
        setOpen(true);
    };
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseSelect, (0, _extendsDefault.default)({
        ref: ref,
        inputRef: inputRef,
        value: value,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        MenuProps: {
            onClose: handleClose
        },
        error: error,
        native: isSelectNative,
        fullWidth: true
    }, other, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSelect, {
        children: valueOptionsFormatted.map((valueOptions)=>renderSingleSelectOptions(valueOptions, isSelectNative ? "option" : (0, _menuItemDefault.default)))
    }));
}
const renderEditSingleSelectCell = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridEditSingleSelectCell, (0, _extendsDefault.default)({}, params));

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/utils":"ziQFX","@mui/material/MenuItem":"dTC9Z","../../utils/keyboardUtils":"o7lWn","../../hooks/utils/useGridRootProps":"cdy2y","../../models/gridEditRowModel":"5QORb","../panel/filterPanel/filterPanelUtils":"kGvsb","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"o7lWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEscapeKey", ()=>isEscapeKey);
parcelHelpers.export(exports, "isEnterKey", ()=>isEnterKey);
parcelHelpers.export(exports, "isTabKey", ()=>isTabKey);
parcelHelpers.export(exports, "isSpaceKey", ()=>isSpaceKey);
parcelHelpers.export(exports, "isArrowKeys", ()=>isArrowKeys);
parcelHelpers.export(exports, "isHomeOrEndKeys", ()=>isHomeOrEndKeys);
parcelHelpers.export(exports, "isPageKeys", ()=>isPageKeys);
parcelHelpers.export(exports, "isDeleteKeys", ()=>isDeleteKeys);
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// We need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
parcelHelpers.export(exports, "isPrintableKey", ()=>isPrintableKey);
parcelHelpers.export(exports, "GRID_MULTIPLE_SELECTION_KEYS", ()=>GRID_MULTIPLE_SELECTION_KEYS);
parcelHelpers.export(exports, "GRID_CELL_EXIT_EDIT_MODE_KEYS", ()=>GRID_CELL_EXIT_EDIT_MODE_KEYS);
parcelHelpers.export(exports, "GRID_CELL_EDIT_COMMIT_KEYS", ()=>GRID_CELL_EDIT_COMMIT_KEYS);
parcelHelpers.export(exports, "isMultipleKey", ()=>isMultipleKey);
parcelHelpers.export(exports, "isCellEnterEditModeKeys", ()=>isCellEnterEditModeKeys);
parcelHelpers.export(exports, "isCellExitEditModeKeys", ()=>isCellExitEditModeKeys);
parcelHelpers.export(exports, "isCellEditCommitKeys", ()=>isCellEditCommitKeys);
parcelHelpers.export(exports, "isNavigationKey", ()=>isNavigationKey);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
parcelHelpers.export(exports, "isHideMenuKey", ()=>isHideMenuKey);
const isEscapeKey = (key)=>key === "Escape"; // TODO remove
const isEnterKey = (key)=>key === "Enter"; // TODO remove
const isTabKey = (key)=>key === "Tab"; // TODO remove
const isSpaceKey = (key)=>key === " ";
const isArrowKeys = (key)=>key.indexOf("Arrow") === 0;
const isHomeOrEndKeys = (key)=>key === "Home" || key === "End";
const isPageKeys = (key)=>key.indexOf("Page") === 0;
const isDeleteKeys = (key)=>key === "Delete" || key === "Backspace"; // Non printable keys have a name, e.g. "ArrowRight", see the whole list:
function isPrintableKey(event) {
    return event.key.length === 1 && event.ctrlKey === false && event.metaKey === false;
}
const GRID_MULTIPLE_SELECTION_KEYS = [
    "Meta",
    "Control",
    "Shift"
];
const GRID_CELL_EXIT_EDIT_MODE_KEYS = [
    "Enter",
    "Escape",
    "Tab"
];
const GRID_CELL_EDIT_COMMIT_KEYS = [
    "Enter",
    "Tab"
];
const isMultipleKey = (key)=>GRID_MULTIPLE_SELECTION_KEYS.indexOf(key) > -1;
const isCellEnterEditModeKeys = (event)=>isEnterKey(event.key) || isDeleteKeys(event.key) || isPrintableKey(event);
const isCellExitEditModeKeys = (key)=>GRID_CELL_EXIT_EDIT_MODE_KEYS.indexOf(key) > -1;
const isCellEditCommitKeys = (key)=>GRID_CELL_EDIT_COMMIT_KEYS.indexOf(key) > -1;
const isNavigationKey = (key)=>isHomeOrEndKeys(key) || isArrowKeys(key) || isPageKeys(key) || isSpaceKey(key);
const isKeyboardEvent = (event)=>!!event.key;
const isHideMenuKey = (key)=>isTabKey(key) || isEscapeKey(key);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2diMd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridActionsCell", ()=>GridActionsCell);
parcelHelpers.export(exports, "renderActionsCell", ()=>renderActionsCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _utils = require("@mui/material/utils");
var _gridClasses = require("../../constants/gridClasses");
var _gridMenu = require("../menu/GridMenu");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "colDef",
    "id",
    "api",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "getValue",
    "tabIndex",
    "position",
    "focusElementRef"
];
const hasActions = (colDef)=>typeof colDef.getActions === "function";
const GridActionsCell = (props)=>{
    const { colDef, id, hasFocus, tabIndex, position = "bottom-end", focusElementRef } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = _react.useState(-1);
    const [open, setOpen] = _react.useState(false);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootRef = _react.useRef(null);
    const buttonRef = _react.useRef(null);
    const ignoreCallToFocus = _react.useRef(false);
    const touchRippleRefs = _react.useRef({});
    const menuId = (0, _utils.unstable_useId)();
    const buttonId = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    _react.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref == null || ref.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    _react.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    _react.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    _react.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) setFocusedButtonIndex(0);
            }
        }), []);
    if (!hasActions(colDef)) throw new Error("MUI: Missing the `getActions` property in the `GridColDef`.");
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    _react.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        let newIndex = focusedButtonIndex;
        if (event.key === "ArrowRight") newIndex += 1;
        else if (event.key === "ArrowLeft") newIndex -= 1;
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, e.g. ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") event.preventDefault();
        if ([
            "Tab",
            "Enter",
            "Escape"
        ].includes(event.key)) hideMenu();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
        role: "menu",
        ref: rootRef,
        tabIndex: -1,
        className: (0, _gridClasses.gridClasses).actionsCell,
        onKeyDown: handleRootKeyDown
    }, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ _react.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText("actionsCellMore"),
                "aria-controls": menuId,
                "aria-expanded": open ? "true" : undefined,
                "aria-haspopup": "true",
                role: "menuitem",
                size: "small",
                onClick: showMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.MoreActionsIcon, {
                    fontSize: "small"
                })
            }),
            menuButtons.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridMenu.GridMenu), {
                onClickAway: hideMenu,
                onClick: hideMenu,
                open: open,
                target: buttonRef.current,
                position: position,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuListDefault.default), {
                    id: menuId,
                    className: (0, _gridClasses.gridClasses).menuList,
                    onKeyDown: handleListKeyDown,
                    "aria-labelledby": buttonId,
                    variant: "menu",
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ _react.cloneElement(button, {
                            key: index
                        }))
                })
            })
        ]
    }));
};
const renderActionsCell = (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridActionsCell, (0, _extendsDefault.default)({}, params));

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/IconButton":"6bnps","@mui/material/MenuList":"503OT","@mui/material/utils":"ziQFX","../../constants/gridClasses":"5U0ME","../menu/GridMenu":"c4xLf","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c4xLf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridMenu", ()=>GridMenu);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _material = require("@mui/material");
var _grow = require("@mui/material/Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _styles = require("@mui/material/styles");
var _utils = require("@mui/utils");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "open",
    "target",
    "onClickAway",
    "children",
    "position",
    "className",
    "onExited"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "menu"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridMenuRoot = (0, _styles.styled)((0, _popperDefault.default), {
    name: "MuiDataGrid",
    slot: "Menu",
    overridesResolver: (props, styles)=>styles.menu
})(({ theme })=>({
        zIndex: theme.zIndex.modal,
        [`& .${(0, _gridClasses.gridClasses).menuList}`]: {
            outline: 0
        }
    }));
const transformOrigin = {
    "bottom-start": "top left",
    "bottom-end": "top right"
};
const GridMenu = (props)=>{
    var _rootProps$components;
    const { open, target, onClickAway, children, position, className, onExited } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const prevTarget = _react.useRef(target);
    const prevOpen = _react.useRef(open);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    _react.useEffect(()=>{
        if (prevOpen.current && prevTarget.current) prevTarget.current.focus();
         // Emit menuOpen or menuClose events
        const eventName = open ? "menuOpen" : "menuClose";
        apiRef.current.publishEvent(eventName, {
            target
        });
        prevOpen.current = open;
        prevTarget.current = target;
    }, [
        apiRef,
        open,
        target
    ]);
    const handleExited = (popperOnExited)=>(node)=>{
            if (popperOnExited) popperOnExited();
            if (onExited) onExited(node);
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridMenuRoot, (0, _extendsDefault.default)({
        as: rootProps.components.BasePopper,
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps,
        open: open,
        anchorEl: target,
        transition: true,
        placement: position
    }, other, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.basePopper, {
        children: ({ TransitionProps, placement })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickAwayListenerDefault.default), {
                onClickAway: onClickAway,
                mouseEvent: "onMouseDown",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _growDefault.default), (0, _extendsDefault.default)({}, TransitionProps, {
                    style: {
                        transformOrigin: transformOrigin[placement]
                    },
                    onExited: handleExited(TransitionProps == null ? void 0 : TransitionProps.onExited),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                        children: children
                    })
                }))
            })
    }));
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/ClickAwayListener":"j08aI","@mui/material":"iknXc","@mui/material/Grow":"eBM9D","@mui/material/Paper":"4qOeF","@mui/material/Popper":"2EAIq","@mui/material/styles":"gNR9m","@mui/utils":"dv12b","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Jh4U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridActionsCellItem", ()=>GridActionsCellItem);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "label",
    "icon",
    "showInMenu",
    "onClick"
];
const GridActionsCellItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { label, icon, showInMenu, onClick } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const handleClick = (event)=>{
        if (onClick) onClick(event);
    };
    if (!showInMenu) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), (0, _extendsDefault.default)({
        ref: ref,
        size: "small",
        role: "menuitem",
        "aria-label": label
    }, other, {
        onClick: handleClick,
        children: /*#__PURE__*/ _react.cloneElement(icon, {
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), (0, _extendsDefault.default)({
        ref: ref
    }, other, {
        onClick: onClick,
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: icon
            }),
            label
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/IconButton":"6bnps","@mui/material/MenuItem":"dTC9Z","@mui/material/ListItemIcon":"ebq0R","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j4Pq9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridSkeletonCell", ()=>GridSkeletonCell);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _utils = require("@mui/material/utils");
var _material = require("@mui/material");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "field",
    "align",
    "width",
    "contentWidth"
];
const useUtilityClasses = (ownerState)=>{
    const { align, classes } = ownerState;
    const slots = {
        root: [
            "cell",
            "cellSkeleton",
            `cell--text${(0, _utils.capitalize)(align)}`
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridSkeletonCell(props) {
    const { align, width, contentWidth } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes,
        align
    };
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        className: classes.root,
        style: {
            width
        }
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
            width: `${contentWidth}%`
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/Skeleton":"eTJwP","@mui/material/utils":"ziQFX","@mui/material":"iknXc","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eaVgS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridRoot = require("./GridRoot");
parcelHelpers.exportAll(_gridRoot, exports);
var _gridFooterContainer = require("./GridFooterContainer");
parcelHelpers.exportAll(_gridFooterContainer, exports);
var _gridOverlay = require("./GridOverlay");
parcelHelpers.exportAll(_gridOverlay, exports);
var _gridToolbarContainer = require("./GridToolbarContainer");
parcelHelpers.exportAll(_gridToolbarContainer, exports);

},{"./GridRoot":"4JD38","./GridFooterContainer":false,"./GridOverlay":false,"./GridToolbarContainer":"4zNsj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4JD38":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRoot", ()=>GridRoot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/material/utils");
var _material = require("@mui/material");
var _gridRootStyles = require("./GridRootStyles");
var _gridColumnsSelector = require("../../hooks/features/columns/gridColumnsSelector");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _densitySelector = require("../../hooks/features/density/densitySelector");
var _gridRowsSelector = require("../../hooks/features/rows/gridRowsSelector");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { autoHeight, density, classes } = ownerState;
    const slots = {
        root: [
            "root",
            autoHeight && "autoHeight",
            `root--density${(0, _utils.capitalize)(density)}`
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridRoot = /*#__PURE__*/ _react.forwardRef(function GridRoot(props, ref) {
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const { children, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const visibleColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector));
    const totalRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridRowCountSelector));
    const densityValue = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityValueSelector));
    const headerGroupingMaxDepth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityHeaderGroupingMaxDepthSelector));
    const rootContainerRef = _react.useRef(null);
    const handleRef = (0, _utils.useForkRef)(rootContainerRef, ref);
    const pinnedRowsCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridPinnedRowsCountSelector));
    const ownerState = (0, _extendsDefault.default)({}, rootProps, {
        density: densityValue
    });
    const classes = useUtilityClasses(ownerState);
    apiRef.current.rootElementRef = rootContainerRef; // Our implementation of <NoSsr />
    const [mountedState, setMountedState] = _react.useState(false);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        setMountedState(true);
    }, []);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (mountedState) apiRef.current.unstable_updateGridDimensionsRef();
    }, [
        apiRef,
        mountedState
    ]);
    if (!mountedState) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridRootStyles.GridRootStyles), (0, _extendsDefault.default)({
        ref: handleRef,
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: ownerState,
        role: "grid",
        "aria-colcount": visibleColumns.length,
        "aria-rowcount": headerGroupingMaxDepth + 1 + pinnedRowsCount + totalRowCount,
        "aria-multiselectable": !rootProps.disableMultipleSelection,
        "aria-label": rootProps["aria-label"],
        "aria-labelledby": rootProps["aria-labelledby"]
    }, other, {
        children: children
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/utils":"ziQFX","@mui/material":"iknXc","./GridRootStyles":"8rodS","../../hooks/features/columns/gridColumnsSelector":"aeHtc","../../hooks/utils/useGridSelector":"96gNX","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","../../hooks/features/density/densitySelector":"chMex","../../hooks/features/rows/gridRowsSelector":"fCZaq","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8rodS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRootStyles", ()=>GridRootStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
const GridRootStyles = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, _gridClasses.gridClasses).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, _gridClasses.gridClasses).aggregationColumnHeader}`]: styles.aggregationColumnHeader
            },
            {
                [`&.${(0, _gridClasses.gridClasses)["aggregationColumnHeader--alignLeft"]}`]: styles["aggregationColumnHeader--alignLeft"]
            },
            {
                [`&.${(0, _gridClasses.gridClasses)["aggregationColumnHeader--alignCenter"]}`]: styles["aggregationColumnHeader--alignCenter"]
            },
            {
                [`&.${(0, _gridClasses.gridClasses)["aggregationColumnHeader--alignRight"]}`]: styles["aggregationColumnHeader--alignRight"]
            },
            {
                [`&.${(0, _gridClasses.gridClasses).aggregationColumnHeaderLabel}`]: styles.aggregationColumnHeaderLabel
            },
            {
                [`& .${(0, _gridClasses.gridClasses).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["cell--editing"]}`]: styles["cell--editing"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["cell--textCenter"]}`]: styles["cell--textCenter"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["cell--textLeft"]}`]: styles["cell--textLeft"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["cell--textRight"]}`]: styles["cell--textRight"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["cell--withRenderer"]}`]: styles["cell--withRenderer"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses).cell}`]: styles.cell
            },
            {
                [`& .${(0, _gridClasses.gridClasses).cellContent}`]: styles.cellContent
            },
            {
                [`& .${(0, _gridClasses.gridClasses).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, _gridClasses.gridClasses).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, _gridClasses.gridClasses).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignCenter"]}`]: styles["columnHeader--alignCenter"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignLeft"]}`]: styles["columnHeader--alignLeft"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]}`]: styles["columnHeader--alignRight"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--dragging"]}`]: styles["columnHeader--dragging"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--moving"]}`]: styles["columnHeader--moving"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--numeric"]}`]: styles["columnHeader--numeric"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--sortable"]}`]: styles["columnHeader--sortable"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnHeader--sorted"]}`]: styles["columnHeader--sorted"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, _gridClasses.gridClasses).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, _gridClasses.gridClasses).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnSeparator--resizable"]}`]: styles["columnSeparator--resizable"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["columnSeparator--resizing"]}`]: styles["columnSeparator--resizing"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, _gridClasses.gridClasses).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, _gridClasses.gridClasses).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, _gridClasses.gridClasses).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, _gridClasses.gridClasses).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, _gridClasses.gridClasses).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, _gridClasses.gridClasses).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["row--editable"]}`]: styles["row--editable"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["row--editing"]}`]: styles["row--editing"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["row--dragging"]}`]: styles["row--dragging"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses).row}`]: styles.row
            },
            {
                [`& .${(0, _gridClasses.gridClasses).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, _gridClasses.gridClasses).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["rowReorderCell--draggable"]}`]: styles["rowReorderCell--draggable"]
            },
            {
                [`& .${(0, _gridClasses.gridClasses).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, _gridClasses.gridClasses).withBorder}`]: styles.withBorder
            },
            {
                [`& .${(0, _gridClasses.gridClasses).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, _gridClasses.gridClasses).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, _gridClasses.gridClasses).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, _gridClasses.gridClasses)["detailPanelToggleCell--expanded"]}`]: styles["detailPanelToggleCell--expanded"]
            },
            styles.root
        ]
})(({ theme })=>{
    const borderColor = theme.palette.mode === "light" ? (0, _styles.lighten)((0, _styles.alpha)(theme.palette.divider, 1), 0.88) : (0, _styles.darken)((0, _styles.alpha)(theme.palette.divider, 1), 0.68);
    const gridStyle = (0, _extendsDefault.default)({
        flex: 1,
        boxSizing: "border-box",
        position: "relative",
        border: `1px solid ${borderColor}`,
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.text.primary
    }, theme.typography.body2, {
        outline: "none",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        [`&.${(0, _gridClasses.gridClasses).autoHeight}`]: {
            height: "auto",
            [`& .${(0, _gridClasses.gridClasses)["row--lastVisible"]} .${(0, _gridClasses.gridClasses).cell}`]: {
                borderBottomColor: "transparent"
            }
        },
        [`& .${(0, _gridClasses.gridClasses)["virtualScrollerContent--overflowed"]} .${(0, _gridClasses.gridClasses)["row--lastVisible"]} .${(0, _gridClasses.gridClasses).cell}`]: {
            borderBottomColor: "transparent"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}, & .${(0, _gridClasses.gridClasses).cell}`]: {
            WebkitTapHighlightColor: "transparent",
            lineHeight: null,
            padding: "0 10px",
            boxSizing: "border-box"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}:focus-within, & .${(0, _gridClasses.gridClasses).cell}:focus-within`]: {
            outline: `solid ${(0, _styles.alpha)(theme.palette.primary.main, 0.5)} 1px`,
            outlineWidth: 1,
            outlineOffset: -1
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}:focus, & .${(0, _gridClasses.gridClasses).cell}:focus`]: {
            outline: `solid ${theme.palette.primary.main} 1px`
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeaderCheckbox}, & .${(0, _gridClasses.gridClasses).cellCheckbox}`]: {
            padding: 0,
            justifyContent: "center",
            alignItems: "center"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}`]: {
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--sorted"]} .${(0, _gridClasses.gridClasses).iconButtonContainer}, & .${(0, _gridClasses.gridClasses)["columnHeader--filtered"]} .${(0, _gridClasses.gridClasses).iconButtonContainer}`]: {
            visibility: "visible",
            width: "auto"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}:not(.${(0, _gridClasses.gridClasses)["columnHeader--sorted"]}) .${(0, _gridClasses.gridClasses).sortIcon}`]: {
            opacity: 0,
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.shorter
            })
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}:not(.${(0, _gridClasses.gridClasses)["columnHeader--sorted"]}):hover .${(0, _gridClasses.gridClasses).sortIcon}`]: {
            opacity: 0.5
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: {
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            flex: 1,
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeaderTitleContainerContent}`]: {
            overflow: "hidden",
            display: "flex",
            alignItems: "center"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--filledGroup"]} .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: {
            borderBottom: `solid ${borderColor} 1px`,
            boxSizing: "border-box"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--filledGroup"]}.${(0, _gridClasses.gridClasses)["columnHeader--showColumnBorder"]} .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: {
            borderBottom: `none`
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--filledGroup"]}.${(0, _gridClasses.gridClasses)["columnHeader--showColumnBorder"]}`]: {
            borderBottom: `solid ${borderColor} 1px`,
            boxSizing: "border-box"
        },
        [`& .${(0, _gridClasses.gridClasses).sortIcon}, & .${(0, _gridClasses.gridClasses).filterIcon}`]: {
            fontSize: "inherit"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--sortable"]}`]: {
            cursor: "pointer"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignCenter"]} .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: {
            justifyContent: "center"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]} .${(0, _gridClasses.gridClasses).columnHeaderDraggableContainer}, & .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]} .${(0, _gridClasses.gridClasses).columnHeaderTitleContainer}`]: {
            flexDirection: "row-reverse"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignCenter"]} .${(0, _gridClasses.gridClasses).menuIcon}, & .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]} .${(0, _gridClasses.gridClasses).menuIcon}`]: {
            marginRight: "auto",
            marginLeft: -6
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]} .${(0, _gridClasses.gridClasses).menuIcon}, & .${(0, _gridClasses.gridClasses)["columnHeader--alignRight"]} .${(0, _gridClasses.gridClasses).menuIcon}`]: {
            marginRight: "auto",
            marginLeft: -10
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--moving"]}`]: {
            backgroundColor: theme.palette.action.hover
        },
        [`& .${(0, _gridClasses.gridClasses).columnSeparator}`]: {
            position: "absolute",
            zIndex: 100,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: borderColor
        },
        [`& .${(0, _gridClasses.gridClasses)["columnSeparator--sideLeft"]}`]: {
            left: -12
        },
        [`& .${(0, _gridClasses.gridClasses)["columnSeparator--sideRight"]}`]: {
            right: -12
        },
        [`& .${(0, _gridClasses.gridClasses)["columnSeparator--resizable"]}`]: {
            cursor: "col-resize",
            touchAction: "none",
            "&:hover": {
                color: theme.palette.text.primary,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    color: borderColor
                }
            },
            [`&.${(0, _gridClasses.gridClasses)["columnSeparator--resizing"]}`]: {
                color: theme.palette.text.primary
            },
            "& svg": {
                pointerEvents: "none"
            }
        },
        [`& .${(0, _gridClasses.gridClasses).iconSeparator}`]: {
            color: "inherit"
        },
        [`& .${(0, _gridClasses.gridClasses).menuIcon}`]: {
            width: 0,
            visibility: "hidden",
            fontSize: 20,
            marginRight: -10,
            display: "flex",
            alignItems: "center"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeader}:hover`]: {
            [`& .${(0, _gridClasses.gridClasses).iconButtonContainer}`]: {
                visibility: "visible",
                width: "auto"
            },
            [`& .${(0, _gridClasses.gridClasses).menuIcon}`]: {
                width: "auto",
                visibility: "visible"
            }
        },
        [`.${(0, _gridClasses.gridClasses).menuOpen}`]: {
            visibility: "visible",
            width: "auto"
        },
        [`& .${(0, _gridClasses.gridClasses).row}`]: {
            display: "flex",
            width: "fit-content",
            breakInside: "avoid",
            // Avoid the row to be broken in two different print pages.
            "&:hover, &.Mui-hovered": {
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&.Mui-selected": {
                backgroundColor: (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                "&:hover, &.Mui-hovered": {
                    backgroundColor: (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                    }
                }
            }
        },
        [`& .${(0, _gridClasses.gridClasses).cell}`]: {
            display: "flex",
            alignItems: "center",
            borderBottom: `1px solid ${borderColor}`
        },
        [`& .${(0, _gridClasses.gridClasses).row}:not(.${(0, _gridClasses.gridClasses)["row--dynamicHeight"]}) > .${(0, _gridClasses.gridClasses).cell}`]: {
            overflow: "hidden",
            whiteSpace: "nowrap"
        },
        [`& .${(0, _gridClasses.gridClasses).cellContent}`]: {
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        [`& .${(0, _gridClasses.gridClasses).cell}.${(0, _gridClasses.gridClasses)["cell--editing"]}`]: {
            padding: 1,
            display: "flex",
            boxShadow: theme.shadows[2],
            backgroundColor: theme.palette.background.paper,
            "&:focus-within": {
                outline: `solid ${theme.palette.primary.main} 1px`,
                outlineOffset: "-1px"
            }
        },
        [`& .${(0, _gridClasses.gridClasses)["row--editing"]}`]: {
            boxShadow: theme.shadows[2]
        },
        [`& .${(0, _gridClasses.gridClasses)["row--editing"]} .${(0, _gridClasses.gridClasses).cell}`]: {
            boxShadow: theme.shadows[0],
            backgroundColor: theme.palette.background.paper
        },
        [`& .${(0, _gridClasses.gridClasses).editBooleanCell}`]: {
            display: "flex",
            height: "100%",
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
        },
        [`& .${(0, _gridClasses.gridClasses).booleanCell}[data-value="true"]`]: {
            color: theme.palette.text.secondary
        },
        [`& .${(0, _gridClasses.gridClasses).booleanCell}[data-value="false"]`]: {
            color: theme.palette.text.disabled
        },
        [`& .${(0, _gridClasses.gridClasses).actionsCell}`]: {
            display: "inline-flex",
            alignItems: "center",
            gridGap: theme.spacing(1)
        },
        [`& .${(0, _gridClasses.gridClasses).rowReorderCell}`]: {
            display: "inline-flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            opacity: theme.palette.action.disabledOpacity
        },
        [`& .${(0, _gridClasses.gridClasses)["rowReorderCell--draggable"]}`]: {
            cursor: "move",
            opacity: 1
        },
        [`& .${(0, _gridClasses.gridClasses).rowReorderCellContainer}`]: {
            padding: 0,
            alignItems: "stretch"
        },
        [`& .${(0, _gridClasses.gridClasses).withBorder}`]: {
            borderRight: `1px solid ${borderColor}`
        },
        [`& .${(0, _gridClasses.gridClasses)["cell--textLeft"]}`]: {
            justifyContent: "flex-start"
        },
        [`& .${(0, _gridClasses.gridClasses)["cell--textRight"]}`]: {
            justifyContent: "flex-end"
        },
        [`& .${(0, _gridClasses.gridClasses)["cell--textCenter"]}`]: {
            justifyContent: "center"
        },
        [`& .${(0, _gridClasses.gridClasses).columnHeaderDraggableContainer}`]: {
            display: "flex",
            width: "100%",
            height: "100%"
        },
        [`& .${(0, _gridClasses.gridClasses).rowReorderCellPlaceholder}`]: {
            display: "none"
        },
        [`& .${(0, _gridClasses.gridClasses)["columnHeader--dragging"]}, & .${(0, _gridClasses.gridClasses)["row--dragging"]}`]: {
            background: theme.palette.background.paper,
            padding: "0 12px",
            borderRadius: theme.shape.borderRadius,
            opacity: theme.palette.action.disabledOpacity
        },
        [`& .${(0, _gridClasses.gridClasses)["row--dragging"]}`]: {
            background: theme.palette.background.paper,
            padding: "0 12px",
            borderRadius: theme.shape.borderRadius,
            opacity: theme.palette.action.disabledOpacity,
            [`& .${(0, _gridClasses.gridClasses).rowReorderCellPlaceholder}`]: {
                display: "flex"
            }
        },
        [`& .${(0, _gridClasses.gridClasses).treeDataGroupingCell}`]: {
            display: "flex",
            alignItems: "center",
            width: "100%"
        },
        [`& .${(0, _gridClasses.gridClasses).treeDataGroupingCellToggle}`]: {
            flex: "0 0 28px",
            alignSelf: "stretch",
            marginRight: theme.spacing(2)
        },
        [`& .${(0, _gridClasses.gridClasses).groupingCriteriaCell}`]: {
            display: "flex",
            alignItems: "center",
            width: "100%"
        },
        [`& .${(0, _gridClasses.gridClasses).groupingCriteriaCellToggle}`]: {
            flex: "0 0 28px",
            alignSelf: "stretch",
            marginRight: theme.spacing(2)
        }
    });
    return gridStyle;
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"boKRI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFooterContainer", ()=>GridFooterContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "footerContainer"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridFooterContainerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "FooterContainer",
    overridesResolver: (props, styles)=>styles.footerContainer
})(({ theme })=>{
    const borderColor = theme.palette.mode === "light" ? (0, _styles.lighten)((0, _styles.alpha)(theme.palette.divider, 1), 0.88) : (0, _styles.darken)((0, _styles.alpha)(theme.palette.divider, 1), 0.68);
    return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: 52,
        // Match TablePagination min height
        borderTop: `1px solid ${borderColor}`
    };
});
const GridFooterContainer = /*#__PURE__*/ _react.forwardRef(function GridFooterContainer(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridFooterContainerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dAA19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridOverlay", ()=>GridOverlay);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "overlay"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridOverlayRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "Overlay",
    overridesResolver: (props, styles)=>styles.overlay
})(({ theme })=>({
        position: "absolute",
        top: 0,
        zIndex: 4,
        // should be above pinned columns, pinned rows and detail panel
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        display: "flex",
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (0, _styles.alpha)(theme.palette.background.default, theme.palette.action.disabledOpacity)
    }));
const GridOverlay = /*#__PURE__*/ _react.forwardRef(function GridOverlay(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridOverlayRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4zNsj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridToolbarContainer", ()=>GridToolbarContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "children"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "toolbarContainer"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridToolbarContainerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ToolbarContainer",
    overridesResolver: (props, styles)=>styles.toolbarContainer
})(({ theme })=>({
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: theme.spacing(0.5, 0.5, 0)
    }));
const GridToolbarContainer = /*#__PURE__*/ _react.forwardRef(function GridToolbarContainer(props, ref) {
    const { className, children } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    if (!children) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridToolbarContainerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps
    }, other, {
        children: children
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6qDRe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridColumnHeaderItem = require("./GridColumnHeaderItem");
parcelHelpers.exportAll(_gridColumnHeaderItem, exports);
var _gridColumnHeaderSeparator = require("./GridColumnHeaderSeparator");
parcelHelpers.exportAll(_gridColumnHeaderSeparator, exports);
var _gridColumnHeaderSortIcon = require("./GridColumnHeaderSortIcon");
parcelHelpers.exportAll(_gridColumnHeaderSortIcon, exports);
var _gridColumnHeaderFilterIconButton = require("./GridColumnHeaderFilterIconButton");
parcelHelpers.exportAll(_gridColumnHeaderFilterIconButton, exports);
var _gridColumnHeaderTitle = require("./GridColumnHeaderTitle");
parcelHelpers.exportAll(_gridColumnHeaderTitle, exports);

},{"./GridColumnHeaderItem":false,"./GridColumnHeaderSeparator":false,"./GridColumnHeaderSortIcon":false,"./GridColumnHeaderFilterIconButton":"6LwWu","./GridColumnHeaderTitle":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iEl8s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderItem", ()=>GridColumnHeaderItem);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridColumnHeaderSortIcon = require("./GridColumnHeaderSortIcon");
var _columnHeaderMenuIcon = require("./ColumnHeaderMenuIcon");
var _gridColumnHeaderMenu = require("../menu/columnMenu/GridColumnHeaderMenu");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridGenericColumnHeaderItem = require("./GridGenericColumnHeaderItem");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { column, classes, isDragging, sortDirection, showRightBorder, filterItemsCounter } = ownerState;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0; // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = column.type === "number";
    const slots = {
        root: [
            "columnHeader",
            column.headerAlign === "left" && "columnHeader--alignLeft",
            column.headerAlign === "center" && "columnHeader--alignCenter",
            column.headerAlign === "right" && "columnHeader--alignRight",
            column.sortable && "columnHeader--sortable",
            isDragging && "columnHeader--moving",
            isColumnSorted && "columnHeader--sorted",
            isColumnFiltered && "columnHeader--filtered",
            isColumnNumeric && "columnHeader--numeric",
            showRightBorder && "withBorder"
        ],
        draggableContainer: [
            "columnHeaderDraggableContainer"
        ],
        titleContainer: [
            "columnHeaderTitleContainer"
        ],
        titleContainerContent: [
            "columnHeaderTitleContainerContent"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridColumnHeaderItem(props) {
    var _apiRef$current$getRo, _rootProps$components, _column$sortingOrder, _rootProps$components2, _column$headerName;
    const { column, columnMenuOpen, colIndex, headerHeight, isResizing, isLastColumn, sortDirection, sortIndex, filterItemsCounter, hasFocus, tabIndex, extendRowFullWidth, disableReorder, separatorSide } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const headerCellRef = _react.useRef(null);
    const columnMenuId = (0, _utils.unstable_useId)();
    const columnMenuButtonId = (0, _utils.unstable_useId)();
    const iconButtonRef = _react.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = _react.useState(columnMenuOpen);
    const { hasScrollX, hasScrollY } = (_apiRef$current$getRo = apiRef.current.getRootDimensions()) != null ? _apiRef$current$getRo : {
        hasScrollX: false,
        hasScrollY: false
    };
    const isDraggable = _react.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !column.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        column.disableReorder
    ]);
    let headerComponent;
    if (column.renderHeader) headerComponent = column.renderHeader(apiRef.current.getColumnHeaderParams(column.field));
    const removeLastBorderRight = isLastColumn && hasScrollX && !hasScrollY;
    const showRightBorder = !isLastColumn ? rootProps.showColumnRightBorder : !removeLastBorderRight && !extendRowFullWidth;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder
    });
    const classes = useUtilityClasses(ownerState);
    const publish = _react.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if (!event.currentTarget.contains(event.target)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(column.field), event);
        }, [
        apiRef,
        column.field
    ]);
    const mouseEventsHandlers = _react.useMemo(()=>({
            onClick: publish("columnHeaderClick"),
            onDoubleClick: publish("columnHeaderDoubleClick"),
            onMouseOver: publish("columnHeaderOver"),
            // TODO remove as it's not used
            onMouseOut: publish("columnHeaderOut"),
            // TODO remove as it's not used
            onMouseEnter: publish("columnHeaderEnter"),
            // TODO remove as it's not used
            onMouseLeave: publish("columnHeaderLeave"),
            // TODO remove as it's not used
            onKeyDown: publish("columnHeaderKeyDown"),
            onFocus: publish("columnHeaderFocus"),
            onBlur: publish("columnHeaderBlur")
        }), [
        publish
    ]);
    const draggableEventHandlers = _react.useMemo(()=>isDraggable ? {
            onDragStart: publish("columnHeaderDragStart"),
            onDragEnter: publish("columnHeaderDragEnter"),
            onDragOver: publish("columnHeaderDragOver"),
            onDragEnd: publish("columnHeaderDragEnd")
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = _react.useMemo(()=>({
            onMouseDown: publish("columnSeparatorMouseDown")
        }), [
        publish
    ]);
    _react.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = _react.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !column.disableColumnMenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnHeaderMenuIcon.ColumnHeaderMenuIcon), {
        column: column,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnHeaderMenu.GridColumnHeaderMenu), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: column.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.components.ColumnMenu,
        contentComponentProps: (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = (_column$sortingOrder = column.sortingOrder) != null ? _column$sortingOrder : rootProps.sortingOrder;
    const columnTitleIconButtons = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ColumnHeaderFilterIconButton, (0, _extendsDefault.default)({
                field: column.field,
                counter: filterItemsCounter
            }, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.columnHeaderFilterIconButton)),
            column.sortable && !column.hideSortIcons && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnHeaderSortIcon.GridColumnHeaderSortIcon), {
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder
            })
        ]
    });
    _react.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof column.headerClassName === "function" ? column.headerClassName({
        field: column.field,
        colDef: column
    }) : column.headerClassName;
    const label = (_column$headerName = column.headerName) != null ? _column$headerName : column.field;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridGenericColumnHeaderItem.GridGenericColumnHeaderItem), (0, _extendsDefault.default)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: column.description,
        elementId: column.field,
        width: column.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: headerClassName,
        label: label,
        resizable: !rootProps.disableColumnResize && !!column.resizable,
        "data-field": column.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps
    }, mouseEventsHandlers));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../../hooks/utils/useGridApiContext":"cn3M8","./GridColumnHeaderSortIcon":"cEf5Z","./ColumnHeaderMenuIcon":"ca0UC","../menu/columnMenu/GridColumnHeaderMenu":"lccDr","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","./GridGenericColumnHeaderItem":"kl2Cy","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cEf5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderSortIcon", ()=>GridColumnHeaderSortIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _badge = require("@mui/material/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridIconButtonContainer = require("./GridIconButtonContainer");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        icon: [
            "sortIcon"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === "asc") Icon = icons.ColumnSortedAscendingIcon;
    else if (direction === "desc") Icon = icons.ColumnSortedDescendingIcon;
    else {
        Icon = icons.ColumnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, (0, _extendsDefault.default)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function GridColumnHeaderSortIconRaw(props) {
    const { direction, index, sortingOrder } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = useUtilityClasses(ownerState);
    const iconElement = getIcon(rootProps.components, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
        tabIndex: -1,
        "aria-label": apiRef.current.getLocaleText("columnHeaderSortIconLabel"),
        title: apiRef.current.getLocaleText("columnHeaderSortIconLabel"),
        size: "small",
        children: iconElement
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridIconButtonContainer.GridIconButtonContainer), {
        children: [
            index != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                badgeContent: index,
                color: "default",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}
const GridColumnHeaderSortIcon = /*#__PURE__*/ _react.memo(GridColumnHeaderSortIconRaw);

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/Badge":"l79LM","@mui/material/IconButton":"6bnps","../../hooks/utils/useGridApiContext":"cn3M8","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","./GridIconButtonContainer":"gsnxy","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gsnxy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridIconButtonContainer", ()=>GridIconButtonContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "iconButtonContainer"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridIconButtonContainerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "IconButtonContainer",
    overridesResolver: (props, styles)=>styles.iconButtonContainer
})(()=>({
        display: "flex",
        visibility: "hidden",
        width: 0
    }));
const GridIconButtonContainer = /*#__PURE__*/ _react.forwardRef(function GridIconButtonContainer(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridIconButtonContainerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ca0UC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnHeaderMenuIcon", ()=>ColumnHeaderMenuIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, open } = ownerState;
    const slots = {
        root: [
            "menuIcon",
            open && "menuOpen"
        ],
        button: [
            "menuIconButton"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const ColumnHeaderMenuIcon = /*#__PURE__*/ _react.memo((props)=>{
    const { column, open, columnMenuId, columnMenuButtonId, iconButtonRef } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = useUtilityClasses(ownerState);
    const handleMenuIconClick = _react.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(column.field);
    }, [
        apiRef,
        column.field
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            ref: iconButtonRef,
            tabIndex: -1,
            className: classes.button,
            "aria-label": apiRef.current.getLocaleText("columnMenuLabel"),
            title: apiRef.current.getLocaleText("columnMenuLabel"),
            size: "small",
            onClick: handleMenuIconClick,
            "aria-expanded": open ? "true" : undefined,
            "aria-haspopup": "true",
            "aria-controls": columnMenuId,
            id: columnMenuButtonId,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ColumnMenuIcon, {
                fontSize: "small"
            })
        })
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","../../hooks/utils/useGridApiContext":"cn3M8","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lccDr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderMenu", ()=>GridColumnHeaderMenu);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _gridMenu = require("../GridMenu");
var _jsxRuntime = require("react/jsx-runtime");
function GridColumnHeaderMenu({ columnMenuId, columnMenuButtonId, ContentComponent, contentComponentProps, field, open, target, onExited }) {
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const currentColumn = apiRef.current.getColumn(field);
    const hideMenu = _react.useCallback((event)=>{
        // Prevent triggering the sorting
        event.stopPropagation();
        apiRef.current.hideColumnMenu();
    }, [
        apiRef
    ]);
    if (!target) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridMenu.GridMenu), {
        placement: `bottom-${currentColumn.align === "right" ? "start" : "end"}`,
        open: open,
        target: target,
        onClickAway: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentComponent, (0, _extendsDefault.default)({
            currentColumn: currentColumn,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/utils":"dv12b","../../../hooks/utils/useGridApiContext":"cn3M8","../GridMenu":"c4xLf","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kl2Cy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridGenericColumnHeaderItem", ()=>GridGenericColumnHeaderItem);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/material/utils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridColumnHeaderTitle = require("./GridColumnHeaderTitle");
var _gridColumnHeaderSeparator = require("./GridColumnHeaderSeparator");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "disableHeaderSeparator"
];
const GridGenericColumnHeaderItem = /*#__PURE__*/ _react.forwardRef(function GridGenericColumnHeaderItem(props, ref) {
    const { classes, columnMenuOpen, colIndex, height, isResizing, sortDirection, hasFocus, tabIndex, separatorSide, isDraggable, headerComponent, description, width, columnMenuIconButton = null, columnMenu = null, columnTitleIconButtons = null, headerClassName, label, resizable, draggableContainerProps, columnHeaderSeparatorProps, disableHeaderSeparator } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const headerCellRef = _react.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = _react.useState(columnMenuOpen);
    const handleRef = (0, _utils.useForkRef)(headerCellRef, ref);
    let ariaSort = "none";
    if (sortDirection != null) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    _react.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    _react.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            elementToFocus == null || elementToFocus.focus();
            apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
        }
    }, [
        apiRef,
        hasFocus
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
        ref: handleRef,
        className: (0, _clsxDefault.default)(classes.root, headerClassName),
        style: {
            height,
            width,
            minWidth: width,
            maxWidth: width
        },
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort,
        "aria-label": headerComponent == null ? label : undefined
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
                className: classes.draggableContainer,
                draggable: isDraggable
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: classes.titleContainer,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnHeaderTitle.GridColumnHeaderTitle), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            !disableHeaderSeparator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnHeaderSeparator.GridColumnHeaderSeparator), (0, _extendsDefault.default)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material/utils":"ziQFX","../../hooks/utils/useGridApiContext":"cn3M8","./GridColumnHeaderTitle":"7Gcaj","./GridColumnHeaderSeparator":"hy3LC","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Gcaj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderTitle", ()=>GridColumnHeaderTitle);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _domUtils = require("../../utils/domUtils");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "columnHeaderTitle"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridColumnHeaderTitleRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaderTitle",
    overridesResolver: (props, styles)=>styles.columnHeaderTitle
})(({ theme })=>({
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        fontWeight: theme.typography.fontWeightMedium
    }));
const ColumnHeaderInnerTitle = /*#__PURE__*/ _react.forwardRef(function ColumnHeaderInnerTitle(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnHeaderTitleRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function GridColumnHeaderTitle(props) {
    var _rootProps$components;
    const { label, description, columnWidth } = props;
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const titleRef = _react.useRef(null);
    const [tooltip, setTooltip] = _react.useState("");
    _react.useEffect(()=>{
        if (!description && titleRef && titleRef.current) {
            const isOver = (0, _domUtils.isOverflown)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip("");
        }
    }, [
        titleRef,
        columnWidth,
        description,
        label
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTooltip, (0, _extendsDefault.default)({
        title: description || tooltip
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTooltip, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnHeaderInnerTitle, {
            ref: titleRef,
            children: label
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../utils/domUtils":"s7LWz","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"s7LWz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOverflown", ()=>isOverflown);
parcelHelpers.export(exports, "findParentElementFromClassName", ()=>findParentElementFromClassName);
parcelHelpers.export(exports, "getRowEl", ()=>getRowEl) // TODO remove
;
parcelHelpers.export(exports, "isGridCellRoot", ()=>isGridCellRoot);
parcelHelpers.export(exports, "isGridHeaderCellRoot", ()=>isGridHeaderCellRoot);
parcelHelpers.export(exports, "getGridColumnHeaderElement", ()=>getGridColumnHeaderElement);
parcelHelpers.export(exports, "getGridRowElement", ()=>getGridRowElement);
parcelHelpers.export(exports, "getGridCellElement", ()=>getGridCellElement);
var _gridClasses = require("../constants/gridClasses");
function isOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function findParentElementFromClassName(elem, className) {
    return elem.closest(`.${className}`);
}
function getRowEl(cell) {
    if (!cell) return null;
    return findParentElementFromClassName(cell, (0, _gridClasses.gridClasses).row);
}
function isGridCellRoot(elem) {
    return elem != null && elem.classList.contains((0, _gridClasses.gridClasses).cell);
}
function isGridHeaderCellRoot(elem) {
    return elem != null && elem.classList.contains((0, _gridClasses.gridClasses).columnHeader);
}
function escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, "\\$&");
}
function getGridColumnHeaderElement(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${escapeOperandAttributeSelector(field)}"]`);
}
function getGridRowElementSelector(id) {
    return `.${(0, _gridClasses.gridClasses).row}[data-id="${escapeOperandAttributeSelector(String(id))}"]`;
}
function getGridRowElement(root, id) {
    return root.querySelector(getGridRowElementSelector(id));
}
function getGridCellElement(root, { id, field }) {
    const rowSelector = getGridRowElementSelector(id);
    const cellSelector = `.${(0, _gridClasses.gridClasses).cell}[data-field="${escapeOperandAttributeSelector(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}

},{"../constants/gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hy3LC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderSeparator", ()=>GridColumnHeaderSeparator);
parcelHelpers.export(exports, "GridColumnHeaderSeparatorSides", ()=>GridColumnHeaderSeparatorSides);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var GridColumnHeaderSeparatorSides;
(function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
})(GridColumnHeaderSeparatorSides || (GridColumnHeaderSeparatorSides = {}));
const useUtilityClasses = (ownerState)=>{
    const { resizable, resizing, classes, side } = ownerState;
    const slots = {
        root: [
            "columnSeparator",
            resizable && "columnSeparator--resizable",
            resizing && "columnSeparator--resizing",
            side && `columnSeparator--side${(0, _utils.capitalize)(side)}`
        ],
        icon: [
            "iconSeparator"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridColumnHeaderSeparatorRaw(props) {
    const { height, side = GridColumnHeaderSeparatorSides.Right } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        side,
        classes: rootProps.classes
    });
    const classes = useUtilityClasses(ownerState);
    const stopClick = _react.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        className: classes.root,
        style: {
            minHeight: height,
            opacity: rootProps.showColumnRightBorder ? 0 : 1
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ColumnResizeIcon, {
            className: classes.icon
        })
    })));
}
const GridColumnHeaderSeparator = /*#__PURE__*/ _react.memo(GridColumnHeaderSeparatorRaw);

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6LwWu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaderFilterIconButton", ()=>GridColumnHeaderFilterIconButton);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _badge = require("@mui/material/Badge");
var _badgeDefault = parcelHelpers.interopDefault(_badge);
var _gridPreferencePanelSelector = require("../../hooks/features/preferencesPanel/gridPreferencePanelSelector");
var _gridPreferencePanelsValue = require("../../hooks/features/preferencesPanel/gridPreferencePanelsValue");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridIconButtonContainer = require("./GridIconButtonContainer");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        icon: [
            "filterIcon"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridColumnHeaderFilterIconButton(props) {
    var _rootProps$components;
    const { counter, field, onClick } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        classes: rootProps.classes
    });
    const classes = useUtilityClasses(ownerState);
    const toggleFilter = _react.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open, openedPanelValue } = (0, _gridPreferencePanelSelector.gridPreferencePanelStateSelector)(apiRef.current.state);
        if (open && openedPanelValue === (0, _gridPreferencePanelsValue.GridPreferencePanelsValue).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel();
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
        onClick: toggleFilter,
        color: "default",
        "aria-label": apiRef.current.getLocaleText("columnHeaderFiltersLabel"),
        size: "small",
        tabIndex: -1,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ColumnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTooltip, (0, _extendsDefault.default)({
        title: apiRef.current.getLocaleText("columnHeaderFiltersTooltipActive")(counter),
        enterDelay: 1000
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTooltip, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridIconButtonContainer.GridIconButtonContainer), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badgeDefault.default), {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","@mui/material/Badge":"l79LM","../../hooks/features/preferencesPanel/gridPreferencePanelSelector":"7GEzE","../../hooks/features/preferencesPanel/gridPreferencePanelsValue":"7YmlH","../../hooks/utils/useGridApiContext":"cn3M8","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","./GridIconButtonContainer":"gsnxy","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7GEzE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridPreferencePanelStateSelector", ()=>gridPreferencePanelStateSelector);
const gridPreferencePanelStateSelector = (state)=>state.preferencePanel;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7YmlH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPreferencePanelsValue", ()=>GridPreferencePanelsValue);
var GridPreferencePanelsValue;
(function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
})(GridPreferencePanelsValue || (GridPreferencePanelsValue = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dRJQi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _columnMenu = require("./columnMenu");
parcelHelpers.exportAll(_columnMenu, exports);
var _gridMenu = require("./GridMenu");
parcelHelpers.exportAll(_gridMenu, exports);

},{"./columnMenu":"2ZScW","./GridMenu":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ZScW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridColumnsMenuItem = require("./GridColumnsMenuItem");
parcelHelpers.exportAll(_gridColumnsMenuItem, exports);
var _gridFilterItemProps = require("./GridFilterItemProps");
parcelHelpers.exportAll(_gridFilterItemProps, exports);
var _gridFilterMenuItem = require("./GridFilterMenuItem");
parcelHelpers.exportAll(_gridFilterMenuItem, exports);
var _gridColumnHeaderMenu = require("./GridColumnHeaderMenu");
parcelHelpers.exportAll(_gridColumnHeaderMenu, exports);
var _gridColumnMenu = require("./GridColumnMenu");
parcelHelpers.exportAll(_gridColumnMenu, exports);
var _hideGridColMenuItem = require("./HideGridColMenuItem");
parcelHelpers.exportAll(_hideGridColMenuItem, exports);
var _sortGridMenuItems = require("./SortGridMenuItems");
parcelHelpers.exportAll(_sortGridMenuItems, exports);
var _gridColumnMenuContainer = require("./GridColumnMenuContainer");
parcelHelpers.exportAll(_gridColumnMenuContainer, exports);
var _gridColumnMenuProps = require("./GridColumnMenuProps");
parcelHelpers.exportAll(_gridColumnMenuProps, exports);

},{"./GridColumnsMenuItem":false,"./GridFilterItemProps":false,"./GridFilterMenuItem":false,"./GridColumnHeaderMenu":false,"./GridColumnMenu":"4YvkP","./HideGridColMenuItem":false,"./SortGridMenuItems":false,"./GridColumnMenuContainer":false,"./GridColumnMenuProps":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6btl9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnsMenuItem", ()=>GridColumnsMenuItem);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _gridPreferencePanelsValue = require("../../../hooks/features/preferencesPanel/gridPreferencePanelsValue");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const GridColumnsMenuItem = (props)=>{
    const { onClick } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const showColumns = _react.useCallback((event)=>{
        onClick(event);
        apiRef.current.showPreferences((0, _gridPreferencePanelsValue.GridPreferencePanelsValue).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
        onClick: showColumns,
        children: apiRef.current.getLocaleText("columnMenuShowColumns")
    });
};

},{"react":"gVheC","prop-types":"3KNJy","@mui/material/MenuItem":"dTC9Z","../../../hooks/features/preferencesPanel/gridPreferencePanelsValue":"7YmlH","../../../hooks/utils/useGridApiContext":"cn3M8","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"c26Jy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterMenuItem", ()=>GridFilterMenuItem);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const GridFilterMenuItem = (props)=>{
    const { column, onClick } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const showFilter = _react.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(column == null ? void 0 : column.field);
    }, [
        apiRef,
        column == null ? void 0 : column.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !(column != null && column.filterable)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
        onClick: showFilter,
        children: apiRef.current.getLocaleText("columnMenuFilter")
    });
};

},{"react":"gVheC","prop-types":"3KNJy","@mui/material/MenuItem":"dTC9Z","../../../hooks/utils/useGridApiContext":"cn3M8","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4YvkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnMenu", ()=>GridColumnMenu);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _gridColumnMenuContainer = require("./GridColumnMenuContainer");
var _gridColumnsMenuItem = require("./GridColumnsMenuItem");
var _gridFilterMenuItem = require("./GridFilterMenuItem");
var _hideGridColMenuItem = require("./HideGridColMenuItem");
var _sortGridMenuItems = require("./SortGridMenuItems");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const GridColumnMenu = /*#__PURE__*/ _react.forwardRef(function GridColumnMenu(props, ref) {
    const { hideMenu, currentColumn } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const defaultButtons = [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortGridMenuItems.SortGridMenuItems), {
            onClick: hideMenu,
            column: currentColumn
        }),
        /*#__PURE__*/ // TODO update types to allow `onClick` and `column` to be optional
        (0, _jsxRuntime.jsx)((0, _gridFilterMenuItem.GridFilterMenuItem), {
            onClick: hideMenu,
            column: currentColumn
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hideGridColMenuItem.HideGridColMenuItem), {
            onClick: hideMenu,
            column: currentColumn
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnsMenuItem.GridColumnsMenuItem), {
            onClick: hideMenu,
            column: currentColumn
        })
    ];
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors("columnMenu", defaultButtons, currentColumn);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnMenuContainer.GridColumnMenuContainer), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ _react.cloneElement(button, {
                key: index,
                onClick: hideMenu,
                column: currentColumn
            }))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","./GridColumnMenuContainer":"nSTdo","./GridColumnsMenuItem":"6btl9","./GridFilterMenuItem":"c26Jy","./HideGridColMenuItem":"5MlAm","./SortGridMenuItems":"d9Muc","../../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"nSTdo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnMenuContainer", ()=>GridColumnMenuContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _gridClasses = require("../../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "hideMenu",
    "currentColumn",
    "open",
    "id",
    "labelledby",
    "className",
    "children"
];
const GridColumnMenuContainer = /*#__PURE__*/ _react.forwardRef(function GridColumnMenuContainer(props, ref) {
    const { hideMenu, open, id, labelledby, className, children } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const handleListKeyDown = _react.useCallback((event)=>{
        if ((0, _keyboardUtils.isTabKey)(event.key)) event.preventDefault();
        if ((0, _keyboardUtils.isHideMenuKey)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuListDefault.default), (0, _extendsDefault.default)({
        id: id,
        ref: ref,
        className: (0, _clsxDefault.default)((0, _gridClasses.gridClasses).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        autoFocus: open
    }, other, {
        children: children
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","clsx":"aaPMT","prop-types":"3KNJy","react":"gVheC","@mui/material/MenuList":"503OT","../../../utils/keyboardUtils":"o7lWn","../../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5MlAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HideGridColMenuItem", ()=>HideGridColMenuItem);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _columns = require("../../../hooks/features/columns");
var _jsxRuntime = require("react/jsx-runtime");
const HideGridColMenuItem = (props)=>{
    const { column, onClick } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const timeoutRef = _react.useRef();
    const visibleColumns = (0, _columns.gridVisibleColumnDefinitionsSelector)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true); // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = _react.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        onClick(event); // time for the transition
        timeoutRef.current = setTimeout(()=>{
            apiRef.current.setColumnVisibility(column == null ? void 0 : column.field, false);
        }, 100);
    }, [
        apiRef,
        column == null ? void 0 : column.field,
        onClick,
        disabled
    ]);
    _react.useEffect(()=>{
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    if (rootProps.disableColumnSelector) return null;
    if (column.hideable === false) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
        onClick: toggleColumn,
        disabled: disabled,
        children: apiRef.current.getLocaleText("columnMenuHideColumn")
    });
};

},{"react":"gVheC","prop-types":"3KNJy","@mui/material/MenuItem":"dTC9Z","../../../hooks/utils/useGridApiContext":"cn3M8","../../../hooks/utils/useGridRootProps":"cdy2y","../../../hooks/features/columns":"99F9P","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"99F9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridColDef", ()=>(0, _gridColumnsUtils.getGridColDef));
var _gridColumnsSelector = require("./gridColumnsSelector");
parcelHelpers.exportAll(_gridColumnsSelector, exports);
var _gridColumnsUtils = require("./gridColumnsUtils");

},{"./gridColumnsSelector":"aeHtc","./gridColumnsUtils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dl6aq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLUMNS_DIMENSION_PROPERTIES", ()=>COLUMNS_DIMENSION_PROPERTIES);
parcelHelpers.export(exports, "computeColumnTypes", ()=>computeColumnTypes);
/**
 * Computes width for flex columns.
 * Based on CSS Flexbox specification:
 * https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
 */ parcelHelpers.export(exports, "computeFlexColumnsWidth", ()=>computeFlexColumnsWidth);
parcelHelpers.export(exports, "hydrateColumnsWidth", ()=>hydrateColumnsWidth);
parcelHelpers.export(exports, "applyInitialState", ()=>applyInitialState);
parcelHelpers.export(exports, "getGridColDef", ()=>getGridColDef);
parcelHelpers.export(exports, "createColumnsState", ()=>createColumnsState);
parcelHelpers.export(exports, "mergeColumnsState", ()=>mergeColumnsState);
parcelHelpers.export(exports, "getFirstNonSpannedColumnToRender", ()=>getFirstNonSpannedColumnToRender);
parcelHelpers.export(exports, "getFirstColumnIndexToRender", ()=>getFirstColumnIndexToRender);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _colDef = require("../../../colDef");
var _gridColumnsSelector = require("./gridColumnsSelector");
var _utils = require("../../../utils/utils");
const COLUMNS_DIMENSION_PROPERTIES = [
    "maxWidth",
    "minWidth",
    "width",
    "flex"
];
const computeColumnTypes = (customColumnTypes = {})=>{
    const mergedColumnTypes = (0, _extendsDefault.default)({}, (0, _colDef.getGridDefaultColumnTypes)());
    Object.entries(customColumnTypes).forEach(([colType, colTypeDef])=>{
        if (mergedColumnTypes[colType]) mergedColumnTypes[colType] = (0, _extendsDefault.default)({}, mergedColumnTypes[colType], colTypeDef);
        else mergedColumnTypes[colType] = (0, _extendsDefault.default)({}, mergedColumnTypes[colTypeDef.extendType || (0, _colDef.DEFAULT_GRID_COL_TYPE_KEY)], colTypeDef);
    });
    return mergedColumnTypes;
};
function computeFlexColumnsWidth({ initialFreeSpace, totalFlexUnits, flexColumns }) {
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    }; // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === flexColumns.length) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0; // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
             // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex; // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth,
                flex: column.flex
            };
        } // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field })=>{
            flexColumnsLookup.freeze(field);
        });
         // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const hydrateColumnsWidth = (rawState, viewportInnerWidth)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = []; // For the non-flex columns, compute their width
    // For the flex columns, compute there minimum width and how much width must be allocated during the flex allocation
    rawState.all.forEach((columnField)=>{
        const newColumn = (0, _extendsDefault.default)({}, rawState.lookup[columnField]);
        if (rawState.columnVisibilityModel[columnField] === false) newColumn.computedWidth = 0;
        else {
            let computedWidth;
            if (newColumn.flex && newColumn.flex > 0) {
                totalFlexUnits += newColumn.flex;
                computedWidth = 0;
                flexColumns.push(newColumn);
            } else computedWidth = (0, _utils.clamp)(newColumn.width, newColumn.minWidth, newColumn.maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
            newColumn.computedWidth = computedWidth;
        }
        columnsLookup[columnField] = newColumn;
    });
    const initialFreeSpace = Math.max(viewportInnerWidth - widthAllocatedBeforeFlex, 0); // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && viewportInnerWidth > 0) {
        const computedColumnWidths = computeFlexColumnsWidth({
            initialFreeSpace,
            totalFlexUnits,
            flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field].computedWidth = computedColumnWidths[field].computedWidth;
        });
    }
    return (0, _extendsDefault.default)({}, rawState, {
        lookup: columnsLookup
    });
};
let columnTypeWarnedOnce = false;
const applyInitialState = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields = [], dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i]; // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.all : [
        ...cleanOrderedFields,
        ...columnsState.all.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, _extendsDefault.default)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, _extendsDefault.default)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = {
        all: newOrderedFields,
        lookup: newColumnLookup
    };
    return newColumnsState;
};
const getGridColDef = (columnTypes, type)=>{
    if (!type) return columnTypes[0, _colDef.DEFAULT_GRID_COL_TYPE_KEY];
    if (!columnTypes[type]) return columnTypes[0, _colDef.DEFAULT_GRID_COL_TYPE_KEY];
    return columnTypes[type];
};
const createColumnsState = ({ apiRef, columnsToUpsert, initialState, columnTypes, currentColumnVisibilityModel = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef), shouldRegenColumnVisibilityModelFromColumns, keepOnlyColumnsToUpsert = false })=>{
    var _apiRef$current$getRo, _apiRef$current$getRo2, _apiRef$current, _apiRef$current$getRo3;
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsStateWithoutColumnVisibilityModel;
    if (isInsideStateInitializer) columnsStateWithoutColumnVisibilityModel = {
        all: [],
        lookup: {}
    };
    else {
        const currentState = (0, _gridColumnsSelector.gridColumnsSelector)(apiRef.current.state);
        columnsStateWithoutColumnVisibilityModel = {
            all: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.all
            ],
            lookup: (0, _extendsDefault.default)({}, currentState.lookup) // Will be cleaned later if keepOnlyColumnsToUpsert=true
        };
    }
    let columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) columnsToKeep = Object.keys(columnsStateWithoutColumnVisibilityModel.lookup).reduce((acc, key)=>(0, _extendsDefault.default)({}, acc, {
            [key]: false
        }), {});
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsStateWithoutColumnVisibilityModel.lookup[field];
        if (existingState == null) {
            // New Column
            existingState = (0, _extendsDefault.default)({}, getGridColDef(columnTypes, newColumn.type), {
                // TODO v6: Inline `getGridColDef`
                field,
                hasBeenResized: false
            });
            columnsStateWithoutColumnVisibilityModel.all.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsStateWithoutColumnVisibilityModel.all.push(field);
        let hasBeenResized = existingState.hasBeenResized;
        COLUMNS_DIMENSION_PROPERTIES.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsStateWithoutColumnVisibilityModel.lookup[field] = (0, _extendsDefault.default)({}, existingState, {
            hide: newColumn.hide == null ? false : newColumn.hide
        }, newColumn, {
            hasBeenResized
        });
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsStateWithoutColumnVisibilityModel.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsStateWithoutColumnVisibilityModel.lookup[field];
    });
    const columnsLookupBeforePreProcessing = (0, _extendsDefault.default)({}, columnsStateWithoutColumnVisibilityModel.lookup);
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors("hydrateColumns", columnsStateWithoutColumnVisibilityModel); // TODO v6: remove the sync between the columns `hide` option and the model.
    let columnVisibilityModel = {};
    if (shouldRegenColumnVisibilityModelFromColumns) {
        let hasModelChanged = false;
        const newColumnVisibilityModel = (0, _extendsDefault.default)({}, currentColumnVisibilityModel);
        if (isInsideStateInitializer) columnsStateWithPreProcessing.all.forEach((field)=>{
            newColumnVisibilityModel[field] = !columnsStateWithoutColumnVisibilityModel.lookup[field].hide;
        });
        else if (keepOnlyColumnsToUpsert) // At this point, `keepOnlyColumnsToUpsert` has a new meaning: keep the columns
        // passed via `columnToUpsert` + columns added by the pre-processors. We do the following
        // cleanup because a given column may have been removed from the `columns` prop but it still
        // exists in the state.
        Object.keys(newColumnVisibilityModel).forEach((field)=>{
            if (!columnsStateWithPreProcessing.lookup[field]) {
                delete newColumnVisibilityModel[field];
                hasModelChanged = true;
            }
        });
        columnsStateWithPreProcessing.all.forEach((field)=>{
            // If neither the `columnsToUpsert` nor the pre-processors updated the column,
            // Then we don't want to update the visibility status of the column in the model.
            if (!columnsToUpsertLookup[field] && columnsLookupBeforePreProcessing[field] === columnsStateWithPreProcessing.lookup[field]) return;
             // We always assume that a column not in the model is visible by default. However, there's an
            // edge case where the column is not in the model but it also doesn't exist in the `columns`
            // prop, meaning that the column is being added. In that case, we assume that the column was
            // not visible before for it be added to the model.
            let isVisibleBefore = currentColumnVisibilityModel[field];
            if (isVisibleBefore === undefined) {
                if (isInsideStateInitializer) isVisibleBefore = true;
                else {
                    const currentState = (0, _gridColumnsSelector.gridColumnsSelector)(apiRef.current.state);
                    isVisibleBefore = !!currentState.lookup[field];
                }
            }
            const isVisibleAfter = !columnsStateWithPreProcessing.lookup[field].hide;
            if (isVisibleAfter !== isVisibleBefore) {
                hasModelChanged = true;
                newColumnVisibilityModel[field] = isVisibleAfter;
            }
        });
        if (hasModelChanged || isInsideStateInitializer) columnVisibilityModel = newColumnVisibilityModel;
        else columnVisibilityModel = currentColumnVisibilityModel;
    } else columnVisibilityModel = currentColumnVisibilityModel;
    const columnsStateWithPortableColumns = applyInitialState(columnsStateWithPreProcessing, initialState);
    const columnsState = (0, _extendsDefault.default)({}, columnsStateWithPortableColumns, {
        columnVisibilityModel
    });
    return hydrateColumnsWidth(columnsState, (_apiRef$current$getRo = (_apiRef$current$getRo2 = (_apiRef$current = apiRef.current).getRootDimensions) == null ? void 0 : (_apiRef$current$getRo3 = _apiRef$current$getRo2.call(_apiRef$current)) == null ? void 0 : _apiRef$current$getRo3.viewportInnerSize.width) != null ? _apiRef$current$getRo : 0);
};
const mergeColumnsState = (columnsState)=>(state)=>(0, _extendsDefault.default)({}, state, {
            columns: columnsState
        });
function getFirstNonSpannedColumnToRender({ firstColumnToRender, apiRef, firstRowToRender, lastRowToRender, visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    for(let i = firstRowToRender; i < lastRowToRender; i += 1){
        const row = visibleRows[i];
        if (row) {
            const rowId = visibleRows[i].id;
            const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstColumnToRender);
            if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
        }
    }
    return firstNonSpannedColumnToRender;
}
function getFirstColumnIndexToRender({ firstColumnIndex, minColumnIndex, columnBuffer, firstRowToRender, lastRowToRender, apiRef, visibleRows }) {
    const initialFirstColumnToRender = Math.max(firstColumnIndex - columnBuffer, minColumnIndex);
    const firstColumnToRender = getFirstNonSpannedColumnToRender({
        firstColumnToRender: initialFirstColumnToRender,
        apiRef,
        firstRowToRender,
        lastRowToRender,
        visibleRows
    });
    return firstColumnToRender;
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../../../colDef":"8Wled","./gridColumnsSelector":"aeHtc","../../../utils/utils":"lwlsg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Wled":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridActionsColDef = require("./gridActionsColDef");
parcelHelpers.exportAll(_gridActionsColDef, exports);
var _gridBooleanColDef = require("./gridBooleanColDef");
parcelHelpers.exportAll(_gridBooleanColDef, exports);
var _gridCheckboxSelectionColDef = require("./gridCheckboxSelectionColDef");
parcelHelpers.exportAll(_gridCheckboxSelectionColDef, exports);
var _gridDateColDef = require("./gridDateColDef");
parcelHelpers.exportAll(_gridDateColDef, exports);
var _gridNumericColDef = require("./gridNumericColDef");
parcelHelpers.exportAll(_gridNumericColDef, exports);
var _gridSingleSelectColDef = require("./gridSingleSelectColDef");
parcelHelpers.exportAll(_gridSingleSelectColDef, exports);
var _gridStringColDef = require("./gridStringColDef");
parcelHelpers.exportAll(_gridStringColDef, exports);
var _gridBooleanOperators = require("./gridBooleanOperators");
parcelHelpers.exportAll(_gridBooleanOperators, exports);
var _gridDateOperators = require("./gridDateOperators");
parcelHelpers.exportAll(_gridDateOperators, exports);
var _gridNumericOperators = require("./gridNumericOperators");
parcelHelpers.exportAll(_gridNumericOperators, exports);
var _gridSingleSelectOperators = require("./gridSingleSelectOperators");
parcelHelpers.exportAll(_gridSingleSelectOperators, exports);
var _gridStringOperators = require("./gridStringOperators");
parcelHelpers.exportAll(_gridStringOperators, exports);
var _gridDefaultColumnTypes = require("./gridDefaultColumnTypes");
parcelHelpers.exportAll(_gridDefaultColumnTypes, exports);

},{"./gridActionsColDef":"2wcgU","./gridBooleanColDef":false,"./gridCheckboxSelectionColDef":"jNhez","./gridDateColDef":false,"./gridNumericColDef":false,"./gridSingleSelectColDef":false,"./gridStringColDef":false,"./gridBooleanOperators":false,"./gridDateOperators":false,"./gridNumericOperators":false,"./gridSingleSelectOperators":false,"./gridStringOperators":false,"./gridDefaultColumnTypes":"cGyNj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2wcgU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_ACTIONS_COLUMN_TYPE", ()=>GRID_ACTIONS_COLUMN_TYPE);
parcelHelpers.export(exports, "GRID_ACTIONS_COL_DEF", ()=>GRID_ACTIONS_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _gridStringColDef = require("./gridStringColDef");
var _gridActionsCell = require("../components/cell/GridActionsCell");
const GRID_ACTIONS_COLUMN_TYPE = "actions";
const GRID_ACTIONS_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    width: 100,
    align: "center",
    headerAlign: "center",
    headerName: "",
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, _gridActionsCell.renderActionsCell),
    getApplyQuickFilterFn: undefined
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./gridStringColDef":"f3A6m","../components/cell/GridActionsCell":"2diMd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f3A6m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_STRING_COL_DEF", ()=>GRID_STRING_COL_DEF);
var _gridEditInputCell = require("../components/cell/GridEditInputCell");
var _gridSortingUtils = require("../hooks/features/sorting/gridSortingUtils");
var _gridStringOperators = require("./gridStringOperators");
const GRID_STRING_COL_DEF = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hide: false,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    editable: false,
    sortComparator: (0, _gridSortingUtils.gridStringOrNumberComparator),
    type: "string",
    align: "left",
    filterOperators: (0, _gridStringOperators.getGridStringOperators)(),
    renderEditCell: (0, _gridEditInputCell.renderEditInputCell),
    getApplyQuickFilterFn: (0, _gridStringOperators.getGridStringQuickFilterFn)
};

},{"../components/cell/GridEditInputCell":"5jONo","../hooks/features/sorting/gridSortingUtils":"jsmfR","./gridStringOperators":"d6Pfv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jsmfR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeSortModel", ()=>sanitizeSortModel);
parcelHelpers.export(exports, "mergeStateWithSortModel", ()=>mergeStateWithSortModel);
parcelHelpers.export(exports, "buildAggregatedSortingApplier", ()=>buildAggregatedSortingApplier);
parcelHelpers.export(exports, "getNextGridSortDirection", ()=>getNextGridSortDirection);
parcelHelpers.export(exports, "gridStringOrNumberComparator", ()=>gridStringOrNumberComparator);
parcelHelpers.export(exports, "gridNumberComparator", ()=>gridNumberComparator);
parcelHelpers.export(exports, "gridDateComparator", ()=>gridDateComparator);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _warning = require("../../../utils/warning");
const sortModelDisableMultiColumnsSortingWarning = (0, _warning.buildWarning)([
    "MUI: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.",
    "If you are using the community version of the `DataGrid`, this prop is always `true`."
], "error");
const sanitizeSortModel = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) {
        sortModelDisableMultiColumnsSortingWarning();
        return [
            model[0]
        ];
    }
    return model;
};
const mergeStateWithSortModel = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, _extendsDefault.default)({}, state, {
            sorting: (0, _extendsDefault.default)({}, state.sorting, {
                sortModel: sanitizeSortModel(sortModel, disableMultipleColumnsSorting)
            })
        });
const isDesc = (direction)=>direction === "desc";
/**
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {React.MutableRefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column) return null;
    const comparator = isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    const getSortCellParams = (id)=>({
            id,
            field: column.field,
            rowNode: apiRef.current.getRowNode(id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams,
        comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const buildAggregatedSortingApplier = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const getNextGridSortDirection = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const collator = new Intl.Collator();
const gridStringOrNumberComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === "string") return collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const gridNumberComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const gridDateComparator = (value1, value2)=>{
    const nillResult = gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d6Pfv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridStringQuickFilterFn", ()=>getGridStringQuickFilterFn);
parcelHelpers.export(exports, "getGridStringOperators", ()=>getGridStringOperators);
var _gridFilterInputValue = require("../components/panel/filterPanel/GridFilterInputValue");
var _utils = require("../utils/utils");
var _gridFilterInputMultipleValue = require("../components/panel/filterPanel/GridFilterInputMultipleValue");
const getGridStringQuickFilterFn = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, _utils.escapeRegExp)(value), "i");
    return ({ value: columnValue })=>{
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
const getGridStringOperators = (disableTrim = false)=>[
        {
            value: "contains",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp((0, _utils.escapeRegExp)(filterItemValue), "i");
                return ({ value })=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue)
        },
        {
            value: "equals",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const collator = new Intl.Collator(undefined, {
                    sensitivity: "base",
                    usage: "search"
                });
                return ({ value })=>{
                    return value != null ? collator.compare(filterItemValue, value.toString()) === 0 : false;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue)
        },
        {
            value: "startsWith",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, _utils.escapeRegExp)(filterItemValue)}.*$`, "i");
                return ({ value })=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue)
        },
        {
            value: "endsWith",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, _utils.escapeRegExp)(filterItemValue)}$`, "i");
                return ({ value })=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue)
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value === "" || value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value !== "" && value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: "base",
                    usage: "search"
                });
                return ({ value })=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || "") === 0;
                    }) : false;
            },
            InputComponent: (0, _gridFilterInputMultipleValue.GridFilterInputMultipleValue)
        }
    ];

},{"../components/panel/filterPanel/GridFilterInputValue":"gCTz4","../utils/utils":"lwlsg","../components/panel/filterPanel/GridFilterInputMultipleValue":"fRjMZ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lwlsg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "localStorageAvailable", ()=>localStorageAvailable);
parcelHelpers.export(exports, "escapeRegExp", ()=>escapeRegExp);
parcelHelpers.export(exports, "clamp", ()=>clamp);
/**
 * Based on `fast-deep-equal`
 *
 *  MIT License
 *
 * Copyright (c) 2017 Evgeny Poberezkin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * We only type the public interface to avoid dozens of `as` in the function.
 */ parcelHelpers.export(exports, "isDeepEqual", ()=>isDeepEqual) // Pseudo random number. See https://stackoverflow.com/a/47593316
;
parcelHelpers.export(exports, "randomNumberBetween", ()=>randomNumberBetween);
parcelHelpers.export(exports, "deepClone", ()=>deepClone);
function isNumber(value) {
    return typeof value === "number";
}
function isFunction(value) {
    return typeof value === "function";
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function localStorageAvailable() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = "__some_random_key_you_are_not_going_to_use__";
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
function isDeepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!isDeepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!isDeepEqual(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!isDeepEqual(a[key], b[key])) return false;
        }
        return true;
    } // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}
function mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function randomNumberBetween(seed, min, max) {
    const random = mulberry32(seed);
    return ()=>min + (max - min) * random();
}
function deepClone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fRjMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterInputMultipleValue", ()=>GridFilterInputMultipleValue);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _utils = require("@mui/material/utils");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
function GridFilterInputMultipleValue(props) {
    const { item, applyValue, type, apiRef, focusElementRef, color, error, helperText, size, variant } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const TextFieldProps = {
        color,
        error,
        helperText,
        size,
        variant
    };
    const [filterValueState, setFilterValueState] = _react.useState(item.value || []);
    const id = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    _react.useEffect(()=>{
        var _item$value;
        const itemValue = (_item$value = item.value) != null ? _item$value : [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = _react.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, _extendsDefault.default)({}, item, {
            value: [
                ...value
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), (0, _extendsDefault.default)({
        multiple: true,
        freeSolo: true,
        options: [],
        filterOptions: (options, params)=>{
            const { inputValue } = params;
            return inputValue == null || inputValue === "" ? [] : [
                inputValue
            ];
        },
        id: id,
        value: filterValueState,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), (0, _extendsDefault.default)({
                    variant: "outlined",
                    size: "small",
                    label: option
                }, getTagProps({
                    index
                })))),
        renderInput: (params)=>{
            var _rootProps$components;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({}, params, {
                label: apiRef.current.getLocaleText("filterPanelInputLabel"),
                placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
                InputLabelProps: (0, _extendsDefault.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: type || "text"
            }, TextFieldProps, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTextField));
        }
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/Autocomplete":"3qDJc","@mui/material/Chip":"bwuFy","@mui/material/utils":"ziQFX","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Uwmf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_BOOLEAN_COL_DEF", ()=>GRID_BOOLEAN_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _gridStringColDef = require("./gridStringColDef");
var _gridBooleanCell = require("../components/cell/GridBooleanCell");
var _gridEditBooleanCell = require("../components/cell/GridEditBooleanCell");
var _gridSortingUtils = require("../hooks/features/sorting/gridSortingUtils");
var _gridBooleanOperators = require("./gridBooleanOperators");
function gridBooleanFormatter({ value, api }) {
    return value ? api.getLocaleText("booleanCellTrueLabel") : api.getLocaleText("booleanCellFalseLabel");
}
const GRID_BOOLEAN_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    type: "boolean",
    align: "center",
    headerAlign: "center",
    renderCell: (0, _gridBooleanCell.renderBooleanCell),
    renderEditCell: (0, _gridEditBooleanCell.renderEditBooleanCell),
    sortComparator: (0, _gridSortingUtils.gridNumberComparator),
    valueFormatter: gridBooleanFormatter,
    filterOperators: (0, _gridBooleanOperators.getGridBooleanOperators)(),
    getApplyQuickFilterFn: undefined,
    // @ts-ignore
    aggregable: false
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./gridStringColDef":"f3A6m","../components/cell/GridBooleanCell":"1PRia","../components/cell/GridEditBooleanCell":"bNTpw","../hooks/features/sorting/gridSortingUtils":"jsmfR","./gridBooleanOperators":"kguyq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kguyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridBooleanOperators", ()=>getGridBooleanOperators);
var _gridFilterInputBoolean = require("../components/panel/filterPanel/GridFilterInputBoolean");
const getGridBooleanOperators = ()=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const valueAsBoolean = filterItem.value === "true";
                return ({ value })=>{
                    return Boolean(value) === valueAsBoolean;
                };
            },
            InputComponent: (0, _gridFilterInputBoolean.GridFilterInputBoolean)
        }
    ];

},{"../components/panel/filterPanel/GridFilterInputBoolean":"2iSsQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2iSsQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterInputBoolean", ()=>GridFilterInputBoolean);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef"
];
function GridFilterInputBoolean(props) {
    var _rootProps$components, _baseSelectProps$nati, _rootProps$components2, _rootProps$components3;
    const { item, applyValue, apiRef, focusElementRef } = props, others = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [filterValueState, setFilterValueState] = _react.useState(item.value || "");
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const baseSelectProps = ((_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const OptionComponent = isSelectNative ? "option" : (0, _menuItemDefault.default);
    const onFilterChange = _react.useCallback((event)=>{
        const value = event.target.value;
        setFilterValueState(value);
        applyValue((0, _extendsDefault.default)({}, item, {
            value
        }));
    }, [
        applyValue,
        item
    ]);
    _react.useEffect(()=>{
        setFilterValueState(item.value || "");
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        value: filterValueState,
        onChange: onFilterChange,
        select: true,
        variant: "standard",
        SelectProps: (0, _extendsDefault.default)({
            native: isSelectNative,
            displayEmpty: true
        }, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSelect),
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef
    }, others, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.baseTextField, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                value: "",
                children: apiRef.current.getLocaleText("filterValueAny")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                value: "true",
                children: apiRef.current.getLocaleText("filterValueTrue")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                value: "false",
                children: apiRef.current.getLocaleText("filterValueFalse")
            })
        ]
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/material/MenuItem":"dTC9Z","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jNhez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_CHECKBOX_SELECTION_FIELD", ()=>GRID_CHECKBOX_SELECTION_FIELD);
parcelHelpers.export(exports, "GRID_CHECKBOX_SELECTION_COL_DEF", ()=>GRID_CHECKBOX_SELECTION_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridCellCheckboxRenderer = require("../components/columnSelection/GridCellCheckboxRenderer");
var _gridHeaderCheckbox = require("../components/columnSelection/GridHeaderCheckbox");
var _gridSelectionSelector = require("../hooks/features/selection/gridSelectionSelector");
var _gridBooleanColDef = require("./gridBooleanColDef");
var _jsxRuntime = require("react/jsx-runtime");
const GRID_CHECKBOX_SELECTION_FIELD = "__check__";
const GRID_CHECKBOX_SELECTION_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridBooleanColDef.GRID_BOOLEAN_COL_DEF), {
    field: GRID_CHECKBOX_SELECTION_FIELD,
    type: "checkboxSelection",
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: undefined,
    valueGetter: (params)=>{
        const selectionLookup = (0, _gridSelectionSelector.selectedIdsLookupSelector)(params.api.state, params.api.instanceId);
        return selectionLookup[params.id] !== undefined;
    },
    renderHeader: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridHeaderCheckbox.GridHeaderCheckbox), (0, _extendsDefault.default)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridCellCheckboxRenderer.GridCellCheckboxRenderer), (0, _extendsDefault.default)({}, params))
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../components/columnSelection/GridCellCheckboxRenderer":"1QKQZ","../components/columnSelection/GridHeaderCheckbox":"afYZo","../hooks/features/selection/gridSelectionSelector":"XuHYC","./gridBooleanColDef":"7Uwmf","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QKQZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridCellCheckboxForwardRef", ()=>GridCellCheckboxForwardRef);
parcelHelpers.export(exports, "GridCellCheckboxRenderer", ()=>GridCellCheckboxRenderer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _utils = require("@mui/material/utils");
var _keyboardUtils = require("../../utils/keyboardUtils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "field",
    "id",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "getValue",
    "api"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "checkboxInput"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridCellCheckboxForwardRef = /*#__PURE__*/ _react.forwardRef(function GridCellCheckboxRenderer(props, ref) {
    var _rootProps$components;
    const { field, id, value: isChecked, rowNode, hasFocus, tabIndex } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const checkboxElement = _react.useRef(null);
    const rippleRef = _react.useRef();
    const handleRef = (0, _utils.useForkRef)(checkboxElement, ref);
    const element = apiRef.current.getCellElement(id, field);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id
        };
        apiRef.current.publishEvent("rowSelectionCheckboxChange", params, event);
    };
    _react.useLayoutEffect(()=>{
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        element,
        tabIndex
    ]);
    _react.useEffect(()=>{
        if (hasFocus) {
            var _checkboxElement$curr;
            const input = (_checkboxElement$curr = checkboxElement.current) == null ? void 0 : _checkboxElement$curr.querySelector("input");
            input == null || input.focus({
                preventScroll: true
            });
        } else if (rippleRef.current) // Only available in @mui/material v5.4.1 or later
        rippleRef.current.stop({});
    }, [
        hasFocus
    ]);
    const handleKeyDown = _react.useCallback((event)=>{
        if ((0, _keyboardUtils.isSpaceKey)(event.key)) event.stopPropagation();
        if ((0, _keyboardUtils.isNavigationKey)(event.key) && !event.shiftKey) apiRef.current.publishEvent("cellNavigationKeyDown", props, event);
    }, [
        apiRef,
        props
    ]);
    if (rowNode.position === "footer") return null;
    const isSelectable = apiRef.current.isRowSelectable(id);
    const label = apiRef.current.getLocaleText(isChecked ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
    if (rowNode.isPinned) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseCheckbox, (0, _extendsDefault.default)({
        ref: handleRef,
        tabIndex: tabIndex,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            "aria-label": label
        },
        onKeyDown: handleKeyDown,
        disabled: !isSelectable,
        touchRippleRef: rippleRef
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseCheckbox, other));
});
const GridCellCheckboxRenderer = GridCellCheckboxForwardRef;

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/utils":"ziQFX","../../utils/keyboardUtils":"o7lWn","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"afYZo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridHeaderCheckbox", ()=>GridHeaderCheckbox);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _gridFocusStateSelector = require("../../hooks/features/focus/gridFocusStateSelector");
var _gridSelectionSelector = require("../../hooks/features/selection/gridSelectionSelector");
var _keyboardUtils = require("../../utils/keyboardUtils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridFilterSelector = require("../../hooks/features/filter/gridFilterSelector");
var _gridPaginationSelector = require("../../hooks/features/pagination/gridPaginationSelector");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "field",
    "colDef"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "checkboxInput"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridHeaderCheckbox = /*#__PURE__*/ _react.forwardRef(function GridHeaderCheckbox(props, ref) {
    var _rootProps$components;
    const other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [, forceUpdate] = _react.useState(false);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = useUtilityClasses(ownerState);
    const tabIndexState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridTabIndexColumnHeaderSelector));
    const selection = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSelectionSelector.gridSelectionStateSelector));
    const visibleRowIds = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridVisibleSortedRowIdsSelector));
    const paginatedVisibleRowIds = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridPaginationSelector.gridPaginatedVisibleSortedGridRowIdsSelector));
    const filteredSelection = _react.useMemo(()=>{
        if (typeof rootProps.isRowSelectable !== "function") return selection;
        return selection.filter((id)=>{
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) return false;
            return rootProps.isRowSelectable(apiRef.current.getRowParams(id));
        });
    }, [
        apiRef,
        rootProps.isRowSelectable,
        selection
    ]); // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = _react.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly ? visibleRowIds : paginatedVisibleRowIds; // Convert to an object to make O(1) checking if a row exists or not
        // TODO create selector that returns visibleRowIds/paginatedVisibleRowIds as an object
        return rowIds.reduce((acc, id)=>{
            acc[id] = true;
            return acc;
        }, {});
    }, [
        rootProps.pagination,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]); // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = _react.useMemo(()=>filteredSelection.filter((id)=>selectionCandidates[id]).length, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = currentSelectionSize > 0 && currentSelectionSize < Object.keys(selectionCandidates).length;
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent("headerSelectionCheckboxChange", params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    _react.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = _react.useCallback((event)=>{
        if (event.key === " ") // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent("headerSelectionCheckboxChange", {
            value: !isChecked
        });
         // TODO v6 remove columnHeaderNavigationKeyDown events which are not used internally anymore
        if ((0, _keyboardUtils.isNavigationKey)(event.key) && !event.shiftKey) apiRef.current.publishEvent("columnHeaderNavigationKeyDown", props, event);
    }, [
        apiRef,
        props,
        isChecked
    ]);
    const handleSelectionChange = _react.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    _react.useEffect(()=>{
        return apiRef.current.subscribeEvent("selectionChange", handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseCheckbox, (0, _extendsDefault.default)({
        ref: ref,
        indeterminate: isIndeterminate,
        checked: isChecked,
        onChange: handleChange,
        className: classes.root,
        inputProps: {
            "aria-label": label
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseCheckbox, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","../../hooks/utils/useGridSelector":"96gNX","../../hooks/features/focus/gridFocusStateSelector":"7pS2P","../../hooks/features/selection/gridSelectionSelector":"XuHYC","../../utils/keyboardUtils":"o7lWn","../../hooks/utils/useGridApiContext":"cn3M8","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/features/filter/gridFilterSelector":"lndlA","../../hooks/features/pagination/gridPaginationSelector":"e6xRD","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"XuHYC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridSelectionStateSelector", ()=>gridSelectionStateSelector);
parcelHelpers.export(exports, "selectedGridRowsCountSelector", ()=>selectedGridRowsCountSelector);
parcelHelpers.export(exports, "selectedGridRowsSelector", ()=>selectedGridRowsSelector);
parcelHelpers.export(exports, "selectedIdsLookupSelector", ()=>selectedIdsLookupSelector);
var _createSelector = require("../../../utils/createSelector");
var _gridRowsSelector = require("../rows/gridRowsSelector");
const gridSelectionStateSelector = (state)=>state.selection;
const selectedGridRowsCountSelector = (0, _createSelector.createSelector)(gridSelectionStateSelector, (selection)=>selection.length);
const selectedGridRowsSelector = (0, _createSelector.createSelector)(gridSelectionStateSelector, (0, _gridRowsSelector.gridRowsLookupSelector), (selectedRows, rowsLookup)=>new Map(selectedRows.map((id)=>[
            id,
            rowsLookup[id]
        ])));
const selectedIdsLookupSelector = (0, _createSelector.createSelector)(gridSelectionStateSelector, (selection)=>selection.reduce((lookup, rowId)=>{
        lookup[rowId] = rowId;
        return lookup;
    }, {}));

},{"../../../utils/createSelector":"4xqAC","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e6xRD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridPaginationSelector", ()=>gridPaginationSelector);
parcelHelpers.export(exports, "gridPageSelector", ()=>gridPageSelector);
parcelHelpers.export(exports, "gridPageSizeSelector", ()=>gridPageSizeSelector);
parcelHelpers.export(exports, "gridPageCountSelector", ()=>gridPageCountSelector);
parcelHelpers.export(exports, "gridPaginationRowRangeSelector", ()=>gridPaginationRowRangeSelector);
parcelHelpers.export(exports, "gridPaginatedVisibleSortedGridRowEntriesSelector", ()=>gridPaginatedVisibleSortedGridRowEntriesSelector);
parcelHelpers.export(exports, "gridPaginatedVisibleSortedGridRowIdsSelector", ()=>gridPaginatedVisibleSortedGridRowIdsSelector);
var _createSelector = require("../../../utils/createSelector");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridRowsSelector = require("../rows/gridRowsSelector");
const gridPaginationSelector = (state)=>state.pagination;
const gridPageSelector = (0, _createSelector.createSelector)(gridPaginationSelector, (pagination)=>pagination.page);
const gridPageSizeSelector = (0, _createSelector.createSelector)(gridPaginationSelector, (pagination)=>pagination.pageSize);
const gridPageCountSelector = (0, _createSelector.createSelector)(gridPaginationSelector, (pagination)=>pagination.pageCount);
const gridPaginationRowRangeSelector = (0, _createSelector.createSelector)(gridPaginationSelector, (0, _gridRowsSelector.gridRowTreeSelector), (0, _gridRowsSelector.gridRowTreeDepthSelector), (0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector), (0, _gridFilterSelector.gridVisibleSortedTopLevelRowEntriesSelector), (pagination, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(pagination.pageSize * pagination.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = Math.min(topLevelFirstRowIndex + pagination.pageSize - 1, visibleTopLevelRowCount - 1); // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
     // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id].depth;
        if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
        if (depth === 0) topLevelRowAdded += 1;
    }
    return {
        firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const gridPaginatedVisibleSortedGridRowEntriesSelector = (0, _createSelector.createSelector)((0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector), gridPaginationRowRangeSelector, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const gridPaginatedVisibleSortedGridRowIdsSelector = (0, _createSelector.createSelector)((0, _gridFilterSelector.gridVisibleSortedRowIdsSelector), gridPaginationRowRangeSelector, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});

},{"../../../utils/createSelector":"4xqAC","../filter/gridFilterSelector":"lndlA","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1GWhw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridDateFormatter", ()=>gridDateFormatter);
parcelHelpers.export(exports, "gridDateTimeFormatter", ()=>gridDateTimeFormatter);
parcelHelpers.export(exports, "GRID_DATE_COL_DEF", ()=>GRID_DATE_COL_DEF);
parcelHelpers.export(exports, "GRID_DATETIME_COL_DEF", ()=>GRID_DATETIME_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _gridSortingUtils = require("../hooks/features/sorting/gridSortingUtils");
var _gridDateOperators = require("./gridDateOperators");
var _gridStringColDef = require("./gridStringColDef");
var _gridEditDateCell = require("../components/cell/GridEditDateCell");
function gridDateFormatter({ value }) {
    if (value instanceof Date) return value.toLocaleDateString();
    return value != null ? value : "";
}
function gridDateTimeFormatter({ value }) {
    if (value instanceof Date) return value.toLocaleString();
    return value != null ? value : "";
}
const GRID_DATE_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    type: "date",
    sortComparator: (0, _gridSortingUtils.gridDateComparator),
    valueFormatter: gridDateFormatter,
    filterOperators: (0, _gridDateOperators.getGridDateOperators)(),
    renderEditCell: (0, _gridEditDateCell.renderEditDateCell),
    getApplyQuickFilterFn: undefined
});
const GRID_DATETIME_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    type: "dateTime",
    sortComparator: (0, _gridSortingUtils.gridDateComparator),
    valueFormatter: gridDateTimeFormatter,
    filterOperators: (0, _gridDateOperators.getGridDateOperators)(true),
    renderEditCell: (0, _gridEditDateCell.renderEditDateCell),
    getApplyQuickFilterFn: undefined
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../hooks/features/sorting/gridSortingUtils":"jsmfR","./gridDateOperators":"ari4h","./gridStringColDef":"f3A6m","../components/cell/GridEditDateCell":"6jzYL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ari4h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridDateOperators", ()=>getGridDateOperators);
var _gridFilterInputDate = require("../components/panel/filterPanel/GridFilterInputDate");
const dateRegex = /(\d+)-(\d+)-(\d+)/;
const dateTimeRegex = /(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;
function buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const [year, month, day, hour, minute] = filterItem.value.match(showTime ? dateTimeRegex : dateRegex).slice(1).map(Number);
    const time = new Date(year, month - 1, day, hour || 0, minute || 0).getTime();
    return ({ value })=>{
        if (!value) return false;
        const valueAsDate = value instanceof Date ? value : new Date(value.toString());
        if (keepHours) return compareFn(valueAsDate.getTime(), time);
         // Make a copy of the date to not reset the hours in the original object
        const dateCopy = value instanceof Date ? new Date(valueAsDate) : valueAsDate;
        const timeToCompare = dateCopy.setHours(showTime ? valueAsDate.getHours() : 0, showTime ? valueAsDate.getMinutes() : 0, 0, 0);
        return compareFn(timeToCompare, time);
    };
}
const getGridDateOperators = (showTime)=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "not",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "after",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrAfter",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "before",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "onOrBefore",
            getApplyFilterFn: (filterItem)=>{
                return buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, _gridFilterInputDate.GridFilterInputDate),
            InputComponentProps: {
                type: showTime ? "datetime-local" : "date"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];

},{"../components/panel/filterPanel/GridFilterInputDate":"i8YP9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"i8YP9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUBMIT_FILTER_DATE_STROKE_TIME", ()=>SUBMIT_FILTER_DATE_STROKE_TIME);
parcelHelpers.export(exports, "GridFilterInputDate", ()=>GridFilterInputDate);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _icons = require("../../icons");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "InputProps"
];
const SUBMIT_FILTER_DATE_STROKE_TIME = 500;
function GridFilterInputDate(props) {
    var _item$value, _rootProps$components;
    const { item, applyValue, type, apiRef, focusElementRef, InputProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const filterTimeout = _react.useRef();
    const [filterValueState, setFilterValueState] = _react.useState((_item$value = item.value) != null ? _item$value : "");
    const [applying, setIsApplying] = _react.useState(false);
    const id = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const onFilterChange = _react.useCallback((event)=>{
        const value = event.target.value;
        clearTimeout(filterTimeout.current);
        setFilterValueState(String(value));
        setIsApplying(true);
        filterTimeout.current = setTimeout(()=>{
            applyValue((0, _extendsDefault.default)({}, item, {
                value
            }));
            setIsApplying(false);
        }, SUBMIT_FILTER_DATE_STROKE_TIME);
    }, [
        applyValue,
        item
    ]);
    _react.useEffect(()=>{
        return ()=>{
            clearTimeout(filterTimeout.current);
        };
    }, []);
    _react.useEffect(()=>{
        var _item$value2;
        const itemValue = (_item$value2 = item.value) != null ? _item$value2 : "";
        setFilterValueState(String(itemValue));
    }, [
        item.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({
        id: id,
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || "text",
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        InputProps: (0, _extendsDefault.default)({}, applying ? {
            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.GridLoadIcon), {})
        } : {}, InputProps, {
            inputProps: (0, _extendsDefault.default)({
                max: type === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31"
            }, InputProps == null ? void 0 : InputProps.inputProps)
        })
    }, other, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTextField));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/utils":"ziQFX","../../icons":"kOLOm","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Fl0Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_NUMERIC_COL_DEF", ()=>GRID_NUMERIC_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _gridSortingUtils = require("../hooks/features/sorting/gridSortingUtils");
var _utils = require("../utils/utils");
var _gridNumericOperators = require("./gridNumericOperators");
var _gridStringColDef = require("./gridStringColDef");
const GRID_NUMERIC_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    type: "number",
    align: "right",
    headerAlign: "right",
    sortComparator: (0, _gridSortingUtils.gridNumberComparator),
    valueParser: (value)=>value === "" ? null : Number(value),
    valueFormatter: ({ value })=>(0, _utils.isNumber)(value) ? value.toLocaleString() : value || "",
    filterOperators: (0, _gridNumericOperators.getGridNumericOperators)(),
    getApplyQuickFilterFn: (0, _gridNumericOperators.getGridNumericQuickFilterFn)
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../hooks/features/sorting/gridSortingUtils":"jsmfR","../utils/utils":"lwlsg","./gridNumericOperators":"jOitN","./gridStringColDef":"f3A6m","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jOitN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridNumericQuickFilterFn", ()=>getGridNumericQuickFilterFn);
parcelHelpers.export(exports, "getGridNumericOperators", ()=>getGridNumericOperators);
parcelHelpers.export(exports, "getGridNumericColumnOperators", ()=>getGridNumericColumnOperators);
var _gridFilterInputValue = require("../components/panel/filterPanel/GridFilterInputValue");
var _gridFilterInputMultipleValue = require("../components/panel/filterPanel/GridFilterInputMultipleValue");
var _warning = require("../utils/warning");
const parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const getGridNumericQuickFilterFn = (value)=>{
    if (value == null || Number.isNaN(value) || value === "") return null;
    return ({ value: columnValue })=>{
        return parseNumericValue(columnValue) === parseNumericValue(value);
    };
};
const getGridNumericOperators = ()=>[
        {
            label: "=",
            value: "=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    return parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "!=",
            value: "!=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    return parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: ">",
            value: ">",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    if (value == null) return false;
                    return parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: ">=",
            value: ">=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    if (value == null) return false;
                    return parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "<",
            value: "<",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    if (value == null) return false;
                    return parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            label: "<=",
            value: "<=",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return ({ value })=>{
                    if (value == null) return false;
                    return parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, _gridFilterInputValue.GridFilterInputValue),
            InputComponentProps: {
                type: "number"
            }
        },
        {
            value: "isEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isNotEmpty",
            getApplyFilterFn: ()=>{
                return ({ value })=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return ({ value })=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, _gridFilterInputMultipleValue.GridFilterInputMultipleValue),
            InputComponentProps: {
                type: "number"
            }
        }
    ];
const getGridNumericColumnOperators = (0, _warning.wrapWithWarningOnCall)(getGridNumericOperators, [
    "MUI: The method getGridNumericColumnOperators is deprecated and will be removed in the next major version.",
    "Use getGridNumericOperators instead."
]);

},{"../components/panel/filterPanel/GridFilterInputValue":"gCTz4","../components/panel/filterPanel/GridFilterInputMultipleValue":"fRjMZ","../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"etPWY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_SINGLE_SELECT_COL_DEF", ()=>GRID_SINGLE_SELECT_COL_DEF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _gridStringColDef = require("./gridStringColDef");
var _gridEditSingleSelectCell = require("../components/cell/GridEditSingleSelectCell");
var _gridSingleSelectOperators = require("./gridSingleSelectOperators");
const GRID_SINGLE_SELECT_COL_DEF = (0, _extendsDefault.default)({}, (0, _gridStringColDef.GRID_STRING_COL_DEF), {
    type: "singleSelect",
    renderEditCell: (0, _gridEditSingleSelectCell.renderEditSingleSelectCell),
    filterOperators: (0, _gridSingleSelectOperators.getGridSingleSelectOperators)(),
    getApplyQuickFilterFn: (0, _gridSingleSelectOperators.getGridSingleSelectQuickFilterFn)
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./gridStringColDef":"f3A6m","../components/cell/GridEditSingleSelectCell":"anoTd","./gridSingleSelectOperators":"jFelT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jFelT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridSingleSelectQuickFilterFn", ()=>getGridSingleSelectQuickFilterFn);
parcelHelpers.export(exports, "getGridSingleSelectOperators", ()=>getGridSingleSelectOperators);
var _gridFilterInputSingleSelect = require("../components/panel/filterPanel/GridFilterInputSingleSelect");
var _gridFilterInputMultipleSingleSelect = require("../components/panel/filterPanel/GridFilterInputMultipleSingleSelect");
const parseObjectValue = (value)=>{
    if (value == null || typeof value !== "object") return value;
    return value.value;
};
const getGridSingleSelectQuickFilterFn = (value, column, apiRef)=>{
    if (!value) return null;
    const { valueOptions, valueFormatter, field } = column;
    const potentialValues = [
        parseObjectValue(value).toString()
    ];
    const iterableColumnValues = typeof valueOptions === "function" ? valueOptions({
        field
    }) : valueOptions || [];
    if (iterableColumnValues) iterableColumnValues.forEach((option)=>{
        // for each valueOption, check if the formatted value
        let optionValue;
        let optionLabel;
        if (typeof option === "object") {
            optionValue = option.value;
            optionLabel = option.label;
        } else {
            optionValue = option;
            if (valueFormatter) optionLabel = valueFormatter({
                value: option,
                field,
                api: apiRef.current
            });
            else optionLabel = option;
        }
        if (optionLabel.slice(0, value.length).toLowerCase() === value.toLowerCase()) {
            if (!potentialValues.includes(optionValue)) potentialValues.push(optionValue.toString());
        }
    });
    return ({ value: columnValue })=>{
        return columnValue != null ? potentialValues.includes(parseObjectValue(columnValue).toString()) : false;
    };
};
const getGridSingleSelectOperators = ()=>[
        {
            value: "is",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === "") return null;
                return ({ value })=>parseObjectValue(value) === parseObjectValue(filterItem.value);
            },
            InputComponent: (0, _gridFilterInputSingleSelect.GridFilterInputSingleSelect)
        },
        {
            value: "not",
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === "") return null;
                return ({ value })=>parseObjectValue(value) !== parseObjectValue(filterItem.value);
            },
            InputComponent: (0, _gridFilterInputSingleSelect.GridFilterInputSingleSelect)
        },
        {
            value: "isAnyOf",
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map(parseObjectValue);
                return ({ value })=>filterItemValues.includes(parseObjectValue(value));
            },
            InputComponent: (0, _gridFilterInputMultipleSingleSelect.GridFilterInputMultipleSingleSelect)
        }
    ];

},{"../components/panel/filterPanel/GridFilterInputSingleSelect":"9GVLh","../components/panel/filterPanel/GridFilterInputMultipleSingleSelect":"ekiJB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9GVLh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterInputSingleSelect", ()=>GridFilterInputSingleSelect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/material/utils");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _filterPanelUtils = require("./filterPanelUtils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef"
];
const renderSingleSelectOptions = ({ valueOptions, valueFormatter, field }, api, OptionComponent)=>{
    const iterableColumnValues = typeof valueOptions === "function" ? [
        "",
        ...valueOptions({
            field
        })
    ] : [
        "",
        ...valueOptions || []
    ];
    return iterableColumnValues.map((option)=>{
        const isOptionTypeObject = typeof option === "object";
        const key = isOptionTypeObject ? option.value : option;
        const value = isOptionTypeObject ? option.value : option;
        const formattedValue = valueFormatter && option !== "" ? valueFormatter({
            value: option,
            field,
            api
        }) : option;
        const content = isOptionTypeObject ? option.label : formattedValue;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
            value: value,
            children: content
        }, key);
    });
};
function GridFilterInputSingleSelect(props) {
    var _item$value, _rootProps$components, _baseSelectProps$nati, _rootProps$components2, _rootProps$components3;
    const { item, applyValue, type, apiRef, focusElementRef } = props, others = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [filterValueState, setFilterValueState] = _react.useState((_item$value = item.value) != null ? _item$value : "");
    const id = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const baseSelectProps = ((_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseSelect) || {};
    const isSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const currentColumn = item.columnField ? apiRef.current.getColumn(item.columnField) : null;
    const currentValueOptions = _react.useMemo(()=>{
        if (currentColumn === null) return undefined;
        return typeof currentColumn.valueOptions === "function" ? currentColumn.valueOptions({
            field: currentColumn.field
        }) : currentColumn.valueOptions;
    }, [
        currentColumn
    ]);
    const onFilterChange = _react.useCallback((event)=>{
        let value = event.target.value; // NativeSelect casts the value to a string.
        value = (0, _filterPanelUtils.getValueFromValueOptions)(value, currentValueOptions);
        setFilterValueState(String(value));
        applyValue((0, _extendsDefault.default)({}, item, {
            value
        }));
    }, [
        applyValue,
        item,
        currentValueOptions
    ]);
    _react.useEffect(()=>{
        var _itemValue;
        let itemValue;
        if (currentValueOptions !== undefined) {
            // sanitize if valueOptions are provided
            itemValue = (0, _filterPanelUtils.getValueFromValueOptions)(item.value, currentValueOptions);
            if (itemValue !== item.value) {
                applyValue((0, _extendsDefault.default)({}, item, {
                    value: itemValue
                }));
                return;
            }
        } else itemValue = item.value;
        itemValue = (_itemValue = itemValue) != null ? _itemValue : "";
        setFilterValueState(String(itemValue));
    }, [
        item,
        currentValueOptions,
        applyValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({
        id: id,
        label: apiRef.current.getLocaleText("filterPanelInputLabel"),
        placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
        value: filterValueState,
        onChange: onFilterChange,
        variant: "standard",
        type: type || "text",
        InputLabelProps: {
            shrink: true
        },
        inputRef: focusElementRef,
        select: true,
        SelectProps: (0, _extendsDefault.default)({
            native: isSelectNative
        }, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSelect)
    }, others, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.baseTextField, {
        children: renderSingleSelectOptions(apiRef.current.getColumn(item.columnField), apiRef.current, isSelectNative ? "option" : (0, _menuItemDefault.default))
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/utils":"ziQFX","@mui/material/MenuItem":"dTC9Z","../../../hooks/utils/useGridRootProps":"cdy2y","./filterPanelUtils":"kGvsb","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ekiJB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterInputMultipleSingleSelect", ()=>GridFilterInputMultipleSingleSelect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _autocomplete = require("@mui/material/Autocomplete");
var _autocompleteDefault = parcelHelpers.interopDefault(_autocomplete);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _utils = require("@mui/material/utils");
var _filterPanelUtils = require("./filterPanelUtils");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "color",
    "error",
    "helperText",
    "size",
    "variant"
];
const isOptionEqualToValue = (option, value)=>(0, _filterPanelUtils.getValueFromOption)(option) === (0, _filterPanelUtils.getValueFromOption)(value);
const filter = (0, _autocomplete.createFilterOptions)();
function GridFilterInputMultipleSingleSelect(props) {
    const { item, applyValue, apiRef, focusElementRef, color, error, helperText, size, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const TextFieldProps = {
        color,
        error,
        helperText,
        size,
        variant
    };
    const id = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const resolvedColumn = item.columnField ? apiRef.current.getColumn(item.columnField) : null;
    const resolvedValueOptions = _react.useMemo(()=>{
        if (!(resolvedColumn != null && resolvedColumn.valueOptions)) return [];
        if (typeof resolvedColumn.valueOptions === "function") return resolvedColumn.valueOptions({
            field: resolvedColumn.field
        });
        return resolvedColumn.valueOptions;
    }, [
        resolvedColumn
    ]);
    const resolvedFormattedValueOptions = _react.useMemo(()=>{
        return resolvedValueOptions == null ? void 0 : resolvedValueOptions.map((0, _filterPanelUtils.getValueFromOption));
    }, [
        resolvedValueOptions
    ]);
    const { valueFormatter, field } = apiRef.current.getColumn(item.columnField);
    const filterValueOptionFormatter = (option)=>{
        if (typeof option === "object") return option.label;
        return valueFormatter && option !== "" ? valueFormatter({
            value: option,
            field,
            api: apiRef.current
        }) : option;
    }; // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filterValues = _react.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        if (resolvedValueOptions !== undefined) {
            const itemValueIndexes = item.value.map((element)=>{
                // get the index matching between values and valueOptions
                const formattedElement = (0, _filterPanelUtils.getValueFromOption)(element);
                const index = (resolvedFormattedValueOptions == null ? void 0 : resolvedFormattedValueOptions.findIndex((formatedOption)=>formatedOption === formattedElement)) || 0;
                return index;
            });
            return itemValueIndexes.filter((index)=>index >= 0).map((index)=>resolvedValueOptions[index]);
        }
        return item.value;
    }, [
        item.value,
        resolvedValueOptions,
        resolvedFormattedValueOptions
    ]);
    _react.useEffect(()=>{
        if (!Array.isArray(item.value) || filterValues.length !== item.value.length) // update the state if the filter value has been cleaned by the component
        applyValue((0, _extendsDefault.default)({}, item, {
            value: filterValues.map((0, _filterPanelUtils.getValueFromOption))
        }));
    }, [
        item,
        filterValues,
        applyValue
    ]);
    const handleChange = _react.useCallback((event, value)=>{
        applyValue((0, _extendsDefault.default)({}, item, {
            value: [
                ...value.map((0, _filterPanelUtils.getValueFromOption))
            ]
        }));
    }, [
        applyValue,
        item
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autocompleteDefault.default), (0, _extendsDefault.default)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        filterOptions: filter,
        id: id,
        value: filterValues,
        onChange: handleChange,
        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), (0, _extendsDefault.default)({
                    variant: "outlined",
                    size: "small",
                    label: filterValueOptionFormatter(option)
                }, getTagProps({
                    index
                })))),
        renderInput: (params)=>{
            var _rootProps$components;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({}, params, {
                label: apiRef.current.getLocaleText("filterPanelInputLabel"),
                placeholder: apiRef.current.getLocaleText("filterPanelInputPlaceholder"),
                InputLabelProps: (0, _extendsDefault.default)({}, params.InputLabelProps, {
                    shrink: true
                }),
                inputRef: focusElementRef,
                type: "singleSelect"
            }, TextFieldProps, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTextField));
        }
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/Autocomplete":"3qDJc","@mui/material/Chip":"bwuFy","@mui/material/utils":"ziQFX","./filterPanelUtils":"kGvsb","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cGyNj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_GRID_COL_TYPE_KEY", ()=>DEFAULT_GRID_COL_TYPE_KEY);
parcelHelpers.export(exports, "getGridDefaultColumnTypes", ()=>getGridDefaultColumnTypes);
var _gridStringColDef = require("./gridStringColDef");
var _gridNumericColDef = require("./gridNumericColDef");
var _gridDateColDef = require("./gridDateColDef");
var _gridBooleanColDef = require("./gridBooleanColDef");
var _gridSingleSelectColDef = require("./gridSingleSelectColDef");
var _gridActionsColDef = require("./gridActionsColDef");
const DEFAULT_GRID_COL_TYPE_KEY = "__default__";
const getGridDefaultColumnTypes = ()=>{
    const nativeColumnTypes = {
        string: (0, _gridStringColDef.GRID_STRING_COL_DEF),
        number: (0, _gridNumericColDef.GRID_NUMERIC_COL_DEF),
        date: (0, _gridDateColDef.GRID_DATE_COL_DEF),
        dateTime: (0, _gridDateColDef.GRID_DATETIME_COL_DEF),
        boolean: (0, _gridBooleanColDef.GRID_BOOLEAN_COL_DEF),
        singleSelect: (0, _gridSingleSelectColDef.GRID_SINGLE_SELECT_COL_DEF),
        [(0, _gridActionsColDef.GRID_ACTIONS_COLUMN_TYPE)]: (0, _gridActionsColDef.GRID_ACTIONS_COL_DEF),
        [DEFAULT_GRID_COL_TYPE_KEY]: (0, _gridStringColDef.GRID_STRING_COL_DEF)
    };
    return nativeColumnTypes;
};

},{"./gridStringColDef":"f3A6m","./gridNumericColDef":"7Fl0Q","./gridDateColDef":"1GWhw","./gridBooleanColDef":"7Uwmf","./gridSingleSelectColDef":"etPWY","./gridActionsColDef":"2wcgU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9Muc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortGridMenuItems", ()=>SortGridMenuItems);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridSelector = require("../../../hooks/utils/useGridSelector");
var _gridSortingSelector = require("../../../hooks/features/sorting/gridSortingSelector");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
function SortGridMenuItems(props) {
    var _column$sortingOrder;
    const { column, onClick } = props;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const sortModel = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSortingSelector.gridSortModelSelector));
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const sortingOrder = (_column$sortingOrder = column.sortingOrder) != null ? _column$sortingOrder : rootProps.sortingOrder;
    const sortDirection = _react.useMemo(()=>{
        if (!column) return null;
        const sortItem = sortModel.find((item)=>item.field === column.field);
        return sortItem == null ? void 0 : sortItem.sort;
    }, [
        column,
        sortModel
    ]);
    const onSortMenuItemClick = _react.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute("data-value") || null;
        apiRef.current.sortColumn(column, direction);
    }, [
        apiRef,
        column,
        onClick
    ]);
    if (!column || !column.sortable) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            sortingOrder.includes(null) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                onClick: onSortMenuItemClick,
                disabled: sortDirection == null,
                children: apiRef.current.getLocaleText("columnMenuUnsort")
            }) : null,
            sortingOrder.includes("asc") ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                disabled: sortDirection === "asc",
                children: apiRef.current.getLocaleText("columnMenuSortAsc")
            }) : null,
            sortingOrder.includes("desc") ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                disabled: sortDirection === "desc",
                children: apiRef.current.getLocaleText("columnMenuSortDesc")
            }) : null
        ]
    });
}

},{"react":"gVheC","prop-types":"3KNJy","@mui/material/MenuItem":"dTC9Z","../../../hooks/utils/useGridSelector":"96gNX","../../../hooks/features/sorting/gridSortingSelector":"1g9b1","../../../hooks/utils/useGridApiContext":"cn3M8","../../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kUCv9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridColumnsPanel = require("./GridColumnsPanel");
parcelHelpers.exportAll(_gridColumnsPanel, exports);
var _gridPanel = require("./GridPanel");
parcelHelpers.exportAll(_gridPanel, exports);
var _gridPanelContent = require("./GridPanelContent");
parcelHelpers.exportAll(_gridPanelContent, exports);
var _gridPanelFooter = require("./GridPanelFooter");
parcelHelpers.exportAll(_gridPanelFooter, exports);
var _gridPanelHeader = require("./GridPanelHeader");
parcelHelpers.exportAll(_gridPanelHeader, exports);
var _gridPanelWrapper = require("./GridPanelWrapper");
parcelHelpers.exportAll(_gridPanelWrapper, exports);
var _gridPreferencesPanel = require("./GridPreferencesPanel");
parcelHelpers.exportAll(_gridPreferencesPanel, exports);
var _filterPanel = require("./filterPanel");
parcelHelpers.exportAll(_filterPanel, exports);

},{"./GridColumnsPanel":"8fTNR","./GridPanel":"gVtQY","./GridPanelContent":false,"./GridPanelFooter":false,"./GridPanelHeader":false,"./GridPanelWrapper":false,"./GridPreferencesPanel":"iD3pM","./filterPanel":"aCKkz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8fTNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnsPanel", ()=>GridColumnsPanel);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _switch = require("@mui/material/Switch");
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _styles = require("@mui/material/styles");
var _gridColumnsSelector = require("../../hooks/features/columns/gridColumnsSelector");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _icons = require("../icons");
var _gridPanelContent = require("./GridPanelContent");
var _gridPanelFooter = require("./GridPanelFooter");
var _gridPanelHeader = require("./GridPanelHeader");
var _gridPanelWrapper = require("./GridPanelWrapper");
var _envConstants = require("../../constants/envConstants");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "sort",
    "searchPredicate",
    "autoFocusSearchField"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "columnsPanel"
        ],
        columnsPanelRow: [
            "columnsPanelRow"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridColumnsPanelRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ColumnsPanel",
    overridesResolver: (props, styles)=>styles.columnsPanel
})({
    padding: "8px 0px 8px 8px"
});
const GridColumnsPanelRowRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ColumnsPanelRow",
    overridesResolver: (props, styles)=>styles.columnsPanelRow
})(({ theme })=>({
        display: "flex",
        justifyContent: "space-between",
        padding: "1px 8px 1px 7px",
        [`& .${(0, _switch.switchClasses).root}`]: {
            marginRight: theme.spacing(0.5)
        }
    }));
const GridIconButtonRoot = (0, _styles.styled)((0, _iconButtonDefault.default))({
    justifyContent: "flex-end"
});
const collator = new Intl.Collator();
const defaultSearchPredicate = (column, searchValue)=>{
    return (column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;
};
function GridColumnsPanel(props) {
    var _rootProps$components, _rootProps$components3, _rootProps$components4;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const searchInputRef = _react.useRef(null);
    const columns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnDefinitionsSelector));
    const columnVisibilityModel = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnVisibilityModelSelector));
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const [searchValue, setSearchValue] = _react.useState("");
    const classes = useUtilityClasses(rootProps);
    const { sort, searchPredicate = defaultSearchPredicate, autoFocusSearchField = true } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const sortedColumns = _react.useMemo(()=>{
        switch(sort){
            case "asc":
                return [
                    ...columns
                ].sort((a, b)=>collator.compare(a.headerName || a.field, b.headerName || b.field));
            case "desc":
                return [
                    ...columns
                ].sort((a, b)=>-collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const toggleAllColumns = _react.useCallback((isVisible)=>{
        if (apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel) {
            const currentModel = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef);
            const newModel = (0, _extendsDefault.default)({}, currentModel);
            columns.forEach((col)=>{
                if (col.hideable) {
                    if (isVisible) // delete the key from the model instead of setting it to `true`
                    delete newModel[col.field];
                    else newModel[col.field] = false;
                }
            });
            return apiRef.current.setColumnVisibilityModel(newModel);
        } // TODO v6: Remove
        return apiRef.current.updateColumns(columns.map((col)=>{
            if (col.hideable !== false) return {
                field: col.field,
                hide: !isVisible
            };
            return col;
        }));
    }, [
        apiRef,
        columns
    ]);
    const handleSearchValueChange = _react.useCallback((event)=>{
        setSearchValue(event.target.value);
    }, []);
    const currentColumns = _react.useMemo(()=>{
        if (!searchValue) return sortedColumns;
        const searchValueToCheck = searchValue.toLowerCase();
        return sortedColumns.filter((column)=>searchPredicate(column, searchValueToCheck));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate
    ]);
    const firstSwitchRef = _react.useRef(null);
    _react.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === "function") firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridPanelWrapper.GridPanelWrapper), (0, _extendsDefault.default)({}, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridPanelHeader.GridPanelHeader), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseTextField, (0, _extendsDefault.default)({
                    label: apiRef.current.getLocaleText("columnsPanelTextFieldLabel"),
                    placeholder: apiRef.current.getLocaleText("columnsPanelTextFieldPlaceholder"),
                    inputRef: searchInputRef,
                    value: searchValue,
                    onChange: handleSearchValueChange,
                    variant: "standard",
                    fullWidth: true
                }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseTextField))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridPanelContent.GridPanelContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnsPanelRoot, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: currentColumns.map((column)=>{
                        var _rootProps$components2;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GridColumnsPanelRowRoot, {
                            className: classes.columnsPanelRow,
                            ownerState: rootProps,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                    control: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseSwitch, (0, _extendsDefault.default)({
                                        disabled: column.hideable === false,
                                        checked: columnVisibilityModel[column.field] !== false,
                                        onClick: toggleColumn,
                                        name: column.field,
                                        size: "small",
                                        inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined
                                    }, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSwitch)),
                                    label: column.headerName || column.field
                                }),
                                !rootProps.disableColumnReorder && (0, _envConstants.GRID_EXPERIMENTAL_ENABLED) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridIconButtonRoot, {
                                    draggable: true,
                                    "aria-label": apiRef.current.getLocaleText("columnsPanelDragIconLabel"),
                                    title: apiRef.current.getLocaleText("columnsPanelDragIconLabel"),
                                    size: "small",
                                    disabled: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.GridDragIcon), {})
                                })
                            ]
                        }, column.field);
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridPanelFooter.GridPanelFooter), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseButton, (0, _extendsDefault.default)({
                        onClick: ()=>toggleAllColumns(false)
                    }, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.baseButton, {
                        children: apiRef.current.getLocaleText("columnsPanelHideAllButton")
                    })),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseButton, (0, _extendsDefault.default)({
                        onClick: ()=>toggleAllColumns(true)
                    }, (_rootProps$components4 = rootProps.componentsProps) == null ? void 0 : _rootProps$components4.baseButton, {
                        children: apiRef.current.getLocaleText("columnsPanelShowAllButton")
                    }))
                ]
            })
        ]
    }));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","@mui/material/Switch":"3POY0","@mui/material/FormControlLabel":"c21sM","@mui/material/styles":"gNR9m","../../hooks/features/columns/gridColumnsSelector":"aeHtc","../../hooks/utils/useGridSelector":"96gNX","../../hooks/utils/useGridApiContext":"cn3M8","../icons":"kOLOm","./GridPanelContent":"1ebDj","./GridPanelFooter":"2Ol2G","./GridPanelHeader":"4clpO","./GridPanelWrapper":"lIql3","../../constants/envConstants":"iBPsu","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1ebDj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPanelContent", ()=>GridPanelContent);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "panelContent"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridPanelContentRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "PanelContent",
    overridesResolver: (props, styles)=>styles.panelContent
})({
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    flex: "1 1",
    maxHeight: 400
});
function GridPanelContent(props) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPanelContentRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Ol2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPanelFooter", ()=>GridPanelFooter);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "panelFooter"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridPanelFooterRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "PanelFooter",
    overridesResolver: (props, styles)=>styles.panelFooter
})(({ theme })=>({
        padding: theme.spacing(0.5),
        display: "flex",
        justifyContent: "space-between"
    }));
function GridPanelFooter(props) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPanelFooterRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4clpO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPanelHeader", ()=>GridPanelHeader);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "panelHeader"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridPanelHeaderRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "PanelHeader",
    overridesResolver: (props, styles)=>styles.panelHeader
})(({ theme })=>({
        padding: theme.spacing(1)
    }));
function GridPanelHeader(props) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPanelHeaderRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lIql3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPanelWrapper", ()=>GridPanelWrapper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _unstableTrapFocus = require("@mui/material/Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "slotProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "panelWrapper"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridPanelWrapperRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "PanelWrapper",
    overridesResolver: (props, styles)=>styles.panelWrapper
})({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    "&:focus": {
        outline: 0
    }
});
const isEnabled = ()=>true;
const GridPanelWrapper = /*#__PURE__*/ _react.forwardRef(function GridPanelWrapper(props, ref) {
    const { className, slotProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableTrapFocusDefault.default), (0, _extendsDefault.default)({
        open: true,
        disableEnforceFocus: true,
        isEnabled: isEnabled
    }, slotProps.TrapFocus, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPanelWrapperRoot, (0, _extendsDefault.default)({
            ref: ref,
            tabIndex: -1,
            className: (0, _clsxDefault.default)(className, classes.root),
            ownerState: rootProps
        }, other))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/Unstable_TrapFocus":"kxC5X","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBPsu":[function(require,module,exports) {
// A guide to feature toggling (deprecated)
//
// The feature toggle is:
// - independent from the NODE_ENV
// - isn't pruning code in production, as the objective is to eventually ship the code.
// - doesn't allow to cherry-pick which feature to enable
//
// By default, the experimental features are only enabled in:
// - the local environment
// - the pull request previews
//
// Reviewers can force the value with the local storage and the GRID_EXPERIMENTAL_ENABLED key:
// - 'true' => force it to be enabled
// - 'false' => force it to be disabled
//
// Developers (users) are discouraged to enable the experimental feature by setting the GRID_EXPERIMENTAL_ENABLED env.
// Instead, prefer exposing experimental APIs, for instance, a prop or a new `unstable_` module.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_EXPERIMENTAL_ENABLED", ()=>GRID_EXPERIMENTAL_ENABLED);
const GRID_EXPERIMENTAL_ENABLED = false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gVtQY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridPanelClasses", ()=>gridPanelClasses);
parcelHelpers.export(exports, "GridPanel", ()=>GridPanel);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _keyboardUtils = require("../../utils/keyboardUtils");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "className",
    "classes"
];
const gridPanelClasses = (0, _material.generateUtilityClasses)("MuiDataGrid", [
    "panel",
    "paper"
]);
const GridPanelRoot = (0, _styles.styled)((0, _popperDefault.default), {
    name: "MuiDataGrid",
    slot: "Panel",
    overridesResolver: (props, styles)=>styles.panel
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const GridPaperRoot = (0, _styles.styled)((0, _paperDefault.default), {
    name: "MuiDataGrid",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme })=>({
        backgroundColor: theme.palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: "flex"
    }));
const GridPanel = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    var _apiRef$current$colum;
    const { children, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = gridPanelClasses;
    const [isPlaced, setIsPlaced] = _react.useState(false);
    const handleClickAway = _react.useCallback(()=>{
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const handleKeyDown = _react.useCallback((event)=>{
        if ((0, _keyboardUtils.isEscapeKey)(event.key)) apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    const modifiers = _react.useMemo(()=>[
            {
                name: "flip",
                enabled: false
            },
            {
                name: "isPlaced",
                enabled: true,
                phase: "main",
                fn: ()=>{
                    setIsPlaced(true);
                },
                effect: ()=>()=>{
                        setIsPlaced(false);
                    }
            }
        ], []);
    const anchorEl = (_apiRef$current$colum = apiRef.current.columnHeadersContainerElementRef) == null ? void 0 : _apiRef$current$colum.current;
    if (!anchorEl) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPanelRoot, (0, _extendsDefault.default)({
        ref: ref,
        placement: "bottom-start",
        className: (0, _clsxDefault.default)(className, classes.panel),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickAwayListenerDefault.default), {
            mouseEvent: "onMouseUp",
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","@mui/material/ClickAwayListener":"j08aI","@mui/material/Paper":"4qOeF","@mui/material/Popper":"2EAIq","../../hooks/utils/useGridApiContext":"cn3M8","../../utils/keyboardUtils":"o7lWn","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iD3pM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPreferencesPanel", ()=>GridPreferencesPanel);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridColumnsSelector = require("../../hooks/features/columns/gridColumnsSelector");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _gridPreferencePanelSelector = require("../../hooks/features/preferencesPanel/gridPreferencePanelSelector");
var _gridPreferencePanelsValue = require("../../hooks/features/preferencesPanel/gridPreferencePanelsValue");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const GridPreferencesPanel = /*#__PURE__*/ _react.forwardRef(function GridPreferencesPanel(props, ref) {
    var _preferencePanelState, _rootProps$components, _rootProps$components2;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const columns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnDefinitionsSelector));
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const preferencePanelState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridPreferencePanelSelector.gridPreferencePanelStateSelector));
    const panelContent = apiRef.current.unstable_applyPipeProcessors("preferencePanel", null, (_preferencePanelState = preferencePanelState.openedPanelValue) != null ? _preferencePanelState : (0, _gridPreferencePanelsValue.GridPreferencePanelsValue).filters);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Panel, (0, _extendsDefault.default)({
        ref: ref,
        as: rootProps.components.BasePopper,
        open: columns.length > 0 && preferencePanelState.open
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.panel, props, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.basePopper, {
        children: panelContent
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../hooks/features/columns/gridColumnsSelector":"aeHtc","../../hooks/utils/useGridSelector":"96gNX","../../hooks/features/preferencesPanel/gridPreferencePanelSelector":"7GEzE","../../hooks/features/preferencesPanel/gridPreferencePanelsValue":"7YmlH","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aCKkz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridFilterForm = require("./GridFilterForm");
parcelHelpers.exportAll(_gridFilterForm, exports);
var _gridFilterInputValue = require("./GridFilterInputValue");
parcelHelpers.exportAll(_gridFilterInputValue, exports);
var _gridFilterInputDate = require("./GridFilterInputDate");
parcelHelpers.exportAll(_gridFilterInputDate, exports);
var _gridFilterInputSingleSelect = require("./GridFilterInputSingleSelect");
parcelHelpers.exportAll(_gridFilterInputSingleSelect, exports);
var _gridFilterInputValueProps = require("./GridFilterInputValueProps");
parcelHelpers.exportAll(_gridFilterInputValueProps, exports);
var _gridFilterPanel = require("./GridFilterPanel");
parcelHelpers.exportAll(_gridFilterPanel, exports);
var _gridFilterInputMultipleValue = require("./GridFilterInputMultipleValue");
parcelHelpers.exportAll(_gridFilterInputMultipleValue, exports);
var _gridFilterInputMultipleSingleSelect = require("./GridFilterInputMultipleSingleSelect");
parcelHelpers.exportAll(_gridFilterInputMultipleSingleSelect, exports);

},{"./GridFilterForm":false,"./GridFilterInputValue":false,"./GridFilterInputDate":false,"./GridFilterInputSingleSelect":false,"./GridFilterInputValueProps":false,"./GridFilterPanel":"4kuHz","./GridFilterInputMultipleValue":false,"./GridFilterInputMultipleSingleSelect":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iGlsX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterForm", ()=>GridFilterForm);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _material = require("@mui/material");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _gridColumnsSelector = require("../../../hooks/features/columns/gridColumnsSelector");
var _useGridSelector = require("../../../hooks/utils/useGridSelector");
var _gridFilterItem = require("../../../models/gridFilterItem");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "multiFilterOperator",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "linkOperators",
    "columnsSort",
    "deleteIconProps",
    "linkOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "children"
], _excluded2 = [
    "InputComponentProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "filterForm"
        ],
        deleteIcon: [
            "filterFormDeleteIcon"
        ],
        linkOperatorInput: [
            "filterFormLinkOperatorInput"
        ],
        columnInput: [
            "filterFormColumnInput"
        ],
        operatorInput: [
            "filterFormOperatorInput"
        ],
        valueInput: [
            "filterFormValueInput"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridFilterFormRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "FilterForm",
    overridesResolver: (props, styles)=>styles.filterForm
})(({ theme })=>({
        display: "flex",
        padding: theme.spacing(1)
    }));
const FilterFormDeleteIcon = (0, _styles.styled)((0, _formControlDefault.default), {
    name: "MuiDataGrid",
    slot: "FilterFormDeleteIcon",
    overridesResolver: (_, styles)=>styles.filterFormDeleteIcon
})(({ theme })=>({
        flexShrink: 0,
        justifyContent: "flex-end",
        marginRight: theme.spacing(0.5),
        marginBottom: theme.spacing(0.2)
    }));
const FilterFormLinkOperatorInput = (0, _styles.styled)((0, _formControlDefault.default), {
    name: "MuiDataGrid",
    slot: "FilterFormLinkOperatorInput",
    overridesResolver: (_, styles)=>styles.filterFormLinkOperatorInput
})({
    minWidth: 55,
    marginRight: 5,
    justifyContent: "end"
});
const FilterFormColumnInput = (0, _styles.styled)((0, _formControlDefault.default), {
    name: "MuiDataGrid",
    slot: "FilterFormColumnInput",
    overridesResolver: (_, styles)=>styles.filterFormColumnInput
})({
    width: 150
});
const FilterFormOperatorInput = (0, _styles.styled)((0, _formControlDefault.default), {
    name: "MuiDataGrid",
    slot: "FilterFormOperatorInput",
    overridesResolver: (_, styles)=>styles.filterFormOperatorInput
})({
    width: 120
});
const FilterFormValueInput = (0, _styles.styled)((0, _formControlDefault.default), {
    name: "MuiDataGrid",
    slot: "FilterFormValueInput",
    overridesResolver: (_, styles)=>styles.filterFormValueInput
})({
    width: 190
});
const getLinkOperatorLocaleKey = (linkOperator)=>{
    switch(linkOperator){
        case (0, _gridFilterItem.GridLinkOperator).And:
            return "filterPanelOperatorAnd";
        case (0, _gridFilterItem.GridLinkOperator).Or:
            return "filterPanelOperatorOr";
        default:
            throw new Error("MUI: Invalid `linkOperator` property in the `GridFilterPanel`.");
    }
};
const getColumnLabel = (col)=>col.headerName || col.field;
const collator = new Intl.Collator();
const GridFilterForm = /*#__PURE__*/ _react.forwardRef(function GridFilterForm(props, ref) {
    var _rootProps$components, _rootProps$components2, _baseSelectProps$nati, _rootProps$components3, _rootProps$components4, _rootProps$components5, _currentColumn$filter2;
    const { item, hasMultipleFilters, deleteFilter, applyFilterChanges, multiFilterOperator, showMultiFilterOperators, disableMultiFilterOperator, applyMultiFilterOperatorChanges, focusElementRef, linkOperators = [
        (0, _gridFilterItem.GridLinkOperator).And,
        (0, _gridFilterItem.GridLinkOperator).Or
    ], columnsSort, deleteIconProps = {}, linkOperatorInputProps = {}, operatorInputProps = {}, columnInputProps = {}, valueInputProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const filterableColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridFilterableColumnDefinitionsSelector));
    const columnSelectId = (0, _utils.unstable_useId)();
    const columnSelectLabelId = (0, _utils.unstable_useId)();
    const operatorSelectId = (0, _utils.unstable_useId)();
    const operatorSelectLabelId = (0, _utils.unstable_useId)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    const valueRef = _react.useRef(null);
    const filterSelectorRef = _react.useRef(null);
    const hasLinkOperatorColumn = hasMultipleFilters && linkOperators.length > 0;
    const baseFormControlProps = ((_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseFormControl) || {};
    const baseSelectProps = ((_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.baseSelect) || {};
    const isBaseSelectNative = (_baseSelectProps$nati = baseSelectProps.native) != null ? _baseSelectProps$nati : true;
    const OptionComponent = isBaseSelectNative ? "option" : (0, _menuItemDefault.default);
    const { InputComponentProps } = valueInputProps, valueInputPropsOther = (0, _objectWithoutPropertiesLooseDefault.default)(valueInputProps, _excluded2);
    const sortedFilterableColumns = _react.useMemo(()=>{
        switch(columnsSort){
            case "asc":
                return filterableColumns.sort((a, b)=>collator.compare(getColumnLabel(a), getColumnLabel(b)));
            case "desc":
                return filterableColumns.sort((a, b)=>-collator.compare(getColumnLabel(a), getColumnLabel(b)));
            default:
                return filterableColumns;
        }
    }, [
        filterableColumns,
        columnsSort
    ]);
    const currentColumn = item.columnField ? apiRef.current.getColumn(item.columnField) : null;
    const currentOperator = _react.useMemo(()=>{
        var _currentColumn$filter;
        if (!item.operatorValue || !currentColumn) return null;
        return (_currentColumn$filter = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter.find((operator)=>operator.value === item.operatorValue);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = _react.useCallback((event)=>{
        const columnField = event.target.value;
        const column = apiRef.current.getColumn(columnField);
        if (column.field === currentColumn.field) // column did not change
        return;
         // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operatorValue) || column.filterOperators[0]; // Erase filter value if the input component is modified
        const eraseItemValue = !newOperator.InputComponent || newOperator.InputComponent !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
        applyFilterChanges((0, _extendsDefault.default)({}, item, {
            columnField,
            operatorValue: newOperator.value,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = _react.useCallback((event)=>{
        const operatorValue = event.target.value;
        const newOperator = currentColumn == null ? void 0 : currentColumn.filterOperators.find((operator)=>operator.value === operatorValue);
        const eraseItemValue = !(newOperator != null && newOperator.InputComponent) || (newOperator == null ? void 0 : newOperator.InputComponent) !== (currentOperator == null ? void 0 : currentOperator.InputComponent);
        applyFilterChanges((0, _extendsDefault.default)({}, item, {
            operatorValue,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLinkOperator = _react.useCallback((event)=>{
        const linkOperator = event.target.value === (0, _gridFilterItem.GridLinkOperator).And.toString() ? (0, _gridFilterItem.GridLinkOperator).And : (0, _gridFilterItem.GridLinkOperator).Or;
        applyMultiFilterOperatorChanges(linkOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        if (rootProps.disableMultipleColumnsFiltering) {
            if (item.value === undefined) deleteFilter(item);
            else // TODO v6: simplify the behavior by always remove the filter form
            applyFilterChanges((0, _extendsDefault.default)({}, item, {
                value: undefined
            }));
        } else deleteFilter(item);
    };
    _react.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator != null && currentOperator.InputComponent) {
                    var _valueRef$current;
                    valueRef == null || (_valueRef$current = valueRef.current) == null || _valueRef$current.focus();
                } else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GridFilterFormRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: classes.root,
        ownerState: rootProps
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterFormDeleteIcon, (0, _extendsDefault.default)({
                variant: "standard",
                as: rootProps.components.BaseFormControl
            }, baseFormControlProps, deleteIconProps, {
                className: (0, _clsxDefault.default)(classes.deleteIcon, baseFormControlProps.className, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    "aria-label": apiRef.current.getLocaleText("filterPanelDeleteIconLabel"),
                    title: apiRef.current.getLocaleText("filterPanelDeleteIconLabel"),
                    onClick: handleDeleteFilter,
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.FilterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                })
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterFormLinkOperatorInput, (0, _extendsDefault.default)({
                variant: "standard",
                as: rootProps.components.BaseFormControl
            }, baseFormControlProps, linkOperatorInputProps, {
                sx: (0, _extendsDefault.default)({
                    display: hasLinkOperatorColumn ? "flex" : "none",
                    visibility: showMultiFilterOperators ? "visible" : "hidden"
                }, baseFormControlProps.sx || {}, linkOperatorInputProps.sx || {}),
                className: (0, _clsxDefault.default)(classes.linkOperatorInput, baseFormControlProps.className, linkOperatorInputProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseSelect, (0, _extendsDefault.default)({
                    inputProps: {
                        "aria-label": apiRef.current.getLocaleText("filterPanelLinkOperator")
                    },
                    value: multiFilterOperator,
                    onChange: changeLinkOperator,
                    disabled: !!disableMultiFilterOperator || linkOperators.length === 1,
                    native: isBaseSelectNative
                }, (_rootProps$components3 = rootProps.componentsProps) == null ? void 0 : _rootProps$components3.baseSelect, {
                    children: linkOperators.map((linkOperator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                            value: linkOperator.toString(),
                            children: apiRef.current.getLocaleText(getLinkOperatorLocaleKey(linkOperator))
                        }, linkOperator.toString()))
                }))
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FilterFormColumnInput, (0, _extendsDefault.default)({
                variant: "standard",
                as: rootProps.components.BaseFormControl
            }, baseFormControlProps, columnInputProps, {
                className: (0, _clsxDefault.default)(classes.columnInput, baseFormControlProps.className, columnInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                        htmlFor: columnSelectId,
                        id: columnSelectLabelId,
                        children: apiRef.current.getLocaleText("filterPanelColumns")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseSelect, (0, _extendsDefault.default)({
                        labelId: columnSelectLabelId,
                        id: columnSelectId,
                        label: apiRef.current.getLocaleText("filterPanelColumns"),
                        value: item.columnField || "",
                        onChange: changeColumn,
                        native: isBaseSelectNative
                    }, (_rootProps$components4 = rootProps.componentsProps) == null ? void 0 : _rootProps$components4.baseSelect, {
                        children: sortedFilterableColumns.map((col)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                                value: col.field,
                                children: getColumnLabel(col)
                            }, col.field))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FilterFormOperatorInput, (0, _extendsDefault.default)({
                variant: "standard",
                as: rootProps.components.BaseFormControl
            }, baseFormControlProps, operatorInputProps, {
                className: (0, _clsxDefault.default)(classes.operatorInput, baseFormControlProps.className, operatorInputProps.className),
                ownerState: rootProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                        htmlFor: operatorSelectId,
                        id: operatorSelectLabelId,
                        children: apiRef.current.getLocaleText("filterPanelOperators")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseSelect, (0, _extendsDefault.default)({
                        labelId: operatorSelectLabelId,
                        label: apiRef.current.getLocaleText("filterPanelOperators"),
                        id: operatorSelectId,
                        value: item.operatorValue,
                        onChange: changeOperator,
                        native: isBaseSelectNative,
                        inputRef: filterSelectorRef
                    }, (_rootProps$components5 = rootProps.componentsProps) == null ? void 0 : _rootProps$components5.baseSelect, {
                        children: currentColumn == null ? void 0 : (_currentColumn$filter2 = currentColumn.filterOperators) == null ? void 0 : _currentColumn$filter2.map((operator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionComponent, {
                                value: operator.value,
                                children: operator.label || apiRef.current.getLocaleText(`filterOperator${(0, _utils.capitalize)(operator.value)}`)
                            }, operator.value))
                    }))
                ]
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterFormValueInput, (0, _extendsDefault.default)({
                variant: "standard",
                as: rootProps.components.BaseFormControl
            }, baseFormControlProps, valueInputPropsOther, {
                className: (0, _clsxDefault.default)(classes.valueInput, baseFormControlProps.className, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator != null && currentOperator.InputComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(currentOperator.InputComponent, (0, _extendsDefault.default)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef
                }, currentOperator.InputComponentProps, InputComponentProps)) : null
            }))
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material":"iknXc","@mui/material/IconButton":"6bnps","@mui/material/MenuItem":"dTC9Z","@mui/material/InputLabel":"i0KlN","@mui/material/FormControl":"6EcMm","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","clsx":"aaPMT","../../../hooks/features/columns/gridColumnsSelector":"aeHtc","../../../hooks/utils/useGridSelector":"96gNX","../../../models/gridFilterItem":"j8Skw","../../../hooks/utils/useGridApiContext":"cn3M8","../../../hooks/utils/useGridRootProps":"cdy2y","../../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4kuHz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFilterPanel", ()=>GridFilterPanel);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _gridFilterItem = require("../../../models/gridFilterItem");
var _useGridApiContext = require("../../../hooks/utils/useGridApiContext");
var _icons = require("../../icons");
var _gridPanelContent = require("../GridPanelContent");
var _gridPanelFooter = require("../GridPanelFooter");
var _gridPanelWrapper = require("../GridPanelWrapper");
var _gridFilterForm = require("./GridFilterForm");
var _useGridRootProps = require("../../../hooks/utils/useGridRootProps");
var _useGridSelector = require("../../../hooks/utils/useGridSelector");
var _gridFilterSelector = require("../../../hooks/features/filter/gridFilterSelector");
var _gridColumnsSelector = require("../../../hooks/features/columns/gridColumnsSelector");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "linkOperators",
    "columnsSort",
    "filterFormProps",
    "children"
];
const GridFilterPanel = /*#__PURE__*/ _react.forwardRef(function GridFilterPanel(props, ref) {
    var _rootProps$components;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const filterModel = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridFilterModelSelector));
    const filterableColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridFilterableColumnDefinitionsSelector));
    const lastFilterRef = _react.useRef(null);
    const { linkOperators = [
        (0, _gridFilterItem.GridLinkOperator).And,
        (0, _gridFilterItem.GridLinkOperator).Or
    ], columnsSort, filterFormProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const applyFilter = _react.useCallback((item)=>{
        apiRef.current.upsertFilterItem(item);
    }, [
        apiRef
    ]);
    const applyFilterLinkOperator = _react.useCallback((operator)=>{
        apiRef.current.setFilterLinkOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultItem = _react.useCallback(()=>{
        const firstColumnWithOperator = filterableColumns.find((colDef)=>{
            var _colDef$filterOperato;
            return (_colDef$filterOperato = colDef.filterOperators) == null ? void 0 : _colDef$filterOperato.length;
        });
        if (!firstColumnWithOperator) return null;
        return {
            columnField: firstColumnWithOperator.field,
            operatorValue: firstColumnWithOperator.filterOperators[0].value,
            id: Math.round(Math.random() * 1e5)
        };
    }, [
        filterableColumns
    ]);
    const items = _react.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        const defaultItem = getDefaultItem();
        return defaultItem ? [
            defaultItem
        ] : [];
    }, [
        filterModel.items,
        getDefaultItem
    ]);
    const hasMultipleFilters = items.length > 1;
    const addNewFilter = ()=>{
        const defaultItem = getDefaultItem();
        if (!defaultItem) return;
        apiRef.current.upsertFilterItems([
            ...items,
            defaultItem
        ]);
    };
    const deleteFilter = _react.useCallback((item)=>{
        const shouldCloseFilterPanel = items.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        items.length
    ]);
    _react.useEffect(()=>{
        if (linkOperators.length > 0 && filterModel.linkOperator && !linkOperators.includes(filterModel.linkOperator)) applyFilterLinkOperator(linkOperators[0]);
    }, [
        linkOperators,
        applyFilterLinkOperator,
        filterModel.linkOperator
    ]);
    _react.useEffect(()=>{
        if (items.length > 0) lastFilterRef.current.focus();
    }, [
        items.length
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridPanelWrapper.GridPanelWrapper), (0, _extendsDefault.default)({
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridPanelContent.GridPanelContent), {
                children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridFilterForm.GridFilterForm), (0, _extendsDefault.default)({
                        item: item,
                        applyFilterChanges: applyFilter,
                        deleteFilter: deleteFilter,
                        hasMultipleFilters: hasMultipleFilters,
                        showMultiFilterOperators: index > 0,
                        multiFilterOperator: filterModel.linkOperator,
                        disableMultiFilterOperator: index !== 1,
                        applyMultiFilterOperatorChanges: applyFilterLinkOperator,
                        focusElementRef: index === items.length - 1 ? lastFilterRef : null,
                        linkOperators: linkOperators,
                        columnsSort: columnsSort
                    }, filterFormProps), item.id == null ? index : item.id))
            }),
            !rootProps.disableMultipleColumnsFiltering && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridPanelFooter.GridPanelFooter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseButton, (0, _extendsDefault.default)({
                    onClick: addNewFilter,
                    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.GridAddIcon), {})
                }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseButton, {
                    children: apiRef.current.getLocaleText("filterPanelAddFilter")
                }))
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","../../../models/gridFilterItem":"j8Skw","../../../hooks/utils/useGridApiContext":"cn3M8","../../icons":"kOLOm","../GridPanelContent":"1ebDj","../GridPanelFooter":"2Ol2G","../GridPanelWrapper":"lIql3","./GridFilterForm":"iGlsX","../../../hooks/utils/useGridRootProps":"cdy2y","../../../hooks/utils/useGridSelector":"96gNX","../../../hooks/features/filter/gridFilterSelector":"lndlA","../../../hooks/features/columns/gridColumnsSelector":"aeHtc","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eYUmj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridCsvExportMenuItem", ()=>(0, _gridToolbarExport.GridCsvExportMenuItem));
parcelHelpers.export(exports, "GridPrintExportMenuItem", ()=>(0, _gridToolbarExport.GridPrintExportMenuItem));
parcelHelpers.export(exports, "GridToolbarExport", ()=>(0, _gridToolbarExport.GridToolbarExport));
var _gridToolbar = require("./GridToolbar");
parcelHelpers.exportAll(_gridToolbar, exports);
var _gridToolbarColumnsButton = require("./GridToolbarColumnsButton");
parcelHelpers.exportAll(_gridToolbarColumnsButton, exports);
var _gridToolbarDensitySelector = require("./GridToolbarDensitySelector");
parcelHelpers.exportAll(_gridToolbarDensitySelector, exports);
var _gridToolbarExport = require("./GridToolbarExport");
var _gridToolbarFilterButton = require("./GridToolbarFilterButton");
parcelHelpers.exportAll(_gridToolbarFilterButton, exports);
var _gridToolbarExportContainer = require("./GridToolbarExportContainer");
parcelHelpers.exportAll(_gridToolbarExportContainer, exports);
var _gridToolbarQuickFilter = require("./GridToolbarQuickFilter");
parcelHelpers.exportAll(_gridToolbarQuickFilter, exports);

},{"./GridToolbar":false,"./GridToolbarColumnsButton":"68CMk","./GridToolbarDensitySelector":false,"./GridToolbarExport":"8E9qo","./GridToolbarFilterButton":false,"./GridToolbarExportContainer":false,"./GridToolbarQuickFilter":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"68CMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridToolbarColumnsButton", ()=>GridToolbarColumnsButton);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _gridPreferencePanelSelector = require("../../hooks/features/preferencesPanel/gridPreferencePanelSelector");
var _gridPreferencePanelsValue = require("../../hooks/features/preferencesPanel/gridPreferencePanelsValue");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "onClick"
];
const GridToolbarColumnsButton = /*#__PURE__*/ _react.forwardRef(function GridToolbarColumnsButton(props, ref) {
    var _rootProps$components;
    const { onClick } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const { open, openedPanelValue } = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridPreferencePanelSelector.gridPreferencePanelStateSelector));
    const showColumns = (event)=>{
        if (open && openedPanelValue === (0, _gridPreferencePanelsValue.GridPreferencePanelsValue).columns) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, _gridPreferencePanelsValue.GridPreferencePanelsValue).columns);
        onClick == null || onClick(event);
    }; // Disable the button if the corresponding is disabled
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseButton, (0, _extendsDefault.default)({
        ref: ref,
        size: "small",
        "aria-label": apiRef.current.getLocaleText("toolbarColumnsLabel"),
        startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ColumnSelectorIcon, {})
    }, other, {
        onClick: showColumns
    }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseButton, {
        children: apiRef.current.getLocaleText("toolbarColumns")
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../../hooks/utils/useGridSelector":"96gNX","../../hooks/features/preferencesPanel/gridPreferencePanelSelector":"7GEzE","../../hooks/features/preferencesPanel/gridPreferencePanelsValue":"7YmlH","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8E9qo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridCsvExportMenuItem", ()=>GridCsvExportMenuItem);
parcelHelpers.export(exports, "GridPrintExportMenuItem", ()=>GridPrintExportMenuItem);
parcelHelpers.export(exports, "GridToolbarExport", ()=>GridToolbarExport);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridToolbarExportContainer = require("./GridToolbarExportContainer");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "hideMenu",
    "options"
], _excluded2 = [
    "hideMenu",
    "options"
], _excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
const GridCsvExportMenuItem = (props)=>{
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const { hideMenu, options } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), (0, _extendsDefault.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText("toolbarExportCSV")
    }));
};
const GridPrintExportMenuItem = (props)=>{
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const { hideMenu, options } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), (0, _extendsDefault.default)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu == null || hideMenu();
        }
    }, other, {
        children: apiRef.current.getLocaleText("toolbarExportPrint")
    }));
};
const GridToolbarExport = /*#__PURE__*/ _react.forwardRef(function GridToolbarExport(props, ref) {
    const { csvOptions = {}, printOptions = {}, excelOptions } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded3);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors("exportMenu", [], {
        excelOptions,
        csvOptions,
        printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridToolbarExportContainer.GridToolbarExportContainer), (0, _extendsDefault.default)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ _react.cloneElement(button.component, {
                key: index
            }))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","@mui/material/MenuItem":"dTC9Z","../../hooks/utils/useGridApiContext":"cn3M8","./GridToolbarExportContainer":"fyB8f","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fyB8f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridToolbarExportContainer", ()=>GridToolbarExportContainer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _keyboardUtils = require("../../utils/keyboardUtils");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _gridMenu = require("../menu/GridMenu");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "onClick"
];
const GridToolbarExportContainer = /*#__PURE__*/ _react.forwardRef(function GridToolbarExportContainer(props, ref) {
    var _rootProps$components;
    const { children, onClick } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const buttonId = (0, _utils.unstable_useId)();
    const menuId = (0, _utils.unstable_useId)();
    const [open, setOpen] = _react.useState(false);
    const buttonRef = _react.useRef(null);
    const handleRef = (0, _utils.useForkRef)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        onClick == null || onClick(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    const handleListKeyDown = (event)=>{
        if ((0, _keyboardUtils.isTabKey)(event.key)) event.preventDefault();
        if ((0, _keyboardUtils.isHideMenuKey)(event.key)) handleMenuClose();
    };
    const handleMenuClickAway = (event)=>{
        var _buttonRef$current;
        if (buttonRef.current === event.target || // if user clicked on the icon
        (_buttonRef$current = buttonRef.current) != null && _buttonRef$current.contains(event.target)) return;
        setOpen(false);
    };
    if (children == null) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.BaseButton, (0, _extendsDefault.default)({
                ref: handleRef,
                size: "small",
                startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.ExportIcon, {}),
                "aria-expanded": open ? "true" : undefined,
                "aria-label": apiRef.current.getLocaleText("toolbarExportLabel"),
                "aria-haspopup": "menu",
                "aria-labelledby": menuId,
                id: buttonId
            }, other, {
                onClick: handleMenuOpen
            }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.baseButton, {
                children: apiRef.current.getLocaleText("toolbarExport")
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridMenu.GridMenu), {
                open: open,
                target: buttonRef.current,
                onClickAway: handleMenuClickAway,
                position: "bottom-start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuListDefault.default), {
                    id: menuId,
                    className: (0, _gridClasses.gridClasses).menuList,
                    "aria-labelledby": buttonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: _react.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ _react.isValidElement(child)) return child;
                        return /*#__PURE__*/ _react.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","@mui/material/utils":"ziQFX","@mui/material/MenuList":"503OT","../../utils/keyboardUtils":"o7lWn","../../hooks/utils/useGridApiContext":"cn3M8","../menu/GridMenu":"c4xLf","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ObsZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridFooter", ()=>GridFooter);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGridSelector = require("../hooks/utils/useGridSelector");
var _gridRowsSelector = require("../hooks/features/rows/gridRowsSelector");
var _gridSelectionSelector = require("../hooks/features/selection/gridSelectionSelector");
var _gridFilterSelector = require("../hooks/features/filter/gridFilterSelector");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridRowCount = require("./GridRowCount");
var _gridSelectedRowCount = require("./GridSelectedRowCount");
var _gridFooterContainer = require("./containers/GridFooterContainer");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const GridFooter = /*#__PURE__*/ _react.forwardRef(function GridFooter(props, ref) {
    var _rootProps$components;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const totalTopLevelRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridTopLevelRowCountSelector));
    const selectedRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSelectionSelector.selectedGridRowsCountSelector));
    const visibleTopLevelRowCount = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridVisibleTopLevelRowCountSelector));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridSelectedRowCount.GridSelectedRowCount), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridRowCount.GridRowCount), {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    }) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.components.Pagination && /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Pagination, (0, _extendsDefault.default)({}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.pagination));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridFooterContainer.GridFooterContainer), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","../hooks/utils/useGridSelector":"96gNX","../hooks/features/rows/gridRowsSelector":"fCZaq","../hooks/features/selection/gridSelectionSelector":"XuHYC","../hooks/features/filter/gridFilterSelector":"lndlA","../hooks/utils/useGridApiContext":"cn3M8","./GridRowCount":"kYdP0","./GridSelectedRowCount":"h1Qu4","./containers/GridFooterContainer":"boKRI","../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kYdP0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRowCount", ()=>GridRowCount);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridClasses = require("../constants/gridClasses");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "rowCount"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridRowCountRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "RowCount",
    overridesResolver: (props, styles)=>styles.rowCount
})(({ theme })=>({
        alignItems: "center",
        display: "flex",
        margin: theme.spacing(0, 2)
    }));
const GridRowCount = /*#__PURE__*/ _react.forwardRef(function GridRowCount(props, ref) {
    const { className, rowCount, visibleRowCount } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const ownerState = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText("footerTotalVisibleRows")(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GridRowCountRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            apiRef.current.getLocaleText("footerTotalRows"),
            " ",
            text
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../hooks/utils/useGridApiContext":"cn3M8","../constants/gridClasses":"5U0ME","../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h1Qu4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridSelectedRowCount", ()=>GridSelectedRowCount);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridClasses = require("../constants/gridClasses");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "selectedRowCount"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "selectedRowCount"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridSelectedRowCountRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "SelectedRowCount",
    overridesResolver: (props, styles)=>styles.selectedRowCount
})(({ theme })=>({
        alignItems: "center",
        display: "flex",
        margin: theme.spacing(0, 2),
        visibility: "hidden",
        width: 0,
        height: 0,
        [theme.breakpoints.up("sm")]: {
            visibility: "visible",
            width: "auto",
            height: "auto"
        }
    }));
const GridSelectedRowCount = /*#__PURE__*/ _react.forwardRef(function GridSelectedRowCount(props, ref) {
    const { className, selectedRowCount } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const ownerState = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText("footerRowSelected")(selectedRowCount);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridSelectedRowCountRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: rowSelectedText
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../hooks/utils/useGridApiContext":"cn3M8","../constants/gridClasses":"5U0ME","../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6qkGi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridHeader", ()=>GridHeader);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const GridHeader = /*#__PURE__*/ _react.forwardRef(function GridHeader(props, ref) {
    var _rootProps$components, _rootProps$components2;
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.PreferencesPanel, (0, _extendsDefault.default)({}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.preferencesPanel)),
            rootProps.components.Toolbar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Toolbar, (0, _extendsDefault.default)({}, (_rootProps$components2 = rootProps.componentsProps) == null ? void 0 : _rootProps$components2.toolbar))
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGDBs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridLoadingOverlay", ()=>GridLoadingOverlay);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _gridOverlay = require("./containers/GridOverlay");
var _jsxRuntime = require("react/jsx-runtime");
const GridLoadingOverlay = /*#__PURE__*/ _react.forwardRef(function GridLoadingOverlay(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridOverlay.GridOverlay), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {})
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","@mui/material/CircularProgress":"fDo20","./containers/GridOverlay":"dAA19","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aSPpB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridNoRowsOverlay", ()=>GridNoRowsOverlay);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridOverlay = require("./containers/GridOverlay");
var _jsxRuntime = require("react/jsx-runtime");
const GridNoRowsOverlay = /*#__PURE__*/ _react.forwardRef(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const noRowsLabel = apiRef.current.getLocaleText("noRowsLabel");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridOverlay.GridOverlay), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: noRowsLabel
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","../hooks/utils/useGridApiContext":"cn3M8","./containers/GridOverlay":"dAA19","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4SChv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPagination", ()=>GridPagination);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _tablePagination = require("@mui/material/TablePagination");
var _tablePaginationDefault = parcelHelpers.interopDefault(_tablePagination);
var _styles = require("@mui/material/styles");
var _useGridSelector = require("../hooks/utils/useGridSelector");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _gridPaginationSelector = require("../hooks/features/pagination/gridPaginationSelector");
var _jsxRuntime = require("react/jsx-runtime");
const GridPaginationRoot = (0, _styles.styled)((0, _tablePaginationDefault.default))(({ theme })=>({
        [`& .${(0, _tablePagination.tablePaginationClasses).selectLabel}`]: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "block"
            }
        },
        [`& .${(0, _tablePagination.tablePaginationClasses).input}`]: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "inline-flex"
            }
        }
    }));
const GridPagination = /*#__PURE__*/ _react.forwardRef(function GridPagination(props, ref) {
    var _rootProps$rowsPerPag;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const paginationState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridPaginationSelector.gridPaginationSelector));
    const lastPage = _react.useMemo(()=>Math.floor(paginationState.rowCount / (paginationState.pageSize || 1)), [
        paginationState.rowCount,
        paginationState.pageSize
    ]);
    const handlePageSizeChange = _react.useCallback((event)=>{
        const newPageSize = Number(event.target.value);
        apiRef.current.setPageSize(newPageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = _react.useCallback((event, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    var _rootProps$pageSize, _rootProps$pageSize2;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridPaginationRoot, (0, _extendsDefault.default)({
        ref: ref,
        component: "div",
        count: paginationState.rowCount,
        page: paginationState.page <= lastPage ? paginationState.page : lastPage,
        rowsPerPageOptions: (_rootProps$rowsPerPag = rootProps.rowsPerPageOptions) != null && _rootProps$rowsPerPag.includes(paginationState.pageSize) ? rootProps.rowsPerPageOptions : [],
        rowsPerPage: paginationState.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange
    }, apiRef.current.getLocaleText("MuiTablePagination"), props));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/TablePagination":"65lFk","@mui/material/styles":"gNR9m","../hooks/utils/useGridSelector":"96gNX","../hooks/utils/useGridApiContext":"cn3M8","../hooks/utils/useGridRootProps":"cdy2y","../hooks/features/pagination/gridPaginationSelector":"e6xRD","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3dYSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRow", ()=>GridRow);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _gridEditRowModel = require("../models/gridEditRowModel");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridClasses = require("../constants/gridClasses");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _gridColumnsSelector = require("../hooks/features/columns/gridColumnsSelector");
var _useGridSelector = require("../hooks/utils/useGridSelector");
var _useGridVisibleRows = require("../hooks/utils/useGridVisibleRows");
var _domUtils = require("../utils/domUtils");
var _gridCheckboxSelectionColDef = require("../colDef/gridCheckboxSelectionColDef");
var _gridActionsColDef = require("../colDef/gridActionsColDef");
var _gridDetailPanelToggleField = require("../constants/gridDetailPanelToggleField");
var _gridSortingSelector = require("../hooks/features/sorting/gridSortingSelector");
var _gridRowsSelector = require("../hooks/features/rows/gridRowsSelector");
var _densitySelector = require("../hooks/features/density/densitySelector");
var _utils = require("../utils/utils");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "position",
    "rowHeight",
    "className",
    "visibleColumns",
    "renderedColumns",
    "containerWidth",
    "firstColumnToRender",
    "lastColumnToRender",
    "cellFocus",
    "cellTabIndex",
    "editRowsState",
    "isLastVisible",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave"
], _excluded2 = [
    "changeReason"
];
const useUtilityClasses = (ownerState)=>{
    const { editable, editing, selected, isLastVisible, rowHeight, classes } = ownerState;
    const slots = {
        root: [
            "row",
            selected && "selected",
            editable && "row--editable",
            editing && "row--editing",
            isLastVisible && "row--lastVisible",
            rowHeight === "auto" && "row--dynamicHeight"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const EmptyCell = ({ width })=>{
    if (!width) return null;
    const style = {
        width
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "MuiDataGrid-cell",
        style: style
    }); // TODO change to .MuiDataGrid-emptyCell or .MuiDataGrid-rowFiller
};
const GridRow = /*#__PURE__*/ _react.forwardRef(function GridRow(props, refProp) {
    var _apiRef$current$getRo;
    const { selected, rowId, row, index, style: styleProp, position, rowHeight, className, visibleColumns, renderedColumns, containerWidth, firstColumnToRender, cellFocus, cellTabIndex, editRowsState, isLastVisible = false, onClick, onDoubleClick, onMouseEnter, onMouseLeave } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const ref = _react.useRef(null);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const currentPage = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, rootProps);
    const columnsTotalWidth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnsTotalWidthSelector));
    const sortModel = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSortingSelector.gridSortModelSelector));
    const treeDepth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridRowTreeDepthSelector));
    const headerGroupingMaxDepth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityHeaderGroupingMaxDepthSelector));
    const handleRef = (0, _material.useForkRef)(ref, refProp);
    const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
    const { hasScrollX, hasScrollY } = (_apiRef$current$getRo = apiRef.current.getRootDimensions()) != null ? _apiRef$current$getRo : {
        hasScrollX: false,
        hasScrollY: false
    };
    const ownerState = {
        selected,
        isLastVisible,
        classes: rootProps.classes,
        editing: apiRef.current.getRowMode(rowId) === (0, _gridEditRowModel.GridRowModes).Edit,
        editable: rootProps.editMode === (0, _gridEditRowModel.GridEditModes).Row,
        rowHeight
    };
    const classes = useUtilityClasses(ownerState);
    _react.useLayoutEffect(()=>{
        if (rowHeight === "auto" && ref.current && typeof ResizeObserver === "undefined") // Fallback for IE
        apiRef.current.unstable_storeRowHeightMeasurement(rowId, ref.current.clientHeight, position);
    }, [
        apiRef,
        rowHeight,
        rowId,
        position
    ]);
    _react.useLayoutEffect(()=>{
        if (currentPage.range) {
            // The index prop is relative to the rows from all pages. As example, the index prop of the
            // first row is 5 if pageSize=5 and page=1. However, the index used by the virtualization
            // doesn't care about pagination and considers the rows from the current page only, so the
            // first row always has index=0. We need to subtract the index of the first row to make it
            // compatible with the index used by the virtualization.
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId); // pinned rows are not part of the visible rows
            if (rowIndex != null) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        const rootElement = ref.current;
        const hasFixedHeight = rowHeight !== "auto";
        if (!rootElement || hasFixedHeight || typeof ResizeObserver === "undefined") return undefined;
        const resizeObserver = new ResizeObserver((entries)=>{
            const [entry] = entries;
            const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
            apiRef.current.unstable_storeRowHeightMeasurement(rowId, height, position);
        });
        resizeObserver.observe(rootElement);
        return ()=>resizeObserver.disconnect();
    }, [
        apiRef,
        currentPage.range,
        index,
        rowHeight,
        rowId,
        position
    ]);
    const publish = _react.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            // The target is not an element when triggered by a Select inside the cell
            // See https://github.com/mui/material-ui/issues/10534
            if (event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return;
             // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = _react.useCallback((event)=>{
        const cell = (0, _domUtils.findParentElementFromClassName)(event.target, (0, _gridClasses.gridClasses).cell);
        const field = cell == null ? void 0 : cell.getAttribute("data-field"); // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, _gridCheckboxSelectionColDef.GRID_CHECKBOX_SELECTION_COL_DEF).field) return;
             // User opened a detail panel
            if (field === (0, _gridDetailPanelToggleField.GRID_DETAIL_PANEL_TOGGLE_FIELD)) return;
             // User reorders a row
            if (field === "__reorder__") return;
             // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, _gridEditRowModel.GridCellModes).Edit) return;
             // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column.type === (0, _gridActionsColDef.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        publish("rowClick", onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const getCell = _react.useCallback((column, cellProps)=>{
        var _rootProps$components;
        const cellParams = apiRef.current.getCellParams(rowId, column.field);
        const classNames = [];
        const disableDragEvents = rootProps.disableColumnReorder && column.disableReorder || !rootProps.rowReordering && !!sortModel.length && treeDepth > 1 && Object.keys(editRowsState).length > 0;
        if (column.cellClassName) classNames.push((0, _clsxDefault.default)(typeof column.cellClassName === "function" ? column.cellClassName(cellParams) : column.cellClassName));
        const editCellState = editRowsState[rowId] ? editRowsState[rowId][column.field] : null;
        let content = null;
        if (editCellState == null && column.renderCell) {
            var _rootProps$classes;
            content = column.renderCell((0, _extendsDefault.default)({}, cellParams, {
                api: apiRef.current
            })); // TODO move to GridCell
            classNames.push((0, _clsxDefault.default)((0, _gridClasses.gridClasses)["cell--withRenderer"], (_rootProps$classes = rootProps.classes) == null ? void 0 : _rootProps$classes["cell--withRenderer"]));
        }
        if (editCellState != null && column.renderEditCell) {
            var _rootProps$classes2;
            let updatedRow = row;
            if (apiRef.current.unstable_getRowWithUpdatedValues) // Only the new editing API has this method
            updatedRow = apiRef.current.unstable_getRowWithUpdatedValues(rowId, column.field);
            const editCellStateRest = (0, _objectWithoutPropertiesLooseDefault.default)(editCellState, _excluded2);
            const params = (0, _extendsDefault.default)({}, cellParams, {
                row: updatedRow
            }, editCellStateRest, {
                api: apiRef.current
            });
            content = column.renderEditCell(params); // TODO move to GridCell
            classNames.push((0, _clsxDefault.default)((0, _gridClasses.gridClasses)["cell--editing"], (_rootProps$classes2 = rootProps.classes) == null ? void 0 : _rootProps$classes2["cell--editing"]));
        }
        if (rootProps.getCellClassName) // TODO move to GridCell
        classNames.push(rootProps.getCellClassName(cellParams));
        const hasFocus = cellFocus !== null && cellFocus.id === rowId && cellFocus.field === column.field;
        const tabIndex = cellTabIndex !== null && cellTabIndex.id === rowId && cellTabIndex.field === column.field && cellParams.cellMode === "view" ? 0 : -1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Cell, (0, _extendsDefault.default)({
            value: cellParams.value,
            field: column.field,
            width: cellProps.width,
            rowId: rowId,
            height: rowHeight,
            showRightBorder: cellProps.showRightBorder,
            formattedValue: cellParams.formattedValue,
            align: column.align || "left",
            cellMode: cellParams.cellMode,
            colIndex: cellProps.indexRelativeToAllColumns,
            isEditable: cellParams.isEditable,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            className: (0, _clsxDefault.default)(classNames),
            colSpan: cellProps.colSpan,
            disableDragEvents: disableDragEvents
        }, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.cell, {
            children: content
        }), column.field);
    }, [
        apiRef,
        cellTabIndex,
        editRowsState,
        cellFocus,
        rootProps,
        row,
        rowHeight,
        rowId,
        treeDepth,
        sortModel.length
    ]);
    const sizes = apiRef.current.unstable_getRowInternalSizes(rowId);
    let minHeight = rowHeight;
    if (minHeight === "auto" && sizes) {
        let numberOfBaseSizes = 0;
        const maximumSize = Object.entries(sizes).reduce((acc, [key, size])=>{
            const isBaseHeight = /^base[A-Z]/.test(key);
            if (!isBaseHeight) return acc;
            numberOfBaseSizes += 1;
            if (size > acc) return size;
            return acc;
        }, 0);
        if (maximumSize > 0 && numberOfBaseSizes > 1) minHeight = maximumSize;
    }
    const style = (0, _extendsDefault.default)({}, styleProp, {
        maxHeight: rowHeight === "auto" ? "none" : rowHeight,
        // max-height doesn't support "auto"
        minHeight
    });
    if (sizes != null && sizes.spacingTop) {
        const property = rootProps.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
        style[property] = sizes.spacingTop;
    }
    if (sizes != null && sizes.spacingBottom) {
        const property = rootProps.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
        let propertyValue = style[property]; // avoid overriding existing value
        if (typeof propertyValue !== "number") propertyValue = parseInt(propertyValue || "0", 10);
        propertyValue += sizes.spacingBottom;
        style[property] = propertyValue;
    }
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors("rowClassName", [], rowId);
    if (typeof rootProps.getRowClassName === "function") {
        var _currentPage$range;
        const indexRelativeToCurrentPage = index - (((_currentPage$range = currentPage.range) == null ? void 0 : _currentPage$range.firstRowIndex) || 0);
        const rowParams = (0, _extendsDefault.default)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const randomNumber = (0, _utils.randomNumberBetween)(10000, 20, 80);
    const cells = [];
    for(let i = 0; i < renderedColumns.length; i += 1){
        const column = renderedColumns[i];
        const indexRelativeToAllColumns = firstColumnToRender + i;
        const isLastColumn = indexRelativeToAllColumns === visibleColumns.length - 1;
        const removeLastBorderRight = isLastColumn && hasScrollX && !hasScrollY;
        const showRightBorder = !isLastColumn ? rootProps.showCellRightBorder : !removeLastBorderRight && rootProps.disableExtendRowFullWidth;
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) {
            if (row) {
                const { colSpan, width } = cellColSpanInfo.cellProps;
                const cellProps = {
                    width,
                    colSpan,
                    showRightBorder,
                    indexRelativeToAllColumns
                };
                cells.push(getCell(column, cellProps));
            } else {
                const { width } = cellColSpanInfo.cellProps;
                const contentWidth = Math.round(randomNumber());
                cells.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.SkeletonCell, {
                    width: width,
                    contentWidth: contentWidth,
                    field: column.field,
                    align: column.align
                }, column.field));
            }
        }
    }
    const emptyCellWidth = containerWidth - columnsTotalWidth;
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish("rowDoubleClick", onDoubleClick),
        onMouseEnter: publish("rowMouseEnter", onMouseEnter),
        onMouseLeave: publish("rowMouseLeave", onMouseLeave)
    } : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _extendsDefault.default)({
        ref: handleRef,
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, _clsxDefault.default)(...rowClassNames, classes.root, className),
        "aria-rowindex": ariaRowIndex,
        "aria-selected": selected,
        style: style
    }, eventHandlers, other, {
        children: [
            cells,
            emptyCellWidth > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyCell, {
                width: emptyCellWidth
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","../models/gridEditRowModel":"5QORb","../hooks/utils/useGridApiContext":"cn3M8","../constants/gridClasses":"5U0ME","../hooks/utils/useGridRootProps":"cdy2y","../hooks/features/columns/gridColumnsSelector":"aeHtc","../hooks/utils/useGridSelector":"96gNX","../hooks/utils/useGridVisibleRows":"giBK8","../utils/domUtils":"s7LWz","../colDef/gridCheckboxSelectionColDef":"jNhez","../colDef/gridActionsColDef":"2wcgU","../constants/gridDetailPanelToggleField":"3vGWg","../hooks/features/sorting/gridSortingSelector":"1g9b1","../hooks/features/rows/gridRowsSelector":"fCZaq","../hooks/features/density/densitySelector":"chMex","../utils/utils":"lwlsg","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"giBK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisibleRows", ()=>getVisibleRows);
parcelHelpers.export(exports, "useGridVisibleRows", ()=>useGridVisibleRows);
var _react = require("react");
var _gridPaginationSelector = require("../features/pagination/gridPaginationSelector");
var _gridFilterSelector = require("../features/filter/gridFilterSelector");
const getVisibleRows = (apiRef, props)=>{
    let rows;
    let range;
    if (props.pagination && props.paginationMode === "client") {
        range = (0, _gridPaginationSelector.gridPaginationRowRangeSelector)(apiRef);
        rows = (0, _gridPaginationSelector.gridPaginatedVisibleSortedGridRowEntriesSelector)(apiRef);
    } else {
        rows = (0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector)(apiRef);
        if (rows.length === 0) range = null;
        else range = {
            firstRowIndex: 0,
            lastRowIndex: rows.length - 1
        };
    }
    return {
        rows,
        range
    };
};
const useGridVisibleRows = (apiRef, props)=>{
    const response = getVisibleRows(apiRef, props);
    return _react.useMemo(()=>({
            rows: response.rows,
            range: response.range
        }), [
        response.rows,
        response.range
    ]);
};

},{"react":"gVheC","../features/pagination/gridPaginationSelector":"e6xRD","../features/filter/gridFilterSelector":"lndlA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vGWg":[function(require,module,exports) {
// Can't import from pro package - hence duplication
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_DETAIL_PANEL_TOGGLE_FIELD", ()=>GRID_DETAIL_PANEL_TOGGLE_FIELD);
const GRID_DETAIL_PANEL_TOGGLE_FIELD = "__detail_panel_toggle__";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2cqFv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridScrollArea", ()=>GridScrollArea);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _useGridApiEventHandler = require("../hooks/utils/useGridApiEventHandler");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridClasses = require("../constants/gridClasses");
var _useGridRootProps = require("../hooks/utils/useGridRootProps");
var _densitySelector = require("../hooks/features/density/densitySelector");
var _useGridSelector = require("../hooks/utils/useGridSelector");
var _jsxRuntime = require("react/jsx-runtime");
const CLIFF = 1;
const SLOP = 1.5;
const useUtilityClasses = (ownerState)=>{
    const { scrollDirection, classes } = ownerState;
    const slots = {
        root: [
            "scrollArea",
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridScrollAreaRawRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ScrollArea",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, _gridClasses.gridClasses)["scrollArea--left"]}`]: styles["scrollArea--left"]
            },
            {
                [`&.${(0, _gridClasses.gridClasses)["scrollArea--right"]}`]: styles["scrollArea--right"]
            },
            styles.scrollArea
        ]
})(()=>({
        position: "absolute",
        top: 0,
        zIndex: 101,
        width: 20,
        bottom: 0,
        [`&.${(0, _gridClasses.gridClasses)["scrollArea--left"]}`]: {
            left: 0
        },
        [`&.${(0, _gridClasses.gridClasses)["scrollArea--right"]}`]: {
            right: 0
        }
    }));
function GridScrollAreaRaw(props) {
    const { scrollDirection } = props;
    const rootRef = _react.useRef(null);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const timeout = _react.useRef();
    const [dragging, setDragging] = _react.useState(false);
    const height = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityHeaderHeightSelector));
    const scrollPosition = _react.useRef({
        left: 0,
        top: 0
    });
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, rootProps, {
        scrollDirection
    });
    const classes = useUtilityClasses(ownerState);
    const handleScrolling = _react.useCallback((newScrollPosition)=>{
        scrollPosition.current = newScrollPosition;
    }, []);
    const handleDragOver = _react.useCallback((event)=>{
        let offset;
        if (scrollDirection === "left") offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === "right") offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error("MUI: Wrong drag direction");
        offset = (offset - CLIFF) * SLOP + CLIFF;
        clearTimeout(timeout.current); // Avoid freeze and inertia.
        timeout.current = setTimeout(()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    }, [
        scrollDirection,
        apiRef
    ]);
    _react.useEffect(()=>{
        return ()=>{
            clearTimeout(timeout.current);
        };
    }, []);
    const toggleDragging = _react.useCallback(()=>{
        setDragging((prevDragging)=>!prevDragging);
    }, []);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowsScroll", handleScrolling);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragStart", toggleDragging);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragEnd", toggleDragging);
    return dragging ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridScrollAreaRawRoot, {
        ref: rootRef,
        className: (0, _clsxDefault.default)(classes.root),
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: {
            height
        }
    }) : null;
}
const GridScrollArea = /*#__PURE__*/ _react.memo(GridScrollAreaRaw);

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","prop-types":"3KNJy","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../hooks/utils/useGridApiEventHandler":"iBXeM","../hooks/utils/useGridApiContext":"cn3M8","../constants/gridClasses":"5U0ME","../hooks/utils/useGridRootProps":"cdy2y","../hooks/features/density/densitySelector":"chMex","../hooks/utils/useGridSelector":"96gNX","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBXeM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Check https://github.com/facebook/react/issues/15317 to get more information
parcelHelpers.export(exports, "createUseGridApiEventHandler", ()=>createUseGridApiEventHandler);
parcelHelpers.export(exports, "unstable_resetCleanupTracking", ()=>unstable_resetCleanupTracking);
parcelHelpers.export(exports, "useGridApiEventHandler", ()=>useGridApiEventHandler);
parcelHelpers.export(exports, "useGridApiOptionHandler", ()=>useGridApiOptionHandler);
parcelHelpers.export(exports, "GridSignature", ()=>GridSignature);
var _react = require("react");
var _timerBasedCleanupTracking = require("../../utils/cleanupTracking/TimerBasedCleanupTracking");
var _finalizationRegistryBasedCleanupTracking = require("../../utils/cleanupTracking/FinalizationRegistryBasedCleanupTracking");
/**
 * Signal to the underlying logic what version of the public component API
 * of the data grid is exposed.
 */ var GridSignature;
(function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
})(GridSignature || (GridSignature = {}));
// We use class to make it easier to detect in heap snapshots by name
class ObjectToBeRetainedByReact {
} // Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
function createUseGridApiEventHandler(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useGridApiEventHandler(apiRef, eventName, handler, options) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== "undefined" ? new (0, _finalizationRegistryBasedCleanupTracking.FinalizationRegistryBasedCleanupTracking)() : new (0, _timerBasedCleanupTracking.TimerBasedCleanupTracking)();
        const [objectRetainedByReact] = _react.useState(new ObjectToBeRetainedByReact());
        const subscription = _react.useRef(null);
        const handlerRef = _react.useRef();
        handlerRef.current = handler;
        const cleanupTokenRef = _react.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) {
                    var _handlerRef$current;
                    (_handlerRef$current = handlerRef.current) == null || _handlerRef$current.call(handlerRef, params, event, details);
                }
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, ()=>{
                var _subscription$current;
                (_subscription$current = subscription.current) == null || _subscription$current.call(subscription);
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        _react.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event, details)=>{
                    if (!event.defaultMuiPrevented) {
                        var _handlerRef$current2;
                        (_handlerRef$current2 = handlerRef.current) == null || _handlerRef$current2.call(handlerRef, params, event, details);
                    }
                };
                subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                var _subscription$current2;
                (_subscription$current2 = subscription.current) == null || _subscription$current2.call(subscription);
                subscription.current = null;
            };
        }, [
            apiRef,
            eventName,
            options
        ]);
    };
}
const registryContainer = {
    registry: null
}; // TODO: move to @mui/x-data-grid/internals
const unstable_resetCleanupTracking = ()=>{
    var _registryContainer$re;
    (_registryContainer$re = registryContainer.registry) == null || _registryContainer$re.reset();
    registryContainer.registry = null;
};
const useGridApiEventHandler = createUseGridApiEventHandler(registryContainer);
const optionsSubscriberOptions = {
    isFirst: true
};
function useGridApiOptionHandler(apiRef, eventName, handler) {
    // Validate that only one per event name?
    useGridApiEventHandler(apiRef, eventName, handler, optionsSubscriberOptions);
}

},{"react":"gVheC","../../utils/cleanupTracking/TimerBasedCleanupTracking":"icUur","../../utils/cleanupTracking/FinalizationRegistryBasedCleanupTracking":"2ebyH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"icUur":[function(require,module,exports) {
// If no effect ran after this amount of time, we assume that the render was not committed by React
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimerBasedCleanupTracking", ()=>TimerBasedCleanupTracking);
const CLEANUP_TIMER_LOOP_MILLIS = 1000;
class TimerBasedCleanupTracking {
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === "function") unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
    constructor(timeout = CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ebyH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FinalizationRegistryBasedCleanupTracking", ()=>FinalizationRegistryBasedCleanupTracking);
class FinalizationRegistryBasedCleanupTracking {
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    reset() {}
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === "function") unsubscribe();
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"klaaX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridContextProvider", ()=>GridContextProvider);
var _react = require("react");
var _gridApiContext = require("../components/GridApiContext");
var _gridRootPropsContext = require("./GridRootPropsContext");
var _jsxRuntime = require("react/jsx-runtime");
const GridContextProvider = ({ apiRef, props, children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridRootPropsContext.GridRootPropsContext).Provider, {
        value: props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridApiContext.GridApiContext).Provider, {
            value: apiRef,
            children: children
        })
    });
};

},{"react":"gVheC","../components/GridApiContext":"7jUSD","./GridRootPropsContext":"gVCkj","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1JiBL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDataGridComponent", ()=>useDataGridComponent);
var _useGridInitialization = require("../hooks/core/useGridInitialization");
var _useGridInitializeState = require("../hooks/utils/useGridInitializeState");
var _useGridClipboard = require("../hooks/features/clipboard/useGridClipboard");
var _useGridColumnMenu = require("../hooks/features/columnMenu/useGridColumnMenu");
var _useGridColumns = require("../hooks/features/columns/useGridColumns");
var _useGridDensity = require("../hooks/features/density/useGridDensity");
var _useGridCsvExport = require("../hooks/features/export/useGridCsvExport");
var _useGridPrintExport = require("../hooks/features/export/useGridPrintExport");
var _useGridFilter = require("../hooks/features/filter/useGridFilter");
var _useGridFocus = require("../hooks/features/focus/useGridFocus");
var _useGridKeyboardNavigation = require("../hooks/features/keyboardNavigation/useGridKeyboardNavigation");
var _useGridPagination = require("../hooks/features/pagination/useGridPagination");
var _useGridPreferencesPanel = require("../hooks/features/preferencesPanel/useGridPreferencesPanel");
var _useGridEditingOld = require("../hooks/features/editRows/useGridEditing.old");
var _useGridEditingNew = require("../hooks/features/editRows/useGridEditing.new");
var _useGridRows = require("../hooks/features/rows/useGridRows");
var _useGridRowsPreProcessors = require("../hooks/features/rows/useGridRowsPreProcessors");
var _useGridParamsApi = require("../hooks/features/rows/useGridParamsApi");
var _useGridSelection = require("../hooks/features/selection/useGridSelection");
var _useGridSelectionPreProcessors = require("../hooks/features/selection/useGridSelectionPreProcessors");
var _useGridSorting = require("../hooks/features/sorting/useGridSorting");
var _useGridScroll = require("../hooks/features/scroll/useGridScroll");
var _useGridEvents = require("../hooks/features/events/useGridEvents");
var _useGridDimensions = require("../hooks/features/dimensions/useGridDimensions");
var _useGridRowsMeta = require("../hooks/features/rows/useGridRowsMeta");
var _useGridStatePersistence = require("../hooks/features/statePersistence/useGridStatePersistence");
var _useGridColumnSpanning = require("../hooks/features/columns/useGridColumnSpanning");
var _useGridColumnGrouping = require("../hooks/features/columnGrouping/useGridColumnGrouping");
var _useGridColumnGroupingPreProcessors = require("../hooks/features/columnGrouping/useGridColumnGroupingPreProcessors");
const useDataGridComponent = (props)=>{
    var _props$experimentalFe, _props$experimentalFe2;
    const apiRef = (0, _useGridInitialization.useGridInitialization)(undefined, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, _useGridColumnGroupingPreProcessors.useGridColumnGroupingPreProcessors)(apiRef, props);
    (0, _useGridSelectionPreProcessors.useGridSelectionPreProcessors)(apiRef, props);
    (0, _useGridRowsPreProcessors.useGridRowsPreProcessors)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, _useGridInitializeState.useGridInitializeState)((0, _useGridSelection.selectionStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridColumns.columnsStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridColumnGrouping.columnGroupsStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridRows.rowsStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.newEditingApi ? (0, _useGridEditingNew.editingStateInitializer) : (0, _useGridEditingOld.editingStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridFocus.focusStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridSorting.sortingStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridPreferencesPanel.preferencePanelStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridFilter.filterStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridDensity.densityStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridPagination.paginationStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridRowsMeta.rowsMetaStateInitializer), apiRef, props);
    (0, _useGridInitializeState.useGridInitializeState)((0, _useGridColumnMenu.columnMenuStateInitializer), apiRef, props);
    (0, _useGridKeyboardNavigation.useGridKeyboardNavigation)(apiRef, props);
    (0, _useGridSelection.useGridSelection)(apiRef, props);
    (0, _useGridColumns.useGridColumns)(apiRef, props);
    (0, _useGridRows.useGridRows)(apiRef, props);
    (0, _useGridParamsApi.useGridParamsApi)(apiRef);
    (0, _useGridColumnSpanning.useGridColumnSpanning)(apiRef);
    (0, _useGridColumnGrouping.useGridColumnGrouping)(apiRef, props);
    const useGridEditing = (_props$experimentalFe2 = props.experimentalFeatures) != null && _props$experimentalFe2.newEditingApi ? (0, _useGridEditingNew.useGridEditing) : (0, _useGridEditingOld.useGridEditing);
    useGridEditing(apiRef, props);
    (0, _useGridFocus.useGridFocus)(apiRef, props);
    (0, _useGridPreferencesPanel.useGridPreferencesPanel)(apiRef, props);
    (0, _useGridFilter.useGridFilter)(apiRef, props);
    (0, _useGridSorting.useGridSorting)(apiRef, props);
    (0, _useGridDensity.useGridDensity)(apiRef, props);
    (0, _useGridPagination.useGridPagination)(apiRef, props);
    (0, _useGridRowsMeta.useGridRowsMeta)(apiRef, props);
    (0, _useGridScroll.useGridScroll)(apiRef, props);
    (0, _useGridColumnMenu.useGridColumnMenu)(apiRef);
    (0, _useGridCsvExport.useGridCsvExport)(apiRef);
    (0, _useGridPrintExport.useGridPrintExport)(apiRef, props);
    (0, _useGridClipboard.useGridClipboard)(apiRef);
    (0, _useGridDimensions.useGridDimensions)(apiRef, props);
    (0, _useGridEvents.useGridEvents)(apiRef, props);
    (0, _useGridStatePersistence.useGridStatePersistence)(apiRef);
    return apiRef;
};

},{"../hooks/core/useGridInitialization":"5jAcG","../hooks/utils/useGridInitializeState":"eJbjG","../hooks/features/clipboard/useGridClipboard":"4CVGb","../hooks/features/columnMenu/useGridColumnMenu":"hl83J","../hooks/features/columns/useGridColumns":"2dlDf","../hooks/features/density/useGridDensity":"dVJqR","../hooks/features/export/useGridCsvExport":"dSIlB","../hooks/features/export/useGridPrintExport":"d9mgo","../hooks/features/filter/useGridFilter":"5AKIQ","../hooks/features/focus/useGridFocus":"3fHP5","../hooks/features/keyboardNavigation/useGridKeyboardNavigation":"1DOdW","../hooks/features/pagination/useGridPagination":"gMyjq","../hooks/features/preferencesPanel/useGridPreferencesPanel":"bNriG","../hooks/features/editRows/useGridEditing.old":"9ifJa","../hooks/features/editRows/useGridEditing.new":"rKilY","../hooks/features/rows/useGridRows":"ahZgW","../hooks/features/rows/useGridRowsPreProcessors":"lL7K1","../hooks/features/rows/useGridParamsApi":"fE2ne","../hooks/features/selection/useGridSelection":"96zCn","../hooks/features/selection/useGridSelectionPreProcessors":"65igq","../hooks/features/sorting/useGridSorting":"5S6nW","../hooks/features/scroll/useGridScroll":"49PeG","../hooks/features/events/useGridEvents":"7hi5I","../hooks/features/dimensions/useGridDimensions":"6db1m","../hooks/features/rows/useGridRowsMeta":"izdSA","../hooks/features/statePersistence/useGridStatePersistence":"hOzDJ","../hooks/features/columns/useGridColumnSpanning":"eno7h","../hooks/features/columnGrouping/useGridColumnGrouping":"rtuq4","../hooks/features/columnGrouping/useGridColumnGroupingPreProcessors":"eHTkg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5jAcG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridInitialization", ()=>useGridInitialization);
var _useGridLoggerFactory = require("./useGridLoggerFactory");
var _useGridApiInitialization = require("./useGridApiInitialization");
var _useGridErrorHandler = require("./useGridErrorHandler");
var _useGridLocaleText = require("./useGridLocaleText");
var _pipeProcessing = require("./pipeProcessing");
var _strategyProcessing = require("./strategyProcessing");
var _useGridStateInitialization = require("./useGridStateInitialization");
const useGridInitialization = (inputApiRef, props)=>{
    const apiRef = (0, _useGridApiInitialization.useGridApiInitialization)(inputApiRef, props);
    (0, _useGridLoggerFactory.useGridLoggerFactory)(apiRef, props);
    (0, _useGridErrorHandler.useGridErrorHandler)(apiRef, props);
    (0, _useGridStateInitialization.useGridStateInitialization)(apiRef, props);
    (0, _pipeProcessing.useGridPipeProcessing)(apiRef);
    (0, _strategyProcessing.useGridStrategyProcessing)(apiRef);
    (0, _useGridLocaleText.useGridLocaleText)(apiRef, props);
    return apiRef;
};

},{"./useGridLoggerFactory":"hKGv2","./useGridApiInitialization":"e7Kn1","./useGridErrorHandler":"evDoM","./useGridLocaleText":"k2rVa","./pipeProcessing":"jx1az","./strategyProcessing":"dzDtc","./useGridStateInitialization":"5kZbL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKGv2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridLoggerFactory", ()=>useGridLoggerFactory);
var _react = require("react");
var _utils = require("../../utils/utils");
const forceDebug = (0, _utils.localStorageAvailable)() && window.localStorage.getItem("DEBUG") != null;
const noop = ()=>{};
const noopLogger = {
    debug: noop,
    info: noop,
    warn: noop,
    error: noop
};
const LOG_LEVELS = [
    "debug",
    "info",
    "warn",
    "error"
];
function getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI: Log level ${logLevel} not recognized.`);
    const logger = LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = noop;
        return loggerObj;
    }, {});
    return logger;
}
const useGridLoggerFactory = (apiRef, props)=>{
    apiRef.current.getLogger = _react.useCallback((name)=>{
        if (forceDebug) return getAppender(name, "debug", props.logger);
        if (!props.logLevel) return noopLogger;
        return getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
};

},{"react":"gVheC","../../utils/utils":"lwlsg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e7Kn1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridApiInitialization", ()=>useGridApiInitialization);
var _react = require("react");
var _useGridApiMethod = require("../utils/useGridApiMethod");
var _useGridApiEventHandler = require("../utils/useGridApiEventHandler");
var _eventManager = require("../../utils/EventManager");
var _createSelector = require("../../utils/createSelector");
const isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
let globalId = 0;
function useGridApiInitialization(inputApiRef, props) {
    const apiRef = _react.useRef();
    if (!apiRef.current) {
        apiRef.current = {
            unstable_eventManager: new (0, _eventManager.EventManager)(),
            unstable_caches: {},
            state: {},
            instanceId: globalId
        };
        globalId += 1;
    }
    _react.useImperativeHandle(inputApiRef, ()=>apiRef.current, [
        apiRef
    ]);
    const publishEvent = _react.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if (isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, _useGridApiEventHandler.GridSignature).DataGridPro ? {
            api: apiRef.current
        } : {};
        apiRef.current.unstable_eventManager.emit(name, params, event, details);
    }, [
        apiRef,
        props.signature
    ]);
    const subscribeEvent = _react.useCallback((event, handler, options)=>{
        apiRef.current.unstable_eventManager.on(event, handler, options);
        const api = apiRef.current;
        return ()=>{
            api.unstable_eventManager.removeListener(event, handler);
        };
    }, [
        apiRef
    ]);
    const showError = _react.useCallback((args)=>{
        apiRef.current.publishEvent("componentError", args);
    }, [
        apiRef
    ]);
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, {
        subscribeEvent,
        publishEvent,
        showError
    }, "GridCoreApi");
    _react.useEffect(()=>{
        const api = apiRef.current;
        return ()=>{
            (0, _createSelector.unstable_resetCreateSelectorCache)(api.instanceId);
            api.publishEvent("unmount");
        };
    }, [
        apiRef
    ]);
    return apiRef;
}

},{"react":"gVheC","../utils/useGridApiMethod":"5EPiD","../utils/useGridApiEventHandler":"iBXeM","../../utils/EventManager":"cgzq9","../../utils/createSelector":"4xqAC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5EPiD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridApiMethod", ()=>useGridApiMethod);
var _react = require("react");
function useGridApiMethod(apiRef, apiMethods, // eslint-disable-next-line @typescript-eslint/no-unused-vars
apiName) {
    const apiMethodsRef = _react.useRef(apiMethods);
    const [apiMethodsNames] = _react.useState(Object.keys(apiMethods));
    const installMethods = _react.useCallback(()=>{
        if (!apiRef.current) return;
        apiMethodsNames.forEach((methodName)=>{
            if (!apiRef.current.hasOwnProperty(methodName)) apiRef.current[methodName] = (...args)=>apiMethodsRef.current[methodName](...args);
        });
    }, [
        apiMethodsNames,
        apiRef
    ]);
    _react.useEffect(()=>{
        apiMethodsRef.current = apiMethods;
    }, [
        apiMethods
    ]);
    _react.useEffect(()=>{
        installMethods();
    }, [
        installMethods
    ]);
    installMethods();
}

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cgzq9":[function(require,module,exports) {
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventManager", ()=>EventManager);
class EventManager {
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
    constructor(){
        this.maxListeners = 10;
        this.warnOnce = false;
        this.events = {};
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"evDoM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridErrorHandler", ()=>useGridErrorHandler);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiEventHandler = require("../utils/useGridApiEventHandler");
function useGridErrorHandler(apiRef, props) {
    const handleError = _react.useCallback((args)=>{
        // We are handling error here, to set up the handler as early as possible and be able to catch error thrown at init time.
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                error: args
            }));
    }, [
        apiRef
    ]);
    _react.useEffect(()=>{
        if (props.error) handleError({
            error: props.error
        });
        else handleError(null);
    }, [
        handleError,
        props.error
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "componentError", handleError);
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../utils/useGridApiEventHandler":"iBXeM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k2rVa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridLocaleText", ()=>useGridLocaleText);
var _react = require("react");
const useGridLocaleText = (apiRef, props)=>{
    const getLocaleText = _react.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.getLocaleText = getLocaleText;
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jx1az":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridPipeProcessingApi = require("./gridPipeProcessingApi");
parcelHelpers.exportAll(_gridPipeProcessingApi, exports);
var _useGridPipeProcessing = require("./useGridPipeProcessing");
parcelHelpers.exportAll(_useGridPipeProcessing, exports);
var _useGridRegisterPipeProcessor = require("./useGridRegisterPipeProcessor");
parcelHelpers.exportAll(_useGridRegisterPipeProcessor, exports);
var _useGridRegisterPipeApplier = require("./useGridRegisterPipeApplier");
parcelHelpers.exportAll(_useGridRegisterPipeApplier, exports);

},{"./gridPipeProcessingApi":false,"./useGridPipeProcessing":"a2bhb","./useGridRegisterPipeProcessor":"4BudO","./useGridRegisterPipeApplier":"iakME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a2bhb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridPipeProcessing", ()=>useGridPipeProcessing);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _toPropertyKey = require("@babel/runtime/helpers/esm/toPropertyKey");
var _toPropertyKeyDefault = parcelHelpers.interopDefault(_toPropertyKey);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
const useGridPipeProcessing = (apiRef)=>{
    const processorsCache = _react.useRef({});
    const runAppliers = _react.useCallback((groupCache)=>{
        if (!groupCache) return;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
    }, []);
    const registerPipeProcessor = _react.useCallback((group, id, processor)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        const groupCache = processorsCache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            runAppliers(groupCache);
        }
        return ()=>{
            processorsCache.current[group].processors.set(id, null);
        };
    }, [
        runAppliers
    ]);
    const registerPipeApplier = _react.useCallback((group, id, applier)=>{
        if (!processorsCache.current[group]) processorsCache.current[group] = {
            processors: new Map(),
            appliers: {}
        };
        processorsCache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = processorsCache.current[group].appliers, otherAppliers = (0, _objectWithoutPropertiesLooseDefault.default)(_appliers, [
                id
            ].map((0, _toPropertyKeyDefault.default)));
            processorsCache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = _react.useCallback((group)=>{
        const groupCache = processorsCache.current[group];
        runAppliers(groupCache);
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = _react.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!processorsCache.current[group]) return value;
        const preProcessors = Array.from(processorsCache.current[group].processors.values());
        return preProcessors.reduce((acc, preProcessor)=>{
            if (!preProcessor) return acc;
            return preProcessor(acc, context);
        }, value);
    }, []);
    const preProcessingApi = {
        unstable_registerPipeProcessor: registerPipeProcessor,
        unstable_registerPipeApplier: registerPipeApplier,
        unstable_requestPipeProcessorsApplication: requestPipeProcessorsApplication,
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, preProcessingApi, "GridPipeProcessingApi");
};

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/toPropertyKey":"4TadU","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4BudO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRegisterPipeProcessor", ()=>useGridRegisterPipeProcessor);
var _react = require("react");
var _useFirstRender = require("../../utils/useFirstRender");
const useGridRegisterPipeProcessor = (apiRef, group, callback)=>{
    const cleanup = _react.useRef();
    const id = _react.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = _react.useCallback(()=>{
        cleanup.current = apiRef.current.unstable_registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, _useFirstRender.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};

},{"react":"gVheC","../../utils/useFirstRender":"3zp8V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3zp8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFirstRender", ()=>useFirstRender);
var _react = require("react");
const useFirstRender = (callback)=>{
    const isFirstRender = _react.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iakME":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRegisterPipeApplier", ()=>useGridRegisterPipeApplier);
var _react = require("react");
var _useFirstRender = require("../../utils/useFirstRender");
const useGridRegisterPipeApplier = (apiRef, group, callback)=>{
    const cleanup = _react.useRef();
    const id = _react.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = _react.useCallback(()=>{
        cleanup.current = apiRef.current.unstable_registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, _useFirstRender.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};

},{"react":"gVheC","../../utils/useFirstRender":"3zp8V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dzDtc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridStrategyProcessingApi = require("./gridStrategyProcessingApi");
parcelHelpers.exportAll(_gridStrategyProcessingApi, exports);
var _useGridRegisterStrategyProcessor = require("./useGridRegisterStrategyProcessor");
parcelHelpers.exportAll(_useGridRegisterStrategyProcessor, exports);
var _useGridStrategyProcessing = require("./useGridStrategyProcessing");
parcelHelpers.exportAll(_useGridStrategyProcessing, exports);

},{"./gridStrategyProcessingApi":false,"./useGridRegisterStrategyProcessor":"gMeu0","./useGridStrategyProcessing":"hGl80","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMeu0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRegisterStrategyProcessor", ()=>useGridRegisterStrategyProcessor);
var _react = require("react");
var _useFirstRender = require("../../utils/useFirstRender");
const useGridRegisterStrategyProcessor = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = _react.useCallback(()=>{
        apiRef.current.unstable_registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, _useFirstRender.useFirstRender)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};

},{"react":"gVheC","../../utils/useFirstRender":"3zp8V","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hGl80":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_DEFAULT_STRATEGY", ()=>GRID_DEFAULT_STRATEGY);
parcelHelpers.export(exports, "GRID_STRATEGIES_PROCESSORS", ()=>GRID_STRATEGIES_PROCESSORS);
parcelHelpers.export(exports, "useGridStrategyProcessing", ()=>useGridStrategyProcessing);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _toPropertyKey = require("@babel/runtime/helpers/esm/toPropertyKey");
var _toPropertyKeyDefault = parcelHelpers.interopDefault(_toPropertyKey);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
const GRID_DEFAULT_STRATEGY = "none";
const GRID_STRATEGIES_PROCESSORS = {
    rowTreeCreation: "rowTree",
    filtering: "rowTree",
    sorting: "rowTree"
};
const useGridStrategyProcessing = (apiRef)=>{
    const availableStrategies = _react.useRef(new Map());
    const strategiesCache = _react.useRef({});
    const registerStrategyProcessor = _react.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
                strategyName
            ].map((0, _toPropertyKeyDefault.default)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.unstable_getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName])) apiRef.current.publishEvent("activeStrategyProcessorChange", processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = _react.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.unstable_getActiveStrategy(GRID_STRATEGIES_PROCESSORS[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = _react.useCallback((strategyGroup)=>{
        var _availableStrategyEnt;
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return (_availableStrategyEnt = availableStrategyEntry == null ? void 0 : availableStrategyEntry[0]) != null ? _availableStrategyEnt : GRID_DEFAULT_STRATEGY;
    }, []);
    const setStrategyAvailability = _react.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable
        });
        apiRef.current.publishEvent("strategyAvailabilityChange");
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        unstable_registerStrategyProcessor: registerStrategyProcessor,
        unstable_applyStrategyProcessor: applyStrategyProcessor,
        unstable_getActiveStrategy: getActiveStrategy,
        unstable_setStrategyAvailability: setStrategyAvailability
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, strategyProcessingApi, "GridStrategyProcessing");
};

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/toPropertyKey":"4TadU","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5kZbL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridStateInitialization", ()=>useGridStateInitialization);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useGridApiEventHandler = require("../utils/useGridApiEventHandler");
var _utils = require("../utils");
var _utils1 = require("../../utils/utils");
const _excluded = [
    "stateId"
];
const useGridStateInitialization = (apiRef, props)=>{
    const controlStateMapRef = _react.useRef({});
    const [, rawForceUpdate] = _react.useState();
    const registerControlState = _react.useCallback((controlStateItem)=>{
        const { stateId } = controlStateItem, others = (0, _objectWithoutPropertiesLooseDefault.default)(controlStateItem, _excluded);
        controlStateMapRef.current[stateId] = (0, _extendsDefault.default)({}, others, {
            stateId
        });
    }, []);
    const setState = _react.useCallback((state, reason)=>{
        let newState;
        if ((0, _utils1.isFunction)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        let ignoreSetState = false; // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef.current.state, apiRef.current.instanceId);
            const newSubState = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            }); // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(", ")} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            if (apiRef.current.publishEvent) apiRef.current.publishEvent("stateChange", newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId, hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(newState, apiRef.current.instanceId);
            if (controlState.propOnChange && hasPropChanged) {
                const details = props.signature === (0, _useGridApiEventHandler.GridSignature).DataGridPro ? {
                    api: apiRef.current,
                    reason
                } : {
                    reason
                };
                controlState.propOnChange(model, details);
            }
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef,
        props.signature
    ]);
    const updateControlState = _react.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, _extendsDefault.default)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const forceUpdate = _react.useCallback(()=>rawForceUpdate(()=>apiRef.current.state), [
        apiRef
    ]);
    const stateApi = {
        setState,
        forceUpdate,
        unstable_updateControlState: updateControlState,
        unstable_registerControlState: registerControlState
    };
    (0, _utils.useGridApiMethod)(apiRef, stateApi, "GridStateApi");
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../utils/useGridApiEventHandler":"iBXeM","../utils":"43GNT","../../utils/utils":"lwlsg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"43GNT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useGridApi = require("./useGridApi");
parcelHelpers.exportAll(_useGridApi, exports);
var _useGridApiEventHandler = require("./useGridApiEventHandler");
parcelHelpers.exportAll(_useGridApiEventHandler, exports);
var _useGridApiMethod = require("./useGridApiMethod");
parcelHelpers.exportAll(_useGridApiMethod, exports);
var _useGridLogger = require("./useGridLogger");
parcelHelpers.exportAll(_useGridLogger, exports);
var _useGridScrollFn = require("./useGridScrollFn");
parcelHelpers.exportAll(_useGridScrollFn, exports);
var _useGridSelector = require("./useGridSelector");
parcelHelpers.exportAll(_useGridSelector, exports);
var _useGridState = require("./useGridState");
parcelHelpers.exportAll(_useGridState, exports);
var _useGridNativeEventListener = require("./useGridNativeEventListener");
parcelHelpers.exportAll(_useGridNativeEventListener, exports);
var _useFirstRender = require("./useFirstRender");
parcelHelpers.exportAll(_useFirstRender, exports);

},{"./useGridApi":false,"./useGridApiEventHandler":"iBXeM","./useGridApiMethod":"5EPiD","./useGridLogger":"6dTTN","./useGridScrollFn":false,"./useGridSelector":"96gNX","./useGridState":false,"./useGridNativeEventListener":"5Df7k","./useFirstRender":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Df7k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridNativeEventListener", ()=>useGridNativeEventListener);
var _react = require("react");
var _utils = require("../../utils/utils");
var _useGridLogger = require("./useGridLogger");
const useGridNativeEventListener = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useNativeEventListener");
    const [added, setAdded] = _react.useState(false);
    const handlerRef = _react.useRef(handler);
    const wrapHandler = _react.useCallback((event)=>{
        return handlerRef.current && handlerRef.current(event);
    }, []);
    _react.useEffect(()=>{
        handlerRef.current = handler;
    }, [
        handler
    ]);
    _react.useEffect(()=>{
        let targetElement;
        if ((0, _utils.isFunction)(ref)) targetElement = ref();
        else targetElement = ref && ref.current ? ref.current : null;
        if (targetElement && eventName && !added) {
            logger.debug(`Binding native ${eventName} event`);
            targetElement.addEventListener(eventName, wrapHandler, options);
            const boundElem = targetElement;
            setAdded(true);
            const unsubscribe = ()=>{
                logger.debug(`Clearing native ${eventName} event`);
                boundElem.removeEventListener(eventName, wrapHandler, options);
            };
            apiRef.current.subscribeEvent("unmount", unsubscribe);
        }
    }, [
        ref,
        wrapHandler,
        eventName,
        added,
        logger,
        options,
        apiRef
    ]);
};

},{"react":"gVheC","../../utils/utils":"lwlsg","./useGridLogger":"6dTTN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eJbjG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridInitializeState", ()=>useGridInitializeState);
var _react = require("react");
const useGridInitializeState = (initializer, apiRef, props)=>{
    const isInitialized = _react.useRef(false);
    if (!isInitialized.current) {
        apiRef.current.state = initializer(apiRef.current.state, props, apiRef);
        isInitialized.current = true;
    }
};

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4CVGb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridClipboard", ()=>useGridClipboard);
var _react = require("react");
var _utils = require("../../utils");
function writeToClipboardPolyfill(data) {
    const span = document.createElement("span");
    span.style.whiteSpace = "pre";
    span.style.userSelect = "all";
    span.style.opacity = "0px";
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand("copy");
    } finally{
        document.body.removeChild(span);
    }
}
function hasNativeSelection(element) {
    var _window$getSelection;
    if (((_window$getSelection = window.getSelection()) == null ? void 0 : _window$getSelection.toString()) !== "") return true;
    if (!element) return false;
    if ((element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const useGridClipboard = (apiRef)=>{
    const copySelectedRowsToClipboard = _react.useCallback((includeHeaders = false)=>{
        if (apiRef.current.getSelectedRows().size === 0) return;
        const data = apiRef.current.getDataAsCsv({
            includeHeaders,
            delimiter: "	"
        });
        if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
            writeToClipboardPolyfill(data);
        });
        else writeToClipboardPolyfill(data);
    }, [
        apiRef
    ]);
    const handleKeydown = _react.useCallback((event)=>{
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey; // event.key === 'c' is not enough as alt+c can lead to ©, ç, or other characters on macOS.
        // event.code === 'KeyC' is not enough as event.code assume a QWERTY keyboard layout which would
        // be wrong with a Dvorak keyboard (as if pressing J).
        if (String.fromCharCode(event.keyCode) !== "C" || !isModifierKeyPressed) return;
         // Do nothing if there's a native selection
        if (hasNativeSelection(event.target)) return;
        apiRef.current.unstable_copySelectedRowsToClipboard(event.altKey);
    }, [
        apiRef
    ]);
    (0, _utils.useGridNativeEventListener)(apiRef, apiRef.current.rootElementRef, "keydown", handleKeydown);
    const clipboardApi = {
        unstable_copySelectedRowsToClipboard: copySelectedRowsToClipboard
    };
    (0, _utils.useGridApiMethod)(apiRef, clipboardApi, "GridClipboardApi");
};

},{"react":"gVheC","../../utils":"43GNT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hl83J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columnMenuStateInitializer", ()=>columnMenuStateInitializer);
parcelHelpers.export(exports, "useGridColumnMenu", ()=>useGridColumnMenu);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("../../utils");
var _columnMenuSelector = require("./columnMenuSelector");
var _gridClasses = require("../../../constants/gridClasses");
const columnMenuStateInitializer = (state)=>(0, _extendsDefault.default)({}, state, {
        columnMenu: {
            open: false
        }
    });
const useGridColumnMenu = (apiRef)=>{
    const logger = (0, _utils.useGridLogger)(apiRef, "useGridColumnMenu");
    /**
   * API METHODS
   */ const showColumnMenu = _react.useCallback((field)=>{
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (state.columnMenu.open && state.columnMenu.field === field) return state;
            logger.debug("Opening Column Menu");
            return (0, _extendsDefault.default)({}, state, {
                columnMenu: {
                    open: true,
                    field
                }
            });
        });
        if (shouldUpdate) {
            apiRef.current.hidePreferences();
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = _react.useCallback(()=>{
        const shouldUpdate = apiRef.current.setState((state)=>{
            if (!state.columnMenu.open && state.columnMenu.field === undefined) return state;
            logger.debug("Hiding Column Menu");
            return (0, _extendsDefault.default)({}, state, {
                columnMenu: (0, _extendsDefault.default)({}, state.columnMenu, {
                    open: false,
                    field: undefined
                })
            });
        });
        if (shouldUpdate) apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = _react.useCallback((field)=>{
        logger.debug("Toggle Column Menu");
        const columnMenu = (0, _columnMenuSelector.gridColumnMenuSelector)(apiRef.current.state);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu,
        hideColumnMenu,
        toggleColumnMenu
    };
    (0, _utils.useGridApiMethod)(apiRef, columnMenuApi, "GridColumnMenuApi");
    /**
   * EVENTS
   */ const handleColumnHeaderFocus = _react.useCallback((params, event)=>{
        // Check if the column menu button received focus
        if (!event.target.classList.contains((0, _gridClasses.gridClasses).menuIconButton)) return;
         // Check if there's an element which lost focus
        if (!event.relatedTarget) return;
         // `true` if the focus was on the column menu itself, not on any item
        const columnMenuLostFocus = event.relatedTarget.classList.contains((0, _gridClasses.gridClasses).menuList); // `true` if the focus was on an item from the column menu
        const columnMenuItemLostFocus = event.relatedTarget.getAttribute("role") === "menuitem";
        if (columnMenuLostFocus || columnMenuItemLostFocus) apiRef.current.setColumnHeaderFocus(params.field);
    }, [
        apiRef
    ]);
    (0, _utils.useGridApiEventHandler)(apiRef, "columnResizeStart", hideColumnMenu);
    (0, _utils.useGridApiEventHandler)(apiRef, "columnHeaderFocus", handleColumnHeaderFocus);
    (0, _utils.useGridApiEventHandler)(apiRef, "virtualScrollerWheel", apiRef.current.hideColumnMenu);
    (0, _utils.useGridApiEventHandler)(apiRef, "virtualScrollerTouchMove", apiRef.current.hideColumnMenu);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils":"43GNT","./columnMenuSelector":"62HSa","../../../constants/gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"62HSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridColumnMenuSelector", ()=>gridColumnMenuSelector);
const gridColumnMenuSelector = (state)=>state.columnMenu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2dlDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columnsStateInitializer", ()=>columnsStateInitializer);
/**
 * @requires useGridParamsApi (method)
 * @requires useGridDimensions (method, event) - can be after
 * TODO: Impossible priority - useGridParamsApi also needs to be after useGridColumns
 */ parcelHelpers.export(exports, "useGridColumns", ()=>useGridColumns);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridColumnsSelector = require("./gridColumnsSelector");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridColumnsUtils = require("./gridColumnsUtils");
var _preferencesPanel = require("../preferencesPanel");
var _jsxRuntime = require("react/jsx-runtime");
const columnsStateInitializer = (state, props, apiRef)=>{
    var _props$initialState, _props$initialState$c, _props$initialState2, _ref, _props$columnVisibili, _props$initialState3, _props$initialState3$;
    const isUsingColumnVisibilityModel = !!props.columnVisibilityModel || !!((_props$initialState = props.initialState) != null && (_props$initialState$c = _props$initialState.columns) != null && _props$initialState$c.columnVisibilityModel);
    apiRef.current.unstable_caches.columns = {
        isUsingColumnVisibilityModel
    };
    const columnsTypes = (0, _gridColumnsUtils.computeColumnTypes)(props.columnTypes);
    const columnsState = (0, _gridColumnsUtils.createColumnsState)({
        apiRef,
        columnTypes: columnsTypes,
        columnsToUpsert: props.columns,
        initialState: (_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.columns,
        shouldRegenColumnVisibilityModelFromColumns: !isUsingColumnVisibilityModel,
        currentColumnVisibilityModel: (_ref = (_props$columnVisibili = props.columnVisibilityModel) != null ? _props$columnVisibili : (_props$initialState3 = props.initialState) == null ? void 0 : (_props$initialState3$ = _props$initialState3.columns) == null ? void 0 : _props$initialState3$.columnVisibilityModel) != null ? _ref : {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, _extendsDefault.default)({}, state, {
        columns: columnsState
    });
};
function useGridColumns(apiRef, props) {
    var _props$initialState5, _props$componentsProp2;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridColumns");
    const columnTypes = _react.useMemo(()=>(0, _gridColumnsUtils.computeColumnTypes)(props.columnTypes), [
        props.columnTypes
    ]);
    const previousColumnsProp = _react.useRef(props.columns);
    const previousColumnTypesProp = _react.useRef(columnTypes);
    apiRef.current.unstable_registerControlState({
        stateId: "visibleColumns",
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, _gridColumnsSelector.gridColumnVisibilityModelSelector),
        changeEvent: "columnVisibilityModelChange"
    });
    const setGridColumnsState = _react.useCallback((columnsState)=>{
        logger.debug("Updating columns state.");
        apiRef.current.setState((0, _gridColumnsUtils.mergeColumnsState)(columnsState));
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent("columnsChange", columnsState.all);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = _react.useCallback((field)=>(0, _gridColumnsSelector.gridColumnLookupSelector)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = _react.useCallback(()=>(0, _gridColumnsSelector.gridColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = _react.useCallback(()=>(0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef), [
        apiRef
    ]);
    const getColumnsMeta = _react.useCallback(()=>(0, _gridColumnsSelector.gridColumnsMetaSelector)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = _react.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef) : (0, _gridColumnsSelector.gridColumnDefinitionsSelector)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = _react.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, _gridColumnsSelector.gridColumnPositionsSelector)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = _react.useCallback((model)=>{
        const currentModel = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                    columns: (0, _gridColumnsUtils.createColumnsState)({
                        apiRef,
                        columnTypes,
                        columnsToUpsert: [],
                        initialState: undefined,
                        shouldRegenColumnVisibilityModelFromColumns: false,
                        currentColumnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        columnTypes
    ]);
    const updateColumns = _react.useCallback((columns)=>{
        const columnsState = (0, _gridColumnsUtils.createColumnsState)({
            apiRef,
            columnTypes,
            columnsToUpsert: columns,
            initialState: undefined,
            shouldRegenColumnVisibilityModelFromColumns: true,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState,
        columnTypes
    ]);
    const updateColumn = _react.useCallback((column)=>apiRef.current.updateColumns([
            column
        ]), [
        apiRef
    ]);
    const setColumnVisibility = _react.useCallback((field, isVisible)=>{
        // We keep updating the `hide` option of `GridColDef` when not controlling the model to avoid any breaking change.
        // `updateColumns` take care of updating the model itself if needs be.
        // TODO v6: stop using the `hide` field even when the model is not defined
        if (apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel) {
            var _columnVisibilityMode;
            const columnVisibilityModel = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef);
            const isCurrentlyVisible = (_columnVisibilityMode = columnVisibilityModel[field]) != null ? _columnVisibilityMode : true;
            if (isVisible !== isCurrentlyVisible) {
                const newModel = (0, _extendsDefault.default)({}, columnVisibilityModel, {
                    [field]: isVisible
                });
                apiRef.current.setColumnVisibilityModel(newModel);
            }
        } else {
            const column = apiRef.current.getColumn(field);
            const newColumn = (0, _extendsDefault.default)({}, column, {
                hide: !isVisible
            });
            apiRef.current.updateColumns([
                newColumn
            ]);
            const params = {
                field,
                colDef: newColumn,
                isVisible
            };
            apiRef.current.publishEvent("columnVisibilityChange", params);
        }
    }, [
        apiRef
    ]);
    const setColumnIndex = _react.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, _gridColumnsSelector.gridColumnFieldsSelector)(apiRef);
        const oldIndexPosition = allColumns.findIndex((col)=>col === field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, _extendsDefault.default)({}, (0, _gridColumnsSelector.gridColumnsSelector)(apiRef.current.state), {
            all: updatedColumns
        }));
        const params = {
            field,
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: apiRef.current.getColumn(field),
            targetIndex: targetIndexPosition,
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent("columnOrderChange", params);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const setColumnWidth = _react.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const column = apiRef.current.getColumn(field);
        const newColumn = (0, _extendsDefault.default)({}, column, {
            width
        });
        apiRef.current.updateColumns([
            newColumn
        ]);
        apiRef.current.publishEvent("columnWidthChange", {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width
        });
    }, [
        apiRef,
        logger
    ]);
    const columnApi = {
        getColumn,
        getAllColumns,
        getColumnIndex,
        getColumnPosition,
        getVisibleColumns,
        getColumnsMeta,
        updateColumn,
        updateColumns,
        setColumnVisibilityModel,
        setColumnVisibility,
        setColumnIndex,
        setColumnWidth
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, columnApi, "GridColumnApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        if (apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel) {
            var _props$initialState$c2, _props$initialState4, _props$initialState4$;
            const columnVisibilityModelToExport = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef);
            const shouldExportColumnVisibilityModel = !context.exportOnlyDirtyModels || // Always export if the model is controlled
            props.columnVisibilityModel != null || // Always export if the model has been initialized
            // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
            Object.keys((_props$initialState$c2 = (_props$initialState4 = props.initialState) == null ? void 0 : (_props$initialState4$ = _props$initialState4.columns) == null ? void 0 : _props$initialState4$.columnVisibilityModel) != null ? _props$initialState$c2 : {}).length > 0 || // Always export if the model is not empty
            Object.keys(columnVisibilityModelToExport).length > 0;
            if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        }
        columnsStateToExport.orderedFields = (0, _gridColumnsSelector.gridColumnFieldsSelector)(apiRef);
        const columns = (0, _gridColumnsSelector.gridColumnDefinitionsSelector)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, _gridColumnsUtils.COLUMNS_DIMENSION_PROPERTIES).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, _extendsDefault.default)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        (_props$initialState5 = props.initialState) == null ? void 0 : _props$initialState5.columns
    ]);
    const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        var _context$stateToResto;
        const columnVisibilityModelToImport = apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel ? (_context$stateToResto = context.stateToRestore.columns) == null ? void 0 : _context$stateToResto.columnVisibilityModel : undefined;
        const initialState = context.stateToRestore.columns;
        if (columnVisibilityModelToImport == null && initialState == null) return params;
        const columnsState = (0, _gridColumnsUtils.createColumnsState)({
            apiRef,
            columnTypes,
            columnsToUpsert: [],
            initialState,
            shouldRegenColumnVisibilityModelFromColumns: !apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel,
            currentColumnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        apiRef.current.setState((0, _gridColumnsUtils.mergeColumnsState)(columnsState));
        if (initialState != null) apiRef.current.publishEvent("columnsChange", columnsState.all);
        return params;
    }, [
        apiRef,
        columnTypes
    ]);
    const preferencePanelPreProcessing = _react.useCallback((initialValue, value)=>{
        if (value === (0, _preferencesPanel.GridPreferencePanelsValue).columns) {
            var _props$componentsProp;
            const ColumnsPanel = props.components.ColumnsPanel;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnsPanel, (0, _extendsDefault.default)({}, (_props$componentsProp = props.componentsProps) == null ? void 0 : _props$componentsProp.columnsPanel));
        }
        return initialValue;
    }, [
        props.components.ColumnsPanel,
        (_props$componentsProp2 = props.componentsProps) == null ? void 0 : _props$componentsProp2.columnsPanel
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "preferencePanel", preferencePanelPreProcessing);
    /**
   * EVENTS
   */ const prevInnerWidth = _react.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            setGridColumnsState((0, _gridColumnsUtils.hydrateColumnsWidth)((0, _gridColumnsSelector.gridColumnsSelector)(apiRef.current.state), viewportInnerSize.width));
        }
    };
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "viewportInnerSizeChange", handleGridSizeChange);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnVisibilityChange", props.onColumnVisibilityChange);
    /**
   * APPLIERS
   */ const hydrateColumns = _react.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, _gridColumnsUtils.createColumnsState)({
            apiRef,
            columnTypes,
            columnsToUpsert: [],
            initialState: undefined,
            shouldRegenColumnVisibilityModelFromColumns: !apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        columnTypes
    ]);
    (0, _pipeProcessing.useGridRegisterPipeApplier)(apiRef, "hydrateColumns", hydrateColumns);
    /**
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        if (previousColumnsProp.current === props.columns && previousColumnTypesProp.current === columnTypes) return;
        const columnsState = (0, _gridColumnsUtils.createColumnsState)({
            apiRef,
            columnTypes,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            shouldRegenColumnVisibilityModelFromColumns: !apiRef.current.unstable_caches.columns.isUsingColumnVisibilityModel,
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true
        });
        previousColumnsProp.current = props.columns;
        previousColumnTypesProp.current = columnTypes;
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        columnTypes
    ]);
    _react.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","./gridColumnsSelector":"aeHtc","../../utils/useGridApiEventHandler":"iBXeM","../../core/pipeProcessing":"jx1az","./gridColumnsUtils":"dl6aq","../preferencesPanel":"gncUn","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gncUn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridPreferencePanelSelector = require("./gridPreferencePanelSelector");
parcelHelpers.exportAll(_gridPreferencePanelSelector, exports);
var _gridPreferencePanelState = require("./gridPreferencePanelState");
parcelHelpers.exportAll(_gridPreferencePanelState, exports);
var _gridPreferencePanelsValue = require("./gridPreferencePanelsValue");
parcelHelpers.exportAll(_gridPreferencePanelsValue, exports);

},{"./gridPreferencePanelSelector":false,"./gridPreferencePanelState":false,"./gridPreferencePanelsValue":"7YmlH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dVJqR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPACT_DENSITY_FACTOR", ()=>COMPACT_DENSITY_FACTOR);
parcelHelpers.export(exports, "COMFORTABLE_DENSITY_FACTOR", ()=>COMFORTABLE_DENSITY_FACTOR);
parcelHelpers.export(exports, "densityStateInitializer", ()=>densityStateInitializer);
parcelHelpers.export(exports, "useGridDensity", ()=>useGridDensity);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridDensity = require("../../../models/gridDensity");
var _useGridLogger = require("../../utils/useGridLogger");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _densitySelector = require("./densitySelector");
var _utils = require("../../../utils/utils");
var _useGridSelector = require("../../utils/useGridSelector");
var _columns = require("../columns");
var _useGridColumnGrouping = require("../columnGrouping/useGridColumnGrouping");
const COMPACT_DENSITY_FACTOR = 0.7;
const COMFORTABLE_DENSITY_FACTOR = 1.3; // TODO v6: revise keeping headerHeight and rowHeight in state
const getUpdatedDensityState = (newDensity, newHeaderHeight, newRowHeight, newMaxDepth)=>{
    switch(newDensity){
        case (0, _gridDensity.GridDensityTypes).Compact:
            return {
                value: newDensity,
                headerHeight: Math.floor(newHeaderHeight * COMPACT_DENSITY_FACTOR),
                rowHeight: Math.floor(newRowHeight * COMPACT_DENSITY_FACTOR),
                headerGroupingMaxDepth: newMaxDepth,
                factor: COMPACT_DENSITY_FACTOR
            };
        case (0, _gridDensity.GridDensityTypes).Comfortable:
            return {
                value: newDensity,
                headerHeight: Math.floor(newHeaderHeight * COMFORTABLE_DENSITY_FACTOR),
                rowHeight: Math.floor(newRowHeight * COMFORTABLE_DENSITY_FACTOR),
                headerGroupingMaxDepth: newMaxDepth,
                factor: COMFORTABLE_DENSITY_FACTOR
            };
        default:
            return {
                value: newDensity,
                headerHeight: newHeaderHeight,
                rowHeight: newRowHeight,
                headerGroupingMaxDepth: newMaxDepth,
                factor: 1
            };
    }
};
const densityStateInitializer = (state, props)=>{
    // TODO: think about improving this initialization. Could it be done in the useColumn initializer?
    // TODO: manage to remove ts-ignore
    let maxDepth;
    if (props.columnGroupingModel == null || Object.keys(props.columnGroupingModel).length === 0) maxDepth = 0;
    else {
        const unwrappedGroupingColumnModel = (0, _useGridColumnGrouping.unwrapGroupingColumnModel)(props.columnGroupingModel);
        const columnsState = state.columns;
        const visibleColumns = columnsState.all.filter((field)=>columnsState.columnVisibilityModel[field] !== false);
        if (visibleColumns.length === 0) maxDepth = 0;
        else maxDepth = Math.max(...visibleColumns.map((field)=>{
            var _unwrappedGroupingCol, _unwrappedGroupingCol2;
            return (_unwrappedGroupingCol = (_unwrappedGroupingCol2 = unwrappedGroupingColumnModel[field]) == null ? void 0 : _unwrappedGroupingCol2.length) != null ? _unwrappedGroupingCol : 0;
        }));
    }
    return (0, _extendsDefault.default)({}, state, {
        density: getUpdatedDensityState(props.density, props.headerHeight, props.rowHeight, maxDepth)
    });
};
const useGridDensity = (apiRef, props)=>{
    const visibleColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _columns.gridVisibleColumnDefinitionsSelector));
    const maxDepth = visibleColumns.length > 0 ? Math.max(...visibleColumns.map((column)=>{
        var _column$groupPath$len, _column$groupPath;
        return (_column$groupPath$len = (_column$groupPath = column.groupPath) == null ? void 0 : _column$groupPath.length) != null ? _column$groupPath$len : 0;
    })) : 0;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useDensity");
    const setDensity = _react.useCallback((newDensity, newHeaderHeight = props.headerHeight, newRowHeight = props.rowHeight, newMaxDepth = maxDepth)=>{
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>{
            const currentDensityState = (0, _densitySelector.gridDensitySelector)(state);
            const newDensityState = getUpdatedDensityState(newDensity, newHeaderHeight, newRowHeight, newMaxDepth);
            if ((0, _utils.isDeepEqual)(currentDensityState, newDensityState)) return state;
            return (0, _extendsDefault.default)({}, state, {
                density: newDensityState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        apiRef,
        props.headerHeight,
        props.rowHeight,
        maxDepth
    ]);
    _react.useEffect(()=>{
        apiRef.current.setDensity(props.density, props.headerHeight, props.rowHeight, maxDepth);
    }, [
        apiRef,
        props.density,
        props.rowHeight,
        props.headerHeight,
        maxDepth
    ]);
    const densityApi = {
        setDensity
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, densityApi, "GridDensityApi");
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../../models/gridDensity":"6Ls1v","../../utils/useGridLogger":"6dTTN","../../utils/useGridApiMethod":"5EPiD","./densitySelector":"chMex","../../../utils/utils":"lwlsg","../../utils/useGridSelector":"96gNX","../columns":"99F9P","../columnGrouping/useGridColumnGrouping":"rtuq4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"rtuq4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasGroupPath", ()=>hasGroupPath);
parcelHelpers.export(exports, "unwrapGroupingColumnModel", ()=>unwrapGroupingColumnModel);
parcelHelpers.export(exports, "columnGroupsStateInitializer", ()=>columnGroupsStateInitializer);
parcelHelpers.export(exports, "useGridColumnGrouping", ()=>useGridColumnGrouping);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _gridColumnGrouping = require("../../../models/gridColumnGrouping");
var _gridColumnGroupsSelector = require("./gridColumnGroupsSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
const _excluded = [
    "groupId",
    "children"
];
function hasGroupPath(lookupElement) {
    return lookupElement.groupPath !== undefined;
}
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplet)=>{
    if ((0, _gridColumnGrouping.isLeaf)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplet[columnGroupNode.field] !== undefined) throw new Error([
            `MUI: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurrs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplet[columnGroupNode.field].join(" > ")}`,
            `- ${parents.join(" > ")}`
        ].join("\n"));
        unwrappedGroupingModelToComplet[columnGroupNode.field] = parents;
        return;
    }
    const { groupId, children } = columnGroupNode;
    children.forEach((child)=>{
        recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplet);
    });
};
const unwrapGroupingColumnModel = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const createGroupLookup = (columnGroupingModel)=>{
    let groupLookup = {};
    columnGroupingModel.forEach((node)=>{
        if ((0, _gridColumnGrouping.isLeaf)(node)) return;
        const { groupId, children } = node, other = (0, _objectWithoutPropertiesLooseDefault.default)(node, _excluded);
        if (!groupId) throw new Error("MUI: An element of the columnGroupingModel does not have either `field` or `groupId`.");
        if (!children) console.warn(`MUI: group groupId=${groupId} has no children.`);
        const groupParam = (0, _extendsDefault.default)({}, other, {
            groupId
        });
        const subTreeLookup = createGroupLookup(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        groupLookup = (0, _extendsDefault.default)({}, groupLookup, subTreeLookup, {
            [groupId]: groupParam
        });
    });
    return (0, _extendsDefault.default)({}, groupLookup);
};
const columnGroupsStateInitializer = (state, props)=>{
    var _props$columnGrouping;
    const groupLookup = createGroupLookup((_props$columnGrouping = props.columnGroupingModel) != null ? _props$columnGrouping : []);
    return (0, _extendsDefault.default)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            groupCollapsedModel: {}
        }
    });
};
const useGridColumnGrouping = (apiRef, props)=>{
    var _props$experimentalFe2;
    /**
   * API METHODS
   */ const getColumnGroupPath = _react.useCallback((field)=>{
        var _columnLookup$field$g, _columnLookup$field;
        const columnLookup = (0, _gridColumnsSelector.gridColumnLookupSelector)(apiRef);
        return (_columnLookup$field$g = (_columnLookup$field = columnLookup[field]) == null ? void 0 : _columnLookup$field.groupPath) != null ? _columnLookup$field$g : [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = _react.useCallback(()=>{
        const columnGroupLookup = (0, _gridColumnGroupsSelector.gridColumnGroupsLookupSelector)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        unstable_getColumnGroupPath: getColumnGroupPath,
        unstable_getAllGroupDetails: getAllGroupDetails
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, columnGroupingApi, "GridColumnGroupingApi");
    /**
   * EFFECTS
   */ // The effect does not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        var _props$experimentalFe, _props$columnGrouping2;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.columnGrouping)) return;
        const groupLookup = createGroupLookup((_props$columnGrouping2 = props.columnGroupingModel) != null ? _props$columnGrouping2 : []);
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                columnGrouping: (0, _extendsDefault.default)({}, state.columnGrouping, {
                    lookup: groupLookup
                })
            }));
    }, [
        apiRef,
        props.columnGroupingModel,
        (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.columnGrouping
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../../../models/gridColumnGrouping":"8r3d8","./gridColumnGroupsSelector":"lvnc9","../columns/gridColumnsSelector":"aeHtc","../../utils/useGridApiMethod":"5EPiD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lvnc9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridColumnGroupingSelector", ()=>gridColumnGroupingSelector);
parcelHelpers.export(exports, "gridColumnGroupsLookupSelector", ()=>gridColumnGroupsLookupSelector);
var _createSelector = require("../../../utils/createSelector");
const gridColumnGroupingSelector = (state)=>state.columnGrouping;
const gridColumnGroupsLookupSelector = (0, _createSelector.createSelector)(gridColumnGroupingSelector, (columnGrouping)=>columnGrouping.lookup);

},{"../../../utils/createSelector":"4xqAC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dSIlB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridCsvExport", ()=>useGridCsvExport);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _exportAs = require("../../../utils/exportAs");
var _csvSerializer = require("./serializers/csvSerializer");
var _utils = require("./utils");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridToolbarExport = require("../../../components/toolbar/GridToolbarExport");
/**
 * @requires useGridColumns (state)
 * @requires useGridFilter (state)
 * @requires useGridSorting (state)
 * @requires useGridSelection (state)
 * @requires useGridParamsApi (method)
 */ var _jsxRuntime = require("react/jsx-runtime");
const useGridCsvExport = (apiRef)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridCsvExport");
    const getDataAsCsv = _react.useCallback((options = {})=>{
        var _options$getRowsToExp, _options$includeHeade;
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, _utils.getColumnsToExport)({
            apiRef,
            options
        });
        const getRowsToExport = (_options$getRowsToExp = options.getRowsToExport) != null ? _options$getRowsToExp : (0, _utils.defaultGetRowsToExport);
        const exportedRowIds = getRowsToExport({
            apiRef
        });
        return (0, _csvSerializer.buildCSV)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            getCellParams: apiRef.current.getCellParams,
            delimiterCharacter: options.delimiter || ",",
            includeHeaders: (_options$includeHeade = options.includeHeaders) != null ? _options$includeHeade : true
        });
    }, [
        logger,
        apiRef
    ]);
    const exportDataAsCsv = _react.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options != null && options.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : "",
            csv
        ], {
            type: "text/csv"
        });
        (0, _exportAs.exportAs)(blob, "csv", options == null ? void 0 : options.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv,
        exportDataAsCsv
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, csvExportApi, "GridCsvExportApi");
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = _react.useCallback((initialValue, options)=>{
        var _options$csvOptions;
        if ((_options$csvOptions = options.csvOptions) != null && _options$csvOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridToolbarExport.GridCsvExportMenuItem), {
                    options: options.csvOptions
                }),
                componentName: "csvExport"
            }
        ];
    }, []);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportMenu", addExportMenuButtons);
};

},{"react":"gVheC","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../../../utils/exportAs":"lCaSl","./serializers/csvSerializer":"1o229","./utils":"7i2Wn","../../core/pipeProcessing":"jx1az","../../../components/toolbar/GridToolbarExport":"8E9qo","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lCaSl":[function(require,module,exports) {
/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportAs", ()=>exportAs);
function exportAs(blob, extension = "csv", filename = document.title || "untitled") {
    const fullName = `${filename}.${extension}`; // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ("download" in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob); // Create a new anchor element
        const a = document.createElement("a");
        a.href = url;
        a.download = fullName; // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click(); // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error("MUI: exportAs not supported");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1o229":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildCSV", ()=>buildCSV);
var _colDef = require("../../../../colDef");
var _warning = require("../../../../utils/warning");
const serializeCellValue = (value, delimiterCharacter)=>{
    if (typeof value === "string") {
        const formattedValue = value.replace(/"/g, '""'); // Make sure value containing delimiter or line break won't be split into multiple rows
        if ([
            delimiterCharacter,
            "\n",
            "\r"
        ].some((delimiter)=>formattedValue.includes(delimiter))) return `"${formattedValue}"`;
        return formattedValue;
    }
    return value;
};
const objectFormattedValueWarning = (0, _warning.buildWarning)([
    "MUI: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.",
    "You can provide a `valueFormatter` with a string representation to be used."
]);
const serializeRow = (id, columns, getCellParams, delimiterCharacter)=>columns.map((column)=>{
        const cellParams = getCellParams(id, column.field);
        return serializeCellValue(cellParams.formattedValue, delimiterCharacter);
    });
function buildCSV(options) {
    const { columns, rowIds, getCellParams, delimiterCharacter, includeHeaders } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${serializeRow(id, columns, getCellParams, delimiterCharacter).join(delimiterCharacter)}\r\n`, "").trim();
    if (!includeHeaders) return CSVBody;
    const CSVHead = `${columns.filter((column)=>column.field !== (0, _colDef.GRID_CHECKBOX_SELECTION_COL_DEF).field).map((column)=>serializeCellValue(column.headerName || column.field, delimiterCharacter)).join(delimiterCharacter)}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}

},{"../../../../colDef":"8Wled","../../../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7i2Wn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getColumnsToExport", ()=>getColumnsToExport);
parcelHelpers.export(exports, "defaultGetRowsToExport", ()=>defaultGetRowsToExport);
var _columns = require("../columns");
var _filter = require("../filter");
var _gridRowsSelector = require("../rows/gridRowsSelector");
const getColumnsToExport = ({ apiRef, options })=>{
    const columns = (0, _columns.gridColumnDefinitionsSelector)(apiRef);
    if (options.fields) return options.fields.map((field)=>columns.find((column)=>column.field === field)).filter((column)=>!!column);
    const validColumns = options.allColumns ? columns : (0, _columns.gridVisibleColumnDefinitionsSelector)(apiRef);
    return validColumns.filter((column)=>!column.disableExport);
};
const defaultGetRowsToExport = ({ apiRef })=>{
    var _pinnedRows$top, _pinnedRows$bottom;
    const filteredSortedRowIds = (0, _filter.gridFilteredSortedRowIdsSelector)(apiRef);
    const rowTree = (0, _gridRowsSelector.gridRowTreeSelector)(apiRef);
    const selectedRows = apiRef.current.getSelectedRows();
    const bodyRows = filteredSortedRowIds.filter((id)=>{
        var _rowTree$id$position;
        return ((_rowTree$id$position = rowTree[id].position) != null ? _rowTree$id$position : "body") === "body";
    });
    const pinnedRows = (0, _gridRowsSelector.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsIds = (pinnedRows == null ? void 0 : (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.map((row)=>row.id)) || [];
    const bottomPinnedRowsIds = (pinnedRows == null ? void 0 : (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.map((row)=>row.id)) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRows.size > 0) return bodyRows.filter((id)=>selectedRows.has(id));
    return bodyRows;
};

},{"../columns":"99F9P","../filter":"6FQgO","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6FQgO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultGridFilterModel", ()=>(0, _gridFilterState.getDefaultGridFilterModel));
var _gridFilterState = require("./gridFilterState");
var _gridFilterSelector = require("./gridFilterSelector");
parcelHelpers.exportAll(_gridFilterSelector, exports);

},{"./gridFilterState":false,"./gridFilterSelector":"lndlA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kWI6f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultGridFilterModel", ()=>getDefaultGridFilterModel);
var _gridFilterItem = require("../../../models/gridFilterItem");
const getDefaultGridFilterModel = ()=>({
        items: [],
        linkOperator: (0, _gridFilterItem.GridLinkOperator).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, _gridFilterItem.GridLinkOperator).And
    });

},{"../../../models/gridFilterItem":"j8Skw","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d9mgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridPrintExport", ()=>useGridPrintExport);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _densitySelector = require("../density/densitySelector");
var _gridClasses = require("../../../constants/gridClasses");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridRowsMetaSelector = require("../rows/gridRowsMetaSelector");
var _utils1 = require("./utils");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridToolbarExport = require("../../../components/toolbar/GridToolbarExport");
var _jsxRuntime = require("react/jsx-runtime");
function raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function getChromeVersion() {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : null;
}
const useGridPrintExport = (apiRef, props)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridPrintExport");
    const doc = _react.useRef(null);
    const previousGridState = _react.useRef(null);
    const previousColumnVisibility = _react.useRef({});
    _react.useEffect(()=>{
        doc.current = (0, _utils.ownerDocument)(apiRef.current.rootElementRef.current);
    }, [
        apiRef
    ]); // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = _react.useCallback((fields, allColumns)=>new Promise((resolve)=>{
            // TODO remove unused Promise
            if (!fields && !allColumns) {
                resolve();
                return;
            }
            const exportedColumnFields = (0, _utils1.getColumnsToExport)({
                apiRef,
                options: {
                    fields,
                    allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, _gridColumnsSelector.gridColumnDefinitionsSelector)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]); // TODO move outside of this scope and remove React.useCallback
    const buildPrintWindow = _react.useCallback((title)=>{
        const iframeEl = document.createElement("iframe");
        iframeEl.style.position = "absolute";
        iframeEl.style.width = "0px";
        iframeEl.style.height = "0px";
        iframeEl.title = title || document.title;
        return iframeEl;
    }, []);
    const handlePrintWindowLoad = _react.useCallback((printWindow, options)=>{
        var _querySelector, _querySelector2;
        const normalizeOptions = (0, _extendsDefault.default)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const totalHeaderHeight = (0, _densitySelector.gridDensityTotalHeaderHeightSelector)(apiRef);
        const rowsMeta = (0, _gridRowsMetaSelector.gridRowsMetaSelector)(apiRef.current.state);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        const gridCloneViewport = gridClone.querySelector(`.${(0, _gridClasses.gridClasses).virtualScroller}`); // Expand the viewport window to prevent clipping
        gridCloneViewport.style.height = "auto";
        gridCloneViewport.style.width = "auto";
        gridCloneViewport.parentElement.style.width = "auto";
        gridCloneViewport.parentElement.style.height = "auto"; // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, _gridClasses.gridClasses).main}`);
        gridMain.style.overflow = "visible";
        const chromeVersion = getChromeVersion();
        if (chromeVersion && chromeVersion >= 108) // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = "size";
        const columnHeaders = gridClone.querySelector(`.${(0, _gridClasses.gridClasses).columnHeaders}`);
        const columnHeadersInner = columnHeaders.querySelector(`.${(0, _gridClasses.gridClasses).columnHeadersInner}`);
        columnHeadersInner.style.width = "100%";
        let gridToolbarElementHeight = ((_querySelector = gridRootElement.querySelector(`.${(0, _gridClasses.gridClasses).toolbarContainer}`)) == null ? void 0 : _querySelector.clientHeight) || 0;
        let gridFooterElementHeight = ((_querySelector2 = gridRootElement.querySelector(`.${(0, _gridClasses.gridClasses).footerContainer}`)) == null ? void 0 : _querySelector2.clientHeight) || 0;
        if (normalizeOptions.hideToolbar) {
            var _gridClone$querySelec;
            (_gridClone$querySelec = gridClone.querySelector(`.${(0, _gridClasses.gridClasses).toolbarContainer}`)) == null || _gridClone$querySelec.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter) {
            var _gridClone$querySelec2;
            (_gridClone$querySelec2 = gridClone.querySelector(`.${(0, _gridClasses.gridClasses).footerContainer}`)) == null || _gridClone$querySelec2.remove();
            gridFooterElementHeight = 0;
        } // Expand container height to accommodate all rows
        gridClone.style.height = `${rowsMeta.currentPageTotalHeight + totalHeaderHeight + gridToolbarElementHeight + gridFooterElementHeight}px`; // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement("div");
        container.appendChild(gridClone);
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === "function" ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === "string") {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement("style");
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(" "));
        if (normalizeOptions.copyStyles) {
            const headStyleElements = doc.current.querySelectorAll("style, link[rel='stylesheet']");
            for(let i = 0; i < headStyleElements.length; i += 1){
                const node = headStyleElements[i];
                if (node.tagName === "STYLE") {
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    const sheet = node.sheet;
                    if (sheet) {
                        let styleCSS = ""; // NOTE: for-of is not supported by IE
                        for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === "string") styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                        newHeadStyleElements.appendChild(printDoc.createTextNode(styleCSS));
                        printDoc.head.appendChild(newHeadStyleElements);
                    }
                } else if (node.getAttribute("href")) {
                    // If `href` tag is empty, avoid loading these links
                    const newHeadStyleElements = printDoc.createElement(node.tagName);
                    for(let j = 0; j < node.attributes.length; j += 1){
                        const attr = node.attributes[j];
                        if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || "");
                    }
                    printDoc.head.appendChild(newHeadStyleElements);
                }
            }
        } // Trigger print
        printWindow.contentWindow.print();
    }, [
        apiRef,
        doc
    ]);
    const handlePrintWindowAfterPrint = _react.useCallback((printWindow)=>{
        var _previousGridState$cu, _previousGridState$cu2;
        // Remove the print iframe
        doc.current.body.removeChild(printWindow); // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!((_previousGridState$cu = previousGridState.current) != null && (_previousGridState$cu2 = _previousGridState$cu.columns) != null && _previousGridState$cu2.columnVisibilityModel)) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.unstable_enableVirtualization(); // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
    }, [
        apiRef
    ]);
    const exportDataAsPrint = _react.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error("MUI: No grid root element available.");
        previousGridState.current = apiRef.current.exportState(); // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, _gridColumnsSelector.gridColumnVisibilityModelSelector)(apiRef);
        if (props.pagination) {
            const visibleRowCount = (0, _gridFilterSelector.gridVisibleRowCountSelector)(apiRef);
            apiRef.current.setPageSize(visibleRowCount);
        }
        await updateGridColumnsForPrint(options == null ? void 0 : options.fields, options == null ? void 0 : options.allColumns);
        apiRef.current.unstable_disableVirtualization();
        await raf(); // wait for the state changes to take action
        const printWindow = buildPrintWindow(options == null ? void 0 : options.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia("print");
            mediaQueryList.addEventListener("change", (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        buildPrintWindow,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, printExportApi, "GridPrintExportApi");
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = _react.useCallback((initialValue, options)=>{
        var _options$printOptions;
        if ((_options$printOptions = options.printOptions) != null && _options$printOptions.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridToolbarExport.GridPrintExportMenuItem), {
                    options: options.printOptions
                }),
                componentName: "printExport"
            }
        ];
    }, []);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportMenu", addExportMenuButtons);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridLogger":"6dTTN","../filter/gridFilterSelector":"lndlA","../columns/gridColumnsSelector":"aeHtc","../density/densitySelector":"chMex","../../../constants/gridClasses":"5U0ME","../../utils/useGridApiMethod":"5EPiD","../rows/gridRowsMetaSelector":"bjCPy","./utils":"7i2Wn","../../core/pipeProcessing":"jx1az","../../../components/toolbar/GridToolbarExport":"8E9qo","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bjCPy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridRowsMetaSelector", ()=>gridRowsMetaSelector);
const gridRowsMetaSelector = (state)=>state.rowsMeta;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5AKIQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterStateInitializer", ()=>filterStateInitializer);
parcelHelpers.export(exports, "useGridFilter", ()=>useGridFilter);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridFeatureMode = require("../../../models/gridFeatureMode");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _gridPreferencePanelsValue = require("../preferencesPanel/gridPreferencePanelsValue");
var _gridFilterState = require("./gridFilterState");
var _gridFilterSelector = require("./gridFilterSelector");
var _useFirstRender = require("../../utils/useFirstRender");
var _rows = require("../rows");
var _pipeProcessing = require("../../core/pipeProcessing");
var _strategyProcessing = require("../../core/strategyProcessing");
var _gridFilterUtils = require("./gridFilterUtils");
var _utils = require("../../../utils/utils");
var _jsxRuntime = require("react/jsx-runtime");
const filterStateInitializer = (state, props, apiRef)=>{
    var _ref, _props$filterModel, _props$initialState, _props$initialState$f;
    const filterModel = (_ref = (_props$filterModel = props.filterModel) != null ? _props$filterModel : (_props$initialState = props.initialState) == null ? void 0 : (_props$initialState$f = _props$initialState.filter) == null ? void 0 : _props$initialState$f.filterModel) != null ? _ref : (0, _gridFilterState.getDefaultGridFilterModel)();
    return (0, _extendsDefault.default)({}, state, {
        filter: {
            filterModel: (0, _gridFilterUtils.sanitizeFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef),
            visibleRowsLookup: {},
            filteredDescendantCountLookup: {}
        }
    });
};
const useGridFilter = (apiRef, props)=>{
    var _props$initialState3, _props$initialState3$, _props$componentsProp2;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridFilter");
    apiRef.current.unstable_registerControlState({
        stateId: "filter",
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, _gridFilterSelector.gridFilterModelSelector),
        changeEvent: "filterModelChange"
    });
    const updateFilteredRows = _react.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(state, apiRef.current.instanceId);
            const isRowMatchingFilters = props.filterMode === (0, _gridFeatureMode.GridFeatureModeConstant).client ? (0, _gridFilterUtils.buildAggregatedFilterApplier)(filterModel, apiRef) : null;
            const filteringResult = apiRef.current.unstable_applyStrategyProcessor("filtering", {
                isRowMatchingFilters,
                filterModel: filterModel != null ? filterModel : (0, _gridFilterState.getDefaultGridFilterModel)()
            });
            return (0, _extendsDefault.default)({}, state, {
                filter: (0, _extendsDefault.default)({}, state.filter, filteringResult)
            });
        });
        apiRef.current.publishEvent("filteredRowsSet");
    }, [
        props.filterMode,
        apiRef
    ]);
    /**
   * API METHODS
   */ const applyFilters = _react.useCallback(()=>{
        updateFilteredRows();
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        updateFilteredRows
    ]);
    const upsertFilterItem = _react.useCallback((item)=>{
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            items
        }), "upsertFilterItem");
    }, [
        apiRef
    ]);
    const upsertFilterItems = _react.useCallback((items)=>{
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            items
        }), "upsertFilterItems");
    }, [
        apiRef
    ]);
    const deleteFilterItem = _react.useCallback((itemToDelete)=>{
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            items
        }), "deleteFilterItem");
    }, [
        apiRef
    ]);
    const showFilterPanel = _react.useCallback((targetColumnField)=>{
        logger.debug("Displaying filter panel");
        if (targetColumnField) {
            const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                var _column$filterOperato;
                if (item.value !== undefined) return true;
                const column = apiRef.current.getColumn(item.columnField);
                const filterOperator = (_column$filterOperato = column.filterOperators) == null ? void 0 : _column$filterOperato.find((operator)=>operator.value === item.operatorValue);
                const requiresFilterValue = typeof (filterOperator == null ? void 0 : filterOperator.requiresFilterValue) === "undefined" ? true : filterOperator == null ? void 0 : filterOperator.requiresFilterValue; // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.columnField === targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, _gridFilterUtils.cleanFilterItem)({
                    columnField: targetColumnField
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, _gridFilterUtils.cleanFilterItem)({
                    columnField: targetColumnField
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, _gridPreferencePanelsValue.GridPreferencePanelsValue).filters);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = _react.useCallback(()=>{
        logger.debug("Hiding filter panel");
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLinkOperator = _react.useCallback((linkOperator)=>{
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        if (filterModel.linkOperator === linkOperator) return;
        apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            linkOperator
        }), "changeLogicOperator");
    }, [
        apiRef
    ]);
    const setQuickFilterValues = _react.useCallback((values)=>{
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        if ((0, _utils.isDeepEqual)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = _react.useCallback((model, reason)=>{
        const currentModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug("Setting filter model");
            apiRef.current.unstable_updateControlState("filter", (0, _gridFilterUtils.mergeStateWithFilterModel)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getVisibleRowModels = _react.useCallback(()=>{
        const visibleSortedRows = (0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector)(apiRef);
        return new Map(visibleSortedRows.map((row)=>[
                row.id,
                row.model
            ]));
    }, [
        apiRef
    ]);
    const filterApi = {
        setFilterLinkOperator,
        unstable_applyFilters: applyFilters,
        deleteFilterItem,
        upsertFilterItem,
        upsertFilterItems,
        setFilterModel,
        showFilterPanel,
        hideFilterPanel,
        getVisibleRowModels,
        setQuickFilterValues
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, filterApi, "GridFilterApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        var _props$initialState2, _props$initialState2$;
        const filterModelToExport = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        const shouldExportFilterModel = !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null ? void 0 : (_props$initialState2$ = _props$initialState2.filter) == null ? void 0 : _props$initialState2$.filterModel) != null || // Export if the model is not equal to the default value
        !(0, _utils.isDeepEqual)(filterModelToExport, (0, _gridFilterState.getDefaultGridFilterModel)());
        if (!shouldExportFilterModel) return prevState;
        return (0, _extendsDefault.default)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        (_props$initialState3 = props.initialState) == null ? void 0 : (_props$initialState3$ = _props$initialState3.filter) == null ? void 0 : _props$initialState3$.filterModel
    ]);
    const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        var _context$stateToResto;
        const filterModel = (_context$stateToResto = context.stateToRestore.filter) == null ? void 0 : _context$stateToResto.filterModel;
        if (filterModel == null) return params;
        apiRef.current.unstable_updateControlState("filter", (0, _gridFilterUtils.mergeStateWithFilterModel)(filterModel, props.disableMultipleColumnsFiltering, apiRef), "restoreState");
        return (0, _extendsDefault.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = _react.useCallback((initialValue, value)=>{
        if (value === (0, _gridPreferencePanelsValue.GridPreferencePanelsValue).filters) {
            var _props$componentsProp;
            const FilterPanel = props.components.FilterPanel;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterPanel, (0, _extendsDefault.default)({}, (_props$componentsProp = props.componentsProps) == null ? void 0 : _props$componentsProp.filterPanel));
        }
        return initialValue;
    }, [
        props.components.FilterPanel,
        (_props$componentsProp2 = props.componentsProps) == null ? void 0 : _props$componentsProp2.filterPanel
    ]);
    const flatFilteringMethod = _react.useCallback((params)=>{
        if (props.filterMode === (0, _gridFeatureMode.GridFeatureModeConstant).client && params.isRowMatchingFilters) {
            const rowIds = (0, _rows.gridRowIdsSelector)(apiRef);
            const filteredRowsLookup = {};
            for(let i = 0; i < rowIds.length; i += 1){
                const rowId = rowIds[i];
                let isRowPassing;
                if (typeof rowId === "string" && rowId.startsWith("auto-generated-group-footer")) isRowPassing = true;
                else {
                    const { passingFilterItems, passingQuickFilterValues } = params.isRowMatchingFilters(rowId);
                    isRowPassing = (0, _gridFilterUtils.passFilterLogic)([
                        passingFilterItems
                    ], [
                        passingQuickFilterValues
                    ], params.filterModel, apiRef);
                }
                filteredRowsLookup[rowId] = isRowPassing;
            }
            return {
                filteredRowsLookup,
                // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` since no row is collapsed.
                visibleRowsLookup: filteredRowsLookup,
                filteredDescendantCountLookup: {}
            };
        }
        return {
            visibleRowsLookup: {},
            filteredRowsLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "preferencePanel", preferencePanelPreProcessing);
    (0, _strategyProcessing.useGridRegisterStrategyProcessor)(apiRef, (0, _strategyProcessing.GRID_DEFAULT_STRATEGY), "filtering", flatFilteringMethod);
    /**
   * EVENTS
   */ const handleColumnsChange = _react.useCallback(()=>{
        logger.debug("onColUpdated - GridColumns changed, applying filters");
        const filterModel = (0, _gridFilterSelector.gridFilterModelSelector)(apiRef);
        const filterableColumnsLookup = (0, _gridColumnsSelector.gridFilterableColumnLookupSelector)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.columnField && filterableColumnsLookup[item.columnField]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, _extendsDefault.default)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = _react.useCallback((methodName)=>{
        if (methodName === "filtering") apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]); // Do not call `apiRef.current.forceUpdate` to avoid re-render before updating the sorted rows.
    // Otherwise, the state is not consistent during the render
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowsSet", updateFilteredRows);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowExpansionChange", apiRef.current.unstable_applyFilters);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnsChange", handleColumnsChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, _useFirstRender.useFirstRender)(()=>{
        apiRef.current.unstable_applyFilters();
    });
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../../models/gridFeatureMode":"l5iiY","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../columns/gridColumnsSelector":"aeHtc","../preferencesPanel/gridPreferencePanelsValue":"7YmlH","./gridFilterState":"kWI6f","./gridFilterSelector":"lndlA","../../utils/useFirstRender":"3zp8V","../rows":"8bHvN","../../core/pipeProcessing":"jx1az","../../core/strategyProcessing":"dzDtc","./gridFilterUtils":"9r06W","../../../utils/utils":"lwlsg","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8bHvN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridRowsStateSelector", ()=>(0, _gridRowsSelector.gridRowsStateSelector));
parcelHelpers.export(exports, "gridRowCountSelector", ()=>(0, _gridRowsSelector.gridRowCountSelector));
parcelHelpers.export(exports, "gridRowsLoadingSelector", ()=>(0, _gridRowsSelector.gridRowsLoadingSelector));
parcelHelpers.export(exports, "gridTopLevelRowCountSelector", ()=>(0, _gridRowsSelector.gridTopLevelRowCountSelector));
parcelHelpers.export(exports, "gridRowsLookupSelector", ()=>(0, _gridRowsSelector.gridRowsLookupSelector));
parcelHelpers.export(exports, "gridRowsIdToIdLookupSelector", ()=>(0, _gridRowsSelector.gridRowsIdToIdLookupSelector));
parcelHelpers.export(exports, "gridRowTreeSelector", ()=>(0, _gridRowsSelector.gridRowTreeSelector));
parcelHelpers.export(exports, "gridRowGroupingNameSelector", ()=>(0, _gridRowsSelector.gridRowGroupingNameSelector));
parcelHelpers.export(exports, "gridRowTreeDepthSelector", ()=>(0, _gridRowsSelector.gridRowTreeDepthSelector));
parcelHelpers.export(exports, "gridRowIdsSelector", ()=>(0, _gridRowsSelector.gridRowIdsSelector));
parcelHelpers.export(exports, "checkGridRowIdIsValid", ()=>(0, _gridRowsUtils.checkGridRowIdIsValid));
var _gridRowsMetaSelector = require("./gridRowsMetaSelector");
parcelHelpers.exportAll(_gridRowsMetaSelector, exports);
var _gridRowsMetaState = require("./gridRowsMetaState");
parcelHelpers.exportAll(_gridRowsMetaState, exports);
var _gridRowsSelector = require("./gridRowsSelector");
var _gridRowsUtils = require("./gridRowsUtils");

},{"./gridRowsMetaSelector":false,"./gridRowsMetaState":false,"./gridRowsSelector":"fCZaq","./gridRowsUtils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iSo8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A helper function to check if the id provided is valid.
 * @param {GridRowId} id Id as [[GridRowId]].
 * @param {GridRowModel | Partial<GridRowModel>} row Row as [[GridRowModel]].
 * @param {string} detailErrorMessage A custom error message to display for invalid IDs
 */ parcelHelpers.export(exports, "checkGridRowIdIsValid", ()=>checkGridRowIdIsValid);
parcelHelpers.export(exports, "getRowIdFromRowModel", ()=>getRowIdFromRowModel);
parcelHelpers.export(exports, "createRowsInternalCache", ()=>createRowsInternalCache);
parcelHelpers.export(exports, "getRowsStateFromCache", ()=>getRowsStateFromCache);
parcelHelpers.export(exports, "getTreeNodeDescendants", ()=>getTreeNodeDescendants);
parcelHelpers.export(exports, "calculatePinnedRowsHeight", ()=>calculatePinnedRowsHeight);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _gridRowsSelector = require("./gridRowsSelector");
const _excluded = [
    "rowsBeforePartialUpdates"
];
function checkGridRowIdIsValid(id, row, detailErrorMessage = "A row was provided without id in the rows prop:") {
    if (id == null) throw new Error([
        "MUI: The data grid component requires all rows to have a unique `id` property.",
        "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.",
        detailErrorMessage,
        JSON.stringify(row)
    ].join("\n"));
}
const getRowIdFromRowModel = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    checkGridRowIdIsValid(id, rowModel, detailErrorMessage);
    return id;
};
const createRowsInternalCache = ({ rows, getRowId, loading, rowCount })=>{
    const cache = {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        idRowsLookup: {},
        idToIdLookup: {},
        ids: []
    };
    for(let i = 0; i < rows.length; i += 1){
        const row = rows[i];
        const id = getRowIdFromRowModel(row, getRowId);
        cache.idRowsLookup[id] = row;
        cache.idToIdLookup[id] = id;
        cache.ids.push(id);
    }
    return cache;
};
const getRowsStateFromCache = ({ apiRef, previousTree, rowCountProp, loadingProp })=>{
    const _apiRef$current$unsta = apiRef.current.unstable_caches.rows, cacheForGrouping = (0, _objectWithoutPropertiesLooseDefault.default)(_apiRef$current$unsta, _excluded);
    const rowCount = rowCountProp != null ? rowCountProp : 0;
    const groupingResponse = apiRef.current.unstable_applyStrategyProcessor("rowTreeCreation", (0, _extendsDefault.default)({}, cacheForGrouping, {
        previousTree
    }));
    const processedGroupingResponse = apiRef.current.unstable_applyPipeProcessors("hydrateRows", groupingResponse);
    const dataTopLevelRowCount = processedGroupingResponse.treeDepth === 1 ? processedGroupingResponse.ids.length : Object.values(processedGroupingResponse.tree).filter((node)=>node.parent == null && !node.isPinned).length;
    return (0, _extendsDefault.default)({}, processedGroupingResponse, {
        groupingResponseBeforeRowHydration: groupingResponse,
        loading: loadingProp,
        totalRowCount: Math.max(rowCount, processedGroupingResponse.ids.length),
        totalTopLevelRowCount: Math.max(rowCount, dataTopLevelRowCount)
    });
};
const getTreeNodeDescendants = (tree, parentId, skipAutoGeneratedRows)=>{
    var _tree$parentId;
    const children = (_tree$parentId = tree[parentId]) == null ? void 0 : _tree$parentId.children;
    if (children == null) return [];
    const validDescendants = [];
    for(let i = 0; i < children.length; i += 1){
        const child = children[i];
        const childNode = tree[child];
        if (!skipAutoGeneratedRows || !childNode.isAutoGenerated) validDescendants.push(child);
        validDescendants.push(...getTreeNodeDescendants(tree, childNode.id, skipAutoGeneratedRows));
    }
    return validDescendants;
};
function calculatePinnedRowsHeight(apiRef) {
    var _pinnedRows$top, _pinnedRows$bottom;
    const pinnedRows = (0, _gridRowsSelector.gridPinnedRowsSelector)(apiRef);
    const topPinnedRowsHeight = (pinnedRows == null ? void 0 : (_pinnedRows$top = pinnedRows.top) == null ? void 0 : _pinnedRows$top.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    const bottomPinnedRowsHeight = (pinnedRows == null ? void 0 : (_pinnedRows$bottom = pinnedRows.bottom) == null ? void 0 : _pinnedRows$bottom.reduce((acc, value)=>{
        acc += apiRef.current.unstable_getRowHeight(value.id);
        return acc;
    }, 0)) || 0;
    return {
        top: topPinnedRowsHeight,
        bottom: bottomPinnedRowsHeight
    };
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","./gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9r06W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanFilterItem", ()=>cleanFilterItem);
parcelHelpers.export(exports, "sanitizeFilterModel", ()=>sanitizeFilterModel);
parcelHelpers.export(exports, "mergeStateWithFilterModel", ()=>mergeStateWithFilterModel);
parcelHelpers.export(exports, "buildAggregatedFilterItemsApplier", ()=>buildAggregatedFilterItemsApplier);
parcelHelpers.export(exports, "buildAggregatedQuickFilterApplier", ()=>buildAggregatedQuickFilterApplier);
parcelHelpers.export(exports, "buildAggregatedFilterApplier", ()=>buildAggregatedFilterApplier);
parcelHelpers.export(exports, "passFilterLogic", ()=>passFilterLogic);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _models = require("../../../models");
var _gridFilterState = require("./gridFilterState");
var _warning = require("../../../utils/warning");
var _columns = require("../columns");
const cleanFilterItem = (item, apiRef)=>{
    const cleanItem = (0, _extendsDefault.default)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operatorValue == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, _columns.gridColumnLookupSelector)(apiRef)[cleanItem.columnField];
        cleanItem.operatorValue = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const filterModelDisableMultiColumnsFilteringWarning = (0, _warning.buildWarning)([
    "MUI: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.",
    "If you are using the community version of the `DataGrid`, this prop is always `true`."
], "error");
const filterModelMissingItemIdWarning = (0, _warning.buildWarning)("MUI: The 'id' field is required on `filterModel.items` when you use multiple filters.", "error");
const filterModelMissingItemOperatorWarning = (0, _warning.buildWarning)([
    "MUI: One of your filtering item have no `operatorValue` provided.",
    "This property will become required on `@mui/x-data-grid@6.X`."
]);
const sanitizeFilterModel = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) {
        filterModelDisableMultiColumnsFilteringWarning();
        items = [
            model.items[0]
        ];
    } else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operatorValue == null);
    if (hasItemsWithoutIds) filterModelMissingItemIdWarning();
    if (hasItemWithoutOperator) filterModelMissingItemOperatorWarning();
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, _extendsDefault.default)({}, model, {
        items: items.map((item)=>cleanFilterItem(item, apiRef))
    });
    if (model.items !== items) return (0, _extendsDefault.default)({}, model, {
        items
    });
    return model;
};
const mergeStateWithFilterModel = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, _extendsDefault.default)({}, filteringState, {
            filterModel: sanitizeFilterModel(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const getFilterCallbackFromItem = (filterItem, apiRef)=>{
    if (!filterItem.columnField || !filterItem.operatorValue) return null;
    const column = apiRef.current.getColumn(filterItem.columnField);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        var _filterItem$value;
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? (_filterItem$value = filterItem.value) == null ? void 0 : _filterItem$value.map((x)=>parser(x)) : parser(filterItem.value);
    } else parsedValue = filterItem.value;
    const newFilterItem = (0, _extendsDefault.default)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!(filterOperators != null && filterOperators.length)) throw new Error(`MUI: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operatorValue);
    if (!filterOperator) throw new Error(`MUI: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operatorValue}'.`);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== "function") return null;
    const fn = (rowId)=>{
        const cellParams = apiRef.current.getCellParams(rowId, newFilterItem.columnField);
        return applyFilterOnRow(cellParams);
    };
    return {
        fn,
        item: newFilterItem
    };
};
const buildAggregatedFilterItemsApplier = (filterModel, apiRef)=>{
    const { items } = filterModel;
    const appliers = items.map((item)=>getFilterCallbackFromItem(item, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    return (rowId, shouldApplyFilter)=>{
        const resultPerItemId = {};
        const filteredAppliers = shouldApplyFilter ? appliers.filter((applier)=>shouldApplyFilter(applier.item.columnField)) : appliers;
        filteredAppliers.forEach((applier)=>{
            resultPerItemId[applier.item.id] = applier.fn(rowId);
        });
        return resultPerItemId;
    };
};
const buildAggregatedQuickFilterApplier = (filterModel, apiRef)=>{
    const { quickFilterValues = [] } = filterModel;
    if (quickFilterValues.length === 0) return null;
    const columnsFields = (0, _columns.gridColumnFieldsSelector)(apiRef);
    const appliersPerColumnField = {};
    columnsFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column == null ? void 0 : column.getApplyQuickFilterFn;
        if (!getApplyQuickFilterFn) return;
        appliersPerColumnField[field] = quickFilterValues.map((value)=>getApplyQuickFilterFn(value, column, apiRef));
    }); // If some value does not have an applier we ignore them
    const sanitizedQuickFilterValues = quickFilterValues.filter((value, index)=>Object.keys(appliersPerColumnField).some((field)=>appliersPerColumnField[field][index] != null));
    if (sanitizedQuickFilterValues.length === 0) return null;
    return (rowId, shouldApplyFilter)=>{
        const usedCellParams = {};
        const columnsFieldsToFilter = [];
        Object.keys(appliersPerColumnField).forEach((columnField)=>{
            if (!shouldApplyFilter || shouldApplyFilter(columnField)) {
                usedCellParams[columnField] = apiRef.current.getCellParams(rowId, columnField);
                columnsFieldsToFilter.push(columnField);
            }
        });
        const quickFilterValueResult = {};
        sanitizedQuickFilterValues.forEach((value, index)=>{
            const isPassing = columnsFieldsToFilter.some((field)=>{
                var _appliersPerColumnFie, _appliersPerColumnFie2;
                if (appliersPerColumnField[field][index] == null) return false;
                return (_appliersPerColumnFie = (_appliersPerColumnFie2 = appliersPerColumnField[field])[index]) == null ? void 0 : _appliersPerColumnFie.call(_appliersPerColumnFie2, usedCellParams[field]);
            });
            quickFilterValueResult[value] = isPassing;
        });
        return quickFilterValueResult;
    };
};
const buildAggregatedFilterApplier = (filterModel, apiRef)=>{
    const isRowMatchingFilterItems = buildAggregatedFilterItemsApplier(filterModel, apiRef);
    const isRowMatchingQuickFilter = buildAggregatedQuickFilterApplier(filterModel, apiRef);
    return (rowId, shouldApplyFilter)=>({
            passingFilterItems: isRowMatchingFilterItems && isRowMatchingFilterItems(rowId, shouldApplyFilter),
            passingQuickFilterValues: isRowMatchingQuickFilter && isRowMatchingQuickFilter(rowId, shouldApplyFilter)
        });
};
const passFilterLogic = (allFilterItemResults, allQuickFilterResults, filterModel, apiRef)=>{
    var _filterModel$quickFil, _filterModel$linkOper;
    const cleanedFilterItems = filterModel.items.filter((item)=>getFilterCallbackFromItem(item, apiRef) !== null);
    const cleanedAllFilterItemResults = allFilterItemResults.filter((result)=>result != null);
    const cleanedAllQuickFilterResults = allQuickFilterResults.filter((result)=>result != null); // Defaultize operators
    const quickFilterLogicOperator = (_filterModel$quickFil = filterModel.quickFilterLogicOperator) != null ? _filterModel$quickFil : (0, _gridFilterState.getDefaultGridFilterModel)().quickFilterLogicOperator;
    const linkOperator = (_filterModel$linkOper = filterModel.linkOperator) != null ? _filterModel$linkOper : (0, _gridFilterState.getDefaultGridFilterModel)().linkOperator; // get result for filter items model
    if (cleanedAllFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedAllFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        if (linkOperator === (0, _models.GridLinkOperator).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    } // get result for quick filter model
    if (cleanedAllQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedAllQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        if (quickFilterLogicOperator === (0, _models.GridLinkOperator).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","../../../models":"15Dm5","./gridFilterState":"kWI6f","../../../utils/warning":"cfes8","../columns":"99F9P","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3fHP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusStateInitializer", ()=>focusStateInitializer);
parcelHelpers.export(exports, "useGridFocus", ()=>useGridFocus);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _gridFocusStateSelector = require("./gridFocusStateSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _utils1 = require("../../../utils/utils");
const focusStateInitializer = (state)=>(0, _extendsDefault.default)({}, state, {
        focus: {
            cell: null,
            columnHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null
        }
    });
const useGridFocus = (apiRef, props)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridFocus");
    const lastClickedCell = _react.useRef(null);
    const publishCellFocusOut = _react.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent("cellFocusOut", apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = _react.useCallback((id, field)=>{
        const focusedCell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        if ((focusedCell == null ? void 0 : focusedCell.id) === id && (focusedCell == null ? void 0 : focusedCell.field) === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, _extendsDefault.default)({}, state, {
                tabIndex: {
                    cell: {
                        id,
                        field
                    },
                    columnHeader: null
                },
                focus: {
                    cell: {
                        id,
                        field
                    },
                    columnHeader: null
                }
            });
        });
        apiRef.current.forceUpdate(); // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent("cellFocusIn", apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = _react.useCallback((field, event = {})=>{
        const cell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, _extendsDefault.default)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field
                    },
                    cell: null
                },
                focus: {
                    columnHeader: {
                        field
                    },
                    cell: null
                }
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const moveFocusToRelativeCell = _react.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        let rowIndexToFocus = apiRef.current.getRowIndexRelativeToVisibleRows(id);
        const visibleColumns = (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef);
        if (direction === "right") columnIndexToFocus += 1;
        else if (direction === "left") columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        const currentPage = (0, _useGridVisibleRows.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPage.rows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, _utils1.clamp)(rowIndexToFocus, 0, currentPage.rows.length - 1);
        const rowToFocus = currentPage.rows[rowIndexToFocus];
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === "left" || direction === "below") columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === "right") columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, _utils1.clamp)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = _react.useCallback(({ id, field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = _react.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === "Enter" || event.key === "Tab" || (0, _keyboardUtils.isNavigationKey)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = _react.useCallback(({ field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleBlur = _react.useCallback(()=>{
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = _react.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = _react.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if ((cellParams == null ? void 0 : cellParams.id) === focusedCell.id && (cellParams == null ? void 0 : cellParams.field) === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement != null && cellElement.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null
                    }
                }));
            apiRef.current.forceUpdate(); // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = _react.useCallback((params)=>{
        if (params.cellMode === "view") return;
        const cell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        if ((cell == null ? void 0 : cell.id) !== params.id || (cell == null ? void 0 : cell.field) !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = _react.useCallback(()=>{
        const cell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef); // If the focused cell is in a row which does not exist anymore, then remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null
                }
            }));
    }, [
        apiRef
    ]);
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, {
        setCellFocus,
        setColumnHeaderFocus,
        unstable_moveFocusToRelativeCell: moveFocusToRelativeCell
    }, "GridFocusApi");
    _react.useEffect(()=>{
        const doc = (0, _utils.ownerDocument)(apiRef.current.rootElementRef.current);
        doc.addEventListener("click", handleDocumentClick);
        return ()=>{
            doc.removeEventListener("click", handleDocumentClick);
        };
    }, [
        apiRef,
        handleDocumentClick
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderBlur", handleBlur);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellDoubleClick", handleCellDoubleClick);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellMouseDown", handleCellMouseDown);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", handleCellKeyDown);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellModeChange", handleCellModeChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderFocus", handleColumnHeaderFocus);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowsSet", handleRowSet);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../../utils/useGridApiEventHandler":"iBXeM","../../../utils/keyboardUtils":"o7lWn","./gridFocusStateSelector":"7pS2P","../columns/gridColumnsSelector":"aeHtc","../../utils/useGridVisibleRows":"giBK8","../../../utils/utils":"lwlsg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1DOdW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridKeyboardNavigation", ()=>useGridKeyboardNavigation);
var _react = require("react");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _useGridLogger = require("../../utils/useGridLogger");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _gridCheckboxSelectionColDef = require("../../../colDef/gridCheckboxSelectionColDef");
var _gridClasses = require("../../../constants/gridClasses");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _gridDetailPanelToggleField = require("../../../constants/gridDetailPanelToggleField");
var _gridRowsSelector = require("../rows/gridRowsSelector");
function enrichPageRowsWithPinnedRows(apiRef, rows) {
    const pinnedRows = (0, _gridRowsSelector.gridPinnedRowsSelector)(apiRef) || {};
    return [
        ...pinnedRows.top || [],
        ...rows,
        ...pinnedRows.bottom || []
    ];
}
const useGridKeyboardNavigation = (apiRef, props)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridKeyboardNavigation");
    const initialCurrentPageRows = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, props).rows;
    const currentPageRows = _react.useMemo(()=>enrichPageRowsWithPinnedRows(apiRef, initialCurrentPageRows), [
        apiRef,
        initialCurrentPageRows
    ]);
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {number} rowIndex index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * TODO replace with apiRef.current.unstable_moveFocusToRelativeCell()
   */ const goToCell = _react.useCallback((colIndex, rowId, closestColumnToUse = "left")=>{
        const visibleSortedRows = (0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === "left") colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === "right") colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        } // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === rowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setCellFocus(rowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = _react.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = _react.useCallback((rowIndex)=>{
        return currentPageRows[rowIndex].id;
    }, [
        currentPageRows
    ]);
    const handleCellNavigationKeyDown = _react.useCallback((params, event)=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (currentPageRows.length === 0 || !dimensions) return;
        const viewportPageSize = apiRef.current.unstable_getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
            case "Enter":
                // TODO v6: Remove Enter case because `cellNavigationKeyDown` is not fired by the new editing API
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1));
                break;
            case "ArrowUp":
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else goToHeader(colIndexBefore, event);
                break;
            case "ArrowRight":
                if (colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), "right");
                break;
            case "ArrowLeft":
                if (colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore));
                break;
            case "Tab":
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), "left");
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), "right");
                break;
            case " ":
                {
                    const field = params.field;
                    if (field === (0, _gridDetailPanelToggleField.GRID_DETAIL_PANEL_TOGGLE_FIELD)) break;
                    const colDef = params.colDef;
                    if (colDef && colDef.type === "treeDataGroup") break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case "PageDown":
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case "PageUp":
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case "Home":
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case "End":
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        goToCell,
        goToHeader,
        getRowIdFromIndex
    ]);
    const handleColumnHeaderKeyDown = _react.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, _gridClasses.gridClasses).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, _gridCheckboxSelectionColDef.GRID_CHECKBOX_SELECTION_COL_DEF).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return;
        const viewportPageSize = apiRef.current.unstable_getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case "ArrowDown":
                if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case "ArrowRight":
                if (colIndexBefore < lastColIndex) goToHeader(colIndexBefore + 1, event);
                break;
            case "ArrowLeft":
                if (colIndexBefore > firstColIndex) goToHeader(colIndexBefore - 1, event);
                break;
            case "PageDown":
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case "Home":
                goToHeader(firstColIndex, event);
                break;
            case "End":
                goToHeader(lastColIndex, event);
                break;
            case "Enter":
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case " ":
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        currentPageRows,
        goToCell,
        goToHeader,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = _react.useCallback((params, event)=>{
        // Ignore portal
        if (!event.currentTarget.contains(event.target)) return;
         // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode !== (0, _gridEditRowModel.GridCellModes).Edit && (0, _keyboardUtils.isNavigationKey)(event.key)) apiRef.current.publishEvent("cellNavigationKeyDown", cellParams, event);
    }, [
        apiRef
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellNavigationKeyDown", handleCellNavigationKeyDown);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderKeyDown", handleColumnHeaderKeyDown);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", handleCellKeyDown);
};

},{"react":"gVheC","../columns/gridColumnsSelector":"aeHtc","../../utils/useGridLogger":"6dTTN","../../utils/useGridApiEventHandler":"iBXeM","../filter/gridFilterSelector":"lndlA","../../utils/useGridVisibleRows":"giBK8","../../../colDef/gridCheckboxSelectionColDef":"jNhez","../../../constants/gridClasses":"5U0ME","../../../models/gridEditRowModel":"5QORb","../../../utils/keyboardUtils":"o7lWn","../../../constants/gridDetailPanelToggleField":"3vGWg","../rows/gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMyjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paginationStateInitializer", ()=>paginationStateInitializer);
parcelHelpers.export(exports, "useGridPagination", ()=>useGridPagination);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _useGridPageSize = require("./useGridPageSize");
var _useGridPage = require("./useGridPage");
const paginationStateInitializer = (state, props)=>{
    var _props$initialState, _props$initialState$p, _ref, _props$page, _props$initialState2, _props$initialState2$, _props$rowCount, _props$rowCount2;
    let pageSize;
    if (props.pageSize != null) pageSize = props.pageSize;
    else if (((_props$initialState = props.initialState) == null ? void 0 : (_props$initialState$p = _props$initialState.pagination) == null ? void 0 : _props$initialState$p.pageSize) != null) pageSize = props.initialState.pagination.pageSize;
    else pageSize = (0, _useGridPageSize.defaultPageSize)(props.autoPageSize);
    return (0, _extendsDefault.default)({}, state, {
        pagination: {
            pageSize,
            page: (_ref = (_props$page = props.page) != null ? _props$page : (_props$initialState2 = props.initialState) == null ? void 0 : (_props$initialState2$ = _props$initialState2.pagination) == null ? void 0 : _props$initialState2$.page) != null ? _ref : 0,
            pageCount: (0, _useGridPage.getPageCount)((_props$rowCount = props.rowCount) != null ? _props$rowCount : 0, pageSize),
            rowCount: (_props$rowCount2 = props.rowCount) != null ? _props$rowCount2 : 0
        }
    });
};
const useGridPagination = (apiRef, props)=>{
    (0, _useGridPageSize.useGridPageSize)(apiRef, props);
    (0, _useGridPage.useGridPage)(apiRef, props);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","./useGridPageSize":"4ZR8R","./useGridPage":"n1xiQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ZR8R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPageSize", ()=>defaultPageSize);
parcelHelpers.export(exports, "useGridPageSize", ()=>useGridPageSize);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("../../utils");
var _gridPaginationSelector = require("./gridPaginationSelector");
var _density = require("../density");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridRowsUtils = require("../rows/gridRowsUtils");
const defaultPageSize = (autoPageSize)=>autoPageSize ? 0 : 100;
const mergeStateWithPageSize = (pageSize)=>(state)=>(0, _extendsDefault.default)({}, state, {
            pagination: (0, _extendsDefault.default)({}, state.pagination, {
                pageSize
            })
        });
const useGridPageSize = (apiRef, props)=>{
    var _props$initialState2, _props$initialState2$;
    const logger = (0, _utils.useGridLogger)(apiRef, "useGridPageSize");
    const rowHeight = (0, _utils.useGridSelector)(apiRef, (0, _density.gridDensityRowHeightSelector));
    apiRef.current.unstable_registerControlState({
        stateId: "pageSize",
        propModel: props.pageSize,
        propOnChange: props.onPageSizeChange,
        stateSelector: (0, _gridPaginationSelector.gridPageSizeSelector),
        changeEvent: "pageSizeChange"
    });
    /**
   * API METHODS
   */ const setPageSize = _react.useCallback((pageSize)=>{
        if (pageSize === (0, _gridPaginationSelector.gridPageSizeSelector)(apiRef)) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setState(mergeStateWithPageSize(pageSize));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const pageSizeApi = {
        setPageSize
    };
    (0, _utils.useGridApiMethod)(apiRef, pageSizeApi, "GridPageSizeApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        var _props$initialState, _props$initialState$p;
        const pageSizeToExport = (0, _gridPaginationSelector.gridPageSizeSelector)(apiRef);
        const shouldExportPageSize = !context.exportOnlyDirtyModels || // Always export if the page size is controlled
        props.pageSize != null || // Always export if the page size has been initialized
        ((_props$initialState = props.initialState) == null ? void 0 : (_props$initialState$p = _props$initialState.pagination) == null ? void 0 : _props$initialState$p.pageSize) != null || // Export if the page size is not equal to the default value
        pageSizeToExport !== defaultPageSize(props.autoPageSize);
        if (!shouldExportPageSize) return prevState;
        return (0, _extendsDefault.default)({}, prevState, {
            pagination: (0, _extendsDefault.default)({}, prevState.pagination, {
                pageSize: pageSizeToExport
            })
        });
    }, [
        apiRef,
        props.pageSize,
        (_props$initialState2 = props.initialState) == null ? void 0 : (_props$initialState2$ = _props$initialState2.pagination) == null ? void 0 : _props$initialState2$.pageSize,
        props.autoPageSize
    ]);
    /**
   * TODO: Add error if `prop.autoHeight = true`
   */ const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        var _context$stateToResto;
        const pageSize = (_context$stateToResto = context.stateToRestore.pagination) == null ? void 0 : _context$stateToResto.pageSize;
        if (pageSize != null) apiRef.current.setState(mergeStateWithPageSize(pageSize));
        return params;
    }, [
        apiRef
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handleUpdateAutoPageSize = _react.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!props.autoPageSize || !dimensions) return;
        const pinnedRowsHeight = (0, _gridRowsUtils.calculatePinnedRowsHeight)(apiRef);
        const maximumPageSizeWithoutScrollBar = Math.floor((dimensions.viewportInnerSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom) / rowHeight);
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    (0, _utils.useGridApiEventHandler)(apiRef, "viewportInnerSizeChange", handleUpdateAutoPageSize);
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        if (props.pageSize != null && !props.autoPageSize) apiRef.current.setPageSize(props.pageSize);
    }, [
        apiRef,
        props.autoPageSize,
        props.pageSize
    ]);
    _react.useEffect(()=>{
        handleUpdateAutoPageSize();
    }, [
        handleUpdateAutoPageSize
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils":"43GNT","./gridPaginationSelector":"e6xRD","../density":"8Z1Np","../../core/pipeProcessing":"jx1az","../rows/gridRowsUtils":"iSo8b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Z1Np":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _densityState = require("./densityState");
parcelHelpers.exportAll(_densityState, exports);
var _densitySelector = require("./densitySelector");
parcelHelpers.exportAll(_densitySelector, exports);

},{"./densityState":false,"./densitySelector":"chMex","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"n1xiQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPageCount", ()=>getPageCount);
parcelHelpers.export(exports, "useGridPage", ()=>useGridPage);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("../../utils");
var _filter = require("../filter");
var _gridPaginationSelector = require("./gridPaginationSelector");
var _pipeProcessing = require("../../core/pipeProcessing");
var _warning = require("../../../utils/warning");
const getPageCount = (rowCount, pageSize)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    return 0;
};
const applyValidPage = (paginationState)=>{
    if (!paginationState.pageCount) return paginationState;
    return (0, _extendsDefault.default)({}, paginationState, {
        page: Math.max(Math.min(paginationState.page, paginationState.pageCount - 1), 0)
    });
};
const mergeStateWithPage = (page)=>(state)=>(0, _extendsDefault.default)({}, state, {
            pagination: applyValidPage((0, _extendsDefault.default)({}, state.pagination, {
                page
            }))
        });
const noRowCountInServerMode = (0, _warning.buildWarning)([
    "MUI: the 'rowCount' prop is undefined while using paginationMode='server'",
    "For more detail, see http://mui.com/components/data-grid/pagination/#basic-implementation"
], "error");
const useGridPage = (apiRef, props)=>{
    var _props$initialState2, _props$initialState2$;
    const logger = (0, _utils.useGridLogger)(apiRef, "useGridPage");
    const visibleTopLevelRowCount = (0, _utils.useGridSelector)(apiRef, (0, _filter.gridVisibleTopLevelRowCountSelector));
    apiRef.current.unstable_registerControlState({
        stateId: "page",
        propModel: props.page,
        propOnChange: props.onPageChange,
        stateSelector: (0, _gridPaginationSelector.gridPageSelector),
        changeEvent: "pageChange"
    });
    /**
   * API METHODS
   */ const setPage = _react.useCallback((page)=>{
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setState(mergeStateWithPage(page));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]);
    const pageApi = {
        setPage
    };
    (0, _utils.useGridApiMethod)(apiRef, pageApi, "GridPageApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        var _props$initialState, _props$initialState$p;
        const pageToExport = (0, _gridPaginationSelector.gridPageSelector)(apiRef);
        const shouldExportPage = !context.exportOnlyDirtyModels || // Always export if the page is controlled
        props.page != null || // Always export if the page has been initialized
        ((_props$initialState = props.initialState) == null ? void 0 : (_props$initialState$p = _props$initialState.pagination) == null ? void 0 : _props$initialState$p.page) != null || // Export if the page is not equal to the default value
        pageToExport !== 0;
        if (!shouldExportPage) return prevState;
        return (0, _extendsDefault.default)({}, prevState, {
            pagination: (0, _extendsDefault.default)({}, prevState.pagination, {
                page: pageToExport
            })
        });
    }, [
        apiRef,
        props.page,
        (_props$initialState2 = props.initialState) == null ? void 0 : (_props$initialState2$ = _props$initialState2.pagination) == null ? void 0 : _props$initialState2$.page
    ]);
    const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        var _context$stateToResto, _context$stateToResto2;
        // We apply the constraint even if the page did not change in case the pageSize changed.
        const page = (_context$stateToResto = (_context$stateToResto2 = context.stateToRestore.pagination) == null ? void 0 : _context$stateToResto2.page) != null ? _context$stateToResto : (0, _gridPaginationSelector.gridPageSelector)(apiRef);
        apiRef.current.setState(mergeStateWithPage(page));
        return params;
    }, [
        apiRef
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePageSizeChange = (pageSize)=>{
        apiRef.current.setState((state)=>{
            const pageCount = getPageCount(state.pagination.rowCount, pageSize);
            return (0, _extendsDefault.default)({}, state, {
                pagination: applyValidPage((0, _extendsDefault.default)({}, state.pagination, {
                    pageCount,
                    page: state.pagination.page
                }))
            });
        });
        apiRef.current.forceUpdate();
    };
    const handlePageChange = ()=>apiRef.current.scrollToIndexes({
            rowIndex: (0, _gridPaginationSelector.gridPageSelector)(apiRef) * (0, _gridPaginationSelector.gridPageSizeSelector)(apiRef)
        });
    (0, _utils.useGridApiEventHandler)(apiRef, "pageSizeChange", handlePageSizeChange);
    (0, _utils.useGridApiEventHandler)(apiRef, "pageChange", handlePageChange);
    /**
   * EFFECTS
   */ _react.useEffect(()=>{}, [
        props.rowCount,
        props.paginationMode
    ]);
    _react.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const rowCount = props.rowCount !== undefined ? props.rowCount : visibleTopLevelRowCount;
            const pageCount = getPageCount(rowCount, state.pagination.pageSize);
            const page = props.page == null ? state.pagination.page : props.page;
            return (0, _extendsDefault.default)({}, state, {
                pagination: applyValidPage((0, _extendsDefault.default)({}, state.pagination, {
                    page,
                    rowCount,
                    pageCount
                }))
            });
        });
        apiRef.current.forceUpdate();
    }, [
        visibleTopLevelRowCount,
        props.rowCount,
        props.page,
        props.paginationMode,
        apiRef
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils":"43GNT","../filter":"6FQgO","./gridPaginationSelector":"e6xRD","../../core/pipeProcessing":"jx1az","../../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bNriG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preferencePanelStateInitializer", ()=>preferencePanelStateInitializer);
parcelHelpers.export(exports, "useGridPreferencesPanel", ()=>useGridPreferencesPanel);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridPreferencePanelSelector = require("./gridPreferencePanelSelector");
const preferencePanelStateInitializer = (state, props)=>{
    var _props$initialState$p, _props$initialState;
    return (0, _extendsDefault.default)({}, state, {
        preferencePanel: (_props$initialState$p = (_props$initialState = props.initialState) == null ? void 0 : _props$initialState.preferencePanel) != null ? _props$initialState$p : {
            open: false
        }
    });
};
const useGridPreferencesPanel = (apiRef, props)=>{
    var _props$initialState3;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridPreferencesPanel");
    const hideTimeout = _react.useRef();
    const immediateTimeout = _react.useRef();
    /**
   * API METHODS
   */ const hidePreferences = _react.useCallback(()=>{
        logger.debug("Hiding Preferences Panel");
        const preferencePanelState = (0, _gridPreferencePanelSelector.gridPreferencePanelStateSelector)(apiRef.current.state);
        if (preferencePanelState.openedPanelValue) apiRef.current.publishEvent("preferencePanelClose", {
            openedPanelValue: preferencePanelState.openedPanelValue
        });
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                preferencePanel: {
                    open: false
                }
            }));
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger
    ]); // This is to prevent the preferences from closing when you open a select box or another panel,
    // The issue is in MUI core V4 => Fixed in V5
    const doNotHidePanel = _react.useCallback(()=>{
        immediateTimeout.current = setTimeout(()=>clearTimeout(hideTimeout.current), 0);
    }, []); // This is a hack for the issue with Core V4, by delaying hiding the panel on the clickAwayListener,
    // we can cancel the action if the trigger element still need the panel...
    const hidePreferencesDelayed = _react.useCallback(()=>{
        hideTimeout.current = setTimeout(hidePreferences, 100);
    }, [
        hidePreferences
    ]);
    const showPreferences = _react.useCallback((newValue)=>{
        logger.debug("Opening Preferences Panel");
        doNotHidePanel();
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                preferencePanel: (0, _extendsDefault.default)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue
                })
            }));
        apiRef.current.publishEvent("preferencePanelOpen", {
            openedPanelValue: newValue
        });
        apiRef.current.forceUpdate();
    }, [
        logger,
        doNotHidePanel,
        apiRef
    ]);
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, {
        showPreferences,
        hidePreferences: hidePreferencesDelayed
    }, "ColumnMenuApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        var _props$initialState2;
        const preferencePanelToExport = (0, _gridPreferencePanelSelector.gridPreferencePanelStateSelector)(apiRef.current.state);
        const shouldExportPreferencePanel = !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        ((_props$initialState2 = props.initialState) == null ? void 0 : _props$initialState2.preferencePanel) != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, _extendsDefault.default)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        (_props$initialState3 = props.initialState) == null ? void 0 : _props$initialState3.preferencePanel
    ]);
    const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        return ()=>{
            clearTimeout(hideTimeout.current);
            clearTimeout(immediateTimeout.current);
        };
    }, []);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../../core/pipeProcessing":"jx1az","./gridPreferencePanelSelector":"7GEzE","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9ifJa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editingStateInitializer", ()=>editingStateInitializer);
/**
 * @requires useGridFocus - can be after, async only
 * @requires useGridParamsApi (method)
 * @requires useGridColumns (state)
 */ parcelHelpers.export(exports, "useGridEditing", ()=>useGridEditing);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
var _useGridCellEditingOld = require("./useGridCellEditing.old");
var _useGridRowEditingOld = require("./useGridRowEditing.old");
const editingStateInitializer = (state)=>(0, _extendsDefault.default)({}, state, {
        editRows: {}
    });
function useGridEditing(apiRef, props) {
    var _props$experimentalFe2;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridEditRows");
    (0, _useGridCellEditingOld.useCellEditing)(apiRef, props);
    (0, _useGridRowEditingOld.useGridRowEditing)(apiRef, props);
    const debounceMap = _react.useRef({});
    apiRef.current.unstable_registerControlState({
        stateId: "editRows",
        propModel: props.editRowsModel,
        propOnChange: props.onEditRowsModelChange,
        stateSelector: (0, _gridEditRowsSelector.gridEditRowsStateSelector),
        changeEvent: "editRowsModelChange"
    });
    const isCellEditable = _react.useCallback((params)=>!params.rowNode.isAutoGenerated && !params.rowNode.isPinned && !!params.colDef.editable && !!params.colDef.renderEditCell && (!props.isCellEditable || props.isCellEditable(params)), [
        props.isCellEditable
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        const callbackToRunImmediately = ()=>{
            callback();
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            callbackToRunImmediately
        ];
    };
    const runPendingEditCellValueMutation = _react.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, callback] = debounceMap.current[id][debouncedField];
            callback();
        });
        else if (debounceMap.current[id][field]) {
            const [, callback] = debounceMap.current[id][field];
            callback();
        }
    }, []);
    const setEditCellValue = _react.useCallback((params, event = {})=>{
        maybeDebounce(params.id, params.field, params.debounceMs, ()=>{
            var _props$experimentalFe;
            if ((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.preventCommitWhileValidating) {
                if (props.editMode === "row") return apiRef.current.unstable_setRowEditingEditCellValue(params);
                return apiRef.current.unstable_setCellEditingEditCellValue(params);
            }
            const newParams = {
                id: params.id,
                field: params.field,
                props: {
                    value: params.value
                }
            };
            return apiRef.current.publishEvent("editCellPropsChange", newParams, event);
        });
    }, [
        apiRef,
        props.editMode,
        (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.preventCommitWhileValidating
    ]);
    const parseValue = _react.useCallback((id, field, value)=>{
        const column = apiRef.current.getColumn(field);
        return column.valueParser ? column.valueParser(value, apiRef.current.getCellParams(id, field)) : value;
    }, [
        apiRef
    ]);
    const setEditCellProps = _react.useCallback((params)=>{
        const { id, field, props: editProps } = params;
        logger.debug(`Setting cell props on id: ${id} field: ${field}`);
        apiRef.current.setState((state)=>{
            const editRowsModel = (0, _extendsDefault.default)({}, state.editRows);
            editRowsModel[id] = (0, _extendsDefault.default)({}, state.editRows[id]);
            editRowsModel[id][field] = (0, _extendsDefault.default)({}, editProps, {
                value: parseValue(id, field, editProps.value)
            });
            return (0, _extendsDefault.default)({}, state, {
                editRows: editRowsModel
            });
        });
        apiRef.current.forceUpdate();
        const editRowsState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        return editRowsState[id][field];
    }, [
        apiRef,
        logger,
        parseValue
    ]);
    const setEditRowsModel = _react.useCallback((model)=>{
        const currentModel = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting editRows model`);
            apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                    editRows: model
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const getEditRowsModel = _react.useCallback(()=>(0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state), [
        apiRef
    ]);
    const preventTextSelection = _react.useCallback((params, event)=>{
        const isMoreThanOneClick = event.detail > 1;
        if (params.isEditable && params.cellMode === (0, _gridEditRowModel.GridCellModes).View && isMoreThanOneClick) // If we click more than one time, then we prevent the default behavior of selecting the text cell.
        event.preventDefault();
    }, []);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellMouseDown", preventTextSelection);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "editCellPropsChange", props.onEditCellPropsChange); // TODO v6: remove, use `preProcessEditCellProps` instead
    const editingSharedApi = {
        isCellEditable,
        setEditRowsModel,
        getEditRowsModel,
        setEditCellValue,
        unstable_setEditCellProps: setEditCellProps,
        unstable_parseValue: parseValue,
        unstable_runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, editingSharedApi, "EditRowApi");
    _react.useEffect(()=>{
        if (props.editRowsModel !== undefined) apiRef.current.setEditRowsModel(props.editRowsModel);
    }, [
        apiRef,
        props.editRowsModel
    ]);
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../../models/gridEditRowModel":"5QORb","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","./gridEditRowsSelector":"978KN","./useGridCellEditing.old":"a0l0n","./useGridRowEditing.old":"fTyiA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"978KN":[function(require,module,exports) {
// TODO v6: rename to gridEditingStateSelector
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gridEditRowsStateSelector", ()=>gridEditRowsStateSelector);
const gridEditRowsStateSelector = (state)=>state.editRows;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a0l0n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCellEditing", ()=>useCellEditing);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
function isPromise(promise) {
    return typeof promise.then === "function";
}
const useCellEditing = (apiRef, props)=>{
    var _props$experimentalFe2;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridEditRows");
    const buildCallback = (callback)=>(...args)=>{
            if (props.editMode === (0, _gridEditRowModel.GridEditModes).Cell) callback(...args);
        };
    const setCellMode = _react.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) === mode) return;
        logger.debug(`Switching cell id: ${id} field: ${field} to mode: ${mode}`);
        apiRef.current.setState((state)=>{
            const newEditRowsState = (0, _extendsDefault.default)({}, state.editRows);
            newEditRowsState[id] = (0, _extendsDefault.default)({}, newEditRowsState[id]);
            if (mode === (0, _gridEditRowModel.GridCellModes).Edit) newEditRowsState[id][field] = {
                value: apiRef.current.getCellValue(id, field)
            };
            else {
                delete newEditRowsState[id][field];
                if (!Object.keys(newEditRowsState[id]).length) delete newEditRowsState[id];
            }
            return (0, _extendsDefault.default)({}, state, {
                editRows: newEditRowsState
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent("cellModeChange", apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger
    ]);
    const getCellMode = _react.useCallback((id, field)=>{
        const editRowsState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editRowsState[id] && editRowsState[id][field];
        return isEditing ? (0, _gridEditRowModel.GridCellModes).Edit : (0, _gridEditRowModel.GridCellModes).View;
    }, [
        apiRef
    ]); // TODO v6: it should always return a promise
    const commitCellChange = _react.useCallback((params, event = {})=>{
        var _props$experimentalFe;
        const { id, field } = params;
        apiRef.current.unstable_runPendingEditCellValueMutation(id, field);
        const model = apiRef.current.getEditRowsModel();
        if (!model[id] || !model[id][field]) throw new Error(`MUI: Cell at id: ${id} and field: ${field} is not in edit mode.`);
        const editCellProps = model[id][field];
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if ((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.preventCommitWhileValidating) {
            const cellProps = model[id][field];
            if (cellProps.isValidating || cellProps.error) return false;
        }
        const commitParams = (0, _extendsDefault.default)({}, params, {
            value: editCellProps.value
        });
        let hasError = !!editCellProps.error;
        if (!hasError && typeof column.preProcessEditCellProps === "function") {
            const result = column.preProcessEditCellProps({
                id,
                row,
                props: editCellProps
            });
            if (isPromise(result)) return result.then((newEditCellProps)=>{
                apiRef.current.unstable_setEditCellProps({
                    id,
                    field,
                    props: newEditCellProps
                });
                if (newEditCellProps.error) return false;
                apiRef.current.publishEvent("cellEditCommit", commitParams, event);
                return true;
            });
            apiRef.current.unstable_setEditCellProps({
                id,
                field,
                props: result
            });
            hasError = !!result.error;
        }
        if (!hasError) {
            apiRef.current.publishEvent("cellEditCommit", commitParams, event);
            return true;
        }
        return false;
    }, [
        apiRef,
        (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.preventCommitWhileValidating
    ]);
    const setCellEditingEditCellValue = _react.useCallback((params)=>{
        const column = apiRef.current.getColumn(params.field);
        const row = apiRef.current.getRow(params.id);
        return new Promise((resolve)=>{
            let newEditCellProps = {
                value: params.value
            };
            const model = apiRef.current.getEditRowsModel();
            const editCellProps = model[params.id][params.field];
            if (typeof column.preProcessEditCellProps !== "function") {
                apiRef.current.unstable_setEditCellProps((0, _extendsDefault.default)({}, params, {
                    props: newEditCellProps
                }));
                resolve(true);
                return;
            } // setEditCellProps runs the value parser and returns the updated props
            newEditCellProps = apiRef.current.unstable_setEditCellProps((0, _extendsDefault.default)({}, params, {
                props: (0, _extendsDefault.default)({}, editCellProps, {
                    isValidating: true
                })
            }));
            Promise.resolve(column.preProcessEditCellProps({
                id: params.id,
                row,
                props: (0, _extendsDefault.default)({}, newEditCellProps, {
                    value: apiRef.current.unstable_parseValue(params.id, params.field, params.value)
                })
            })).then((newEditCellPropsProcessed)=>{
                apiRef.current.unstable_setEditCellProps((0, _extendsDefault.default)({}, params, {
                    props: (0, _extendsDefault.default)({}, newEditCellPropsProcessed, {
                        isValidating: false
                    })
                }));
                resolve(!newEditCellPropsProcessed.error);
            });
        });
    }, [
        apiRef
    ]);
    const cellEditingApi = {
        setCellMode,
        getCellMode,
        commitCellChange,
        unstable_setCellEditingEditCellValue: setCellEditingEditCellValue
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, cellEditingApi, "EditRowApi");
    const handleCellKeyDown = _react.useCallback(async (params, event)=>{
        // Wait until IME is settled for Asian languages like Japanese and Chinese
        // TODO: `event.which` is depricated but this is a temporary workaround
        if (event.which === 229) return;
        const { id, field, cellMode, isEditable } = params;
        if (!isEditable) return;
        const isEditMode = cellMode === (0, _gridEditRowModel.GridCellModes).Edit;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (!isEditMode && (0, _keyboardUtils.isCellEnterEditModeKeys)(event) && !isModifierKeyPressed && !(event.key === " " && event.shiftKey)) apiRef.current.publishEvent("cellEditStart", params, event);
        if (!isEditMode && (0, _keyboardUtils.isDeleteKeys)(event.key)) {
            apiRef.current.setEditCellValue({
                id,
                field,
                value: ""
            });
            apiRef.current.commitCellChange({
                id,
                field
            }, event);
            apiRef.current.publishEvent("cellEditStop", params, event);
        }
        if (isEditMode && (0, _keyboardUtils.isCellEditCommitKeys)(event.key)) {
            const commitParams = {
                id,
                field
            };
            const isValid = await apiRef.current.commitCellChange(commitParams, event);
            if (!isValid) return;
        }
        if (isEditMode && (0, _keyboardUtils.isCellExitEditModeKeys)(event.key)) apiRef.current.publishEvent("cellEditStop", params, event);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        apiRef.current.publishEvent("cellEditStart", params, event);
    }, [
        apiRef
    ]);
    const commitPropsAndExit = async (params, event)=>{
        if (params.cellMode === (0, _gridEditRowModel.GridCellModes).View) return;
        await apiRef.current.commitCellChange(params, event);
        apiRef.current.publishEvent("cellEditStop", params, event);
    };
    const handleCellFocusOut = (0, _utils.useEventCallback)((params, event)=>{
        commitPropsAndExit(params, event);
    });
    const handleColumnHeaderDragStart = (0, _utils.useEventCallback)(()=>{
        const cell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        if (!cell) return;
        const params = apiRef.current.getCellParams(cell.id, cell.field);
        commitPropsAndExit(params, {});
    });
    const handleCellEditStart = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        apiRef.current.setCellMode(params.id, params.field, (0, _gridEditRowModel.GridCellModes).Edit);
        if ((0, _keyboardUtils.isKeyboardEvent)(event) && (0, _keyboardUtils.isPrintableKey)(event)) apiRef.current.unstable_setEditCellProps({
            id: params.id,
            field: params.field,
            props: {
                value: ""
            }
        });
    }, [
        apiRef
    ]);
    const handleCellEditStop = _react.useCallback((params, event)=>{
        apiRef.current.setCellMode(params.id, params.field, (0, _gridEditRowModel.GridCellModes).View);
        if (!(0, _keyboardUtils.isKeyboardEvent)(event)) return;
        if ((0, _keyboardUtils.isCellEditCommitKeys)(event.key)) {
            apiRef.current.publishEvent("cellNavigationKeyDown", params, event);
            return;
        }
        if (event.key === "Escape" || (0, _keyboardUtils.isDeleteKeys)(event.key)) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleCellEditCommit = _react.useCallback((params)=>{
        const { id, field } = params;
        const model = apiRef.current.getEditRowsModel();
        const { value } = model[id][field];
        logger.debug(`Setting cell id: ${id} field: ${field} to value: ${value == null ? void 0 : value.toString()}`);
        const row = apiRef.current.getRow(id);
        if (row) {
            const column = apiRef.current.getColumn(params.field);
            let rowUpdate = (0, _extendsDefault.default)({}, row, {
                [field]: value
            });
            if (column.valueSetter) rowUpdate = column.valueSetter({
                row,
                value
            });
            apiRef.current.updateRows([
                rowUpdate
            ]);
        }
    }, [
        apiRef,
        logger
    ]);
    const handleEditCellPropsChange = _react.useCallback((params)=>{
        const row = apiRef.current.getRow(params.id);
        const column = apiRef.current.getColumn(params.field);
        const editCellProps = column.preProcessEditCellProps ? column.preProcessEditCellProps({
            id: params.id,
            row,
            props: params.props
        }) : params.props;
        if (isPromise(editCellProps)) editCellProps.then((newEditCellProps)=>{
            apiRef.current.unstable_setEditCellProps((0, _extendsDefault.default)({}, params, {
                props: newEditCellProps
            }));
        });
        else apiRef.current.unstable_setEditCellProps((0, _extendsDefault.default)({}, params, {
            props: editCellProps
        }));
    }, [
        apiRef
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", buildCallback(handleCellKeyDown));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellDoubleClick", buildCallback(handleCellDoubleClick));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusOut", buildCallback(handleCellFocusOut));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragStart", buildCallback(handleColumnHeaderDragStart));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellEditStart", buildCallback(handleCellEditStart));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellEditStop", buildCallback(handleCellEditStop));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellEditCommit", buildCallback(handleCellEditCommit));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "editCellPropsChange", buildCallback(handleEditCellPropsChange));
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellEditCommit", props.onCellEditCommit);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellEditStart", props.onCellEditStart);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellEditStop", props.onCellEditStop);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridApiEventHandler":"iBXeM","../../../models/gridEditRowModel":"5QORb","../../../utils/keyboardUtils":"o7lWn","../../utils/useGridLogger":"6dTTN","../focus/gridFocusStateSelector":"7pS2P","../../utils/useGridApiMethod":"5EPiD","./gridEditRowsSelector":"978KN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fTyiA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRowEditing", ()=>useGridRowEditing);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _useGridSelector = require("../../utils/useGridSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
const useGridRowEditing = (apiRef, props)=>{
    var _props$experimentalFe2, _props$experimentalFe4;
    const focusTimeout = _react.useRef(null);
    const nextFocusedCell = _react.useRef(null);
    const columns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnDefinitionsSelector));
    const buildCallback = (callback)=>(...args)=>{
            if (props.editMode === (0, _gridEditRowModel.GridEditModes).Row) callback(...args);
        };
    const setRowMode = _react.useCallback((id, mode)=>{
        if (mode === apiRef.current.getRowMode(id)) return;
        apiRef.current.setState((state)=>{
            const newEditRowsState = (0, _extendsDefault.default)({}, state.editRows);
            if (mode === (0, _gridEditRowModel.GridRowModes).Edit) {
                newEditRowsState[id] = {};
                columns.forEach((column)=>{
                    const cellParams = apiRef.current.getCellParams(id, column.field);
                    if (cellParams.isEditable) newEditRowsState[id][column.field] = {
                        value: cellParams.value
                    };
                });
            } else delete newEditRowsState[id];
            return (0, _extendsDefault.default)({}, state, {
                editRows: newEditRowsState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        columns
    ]);
    const getRowMode = _react.useCallback((id)=>{
        if (props.editMode === (0, _gridEditRowModel.GridEditModes).Cell) return (0, _gridEditRowModel.GridRowModes).View;
        const editRowsState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        return editRowsState[id] ? (0, _gridEditRowModel.GridRowModes).Edit : (0, _gridEditRowModel.GridRowModes).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const commitRowChange = _react.useCallback((id, event = {})=>{
        var _props$experimentalFe;
        if (props.editMode === (0, _gridEditRowModel.GridEditModes).Cell) throw new Error(`MUI: You can't commit changes when the edit mode is 'cell'.`);
        apiRef.current.unstable_runPendingEditCellValueMutation(id);
        const model = apiRef.current.getEditRowsModel();
        const editRowProps = model[id];
        if (!editRowProps) throw new Error(`MUI: Row at id: ${id} is not being edited.`);
        if ((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.preventCommitWhileValidating) {
            const isValid = Object.keys(editRowProps).reduce((acc, field)=>{
                return acc && !editRowProps[field].isValidating && !editRowProps[field].error;
            }, true);
            if (!isValid) return false;
        }
        const hasFieldWithError = Object.values(editRowProps).some((value)=>!!value.error);
        if (hasFieldWithError) return false;
        const fieldsWithValidator = Object.keys(editRowProps).filter((field)=>{
            const column = apiRef.current.getColumn(field);
            return typeof column.preProcessEditCellProps === "function";
        });
        if (fieldsWithValidator.length > 0) {
            const row = apiRef.current.getRow(id);
            const validatorErrors = fieldsWithValidator.map(async (field)=>{
                const column = apiRef.current.getColumn(field);
                const newEditCellProps = await Promise.resolve(column.preProcessEditCellProps({
                    id,
                    row,
                    props: editRowProps[field]
                }));
                apiRef.current.unstable_setEditCellProps({
                    id,
                    field,
                    props: newEditCellProps
                });
                return newEditCellProps.error;
            });
            return Promise.all(validatorErrors).then((errors)=>{
                if (errors.some((error)=>!!error)) return false;
                apiRef.current.publishEvent("rowEditCommit", id, event);
                return true;
            });
        }
        apiRef.current.publishEvent("rowEditCommit", id, event);
        return true;
    }, [
        apiRef,
        props.editMode,
        (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.preventCommitWhileValidating
    ]);
    const setRowEditingEditCellValue = _react.useCallback((params)=>{
        const model = apiRef.current.getEditRowsModel();
        const editRow = model[params.id];
        const row = apiRef.current.getRow(params.id);
        let isValid = true;
        return new Promise((resolve)=>{
            Object.keys(editRow).forEach(async (field)=>{
                const column = apiRef.current.getColumn(field);
                let editCellProps = field === params.field ? {
                    value: params.value
                } : editRow[field]; // setEditCellProps runs the value parser and returns the updated props
                editCellProps = apiRef.current.unstable_setEditCellProps({
                    id: params.id,
                    field,
                    props: (0, _extendsDefault.default)({}, editCellProps, {
                        isValidating: true
                    })
                });
                if (column.preProcessEditCellProps) editCellProps = await Promise.resolve(column.preProcessEditCellProps({
                    id: params.id,
                    row,
                    props: (0, _extendsDefault.default)({}, editCellProps, {
                        value: field === params.field ? apiRef.current.unstable_parseValue(params.id, field, params.value) : editCellProps.value
                    })
                }));
                if (editCellProps.error) isValid = false;
                apiRef.current.unstable_setEditCellProps({
                    id: params.id,
                    field,
                    props: (0, _extendsDefault.default)({}, editCellProps, {
                        isValidating: false
                    })
                });
            });
            resolve(isValid);
        });
    }, [
        apiRef
    ]);
    const rowEditingApi = {
        setRowMode,
        getRowMode,
        commitRowChange,
        unstable_setRowEditingEditCellValue: setRowEditingEditCellValue
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, rowEditingApi, "EditRowApi");
    const handleCellKeyDown = _react.useCallback(async (params, event)=>{
        // Wait until IME is settled for Asian languages like Japanese and Chinese
        // TODO: `event.which` is depricated but this is a temporary workaround
        if (event.which === 229) return;
        const { cellMode, isEditable } = params;
        if (!isEditable) return;
        const isEditMode = cellMode === (0, _gridEditRowModel.GridCellModes).Edit;
        const rowParams = apiRef.current.getRowParams(params.id);
        if (isEditMode) {
            if (event.key === "Enter") {
                var _props$experimentalFe3;
                // TODO: check the return before firing 'rowEditStop'
                // On cell editing, it won't exits the edit mode with error
                const isValid = await apiRef.current.commitRowChange(params.id);
                if (!isValid && (_props$experimentalFe3 = props.experimentalFeatures) != null && _props$experimentalFe3.preventCommitWhileValidating) return;
                apiRef.current.publishEvent("rowEditStop", rowParams, event);
            } else if (event.key === "Escape") apiRef.current.publishEvent("rowEditStop", rowParams, event);
        } else if (event.key === "Enter") apiRef.current.publishEvent("rowEditStart", rowParams, event);
    }, [
        apiRef,
        (_props$experimentalFe4 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe4.preventCommitWhileValidating
    ]);
    const handleCellDoubleClick = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        apiRef.current.publishEvent("rowEditStart", rowParams, event);
    }, [
        apiRef
    ]);
    const handleEditCellPropsChange = _react.useCallback((params)=>{
        const row = apiRef.current.getRow(params.id);
        const model = apiRef.current.getEditRowsModel();
        const editRow = model[params.id];
        Object.keys(editRow).forEach(async (field)=>{
            const column = apiRef.current.getColumn(field);
            if (column.preProcessEditCellProps) {
                const editCellProps = field === params.field ? params.props : editRow[field];
                const newEditCellProps = await Promise.resolve(column.preProcessEditCellProps({
                    id: params.id,
                    row,
                    props: editCellProps
                }));
                apiRef.current.unstable_setEditCellProps({
                    id: params.id,
                    field,
                    props: newEditCellProps
                });
            } else if (field === params.field) apiRef.current.unstable_setEditCellProps(params);
        });
    }, [
        apiRef
    ]);
    const handleRowEditStart = _react.useCallback((params)=>{
        apiRef.current.setRowMode(params.id, (0, _gridEditRowModel.GridRowModes).Edit);
    }, [
        apiRef
    ]);
    const handleRowEditStop = _react.useCallback((params, event)=>{
        apiRef.current.setRowMode(params.id, (0, _gridEditRowModel.GridRowModes).View);
        if (event.key === "Enter") apiRef.current.publishEvent("cellNavigationKeyDown", params, event);
    }, [
        apiRef
    ]);
    const handleRowEditCommit = _react.useCallback((id)=>{
        const model = apiRef.current.getEditRowsModel();
        const editRow = model[id];
        if (!editRow) throw new Error(`MUI: Row at id: ${id} is not being edited.`);
        const row = apiRef.current.getRow(id);
        if (row) {
            let rowUpdate = (0, _extendsDefault.default)({}, row);
            Object.keys(editRow).forEach((field)=>{
                const column = apiRef.current.getColumn(field);
                const value = editRow[field].value;
                if (column.valueSetter) rowUpdate = column.valueSetter({
                    row: rowUpdate,
                    value
                });
                else rowUpdate[field] = value;
            });
            apiRef.current.updateRows([
                rowUpdate
            ]);
        }
    }, [
        apiRef
    ]);
    const handleCellFocusIn = _react.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const commitPropsAndExit = async (params, event)=>{
        if (params.cellMode === (0, _gridEditRowModel.GridCellModes).View) return;
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(async ()=>{
            var _nextFocusedCell$curr;
            if (((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
                await apiRef.current.commitRowChange(params.id, event);
                const rowParams = apiRef.current.getRowParams(params.id);
                apiRef.current.publishEvent("rowEditStop", rowParams, event);
            }
        });
    };
    const handleCellFocusOut = (0, _utils.useEventCallback)((params, event)=>{
        commitPropsAndExit(params, event);
    });
    const handleColumnHeaderDragStart = (0, _utils.useEventCallback)(()=>{
        const cell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        if (!cell) return;
        const params = apiRef.current.getCellParams(cell.id, cell.field);
        commitPropsAndExit(params, {});
    });
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", buildCallback(handleCellKeyDown));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellDoubleClick", buildCallback(handleCellDoubleClick));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "editCellPropsChange", buildCallback(handleEditCellPropsChange));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowEditStart", buildCallback(handleRowEditStart));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowEditStop", buildCallback(handleRowEditStop));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowEditCommit", buildCallback(handleRowEditCommit));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusIn", buildCallback(handleCellFocusIn));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusOut", buildCallback(handleCellFocusOut));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragStart", buildCallback(handleColumnHeaderDragStart));
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowEditCommit", props.onRowEditCommit);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowEditStart", props.onRowEditStart);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowEditStop", props.onRowEditStop);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridApiMethod":"5EPiD","../../../models/gridEditRowModel":"5QORb","../../utils/useGridSelector":"96gNX","../columns/gridColumnsSelector":"aeHtc","./gridEditRowsSelector":"978KN","../focus/gridFocusStateSelector":"7pS2P","../../utils/useGridApiEventHandler":"iBXeM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"rKilY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "editingStateInitializer", ()=>editingStateInitializer);
parcelHelpers.export(exports, "useGridEditing", ()=>useGridEditing);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridCellEditingNew = require("./useGridCellEditing.new");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _useGridRowEditingNew = require("./useGridRowEditing.new");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
const editingStateInitializer = (state)=>(0, _extendsDefault.default)({}, state, {
        editRows: {}
    });
const useGridEditing = (apiRef, props)=>{
    (0, _useGridCellEditingNew.useGridCellEditing)(apiRef, props);
    (0, _useGridRowEditingNew.useGridRowEditing)(apiRef, props);
    const debounceMap = _react.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = _react.useCallback((params)=>{
        if (params.rowNode.isAutoGenerated) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        if (params.rowNode.isPinned) return false;
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        } // To run the callback immediatelly without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    _react.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = _react.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = _react.useCallback((params)=>{
        const { id, field, debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, _gridEditRowModel.GridEditModes).Row ? apiRef.current.unstable_setRowEditingEditCellValue : apiRef.current.unstable_setCellEditingEditCellValue; // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, _gridEditRowModel.GridCellModes).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = _react.useCallback((id, field)=>{
        return props.editMode === (0, _gridEditRowModel.GridEditModes).Cell ? apiRef.current.unstable_getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.unstable_getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = _react.useCallback((id, field)=>{
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        return {
            changeReason: editingState[id][field].changeReason
        };
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable,
        setEditCellValue,
        unstable_runPendingEditCellValueMutation: runPendingEditCellValueMutation,
        unstable_getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, editingSharedApi, "EditingApi");
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","./useGridCellEditing.new":"bFN2E","../../../models/gridEditRowModel":"5QORb","./useGridRowEditing.new":"149zd","./gridEditRowsSelector":"978KN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bFN2E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridCellEditing", ()=>useGridCellEditing);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _toPropertyKey = require("@babel/runtime/helpers/esm/toPropertyKey");
var _toPropertyKeyDefault = parcelHelpers.interopDefault(_toPropertyKey);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _warning = require("../../../utils/warning");
var _gridRowsSelector = require("../rows/gridRowsSelector");
var _utils1 = require("../../../utils/utils");
var _gridEditCellParams = require("../../../models/params/gridEditCellParams");
const _excluded = [
    "id",
    "field"
], _excluded2 = [
    "id",
    "field"
];
const missingOnProcessRowUpdateErrorWarning = (0, _warning.buildWarning)([
    "MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.",
    "To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.",
    "For more detail, see http://mui.com/components/data-grid/editing/#persistence."
], "error");
const useGridCellEditing = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = _react.useState({});
    const cellModesModelRef = _react.useRef(cellModesModel);
    const prevCellModesModel = _react.useRef({});
    const { processRowUpdate, onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange, signature } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, _gridEditRowModel.GridEditModes).Cell) callback(...args);
        };
    const throwIfNotEditable = _react.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = _react.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, _gridEditRowModel.GridCellModes).Edit) return;
        const newParams = (0, _extendsDefault.default)({}, params, {
            reason: (0, _gridEditCellParams.GridCellEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent("cellEditStart", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = _react.useCallback((params, event)=>{
        if (params.cellMode === (0, _gridEditRowModel.GridCellModes).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, _gridEditRowModel.GridCellModes).View) return;
        const newParams = (0, _extendsDefault.default)({}, params, {
            reason: (0, _gridEditCellParams.GridCellEditStopReasons).cellFocusOut
        });
        apiRef.current.publishEvent("cellEditStop", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = _react.useCallback((params, event)=>{
        if (params.cellMode === (0, _gridEditRowModel.GridCellModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is depricated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === "Escape") reason = (0, _gridEditCellParams.GridCellEditStopReasons).escapeKeyDown;
            else if (event.key === "Enter") reason = (0, _gridEditCellParams.GridCellEditStopReasons).enterKeyDown;
            else if (event.key === "Tab") {
                reason = event.shiftKey ? (0, _gridEditCellParams.GridCellEditStopReasons).shiftTabKeyDown : (0, _gridEditCellParams.GridCellEditStopReasons).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, _extendsDefault.default)({}, params, {
                    reason
                });
                apiRef.current.publishEvent("cellEditStop", newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            if (event.key === " " && event.shiftKey) return; // Shift + Space is used to select the row
            if ((0, _keyboardUtils.isPrintableKey)(event)) reason = (0, _gridEditCellParams.GridCellEditStartReasons).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === "v") reason = (0, _gridEditCellParams.GridCellEditStartReasons).printableKeyDown;
            else if (event.key === "Enter") reason = (0, _gridEditCellParams.GridCellEditStartReasons).enterKeyDown;
            else if (event.key === "Delete" || event.key === "Backspace") // Delete on Windows, Backspace on macOS
            reason = (0, _gridEditCellParams.GridCellEditStartReasons).deleteKeyDown;
            if (reason) {
                const newParams = (0, _extendsDefault.default)({}, params, {
                    reason,
                    key: event.key
                });
                apiRef.current.publishEvent("cellEditStart", newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = _react.useCallback((params)=>{
        const { id, field, reason, key } = params;
        const startCellEditModeParams = {
            id,
            field
        };
        if (reason === (0, _gridEditCellParams.GridCellEditStartReasons).printableKeyDown) {
            if (_react.version.startsWith("18")) startCellEditModeParams.initialValue = key; // In React 17, cleaning the input is enough
            else startCellEditModeParams.deleteValue = true;
        } else if (reason === (0, _gridEditCellParams.GridCellEditStartReasons).deleteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = _react.useCallback((params)=>{
        const { id, field, reason } = params;
        apiRef.current.unstable_runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, _gridEditCellParams.GridCellEditStopReasons).enterKeyDown) cellToFocusAfter = "below";
        else if (reason === (0, _gridEditCellParams.GridCellEditStopReasons).tabKeyDown) cellToFocusAfter = "right";
        else if (reason === (0, _gridEditCellParams.GridCellEditStopReasons).shiftTabKeyDown) cellToFocusAfter = "left";
        let ignoreModifications = reason === "escapeKeyDown";
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        if (editingState[id][field].isProcessingProps && !props.disableIgnoreModificationsIfProcessingProps) // The user wants to stop editing the cell but we can't wait for the props to be processed.
        // In this case, discard the modifications.
        ignoreModifications = true;
        apiRef.current.stopCellEditMode({
            id,
            field,
            ignoreModifications,
            cellToFocusAfter
        });
    }, [
        apiRef,
        props.disableIgnoreModificationsIfProcessingProps
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellDoubleClick", runIfEditModeIsCell(handleCellDoubleClick));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusOut", runIfEditModeIsCell(handleCellFocusOut));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", runIfEditModeIsCell(handleCellKeyDown));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellEditStart", runIfEditModeIsCell(handleCellEditStart));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellEditStop", runIfEditModeIsCell(handleCellEditStop));
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellEditStart", props.onCellEditStart);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellEditStop", props.onCellEditStop);
    const getCellMode = _react.useCallback((id, field)=>{
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, _gridEditRowModel.GridCellModes).Edit : (0, _gridEditRowModel.GridCellModes).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, _utils.unstable_useEventCallback)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) {
            const details = signature === (0, _useGridApiEventHandler.GridSignature).DataGridPro ? {
                api: apiRef.current
            } : {};
            onCellModesModelChange(newModel, details);
        }
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent("cellModesModelChange", newModel);
    });
    const updateFieldInCellModesModel = _react.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, _extendsDefault.default)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, _extendsDefault.default)({}, newModel[id], {
            [field]: (0, _extendsDefault.default)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, _objectWithoutPropertiesLooseDefault.default)(_newModel$id, [
                field
            ].map((0, _toPropertyKeyDefault.default))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = _react.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, _extendsDefault.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, _extendsDefault.default)({}, newEditingState[id], {
                [field]: (0, _extendsDefault.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, _extendsDefault.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startCellEditMode = _react.useCallback((params)=>{
        const { id, field } = params, other = (0, _objectWithoutPropertiesLooseDefault.default)(params, _excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, _gridEditRowModel.GridCellModes).View);
        updateFieldInCellModesModel(id, field, (0, _extendsDefault.default)({
            mode: (0, _gridEditRowModel.GridCellModes).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, _utils.unstable_useEventCallback)((params)=>{
        const { id, field, deleteValue, initialValue } = params;
        let newValue = apiRef.current.getCellValue(id, field);
        if (deleteValue || initialValue) newValue = deleteValue ? "" : initialValue;
        const newProps = {
            value: newValue,
            error: false,
            isProcessingProps: false
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
    });
    const stopCellEditMode = _react.useCallback((params)=>{
        const { id, field } = params, other = (0, _objectWithoutPropertiesLooseDefault.default)(params, _excluded2);
        throwIfNotInMode(id, field, (0, _gridEditRowModel.GridCellModes).Edit);
        updateFieldInCellModesModel(id, field, (0, _extendsDefault.default)({
            mode: (0, _gridEditRowModel.GridCellModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, _utils.unstable_useEventCallback)(async (params)=>{
        const { id, field, ignoreModifications, cellToFocusAfter = "none" } = params;
        throwIfNotInMode(id, field, (0, _gridEditRowModel.GridCellModes).Edit);
        apiRef.current.unstable_runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== "none") apiRef.current.unstable_moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const { error, isProcessingProps } = editingState[id][field];
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, _gridEditRowModel.GridCellModes).Edit; // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, _gridEditRowModel.GridCellModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.unstable_getRowWithUpdatedValuesFromCellEditing(id, field);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, _gridEditRowModel.GridCellModes).Edit; // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, _gridEditRowModel.GridCellModes).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else missingOnProcessRowUpdateErrorWarning();
            };
            try {
                const row = apiRef.current.getRow(id);
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = _react.useCallback(async (params)=>{
        var _editingState$id, _editingState$id$fiel;
        const { id, field, value, debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, _gridEditRowModel.GridCellModes).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, _extendsDefault.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? "debouncedSetEditCellValue" : "setEditCellValue"
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, _extendsDefault.default)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id,
                row,
                props: newProps,
                hasChanged
            }));
        } // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, _gridEditRowModel.GridCellModes).View) return false;
        editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        newProps = (0, _extendsDefault.default)({}, newProps, {
            isProcessingProps: false
        }); // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        return !((_editingState$id = editingState[id]) != null && (_editingState$id$fiel = _editingState$id[field]) != null && _editingState$id$fiel.error);
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = _react.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const { value } = editingState[id][field];
        const row = apiRef.current.getRow(id);
        return column.valueSetter ? column.valueSetter({
            value,
            row
        }) : (0, _extendsDefault.default)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode,
        startCellEditMode,
        stopCellEditMode,
        unstable_setCellEditingEditCellValue: setCellEditingEditCellValue,
        unstable_getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, editingApi, "EditingApi");
    _react.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    _react.useEffect(()=>{
        const idToIdLookup = (0, _gridRowsSelector.gridRowsIdToIdLookupSelector)(apiRef); // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, _utils1.deepClone)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                var _copyOfPrevCellModes$, _copyOfPrevCellModes$2, _idToIdLookup$id;
                const prevMode = ((_copyOfPrevCellModes$ = copyOfPrevCellModes[id]) == null ? void 0 : (_copyOfPrevCellModes$2 = _copyOfPrevCellModes$[field]) == null ? void 0 : _copyOfPrevCellModes$2.mode) || (0, _gridEditRowModel.GridCellModes).View;
                const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
                if (params.mode === (0, _gridEditRowModel.GridCellModes).Edit && prevMode === (0, _gridEditRowModel.GridCellModes).View) updateStateToStartCellEditMode((0, _extendsDefault.default)({
                    id: originalId,
                    field
                }, params));
                else if (params.mode === (0, _gridEditRowModel.GridCellModes).View && prevMode === (0, _gridEditRowModel.GridCellModes).Edit) updateStateToStopCellEditMode((0, _extendsDefault.default)({
                    id: originalId,
                    field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/toPropertyKey":"4TadU","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","../../utils/useGridApiEventHandler":"iBXeM","../../../models/gridEditRowModel":"5QORb","../../utils/useGridApiMethod":"5EPiD","./gridEditRowsSelector":"978KN","../../../utils/keyboardUtils":"o7lWn","../../../utils/warning":"cfes8","../rows/gridRowsSelector":"fCZaq","../../../utils/utils":"lwlsg","../../../models/params/gridEditCellParams":"gRNwJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gRNwJ":[function(require,module,exports) {
// TODO v6 - remove
/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ // TODO v6 - remove
// TODO v6 - remove
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/mui/mui-x/pull/3738#discussion_r798504277
parcelHelpers.export(exports, "GridCellEditStartReasons", ()=>GridCellEditStartReasons);
parcelHelpers.export(exports, "GridCellEditStopReasons", ()=>GridCellEditStopReasons);
var GridCellEditStartReasons;
/**
 * Params passed to the `cellEditStart` event.
 */ (function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
})(GridCellEditStartReasons || (GridCellEditStartReasons = {}));
var GridCellEditStopReasons;
/**
 * Params passed to the `cellEditStop event.
 */ (function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
})(GridCellEditStopReasons || (GridCellEditStopReasons = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"149zd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRowEditing", ()=>useGridRowEditing);
var _toPropertyKey = require("@babel/runtime/helpers/esm/toPropertyKey");
var _toPropertyKeyDefault = parcelHelpers.interopDefault(_toPropertyKey);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridEditRowsSelector = require("./gridEditRowsSelector");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _warning = require("../../../utils/warning");
var _gridRowsSelector = require("../rows/gridRowsSelector");
var _utils1 = require("../../../utils/utils");
var _gridRowParams = require("../../../models/params/gridRowParams");
const _excluded = [
    "id"
], _excluded2 = [
    "id"
];
const missingOnProcessRowUpdateErrorWarning = (0, _warning.buildWarning)([
    "MUI: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.",
    "To handle the error pass a callback to the `onProcessRowUpdateError` prop, e.g. `<DataGrid onProcessRowUpdateError={(error) => ...} />`.",
    "For more detail, see http://mui.com/components/data-grid/editing/#persistence."
], "error");
const useGridRowEditing = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = _react.useState({});
    const rowModesModelRef = _react.useRef(rowModesModel);
    const prevRowModesModel = _react.useRef({});
    const focusTimeout = _react.useRef(null);
    const nextFocusedCell = _react.useRef(null);
    const { processRowUpdate, onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange, signature } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, _gridEditRowModel.GridEditModes).Row) callback(...args);
        };
    const throwIfNotEditable = _react.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = _react.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, _gridEditRowModel.GridRowModes).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, _extendsDefault.default)({}, rowParams, {
            field: params.field,
            reason: (0, _gridRowParams.GridRowEditStartReasons).cellDoubleClick
        });
        apiRef.current.publishEvent("rowEditStart", newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = _react.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = _react.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, _gridEditRowModel.GridRowModes).View) return;
         // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            var _nextFocusedCell$curr;
            focusTimeout.current = null;
            if (((_nextFocusedCell$curr = nextFocusedCell.current) == null ? void 0 : _nextFocusedCell$curr.id) !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                 // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, _gridEditRowModel.GridRowModes).View) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, _extendsDefault.default)({}, rowParams, {
                    field: params.field,
                    reason: (0, _gridRowParams.GridRowEditStopReasons).rowFocusOut
                });
                apiRef.current.publishEvent("rowEditStop", newParams, event);
            }
        });
    }, [
        apiRef
    ]);
    _react.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = _react.useCallback((params, event)=>{
        if (params.cellMode === (0, _gridEditRowModel.GridRowModes).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: `event.which` is depricated but this is a temporary workaround
            if (event.which === 229) return;
            let reason;
            if (event.key === "Escape") reason = (0, _gridRowParams.GridRowEditStopReasons).escapeKeyDown;
            else if (event.key === "Enter") reason = (0, _gridRowParams.GridRowEditStopReasons).enterKeyDown;
            else if (event.key === "Tab") {
                const columnFields = (0, _gridColumnsSelector.gridColumnFieldsSelector)(apiRef).filter((field)=>apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field)));
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, _gridRowParams.GridRowEditStopReasons).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, _gridRowParams.GridRowEditStopReasons).tabKeyDown;
                if (reason) event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, _extendsDefault.default)({}, rowParams, {
                    reason,
                    field: params.field
                });
                apiRef.current.publishEvent("rowEditStop", newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            if (event.key === " " && event.shiftKey) return; // Shift + Space is used to select the row
            if ((0, _keyboardUtils.isPrintableKey)(event)) reason = (0, _gridRowParams.GridRowEditStartReasons).printableKeyDown;
            else if ((event.ctrlKey || event.metaKey) && event.key === "v") reason = (0, _gridRowParams.GridRowEditStartReasons).printableKeyDown;
            else if (event.key === "Enter") reason = (0, _gridRowParams.GridRowEditStartReasons).enterKeyDown;
            else if (event.key === "Delete" || event.key === "Backspace") // Delete on Windows, Backspace on macOS
            reason = (0, _gridRowParams.GridRowEditStartReasons).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, _extendsDefault.default)({}, rowParams, {
                    field: params.field,
                    key: event.key,
                    reason
                });
                apiRef.current.publishEvent("rowEditStart", newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleRowEditStart = _react.useCallback((params)=>{
        const { id, field, reason, key } = params;
        const startRowEditModeParams = {
            id,
            fieldToFocus: field
        };
        if (reason === (0, _gridRowParams.GridRowEditStartReasons).printableKeyDown) {
            if (_react.version.startsWith("18")) startRowEditModeParams.initialValue = key; // In React 17, cleaning the input is enough
            else startRowEditModeParams.deleteValue = !!field;
        } else if (reason === (0, _gridRowParams.GridRowEditStartReasons).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = _react.useCallback((params)=>{
        const { id, reason, field } = params;
        apiRef.current.unstable_runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, _gridRowParams.GridRowEditStopReasons).enterKeyDown) cellToFocusAfter = "below";
        else if (reason === (0, _gridRowParams.GridRowEditStopReasons).tabKeyDown) cellToFocusAfter = "right";
        else if (reason === (0, _gridRowParams.GridRowEditStopReasons).shiftTabKeyDown) cellToFocusAfter = "left";
        let ignoreModifications = reason === "escapeKeyDown";
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        if (!ignoreModifications && !props.disableIgnoreModificationsIfProcessingProps) // The user wants to stop editing the cell but we can't wait for the props to be processed.
        // In this case, discard the modifications if any field is processing its props.
        ignoreModifications = Object.values(editingState[id]).some((fieldProps)=>{
            return fieldProps.isProcessingProps;
        });
        apiRef.current.stopRowEditMode({
            id,
            ignoreModifications,
            field,
            cellToFocusAfter
        });
    }, [
        apiRef,
        props.disableIgnoreModificationsIfProcessingProps
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellDoubleClick", runIfEditModeIsRow(handleCellDoubleClick));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusIn", runIfEditModeIsRow(handleCellFocusIn));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellFocusOut", runIfEditModeIsRow(handleCellFocusOut));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", runIfEditModeIsRow(handleCellKeyDown));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowEditStart", runIfEditModeIsRow(handleRowEditStart));
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowEditStop", runIfEditModeIsRow(handleRowEditStop));
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowEditStart", props.onRowEditStart);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowEditStop", props.onRowEditStop);
    const getRowMode = _react.useCallback((id)=>{
        if (props.editMode === (0, _gridEditRowModel.GridEditModes).Cell) return (0, _gridEditRowModel.GridRowModes).View;
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const isEditing = editingState[id] && Object.keys(editingState[id]).length > 0;
        return isEditing ? (0, _gridEditRowModel.GridRowModes).Edit : (0, _gridEditRowModel.GridRowModes).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, _utils.unstable_useEventCallback)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) {
            const details = signature === (0, _useGridApiEventHandler.GridSignature).DataGridPro ? {
                api: apiRef.current
            } : {};
            onRowModesModelChange(newModel, details);
        }
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent("rowModesModelChange", newModel);
    });
    const updateRowInRowModesModel = _react.useCallback((id, newProps)=>{
        const newModel = (0, _extendsDefault.default)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, _extendsDefault.default)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = _react.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, _extendsDefault.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, _extendsDefault.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = _react.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, _extendsDefault.default)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, _extendsDefault.default)({}, newEditingState[id], {
                [field]: (0, _extendsDefault.default)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, _extendsDefault.default)({}, state, {
                editRows: newEditingState
            });
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const startRowEditMode = _react.useCallback((params)=>{
        const { id } = params, other = (0, _objectWithoutPropertiesLooseDefault.default)(params, _excluded);
        throwIfNotInMode(id, (0, _gridEditRowModel.GridRowModes).View);
        updateRowInRowModesModel(id, (0, _extendsDefault.default)({
            mode: (0, _gridEditRowModel.GridRowModes).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, _utils.unstable_useEventCallback)((params)=>{
        const { id, fieldToFocus, deleteValue, initialValue } = params;
        const columnFields = (0, _gridColumnsSelector.gridColumnFieldsSelector)(apiRef);
        const newProps = columnFields.reduce((acc, field)=>{
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) newValue = deleteValue ? "" : initialValue;
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: false
            };
            return acc;
        }, {});
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
    });
    const stopRowEditMode = _react.useCallback((params)=>{
        const { id } = params, other = (0, _objectWithoutPropertiesLooseDefault.default)(params, _excluded2);
        throwIfNotInMode(id, (0, _gridEditRowModel.GridRowModes).Edit);
        updateRowInRowModesModel(id, (0, _extendsDefault.default)({
            mode: (0, _gridEditRowModel.GridRowModes).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, _utils.unstable_useEventCallback)((params)=>{
        const { id, ignoreModifications, field: focusedField, cellToFocusAfter = "none" } = params;
        apiRef.current.unstable_runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== "none" && focusedField) apiRef.current.unstable_moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, _gridEditRowModel.GridRowModes).Edit;
            return;
        }
        const hasSomeFieldWithError = Object.values(editingState[id]).some((fieldProps)=>fieldProps.error);
        if (hasSomeFieldWithError) {
            prevRowModesModel.current[id].mode = (0, _gridEditRowModel.GridRowModes).Edit; // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, _gridEditRowModel.GridRowModes).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.unstable_getRowWithUpdatedValuesFromRowEditing(id);
        if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevRowModesModel.current[id].mode = (0, _gridEditRowModel.GridRowModes).Edit; // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: (0, _gridEditRowModel.GridRowModes).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
                else missingOnProcessRowUpdateErrorWarning();
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row)).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = _react.useCallback((params)=>{
        const { id, field, value, debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, apiRef.current.getCellParams(id, field));
        let editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        let newProps = (0, _extendsDefault.default)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? "debouncedSetEditCellValue" : "setEditCellValue"
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, _extendsDefault.default)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, _objectWithoutPropertiesLooseDefault.default)(_editingState$id, [
                    field
                ].map((0, _toPropertyKeyDefault.default)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id,
                    row,
                    props: newProps,
                    hasChanged,
                    otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, _gridEditRowModel.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
                    processedProps = (0, _extendsDefault.default)({}, processedProps, {
                        isProcessingProps: false
                    }); // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, _extendsDefault.default)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, _objectWithoutPropertiesLooseDefault.default)(_editingState$id2, [
                    thisField
                ].map((0, _toPropertyKeyDefault.default)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id,
                    row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, _gridEditRowModel.GridRowModes).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, _extendsDefault.default)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, _gridEditRowModel.GridRowModes).Edit) {
                    editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = _react.useCallback((id)=>{
        const editingState = (0, _gridEditRowsSelector.gridEditRowsStateSelector)(apiRef.current.state);
        const row = apiRef.current.getRow(id);
        let rowUpdate = (0, _extendsDefault.default)({}, row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            if (column.valueSetter) rowUpdate = column.valueSetter({
                value: fieldProps.value,
                row: rowUpdate
            });
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode,
        startRowEditMode,
        stopRowEditMode,
        unstable_setRowEditingEditCellValue: setRowEditingEditCellValue,
        unstable_getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, editingApi, "EditingApi");
    _react.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    _react.useEffect(()=>{
        const idToIdLookup = (0, _gridRowsSelector.gridRowsIdToIdLookupSelector)(apiRef); // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, _utils1.deepClone)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(rowModesModel).forEach(([id, params])=>{
            var _copyOfPrevRowModesMo, _idToIdLookup$id;
            const prevMode = ((_copyOfPrevRowModesMo = copyOfPrevRowModesModel[id]) == null ? void 0 : _copyOfPrevRowModesMo.mode) || (0, _gridEditRowModel.GridRowModes).View;
            const originalId = (_idToIdLookup$id = idToIdLookup[id]) != null ? _idToIdLookup$id : id;
            if (params.mode === (0, _gridEditRowModel.GridRowModes).Edit && prevMode === (0, _gridEditRowModel.GridRowModes).View) updateStateToStartRowEditMode((0, _extendsDefault.default)({
                id: originalId
            }, params));
            else if (params.mode === (0, _gridEditRowModel.GridRowModes).View && prevMode === (0, _gridEditRowModel.GridRowModes).Edit) updateStateToStopRowEditMode((0, _extendsDefault.default)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};

},{"@babel/runtime/helpers/esm/toPropertyKey":"4TadU","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","../../utils/useGridApiEventHandler":"iBXeM","../../../models/gridEditRowModel":"5QORb","../../utils/useGridApiMethod":"5EPiD","./gridEditRowsSelector":"978KN","../../../utils/keyboardUtils":"o7lWn","../columns/gridColumnsSelector":"aeHtc","../../../utils/warning":"cfes8","../rows/gridRowsSelector":"fCZaq","../../../utils/utils":"lwlsg","../../../models/params/gridRowParams":"fbQG6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fbQG6":[function(require,module,exports) {
/**
 * Object passed as parameter in the row callbacks.
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/mui/mui-x/pull/3738#discussion_r798504277
parcelHelpers.export(exports, "GridRowEditStartReasons", ()=>GridRowEditStartReasons);
parcelHelpers.export(exports, "GridRowEditStopReasons", ()=>GridRowEditStopReasons);
var GridRowEditStartReasons;
/**
 * Params passed to the `rowEditStart` event.
 */ (function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
})(GridRowEditStartReasons || (GridRowEditStartReasons = {}));
var GridRowEditStopReasons;
(function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
})(GridRowEditStopReasons || (GridRowEditStopReasons = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ahZgW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rowsStateInitializer", ()=>rowsStateInitializer);
parcelHelpers.export(exports, "useGridRows", ()=>useGridRows);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridRowsSelector = require("./gridRowsSelector");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _gridSortingSelector = require("../sorting/gridSortingSelector");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridRowsUtils = require("./gridRowsUtils");
var _pipeProcessing = require("../../core/pipeProcessing");
const rowsStateInitializer = (state, props, apiRef)=>{
    apiRef.current.unstable_caches.rows = (0, _gridRowsUtils.createRowsInternalCache)({
        rows: props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, _extendsDefault.default)({}, state, {
        rows: (0, _gridRowsUtils.getRowsStateFromCache)({
            apiRef,
            previousTree: null,
            rowCountProp: props.rowCount,
            loadingProp: props.loading
        })
    });
};
const useGridRows = (apiRef, props)=>{
    var error;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridRows");
    const currentPage = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, props);
    const lastUpdateMs = _react.useRef(Date.now());
    const timeout = _react.useRef(null);
    const getRow = _react.useCallback((id)=>{
        var _ref;
        return (_ref = (0, _gridRowsSelector.gridRowsLookupSelector)(apiRef)[id]) != null ? _ref : null;
    }, [
        apiRef
    ]);
    const lookup = _react.useMemo(()=>currentPage.rows.reduce((acc, { id }, index)=>{
            acc[id] = index;
            return acc;
        }, {}), [
        currentPage.rows
    ]);
    const throttledRowsChange = _react.useCallback((newCache, throttle)=>{
        const run = ()=>{
            timeout.current = null;
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                    rows: (0, _gridRowsUtils.getRowsStateFromCache)({
                        apiRef,
                        previousTree: (0, _gridRowsSelector.gridRowTreeSelector)(apiRef),
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading
                    })
                }));
            apiRef.current.publishEvent("rowsSet");
            apiRef.current.forceUpdate();
        };
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
        apiRef.current.unstable_caches.rows = newCache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.current = setTimeout(run, throttleRemainingTimeMs);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef
    ]);
    /**
   * API METHODS
   */ const setRows = _react.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        const cache = (0, _gridRowsUtils.createRowsInternalCache)({
            rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.unstable_caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange(cache, true);
    }, [
        logger,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = _react.useCallback((updates)=>{
        if (props.signature === (0, _useGridApiEventHandler.GridSignature).DataGrid && updates.length > 1) // TODO: Add test with direct call to `apiRef.current.updateRows` in DataGrid after enabling the `apiRef` on the free plan.
        throw new Error([
            "MUI: You can't update several rows at once in `apiRef.current.updateRows` on the DataGrid.",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
         // we remove duplicate updates. A server can batch updates, and send several updates for the same row in one fn call.
        const uniqueUpdates = new Map();
        updates.forEach((update)=>{
            const id = (0, _gridRowsUtils.getRowIdFromRowModel)(update, props.getRowId, "A row was provided without id when calling updateRows():");
            if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, _extendsDefault.default)({}, uniqueUpdates.get(id), update));
            else uniqueUpdates.set(id, update);
        });
        const deletedRowIds = [];
        const prevCache = apiRef.current.unstable_caches.rows;
        const newCache = {
            rowsBeforePartialUpdates: prevCache.rowsBeforePartialUpdates,
            loadingPropBeforePartialUpdates: prevCache.loadingPropBeforePartialUpdates,
            rowCountPropBeforePartialUpdates: prevCache.rowCountPropBeforePartialUpdates,
            idRowsLookup: (0, _extendsDefault.default)({}, prevCache.idRowsLookup),
            idToIdLookup: (0, _extendsDefault.default)({}, prevCache.idToIdLookup),
            ids: [
                ...prevCache.ids
            ]
        };
        uniqueUpdates.forEach((partialRow, id)=>{
            // eslint-disable-next-line no-underscore-dangle
            if (partialRow._action === "delete") {
                delete newCache.idRowsLookup[id];
                delete newCache.idToIdLookup[id];
                deletedRowIds.push(id);
                return;
            }
            const oldRow = apiRef.current.getRow(id);
            if (!oldRow) {
                newCache.idRowsLookup[id] = partialRow;
                newCache.idToIdLookup[id] = id;
                newCache.ids.push(id);
                return;
            }
            newCache.idRowsLookup[id] = (0, _extendsDefault.default)({}, apiRef.current.getRow(id), partialRow);
        });
        if (deletedRowIds.length > 0) newCache.ids = newCache.ids.filter((id)=>!deletedRowIds.includes(id));
        throttledRowsChange(newCache, true);
    }, [
        props.signature,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const getRowModels = _react.useCallback(()=>{
        const allRows = (0, _gridRowsSelector.gridRowIdsSelector)(apiRef);
        const idRowsLookup = (0, _gridRowsSelector.gridRowsLookupSelector)(apiRef);
        return new Map(allRows.map((id)=>[
                id,
                idRowsLookup[id]
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = _react.useCallback(()=>(0, _gridRowsSelector.gridRowCountSelector)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = _react.useCallback(()=>(0, _gridRowsSelector.gridRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = _react.useCallback((id)=>lookup[id], [
        lookup
    ]);
    const setRowChildrenExpansion = _react.useCallback((id, isExpanded)=>{
        const currentNode = apiRef.current.getRowNode(id);
        if (!currentNode) throw new Error(`MUI: No row with id #${id} found`);
        const newNode = (0, _extendsDefault.default)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, _extendsDefault.default)({}, state, {
                rows: (0, _extendsDefault.default)({}, state.rows, {
                    tree: (0, _extendsDefault.default)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.forceUpdate();
        apiRef.current.publishEvent("rowExpansionChange", newNode);
    }, [
        apiRef
    ]);
    const getRowNode = _react.useCallback((id)=>{
        var _gridRowTreeSelector$;
        return (_gridRowTreeSelector$ = (0, _gridRowsSelector.gridRowTreeSelector)(apiRef)[id]) != null ? _gridRowTreeSelector$ : null;
    }, [
        apiRef
    ]);
    const getRowGroupChildren = _react.useCallback(({ skipAutoGeneratedRows = true, groupId, applySorting, applyFiltering })=>{
        const tree = (0, _gridRowsSelector.gridRowTreeSelector)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, _gridSortingSelector.gridSortedRowIdsSelector)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && tree[sortedRowIds[index]].depth > groupNode.depth; index += 1){
                const id = sortedRowIds[index];
                const node = tree[id];
                if (!skipAutoGeneratedRows || !node.isAutoGenerated) children.push(id);
            }
        } else children = (0, _gridRowsUtils.getTreeNodeDescendants)(tree, groupId, skipAutoGeneratedRows);
        if (applyFiltering) {
            const filteredRowsLookup = (0, _gridFilterSelector.gridFilteredRowsLookupSelector)(apiRef);
            children = children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const setRowIndex = _react.useCallback((rowId, targetIndex)=>{
        const allRows = (0, _gridRowsSelector.gridRowIdsSelector)(apiRef);
        const oldIndex = allRows.findIndex((row)=>row === rowId);
        if (oldIndex === -1 || oldIndex === targetIndex) return;
        logger.debug(`Moving row ${rowId} to index ${targetIndex}`);
        const updatedRows = [
            ...allRows
        ];
        updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                rows: (0, _extendsDefault.default)({}, state.rows, {
                    ids: updatedRows
                })
            }));
        apiRef.current.unstable_caches.rows.ids = updatedRows;
        apiRef.current.publishEvent("rowsSet");
    }, [
        apiRef,
        logger
    ]);
    const replaceRows = _react.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, _useGridApiEventHandler.GridSignature).DataGrid && newRows.length > 1) throw new Error([
            "MUI: You can't replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.",
            "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."
        ].join("\n"));
        if (newRows.length === 0) return;
        const allRows = (0, _gridRowsSelector.gridRowIdsSelector)(apiRef);
        const updatedRows = [
            ...allRows
        ];
        const idRowsLookup = (0, _gridRowsSelector.gridRowsLookupSelector)(apiRef);
        const idToIdLookup = (0, _gridRowsSelector.gridRowsIdToIdLookupSelector)(apiRef);
        const tree = (0, _gridRowsSelector.gridRowTreeSelector)(apiRef);
        const updatedIdRowsLookup = (0, _extendsDefault.default)({}, idRowsLookup);
        const updatedIdToIdLookup = (0, _extendsDefault.default)({}, idToIdLookup);
        const updatedTree = (0, _extendsDefault.default)({}, tree);
        const newRowEntries = newRows.map((newRowModel)=>{
            const rowId = (0, _gridRowsUtils.getRowIdFromRowModel)(newRowModel, props.getRowId, "A row was provided without id when calling replaceRows().");
            return {
                id: rowId,
                model: newRowModel
            };
        });
        newRowEntries.forEach((row, index)=>{
            const [replacedRowId] = updatedRows.splice(firstRowToRender + index, 1, row.id);
            delete updatedIdRowsLookup[replacedRowId];
            delete updatedIdToIdLookup[replacedRowId];
            delete updatedTree[replacedRowId];
        });
        newRowEntries.forEach((row)=>{
            const rowTreeNodeConfig = {
                id: row.id,
                parent: null,
                depth: 0,
                groupingKey: null,
                groupingField: null
            };
            updatedIdRowsLookup[row.id] = row.model;
            updatedIdToIdLookup[row.id] = row.id;
            updatedTree[row.id] = rowTreeNodeConfig;
        });
        apiRef.current.unstable_caches.rows.idRowsLookup = updatedIdRowsLookup;
        apiRef.current.unstable_caches.rows.idToIdLookup = updatedIdToIdLookup;
        apiRef.current.unstable_caches.rows.ids = updatedRows;
        apiRef.current.setState((state)=>{
            const newRowsState = {
                idRowsLookup: updatedIdRowsLookup,
                idToIdLookup: updatedIdToIdLookup,
                tree: updatedTree,
                ids: updatedRows
            };
            return (0, _extendsDefault.default)({}, state, {
                rows: (0, _extendsDefault.default)({}, state.rows, newRowsState, {
                    groupingResponseBeforeRowHydration: (0, _extendsDefault.default)({}, state.rows.groupingResponseBeforeRowHydration, newRowsState)
                })
            });
        });
        apiRef.current.publishEvent("rowsSet");
    }, [
        apiRef,
        props.signature,
        props.getRowId
    ]);
    const rowApi = {
        getRow,
        getRowModels,
        getRowsCount,
        getAllRowIds,
        setRows,
        setRowIndex,
        updateRows,
        setRowChildrenExpansion,
        getRowNode,
        getRowIndexRelativeToVisibleRows,
        getRowGroupChildren,
        unstable_replaceRows: replaceRows
    };
    /**
   * EVENTS
   */ const groupRows = _react.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.unstable_caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = apiRef.current.unstable_caches.rows;
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, _gridRowsUtils.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange(cache, false);
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const handleStrategyProcessorChange = _react.useCallback((methodName)=>{
        if (methodName === "rowTreeCreation") groupRows();
    }, [
        groupRows
    ]);
    const handleStrategyActivityChange = _react.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.unstable_getActiveStrategy("rowTree") !== (0, _gridRowsSelector.gridRowGroupingNameSelector)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "strategyAvailabilityChange", handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = _react.useCallback(()=>{
        apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                rows: (0, _extendsDefault.default)({}, state.rows, apiRef.current.unstable_applyPipeProcessors("hydrateRows", state.rows.groupingResponseBeforeRowHydration))
            }));
        apiRef.current.publishEvent("rowsSet");
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    (0, _pipeProcessing.useGridRegisterPipeApplier)(apiRef, "hydrateRows", applyHydrateRowsProcessor);
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, rowApi, "GridRowApi");
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        return ()=>{
            if (timeout.current !== null) clearTimeout(timeout.current);
        };
    }, []); // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = _react.useRef(true);
    _react.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const areNewRowsAlreadyInState = apiRef.current.unstable_caches.rows.rowsBeforePartialUpdates === props.rows;
        const isNewLoadingAlreadyInState = apiRef.current.unstable_caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.unstable_caches.rows.rowCountPropBeforePartialUpdates === props.rowCount; // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                        rows: (0, _extendsDefault.default)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.unstable_caches.rows.loadingPropBeforePartialUpdates = props.loading;
                apiRef.current.forceUpdate();
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                        rows: (0, _extendsDefault.default)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.unstable_caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
                apiRef.current.forceUpdate();
            }
            return;
        }
        logger.debug(`Updating all rows, new length ${props.rows.length}`);
        throttledRowsChange((0, _gridRowsUtils.createRowsInternalCache)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        }), false);
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","./gridRowsSelector":"fCZaq","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridVisibleRows":"giBK8","../sorting/gridSortingSelector":"1g9b1","../filter/gridFilterSelector":"lndlA","./gridRowsUtils":"iSo8b","../../core/pipeProcessing":"jx1az","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lL7K1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridRowsPreProcessors", ()=>useGridRowsPreProcessors);
var _strategyProcessing = require("../../core/strategyProcessing");
const flatRowTreeCreationMethod = ({ ids, idRowsLookup, idToIdLookup, previousTree })=>{
    const tree = {};
    for(let i = 0; i < ids.length; i += 1){
        const rowId = ids[i];
        if (previousTree && previousTree[rowId] && previousTree[rowId].depth === 0 && previousTree[rowId].parent == null && // pinned row can be unpinned
        !previousTree[rowId].isPinned) tree[rowId] = previousTree[rowId];
        else tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: null,
            groupingKey: "",
            groupingField: null
        };
    }
    return {
        groupingName: (0, _strategyProcessing.GRID_DEFAULT_STRATEGY),
        tree,
        treeDepth: 1,
        idRowsLookup,
        idToIdLookup,
        ids
    };
};
const useGridRowsPreProcessors = (apiRef)=>{
    (0, _strategyProcessing.useGridRegisterStrategyProcessor)(apiRef, (0, _strategyProcessing.GRID_DEFAULT_STRATEGY), "rowTreeCreation", flatRowTreeCreationMethod);
};

},{"../../core/strategyProcessing":"dzDtc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fE2ne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */ parcelHelpers.export(exports, "useGridParamsApi", ()=>useGridParamsApi);
var _react = require("react");
var _domUtils = require("../../../utils/domUtils");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _warning = require("../../../utils/warning");
let warnedOnceMissingColumn = false;
function warnMissingColumn(field) {
    console.warn([
        `MUI: You are calling getValue('${field}') but the column \`${field}\` is not defined.`,
        `Instead, you can access the data from \`params.row.${field}\`.`
    ].join("\n"));
    warnedOnceMissingColumn = true;
}
const getCellValueWarning = (0, _warning.buildWarning)([
    `MUI: You are calling getValue. This method is deprecated and will be removed in the next major version.`,
    "Instead, you can access the data from `params.row`."
]);
function useGridParamsApi(apiRef) {
    const getColumnHeaderParams = _react.useCallback((field)=>({
            field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    /**
   * We want to remove the `getValue` param from `getRowParams`, `getCellParams` and `getBaseCellParams`
   */ const getCellValueWithDeprecationWarning = _react.useCallback((...args)=>{
        return apiRef.current.getCellValue(...args);
    }, [
        apiRef
    ]);
    const getRowParams = _react.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new Error(`No row with id #${id} found`);
        const params = {
            id,
            columns: apiRef.current.getAllColumns(),
            row,
            // TODO v6: remove
            getValue: getCellValueWithDeprecationWarning
        };
        return params;
    }, [
        apiRef,
        getCellValueWithDeprecationWarning
    ]);
    const getBaseCellParams = _react.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new Error(`No row with id #${id} found`);
        const cellFocus = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, _gridFocusStateSelector.gridTabIndexCellSelector)(apiRef);
        const params = {
            id,
            field,
            row,
            rowNode,
            value: row[field],
            colDef: apiRef.current.getColumn(field),
            cellMode: apiRef.current.getCellMode(id, field),
            // TODO v6: remove
            getValue: getCellValueWithDeprecationWarning,
            api: apiRef.current,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1
        };
        return params;
    }, [
        apiRef,
        getCellValueWithDeprecationWarning
    ]);
    const getCellParams = _react.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const value = apiRef.current.getCellValue(id, field);
        const row = apiRef.current.getRow(id);
        const rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) throw new Error(`No row with id #${id} found`);
        const cellFocus = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
        const cellTabIndex = (0, _gridFocusStateSelector.gridTabIndexCellSelector)(apiRef);
        const params = {
            id,
            field,
            row,
            rowNode,
            colDef,
            cellMode: apiRef.current.getCellMode(id, field),
            // TODO v6: remove
            getValue: getCellValueWithDeprecationWarning,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            value,
            formattedValue: value
        };
        if (colDef && colDef.valueFormatter) params.formattedValue = colDef.valueFormatter({
            id,
            field: params.field,
            value: params.value,
            api: apiRef.current
        });
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef,
        getCellValueWithDeprecationWarning
    ]);
    const getCellValue = _react.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        if (!colDef || !colDef.valueGetter) {
            const rowModel = apiRef.current.getRow(id);
            if (!rowModel) throw new Error(`No row with id #${id} found`);
            return rowModel[field];
        }
        return colDef.valueGetter(getBaseCellParams(id, field));
    }, [
        apiRef,
        getBaseCellParams
    ]);
    const getColumnHeaderElement = _react.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, _domUtils.getGridColumnHeaderElement)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = _react.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, _domUtils.getGridRowElement)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = _react.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, _domUtils.getGridCellElement)(apiRef.current.rootElementRef.current, {
            id,
            field
        });
    }, [
        apiRef
    ]);
    const paramsApi = {
        getCellValue,
        getCellParams,
        getCellElement,
        getRowParams,
        getRowElement,
        getColumnHeaderParams,
        getColumnHeaderElement
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, paramsApi, "GridParamsApi");
}

},{"react":"gVheC","../../../utils/domUtils":"s7LWz","../../utils/useGridApiMethod":"5EPiD","../focus/gridFocusStateSelector":"7pS2P","../../../utils/warning":"cfes8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"96zCn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectionStateInitializer", ()=>selectionStateInitializer);
parcelHelpers.export(exports, "useGridSelection", ()=>useGridSelection);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridRowsSelector = require("../rows/gridRowsSelector");
var _gridSelectionSelector = require("./gridSelectionSelector");
var _pagination = require("../pagination");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _colDef = require("../../../colDef");
var _gridEditRowModel = require("../../../models/gridEditRowModel");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _gridDetailPanelToggleField = require("../../../constants/gridDetailPanelToggleField");
var _gridClasses = require("../../../constants/gridClasses");
const getSelectionModelPropValue = (selectionModelProp, prevSelectionModel)=>{
    if (selectionModelProp == null) return selectionModelProp;
    if (Array.isArray(selectionModelProp)) return selectionModelProp;
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) return prevSelectionModel;
    return [
        selectionModelProp
    ];
};
const selectionStateInitializer = (state, props)=>{
    var _getSelectionModelPro;
    return (0, _extendsDefault.default)({}, state, {
        selection: (_getSelectionModelPro = getSelectionModelPropValue(props.selectionModel)) != null ? _getSelectionModelPro : []
    });
};
const useGridSelection = (apiRef, props)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridSelection");
    const propSelectionModel = _react.useMemo(()=>{
        return getSelectionModelPropValue(props.selectionModel, (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state));
    }, [
        apiRef,
        props.selectionModel
    ]);
    const lastRowToggled = _react.useRef(null);
    apiRef.current.unstable_registerControlState({
        stateId: "selection",
        propModel: propSelectionModel,
        propOnChange: props.onSelectionModelChange,
        stateSelector: (0, _gridSelectionSelector.gridSelectionStateSelector),
        changeEvent: "selectionChange"
    });
    const { checkboxSelection, disableMultipleSelection, disableSelectionOnClick, pagination, paginationMode, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = !disableMultipleSelection || checkboxSelection;
    const visibleRows = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, props);
    const expandMouseRowRangeSelection = _react.useCallback((id)=>{
        var _lastRowToggled$curre;
        let endId = id;
        const startId = (_lastRowToggled$curre = lastRowToggled.current) != null ? _lastRowToggled$curre : id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, _gridFilterSelector.gridVisibleSortedRowIdsSelector)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId,
            endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /**
   * API METHODS
   */ const setSelectionModel = _react.useCallback((model)=>{
        const currentModel = (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, _extendsDefault.default)({}, state, {
                    selection: model
                }));
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger
    ]);
    const isRowSelected = _react.useCallback((id)=>(0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state).includes(id), [
        apiRef
    ]);
    const isRowSelectable = _react.useCallback((id)=>{
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = apiRef.current.getRowNode(id);
        if ((rowNode == null ? void 0 : rowNode.position) === "footer" || rowNode != null && rowNode.isPinned) return false;
        return true;
    }, [
        apiRef,
        propIsRowSelectable
    ]);
    const getSelectedRows = _react.useCallback(()=>(0, _gridSelectionSelector.selectedGridRowsSelector)(apiRef), [
        apiRef
    ]);
    const selectRow = _react.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            apiRef.current.setSelectionModel(isSelected ? [
                id
            ] : []);
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selection = (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state);
            const newSelection = selection.filter((el)=>el !== id);
            if (isSelected) newSelection.push(id);
            const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setSelectionModel(newSelection);
        }
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRows = _react.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        const selectableIds = ids.filter((id)=>apiRef.current.isRowSelectable(id));
        let newSelection;
        if (resetSelection) newSelection = isSelected ? selectableIds : [];
        else {
            // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
            const selectionLookup = (0, _extendsDefault.default)({}, (0, _gridSelectionSelector.selectedIdsLookupSelector)(apiRef));
            selectableIds.forEach((id)=>{
                if (isSelected) selectionLookup[id] = id;
                else delete selectionLookup[id];
            });
            newSelection = Object.values(selectionLookup);
        }
        const isSelectionValid = newSelection.length < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setSelectionModel(newSelection);
    }, [
        apiRef,
        logger,
        canHaveMultipleSelection
    ]);
    const selectRowRange = _react.useCallback(({ startId, endId }, isSelected = true, resetSelection)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`); // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, _gridFilterSelector.gridVisibleSortedRowIdsSelector)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionApi = {
        selectRow,
        selectRows,
        selectRowRange,
        setSelectionModel,
        getSelectedRows,
        isRowSelected,
        isRowSelectable
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, selectionApi, "GridSelectionApi");
    /**
   * EVENTS
   */ const removeOutdatedSelection = _react.useCallback(()=>{
        if (props.keepNonExistentRowsSelected) return;
        const currentSelection = (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state);
        const rowsLookup = (0, _gridRowsSelector.gridRowsLookupSelector)(apiRef); // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        const selectionLookup = (0, _extendsDefault.default)({}, (0, _gridSelectionSelector.selectedIdsLookupSelector)(apiRef));
        let hasChanged = false;
        currentSelection.forEach((id)=>{
            if (!rowsLookup[id]) {
                delete selectionLookup[id];
                hasChanged = true;
            }
        });
        if (hasChanged) apiRef.current.setSelectionModel(Object.values(selectionLookup));
    }, [
        apiRef,
        props.keepNonExistentRowsSelected
    ]);
    const handleSingleRowSelection = _react.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey; // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, _keyboardUtils.isKeyboardEvent)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        else apiRef.current.selectRow(id, !isSelected, false);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = _react.useCallback((params, event)=>{
        var _closest;
        if (disableSelectionOnClick) return;
        const field = (_closest = event.target.closest(`.${(0, _gridClasses.gridClasses).cell}`)) == null ? void 0 : _closest.getAttribute("data-field");
        if (field === (0, _colDef.GRID_CHECKBOX_SELECTION_COL_DEF).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, _gridDetailPanelToggleField.GRID_DETAIL_PANEL_TOGGLE_FIELD)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column.type === (0, _colDef.GRID_ACTIONS_COLUMN_TYPE)) return;
        }
        const rowNode = apiRef.current.getRowNode(params.id);
        if (rowNode.isPinned) return;
        if (event.shiftKey && (canHaveMultipleSelection || checkboxSelection)) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableSelectionOnClick,
        canHaveMultipleSelection,
        checkboxSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = _react.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) {
            var _window$getSelection;
            (_window$getSelection = window.getSelection()) == null || _window$getSelection.removeAllRanges();
        }
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = _react.useCallback((params, event)=>{
        if (event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value);
    }, [
        apiRef,
        expandMouseRowRangeSelection
    ]);
    const handleHeaderSelectionCheckboxChange = _react.useCallback((params)=>{
        const shouldLimitSelectionToCurrentPage = props.checkboxSelectionVisibleOnly && props.pagination;
        const rowsToBeSelected = shouldLimitSelectionToCurrentPage ? (0, _pagination.gridPaginatedVisibleSortedGridRowIdsSelector)(apiRef) : (0, _gridFilterSelector.gridVisibleSortedRowIdsSelector)(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination
    ]);
    const handleCellKeyDown = _react.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, _gridEditRowModel.GridCellModes).Edit) return;
         // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if (!event.currentTarget.contains(event.target)) return;
        if ((0, _keyboardUtils.isNavigationKey)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, _gridFocusStateSelector.gridFocusCellSelector)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map((row)=>row.id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === " " && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (event.key.toLowerCase() === "a" && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        visibleRows.rows,
        canHaveMultipleSelection
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "sortedRowsSet", removeOutdatedSelection);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowClick", handleRowClick);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowSelectionCheckboxChange", handleRowSelectionCheckboxChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "headerSelectionCheckboxChange", handleHeaderSelectionCheckboxChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellMouseDown", preventSelectionOnShift);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "cellKeyDown", handleCellKeyDown);
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        if (propSelectionModel !== undefined) apiRef.current.setSelectionModel(propSelectionModel);
    }, [
        apiRef,
        propSelectionModel
    ]);
    const isStateControlled = propSelectionModel != null;
    _react.useEffect(()=>{
        if (isStateControlled) return;
         // props.isRowSelectable changed
        const currentSelection = (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state);
        if (isRowSelectable) {
            const newSelection = currentSelection.filter((id)=>isRowSelectable(id));
            if (newSelection.length < currentSelection.length) apiRef.current.setSelectionModel(newSelection);
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled
    ]);
    _react.useEffect(()=>{
        const currentSelection = (0, _gridSelectionSelector.gridSelectionStateSelector)(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) {
            const { rows: currentPageRows } = (0, _useGridVisibleRows.getVisibleRows)(apiRef, {
                pagination,
                paginationMode
            });
            const currentPageRowsLookup = currentPageRows.reduce((acc, { id })=>{
                acc[id] = true;
                return acc;
            }, {});
            const firstSelectableRow = currentSelection.find((id)=>{
                let isSelectable = true;
                if (isRowSelectable) isSelectable = isRowSelectable(id);
                return isSelectable && currentPageRowsLookup[id]; // Check if the row is in the current page
            });
            apiRef.current.setSelectionModel(firstSelectableRow !== undefined ? [
                firstSelectableRow
            ] : []);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        disableMultipleSelection,
        isRowSelectable,
        pagination,
        paginationMode
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../rows/gridRowsSelector":"fCZaq","./gridSelectionSelector":"XuHYC","../pagination":"bGzSP","../focus/gridFocusStateSelector":"7pS2P","../filter/gridFilterSelector":"lndlA","../../../colDef":"8Wled","../../../models/gridEditRowModel":"5QORb","../../../utils/keyboardUtils":"o7lWn","../../utils/useGridVisibleRows":"giBK8","../../../constants/gridDetailPanelToggleField":"3vGWg","../../../constants/gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bGzSP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gridPaginationSelector = require("./gridPaginationSelector");
parcelHelpers.exportAll(_gridPaginationSelector, exports);

},{"./gridPaginationSelector":"e6xRD","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"65igq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionPreProcessors", ()=>useGridSelectionPreProcessors);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _material = require("@mui/material");
var _pipeProcessing = require("../../core/pipeProcessing");
var _constants = require("../../../constants");
var _colDef = require("../../../colDef");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    return _react.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                "cellCheckbox"
            ],
            columnHeaderCheckbox: [
                "columnHeaderCheckbox"
            ]
        };
        return (0, _material.unstable_composeClasses)(slots, (0, _constants.getDataGridUtilityClass), classes);
    }, [
        classes
    ]);
};
const useGridSelectionPreProcessors = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = useUtilityClasses(ownerState);
    const updateSelectionColumn = _react.useCallback((columnsState)=>{
        const selectionColumn = (0, _extendsDefault.default)({}, (0, _colDef.GRID_CHECKBOX_SELECTION_COL_DEF), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText("checkboxSelectionHeaderName")
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const haveSelectionColumn = columnsState.lookup[0, _colDef.GRID_CHECKBOX_SELECTION_FIELD] != null;
        if (shouldHaveSelectionColumn && !haveSelectionColumn) {
            columnsState.lookup[0, _colDef.GRID_CHECKBOX_SELECTION_FIELD] = selectionColumn;
            columnsState.all = [
                (0, _colDef.GRID_CHECKBOX_SELECTION_FIELD),
                ...columnsState.all
            ];
        } else if (!shouldHaveSelectionColumn && haveSelectionColumn) {
            delete columnsState.lookup[0, _colDef.GRID_CHECKBOX_SELECTION_FIELD];
            columnsState.all = columnsState.all.filter((field)=>field !== (0, _colDef.GRID_CHECKBOX_SELECTION_FIELD));
        } else if (shouldHaveSelectionColumn && haveSelectionColumn) columnsState.lookup[0, _colDef.GRID_CHECKBOX_SELECTION_FIELD] = (0, _extendsDefault.default)({}, selectionColumn, columnsState.lookup[0, _colDef.GRID_CHECKBOX_SELECTION_FIELD]);
        return columnsState;
    }, [
        apiRef,
        classes,
        props.checkboxSelection
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "hydrateColumns", updateSelectionColumn);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material":"iknXc","../../core/pipeProcessing":"jx1az","../../../constants":"bDcEB","../../../colDef":"8Wled","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bDcEB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _envConstants = require("./envConstants");
parcelHelpers.exportAll(_envConstants, exports);
var _localeTextConstants = require("./localeTextConstants");
parcelHelpers.exportAll(_localeTextConstants, exports);
var _defaultGridSlotsComponents = require("./defaultGridSlotsComponents");
parcelHelpers.exportAll(_defaultGridSlotsComponents, exports);
var _gridClasses = require("./gridClasses");
parcelHelpers.exportAll(_gridClasses, exports);

},{"./envConstants":false,"./localeTextConstants":"gqvnd","./defaultGridSlotsComponents":"gjcpc","./gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gqvnd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GRID_DEFAULT_LOCALE_TEXT", ()=>GRID_DEFAULT_LOCALE_TEXT);
const GRID_DEFAULT_LOCALE_TEXT = {
    // Root
    noRowsLabel: "No rows",
    noResultsOverlayLabel: "No results found.",
    errorOverlayDefaultLabel: "An error occurred.",
    // Density selector toolbar button text
    toolbarDensity: "Density",
    toolbarDensityLabel: "Density",
    toolbarDensityCompact: "Compact",
    toolbarDensityStandard: "Standard",
    toolbarDensityComfortable: "Comfortable",
    // Columns selector toolbar button text
    toolbarColumns: "Columns",
    toolbarColumnsLabel: "Select columns",
    // Filters toolbar button text
    toolbarFilters: "Filters",
    toolbarFiltersLabel: "Show filters",
    toolbarFiltersTooltipHide: "Hide filters",
    toolbarFiltersTooltipShow: "Show filters",
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: "Search",
    toolbarQuickFilterDeleteIconLabel: "Clear",
    // Export selector toolbar button text
    toolbarExport: "Export",
    toolbarExportLabel: "Export",
    toolbarExportCSV: "Download as CSV",
    toolbarExportPrint: "Print",
    toolbarExportExcel: "Download as Excel",
    // Columns panel text
    columnsPanelTextFieldLabel: "Find column",
    columnsPanelTextFieldPlaceholder: "Column title",
    columnsPanelDragIconLabel: "Reorder column",
    columnsPanelShowAllButton: "Show all",
    columnsPanelHideAllButton: "Hide all",
    // Filter panel text
    filterPanelAddFilter: "Add filter",
    filterPanelDeleteIconLabel: "Delete",
    filterPanelLinkOperator: "Logic operator",
    filterPanelOperators: "Operator",
    // TODO v6: rename to filterPanelOperator
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: "Columns",
    filterPanelInputLabel: "Value",
    filterPanelInputPlaceholder: "Filter value",
    // Filter operators text
    filterOperatorContains: "contains",
    filterOperatorEquals: "equals",
    filterOperatorStartsWith: "starts with",
    filterOperatorEndsWith: "ends with",
    filterOperatorIs: "is",
    filterOperatorNot: "is not",
    filterOperatorAfter: "is after",
    filterOperatorOnOrAfter: "is on or after",
    filterOperatorBefore: "is before",
    filterOperatorOnOrBefore: "is on or before",
    filterOperatorIsEmpty: "is empty",
    filterOperatorIsNotEmpty: "is not empty",
    filterOperatorIsAnyOf: "is any of",
    // Filter values text
    filterValueAny: "any",
    filterValueTrue: "true",
    filterValueFalse: "false",
    // Column menu text
    columnMenuLabel: "Menu",
    columnMenuShowColumns: "Show columns",
    columnMenuFilter: "Filter",
    columnMenuHideColumn: "Hide",
    columnMenuUnsort: "Unsort",
    columnMenuSortAsc: "Sort by ASC",
    columnMenuSortDesc: "Sort by DESC",
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: "Show filters",
    columnHeaderSortIconLabel: "Sort",
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: "Total Rows:",
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: "Checkbox selection",
    checkboxSelectionSelectAllRows: "Select all rows",
    checkboxSelectionUnselectAllRows: "Unselect all rows",
    checkboxSelectionSelectRow: "Select row",
    checkboxSelectionUnselectRow: "Unselect row",
    // Boolean cell text
    booleanCellTrueLabel: "yes",
    booleanCellFalseLabel: "no",
    // Actions cell more text
    actionsCellMore: "more",
    // Column pinning text
    pinToLeft: "Pin to left",
    pinToRight: "Pin to right",
    unpin: "Unpin",
    // Tree Data
    treeDataGroupingHeaderName: "Group",
    treeDataExpand: "see children",
    treeDataCollapse: "hide children",
    // Grouping columns
    groupingColumnHeaderName: "Group",
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: "Detail panel toggle",
    expandDetailPanel: "Expand",
    collapseDetailPanel: "Collapse",
    // Used core components translation keys
    MuiTablePagination: {},
    // Row reordering text
    rowReorderingHeaderName: "Row reordering",
    // Aggregation
    aggregationMenuItemHeader: "Aggregation",
    aggregationFunctionLabelSum: "sum",
    aggregationFunctionLabelAvg: "avg",
    aggregationFunctionLabelMin: "min",
    aggregationFunctionLabelMax: "max",
    aggregationFunctionLabelSize: "size"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gjcpc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DATA_GRID_DEFAULT_SLOTS_COMPONENTS", ()=>DATA_GRID_DEFAULT_SLOTS_COMPONENTS);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _switch = require("@mui/material/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _components = require("../components");
var _gridColumnUnsortedIcon = require("../components/columnHeaders/GridColumnUnsortedIcon");
var _errorOverlay = require("../components/ErrorOverlay");
var _gridNoResultsOverlay = require("../components/GridNoResultsOverlay");
const DEFAULT_GRID_ICON_SLOTS_COMPONENTS = {
    BooleanCellTrueIcon: (0, _components.GridCheckIcon),
    BooleanCellFalseIcon: (0, _components.GridCloseIcon),
    ColumnMenuIcon: (0, _components.GridTripleDotsVerticalIcon),
    OpenFilterButtonIcon: (0, _components.GridFilterListIcon),
    FilterPanelDeleteIcon: (0, _components.GridCloseIcon),
    ColumnFilteredIcon: (0, _components.GridFilterAltIcon),
    ColumnSelectorIcon: (0, _components.GridColumnIcon),
    ColumnUnsortedIcon: (0, _gridColumnUnsortedIcon.GridColumnUnsortedIcon),
    ColumnSortedAscendingIcon: (0, _components.GridArrowUpwardIcon),
    ColumnSortedDescendingIcon: (0, _components.GridArrowDownwardIcon),
    ColumnResizeIcon: (0, _components.GridSeparatorIcon),
    DensityCompactIcon: (0, _components.GridViewHeadlineIcon),
    DensityStandardIcon: (0, _components.GridTableRowsIcon),
    DensityComfortableIcon: (0, _components.GridViewStreamIcon),
    ExportIcon: (0, _components.GridSaveAltIcon),
    MoreActionsIcon: (0, _components.GridMoreVertIcon),
    TreeDataCollapseIcon: (0, _components.GridExpandMoreIcon),
    TreeDataExpandIcon: (0, _components.GridKeyboardArrowRight),
    GroupingCriteriaCollapseIcon: (0, _components.GridExpandMoreIcon),
    GroupingCriteriaExpandIcon: (0, _components.GridKeyboardArrowRight),
    DetailPanelExpandIcon: (0, _components.GridAddIcon),
    DetailPanelCollapseIcon: (0, _components.GridRemoveIcon),
    RowReorderIcon: (0, _components.GridDragIcon),
    QuickFilterIcon: (0, _components.GridSearchIcon),
    QuickFilterClearIcon: (0, _components.GridCloseIcon)
};
const DATA_GRID_DEFAULT_SLOTS_COMPONENTS = (0, _extendsDefault.default)({}, DEFAULT_GRID_ICON_SLOTS_COMPONENTS, {
    BaseCheckbox: (0, _checkboxDefault.default),
    BaseTextField: (0, _textFieldDefault.default),
    BaseFormControl: (0, _formControlDefault.default),
    BaseSelect: (0, _selectDefault.default),
    BaseSwitch: (0, _switchDefault.default),
    BaseButton: (0, _buttonDefault.default),
    BaseTooltip: (0, _tooltipDefault.default),
    BasePopper: (0, _popperDefault.default),
    Cell: (0, _components.GridCell),
    SkeletonCell: (0, _components.GridSkeletonCell),
    ColumnHeaderFilterIconButton: (0, _components.GridColumnHeaderFilterIconButton),
    ColumnMenu: (0, _components.GridColumnMenu),
    ErrorOverlay: (0, _errorOverlay.ErrorOverlay),
    Footer: (0, _components.GridFooter),
    Header: (0, _components.GridHeader),
    Toolbar: null,
    PreferencesPanel: (0, _components.GridPreferencesPanel),
    LoadingOverlay: (0, _components.GridLoadingOverlay),
    NoResultsOverlay: (0, _gridNoResultsOverlay.GridNoResultsOverlay),
    NoRowsOverlay: (0, _components.GridNoRowsOverlay),
    Pagination: (0, _components.GridPagination),
    FilterPanel: (0, _components.GridFilterPanel),
    ColumnsPanel: (0, _components.GridColumnsPanel),
    Panel: (0, _components.GridPanel),
    Row: (0, _components.GridRow)
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@mui/material/Checkbox":"jMXWA","@mui/material/TextField":"j02FZ","@mui/material/FormControl":"6EcMm","@mui/material/Select":"aiyFZ","@mui/material/Switch":"3POY0","@mui/material/Button":"6pu9h","@mui/material/Tooltip":"fmb01","@mui/material/Popper":"2EAIq","../components":"6eLWA","../components/columnHeaders/GridColumnUnsortedIcon":"8IBmy","../components/ErrorOverlay":"imDgd","../components/GridNoResultsOverlay":"bOUGp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8IBmy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnUnsortedIcon", ()=>GridColumnUnsortedIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "sortingOrder"
];
const GridColumnUnsortedIcon = /*#__PURE__*/ _react.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === "asc" ? rootProps.components.ColumnSortedAscendingIcon : rootProps.components.ColumnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, (0, _extendsDefault.default)({}, other)) : null;
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"imDgd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorOverlay", ()=>ErrorOverlay);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridOverlay = require("./containers/GridOverlay");
var _useGridSelector = require("../hooks/utils/useGridSelector");
var _densitySelector = require("../hooks/features/density/densitySelector");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "error",
    "hasError",
    "errorInfo"
];
const ErrorOverlay = /*#__PURE__*/ _react.forwardRef(function ErrorOverlay(props, ref) {
    const { error } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const defaultLabel = apiRef.current.getLocaleText("errorOverlayDefaultLabel");
    const rowHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityRowHeightSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridOverlay.GridOverlay), (0, _extendsDefault.default)({
        ref: ref,
        sx: {
            width: "100%",
            minHeight: 2 * rowHeight
        }
    }, other, {
        children: (error == null ? void 0 : error.message) || defaultLabel
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../hooks/utils/useGridApiContext":"cn3M8","./containers/GridOverlay":"dAA19","../hooks/utils/useGridSelector":"96gNX","../hooks/features/density/densitySelector":"chMex","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bOUGp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridNoResultsOverlay", ()=>GridNoResultsOverlay);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _useGridApiContext = require("../hooks/utils/useGridApiContext");
var _gridOverlay = require("./containers/GridOverlay");
var _jsxRuntime = require("react/jsx-runtime");
const GridNoResultsOverlay = /*#__PURE__*/ _react.forwardRef(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText("noResultsOverlayLabel");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridOverlay.GridOverlay), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        children: noResultsOverlayLabel
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../hooks/utils/useGridApiContext":"cn3M8","./containers/GridOverlay":"dAA19","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5S6nW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortingStateInitializer", ()=>sortingStateInitializer);
parcelHelpers.export(exports, "useGridSorting", ()=>useGridSorting);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _gridFeatureMode = require("../../../models/gridFeatureMode");
var _keyboardUtils = require("../../../utils/keyboardUtils");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _gridSortingSelector = require("./gridSortingSelector");
var _rows = require("../rows");
var _useFirstRender = require("../../utils/useFirstRender");
var _strategyProcessing = require("../../core/strategyProcessing");
var _gridSortingUtils = require("./gridSortingUtils");
var _pipeProcessing = require("../../core/pipeProcessing");
const sortingStateInitializer = (state, props)=>{
    var _ref, _props$sortModel, _props$initialState, _props$initialState$s;
    const sortModel = (_ref = (_props$sortModel = props.sortModel) != null ? _props$sortModel : (_props$initialState = props.initialState) == null ? void 0 : (_props$initialState$s = _props$initialState.sorting) == null ? void 0 : _props$initialState$s.sortModel) != null ? _ref : [];
    return (0, _extendsDefault.default)({}, state, {
        sorting: {
            sortModel: (0, _gridSortingUtils.sanitizeSortModel)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const useGridSorting = (apiRef, props)=>{
    var _props$initialState3, _props$initialState3$;
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridSorting");
    apiRef.current.unstable_registerControlState({
        stateId: "sortModel",
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, _gridSortingSelector.gridSortModelSelector),
        changeEvent: "sortModelChange"
    });
    const upsertSortModel = _react.useCallback((field, sortItem)=>{
        const sortModel = (0, _gridSortingSelector.gridSortModelSelector)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (!sortItem) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = _react.useCallback((col, directionOverride)=>{
        var _col$sortingOrder2;
        const sortModel = (0, _gridSortingSelector.gridSortModelSelector)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            var _col$sortingOrder;
            const nextSort = directionOverride === undefined ? (0, _gridSortingUtils.getNextGridSortDirection)((_col$sortingOrder = col.sortingOrder) != null ? _col$sortingOrder : props.sortingOrder, existing.sort) : directionOverride;
            return nextSort == null ? undefined : (0, _extendsDefault.default)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, _gridSortingUtils.getNextGridSortDirection)((_col$sortingOrder2 = col.sortingOrder) != null ? _col$sortingOrder2 : props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    /**
   * API METHODS
   */ const applySorting = _react.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === (0, _gridFeatureMode.GridFeatureModeConstant).server) {
                logger.debug("Skipping sorting rows as sortingMode = server");
                return (0, _extendsDefault.default)({}, state, {
                    sorting: (0, _extendsDefault.default)({}, state.sorting, {
                        sortedRows: (0, _rows.gridRowIdsSelector)(state, apiRef.current.instanceId)
                    })
                });
            }
            const sortModel = (0, _gridSortingSelector.gridSortModelSelector)(state, apiRef.current.instanceId);
            const sortRowList = (0, _gridSortingUtils.buildAggregatedSortingApplier)(sortModel, apiRef);
            const sortedRows = apiRef.current.unstable_applyStrategyProcessor("sorting", {
                sortRowList
            });
            return (0, _extendsDefault.default)({}, state, {
                sorting: (0, _extendsDefault.default)({}, state.sorting, {
                    sortedRows
                })
            });
        });
        apiRef.current.publishEvent("sortedRowsSet");
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = _react.useCallback((model)=>{
        const currentModel = (0, _gridSortingSelector.gridSortModelSelector)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, _gridSortingUtils.mergeStateWithSortModel)(model, props.disableMultipleColumnsSorting));
            apiRef.current.forceUpdate();
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = _react.useCallback((column, direction, allowMultipleSorting)=>{
        if (!column.sortable) return;
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = !sortItem ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = _react.useCallback(()=>(0, _gridSortingSelector.gridSortModelSelector)(apiRef), [
        apiRef
    ]);
    const getSortedRows = _react.useCallback(()=>{
        const sortedRows = (0, _gridSortingSelector.gridSortedRowEntriesSelector)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = _react.useCallback(()=>(0, _gridSortingSelector.gridSortedRowIdsSelector)(apiRef), [
        apiRef
    ]);
    const getRowIndex = _react.useCallback((id)=>apiRef.current.getSortedRowIds().indexOf(id), [
        apiRef
    ]);
    const getRowIdFromRowIndex = _react.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel,
        getSortedRows,
        getSortedRowIds,
        getRowIndex,
        getRowIdFromRowIndex,
        setSortModel,
        sortColumn,
        applySorting
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, sortApi, "GridSortApi");
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = _react.useCallback((prevState, context)=>{
        var _props$initialState2, _props$initialState2$;
        const sortModelToExport = (0, _gridSortingSelector.gridSortModelSelector)(apiRef);
        const shouldExportSortModel = !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        ((_props$initialState2 = props.initialState) == null ? void 0 : (_props$initialState2$ = _props$initialState2.sorting) == null ? void 0 : _props$initialState2$.sortModel) != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, _extendsDefault.default)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        (_props$initialState3 = props.initialState) == null ? void 0 : (_props$initialState3$ = _props$initialState3.sorting) == null ? void 0 : _props$initialState3$.sortModel
    ]);
    const stateRestorePreProcessing = _react.useCallback((params, context)=>{
        var _context$stateToResto;
        const sortModel = (_context$stateToResto = context.stateToRestore.sorting) == null ? void 0 : _context$stateToResto.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, _gridSortingUtils.mergeStateWithSortModel)(sortModel, props.disableMultipleColumnsSorting));
        return (0, _extendsDefault.default)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = _react.useCallback((params)=>{
        const rowTree = (0, _rows.gridRowTreeSelector)(apiRef);
        if (!params.sortRowList) {
            const bodyRowIds = [];
            const footerRowIds = [];
            (0, _rows.gridRowIdsSelector)(apiRef).forEach((rowId)=>{
                if (rowTree[rowId].isPinned) return;
                if (rowTree[rowId].position === "footer") footerRowIds.push(rowId);
                else bodyRowIds.push(rowId);
            });
            return [
                ...bodyRowIds,
                ...footerRowIds
            ];
        }
        const bodyRows = [];
        const footerRowIds = [];
        Object.values(rowTree).forEach((rowNode)=>{
            if (rowNode.isPinned) return;
            if (rowNode.position === "footer") footerRowIds.push(rowNode.id);
            else bodyRows.push(rowNode);
        });
        return [
            ...params.sortRowList(bodyRows),
            ...footerRowIds
        ];
    }, [
        apiRef
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "exportState", stateExportPreProcessing);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "restoreState", stateRestorePreProcessing);
    (0, _strategyProcessing.useGridRegisterStrategyProcessor)(apiRef, (0, _strategyProcessing.GRID_DEFAULT_STRATEGY), "sorting", flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = _react.useCallback(({ colDef }, event)=>{
        const allowMultipleSorting = event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(colDef, undefined, allowMultipleSorting);
    }, [
        sortColumn
    ]);
    const handleColumnHeaderKeyDown = _react.useCallback(({ colDef }, event)=>{
        // Ctrl + Enter opens the column menu
        if ((0, _keyboardUtils.isEnterKey)(event.key) && !event.ctrlKey && !event.metaKey) sortColumn(colDef, undefined, event.shiftKey);
    }, [
        sortColumn
    ]);
    const handleColumnsChange = _react.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, _gridSortingSelector.gridSortModelSelector)(apiRef);
        const latestColumns = (0, _gridColumnsSelector.gridColumnLookupSelector)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = _react.useCallback((methodName)=>{
        if (methodName === "sorting") apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderClick", handleColumnHeaderClick);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderKeyDown", handleColumnHeaderKeyDown);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowsSet", apiRef.current.applySorting);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnsChange", handleColumnsChange);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "activeStrategyProcessorChange", handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, _useFirstRender.useFirstRender)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ _react.useEffect(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../../models/gridFeatureMode":"l5iiY","../../../utils/keyboardUtils":"o7lWn","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../columns/gridColumnsSelector":"aeHtc","./gridSortingSelector":"1g9b1","../rows":"8bHvN","../../utils/useFirstRender":"3zp8V","../../core/strategyProcessing":"dzDtc","./gridSortingUtils":"jsmfR","../../core/pipeProcessing":"jx1az","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49PeG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridScroll", ()=>useGridScroll);
var _react = require("react");
var _useGridLogger = require("../../utils/useGridLogger");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _useGridSelector = require("../../utils/useGridSelector");
var _gridPaginationSelector = require("../pagination/gridPaginationSelector");
var _gridRowsSelector = require("../rows/gridRowsSelector");
var _gridRowsMetaSelector = require("../rows/gridRowsMetaSelector");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridClasses = require("../../../constants/gridClasses"); // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function scrollIntoView(dimensions) {
    const { clientHeight, scrollTop, offsetHeight, offsetTop } = dimensions;
    const elementBottom = offsetTop + offsetHeight; // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (offsetHeight > clientHeight) return offsetTop;
    if (elementBottom - clientHeight > scrollTop) return elementBottom - clientHeight;
    if (offsetTop < scrollTop) return offsetTop;
    return undefined;
}
const useGridScroll = (apiRef, props)=>{
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useGridScroll");
    const colRef = apiRef.current.columnHeadersElementRef;
    const windowRef = apiRef.current.windowRef;
    const visibleSortedRows = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridVisibleSortedRowEntriesSelector));
    const scrollToIndexes = _react.useCallback((params)=>{
        const totalRowCount = (0, _gridRowsSelector.gridRowCountSelector)(apiRef);
        const visibleColumns = (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex != null) {
            const columnPositions = (0, _gridColumnsSelector.gridColumnPositionsSelector)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== "undefined") {
                var _visibleSortedRows$pa;
                const rowId = (_visibleSortedRows$pa = visibleSortedRows[params.rowIndex]) == null ? void 0 : _visibleSortedRows$pa.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === "undefined") cellWidth = visibleColumns[params.colIndex].computedWidth;
            scrollCoordinates.left = scrollIntoView({
                clientHeight: windowRef.current.clientWidth,
                scrollTop: windowRef.current.scrollLeft,
                offsetHeight: cellWidth,
                offsetTop: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex != null) {
            var _querySelector, _querySelector2;
            const rowsMeta = (0, _gridRowsMetaSelector.gridRowsMetaSelector)(apiRef.current.state);
            const page = (0, _gridPaginationSelector.gridPageSelector)(apiRef);
            const pageSize = (0, _gridPaginationSelector.gridPageSizeSelector)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            const topPinnedRowsHeight = ((_querySelector = windowRef.current.querySelector(`.${(0, _gridClasses.gridClasses)["pinnedRows--top"]}`)) == null ? void 0 : _querySelector.clientHeight) || 0;
            const bottomPinnedRowsHeight = ((_querySelector2 = windowRef.current.querySelector(`.${(0, _gridClasses.gridClasses)["pinnedRows--bottom"]}`)) == null ? void 0 : _querySelector2.clientHeight) || 0;
            scrollCoordinates.top = scrollIntoView({
                clientHeight: windowRef.current.clientHeight - topPinnedRowsHeight - bottomPinnedRowsHeight,
                scrollTop: windowRef.current.scrollTop,
                offsetHeight: targetOffsetHeight,
                offsetTop: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors("scrollToIndexes", scrollCoordinates, params);
        scrollCoordinates.left;
        apiRef.current.scroll(scrollCoordinates);
        return true;
        return false;
    }, [
        logger,
        apiRef,
        windowRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = _react.useCallback((params)=>{
        if (windowRef.current && params.left != null && colRef.current) {
            colRef.current.scrollLeft = params.left;
            windowRef.current.scrollLeft = params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (windowRef.current && params.top != null) {
            windowRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        windowRef,
        colRef,
        logger
    ]);
    const getScrollPosition = _react.useCallback(()=>{
        if (!(windowRef != null && windowRef.current)) return {
            top: 0,
            left: 0
        };
        return {
            top: windowRef.current.scrollTop,
            left: windowRef.current.scrollLeft
        };
    }, [
        windowRef
    ]);
    const scrollApi = {
        scroll,
        scrollToIndexes,
        getScrollPosition
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, scrollApi, "GridScrollApi");
};

},{"react":"gVheC","../../utils/useGridLogger":"6dTTN","../columns/gridColumnsSelector":"aeHtc","../../utils/useGridSelector":"96gNX","../pagination/gridPaginationSelector":"e6xRD","../rows/gridRowsSelector":"fCZaq","../rows/gridRowsMetaSelector":"bjCPy","../../utils/useGridApiMethod":"5EPiD","../filter/gridFilterSelector":"lndlA","../../../constants/gridClasses":"5U0ME","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7hi5I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @requires useGridFocus (event) - can be after, async only
 * @requires useGridColumns (event) - can be after, async only
 */ parcelHelpers.export(exports, "useGridEvents", ()=>useGridEvents);
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
function useGridEvents(apiRef, props) {
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderClick", props.onColumnHeaderClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderDoubleClick", props.onColumnHeaderDoubleClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderOver", props.onColumnHeaderOver);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderOut", props.onColumnHeaderOut);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderEnter", props.onColumnHeaderEnter);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnHeaderLeave", props.onColumnHeaderLeave);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnOrderChange", props.onColumnOrderChange);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellClick", props.onCellClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellDoubleClick", props.onCellDoubleClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellKeyDown", props.onCellKeyDown);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "cellFocusOut", props.onCellFocusOut);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "preferencePanelClose", props.onPreferencePanelClose);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "preferencePanelOpen", props.onPreferencePanelOpen);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "menuOpen", props.onMenuOpen);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "menuClose", props.onMenuClose);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowDoubleClick", props.onRowDoubleClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "rowClick", props.onRowClick);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "componentError", props.onError);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "stateChange", props.onStateChange);
}

},{"../../utils/useGridApiEventHandler":"iBXeM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6db1m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridDimensions", ()=>useGridDimensions);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridLogger = require("../../utils/useGridLogger");
var _columns = require("../columns");
var _density = require("../density");
var _utils1 = require("../../utils");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _gridRowsMetaSelector = require("../rows/gridRowsMetaSelector");
var _gridRowsUtils = require("../rows/gridRowsUtils");
const isTestEnvironment = false;
const hasScroll = ({ content, container, scrollBarSize })=>{
    const hasScrollXIfNoYScrollBar = content.width > container.width;
    const hasScrollYIfNoXScrollBar = content.height > container.height;
    let hasScrollX = false;
    let hasScrollY = false;
    if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
        hasScrollX = hasScrollXIfNoYScrollBar;
        hasScrollY = content.height + (hasScrollX ? scrollBarSize : 0) > container.height; // We recalculate the scroll x to consider the size of the y scrollbar.
        if (hasScrollY) hasScrollX = content.width + scrollBarSize > container.width;
    }
    return {
        hasScrollX,
        hasScrollY
    };
};
function useGridDimensions(apiRef, props) {
    const logger = (0, _useGridLogger.useGridLogger)(apiRef, "useResizeContainer");
    const errorShown = _react.useRef(false);
    const rootDimensionsRef = _react.useRef(null);
    const fullDimensionsRef = _react.useRef(null);
    const rowsMeta = (0, _utils1.useGridSelector)(apiRef, (0, _gridRowsMetaSelector.gridRowsMetaSelector));
    const totalHeaderHeight = (0, _utils1.useGridSelector)(apiRef, (0, _density.gridDensityTotalHeaderHeightSelector));
    const updateGridDimensionsRef = _react.useCallback(()=>{
        var _apiRef$current$rootE;
        const rootElement = (_apiRef$current$rootE = apiRef.current.rootElementRef) == null ? void 0 : _apiRef$current$rootE.current;
        const columnsTotalWidth = (0, _columns.gridColumnsTotalWidthSelector)(apiRef);
        const pinnedRowsHeight = (0, _gridRowsUtils.calculatePinnedRowsHeight)(apiRef);
        if (!rootDimensionsRef.current) return;
        let scrollBarSize;
        if (props.scrollbarSize != null) scrollBarSize = props.scrollbarSize;
        else if (!columnsTotalWidth || !rootElement) scrollBarSize = 0;
        else {
            const doc = (0, _utils.ownerDocument)(rootElement);
            const scrollDiv = doc.createElement("div");
            scrollDiv.style.width = "99px";
            scrollDiv.style.height = "99px";
            scrollDiv.style.position = "absolute";
            scrollDiv.style.overflow = "scroll";
            scrollDiv.className = "scrollDiv";
            rootElement.appendChild(scrollDiv);
            scrollBarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            rootElement.removeChild(scrollDiv);
        }
        let viewportOuterSize;
        let hasScrollX;
        let hasScrollY;
        if (props.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > rootDimensionsRef.current.width;
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rowsMeta.currentPageTotalHeight + (hasScrollX ? scrollBarSize : 0)
            };
        } else {
            viewportOuterSize = {
                width: rootDimensionsRef.current.width,
                height: rootDimensionsRef.current.height - totalHeaderHeight
            };
            const scrollInformation = hasScroll({
                content: {
                    width: Math.round(columnsTotalWidth),
                    height: rowsMeta.currentPageTotalHeight
                },
                container: {
                    width: viewportOuterSize.width,
                    height: viewportOuterSize.height - pinnedRowsHeight.top - pinnedRowsHeight.bottom
                },
                scrollBarSize
            });
            hasScrollY = scrollInformation.hasScrollY;
            hasScrollX = scrollInformation.hasScrollX;
        }
        const viewportInnerSize = {
            width: viewportOuterSize.width - (hasScrollY ? scrollBarSize : 0),
            height: viewportOuterSize.height - (hasScrollX ? scrollBarSize : 0)
        };
        const newFullDimensions = {
            viewportOuterSize,
            viewportInnerSize,
            hasScrollX,
            hasScrollY,
            scrollBarSize
        };
        const prevDimensions = fullDimensionsRef.current;
        fullDimensionsRef.current = newFullDimensions;
        if (newFullDimensions.viewportInnerSize.width !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.width) || newFullDimensions.viewportInnerSize.height !== (prevDimensions == null ? void 0 : prevDimensions.viewportInnerSize.height)) apiRef.current.publishEvent("viewportInnerSizeChange", newFullDimensions.viewportInnerSize);
    }, [
        apiRef,
        props.scrollbarSize,
        props.autoHeight,
        totalHeaderHeight,
        rowsMeta.currentPageTotalHeight
    ]);
    const resize = _react.useCallback(()=>{
        updateGridDimensionsRef();
        apiRef.current.publishEvent("debouncedResize", rootDimensionsRef.current);
    }, [
        apiRef,
        updateGridDimensionsRef
    ]);
    const getRootDimensions = _react.useCallback(()=>fullDimensionsRef.current, []);
    const getViewportPageSize = _react.useCallback(()=>{
        const dimensions = apiRef.current.getRootDimensions();
        if (!dimensions) return 0;
        const currentPage = (0, _useGridVisibleRows.getVisibleRows)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        }); // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (props.getRowHeight) {
            const renderContext = apiRef.current.unstable_getRenderContext();
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, currentPage.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / (0, _density.gridDensityRowHeightSelector)(apiRef));
        return Math.min(maximumPageSizeWithoutScrollBar, currentPage.rows.length);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode,
        props.getRowHeight
    ]);
    const dimensionsApi = {
        resize,
        getRootDimensions,
        unstable_getViewportPageSize: getViewportPageSize,
        unstable_updateGridDimensionsRef: updateGridDimensionsRef
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, dimensionsApi, "GridDimensionsApi");
    const debounceResize = _react.useMemo(()=>(0, _utils.debounce)(resize, 60), [
        resize
    ]);
    const isFirstSizing = _react.useRef(true);
    const handleResize = _react.useCallback((size)=>{
        rootDimensionsRef.current = size; // jsdom has no layout capabilities
        const isJSDOM = /jsdom/.test(window.navigator.userAgent);
        if (size.height === 0 && !errorShown.current && !props.autoHeight && !isJSDOM) {
            logger.error([
                "The parent DOM element of the data grid has an empty height.",
                "Please make sure that this element has an intrinsic height.",
                "The grid displays with a height of 0px.",
                "",
                "More details: https://mui.com/r/x-data-grid-no-dimensions."
            ].join("\n"));
            errorShown.current = true;
        }
        if (size.width === 0 && !errorShown.current && !isJSDOM) {
            logger.error([
                "The parent DOM element of the data grid has an empty width.",
                "Please make sure that this element has an intrinsic width.",
                "The grid displays with a width of 0px.",
                "",
                "More details: https://mui.com/r/x-data-grid-no-dimensions."
            ].join("\n"));
            errorShown.current = true;
        }
        if (isTestEnvironment) {
            // We don't need to debounce the resize for tests.
            resize();
            isFirstSizing.current = false;
            return;
        }
        if (isFirstSizing.current) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            resize();
            isFirstSizing.current = false;
            return;
        }
        debounceResize();
    }, [
        props.autoHeight,
        debounceResize,
        logger,
        resize
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>updateGridDimensionsRef(), [
        updateGridDimensionsRef
    ]);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "sortedRowsSet", updateGridDimensionsRef);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "pageChange", updateGridDimensionsRef);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "pageSizeChange", updateGridDimensionsRef);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "columnsChange", updateGridDimensionsRef);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "resize", handleResize);
    (0, _useGridApiEventHandler.useGridApiOptionHandler)(apiRef, "debouncedResize", props.onResize);
}

},{"react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridApiEventHandler":"iBXeM","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridLogger":"6dTTN","../columns":"99F9P","../density":"8Z1Np","../../utils":"43GNT","../../utils/useGridVisibleRows":"giBK8","../rows/gridRowsMetaSelector":"bjCPy","../rows/gridRowsUtils":"iSo8b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"izdSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rowsMetaStateInitializer", ()=>rowsMetaStateInitializer);
parcelHelpers.export(exports, "useGridRowsMeta", ()=>useGridRowsMeta);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/material/utils");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridSelector = require("../../utils/useGridSelector");
var _densitySelector = require("../density/densitySelector");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridPaginationSelector = require("../pagination/gridPaginationSelector");
var _gridSortingSelector = require("../sorting/gridSortingSelector");
var _pipeProcessing = require("../../core/pipeProcessing");
var _gridRowsSelector = require("./gridRowsSelector");
const rowsMetaStateInitializer = (state)=>(0, _extendsDefault.default)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: 0,
            positions: []
        }
    });
const useGridRowsMeta = (apiRef, props)=>{
    const { getRowHeight: getRowHeightProp, getRowSpacing, getEstimatedRowHeight } = props;
    const rowsHeightLookup = _react.useRef({}); // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    const lastMeasuredRowIndex = _react.useRef(-1);
    const hasRowWithAutoHeight = _react.useRef(false);
    const rowHeightFromDensity = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityRowHeightSelector));
    const filterState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridFilterStateSelector));
    const paginationState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridPaginationSelector.gridPaginationSelector));
    const sortingState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSortingSelector.gridSortingStateSelector));
    const currentPage = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, props);
    const pinnedRows = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsSelector.gridPinnedRowsSelector));
    const hydrateRowsMeta = _react.useCallback(()=>{
        var _pinnedRows$top, _pinnedRows$bottom;
        hasRowWithAutoHeight.current = false;
        const densityFactor = (0, _densitySelector.gridDensityFactorSelector)(apiRef.current.state, apiRef.current.instanceId);
        const calculateRowProcessedSizes = (row)=>{
            if (!rowsHeightLookup.current[row.id]) rowsHeightLookup.current[row.id] = {
                sizes: {
                    baseCenter: rowHeightFromDensity
                },
                isResized: false,
                autoHeight: false,
                needsFirstMeasurement: true // Assume all rows will need to be measured by default
            };
            const { isResized, needsFirstMeasurement, sizes } = rowsHeightLookup.current[row.id];
            let baseRowHeight = rowHeightFromDensity;
            const existingBaseRowHeight = sizes.baseCenter;
            if (isResized) // Do not recalculate resized row height and use the value from the lookup
            baseRowHeight = existingBaseRowHeight;
            else if (getRowHeightProp) {
                const rowHeightFromUser = getRowHeightProp((0, _extendsDefault.default)({}, row, {
                    densityFactor
                }));
                if (rowHeightFromUser === "auto") {
                    if (needsFirstMeasurement) {
                        const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight((0, _extendsDefault.default)({}, row, {
                            densityFactor
                        })) : rowHeightFromDensity; // If the row was not measured yet use the estimated row height
                        baseRowHeight = estimatedRowHeight != null ? estimatedRowHeight : rowHeightFromDensity;
                    } else baseRowHeight = existingBaseRowHeight;
                    hasRowWithAutoHeight.current = true;
                    rowsHeightLookup.current[row.id].autoHeight = true;
                } else {
                    // Default back to base rowHeight if getRowHeight returns null or undefined.
                    baseRowHeight = rowHeightFromUser != null ? rowHeightFromUser : rowHeightFromDensity;
                    rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
                    rowsHeightLookup.current[row.id].autoHeight = false;
                }
            } else rowsHeightLookup.current[row.id].needsFirstMeasurement = false;
            const existingBaseSizes = Object.entries(sizes).reduce((acc, [key, size])=>{
                if (/^base[A-Z]/.test(key)) acc[key] = size;
                return acc;
            }, {}); // We use an object to make simple to check if a height is already added or not
            const initialHeights = (0, _extendsDefault.default)({}, existingBaseSizes, {
                baseCenter: baseRowHeight
            });
            if (getRowSpacing) {
                var _spacing$top, _spacing$bottom;
                const indexRelativeToCurrentPage = apiRef.current.getRowIndexRelativeToVisibleRows(row.id);
                const spacing = getRowSpacing((0, _extendsDefault.default)({}, row, {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage
                }));
                initialHeights.spacingTop = (_spacing$top = spacing.top) != null ? _spacing$top : 0;
                initialHeights.spacingBottom = (_spacing$bottom = spacing.bottom) != null ? _spacing$bottom : 0;
            }
            const processedSizes = apiRef.current.unstable_applyPipeProcessors("rowHeight", initialHeights, row);
            rowsHeightLookup.current[row.id].sizes = processedSizes;
            return processedSizes;
        };
        const positions = [];
        const currentPageTotalHeight = currentPage.rows.reduce((acc, row)=>{
            positions.push(acc);
            let maximumBaseSize = 0;
            let otherSizes = 0;
            const processedSizes = calculateRowProcessedSizes(row);
            Object.entries(processedSizes).forEach(([size, value])=>{
                if (/^base[A-Z]/.test(size)) maximumBaseSize = value > maximumBaseSize ? value : maximumBaseSize;
                else otherSizes += value;
            });
            return acc + maximumBaseSize + otherSizes;
        }, 0);
        pinnedRows == null || (_pinnedRows$top = pinnedRows.top) == null || _pinnedRows$top.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        pinnedRows == null || (_pinnedRows$bottom = pinnedRows.bottom) == null || _pinnedRows$bottom.forEach((row)=>{
            calculateRowProcessedSizes(row);
        });
        apiRef.current.setState((state)=>{
            return (0, _extendsDefault.default)({}, state, {
                rowsMeta: {
                    currentPageTotalHeight,
                    positions
                }
            });
        });
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        apiRef.current.forceUpdate();
    }, [
        apiRef,
        currentPage.rows,
        rowHeightFromDensity,
        getRowHeightProp,
        getRowSpacing,
        getEstimatedRowHeight,
        pinnedRows
    ]);
    const getRowHeight = _react.useCallback((rowId)=>{
        const height = rowsHeightLookup.current[rowId];
        return height ? height.sizes.baseCenter : rowHeightFromDensity;
    }, [
        rowHeightFromDensity
    ]);
    const getRowInternalSizes = (rowId)=>{
        var _rowsHeightLookup$cur;
        return (_rowsHeightLookup$cur = rowsHeightLookup.current[rowId]) == null ? void 0 : _rowsHeightLookup$cur.sizes;
    };
    const setRowHeight = _react.useCallback((id, height)=>{
        rowsHeightLookup.current[id].sizes.baseCenter = height;
        rowsHeightLookup.current[id].isResized = true;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    const debouncedHydrateRowsMeta = _react.useMemo(()=>(0, _utils.debounce)(hydrateRowsMeta), [
        hydrateRowsMeta
    ]);
    const storeMeasuredRowHeight = _react.useCallback((id, height, position)=>{
        if (!rowsHeightLookup.current[id] || !rowsHeightLookup.current[id].autoHeight) return;
         // Only trigger hydration if the value is different, otherwise we trigger a loop
        const needsHydration = rowsHeightLookup.current[id].sizes[`base${(0, _utils.capitalize)(position)}`] !== height;
        rowsHeightLookup.current[id].needsFirstMeasurement = false;
        rowsHeightLookup.current[id].sizes[`base${(0, _utils.capitalize)(position)}`] = height;
        if (needsHydration) debouncedHydrateRowsMeta();
    }, [
        debouncedHydrateRowsMeta
    ]);
    const rowHasAutoHeight = _react.useCallback((id)=>{
        var _rowsHeightLookup$cur2;
        return ((_rowsHeightLookup$cur2 = rowsHeightLookup.current[id]) == null ? void 0 : _rowsHeightLookup$cur2.autoHeight) || false;
    }, []);
    const getLastMeasuredRowIndex = _react.useCallback(()=>{
        return lastMeasuredRowIndex.current;
    }, []);
    const setLastMeasuredRowIndex = _react.useCallback((index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    }, []);
    const resetRowHeights = _react.useCallback(()=>{
        rowsHeightLookup.current = {};
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]); // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    _react.useEffect(()=>{
        hydrateRowsMeta();
    }, [
        rowHeightFromDensity,
        filterState,
        paginationState,
        sortingState,
        hydrateRowsMeta
    ]);
    (0, _pipeProcessing.useGridRegisterPipeApplier)(apiRef, "rowHeight", hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_rowHasAutoHeight: rowHasAutoHeight,
        unstable_getRowHeight: getRowHeight,
        unstable_getRowInternalSizes: getRowInternalSizes,
        unstable_setRowHeight: setRowHeight,
        unstable_storeRowHeightMeasurement: storeMeasuredRowHeight,
        resetRowHeights
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, rowsMetaApi, "GridRowsMetaApi");
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/utils":"ziQFX","../../utils/useGridVisibleRows":"giBK8","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridSelector":"96gNX","../density/densitySelector":"chMex","../filter/gridFilterSelector":"lndlA","../pagination/gridPaginationSelector":"e6xRD","../sorting/gridSortingSelector":"1g9b1","../../core/pipeProcessing":"jx1az","./gridRowsSelector":"fCZaq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hOzDJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridStatePersistence", ()=>useGridStatePersistence);
var _react = require("react");
var _utils = require("../../utils");
const useGridStatePersistence = (apiRef)=>{
    const exportState = _react.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors("exportState", {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = _react.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors("restoreState", {
            callbacks: []
        }, {
            stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
        apiRef.current.forceUpdate();
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState,
        restoreState
    };
    (0, _utils.useGridApiMethod)(apiRef, statePersistenceApi, "GridStatePersistenceApi");
};

},{"react":"gVheC","../../utils":"43GNT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eno7h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridColumnSpanning", ()=>useGridColumnSpanning);
var _react = require("react");
var _useGridApiMethod = require("../../utils/useGridApiMethod");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
const useGridColumnSpanning = (apiRef)=>{
    const lookup = _react.useRef({});
    const setCellColSpanInfo = _react.useCallback((rowId, columnIndex, cellColSpanInfo)=>{
        const sizes = lookup.current;
        if (!sizes[rowId]) sizes[rowId] = {};
        sizes[rowId][columnIndex] = cellColSpanInfo;
    }, []);
    const getCellColSpanInfo = _react.useCallback((rowId, columnIndex)=>{
        var _lookup$current$rowId;
        return (_lookup$current$rowId = lookup.current[rowId]) == null ? void 0 : _lookup$current$rowId[columnIndex];
    }, []); // Calculate `colSpan` for the cell.
    const calculateCellColSpan = _react.useCallback((params)=>{
        const { columnIndex, rowId, minFirstColumnIndex, maxLastColumnIndex, columns } = params;
        const columnsLength = columns.length;
        const column = columns[columnIndex];
        const colSpan = typeof column.colSpan === "function" ? column.colSpan(apiRef.current.getCellParams(rowId, column.field)) : column.colSpan;
        if (!colSpan || colSpan === 1) {
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan: 1,
                    width: column.computedWidth
                }
            });
            return {
                colSpan: 1
            };
        }
        let width = column.computedWidth;
        for(let j = 1; j < colSpan; j += 1){
            const nextColumnIndex = columnIndex + j; // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
            if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
                const nextColumn = columns[nextColumnIndex];
                width += nextColumn.computedWidth;
                setCellColSpanInfo(rowId, columnIndex + j, {
                    spannedByColSpan: true,
                    rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                    leftVisibleCellIndex: columnIndex
                });
            }
            setCellColSpanInfo(rowId, columnIndex, {
                spannedByColSpan: false,
                cellProps: {
                    colSpan,
                    width
                }
            });
        }
        return {
            colSpan
        };
    }, [
        apiRef,
        setCellColSpanInfo
    ]); // Calculate `colSpan` for each cell in the row
    const calculateColSpan = _react.useCallback(({ rowId, minFirstColumn, maxLastColumn, columns })=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = calculateCellColSpan({
                columnIndex: i,
                rowId,
                minFirstColumnIndex: minFirstColumn,
                maxLastColumnIndex: maxLastColumn,
                columns
            });
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    }, [
        calculateCellColSpan
    ]);
    const columnSpanningApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo,
        unstable_calculateColSpan: calculateColSpan
    };
    (0, _useGridApiMethod.useGridApiMethod)(apiRef, columnSpanningApi, "GridColumnSpanningAPI");
    const handleColumnReorderChange = _react.useCallback(()=>{
        // `colSpan` needs to be recalculated after column reordering
        lookup.current = {};
    }, []);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnOrderChange", handleColumnReorderChange);
};

},{"react":"gVheC","../../utils/useGridApiMethod":"5EPiD","../../utils/useGridApiEventHandler":"iBXeM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eHTkg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridColumnGroupingPreProcessors", ()=>useGridColumnGroupingPreProcessors);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _pipeProcessing = require("../../core/pipeProcessing");
var _utils = require("../../../utils/utils");
var _useGridColumnGrouping = require("./useGridColumnGrouping");
const useGridColumnGroupingPreProcessors = (apiRef, props)=>{
    var _props$experimentalFe2;
    const addHeaderGroups = _react.useCallback((columnsState)=>{
        var _props$experimentalFe;
        if (!((_props$experimentalFe = props.experimentalFeatures) != null && _props$experimentalFe.columnGrouping)) return columnsState;
        const unwrappedGroupingModel = (0, _useGridColumnGrouping.unwrapGroupingColumnModel)(props.columnGroupingModel);
        columnsState.all.forEach((field)=>{
            var _unwrappedGroupingMod, _unwrappedGroupingMod2;
            const newGroupPath = (_unwrappedGroupingMod = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod : [];
            const lookupElement = columnsState.lookup[field];
            if ((0, _useGridColumnGrouping.hasGroupPath)(lookupElement) && (0, _utils.isDeepEqual)(newGroupPath, lookupElement == null ? void 0 : lookupElement.groupPath)) // Avoid modifying the pointer to allow shadow comparison in https://github.com/mui/mui-x/blob/f90afbf10a1264ee8b453d7549dd7cdd6110a4ed/packages/grid/x-data-grid/src/hooks/features/columns/gridColumnsUtils.ts#L446:L453
            return;
            columnsState.lookup[field] = (0, _extendsDefault.default)({}, columnsState.lookup[field], {
                groupPath: (_unwrappedGroupingMod2 = unwrappedGroupingModel[field]) != null ? _unwrappedGroupingMod2 : []
            });
        });
        return columnsState;
    }, [
        props.columnGroupingModel,
        (_props$experimentalFe2 = props.experimentalFeatures) == null ? void 0 : _props$experimentalFe2.columnGrouping
    ]);
    (0, _pipeProcessing.useGridRegisterPipeProcessor)(apiRef, "hydrateColumns", addHeaderGroups);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","../../core/pipeProcessing":"jx1az","../../../utils/utils":"lwlsg","./useGridColumnGrouping":"rtuq4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e5PtH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_PAGE_SIZE", ()=>MAX_PAGE_SIZE);
parcelHelpers.export(exports, "DATA_GRID_PROPS_DEFAULT_VALUES", ()=>DATA_GRID_PROPS_DEFAULT_VALUES);
parcelHelpers.export(exports, "useDataGridProps", ()=>useDataGridProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _styles = require("@mui/material/styles");
var _constants = require("../constants");
var _models = require("../models");
const DATA_GRID_FORCED_PROPS = {
    apiRef: undefined,
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    disableMultipleSelection: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    disableColumnResize: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: "DataGrid"
};
const MAX_PAGE_SIZE = 100;
const DATA_GRID_PROPS_DEFAULT_VALUES = {
    autoHeight: false,
    autoPageSize: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    columnBuffer: 3,
    rowBuffer: 3,
    columnThreshold: 3,
    rowThreshold: 3,
    density: (0, _models.GridDensityTypes).Standard,
    disableExtendRowFullWidth: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnSelector: false,
    disableDensitySelector: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleSelection: false,
    disableMultipleColumnsSorting: false,
    disableSelectionOnClick: false,
    disableVirtualization: false,
    disableIgnoreModificationsIfProcessingProps: false,
    editMode: (0, _models.GridEditModes).Cell,
    filterMode: (0, _models.GridFeatureModeConstant).client,
    headerHeight: 56,
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    logger: console,
    logLevel: "error",
    pagination: false,
    paginationMode: (0, _models.GridFeatureModeConstant).client,
    rowHeight: 52,
    rowsPerPageOptions: [
        25,
        50,
        100
    ],
    rowSpacingType: "margin",
    showCellRightBorder: false,
    showColumnRightBorder: false,
    sortingOrder: [
        "asc",
        "desc",
        null
    ],
    sortingMode: (0, _models.GridFeatureModeConstant).client,
    throttleRowsMs: 0,
    disableColumnReorder: false,
    disableColumnResize: false,
    keepNonExistentRowsSelected: false,
    keepColumnPositionIfDraggedOutside: false
};
const useDataGridProps = (inProps)=>{
    if (inProps.pageSize > MAX_PAGE_SIZE) throw new Error(`'props.pageSize' cannot exceed 100 in DataGrid.`);
    const themedProps = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiDataGrid"
    });
    const localeText = _react.useMemo(()=>(0, _extendsDefault.default)({}, (0, _constants.GRID_DEFAULT_LOCALE_TEXT), themedProps.localeText), [
        themedProps.localeText
    ]);
    const components = _react.useMemo(()=>{
        const overrides = themedProps.components;
        if (!overrides) return (0, _extendsDefault.default)({}, (0, _constants.DATA_GRID_DEFAULT_SLOTS_COMPONENTS));
        const mergedComponents = {};
        Object.entries((0, _constants.DATA_GRID_DEFAULT_SLOTS_COMPONENTS)).forEach(([key, defaultComponent])=>{
            mergedComponents[key] = overrides[key] === undefined ? defaultComponent : overrides[key];
        });
        return mergedComponents;
    }, [
        themedProps.components
    ]);
    return _react.useMemo(()=>(0, _extendsDefault.default)({}, DATA_GRID_PROPS_DEFAULT_VALUES, themedProps, {
            localeText,
            components
        }, DATA_GRID_FORCED_PROPS), [
        themedProps,
        localeText,
        components
    ]);
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/material/styles":"gNR9m","../constants":"bDcEB","../models":"15Dm5","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ee75N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataGridVirtualScroller", ()=>DataGridVirtualScroller);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _gridVirtualScroller = require("./virtualization/GridVirtualScroller");
var _gridVirtualScrollerContent = require("./virtualization/GridVirtualScrollerContent");
var _gridVirtualScrollerRenderZone = require("./virtualization/GridVirtualScrollerRenderZone");
var _useGridVirtualScroller = require("../hooks/features/virtualization/useGridVirtualScroller");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "disableVirtualization"
];
const DataGridVirtualScroller = /*#__PURE__*/ _react.forwardRef(function DataGridVirtualScroller(props, ref) {
    const { className, disableVirtualization } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { getRootProps, getContentProps, getRenderZoneProps, getRows } = (0, _useGridVirtualScroller.useGridVirtualScroller)({
        ref,
        disableVirtualization
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridVirtualScroller.GridVirtualScroller), (0, _extendsDefault.default)({
        className: className
    }, getRootProps(other), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridVirtualScrollerContent.GridVirtualScrollerContent), (0, _extendsDefault.default)({}, getContentProps(), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridVirtualScrollerRenderZone.GridVirtualScrollerRenderZone), (0, _extendsDefault.default)({}, getRenderZoneProps(), {
                children: getRows()
            }))
        }))
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","./virtualization/GridVirtualScroller":"cDZqS","./virtualization/GridVirtualScrollerContent":"dh8Iq","./virtualization/GridVirtualScrollerRenderZone":"3CwYH","../hooks/features/virtualization/useGridVirtualScroller":"cPTmb","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cDZqS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridVirtualScroller", ()=>GridVirtualScroller);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "virtualScroller"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const VirtualScrollerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScroller",
    overridesResolver: (props, styles)=>styles.virtualScroller
})({
    overflow: "auto",
    // See https://github.com/mui/mui-x/issues/4360
    position: "relative",
    "@media print": {
        overflow: "hidden"
    }
});
const GridVirtualScroller = /*#__PURE__*/ _react.forwardRef(function GridVirtualScroller(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VirtualScrollerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dh8Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridVirtualScrollerContent", ()=>GridVirtualScrollerContent);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "style"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, overflowedContent } = ownerState;
    const slots = {
        root: [
            "virtualScrollerContent",
            overflowedContent && "virtualScrollerContent--overflowed"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const VirtualScrollerContentRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerContent",
    overridesResolver: (props, styles)=>styles.virtualScrollerContent
})({});
const GridVirtualScrollerContent = /*#__PURE__*/ _react.forwardRef(function GridVirtualScrollerContent(props, ref) {
    const { className, style } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, rootProps, {
        overflowedContent: !rootProps.autoHeight && (style == null ? void 0 : style.minHeight) === "auto"
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VirtualScrollerContentRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        style: style
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3CwYH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridVirtualScrollerRenderZone", ()=>GridVirtualScrollerRenderZone);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridClasses = require("../../constants/gridClasses");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "virtualScrollerRenderZone"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const VirtualScrollerRenderZoneRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "VirtualScrollerRenderZone",
    overridesResolver: (props, styles)=>styles.virtualScrollerRenderZone
})({
    position: "absolute",
    display: "flex",
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: "column"
});
const GridVirtualScrollerRenderZone = /*#__PURE__*/ _react.forwardRef(function GridVirtualScrollerRenderZone(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VirtualScrollerRenderZoneRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material/styles":"gNR9m","@mui/material":"iknXc","../../hooks/utils/useGridRootProps":"cdy2y","../../constants/gridClasses":"5U0ME","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cPTmb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "binarySearch", ()=>binarySearch);
parcelHelpers.export(exports, "getRenderableIndexes", ()=>getRenderableIndexes);
parcelHelpers.export(exports, "useGridVirtualScroller", ()=>useGridVirtualScroller);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDom = require("react-dom");
var _utils = require("@mui/material/utils");
var _useGridApiContext = require("../../utils/useGridApiContext");
var _useGridRootProps = require("../../utils/useGridRootProps");
var _useGridSelector = require("../../utils/useGridSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _densitySelector = require("../density/densitySelector");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _gridEditRowsSelector = require("../editRows/gridEditRowsSelector");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _utils1 = require("../../../utils/utils");
var _gridSelectionSelector = require("../selection/gridSelectionSelector");
var _gridRowsMetaSelector = require("../rows/gridRowsMetaSelector");
var _gridColumnsUtils = require("../columns/gridColumnsUtils"); // Uses binary search to avoid looping through all possible positions
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "style"
];
function binarySearch(offset, positions, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const itemOffset = positions[pivot];
    return offset <= itemOffset ? binarySearch(offset, positions, sliceStart, pivot) : binarySearch(offset, positions, pivot + 1, sliceEnd);
}
function exponentialSearch(offset, positions, index) {
    let interval = 1;
    while(index < positions.length && positions[index] < offset){
        index += interval;
        interval *= 2;
    }
    return binarySearch(offset, positions, Math.floor(index / 2), Math.min(index, positions.length));
}
const getRenderableIndexes = ({ firstIndex, lastIndex, buffer, minFirstIndex, maxLastIndex })=>{
    return [
        (0, _utils1.clamp)(firstIndex - buffer, minFirstIndex, maxLastIndex),
        (0, _utils1.clamp)(lastIndex + buffer, minFirstIndex, maxLastIndex)
    ];
};
const areRenderContextsEqual = (context1, context2)=>{
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
};
const useGridVirtualScroller = (props)=>{
    var _currentPage$range3, _currentPage$range4;
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const visibleColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector));
    const { ref, disableVirtualization, onRenderZonePositioning, renderZoneMinColumnIndex = 0, renderZoneMaxColumnIndex = visibleColumns.length, getRowProps } = props;
    const columnPositions = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnPositionsSelector));
    const columnsTotalWidth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnsTotalWidthSelector));
    const rowHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityRowHeightSelector));
    const cellFocus = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridFocusCellSelector));
    const cellTabIndex = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridTabIndexCellSelector));
    const rowsMeta = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridRowsMetaSelector.gridRowsMetaSelector));
    const editRowsState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridEditRowsSelector.gridEditRowsStateSelector));
    const selectedRowsLookup = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSelectionSelector.selectedIdsLookupSelector));
    const currentPage = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, rootProps);
    const renderZoneRef = _react.useRef(null);
    const rootRef = _react.useRef(null);
    const handleRef = (0, _utils.useForkRef)(ref, rootRef);
    const [renderContext, setRenderContext] = _react.useState(null);
    const prevRenderContext = _react.useRef(renderContext);
    const scrollPosition = _react.useRef({
        top: 0,
        left: 0
    });
    const [containerDimensions, setContainerDimensions] = _react.useState({
        width: null,
        height: null
    });
    const prevTotalWidth = _react.useRef(columnsTotalWidth);
    const getNearestIndexToRender = _react.useCallback((offset)=>{
        var _currentPage$range, _currentPage$range2;
        const lastMeasuredIndexRelativeToAllRows = apiRef.current.unstable_getLastMeasuredRowIndex();
        let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
        if ((_currentPage$range = currentPage.range) != null && _currentPage$range.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
        allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= currentPage.range.lastRowIndex;
        const lastMeasuredIndexRelativeToCurrentPage = (0, _utils1.clamp)(lastMeasuredIndexRelativeToAllRows - (((_currentPage$range2 = currentPage.range) == null ? void 0 : _currentPage$range2.firstRowIndex) || 0), 0, rowsMeta.positions.length);
        if (allRowsMeasured || rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
        // were measured, then use a binary search because it's faster.
        return binarySearch(offset, rowsMeta.positions);
         // Otherwise, use an exponential search.
        // If rows have "auto" as height, their positions will be based on estimated heights.
        // In this case, we can skip several steps until we find a position higher than the offset.
        // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
        return exponentialSearch(offset, rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage);
    }, [
        apiRef,
        (_currentPage$range3 = currentPage.range) == null ? void 0 : _currentPage$range3.firstRowIndex,
        (_currentPage$range4 = currentPage.range) == null ? void 0 : _currentPage$range4.lastRowIndex,
        rowsMeta.positions
    ]);
    const computeRenderContext = _react.useCallback(()=>{
        if (disableVirtualization) return {
            firstRowIndex: 0,
            lastRowIndex: currentPage.rows.length,
            firstColumnIndex: 0,
            lastColumnIndex: visibleColumns.length
        };
        const { top, left } = scrollPosition.current; // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        const firstRowIndex = Math.min(getNearestIndexToRender(top), rowsMeta.positions.length - 1);
        const lastRowIndex = rootProps.autoHeight ? firstRowIndex + currentPage.rows.length : getNearestIndexToRender(top + containerDimensions.height);
        let hasRowWithAutoHeight = false;
        let firstColumnIndex = 0;
        let lastColumnIndex = columnPositions.length;
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: firstRowIndex,
            lastIndex: lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = currentPage.rows[i];
            hasRowWithAutoHeight = apiRef.current.unstable_rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight) {
            firstColumnIndex = binarySearch(left, columnPositions);
            lastColumnIndex = binarySearch(left + containerDimensions.width, columnPositions);
        }
        return {
            firstRowIndex,
            lastRowIndex,
            firstColumnIndex,
            lastColumnIndex
        };
    }, [
        disableVirtualization,
        getNearestIndexToRender,
        rowsMeta.positions.length,
        rootProps.autoHeight,
        rootProps.rowBuffer,
        currentPage.rows,
        columnPositions,
        visibleColumns.length,
        apiRef,
        containerDimensions
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (disableVirtualization) renderZoneRef.current.style.transform = `translate3d(0px, 0px, 0px)`;
        else {
            // TODO a scroll reset should not be necessary
            rootRef.current.scrollLeft = 0;
            rootRef.current.scrollTop = 0;
        }
    }, [
        disableVirtualization
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        setContainerDimensions({
            width: rootRef.current.clientWidth,
            height: rootRef.current.clientHeight
        });
    }, [
        rowsMeta.currentPageTotalHeight
    ]);
    const handleResize = _react.useCallback((params)=>{
        setContainerDimensions({
            width: params.width,
            height: params.height
        });
    }, []);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "resize", handleResize);
    const updateRenderZonePosition = _react.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const [initialFirstColumnToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: renderZoneMinColumnIndex,
            maxLastIndex: renderZoneMaxColumnIndex,
            buffer: rootProps.columnBuffer
        });
        const firstColumnToRender = (0, _gridColumnsUtils.getFirstNonSpannedColumnToRender)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        });
        const top = (0, _gridRowsMetaSelector.gridRowsMetaSelector)(apiRef.current.state).positions[firstRowToRender];
        const left = (0, _gridColumnsSelector.gridColumnPositionsSelector)(apiRef)[firstColumnToRender]; // Call directly the selector because it might be outdated when this method is called
        renderZoneRef.current.style.transform = `translate3d(${left}px, ${top}px, 0px)`;
        if (typeof onRenderZonePositioning === "function") onRenderZonePositioning({
            top,
            left
        });
    }, [
        apiRef,
        currentPage.rows,
        onRenderZonePositioning,
        renderZoneMinColumnIndex,
        renderZoneMaxColumnIndex,
        rootProps.columnBuffer,
        rootProps.rowBuffer
    ]);
    const updateRenderContext = _react.useCallback((nextRenderContext)=>{
        if (prevRenderContext.current && areRenderContextsEqual(nextRenderContext, prevRenderContext.current)) {
            updateRenderZonePosition(nextRenderContext);
            return;
        }
        setRenderContext(nextRenderContext);
        updateRenderZonePosition(nextRenderContext);
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        apiRef.current.publishEvent("renderedRowsIntervalChange", {
            firstRowToRender,
            lastRowToRender
        });
        prevRenderContext.current = nextRenderContext;
    }, [
        apiRef,
        setRenderContext,
        prevRenderContext,
        currentPage.rows.length,
        rootProps.rowBuffer,
        updateRenderZonePosition
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (containerDimensions.width == null) return;
        const initialRenderContext = computeRenderContext();
        updateRenderContext(initialRenderContext);
        const { top, left } = scrollPosition.current;
        const params = {
            top,
            left,
            renderContext: initialRenderContext
        };
        apiRef.current.publishEvent("rowsScroll", params);
    }, [
        apiRef,
        computeRenderContext,
        containerDimensions.width,
        updateRenderContext
    ]);
    const handleScroll = (event)=>{
        const { scrollTop, scrollLeft } = event.currentTarget;
        scrollPosition.current.top = scrollTop;
        scrollPosition.current.left = scrollLeft; // On iOS and macOS, negative offsets are possible when swiping past the start
        if (scrollLeft < 0 || scrollTop < 0 || !prevRenderContext.current) return;
         // When virtualization is disabled, the context never changes during scroll
        const nextRenderContext = disableVirtualization ? prevRenderContext.current : computeRenderContext();
        const topRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstRowIndex - prevRenderContext.current.firstRowIndex);
        const bottomRowsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastRowIndex - prevRenderContext.current.lastRowIndex);
        const topColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.firstColumnIndex - prevRenderContext.current.firstColumnIndex);
        const bottomColumnsScrolledSincePreviousRender = Math.abs(nextRenderContext.lastColumnIndex - prevRenderContext.current.lastColumnIndex);
        const shouldSetState = topRowsScrolledSincePreviousRender >= rootProps.rowThreshold || bottomRowsScrolledSincePreviousRender >= rootProps.rowThreshold || topColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || bottomColumnsScrolledSincePreviousRender >= rootProps.columnThreshold || prevTotalWidth.current !== columnsTotalWidth; // TODO v6: rename event to a wider name, it's not only fired for row scrolling
        apiRef.current.publishEvent("rowsScroll", {
            top: scrollTop,
            left: scrollLeft,
            renderContext: shouldSetState ? nextRenderContext : prevRenderContext.current
        }, event);
        if (shouldSetState) {
            // Prevents batching render context changes
            _reactDom.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            prevTotalWidth.current = columnsTotalWidth;
        }
    };
    const handleWheel = (event)=>{
        apiRef.current.publishEvent("virtualScrollerWheel", {}, event);
    };
    const handleTouchMove = (event)=>{
        apiRef.current.publishEvent("virtualScrollerTouchMove", {}, event);
    };
    const getRows = (params = {
        renderContext
    })=>{
        const { renderContext: nextRenderContext, minFirstColumn = renderZoneMinColumnIndex, maxLastColumn = renderZoneMaxColumnIndex, availableSpace = containerDimensions.width, rowIndexOffset = 0, position = "center" } = params;
        if (!nextRenderContext || availableSpace == null) return null;
        const rowBuffer = !disableVirtualization ? rootProps.rowBuffer : 0;
        const columnBuffer = !disableVirtualization ? rootProps.columnBuffer : 0;
        const [firstRowToRender, lastRowToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rowBuffer
        });
        const renderedRows = [];
        if (params.rows) params.rows.forEach((row)=>{
            renderedRows.push(row);
            apiRef.current.unstable_calculateColSpan({
                rowId: row.id,
                minFirstColumn,
                maxLastColumn,
                columns: visibleColumns
            });
        });
        else {
            if (!currentPage.range) return null;
            for(let i = firstRowToRender; i < lastRowToRender; i += 1){
                const row = currentPage.rows[i];
                renderedRows.push(row);
                apiRef.current.unstable_calculateColSpan({
                    rowId: row.id,
                    minFirstColumn,
                    maxLastColumn,
                    columns: visibleColumns
                });
            }
        }
        const [initialFirstColumnToRender, lastColumnToRender] = getRenderableIndexes({
            firstIndex: nextRenderContext.firstColumnIndex,
            lastIndex: nextRenderContext.lastColumnIndex,
            minFirstIndex: minFirstColumn,
            maxLastIndex: maxLastColumn,
            buffer: columnBuffer
        });
        const firstColumnToRender = (0, _gridColumnsUtils.getFirstNonSpannedColumnToRender)({
            firstColumnToRender: initialFirstColumnToRender,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        });
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        const rows = [];
        for(let i = 0; i < renderedRows.length; i += 1){
            var _currentPage$range5, _rootProps$components;
            const { id, model } = renderedRows[i];
            const lastVisibleRowIndex = firstRowToRender + i === currentPage.rows.length - 1;
            const baseRowHeight = !apiRef.current.unstable_rowHasAutoHeight(id) ? apiRef.current.unstable_getRowHeight(id) : "auto";
            let isSelected;
            if (selectedRowsLookup[id] == null) isSelected = false;
            else isSelected = apiRef.current.isRowSelectable(id);
            rows.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(rootProps.components.Row, (0, _extendsDefault.default)({
                row: model,
                rowId: id,
                rowHeight: baseRowHeight,
                cellFocus: cellFocus // TODO move to inside the row
                ,
                cellTabIndex: cellTabIndex // TODO move to inside the row
                ,
                editRowsState: editRowsState // TODO move to inside the row
                ,
                renderedColumns: renderedColumns,
                visibleColumns: visibleColumns,
                firstColumnToRender: firstColumnToRender,
                lastColumnToRender: lastColumnToRender,
                selected: isSelected,
                index: rowIndexOffset + ((currentPage == null ? void 0 : (_currentPage$range5 = currentPage.range) == null ? void 0 : _currentPage$range5.firstRowIndex) || 0) + firstRowToRender + i,
                containerWidth: availableSpace,
                isLastVisible: lastVisibleRowIndex,
                position: position
            }, typeof getRowProps === "function" ? getRowProps(id, model) : {}, (_rootProps$components = rootProps.componentsProps) == null ? void 0 : _rootProps$components.row), id));
        }
        return rows;
    };
    const needsHorizontalScrollbar = containerDimensions.width && columnsTotalWidth > containerDimensions.width;
    const contentSize = _react.useMemo(()=>{
        // In cases where the columns exceed the available width,
        // the horizontal scrollbar should be shown even when there're no rows.
        // Keeping 1px as minimum height ensures that the scrollbar will visible if necessary.
        const height = Math.max(rowsMeta.currentPageTotalHeight, 1);
        let shouldExtendContent = false;
        if (rootRef != null && rootRef.current && height <= (rootRef == null ? void 0 : rootRef.current.clientHeight)) shouldExtendContent = true;
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : "auto",
            height,
            minHeight: shouldExtendContent ? "100%" : "auto"
        };
        if (rootProps.autoHeight && currentPage.rows.length === 0) size.height = 2 * rowHeight; // Give room to show the overlay when there's no row.
        return size;
    }, [
        rootRef,
        columnsTotalWidth,
        rowsMeta.currentPageTotalHeight,
        currentPage.rows.length,
        needsHorizontalScrollbar,
        rootProps.autoHeight,
        rowHeight
    ]);
    _react.useEffect(()=>{
        apiRef.current.publishEvent("virtualScrollerContentSizeChange");
    }, [
        apiRef,
        contentSize
    ]);
    if (rootProps.autoHeight && currentPage.rows.length === 0) contentSize.height = 2 * rowHeight; // Give room to show the overlay when there no rows.
    const rootStyle = {};
    if (!needsHorizontalScrollbar) rootStyle.overflowX = "hidden";
    if (rootProps.autoHeight) rootStyle.overflowY = "hidden";
    const getRenderContext = _react.useCallback(()=>{
        return prevRenderContext.current;
    }, []);
    apiRef.current.unstable_getRenderContext = getRenderContext;
    return {
        renderContext,
        updateRenderZonePosition,
        getRows,
        getRootProps: (_ref = {})=>{
            let { style = {} } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
            return (0, _extendsDefault.default)({
                ref: handleRef,
                onScroll: handleScroll,
                onWheel: handleWheel,
                onTouchMove: handleTouchMove,
                style: (0, _extendsDefault.default)({}, style, rootStyle)
            }, other);
        },
        getContentProps: ({ style = {} } = {})=>({
                style: (0, _extendsDefault.default)({}, style, contentSize)
            }),
        getRenderZoneProps: ()=>({
                ref: renderZoneRef
            })
    };
};

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","react-dom":"d8jlt","@mui/material/utils":"ziQFX","../../utils/useGridApiContext":"cn3M8","../../utils/useGridRootProps":"cdy2y","../../utils/useGridSelector":"96gNX","../columns/gridColumnsSelector":"aeHtc","../density/densitySelector":"chMex","../focus/gridFocusStateSelector":"7pS2P","../editRows/gridEditRowsSelector":"978KN","../../utils/useGridVisibleRows":"giBK8","../../utils/useGridApiEventHandler":"iBXeM","../../../utils/utils":"lwlsg","../selection/gridSelectionSelector":"XuHYC","../rows/gridRowsMetaSelector":"bjCPy","../columns/gridColumnsUtils":"dl6aq","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lK1RY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataGridColumnHeaders", ()=>DataGridColumnHeaders);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useGridColumnHeaders = require("../hooks/features/columnHeaders/useGridColumnHeaders");
var _gridScrollArea = require("./GridScrollArea");
var _gridColumnHeaders = require("./columnHeaders/GridColumnHeaders");
var _gridColumnHeadersInner = require("./columnHeaders/GridColumnHeadersInner");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "innerRef",
    "className"
];
const DataGridColumnHeaders = /*#__PURE__*/ _react.forwardRef(function GridColumnsHeader(props, ref) {
    const { innerRef } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { isDragging, getRootProps, getInnerProps, getColumnHeaders, getColumnGroupHeaders } = (0, _useGridColumnHeaders.useGridColumnHeaders)({
        innerRef
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridColumnHeaders.GridColumnHeaders), (0, _extendsDefault.default)({
        ref: ref
    }, getRootProps(other), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridScrollArea.GridScrollArea), {
                scrollDirection: "left"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridColumnHeadersInner.GridColumnHeadersInner), (0, _extendsDefault.default)({
                isDragging: isDragging
            }, getInnerProps(), {
                children: [
                    getColumnGroupHeaders(),
                    getColumnHeaders()
                ]
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridScrollArea.GridScrollArea), {
                scrollDirection: "right"
            })
        ]
    }));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","../hooks/features/columnHeaders/useGridColumnHeaders":"kp8Vv","./GridScrollArea":"2cqFv","./columnHeaders/GridColumnHeaders":"iBHX8","./columnHeaders/GridColumnHeadersInner":"fGOuh","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kp8Vv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridColumnHeaders", ()=>useGridColumnHeaders);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDom = require("react-dom");
var _utils = require("@mui/material/utils");
var _styles = require("@mui/material/styles");
var _reselect = require("reselect");
var _useGridApiContext = require("../../utils/useGridApiContext");
var _useGridSelector = require("../../utils/useGridSelector");
var _gridColumnsSelector = require("../columns/gridColumnsSelector");
var _gridFocusStateSelector = require("../focus/gridFocusStateSelector");
var _densitySelector = require("../density/densitySelector");
var _gridFilterSelector = require("../filter/gridFilterSelector");
var _gridSortingSelector = require("../sorting/gridSortingSelector");
var _columnMenuSelector = require("../columnMenu/columnMenuSelector");
var _useGridRootProps = require("../../utils/useGridRootProps");
var _useGridApiEventHandler = require("../../utils/useGridApiEventHandler");
var _gridColumnHeaderItem = require("../../../components/columnHeaders/GridColumnHeaderItem");
var _gridColumnsUtils = require("../columns/gridColumnsUtils");
var _useGridVisibleRows = require("../../utils/useGridVisibleRows");
var _useGridVirtualScroller = require("../virtualization/useGridVirtualScroller");
var _gridColumnGroupHeader = require("../../../components/columnHeaders/GridColumnGroupHeader");
var _utils1 = require("../../../utils/utils");
var _jsxRuntime = require("react/jsx-runtime");
// TODO: add the possibility to switch this value if needed for customization
const MERGE_EMPTY_CELLS = true;
const GridColumnHeaderRow = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaderRow",
    overridesResolver: (props, styles)=>styles.columnHeaderRow
})(()=>({
        display: "flex"
    }));
function isUIEvent(event) {
    return !!event.target;
}
const useGridColumnHeaders = (props)=>{
    const { innerRef: innerRefProp, minColumnIndex = 0 } = props;
    const [dragCol, setDragCol] = _react.useState("");
    const [resizeCol, setResizeCol] = _react.useState("");
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const visibleColumns = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridVisibleColumnDefinitionsSelector));
    const columnPositions = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnsSelector.gridColumnPositionsSelector));
    const tabIndexState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridTabIndexColumnHeaderSelector));
    const cellTabIndexState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridTabIndexCellSelector));
    const columnHeaderFocus = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFocusStateSelector.gridFocusColumnHeaderSelector));
    const headerHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityHeaderHeightSelector));
    const headerGroupingMaxDepth = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityHeaderGroupingMaxDepthSelector));
    const totalHeaderHeight = (0, _useGridSelector.useGridSelector)(apiRef, (0, _densitySelector.gridDensityTotalHeaderHeightSelector));
    const filterColumnLookup = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridFilterSelector.gridFilterActiveItemsLookupSelector));
    const sortColumnLookup = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridSortingSelector.gridSortColumnLookupSelector));
    const columnMenuState = (0, _useGridSelector.useGridSelector)(apiRef, (0, _columnMenuSelector.gridColumnMenuSelector));
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const innerRef = _react.useRef(null);
    const handleInnerRef = (0, _utils.useForkRef)(innerRefProp, innerRef);
    const [renderContext, setRenderContext] = _react.useState(null);
    const prevRenderContext = _react.useRef(renderContext);
    const prevScrollLeft = _react.useRef(0);
    const currentPage = (0, _useGridVisibleRows.useGridVisibleRows)(apiRef, rootProps);
    _react.useEffect(()=>{
        apiRef.current.columnHeadersContainerElementRef.current.scrollLeft = 0;
    }, [
        apiRef
    ]); // memoize `getFirstColumnIndexToRender`, since it's called on scroll
    const getFirstColumnIndexToRenderRef = _react.useRef((0, _reselect.defaultMemoize)((0, _gridColumnsUtils.getFirstColumnIndexToRender), {
        equalityCheck: (a, b)=>[
                "firstColumnIndex",
                "minColumnIndex",
                "columnBuffer"
            ].every((key)=>a[key] === b[key])
    }));
    const updateInnerPosition = _react.useCallback((nextRenderContext)=>{
        const [firstRowToRender, lastRowToRender] = (0, _useGridVirtualScroller.getRenderableIndexes)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex,
            columnBuffer: rootProps.columnBuffer,
            firstRowToRender,
            lastRowToRender,
            apiRef,
            visibleRows: currentPage.rows
        });
        const offset = firstColumnToRender > 0 ? prevScrollLeft.current - columnPositions[firstColumnToRender] : prevScrollLeft.current;
        innerRef.current.style.transform = `translate3d(${-offset}px, 0px, 0px)`;
    }, [
        columnPositions,
        minColumnIndex,
        rootProps.columnBuffer,
        apiRef,
        currentPage.rows,
        rootProps.rowBuffer
    ]);
    _react.useLayoutEffect(()=>{
        if (renderContext) updateInnerPosition(renderContext);
    }, [
        renderContext,
        updateInnerPosition
    ]);
    const handleScroll = _react.useCallback(({ left, renderContext: nextRenderContext = null }, event)=>{
        var _prevRenderContext$cu, _prevRenderContext$cu2;
        if (!innerRef.current) return;
         // Ignore vertical scroll.
        // Excepts the first event which sets the previous render context.
        if (prevScrollLeft.current === left && ((_prevRenderContext$cu = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu.firstColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.firstColumnIndex) && ((_prevRenderContext$cu2 = prevRenderContext.current) == null ? void 0 : _prevRenderContext$cu2.lastColumnIndex) === (nextRenderContext == null ? void 0 : nextRenderContext.lastColumnIndex)) return;
        prevScrollLeft.current = left; // We can only update the position when we guarantee that the render context has been
        // rendered. This is achieved using ReactDOM.flushSync or when the context doesn't change.
        let canUpdateInnerPosition = false;
        if (nextRenderContext !== prevRenderContext.current || !prevRenderContext.current) {
            // ReactDOM.flushSync cannot be called on `scroll` events fired inside effects
            if (isUIEvent(event)) {
                // To prevent flickering, the inner position can only be updated after the new context has
                // been rendered. ReactDOM.flushSync ensures that the state changes will happen before
                // updating the position.
                _reactDom.flushSync(()=>{
                    setRenderContext(nextRenderContext);
                });
                canUpdateInnerPosition = true;
            } else setRenderContext(nextRenderContext);
            prevRenderContext.current = nextRenderContext;
        } else canUpdateInnerPosition = true;
         // Pass directly the render context to avoid waiting for the next render
        if (nextRenderContext && canUpdateInnerPosition) updateInnerPosition(nextRenderContext);
    }, [
        updateInnerPosition
    ]);
    const handleColumnResizeStart = _react.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = _react.useCallback(()=>setResizeCol(""), []);
    const handleColumnReorderStart = _react.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = _react.useCallback(()=>setDragCol(""), []);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnResizeStart", handleColumnResizeStart);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnResizeStop", handleColumnResizeStop);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragStart", handleColumnReorderStart);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "columnHeaderDragEnd", handleColumnReorderStop);
    (0, _useGridApiEventHandler.useGridApiEventHandler)(apiRef, "rowsScroll", handleScroll); // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: nextRenderContext = renderContext, minFirstColumn = minColumnIndex, maxLastColumn = visibleColumns.length } = params || {};
        if (!nextRenderContext) return null;
        const [firstRowToRender, lastRowToRender] = (0, _useGridVirtualScroller.getRenderableIndexes)({
            firstIndex: nextRenderContext.firstRowIndex,
            lastIndex: nextRenderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: currentPage.rows.length,
            buffer: rootProps.rowBuffer
        });
        const firstColumnToRender = getFirstColumnIndexToRenderRef.current({
            firstColumnIndex: nextRenderContext.firstColumnIndex,
            minColumnIndex: minFirstColumn,
            columnBuffer: rootProps.columnBuffer,
            apiRef,
            firstRowToRender,
            lastRowToRender,
            visibleRows: currentPage.rows
        });
        const lastColumnToRender = Math.min(nextRenderContext.lastColumnIndex + rootProps.columnBuffer, maxLastColumn);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns,
            firstColumnToRender,
            lastColumnToRender,
            minFirstColumn,
            maxLastColumn
        };
    };
    const getColumnHeaders = (params, other = {})=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null) return null;
        const { renderedColumns, firstColumnToRender } = columnsToRender;
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const column = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const hasTabbableElement = !(tabIndexState === null && cellTabIndexState === null);
            const tabIndex = tabIndexState !== null && tabIndexState.field === column.field || isFirstColumn && !hasTabbableElement ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === column.field;
            const open = columnMenuState.open && columnMenuState.field === column.field;
            columns.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnHeaderItem.GridColumnHeaderItem), (0, _extendsDefault.default)({}, sortColumnLookup[column.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[column.field] && filterColumnLookup[column.field].length,
                headerHeight: headerHeight,
                isDragging: column.field === dragCol,
                column: column,
                colIndex: columnIndex,
                isResizing: resizeCol === column.field,
                isLastColumn: columnIndex === visibleColumns.length - 1,
                extendRowFullWidth: !rootProps.disableExtendRowFullWidth,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            }, other), column.field));
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnHeaderRow, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            children: columns
        });
    };
    const getParents = (path = [], depth)=>path.slice(0, depth + 1);
    const getColumnGroupHeaders = (params)=>{
        if (headerGroupingMaxDepth === 0) return null;
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender == null || columnsToRender.renderedColumns.length === 0) return null;
        const { renderedColumns, firstColumnToRender, lastColumnToRender, maxLastColumn } = columnsToRender;
        const columns = [];
        const headerToRender = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1){
            var _visibleColumns$first, _visibleColumns$first2, _visibleColumns$first3;
            // Initialize the header line with a grouping item containing all the columns on the left of the virtualization which are in the same group as the first group to render
            const initialHeader = [];
            let leftOverflow = 0;
            let columnIndex = firstColumnToRender - 1;
            const firstColumnToRenderGroup = (_visibleColumns$first = visibleColumns[firstColumnToRender]) == null ? void 0 : (_visibleColumns$first2 = _visibleColumns$first.groupPath) == null ? void 0 : _visibleColumns$first2[depth]; // The array of parent is used to manage empty grouping cell
            // When two empty grouping cell are next to each other, we merge them if the belong to the same group.
            const firstColumnToRenderGroupParents = getParents((_visibleColumns$first3 = visibleColumns[firstColumnToRender]) == null ? void 0 : _visibleColumns$first3.groupPath, depth);
            while(firstColumnToRenderGroup !== null && columnIndex >= minColumnIndex && (_visibleColumns$colum = visibleColumns[columnIndex]) != null && _visibleColumns$colum.groupPath && (0, _utils1.isDeepEqual)(getParents((_visibleColumns$colum2 = visibleColumns[columnIndex]) == null ? void 0 : _visibleColumns$colum2.groupPath, depth), firstColumnToRenderGroupParents)){
                var _visibleColumns$colum, _visibleColumns$colum2, _column$computedWidth;
                const column = visibleColumns[columnIndex];
                leftOverflow += (_column$computedWidth = column.computedWidth) != null ? _column$computedWidth : 0;
                if (initialHeader.length === 0) {
                    var _column$computedWidth2;
                    initialHeader.push({
                        width: (_column$computedWidth2 = column.computedWidth) != null ? _column$computedWidth2 : 0,
                        fields: [
                            column.field
                        ],
                        groupId: firstColumnToRenderGroup,
                        groupParents: firstColumnToRenderGroupParents,
                        colIndex: columnIndex
                    });
                } else {
                    var _column$computedWidth3;
                    initialHeader[0].width += (_column$computedWidth3 = column.computedWidth) != null ? _column$computedWidth3 : 0;
                    initialHeader[0].fields.push(column.field);
                    initialHeader[0].colIndex = columnIndex;
                }
                columnIndex -= 1;
            }
            const depthInfo = renderedColumns.reduce((aggregated, column, i)=>{
                var _column$computedWidth7;
                const lastItem = aggregated[aggregated.length - 1];
                if (column.groupPath && column.groupPath.length > depth) {
                    var _column$computedWidth5;
                    if (lastItem && lastItem.groupId === column.groupPath[depth]) {
                        var _column$computedWidth4;
                        // Merge with the previous columns
                        return [
                            ...aggregated.slice(0, aggregated.length - 1),
                            (0, _extendsDefault.default)({}, lastItem, {
                                width: lastItem.width + ((_column$computedWidth4 = column.computedWidth) != null ? _column$computedWidth4 : 0),
                                fields: [
                                    ...lastItem.fields,
                                    column.field
                                ]
                            })
                        ];
                    } // Create a new grouping
                    return [
                        ...aggregated,
                        {
                            groupId: column.groupPath[depth],
                            groupParents: getParents(column.groupPath, depth),
                            width: (_column$computedWidth5 = column.computedWidth) != null ? _column$computedWidth5 : 0,
                            fields: [
                                column.field
                            ],
                            colIndex: firstColumnToRender + i
                        }
                    ];
                }
                if (MERGE_EMPTY_CELLS && lastItem && lastItem.groupId === null && (0, _utils1.isDeepEqual)(getParents(column.groupPath, depth), lastItem.groupParents)) {
                    var _column$computedWidth6;
                    // We merge with previous column
                    return [
                        ...aggregated.slice(0, aggregated.length - 1),
                        (0, _extendsDefault.default)({}, lastItem, {
                            width: lastItem.width + ((_column$computedWidth6 = column.computedWidth) != null ? _column$computedWidth6 : 0),
                            fields: [
                                ...lastItem.fields,
                                column.field
                            ]
                        })
                    ];
                } // We create new empty cell
                return [
                    ...aggregated,
                    {
                        groupId: null,
                        groupParents: getParents(column.groupPath, depth),
                        width: (_column$computedWidth7 = column.computedWidth) != null ? _column$computedWidth7 : 0,
                        fields: [
                            column.field
                        ],
                        colIndex: firstColumnToRender + i
                    }
                ];
            }, initialHeader);
            columnIndex = lastColumnToRender;
            const lastColumnToRenderGroup = depthInfo[depthInfo.length - 1].groupId;
            while(lastColumnToRenderGroup !== null && columnIndex < maxLastColumn && (_visibleColumns$colum3 = visibleColumns[columnIndex]) != null && _visibleColumns$colum3.groupPath && ((_visibleColumns$colum4 = visibleColumns[columnIndex]) == null ? void 0 : (_visibleColumns$colum5 = _visibleColumns$colum4.groupPath) == null ? void 0 : _visibleColumns$colum5[depth]) === lastColumnToRenderGroup){
                var _visibleColumns$colum3, _visibleColumns$colum4, _visibleColumns$colum5, _column$computedWidth8;
                const column = visibleColumns[columnIndex];
                depthInfo[depthInfo.length - 1].width += (_column$computedWidth8 = column.computedWidth) != null ? _column$computedWidth8 : 0;
                depthInfo[depthInfo.length - 1].fields.push(column.field);
                columnIndex += 1;
            }
            headerToRender.push({
                leftOverflow,
                elements: [
                    ...depthInfo
                ]
            });
        }
        headerToRender.forEach((depthInfo, depthIndex)=>{
            columns.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnHeaderRow, {
                style: {
                    height: `${headerHeight}px`,
                    transform: `translateX(-${depthInfo.leftOverflow}px)`
                },
                role: "row",
                "aria-rowindex": depthIndex + 1,
                ownerState: rootProps,
                children: depthInfo.elements.map(({ groupId, width, fields, colIndex }, groupIndex)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridColumnGroupHeader.GridColumnGroupHeader), {
                        groupId: groupId,
                        width: width,
                        fields: fields,
                        colIndex: colIndex,
                        depth: depthIndex,
                        isLastColumn: colIndex === visibleColumns.length - fields.length,
                        extendRowFullWidth: !rootProps.disableExtendRowFullWidth,
                        maxDepth: headerToRender.length,
                        height: headerHeight
                    }, groupIndex);
                })
            }, depthIndex));
        });
        return columns;
    };
    const rootStyle = {
        minHeight: totalHeaderHeight,
        maxHeight: totalHeaderHeight,
        lineHeight: `${headerHeight}px`
    };
    return {
        renderContext,
        getColumnHeaders,
        getColumnGroupHeaders,
        isDragging: !!dragCol,
        getRootProps: (other = {})=>(0, _extendsDefault.default)({
                style: rootStyle
            }, other),
        getInnerProps: ()=>({
                ref: handleInnerRef,
                role: "rowgroup"
            })
    };
};

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","react-dom":"d8jlt","@mui/material/utils":"ziQFX","@mui/material/styles":"gNR9m","reselect":"iYtdg","../../utils/useGridApiContext":"cn3M8","../../utils/useGridSelector":"96gNX","../columns/gridColumnsSelector":"aeHtc","../focus/gridFocusStateSelector":"7pS2P","../density/densitySelector":"chMex","../filter/gridFilterSelector":"lndlA","../sorting/gridSortingSelector":"1g9b1","../columnMenu/columnMenuSelector":"62HSa","../../utils/useGridRootProps":"cdy2y","../../utils/useGridApiEventHandler":"iBXeM","../../../components/columnHeaders/GridColumnHeaderItem":"iEl8s","../columns/gridColumnsUtils":"dl6aq","../../utils/useGridVisibleRows":"giBK8","../virtualization/useGridVirtualScroller":"cPTmb","../../../components/columnHeaders/GridColumnGroupHeader":"qY4dE","../../../utils/utils":"lwlsg","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"qY4dE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnGroupHeader", ()=>GridColumnGroupHeader);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _material = require("@mui/material");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _gridColumnGroupsSelector = require("../../hooks/features/columnGrouping/gridColumnGroupsSelector");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _useGridSelector = require("../../hooks/utils/useGridSelector");
var _gridGenericColumnHeaderItem = require("./GridGenericColumnHeaderItem");
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, headerAlign, isDragging, showRightBorder, showColumnBorder, groupId } = ownerState;
    const slots = {
        root: [
            "columnHeader",
            headerAlign === "left" && "columnHeader--alignLeft",
            headerAlign === "center" && "columnHeader--alignCenter",
            headerAlign === "right" && "columnHeader--alignRight",
            isDragging && "columnHeader--moving",
            showRightBorder && "withBorder",
            showColumnBorder && "columnHeader--showColumnBorder",
            groupId === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup"
        ],
        draggableContainer: [
            "columnHeaderDraggableContainer"
        ],
        titleContainer: [
            "columnHeaderTitleContainer"
        ],
        titleContainerContent: [
            "columnHeaderTitleContainerContent"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
function GridColumnGroupHeader(props) {
    var _apiRef$current$getRo, _columnGroupsLookup$g;
    const { groupId, width, depth, maxDepth, fields, height, colIndex, isLastColumn, extendRowFullWidth } = props;
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const columnGroupsLookup = (0, _useGridSelector.useGridSelector)(apiRef, (0, _gridColumnGroupsSelector.gridColumnGroupsLookupSelector));
    const { hasScrollX, hasScrollY } = (_apiRef$current$getRo = apiRef.current.getRootDimensions()) != null ? _apiRef$current$getRo : {
        hasScrollX: false,
        hasScrollY: false
    };
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName = groupId != null ? groupId : "", description = "", headerAlign } = group;
    let headerComponent;
    const render = groupId && ((_columnGroupsLookup$g = columnGroupsLookup[groupId]) == null ? void 0 : _columnGroupsLookup$g.renderHeaderGroup);
    const renderParams = {
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    };
    if (groupId && render) headerComponent = render(renderParams);
    const removeLastBorderRight = isLastColumn && hasScrollX && !hasScrollY;
    const showRightBorder = !isLastColumn ? rootProps.showColumnRightBorder : !removeLastBorderRight && !extendRowFullWidth;
    const showColumnBorder = rootProps.showColumnRightBorder;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        classes: rootProps.classes,
        showRightBorder,
        showColumnBorder,
        headerAlign,
        depth,
        isDragging: false
    });
    const label = headerName != null ? headerName : groupId;
    const id = (0, _utils.unstable_useId)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = useUtilityClasses(ownerState);
    const headerClassName = typeof group.headerClassName === "function" ? group.headerClassName(renderParams) : group.headerClassName;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridGenericColumnHeaderItem.GridGenericColumnHeaderItem), {
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: -1,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length // The fields are wrapped between |-...-| to avoid confusion between fields "id" and "id2" when using selector data-fields~=
        ,
        "data-fields": `|-${fields.join("-|-")}-|`,
        disableHeaderSeparator: true
    });
}

},{"@babel/runtime/helpers/esm/extends":"d4f7v","react":"gVheC","@mui/utils":"dv12b","@mui/material":"iknXc","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/features/columnGrouping/gridColumnGroupsSelector":"lvnc9","../../hooks/utils/useGridApiContext":"cn3M8","../../hooks/utils/useGridSelector":"96gNX","./GridGenericColumnHeaderItem":"kl2Cy","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iBHX8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeaders", ()=>GridColumnHeaders);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "columnHeaders"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridColumnHeadersRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "ColumnHeaders",
    overridesResolver: (props, styles)=>styles.columnHeaders
})(({ theme })=>{
    const borderColor = theme.palette.mode === "light" ? (0, _styles.lighten)((0, _styles.alpha)(theme.palette.divider, 1), 0.88) : (0, _styles.darken)((0, _styles.alpha)(theme.palette.divider, 1), 0.68);
    return {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        borderBottom: `1px solid ${borderColor}`,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
    };
});
const GridColumnHeaders = /*#__PURE__*/ _react.forwardRef(function GridColumnHeaders(props, ref) {
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const classes = useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnHeadersRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: rootProps
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fGOuh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridColumnHeadersInner", ()=>GridColumnHeadersInner);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _gridClasses = require("../../constants/gridClasses");
var _useGridRootProps = require("../../hooks/utils/useGridRootProps");
var _useGridApiContext = require("../../hooks/utils/useGridApiContext");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "isDragging",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { isDragging, hasScrollX, classes } = ownerState;
    const slots = {
        root: [
            "columnHeadersInner",
            isDragging && "columnHeaderDropZone",
            hasScrollX && "columnHeadersInner--scrollable"
        ]
    };
    return (0, _material.unstable_composeClasses)(slots, (0, _gridClasses.getDataGridUtilityClass), classes);
};
const GridColumnHeadersInnerRoot = (0, _styles.styled)("div", {
    name: "MuiDataGrid",
    slot: "columnHeadersInner",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, _gridClasses.gridClasses).columnHeaderDropZone}`]: styles.columnHeaderDropZone
            },
            styles.columnHeadersInner
        ]
})(()=>({
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        [`&.${(0, _gridClasses.gridClasses).columnHeaderDropZone} .${(0, _gridClasses.gridClasses).columnHeaderDraggableContainer}`]: {
            cursor: "move"
        },
        [`&.${(0, _gridClasses.gridClasses)["columnHeadersInner--scrollable"]} .${(0, _gridClasses.gridClasses).columnHeader}:last-child`]: {
            borderRight: "none"
        }
    }));
const GridColumnHeadersInner = /*#__PURE__*/ _react.forwardRef(function GridColumnHeadersInner(props, ref) {
    var _apiRef$current$getRo, _apiRef$current$getRo2;
    const { isDragging, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const apiRef = (0, _useGridApiContext.useGridApiContext)();
    const rootProps = (0, _useGridRootProps.useGridRootProps)();
    const ownerState = (0, _extendsDefault.default)({}, rootProps, {
        isDragging,
        hasScrollX: (_apiRef$current$getRo = (_apiRef$current$getRo2 = apiRef.current.getRootDimensions()) == null ? void 0 : _apiRef$current$getRo2.hasScrollX) != null ? _apiRef$current$getRo : false
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridColumnHeadersInnerRoot, (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsxDefault.default)(className, classes.root),
        ownerState: ownerState
    }, other));
});

},{"@babel/runtime/helpers/esm/extends":"d4f7v","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"8FYSI","react":"gVheC","clsx":"aaPMT","@mui/material":"iknXc","@mui/material/styles":"gNR9m","../../constants/gridClasses":"5U0ME","../../hooks/utils/useGridRootProps":"cdy2y","../../hooks/utils/useGridApiContext":"cn3M8","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2xQfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _features = require("./features");
parcelHelpers.exportAll(_features, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _core = require("./core");
parcelHelpers.exportAll(_core, exports);

},{"./features":"2nCd8","./utils":"43GNT","./core":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2nCd8":[function(require,module,exports) {
// Only export the variable and types that should be publicly exposed and re-exported from `@mui/x-data-grid-pro`
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _columnMenu = require("./columnMenu");
parcelHelpers.exportAll(_columnMenu, exports);
var _columns = require("./columns");
parcelHelpers.exportAll(_columns, exports);
var _columnGrouping = require("./columnGrouping");
parcelHelpers.exportAll(_columnGrouping, exports);
var _density = require("./density");
parcelHelpers.exportAll(_density, exports);
var _editRows = require("./editRows");
parcelHelpers.exportAll(_editRows, exports);
var _filter = require("./filter");
parcelHelpers.exportAll(_filter, exports);
var _focus = require("./focus");
parcelHelpers.exportAll(_focus, exports);
var _pagination = require("./pagination");
parcelHelpers.exportAll(_pagination, exports);
var _preferencesPanel = require("./preferencesPanel");
parcelHelpers.exportAll(_preferencesPanel, exports);
var _rows = require("./rows");
parcelHelpers.exportAll(_rows, exports);
var _selection = require("./selection");
parcelHelpers.exportAll(_selection, exports);
var _sorting = require("./sorting");
parcelHelpers.exportAll(_sorting, exports);
var _dimensions = require("./dimensions");
parcelHelpers.exportAll(_dimensions, exports);
var _statePersistence = require("./statePersistence");
parcelHelpers.exportAll(_statePersistence, exports);

},{"./columnMenu":false,"./columns":false,"./columnGrouping":false,"./density":false,"./editRows":false,"./filter":false,"./focus":false,"./pagination":"bGzSP","./preferencesPanel":false,"./rows":false,"./selection":false,"./sorting":false,"./dimensions":false,"./statePersistence":false,"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1X9gG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _emptyState = require("./EmptyState");
parcelHelpers.exportAll(_emptyState, exports);
var _errorState = require("./ErrorState");
parcelHelpers.exportAll(_errorState, exports);
var _loadingState = require("./LoadingState");
parcelHelpers.exportAll(_loadingState, exports);
var _toolbar = require("./Toolbar");
parcelHelpers.exportAll(_toolbar, exports);
var _pagination = require("./Pagination");
parcelHelpers.exportAll(_pagination, exports);
var _footer = require("./Footer");
parcelHelpers.exportAll(_footer, exports);

},{"./EmptyState":"kGo8J","./ErrorState":"evv1l","./LoadingState":"4Y6mm","./Toolbar":"6cxNe","./Pagination":"eUvsz","./Footer":"lQwbK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kGo8J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyState", ()=>EmptyState);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _buttons = require("../../Buttons");
const EmptyState = ({ title, description, action, testID })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            position: "relative",
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 1
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "flex",
                width: 1,
                maxWidth: 500,
                flexDirection: "column",
                padding: 3,
                alignItems: "center",
                justifyContent: "center",
                border: 1,
                borderColor: "grey.100",
                backgroundColor: "grey.100",
                borderRadius: 1,
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                    component: "h3",
                    variant: "h5",
                    children: title
                }),
                description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                    children: description
                }),
                action && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.PrimaryButton), {
                    onClick: action.onClick,
                    startIcon: action.icon,
                    "data-testid": `${testID}-no-data-button`,
                    children: action.label
                })
            ]
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../../Buttons":"jEO6Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"evv1l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorState", ()=>ErrorState);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _buttons = require("../../Buttons");
const ErrorState = ({ onClick, error })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 1
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "flex",
                width: 1,
                maxWidth: 500,
                flexDirection: "column",
                padding: 3,
                alignItems: "center",
                justifyContent: "center",
                border: 1,
                borderColor: "grey.100",
                backgroundColor: "grey.100",
                borderRadius: 1,
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.WarningAmber), {
                    fontSize: "large",
                    color: "error"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                    children: error ? error.message : "Oops, something went wrong loading the data."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.PrimaryButton), {
                    onClick: onClick,
                    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Cached), {}),
                    "data-testid": "grid-error-button",
                    children: "Refresh Data"
                })
            ]
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","../../Buttons":"jEO6Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Y6mm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingState", ()=>LoadingState);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const LoadingState = ({ data = [], rows = 5 })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: data.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.LinearProgress), {
            sx: {
                postition: "relative",
                zIndex: 1
            }
        }) : [
            ...Array(rows)
        ].map((_, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Skeleton), {
                animation: "wave",
                height: 52,
                sx: {
                    mb: 6.5,
                    bgcolor: "grey.50"
                },
                variant: "rectangular"
            }, idx))
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6cxNe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toolbar", ()=>Toolbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDataGrid = require("@mui/x-data-grid");
var _hooks = require("../../../hooks");
const Toolbar = ({ hideColumnSelector, hideExport, header, csvOptions })=>{
    const { isMd } = (0, _hooks.useResponsive)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _xDataGrid.GridToolbarContainer), {
        sx: {
            display: "flex",
            justifyContent: hideColumnSelector && !header ? "right" : "space-between",
            mb: hideColumnSelector && hideExport ? 0 : 2
        },
        children: [
            !hideColumnSelector && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-testid": "grid-column-selector-button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridToolbarColumnsButton), {})
            }),
            !!header && !isMd && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                variant: "h6",
                children: header
            }),
            !hideExport && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-testid": "grid-export-button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridToolbarExport), {
                    variant: "outlined",
                    csvOptions: {
                        allColumns: true,
                        ...csvOptions
                    },
                    printOptions: {
                        disableToolbarButton: true
                    }
                })
            }),
            !!header && isMd && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                variant: "h6",
                children: header
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/x-data-grid":"1d1Aj","../../../hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eUvsz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _xDataGrid = require("@mui/x-data-grid");
const Pagination = ()=>{
    const apiRef = (0, _xDataGrid.useGridApiContext)();
    const page = (0, _xDataGrid.useGridSelector)(apiRef, (0, _xDataGrid.gridPageSelector));
    const pageCount = (0, _xDataGrid.useGridSelector)(apiRef, (0, _xDataGrid.gridPageCountSelector));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Pagination), {
        sx: {
            mt: 1
        },
        count: pageCount,
        page: page + 1,
        onChange: (_, value)=>apiRef.current.setPage(value - 1)
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/x-data-grid":"1d1Aj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lQwbK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const Footer = ({ content })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        sx: {
            pr: 11,
            display: content ? "flex" : "none",
            justifyContent: "flex-end"
        },
        children: content
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8O41m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDataGrid", ()=>StyledDataGrid);
var _material = require("@mui/material");
var _xDataGrid = require("@mui/x-data-grid");
const StyledDataGrid = (0, _material.styled)((0, _xDataGrid.DataGrid))(({ theme })=>({
        border: 0,
        color: "rgb(0 0 0 / 85%)",
        webkitFontSmoothing: "auto",
        letterSpacing: "normal",
        "& .MuiDataGrid-iconSeparator": {
            display: "none"
        },
        "& .MuiDataGrid-columnsContainer": {
            backgroundColor: theme.palette.grey[50]
        },
        "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
            borderBottom: "1px solid #f0f0f0"
        },
        "& .MuiDataGrid-columnHeader:not(:last-child), .MuiDataGrid-cell": {
            borderRight: "1px solid #f0f0f0"
        },
        "& .MuiDataGrid-cell": {
            color: "rgb(0 0 0 / 85%)"
        },
        "& .MuiDataGrid-cell.error": {
            backgroundColor: (0, _material.alpha)(theme.palette.error.light, 0.1)
        },
        "& .MuiDataGrid-cell.warning": {
            backgroundColor: (0, _material.alpha)(theme.palette.warning.light, 0.1)
        },
        "& .MuiDataGrid-cell.success": {
            backgroundColor: (0, _material.alpha)(theme.palette.success.light, 0.5)
        },
        "& .MuiDataGrid-cell--editable": {
            cursor: "pointer",
            "& .MuiInputBase-root": {
                height: "100%"
            }
        },
        ".MuiDataGrid-cell:first-of-type": {
            borderLeft: "1px solid #f0f0f0"
        },
        "& .MuiPaginationItem-root": {
            borderRadius: 0
        },
        [`& .${(0, _xDataGrid.gridClasses).row}`]: {
            "&.warning": {
                backgroundColor: (0, _material.alpha)(theme.palette.warning.light, 0.1)
            },
            "&.danger": {
                backgroundColor: (0, _material.alpha)(theme.palette.error.light, 0.1)
            },
            "&.even": {
                backgroundColor: theme.palette.grey[50],
                "&.warning": {
                    backgroundColor: (0, _material.alpha)(theme.palette.warning.light, 0.2)
                },
                "&.danger": {
                    backgroundColor: (0, _material.alpha)(theme.palette.error.light, 0.2)
                }
            }
        },
        [`& .${(0, _xDataGrid.gridClasses).row}.odd, & .${(0, _xDataGrid.gridClasses).row}.even`]: {
            "&:hover, &.Mui-hovered": {
                backgroundColor: (0, _material.alpha)(theme.palette.primary.main, 0.1),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        }
    }));

},{"@mui/material":"iknXc","@mui/x-data-grid":"1d1Aj","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9bzsl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColumns", ()=>useColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xDataGrid = require("@mui/x-data-grid");
var _tooltip = require("../Tooltip");
var _cells = require("./Cells");
const useColumns = ({ columns, rowActions })=>(0, _react.useMemo)(()=>[
            ...columns ? columns.map((column)=>column.type !== "singleSelect" ? {
                    renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.TooltipCell), {
                            children: value
                        }),
                    ...column
                } : column) : [],
            ...rowActions ? [
                {
                    field: "actions",
                    type: "actions",
                    headerName: "",
                    cellClassName: "actions",
                    width: rowActions.length > 1 ? 50 * rowActions.length : 75,
                    getActions: (params)=>rowActions.map(({ label, onClick, icon, disabled }, idx)=>{
                            const Action = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                "data-testid": `grid-${label.toLowerCase()}-button`,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridActionsCellItem), {
                                    disabled: disabled,
                                    label: label,
                                    onClick: ()=>{
                                        onClick(params);
                                    },
                                    icon: icon
                                })
                            });
                            return disabled ? Action : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.Tooltip), {
                                title: label,
                                placement: "top",
                                children: Action
                            }, idx);
                        })
                }
            ] : []
        ], [
        columns,
        rowActions
    ]);

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/x-data-grid":"1d1Aj","../Tooltip":"ikXCW","./Cells":"cuW2I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8z13E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryPagination", ()=>useQueryPagination);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _ = require("..");
var _lib = require("../../lib");
// Integrate into a gql limit variable
// NOTE: limits are applied before filters, so it may appear less was
// fetched than intended
const PAGE_SIZE = 100;
const useQueryPagination = (query)=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const pageToken = (0, _react.useRef)({});
    const [page, setPage] = (0, _react.useState)(0);
    const input = (0, _react.useCallback)((page)=>({
            vars: {
                nextToken: pageToken.current[page - 1]
            },
            key: [
                page
            ]
        }), []);
    const rowsQuery = (0, _react.useCallback)((page)=>{
        const { queryKey: key, queryFn, ...rest } = query(input(page));
        return {
            ...rest,
            queryKey: key ? [
                ...key,
                page
            ] : [
                page
            ],
            queryFn: async ()=>{
                const { items, nextToken, ...rest } = await queryFn();
                return {
                    ...rest,
                    items: await (0, _lib.filterNull)(items !== null && items !== void 0 ? items : []),
                    nextToken: nextToken !== null && nextToken !== void 0 ? nextToken : undefined
                };
            }
        };
    }, [
        input,
        query
    ]);
    const { data, isError, isLoading, refetch, isFetching, isPreviousData } = (0, _reactQuery.useQuery)({
        ...rowsQuery(page),
        keepPreviousData: true,
        staleTime: 5000
    });
    // Prefetch next page
    (0, _react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.nextToken) {
            pageToken.current[page] = data.nextToken;
            queryClient.prefetchQuery(rowsQuery(page + 1));
        }
    }, [
        data === null || data === void 0 ? void 0 : data.nextToken,
        input,
        page,
        query,
        queryClient,
        rowsQuery
    ]);
    // Some API clients return undefined while loading
    // Following lines are here to prevent `rowCountState` from being undefined during the loading
    const [rowCountState, setRowCountState] = (0, _react.useState)((data === null || data === void 0 ? void 0 : data.items.length) || 0);
    // With Dynamo total rows are unknown w/o expensive query
    // Adds 1 to row count if nextToken is defined to allow pagination
    (0, _react.useEffect)(()=>{
        setRowCountState((prev)=>{
            var _data_items_length;
            if (!pageToken.current[page]) return page * PAGE_SIZE + ((_data_items_length = data === null || data === void 0 ? void 0 : data.items.length) !== null && _data_items_length !== void 0 ? _data_items_length : 0);
            else return prev > (page + 1) * PAGE_SIZE ? prev : (page + 1) * PAGE_SIZE + 1;
        });
    }, [
        data === null || data === void 0 ? void 0 : data.items.length,
        page,
        setRowCountState
    ]);
    const handlePageChange = (newPage)=>{
        if (newPage === 0 || pageToken.current[newPage - 1]) setPage(newPage);
    };
    return {
        data,
        isError,
        refetch,
        isPending: isLoading || isPreviousData || isFetching,
        pagination: {
            page,
            paginationMode: (0, _.PaginationMode).SERVER,
            rowCount: rowCountState,
            onPageChange: handlePageChange
        }
    };
};

},{"react":"gVheC","@tanstack/react-query":"j0XMv","..":"0272J","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ieR16":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _contractsModal = require("./ContractsModal");
parcelHelpers.exportAll(_contractsModal, exports);
var _updateModal = require("./UpdateModal");
parcelHelpers.exportAll(_updateModal, exports);
var _modalContext = require("./ModalContext");
parcelHelpers.exportAll(_modalContext, exports);
var _modalProvider = require("./ModalProvider");
parcelHelpers.exportAll(_modalProvider, exports);
var _modalSkeleton = require("./ModalSkeleton");
parcelHelpers.exportAll(_modalSkeleton, exports);
var _useModal = require("./useModal");
parcelHelpers.exportAll(_useModal, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./ContractsModal":"3ErM9","./UpdateModal":"gIboc","./ModalContext":"5z5G9","./ModalProvider":"929BG","./ModalSkeleton":"dodjl","./useModal":"kZSKN","./types":"331gV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ErM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContractsModal", ()=>ContractsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _optionField = require("../OptionField");
var _modalSkeleton = require("./ModalSkeleton");
const ContractsModal = ({ title, onSubmit, testID, params: { id, contracts, selected, options }, ...rest })=>{
    const [saving, setSaving] = (0, _react.useState)(false);
    const { control, handleSubmit } = (0, _reactHookForm.useForm)({
        defaultValues: {
            selected: selected
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalSkeleton.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit(({ selected })=>{
                setSaving(true);
                return onSubmit({
                    assigning: title,
                    id,
                    selected,
                    contracts
                });
            }),
            testID: "save"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)"
                },
                gap: 2
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionField.SelectField), {
                control: control,
                name: "selected",
                label: `Assign ${title}`,
                multiple: true,
                options: options,
                optional: true,
                variant: "outlined"
            })
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","../OptionField":"8Mgzz","./ModalSkeleton":"dodjl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dodjl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalSkeleton", ()=>ModalSkeleton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _buttons = require("../Buttons");
const ModalSkeleton = ({ children, title, isOpen, onClose, primaryAction, isForm, testID })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        open: isOpen,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        "data-testid": `${testID}-modal`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                children: title
            }),
            isForm ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: primaryAction.onSubmit,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Divider), {
                        variant: "middle"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                        sx: {
                            padding: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.SecondaryButton), {
                                onClick: onClose,
                                "data-testid": `${testID}-modal-cancel-button`,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                sx: {
                                    m: 1,
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.PrimaryButton), {
                                        type: "submit",
                                        disabled: primaryAction.pending,
                                        color: primaryAction.isDanger ? "error" : "primary",
                                        "data-testid": `${testID}-modal-${primaryAction.testID}-button`,
                                        children: primaryAction.label
                                    }),
                                    primaryAction.pending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CircularProgress), {
                                        size: 24,
                                        sx: {
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px"
                                        },
                                        color: primaryAction.isDanger ? "error" : "primary"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Divider), {
                        variant: "middle"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                        sx: {
                            padding: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.SecondaryButton), {
                                onClick: onClose,
                                "data-testid": `${testID}-modal-cancel-button`,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                sx: {
                                    m: 1,
                                    position: "relative"
                                },
                                children: [
                                    primaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.PrimaryButton), {
                                        onClick: primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.onClick,
                                        type: "button",
                                        disabled: primaryAction.pending,
                                        color: primaryAction.isDanger ? "error" : "primary",
                                        "data-testid": `${testID}-modal-${primaryAction.testID}-button`,
                                        children: primaryAction.label
                                    }),
                                    primaryAction && primaryAction.pending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CircularProgress), {
                                        size: 24,
                                        sx: {
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px"
                                        },
                                        color: primaryAction.isDanger ? "error" : "primary"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../Buttons":"jEO6Z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gIboc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateModal", ()=>UpdateModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalSkeleton = require("./ModalSkeleton");
const UpdateModal = ({ title, label, description, onUpdate, params, ...rest })=>{
    const [updating, setUpdating] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalSkeleton.ModalSkeleton), {
        title: title,
        primaryAction: {
            label: label,
            pending: updating,
            onClick: ()=>{
                setUpdating(true);
                return onUpdate(params);
            },
            isDanger: true,
            testID: "update"
        },
        testID: "update",
        ...rest,
        children: description
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","./ModalSkeleton":"dodjl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5z5G9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalContext", ()=>ModalContext);
var _react = require("react");
const ModalContext = (0, _react.createContext)({
    showModal: ()=>({
            key: "",
            component: null
        }),
    hideModal: ()=>({
            key: ""
        })
});

},{"react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"929BG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalProvider", ()=>ModalProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalContext = require("./ModalContext");
const ModalProvider = ({ children })=>{
    const [modalsConfig, setModalsConfig] = (0, _react.useState)({});
    const showModal = (0, _react.useCallback)(({ key, component, data })=>{
        setModalsConfig((prevConfig)=>({
                ...prevConfig,
                [key]: {
                    isOpen: true,
                    component,
                    data
                }
            }));
    }, [
        setModalsConfig
    ]);
    const hideModal = (0, _react.useCallback)(({ key, onClose })=>{
        setModalsConfig((prevConfig)=>({
                ...prevConfig,
                [key]: {
                    ...prevConfig[key],
                    isOpen: false
                }
            }));
        if (onClose) onClose();
    }, [
        setModalsConfig
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            showModal,
            hideModal
        }), [
        hideModal,
        showModal
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modalContext.ModalContext).Provider, {
        value: contextValue,
        children: [
            children,
            Object.keys(modalsConfig).map((key)=>{
                const { component: Component, isOpen, data } = modalsConfig[key];
                return isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    isOpen: isOpen,
                    onClose: ()=>hideModal({
                            key
                        }),
                    ...data
                }, key);
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","./ModalContext":"5z5G9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kZSKN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useModal", ()=>useModal);
var _react = require("react");
var _modalContext = require("./ModalContext");
const useModal = ({ component, data, onClose })=>{
    const key = (0, _react.useMemo)(generateModalKey, []);
    const { showModal: showModalContext, hideModal: hideModalContext } = (0, _react.useContext)((0, _modalContext.ModalContext));
    const showModal = (0, _react.useCallback)((params)=>showModalContext({
            key,
            component,
            data: params instanceof Event ? data : {
                ...data,
                params: params || {}
            }
        }), [
        showModalContext,
        key,
        component,
        data
    ]);
    const hideModal = (0, _react.useCallback)(()=>hideModalContext({
            key,
            onClose
        }), [
        hideModalContext,
        key,
        onClose
    ]);
    return {
        showModal,
        hideModal
    };
};
const generateModalKey = (()=>{
    let count = 0;
    return ()=>`${++count}`;
})();

},{"react":"gVheC","./ModalContext":"5z5G9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"331gV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3OVDt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _navigation = require("./Navigation");
parcelHelpers.exportAll(_navigation, exports);

},{"./Navigation":"7Amul","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7Amul":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navigation", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _userAvatar = require("../UserAvatar");
var _navList = require("./NavList");
var _collapsableNav = require("./CollapsableNav");
const Navigation = ({ isOpen, onClose, drawerwidth: drawerWidth = 240 })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        component: "div",
        "data-testid": "nav",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Drawer), {
                variant: "temporary",
                open: isOpen,
                onClose: onClose,
                sx: {
                    display: {
                        xs: "block",
                        md: "none"
                    },
                    "& .MuiDrawer-paper": {
                        boxSizing: "border-box",
                        width: drawerWidth
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            p: 3,
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                p: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userAvatar.UserAvatar), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navList.NavList), {
                            onClose: onClose,
                            testID: "mob",
                            isOpen: isOpen
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsableNav.CollapsableNav), {
                onClose: onClose,
                drawerWidth: drawerWidth
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../UserAvatar":"anYwW","./NavList":"4ax7b","./CollapsableNav":"lXB4T","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4ax7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavList", ()=>NavList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _uiReact = require("@aws-amplify/ui-react");
var _hooks = require("../../hooks");
var _links = require("./links");
const Nav = (0, _material.styled)((0, _material.List))({
    "& .MuiListItemButton-root": {
        paddingLeft: 24,
        paddingRight: 24
    },
    "& .MuiListItemIcon-root": {
        minWidth: 0,
        marginRight: 16
    },
    "& .MuiSvgIcon-root": {
        fontSize: 20
    }
});
const NavList = ({ onClose, testID, isOpen })=>{
    var _useUser;
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const { signOut } = (0, _uiReact.useAuthenticator)((context)=>[
            context.user
        ]);
    const isAdmin = (_useUser = (0, _hooks.useUser)()) === null || _useUser === void 0 ? void 0 : _useUser.isAdmin;
    const { Admin, ...rest } = (0, _links.LinksComponent)();
    const links = isAdmin ? {
        ...rest,
        Admin
    } : rest;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Nav, {
        component: "nav",
        disablePadding: true,
        "data-testid": `${testID}-nav`,
        children: [
            Object.keys(links).map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListSubheader), {
                            component: "div",
                            sx: {
                                pl: 3
                            },
                            children: item
                        }),
                        links[item].map((link)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ListItemButton), {
                                component: (0, _reactRouterDom.NavLink),
                                to: link.to,
                                selected: pathname === `/${link.to}`,
                                onClick: ()=>onClose(),
                                "data-testid": `${testID}-nav-link-${link.name.toLowerCase()}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemIcon), {
                                        sx: {
                                            fontSize: 20
                                        },
                                        children: link.icon
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                                        primary: link.name
                                    })
                                ]
                            }, link.name))
                    ]
                }, item)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    display: {
                        xs: "block",
                        md: "none"
                    },
                    mt: 3
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ListItemButton), {
                    component: "a",
                    onClick: ()=>{
                        onClose();
                        signOut();
                    },
                    "data-testid": "mob-nav-link-logout",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemIcon), {
                            sx: {
                                fontSize: 20
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Logout), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                            primary: "Logout"
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/material":"iknXc","@mui/icons-material":"4DI4K","@aws-amplify/ui-react":"40VMD","../../hooks":"9Pg07","./links":"eEkbM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eEkbM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinksComponent", ()=>LinksComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _featureFlags = require("../../featureFlags");
var _hooks = require("../../hooks");
const LinksComponent = ()=>{
    const user = (0, _hooks.useUser)();
    const isBetaTester = user === null || user === void 0 ? void 0 : user.isBeta;
    const isTimeOffBetaEnabled = (0, _featureFlags.isTimeOffEnabled) && isBetaTester;
    const links = [
        {
            heading: "Manage",
            name: "Dashboard",
            to: "",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Dashboard), {})
        },
        {
            heading: "Manage",
            name: "Timesheets",
            to: "timesheets",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AccessAlarm), {})
        },
        isTimeOffBetaEnabled ? {
            heading: "Manage",
            name: "Time off",
            to: "time-off",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AlarmOff), {})
        } : undefined,
        isTimeOffBetaEnabled ? {
            heading: "Manage",
            name: "Time in lieu",
            to: "time-in-lieu",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Loop), {})
        } : undefined,
        {
            heading: "Admin",
            name: "Dashboard",
            to: "admin",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Dashboard), {})
        },
        {
            heading: "Admin",
            name: "Approvals",
            to: "admin/approvals",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Rule), {})
        },
        {
            heading: "Admin",
            name: "Clients",
            to: "admin/clients",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Business), {})
        },
        {
            heading: "Admin",
            name: "Employees",
            to: "admin/employees",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Group), {})
        },
        {
            heading: "Admin",
            name: "Reports",
            to: "admin/reports",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.StackedLineChart), {})
        },
        isTimeOffBetaEnabled ? {
            heading: "Admin",
            name: "Absence Tracker",
            to: "admin/absence",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.EventBusy), {})
        } : undefined,
        isTimeOffBetaEnabled ? {
            heading: "Admin",
            name: "Time in Lieu",
            to: "admin/time-in-lieu",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Loop), {})
        } : undefined,
        isTimeOffBetaEnabled ? {
            heading: "Admin",
            name: "Bank Holidays",
            to: "admin/bank-holidays",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Celebration), {})
        } : undefined,
        isTimeOffBetaEnabled ? {
            heading: "Admin",
            name: "Calendar",
            to: "admin/calendar",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CalendarMonth), {})
        } : undefined
    ];
    return links.filter((l)=>l !== undefined).reduce((groups, item)=>Object.assign(groups, {
            [item.heading]: (groups[item.heading] || []).concat(item)
        }), Object.create(null));
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","../../featureFlags":"far4e","../../hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"far4e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTimeOffEnabled", ()=>isTimeOffEnabled);
const isTimeOffEnabled = true;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lXB4T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollapsableNav", ()=>CollapsableNav);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _drawer = require("@mui/material/Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _appBar = require("@mui/material/AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _toolbar = require("@mui/material/Toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _cssBaseline = require("@mui/material/CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _chevronLeft = require("@mui/icons-material/ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _chevronRight = require("@mui/icons-material/ChevronRight");
var _chevronRightDefault = parcelHelpers.interopDefault(_chevronRight);
var _colors = require("@mui/material/colors");
var _desktop = require("../AppBarScreens/Desktop");
var _tdsLogo = require("../TdsLogo");
var _navList = require("./NavList");
const openedMixin = (theme, drawerWidth)=>({
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        overflowX: "hidden"
    });
const closedMixin = (theme)=>({
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: `calc(${theme.spacing(7.5)})`,
        [theme.breakpoints.up("sm")]: {
            width: `calc(${theme.spacing(7.5)})`
        }
    });
const DrawerHeader = (0, _styles.styled)("div")(({ theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar
    }));
const AppBar = (0, _styles.styled)((0, _appBarDefault.default), {
    shouldForwardProp: (prop)=>prop !== "open"
})(({ theme, open, drawerwidth })=>({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create([
            "width",
            "margin"
        ], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        backgroundColor: "white",
        ...open && {
            marginLeft: drawerwidth,
            width: `calc(100% - ${drawerwidth}px)`,
            transition: theme.transitions.create([
                "width",
                "margin"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        }
    }));
const Drawer = (0, _styles.styled)((0, _drawerDefault.default), {
    shouldForwardProp: (prop)=>prop !== "open"
})(({ theme, open, drawerwidth })=>({
        width: drawerwidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...open && {
            ...openedMixin(theme, drawerwidth),
            "& .MuiDrawer-paper": openedMixin(theme, drawerwidth)
        },
        ...!open && {
            ...closedMixin(theme),
            "& .MuiDrawer-paper": closedMixin(theme)
        }
    }));
const CollapsableNav = ({ onClose, drawerWidth: drawerWidth })=>{
    const [isOpen, setIsOpen] = _react.useState(true);
    const handleDrawerOpen = ()=>{
        setIsOpen(true);
    };
    const handleDrawerClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: {
                xs: "none",
                md: "flex"
            },
            "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth
            }
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cssBaselineDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppBar, {
                position: "fixed",
                open: isOpen,
                color: "transparent",
                elevation: 0,
                sx: {
                    ml: {
                        md: `${drawerWidth}px`
                    },
                    bgcolor: (0, _colors.grey)[100]
                },
                "data-testid": "app-bar",
                drawerwidth: drawerWidth,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toolbarDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            color: "default",
                            "aria-label": "open drawer",
                            onClick: handleDrawerOpen,
                            edge: "start",
                            sx: {
                                marginRight: 5,
                                ...isOpen && {
                                    display: "none"
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _desktop.Desktop), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Drawer, {
                variant: "permanent",
                open: isOpen,
                drawerwidth: drawerWidth,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DrawerHeader, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "10%",
                            paddingLeft: "10%"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tdsLogo.TdsLogo), {
                                testID: "dt"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                onClick: handleDrawerClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronLeftDefault.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navList.NavList), {
                        onClose: onClose,
                        isOpen: isOpen,
                        testID: "dt"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material/styles":"gNR9m","@mui/material/Box":"52i65","@mui/material/Drawer":"kfkBA","@mui/material/AppBar":"hCJE4","@mui/material/Toolbar":"8LwX6","@mui/material/CssBaseline":"eCY2Z","@mui/material/IconButton":"6bnps","@mui/icons-material/ChevronLeft":"x1KNu","@mui/icons-material/ChevronRight":"esgYU","@mui/material/colors":"gGfHv","../AppBarScreens/Desktop":"6dcwD","../TdsLogo":"cE4zn","./NavList":"4ax7b","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"x1KNu":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ba1e4328c093dd36");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("83c5ca8882966333"));
var _jsxRuntime = require("dd05b9c53ca3eb31");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");

},{"ba1e4328c093dd36":"6zI5d","83c5ca8882966333":"fp1As","dd05b9c53ca3eb31":"1elNt"}],"esgYU":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("d992eaa86b8ea0fd");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("9d46befc7dd20c8f"));
var _jsxRuntime = require("fb9fd761c7262b57");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");

},{"d992eaa86b8ea0fd":"6zI5d","9d46befc7dd20c8f":"fp1As","fb9fd761c7262b57":"1elNt"}],"aZYdx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pageLayout = require("./PageLayout");
parcelHelpers.exportAll(_pageLayout, exports);

},{"./PageLayout":"bGQYi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bGQYi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageLayout", ()=>PageLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _colors = require("@mui/material/colors");
var _navigation = require("../Navigation");
var _desktop = require("../AppBarScreens/Desktop");
var _mobile = require("../AppBarScreens/Mobile");
const PageLayout = ()=>{
    const drawerWidth = 240;
    const [mobileOpen, setMobileOpen] = (0, _react.useState)(false);
    const handleDrawerToggle = ()=>setMobileOpen(!mobileOpen);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: "flex"
        },
        "data-testid": "page-layout",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CssBaseline), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AppBar), {
                position: "fixed",
                color: "transparent",
                elevation: 0,
                sx: {
                    width: {
                        md: `calc(100% - ${drawerWidth}px)`
                    },
                    ml: {
                        md: `${drawerWidth}px`
                    },
                    bgcolor: (0, _colors.grey)[100]
                },
                "data-testid": "app-bar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Toolbar), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _desktop.Desktop), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobile.Mobile), {
                            onClick: handleDrawerToggle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigation.Navigation), {
                isOpen: mobileOpen,
                onClose: handleDrawerToggle,
                drawerwidth: drawerWidth
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                component: "main",
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: {
                        md: `calc(100% - ${drawerWidth}px)`
                    },
                    height: "100vh",
                    p: {
                        xs: 2,
                        sm: 3
                    },
                    pt: {
                        xs: 9,
                        sm: 11
                    }
                },
                "data-testid": "main",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/material":"iknXc","@mui/material/colors":"gGfHv","../Navigation":"3OVDt","../AppBarScreens/Desktop":"6dcwD","../AppBarScreens/Mobile":"dYpdn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ls1su":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _pageTitle = require("./PageTitle");
parcelHelpers.exportAll(_pageTitle, exports);

},{"./PageTitle":"iGxFS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iGxFS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageTitle", ()=>PageTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _buttons = require("../Buttons");
var _hooks = require("../../hooks");
const PageTitle = ({ title, icon, altIcon, action, altAction, testID })=>{
    const { isMd } = (0, _hooks.useResponsive)();
    const tID = `${testID}-page-title`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: isMd ? 3 : 5
        },
        "data-testid": tID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    icon && /*#__PURE__*/ (0, _react.cloneElement)(icon, {
                        sx: {
                            mr: 1
                        },
                        fontSize: isMd ? "small" : "large"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                        component: "h2",
                        variant: isMd ? "h6" : "h4",
                        "data-testid": `${tID}-heading`,
                        children: title
                    }),
                    altIcon && /*#__PURE__*/ (0, _react.cloneElement)(altIcon, {
                        sx: {
                            ml: 1
                        },
                        fontSize: isMd ? "small" : "large"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                children: [
                    altAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.SecondaryButton), {
                        sx: {
                            mr: 1
                        },
                        disabled: altAction.disabled,
                        onClick: altAction.onClick,
                        size: isMd ? "small" : "medium",
                        startIcon: altAction.icon,
                        "data-testid": `${tID}-alt-button`,
                        children: altAction.label
                    }),
                    action && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.PrimaryButton), {
                        disabled: action.disabled,
                        onClick: action.onClick,
                        size: isMd ? "small" : "medium",
                        startIcon: action.icon,
                        "data-testid": `${tID}-button`,
                        children: action.label
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../Buttons":"jEO6Z","../../hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Pq7w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _textField = require("./TextField");
parcelHelpers.exportAll(_textField, exports);

},{"./TextField":"2vn7R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2vn7R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", ()=>TextField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
const TextField = ({ control, name, optional = false, rules, type, inputProps, helperText, ...rest })=>{
    const validation = {
        required: {
            value: !optional,
            message: `${rest.label} is required.`
        },
        ...type === "email" && {
            pattern: {
                value: /^\S+@\S+\.\S+$/i,
                message: "Must be 'email@domain.site'"
            }
        },
        ...type === "number" && (inputProps === null || inputProps === void 0 ? void 0 : inputProps.min) && {
            min: {
                value: inputProps.min,
                message: `Must be greater than or equal to ${inputProps.min}`
            }
        },
        ...type === "number" && (inputProps === null || inputProps === void 0 ? void 0 : inputProps.max) && {
            max: {
                value: inputProps.max,
                message: `Must be less than or equal to ${inputProps.max}`
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
        control: control,
        name: name,
        rules: {
            ...validation,
            ...rules
        },
        render: ({ field, fieldState: { error } })=>/*#__PURE__*/ {
            var _error_message, _ref;
            return (0, _jsxRuntime.jsx)(CustomTextField, {
                ...field,
                ...rest,
                type: type,
                required: !optional,
                variant: "outlined",
                InputLabelProps: {
                    shrink: true
                },
                margin: "dense",
                size: "small",
                error: !!error,
                helperText: (_ref = (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : helperText) !== null && _ref !== void 0 ? _ref : null,
                inputProps: inputProps
            });
        }
    });
};
const CustomTextField = (0, _material.styled)((0, _material.TextField))(({ theme })=>({
        "& .MuiInputBase-root": {
            backgroundColor: theme.palette.common.white
        }
    }));

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jH9KH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _approvalIcon = require("./ApprovalIcon");
parcelHelpers.exportAll(_approvalIcon, exports);
var _timesheetIcon = require("./TimesheetIcon");
parcelHelpers.exportAll(_timesheetIcon, exports);

},{"./ApprovalIcon":"4KNzt","./TimesheetIcon":"bhjas","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KNzt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApprovalIcon", ()=>ApprovalIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _statusIcon = require("./StatusIcon");
const mapToStatus = {
    approved: {
        label: "Approved",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckCircleOutline), {
            color: "success"
        })
    },
    rejected: {
        label: "Changes Required",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.ErrorOutline), {
            color: "error"
        })
    },
    pending: {
        label: "Pending Approval",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.PauseCircleOutline), {
            color: "disabled"
        })
    },
    expired: {
        label: "Expired",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.RunningWithErrors), {
            color: "disabled"
        })
    }
};
const ApprovalIcon = ({ status, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
        ...rest,
        status: getStatus(status),
        "data-testid": "status-icon"
    });
const getStatus = (val)=>mapToStatus[typeof val === "string" ? val : val === null ? "pending" : val ? "approved" : "rejected"];

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","./StatusIcon":"5b7dp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5b7dp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusIcon", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const StatusIcon = ({ status: { label, icon }, tooltip = true, ...rest })=>{
    const ele = /*#__PURE__*/ (0, _react.cloneElement)(icon, rest);
    return tooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Tooltip), {
        title: label,
        placement: "top",
        children: ele
    }) : ele;
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bhjas":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimesheetIcon", ()=>TimesheetIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _statusIcon = require("./StatusIcon");
const mapToStatus = {
    saved: {
        label: "Saved",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CloudDoneOutlined), {
            color: "info"
        })
    },
    saving: {
        label: "Saving",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CloudUploadOutlined), {
            color: "info"
        })
    },
    error: {
        label: "Changes not saved",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CloudOffOutlined), {
            color: "error"
        })
    }
};
const TimesheetIcon = ({ status, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
        ...rest,
        status: getStatus(status)
    });
const getStatus = (val)=>mapToStatus[typeof val === "string" ? val : val === null ? "saving" : val ? "saved" : "error"];

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","./StatusIcon":"5b7dp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gesLW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tiles = require("./Tiles");
parcelHelpers.exportAll(_tiles, exports);

},{"./Tiles":"8OlO7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8OlO7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tiles", ()=>Tiles);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
const Tiles = ({ items })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    p: 2,
                    display: "flex",
                    bgcolor: "grey.100",
                    borderRadius: 1
                },
                "data-testid": "tile-item",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                    variant: "body1",
                    children: item
                })
            }, item))
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h2Hl0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkbox = require("./Checkbox");
parcelHelpers.exportAll(_checkbox, exports);

},{"./Checkbox":"iqnWI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iqnWI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
const Checkbox = ({ control, name, label, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
        control: control,
        name: name,
        render: ({ field })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                    ...field,
                    ...rest,
                    checked: field.value
                }),
                label: label
            })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fUo4r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Routing", ()=>Routing);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _uiReact = require("@aws-amplify/ui-react");
var _components = require("./components");
var _pages = require("./pages");
var _hooks = require("./hooks");
var _timeInLieuTracking = require("./pages/TimeInLieuTracking");
var _featureFlags = require("./featureFlags");
var _bankHolidays = require("./pages/BankHolidays");
var _timeInLieu = require("./pages/TimeInLieu");
const Routing = ()=>{
    var _useUser, _useUser1;
    const { authStatus } = (0, _uiReact.useAuthenticator)((context)=>[
            context.authStatus
        ]);
    const location = (0, _reactRouterDom.useLocation)();
    const isAdmin = (_useUser = (0, _hooks.useUser)()) === null || _useUser === void 0 ? void 0 : _useUser.isAdmin;
    const isBetaTester = (_useUser1 = (0, _hooks.useUser)()) === null || _useUser1 === void 0 ? void 0 : _useUser1.isBeta;
    const timeOffFallbackRoute = (next)=>(0, _featureFlags.isTimeOffEnabled) && isBetaTester ? next : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
            to: "/",
            replace: true
        });
    return (0, _reactRouterDom.useRoutes)([
        {
            path: "/",
            element: authStatus !== "authenticated" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: "/login",
                state: {
                    from: location
                },
                replace: true
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageLayout), {}),
            children: [
                {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Main), {})
                },
                {
                    path: "timesheets",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Timesheet), {})
                },
                {
                    path: "time-off",
                    element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.TimeOff), {}))
                },
                {
                    path: "time-in-lieu",
                    element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeInLieu.TimeInLieu), {}))
                },
                {
                    path: "admin",
                    element: isAdmin ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                        to: "/",
                        state: {
                            from: location,
                            error: "unauthorized"
                        },
                        replace: true
                    }),
                    children: [
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Admin), {})
                        },
                        {
                            path: "approvals",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Approvals), {})
                        },
                        {
                            path: "clients",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Clients), {})
                        },
                        {
                            path: "employees",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Employees), {})
                        },
                        {
                            path: "reports",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Reports), {})
                        },
                        {
                            path: "time-in-lieu",
                            element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeInLieuTracking.TimeInLieuTracker), {}))
                        },
                        {
                            path: "absence",
                            element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.AbsenceTracker), {}))
                        },
                        {
                            path: "bank-holidays",
                            element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bankHolidays.BankHolidays), {}))
                        },
                        {
                            path: "calendar",
                            element: timeOffFallbackRoute(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Calendar), {}))
                        }
                    ]
                }
            ]
        },
        {
            path: "login",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.Login), {})
        },
        {
            path: "*",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pages.NotFound), {})
        }
    ]);
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@aws-amplify/ui-react":"40VMD","./components":"0272J","./pages":"g3aSt","./hooks":"9Pg07","./pages/TimeInLieuTracking":"3uRvp","./featureFlags":"far4e","./pages/BankHolidays":"bNs0m","./pages/TimeInLieu":"eY9o1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g3aSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _admin = require("./Admin");
parcelHelpers.exportAll(_admin, exports);
var _approvals = require("./Approvals");
parcelHelpers.exportAll(_approvals, exports);
var _clients = require("./Clients");
parcelHelpers.exportAll(_clients, exports);
var _employees = require("./Employees");
parcelHelpers.exportAll(_employees, exports);
var _login = require("./Login");
parcelHelpers.exportAll(_login, exports);
var _main = require("./Main");
parcelHelpers.exportAll(_main, exports);
var _notFound = require("./NotFound");
parcelHelpers.exportAll(_notFound, exports);
var _reports = require("./Reports");
parcelHelpers.exportAll(_reports, exports);
var _timesheet = require("./Timesheet");
parcelHelpers.exportAll(_timesheet, exports);
var _timeOff = require("./TimeOff");
parcelHelpers.exportAll(_timeOff, exports);
var _absence = require("./Absence");
parcelHelpers.exportAll(_absence, exports);
var _calendar = require("./Calendar");
parcelHelpers.exportAll(_calendar, exports);

},{"./Admin":"aZ7m7","./Approvals":"akt5c","./Clients":"5EzgG","./Employees":"b5KZw","./Login":"68E3U","./Main":"inlSP","./NotFound":"3rtGP","./Reports":"IYT9l","./Timesheet":"10gRb","./TimeOff":"eRKqv","./Absence":"9cGG3","./Calendar":"4IppG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZ7m7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _admin = require("./Admin");
parcelHelpers.exportAll(_admin, exports);

},{"./Admin":"5ttzq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ttzq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Admin", ()=>Admin);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _components = require("../../components");
const Admin = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Dashboard), {}),
        title: "Admin",
        testID: "admin"
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"akt5c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _approvals = require("./Approvals");
parcelHelpers.exportAll(_approvals, exports);

},{"./Approvals":"1nWSJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1nWSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Approvals", ()=>Approvals);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _reactQuery = require("@tanstack/react-query");
var _components = require("../../components");
var _lib = require("../../lib");
var _hooks = require("../../hooks");
var _downloader = require("../Timesheet/Downloader");
var _columns = require("./columns");
var _utils = require("./utils");
const Approvals = ()=>{
    const { isMd } = (0, _hooks.useResponsive)();
    const { setTimelogApproval } = (0, _lib.useTimelogLib)();
    const [selectionModel, setSelectionModel] = (0, _react.useState)([]);
    const [employeeID, setEmployeeID] = (0, _react.useState)("");
    const [companyID, setCompanyID] = (0, _react.useState)("");
    const [hideApproved, setHideApproved] = (0, _react.useState)(false);
    const [week, setWeek] = (0, _react.useState)({
        start: (0, _dateFns.startOfWeek)(new Date()),
        end: (0, _dateFns.endOfWeek)(new Date())
    });
    const { data: company } = (0, _reactQuery.useQuery)((0, _lib.getCompanyClientIDs)(companyID));
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)((0, _utils.approvalQuery)({
        week,
        employeeID,
        companyID,
        logFilter: company === null || company === void 0 ? void 0 : company.clientFilter
    }));
    const hideApprovals = {
        label: hideApproved ? "Show Approved" : "Hide Approved",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckCircleOutline), {}),
        onClick: ()=>setHideApproved(!hideApproved)
    };
    const downloadSheets = {
        disabled: selectionModel.length === 0 || !week,
        label: "Download Timesheets",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.FileDownloadOutlined), {}),
        onClick: ()=>{
            var _data_employees;
            return week && (0, _downloader.downloadAction)({
                employees: ((_data_employees = data === null || data === void 0 ? void 0 : data.employees) !== null && _data_employees !== void 0 ? _data_employees : []).filter((e)=>selectionModel.includes(e.id)),
                week,
                filterCompanyID: companyID
            });
        }
    };
    var _data_items, _data_items1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Rule), {}),
                title: "Approvals",
                action: downloadSheets,
                altAction: hideApprovals,
                testID: "approvals"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                dates: {
                    value: week,
                    onChange: setWeek,
                    type: "week"
                },
                company: {
                    value: companyID,
                    onChange: setCompanyID
                },
                employee: {
                    value: employeeID,
                    onChange: setEmployeeID
                },
                testID: "approvals"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                header: week ? (0, _lib.toIntervalString)(week) : undefined,
                columns: (0, _columns.columns)({
                    approveTimesheet: ({ logIds, approved })=>setTimelogApproval(logIds, approved, {
                            onSettled: refetch
                        })
                }),
                data: hideApproved ? ((_data_items = data === null || data === void 0 ? void 0 : data.items) !== null && _data_items !== void 0 ? _data_items : []).filter(({ approved })=>approved !== "approved") : (_data_items1 = data === null || data === void 0 ? void 0 : data.items) !== null && _data_items1 !== void 0 ? _data_items1 : [],
                emptyState: {
                    title: "Timesheet Approvals",
                    description: "Timesheets that are pending will appear here for you to approve.",
                    testID: "approvals"
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                pagination: pagination,
                testID: "approvals",
                checkboxSelection: true,
                selectionModel: selectionModel,
                onSelectionModelChange: setSelectionModel,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : (0, _columns.hiddenColumnsDesktop)
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","@tanstack/react-query":"j0XMv","../../components":"0272J","../../lib":"lWrCo","../../hooks":"9Pg07","../Timesheet/Downloader":"gvTfA","./columns":"hKqbk","./utils":"5lLAa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gvTfA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _downloadAction = require("./DownloadAction");
parcelHelpers.exportAll(_downloadAction, exports);

},{"./DownloadAction":"iuAIo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iuAIo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadAction", ()=>downloadAction);
var _clientZip = require("client-zip");
var _renderer = require("@react-pdf/renderer");
var _dateFns = require("date-fns");
var _lib = require("../../../lib");
var _utils = require("../utils");
var _addresses = require("../../../addresses");
var _timesheetPDF = require("./TimesheetPDF");
const downloadAction = async ({ employees, week, filterCompanyID })=>{
    const friDate = (0, _dateFns.nextFriday)(week.start).toLocaleDateString("sv");
    const getFileName = async ({ company: { name } }, { firstName, lastName })=>[
            `Timesheets-${friDate}`,
            name,
            `${firstName}${lastName}_TDS_Timesheet_${friDate}.pdf`
        ];
    const pdfs = (await Promise.all(employees.map(async (employee)=>{
        var _employee_clients;
        return Promise.all((await (0, _lib.filterNull)((_employee_clients = employee.clients) === null || _employee_clients === void 0 ? void 0 : _employee_clients.items, ({ client: { companyClientsId } })=>filterCompanyID === "" || filterCompanyID === companyClientsId)).map(async ({ client })=>{
            var _client_company_country;
            return buildPDF({
                employee,
                client,
                week,
                address: (0, _addresses.OFFICES)[(_client_company_country = client.company.country) !== null && _client_company_country !== void 0 ? _client_company_country : "GB"],
                fileName: await getFileName(client, employee)
            });
        }));
    }))).flat();
    // temporary link to download the Blob
    const link = document.createElement("a");
    link.href = URL.createObjectURL(await (0, _clientZip.downloadZip)(pdfs).blob());
    link.download = `Timesheets-${friDate}`;
    link.click();
    link.remove();
};
const buildPDF = async ({ fileName, ...input })=>({
        name: fileName.join("/"),
        input: await (0, _renderer.pdf)((0, _timesheetPDF.TimesheetPDF)({
            ...input,
            title: fileName[-1],
            timesheet: await (0, _utils.buildTimesheet)(input)
        })).toBlob()
    });

},{"client-zip":"1QdjL","@react-pdf/renderer":"dlG57","date-fns":"5Pdd3","../../../lib":"lWrCo","../utils":"f9RHL","../../../addresses":"3Mw7F","./TimesheetPDF":"gW0kq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1QdjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadZip", ()=>A);
parcelHelpers.export(exports, "makeZip", ()=>N);
parcelHelpers.export(exports, "predictLength", ()=>S);
"stream" in Blob.prototype || Object.defineProperty(Blob.prototype, "stream", {
    value () {
        return new Response(this).body;
    }
}), "setBigUint64" in DataView.prototype || Object.defineProperty(DataView.prototype, "setBigUint64", {
    value (e, n, t) {
        const i = Number(0xffffffffn & n), r = Number(n >> 32n);
        this.setUint32(e + (t ? 0 : 4), i, t), this.setUint32(e + (t ? 4 : 0), r, t);
    }
});
var e = (e)=>new DataView(new ArrayBuffer(e)), n = (e)=>new Uint8Array(e.buffer || e), t = (e)=>(new TextEncoder).encode(String(e)), i = (e)=>Math.min(4294967295, Number(e)), r = (e)=>Math.min(65535, Number(e));
function f(e, i) {
    if (void 0 === i || i instanceof Date || (i = new Date(i)), e instanceof File) return {
        isFile: 1,
        t: i || new Date(e.lastModified),
        i: e.stream()
    };
    if (e instanceof Response) return {
        isFile: 1,
        t: i || new Date(e.headers.get("Last-Modified") || Date.now()),
        i: e.body
    };
    if (void 0 === i) i = new Date;
    else if (isNaN(i)) throw new Error("Invalid modification date.");
    if (void 0 === e) return {
        isFile: 0,
        t: i
    };
    if ("string" == typeof e) return {
        isFile: 1,
        t: i,
        i: t(e)
    };
    if (e instanceof Blob) return {
        isFile: 1,
        t: i,
        i: e.stream()
    };
    if (e instanceof Uint8Array || e instanceof ReadableStream) return {
        isFile: 1,
        t: i,
        i: e
    };
    if (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) return {
        isFile: 1,
        t: i,
        i: n(e)
    };
    if (Symbol.asyncIterator in e) return {
        isFile: 1,
        t: i,
        i: o(e[Symbol.asyncIterator]())
    };
    throw new TypeError("Unsupported input format.");
}
function o(e, n = e) {
    return new ReadableStream({
        async pull (n) {
            let t = 0;
            for(; n.desiredSize > t;){
                const i = await e.next();
                if (!i.value) {
                    n.close();
                    break;
                }
                {
                    const e = a(i.value);
                    n.enqueue(e), t += e.byteLength;
                }
            }
        },
        cancel (e) {
            var _n_throw;
            (_n_throw = n.throw) === null || _n_throw === void 0 ? void 0 : _n_throw.call(n, e);
        }
    });
}
function a(e) {
    return "string" == typeof e ? t(e) : e instanceof Uint8Array ? e : n(e);
}
function s(e, i, r) {
    let [f, o] = function(e) {
        return e ? e instanceof Uint8Array ? [
            e,
            1
        ] : ArrayBuffer.isView(e) || e instanceof ArrayBuffer ? [
            n(e),
            1
        ] : [
            t(e),
            0
        ] : [
            void 0,
            0
        ];
    }(i);
    if (e instanceof File) return {
        o: d(f || t(e.name)),
        u: BigInt(e.size),
        l: o
    };
    if (e instanceof Response) {
        const n = e.headers.get("content-disposition"), i = n && n.match(/;\s*filename\*?=["']?(.*?)["']?$/i), a = i && i[1] || e.url && new URL(e.url).pathname.split("/").findLast(Boolean), s = a && decodeURIComponent(a), u = r || +e.headers.get("content-length");
        return {
            o: d(f || t(s)),
            u: BigInt(u),
            l: o
        };
    }
    return f = d(f, void 0 !== e || void 0 !== r), "string" == typeof e ? {
        o: f,
        u: BigInt(t(e).length),
        l: o
    } : e instanceof Blob ? {
        o: f,
        u: BigInt(e.size),
        l: o
    } : e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? {
        o: f,
        u: BigInt(e.byteLength),
        l: o
    } : {
        o: f,
        u: u(e, r),
        l: o
    };
}
function u(e, n) {
    return n > -1 ? BigInt(n) : e ? void 0 : 0n;
}
function d(e, n = 1) {
    if (!e || e.every((c)=>47 === c)) throw new Error("The file must have a name.");
    if (n) for(; 47 === e[e.length - 1];)e = e.subarray(0, -1);
    else 47 !== e[e.length - 1] && (e = new Uint8Array([
        ...e,
        47
    ]));
    return e;
}
var l = new Uint32Array(256);
for(let e = 0; e < 256; ++e){
    let n = e;
    for(let e = 0; e < 8; ++e)n = n >>> 1 ^ (1 & n && 3988292384);
    l[e] = n;
}
function y(e, n = 0) {
    n ^= -1;
    for(var t = 0, i = e.length; t < i; t++)n = n >>> 8 ^ l[255 & n ^ e[t]];
    return (-1 ^ n) >>> 0;
}
function B(e, n, t = 0) {
    const i = e.getSeconds() >> 1 | e.getMinutes() << 5 | e.getHours() << 11, r = e.getDate() | e.getMonth() + 1 << 5 | e.getFullYear() - 1980 << 9;
    n.setUint16(t, i, 1), n.setUint16(t + 2, r, 1);
}
function w({ o: e, l: n }, t) {
    return 8 * (!n || (t !== null && t !== void 0 ? t : function(e) {
        try {
            b.decode(e);
        } catch  {
            return 0;
        }
        return 1;
    }(e)));
}
var b = new TextDecoder("utf8", {
    fatal: 1
});
function p(t, i = 0) {
    const r = e(30);
    return r.setUint32(0, 1347093252), r.setUint32(4, 754976768 | i), B(t.t, r, 10), r.setUint16(26, t.o.length, 1), n(r);
}
async function* g(e) {
    let { i: n } = e;
    if ("then" in n && (n = await n), n instanceof Uint8Array) yield n, e.m = y(n, 0), e.u = BigInt(n.length);
    else {
        e.u = 0n;
        const t = n.getReader();
        for(;;){
            const { value: n, done: i } = await t.read();
            if (i) break;
            e.m = y(n, e.m), e.u += BigInt(n.length), yield n;
        }
    }
}
function I(t, r) {
    const f = e(16 + (r ? 8 : 0));
    return f.setUint32(0, 1347094280), f.setUint32(4, t.isFile ? t.m : 0, 1), r ? (f.setBigUint64(8, t.u, 1), f.setBigUint64(16, t.u, 1)) : (f.setUint32(8, i(t.u), 1), f.setUint32(12, i(t.u), 1)), n(f);
}
function v(t, r, f = 0, o = 0) {
    const a = e(46);
    return a.setUint32(0, 1347092738), a.setUint32(4, 755182848), a.setUint16(8, 2048 | f), B(t.t, a, 12), a.setUint32(16, t.isFile ? t.m : 0, 1), a.setUint32(20, i(t.u), 1), a.setUint32(24, i(t.u), 1), a.setUint16(28, t.o.length, 1), a.setUint16(30, o, 1), a.setUint16(40, t.isFile ? 33204 : 16893, 1), a.setUint32(42, i(r), 1), n(a);
}
function h(t, i, r) {
    const f = e(r);
    return f.setUint16(0, 1, 1), f.setUint16(2, r - 4, 1), 16 & r && (f.setBigUint64(4, t.u, 1), f.setBigUint64(12, t.u, 1)), f.setBigUint64(r - 8, i, 1), n(f);
}
function D(e) {
    return e instanceof File || e instanceof Response ? [
        [
            e
        ],
        [
            e
        ]
    ] : [
        [
            e.input,
            e.name,
            e.size
        ],
        [
            e.input,
            e.lastModified
        ]
    ];
}
var S = (e)=>(function(e) {
        let n = BigInt(22), t = 0n, i = 0;
        for (const r of e){
            if (!r.o) throw new Error("Every file must have a non-empty name.");
            if (void 0 === r.u) throw new Error(`Missing size for file "${(new TextDecoder).decode(r.o)}".`);
            const e = r.u >= 0xffffffffn, f = t >= 0xffffffffn;
            t += BigInt(46 + r.o.length + (e && 8)) + r.u, n += BigInt(r.o.length + 46 + (12 * f | 28 * e)), i || (i = e);
        }
        return (i || t >= 0xffffffffn) && (n += BigInt(76)), n + t;
    })(function*(e) {
        for (const n of e)yield s(...D(n)[0]);
    }(e));
function A(e, n = {}) {
    const t = {
        "Content-Type": "application/zip",
        "Content-Disposition": "attachment"
    };
    return ("bigint" == typeof n.length || Number.isInteger(n.length)) && n.length > 0 && (t["Content-Length"] = String(n.length)), n.metadata && (t["Content-Length"] = String(S(n.metadata))), new Response(N(e, n), {
        headers: t
    });
}
function N(t, a = {}) {
    const u = function(e) {
        var _n_throw;
        const n = e[Symbol.iterator in e ? Symbol.iterator : Symbol.asyncIterator]();
        return {
            async next () {
                const e = await n.next();
                if (e.done) return e;
                const [t, i] = D(e.value);
                return {
                    done: 0,
                    value: Object.assign(f(...i), s(...t))
                };
            },
            throw: (_n_throw = n.throw) === null || _n_throw === void 0 ? void 0 : _n_throw.bind(n),
            [Symbol.asyncIterator] () {
                return this;
            }
        };
    }(t);
    return o(async function*(t, f) {
        const o = [];
        let a = 0n, s = 0n, u = 0;
        for await (const e of t){
            const n = w(e, f.buffersAreUTF8);
            yield p(e, n), yield e.o, e.isFile && (yield* g(e));
            const t = e.u >= 0xffffffffn, i = 12 * (a >= 0xffffffffn) | 28 * t;
            yield I(e, t), o.push(v(e, a, n, i)), o.push(e.o), i && o.push(h(e, a, i)), t && (a += 8n), s++, a += BigInt(46 + e.o.length) + e.u, u || (u = t);
        }
        let d = 0n;
        for (const e of o)yield e, d += BigInt(e.length);
        if (u || a >= 0xffffffffn) {
            const t = e(76);
            t.setUint32(0, 1347094022), t.setBigUint64(4, BigInt(44), 1), t.setUint32(12, 755182848), t.setBigUint64(24, s, 1), t.setBigUint64(32, s, 1), t.setBigUint64(40, d, 1), t.setBigUint64(48, a, 1), t.setUint32(56, 1347094023), t.setBigUint64(64, a + d, 1), t.setUint32(72, 1, 1), yield n(t);
        }
        const l = e(22);
        l.setUint32(0, 1347093766), l.setUint16(8, r(s), 1), l.setUint16(10, r(s), 1), l.setUint32(12, i(d), 1), l.setUint32(16, i(a), 1), yield n(l);
    }(u, a), u);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dlG57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlobProvider", ()=>BlobProvider);
parcelHelpers.export(exports, "Font", ()=>Font);
parcelHelpers.export(exports, "PDFDownloadLink", ()=>PDFDownloadLink);
parcelHelpers.export(exports, "PDFViewer", ()=>PDFViewer);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "default", ()=>index);
parcelHelpers.export(exports, "pdf", ()=>pdf);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "renderToBuffer", ()=>renderToBuffer);
parcelHelpers.export(exports, "renderToFile", ()=>renderToFile);
parcelHelpers.export(exports, "renderToStream", ()=>renderToStream);
parcelHelpers.export(exports, "renderToString", ()=>renderToString);
parcelHelpers.export(exports, "usePDF", ()=>usePDF);
parcelHelpers.export(exports, "version", ()=>version);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _primitives = require("@react-pdf/primitives");
parcelHelpers.exportAll(_primitives, exports);
var _queue = require("queue");
var _queueDefault = parcelHelpers.interopDefault(_queue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _font = require("@react-pdf/font");
var _fontDefault = parcelHelpers.interopDefault(_font);
var _render = require("@react-pdf/render");
var _renderDefault = parcelHelpers.interopDefault(_render);
var _pdfkit = require("@react-pdf/pdfkit");
var _pdfkitDefault = parcelHelpers.interopDefault(_pdfkit);
var _layout = require("@react-pdf/layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _objectAssign = require("object-assign");
var _objectAssignDefault = parcelHelpers.interopDefault(_objectAssign);
var _scheduler = require("scheduler");
var _jsxRuntime = require("react/jsx-runtime");
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a() {
            if (this instanceof a) return Reflect.construct(f, arguments, this.constructor);
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var reactReconciler_production_min = {
    exports: {}
};
var require$$2 = /*@__PURE__*/ getAugmentedNamespace(_scheduler);
/** @license React v0.23.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(module) {
    module.exports = function $$$reconciler($$$hostConfig) {
        var aa = (0, _objectAssignDefault.default), ba = (0, _reactDefault.default), m = require$$2;
        function n(a) {
            for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
            return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var q = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        q.hasOwnProperty("ReactCurrentDispatcher") || (q.ReactCurrentDispatcher = {
            current: null
        });
        q.hasOwnProperty("ReactCurrentBatchConfig") || (q.ReactCurrentBatchConfig = {
            suspense: null
        });
        var u = "function" === typeof Symbol && Symbol.for, ca = u ? Symbol.for("react.element") : 60103, da = u ? Symbol.for("react.portal") : 60106, ea = u ? Symbol.for("react.fragment") : 60107, fa = u ? Symbol.for("react.strict_mode") : 60108, ha = u ? Symbol.for("react.profiler") : 60114, ia = u ? Symbol.for("react.provider") : 60109, ja = u ? Symbol.for("react.context") : 60110, ka = u ? Symbol.for("react.concurrent_mode") : 60111, la = u ? Symbol.for("react.forward_ref") : 60112, ma = u ? Symbol.for("react.suspense") : 60113, na = u ? Symbol.for("react.suspense_list") : 60120, oa = u ? Symbol.for("react.memo") : 60115, pa = u ? Symbol.for("react.lazy") : 60116;
        var qa = "function" === typeof Symbol && Symbol.iterator;
        function ra(a) {
            if (null === a || "object" !== typeof a) return null;
            a = qa && a[qa] || a["@@iterator"];
            return "function" === typeof a ? a : null;
        }
        function sa(a) {
            if (-1 === a._status) {
                a._status = 0;
                var b = a._ctor;
                b = b();
                a._result = b;
                b.then(function(b) {
                    0 === a._status && (b = b.default, a._status = 1, a._result = b);
                }, function(b) {
                    0 === a._status && (a._status = 2, a._result = b);
                });
            }
        }
        function ta(a) {
            if (null == a) return null;
            if ("function" === typeof a) return a.displayName || a.name || null;
            if ("string" === typeof a) return a;
            switch(a){
                case ea:
                    return "Fragment";
                case da:
                    return "Portal";
                case ha:
                    return "Profiler";
                case fa:
                    return "StrictMode";
                case ma:
                    return "Suspense";
                case na:
                    return "SuspenseList";
            }
            if ("object" === typeof a) switch(a.$$typeof){
                case ja:
                    return "Context.Consumer";
                case ia:
                    return "Context.Provider";
                case la:
                    var b = a.render;
                    b = b.displayName || b.name || "";
                    return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
                case oa:
                    return ta(a.type);
                case pa:
                    if (a = 1 === a._status ? a._result : null) return ta(a);
            }
            return null;
        }
        function ua(a) {
            var b = a, c = a;
            if (a.alternate) for(; b.return;)b = b.return;
            else {
                a = b;
                do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
                while (a);
            }
            return 3 === b.tag ? c : null;
        }
        function va(a) {
            if (ua(a) !== a) throw Error(n(188));
        }
        function wa(a) {
            var b = a.alternate;
            if (!b) {
                b = ua(a);
                if (null === b) throw Error(n(188));
                return b !== a ? null : a;
            }
            for(var c = a, d = b;;){
                var e = c.return;
                if (null === e) break;
                var f = e.alternate;
                if (null === f) {
                    d = e.return;
                    if (null !== d) {
                        c = d;
                        continue;
                    }
                    break;
                }
                if (e.child === f.child) {
                    for(f = e.child; f;){
                        if (f === c) return va(e), a;
                        if (f === d) return va(e), b;
                        f = f.sibling;
                    }
                    throw Error(n(188));
                }
                if (c.return !== d.return) c = e, d = f;
                else {
                    for(var g = !1, l = e.child; l;){
                        if (l === c) {
                            g = !0;
                            c = e;
                            d = f;
                            break;
                        }
                        if (l === d) {
                            g = !0;
                            d = e;
                            c = f;
                            break;
                        }
                        l = l.sibling;
                    }
                    if (!g) {
                        for(l = f.child; l;){
                            if (l === c) {
                                g = !0;
                                c = f;
                                d = e;
                                break;
                            }
                            if (l === d) {
                                g = !0;
                                d = f;
                                c = e;
                                break;
                            }
                            l = l.sibling;
                        }
                        if (!g) throw Error(n(189));
                    }
                }
                if (c.alternate !== d) throw Error(n(190));
            }
            if (3 !== c.tag) throw Error(n(188));
            return c.stateNode.current === c ? a : b;
        }
        function xa(a) {
            a = wa(a);
            if (!a) return null;
            for(var b = a;;){
                if (5 === b.tag || 6 === b.tag) return b;
                if (b.child) b.child.return = b, b = b.child;
                else {
                    if (b === a) break;
                    for(; !b.sibling;){
                        if (!b.return || b.return === a) return null;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
            return null;
        }
        function ya(a) {
            a = wa(a);
            if (!a) return null;
            for(var b = a;;){
                if (5 === b.tag || 6 === b.tag) return b;
                if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;
                else {
                    if (b === a) break;
                    for(; !b.sibling;){
                        if (!b.return || b.return === a) return null;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
            return null;
        }
        var za = $$$hostConfig.getPublicInstance, Aa = $$$hostConfig.getRootHostContext, Ba = $$$hostConfig.getChildHostContext, Ca = $$$hostConfig.prepareForCommit, Da = $$$hostConfig.resetAfterCommit, Ea = $$$hostConfig.createInstance, Fa = $$$hostConfig.appendInitialChild, Ga = $$$hostConfig.finalizeInitialChildren, Ia = $$$hostConfig.prepareUpdate, Ja = $$$hostConfig.shouldSetTextContent, Ka = $$$hostConfig.shouldDeprioritizeSubtree, La = $$$hostConfig.createTextInstance, Ma = $$$hostConfig.setTimeout, Na = $$$hostConfig.clearTimeout, Oa = $$$hostConfig.noTimeout, Pa = $$$hostConfig.isPrimaryRenderer, Qa = $$$hostConfig.supportsMutation, Ra = $$$hostConfig.supportsPersistence, Sa = $$$hostConfig.supportsHydration, Ta = $$$hostConfig.appendChild, Ua = $$$hostConfig.appendChildToContainer, Va = $$$hostConfig.commitTextUpdate, Wa = $$$hostConfig.commitMount, Xa = $$$hostConfig.commitUpdate, Ya = $$$hostConfig.insertBefore, Za = $$$hostConfig.insertInContainerBefore, $a = $$$hostConfig.removeChild, ab = $$$hostConfig.removeChildFromContainer, bb = $$$hostConfig.resetTextContent, cb = $$$hostConfig.hideInstance, db = $$$hostConfig.hideTextInstance, eb = $$$hostConfig.unhideInstance, fb = $$$hostConfig.unhideTextInstance, gb = $$$hostConfig.cloneInstance, hb = $$$hostConfig.createContainerChildSet, ib = $$$hostConfig.appendChildToContainerChildSet, kb = $$$hostConfig.finalizeContainerChildren, lb = $$$hostConfig.replaceContainerChildren, mb = $$$hostConfig.cloneHiddenInstance, nb = $$$hostConfig.cloneHiddenTextInstance, ob = $$$hostConfig.canHydrateInstance, pb = $$$hostConfig.canHydrateTextInstance, qb = $$$hostConfig.isSuspenseInstancePending, rb = $$$hostConfig.isSuspenseInstanceFallback, sb = $$$hostConfig.getNextHydratableSibling, tb = $$$hostConfig.getFirstHydratableChild, ub = $$$hostConfig.hydrateInstance, vb = $$$hostConfig.hydrateTextInstance, wb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, xb = $$$hostConfig.commitHydratedContainer, yb = $$$hostConfig.commitHydratedSuspenseInstance, zb = /^(.*)[\\\/]/;
        function Ab(a) {
            var b = "";
            do {
                a: switch(a.tag){
                    case 3:
                    case 4:
                    case 6:
                    case 7:
                    case 10:
                    case 9:
                        var c = "";
                        break a;
                    default:
                        var d = a._debugOwner, e = a._debugSource, f = ta(a.type);
                        c = null;
                        d && (c = ta(d.type));
                        d = f;
                        f = "";
                        e ? f = " (at " + e.fileName.replace(zb, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                        c = "\n    in " + (d || "Unknown") + f;
                }
                b += c;
                a = a.return;
            }while (a);
            return b;
        }
        var Bb = [], Cb = -1;
        function y(a) {
            0 > Cb || (a.current = Bb[Cb], Bb[Cb] = null, Cb--);
        }
        function z(a, b) {
            Cb++;
            Bb[Cb] = a.current;
            a.current = b;
        }
        var Db = {}, A = {
            current: Db
        }, B = {
            current: !1
        }, Eb = Db;
        function Fb(a, b) {
            var c = a.type.contextTypes;
            if (!c) return Db;
            var d = a.stateNode;
            if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
            var e = {}, f;
            for(f in c)e[f] = b[f];
            d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
            return e;
        }
        function C(a) {
            a = a.childContextTypes;
            return null !== a && void 0 !== a;
        }
        function Gb(a) {
            y(B);
            y(A);
        }
        function Hb(a) {
            y(B);
            y(A);
        }
        function Ib(a, b, c) {
            if (A.current !== Db) throw Error(n(168));
            z(A, b);
            z(B, c);
        }
        function Jb(a, b, c) {
            var d = a.stateNode;
            a = b.childContextTypes;
            if ("function" !== typeof d.getChildContext) return c;
            d = d.getChildContext();
            for(var e in d)if (!(e in a)) throw Error(n(108, ta(b) || "Unknown", e));
            return aa({}, c, {}, d);
        }
        function Kb(a) {
            var b = a.stateNode;
            b = b && b.__reactInternalMemoizedMergedChildContext || Db;
            Eb = A.current;
            z(A, b);
            z(B, B.current);
            return !0;
        }
        function Lb(a, b, c) {
            var d = a.stateNode;
            if (!d) throw Error(n(169));
            c ? (b = Jb(a, b, Eb), d.__reactInternalMemoizedMergedChildContext = b, y(B), y(A), z(A, b)) : y(B);
            z(B, c);
        }
        var Mb = m.unstable_runWithPriority, Nb = m.unstable_scheduleCallback, Ob = m.unstable_cancelCallback, Pb = m.unstable_shouldYield, Qb = m.unstable_requestPaint, Tb = m.unstable_now, Ub = m.unstable_getCurrentPriorityLevel, Vb = m.unstable_ImmediatePriority, Wb = m.unstable_UserBlockingPriority, Xb = m.unstable_NormalPriority, Yb = m.unstable_LowPriority, Zb = m.unstable_IdlePriority, $b = {}, ac = void 0 !== Qb ? Qb : function() {}, bc = null, cc = null, dc = !1, ec = Tb(), E = 1E4 > ec ? Tb : function() {
            return Tb() - ec;
        };
        function fc() {
            switch(Ub()){
                case Vb:
                    return 99;
                case Wb:
                    return 98;
                case Xb:
                    return 97;
                case Yb:
                    return 96;
                case Zb:
                    return 95;
                default:
                    throw Error(n(332));
            }
        }
        function gc(a) {
            switch(a){
                case 99:
                    return Vb;
                case 98:
                    return Wb;
                case 97:
                    return Xb;
                case 96:
                    return Yb;
                case 95:
                    return Zb;
                default:
                    throw Error(n(332));
            }
        }
        function hc(a, b) {
            a = gc(a);
            return Mb(a, b);
        }
        function ic(a, b, c) {
            a = gc(a);
            return Nb(a, b, c);
        }
        function jc(a) {
            null === bc ? (bc = [
                a
            ], cc = Nb(Vb, kc)) : bc.push(a);
            return $b;
        }
        function F() {
            if (null !== cc) {
                var a = cc;
                cc = null;
                Ob(a);
            }
            kc();
        }
        function kc() {
            if (!dc && null !== bc) {
                dc = !0;
                var a = 0;
                try {
                    var b = bc;
                    hc(99, function() {
                        for(; a < b.length; a++){
                            var c = b[a];
                            do c = c(!0);
                            while (null !== c);
                        }
                    });
                    bc = null;
                } catch (c) {
                    throw null !== bc && (bc = bc.slice(a + 1)), Nb(Vb, F), c;
                } finally{
                    dc = !1;
                }
            }
        }
        var lc = 3;
        function mc(a, b, c) {
            c /= 10;
            return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
        }
        function nc(a, b) {
            return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
        }
        var oc = "function" === typeof Object.is ? Object.is : nc, pc = Object.prototype.hasOwnProperty;
        function qc(a, b) {
            if (oc(a, b)) return !0;
            if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
            var c = Object.keys(a), d = Object.keys(b);
            if (c.length !== d.length) return !1;
            for(d = 0; d < c.length; d++)if (!pc.call(b, c[d]) || !oc(a[c[d]], b[c[d]])) return !1;
            return !0;
        }
        function rc(a, b) {
            if (a && a.defaultProps) {
                b = aa({}, b);
                a = a.defaultProps;
                for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            }
            return b;
        }
        var sc = {
            current: null
        }, tc = null, uc = null, vc = null;
        function wc() {
            vc = uc = tc = null;
        }
        function xc(a, b) {
            var c = a.type._context;
            Pa ? (z(sc, c._currentValue), c._currentValue = b) : (z(sc, c._currentValue2), c._currentValue2 = b);
        }
        function yc(a) {
            var b = sc.current;
            y(sc);
            a = a.type._context;
            Pa ? a._currentValue = b : a._currentValue2 = b;
        }
        function zc(a, b) {
            for(; null !== a;){
                var c = a.alternate;
                if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
                else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
                else break;
                a = a.return;
            }
        }
        function Ac(a, b) {
            tc = a;
            vc = uc = null;
            a = a.dependencies;
            null !== a && null !== a.firstContext && (a.expirationTime >= b && (Bc = !0), a.firstContext = null);
        }
        function Cc(a, b) {
            if (vc !== a && !1 !== b && 0 !== b) {
                if ("number" !== typeof b || 1073741823 === b) vc = a, b = 1073741823;
                b = {
                    context: a,
                    observedBits: b,
                    next: null
                };
                if (null === uc) {
                    if (null === tc) throw Error(n(308));
                    uc = b;
                    tc.dependencies = {
                        expirationTime: 0,
                        firstContext: b,
                        responders: null
                    };
                } else uc = uc.next = b;
            }
            return Pa ? a._currentValue : a._currentValue2;
        }
        var Dc = !1;
        function Ec(a) {
            return {
                baseState: a,
                firstUpdate: null,
                lastUpdate: null,
                firstCapturedUpdate: null,
                lastCapturedUpdate: null,
                firstEffect: null,
                lastEffect: null,
                firstCapturedEffect: null,
                lastCapturedEffect: null
            };
        }
        function Fc(a) {
            return {
                baseState: a.baseState,
                firstUpdate: a.firstUpdate,
                lastUpdate: a.lastUpdate,
                firstCapturedUpdate: null,
                lastCapturedUpdate: null,
                firstEffect: null,
                lastEffect: null,
                firstCapturedEffect: null,
                lastCapturedEffect: null
            };
        }
        function Gc(a, b) {
            return {
                expirationTime: a,
                suspenseConfig: b,
                tag: 0,
                payload: null,
                callback: null,
                next: null,
                nextEffect: null
            };
        }
        function Hc(a, b) {
            null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
        }
        function Ic(a, b) {
            var c = a.alternate;
            if (null === c) {
                var d = a.updateQueue;
                var e = null;
                null === d && (d = a.updateQueue = Ec(a.memoizedState));
            } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = Ec(a.memoizedState), e = c.updateQueue = Ec(c.memoizedState)) : d = a.updateQueue = Fc(e) : null === e && (e = c.updateQueue = Fc(d));
            null === e || d === e ? Hc(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (Hc(d, b), Hc(e, b)) : (Hc(d, b), e.lastUpdate = b);
        }
        function Jc(a, b) {
            var c = a.updateQueue;
            c = null === c ? a.updateQueue = Ec(a.memoizedState) : Kc(a, c);
            null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
        }
        function Kc(a, b) {
            var c = a.alternate;
            null !== c && b === c.updateQueue && (b = a.updateQueue = Fc(b));
            return b;
        }
        function Lc(a, b, c, d, e, f) {
            switch(c.tag){
                case 1:
                    return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
                case 3:
                    a.effectTag = a.effectTag & -4097 | 64;
                case 0:
                    a = c.payload;
                    e = "function" === typeof a ? a.call(f, d, e) : a;
                    if (null === e || void 0 === e) break;
                    return aa({}, d, e);
                case 2:
                    Dc = !0;
            }
            return d;
        }
        function Nc(a, b, c, d, e) {
            Dc = !1;
            b = Kc(a, b);
            for(var f = b.baseState, g = null, l = 0, h = b.firstUpdate, k = f; null !== h;){
                var p = h.expirationTime;
                p < e ? (null === g && (g = h, f = k), l < p && (l = p)) : (Oc(p, h.suspenseConfig), k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = h : (b.lastEffect.nextEffect = h, b.lastEffect = h)));
                h = h.next;
            }
            p = null;
            for(h = b.firstCapturedUpdate; null !== h;){
                var D = h.expirationTime;
                D < e ? (null === p && (p = h, null === g && (f = k)), l < D && (l = D)) : (k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = h : (b.lastCapturedEffect.nextEffect = h, b.lastCapturedEffect = h)));
                h = h.next;
            }
            null === g && (b.lastUpdate = null);
            null === p ? b.lastCapturedUpdate = null : a.effectTag |= 32;
            null === g && null === p && (f = k);
            b.baseState = f;
            b.firstUpdate = g;
            b.firstCapturedUpdate = p;
            Pc(l);
            a.expirationTime = l;
            a.memoizedState = k;
        }
        function Qc(a, b, c) {
            null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
            Rc(b.firstEffect, c);
            b.firstEffect = b.lastEffect = null;
            Rc(b.firstCapturedEffect, c);
            b.firstCapturedEffect = b.lastCapturedEffect = null;
        }
        function Rc(a, b) {
            for(; null !== a;){
                var c = a.callback;
                if (null !== c) {
                    a.callback = null;
                    var d = b;
                    if ("function" !== typeof c) throw Error(n(191, c));
                    c.call(d);
                }
                a = a.nextEffect;
            }
        }
        var Sc = q.ReactCurrentBatchConfig, Tc = new ba.Component().refs;
        function Uc(a, b, c, d) {
            b = a.memoizedState;
            c = c(d, b);
            c = null === c || void 0 === c ? b : aa({}, b, c);
            a.memoizedState = c;
            d = a.updateQueue;
            null !== d && 0 === a.expirationTime && (d.baseState = c);
        }
        var Xc = {
            isMounted: function isMounted(a) {
                return (a = a._reactInternalFiber) ? ua(a) === a : !1;
            },
            enqueueSetState: function enqueueSetState(a, b, c) {
                a = a._reactInternalFiber;
                var d = G(), e = Sc.suspense;
                d = Vc(d, a, e);
                e = Gc(d, e);
                e.payload = b;
                void 0 !== c && null !== c && (e.callback = c);
                Ic(a, e);
                Wc(a, d);
            },
            enqueueReplaceState: function enqueueReplaceState(a, b, c) {
                a = a._reactInternalFiber;
                var d = G(), e = Sc.suspense;
                d = Vc(d, a, e);
                e = Gc(d, e);
                e.tag = 1;
                e.payload = b;
                void 0 !== c && null !== c && (e.callback = c);
                Ic(a, e);
                Wc(a, d);
            },
            enqueueForceUpdate: function enqueueForceUpdate(a, b) {
                a = a._reactInternalFiber;
                var c = G(), d = Sc.suspense;
                c = Vc(c, a, d);
                d = Gc(c, d);
                d.tag = 2;
                void 0 !== b && null !== b && (d.callback = b);
                Ic(a, d);
                Wc(a, c);
            }
        };
        function Yc(a, b, c, d, e, f, g) {
            a = a.stateNode;
            return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !qc(c, d) || !qc(e, f) : !0;
        }
        function Zc(a, b, c) {
            var d = !1, e = Db;
            var f = b.contextType;
            "object" === typeof f && null !== f ? f = Cc(f) : (e = C(b) ? Eb : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Fb(a, e) : Db);
            b = new b(c, f);
            a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
            b.updater = Xc;
            a.stateNode = b;
            b._reactInternalFiber = a;
            d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
            return b;
        }
        function $c(a, b, c, d) {
            a = b.state;
            "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
            "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
            b.state !== a && Xc.enqueueReplaceState(b, b.state, null);
        }
        function ad(a, b, c, d) {
            var e = a.stateNode;
            e.props = c;
            e.state = a.memoizedState;
            e.refs = Tc;
            var f = b.contextType;
            "object" === typeof f && null !== f ? e.context = Cc(f) : (f = C(b) ? Eb : A.current, e.context = Fb(a, f));
            f = a.updateQueue;
            null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState);
            f = b.getDerivedStateFromProps;
            "function" === typeof f && (Uc(a, b, f, c), e.state = a.memoizedState);
            "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Xc.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState));
            "function" === typeof e.componentDidMount && (a.effectTag |= 4);
        }
        var bd = Array.isArray;
        function cd(a, b, c) {
            a = c.ref;
            if (null !== a && "function" !== typeof a && "object" !== typeof a) {
                if (c._owner) {
                    c = c._owner;
                    if (c) {
                        if (1 !== c.tag) throw Error(n(309));
                        var d = c.stateNode;
                    }
                    if (!d) throw Error(n(147, a));
                    var e = "" + a;
                    if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                    b = function b(_b) {
                        var a = d.refs;
                        a === Tc && (a = d.refs = {});
                        null === _b ? delete a[e] : a[e] = _b;
                    };
                    b._stringRef = e;
                    return b;
                }
                if ("string" !== typeof a) throw Error(n(284));
                if (!c._owner) throw Error(n(290, a));
            }
            return a;
        }
        function dd(a, b) {
            if ("textarea" !== a.type) throw Error(n(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
        }
        function ed(a) {
            function b(b, c) {
                if (a) {
                    var d = b.lastEffect;
                    null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
                    c.nextEffect = null;
                    c.effectTag = 8;
                }
            }
            function c(c, d) {
                if (!a) return null;
                for(; null !== d;)b(c, d), d = d.sibling;
                return null;
            }
            function d(b, a) {
                for(b = new Map(); null !== a;)null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
                return b;
            }
            function e(b, a, c) {
                b = fd(b, a);
                b.index = 0;
                b.sibling = null;
                return b;
            }
            function f(b, c, d) {
                b.index = d;
                if (!a) return c;
                d = b.alternate;
                if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
                b.effectTag = 2;
                return c;
            }
            function g(b) {
                a && null === b.alternate && (b.effectTag = 2);
                return b;
            }
            function l(b, a, c, d) {
                if (null === a || 6 !== a.tag) return a = gd(c, b.mode, d), a.return = b, a;
                a = e(a, c);
                a.return = b;
                return a;
            }
            function h(b, a, c, d) {
                if (null !== a && a.elementType === c.type) return d = e(a, c.props), d.ref = cd(b, a, c), d.return = b, d;
                d = hd(c.type, c.key, c.props, null, b.mode, d);
                d.ref = cd(b, a, c);
                d.return = b;
                return d;
            }
            function k(b, a, c, d) {
                if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = id(c, b.mode, d), a.return = b, a;
                a = e(a, c.children || []);
                a.return = b;
                return a;
            }
            function p(b, a, c, d, f) {
                if (null === a || 7 !== a.tag) return a = jd(c, b.mode, d, f), a.return = b, a;
                a = e(a, c);
                a.return = b;
                return a;
            }
            function D(b, a, c) {
                if ("string" === typeof a || "number" === typeof a) return a = gd("" + a, b.mode, c), a.return = b, a;
                if ("object" === typeof a && null !== a) {
                    switch(a.$$typeof){
                        case ca:
                            return c = hd(a.type, a.key, a.props, null, b.mode, c), c.ref = cd(b, null, a), c.return = b, c;
                        case da:
                            return a = id(a, b.mode, c), a.return = b, a;
                    }
                    if (bd(a) || ra(a)) return a = jd(a, b.mode, c, null), a.return = b, a;
                    dd(b, a);
                }
                return null;
            }
            function x(b, a, c, d) {
                var e = null !== a ? a.key : null;
                if ("string" === typeof c || "number" === typeof c) return null !== e ? null : l(b, a, "" + c, d);
                if ("object" === typeof c && null !== c) {
                    switch(c.$$typeof){
                        case ca:
                            return c.key === e ? c.type === ea ? p(b, a, c.props.children, d, e) : h(b, a, c, d) : null;
                        case da:
                            return c.key === e ? k(b, a, c, d) : null;
                    }
                    if (bd(c) || ra(c)) return null !== e ? null : p(b, a, c, d, null);
                    dd(b, c);
                }
                return null;
            }
            function K(b, a, c, d, e) {
                if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, l(a, b, "" + d, e);
                if ("object" === typeof d && null !== d) {
                    switch(d.$$typeof){
                        case ca:
                            return b = b.get(null === d.key ? c : d.key) || null, d.type === ea ? p(a, b, d.props.children, e, d.key) : h(a, b, d, e);
                        case da:
                            return b = b.get(null === d.key ? c : d.key) || null, k(a, b, d, e);
                    }
                    if (bd(d) || ra(d)) return b = b.get(c) || null, p(a, b, d, e, null);
                    dd(a, d);
                }
                return null;
            }
            function Ha(e, g, h, l) {
                for(var k = null, w = null, t = g, r = g = 0, p = null; null !== t && r < h.length; r++){
                    t.index > r ? (p = t, t = null) : p = t.sibling;
                    var v = x(e, t, h[r], l);
                    if (null === v) {
                        null === t && (t = p);
                        break;
                    }
                    a && t && null === v.alternate && b(e, t);
                    g = f(v, g, r);
                    null === w ? k = v : w.sibling = v;
                    w = v;
                    t = p;
                }
                if (r === h.length) return c(e, t), k;
                if (null === t) {
                    for(; r < h.length; r++)t = D(e, h[r], l), null !== t && (g = f(t, g, r), null === w ? k = t : w.sibling = t, w = t);
                    return k;
                }
                for(t = d(e, t); r < h.length; r++)p = K(t, e, r, h[r], l), null !== p && (a && null !== p.alternate && t.delete(null === p.key ? r : p.key), g = f(p, g, r), null === w ? k = p : w.sibling = p, w = p);
                a && t.forEach(function(a) {
                    return b(e, a);
                });
                return k;
            }
            function O(e, g, h, l) {
                var k = ra(h);
                if ("function" !== typeof k) throw Error(n(150));
                h = k.call(h);
                if (null == h) throw Error(n(151));
                for(var t = k = null, r = g, w = g = 0, p = null, v = h.next(); null !== r && !v.done; w++, v = h.next()){
                    r.index > w ? (p = r, r = null) : p = r.sibling;
                    var N = x(e, r, v.value, l);
                    if (null === N) {
                        null === r && (r = p);
                        break;
                    }
                    a && r && null === N.alternate && b(e, r);
                    g = f(N, g, w);
                    null === t ? k = N : t.sibling = N;
                    t = N;
                    r = p;
                }
                if (v.done) return c(e, r), k;
                if (null === r) {
                    for(; !v.done; w++, v = h.next())v = D(e, v.value, l), null !== v && (g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
                    return k;
                }
                for(r = d(e, r); !v.done; w++, v = h.next())v = K(r, e, w, v.value, l), null !== v && (a && null !== v.alternate && r.delete(null === v.key ? w : v.key), g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
                a && r.forEach(function(a) {
                    return b(e, a);
                });
                return k;
            }
            return function(a, d, f, h) {
                var k = "object" === typeof f && null !== f && f.type === ea && null === f.key;
                k && (f = f.props.children);
                var l = "object" === typeof f && null !== f;
                if (l) switch(f.$$typeof){
                    case ca:
                        a: {
                            l = f.key;
                            for(k = d; null !== k;){
                                if (k.key === l) {
                                    if (7 === k.tag ? f.type === ea : k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.type === ea ? f.props.children : f.props);
                                        d.ref = cd(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, k);
                                        break;
                                    }
                                } else b(a, k);
                                k = k.sibling;
                            }
                            f.type === ea ? (d = jd(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = hd(f.type, f.key, f.props, null, a.mode, h), h.ref = cd(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case da:
                        a: {
                            for(k = f.key; null !== d;){
                                if (d.key === k) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = id(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                }
                if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = gd(f, a.mode, h), d.return = a, a = d), g(a);
                if (bd(f)) return Ha(a, d, f, h);
                if (ra(f)) return O(a, d, f, h);
                l && dd(a, f);
                if ("undefined" === typeof f && !k) switch(a.tag){
                    case 1:
                    case 0:
                        throw a = a.type, Error(n(152, a.displayName || a.name || "Component"));
                }
                return c(a, d);
            };
        }
        var kd = ed(!0), ld = ed(!1), md = {}, H = {
            current: md
        }, nd = {
            current: md
        }, od = {
            current: md
        };
        function pd(a) {
            if (a === md) throw Error(n(174));
            return a;
        }
        function qd(a, b) {
            z(od, b);
            z(nd, a);
            z(H, md);
            b = Aa(b);
            y(H);
            z(H, b);
        }
        function rd(a) {
            y(H);
            y(nd);
            y(od);
        }
        function sd(a) {
            var b = pd(od.current), c = pd(H.current);
            b = Ba(c, a.type, b);
            c !== b && (z(nd, a), z(H, b));
        }
        function td(a) {
            nd.current === a && (y(H), y(nd));
        }
        var I = {
            current: 0
        };
        function ud(a) {
            for(var b = a; null !== b;){
                if (13 === b.tag) {
                    var c = b.memoizedState;
                    if (null !== c && (c = c.dehydrated, null === c || qb(c) || rb(c))) return b;
                } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                    if (0 !== (b.effectTag & 64)) return b;
                } else if (null !== b.child) {
                    b.child.return = b;
                    b = b.child;
                    continue;
                }
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
            return null;
        }
        function vd(a, b) {
            return {
                responder: a,
                props: b
            };
        }
        var wd = q.ReactCurrentDispatcher, J = q.ReactCurrentBatchConfig, xd = 0, yd = null, L = null, zd = null, Ad = null, M = null, Bd = null, Cd = 0, Dd = null, Ed = 0, Fd = !1, Gd = null, Hd = 0;
        function P() {
            throw Error(n(321));
        }
        function Id(a, b) {
            if (null === b) return !1;
            for(var c = 0; c < b.length && c < a.length; c++)if (!oc(a[c], b[c])) return !1;
            return !0;
        }
        function Jd(a, b, c, d, e, f) {
            xd = f;
            yd = b;
            zd = null !== a ? a.memoizedState : null;
            wd.current = null === zd ? Kd : Ld;
            b = c(d, e);
            if (Fd) {
                do Fd = !1, Hd += 1, zd = null !== a ? a.memoizedState : null, Bd = Ad, Dd = M = L = null, wd.current = Ld, b = c(d, e);
                while (Fd);
                Gd = null;
                Hd = 0;
            }
            wd.current = Md;
            a = yd;
            a.memoizedState = Ad;
            a.expirationTime = Cd;
            a.updateQueue = Dd;
            a.effectTag |= Ed;
            a = null !== L && null !== L.next;
            xd = 0;
            Bd = M = Ad = zd = L = yd = null;
            Cd = 0;
            Dd = null;
            Ed = 0;
            if (a) throw Error(n(300));
            return b;
        }
        function Nd() {
            wd.current = Md;
            xd = 0;
            Bd = M = Ad = zd = L = yd = null;
            Cd = 0;
            Dd = null;
            Ed = 0;
            Fd = !1;
            Gd = null;
            Hd = 0;
        }
        function Od() {
            var a = {
                memoizedState: null,
                baseState: null,
                queue: null,
                baseUpdate: null,
                next: null
            };
            null === M ? Ad = M = a : M = M.next = a;
            return M;
        }
        function Pd() {
            if (null !== Bd) M = Bd, Bd = M.next, L = zd, zd = null !== L ? L.next : null;
            else {
                if (null === zd) throw Error(n(310));
                L = zd;
                var a = {
                    memoizedState: L.memoizedState,
                    baseState: L.baseState,
                    queue: L.queue,
                    baseUpdate: L.baseUpdate,
                    next: null
                };
                M = null === M ? Ad = a : M.next = a;
                zd = L.next;
            }
            return M;
        }
        function Qd(a, b) {
            return "function" === typeof b ? b(a) : b;
        }
        function Rd(a) {
            var b = Pd(), c = b.queue;
            if (null === c) throw Error(n(311));
            c.lastRenderedReducer = a;
            if (0 < Hd) {
                var d = c.dispatch;
                if (null !== Gd) {
                    var e = Gd.get(c);
                    if (void 0 !== e) {
                        Gd.delete(c);
                        var f = b.memoizedState;
                        do f = a(f, e.action), e = e.next;
                        while (null !== e);
                        oc(f, b.memoizedState) || (Bc = !0);
                        b.memoizedState = f;
                        b.baseUpdate === c.last && (b.baseState = f);
                        c.lastRenderedState = f;
                        return [
                            f,
                            d
                        ];
                    }
                }
                return [
                    b.memoizedState,
                    d
                ];
            }
            d = c.last;
            var g = b.baseUpdate;
            f = b.baseState;
            null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
            if (null !== d) {
                var l = e = null, h = d, k = !1;
                do {
                    var p = h.expirationTime;
                    p < xd ? (k || (k = !0, l = g, e = f), p > Cd && (Cd = p, Pc(Cd))) : (Oc(p, h.suspenseConfig), f = h.eagerReducer === a ? h.eagerState : a(f, h.action));
                    g = h;
                    h = h.next;
                }while (null !== h && h !== d);
                k || (l = g, e = f);
                oc(f, b.memoizedState) || (Bc = !0);
                b.memoizedState = f;
                b.baseUpdate = l;
                b.baseState = e;
                c.lastRenderedState = f;
            }
            return [
                b.memoizedState,
                c.dispatch
            ];
        }
        function Sd(a) {
            var b = Od();
            "function" === typeof a && (a = a());
            b.memoizedState = b.baseState = a;
            a = b.queue = {
                last: null,
                dispatch: null,
                lastRenderedReducer: Qd,
                lastRenderedState: a
            };
            a = a.dispatch = Td.bind(null, yd, a);
            return [
                b.memoizedState,
                a
            ];
        }
        function Ud(a) {
            return Rd(Qd);
        }
        function Vd(a, b, c, d) {
            a = {
                tag: a,
                create: b,
                destroy: c,
                deps: d,
                next: null
            };
            null === Dd ? (Dd = {
                lastEffect: null
            }, Dd.lastEffect = a.next = a) : (b = Dd.lastEffect, null === b ? Dd.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, Dd.lastEffect = a));
            return a;
        }
        function Wd(a, b, c, d) {
            var e = Od();
            Ed |= a;
            e.memoizedState = Vd(b, c, void 0, void 0 === d ? null : d);
        }
        function Xd(a, b, c, d) {
            var e = Pd();
            d = void 0 === d ? null : d;
            var f = void 0;
            if (null !== L) {
                var g = L.memoizedState;
                f = g.destroy;
                if (null !== d && Id(d, g.deps)) {
                    Vd(0, c, f, d);
                    return;
                }
            }
            Ed |= a;
            e.memoizedState = Vd(b, c, f, d);
        }
        function Yd(a, b) {
            return Wd(516, 192, a, b);
        }
        function Zd(a, b) {
            return Xd(516, 192, a, b);
        }
        function $d(a, b) {
            if ("function" === typeof b) return a = a(), b(a), function() {
                b(null);
            };
            if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
                b.current = null;
            };
        }
        function ae() {}
        function be(a, b) {
            Od().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        }
        function ce(a, b) {
            var c = Pd();
            b = void 0 === b ? null : b;
            var d = c.memoizedState;
            if (null !== d && null !== b && Id(b, d[1])) return d[0];
            c.memoizedState = [
                a,
                b
            ];
            return a;
        }
        function Td(a, b, c) {
            if (!(25 > Hd)) throw Error(n(301));
            var d = a.alternate;
            if (a === yd || null !== d && d === yd) {
                if (Fd = !0, a = {
                    expirationTime: xd,
                    suspenseConfig: null,
                    action: c,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, null === Gd && (Gd = new Map()), c = Gd.get(b), void 0 === c) Gd.set(b, a);
                else {
                    for(b = c; null !== b.next;)b = b.next;
                    b.next = a;
                }
            } else {
                var e = G(), f = Sc.suspense;
                e = Vc(e, a, f);
                f = {
                    expirationTime: e,
                    suspenseConfig: f,
                    action: c,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                };
                var g = b.last;
                if (null === g) f.next = f;
                else {
                    var l = g.next;
                    null !== l && (f.next = l);
                    g.next = f;
                }
                b.last = f;
                if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
                    var h = b.lastRenderedState, k = d(h, c);
                    f.eagerReducer = d;
                    f.eagerState = k;
                    if (oc(k, h)) return;
                } catch (p) {} finally{}
                Wc(a, e);
            }
        }
        var Md = {
            readContext: Cc,
            useCallback: P,
            useContext: P,
            useEffect: P,
            useImperativeHandle: P,
            useLayoutEffect: P,
            useMemo: P,
            useReducer: P,
            useRef: P,
            useState: P,
            useDebugValue: P,
            useResponder: P,
            useDeferredValue: P,
            useTransition: P
        }, Kd = {
            readContext: Cc,
            useCallback: be,
            useContext: Cc,
            useEffect: Yd,
            useImperativeHandle: function useImperativeHandle(a, b, c) {
                c = null !== c && void 0 !== c ? c.concat([
                    a
                ]) : null;
                return Wd(4, 36, $d.bind(null, b, a), c);
            },
            useLayoutEffect: function useLayoutEffect(a, b) {
                return Wd(4, 36, a, b);
            },
            useMemo: function useMemo(a, b) {
                var c = Od();
                b = void 0 === b ? null : b;
                a = a();
                c.memoizedState = [
                    a,
                    b
                ];
                return a;
            },
            useReducer: function useReducer(a, b, c) {
                var d = Od();
                b = void 0 !== c ? c(b) : b;
                d.memoizedState = d.baseState = b;
                a = d.queue = {
                    last: null,
                    dispatch: null,
                    lastRenderedReducer: a,
                    lastRenderedState: b
                };
                a = a.dispatch = Td.bind(null, yd, a);
                return [
                    d.memoizedState,
                    a
                ];
            },
            useRef: function useRef(a) {
                var b = Od();
                a = {
                    current: a
                };
                return b.memoizedState = a;
            },
            useState: Sd,
            useDebugValue: ae,
            useResponder: vd,
            useDeferredValue: function useDeferredValue(a, b) {
                var c = Sd(a), d = c[0], e = c[1];
                Yd(function() {
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === b ? null : b;
                        try {
                            e(a);
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    b
                ]);
                return d;
            },
            useTransition: function useTransition(a) {
                var b = Sd(!1), c = b[0], d = b[1];
                return [
                    be(function(b) {
                        d(!0);
                        m.unstable_next(function() {
                            var c = J.suspense;
                            J.suspense = void 0 === a ? null : a;
                            try {
                                d(!1), b();
                            } finally{
                                J.suspense = c;
                            }
                        });
                    }, [
                        a,
                        c
                    ]),
                    c
                ];
            }
        }, Ld = {
            readContext: Cc,
            useCallback: ce,
            useContext: Cc,
            useEffect: Zd,
            useImperativeHandle: function useImperativeHandle(a, b, c) {
                c = null !== c && void 0 !== c ? c.concat([
                    a
                ]) : null;
                return Xd(4, 36, $d.bind(null, b, a), c);
            },
            useLayoutEffect: function useLayoutEffect(a, b) {
                return Xd(4, 36, a, b);
            },
            useMemo: function useMemo(a, b) {
                var c = Pd();
                b = void 0 === b ? null : b;
                var d = c.memoizedState;
                if (null !== d && null !== b && Id(b, d[1])) return d[0];
                a = a();
                c.memoizedState = [
                    a,
                    b
                ];
                return a;
            },
            useReducer: Rd,
            useRef: function useRef() {
                return Pd().memoizedState;
            },
            useState: Ud,
            useDebugValue: ae,
            useResponder: vd,
            useDeferredValue: function useDeferredValue(a, b) {
                var c = Ud(), d = c[0], e = c[1];
                Zd(function() {
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === b ? null : b;
                        try {
                            e(a);
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    b
                ]);
                return d;
            },
            useTransition: function useTransition(a) {
                var b = Ud(), c = b[0], d = b[1];
                return [
                    ce(function(b) {
                        d(!0);
                        m.unstable_next(function() {
                            var c = J.suspense;
                            J.suspense = void 0 === a ? null : a;
                            try {
                                d(!1), b();
                            } finally{
                                J.suspense = c;
                            }
                        });
                    }, [
                        a,
                        c
                    ]),
                    c
                ];
            }
        }, de = null, ee = null, fe = !1;
        function ge(a, b) {
            var c = he(5, null, null, 0);
            c.elementType = "DELETED";
            c.type = "DELETED";
            c.stateNode = b;
            c.return = a;
            c.effectTag = 8;
            null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
        }
        function ie(a, b) {
            switch(a.tag){
                case 5:
                    return b = ob(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
                case 6:
                    return b = pb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
                case 13:
                    return !1;
                default:
                    return !1;
            }
        }
        function je(a) {
            if (fe) {
                var b = ee;
                if (b) {
                    var c = b;
                    if (!ie(a, b)) {
                        b = sb(c);
                        if (!b || !ie(a, b)) {
                            a.effectTag = a.effectTag & -1025 | 2;
                            fe = !1;
                            de = a;
                            return;
                        }
                        ge(de, c);
                    }
                    de = a;
                    ee = tb(b);
                } else a.effectTag = a.effectTag & -1025 | 2, fe = !1, de = a;
            }
        }
        function ke(a) {
            for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
            de = a;
        }
        function ne(a) {
            if (!Sa || a !== de) return !1;
            if (!fe) return ke(a), fe = !0, !1;
            var b = a.type;
            if (5 !== a.tag || "head" !== b && "body" !== b && !Ja(b, a.memoizedProps)) for(b = ee; b;)ge(a, b), b = sb(b);
            ke(a);
            if (13 === a.tag) {
                if (!Sa) throw Error(n(316));
                a = a.memoizedState;
                a = null !== a ? a.dehydrated : null;
                if (!a) throw Error(n(317));
                ee = wb(a);
            } else ee = de ? sb(a.stateNode) : null;
            return !0;
        }
        function oe() {
            Sa && (ee = de = null, fe = !1);
        }
        var pe = q.ReactCurrentOwner, Bc = !1;
        function Q(a, b, c, d) {
            b.child = null === a ? ld(b, null, c, d) : kd(b, a.child, c, d);
        }
        function qe(a, b, c, d, e) {
            c = c.render;
            var f = b.ref;
            Ac(b, e);
            d = Jd(a, b, c, d, f, e);
            if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
            b.effectTag |= 1;
            Q(a, b, d, e);
            return b.child;
        }
        function se(a, b, c, d, e, f) {
            if (null === a) {
                var g = c.type;
                if ("function" === typeof g && !te(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ue(a, b, g, d, e, f);
                a = hd(c.type, null, d, null, b.mode, f);
                a.ref = b.ref;
                a.return = b;
                return b.child = a;
            }
            g = a.child;
            if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : qc, c(e, d) && a.ref === b.ref)) return re(a, b, f);
            b.effectTag |= 1;
            a = fd(g, d);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        function ue(a, b, c, d, e, f) {
            return null !== a && qc(a.memoizedProps, d) && a.ref === b.ref && (Bc = !1, e < f) ? re(a, b, f) : ve(a, b, c, d, f);
        }
        function we(a, b) {
            var c = b.ref;
            if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
        }
        function ve(a, b, c, d, e) {
            var f = C(c) ? Eb : A.current;
            f = Fb(b, f);
            Ac(b, e);
            c = Jd(a, b, c, d, f, e);
            if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
            b.effectTag |= 1;
            Q(a, b, c, e);
            return b.child;
        }
        function xe(a, b, c, d, e) {
            if (C(c)) {
                var f = !0;
                Kb(b);
            } else f = !1;
            Ac(b, e);
            if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Zc(b, c, d), ad(b, c, d, e), d = !0;
            else if (null === a) {
                var g = b.stateNode, l = b.memoizedProps;
                g.props = l;
                var h = g.context, k = c.contextType;
                "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k));
                var p = c.getDerivedStateFromProps, D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate;
                D || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k);
                Dc = !1;
                var x = b.memoizedState;
                h = g.state = x;
                var K = b.updateQueue;
                null !== K && (Nc(b, K, d, g, e), h = b.memoizedState);
                l !== d || x !== h || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), h = b.memoizedState), (l = Dc || Yc(b, c, l, d, x, h, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = h), g.props = d, g.state = h, g.context = k, d = l) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
            } else g = b.stateNode, l = b.memoizedProps, g.props = b.type === b.elementType ? l : rc(b.type, l), h = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k)), p = c.getDerivedStateFromProps, (D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k), Dc = !1, h = b.memoizedState, x = g.state = h, K = b.updateQueue, null !== K && (Nc(b, K, d, g, e), x = b.memoizedState), l !== d || h !== x || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), x = b.memoizedState), (p = Dc || Yc(b, c, l, d, h, x, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = p) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), d = !1);
            return ye(a, b, c, d, f, e);
        }
        function ye(a, b, c, d, e, f) {
            we(a, b);
            var g = 0 !== (b.effectTag & 64);
            if (!d && !g) return e && Lb(b, c, !1), re(a, b, f);
            d = b.stateNode;
            pe.current = b;
            var l = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
            b.effectTag |= 1;
            null !== a && g ? (b.child = kd(b, a.child, null, f), b.child = kd(b, null, l, f)) : Q(a, b, l, f);
            b.memoizedState = d.state;
            e && Lb(b, c, !0);
            return b.child;
        }
        function ze(a) {
            var b = a.stateNode;
            b.pendingContext ? Ib(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ib(a, b.context, !1);
            qd(a, b.containerInfo);
        }
        var Ae = {
            dehydrated: null,
            retryTime: 0
        };
        function Be(a, b, c) {
            var d = b.mode, e = b.pendingProps, f = I.current, g = !1, l;
            (l = 0 !== (b.effectTag & 64)) || (l = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
            l ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
            z(I, f & 1);
            if (null === a) {
                void 0 !== e.fallback && je(b);
                if (g) {
                    g = e.fallback;
                    e = jd(null, d, 0, null);
                    e.return = b;
                    if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
                    c = jd(g, d, c, null);
                    c.return = b;
                    e.sibling = c;
                    b.memoizedState = Ae;
                    b.child = e;
                    return c;
                }
                d = e.children;
                b.memoizedState = null;
                return b.child = ld(b, null, d, c);
            }
            if (null !== a.memoizedState) {
                a = a.child;
                d = a.sibling;
                if (g) {
                    e = e.fallback;
                    c = fd(a, a.pendingProps);
                    c.return = b;
                    if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
                    d = fd(d, e, d.expirationTime);
                    d.return = b;
                    c.sibling = d;
                    c.childExpirationTime = 0;
                    b.memoizedState = Ae;
                    b.child = c;
                    return d;
                }
                c = kd(b, a.child, e.children, c);
                b.memoizedState = null;
                return b.child = c;
            }
            a = a.child;
            if (g) {
                g = e.fallback;
                e = jd(null, d, 0, null);
                e.return = b;
                e.child = a;
                null !== a && (a.return = e);
                if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
                c = jd(g, d, c, null);
                c.return = b;
                e.sibling = c;
                c.effectTag |= 2;
                e.childExpirationTime = 0;
                b.memoizedState = Ae;
                b.child = e;
                return c;
            }
            b.memoizedState = null;
            return b.child = kd(b, a, e.children, c);
        }
        function Ce(a, b) {
            a.expirationTime < b && (a.expirationTime = b);
            var c = a.alternate;
            null !== c && c.expirationTime < b && (c.expirationTime = b);
            zc(a.return, b);
        }
        function De(a, b, c, d, e, f) {
            var g = a.memoizedState;
            null === g ? a.memoizedState = {
                isBackwards: b,
                rendering: null,
                last: d,
                tail: c,
                tailExpiration: 0,
                tailMode: e,
                lastEffect: f
            } : (g.isBackwards = b, g.rendering = null, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
        }
        function Ee(a, b, c) {
            var d = b.pendingProps, e = d.revealOrder, f = d.tail;
            Q(a, b, d.children, c);
            d = I.current;
            if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
            else {
                if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
                    if (13 === a.tag) null !== a.memoizedState && Ce(a, c);
                    else if (19 === a.tag) Ce(a, c);
                    else if (null !== a.child) {
                        a.child.return = a;
                        a = a.child;
                        continue;
                    }
                    if (a === b) break a;
                    for(; null === a.sibling;){
                        if (null === a.return || a.return === b) break a;
                        a = a.return;
                    }
                    a.sibling.return = a.return;
                    a = a.sibling;
                }
                d &= 1;
            }
            z(I, d);
            if (0 === (b.mode & 2)) b.memoizedState = null;
            else switch(e){
                case "forwards":
                    c = b.child;
                    for(e = null; null !== c;)a = c.alternate, null !== a && null === ud(a) && (e = c), c = c.sibling;
                    c = e;
                    null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                    De(b, !1, e, c, f, b.lastEffect);
                    break;
                case "backwards":
                    c = null;
                    e = b.child;
                    for(b.child = null; null !== e;){
                        a = e.alternate;
                        if (null !== a && null === ud(a)) {
                            b.child = e;
                            break;
                        }
                        a = e.sibling;
                        e.sibling = c;
                        c = e;
                        e = a;
                    }
                    De(b, !0, c, null, f, b.lastEffect);
                    break;
                case "together":
                    De(b, !1, null, null, void 0, b.lastEffect);
                    break;
                default:
                    b.memoizedState = null;
            }
            return b.child;
        }
        function re(a, b, c) {
            null !== a && (b.dependencies = a.dependencies);
            var d = b.expirationTime;
            0 !== d && Pc(d);
            if (b.childExpirationTime < c) return null;
            if (null !== a && b.child !== a.child) throw Error(n(153));
            if (null !== b.child) {
                a = b.child;
                c = fd(a, a.pendingProps, a.expirationTime);
                b.child = c;
                for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = fd(a, a.pendingProps, a.expirationTime), c.return = b;
                c.sibling = null;
            }
            return b.child;
        }
        function Fe(a) {
            a.effectTag |= 4;
        }
        var _Ge, He, Ie, Je;
        if (Qa) _Ge = function Ge(a, b) {
            for(var c = b.child; null !== c;){
                if (5 === c.tag || 6 === c.tag) Fa(a, c.stateNode);
                else if (4 !== c.tag && null !== c.child) {
                    c.child.return = c;
                    c = c.child;
                    continue;
                }
                if (c === b) break;
                for(; null === c.sibling;){
                    if (null === c.return || c.return === b) return;
                    c = c.return;
                }
                c.sibling.return = c.return;
                c = c.sibling;
            }
        }, He = function He() {}, Ie = function Ie(a, b, c, d, e) {
            a = a.memoizedProps;
            if (a !== d) {
                var f = b.stateNode, g = pd(H.current);
                c = Ia(f, c, a, d, e, g);
                (b.updateQueue = c) && Fe(b);
            }
        }, Je = function Je(a, b, c, d) {
            c !== d && Fe(b);
        };
        else if (Ra) {
            _Ge = function Ge(a, b, c, d) {
                for(var e = b.child; null !== e;){
                    if (5 === e.tag) {
                        var f = e.stateNode;
                        c && d && (f = mb(f, e.type, e.memoizedProps, e));
                        Fa(a, f);
                    } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), Fa(a, f);
                    else if (4 !== e.tag) {
                        if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                            var g = e.child;
                            if (null !== g && (null !== g.child && (g.child.return = g, _Ge(a, g, !0, f)), f = g.sibling, null !== f)) {
                                f.return = e;
                                e = f;
                                continue;
                            }
                        }
                        if (null !== e.child) {
                            e.child.return = e;
                            e = e.child;
                            continue;
                        }
                    }
                    if (e === b) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === b) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            };
            var Ke = function Ke(a, b, c, d) {
                for(var e = b.child; null !== e;){
                    if (5 === e.tag) {
                        var f = e.stateNode;
                        c && d && (f = mb(f, e.type, e.memoizedProps, e));
                        ib(a, f);
                    } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), ib(a, f);
                    else if (4 !== e.tag) {
                        if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                            var g = e.child;
                            if (null !== g && (null !== g.child && (g.child.return = g, Ke(a, g, !0, f)), f = g.sibling, null !== f)) {
                                f.return = e;
                                e = f;
                                continue;
                            }
                        }
                        if (null !== e.child) {
                            e.child.return = e;
                            e = e.child;
                            continue;
                        }
                    }
                    if (e === b) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === b) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            };
            He = function He(a) {
                var b = a.stateNode;
                if (null !== a.firstEffect) {
                    var c = b.containerInfo, d = hb(c);
                    Ke(d, a, !1, !1);
                    b.pendingChildren = d;
                    Fe(a);
                    kb(c, d);
                }
            };
            Ie = function Ie(a, b, c, d, e) {
                var f = a.stateNode, g = a.memoizedProps;
                if ((a = null === b.firstEffect) && g === d) b.stateNode = f;
                else {
                    var l = b.stateNode, h = pd(H.current), k = null;
                    g !== d && (k = Ia(l, c, g, d, e, h));
                    a && null === k ? b.stateNode = f : (f = gb(f, k, c, g, d, b, a, l), Ga(f, c, d, e, h) && Fe(b), b.stateNode = f, a ? Fe(b) : _Ge(f, b, !1, !1));
                }
            };
            Je = function Je(a, b, c, d) {
                c !== d && (a = pd(od.current), c = pd(H.current), b.stateNode = La(d, a, c, b), Fe(b));
            };
        } else He = function He() {}, Ie = function Ie() {}, Je = function Je() {};
        function Le(a, b) {
            switch(a.tailMode){
                case "hidden":
                    b = a.tail;
                    for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                    null === c ? a.tail = null : c.sibling = null;
                    break;
                case "collapsed":
                    c = a.tail;
                    for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                    null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
            }
        }
        function Me(a) {
            switch(a.tag){
                case 1:
                    C(a.type) && Gb();
                    var b = a.effectTag;
                    return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
                case 3:
                    rd();
                    Hb();
                    b = a.effectTag;
                    if (0 !== (b & 64)) throw Error(n(285));
                    a.effectTag = b & -4097 | 64;
                    return a;
                case 5:
                    return td(a), null;
                case 13:
                    return y(I), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
                case 19:
                    return y(I), null;
                case 4:
                    return rd(), null;
                case 10:
                    return yc(a), null;
                default:
                    return null;
            }
        }
        function Ne(a, b) {
            return {
                value: a,
                source: b,
                stack: Ab(b)
            };
        }
        var Oe = "function" === typeof WeakSet ? WeakSet : Set;
        function Pe(a, b) {
            var c = b.source, d = b.stack;
            null === d && null !== c && (d = Ab(c));
            null !== c && ta(c.type);
            b = b.value;
            null !== a && 1 === a.tag && ta(a.type);
            try {
                console.error(b);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                });
            }
        }
        function Qe(a, b) {
            try {
                b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
            } catch (c) {
                Re(a, c);
            }
        }
        function Se(a) {
            var b = a.ref;
            if (null !== b) {
                if ("function" === typeof b) try {
                    b(null);
                } catch (c) {
                    Re(a, c);
                }
                else b.current = null;
            }
        }
        function Te(a, b) {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    Ue(2, 0, b);
                    break;
                case 1:
                    if (b.effectTag & 256 && null !== a) {
                        var c = a.memoizedProps, d = a.memoizedState;
                        a = b.stateNode;
                        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : rc(b.type, c), d);
                        a.__reactInternalSnapshotBeforeUpdate = b;
                    }
                    break;
                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(n(163));
            }
        }
        function Ue(a, b, c) {
            c = c.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do {
                    if (0 !== (d.tag & a)) {
                        var e = d.destroy;
                        d.destroy = void 0;
                        void 0 !== e && e();
                    }
                    0 !== (d.tag & b) && (e = d.create, d.destroy = e());
                    d = d.next;
                }while (d !== c);
            }
        }
        function Ve(a, b, c) {
            "function" === typeof We && We(b);
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    a = b.updateQueue;
                    if (null !== a && (a = a.lastEffect, null !== a)) {
                        var d = a.next;
                        hc(97 < c ? 97 : c, function() {
                            var a = d;
                            do {
                                var c = a.destroy;
                                if (void 0 !== c) {
                                    var g = b;
                                    try {
                                        c();
                                    } catch (l) {
                                        Re(g, l);
                                    }
                                }
                                a = a.next;
                            }while (a !== d);
                        });
                    }
                    break;
                case 1:
                    Se(b);
                    c = b.stateNode;
                    "function" === typeof c.componentWillUnmount && Qe(b, c);
                    break;
                case 5:
                    Se(b);
                    break;
                case 4:
                    Qa ? Xe(a, b, c) : Ra && Ye(b);
            }
        }
        function Ze(a, b, c) {
            for(var d = b;;)if (Ve(a, d, c), null === d.child || Qa && 4 === d.tag) {
                if (d === b) break;
                for(; null === d.sibling;){
                    if (null === d.return || d.return === b) return;
                    d = d.return;
                }
                d.sibling.return = d.return;
                d = d.sibling;
            } else d.child.return = d, d = d.child;
        }
        function $e(a) {
            var b = a.alternate;
            a.return = null;
            a.child = null;
            a.memoizedState = null;
            a.updateQueue = null;
            a.dependencies = null;
            a.alternate = null;
            a.firstEffect = null;
            a.lastEffect = null;
            a.pendingProps = null;
            a.memoizedProps = null;
            null !== b && $e(b);
        }
        function Ye(a) {
            if (Ra) {
                a = a.stateNode.containerInfo;
                var b = hb(a);
                lb(a, b);
            }
        }
        function af(a) {
            return 5 === a.tag || 3 === a.tag || 4 === a.tag;
        }
        function bf(a) {
            if (Qa) {
                a: {
                    for(var b = a.return; null !== b;){
                        if (af(b)) {
                            var c = b;
                            break a;
                        }
                        b = b.return;
                    }
                    throw Error(n(160));
                }
                b = c.stateNode;
                switch(c.tag){
                    case 5:
                        var d = !1;
                        break;
                    case 3:
                        b = b.containerInfo;
                        d = !0;
                        break;
                    case 4:
                        b = b.containerInfo;
                        d = !0;
                        break;
                    default:
                        throw Error(n(161));
                }
                c.effectTag & 16 && (bb(b), c.effectTag &= -17);
                a: b: for(c = a;;){
                    for(; null === c.sibling;){
                        if (null === c.return || af(c.return)) {
                            c = null;
                            break a;
                        }
                        c = c.return;
                    }
                    c.sibling.return = c.return;
                    for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
                        if (c.effectTag & 2) continue b;
                        if (null === c.child || 4 === c.tag) continue b;
                        else c.child.return = c, c = c.child;
                    }
                    if (!(c.effectTag & 2)) {
                        c = c.stateNode;
                        break a;
                    }
                }
                for(var e = a;;){
                    var f = 5 === e.tag || 6 === e.tag;
                    if (f) f = f ? e.stateNode : e.stateNode.instance, c ? d ? Za(b, f, c) : Ya(b, f, c) : d ? Ua(b, f) : Ta(b, f);
                    else if (4 !== e.tag && null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                    if (e === a) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === a) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            }
        }
        function Xe(a, b, c) {
            for(var d = b, e = !1, f, g;;){
                if (!e) {
                    e = d.return;
                    a: for(;;){
                        if (null === e) throw Error(n(160));
                        f = e.stateNode;
                        switch(e.tag){
                            case 5:
                                g = !1;
                                break a;
                            case 3:
                                f = f.containerInfo;
                                g = !0;
                                break a;
                            case 4:
                                f = f.containerInfo;
                                g = !0;
                                break a;
                        }
                        e = e.return;
                    }
                    e = !0;
                }
                if (5 === d.tag || 6 === d.tag) Ze(a, d, c), g ? ab(f, d.stateNode) : $a(f, d.stateNode);
                else if (4 === d.tag) {
                    if (null !== d.child) {
                        f = d.stateNode.containerInfo;
                        g = !0;
                        d.child.return = d;
                        d = d.child;
                        continue;
                    }
                } else if (Ve(a, d, c), null !== d.child) {
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
                if (d === b) break;
                for(; null === d.sibling;){
                    if (null === d.return || d.return === b) return;
                    d = d.return;
                    4 === d.tag && (e = !1);
                }
                d.sibling.return = d.return;
                d = d.sibling;
            }
        }
        function cf(a, b) {
            if (Qa) switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Ue(4, 8, b);
                    break;
                case 1:
                    break;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && Xa(c, f, e, a, d, b);
                    }
                    break;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    Va(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    break;
                case 3:
                    Sa && (b = b.stateNode, b.hydrate && (b.hydrate = !1, xb(b.containerInfo)));
                    break;
                case 12:
                    break;
                case 13:
                    df(b);
                    ef(b);
                    break;
                case 19:
                    ef(b);
                    break;
                case 17:
                    break;
                case 20:
                    break;
                case 21:
                    break;
                default:
                    throw Error(n(163));
            }
            else {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Ue(4, 8, b);
                        return;
                    case 12:
                        return;
                    case 13:
                        df(b);
                        ef(b);
                        return;
                    case 19:
                        ef(b);
                        return;
                    case 3:
                        Sa && (c = b.stateNode, c.hydrate && (c.hydrate = !1, xb(c.containerInfo)));
                }
                a: if (Ra) switch(b.tag){
                    case 1:
                    case 5:
                    case 6:
                    case 20:
                        break a;
                    case 3:
                    case 4:
                        b = b.stateNode;
                        lb(b.containerInfo, b.pendingChildren);
                        break a;
                    default:
                        throw Error(n(163));
                }
            }
        }
        function df(a) {
            var b = a;
            if (null === a.memoizedState) var c = !1;
            else c = !0, b = a.child, ff = E();
            if (Qa && null !== b) {
                a: if (a = b, Qa) for(b = a;;){
                    if (5 === b.tag) {
                        var d = b.stateNode;
                        c ? cb(d) : eb(b.stateNode, b.memoizedProps);
                    } else if (6 === b.tag) d = b.stateNode, c ? db(d) : fb(d, b.memoizedProps);
                    else if (13 === b.tag && null !== b.memoizedState && null === b.memoizedState.dehydrated) {
                        d = b.child.sibling;
                        d.return = b;
                        b = d;
                        continue;
                    } else if (null !== b.child) {
                        b.child.return = b;
                        b = b.child;
                        continue;
                    }
                    if (b === a) break a;
                    for(; null === b.sibling;){
                        if (null === b.return || b.return === a) break a;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
        }
        function ef(a) {
            var b = a.updateQueue;
            if (null !== b) {
                a.updateQueue = null;
                var c = a.stateNode;
                null === c && (c = a.stateNode = new Oe());
                b.forEach(function(b) {
                    var d = gf.bind(null, a, b);
                    c.has(b) || (c.add(b), b.then(d, d));
                });
            }
        }
        var hf = "function" === typeof WeakMap ? WeakMap : Map;
        function jf(a, b, c) {
            c = Gc(c, null);
            c.tag = 3;
            c.payload = {
                element: null
            };
            var d = b.value;
            c.callback = function() {
                kf || (kf = !0, lf = d);
                Pe(a, b);
            };
            return c;
        }
        function mf(a, b, c) {
            c = Gc(c, null);
            c.tag = 3;
            var d = a.type.getDerivedStateFromError;
            if ("function" === typeof d) {
                var e = b.value;
                c.payload = function() {
                    Pe(a, b);
                    return d(e);
                };
            }
            var f = a.stateNode;
            null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
                "function" !== typeof d && (null === nf ? nf = new Set([
                    this
                ]) : nf.add(this), Pe(a, b));
                var c = b.stack;
                this.componentDidCatch(b.value, {
                    componentStack: null !== c ? c : ""
                });
            });
            return c;
        }
        var of = Math.ceil, pf = q.ReactCurrentDispatcher, qf = q.ReactCurrentOwner, R = 0, rf = 8, S = 16, sf = 32, tf = 0, uf = 1, vf = 2, wf = 3, xf = 4, yf = 5, T = R, U = null, V = null, W = 0, X = tf, zf = null, Af = 1073741823, Bf = 1073741823, Cf = null, Df = 0, Ef = !1, ff = 0, Ff = 500, Y = null, kf = !1, lf = null, nf = null, Gf = !1, Hf = null, If = 90, Jf = null, Kf = 0, Lf = null, Mf = 0;
        function G() {
            return (T & (S | sf)) !== R ? 1073741821 - (E() / 10 | 0) : 0 !== Mf ? Mf : Mf = 1073741821 - (E() / 10 | 0);
        }
        function Vc(a, b, c) {
            b = b.mode;
            if (0 === (b & 2)) return 1073741823;
            var d = fc();
            if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
            if ((T & S) !== R) return W;
            if (null !== c) a = mc(a, c.timeoutMs | 0 || 5E3, 250);
            else switch(d){
                case 99:
                    a = 1073741823;
                    break;
                case 98:
                    a = mc(a, 150, 100);
                    break;
                case 97:
                case 96:
                    a = mc(a, 5E3, 250);
                    break;
                case 95:
                    a = 2;
                    break;
                default:
                    throw Error(n(326));
            }
            null !== U && a === W && --a;
            return a;
        }
        function Wc(a, b) {
            if (50 < Kf) throw Kf = 0, Lf = null, Error(n(185));
            a = Nf(a, b);
            if (null !== a) {
                var c = fc();
                1073741823 === b ? (T & rf) !== R && (T & (S | sf)) === R ? Of(a) : (Z(a), T === R && F()) : Z(a);
                (T & 4) === R || 98 !== c && 99 !== c || (null === Jf ? Jf = new Map([
                    [
                        a,
                        b
                    ]
                ]) : (c = Jf.get(a), (void 0 === c || c > b) && Jf.set(a, b)));
            }
        }
        function Nf(a, b) {
            a.expirationTime < b && (a.expirationTime = b);
            var c = a.alternate;
            null !== c && c.expirationTime < b && (c.expirationTime = b);
            var d = a.return, e = null;
            if (null === d && 3 === a.tag) e = a.stateNode;
            else for(; null !== d;){
                c = d.alternate;
                d.childExpirationTime < b && (d.childExpirationTime = b);
                null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
                if (null === d.return && 3 === d.tag) {
                    e = d.stateNode;
                    break;
                }
                d = d.return;
            }
            null !== e && (U === e && (Pc(b), X === xf && Pf(e, W)), Qf(e, b));
            return e;
        }
        function Rf(a) {
            var b = a.lastExpiredTime;
            if (0 !== b) return b;
            b = a.firstPendingTime;
            if (!Sf(a, b)) return b;
            b = a.lastPingedTime;
            a = a.nextKnownPendingLevel;
            return b > a ? b : a;
        }
        function Z(a) {
            if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = jc(Of.bind(null, a));
            else {
                var b = Rf(a), c = a.callbackNode;
                if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
                else {
                    var d = G();
                    1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
                    if (null !== c) {
                        var e = a.callbackPriority;
                        if (a.callbackExpirationTime === b && e >= d) return;
                        c !== $b && Ob(c);
                    }
                    a.callbackExpirationTime = b;
                    a.callbackPriority = d;
                    b = 1073741823 === b ? jc(Of.bind(null, a)) : ic(d, Tf.bind(null, a), {
                        timeout: 10 * (1073741821 - b) - E()
                    });
                    a.callbackNode = b;
                }
            }
        }
        function Tf(a, b) {
            Mf = 0;
            if (b) return b = G(), Uf(a, b), Z(a), null;
            var c = Rf(a);
            if (0 !== c) {
                b = a.callbackNode;
                if ((T & (S | sf)) !== R) throw Error(n(327));
                Vf();
                a === U && c === W || Wf(a, c);
                if (null !== V) {
                    var d = T;
                    T |= S;
                    var e = Xf();
                    for(;;)try {
                        Yf();
                        break;
                    } catch (l) {
                        Zf(a, l);
                    }
                    wc();
                    T = d;
                    pf.current = e;
                    if (X === uf) throw b = zf, Wf(a, c), Pf(a, c), Z(a), b;
                    if (null === V) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = X, U = null, d){
                        case tf:
                        case uf:
                            throw Error(n(345));
                        case vf:
                            Uf(a, 2 < c ? 2 : c);
                            break;
                        case wf:
                            Pf(a, c);
                            d = a.lastSuspendedTime;
                            c === d && (a.nextKnownPendingLevel = $f(e));
                            if (1073741823 === Af && (e = ff + Ff - E(), 10 < e)) {
                                if (Ef) {
                                    var f = a.lastPingedTime;
                                    if (0 === f || f >= c) {
                                        a.lastPingedTime = c;
                                        Wf(a, c);
                                        break;
                                    }
                                }
                                f = Rf(a);
                                if (0 !== f && f !== c) break;
                                if (0 !== d && d !== c) {
                                    a.lastPingedTime = d;
                                    break;
                                }
                                a.timeoutHandle = Ma(ag.bind(null, a), e);
                                break;
                            }
                            ag(a);
                            break;
                        case xf:
                            Pf(a, c);
                            d = a.lastSuspendedTime;
                            c === d && (a.nextKnownPendingLevel = $f(e));
                            if (Ef && (e = a.lastPingedTime, 0 === e || e >= c)) {
                                a.lastPingedTime = c;
                                Wf(a, c);
                                break;
                            }
                            e = Rf(a);
                            if (0 !== e && e !== c) break;
                            if (0 !== d && d !== c) {
                                a.lastPingedTime = d;
                                break;
                            }
                            1073741823 !== Bf ? d = 10 * (1073741821 - Bf) - E() : 1073741823 === Af ? d = 0 : (d = 10 * (1073741821 - Af) - 5E3, e = E(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * of(d / 1960)) - d, c < d && (d = c));
                            if (10 < d) {
                                a.timeoutHandle = Ma(ag.bind(null, a), d);
                                break;
                            }
                            ag(a);
                            break;
                        case yf:
                            if (1073741823 !== Af && null !== Cf) {
                                f = Af;
                                var g = Cf;
                                d = g.busyMinDurationMs | 0;
                                0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = E() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                                if (10 < d) {
                                    Pf(a, c);
                                    a.timeoutHandle = Ma(ag.bind(null, a), d);
                                    break;
                                }
                            }
                            ag(a);
                            break;
                        default:
                            throw Error(n(329));
                    }
                    Z(a);
                    if (a.callbackNode === b) return Tf.bind(null, a);
                }
            }
            return null;
        }
        function Of(a) {
            var b = a.lastExpiredTime;
            b = 0 !== b ? b : 1073741823;
            if (a.finishedExpirationTime === b) ag(a);
            else {
                if ((T & (S | sf)) !== R) throw Error(n(327));
                Vf();
                a === U && b === W || Wf(a, b);
                if (null !== V) {
                    var c = T;
                    T |= S;
                    var d = Xf();
                    for(;;)try {
                        bg();
                        break;
                    } catch (e) {
                        Zf(a, e);
                    }
                    wc();
                    T = c;
                    pf.current = d;
                    if (X === uf) throw c = zf, Wf(a, b), Pf(a, b), Z(a), c;
                    if (null !== V) throw Error(n(261));
                    a.finishedWork = a.current.alternate;
                    a.finishedExpirationTime = b;
                    U = null;
                    ag(a);
                    Z(a);
                }
            }
            return null;
        }
        function cg(a, b) {
            Uf(a, b);
            Z(a);
            (T & (S | sf)) === R && F();
        }
        function dg() {
            if (null !== Jf) {
                var a = Jf;
                Jf = null;
                a.forEach(function(a, c) {
                    Uf(c, a);
                    Z(c);
                });
                F();
            }
        }
        function eg(a, b) {
            if ((T & (S | sf)) !== R) throw Error(n(187));
            var c = T;
            T |= 1;
            try {
                return hc(99, a.bind(null, b));
            } finally{
                T = c, F();
            }
        }
        function Wf(a, b) {
            a.finishedWork = null;
            a.finishedExpirationTime = 0;
            var c = a.timeoutHandle;
            c !== Oa && (a.timeoutHandle = Oa, Na(c));
            if (null !== V) for(c = V.return; null !== c;){
                var d = c;
                switch(d.tag){
                    case 1:
                        var e = d.type.childContextTypes;
                        null !== e && void 0 !== e && Gb();
                        break;
                    case 3:
                        rd();
                        Hb();
                        break;
                    case 5:
                        td(d);
                        break;
                    case 4:
                        rd();
                        break;
                    case 13:
                        y(I);
                        break;
                    case 19:
                        y(I);
                        break;
                    case 10:
                        yc(d);
                }
                c = c.return;
            }
            U = a;
            V = fd(a.current, null);
            W = b;
            X = tf;
            zf = null;
            Bf = Af = 1073741823;
            Cf = null;
            Df = 0;
            Ef = !1;
        }
        function Zf(a, b) {
            do {
                try {
                    wc();
                    Nd();
                    if (null === V || null === V.return) return X = uf, zf = b, null;
                    a: {
                        var c = a, d = V.return, e = V, f = b;
                        b = W;
                        e.effectTag |= 2048;
                        e.firstEffect = e.lastEffect = null;
                        if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                            var g = f, l = 0 !== (I.current & 1), h = d;
                            do {
                                var k;
                                if (k = 13 === h.tag) {
                                    var p = h.memoizedState;
                                    if (null !== p) k = null !== p.dehydrated ? !0 : !1;
                                    else {
                                        var D = h.memoizedProps;
                                        k = void 0 === D.fallback ? !1 : !0 !== D.unstable_avoidThisFallback ? !0 : l ? !1 : !0;
                                    }
                                }
                                if (k) {
                                    var x = h.updateQueue;
                                    if (null === x) {
                                        var K = new Set();
                                        K.add(g);
                                        h.updateQueue = K;
                                    } else x.add(g);
                                    if (0 === (h.mode & 2)) {
                                        h.effectTag |= 64;
                                        e.effectTag &= -2981;
                                        if (1 === e.tag) {
                                            if (null === e.alternate) e.tag = 17;
                                            else {
                                                var Ha = Gc(1073741823, null);
                                                Ha.tag = 2;
                                                Ic(e, Ha);
                                            }
                                        }
                                        e.expirationTime = 1073741823;
                                        break a;
                                    }
                                    f = void 0;
                                    e = b;
                                    var O = c.pingCache;
                                    null === O ? (O = c.pingCache = new hf(), f = new Set(), O.set(g, f)) : (f = O.get(g), void 0 === f && (f = new Set(), O.set(g, f)));
                                    if (!f.has(e)) {
                                        f.add(e);
                                        var w = fg.bind(null, c, g, e);
                                        g.then(w, w);
                                    }
                                    h.effectTag |= 4096;
                                    h.expirationTime = b;
                                    break a;
                                }
                                h = h.return;
                            }while (null !== h);
                            f = Error((ta(e.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Ab(e));
                        }
                        X !== yf && (X = vf);
                        f = Ne(f, e);
                        h = d;
                        do {
                            switch(h.tag){
                                case 3:
                                    g = f;
                                    h.effectTag |= 4096;
                                    h.expirationTime = b;
                                    var r = jf(h, g, b);
                                    Jc(h, r);
                                    break a;
                                case 1:
                                    g = f;
                                    var t = h.type, N = h.stateNode;
                                    if (0 === (h.effectTag & 64) && ("function" === typeof t.getDerivedStateFromError || null !== N && "function" === typeof N.componentDidCatch && (null === nf || !nf.has(N)))) {
                                        h.effectTag |= 4096;
                                        h.expirationTime = b;
                                        var Mc = mf(h, g, b);
                                        Jc(h, Mc);
                                        break a;
                                    }
                            }
                            h = h.return;
                        }while (null !== h);
                    }
                    V = gg(V);
                } catch (Rb) {
                    b = Rb;
                    continue;
                }
                break;
            }while (1);
        }
        function Xf() {
            var a = pf.current;
            pf.current = Md;
            return null === a ? Md : a;
        }
        function Oc(a, b) {
            a < Af && 2 < a && (Af = a);
            null !== b && a < Bf && 2 < a && (Bf = a, Cf = b);
        }
        function Pc(a) {
            a > Df && (Df = a);
        }
        function bg() {
            for(; null !== V;)V = hg(V);
        }
        function Yf() {
            for(; null !== V && !Pb();)V = hg(V);
        }
        function hg(a) {
            var b = ig(a.alternate, a, W);
            a.memoizedProps = a.pendingProps;
            null === b && (b = gg(a));
            qf.current = null;
            return b;
        }
        function gg(a) {
            V = a;
            do {
                var b = V.alternate;
                a = V.return;
                if (0 === (V.effectTag & 2048)) {
                    a: {
                        var c = b;
                        b = V;
                        var d = W, e = b.pendingProps;
                        switch(b.tag){
                            case 2:
                                break;
                            case 16:
                                break;
                            case 15:
                            case 0:
                                break;
                            case 1:
                                C(b.type) && Gb();
                                break;
                            case 3:
                                rd();
                                Hb();
                                e = b.stateNode;
                                e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null);
                                (null === c || null === c.child) && ne(b) && Fe(b);
                                He(b);
                                break;
                            case 5:
                                td(b);
                                var f = pd(od.current);
                                d = b.type;
                                if (null !== c && null != b.stateNode) Ie(c, b, d, e, f), c.ref !== b.ref && (b.effectTag |= 128);
                                else if (e) {
                                    c = pd(H.current);
                                    if (ne(b)) {
                                        e = b;
                                        if (!Sa) throw Error(n(175));
                                        c = ub(e.stateNode, e.type, e.memoizedProps, f, c, e);
                                        e.updateQueue = c;
                                        c = null !== c ? !0 : !1;
                                        c && Fe(b);
                                    } else {
                                        var g = Ea(d, e, f, c, b);
                                        _Ge(g, b, !1, !1);
                                        b.stateNode = g;
                                        Ga(g, d, e, f, c) && Fe(b);
                                    }
                                    null !== b.ref && (b.effectTag |= 128);
                                } else if (null === b.stateNode) throw Error(n(166));
                                break;
                            case 6:
                                if (c && null != b.stateNode) Je(c, b, c.memoizedProps, e);
                                else {
                                    if ("string" !== typeof e && null === b.stateNode) throw Error(n(166));
                                    c = pd(od.current);
                                    f = pd(H.current);
                                    if (ne(b)) {
                                        c = b;
                                        if (!Sa) throw Error(n(176));
                                        (c = vb(c.stateNode, c.memoizedProps, c)) && Fe(b);
                                    } else b.stateNode = La(e, c, f, b);
                                }
                                break;
                            case 11:
                                break;
                            case 13:
                                y(I);
                                e = b.memoizedState;
                                if (0 !== (b.effectTag & 64)) {
                                    b.expirationTime = d;
                                    break a;
                                }
                                e = null !== e;
                                f = !1;
                                null === c ? void 0 !== b.memoizedProps.fallback && ne(b) : (d = c.memoizedState, f = null !== d, e || null === d || (d = c.child.sibling, null !== d && (g = b.firstEffect, null !== g ? (b.firstEffect = d, d.nextEffect = g) : (b.firstEffect = b.lastEffect = d, d.nextEffect = null), d.effectTag = 8)));
                                if (e && !f && 0 !== (b.mode & 2)) {
                                    if (null === c && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (I.current & 1)) X === tf && (X = wf);
                                    else {
                                        if (X === tf || X === wf) X = xf;
                                        0 !== Df && null !== U && (Pf(U, W), Qf(U, Df));
                                    }
                                }
                                Ra && e && (b.effectTag |= 4);
                                Qa && (e || f) && (b.effectTag |= 4);
                                break;
                            case 7:
                                break;
                            case 8:
                                break;
                            case 12:
                                break;
                            case 4:
                                rd();
                                He(b);
                                break;
                            case 10:
                                yc(b);
                                break;
                            case 9:
                                break;
                            case 14:
                                break;
                            case 17:
                                C(b.type) && Gb();
                                break;
                            case 19:
                                y(I);
                                e = b.memoizedState;
                                if (null === e) break;
                                f = 0 !== (b.effectTag & 64);
                                g = e.rendering;
                                if (null === g) {
                                    if (f) Le(e, !1);
                                    else {
                                        if (X !== tf || null !== c && 0 !== (c.effectTag & 64)) for(c = b.child; null !== c;){
                                            g = ud(c);
                                            if (null !== g) {
                                                b.effectTag |= 64;
                                                Le(e, !1);
                                                c = g.updateQueue;
                                                null !== c && (b.updateQueue = c, b.effectTag |= 4);
                                                null === e.lastEffect && (b.firstEffect = null);
                                                b.lastEffect = e.lastEffect;
                                                c = d;
                                                for(e = b.child; null !== e;)f = e, d = c, f.effectTag &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childExpirationTime = 0, f.expirationTime = d, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null) : (f.childExpirationTime = g.childExpirationTime, f.expirationTime = g.expirationTime, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, d = g.dependencies, f.dependencies = null === d ? null : {
                                                    expirationTime: d.expirationTime,
                                                    firstContext: d.firstContext,
                                                    responders: d.responders
                                                }), e = e.sibling;
                                                z(I, I.current & 1 | 2);
                                                b = b.child;
                                                break a;
                                            }
                                            c = c.sibling;
                                        }
                                    }
                                } else {
                                    if (!f) {
                                        if (c = ud(g), null !== c) {
                                            if (b.effectTag |= 64, f = !0, c = c.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), Le(e, !0), null === e.tail && "hidden" === e.tailMode) {
                                                b = b.lastEffect = e.lastEffect;
                                                null !== b && (b.nextEffect = null);
                                                break;
                                            }
                                        } else E() > e.tailExpiration && 1 < d && (b.effectTag |= 64, f = !0, Le(e, !1), b.expirationTime = b.childExpirationTime = d - 1);
                                    }
                                    e.isBackwards ? (g.sibling = b.child, b.child = g) : (c = e.last, null !== c ? c.sibling = g : b.child = g, e.last = g);
                                }
                                if (null !== e.tail) {
                                    0 === e.tailExpiration && (e.tailExpiration = E() + 500);
                                    c = e.tail;
                                    e.rendering = c;
                                    e.tail = c.sibling;
                                    e.lastEffect = b.lastEffect;
                                    c.sibling = null;
                                    e = I.current;
                                    e = f ? e & 1 | 2 : e & 1;
                                    z(I, e);
                                    b = c;
                                    break a;
                                }
                                break;
                            case 20:
                                break;
                            case 21:
                                break;
                            default:
                                throw Error(n(156, b.tag));
                        }
                        b = null;
                    }
                    c = V;
                    if (1 === W || 1 !== c.childExpirationTime) {
                        e = 0;
                        for(f = c.child; null !== f;)d = f.expirationTime, g = f.childExpirationTime, d > e && (e = d), g > e && (e = g), f = f.sibling;
                        c.childExpirationTime = e;
                    }
                    if (null !== b) return b;
                    null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = V.firstEffect), null !== V.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = V.firstEffect), a.lastEffect = V.lastEffect), 1 < V.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = V : a.firstEffect = V, a.lastEffect = V));
                } else {
                    b = Me(V);
                    if (null !== b) return b.effectTag &= 2047, b;
                    null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
                }
                b = V.sibling;
                if (null !== b) return b;
                V = a;
            }while (null !== V);
            X === tf && (X = yf);
            return null;
        }
        function $f(a) {
            var b = a.expirationTime;
            a = a.childExpirationTime;
            return b > a ? b : a;
        }
        function ag(a) {
            var b = fc();
            hc(99, jg.bind(null, a, b));
            return null;
        }
        function jg(a, b) {
            Vf();
            if ((T & (S | sf)) !== R) throw Error(n(327));
            var c = a.finishedWork, d = a.finishedExpirationTime;
            if (null === c) return null;
            a.finishedWork = null;
            a.finishedExpirationTime = 0;
            if (c === a.current) throw Error(n(177));
            a.callbackNode = null;
            a.callbackExpirationTime = 0;
            a.callbackPriority = 90;
            a.nextKnownPendingLevel = 0;
            var e = $f(c);
            a.firstPendingTime = e;
            d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
            d <= a.lastPingedTime && (a.lastPingedTime = 0);
            d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
            a === U && (V = U = null, W = 0);
            1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
            if (null !== e) {
                var f = T;
                T |= sf;
                qf.current = null;
                Ca(a.containerInfo);
                Y = e;
                do try {
                    kg();
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Y = e;
                do try {
                    for(var g = a, l = b; null !== Y;){
                        var h = Y.effectTag;
                        h & 16 && Qa && bb(Y.stateNode);
                        if (h & 128) {
                            var k = Y.alternate;
                            if (null !== k) {
                                var p = k.ref;
                                null !== p && ("function" === typeof p ? p(null) : p.current = null);
                            }
                        }
                        switch(h & 1038){
                            case 2:
                                bf(Y);
                                Y.effectTag &= -3;
                                break;
                            case 6:
                                bf(Y);
                                Y.effectTag &= -3;
                                cf(Y.alternate, Y);
                                break;
                            case 1024:
                                Y.effectTag &= -1025;
                                break;
                            case 1028:
                                Y.effectTag &= -1025;
                                cf(Y.alternate, Y);
                                break;
                            case 4:
                                cf(Y.alternate, Y);
                                break;
                            case 8:
                                var D = g, x = Y, K = l;
                                Qa ? Xe(D, x, K) : Ze(D, x, K);
                                $e(x);
                        }
                        Y = Y.nextEffect;
                    }
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Da(a.containerInfo);
                a.current = c;
                Y = e;
                do try {
                    for(h = d; null !== Y;){
                        var Ha = Y.effectTag;
                        if (Ha & 36) {
                            var O = Y.alternate;
                            k = Y;
                            p = h;
                            switch(k.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Ue(16, 32, k);
                                    break;
                                case 1:
                                    var w = k.stateNode;
                                    if (k.effectTag & 4) {
                                        if (null === O) w.componentDidMount();
                                        else {
                                            var r = k.elementType === k.type ? O.memoizedProps : rc(k.type, O.memoizedProps);
                                            w.componentDidUpdate(r, O.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                                        }
                                    }
                                    var t = k.updateQueue;
                                    null !== t && Qc(k, t, w, p);
                                    break;
                                case 3:
                                    var N = k.updateQueue;
                                    if (null !== N) {
                                        g = null;
                                        if (null !== k.child) switch(k.child.tag){
                                            case 5:
                                                g = za(k.child.stateNode);
                                                break;
                                            case 1:
                                                g = k.child.stateNode;
                                        }
                                        Qc(k, N, g, p);
                                    }
                                    break;
                                case 5:
                                    var Mc = k.stateNode;
                                    null === O && k.effectTag & 4 && Wa(Mc, k.type, k.memoizedProps, k);
                                    break;
                                case 6:
                                    break;
                                case 4:
                                    break;
                                case 12:
                                    break;
                                case 13:
                                    if (Sa && null === k.memoizedState) {
                                        var Rb = k.alternate;
                                        if (null !== Rb) {
                                            var le = Rb.memoizedState;
                                            if (null !== le) {
                                                var me = le.dehydrated;
                                                null !== me && yb(me);
                                            }
                                        }
                                    }
                                    break;
                                case 19:
                                case 17:
                                case 20:
                                case 21:
                                    break;
                                default:
                                    throw Error(n(163));
                            }
                        }
                        if (Ha & 128) {
                            k = void 0;
                            var Sb = Y.ref;
                            if (null !== Sb) {
                                var v = Y.stateNode;
                                switch(Y.tag){
                                    case 5:
                                        k = za(v);
                                        break;
                                    default:
                                        k = v;
                                }
                                "function" === typeof Sb ? Sb(k) : Sb.current = k;
                            }
                        }
                        Y = Y.nextEffect;
                    }
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Y = null;
                ac();
                T = f;
            } else a.current = c;
            if (Gf) Gf = !1, Hf = a, If = b;
            else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
            b = a.firstPendingTime;
            0 === b && (nf = null);
            1073741823 === b ? a === Lf ? Kf++ : (Kf = 0, Lf = a) : Kf = 0;
            "function" === typeof lg && lg(c.stateNode, d);
            Z(a);
            if (kf) throw kf = !1, a = lf, lf = null, a;
            if ((T & rf) !== R) return null;
            F();
            return null;
        }
        function kg() {
            for(; null !== Y;){
                var a = Y.effectTag;
                0 !== (a & 256) && Te(Y.alternate, Y);
                0 === (a & 512) || Gf || (Gf = !0, ic(97, function() {
                    Vf();
                    return null;
                }));
                Y = Y.nextEffect;
            }
        }
        function Vf() {
            if (90 !== If) {
                var a = 97 < If ? 97 : If;
                If = 90;
                return hc(a, mg);
            }
        }
        function mg() {
            if (null === Hf) return !1;
            var a = Hf;
            Hf = null;
            if ((T & (S | sf)) !== R) throw Error(n(331));
            var b = T;
            T |= sf;
            for(a = a.current.firstEffect; null !== a;){
                try {
                    var c = a;
                    if (0 !== (c.effectTag & 512)) switch(c.tag){
                        case 0:
                        case 11:
                        case 15:
                            Ue(128, 0, c), Ue(0, 64, c);
                    }
                } catch (d) {
                    if (null === a) throw Error(n(330));
                    Re(a, d);
                }
                c = a.nextEffect;
                a.nextEffect = null;
                a = c;
            }
            T = b;
            F();
            return !0;
        }
        function ng(a, b, c) {
            b = Ne(c, b);
            b = jf(a, b, 1073741823);
            Ic(a, b);
            a = Nf(a, 1073741823);
            null !== a && Z(a);
        }
        function Re(a, b) {
            if (3 === a.tag) ng(a, a, b);
            else for(var c = a.return; null !== c;){
                if (3 === c.tag) {
                    ng(c, a, b);
                    break;
                } else if (1 === c.tag) {
                    var d = c.stateNode;
                    if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === nf || !nf.has(d))) {
                        a = Ne(b, a);
                        a = mf(c, a, 1073741823);
                        Ic(c, a);
                        c = Nf(c, 1073741823);
                        null !== c && Z(c);
                        break;
                    }
                }
                c = c.return;
            }
        }
        function fg(a, b, c) {
            var d = a.pingCache;
            null !== d && d.delete(b);
            U === a && W === c ? X === xf || X === wf && 1073741823 === Af && E() - ff < Ff ? Wf(a, W) : Ef = !0 : Sf(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), Z(a)));
        }
        function gf(a, b) {
            var c = a.stateNode;
            null !== c && c.delete(b);
            b = 0;
            0 === b && (b = G(), b = Vc(b, a, null));
            a = Nf(a, b);
            null !== a && Z(a);
        }
        var ig;
        ig = function ig(a, b, c) {
            var d = b.expirationTime;
            if (null !== a) {
                var e = b.pendingProps;
                if (a.memoizedProps !== e || B.current) Bc = !0;
                else {
                    if (d < c) {
                        Bc = !1;
                        switch(b.tag){
                            case 3:
                                ze(b);
                                oe();
                                break;
                            case 5:
                                sd(b);
                                if (b.mode & 4 && 1 !== c && Ka(b.type, e)) return b.expirationTime = b.childExpirationTime = 1, null;
                                break;
                            case 1:
                                C(b.type) && Kb(b);
                                break;
                            case 4:
                                qd(b, b.stateNode.containerInfo);
                                break;
                            case 10:
                                xc(b, b.memoizedProps.value);
                                break;
                            case 13:
                                if (null !== b.memoizedState) {
                                    d = b.child.childExpirationTime;
                                    if (0 !== d && d >= c) return Be(a, b, c);
                                    z(I, I.current & 1);
                                    b = re(a, b, c);
                                    return null !== b ? b.sibling : null;
                                }
                                z(I, I.current & 1);
                                break;
                            case 19:
                                d = b.childExpirationTime >= c;
                                if (0 !== (a.effectTag & 64)) {
                                    if (d) return Ee(a, b, c);
                                    b.effectTag |= 64;
                                }
                                e = b.memoizedState;
                                null !== e && (e.rendering = null, e.tail = null);
                                z(I, I.current);
                                if (!d) return null;
                        }
                        return re(a, b, c);
                    }
                    Bc = !1;
                }
            } else Bc = !1;
            b.expirationTime = 0;
            switch(b.tag){
                case 2:
                    d = b.type;
                    null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                    a = b.pendingProps;
                    e = Fb(b, A.current);
                    Ac(b, c);
                    e = Jd(null, b, d, a, e, c);
                    b.effectTag |= 1;
                    if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                        b.tag = 1;
                        Nd();
                        if (C(d)) {
                            var f = !0;
                            Kb(b);
                        } else f = !1;
                        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                        var g = d.getDerivedStateFromProps;
                        "function" === typeof g && Uc(b, d, g, a);
                        e.updater = Xc;
                        b.stateNode = e;
                        e._reactInternalFiber = b;
                        ad(b, d, a, c);
                        b = ye(null, b, d, !0, f, c);
                    } else b.tag = 0, Q(null, b, e, c), b = b.child;
                    return b;
                case 16:
                    e = b.elementType;
                    null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                    a = b.pendingProps;
                    sa(e);
                    if (1 !== e._status) throw e._result;
                    e = e._result;
                    b.type = e;
                    f = b.tag = og(e);
                    a = rc(e, a);
                    switch(f){
                        case 0:
                            b = ve(null, b, e, a, c);
                            break;
                        case 1:
                            b = xe(null, b, e, a, c);
                            break;
                        case 11:
                            b = qe(null, b, e, a, c);
                            break;
                        case 14:
                            b = se(null, b, e, rc(e.type, a), d, c);
                            break;
                        default:
                            throw Error(n(306, e, ""));
                    }
                    return b;
                case 0:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), ve(a, b, d, e, c);
                case 1:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), xe(a, b, d, e, c);
                case 3:
                    ze(b);
                    d = b.updateQueue;
                    if (null === d) throw Error(n(282));
                    e = b.memoizedState;
                    e = null !== e ? e.element : null;
                    Nc(b, d, b.pendingProps, null, c);
                    d = b.memoizedState.element;
                    if (d === e) oe(), b = re(a, b, c);
                    else {
                        if (e = b.stateNode.hydrate) Sa ? (ee = tb(b.stateNode.containerInfo), de = b, e = fe = !0) : e = !1;
                        if (e) for(c = ld(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                        else Q(a, b, d, c), oe();
                        b = b.child;
                    }
                    return b;
                case 5:
                    return sd(b), null === a && je(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ja(d, e) ? g = null : null !== f && Ja(d, f) && (b.effectTag |= 16), we(a, b), b.mode & 4 && 1 !== c && Ka(d, e) ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (Q(a, b, g, c), b = b.child), b;
                case 6:
                    return null === a && je(b), null;
                case 13:
                    return Be(a, b, c);
                case 4:
                    return qd(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = kd(b, null, d, c) : Q(a, b, d, c), b.child;
                case 11:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), qe(a, b, d, e, c);
                case 7:
                    return Q(a, b, b.pendingProps, c), b.child;
                case 8:
                    return Q(a, b, b.pendingProps.children, c), b.child;
                case 12:
                    return Q(a, b, b.pendingProps.children, c), b.child;
                case 10:
                    a: {
                        d = b.type._context;
                        e = b.pendingProps;
                        g = b.memoizedProps;
                        f = e.value;
                        xc(b, f);
                        if (null !== g) {
                            var l = g.value;
                            f = oc(l, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(l, f) : 1073741823) | 0;
                            if (0 === f) {
                                if (g.children === e.children && !B.current) {
                                    b = re(a, b, c);
                                    break a;
                                }
                            } else for(l = b.child, null !== l && (l.return = b); null !== l;){
                                var h = l.dependencies;
                                if (null !== h) {
                                    g = l.child;
                                    for(var k = h.firstContext; null !== k;){
                                        if (k.context === d && 0 !== (k.observedBits & f)) {
                                            1 === l.tag && (k = Gc(c, null), k.tag = 2, Ic(l, k));
                                            l.expirationTime < c && (l.expirationTime = c);
                                            k = l.alternate;
                                            null !== k && k.expirationTime < c && (k.expirationTime = c);
                                            zc(l.return, c);
                                            h.expirationTime < c && (h.expirationTime = c);
                                            break;
                                        }
                                        k = k.next;
                                    }
                                } else g = 10 === l.tag ? l.type === b.type ? null : l.child : l.child;
                                if (null !== g) g.return = l;
                                else for(g = l; null !== g;){
                                    if (g === b) {
                                        g = null;
                                        break;
                                    }
                                    l = g.sibling;
                                    if (null !== l) {
                                        l.return = g.return;
                                        g = l;
                                        break;
                                    }
                                    g = g.return;
                                }
                                l = g;
                            }
                        }
                        Q(a, b, e.children, c);
                        b = b.child;
                    }
                    return b;
                case 9:
                    return e = b.type, f = b.pendingProps, d = f.children, Ac(b, c), e = Cc(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, Q(a, b, d, c), b.child;
                case 14:
                    return e = b.type, f = rc(e, b.pendingProps), f = rc(e.type, f), se(a, b, e, f, d, c);
                case 15:
                    return ue(a, b, b.type, b.pendingProps, d, c);
                case 17:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, C(d) ? (a = !0, Kb(b)) : a = !1, Ac(b, c), Zc(b, d, e), ad(b, d, e, c), ye(null, b, d, !0, a, c);
                case 19:
                    return Ee(a, b, c);
            }
            throw Error(n(156, b.tag));
        };
        var lg = null, We = null;
        function pg(a) {
            if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) return !0;
            try {
                var c = b.inject(a);
                lg = function lg(a) {
                    try {
                        b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
                    } catch (e) {}
                };
                We = function We(a) {
                    try {
                        b.onCommitFiberUnmount(c, a);
                    } catch (e) {}
                };
            } catch (d) {}
            return !0;
        }
        function qg(a, b, c, d) {
            this.tag = a;
            this.key = c;
            this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
            this.index = 0;
            this.ref = null;
            this.pendingProps = b;
            this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
            this.mode = d;
            this.effectTag = 0;
            this.lastEffect = this.firstEffect = this.nextEffect = null;
            this.childExpirationTime = this.expirationTime = 0;
            this.alternate = null;
        }
        function he(a, b, c, d) {
            return new qg(a, b, c, d);
        }
        function te(a) {
            a = a.prototype;
            return !(!a || !a.isReactComponent);
        }
        function og(a) {
            if ("function" === typeof a) return te(a) ? 1 : 0;
            if (void 0 !== a && null !== a) {
                a = a.$$typeof;
                if (a === la) return 11;
                if (a === oa) return 14;
            }
            return 2;
        }
        function fd(a, b) {
            var c = a.alternate;
            null === c ? (c = he(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
            c.childExpirationTime = a.childExpirationTime;
            c.expirationTime = a.expirationTime;
            c.child = a.child;
            c.memoizedProps = a.memoizedProps;
            c.memoizedState = a.memoizedState;
            c.updateQueue = a.updateQueue;
            b = a.dependencies;
            c.dependencies = null === b ? null : {
                expirationTime: b.expirationTime,
                firstContext: b.firstContext,
                responders: b.responders
            };
            c.sibling = a.sibling;
            c.index = a.index;
            c.ref = a.ref;
            return c;
        }
        function hd(a, b, c, d, e, f) {
            var g = 2;
            d = a;
            if ("function" === typeof a) te(a) && (g = 1);
            else if ("string" === typeof a) g = 5;
            else a: switch(a){
                case ea:
                    return jd(c.children, e, f, b);
                case ka:
                    g = 8;
                    e |= 7;
                    break;
                case fa:
                    g = 8;
                    e |= 1;
                    break;
                case ha:
                    return a = he(12, c, b, e | 8), a.elementType = ha, a.type = ha, a.expirationTime = f, a;
                case ma:
                    return a = he(13, c, b, e), a.type = ma, a.elementType = ma, a.expirationTime = f, a;
                case na:
                    return a = he(19, c, b, e), a.elementType = na, a.expirationTime = f, a;
                default:
                    if ("object" === typeof a && null !== a) switch(a.$$typeof){
                        case ia:
                            g = 10;
                            break a;
                        case ja:
                            g = 9;
                            break a;
                        case la:
                            g = 11;
                            break a;
                        case oa:
                            g = 14;
                            break a;
                        case pa:
                            g = 16;
                            d = null;
                            break a;
                    }
                    throw Error(n(130, null == a ? a : typeof a, ""));
            }
            b = he(g, c, b, e);
            b.elementType = a;
            b.type = d;
            b.expirationTime = f;
            return b;
        }
        function jd(a, b, c, d) {
            a = he(7, a, d, b);
            a.expirationTime = c;
            return a;
        }
        function gd(a, b, c) {
            a = he(6, a, null, b);
            a.expirationTime = c;
            return a;
        }
        function id(a, b, c) {
            b = he(4, null !== a.children ? a.children : [], a.key, b);
            b.expirationTime = c;
            b.stateNode = {
                containerInfo: a.containerInfo,
                pendingChildren: null,
                implementation: a.implementation
            };
            return b;
        }
        function rg(a, b, c) {
            this.tag = b;
            this.current = null;
            this.containerInfo = a;
            this.pingCache = this.pendingChildren = null;
            this.finishedExpirationTime = 0;
            this.finishedWork = null;
            this.timeoutHandle = Oa;
            this.pendingContext = this.context = null;
            this.hydrate = c;
            this.callbackNode = null;
            this.callbackPriority = 90;
            this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
        }
        function Sf(a, b) {
            var c = a.firstSuspendedTime;
            a = a.lastSuspendedTime;
            return 0 !== c && c >= b && a <= b;
        }
        function Pf(a, b) {
            var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
            c < b && (a.firstSuspendedTime = b);
            if (d > b || 0 === c) a.lastSuspendedTime = b;
            b <= a.lastPingedTime && (a.lastPingedTime = 0);
            b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
        }
        function Qf(a, b) {
            b > a.firstPendingTime && (a.firstPendingTime = b);
            var c = a.firstSuspendedTime;
            0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
        }
        function Uf(a, b) {
            var c = a.lastExpiredTime;
            if (0 === c || c > b) a.lastExpiredTime = b;
        }
        function sg(a) {
            var b = a._reactInternalFiber;
            if (void 0 === b) {
                if ("function" === typeof a.render) throw Error(n(188));
                throw Error(n(268, Object.keys(a)));
            }
            a = xa(b);
            return null === a ? null : a.stateNode;
        }
        function tg(a, b) {
            a = a.memoizedState;
            null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
        }
        function ug(a, b) {
            tg(a, b);
            (a = a.alternate) && tg(a, b);
        }
        var vg = {
            createContainer: function createContainer(a, b, c) {
                a = new rg(a, b, c);
                b = he(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
                a.current = b;
                return b.stateNode = a;
            },
            updateContainer: function updateContainer(a, b, c, d) {
                var e = b.current, f = G(), g = Sc.suspense;
                f = Vc(f, e, g);
                a: if (c) {
                    c = c._reactInternalFiber;
                    b: {
                        if (ua(c) !== c || 1 !== c.tag) throw Error(n(170));
                        var l = c;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break b;
                                case 1:
                                    if (C(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break b;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(n(171));
                    }
                    if (1 === c.tag) {
                        var h = c.type;
                        if (C(h)) {
                            c = Jb(c, h, l);
                            break a;
                        }
                    }
                    c = l;
                } else c = Db;
                null === b.context ? b.context = c : b.pendingContext = c;
                b = Gc(f, g);
                b.payload = {
                    element: a
                };
                d = void 0 === d ? null : d;
                null !== d && (b.callback = d);
                Ic(e, b);
                Wc(e, f);
                return f;
            },
            batchedEventUpdates: function batchedEventUpdates(a, b) {
                var c = T;
                T |= 2;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            batchedUpdates: function batchedUpdates(a, b) {
                var c = T;
                T |= 1;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            unbatchedUpdates: function unbatchedUpdates(a, b) {
                var c = T;
                T &= -2;
                T |= rf;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            deferredUpdates: function deferredUpdates(a) {
                return hc(97, a);
            },
            syncUpdates: function syncUpdates(a, b, c, d) {
                return hc(99, a.bind(null, b, c, d));
            },
            discreteUpdates: function discreteUpdates(a, b, c, d) {
                var e = T;
                T |= 4;
                try {
                    return hc(98, a.bind(null, b, c, d));
                } finally{
                    T = e, T === R && F();
                }
            },
            flushDiscreteUpdates: function flushDiscreteUpdates() {
                (T & (1 | S | sf)) === R && (dg(), Vf());
            },
            flushControlled: function flushControlled(a) {
                var b = T;
                T |= 1;
                try {
                    hc(99, a);
                } finally{
                    T = b, T === R && F();
                }
            },
            flushSync: eg,
            flushPassiveEffects: Vf,
            IsThisRendererActing: {
                current: !1
            },
            getPublicRootInstance: function getPublicRootInstance(a) {
                a = a.current;
                if (!a.child) return null;
                switch(a.child.tag){
                    case 5:
                        return za(a.child.stateNode);
                    default:
                        return a.child.stateNode;
                }
            },
            attemptSynchronousHydration: function attemptSynchronousHydration(a) {
                switch(a.tag){
                    case 3:
                        var b = a.stateNode;
                        b.hydrate && cg(b, b.firstPendingTime);
                        break;
                    case 13:
                        eg(function() {
                            return Wc(a, 1073741823);
                        }), b = mc(G(), 150, 100), ug(a, b);
                }
            },
            attemptUserBlockingHydration: function attemptUserBlockingHydration(a) {
                if (13 === a.tag) {
                    var b = mc(G(), 150, 100);
                    Wc(a, b);
                    ug(a, b);
                }
            },
            attemptContinuousHydration: function attemptContinuousHydration(a) {
                if (13 === a.tag) {
                    G();
                    var b = lc++;
                    Wc(a, b);
                    ug(a, b);
                }
            },
            attemptHydrationAtCurrentPriority: function attemptHydrationAtCurrentPriority(a) {
                if (13 === a.tag) {
                    var b = G();
                    b = Vc(b, a, null);
                    Wc(a, b);
                    ug(a, b);
                }
            },
            findHostInstance: sg,
            findHostInstanceWithWarning: function findHostInstanceWithWarning(a) {
                return sg(a);
            },
            findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
                a = ya(a);
                return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
            },
            shouldSuspend: function shouldSuspend() {
                return !1;
            },
            injectIntoDevTools: function injectIntoDevTools(a) {
                var b = a.findFiberByHostInstance;
                return pg(aa({}, a, {
                    overrideHookState: null,
                    overrideProps: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: q.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
                        a = xa(a);
                        return null === a ? null : a.stateNode;
                    },
                    findFiberByHostInstance: function findFiberByHostInstance(a) {
                        return b ? b(a) : null;
                    },
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null
                }));
            }
        };
        module.exports = vg.default || vg;
        var $$$renderer = module.exports;
        module.exports = $$$reconciler;
        return $$$renderer;
    };
})(reactReconciler_production_min);
var reactReconciler_production_minExports = reactReconciler_production_min.exports;
var ReactFiberReconciler = /*@__PURE__*/ getDefaultExportFromCjs(reactReconciler_production_minExports);
/* eslint-disable no-continue */ /**
 * Checks if two sets of props are equal (recursively)
 *
 * @param {Object} a props A
 * @param {Object} b props B
 * @returns {boolean} props equals?
 *
 */ var propsEqual = function propsEqual(a, b) {
    var oldPropsKeys = Object.keys(a);
    var newPropsKeys = Object.keys(b);
    if (oldPropsKeys.length !== newPropsKeys.length) return false;
    for(var i = 0; i < oldPropsKeys.length; i += 1){
        var propName = oldPropsKeys[i];
        if (propName === "render" && !a[propName] !== !b[propName]) return false;
        if (propName !== "children" && a[propName] !== b[propName]) {
            if (typeof a[propName] === "object" && typeof b[propName] === "object" && propsEqual(a[propName], b[propName])) continue;
            return false;
        }
        if (propName === "children" && (typeof a[propName] === "string" || typeof b[propName] === "string")) return a[propName] === b[propName];
    }
    return true;
};
var _excluded$2 = [
    "style",
    "children"
], _excluded2 = [
    "style"
];
var emptyObject = {};
var appendChild = function appendChild(parentInstance, child) {
    var isParentText = parentInstance.type === "TEXT" || parentInstance.type === "LINK" || parentInstance.type === "TSPAN";
    var isChildTextInstance = child.type === "TEXT_INSTANCE";
    var isOrphanTextInstance = isChildTextInstance && !isParentText;
    // Ignore orphan text instances.
    // Caused by cases such as <>{name && <Text>{name}</Text>}</>
    if (isOrphanTextInstance) {
        console.warn("Invalid '" + child.value + "' string child outside <Text> component");
        return;
    }
    parentInstance.children.push(child);
};
var createRenderer = function createRenderer(_ref) {
    var _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function() {} : _ref$onChange;
    return ReactFiberReconciler({
        schedulePassiveEffects: _scheduler.unstable_scheduleCallback,
        cancelPassiveEffects: _scheduler.unstable_cancelCallback,
        supportsMutation: true,
        isPrimaryRenderer: false,
        warnsIfNotActing: false,
        appendInitialChild: appendChild,
        createInstance: function createInstance(type, _ref2) {
            var style = _ref2.style;
            _ref2.children;
            var props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded$2);
            return {
                type: type,
                box: {},
                style: style || {},
                props: props || {},
                children: []
            };
        },
        createTextInstance: function createTextInstance(text, rootContainerInstance) {
            return {
                type: "TEXT_INSTANCE",
                value: text
            };
        },
        finalizeInitialChildren: function finalizeInitialChildren(element, type, props) {
            return false;
        },
        getPublicInstance: function getPublicInstance(instance) {
            return instance;
        },
        prepareForCommit: function prepareForCommit() {
        // Noop
        },
        clearContainer: function clearContainer() {
        // Noop
        },
        prepareUpdate: function prepareUpdate(element, type, oldProps, newProps) {
            return !propsEqual(oldProps, newProps);
        },
        resetAfterCommit: onChange,
        resetTextContent: function resetTextContent(element) {
        // Noop
        },
        getRootHostContext: function getRootHostContext() {
            return emptyObject;
        },
        getChildHostContext: function getChildHostContext() {
            return emptyObject;
        },
        shouldSetTextContent: function shouldSetTextContent(type, props) {
            return false;
        },
        now: Date.now,
        useSyncScheduling: true,
        appendChild: appendChild,
        appendChildToContainer: function appendChildToContainer(parentInstance, child) {
            if (parentInstance.type === "ROOT") parentInstance.document = child;
            else appendChild(parentInstance, child);
        },
        insertBefore: function insertBefore(parentInstance, child, beforeChild) {
            var _parentInstance$child;
            var index = (_parentInstance$child = parentInstance.children) === null || _parentInstance$child === void 0 ? void 0 : _parentInstance$child.indexOf(beforeChild);
            if (index === undefined) return;
            if (index !== -1 && child) parentInstance.children.splice(index, 0, child);
        },
        removeChild: function removeChild(parentInstance, child) {
            var _parentInstance$child2;
            var index = (_parentInstance$child2 = parentInstance.children) === null || _parentInstance$child2 === void 0 ? void 0 : _parentInstance$child2.indexOf(child);
            if (index === undefined) return;
            if (index !== -1) parentInstance.children.splice(index, 1);
        },
        removeChildFromContainer: function removeChildFromContainer(parentInstance, child) {
            var _parentInstance$child3;
            var index = (_parentInstance$child3 = parentInstance.children) === null || _parentInstance$child3 === void 0 ? void 0 : _parentInstance$child3.indexOf(child);
            if (index === undefined) return;
            if (index !== -1) parentInstance.children.splice(index, 1);
        },
        commitTextUpdate: function commitTextUpdate(textInstance, oldText, newText) {
            textInstance.value = newText;
        },
        commitUpdate: function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
            var style = newProps.style, props = (0, _objectWithoutPropertiesLooseDefault.default)(newProps, _excluded2);
            instance.props = props;
            instance.style = style;
        }
    });
};
var name = "@react-pdf/renderer";
var version$1 = "3.3.8";
var license = "MIT";
var description = "Create PDF files on the browser and server";
var author = "Diego Muracciole <diegomuracciole@gmail.com>";
var homepage = "https://github.com/diegomura/react-pdf#readme";
var type = "module";
var main = "./lib/react-pdf.cjs";
var module = "./lib/react-pdf.js";
var browser = {
    "./lib/react-pdf.js": "./lib/react-pdf.browser.js",
    "./lib/react-pdf.cjs": "./lib/react-pdf.browser.cjs"
};
var exports = {
    ".": {
        "import": "./lib/react-pdf.js",
        require: "./lib/react-pdf.cjs",
        "default": "./lib/react-pdf.js"
    }
};
var repository = {
    type: "git",
    url: "https://github.com/diegomura/react-pdf.git",
    directory: "packages/renderer"
};
var scripts = {
    build: "rimraf ./lib && rollup -c",
    watch: "rimraf ./lib && rollup -c -w",
    size: "size-limit",
    lint: "eslint src",
    test: "vitest && vitest --config vitest.browser.config.js"
};
var dependencies = {
    "@babel/runtime": "^7.20.13",
    "@react-pdf/font": "^2.4.4",
    "@react-pdf/layout": "^3.11.2",
    "@react-pdf/pdfkit": "^3.1.6",
    "@react-pdf/primitives": "^3.1.1",
    "@react-pdf/render": "^3.4.3",
    "@react-pdf/types": "^2.4.1",
    events: "^3.3.0",
    "object-assign": "^4.1.1",
    "prop-types": "^15.6.2",
    queue: "^6.0.1",
    scheduler: "^0.17.0"
};
var peerDependencies = {
    react: "^16.8.0 || ^17.0.0 || ^18.0.0"
};
var files = [
    "lib",
    "index.d.ts"
];
var collective = {
    type: "opencollective",
    url: "https://opencollective.com/react-pdf",
    logo: "https://opencollective.com/opencollective/logo.txt"
};
var devDependencies = {
    "@size-limit/preset-big-lib": "^11.0.1",
    assert: "^2.0.0",
    "browserify-zlib": "^0.2.0",
    buffer: "^6.0.3",
    process: "^0.11.10",
    "react-reconciler": "0.23.0",
    "size-limit": "^11.0.1",
    util: "^0.12.4"
};
var packageJson = {
    name: name,
    version: version$1,
    license: license,
    description: description,
    author: author,
    homepage: homepage,
    type: type,
    main: main,
    module: module,
    browser: browser,
    exports: exports,
    repository: repository,
    scripts: scripts,
    dependencies: dependencies,
    peerDependencies: peerDependencies,
    "lint-staged": {
        "*.js": [
            "yarn lint",
            "prettier --write"
        ]
    },
    files: files,
    collective: collective,
    devDependencies: devDependencies
};
var version = packageJson.version;
var fontStore = new (0, _fontDefault.default)();
// We must keep a single renderer instance, otherwise React will complain
var renderer;
// The pdf instance acts as an event emitter for DOM usage.
// We only want to trigger an update when PDF content changes
var events = {};
var pdf = function pdf(initialValue) {
    var onChange = function onChange() {
        var _events$change;
        var listeners = ((_events$change = events.change) === null || _events$change === void 0 ? void 0 : _events$change.slice()) || [];
        for(var i = 0; i < listeners.length; i += 1)listeners[i]();
    };
    var container = {
        type: "ROOT",
        document: null
    };
    renderer = renderer || createRenderer({
        onChange: onChange
    });
    var mountNode = renderer.createContainer(container);
    var updateContainer = function updateContainer(doc, callback) {
        renderer.updateContainer(doc, mountNode, null, callback);
    };
    if (initialValue) updateContainer(initialValue);
    var render = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(compress) {
            var props, pdfVersion, language, pageLayout, pageMode, ctx, layout, fileStream;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (compress === void 0) compress = true;
                        props = container.document.props || {};
                        pdfVersion = props.pdfVersion, language = props.language, pageLayout = props.pageLayout, pageMode = props.pageMode;
                        ctx = new (0, _pdfkitDefault.default)({
                            compress: compress,
                            pdfVersion: pdfVersion,
                            lang: language,
                            displayTitle: true,
                            autoFirstPage: false,
                            pageLayout: pageLayout,
                            pageMode: pageMode
                        });
                        _context.next = 6;
                        return (0, _layoutDefault.default)(container.document, fontStore);
                    case 6:
                        layout = _context.sent;
                        fileStream = (0, _renderDefault.default)(ctx, layout);
                        return _context.abrupt("return", {
                            layout: layout,
                            fileStream: fileStream
                        });
                    case 9:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function render(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var callOnRender = function callOnRender(params) {
        if (params === void 0) params = {};
        if (container.document.props.onRender) container.document.props.onRender(params);
    };
    var toBlob = /*#__PURE__*/ function() {
        var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2() {
            var chunks, _yield$render, _INTERNAL__LAYOUT__DATA_, instance;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        chunks = [];
                        _context2.next = 3;
                        return render();
                    case 3:
                        _yield$render = _context2.sent;
                        _INTERNAL__LAYOUT__DATA_ = _yield$render.layout;
                        instance = _yield$render.fileStream;
                        return _context2.abrupt("return", new Promise(function(resolve, reject) {
                            instance.on("data", function(chunk) {
                                chunks.push(chunk instanceof Uint8Array ? chunk : new Uint8Array(chunk));
                            });
                            instance.on("end", function() {
                                try {
                                    var blob = new Blob(chunks, {
                                        type: "application/pdf"
                                    });
                                    callOnRender({
                                        blob: blob,
                                        _INTERNAL__LAYOUT__DATA_: _INTERNAL__LAYOUT__DATA_
                                    });
                                    resolve(blob);
                                } catch (error) {
                                    reject(error);
                                }
                            });
                        }));
                    case 7:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function toBlob() {
            return _ref2.apply(this, arguments);
        };
    }();
    // TODO: rename this method to `toStream` in next major release, because it return stream not a buffer
    var toBuffer = /*#__PURE__*/ function() {
        var _ref3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee3() {
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        callOnRender();
                        _context3.next = 3;
                        return render();
                    case 3:
                        return _context3.abrupt("return", _context3.sent.fileStream);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function toBuffer() {
            return _ref3.apply(this, arguments);
        };
    }();
    /*
   * TODO: remove this method in next major release. it is buggy
   * see
   * - https://github.com/diegomura/react-pdf/issues/2112
   * - https://github.com/diegomura/react-pdf/issues/2095
   */ var toString = /*#__PURE__*/ function() {
        var _ref4 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee4() {
            var result, _yield$render2, instance;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        result = "";
                        _context4.next = 4;
                        return render(false);
                    case 4:
                        _yield$render2 = _context4.sent;
                        instance = _yield$render2.fileStream;
                        return _context4.abrupt("return", new Promise(function(resolve, reject) {
                            try {
                                instance.on("data", function(buffer) {
                                    result += buffer;
                                });
                                instance.on("end", function() {
                                    callOnRender();
                                    resolve(result);
                                });
                            } catch (error) {
                                reject(error);
                            }
                        }));
                    case 7:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4);
        }));
        return function toString() {
            return _ref4.apply(this, arguments);
        };
    }();
    var on = function on(event, listener) {
        if (!events[event]) events[event] = [];
        events[event].push(listener);
    };
    var removeListener = function removeListener(event, listener) {
        if (!events[event]) return;
        var idx = events[event].indexOf(listener);
        if (idx > -1) events[event].splice(idx, 1);
    };
    return {
        on: on,
        container: container,
        toBlob: toBlob,
        toBuffer: toBuffer,
        toString: toString,
        removeListener: removeListener,
        updateContainer: updateContainer
    };
};
var Font = fontStore;
var StyleSheet = {
    create: function create(s) {
        return s;
    }
};
/**
 * PDF hook
 *
 * @param {Object} [options] hook options
 * @returns {[Object, Function]} pdf state and update function
 */ var usePDF = function usePDF(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, document = _ref.document;
    var pdfInstance = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)({
        url: null,
        blob: null,
        error: null,
        loading: !!document
    }), state = _useState[0], setState = _useState[1];
    // Setup rendering queue
    (0, _react.useEffect)(function() {
        var renderQueue = (0, _queueDefault.default)({
            autostart: true,
            concurrency: 1
        });
        var queueDocumentRender = function queueDocumentRender() {
            setState(function(prev) {
                return (0, _extendsDefault.default)({}, prev, {
                    loading: true
                });
            });
            renderQueue.splice(0, renderQueue.length, function() {
                return state.error ? Promise.resolve() : pdfInstance.current.toBlob();
            });
        };
        var onRenderFailed = function onRenderFailed(error) {
            console.error(error);
            setState(function(prev) {
                return (0, _extendsDefault.default)({}, prev, {
                    loading: false,
                    error: error
                });
            });
        };
        var onRenderSuccessful = function onRenderSuccessful(blob) {
            setState({
                blob: blob,
                error: null,
                loading: false,
                url: URL.createObjectURL(blob)
            });
        };
        pdfInstance.current = pdf();
        pdfInstance.current.on("change", queueDocumentRender);
        if (document) pdfInstance.current.updateContainer(document);
        renderQueue.on("error", onRenderFailed);
        renderQueue.on("success", onRenderSuccessful);
        return function() {
            renderQueue.end();
            pdfInstance.current.removeListener("change", queueDocumentRender);
        };
    }, []);
    // Revoke old unused url instances
    (0, _react.useEffect)(function() {
        return function() {
            if (state.url) URL.revokeObjectURL(state.url);
        };
    }, [
        state.url
    ]);
    var update = (0, _react.useCallback)(function(newDoc) {
        pdfInstance.current.updateContainer(newDoc);
    }, []);
    return [
        state,
        update
    ];
};
var _excluded$1 = [
    "title",
    "style",
    "className",
    "children",
    "innerRef",
    "showToolbar"
];
var PDFViewer = function PDFViewer(_ref) {
    var title = _ref.title, style = _ref.style, className = _ref.className, children = _ref.children, innerRef = _ref.innerRef, _ref$showToolbar = _ref.showToolbar, showToolbar = _ref$showToolbar === void 0 ? true : _ref$showToolbar, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded$1);
    var _usePDF = usePDF(), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(function() {
        return updateInstance(children);
    }, [
        children
    ]);
    var src = instance.url ? instance.url + "#toolbar=" + (showToolbar ? 1 : 0) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", (0, _extendsDefault.default)({
        src: src,
        title: title,
        ref: innerRef,
        style: style,
        className: className
    }, props));
};
/* eslint-disable no-console */ var BlobProvider = function BlobProvider(_ref) {
    var doc = _ref.document, children = _ref.children;
    var _usePDF = usePDF(), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(function() {
        return updateInstance(doc);
    }, [
        doc
    ]);
    if (!doc) {
        console.warn("You should pass a valid document to BlobProvider");
        return null;
    }
    return children(instance);
};
var _excluded = [
    "fileName",
    "document",
    "children",
    "onClick",
    "href"
];
var PDFDownloadLink = function PDFDownloadLink(_ref) {
    var _ref$fileName = _ref.fileName, fileName = _ref$fileName === void 0 ? "document.pdf" : _ref$fileName, doc = _ref.document, children = _ref.children, onClick = _ref.onClick;
    _ref.href;
    var rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var _usePDF = usePDF(), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(function() {
        return updateInstance(doc);
    }, [
        doc
    ]);
    if (!doc) {
        console.warn("You should pass a valid document to PDFDownloadLink");
        return null;
    }
    var handleDownloadIE = function handleDownloadIE() {
        if (window.navigator.msSaveBlob) // IE
        window.navigator.msSaveBlob(instance.blob, fileName);
    };
    var handleClick = function handleClick(event) {
        handleDownloadIE();
        if (typeof onClick === "function") onClick(event, instance);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", (0, _extendsDefault.default)({
        href: instance.url,
        download: fileName,
        onClick: handleClick
    }, rest, {
        children: typeof children === "function" ? children(instance) : children
    }));
};
var throwEnvironmentError = function throwEnvironmentError(name) {
    throw new Error(name + " is a Node specific API. You're either using this method in a browser, or your bundler is not loading react-pdf from the appropriate web build.");
};
var renderToStream = function renderToStream() {
    throwEnvironmentError("renderToStream");
};
var renderToBuffer = function renderToBuffer() {
    throwEnvironmentError("renderToBuffer");
};
var renderToString = function renderToString() {
    throwEnvironmentError("renderToString");
};
var renderToFile = function renderToFile() {
    throwEnvironmentError("renderToFile");
};
var render = function render() {
    throwEnvironmentError("render");
};
// TODO: remove this default export in next major release because it breaks tree-shacking
var index = (0, _extendsDefault.default)({
    pdf: pdf,
    usePDF: usePDF,
    Font: Font,
    version: version,
    StyleSheet: StyleSheet,
    PDFViewer: PDFViewer,
    BlobProvider: BlobProvider,
    PDFDownloadLink: PDFDownloadLink,
    renderToStream: renderToStream,
    renderToString: renderToString,
    renderToFile: renderToFile,
    render: render
}, _primitives);

},{"@babel/runtime/helpers/extends":"lKkcq","@react-pdf/primitives":"bti5i","queue":"j3xJu","react":"gVheC","@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@react-pdf/font":"7K49F","@react-pdf/render":"76x2x","@react-pdf/pdfkit":"kKgRa","@react-pdf/layout":"9jeDh","@babel/runtime/helpers/objectWithoutPropertiesLoose":"6F7Pt","object-assign":"hAlka","scheduler":"3Mfyz","react/jsx-runtime":"1elNt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bti5i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "G", ()=>G);
parcelHelpers.export(exports, "Svg", ()=>Svg);
parcelHelpers.export(exports, "View", ()=>View);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "Page", ()=>Page);
parcelHelpers.export(exports, "Note", ()=>Note);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "Rect", ()=>Rect);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Stop", ()=>Stop);
parcelHelpers.export(exports, "Defs", ()=>Defs);
parcelHelpers.export(exports, "Image", ()=>Image);
parcelHelpers.export(exports, "Tspan", ()=>Tspan);
parcelHelpers.export(exports, "Canvas", ()=>Canvas);
parcelHelpers.export(exports, "Circle", ()=>Circle);
parcelHelpers.export(exports, "Ellipse", ()=>Ellipse);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
parcelHelpers.export(exports, "Document", ()=>Document);
parcelHelpers.export(exports, "Polyline", ()=>Polyline);
parcelHelpers.export(exports, "ClipPath", ()=>ClipPath);
parcelHelpers.export(exports, "TextInstance", ()=>TextInstance);
parcelHelpers.export(exports, "LinearGradient", ()=>LinearGradient);
parcelHelpers.export(exports, "RadialGradient", ()=>RadialGradient);
const G = "G";
const Svg = "SVG";
const View = "VIEW";
const Text = "TEXT";
const Link = "LINK";
const Page = "PAGE";
const Note = "NOTE";
const Path = "PATH";
const Rect = "RECT";
const Line = "LINE";
const Stop = "STOP";
const Defs = "DEFS";
const Image = "IMAGE";
const Tspan = "TSPAN";
const Canvas = "CANVAS";
const Circle = "CIRCLE";
const Ellipse = "ELLIPSE";
const Polygon = "POLYGON";
const Document = "DOCUMENT";
const Polyline = "POLYLINE";
const ClipPath = "CLIP_PATH";
const TextInstance = "TEXT_INSTANCE";
const LinearGradient = "LINEAR_GRADIENT";
const RadialGradient = "RADIAL_GRADIENT";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"j3xJu":[function(require,module,exports) {
var inherits = require("1075dd0c6e199d0e");
var EventEmitter = require("2935debf5437e7d1").EventEmitter;
module.exports = Queue;
module.exports.default = Queue;
function Queue(options) {
    if (!(this instanceof Queue)) return new Queue(options);
    EventEmitter.call(this);
    options = options || {};
    this.concurrency = options.concurrency || Infinity;
    this.timeout = options.timeout || 0;
    this.autostart = options.autostart || false;
    this.results = options.results || null;
    this.pending = 0;
    this.session = 0;
    this.running = false;
    this.jobs = [];
    this.timers = {};
}
inherits(Queue, EventEmitter);
var arrayMethods = [
    "pop",
    "shift",
    "indexOf",
    "lastIndexOf"
];
arrayMethods.forEach(function(method) {
    Queue.prototype[method] = function() {
        return Array.prototype[method].apply(this.jobs, arguments);
    };
});
Queue.prototype.slice = function(begin, end) {
    this.jobs = this.jobs.slice(begin, end);
    return this;
};
Queue.prototype.reverse = function() {
    this.jobs.reverse();
    return this;
};
var arrayAddMethods = [
    "push",
    "unshift",
    "splice"
];
arrayAddMethods.forEach(function(method) {
    Queue.prototype[method] = function() {
        var methodResult = Array.prototype[method].apply(this.jobs, arguments);
        if (this.autostart) this.start();
        return methodResult;
    };
});
Object.defineProperty(Queue.prototype, "length", {
    get: function() {
        return this.pending + this.jobs.length;
    }
});
Queue.prototype.start = function(cb) {
    if (cb) callOnErrorOrEnd.call(this, cb);
    this.running = true;
    if (this.pending >= this.concurrency) return;
    if (this.jobs.length === 0) {
        if (this.pending === 0) done.call(this);
        return;
    }
    var self = this;
    var job = this.jobs.shift();
    var once = true;
    var session = this.session;
    var timeoutId = null;
    var didTimeout = false;
    var resultIndex = null;
    var timeout = job.hasOwnProperty("timeout") ? job.timeout : this.timeout;
    function next(err, result) {
        if (once && self.session === session) {
            once = false;
            self.pending--;
            if (timeoutId !== null) {
                delete self.timers[timeoutId];
                clearTimeout(timeoutId);
            }
            if (err) self.emit("error", err, job);
            else if (didTimeout === false) {
                if (resultIndex !== null) self.results[resultIndex] = Array.prototype.slice.call(arguments, 1);
                self.emit("success", result, job);
            }
            if (self.session === session) {
                if (self.pending === 0 && self.jobs.length === 0) done.call(self);
                else if (self.running) self.start();
            }
        }
    }
    if (timeout) {
        timeoutId = setTimeout(function() {
            didTimeout = true;
            if (self.listeners("timeout").length > 0) self.emit("timeout", next, job);
            else next();
        }, timeout);
        this.timers[timeoutId] = timeoutId;
    }
    if (this.results) {
        resultIndex = this.results.length;
        this.results[resultIndex] = null;
    }
    this.pending++;
    self.emit("start", job);
    var promise = job(next);
    if (promise && promise.then && typeof promise.then === "function") promise.then(function(result) {
        return next(null, result);
    }).catch(function(err) {
        return next(err || true);
    });
    if (this.running && this.jobs.length > 0) this.start();
};
Queue.prototype.stop = function() {
    this.running = false;
};
Queue.prototype.end = function(err) {
    clearTimers.call(this);
    this.jobs.length = 0;
    this.pending = 0;
    done.call(this, err);
};
function clearTimers() {
    for(var key in this.timers){
        var timeoutId = this.timers[key];
        delete this.timers[key];
        clearTimeout(timeoutId);
    }
}
function callOnErrorOrEnd(cb) {
    var self = this;
    this.on("error", onerror);
    this.on("end", onend);
    function onerror(err) {
        self.end(err);
    }
    function onend(err) {
        self.removeListener("error", onerror);
        self.removeListener("end", onend);
        cb(err, this.results);
    }
}
function done(err) {
    this.session++;
    this.running = false;
    this.emit("end", err);
}

},{"1075dd0c6e199d0e":"7B41j","2935debf5437e7d1":"dar5h"}],"7B41j":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"lzux5":[function(require,module,exports) {
var _typeof = require("921e792370458e88")["default"];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"921e792370458e88":"47zzI"}],"47zzI":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fs5T9":[function(require,module,exports) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7K49F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontStore);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _isUrl = require("is-url");
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _fontkit = require("fontkit");
var _excluded = [
    "src",
    "fontWeight",
    "fontStyle"
];
var FONT_WEIGHTS = {
    thin: 100,
    hairline: 100,
    ultralight: 200,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    demibold: 600,
    bold: 700,
    ultrabold: 800,
    extrabold: 800,
    heavy: 900,
    black: 900
};
var fetchFont = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(src, options) {
        var response, data;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(src, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.arrayBuffer();
                case 5:
                    data = _context.sent;
                    return _context.abrupt("return", new Uint8Array(data));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchFont(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isDataUrl = function isDataUrl(dataUrl) {
    var header = dataUrl.split(",")[0];
    var hasDataPrefix = header.substring(0, 5) === "data:";
    var hasBase64Prefix = header.split(";")[1] === "base64";
    return hasDataPrefix && hasBase64Prefix;
};
var resolveFontWeight = function resolveFontWeight(value) {
    return typeof value === "string" ? FONT_WEIGHTS[value] : value;
};
var sortByFontWeight = function sortByFontWeight(a, b) {
    return a.fontWeight - b.fontWeight;
};
var FontSource = /*#__PURE__*/ function() {
    function FontSource(src, fontFamily, fontStyle, fontWeight, options) {
        this.src = src;
        this.fontFamily = fontFamily;
        this.fontStyle = fontStyle || "normal";
        this.fontWeight = fontWeight || 400;
        this.data = null;
        this.options = options;
        this.loadResultPromise = null;
    }
    var _proto = FontSource.prototype;
    _proto._load = /*#__PURE__*/ function() {
        var _load2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2() {
            var postscriptName, raw, uint8Array, _this$options, headers, body, _this$options$method, method, data;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        postscriptName = this.options.postscriptName;
                        if (!isDataUrl(this.src)) {
                            _context2.next = 7;
                            break;
                        }
                        raw = this.src.split(",")[1];
                        uint8Array = new Uint8Array(atob(raw).split("").map(function(c) {
                            return c.charCodeAt(0);
                        }));
                        this.data = _fontkit.create(uint8Array, postscriptName);
                        _context2.next = 19;
                        break;
                    case 7:
                        _this$options = this.options, headers = _this$options.headers, body = _this$options.body, _this$options$method = _this$options.method, method = _this$options$method === void 0 ? "GET" : _this$options$method;
                        _context2.next = 11;
                        return fetchFont(this.src, {
                            method: method,
                            body: body,
                            headers: headers
                        });
                    case 11:
                        data = _context2.sent;
                        this.data = _fontkit.create(data, postscriptName);
                        _context2.next = 19;
                        break;
                    case 15:
                        _context2.next = 19;
                        break;
                    case 18:
                        this.data = _context2.sent;
                    case 19:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function _load() {
            return _load2.apply(this, arguments);
        }
        return _load;
    }();
    _proto.load = /*#__PURE__*/ function() {
        var _load3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee3() {
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        if (this.loadResultPromise === null) this.loadResultPromise = this._load();
                        return _context3.abrupt("return", this.loadResultPromise);
                    case 2:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function load() {
            return _load3.apply(this, arguments);
        }
        return load;
    }();
    return FontSource;
}();
var Font = /*#__PURE__*/ function() {
    Font.create = function create(family) {
        return new Font(family);
    };
    function Font(family) {
        this.family = family;
        this.sources = [];
    }
    var _proto2 = Font.prototype;
    _proto2.register = function register(_ref2) {
        var src = _ref2.src, fontWeight = _ref2.fontWeight, fontStyle = _ref2.fontStyle, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
        var numericFontWeight = resolveFontWeight(fontWeight);
        this.sources.push(new FontSource(src, this.family, fontStyle, numericFontWeight, options));
    };
    _proto2.resolve = function resolve(descriptor) {
        var _descriptor$fontWeigh = descriptor.fontWeight, fontWeight = _descriptor$fontWeigh === void 0 ? 400 : _descriptor$fontWeigh, _descriptor$fontStyle = descriptor.fontStyle, fontStyle = _descriptor$fontStyle === void 0 ? "normal" : _descriptor$fontStyle;
        var styleSources = this.sources.filter(function(s) {
            return s.fontStyle === fontStyle;
        });
        // Weight resolution. https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Fallback_weights
        var exactFit = styleSources.find(function(s) {
            return s.fontWeight === fontWeight;
        });
        if (exactFit) return exactFit;
        var res;
        if (fontWeight >= 400 && fontWeight <= 500) {
            var leftOffset = styleSources.filter(function(s) {
                return s.fontWeight <= fontWeight;
            });
            var rightOffset = styleSources.filter(function(s) {
                return s.fontWeight > 500;
            });
            var fit = styleSources.filter(function(s) {
                return s.fontWeight >= fontWeight && s.fontWeight < 500;
            });
            res = fit[0] || leftOffset[leftOffset.length - 1] || rightOffset[0];
        }
        var lt = styleSources.filter(function(s) {
            return s.fontWeight < fontWeight;
        }).sort(sortByFontWeight);
        var gt = styleSources.filter(function(s) {
            return s.fontWeight > fontWeight;
        }).sort(sortByFontWeight);
        if (fontWeight < 400) res = lt[lt.length - 1] || gt[0];
        if (fontWeight > 500) res = gt[0] || lt[lt.length - 1];
        if (!res) throw new Error("Could not resolve font for " + this.family + ", fontWeight " + fontWeight);
        return res;
    };
    return Font;
}();
var standard = [
    "Courier",
    "Courier-Bold",
    "Courier-Oblique",
    "Courier-BoldOblique",
    "Helvetica",
    "Helvetica-Bold",
    "Helvetica-Oblique",
    "Helvetica-BoldOblique",
    "Times-Roman",
    "Times-Bold",
    "Times-Italic",
    "Times-BoldItalic"
];
function FontStore() {
    var _this = this;
    var fonts = {};
    var emojiSource = null;
    var hyphenationCallback = null;
    this.register = function(data) {
        var family = data.family;
        if (!fonts[family]) fonts[family] = Font.create(family);
        // Bulk loading
        if (data.fonts) for(var i = 0; i < data.fonts.length; i += 1)fonts[family].register((0, _extendsDefault.default)({
            family: family
        }, data.fonts[i]));
        else fonts[family].register(data);
    };
    this.registerEmojiSource = function(_ref) {
        var url = _ref.url, _ref$format = _ref.format, format = _ref$format === void 0 ? "png" : _ref$format, builder = _ref.builder, _ref$withVariationSel = _ref.withVariationSelectors, withVariationSelectors = _ref$withVariationSel === void 0 ? false : _ref$withVariationSel;
        emojiSource = {
            url: url,
            format: format,
            builder: builder,
            withVariationSelectors: withVariationSelectors
        };
    };
    this.registerHyphenationCallback = function(callback) {
        hyphenationCallback = callback;
    };
    this.getFont = function(descriptor) {
        var fontFamily = descriptor.fontFamily;
        var isStandard = standard.includes(fontFamily);
        if (isStandard) return null;
        if (!fonts[fontFamily]) throw new Error("Font family not registered: " + fontFamily + ". Please register it calling Font.register() method.");
        return fonts[fontFamily].resolve(descriptor);
    };
    this.load = /*#__PURE__*/ function() {
        var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(descriptor) {
            var fontFamily, isStandard, f;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        fontFamily = descriptor.fontFamily;
                        isStandard = standard.includes(fontFamily);
                        if (!isStandard) {
                            _context.next = 4;
                            break;
                        }
                        return _context.abrupt("return");
                    case 4:
                        f = _this.getFont(descriptor); // We cache the font to avoid fetching it many times
                        _context.next = 7;
                        return f.load();
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    this.reset = function() {
        var keys = Object.keys(fonts);
        for(var i = 0; i < keys.length; i += 1){
            var key = keys[i];
            fonts[key].data = null;
        }
    };
    this.clear = function() {
        fonts = {};
    };
    this.getRegisteredFonts = function() {
        return fonts;
    };
    this.getEmojiSource = function() {
        return emojiSource;
    };
    this.getHyphenationCallback = function() {
        return hyphenationCallback;
    };
    this.getRegisteredFontFamilies = function() {
        return Object.keys(fonts);
    };
}

},{"@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@babel/runtime/helpers/extends":"lKkcq","@babel/runtime/helpers/objectWithoutPropertiesLoose":"6F7Pt","is-url":"7xrg2","cross-fetch":"2oWud","fontkit":"3l9Ub","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6F7Pt":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7xrg2":[function(require,module,exports) {
/**
 * Expose `isUrl`.
 */ module.exports = isUrl;
/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */ var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */ function isUrl(string) {
    if (typeof string !== "string") return false;
    var match = string.match(protocolAndDomainRE);
    if (!match) return false;
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) return false;
    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) return true;
    return false;
}

},{}],"2oWud":[function(require,module,exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"3l9Ub":[function(require,module,exports) {
var $gfJaN$restructure = require("f21b476b3755c378");
var $gfJaN$swchelperslib_define_propertyjs = require("ff6728da855c7440");
var $gfJaN$swchelperslib_ts_decoratejs = require("6aa66445f242ca61");
var $gfJaN$fastdeepequal = require("512c7b618d747e29");
var $gfJaN$unicodeproperties = require("4c80a4567e3a20c2");
var $gfJaN$unicodetrie = require("5389545d6ddd3821");
var $gfJaN$dfa = require("bffd1a7b85ce30bb");
var $gfJaN$clone = require("b4fd531a03fcb1a9");
var $gfJaN$tinyinflate = require("998fb3c74b159a7f");
var $gfJaN$brotlidecompressjs = require("6035591d530ded93");
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $59aa4ed98453e1d4$exports = {};
$parcel$export($59aa4ed98453e1d4$exports, "logErrors", ()=>$59aa4ed98453e1d4$export$bd5c5d8b8dcafd78);
$parcel$export($59aa4ed98453e1d4$exports, "registerFormat", ()=>$59aa4ed98453e1d4$export$36b2f24e97d43be);
$parcel$export($59aa4ed98453e1d4$exports, "create", ()=>$59aa4ed98453e1d4$export$185802fd694ee1f5);
$parcel$export($59aa4ed98453e1d4$exports, "defaultLanguage", ()=>$59aa4ed98453e1d4$export$42940898df819940);
$parcel$export($59aa4ed98453e1d4$exports, "setDefaultLanguage", ()=>$59aa4ed98453e1d4$export$5157e7780d44cc36);
let $59aa4ed98453e1d4$export$bd5c5d8b8dcafd78 = false;
let $59aa4ed98453e1d4$var$formats = [];
function $59aa4ed98453e1d4$export$36b2f24e97d43be(format) {
    $59aa4ed98453e1d4$var$formats.push(format);
}
function $59aa4ed98453e1d4$export$185802fd694ee1f5(buffer, postscriptName) {
    for(let i = 0; i < $59aa4ed98453e1d4$var$formats.length; i++){
        let format = $59aa4ed98453e1d4$var$formats[i];
        if (format.probe(buffer)) {
            let font = new format(new $gfJaN$restructure.DecodeStream(buffer));
            if (postscriptName) return font.getFont(postscriptName);
            return font;
        }
    }
    throw new Error("Unknown font format");
}
let $59aa4ed98453e1d4$export$42940898df819940 = "en";
function $59aa4ed98453e1d4$export$5157e7780d44cc36(lang = "en") {
    $59aa4ed98453e1d4$export$42940898df819940 = lang;
}
function $3bda6911913b43f0$export$69a3209f1a06c04d(target, key1, descriptor) {
    if (descriptor.get) {
        let get = descriptor.get;
        descriptor.get = function() {
            let value = get.call(this);
            Object.defineProperty(this, key1, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === "function") {
        let fn = descriptor.value;
        return {
            get () {
                let cache1 = new Map;
                function memoized(...args) {
                    let key = args.length > 0 ? args[0] : "value";
                    if (cache1.has(key)) return cache1.get(key);
                    let result = fn.apply(this, args);
                    cache1.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key1, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
let $e4ae0436c91af89f$var$SubHeader = new $gfJaN$restructure.Struct({
    firstCode: $gfJaN$restructure.uint16,
    entryCount: $gfJaN$restructure.uint16,
    idDelta: $gfJaN$restructure.int16,
    idRangeOffset: $gfJaN$restructure.uint16
});
let $e4ae0436c91af89f$var$CmapGroup = new $gfJaN$restructure.Struct({
    startCharCode: $gfJaN$restructure.uint32,
    endCharCode: $gfJaN$restructure.uint32,
    glyphID: $gfJaN$restructure.uint32
});
let $e4ae0436c91af89f$var$UnicodeValueRange = new $gfJaN$restructure.Struct({
    startUnicodeValue: $gfJaN$restructure.uint24,
    additionalCount: $gfJaN$restructure.uint8
});
let $e4ae0436c91af89f$var$UVSMapping = new $gfJaN$restructure.Struct({
    unicodeValue: $gfJaN$restructure.uint24,
    glyphID: $gfJaN$restructure.uint16
});
let $e4ae0436c91af89f$var$DefaultUVS = new $gfJaN$restructure.Array($e4ae0436c91af89f$var$UnicodeValueRange, $gfJaN$restructure.uint32);
let $e4ae0436c91af89f$var$NonDefaultUVS = new $gfJaN$restructure.Array($e4ae0436c91af89f$var$UVSMapping, $gfJaN$restructure.uint32);
let $e4ae0436c91af89f$var$VarSelectorRecord = new $gfJaN$restructure.Struct({
    varSelector: $gfJaN$restructure.uint24,
    defaultUVS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$DefaultUVS, {
        type: "parent"
    }),
    nonDefaultUVS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$NonDefaultUVS, {
        type: "parent"
    })
});
let $e4ae0436c91af89f$var$CmapSubtable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        codeMap: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint8, 256)
    },
    2: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        subHeaderKeys: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 256),
        subHeaderCount: (t)=>Math.max.apply(Math, t.subHeaderKeys),
        subHeaders: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$SubHeader, "subHeaderCount"),
        glyphIndexArray: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "subHeaderCount")
    },
    4: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        segCountX2: $gfJaN$restructure.uint16,
        segCount: (t)=>t.segCountX2 >> 1,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16,
        endCode: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        reservedPad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        startCode: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        idDelta: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, "segCount"),
        idRangeOffset: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        glyphIndexArray: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, (t)=>(t.length - t._currentOffset) / 2)
    },
    6: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        firstCode: $gfJaN$restructure.uint16,
        entryCount: $gfJaN$restructure.uint16,
        glyphIndices: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "entryCount")
    },
    8: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint16,
        is32: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint8, 8192),
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    10: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        firstCode: $gfJaN$restructure.uint32,
        entryCount: $gfJaN$restructure.uint32,
        glyphIndices: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "numChars")
    },
    12: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    13: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    14: {
        length: $gfJaN$restructure.uint32,
        numRecords: $gfJaN$restructure.uint32,
        varSelectors: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$VarSelectorRecord, "numRecords")
    }
});
let $e4ae0436c91af89f$var$CmapEntry = new $gfJaN$restructure.Struct({
    platformID: $gfJaN$restructure.uint16,
    encodingID: $gfJaN$restructure.uint16,
    table: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$CmapSubtable, {
        type: "parent",
        lazy: true
    })
});
var $e4ae0436c91af89f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numSubtables: $gfJaN$restructure.uint16,
    tables: new $gfJaN$restructure.Array($e4ae0436c91af89f$var$CmapEntry, "numSubtables")
});
var $55a60976afb7c261$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    revision: $gfJaN$restructure.int32,
    checkSumAdjustment: $gfJaN$restructure.uint32,
    magicNumber: $gfJaN$restructure.uint32,
    flags: $gfJaN$restructure.uint16,
    unitsPerEm: $gfJaN$restructure.uint16,
    created: new $gfJaN$restructure.Array($gfJaN$restructure.int32, 2),
    modified: new $gfJaN$restructure.Array($gfJaN$restructure.int32, 2),
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16,
    macStyle: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "bold",
        "italic",
        "underline",
        "outline",
        "shadow",
        "condensed",
        "extended"
    ]),
    lowestRecPPEM: $gfJaN$restructure.uint16,
    fontDirectionHint: $gfJaN$restructure.int16,
    indexToLocFormat: $gfJaN$restructure.int16,
    glyphDataFormat: $gfJaN$restructure.int16 // 0 for current format
});
var $dde72b7b5b650596$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    ascent: $gfJaN$restructure.int16,
    descent: $gfJaN$restructure.int16,
    lineGap: $gfJaN$restructure.int16,
    advanceWidthMax: $gfJaN$restructure.uint16,
    minLeftSideBearing: $gfJaN$restructure.int16,
    minRightSideBearing: $gfJaN$restructure.int16,
    xMaxExtent: $gfJaN$restructure.int16,
    caretSlopeRise: $gfJaN$restructure.int16,
    caretSlopeRun: $gfJaN$restructure.int16,
    caretOffset: $gfJaN$restructure.int16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.int16, 4),
    metricDataFormat: $gfJaN$restructure.int16,
    numberOfMetrics: $gfJaN$restructure.uint16 // Number of advance widths in 'hmtx' table
});
let $a7c40184072c9a5b$var$HmtxEntry = new $gfJaN$restructure.Struct({
    advance: $gfJaN$restructure.uint16,
    bearing: $gfJaN$restructure.int16
});
var $a7c40184072c9a5b$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    metrics: new $gfJaN$restructure.LazyArray($a7c40184072c9a5b$var$HmtxEntry, (t)=>t.parent.hhea.numberOfMetrics),
    bearings: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)
});
var $521197722369f691$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    numGlyphs: $gfJaN$restructure.uint16,
    maxPoints: $gfJaN$restructure.uint16,
    maxContours: $gfJaN$restructure.uint16,
    maxComponentPoints: $gfJaN$restructure.uint16,
    maxComponentContours: $gfJaN$restructure.uint16,
    maxZones: $gfJaN$restructure.uint16,
    maxTwilightPoints: $gfJaN$restructure.uint16,
    maxStorage: $gfJaN$restructure.uint16,
    maxFunctionDefs: $gfJaN$restructure.uint16,
    maxInstructionDefs: $gfJaN$restructure.uint16,
    maxStackElements: $gfJaN$restructure.uint16,
    maxSizeOfInstructions: $gfJaN$restructure.uint16,
    maxComponentElements: $gfJaN$restructure.uint16,
    maxComponentDepth: $gfJaN$restructure.uint16 // Maximum levels of recursion; 1 for simple components
});
function $e2613b812f052cbe$export$badc544e0651b6b1(platformID, encodingID, languageID = 0) {
    if (platformID === 1 && $e2613b812f052cbe$export$479e671907f486d1[languageID]) return $e2613b812f052cbe$export$479e671907f486d1[languageID];
    return $e2613b812f052cbe$export$6fef87b7618bdf0b[platformID][encodingID];
}
const $e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS = new Set([
    "x-mac-roman",
    "x-mac-cyrillic",
    "iso-8859-6",
    "iso-8859-8"
]);
const $e2613b812f052cbe$var$MAC_ENCODINGS = {
    "x-mac-croatian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026 \xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
    "x-mac-gaelic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
    "x-mac-greek": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026 \u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
    "x-mac-icelandic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026 \u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
    "x-mac-ce": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026 \u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
    "x-mac-romanian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    "x-mac-turkish": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
};
const $e2613b812f052cbe$var$encodingCache = new Map();
function $e2613b812f052cbe$export$1dceb3c14ed68bee(encoding) {
    let cached = $e2613b812f052cbe$var$encodingCache.get(encoding);
    if (cached) return cached;
    // These encodings aren't supported by TextDecoder.
    let mapping = $e2613b812f052cbe$var$MAC_ENCODINGS[encoding];
    if (mapping) {
        let res = new Map();
        for(let i = 0; i < mapping.length; i++)res.set(mapping.charCodeAt(i), 0x80 + i);
        $e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
    // Only single byte encodings can be mapped 1:1.
    if ($e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS.has(encoding)) {
        // TextEncoder only supports utf8, whereas TextDecoder supports legacy encodings.
        // Use this to create a mapping of code points.
        let decoder = new TextDecoder(encoding);
        let mapping = new Uint8Array(0x80);
        for(let i = 0; i < 0x80; i++)mapping[i] = 0x80 + i;
        let res = new Map();
        let s = decoder.decode(mapping);
        for(let i1 = 0; i1 < 0x80; i1++)res.set(s.charCodeAt(i1), 0x80 + i1);
        $e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
}
const $e2613b812f052cbe$export$6fef87b7618bdf0b = [
    // unicode
    [
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be"
    ],
    // macintosh
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        "x-mac-roman",
        "shift-jis",
        "big5",
        "euc-kr",
        "iso-8859-6",
        "iso-8859-8",
        "x-mac-greek",
        "x-mac-cyrillic",
        "x-mac-symbol",
        "x-mac-devanagari",
        "x-mac-gurmukhi",
        "x-mac-gujarati",
        "Oriya",
        "Bengali",
        "Tamil",
        "Telugu",
        "Kannada",
        "Malayalam",
        "Sinhalese",
        "Burmese",
        "Khmer",
        "iso-8859-11",
        "Laotian",
        "Georgian",
        "Armenian",
        "hz-gb-2312",
        "Tibetan",
        "Mongolian",
        "Geez",
        "x-mac-ce",
        "Vietnamese",
        "Sindhi"
    ],
    // ISO (deprecated)
    [
        "ascii"
    ],
    // windows
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        "symbol",
        "utf16be",
        "shift-jis",
        "gb18030",
        "big5",
        "x-cp20949",
        "johab",
        null,
        null,
        null,
        "utf16be"
    ]
];
const $e2613b812f052cbe$export$479e671907f486d1 = {
    15: "x-mac-icelandic",
    17: "x-mac-turkish",
    18: "x-mac-croatian",
    24: "x-mac-ce",
    25: "x-mac-ce",
    26: "x-mac-ce",
    27: "x-mac-ce",
    28: "x-mac-ce",
    30: "x-mac-icelandic",
    37: "x-mac-romanian",
    38: "x-mac-ce",
    39: "x-mac-ce",
    40: "x-mac-ce",
    143: "x-mac-inuit",
    146: "x-mac-gaelic"
};
const $e2613b812f052cbe$export$2092376fd002e13 = [
    // unicode
    [],
    {
        0: "en",
        30: "fo",
        60: "ks",
        90: "rw",
        1: "fr",
        31: "fa",
        61: "ku",
        91: "rn",
        2: "de",
        32: "ru",
        62: "sd",
        92: "ny",
        3: "it",
        33: "zh",
        63: "bo",
        93: "mg",
        4: "nl",
        34: "nl-BE",
        64: "ne",
        94: "eo",
        5: "sv",
        35: "ga",
        65: "sa",
        128: "cy",
        6: "es",
        36: "sq",
        66: "mr",
        129: "eu",
        7: "da",
        37: "ro",
        67: "bn",
        130: "ca",
        8: "pt",
        38: "cz",
        68: "as",
        131: "la",
        9: "no",
        39: "sk",
        69: "gu",
        132: "qu",
        10: "he",
        40: "si",
        70: "pa",
        133: "gn",
        11: "ja",
        41: "yi",
        71: "or",
        134: "ay",
        12: "ar",
        42: "sr",
        72: "ml",
        135: "tt",
        13: "fi",
        43: "mk",
        73: "kn",
        136: "ug",
        14: "el",
        44: "bg",
        74: "ta",
        137: "dz",
        15: "is",
        45: "uk",
        75: "te",
        138: "jv",
        16: "mt",
        46: "be",
        76: "si",
        139: "su",
        17: "tr",
        47: "uz",
        77: "my",
        140: "gl",
        18: "hr",
        48: "kk",
        78: "km",
        141: "af",
        19: "zh-Hant",
        49: "az-Cyrl",
        79: "lo",
        142: "br",
        20: "ur",
        50: "az-Arab",
        80: "vi",
        143: "iu",
        21: "hi",
        51: "hy",
        81: "id",
        144: "gd",
        22: "th",
        52: "ka",
        82: "tl",
        145: "gv",
        23: "ko",
        53: "mo",
        83: "ms",
        146: "ga",
        24: "lt",
        54: "ky",
        84: "ms-Arab",
        147: "to",
        25: "pl",
        55: "tg",
        85: "am",
        148: "el-polyton",
        26: "hu",
        56: "tk",
        86: "ti",
        149: "kl",
        27: "es",
        57: "mn-CN",
        87: "om",
        150: "az",
        28: "lv",
        58: "mn",
        88: "so",
        151: "nn",
        29: "se",
        59: "ps",
        89: "sw"
    },
    // ISO (deprecated)
    [],
    {
        0x0436: "af",
        0x4009: "en-IN",
        0x0487: "rw",
        0x0432: "tn",
        0x041C: "sq",
        0x1809: "en-IE",
        0x0441: "sw",
        0x045B: "si",
        0x0484: "gsw",
        0x2009: "en-JM",
        0x0457: "kok",
        0x041B: "sk",
        0x045E: "am",
        0x4409: "en-MY",
        0x0412: "ko",
        0x0424: "sl",
        0x1401: "ar-DZ",
        0x1409: "en-NZ",
        0x0440: "ky",
        0x2C0A: "es-AR",
        0x3C01: "ar-BH",
        0x3409: "en-PH",
        0x0454: "lo",
        0x400A: "es-BO",
        0x0C01: "ar",
        0x4809: "en-SG",
        0x0426: "lv",
        0x340A: "es-CL",
        0x0801: "ar-IQ",
        0x1C09: "en-ZA",
        0x0427: "lt",
        0x240A: "es-CO",
        0x2C01: "ar-JO",
        0x2C09: "en-TT",
        0x082E: "dsb",
        0x140A: "es-CR",
        0x3401: "ar-KW",
        0x0809: "en-GB",
        0x046E: "lb",
        0x1C0A: "es-DO",
        0x3001: "ar-LB",
        0x0409: "en",
        0x042F: "mk",
        0x300A: "es-EC",
        0x1001: "ar-LY",
        0x3009: "en-ZW",
        0x083E: "ms-BN",
        0x440A: "es-SV",
        0x1801: "ary",
        0x0425: "et",
        0x043E: "ms",
        0x100A: "es-GT",
        0x2001: "ar-OM",
        0x0438: "fo",
        0x044C: "ml",
        0x480A: "es-HN",
        0x4001: "ar-QA",
        0x0464: "fil",
        0x043A: "mt",
        0x080A: "es-MX",
        0x0401: "ar-SA",
        0x040B: "fi",
        0x0481: "mi",
        0x4C0A: "es-NI",
        0x2801: "ar-SY",
        0x080C: "fr-BE",
        0x047A: "arn",
        0x180A: "es-PA",
        0x1C01: "aeb",
        0x0C0C: "fr-CA",
        0x044E: "mr",
        0x3C0A: "es-PY",
        0x3801: "ar-AE",
        0x040C: "fr",
        0x047C: "moh",
        0x280A: "es-PE",
        0x2401: "ar-YE",
        0x140C: "fr-LU",
        0x0450: "mn",
        0x500A: "es-PR",
        0x042B: "hy",
        0x180C: "fr-MC",
        0x0850: "mn-CN",
        0x0C0A: "es",
        0x044D: "as",
        0x100C: "fr-CH",
        0x0461: "ne",
        0x040A: "es",
        0x082C: "az-Cyrl",
        0x0462: "fy",
        0x0414: "nb",
        0x540A: "es-US",
        0x042C: "az",
        0x0456: "gl",
        0x0814: "nn",
        0x380A: "es-UY",
        0x046D: "ba",
        0x0437: "ka",
        0x0482: "oc",
        0x200A: "es-VE",
        0x042D: "eu",
        0x0C07: "de-AT",
        0x0448: "or",
        0x081D: "sv-FI",
        0x0423: "be",
        0x0407: "de",
        0x0463: "ps",
        0x041D: "sv",
        0x0845: "bn",
        0x1407: "de-LI",
        0x0415: "pl",
        0x045A: "syr",
        0x0445: "bn-IN",
        0x1007: "de-LU",
        0x0416: "pt",
        0x0428: "tg",
        0x201A: "bs-Cyrl",
        0x0807: "de-CH",
        0x0816: "pt-PT",
        0x085F: "tzm",
        0x141A: "bs",
        0x0408: "el",
        0x0446: "pa",
        0x0449: "ta",
        0x047E: "br",
        0x046F: "kl",
        0x046B: "qu-BO",
        0x0444: "tt",
        0x0402: "bg",
        0x0447: "gu",
        0x086B: "qu-EC",
        0x044A: "te",
        0x0403: "ca",
        0x0468: "ha",
        0x0C6B: "qu",
        0x041E: "th",
        0x0C04: "zh-HK",
        0x040D: "he",
        0x0418: "ro",
        0x0451: "bo",
        0x1404: "zh-MO",
        0x0439: "hi",
        0x0417: "rm",
        0x041F: "tr",
        0x0804: "zh",
        0x040E: "hu",
        0x0419: "ru",
        0x0442: "tk",
        0x1004: "zh-SG",
        0x040F: "is",
        0x243B: "smn",
        0x0480: "ug",
        0x0404: "zh-TW",
        0x0470: "ig",
        0x103B: "smj-NO",
        0x0422: "uk",
        0x0483: "co",
        0x0421: "id",
        0x143B: "smj",
        0x042E: "hsb",
        0x041A: "hr",
        0x045D: "iu",
        0x0C3B: "se-FI",
        0x0420: "ur",
        0x101A: "hr-BA",
        0x085D: "iu-Latn",
        0x043B: "se",
        0x0843: "uz-Cyrl",
        0x0405: "cs",
        0x083C: "ga",
        0x083B: "se-SE",
        0x0443: "uz",
        0x0406: "da",
        0x0434: "xh",
        0x203B: "sms",
        0x042A: "vi",
        0x048C: "prs",
        0x0435: "zu",
        0x183B: "sma-NO",
        0x0452: "cy",
        0x0465: "dv",
        0x0410: "it",
        0x1C3B: "sms",
        0x0488: "wo",
        0x0813: "nl-BE",
        0x0810: "it-CH",
        0x044F: "sa",
        0x0485: "sah",
        0x0413: "nl",
        0x0411: "ja",
        0x1C1A: "sr-Cyrl-BA",
        0x0478: "ii",
        0x0C09: "en-AU",
        0x044B: "kn",
        0x0C1A: "sr",
        0x046A: "yo",
        0x2809: "en-BZ",
        0x043F: "kk",
        0x181A: "sr-Latn-BA",
        0x1009: "en-CA",
        0x0453: "km",
        0x081A: "sr-Latn",
        0x2409: "en-029",
        0x0486: "quc",
        0x046C: "nso"
    }
];
let $51a9f4feb3a3b2b1$var$NameRecord = new $gfJaN$restructure.Struct({
    platformID: $gfJaN$restructure.uint16,
    encodingID: $gfJaN$restructure.uint16,
    languageID: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16,
    length: $gfJaN$restructure.uint16,
    string: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.String("length", (t)=>$e2613b812f052cbe$export$badc544e0651b6b1(t.platformID, t.encodingID, t.languageID)), {
        type: "parent",
        relativeTo: (ctx)=>ctx.parent.stringOffset,
        allowNull: false
    })
});
let $51a9f4feb3a3b2b1$var$LangTagRecord = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    tag: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.String("length", "utf16be"), {
        type: "parent",
        relativeTo: (ctx)=>ctx.stringOffset
    })
});
var $51a9f4feb3a3b2b1$var$NameTable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        count: $gfJaN$restructure.uint16,
        stringOffset: $gfJaN$restructure.uint16,
        records: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$NameRecord, "count")
    },
    1: {
        count: $gfJaN$restructure.uint16,
        stringOffset: $gfJaN$restructure.uint16,
        records: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$NameRecord, "count"),
        langTagCount: $gfJaN$restructure.uint16,
        langTags: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$LangTagRecord, "langTagCount")
    }
});
var $51a9f4feb3a3b2b1$export$2e2bcd8739ae039 = $51a9f4feb3a3b2b1$var$NameTable;
const $51a9f4feb3a3b2b1$var$NAMES = [
    "copyright",
    "fontFamily",
    "fontSubfamily",
    "uniqueSubfamily",
    "fullName",
    "version",
    "postscriptName",
    "trademark",
    "manufacturer",
    "designer",
    "description",
    "vendorURL",
    "designerURL",
    "license",
    "licenseURL",
    null,
    "preferredFamily",
    "preferredSubfamily",
    "compatibleFull",
    "sampleText",
    "postscriptCIDFontName",
    "wwsFamilyName",
    "wwsSubfamilyName"
];
$51a9f4feb3a3b2b1$var$NameTable.process = function(stream) {
    var records = {};
    for (let record of this.records){
        // find out what language this is for
        let language = $e2613b812f052cbe$export$2092376fd002e13[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + "-" + record.languageID;
        // if the nameID is >= 256, it is a font feature record (AAT)
        let key = record.nameID >= 256 ? "fontFeatures" : $51a9f4feb3a3b2b1$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        let obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === "string" || typeof obj[language] !== "string") obj[language] = record.string;
    }
    this.records = records;
};
$51a9f4feb3a3b2b1$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    let records = [];
    for(let key in this.records){
        let val = this.records[key];
        if (key === "fontFeatures") continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length * 2,
            string: val.en
        });
        if (key === "postscriptName") records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $51a9f4feb3a3b2b1$var$NameTable.size(this, null, false);
};
var $114ea85db469b435$var$OS2 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        xAvgCharWidth: $gfJaN$restructure.int16,
        usWeightClass: $gfJaN$restructure.uint16,
        usWidthClass: $gfJaN$restructure.uint16,
        fsType: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
            null,
            "noEmbedding",
            "viewOnly",
            "editable",
            null,
            null,
            null,
            null,
            "noSubsetting",
            "bitmapOnly"
        ]),
        ySubscriptXSize: $gfJaN$restructure.int16,
        ySubscriptYSize: $gfJaN$restructure.int16,
        ySubscriptXOffset: $gfJaN$restructure.int16,
        ySubscriptYOffset: $gfJaN$restructure.int16,
        ySuperscriptXSize: $gfJaN$restructure.int16,
        ySuperscriptYSize: $gfJaN$restructure.int16,
        ySuperscriptXOffset: $gfJaN$restructure.int16,
        ySuperscriptYOffset: $gfJaN$restructure.int16,
        yStrikeoutSize: $gfJaN$restructure.int16,
        yStrikeoutPosition: $gfJaN$restructure.int16,
        sFamilyClass: $gfJaN$restructure.int16,
        panose: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, 10),
        ulCharRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 4),
        vendorID: new $gfJaN$restructure.String(4),
        fsSelection: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
            "italic",
            "underscore",
            "negative",
            "outlined",
            "strikeout",
            "bold",
            "regular",
            "useTypoMetrics",
            "wws",
            "oblique"
        ]),
        usFirstCharIndex: $gfJaN$restructure.uint16,
        usLastCharIndex: $gfJaN$restructure.uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2),
        xHeight: $gfJaN$restructure.int16,
        capHeight: $gfJaN$restructure.int16,
        defaultChar: $gfJaN$restructure.uint16,
        breakChar: $gfJaN$restructure.uint16,
        maxContent: $gfJaN$restructure.uint16
    },
    5: {
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2),
        xHeight: $gfJaN$restructure.int16,
        capHeight: $gfJaN$restructure.int16,
        defaultChar: $gfJaN$restructure.uint16,
        breakChar: $gfJaN$restructure.uint16,
        maxContent: $gfJaN$restructure.uint16,
        usLowerOpticalPointSize: $gfJaN$restructure.uint16,
        usUpperOpticalPointSize: $gfJaN$restructure.uint16
    }
});
let $114ea85db469b435$var$versions = $114ea85db469b435$var$OS2.versions;
$114ea85db469b435$var$versions[3] = $114ea85db469b435$var$versions[4] = $114ea85db469b435$var$versions[2];
var $114ea85db469b435$export$2e2bcd8739ae039 = $114ea85db469b435$var$OS2;
var $f93b30299e1ea0f5$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.fixed32, {
    header: {
        italicAngle: $gfJaN$restructure.fixed32,
        underlinePosition: $gfJaN$restructure.int16,
        underlineThickness: $gfJaN$restructure.int16,
        isFixedPitch: $gfJaN$restructure.uint32,
        minMemType42: $gfJaN$restructure.uint32,
        maxMemType42: $gfJaN$restructure.uint32,
        minMemType1: $gfJaN$restructure.uint32,
        maxMemType1: $gfJaN$restructure.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    2: {
        numberOfGlyphs: $gfJaN$restructure.uint16,
        glyphNameIndex: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numberOfGlyphs"),
        names: new $gfJaN$restructure.Array(new $gfJaN$restructure.String($gfJaN$restructure.uint8))
    },
    2.5: {
        numberOfGlyphs: $gfJaN$restructure.uint16,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "numberOfGlyphs")
    },
    3: {},
    4: {
        map: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, (t)=>t.parent.maxp.numGlyphs)
    }
});
var $8fb09b0f473d61a0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    controlValues: new $gfJaN$restructure.Array($gfJaN$restructure.int16)
});
var // These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
$873d79fea57d3161$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    instructions: new $gfJaN$restructure.Array($gfJaN$restructure.uint8)
});
let $83c4155666d50c37$var$loca = new $gfJaN$restructure.VersionedStruct("head.indexToLocFormat", {
    0: {
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16)
    },
    1: {
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32)
    }
});
$83c4155666d50c37$var$loca.process = function() {
    if (this.version === 0 && !this._processed) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
        this._processed = true;
    }
};
$83c4155666d50c37$var$loca.preEncode = function() {
    if (this.version === 0 && this._processed !== false) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
        this._processed = false;
    }
};
var $83c4155666d50c37$export$2e2bcd8739ae039 = $83c4155666d50c37$var$loca;
var $b12598db7cdf7042$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    controlValueProgram: new $gfJaN$restructure.Array($gfJaN$restructure.uint8)
});
var $7707bdf21a3d89cc$export$2e2bcd8739ae039 = new $gfJaN$restructure.Array(new $gfJaN$restructure.Buffer);
class $9eaea3754914a290$export$2e2bcd8739ae039 {
    getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    }
    decode(stream, parent) {
        let version = this.getCFFVersion(parent);
        let count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        let offSize = stream.readUInt8();
        let offsetType;
        if (offSize === 1) offsetType = $gfJaN$restructure.uint8;
        else if (offSize === 2) offsetType = $gfJaN$restructure.uint16;
        else if (offSize === 3) offsetType = $gfJaN$restructure.uint24;
        else if (offSize === 4) offsetType = $gfJaN$restructure.uint32;
        else throw new Error(`Bad offset size in CFFIndex: ${offSize} ${stream.pos}`);
        let ret = [];
        let startPos = stream.pos + (count + 1) * offSize - 1;
        let start = offsetType.decode(stream);
        for(let i = 0; i < count; i++){
            let end = offsetType.decode(stream);
            if (this.type != null) {
                let pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    }
    size(arr, parent) {
        let size = 2;
        if (arr.length === 0) return size;
        let type = this.type || new $gfJaN$restructure.Buffer;
        // find maximum offset to detminine offset type
        let offset = 1;
        for(let i = 0; i < arr.length; i++){
            let item = arr[i];
            offset += type.size(item, parent);
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $gfJaN$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $gfJaN$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $gfJaN$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $gfJaN$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    }
    encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        let type = this.type || new $gfJaN$restructure.Buffer;
        // find maximum offset to detminine offset type
        let sizes = [];
        let offset = 1;
        for (let item of arr){
            let s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $gfJaN$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $gfJaN$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $gfJaN$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $gfJaN$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        // write offset size
        stream.writeUInt8(offsetType.size());
        // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for (let size of sizes){
            offset += size;
            offsetType.encode(stream, offset);
        }
        for (let item1 of arr)type.encode(stream, item1, parent);
        return;
    }
    constructor(type){
        this.type = type;
    }
}
const $f77b592c17132d70$var$FLOAT_EOF = 0xf;
const $f77b592c17132d70$var$FLOAT_LOOKUP = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "E",
    "E-",
    null,
    "-"
];
const $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP = {
    ".": 10,
    "E": 11,
    "E-": 12,
    "-": 14
};
class $f77b592c17132d70$export$2e2bcd8739ae039 {
    static decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            let str = "";
            while(true){
                let b = stream.readUInt8();
                let n1 = b >> 4;
                if (n1 === $f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f77b592c17132d70$var$FLOAT_LOOKUP[n1];
                let n2 = b & 15;
                if (n2 === $f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f77b592c17132d70$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    }
    static size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            let str = "" + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    }
    static encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        let val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            stream.writeUInt8(30);
            let str = "" + val;
            for(let i = 0; i < str.length; i += 2){
                let c1 = str[i];
                let n1 = $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $f77b592c17132d70$var$FLOAT_EOF;
                else {
                    let c2 = str[i + 1];
                    var n2 = $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $f77b592c17132d70$var$FLOAT_EOF) return stream.writeUInt8($f77b592c17132d70$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    }
}
class $efe622f40a9c35bd$export$2e2bcd8739ae039 {
    decodeOperands(type, stream, ret, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.decodeOperands(type[i], stream, ret, [
                op
            ]));
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case "number":
            case "offset":
            case "sid":
                return operands[0];
            case "boolean":
                return !!operands[0];
            default:
                return operands;
        }
    }
    encodeOperands(type, stream, ctx, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.encodeOperands(type[i], stream, ctx, op)[0]);
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === "number") return [
            operands
        ];
        else if (typeof operands === "boolean") return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    }
    decode(stream, parent) {
        let end = stream.pos + parent.length;
        let ret = {};
        let operands = [];
        // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        });
        // fill in defaults
        for(let key in this.fields){
            let field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            let b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                let field = this.fields[b];
                if (!field) throw new Error(`Unknown operator ${b}`);
                let val = this.decodeOperands(field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof $gfJaN$restructure.PropertyDescriptor) Object.defineProperty(ret, field[1], val);
                    else ret[field[1]] = val;
                }
                operands = [];
            } else operands.push($f77b592c17132d70$export$2e2bcd8739ae039.decode(stream, b));
        }
        return ret;
    }
    size(dict, parent, includePointers = true) {
        let ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        let len = 0;
        for(let k in this.fields){
            let field = this.fields[k];
            let val = dict[field[1]];
            if (val == null || $parcel$interopDefault($gfJaN$fastdeepequal)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], null, ctx, val);
            for (let op of operands)len += $f77b592c17132d70$export$2e2bcd8739ae039.size(op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    }
    encode(stream, dict, parent) {
        let ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for (let field of this.ops){
            let val = dict[field[1]];
            if (val == null || $parcel$interopDefault($gfJaN$fastdeepequal)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], stream, ctx, val);
            for (let op of operands)$f77b592c17132d70$export$2e2bcd8739ae039.encode(stream, op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for (let op1 of key)stream.writeUInt8(op1);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            let ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    }
    constructor(ops = []){
        this.ops = ops;
        this.fields = {};
        for (let field of ops){
            let key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
}
class $4aa1b0749c2770f8$export$2e2bcd8739ae039 extends $gfJaN$restructure.Pointer {
    decode(stream, parent, operands) {
        this.offsetType = {
            decode: ()=>operands[0]
        };
        return super.decode(stream, parent, operands);
    }
    encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: ()=>0
            };
            this.size(value, ctx);
            return [
                new $4aa1b0749c2770f8$var$Ptr(0)
            ];
        }
        let ptr = null;
        this.offsetType = {
            encode: (stream, val)=>ptr = val
        };
        super.encode(stream, value, ctx);
        return [
            new $4aa1b0749c2770f8$var$Ptr(ptr)
        ];
    }
    constructor(type, options = {}){
        if (options.type == null) options.type = "global";
        super(null, type, options);
    }
}
class $4aa1b0749c2770f8$var$Ptr {
    valueOf() {
        return this.val;
    }
    constructor(val){
        this.val = val;
        this.forceLarge = true;
    }
}
class $15a0cbb3d09cf7ee$var$CFFBlendOp {
    static decode(stream, parent, operands) {
        let numBlends = operands.pop();
        // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    }
}
var $15a0cbb3d09cf7ee$export$2e2bcd8739ae039 = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                    type                                          default
    [
        6,
        "BlueValues",
        "delta",
        null
    ],
    [
        7,
        "OtherBlues",
        "delta",
        null
    ],
    [
        8,
        "FamilyBlues",
        "delta",
        null
    ],
    [
        9,
        "FamilyOtherBlues",
        "delta",
        null
    ],
    [
        [
            12,
            9
        ],
        "BlueScale",
        "number",
        0.039625
    ],
    [
        [
            12,
            10
        ],
        "BlueShift",
        "number",
        7
    ],
    [
        [
            12,
            11
        ],
        "BlueFuzz",
        "number",
        1
    ],
    [
        10,
        "StdHW",
        "number",
        null
    ],
    [
        11,
        "StdVW",
        "number",
        null
    ],
    [
        [
            12,
            12
        ],
        "StemSnapH",
        "delta",
        null
    ],
    [
        [
            12,
            13
        ],
        "StemSnapV",
        "delta",
        null
    ],
    [
        [
            12,
            14
        ],
        "ForceBold",
        "boolean",
        false
    ],
    [
        [
            12,
            17
        ],
        "LanguageGroup",
        "number",
        0
    ],
    [
        [
            12,
            18
        ],
        "ExpansionFactor",
        "number",
        0.06
    ],
    [
        [
            12,
            19
        ],
        "initialRandomSeed",
        "number",
        0
    ],
    [
        20,
        "defaultWidthX",
        "number",
        0
    ],
    [
        21,
        "nominalWidthX",
        "number",
        0
    ],
    [
        22,
        "vsindex",
        "number",
        0
    ],
    [
        23,
        "blend",
        $15a0cbb3d09cf7ee$var$CFFBlendOp,
        null
    ],
    [
        19,
        "Subrs",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039, {
            type: "local"
        }),
        null
    ]
]);
var // not edit. Length should be 391.
$860d3574d7fa3a51$export$2e2bcd8739ae039 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
let $c4ffe47cba1d7f36$export$dee0027060fa13bd = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "",
    "questiondown",
    "",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "",
    "ring",
    "cedilla",
    "",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "AE",
    "",
    "ordfeminine",
    "",
    "",
    "",
    "",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "",
    "",
    "",
    "",
    "",
    "ae",
    "",
    "",
    "",
    "dotlessi",
    "",
    "",
    "lslash",
    "oslash",
    "oe",
    "germandbls"
];
let $c4ffe47cba1d7f36$export$4f58f497e14a53c3 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "space",
    "exclamsmall",
    "Hungarumlautsmall",
    "",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "",
    "",
    "isuperior",
    "",
    "",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "",
    "",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "",
    "",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "",
    "Dotaccentsmall",
    "",
    "",
    "Macronsmall",
    "",
    "",
    "figuredash",
    "hypheninferior",
    "",
    "",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "",
    "",
    "",
    "onequarter",
    "onehalf",
    "threequarters",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "",
    "",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall"
];
let $1e7c7c16984e4427$export$c33b50336c234f16 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron"
];
let $1e7c7c16984e4427$export$3ed0f9e1fee8d489 = [
    ".notdef",
    "space",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "onequarter",
    "onehalf",
    "threequarters",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall"
];
let $1e7c7c16984e4427$export$dc28be11139d4120 = [
    ".notdef",
    "space",
    "dollaroldstyle",
    "dollarsuperior",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "hyphensuperior",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "centoldstyle",
    "figuredash",
    "hypheninferior",
    "onequarter",
    "onehalf",
    "threequarters",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior"
];
//########################
// Scripts and Languages #
//########################
let $b6dd765146ad212a$var$LangSysTable = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    reqFeatureIndex: $gfJaN$restructure.uint16,
    featureCount: $gfJaN$restructure.uint16,
    featureIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "featureCount")
});
let $b6dd765146ad212a$var$LangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    langSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$LangSysTable, {
        type: "parent"
    })
});
let $b6dd765146ad212a$var$Script = new $gfJaN$restructure.Struct({
    defaultLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$LangSysTable),
    count: $gfJaN$restructure.uint16,
    langSysRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LangSysRecord, "count")
});
let $b6dd765146ad212a$var$ScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$Script, {
        type: "parent"
    })
});
let $b6dd765146ad212a$export$3e15fc05ce864229 = new $gfJaN$restructure.Array($b6dd765146ad212a$var$ScriptRecord, $gfJaN$restructure.uint16);
//#######################
// Features and Lookups #
//#######################
let $b6dd765146ad212a$var$FeatureParams = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$6e91cf7616333d5 = new $gfJaN$restructure.Struct({
    featureParams: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$FeatureParams),
    lookupCount: $gfJaN$restructure.uint16,
    lookupListIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "lookupCount")
});
let $b6dd765146ad212a$var$FeatureRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    feature: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$6e91cf7616333d5, {
        type: "parent"
    })
});
let $b6dd765146ad212a$export$aa18130def4b6cb4 = new $gfJaN$restructure.Array($b6dd765146ad212a$var$FeatureRecord, $gfJaN$restructure.uint16);
let $b6dd765146ad212a$var$LookupFlags = new $gfJaN$restructure.Struct({
    markAttachmentType: $gfJaN$restructure.uint8,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        "rightToLeft",
        "ignoreBaseGlyphs",
        "ignoreLigatures",
        "ignoreMarks",
        "useMarkFilteringSet"
    ])
});
function $b6dd765146ad212a$export$df0008c6ff2da22a(SubTable) {
    let Lookup = new $gfJaN$restructure.Struct({
        lookupType: $gfJaN$restructure.uint16,
        flags: $b6dd765146ad212a$var$LookupFlags,
        subTableCount: $gfJaN$restructure.uint16,
        subTables: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, SubTable), "subTableCount"),
        markFilteringSet: new $gfJaN$restructure.Optional($gfJaN$restructure.uint16, (t)=>t.flags.flags.useMarkFilteringSet)
    });
    return new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, Lookup), $gfJaN$restructure.uint16);
}
//#################
// Coverage Table #
//#################
let $b6dd765146ad212a$var$RangeRecord = new $gfJaN$restructure.Struct({
    start: $gfJaN$restructure.uint16,
    end: $gfJaN$restructure.uint16,
    startCoverageIndex: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$17608c3f81a6111 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        glyphCount: $gfJaN$restructure.uint16,
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    },
    2: {
        rangeCount: $gfJaN$restructure.uint16,
        rangeRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$RangeRecord, "rangeCount")
    }
});
//#########################
// Class Definition Table #
//#########################
let $b6dd765146ad212a$var$ClassRangeRecord = new $gfJaN$restructure.Struct({
    start: $gfJaN$restructure.uint16,
    end: $gfJaN$restructure.uint16,
    class: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$843d551fbbafef71 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        startGlyph: $gfJaN$restructure.uint16,
        glyphCount: $gfJaN$restructure.uint16,
        classValueArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    },
    2: {
        classRangeCount: $gfJaN$restructure.uint16,
        classRangeRecord: new $gfJaN$restructure.Array($b6dd765146ad212a$var$ClassRangeRecord, "classRangeCount")
    }
});
let $b6dd765146ad212a$export$8215d14a63d9fb10 = new $gfJaN$restructure.Struct({
    a: $gfJaN$restructure.uint16,
    b: $gfJaN$restructure.uint16,
    deltaFormat: $gfJaN$restructure.uint16
});
//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
let $b6dd765146ad212a$var$LookupRecord = new $gfJaN$restructure.Struct({
    sequenceIndex: $gfJaN$restructure.uint16,
    lookupListIndex: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$var$Rule = new $gfJaN$restructure.Struct({
    glyphCount: $gfJaN$restructure.uint16,
    lookupCount: $gfJaN$restructure.uint16,
    input: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$RuleSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$Rule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$var$ClassRule = new $gfJaN$restructure.Struct({
    glyphCount: $gfJaN$restructure.uint16,
    lookupCount: $gfJaN$restructure.uint16,
    classes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$ClassSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ClassRule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$export$841858b892ce1f4c = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        ruleSetCount: $gfJaN$restructure.uint16,
        ruleSets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$RuleSet), "ruleSetCount")
    },
    2: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        classSetCnt: $gfJaN$restructure.uint16,
        classSet: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ClassSet), "classSetCnt")
    },
    3: {
        glyphCount: $gfJaN$restructure.uint16,
        lookupCount: $gfJaN$restructure.uint16,
        coverages: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "glyphCount"),
        lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
    }
});
//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
let $b6dd765146ad212a$var$ChainRule = new $gfJaN$restructure.Struct({
    backtrackGlyphCount: $gfJaN$restructure.uint16,
    backtrack: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "backtrackGlyphCount"),
    inputGlyphCount: $gfJaN$restructure.uint16,
    input: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.inputGlyphCount - 1),
    lookaheadGlyphCount: $gfJaN$restructure.uint16,
    lookahead: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "lookaheadGlyphCount"),
    lookupCount: $gfJaN$restructure.uint16,
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$ChainRuleSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$export$5e6d09e6861162f6 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        chainCount: $gfJaN$restructure.uint16,
        chainRuleSets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRuleSet), "chainCount")
    },
    2: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        backtrackClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        inputClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        lookaheadClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        chainCount: $gfJaN$restructure.uint16,
        chainClassSet: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRuleSet), "chainCount")
    },
    3: {
        backtrackGlyphCount: $gfJaN$restructure.uint16,
        backtrackCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "backtrackGlyphCount"),
        inputGlyphCount: $gfJaN$restructure.uint16,
        inputCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "inputGlyphCount"),
        lookaheadGlyphCount: $gfJaN$restructure.uint16,
        lookaheadCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "lookaheadGlyphCount"),
        lookupCount: $gfJaN$restructure.uint16,
        lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
    }
});
/*******************
 * Variation Store *
 *******************/ let $2e4adcda047b3383$var$F2DOT14 = new $gfJaN$restructure.Fixed(16, "BE", 14);
let $2e4adcda047b3383$var$RegionAxisCoordinates = new $gfJaN$restructure.Struct({
    startCoord: $2e4adcda047b3383$var$F2DOT14,
    peakCoord: $2e4adcda047b3383$var$F2DOT14,
    endCoord: $2e4adcda047b3383$var$F2DOT14
});
let $2e4adcda047b3383$var$VariationRegionList = new $gfJaN$restructure.Struct({
    axisCount: $gfJaN$restructure.uint16,
    regionCount: $gfJaN$restructure.uint16,
    variationRegions: new $gfJaN$restructure.Array(new $gfJaN$restructure.Array($2e4adcda047b3383$var$RegionAxisCoordinates, "axisCount"), "regionCount")
});
let $2e4adcda047b3383$var$DeltaSet = new $gfJaN$restructure.Struct({
    shortDeltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, (t)=>t.parent.shortDeltaCount),
    regionDeltas: new $gfJaN$restructure.Array($gfJaN$restructure.int8, (t)=>t.parent.regionIndexCount - t.parent.shortDeltaCount),
    deltas: (t)=>t.shortDeltas.concat(t.regionDeltas)
});
let $2e4adcda047b3383$var$ItemVariationData = new $gfJaN$restructure.Struct({
    itemCount: $gfJaN$restructure.uint16,
    shortDeltaCount: $gfJaN$restructure.uint16,
    regionIndexCount: $gfJaN$restructure.uint16,
    regionIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "regionIndexCount"),
    deltaSets: new $gfJaN$restructure.Array($2e4adcda047b3383$var$DeltaSet, "itemCount")
});
let $2e4adcda047b3383$export$fe1b122a2710f241 = new $gfJaN$restructure.Struct({
    format: $gfJaN$restructure.uint16,
    variationRegionList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$VariationRegionList),
    variationDataCount: $gfJaN$restructure.uint16,
    itemVariationData: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ItemVariationData), "variationDataCount")
});
/**********************
 * Feature Variations *
 **********************/ let $2e4adcda047b3383$var$ConditionTable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        axisIndex: $gfJaN$restructure.uint16,
        axisIndex: $gfJaN$restructure.uint16,
        filterRangeMinValue: $2e4adcda047b3383$var$F2DOT14,
        filterRangeMaxValue: $2e4adcda047b3383$var$F2DOT14
    }
});
let $2e4adcda047b3383$var$ConditionSet = new $gfJaN$restructure.Struct({
    conditionCount: $gfJaN$restructure.uint16,
    conditionTable: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ConditionTable), "conditionCount")
});
let $2e4adcda047b3383$var$FeatureTableSubstitutionRecord = new $gfJaN$restructure.Struct({
    featureIndex: $gfJaN$restructure.uint16,
    alternateFeatureTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $b6dd765146ad212a$export$6e91cf7616333d5, {
        type: "parent"
    })
});
let $2e4adcda047b3383$var$FeatureTableSubstitution = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    substitutionCount: $gfJaN$restructure.uint16,
    substitutions: new $gfJaN$restructure.Array($2e4adcda047b3383$var$FeatureTableSubstitutionRecord, "substitutionCount")
});
let $2e4adcda047b3383$var$FeatureVariationRecord = new $gfJaN$restructure.Struct({
    conditionSet: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ConditionSet, {
        type: "parent"
    }),
    featureTableSubstitution: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$FeatureTableSubstitution, {
        type: "parent"
    })
});
let $2e4adcda047b3383$export$441b70b7971dd419 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    featureVariationRecordCount: $gfJaN$restructure.uint32,
    featureVariationRecords: new $gfJaN$restructure.Array($2e4adcda047b3383$var$FeatureVariationRecord, "featureVariationRecordCount")
});
// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.
class $5b547cf9e5da519b$var$PredefinedOp {
    decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    }
    size(value, ctx) {
        return this.type.size(value, ctx);
    }
    encode(stream, value, ctx) {
        let index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    }
    constructor(predefinedOps, type){
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
}
class $5b547cf9e5da519b$var$CFFEncodingVersion extends $gfJaN$restructure.Number {
    decode(stream) {
        return $gfJaN$restructure.uint8.decode(stream) & 0x7f;
    }
    constructor(){
        super("UInt8");
    }
}
let $5b547cf9e5da519b$var$Range1 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    nLeft: $gfJaN$restructure.uint8
});
let $5b547cf9e5da519b$var$Range2 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    nLeft: $gfJaN$restructure.uint16
});
let $5b547cf9e5da519b$var$CFFCustomEncoding = new $gfJaN$restructure.VersionedStruct(new $5b547cf9e5da519b$var$CFFEncodingVersion(), {
    0: {
        nCodes: $gfJaN$restructure.uint8,
        codes: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "nCodes")
    },
    1: {
        nRanges: $gfJaN$restructure.uint8,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$Range1, "nRanges")
    }
});
let $5b547cf9e5da519b$var$CFFEncoding = new $5b547cf9e5da519b$var$PredefinedOp([
    $c4ffe47cba1d7f36$export$dee0027060fa13bd,
    $c4ffe47cba1d7f36$export$4f58f497e14a53c3
], new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFCustomEncoding, {
    lazy: true
}));
// Decodes an array of ranges until the total
// length is equal to the provided length.
class $5b547cf9e5da519b$var$RangeArray extends $gfJaN$restructure.Array {
    decode(stream, parent) {
        let length = (0, $gfJaN$restructure.resolveLength)(this.length, stream, parent);
        let count = 0;
        let res = [];
        while(count < length){
            let range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    }
}
let $5b547cf9e5da519b$var$CFFCustomCharset = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint8, {
    0: {
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.parent.CharStrings.length - 1)
    },
    1: {
        ranges: new $5b547cf9e5da519b$var$RangeArray($5b547cf9e5da519b$var$Range1, (t)=>t.parent.CharStrings.length - 1)
    },
    2: {
        ranges: new $5b547cf9e5da519b$var$RangeArray($5b547cf9e5da519b$var$Range2, (t)=>t.parent.CharStrings.length - 1)
    }
});
let $5b547cf9e5da519b$var$CFFCharset = new $5b547cf9e5da519b$var$PredefinedOp([
    $1e7c7c16984e4427$export$c33b50336c234f16,
    $1e7c7c16984e4427$export$3ed0f9e1fee8d489,
    $1e7c7c16984e4427$export$dc28be11139d4120
], new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFCustomCharset, {
    lazy: true
}));
let $5b547cf9e5da519b$var$FDRange3 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    fd: $gfJaN$restructure.uint8
});
let $5b547cf9e5da519b$var$FDRange4 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint32,
    fd: $gfJaN$restructure.uint16
});
let $5b547cf9e5da519b$var$FDSelect = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint8, {
    0: {
        fds: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.parent.CharStrings.length)
    },
    3: {
        nRanges: $gfJaN$restructure.uint16,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$FDRange3, "nRanges"),
        sentinel: $gfJaN$restructure.uint16
    },
    4: {
        nRanges: $gfJaN$restructure.uint32,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$FDRange4, "nRanges"),
        sentinel: $gfJaN$restructure.uint32
    }
});
let $5b547cf9e5da519b$var$ptr = new $4aa1b0749c2770f8$export$2e2bcd8739ae039($15a0cbb3d09cf7ee$export$2e2bcd8739ae039);
class $5b547cf9e5da519b$var$CFFPrivateOp {
    decode(stream, parent, operands) {
        parent.length = operands[0];
        return $5b547cf9e5da519b$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    }
    size(dict, ctx) {
        return [
            $15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $5b547cf9e5da519b$var$ptr.size(dict, ctx)[0]
        ];
    }
    encode(stream, dict, ctx) {
        return [
            $15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $5b547cf9e5da519b$var$ptr.encode(stream, dict, ctx)[0]
        ];
    }
}
let $5b547cf9e5da519b$var$FontDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        18,
        "Private",
        new $5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            38
        ],
        "FontName",
        "sid",
        null
    ],
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        [
            12,
            5
        ],
        "PaintType",
        "number",
        0
    ]
]);
let $5b547cf9e5da519b$var$CFFTopDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        [
            12,
            30
        ],
        "ROS",
        [
            "sid",
            "sid",
            "number"
        ],
        null
    ],
    [
        0,
        "version",
        "sid",
        null
    ],
    [
        1,
        "Notice",
        "sid",
        null
    ],
    [
        [
            12,
            0
        ],
        "Copyright",
        "sid",
        null
    ],
    [
        2,
        "FullName",
        "sid",
        null
    ],
    [
        3,
        "FamilyName",
        "sid",
        null
    ],
    [
        4,
        "Weight",
        "sid",
        null
    ],
    [
        [
            12,
            1
        ],
        "isFixedPitch",
        "boolean",
        false
    ],
    [
        [
            12,
            2
        ],
        "ItalicAngle",
        "number",
        0
    ],
    [
        [
            12,
            3
        ],
        "UnderlinePosition",
        "number",
        -100
    ],
    [
        [
            12,
            4
        ],
        "UnderlineThickness",
        "number",
        50
    ],
    [
        [
            12,
            5
        ],
        "PaintType",
        "number",
        0
    ],
    [
        [
            12,
            6
        ],
        "CharstringType",
        "number",
        2
    ],
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        "UniqueID",
        "number",
        null
    ],
    [
        5,
        "FontBBox",
        "array",
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        "StrokeWidth",
        "number",
        0
    ],
    [
        14,
        "XUID",
        "array",
        null
    ],
    [
        15,
        "charset",
        $5b547cf9e5da519b$var$CFFCharset,
        $1e7c7c16984e4427$export$c33b50336c234f16
    ],
    [
        16,
        "Encoding",
        $5b547cf9e5da519b$var$CFFEncoding,
        $c4ffe47cba1d7f36$export$dee0027060fa13bd
    ],
    [
        17,
        "CharStrings",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        18,
        "Private",
        new $5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            20
        ],
        "SyntheticBase",
        "number",
        null
    ],
    [
        [
            12,
            21
        ],
        "PostScript",
        "sid",
        null
    ],
    [
        [
            12,
            22
        ],
        "BaseFontName",
        "sid",
        null
    ],
    [
        [
            12,
            23
        ],
        "BaseFontBlend",
        "delta",
        null
    ],
    // CID font specific
    [
        [
            12,
            31
        ],
        "CIDFontVersion",
        "number",
        0
    ],
    [
        [
            12,
            32
        ],
        "CIDFontRevision",
        "number",
        0
    ],
    [
        [
            12,
            33
        ],
        "CIDFontType",
        "number",
        0
    ],
    [
        [
            12,
            34
        ],
        "CIDCount",
        "number",
        8720
    ],
    [
        [
            12,
            35
        ],
        "UIDBase",
        "number",
        null
    ],
    [
        [
            12,
            37
        ],
        "FDSelect",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        "FDArray",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        "FontName",
        "sid",
        null
    ]
]);
let $5b547cf9e5da519b$var$VariationStore = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    itemVariationStore: $2e4adcda047b3383$export$fe1b122a2710f241
});
let $5b547cf9e5da519b$var$CFF2TopDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        "CharStrings",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        [
            12,
            37
        ],
        "FDSelect",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        "FDArray",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        24,
        "vstore",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$VariationStore),
        null
    ],
    [
        25,
        "maxstack",
        "number",
        193
    ]
]);
let $5b547cf9e5da519b$var$CFFTop = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.fixed16, {
    1: {
        hdrSize: $gfJaN$restructure.uint8,
        offSize: $gfJaN$restructure.uint8,
        nameIndex: new $9eaea3754914a290$export$2e2bcd8739ae039(new $gfJaN$restructure.String("length")),
        topDictIndex: new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFTopDict),
        stringIndex: new $9eaea3754914a290$export$2e2bcd8739ae039(new $gfJaN$restructure.String("length")),
        globalSubrIndex: new $9eaea3754914a290$export$2e2bcd8739ae039
    },
    2: {
        hdrSize: $gfJaN$restructure.uint8,
        length: $gfJaN$restructure.uint16,
        topDict: $5b547cf9e5da519b$var$CFF2TopDict,
        globalSubrIndex: new $9eaea3754914a290$export$2e2bcd8739ae039
    }
});
var $5b547cf9e5da519b$export$2e2bcd8739ae039 = $5b547cf9e5da519b$var$CFFTop;
class $f717432b360040c7$var$CFFFont {
    static decode(stream) {
        return new $f717432b360040c7$var$CFFFont(stream);
    }
    decode() {
        let start = this.stream.pos;
        let top = $5b547cf9e5da519b$export$2e2bcd8739ae039.decode(this.stream);
        for(let key in top){
            let val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    }
    string(sid) {
        if (this.version >= 2) return null;
        if (sid < $860d3574d7fa3a51$export$2e2bcd8739ae039.length) return $860d3574d7fa3a51$export$2e2bcd8739ae039[sid];
        return this.stringIndex[sid - $860d3574d7fa3a51$export$2e2bcd8739ae039.length];
    }
    get postscriptName() {
        if (this.version < 2) return this.nameIndex[0];
        return null;
    }
    get fullName() {
        return this.string(this.topDict.FullName);
    }
    get familyName() {
        return this.string(this.topDict.FamilyName);
    }
    getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    }
    getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
        // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        let { charset: charset } = this.topDict;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return ".notdef";
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(let i = 0; i < charset.ranges.length; i++){
                    let range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    }
    fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                let { ranges: ranges } = this.topDict.FDSelect;
                let low = 0;
                let high = ranges.length - 1;
                while(low <= high){
                    let mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
        }
    }
    privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            let fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    }
    constructor(stream){
        this.stream = stream;
        this.decode();
    }
}
var $f717432b360040c7$export$2e2bcd8739ae039 = $f717432b360040c7$var$CFFFont;
let $8cb7ae73ed7aa7d8$var$VerticalOrigin = new $gfJaN$restructure.Struct({
    glyphIndex: $gfJaN$restructure.uint16,
    vertOriginY: $gfJaN$restructure.int16
});
var $8cb7ae73ed7aa7d8$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    defaultVertOriginY: $gfJaN$restructure.int16,
    numVertOriginYMetrics: $gfJaN$restructure.uint16,
    metrics: new $gfJaN$restructure.Array($8cb7ae73ed7aa7d8$var$VerticalOrigin, "numVertOriginYMetrics")
});
let $20e0c7bbecb76d75$export$16b227cb15d716a0 = new $gfJaN$restructure.Struct({
    height: $gfJaN$restructure.uint8,
    width: $gfJaN$restructure.uint8,
    horiBearingX: $gfJaN$restructure.int8,
    horiBearingY: $gfJaN$restructure.int8,
    horiAdvance: $gfJaN$restructure.uint8,
    vertBearingX: $gfJaN$restructure.int8,
    vertBearingY: $gfJaN$restructure.int8,
    vertAdvance: $gfJaN$restructure.uint8
});
let $20e0c7bbecb76d75$export$62c53e75f69bfe12 = new $gfJaN$restructure.Struct({
    height: $gfJaN$restructure.uint8,
    width: $gfJaN$restructure.uint8,
    bearingX: $gfJaN$restructure.int8,
    bearingY: $gfJaN$restructure.int8,
    advance: $gfJaN$restructure.uint8
});
let $20e0c7bbecb76d75$var$EBDTComponent = new $gfJaN$restructure.Struct({
    glyph: $gfJaN$restructure.uint16,
    xOffset: $gfJaN$restructure.int8,
    yOffset: $gfJaN$restructure.int8
});
class $20e0c7bbecb76d75$var$ByteAligned {
}
class $20e0c7bbecb76d75$var$BitAligned {
}
let $20e0c7bbecb76d75$export$f1f5ddeb20d14f = new $gfJaN$restructure.VersionedStruct("version", {
    1: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $20e0c7bbecb76d75$var$ByteAligned
    },
    2: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    6: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $20e0c7bbecb76d75$var$ByteAligned
    },
    7: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    8: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8),
        numComponents: $gfJaN$restructure.uint16,
        components: new $gfJaN$restructure.Array($20e0c7bbecb76d75$var$EBDTComponent, "numComponents")
    },
    9: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8),
        numComponents: $gfJaN$restructure.uint16,
        components: new $gfJaN$restructure.Array($20e0c7bbecb76d75$var$EBDTComponent, "numComponents")
    },
    17: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    },
    18: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    },
    19: {
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    }
});
let $035bb95c0cdb1f6d$var$SBitLineMetrics = new $gfJaN$restructure.Struct({
    ascender: $gfJaN$restructure.int8,
    descender: $gfJaN$restructure.int8,
    widthMax: $gfJaN$restructure.uint8,
    caretSlopeNumerator: $gfJaN$restructure.int8,
    caretSlopeDenominator: $gfJaN$restructure.int8,
    caretOffset: $gfJaN$restructure.int8,
    minOriginSB: $gfJaN$restructure.int8,
    minAdvanceSB: $gfJaN$restructure.int8,
    maxBeforeBL: $gfJaN$restructure.int8,
    minAfterBL: $gfJaN$restructure.int8,
    pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.int8, 2)
});
let $035bb95c0cdb1f6d$var$CodeOffsetPair = new $gfJaN$restructure.Struct({
    glyphCode: $gfJaN$restructure.uint16,
    offset: $gfJaN$restructure.uint16
});
let $035bb95c0cdb1f6d$var$IndexSubtable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        imageFormat: $gfJaN$restructure.uint16,
        imageDataOffset: $gfJaN$restructure.uint32
    },
    1: {
        offsetArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    2: {
        imageSize: $gfJaN$restructure.uint32,
        bigMetrics: $20e0c7bbecb76d75$export$16b227cb15d716a0
    },
    3: {
        offsetArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    4: {
        numGlyphs: $gfJaN$restructure.uint32,
        glyphArray: new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$CodeOffsetPair, (t)=>t.numGlyphs + 1)
    },
    5: {
        imageSize: $gfJaN$restructure.uint32,
        bigMetrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        numGlyphs: $gfJaN$restructure.uint32,
        glyphCodeArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numGlyphs")
    }
});
let $035bb95c0cdb1f6d$var$IndexSubtableArray = new $gfJaN$restructure.Struct({
    firstGlyphIndex: $gfJaN$restructure.uint16,
    lastGlyphIndex: $gfJaN$restructure.uint16,
    subtable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $035bb95c0cdb1f6d$var$IndexSubtable)
});
let $035bb95c0cdb1f6d$var$BitmapSizeTable = new $gfJaN$restructure.Struct({
    indexSubTableArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$IndexSubtableArray, 1), {
        type: "parent"
    }),
    indexTablesSize: $gfJaN$restructure.uint32,
    numberOfIndexSubTables: $gfJaN$restructure.uint32,
    colorRef: $gfJaN$restructure.uint32,
    hori: $035bb95c0cdb1f6d$var$SBitLineMetrics,
    vert: $035bb95c0cdb1f6d$var$SBitLineMetrics,
    startGlyphIndex: $gfJaN$restructure.uint16,
    endGlyphIndex: $gfJaN$restructure.uint16,
    ppemX: $gfJaN$restructure.uint8,
    ppemY: $gfJaN$restructure.uint8,
    bitDepth: $gfJaN$restructure.uint8,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        "horizontal",
        "vertical"
    ])
});
var $035bb95c0cdb1f6d$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    numSizes: $gfJaN$restructure.uint32,
    sizes: new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$BitmapSizeTable, "numSizes")
});
let $73d13900b55a3c0c$var$ImageTable = new $gfJaN$restructure.Struct({
    ppem: $gfJaN$restructure.uint16,
    resolution: $gfJaN$restructure.uint16,
    imageOffsets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void"), (t)=>t.parent.parent.maxp.numGlyphs + 1)
});
var // It includes several image tables with images for each bitmap glyph
// of several different sizes.
$73d13900b55a3c0c$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "renderOutlines"
    ]),
    numImgTables: $gfJaN$restructure.uint32,
    imageTables: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $73d13900b55a3c0c$var$ImageTable), "numImgTables")
});
let $97f6b8be3a347a8f$var$LayerRecord = new $gfJaN$restructure.Struct({
    gid: $gfJaN$restructure.uint16,
    paletteIndex: $gfJaN$restructure.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
let $97f6b8be3a347a8f$var$BaseGlyphRecord = new $gfJaN$restructure.Struct({
    gid: $gfJaN$restructure.uint16,
    // and is not rendered for color.
    firstLayerIndex: $gfJaN$restructure.uint16,
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: $gfJaN$restructure.uint16
});
var $97f6b8be3a347a8f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numBaseGlyphRecords: $gfJaN$restructure.uint16,
    baseGlyphRecord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($97f6b8be3a347a8f$var$BaseGlyphRecord, "numBaseGlyphRecords")),
    layerRecords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($97f6b8be3a347a8f$var$LayerRecord, "numLayerRecords"), {
        lazy: true
    }),
    numLayerRecords: $gfJaN$restructure.uint16
});
let $16ca60ecbdee30ea$var$ColorRecord = new $gfJaN$restructure.Struct({
    blue: $gfJaN$restructure.uint8,
    green: $gfJaN$restructure.uint8,
    red: $gfJaN$restructure.uint8,
    alpha: $gfJaN$restructure.uint8
});
var $16ca60ecbdee30ea$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        numPaletteEntries: $gfJaN$restructure.uint16,
        numPalettes: $gfJaN$restructure.uint16,
        numColorRecords: $gfJaN$restructure.uint16,
        colorRecords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($16ca60ecbdee30ea$var$ColorRecord, "numColorRecords")),
        colorRecordIndices: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPalettes")
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numPalettes")),
        offsetPaletteLabelArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPalettes")),
        offsetPaletteEntryLabelArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPaletteEntries"))
    }
});
let $7327e41706f9d5c7$var$BaseCoord = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coordinate: $gfJaN$restructure.int16 // X or Y value, in design units
    },
    2: {
        coordinate: $gfJaN$restructure.int16,
        referenceGlyph: $gfJaN$restructure.uint16,
        baseCoordPoint: $gfJaN$restructure.uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        coordinate: $gfJaN$restructure.int16,
        deviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10) // Device table for X or Y value
    }
});
let $7327e41706f9d5c7$var$BaseValues = new $gfJaN$restructure.Struct({
    defaultIndex: $gfJaN$restructure.uint16,
    baseCoordCount: $gfJaN$restructure.uint16,
    baseCoords: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord), "baseCoordCount")
});
let $7327e41706f9d5c7$var$FeatMinMaxRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    minCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord, {
        type: "parent"
    }),
    maxCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord, {
        type: "parent"
    }) // May be NULL
});
let $7327e41706f9d5c7$var$MinMax = new $gfJaN$restructure.Struct({
    minCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord),
    maxCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord),
    featMinMaxCount: $gfJaN$restructure.uint16,
    featMinMaxRecords: new $gfJaN$restructure.Array($7327e41706f9d5c7$var$FeatMinMaxRecord, "featMinMaxCount") // In alphabetical order
});
let $7327e41706f9d5c7$var$BaseLangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    minMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$MinMax, {
        type: "parent"
    })
});
let $7327e41706f9d5c7$var$BaseScript = new $gfJaN$restructure.Struct({
    baseValues: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseValues),
    defaultMinMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$MinMax),
    baseLangSysCount: $gfJaN$restructure.uint16,
    baseLangSysRecords: new $gfJaN$restructure.Array($7327e41706f9d5c7$var$BaseLangSysRecord, "baseLangSysCount") // in alphabetical order by BaseLangSysTag
});
let $7327e41706f9d5c7$var$BaseScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseScript, {
        type: "parent"
    })
});
let $7327e41706f9d5c7$var$BaseScriptList = new $gfJaN$restructure.Array($7327e41706f9d5c7$var$BaseScriptRecord, $gfJaN$restructure.uint16);
// Array of 4-byte baseline identification tags-must be in alphabetical order
let $7327e41706f9d5c7$var$BaseTagList = new $gfJaN$restructure.Array(new $gfJaN$restructure.String(4), $gfJaN$restructure.uint16);
let $7327e41706f9d5c7$var$Axis = new $gfJaN$restructure.Struct({
    baseTagList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseTagList),
    baseScriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseScriptList)
});
var $7327e41706f9d5c7$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        horizAxis: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$Axis),
        vertAxis: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $7e48bbe9e5345664$var$AttachPoint = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $7e48bbe9e5345664$var$AttachList = new $gfJaN$restructure.Struct({
    coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
    glyphCount: $gfJaN$restructure.uint16,
    attachPoints: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$AttachPoint), "glyphCount")
});
let $7e48bbe9e5345664$var$CaretValue = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coordinate: $gfJaN$restructure.int16
    },
    2: {
        caretValuePoint: $gfJaN$restructure.uint16
    },
    3: {
        coordinate: $gfJaN$restructure.int16,
        deviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $7e48bbe9e5345664$var$LigGlyph = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$CaretValue), $gfJaN$restructure.uint16);
let $7e48bbe9e5345664$var$LigCaretList = new $gfJaN$restructure.Struct({
    coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
    ligGlyphCount: $gfJaN$restructure.uint16,
    ligGlyphs: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$LigGlyph), "ligGlyphCount")
});
let $7e48bbe9e5345664$var$MarkGlyphSetsDef = new $gfJaN$restructure.Struct({
    markSetTableFormat: $gfJaN$restructure.uint16,
    markSetCount: $gfJaN$restructure.uint16,
    coverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $b6dd765146ad212a$export$17608c3f81a6111), "markSetCount")
});
var $7e48bbe9e5345664$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        glyphClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        attachList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$AttachList),
        ligCaretList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$LigCaretList),
        markAttachClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$MarkGlyphSetsDef),
        itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $b687332511a4da75$var$ValueFormat = new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
    "xPlacement",
    "yPlacement",
    "xAdvance",
    "yAdvance",
    "xPlaDevice",
    "yPlaDevice",
    "xAdvDevice",
    "yAdvDevice"
]);
let $b687332511a4da75$var$types = {
    xPlacement: $gfJaN$restructure.int16,
    yPlacement: $gfJaN$restructure.int16,
    xAdvance: $gfJaN$restructure.int16,
    yAdvance: $gfJaN$restructure.int16,
    xPlaDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    yPlaDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    xAdvDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    yAdvDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    })
};
class $b687332511a4da75$var$ValueRecord {
    buildStruct(parent) {
        let struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        let fields = {};
        fields.rel = ()=>struct._startOffset;
        let format = struct[this.key];
        for(let key in format)if (format[key]) fields[key] = $b687332511a4da75$var$types[key];
        return new $gfJaN$restructure.Struct(fields);
    }
    size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    }
    decode(stream, parent) {
        let res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    }
    constructor(key = "valueFormat"){
        this.key = key;
    }
}
let $b687332511a4da75$var$PairValueRecord = new $gfJaN$restructure.Struct({
    secondGlyph: $gfJaN$restructure.uint16,
    value1: new $b687332511a4da75$var$ValueRecord("valueFormat1"),
    value2: new $b687332511a4da75$var$ValueRecord("valueFormat2")
});
let $b687332511a4da75$var$PairSet = new $gfJaN$restructure.Array($b687332511a4da75$var$PairValueRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$Class2Record = new $gfJaN$restructure.Struct({
    value1: new $b687332511a4da75$var$ValueRecord("valueFormat1"),
    value2: new $b687332511a4da75$var$ValueRecord("valueFormat2")
});
let $b687332511a4da75$var$Anchor = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16
    },
    2: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16,
        anchorPoint: $gfJaN$restructure.uint16
    },
    3: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16,
        xDeviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10),
        yDeviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $b687332511a4da75$var$EntryExitRecord = new $gfJaN$restructure.Struct({
    entryAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    }),
    exitAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    })
});
let $b687332511a4da75$var$MarkRecord = new $gfJaN$restructure.Struct({
    class: $gfJaN$restructure.uint16,
    markAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    })
});
let $b687332511a4da75$var$MarkArray = new $gfJaN$restructure.Array($b687332511a4da75$var$MarkRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$BaseRecord = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor), (t)=>t.parent.classCount);
let $b687332511a4da75$var$BaseArray = new $gfJaN$restructure.Array($b687332511a4da75$var$BaseRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$ComponentRecord = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor), (t)=>t.parent.parent.classCount);
let $b687332511a4da75$var$LigatureAttach = new $gfJaN$restructure.Array($b687332511a4da75$var$ComponentRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$LigatureArray = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$LigatureAttach), $gfJaN$restructure.uint16);
let $b687332511a4da75$export$73a8cfb19cd43a0f = new $gfJaN$restructure.VersionedStruct("lookupType", {
    1: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $b687332511a4da75$var$ValueFormat,
            value: new $b687332511a4da75$var$ValueRecord()
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $b687332511a4da75$var$ValueFormat,
            valueCount: $gfJaN$restructure.uint16,
            values: new $gfJaN$restructure.LazyArray(new $b687332511a4da75$var$ValueRecord(), "valueCount")
        }
    }),
    2: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $b687332511a4da75$var$ValueFormat,
            valueFormat2: $b687332511a4da75$var$ValueFormat,
            pairSetCount: $gfJaN$restructure.uint16,
            pairSets: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$PairSet), "pairSetCount")
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $b687332511a4da75$var$ValueFormat,
            valueFormat2: $b687332511a4da75$var$ValueFormat,
            classDef1: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
            classDef2: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
            class1Count: $gfJaN$restructure.uint16,
            class2Count: $gfJaN$restructure.uint16,
            classRecords: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.LazyArray($b687332511a4da75$var$Class2Record, "class2Count"), "class1Count")
        }
    }),
    3: {
        format: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        entryExitCount: $gfJaN$restructure.uint16,
        entryExitRecords: new $gfJaN$restructure.Array($b687332511a4da75$var$EntryExitRecord, "entryExitCount")
    },
    4: {
        format: $gfJaN$restructure.uint16,
        markCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        baseCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        markArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        baseArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$BaseArray)
    },
    5: {
        format: $gfJaN$restructure.uint16,
        markCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        ligatureCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        markArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        ligatureArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$LigatureArray)
    },
    6: {
        format: $gfJaN$restructure.uint16,
        mark1Coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        mark2Coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        mark1Array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        mark2Array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$BaseArray)
    },
    7: $b6dd765146ad212a$export$841858b892ce1f4c,
    8: $b6dd765146ad212a$export$5e6d09e6861162f6,
    9: {
        posFormat: $gfJaN$restructure.uint16,
        lookupType: $gfJaN$restructure.uint16,
        extension: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, null)
    }
});
// Fix circular reference
$b687332511a4da75$export$73a8cfb19cd43a0f.versions[9].extension.type = $b687332511a4da75$export$73a8cfb19cd43a0f;
var $b687332511a4da75$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        scriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $99ccad60b96f92fb$var$Sequence = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $99ccad60b96f92fb$var$AlternateSet = $99ccad60b96f92fb$var$Sequence;
let $99ccad60b96f92fb$var$Ligature = new $gfJaN$restructure.Struct({
    glyph: $gfJaN$restructure.uint16,
    compCount: $gfJaN$restructure.uint16,
    components: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.compCount - 1)
});
let $99ccad60b96f92fb$var$LigatureSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$Ligature), $gfJaN$restructure.uint16);
let $99ccad60b96f92fb$var$GSUBLookup = new $gfJaN$restructure.VersionedStruct("lookupType", {
    1: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            deltaGlyphID: $gfJaN$restructure.int16
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            glyphCount: $gfJaN$restructure.uint16,
            substitute: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "glyphCount")
        }
    }),
    2: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        sequences: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$Sequence), "count")
    },
    3: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        alternateSet: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$AlternateSet), "count")
    },
    4: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        ligatureSets: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$LigatureSet), "count")
    },
    5: $b6dd765146ad212a$export$841858b892ce1f4c,
    6: $b6dd765146ad212a$export$5e6d09e6861162f6,
    7: {
        substFormat: $gfJaN$restructure.uint16,
        lookupType: $gfJaN$restructure.uint16,
        extension: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, null)
    },
    8: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        backtrackCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "backtrackGlyphCount"),
        lookaheadGlyphCount: $gfJaN$restructure.uint16,
        lookaheadCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "lookaheadGlyphCount"),
        glyphCount: $gfJaN$restructure.uint16,
        substitutes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    }
});
// Fix circular reference
$99ccad60b96f92fb$var$GSUBLookup.versions[7].extension.type = $99ccad60b96f92fb$var$GSUBLookup;
var $99ccad60b96f92fb$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        scriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($99ccad60b96f92fb$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $573d5042c76c4940$var$JstfGSUBModList = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $573d5042c76c4940$var$JstfPriority = new $gfJaN$restructure.Struct({
    shrinkageEnableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageEnableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageJstfMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f)),
    extensionEnableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionEnableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionJstfMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f))
});
let $573d5042c76c4940$var$JstfLangSys = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfPriority), $gfJaN$restructure.uint16);
let $573d5042c76c4940$var$JstfLangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    jstfLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfLangSys)
});
let $573d5042c76c4940$var$JstfScript = new $gfJaN$restructure.Struct({
    extenderGlyphs: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16)),
    defaultLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfLangSys),
    langSysCount: $gfJaN$restructure.uint16,
    langSysRecords: new $gfJaN$restructure.Array($573d5042c76c4940$var$JstfLangSysRecord, "langSysCount")
});
let $573d5042c76c4940$var$JstfScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfScript, {
        type: "parent"
    })
});
var $573d5042c76c4940$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    scriptCount: $gfJaN$restructure.uint16,
    scriptList: new $gfJaN$restructure.Array($573d5042c76c4940$var$JstfScriptRecord, "scriptCount")
});
// TODO: add this to restructure
class $a5875b80d6087f61$var$VariableSizeNumber {
    decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    }
    size(val, parent) {
        return (0, $gfJaN$restructure.resolveLength)(this._size, null, parent);
    }
    constructor(size){
        this._size = size;
    }
}
let $a5875b80d6087f61$var$MapDataEntry = new $gfJaN$restructure.Struct({
    entry: new $a5875b80d6087f61$var$VariableSizeNumber((t)=>((t.parent.entryFormat & 0x0030) >> 4) + 1),
    outerIndex: (t)=>t.entry >> (t.parent.entryFormat & 0x000F) + 1,
    innerIndex: (t)=>t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1
});
let $a5875b80d6087f61$var$DeltaSetIndexMap = new $gfJaN$restructure.Struct({
    entryFormat: $gfJaN$restructure.uint16,
    mapCount: $gfJaN$restructure.uint16,
    mapData: new $gfJaN$restructure.Array($a5875b80d6087f61$var$MapDataEntry, "mapCount")
});
var $a5875b80d6087f61$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241),
    advanceWidthMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap),
    LSBMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap),
    RSBMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap)
});
let $4423bc1ac09bbbd1$var$Signature = new $gfJaN$restructure.Struct({
    format: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    offset: $gfJaN$restructure.uint32
});
let $4423bc1ac09bbbd1$var$SignatureBlock = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16, 2),
    cbSignature: $gfJaN$restructure.uint32,
    signature: new $gfJaN$restructure.Buffer("cbSignature")
});
var $4423bc1ac09bbbd1$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    ulVersion: $gfJaN$restructure.uint32,
    usNumSigs: $gfJaN$restructure.uint16,
    usFlag: $gfJaN$restructure.uint16,
    signatures: new $gfJaN$restructure.Array($4423bc1ac09bbbd1$var$Signature, "usNumSigs"),
    signatureBlocks: new $gfJaN$restructure.Array($4423bc1ac09bbbd1$var$SignatureBlock, "usNumSigs")
});
let $7b50e3f8d83263de$var$GaspRange = new $gfJaN$restructure.Struct({
    rangeMaxPPEM: $gfJaN$restructure.uint16,
    rangeGaspBehavior: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "grayscale",
        "gridfit",
        "symmetricSmoothing",
        "symmetricGridfit" // only in version 1, for ClearType
    ])
});
var $7b50e3f8d83263de$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRanges: $gfJaN$restructure.uint16,
    gaspRanges: new $gfJaN$restructure.Array($7b50e3f8d83263de$var$GaspRange, "numRanges") // Sorted by ppem
});
let $7bf92ec372cd2307$var$DeviceRecord = new $gfJaN$restructure.Struct({
    pixelSize: $gfJaN$restructure.uint8,
    maximumWidth: $gfJaN$restructure.uint8,
    widths: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.parent.parent.maxp.numGlyphs)
});
var $7bf92ec372cd2307$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRecords: $gfJaN$restructure.int16,
    sizeDeviceRecord: $gfJaN$restructure.int32,
    records: new $gfJaN$restructure.Array($7bf92ec372cd2307$var$DeviceRecord, "numRecords")
});
let $a3f544bcf76542d1$var$KernPair = new $gfJaN$restructure.Struct({
    left: $gfJaN$restructure.uint16,
    right: $gfJaN$restructure.uint16,
    value: $gfJaN$restructure.int16
});
let $a3f544bcf76542d1$var$ClassTable = new $gfJaN$restructure.Struct({
    firstGlyph: $gfJaN$restructure.uint16,
    nGlyphs: $gfJaN$restructure.uint16,
    offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "nGlyphs"),
    max: (t)=>t.offsets.length && Math.max.apply(Math, t.offsets)
});
let $a3f544bcf76542d1$var$Kern2Array = new $gfJaN$restructure.Struct({
    off: (t)=>t._startOffset - t.parent.parent._startOffset,
    len: (t)=>((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2),
    values: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, "len")
});
let $a3f544bcf76542d1$var$KernSubtable = new $gfJaN$restructure.VersionedStruct("format", {
    0: {
        nPairs: $gfJaN$restructure.uint16,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16,
        pairs: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernPair, "nPairs")
    },
    2: {
        rowWidth: $gfJaN$restructure.uint16,
        leftTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$ClassTable, {
            type: "parent"
        }),
        rightTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$ClassTable, {
            type: "parent"
        }),
        array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$Kern2Array, {
            type: "parent"
        })
    },
    3: {
        glyphCount: $gfJaN$restructure.uint16,
        kernValueCount: $gfJaN$restructure.uint8,
        leftClassCount: $gfJaN$restructure.uint8,
        rightClassCount: $gfJaN$restructure.uint8,
        flags: $gfJaN$restructure.uint8,
        kernValue: new $gfJaN$restructure.Array($gfJaN$restructure.int16, "kernValueCount"),
        leftClass: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "glyphCount"),
        rightClass: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "glyphCount"),
        kernIndex: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.leftClassCount * t.rightClassCount)
    }
});
let $a3f544bcf76542d1$var$KernTable = new $gfJaN$restructure.VersionedStruct("version", {
    0: {
        subVersion: $gfJaN$restructure.uint16,
        length: $gfJaN$restructure.uint16,
        format: $gfJaN$restructure.uint8,
        coverage: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
            "horizontal",
            "minimum",
            "crossStream",
            "override" // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $a3f544bcf76542d1$var$KernSubtable,
        padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
    },
    1: {
        length: $gfJaN$restructure.uint32,
        coverage: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
            null,
            null,
            null,
            null,
            null,
            "variation",
            "crossStream",
            "vertical" // Set if table has vertical kerning values
        ]),
        format: $gfJaN$restructure.uint8,
        tupleIndex: $gfJaN$restructure.uint16,
        subtable: $a3f544bcf76542d1$var$KernSubtable,
        padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
    }
});
var $a3f544bcf76542d1$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        nTables: $gfJaN$restructure.uint16,
        tables: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernTable, "nTables")
    },
    1: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        nTables: $gfJaN$restructure.uint32,
        tables: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernTable, "nTables")
    }
});
var // Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
$86687befb45925d0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numGlyphs: $gfJaN$restructure.uint16,
    yPels: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "numGlyphs")
});
var // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
$91429006e51e0fe8$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    fontNumber: $gfJaN$restructure.uint32,
    pitch: $gfJaN$restructure.uint16,
    xHeight: $gfJaN$restructure.uint16,
    style: $gfJaN$restructure.uint16,
    typeFamily: $gfJaN$restructure.uint16,
    capHeight: $gfJaN$restructure.uint16,
    symbolSet: $gfJaN$restructure.uint16,
    typeface: new $gfJaN$restructure.String(16),
    characterComplement: new $gfJaN$restructure.String(8),
    fileName: new $gfJaN$restructure.String(6),
    strokeWeight: new $gfJaN$restructure.String(1),
    widthType: new $gfJaN$restructure.String(1),
    serifStyle: $gfJaN$restructure.uint8,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8)
});
// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.
let $627850fc9deed59a$var$Ratio = new $gfJaN$restructure.Struct({
    bCharSet: $gfJaN$restructure.uint8,
    xRatio: $gfJaN$restructure.uint8,
    yStartRatio: $gfJaN$restructure.uint8,
    yEndRatio: $gfJaN$restructure.uint8 // Ending y-Ratio value
});
let $627850fc9deed59a$var$vTable = new $gfJaN$restructure.Struct({
    yPelHeight: $gfJaN$restructure.uint16,
    yMax: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16 // Minimum value (in pels) for this yPelHeight
});
let $627850fc9deed59a$var$VdmxGroup = new $gfJaN$restructure.Struct({
    recs: $gfJaN$restructure.uint16,
    startsz: $gfJaN$restructure.uint8,
    endsz: $gfJaN$restructure.uint8,
    entries: new $gfJaN$restructure.Array($627850fc9deed59a$var$vTable, "recs") // The VDMX records
});
var $627850fc9deed59a$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRecs: $gfJaN$restructure.uint16,
    numRatios: $gfJaN$restructure.uint16,
    ratioRanges: new $gfJaN$restructure.Array($627850fc9deed59a$var$Ratio, "numRatios"),
    offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numRatios"),
    groups: new $gfJaN$restructure.Array($627850fc9deed59a$var$VdmxGroup, "numRecs") // The actual VDMX groupings
});
var $65c33f5f068fc77f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    ascent: $gfJaN$restructure.int16,
    descent: $gfJaN$restructure.int16,
    lineGap: $gfJaN$restructure.int16,
    advanceHeightMax: $gfJaN$restructure.int16,
    minTopSideBearing: $gfJaN$restructure.int16,
    minBottomSideBearing: $gfJaN$restructure.int16,
    yMaxExtent: $gfJaN$restructure.int16,
    caretSlopeRise: $gfJaN$restructure.int16,
    caretSlopeRun: $gfJaN$restructure.int16,
    caretOffset: $gfJaN$restructure.int16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.int16, 4),
    metricDataFormat: $gfJaN$restructure.int16,
    numberOfMetrics: $gfJaN$restructure.uint16 // Number of advance heights in the Vertical Metrics table
});
let $597d739523b65bb3$var$VmtxEntry = new $gfJaN$restructure.Struct({
    advance: $gfJaN$restructure.uint16,
    bearing: $gfJaN$restructure.int16 // The top sidebearing of the glyph
});
var $597d739523b65bb3$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    metrics: new $gfJaN$restructure.LazyArray($597d739523b65bb3$var$VmtxEntry, (t)=>t.parent.vhea.numberOfMetrics),
    bearings: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)
});
let $35aa0c87d9c3d3a0$var$shortFrac = new $gfJaN$restructure.Fixed(16, "BE", 14);
let $35aa0c87d9c3d3a0$var$Correspondence = new $gfJaN$restructure.Struct({
    fromCoord: $35aa0c87d9c3d3a0$var$shortFrac,
    toCoord: $35aa0c87d9c3d3a0$var$shortFrac
});
let $35aa0c87d9c3d3a0$var$Segment = new $gfJaN$restructure.Struct({
    pairCount: $gfJaN$restructure.uint16,
    correspondence: new $gfJaN$restructure.Array($35aa0c87d9c3d3a0$var$Correspondence, "pairCount")
});
var $35aa0c87d9c3d3a0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    axisCount: $gfJaN$restructure.uint32,
    segment: new $gfJaN$restructure.Array($35aa0c87d9c3d3a0$var$Segment, "axisCount")
});
class $22801616bd931ca3$var$UnboundedArrayAccessor {
    getItem(index) {
        if (this._items[index] == null) {
            let pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    }
    inspect() {
        return `[UnboundedArray ${this.type.constructor.name}]`;
    }
    constructor(type, stream, parent){
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
}
class $22801616bd931ca3$export$c5af1eebc882e39a extends $gfJaN$restructure.Array {
    decode(stream, parent) {
        return new $22801616bd931ca3$var$UnboundedArrayAccessor(this.type, stream, parent);
    }
    constructor(type){
        super(type, 0);
    }
}
let $22801616bd931ca3$export$8351f8c2ae2f103c = function(ValueType = $gfJaN$restructure.uint16) {
    // Helper class that makes internal structures invisible to pointers
    class Shadow {
        decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        }
        size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        }
        encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        }
        constructor(type){
            this.type = type;
        }
    }
    ValueType = new Shadow(ValueType);
    let BinarySearchHeader = new $gfJaN$restructure.Struct({
        unitSize: $gfJaN$restructure.uint16,
        nUnits: $gfJaN$restructure.uint16,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16
    });
    let LookupSegmentSingle = new $gfJaN$restructure.Struct({
        lastGlyph: $gfJaN$restructure.uint16,
        firstGlyph: $gfJaN$restructure.uint16,
        value: ValueType
    });
    let LookupSegmentArray = new $gfJaN$restructure.Struct({
        lastGlyph: $gfJaN$restructure.uint16,
        firstGlyph: $gfJaN$restructure.uint16,
        values: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array(ValueType, (t)=>t.lastGlyph - t.firstGlyph + 1), {
            type: "parent"
        })
    });
    let LookupSingle = new $gfJaN$restructure.Struct({
        glyph: $gfJaN$restructure.uint16,
        value: ValueType
    });
    return new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        0: {
            values: new $22801616bd931ca3$export$c5af1eebc882e39a(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSegmentSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSegmentArray, (t)=>t.binarySearchHeader.nUnits)
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        8: {
            firstGlyph: $gfJaN$restructure.uint16,
            count: $gfJaN$restructure.uint16,
            values: new $gfJaN$restructure.Array(ValueType, "count")
        }
    });
};
function $22801616bd931ca3$export$79f7d93d790934ba(entryData = {}, lookupType = $gfJaN$restructure.uint16) {
    let entry = Object.assign({
        newState: $gfJaN$restructure.uint16,
        flags: $gfJaN$restructure.uint16
    }, entryData);
    let Entry = new $gfJaN$restructure.Struct(entry);
    let StateArray = new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.nClasses));
    let StateHeader = new $gfJaN$restructure.Struct({
        nClasses: $gfJaN$restructure.uint32,
        classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$8351f8c2ae2f103c(lookupType)),
        stateArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, StateArray),
        entryTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader;
}
function $22801616bd931ca3$export$105027425199cc51(entryData = {}, lookupType = $gfJaN$restructure.uint16) {
    let ClassLookupTable = new $gfJaN$restructure.Struct({
        version () {
            return 8;
        },
        firstGlyph: $gfJaN$restructure.uint16,
        values: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16)
    });
    let entry = Object.assign({
        newStateOffset: $gfJaN$restructure.uint16,
        // convert offset to stateArray index
        newState: (t)=>(t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses,
        flags: $gfJaN$restructure.uint16
    }, entryData);
    let Entry = new $gfJaN$restructure.Struct(entry);
    let StateArray = new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.nClasses));
    let StateHeader1 = new $gfJaN$restructure.Struct({
        nClasses: $gfJaN$restructure.uint16,
        classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, ClassLookupTable),
        stateArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, StateArray),
        entryTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader1;
}
let $3a5ca96d3e3aaf20$var$BslnSubtable = new $gfJaN$restructure.VersionedStruct("format", {
    0: {
        deltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, 32)
    },
    1: {
        deltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, 32),
        mappingData: new $22801616bd931ca3$export$8351f8c2ae2f103c($gfJaN$restructure.uint16)
    },
    2: {
        standardGlyph: $gfJaN$restructure.uint16,
        controlPoints: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 32)
    },
    3: {
        standardGlyph: $gfJaN$restructure.uint16,
        controlPoints: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 32),
        mappingData: new $22801616bd931ca3$export$8351f8c2ae2f103c($gfJaN$restructure.uint16)
    }
});
var $3a5ca96d3e3aaf20$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    format: $gfJaN$restructure.uint16,
    defaultBaseline: $gfJaN$restructure.uint16,
    subtable: $3a5ca96d3e3aaf20$var$BslnSubtable
});
let $8d4241d96b2b0589$var$Setting = new $gfJaN$restructure.Struct({
    setting: $gfJaN$restructure.uint16,
    nameIndex: $gfJaN$restructure.int16,
    name: (t)=>t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]
});
let $8d4241d96b2b0589$var$FeatureName = new $gfJaN$restructure.Struct({
    feature: $gfJaN$restructure.uint16,
    nSettings: $gfJaN$restructure.uint16,
    settingTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($8d4241d96b2b0589$var$Setting, "nSettings"), {
        type: "parent"
    }),
    featureFlags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        "hasDefault",
        "exclusive"
    ]),
    defaultSetting: $gfJaN$restructure.uint8,
    nameIndex: $gfJaN$restructure.int16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameIndex]
});
var $8d4241d96b2b0589$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    featureNameCount: $gfJaN$restructure.uint16,
    reserved1: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    reserved2: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint32),
    featureNames: new $gfJaN$restructure.Array($8d4241d96b2b0589$var$FeatureName, "featureNameCount")
});
let $a79cd5132b1cf476$var$Axis = new $gfJaN$restructure.Struct({
    axisTag: new $gfJaN$restructure.String(4),
    minValue: $gfJaN$restructure.fixed32,
    defaultValue: $gfJaN$restructure.fixed32,
    maxValue: $gfJaN$restructure.fixed32,
    flags: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID]
});
let $a79cd5132b1cf476$var$Instance = new $gfJaN$restructure.Struct({
    nameID: $gfJaN$restructure.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID],
    flags: $gfJaN$restructure.uint16,
    coord: new $gfJaN$restructure.Array($gfJaN$restructure.fixed32, (t)=>t.parent.axisCount),
    postscriptNameID: new $gfJaN$restructure.Optional($gfJaN$restructure.uint16, (t)=>t.parent.instanceSize - t._currentOffset > 0)
});
var $a79cd5132b1cf476$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    offsetToData: $gfJaN$restructure.uint16,
    countSizePairs: $gfJaN$restructure.uint16,
    axisCount: $gfJaN$restructure.uint16,
    axisSize: $gfJaN$restructure.uint16,
    instanceCount: $gfJaN$restructure.uint16,
    instanceSize: $gfJaN$restructure.uint16,
    axis: new $gfJaN$restructure.Array($a79cd5132b1cf476$var$Axis, "axisCount"),
    instance: new $gfJaN$restructure.Array($a79cd5132b1cf476$var$Instance, "instanceCount")
});
let $3f36f1a5e6989457$var$shortFrac = new $gfJaN$restructure.Fixed(16, "BE", 14);
class $3f36f1a5e6989457$var$Offset {
    static decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    }
}
let $3f36f1a5e6989457$var$gvar = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    axisCount: $gfJaN$restructure.uint16,
    globalCoordCount: $gfJaN$restructure.uint16,
    globalCoords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array(new $gfJaN$restructure.Array($3f36f1a5e6989457$var$shortFrac, "axisCount"), "globalCoordCount")),
    glyphCount: $gfJaN$restructure.uint16,
    flags: $gfJaN$restructure.uint16,
    offsetToData: $gfJaN$restructure.uint32,
    offsets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($3f36f1a5e6989457$var$Offset, "void", {
        relativeTo: (ctx)=>ctx.offsetToData,
        allowNull: false
    }), (t)=>t.glyphCount + 1)
});
var $3f36f1a5e6989457$export$2e2bcd8739ae039 = $3f36f1a5e6989457$var$gvar;
let $0bd8fe7a6d1d9fb4$var$ClassTable = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    coverage: $gfJaN$restructure.uint16,
    subFeatureFlags: $gfJaN$restructure.uint32,
    stateTable: new $22801616bd931ca3$export$105027425199cc51
});
let $0bd8fe7a6d1d9fb4$var$WidthDeltaRecord = new $gfJaN$restructure.Struct({
    justClass: $gfJaN$restructure.uint32,
    beforeGrowLimit: $gfJaN$restructure.fixed32,
    beforeShrinkLimit: $gfJaN$restructure.fixed32,
    afterGrowLimit: $gfJaN$restructure.fixed32,
    afterShrinkLimit: $gfJaN$restructure.fixed32,
    growFlags: $gfJaN$restructure.uint16,
    shrinkFlags: $gfJaN$restructure.uint16
});
let $0bd8fe7a6d1d9fb4$var$WidthDeltaCluster = new $gfJaN$restructure.Array($0bd8fe7a6d1d9fb4$var$WidthDeltaRecord, $gfJaN$restructure.uint32);
let $0bd8fe7a6d1d9fb4$var$ActionData = new $gfJaN$restructure.VersionedStruct("actionType", {
    0: {
        lowerLimit: $gfJaN$restructure.fixed32,
        upperLimit: $gfJaN$restructure.fixed32,
        order: $gfJaN$restructure.uint16,
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16)
    },
    1: {
        addGlyph: $gfJaN$restructure.uint16
    },
    2: {
        substThreshold: $gfJaN$restructure.fixed32,
        addGlyph: $gfJaN$restructure.uint16,
        substGlyph: $gfJaN$restructure.uint16
    },
    3: {},
    4: {
        variationAxis: $gfJaN$restructure.uint32,
        minimumLimit: $gfJaN$restructure.fixed32,
        noStretchValue: $gfJaN$restructure.fixed32,
        maximumLimit: $gfJaN$restructure.fixed32
    },
    5: {
        flags: $gfJaN$restructure.uint16,
        glyph: $gfJaN$restructure.uint16
    }
});
let $0bd8fe7a6d1d9fb4$var$Action = new $gfJaN$restructure.Struct({
    actionClass: $gfJaN$restructure.uint16,
    actionType: $gfJaN$restructure.uint16,
    actionLength: $gfJaN$restructure.uint32,
    actionData: $0bd8fe7a6d1d9fb4$var$ActionData,
    padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.actionLength - t._currentOffset)
});
let $0bd8fe7a6d1d9fb4$var$PostcompensationAction = new $gfJaN$restructure.Array($0bd8fe7a6d1d9fb4$var$Action, $gfJaN$restructure.uint32);
let $0bd8fe7a6d1d9fb4$var$PostCompensationTable = new $gfJaN$restructure.Struct({
    lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$PostcompensationAction))
});
let $0bd8fe7a6d1d9fb4$var$JustificationTable = new $gfJaN$restructure.Struct({
    classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$ClassTable, {
        type: "parent"
    }),
    wdcOffset: $gfJaN$restructure.uint16,
    postCompensationTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$PostCompensationTable, {
        type: "parent"
    }),
    widthDeltaClusters: new $22801616bd931ca3$export$8351f8c2ae2f103c(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$WidthDeltaCluster, {
        type: "parent",
        relativeTo: (ctx)=>ctx.wdcOffset
    }))
});
var $0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    format: $gfJaN$restructure.uint16,
    horizontal: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$JustificationTable),
    vertical: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$JustificationTable)
});
let $ef40c6dc80fd50a2$var$LigatureData = {
    action: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$ContextualData = {
    markIndex: $gfJaN$restructure.uint16,
    currentIndex: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$InsertionData = {
    currentInsertIndex: $gfJaN$restructure.uint16,
    markedInsertIndex: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$SubstitutionTable = new $gfJaN$restructure.Struct({
    items: new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$8351f8c2ae2f103c))
});
let $ef40c6dc80fd50a2$var$SubtableData = new $gfJaN$restructure.VersionedStruct("type", {
    0: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba
    },
    1: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$ContextualData),
        substitutionTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $ef40c6dc80fd50a2$var$SubstitutionTable)
    },
    2: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$LigatureData),
        ligatureActions: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint32)),
        components: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16)),
        ligatureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16))
    },
    4: {
        lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c
    },
    5: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$InsertionData),
        insertionActions: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16))
    }
});
let $ef40c6dc80fd50a2$var$Subtable = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint32,
    coverage: $gfJaN$restructure.uint24,
    type: $gfJaN$restructure.uint8,
    subFeatureFlags: $gfJaN$restructure.uint32,
    table: $ef40c6dc80fd50a2$var$SubtableData,
    padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
});
let $ef40c6dc80fd50a2$var$FeatureEntry = new $gfJaN$restructure.Struct({
    featureType: $gfJaN$restructure.uint16,
    featureSetting: $gfJaN$restructure.uint16,
    enableFlags: $gfJaN$restructure.uint32,
    disableFlags: $gfJaN$restructure.uint32
});
let $ef40c6dc80fd50a2$var$MorxChain = new $gfJaN$restructure.Struct({
    defaultFlags: $gfJaN$restructure.uint32,
    chainLength: $gfJaN$restructure.uint32,
    nFeatureEntries: $gfJaN$restructure.uint32,
    nSubtables: $gfJaN$restructure.uint32,
    features: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$FeatureEntry, "nFeatureEntries"),
    subtables: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$Subtable, "nSubtables")
});
var $ef40c6dc80fd50a2$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    unused: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    nChains: $gfJaN$restructure.uint32,
    chains: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$MorxChain, "nChains")
});
let $ab24dea08b58a7cc$var$OpticalBounds = new $gfJaN$restructure.Struct({
    left: $gfJaN$restructure.int16,
    top: $gfJaN$restructure.int16,
    right: $gfJaN$restructure.int16,
    bottom: $gfJaN$restructure.int16
});
var $ab24dea08b58a7cc$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    format: $gfJaN$restructure.uint16,
    lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c($ab24dea08b58a7cc$var$OpticalBounds)
});
let $5825c04ce8f7102d$var$tables = {};
var $5825c04ce8f7102d$export$2e2bcd8739ae039 = $5825c04ce8f7102d$var$tables;
$5825c04ce8f7102d$var$tables.cmap = $e4ae0436c91af89f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.head = $55a60976afb7c261$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hhea = $dde72b7b5b650596$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hmtx = $a7c40184072c9a5b$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.maxp = $521197722369f691$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.name = $51a9f4feb3a3b2b1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["OS/2"] = $114ea85db469b435$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.post = $f93b30299e1ea0f5$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.fpgm = $873d79fea57d3161$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.loca = $83c4155666d50c37$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.prep = $b12598db7cdf7042$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["cvt "] = $8fb09b0f473d61a0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.glyf = $7707bdf21a3d89cc$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["CFF "] = $f717432b360040c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["CFF2"] = $f717432b360040c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.VORG = $8cb7ae73ed7aa7d8$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.EBLC = $035bb95c0cdb1f6d$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.CBLC = $5825c04ce8f7102d$var$tables.EBLC;
$5825c04ce8f7102d$var$tables.sbix = $73d13900b55a3c0c$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.COLR = $97f6b8be3a347a8f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.CPAL = $16ca60ecbdee30ea$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.BASE = $7327e41706f9d5c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GDEF = $7e48bbe9e5345664$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GPOS = $b687332511a4da75$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GSUB = $99ccad60b96f92fb$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.JSTF = $573d5042c76c4940$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.HVAR = $a5875b80d6087f61$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.DSIG = $4423bc1ac09bbbd1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.gasp = $7b50e3f8d83263de$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hdmx = $7bf92ec372cd2307$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.kern = $a3f544bcf76542d1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.LTSH = $86687befb45925d0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.PCLT = $91429006e51e0fe8$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.VDMX = $627850fc9deed59a$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.vhea = $65c33f5f068fc77f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.vmtx = $597d739523b65bb3$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.avar = $35aa0c87d9c3d3a0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.bsln = $3a5ca96d3e3aaf20$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.feat = $8d4241d96b2b0589$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.fvar = $a79cd5132b1cf476$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.gvar = $3f36f1a5e6989457$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.just = $0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.morx = $ef40c6dc80fd50a2$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.opbd = $ab24dea08b58a7cc$export$2e2bcd8739ae039;
let $df50e1efe10a1247$var$TableEntry = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    checkSum: $gfJaN$restructure.uint32,
    offset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void", {
        type: "global"
    }),
    length: $gfJaN$restructure.uint32
});
let $df50e1efe10a1247$var$Directory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    numTables: $gfJaN$restructure.uint16,
    searchRange: $gfJaN$restructure.uint16,
    entrySelector: $gfJaN$restructure.uint16,
    rangeShift: $gfJaN$restructure.uint16,
    tables: new $gfJaN$restructure.Array($df50e1efe10a1247$var$TableEntry, "numTables")
});
$df50e1efe10a1247$var$Directory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
$df50e1efe10a1247$var$Directory.preEncode = function() {
    if (!Array.isArray(this.tables)) {
        let tables = [];
        for(let tag in this.tables){
            let table = this.tables[tag];
            if (table) tables.push({
                tag: tag,
                checkSum: 0,
                offset: new $gfJaN$restructure.VoidPointer($5825c04ce8f7102d$export$2e2bcd8739ae039[tag], table),
                length: $5825c04ce8f7102d$export$2e2bcd8739ae039[tag].size(table)
            });
        }
        this.tables = tables;
    }
    this.tag = "true";
    this.numTables = this.tables.length;
    let maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    let maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $df50e1efe10a1247$export$2e2bcd8739ae039 = $df50e1efe10a1247$var$Directory;
function $66a5b9fb5318558a$export$2e0ae67339d5f1ac(arr, cmp) {
    let min = 0;
    let max = arr.length - 1;
    while(min <= max){
        let mid = min + max >> 1;
        let res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $66a5b9fb5318558a$export$d02631cccf789723(index, end) {
    let range1 = [];
    while(index < end)range1.push(index++);
    return range1;
}
const $66a5b9fb5318558a$export$3d28c1996ced1f14 = new TextDecoder("ascii");
// Based on https://github.com/niklasvh/base64-arraybuffer. MIT license.
const $66a5b9fb5318558a$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $66a5b9fb5318558a$var$LOOKUP = new Uint8Array(256);
for(let i = 0; i < $66a5b9fb5318558a$var$CHARS.length; i++)$66a5b9fb5318558a$var$LOOKUP[$66a5b9fb5318558a$var$CHARS.charCodeAt(i)] = i;
function $66a5b9fb5318558a$export$94fdf11bafc8de6b(base64) {
    let bufferLength = base64.length * 0.75;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    let bytes = new Uint8Array(bufferLength);
    let p = 0;
    for(let i1 = 0, len = base64.length; i1 < len; i1 += 4){
        let encoded1 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1)];
        let encoded2 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 1)];
        let encoded3 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 2)];
        let encoded4 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
}
class $0d6e160064c86e50$export$2e2bcd8739ae039 {
    findSubtable(cmapTable, pairs) {
        for (let [platformID, encodingID] of pairs)for (let cmap of cmapTable.tables){
            if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
        }
        return null;
    }
    lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) codepoint = this.encoding.get(codepoint) || codepoint;
        else if (variationSelector) {
            let gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                {
                    let min = 0;
                    let max = cmap.segCount - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                        else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                        else {
                            let rangeOffset = cmap.idRangeOffset.get(mid);
                            let gid;
                            if (rangeOffset === 0) gid = codepoint + cmap.idDelta.get(mid);
                            else {
                                let index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                gid = cmap.glyphIndexArray.get(index) || 0;
                                if (gid !== 0) gid += cmap.idDelta.get(mid);
                            }
                            return gid & 0xffff;
                        }
                    }
                    return 0;
                }
            case 8:
                throw new Error("TODO: cmap format 8");
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                {
                    let min = 0;
                    let max = cmap.nGroups - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        let group = cmap.groups.get(mid);
                        if (codepoint < group.startCharCode) max = mid - 1;
                        else if (codepoint > group.endCharCode) min = mid + 1;
                        else {
                            if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                            else return group.glyphID;
                        }
                    }
                    return 0;
                }
            case 14:
                throw new Error("TODO: cmap format 14");
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        let selectors = this.uvs.varSelectors.toArray();
        let i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(selectors, (x)=>variationSelector - x.varSelector);
        let sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.defaultUVS, (x)=>codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0);
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.nonDefaultUVS, (x)=>codepoint - x.unicodeValue);
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    }
    getCharacterSet() {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $66a5b9fb5318558a$export$d02631cccf789723(0, cmap.codeMap.length);
            case 4:
                {
                    let res = [];
                    let endCodes = cmap.endCode.toArray();
                    for(let i = 0; i < endCodes.length; i++){
                        let tail = endCodes[i] + 1;
                        let start = cmap.startCode.get(i);
                        res.push(...$66a5b9fb5318558a$export$d02631cccf789723(start, tail));
                    }
                    return res;
                }
            case 8:
                throw new Error("TODO: cmap format 8");
            case 6:
            case 10:
                return $66a5b9fb5318558a$export$d02631cccf789723(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())res.push(...$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            case 14:
                throw new Error("TODO: cmap format 14");
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    codePointsForGlyph(gid) {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                {
                    let res = [];
                    for(let i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                    return res;
                }
            case 4:
                {
                    let res = [];
                    for(let i = 0; i < cmap.segCount; i++){
                        let end = cmap.endCode.get(i);
                        let start = cmap.startCode.get(i);
                        let rangeOffset = cmap.idRangeOffset.get(i);
                        let delta = cmap.idDelta.get(i);
                        for(var c = start; c <= end; c++){
                            let g = 0;
                            if (rangeOffset === 0) g = c + delta;
                            else {
                                let index = rangeOffset / 2 + (c - start) - (cmap.segCount - i);
                                g = cmap.glyphIndexArray.get(index) || 0;
                                if (g !== 0) g += delta;
                            }
                            if (g === gid) res.push(c);
                        }
                    }
                    return res;
                }
            case 12:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) res.push(group.startCharCode + (gid - group.glyphID));
                    return res;
                }
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid === group.glyphID) res.push(...$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    constructor(cmapTable){
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            // 32-bit subtables
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            // 16-bit subtables
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]);
        // If not unicode cmap was found, take the first table with a supported encoding.
        if (!this.cmap) for (let cmap of cmapTable.tables){
            let encoding = $e2613b812f052cbe$export$badc544e0651b6b1(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            let mapping = $e2613b812f052cbe$export$1dceb3c14ed68bee(encoding);
            if (mapping) {
                this.cmap = cmap.table;
                this.encoding = mapping;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $4646d52c2a559cdb$export$2e2bcd8739ae039 {
    process(glyphs, positions) {
        for(let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            let left = glyphs[glyphIndex].id;
            let right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    }
    getKerning(left, right) {
        let res = 0;
        for (let table of this.kern.tables){
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error(`Unsupported kerning table version ${table.version}`);
            }
            let val = 0;
            let s = table.subtable;
            switch(table.format){
                case 0:
                    let pairIdx = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    let leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    let index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error(`Unsupported kerning sub-table format ${table.format}`);
            }
            // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    }
    constructor(font){
        this.kern = font.kern;
    }
}
class $a57a26817cd35108$export$2e2bcd8739ae039 {
    positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        let clusterStart = 0;
        let clusterEnd = 0;
        for(let index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.isMark) clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    }
    positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        let base = glyphs[clusterStart];
        let baseBox = base.cbox.copy();
        // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        let xOffset = -positions[clusterStart].xAdvance;
        let yOffset = 0;
        let yGap = this.font.unitsPerEm / 16;
        // position each of the mark glyphs relative to the base glyph
        for(let index = clusterStart + 1; index <= clusterEnd; index++){
            let mark = glyphs[index];
            let markBox = mark.cbox;
            let position = positions[index];
            let combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== "Not_Reordered") {
                position.xOffset = position.yOffset = 0;
                // x positioning
                switch(combiningClass){
                    case "Double_Above":
                    case "Double_Below":
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case "Attached_Below_Left":
                    case "Below_Left":
                    case "Above_Left":
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case "Attached_Above_Right":
                    case "Below_Right":
                    case "Above_Right":
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                }
                // y positioning
                switch(combiningClass){
                    case "Double_Below":
                    case "Below_Left":
                    case "Below":
                    case "Below_Right":
                    case "Attached_Below_Left":
                    case "Attached_Below":
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === "Attached_Below_Left" || combiningClass === "Attached_Below") baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case "Double_Above":
                    case "Above_Left":
                    case "Above":
                    case "Above_Right":
                    case "Attached_Above":
                    case "Attached_Above_Right":
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === "Attached_Above" || combiningClass === "Attached_Above_Right") baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    }
    getCombiningClass(codePoint) {
        let combiningClass = (0, $gfJaN$unicodeproperties.getCombiningClass)(codePoint);
        // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === "Not_Reordered") switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return "Above_Right";
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return "Above";
                case 0x0ebc:
                    return "Below";
            }
            else if (codePoint === 0x0e3a) return "Below_Right";
        }
        switch(combiningClass){
            // Hebrew
            case "CCC10":
            case "CCC11":
            case "CCC12":
            case "CCC13":
            case "CCC14":
            case "CCC15":
            case "CCC16":
            case "CCC17":
            case "CCC18":
            case "CCC20":
            case "CCC22":
                return "Below";
            case "CCC23":
                return "Attached_Above";
            case "CCC24":
                return "Above_Right";
            case "CCC25":
            case "CCC19":
                return "Above_Left";
            case "CCC26":
                return "Above";
            case "CCC21":
                break;
            // Arabic and Syriac
            case "CCC27":
            case "CCC28":
            case "CCC30":
            case "CCC31":
            case "CCC33":
            case "CCC34":
            case "CCC35":
            case "CCC36":
                return "Above";
            case "CCC29":
            case "CCC32":
                return "Below";
            // Thai
            case "CCC103":
                return "Below_Right";
            case "CCC107":
                return "Above_Right";
            // Lao
            case "CCC118":
                return "Below";
            case "CCC122":
                return "Above";
            // Tibetan
            case "CCC129":
            case "CCC132":
                return "Below";
            case "CCC130":
                return "Above";
        }
        return combiningClass;
    }
    constructor(font){
        this.font = font;
    }
}
class $0e2da1c4ce69e8ad$export$2e2bcd8739ae039 {
    /**
   * The width of the bounding box
   * @type {number}
   */ get width() {
        return this.maxX - this.minX;
    }
    /**
   * The height of the bounding box
   * @type {number}
   */ get height() {
        return this.maxY - this.minY;
    }
    addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    }
    copy() {
        return new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
    }
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
}
// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
const $e38a1a895f6aeb54$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: "aghb",
    Arabic: "arab",
    Imperial_Aramaic: "armi",
    Armenian: "armn",
    Avestan: "avst",
    Balinese: "bali",
    Bamum: "bamu",
    Bassa_Vah: "bass",
    Batak: "batk",
    Bengali: [
        "bng2",
        "beng"
    ],
    Bopomofo: "bopo",
    Brahmi: "brah",
    Braille: "brai",
    Buginese: "bugi",
    Buhid: "buhd",
    Chakma: "cakm",
    Canadian_Aboriginal: "cans",
    Carian: "cari",
    Cham: "cham",
    Cherokee: "cher",
    Coptic: "copt",
    Cypriot: "cprt",
    Cyrillic: "cyrl",
    Devanagari: [
        "dev2",
        "deva"
    ],
    Deseret: "dsrt",
    Duployan: "dupl",
    Egyptian_Hieroglyphs: "egyp",
    Elbasan: "elba",
    Ethiopic: "ethi",
    Georgian: "geor",
    Glagolitic: "glag",
    Gothic: "goth",
    Grantha: "gran",
    Greek: "grek",
    Gujarati: [
        "gjr2",
        "gujr"
    ],
    Gurmukhi: [
        "gur2",
        "guru"
    ],
    Hangul: "hang",
    Han: "hani",
    Hanunoo: "hano",
    Hebrew: "hebr",
    Hiragana: "hira",
    Pahawh_Hmong: "hmng",
    Katakana_Or_Hiragana: "hrkt",
    Old_Italic: "ital",
    Javanese: "java",
    Kayah_Li: "kali",
    Katakana: "kana",
    Kharoshthi: "khar",
    Khmer: "khmr",
    Khojki: "khoj",
    Kannada: [
        "knd2",
        "knda"
    ],
    Kaithi: "kthi",
    Tai_Tham: "lana",
    Lao: "lao ",
    Latin: "latn",
    Lepcha: "lepc",
    Limbu: "limb",
    Linear_A: "lina",
    Linear_B: "linb",
    Lisu: "lisu",
    Lycian: "lyci",
    Lydian: "lydi",
    Mahajani: "mahj",
    Mandaic: "mand",
    Manichaean: "mani",
    Mende_Kikakui: "mend",
    Meroitic_Cursive: "merc",
    Meroitic_Hieroglyphs: "mero",
    Malayalam: [
        "mlm2",
        "mlym"
    ],
    Modi: "modi",
    Mongolian: "mong",
    Mro: "mroo",
    Meetei_Mayek: "mtei",
    Myanmar: [
        "mym2",
        "mymr"
    ],
    Old_North_Arabian: "narb",
    Nabataean: "nbat",
    Nko: "nko ",
    Ogham: "ogam",
    Ol_Chiki: "olck",
    Old_Turkic: "orkh",
    Oriya: [
        "ory2",
        "orya"
    ],
    Osmanya: "osma",
    Palmyrene: "palm",
    Pau_Cin_Hau: "pauc",
    Old_Permic: "perm",
    Phags_Pa: "phag",
    Inscriptional_Pahlavi: "phli",
    Psalter_Pahlavi: "phlp",
    Phoenician: "phnx",
    Miao: "plrd",
    Inscriptional_Parthian: "prti",
    Rejang: "rjng",
    Runic: "runr",
    Samaritan: "samr",
    Old_South_Arabian: "sarb",
    Saurashtra: "saur",
    Shavian: "shaw",
    Sharada: "shrd",
    Siddham: "sidd",
    Khudawadi: "sind",
    Sinhala: "sinh",
    Sora_Sompeng: "sora",
    Sundanese: "sund",
    Syloti_Nagri: "sylo",
    Syriac: "syrc",
    Tagbanwa: "tagb",
    Takri: "takr",
    Tai_Le: "tale",
    New_Tai_Lue: "talu",
    Tamil: [
        "tml2",
        "taml"
    ],
    Tai_Viet: "tavt",
    Telugu: [
        "tel2",
        "telu"
    ],
    Tifinagh: "tfng",
    Tagalog: "tglg",
    Thaana: "thaa",
    Thai: "thai",
    Tibetan: "tibt",
    Tirhuta: "tirh",
    Ugaritic: "ugar",
    Vai: "vai ",
    Warang_Citi: "wara",
    Old_Persian: "xpeo",
    Cuneiform: "xsux",
    Yi: "yi  ",
    Inherited: "zinh",
    Common: "zyyy",
    Unknown: "zzzz"
};
const $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS = {};
for(let script in $e38a1a895f6aeb54$var$UNICODE_SCRIPTS){
    let tag = $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) for (let t of tag)$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[t] = script;
    else $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag] = script;
}
function $e38a1a895f6aeb54$export$b32f0b5f69d65e51(script1) {
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script1];
}
function $e38a1a895f6aeb54$export$ce50e82f12a827a4(tag) {
    return $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag];
}
function $e38a1a895f6aeb54$export$e5cb25e204fb8450(string) {
    let len = string.length;
    let idx = 0;
    while(idx < len){
        let code = string.charCodeAt(idx++);
        // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            let next = string.charCodeAt(idx);
            // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        let script2 = (0, $gfJaN$unicodeproperties.getScript)(code);
        if (script2 !== "Common" && script2 !== "Inherited" && script2 !== "Unknown") return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script2];
    }
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
function $e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints) {
    for(let i = 0; i < codePoints.length; i++){
        let codePoint = codePoints[i];
        let script3 = (0, $gfJaN$unicodeproperties.getScript)(codePoint);
        if (script3 !== "Common" && script3 !== "Inherited" && script3 !== "Unknown") return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script3];
    }
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
// The scripts in this map are written from right to left
const $e38a1a895f6aeb54$var$RTL = {
    arab: true,
    hebr: true,
    syrc: true,
    thaa: true,
    cprt: true,
    khar: true,
    phnx: true,
    "nko ": true,
    lydi: true,
    avst: true,
    armi: true,
    phli: true,
    prti: true,
    sarb: true,
    orkh: true,
    samr: true,
    mand: true,
    merc: true,
    mero: true,
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    mend: true,
    nbat: true,
    narb: true,
    palm: true,
    phlp: true // Psalter Pahlavi
};
function $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script4) {
    if ($e38a1a895f6aeb54$var$RTL[script4]) return "rtl";
    return "ltr";
}
class $b19c79ec7a94fa39$export$2e2bcd8739ae039 {
    /**
   * The total advance width of the run.
   * @type {number}
   */ get advanceWidth() {
        let width = 0;
        for (let position of this.positions)width += position.xAdvance;
        return width;
    }
    /**
  * The total advance height of the run.
  * @type {number}
  */ get advanceHeight() {
        let height = 0;
        for (let position of this.positions)height += position.yAdvance;
        return height;
    }
    /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */ get bbox() {
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let x = 0;
        let y = 0;
        for(let index = 0; index < this.glyphs.length; index++){
            let glyph = this.glyphs[index];
            let p = this.positions[index];
            let b = glyph.bbox;
            bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
            bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
            x += p.xAdvance;
            y += p.yAdvance;
        }
        return bbox;
    }
    constructor(glyphs, features, script, language, direction){
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction || $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {};
        // Convert features to an object
        if (Array.isArray(features)) for (let tag of features)this.features[tag] = true;
        else if (typeof features === "object") this.features = features;
    }
}
class $9195cf1266c12ea5$export$2e2bcd8739ae039 {
    constructor(xAdvance = 0, yAdvance = 0, xOffset = 0, yOffset = 0){
        /**
     * The amount to move the virtual pen in the X direction after rendering this glyph.
     * @type {number}
     */ this.xAdvance = xAdvance;
        /**
     * The amount to move the virtual pen in the Y direction after rendering this glyph.
     * @type {number}
     */ this.yAdvance = yAdvance;
        /**
     * The offset from the pen position in the X direction at which to render this glyph.
     * @type {number}
     */ this.xOffset = xOffset;
        /**
     * The offset from the pen position in the Y direction at which to render this glyph.
     * @type {number}
     */ this.yOffset = yOffset;
    }
}
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
const $2b7f887ebcb5888a$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
const $2b7f887ebcb5888a$var$feature = (name, selector)=>[
        $2b7f887ebcb5888a$var$features[name].code,
        $2b7f887ebcb5888a$var$features[name][selector]
    ];
const $2b7f887ebcb5888a$var$OTMapping = {
    rlig: $2b7f887ebcb5888a$var$feature("ligatures", "requiredLigatures"),
    clig: $2b7f887ebcb5888a$var$feature("ligatures", "contextualLigatures"),
    dlig: $2b7f887ebcb5888a$var$feature("ligatures", "rareLigatures"),
    hlig: $2b7f887ebcb5888a$var$feature("ligatures", "historicalLigatures"),
    liga: $2b7f887ebcb5888a$var$feature("ligatures", "commonLigatures"),
    hist: $2b7f887ebcb5888a$var$feature("ligatures", "historicalLigatures"),
    smcp: $2b7f887ebcb5888a$var$feature("lowerCase", "lowerCaseSmallCaps"),
    pcap: $2b7f887ebcb5888a$var$feature("lowerCase", "lowerCasePetiteCaps"),
    frac: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    dnom: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    numr: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    afrc: $2b7f887ebcb5888a$var$feature("fractions", "verticalFractions"),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    case: $2b7f887ebcb5888a$var$feature("caseSensitiveLayout", "caseSensitiveLayout"),
    ccmp: $2b7f887ebcb5888a$var$feature("unicodeDecomposition", "canonicalComposition"),
    cpct: $2b7f887ebcb5888a$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
    valt: $2b7f887ebcb5888a$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
    swsh: $2b7f887ebcb5888a$var$feature("contextualAlternates", "swashAlternates"),
    cswh: $2b7f887ebcb5888a$var$feature("contextualAlternates", "contextualSwashAlternates"),
    curs: $2b7f887ebcb5888a$var$feature("cursiveConnection", "cursive"),
    c2pc: $2b7f887ebcb5888a$var$feature("upperCase", "upperCasePetiteCaps"),
    c2sc: $2b7f887ebcb5888a$var$feature("upperCase", "upperCaseSmallCaps"),
    init: $2b7f887ebcb5888a$var$feature("smartSwash", "wordInitialSwashes"),
    fin2: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    medi: $2b7f887ebcb5888a$var$feature("smartSwash", "nonFinalSwashes"),
    med2: $2b7f887ebcb5888a$var$feature("smartSwash", "nonFinalSwashes"),
    fin3: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    fina: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    pkna: $2b7f887ebcb5888a$var$feature("kanaSpacing", "proportionalKana"),
    half: $2b7f887ebcb5888a$var$feature("textSpacing", "halfWidthText"),
    halt: $2b7f887ebcb5888a$var$feature("textSpacing", "altHalfWidthText"),
    hkna: $2b7f887ebcb5888a$var$feature("alternateKana", "alternateHorizKana"),
    vkna: $2b7f887ebcb5888a$var$feature("alternateKana", "alternateVertKana"),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $2b7f887ebcb5888a$var$feature("italicCJKRoman", "CJKItalicRoman"),
    lnum: $2b7f887ebcb5888a$var$feature("numberCase", "upperCaseNumbers"),
    onum: $2b7f887ebcb5888a$var$feature("numberCase", "lowerCaseNumbers"),
    mgrk: $2b7f887ebcb5888a$var$feature("mathematicalExtras", "mathematicalGreek"),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $2b7f887ebcb5888a$var$feature("contextualAlternates", "contextualAlternates"),
    vrt2: $2b7f887ebcb5888a$var$feature("verticalSubstitution", "substituteVerticalForms"),
    vert: $2b7f887ebcb5888a$var$feature("verticalSubstitution", "substituteVerticalForms"),
    tnum: $2b7f887ebcb5888a$var$feature("numberSpacing", "monospacedNumbers"),
    pnum: $2b7f887ebcb5888a$var$feature("numberSpacing", "proportionalNumbers"),
    sups: $2b7f887ebcb5888a$var$feature("verticalPosition", "superiors"),
    subs: $2b7f887ebcb5888a$var$feature("verticalPosition", "inferiors"),
    ordn: $2b7f887ebcb5888a$var$feature("verticalPosition", "ordinals"),
    pwid: $2b7f887ebcb5888a$var$feature("textSpacing", "proportionalText"),
    hwid: $2b7f887ebcb5888a$var$feature("textSpacing", "halfWidthText"),
    qwid: $2b7f887ebcb5888a$var$feature("textSpacing", "quarterWidthText"),
    twid: $2b7f887ebcb5888a$var$feature("textSpacing", "thirdWidthText"),
    fwid: $2b7f887ebcb5888a$var$feature("textSpacing", "proportionalText"),
    palt: $2b7f887ebcb5888a$var$feature("textSpacing", "altProportionalText"),
    trad: $2b7f887ebcb5888a$var$feature("characterShape", "traditionalCharacters"),
    smpl: $2b7f887ebcb5888a$var$feature("characterShape", "simplifiedCharacters"),
    jp78: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1978Characters"),
    jp83: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1983Characters"),
    jp90: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1990Characters"),
    jp04: $2b7f887ebcb5888a$var$feature("characterShape", "JIS2004Characters"),
    expt: $2b7f887ebcb5888a$var$feature("characterShape", "expertCharacters"),
    hojo: $2b7f887ebcb5888a$var$feature("characterShape", "hojoCharacters"),
    nlck: $2b7f887ebcb5888a$var$feature("characterShape", "NLCCharacters"),
    tnam: $2b7f887ebcb5888a$var$feature("characterShape", "traditionalNamesCharacters"),
    ruby: $2b7f887ebcb5888a$var$feature("rubyKana", "rubyKana"),
    titl: $2b7f887ebcb5888a$var$feature("styleOptions", "titlingCaps"),
    zero: $2b7f887ebcb5888a$var$feature("typographicExtras", "slashedZero"),
    ss01: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltOne"),
    ss02: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwo"),
    ss03: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltThree"),
    ss04: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFour"),
    ss05: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFive"),
    ss06: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSix"),
    ss07: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSeven"),
    ss08: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEight"),
    ss09: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltNine"),
    ss10: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTen"),
    ss11: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEleven"),
    ss12: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwelve"),
    ss13: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltThirteen"),
    ss14: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFourteen"),
    ss15: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFifteen"),
    ss16: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSixteen"),
    ss17: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSeventeen"),
    ss18: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEighteen"),
    ss19: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltNineteen"),
    ss20: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwenty")
};
// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(let i = 1; i <= 99; i++)$2b7f887ebcb5888a$var$OTMapping[`cv${`00${i}`.slice(-2)}`] = [
    $2b7f887ebcb5888a$var$features.characterAlternatives.code,
    i
];
// create inverse mapping
let $2b7f887ebcb5888a$var$AATMapping = {};
for(let ot in $2b7f887ebcb5888a$var$OTMapping){
    let aat = $2b7f887ebcb5888a$var$OTMapping[ot];
    if ($2b7f887ebcb5888a$var$AATMapping[aat[0]] == null) $2b7f887ebcb5888a$var$AATMapping[aat[0]] = {};
    $2b7f887ebcb5888a$var$AATMapping[aat[0]][aat[1]] = ot;
}
function $2b7f887ebcb5888a$export$b813f7d2a1677c16(features1) {
    let res = {};
    for(let k in features1){
        let r;
        if (r = $2b7f887ebcb5888a$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features1[k];
        }
    }
    return res;
}
// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $2b7f887ebcb5888a$var$mapFeatureStrings(f) {
    let [type, setting] = f;
    if (isNaN(type)) var typeCode = $2b7f887ebcb5888a$var$features[type] && $2b7f887ebcb5888a$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $2b7f887ebcb5888a$var$features[type] && $2b7f887ebcb5888a$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
}
function $2b7f887ebcb5888a$export$bd6df347a4f391c4(features2) {
    let res = {};
    if (Array.isArray(features2)) for(let k = 0; k < features2.length; k++){
        let r;
        let f = $2b7f887ebcb5888a$var$mapFeatureStrings(features2[k]);
        if (r = $2b7f887ebcb5888a$var$AATMapping[f[0]] && $2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features2 === "object") for(let type in features2){
        let feature1 = features2[type];
        for(let setting in feature1){
            let r;
            let f = $2b7f887ebcb5888a$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (feature1[setting] && (r = $2b7f887ebcb5888a$var$AATMapping[f[0]] && $2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]])) res[r] = true;
        }
    }
    return Object.keys(res);
}
class $f3d63ae925545400$export$2e2bcd8739ae039 {
    lookup(glyph) {
        switch(this.table.version){
            case 0:
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.firstGlyph === 0xffff) return null;
                        if (glyph < seg.firstGlyph) max = mid - 1;
                        else if (glyph > seg.lastGlyph) min = mid + 1;
                        else {
                            if (this.table.version === 2) return seg.value;
                            else return seg.values[glyph - seg.firstGlyph];
                        }
                    }
                    return null;
                }
            case 6:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.glyph === 0xffff) return null;
                        if (glyph < seg.glyph) max = mid - 1;
                        else if (glyph > seg.glyph) min = mid + 1;
                        else return seg.value;
                    }
                    return null;
                }
            case 8:
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
    }
    glyphsForValue(classValue) {
        let res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for (let segment of this.table.segments)if (this.table.version === 2 && segment.value === classValue) res.push(...$66a5b9fb5318558a$export$d02631cccf789723(segment.firstGlyph, segment.lastGlyph + 1));
                else {
                    for(let index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                }
                break;
            case 6:
                for (let segment1 of this.table.segments)if (segment1.value === classValue) res.push(segment1.glyph);
                break;
            case 8:
                for(let i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
        return res;
    }
    constructor(table){
        this.table = table;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $f3d63ae925545400$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $860c6347bb941b91$var$START_OF_TEXT_STATE = 0;
const $860c6347bb941b91$var$START_OF_LINE_STATE = 1;
const $860c6347bb941b91$var$END_OF_TEXT_CLASS = 0;
const $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS = 1;
const $860c6347bb941b91$var$DELETED_GLYPH_CLASS = 2;
const $860c6347bb941b91$var$END_OF_LINE_CLASS = 3;
const $860c6347bb941b91$var$DONT_ADVANCE = 0x4000;
class $860c6347bb941b91$export$2e2bcd8739ae039 {
    process(glyphs, reverse, processEntry) {
        let currentState = $860c6347bb941b91$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        let index = reverse ? glyphs.length - 1 : 0;
        let dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            let glyph = null;
            let classCode = $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
            let shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $860c6347bb941b91$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) classCode = $860c6347bb941b91$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            let row = this.stateTable.stateArray.getItem(currentState);
            let entryIndex = row[classCode];
            let entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $860c6347bb941b91$var$END_OF_TEXT_CLASS && classCode !== $860c6347bb941b91$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $860c6347bb941b91$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    }
    /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ traverse(opts, state = 0, visited = new Set) {
        if (visited.has(state)) return;
        visited.add(state);
        let { nClasses: nClasses, stateArray: stateArray, entryTable: entryTable } = this.stateTable;
        let row = stateArray.getItem(state);
        // Skip predefined classes
        for(let classCode = 4; classCode < nClasses; classCode++){
            let entryIndex = row[classCode];
            let entry = entryTable.getItem(entryIndex);
            // Try all glyphs in the class
            for (let glyph of this.lookupTable.glyphsForValue(classCode)){
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    }
    constructor(stateTable){
        this.stateTable = stateTable;
        this.lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(stateTable.classTable);
    }
}
// indic replacement flags
const $99be642f82069918$var$MARK_FIRST = 0x8000;
const $99be642f82069918$var$MARK_LAST = 0x2000;
const $99be642f82069918$var$VERB = 0x000F;
// contextual substitution and glyph insertion flag
const $99be642f82069918$var$SET_MARK = 0x8000;
// ligature entry flags
const $99be642f82069918$var$SET_COMPONENT = 0x8000;
const $99be642f82069918$var$PERFORM_ACTION = 0x2000;
// ligature action masks
const $99be642f82069918$var$LAST_MASK = 0x80000000;
const $99be642f82069918$var$STORE_MASK = 0x40000000;
const $99be642f82069918$var$OFFSET_MASK = 0x3FFFFFFF;
const $99be642f82069918$var$VERTICAL_ONLY = 0x800000;
const $99be642f82069918$var$REVERSE_DIRECTION = 0x400000;
const $99be642f82069918$var$HORIZONTAL_AND_VERTICAL = 0x200000;
// glyph insertion flags
const $99be642f82069918$var$CURRENT_IS_KASHIDA_LIKE = 0x2000;
const $99be642f82069918$var$MARKED_IS_KASHIDA_LIKE = 0x1000;
const $99be642f82069918$var$CURRENT_INSERT_BEFORE = 0x0800;
const $99be642f82069918$var$MARKED_INSERT_BEFORE = 0x0400;
const $99be642f82069918$var$CURRENT_INSERT_COUNT = 0x03E0;
const $99be642f82069918$var$MARKED_INSERT_COUNT = 0x001F;
class $99be642f82069918$export$2e2bcd8739ae039 {
    // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:boolean}}
    process(glyphs, features = {}) {
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            // enable/disable the requested features
            for (let feature of chain.features){
                let f;
                if (f = features[feature.featureType]) {
                    if (f[feature.featureSetting]) {
                        flags &= feature.disableFlags;
                        flags |= feature.enableFlags;
                    } else if (f[feature.featureSetting] === false) {
                        flags |= ~feature.disableFlags;
                        flags &= ~feature.enableFlags;
                    }
                }
            }
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
        }
        // remove deleted glyphs
        let index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    }
    processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let reverse = !!(this.subtable.coverage & $99be642f82069918$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    }
    getStateMachine(subtable) {
        return new $860c6347bb941b91$export$2e2bcd8739ae039(subtable.table.stateTable);
    }
    getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
        }
    }
    processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $99be642f82069918$var$MARK_LAST) this.lastGlyph = index;
        $99be642f82069918$var$reorderGlyphs(this.glyphs, entry.flags & $99be642f82069918$var$VERB, this.firstGlyph, this.lastGlyph);
    }
    processContextualSubstitution(glyph, entry, index) {
        let subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.markIndex);
            let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.currentIndex);
            let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[index];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $99be642f82069918$var$SET_MARK) this.markedGlyph = index;
    }
    processLigature(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $99be642f82069918$var$PERFORM_ACTION) {
            let actions = this.subtable.table.ligatureActions;
            let components = this.subtable.table.components;
            let ligatureList = this.subtable.table.ligatureList;
            let actionIndex = entry.action;
            let last = false;
            let ligatureIndex = 0;
            let codePoints = [];
            let ligatureGlyphs = [];
            while(!last){
                let componentGlyph = this.ligatureStack.pop();
                codePoints.unshift(...this.glyphs[componentGlyph].codePoints);
                let action = actions.getItem(actionIndex++);
                last = !!(action & $99be642f82069918$var$LAST_MASK);
                let store = !!(action & $99be642f82069918$var$STORE_MASK);
                let offset = (action & $99be642f82069918$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                let component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    let ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            }
            // Put ligature glyph indexes back on the stack
            this.ligatureStack.push(...ligatureGlyphs);
        }
    }
    processNoncontextualSubstitutions(subtable, glyphs, index) {
        let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                let gid = lookupTable.lookup(glyph.id);
                if (gid) glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    }
    _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        let insertions = [];
        while(count--){
            let gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        this.glyphs.splice(glyphIndex, 0, ...insertions);
    }
    processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            let count = (entry.flags & $99be642f82069918$var$MARKED_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $99be642f82069918$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            let count = (entry.flags & $99be642f82069918$var$CURRENT_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $99be642f82069918$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, count, isBefore);
        }
    }
    getSupportedFeatures() {
        let features = [];
        for (let chain of this.morx.chains)for (let feature of chain.features)features.push([
            feature.featureType,
            feature.featureSetting
        ]);
        return features;
    }
    generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    }
    generateInputCache() {
        this.inputCache = {};
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
        }
    }
    generateInputsForSubtable(subtable) {
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        let reverse = !!(subtable.coverage & $99be642f82069918$var$REVERSE_DIRECTION);
        if (reverse) throw new Error("Reverse subtable, not supported.");
        this.subtable = subtable;
        this.ligatureStack = [];
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let input = [];
        let stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: (glyph, entry)=>{
                let glyphs = this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: this.ligatureStack.slice()
                });
                // Add glyph to input and glyphs to process.
                let g1 = this.font.getGlyph(glyph);
                input.push(g1);
                glyphs.push(input[input.length - 1]);
                // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                // Add input to result if only one matching (non-deleted) glyph remains.
                let count = 0;
                let found = 0;
                for(let i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    let result = input.map((g)=>g.id);
                    let cache1 = this.inputCache[found];
                    if (cache1) cache1.push(result);
                    else this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: ()=>{
                ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = stack.pop());
                input.pop();
            }
        });
    }
    constructor(font){
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $99be642f82069918$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
// swaps the glyphs in rangeA with those in rangeB
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $99be642f82069918$var$swap(glyphs, rangeA, rangeB, reverseA = false, reverseB = false) {
    let end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    let start = glyphs.splice(rangeA[0], rangeA[1], ...end);
    if (reverseA) start.reverse();
    glyphs.splice(rangeB[0] - (rangeA[1] - 1), 0, ...start);
    return glyphs;
}
function $99be642f82069918$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    let length = lastGlyph - firstGlyph + 1;
    switch(verb){
        case 0:
            return glyphs;
        case 1:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error(`Unknown verb: ${verb}`);
    }
}
class $860fcbd64bc12fbc$export$2e2bcd8739ae039 {
    substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === "rtl") glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $2b7f887ebcb5888a$export$b813f7d2a1677c16(glyphRun.features));
    }
    getAvailableFeatures(script, language) {
        return $2b7f887ebcb5888a$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
    }
    stringsForGlyph(gid) {
        let glyphStrings = this.morxProcessor.generateInputs(gid);
        let result = new Set;
        for (let glyphs of glyphStrings)this._addStrings(glyphs, 0, result, "");
        return result;
    }
    _addStrings(glyphs, index, strings, string) {
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for (let codePoint of codePoints){
            let s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    }
    constructor(font){
        this.font = font;
        this.morxProcessor = new $99be642f82069918$export$2e2bcd8739ae039(font);
        this.fallbackPosition = false;
    }
}
class $d7e93cca3cf8ce8a$export$2e2bcd8739ae039 {
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ _addFeatures(features, global) {
        let stageIndex = this.stages.length - 1;
        let stage = this.stages[stageIndex];
        for (let feature of features)if (this.allFeatures[feature] == null) {
            stage.push(feature);
            this.allFeatures[feature] = stageIndex;
            if (global) this.globalFeatures[feature] = true;
        }
    }
    /**
   * Add features to the last stage
   */ add(arg, global = true) {
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === "string") arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global);
        else if (typeof arg === "object") {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    }
    /**
   * Add a new stage
   */ addStage(arg, global) {
        if (typeof arg === "function") this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global);
        }
    }
    setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === "object") for(let tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                let stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    }
    /**
   * Assigns the global features to the given glyphs
   */ assignGlobalFeatures(glyphs) {
        for (let glyph of glyphs)for(let feature in this.globalFeatures)glyph.features[feature] = true;
    }
    /**
   * Executes the planned stages using the given OTProcessor
   */ process(processor, glyphs, positions) {
        for (let stage of this.stages){
            if (typeof stage === "function") {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    }
    constructor(font, script, direction){
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
}
const $d28fb665ee343afc$var$VARIATION_FEATURES = [
    "rvrn"
];
const $d28fb665ee343afc$var$COMMON_FEATURES = [
    "ccmp",
    "locl",
    "rlig",
    "mark",
    "mkmk"
];
const $d28fb665ee343afc$var$FRACTIONAL_FEATURES = [
    "frac",
    "numr",
    "dnom"
];
const $d28fb665ee343afc$var$HORIZONTAL_FEATURES = [
    "calt",
    "clig",
    "liga",
    "rclt",
    "curs",
    "kern"
];
const $d28fb665ee343afc$var$VERTICAL_FEATURES = [
    "vert"
];
const $d28fb665ee343afc$var$DIRECTIONAL_FEATURES = {
    ltr: [
        "ltra",
        "ltrm"
    ],
    rtl: [
        "rtla",
        "rtlm"
    ]
};
class $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static plan(plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(plan);
        this.planFeatures(plan);
        this.planPostprocessing(plan, features);
        // Assign the global features to all the glyphs
        plan.assignGlobalFeatures(glyphs);
        // Assign local features to glyphs
        this.assignFeatures(plan, glyphs);
    }
    static planPreprocessing(plan) {
        plan.add({
            global: [
                ...$d28fb665ee343afc$var$VARIATION_FEATURES,
                ...$d28fb665ee343afc$var$DIRECTIONAL_FEATURES[plan.direction]
            ],
            local: $d28fb665ee343afc$var$FRACTIONAL_FEATURES
        });
    }
    static planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
    }
    static planPostprocessing(plan, userFeatures) {
        plan.add([
            ...$d28fb665ee343afc$var$COMMON_FEATURES,
            ...$d28fb665ee343afc$var$HORIZONTAL_FEATURES
        ]);
        plan.setFeatureOverrides(userFeatures);
    }
    static assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(let i = 0; i < glyphs.length; i++){
            let glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                let start = i;
                let end = i + 1;
                // Apply numerator
                while(start > 0 && (0, $gfJaN$unicodeproperties.isDigit)(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                }
                // Apply denominator
                while(end < glyphs.length && (0, $gfJaN$unicodeproperties.isDigit)(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                }
                // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($d28fb665ee343afc$export$2e2bcd8739ae039, "zeroMarkWidths", "AFTER_GPOS");
const $17ba6019f27bfcf9$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("ABABAAAAAACgMQAAAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0="));
const $17ba6019f27bfcf9$var$FEATURES = [
    "isol",
    "fina",
    "fin2",
    "fin3",
    "medi",
    "med2",
    "init"
];
const $17ba6019f27bfcf9$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    "DALATH RISH": 5,
    Transparent: 6
};
const $17ba6019f27bfcf9$var$ISOL = "isol";
const $17ba6019f27bfcf9$var$FINA = "fina";
const $17ba6019f27bfcf9$var$FIN2 = "fin2";
const $17ba6019f27bfcf9$var$FIN3 = "fin3";
const $17ba6019f27bfcf9$var$MEDI = "medi";
const $17ba6019f27bfcf9$var$MED2 = "med2";
const $17ba6019f27bfcf9$var$INIT = "init";
const $17ba6019f27bfcf9$var$NONE = null;
// Each entry is [prevAction, curAction, nextState]
const $17ba6019f27bfcf9$var$STATE_TABLE = [
    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
    // State 0: prev was U,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 2: prev was D/L in ISOL form,  willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 3: prev was D in FINA form,  willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 4: prev was FINA ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 6: prev was DALATH/RISH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$FIN3,
            5
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ]
];
class $17ba6019f27bfcf9$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            "ccmp",
            "locl"
        ]);
        for(let i = 0; i < $17ba6019f27bfcf9$var$FEATURES.length; i++){
            let feature = $17ba6019f27bfcf9$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage("mset");
    }
    static assignFeatures(plan, glyphs) {
        super.assignFeatures(plan, glyphs);
        let prev = -1;
        let state = 0;
        let actions = [];
        // Apply the state machine to map glyphs to features
        for(let i = 0; i < glyphs.length; i++){
            let curAction, prevAction;
            var glyph = glyphs[i];
            let type = $17ba6019f27bfcf9$var$getShapingClass(glyph.codePoints[0]);
            if (type === $17ba6019f27bfcf9$var$ShapingClasses.Transparent) {
                actions[i] = $17ba6019f27bfcf9$var$NONE;
                continue;
            }
            [prevAction, curAction, state] = $17ba6019f27bfcf9$var$STATE_TABLE[state][type];
            if (prevAction !== $17ba6019f27bfcf9$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        }
        // Apply the chosen features to their respective glyphs
        for(let index = 0; index < glyphs.length; index++){
            let feature;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    }
}
function $17ba6019f27bfcf9$var$getShapingClass(codePoint) {
    let res = $17ba6019f27bfcf9$var$trie.get(codePoint);
    if (res) return res - 1;
    let category = (0, $gfJaN$unicodeproperties.getCategory)(codePoint);
    if (category === "Mn" || category === "Me" || category === "Cf") return $17ba6019f27bfcf9$var$ShapingClasses.Transparent;
    return $17ba6019f27bfcf9$var$ShapingClasses.Non_Joining;
}
class $d6368085223f631e$export$2e2bcd8739ae039 {
    reset(options = {}, index = 0) {
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    }
    get cur() {
        return this.glyphs[this.index] || null;
    }
    shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    }
    move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    }
    next() {
        return this.move(1);
    }
    prev() {
        return this.move(-1);
    }
    peek(count = 1) {
        let idx = this.index;
        let res = this.increment(count);
        this.index = idx;
        return res;
    }
    peekIndex(count = 1) {
        let idx = this.index;
        this.increment(count);
        let res = this.index;
        this.index = idx;
        return res;
    }
    increment(count = 1) {
        let dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    }
    constructor(glyphs, options){
        this.glyphs = glyphs;
        this.reset(options);
    }
}
const $7b226e6bbeadedeb$var$DEFAULT_SCRIPTS = [
    "DFLT",
    "dflt",
    "latn"
];
class $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for (let s of script)for (let entry of this.table.scriptList){
            if (entry.tag === s) return entry;
        }
        return null;
    }
    selectScript(script, language, direction) {
        let changed = false;
        let entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($7b226e6bbeadedeb$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction || direction !== this.direction) this.direction = direction || $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        if (language && language.length < 4) language += " ".repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for (let lang of this.script.langSysRecords)if (lang.tag === language) {
                this.language = lang.langSys;
                this.languageTag = lang.tag;
                break;
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        }
        // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for (let featureIndex of this.language.featureIndexes){
                let record = this.table.featureList[featureIndex];
                let substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    }
    lookupsForFeatures(userFeatures = [], exclude) {
        let lookups = [];
        for (let tag of userFeatures){
            let feature = this.features[tag];
            if (!feature) continue;
            for (let lookupIndex of feature.lookupListIndexes){
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort((a, b)=>a.index - b.index);
        return lookups;
    }
    substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        let record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        let substitutions = record.featureTableSubstitution.substitutions;
        for (let substitution of substitutions){
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    }
    findVariationsIndex(coords) {
        let variations = this.table.featureVariations;
        if (!variations) return -1;
        let records = variations.featureVariationRecords;
        for(let i = 0; i < records.length; i++){
            let conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    }
    variationConditionsMatch(conditions, coords) {
        return conditions.every((condition)=>{
            let coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    }
    applyFeatures(userFeatures, glyphs, advances) {
        let lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    }
    applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $d6368085223f631e$export$2e2bcd8739ae039(glyphs);
        for (let { feature: feature, lookup: lookup } of lookups){
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for (let table of lookup.subTables){
                    let res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    }
    applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    }
    applyLookupList(lookupRecords) {
        let options = this.glyphIterator.options;
        let glyphIndex = this.glyphIterator.index;
        for (let lookupRecord of lookupRecords){
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex);
            // Get the lookup and setup flags for subtables
            let lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
            // Apply lookup subtables until one matches
            for (let table of lookup.subTables){
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    }
    coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for (let range of coverage.rangeRecords){
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    }
    match(sequenceIndex, sequence, fn, matched) {
        let pos = this.glyphIterator.index;
        let glyph = this.glyphIterator.increment(sequenceIndex);
        let idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    }
    sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>component === glyph.id);
    }
    sequenceMatchIndices(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>{
            // If the current feature doesn't apply to this glyph,
            if (!(this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    }
    coverageSequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (coverage, glyph)=>this.coverageIndex(coverage, glyph.id) >= 0);
    }
    getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                let i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for (let range of classDef.classRangeRecord){
                    if (range.start <= glyph && glyph <= range.end) return range.class;
                }
                break;
        }
        return 0;
    }
    classSequenceMatches(sequenceIndex, sequence, classDef) {
        return this.match(sequenceIndex, sequence, (classID, glyph)=>classID === this.getClassID(glyph.id, classDef));
    }
    applyContext(table) {
        let index, set;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                set = table.ruleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for (let rule1 of set){
                    if (this.classSequenceMatches(1, rule1.classes, table.classDef)) return this.applyLookupList(rule1.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    applyChainingContext(table) {
        let index;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                let set = table.chainRuleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                let rules = table.chainClassSet[index];
                if (!rules) return false;
                for (let rule2 of rules){
                    if (this.classSequenceMatches(-rule2.backtrack.length, rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + rule2.input.length, rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(rule2.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    constructor(font, table){
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {};
        // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
        // initialize to default script + language
        this.selectScript();
        // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
}
class $f22bb23c9fd478d8$export$2e2bcd8739ae039 {
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
        this.substituted = true;
        let GDEF = this._font.GDEF;
        if (GDEF && GDEF.glyphClassDef) {
            // TODO: clean this up
            let classID = $7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.glyphClassDef);
            this.isBase = classID === 1;
            this.isLigature = classID === 2;
            this.isMark = classID === 3;
            this.markAttachmentType = GDEF.markAttachClassDef ? $7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
        } else {
            this.isMark = this.codePoints.length > 0 && this.codePoints.every($gfJaN$unicodeproperties.isMark);
            this.isBase = !this.isMark;
            this.isLigature = this.codePoints.length > 1;
            this.markAttachmentType = 0;
        }
    }
    copy() {
        return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
    }
    constructor(font, id, codePoints = [], features){
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(let i = 0; i < features.length; i++){
            let feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === "object") Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
}
class $fa1d9fd80dd7279e$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            "ljmo",
            "vjmo",
            "tjmo"
        ], false);
    }
    static assignFeatures(plan, glyphs) {
        let state = 0;
        let i = 0;
        while(i < glyphs.length){
            let action;
            let glyph = glyphs[i];
            let code = glyph.codePoints[0];
            let type = $fa1d9fd80dd7279e$var$getType(code);
            [action, state] = $fa1d9fd80dd7279e$var$STATE_TABLE[state][type];
            switch(action){
                case $fa1d9fd80dd7279e$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $fa1d9fd80dd7279e$var$decompose(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $fa1d9fd80dd7279e$var$compose(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($fa1d9fd80dd7279e$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
const $fa1d9fd80dd7279e$var$HANGUL_BASE = 0xac00;
const $fa1d9fd80dd7279e$var$HANGUL_END = 0xd7a4;
const $fa1d9fd80dd7279e$var$HANGUL_COUNT = $fa1d9fd80dd7279e$var$HANGUL_END - $fa1d9fd80dd7279e$var$HANGUL_BASE + 1;
const $fa1d9fd80dd7279e$var$L_BASE = 0x1100; // lead
const $fa1d9fd80dd7279e$var$V_BASE = 0x1161; // vowel
const $fa1d9fd80dd7279e$var$T_BASE = 0x11a7; // trail
const $fa1d9fd80dd7279e$var$L_COUNT = 19;
const $fa1d9fd80dd7279e$var$V_COUNT = 21;
const $fa1d9fd80dd7279e$var$T_COUNT = 28;
const $fa1d9fd80dd7279e$var$L_END = $fa1d9fd80dd7279e$var$L_BASE + $fa1d9fd80dd7279e$var$L_COUNT - 1;
const $fa1d9fd80dd7279e$var$V_END = $fa1d9fd80dd7279e$var$V_BASE + $fa1d9fd80dd7279e$var$V_COUNT - 1;
const $fa1d9fd80dd7279e$var$T_END = $fa1d9fd80dd7279e$var$T_BASE + $fa1d9fd80dd7279e$var$T_COUNT - 1;
const $fa1d9fd80dd7279e$var$DOTTED_CIRCLE = 0x25cc;
const $fa1d9fd80dd7279e$var$isL = (code)=>0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
const $fa1d9fd80dd7279e$var$isV = (code)=>0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
const $fa1d9fd80dd7279e$var$isT = (code)=>0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
const $fa1d9fd80dd7279e$var$isTone = (code)=>0x302e <= code && code <= 0x302f;
const $fa1d9fd80dd7279e$var$isLVT = (code)=>$fa1d9fd80dd7279e$var$HANGUL_BASE <= code && code <= $fa1d9fd80dd7279e$var$HANGUL_END;
const $fa1d9fd80dd7279e$var$isLV = (code)=>code - $fa1d9fd80dd7279e$var$HANGUL_BASE < $fa1d9fd80dd7279e$var$HANGUL_COUNT && (code - $fa1d9fd80dd7279e$var$HANGUL_BASE) % $fa1d9fd80dd7279e$var$T_COUNT === 0;
const $fa1d9fd80dd7279e$var$isCombiningL = (code)=>$fa1d9fd80dd7279e$var$L_BASE <= code && code <= $fa1d9fd80dd7279e$var$L_END;
const $fa1d9fd80dd7279e$var$isCombiningV = (code)=>$fa1d9fd80dd7279e$var$V_BASE <= code && code <= $fa1d9fd80dd7279e$var$V_END;
const $fa1d9fd80dd7279e$var$isCombiningT = (code)=>$fa1d9fd80dd7279e$var$T_BASE + 1 && 1 <= code && code <= $fa1d9fd80dd7279e$var$T_END;
// Character categories
const $fa1d9fd80dd7279e$var$X = 0; // Other character
const $fa1d9fd80dd7279e$var$L = 1; // Leading consonant
const $fa1d9fd80dd7279e$var$V = 2; // Medial vowel
const $fa1d9fd80dd7279e$var$T = 3; // Trailing consonant
const $fa1d9fd80dd7279e$var$LV = 4; // Composed <LV> syllable
const $fa1d9fd80dd7279e$var$LVT = 5; // Composed <LVT> syllable
const $fa1d9fd80dd7279e$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $fa1d9fd80dd7279e$var$getType(code) {
    if ($fa1d9fd80dd7279e$var$isL(code)) return $fa1d9fd80dd7279e$var$L;
    if ($fa1d9fd80dd7279e$var$isV(code)) return $fa1d9fd80dd7279e$var$V;
    if ($fa1d9fd80dd7279e$var$isT(code)) return $fa1d9fd80dd7279e$var$T;
    if ($fa1d9fd80dd7279e$var$isLV(code)) return $fa1d9fd80dd7279e$var$LV;
    if ($fa1d9fd80dd7279e$var$isLVT(code)) return $fa1d9fd80dd7279e$var$LVT;
    if ($fa1d9fd80dd7279e$var$isTone(code)) return $fa1d9fd80dd7279e$var$M;
    return $fa1d9fd80dd7279e$var$X;
}
// State machine actions
const $fa1d9fd80dd7279e$var$NO_ACTION = 0;
const $fa1d9fd80dd7279e$var$DECOMPOSE = 1;
const $fa1d9fd80dd7279e$var$COMPOSE = 2;
const $fa1d9fd80dd7279e$var$TONE_MARK = 4;
const $fa1d9fd80dd7279e$var$INVALID = 5;
// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
const $fa1d9fd80dd7279e$var$STATE_TABLE = [
    //       X                 L                 V                T                  LV                LVT               M
    // State 0: start state
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 1: <L>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$COMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 2: <L,V> or <LV>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$COMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ],
    // State 3: <L,V,T> or <LVT>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ]
];
function $fa1d9fd80dd7279e$var$getGlyph(font, code, features) {
    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $fa1d9fd80dd7279e$var$decompose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyph.codePoints[0];
    let s = code - $fa1d9fd80dd7279e$var$HANGUL_BASE;
    let t = $fa1d9fd80dd7279e$var$T_BASE + s % $fa1d9fd80dd7279e$var$T_COUNT;
    s = s / $fa1d9fd80dd7279e$var$T_COUNT | 0;
    let l = $fa1d9fd80dd7279e$var$L_BASE + s / $fa1d9fd80dd7279e$var$V_COUNT | 0;
    let v = $fa1d9fd80dd7279e$var$V_BASE + s % $fa1d9fd80dd7279e$var$V_COUNT;
    // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $fa1d9fd80dd7279e$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
    // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    let ljmo = $fa1d9fd80dd7279e$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    let vjmo = $fa1d9fd80dd7279e$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    let insert = [
        ljmo,
        vjmo
    ];
    if (t > $fa1d9fd80dd7279e$var$T_BASE) {
        let tjmo = $fa1d9fd80dd7279e$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice(i, 1, ...insert);
    return i + insert.length - 1;
}
function $fa1d9fd80dd7279e$var$compose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    let type = $fa1d9fd80dd7279e$var$getType(code);
    let prev = glyphs[i - 1].codePoints[0];
    let prevType = $fa1d9fd80dd7279e$var$getType(prev);
    // Figure out what type of syllable we're dealing with
    let lv, ljmo, vjmo, tjmo;
    if (prevType === $fa1d9fd80dd7279e$var$LV && type === $fa1d9fd80dd7279e$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $fa1d9fd80dd7279e$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        let l = ljmo.codePoints[0];
        let v = vjmo.codePoints[0];
        // Make sure L and V are combining characters
        if ($fa1d9fd80dd7279e$var$isCombiningL(l) && $fa1d9fd80dd7279e$var$isCombiningV(v)) lv = $fa1d9fd80dd7279e$var$HANGUL_BASE + ((l - $fa1d9fd80dd7279e$var$L_BASE) * $fa1d9fd80dd7279e$var$V_COUNT + (v - $fa1d9fd80dd7279e$var$V_BASE)) * $fa1d9fd80dd7279e$var$T_COUNT;
    }
    let t = tjmo && tjmo.codePoints[0] || $fa1d9fd80dd7279e$var$T_BASE;
    if (lv != null && (t === $fa1d9fd80dd7279e$var$T_BASE || $fa1d9fd80dd7279e$var$isCombiningT(t))) {
        let s = lv + (t - $fa1d9fd80dd7279e$var$T_BASE);
        // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            let del = prevType === $fa1d9fd80dd7279e$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $fa1d9fd80dd7279e$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $fa1d9fd80dd7279e$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $fa1d9fd80dd7279e$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $fa1d9fd80dd7279e$var$getLength(code) {
    switch($fa1d9fd80dd7279e$var$getType(code)){
        case $fa1d9fd80dd7279e$var$LV:
        case $fa1d9fd80dd7279e$var$LVT:
            return 1;
        case $fa1d9fd80dd7279e$var$V:
            return 2;
        case $fa1d9fd80dd7279e$var$T:
            return 3;
    }
}
function $fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    let prev = glyphs[i - 1].codePoints[0];
    let len = $fa1d9fd80dd7279e$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($fa1d9fd80dd7279e$var$DOTTED_CIRCLE)) {
        let dottedCircle = $fa1d9fd80dd7279e$var$getGlyph(font, $fa1d9fd80dd7279e$var$DOTTED_CIRCLE, glyph.features);
        // If the tone mark is zero width, insert the dotted circle before, otherwise after
        let idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var $d22b56f2cf15e5ba$exports = {};
$d22b56f2cf15e5ba$exports = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var $79781f8c452881c2$exports = {};
$79781f8c452881c2$exports = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,23,0,0,2,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const $79e3b6f2c331d0bf$export$a513ea61a7bee91c = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    Coeng: 16384,
    Repha: 32768,
    Ra: 65536,
    CM: 131072,
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
};
const $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0 = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
const $79e3b6f2c331d0bf$export$8519deaa7de2b07 = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.C | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.V | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Placeholder | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Dotted_Circle;
const $79e3b6f2c331d0bf$export$bbcd928767338e0d = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
const $79e3b6f2c331d0bf$export$ca9599b2a300afc = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Coeng;
const $79e3b6f2c331d0bf$export$e99d119da76a0fc5 = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Sub,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Explicit",
        blwfMode: "Post_Only"
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Implicit",
        blwfMode: "Post_Only"
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: "Log_Repha",
        blwfMode: "Pre_And_Post"
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: "First",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
        rephMode: "Vis_Repha",
        blwfMode: "Pre_And_Post"
    }
};
const $79e3b6f2c331d0bf$export$f647c9cfdd77d95a = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
const { decompositions: $d203e6b9523d0071$var$decompositions } = /*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports);
const $d203e6b9523d0071$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("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"));
const $d203e6b9523d0071$var$stateMachine = new ($parcel$interopDefault($gfJaN$dfa))(/*@__PURE__*/ $parcel$interopDefault($d22b56f2cf15e5ba$exports));
class $d203e6b9523d0071$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($d203e6b9523d0071$var$setupSyllables);
        plan.addStage([
            "locl",
            "ccmp"
        ]);
        plan.addStage($d203e6b9523d0071$var$initialReordering);
        plan.addStage("nukt");
        plan.addStage("akhn");
        plan.addStage("rphf", false);
        plan.addStage("rkrf");
        plan.addStage("pref", false);
        plan.addStage("blwf", false);
        plan.addStage("abvf", false);
        plan.addStage("half", false);
        plan.addStage("pstf", false);
        plan.addStage("vatu");
        plan.addStage("cjct");
        plan.addStage("cfar", false);
        plan.addStage($d203e6b9523d0071$var$finalReordering);
        plan.addStage({
            local: [
                "init"
            ],
            global: [
                "pres",
                "abvs",
                "blws",
                "psts",
                "haln",
                "dist",
                "abvm",
                "blwm",
                "calt",
                "clig"
            ]
        });
        // Setup the indic config for the selected script
        plan.unicodeScript = $e38a1a895f6aeb54$export$ce50e82f12a827a4(plan.script);
        plan.indicConfig = $79e3b6f2c331d0bf$export$e99d119da76a0fc5[plan.unicodeScript] || $79e3b6f2c331d0bf$export$e99d119da76a0fc5.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== "2";
    // TODO: turn off kern (Khmer) and liga features.
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            let d = $79e3b6f2c331d0bf$export$f647c9cfdd77d95a[codepoint] || $d203e6b9523d0071$var$decompositions[codepoint];
            if (d) {
                let decomposed = d.map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($d203e6b9523d0071$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
function $d203e6b9523d0071$var$indicCategory(glyph) {
    return $d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) >> 8;
}
function $d203e6b9523d0071$var$indicPosition(glyph) {
    return 1 << ($d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) & 0xff);
}
class $d203e6b9523d0071$var$IndicInfo {
    constructor(category, position, syllableType, syllable){
        this.category = category;
        this.position = position;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $d203e6b9523d0071$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    let last = 0;
    for (let [start, end, tags] of $d203e6b9523d0071$var$stateMachine.match(glyphs.map($d203e6b9523d0071$var$indicCategory))){
        if (start > last) {
            ++syllable;
            for(let i = last; i < start; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo($79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", syllable);
        }
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo(1 << $d203e6b9523d0071$var$indicCategory(glyphs[i]), $d203e6b9523d0071$var$indicPosition(glyphs[i]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(let i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo($79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", syllable);
    }
}
function $d203e6b9523d0071$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$8519deaa7de2b07;
}
function $d203e6b9523d0071$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$bbcd928767338e0d;
}
function $d203e6b9523d0071$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$ca9599b2a300afc;
}
function $d203e6b9523d0071$var$wouldSubstitute(glyphs, feature) {
    for (let glyph of glyphs)glyph.features = {
        [feature]: true
    };
    let GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $d203e6b9523d0071$var$consonantPosition(font, consonant, virama) {
    let glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "blwf") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "blwf")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
    else if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "pstf") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "pstf")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    else if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "pref") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "pref")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
}
function $d203e6b9523d0071$var$initialReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    let virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        let info = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, virama, [
            indicConfig.virama
        ]);
        for(let i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) glyphs[i].shaperInfo.position = $d203e6b9523d0071$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(let start = 0, end = $d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        let { category: category, syllableType: syllableType } = glyphs[start].shaperInfo;
        if (syllableType === "symbol_cluster" || syllableType === "non_indic_cluster") continue;
        if (syllableType === "broken_cluster" && dottedCircle) {
            let g = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $d203e6b9523d0071$var$IndicInfo(1 << $d203e6b9523d0071$var$indicCategory(g), $d203e6b9523d0071$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            // Insert after possible Repha.
            let i = start;
            while(i < end && glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha)i++;
            glyphs.splice(i++, 0, g);
            end++;
        }
        // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        let base = end;
        let limit = start;
        let hasReph = false;
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === "Implicit" && !$d203e6b9523d0071$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === "Explicit" && glyphs[start + 2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
            // See if it matches the 'rphf' feature.
            let g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($d203e6b9523d0071$var$wouldSubstitute(g.slice(0, 2), "rphf") || indicConfig.rephMode === "Explicit" && $d203e6b9523d0071$var$wouldSubstitute(g, "rphf")) {
                limit += 2;
                while(limit < end && $d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === "Log_Repha" && glyphs[start].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha) {
            limit++;
            while(limit < end && $d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case "Last":
                {
                    // starting from the end of the syllable, move backwards
                    let i = end;
                    let seenBelow = false;
                    do {
                        let info = glyphs[--i].shaperInfo;
                        // until a consonant is found
                        if ($d203e6b9523d0071$var$isConsonant(glyphs[i])) {
                            // that does not have a below-base or post-base form
                            // (post-base forms have to follow below-base forms),
                            if (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C && (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C || seenBelow)) {
                                base = i;
                                break;
                            }
                            // or that is not a pre-base reordering Ra,
                            //
                            // IMPLEMENTATION NOTES:
                            //
                            // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                            // by the logic above already.
                            //
                            // or arrive at the first consonant. The consonant stopped at will
                            // be the base.
                            if (info.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) seenBelow = true;
                            base = i;
                        } else if (start < i && info.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ && glyphs[i - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                    }while (i > limit);
                    break;
                }
            case "First":
                // The first consonant is always the base.
                base = start;
                // Mark all subsequent consonants as below.
                for(let i = base + 1; i < end; i++)if ($d203e6b9523d0071$var$isConsonant(glyphs[i])) glyphs[i].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
        }
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
        // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(let i1 = start; i1 < base; i1++){
            let info = glyphs[i1].shaperInfo;
            info.position = Math.min($79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_C, info.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
        // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(let i2 = base + 1; i2 < end; i2++)if (glyphs[i2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
            for(let j = i2 + 1; j < end; j++)if ($d203e6b9523d0071$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Final_C;
                break;
            }
            break;
        }
        // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph;
        // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            let disallowDoubleHalants = plan.unicodeScript !== "Malayalam";
            for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) {
                let j;
                for(j = end - 1; j > i; j--){
                    if ($d203e6b9523d0071$var$isConsonant(glyphs[j]) || disallowDoubleHalants && glyphs[j].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                }
                if (glyphs[j].shaperInfo.category !== $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && j > i) {
                    // Move Halant to after last consonant.
                    let t = glyphs[i];
                    glyphs.splice(i, 0, ...glyphs.splice(i + 1, j - i));
                    glyphs[j] = t;
                }
                break;
            }
        }
        // Attach misc marks to previous char to move with them.
        let lastPos = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Start;
        for(let i3 = start; i3 < end; i3++){
            let info = glyphs[i3].shaperInfo;
            if (info.category & ($79e3b6f2c331d0bf$export$bbcd928767338e0d | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.RS | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $79e3b6f2c331d0bf$export$ca9599b2a300afc & info.category)) {
                info.position = lastPos;
                if (info.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && info.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(let j = i3; j > start; j--)if (glyphs[j - 1].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                        info.position = glyphs[j - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) lastPos = info.position;
        }
        // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        let last = base;
        for(let i4 = base + 1; i4 < end; i4++){
            if ($d203e6b9523d0071$var$isConsonant(glyphs[i4])) {
                for(let j = last + 1; j < i4; j++)if (glyphs[j].shaperInfo.position < $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) glyphs[j].shaperInfo.position = glyphs[i4].shaperInfo.position;
                last = i4;
            } else if (glyphs[i4].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) last = i4;
        }
        let arr = glyphs.slice(start, end);
        arr.sort((a, b)=>a.shaperInfo.position - b.shaperInfo.position);
        glyphs.splice(start, arr.length, ...arr);
        // Find base again
        for(let i5 = start; i5 < end; i5++)if (glyphs[i5].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            base = i5;
            break;
        }
        // Setup features now
        // Reph
        for(let i6 = start; i6 < end && glyphs[i6].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; i6++)glyphs[i6].features.rphf = true;
        // Pre-base
        let blwf = !plan.isOldSpec && indicConfig.blwfMode === "Pre_And_Post";
        for(let i7 = start; i7 < base; i7++){
            glyphs[i7].features.half = true;
            if (blwf) glyphs[i7].features.blwf = true;
        }
        // Post-base
        for(let i8 = base + 1; i8 < end; i8++){
            glyphs[i8].features.abvf = true;
            glyphs[i8].features.pstf = true;
            glyphs[i8].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === "Devanagari") {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(let i = start; i + 1 < base; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra && glyphs[i + 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && (i + 1 === base || glyphs[i + 2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
                glyphs[i].features.blwf = true;
                glyphs[i + 1].features.blwf = true;
            }
        }
        let prefLen = 2;
        if (features.pref && base + prefLen < end) for(let i9 = base + 1; i9 + prefLen - 1 < end; i9++){
            let g = [
                glyphs[i9].copy(),
                glyphs[i9 + 1].copy()
            ];
            if ($d203e6b9523d0071$var$wouldSubstitute(g, "pref")) {
                for(let j = 0; j < prefLen; j++)glyphs[i9++].features.pref = true;
                // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; i9 < end; i9++)glyphs[i9].features.cfar = true;
                break;
            }
        }
        // Apply ZWJ/ZWNJ effects
        for(let i10 = start + 1; i10 < end; i10++)if ($d203e6b9523d0071$var$isJoiner(glyphs[i10])) {
            let nonJoiner = glyphs[i10].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
            let j = i10;
            do {
                j--;
                // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[j].features.half;
            }while (j > start && !$d203e6b9523d0071$var$isConsonant(glyphs[j]));
        }
    }
}
function $d203e6b9523d0071$var$finalReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    for(let start = 0, end = $d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        let tryPref = !!features.pref;
        // Find base again
        let base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            if (tryPref && base + 1 < end) {
                for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            }
            // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === "Malayalam") for(let i = base + 1; i < end; i++){
                while(i < end && $d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i === end || !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[i])) break;
                i++; // Skip halant.
                while(i < end && $d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i < end && $d203e6b9523d0071$var$isConsonant(glyphs[i]) && glyphs[i].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) {
                    base = i;
                    glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $79e3b6f2c331d0bf$export$ca9599b2a300afc))base--;
        // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // If we lost track of base, alas, position before last thingy.
            let newPos = base === end ? base - 2 : base - 1;
            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    if (newPos + 1 < end && $d203e6b9523d0071$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                // Now go see if there's actually any matras...
                for(let i = newPos; i > start; i--)if (glyphs[i - 1].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    let oldPos = i - 1;
                    if (oldPos < base && base <= newPos) base--;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(oldPos, 0, ...glyphs.splice(oldPos + 1, newPos - oldPos));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        }
        // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            let newRephPos;
            let rephPos = indicConfig.rephPos;
            let found = false;
            // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
                // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main)newRephPos++;
                    found = newRephPos < end;
                }
                // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C | $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post | $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            }
            //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            }
            // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)newRephPos--;
                // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(let i = base + 1; i < newRephPos; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) newRephPos--;
                }
            }
            let reph = glyphs[start];
            glyphs.splice(start, 0, ...glyphs.splice(start + 1, newRephPos - start));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        }
        // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[i].isLigated && !glyphs[i].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    let newPos = base;
                    // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                        while(newPos > start && !(glyphs[newPos - 1].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                        // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (newPos > start && glyphs[newPos - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                            let oldPos = i;
                            for(let j = base + 1; j < oldPos; j++)if (glyphs[j].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                                newPos--;
                                break;
                            }
                        }
                    }
                    if (newPos > start && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos - 1])) {
                        if (newPos < end && $d203e6b9523d0071$var$isJoiner(glyphs[newPos])) newPos++;
                    }
                    let oldPos = i;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(newPos + 1, 0, ...glyphs.splice(newPos, oldPos - newPos));
                    glyphs[newPos] = tmp;
                    if (newPos <= base && base < oldPos) base++;
                }
                break;
            }
        }
        // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M && (!start || !/Cf|Mn/.test((0, $gfJaN$unicodeproperties.getCategory)(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $d203e6b9523d0071$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
const { categories: $9b772791ccede8a5$var$categories, decompositions: $9b772791ccede8a5$var$decompositions } = /*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports);
const $9b772791ccede8a5$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("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"));
const $9b772791ccede8a5$var$stateMachine = new ($parcel$interopDefault($gfJaN$dfa))(/*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports));
class $9b772791ccede8a5$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($9b772791ccede8a5$var$setupSyllables);
        // Default glyph pre-processing group
        plan.addStage([
            "locl",
            "ccmp",
            "nukt",
            "akhn"
        ]);
        // Reordering group
        plan.addStage($9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            "rphf"
        ], false);
        plan.addStage($9b772791ccede8a5$var$recordRphf);
        plan.addStage($9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            "pref"
        ]);
        plan.addStage($9b772791ccede8a5$var$recordPref);
        // Orthographic unit shaping group
        plan.addStage([
            "rkrf",
            "abvf",
            "blwf",
            "half",
            "pstf",
            "vatu",
            "cjct"
        ]);
        plan.addStage($9b772791ccede8a5$var$reorder);
        // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            "abvs",
            "blws",
            "pres",
            "psts",
            "dist",
            "abvm",
            "blwm"
        ]);
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            if ($9b772791ccede8a5$var$decompositions[codepoint]) {
                let decomposed = $9b772791ccede8a5$var$decompositions[codepoint].map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($9b772791ccede8a5$export$2e2bcd8739ae039, "zeroMarkWidths", "BEFORE_GPOS");
function $9b772791ccede8a5$var$useCategory(glyph) {
    return $9b772791ccede8a5$var$trie.get(glyph.codePoints[0]);
}
class $9b772791ccede8a5$var$USEInfo {
    constructor(category, syllableType, syllable){
        this.category = category;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $9b772791ccede8a5$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    for (let [start, end, tags] of $9b772791ccede8a5$var$stateMachine.match(glyphs.map($9b772791ccede8a5$var$useCategory))){
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $9b772791ccede8a5$var$USEInfo($9b772791ccede8a5$var$categories[$9b772791ccede8a5$var$useCategory(glyphs[i])], tags[0], syllable);
        // Assign rphf feature
        let limit = glyphs[start].shaperInfo.category === "R" ? 1 : Math.min(3, end - start);
        for(let i1 = start; i1 < start + limit; i1++)glyphs[i1].features.rphf = true;
    }
}
function $9b772791ccede8a5$var$clearSubstitutionFlags(font, glyphs) {
    for (let glyph of glyphs)glyph.substituted = false;
}
function $9b772791ccede8a5$var$recordRphf(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted && glyph.features.rphf) glyph.shaperInfo.category = "R";
}
function $9b772791ccede8a5$var$recordPref(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted) glyph.shaperInfo.category = "VPre";
}
function $9b772791ccede8a5$var$reorder(font, glyphs) {
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(let start = 0, end = $9b772791ccede8a5$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $9b772791ccede8a5$var$nextSyllable(glyphs, start)){
        let i, j;
        let info = glyphs[start].shaperInfo;
        let type = info.syllableType;
        // Only a few syllable types need reordering.
        if (type !== "virama_terminated_cluster" && type !== "standard_cluster" && type !== "broken_cluster") continue;
        // Insert a dotted circle glyph in broken clusters.
        if (type === "broken_cluster" && dottedCircle) {
            let g = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info;
            // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === "R"; i++);
            glyphs.splice(++i, 0, g);
            end++;
        }
        // Move things forward.
        if (info.category === "R" && end - start > 1) for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($9b772791ccede8a5$var$isBase(info) || $9b772791ccede8a5$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($9b772791ccede8a5$var$isHalant(glyphs[i])) i--;
                glyphs.splice(start, 0, ...glyphs.splice(start + 1, i - start), glyphs[i]);
                break;
            }
        }
        // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($9b772791ccede8a5$var$isBase(info) || $9b772791ccede8a5$var$isHalant(glyphs[i])) // place, and shift things in between backward.
            j = $9b772791ccede8a5$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === "VPre" || info.category === "VMPre") && j < i) glyphs.splice(j, 1, glyphs[i], ...glyphs.splice(j, i - j));
        }
    }
}
function $9b772791ccede8a5$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $9b772791ccede8a5$var$isHalant(glyph) {
    return glyph.shaperInfo.category === "H" && !glyph.isLigated;
}
function $9b772791ccede8a5$var$isBase(info) {
    return info.category === "B" || info.category === "GB";
}
const $fdb4471fc82bc2c2$var$SHAPERS = {
    arab: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mong: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    syrc: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    "nko ": $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phag: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mand: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mani: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phlp: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    hang: $fa1d9fd80dd7279e$export$2e2bcd8739ae039,
    bng2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    beng: $d203e6b9523d0071$export$2e2bcd8739ae039,
    dev2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    deva: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gjr2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gujr: $d203e6b9523d0071$export$2e2bcd8739ae039,
    guru: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gur2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    knda: $d203e6b9523d0071$export$2e2bcd8739ae039,
    knd2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    mlm2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    mlym: $d203e6b9523d0071$export$2e2bcd8739ae039,
    ory2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    orya: $d203e6b9523d0071$export$2e2bcd8739ae039,
    taml: $d203e6b9523d0071$export$2e2bcd8739ae039,
    tml2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    telu: $d203e6b9523d0071$export$2e2bcd8739ae039,
    tel2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    khmr: $d203e6b9523d0071$export$2e2bcd8739ae039,
    bali: $9b772791ccede8a5$export$2e2bcd8739ae039,
    batk: $9b772791ccede8a5$export$2e2bcd8739ae039,
    brah: $9b772791ccede8a5$export$2e2bcd8739ae039,
    bugi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    buhd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    cakm: $9b772791ccede8a5$export$2e2bcd8739ae039,
    cham: $9b772791ccede8a5$export$2e2bcd8739ae039,
    dupl: $9b772791ccede8a5$export$2e2bcd8739ae039,
    egyp: $9b772791ccede8a5$export$2e2bcd8739ae039,
    gran: $9b772791ccede8a5$export$2e2bcd8739ae039,
    hano: $9b772791ccede8a5$export$2e2bcd8739ae039,
    java: $9b772791ccede8a5$export$2e2bcd8739ae039,
    kthi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    kali: $9b772791ccede8a5$export$2e2bcd8739ae039,
    khar: $9b772791ccede8a5$export$2e2bcd8739ae039,
    khoj: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sind: $9b772791ccede8a5$export$2e2bcd8739ae039,
    lepc: $9b772791ccede8a5$export$2e2bcd8739ae039,
    limb: $9b772791ccede8a5$export$2e2bcd8739ae039,
    mahj: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $9b772791ccede8a5$export$2e2bcd8739ae039,
    modi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    saur: $9b772791ccede8a5$export$2e2bcd8739ae039,
    shrd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sidd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sinh: $d203e6b9523d0071$export$2e2bcd8739ae039,
    sund: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sylo: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tglg: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tagb: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tale: $9b772791ccede8a5$export$2e2bcd8739ae039,
    lana: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tavt: $9b772791ccede8a5$export$2e2bcd8739ae039,
    takr: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tibt: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tfng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tirh: $9b772791ccede8a5$export$2e2bcd8739ae039,
    latn: $d28fb665ee343afc$export$2e2bcd8739ae039,
    DFLT: $d28fb665ee343afc$export$2e2bcd8739ae039 // Default
};
function $fdb4471fc82bc2c2$export$7877a478dd30fd3d(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for (let s of script){
        let shaper = $fdb4471fc82bc2c2$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $d28fb665ee343afc$export$2e2bcd8739ae039;
}
class $86bc1883359e094a$export$2e2bcd8739ae039 extends $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    let glyph = this.glyphIterator.cur;
                    switch(table.version){
                        case 1:
                            glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                            break;
                        case 2:
                            glyph.id = table.substitute.get(index);
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let sequence = table.sequences.get(index);
                        if (sequence.length === 0) {
                            // If the sequence length is zero, delete the glyph.
                            // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                        }
                        this.glyphIterator.cur.id = sequence[0];
                        this.glyphIterator.cur.ligatureComponent = 0;
                        let features = this.glyphIterator.cur.features;
                        let curGlyph = this.glyphIterator.cur;
                        let replacement = sequence.slice(1).map((gid, i)=>{
                            let glyph = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, gid, undefined, features);
                            glyph.shaperInfo = curGlyph.shaperInfo;
                            glyph.isLigated = curGlyph.isLigated;
                            glyph.ligatureComponent = i + 1;
                            glyph.substituted = true;
                            glyph.isMultiplied = true;
                            return glyph;
                        });
                        this.glyphs.splice(this.glyphIterator.index + 1, 0, ...replacement);
                        return true;
                    }
                    return false;
                }
            case 3:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let USER_INDEX = 0; // TODO
                        this.glyphIterator.cur.id = table.alternateSet.get(index)[USER_INDEX];
                        return true;
                    }
                    return false;
                }
            case 4:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    for (let ligature of table.ligatureSets.get(index)){
                        let matched = this.sequenceMatchIndices(1, ligature.components);
                        if (!matched) continue;
                        let curGlyph = this.glyphIterator.cur;
                        // Concatenate all of the characters the new ligature will represent
                        let characters = curGlyph.codePoints.slice();
                        for (let index of matched)characters.push(...this.glyphs[index].codePoints);
                        // Create the replacement ligature glyph
                        let ligatureGlyph = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, ligature.glyph, characters, curGlyph.features);
                        ligatureGlyph.shaperInfo = curGlyph.shaperInfo;
                        ligatureGlyph.isLigated = true;
                        ligatureGlyph.substituted = true;
                        // From Harfbuzz:
                        // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                        //   the ligature to keep its old ligature id.  This will allow it to attach to
                        //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                        //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                        //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                        //   later, we don't want them to lose their ligature id/component, otherwise
                        //   GPOS will fail to correctly position the mark ligature on top of the
                        //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                        //
                        // - If a ligature is formed of components that some of which are also ligatures
                        //   themselves, and those ligature components had marks attached to *their*
                        //   components, we have to attach the marks to the new ligature component
                        //   positions!  Now *that*'s tricky!  And these marks may be following the
                        //   last component of the whole sequence, so we should loop forward looking
                        //   for them and update them.
                        //
                        //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                        //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                        //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                        //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                        //   the new ligature with a component value of 2.
                        //
                        //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                        let isMarkLigature = curGlyph.isMark;
                        for(let i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                        ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                        let lastLigID = curGlyph.ligatureID;
                        let lastNumComps = curGlyph.codePoints.length;
                        let curComps = lastNumComps;
                        let idx = this.glyphIterator.index + 1;
                        // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                        // This allows GPOS to attach marks to the correct ligature components.
                        for (let matchIndex of matched){
                            // Don't assign new ligature components for mark ligatures (see above)
                            if (isMarkLigature) idx = matchIndex;
                            else while(idx < matchIndex){
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                this.glyphs[idx].ligatureComponent = ligatureComponent;
                                idx++;
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++; // skip base glyph
                        }
                        // Adjust ligature components for any marks following
                        if (lastLigID && !isMarkLigature) for(let i1 = idx; i1 < this.glyphs.length; i1++){
                            if (this.glyphs[i1].ligatureID === lastLigID) {
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[i1].ligatureComponent || 1, lastNumComps);
                                this.glyphs[i1].ligatureComponent = ligatureComponent;
                            } else break;
                        }
                        // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                        for(let i2 = matched.length - 1; i2 >= 0; i2--)this.glyphs.splice(matched[i2], 1);
                        this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                        return true;
                    }
                    return false;
                }
            case 5:
                return this.applyContext(table);
            case 6:
                return this.applyChainingContext(table);
            case 7:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`GSUB lookupType ${lookupType} is not supported`);
        }
    }
}
class $79ea6270f0a90256$export$2e2bcd8739ae039 extends $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyPositionValue(sequenceIndex, value) {
        let position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        }
    // TODO: device tables
    }
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            this.applyPositionValue(0, table.value);
                            break;
                        case 2:
                            this.applyPositionValue(0, table.values.get(index));
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let nextGlyph = this.glyphIterator.peek();
                    if (!nextGlyph) return false;
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            let set = table.pairSets.get(index);
                            for (let pair of set)if (pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, pair.value1);
                                this.applyPositionValue(1, pair.value2);
                                return true;
                            }
                            return false;
                        case 2:
                            let class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                            let class2 = this.getClassID(nextGlyph.id, table.classDef2);
                            if (class1 === -1 || class2 === -1) return false;
                            var pair1 = table.classRecords.get(class1).get(class2);
                            this.applyPositionValue(0, pair1.value1);
                            this.applyPositionValue(1, pair1.value2);
                            return true;
                    }
                }
            case 3:
                {
                    let nextIndex = this.glyphIterator.peekIndex();
                    let nextGlyph = this.glyphs[nextIndex];
                    if (!nextGlyph) return false;
                    let curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                    if (!curRecord || !curRecord.exitAnchor) return false;
                    let nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, nextGlyph.id)];
                    if (!nextRecord || !nextRecord.entryAnchor) return false;
                    let entry = this.getAnchor(nextRecord.entryAnchor);
                    let exit = this.getAnchor(curRecord.exitAnchor);
                    let cur = this.positions[this.glyphIterator.index];
                    let next = this.positions[nextIndex];
                    let d;
                    switch(this.direction){
                        case "ltr":
                            cur.xAdvance = exit.x + cur.xOffset;
                            d = entry.x + next.xOffset;
                            next.xAdvance -= d;
                            next.xOffset -= d;
                            break;
                        case "rtl":
                            d = exit.x + cur.xOffset;
                            cur.xAdvance -= d;
                            cur.xOffset -= d;
                            next.xAdvance = entry.x + next.xOffset;
                            break;
                    }
                    if (this.glyphIterator.flags.rightToLeft) {
                        this.glyphIterator.cur.cursiveAttachment = nextIndex;
                        cur.yOffset = entry.y - exit.y;
                    } else {
                        nextGlyph.cursiveAttachment = this.glyphIterator.index;
                        cur.yOffset = exit.y - entry.y;
                    }
                    return true;
                }
            case 4:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                    if (baseGlyphIndex < 0) return false;
                    let baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                    if (baseIndex === -1) return false;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = table.baseArray[baseIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 5:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && this.glyphs[baseGlyphIndex].isMark);
                    if (baseGlyphIndex < 0) return false;
                    let ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[baseGlyphIndex].id);
                    if (ligIndex === -1) return false;
                    let ligAttach = table.ligatureArray[ligIndex];
                    let markGlyph = this.glyphIterator.cur;
                    let ligGlyph = this.glyphs[baseGlyphIndex];
                    let compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = ligAttach[compIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 6:
                {
                    let mark1Index = this.coverageIndex(table.mark1Coverage);
                    if (mark1Index === -1) return false;
                    // get the previous mark to attach to
                    let prevIndex = this.glyphIterator.peekIndex(-1);
                    let prev = this.glyphs[prevIndex];
                    if (!prev || !prev.isMark) return false;
                    let cur = this.glyphIterator.cur;
                    // The following logic was borrowed from Harfbuzz
                    let good = false;
                    if (cur.ligatureID === prev.ligatureID) {
                        if (!cur.ligatureID) good = true;
                        else if (cur.ligatureComponent === prev.ligatureComponent) good = true;
                    } else // itself is a ligature, in which case match.
                    if (cur.ligatureID && !cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                    if (!good) return false;
                    let mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                    if (mark2Index === -1) return false;
                    let markRecord = table.mark1Array[mark1Index];
                    let baseAnchor = table.mark2Array[mark2Index][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, prevIndex);
                    return true;
                }
            case 7:
                return this.applyContext(table);
            case 8:
                return this.applyChainingContext(table);
            case 9:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`Unsupported GPOS table: ${lookupType}`);
        }
    }
    applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        let baseCoords = this.getAnchor(baseAnchor);
        let markCoords = this.getAnchor(markRecord.markAnchor);
        let basePos = this.positions[baseGlyphIndex];
        let markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    }
    getAnchor(anchor) {
        // TODO: contour point, device tables
        let x = anchor.xCoordinate;
        let y = anchor.yCoordinate;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    }
    applyFeatures(userFeatures, glyphs, advances) {
        super.applyFeatures(userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    }
    fixCursiveAttachment(i) {
        let glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            let j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    }
    fixMarkAttachment() {
        for(let i = 0; i < this.glyphs.length; i++){
            let glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                let j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === "ltr") for(let k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(let k1 = j + 1; k1 < i + 1; k1++){
                    this.positions[i].xOffset += this.positions[k1].xAdvance;
                    this.positions[i].yOffset += this.positions[k1].yAdvance;
                }
            }
        }
    }
}
class $b2f26a32cb9ab2fa$export$2e2bcd8739ae039 {
    setup(glyphRun) {
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map((glyph)=>new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, glyph.id, [
                ...glyph.codePoints
            ]));
        // Select a script based on what is available in GSUB/GPOS.
        let script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $fdb4471fc82bc2c2$export$7877a478dd30fd3d(script);
        this.plan = new $d7e93cca3cf8ce8a$export$2e2bcd8739ae039(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
        // Assign chosen features to output glyph run
        for(let key in this.plan.allFeatures)glyphRun.features[key] = true;
    }
    substitute(glyphRun) {
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos);
            // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map((glyphInfo)=>this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
        }
    }
    position(glyphRun) {
        if (this.shaper.zeroMarkWidths === "BEFORE_GPOS") this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === "AFTER_GPOS") this.zeroMarkAdvances(glyphRun.positions);
        // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === "rtl") {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    }
    zeroMarkAdvances(positions) {
        for(let i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GPOSProcessor.features));
        }
        return features;
    }
    constructor(font){
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $86bc1883359e094a$export$2e2bcd8739ae039(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $79ea6270f0a90256$export$2e2bcd8739ae039(font, font.GPOS);
    }
}
class $9d641258c9d7180d$export$2e2bcd8739ae039 {
    layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === "string") {
            direction = language;
            language = script;
            script = features;
            features = [];
        }
        // Map string to glyphs if needed
        if (typeof string === "string") {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $e38a1a895f6aeb54$export$e5cb25e204fb8450(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                let codePoints = [];
                for (let glyph of string)codePoints.push(...glyph.codePoints);
                script = $e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints);
            }
            var glyphs = string;
        }
        let glyphRun = new $b19c79ec7a94fa39$export$2e2bcd8739ae039(glyphs, features, script, language, direction);
        // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        }
        // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
        // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
        // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    }
    substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    }
    position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map((glyph)=>new $9195cf1266c12ea5$export$2e2bcd8739ae039(glyph.advanceWidth));
        let positioned = null;
        // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
        // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $a57a26817cd35108$export$2e2bcd8739ae039(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        }
        // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $4646d52c2a559cdb$export$2e2bcd8739ae039(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    }
    hideDefaultIgnorables(glyphs, positions) {
        let space = this.font.glyphForCodePoint(0x20);
        for(let i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        let plane = ch >> 16;
        if (plane === 0) switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.engine) features.push(...this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf("kern") === -1) features.push("kern");
        return features;
    }
    stringsForGlyph(gid) {
        let result = new Set;
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for (let codePoint of codePoints)result.add(String.fromCodePoint(codePoint));
        if (this.engine && this.engine.stringsForGlyph) for (let string of this.engine.stringsForGlyph(gid))result.add(string);
        return Array.from(result);
    }
    constructor(font){
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null;
        // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $860fcbd64bc12fbc$export$2e2bcd8739ae039(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $b2f26a32cb9ab2fa$export$2e2bcd8739ae039(this.font);
    }
}
const $67ee4828d81adb28$var$SVG_COMMANDS = {
    moveTo: "M",
    lineTo: "L",
    quadraticCurveTo: "Q",
    bezierCurveTo: "C",
    closePath: "Z"
};
class $67ee4828d81adb28$export$2e2bcd8739ae039 {
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ toFunction() {
        return (ctx)=>{
            this.commands.forEach((c)=>{
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    }
    /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ toSVG() {
        let cmds = this.commands.map((c)=>{
            let args = c.args.map((arg)=>Math.round(arg * 100) / 100);
            return `${$67ee4828d81adb28$var$SVG_COMMANDS[c.command]}${args.join(" ")}`;
        });
        return cmds.join("");
    }
    /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ get cbox() {
        if (!this._cbox) {
            let cbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
            for (let command1 of this.commands)for(let i = 0; i < command1.args.length; i += 2)cbox.addPoint(command1.args[i], command1.args[i + 1]);
            this._cbox = Object.freeze(cbox);
        }
        return this._cbox;
    }
    /**
   * Gets the exact bounding box of the path by evaluating curve segments.
   * Slower to compute than the control box, but more accurate.
   * @type {BBox}
   */ get bbox() {
        if (this._bbox) return this._bbox;
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let cx = 0, cy = 0;
        let f = (t)=>Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
        for (let c of this.commands)switch(c.command){
            case "moveTo":
            case "lineTo":
                let [x, y] = c.args;
                bbox.addPoint(x, y);
                cx = x;
                cy = y;
                break;
            case "quadraticCurveTo":
            case "bezierCurveTo":
                if (c.command === "quadraticCurveTo") {
                    // http://fontforge.org/bezier.html
                    var [qp1x, qp1y, p3x, p3y] = c.args;
                    var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                    var cp1y = cy + 2 / 3 * (qp1y - cy);
                    var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                    var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                } else var [cp1x, cp1y, cp2x, cp2y, p3x, p3y] = c.args;
                // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                bbox.addPoint(p3x, p3y);
                var p0 = [
                    cx,
                    cy
                ];
                var p1 = [
                    cp1x,
                    cp1y
                ];
                var p2 = [
                    cp2x,
                    cp2y
                ];
                var p3 = [
                    p3x,
                    p3y
                ];
                for(var i = 0; i <= 1; i++){
                    let b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                    let a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                    c = 3 * p1[i] - 3 * p0[i];
                    if (a === 0) {
                        if (b === 0) continue;
                        let t = -c / b;
                        if (0 < t && t < 1) {
                            if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                            else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                        }
                        continue;
                    }
                    let b2ac = Math.pow(b, 2) - 4 * c * a;
                    if (b2ac < 0) continue;
                    let t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                        if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                    }
                    let t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t2 && t2 < 1) {
                        if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                    }
                }
                cx = p3x;
                cy = p3y;
                break;
        }
        return this._bbox = Object.freeze(bbox);
    }
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ mapPoints(fn) {
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        for (let c of this.commands){
            let args = [];
            for(let i = 0; i < c.args.length; i += 2){
                let [x, y] = fn(c.args[i], c.args[i + 1]);
                args.push(x, y);
            }
            path[c.command](...args);
        }
        return path;
    }
    /**
   * Transforms the path by the given matrix.
   */ transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints((x, y)=>{
            const tx = m0 * x + m2 * y + m4;
            const ty = m1 * x + m3 * y + m5;
            return [
                tx,
                ty
            ];
        });
    }
    /**
   * Translates the path by the given offset.
   */ translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    }
    /**
   * Rotates the path by the given angle (in radians).
   */ rotate(angle) {
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    }
    /**
   * Scales the path.
   */ scale(scaleX, scaleY = scaleX) {
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    }
    constructor(){
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
}
for (let command of [
    "moveTo",
    "lineTo",
    "quadraticCurveTo",
    "bezierCurveTo",
    "closePath"
])$67ee4828d81adb28$export$2e2bcd8739ae039.prototype[command] = function(...args) {
    this._bbox = this._cbox = null;
    this.commands.push({
        command: command,
        args: args
    });
    return this;
};
var $85e16e40023cfb0f$export$2e2bcd8739ae039 = [
    ".notdef",
    ".null",
    "nonmarkingreturn",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quotesingle",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "grave",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "Adieresis",
    "Aring",
    "Ccedilla",
    "Eacute",
    "Ntilde",
    "Odieresis",
    "Udieresis",
    "aacute",
    "agrave",
    "acircumflex",
    "adieresis",
    "atilde",
    "aring",
    "ccedilla",
    "eacute",
    "egrave",
    "ecircumflex",
    "edieresis",
    "iacute",
    "igrave",
    "icircumflex",
    "idieresis",
    "ntilde",
    "oacute",
    "ograve",
    "ocircumflex",
    "odieresis",
    "otilde",
    "uacute",
    "ugrave",
    "ucircumflex",
    "udieresis",
    "dagger",
    "degree",
    "cent",
    "sterling",
    "section",
    "bullet",
    "paragraph",
    "germandbls",
    "registered",
    "copyright",
    "trademark",
    "acute",
    "dieresis",
    "notequal",
    "AE",
    "Oslash",
    "infinity",
    "plusminus",
    "lessequal",
    "greaterequal",
    "yen",
    "mu",
    "partialdiff",
    "summation",
    "product",
    "pi",
    "integral",
    "ordfeminine",
    "ordmasculine",
    "Omega",
    "ae",
    "oslash",
    "questiondown",
    "exclamdown",
    "logicalnot",
    "radical",
    "florin",
    "approxequal",
    "Delta",
    "guillemotleft",
    "guillemotright",
    "ellipsis",
    "nonbreakingspace",
    "Agrave",
    "Atilde",
    "Otilde",
    "OE",
    "oe",
    "endash",
    "emdash",
    "quotedblleft",
    "quotedblright",
    "quoteleft",
    "quoteright",
    "divide",
    "lozenge",
    "ydieresis",
    "Ydieresis",
    "fraction",
    "currency",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "daggerdbl",
    "periodcentered",
    "quotesinglbase",
    "quotedblbase",
    "perthousand",
    "Acircumflex",
    "Ecircumflex",
    "Aacute",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Oacute",
    "Ocircumflex",
    "apple",
    "Ograve",
    "Uacute",
    "Ucircumflex",
    "Ugrave",
    "dotlessi",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "Lslash",
    "lslash",
    "Scaron",
    "scaron",
    "Zcaron",
    "zcaron",
    "brokenbar",
    "Eth",
    "eth",
    "Yacute",
    "yacute",
    "Thorn",
    "thorn",
    "minus",
    "multiply",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "onehalf",
    "onequarter",
    "threequarters",
    "franc",
    "Gbreve",
    "gbreve",
    "Idotaccent",
    "Scedilla",
    "scedilla",
    "Cacute",
    "cacute",
    "Ccaron",
    "ccaron",
    "dcroat"
];
class $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getPath() {
        return new $67ee4828d81adb28$export$2e2bcd8739ae039();
    }
    _getCBox() {
        return this.path.cbox;
    }
    _getBBox() {
        return this.path.bbox;
    }
    _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        let metric = table.metrics.get(table.metrics.length - 1);
        let res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    }
    _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        let { advance: advanceWidth, bearing: leftBearing } = this._getTableMetrics(this._font.hmtx);
        // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var { advance: advanceHeight, bearing: topBearing } = this._getTableMetrics(this._font.vmtx);
        else {
            let os2;
            if (typeof cbox === "undefined" || cbox === null) ({ cbox: cbox } = this);
            if ((os2 = this._font["OS/2"]) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                let { hhea: hhea } = this._font;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    }
    /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ get cbox() {
        return this._getCBox();
    }
    /**
   * The glyph’s bounding box, i.e. the rectangle that encloses the
   * glyph outline as tightly as possible.
   * @type {BBox}
   */ get bbox() {
        return this._getBBox();
    }
    /**
   * A vector Path object representing the glyph outline.
   * @type {Path}
   */ get path() {
        // Cache the path so we only decode it once
        // Decoding is actually performed by subclasses
        return this._getPath();
    }
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ getScaledPath(size) {
        let scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    }
    /**
   * The glyph's advance width.
   * @type {number}
   */ get advanceWidth() {
        return this._getMetrics().advanceWidth;
    }
    /**
   * The glyph's advance height.
   * @type {number}
   */ get advanceHeight() {
        return this._getMetrics().advanceHeight;
    }
    get ligatureCaretPositions() {}
    _getName() {
        let { post: post } = this._font;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $85e16e40023cfb0f$export$2e2bcd8739ae039[this.id];
            case 2:
                let id = post.glyphNameIndex[this.id];
                if (id < $85e16e40023cfb0f$export$2e2bcd8739ae039.length) return $85e16e40023cfb0f$export$2e2bcd8739ae039[id];
                return post.names[id - $85e16e40023cfb0f$export$2e2bcd8739ae039.length];
            case 2.5:
                return $85e16e40023cfb0f$export$2e2bcd8739ae039[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    }
    /**
   * The glyph's name
   * @type {string}
   */ get name() {
        return this._getName();
    }
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ render(ctx, size) {
        ctx.save();
        let scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        let fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    }
    constructor(id, codePoints, font){
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font;
        // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every($gfJaN$unicodeproperties.isMark);
        this.isLigature = this.codePoints.length > 1;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "cbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "bbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "path", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "name", null);
// The header for both simple and composite glyphs
let $f680320fa07ef53d$var$GlyfHeader = new $gfJaN$restructure.Struct({
    numberOfContours: $gfJaN$restructure.int16,
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16
});
// Flags for simple glyphs
const $f680320fa07ef53d$var$ON_CURVE = 1;
const $f680320fa07ef53d$var$X_SHORT_VECTOR = 2;
const $f680320fa07ef53d$var$Y_SHORT_VECTOR = 4;
const $f680320fa07ef53d$var$REPEAT = 8;
const $f680320fa07ef53d$var$SAME_X = 16;
const $f680320fa07ef53d$var$SAME_Y = 32;
// Flags for composite glyphs
const $f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS = 1;
const $f680320fa07ef53d$var$ARGS_ARE_XY_VALUES = 2;
const $f680320fa07ef53d$var$ROUND_XY_TO_GRID = 4;
const $f680320fa07ef53d$var$WE_HAVE_A_SCALE = 8;
const $f680320fa07ef53d$var$MORE_COMPONENTS = 32;
const $f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
const $f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO = 128;
const $f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS = 256;
const $f680320fa07ef53d$var$USE_MY_METRICS = 512;
const $f680320fa07ef53d$var$OVERLAP_COMPOUND = 1024;
const $f680320fa07ef53d$var$SCALED_COMPONENT_OFFSET = 2048;
const $f680320fa07ef53d$var$UNSCALED_COMPONENT_OFFSET = 4096;
class $f680320fa07ef53d$export$baf26146a414f24a {
    copy() {
        return new $f680320fa07ef53d$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
    }
    constructor(onCurve, endContour, x = 0, y = 0){
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
}
// Represents a component in a composite glyph
class $f680320fa07ef53d$var$Component {
    constructor(glyphID, dx, dy){
        this.glyphID = glyphID;
        this.dx = dx;
        this.dy = dy;
        this.pos = 0;
        this.scaleX = this.scaleY = 1;
        this.scale01 = this.scale10 = 0;
    }
}
class $f680320fa07ef53d$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    // Parses just the glyph header and returns the bounding box
    _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        let stream = this._font._getTableStream("glyf");
        stream.pos += this._font.loca.offsets[this.id];
        let glyph = $f680320fa07ef53d$var$GlyfHeader.decode(stream);
        let cbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    }
    // Parses a single glyph coordinate
    _parseGlyphCoord(stream, prev, short, same) {
        if (short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    }
    // Decodes the glyph data into points for simple glyphs,
    // or components for composite glyphs
    _decode() {
        let glyfPos = this._font.loca.offsets[this.id];
        let nextPos = this._font.loca.offsets[this.id + 1];
        // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        let stream = this._font._getTableStream("glyf");
        stream.pos += glyfPos;
        let startPos = stream.pos;
        let glyph = $f680320fa07ef53d$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    }
    _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        let endPtsOfContours = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16).decode(stream);
        let flags = [];
        let numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag);
            // check for repeat flag
            if (flag & $f680320fa07ef53d$var$REPEAT) {
                let count = stream.readUInt8();
                for(let j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            let point = new $f680320fa07ef53d$export$baf26146a414f24a(!!(flag & $f680320fa07ef53d$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        let px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $f680320fa07ef53d$var$X_SHORT_VECTOR, flag & $f680320fa07ef53d$var$SAME_X);
        }
        let py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $f680320fa07ef53d$var$Y_SHORT_VECTOR, flag & $f680320fa07ef53d$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            let points = glyph.points.slice();
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    }
    _decodeComposite(glyph, stream, offset = 0) {
        // this is a composite glyph
        glyph.components = [];
        let haveInstructions = false;
        let flags = $f680320fa07ef53d$var$MORE_COMPONENTS;
        while(flags & $f680320fa07ef53d$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            let gPos = stream.pos - offset;
            let glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $f680320fa07ef53d$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $f680320fa07ef53d$var$WE_HAVE_A_SCALE) component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            let points = [];
            for(let j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $f680320fa07ef53d$export$baf26146a414f24a(true, true, component.dx, component.dy));
            }
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(let i = 0; i < points.length; i++){
                let point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    }
    _getPhantomPoints(glyph) {
        let cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype._getMetrics.call(this, cbox);
        let { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing } = this._metrics;
        return [
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing, 0),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    }
    // Decodes font data, resolves composite glyphs, and returns an array of contours
    _getContours() {
        let glyph = this._decode();
        if (!glyph) return [];
        let points = [];
        if (glyph.numberOfContours < 0) for (let component of glyph.components){
            let contours = this._font.getGlyph(component.glyphID)._getContours();
            for(let i = 0; i < contours.length; i++){
                let contour = contours[i];
                for(let j = 0; j < contour.length; j++){
                    let point = contour[j];
                    let x = point.x * component.scaleX + point.y * component.scale01 + component.dx;
                    let y = point.y * component.scaleY + point.x * component.scale10 + component.dy;
                    points.push(new $f680320fa07ef53d$export$baf26146a414f24a(point.onCurve, point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
        // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        let contours = [];
        let cur = [];
        for(let k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    }
    _getMetrics() {
        if (this._metrics) return this._metrics;
        let cbox = this._getCBox(true);
        super._getMetrics(cbox);
        if (this._font._variationProcessor && !this._font.HVAR) this.path;
        return this._metrics;
    }
    // Converts contours to a Path object that can be rendered
    _getPath() {
        let contours = this._getContours();
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        for(let i = 0; i < contours.length; i++){
            let contour = contours[i];
            let firstPt = contour[0];
            let lastPt = contour[contour.length - 1];
            let start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) firstPt = lastPt;
                else firstPt = new $f680320fa07ef53d$export$baf26146a414f24a(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(let j = start; j < contour.length; j++){
                let pt = contour[j];
                let prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    let midX = (prevPt.x + pt.x) / 2;
                    let midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            }
            // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTF");
    }
}
class $7ee0705195f3b047$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getName() {
        if (this._font.CFF2) return super._getName();
        return this._font["CFF "].getGlyphName(this.id);
    }
    bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    }
    _getPath() {
        let cff = this._font.CFF2 || this._font["CFF "];
        let { stream: stream } = cff;
        let str = cff.topDict.CharStrings[this.id];
        let end = str.offset + str.length;
        stream.pos = str.offset;
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        let stack = [];
        let trans = [];
        let width = null;
        let nStems = 0;
        let x1 = 0, y1 = 0;
        let usedGsubrs;
        let usedSubrs;
        let open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        let gsubrs = cff.globalSubrIndex || [];
        let gsubrsBias = this.bias(gsubrs);
        let privateDict = cff.privateDictForGlyph(this.id) || {};
        let subrs = privateDict.Subrs || [];
        let subrsBias = this.bias(subrs);
        let vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        let vsindex = privateDict.vsindex;
        let variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        let parse = function() {
            while(stream.pos < end){
                let op = stream.readUInt8();
                if (op < 32) {
                    let index, subr, phase;
                    switch(op){
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                            parseStems();
                            break;
                        case 4:
                            if (stack.length > 1) checkWidth();
                            y1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 5:
                            while(stack.length >= 2){
                                x1 += stack.shift();
                                y1 += stack.shift();
                                path.lineTo(x1, y1);
                            }
                            break;
                        case 6:
                        case 7:
                            phase = op === 6;
                            while(stack.length >= 1){
                                if (phase) x1 += stack.shift();
                                else y1 += stack.shift();
                                path.lineTo(x1, y1);
                                phase = !phase;
                            }
                            break;
                        case 8:
                            while(stack.length > 0){
                                var c1x = x1 + stack.shift();
                                var c1y = y1 + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 10:
                            index = stack.pop() + subrsBias;
                            subr = subrs[index];
                            if (subr) {
                                usedSubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 11:
                            if (cff.version >= 2) break;
                            return;
                        case 14:
                            if (cff.version >= 2) break;
                            if (stack.length > 0) checkWidth();
                            if (open) {
                                path.closePath();
                                open = false;
                            }
                            break;
                        case 15:
                            if (cff.version < 2) throw new Error("vsindex operator not supported in CFF v1");
                            vsindex = stack.pop();
                            break;
                        case 16:
                            {
                                if (cff.version < 2) throw new Error("blend operator not supported in CFF v1");
                                if (!variationProcessor) throw new Error("blend operator in non-variation font");
                                let blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                let numBlends = stack.pop();
                                let numOperands = numBlends * blendVector.length;
                                let delta = stack.length - numOperands;
                                let base = delta - numBlends;
                                for(let i = 0; i < numBlends; i++){
                                    let sum = stack[base + i];
                                    for(let j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                    stack[base + i] = sum;
                                }
                                while(numOperands--)stack.pop();
                                break;
                            }
                        case 19:
                        case 20:
                            parseStems();
                            stream.pos += nStems + 7 >> 3;
                            break;
                        case 21:
                            if (stack.length > 2) checkWidth();
                            x1 += stack.shift();
                            y1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 22:
                            if (stack.length > 1) checkWidth();
                            x1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 24:
                            while(stack.length >= 8){
                                var c1x = x1 + stack.shift();
                                var c1y = y1 + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            x1 += stack.shift();
                            y1 += stack.shift();
                            path.lineTo(x1, y1);
                            break;
                        case 25:
                            while(stack.length >= 8){
                                x1 += stack.shift();
                                y1 += stack.shift();
                                path.lineTo(x1, y1);
                            }
                            var c1x = x1 + stack.shift();
                            var c1y = y1 + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x1 = c2x + stack.shift();
                            y1 = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            break;
                        case 26:
                            if (stack.length % 2) x1 += stack.shift();
                            while(stack.length >= 4){
                                c1x = x1;
                                c1y = y1 + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x1 = c2x;
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 27:
                            if (stack.length % 2) y1 += stack.shift();
                            while(stack.length >= 4){
                                c1x = x1 + stack.shift();
                                c1y = y1;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 28:
                            stack.push(stream.readInt16BE());
                            break;
                        case 29:
                            index = stack.pop() + gsubrsBias;
                            subr = gsubrs[index];
                            if (subr) {
                                usedGsubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 30:
                        case 31:
                            phase = op === 31;
                            while(stack.length >= 4){
                                if (phase) {
                                    c1x = x1 + stack.shift();
                                    c1y = y1;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    y1 = c2y + stack.shift();
                                    x1 = c2x + (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                    c1x = x1;
                                    c1y = y1 + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    x1 = c2x + stack.shift();
                                    y1 = c2y + (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                                phase = !phase;
                            }
                            break;
                        case 12:
                            op = stream.readUInt8();
                            switch(op){
                                case 3:
                                    let a = stack.pop();
                                    let b = stack.pop();
                                    stack.push(a && b ? 1 : 0);
                                    break;
                                case 4:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a || b ? 1 : 0);
                                    break;
                                case 5:
                                    a = stack.pop();
                                    stack.push(a ? 0 : 1);
                                    break;
                                case 9:
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case 10:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case 11:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case 12:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case 14:
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case 15:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a === b ? 1 : 0);
                                    break;
                                case 18:
                                    stack.pop();
                                    break;
                                case 20:
                                    let val = stack.pop();
                                    let idx = stack.pop();
                                    trans[idx] = val;
                                    break;
                                case 21:
                                    idx = stack.pop();
                                    stack.push(trans[idx] || 0);
                                    break;
                                case 22:
                                    let s1 = stack.pop();
                                    let s2 = stack.pop();
                                    let v1 = stack.pop();
                                    let v2 = stack.pop();
                                    stack.push(v1 <= v2 ? s1 : s2);
                                    break;
                                case 23:
                                    stack.push(Math.random());
                                    break;
                                case 24:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case 26:
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case 27:
                                    a = stack.pop();
                                    stack.push(a, a);
                                    break;
                                case 28:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(b, a);
                                    break;
                                case 29:
                                    idx = stack.pop();
                                    if (idx < 0) idx = 0;
                                    else if (idx > stack.length - 1) idx = stack.length - 1;
                                    stack.push(stack[idx]);
                                    break;
                                case 30:
                                    let n = stack.pop();
                                    let j = stack.pop();
                                    if (j >= 0) while(j > 0){
                                        var t = stack[n - 1];
                                        for(let i = n - 2; i >= 0; i--)stack[i + 1] = stack[i];
                                        stack[0] = t;
                                        j--;
                                    }
                                    else while(j < 0){
                                        var t = stack[0];
                                        for(let i = 0; i <= n; i++)stack[i] = stack[i + 1];
                                        stack[n - 1] = t;
                                        j++;
                                    }
                                    break;
                                case 34:
                                    c1x = x1 + stack.shift();
                                    c1y = y1;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    let c3x = c2x + stack.shift();
                                    let c3y = c2y;
                                    let c4x = c3x + stack.shift();
                                    let c4y = c3y;
                                    let c5x = c4x + stack.shift();
                                    let c5y = c4y;
                                    let c6x = c5x + stack.shift();
                                    let c6y = c5y;
                                    x1 = c6x;
                                    y1 = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 35:
                                    let pts = [];
                                    for(let i = 0; i <= 5; i++){
                                        x1 += stack.shift();
                                        y1 += stack.shift();
                                        pts.push(x1, y1);
                                    }
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    stack.shift(); // fd
                                    break;
                                case 36:
                                    c1x = x1 + stack.shift();
                                    c1y = y1 + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y + stack.shift();
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x1 = c6x;
                                    y1 = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 37:
                                    let startx = x1;
                                    let starty = y1;
                                    pts = [];
                                    for(let i1 = 0; i1 <= 4; i1++){
                                        x1 += stack.shift();
                                        y1 += stack.shift();
                                        pts.push(x1, y1);
                                    }
                                    if (Math.abs(x1 - startx) > Math.abs(y1 - starty)) {
                                        x1 += stack.shift();
                                        y1 = starty;
                                    } else {
                                        x1 = startx;
                                        y1 += stack.shift();
                                    }
                                    pts.push(x1, y1);
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    break;
                                default:
                                    throw new Error(`Unknown op: 12 ${op}`);
                            }
                            break;
                        default:
                            throw new Error(`Unknown op: ${op}`);
                    }
                } else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "CFF");
    }
}
let $55855d6d316b015e$var$SBIXImage = new $gfJaN$restructure.Struct({
    originX: $gfJaN$restructure.uint16,
    originY: $gfJaN$restructure.uint16,
    type: new $gfJaN$restructure.String(4),
    data: new $gfJaN$restructure.Buffer((t)=>t.parent.buflen - t._currentOffset)
});
class $55855d6d316b015e$export$2e2bcd8739ae039 extends $f680320fa07ef53d$export$2e2bcd8739ae039 {
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ getImageForSize(size) {
        for(let i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        let offsets = table.imageOffsets;
        let start = offsets[this.id];
        let end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $55855d6d316b015e$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    }
    render(ctx, size) {
        let img = this.getImageForSize(size);
        if (img != null) {
            let scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) super.render(ctx, size);
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "SBIX");
    }
}
class $42d9dbd2de9ee2d8$var$COLRLayer {
    constructor(glyph, color){
        this.glyph = glyph;
        this.color = color;
    }
}
class $42d9dbd2de9ee2d8$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getBBox() {
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        for(let i = 0; i < this.layers.length; i++){
            let layer = this.layers[i];
            let b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    }
    /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ get layers() {
        let cpal = this._font.CPAL;
        let colr = this._font.COLR;
        let low = 0;
        let high = colr.baseGlyphRecord.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            var rec = colr.baseGlyphRecord[mid];
            if (this.id < rec.gid) high = mid - 1;
            else if (this.id > rec.gid) low = mid + 1;
            else {
                var baseLayer = rec;
                break;
            }
        }
        // if base glyph not found in COLR table,
        // default to normal glyph from glyf or CFF
        if (baseLayer == null) {
            var g = this._font._getBaseGlyph(this.id);
            var color = {
                red: 0,
                green: 0,
                blue: 0,
                alpha: 255
            };
            return [
                new $42d9dbd2de9ee2d8$var$COLRLayer(g, color)
            ];
        }
        // otherwise, return an array of all the layers
        let layers = [];
        for(let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
            var rec = colr.layerRecords[i];
            var color = cpal.colorRecords[rec.paletteIndex];
            var g = this._font._getBaseGlyph(rec.gid);
            layers.push(new $42d9dbd2de9ee2d8$var$COLRLayer(g, color));
        }
        return layers;
    }
    render(ctx, size) {
        for (let { glyph: glyph, color: color } of this.layers){
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "COLR");
    }
}
const $7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
const $7586bb9ea67c41d8$var$TUPLE_COUNT_MASK = 0x0fff;
const $7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD = 0x8000;
const $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE = 0x4000;
const $7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS = 0x2000;
const $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK = 0x0fff;
const $7586bb9ea67c41d8$var$POINTS_ARE_WORDS = 0x80;
const $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK = 0x7f;
const $7586bb9ea67c41d8$var$DELTAS_ARE_ZERO = 0x80;
const $7586bb9ea67c41d8$var$DELTAS_ARE_WORDS = 0x40;
const $7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK = 0x3f;
class $7586bb9ea67c41d8$export$2e2bcd8739ae039 {
    normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        let normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            let axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        }
        // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            let segment = this.font.avar.segment[i];
            for(let j = 0; j < segment.correspondence.length; j++){
                let pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    let prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    }
    transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        let { gvar: gvar } = this.font;
        if (gid >= gvar.glyphCount) return;
        let offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
        // Read the gvar data for this glyph
        let { stream: stream } = this.font;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        let tupleCount = stream.readUInt16BE();
        let offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        let origPoints = glyphPoints.map((pt)=>pt.copy());
        tupleCount &= $7586bb9ea67c41d8$var$TUPLE_COUNT_MASK;
        for(let i = 0; i < tupleCount; i++){
            let tupleDataSize = stream.readUInt16BE();
            let tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error("Invalid gvar table");
                var tupleCoords = gvar.globalCoords[tupleIndex & $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(let a1 = 0; a1 < gvar.axisCount; a1++)endCoords.push(stream.readInt16BE() / 16384);
            }
            // Get the factor at which to apply this tuple
            let factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
            // points.length = 0 means there are deltas for all points
            let nPoints = points.length === 0 ? glyphPoints.length : points.length;
            let xDeltas = this.decodeDeltas(nPoints);
            let yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) for(let i = 0; i < glyphPoints.length; i++){
                var point = glyphPoints[i];
                point.x += Math.round(xDeltas[i] * factor);
                point.y += Math.round(yDeltas[i] * factor);
            }
            else {
                let outPoints = origPoints.map((pt)=>pt.copy());
                let hasDelta = glyphPoints.map(()=>false);
                for(let i = 0; i < points.length; i++){
                    let idx = points[i];
                    if (idx < glyphPoints.length) {
                        let point = outPoints[idx];
                        hasDelta[idx] = true;
                        point.x += Math.round(xDeltas[i] * factor);
                        point.y += Math.round(yDeltas[i] * factor);
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(let i1 = 0; i1 < glyphPoints.length; i1++){
                    let deltaX = outPoints[i1].x - origPoints[i1].x;
                    let deltaY = outPoints[i1].y - origPoints[i1].y;
                    glyphPoints[i1].x += deltaX;
                    glyphPoints[i1].y += deltaY;
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    }
    decodePoints() {
        let stream = this.font.stream;
        let count = stream.readUInt8();
        if (count & $7586bb9ea67c41d8$var$POINTS_ARE_WORDS) count = (count & $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        let points = new Uint16Array(count);
        let i = 0;
        let point = 0;
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) + 1;
            let fn = run & $7586bb9ea67c41d8$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(let j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    }
    decodeDeltas(count) {
        let stream = this.font.stream;
        let i = 0;
        let deltas = new Int16Array(count);
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $7586bb9ea67c41d8$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                let fn = run & $7586bb9ea67c41d8$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(let j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    }
    tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        let normalized = this.normalizedCoords;
        let { gvar: gvar } = this.font;
        let factor = 1;
        for(let i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    }
    // Interpolates points without delta values.
    // Needed for the Ø and Q glyphs in Skia.
    // Algorithm from Freetype.
    interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        let point = 0;
        while(point < points.length){
            let firstPoint = point;
            // find the end point of the contour
            let endPoint = point;
            let pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
            // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            let firstDelta = point;
            let curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            }
            // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    }
    deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        let iterable = [
            "x",
            "y"
        ];
        for(let i = 0; i < iterable.length; i++){
            let k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            let in1 = inPoints[ref1][k];
            let in2 = inPoints[ref2][k];
            let out1 = outPoints[ref1][k];
            let out2 = outPoints[ref2][k];
            // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                let scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(let p = p1; p <= p2; p++){
                    let out = inPoints[p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[p][k] = out;
                }
            }
        }
    }
    deltaShift(p1, p2, ref, inPoints, outPoints) {
        let deltaX = outPoints[ref].x - inPoints[ref].x;
        let deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(let p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    }
    getAdvanceAdjustment(gid, table) {
        let outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            let idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            let entryFormat = table.advanceWidthMapping.entryFormat;
            ({ outerIndex: outerIndex, innerIndex: innerIndex } = table.advanceWidthMapping.mapData[idx]);
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    }
    // See pseudo code from `Font Variations Overview'
    // in the OpenType specification.
    getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        let varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        let deltaSet = varData.deltaSets[innerIndex];
        let blendVector = this.getBlendVector(itemStore, outerIndex);
        let netAdjustment = 0;
        for(let master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    }
    getBlendVector(itemStore, outerIndex) {
        let varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        let normalizedCoords = this.normalizedCoords;
        let blendVector = [];
        // outer loop steps through master designs to be blended
        for(let master = 0; master < varData.regionIndexCount; master++){
            let scalar = 1;
            let regionIndex = varData.regionIndexes[master];
            let axes = itemStore.variationRegionList.variationRegions[regionIndex];
            // inner loop steps through axes in this region
            for(let j = 0; j < axes.length; j++){
                let axis = axes[j];
                let axisScalar;
                // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
                else if (axis.peakCoord === 0) axisScalar = 1;
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                }
                // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    }
    constructor(font, coords){
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map;
    }
}
const $a8ac370803cb82cf$var$resolved = Promise.resolve();
class $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    includeGlyph(glyph) {
        if (typeof glyph === "object") glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    }
    constructor(font){
        this.font = font;
        this.glyphs = [];
        this.mapping = {};
        // always include the missing glyph
        this.includeGlyph(0);
    }
}
// Flags for simple glyphs
const $2784eedf0b35a048$var$ON_CURVE = 1;
const $2784eedf0b35a048$var$X_SHORT_VECTOR = 2;
const $2784eedf0b35a048$var$Y_SHORT_VECTOR = 4;
const $2784eedf0b35a048$var$REPEAT = 8;
const $2784eedf0b35a048$var$SAME_X = 16;
const $2784eedf0b35a048$var$SAME_Y = 32;
class $2784eedf0b35a048$var$Point {
    static size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    }
    static encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    }
}
let $2784eedf0b35a048$var$Glyf = new $gfJaN$restructure.Struct({
    numberOfContours: $gfJaN$restructure.int16,
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16,
    endPtsOfContours: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numberOfContours"),
    instructions: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16),
    flags: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, 0),
    xPoints: new $gfJaN$restructure.Array($2784eedf0b35a048$var$Point, 0),
    yPoints: new $gfJaN$restructure.Array($2784eedf0b35a048$var$Point, 0)
});
class $2784eedf0b35a048$export$2e2bcd8739ae039 {
    encodeSimple(path, instructions = []) {
        let endPtsOfContours = [];
        let xPoints = [];
        let yPoints = [];
        let flags = [];
        let same = 0;
        let lastX = 0, lastY = 0, lastFlag = 0;
        let pointCount = 0;
        for(let i = 0; i < path.commands.length; i++){
            let c = path.commands[i];
            for(let j = 0; j < c.args.length; j += 2){
                let x = c.args[j];
                let y = c.args[j + 1];
                let flag = 0;
                // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === "quadraticCurveTo" && j === 2) {
                    let next = path.commands[i + 1];
                    if (next && next.command === "quadraticCurveTo") {
                        let midX = (lastX + next.args[0]) / 2;
                        let midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                }
                // All points except control points are on curve.
                if (!(c.command === "quadraticCurveTo" && j === 0)) flag |= $2784eedf0b35a048$var$ON_CURVE;
                flag = this._encodePoint(x, lastX, xPoints, flag, $2784eedf0b35a048$var$X_SHORT_VECTOR, $2784eedf0b35a048$var$SAME_X);
                flag = this._encodePoint(y, lastY, yPoints, flag, $2784eedf0b35a048$var$Y_SHORT_VECTOR, $2784eedf0b35a048$var$SAME_Y);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $2784eedf0b35a048$var$REPEAT;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === "closePath") endPtsOfContours.push(pointCount - 1);
        }
        // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== "closePath") endPtsOfContours.push(pointCount - 1);
        let bbox = path.bbox;
        let glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        let size = $2784eedf0b35a048$var$Glyf.size(glyf);
        let tail = 4 - size % 4;
        let stream = new $gfJaN$restructure.EncodeStream(size + tail);
        $2784eedf0b35a048$var$Glyf.encode(stream, glyf);
        // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    }
    _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        let diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    }
}
class $fe042f4b88f46896$export$2e2bcd8739ae039 extends $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    _addGlyph(gid) {
        let glyph = this.font.getGlyph(gid);
        let glyf = glyph._decode();
        // get the offset to the glyph from the loca table
        let curOffset = this.font.loca.offsets[gid];
        let nextOffset = this.font.loca.offsets[gid + 1];
        let stream = this.font._getTableStream("glyf");
        stream.pos += curOffset;
        let buffer = stream.readBuffer(nextOffset - curOffset);
        // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new Uint8Array(buffer);
            let view = new DataView(buffer.buffer);
            for (let component of glyf.components){
                gid = this.includeGlyph(component.glyphID);
                view.setUint16(component.pos, gid);
            }
        } else if (glyf && this.font._variationProcessor) buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    }
    encode() {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: [],
            version: this.font.loca.version
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        };
        // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        let i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        let maxp = $parcel$interopDefault($gfJaN$clone)(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        let head = $parcel$interopDefault($gfJaN$clone)(this.font.head);
        head.indexToLocFormat = this.loca.version;
        let hhea = $parcel$interopDefault($gfJaN$clone)(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length;
        // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        return $df50e1efe10a1247$export$2e2bcd8739ae039.toBuffer({
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                "cvt ": this.font["cvt "],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm
            }
        });
    }
    constructor(font){
        super(font);
        this.glyphEncoder = new $2784eedf0b35a048$export$2e2bcd8739ae039;
    }
}
class $ec40f80c07a4e08a$export$2e2bcd8739ae039 extends $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    subsetCharstrings() {
        this.charstrings = [];
        let gsubrs = {};
        for (let gid of this.glyphs){
            this.charstrings.push(this.cff.getCharString(gid));
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    }
    subsetSubrs(subrs, used) {
        let res = [];
        for(let i = 0; i < subrs.length; i++){
            let subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new Uint8Array([
                11
            ])); // return
        }
        return res;
    }
    subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        let used_fds = {};
        let used_subrs = [];
        let fd_select = {};
        for (let gid of this.glyphs){
            let fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
                fd_select[fd] = topDict.FDArray.length - 1;
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(fd_select[fd]);
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
        }
        for(let i = 0; i < topDict.FDArray.length; i++){
            let dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    }
    createCIDFontdict(topDict) {
        let used_subrs = {};
        for (let gid of this.glyphs){
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        let privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    }
    addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $860d3574d7fa3a51$export$2e2bcd8739ae039.length + this.strings.length - 1;
    }
    encode() {
        this.subsetCharstrings();
        let charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        let topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for (let key of [
            "version",
            "Notice",
            "Copyright",
            "FullName",
            "FamilyName",
            "Weight",
            "PostScript",
            "BaseFontName",
            "FontName"
        ])topDict[key] = this.addString(this.cff.string(topDict[key]));
        topDict.ROS = [
            this.addString("Adobe"),
            this.addString("Identity"),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        let top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: 4,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        return $5b547cf9e5da519b$export$2e2bcd8739ae039.toBuffer(top);
    }
    constructor(font){
        super(font);
        this.cff = this.font["CFF "];
        if (!this.cff) throw new Error("Not a CFF Font");
    }
}
class $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let format = $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4));
        return format === "true" || format === "OTTO" || format === String.fromCharCode(0, 1, 0, 0);
    }
    setDefaultLanguage(lang = null) {
        this.defaultLanguage = lang;
    }
    _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($59aa4ed98453e1d4$export$bd5c5d8b8dcafd78) {
                console.error(`Error decoding table ${table.tag}`);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    }
    _decodeDirectory() {
        return this.directory = $df50e1efe10a1247$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _decodeTable(table) {
        let pos = this.stream.pos;
        let stream = this._getTableStream(table.tag);
        let result = $5825c04ce8f7102d$export$2e2bcd8739ae039[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    }
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ getName(key, lang = this.defaultLanguage || $59aa4ed98453e1d4$export$42940898df819940) {
        let record = this.name && this.name.records[key];
        if (record) return record[lang] || record[this.defaultLanguage] || record[$59aa4ed98453e1d4$export$42940898df819940] || record["en"] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
         || null;
        return null;
    }
    /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ get postscriptName() {
        return this.getName("postscriptName");
    }
    /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */ get fullName() {
        return this.getName("fullName");
    }
    /**
   * The font's family name, e.g. "Helvetica"
   * @type {string}
   */ get familyName() {
        return this.getName("fontFamily");
    }
    /**
   * The font's sub-family, e.g. "Bold".
   * @type {string}
   */ get subfamilyName() {
        return this.getName("fontSubfamily");
    }
    /**
   * The font's copyright information
   * @type {string}
   */ get copyright() {
        return this.getName("copyright");
    }
    /**
   * The font's version number
   * @type {string}
   */ get version() {
        return this.getName("version");
    }
    /**
   * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
   * @type {number}
   */ get ascent() {
        return this.hhea.ascent;
    }
    /**
   * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
   * @type {number}
   */ get descent() {
        return this.hhea.descent;
    }
    /**
   * The amount of space that should be included between lines
   * @type {number}
   */ get lineGap() {
        return this.hhea.lineGap;
    }
    /**
   * The offset from the normal underline position that should be used
   * @type {number}
   */ get underlinePosition() {
        return this.post.underlinePosition;
    }
    /**
   * The weight of the underline that should be used
   * @type {number}
   */ get underlineThickness() {
        return this.post.underlineThickness;
    }
    /**
   * If this is an italic font, the angle the cursor should be drawn at to match the font design
   * @type {number}
   */ get italicAngle() {
        return this.post.italicAngle;
    }
    /**
   * The height of capital letters above the baseline.
   * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
   * @type {number}
   */ get capHeight() {
        let os2 = this["OS/2"];
        return os2 ? os2.capHeight : this.ascent;
    }
    /**
   * The height of lower case letters in the font.
   * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
   * @type {number}
   */ get xHeight() {
        let os2 = this["OS/2"];
        return os2 ? os2.xHeight : 0;
    }
    /**
   * The number of glyphs in the font.
   * @type {number}
   */ get numGlyphs() {
        return this.maxp.numGlyphs;
    }
    /**
   * The size of the font’s internal coordinate grid
   * @type {number}
   */ get unitsPerEm() {
        return this.head.unitsPerEm;
    }
    /**
   * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
   * @type {BBox}
   */ get bbox() {
        return Object.freeze(new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
    }
    get _cmapProcessor() {
        return new $0d6e160064c86e50$export$2e2bcd8739ae039(this.cmap);
    }
    /**
   * An array of all of the unicode code points supported by the font.
   * @type {number[]}
   */ get characterSet() {
        return this._cmapProcessor.getCharacterSet();
    }
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    }
    /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    }
    /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ glyphsForString(string) {
        let glyphs = [];
        let len = string.length;
        let idx = 0;
        let last = -1;
        let state = -1;
        while(idx <= len){
            let code = 0;
            let nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    let next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    }
    get _layoutEngine() {
        return new $9d641258c9d7180d$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    }
    /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    }
    /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ get availableFeatures() {
        return this._layoutEngine.getAvailableFeatures();
    }
    getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    }
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $f680320fa07ef53d$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables["CFF "] || this.directory.tables.CFF2) this._glyphs[glyph] = new $7ee0705195f3b047$export$2e2bcd8739ae039(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ getGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $55855d6d316b015e$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $42d9dbd2de9ee2d8$export$2e2bcd8739ae039(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ createSubset() {
        if (this.directory.tables["CFF "]) return new $ec40f80c07a4e08a$export$2e2bcd8739ae039(this);
        return new $fe042f4b88f46896$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ get variationAxes() {
        let res = {};
        if (!this.fvar) return res;
        for (let axis of this.fvar.axis)res[axis.axisTag.trim()] = {
            name: axis.name.en,
            min: axis.minValue,
            default: axis.defaultValue,
            max: axis.maxValue
        };
        return res;
    }
    /**
   * Returns an object describing the named variation instances
   * that the font designer has specified. Keys are variation names
   * and values are the variation settings for this instance.
   *
   * @type {object}
   */ get namedVariations() {
        let res = {};
        if (!this.fvar) return res;
        for (let instance of this.fvar.instance){
            let settings = {};
            for(let i = 0; i < this.fvar.axis.length; i++){
                let axis = this.fvar.axis[i];
                settings[axis.axisTag.trim()] = instance.coord[i];
            }
            res[instance.name.en] = settings;
        }
        return res;
    }
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
        if (typeof settings === "string") settings = this.namedVariations[settings];
        if (typeof settings !== "object") throw new Error("Variation settings must be either a variation name or settings object.");
        // normalize the coordinates
        let coords = this.fvar.axis.map((axis, i)=>{
            let axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream, coords);
        font._tables = this._tables;
        return font;
    }
    get _variationProcessor() {
        if (!this.fvar) return null;
        let variationCoords = this.variationCoords;
        // Ignore if no variation coords and not CFF2
        if (!variationCoords && !this.CFF2) return null;
        if (!variationCoords) variationCoords = this.fvar.axis.map((axis)=>axis.defaultValue);
        return new $7586bb9ea67c41d8$export$2e2bcd8739ae039(this, variationCoords);
    }
    // Standardized format plugin API
    getFont(name) {
        return this.getVariation(name);
    }
    constructor(stream, variationCoords = null){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTF");
        this.defaultLanguage = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory();
        // define properties for each table to lazily parse
        for(let tag in this.directory.tables){
            let table = this.directory.tables[tag];
            if ($5825c04ce8f7102d$export$2e2bcd8739ae039[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "bbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "characterSet", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "variationAxes", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "namedVariations", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $89f72d2d7c9afc0d$var$WOFFDirectoryEntry = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    offset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void", {
        type: "global"
    }),
    compLength: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    origChecksum: $gfJaN$restructure.uint32
});
let $89f72d2d7c9afc0d$var$WOFFDirectory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    flavor: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    numTables: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    totalSfntSize: $gfJaN$restructure.uint32,
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    metaOffset: $gfJaN$restructure.uint32,
    metaLength: $gfJaN$restructure.uint32,
    metaOrigLength: $gfJaN$restructure.uint32,
    privOffset: $gfJaN$restructure.uint32,
    privLength: $gfJaN$restructure.uint32,
    tables: new $gfJaN$restructure.Array($89f72d2d7c9afc0d$var$WOFFDirectoryEntry, "numTables")
});
$89f72d2d7c9afc0d$var$WOFFDirectory.process = function() {
    let tables1 = {};
    for (let table of this.tables)tables1[table.tag] = table;
    this.tables = tables1;
};
var $89f72d2d7c9afc0d$export$2e2bcd8739ae039 = $89f72d2d7c9afc0d$var$WOFFDirectory;
class $8a0a49baaf5d834d$export$2e2bcd8739ae039 extends $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "wOFF";
    }
    _decodeDirectory() {
        this.directory = $89f72d2d7c9afc0d$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                let outBuffer = new Uint8Array(table.length);
                let buf = $parcel$interopDefault($gfJaN$tinyinflate)(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new $gfJaN$restructure.DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF");
    }
}
class $44b9edca0e403d6d$export$2e2bcd8739ae039 extends $f680320fa07ef53d$export$2e2bcd8739ae039 {
    _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    }
    _getCBox() {
        return this.path.bbox;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF2");
    }
}
const $2f0bfd9a5c1d7b58$var$Base128 = {
    decode (stream) {
        let result = 0;
        let iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(let j = 0; j < iterable.length; j++){
            let i = iterable[j];
            let code = stream.readUInt8();
            // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error("Overflow");
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error("Bad base 128 number");
    }
};
let $2f0bfd9a5c1d7b58$var$knownTags = [
    "cmap",
    "head",
    "hhea",
    "hmtx",
    "maxp",
    "name",
    "OS/2",
    "post",
    "cvt ",
    "fpgm",
    "glyf",
    "loca",
    "prep",
    "CFF ",
    "VORG",
    "EBDT",
    "EBLC",
    "gasp",
    "hdmx",
    "kern",
    "LTSH",
    "PCLT",
    "VDMX",
    "vhea",
    "vmtx",
    "BASE",
    "GDEF",
    "GPOS",
    "GSUB",
    "EBSC",
    "JSTF",
    "MATH",
    "CBDT",
    "CBLC",
    "COLR",
    "CPAL",
    "SVG ",
    "sbix",
    "acnt",
    "avar",
    "bdat",
    "bloc",
    "bsln",
    "cvar",
    "fdsc",
    "feat",
    "fmtx",
    "fvar",
    "gvar",
    "hsty",
    "just",
    "lcar",
    "mort",
    "morx",
    "opbd",
    "prop",
    "trak",
    "Zapf",
    "Silf",
    "Glat",
    "Gloc",
    "Feat",
    "Sill"
];
let $2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry = new $gfJaN$restructure.Struct({
    flags: $gfJaN$restructure.uint8,
    customTag: new $gfJaN$restructure.Optional(new $gfJaN$restructure.String(4), (t)=>(t.flags & 0x3f) === 0x3f),
    tag: (t)=>t.customTag || $2f0bfd9a5c1d7b58$var$knownTags[t.flags & 0x3f],
    length: $2f0bfd9a5c1d7b58$var$Base128,
    transformVersion: (t)=>t.flags >>> 6 & 0x03,
    transformed: (t)=>t.tag === "glyf" || t.tag === "loca" ? t.transformVersion === 0 : t.transformVersion !== 0,
    transformLength: new $gfJaN$restructure.Optional($2f0bfd9a5c1d7b58$var$Base128, (t)=>t.transformed)
});
let $2f0bfd9a5c1d7b58$var$WOFF2Directory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    flavor: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    numTables: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    totalSfntSize: $gfJaN$restructure.uint32,
    totalCompressedSize: $gfJaN$restructure.uint32,
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    metaOffset: $gfJaN$restructure.uint32,
    metaLength: $gfJaN$restructure.uint32,
    metaOrigLength: $gfJaN$restructure.uint32,
    privOffset: $gfJaN$restructure.uint32,
    privLength: $gfJaN$restructure.uint32,
    tables: new $gfJaN$restructure.Array($2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry, "numTables")
});
$2f0bfd9a5c1d7b58$var$WOFF2Directory.process = function() {
    let tables = {};
    for(let i = 0; i < this.tables.length; i++){
        let table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
var $2f0bfd9a5c1d7b58$export$2e2bcd8739ae039 = $2f0bfd9a5c1d7b58$var$WOFF2Directory;
class $333fb94547d9fb5c$export$2e2bcd8739ae039 extends $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "wOF2";
    }
    _decodeDirectory() {
        this.directory = $2f0bfd9a5c1d7b58$export$2e2bcd8739ae039.decode(this.stream);
        this._dataPos = this.stream.pos;
    }
    _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            let buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            let decompressedSize = 0;
            for(let tag in this.directory.tables){
                let entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            let decompressed = $parcel$interopDefault($gfJaN$brotlidecompressjs)(buffer, decompressedSize);
            if (!decompressed) throw new Error("Error decoding compressed data in WOFF2");
            this.stream = new $gfJaN$restructure.DecodeStream(decompressed);
            this._decompressed = true;
        }
    }
    _decodeTable(table) {
        this._decompress();
        return super._decodeTable(table);
    }
    // Override this method to get a glyph and return our
    // custom subclass if there is a glyf table.
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $44b9edca0e403d6d$export$2e2bcd8739ae039(glyph, characters, this);
            } else return super._getBaseGlyph(glyph, characters);
        }
    }
    _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        let table = $333fb94547d9fb5c$var$GlyfTable.decode(this.stream);
        let glyphs = [];
        for(let index = 0; index < table.numGlyphs; index++){
            let glyph = {};
            let nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                let nPoints = [];
                let totalPoints = 0;
                for(let i = 0; i < nContours; i++){
                    let r1 = $333fb94547d9fb5c$var$read255UInt16(table.nPoints);
                    totalPoints += r1;
                    nPoints.push(totalPoints);
                }
                glyph.points = $333fb94547d9fb5c$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(let i1 = 0; i1 < nContours; i1++)glyph.points[nPoints[i1] - 1].endContour = true;
                var instructionSize = $333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                let haveInstructions = $f680320fa07ef53d$export$2e2bcd8739ae039.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF2");
    }
}
// Special class that accepts a length and returns a sub-stream for that data
class $333fb94547d9fb5c$var$Substream {
    decode(stream, parent) {
        return new $gfJaN$restructure.DecodeStream(this._buf.decode(stream, parent));
    }
    constructor(length){
        this.length = length;
        this._buf = new $gfJaN$restructure.Buffer(length);
    }
}
// This struct represents the entire glyf table
let $333fb94547d9fb5c$var$GlyfTable = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    numGlyphs: $gfJaN$restructure.uint16,
    indexFormat: $gfJaN$restructure.uint16,
    nContourStreamSize: $gfJaN$restructure.uint32,
    nPointsStreamSize: $gfJaN$restructure.uint32,
    flagStreamSize: $gfJaN$restructure.uint32,
    glyphStreamSize: $gfJaN$restructure.uint32,
    compositeStreamSize: $gfJaN$restructure.uint32,
    bboxStreamSize: $gfJaN$restructure.uint32,
    instructionStreamSize: $gfJaN$restructure.uint32,
    nContours: new $333fb94547d9fb5c$var$Substream("nContourStreamSize"),
    nPoints: new $333fb94547d9fb5c$var$Substream("nPointsStreamSize"),
    flags: new $333fb94547d9fb5c$var$Substream("flagStreamSize"),
    glyphs: new $333fb94547d9fb5c$var$Substream("glyphStreamSize"),
    composites: new $333fb94547d9fb5c$var$Substream("compositeStreamSize"),
    bboxes: new $333fb94547d9fb5c$var$Substream("bboxStreamSize"),
    instructions: new $333fb94547d9fb5c$var$Substream("instructionStreamSize")
});
const $333fb94547d9fb5c$var$WORD_CODE = 253;
const $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2 = 254;
const $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1 = 255;
const $333fb94547d9fb5c$var$LOWEST_U_CODE = 253;
function $333fb94547d9fb5c$var$read255UInt16(stream) {
    let code = stream.readUInt8();
    if (code === $333fb94547d9fb5c$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $333fb94547d9fb5c$var$LOWEST_U_CODE;
    if (code === $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $333fb94547d9fb5c$var$LOWEST_U_CODE * 2;
    return code;
}
function $333fb94547d9fb5c$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $333fb94547d9fb5c$var$decodeTriplet(flags, glyphs, nPoints) {
    let y;
    let x = y = 0;
    let res = [];
    for(let i = 0; i < nPoints; i++){
        let dx = 0, dy = 0;
        let flag = flags.readUInt8();
        let onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $333fb94547d9fb5c$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $333fb94547d9fb5c$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $333fb94547d9fb5c$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $333fb94547d9fb5c$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            let b2 = glyphs.readUInt8();
            dx = $333fb94547d9fb5c$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $333fb94547d9fb5c$var$withSign(flag, glyphs.readUInt16BE());
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $f680320fa07ef53d$export$baf26146a414f24a(onCurve, false, x, y));
    }
    return res;
}
let $e0b2de9958441c02$var$TTCHeader = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    0x00010000: {
        numFonts: $gfJaN$restructure.uint32,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numFonts")
    },
    0x00020000: {
        numFonts: $gfJaN$restructure.uint32,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numFonts"),
        dsigTag: $gfJaN$restructure.uint32,
        dsigLength: $gfJaN$restructure.uint32,
        dsigOffset: $gfJaN$restructure.uint32
    }
});
class $e0b2de9958441c02$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "ttcf";
    }
    getFont(name) {
        for (let offset of this.header.offsets){
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let offset of this.header.offsets){
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            fonts.push(new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTC");
        this.stream = stream;
        if (stream.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
        this.header = $e0b2de9958441c02$var$TTCHeader.decode(stream);
    }
}
let $d0fe640dc6c78783$var$DFontName = new $gfJaN$restructure.String($gfJaN$restructure.uint8);
let $d0fe640dc6c78783$var$DFontData = new $gfJaN$restructure.Struct({
    len: $gfJaN$restructure.uint32,
    buf: new $gfJaN$restructure.Buffer("len")
});
let $d0fe640dc6c78783$var$Ref = new $gfJaN$restructure.Struct({
    id: $gfJaN$restructure.uint16,
    nameOffset: $gfJaN$restructure.int16,
    attr: $gfJaN$restructure.uint8,
    dataOffset: $gfJaN$restructure.uint24,
    handle: $gfJaN$restructure.uint32
});
let $d0fe640dc6c78783$var$Type = new $gfJaN$restructure.Struct({
    name: new $gfJaN$restructure.String(4),
    maxTypeIndex: $gfJaN$restructure.uint16,
    refList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array($d0fe640dc6c78783$var$Ref, (t)=>t.maxTypeIndex + 1), {
        type: "parent"
    })
});
let $d0fe640dc6c78783$var$TypeList = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    types: new $gfJaN$restructure.Array($d0fe640dc6c78783$var$Type, (t)=>t.length + 1)
});
let $d0fe640dc6c78783$var$DFontMap = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, 24),
    typeList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $d0fe640dc6c78783$var$TypeList),
    nameListOffset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, "void")
});
let $d0fe640dc6c78783$var$DFontHeader = new $gfJaN$restructure.Struct({
    dataOffset: $gfJaN$restructure.uint32,
    map: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $d0fe640dc6c78783$var$DFontMap),
    dataLength: $gfJaN$restructure.uint32,
    mapLength: $gfJaN$restructure.uint32
});
class $d0fe640dc6c78783$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let stream = new $gfJaN$restructure.DecodeStream(buffer);
        try {
            var header = $d0fe640dc6c78783$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for (let type of header.map.typeList.types){
            if (type.name === "sfnt") return true;
        }
        return false;
    }
    getFont(name) {
        if (!this.sfnt) return null;
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer.slice(pos));
            let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer.slice(pos));
            fonts.push(new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "DFont");
        this.stream = stream;
        this.header = $d0fe640dc6c78783$var$DFontHeader.decode(this.stream);
        for (let type of this.header.map.typeList.types){
            for (let ref of type.refList)if (ref.nameOffset >= 0) {
                this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                ref.name = $d0fe640dc6c78783$var$DFontName.decode(this.stream);
            } else ref.name = null;
            if (type.name === "sfnt") this.sfnt = type;
        }
    }
}
$59aa4ed98453e1d4$export$36b2f24e97d43be($0a8ef2660a6ce4b6$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($8a0a49baaf5d834d$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($333fb94547d9fb5c$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($e0b2de9958441c02$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($d0fe640dc6c78783$export$2e2bcd8739ae039);
$parcel$exportWildcard(module.exports, $59aa4ed98453e1d4$exports); //# sourceMappingURL=browser.cjs.map

},{"f21b476b3755c378":"fXayK","ff6728da855c7440":"dtA7R","6aa66445f242ca61":"cBJXB","512c7b618d747e29":"lInwn","4c80a4567e3a20c2":"bOC1E","5389545d6ddd3821":"laCPz","bffd1a7b85ce30bb":"d51GW","b4fd531a03fcb1a9":"jxYIZ","998fb3c74b159a7f":"b3Jav","6035591d530ded93":"k63ZE"}],"fXayK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncodeStream", ()=>(0, _encodeStreamJs.EncodeStream));
parcelHelpers.export(exports, "DecodeStream", ()=>(0, _decodeStreamJs.DecodeStream));
parcelHelpers.export(exports, "Array", ()=>(0, _arrayJs.Array));
parcelHelpers.export(exports, "LazyArray", ()=>(0, _lazyArrayJs.LazyArray));
parcelHelpers.export(exports, "Bitfield", ()=>(0, _bitfieldJs.Bitfield));
parcelHelpers.export(exports, "Boolean", ()=>(0, _booleanJs.Boolean));
parcelHelpers.export(exports, "Buffer", ()=>(0, _bufferJs.Buffer));
parcelHelpers.export(exports, "Enum", ()=>(0, _enumJs.Enum));
parcelHelpers.export(exports, "Optional", ()=>(0, _optionalJs.Optional));
parcelHelpers.export(exports, "Reserved", ()=>(0, _reservedJs.Reserved));
parcelHelpers.export(exports, "String", ()=>(0, _stringJs.String));
parcelHelpers.export(exports, "Struct", ()=>(0, _structJs.Struct));
parcelHelpers.export(exports, "VersionedStruct", ()=>(0, _versionedStructJs.VersionedStruct));
var _encodeStreamJs = require("./src/EncodeStream.js");
var _decodeStreamJs = require("./src/DecodeStream.js");
var _arrayJs = require("./src/Array.js");
var _lazyArrayJs = require("./src/LazyArray.js");
var _bitfieldJs = require("./src/Bitfield.js");
var _booleanJs = require("./src/Boolean.js");
var _bufferJs = require("./src/Buffer.js");
var _enumJs = require("./src/Enum.js");
var _optionalJs = require("./src/Optional.js");
var _reservedJs = require("./src/Reserved.js");
var _stringJs = require("./src/String.js");
var _structJs = require("./src/Struct.js");
var _versionedStructJs = require("./src/VersionedStruct.js");
var _utilsJs = require("./src/utils.js");
parcelHelpers.exportAll(_utilsJs, exports);
var _numberJs = require("./src/Number.js");
parcelHelpers.exportAll(_numberJs, exports);
var _pointerJs = require("./src/Pointer.js");
parcelHelpers.exportAll(_pointerJs, exports);

},{"./src/EncodeStream.js":"g8oee","./src/DecodeStream.js":"4Uzsa","./src/Array.js":"2Msx6","./src/LazyArray.js":"bR16k","./src/Bitfield.js":"4tvdV","./src/Boolean.js":"fqDFb","./src/Buffer.js":"bcSgB","./src/Enum.js":"aoQt5","./src/Optional.js":"h18TC","./src/Reserved.js":"chsT8","./src/String.js":"hqdWd","./src/Struct.js":"huFyI","./src/VersionedStruct.js":"f0ZSi","./src/utils.js":"1Dzn9","./src/Number.js":"ahJAG","./src/Pointer.js":"49W3o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"g8oee":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncodeStream", ()=>EncodeStream);
var _decodeStreamJs = require("./DecodeStream.js");
const textEncoder = new TextEncoder();
const isBigEndian = new Uint8Array(new Uint16Array([
    0x1234
]).buffer)[0] == 0x12;
class EncodeStream {
    writeBuffer(buffer) {
        this.buffer.set(buffer, this.pos);
        this.pos += buffer.length;
    }
    writeString(string, encoding = "ascii") {
        let buf;
        switch(encoding){
            case "utf16le":
            case "utf16-le":
            case "ucs2":
                buf = stringToUtf16(string, isBigEndian);
                break;
            case "utf16be":
            case "utf16-be":
                buf = stringToUtf16(string, !isBigEndian);
                break;
            case "utf8":
                buf = textEncoder.encode(string);
                break;
            case "ascii":
                buf = stringToAscii(string);
                break;
            default:
                throw new Error(`Unsupported encoding: ${encoding}`);
        }
        this.writeBuffer(buf);
    }
    writeUInt24BE(val) {
        this.buffer[this.pos++] = val >>> 16 & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val & 0xff;
    }
    writeUInt24LE(val) {
        this.buffer[this.pos++] = val & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val >>> 16 & 0xff;
    }
    writeInt24BE(val) {
        if (val >= 0) this.writeUInt24BE(val);
        else this.writeUInt24BE(val + 0xffffff + 1);
    }
    writeInt24LE(val) {
        if (val >= 0) this.writeUInt24LE(val);
        else this.writeUInt24LE(val + 0xffffff + 1);
    }
    fill(val, length) {
        if (length < this.buffer.length) {
            this.buffer.fill(val, this.pos, this.pos + length);
            this.pos += length;
        } else {
            const buf = new Uint8Array(length);
            buf.fill(val);
            this.writeBuffer(buf);
        }
    }
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        this.pos = 0;
    }
}
function stringToUtf16(string, swap) {
    let buf = new Uint16Array(string.length);
    for(let i = 0; i < string.length; i++){
        let code = string.charCodeAt(i);
        if (swap) code = code >> 8 | (code & 0xff) << 8;
        buf[i] = code;
    }
    return new Uint8Array(buf.buffer);
}
function stringToAscii(string) {
    let buf = new Uint8Array(string.length);
    for(let i = 0; i < string.length; i++)// Match node.js behavior - encoding allows 8-bit rather than 7-bit.
    buf[i] = string.charCodeAt(i);
    return buf;
}
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === "set") {
    let type = key.slice(3).replace("Ui", "UI");
    if (type === "Float32") type = "Float";
    else if (type === "Float64") type = "Double";
    let bytes = (0, _decodeStreamJs.DecodeStream).TYPES[type];
    EncodeStream.prototype["write" + type + (bytes === 1 ? "" : "BE")] = function(value) {
        this.view[key](this.pos, value, false);
        this.pos += bytes;
    };
    if (bytes !== 1) EncodeStream.prototype["write" + type + "LE"] = function(value) {
        this.view[key](this.pos, value, true);
        this.pos += bytes;
    };
}

},{"./DecodeStream.js":"4Uzsa","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Uzsa":[function(require,module,exports) {
// Node back-compat.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DecodeStream", ()=>DecodeStream);
const ENCODING_MAPPING = {
    utf16le: "utf-16le",
    ucs2: "utf-16le",
    utf16be: "utf-16be"
};
class DecodeStream {
    readString(length, encoding = "ascii") {
        encoding = ENCODING_MAPPING[encoding] || encoding;
        let buf = this.readBuffer(length);
        try {
            let decoder = new TextDecoder(encoding);
            return decoder.decode(buf);
        } catch (err) {
            return buf;
        }
    }
    readBuffer(length) {
        return this.buffer.slice(this.pos, this.pos += length);
    }
    readUInt24BE() {
        return (this.readUInt16BE() << 8) + this.readUInt8();
    }
    readUInt24LE() {
        return this.readUInt16LE() + (this.readUInt8() << 16);
    }
    readInt24BE() {
        return (this.readInt16BE() << 8) + this.readUInt8();
    }
    readInt24LE() {
        return this.readUInt16LE() + (this.readInt8() << 16);
    }
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        this.pos = 0;
        this.length = this.buffer.length;
    }
}
DecodeStream.TYPES = {
    UInt8: 1,
    UInt16: 2,
    UInt24: 3,
    UInt32: 4,
    Int8: 1,
    Int16: 2,
    Int24: 3,
    Int32: 4,
    Float: 4,
    Double: 8
};
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === "get") {
    let type = key.slice(3).replace("Ui", "UI");
    if (type === "Float32") type = "Float";
    else if (type === "Float64") type = "Double";
    let bytes = DecodeStream.TYPES[type];
    DecodeStream.prototype["read" + type + (bytes === 1 ? "" : "BE")] = function() {
        const ret = this.view[key](this.pos, false);
        this.pos += bytes;
        return ret;
    };
    if (bytes !== 1) DecodeStream.prototype["read" + type + "LE"] = function() {
        const ret = this.view[key](this.pos, true);
        this.pos += bytes;
        return ret;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Msx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Array", ()=>ArrayT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class ArrayT extends (0, _baseJs.Base) {
    decode(stream, parent) {
        let length;
        const { pos } = stream;
        const res = [];
        let ctx = parent;
        if (this.length != null) length = _utilsJs.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, _numberJs.Number)) {
            // define hidden properties
            Object.defineProperties(res, {
                parent: {
                    value: parent
                },
                _startOffset: {
                    value: pos
                },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: {
                    value: length
                }
            });
            ctx = res;
        }
        if (length == null || this.lengthType === "bytes") {
            const target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
        } else for(let i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
        return res;
    }
    size(array, ctx, includePointers = true) {
        if (!array) return this.type.size(null, ctx) * _utilsJs.resolveLength(this.length, null, ctx);
        let size = 0;
        if (this.length instanceof (0, _numberJs.Number)) {
            size += this.length.size();
            ctx = {
                parent: ctx,
                pointerSize: 0
            };
        }
        for (let item of array)size += this.type.size(item, ctx);
        if (ctx && includePointers && this.length instanceof (0, _numberJs.Number)) size += ctx.pointerSize;
        return size;
    }
    encode(stream, array, parent) {
        let ctx = parent;
        if (this.length instanceof (0, _numberJs.Number)) {
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent
            };
            ctx.pointerOffset = stream.pos + this.size(array, ctx, false);
            this.length.encode(stream, array.length);
        }
        for (let item of array)this.type.encode(stream, item, ctx);
        if (this.length instanceof (0, _numberJs.Number)) {
            let i = 0;
            while(i < ctx.pointers.length){
                const ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        }
    }
    constructor(type, length, lengthType = "count"){
        super();
        this.type = type;
        this.length = length;
        this.lengthType = lengthType;
    }
}

},{"./Base.js":"kwp9t","./Number.js":"ahJAG","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kwp9t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Base", ()=>Base);
var _decodeStreamJs = require("./DecodeStream.js");
var _encodeStreamJs = require("./EncodeStream.js");
class Base {
    fromBuffer(buffer) {
        let stream = new (0, _decodeStreamJs.DecodeStream)(buffer);
        return this.decode(stream);
    }
    toBuffer(value) {
        let size = this.size(value);
        let buffer = new Uint8Array(size);
        let stream = new (0, _encodeStreamJs.EncodeStream)(buffer);
        this.encode(stream, value);
        return buffer;
    }
}

},{"./DecodeStream.js":"4Uzsa","./EncodeStream.js":"g8oee","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ahJAG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Number", ()=>NumberT);
parcelHelpers.export(exports, "uint8", ()=>uint8);
parcelHelpers.export(exports, "uint16be", ()=>uint16be);
parcelHelpers.export(exports, "uint16", ()=>uint16);
parcelHelpers.export(exports, "uint16le", ()=>uint16le);
parcelHelpers.export(exports, "uint24be", ()=>uint24be);
parcelHelpers.export(exports, "uint24", ()=>uint24);
parcelHelpers.export(exports, "uint24le", ()=>uint24le);
parcelHelpers.export(exports, "uint32be", ()=>uint32be);
parcelHelpers.export(exports, "uint32", ()=>uint32);
parcelHelpers.export(exports, "uint32le", ()=>uint32le);
parcelHelpers.export(exports, "int8", ()=>int8);
parcelHelpers.export(exports, "int16be", ()=>int16be);
parcelHelpers.export(exports, "int16", ()=>int16);
parcelHelpers.export(exports, "int16le", ()=>int16le);
parcelHelpers.export(exports, "int24be", ()=>int24be);
parcelHelpers.export(exports, "int24", ()=>int24);
parcelHelpers.export(exports, "int24le", ()=>int24le);
parcelHelpers.export(exports, "int32be", ()=>int32be);
parcelHelpers.export(exports, "int32", ()=>int32);
parcelHelpers.export(exports, "int32le", ()=>int32le);
parcelHelpers.export(exports, "floatbe", ()=>floatbe);
parcelHelpers.export(exports, "float", ()=>float);
parcelHelpers.export(exports, "floatle", ()=>floatle);
parcelHelpers.export(exports, "doublebe", ()=>doublebe);
parcelHelpers.export(exports, "double", ()=>double);
parcelHelpers.export(exports, "doublele", ()=>doublele);
parcelHelpers.export(exports, "Fixed", ()=>Fixed);
parcelHelpers.export(exports, "fixed16be", ()=>fixed16be);
parcelHelpers.export(exports, "fixed16", ()=>fixed16);
parcelHelpers.export(exports, "fixed16le", ()=>fixed16le);
parcelHelpers.export(exports, "fixed32be", ()=>fixed32be);
parcelHelpers.export(exports, "fixed32", ()=>fixed32);
parcelHelpers.export(exports, "fixed32le", ()=>fixed32le);
var _decodeStreamJs = require("./DecodeStream.js");
var _baseJs = require("./Base.js");
class NumberT extends (0, _baseJs.Base) {
    size() {
        return (0, _decodeStreamJs.DecodeStream).TYPES[this.type];
    }
    decode(stream) {
        return stream[`read${this.fn}`]();
    }
    encode(stream, val) {
        return stream[`write${this.fn}`](val);
    }
    constructor(type, endian = "BE"){
        super();
        this.type = type;
        this.endian = endian;
        this.fn = this.type;
        if (this.type[this.type.length - 1] !== "8") this.fn += this.endian;
    }
}
const uint8 = new NumberT("UInt8");
const uint16be = new NumberT("UInt16", "BE");
const uint16 = uint16be;
const uint16le = new NumberT("UInt16", "LE");
const uint24be = new NumberT("UInt24", "BE");
const uint24 = uint24be;
const uint24le = new NumberT("UInt24", "LE");
const uint32be = new NumberT("UInt32", "BE");
const uint32 = uint32be;
const uint32le = new NumberT("UInt32", "LE");
const int8 = new NumberT("Int8");
const int16be = new NumberT("Int16", "BE");
const int16 = int16be;
const int16le = new NumberT("Int16", "LE");
const int24be = new NumberT("Int24", "BE");
const int24 = int24be;
const int24le = new NumberT("Int24", "LE");
const int32be = new NumberT("Int32", "BE");
const int32 = int32be;
const int32le = new NumberT("Int32", "LE");
const floatbe = new NumberT("Float", "BE");
const float = floatbe;
const floatle = new NumberT("Float", "LE");
const doublebe = new NumberT("Double", "BE");
const double = doublebe;
const doublele = new NumberT("Double", "LE");
class Fixed extends NumberT {
    decode(stream) {
        return super.decode(stream) / this._point;
    }
    encode(stream, val) {
        return super.encode(stream, val * this._point | 0);
    }
    constructor(size, endian, fracBits = size >> 1){
        super(`Int${size}`, endian);
        this._point = 1 << fracBits;
    }
}
const fixed16be = new Fixed(16, "BE");
const fixed16 = fixed16be;
const fixed16le = new Fixed(16, "LE");
const fixed32be = new Fixed(32, "BE");
const fixed32 = fixed32be;
const fixed32le = new Fixed(32, "LE");

},{"./DecodeStream.js":"4Uzsa","./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Dzn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveLength", ()=>resolveLength);
parcelHelpers.export(exports, "PropertyDescriptor", ()=>PropertyDescriptor);
var _numberJs = require("./Number.js");
function resolveLength(length, stream, parent) {
    let res;
    if (typeof length === "number") res = length;
    else if (typeof length === "function") res = length.call(parent, parent);
    else if (parent && typeof length === "string") res = parent[length];
    else if (stream && length instanceof (0, _numberJs.Number)) res = length.decode(stream);
    if (isNaN(res)) throw new Error("Not a fixed size");
    return res;
}
class PropertyDescriptor {
    constructor(opts = {}){
        this.enumerable = true;
        this.configurable = true;
        for(let key in opts){
            const val = opts[key];
            this[key] = val;
        }
    }
}

},{"./Number.js":"ahJAG","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bR16k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyArray", ()=>LazyArray);
var _arrayJs = require("./Array.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class LazyArray extends (0, _arrayJs.Array) {
    decode(stream, parent) {
        const { pos } = stream;
        const length = _utilsJs.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, _numberJs.Number)) parent = {
            parent,
            _startOffset: pos,
            _currentOffset: 0,
            _length: length
        };
        const res = new LazyArrayValue(this.type, length, stream, parent);
        stream.pos += length * this.type.size(null, parent);
        return res;
    }
    size(val, ctx) {
        if (val instanceof LazyArrayValue) val = val.toArray();
        return super.size(val, ctx);
    }
    encode(stream, val, ctx) {
        if (val instanceof LazyArrayValue) val = val.toArray();
        return super.encode(stream, val, ctx);
    }
}
class LazyArrayValue {
    get(index) {
        if (index < 0 || index >= this.length) return undefined;
        if (this.items[index] == null) {
            const { pos } = this.stream;
            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
            this.items[index] = this.type.decode(this.stream, this.ctx);
            this.stream.pos = pos;
        }
        return this.items[index];
    }
    toArray() {
        const result = [];
        for(let i = 0, end = this.length; i < end; i++)result.push(this.get(i));
        return result;
    }
    constructor(type, length, stream, ctx){
        this.type = type;
        this.length = length;
        this.stream = stream;
        this.ctx = ctx;
        this.base = this.stream.pos;
        this.items = [];
    }
}

},{"./Array.js":"2Msx6","./Number.js":"ahJAG","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4tvdV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bitfield", ()=>Bitfield);
var _baseJs = require("./Base.js");
class Bitfield extends (0, _baseJs.Base) {
    decode(stream) {
        const val = this.type.decode(stream);
        const res = {};
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) res[flag] = !!(val & 1 << i);
        }
        return res;
    }
    size() {
        return this.type.size();
    }
    encode(stream, keys) {
        let val = 0;
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) {
                if (keys[flag]) val |= 1 << i;
            }
        }
        return this.type.encode(stream, val);
    }
    constructor(type, flags = []){
        super();
        this.type = type;
        this.flags = flags;
    }
}

},{"./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fqDFb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BooleanT", ()=>BooleanT);
parcelHelpers.export(exports, "Boolean", ()=>BooleanT);
var _baseJs = require("./Base.js");
class BooleanT extends (0, _baseJs.Base) {
    decode(stream, parent) {
        return !!this.type.decode(stream, parent);
    }
    size(val, parent) {
        return this.type.size(val, parent);
    }
    encode(stream, val, parent) {
        return this.type.encode(stream, +val, parent);
    }
    constructor(type){
        super();
        this.type = type;
    }
}

},{"./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bcSgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferT", ()=>BufferT);
parcelHelpers.export(exports, "Buffer", ()=>BufferT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class BufferT extends (0, _baseJs.Base) {
    decode(stream, parent) {
        const length = _utilsJs.resolveLength(this.length, stream, parent);
        return stream.readBuffer(length);
    }
    size(val, parent) {
        if (!val) return _utilsJs.resolveLength(this.length, null, parent);
        let len = val.length;
        if (this.length instanceof (0, _numberJs.Number)) len += this.length.size();
        return len;
    }
    encode(stream, buf, parent) {
        if (this.length instanceof (0, _numberJs.Number)) this.length.encode(stream, buf.length);
        return stream.writeBuffer(buf);
    }
    constructor(length){
        super();
        this.length = length;
    }
}

},{"./Base.js":"kwp9t","./Number.js":"ahJAG","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aoQt5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Enum", ()=>Enum);
var _baseJs = require("./Base.js");
class Enum extends (0, _baseJs.Base) {
    decode(stream) {
        const index = this.type.decode(stream);
        return this.options[index] || index;
    }
    size() {
        return this.type.size();
    }
    encode(stream, val) {
        const index = this.options.indexOf(val);
        if (index === -1) throw new Error(`Unknown option in enum: ${val}`);
        return this.type.encode(stream, index);
    }
    constructor(type, options = []){
        super();
        this.type = type;
        this.options = options;
    }
}

},{"./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h18TC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Optional", ()=>Optional);
var _baseJs = require("./Base.js");
class Optional extends (0, _baseJs.Base) {
    decode(stream, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.decode(stream, parent);
    }
    size(val, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.size(val, parent);
        else return 0;
    }
    encode(stream, val, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.encode(stream, val, parent);
    }
    constructor(type, condition = true){
        super();
        this.type = type;
        this.condition = condition;
    }
}

},{"./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"chsT8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reserved", ()=>Reserved);
var _baseJs = require("./Base.js");
var _utilsJs = require("./utils.js");
class Reserved extends (0, _baseJs.Base) {
    decode(stream, parent) {
        stream.pos += this.size(null, parent);
        return undefined;
    }
    size(data, parent) {
        const count = _utilsJs.resolveLength(this.count, null, parent);
        return this.type.size() * count;
    }
    encode(stream, val, parent) {
        return stream.fill(0, this.size(val, parent));
    }
    constructor(type, count = 1){
        super();
        this.type = type;
        this.count = count;
    }
}

},{"./Base.js":"kwp9t","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hqdWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "String", ()=>StringT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class StringT extends (0, _baseJs.Base) {
    decode(stream, parent) {
        let length, pos;
        if (this.length != null) length = _utilsJs.resolveLength(this.length, stream, parent);
        else {
            let buffer;
            ({ buffer, length, pos } = stream);
            while(pos < length && buffer[pos] !== 0x00)++pos;
            length = pos - stream.pos;
        }
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent, parent) || "ascii";
        const string = stream.readString(length, encoding);
        if (this.length == null && stream.pos < stream.length) stream.pos++;
        return string;
    }
    size(val, parent) {
        // Use the defined value if no value was given
        if (!val) return _utilsJs.resolveLength(this.length, null, parent);
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
        if (encoding === "utf16be") encoding = "utf16le";
        let size = byteLength(val, encoding);
        if (this.length instanceof (0, _numberJs.Number)) size += this.length.size();
        if (this.length == null) size++;
        return size;
    }
    encode(stream, val, parent) {
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
        if (this.length instanceof (0, _numberJs.Number)) this.length.encode(stream, byteLength(val, encoding));
        stream.writeString(val, encoding);
        if (this.length == null) return stream.writeUInt8(0x00);
    }
    constructor(length, encoding = "ascii"){
        super();
        this.length = length;
        this.encoding = encoding;
    }
}
function byteLength(string, encoding) {
    switch(encoding){
        case "ascii":
            return string.length;
        case "utf8":
            let len = 0;
            for(let i = 0; i < string.length; i++){
                let c = string.charCodeAt(i);
                if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
                    let c2 = string.charCodeAt(++i);
                    if ((c2 & 0xfc00) === 0xdc00) c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
                    else // unmatched surrogate.
                    i--;
                }
                if ((c & 0xffffff80) === 0) len++;
                else if ((c & 0xfffff800) === 0) len += 2;
                else if ((c & 0xffff0000) === 0) len += 3;
                else if ((c & 0xffe00000) === 0) len += 4;
            }
            return len;
        case "utf16le":
        case "utf16-le":
        case "utf16be":
        case "utf16-be":
        case "ucs2":
            return string.length * 2;
        default:
            throw new Error("Unknown encoding " + encoding);
    }
}

},{"./Base.js":"kwp9t","./Number.js":"ahJAG","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"huFyI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Struct", ()=>Struct);
var _baseJs = require("./Base.js");
var _utilsJs = require("./utils.js");
class Struct extends (0, _baseJs.Base) {
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        this._parseFields(stream, res, this.fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    _setup(stream, parent, length) {
        const res = {};
        // define hidden properties
        Object.defineProperties(res, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            },
            _currentOffset: {
                value: 0,
                writable: true
            },
            _length: {
                value: length
            }
        });
        return res;
    }
    _parseFields(stream, res, fields) {
        for(let key in fields){
            var val;
            const type = fields[key];
            if (typeof type === "function") val = type.call(res, res);
            else val = type.decode(stream, res);
            if (val !== undefined) {
                if (val instanceof _utilsJs.PropertyDescriptor) Object.defineProperty(res, key, val);
                else res[key] = val;
            }
            res._currentOffset = stream.pos - res._startOffset;
        }
    }
    size(val, parent, includePointers = true) {
        if (val == null) val = {};
        const ctx = {
            parent,
            val,
            pointerSize: 0
        };
        if (this.preEncode != null) this.preEncode.call(val);
        let size = 0;
        for(let key in this.fields){
            const type = this.fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent,
            val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        for(let key in this.fields){
            type = this.fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
    constructor(fields = {}){
        super();
        this.fields = fields;
    }
}

},{"./Base.js":"kwp9t","./utils.js":"1Dzn9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f0ZSi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VersionedStruct", ()=>VersionedStruct);
var _structJs = require("./Struct.js");
const getPath = (object, pathArray)=>{
    return pathArray.reduce((prevObj, key)=>prevObj && prevObj[key], object);
};
class VersionedStruct extends (0, _structJs.Struct) {
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        if (typeof this.type === "string") res.version = getPath(parent, this.versionPath);
        else res.version = this.type.decode(stream);
        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
        const fields = this.versions[res.version];
        if (fields == null) throw new Error(`Unknown version ${res.version}`);
        if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
        this._parseFields(stream, res, fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    size(val, parent, includePointers = true) {
        let key, type;
        if (!val) throw new Error("Not a fixed size");
        if (this.preEncode != null) this.preEncode.call(val);
        const ctx = {
            parent,
            val,
            pointerSize: 0
        };
        let size = 0;
        if (typeof this.type !== "string") size += this.type.size(val.version, ctx);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        const fields = this.versions[val.version];
        if (fields == null) throw new Error(`Unknown version ${val.version}`);
        for(key in fields){
            type = fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let key, type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent,
            val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        if (typeof this.type !== "string") this.type.encode(stream, val.version);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        const fields = this.versions[val.version];
        for(key in fields){
            type = fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
    constructor(type, versions = {}){
        super();
        this.type = type;
        this.versions = versions;
        if (typeof type === "string") this.versionPath = type.split(".");
    }
}

},{"./Struct.js":"huFyI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"49W3o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pointer", ()=>Pointer);
// A pointer whose type is determined at decode time
parcelHelpers.export(exports, "VoidPointer", ()=>VoidPointer);
var _utilsJs = require("./utils.js");
var _baseJs = require("./Base.js");
class Pointer extends (0, _baseJs.Base) {
    decode(stream, ctx) {
        const offset = this.offsetType.decode(stream, ctx);
        // handle NULL pointers
        if (offset === this.options.nullValue && this.options.allowNull) return null;
        let relative;
        switch(this.options.type){
            case "local":
                relative = ctx._startOffset;
                break;
            case "immediate":
                relative = stream.pos - this.offsetType.size();
                break;
            case "parent":
                relative = ctx.parent._startOffset;
                break;
            default:
                var c = ctx;
                while(c.parent)c = c.parent;
                relative = c._startOffset || 0;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
        const ptr = offset + relative;
        if (this.type != null) {
            let val = null;
            const decodeValue = ()=>{
                if (val != null) return val;
                const { pos } = stream;
                stream.pos = ptr;
                val = this.type.decode(stream, ctx);
                stream.pos = pos;
                return val;
            };
            // If this is a lazy pointer, define a getter to decode only when needed.
            // This obviously only works when the pointer is contained by a Struct.
            if (this.options.lazy) return new _utilsJs.PropertyDescriptor({
                get: decodeValue
            });
            return decodeValue();
        } else return ptr;
    }
    size(val, ctx) {
        const parent = ctx;
        switch(this.options.type){
            case "local":
            case "immediate":
                break;
            case "parent":
                ctx = ctx.parent;
                break;
            default:
                while(ctx.parent)ctx = ctx.parent;
        }
        let { type } = this;
        if (type == null) {
            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
            ({ type } = val);
            val = val.value;
        }
        if (val && ctx) {
            // Must be written as two separate lines rather than += in case `type.size` mutates ctx.pointerSize.
            let size = type.size(val, parent);
            ctx.pointerSize += size;
        }
        return this.offsetType.size();
    }
    encode(stream, val, ctx) {
        let relative;
        const parent = ctx;
        if (val == null) {
            this.offsetType.encode(stream, this.options.nullValue);
            return;
        }
        switch(this.options.type){
            case "local":
                relative = ctx.startOffset;
                break;
            case "immediate":
                relative = stream.pos + this.offsetType.size(val, parent);
                break;
            case "parent":
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;
            default:
                relative = 0;
                while(ctx.parent)ctx = ctx.parent;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
        this.offsetType.encode(stream, ctx.pointerOffset - relative);
        let { type } = this;
        if (type == null) {
            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
            ({ type } = val);
            val = val.value;
        }
        ctx.pointers.push({
            type,
            val,
            parent
        });
        return ctx.pointerOffset += type.size(val, parent);
    }
    constructor(offsetType, type, options = {}){
        super();
        this.offsetType = offsetType;
        this.type = type;
        this.options = options;
        if (this.type === "void") this.type = null;
        if (this.options.type == null) this.options.type = "local";
        if (this.options.allowNull == null) this.options.allowNull = true;
        if (this.options.nullValue == null) this.options.nullValue = 0;
        if (this.options.lazy == null) this.options.lazy = false;
        if (this.options.relativeTo) {
            if (typeof this.options.relativeTo !== "function") throw new Error("relativeTo option must be a function");
            this.relativeToGetter = options.relativeTo;
        }
    }
}
class VoidPointer {
    constructor(type, value){
        this.type = type;
        this.value = value;
    }
}

},{"./utils.js":"1Dzn9","./Base.js":"kwp9t","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dtA7R":[function(require,module,exports) {
module.exports = require("22c5fd25e4d753f4");

},{"22c5fd25e4d753f4":"5r55e"}],"5r55e":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _defineProperty;
    }
});
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{}],"cBJXB":[function(require,module,exports) {
module.exports = require("6b10ee8598f405e5");

},{"6b10ee8598f405e5":"3v3Vr"}],"3v3Vr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _tslib["__decorate"];
    }
});
var _tslib = require("d48bdc6418109143");

},{"d48bdc6418109143":"86BcK"}],"lInwn":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"bOC1E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCategory", ()=>$747425b437e121da$export$410364bbb673ddbc);
parcelHelpers.export(exports, "getCombiningClass", ()=>$747425b437e121da$export$c03b919c6651ed55);
parcelHelpers.export(exports, "getScript", ()=>$747425b437e121da$export$941569448d136665);
parcelHelpers.export(exports, "getEastAsianWidth", ()=>$747425b437e121da$export$92f6187db8ca6d26);
parcelHelpers.export(exports, "getNumericValue", ()=>$747425b437e121da$export$7d1258ebb7625a0d);
parcelHelpers.export(exports, "isAlphabetic", ()=>$747425b437e121da$export$52c8ea63abd07594);
parcelHelpers.export(exports, "isDigit", ()=>$747425b437e121da$export$727d9dbc4fbb948f);
parcelHelpers.export(exports, "isPunctuation", ()=>$747425b437e121da$export$a5b49f4dc6a07d2c);
parcelHelpers.export(exports, "isLowerCase", ()=>$747425b437e121da$export$7b6804e8df61fcf5);
parcelHelpers.export(exports, "isUpperCase", ()=>$747425b437e121da$export$aebd617640818cda);
parcelHelpers.export(exports, "isTitleCase", ()=>$747425b437e121da$export$de8b4ee23b2cf823);
parcelHelpers.export(exports, "isWhiteSpace", ()=>$747425b437e121da$export$3c52dd84024ae72c);
parcelHelpers.export(exports, "isBaseForm", ()=>$747425b437e121da$export$a11bdcffe109e74b);
parcelHelpers.export(exports, "isMark", ()=>$747425b437e121da$export$e33ad6871e762338);
parcelHelpers.export(exports, "default", ()=>$747425b437e121da$export$2e2bcd8739ae039);
var _base64Js = require("base64-js");
var _base64JsDefault = parcelHelpers.interopDefault(_base64Js);
var _unicodeTrie = require("unicode-trie");
var _unicodeTrieDefault = parcelHelpers.interopDefault(_unicodeTrie);
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $f4087201da764553$exports = {};
$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $747425b437e121da$var$trie = new (0, _unicodeTrieDefault.default)((0, _base64JsDefault.default).toByteArray("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"));
const $747425b437e121da$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
const $747425b437e121da$var$bits = (n)=>$747425b437e121da$var$log2(n) + 1 | 0;
// compute the number of bits stored for each field
const $747425b437e121da$var$CATEGORY_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).categories.length - 1);
const $747425b437e121da$var$COMBINING_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).combiningClasses.length - 1);
const $747425b437e121da$var$SCRIPT_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).scripts.length - 1);
const $747425b437e121da$var$EAW_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).eaw.length - 1);
const $747425b437e121da$var$NUMBER_BITS = 10;
// compute shift and mask values for each field
const $747425b437e121da$var$CATEGORY_SHIFT = $747425b437e121da$var$COMBINING_BITS + $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$COMBINING_SHIFT = $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$SCRIPT_SHIFT = $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$EAW_SHIFT = $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$CATEGORY_MASK = (1 << $747425b437e121da$var$CATEGORY_BITS) - 1;
const $747425b437e121da$var$COMBINING_MASK = (1 << $747425b437e121da$var$COMBINING_BITS) - 1;
const $747425b437e121da$var$SCRIPT_MASK = (1 << $747425b437e121da$var$SCRIPT_BITS) - 1;
const $747425b437e121da$var$EAW_MASK = (1 << $747425b437e121da$var$EAW_BITS) - 1;
const $747425b437e121da$var$NUMBER_MASK = (1 << $747425b437e121da$var$NUMBER_BITS) - 1;
function $747425b437e121da$export$410364bbb673ddbc(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).categories[val >> $747425b437e121da$var$CATEGORY_SHIFT & $747425b437e121da$var$CATEGORY_MASK];
}
function $747425b437e121da$export$c03b919c6651ed55(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).combiningClasses[val >> $747425b437e121da$var$COMBINING_SHIFT & $747425b437e121da$var$COMBINING_MASK];
}
function $747425b437e121da$export$941569448d136665(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).scripts[val >> $747425b437e121da$var$SCRIPT_SHIFT & $747425b437e121da$var$SCRIPT_MASK];
}
function $747425b437e121da$export$92f6187db8ca6d26(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).eaw[val >> $747425b437e121da$var$EAW_SHIFT & $747425b437e121da$var$EAW_MASK];
}
function $747425b437e121da$export$7d1258ebb7625a0d(codePoint) {
    let val = $747425b437e121da$var$trie.get(codePoint);
    let num = val & $747425b437e121da$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        const numerator = (num >> 4) - 12;
        const denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        let exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        let exp = (num & 3) + 1;
        while(exp > 0){
            val *= 60;
            exp--;
        }
        return val;
    }
}
function $747425b437e121da$export$52c8ea63abd07594(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
}
function $747425b437e121da$export$727d9dbc4fbb948f(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Nd";
}
function $747425b437e121da$export$a5b49f4dc6a07d2c(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
}
function $747425b437e121da$export$7b6804e8df61fcf5(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Ll";
}
function $747425b437e121da$export$aebd617640818cda(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Lu";
}
function $747425b437e121da$export$de8b4ee23b2cf823(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Lt";
}
function $747425b437e121da$export$3c52dd84024ae72c(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Zs" || category === "Zl" || category === "Zp";
}
function $747425b437e121da$export$a11bdcffe109e74b(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
}
function $747425b437e121da$export$e33ad6871e762338(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Mn" || category === "Me" || category === "Mc";
}
var $747425b437e121da$export$2e2bcd8739ae039 = {
    getCategory: $747425b437e121da$export$410364bbb673ddbc,
    getCombiningClass: $747425b437e121da$export$c03b919c6651ed55,
    getScript: $747425b437e121da$export$941569448d136665,
    getEastAsianWidth: $747425b437e121da$export$92f6187db8ca6d26,
    getNumericValue: $747425b437e121da$export$7d1258ebb7625a0d,
    isAlphabetic: $747425b437e121da$export$52c8ea63abd07594,
    isDigit: $747425b437e121da$export$727d9dbc4fbb948f,
    isPunctuation: $747425b437e121da$export$a5b49f4dc6a07d2c,
    isLowerCase: $747425b437e121da$export$7b6804e8df61fcf5,
    isUpperCase: $747425b437e121da$export$aebd617640818cda,
    isTitleCase: $747425b437e121da$export$de8b4ee23b2cf823,
    isWhiteSpace: $747425b437e121da$export$3c52dd84024ae72c,
    isBaseForm: $747425b437e121da$export$a11bdcffe109e74b,
    isMark: $747425b437e121da$export$e33ad6871e762338
};

},{"base64-js":"MlSYJ","unicode-trie":"laCPz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"laCPz":[function(require,module,exports) {
const inflate = require("8ae222e01e363bff");
const { swap32LE } = require("16e27bed1474c3a6");
// Shift size for getting the index-1 table offset.
const SHIFT_1 = 11;
// Shift size for getting the index-2 table offset.
const SHIFT_2 = 5;
// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const SHIFT_1_2 = SHIFT_1 - SHIFT_2;
// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
// Number of entries in an index-2 block. 64=0x40
const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
// Mask for getting the lower bits for the in-index-2-block offset. */
const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const INDEX_SHIFT = 2;
// Number of entries in a data block. 32=0x20
const DATA_BLOCK_LENGTH = 1 << SHIFT_2;
// Mask for getting the lower bits for the in-data-block offset.
const DATA_MASK = DATA_BLOCK_LENGTH - 1;
// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
// Count the lengths of both BMP pieces. 2080=0x820
const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
const UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
// The alignment size of a data block. Also the granularity for compaction.
const DATA_GRANULARITY = 1 << INDEX_SHIFT;
class UnicodeTrie {
    get(codePoint) {
        let index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            // Ordinary BMP code point, excluding leading surrogates.
            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
            // data is stored in the index array itself.
            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            // Lead Surrogate Code Point.  A Separate index section is stored for
            // lead surrogate code units and code points.
            //   The main index has the code unit data.
            //   For this function, we need the code point data.
            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            // Supplemental code point, use two-level lookup.
            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
    }
    constructor(data){
        const isBuffer = typeof data.readUInt32BE === "function" && typeof data.slice === "function";
        if (isBuffer || data instanceof Uint8Array) {
            // read binary format
            let uncompressedLength;
            if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
            } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
            }
            // double inflate the actual trie data
            data = inflate(data, new Uint8Array(uncompressedLength));
            data = inflate(data, new Uint8Array(uncompressedLength));
            // swap bytes from little-endian
            swap32LE(data);
            this.data = new Uint32Array(data.buffer);
        } else // pre-parsed data
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
}
module.exports = UnicodeTrie;

},{"8ae222e01e363bff":"b3Jav","16e27bed1474c3a6":"97WI2"}],"b3Jav":[function(require,module,exports) {
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;
function Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var sltree = new Tree();
var sdtree = new Tree();
/* extra bits and base tables for length codes */ var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var code_tree = new Tree();
var lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var offs = new Uint16Array(16);
function tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = tinf_read_bits(d, 3, 0);
        lengths[clcidx[i]] = clen;
    }
    /* build code length tree */ tinf_build_tree(code_tree, lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = tinf_decode_symbol(d, code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = lengths[num - 1];
                for(length = tinf_read_bits(d, 2, 3); length; --length)lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = tinf_read_bits(d, 3, 3); length; --length)lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = tinf_read_bits(d, 7, 11); length; --length)lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ tinf_build_tree(lt, lengths, 0, hlit);
    tinf_build_tree(dt, lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
            dist = tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return TINF_OK;
}
/* inflate stream from source to dest */ function tinf_uncompress(source, dest) {
    var d = new Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = tinf_getbit(d);
        /* read block type (2 bits) */ btype = tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = tinf_inflate_block_data(d, sltree, sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ tinf_decode_trees(d, d.ltree, d.dtree);
                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = TINF_DATA_ERROR;
        }
        if (res !== TINF_OK) throw new Error("Data error");
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === "function") return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ tinf_build_fixed_trees(sltree, sdtree);
/* build extra bits and base tables */ tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);
/* fix a special case */ length_bits[28] = 0;
length_base[28] = 258;
module.exports = tinf_uncompress;

},{}],"97WI2":[function(require,module,exports) {
const isBigEndian = new Uint8Array(new Uint32Array([
    0x12345678
]).buffer)[0] === 0x12;
const swap = (b, n, m)=>{
    let i = b[n];
    b[n] = b[m];
    b[m] = i;
};
const swap32 = (array)=>{
    const len = array.length;
    for(let i = 0; i < len; i += 4){
        swap(array, i, i + 3);
        swap(array, i + 1, i + 2);
    }
};
const swap32LE = (array)=>{
    if (isBigEndian) swap32(array);
};
module.exports = {
    swap32LE: swap32LE
};

},{}],"d51GW":[function(require,module,exports) {
"use strict";
var INITIAL_STATE = 1;
var FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ class StateMachine {
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ match(str) {
        var self = this;
        return {
            *[Symbol.iterator] () {
                var state = INITIAL_STATE;
                var startRun = null;
                var lastAccepting = null;
                var lastState = null;
                for(var p = 0; p < str.length; p++){
                    var c = str[p];
                    lastState = state;
                    state = self.stateTable[state][c];
                    if (state === FAIL_STATE) {
                        // yield the last match if any
                        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                            startRun,
                            lastAccepting,
                            self.tags[lastState]
                        ];
                         // reset the state as if we started over from the initial state
                        state = self.stateTable[INITIAL_STATE][c];
                        startRun = null;
                    } // start a run if not in the failure state
                    if (state !== FAIL_STATE && startRun == null) startRun = p;
                     // if accepting, mark the potential match end
                    if (self.accepting[state]) lastAccepting = p;
                     // reset the state to the initial state if we get into the failure state
                    if (state === FAIL_STATE) state = INITIAL_STATE;
                } // yield the last match if any
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                    startRun,
                    lastAccepting,
                    self.tags[state]
                ];
            }
        };
    }
    /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ apply(str, actions) {
        for (var [start, end, tags] of this.match(str)){
            for (var tag of tags)if (typeof actions[tag] === "function") actions[tag](start, end, str.slice(start, end + 1));
        }
    }
    constructor(dfa){
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
}
module.exports = StateMachine;

},{}],"jxYIZ":[function(require,module,exports) {
var Buffer = require("6a12806bba69ad08").Buffer;
var clone = function() {
    "use strict";
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === "object") {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != "undefined";
        if (typeof circular == "undefined") circular = true;
        if (typeof depth == "undefined") depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != "object") return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == "undefined") {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === "object" && __objToStr(o) === "[object Date]";
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === "object" && __objToStr(o) === "[object Array]";
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === "object" && __objToStr(o) === "[object RegExp]";
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = "";
        if (re.global) flags += "g";
        if (re.ignoreCase) flags += "i";
        if (re.multiline) flags += "m";
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (0, module.exports) module.exports = clone;

},{"6a12806bba69ad08":"cvSE8"}],"k63ZE":[function(require,module,exports) {
module.exports = require("e749e0bd4b2ed991").BrotliDecompressBuffer;

},{"e749e0bd4b2ed991":"3KZRz"}],"3KZRz":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var BrotliInput = require("e78da4f881c045fc").BrotliInput;
var BrotliOutput = require("e78da4f881c045fc").BrotliOutput;
var BrotliBitReader = require("8ead054b5aa5fe7b");
var BrotliDictionary = require("972dabfef886f9ef");
var HuffmanCode = require("3a26f72c03db659e").HuffmanCode;
var BrotliBuildHuffmanTable = require("3a26f72c03db659e").BrotliBuildHuffmanTable;
var Context = require("ec89e1d307370091");
var Prefix = require("b64dbc814ce2ff4a");
var Transform = require("3133426e058893de");
var kDefaultCodeLength = 8;
var kCodeLengthRepeatCode = 16;
var kNumLiteralCodes = 256;
var kNumInsertAndCopyCodes = 704;
var kNumBlockLengthCodes = 26;
var kLiteralContextBits = 6;
var kDistanceContextBits = 2;
var HUFFMAN_TABLE_BITS = 8;
var HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var HUFFMAN_MAX_TABLE_SIZE = 1080;
var CODE_LENGTH_CODES = 18;
var kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var NUM_DISTANCE_SHORT_CODES = 16;
var kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function DecodeMetaBlockLength(br) {
    var out = new MetaBlockLength;
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error("Invalid reserved bit");
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error("Invalid size byte");
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error("Invalid size nibble");
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function ReadSymbol(table, index, br) {
    var start_index = index;
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new HuffmanCode(0, 0));
    BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error("[ReadHuffmanCode] invalid symbols");
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error("[ReadHuffmanCode] invalid symbols");
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error("[ReadHuffmanCode] invalid symbols");
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        var i;
        var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(3, 2),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(4, 1),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(3, 2),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(4, 5)
        ];
        for(i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error("[ReadHuffmanCode] invalid num_codes or space");
        ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = ReadSymbol(table, index, br);
    nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
    return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < NUM_DISTANCE_SHORT_CODES) {
        index += kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
    } else val = code - NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new HuffmanCode(0, 0);
    ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
        var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function BrotliDecompressedSize(buffer) {
    var input = new BrotliInput(buffer);
    var br = new BrotliBitReader(input);
    DecodeWindowBits(br);
    var out = DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
exports.BrotliDecompressedSize = BrotliDecompressedSize;
function BrotliDecompressBuffer(buffer, output_size) {
    var input = new BrotliInput(buffer);
    if (output_size == null) output_size = BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new BrotliOutput(output_buffer);
    BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
function BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new HuffmanTreeGroup(0, 0),
        new HuffmanTreeGroup(0, 0),
        new HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
    br = new BrotliBitReader(input);
    /* Decode window size. */ window_bits = DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new HuffmanCode(0, 0);
        block_len_trees[x] = new HuffmanCode(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = Context.lookupOffsets[context_mode];
        context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = Prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = Context.lookupOffsets[context_mode];
                    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                }
                context = Context.lookup[context_lookup_offset1 + prev_byte1] | Context.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error("[BrotliDecompress] invalid distance");
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= BrotliDictionary.minDictionaryWordLength && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
                    var offset = BrotliDictionary.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = BrotliDictionary.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < Transform.kNumTransforms) {
                        var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
exports.BrotliDecompress = BrotliDecompress;
BrotliDictionary.init();

},{"e78da4f881c045fc":"1Z5Ku","8ead054b5aa5fe7b":"6tDGW","972dabfef886f9ef":"4O0VK","3a26f72c03db659e":"5fljv","ec89e1d307370091":"iwAO4","b64dbc814ce2ff4a":"1p6Bf","3133426e058893de":"a7H5h"}],"1Z5Ku":[function(require,module,exports) {
function BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
exports.BrotliInput = BrotliInput;
function BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error("Output buffer is not large enough");
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
exports.BrotliOutput = BrotliOutput;

},{}],"6tDGW":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var BROTLI_READ_SIZE = 4096;
var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
var kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function BrotliBitReader(input) {
    this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
    this.input_ = input; /* input callback */ 
    this.reset();
}
BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0; /* next input will write here */ 
    this.val_ = 0; /* pre-fetched bits */ 
    this.pos_ = 0; /* byte position in stream */ 
    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
    this.eos_ = 0; /* input stream is finished */ 
    this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error("Unexpected end of input");
        if (bytes_read < BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
module.exports = BrotliBitReader;

},{}],"4O0VK":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var data = require("cc4e303e4d9de88b");
exports.init = function() {
    exports.dictionary = data.init();
};
exports.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
]);
exports.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
]);
exports.minDictionaryWordLength = 4;
exports.maxDictionaryWordLength = 24;

},{"cc4e303e4d9de88b":"j9AQh"}],"j9AQh":[function(require,module,exports) {
var base64 = require("ca5b90775bbb49d4");
/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ exports.init = function() {
    var BrotliDecompressBuffer = require("88e0068b448e70dd").BrotliDecompressBuffer;
    var compressed = base64.toByteArray(require("5f847a6a03eeb1d8"));
    return BrotliDecompressBuffer(compressed);
};

},{"ca5b90775bbb49d4":"MlSYJ","88e0068b448e70dd":"3KZRz","5f847a6a03eeb1d8":"lb2Ya"}],"lb2Ya":[function(require,module,exports) {
module.exports = "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";

},{}],"5fljv":[function(require,module,exports) {
function HuffmanCode(bits, value) {
    this.bits = bits; /* number of bits used for this symbol */ 
    this.value = value; /* symbol value or table offset */ 
}
exports.HuffmanCode = HuffmanCode;
var MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code; /* current table entry */ 
    var len; /* current code length */ 
    var symbol; /* symbol index in original or sorted table */ 
    var key; /* reversed prefix code */ 
    var step; /* step size to replicate values in current table */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low bits */ 
    var table_bits; /* key length of current table */ 
    var table_size; /* size of current table */ 
    var total_size; /* sum of root table size and 2nd level table sizes */ 
    var sorted; /* symbols sorted by code length */ 
    var count = new Int32Array(MAX_LENGTH + 1); /* number of codes of each length */ 
    var offset = new Int32Array(MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
    sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        ReplicateValue(root_table, table + key, step, table_size, code);
        key = GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = GetNextKey(key, len);
    }
    return total_size;
};

},{}],"iwAO4":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ var CONTEXT_LSB6 = 0;
var CONTEXT_MSB6 = 1;
var CONTEXT_UTF8 = 2;
var CONTEXT_SIGNED = 3;
/* Common context lookup table for all context modes. */ exports.lookup = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
exports.lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);

},{}],"1p6Bf":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
exports.kBlockLengthPrefixCode = [
    new PrefixCodeRange(1, 2),
    new PrefixCodeRange(5, 2),
    new PrefixCodeRange(9, 2),
    new PrefixCodeRange(13, 2),
    new PrefixCodeRange(17, 3),
    new PrefixCodeRange(25, 3),
    new PrefixCodeRange(33, 3),
    new PrefixCodeRange(41, 3),
    new PrefixCodeRange(49, 4),
    new PrefixCodeRange(65, 4),
    new PrefixCodeRange(81, 4),
    new PrefixCodeRange(97, 4),
    new PrefixCodeRange(113, 5),
    new PrefixCodeRange(145, 5),
    new PrefixCodeRange(177, 5),
    new PrefixCodeRange(209, 5),
    new PrefixCodeRange(241, 6),
    new PrefixCodeRange(305, 6),
    new PrefixCodeRange(369, 7),
    new PrefixCodeRange(497, 8),
    new PrefixCodeRange(753, 9),
    new PrefixCodeRange(1265, 10),
    new PrefixCodeRange(2289, 11),
    new PrefixCodeRange(4337, 12),
    new PrefixCodeRange(8433, 13),
    new PrefixCodeRange(16625, 24)
];
exports.kInsertLengthPrefixCode = [
    new PrefixCodeRange(0, 0),
    new PrefixCodeRange(1, 0),
    new PrefixCodeRange(2, 0),
    new PrefixCodeRange(3, 0),
    new PrefixCodeRange(4, 0),
    new PrefixCodeRange(5, 0),
    new PrefixCodeRange(6, 1),
    new PrefixCodeRange(8, 1),
    new PrefixCodeRange(10, 2),
    new PrefixCodeRange(14, 2),
    new PrefixCodeRange(18, 3),
    new PrefixCodeRange(26, 3),
    new PrefixCodeRange(34, 4),
    new PrefixCodeRange(50, 4),
    new PrefixCodeRange(66, 5),
    new PrefixCodeRange(98, 5),
    new PrefixCodeRange(130, 6),
    new PrefixCodeRange(194, 7),
    new PrefixCodeRange(322, 8),
    new PrefixCodeRange(578, 9),
    new PrefixCodeRange(1090, 10),
    new PrefixCodeRange(2114, 12),
    new PrefixCodeRange(6210, 14),
    new PrefixCodeRange(22594, 24)
];
exports.kCopyLengthPrefixCode = [
    new PrefixCodeRange(2, 0),
    new PrefixCodeRange(3, 0),
    new PrefixCodeRange(4, 0),
    new PrefixCodeRange(5, 0),
    new PrefixCodeRange(6, 0),
    new PrefixCodeRange(7, 0),
    new PrefixCodeRange(8, 0),
    new PrefixCodeRange(9, 0),
    new PrefixCodeRange(10, 1),
    new PrefixCodeRange(12, 1),
    new PrefixCodeRange(14, 2),
    new PrefixCodeRange(18, 2),
    new PrefixCodeRange(22, 3),
    new PrefixCodeRange(30, 3),
    new PrefixCodeRange(38, 4),
    new PrefixCodeRange(54, 4),
    new PrefixCodeRange(70, 5),
    new PrefixCodeRange(102, 5),
    new PrefixCodeRange(134, 6),
    new PrefixCodeRange(198, 7),
    new PrefixCodeRange(326, 8),
    new PrefixCodeRange(582, 9),
    new PrefixCodeRange(1094, 10),
    new PrefixCodeRange(2118, 24)
];
exports.kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
exports.kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];

},{}],"a7H5h":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var BrotliDictionary = require("45d18961111db3ce");
var kIdentity = 0;
var kOmitLast1 = 1;
var kOmitLast2 = 2;
var kOmitLast3 = 3;
var kOmitLast4 = 4;
var kOmitLast5 = 5;
var kOmitLast6 = 6;
var kOmitLast7 = 7;
var kOmitLast8 = 8;
var kOmitLast9 = 9;
var kUppercaseFirst = 10;
var kUppercaseAll = 11;
var kOmitFirst1 = 12;
var kOmitFirst2 = 13;
var kOmitFirst3 = 14;
var kOmitFirst4 = 15;
var kOmitFirst5 = 16;
var kOmitFirst6 = 17;
var kOmitFirst7 = 18;
var kOmitFirst8 = 19;
var kOmitFirst9 = 20;
function Transform(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var kTransforms = [
    new Transform("", kIdentity, ""),
    new Transform("", kIdentity, " "),
    new Transform(" ", kIdentity, " "),
    new Transform("", kOmitFirst1, ""),
    new Transform("", kUppercaseFirst, " "),
    new Transform("", kIdentity, " the "),
    new Transform(" ", kIdentity, ""),
    new Transform("s ", kIdentity, " "),
    new Transform("", kIdentity, " of "),
    new Transform("", kUppercaseFirst, ""),
    new Transform("", kIdentity, " and "),
    new Transform("", kOmitFirst2, ""),
    new Transform("", kOmitLast1, ""),
    new Transform(", ", kIdentity, " "),
    new Transform("", kIdentity, ", "),
    new Transform(" ", kUppercaseFirst, " "),
    new Transform("", kIdentity, " in "),
    new Transform("", kIdentity, " to "),
    new Transform("e ", kIdentity, " "),
    new Transform("", kIdentity, '"'),
    new Transform("", kIdentity, "."),
    new Transform("", kIdentity, '">'),
    new Transform("", kIdentity, "\n"),
    new Transform("", kOmitLast3, ""),
    new Transform("", kIdentity, "]"),
    new Transform("", kIdentity, " for "),
    new Transform("", kOmitFirst3, ""),
    new Transform("", kOmitLast2, ""),
    new Transform("", kIdentity, " a "),
    new Transform("", kIdentity, " that "),
    new Transform(" ", kUppercaseFirst, ""),
    new Transform("", kIdentity, ". "),
    new Transform(".", kIdentity, ""),
    new Transform(" ", kIdentity, ", "),
    new Transform("", kOmitFirst4, ""),
    new Transform("", kIdentity, " with "),
    new Transform("", kIdentity, "'"),
    new Transform("", kIdentity, " from "),
    new Transform("", kIdentity, " by "),
    new Transform("", kOmitFirst5, ""),
    new Transform("", kOmitFirst6, ""),
    new Transform(" the ", kIdentity, ""),
    new Transform("", kOmitLast4, ""),
    new Transform("", kIdentity, ". The "),
    new Transform("", kUppercaseAll, ""),
    new Transform("", kIdentity, " on "),
    new Transform("", kIdentity, " as "),
    new Transform("", kIdentity, " is "),
    new Transform("", kOmitLast7, ""),
    new Transform("", kOmitLast1, "ing "),
    new Transform("", kIdentity, "\n	"),
    new Transform("", kIdentity, ":"),
    new Transform(" ", kIdentity, ". "),
    new Transform("", kIdentity, "ed "),
    new Transform("", kOmitFirst9, ""),
    new Transform("", kOmitFirst7, ""),
    new Transform("", kOmitLast6, ""),
    new Transform("", kIdentity, "("),
    new Transform("", kUppercaseFirst, ", "),
    new Transform("", kOmitLast8, ""),
    new Transform("", kIdentity, " at "),
    new Transform("", kIdentity, "ly "),
    new Transform(" the ", kIdentity, " of "),
    new Transform("", kOmitLast5, ""),
    new Transform("", kOmitLast9, ""),
    new Transform(" ", kUppercaseFirst, ", "),
    new Transform("", kUppercaseFirst, '"'),
    new Transform(".", kIdentity, "("),
    new Transform("", kUppercaseAll, " "),
    new Transform("", kUppercaseFirst, '">'),
    new Transform("", kIdentity, '="'),
    new Transform(" ", kIdentity, "."),
    new Transform(".com/", kIdentity, ""),
    new Transform(" the ", kIdentity, " of the "),
    new Transform("", kUppercaseFirst, "'"),
    new Transform("", kIdentity, ". This "),
    new Transform("", kIdentity, ","),
    new Transform(".", kIdentity, " "),
    new Transform("", kUppercaseFirst, "("),
    new Transform("", kUppercaseFirst, "."),
    new Transform("", kIdentity, " not "),
    new Transform(" ", kIdentity, '="'),
    new Transform("", kIdentity, "er "),
    new Transform(" ", kUppercaseAll, " "),
    new Transform("", kIdentity, "al "),
    new Transform(" ", kUppercaseAll, ""),
    new Transform("", kIdentity, "='"),
    new Transform("", kUppercaseAll, '"'),
    new Transform("", kUppercaseFirst, ". "),
    new Transform(" ", kIdentity, "("),
    new Transform("", kIdentity, "ful "),
    new Transform(" ", kUppercaseFirst, ". "),
    new Transform("", kIdentity, "ive "),
    new Transform("", kIdentity, "less "),
    new Transform("", kUppercaseAll, "'"),
    new Transform("", kIdentity, "est "),
    new Transform(" ", kUppercaseFirst, "."),
    new Transform("", kUppercaseAll, '">'),
    new Transform(" ", kIdentity, "='"),
    new Transform("", kUppercaseFirst, ","),
    new Transform("", kIdentity, "ize "),
    new Transform("", kUppercaseAll, "."),
    new Transform("\xc2\xa0", kIdentity, ""),
    new Transform(" ", kIdentity, ","),
    new Transform("", kUppercaseFirst, '="'),
    new Transform("", kUppercaseAll, '="'),
    new Transform("", kIdentity, "ous "),
    new Transform("", kUppercaseAll, ", "),
    new Transform("", kUppercaseFirst, "='"),
    new Transform(" ", kUppercaseFirst, ","),
    new Transform(" ", kUppercaseAll, '="'),
    new Transform(" ", kUppercaseAll, ", "),
    new Transform("", kUppercaseAll, ","),
    new Transform("", kUppercaseAll, "("),
    new Transform("", kUppercaseAll, ". "),
    new Transform(" ", kUppercaseAll, "."),
    new Transform("", kUppercaseAll, "='"),
    new Transform(" ", kUppercaseAll, ". "),
    new Transform(" ", kUppercaseFirst, '="'),
    new Transform(" ", kUppercaseAll, "='"),
    new Transform(" ", kUppercaseFirst, "='")
];
exports.kTransforms = kTransforms;
exports.kNumTransforms = kTransforms.length;
function ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
    var prefix = kTransforms[transform].prefix;
    var suffix = kTransforms[transform].suffix;
    var t = kTransforms[transform].transform;
    var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = BrotliDictionary.dictionary[word + i];
    uppercase = idx - len;
    if (t === kUppercaseFirst) ToUpperCase(dst, uppercase);
    else if (t === kUppercaseAll) while(len > 0){
        var step = ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};

},{"45d18961111db3ce":"4O0VK"}],"76x2x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>render);
var _primitives = require("@react-pdf/primitives");
var _fns = require("@react-pdf/fns");
var _absSvgPath = require("abs-svg-path");
var _absSvgPathDefault = parcelHelpers.interopDefault(_absSvgPath);
var _parseSvgPath = require("parse-svg-path");
var _parseSvgPathDefault = parcelHelpers.interopDefault(_parseSvgPath);
var _normalizeSvgPath = require("normalize-svg-path");
var _normalizeSvgPathDefault = parcelHelpers.interopDefault(_normalizeSvgPath);
var _colorString = require("color-string");
var _colorStringDefault = parcelHelpers.interopDefault(_colorString);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var renderPath = function renderPath(ctx, node) {
    var _node$props;
    var d = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.d;
    if (d) ctx.path(node.props.d);
};
var KAPPA$3 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var renderRect = function renderRect(ctx, node) {
    var _node$props, _node$props2, _node$props3, _node$props4, _node$props5, _node$props6;
    var x = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.x) || 0;
    var y = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.y) || 0;
    var rx = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.rx) || 0;
    var ry = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.ry) || 0;
    var width = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.width) || 0;
    var height = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.height) || 0;
    if (!width || !height) return;
    if (rx && ry) {
        var krx = rx * KAPPA$3;
        var kry = ry * KAPPA$3;
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x - rx + width, y);
        ctx.bezierCurveTo(x - rx + width + krx, y, x + width, y + ry - kry, x + width, y + ry);
        ctx.lineTo(x + width, y + height - ry);
        ctx.bezierCurveTo(x + width, y + height - ry + kry, x - rx + width + krx, y + height, x - rx + width, y + height);
        ctx.lineTo(x + rx, y + height);
        ctx.bezierCurveTo(x + rx - krx, y + height, x, y + height - ry + kry, x, y + height - ry);
        ctx.lineTo(x, y + ry);
        ctx.bezierCurveTo(x, y + ry - kry, x + rx - krx, y, x + rx, y);
    } else {
        ctx.moveTo(x, y);
        ctx.lineTo(x + width, y);
        ctx.lineTo(x + width, y + height);
        ctx.lineTo(x, y + height);
    }
    ctx.closePath();
};
var renderLine$1 = function renderLine(ctx, node) {
    var _ref = node.props || {}, x1 = _ref.x1, x2 = _ref.x2, y1 = _ref.y1, y2 = _ref.y2;
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
};
var renderGroup = function renderGroup() {
// noop
};
var KAPPA$2 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var drawEllipse = function drawEllipse(ctx, cx, cy, rx, ry) {
    if (cx === void 0) cx = 0;
    if (cy === void 0) cy = 0;
    var x = cx - rx;
    var y = cy - ry;
    var ox = rx * KAPPA$2;
    var oy = ry * KAPPA$2;
    var xe = x + rx * 2;
    var ye = y + ry * 2;
    var xm = x + rx;
    var ym = y + ry;
    ctx.moveTo(x, ym);
    ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    ctx.closePath();
};
var renderEllipse = function renderEllipse(ctx, node) {
    var _ref = node.props || {}, cx = _ref.cx, cy = _ref.cy, rx = _ref.rx, ry = _ref.ry;
    drawEllipse(ctx, cx, cy, rx, ry);
};
var renderCircle = function renderCircle(ctx, node) {
    var _node$props, _node$props2, _node$props3;
    var cx = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.cx;
    var cy = (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.cy;
    var r = (_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.r;
    drawEllipse(ctx, cx, cy, r, r);
};
var renderGlyphs = function renderGlyphs(ctx, glyphs, positions, x, y, options) {
    if (options === void 0) options = {};
    var scale = 1000 / ctx._fontSize;
    var unitsPerEm = ctx._font.font.unitsPerEm || 1000;
    var advanceWidthScale = 1000 / unitsPerEm;
    // Glyph encoding and positioning
    var encodedGlyphs = ctx._font.encodeGlyphs(glyphs);
    var encodedPositions = positions.map(function(pos, i) {
        return {
            xAdvance: pos.xAdvance * scale,
            yAdvance: pos.yAdvance * scale,
            xOffset: pos.xOffset,
            yOffset: pos.yOffset,
            advanceWidth: glyphs[i].advanceWidth * advanceWidthScale
        };
    });
    return ctx._glyphs(encodedGlyphs, encodedPositions, x, y, options);
};
var renderRun$1 = function renderRun(ctx, run) {
    var runAdvanceWidth = run.xAdvance;
    var _run$attributes = run.attributes, font = _run$attributes.font, fontSize = _run$attributes.fontSize, color = _run$attributes.color, opacity = _run$attributes.opacity;
    ctx.fillColor(color);
    ctx.fillOpacity(opacity);
    if (font.sbix || font.COLR && font.CPAL) {
        ctx.save();
        ctx.translate(0, -run.ascent);
        for(var i = 0; i < run.glyphs.length; i += 1){
            var position = run.positions[i];
            var glyph = run.glyphs[i];
            ctx.save();
            ctx.translate(position.xOffset, position.yOffset);
            glyph.render(ctx, fontSize);
            ctx.restore();
            ctx.translate(position.xAdvance, position.yAdvance);
        }
        ctx.restore();
    } else {
        ctx.font(typeof font.name === "string" ? font.name : font, fontSize);
        try {
            renderGlyphs(ctx, run.glyphs, run.positions, 0, 0);
        } catch (error) {
            console.log(error);
        }
    }
    ctx.translate(runAdvanceWidth, 0);
};
var renderSpan = function renderSpan(ctx, line, textAnchor, dominantBaseline) {
    var _line$box, _line$box2, _line$runs$, _line$runs$2, _line$runs$2$attribut;
    ctx.save();
    var x = ((_line$box = line.box) === null || _line$box === void 0 ? void 0 : _line$box.x) || 0;
    var y = ((_line$box2 = line.box) === null || _line$box2 === void 0 ? void 0 : _line$box2.y) || 0;
    var font = (_line$runs$ = line.runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes.font;
    var scale = ((_line$runs$2 = line.runs[0]) === null || _line$runs$2 === void 0 ? void 0 : (_line$runs$2$attribut = _line$runs$2.attributes) === null || _line$runs$2$attribut === void 0 ? void 0 : _line$runs$2$attribut.scale) || 1;
    var width = line.xAdvance;
    var ascent = font.ascent * scale;
    var xHeight = font.xHeight * scale;
    var descent = font.descent * scale;
    var capHeight = font.capHeight * scale;
    var xTranslate = x;
    var yTranslate = y;
    switch(textAnchor){
        case "middle":
            xTranslate = x - width / 2;
            break;
        case "end":
            xTranslate = x - width;
            break;
        default:
            xTranslate = x;
            break;
    }
    switch(dominantBaseline){
        case "middle":
        case "central":
            yTranslate = y + capHeight / 2;
            break;
        case "hanging":
            yTranslate = y + capHeight;
            break;
        case "mathematical":
            yTranslate = y + xHeight;
            break;
        case "text-after-edge":
            yTranslate = y + descent;
            break;
        case "text-before-edge":
            yTranslate = y + ascent;
            break;
        default:
            yTranslate = y;
            break;
    }
    ctx.translate(xTranslate, yTranslate);
    line.runs.forEach(function(run) {
        return renderRun$1(ctx, run);
    });
    ctx.restore();
};
var renderSvgText = function renderSvgText(ctx, node) {
    node.children.forEach(function(span) {
        return renderSpan(ctx, span.lines[0], span.props.textAnchor, span.props.dominantBaseline);
    });
};
/**
 * Create pairs from array
 *
 * @template T
 * @param {T[]} values array
 * @returns {T[][]} pairs
 */ var pairs = function pairs(values) {
    var result = [];
    for(var i = 0; i < values.length; i += 2)result.push([
        values[i],
        values[i + 1]
    ]);
    return result;
};
/**
 * Parse svg-like points into number arrays
 *
 * @param {string} points string ex. "20,30 50,60"
 * @returns {number[][]} points array ex. [[20, 30], [50, 60]]
 */ var parsePoints = function parsePoints(points) {
    var values = (points || "").trim().replace(/,/g, " ").replace(/(\d)-(\d)/g, "$1 -$2").split(/\s+/);
    if (values.length % 2 !== 0) values = values.slice(0, -1);
    var mappedValues = values.map(parseFloat);
    return pairs(mappedValues);
};
var drawPolyline = function drawPolyline(ctx, points) {
    if (points.length > 0) {
        ctx.moveTo(points[0][0], points[0][1]);
        points.slice(1).forEach(function(p) {
            return ctx.lineTo(p[0], p[1]);
        });
    }
};
var renderPolyline = function renderPolyline(ctx, node) {
    var points = parsePoints(node.props.points || "");
    drawPolyline(ctx, points);
};
var renderPolygon = function renderPolygon(ctx, node) {
    renderPolyline(ctx, node);
    ctx.closePath();
};
var renderImage$1 = function renderImage(ctx, node) {
    if (!node.image.data) return;
    var _node$props = node.props, x = _node$props.x, y = _node$props.y;
    var _node$style = node.style, width = _node$style.width, height = _node$style.height, opacity = _node$style.opacity;
    var paddingTop = node.box.paddingLeft || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    if (width === 0 || height === 0) {
        console.warn("Image with src '" + node.props.href + "' skipped due to invalid dimensions");
        return;
    }
    ctx.save();
    ctx.fillOpacity(opacity || 1).image(node.image.data, x + paddingLeft, y + paddingTop, {
        width: width,
        height: height
    });
    ctx.restore();
};
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA$1 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var clipNode = function clipNode(ctx, node) {
    if (!node.style) return;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var _node$style = node.style, _node$style$borderTop = _node$style.borderTopLeftRadius, borderTopLeftRadius = _node$style$borderTop === void 0 ? 0 : _node$style$borderTop, _node$style$borderTop2 = _node$style.borderTopRightRadius, borderTopRightRadius = _node$style$borderTop2 === void 0 ? 0 : _node$style$borderTop2, _node$style$borderBot = _node$style.borderBottomRightRadius, borderBottomRightRadius = _node$style$borderBot === void 0 ? 0 : _node$style$borderBot, _node$style$borderBot2 = _node$style.borderBottomLeftRadius, borderBottomLeftRadius = _node$style$borderBot2 === void 0 ? 0 : _node$style$borderBot2;
    // Border top
    var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
    var ctr = rtr * (1.0 - KAPPA$1);
    ctx.moveTo(left + rtr, top);
    ctx.lineTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - ctr, top, left + width, top + ctr, left + width, top + rtr);
    // Border right
    var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
    var cbr = rbr * (1.0 - KAPPA$1);
    ctx.lineTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - cbr, left + width - cbr, top + height, left + width - rbr, top + height);
    // Border bottom
    var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
    var cbl = rbl * (1.0 - KAPPA$1);
    ctx.lineTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + cbl, top + height, left, top + height - cbl, left, top + height - rbl);
    // Border left
    var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
    var ctl = rtl * (1.0 - KAPPA$1);
    ctx.lineTo(left, top + rtl);
    ctx.bezierCurveTo(left, top + ctl, left + ctl, top, left + rtl, top);
    ctx.closePath();
    ctx.clip();
};
var applySingleTransformation = function applySingleTransformation(ctx, transform, origin) {
    var operation = transform.operation, value = transform.value;
    switch(operation){
        case "scale":
            var scaleX = value[0], scaleY = value[1];
            ctx.scale(scaleX, scaleY, {
                origin: origin
            });
            break;
        case "rotate":
            var angle = value[0];
            ctx.rotate(angle, {
                origin: origin
            });
            break;
        case "translate":
            var x = value[0], _value$ = value[1], y = _value$ === void 0 ? 0 : _value$;
            ctx.translate(x, y, {
                origin: origin
            });
            break;
        case "skew":
            var xAngle = value[0], yAngle = value[1];
            ctx.skew(xAngle, yAngle, {
                origin: origin
            });
            break;
        case "matrix":
            ctx.transform.apply(ctx, value);
            break;
        default:
            console.error("Transform operation: '" + operation + "' doesn't supported");
    }
};
var applyTransformations = function applyTransformations(ctx, node) {
    var _node$style, _node$props;
    if (!node.origin) return;
    var origin = [
        node.origin.left,
        node.origin.top
    ];
    var operations = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.transform) || ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.transform) || [];
    operations.forEach(function(operation) {
        applySingleTransformation(ctx, operation, origin);
    });
};
var _boundingBoxFns;
// From https://github.com/dy/svg-path-bounds/blob/master/index.js
var getPathBoundingBox = function getPathBoundingBox(node) {
    var _node$props;
    var path = (0, _normalizeSvgPathDefault.default)((0, _absSvgPathDefault.default)((0, _parseSvgPathDefault.default)(((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.d) || "")));
    if (!path.length) return [
        0,
        0,
        0,
        0
    ];
    var bounds = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    for(var i = 0, l = path.length; i < l; i += 1){
        var points = path[i].slice(1);
        for(var j = 0; j < points.length; j += 2){
            if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0];
            if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1];
            if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0];
            if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1];
        }
    }
    return bounds;
};
var getCircleBoundingBox = function getCircleBoundingBox(node) {
    var _node$props2, _node$props3, _node$props4;
    var r = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.r) || 0;
    var cx = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.cx) || 0;
    var cy = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.cy) || 0;
    return [
        cx - r,
        cy - r,
        cx + r,
        cy + r
    ];
};
var getEllipseBoundingBox = function getEllipseBoundingBox(node) {
    var _node$props5, _node$props6, _node$props7, _node$props8;
    var cx = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.cx) || 0;
    var cy = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.cy) || 0;
    var rx = ((_node$props7 = node.props) === null || _node$props7 === void 0 ? void 0 : _node$props7.rx) || 0;
    var ry = ((_node$props8 = node.props) === null || _node$props8 === void 0 ? void 0 : _node$props8.ry) || 0;
    return [
        cx - rx,
        cy - ry,
        cx + rx,
        cy + ry
    ];
};
var getLineBoundingBox = function getLineBoundingBox(node) {
    var _node$props9, _node$props10, _node$props11, _node$props12;
    var x1 = ((_node$props9 = node.props) === null || _node$props9 === void 0 ? void 0 : _node$props9.x1) || 0;
    var y1 = ((_node$props10 = node.props) === null || _node$props10 === void 0 ? void 0 : _node$props10.y1) || 0;
    var x2 = ((_node$props11 = node.props) === null || _node$props11 === void 0 ? void 0 : _node$props11.x2) || 0;
    var y2 = ((_node$props12 = node.props) === null || _node$props12 === void 0 ? void 0 : _node$props12.y2) || 0;
    return [
        Math.min(x1, x2),
        Math.min(y1, y2),
        Math.max(x1, x2),
        Math.max(y1, y2)
    ];
};
var getRectBoundingBox = function getRectBoundingBox(node) {
    var _node$props13, _node$props14, _node$props15, _node$props16;
    var x = ((_node$props13 = node.props) === null || _node$props13 === void 0 ? void 0 : _node$props13.x) || 0;
    var y = ((_node$props14 = node.props) === null || _node$props14 === void 0 ? void 0 : _node$props14.y) || 0;
    var width = ((_node$props15 = node.props) === null || _node$props15 === void 0 ? void 0 : _node$props15.width) || 0;
    var height = ((_node$props16 = node.props) === null || _node$props16 === void 0 ? void 0 : _node$props16.height) || 0;
    return [
        x,
        y,
        x + width,
        y + height
    ];
};
var max = function max(values) {
    return Math.max.apply(Math, [
        -Infinity
    ].concat(values));
};
var min = function min(values) {
    return Math.min.apply(Math, [
        Infinity
    ].concat(values));
};
var getPolylineBoundingBox = function getPolylineBoundingBox(node) {
    var _node$props17;
    var points = parsePoints(((_node$props17 = node.props) === null || _node$props17 === void 0 ? void 0 : _node$props17.points) || []);
    var xValues = points.map(function(p) {
        return p[0];
    });
    var yValues = points.map(function(p) {
        return p[1];
    });
    return [
        min(xValues),
        min(yValues),
        max(xValues),
        max(yValues)
    ];
};
var boundingBoxFns = (_boundingBoxFns = {}, _boundingBoxFns[_primitives.Rect] = getRectBoundingBox, _boundingBoxFns[_primitives.Line] = getLineBoundingBox, _boundingBoxFns[_primitives.Path] = getPathBoundingBox, _boundingBoxFns[_primitives.Circle] = getCircleBoundingBox, _boundingBoxFns[_primitives.Ellipse] = getEllipseBoundingBox, _boundingBoxFns[_primitives.Polygon] = getPolylineBoundingBox, _boundingBoxFns[_primitives.Polyline] = getPolylineBoundingBox, _boundingBoxFns);
var getBoundingBox = function getBoundingBox(node) {
    var boundingBoxFn = boundingBoxFns[node.type];
    return boundingBoxFn ? boundingBoxFn(node) : [
        0,
        0,
        0,
        0
    ];
};
var _renderFns$1;
var setStrokeWidth = function setStrokeWidth(ctx, node) {
    var _node$props;
    var lineWidth = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.strokeWidth) || 0;
    if (lineWidth) ctx.lineWidth(lineWidth);
};
var setStrokeColor = function setStrokeColor(ctx, node) {
    var _node$props2;
    var strokeColor = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.stroke) || null;
    if (strokeColor) ctx.strokeColor(strokeColor);
};
var setOpacity = function setOpacity(ctx, node) {
    var _node$props3;
    var opacity = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.opacity) || null;
    if (!(0, _fns.isNil)(opacity)) ctx.opacity(opacity);
};
var setFillOpacity = function setFillOpacity(ctx, node) {
    var _node$props4;
    var fillOpacity = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.fillOpacity) || null;
    if (!(0, _fns.isNil)(fillOpacity)) ctx.fillOpacity(fillOpacity);
};
var setStrokeOpacity = function setStrokeOpacity(ctx, node) {
    var _node$props5;
    var strokeOpacity = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.strokeOpacity) || null;
    if (!(0, _fns.isNil)(strokeOpacity)) ctx.strokeOpacity(strokeOpacity);
};
var setLineJoin = function setLineJoin(ctx, node) {
    var _node$props6;
    var lineJoin = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.strokeLinejoin) || null;
    if (lineJoin) ctx.lineJoin(lineJoin);
};
var setLineCap = function setLineCap(ctx, node) {
    var _node$props7;
    var lineCap = ((_node$props7 = node.props) === null || _node$props7 === void 0 ? void 0 : _node$props7.strokeLinecap) || null;
    if (lineCap) ctx.lineCap(lineCap);
};
var setLineDash = function setLineDash(ctx, node) {
    var _node$props8;
    var value = ((_node$props8 = node.props) === null || _node$props8 === void 0 ? void 0 : _node$props8.strokeDasharray) || null;
    if (value) ctx.dash(value.split(",").map(Number));
};
var hasLinearGradientFill = function hasLinearGradientFill(node) {
    var _node$props9, _node$props9$fill;
    return ((_node$props9 = node.props) === null || _node$props9 === void 0 ? void 0 : (_node$props9$fill = _node$props9.fill) === null || _node$props9$fill === void 0 ? void 0 : _node$props9$fill.type) === _primitives.LinearGradient;
};
var hasRadialGradientFill = function hasRadialGradientFill(node) {
    var _node$props10, _node$props10$fill;
    return ((_node$props10 = node.props) === null || _node$props10 === void 0 ? void 0 : (_node$props10$fill = _node$props10.fill) === null || _node$props10$fill === void 0 ? void 0 : _node$props10$fill.type) === _primitives.RadialGradient;
};
// Math simplified from https://github.com/devongovett/svgkit/blob/master/src/elements/SVGGradient.js#L104
var setLinearGradientFill = function setLinearGradientFill(ctx, node) {
    var _node$props11;
    var bbox = getBoundingBox(node);
    var gradient = ((_node$props11 = node.props) === null || _node$props11 === void 0 ? void 0 : _node$props11.fill) || null;
    var x1 = gradient.props.x1 || 0;
    var y1 = gradient.props.y1 || 0;
    var x2 = gradient.props.x2 || 1;
    var y2 = gradient.props.y2 || 0;
    var m0 = bbox[2] - bbox[0];
    var m3 = bbox[3] - bbox[1];
    var m4 = bbox[0];
    var m5 = bbox[1];
    var gx1 = m0 * x1 + m4;
    var gy1 = m3 * y1 + m5;
    var gx2 = m0 * x2 + m4;
    var gy2 = m3 * y2 + m5;
    var grad = ctx.linearGradient(gx1, gy1, gx2, gy2);
    gradient.children.forEach(function(stop) {
        grad.stop(stop.props.offset, stop.props.stopColor, stop.props.stopOpacity);
    });
    ctx.fill(grad);
};
// Math simplified from https://github.com/devongovett/svgkit/blob/master/src/elements/SVGGradient.js#L155
var setRadialGradientFill = function setRadialGradientFill(ctx, node) {
    var _node$props12;
    var bbox = getBoundingBox(node);
    var gradient = ((_node$props12 = node.props) === null || _node$props12 === void 0 ? void 0 : _node$props12.fill) || null;
    var cx = gradient.props.cx || 0.5;
    var cy = gradient.props.cy || 0.5;
    var fx = gradient.props.fx || cx;
    var fy = gradient.props.fy || cy;
    var r = gradient.props.r || 0.5;
    var m0 = bbox[2] - bbox[0];
    var m3 = bbox[3] - bbox[1];
    var m4 = bbox[0];
    var m5 = bbox[1];
    var gr = r * m0;
    var gcx = m0 * cx + m4;
    var gcy = m3 * cy + m5;
    var gfx = m0 * fx + m4;
    var gfy = m3 * fy + m5;
    var grad = ctx.radialGradient(gfx, gfy, 0, gcx, gcy, gr);
    gradient.children.forEach(function(stop) {
        grad.stop(stop.props.offset, stop.props.stopColor, stop.props.stopOpacity);
    });
    ctx.fill(grad);
};
var setFillColor = function setFillColor(ctx, node) {
    var _node$props13;
    var fillColor = ((_node$props13 = node.props) === null || _node$props13 === void 0 ? void 0 : _node$props13.fill) || null;
    if (fillColor) ctx.fillColor(fillColor);
};
var setFill = function setFill(ctx, node) {
    if (hasLinearGradientFill(node)) return setLinearGradientFill(ctx, node);
    if (hasRadialGradientFill(node)) return setRadialGradientFill(ctx, node);
    return setFillColor(ctx, node);
};
var draw = function draw(ctx, node) {
    var props = node.props || {};
    if (props.fill && props.stroke) ctx.fillAndStroke(props.fillRule);
    else if (props.fill) ctx.fill(props.fillRule);
    else if (props.stroke) ctx.stroke();
    else {
        ctx.save();
        ctx.opacity(0);
        ctx.fill(null);
        ctx.restore();
    }
};
var noop = function noop() {};
var renderFns$1 = (_renderFns$1 = {}, _renderFns$1[_primitives.Tspan] = noop, _renderFns$1[_primitives.TextInstance] = noop, _renderFns$1[_primitives.Path] = renderPath, _renderFns$1[_primitives.Rect] = renderRect, _renderFns$1[_primitives.Line] = renderLine$1, _renderFns$1[_primitives.G] = renderGroup, _renderFns$1[_primitives.Text] = renderSvgText, _renderFns$1[_primitives.Circle] = renderCircle, _renderFns$1[_primitives.Image] = renderImage$1, _renderFns$1[_primitives.Ellipse] = renderEllipse, _renderFns$1[_primitives.Polygon] = renderPolygon, _renderFns$1[_primitives.Polyline] = renderPolyline, _renderFns$1);
var renderNode$1 = function renderNode(ctx, node) {
    var renderFn = renderFns$1[node.type];
    if (renderFns$1) renderFn(ctx, node);
    else console.warn("SVG node of type " + node.type + " is not currenty supported");
};
var drawNode = function drawNode(ctx, node) {
    setLineCap(ctx, node);
    setLineDash(ctx, node);
    setLineJoin(ctx, node);
    setStrokeWidth(ctx, node);
    setStrokeColor(ctx, node);
    setFill(ctx, node);
    setStrokeOpacity(ctx, node);
    setFillOpacity(ctx, node);
    setOpacity(ctx, node);
    applyTransformations(ctx, node);
    renderNode$1(ctx, node);
    draw(ctx, node);
};
var clipPath = function clipPath(ctx, node) {
    var _node$props14;
    var value = (_node$props14 = node.props) === null || _node$props14 === void 0 ? void 0 : _node$props14.clipPath;
    if (value) {
        var children = value.children || [];
        children.forEach(function(child) {
            return renderNode$1(ctx, child);
        });
        ctx.clip();
    }
};
var drawChildren = function drawChildren(ctx, node) {
    var children = node.children || [];
    children.forEach(function(child) {
        ctx.save();
        clipPath(ctx, child);
        drawNode(ctx, child);
        drawChildren(ctx, child);
        ctx.restore();
    });
};
var resolveAspectRatio = function resolveAspectRatio(ctx, node) {
    var _node$box = node.box, width = _node$box.width, height = _node$box.height;
    var _node$props15 = node.props, viewBox = _node$props15.viewBox, _node$props15$preserv = _node$props15.preserveAspectRatio, preserveAspectRatio = _node$props15$preserv === void 0 ? {} : _node$props15$preserv;
    var _preserveAspectRatio$ = preserveAspectRatio.meetOrSlice, meetOrSlice = _preserveAspectRatio$ === void 0 ? "meet" : _preserveAspectRatio$, _preserveAspectRatio$2 = preserveAspectRatio.align, align = _preserveAspectRatio$2 === void 0 ? "xMidYMid" : _preserveAspectRatio$2;
    if (viewBox == null || width == null || height == null) return;
    var x = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.minX) || 0;
    var y = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.minY) || 0;
    var logicalWidth = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.maxX) || width;
    var logicalHeight = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.maxY) || height;
    var logicalRatio = logicalWidth / logicalHeight;
    var physicalRatio = width / height;
    var scaleX = width / logicalWidth;
    var scaleY = height / logicalHeight;
    if (align === "none") {
        ctx.scale(scaleX, scaleY);
        ctx.translate(-x, -y);
        return;
    }
    if (logicalRatio < physicalRatio && meetOrSlice === "meet" || logicalRatio >= physicalRatio && meetOrSlice === "slice") {
        ctx.scale(scaleY, scaleY);
        switch(align){
            case "xMinYMin":
            case "xMinYMid":
            case "xMinYMax":
                ctx.translate(-x, -y);
                break;
            case "xMidYMin":
            case "xMidYMid":
            case "xMidYMax":
                ctx.translate(-x - (logicalWidth - width * logicalHeight / height) / 2, -y);
                break;
            default:
                ctx.translate(-x - (logicalWidth - width * logicalHeight / height), -y);
        }
    } else {
        ctx.scale(scaleX, scaleX);
        switch(align){
            case "xMinYMin":
            case "xMidYMin":
            case "xMaxYMin":
                ctx.translate(-x, -y);
                break;
            case "xMinYMid":
            case "xMidYMid":
            case "xMaxYMid":
                ctx.translate(-x, -y - (logicalHeight - height * logicalWidth / width) / 2);
                break;
            default:
                ctx.translate(-x, -y - (logicalHeight - height * logicalWidth / width));
        }
    }
};
var moveToOrigin = function moveToOrigin(ctx, node) {
    var _node$box2 = node.box, top = _node$box2.top, left = _node$box2.left;
    var paddingLeft = node.box.paddingLeft || 0;
    var paddingTop = node.box.paddingTop || 0;
    ctx.translate(left + paddingLeft, top + paddingTop);
};
var renderSvg = function renderSvg(ctx, node) {
    ctx.save();
    clipNode(ctx, node);
    moveToOrigin(ctx, node);
    resolveAspectRatio(ctx, node);
    drawChildren(ctx, node);
    ctx.restore();
};
var black = {
    value: [
        0,
        0,
        0
    ],
    opacity: 1
};
var parseColor = function parseColor(hex) {
    var parsed = (0, _colorStringDefault.default).get(hex);
    if (!parsed) return black;
    var value = (0, _colorStringDefault.default).to.hex(parsed.value.slice(0, 3));
    var opacity = parsed.value[3];
    return {
        value: value,
        opacity: opacity
    };
};
/* eslint-disable no-param-reassign */ var DEST_REGEXP = /^#.+/;
var isSrcId$1 = function isSrcId(src) {
    return src.match(DEST_REGEXP);
};
var renderAttachment = function renderAttachment(ctx, attachment) {
    var _attachment$xOffset = attachment.xOffset, xOffset = _attachment$xOffset === void 0 ? 0 : _attachment$xOffset, _attachment$yOffset = attachment.yOffset, yOffset = _attachment$yOffset === void 0 ? 0 : _attachment$yOffset, width = attachment.width, height = attachment.height, image = attachment.image;
    ctx.translate(-width + xOffset, -height + yOffset);
    ctx.image(image, 0, 0, {
        fit: [
            width,
            height
        ],
        align: "center",
        valign: "bottom"
    });
};
var renderAttachments = function renderAttachments(ctx, run) {
    ctx.save();
    var font = run.attributes.font;
    var space = font.glyphForCodePoint(0x20);
    var objectReplacement = font.glyphForCodePoint(0xfffc);
    var attachmentAdvance = 0;
    for(var i = 0; i < run.glyphs.length; i += 1){
        var position = run.positions[i];
        var glyph = run.glyphs[i];
        attachmentAdvance += position.xAdvance || 0;
        if (glyph.id === objectReplacement.id && run.attributes.attachment) {
            ctx.translate(attachmentAdvance, position.yOffset || 0);
            renderAttachment(ctx, run.attributes.attachment);
            run.glyphs[i] = space;
            attachmentAdvance = 0;
        }
    }
    ctx.restore();
};
var renderRun = function renderRun(ctx, run, options) {
    var _run$attributes = run.attributes, font = _run$attributes.font, fontSize = _run$attributes.fontSize, link = _run$attributes.link;
    var color = parseColor(run.attributes.color);
    var opacity = (0, _fns.isNil)(run.attributes.opacity) ? color.opacity : run.attributes.opacity;
    var height = run.height, descent = run.descent, xAdvance = run.xAdvance;
    if (options.outlineRuns) ctx.rect(0, -height, xAdvance, height).stroke();
    ctx.fillColor(color.value);
    ctx.fillOpacity(opacity);
    if (link) {
        if (isSrcId$1(link)) ctx.goTo(0, -height - descent, xAdvance, height, link.slice(1));
        else ctx.link(0, -height - descent, xAdvance, height, link);
    }
    renderAttachments(ctx, run);
    if (font.sbix || font.COLR && font.CPAL) {
        ctx.save();
        ctx.translate(0, -run.ascent);
        for(var i = 0; i < run.glyphs.length; i += 1){
            var position = run.positions[i];
            var glyph = run.glyphs[i];
            ctx.save();
            ctx.translate(position.xOffset, position.yOffset);
            glyph.render(ctx, fontSize);
            ctx.restore();
            ctx.translate(position.xAdvance, position.yAdvance);
        }
        ctx.restore();
    } else {
        ctx.font(typeof font.name === "string" ? font.name : font, fontSize);
        try {
            renderGlyphs(ctx, run.glyphs, run.positions, 0, 0);
        } catch (error) {
            console.log(error);
        }
    }
    ctx.translate(xAdvance, 0);
};
var renderBackground$1 = function renderBackground(ctx, rect, backgroundColor) {
    var color = parseColor(backgroundColor);
    ctx.save();
    ctx.fillOpacity(color.opacity);
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.fill(color.value);
    ctx.restore();
};
var renderDecorationLine = function renderDecorationLine(ctx, line) {
    ctx.save();
    ctx.lineWidth(line.rect.height);
    ctx.strokeOpacity(line.opacity);
    if (/dashed/.test(line.style)) ctx.dash(3 * line.rect.height);
    else if (/dotted/.test(line.style)) ctx.dash(line.rect.height);
    if (/wavy/.test(line.style)) {
        var dist = Math.max(2, line.rect.height);
        var step = 1.1 * dist;
        var stepCount = Math.floor(line.rect.width / (2 * step));
        // Adjust step to fill entire width
        var remainingWidth = line.rect.width - stepCount * 2 * step;
        var adjustment = remainingWidth / stepCount / 2;
        step += adjustment;
        var cp1y = line.rect.y + dist;
        var cp2y = line.rect.y - dist;
        var x = line.rect.x;
        ctx.moveTo(line.rect.x, line.rect.y);
        for(var i = 0; i < stepCount; i += 1){
            ctx.bezierCurveTo(x + step, cp1y, x + step, cp2y, x + 2 * step, line.rect.y);
            x += 2 * step;
        }
    } else {
        ctx.moveTo(line.rect.x, line.rect.y);
        ctx.lineTo(line.rect.x + line.rect.width, line.rect.y);
        if (/double/.test(line.style)) {
            ctx.moveTo(line.rect.x, line.rect.y + line.rect.height * 2);
            ctx.lineTo(line.rect.x + line.rect.width, line.rect.y + line.rect.height * 2);
        }
    }
    ctx.stroke(line.color);
    ctx.restore();
};
var renderLine = function renderLine(ctx, line, options) {
    var lineAscent = line.ascent;
    if (options.outlineLines) ctx.rect(line.box.x, line.box.y, line.box.width, line.box.height).stroke();
    ctx.save();
    ctx.translate(line.box.x, line.box.y + lineAscent);
    for(var i = 0; i < line.runs.length; i += 1){
        var run = line.runs[i];
        var isLastRun = i === line.runs.length - 1;
        if (run.attributes.backgroundColor) {
            var overflowRight = isLastRun ? line.overflowRight : 0;
            var backgroundRect = {
                x: 0,
                y: -lineAscent,
                height: line.box.height,
                width: run.xAdvance - overflowRight
            };
            renderBackground$1(ctx, backgroundRect, run.attributes.backgroundColor);
        }
        renderRun(ctx, run, options);
    }
    ctx.restore();
    ctx.save();
    ctx.translate(line.box.x, line.box.y);
    for(var _i = 0; _i < line.decorationLines.length; _i += 1){
        var decorationLine = line.decorationLines[_i];
        renderDecorationLine(ctx, decorationLine);
    }
    ctx.restore();
};
var renderBlock = function renderBlock(ctx, block, options) {
    block.forEach(function(line) {
        renderLine(ctx, line, options);
    });
};
var renderText = function renderText(ctx, node) {
    var _node$box2, _node$box3;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left;
    var blocks = [
        node.lines
    ];
    var paddingTop = ((_node$box2 = node.box) === null || _node$box2 === void 0 ? void 0 : _node$box2.paddingTop) || 0;
    var paddingLeft = ((_node$box3 = node.box) === null || _node$box3 === void 0 ? void 0 : _node$box3.paddingLeft) || 0;
    var initialY = node.lines[0] ? node.lines[0].box.y : 0;
    var offsetX = node.alignOffset || 0;
    ctx.save();
    ctx.translate(left + paddingLeft - offsetX, top + paddingTop - initialY);
    blocks.forEach(function(block) {
        renderBlock(ctx, block, {});
    });
    ctx.restore();
};
var renderPage = function renderPage(ctx, node) {
    var _node$props;
    var _node$box = node.box, width = _node$box.width, height = _node$box.height;
    var dpi = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.dpi) || 72;
    var userUnit = dpi / 72;
    ctx.addPage({
        size: [
            width,
            height
        ],
        margin: 0,
        userUnit: userUnit
    });
};
var renderNote = function renderNote(ctx, node) {
    var _node$children, _node$style, _node$style2;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left;
    var value = (node === null || node === void 0 ? void 0 : (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children[0].value) || "";
    var color = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.backgroundColor) || null;
    var borderWidth = ((_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.borderWidth) || null;
    ctx.note(left, top, 0, 0, value, {
        color: color,
        borderWidth: borderWidth
    });
};
var isNumeric = function isNumeric(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
};
var applyContainObjectFit = function applyContainObjectFit(cw, ch, iw, ih, px, py) {
    var cr = cw / ch;
    var ir = iw / ih;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var _height = ch;
        var _width = _height * ir;
        var _yOffset = isNumeric(py) ? py : 0;
        var _xOffset = isNumeric(px) ? px : (cw - _width) * pxv;
        return {
            width: _width,
            height: _height,
            xOffset: _xOffset,
            yOffset: _yOffset
        };
    }
    var width = cw;
    var height = width / ir;
    var xOffset = isNumeric(px) ? px : 0;
    var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
    return {
        width: width,
        height: height,
        yOffset: yOffset,
        xOffset: xOffset
    };
};
var applyNoneObjectFit = function applyNoneObjectFit(cw, ch, iw, ih, px, py) {
    var width = iw;
    var height = ih;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
    var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
    return {
        width: width,
        height: height,
        xOffset: xOffset,
        yOffset: yOffset
    };
};
var applyCoverObjectFit = function applyCoverObjectFit(cw, ch, iw, ih, px, py) {
    var ir = iw / ih;
    var cr = cw / ch;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var _width2 = cw;
        var _height2 = _width2 / ir;
        var _xOffset2 = isNumeric(px) ? px : 0;
        var _yOffset2 = isNumeric(py) ? py : (ch - _height2) * pyv;
        return {
            width: _width2,
            height: _height2,
            yOffset: _yOffset2,
            xOffset: _xOffset2
        };
    }
    var height = ch;
    var width = height * ir;
    var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
    var yOffset = isNumeric(py) ? py : 0;
    return {
        width: width,
        height: height,
        xOffset: xOffset,
        yOffset: yOffset
    };
};
var applyScaleDownObjectFit = function applyScaleDownObjectFit(cw, ch, iw, ih, px, py) {
    var containDimension = applyContainObjectFit(cw, ch, iw, ih, px, py);
    var noneDimension = applyNoneObjectFit(cw, ch, iw, ih, px, py);
    return containDimension.width < noneDimension.width ? containDimension : noneDimension;
};
var applyFillObjectFit = function applyFillObjectFit(cw, ch, px, py) {
    return {
        width: cw,
        height: ch,
        xOffset: (0, _fns.matchPercent)(px) ? 0 : px || 0,
        yOffset: (0, _fns.matchPercent)(py) ? 0 : py || 0
    };
};
var resolveObjectFit = function resolveObjectFit(type, cw, ch, iw, ih, px, py) {
    if (type === void 0) type = "fill";
    switch(type){
        case "contain":
            return applyContainObjectFit(cw, ch, iw, ih, px, py);
        case "cover":
            return applyCoverObjectFit(cw, ch, iw, ih, px, py);
        case "none":
            return applyNoneObjectFit(cw, ch, iw, ih, px, py);
        case "scale-down":
            return applyScaleDownObjectFit(cw, ch, iw, ih, px, py);
        default:
            return applyFillObjectFit(cw, ch, px, py);
    }
};
var drawImage = function drawImage(ctx, node, options) {
    var _node$style, _node$style2, _node$style3, _node$style4;
    if (options === void 0) options = {};
    var _node$box = node.box, left = _node$box.left, top = _node$box.top;
    var opacity = (_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.opacity;
    var objectFit = (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.objectFit;
    var objectPositionX = (_node$style3 = node.style) === null || _node$style3 === void 0 ? void 0 : _node$style3.objectPositionX;
    var objectPositionY = (_node$style4 = node.style) === null || _node$style4 === void 0 ? void 0 : _node$style4.objectPositionY;
    var paddingTop = node.box.paddingTop || 0;
    var paddingRight = node.box.paddingRight || 0;
    var paddingBottom = node.box.paddingBottom || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    var imageCache = options.imageCache || new Map();
    var _resolveObjectFit = resolveObjectFit(objectFit, node.box.width - paddingLeft - paddingRight, node.box.height - paddingTop - paddingBottom, node.image.width, node.image.height, objectPositionX, objectPositionY), width = _resolveObjectFit.width, height = _resolveObjectFit.height, xOffset = _resolveObjectFit.xOffset, yOffset = _resolveObjectFit.yOffset;
    if (node.image.data) {
        if (width !== 0 && height !== 0) {
            var cacheKey = node.image.key;
            var image = imageCache.get(cacheKey) || ctx.embedImage(node.image.data);
            if (cacheKey) imageCache.set(cacheKey, image);
            var imageOpacity = (0, _fns.isNil)(opacity) ? 1 : opacity;
            ctx.fillOpacity(imageOpacity).image(image, left + paddingLeft + xOffset, top + paddingTop + yOffset, {
                width: width,
                height: height
            });
        } else console.warn("Image with src '" + JSON.stringify(node.props.src) + "' skipped due to invalid dimensions");
    }
};
var renderImage = function renderImage(ctx, node, options) {
    ctx.save();
    clipNode(ctx, node);
    drawImage(ctx, node, options);
    ctx.restore();
};
var CONTENT_COLOR = "#a1c6e7";
var PADDING_COLOR = "#c4deb9";
var MARGIN_COLOR = "#f8cca1";
// TODO: Draw debug boxes using clipping to enhance quality
var debugContent = function debugContent(ctx, node) {
    var _node$box = node.box, left = _node$box.left, top = _node$box.top, width = _node$box.width, height = _node$box.height, _node$box$paddingLeft = _node$box.paddingLeft, paddingLeft = _node$box$paddingLeft === void 0 ? 0 : _node$box$paddingLeft, _node$box$paddingTop = _node$box.paddingTop, paddingTop = _node$box$paddingTop === void 0 ? 0 : _node$box$paddingTop, _node$box$paddingRigh = _node$box.paddingRight, paddingRight = _node$box$paddingRigh === void 0 ? 0 : _node$box$paddingRigh, _node$box$paddingBott = _node$box.paddingBottom, paddingBottom = _node$box$paddingBott === void 0 ? 0 : _node$box$paddingBott, _node$box$borderLeftW = _node$box.borderLeftWidth, borderLeftWidth = _node$box$borderLeftW === void 0 ? 0 : _node$box$borderLeftW, _node$box$borderTopWi = _node$box.borderTopWidth, borderTopWidth = _node$box$borderTopWi === void 0 ? 0 : _node$box$borderTopWi, _node$box$borderRight = _node$box.borderRightWidth, borderRightWidth = _node$box$borderRight === void 0 ? 0 : _node$box$borderRight, _node$box$borderBotto = _node$box.borderBottomWidth, borderBottomWidth = _node$box$borderBotto === void 0 ? 0 : _node$box$borderBotto;
    ctx.fillColor(CONTENT_COLOR).opacity(0.5).rect(left + paddingLeft + borderLeftWidth, top + paddingTop + borderTopWidth, width - paddingLeft - paddingRight - borderRightWidth - borderLeftWidth, height - paddingTop - paddingBottom - borderTopWidth - borderBottomWidth).fill();
};
var debugPadding = function debugPadding(ctx, node) {
    var _node$box2 = node.box, left = _node$box2.left, top = _node$box2.top, width = _node$box2.width, height = _node$box2.height, _node$box2$paddingLef = _node$box2.paddingLeft, paddingLeft = _node$box2$paddingLef === void 0 ? 0 : _node$box2$paddingLef, _node$box2$paddingTop = _node$box2.paddingTop, paddingTop = _node$box2$paddingTop === void 0 ? 0 : _node$box2$paddingTop, _node$box2$paddingRig = _node$box2.paddingRight, paddingRight = _node$box2$paddingRig === void 0 ? 0 : _node$box2$paddingRig, _node$box2$paddingBot = _node$box2.paddingBottom, paddingBottom = _node$box2$paddingBot === void 0 ? 0 : _node$box2$paddingBot, _node$box2$borderLeft = _node$box2.borderLeftWidth, borderLeftWidth = _node$box2$borderLeft === void 0 ? 0 : _node$box2$borderLeft, _node$box2$borderTopW = _node$box2.borderTopWidth, borderTopWidth = _node$box2$borderTopW === void 0 ? 0 : _node$box2$borderTopW, _node$box2$borderRigh = _node$box2.borderRightWidth, borderRightWidth = _node$box2$borderRigh === void 0 ? 0 : _node$box2$borderRigh, _node$box2$borderBott = _node$box2.borderBottomWidth, borderBottomWidth = _node$box2$borderBott === void 0 ? 0 : _node$box2$borderBott;
    ctx.fillColor(PADDING_COLOR).opacity(0.5);
    // Padding top
    ctx.rect(left + paddingLeft + borderLeftWidth, top + borderTopWidth, width - paddingRight - paddingLeft - borderLeftWidth - borderRightWidth, paddingTop).fill();
    // Padding left
    ctx.rect(left + borderLeftWidth, top + borderTopWidth, paddingLeft, height - borderTopWidth - borderBottomWidth).fill();
    // Padding right
    ctx.rect(left + width - paddingRight - borderRightWidth, top + borderTopWidth, paddingRight, height - borderTopWidth - borderBottomWidth).fill();
    // Padding bottom
    ctx.rect(left + paddingLeft + borderLeftWidth, top + height - paddingBottom - borderBottomWidth, width - paddingRight - paddingLeft - borderLeftWidth - borderRightWidth, paddingBottom).fill();
};
var getMargin = function getMargin(box) {
    var marginLeft = box.marginLeft === "auto" ? 0 : box.marginLeft;
    var marginTop = box.marginTop === "auto" ? 0 : box.marginTop;
    var marginRight = box.marginRight === "auto" ? 0 : box.marginRight;
    var marginBottom = box.marginBottom === "auto" ? 0 : box.marginBottom;
    return {
        marginLeft: marginLeft,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom
    };
};
var debugMargin = function debugMargin(ctx, node) {
    var _node$box3 = node.box, left = _node$box3.left, top = _node$box3.top, width = _node$box3.width, height = _node$box3.height;
    var _getMargin = getMargin(node.box), _getMargin$marginLeft = _getMargin.marginLeft, marginLeft = _getMargin$marginLeft === void 0 ? 0 : _getMargin$marginLeft, _getMargin$marginTop = _getMargin.marginTop, marginTop = _getMargin$marginTop === void 0 ? 0 : _getMargin$marginTop, _getMargin$marginRigh = _getMargin.marginRight, marginRight = _getMargin$marginRigh === void 0 ? 0 : _getMargin$marginRigh, _getMargin$marginBott = _getMargin.marginBottom, marginBottom = _getMargin$marginBott === void 0 ? 0 : _getMargin$marginBott;
    ctx.fillColor(MARGIN_COLOR).opacity(0.5);
    // Margin top
    ctx.rect(left, top - marginTop, width, marginTop).fill();
    // Margin left
    ctx.rect(left - marginLeft, top - marginTop, marginLeft, height + marginTop + marginBottom).fill();
    // Margin right
    ctx.rect(left + width, top - marginTop, marginRight, height + marginTop + marginBottom).fill();
    // Margin bottom
    ctx.rect(left, top + height, width, marginBottom).fill();
};
var debugText = function debugText(ctx, node) {
    var _node$box4 = node.box, left = _node$box4.left, top = _node$box4.top, width = _node$box4.width, height = _node$box4.height;
    var _getMargin2 = getMargin(node.box), _getMargin2$marginLef = _getMargin2.marginLeft, marginLeft = _getMargin2$marginLef === void 0 ? 0 : _getMargin2$marginLef, _getMargin2$marginTop = _getMargin2.marginTop, marginTop = _getMargin2$marginTop === void 0 ? 0 : _getMargin2$marginTop, _getMargin2$marginRig = _getMargin2.marginRight, marginRight = _getMargin2$marginRig === void 0 ? 0 : _getMargin2$marginRig, _getMargin2$marginBot = _getMargin2.marginBottom, marginBottom = _getMargin2$marginBot === void 0 ? 0 : _getMargin2$marginBot;
    var roundedWidth = Math.round(width + marginLeft + marginRight);
    var roundedHeight = Math.round(height + marginTop + marginBottom);
    ctx.fontSize(6).opacity(1).fillColor("black").text(roundedWidth + " x " + roundedHeight, left - marginLeft, Math.max(top - marginTop - 4, 1));
};
var debugOrigin = function debugOrigin(ctx, node) {
    if (node.origin) ctx.circle(node.origin.left, node.origin.top, 3).fill("red").circle(node.origin.left, node.origin.top, 5).stroke("red");
};
var renderDebug = function renderDebug(ctx, node) {
    var _node$props;
    if (!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.debug)) return;
    ctx.save();
    debugContent(ctx, node);
    debugPadding(ctx, node);
    debugMargin(ctx, node);
    debugText(ctx, node);
    debugOrigin(ctx, node);
    ctx.restore();
};
var availableMethods = [
    "dash",
    "clip",
    "save",
    "path",
    "fill",
    "font",
    "text",
    "rect",
    "scale",
    "moveTo",
    "lineTo",
    "stroke",
    "rotate",
    "circle",
    "lineCap",
    "opacity",
    "ellipse",
    "polygon",
    "restore",
    "lineJoin",
    "fontSize",
    "fillColor",
    "lineWidth",
    "translate",
    "miterLimit",
    "strokeColor",
    "fillOpacity",
    "roundedRect",
    "fillAndStroke",
    "strokeOpacity",
    "bezierCurveTo",
    "quadraticCurveTo",
    "linearGradient",
    "radialGradient"
];
var painter = function painter(ctx) {
    var p = availableMethods.reduce(function(acc, prop) {
        var _extends2;
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[prop] = function() {
            ctx[prop].apply(ctx, arguments);
            return p;
        }, _extends2));
    }, {});
    return p;
};
var renderCanvas = function renderCanvas(ctx, node) {
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var paddingTop = node.box.paddingTop || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    var paddingRight = node.box.paddingRight || 0;
    var paddingBottom = node.box.paddingBottom || 0;
    var availableWidth = width - paddingLeft - paddingRight;
    var availableHeight = height - paddingTop - paddingBottom;
    if (!availableWidth || !availableHeight) console.warn("Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it.");
    ctx.save().translate(left + paddingLeft, top + paddingTop);
    if (node.props.paint) node.props.paint(painter(ctx), availableWidth, availableHeight);
    ctx.restore();
};
// Ref: https://www.w3.org/TR/css-backgrounds-3/#borders
// This constant is used to approximate a symmetrical arc using a cubic Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var clipBorderTop = function clipBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    // Clip outer top border edge
    ctx.moveTo(left + rtl, top);
    ctx.lineTo(left + width - rtr, top);
    // Ellipse coefficients outer top right cap
    var c0 = rtr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c0, top, left + width, top + c0, left + width, top + rtr);
    // Move down in case the margin exceedes the radius
    var topRightYCoord = top + Math.max(borderTopWidth, rtr);
    ctx.lineTo(left + width, topRightYCoord);
    // Clip inner top right cap
    ctx.lineTo(left + width - borderRightWidth, topRightYCoord);
    // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c1 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c2 = innerTopRightRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c2, left + width - borderRightWidth - c1, top + borderTopWidth, left + width - borderRightWidth - innerTopRightRadiusX, top + borderTopWidth);
    // Clip inner top border edge
    ctx.lineTo(left + Math.max(rtl, borderLeftWidth), top + borderTopWidth);
    // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c3 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerTopLeftRadiusY * (1.0 - KAPPA);
    var topLeftYCoord = top + Math.max(borderTopWidth, rtl);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth + c3, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c4, left + borderLeftWidth, topLeftYCoord);
    ctx.lineTo(left, topLeftYCoord);
    // Move down in case the margin exceedes the radius
    ctx.lineTo(left, top + rtl);
    // Ellipse coefficients outer top left cap
    var c5 = rtl * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c5, left + c5, top, left + rtl, top);
    ctx.closePath();
    ctx.clip();
    // Clip border top cap joins
    if (borderRightWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var _trSlope = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderTop = function fillBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width;
    var borderTopColor = style.borderTopColor, borderTopWidth = style.borderTopWidth, borderTopStyle = style.borderTopStyle, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rtl * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left, top + Math.max(rtl, borderTopWidth));
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top);
    ctx.lineTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.strokeColor(borderTopColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderLeftWidth) * 2);
    if (borderTopStyle === "dashed") ctx.dash(borderTopWidth * 2, {
        space: borderTopWidth * 1.2
    });
    else if (borderTopStyle === "dotted") ctx.dash(borderTopWidth, {
        space: borderTopWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderRight = function clipBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderBottomWidth = style.borderBottomWidth;
    // Clip outer right border edge
    ctx.moveTo(left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr);
    // Ellipse coefficients outer bottom right cap
    var c0 = rbr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height);
    // Move left in case the margin exceedes the radius
    var topBottomXCoord = left + width - Math.max(borderRightWidth, rbr);
    ctx.lineTo(topBottomXCoord, top + height);
    // Clip inner bottom right cap
    ctx.lineTo(topBottomXCoord, top + height - borderBottomWidth);
    // Ellipse coefficients inner bottom right cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c1 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomRightRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c1, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c2, left + width - borderRightWidth, top + height - Math.max(rbr, borderBottomWidth));
    // Clip inner right border edge
    ctx.lineTo(left + width - borderRightWidth, top + Math.max(rtr, borderTopWidth));
    // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c3 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c4 = innerTopRightRadiusY * (1.0 - KAPPA);
    var topRightXCoord = left + width - Math.max(rtr, borderRightWidth);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c4, left + width - borderRightWidth - c3, top + borderTopWidth, topRightXCoord, top + borderTopWidth);
    ctx.lineTo(topRightXCoord, top);
    // Move right in case the margin exceedes the radius
    ctx.lineTo(left + width - rtr, top);
    // Ellipse coefficients outer top right cap
    var c5 = rtr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c5, top, left + width, top + c5, left + width, top + rtr);
    ctx.closePath();
    ctx.clip();
    // Clip border right cap joins
    if (borderTopWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderRight = function fillBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderRightColor = style.borderRightColor, borderRightStyle = style.borderRightStyle, borderRightWidth = style.borderRightWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbr * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height);
    ctx.strokeColor(borderRightColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderRightStyle === "dashed") ctx.dash(borderRightWidth * 2, {
        space: borderRightWidth * 1.2
    });
    else if (borderRightStyle === "dotted") ctx.dash(borderRightWidth, {
        space: borderRightWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderBottom = function clipBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    // Clip outer top border edge
    ctx.moveTo(left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height);
    // Ellipse coefficients outer top right cap
    var c0 = rbl * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    // Move up in case the margin exceedes the radius
    var bottomLeftYCoord = top + height - Math.max(borderBottomWidth, rbl);
    ctx.lineTo(left, bottomLeftYCoord);
    // Clip inner bottom left cap
    ctx.lineTo(left + borderLeftWidth, bottomLeftYCoord);
    // Ellipse coefficients inner top right cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c1 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomLeftRadiusY * (1.0 - KAPPA);
    // Clip inner bottom left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c2, left + borderLeftWidth + c1, top + height - borderBottomWidth, left + borderLeftWidth + innerBottomLeftRadiusX, top + height - borderBottomWidth);
    // Clip inner bottom border edge
    ctx.lineTo(left + width - Math.max(rbr, borderRightWidth), top + height - borderBottomWidth);
    // Ellipse coefficients inner top left cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c3 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomRightRadiusY * (1.0 - KAPPA);
    var bottomRightYCoord = top + height - Math.max(borderBottomWidth, rbr);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c3, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c4, left + width - borderRightWidth, bottomRightYCoord);
    ctx.lineTo(left + width, bottomRightYCoord);
    // Move down in case the margin exceedes the radius
    ctx.lineTo(left + width, top + height - rbr);
    // Ellipse coefficients outer top left cap
    var c5 = rbr * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left + width, top + height - c5, left + width - c5, top + height, left + width - rbr, top + height);
    ctx.closePath();
    ctx.clip();
    // Clip border bottom cap joins
    if (borderRightWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderBottom = function fillBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomColor = style.borderBottomColor, borderBottomStyle = style.borderBottomStyle, borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rbr * (1.0 - KAPPA);
    ctx.moveTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c1, left + width - c1, top + height, left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.strokeColor(borderBottomColor);
    ctx.lineWidth(Math.max(borderBottomWidth, borderRightWidth, borderLeftWidth) * 2);
    if (borderBottomStyle === "dashed") ctx.dash(borderBottomWidth * 2, {
        space: borderBottomWidth * 1.2
    });
    else if (borderBottomStyle === "dotted") ctx.dash(borderBottomWidth, {
        space: borderBottomWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderLeft = function clipBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderLeftWidth = style.borderLeftWidth, borderBottomWidth = style.borderBottomWidth;
    // Clip outer left border edge
    ctx.moveTo(left, top + height - rbl);
    ctx.lineTo(left, top + rtl);
    // Ellipse coefficients outer top left cap
    var c0 = rtl * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top);
    // Move right in case the margin exceedes the radius
    var topLeftCoordX = left + Math.max(borderLeftWidth, rtl);
    ctx.lineTo(topLeftCoordX, top);
    // Clip inner top left cap
    ctx.lineTo(topLeftCoordX, top + borderTopWidth);
    // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c1 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerTopLeftRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + borderLeftWidth + c1, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c2, left + borderLeftWidth, top + Math.max(rtl, borderTopWidth));
    // Clip inner left border edge
    ctx.lineTo(left + borderLeftWidth, top + height - Math.max(rbl, borderBottomWidth));
    // Ellipse coefficients inner bottom left cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c3 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomLeftRadiusY * (1.0 - KAPPA);
    var bottomLeftXCoord = left + Math.max(rbl, borderLeftWidth);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c4, left + borderLeftWidth + c3, top + height - borderBottomWidth, bottomLeftXCoord, top + height - borderBottomWidth);
    ctx.lineTo(bottomLeftXCoord, top + height);
    // Move left in case the margin exceedes the radius
    ctx.lineTo(left + rbl, top + height);
    // Ellipse coefficients outer top right cap
    var c5 = rbl * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + c5, top + height, left, top + height - c5, left, top + height - rbl);
    ctx.closePath();
    ctx.clip();
    // Clip border right cap joins
    if (borderBottomWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var _trSlope2 = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope2 * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderLeft = function fillBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, height = layout.height;
    var borderLeftColor = style.borderLeftColor, borderLeftStyle = style.borderLeftStyle, borderLeftWidth = style.borderLeftWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rtl * (1.0 - KAPPA);
    ctx.moveTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.lineTo(left, top + rtl);
    ctx.bezierCurveTo(left, top + c1, left + c1, top, left + rtl, top);
    ctx.strokeColor(borderLeftColor);
    ctx.lineWidth(Math.max(borderLeftWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderLeftStyle === "dashed") ctx.dash(borderLeftWidth * 2, {
        space: borderLeftWidth * 1.2
    });
    else if (borderLeftStyle === "dotted") ctx.dash(borderLeftWidth, {
        space: borderLeftWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var shouldRenderBorders = function shouldRenderBorders(node) {
    return node.box && (node.box.borderTopWidth || node.box.borderRightWidth || node.box.borderBottomWidth || node.box.borderLeftWidth);
};
var renderBorders = function renderBorders(ctx, node) {
    if (!shouldRenderBorders(node)) return;
    var _node$box = node.box, width = _node$box.width, height = _node$box.height, borderTopWidth = _node$box.borderTopWidth, borderLeftWidth = _node$box.borderLeftWidth, borderRightWidth = _node$box.borderRightWidth, borderBottomWidth = _node$box.borderBottomWidth;
    var _node$style = node.style, opacity = _node$style.opacity, _node$style$borderTop = _node$style.borderTopLeftRadius, borderTopLeftRadius = _node$style$borderTop === void 0 ? 0 : _node$style$borderTop, _node$style$borderTop2 = _node$style.borderTopRightRadius, borderTopRightRadius = _node$style$borderTop2 === void 0 ? 0 : _node$style$borderTop2, _node$style$borderBot = _node$style.borderBottomLeftRadius, borderBottomLeftRadius = _node$style$borderBot === void 0 ? 0 : _node$style$borderBot, _node$style$borderBot2 = _node$style.borderBottomRightRadius, borderBottomRightRadius = _node$style$borderBot2 === void 0 ? 0 : _node$style$borderBot2, _node$style$borderTop3 = _node$style.borderTopColor, borderTopColor = _node$style$borderTop3 === void 0 ? "black" : _node$style$borderTop3, _node$style$borderTop4 = _node$style.borderTopStyle, borderTopStyle = _node$style$borderTop4 === void 0 ? "solid" : _node$style$borderTop4, _node$style$borderLef = _node$style.borderLeftColor, borderLeftColor = _node$style$borderLef === void 0 ? "black" : _node$style$borderLef, _node$style$borderLef2 = _node$style.borderLeftStyle, borderLeftStyle = _node$style$borderLef2 === void 0 ? "solid" : _node$style$borderLef2, _node$style$borderRig = _node$style.borderRightColor, borderRightColor = _node$style$borderRig === void 0 ? "black" : _node$style$borderRig, _node$style$borderRig2 = _node$style.borderRightStyle, borderRightStyle = _node$style$borderRig2 === void 0 ? "solid" : _node$style$borderRig2, _node$style$borderBot3 = _node$style.borderBottomColor, borderBottomColor = _node$style$borderBot3 === void 0 ? "black" : _node$style$borderBot3, _node$style$borderBot4 = _node$style.borderBottomStyle, borderBottomStyle = _node$style$borderBot4 === void 0 ? "solid" : _node$style$borderBot4;
    var style = {
        borderTopColor: borderTopColor,
        borderTopWidth: borderTopWidth,
        borderTopStyle: borderTopStyle,
        borderLeftColor: borderLeftColor,
        borderLeftWidth: borderLeftWidth,
        borderLeftStyle: borderLeftStyle,
        borderRightColor: borderRightColor,
        borderRightWidth: borderRightWidth,
        borderRightStyle: borderRightStyle,
        borderBottomColor: borderBottomColor,
        borderBottomWidth: borderBottomWidth,
        borderBottomStyle: borderBottomStyle,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderBottomRightRadius: borderBottomRightRadius
    };
    var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
    var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
    var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
    var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
    ctx.save();
    ctx.strokeOpacity(opacity);
    if (borderTopWidth) {
        ctx.save();
        clipBorderTop(ctx, node.box, style, rtr, rtl);
        fillBorderTop(ctx, node.box, style, rtr, rtl);
        ctx.restore();
    }
    if (borderRightWidth) {
        ctx.save();
        clipBorderRight(ctx, node.box, style, rtr, rbr);
        fillBorderRight(ctx, node.box, style, rtr, rbr);
        ctx.restore();
    }
    if (borderBottomWidth) {
        ctx.save();
        clipBorderBottom(ctx, node.box, style, rbl, rbr);
        fillBorderBottom(ctx, node.box, style, rbl, rbr);
        ctx.restore();
    }
    if (borderLeftWidth) {
        ctx.save();
        clipBorderLeft(ctx, node.box, style, rbl, rtl);
        fillBorderLeft(ctx, node.box, style, rbl, rtl);
        ctx.restore();
    }
    ctx.restore();
};
var drawBackground = function drawBackground(ctx, node) {
    var _node$style;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var color = parseColor(node.style.backgroundColor);
    var nodeOpacity = (0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.opacity) ? 1 : node.style.opacity;
    var opacity = Math.min(color.opacity, nodeOpacity);
    ctx.fillOpacity(opacity).fillColor(color.value).rect(left, top, width, height).fill();
};
var renderBackground = function renderBackground(ctx, node) {
    var _node$style2;
    var hasBackground = !!node.box && !!((_node$style2 = node.style) !== null && _node$style2 !== void 0 && _node$style2.backgroundColor);
    if (hasBackground) {
        ctx.save();
        clipNode(ctx, node);
        drawBackground(ctx, node);
        ctx.restore();
    }
};
var isSrcId = function isSrcId(value) {
    return /^#.+/.test(value);
};
var setLink = function setLink(ctx, node) {
    var props = node.props || {};
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var src = props.src || props.href;
    if (src) {
        var isId = isSrcId(src);
        var method = isId ? "goTo" : "link";
        var value = isId ? src.slice(1) : src;
        ctx[method](left, top, width, height, value);
    }
};
var setDestination = function setDestination(ctx, node) {
    var _node$props;
    if ((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.id) ctx.addNamedDestination(node.props.id, "XYZ", null, node.box.top, null);
};
var _renderFns;
var isRecursiveNode = function isRecursiveNode(node) {
    return node.type !== _primitives.Text && node.type !== _primitives.Svg;
};
var renderChildren = function renderChildren(ctx, node, options) {
    ctx.save();
    if (node.box) ctx.translate(node.box.left, node.box.top);
    var children = node.children || [];
    var renderChild = function renderChild(child) {
        return renderNode(ctx, child, options);
    };
    children.forEach(renderChild);
    ctx.restore();
};
var renderFns = (_renderFns = {}, _renderFns[_primitives.Text] = renderText, _renderFns[_primitives.Note] = renderNote, _renderFns[_primitives.Image] = renderImage, _renderFns[_primitives.Canvas] = renderCanvas, _renderFns[_primitives.Svg] = renderSvg, _renderFns[_primitives.Link] = setLink, _renderFns);
var renderNode = function renderNode(ctx, node, options) {
    var _node$style;
    var overflowHidden = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.overflow) === "hidden";
    var shouldRenderChildren = isRecursiveNode(node);
    if (node.type === _primitives.Page) renderPage(ctx, node);
    ctx.save();
    if (overflowHidden) clipNode(ctx, node);
    applyTransformations(ctx, node);
    renderBackground(ctx, node);
    renderBorders(ctx, node);
    var renderFn = renderFns[node.type];
    if (renderFn) renderFn(ctx, node, options);
    if (shouldRenderChildren) renderChildren(ctx, node, options);
    setDestination(ctx, node);
    renderDebug(ctx, node);
    ctx.restore();
};
/* eslint-disable no-param-reassign */ var setPDFMetadata = function setPDFMetadata(target) {
    return function(key, value) {
        if (value) target.info[key] = value;
    };
};
/**
 * Set document instance metadata
 *
 * @param {Object} ctx document instance
 * @param {Object} doc document root
 */ var addMetadata = function addMetadata(ctx, doc) {
    var _props$creator, _props$producer;
    var setProp = setPDFMetadata(ctx);
    var props = doc.props || {};
    var title = props.title || null;
    var author = props.author || null;
    var subject = props.subject || null;
    var keywords = props.keywords || null;
    var creator = (_props$creator = props.creator) != null ? _props$creator : "react-pdf";
    var producer = (_props$producer = props.producer) != null ? _props$producer : "react-pdf";
    var creationDate = props.creationDate || new Date();
    var modificationDate = props.modificationDate || null;
    setProp("Title", title);
    setProp("Author", author);
    setProp("Subject", subject);
    setProp("Keywords", keywords);
    setProp("Creator", creator);
    setProp("Producer", producer);
    setProp("CreationDate", creationDate);
    setProp("ModificationDate", modificationDate);
};
/* eslint-disable no-param-reassign */ var addNodeBookmark = function addNodeBookmark(ctx, node, pageNumber, registry) {
    var _node$props;
    var bookmark = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.bookmark;
    if (bookmark) {
        var title = bookmark.title, parent = bookmark.parent, expanded = bookmark.expanded, zoom = bookmark.zoom, fit = bookmark.fit;
        var outline = registry[parent] || ctx.outline;
        var top = bookmark.top || node.box.top;
        var left = bookmark.left || node.box.left;
        var instance = outline.addItem(title, {
            pageNumber: pageNumber,
            expanded: expanded,
            top: top,
            left: left,
            zoom: zoom,
            fit: fit
        });
        registry[bookmark.ref] = instance;
    }
    if (!node.children) return;
    node.children.forEach(function(child) {
        return addNodeBookmark(ctx, child, pageNumber, registry);
    });
};
var addBookmarks = function addBookmarks(ctx, root) {
    var registry = {};
    var pages = root.children || [];
    pages.forEach(function(page, i) {
        addNodeBookmark(ctx, page, i, registry);
    });
};
var render = function render(ctx, doc) {
    var pages = doc.children || [];
    var options = {
        imageCache: new Map()
    };
    addMetadata(ctx, doc);
    pages.forEach(function(page) {
        return renderNode(ctx, page, options);
    });
    addBookmarks(ctx, doc);
    ctx.end();
    return ctx;
};

},{"@react-pdf/primitives":"bti5i","@react-pdf/fns":"7kb6I","abs-svg-path":"arqpq","parse-svg-path":"b5nOi","normalize-svg-path":"bSfIa","color-string":"fIg9F","@babel/runtime/helpers/extends":"lKkcq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7kb6I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjust", ()=>adjust);
parcelHelpers.export(exports, "asyncCompose", ()=>asyncCompose);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "castArray", ()=>castArray);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "dropLast", ()=>dropLast);
parcelHelpers.export(exports, "evolve", ()=>evolve);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "last", ()=>last);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "matchPercent", ()=>matchPercent);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
/**
 * Applies a function to the value at the given index of an array

 * @param {number} index
 * @param {function} fn
 * @param {array} collection
 * @returns copy of the array with the element at the given index replaced with the result of the function application.
 */ var adjust = function adjust(index, fn, collection) {
    var _Object$assign;
    if (index >= 0 && index >= collection.length) return collection;
    if (index < 0 && Math.abs(index) > collection.length) return collection;
    var i = index < 0 ? collection.length + index : index;
    return Object.assign([], collection, (_Object$assign = {}, _Object$assign[i] = fn(collection[i]), _Object$assign));
};
var reverse = function reverse(list) {
    return Array.prototype.slice.call(list, 0).reverse();
};
/**
 * @typedef {Function} AsyncCompose
 * @param {any} value
 * @param {...any} args
 * @returns {any} result
 */ /**
 * Performs right-to-left function composition with async functions support
 *
 * @param {...Function} fns functions
 * @returns {AsyncCompose} composed function
 */ var asyncCompose = function asyncCompose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(value) {
            var result, reversedFns, _len2, args, _key2, i, fn, _args = arguments;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        result = value;
                        reversedFns = reverse(fns);
                        for(_len2 = _args.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = _args[_key2];
                        i = 0;
                    case 4:
                        if (!(i < reversedFns.length)) {
                            _context.next = 12;
                            break;
                        }
                        fn = reversedFns[i];
                        _context.next = 8;
                        return fn.apply(void 0, [
                            result
                        ].concat(args));
                    case 8:
                        result = _context.sent;
                    case 9:
                        i += 1;
                        _context.next = 4;
                        break;
                    case 12:
                        return _context.abrupt("return", result);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Capitalize first letter of each word
 *
 * @param {string} value string
 * @returns {string} capitalized string
 */ var capitalize = function capitalize(value) {
    if (!value) return value;
    return value.replace(/(^|\s)\S/g, function(l) {
        return l.toUpperCase();
    });
};
/**
 * Casts value to array
 *
 * @template T
 * @param {T|T[]} value value
 * @returns {T[]} array
 */ var castArray = function castArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
/* eslint-disable no-await-in-loop */ /**
 * @typedef {Function} Compose
 * @param {any} value
 * @param {...any} args
 * @returns {any} result
 */ /**
 * Performs right-to-left function composition
 *
 * @param {...Function} fns functions
 * @returns {Compose} composed function
 */ var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(value) {
        var result = value;
        var reversedFns = reverse(fns);
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        for(var i = 0; i < reversedFns.length; i += 1){
            var fn = reversedFns[i];
            result = fn.apply(void 0, [
                result
            ].concat(args));
        }
        return result;
    };
};
var dropLast = function dropLast(array) {
    return array.slice(0, array.length - 1);
};
var evolve = function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var keys = Object.keys(object);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var transformation = transformations[key];
        var type = typeof transformation;
        if (type === "function") result[key] = transformation(object[key]);
        else if (transformation && type === "object") result[key] = evolve(transformation, object[key]);
        else result[key] = object[key];
    }
    return result;
};
var isNil = function isNil(value) {
    return value === null || value === undefined;
};
var get = function get(target, path, defaultValue) {
    if (isNil(target)) return defaultValue;
    var _path = castArray(path);
    var result = target;
    for(var i = 0; i < _path.length; i += 1){
        if (isNil(result)) return undefined;
        result = result[_path[i]];
    }
    return isNil(result) ? defaultValue : result;
};
var last = function last(value) {
    return value === "" ? "" : value[value.length - 1];
};
var mapValues = function mapValues(object, fn) {
    var entries = Object.entries(object);
    return entries.reduce(function(acc, _ref, index) {
        var key = _ref[0], value = _ref[1];
        acc[key] = fn(value, key, index);
        return acc;
    }, {});
};
/**
 * @param {string | number} value
 * @returns {RegExpExecArray | null} match
 */ var isPercent = function isPercent(value) {
    return /((-)?\d+\.?\d*)%/g.exec("" + value);
};
/**
 * Get percentage value of input
 *
 * @param {string | number} value
 * @returns {{ percent: number, value: number } | null} percent value (if matches)
 */ var matchPercent = function matchPercent(value) {
    var match = isPercent(value);
    if (match) {
        var f = parseFloat(match[1]);
        var percent = f / 100;
        return {
            percent: percent,
            value: f
        };
    }
    return null;
};
var omit = function omit(keys, object) {
    var _keys = castArray(keys);
    var copy = Object.assign({}, object);
    _keys.forEach(function(key) {
        delete copy[key];
    });
    return copy;
};
var pick = function pick(keys, obj) {
    var result = {};
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        if (key in obj) result[key] = obj[key];
    }
    return result;
};
var repeat = function repeat(list, length) {
    if (length === void 0) length = 0;
    var result = new Array(length);
    for(var i = 0; i < length; i += 1)result[i] = list;
    return result;
};
/**
 * Capitalize first letter of string
 *
 * @param {string} value string
 * @returns {string} capitalized string
 */ var upperFirst = function upperFirst(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};

},{"@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"arqpq":[function(require,module,exports) {
module.exports = absolutize;
/**
 * redefine `path` with absolute coordinates
 *
 * @param {Array} path
 * @return {Array}
 */ function absolutize(path) {
    var startX = 0;
    var startY = 0;
    var x = 0;
    var y = 0;
    return path.map(function(seg) {
        seg = seg.slice();
        var type = seg[0];
        var command = type.toUpperCase();
        // is relative
        if (type != command) {
            seg[0] = command;
            switch(type){
                case "a":
                    seg[6] += x;
                    seg[7] += y;
                    break;
                case "v":
                    seg[1] += y;
                    break;
                case "h":
                    seg[1] += x;
                    break;
                default:
                    for(var i = 1; i < seg.length;){
                        seg[i++] += x;
                        seg[i++] += y;
                    }
            }
        }
        // update cursor state
        switch(command){
            case "Z":
                x = startX;
                y = startY;
                break;
            case "H":
                x = seg[1];
                break;
            case "V":
                y = seg[1];
                break;
            case "M":
                x = startX = seg[1];
                y = startY = seg[2];
                break;
            default:
                x = seg[seg.length - 2];
                y = seg[seg.length - 1];
        }
        return seg;
    });
}

},{}],"b5nOi":[function(require,module,exports) {
module.exports = parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function parse(path) {
    var data = [];
    path.replace(segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = parseValues(args);
        // overloaded moveTo
        if (type == "m" && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = "l";
            command = command == "m" ? "l" : "L";
        }
        while(true){
            if (args.length == length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < length[type]) throw new Error("malformed path data");
            data.push([
                command
            ].concat(args.splice(0, length[type])));
        }
    });
    return data;
}
var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function parseValues(args) {
    var numbers = args.match(number);
    return numbers ? numbers.map(Number) : [];
}

},{}],"bSfIa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>normalize);
var _svgArcToCubicBezier = require("svg-arc-to-cubic-bezier");
var _svgArcToCubicBezierDefault = parcelHelpers.interopDefault(_svgArcToCubicBezier);
function normalize(path) {
    // init state
    var prev;
    var result = [];
    var bezierX = 0;
    var bezierY = 0;
    var startX = 0;
    var startY = 0;
    var quadX = null;
    var quadY = null;
    var x = 0;
    var y = 0;
    for(var i = 0, len = path.length; i < len; i++){
        var seg = path[i];
        var command = seg[0];
        switch(command){
            case "M":
                startX = seg[1];
                startY = seg[2];
                break;
            case "A":
                var curves = (0, _svgArcToCubicBezierDefault.default)({
                    px: x,
                    py: y,
                    cx: seg[6],
                    cy: seg[7],
                    rx: seg[1],
                    ry: seg[2],
                    xAxisRotation: seg[3],
                    largeArcFlag: seg[4],
                    sweepFlag: seg[5]
                });
                // null-curves
                if (!curves.length) continue;
                for(var j = 0, c; j < curves.length; j++){
                    c = curves[j];
                    seg = [
                        "C",
                        c.x1,
                        c.y1,
                        c.x2,
                        c.y2,
                        c.x,
                        c.y
                    ];
                    if (j < curves.length - 1) result.push(seg);
                }
                break;
            case "S":
                // default control point
                var cx = x;
                var cy = y;
                if (prev == "C" || prev == "S") {
                    cx += cx - bezierX // reflect the previous command's control
                    ;
                    cy += cy - bezierY // point relative to the current point
                    ;
                }
                seg = [
                    "C",
                    cx,
                    cy,
                    seg[1],
                    seg[2],
                    seg[3],
                    seg[4]
                ];
                break;
            case "T":
                if (prev == "Q" || prev == "T") {
                    quadX = x * 2 - quadX // as with 'S' reflect previous control point
                    ;
                    quadY = y * 2 - quadY;
                } else {
                    quadX = x;
                    quadY = y;
                }
                seg = quadratic(x, y, quadX, quadY, seg[1], seg[2]);
                break;
            case "Q":
                quadX = seg[1];
                quadY = seg[2];
                seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
                break;
            case "L":
                seg = line(x, y, seg[1], seg[2]);
                break;
            case "H":
                seg = line(x, y, seg[1], y);
                break;
            case "V":
                seg = line(x, y, x, seg[1]);
                break;
            case "Z":
                seg = line(x, y, startX, startY);
                break;
        }
        // update state
        prev = command;
        x = seg[seg.length - 2];
        y = seg[seg.length - 1];
        if (seg.length > 4) {
            bezierX = seg[seg.length - 4];
            bezierY = seg[seg.length - 3];
        } else {
            bezierX = x;
            bezierY = y;
        }
        result.push(seg);
    }
    return result;
}
function line(x1, y1, x2, y2) {
    return [
        "C",
        x1,
        y1,
        x2,
        y2,
        x2,
        y2
    ];
}
function quadratic(x1, y1, cx, cy, x2, y2) {
    return [
        "C",
        x1 / 3 + 2 / 3 * cx,
        y1 / 3 + 2 / 3 * cy,
        x2 / 3 + 2 / 3 * cx,
        y2 / 3 + 2 / 3 * cy,
        x2,
        y2
    ];
}

},{"svg-arc-to-cubic-bezier":"3iCKK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3iCKK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var TAU = Math.PI * 2;
var mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
    var x = _ref.x, y = _ref.y;
    x *= rx;
    y *= ry;
    var xp = cosphi * x - sinphi * y;
    var yp = sinphi * x + cosphi * y;
    return {
        x: xp + centerx,
        y: yp + centery
    };
};
var approxUnitArc = function approxUnitArc(ang1, ang2) {
    // If 90 degree circular arc, use a constant
    // as derived from http://spencermortensen.com/articles/bezier-circle
    var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    var x1 = Math.cos(ang1);
    var y1 = Math.sin(ang1);
    var x2 = Math.cos(ang1 + ang2);
    var y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
};
var vectorAngle = function vectorAngle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
    var dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
var getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
    var rxsq = Math.pow(rx, 2);
    var rysq = Math.pow(ry, 2);
    var pxpsq = Math.pow(pxp, 2);
    var pypsq = Math.pow(pyp, 2);
    var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
    if (radicant < 0) radicant = 0;
    radicant /= rxsq * pypsq + rysq * pxpsq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    var centerxp = radicant * rx / ry * pyp;
    var centeryp = radicant * -ry / rx * pxp;
    var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
    var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
    var vx1 = (pxp - centerxp) / rx;
    var vy1 = (pyp - centeryp) / ry;
    var vx2 = (-pxp - centerxp) / rx;
    var vy2 = (-pyp - centeryp) / ry;
    var ang1 = vectorAngle(1, 0, vx1, vy1);
    var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += TAU;
    return [
        centerx,
        centery,
        ang1,
        ang2
    ];
};
var arcToBezier = function arcToBezier(_ref2) {
    var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
    var curves = [];
    if (rx === 0 || ry === 0) return [];
    var sinphi = Math.sin(xAxisRotation * TAU / 360);
    var cosphi = Math.cos(xAxisRotation * TAU / 360);
    var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
    var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return [];
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = _slicedToArray(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
    // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
    // 1.0000000001. This causes `segments` to be greater than one, which is an
    // unecessary split, and adds extra points to the bezier curve. To alleviate
    // this issue, we round to 1.0 when the ratio is close to 1.0.
    var ratio = Math.abs(ang2) / (TAU / 4);
    if (Math.abs(1.0 - ratio) < 0.0000001) ratio = 1.0;
    var segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    for(var i = 0; i < segments; i++){
        curves.push(approxUnitArc(ang1, ang2));
        ang1 += ang2;
    }
    return curves.map(function(curve) {
        var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
        var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
        var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x = _mapToEllipse3.x, y = _mapToEllipse3.y;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        };
    });
};
exports.default = arcToBezier;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fIg9F":[function(require,module,exports) {
/* MIT license */ var colorNames = require("d7a6eeb7388b4bb");
var swizzle = require("248ce9e419a8df53");
var hasOwnProperty = Object.hasOwnProperty;
var reverseNames = Object.create(null);
// create a list of reverse color names
for(var name in colorNames)if (hasOwnProperty.call(colorNames, name)) reverseNames[colorNames[name]] = name;
var cs = module.exports = {
    to: {},
    get: {}
};
cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!hasOwnProperty.call(colorNames, match[1])) return null;
        rgb = colorNames[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = clamp(rgb[i], 0, 255);
    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
};
cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = clamp(parseFloat(match[2]), 0, 100);
        var l = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match[2]), 0, 100);
        var b = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
cs.to.hex = function() {
    var rgba = swizzle(arguments);
    return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
    var rgba = swizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
    var rgba = swizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
    var hsla = swizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function() {
    var hwba = swizzle(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
    return reverseNames[rgb.slice(0, 3)];
};
// helpers
function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

},{"d7a6eeb7388b4bb":"dC3l3","248ce9e419a8df53":"jRrMa"}],"dC3l3":[function(require,module,exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"jRrMa":[function(require,module,exports) {
"use strict";
var isArrayish = require("ce0bf6d0bc000d24");
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if (isArrayish(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
        else results.push(arg);
    }
    return results;
};
swizzle.wrap = function(fn) {
    return function() {
        return fn(swizzle(arguments));
    };
};

},{"ce0bf6d0bc000d24":"5wdZ5"}],"5wdZ5":[function(require,module,exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

},{}],"kKgRa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbeddedFont", ()=>EmbeddedFont);
parcelHelpers.export(exports, "PDFFont", ()=>PDFFont);
parcelHelpers.export(exports, "StandardFont", ()=>StandardFont);
parcelHelpers.export(exports, "default", ()=>PDFDocument);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _zstreamJs = require("pako/lib/zlib/zstream.js");
var _zstreamJsDefault = parcelHelpers.interopDefault(_zstreamJs);
var _deflateJs = require("pako/lib/zlib/deflate.js");
var _deflateJsDefault = parcelHelpers.interopDefault(_deflateJs);
var _inflateJs = require("pako/lib/zlib/inflate.js");
var _inflateJsDefault = parcelHelpers.interopDefault(_inflateJs);
var _constantsJs = require("pako/lib/zlib/constants.js");
var _constantsJsDefault = parcelHelpers.interopDefault(_constantsJs);
var _createForOfIteratorHelperLoose = require("@babel/runtime/helpers/createForOfIteratorHelperLoose");
var _createForOfIteratorHelperLooseDefault = parcelHelpers.interopDefault(_createForOfIteratorHelperLoose);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _md5Js = require("crypto-js/md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
var _fontkit = require("fontkit");
var _jayPeg = require("jay-peg");
var _jayPegDefault = parcelHelpers.interopDefault(_jayPeg);
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _coreJs = require("crypto-js/core.js");
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup[tmp >> 10];
        output += lookup[tmp >> 4 & 0x3F];
        output += lookup[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString = {}.toString;
var isArray$1 = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer$2.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
/*
 * Export kMaxLength after typed array support is determined.
 */ var _kMaxLength = kMaxLength();
function kMaxLength() {
    return Buffer$2.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer$2.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer$2(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer$2(arg, encodingOrOffset, length) {
    if (!Buffer$2.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$2)) return new Buffer$2(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from$1(this, arg, encodingOrOffset, length);
}
Buffer$2.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer$2._augment = function(arr) {
    arr.__proto__ = Buffer$2.prototype;
    return arr;
};
function from$1(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer$2.from = function(value, encodingOrOffset, length) {
    return from$1(null, value, encodingOrOffset, length);
};
if (Buffer$2.TYPED_ARRAY_SUPPORT) {
    Buffer$2.prototype.__proto__ = Uint8Array.prototype;
    Buffer$2.__proto__ = Uint8Array;
    typeof Symbol !== "undefined" && Symbol.species && Buffer$2[Symbol.species];
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer$2.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer$2.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer$2.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer$2.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer$2.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer$2.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray$1(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer$2.alloc(+length);
}
Buffer$2.isBuffer = isBuffer$1;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer$2.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer$2.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer$2.concat = function concat(list, length) {
    if (!isArray$1(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer$2.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer$2.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer$2.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer$2.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer$2.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer$2.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer$2.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer$2.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer$2.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer$2.compare(this, b) === 0;
};
Buffer$2.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer$2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer$2.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer$2.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer$2.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer$2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer$2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer$2.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer$2.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray(buf);
    else return fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex$1(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer$2.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer$2.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer$2(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer$2.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer$2.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer$2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer$2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer$2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer$2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer$2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer$2.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$2.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$2.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer$2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer$2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer$2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer$2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer$2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer$2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer$2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer$2.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer$2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer$2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer$2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer$2.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer$2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer$2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer$2.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer$2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer$2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer$2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer$2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer$2.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer$2.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer$2.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer$2.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$2(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex$1(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer$1(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
var _polyfillNode_buffer = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Buffer: Buffer$2,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer$1,
    kMaxLength: _kMaxLength
});
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a() {
            if (this instanceof a) return Reflect.construct(f, arguments, this.constructor);
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var readableBrowser = {
    exports: {}
};
var _registry = {};
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === "function") cachedSetTimeout = setTimeout;
if (typeof global$1.clearTimeout === "function") cachedClearTimeout = clearTimeout;
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var title = "browser";
var platform = "browser";
var browser$1 = true;
var env = {};
var argv = [];
var version = ""; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config$1 = {};
function noop$2() {}
var on = noop$2;
var addListener = noop$2;
var once$2 = noop$2;
var off = noop$2;
var removeListener = noop$2;
var removeAllListeners = noop$2;
var emit = noop$2;
function binding$1(name) {
    throw new Error("process.binding is not supported");
}
function cwd() {
    return "/";
}
function chdir(dir) {
    throw new Error("process.chdir is not supported");
}
function umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var startTime = new Date();
function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
}
var browser$1$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser$1,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once$2,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding$1,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config$1,
    uptime: uptime
};
var domain;
// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);
function EventEmitter() {
    EventEmitter.init.call(this);
}
// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;
EventEmitter.init = function() {
    this.domain = null;
    if (EventEmitter.usingDomains) // if there is an active domain, then attach to it.
    domain.active;
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new EventHandlers();
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
};
function $getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
};
// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self1) {
    if (isFn) handler.call(self1);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1);
    }
}
function emitOne(handler, isFn, self1, arg1) {
    if (isFn) handler.call(self1, arg1);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
    }
}
function emitTwo(handler, isFn, self1, arg1, arg2) {
    if (isFn) handler.call(self1, arg1, arg2);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
    }
}
function emitThree(handler, isFn, self1, arg1, arg2, arg3) {
    if (isFn) handler.call(self1, arg1, arg2, arg3);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
    }
}
function emitMany(handler, isFn, self1, args) {
    if (isFn) handler.apply(self1, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
    }
}
EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === "error";
    events = this._events;
    if (events) doError = doError && events.error == null;
    else if (!doError) return false;
    domain = this.domain;
    // If there is no 'error' event listener then throw.
    if (doError) {
        er = arguments[1];
        if (domain) {
            if (!er) er = new Error('Uncaught, unspecified "error" event');
            er.domainEmitter = this;
            er.domain = domain;
            er.domainThrown = false;
            domain.emit("error", er);
        } else if (er instanceof Error) throw er; // Unhandled 'error' event
        else {
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
            err.context = er;
            throw err;
        }
        return false;
    }
    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === "function";
    len = arguments.length;
    switch(len){
        // fast cases
        case 1:
            emitNone(handler, isFn, this);
            break;
        case 2:
            emitOne(handler, isFn, this, arguments[1]);
            break;
        case 3:
            emitTwo(handler, isFn, this, arguments[1], arguments[2]);
            break;
        case 4:
            emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
            break;
        // slower
        default:
            args = new Array(len - 1);
            for(i = 1; i < len; i++)args[i - 1] = arguments[i];
            emitMany(handler, isFn, this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
        events = target._events = new EventHandlers();
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else // If we've already got an array, just append.
        if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        if (!existing.warned) {
            m = $getMaxListeners(target);
            if (m && m > 0 && existing.length > m) {
                existing.warned = true;
                var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type + " listeners added. " + "Use emitter.setMaxListeners() to increase limit");
                w.name = "MaxListenersExceededWarning";
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                emitWarning(w);
            }
        }
    }
    return target;
}
function emitWarning(e) {
    typeof console.warn === "function" ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function _onceWrap(target, type, listener) {
    var fired = false;
    function g() {
        target.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(target, arguments);
        }
    }
    g.listener = listener;
    return g;
}
EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;
    if (list === listener || list.listener && list.listener === listener) {
        if (--this._eventsCount === 0) this._events = new EventHandlers();
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
                this._events = new EventHandlers();
                return this;
            } else delete events[type];
        } else spliceOne(list, position);
        if (events.removeListener) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener) {
    return this.removeListener(type, listener);
};
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this;
    // not listening for removeListener, no need to emit
    if (!events.removeListener) {
        if (arguments.length === 0) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
        } else if (events[type]) {
            if (--this._eventsCount === 0) this._events = new EventHandlers();
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        for(var i = 0, key; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    do this.removeListener(type, listeners[listeners.length - 1]);
    while (listeners[0]);
    return this;
};
EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];
    else {
        evlistener = events[type];
        if (!evlistener) ret = [];
        else if (typeof evlistener === "function") ret = [
            evlistener.listener || evlistener
        ];
        else ret = unwrapListeners(evlistener);
    }
    return ret;
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
function arrayClone(arr, i) {
    var copy = new Array(i);
    while(i--)copy[i] = arr[i];
    return copy;
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
var _polyfillNode_events = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    EventEmitter: EventEmitter,
    default: EventEmitter
});
var require$$1$1 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_events);
var streamBrowser = require$$1$1.EventEmitter;
var require$$0 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_buffer);
var inherits$2;
if (typeof Object.create === "function") inherits$2 = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else inherits$2 = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var inherits$3 = inherits$2;
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var formatRegExp = /%[sdj%]/g;
function format(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect$1(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
    else str += " " + inspect$1(x);
    return str;
}
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function deprecate$1(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global$1.process)) return function() {
        return deprecate$1(fn, msg).apply(this, arguments);
    };
    if (browser$1$1.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (browser$1$1.throwDeprecation) throw new Error(msg);
            else if (browser$1$1.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
var debugs = {};
var debugEnviron;
function debuglog(set) {
    if (isUndefined(debugEnviron)) debugEnviron = browser$1$1.env.NODE_DEBUG || "";
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
            var pid = 0;
            debugs[set] = function() {
                var msg = format.apply(null, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect$1(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    _extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect$1.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect$1.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function stylizeWithColor(str, styleType) {
    var style = inspect$1.styles[styleType];
    if (style) return "\x1b[" + inspect$1.colors[style][0] + "m" + str + "\x1b[" + inspect$1.colors[style][1] + "m";
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== inspect$1 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if (isError(value)) return formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = " " + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if (isNumber(value)) return ctx.stylize("" + value, "number");
    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize("null", "null");
}
function formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf("\n");
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
    return Array.isArray(ar);
}
function isBoolean(arg) {
    return typeof arg === "boolean";
}
function isNull(arg) {
    return arg === null;
}
function isNullOrUndefined(arg) {
    return arg == null;
}
function isNumber(arg) {
    return typeof arg === "number";
}
function isString(arg) {
    return typeof arg === "string";
}
function isSymbol(arg) {
    return typeof arg === "symbol";
}
function isUndefined(arg) {
    return arg === void 0;
}
function isRegExp(re) {
    return isObject(re) && objectToString(re) === "[object RegExp]";
}
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
function isError(e) {
    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
}
function isFunction(arg) {
    return typeof arg === "function";
}
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
function isBuffer(maybeBuf) {
    return Buffer$2.isBuffer(maybeBuf);
}
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad$1(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad$1(d.getHours()),
        pad$1(d.getMinutes()),
        pad$1(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
function log() {
    console.log("%s - %s", timestamp(), format.apply(null, arguments));
}
function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
}
promisify.custom = kCustomPromisifiedSymbol;
function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self1 = this;
        var cb = function() {
            return maybeCb.apply(self1, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            browser$1$1.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            browser$1$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
}
var _polyfillNode_util = {
    inherits: inherits$3,
    _extend: _extend,
    log: log,
    isBuffer: isBuffer,
    isPrimitive: isPrimitive,
    isFunction: isFunction,
    isError: isError,
    isDate: isDate,
    isObject: isObject,
    isRegExp: isRegExp,
    isUndefined: isUndefined,
    isSymbol: isSymbol,
    isString: isString,
    isNumber: isNumber,
    isNullOrUndefined: isNullOrUndefined,
    isNull: isNull,
    isBoolean: isBoolean,
    isArray: isArray,
    inspect: inspect$1,
    deprecate: deprecate$1,
    format: format,
    debuglog: debuglog,
    promisify: promisify,
    callbackify: callbackify
};
var _polyfillNode_util$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    _extend: _extend,
    callbackify: callbackify,
    debuglog: debuglog,
    default: _polyfillNode_util,
    deprecate: deprecate$1,
    format: format,
    inherits: inherits$3,
    inspect: inspect$1,
    isArray: isArray,
    isBoolean: isBoolean,
    isBuffer: isBuffer,
    isDate: isDate,
    isError: isError,
    isFunction: isFunction,
    isNull: isNull,
    isNullOrUndefined: isNullOrUndefined,
    isNumber: isNumber,
    isObject: isObject,
    isPrimitive: isPrimitive,
    isRegExp: isRegExp,
    isString: isString,
    isSymbol: isSymbol,
    isUndefined: isUndefined,
    log: log,
    promisify: promisify
});
var require$$3 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_util$1);
var buffer_list;
var hasRequiredBuffer_list;
function requireBuffer_list() {
    if (hasRequiredBuffer_list) return buffer_list;
    hasRequiredBuffer_list = 1;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var _require = require$$0, Buffer = _require.Buffer;
    var _require2 = require$$3, inspect = _require2.inspect;
    var custom = inspect && inspect.custom || "inspect";
    function copyBuffer(src, target, offset) {
        Buffer.prototype.copy.call(src, target, offset);
    }
    buffer_list = /*#__PURE__*/ function() {
        function BufferList() {
            _classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        _createClass(BufferList, [
            {
                key: "push",
                value: function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                }
            },
            {
                key: "unshift",
                value: function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
            },
            {
                key: "join",
                value: function join(s) {
                    if (this.length === 0) return "";
                    var p = this.head;
                    var ret = "" + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                }
            },
            {
                key: "concat",
                value: function concat(n) {
                    if (this.length === 0) return Buffer.alloc(0);
                    var ret = Buffer.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                } // Consumes a specified amount of bytes or characters from the buffered data.
            },
            {
                key: "consume",
                value: function consume(n, hasStrings) {
                    var ret;
                    if (n < this.head.data.length) {
                        // `slice` is the same for buffers and strings.
                        ret = this.head.data.slice(0, n);
                        this.head.data = this.head.data.slice(n);
                    } else if (n === this.head.data.length) // First chunk is a perfect match.
                    ret = this.shift();
                    else // Result spans more than one buffer.
                    ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                    return ret;
                }
            },
            {
                key: "first",
                value: function first() {
                    return this.head.data;
                } // Consumes a specified amount of characters from the buffered data.
            },
            {
                key: "_getString",
                value: function _getString(n) {
                    var p = this.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                } // Consumes a specified amount of bytes from the buffered data.
            },
            {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                    var ret = Buffer.allocUnsafe(n);
                    var p = this.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                } // Make sure the linked list only shows the minimal necessary information.
            },
            {
                key: custom,
                value: function value(_, options) {
                    return inspect(this, _objectSpread({}, options, {
                        // Only inspect one level.
                        depth: 0,
                        // It should not recurse.
                        customInspect: false
                    }));
                }
            }
        ]);
        return BufferList;
    }();
    return buffer_list;
}
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) browser$1$1.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                browser$1$1.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) browser$1$1.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                browser$1$1.nextTick(emitErrorAndCloseNT, _this, err);
            } else browser$1$1.nextTick(emitCloseNT, _this);
        } else if (cb) {
            browser$1$1.nextTick(emitCloseNT, _this);
            cb(err);
        } else browser$1$1.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self1, err) {
    emitErrorNT(self1, err);
    emitCloseNT(self1);
}
function emitCloseNT(self1) {
    if (self1._writableState && !self1._writableState.emitClose) return;
    if (self1._readableState && !self1._readableState.emitClose) return;
    self1.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self1, err) {
    self1.emit("error", err);
}
function errorOrDestroy$2(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
var destroy_1 = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy$2
};
var errorsBrowser = {};
function _inheritsLoose1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose1(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark$2(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
var state = {
    getHighWaterMark: getHighWaterMark$2
};
var inherits;
if (typeof Object.create === "function") inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var inherits$1 = inherits;
var _polyfillNode_inherits = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    default: inherits$1
});
var require$$1 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_inherits);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var isBufferEncoding = Buffer$2.isEncoding || function(encoding) {
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) throw new Error("Unknown encoding: " + encoding);
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
function StringDecoder$1(encoding) {
    this.encoding = (encoding || "utf8").toLowerCase().replace(/[-_]/, "");
    assertEncoding(encoding);
    switch(this.encoding){
        case "utf8":
            // CESU-8 represents each of Surrogate Pair by 3-bytes
            this.surrogateSize = 3;
            break;
        case "ucs2":
        case "utf16le":
            // UTF-16 represents each of Surrogate Pair by 2-bytes
            this.surrogateSize = 2;
            this.detectIncompleteChar = utf16DetectIncompleteChar;
            break;
        case "base64":
            // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
            this.surrogateSize = 3;
            this.detectIncompleteChar = base64DetectIncompleteChar;
            break;
        default:
            this.write = passThroughWrite;
            return;
    }
    // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    this.charBuffer = new Buffer$2(6);
    // Number of bytes received for the current incomplete multi-byte character.
    this.charReceived = 0;
    // Number of bytes expected for the current incomplete multi-byte character.
    this.charLength = 0;
}
// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder$1.prototype.write = function(buffer) {
    var charStr = "";
    // if our last write ended with an incomplete multibyte character
    while(this.charLength){
        // determine how many remaining bytes this buffer has to offer for this char
        var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
        // add the new bytes to the char buffer
        buffer.copy(this.charBuffer, this.charReceived, 0, available);
        this.charReceived += available;
        if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
        return "";
        // remove bytes belonging to the current character from the buffer
        buffer = buffer.slice(available, buffer.length);
        // get the character that was split
        charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
        // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        var charCode = charStr.charCodeAt(charStr.length - 1);
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            this.charLength += this.surrogateSize;
            charStr = "";
            continue;
        }
        this.charReceived = this.charLength = 0;
        // if there are no more bytes in this buffer, just emit our char
        if (buffer.length === 0) return charStr;
        break;
    }
    // determine and set charLength / charReceived
    this.detectIncompleteChar(buffer);
    var end = buffer.length;
    if (this.charLength) {
        // buffer the incomplete character bytes we got
        buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
        end -= this.charReceived;
    }
    charStr += buffer.toString(this.encoding, 0, end);
    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        var size = this.surrogateSize;
        this.charLength += size;
        this.charReceived += size;
        this.charBuffer.copy(this.charBuffer, size, 0, size);
        buffer.copy(this.charBuffer, 0, 0, size);
        return charStr.substring(0, end);
    }
    // or just emit the charStr
    return charStr;
};
// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder$1.prototype.detectIncompleteChar = function(buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = buffer.length >= 3 ? 3 : buffer.length;
    // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.
    for(; i > 0; i--){
        var c = buffer[buffer.length - i];
        // See http://en.wikipedia.org/wiki/UTF-8#Description
        // 110XXXXX
        if (i == 1 && c >> 5 == 0x06) {
            this.charLength = 2;
            break;
        }
        // 1110XXXX
        if (i <= 2 && c >> 4 == 0x0E) {
            this.charLength = 3;
            break;
        }
        // 11110XXX
        if (i <= 3 && c >> 3 == 0x1E) {
            this.charLength = 4;
            break;
        }
    }
    this.charReceived = i;
};
StringDecoder$1.prototype.end = function(buffer) {
    var res = "";
    if (buffer && buffer.length) res = this.write(buffer);
    if (this.charReceived) {
        var cr = this.charReceived;
        var buf = this.charBuffer;
        var enc = this.encoding;
        res += buf.slice(0, cr).toString(enc);
    }
    return res;
};
function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
}
function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
}
function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
}
var _polyfillNode_string_decoder = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    StringDecoder: StringDecoder$1
});
var require$$10 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_string_decoder);
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop$1() {}
function isRequest$1(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos$1(stream, opts, callback) {
    if (typeof opts === "function") return eos$1(stream, null, opts);
    if (!opts) opts = {};
    callback = once$1(callback || noop$1);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest$1(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
var endOfStream = eos$1;
var async_iterator;
var hasRequiredAsync_iterator;
function requireAsync_iterator() {
    if (hasRequiredAsync_iterator) return async_iterator;
    hasRequiredAsync_iterator = 1;
    var _Object$setPrototypeO;
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var finished = endOfStream;
    var kLastResolve = Symbol("lastResolve");
    var kLastReject = Symbol("lastReject");
    var kError = Symbol("error");
    var kEnded = Symbol("ended");
    var kLastPromise = Symbol("lastPromise");
    var kHandlePromise = Symbol("handlePromise");
    var kStream = Symbol("stream");
    function createIterResult(value, done) {
        return {
            value: value,
            done: done
        };
    }
    function readAndResolve(iter) {
        var resolve = iter[kLastResolve];
        if (resolve !== null) {
            var data = iter[kStream].read(); // we defer if data is null
            // we can be expecting either 'end' or
            // 'error'
            if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve(createIterResult(data, false));
            }
        }
    }
    function onReadable(iter) {
        // we wait for the next tick, because it might
        // emit an error with process.nextTick
        browser$1$1.nextTick(readAndResolve, iter);
    }
    function wrapForNext(lastPromise, iter) {
        return function(resolve, reject) {
            lastPromise.then(function() {
                if (iter[kEnded]) {
                    resolve(createIterResult(undefined, true));
                    return;
                }
                iter[kHandlePromise](resolve, reject);
            }, reject);
        };
    }
    var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
    var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
        get stream () {
            return this[kStream];
        },
        next: function next() {
            var _this = this;
            // if we have detected an error in the meanwhile
            // reject straight away
            var error = this[kError];
            if (error !== null) return Promise.reject(error);
            if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
            if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
            // called, the error will be emitted via nextTick, and
            // we cannot guarantee that there is no error lingering around
            // waiting to be emitted.
            return new Promise(function(resolve, reject) {
                browser$1$1.nextTick(function() {
                    if (_this[kError]) reject(_this[kError]);
                    else resolve(createIterResult(undefined, true));
                });
            });
             // if we have multiple next() calls
            // we will wait for the previous Promise to finish
            // this logic is optimized to support for await loops,
            // where next() is only called once at a time
            var lastPromise = this[kLastPromise];
            var promise;
            if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
            else {
                // fast path needed to support multiple this.push()
                // without triggering the next() queue
                var data = this[kStream].read();
                if (data !== null) return Promise.resolve(createIterResult(data, false));
                promise = new Promise(this[kHandlePromise]);
            }
            this[kLastPromise] = promise;
            return promise;
        }
    }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
        return this;
    }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
        var _this2 = this;
        // destroy(err, cb) is a private API
        // we can guarantee we have that here, because we control the
        // Readable class this is attached to
        return new Promise(function(resolve, reject) {
            _this2[kStream].destroy(null, function(err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(createIterResult(undefined, true));
            });
        });
    }), _Object$setPrototypeO), AsyncIteratorPrototype);
    var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
        var _Object$create;
        var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
            value: stream,
            writable: true
        }), _defineProperty(_Object$create, kLastResolve, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kLastReject, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kError, {
            value: null,
            writable: true
        }), _defineProperty(_Object$create, kEnded, {
            value: stream._readableState.endEmitted,
            writable: true
        }), _defineProperty(_Object$create, kHandlePromise, {
            value: function value(resolve, reject) {
                var data = iterator[kStream].read();
                if (data) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    resolve(createIterResult(data, false));
                } else {
                    iterator[kLastResolve] = resolve;
                    iterator[kLastReject] = reject;
                }
            },
            writable: true
        }), _Object$create));
        iterator[kLastPromise] = null;
        finished(stream, function(err) {
            if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                // returned by next() and store the error
                if (reject !== null) {
                    iterator[kLastPromise] = null;
                    iterator[kLastResolve] = null;
                    iterator[kLastReject] = null;
                    reject(err);
                }
                iterator[kError] = err;
                return;
            }
            var resolve = iterator[kLastResolve];
            if (resolve !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(undefined, true));
            }
            iterator[kEnded] = true;
        });
        stream.on("readable", onReadable.bind(null, iterator));
        return iterator;
    };
    async_iterator = createReadableStreamAsyncIterator;
    return async_iterator;
}
var fromBrowser;
var hasRequiredFromBrowser;
function requireFromBrowser() {
    if (hasRequiredFromBrowser) return fromBrowser;
    hasRequiredFromBrowser = 1;
    fromBrowser = function fromBrowser() {
        throw new Error("Readable.from is not available in the browser");
    };
    return fromBrowser;
}
var Registry$4 = _registry;
Registry$4.Readable = Readable;
Readable.ReadableState = ReadableState;
/*<replacement>*/ require$$1$1.EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream$1 = streamBrowser;
/*</replacement>*/ var Buffer$1 = require$$0.Buffer;
var OurUint8Array$1 = commonjsGlobal.Uint8Array || function() {};
function _uint8ArrayToBuffer$1(chunk) {
    return Buffer$1.from(chunk);
}
function _isUint8Array$1(obj) {
    return Buffer$1.isBuffer(obj) || obj instanceof OurUint8Array$1;
}
/*<replacement>*/ var debugUtil = require$$3;
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = requireBuffer_list();
var destroyImpl$1 = destroy_1;
var _require$1 = state, getHighWaterMark$1 = _require$1.getHighWaterMark;
var _require$codes$3 = errorsBrowser.codes, ERR_INVALID_ARG_TYPE$1 = _require$codes$3.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes$3.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED$2 = _require$codes$3.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes$3.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require$$1(Readable, Stream$1);
var errorOrDestroy$1 = destroyImpl$1.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Registry$4.Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark$1(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require$$10.StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Registry$4.Duplex;
    this._readableState = new ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream$1.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl$1.destroy;
Readable.prototype._undestroy = destroyImpl$1.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer$1.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy$1(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer$1.prototype) chunk = _uint8ArrayToBuffer$1(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy$1(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy$1(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array$1(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE$1("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require$$10.StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        browser$1$1.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        browser$1$1.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy$1(this, new ERR_METHOD_NOT_IMPLEMENTED$2("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== browser$1$1.stdout && dest !== browser$1$1.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) browser$1$1.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy$1(dest, er);
    } // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream$1.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) browser$1$1.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream$1.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    browser$1$1.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream$1.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    browser$1$1.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        browser$1$1.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = requireAsync_iterator();
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        browser$1$1.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = requireFromBrowser();
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
/**
 * Module exports.
 */ var browser = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!commonjsGlobal.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = commonjsGlobal.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}
var Registry$3 = _registry;
Registry$3.Writable = Writable;
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ /*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: browser
};
/*</replacement>*/ /*<replacement>*/ var Stream = streamBrowser;
/*</replacement>*/ var Buffer = require$$0.Buffer;
var OurUint8Array = commonjsGlobal.Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = destroy_1;
var _require = state, getHighWaterMark = _require.getHighWaterMark;
var _require$codes$2 = errorsBrowser.codes, ERR_INVALID_ARG_TYPE = _require$codes$2.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED$1 = _require$codes$2.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK$1 = _require$codes$2.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes$2.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED$1 = _require$codes$2.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes$2.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes$2.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes$2.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require$$1(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Registry$3.Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Registry$3.Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    browser$1$1.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        browser$1$1.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED$1("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        browser$1$1.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        browser$1$1.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK$1();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) browser$1$1.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED$1("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish$1(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            browser$1$1.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish$1(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) browser$1$1.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
/*<replacement>*/ var objectKeys$1 = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ var Registry$2 = _registry;
Registry$2.Duplex = Duplex;
require$$1(Duplex, Registry$2.Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys$1(Registry$2.Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Registry$2.Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Registry$2.Readable.call(this, options);
    Registry$2.Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    browser$1$1.nextTick(onEndNT, this);
}
function onEndNT(self1) {
    self1.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
var Registry$1 = _registry;
Registry$1.Transform = Transform$1;
var _require$codes$1 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$1.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$1.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$1.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$1.ERR_TRANSFORM_WITH_LENGTH_0;
require$$1(Transform$1, Registry$1.Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform$1(options) {
    if (!(this instanceof Transform$1)) return new Transform$1(options);
    Registry$1.Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform$1.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Registry$1.Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform$1.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$1.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform$1.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform$1.prototype._destroy = function(err, cb) {
    Registry$1.Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}
var Registry = _registry;
Registry.PassThrough = PassThrough;
require$$1(PassThrough, Registry.Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = errorsBrowser.codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = endOfStream;
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
var pipeline_1 = pipeline;
(function(module, exports) {
    var Registry = _registry;
    exports = module.exports = Registry.Readable;
    exports.Stream = Registry.Readable;
    exports.Readable = Registry.Readable;
    exports.Writable = Registry.Writable;
    exports.Duplex = Registry.Duplex;
    exports.Transform = Registry.Transform;
    exports.PassThrough = Registry.PassThrough;
    exports.finished = endOfStream;
    exports.pipeline = pipeline_1;
})(readableBrowser, readableBrowser.exports);
var readableBrowserExports = readableBrowser.exports;
var stream = /*@__PURE__*/ getDefaultExportFromCjs(readableBrowserExports);
var lib = {};
var binding = {};
function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var hasOwn = Object.prototype.hasOwnProperty;
var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)if (hasOwn.call(obj, key)) keys.push(key);
    return keys;
};
var pSlice = Array.prototype.slice;
var _functionsHaveNames;
function functionsHaveNames() {
    if (typeof _functionsHaveNames !== "undefined") return _functionsHaveNames;
    return _functionsHaveNames = function() {
        return (function foo() {}).name === "foo";
    }();
}
function pToString(obj) {
    return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
    if (isBuffer$1(arrbuf)) return false;
    if (typeof global$1.ArrayBuffer !== "function") return false;
    if (typeof ArrayBuffer.isView === "function") return ArrayBuffer.isView(arrbuf);
    if (!arrbuf) return false;
    if (arrbuf instanceof DataView) return true;
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
    return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
function assert(value, message) {
    if (!value) fail(value, true, message, "==", ok);
}
// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })
var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
    if (!isFunction(func)) return;
    if (functionsHaveNames()) return func.name;
    var str = func.toString();
    var match = str.match(regex);
    return match && match[1];
}
assert.AssertionError = AssertionError;
function AssertionError(options) {
    this.name = "AssertionError";
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
    } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || fail;
    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
    else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
            var out = err.stack;
            // try to strip useless frames
            var fn_name = getName(stackStartFunction);
            var idx = out.indexOf("\n" + fn_name);
            if (idx >= 0) {
                // once we have located the function frame
                // we need to strip out everything before it (and its line)
                var next_line = out.indexOf("\n", idx + 1);
                out = out.substring(next_line + 1);
            }
            this.stack = out;
        }
    }
}
// assert.AssertionError instanceof Error
inherits$3(AssertionError, Error);
function truncate(s, n) {
    if (typeof s === "string") return s.length < n ? s : s.slice(0, n);
    else return s;
}
function inspect(something) {
    if (functionsHaveNames() || !isFunction(something)) return inspect$1(something);
    var rawname = getName(something);
    var name = rawname ? ": " + rawname : "";
    return "[Function" + name + "]";
}
function getMessage(self1) {
    return truncate(inspect(self1.actual), 128) + " " + self1.operator + " " + truncate(inspect(self1.expected), 128);
}
// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.
// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function fail(actual, expected, message, operator, stackStartFunction) {
    throw new AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
    });
}
// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;
// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.
function ok(value, message) {
    if (!value) fail(value, true, message, "==", ok);
}
assert.ok = ok;
// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);
assert.equal = equal;
function equal(actual, expected, message) {
    if (actual != expected) fail(actual, expected, message, "==", equal);
}
// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);
assert.notEqual = notEqual;
function notEqual(actual, expected, message) {
    if (actual == expected) fail(actual, expected, message, "!=", notEqual);
}
// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);
assert.deepEqual = deepEqual;
function deepEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, false)) fail(actual, expected, message, "deepEqual", deepEqual);
}
assert.deepStrictEqual = deepStrictEqual;
function deepStrictEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, true)) fail(actual, expected, message, "deepStrictEqual", deepStrictEqual);
}
function _deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (isBuffer$1(actual) && isBuffer$1(expected)) return compare(actual, expected) === 0;
    else if (isDate(actual) && isDate(expected)) return actual.getTime() === expected.getTime();
    else if (isRegExp(actual) && isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
    else if ((actual === null || typeof actual !== "object") && (expected === null || typeof expected !== "object")) return strict ? actual === expected : actual == expected;
    else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
    else if (isBuffer$1(actual) !== isBuffer$1(expected)) return false;
    else {
        memos = memos || {
            actual: [],
            expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
            if (actualIndex === memos.expected.indexOf(expected)) return true;
        }
        memos.actual.push(actual);
        memos.expected.push(expected);
        return objEquiv(actual, expected, strict, memos);
    }
}
function isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
}
function objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    // if one is a primitive, the other must be same
    if (isPrimitive(a) || isPrimitive(b)) return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
    var aIsArgs = isArguments(a);
    var bIsArgs = isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
    }
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] !== kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
    }
    return true;
}
// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);
assert.notDeepEqual = notDeepEqual;
function notDeepEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, false)) fail(actual, expected, message, "notDeepEqual", notDeepEqual);
}
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, true)) fail(actual, expected, message, "notDeepStrictEqual", notDeepStrictEqual);
}
// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);
assert.strictEqual = strictEqual;
function strictEqual(actual, expected, message) {
    if (actual !== expected) fail(actual, expected, message, "===", strictEqual);
}
// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
assert.notStrictEqual = notStrictEqual;
function notStrictEqual(actual, expected, message) {
    if (actual === expected) fail(actual, expected, message, "!==", notStrictEqual);
}
function expectedException(actual, expected) {
    if (!actual || !expected) return false;
    if (Object.prototype.toString.call(expected) == "[object RegExp]") return expected.test(actual);
    try {
        if (actual instanceof expected) return true;
    } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
    }
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function _tryBlock(block) {
    var error;
    try {
        block();
    } catch (e) {
        error = e;
    }
    return error;
}
function _throws(shouldThrow, block, expected, message) {
    var actual;
    if (typeof block !== "function") throw new TypeError('"block" argument must be a function');
    if (typeof expected === "string") {
        message = expected;
        expected = null;
    }
    actual = _tryBlock(block);
    message = (expected && expected.name ? " (" + expected.name + ")." : ".") + (message ? " " + message : ".");
    if (shouldThrow && !actual) fail(actual, expected, "Missing expected exception" + message);
    var userProvidedMessage = typeof message === "string";
    var isUnwantedException = !shouldThrow && isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
    if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) fail(actual, expected, "Got unwanted exception" + message);
    if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) throw actual;
}
// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);
assert.throws = throws;
function throws(block, /*optional*/ error, /*optional*/ message) {
    _throws(true, block, error, message);
}
// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = doesNotThrow;
function doesNotThrow(block, /*optional*/ error, /*optional*/ message) {
    _throws(false, block, error, message);
}
assert.ifError = ifError;
function ifError(err) {
    if (err) throw err;
}
var _polyfillNode_assert = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AssertionError: AssertionError,
    assert: ok,
    deepEqual: deepEqual,
    deepStrictEqual: deepStrictEqual,
    default: assert,
    doesNotThrow: doesNotThrow,
    equal: equal,
    fail: fail,
    ifError: ifError,
    notDeepEqual: notDeepEqual,
    notDeepStrictEqual: notDeepStrictEqual,
    notEqual: notEqual,
    notStrictEqual: notStrictEqual,
    ok: ok,
    strictEqual: strictEqual,
    throws: throws
});
var require$$4 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_assert);
(function(exports) {
    /* eslint camelcase: "off" */ var assert = require$$4;
    var Zstream = (0, _zstreamJsDefault.default);
    var zlib_deflate = (0, _deflateJsDefault.default);
    var zlib_inflate = (0, _inflateJsDefault.default);
    var constants = (0, _constantsJsDefault.default);
    for(var key in constants)exports[key] = constants[key];
    // zlib modes
    exports.NONE = 0;
    exports.DEFLATE = 1;
    exports.INFLATE = 2;
    exports.GZIP = 3;
    exports.GUNZIP = 4;
    exports.DEFLATERAW = 5;
    exports.INFLATERAW = 6;
    exports.UNZIP = 7;
    var GZIP_HEADER_ID1 = 0x1f;
    var GZIP_HEADER_ID2 = 0x8b;
    /**
   * Emulate Node's zlib C++ layer for use by the JS layer in index.js
   */ function Zlib(mode) {
        if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null;
        this.err = 0;
        this.flush = 0;
        this.init_done = false;
        this.level = 0;
        this.memLevel = 0;
        this.mode = mode;
        this.strategy = 0;
        this.windowBits = 0;
        this.write_in_progress = false;
        this.pending_close = false;
        this.gzip_id_bytes_read = 0;
    }
    Zlib.prototype.close = function() {
        if (this.write_in_progress) {
            this.pending_close = true;
            return;
        }
        this.pending_close = false;
        assert(this.init_done, "close before init");
        assert(this.mode <= exports.UNZIP);
        if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
        else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
        this.mode = exports.NONE;
        this.dictionary = null;
    };
    Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
        assert.equal(arguments.length, 8);
        assert(this.init_done, "write before init");
        assert(this.mode !== exports.NONE, "already finalized");
        assert.equal(false, this.write_in_progress, "write already in progress");
        assert.equal(false, this.pending_close, "close is pending");
        this.write_in_progress = true;
        assert.equal(false, flush === undefined, "must provide flush value");
        this.write_in_progress = true;
        if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
        if (input == null) {
            input = Buffer$2.alloc(0);
            in_len = 0;
            in_off = 0;
        }
        this.strm.avail_in = in_len;
        this.strm.input = input;
        this.strm.next_in = in_off;
        this.strm.avail_out = out_len;
        this.strm.output = out;
        this.strm.next_out = out_off;
        this.flush = flush;
        if (!async) {
            // sync version
            this._process();
            if (this._checkError()) return this._afterSync();
            return;
        }
        // async version
        var self1 = this;
        browser$1$1.nextTick(function() {
            self1._process();
            self1._after();
        });
        return this;
    };
    Zlib.prototype._afterSync = function() {
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        return [
            avail_in,
            avail_out
        ];
    };
    Zlib.prototype._process = function() {
        var next_expected_header_byte = null;
        // If the avail_out is left at 0, then it means that it ran out
        // of room.  If there was avail_out left over, then it means
        // that all of the input was consumed.
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflate(this.strm, this.flush);
                break;
            case exports.UNZIP:
                if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                switch(this.gzip_id_bytes_read){
                    case 0:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                            this.gzip_id_bytes_read = 1;
                            next_expected_header_byte++;
                            if (this.strm.avail_in === 1) break;
                        } else {
                            this.mode = exports.INFLATE;
                            break;
                        }
                    // fallthrough
                    case 1:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                            this.gzip_id_bytes_read = 2;
                            this.mode = exports.GUNZIP;
                        } else // There is no actual difference between INFLATE and INFLATERAW
                        // (after initialization).
                        this.mode = exports.INFLATE;
                        break;
                    default:
                        throw new Error("invalid number of gzip magic number bytes read");
                }
            // fallthrough
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                    // Load it
                    this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                    if (this.err === exports.Z_OK) // And try to decode again
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                    else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                    // Make it possible for After() to tell a bad dictionary from bad
                    // input.
                    this.err = exports.Z_NEED_DICT;
                }
                while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                    // Bytes remain in input buffer. Perhaps this is another compressed
                    // member in the same archive, or just trailing garbage.
                    // Trailing zero bytes are okay, though, since they are frequently
                    // used for padding.
                    this.reset();
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                }
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
    };
    Zlib.prototype._checkError = function() {
        // Acceptable error states depend on the type of zlib stream.
        switch(this.err){
            case exports.Z_OK:
            case exports.Z_BUF_ERROR:
                if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                    this._error("unexpected end of file");
                    return false;
                }
                break;
            case exports.Z_STREAM_END:
                break;
            case exports.Z_NEED_DICT:
                if (this.dictionary == null) this._error("Missing dictionary");
                else this._error("Bad dictionary");
                return false;
            default:
                // something else.
                this._error("Zlib error");
                return false;
        }
        return true;
    };
    Zlib.prototype._after = function() {
        if (!this._checkError()) return;
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        // call the write() cb
        this.callback(avail_in, avail_out);
        if (this.pending_close) this.close();
    };
    Zlib.prototype._error = function(message) {
        if (this.strm.msg) message = this.strm.msg;
        this.onerror(message, this.err);
        this.write_in_progress = false;
        if (this.pending_close) this.close();
    };
    Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
        assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
        assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
        assert(level >= -1 && level <= 9, "invalid compression level");
        assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
        assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
        this._init(level, windowBits, memLevel, strategy, dictionary);
        this._setDictionary();
    };
    Zlib.prototype.params = function() {
        throw new Error("deflateParams Not supported");
    };
    Zlib.prototype.reset = function() {
        this._reset();
        this._setDictionary();
    };
    Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
        this.level = level;
        this.windowBits = windowBits;
        this.memLevel = memLevel;
        this.strategy = strategy;
        this.flush = exports.Z_NO_FLUSH;
        this.err = exports.Z_OK;
        if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
        if (this.mode === exports.UNZIP) this.windowBits += 32;
        if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
        this.strm = new Zstream();
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                break;
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
            case exports.UNZIP:
                this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
        if (this.err !== exports.Z_OK) this._error("Init error");
        this.dictionary = dictionary;
        this.write_in_progress = false;
        this.init_done = true;
    };
    Zlib.prototype._setDictionary = function() {
        if (this.dictionary == null) return;
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
    };
    Zlib.prototype._reset = function() {
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
            case exports.GZIP:
                this.err = zlib_deflate.deflateReset(this.strm);
                break;
            case exports.INFLATE:
            case exports.INFLATERAW:
            case exports.GUNZIP:
                this.err = zlib_inflate.inflateReset(this.strm);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
    };
    exports.Zlib = Zlib;
})(binding);
(function(exports) {
    var Buffer = require$$0.Buffer;
    var Transform1 = readableBrowserExports.Transform;
    var binding$1 = binding;
    var util = require$$3;
    var assert = require$$4.ok;
    var kMaxLength = require$$0.kMaxLength;
    var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
    // zlib doesn't provide these, so kludge them in following the same
    // const naming scheme zlib uses.
    binding$1.Z_MIN_WINDOWBITS = 8;
    binding$1.Z_MAX_WINDOWBITS = 15;
    binding$1.Z_DEFAULT_WINDOWBITS = 15;
    // fewer than 64 bytes per chunk is stupid.
    // technically it could work with as few as 8, but even 64 bytes
    // is absurdly low.  Usually a MB or more is best.
    binding$1.Z_MIN_CHUNK = 64;
    binding$1.Z_MAX_CHUNK = Infinity;
    binding$1.Z_DEFAULT_CHUNK = 16384;
    binding$1.Z_MIN_MEMLEVEL = 1;
    binding$1.Z_MAX_MEMLEVEL = 9;
    binding$1.Z_DEFAULT_MEMLEVEL = 8;
    binding$1.Z_MIN_LEVEL = -1;
    binding$1.Z_MAX_LEVEL = 9;
    binding$1.Z_DEFAULT_LEVEL = binding$1.Z_DEFAULT_COMPRESSION;
    // expose all the zlib constants
    var bkeys = Object.keys(binding$1);
    for(var bk = 0; bk < bkeys.length; bk++){
        var bkey = bkeys[bk];
        if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
            enumerable: true,
            value: binding$1[bkey],
            writable: false
        });
    }
    // translation table for return codes.
    var codes = {
        Z_OK: binding$1.Z_OK,
        Z_STREAM_END: binding$1.Z_STREAM_END,
        Z_NEED_DICT: binding$1.Z_NEED_DICT,
        Z_ERRNO: binding$1.Z_ERRNO,
        Z_STREAM_ERROR: binding$1.Z_STREAM_ERROR,
        Z_DATA_ERROR: binding$1.Z_DATA_ERROR,
        Z_MEM_ERROR: binding$1.Z_MEM_ERROR,
        Z_BUF_ERROR: binding$1.Z_BUF_ERROR,
        Z_VERSION_ERROR: binding$1.Z_VERSION_ERROR
    };
    var ckeys = Object.keys(codes);
    for(var ck = 0; ck < ckeys.length; ck++){
        var ckey = ckeys[ck];
        codes[codes[ckey]] = ckey;
    }
    Object.defineProperty(exports, "codes", {
        enumerable: true,
        value: Object.freeze(codes),
        writable: false
    });
    exports.Deflate = Deflate;
    exports.Inflate = Inflate;
    exports.Gzip = Gzip;
    exports.Gunzip = Gunzip;
    exports.DeflateRaw = DeflateRaw;
    exports.InflateRaw = InflateRaw;
    exports.Unzip = Unzip;
    exports.createDeflate = function(o) {
        return new Deflate(o);
    };
    exports.createInflate = function(o) {
        return new Inflate(o);
    };
    exports.createDeflateRaw = function(o) {
        return new DeflateRaw(o);
    };
    exports.createInflateRaw = function(o) {
        return new InflateRaw(o);
    };
    exports.createGzip = function(o) {
        return new Gzip(o);
    };
    exports.createGunzip = function(o) {
        return new Gunzip(o);
    };
    exports.createUnzip = function(o) {
        return new Unzip(o);
    };
    // Convenience methods.
    // compress/decompress a string or buffer in one step.
    exports.deflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Deflate(opts), buffer, callback);
    };
    exports.deflateSync = function(buffer, opts) {
        return zlibBufferSync(new Deflate(opts), buffer);
    };
    exports.gzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gzip(opts), buffer, callback);
    };
    exports.gzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gzip(opts), buffer);
    };
    exports.deflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new DeflateRaw(opts), buffer, callback);
    };
    exports.deflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new DeflateRaw(opts), buffer);
    };
    exports.unzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Unzip(opts), buffer, callback);
    };
    exports.unzipSync = function(buffer, opts) {
        return zlibBufferSync(new Unzip(opts), buffer);
    };
    exports.inflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Inflate(opts), buffer, callback);
    };
    exports.inflateSync = function(buffer, opts) {
        return zlibBufferSync(new Inflate(opts), buffer);
    };
    exports.gunzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gunzip(opts), buffer, callback);
    };
    exports.gunzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gunzip(opts), buffer);
    };
    exports.inflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new InflateRaw(opts), buffer, callback);
    };
    exports.inflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new InflateRaw(opts), buffer);
    };
    function zlibBuffer(engine, buffer, callback) {
        var buffers = [];
        var nread = 0;
        engine.on("error", onError);
        engine.on("end", onEnd);
        engine.end(buffer);
        flow();
        function flow() {
            var chunk;
            while(null !== (chunk = engine.read())){
                buffers.push(chunk);
                nread += chunk.length;
            }
            engine.once("readable", flow);
        }
        function onError(err) {
            engine.removeListener("end", onEnd);
            engine.removeListener("readable", flow);
            callback(err);
        }
        function onEnd() {
            var buf;
            var err = null;
            if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
            else buf = Buffer.concat(buffers, nread);
            buffers = [];
            engine.close();
            callback(err, buf);
        }
    }
    function zlibBufferSync(engine, buffer) {
        if (typeof buffer === "string") buffer = Buffer.from(buffer);
        if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
        var flushFlag = engine._finishFlushFlag;
        return engine._processChunk(buffer, flushFlag);
    }
    // generic zlib
    // minimal 2-byte header
    function Deflate(opts) {
        if (!(this instanceof Deflate)) return new Deflate(opts);
        Zlib.call(this, opts, binding$1.DEFLATE);
    }
    function Inflate(opts) {
        if (!(this instanceof Inflate)) return new Inflate(opts);
        Zlib.call(this, opts, binding$1.INFLATE);
    }
    // gzip - bigger header, same deflate compression
    function Gzip(opts) {
        if (!(this instanceof Gzip)) return new Gzip(opts);
        Zlib.call(this, opts, binding$1.GZIP);
    }
    function Gunzip(opts) {
        if (!(this instanceof Gunzip)) return new Gunzip(opts);
        Zlib.call(this, opts, binding$1.GUNZIP);
    }
    // raw - no header
    function DeflateRaw(opts) {
        if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
        Zlib.call(this, opts, binding$1.DEFLATERAW);
    }
    function InflateRaw(opts) {
        if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
        Zlib.call(this, opts, binding$1.INFLATERAW);
    }
    // auto-detect header.
    function Unzip(opts) {
        if (!(this instanceof Unzip)) return new Unzip(opts);
        Zlib.call(this, opts, binding$1.UNZIP);
    }
    function isValidFlushFlag(flag) {
        return flag === binding$1.Z_NO_FLUSH || flag === binding$1.Z_PARTIAL_FLUSH || flag === binding$1.Z_SYNC_FLUSH || flag === binding$1.Z_FULL_FLUSH || flag === binding$1.Z_FINISH || flag === binding$1.Z_BLOCK;
    }
    // the Zlib class they all inherit from
    // This thing manages the queue of requests, and returns
    // true or false if there is anything in the queue when
    // you call the .write() method.
    function Zlib(opts, mode) {
        var _this = this;
        this._opts = opts = opts || {};
        this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
        Transform1.call(this, opts);
        if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
        if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
        this._flushFlag = opts.flush || binding$1.Z_NO_FLUSH;
        this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding$1.Z_FINISH;
        if (opts.chunkSize) {
            if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
        }
        if (opts.windowBits) {
            if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
        }
        if (opts.level) {
            if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
        }
        if (opts.memLevel) {
            if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
        }
        if (opts.strategy) {
            if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
        }
        if (opts.dictionary) {
            if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
        }
        this._handle = new binding$1.Zlib(mode);
        var self1 = this;
        this._hadError = false;
        this._handle.onerror = function(message, errno) {
            // there is no way to cleanly recover.
            // continuing only obscures problems.
            _close(self1);
            self1._hadError = true;
            var error = new Error(message);
            error.errno = errno;
            error.code = exports.codes[errno];
            self1.emit("error", error);
        };
        var level = exports.Z_DEFAULT_COMPRESSION;
        if (typeof opts.level === "number") level = opts.level;
        var strategy = exports.Z_DEFAULT_STRATEGY;
        if (typeof opts.strategy === "number") strategy = opts.strategy;
        this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
        this._buffer = Buffer.allocUnsafe(this._chunkSize);
        this._offset = 0;
        this._level = level;
        this._strategy = strategy;
        this.once("end", this.close);
        Object.defineProperty(this, "_closed", {
            get: function get() {
                return !_this._handle;
            },
            configurable: true,
            enumerable: true
        });
    }
    util.inherits(Zlib, Transform1);
    Zlib.prototype.params = function(level, strategy, callback) {
        if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
        if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
        if (this._level !== level || this._strategy !== strategy) {
            var self1 = this;
            this.flush(binding$1.Z_SYNC_FLUSH, function() {
                assert(self1._handle, "zlib binding closed");
                self1._handle.params(level, strategy);
                if (!self1._hadError) {
                    self1._level = level;
                    self1._strategy = strategy;
                    if (callback) callback();
                }
            });
        } else browser$1$1.nextTick(callback);
    };
    Zlib.prototype.reset = function() {
        assert(this._handle, "zlib binding closed");
        return this._handle.reset();
    };
    // This is the _flush function called by the transform class,
    // internally, when the last chunk has been written.
    Zlib.prototype._flush = function(callback) {
        this._transform(Buffer.alloc(0), "", callback);
    };
    Zlib.prototype.flush = function(kind, callback) {
        var _this2 = this;
        var ws = this._writableState;
        if (typeof kind === "function" || kind === undefined && !callback) {
            callback = kind;
            kind = binding$1.Z_FULL_FLUSH;
        }
        if (ws.ended) {
            if (callback) browser$1$1.nextTick(callback);
        } else if (ws.ending) {
            if (callback) this.once("end", callback);
        } else if (ws.needDrain) {
            if (callback) this.once("drain", function() {
                return _this2.flush(kind, callback);
            });
        } else {
            this._flushFlag = kind;
            this.write(Buffer.alloc(0), "", callback);
        }
    };
    Zlib.prototype.close = function(callback) {
        _close(this, callback);
        browser$1$1.nextTick(emitCloseNT, this);
    };
    function _close(engine, callback) {
        if (callback) browser$1$1.nextTick(callback);
        // Caller may invoke .close after a zlib error (which will null _handle).
        if (!engine._handle) return;
        engine._handle.close();
        engine._handle = null;
    }
    function emitCloseNT(self1) {
        self1.emit("close");
    }
    Zlib.prototype._transform = function(chunk, encoding, cb) {
        var flushFlag;
        var ws = this._writableState;
        var ending = ws.ending || ws.ended;
        var last = ending && (!chunk || ws.length === chunk.length);
        if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
        if (!this._handle) return cb(new Error("zlib binding closed"));
        // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
        // (or whatever flag was provided using opts.finishFlush).
        // If it's explicitly flushing at some other time, then we use
        // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
        // goodness.
        if (last) flushFlag = this._finishFlushFlag;
        else {
            flushFlag = this._flushFlag;
            // once we've flushed the last of the queue, stop flushing and
            // go back to the normal behavior.
            if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding$1.Z_NO_FLUSH;
        }
        this._processChunk(chunk, flushFlag, cb);
    };
    Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
        var availInBefore = chunk && chunk.length;
        var availOutBefore = this._chunkSize - this._offset;
        var inOff = 0;
        var self1 = this;
        var async = typeof cb === "function";
        if (!async) {
            var buffers = [];
            var nread = 0;
            var error;
            this.on("error", function(er) {
                error = er;
            });
            assert(this._handle, "zlib binding closed");
            do var res = this._handle.writeSync(flushFlag, chunk, // in
            inOff, // in_off
            availInBefore, // in_len
            this._buffer, // out
            this._offset, //out_off
            availOutBefore); // out_len
            while (!this._hadError && callback(res[0], res[1]));
            if (this._hadError) throw error;
            if (nread >= kMaxLength) {
                _close(this);
                throw new RangeError(kRangeErrorMessage);
            }
            var buf = Buffer.concat(buffers, nread);
            _close(this);
            return buf;
        }
        assert(this._handle, "zlib binding closed");
        var req = this._handle.write(flushFlag, chunk, // in
        inOff, // in_off
        availInBefore, // in_len
        this._buffer, // out
        this._offset, //out_off
        availOutBefore); // out_len
        req.buffer = chunk;
        req.callback = callback;
        function callback(availInAfter, availOutAfter) {
            // When the callback is used in an async write, the callback's
            // context is the `req` object that was created. The req object
            // is === this._handle, and that's why it's important to null
            // out the values after they are done being used. `this._handle`
            // can stay in memory longer than the callback and buffer are needed.
            if (this) {
                this.buffer = null;
                this.callback = null;
            }
            if (self1._hadError) return;
            var have = availOutBefore - availOutAfter;
            assert(have >= 0, "have should not go down");
            if (have > 0) {
                var out = self1._buffer.slice(self1._offset, self1._offset + have);
                self1._offset += have;
                // serve some output to the consumer.
                if (async) self1.push(out);
                else {
                    buffers.push(out);
                    nread += out.length;
                }
            }
            // exhausted the output buffer, or used all the input create a new one.
            if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                availOutBefore = self1._chunkSize;
                self1._offset = 0;
                self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
            }
            if (availOutAfter === 0) {
                // Not actually done.  Need to reprocess.
                // Also, update the availInBefore to the availInAfter value,
                // so that if we have to hit it a third (fourth, etc.) time,
                // it'll have the correct byte counts.
                inOff += availInBefore - availInAfter;
                availInBefore = availInAfter;
                if (!async) return true;
                var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                newReq.callback = callback; // this same function
                newReq.buffer = chunk;
                return;
            }
            if (!async) return false;
            // finished with the chunk.
            cb();
        }
    };
    util.inherits(Deflate, Zlib);
    util.inherits(Inflate, Zlib);
    util.inherits(Gzip, Zlib);
    util.inherits(Gunzip, Zlib);
    util.inherits(DeflateRaw, Zlib);
    util.inherits(InflateRaw, Zlib);
    util.inherits(Unzip, Zlib);
})(lib);
var zlib = /*@__PURE__*/ getDefaultExportFromCjs(lib);
var PDFReference = /*#__PURE__*/ function(_stream$Writable) {
    (0, _inheritsLooseDefault.default)(PDFReference, _stream$Writable);
    function PDFReference(document, id, data) {
        var _this;
        _this = _stream$Writable.call(this, {
            decodeStrings: false
        }) || this;
        _this.finalize = _this.finalize.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.document = document;
        _this.id = id;
        if (data == null) data = {};
        _this.data = data;
        _this.gen = 0;
        _this.deflate = null;
        _this.compress = _this.document.compress && !_this.data.Filter;
        _this.uncompressedLength = 0;
        _this.chunks = [];
        return _this;
    }
    var _proto = PDFReference.prototype;
    _proto.initDeflate = function initDeflate() {
        var _this2 = this;
        this.data.Filter = "FlateDecode";
        this.deflate = zlib.createDeflate();
        this.deflate.on("data", function(chunk) {
            _this2.chunks.push(chunk);
            return _this2.data.Length += chunk.length;
        });
        return this.deflate.on("end", this.finalize);
    };
    _proto._write = function _write(chunk, encoding, callback) {
        if (!(chunk instanceof Uint8Array)) chunk = Buffer$2.from(chunk + "\n", "binary");
        this.uncompressedLength += chunk.length;
        if (this.data.Length == null) this.data.Length = 0;
        if (this.compress) {
            if (!this.deflate) this.initDeflate();
            this.deflate.write(chunk);
        } else {
            this.chunks.push(chunk);
            this.data.Length += chunk.length;
        }
        return callback();
    };
    _proto.end = function end() {
        _stream$Writable.prototype.end.apply(this, arguments);
        if (this.deflate) return this.deflate.end();
        return this.finalize();
    };
    _proto.finalize = function finalize() {
        this.offset = this.document._offset;
        this.document._write(this.id + " " + this.gen + " obj");
        this.document._write(PDFObject$1.convert(this.data));
        if (this.chunks.length) {
            this.document._write("stream");
            for(var _i = 0, _Array$from = Array.from(this.chunks); _i < _Array$from.length; _i++){
                var chunk = _Array$from[_i];
                this.document._write(chunk);
            }
            this.chunks.length = 0; // free up memory
            this.document._write("\nendstream");
        }
        this.document._write("endobj");
        return this.document._refEnd(this);
    };
    _proto.toString = function toString() {
        return this.id + " " + this.gen + " R";
    };
    return PDFReference;
}(stream.Writable);
var PDFTree = /*#__PURE__*/ function() {
    function PDFTree(options) {
        if (options === void 0) options = {};
        this._items = {};
        // disable /Limits output for this tree
        this.limits = typeof options.limits === "boolean" ? options.limits : true;
    }
    var _proto = PDFTree.prototype;
    _proto.add = function add(key, val) {
        return this._items[key] = val;
    };
    _proto.get = function get(key) {
        return this._items[key];
    };
    _proto.toString = function toString() {
        var _this = this;
        // Needs to be sorted by key
        var sortedKeys = Object.keys(this._items).sort(function(a, b) {
            return _this._compareKeys(a, b);
        });
        var out = [
            "<<"
        ];
        if (this.limits && sortedKeys.length > 1) {
            var first = sortedKeys[0], last = sortedKeys[sortedKeys.length - 1];
            out.push("  /Limits " + PDFObject$1.convert([
                this._dataForKey(first),
                this._dataForKey(last)
            ]));
        }
        out.push("  /" + this._keysName() + " [");
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(sortedKeys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            out.push("    " + PDFObject$1.convert(this._dataForKey(key)) + " " + PDFObject$1.convert(this._items[key]));
        }
        out.push("]");
        out.push(">>");
        return out.join("\n");
    };
    _proto._compareKeys = function _compareKeys() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto._keysName = function _keysName() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto._dataForKey = function _dataForKey() {
        throw new Error("Must be implemented by subclasses");
    };
    return PDFTree;
}();
var PDFNameTree = /*#__PURE__*/ function(_PDFTree) {
    (0, _inheritsLooseDefault.default)(PDFNameTree, _PDFTree);
    function PDFNameTree() {
        return _PDFTree.apply(this, arguments) || this;
    }
    var _proto = PDFNameTree.prototype;
    _proto._compareKeys = function _compareKeys(a, b) {
        return a.localeCompare(b);
    };
    _proto._keysName = function _keysName() {
        return "Names";
    };
    _proto._dataForKey = function _dataForKey(k) {
        return new String(k);
    };
    return PDFNameTree;
}(PDFTree);
var escapableRe = /[\n\r\t\b\f\(\)\\]/g;
var escapable = {
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t",
    "\b": "\\b",
    "\f": "\\f",
    "\\": "\\\\",
    "(": "\\(",
    ")": "\\)"
};
var pad = function pad(str, length) {
    return (Array(length + 1).join("0") + str).slice(-length);
};
// Convert little endian UTF-16 to big endian
var swapBytes = function swapBytes(buff) {
    var l = buff.length;
    if (l & 0x01) throw new Error("Buffer length must be even");
    else for(var i = 0, end = l - 1; i < end; i += 2){
        var a = buff[i];
        buff[i] = buff[i + 1];
        buff[i + 1] = a;
    }
    return buff;
};
var PDFObject = /*#__PURE__*/ function() {
    function PDFObject() {}
    PDFObject.convert = function convert(object) {
        // String literals are converted to the PDF name type
        if (typeof object === "string") return "/" + object;
        // String objects are converted to PDF strings (UTF-16)
        if (object instanceof String) {
            var string = object;
            // Detect if this is a unicode string
            var isUnicode = false;
            for(var i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                isUnicode = true;
                break;
            }
            // If so, encode it as big endian UTF-16
            if (isUnicode) string = swapBytes(Buffer$2.from("\uFEFF" + string, "utf16le")).toString("binary");
            // Escape characters as required by the spec
            string = string.replace(escapableRe, function(c) {
                return escapable[c];
            });
            return "(" + string + ")";
        // Buffers are converted to PDF hex strings
        }
        if (Buffer$2.isBuffer(object)) return "<" + object.toString("hex") + ">";
        if (object instanceof PDFReference || object instanceof PDFNameTree) return object.toString();
        if (object instanceof Date) return "(D:" + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + "Z)";
        if (Array.isArray(object)) {
            var items = Array.from(object).map(function(e) {
                return PDFObject.convert(e);
            }).join(" ");
            return "[" + items + "]";
        }
        if (({}).toString.call(object) === "[object Object]") {
            var out = [
                "<<"
            ];
            for(var key in object){
                var val = object[key];
                out.push("/" + key + " " + PDFObject.convert(val));
            }
            out.push(">>");
            return out.join("\n");
        }
        if (typeof object === "number") return PDFObject.number(object);
        return "" + object;
    };
    PDFObject.number = function number(n) {
        if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
        throw new Error("unsupported number: " + n);
    };
    return PDFObject;
}();
var PDFObject$1 = PDFObject;
/*
PDFPage - represents a single page in the PDF document
By Devon Govett
*/ var DEFAULT_MARGINS = {
    top: 72,
    left: 72,
    bottom: 72,
    right: 72
};
var SIZES = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ]
};
var PDFPage = /*#__PURE__*/ function() {
    function PDFPage(document, options) {
        if (options === void 0) options = {};
        this.document = document;
        this.size = options.size || "letter";
        this.layout = options.layout || "portrait";
        this.userUnit = options.userUnit || 1.0;
        // process margins
        if (typeof options.margin === "number") this.margins = {
            top: options.margin,
            left: options.margin,
            bottom: options.margin,
            right: options.margin
        };
        else this.margins = options.margins || DEFAULT_MARGINS;
        // calculate page dimensions
        var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
        this.width = dimensions[this.layout === "portrait" ? 0 : 1];
        this.height = dimensions[this.layout === "portrait" ? 1 : 0];
        this.content = this.document.ref();
        // Initialize the Font, XObject, and ExtGState dictionaries
        this.resources = this.document.ref({
            ProcSet: [
                "PDF",
                "Text",
                "ImageB",
                "ImageC",
                "ImageI"
            ]
        });
        // The page dictionary
        this.dictionary = this.document.ref({
            Type: "Page",
            Parent: this.document._root.data.Pages,
            MediaBox: [
                0,
                0,
                this.width,
                this.height
            ],
            Contents: this.content,
            Resources: this.resources,
            UserUnit: this.userUnit
        });
        this.markings = [];
    }
    // Lazily create these objects
    var _proto = PDFPage.prototype;
    _proto.maxY = function maxY() {
        return this.height - this.margins.bottom;
    };
    _proto.write = function write(chunk) {
        return this.content.write(chunk);
    };
    _proto.end = function end() {
        this.dictionary.end();
        this.resources.end();
        return this.content.end();
    };
    (0, _createClassDefault.default)(PDFPage, [
        {
            key: "fonts",
            get: function get() {
                var data = this.resources.data;
                return data.Font != null ? data.Font : data.Font = {};
            }
        },
        {
            key: "xobjects",
            get: function get() {
                var data = this.resources.data;
                return data.XObject != null ? data.XObject : data.XObject = {};
            }
        },
        {
            key: "ext_gstates",
            get: function get() {
                var data = this.resources.data;
                return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
            }
        },
        {
            key: "patterns",
            get: function get() {
                var data = this.resources.data;
                return data.Pattern != null ? data.Pattern : data.Pattern = {};
            }
        },
        {
            key: "colorSpaces",
            get: function get() {
                var data = this.resources.data;
                return data.ColorSpace || (data.ColorSpace = {});
            }
        },
        {
            key: "annotations",
            get: function get() {
                var data = this.dictionary.data;
                return data.Annots != null ? data.Annots : data.Annots = [];
            }
        },
        {
            key: "structParentTreeKey",
            get: function get() {
                var data = this.dictionary.data;
                return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
            }
        }
    ]);
    return PDFPage;
}();
var wordArrayToBuffer = function wordArrayToBuffer(wordArray) {
    var byteArray = [];
    for(var i = 0; i < wordArray.sigBytes; i++)byteArray.push(wordArray.words[Math.floor(i / 4)] >> 8 * (3 - i % 4) & 0xff);
    return Buffer$2.from(byteArray);
};
var PDFSecurity = /*#__PURE__*/ function() {
    function PDFSecurity() {}
    PDFSecurity.generateFileID = function generateFileID(info) {
        if (info === void 0) info = {};
        var infoStr = info.CreationDate.getTime() + "\n";
        for(var key in info){
            if (!info.hasOwnProperty(key)) continue;
            infoStr += key + ": " + info[key].valueOf() + "\n";
        }
        return wordArrayToBuffer((0, _md5JsDefault.default)(infoStr));
    };
    return PDFSecurity;
}();
var number$2 = PDFObject$1.number;
var PDFGradient$1 = /*#__PURE__*/ function() {
    function PDFGradient(doc) {
        this.doc = doc;
        this.stops = [];
        this.embedded = false;
        this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    var _proto = PDFGradient.prototype;
    _proto.stop = function stop(pos, color, opacity) {
        if (opacity == null) opacity = 1;
        color = this.doc._normalizeColor(color);
        if (this.stops.length === 0) {
            if (color.length === 3) this._colorSpace = "DeviceRGB";
            else if (color.length === 4) this._colorSpace = "DeviceCMYK";
            else if (color.length === 1) this._colorSpace = "DeviceGray";
            else throw new Error("Unknown color space");
        } else if (this._colorSpace === "DeviceRGB" && color.length !== 3 || this._colorSpace === "DeviceCMYK" && color.length !== 4 || this._colorSpace === "DeviceGray" && color.length !== 1) throw new Error("All gradient stops must use the same color space");
        opacity = Math.max(0, Math.min(1, opacity));
        this.stops.push([
            pos,
            color,
            opacity
        ]);
        return this;
    };
    _proto.setTransform = function setTransform(m11, m12, m21, m22, dx, dy) {
        this.transform = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ];
        return this;
    };
    _proto.embed = function embed(m) {
        var fn;
        var stopsLength = this.stops.length;
        if (stopsLength === 0) return;
        this.embedded = true;
        this.matrix = m;
        // if the last stop comes before 100%, add a copy at 100%
        var last = this.stops[stopsLength - 1];
        if (last[0] < 1) this.stops.push([
            1,
            last[1],
            last[2]
        ]);
        var bounds = [];
        var encode = [];
        var stops = [];
        for(var i = 0; i < stopsLength - 1; i++){
            encode.push(0, 1);
            if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
            fn = this.doc.ref({
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                C0: this.stops[i + 0][1],
                C1: this.stops[i + 1][1],
                N: 1
            });
            stops.push(fn);
            fn.end();
        }
        // if there are only two stops, we don't need a stitching function
        if (stopsLength === 1) fn = stops[0];
        else {
            fn = this.doc.ref({
                FunctionType: 3,
                // stitching function
                Domain: [
                    0,
                    1
                ],
                Functions: stops,
                Bounds: bounds,
                Encode: encode
            });
            fn.end();
        }
        this.id = "Sh" + ++this.doc._gradCount;
        var shader = this.shader(fn);
        shader.end();
        var pattern = this.doc.ref({
            Type: "Pattern",
            PatternType: 2,
            Shading: shader,
            Matrix: this.matrix.map(number$2)
        });
        pattern.end();
        if (this.stops.some(function(stop) {
            return stop[2] < 1;
        })) {
            var grad = this.opacityGradient();
            grad._colorSpace = "DeviceGray";
            for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(this.stops), _step; !(_step = _iterator()).done;){
                var stop = _step.value;
                grad.stop(stop[0], [
                    stop[2]
                ]);
            }
            grad = grad.embed(this.matrix);
            var pageBBox = [
                0,
                0,
                this.doc.page.width,
                this.doc.page.height
            ];
            var form = this.doc.ref({
                Type: "XObject",
                Subtype: "Form",
                FormType: 1,
                BBox: pageBBox,
                Group: {
                    Type: "Group",
                    S: "Transparency",
                    CS: "DeviceGray"
                },
                Resources: {
                    ProcSet: [
                        "PDF",
                        "Text",
                        "ImageB",
                        "ImageC",
                        "ImageI"
                    ],
                    Pattern: {
                        Sh1: grad
                    }
                }
            });
            form.write("/Pattern cs /Sh1 scn");
            form.end(pageBBox.join(" ") + " re f");
            var gstate = this.doc.ref({
                Type: "ExtGState",
                SMask: {
                    Type: "Mask",
                    S: "Luminosity",
                    G: form
                }
            });
            gstate.end();
            var opacityPattern = this.doc.ref({
                Type: "Pattern",
                PatternType: 1,
                PaintType: 1,
                TilingType: 2,
                BBox: pageBBox,
                XStep: pageBBox[2],
                YStep: pageBBox[3],
                Resources: {
                    ProcSet: [
                        "PDF",
                        "Text",
                        "ImageB",
                        "ImageC",
                        "ImageI"
                    ],
                    Pattern: {
                        Sh1: pattern
                    },
                    ExtGState: {
                        Gs1: gstate
                    }
                }
            });
            opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
            opacityPattern.end(pageBBox.join(" ") + " re f");
            this.doc.page.patterns[this.id] = opacityPattern;
        } else this.doc.page.patterns[this.id] = pattern;
        return pattern;
    };
    _proto.apply = function apply(stroke) {
        // apply gradient transform to existing document ctm
        var _this$doc$_ctm = this.doc._ctm, m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
        var _this$transform = this.transform, m11 = _this$transform[0], m12 = _this$transform[1], m21 = _this$transform[2], m22 = _this$transform[3], dx = _this$transform[4], dy = _this$transform[5];
        var m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        if (!this.embedded || m.join(" ") !== this.matrix.join(" ")) this.embed(m);
        this.doc._setColorSpace("Pattern", stroke);
        var op = stroke ? "SCN" : "scn";
        return this.doc.addContent("/" + this.id + " " + op);
    };
    return PDFGradient;
}();
var PDFLinearGradient$1 = /*#__PURE__*/ function(_PDFGradient) {
    (0, _inheritsLooseDefault.default)(PDFLinearGradient, _PDFGradient);
    function PDFLinearGradient(doc, x1, y1, x2, y2) {
        var _this;
        _this = _PDFGradient.call(this, doc) || this;
        _this.x1 = x1;
        _this.y1 = y1;
        _this.x2 = x2;
        _this.y2 = y2;
        return _this;
    }
    var _proto2 = PDFLinearGradient.prototype;
    _proto2.shader = function shader(fn) {
        return this.doc.ref({
            ShadingType: 2,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.x2,
                this.y2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    };
    _proto2.opacityGradient = function opacityGradient() {
        return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
    };
    return PDFLinearGradient;
}(PDFGradient$1);
var PDFRadialGradient$1 = /*#__PURE__*/ function(_PDFGradient2) {
    (0, _inheritsLooseDefault.default)(PDFRadialGradient, _PDFGradient2);
    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
        var _this2;
        _this2 = _PDFGradient2.call(this, doc) || this;
        _this2.doc = doc;
        _this2.x1 = x1;
        _this2.y1 = y1;
        _this2.r1 = r1;
        _this2.x2 = x2;
        _this2.y2 = y2;
        _this2.r2 = r2;
        return _this2;
    }
    var _proto3 = PDFRadialGradient.prototype;
    _proto3.shader = function shader(fn) {
        return this.doc.ref({
            ShadingType: 3,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.r1,
                this.x2,
                this.y2,
                this.r2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    };
    _proto3.opacityGradient = function opacityGradient() {
        return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
    };
    return PDFRadialGradient;
}(PDFGradient$1);
var Gradient = {
    PDFGradient: PDFGradient$1,
    PDFLinearGradient: PDFLinearGradient$1,
    PDFRadialGradient: PDFRadialGradient$1
};
/*
PDF tiling pattern support. Uncolored only.
 */ var underlyingColorSpaces = [
    "DeviceCMYK",
    "DeviceRGB"
];
var PDFTilingPattern$1 = /*#__PURE__*/ function() {
    function PDFTilingPattern(doc, bBox, xStep, yStep, stream) {
        this.doc = doc;
        this.bBox = bBox;
        this.xStep = xStep;
        this.yStep = yStep;
        this.stream = stream;
    }
    var _proto = PDFTilingPattern.prototype;
    _proto.createPattern = function createPattern() {
        // no resources needed for our current usage
        // required entry
        var resources = this.doc.ref();
        resources.end();
        // apply default transform matrix (flipped in the default doc._ctm)
        // see document.js & gradient.js
        var _this$doc$_ctm = this.doc._ctm, m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
        var m11 = 1, m12 = 0, m21 = 0, m22 = 1, dx = 0, dy = 0;
        var m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        var pattern = this.doc.ref({
            Type: "Pattern",
            PatternType: 1,
            // tiling
            PaintType: 2,
            // 1-colored, 2-uncolored
            TilingType: 2,
            // 2-no distortion
            BBox: this.bBox,
            XStep: this.xStep,
            YStep: this.yStep,
            Matrix: m.map(function(v) {
                return +v.toFixed(5);
            }),
            Resources: resources
        });
        pattern.end(this.stream);
        return pattern;
    };
    _proto.embedPatternColorSpaces = function embedPatternColorSpaces() {
        var _this = this;
        // map each pattern to an underlying color space
        // and embed on each page
        underlyingColorSpaces.forEach(function(csName) {
            var csId = _this.getPatternColorSpaceId(csName);
            if (_this.doc.page.colorSpaces[csId]) return;
            var cs = _this.doc.ref([
                "Pattern",
                csName
            ]);
            cs.end();
            _this.doc.page.colorSpaces[csId] = cs;
        });
    };
    _proto.getPatternColorSpaceId = function getPatternColorSpaceId(underlyingColorspace) {
        return "CsP" + underlyingColorspace;
    };
    _proto.embed = function embed() {
        if (!this.id) {
            this.doc._patternCount = this.doc._patternCount + 1;
            this.id = "P" + this.doc._patternCount;
            this.pattern = this.createPattern();
        }
        // patterns are embedded in each page
        if (!this.doc.page.patterns[this.id]) this.doc.page.patterns[this.id] = this.pattern;
    };
    _proto.apply = function apply(stroke, patternColor) {
        // do any embedding/creating that might be needed
        this.embedPatternColorSpaces();
        this.embed();
        var normalizedColor = this.doc._normalizeColor(patternColor);
        if (!normalizedColor) throw Error("invalid pattern color. (value: " + patternColor + ")");
        // select one of the pattern color spaces
        var csId = this.getPatternColorSpaceId(this.doc._getColorSpace(normalizedColor));
        this.doc._setColorSpace(csId, stroke);
        // stroke/fill using the pattern and color (in the above underlying color space)
        var op = stroke ? "SCN" : "scn";
        return this.doc.addContent(normalizedColor.join(" ") + " /" + this.id + " " + op);
    };
    return PDFTilingPattern;
}();
var pattern = {
    PDFTilingPattern: PDFTilingPattern$1
};
var PDFGradient = Gradient.PDFGradient, PDFLinearGradient = Gradient.PDFLinearGradient, PDFRadialGradient = Gradient.PDFRadialGradient;
var PDFTilingPattern = pattern.PDFTilingPattern;
var ColorMixin = {
    initColor: function initColor() {
        // The opacity dictionaries
        this._opacityRegistry = {};
        this._opacityCount = 0;
        this._patternCount = 0;
        return this._gradCount = 0;
    },
    _normalizeColor: function _normalizeColor(color) {
        if (typeof color === "string") {
            if (color.charAt(0) === "#") {
                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
                var hex = parseInt(color.slice(1), 16);
                color = [
                    hex >> 16,
                    hex >> 8 & 0xff,
                    hex & 0xff
                ];
            } else if (namedColors[color]) color = namedColors[color];
        }
        if (Array.isArray(color)) {
            // RGB
            if (color.length === 3) color = color.map(function(part) {
                return part / 255;
            });
            else if (color.length === 4) color = color.map(function(part) {
                return part / 100;
            });
            return color;
        }
        return null;
    },
    _setColor: function _setColor(color, stroke) {
        if (color instanceof PDFGradient) {
            color.apply(stroke);
            return true;
        // see if tiling pattern, decode & apply it it
        } else if (Array.isArray(color) && color[0] instanceof PDFTilingPattern) {
            color[0].apply(stroke, color[1]);
            return true;
        }
        // any other case should be a normal color and not a pattern
        return this._setColorCore(color, stroke);
    },
    _setColorCore: function _setColorCore(color, stroke) {
        color = this._normalizeColor(color);
        if (!color) return false;
        var op = stroke ? "SCN" : "scn";
        var space = this._getColorSpace(color);
        this._setColorSpace(space, stroke);
        color = color.join(" ");
        this.addContent(color + " " + op);
        return true;
    },
    _setColorSpace: function _setColorSpace(space, stroke) {
        var op = stroke ? "CS" : "cs";
        return this.addContent("/" + space + " " + op);
    },
    _getColorSpace: function _getColorSpace(color) {
        return color.length === 4 ? "DeviceCMYK" : "DeviceRGB";
    },
    fillColor: function fillColor(color, opacity) {
        var set = this._setColor(color, false);
        if (set) this.fillOpacity(opacity);
        // save this for text wrapper, which needs to reset
        // the fill color on new pages
        this._fillColor = [
            color,
            opacity
        ];
        return this;
    },
    strokeColor: function strokeColor(color, opacity) {
        var set = this._setColor(color, true);
        if (set) this.strokeOpacity(opacity);
        return this;
    },
    opacity: function opacity(_opacity) {
        this._doOpacity(_opacity, _opacity);
        return this;
    },
    fillOpacity: function fillOpacity(opacity) {
        this._doOpacity(opacity, null);
        return this;
    },
    strokeOpacity: function strokeOpacity(opacity) {
        this._doOpacity(null, opacity);
        return this;
    },
    _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
        var dictionary, name;
        if (fillOpacity == null && strokeOpacity == null) return;
        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
        var key = fillOpacity + "_" + strokeOpacity;
        if (this._opacityRegistry[key]) {
            var _this$_opacityRegistr = this._opacityRegistry[key];
            dictionary = _this$_opacityRegistr[0];
            name = _this$_opacityRegistr[1];
        } else {
            dictionary = {
                Type: "ExtGState"
            };
            if (fillOpacity != null) dictionary.ca = fillOpacity;
            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
            dictionary = this.ref(dictionary);
            dictionary.end();
            var id = ++this._opacityCount;
            name = "Gs" + id;
            this._opacityRegistry[key] = [
                dictionary,
                name
            ];
        }
        this.page.ext_gstates[name] = dictionary;
        return this.addContent("/" + name + " gs");
    },
    linearGradient: function linearGradient(x1, y1, x2, y2) {
        return new PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
        return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    },
    pattern: function pattern(bbox, xStep, yStep, stream) {
        return new PDFTilingPattern(this, bbox, xStep, yStep, stream);
    }
};
var namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
/* eslint-disable no-lonely-if */ var cx;
var cy;
var px;
var py;
var sx;
var sy;
cx = cy = px = py = sx = sy = 0;
// parseDataPath copy pasted from svgo
// https://github.com/svg/svgo/blob/e4918ccdd1a2b5831defe0f00c1286744b479448/lib/path.js
/**
 * @typedef {'M' | 'm' | 'Z' | 'z' | 'L' | 'l' | 'H' | 'h' | 'V' | 'v' | 'C' | 'c' | 'S' | 's' | 'Q' | 'q' | 'T' | 't' | 'A' | 'a'} PathDataCommand
 */ /**
 * @typedef {Object} PathDataItem
 * @property {PathDataCommand} command
 * @property {number[]} args
 */ var argsCountPerCommand = {
    M: 2,
    m: 2,
    Z: 0,
    z: 0,
    L: 2,
    l: 2,
    H: 1,
    h: 1,
    V: 1,
    v: 1,
    C: 6,
    c: 6,
    S: 4,
    s: 4,
    Q: 4,
    q: 4,
    T: 2,
    t: 2,
    A: 7,
    a: 7
};
/**
 * @type {(c: string) => c is PathDataCommand}
 */ var isCommand = function isCommand(c) {
    return c in argsCountPerCommand;
};
/**
 * @type {(c: string) => boolean}
 */ var isWsp = function isWsp(c) {
    var codePoint = c.codePointAt(0);
    return codePoint === 0x20 || codePoint === 0x9 || codePoint === 0xd || codePoint === 0xa;
};
/**
 * @type {(c: string) => boolean}
 */ var isDigit = function isDigit(c) {
    var codePoint = c.codePointAt(0);
    if (codePoint == null) return false;
    return 48 <= codePoint && codePoint <= 57;
};
/**
 * @typedef {'none' | 'sign' | 'whole' | 'decimal_point' | 'decimal' | 'e' | 'exponent_sign' | 'exponent'} ReadNumberState
 */ /**
 * @type {(string: string, cursor: number) => [number, number | null]}
 */ var readNumber = function readNumber(string, cursor) {
    var i = cursor;
    var value = "";
    var state = /** @type {ReadNumberState} */ "none";
    for(; i < string.length; i += 1){
        var c = string[i];
        if (c === "+" || c === "-") {
            if (state === "none") {
                state = "sign";
                value += c;
                continue;
            }
            if (state === "e") {
                state = "exponent_sign";
                value += c;
                continue;
            }
        }
        if (isDigit(c)) {
            if (state === "none" || state === "sign" || state === "whole") {
                state = "whole";
                value += c;
                continue;
            }
            if (state === "decimal_point" || state === "decimal") {
                state = "decimal";
                value += c;
                continue;
            }
            if (state === "e" || state === "exponent_sign" || state === "exponent") {
                state = "exponent";
                value += c;
                continue;
            }
        }
        if (c === ".") {
            if (state === "none" || state === "sign" || state === "whole") {
                state = "decimal_point";
                value += c;
                continue;
            }
        }
        if (c === "E" || c === "e") {
            if (state === "whole" || state === "decimal_point" || state === "decimal") {
                state = "e";
                value += c;
                continue;
            }
        }
        break;
    }
    var number = Number.parseFloat(value);
    if (Number.isNaN(number)) return [
        cursor,
        null
    ];
    // step back to delegate iteration to parent loop
    return [
        i - 1,
        number
    ];
};
/**
 * @type {(string: string) => Array<PathDataItem>}
 */ var parsePathData = function parsePathData(string) {
    /**
   * @type {Array<PathDataItem>}
   */ var pathData = [];
    /**
   * @type {null | PathDataCommand}
   */ var command = null;
    var args = /** @type {number[]} */ [];
    var argsCount = 0;
    var canHaveComma = false;
    var hadComma = false;
    for(var i = 0; i < string.length; i += 1){
        var c = string.charAt(i);
        if (isWsp(c)) continue;
        // allow comma only between arguments
        if (canHaveComma && c === ",") {
            if (hadComma) break;
            hadComma = true;
            continue;
        }
        if (isCommand(c)) {
            if (hadComma) return pathData;
            if (command == null) {
                // moveto should be leading command
                if (c !== "M" && c !== "m") return pathData;
            } else {
                // stop if previous command arguments are not flushed
                if (args.length !== 0) return pathData;
            }
            command = c;
            args = [];
            argsCount = argsCountPerCommand[command];
            canHaveComma = false;
            // flush command without arguments
            if (argsCount === 0) pathData.push({
                command: command,
                args: args
            });
            continue;
        }
        // avoid parsing arguments if no command detected
        if (command == null) return pathData;
        // read next argument
        var newCursor = i;
        var number = null;
        if (command === "A" || command === "a") {
            var position = args.length;
            if (position === 0 || position === 1) // allow only positive number without sign as first two arguments
            {
                if (c !== "+" && c !== "-") {
                    var _readNumber = readNumber(string, i);
                    newCursor = _readNumber[0];
                    number = _readNumber[1];
                }
            }
            if (position === 2 || position === 5 || position === 6) {
                var _readNumber2 = readNumber(string, i);
                newCursor = _readNumber2[0];
                number = _readNumber2[1];
            }
            if (position === 3 || position === 4) {
                // read flags
                if (c === "0") number = 0;
                if (c === "1") number = 1;
            }
        } else {
            var _readNumber3 = readNumber(string, i);
            newCursor = _readNumber3[0];
            number = _readNumber3[1];
        }
        if (number == null) return pathData;
        args.push(number);
        canHaveComma = true;
        hadComma = false;
        i = newCursor;
        // flush arguments when necessary count is reached
        if (args.length === argsCount) {
            pathData.push({
                command: command,
                args: args
            });
            // subsequent moveto coordinates are threated as implicit lineto commands
            if (command === "M") command = "L";
            if (command === "m") command = "l";
            args = [];
        }
    }
    return pathData;
};
var _apply = function apply(commands, doc) {
    // current point, control point, and subpath starting point
    cx = cy = px = py = sx = sy = 0;
    // run the commands
    for(var i = 0; i < commands.length; i++){
        var _commands$i = commands[i], command = _commands$i.command, args = _commands$i.args;
        if (typeof runners[command] === "function") runners[command](doc, args);
    }
};
var runners = {
    M: function M(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
    },
    m: function m(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
    },
    C: function C(doc, a) {
        cx = a[4];
        cy = a[5];
        px = a[2];
        py = a[3];
        return doc.bezierCurveTo.apply(doc, a);
    },
    c: function c(doc, a) {
        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
        px = cx + a[2];
        py = cy + a[3];
        cx += a[4];
        return cy += a[5];
    },
    S: function S(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
        px = a[0];
        py = a[1];
        cx = a[2];
        return cy = a[3];
    },
    s: function s(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
    },
    Q: function Q(doc, a) {
        px = a[0];
        py = a[1];
        cx = a[2];
        cy = a[3];
        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
    },
    q: function q(doc, a) {
        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
    },
    T: function T(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        } else {
            px = cx - (px - cx);
            py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, a[0], a[1]);
        px = cx - (px - cx);
        py = cy - (py - cy);
        cx = a[0];
        return cy = a[1];
    },
    t: function t(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        } else {
            px = cx - (px - cx);
            py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
        cx += a[0];
        return cy += a[1];
    },
    A: function A(doc, a) {
        solveArc(doc, cx, cy, a);
        cx = a[5];
        return cy = a[6];
    },
    a: function a(doc, _a) {
        _a[5] += cx;
        _a[6] += cy;
        solveArc(doc, cx, cy, _a);
        cx = _a[5];
        return cy = _a[6];
    },
    L: function L(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    l: function l(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    H: function H(doc, a) {
        cx = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    h: function h(doc, a) {
        cx += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    V: function V(doc, a) {
        cy = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    v: function v(doc, a) {
        cy += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    Z: function Z(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
    },
    z: function z(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
    }
};
var solveArc = function solveArc(doc, x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(segs), _step; !(_step = _iterator()).done;){
        var seg = _step.value;
        var bez = segmentToBezier.apply(void 0, seg);
        doc.bezierCurveTo.apply(doc, bez);
    }
};
// from Inkscape svgtopdf, thanks!
var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sin_th = Math.sin(th);
    var cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    var pl = px * px / (rx * rx) + py * py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cos_th / rx;
    var a01 = sin_th / rx;
    var a10 = -sin_th / ry;
    var a11 = cos_th / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    var sfactor = Math.sqrt(sfactor_sq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * th_arc / segments;
        var th3 = th0 + (i + 1) * th_arc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return result;
};
var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
    var a00 = cos_th * rx;
    var a01 = -sin_th * ry;
    var a10 = sin_th * rx;
    var a11 = cos_th * ry;
    var th_half = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
    var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx + Math.cos(th1);
    var y3 = cy + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    return [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
};
var SVGPath = /*#__PURE__*/ function() {
    function SVGPath() {}
    SVGPath.apply = function apply(doc, path) {
        var commands = parsePathData(path);
        _apply(commands, doc);
    };
    return SVGPath;
}();
var number$1 = PDFObject$1.number;
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var VectorMixin = {
    initVector: function initVector() {
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ]; // current transformation matrix
        return this._ctmStack = [];
    },
    save: function save() {
        this._ctmStack.push(this._ctm.slice());
        // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
        return this.addContent("q");
    },
    restore: function restore() {
        this._ctm = this._ctmStack.pop() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return this.addContent("Q");
    },
    closePath: function closePath() {
        return this.addContent("h");
    },
    lineWidth: function lineWidth(w) {
        return this.addContent(number$1(w) + " w");
    },
    _CAP_STYLES: {
        BUTT: 0,
        ROUND: 1,
        SQUARE: 2
    },
    lineCap: function lineCap(c) {
        if (typeof c === "string") c = this._CAP_STYLES[c.toUpperCase()];
        return this.addContent(c + " J");
    },
    _JOIN_STYLES: {
        MITER: 0,
        ROUND: 1,
        BEVEL: 2
    },
    lineJoin: function lineJoin(j) {
        if (typeof j === "string") j = this._JOIN_STYLES[j.toUpperCase()];
        return this.addContent(j + " j");
    },
    miterLimit: function miterLimit(m) {
        return this.addContent(number$1(m) + " M");
    },
    dash: function dash(length, options) {
        if (options === void 0) options = {};
        var originalLength = length;
        if (!Array.isArray(length)) length = [
            length,
            options.space || length
        ];
        var valid = length.every(function(x) {
            return Number.isFinite(x) && x > 0;
        });
        if (!valid) throw new Error("dash(" + JSON.stringify(originalLength) + ", " + JSON.stringify(options) + ") invalid, lengths must be numeric and greater than zero");
        length = length.map(number$1).join(" ");
        return this.addContent("[" + length + "] " + number$1(options.phase || 0) + " d");
    },
    undash: function undash() {
        return this.addContent("[] 0 d");
    },
    moveTo: function moveTo(x, y) {
        return this.addContent(number$1(x) + " " + number$1(y) + " m");
    },
    lineTo: function lineTo(x, y) {
        return this.addContent(number$1(x) + " " + number$1(y) + " l");
    },
    bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        return this.addContent(number$1(cp1x) + " " + number$1(cp1y) + " " + number$1(cp2x) + " " + number$1(cp2y) + " " + number$1(x) + " " + number$1(y) + " c");
    },
    quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
        return this.addContent(number$1(cpx) + " " + number$1(cpy) + " " + number$1(x) + " " + number$1(y) + " v");
    },
    rect: function rect(x, y, w, h) {
        return this.addContent(number$1(x) + " " + number$1(y) + " " + number$1(w) + " " + number$1(h) + " re");
    },
    roundedRect: function roundedRect(x, y, w, h, r) {
        if (r == null) r = 0;
        r = Math.min(r, 0.5 * w, 0.5 * h);
        // amount to inset control points from corners (see `ellipse`)
        var c = r * (1.0 - KAPPA);
        this.moveTo(x + r, y);
        this.lineTo(x + w - r, y);
        this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
        this.lineTo(x + w, y + h - r);
        this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
        this.lineTo(x + r, y + h);
        this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
        this.lineTo(x, y + r);
        this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
        return this.closePath();
    },
    ellipse: function ellipse(x, y, r1, r2) {
        // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
        if (r2 == null) r2 = r1;
        x -= r1;
        y -= r2;
        var ox = r1 * KAPPA;
        var oy = r2 * KAPPA;
        var xe = x + r1 * 2;
        var ye = y + r2 * 2;
        var xm = x + r1;
        var ym = y + r2;
        this.moveTo(x, ym);
        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        return this.closePath();
    },
    circle: function circle(x, y, radius) {
        return this.ellipse(x, y, radius);
    },
    arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise == null) anticlockwise = false;
        var TWO_PI = 2.0 * Math.PI;
        var HALF_PI = 0.5 * Math.PI;
        var deltaAng = endAngle - startAngle;
        if (Math.abs(deltaAng) > TWO_PI) // draw only full circle if more than that is specified
        deltaAng = TWO_PI;
        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
            // necessary to flip direction of rendering
            var dir = anticlockwise ? -1 : 1;
            deltaAng = dir * TWO_PI + deltaAng;
        }
        var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
        var segAng = deltaAng / numSegs;
        var handleLen = segAng / HALF_PI * KAPPA * radius;
        var curAng = startAngle;
        // component distances between anchor point and control point
        var deltaCx = -Math.sin(curAng) * handleLen;
        var deltaCy = Math.cos(curAng) * handleLen;
        // anchor point
        var ax = x + Math.cos(curAng) * radius;
        var ay = y + Math.sin(curAng) * radius;
        // calculate and render segments
        this.moveTo(ax, ay);
        for(var segIdx = 0; segIdx < numSegs; segIdx++){
            // starting control point
            var cp1x = ax + deltaCx;
            var cp1y = ay + deltaCy;
            // step angle
            curAng += segAng;
            // next anchor point
            ax = x + Math.cos(curAng) * radius;
            ay = y + Math.sin(curAng) * radius;
            // next control point delta
            deltaCx = -Math.sin(curAng) * handleLen;
            deltaCy = Math.cos(curAng) * handleLen;
            // ending control point
            var cp2x = ax - deltaCx;
            var cp2y = ay - deltaCy;
            // render segment
            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
        }
        return this;
    },
    polygon: function polygon() {
        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
        this.moveTo.apply(this, points.shift() || []);
        for(var _i = 0, _points = points; _i < _points.length; _i++){
            var point = _points[_i];
            this.lineTo.apply(this, point || []);
        }
        return this.closePath();
    },
    path: function path(_path) {
        SVGPath.apply(this, _path);
        return this;
    },
    _windingRule: function _windingRule(rule) {
        if (/even-?odd/.test(rule)) return "*";
        return "";
    },
    fill: function fill(color, rule) {
        if (/(even-?odd)|(non-?zero)/.test(color)) {
            rule = color;
            color = null;
        }
        if (color) this.fillColor(color);
        return this.addContent("f" + this._windingRule(rule));
    },
    stroke: function stroke(color) {
        if (color) this.strokeColor(color);
        return this.addContent("S");
    },
    fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
        if (strokeColor == null) strokeColor = fillColor;
        var isFillRule = /(even-?odd)|(non-?zero)/;
        if (isFillRule.test(fillColor)) {
            rule = fillColor;
            fillColor = null;
        }
        if (isFillRule.test(strokeColor)) {
            rule = strokeColor;
            strokeColor = fillColor;
        }
        if (fillColor) {
            this.fillColor(fillColor);
            this.strokeColor(strokeColor);
        }
        return this.addContent("B" + this._windingRule(rule));
    },
    clip: function clip(rule) {
        return this.addContent("W" + this._windingRule(rule) + " n");
    },
    transform: function transform(m11, m12, m21, m22, dx, dy) {
        // keep track of the current transformation matrix
        if (m11 === 1 && m12 === 0 && m21 === 0 && m22 === 1 && dx === 0 && dy === 0) // Ignore identity transforms
        return this;
        var m = this._ctm;
        var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5];
        m[0] = m0 * m11 + m2 * m12;
        m[1] = m1 * m11 + m3 * m12;
        m[2] = m0 * m21 + m2 * m22;
        m[3] = m1 * m21 + m3 * m22;
        m[4] = m0 * dx + m2 * dy + m4;
        m[5] = m1 * dx + m3 * dy + m5;
        var values = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ].map(function(v) {
            return number$1(v);
        }).join(" ");
        return this.addContent(values + " cm");
    },
    translate: function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    },
    rotate: function rotate(angle, options) {
        if (options === void 0) options = {};
        var y;
        var rad = angle * Math.PI / 180;
        var cos = Math.cos(rad);
        var sin = Math.sin(rad);
        var x = y = 0;
        if (options.origin != null) {
            var _options$origin = options.origin;
            x = _options$origin[0];
            y = _options$origin[1];
            var x1 = x * cos - y * sin;
            var y1 = x * sin + y * cos;
            x -= x1;
            y -= y1;
        }
        return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale: function scale(xFactor, yFactor, options) {
        if (options === void 0) options = {};
        var y;
        if (yFactor == null) yFactor = xFactor;
        if (typeof yFactor === "object") {
            options = yFactor;
            yFactor = xFactor;
        }
        var x = y = 0;
        if (options.origin != null) {
            var _options$origin2 = options.origin;
            x = _options$origin2[0];
            y = _options$origin2[1];
            x -= xFactor * x;
            y -= yFactor * y;
        }
        return this.transform(xFactor, 0, 0, yFactor, x, y);
    }
};
var fs = {};
var range = function range(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
};
var WIN_ANSI_MAP = {
    402: 131,
    8211: 150,
    8212: 151,
    8216: 145,
    8217: 146,
    8218: 130,
    8220: 147,
    8221: 148,
    8222: 132,
    8224: 134,
    8225: 135,
    8226: 149,
    8230: 133,
    8364: 128,
    8240: 137,
    8249: 139,
    8250: 155,
    710: 136,
    8482: 153,
    338: 140,
    339: 156,
    732: 152,
    352: 138,
    353: 154,
    376: 159,
    381: 142,
    382: 158
};
var characters = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);
function _parse(contents) {
    var obj = {
        attributes: {},
        glyphWidths: {},
        kernPairs: {}
    };
    var section = "";
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(contents.split("\n")), _step; !(_step = _iterator()).done;){
        var line = _step.value;
        var match;
        var a;
        if (match = line.match(/^Start(\w+)/)) {
            section = match[1];
            continue;
        } else if (match = line.match(/^End(\w+)/)) {
            section = "";
            continue;
        }
        switch(section){
            case "FontMetrics":
                match = line.match(/(^\w+)\s+(.*)/);
                var key = match[1];
                var value = match[2];
                if (a = obj.attributes[key]) {
                    if (!Array.isArray(a)) a = obj.attributes[key] = [
                        a
                    ];
                    a.push(value);
                } else obj.attributes[key] = value;
                break;
            case "CharMetrics":
                if (!/^CH?\s/.test(line)) continue;
                var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                obj.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                break;
            case "KernPairs":
                match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                if (match) obj.kernPairs[match[1] + match[2]] = parseInt(match[3]);
                break;
        }
    }
    return obj;
}
var AFMFont = /*#__PURE__*/ function() {
    AFMFont.open = function open(filename) {
        throw new Error("AFMFont.open not available on browser build");
    };
    AFMFont.fromJson = function fromJson(json) {
        return new AFMFont(json);
    };
    function AFMFont(contents) {
        var _this = this;
        if (typeof contents === "string") {
            this.contents = contents;
            this.parse();
        } else {
            this.attributes = contents.attributes;
            this.glyphWidths = contents.glyphWidths;
            this.kernPairs = contents.kernPairs;
        }
        this.charWidths = range(0, 255, true).map(function(i) {
            return _this.glyphWidths[characters[i]];
        });
        this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map(function(e) {
            return +e;
        });
        this.ascender = +(this.attributes.Ascender || 0);
        this.descender = +(this.attributes.Descender || 0);
        this.xHeight = +(this.attributes.XHeight || 0);
        this.capHeight = +(this.attributes.CapHeight || 0);
        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
    }
    var _proto = AFMFont.prototype;
    _proto.parse = function parse() {
        var parsed = _parse(this.contents);
        this.attributes = parsed.attributes;
        this.glyphWidths = parsed.glyphWidths;
        this.kernPairs = parsed.kernPairs;
    };
    _proto.encodeText = function encodeText(text) {
        var res = [];
        for(var i = 0, end = text.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
            var char = text.charCodeAt(i);
            char = WIN_ANSI_MAP[char] || char;
            res.push(char.toString(16));
        }
        return res;
    };
    _proto.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        for(var i = 0, end = string.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
            var charCode = string.charCodeAt(i);
            glyphs.push(this.characterToGlyph(charCode));
        }
        return glyphs;
    };
    _proto.characterToGlyph = function characterToGlyph(character) {
        return characters[WIN_ANSI_MAP[character] || character] || ".notdef";
    };
    _proto.widthOfGlyph = function widthOfGlyph(glyph) {
        return this.glyphWidths[glyph] || 0;
    };
    _proto.getKernPair = function getKernPair(left, right) {
        return this.kernPairs[left + right] || 0;
    };
    _proto.advancesForGlyphs = function advancesForGlyphs(glyphs) {
        var advances = [];
        for(var index = 0; index < glyphs.length; index++){
            var left = glyphs[index];
            var right = glyphs[index + 1];
            advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
        }
        return advances;
    };
    return AFMFont;
}();
var attributes = [
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:43:52 1997",
            "UniqueID 43052",
            "VMusage 37169 48194"
        ],
        FontName: "Helvetica-Bold",
        FullName: "Helvetica Bold",
        FamilyName: "Helvetica",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-170 -228 1003 962 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "532",
        Ascender: "718",
        Descender: "-207",
        StdHW: "118",
        StdVW: "140"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:45:12 1997",
            "UniqueID 43053",
            "VMusage 14482 68586"
        ],
        FontName: "Helvetica-BoldOblique",
        FullName: "Helvetica Bold Oblique",
        FamilyName: "Helvetica",
        Weight: "Bold",
        ItalicAngle: "-12",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-174 -228 1114 962",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "532",
        Ascender: "718",
        Descender: "-207",
        StdHW: "118",
        StdVW: "140"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:44:31 1997",
            "UniqueID 43055",
            "VMusage 14960 69346"
        ],
        FontName: "Helvetica-Oblique",
        FullName: "Helvetica Oblique",
        FamilyName: "Helvetica",
        Weight: "Medium",
        ItalicAngle: "-12",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-170 -225 1116 931 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "523",
        Ascender: "718",
        Descender: "-207",
        StdHW: "76",
        StdVW: "88"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:38:23 1997",
            "UniqueID 43054",
            "VMusage 37069 48094"
        ],
        FontName: "Helvetica",
        FullName: "Helvetica",
        FamilyName: "Helvetica",
        Weight: "Medium",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-166 -225 1000 931 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "523",
        Ascender: "718",
        Descender: "-207",
        StdHW: "76",
        StdVW: "88"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:52:56 1997",
            "UniqueID 43065",
            "VMusage 41636 52661"
        ],
        FontName: "Times-Bold",
        FullName: "Times Bold",
        FamilyName: "Times",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-168 -218 1000 935 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "676",
        XHeight: "461",
        Ascender: "683",
        Descender: "-217",
        StdHW: "44",
        StdVW: "139"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 13:04:06 1997",
            "UniqueID 43066",
            "VMusage 45874 56899"
        ],
        FontName: "Times-BoldItalic",
        FullName: "Times Bold Italic",
        FamilyName: "Times",
        Weight: "Bold",
        ItalicAngle: "-15",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-200 -218 996 921",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "669",
        XHeight: "462",
        Ascender: "683",
        Descender: "-217",
        StdHW: "42",
        StdVW: "121"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:56:55 1997",
            "UniqueID 43067",
            "VMusage 47727 58752"
        ],
        FontName: "Times-Italic",
        FullName: "Times Italic",
        FamilyName: "Times",
        Weight: "Medium",
        ItalicAngle: "-15.5",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-169 -217 1010 883 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "653",
        XHeight: "441",
        Ascender: "683",
        Descender: "-217",
        StdHW: "32",
        StdVW: "76"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:49:17 1997",
            "UniqueID 43068",
            "VMusage 43909 54934"
        ],
        FontName: "Times-Roman",
        FullName: "Times Roman",
        FamilyName: "Times",
        Weight: "Roman",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-168 -218 1000 898 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "662",
        XHeight: "450",
        Ascender: "683",
        Descender: "-217",
        StdHW: "28",
        StdVW: "84"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Mon Jun 23 16:28:00 1997",
            "UniqueID 43048",
            "VMusage 41139 52164"
        ],
        FontName: "Courier-Bold",
        FullName: "Courier Bold",
        FamilyName: "Courier",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-113 -250 749 801 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "439",
        Ascender: "629",
        Descender: "-157",
        StdHW: "84",
        StdVW: "106"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Mon Jun 23 16:28:46 1997",
            "UniqueID 43049",
            "VMusage 17529 79244"
        ],
        FontName: "Courier-BoldOblique",
        FullName: "Courier Bold Oblique",
        FamilyName: "Courier",
        Weight: "Bold",
        ItalicAngle: "-12",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-57 -250 869 801",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "439",
        Ascender: "629",
        Descender: "-157",
        StdHW: "84",
        StdVW: "106"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 17:37:52 1997",
            "UniqueID 43051",
            "VMusage 16248 75829"
        ],
        FontName: "Courier-Oblique",
        FullName: "Courier Oblique",
        FamilyName: "Courier",
        Weight: "Medium",
        ItalicAngle: "-12",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-27 -250 849 805 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "426",
        Ascender: "629",
        Descender: "-157",
        StdHW: "51",
        StdVW: "51"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 17:27:09 1997",
            "UniqueID 43050",
            "VMusage 39754 50779"
        ],
        FontName: "Courier",
        FullName: "Courier",
        FamilyName: "Courier",
        Weight: "Medium",
        ItalicAngle: "0",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-23 -250 715 805 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "426",
        Ascender: "629",
        Descender: "-157",
        StdHW: "51",
        StdVW: "51"
    }
];
var glyphWidths = {
    space: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    exclam: [
        333,
        333,
        278,
        278,
        333,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    quotedbl: [
        474,
        474,
        355,
        355,
        555,
        555,
        420,
        408,
        600,
        600,
        600,
        600
    ],
    numbersign: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    dollar: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    percent: [
        889,
        889,
        889,
        889,
        1000,
        833,
        833,
        833,
        600,
        600,
        600,
        600
    ],
    ampersand: [
        722,
        722,
        667,
        667,
        833,
        778,
        778,
        778,
        600,
        600,
        600,
        600
    ],
    quoteright: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    parenleft: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    parenright: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    asterisk: [
        389,
        389,
        389,
        389,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    plus: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    comma: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    hyphen: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    period: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    slash: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    zero: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    one: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    two: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    three: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    four: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    five: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    six: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    seven: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    eight: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    nine: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    colon: [
        333,
        333,
        278,
        278,
        333,
        333,
        333,
        278,
        600,
        600,
        600,
        600
    ],
    semicolon: [
        333,
        333,
        278,
        278,
        333,
        333,
        333,
        278,
        600,
        600,
        600,
        600
    ],
    less: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    equal: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    greater: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    question: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    at: [
        975,
        975,
        1015,
        1015,
        930,
        832,
        920,
        921,
        600,
        600,
        600,
        600
    ],
    A: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    B: [
        722,
        722,
        667,
        667,
        667,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    C: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    D: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    E: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    F: [
        611,
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    G: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    H: [
        722,
        722,
        722,
        722,
        778,
        778,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    I: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    J: [
        556,
        556,
        500,
        500,
        500,
        500,
        444,
        389,
        600,
        600,
        600,
        600
    ],
    K: [
        722,
        722,
        667,
        667,
        778,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    L: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    M: [
        833,
        833,
        833,
        833,
        944,
        889,
        833,
        889,
        600,
        600,
        600,
        600
    ],
    N: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    O: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    P: [
        667,
        667,
        667,
        667,
        611,
        611,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    Q: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    R: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    S: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    T: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    U: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    V: [
        667,
        667,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    W: [
        944,
        944,
        944,
        944,
        1000,
        889,
        833,
        944,
        600,
        600,
        600,
        600
    ],
    X: [
        667,
        667,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Y: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    Z: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    bracketleft: [
        333,
        333,
        278,
        278,
        333,
        333,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    backslash: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    bracketright: [
        333,
        333,
        278,
        278,
        333,
        333,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    asciicircum: [
        584,
        584,
        469,
        469,
        581,
        570,
        422,
        469,
        600,
        600,
        600,
        600
    ],
    underscore: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    quoteleft: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    a: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    b: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    c: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    d: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    e: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    f: [
        333,
        333,
        278,
        278,
        333,
        333,
        278,
        333,
        600,
        600,
        600,
        600
    ],
    g: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    h: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    i: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    j: [
        278,
        278,
        222,
        222,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    k: [
        556,
        556,
        500,
        500,
        556,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    l: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    m: [
        889,
        889,
        833,
        833,
        833,
        778,
        722,
        778,
        600,
        600,
        600,
        600
    ],
    n: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    o: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    p: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    q: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    r: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    s: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    t: [
        333,
        333,
        278,
        278,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    u: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    v: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    w: [
        778,
        778,
        722,
        722,
        722,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    x: [
        556,
        556,
        500,
        500,
        500,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    y: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    z: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    braceleft: [
        389,
        389,
        334,
        334,
        394,
        348,
        400,
        480,
        600,
        600,
        600,
        600
    ],
    bar: [
        280,
        280,
        260,
        260,
        220,
        220,
        275,
        200,
        600,
        600,
        600,
        600
    ],
    braceright: [
        389,
        389,
        334,
        334,
        394,
        348,
        400,
        480,
        600,
        600,
        600,
        600
    ],
    asciitilde: [
        584,
        584,
        584,
        584,
        520,
        570,
        541,
        541,
        600,
        600,
        600,
        600
    ],
    exclamdown: [
        333,
        333,
        333,
        333,
        333,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    cent: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    sterling: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    fraction: [
        167,
        167,
        167,
        167,
        167,
        167,
        167,
        167,
        600,
        600,
        600,
        600
    ],
    yen: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    florin: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    section: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    currency: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    quotesingle: [
        238,
        238,
        191,
        191,
        278,
        278,
        214,
        180,
        600,
        600,
        600,
        600
    ],
    quotedblleft: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    guillemotleft: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    guilsinglleft: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    guilsinglright: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    fi: [
        611,
        611,
        500,
        500,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    fl: [
        611,
        611,
        500,
        500,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    endash: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    dagger: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    daggerdbl: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    periodcentered: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    paragraph: [
        556,
        556,
        537,
        537,
        540,
        500,
        523,
        453,
        600,
        600,
        600,
        600
    ],
    bullet: [
        350,
        350,
        350,
        350,
        350,
        350,
        350,
        350,
        600,
        600,
        600,
        600
    ],
    quotesinglbase: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    quotedblbase: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    quotedblright: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    guillemotright: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ellipsis: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        889,
        1000,
        600,
        600,
        600,
        600
    ],
    perthousand: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        600,
        600,
        600,
        600
    ],
    questiondown: [
        611,
        611,
        611,
        611,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    grave: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    acute: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    circumflex: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    tilde: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    macron: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    breve: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    dotaccent: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    dieresis: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ring: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    cedilla: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    hungarumlaut: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ogonek: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    caron: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    emdash: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        889,
        1000,
        600,
        600,
        600,
        600
    ],
    AE: [
        1000,
        1000,
        1000,
        1000,
        1000,
        944,
        889,
        889,
        600,
        600,
        600,
        600
    ],
    ordfeminine: [
        370,
        370,
        370,
        370,
        300,
        266,
        276,
        276,
        600,
        600,
        600,
        600
    ],
    Lslash: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Oslash: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    OE: [
        1000,
        1000,
        1000,
        1000,
        1000,
        944,
        944,
        889,
        600,
        600,
        600,
        600
    ],
    ordmasculine: [
        365,
        365,
        365,
        365,
        330,
        300,
        310,
        310,
        600,
        600,
        600,
        600
    ],
    ae: [
        889,
        889,
        889,
        889,
        722,
        722,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    dotlessi: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    lslash: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    oslash: [
        611,
        611,
        611,
        611,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    oe: [
        944,
        944,
        944,
        944,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    germandbls: [
        611,
        611,
        611,
        611,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Idieresis: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    eacute: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    abreve: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    uhungarumlaut: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ecaron: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Ydieresis: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    divide: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    Yacute: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    Acircumflex: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    aacute: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Ucircumflex: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    yacute: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    scommaaccent: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    ecircumflex: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Uring: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Udieresis: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    aogonek: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Uacute: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    uogonek: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Edieresis: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    Dcroat: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    commaaccent: [
        250,
        250,
        250,
        250,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    copyright: [
        737,
        737,
        737,
        737,
        747,
        747,
        760,
        760,
        600,
        600,
        600,
        600
    ],
    Emacron: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    ccaron: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    aring: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Ncommaaccent: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    lacute: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    agrave: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Tcommaaccent: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Cacute: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    atilde: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Edotaccent: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    scaron: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    scedilla: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    iacute: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    lozenge: [
        494,
        494,
        471,
        471,
        494,
        494,
        471,
        471,
        600,
        600,
        600,
        600
    ],
    Rcaron: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Gcommaaccent: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    ucircumflex: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    acircumflex: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Amacron: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    rcaron: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    ccedilla: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Zdotaccent: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Thorn: [
        667,
        667,
        667,
        667,
        611,
        611,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    Omacron: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Racute: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Sacute: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    dcaron: [
        743,
        743,
        643,
        643,
        672,
        608,
        544,
        588,
        600,
        600,
        600,
        600
    ],
    Umacron: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    uring: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    threesuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    Ograve: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Agrave: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Abreve: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    multiply: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    uacute: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Tcaron: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    partialdiff: [
        494,
        494,
        476,
        476,
        494,
        494,
        476,
        476,
        600,
        600,
        600,
        600
    ],
    ydieresis: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    Nacute: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    icircumflex: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Ecircumflex: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    adieresis: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    edieresis: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    cacute: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    nacute: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    umacron: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Ncaron: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    Iacute: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    plusminus: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    brokenbar: [
        280,
        280,
        260,
        260,
        220,
        220,
        275,
        200,
        600,
        600,
        600,
        600
    ],
    registered: [
        737,
        737,
        737,
        737,
        747,
        747,
        760,
        760,
        600,
        600,
        600,
        600
    ],
    Gbreve: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Idotaccent: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    summation: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    Egrave: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    racute: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    omacron: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Zacute: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Zcaron: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    greaterequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    Eth: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Ccedilla: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    lcommaaccent: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    tcaron: [
        389,
        389,
        317,
        317,
        416,
        366,
        300,
        326,
        600,
        600,
        600,
        600
    ],
    eogonek: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Uogonek: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Aacute: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Adieresis: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    egrave: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    zacute: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    iogonek: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Oacute: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    oacute: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    amacron: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    sacute: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    idieresis: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Ocircumflex: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Ugrave: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Delta: [
        612,
        612,
        612,
        612,
        612,
        612,
        612,
        612,
        600,
        600,
        600,
        600
    ],
    thorn: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    twosuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    Odieresis: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    mu: [
        611,
        611,
        556,
        556,
        556,
        576,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    igrave: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    ohungarumlaut: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Eogonek: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    dcroat: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    threequarters: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    Scedilla: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    lcaron: [
        400,
        400,
        299,
        299,
        394,
        382,
        300,
        344,
        600,
        600,
        600,
        600
    ],
    Kcommaaccent: [
        722,
        722,
        667,
        667,
        778,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    Lacute: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    trademark: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        980,
        980,
        600,
        600,
        600,
        600
    ],
    edotaccent: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Igrave: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    Imacron: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    Lcaron: [
        611,
        611,
        556,
        556,
        667,
        611,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    onehalf: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    lessequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    ocircumflex: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ntilde: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Uhungarumlaut: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Eacute: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    emacron: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    gbreve: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    onequarter: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    Scaron: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    Scommaaccent: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    Ohungarumlaut: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    degree: [
        400,
        400,
        400,
        400,
        400,
        400,
        400,
        400,
        600,
        600,
        600,
        600
    ],
    ograve: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Ccaron: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    ugrave: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    radical: [
        549,
        549,
        453,
        453,
        549,
        549,
        453,
        453,
        600,
        600,
        600,
        600
    ],
    Dcaron: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    rcommaaccent: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    Ntilde: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    otilde: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Rcommaaccent: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Lcommaaccent: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Atilde: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Aogonek: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Aring: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Otilde: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    zdotaccent: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    Ecaron: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    Iogonek: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    kcommaaccent: [
        556,
        556,
        500,
        500,
        556,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    minus: [
        584,
        584,
        584,
        584,
        570,
        606,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    Icircumflex: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ncaron: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    tcommaaccent: [
        333,
        333,
        278,
        278,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    logicalnot: [
        584,
        584,
        584,
        584,
        570,
        606,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    odieresis: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    udieresis: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    notequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    gcommaaccent: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    eth: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    zcaron: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    ncommaaccent: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    onesuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    imacron: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Euro: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ]
};
var kernPairs = {
    AC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    ATcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    ATcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Au: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Audieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Augrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Av: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Ay: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Ayacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AacuteC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AacuteT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AacuteW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AacuteY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AacuteYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AacuteYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aacuteu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacutev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aacutew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Aacutey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aacuteyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aacuteydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AbreveC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AbreveT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AbreveW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AbreveY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AbreveYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AbreveYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Abreveu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abrevev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Abrevew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Abrevey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Abreveyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Abreveydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AcircumflexC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AcircumflexT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AcircumflexW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AcircumflexY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AcircumflexYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AcircumflexYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Acircumflexu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Acircumflexw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Acircumflexy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Acircumflexyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Acircumflexydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AdieresisC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AdieresisT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AdieresisW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AdieresisY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AdieresisYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AdieresisYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Adieresisu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Adieresisw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Adieresisy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Adieresisyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Adieresisydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AgraveC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AgraveT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AgraveW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AgraveY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AgraveYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AgraveYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Agraveu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agravev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Agravew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Agravey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Agraveyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Agraveydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AmacronC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AmacronT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AmacronW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AmacronY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AmacronYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AmacronYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Amacronu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Amacronw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Amacrony: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Amacronyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Amacronydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AogonekC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AogonekT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AogonekW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AogonekY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AogonekYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AogonekYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aogoneku: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aogonekw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -52
    ],
    Aogoneky: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    Aogonekyacute: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    Aogonekydieresis: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    AringC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AringT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AringW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AringY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AringYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AringYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aringu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aringw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Aringy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aringyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aringydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AtildeC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AtildeT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AtildeW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AtildeY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AtildeYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AtildeYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Atildeu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Atildew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Atildey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Atildeyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Atildeydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    BA: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAacute: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAbreve: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAcircumflex: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAdieresis: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAgrave: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAmacron: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAogonek: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAring: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAtilde: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BU: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUacute: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUcircumflex: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUdieresis: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUgrave: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUhungarumlaut: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUmacron: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUogonek: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUring: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    DA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    DcaronA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DcaronW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DcaronY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcaronYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcaronYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcaroncomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dcaronperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    DcroatA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DcroatW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DcroatY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcroatYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcroatYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcroatcomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dcroatperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    FA: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAacute: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAbreve: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAcircumflex: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAdieresis: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAgrave: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAmacron: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAogonek: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAring: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAtilde: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    Fa: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faacute: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fabreve: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Facircumflex: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fadieresis: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fagrave: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Famacron: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faogonek: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faring: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fatilde: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fcomma: [
        -100,
        -100,
        -150,
        -150,
        -92,
        -129,
        -135,
        -80
    ],
    Fperiod: [
        -100,
        -100,
        -150,
        -150,
        -110,
        -129,
        -135,
        -80
    ],
    JA: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAbreve: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAogonek: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAring: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    Jcomma: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        -25
    ],
    Jperiod: [
        -20,
        -20,
        -30,
        -30,
        -20,
        -10,
        -25
    ],
    Ju: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juacute: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jucircumflex: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Judieresis: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jugrave: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jumacron: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juogonek: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juring: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    KO: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOacute: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOcircumflex: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOdieresis: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOgrave: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOhungarumlaut: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOmacron: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOslash: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOtilde: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    Ke: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Keacute: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kecaron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kecircumflex: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kedieresis: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kedotaccent: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kegrave: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kemacron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Keogonek: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Ko: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Koacute: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kocircumflex: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kodieresis: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kograve: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kohungarumlaut: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Komacron: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Koslash: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kotilde: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Ku: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuacute: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kudieresis: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kugrave: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kumacron: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuogonek: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuring: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Ky: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kyacute: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kydieresis: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    KcommaaccentO: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOacute: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOcircumflex: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOdieresis: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOgrave: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOhungarumlaut: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOmacron: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOslash: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOtilde: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    Kcommaaccente: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccenteacute: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentecaron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentecircumflex: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentedieresis: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentedotaccent: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentegrave: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentemacron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccenteogonek: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccento: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentoacute: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentocircumflex: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentodieresis: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentograve: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentohungarumlaut: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentomacron: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentoslash: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentotilde: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentu: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuacute: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentudieresis: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentugrave: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentumacron: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuogonek: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccenturing: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccenty: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kcommaaccentyacute: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kcommaaccentydieresis: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    LT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Ly: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LacuteT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LacuteW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LacuteY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LacuteYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LacuteYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lacutequotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lacutequoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lacutey: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lacuteyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lacuteydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LcommaaccentT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LcommaaccentW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LcommaaccentY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LcommaaccentYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LcommaaccentYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lcommaaccentquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lcommaaccentquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lcommaaccenty: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lcommaaccentyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lcommaaccentydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LslashT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LslashW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LslashY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LslashYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LslashYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lslashquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lslashquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lslashy: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lslashyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lslashydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    OA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ocomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Operiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OacuteA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OacuteX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Oacutecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Oacuteperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OcircumflexX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ocircumflexcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ocircumflexperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OdieresisX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Odieresiscomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Odieresisperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OgraveA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OgraveX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ogravecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ograveperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OhungarumlautX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ohungarumlautcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ohungarumlautperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OmacronA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OmacronX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Omacroncomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Omacronperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OslashA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OslashW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OslashX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OslashY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OslashYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OslashYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Oslashcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Oslashperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OtildeA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OtildeX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Otildecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Otildeperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    PA: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAacute: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAbreve: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAcircumflex: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAdieresis: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAgrave: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAmacron: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAogonek: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAring: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAtilde: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    Pa: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paacute: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pabreve: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pacircumflex: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Padieresis: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pagrave: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pamacron: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paogonek: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paring: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Patilde: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pcomma: [
        -120,
        -120,
        -180,
        -180,
        -92,
        -129,
        -135,
        -111
    ],
    Pe: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Peacute: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pecaron: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pecircumflex: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pedieresis: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pedotaccent: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pegrave: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pemacron: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Peogonek: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Po: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Poacute: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pocircumflex: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Podieresis: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pograve: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pohungarumlaut: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pomacron: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Poslash: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Potilde: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pperiod: [
        -120,
        -120,
        -180,
        -180,
        -110,
        -129,
        -135,
        -111
    ],
    QU: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUacute: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUcircumflex: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUdieresis: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUgrave: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUhungarumlaut: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUmacron: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUogonek: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUring: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    Qcomma: [
        20,
        20
    ],
    Qperiod: [
        20,
        20,
        0,
        0,
        -20
    ],
    RO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RacuteW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RacuteY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RcaronW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RcaronY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RcommaaccentW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RcommaaccentY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    TA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Ta: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Taacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Taogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Taring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Te: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Teacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -70
    ],
    Tedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Temacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Teogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Thyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    To: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Toacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Todieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Toslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Totilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Trcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Turing: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Ty: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    TcaronA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Tcarona: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronaacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tcaronacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tcaronadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronaogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronaring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaroncolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcaroncomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Tcarone: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaroneacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -30
    ],
    Tcaronedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tcaronedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Tcaronemacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Tcaroneogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronhyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    Tcarono: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronoacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronodieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronoslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronotilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tcaronr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronrcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tcaronu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuring: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Tcarony: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcaronyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcaronydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    TcommaaccentA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Tcommaaccenta: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentaacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tcommaaccentacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tcommaaccentadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentaogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentaring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentcolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcommaaccentcomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Tcommaaccente: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccenteacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -30
    ],
    Tcommaaccentedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tcommaaccentedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Tcommaaccentemacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Tcommaaccenteogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccenthyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    Tcommaaccento: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentoacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentodieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentoslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentotilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tcommaaccentr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentrcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tcommaaccentu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccenturing: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Tcommaaccenty: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcommaaccentyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcommaaccentydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    UA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ucomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UacuteA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uacutecomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uacuteperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UcircumflexA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ucircumflexcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Ucircumflexperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UdieresisA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Udieresiscomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Udieresisperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UgraveA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ugravecomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Ugraveperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UhungarumlautA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uhungarumlautcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uhungarumlautperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UmacronA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Umacroncomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Umacronperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UogonekA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uogonekcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uogonekperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UringA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uringcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uringperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    VA: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAacute: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAbreve: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAcircumflex: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAdieresis: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAgrave: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAmacron: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAogonek: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAring: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAtilde: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VG: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VGbreve: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VGcommaaccent: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VO: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOacute: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOdieresis: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOgrave: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOhungarumlaut: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOmacron: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOslash: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOtilde: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    Va: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vaacute: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vabreve: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vacircumflex: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vadieresis: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vagrave: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vamacron: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vaogonek: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Varing: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vatilde: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vcolon: [
        -40,
        -40,
        -40,
        -40,
        -92,
        -74,
        -65,
        -74
    ],
    Vcomma: [
        -120,
        -120,
        -125,
        -125,
        -129,
        -129,
        -129,
        -129
    ],
    Ve: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Veacute: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vecaron: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -71
    ],
    Vecircumflex: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -71
    ],
    Vedieresis: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Vedotaccent: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vegrave: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Vemacron: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Veogonek: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vhyphen: [
        -80,
        -80,
        -80,
        -80,
        -74,
        -70,
        -55,
        -100
    ],
    Vo: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Voacute: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vocircumflex: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vodieresis: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vograve: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vohungarumlaut: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vomacron: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Voslash: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Votilde: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vperiod: [
        -120,
        -120,
        -125,
        -125,
        -145,
        -129,
        -129,
        -129
    ],
    Vsemicolon: [
        -40,
        -40,
        -40,
        -40,
        -92,
        -74,
        -74,
        -74
    ],
    Vu: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuacute: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vucircumflex: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vudieresis: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vugrave: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuhungarumlaut: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vumacron: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuogonek: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuring: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    WA: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAacute: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAbreve: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAcircumflex: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAdieresis: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAgrave: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAmacron: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAogonek: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAring: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAtilde: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WO: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOacute: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOgrave: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOmacron: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOslash: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOtilde: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    Wa: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waacute: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wabreve: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wacircumflex: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wadieresis: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wagrave: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wamacron: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waogonek: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waring: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Watilde: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wcolon: [
        -10,
        -10,
        0,
        0,
        -55,
        -55,
        -65,
        -37
    ],
    Wcomma: [
        -80,
        -80,
        -80,
        -80,
        -92,
        -74,
        -92,
        -92
    ],
    We: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Weacute: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wecaron: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wecircumflex: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wedieresis: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Wedotaccent: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wegrave: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Wemacron: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Weogonek: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Whyphen: [
        -40,
        -40,
        -40,
        -40,
        -37,
        -50,
        -37,
        -65
    ],
    Wo: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Woacute: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wocircumflex: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wodieresis: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wograve: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wohungarumlaut: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Womacron: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Woslash: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wotilde: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wperiod: [
        -80,
        -80,
        -80,
        -80,
        -92,
        -74,
        -92,
        -92
    ],
    Wsemicolon: [
        -10,
        -10,
        0,
        0,
        -55,
        -55,
        -65,
        -37
    ],
    Wu: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuacute: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wucircumflex: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wudieresis: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wugrave: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuhungarumlaut: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wumacron: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuogonek: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuring: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wy: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    Wyacute: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    Wydieresis: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    YA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Ya: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Yacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yaring: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yatilde: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ycolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ycomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Ye: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yeacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Yedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Yeogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yo: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yomacron: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Ysemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    YacuteA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Yacutea: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacutearing: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteatilde: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yacutecolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yacutecomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Yacutee: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteeacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Yacuteedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteeogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteo: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteomacron: [
        -100,
        -100,
        -70,
        -70,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Yacutesemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yacuteu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    YdieresisA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Ydieresisa: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisaring: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisatilde: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresiscolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ydieresiscomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Ydieresise: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresiseacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Ydieresisedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresisedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresisemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresiseogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresiso: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisomacron: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Ydieresissemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ydieresisu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    ag: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    av: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    ay: [
        -20,
        -20,
        -30,
        -30
    ],
    ayacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aacutew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aacutey: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    abrevew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    abrevey: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    acircumflexw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    acircumflexy: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    adieresisw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    adieresisy: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    agravew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    agravey: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    amacrong: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacrongbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacrongcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacronv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    amacronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    amacrony: [
        -20,
        -20,
        -30,
        -30
    ],
    amacronyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    amacronydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aogonekw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aogoneky: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aringg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aringw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aringy: [
        -20,
        -20,
        -30,
        -30
    ],
    aringyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aringydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    atildew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    atildey: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    bl: [
        -10,
        -10,
        -20,
        -20
    ],
    blacute: [
        -10,
        -10,
        -20,
        -20
    ],
    blcommaaccent: [
        -10,
        -10,
        -20,
        -20
    ],
    blslash: [
        -10,
        -10,
        -20,
        -20
    ],
    bu: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buacute: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bucircumflex: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    budieresis: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bugrave: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bumacron: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buogonek: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buring: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bv: [
        -20,
        -20,
        -20,
        -20,
        -15,
        0,
        0,
        -15
    ],
    by: [
        -20,
        -20,
        -20,
        -20
    ],
    byacute: [
        -20,
        -20,
        -20,
        -20
    ],
    bydieresis: [
        -20,
        -20,
        -20,
        -20
    ],
    ch: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ck: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ckcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cl: [
        -20,
        -20
    ],
    clacute: [
        -20,
        -20
    ],
    clcommaaccent: [
        -20,
        -20
    ],
    clslash: [
        -20,
        -20
    ],
    cy: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteh: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    cacutek: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cacutekcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cacutel: [
        -20,
        -20
    ],
    cacutelacute: [
        -20,
        -20
    ],
    cacutelcommaaccent: [
        -20,
        -20
    ],
    cacutelslash: [
        -20,
        -20
    ],
    cacutey: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronh: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ccaronk: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccaronkcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccaronl: [
        -20,
        -20
    ],
    ccaronlacute: [
        -20,
        -20
    ],
    ccaronlcommaaccent: [
        -20,
        -20
    ],
    ccaronlslash: [
        -20,
        -20
    ],
    ccarony: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillah: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ccedillak: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccedillakcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccedillal: [
        -20,
        -20
    ],
    ccedillalacute: [
        -20,
        -20
    ],
    ccedillalcommaaccent: [
        -20,
        -20
    ],
    ccedillalslash: [
        -20,
        -20
    ],
    ccedillay: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillayacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillaydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    colonspace: [
        -40,
        -40,
        -50,
        -50
    ],
    commaquotedblright: [
        -120,
        -120,
        -100,
        -100,
        -45,
        -95,
        -140,
        -70
    ],
    commaquoteright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    commaspace: [
        -40,
        -40
    ],
    dd: [
        -10,
        -10
    ],
    ddcroat: [
        -10,
        -10
    ],
    dv: [
        -15,
        -15
    ],
    dw: [
        -15,
        -15,
        0,
        0,
        -15
    ],
    dy: [
        -15,
        -15
    ],
    dyacute: [
        -15,
        -15
    ],
    dydieresis: [
        -15,
        -15
    ],
    dcroatd: [
        -10,
        -10
    ],
    dcroatdcroat: [
        -10,
        -10
    ],
    dcroatv: [
        -15,
        -15
    ],
    dcroatw: [
        -15,
        -15,
        0,
        0,
        -15
    ],
    dcroaty: [
        -15,
        -15
    ],
    dcroatyacute: [
        -15,
        -15
    ],
    dcroatydieresis: [
        -15,
        -15
    ],
    ecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacutecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eacuteperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    eacutev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    eacutew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    eacutex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    eacutey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacuteyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacuteydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaroncomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    ecaronperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ecaronv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ecaronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ecaronx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ecarony: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaronyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaronydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    ecircumflexperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ecircumflexv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ecircumflexw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ecircumflexx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ecircumflexy: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresiscomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    edieresisperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    edieresisv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    edieresisw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    edieresisx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    edieresisy: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresisyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresisydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    edotaccentperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    edotaccentv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    edotaccentw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    edotaccentx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    edotaccenty: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egravecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    egraveperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    egravev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    egravew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    egravex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    egravey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egraveyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egraveydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacroncomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    emacronperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    emacronv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    emacronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    emacronx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    emacrony: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacronyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacronydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eogonekperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    eogonekv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    eogonekw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    eogonekx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    eogoneky: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    fcomma: [
        -10,
        -10,
        -30,
        -30,
        -15,
        -10,
        -10
    ],
    fe: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    feacute: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fecaron: [
        -10,
        -10,
        -30,
        -30
    ],
    fecircumflex: [
        -10,
        -10,
        -30,
        -30
    ],
    fedieresis: [
        -10,
        -10,
        -30,
        -30
    ],
    fedotaccent: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fegrave: [
        -10,
        -10,
        -30,
        -30
    ],
    femacron: [
        -10,
        -10,
        -30,
        -30
    ],
    feogonek: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fo: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    foacute: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    focircumflex: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fodieresis: [
        -20,
        -20,
        -30,
        -30,
        -25
    ],
    fograve: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fohungarumlaut: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fomacron: [
        -20,
        -20,
        -30,
        -30,
        -25
    ],
    foslash: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fotilde: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fperiod: [
        -10,
        -10,
        -30,
        -30,
        -15,
        -10,
        -15
    ],
    fquotedblright: [
        30,
        30,
        60,
        60,
        50
    ],
    fquoteright: [
        30,
        30,
        50,
        50,
        55,
        55,
        92,
        55
    ],
    ge: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    geacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    geogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    ggbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    ggcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevee: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveeacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveeogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccente: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccenteacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccenteogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    hy: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    hyacute: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    hydieresis: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    ko: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    koacute: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kocircumflex: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kodieresis: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kograve: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kohungarumlaut: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    komacron: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    koslash: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kotilde: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccento: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentoacute: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentocircumflex: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentodieresis: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentograve: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentohungarumlaut: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentomacron: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentoslash: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentotilde: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    lw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ly: [
        -15,
        -15
    ],
    lyacute: [
        -15,
        -15
    ],
    lydieresis: [
        -15,
        -15
    ],
    lacutew: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lacutey: [
        -15,
        -15
    ],
    lacuteyacute: [
        -15,
        -15
    ],
    lacuteydieresis: [
        -15,
        -15
    ],
    lcommaaccentw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lcommaaccenty: [
        -15,
        -15
    ],
    lcommaaccentyacute: [
        -15,
        -15
    ],
    lcommaaccentydieresis: [
        -15,
        -15
    ],
    lslashw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lslashy: [
        -15,
        -15
    ],
    lslashyacute: [
        -15,
        -15
    ],
    lslashydieresis: [
        -15,
        -15
    ],
    mu: [
        -20,
        -20,
        -10,
        -10
    ],
    muacute: [
        -20,
        -20,
        -10,
        -10
    ],
    mucircumflex: [
        -20,
        -20,
        -10,
        -10
    ],
    mudieresis: [
        -20,
        -20,
        -10,
        -10
    ],
    mugrave: [
        -20,
        -20,
        -10,
        -10
    ],
    muhungarumlaut: [
        -20,
        -20,
        -10,
        -10
    ],
    mumacron: [
        -20,
        -20,
        -10,
        -10
    ],
    muogonek: [
        -20,
        -20,
        -10,
        -10
    ],
    muring: [
        -20,
        -20,
        -10,
        -10
    ],
    my: [
        -30,
        -30,
        -15,
        -15
    ],
    myacute: [
        -30,
        -30,
        -15,
        -15
    ],
    mydieresis: [
        -30,
        -30,
        -15,
        -15
    ],
    nu: [
        -10,
        -10,
        -10,
        -10
    ],
    nuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    nucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    nudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    nugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    nuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    numacron: [
        -10,
        -10,
        -10,
        -10
    ],
    nuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    nuring: [
        -10,
        -10,
        -10,
        -10
    ],
    nv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ny: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteu: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuring: [
        -10,
        -10,
        -10,
        -10
    ],
    nacutev: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    nacutey: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronu: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuring: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ncarony: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentu: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccenturing: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ncommaaccenty: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeu: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuring: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildev: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ntildey: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ov: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ow: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ox: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    oy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacutev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    oacutew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    oacutex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    oacutey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacuteyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacuteydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ocircumflexw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ocircumflexx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ocircumflexy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    odieresisw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    odieresisx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    odieresisy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ogravev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ogravew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ogravex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ogravey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ograveyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ograveydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ohungarumlautw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ohungarumlautx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ohungarumlauty: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    omacronw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    omacronx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    omacrony: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oslashv: [
        -20,
        -20,
        -70,
        -70,
        -10,
        -15,
        -10,
        -15
    ],
    oslashw: [
        -15,
        -15,
        -70,
        -70,
        -10,
        -25,
        0,
        -25
    ],
    oslashx: [
        -30,
        -30,
        -85,
        -85,
        0,
        -10
    ],
    oslashy: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    oslashyacute: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    oslashydieresis: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    otildev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    otildew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    otildex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    otildey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    otildeyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    otildeydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    py: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    pyacute: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    pydieresis: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    periodquotedblright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    periodquoteright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    periodspace: [
        -40,
        -40,
        -60,
        -60
    ],
    quotedblrightspace: [
        -80,
        -80,
        -40,
        -40
    ],
    quoteleftquoteleft: [
        -46,
        -46,
        -57,
        -57,
        -63,
        -74,
        -111,
        -74
    ],
    quoterightd: [
        -80,
        -80,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightdcroat: [
        -80,
        -80,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightl: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlacute: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlcommaaccent: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlslash: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightquoteright: [
        -46,
        -46,
        -57,
        -57,
        -63,
        -74,
        -111,
        -74
    ],
    quoterightr: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightracute: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightrcaron: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightrcommaaccent: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterights: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightsacute: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscaron: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscedilla: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscommaaccent: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightspace: [
        -80,
        -80,
        -70,
        -70,
        -74,
        -74,
        -111,
        -74
    ],
    quoterightv: [
        -20,
        -20,
        0,
        0,
        -20,
        -15,
        -10,
        -50
    ],
    rc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rd: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rdcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rgbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rgcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rhyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    ro: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    roacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    romacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    roslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rs: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rt: [
        20,
        20,
        40,
        40
    ],
    rtcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rv: [
        10,
        10,
        30,
        30,
        -10
    ],
    ry: [
        10,
        10,
        30,
        30
    ],
    ryacute: [
        10,
        10,
        30,
        30
    ],
    rydieresis: [
        10,
        10,
        30,
        30
    ],
    racutec: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutecacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutecomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    racuted: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    racutedcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    racuteg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutegbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutegcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutehyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    racuteo: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    racuteq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutes: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutesacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutet: [
        20,
        20,
        40,
        40
    ],
    racutetcommaaccent: [
        20,
        20,
        40,
        40
    ],
    racutev: [
        10,
        10,
        30,
        30,
        -10
    ],
    racutey: [
        10,
        10,
        30,
        30
    ],
    racuteyacute: [
        10,
        10,
        30,
        30
    ],
    racuteydieresis: [
        10,
        10,
        30,
        30
    ],
    rcaronc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroncacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroncomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rcarond: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcarondcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcarong: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcarongbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcarongcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcaronhyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    rcarono: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rcaronq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcarons: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaront: [
        20,
        20,
        40,
        40
    ],
    rcarontcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rcaronv: [
        10,
        10,
        30,
        30,
        -10
    ],
    rcarony: [
        10,
        10,
        30,
        30
    ],
    rcaronyacute: [
        10,
        10,
        30,
        30
    ],
    rcaronydieresis: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentcacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentcomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rcommaaccentd: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcommaaccentdcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcommaaccentg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccentgbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccentgcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccenthyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    rcommaaccento: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rcommaaccentq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccents: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentt: [
        20,
        20,
        40,
        40
    ],
    rcommaaccenttcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rcommaaccentv: [
        10,
        10,
        30,
        30,
        -10
    ],
    rcommaaccenty: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentyacute: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentydieresis: [
        10,
        10,
        30,
        30
    ],
    sw: [
        -15,
        -15,
        -30,
        -30
    ],
    sacutew: [
        -15,
        -15,
        -30,
        -30
    ],
    scaronw: [
        -15,
        -15,
        -30,
        -30
    ],
    scedillaw: [
        -15,
        -15,
        -30,
        -30
    ],
    scommaaccentw: [
        -15,
        -15,
        -30,
        -30
    ],
    semicolonspace: [
        -40,
        -40,
        -50,
        -50
    ],
    spaceT: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceTcaron: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceTcommaaccent: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceV: [
        -80,
        -80,
        -50,
        -50,
        -45,
        -70,
        -35,
        -50
    ],
    spaceW: [
        -80,
        -80,
        -40,
        -40,
        -30,
        -70,
        -40,
        -30
    ],
    spaceY: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spaceYacute: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spaceYdieresis: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spacequotedblleft: [
        -80,
        -80,
        -30,
        -30
    ],
    spacequoteleft: [
        -60,
        -60,
        -60,
        -60
    ],
    va: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vaacute: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vabreve: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vacircumflex: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vadieresis: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vagrave: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vamacron: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vaogonek: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    varing: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vatilde: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vcomma: [
        -80,
        -80,
        -80,
        -80,
        -55,
        -37,
        -74,
        -65
    ],
    vo: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    voacute: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vocircumflex: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vodieresis: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vograve: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vohungarumlaut: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vomacron: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    voslash: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    votilde: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vperiod: [
        -80,
        -80,
        -80,
        -80,
        -70,
        -37,
        -74,
        -65
    ],
    wcomma: [
        -40,
        -40,
        -60,
        -60,
        -55,
        -37,
        -74,
        -65
    ],
    wo: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    woacute: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wocircumflex: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wodieresis: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wograve: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wohungarumlaut: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    womacron: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    woslash: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wotilde: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wperiod: [
        -40,
        -40,
        -60,
        -60,
        -70,
        -37,
        -74,
        -65
    ],
    xe: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xeacute: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xecaron: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xecircumflex: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xedieresis: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xedotaccent: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xegrave: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xemacron: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xeogonek: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    ya: [
        -30,
        -30,
        -20,
        -20
    ],
    yaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    yabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    yacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    yadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    yagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    yamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    yaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    yaring: [
        -30,
        -30,
        -20,
        -20
    ],
    yatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    ycomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    ye: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yeacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yeogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yo: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    yacutea: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    yacutearing: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    yacutecomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    yacutee: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteeacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteeogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteo: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    ydieresisa: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaring: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresiscomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    ydieresise: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiseacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiseogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiso: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    ze: [
        10,
        10,
        -15,
        -15
    ],
    zeacute: [
        10,
        10,
        -15,
        -15
    ],
    zecaron: [
        10,
        10,
        -15,
        -15
    ],
    zecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zegrave: [
        10,
        10,
        -15,
        -15
    ],
    zemacron: [
        10,
        10,
        -15,
        -15
    ],
    zeogonek: [
        10,
        10,
        -15,
        -15
    ],
    zacutee: [
        10,
        10,
        -15,
        -15
    ],
    zacuteeacute: [
        10,
        10,
        -15,
        -15
    ],
    zacuteecaron: [
        10,
        10,
        -15,
        -15
    ],
    zacuteecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zacuteedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zacuteedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zacuteegrave: [
        10,
        10,
        -15,
        -15
    ],
    zacuteemacron: [
        10,
        10,
        -15,
        -15
    ],
    zacuteeogonek: [
        10,
        10,
        -15,
        -15
    ],
    zcarone: [
        10,
        10,
        -15,
        -15
    ],
    zcaroneacute: [
        10,
        10,
        -15,
        -15
    ],
    zcaronecaron: [
        10,
        10,
        -15,
        -15
    ],
    zcaronecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zcaronedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zcaronedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zcaronegrave: [
        10,
        10,
        -15,
        -15
    ],
    zcaronemacron: [
        10,
        10,
        -15,
        -15
    ],
    zcaroneogonek: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccente: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccenteacute: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentecaron: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentegrave: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentemacron: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccenteogonek: [
        10,
        10,
        -15,
        -15
    ],
    Bcomma: [
        0,
        0,
        -20,
        -20
    ],
    Bperiod: [
        0,
        0,
        -20,
        -20
    ],
    Ccomma: [
        0,
        0,
        -30,
        -30
    ],
    Cperiod: [
        0,
        0,
        -30,
        -30
    ],
    Cacutecomma: [
        0,
        0,
        -30,
        -30
    ],
    Cacuteperiod: [
        0,
        0,
        -30,
        -30
    ],
    Ccaroncomma: [
        0,
        0,
        -30,
        -30
    ],
    Ccaronperiod: [
        0,
        0,
        -30,
        -30
    ],
    Ccedillacomma: [
        0,
        0,
        -30,
        -30
    ],
    Ccedillaperiod: [
        0,
        0,
        -30,
        -30
    ],
    Fe: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Feacute: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fecaron: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fecircumflex: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fedieresis: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fedotaccent: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fegrave: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Femacron: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Feogonek: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fo: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Foacute: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Focircumflex: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fodieresis: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fograve: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fohungarumlaut: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fomacron: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Foslash: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fotilde: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fr: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Fracute: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Frcaron: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Frcommaaccent: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Ja: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaacute: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jabreve: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jacircumflex: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jadieresis: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jagrave: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jamacron: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaogonek: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaring: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jatilde: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    LcaronT: [
        0,
        0,
        -110,
        -110
    ],
    LcaronTcaron: [
        0,
        0,
        -110,
        -110
    ],
    LcaronTcommaaccent: [
        0,
        0,
        -110,
        -110
    ],
    LcaronV: [
        0,
        0,
        -110,
        -110
    ],
    LcaronW: [
        0,
        0,
        -70,
        -70
    ],
    LcaronY: [
        0,
        0,
        -140,
        -140
    ],
    LcaronYacute: [
        0,
        0,
        -140,
        -140
    ],
    LcaronYdieresis: [
        0,
        0,
        -140,
        -140
    ],
    Lcaronquotedblright: [
        0,
        0,
        -140,
        -140
    ],
    Lcaronquoteright: [
        0,
        0,
        -160,
        -160,
        0,
        0,
        0,
        -92
    ],
    Lcarony: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Lcaronyacute: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Lcaronydieresis: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Scomma: [
        0,
        0,
        -20,
        -20
    ],
    Speriod: [
        0,
        0,
        -20,
        -20
    ],
    Sacutecomma: [
        0,
        0,
        -20,
        -20
    ],
    Sacuteperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scaroncomma: [
        0,
        0,
        -20,
        -20
    ],
    Scaronperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scedillacomma: [
        0,
        0,
        -20,
        -20
    ],
    Scedillaperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scommaaccentcomma: [
        0,
        0,
        -20,
        -20
    ],
    Scommaaccentperiod: [
        0,
        0,
        -20,
        -20
    ],
    Trcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronrcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentrcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Yhyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Yi: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacutehyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Yacutei: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacuteiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacuteiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresishyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Ydieresisi: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresisiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresisiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    bb: [
        0,
        0,
        -10,
        -10,
        -10,
        -10
    ],
    bcomma: [
        0,
        0,
        -40,
        -40
    ],
    bperiod: [
        0,
        0,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    ccomma: [
        0,
        0,
        -15,
        -15
    ],
    cacutecomma: [
        0,
        0,
        -15,
        -15
    ],
    ccaroncomma: [
        0,
        0,
        -15,
        -15
    ],
    ccedillacomma: [
        0,
        0,
        -15,
        -15
    ],
    fa: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faacute: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fabreve: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    facircumflex: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fadieresis: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fagrave: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    famacron: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faogonek: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faring: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fatilde: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fdotlessi: [
        0,
        0,
        -28,
        -28,
        -35,
        -30,
        -60,
        -50
    ],
    gr: [
        0,
        0,
        -10,
        -10
    ],
    gracute: [
        0,
        0,
        -10,
        -10
    ],
    grcaron: [
        0,
        0,
        -10,
        -10
    ],
    grcommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    gbrever: [
        0,
        0,
        -10,
        -10
    ],
    gbreveracute: [
        0,
        0,
        -10,
        -10
    ],
    gbrevercaron: [
        0,
        0,
        -10,
        -10
    ],
    gbrevercommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentr: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentracute: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentrcaron: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentrcommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    ke: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    keacute: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kecaron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kecircumflex: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kedieresis: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kedotaccent: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kegrave: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kemacron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    keogonek: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccente: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccenteacute: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentecaron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentecircumflex: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentedieresis: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentedotaccent: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentegrave: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentemacron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccenteogonek: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    ocomma: [
        0,
        0,
        -40,
        -40
    ],
    operiod: [
        0,
        0,
        -40,
        -40
    ],
    oacutecomma: [
        0,
        0,
        -40,
        -40
    ],
    oacuteperiod: [
        0,
        0,
        -40,
        -40
    ],
    ocircumflexcomma: [
        0,
        0,
        -40,
        -40
    ],
    ocircumflexperiod: [
        0,
        0,
        -40,
        -40
    ],
    odieresiscomma: [
        0,
        0,
        -40,
        -40
    ],
    odieresisperiod: [
        0,
        0,
        -40,
        -40
    ],
    ogravecomma: [
        0,
        0,
        -40,
        -40
    ],
    ograveperiod: [
        0,
        0,
        -40,
        -40
    ],
    ohungarumlautcomma: [
        0,
        0,
        -40,
        -40
    ],
    ohungarumlautperiod: [
        0,
        0,
        -40,
        -40
    ],
    omacroncomma: [
        0,
        0,
        -40,
        -40
    ],
    omacronperiod: [
        0,
        0,
        -40,
        -40
    ],
    oslasha: [
        0,
        0,
        -55,
        -55
    ],
    oslashaacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashabreve: [
        0,
        0,
        -55,
        -55
    ],
    oslashacircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashadieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashagrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashamacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashaogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslasharing: [
        0,
        0,
        -55,
        -55
    ],
    oslashatilde: [
        0,
        0,
        -55,
        -55
    ],
    oslashb: [
        0,
        0,
        -55,
        -55
    ],
    oslashc: [
        0,
        0,
        -55,
        -55
    ],
    oslashcacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashccaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashccedilla: [
        0,
        0,
        -55,
        -55
    ],
    oslashcomma: [
        0,
        0,
        -95,
        -95
    ],
    oslashd: [
        0,
        0,
        -55,
        -55
    ],
    oslashdcroat: [
        0,
        0,
        -55,
        -55
    ],
    oslashe: [
        0,
        0,
        -55,
        -55
    ],
    oslasheacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashecaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashecircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashedieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashedotaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashegrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashemacron: [
        0,
        0,
        -55,
        -55
    ],
    oslasheogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashf: [
        0,
        0,
        -55,
        -55
    ],
    oslashg: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashgbreve: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashgcommaaccent: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashh: [
        0,
        0,
        -55,
        -55
    ],
    oslashi: [
        0,
        0,
        -55,
        -55
    ],
    oslashiacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashicircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashidieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashigrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashimacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashiogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashj: [
        0,
        0,
        -55,
        -55
    ],
    oslashk: [
        0,
        0,
        -55,
        -55
    ],
    oslashkcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashl: [
        0,
        0,
        -55,
        -55
    ],
    oslashlacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashlcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashlslash: [
        0,
        0,
        -55,
        -55
    ],
    oslashm: [
        0,
        0,
        -55,
        -55
    ],
    oslashn: [
        0,
        0,
        -55,
        -55
    ],
    oslashnacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashncaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashncommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashntilde: [
        0,
        0,
        -55,
        -55
    ],
    oslasho: [
        0,
        0,
        -55,
        -55
    ],
    oslashoacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashocircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashodieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashograve: [
        0,
        0,
        -55,
        -55
    ],
    oslashohungarumlaut: [
        0,
        0,
        -55,
        -55
    ],
    oslashomacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashoslash: [
        0,
        0,
        -55,
        -55
    ],
    oslashotilde: [
        0,
        0,
        -55,
        -55
    ],
    oslashp: [
        0,
        0,
        -55,
        -55
    ],
    oslashperiod: [
        0,
        0,
        -95,
        -95
    ],
    oslashq: [
        0,
        0,
        -55,
        -55
    ],
    oslashr: [
        0,
        0,
        -55,
        -55
    ],
    oslashracute: [
        0,
        0,
        -55,
        -55
    ],
    oslashrcaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashrcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashs: [
        0,
        0,
        -55,
        -55
    ],
    oslashsacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashscaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashscedilla: [
        0,
        0,
        -55,
        -55
    ],
    oslashscommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslasht: [
        0,
        0,
        -55,
        -55
    ],
    oslashtcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashu: [
        0,
        0,
        -55,
        -55
    ],
    oslashuacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashucircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashudieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashugrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashuhungarumlaut: [
        0,
        0,
        -55,
        -55
    ],
    oslashumacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashuogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashuring: [
        0,
        0,
        -55,
        -55
    ],
    oslashz: [
        0,
        0,
        -55,
        -55
    ],
    oslashzacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashzcaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashzdotaccent: [
        0,
        0,
        -55,
        -55
    ],
    otildecomma: [
        0,
        0,
        -40,
        -40
    ],
    otildeperiod: [
        0,
        0,
        -40,
        -40
    ],
    pcomma: [
        0,
        0,
        -35,
        -35
    ],
    pperiod: [
        0,
        0,
        -35,
        -35
    ],
    ra: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    radieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ragrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ramacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ratilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcolon: [
        0,
        0,
        30,
        30
    ],
    ri: [
        0,
        0,
        15,
        15
    ],
    riacute: [
        0,
        0,
        15,
        15
    ],
    ricircumflex: [
        0,
        0,
        15,
        15
    ],
    ridieresis: [
        0,
        0,
        15,
        15
    ],
    rigrave: [
        0,
        0,
        15,
        15
    ],
    rimacron: [
        0,
        0,
        15,
        15
    ],
    riogonek: [
        0,
        0,
        15,
        15
    ],
    rk: [
        0,
        0,
        15,
        15
    ],
    rkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rl: [
        0,
        0,
        15,
        15
    ],
    rlacute: [
        0,
        0,
        15,
        15
    ],
    rlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rlslash: [
        0,
        0,
        15,
        15
    ],
    rm: [
        0,
        0,
        25,
        25
    ],
    rn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rsemicolon: [
        0,
        0,
        30,
        30
    ],
    ru: [
        0,
        0,
        15,
        15
    ],
    ruacute: [
        0,
        0,
        15,
        15
    ],
    rucircumflex: [
        0,
        0,
        15,
        15
    ],
    rudieresis: [
        0,
        0,
        15,
        15
    ],
    rugrave: [
        0,
        0,
        15,
        15
    ],
    ruhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rumacron: [
        0,
        0,
        15,
        15
    ],
    ruogonek: [
        0,
        0,
        15,
        15
    ],
    ruring: [
        0,
        0,
        15,
        15
    ],
    racutea: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racutearing: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racutecolon: [
        0,
        0,
        30,
        30
    ],
    racutei: [
        0,
        0,
        15,
        15
    ],
    racuteiacute: [
        0,
        0,
        15,
        15
    ],
    racuteicircumflex: [
        0,
        0,
        15,
        15
    ],
    racuteidieresis: [
        0,
        0,
        15,
        15
    ],
    racuteigrave: [
        0,
        0,
        15,
        15
    ],
    racuteimacron: [
        0,
        0,
        15,
        15
    ],
    racuteiogonek: [
        0,
        0,
        15,
        15
    ],
    racutek: [
        0,
        0,
        15,
        15
    ],
    racutekcommaaccent: [
        0,
        0,
        15,
        15
    ],
    racutel: [
        0,
        0,
        15,
        15
    ],
    racutelacute: [
        0,
        0,
        15,
        15
    ],
    racutelcommaaccent: [
        0,
        0,
        15,
        15
    ],
    racutelslash: [
        0,
        0,
        15,
        15
    ],
    racutem: [
        0,
        0,
        25,
        25
    ],
    racuten: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutenacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutencaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutencommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutentilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutep: [
        0,
        0,
        30,
        30,
        -10
    ],
    racutesemicolon: [
        0,
        0,
        30,
        30
    ],
    racuteu: [
        0,
        0,
        15,
        15
    ],
    racuteuacute: [
        0,
        0,
        15,
        15
    ],
    racuteucircumflex: [
        0,
        0,
        15,
        15
    ],
    racuteudieresis: [
        0,
        0,
        15,
        15
    ],
    racuteugrave: [
        0,
        0,
        15,
        15
    ],
    racuteuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    racuteumacron: [
        0,
        0,
        15,
        15
    ],
    racuteuogonek: [
        0,
        0,
        15,
        15
    ],
    racuteuring: [
        0,
        0,
        15,
        15
    ],
    rcarona: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaroncolon: [
        0,
        0,
        30,
        30
    ],
    rcaroni: [
        0,
        0,
        15,
        15
    ],
    rcaroniacute: [
        0,
        0,
        15,
        15
    ],
    rcaronicircumflex: [
        0,
        0,
        15,
        15
    ],
    rcaronidieresis: [
        0,
        0,
        15,
        15
    ],
    rcaronigrave: [
        0,
        0,
        15,
        15
    ],
    rcaronimacron: [
        0,
        0,
        15,
        15
    ],
    rcaroniogonek: [
        0,
        0,
        15,
        15
    ],
    rcaronk: [
        0,
        0,
        15,
        15
    ],
    rcaronkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcaronl: [
        0,
        0,
        15,
        15
    ],
    rcaronlacute: [
        0,
        0,
        15,
        15
    ],
    rcaronlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcaronlslash: [
        0,
        0,
        15,
        15
    ],
    rcaronm: [
        0,
        0,
        25,
        25
    ],
    rcaronn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rcaronsemicolon: [
        0,
        0,
        30,
        30
    ],
    rcaronu: [
        0,
        0,
        15,
        15
    ],
    rcaronuacute: [
        0,
        0,
        15,
        15
    ],
    rcaronucircumflex: [
        0,
        0,
        15,
        15
    ],
    rcaronudieresis: [
        0,
        0,
        15,
        15
    ],
    rcaronugrave: [
        0,
        0,
        15,
        15
    ],
    rcaronuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rcaronumacron: [
        0,
        0,
        15,
        15
    ],
    rcaronuogonek: [
        0,
        0,
        15,
        15
    ],
    rcaronuring: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenta: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentcolon: [
        0,
        0,
        30,
        30
    ],
    rcommaaccenti: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentiacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenticircumflex: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentidieresis: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentigrave: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentimacron: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentiogonek: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentk: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentl: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlslash: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentm: [
        0,
        0,
        25,
        25
    ],
    rcommaaccentn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rcommaaccentsemicolon: [
        0,
        0,
        30,
        30
    ],
    rcommaaccentu: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentucircumflex: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentudieresis: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentugrave: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentumacron: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuogonek: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenturing: [
        0,
        0,
        15,
        15
    ],
    scomma: [
        0,
        0,
        -15,
        -15
    ],
    speriod: [
        0,
        0,
        -15,
        -15
    ],
    sacutecomma: [
        0,
        0,
        -15,
        -15
    ],
    sacuteperiod: [
        0,
        0,
        -15,
        -15
    ],
    scaroncomma: [
        0,
        0,
        -15,
        -15
    ],
    scaronperiod: [
        0,
        0,
        -15,
        -15
    ],
    scedillacomma: [
        0,
        0,
        -15,
        -15
    ],
    scedillaperiod: [
        0,
        0,
        -15,
        -15
    ],
    scommaaccentcomma: [
        0,
        0,
        -15,
        -15
    ],
    scommaaccentperiod: [
        0,
        0,
        -15,
        -15
    ],
    ve: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    veacute: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vecaron: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vecircumflex: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vedieresis: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vedotaccent: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vegrave: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vemacron: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    veogonek: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    wa: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waacute: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wabreve: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wacircumflex: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wadieresis: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wagrave: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wamacron: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waogonek: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waring: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    watilde: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    we: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    weacute: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wecaron: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wecircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wedieresis: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wedotaccent: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wegrave: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wemacron: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    weogonek: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    zo: [
        0,
        0,
        -15,
        -15
    ],
    zoacute: [
        0,
        0,
        -15,
        -15
    ],
    zocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zograve: [
        0,
        0,
        -15,
        -15
    ],
    zohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zomacron: [
        0,
        0,
        -15,
        -15
    ],
    zoslash: [
        0,
        0,
        -15,
        -15
    ],
    zotilde: [
        0,
        0,
        -15,
        -15
    ],
    zacuteo: [
        0,
        0,
        -15,
        -15
    ],
    zacuteoacute: [
        0,
        0,
        -15,
        -15
    ],
    zacuteocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zacuteodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zacuteograve: [
        0,
        0,
        -15,
        -15
    ],
    zacuteohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zacuteomacron: [
        0,
        0,
        -15,
        -15
    ],
    zacuteoslash: [
        0,
        0,
        -15,
        -15
    ],
    zacuteotilde: [
        0,
        0,
        -15,
        -15
    ],
    zcarono: [
        0,
        0,
        -15,
        -15
    ],
    zcaronoacute: [
        0,
        0,
        -15,
        -15
    ],
    zcaronocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zcaronodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zcaronograve: [
        0,
        0,
        -15,
        -15
    ],
    zcaronohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zcaronomacron: [
        0,
        0,
        -15,
        -15
    ],
    zcaronoslash: [
        0,
        0,
        -15,
        -15
    ],
    zcaronotilde: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccento: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentoacute: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentograve: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentomacron: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentoslash: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentotilde: [
        0,
        0,
        -15,
        -15
    ],
    Ap: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aacutep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aacutequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Abrevep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Abrevequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Acircumflexp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Acircumflexquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Adieresisp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Adieresisquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Agravep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Agravequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Amacronp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Amacronquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aogonekp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aogonekquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aringp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aringquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Atildep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Atildequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Je: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jeacute: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jecaron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jecircumflex: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jedieresis: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jedotaccent: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jegrave: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jemacron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jeogonek: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jo: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Joacute: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jocircumflex: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jodieresis: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jograve: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Johungarumlaut: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jomacron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Joslash: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jotilde: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    NA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    Ti: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroni: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroniacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroniogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccenti: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccentiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccentiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Vi: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Viacute: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Vicircumflex: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vidieresis: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vigrave: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vimacron: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Viogonek: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Wi: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    Wiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    Wiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    fi: [
        0,
        0,
        0,
        0,
        -25,
        0,
        -20,
        -20
    ],
    gperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    gbreveperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    gcommaaccentperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    iv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    iacutev: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    icircumflexv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    idieresisv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    igravev: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    imacronv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    iogonekv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    ky: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kyacute: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kydieresis: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccenty: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccentyacute: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccentydieresis: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    quotedblleftA: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAacute: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAbreve: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAcircumflex: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAdieresis: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAgrave: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAmacron: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAogonek: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAring: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAtilde: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftA: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAacute: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAbreve: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAcircumflex: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAdieresis: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAgrave: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAmacron: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAogonek: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAring: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAtilde: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    re: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    reacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    recaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    recircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    redieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    redotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    regrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    remacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    reogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutee: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteeacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteeogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcarone: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroneacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroneogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccente: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccenteacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccenteogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    spaceA: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAacute: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAbreve: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAcircumflex: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAdieresis: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAgrave: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAmacron: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAogonek: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAring: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAtilde: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    Fi: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fiacute: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Ficircumflex: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fidieresis: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Figrave: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fimacron: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fiogonek: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    eb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    eacuteb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ecaronb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ecircumflexb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    edieresisb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    edotaccentb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    egraveb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    emacronb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    eogonekb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ff: [
        0,
        0,
        0,
        0,
        0,
        -18,
        -18,
        -25
    ],
    quoterightt: [
        0,
        0,
        0,
        0,
        0,
        -37,
        -30,
        -18
    ],
    quoterighttcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        -37,
        -30,
        -18
    ],
    Yicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    eg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacuteg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacutegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacutegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egraveg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egravegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egravegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    fiogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        -20
    ],
    gcomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevecomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentcomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    og: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacuteg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacutegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacutegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ograveg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogravegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogravegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildeg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    fiacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -20
    ],
    ga: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    garing: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbrevea: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbrevearing: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccenta: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaring: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ]
};
var data = {
    attributes: attributes,
    glyphWidths: glyphWidths,
    kernPairs: kernPairs
};
var initFont = function initFont(font) {
    return [
        font.FontName,
        {
            attributes: font,
            glyphWidths: {},
            kernPairs: {}
        }
    ];
};
var expandData = function expandData(data) {
    var attributes = data.attributes, glyphWidths = data.glyphWidths, kernPairs = data.kernPairs;
    var fonts = attributes.map(initFont);
    Object.keys(glyphWidths).forEach(function(key) {
        glyphWidths[key].forEach(function(value, index) {
            if (value) fonts[index][1].glyphWidths[key] = value;
        });
    });
    Object.keys(kernPairs).forEach(function(key) {
        kernPairs[key].forEach(function(value, index) {
            if (value) fonts[index][1].kernPairs[key] = value;
        });
    });
    return Object.fromEntries(fonts);
};
var STANDARD_FONTS = expandData(data);
var createStandardFont = function createStandardFont(PDFFont) {
    return /*#__PURE__*/ function(_PDFFont) {
        (0, _inheritsLooseDefault.default)(StandardFont, _PDFFont);
        function StandardFont(document, name, id) {
            var _this;
            _this = _PDFFont.call(this) || this;
            _this.document = document;
            _this.name = name;
            _this.id = id;
            _this.font = AFMFont.fromJson(STANDARD_FONTS[_this.name]);
            _this.ascender = _this.font.ascender;
            _this.descender = _this.font.descender;
            _this.bbox = _this.font.bbox;
            _this.lineGap = _this.font.lineGap;
            return _this;
        }
        var _proto = StandardFont.prototype;
        _proto.embed = function embed() {
            this.dictionary.data = {
                Type: "Font",
                BaseFont: this.name,
                Subtype: "Type1",
                Encoding: "WinAnsiEncoding"
            };
            return this.dictionary.end();
        };
        _proto.encode = function encode(text) {
            var encoded = this.font.encodeText(text);
            var glyphs = this.font.glyphsForString("" + text);
            var advances = this.font.advancesForGlyphs(glyphs);
            var positions = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                positions.push({
                    xAdvance: advances[i],
                    yAdvance: 0,
                    xOffset: 0,
                    yOffset: 0,
                    advanceWidth: this.font.widthOfGlyph(glyph)
                });
            }
            return [
                encoded,
                positions
            ];
        };
        _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
            var res = [];
            for(var _i = 0, _Array$from = Array.from(glyphs); _i < _Array$from.length; _i++){
                var glyph = _Array$from[_i];
                res.push(("00" + glyph.id.toString(16)).slice(-2));
            }
            return res;
        };
        _proto.widthOfString = function widthOfString(string, size) {
            var glyphs = this.font.glyphsForString("" + string);
            var advances = this.font.advancesForGlyphs(glyphs);
            var width = 0;
            for(var _i2 = 0, _Array$from2 = Array.from(advances); _i2 < _Array$from2.length; _i2++){
                var advance = _Array$from2[_i2];
                width += advance;
            }
            var scale = size / 1000;
            return width * scale;
        };
        StandardFont.isStandardFont = function isStandardFont(name) {
            return name in STANDARD_FONTS;
        };
        return StandardFont;
    }(PDFFont);
};
var toHex = function toHex() {
    for(var _len = arguments.length, codePoints = new Array(_len), _key = 0; _key < _len; _key++)codePoints[_key] = arguments[_key];
    var codes = Array.from(codePoints).map(function(code) {
        return ("0000" + code.toString(16)).slice(-4);
    });
    return codes.join("");
};
var createEmbeddedFont = function createEmbeddedFont(PDFFont) {
    return /*#__PURE__*/ function(_PDFFont) {
        (0, _inheritsLooseDefault.default)(EmbeddedFont, _PDFFont);
        function EmbeddedFont(document, font, id) {
            var _this;
            _this = _PDFFont.call(this) || this;
            _this.document = document;
            _this.font = font;
            _this.id = id;
            _this.subset = _this.font.createSubset();
            _this.unicode = [
                [
                    0
                ]
            ];
            _this.widths = [
                _this.font.getGlyph(0).advanceWidth
            ];
            _this.name = _this.font.postscriptName;
            _this.scale = 1000 / _this.font.unitsPerEm;
            _this.ascender = _this.font.ascent * _this.scale;
            _this.descender = _this.font.descent * _this.scale;
            _this.xHeight = _this.font.xHeight * _this.scale;
            _this.capHeight = _this.font.capHeight * _this.scale;
            _this.lineGap = _this.font.lineGap * _this.scale;
            _this.bbox = _this.font.bbox;
            _this.layoutCache = Object.create(null);
            return _this;
        }
        var _proto = EmbeddedFont.prototype;
        _proto.layoutRun = function layoutRun(text, features) {
            // passing LTR To force fontkit to not reverse the string
            var run = this.font.layout(text, features, undefined, undefined, "ltr");
            // Normalize position values
            for(var i = 0; i < run.positions.length; i++){
                var position = run.positions[i];
                for(var key in position)position[key] *= this.scale;
                position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
            }
            return run;
        };
        _proto.layoutCached = function layoutCached(text) {
            var cached;
            if (cached = this.layoutCache[text]) return cached;
            var run = this.layoutRun(text);
            this.layoutCache[text] = run;
            return run;
        };
        _proto.layout = function layout(text, features, onlyWidth) {
            // Skip the cache if any user defined features are applied
            if (onlyWidth == null) onlyWidth = false;
            if (features) return this.layoutRun(text, features);
            var glyphs = onlyWidth ? null : [];
            var positions = onlyWidth ? null : [];
            var advanceWidth = 0;
            // Split the string by words to increase cache efficiency.
            // For this purpose, spaces and tabs are a good enough delimeter.
            var last = 0;
            var index = 0;
            while(index <= text.length){
                var needle = void 0;
                if (index === text.length && last < index || (needle = text.charAt(index), [
                    " ",
                    "	"
                ].includes(needle))) {
                    var run = this.layoutCached(text.slice(last, ++index));
                    if (!onlyWidth) {
                        glyphs.push.apply(glyphs, Array.from(run.glyphs || []));
                        positions.push.apply(positions, Array.from(run.positions || []));
                    }
                    advanceWidth += run.advanceWidth;
                    last = index;
                } else index++;
            }
            return {
                glyphs: glyphs,
                positions: positions,
                advanceWidth: advanceWidth
            };
        };
        _proto.encode = function encode(text, features) {
            var _this$layout = this.layout(text, features), glyphs = _this$layout.glyphs, positions = _this$layout.positions;
            var res = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                var gid = this.subset.includeGlyph(glyph.id);
                res.push(("0000" + gid.toString(16)).slice(-4));
                if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
            }
            return [
                res,
                positions
            ];
        };
        _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
            var res = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                var gid = this.subset.includeGlyph(glyph.id);
                res.push(("0000" + gid.toString(16)).slice(-4));
                if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                if (this.unicode[gid] == null) this.unicode[gid] = glyph.codePoints;
            }
            return res;
        };
        _proto.widthOfString = function widthOfString(string, size, features) {
            var width = this.layout(string, features, true).advanceWidth;
            var scale = size / 1000;
            return width * scale;
        };
        _proto.embed = function embed() {
            var isCFF = this.subset.cff != null;
            var fontFile = this.document.ref();
            if (isCFF) fontFile.data.Subtype = "CIDFontType0C";
            fontFile.end(this.subset.encode());
            var familyClass = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : undefined) || 0) >> 8;
            var flags = 0;
            if (this.font.post.isFixedPitch) flags |= 1;
            if (1 <= familyClass && familyClass <= 7) flags |= 2;
            flags |= 4; // assume the font uses non-latin characters
            if (familyClass === 10) flags |= 8;
            if (this.font.head.macStyle.italic) flags |= 64;
            // generate a random tag (6 uppercase letters. 65 is the char code for 'A')
            var tag = [
                0,
                1,
                2,
                3,
                4,
                5
            ].map(function() {
                return String.fromCharCode(Math.random() * 26 + 65);
            }).join("");
            var name = tag + "+" + this.font.postscriptName;
            var bbox = this.font.bbox;
            var descriptor = this.document.ref({
                Type: "FontDescriptor",
                FontName: name,
                Flags: flags,
                FontBBox: [
                    bbox.minX * this.scale,
                    bbox.minY * this.scale,
                    bbox.maxX * this.scale,
                    bbox.maxY * this.scale
                ],
                ItalicAngle: this.font.italicAngle,
                Ascent: this.ascender,
                Descent: this.descender,
                CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                XHeight: (this.font.xHeight || 0) * this.scale,
                StemV: 0
            }); // not sure how to calculate this
            if (isCFF) descriptor.data.FontFile3 = fontFile;
            else descriptor.data.FontFile2 = fontFile;
            descriptor.end();
            var descendantFontData = {
                Type: "Font",
                Subtype: "CIDFontType0",
                BaseFont: name,
                CIDSystemInfo: {
                    Registry: new String("Adobe"),
                    Ordering: new String("Identity"),
                    Supplement: 0
                },
                FontDescriptor: descriptor,
                W: [
                    0,
                    this.widths
                ]
            };
            if (!isCFF) {
                descendantFontData.Subtype = "CIDFontType2";
                descendantFontData.CIDToGIDMap = "Identity";
            }
            var descendantFont = this.document.ref(descendantFontData);
            descendantFont.end();
            this.dictionary.data = {
                Type: "Font",
                Subtype: "Type0",
                BaseFont: name,
                Encoding: "Identity-H",
                DescendantFonts: [
                    descendantFont
                ],
                ToUnicode: this.toUnicodeCmap()
            };
            return this.dictionary.end();
        };
        _proto.toUnicodeCmap = function toUnicodeCmap() {
            var cmap = this.document.ref();
            var entries = [];
            var unicodeMap = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange";
            for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(this.unicode.entries()), _step; !(_step = _iterator()).done;){
                var _step$value = _step.value, index = _step$value[0], codePoints = _step$value[1];
                var encoded = [];
                if (entries.length >= 100) {
                    unicodeMap += "\n" + entries.length + " beginbfchar\n" + entries.join("\n") + "\nendbfchar";
                    entries = [];
                }
                // encode codePoints to utf16
                for(var _iterator2 = (0, _createForOfIteratorHelperLooseDefault.default)(codePoints), _step2; !(_step2 = _iterator2()).done;){
                    var value = _step2.value;
                    if (value > 0xffff) {
                        value -= 0x10000;
                        encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                        value = 0xdc00 | value & 0x3ff;
                    }
                    encoded.push(toHex(value));
                }
                // eslint-disable-next-line no-useless-concat
                entries.push("<" + toHex(index) + ">" + "<" + encoded.join(" ") + ">");
            }
            if (entries.length) unicodeMap += "\n" + entries.length + " beginbfchar\n" + entries.join("\n") + "\nendbfchar\n";
            unicodeMap += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
            cmap.end(unicodeMap);
            return cmap;
        };
        return EmbeddedFont;
    }(PDFFont);
};
var PDFFont = /*#__PURE__*/ function() {
    function PDFFont() {}
    PDFFont.open = function open(document, src, family, id) {
        var font;
        if (typeof src === "string") {
            if (StandardFont.isStandardFont(src)) return new StandardFont(document, src, id);
            throw new Error("Can't open " + src + " in browser build");
        } else if (src instanceof Uint8Array) font = _fontkit.create(src, family);
        else if (src instanceof ArrayBuffer) font = _fontkit.create(new Uint8Array(src), family);
        else if (typeof src === "object") font = src;
        if (font == null) throw new Error("Not a supported font format or standard PDF font.");
        return new EmbeddedFont(document, font, id);
    };
    var _proto = PDFFont.prototype;
    _proto.encode = function encode() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.widthOfString = function widthOfString() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.ref = function ref() {
        return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
    };
    _proto.finalize = function finalize() {
        if (this.embedded || this.dictionary == null) return;
        this.embed();
        return this.embedded = true;
    };
    _proto.embed = function embed() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.lineHeight = function lineHeight(size, includeGap) {
        if (includeGap == null) includeGap = false;
        var gap = includeGap ? this.lineGap : 0;
        return (this.ascender + gap - this.descender) / 1000 * size;
    };
    return PDFFont;
}();
var StandardFont = createStandardFont(PDFFont);
var EmbeddedFont = createEmbeddedFont(PDFFont);
var FontsMixin = {
    initFonts: function initFonts() {
        // Lookup table for embedded fonts
        this._fontFamilies = {};
        this._fontCount = 0;
        // Font state
        this._fontSize = 12;
        this._font = null;
        this._registeredFonts = {};
        // Set the default font
        return this.font("Helvetica");
    },
    font: function font(src, family, size) {
        var cacheKey;
        var font;
        if (typeof family === "number") {
            size = family;
            family = null;
        }
        // check registered fonts if src is a string
        if (typeof src === "string" && this._registeredFonts[src]) {
            cacheKey = src;
            var _this$_registeredFont = this._registeredFonts[src];
            src = _this$_registeredFont.src;
            family = _this$_registeredFont.family;
        } else {
            cacheKey = family || src;
            if (typeof cacheKey !== "string") cacheKey = null;
        }
        if (size != null) this.fontSize(size);
        // fast path: check if the font is already in the PDF
        if (font = this._fontFamilies[cacheKey]) {
            this._font = font;
            return this;
        }
        // load the font
        var id = "F" + ++this._fontCount;
        this._font = PDFFont.open(this, src, family, id);
        // check for existing font familes with the same name already in the PDF
        // useful if the font was passed as a buffer
        if (font = this._fontFamilies[this._font.name]) {
            this._font = font;
            return this;
        }
        // save the font for reuse later
        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
        if (this._font.name) this._fontFamilies[this._font.name] = this._font;
        return this;
    },
    fontSize: function fontSize(_fontSize) {
        this._fontSize = _fontSize;
        return this;
    },
    currentLineHeight: function currentLineHeight(includeGap) {
        if (includeGap == null) includeGap = false;
        return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont: function registerFont(name, src, family) {
        this._registeredFonts[name] = {
            src: src,
            family: family
        };
        return this;
    }
};
var number = PDFObject$1.number;
var TextMixin = {
    initText: function initText() {
        this._line = this._line.bind(this);
        // Current coordinates
        this.x = 0;
        this.y = 0;
        return this._lineGap = 0;
    },
    _text: function _text(text, x, y, options, lineCallback) {
        var _this = this;
        options = this._initOptions(x, y, options);
        // Convert text to a string
        text = text == null ? "" : "" + text;
        // if the wordSpacing option is specified, remove multiple consecutive spaces
        if (options.wordSpacing) text = text.replace(/\s{2,}/g, " ");
        var addStructure = function addStructure() {
            if (options.structParent) options.structParent.add(_this.struct(options.structType || "P", [
                _this.markStructureContent(options.structType || "P")
            ]));
        };
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(text.split("\n")), _step; !(_step = _iterator()).done;){
            var line = _step.value;
            addStructure();
            lineCallback(line, options);
        }
        return this;
    },
    text: function text(_text2, x, y, options) {
        return this._text(_text2, x, y, options, this._line);
    },
    widthOfString: function widthOfString(string, options) {
        if (options === void 0) options = {};
        return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
    },
    _initOptions: function _initOptions(x, y, options) {
        if (x === void 0) x = {};
        if (options === void 0) options = {};
        if (typeof x === "object") {
            options = x;
            x = null;
        }
        // shallow clone options object
        /**
     * @type {Object}
     */ var result = Object.assign({}, options);
        // extend options with previous values for continued text
        if (this._textOptions) for(var key in this._textOptions){
            var val = this._textOptions[key];
            if (key !== "continued") {
                if (result[key] === undefined) result[key] = val;
            }
        }
        // Update the current position
        if (x != null) this.x = x;
        if (y != null) this.y = y;
        // wrap to margins if no x or y position passed
        if (result.lineBreak !== false) {
            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
            result.width = Math.max(result.width, 0);
        }
        if (!result.columns) result.columns = 0;
        if (result.columnGap == null) result.columnGap = 18;
         // 1/4 inch
        return result;
    },
    _line: function _line(text, options) {
        if (options === void 0) options = {};
        this._fragment(text, this.x, this.y, options);
        return this.x += this.widthOfString(text);
    },
    _fragment: function _fragment(text, x, y, options) {
        text = ("" + text).replace(/\n/g, "");
        if (text.length === 0) return;
        var _this$_font$encode = this._font.encode(text, options.features), encoded = _this$_font$encode[0], positions = _this$_font$encode[1];
        var dy = this._font.ascender / 1000 * this._fontSize;
        this._glyphs(encoded, positions, x, y + dy, options);
    },
    _glyphs: function _glyphs(encoded, positions, x, y, options) {
        var _this2 = this;
        var commands = [];
        var scale = this._fontSize / 1000;
        var i;
        var last = 0;
        var hadOffset = false;
        this.save();
        // flip coordinate system
        this.transform(1, 0, 0, -1, 0, this.page.height);
        y = this.page.height - y;
        // add current font to page if necessary
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        // begin the text object
        this.addContent("BT");
        // text position
        this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm");
        // font and font size
        this.addContent("/" + this._font.id + " " + number(this._fontSize) + " Tf");
        // rendering mode
        var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
        if (mode) this.addContent(mode + " Tr");
        // Adds a segment of text to the TJ command buffer
        var addSegment = function addSegment(cur) {
            if (last < cur) {
                var hex = encoded.slice(last, cur).join("");
                var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push("<" + hex + "> " + number(-advance));
            }
            return last = cur;
        };
        // Flushes the current TJ commands to the output stream
        var flush = function flush(i) {
            addSegment(i);
            if (commands.length > 0) {
                _this2.addContent("[" + commands.join(" ") + "] TJ");
                return commands.length = 0;
            }
        };
        for(i = 0; i < positions.length; i++){
            // If we have an x or y offset, we have to break out of the current TJ command
            // so we can move the text position.
            var pos = positions[i];
            if (pos.xOffset || pos.yOffset) {
                // Flush the current buffer
                flush(i);
                // Move the text position and flush just the current character
                this.addContent("1 0 0 1 " + number(x + pos.xOffset * scale) + " " + number(y + pos.yOffset * scale) + " Tm");
                flush(i + 1);
                hadOffset = true;
            } else {
                // If the last character had an offset, reset the text position
                if (hadOffset) {
                    this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm");
                    hadOffset = false;
                }
                // Group segments that don't have any advance adjustments
                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
            }
            x += pos.xAdvance * scale;
        }
        // Flush any remaining commands
        flush(i);
        // end the text object
        this.addContent("ET");
        // restore flipped coordinate system
        return this.restore();
    }
};
var COLOR_SPACE_MAP = {
    1: "DeviceGray",
    3: "DeviceRGB",
    4: "DeviceCMYK"
};
var JPEG = /*#__PURE__*/ function() {
    function JPEG(data, label) {
        this.data = data;
        this.label = label;
        this.orientation = 1;
        if (this.data.readUInt16BE(0) !== 0xffd8) throw "SOI not found in JPEG";
        var markers = (0, _jayPegDefault.default).decode(this.data);
        for(var i = 0; i < markers.length; i += 1){
            var marker = markers[i];
            if (marker.name === "EXIF" && marker.entries.orientation) this.orientation = marker.entries.orientation;
            if (marker.name === "SOF") {
                this.width || (this.width = marker.width);
                this.height || (this.height = marker.height);
                this.colorSpace || (this.colorSpace = COLOR_SPACE_MAP[marker.numberOfComponents]);
            }
        }
        this.obj = null;
    }
    var _proto = JPEG.prototype;
    _proto.embed = function embed(document) {
        if (this.obj) return;
        this.obj = document.ref({
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.bits,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: "DCTDecode"
        });
        // add extra decode params for CMYK images. By swapping the
        // min and max values from the default, we invert the colors. See
        // section 4.8.4 of the spec.
        if (this.colorSpace === "DeviceCMYK") this.obj.data["Decode"] = [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ];
        this.obj.end(this.data);
        // free memory
        return this.data = null;
    };
    return JPEG;
}();
var PNGImage = /*#__PURE__*/ function() {
    function PNGImage(data, label) {
        this.label = label;
        this.image = new (0, _pngJsDefault.default)(data);
        this.width = this.image.width;
        this.height = this.image.height;
        this.imgData = this.image.imgData;
        this.obj = null;
    }
    var _proto = PNGImage.prototype;
    _proto.embed = function embed(document) {
        var dataDecoded = false;
        this.document = document;
        if (this.obj) return;
        var hasAlphaChannel = this.image.hasAlphaChannel;
        var isInterlaced = this.image.interlaceMethod === 1;
        this.obj = this.document.ref({
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
            Width: this.width,
            Height: this.height,
            Filter: "FlateDecode"
        });
        if (!hasAlphaChannel) {
            var params = this.document.ref({
                Predictor: isInterlaced ? 1 : 15,
                Colors: this.image.colors,
                BitsPerComponent: this.image.bits,
                Columns: this.width
            });
            this.obj.data.DecodeParms = params;
            params.end();
        }
        if (this.image.palette.length === 0) this.obj.data.ColorSpace = this.image.colorSpace;
        else {
            // embed the color palette in the PDF as an object stream
            var palette = this.document.ref();
            palette.end(Buffer$2.from(this.image.palette));
            // build the color space array for the image
            this.obj.data.ColorSpace = [
                "Indexed",
                "DeviceRGB",
                this.image.palette.length / 3 - 1,
                palette
            ];
        }
        // For PNG color types 0, 2 and 3, the transparency data is stored in
        // a dedicated PNG chunk.
        if (this.image.transparency.grayscale != null) {
            // Use Color Key Masking (spec section 4.8.5)
            // An array with N elements, where N is two times the number of color components.
            var val = this.image.transparency.grayscale;
            this.obj.data.Mask = [
                val,
                val
            ];
        } else if (this.image.transparency.rgb) {
            // Use Color Key Masking (spec section 4.8.5)
            // An array with N elements, where N is two times the number of color components.
            var rgb = this.image.transparency.rgb;
            var mask = [];
            for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(rgb), _step; !(_step = _iterator()).done;){
                var x = _step.value;
                mask.push(x, x);
            }
            this.obj.data.Mask = mask;
        } else if (this.image.transparency.indexed) {
            // Create a transparency SMask for the image based on the data
            // in the PLTE and tRNS sections. See below for details on SMasks.
            dataDecoded = true;
            return this.loadIndexedAlphaChannel();
        } else if (hasAlphaChannel) {
            // For PNG color types 4 and 6, the transparency data is stored as a alpha
            // channel mixed in with the main image data. Separate this data out into an
            // SMask object and store it separately in the PDF.
            dataDecoded = true;
            return this.splitAlphaChannel();
        }
        if (isInterlaced && !dataDecoded) return this.decodeData();
        this.finalize();
    };
    _proto.finalize = function finalize() {
        if (this.alphaChannel) {
            var sMask = this.document.ref({
                Type: "XObject",
                Subtype: "Image",
                Height: this.height,
                Width: this.width,
                BitsPerComponent: 8,
                Filter: "FlateDecode",
                ColorSpace: "DeviceGray",
                Decode: [
                    0,
                    1
                ]
            });
            sMask.end(this.alphaChannel);
            this.obj.data.SMask = sMask;
        }
        // add the actual image data
        this.obj.end(this.imgData);
        // free memory
        this.image = null;
        return this.imgData = null;
    };
    _proto.splitAlphaChannel = function splitAlphaChannel() {
        var _this = this;
        return this.image.decodePixels(function(pixels) {
            var a;
            var p;
            var colorCount = _this.image.colors;
            var pixelCount = _this.width * _this.height;
            var imgData = Buffer$2.alloc(pixelCount * colorCount);
            var alphaChannel = Buffer$2.alloc(pixelCount);
            var i = p = a = 0;
            var len = pixels.length;
            // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)
            var skipByteCount = _this.image.bits === 16 ? 1 : 0;
            while(i < len){
                for(var colorIndex = 0; colorIndex < colorCount; colorIndex++){
                    imgData[p++] = pixels[i++];
                    i += skipByteCount;
                }
                alphaChannel[a++] = pixels[i++];
                i += skipByteCount;
            }
            _this.imgData = zlib.deflateSync(imgData);
            _this.alphaChannel = zlib.deflateSync(alphaChannel);
            return _this.finalize();
        });
    };
    _proto.loadIndexedAlphaChannel = function loadIndexedAlphaChannel() {
        var _this2 = this;
        var transparency = this.image.transparency.indexed;
        return this.image.decodePixels(function(pixels) {
            var alphaChannel = Buffer$2.alloc(_this2.width * _this2.height);
            var i = 0;
            for(var j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
            _this2.alphaChannel = zlib.deflateSync(alphaChannel);
            return _this2.finalize();
        });
    };
    _proto.decodeData = function decodeData() {
        var _this3 = this;
        this.image.decodePixels(function(pixels) {
            _this3.imgData = zlib.deflateSync(pixels);
            _this3.finalize();
        });
    };
    return PNGImage;
}();
var PDFImage = /*#__PURE__*/ function() {
    function PDFImage() {}
    PDFImage.open = function open(src, label) {
        var data;
        if (Buffer$2.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = Buffer$2.from(new Uint8Array(src));
        else {
            var match;
            if (match = /^data:.+?;base64,(.*)$/.exec(src)) data = Buffer$2.from(match[1], "base64");
            else {
                data = fs.readFileSync(src);
                if (!data) return;
            }
        }
        if (data[0] === 0xff && data[1] === 0xd8) return new JPEG(data, label);
        else if (data[0] === 0x89 && data.toString("ascii", 1, 4) === "PNG") return new PNGImage(data, label);
        else throw new Error("Unknown image format.");
    };
    return PDFImage;
}();
var ImagesMixin = {
    initImages: function initImages() {
        this._imageRegistry = {};
        return this._imageCount = 0;
    },
    embedImage: function embedImage(src) {
        var image;
        if (typeof src === "string") image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        return image;
    },
    image: function image(src, x, y, options) {
        if (options === void 0) options = {};
        var bh;
        var bp;
        var bw;
        var image;
        var ip;
        var left;
        var left1;
        var rotateAngle;
        var originX;
        var originY;
        if (typeof x === "object") {
            options = x;
            x = null;
        }
        // Ignore orientation based on document options or image options
        var ignoreOrientation = options.ignoreOrientation || options.ignoreOrientation !== false && this.options.ignoreOrientation;
        x = (left = x != null ? x : options.x) != null ? left : this.x;
        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
        if (typeof src === "string") image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
        var _image = image, width = _image.width, height = _image.height;
        // If EXIF orientation calls for it, swap width and height
        if (!ignoreOrientation && image.orientation > 4) {
            var _ref = [
                height,
                width
            ];
            width = _ref[0];
            height = _ref[1];
        }
        var w = options.width || width;
        var h = options.height || height;
        if (options.width && !options.height) {
            var wp = w / width;
            w = width * wp;
            h = height * wp;
        } else if (options.height && !options.width) {
            var hp = h / height;
            w = width * hp;
            h = height * hp;
        } else if (options.scale) {
            w = width * options.scale;
            h = height * options.scale;
        } else if (options.fit) {
            var _options$fit = options.fit;
            bw = _options$fit[0];
            bh = _options$fit[1];
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                w = bw;
                h = bw / ip;
            } else {
                h = bh;
                w = bh * ip;
            }
        } else if (options.cover) {
            var _options$cover = options.cover;
            bw = _options$cover[0];
            bh = _options$cover[1];
            bp = bw / bh;
            ip = width / height;
            if (ip > bp) {
                h = bh;
                w = bh * ip;
            } else {
                w = bw;
                h = bw / ip;
            }
        }
        if (options.fit || options.cover) {
            if (options.align === "center") x = x + bw / 2 - w / 2;
            else if (options.align === "right") x = x + bw - w;
            if (options.valign === "center") y = y + bh / 2 - h / 2;
            else if (options.valign === "bottom") y = y + bh - h;
        }
        if (!ignoreOrientation) switch(image.orientation){
            // No orientation (need to flip image, though, because of the default transform matrix on the document)
            default:
            case 1:
                h = -h;
                y -= h;
                rotateAngle = 0;
                break;
            // Flip Horizontal
            case 2:
                w = -w;
                h = -h;
                x -= w;
                y -= h;
                rotateAngle = 0;
                break;
            // Rotate 180 degrees
            case 3:
                originX = x;
                originY = y;
                h = -h;
                x -= w;
                rotateAngle = 180;
                break;
            // Flip vertical
            case 4:
                break;
            // Flip horizontally and rotate 270 degrees CW
            case 5:
                originX = x;
                originY = y;
                var _ref2 = [
                    h,
                    w
                ];
                w = _ref2[0];
                h = _ref2[1];
                y -= h;
                rotateAngle = 90;
                break;
            // Rotate 90 degrees CW
            case 6:
                originX = x;
                originY = y;
                var _ref3 = [
                    h,
                    w
                ];
                w = _ref3[0];
                h = _ref3[1];
                h = -h;
                rotateAngle = 90;
                break;
            // Flip horizontally and rotate 90 degrees CW
            case 7:
                originX = x;
                originY = y;
                var _ref4 = [
                    h,
                    w
                ];
                w = _ref4[0];
                h = _ref4[1];
                h = -h;
                w = -w;
                x -= w;
                rotateAngle = 90;
                break;
            // Rotate 270 degrees CW
            case 8:
                originX = x;
                originY = y;
                var _ref5 = [
                    h,
                    w
                ];
                w = _ref5[0];
                h = _ref5[1];
                h = -h;
                x -= w;
                y -= h;
                rotateAngle = -90;
                break;
        }
        else {
            h = -h;
            y -= h;
            rotateAngle = 0;
        }
        // Set the current y position to below the image if it is in the document flow
        if (this.y === y) this.y += h;
        this.save();
        if (rotateAngle) this.rotate(rotateAngle, {
            origin: [
                originX,
                originY
            ]
        });
        this.transform(w, 0, 0, h, x, y);
        this.addContent("/" + image.label + " Do");
        this.restore();
        return this;
    },
    openImage: function openImage(src) {
        var image;
        if (typeof src === "string") image = this._imageRegistry[src];
        if (!image) {
            image = PDFImage.open(src, "I" + ++this._imageCount);
            if (typeof src === "string") this._imageRegistry[src] = image;
        }
        return image;
    }
};
var AnnotationsMixin = {
    annotate: function annotate(x, y, w, h, options) {
        options.Type = "Annot";
        options.Rect = this._convertRect(x, y, w, h);
        options.Border = [
            0,
            0,
            0
        ];
        if (options.Subtype === "Link" && typeof options.F === "undefined") options.F = 4; // Print Annotation Flag
        if (options.Subtype !== "Link") {
            if (options.C == null) options.C = this._normalizeColor(options.color || [
                0,
                0,
                0
            ]);
        } // convert colors
        delete options.color;
        if (typeof options.Dest === "string") options.Dest = new String(options.Dest);
        // Capitalize keys
        for(var key in options){
            var val = options[key];
            options[key[0].toUpperCase() + key.slice(1)] = val;
        }
        var ref = this.ref(options);
        this.page.annotations.push(ref);
        ref.end();
        return this;
    },
    note: function note(x, y, w, h, contents, options) {
        if (options === void 0) options = {};
        options.Subtype = "Text";
        options.Contents = new String(contents);
        options.Name = "Comment";
        if (options.color == null) options.color = [
            243,
            223,
            92
        ];
        return this.annotate(x, y, w, h, options);
    },
    goTo: function goTo(x, y, w, h, name, options) {
        if (options === void 0) options = {};
        options.Subtype = "Link";
        options.A = this.ref({
            S: "GoTo",
            D: new String(name)
        });
        options.A.end();
        return this.annotate(x, y, w, h, options);
    },
    link: function link(x, y, w, h, url, options) {
        if (options === void 0) options = {};
        options.Subtype = "Link";
        if (typeof url === "number") {
            // Link to a page in the document (the page must already exist)
            var pages = this._root.data.Pages.data;
            if (url >= 0 && url < pages.Kids.length) {
                options.A = this.ref({
                    S: "GoTo",
                    D: [
                        pages.Kids[url],
                        "XYZ",
                        null,
                        null,
                        null
                    ]
                });
                options.A.end();
            } else throw new Error("The document has no page " + url);
        } else {
            // Link to an external url
            options.A = this.ref({
                S: "URI",
                URI: new String(url)
            });
            options.A.end();
        }
        return this.annotate(x, y, w, h, options);
    },
    _markup: function _markup(x, y, w, h, options) {
        if (options === void 0) options = {};
        var _this$_convertRect = this._convertRect(x, y, w, h), x1 = _this$_convertRect[0], y1 = _this$_convertRect[1], x2 = _this$_convertRect[2], y2 = _this$_convertRect[3];
        options.QuadPoints = [
            x1,
            y2,
            x2,
            y2,
            x1,
            y1,
            x2,
            y1
        ];
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    highlight: function highlight(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "Highlight";
        if (options.color == null) options.color = [
            241,
            238,
            148
        ];
        return this._markup(x, y, w, h, options);
    },
    underline: function underline(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "Underline";
        return this._markup(x, y, w, h, options);
    },
    strike: function strike(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "StrikeOut";
        return this._markup(x, y, w, h, options);
    },
    lineAnnotation: function lineAnnotation(x1, y1, x2, y2, options) {
        if (options === void 0) options = {};
        options.Subtype = "Line";
        options.Contents = new String();
        options.L = [
            x1,
            this.page.height - y1,
            x2,
            this.page.height - y2
        ];
        return this.annotate(x1, y1, x2, y2, options);
    },
    rectAnnotation: function rectAnnotation(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "Square";
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    ellipseAnnotation: function ellipseAnnotation(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "Circle";
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    textAnnotation: function textAnnotation(x, y, w, h, text, options) {
        if (options === void 0) options = {};
        options.Subtype = "FreeText";
        options.Contents = new String(text);
        options.DA = new String();
        return this.annotate(x, y, w, h, options);
    },
    fileAnnotation: function fileAnnotation(x, y, w, h, file, options) {
        if (file === void 0) file = {};
        if (options === void 0) options = {};
        // create hidden file
        var filespec = this.file(file.src, Object.assign({
            hidden: true
        }, file));
        options.Subtype = "FileAttachment";
        options.FS = filespec;
        // add description from filespec unless description (Contents) has already been set
        if (options.Contents) options.Contents = new String(options.Contents);
        else if (filespec.data.Desc) options.Contents = filespec.data.Desc;
        return this.annotate(x, y, w, h, options);
    },
    _convertRect: function _convertRect(x1, y1, w, h) {
        // flip y1 and y2
        var y2 = y1;
        y1 += h;
        // make x2
        var x2 = x1 + w;
        // apply current transformation matrix to points
        var _this$_ctm = this._ctm, m0 = _this$_ctm[0], m1 = _this$_ctm[1], m2 = _this$_ctm[2], m3 = _this$_ctm[3], m4 = _this$_ctm[4], m5 = _this$_ctm[5];
        x1 = m0 * x1 + m2 * y1 + m4;
        y1 = m1 * x1 + m3 * y1 + m5;
        x2 = m0 * x2 + m2 * y2 + m4;
        y2 = m1 * x2 + m3 * y2 + m5;
        return [
            x1,
            y1,
            x2,
            y2
        ];
    }
};
var PDFOutline = /*#__PURE__*/ function() {
    function PDFOutline(document, parent, title, dest, options) {
        if (options === void 0) options = {
            expanded: false
        };
        this.document = document;
        this.options = options;
        this.outlineData = {};
        if (dest !== null) this.outlineData["Dest"] = [
            dest.dictionary,
            "Fit"
        ];
        if (parent !== null) this.outlineData["Parent"] = parent;
        if (title !== null) this.outlineData["Title"] = new String(title);
        this.dictionary = this.document.ref(this.outlineData);
        this.children = [];
    }
    var _proto = PDFOutline.prototype;
    _proto.addItem = function addItem(title, options) {
        if (options === void 0) options = {
            expanded: false
        };
        var result = new PDFOutline(this.document, this.dictionary, title, this.document.page, options);
        this.children.push(result);
        return result;
    };
    _proto.endOutline = function endOutline() {
        if (this.children.length > 0) {
            if (this.options.expanded) this.outlineData.Count = this.children.length;
            var first = this.children[0], last = this.children[this.children.length - 1];
            this.outlineData.First = first.dictionary;
            this.outlineData.Last = last.dictionary;
            for(var i = 0, len = this.children.length; i < len; i++){
                var child = this.children[i];
                if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                child.endOutline();
            }
        }
        return this.dictionary.end();
    };
    return PDFOutline;
}();
var OutlineMixin = {
    initOutline: function initOutline() {
        return this.outline = new PDFOutline(this, null, null, null);
    },
    endOutline: function endOutline() {
        this.outline.endOutline();
        if (this.outline.children.length > 0) {
            this._root.data.Outlines = this.outline.dictionary;
            return this._root.data.PageMode = "UseOutlines";
        }
    }
};
/*
PDFStructureContent - a reference to a marked structure content
By Ben Schmidt
*/ var PDFStructureContent = /*#__PURE__*/ function() {
    function PDFStructureContent(pageRef, mcid) {
        this.refs = [
            {
                pageRef: pageRef,
                mcid: mcid
            }
        ];
    }
    var _proto = PDFStructureContent.prototype;
    _proto.push = function push(structContent) {
        var _this = this;
        structContent.refs.forEach(function(ref) {
            return _this.refs.push(ref);
        });
    };
    return PDFStructureContent;
}();
/*
PDFStructureElement - represents an element in the PDF logical structure tree
By Ben Schmidt
*/ var PDFStructureElement = /*#__PURE__*/ function() {
    function PDFStructureElement(document, type, options, children) {
        var _this = this;
        if (options === void 0) options = {};
        if (children === void 0) children = null;
        this.document = document;
        this._attached = false;
        this._ended = false;
        this._flushed = false;
        this.dictionary = document.ref({
            // Type: "StructElem",
            S: type
        });
        var data = this.dictionary.data;
        if (Array.isArray(options) || this._isValidChild(options)) {
            children = options;
            options = {};
        }
        if (typeof options.title !== "undefined") data.T = new String(options.title);
        if (typeof options.lang !== "undefined") data.Lang = new String(options.lang);
        if (typeof options.alt !== "undefined") data.Alt = new String(options.alt);
        if (typeof options.expanded !== "undefined") data.E = new String(options.expanded);
        if (typeof options.actual !== "undefined") data.ActualText = new String(options.actual);
        this._children = [];
        if (children) {
            if (!Array.isArray(children)) children = [
                children
            ];
            children.forEach(function(child) {
                return _this.add(child);
            });
            this.end();
        }
    }
    var _proto = PDFStructureElement.prototype;
    _proto.add = function add(child) {
        if (this._ended) throw new Error("Cannot add child to already-ended structure element");
        if (!this._isValidChild(child)) throw new Error("Invalid structure element child");
        if (child instanceof PDFStructureElement) {
            child.setParent(this.dictionary);
            if (this._attached) child.setAttached();
        }
        if (child instanceof PDFStructureContent) this._addContentToParentTree(child);
        if (typeof child === "function" && this._attached) // _contentForClosure() adds the content to the parent tree
        child = this._contentForClosure(child);
        this._children.push(child);
        return this;
    };
    _proto._addContentToParentTree = function _addContentToParentTree(content) {
        var _this2 = this;
        content.refs.forEach(function(_ref) {
            var pageRef = _ref.pageRef, mcid = _ref.mcid;
            var pageStructParents = _this2.document.getStructParentTree().get(pageRef.data.StructParents);
            pageStructParents[mcid] = _this2.dictionary;
        });
    };
    _proto.setParent = function setParent(parentRef) {
        if (this.dictionary.data.P) throw new Error("Structure element added to more than one parent");
        this.dictionary.data.P = parentRef;
        this._flush();
    };
    _proto.setAttached = function setAttached() {
        var _this3 = this;
        if (this._attached) return;
        this._children.forEach(function(child, index) {
            if (child instanceof PDFStructureElement) child.setAttached();
            if (typeof child === "function") _this3._children[index] = _this3._contentForClosure(child);
        });
        this._attached = true;
        this._flush();
    };
    _proto.end = function end() {
        if (this._ended) return;
        this._children.filter(function(child) {
            return child instanceof PDFStructureElement;
        }).forEach(function(child) {
            return child.end();
        });
        this._ended = true;
        this._flush();
    };
    _proto._isValidChild = function _isValidChild(child) {
        return child instanceof PDFStructureElement || child instanceof PDFStructureContent || typeof child === "function";
    };
    _proto._contentForClosure = function _contentForClosure(closure) {
        var content = this.document.markStructureContent(this.dictionary.data.S);
        closure();
        this.document.endMarkedContent();
        this._addContentToParentTree(content);
        return content;
    };
    _proto._isFlushable = function _isFlushable() {
        if (!this.dictionary.data.P || !this._ended) return false;
        return this._children.every(function(child) {
            if (typeof child === "function") return false;
            if (child instanceof PDFStructureElement) return child._isFlushable();
            return true;
        });
    };
    _proto._flush = function _flush() {
        var _this4 = this;
        if (this._flushed || !this._isFlushable()) return;
        this.dictionary.data.K = [];
        this._children.forEach(function(child) {
            return _this4._flushChild(child);
        });
        this.dictionary.end();
        // free memory used by children; the dictionary itself may still be
        // referenced by a parent structure element or root, but we can
        // at least trim the tree here
        this._children = [];
        this.dictionary.data.K = null;
        this._flushed = true;
    };
    _proto._flushChild = function _flushChild(child) {
        var _this5 = this;
        if (child instanceof PDFStructureElement) this.dictionary.data.K.push(child.dictionary);
        if (child instanceof PDFStructureContent) child.refs.forEach(function(_ref2) {
            var pageRef = _ref2.pageRef, mcid = _ref2.mcid;
            if (!_this5.dictionary.data.Pg) _this5.dictionary.data.Pg = pageRef;
            if (_this5.dictionary.data.Pg === pageRef) _this5.dictionary.data.K.push(mcid);
            else _this5.dictionary.data.K.push({
                Type: "MCR",
                Pg: pageRef,
                MCID: mcid
            });
        });
    };
    return PDFStructureElement;
}();
var PDFNumberTree = /*#__PURE__*/ function(_PDFTree) {
    (0, _inheritsLooseDefault.default)(PDFNumberTree, _PDFTree);
    function PDFNumberTree() {
        return _PDFTree.apply(this, arguments) || this;
    }
    var _proto = PDFNumberTree.prototype;
    _proto._compareKeys = function _compareKeys(a, b) {
        return parseInt(a) - parseInt(b);
    };
    _proto._keysName = function _keysName() {
        return "Nums";
    };
    _proto._dataForKey = function _dataForKey(k) {
        return parseInt(k);
    };
    return PDFNumberTree;
}(PDFTree);
var MarkingsMixin = {
    initMarkings: function initMarkings(options) {
        this.structChildren = [];
        if (options.tagged) {
            this.getMarkInfoDictionary().data.Marked = true;
            this.getStructTreeRoot();
        }
    },
    markContent: function markContent(tag, options) {
        if (options === void 0) options = null;
        if (tag === "Artifact" || options && options.mcid) {
            var toClose = 0;
            this.page.markings.forEach(function(marking) {
                if (toClose || marking.structContent || marking.tag === "Artifact") toClose++;
            });
            while(toClose--)this.endMarkedContent();
        }
        if (!options) {
            this.page.markings.push({
                tag: tag
            });
            this.addContent("/" + tag + " BMC");
            return this;
        }
        this.page.markings.push({
            tag: tag,
            options: options
        });
        var dictionary = {};
        if (typeof options.mcid !== "undefined") dictionary.MCID = options.mcid;
        if (tag === "Artifact") {
            if (typeof options.type === "string") dictionary.Type = options.type;
            if (Array.isArray(options.bbox)) dictionary.BBox = [
                options.bbox[0],
                this.page.height - options.bbox[3],
                options.bbox[2],
                this.page.height - options.bbox[1]
            ];
            if (Array.isArray(options.attached) && options.attached.every(function(val) {
                return typeof val === "string";
            })) dictionary.Attached = options.attached;
        }
        if (tag === "Span") {
            if (options.lang) dictionary.Lang = new String(options.lang);
            if (options.alt) dictionary.Alt = new String(options.alt);
            if (options.expanded) dictionary.E = new String(options.expanded);
            if (options.actual) dictionary.ActualText = new String(options.actual);
        }
        this.addContent("/" + tag + " " + PDFObject$1.convert(dictionary) + " BDC");
        return this;
    },
    markStructureContent: function markStructureContent(tag, options) {
        if (options === void 0) options = {};
        var pageStructParents = this.getStructParentTree().get(this.page.structParentTreeKey);
        var mcid = pageStructParents.length;
        pageStructParents.push(null);
        this.markContent(tag, (0, _extendsDefault.default)({}, options, {
            mcid: mcid
        }));
        var structContent = new PDFStructureContent(this.page.dictionary, mcid);
        this.page.markings.slice(-1)[0].structContent = structContent;
        return structContent;
    },
    endMarkedContent: function endMarkedContent() {
        this.page.markings.pop();
        this.addContent("EMC");
        return this;
    },
    struct: function struct(type, options, children) {
        if (options === void 0) options = {};
        if (children === void 0) children = null;
        return new PDFStructureElement(this, type, options, children);
    },
    addStructure: function addStructure(structElem) {
        var structTreeRoot = this.getStructTreeRoot();
        structElem.setParent(structTreeRoot);
        structElem.setAttached();
        this.structChildren.push(structElem);
        if (!structTreeRoot.data.K) structTreeRoot.data.K = [];
        structTreeRoot.data.K.push(structElem.dictionary);
        return this;
    },
    initPageMarkings: function initPageMarkings(pageMarkings) {
        var _this = this;
        pageMarkings.forEach(function(marking) {
            if (marking.structContent) {
                var structContent = marking.structContent;
                var newStructContent = _this.markStructureContent(marking.tag, marking.options);
                structContent.push(newStructContent);
                _this.page.markings.slice(-1)[0].structContent = structContent;
            } else _this.markContent(marking.tag, marking.options);
        });
    },
    endPageMarkings: function endPageMarkings(page) {
        var pageMarkings = page.markings;
        pageMarkings.forEach(function() {
            return page.write("EMC");
        });
        page.markings = [];
        return pageMarkings;
    },
    getMarkInfoDictionary: function getMarkInfoDictionary() {
        if (!this._root.data.MarkInfo) this._root.data.MarkInfo = this.ref({});
        return this._root.data.MarkInfo;
    },
    getStructTreeRoot: function getStructTreeRoot() {
        if (!this._root.data.StructTreeRoot) this._root.data.StructTreeRoot = this.ref({
            Type: "StructTreeRoot",
            ParentTree: new PDFNumberTree(),
            ParentTreeNextKey: 0
        });
        return this._root.data.StructTreeRoot;
    },
    getStructParentTree: function getStructParentTree() {
        return this.getStructTreeRoot().data.ParentTree;
    },
    createStructParentTreeNextKey: function createStructParentTreeNextKey() {
        // initialise the MarkInfo dictionary
        this.getMarkInfoDictionary();
        var structTreeRoot = this.getStructTreeRoot();
        var key = structTreeRoot.data.ParentTreeNextKey++;
        structTreeRoot.data.ParentTree.add(key, []);
        return key;
    },
    endMarkings: function endMarkings() {
        var structTreeRoot = this._root.data.StructTreeRoot;
        if (structTreeRoot) {
            structTreeRoot.end();
            this.structChildren.forEach(function(structElem) {
                return structElem.end();
            });
        }
        if (this._root.data.MarkInfo) this._root.data.MarkInfo.end();
    }
};
var FIELD_FLAGS = {
    readOnly: 1,
    required: 2,
    noExport: 4,
    multiline: 0x1000,
    password: 0x2000,
    toggleToOffButton: 0x4000,
    radioButton: 0x8000,
    pushButton: 0x10000,
    combo: 0x20000,
    edit: 0x40000,
    sort: 0x80000,
    multiSelect: 0x200000,
    noSpell: 0x400000
};
var FIELD_JUSTIFY = {
    left: 0,
    center: 1,
    right: 2
};
var VALUE_MAP = {
    value: "V",
    defaultValue: "DV"
};
var FORMAT_SPECIAL = {
    zip: "0",
    zipPlus4: "1",
    zip4: "1",
    phone: "2",
    ssn: "3"
};
var FORMAT_DEFAULT = {
    number: {
        nDec: 0,
        sepComma: false,
        negStyle: "MinusBlack",
        currency: "",
        currencyPrepend: true
    },
    percent: {
        nDec: 0,
        sepComma: false
    }
};
var AcroFormMixin = {
    /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */ initForm: function initForm() {
        if (!this._font) throw new Error("Must set a font before calling initForm method");
        this._acroform = {
            fonts: {},
            defaultFont: this._font.name
        };
        this._acroform.fonts[this._font.id] = this._font.ref();
        var data = {
            Fields: [],
            NeedAppearances: true,
            DA: new String("/" + this._font.id + " 0 Tf 0 g"),
            DR: {
                Font: {}
            }
        };
        data.DR.Font[this._font.id] = this._font.ref();
        var AcroForm = this.ref(data);
        this._root.data.AcroForm = AcroForm;
        return this;
    },
    /**
   * Called automatically by document.js
   */ endAcroForm: function endAcroForm() {
        var _this = this;
        if (this._root.data.AcroForm) {
            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error("No fonts specified for PDF form");
            var fontDict = this._root.data.AcroForm.data.DR.Font;
            Object.keys(this._acroform.fonts).forEach(function(name) {
                fontDict[name] = _this._acroform.fonts[name];
            });
            this._root.data.AcroForm.data.Fields.forEach(function(fieldRef) {
                _this._endChild(fieldRef);
            });
            this._root.data.AcroForm.end();
        }
        return this;
    },
    _endChild: function _endChild(ref) {
        var _this2 = this;
        if (Array.isArray(ref.data.Kids)) {
            ref.data.Kids.forEach(function(childRef) {
                _this2._endChild(childRef);
            });
            ref.end();
        }
        return this;
    },
    /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */ formField: function formField(name, options) {
        if (options === void 0) options = {};
        var fieldDict = this._fieldDict(name, null, options);
        var fieldRef = this.ref(fieldDict);
        this._addToParent(fieldRef);
        return fieldRef;
    },
    /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */ formAnnotation: function formAnnotation(name, type, x, y, w, h, options) {
        if (options === void 0) options = {};
        var fieldDict = this._fieldDict(name, type, options);
        fieldDict.Subtype = "Widget";
        if (fieldDict.F === undefined) fieldDict.F = 4; // print the annotation
        // Add Field annot to page, and get it's ref
        this.annotate(x, y, w, h, fieldDict);
        var annotRef = this.page.annotations[this.page.annotations.length - 1];
        return this._addToParent(annotRef);
    },
    formText: function formText(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "text", x, y, w, h, options);
    },
    formPushButton: function formPushButton(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "pushButton", x, y, w, h, options);
    },
    formCombo: function formCombo(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "combo", x, y, w, h, options);
    },
    formList: function formList(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "list", x, y, w, h, options);
    },
    formRadioButton: function formRadioButton(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "radioButton", x, y, w, h, options);
    },
    formCheckbox: function formCheckbox(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "checkbox", x, y, w, h, options);
    },
    _addToParent: function _addToParent(fieldRef) {
        var parent = fieldRef.data.Parent;
        if (parent) {
            if (!parent.data.Kids) parent.data.Kids = [];
            parent.data.Kids.push(fieldRef);
        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
        return this;
    },
    _fieldDict: function _fieldDict(name, type, options) {
        if (options === void 0) options = {};
        if (!this._acroform) throw new Error("Call document.initForms() method before adding form elements to document");
        var opts = Object.assign({}, options);
        if (type !== null) opts = this._resolveType(type, options);
        opts = this._resolveFlags(opts);
        opts = this._resolveJustify(opts);
        opts = this._resolveFont(opts);
        opts = this._resolveStrings(opts);
        opts = this._resolveColors(opts);
        opts = this._resolveFormat(opts);
        opts.T = new String(name);
        if (opts.parent) {
            opts.Parent = opts.parent;
            delete opts.parent;
        }
        return opts;
    },
    _resolveType: function _resolveType(type, opts) {
        if (type === "text") opts.FT = "Tx";
        else if (type === "pushButton") {
            opts.FT = "Btn";
            opts.pushButton = true;
        } else if (type === "radioButton") {
            opts.FT = "Btn";
            opts.radioButton = true;
        } else if (type === "checkbox") opts.FT = "Btn";
        else if (type === "combo") {
            opts.FT = "Ch";
            opts.combo = true;
        } else if (type === "list") opts.FT = "Ch";
        else throw new Error("Invalid form annotation type '" + type + "'");
        return opts;
    },
    _resolveFormat: function _resolveFormat(opts) {
        var f = opts.format;
        if (f && f.type) {
            var fnKeystroke;
            var fnFormat;
            var params = "";
            if (FORMAT_SPECIAL[f.type] !== undefined) {
                fnKeystroke = "AFSpecial_Keystroke";
                fnFormat = "AFSpecial_Format";
                params = FORMAT_SPECIAL[f.type];
            } else {
                var format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                fnKeystroke = "AF" + format + "_Keystroke";
                fnFormat = "AF" + format + "_Format";
                if (f.type === "date") {
                    fnKeystroke += "Ex";
                    params = String(f.param);
                } else if (f.type === "time") params = String(f.param);
                else if (f.type === "number") {
                    var p = Object.assign({}, FORMAT_DEFAULT.number, f);
                    params = String([
                        String(p.nDec),
                        p.sepComma ? "0" : "1",
                        '"' + p.negStyle + '"',
                        "null",
                        '"' + p.currency + '"',
                        String(p.currencyPrepend)
                    ].join(","));
                } else if (f.type === "percent") {
                    var _p = Object.assign({}, FORMAT_DEFAULT.percent, f);
                    params = String([
                        String(_p.nDec),
                        _p.sepComma ? "0" : "1"
                    ].join(","));
                }
            }
            opts.AA = opts.AA ? opts.AA : {};
            opts.AA.K = {
                S: "JavaScript",
                JS: new String(fnKeystroke + "(" + params + ");")
            };
            opts.AA.F = {
                S: "JavaScript",
                JS: new String(fnFormat + "(" + params + ");")
            };
        }
        delete opts.format;
        return opts;
    },
    _resolveColors: function _resolveColors(opts) {
        var color = this._normalizeColor(opts.backgroundColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BG = color;
        }
        color = this._normalizeColor(opts.borderColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BC = color;
        }
        delete opts.backgroundColor;
        delete opts.borderColor;
        return opts;
    },
    _resolveFlags: function _resolveFlags(options) {
        var result = 0;
        Object.keys(options).forEach(function(key) {
            if (FIELD_FLAGS[key]) {
                result |= FIELD_FLAGS[key];
                delete options[key];
            }
        });
        if (result !== 0) {
            options.Ff = options.Ff ? options.Ff : 0;
            options.Ff |= result;
        }
        return options;
    },
    _resolveJustify: function _resolveJustify(options) {
        var result = 0;
        if (options.align !== undefined) {
            if (typeof FIELD_JUSTIFY[options.align] === "number") result = FIELD_JUSTIFY[options.align];
            delete options.align;
        }
        if (result !== 0) options.Q = result; // default
        return options;
    },
    _resolveFont: function _resolveFont(options) {
        // add current font to document-level AcroForm dict if necessary
        if (this._acroform.fonts[this._font.id] === null) this._acroform.fonts[this._font.id] = this._font.ref();
        // add current font to field's resource dict (RD) if not the default acroform font
        if (this._acroform.defaultFont !== this._font.name) {
            options.DR = {
                Font: {}
            };
            // Get the fontSize option. If not set use auto sizing
            var fontSize = options.fontSize || 0;
            options.DR.Font[this._font.id] = this._font.ref();
            options.DA = new String("/" + this._font.id + " " + fontSize + " Tf 0 g");
        }
        return options;
    },
    _resolveStrings: function _resolveStrings(options) {
        var select = [];
        function appendChoices(a) {
            if (Array.isArray(a)) {
                for(var idx = 0; idx < a.length; idx++)if (typeof a[idx] === "string") select.push(new String(a[idx]));
                else select.push(a[idx]);
            }
        }
        appendChoices(options.Opt);
        if (options.select) {
            appendChoices(options.select);
            delete options.select;
        }
        if (select.length) options.Opt = select;
        Object.keys(VALUE_MAP).forEach(function(key) {
            if (options[key] !== undefined) {
                options[VALUE_MAP[key]] = options[key];
                delete options[key];
            }
        });
        [
            "V",
            "DV"
        ].forEach(function(key) {
            if (typeof options[key] === "string") options[key] = new String(options[key]);
        });
        if (options.MK && options.MK.CA) options.MK.CA = new String(options.MK.CA);
        if (options.label) {
            options.MK = options.MK ? options.MK : {};
            options.MK.CA = new String(options.label);
            delete options.label;
        }
        return options;
    }
};
var AttachmentsMixin = {
    /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */ file: function file(src, options) {
        if (options === void 0) options = {};
        options.name = options.name || src;
        var refBody = {
            Type: "EmbeddedFile",
            Params: {}
        };
        var data;
        if (!src) throw new Error("No src specified");
        if (Buffer$2.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = Buffer$2.from(new Uint8Array(src));
        else {
            var match;
            if (match = /^data:(.*);base64,(.*)$/.exec(src)) {
                if (match[1]) refBody.Subtype = match[1].replace("/", "#2F");
                data = Buffer$2.from(match[2], "base64");
            } else throw new Error("Could not find file " + src);
        }
        // override creation date and modified date
        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
        // add optional subtype
        if (options.type) refBody.Subtype = options.type.replace("/", "#2F");
        // add checksum and size information
        var checksum = (0, _md5JsDefault.default)(_coreJs.lib.WordArray.create(new Uint8Array(data)));
        refBody.Params.CheckSum = new String(checksum);
        refBody.Params.Size = data.byteLength;
        // save some space when embedding the same file again
        // if a file with the same name and metadata exists, reuse its reference
        var ref;
        if (!this._fileRegistry) this._fileRegistry = {};
        var file = this._fileRegistry[options.name];
        if (file && isEqual(refBody, file)) ref = file.ref;
        else {
            ref = this.ref(refBody);
            ref.end(data);
            this._fileRegistry[options.name] = (0, _extendsDefault.default)({}, refBody, {
                ref: ref
            });
        }
        // add filespec for embedded file
        var fileSpecBody = {
            Type: "Filespec",
            F: new String(options.name),
            EF: {
                F: ref
            },
            UF: new String(options.name)
        };
        if (options.description) fileSpecBody.Desc = new String(options.description);
        var filespec = this.ref(fileSpecBody);
        filespec.end();
        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
        return filespec;
    }
};
/** check two embedded file metadata objects for equality */ function isEqual(a, b) {
    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate === b.Params.CreationDate && a.Params.ModDate === b.Params.ModDate;
}
var PDFMetadata = /*#__PURE__*/ function() {
    function PDFMetadata() {
        this._metadata = '\n        <?xpacket begin="\uFEFF" id="W5M0MpCehiHzreSzNTczkc9d"?>\n            <x:xmpmeta xmlns:x="adobe:ns:meta/">\n                <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n        ';
    }
    var _proto = PDFMetadata.prototype;
    _proto._closeTags = function _closeTags() {
        this._metadata = this._metadata.concat('\n                </rdf:RDF>\n            </x:xmpmeta>\n        <?xpacket end="w"?>\n        ');
    };
    _proto.append = function append(xml, newline) {
        if (newline === void 0) newline = true;
        this._metadata = this._metadata.concat(xml);
        if (newline) this._metadata = this._metadata.concat("\n");
    };
    _proto.getXML = function getXML() {
        return this._metadata;
    };
    _proto.getLength = function getLength() {
        return this._metadata.length;
    };
    _proto.end = function end() {
        this._closeTags();
        this._metadata = this._metadata.trim();
    };
    return PDFMetadata;
}();
var MetadataMixin = {
    initMetadata: function initMetadata() {
        this.metadata = new PDFMetadata();
    },
    appendXML: function appendXML(xml, newline) {
        if (newline === void 0) newline = true;
        this.metadata.append(xml, newline);
    },
    _addInfo: function _addInfo() {
        this.appendXML('\n        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">\n            <xmp:CreateDate>' + (this.info.CreationDate.toISOString().split(".")[0] + "Z") + "</xmp:CreateDate>\n            <xmp:CreatorTool>" + this.info.Creator + "</xmp:CreatorTool>\n        </rdf:Description>\n        ");
        if (this.info.Title || this.info.Author || this.info.Subject) {
            this.appendXML('\n            <rdf:Description rdf:about="" xmlns:dc="http://purl.org/dc/elements/1.1/">\n            ');
            if (this.info.Title) this.appendXML('\n                <dc:title>\n                    <rdf:Alt>\n                        <rdf:li xml:lang="x-default">' + this.info.Title + "</rdf:li>\n                    </rdf:Alt>\n                </dc:title>\n                ");
            if (this.info.Author) this.appendXML("\n                <dc:creator>\n                    <rdf:Seq>\n                        <rdf:li>" + this.info.Author + "</rdf:li>\n                    </rdf:Seq>\n                </dc:creator>\n                ");
            if (this.info.Subject) this.appendXML('\n                <dc:description>\n                    <rdf:Alt>\n                        <rdf:li xml:lang="x-default">' + this.info.Subject + "</rdf:li>\n                    </rdf:Alt>\n                </dc:description>\n                ");
            this.appendXML("\n            </rdf:Description>\n            ");
        }
        this.appendXML('\n        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">\n            <pdf:Producer>' + this.info.Creator + "</pdf:Producer>", false);
        if (this.info.Keywords) this.appendXML("\n            <pdf:Keywords>" + this.info.Keywords + "</pdf:Keywords>", false);
        this.appendXML("\n        </rdf:Description>\n        ");
    },
    endMetadata: function endMetadata() {
        this._addInfo();
        this.metadata.end();
        /*
        Metadata was introduced in PDF 1.4, so adding it to 1.3
        will likely only take up more space.
        */ if (this.version != 1.3) {
            this.metadataRef = this.ref({
                length: this.metadata.getLength(),
                Type: "Metadata",
                Subtype: "XML"
            });
            this.metadataRef.compress = false;
            this.metadataRef.write(Buffer$2.from(this.metadata.getXML(), "utf-8"));
            this.metadataRef.end();
            this._root.data.Metadata = this.metadataRef;
        }
    }
};
var capitalize = function capitalize(v) {
    return v[0].toUpperCase() + v.slice(1);
};
var PDFDocument = /*#__PURE__*/ function(_stream$Readable) {
    (0, _inheritsLooseDefault.default)(PDFDocument, _stream$Readable);
    function PDFDocument(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _stream$Readable.call(this) || this;
        _this.options = options;
        // PDF version
        switch(options.pdfVersion){
            case "1.4":
                _this.version = 1.4;
                break;
            case "1.5":
                _this.version = 1.5;
                break;
            case "1.6":
                _this.version = 1.6;
                break;
            case "1.7":
            case "1.7ext3":
                _this.version = 1.7;
                break;
            default:
                _this.version = 1.3;
                break;
        }
        // Whether streams should be compressed
        _this.compress = _this.options.compress != null ? _this.options.compress : true;
        _this._pageBuffer = [];
        _this._pageBufferStart = 0;
        // The PDF object store
        _this._offsets = [];
        _this._waiting = 0;
        _this._ended = false;
        _this._offset = 0;
        var Pages = _this.ref({
            Type: "Pages",
            Count: 0,
            Kids: []
        });
        var Names = _this.ref({
            Dests: new PDFNameTree()
        });
        _this._root = _this.ref({
            Type: "Catalog",
            Pages: Pages,
            Names: Names
        });
        if (_this.options.lang) _this._root.data.Lang = new String(_this.options.lang);
        if (_this.options.pageLayout) _this._root.data.PageLayout = capitalize(_this.options.pageLayout);
        if (_this.options.pageMode) _this._root.data.PageMode = capitalize(_this.options.pageMode);
        // The current page
        _this.page = null;
        // Initialize mixins
        _this.initColor();
        _this.initVector();
        _this.initFonts();
        _this.initText();
        _this.initImages();
        _this.initOutline();
        // this.initMarkings(options)
        // Initialize the metadata
        _this.info = {
            Producer: "PDFKit",
            Creator: "PDFKit",
            CreationDate: new Date()
        };
        if (_this.options.info) for(var key in _this.options.info){
            var val = _this.options.info[key];
            _this.info[key] = val;
        }
        if (_this.options.displayTitle) _this._root.data.ViewerPreferences = _this.ref({
            DisplayDocTitle: true
        });
        // Generate file ID
        _this._id = PDFSecurity.generateFileID(_this.info);
        // Initialize security settings
        // this._security = PDFSecurity.create(this, options);
        // Write the header PDF version
        _this._write("%PDF-" + _this.version);
        // 4 binary chars, as recommended by the spec
        _this._write("%\xff\xff\xff\xff");
        // Add the first page
        if (_this.options.autoFirstPage !== false) _this.addPage();
        return _this;
    }
    var _proto = PDFDocument.prototype;
    _proto.addPage = function addPage(options) {
        // end the current page if needed
        if (options == null) options = this.options;
        // end the current page if needed
        if (!this.options.bufferPages) this.flushPages();
        // create a page object
        this.page = new PDFPage(this, options);
        this._pageBuffer.push(this.page);
        // add the page to the object store
        var pages = this._root.data.Pages.data;
        pages.Kids.push(this.page.dictionary);
        pages.Count++;
        // flip PDF coordinate system so that the origin is in
        // the top left rather than the bottom left
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this.transform(1, 0, 0, -1, 0, this.page.height);
        // this.emit('pageAdded');
        return this;
    };
    _proto.flushPages = function flushPages() {
        // this local variable exists so we're future-proof against
        // reentrant calls to flushPages.
        var pages = this._pageBuffer;
        this._pageBuffer = [];
        this._pageBufferStart += pages.length;
        for(var _i = 0, _Array$from = Array.from(pages); _i < _Array$from.length; _i++){
            var page = _Array$from[_i];
            // this.endPageMarkings(page);
            page.end();
        }
    };
    _proto.addNamedDestination = function addNamedDestination(name) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (args.length === 0) args = [
            "XYZ",
            null,
            null,
            null
        ];
        if (args[0] === "XYZ" && args[2] !== null) args[2] = this.page.height - args[2];
        args.unshift(this.page.dictionary);
        this._root.data.Names.data.Dests.add(name, args);
    };
    _proto.addNamedEmbeddedFile = function addNamedEmbeddedFile(name, ref) {
        if (!this._root.data.Names.data.EmbeddedFiles) // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
        this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
            limits: false
        });
        // add filespec to EmbeddedFiles
        this._root.data.Names.data.EmbeddedFiles.add(name, ref);
    };
    _proto.addNamedJavaScript = function addNamedJavaScript(name, js) {
        if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new PDFNameTree();
        var data = {
            JS: new String(js),
            S: "JavaScript"
        };
        this._root.data.Names.data.JavaScript.add(name, data);
    };
    _proto.ref = function ref(data) {
        var ref = new PDFReference(this, this._offsets.length + 1, data);
        this._offsets.push(null); // placeholder for this object's offset once it is finalized
        this._waiting++;
        return ref;
    };
    _proto._read = function _read() {
    // do nothing, but this method is required by node
    };
    _proto._write = function _write(data) {
        if (!Buffer$2.isBuffer(data)) data = Buffer$2.from(data + "\n", "binary");
        this.push(data);
        return this._offset += data.length;
    };
    _proto.addContent = function addContent(data) {
        this.page.write(data);
        return this;
    };
    _proto._refEnd = function _refEnd(ref) {
        this._offsets[ref.id - 1] = ref.offset;
        if (--this._waiting === 0 && this._ended) {
            this._finalize();
            return this._ended = false;
        }
    };
    _proto.end = function end() {
        this.flushPages();
        this._info = this.ref();
        for(var key in this.info){
            var val = this.info[key];
            if (typeof val === "string") val = new String(val);
            var entry = this.ref(val);
            entry.end();
            this._info.data[key] = entry;
        }
        this._info.end();
        for(var name in this._fontFamilies){
            var font = this._fontFamilies[name];
            font.finalize();
        }
        this.endOutline();
        // this.endMarkings();
        this._root.end();
        this._root.data.Pages.end();
        this._root.data.Names.end();
        this.endAcroForm();
        if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
        // if (this._security) {
        //   this._security.end();
        // }
        if (this._waiting === 0) return this._finalize();
        this._ended = true;
    };
    _proto._finalize = function _finalize() {
        // generate xref
        var xRefOffset = this._offset;
        this._write("xref");
        this._write("0 " + (this._offsets.length + 1));
        this._write("0000000000 65535 f ");
        for(var _i2 = 0, _Array$from2 = Array.from(this._offsets); _i2 < _Array$from2.length; _i2++){
            var offset = _Array$from2[_i2];
            offset = ("0000000000" + offset).slice(-10);
            this._write(offset + " 00000 n ");
        }
        // trailer
        var trailer = {
            Size: this._offsets.length + 1,
            Root: this._root,
            Info: this._info,
            ID: [
                this._id,
                this._id
            ]
        };
        // if (this._security) {
        //   trailer.Encrypt = this._security.dictionary;
        // }
        this._write("trailer");
        this._write(PDFObject$1.convert(trailer));
        this._write("startxref");
        this._write("" + xRefOffset);
        this._write("%%EOF");
        // end the stream
        return this.push(null);
    };
    _proto.toString = function toString() {
        return "[object PDFDocument]";
    };
    _proto.initColor = function initColor() {};
    _proto.initVector = function initVector() {};
    _proto.initFonts = function initFonts() {};
    _proto.initText = function initText() {};
    _proto.initImages = function initImages() {};
    _proto.initOutline = function initOutline() {};
    _proto.transform = function transform(m11, m12, m21, m22, dx, dy) {};
    _proto.endOutline = function endOutline() {};
    _proto.endAcroForm = function endAcroForm() {};
    return PDFDocument;
}(stream.Readable);
var mixin = function mixin(methods) {
    Object.assign(PDFDocument.prototype, methods);
};
// Load mixins
mixin(MetadataMixin);
mixin(ColorMixin);
mixin(VectorMixin);
mixin(FontsMixin);
mixin(TextMixin);
mixin(ImagesMixin);
mixin(AnnotationsMixin);
mixin(OutlineMixin);
mixin(MarkingsMixin);
mixin(AcroFormMixin);
mixin(AttachmentsMixin);

},{"@babel/runtime/helpers/inheritsLoose":"eFgUx","@babel/runtime/helpers/assertThisInitialized":"LYz4W","pako/lib/zlib/zstream.js":"iOQFq","pako/lib/zlib/deflate.js":"gcoKd","pako/lib/zlib/inflate.js":"eyqDB","pako/lib/zlib/constants.js":"eRjMX","@babel/runtime/helpers/createForOfIteratorHelperLoose":"cBNai","@babel/runtime/helpers/createClass":"4S2iS","crypto-js/md5.js":"2XpZP","fontkit":"3l9Ub","jay-peg":"bm3FR","@react-pdf/png-js":"gUjti","@babel/runtime/helpers/extends":"lKkcq","crypto-js/core.js":"ezcuS","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eFgUx":[function(require,module,exports) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"jUFG4"}],"jUFG4":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"LYz4W":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"iOQFq":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = ZStream;

},{}],"gcoKd":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = require("b17b4660c9a756a1");
const adler32 = require("8a0173ce93724f81");
const crc32 = require("9fe740ea87b93669");
const msg = require("86729d90d4373c72");
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH, Z_PARTIAL_FLUSH, Z_FULL_FLUSH, Z_FINISH, Z_BLOCK, Z_OK, Z_STREAM_END, Z_STREAM_ERROR, Z_DATA_ERROR, Z_BUF_ERROR, Z_DEFAULT_COMPRESSION, Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY, Z_UNKNOWN, Z_DEFLATED } = require("f924a34acc547ed3");
/*============================================================================*/ const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const MAX_WBITS = 15;
/* 32K LZ77 window */ const DEF_MEM_LEVEL = 8;
const LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const LITERALS = 256;
/* number of literal bytes 0..255 */ const L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES = 30;
/* number of distance codes */ const BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ const MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
const PRESET_DICT = 0x20;
const INIT_STATE = 42;
const EXTRA_STATE = 69;
const NAME_STATE = 73;
const COMMENT_STATE = 91;
const HCRC_STATE = 103;
const BUSY_STATE = 113;
const FINISH_STATE = 666;
const BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const BS_BLOCK_DONE = 2; /* block flush performed */ 
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const err = (strm, errorCode)=>{
    strm.msg = msg[errorCode];
    return errorCode;
};
const rank = (f)=>{
    return (f << 1) - (f > 4 ? 9 : 0);
};
const zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* eslint-disable new-cap */ let HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ const flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const flush_block_only = (s, last)=>{
    _tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
};
const put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const fill_window = (s)=>{
    const _w_size = s.w_size;
    let p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ const deflate_stored = (s, flush)=>{
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ let max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ const max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = _tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
const deflateResetKeep = (strm)=>{
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    _tr_init(s);
    return Z_OK;
};
const deflateReset = (strm)=>{
    const ret = deflateResetKeep(strm);
    if (ret === Z_OK) lm_init(strm.state);
    return ret;
};
const deflateSetHeader = (strm, head)=>{
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return Z_OK;
};
const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return Z_STREAM_ERROR;
    let wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
};
const deflateInit = (strm, level)=>{
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
};
const deflate = (strm, flush)=>{
    let beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    const s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            let header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            let level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        let bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) _tr_align(s);
            else if (flush !== Z_BLOCK) {
                _tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH) return Z_OK;
    if (s.wrap <= 0) return Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
};
const deflateEnd = (strm)=>{
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    const status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
};
module.exports.deflateInit = deflateInit;
module.exports.deflateInit2 = deflateInit2;
module.exports.deflateReset = deflateReset;
module.exports.deflateResetKeep = deflateResetKeep;
module.exports.deflateSetHeader = deflateSetHeader;
module.exports.deflate = deflate;
module.exports.deflateEnd = deflateEnd;
module.exports.deflateSetDictionary = deflateSetDictionary;
module.exports.deflateInfo = "pako deflate (from Nodeca project)"; /* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ 

},{"b17b4660c9a756a1":"agCWo","8a0173ce93724f81":"OwvOf","9fe740ea87b93669":"49E7g","86729d90d4373c72":"1UZve","f924a34acc547ed3":"eRjMX"}],"agCWo":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const Z_BINARY = 0;
const Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN = 2;
/*============================================================================*/ function zero(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES = 2;
/* The three kinds of block type */ const MIN_MATCH = 3;
const MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const LITERALS = 256;
/* number of literal bytes 0..255 */ const L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const D_CODES = 30;
/* number of distance codes */ const BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ const MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const END_BLOCK = 256;
/* end of block literal code */ const REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const base_length = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const base_dist = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let static_l_desc;
let static_d_desc;
let static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const d_code = (dist)=>{
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const send_bits = (s, value, length)=>{
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const send_code = (s, c, tree)=>{
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const gen_bitlen = (s, desc)=>//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const gen_codes = (tree, max_code, bl_count)=>//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    const next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const bi_windup = (s)=>{
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ const copy_block = (s, buf, len, header)=>//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
    s.pending += len;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const pqdownheap = (s, tree, k)=>//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const compress_block = (s, ltree, dtree)=>//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let lx = 0; /* running index in l_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const build_tree = (s, desc)=>//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const scan_tree = (s, tree, max_code)=>//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const send_tree = (s, tree, max_code)=>//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const send_all_trees = (s, lcodes, dcodes, blcodes)=>//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const detect_data_type = (s)=>{
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let black_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
};
let static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const _tr_init = (s)=>{
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const _tr_stored_block = (s, buf, stored_len, last)=>//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const _tr_align = (s)=>{
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ const _tr_flush_block = (s, buf, stored_len, last)=>//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const _tr_tally = (s, dist, lc)=>//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //let out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ };
module.exports._tr_init = _tr_init;
module.exports._tr_stored_block = _tr_stored_block;
module.exports._tr_flush_block = _tr_flush_block;
module.exports._tr_tally = _tr_tally;
module.exports._tr_align = _tr_align;

},{}],"OwvOf":[function(require,module,exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
module.exports = adler32;

},{}],"49E7g":[function(require,module,exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());
const crc32 = (crc, buf, len, pos)=>{
    const t = crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
module.exports = crc32;

},{}],"1UZve":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

},{}],"eRjMX":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

},{}],"eyqDB":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const adler32 = require("6ebe24dff7c86ec6");
const crc32 = require("733ae5de3dad536a");
const inflate_fast = require("d6c5d4935fa23026");
const inflate_table = require("f4fe87fcccdc3597");
const CODES = 0;
const LENS = 1;
const DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH, Z_BLOCK, Z_TREES, Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR, Z_BUF_ERROR, Z_DEFLATED } = require("200284b61958a3c0");
/* STATES ====================================================================*/ /* ===========================================================================*/ const HEAD = 1; /* i: waiting for magic header */ 
const FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
const TIME = 3; /* i: waiting for modification time (gzip) */ 
const OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
const EXLEN = 5; /* i: waiting for extra length (gzip) */ 
const EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
const NAME = 7; /* i: waiting for end of file name (gzip) */ 
const COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
const HCRC = 9; /* i: waiting for header crc (gzip) */ 
const DICTID = 10; /* i: waiting for dictionary check value */ 
const DICT = 11; /* waiting for inflateSetDictionary() call */ 
const TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
const TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
const STORED = 14; /* i: waiting for stored size (length and complement) */ 
const COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
const COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
const TABLE = 17; /* i: waiting for dynamic block table lengths */ 
const LENLENS = 18; /* i: waiting for code length code lengths */ 
const CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
const LEN_ = 20; /* i: same as LEN below, but only first time in */ 
const LEN = 21; /* i: waiting for length/lit/eob code */ 
const LENEXT = 22; /* i: waiting for length extra bits */ 
const DIST = 23; /* i: waiting for distance code */ 
const DISTEXT = 24; /* i: waiting for distance extra bits */ 
const MATCH = 25; /* o: waiting for output space to copy string */ 
const LIT = 26; /* o: waiting for output space to write literal */ 
const CHECK = 27; /* i: waiting for 32-bit check value */ 
const LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
const DONE = 29; /* finished check, done -- remain here until reset */ 
const BAD = 30; /* got a data error -- remain here until reset */ 
const MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
const SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const MAX_WBITS = 15;
/* 32K LZ77 window */ const DEF_WBITS = MAX_WBITS;
const zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const inflateResetKeep = (strm)=>{
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
};
const inflateReset = (strm)=>{
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
};
const inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
};
const inflateInit2 = (strm, windowBits)=>{
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    const ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const inflateInit = (strm)=>{
    return inflateInit2(strm, DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let virgin = true;
let lenfix, distfix; // We have no pointers in JS, so keep tables separate
const fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        lenfix = new Int32Array(512);
        distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const inflate = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
};
const inflateEnd = (strm)=>{
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
};
const inflateGetHeader = (strm, head)=>{
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
};
const inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
};
module.exports.inflateReset = inflateReset;
module.exports.inflateReset2 = inflateReset2;
module.exports.inflateResetKeep = inflateResetKeep;
module.exports.inflateInit = inflateInit;
module.exports.inflateInit2 = inflateInit2;
module.exports.inflate = inflate;
module.exports.inflateEnd = inflateEnd;
module.exports.inflateGetHeader = inflateGetHeader;
module.exports.inflateSetDictionary = inflateSetDictionary;
module.exports.inflateInfo = "pako inflate (from Nodeca project)"; /* Not implemented
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
*/ 

},{"6ebe24dff7c86ec6":"OwvOf","733ae5de3dad536a":"49E7g","d6c5d4935fa23026":"g3Mgn","f4fe87fcccdc3597":"2DZt9","200284b61958a3c0":"eRjMX"}],"g3Mgn":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const BAD = 30; /* got a data error -- remain here until reset */ 
const TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

},{}],"2DZt9":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const MAXBITS = 15;
const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const CODES = 0;
const LENS = 1;
const DISTS = 2;
const lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    let base_index = 0;
    //  let shoextra;    /* extra bits table to use */
    let end; /* use base and extra for symbol > end */ 
    const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let extra_index = 0;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
module.exports = inflate_table;

},{}],"cBNai":[function(require,module,exports) {
var unsupportedIterableToArray = require("750ca7ff73b0b6ce");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _createForOfIteratorHelperLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"750ca7ff73b0b6ce":"ikRAk"}],"ikRAk":[function(require,module,exports) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"d7ToU"}],"d7ToU":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4S2iS":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"gWiZy"}],"gWiZy":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"47zzI","2713647ce51d8c75":"bzAoJ"}],"bzAoJ":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"47zzI"}],"2XpZP":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("df297d5f1a7605f5"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

},{"df297d5f1a7605f5":"ezcuS"}],"ezcuS":[function(require,module,exports) {
var global = arguments[3];
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = require("b7760e5f0b7216d4");
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

},{"b7760e5f0b7216d4":"ixEMk"}],"bm3FR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
var _dacJs = require("./markers/dac.js");
var _dacJsDefault = parcelHelpers.interopDefault(_dacJs);
var _dhtJs = require("./markers/dht.js");
var _dhtJsDefault = parcelHelpers.interopDefault(_dhtJs);
var _dqtJs = require("./markers/dqt.js");
var _dqtJsDefault = parcelHelpers.interopDefault(_dqtJs);
var _driJs = require("./markers/dri.js");
var _driJsDefault = parcelHelpers.interopDefault(_driJs);
var _eoiJs = require("./markers/eoi.js");
var _eoiJsDefault = parcelHelpers.interopDefault(_eoiJs);
var _exifJs = require("./markers/exif.js");
var _exifJsDefault = parcelHelpers.interopDefault(_exifJs);
var _jfifJs = require("./markers/jfif.js");
var _jfifJsDefault = parcelHelpers.interopDefault(_jfifJs);
var _sosJs = require("./markers/sos.js");
var _sosJsDefault = parcelHelpers.interopDefault(_sosJs);
var _sofJs = require("./markers/sof.js");
var _sofJsDefault = parcelHelpers.interopDefault(_sofJs);
var _soiJs = require("./markers/soi.js");
var _soiJsDefault = parcelHelpers.interopDefault(_soiJs);
const UnkownMarker = {
    length: _restructure.uint16be,
    buf: new _restructure.Buffer((parent)=>parent.length - 2)
};
const unknownMarkers = Array(63).fill(0).reduce((acc, v, i)=>({
        ...acc,
        [i + 0xffc0]: UnkownMarker
    }), {});
const Marker = new _restructure.VersionedStruct(_restructure.uint16be, {
    ...unknownMarkers,
    0xffc0: (0, _sofJsDefault.default),
    0xffc1: (0, _sofJsDefault.default),
    0xffc2: (0, _sofJsDefault.default),
    0xffc3: (0, _sofJsDefault.default),
    0xffc4: (0, _dhtJsDefault.default),
    0xffc5: (0, _sofJsDefault.default),
    0xffc6: (0, _sofJsDefault.default),
    0xffc7: (0, _sofJsDefault.default),
    0xffc9: (0, _sofJsDefault.default),
    0xffca: (0, _sofJsDefault.default),
    0xffcb: (0, _sofJsDefault.default),
    0xffcc: (0, _dacJsDefault.default),
    0xffcd: (0, _sofJsDefault.default),
    0xffce: (0, _sofJsDefault.default),
    0xffcf: (0, _sofJsDefault.default),
    0xffd8: (0, _soiJsDefault.default),
    0xffd9: (0, _eoiJsDefault.default),
    0xffda: (0, _sosJsDefault.default),
    0xffdb: (0, _dqtJsDefault.default),
    0xffdd: (0, _driJsDefault.default),
    0xffe0: (0, _jfifJsDefault.default),
    0xffe1: (0, _exifJsDefault.default)
});
const JPEG = new _restructure.Array(Marker);
const decode = (buffer)=>{
    const markers = JPEG.fromBuffer(buffer);
    return markers.map(({ version, ...rest })=>({
            type: version,
            ...rest
        }));
};
exports.default = {
    decode
};

},{"restructure":"fXayK","./markers/dac.js":"ciKNa","./markers/dht.js":"94a22","./markers/dqt.js":"8zGwC","./markers/dri.js":"jpuAK","./markers/eoi.js":"fjJ4Q","./markers/exif.js":"cW4mW","./markers/jfif.js":"h8VBs","./markers/sos.js":"8or90","./markers/sof.js":"1C7t5","./markers/soi.js":"hXYB4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ciKNa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
const DACTable = new _restructure.Struct({
    identifier: new _restructure.Buffer(1),
    value: new _restructure.Buffer(1)
});
const DACMarker = {
    name: ()=>"DAC",
    length: _restructure.uint16be,
    tables: new _restructure.Array(DACTable, (parent)=>parent.length / 2)
};
exports.default = DACMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"94a22":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
var _utilsJs = require("./utils.js");
class HuffmanTableElements {
    decode(stream, parent) {
        const tables = {};
        let buffer = stream.buffer.slice(stream.pos, stream.pos + parent.length - 2);
        while(buffer.length > 0){
            let offset = 1;
            const elements = [];
            const identifier = (0, _utilsJs.readUInt8)(buffer, 0);
            const lengths = buffer.slice(offset, offset + 16);
            offset += 16;
            for (const length of lengths){
                elements.push(buffer.slice(offset, offset + length));
                offset += length;
            }
            buffer = buffer.slice(offset);
            tables[identifier] = (0, _utilsJs.concatenateUint8Arrays)(elements);
        }
        stream.pos += parent.length - 2;
        return tables;
    }
}
const DefineHuffmanTableMarker = {
    name: ()=>"DHT",
    length: _restructure.uint16be,
    tables: new HuffmanTableElements()
};
exports.default = DefineHuffmanTableMarker;

},{"restructure":"fXayK","./utils.js":"hBma1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hBma1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readUInt8", ()=>readUInt8);
parcelHelpers.export(exports, "readUInt16BE", ()=>readUInt16BE);
parcelHelpers.export(exports, "readUInt16LE", ()=>readUInt16LE);
parcelHelpers.export(exports, "readUInt32BE", ()=>readUInt32BE);
parcelHelpers.export(exports, "readUInt32LE", ()=>readUInt32LE);
parcelHelpers.export(exports, "uint8ArrayToHexString", ()=>uint8ArrayToHexString);
parcelHelpers.export(exports, "uint8ArrayToString", ()=>uint8ArrayToString);
parcelHelpers.export(exports, "concatenateUint8Arrays", ()=>concatenateUint8Arrays);
const readUInt8 = (array, offset)=>{
    return array[offset];
};
const readUInt16BE = (array, offset)=>{
    return array[offset] << 8 | array[offset + 1];
};
const readUInt16LE = (array, offset)=>{
    return array[offset] | array[offset + 1] << 8;
};
const readUInt32BE = (array, offset)=>{
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
};
const readUInt32LE = (array, offset)=>{
    return array[offset] | array[offset + 1] << 8 | array[offset + 2] << 16 | array[offset + 3] << 24;
};
const uint8ArrayToHexString = (uint8Array)=>{
    return Array.from(uint8Array, (byte)=>byte.toString(16).padStart(2, "0")).join("");
};
const decoder = new TextDecoder("utf-8");
const uint8ArrayToString = (uint8Array)=>{
    return decoder.decode(uint8Array);
};
const concatenateUint8Arrays = (arrays)=>{
    const totalLength = arrays.reduce((length, arr)=>length + arr.length, 0);
    const concatenatedArray = new Uint8Array(totalLength);
    let offset = 0;
    arrays.forEach((arr)=>{
        concatenatedArray.set(arr, offset);
        offset += arr.length;
    });
    return concatenatedArray;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8zGwC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
const DQTMarker = {
    name: ()=>"DQT",
    length: _restructure.uint16be,
    tables: new _restructure.Array(new _restructure.Struct({
        identifier: new _restructure.Buffer(1),
        data: new _restructure.Buffer(64)
    }), (parent)=>(parent.length - 2) / 65)
};
exports.default = DQTMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jpuAK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
const DRIMarker = {
    name: ()=>"DRI",
    length: _restructure.uint16be,
    restartInterval: _restructure.uint16be
};
exports.default = DRIMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fjJ4Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const EndOfImageMarker = {
    name: ()=>"EOI"
};
exports.default = EndOfImageMarker;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cW4mW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
var _utilsJs = require("./utils.js");
const tags = {
    ifd: {
        "010e": "imageDescription",
        "010f": "make",
        "011a": "xResolution",
        "011b": "yResolution",
        "011c": "planarConfiguration",
        "012d": "transferFunction",
        "013b": "artist",
        "013e": "whitePoint",
        "013f": "primaryChromaticities",
        "0100": "imageWidth",
        "0101": "imageHeight",
        "0102": "bitsPerSample",
        "0103": "compression",
        "0106": "photometricInterpretation",
        "0110": "model",
        "0111": "stripOffsets",
        "0112": "orientation",
        "0115": "samplesPerPixel",
        "0116": "rowsPerStrip",
        "0117": "stripByteCounts",
        "0128": "resolutionUnit",
        "0131": "software",
        "0132": "dateTime",
        "0201": "jpegInterchangeFormat",
        "0202": "jpegInterchangeFormatLength",
        "0211": "ycbCrCoefficients",
        "0212": "ycbCrSubSampling",
        "0213": "ycbCrPositioning",
        "0214": "referenceBlackWhite",
        "829a": "exposureTime",
        "829d": "fNumber",
        "920a": "focalLength",
        "927c": "makerNote",
        8298: "copyright",
        8769: "exifIFDPointer",
        8822: "exposureProgram",
        8824: "spectralSensitivity",
        8825: "gpsInfoIFDPointer",
        8827: "photographicSensitivity",
        8828: "oecf",
        8830: "sensitivityType",
        8831: "standardOutputSensitivity",
        8832: "recommendedExposureIndex",
        8833: "isoSpeed",
        8834: "isoSpeedLatitudeyyy",
        8835: "isoSpeedLatitudezzz",
        9000: "exifVersion",
        9003: "dateTimeOriginal",
        9004: "dateTimeDigitized",
        9101: "componentsConfiguration",
        9102: "compressedBitsPerPixel",
        9201: "shutterSpeedValue",
        9202: "apertureValue",
        9203: "brightnessValue",
        9204: "exposureBiasValue",
        9205: "maxApertureValue",
        9206: "subjectDistance",
        9207: "meteringMode",
        9208: "lightSource",
        9209: "flash",
        9214: "subjectArea",
        9286: "userComment",
        9290: "subSecTime",
        9291: "subSecTimeOriginal",
        9292: "subSecTimeDigitized",
        a000: "flashpixVersion",
        a001: "colorSpace",
        a002: "pixelXDimension",
        a003: "pixelYDimension",
        a004: "relatedSoundFile",
        a005: "interoperabilityIFDPointer",
        a20b: "flashEnergy",
        a20c: "spatialFrequencyResponse",
        a20e: "focalPlaneXResolution",
        a20f: "focalPlaneYResolution",
        a40a: "sharpness",
        a40b: "deviceSettingDescription",
        a40c: "subjectDistanceRange",
        a210: "focalPlaneResolutionUnit",
        a214: "subjectLocation",
        a215: "exposureIndex",
        a217: "sensingMethod",
        a300: "fileSource",
        a301: "sceneType",
        a302: "cfaPattern",
        a401: "customRendered",
        a402: "exposureMode",
        a403: "whiteBalance",
        a404: "digitalZoomRatio",
        a405: "focalLengthIn35mmFilm",
        a406: "sceneCaptureType",
        a407: "gainControl",
        a408: "contrast",
        a409: "saturation",
        a420: "imageUniqueID",
        a430: "cameraOwnerName",
        a431: "bodySerialNumber",
        a432: "lensSpecification",
        a433: "lensMake",
        a434: "lensModel",
        a435: "lensSerialNumber",
        a500: "gamma"
    },
    gps: {
        "0000": "gpsVersionID",
        "0001": "gpsLatitudeRef",
        "0002": "gpsLatitude",
        "0003": "gpsLongitudeRef",
        "0004": "gpsLongitude",
        "0005": "gpsAltitudeRef",
        "0006": "gpsAltitude",
        "0007": "gpsTimeStamp",
        "0008": "gpsSatellites",
        "0009": "gpsStatus",
        "000a": "gpsMeasureMode",
        "000b": "gpsDOP",
        "000c": "gpsSpeedRef",
        "000d": "gpsSpeed",
        "000e": "gpsTrackRef",
        "000f": "gpsTrack",
        "0010": "gpsImgDirectionRef",
        "0011": "gpsImgDirection",
        "0012": "gpsMapDatum",
        "0013": "gpsDestLatitudeRef",
        "0014": "gpsDestLatitude",
        "0015": "gpsDestLongitudeRef",
        "0016": "gpsDestLongitude",
        "0017": "gpsDestBearingRef",
        "0018": "gpsDestBearing",
        "0019": "gpsDestDistanceRef",
        "001a": "gpsDestDistance",
        "001b": "gpsProcessingMethod",
        "001c": "gpsAreaInformation",
        "001d": "gpsDateStamp",
        "001e": "gpsDifferential",
        "001f": "gpsHPositioningError"
    }
};
class IDFEntries {
    _getTagValue(dataValue, dataFormat) {
        const uint16 = (pos)=>this.bigEndian ? (0, _utilsJs.readUInt16BE)(dataValue, pos) : (0, _utilsJs.readUInt16LE)(dataValue, pos);
        const uint32 = (pos)=>this.bigEndian ? (0, _utilsJs.readUInt32BE)(dataValue, pos) : (0, _utilsJs.readUInt32LE)(dataValue, pos);
        switch(dataFormat){
            case 1:
                return dataValue.readUInt8(0);
            case 2:
                return dataValue.toString("ascii").replace(/\0+$/, "");
            case 3:
                return uint16(0);
            case 4:
                return uint32(0);
            case 5:
                const tagValue = [];
                for(var i = 0; i < dataValue.length; i += 8)tagValue.push(uint32(i) / uint32(i + 4));
                return tagValue;
            case 7:
                return null;
            case 10:
                return uint32(0) / uint32(4);
            default:
                return "0x" + dataValue.toString("hex");
        }
    }
    _decodeIDFEntries(buffer, tags, offset) {
        let pos = 2;
        const entries = {};
        const uint16 = (pos)=>this.bigEndian ? (0, _utilsJs.readUInt16BE)(buffer, pos) : (0, _utilsJs.readUInt16LE)(buffer, pos);
        const uint32 = (pos)=>this.bigEndian ? (0, _utilsJs.readUInt32BE)(buffer, pos) : (0, _utilsJs.readUInt32LE)(buffer, pos);
        const numberOfEntries = uint16(0);
        for(let i = 0; i < numberOfEntries; i++){
            const tagAddress = buffer.slice(pos, pos + 2);
            const dataFormat = uint16(pos + 2);
            const componentsNumber = uint32(pos + 4);
            const componentsBytes = this.bytes[dataFormat];
            const dataLength = componentsNumber * componentsBytes;
            let dataValue = buffer.slice(pos + 8, pos + 12);
            if (dataLength > 4) {
                const valueOffset = this.bigEndian ? (0, _utilsJs.readUInt32BE)(dataValue, 0) : (0, _utilsJs.readUInt32LE)(dataValue, 0);
                const dataOffset = valueOffset - offset;
                dataValue = buffer.slice(dataOffset, dataOffset + dataLength);
            }
            const tagValue = this._getTagValue(dataValue, dataFormat);
            const tagNumber = this.bigEndian ? (0, _utilsJs.uint8ArrayToHexString)(tagAddress) : (0, _utilsJs.uint8ArrayToHexString)(tagAddress.reverse());
            const tagName = tags[tagNumber];
            entries[tagName] = tagValue;
            pos += 12;
        }
        return entries;
    }
    decode(stream, parent) {
        const buffer = stream.buffer.slice(stream.pos);
        const offsetToFirstIFD = parent.offsetToFirstIFD;
        if (offsetToFirstIFD > buffer.length) {
            stream.pos += parent.parent.length - 16;
            return {};
        }
        const entries = this._decodeIDFEntries(buffer, tags.ifd, offsetToFirstIFD);
        const { exifIFDPointer, gpsInfoIFDPointer } = entries;
        if (exifIFDPointer) {
            const subuffer = buffer.slice(exifIFDPointer - offsetToFirstIFD);
            entries.subExif = this._decodeIDFEntries(subuffer, tags.ifd, exifIFDPointer);
        }
        if (gpsInfoIFDPointer) {
            const gps = gpsInfoIFDPointer;
            const subuffer = buffer.slice(exifIFDPointer ? gps - exifIFDPointer : gps - offsetToFirstIFD);
            entries.gpsInfo = IFDHandler(subuffer, tags.gps, gps);
        }
        stream.pos += parent.parent.length - 16;
        return entries;
    }
    constructor(bigEndian){
        this.bigEndian = bigEndian;
        this.bytes = [
            0,
            1,
            1,
            2,
            4,
            8,
            1,
            1,
            2,
            4,
            8,
            4,
            8
        ];
    }
}
const IFDData = (bigEndian)=>{
    const uint16 = bigEndian ? _restructure.uint16be : _restructure.uint16le;
    const uint32 = bigEndian ? _restructure.uint32be : _restructure.uint32le;
    return new _restructure.Struct({
        fortyTwo: uint16,
        offsetToFirstIFD: uint32,
        entries: new IDFEntries(bigEndian)
    });
};
class TIFFHeader {
    decode(stream, parent) {
        const byteOrder = (0, _utilsJs.uint8ArrayToString)(stream.buffer.slice(stream.pos, stream.pos + 2));
        const bigEndian = byteOrder === "MM";
        stream.pos += 2;
        const data = IFDData(bigEndian).decode(stream, parent);
        return data.entries;
    }
}
const EXIFMarker = {
    name: ()=>"EXIF",
    length: _restructure.uint16be,
    identifier: new _restructure.String(6),
    entries: new TIFFHeader()
};
exports.default = EXIFMarker;

},{"restructure":"fXayK","./utils.js":"hBma1","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"h8VBs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
const JFIFMarker = {
    name: ()=>"JFIF",
    length: _restructure.uint16be,
    identifier: new _restructure.String(5),
    version: _restructure.uint16be,
    units: _restructure.uint8,
    xDensity: _restructure.uint16be,
    yDensity: _restructure.uint16be,
    thumbnailWidth: _restructure.uint8,
    thumbnailHeight: _restructure.uint8
};
exports.default = JFIFMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8or90":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
class ImageData {
    decode(stream) {
        const buffer = stream.buffer.slice(stream.pos);
        let length = 0;
        let i = buffer.indexOf(0xff);
        while(i !== -1){
            length = i;
            const nextByte = buffer[length + 1];
            const comesRestart = nextByte >= 0xd0 && nextByte <= 0xd7;
            if (nextByte !== 0x00 && !comesRestart) break;
            i = buffer.indexOf(0xff, i + 1);
        }
        stream.pos += length;
        return buffer.slice(0, length);
    }
}
const SOSComponentSpecification = new _restructure.Struct({
    scanComponentSelector: _restructure.uint8,
    entropyCodingTable: new _restructure.Buffer(1)
});
const SOSMarker = {
    name: ()=>"SOS",
    length: _restructure.uint16be,
    numberOfImageComponents: _restructure.uint8,
    componentSpecifications: new _restructure.Array(SOSComponentSpecification, (parent)=>parent.numberOfImageComponents),
    startOfSpectral: _restructure.uint8,
    endOfSpectral: _restructure.uint8,
    successiveApproximationBit: new _restructure.Buffer(1),
    data: new ImageData()
};
exports.default = SOSMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1C7t5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
const FrameColorComponent = new _restructure.Struct({
    id: _restructure.uint8,
    samplingFactors: _restructure.uint8,
    quantizationTableId: _restructure.uint8
});
const StartOfFrameMarker = {
    name: ()=>"SOF",
    length: _restructure.uint16be,
    precision: _restructure.uint8,
    height: _restructure.uint16be,
    width: _restructure.uint16be,
    numberOfComponents: _restructure.uint8,
    components: new _restructure.Array(FrameColorComponent, (parent)=>parent.numberOfComponents)
};
exports.default = StartOfFrameMarker;

},{"restructure":"fXayK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hXYB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const StartOfImageMarker = {
    name: ()=>"SOI"
};
exports.default = StartOfImageMarker;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gUjti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PNG);
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup[tmp >> 10];
        output += lookup[tmp >> 4 & 0x3F];
        output += lookup[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString = {}.toString;
var isArray$1 = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
/*
 * Export kMaxLength after typed array support is determined.
 */ var _kMaxLength = kMaxLength();
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species];
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray$1(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = isBuffer$1;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray$1(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray(buf);
    else return fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer$1(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
var _polyfillNode_buffer = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Buffer: Buffer,
    INSPECT_MAX_BYTES: INSPECT_MAX_BYTES,
    SlowBuffer: SlowBuffer,
    isBuffer: isBuffer$1,
    kMaxLength: _kMaxLength
});
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === "function") cachedSetTimeout = setTimeout;
if (typeof global$1.clearTimeout === "function") cachedClearTimeout = clearTimeout;
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var title = "browser";
var platform = "browser";
var browser = true;
var env = {};
var argv = [];
var version = ""; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};
function noop() {}
var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;
function binding$1(name) {
    throw new Error("process.binding is not supported");
}
function cwd() {
    return "/";
}
function chdir(dir) {
    throw new Error("process.chdir is not supported");
}
function umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var startTime = new Date();
function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
}
var browser$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding$1,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
    if (typeof f == "function") {
        var a = function a() {
            if (this instanceof a) return Reflect.construct(f, arguments, this.constructor);
            return f.apply(this, arguments);
        };
        a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var lib = {};
var require$$0 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_buffer);
var domain;
// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);
function EventEmitter() {
    EventEmitter.init.call(this);
}
// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;
EventEmitter.init = function() {
    this.domain = null;
    if (EventEmitter.usingDomains) // if there is an active domain, then attach to it.
    domain.active;
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new EventHandlers();
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
};
function $getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
};
// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self1) {
    if (isFn) handler.call(self1);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1);
    }
}
function emitOne(handler, isFn, self1, arg1) {
    if (isFn) handler.call(self1, arg1);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
    }
}
function emitTwo(handler, isFn, self1, arg1, arg2) {
    if (isFn) handler.call(self1, arg1, arg2);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
    }
}
function emitThree(handler, isFn, self1, arg1, arg2, arg3) {
    if (isFn) handler.call(self1, arg1, arg2, arg3);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
    }
}
function emitMany(handler, isFn, self1, args) {
    if (isFn) handler.apply(self1, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
    }
}
EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === "error";
    events = this._events;
    if (events) doError = doError && events.error == null;
    else if (!doError) return false;
    domain = this.domain;
    // If there is no 'error' event listener then throw.
    if (doError) {
        er = arguments[1];
        if (domain) {
            if (!er) er = new Error('Uncaught, unspecified "error" event');
            er.domainEmitter = this;
            er.domain = domain;
            er.domainThrown = false;
            domain.emit("error", er);
        } else if (er instanceof Error) throw er; // Unhandled 'error' event
        else {
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
            err.context = er;
            throw err;
        }
        return false;
    }
    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === "function";
    len = arguments.length;
    switch(len){
        // fast cases
        case 1:
            emitNone(handler, isFn, this);
            break;
        case 2:
            emitOne(handler, isFn, this, arguments[1]);
            break;
        case 3:
            emitTwo(handler, isFn, this, arguments[1], arguments[2]);
            break;
        case 4:
            emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
            break;
        // slower
        default:
            args = new Array(len - 1);
            for(i = 1; i < len; i++)args[i - 1] = arguments[i];
            emitMany(handler, isFn, this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
        events = target._events = new EventHandlers();
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else // If we've already got an array, just append.
        if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        if (!existing.warned) {
            m = $getMaxListeners(target);
            if (m && m > 0 && existing.length > m) {
                existing.warned = true;
                var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type + " listeners added. " + "Use emitter.setMaxListeners() to increase limit");
                w.name = "MaxListenersExceededWarning";
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                emitWarning(w);
            }
        }
    }
    return target;
}
function emitWarning(e) {
    typeof console.warn === "function" ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function _onceWrap(target, type, listener) {
    var fired = false;
    function g() {
        target.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(target, arguments);
        }
    }
    g.listener = listener;
    return g;
}
EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;
    if (list === listener || list.listener && list.listener === listener) {
        if (--this._eventsCount === 0) this._events = new EventHandlers();
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
                this._events = new EventHandlers();
                return this;
            } else delete events[type];
        } else spliceOne(list, position);
        if (events.removeListener) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener) {
    return this.removeListener(type, listener);
};
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this;
    // not listening for removeListener, no need to emit
    if (!events.removeListener) {
        if (arguments.length === 0) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
        } else if (events[type]) {
            if (--this._eventsCount === 0) this._events = new EventHandlers();
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        for(var i = 0, key; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    do this.removeListener(type, listeners[listeners.length - 1]);
    while (listeners[0]);
    return this;
};
EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];
    else {
        evlistener = events[type];
        if (!evlistener) ret = [];
        else if (typeof evlistener === "function") ret = [
            evlistener.listener || evlistener
        ];
        else ret = unwrapListeners(evlistener);
    }
    return ret;
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount$1.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount$1;
function listenerCount$1(type) {
    var events = this._events;
    if (events) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
function arrayClone(arr, i) {
    var copy = new Array(i);
    while(i--)copy[i] = arr[i];
    return copy;
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
var inherits;
if (typeof Object.create === "function") inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var inherits$1 = inherits;
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var formatRegExp = /%[sdj%]/g;
function format(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect$1(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
    else str += " " + inspect$1(x);
    return str;
}
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global$1.process)) return function() {
        return deprecate(fn, msg).apply(this, arguments);
    };
    if (browser$1.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (browser$1.throwDeprecation) throw new Error(msg);
            else if (browser$1.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
var debugs = {};
var debugEnviron;
function debuglog(set) {
    if (isUndefined(debugEnviron)) debugEnviron = browser$1.env.NODE_DEBUG || "";
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
            var pid = 0;
            debugs[set] = function() {
                var msg = format.apply(null, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect$1(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    _extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect$1.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect$1.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function stylizeWithColor(str, styleType) {
    var style = inspect$1.styles[styleType];
    if (style) return "\x1b[" + inspect$1.colors[style][0] + "m" + str + "\x1b[" + inspect$1.colors[style][1] + "m";
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== inspect$1 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if (isError(value)) return formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = " " + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if (isNumber(value)) return ctx.stylize("" + value, "number");
    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize("null", "null");
}
function formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf("\n");
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
    return Array.isArray(ar);
}
function isBoolean(arg) {
    return typeof arg === "boolean";
}
function isNull(arg) {
    return arg === null;
}
function isNullOrUndefined(arg) {
    return arg == null;
}
function isNumber(arg) {
    return typeof arg === "number";
}
function isString(arg) {
    return typeof arg === "string";
}
function isSymbol(arg) {
    return typeof arg === "symbol";
}
function isUndefined(arg) {
    return arg === void 0;
}
function isRegExp(re) {
    return isObject(re) && objectToString(re) === "[object RegExp]";
}
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
function isError(e) {
    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
}
function isFunction(arg) {
    return typeof arg === "function";
}
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
function isBuffer(maybeBuf) {
    return Buffer.isBuffer(maybeBuf);
}
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
function log() {
    console.log("%s - %s", timestamp(), format.apply(null, arguments));
}
function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
}
promisify.custom = kCustomPromisifiedSymbol;
function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self1 = this;
        var cb = function() {
            return maybeCb.apply(self1, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            browser$1.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            browser$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
}
var _polyfillNode_util = {
    inherits: inherits$1,
    _extend: _extend,
    log: log,
    isBuffer: isBuffer,
    isPrimitive: isPrimitive,
    isFunction: isFunction,
    isError: isError,
    isDate: isDate,
    isObject: isObject,
    isRegExp: isRegExp,
    isUndefined: isUndefined,
    isSymbol: isSymbol,
    isString: isString,
    isNumber: isNumber,
    isNullOrUndefined: isNullOrUndefined,
    isNull: isNull,
    isBoolean: isBoolean,
    isArray: isArray,
    inspect: inspect$1,
    deprecate: deprecate,
    format: format,
    debuglog: debuglog,
    promisify: promisify,
    callbackify: callbackify
};
var _polyfillNode_util$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    _extend: _extend,
    callbackify: callbackify,
    debuglog: debuglog,
    default: _polyfillNode_util,
    deprecate: deprecate,
    format: format,
    inherits: inherits$1,
    inspect: inspect$1,
    isArray: isArray,
    isBoolean: isBoolean,
    isBuffer: isBuffer,
    isDate: isDate,
    isError: isError,
    isFunction: isFunction,
    isNull: isNull,
    isNullOrUndefined: isNullOrUndefined,
    isNumber: isNumber,
    isObject: isObject,
    isPrimitive: isPrimitive,
    isRegExp: isRegExp,
    isString: isString,
    isSymbol: isSymbol,
    isUndefined: isUndefined,
    log: log,
    promisify: promisify
});
function BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
}
BufferList.prototype.push = function(v) {
    var entry = {
        data: v,
        next: null
    };
    if (this.length > 0) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
    ++this.length;
};
BufferList.prototype.unshift = function(v) {
    var entry = {
        data: v,
        next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
};
BufferList.prototype.shift = function() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;
    else this.head = this.head.next;
    --this.length;
    return ret;
};
BufferList.prototype.clear = function() {
    this.head = this.tail = null;
    this.length = 0;
};
BufferList.prototype.join = function(s) {
    if (this.length === 0) return "";
    var p = this.head;
    var ret = "" + p.data;
    while(p = p.next)ret += s + p.data;
    return ret;
};
BufferList.prototype.concat = function(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while(p){
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
    }
    return ret;
};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var isBufferEncoding = Buffer.isEncoding || function(encoding) {
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) throw new Error("Unknown encoding: " + encoding);
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
function StringDecoder(encoding) {
    this.encoding = (encoding || "utf8").toLowerCase().replace(/[-_]/, "");
    assertEncoding(encoding);
    switch(this.encoding){
        case "utf8":
            // CESU-8 represents each of Surrogate Pair by 3-bytes
            this.surrogateSize = 3;
            break;
        case "ucs2":
        case "utf16le":
            // UTF-16 represents each of Surrogate Pair by 2-bytes
            this.surrogateSize = 2;
            this.detectIncompleteChar = utf16DetectIncompleteChar;
            break;
        case "base64":
            // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
            this.surrogateSize = 3;
            this.detectIncompleteChar = base64DetectIncompleteChar;
            break;
        default:
            this.write = passThroughWrite;
            return;
    }
    // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    this.charBuffer = new Buffer(6);
    // Number of bytes received for the current incomplete multi-byte character.
    this.charReceived = 0;
    // Number of bytes expected for the current incomplete multi-byte character.
    this.charLength = 0;
}
// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
    var charStr = "";
    // if our last write ended with an incomplete multibyte character
    while(this.charLength){
        // determine how many remaining bytes this buffer has to offer for this char
        var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
        // add the new bytes to the char buffer
        buffer.copy(this.charBuffer, this.charReceived, 0, available);
        this.charReceived += available;
        if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
        return "";
        // remove bytes belonging to the current character from the buffer
        buffer = buffer.slice(available, buffer.length);
        // get the character that was split
        charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
        // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        var charCode = charStr.charCodeAt(charStr.length - 1);
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            this.charLength += this.surrogateSize;
            charStr = "";
            continue;
        }
        this.charReceived = this.charLength = 0;
        // if there are no more bytes in this buffer, just emit our char
        if (buffer.length === 0) return charStr;
        break;
    }
    // determine and set charLength / charReceived
    this.detectIncompleteChar(buffer);
    var end = buffer.length;
    if (this.charLength) {
        // buffer the incomplete character bytes we got
        buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
        end -= this.charReceived;
    }
    charStr += buffer.toString(this.encoding, 0, end);
    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        var size = this.surrogateSize;
        this.charLength += size;
        this.charReceived += size;
        this.charBuffer.copy(this.charBuffer, size, 0, size);
        buffer.copy(this.charBuffer, 0, 0, size);
        return charStr.substring(0, end);
    }
    // or just emit the charStr
    return charStr;
};
// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = buffer.length >= 3 ? 3 : buffer.length;
    // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.
    for(; i > 0; i--){
        var c = buffer[buffer.length - i];
        // See http://en.wikipedia.org/wiki/UTF-8#Description
        // 110XXXXX
        if (i == 1 && c >> 5 == 0x06) {
            this.charLength = 2;
            break;
        }
        // 1110XXXX
        if (i <= 2 && c >> 4 == 0x0E) {
            this.charLength = 3;
            break;
        }
        // 11110XXX
        if (i <= 3 && c >> 3 == 0x1E) {
            this.charLength = 4;
            break;
        }
    }
    this.charReceived = i;
};
StringDecoder.prototype.end = function(buffer) {
    var res = "";
    if (buffer && buffer.length) res = this.write(buffer);
    if (this.charReceived) {
        var cr = this.charReceived;
        var buf = this.charBuffer;
        var enc = this.encoding;
        res += buf.slice(0, cr).toString(enc);
    }
    return res;
};
function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
}
function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
}
function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
}
Readable.ReadableState = ReadableState;
var debug = debuglog("stream");
inherits$1(Readable, EventEmitter);
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
}
function listenerCount(emitter, type) {
    return emitter.listeners(type).length;
}
function ReadableState(options, stream) {
    options = options || {};
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false;
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    if (!(this instanceof Readable)) return new Readable(options);
    this._readableState = new ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options && typeof options.read === "function") this._read = options.read;
    EventEmitter.call(this);
}
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    if (!state.objectMode && typeof chunk === "string") {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
            chunk = Buffer.from(chunk, encoding);
            encoding = "";
        }
    }
    return readableAddChunk(this, state, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    var state = this._readableState;
    return readableAddChunk(this, state, chunk, "", true);
};
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
function readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = chunkInvalid(state, chunk);
    if (er) stream.emit("error", er);
    else if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
            var e = new Error("stream.push() after EOF");
            stream.emit("error", e);
        } else if (state.endEmitted && addToFront) {
            var _e = new Error("stream.unshift() after end event");
            stream.emit("error", _e);
        } else {
            var skipAdd;
            if (state.decoder && !addToFront && !encoding) {
                chunk = state.decoder.write(chunk);
                skipAdd = !state.objectMode && chunk.length === 0;
            }
            if (!addToFront) state.reading = false;
            // Don't add to the buffer if we've decoded to an empty string chunk and
            // we're not in object mode
            if (!skipAdd) {
                // if we want the data now, just emit it.
                if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit("data", chunk);
                    stream.read(0);
                } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
                    if (state.needReadable) emitReadable(stream);
                }
            }
            maybeReadMore(stream, state);
        }
    } else if (!addToFront) state.reading = false;
    return needMoreData(state);
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function chunkInvalid(state, chunk) {
    var er = null;
    if (!Buffer.isBuffer(chunk) && typeof chunk !== "string" && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) nextTick(emitReadable_, stream);
        else emitReadable_(stream);
    }
}
function emitReadable_(stream) {
    debug("emit readable");
    stream.emit("readable");
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    this.emit("error", new Error("not implemented"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable) {
        debug("onunpipe");
        if (readable === src) cleanup();
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", cleanup);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (listenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners("data").length) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var _i = 0; _i < len; _i++)dests[_i].emit("unpipe", this);
        return this;
    }
    // try to find the right one.
    var i = indexOf(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = EventEmitter.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) nextTick(nReadingNextTick, this);
            else if (state.length) emitReadable(this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        state.flowing = true;
        resume(this, state);
    }
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    if (!state.reading) {
        debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    var self1 = this;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) self1.push(chunk);
        }
        self1.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = self1.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    var events = [
        "error",
        "close",
        "destroy",
        "pause",
        "resume"
    ];
    forEach(events, function(ev) {
        stream.on(ev, self1.emit.bind(self1, ev));
    });
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self1._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return self1;
};
// exposed for testing purposes only.
Readable._fromList = fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function forEach(xs, f) {
    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
}
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
Writable.WritableState = WritableState;
inherits$1(Writable, EventEmitter);
function nop() {}
function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
function WritableState(options, stream) {
    Object.defineProperty(this, "buffer", {
        get: deprecate(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    });
    options = options || {};
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
function Writable(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
    this._writableState = new WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
    }
    EventEmitter.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    nextTick(cb, er);
}
// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (!Buffer.isBuffer(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        nextTick(cb, er);
        valid = false;
    }
    return valid;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (Buffer.isBuffer(chunk)) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ended) writeAfterEnd(this, cb);
    else if (validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = decodeChunk(state, chunk, encoding);
    if (Buffer.isBuffer(chunk)) encoding = "buffer";
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) nextTick(cb, er);
    else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit("error", er);
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) /*<replacement>*/ nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        while(entry){
            buffer[count] = entry;
            entry = entry.next;
            count += 1;
        }
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("not implemented"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) endWritable(this, state, cb);
};
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function prefinish(stream, state) {
    if (!state.prefinished) {
        state.prefinished = true;
        stream.emit("prefinish");
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        if (state.pendingcb === 0) {
            prefinish(stream, state);
            state.finished = true;
            stream.emit("finish");
        } else prefinish(stream, state);
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function(err) {
        var entry = _this.entry;
        _this.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
        else state.corkedRequestsFree = _this;
    };
}
inherits$1(Duplex, Readable);
var keys = Object.keys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", onend);
}
// the no-half-open enforcer
function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    nextTick(onEndNT, this);
}
function onEndNT(self1) {
    self1.end();
}
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
inherits$1(Transform, Duplex);
function TransformState(stream) {
    this.afterTransform = function(er, data) {
        return afterTransform(stream, er, data);
    };
    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
}
function afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit("error", new Error("no writecb in Transform class"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = new TransformState(this);
    // when the writable side finishes, then flush out anything remaining.
    var stream = this;
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    this.once("prefinish", function() {
        if (typeof this._flush === "function") this._flush(function(er) {
            done(stream, er);
        });
        else done(stream);
    });
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("Not implemented");
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
function done(stream, er) {
    if (er) return stream.emit("error", er);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error("Calling transform done when ws.length != 0");
    if (ts.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}
inherits$1(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
inherits$1(Stream, EventEmitter);
Stream.Readable = Readable;
Stream.Writable = Writable;
Stream.Duplex = Duplex;
Stream.Transform = Transform;
Stream.PassThrough = PassThrough;
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EventEmitter.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EventEmitter.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
var _polyfillNode_stream = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Duplex: Duplex,
    PassThrough: PassThrough,
    Readable: Readable,
    Stream: Stream,
    Transform: Transform,
    Writable: Writable,
    default: Stream
});
var require$$1 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_stream);
var binding = {};
function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var hasOwn = Object.prototype.hasOwnProperty;
var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)if (hasOwn.call(obj, key)) keys.push(key);
    return keys;
};
var pSlice = Array.prototype.slice;
var _functionsHaveNames;
function functionsHaveNames() {
    if (typeof _functionsHaveNames !== "undefined") return _functionsHaveNames;
    return _functionsHaveNames = function() {
        return (function foo() {}).name === "foo";
    }();
}
function pToString(obj) {
    return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
    if (isBuffer$1(arrbuf)) return false;
    if (typeof global$1.ArrayBuffer !== "function") return false;
    if (typeof ArrayBuffer.isView === "function") return ArrayBuffer.isView(arrbuf);
    if (!arrbuf) return false;
    if (arrbuf instanceof DataView) return true;
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) return true;
    return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
function assert(value, message) {
    if (!value) fail(value, true, message, "==", ok);
}
// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })
var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
    if (!isFunction(func)) return;
    if (functionsHaveNames()) return func.name;
    var str = func.toString();
    var match = str.match(regex);
    return match && match[1];
}
assert.AssertionError = AssertionError;
function AssertionError(options) {
    this.name = "AssertionError";
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
        this.message = options.message;
        this.generatedMessage = false;
    } else {
        this.message = getMessage(this);
        this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || fail;
    if (Error.captureStackTrace) Error.captureStackTrace(this, stackStartFunction);
    else {
        // non v8 browsers so we can have a stacktrace
        var err = new Error();
        if (err.stack) {
            var out = err.stack;
            // try to strip useless frames
            var fn_name = getName(stackStartFunction);
            var idx = out.indexOf("\n" + fn_name);
            if (idx >= 0) {
                // once we have located the function frame
                // we need to strip out everything before it (and its line)
                var next_line = out.indexOf("\n", idx + 1);
                out = out.substring(next_line + 1);
            }
            this.stack = out;
        }
    }
}
// assert.AssertionError instanceof Error
inherits$1(AssertionError, Error);
function truncate(s, n) {
    if (typeof s === "string") return s.length < n ? s : s.slice(0, n);
    else return s;
}
function inspect(something) {
    if (functionsHaveNames() || !isFunction(something)) return inspect$1(something);
    var rawname = getName(something);
    var name = rawname ? ": " + rawname : "";
    return "[Function" + name + "]";
}
function getMessage(self1) {
    return truncate(inspect(self1.actual), 128) + " " + self1.operator + " " + truncate(inspect(self1.expected), 128);
}
// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.
// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function fail(actual, expected, message, operator, stackStartFunction) {
    throw new AssertionError({
        message: message,
        actual: actual,
        expected: expected,
        operator: operator,
        stackStartFunction: stackStartFunction
    });
}
// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;
// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.
function ok(value, message) {
    if (!value) fail(value, true, message, "==", ok);
}
assert.ok = ok;
// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);
assert.equal = equal;
function equal(actual, expected, message) {
    if (actual != expected) fail(actual, expected, message, "==", equal);
}
// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);
assert.notEqual = notEqual;
function notEqual(actual, expected, message) {
    if (actual == expected) fail(actual, expected, message, "!=", notEqual);
}
// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);
assert.deepEqual = deepEqual;
function deepEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, false)) fail(actual, expected, message, "deepEqual", deepEqual);
}
assert.deepStrictEqual = deepStrictEqual;
function deepStrictEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, true)) fail(actual, expected, message, "deepStrictEqual", deepStrictEqual);
}
function _deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (isBuffer$1(actual) && isBuffer$1(expected)) return compare(actual, expected) === 0;
    else if (isDate(actual) && isDate(expected)) return actual.getTime() === expected.getTime();
    else if (isRegExp(actual) && isRegExp(expected)) return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
    else if ((actual === null || typeof actual !== "object") && (expected === null || typeof expected !== "object")) return strict ? actual === expected : actual == expected;
    else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
    else if (isBuffer$1(actual) !== isBuffer$1(expected)) return false;
    else {
        memos = memos || {
            actual: [],
            expected: []
        };
        var actualIndex = memos.actual.indexOf(actual);
        if (actualIndex !== -1) {
            if (actualIndex === memos.expected.indexOf(expected)) return true;
        }
        memos.actual.push(actual);
        memos.expected.push(expected);
        return objEquiv(actual, expected, strict, memos);
    }
}
function isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
}
function objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    // if one is a primitive, the other must be same
    if (isPrimitive(a) || isPrimitive(b)) return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
    var aIsArgs = isArguments(a);
    var bIsArgs = isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
        a = pSlice.call(a);
        b = pSlice.call(b);
        return _deepEqual(a, b, strict);
    }
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] !== kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
    }
    return true;
}
// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);
assert.notDeepEqual = notDeepEqual;
function notDeepEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, false)) fail(actual, expected, message, "notDeepEqual", notDeepEqual);
}
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, true)) fail(actual, expected, message, "notDeepStrictEqual", notDeepStrictEqual);
}
// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);
assert.strictEqual = strictEqual;
function strictEqual(actual, expected, message) {
    if (actual !== expected) fail(actual, expected, message, "===", strictEqual);
}
// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
assert.notStrictEqual = notStrictEqual;
function notStrictEqual(actual, expected, message) {
    if (actual === expected) fail(actual, expected, message, "!==", notStrictEqual);
}
function expectedException(actual, expected) {
    if (!actual || !expected) return false;
    if (Object.prototype.toString.call(expected) == "[object RegExp]") return expected.test(actual);
    try {
        if (actual instanceof expected) return true;
    } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
    }
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function _tryBlock(block) {
    var error;
    try {
        block();
    } catch (e) {
        error = e;
    }
    return error;
}
function _throws(shouldThrow, block, expected, message) {
    var actual;
    if (typeof block !== "function") throw new TypeError('"block" argument must be a function');
    if (typeof expected === "string") {
        message = expected;
        expected = null;
    }
    actual = _tryBlock(block);
    message = (expected && expected.name ? " (" + expected.name + ")." : ".") + (message ? " " + message : ".");
    if (shouldThrow && !actual) fail(actual, expected, "Missing expected exception" + message);
    var userProvidedMessage = typeof message === "string";
    var isUnwantedException = !shouldThrow && isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
    if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) fail(actual, expected, "Got unwanted exception" + message);
    if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) throw actual;
}
// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);
assert.throws = throws;
function throws(block, /*optional*/ error, /*optional*/ message) {
    _throws(true, block, error, message);
}
// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = doesNotThrow;
function doesNotThrow(block, /*optional*/ error, /*optional*/ message) {
    _throws(false, block, error, message);
}
assert.ifError = ifError;
function ifError(err) {
    if (err) throw err;
}
var _polyfillNode_assert = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AssertionError: AssertionError,
    assert: ok,
    deepEqual: deepEqual,
    deepStrictEqual: deepStrictEqual,
    default: assert,
    doesNotThrow: doesNotThrow,
    equal: equal,
    fail: fail,
    ifError: ifError,
    notDeepEqual: notDeepEqual,
    notDeepStrictEqual: notDeepStrictEqual,
    notEqual: notEqual,
    notStrictEqual: notStrictEqual,
    ok: ok,
    strictEqual: strictEqual,
    throws: throws
});
var require$$4 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_assert);
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var zstream = ZStream;
var deflate$1 = {};
var common = {};
(function(exports) {
    var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
    function _has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }
    exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while(sources.length){
            var source = sources.shift();
            if (!source) continue;
            if (typeof source !== "object") throw new TypeError(source + "must be non-object");
            for(var p in source)if (_has(source, p)) obj[p] = source[p];
        }
        return obj;
    };
    // reduce buffer size, avoiding mem copy
    exports.shrinkBuf = function(buf, size) {
        if (buf.length === size) return buf;
        if (buf.subarray) return buf.subarray(0, size);
        buf.length = size;
        return buf;
    };
    var fnTyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
            if (src.subarray && dest.subarray) {
                dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                return;
            }
            // Fallback to ordinary array
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
            var i, l, len, pos, chunk, result;
            // calculate data length
            len = 0;
            for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
            // join chunks
            result = new Uint8Array(len);
            pos = 0;
            for(i = 0, l = chunks.length; i < l; i++){
                chunk = chunks[i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
    };
    var fnUntyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
            return [].concat.apply([], chunks);
        }
    };
    // Enable/Disable typed arrays use, for testing
    //
    exports.setTyped = function(on) {
        if (on) {
            exports.Buf8 = Uint8Array;
            exports.Buf16 = Uint16Array;
            exports.Buf32 = Int32Array;
            exports.assign(exports, fnTyped);
        } else {
            exports.Buf8 = Array;
            exports.Buf16 = Array;
            exports.Buf32 = Array;
            exports.assign(exports, fnUntyped);
        }
    };
    exports.setTyped(TYPED_OK);
})(common);
var trees$1 = {};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils$3 = common;
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED$1 = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN$1 = 2;
/*============================================================================*/ function zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH$1 = 3;
var MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES$1 = 30;
/* number of distance codes */ var BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
/* maximum heap size */ var MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS$1; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array(MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
    static_l_desc.static_tree = static_ltree;
    static_l_desc.extra_bits = extra_lbits;
    static_d_desc.static_tree = static_dtree;
    static_d_desc.extra_bits = extra_dbits;
    static_bl_desc.extra_bits = extra_blbits;
  #endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES$1 - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES$1; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES$1; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils$3.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN$1) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
trees$1._tr_init = _tr_init;
trees$1._tr_stored_block = _tr_stored_block;
trees$1._tr_flush_block = _tr_flush_block;
trees$1._tr_tally = _tr_tally;
trees$1._tr_align = _tr_align;
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32$2(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
var adler32_1 = adler32$2;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32$2(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
var crc32_1 = crc32$2;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils$2 = common;
var trees = trees$1;
var adler32$1 = adler32_1;
var crc32$1 = crc32_1;
var msg = messages;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH$1 = 4;
var Z_BLOCK$1 = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK$1 = 0;
var Z_STREAM_END$1 = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR$1 = -2;
var Z_DATA_ERROR$1 = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR$1 = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED$1 = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS$1 = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var BS_BLOCK_DONE = 2; /* block flush performed */ 
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils$2.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    utils$2.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32$1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32$1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils$2.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/ ) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED$1; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils$2.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils$2.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils$2.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils$2.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils$2.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils$2.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR$1);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK$1;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK$1) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR$1;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR$1;
    strm.state.gzhead = head;
    return Z_OK$1;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) // === Z_NULL
    return Z_STREAM_ERROR$1;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        /* suppress zlib wrapper */ wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$1 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR$1);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils$2.Buf8(s.w_size * 2);
    s.head = new utils$2.Buf16(s.hash_size);
    s.prev = new utils$2.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils$2.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED$1, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK$1 || flush < 0) return strm ? err(strm, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH$1) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                // s->gzhead == Z_NULL
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else // DEFLATE header
        {
            var header = Z_DEFLATED$1 + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK$1;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$1) return err(strm, Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR$1);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK$1;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK$1) {
                /* FULL_FLUSH or SYNC_FLUSH */ trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK$1;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH$1) return Z_OK$1;
    if (s.wrap <= 0) return Z_STREAM_END$1;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK$1 : Z_STREAM_END$1;
}
function deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR$1;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR$1);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$1) : Z_OK$1;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR$1;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR$1;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /* already empty otherwise */ /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils$2.Buf8(s.w_size);
        utils$2.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK$1;
}
deflate$1.deflateInit = deflateInit;
deflate$1.deflateInit2 = deflateInit2;
deflate$1.deflateReset = deflateReset;
deflate$1.deflateResetKeep = deflateResetKeep;
deflate$1.deflateSetHeader = deflateSetHeader;
deflate$1.deflate = deflate;
deflate$1.deflateEnd = deflateEnd;
deflate$1.deflateSetDictionary = deflateSetDictionary;
deflate$1.deflateInfo = "pako deflate (from Nodeca project)";
var inflate$1 = {};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD$1 = 30; /* got a data error -- remain here until reset */ 
var TYPE$1 = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var inffast = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            // Goto emulation
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) /* literal */ //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                /* length base */ len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    // goto emulation
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        /* distance base */ dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            /* see if copy from window */ op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                /* very common case */ from += wsize - op;
                                if (op < len) {
                                    /* some from window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                /* wrap around window */ from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    /* some from end of window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        /* some from start of window */ op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                /* contiguous in window */ from += wnext - op;
                                if (op < len) {
                                    /* some from window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                /* minimum length is three */ output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        /* 2nd level distance code */ here = dcode[(here & 0xffff /*here.val*/ ) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                /* 2nd level length code */ here = lcode[(here & 0xffff /*here.val*/ ) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                /* end-of-block */ //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils$1 = common;
var MAXBITS = 15;
var ENOUGH_LENS$1 = 852;
var ENOUGH_DISTS$1 = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES$1 = 0;
var LENS$1 = 1;
var DISTS$1 = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
var inftrees = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new utils$1.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils$1.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.
    This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.
    The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.
    The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        /* no symbols to code at all */ //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.
    root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.
    When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.
    used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.
    sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS$1) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        /* DISTS */ base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = common;
var adler32 = adler32_1;
var crc32 = crc32_1;
var inflate_fast = inffast;
var inflate_table = inftrees;
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var TIME = 3; /* i: waiting for modification time (gzip) */ 
var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var NAME = 7; /* i: waiting for end of file name (gzip) */ 
var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var HCRC = 9; /* i: waiting for header crc (gzip) */ 
var DICTID = 10; /* i: waiting for dictionary check value */ 
var DICT = 11; /* waiting for inflateSetDictionary() call */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var STORED = 14; /* i: waiting for stored size (length and complement) */ 
var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var LENLENS = 18; /* i: waiting for code length code lengths */ 
var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var LEN = 21; /* i: waiting for length/lit/eob code */ 
var LENEXT = 22; /* i: waiting for length extra bits */ 
var DIST = 23; /* i: waiting for distance code */ 
var DISTEXT = 24; /* i: waiting for distance extra bits */ 
var MATCH = 25; /* o: waiting for output space to copy string */ 
var LIT = 26; /* o: waiting for output space to write literal */ 
var CHECK = 27; /* i: waiting for 32-bit check value */ 
var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var DONE = 29; /* finished check, done -- remain here until reset */ 
var BAD = 30; /* got a data error -- remain here until reset */ 
var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new utils.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) /* to support ill-conceived Java test suite */ strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: // goto emulation
    for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */ state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff /*BITS(8)*/ ) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f /*BITS(4)*/ ) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f /*BITS(4)*/ ) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03 /*BITS(2)*/ ){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f /*BITS(5)*/ ) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f /*BITS(5)*/ ) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f /*BITS(4)*/ ) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/ ) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/ ) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                /* copy from window */ copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                /* copy from output */ from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
inflate$1.inflateReset = inflateReset;
inflate$1.inflateReset2 = inflateReset2;
inflate$1.inflateResetKeep = inflateResetKeep;
inflate$1.inflateInit = inflateInit;
inflate$1.inflateInit2 = inflateInit2;
inflate$1.inflate = inflate;
inflate$1.inflateEnd = inflateEnd;
inflate$1.inflateGetHeader = inflateGetHeader;
inflate$1.inflateSetDictionary = inflateSetDictionary;
inflate$1.inflateInfo = "pako inflate (from Nodeca project)";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var constants = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
(function(exports) {
    /* eslint camelcase: "off" */ var assert = require$$4;
    var Zstream = zstream;
    var zlib_deflate = deflate$1;
    var zlib_inflate = inflate$1;
    var constants$1 = constants;
    for(var key in constants$1)exports[key] = constants$1[key];
    // zlib modes
    exports.NONE = 0;
    exports.DEFLATE = 1;
    exports.INFLATE = 2;
    exports.GZIP = 3;
    exports.GUNZIP = 4;
    exports.DEFLATERAW = 5;
    exports.INFLATERAW = 6;
    exports.UNZIP = 7;
    var GZIP_HEADER_ID1 = 0x1f;
    var GZIP_HEADER_ID2 = 0x8b;
    /**
   * Emulate Node's zlib C++ layer for use by the JS layer in index.js
   */ function Zlib(mode) {
        if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null;
        this.err = 0;
        this.flush = 0;
        this.init_done = false;
        this.level = 0;
        this.memLevel = 0;
        this.mode = mode;
        this.strategy = 0;
        this.windowBits = 0;
        this.write_in_progress = false;
        this.pending_close = false;
        this.gzip_id_bytes_read = 0;
    }
    Zlib.prototype.close = function() {
        if (this.write_in_progress) {
            this.pending_close = true;
            return;
        }
        this.pending_close = false;
        assert(this.init_done, "close before init");
        assert(this.mode <= exports.UNZIP);
        if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
        else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
        this.mode = exports.NONE;
        this.dictionary = null;
    };
    Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
        assert.equal(arguments.length, 8);
        assert(this.init_done, "write before init");
        assert(this.mode !== exports.NONE, "already finalized");
        assert.equal(false, this.write_in_progress, "write already in progress");
        assert.equal(false, this.pending_close, "close is pending");
        this.write_in_progress = true;
        assert.equal(false, flush === undefined, "must provide flush value");
        this.write_in_progress = true;
        if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
        if (input == null) {
            input = Buffer.alloc(0);
            in_len = 0;
            in_off = 0;
        }
        this.strm.avail_in = in_len;
        this.strm.input = input;
        this.strm.next_in = in_off;
        this.strm.avail_out = out_len;
        this.strm.output = out;
        this.strm.next_out = out_off;
        this.flush = flush;
        if (!async) {
            // sync version
            this._process();
            if (this._checkError()) return this._afterSync();
            return;
        }
        // async version
        var self1 = this;
        browser$1.nextTick(function() {
            self1._process();
            self1._after();
        });
        return this;
    };
    Zlib.prototype._afterSync = function() {
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        return [
            avail_in,
            avail_out
        ];
    };
    Zlib.prototype._process = function() {
        var next_expected_header_byte = null;
        // If the avail_out is left at 0, then it means that it ran out
        // of room.  If there was avail_out left over, then it means
        // that all of the input was consumed.
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflate(this.strm, this.flush);
                break;
            case exports.UNZIP:
                if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                switch(this.gzip_id_bytes_read){
                    case 0:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                            this.gzip_id_bytes_read = 1;
                            next_expected_header_byte++;
                            if (this.strm.avail_in === 1) break;
                        } else {
                            this.mode = exports.INFLATE;
                            break;
                        }
                    // fallthrough
                    case 1:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                            this.gzip_id_bytes_read = 2;
                            this.mode = exports.GUNZIP;
                        } else // There is no actual difference between INFLATE and INFLATERAW
                        // (after initialization).
                        this.mode = exports.INFLATE;
                        break;
                    default:
                        throw new Error("invalid number of gzip magic number bytes read");
                }
            // fallthrough
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                    // Load it
                    this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                    if (this.err === exports.Z_OK) // And try to decode again
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                    else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                    // Make it possible for After() to tell a bad dictionary from bad
                    // input.
                    this.err = exports.Z_NEED_DICT;
                }
                while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                    // Bytes remain in input buffer. Perhaps this is another compressed
                    // member in the same archive, or just trailing garbage.
                    // Trailing zero bytes are okay, though, since they are frequently
                    // used for padding.
                    this.reset();
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                }
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
    };
    Zlib.prototype._checkError = function() {
        // Acceptable error states depend on the type of zlib stream.
        switch(this.err){
            case exports.Z_OK:
            case exports.Z_BUF_ERROR:
                if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                    this._error("unexpected end of file");
                    return false;
                }
                break;
            case exports.Z_STREAM_END:
                break;
            case exports.Z_NEED_DICT:
                if (this.dictionary == null) this._error("Missing dictionary");
                else this._error("Bad dictionary");
                return false;
            default:
                // something else.
                this._error("Zlib error");
                return false;
        }
        return true;
    };
    Zlib.prototype._after = function() {
        if (!this._checkError()) return;
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        // call the write() cb
        this.callback(avail_in, avail_out);
        if (this.pending_close) this.close();
    };
    Zlib.prototype._error = function(message) {
        if (this.strm.msg) message = this.strm.msg;
        this.onerror(message, this.err);
        this.write_in_progress = false;
        if (this.pending_close) this.close();
    };
    Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
        assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
        assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
        assert(level >= -1 && level <= 9, "invalid compression level");
        assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
        assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
        this._init(level, windowBits, memLevel, strategy, dictionary);
        this._setDictionary();
    };
    Zlib.prototype.params = function() {
        throw new Error("deflateParams Not supported");
    };
    Zlib.prototype.reset = function() {
        this._reset();
        this._setDictionary();
    };
    Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
        this.level = level;
        this.windowBits = windowBits;
        this.memLevel = memLevel;
        this.strategy = strategy;
        this.flush = exports.Z_NO_FLUSH;
        this.err = exports.Z_OK;
        if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
        if (this.mode === exports.UNZIP) this.windowBits += 32;
        if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
        this.strm = new Zstream();
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                break;
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
            case exports.UNZIP:
                this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
        if (this.err !== exports.Z_OK) this._error("Init error");
        this.dictionary = dictionary;
        this.write_in_progress = false;
        this.init_done = true;
    };
    Zlib.prototype._setDictionary = function() {
        if (this.dictionary == null) return;
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
    };
    Zlib.prototype._reset = function() {
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
            case exports.GZIP:
                this.err = zlib_deflate.deflateReset(this.strm);
                break;
            case exports.INFLATE:
            case exports.INFLATERAW:
            case exports.GUNZIP:
                this.err = zlib_inflate.inflateReset(this.strm);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
    };
    exports.Zlib = Zlib;
})(binding);
var require$$3 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_util$1);
(function(exports) {
    var Buffer = require$$0.Buffer;
    var Transform = require$$1.Transform;
    var binding$1 = binding;
    var util = require$$3;
    var assert = require$$4.ok;
    var kMaxLength = require$$0.kMaxLength;
    var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
    // zlib doesn't provide these, so kludge them in following the same
    // const naming scheme zlib uses.
    binding$1.Z_MIN_WINDOWBITS = 8;
    binding$1.Z_MAX_WINDOWBITS = 15;
    binding$1.Z_DEFAULT_WINDOWBITS = 15;
    // fewer than 64 bytes per chunk is stupid.
    // technically it could work with as few as 8, but even 64 bytes
    // is absurdly low.  Usually a MB or more is best.
    binding$1.Z_MIN_CHUNK = 64;
    binding$1.Z_MAX_CHUNK = Infinity;
    binding$1.Z_DEFAULT_CHUNK = 16384;
    binding$1.Z_MIN_MEMLEVEL = 1;
    binding$1.Z_MAX_MEMLEVEL = 9;
    binding$1.Z_DEFAULT_MEMLEVEL = 8;
    binding$1.Z_MIN_LEVEL = -1;
    binding$1.Z_MAX_LEVEL = 9;
    binding$1.Z_DEFAULT_LEVEL = binding$1.Z_DEFAULT_COMPRESSION;
    // expose all the zlib constants
    var bkeys = Object.keys(binding$1);
    for(var bk = 0; bk < bkeys.length; bk++){
        var bkey = bkeys[bk];
        if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
            enumerable: true,
            value: binding$1[bkey],
            writable: false
        });
    }
    // translation table for return codes.
    var codes = {
        Z_OK: binding$1.Z_OK,
        Z_STREAM_END: binding$1.Z_STREAM_END,
        Z_NEED_DICT: binding$1.Z_NEED_DICT,
        Z_ERRNO: binding$1.Z_ERRNO,
        Z_STREAM_ERROR: binding$1.Z_STREAM_ERROR,
        Z_DATA_ERROR: binding$1.Z_DATA_ERROR,
        Z_MEM_ERROR: binding$1.Z_MEM_ERROR,
        Z_BUF_ERROR: binding$1.Z_BUF_ERROR,
        Z_VERSION_ERROR: binding$1.Z_VERSION_ERROR
    };
    var ckeys = Object.keys(codes);
    for(var ck = 0; ck < ckeys.length; ck++){
        var ckey = ckeys[ck];
        codes[codes[ckey]] = ckey;
    }
    Object.defineProperty(exports, "codes", {
        enumerable: true,
        value: Object.freeze(codes),
        writable: false
    });
    exports.Deflate = Deflate;
    exports.Inflate = Inflate;
    exports.Gzip = Gzip;
    exports.Gunzip = Gunzip;
    exports.DeflateRaw = DeflateRaw;
    exports.InflateRaw = InflateRaw;
    exports.Unzip = Unzip;
    exports.createDeflate = function(o) {
        return new Deflate(o);
    };
    exports.createInflate = function(o) {
        return new Inflate(o);
    };
    exports.createDeflateRaw = function(o) {
        return new DeflateRaw(o);
    };
    exports.createInflateRaw = function(o) {
        return new InflateRaw(o);
    };
    exports.createGzip = function(o) {
        return new Gzip(o);
    };
    exports.createGunzip = function(o) {
        return new Gunzip(o);
    };
    exports.createUnzip = function(o) {
        return new Unzip(o);
    };
    // Convenience methods.
    // compress/decompress a string or buffer in one step.
    exports.deflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Deflate(opts), buffer, callback);
    };
    exports.deflateSync = function(buffer, opts) {
        return zlibBufferSync(new Deflate(opts), buffer);
    };
    exports.gzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gzip(opts), buffer, callback);
    };
    exports.gzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gzip(opts), buffer);
    };
    exports.deflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new DeflateRaw(opts), buffer, callback);
    };
    exports.deflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new DeflateRaw(opts), buffer);
    };
    exports.unzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Unzip(opts), buffer, callback);
    };
    exports.unzipSync = function(buffer, opts) {
        return zlibBufferSync(new Unzip(opts), buffer);
    };
    exports.inflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Inflate(opts), buffer, callback);
    };
    exports.inflateSync = function(buffer, opts) {
        return zlibBufferSync(new Inflate(opts), buffer);
    };
    exports.gunzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gunzip(opts), buffer, callback);
    };
    exports.gunzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gunzip(opts), buffer);
    };
    exports.inflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new InflateRaw(opts), buffer, callback);
    };
    exports.inflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new InflateRaw(opts), buffer);
    };
    function zlibBuffer(engine, buffer, callback) {
        var buffers = [];
        var nread = 0;
        engine.on("error", onError);
        engine.on("end", onEnd);
        engine.end(buffer);
        flow();
        function flow() {
            var chunk;
            while(null !== (chunk = engine.read())){
                buffers.push(chunk);
                nread += chunk.length;
            }
            engine.once("readable", flow);
        }
        function onError(err) {
            engine.removeListener("end", onEnd);
            engine.removeListener("readable", flow);
            callback(err);
        }
        function onEnd() {
            var buf;
            var err = null;
            if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
            else buf = Buffer.concat(buffers, nread);
            buffers = [];
            engine.close();
            callback(err, buf);
        }
    }
    function zlibBufferSync(engine, buffer) {
        if (typeof buffer === "string") buffer = Buffer.from(buffer);
        if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
        var flushFlag = engine._finishFlushFlag;
        return engine._processChunk(buffer, flushFlag);
    }
    // generic zlib
    // minimal 2-byte header
    function Deflate(opts) {
        if (!(this instanceof Deflate)) return new Deflate(opts);
        Zlib.call(this, opts, binding$1.DEFLATE);
    }
    function Inflate(opts) {
        if (!(this instanceof Inflate)) return new Inflate(opts);
        Zlib.call(this, opts, binding$1.INFLATE);
    }
    // gzip - bigger header, same deflate compression
    function Gzip(opts) {
        if (!(this instanceof Gzip)) return new Gzip(opts);
        Zlib.call(this, opts, binding$1.GZIP);
    }
    function Gunzip(opts) {
        if (!(this instanceof Gunzip)) return new Gunzip(opts);
        Zlib.call(this, opts, binding$1.GUNZIP);
    }
    // raw - no header
    function DeflateRaw(opts) {
        if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
        Zlib.call(this, opts, binding$1.DEFLATERAW);
    }
    function InflateRaw(opts) {
        if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
        Zlib.call(this, opts, binding$1.INFLATERAW);
    }
    // auto-detect header.
    function Unzip(opts) {
        if (!(this instanceof Unzip)) return new Unzip(opts);
        Zlib.call(this, opts, binding$1.UNZIP);
    }
    function isValidFlushFlag(flag) {
        return flag === binding$1.Z_NO_FLUSH || flag === binding$1.Z_PARTIAL_FLUSH || flag === binding$1.Z_SYNC_FLUSH || flag === binding$1.Z_FULL_FLUSH || flag === binding$1.Z_FINISH || flag === binding$1.Z_BLOCK;
    }
    // the Zlib class they all inherit from
    // This thing manages the queue of requests, and returns
    // true or false if there is anything in the queue when
    // you call the .write() method.
    function Zlib(opts, mode) {
        var _this = this;
        this._opts = opts = opts || {};
        this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
        Transform.call(this, opts);
        if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
        if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
        this._flushFlag = opts.flush || binding$1.Z_NO_FLUSH;
        this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding$1.Z_FINISH;
        if (opts.chunkSize) {
            if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
        }
        if (opts.windowBits) {
            if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
        }
        if (opts.level) {
            if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
        }
        if (opts.memLevel) {
            if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
        }
        if (opts.strategy) {
            if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
        }
        if (opts.dictionary) {
            if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
        }
        this._handle = new binding$1.Zlib(mode);
        var self1 = this;
        this._hadError = false;
        this._handle.onerror = function(message, errno) {
            // there is no way to cleanly recover.
            // continuing only obscures problems.
            _close(self1);
            self1._hadError = true;
            var error = new Error(message);
            error.errno = errno;
            error.code = exports.codes[errno];
            self1.emit("error", error);
        };
        var level = exports.Z_DEFAULT_COMPRESSION;
        if (typeof opts.level === "number") level = opts.level;
        var strategy = exports.Z_DEFAULT_STRATEGY;
        if (typeof opts.strategy === "number") strategy = opts.strategy;
        this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
        this._buffer = Buffer.allocUnsafe(this._chunkSize);
        this._offset = 0;
        this._level = level;
        this._strategy = strategy;
        this.once("end", this.close);
        Object.defineProperty(this, "_closed", {
            get: function get() {
                return !_this._handle;
            },
            configurable: true,
            enumerable: true
        });
    }
    util.inherits(Zlib, Transform);
    Zlib.prototype.params = function(level, strategy, callback) {
        if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
        if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
        if (this._level !== level || this._strategy !== strategy) {
            var self1 = this;
            this.flush(binding$1.Z_SYNC_FLUSH, function() {
                assert(self1._handle, "zlib binding closed");
                self1._handle.params(level, strategy);
                if (!self1._hadError) {
                    self1._level = level;
                    self1._strategy = strategy;
                    if (callback) callback();
                }
            });
        } else browser$1.nextTick(callback);
    };
    Zlib.prototype.reset = function() {
        assert(this._handle, "zlib binding closed");
        return this._handle.reset();
    };
    // This is the _flush function called by the transform class,
    // internally, when the last chunk has been written.
    Zlib.prototype._flush = function(callback) {
        this._transform(Buffer.alloc(0), "", callback);
    };
    Zlib.prototype.flush = function(kind, callback) {
        var _this2 = this;
        var ws = this._writableState;
        if (typeof kind === "function" || kind === undefined && !callback) {
            callback = kind;
            kind = binding$1.Z_FULL_FLUSH;
        }
        if (ws.ended) {
            if (callback) browser$1.nextTick(callback);
        } else if (ws.ending) {
            if (callback) this.once("end", callback);
        } else if (ws.needDrain) {
            if (callback) this.once("drain", function() {
                return _this2.flush(kind, callback);
            });
        } else {
            this._flushFlag = kind;
            this.write(Buffer.alloc(0), "", callback);
        }
    };
    Zlib.prototype.close = function(callback) {
        _close(this, callback);
        browser$1.nextTick(emitCloseNT, this);
    };
    function _close(engine, callback) {
        if (callback) browser$1.nextTick(callback);
        // Caller may invoke .close after a zlib error (which will null _handle).
        if (!engine._handle) return;
        engine._handle.close();
        engine._handle = null;
    }
    function emitCloseNT(self1) {
        self1.emit("close");
    }
    Zlib.prototype._transform = function(chunk, encoding, cb) {
        var flushFlag;
        var ws = this._writableState;
        var ending = ws.ending || ws.ended;
        var last = ending && (!chunk || ws.length === chunk.length);
        if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
        if (!this._handle) return cb(new Error("zlib binding closed"));
        // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
        // (or whatever flag was provided using opts.finishFlush).
        // If it's explicitly flushing at some other time, then we use
        // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
        // goodness.
        if (last) flushFlag = this._finishFlushFlag;
        else {
            flushFlag = this._flushFlag;
            // once we've flushed the last of the queue, stop flushing and
            // go back to the normal behavior.
            if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding$1.Z_NO_FLUSH;
        }
        this._processChunk(chunk, flushFlag, cb);
    };
    Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
        var availInBefore = chunk && chunk.length;
        var availOutBefore = this._chunkSize - this._offset;
        var inOff = 0;
        var self1 = this;
        var async = typeof cb === "function";
        if (!async) {
            var buffers = [];
            var nread = 0;
            var error;
            this.on("error", function(er) {
                error = er;
            });
            assert(this._handle, "zlib binding closed");
            do var res = this._handle.writeSync(flushFlag, chunk, // in
            inOff, // in_off
            availInBefore, // in_len
            this._buffer, // out
            this._offset, //out_off
            availOutBefore); // out_len
            while (!this._hadError && callback(res[0], res[1]));
            if (this._hadError) throw error;
            if (nread >= kMaxLength) {
                _close(this);
                throw new RangeError(kRangeErrorMessage);
            }
            var buf = Buffer.concat(buffers, nread);
            _close(this);
            return buf;
        }
        assert(this._handle, "zlib binding closed");
        var req = this._handle.write(flushFlag, chunk, // in
        inOff, // in_off
        availInBefore, // in_len
        this._buffer, // out
        this._offset, //out_off
        availOutBefore); // out_len
        req.buffer = chunk;
        req.callback = callback;
        function callback(availInAfter, availOutAfter) {
            // When the callback is used in an async write, the callback's
            // context is the `req` object that was created. The req object
            // is === this._handle, and that's why it's important to null
            // out the values after they are done being used. `this._handle`
            // can stay in memory longer than the callback and buffer are needed.
            if (this) {
                this.buffer = null;
                this.callback = null;
            }
            if (self1._hadError) return;
            var have = availOutBefore - availOutAfter;
            assert(have >= 0, "have should not go down");
            if (have > 0) {
                var out = self1._buffer.slice(self1._offset, self1._offset + have);
                self1._offset += have;
                // serve some output to the consumer.
                if (async) self1.push(out);
                else {
                    buffers.push(out);
                    nread += out.length;
                }
            }
            // exhausted the output buffer, or used all the input create a new one.
            if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                availOutBefore = self1._chunkSize;
                self1._offset = 0;
                self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
            }
            if (availOutAfter === 0) {
                // Not actually done.  Need to reprocess.
                // Also, update the availInBefore to the availInAfter value,
                // so that if we have to hit it a third (fourth, etc.) time,
                // it'll have the correct byte counts.
                inOff += availInBefore - availInAfter;
                availInBefore = availInAfter;
                if (!async) return true;
                var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                newReq.callback = callback; // this same function
                newReq.buffer = chunk;
                return;
            }
            if (!async) return false;
            // finished with the chunk.
            cb();
        }
    };
    util.inherits(Deflate, Zlib);
    util.inherits(Inflate, Zlib);
    util.inherits(Gzip, Zlib);
    util.inherits(Gunzip, Zlib);
    util.inherits(DeflateRaw, Zlib);
    util.inherits(InflateRaw, Zlib);
    util.inherits(Unzip, Zlib);
})(lib);
var zlib = /*@__PURE__*/ getDefaultExportFromCjs(lib);
var PNG = /*#__PURE__*/ function() {
    PNG.decode = function decode(path, fn) {
        throw new Error("PNG.decode not available in browser build");
    };
    PNG.load = function load(path) {
        throw new Error("PNG.load not available in browser build");
    };
    function PNG(data) {
        var i;
        this.data = data;
        this.pos = 8; // Skip the default header
        this.palette = [];
        this.imgData = [];
        this.transparency = {};
        this.text = {};
        while(true){
            var chunkSize = this.readUInt32();
            var section = "";
            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
            switch(section){
                case "IHDR":
                    // we can grab  interesting values from here (like width, height, etc)
                    this.width = this.readUInt32();
                    this.height = this.readUInt32();
                    this.bits = this.data[this.pos++];
                    this.colorType = this.data[this.pos++];
                    this.compressionMethod = this.data[this.pos++];
                    this.filterMethod = this.data[this.pos++];
                    this.interlaceMethod = this.data[this.pos++];
                    break;
                case "PLTE":
                    this.palette = this.read(chunkSize);
                    break;
                case "IDAT":
                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    // This chunk can only occur once and it must occur after the
                    // PLTE chunk and before the IDAT chunk.
                    this.transparency = {};
                    switch(this.colorType){
                        case 3:
                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                            // the palette index in the PLTE ("palette") chunk up until the
                            // last non-opaque entry. Set up an array, stretching over all
                            // palette entries which will be 0 (opaque) or 1 (transparent).
                            this.transparency.indexed = this.read(chunkSize);
                            var short = 255 - this.transparency.indexed.length;
                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            // Greyscale. Corresponding to entries in the PLTE chunk.
                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                            this.transparency.grayscale = this.read(chunkSize)[0];
                            break;
                        case 2:
                            // True color with proper alpha channel.
                            this.transparency.rgb = this.read(chunkSize);
                            break;
                    }
                    break;
                case "tEXt":
                    var text = this.read(chunkSize);
                    var index = text.indexOf(0);
                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                    break;
                case "IEND":
                    // we've got everything we need!
                    switch(this.colorType){
                        case 0:
                        case 3:
                        case 4:
                            this.colors = 1;
                            break;
                        case 2:
                        case 6:
                            this.colors = 3;
                            break;
                    }
                    this.hasAlphaChannel = [
                        4,
                        6
                    ].includes(this.colorType);
                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                    this.pixelBitlength = this.bits * colors;
                    switch(this.colors){
                        case 1:
                            this.colorSpace = "DeviceGray";
                            break;
                        case 3:
                            this.colorSpace = "DeviceRGB";
                            break;
                    }
                    this.imgData = Buffer.from(this.imgData);
                    return;
                default:
                    // unknown (or unimportant) section, skip it
                    this.pos += chunkSize;
            }
            this.pos += 4; // Skip the CRC
            if (this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    var _proto = PNG.prototype;
    _proto.read = function read(bytes) {
        var result = new Array(bytes);
        for(var i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
        return result;
    };
    _proto.readUInt32 = function readUInt32() {
        var b1 = this.data[this.pos++] << 24;
        var b2 = this.data[this.pos++] << 16;
        var b3 = this.data[this.pos++] << 8;
        var b4 = this.data[this.pos++];
        return b1 | b2 | b3 | b4;
    };
    _proto.readUInt16 = function readUInt16() {
        var b1 = this.data[this.pos++] << 8;
        var b2 = this.data[this.pos++];
        return b1 | b2;
    };
    _proto.decodePixels = function decodePixels(fn) {
        var _this = this;
        return zlib.inflate(this.imgData, function(err, data) {
            if (err) throw err;
            var pos = 0;
            var width = _this.width, height = _this.height;
            var pixelBytes = _this.pixelBitlength / 8;
            var pixels = Buffer.alloc(width * height * pixelBytes);
            function pass(x0, y0, dx, dy, singlePass) {
                if (singlePass === void 0) singlePass = false;
                var w = Math.ceil((width - x0) / dx);
                var h = Math.ceil((height - y0) / dy);
                var scanlineLength = pixelBytes * w;
                var buffer = singlePass ? pixels : Buffer.alloc(scanlineLength * h);
                var row = 0;
                var c = 0;
                while(row < h && pos < data.length){
                    var byte;
                    var col;
                    var i;
                    var left;
                    var upper;
                    switch(data[pos++]){
                        case 0:
                            // None
                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                            break;
                        case 1:
                            // Sub
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                buffer[c++] = (byte + left) % 256;
                            }
                            break;
                        case 2:
                            // Up
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (upper + byte) % 256;
                            }
                            break;
                        case 3:
                            // Average
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                            }
                            break;
                        case 4:
                            // Paeth
                            for(i = 0; i < scanlineLength; i++){
                                var paeth;
                                var upperLeft;
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                if (row === 0) upper = upperLeft = 0;
                                else {
                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                }
                                var p = left + upper - upperLeft;
                                var pa = Math.abs(p - left);
                                var pb = Math.abs(p - upper);
                                var pc = Math.abs(p - upperLeft);
                                if (pa <= pb && pa <= pc) paeth = left;
                                else if (pb <= pc) paeth = upper;
                                else paeth = upperLeft;
                                buffer[c++] = (byte + paeth) % 256;
                            }
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + data[pos - 1]);
                    }
                    if (!singlePass) {
                        var pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                        var bufferPos = row * scanlineLength;
                        for(i = 0; i < w; i++){
                            for(var j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                            pixelsPos += (dx - 1) * pixelBytes;
                        }
                    }
                    row++;
                }
            }
            if (_this.interlaceMethod === 1) {
                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                pass(4, 0, 8, 8); // 2
                pass(0, 4, 4, 8); // 3
                pass(2, 0, 4, 4); // 4
                pass(0, 2, 2, 4); // 5
                pass(1, 0, 2, 2); // 6
                pass(0, 1, 1, 2); // 7
            } else pass(0, 0, 1, 1, true);
            return fn(pixels);
        });
    };
    _proto.decodePalette = function decodePalette() {
        var palette = this.palette;
        var length = palette.length;
        var transparency = this.transparency.indexed || [];
        var ret = Buffer.alloc(transparency.length + length);
        var pos = 0;
        var c = 0;
        for(var i = 0; i < length; i += 3){
            var left;
            ret[pos++] = palette[i];
            ret[pos++] = palette[i + 1];
            ret[pos++] = palette[i + 2];
            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
        }
        return ret;
    };
    _proto.copyToImageData = function copyToImageData(imageData, pixels) {
        var j;
        var k;
        var colors = this.colors;
        var palette = null;
        var alpha = this.hasAlphaChannel;
        if (this.palette.length) {
            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
            colors = 4;
            alpha = true;
        }
        var data = imageData.data || imageData;
        var length = data.length;
        var input = palette || pixels;
        var i = j = 0;
        if (colors === 1) while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            var v = input[k++];
            data[i++] = v;
            data[i++] = v;
            data[i++] = v;
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
        else while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
    };
    _proto.decode = function decode(fn) {
        var _this2 = this;
        var ret = Buffer.alloc(this.width * this.height * 4);
        return this.decodePixels(function(pixels) {
            _this2.copyToImageData(ret, pixels);
            return fn(ret);
        });
    };
    return PNG;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9jeDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>layout);
var _fns = require("@react-pdf/fns");
var _primitives = require("@react-pdf/primitives");
var _stylesheet = require("@react-pdf/stylesheet");
var _stylesheetDefault = parcelHelpers.interopDefault(_stylesheet);
var _textkit = require("@react-pdf/textkit");
var _textkitDefault = parcelHelpers.interopDefault(_textkit);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _pdfkit = require("@react-pdf/pdfkit");
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _emojiRegex = require("emoji-regex");
var _emojiRegexDefault = parcelHelpers.interopDefault(_emojiRegex);
var _image = require("@react-pdf/image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _yoga = require("@react-pdf/yoga");
var _yogaDefault = parcelHelpers.interopDefault(_yoga);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/**
 * Create attributed string from text fragments
 *
 * @param  {Array}  fragments
 * @return {Object} attributed string
 */ var fromFragments = function fromFragments(fragments) {
    var offset = 0;
    var string = "";
    var runs = [];
    fragments.forEach(function(fragment) {
        string += fragment.string;
        runs.push({
            start: offset,
            end: offset + fragment.string.length,
            attributes: fragment.attributes || {}
        });
        offset += fragment.string.length;
    });
    return {
        string: string,
        runs: runs
    };
};
/**
 * Apply transformation to text string
 *
 * @param {String} text
 * @param {String} transformation type
 * @returns {String} transformed text
 */ var transformText = function transformText(text, transformation) {
    switch(transformation){
        case "uppercase":
            return text.toUpperCase();
        case "lowercase":
            return text.toLowerCase();
        case "capitalize":
            return (0, _fns.capitalize)(text);
        case "upperfirst":
            return (0, _fns.upperFirst)(text);
        default:
            return text;
    }
};
var StandardFont = /*#__PURE__*/ function() {
    function StandardFont(src) {
        this.name = src;
        this.src = (0, _pdfkit.PDFFont).open(null, src);
    }
    var _proto = StandardFont.prototype;
    _proto.encode = function encode(str) {
        return this.src.encode(str);
    };
    _proto.layout = function layout(str) {
        var _this = this;
        var _this$encode = this.encode(str), encoded = _this$encode[0], positions = _this$encode[1];
        return {
            positions: positions,
            stringIndices: positions.map(function(_, i) {
                return i;
            }),
            glyphs: encoded.map(function(g, i) {
                var glyph = _this.getGlyph(parseInt(g, 16));
                glyph.advanceWidth = positions[i].advanceWidth;
                return glyph;
            })
        };
    };
    _proto.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        var glyph = this.getGlyph(codePoint);
        glyph.advanceWidth = 400;
        return glyph;
    };
    _proto.getGlyph = function getGlyph(id) {
        return {
            id: id,
            _font: this.src,
            codePoints: [
                id
            ],
            isLigature: false,
            name: this.src.font.characterToGlyph(id)
        };
    };
    _proto.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return this.src.font.characterToGlyph(codePoint) !== ".notdef";
    };
    (0, _createClassDefault.default)(StandardFont, [
        {
            key: "ascent",
            get: function get() {
                return 900;
            }
        },
        {
            key: "capHeight",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return 650;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return 550;
                    default:
                        return 690;
                }
            }
        },
        {
            key: "xHeight",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return 440;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return 390;
                    default:
                        return 490;
                }
            }
        },
        {
            key: "descent",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return -220;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return -230;
                    default:
                        return -200;
                }
            }
        },
        {
            key: "lineGap",
            get: function get() {
                return 0;
            }
        },
        {
            key: "unitsPerEm",
            get: function get() {
                return 1000;
            }
        }
    ]);
    return StandardFont;
}();
var fontCache = {};
var IGNORED_CODE_POINTS = [
    173
];
var getFontSize = function getFontSize(node) {
    return node.attributes.fontSize || 12;
};
var getOrCreateFont = function getOrCreateFont(name) {
    if (fontCache[name]) return fontCache[name];
    var font = new StandardFont(name);
    fontCache[name] = font;
    return font;
};
var getFallbackFont = function getFallbackFont() {
    return getOrCreateFont("Helvetica");
};
var shouldFallbackToFont = function shouldFallbackToFont(codePoint, font) {
    return !font || !IGNORED_CODE_POINTS.includes(codePoint) && !font.hasGlyphForCodePoint(codePoint) && getFallbackFont().hasGlyphForCodePoint(codePoint);
};
var fontSubstitution = function fontSubstitution() {
    return function(_ref) {
        var string = _ref.string, runs = _ref.runs;
        var lastFont = null;
        var lastFontSize = null;
        var lastIndex = 0;
        var index = 0;
        var res = [];
        for(var i = 0; i < runs.length; i += 1){
            var run = runs[i];
            var defaultFont = typeof run.attributes.font === "string" ? getOrCreateFont(run.attributes.font) : run.attributes.font;
            if (string.length === 0) {
                res.push({
                    start: 0,
                    end: 0,
                    attributes: {
                        font: defaultFont
                    }
                });
                break;
            }
            var chars = string.slice(run.start, run.end);
            for(var j = 0; j < chars.length; j += 1){
                var char = chars[j];
                var codePoint = char.codePointAt();
                var shouldFallback = shouldFallbackToFont(codePoint, defaultFont);
                // If the default font does not have a glyph and the fallback font does, we use it
                var font = shouldFallback ? getFallbackFont() : defaultFont;
                var fontSize = getFontSize(run);
                // If anything that would impact res has changed, update it
                if (font !== lastFont || fontSize !== lastFontSize || font.unitsPerEm !== lastFont.unitsPerEm) {
                    if (lastFont) res.push({
                        start: lastIndex,
                        end: index,
                        attributes: {
                            font: lastFont,
                            scale: lastFontSize / lastFont.unitsPerEm
                        }
                    });
                    lastFont = font;
                    lastFontSize = fontSize;
                    lastIndex = index;
                }
                index += char.length;
            }
        }
        if (lastIndex < string.length) {
            var _fontSize = getFontSize((0, _fns.last)(runs));
            res.push({
                start: lastIndex,
                end: string.length,
                attributes: {
                    font: lastFont,
                    scale: _fontSize / lastFont.unitsPerEm
                }
            });
        }
        return {
            string: string,
            runs: res
        };
    };
};
var isTextInstance$4 = function isTextInstance(node) {
    return node.type === _primitives.TextInstance;
};
var engines$1 = {
    linebreaker: (0, _textkit.linebreaker),
    justification: (0, _textkit.justification),
    textDecoration: (0, _textkit.textDecoration),
    scriptItemizer: (0, _textkit.scriptItemizer),
    wordHyphenation: (0, _textkit.wordHyphenation),
    fontSubstitution: fontSubstitution
};
var engine$1 = (0, _textkitDefault.default)(engines$1);
var getFragments$1 = function getFragments(fontStore, instance) {
    if (!instance) return [
        {
            string: ""
        }
    ];
    var fragments = [];
    var _instance$props = instance.props, _instance$props$fill = _instance$props.fill, fill = _instance$props$fill === void 0 ? "black" : _instance$props$fill, _instance$props$fontF = _instance$props.fontFamily, fontFamily = _instance$props$fontF === void 0 ? "Helvetica" : _instance$props$fontF, fontWeight = _instance$props.fontWeight, fontStyle = _instance$props.fontStyle, _instance$props$fontS = _instance$props.fontSize, fontSize = _instance$props$fontS === void 0 ? 18 : _instance$props$fontS, textDecorationColor = _instance$props.textDecorationColor, textDecorationStyle = _instance$props.textDecorationStyle, textTransform = _instance$props.textTransform, opacity = _instance$props.opacity;
    var _textDecoration = instance.props.textDecoration;
    var obj = fontStore ? fontStore.getFont({
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle
    }) : null;
    var font = obj ? obj.data : fontFamily;
    var attributes = {
        font: font,
        opacity: opacity,
        fontSize: fontSize,
        color: fill,
        underlineStyle: textDecorationStyle,
        underline: _textDecoration === "underline" || _textDecoration === "underline line-through" || _textDecoration === "line-through underline",
        underlineColor: textDecorationColor || fill,
        strike: _textDecoration === "line-through" || _textDecoration === "underline line-through" || _textDecoration === "line-through underline",
        strikeStyle: textDecorationStyle,
        strikeColor: textDecorationColor || fill
    };
    for(var i = 0; i < instance.children.length; i += 1){
        var child = instance.children[i];
        if (isTextInstance$4(child)) fragments.push({
            string: transformText(child.value, textTransform),
            attributes: attributes
        });
        else if (child) fragments.push.apply(fragments, getFragments(child));
    }
    return fragments;
};
var getAttributedString$1 = function getAttributedString(fontStore, instance) {
    return fromFragments(getFragments$1(fontStore, instance));
};
var AlmostInfinity = 999999999999;
var shrinkWhitespaceFactor = {
    before: -0.5,
    after: -0.5
};
var layoutTspan = function layoutTspan(fontStore) {
    return function(node) {
        var _node$props, _node$props2;
        var attributedString = getAttributedString$1(fontStore, node);
        var x = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.x) || 0;
        var y = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.y) || 0;
        var container = {
            x: x,
            y: y,
            width: AlmostInfinity,
            height: AlmostInfinity
        };
        var hyphenationCallback = node.props.hyphenationCallback || (fontStore === null || fontStore === void 0 ? void 0 : fontStore.getHyphenationCallback()) || null;
        var layoutOptions = {
            hyphenationCallback: hyphenationCallback,
            shrinkWhitespaceFactor: shrinkWhitespaceFactor
        };
        var lines = engine$1(attributedString, container, layoutOptions).flat();
        return Object.assign({}, node, {
            lines: lines
        });
    };
};
var layoutText$1 = function layoutText(fontStore, node) {
    if (!node.children) return node;
    var children = node.children.map(layoutTspan(fontStore));
    return Object.assign({}, node, {
        children: children
    });
};
var isDefs = function isDefs(node) {
    return node.type === _primitives.Defs;
};
var getDefs = function getDefs(node) {
    var children = node.children || [];
    var defs = children.find(isDefs) || {};
    var values = defs.children || [];
    return values.reduce(function(acc, value) {
        var _value$props;
        var id = (_value$props = value.props) === null || _value$props === void 0 ? void 0 : _value$props.id;
        if (id) acc[id] = value;
        return acc;
    }, {});
};
var isNotDefs = function isNotDefs(node) {
    return node.type !== _primitives.Defs;
};
var detachDefs = function detachDefs(node) {
    if (!node.children) return node;
    var children = node.children.filter(isNotDefs);
    return Object.assign({}, node, {
        children: children
    });
};
var URL_REGEX = /url\(['"]?#([^'"]+)['"]?\)/;
var replaceDef = function replaceDef(defs, value) {
    if (!value) return undefined;
    if (!URL_REGEX.test(value)) return value;
    var match = value.match(URL_REGEX);
    return defs[match[1]];
};
var parseNodeDefs = function parseNodeDefs(defs) {
    return function(node) {
        var _node$props, _node$props2;
        var fill = replaceDef(defs, (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.fill);
        var clipPath = replaceDef(defs, (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.clipPath);
        var props = Object.assign({}, node.props, {
            fill: fill,
            clipPath: clipPath
        });
        var children = node.children ? node.children.map(parseNodeDefs(defs)) : undefined;
        return Object.assign({}, node, {
            props: props,
            children: children
        });
    };
};
var parseDefs = function parseDefs(root) {
    if (!root.children) return root;
    var defs = getDefs(root);
    var children = root.children.map(parseNodeDefs(defs));
    return Object.assign({}, root, {
        children: children
    });
};
var replaceDefs = function replaceDefs(node) {
    return detachDefs(parseDefs(node));
};
var parseViewbox = function parseViewbox(value) {
    if (!value) return null;
    var values = value.split(/[,\s]+/).map(parseFloat);
    if (values.length !== 4) return null;
    return {
        minX: values[0],
        minY: values[1],
        maxX: values[2],
        maxY: values[3]
    };
};
var getContainer$1 = function getContainer(node) {
    var viewbox = parseViewbox(node.props.viewBox);
    if (viewbox) return {
        width: viewbox.maxX,
        height: viewbox.maxY
    };
    if (node.props.width && node.props.height) return {
        width: parseFloat(node.props.width),
        height: parseFloat(node.props.height)
    };
    return {
        width: 0,
        height: 0
    };
};
var SVG_INHERITED_PROPS = [
    "x",
    "y",
    "clipPath",
    "clipRule",
    "opacity",
    "fill",
    "fillOpacity",
    "fillRule",
    "stroke",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeOpacity",
    "strokeWidth",
    "textAnchor",
    "dominantBaseline",
    "color",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "opacity",
    "textDecoration",
    "lineHeight",
    "textAlign",
    "visibility",
    "wordSpacing"
];
var getInheritProps = function getInheritProps(node) {
    var props = node.props || {};
    return (0, _fns.pick)(SVG_INHERITED_PROPS, props);
};
var inheritProps = function inheritProps(node) {
    if (!node.children) return node;
    var inheritedProps = getInheritProps(node);
    var children = node.children.map(function(child) {
        var props = Object.assign({}, inheritedProps, child.props || {});
        var newChild = Object.assign({}, child, {
            props: props
        });
        return inheritProps(newChild);
    });
    return Object.assign({}, node, {
        children: children
    });
};
var parseAspectRatio = function parseAspectRatio(value) {
    var match = value.replace(/[\s\r\t\n]+/gm, " ").replace(/^defer\s/, "").split(" ");
    var align = match[0] || "xMidYMid";
    var meetOrSlice = match[1] || "meet";
    return {
        align: align,
        meetOrSlice: meetOrSlice
    };
};
var STYLE_PROPS = [
    "width",
    "height",
    "color",
    "stroke",
    "strokeWidth",
    "opacity",
    "fillOpacity",
    "strokeOpacity",
    "fill",
    "fillRule",
    "clipPath",
    "offset",
    "transform",
    "strokeLinejoin",
    "strokeLinecap",
    "strokeDasharray"
];
var VERTICAL_PROPS = [
    "y",
    "y1",
    "y2",
    "height",
    "cy",
    "ry"
];
var HORIZONTAL_PROPS = [
    "x",
    "x1",
    "x2",
    "width",
    "cx",
    "rx"
];
var isType$3 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg$3 = isType$3(_primitives.Svg);
var isText$4 = isType$3(_primitives.Text);
var isTextInstance$3 = isType$3(_primitives.TextInstance);
var transformPercent = function transformPercent(container) {
    return function(props) {
        return (0, _fns.mapValues)(props, function(value, key) {
            var match = (0, _fns.matchPercent)(value);
            if (match && VERTICAL_PROPS.includes(key)) return match.percent * container.height;
            if (match && HORIZONTAL_PROPS.includes(key)) return match.percent * container.width;
            return value;
        });
    };
};
var parsePercent = function parsePercent(value) {
    var match = (0, _fns.matchPercent)(value);
    return match ? match.percent : parseFloat(value);
};
var parseProps = function parseProps(container) {
    return function(node) {
        var props = transformPercent(container)(node.props);
        props = (0, _fns.evolve)({
            x: parseFloat,
            x1: parseFloat,
            x2: parseFloat,
            y: parseFloat,
            y1: parseFloat,
            y2: parseFloat,
            r: parseFloat,
            rx: parseFloat,
            ry: parseFloat,
            cx: parseFloat,
            cy: parseFloat,
            width: parseFloat,
            height: parseFloat,
            offset: parsePercent,
            fill: (0, _stylesheet.transformColor),
            opacity: parsePercent,
            stroke: (0, _stylesheet.transformColor),
            stopOpacity: parsePercent,
            stopColor: (0, _stylesheet.transformColor),
            transform: (0, _stylesheet.processTransform)
        }, props);
        return Object.assign({}, node, {
            props: props
        });
    };
};
var mergeStyles$1 = function mergeStyles(node) {
    var style = node.style || {};
    var props = Object.assign({}, style, node.props);
    return Object.assign({}, node, {
        props: props
    });
};
var removeNoneValues = function removeNoneValues(node) {
    var removeNone = function removeNone(value) {
        return value === "none" ? null : value;
    };
    var props = (0, _fns.mapValues)(node.props, removeNone);
    return Object.assign({}, node, {
        props: props
    });
};
var pickStyleProps = function pickStyleProps(node) {
    var props = node.props || {};
    var styleProps = (0, _fns.pick)(STYLE_PROPS, props);
    var style = Object.assign({}, styleProps, node.style || {});
    return Object.assign({}, node, {
        style: style
    });
};
var parseSvgProps = function parseSvgProps(node) {
    var props = (0, _fns.evolve)({
        width: parseFloat,
        height: parseFloat,
        viewBox: parseViewbox,
        preserveAspectRatio: parseAspectRatio
    }, node.props);
    return Object.assign({}, node, {
        props: props
    });
};
var wrapBetweenTspan = function wrapBetweenTspan(node) {
    return {
        type: _primitives.Tspan,
        props: {},
        children: [
            node
        ]
    };
};
var addMissingTspan = function addMissingTspan(node) {
    if (!isText$4(node)) return node;
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return isTextInstance$3(child) ? wrapBetweenTspan(child) : child;
    };
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var parseText = function parseText(fontStore) {
    return function(node) {
        if (isText$4(node)) return layoutText$1(fontStore, node);
        if (!node.children) return node;
        var children = node.children.map(parseText(fontStore));
        return Object.assign({}, node, {
            children: children
        });
    };
};
var resolveSvgNode = function resolveSvgNode(container) {
    return (0, _fns.compose)(parseProps(container), addMissingTspan, removeNoneValues, mergeStyles$1);
};
var resolveChildren = function resolveChildren(container) {
    return function(node) {
        if (!node.children) return node;
        var resolveChild = (0, _fns.compose)(resolveChildren(container), resolveSvgNode(container));
        var children = node.children.map(resolveChild);
        return Object.assign({}, node, {
            children: children
        });
    };
};
var resolveSvgRoot = function resolveSvgRoot(node, fontStore) {
    var container = getContainer$1(node);
    return (0, _fns.compose)(replaceDefs, parseText(fontStore), parseSvgProps, pickStyleProps, inheritProps, resolveChildren(container))(node);
};
/**
 * Pre-process SVG nodes so they can be rendered in the next steps
 *
 * @param {Object} root node
 * @param {Object} fontStore font store
 * @returns {Object} root node
 */ var resolveSvg = function resolveSvg(node, fontStore) {
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return resolveSvg(child, fontStore);
    };
    var root = isSvg$3(node) ? resolveSvgRoot(node, fontStore) : node;
    var children = root.children.map(resolveChild);
    return Object.assign({}, root, {
        children: children
    });
};
var getZIndex = function getZIndex(node) {
    return node.style.zIndex;
};
var shouldSort = function shouldSort(node) {
    return node.type !== _primitives.Document && node.type !== _primitives.Svg;
};
var sortZIndex = function sortZIndex(a, b) {
    var za = getZIndex(a);
    var zb = getZIndex(b);
    if (!za && !zb) return 0;
    if (!za) return 1;
    if (!zb) return -1;
    return zb - za;
};
/**
 * Sort children by zIndex value
 *
 * @param {Object} node
 * @returns {Object} node
 */ var resolveZIndex = function resolveZIndex(node) {
    if (!node.children) return node;
    var sortedChildren = shouldSort(node) ? node.children.sort(sortZIndex) : node.children;
    var children = sortedChildren.map(resolveZIndex);
    return Object.assign({}, node, {
        children: children
    });
};
// Caches emoji images data
var emojis = {};
var regex = (0, _emojiRegexDefault.default)();
var reflect = function reflect(promise) {
    return function() {
        return promise.apply(void 0, arguments).then(function(v) {
            return v;
        }, function(e) {
            return e;
        });
    };
};
// Returns a function to be able to mock resolveImage.
var makeFetchEmojiImage = function makeFetchEmojiImage() {
    return reflect((0, _imageDefault.default));
};
/**
 * When an emoji as no color, it might still have 2 parts,
 * the canonical emoji and an empty string.
 * ex.
 *   (no color) Array.from('❤️') => ["❤", "️"]
 *   (w/ color) Array.from('👍🏿') => ["👍", "🏿"]
 *
 * The empty string needs to be removed otherwise the generated
 * url will be incorect.
 */ var _removeNoColor = function _removeNoColor(x) {
    return x !== "\uFE0F";
};
var getCodePoints = function getCodePoints(string) {
    return Array.from(string).filter(_removeNoColor).map(function(char) {
        return char.codePointAt(0).toString(16);
    }).join("-");
};
var buildEmojiUrl = function buildEmojiUrl(emoji, source) {
    var url = source.url, format = source.format, builder = source.builder;
    if (typeof builder === "function") return builder(getCodePoints(emoji));
    return "" + url + getCodePoints(emoji) + "." + format;
};
var fetchEmojis = function fetchEmojis(string, source) {
    if (!source || !source.url && !source.builder) return [];
    var promises = [];
    Array.from(string.matchAll(regex)).forEach(function(match) {
        var emoji = match[0];
        if (!emojis[emoji] || emojis[emoji].loading) {
            var emojiUrl = buildEmojiUrl(emoji, source);
            emojis[emoji] = {
                loading: true
            };
            var fetchEmojiImage = makeFetchEmojiImage();
            promises.push(fetchEmojiImage({
                uri: emojiUrl
            }).then(function(image) {
                emojis[emoji].loading = false;
                emojis[emoji].data = image.data;
            }));
        }
    });
    return promises;
};
var embedEmojis = function embedEmojis(fragments) {
    var result = [];
    var _loop = function _loop() {
        var fragment = fragments[i];
        var lastIndex = 0;
        Array.from(fragment.string.matchAll(regex)).forEach(function(match) {
            var index = match.index;
            var emoji = match[0];
            var emojiSize = fragment.attributes.fontSize;
            var chunk = fragment.string.slice(lastIndex, index + match[0].length);
            // If emoji image was found, we create a new fragment with the
            // correct attachment and object substitution character;
            if (emojis[emoji] && emojis[emoji].data) result.push({
                string: chunk.replace(match, String.fromCharCode(0xfffc)),
                attributes: (0, _extendsDefault.default)({}, fragment.attributes, {
                    attachment: {
                        width: emojiSize,
                        height: emojiSize,
                        yOffset: Math.floor(emojiSize * 0.1),
                        image: emojis[emoji].data
                    }
                })
            });
            else // If no emoji data, we just replace the emoji with a nodef char
            result.push({
                string: chunk.replace(match, String.fromCharCode(0)),
                attributes: fragment.attributes
            });
            lastIndex = index + emoji.length;
        });
        if (lastIndex < fragment.string.length) result.push({
            string: fragment.string.slice(lastIndex),
            attributes: fragment.attributes
        });
    };
    for(var i = 0; i < fragments.length; i += 1)_loop();
    return result;
};
/**
 * Get image source
 *
 * @param {Object} image node
 * @returns {String | Object} image src
 */ var getSource = function getSource(node) {
    var _node$props, _node$props2, _node$props3;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.src) || ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.source) || ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.href);
};
/**
 * Resolves `src` to `@react-pdf/image` interface.
 *
 * Also it handles factories and async sources.
 *
 * @param {string | Object | Function} src
 * @returns {object} resolved src
 */ var resolveSource = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(src) {
        var source;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof src === "function")) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 3;
                    return src();
                case 3:
                    _context.t0 = _context.sent;
                    _context.next = 9;
                    break;
                case 6:
                    _context.next = 8;
                    return src;
                case 8:
                    _context.t0 = _context.sent;
                case 9:
                    source = _context.t0;
                    return _context.abrupt("return", typeof source === "string" ? {
                        uri: source
                    } : source);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveSource(_x) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetches image and append data to node
 * Ideally this fn should be immutable.
 *
 * @param {Object} node
 */ var fetchImage = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(node) {
        var src, cache, source;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    src = getSource(node);
                    cache = node.props.cache;
                    if (src) {
                        _context.next = 5;
                        break;
                    }
                    console.warn(false, 'Image should receive either a "src" or "source" prop');
                    return _context.abrupt("return");
                case 5:
                    _context.prev = 5;
                    _context.next = 8;
                    return resolveSource(src);
                case 8:
                    source = _context.sent;
                    if (source) {
                        _context.next = 11;
                        break;
                    }
                    throw new Error('Image\'s "src" or "source" prop returned ' + source);
                case 11:
                    _context.next = 13;
                    return (0, _imageDefault.default)(source, {
                        cache: cache
                    });
                case 13:
                    node.image = _context.sent;
                    node.image.key = source.data ? source.data.toString() : source.uri;
                    _context.next = 21;
                    break;
                case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](5);
                    node.image = {
                        width: 0,
                        height: 0,
                        key: null
                    };
                    console.warn(_context.t0.message);
                case 21:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                17
            ]
        ]);
    }));
    return function fetchImage(_x) {
        return _ref.apply(this, arguments);
    };
}();
var isImage$2 = function isImage(node) {
    return node.type === _primitives.Image;
};
/**
 * Get all asset promises that need to be resolved
 *
 * @param {Object} root node
 * @returns {Array} asset promises
 */ var fetchAssets = function fetchAssets(fontStore, node) {
    var _node$children;
    var promises = [];
    var listToExplore = ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.slice(0)) || [];
    var emojiSource = fontStore ? fontStore.getEmojiSource() : null;
    while(listToExplore.length > 0){
        var _n$style;
        var n = listToExplore.shift();
        if (isImage$2(n)) promises.push(fetchImage(n));
        if (fontStore && (_n$style = n.style) !== null && _n$style !== void 0 && _n$style.fontFamily) promises.push(fontStore.load(n.style));
        if (typeof n === "string") promises.push.apply(promises, fetchEmojis(n, emojiSource));
        if (typeof n.value === "string") promises.push.apply(promises, fetchEmojis(n.value, emojiSource));
        if (n.children) n.children.forEach(function(childNode) {
            listToExplore.push(childNode);
        });
    }
    return promises;
};
/**
 * Fetch image, font and emoji assets in parallel.
 * Layout process will not be resumed until promise resolves.
 *
 * @param {Object} root node
 * @param {Object} fontStore font store
 * @returns {Object} root node
 */ var resolveAssets = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(node, fontStore) {
        var promises;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    promises = fetchAssets(fontStore, node);
                    _context.next = 3;
                    return Promise.all(promises);
                case 3:
                    return _context.abrupt("return", node);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveAssets(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isLink$1 = function isLink(node) {
    return node.type === _primitives.Link;
};
var DEFAULT_LINK_STYLES = {
    color: "blue",
    textDecoration: "underline"
};
/**
 * Computes styles using stylesheet
 *
 * @param {Object} container
 * @param {Object} document node
 * @returns {Object} computed styles
 */ var computeStyle = function computeStyle(container, node) {
    var baseStyle = node.style;
    if (isLink$1(node)) baseStyle = Array.isArray(node.style) ? [
        DEFAULT_LINK_STYLES
    ].concat(node.style) : [
        DEFAULT_LINK_STYLES,
        node.style
    ];
    return (0, _stylesheetDefault.default)(container, baseStyle);
};
/**
 * Resolves node styles
 *
 * @param {Object} container
 * @param {Object} document node
 * @returns {Object} node (and subnodes) with resolved styles
 */ var resolveNodeStyles = function resolveNodeStyles(container) {
    return function(node) {
        var style = computeStyle(container, node);
        if (!node.children) return Object.assign({}, node, {
            style: style
        });
        var children = node.children.map(resolveNodeStyles(container));
        return Object.assign({}, node, {
            style: style,
            children: children
        });
    };
};
/**
 * Resolves page styles
 *
 * @param {Object} document page
 * @returns {Object} document page with resolved styles
 */ var resolvePageStyles = function resolvePageStyles(page) {
    var _page$props, _page$box, _page$box2, _page$props2;
    var dpi = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.dpi) || 72;
    var width = ((_page$box = page.box) === null || _page$box === void 0 ? void 0 : _page$box.width) || page.style.width;
    var height = ((_page$box2 = page.box) === null || _page$box2 === void 0 ? void 0 : _page$box2.height) || page.style.height;
    var orientation = ((_page$props2 = page.props) === null || _page$props2 === void 0 ? void 0 : _page$props2.orientation) || "portrait";
    var container = {
        width: width,
        height: height,
        orientation: orientation,
        dpi: dpi
    };
    return resolveNodeStyles(container)(page);
};
/**
 * Resolves document styles
 *
 * @param {Object} document root
 * @returns {Object} document root with resolved styles
 */ var resolveStyles = function resolveStyles(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePageStyles);
    return Object.assign({}, root, {
        children: children
    });
};
var getTransformStyle = function getTransformStyle(s) {
    return function(node) {
        var _node$style, _node$style2;
        return (0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style[s]) ? "50%" : (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2[s];
    };
};
/**
 * Get node origin
 *
 * @param {Object} node
 * @returns {Object} node origin
 */ var getOrigin = function getOrigin(node) {
    if (!node.box) return {};
    var _node$box = node.box, left = _node$box.left, top = _node$box.top, width = _node$box.width, height = _node$box.height;
    var transformOriginX = getTransformStyle("transformOriginX")(node);
    var transformOriginY = getTransformStyle("transformOriginY")(node);
    var percentX = (0, _fns.matchPercent)(transformOriginX);
    var percentY = (0, _fns.matchPercent)(transformOriginY);
    var offsetX = percentX ? width * percentX.percent : transformOriginX;
    var offsetY = percentY ? height * percentY.percent : transformOriginY;
    return {
        left: left + offsetX,
        top: top + offsetY
    };
};
/**
 * Resolve node origin
 *
 * @param {Object} node
 * @returns {Object} node with origin attribute
 */ var resolveNodeOrigin = function resolveNodeOrigin(node) {
    var origin = getOrigin(node);
    var newNode = Object.assign({}, node, {
        origin: origin
    });
    if (!node.children) return newNode;
    var children = node.children.map(resolveNodeOrigin);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Resolve document origins
 *
 * @param {Object} document root
 * @returns {Object} documrnt root
 */ var resolveOrigin = function resolveOrigin(root) {
    if (!root.children) return root;
    var children = root.children.map(resolveNodeOrigin);
    return Object.assign({}, root, {
        children: children
    });
};
/* eslint-disable no-plusplus */ /* eslint-disable prefer-const */ /* eslint-disable prefer-destructuring */ var getBookmarkValue = function getBookmarkValue(title) {
    return typeof title === "string" ? {
        title: title,
        fit: false,
        expanded: false
    } : title;
};
var resolveBookmarks = function resolveBookmarks(node) {
    var refs = 0;
    var children = (node.children || []).slice(0);
    var listToExplore = children.map(function(value) {
        return {
            value: value,
            parent: null
        };
    });
    var _loop = function _loop() {
        var _child$props;
        var element = listToExplore.shift();
        var child = element.value;
        var parent = element.parent;
        if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.bookmark) {
            var _parent;
            var bookmark = getBookmarkValue(child.props.bookmark);
            var ref = refs++;
            var newHierarchy = (0, _extendsDefault.default)({
                ref: ref,
                parent: (_parent = parent) === null || _parent === void 0 ? void 0 : _parent.ref
            }, bookmark);
            child.props.bookmark = newHierarchy;
            parent = newHierarchy;
        }
        if (child.children) child.children.forEach(function(childNode) {
            listToExplore.push({
                value: childNode,
                parent: parent
            });
        });
    };
    while(listToExplore.length > 0)_loop();
    return node;
};
var VALID_ORIENTATIONS = [
    "portrait",
    "landscape"
];
/**
 * Get page orientation. Defaults to portrait
 *
 * @param { Object } page object
 * @returns { String } page orientation
 */ var getOrientation = function getOrientation(page) {
    var _page$props;
    var value = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.orientation) || "portrait";
    return VALID_ORIENTATIONS.includes(value) ? value : "portrait";
};
/**
 * Return true if page is landscape
 *
 * @param {Object} page instance
 * @returns {Boolean} is page landscape
 */ var isLandscape = function isLandscape(page) {
    return getOrientation(page) === "landscape";
};
var PAGE_SIZES = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ],
    ID1: [
        153,
        243
    ]
};
/**
 * Transforms array into size object
 *
 * @param {Array} array
 * @returns {Object} size object with width and height
 */ var toSizeObject = function toSizeObject(v) {
    return {
        width: v[0],
        height: v[1]
    };
};
/**
 * Flip size object
 *
 * @param {Object} size object
 * @returns {Object} flipped size object
 */ var flipSizeObject = function flipSizeObject(v) {
    return {
        width: v.height,
        height: v.width
    };
};
/**
 * Adjust page size to passed DPI
 *
 * @param {Object} size object
 * @param {number} dpi
 * @returns {Object} adjusted size object
 */ var adjustDpi = function adjustDpi(v, dpi) {
    return {
        width: v.width ? v.width * dpi : v.width,
        height: v.height ? v.height * dpi : v.height
    };
};
/**
 * Returns size object from a given string
 *
 * @param {String} page size string
 * @returns {Object} size object with width and height
 */ var getStringSize = function getStringSize(v) {
    return toSizeObject(PAGE_SIZES[v.toUpperCase()]);
};
/**
 * Returns size object from a single number
 *
 * @param {Number} page size number
 * @returns {Object} size object with width and height
 */ var getNumberSize = function getNumberSize(n) {
    return toSizeObject([
        n
    ]);
};
/**
 * Return page size in an object { width, height }
 *
 * @param {Object} page instance
 * @returns {Object} size object with width and height
 */ var getSize = function getSize(page) {
    var _page$props, _page$props2;
    var value = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.size) || "A4";
    var dpi = parseFloat(((_page$props2 = page.props) === null || _page$props2 === void 0 ? void 0 : _page$props2.dpi) || 72);
    var type = typeof value;
    var size = value;
    if (type === "string") size = getStringSize(value);
    else if (Array.isArray(value)) size = toSizeObject(value);
    else if (type === "number") size = getNumberSize(value);
    size = adjustDpi(size, dpi / 72);
    return isLandscape(page) ? flipSizeObject(size) : size;
};
/**
 * Resolves page size
 *
 * @param {Object} page
 * @returns {Object} page with resolved size in style attribute
 */ var resolvePageSize = function resolvePageSize(page) {
    var size = getSize(page);
    var style = (0, _stylesheet.flatten)(page.style || {});
    return (0, _extendsDefault.default)({}, page, {
        style: (0, _extendsDefault.default)({}, style, size)
    });
};
/**
 * Resolves page sizes
 *
 * @param {Object} document root
 * @returns {Object} document root with resolved page sizes
 */ var resolvePageSizes = function resolvePageSizes(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePageSize);
    return Object.assign({}, root, {
        children: children
    });
};
var isFixed = function isFixed(node) {
    var _node$props;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.fixed) === true;
};
/**
 * Get line index at given height
 *
 * @param {Object} node
 * @param {Number} height
 */ var lineIndexAtHeight = function lineIndexAtHeight(node, height) {
    var y = 0;
    if (!node.lines) return 0;
    for(var i = 0; i < node.lines.length; i += 1){
        var line = node.lines[i];
        if (y + line.box.height > height) return i;
        y += line.box.height;
    }
    return node.lines.length;
};
/**
 * Get height for given text line index
 *
 * @param {Object} node
 * @param {Number} index
 */ var heightAtLineIndex = function heightAtLineIndex(node, index) {
    var counter = 0;
    if (!node.lines) return counter;
    for(var i = 0; i < index; i += 1){
        var line = node.lines[i];
        if (!line) break;
        counter += line.box.height;
    }
    return counter;
};
var getLineBreak = function getLineBreak(node, height) {
    var top = (0, _fns.get)(node, [
        "box",
        "top"
    ], 0);
    var widows = (0, _fns.get)(node, [
        "props",
        "widows"
    ], 2);
    var orphans = (0, _fns.get)(node, [
        "props",
        "orphans"
    ], 2);
    var linesQuantity = node.lines.length;
    var slicedLine = lineIndexAtHeight(node, height - top);
    if (slicedLine === 0) return 0;
    if (linesQuantity < orphans) return linesQuantity;
    if (slicedLine < orphans || linesQuantity < orphans + widows) return 0;
    if (linesQuantity === orphans + widows) return orphans;
    if (linesQuantity - slicedLine < widows) return linesQuantity - widows;
    return slicedLine;
};
// Also receives contentArea in case it's needed
var splitText = function splitText(node, height) {
    var slicedLineIndex = getLineBreak(node, height);
    var currentHeight = heightAtLineIndex(node, slicedLineIndex);
    var nextHeight = node.box.height - currentHeight;
    var current = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            height: currentHeight,
            borderBottomWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottomWidth: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }),
        lines: node.lines.slice(0, slicedLineIndex)
    });
    var next = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            top: 0,
            height: nextHeight,
            borderTopWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginTop: 0,
            paddingTop: 0,
            borderTopWidth: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }),
        lines: node.lines.slice(slicedLineIndex)
    });
    return [
        current,
        next
    ];
};
var getTop$1 = function getTop(node) {
    var _node$box;
    return ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
};
var hasFixedHeight = function hasFixedHeight(node) {
    var _node$style;
    return !(0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.height);
};
var splitNode = function splitNode(node, height) {
    if (!node) return [
        null,
        null
    ];
    var nodeTop = getTop$1(node);
    var current = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            borderBottomWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottomWidth: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        })
    });
    current.style.height = height - nodeTop;
    var nextHeight = hasFixedHeight(node) ? node.box.height - (height - nodeTop) : null;
    var next = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            top: 0,
            borderTopWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginTop: 0,
            paddingTop: 0,
            borderTopWidth: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        })
    });
    if (nextHeight) next.style.height = nextHeight;
    return [
        current,
        next
    ];
};
var NON_WRAP_TYPES = [
    _primitives.Svg,
    _primitives.Note,
    _primitives.Image,
    _primitives.Canvas
];
var getWrap = function getWrap(node) {
    var _node$props;
    if (NON_WRAP_TYPES.includes(node.type)) return false;
    return (0, _fns.isNil)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.wrap) ? true : node.props.wrap;
};
var getComputedPadding = function getComputedPadding(node, edge) {
    var yogaNode = node.yogaNode;
    return yogaNode ? yogaNode.getComputedPadding(edge) : null;
};
/**
 * Get Yoga computed paddings. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} paddings
 */ var getPadding = function getPadding(node) {
    var style = node.style, box = node.box;
    var paddingTop = getComputedPadding(node, (0, _yogaDefault.default).EDGE_TOP) || (box === null || box === void 0 ? void 0 : box.paddingTop) || (style === null || style === void 0 ? void 0 : style.paddingTop) || (style === null || style === void 0 ? void 0 : style.paddingVertical) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingRight = getComputedPadding(node, (0, _yogaDefault.default).EDGE_RIGHT) || (box === null || box === void 0 ? void 0 : box.paddingRight) || (style === null || style === void 0 ? void 0 : style.paddingRight) || (style === null || style === void 0 ? void 0 : style.paddingHorizontal) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingBottom = getComputedPadding(node, (0, _yogaDefault.default).EDGE_BOTTOM) || (box === null || box === void 0 ? void 0 : box.paddingBottom) || (style === null || style === void 0 ? void 0 : style.paddingBottom) || (style === null || style === void 0 ? void 0 : style.paddingVertical) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingLeft = getComputedPadding(node, (0, _yogaDefault.default).EDGE_LEFT) || (box === null || box === void 0 ? void 0 : box.paddingLeft) || (style === null || style === void 0 ? void 0 : style.paddingLeft) || (style === null || style === void 0 ? void 0 : style.paddingHorizontal) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    return {
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft
    };
};
var getWrapArea = function getWrapArea(page) {
    var _page$style;
    var _getPadding = getPadding(page), paddingBottom = _getPadding.paddingBottom;
    var height = (_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.height;
    return height - paddingBottom;
};
var getContentArea = function getContentArea(page) {
    var _page$style;
    var height = (_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.height;
    var _getPadding = getPadding(page), paddingTop = _getPadding.paddingTop, paddingBottom = _getPadding.paddingBottom;
    return height - paddingBottom - paddingTop;
};
var _excluded = [
    "style",
    "children"
];
var isString = function isString(value) {
    return typeof value === "string";
};
var isNumber = function isNumber(value) {
    return typeof value === "number";
};
var isFragment = function isFragment(value) {
    return value && value.type === Symbol.for("react.fragment");
};
/**
 * Transforms a react element instance to internal element format.
 *
 * Can return multiple instances in the case of arrays or fragments.
 *
 * @param {Object} React element
 * @returns {Array} parsed react elements
 */ var createInstances = function createInstances(element) {
    if (!element) return [];
    if (isString(element) || isNumber(element)) return [
        {
            type: (0, _primitives.TextInstance),
            value: "" + element
        }
    ];
    if (isFragment(element)) return createInstances(element.props.children);
    if (Array.isArray(element)) return element.reduce(function(acc, el) {
        return acc.concat(createInstances(el));
    }, []);
    if (!isString(element.type)) return createInstances(element.type(element.props));
    var type = element.type, _element$props = element.props, _element$props$style = _element$props.style, style = _element$props$style === void 0 ? {} : _element$props$style, _element$props$childr = _element$props.children, children = _element$props$childr === void 0 ? [] : _element$props$childr, props = (0, _objectWithoutPropertiesLooseDefault.default)(_element$props, _excluded);
    var nextChildren = (0, _fns.castArray)(children).reduce(function(acc, child) {
        return acc.concat(createInstances(child));
    }, []);
    return [
        {
            type: type,
            style: style,
            props: props,
            box: {},
            children: nextChildren
        }
    ];
};
/**
 * Get many nodes height
 *
 * @param {Array} nodes
 * @return {number} nodes height
 */ var getNodesHeight = function getNodesHeight(nodes) {
    var max = 0;
    var min = Infinity;
    if (!nodes || nodes.length === 0) return 0;
    for(var i = 0; i < nodes.length; i += 1){
        var node = nodes[i];
        min = Math.min(min, node.box.top);
        max = Math.max(max, node.box.top + node.box.height);
    }
    return max - min;
};
/* eslint-disable no-continue */ var getBreak = function getBreak(node) {
    var _node$props;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.break) || false;
};
var getMinPresenceAhead = function getMinPresenceAhead(node) {
    var _node$props2;
    return (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.minPresenceAhead;
};
var defaultPresenceAhead = function defaultPresenceAhead(element) {
    return function(height) {
        return Math.min(element.box.height, height);
    };
};
var getPresenceAhead = function getPresenceAhead(elements, height) {
    var result = 0;
    for(var i = 0; i < elements.length; i += 1){
        var element = elements[i];
        if (!element.box) continue;
        var isElementInside = height > element.box.top;
        var presenceAhead = element.props.presenceAhead || defaultPresenceAhead(element);
        if (element && isElementInside) result += presenceAhead(height - element.box.top);
    }
    return result;
};
var shouldBreak = function shouldBreak(child, futureElements, height) {
    var minPresenceAhead = getMinPresenceAhead(child);
    var presenceAhead = getPresenceAhead(futureElements, height);
    var futureHeight = getNodesHeight(futureElements);
    var shouldSplit = height < child.box.top + child.box.height;
    var shouldWrap = getWrap(child);
    return getBreak(child) || !shouldWrap && shouldSplit || minPresenceAhead < futureHeight && presenceAhead < minPresenceAhead;
};
var IGNORABLE_CODEPOINTS = [
    8232,
    // LINE_SEPARATOR
    8233 // PARAGRAPH_SEPARATOR
];
var buildSubsetForFont = function buildSubsetForFont(font) {
    return IGNORABLE_CODEPOINTS.reduce(function(acc, codePoint) {
        if (font && font.hasGlyphForCodePoint && font.hasGlyphForCodePoint(codePoint)) return acc;
        return [].concat(acc, [
            String.fromCharCode(codePoint)
        ]);
    }, []);
};
var ignoreChars = function ignoreChars(fragments) {
    return fragments.map(function(fragment) {
        var charSubset = buildSubsetForFont(fragment.attributes.font);
        var subsetRegex = new RegExp(charSubset.join("|"));
        return {
            string: fragment.string.replace(subsetRegex, ""),
            attributes: fragment.attributes
        };
    });
};
var PREPROCESSORS = [
    ignoreChars,
    embedEmojis
];
var isImage$1 = function isImage(node) {
    return node.type === _primitives.Image;
};
var isTextInstance$2 = function isTextInstance(node) {
    return node.type === _primitives.TextInstance;
};
/**
 * Get textkit fragments of given node object
 *
 * @param {Object} font store
 * @param {Object} instance node
 * @returns {Array} text fragments
 */ var getFragments = function getFragments(fontStore, instance, parentLink, level) {
    var _instance$props, _instance$props2;
    if (level === void 0) level = 0;
    if (!instance) return [
        {
            string: ""
        }
    ];
    var fragments = [];
    var _instance$style = instance.style, _instance$style$color = _instance$style.color, color = _instance$style$color === void 0 ? "black" : _instance$style$color, _instance$style$fontF = _instance$style.fontFamily, fontFamily = _instance$style$fontF === void 0 ? "Helvetica" : _instance$style$fontF, fontWeight = _instance$style.fontWeight, fontStyle = _instance$style.fontStyle, _instance$style$fontS = _instance$style.fontSize, fontSize = _instance$style$fontS === void 0 ? 18 : _instance$style$fontS, _instance$style$textA = _instance$style.textAlign, textAlign = _instance$style$textA === void 0 ? "left" : _instance$style$textA, lineHeight = _instance$style.lineHeight, textDecoration = _instance$style.textDecoration, textDecorationColor = _instance$style.textDecorationColor, textDecorationStyle = _instance$style.textDecorationStyle, textTransform = _instance$style.textTransform, letterSpacing = _instance$style.letterSpacing, textIndent = _instance$style.textIndent, opacity = _instance$style.opacity, verticalAlign = _instance$style.verticalAlign;
    var opts = {
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle
    };
    var obj = fontStore ? fontStore.getFont(opts) : null;
    var font = obj ? obj.data : fontFamily;
    // Don't pass main background color to textkit. Will be rendered by the render package instead
    var backgroundColor = level === 0 ? null : instance.style.backgroundColor;
    var attributes = {
        font: font,
        color: color,
        opacity: opacity,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        align: textAlign,
        indent: textIndent,
        characterSpacing: letterSpacing,
        strikeStyle: textDecorationStyle,
        underlineStyle: textDecorationStyle,
        underline: textDecoration === "underline" || textDecoration === "underline line-through" || textDecoration === "line-through underline",
        strike: textDecoration === "line-through" || textDecoration === "underline line-through" || textDecoration === "line-through underline",
        strikeColor: textDecorationColor || color,
        underlineColor: textDecorationColor || color,
        link: parentLink || ((_instance$props = instance.props) === null || _instance$props === void 0 ? void 0 : _instance$props.src) || ((_instance$props2 = instance.props) === null || _instance$props2 === void 0 ? void 0 : _instance$props2.href),
        lineHeight: lineHeight ? lineHeight * fontSize : null,
        verticalAlign: verticalAlign
    };
    for(var i = 0; i < instance.children.length; i += 1){
        var child = instance.children[i];
        if (isImage$1(child)) fragments.push({
            string: String.fromCharCode(0xfffc),
            attributes: (0, _extendsDefault.default)({}, attributes, {
                attachment: {
                    width: child.style.width || fontSize,
                    height: child.style.height || fontSize,
                    image: child.image.data
                }
            })
        });
        else if (isTextInstance$2(child)) fragments.push({
            string: transformText(child.value, textTransform),
            attributes: attributes
        });
        else if (child) {
            var _fragments;
            (_fragments = fragments).push.apply(_fragments, getFragments(fontStore, child, attributes.link, level + 1));
        }
    }
    for(var _i = 0; _i < PREPROCESSORS.length; _i += 1){
        var preprocessor = PREPROCESSORS[_i];
        fragments = preprocessor(fragments);
    }
    return fragments;
};
/**
 * Get textkit attributed string from text node
 *
 * @param {Object} font store
 * @param {Object} instance node
 * @returns {Object} attributed string
 */ var getAttributedString = function getAttributedString(fontStore, instance) {
    var fragments = getFragments(fontStore, instance);
    return fromFragments(fragments);
};
var engines = {
    linebreaker: (0, _textkit.linebreaker),
    justification: (0, _textkit.justification),
    textDecoration: (0, _textkit.textDecoration),
    scriptItemizer: (0, _textkit.scriptItemizer),
    wordHyphenation: (0, _textkit.wordHyphenation),
    fontSubstitution: fontSubstitution
};
var engine = (0, _textkitDefault.default)(engines);
var getMaxLines = function getMaxLines(node) {
    var _node$style;
    return (_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.maxLines;
};
var getTextOverflow = function getTextOverflow(node) {
    var _node$style2;
    return (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.textOverflow;
};
/**
 * Get layout container for specific text node
 *
 * @param {Number} width
 * @param {Number} height
 * @param {Object} node
 * @returns {Object} layout container
 */ var getContainer = function getContainer(width, height, node) {
    var maxLines = getMaxLines(node);
    var textOverflow = getTextOverflow(node);
    return {
        x: 0,
        y: 0,
        width: width,
        maxLines: maxLines,
        height: height || Infinity,
        truncateMode: textOverflow
    };
};
/**
 * Get text layout options for specific text node
 *
 * @param {Object} node instance
 * @returns {Object} layout options
 */ var getLayoutOptions = function getLayoutOptions(fontStore, node) {
    return {
        hyphenationPenalty: node.props.hyphenationPenalty,
        shrinkWhitespaceFactor: {
            before: -0.5,
            after: -0.5
        },
        hyphenationCallback: node.props.hyphenationCallback || (fontStore === null || fontStore === void 0 ? void 0 : fontStore.getHyphenationCallback()) || null
    };
};
/**
 * Get text lines for given node
 *
 * @param {Object} node
 * @param {Number} container width
 * @param {Number} container height
 * @param {Number} fontStore font store
 * @returns {Array} layout lines
 */ var layoutText = function layoutText(node, width, height, fontStore) {
    var attributedString = getAttributedString(fontStore, node);
    var container = getContainer(width, height, node);
    var options = getLayoutOptions(fontStore, node);
    var lines = engine(attributedString, container, options);
    return lines.reduce(function(acc, line) {
        return [].concat(acc, line);
    }, []);
};
var isType$2 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg$2 = isType$2(_primitives.Svg);
var isText$3 = isType$2(_primitives.Text);
var shouldIterate = function shouldIterate(node) {
    return !isSvg$2(node) && !isText$3(node);
};
var shouldLayoutText = function shouldLayoutText(node) {
    return isText$3(node) && !node.lines;
};
/**
 * Performs text layout on text node if wasn't calculated before.
 * Text layout is usually performed on Yoga's layout process (via setMeasureFunc),
 * but we need to layout those nodes with fixed width and height.
 *
 * @param {Object} node
 * @returns {Object} layout node
 */ var resolveTextLayout = function resolveTextLayout(node, fontStore) {
    if (shouldLayoutText(node)) {
        var width = node.box.width - (node.box.paddingRight + node.box.paddingLeft);
        var height = node.box.height - (node.box.paddingTop + node.box.paddingBottom);
        // eslint-disable-next-line no-param-reassign
        node.lines = layoutText(node, width, height, fontStore);
    }
    if (shouldIterate(node)) {
        if (!node.children) return node;
        var mapChild = function mapChild(child) {
            return resolveTextLayout(child, fontStore);
        };
        var children = node.children.map(mapChild);
        return Object.assign({}, node, {
            children: children
        });
    }
    return node;
};
var INHERITED_PROPERTIES = [
    "color",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "opacity",
    "textDecoration",
    "textTransform",
    "lineHeight",
    "textAlign",
    "visibility",
    "wordSpacing"
];
var isSvg$1 = function isSvg(node) {
    return node.type === _primitives.Svg;
};
// Merge style values
var mergeValues = function mergeValues(styleName, value, inheritedValue) {
    switch(styleName){
        case "textDecoration":
            // merge not none and not false textDecoration values to one rule
            return [
                inheritedValue,
                value
            ].filter(function(v) {
                return v && v !== "none";
            }).join(" ");
        default:
            return value;
    }
};
// Merge inherited and node styles
var merge = function merge(inheritedStyles, style) {
    var mergedStyles = (0, _extendsDefault.default)({}, inheritedStyles);
    Object.entries(style).forEach(function(_ref) {
        var styleName = _ref[0], value = _ref[1];
        mergedStyles[styleName] = mergeValues(styleName, value, inheritedStyles[styleName]);
    });
    return mergedStyles;
};
/**
 * Merges styles with node
 *
 * @param {Object} style object
 * @param {Object} node
 * @returns {Object} node with styles merged
 */ var mergeStyles = function mergeStyles(inheritedStyles) {
    return function(node) {
        var style = merge(inheritedStyles, node.style || {});
        return Object.assign({}, node, {
            style: style
        });
    };
};
/**
 * Inherit style values from the root to the leafs
 *
 * @param {Object} document root
 * @returns {Object} document root with inheritance
 *
 */ var resolveInheritance = function resolveInheritance(node) {
    if (isSvg$1(node)) return node;
    if (!node.children) return node;
    var inheritStyles = (0, _fns.pick)(INHERITED_PROPERTIES, node.style || {});
    var resolveChild = (0, _fns.compose)(resolveInheritance, mergeStyles(inheritStyles));
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var getComputedMargin = function getComputedMargin(node, edge) {
    var yogaNode = node.yogaNode;
    return yogaNode ? yogaNode.getComputedMargin(edge) : null;
};
/**
 * Get Yoga computed magins. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} margins
 */ var getMargin = function getMargin(node) {
    var style = node.style, box = node.box;
    var marginTop = getComputedMargin(node, (0, _yogaDefault.default).EDGE_TOP) || (box === null || box === void 0 ? void 0 : box.marginTop) || (style === null || style === void 0 ? void 0 : style.marginTop) || (style === null || style === void 0 ? void 0 : style.marginVertical) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginRight = getComputedMargin(node, (0, _yogaDefault.default).EDGE_RIGHT) || (box === null || box === void 0 ? void 0 : box.marginRight) || (style === null || style === void 0 ? void 0 : style.marginRight) || (style === null || style === void 0 ? void 0 : style.marginHorizontal) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginBottom = getComputedMargin(node, (0, _yogaDefault.default).EDGE_BOTTOM) || (box === null || box === void 0 ? void 0 : box.marginBottom) || (style === null || style === void 0 ? void 0 : style.marginBottom) || (style === null || style === void 0 ? void 0 : style.marginVertical) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginLeft = getComputedMargin(node, (0, _yogaDefault.default).EDGE_LEFT) || (box === null || box === void 0 ? void 0 : box.marginLeft) || (style === null || style === void 0 ? void 0 : style.marginLeft) || (style === null || style === void 0 ? void 0 : style.marginHorizontal) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    return {
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    };
};
/**
 * Get Yoga computed position. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} position
 */ var getPosition = function getPosition(node) {
    var yogaNode = node.yogaNode;
    return {
        top: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedTop()) || 0,
        right: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedRight()) || 0,
        bottom: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedBottom()) || 0,
        left: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedLeft()) || 0
    };
};
var DEFAULT_DIMENSION = {
    width: 0,
    height: 0
};
/**
 * Get Yoga computed dimensions. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} dimensions
 */ var getDimension = function getDimension(node) {
    var yogaNode = node.yogaNode;
    if (!yogaNode) return DEFAULT_DIMENSION;
    return {
        width: yogaNode.getComputedWidth(),
        height: yogaNode.getComputedHeight()
    };
};
var getComputedBorder = function getComputedBorder(yogaNode, edge) {
    return yogaNode ? yogaNode.getComputedBorder(edge) : 0;
};
/**
 * Get Yoga computed border width. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} border widths
 */ var getBorderWidth = function getBorderWidth(node) {
    var yogaNode = node.yogaNode;
    return {
        borderTopWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_TOP),
        borderRightWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_RIGHT),
        borderBottomWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_BOTTOM),
        borderLeftWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_LEFT)
    };
};
/**
 * Set display attribute to node's Yoga instance
 *
 * @param {String} display
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setDisplay = function setDisplay(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) yogaNode.setDisplay(value === "none" ? (0, _yogaDefault.default).DISPLAY_NONE : (0, _yogaDefault.default).DISPLAY_FLEX);
        return node;
    };
};
var OVERFLOW = {
    hidden: (0, _yogaDefault.default).OVERFLOW_HIDDEN,
    scroll: (0, _yogaDefault.default).OVERFLOW_SCROLL
};
/**
 * Set overflow attribute to node's Yoga instance
 *
 * @param {String} overflow value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setOverflow = function setOverflow(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            var overflow = OVERFLOW[value] || (0, _yogaDefault.default).OVERFLOW_VISIBLE;
            yogaNode.setOverflow(overflow);
        }
        return node;
    };
};
var FLEX_WRAP = {
    wrap: (0, _yogaDefault.default).WRAP_WRAP,
    "wrap-reverse": (0, _yogaDefault.default).WRAP_WRAP_REVERSE
};
/**
 * Set flex wrap attribute to node's Yoga instance
 *
 * @param {String} flex wrap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexWrap = function setFlexWrap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) {
            var flexWrap = FLEX_WRAP[value] || (0, _yogaDefault.default).WRAP_NO_WRAP;
            yogaNode.setFlexWrap(flexWrap);
        }
        return node;
    };
};
/* eslint-disable no-unused-expressions */ /**
 * Set generic yoga attribute to node's Yoga instance, handing `auto`, edges and percentage cases
 *
 * @param {String} property
 * @param {Number} edge
 * @param {any} value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setYogaValue = function setYogaValue(attr, edge) {
    return function(value) {
        return function(node) {
            var yogaNode = node.yogaNode;
            if (!(0, _fns.isNil)(value) && yogaNode) {
                var hasEdge = !(0, _fns.isNil)(edge);
                var fixedMethod = "set" + (0, _fns.upperFirst)(attr);
                var autoMethod = fixedMethod + "Auto";
                var percentMethod = fixedMethod + "Percent";
                var percent = (0, _fns.matchPercent)(value);
                if (percent && !yogaNode[percentMethod]) throw new Error("You can't pass percentage values to " + attr + " property");
                if (percent) {
                    if (hasEdge) {
                        var _yogaNode$percentMeth;
                        (_yogaNode$percentMeth = yogaNode[percentMethod]) === null || _yogaNode$percentMeth === void 0 || _yogaNode$percentMeth.call(yogaNode, edge, percent.value);
                    } else {
                        var _yogaNode$percentMeth2;
                        (_yogaNode$percentMeth2 = yogaNode[percentMethod]) === null || _yogaNode$percentMeth2 === void 0 || _yogaNode$percentMeth2.call(yogaNode, percent.value);
                    }
                } else if (value === "auto") {
                    if (hasEdge) {
                        var _yogaNode$autoMethod;
                        (_yogaNode$autoMethod = yogaNode[autoMethod]) === null || _yogaNode$autoMethod === void 0 || _yogaNode$autoMethod.call(yogaNode, edge);
                    } else {
                        var _yogaNode$autoMethod2;
                        (_yogaNode$autoMethod2 = yogaNode[autoMethod]) === null || _yogaNode$autoMethod2 === void 0 || _yogaNode$autoMethod2.call(yogaNode);
                    }
                } else if (hasEdge) {
                    var _yogaNode$fixedMethod;
                    (_yogaNode$fixedMethod = yogaNode[fixedMethod]) === null || _yogaNode$fixedMethod === void 0 || _yogaNode$fixedMethod.call(yogaNode, edge, value);
                } else {
                    var _yogaNode$fixedMethod2;
                    (_yogaNode$fixedMethod2 = yogaNode[fixedMethod]) === null || _yogaNode$fixedMethod2 === void 0 || _yogaNode$fixedMethod2.call(yogaNode, value);
                }
            }
            return node;
        };
    };
};
/**
 * Set flex grow attribute to node's Yoga instance
 *
 * @param {Number} flex grow value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexGrow = function setFlexGrow(value) {
    return function(node) {
        return setYogaValue("flexGrow")(value || 0)(node);
    };
};
/**
 * Set flex basis attribute to node's Yoga instance
 *
 * @param {Number} flex basis value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexBasis = setYogaValue("flexBasis");
var ALIGN = {
    "flex-start": (0, _yogaDefault.default).ALIGN_FLEX_START,
    center: (0, _yogaDefault.default).ALIGN_CENTER,
    "flex-end": (0, _yogaDefault.default).ALIGN_FLEX_END,
    stretch: (0, _yogaDefault.default).ALIGN_STRETCH,
    baseline: (0, _yogaDefault.default).ALIGN_BASELINE,
    "space-between": (0, _yogaDefault.default).ALIGN_SPACE_BETWEEN,
    "space-around": (0, _yogaDefault.default).ALIGN_SPACE_AROUND
};
/**
 * Set generic align attribute to node's Yoga instance
 *
 * @param {String} specific align property
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlign = function setAlign(attr) {
    return function(value) {
        return function(node) {
            var yogaNode = node.yogaNode;
            var defaultValue = attr === "items" ? (0, _yogaDefault.default).ALIGN_STRETCH : (0, _yogaDefault.default).ALIGN_AUTO;
            if (yogaNode) {
                var align = ALIGN[value] || defaultValue;
                yogaNode["setAlign" + (0, _fns.upperFirst)(attr)](align);
            }
            return node;
        };
    };
};
/**
 * Set align self attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignSelf = setAlign("self");
/**
 * Set align items attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignItems = setAlign("items");
/**
 * Set flex shrink attribute to node's Yoga instance
 *
 * @param {Number} flex shrink value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexShrink = function setFlexShrink(value) {
    return function(node) {
        return setYogaValue("flexShrink")(value || 1)(node);
    };
};
/**
 * Set aspect ratio attribute to node's Yoga instance
 *
 * @param {Number} ratio
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAspectRatio = function setAspectRatio(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) yogaNode.setAspectRatio(value);
        return node;
    };
};
/**
 * Set align content attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignContent = setAlign("content");
/**
 * Set position type attribute to node's Yoga instance
 *
 * @param {String} position type
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionType = function setPositionType(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) yogaNode.setPositionType(value === "absolute" ? (0, _yogaDefault.default).POSITION_TYPE_ABSOLUTE : (0, _yogaDefault.default).POSITION_TYPE_RELATIVE);
        return node;
    };
};
var FLEX_DIRECTIONS = {
    row: (0, _yogaDefault.default).FLEX_DIRECTION_ROW,
    "row-reverse": (0, _yogaDefault.default).FLEX_DIRECTION_ROW_REVERSE,
    "column-reverse": (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN_REVERSE
};
/**
 * Set flex direction attribute to node's Yoga instance
 *
 * @param {String} flex direction value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexDirection = function setFlexDirection(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) {
            var flexDirection = FLEX_DIRECTIONS[value] || (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN;
            yogaNode.setFlexDirection(flexDirection);
        }
        return node;
    };
};
var JUSTIFY_CONTENT = {
    center: (0, _yogaDefault.default).JUSTIFY_CENTER,
    "flex-end": (0, _yogaDefault.default).JUSTIFY_FLEX_END,
    "space-between": (0, _yogaDefault.default).JUSTIFY_SPACE_BETWEEN,
    "space-around": (0, _yogaDefault.default).JUSTIFY_SPACE_AROUND,
    "space-evenly": (0, _yogaDefault.default).JUSTIFY_SPACE_EVENLY
};
/**
 * Set justify content attribute to node's Yoga instance
 *
 * @param {String} justify content value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setJustifyContent = function setJustifyContent(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            var justifyContent = JUSTIFY_CONTENT[value] || (0, _yogaDefault.default).JUSTIFY_FLEX_START;
            yogaNode.setJustifyContent(justifyContent);
        }
        return node;
    };
};
/**
 * Set margin top attribute to node's Yoga instance
 *
 * @param {Number} margin top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginTop = setYogaValue("margin", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set margin right attribute to node's Yoga instance
 *
 * @param {Number} margin right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginRight = setYogaValue("margin", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set margin bottom attribute to node's Yoga instance
 *
 * @param {Number} margin bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginBottom = setYogaValue("margin", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set margin left attribute to node's Yoga instance
 *
 * @param {Number} margin left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginLeft = setYogaValue("margin", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set padding top attribute to node's Yoga instance
 *
 * @param {Number} padding top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingTop = setYogaValue("padding", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set padding right attribute to node's Yoga instance
 *
 * @param {Number} padding right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingRight = setYogaValue("padding", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set padding bottom attribute to node's Yoga instance
 *
 * @param {Number} padding bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingBottom = setYogaValue("padding", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set padding left attribute to node's Yoga instance
 *
 * @param {Number} padding left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingLeft = setYogaValue("padding", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set border top attribute to node's Yoga instance
 *
 * @param {Number} border top width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderTop = setYogaValue("border", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set border right attribute to node's Yoga instance
 *
 * @param {Number} border right width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderRight = setYogaValue("border", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set border bottom attribute to node's Yoga instance
 *
 * @param {Number} border bottom width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderBottom = setYogaValue("border", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set border left attribute to node's Yoga instance
 *
 * @param {Number} border left width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderLeft = setYogaValue("border", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set position top attribute to node's Yoga instance
 *
 * @param {Number} position top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionTop = setYogaValue("position", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set position right attribute to node's Yoga instance
 *
 * @param {Number} position right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionRight = setYogaValue("position", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set position bottom attribute to node's Yoga instance
 *
 * @param {Number} position bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionBottom = setYogaValue("position", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set position left attribute to node's Yoga instance
 *
 * @param {Number} position left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionLeft = setYogaValue("position", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set width to node's Yoga instance
 *
 * @param {Number} width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setWidth = setYogaValue("width");
/**
 * Set min width to node's Yoga instance
 *
 * @param {Number} min width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMinWidth = setYogaValue("minWidth");
/**
 * Set max width to node's Yoga instance
 *
 * @param {Number} max width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMaxWidth = setYogaValue("maxWidth");
/**
 * Set height to node's Yoga instance
 *
 * @param {Number} height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setHeight = setYogaValue("height");
/**
 * Set min height to node's Yoga instance
 *
 * @param {Number} min height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMinHeight = setYogaValue("minHeight");
/**
 * Set max height to node's Yoga instance
 *
 * @param {Number} max height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMaxHeight = setYogaValue("maxHeight");
var checkPercents = function checkPercents(attr, value) {
    var percent = (0, _fns.matchPercent)(value);
    if (percent) throw new Error("You can't pass percentage values to " + attr + " property");
};
/**
 * Set rowGap value to node's Yoga instance
 *
 * @param {Number} gap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setRowGap = function setRowGap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            checkPercents("rowGap", value);
            yogaNode.setGap((0, _yogaDefault.default).GUTTER_ROW, value);
        }
        return node;
    };
};
/**
 * Set columnGap value to node's Yoga instance
 *
 * @param {Number} gap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setColumnGap = function setColumnGap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            checkPercents("columnGap", value);
            yogaNode.setGap((0, _yogaDefault.default).GUTTER_COLUMN, value);
        }
        return node;
    };
};
var getAspectRatio = function getAspectRatio(viewbox) {
    if (!viewbox) return null;
    return (viewbox.maxX - viewbox.minX) / (viewbox.maxY - viewbox.minY);
};
/**
 * Yoga svg measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} canvas width and height
 */ var measureCanvas$1 = function measureCanvas(page, node) {
    return function(width, widthMode, height, heightMode) {
        var aspectRatio = getAspectRatio(node.props.viewBox) || 1;
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY || widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) return {
            width: width,
            height: width / aspectRatio
        };
        if (heightMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY) return {
            width: height * aspectRatio
        };
        return {};
    };
};
/**
 * Get lines width (if any)
 *
 * @param {Object} node
 * @returns {Number} lines width
 */ var linesWidth = function linesWidth(node) {
    if (!node.lines) return 0;
    return Math.max.apply(Math, [
        0
    ].concat(node.lines.map(function(line) {
        return line.xAdvance;
    })));
};
/**
 * Get lines height (if any)
 *
 * @param {Object} node
 * @returns {Number} lines height
 */ var linesHeight = function linesHeight(node) {
    if (!node.lines) return -1;
    return node.lines.reduce(function(acc, line) {
        return acc + line.box.height;
    }, 0);
};
/* eslint-disable no-param-reassign */ var ALIGNMENT_FACTORS = {
    center: 0.5,
    right: 1
};
/**
 * Yoga text measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} text width and height
 */ var measureText = function measureText(page, node, fontStore) {
    return function(width, widthMode, height) {
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY) {
            if (!node.lines) node.lines = layoutText(node, width, height, fontStore);
            return {
                height: linesHeight(node)
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            var _node$style;
            var alignFactor = ALIGNMENT_FACTORS[(_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.textAlign] || 0;
            if (!node.lines) {
                node.lines = layoutText(node, width, height, fontStore);
                node.alignOffset = (width - linesWidth(node)) * alignFactor; // Compensate align in variable width containers
            }
            return {
                height: linesHeight(node),
                width: Math.min(width, linesWidth(node))
            };
        }
        return {};
    };
};
/**
 * Get image ratio
 *
 * @param {Object} image node
 * @returns {Number} image ratio
 */ var getRatio = function getRatio(node) {
    var _node$image;
    return (_node$image = node.image) !== null && _node$image !== void 0 && _node$image.data ? node.image.width / node.image.height : 1;
};
/**
 * Checks if page has auto height
 *
 * @param {Object} page
 * @returns {Boolean} is page height auto
 */ var isHeightAuto = function isHeightAuto(page) {
    var _page$box;
    return (0, _fns.isNil)((_page$box = page.box) === null || _page$box === void 0 ? void 0 : _page$box.height);
};
var SAFETY_HEIGHT$1 = 10;
/**
 * Yoga image measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} image width and height
 */ var measureImage = function measureImage(page, node) {
    return function(width, widthMode, height, heightMode) {
        var imageRatio = getRatio(node);
        var imageMargin = getMargin(node);
        var pagePadding = getPadding(page);
        var pageArea = isHeightAuto(page) ? Infinity : page.box.height - pagePadding.paddingTop - pagePadding.paddingBottom - imageMargin.marginTop - imageMargin.marginBottom - SAFETY_HEIGHT$1;
        // Skip measure if image data not present yet
        if (!node.image) return {
            width: 0,
            height: 0
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED) {
            var scaledHeight = width / imageRatio;
            return {
                height: Math.min(pageArea, scaledHeight)
            };
        }
        if (heightMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST || widthMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED)) return {
            width: Math.min(height * imageRatio, width)
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            var _scaledHeight = width / imageRatio;
            return {
                height: Math.min(height, pageArea, _scaledHeight)
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            if (imageRatio > 1) return {
                width: width,
                height: Math.min(width / imageRatio, height)
            };
            return {
                height: height,
                width: Math.min(height * imageRatio, width)
            };
        }
        return {
            height: height,
            width: width
        };
    };
};
/* eslint-disable no-param-reassign */ var SAFETY_HEIGHT = 10;
var getMax = function getMax(values) {
    return Math.max.apply(Math, [
        -Infinity
    ].concat(values));
};
/**
 * Helper object to predict canvas size
 * TODO: Implement remaining functions (as close as possible);
 */ var measureCtx = function measureCtx() {
    var ctx = {};
    var points = [];
    var nil = function nil() {
        return ctx;
    };
    var addPoint = function addPoint(x, y) {
        return points.push([
            x,
            y
        ]);
    };
    var moveTo = function moveTo() {
        addPoint.apply(void 0, arguments);
        return ctx;
    };
    var rect = function rect(x, y, w, h) {
        addPoint(x, y);
        addPoint(x + w, y);
        addPoint(x, y + h);
        addPoint(x + w, y + h);
        return ctx;
    };
    var ellipse = function ellipse(x, y, rx, ry) {
        ry = ry || rx;
        addPoint(x - rx, y - ry);
        addPoint(x + rx, y - ry);
        addPoint(x + rx, y + ry);
        addPoint(x - rx, y + ry);
        return ctx;
    };
    var polygon = function polygon() {
        points.push.apply(points, arguments);
        return ctx;
    };
    // Change dimensions
    ctx.rect = rect;
    ctx.moveTo = moveTo;
    ctx.lineTo = moveTo;
    ctx.circle = ellipse;
    ctx.polygon = polygon;
    ctx.ellipse = ellipse;
    ctx.roundedRect = rect;
    // To be implemented
    ctx.text = nil;
    ctx.path = nil;
    ctx.lineWidth = nil;
    ctx.bezierCurveTo = nil;
    ctx.quadraticCurveTo = nil;
    ctx.scale = nil;
    ctx.rotate = nil;
    ctx.translate = nil;
    // These don't change dimensions
    ctx.dash = nil;
    ctx.clip = nil;
    ctx.save = nil;
    ctx.fill = nil;
    ctx.font = nil;
    ctx.stroke = nil;
    ctx.lineCap = nil;
    ctx.opacity = nil;
    ctx.restore = nil;
    ctx.lineJoin = nil;
    ctx.fontSize = nil;
    ctx.fillColor = nil;
    ctx.miterLimit = nil;
    ctx.strokeColor = nil;
    ctx.fillOpacity = nil;
    ctx.strokeOpacity = nil;
    ctx.linearGradient = nil;
    ctx.radialGradient = nil;
    ctx.getWidth = function() {
        return getMax(points.map(function(p) {
            return p[0];
        }));
    };
    ctx.getHeight = function() {
        return getMax(points.map(function(p) {
            return p[1];
        }));
    };
    return ctx;
};
/**
 * Yoga canvas measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} canvas width and height
 */ var measureCanvas = function measureCanvas(page, node) {
    return function() {
        var imageMargin = getMargin(node);
        var pagePadding = getPadding(page);
        var pageArea = isHeightAuto(page) ? Infinity : page.box.height - pagePadding.paddingTop - pagePadding.paddingBottom - imageMargin.marginTop - imageMargin.marginBottom - SAFETY_HEIGHT;
        var ctx = measureCtx();
        node.props.paint(ctx);
        var width = ctx.getWidth();
        var height = Math.min(pageArea, ctx.getHeight());
        return {
            height: height,
            width: width
        };
    };
};
var YOGA_CONFIG = (0, _yogaDefault.default).Config.create();
YOGA_CONFIG.setPointScaleFactor(0);
var isType$1 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg = isType$1(_primitives.Svg);
var isText$2 = isType$1(_primitives.Text);
var isNote = isType$1(_primitives.Note);
var isPage = isType$1(_primitives.Page);
var isImage = isType$1(_primitives.Image);
var isCanvas = isType$1(_primitives.Canvas);
var isTextInstance$1 = isType$1(_primitives.TextInstance);
var setNodeHeight = function setNodeHeight(node) {
    var value = isPage(node) ? node.box.height : node.style.height;
    return setHeight(value);
};
/**
 * Set styles valeus into yoga node before layout calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */ var setYogaValues = function setYogaValues(node) {
    (0, _fns.compose)(setNodeHeight(node), setWidth(node.style.width), setMinWidth(node.style.minWidth), setMaxWidth(node.style.maxWidth), setMinHeight(node.style.minHeight), setMaxHeight(node.style.maxHeight), setMarginTop(node.style.marginTop), setMarginRight(node.style.marginRight), setMarginBottom(node.style.marginBottom), setMarginLeft(node.style.marginLeft), setPaddingTop(node.style.paddingTop), setPaddingRight(node.style.paddingRight), setPaddingBottom(node.style.paddingBottom), setPaddingLeft(node.style.paddingLeft), setPositionType(node.style.position), setPositionTop(node.style.top), setPositionRight(node.style.right), setPositionBottom(node.style.bottom), setPositionLeft(node.style.left), setBorderTop(node.style.borderTopWidth), setBorderRight(node.style.borderRightWidth), setBorderBottom(node.style.borderBottomWidth), setBorderLeft(node.style.borderLeftWidth), setDisplay(node.style.display), setFlexDirection(node.style.flexDirection), setAlignSelf(node.style.alignSelf), setAlignContent(node.style.alignContent), setAlignItems(node.style.alignItems), setJustifyContent(node.style.justifyContent), setFlexWrap(node.style.flexWrap), setOverflow(node.style.overflow), setAspectRatio(node.style.aspectRatio), setFlexBasis(node.style.flexBasis), setFlexGrow(node.style.flexGrow), setFlexShrink(node.style.flexShrink), setRowGap(node.style.rowGap), setColumnGap(node.style.columnGap))(node);
};
/**
 * Inserts child into parent' yoga node
 *
 * @param {Object} parent
 * @param {Object} node
 * @param {Object} node
 */ var insertYogaNodes = function insertYogaNodes(parent) {
    return function(child) {
        parent.insertChild(child.yogaNode, parent.getChildCount());
        return child;
    };
};
var setMeasureFunc = function setMeasureFunc(node, page, fontStore) {
    var yogaNode = node.yogaNode;
    if (isText$2(node)) yogaNode.setMeasureFunc(measureText(page, node, fontStore));
    if (isImage(node)) yogaNode.setMeasureFunc(measureImage(page, node));
    if (isCanvas(node)) yogaNode.setMeasureFunc(measureCanvas(page, node));
    if (isSvg(node)) yogaNode.setMeasureFunc(measureCanvas$1(page, node));
    return node;
};
var isLayoutElement = function isLayoutElement(node) {
    return !isText$2(node) && !isNote(node) && !isSvg(node);
};
/**
 * Creates and add yoga node to document tree
 * Handles measure function for text and image nodes
 *
 * @param {Object} node
 * @returns {Object} node with appended yoga node
 */ var createYogaNodes = function createYogaNodes(page, fontStore) {
    return function(node) {
        var yogaNode = (0, _yogaDefault.default).Node.createWithConfig(YOGA_CONFIG);
        var result = Object.assign({}, node, {
            yogaNode: yogaNode
        });
        setYogaValues(result);
        if (isLayoutElement(node) && node.children) {
            var resolveChild = (0, _fns.compose)(insertYogaNodes(yogaNode), createYogaNodes(page, fontStore));
            result.children = node.children.map(resolveChild);
        }
        setMeasureFunc(result, page, fontStore);
        return result;
    };
};
/**
 * Performs yoga calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */ var calculateLayout = function calculateLayout(page) {
    page.yogaNode.calculateLayout();
    return page;
};
/**
 * Saves Yoga layout result into 'box' attribute of node
 *
 * @param {Object} node
 * @returns {Object} node with box data
 */ var persistDimensions = function persistDimensions(node) {
    if (isTextInstance$1(node)) return node;
    var box = Object.assign(getPadding(node), getMargin(node), getBorderWidth(node), getPosition(node), getDimension(node));
    var newNode = Object.assign({}, node, {
        box: box
    });
    if (!node.children) return newNode;
    var children = node.children.map(persistDimensions);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Removes yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */ var destroyYogaNodes = function destroyYogaNodes(node) {
    var newNode = Object.assign({}, node);
    delete newNode.yogaNode;
    if (!node.children) return newNode;
    var children = node.children.map(destroyYogaNodes);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Free yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */ var freeYogaNodes = function freeYogaNodes(node) {
    if (node.yogaNode) node.yogaNode.freeRecursive();
    return node;
};
/**
 * Calculates page object layout using Yoga.
 * Takes node values from 'box' and 'style' attributes, and persist them back into 'box'
 * Destroy yoga values at the end.
 *
 * @param {Object} page object
 * @returns {Object} page object with correct 'box' layout attributes
 */ var resolvePageDimensions = function resolvePageDimensions(page, fontStore) {
    if ((0, _fns.isNil)(page)) return null;
    return (0, _fns.compose)(destroyYogaNodes, freeYogaNodes, persistDimensions, calculateLayout, createYogaNodes(page, fontStore))(page);
};
/**
 * Calculates root object layout using Yoga.
 *
 * @param {Object} root object
 * @returns {Object} root object with correct 'box' layout attributes
 */ var resolveDimensions = function resolveDimensions(node, fontStore) {
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return resolvePageDimensions(child, fontStore);
    };
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var isText$1 = function isText(node) {
    return node.type === _primitives.Text;
};
// Prevent splitting elements by low decimal numbers
var SAFTY_THRESHOLD = 0.001;
var assingChildren = function assingChildren(children, node) {
    return Object.assign({}, node, {
        children: children
    });
};
var getTop = function getTop(node) {
    var _node$box;
    return ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
};
var allFixed = function allFixed(nodes) {
    return nodes.every(isFixed);
};
var isDynamic = function isDynamic(node) {
    var _node$props;
    return !(0, _fns.isNil)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.render);
};
var relayoutPage = (0, _fns.compose)(resolveTextLayout, resolveInheritance, resolvePageDimensions);
var warnUnavailableSpace = function warnUnavailableSpace(node) {
    console.warn("Node of type " + node.type + " can't wrap between pages and it's bigger than available page height");
};
var splitNodes = function splitNodes(height, contentArea, nodes) {
    var currentChildren = [];
    var nextChildren = [];
    for(var i = 0; i < nodes.length; i += 1){
        var child = nodes[i];
        var futureNodes = nodes.slice(i + 1);
        var futureFixedNodes = futureNodes.filter(isFixed);
        var nodeTop = getTop(child);
        var nodeHeight = child.box.height;
        var isOutside = height <= nodeTop;
        var shouldBreak$1 = shouldBreak(child, futureNodes, height);
        var shouldSplit = height + SAFTY_THRESHOLD < nodeTop + nodeHeight;
        var canWrap = getWrap(child);
        var fitsInsidePage = nodeHeight <= contentArea;
        if (isFixed(child)) {
            nextChildren.push(child);
            currentChildren.push(child);
            continue;
        }
        if (isOutside) {
            var box = Object.assign({}, child.box, {
                top: child.box.top - height
            });
            var next = Object.assign({}, child, {
                box: box
            });
            nextChildren.push(next);
            continue;
        }
        if (!fitsInsidePage && !canWrap) {
            currentChildren.push(child);
            nextChildren.push.apply(nextChildren, futureNodes);
            warnUnavailableSpace(child);
            break;
        }
        if (shouldBreak$1) {
            var _box = Object.assign({}, child.box, {
                top: child.box.top - height
            });
            var props = Object.assign({}, child.props, {
                wrap: true,
                break: false
            });
            var _next = Object.assign({}, child, {
                box: _box,
                props: props
            });
            currentChildren.push.apply(currentChildren, futureFixedNodes);
            nextChildren.push.apply(nextChildren, [
                _next
            ].concat(futureNodes));
            break;
        }
        if (shouldSplit) {
            var _split = split(child, height, contentArea), currentChild = _split[0], nextChild = _split[1];
            // All children are moved to the next page, it doesn't make sense to show the parent on the current page
            if (child.children.length > 0 && currentChild.children.length === 0) {
                var _box2 = Object.assign({}, child.box, {
                    top: child.box.top - height
                });
                var _next2 = Object.assign({}, child, {
                    box: _box2
                });
                currentChildren.push.apply(currentChildren, futureFixedNodes);
                nextChildren.push.apply(nextChildren, [
                    _next2
                ].concat(futureNodes));
                break;
            }
            if (currentChild) currentChildren.push(currentChild);
            if (nextChild) nextChildren.push(nextChild);
            continue;
        }
        currentChildren.push(child);
    }
    return [
        currentChildren,
        nextChildren
    ];
};
var splitChildren = function splitChildren(height, contentArea, node) {
    var children = node.children || [];
    var availableHeight = height - getTop(node);
    return splitNodes(availableHeight, contentArea, children);
};
var splitView = function splitView(node, height, contentArea) {
    var _splitNode = splitNode(node, height), currentNode = _splitNode[0], nextNode = _splitNode[1];
    var _splitChildren = splitChildren(height, contentArea, node), currentChilds = _splitChildren[0], nextChildren = _splitChildren[1];
    return [
        assingChildren(currentChilds, currentNode),
        assingChildren(nextChildren, nextNode)
    ];
};
var split = function split(node, height, contentArea) {
    return isText$1(node) ? splitText(node, height) : splitView(node, height, contentArea);
};
var shouldResolveDynamicNodes = function shouldResolveDynamicNodes(node) {
    var children = node.children || [];
    return isDynamic(node) || children.some(shouldResolveDynamicNodes);
};
var resolveDynamicNodes = function resolveDynamicNodes(props, node) {
    var isNodeDynamic = isDynamic(node);
    // Call render prop on dynamic nodes and append result to children
    var resolveChildren = function resolveChildren(children) {
        if (children === void 0) children = [];
        if (isNodeDynamic) {
            var res = node.props.render(props);
            return createInstances(res).filter(Boolean).map(function(n) {
                return resolveDynamicNodes(props, n);
            });
        }
        return children.map(function(c) {
            return resolveDynamicNodes(props, c);
        });
    };
    // We reset dynamic text box so it can be computed again later on
    var resetHeight = isNodeDynamic && isText$1(node);
    var box = resetHeight ? (0, _extendsDefault.default)({}, node.box, {
        height: 0
    }) : node.box;
    var children = resolveChildren(node.children);
    var lines = isNodeDynamic ? null : node.lines;
    return Object.assign({}, node, {
        box: box,
        lines: lines,
        children: children
    });
};
var resolveDynamicPage = function resolveDynamicPage(props, page, fontStore) {
    if (shouldResolveDynamicNodes(page)) {
        var resolvedPage = resolveDynamicNodes(props, page);
        return relayoutPage(resolvedPage, fontStore);
    }
    return page;
};
var splitPage = function splitPage(page, pageNumber, fontStore) {
    var wrapArea = getWrapArea(page);
    var contentArea = getContentArea(page);
    var dynamicPage = resolveDynamicPage({
        pageNumber: pageNumber
    }, page, fontStore);
    var height = page.style.height;
    var _splitNodes = splitNodes(wrapArea, contentArea, dynamicPage.children), currentChilds = _splitNodes[0], nextChilds = _splitNodes[1];
    var relayout = function relayout(node) {
        return relayoutPage(node, fontStore);
    };
    var currentBox = (0, _extendsDefault.default)({}, page.box, {
        height: height
    });
    var currentPage = relayout(Object.assign({}, page, {
        box: currentBox,
        children: currentChilds
    }));
    if (nextChilds.length === 0 || allFixed(nextChilds)) return [
        currentPage,
        null
    ];
    var nextBox = (0, _fns.omit)("height", page.box);
    var nextProps = (0, _fns.omit)("bookmark", page.props);
    var nextPage = relayout(Object.assign({}, page, {
        props: nextProps,
        box: nextBox,
        children: nextChilds
    }));
    return [
        currentPage,
        nextPage
    ];
};
var resolvePageIndices = function resolvePageIndices(fontStore, page, pageNumber, pages) {
    var totalPages = pages.length;
    var props = {
        totalPages: totalPages,
        pageNumber: pageNumber + 1,
        subPageNumber: page.subPageNumber + 1,
        subPageTotalPages: page.subPageTotalPages
    };
    return resolveDynamicPage(props, page, fontStore);
};
var assocSubPageData = function assocSubPageData(subpages) {
    return subpages.map(function(page, i) {
        return (0, _extendsDefault.default)({}, page, {
            subPageNumber: i,
            subPageTotalPages: subpages.length
        });
    });
};
var dissocSubPageData = function dissocSubPageData(page) {
    return (0, _fns.omit)([
        "subPageNumber",
        "subPageTotalPages"
    ], page);
};
var paginate = function paginate(page, pageNumber, fontStore) {
    var _page$props;
    if (!page) return [];
    if (((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.wrap) === false) return [
        page
    ];
    var splittedPage = splitPage(page, pageNumber, fontStore);
    var pages = [
        splittedPage[0]
    ];
    var nextPage = splittedPage[1];
    while(nextPage !== null){
        splittedPage = splitPage(nextPage, pageNumber + pages.length, fontStore);
        pages.push(splittedPage[0]);
        nextPage = splittedPage[1];
    }
    return pages;
};
/**
 * Performs pagination. This is the step responsible of breaking the whole document
 * into pages following pagiation rules, such as `fixed`, `break` and dynamic nodes.
 *
 * @param {Object} node
 * @param {Object} fontStore font store
 * @returns {Object} layout node
 */ var resolvePagination = function resolvePagination(doc, fontStore) {
    var pages = [];
    var pageNumber = 1;
    for(var i = 0; i < doc.children.length; i += 1){
        var page = doc.children[i];
        var subpages = paginate(page, pageNumber, fontStore);
        subpages = assocSubPageData(subpages);
        pageNumber += subpages.length;
        pages = pages.concat(subpages);
    }
    pages = pages.map(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return dissocSubPageData(resolvePageIndices.apply(void 0, [
            fontStore
        ].concat(args)));
    });
    return assingChildren(pages, doc);
};
/*
 * Translates page percentage horizontal paddings in fixed ones
 *
 * @param {Object} page container
 * @param {String} padding value
 * @returns {Object} translated padding value
 */ var resolvePageHorizontalPadding = function resolvePageHorizontalPadding(container) {
    return function(value) {
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * container.width : value;
    };
};
/**
 * Translates page percentage vertical paddings in fixed ones
 *
 * @param {Object} page container
 * @param {String} padding value
 * @returns {Object} translated padding value
 */ var resolvePageVerticalPadding = function resolvePageVerticalPadding(container) {
    return function(value) {
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * container.height : value;
    };
};
/**
 * Translates page percentage paddings in fixed ones
 *
 * @param {Object} page
 * @returns {Object} page with fixed paddings
 */ var resolvePagePaddings = function resolvePagePaddings(page) {
    var container = page.style;
    var style = (0, _fns.evolve)({
        paddingTop: resolvePageVerticalPadding(container),
        paddingLeft: resolvePageHorizontalPadding(container),
        paddingRight: resolvePageHorizontalPadding(container),
        paddingBottom: resolvePageVerticalPadding(container)
    }, page.style);
    return Object.assign({}, page, {
        style: style
    });
};
/**
 * Translates all pages percentage paddings in fixed ones
 * This has to be computed from pages calculated size and not by Yoga
 * because at this point we didn't performed pagination yet.
 *
 * @param {Object} document root
 * @returns {Object} document root with translated page paddings
 */ var resolvePagesPaddings = function resolvePagesPaddings(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePagePaddings);
    return Object.assign({}, root, {
        children: children
    });
};
/**
 *
 * @param {Object} container width and height
 * @param {String | Number} value border radius value
 * @returns {Number} fixed border radius value
 */ var resolveRadius = function resolveRadius(container) {
    return function(value) {
        if (!value) return undefined;
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * Math.min(container.width, container.height) : value;
    };
};
/**
 * Transforms percent border radius into fixed values
 *
 * @param {Object} node
 * @returns {Object} node
 */ var resolvePercentRadius = function resolvePercentRadius(node) {
    var style = (0, _fns.evolve)({
        borderTopLeftRadius: resolveRadius(node.box),
        borderTopRightRadius: resolveRadius(node.box),
        borderBottomRightRadius: resolveRadius(node.box),
        borderBottomLeftRadius: resolveRadius(node.box)
    }, node.style || {});
    var newNode = Object.assign({}, node, {
        style: style
    });
    if (!node.children) return newNode;
    var children = node.children.map(resolvePercentRadius);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Transform percent height into fixed
 *
 * @param {String | number} height
 * @return {number} height
 */ var transformHeight = function transformHeight(pageArea, height) {
    var match = (0, _fns.matchPercent)(height);
    return match ? match.percent * pageArea : height;
};
/**
 * Get page area (height minus paddings)
 *
 * @param {Object} page
 * @return {number} page area
 */ var getPageArea = function getPageArea(page) {
    var _page$style, _page$style2;
    var pageHeight = page.style.height;
    var pagePaddingTop = ((_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.paddingTop) || 0;
    var pagePaddingBottom = ((_page$style2 = page.style) === null || _page$style2 === void 0 ? void 0 : _page$style2.paddingBottom) || 0;
    return pageHeight - pagePaddingTop - pagePaddingBottom;
};
/**
 * Transform node percent height to fixed
 *
 * @param {Object} page
 * @param {Object} node
 * @return {Object} transformed node
 */ var resolveNodePercentHeight = function resolveNodePercentHeight(page, node) {
    var _page$style3, _node$style;
    if ((0, _fns.isNil)((_page$style3 = page.style) === null || _page$style3 === void 0 ? void 0 : _page$style3.height)) return node;
    if ((0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.height)) return node;
    var pageArea = getPageArea(page);
    var height = transformHeight(pageArea, node.style.height);
    var style = Object.assign({}, node.style, {
        height: height
    });
    return Object.assign({}, node, {
        style: style
    });
};
/**
 * Transform page immediate children with percent height to fixed
 *
 * @param {Object} page
 * @return {Object} transformed page
 */ var resolvePagePercentHeight = function resolvePagePercentHeight(page) {
    if (!page.children) return page;
    var resolveChild = function resolveChild(child) {
        return resolveNodePercentHeight(page, child);
    };
    var children = page.children.map(resolveChild);
    return Object.assign({}, page, {
        children: children
    });
};
/**
 * Transform all page immediate children with percent height to fixed.
 * This is needed for computing correct dimensions on pre-pagination layout.
 *
 * @param {Object} document root
 * @return {Object} transformed document root
 */ var resolvePercentHeight = function resolvePercentHeight(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePagePercentHeight);
    return Object.assign({}, root, {
        children: children
    });
};
var isType = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isLink = isType(_primitives.Link);
var isText = isType(_primitives.Text);
var isTextInstance = isType(_primitives.TextInstance);
/**
 * Checks if node has render prop
 *
 * @param {Object} node
 * @returns {Boolean} has render prop?
 */ var hasRenderProp = function hasRenderProp(node) {
    var _node$props;
    return !!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.render);
};
/**
 * Checks if node is text type (Text or TextInstance)
 *
 * @param {Object} node
 * @returns {Boolean} are all children text instances?
 */ var isTextType = function isTextType(node) {
    return isText(node) || isTextInstance(node);
};
/**
 * Checks if is tet link that needs to be wrapped in Text
 *
 * @param {Object} node
 * @returns {Boolean} are all children text instances?
 */ var isTextLink = function isTextLink(node) {
    var children = node.children || [];
    // Text string inside a Link
    if (children.every(isTextInstance)) return true;
    // Text node inside a Link
    if (children.every(isText)) return false;
    return children.every(isTextType);
};
/**
 * Wraps node children inside Text node
 *
 * @param {Object} node
 * @returns {Boolean} node with intermediate Text child
 */ var wrapText = function wrapText(node) {
    var textElement = {
        type: _primitives.Text,
        props: {},
        style: {},
        box: {},
        children: node.children
    };
    return Object.assign({}, node, {
        children: [
            textElement
        ]
    });
};
var transformLink = function transformLink(node) {
    if (!isLink(node)) return node;
    // If has render prop substitute the instance by a Text, that will
    // ultimately render the inline Link via the textkit PDF renderer.
    if (hasRenderProp(node)) return Object.assign({}, node, {
        type: _primitives.Text
    });
    // If is a text link (either contains Text or TextInstalce), wrap it
    // inside a Text element so styles are applied correctly
    if (isTextLink(node)) return wrapText(node);
    return node;
};
/**
 * Transforms Link layout to correctly render text and dynamic rendered links
 *
 * @param {Object} node
 * @returns {Object} node with link substitution
 */ var resolveLinkSubstitution = function resolveLinkSubstitution(node) {
    if (!node.children) return node;
    var resolveChild = (0, _fns.compose)(transformLink, resolveLinkSubstitution);
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var layout = (0, _fns.asyncCompose)(resolveZIndex, resolveOrigin, resolvePagination, resolveTextLayout, resolvePercentRadius, resolveDimensions, resolveSvg, resolveAssets, resolveInheritance, resolvePercentHeight, resolvePagesPaddings, resolveStyles, resolveLinkSubstitution, resolveBookmarks, resolvePageSizes);

},{"@react-pdf/fns":"3vobK","@react-pdf/primitives":"bti5i","@react-pdf/stylesheet":"5hac5","@react-pdf/textkit":"4z9xT","@babel/runtime/helpers/createClass":"4S2iS","@react-pdf/pdfkit":"kKgRa","@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@babel/runtime/helpers/extends":"lKkcq","emoji-regex":"5Hm5v","@react-pdf/image":"l7pXI","@react-pdf/yoga":"26m2y","@babel/runtime/helpers/objectWithoutPropertiesLoose":"6F7Pt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3vobK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjust", ()=>adjust);
parcelHelpers.export(exports, "asyncCompose", ()=>asyncCompose);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "castArray", ()=>castArray);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "dropLast", ()=>dropLast);
parcelHelpers.export(exports, "evolve", ()=>evolve);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "last", ()=>last);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "matchPercent", ()=>matchPercent);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
/**
 * Applies a function to the value at the given index of an array

 * @param {number} index
 * @param {function} fn
 * @param {array} collection
 * @returns copy of the array with the element at the given index replaced with the result of the function application.
 */ var adjust = function adjust(index, fn, collection) {
    var _Object$assign;
    if (index >= 0 && index >= collection.length) return collection;
    if (index < 0 && Math.abs(index) > collection.length) return collection;
    var i = index < 0 ? collection.length + index : index;
    return Object.assign([], collection, (_Object$assign = {}, _Object$assign[i] = fn(collection[i]), _Object$assign));
};
var reverse = function reverse(list) {
    return Array.prototype.slice.call(list, 0).reverse();
};
/**
 * Performs right-to-left function composition with async functions support
 *
 * @param  {...any} functions
 */ var asyncCompose = function asyncCompose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(value) {
            var result, reversedFns, _len2, args, _key2, i, fn, _args = arguments;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        result = value;
                        reversedFns = reverse(fns);
                        for(_len2 = _args.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = _args[_key2];
                        i = 0;
                    case 4:
                        if (!(i < reversedFns.length)) {
                            _context.next = 12;
                            break;
                        }
                        fn = reversedFns[i];
                        _context.next = 8;
                        return fn.apply(void 0, [
                            result
                        ].concat(args));
                    case 8:
                        result = _context.sent;
                    case 9:
                        i += 1;
                        _context.next = 4;
                        break;
                    case 12:
                        return _context.abrupt("return", result);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Capitalize first letter of each word
 *
 * @param {String} string
 * @returns {String} capitalized string
 */ var capitalize = function capitalize(value) {
    if (!value) return value;
    return value.replace(/(^|\s)\S/g, function(l) {
        return l.toUpperCase();
    });
};
/**
 * Casts value to array
 *
 * @param {any} value
 * @returns {Array} casted value
 */ var castArray = function castArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
/* eslint-disable no-await-in-loop */ /**
 * Performs right-to-left function composition
 *
 * @param  {...any} functions
 */ var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(value) {
        var result = value;
        var reversedFns = reverse(fns);
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        for(var i = 0; i < reversedFns.length; i += 1){
            var fn = reversedFns[i];
            result = fn.apply(void 0, [
                result
            ].concat(args));
        }
        return result;
    };
};
var dropLast = function dropLast(array) {
    return array.slice(0, array.length - 1);
};
var evolve = function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var keys = Object.keys(object);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var transformation = transformations[key];
        var type = typeof transformation;
        if (type === "function") result[key] = transformation(object[key]);
        else if (transformation && type === "object") result[key] = evolve(transformation, object[key]);
        else result[key] = object[key];
    }
    return result;
};
var isNil = function isNil(value) {
    return value === null || value === undefined;
};
var get = function get(target, path, defaultValue) {
    if (isNil(target)) return defaultValue;
    var _path = castArray(path);
    var result = target;
    for(var i = 0; i < _path.length; i += 1){
        if (isNil(result)) return undefined;
        result = result[_path[i]];
    }
    return isNil(result) ? defaultValue : result;
};
var last = function last(value) {
    return value === "" ? "" : value[value.length - 1];
};
var mapValues = function mapValues(object, fn) {
    var entries = Object.entries(object);
    return entries.reduce(function(acc, _ref, index) {
        var key = _ref[0], value = _ref[1];
        acc[key] = fn(value, key, index);
        return acc;
    }, {});
};
var isPercent = function isPercent(value) {
    return /((-)?\d+\.?\d*)%/g.exec(value);
};
/**
 * Get percentage value of input
 *
 * @param {String} value
 * @returns {Object} percent value (if matches)
 */ var matchPercent = function matchPercent(value) {
    var match = isPercent(value);
    if (match) {
        var f = parseFloat(match[1], 10);
        var percent = f / 100;
        return {
            percent: percent,
            value: f
        };
    }
    return null;
};
var omit = function omit(keys, object) {
    var _keys = castArray(keys);
    var copy = Object.assign({}, object);
    _keys.forEach(function(key) {
        delete copy[key];
    });
    return copy;
};
var pick = function pick(keys, obj) {
    var result = {};
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        if (key in obj) result[key] = obj[key];
    }
    return result;
};
/**
 * Capitalize first letter of string
 *
 * @param {String} string
 * @returns {String} capitalized string
 */ var upperFirst = function upperFirst(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};

},{"@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5hac5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveStyles);
parcelHelpers.export(exports, "flatten", ()=>flatten);
parcelHelpers.export(exports, "processTransform", ()=>processTransform);
parcelHelpers.export(exports, "transformColor", ()=>transformColor);
var _fns = require("@react-pdf/fns");
var _parseJs = require("postcss-value-parser/lib/parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _unitJs = require("postcss-value-parser/lib/unit.js");
var _unitJsDefault = parcelHelpers.interopDefault(_unitJs);
var _hslToHex = require("hsl-to-hex");
var _hslToHexDefault = parcelHelpers.interopDefault(_hslToHex);
var _colorString = require("color-string");
var _colorStringDefault = parcelHelpers.interopDefault(_colorString);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _mediaEngine = require("media-engine");
var _mediaEngineDefault = parcelHelpers.interopDefault(_mediaEngine);
// https://developer.mozilla.org/en-US/docs/Web/CSS/flex#values
// TODO: change flex defaults to [0, 1, 'auto'] as in spec in next major release
var flexDefaults = [
    1,
    1,
    0
];
/**
 * @type {(number | 'auto')[]}
 */ var flexAuto = [
    1,
    1,
    "auto"
];
var expandFlex = function expandFlex(key, value) {
    /**
   * @type {(number | 'auto')[]}
   */ var defaults = flexDefaults;
    var matches = [];
    if (value === "auto") defaults = flexAuto;
    else matches = ("" + value).split(" ");
    var flexGrow = matches[0] || defaults[0];
    var flexShrink = matches[1] || defaults[1];
    var flexBasis = matches[2] || defaults[2];
    return {
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis
    };
};
/* eslint-disable no-plusplus */ // This file is ran directly with Node - needs to have .js extension
// eslint-disable-next-line import/extensions
var BOX_MODEL_UNITS = "px,in,mm,cm,pt,%,vw,vh";
var logError = function logError(style, value) {
    console.error("\n    @react-pdf/stylesheet parsing error:\n\n    " + style + ": " + value + ",\n    " + " ".repeat(style.length + 2) + "^\n    Unsupported " + style + " value format\n  ");
};
/**
 * @param {Object} options
 * @param {Function} [options.expandsTo]
 * @param {number} [options.maxValues]
 * @param {boolean} [options.autoSupported]
 */ var expandBoxModel = function expandBoxModel(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, expandsTo = _ref.expandsTo, _ref$maxValues = _ref.maxValues, maxValues = _ref$maxValues === void 0 ? 1 : _ref$maxValues, _ref$autoSupported = _ref.autoSupported, autoSupported = _ref$autoSupported === void 0 ? false : _ref$autoSupported;
    return function(model, value) {
        var _ref2;
        var nodes = (0, _parseJsDefault.default)("" + value);
        var parts = [];
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            // value contains `calc`, `url` or other css function
            // `,`, `/` or strings that unsupported by margin and padding
            if (node.type === "function" || node.type === "string" || node.type === "div") {
                logError(model, value);
                return {};
            }
            if (node.type === "word") {
                if (node.value === "auto" && autoSupported) parts.push(node.value);
                else {
                    var result = (0, _unitJsDefault.default)(node.value);
                    // when unit isn't specified this condition is true
                    if (result && BOX_MODEL_UNITS.includes(result.unit)) parts.push(node.value);
                    else {
                        logError(model, value);
                        return {};
                    }
                }
            }
        }
        // checks that we have enough parsed values
        if (parts.length > maxValues) {
            logError(model, value);
            return {};
        }
        var first = parts[0];
        if (expandsTo) {
            var second = parts[1] || parts[0];
            var third = parts[2] || parts[0];
            var fourth = parts[3] || parts[1] || parts[0];
            return expandsTo({
                first: first,
                second: second,
                third: third,
                fourth: fourth
            });
        }
        return _ref2 = {}, _ref2[model] = first, _ref2;
    };
};
var processMargin = expandBoxModel({
    expandsTo: function expandsTo(_ref) {
        var first = _ref.first, second = _ref.second, third = _ref.third, fourth = _ref.fourth;
        return {
            marginTop: first,
            marginRight: second,
            marginBottom: third,
            marginLeft: fourth
        };
    },
    maxValues: 4,
    autoSupported: true
});
var processMarginVertical = expandBoxModel({
    expandsTo: function expandsTo(_ref2) {
        var first = _ref2.first, second = _ref2.second;
        return {
            marginTop: first,
            marginBottom: second
        };
    },
    maxValues: 2,
    autoSupported: true
});
var processMarginHorizontal = expandBoxModel({
    expandsTo: function expandsTo(_ref3) {
        var first = _ref3.first, second = _ref3.second;
        return {
            marginRight: first,
            marginLeft: second
        };
    },
    maxValues: 2,
    autoSupported: true
});
var processMarginSingle = expandBoxModel({
    autoSupported: true
});
var BORDER_SHORTHAND_REGEX = /(-?\d+(\.\d+)?(px|in|mm|cm|pt|vw|vh|px)?)\s(\S+)\s(.+)/;
var matchBorderShorthand = function matchBorderShorthand(value) {
    return value.match(BORDER_SHORTHAND_REGEX) || [];
};
var expandBorders = function expandBorders(key, value) {
    var match = matchBorderShorthand("" + value);
    if (match) {
        var color = match[5] || value;
        var style = match[4] || value;
        var width = match[1] || value;
        if (key.match(/(Top|Right|Bottom|Left)$/)) {
            var _ref;
            return _ref = {}, _ref[key + "Color"] = color, _ref[key + "Style"] = style, _ref[key + "Width"] = width, _ref;
        }
        if (key.match(/Color$/)) return {
            borderTopColor: color,
            borderRightColor: color,
            borderBottomColor: color,
            borderLeftColor: color
        };
        if (key.match(/Style$/)) return {
            borderTopStyle: style,
            borderRightStyle: style,
            borderBottomStyle: style,
            borderLeftStyle: style
        };
        if (key.match(/Width$/)) return {
            borderTopWidth: width,
            borderRightWidth: width,
            borderBottomWidth: width,
            borderLeftWidth: width
        };
        if (key.match(/Radius$/)) return {
            borderTopLeftRadius: value,
            borderTopRightRadius: value,
            borderBottomRightRadius: value,
            borderBottomLeftRadius: value
        };
        return {
            borderTopColor: color,
            borderTopStyle: style,
            borderTopWidth: width,
            borderRightColor: color,
            borderRightStyle: style,
            borderRightWidth: width,
            borderBottomColor: color,
            borderBottomStyle: style,
            borderBottomWidth: width,
            borderLeftColor: color,
            borderLeftStyle: style,
            borderLeftWidth: width
        };
    }
    return value;
};
var processPadding = expandBoxModel({
    expandsTo: function expandsTo(_ref) {
        var first = _ref.first, second = _ref.second, third = _ref.third, fourth = _ref.fourth;
        return {
            paddingTop: first,
            paddingRight: second,
            paddingBottom: third,
            paddingLeft: fourth
        };
    },
    maxValues: 4
});
var processPaddingVertical = expandBoxModel({
    expandsTo: function expandsTo(_ref2) {
        var first = _ref2.first, second = _ref2.second;
        return {
            paddingTop: first,
            paddingBottom: second
        };
    },
    maxValues: 2
});
var processPaddingHorizontal = expandBoxModel({
    expandsTo: function expandsTo(_ref3) {
        var first = _ref3.first, second = _ref3.second;
        return {
            paddingRight: first,
            paddingLeft: second
        };
    },
    maxValues: 2
});
var processPaddingSingle = expandBoxModel();
var expandObjectPosition = function expandObjectPosition(key, value) {
    var match = ("" + value).split(" ");
    return {
        objectPositionX: (match === null || match === void 0 ? void 0 : match[0]) || value,
        objectPositionY: (match === null || match === void 0 ? void 0 : match[1]) || value
    };
};
var Y_AXIS_SHORTHANDS = {
    top: true,
    bottom: true
};
var sortTransformOriginPair = function sortTransformOriginPair(a, b) {
    if (Y_AXIS_SHORTHANDS[a]) return 1;
    if (Y_AXIS_SHORTHANDS[b]) return -1;
    return 0;
};
var getTransformOriginPair = function getTransformOriginPair(values) {
    if (!values || values.length === 0) return [
        "center",
        "center"
    ];
    var pair = values.length === 1 ? [
        values[0],
        "center"
    ] : values;
    return pair.sort(sortTransformOriginPair);
};
// Transforms shorthand transformOrigin values
var expandTransformOrigin = function expandTransformOrigin(key, value) {
    var match = ("" + value).split(" ");
    var pair = getTransformOriginPair(match);
    return {
        transformOriginX: pair[0],
        transformOriginY: pair[1]
    };
};
var expandGap = function expandGap(key, value) {
    var match = ("" + value).split(" ");
    return {
        rowGap: (match === null || match === void 0 ? void 0 : match[0]) || value,
        columnGap: (match === null || match === void 0 ? void 0 : match[1]) || value
    };
};
var shorthands = {
    flex: expandFlex,
    gap: expandGap,
    margin: processMargin,
    marginHorizontal: processMarginHorizontal,
    marginVertical: processMarginVertical,
    marginTop: processMarginSingle,
    marginRight: processMarginSingle,
    marginBottom: processMarginSingle,
    marginLeft: processMarginSingle,
    padding: processPadding,
    paddingHorizontal: processPaddingHorizontal,
    paddingVertical: processPaddingVertical,
    paddingTop: processPaddingSingle,
    paddingRight: processPaddingSingle,
    paddingBottom: processPaddingSingle,
    paddingLeft: processPaddingSingle,
    border: expandBorders,
    borderTop: expandBorders,
    borderRight: expandBorders,
    borderBottom: expandBorders,
    borderLeft: expandBorders,
    borderColor: expandBorders,
    borderRadius: expandBorders,
    borderStyle: expandBorders,
    borderWidth: expandBorders,
    objectPosition: expandObjectPosition,
    transformOrigin: expandTransformOrigin
};
/**
 * Transforms style key-value
 *
 * @param {string} key style key
 * @param {string} value style value
 * @returns {string | Number} transformed style values
 */ var expandStyle = function expandStyle(key, value) {
    var _ref;
    return shorthands[key] ? shorthands[key](key, value) : (_ref = {}, _ref[key] = value, _ref);
};
/**
 * Expand the shorthand properties.
 *
 * @param {Object} style object
 * @returns {Object} expanded style object
 */ var expand = function expand(style) {
    if (!style) return style;
    var propsArray = Object.keys(style);
    var resolvedStyle = {};
    for(var i = 0; i < propsArray.length; i += 1){
        var key = propsArray[i];
        var value = style[key];
        var extended = expandStyle(key, value);
        var keys = Object.keys(extended);
        for(var j = 0; j < keys.length; j += 1){
            var propName = keys[j];
            var propValue = extended[propName];
            resolvedStyle[propName] = propValue;
        }
    }
    return resolvedStyle;
};
/**
 * Remove nil values from array
 *
 * @template T
 * @param {(T | null | undefined)[]} array
 * @returns {T[]} array without nils
 */ var compact = function compact(array) {
    return array.filter(Boolean);
};
/**
 * Merges style objects array
 *
 * @param {Object[]} styles style objects array
 * @returns {Object} merged style object
 */ var mergeStyles = function mergeStyles(styles) {
    return styles.reduce(function(acc, style) {
        var s = Array.isArray(style) ? flatten(style) : style;
        Object.keys(s).forEach(function(key) {
            if (s[key] !== null && s[key] !== undefined) acc[key] = s[key];
        });
        return acc;
    }, {});
};
/**
 * Flattens an array of style objects, into one aggregated style object.
 *
 * @param {Object[]} styles style objects array
 * @returns {Object} flattened style object
 */ var flatten = (0, _fns.compose)(mergeStyles, compact, (0, _fns.castArray));
/**
 * Parses scalar value in value and unit pairs
 *
 * @param {string} value scalar value
 * @returns {Object} parsed value
 */ var parseValue = function parseValue(value) {
    var match = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw|px)?$/g.exec(value);
    return match ? {
        value: parseFloat(match[1]),
        unit: match[2] || "pt"
    } : {
        value: value,
        unit: undefined
    };
};
/**
 * Transform given scalar value
 *
 * @param {Object} container
 * @param {string} value styles value
 * @returns {Object} transformed value
 */ var transformUnit = function transformUnit(container, value) {
    var scalar = parseValue(value);
    var dpi = container.dpi || 72;
    var mmFactor = 1 / 25.4 * dpi;
    var cmFactor = 1 / 2.54 * dpi;
    switch(scalar.unit){
        case "in":
            return scalar.value * dpi;
        case "mm":
            return scalar.value * mmFactor;
        case "cm":
            return scalar.value * cmFactor;
        case "vh":
            return scalar.value * (container.height / 100);
        case "vw":
            return scalar.value * (container.width / 100);
        default:
            return scalar.value;
    }
};
var isRgb = function isRgb(value) {
    return /rgba?/g.test(value);
};
var isHsl = function isHsl(value) {
    return /hsla?/g.test(value);
};
/**
 * Transform rgb color to hexa
 *
 * @param {string} value styles value
 * @returns {Object} transformed value
 */ var parseRgb = function parseRgb(value) {
    var rgb = (0, _colorStringDefault.default).get.rgb(value);
    return (0, _colorStringDefault.default).to.hex(rgb);
};
/**
 * Transform Hsl color to hexa
 *
 * @param {string} value styles value
 * @returns {Object} transformed value
 */ var parseHsl = function parseHsl(value) {
    var hsl = (0, _colorStringDefault.default).get.hsl(value).map(Math.round);
    var hex = (0, _hslToHexDefault.default).apply(void 0, hsl);
    return hex.toUpperCase();
};
/**
 * Transform given color to hexa
 *
 * @param {string} value styles value
 * @returns {Object} transformed value
 */ var transformColor = function transformColor(value) {
    if (isRgb(value)) return parseRgb(value);
    if (isHsl(value)) return parseHsl(value);
    return value;
};
var parse = function parse(transformString) {
    var transforms = transformString.trim().split(/\) |\)/);
    // Handle "initial", "inherit", "unset".
    if (transforms.length === 1) return [
        [
            transforms[0],
            true
        ]
    ];
    var parsed = [];
    for(var i = 0; i < transforms.length; i += 1){
        var transform = transforms[i];
        if (transform) {
            var _transform$split = transform.split("("), name = _transform$split[0], rawValue = _transform$split[1];
            var splitChar = rawValue.indexOf(",") >= 0 ? "," : " ";
            var value = rawValue.split(splitChar).map(function(val) {
                return val.trim();
            });
            parsed.push({
                operation: name,
                value: value
            });
        }
    }
    return parsed;
};
var parseAngle = function parseAngle(value) {
    var unitsRegexp = /(-?\d*\.?\d*)(\w*)?/i;
    var _unitsRegexp$exec = unitsRegexp.exec(value), angle = _unitsRegexp$exec[1], unit = _unitsRegexp$exec[2];
    var number = Number.parseFloat(angle);
    return unit === "rad" ? number * 180 / Math.PI : number;
};
var normalizeTransformOperation = function normalizeTransformOperation(_ref) {
    var operation = _ref.operation, value = _ref.value;
    switch(operation){
        case "scale":
            var _value$map = value.map(function(num) {
                return Number.parseFloat(num);
            }), scaleX = _value$map[0], _value$map$ = _value$map[1], scaleY = _value$map$ === void 0 ? scaleX : _value$map$;
            return {
                operation: "scale",
                value: [
                    scaleX,
                    scaleY
                ]
            };
        case "scaleX":
            return {
                operation: "scale",
                value: [
                    Number.parseFloat(value),
                    1
                ]
            };
        case "scaleY":
            return {
                operation: "scale",
                value: [
                    1,
                    Number.parseFloat(value)
                ]
            };
        case "rotate":
            return {
                operation: "rotate",
                value: [
                    parseAngle(value)
                ]
            };
        case "translate":
            return {
                operation: "translate",
                value: value.map(function(num) {
                    return Number.parseFloat(num);
                })
            };
        case "translateX":
            return {
                operation: "translate",
                value: [
                    Number.parseFloat(value),
                    0
                ]
            };
        case "translateY":
            return {
                operation: "translate",
                value: [
                    0,
                    Number.parseFloat(value)
                ]
            };
        case "skew":
            return {
                operation: "skew",
                value: value.map(parseAngle)
            };
        case "skewX":
            return {
                operation: "skew",
                value: [
                    parseAngle(value),
                    0
                ]
            };
        case "skewY":
            return {
                operation: "skew",
                value: [
                    0,
                    parseAngle(value)
                ]
            };
        default:
            return {
                operation: operation,
                value: value.map(function(num) {
                    return Number.parseFloat(num);
                })
            };
    }
};
var normalize = function normalize(operations) {
    return operations.map(function(operation) {
        return normalizeTransformOperation(operation);
    });
};
var processTransform = function processTransform(value) {
    if (typeof value !== "string") return value;
    return normalize(parse(value));
};
var FONT_WEIGHTS = {
    thin: 100,
    hairline: 100,
    ultralight: 200,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    demibold: 600,
    bold: 700,
    ultrabold: 800,
    extrabold: 800,
    heavy: 900,
    black: 900
};
var processFontWeight = function processFontWeight(value) {
    if (!value) return FONT_WEIGHTS.normal;
    if (typeof value === "number") return value;
    var lv = value.toLowerCase();
    if (FONT_WEIGHTS[lv]) return FONT_WEIGHTS[lv];
    return value;
};
var matchNumber = function matchNumber(value) {
    return typeof value === "string" && /^-?\d*\.?\d*$/.test(value);
};
var castFloat = function castFloat(value) {
    if (typeof value !== "string") return value;
    if (matchNumber(value)) return parseFloat(value);
    return value;
};
var offsetKeyword = function offsetKeyword(value) {
    switch(value){
        case "top":
        case "left":
            return "0%";
        case "right":
        case "bottom":
            return "100%";
        case "center":
            return "50%";
        default:
            return null;
    }
};
var transformObjectPosition = function transformObjectPosition(value) {
    return offsetKeyword(value) || castFloat(value);
};
var transformTransformOrigin = function transformTransformOrigin(value) {
    return offsetKeyword(value) || castFloat(value);
};
var handlers = {
    transform: processTransform,
    fontWeight: processFontWeight,
    objectPositionX: transformObjectPosition,
    objectPositionY: transformObjectPosition,
    transformOriginX: transformTransformOrigin,
    transformOriginY: transformTransformOrigin
};
var transformStyle = function transformStyle(key, value, container) {
    var result = handlers[key] ? handlers[key](value) : value;
    return transformColor(transformUnit(container, castFloat(result)));
};
/**
 * @typedef {Function} Transform
 * @param {Object} style styles object
 * @returns {Object} transformed styles
 */ /**
 * Transform styles values
 *
 * @param {Object} container
 * @returns {Transform} transform function
 */ var transform = function transform(container) {
    return function(style) {
        if (!style) return style;
        var propsArray = Object.keys(style);
        var resolvedStyle = {};
        for(var i = 0; i < propsArray.length; i += 1){
            var key = propsArray[i];
            var value = style[key];
            var transformed = transformStyle(key, value, container);
            resolvedStyle[key] = transformed;
        }
        return resolvedStyle;
    };
};
/**
 * Resolves media queries in styles object
 *
 * @param {Object} container
 * @param {Object} styles object
 */ var resolveMediaQueries = function resolveMediaQueries(container, styles) {
    return Object.keys(styles).reduce(function(acc, key) {
        var _extends2;
        if (/@media/.test(key)) {
            var _matchMedia;
            return (0, _extendsDefault.default)({}, acc, (0, _mediaEngineDefault.default)((_matchMedia = {}, _matchMedia[key] = styles[key], _matchMedia), container));
        }
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[key] = styles[key], _extends2));
    }, {});
};
/**
 * Resolves styles
 *
 * @param {Object} container
 * @param {Object} style object
 * @returns {Object} resolved style object
 */ var resolveStyles = function resolveStyles(container, style) {
    var computeMediaQueries = function computeMediaQueries(value) {
        return resolveMediaQueries(container, value);
    };
    return (0, _fns.compose)(transform(container), expand, computeMediaQueries, flatten)(style);
};

},{"@react-pdf/fns":"0LqGK","postcss-value-parser/lib/parse.js":"8TWdZ","postcss-value-parser/lib/unit.js":"9CT8b","hsl-to-hex":"7DyaM","color-string":"fIg9F","@babel/runtime/helpers/extends":"lKkcq","media-engine":"fMRDI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"0LqGK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjust", ()=>adjust);
parcelHelpers.export(exports, "asyncCompose", ()=>asyncCompose);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "castArray", ()=>castArray);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "dropLast", ()=>dropLast);
parcelHelpers.export(exports, "evolve", ()=>evolve);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "last", ()=>last);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "matchPercent", ()=>matchPercent);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "repeat", ()=>repeat);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
/**
 * Applies a function to the value at the given index of an array

 * @param {number} index
 * @param {function} fn
 * @param {array} collection
 * @returns copy of the array with the element at the given index replaced with the result of the function application.
 */ var adjust = function adjust(index, fn, collection) {
    var _Object$assign;
    if (index >= 0 && index >= collection.length) return collection;
    if (index < 0 && Math.abs(index) > collection.length) return collection;
    var i = index < 0 ? collection.length + index : index;
    return Object.assign([], collection, (_Object$assign = {}, _Object$assign[i] = fn(collection[i]), _Object$assign));
};
var reverse = function reverse(list) {
    return Array.prototype.slice.call(list, 0).reverse();
};
/**
 * @typedef {Function} AsyncCompose
 * @param {any} value
 * @param {...any} args
 * @returns {any} result
 */ /**
 * Performs right-to-left function composition with async functions support
 *
 * @param {...Function} fns functions
 * @returns {AsyncCompose} composed function
 */ var asyncCompose = function asyncCompose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(value) {
            var result, reversedFns, _len2, args, _key2, i, fn, _args = arguments;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        result = value;
                        reversedFns = reverse(fns);
                        for(_len2 = _args.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = _args[_key2];
                        i = 0;
                    case 4:
                        if (!(i < reversedFns.length)) {
                            _context.next = 12;
                            break;
                        }
                        fn = reversedFns[i];
                        _context.next = 8;
                        return fn.apply(void 0, [
                            result
                        ].concat(args));
                    case 8:
                        result = _context.sent;
                    case 9:
                        i += 1;
                        _context.next = 4;
                        break;
                    case 12:
                        return _context.abrupt("return", result);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Capitalize first letter of each word
 *
 * @param {string} value string
 * @returns {string} capitalized string
 */ var capitalize = function capitalize(value) {
    if (!value) return value;
    return value.replace(/(^|\s)\S/g, function(l) {
        return l.toUpperCase();
    });
};
/**
 * Casts value to array
 *
 * @template T
 * @param {T|T[]} value value
 * @returns {T[]} array
 */ var castArray = function castArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
/* eslint-disable no-await-in-loop */ /**
 * @typedef {Function} Compose
 * @param {any} value
 * @param {...any} args
 * @returns {any} result
 */ /**
 * Performs right-to-left function composition
 *
 * @param {...Function} fns functions
 * @returns {Compose} composed function
 */ var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(value) {
        var result = value;
        var reversedFns = reverse(fns);
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        for(var i = 0; i < reversedFns.length; i += 1){
            var fn = reversedFns[i];
            result = fn.apply(void 0, [
                result
            ].concat(args));
        }
        return result;
    };
};
var dropLast = function dropLast(array) {
    return array.slice(0, array.length - 1);
};
var evolve = function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var keys = Object.keys(object);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var transformation = transformations[key];
        var type = typeof transformation;
        if (type === "function") result[key] = transformation(object[key]);
        else if (transformation && type === "object") result[key] = evolve(transformation, object[key]);
        else result[key] = object[key];
    }
    return result;
};
var isNil = function isNil(value) {
    return value === null || value === undefined;
};
var get = function get(target, path, defaultValue) {
    if (isNil(target)) return defaultValue;
    var _path = castArray(path);
    var result = target;
    for(var i = 0; i < _path.length; i += 1){
        if (isNil(result)) return undefined;
        result = result[_path[i]];
    }
    return isNil(result) ? defaultValue : result;
};
var last = function last(value) {
    return value === "" ? "" : value[value.length - 1];
};
var mapValues = function mapValues(object, fn) {
    var entries = Object.entries(object);
    return entries.reduce(function(acc, _ref, index) {
        var key = _ref[0], value = _ref[1];
        acc[key] = fn(value, key, index);
        return acc;
    }, {});
};
/**
 * @param {string | number} value
 * @returns {RegExpExecArray | null} match
 */ var isPercent = function isPercent(value) {
    return /((-)?\d+\.?\d*)%/g.exec("" + value);
};
/**
 * Get percentage value of input
 *
 * @param {string | number} value
 * @returns {{ percent: number, value: number } | null} percent value (if matches)
 */ var matchPercent = function matchPercent(value) {
    var match = isPercent(value);
    if (match) {
        var f = parseFloat(match[1]);
        var percent = f / 100;
        return {
            percent: percent,
            value: f
        };
    }
    return null;
};
var omit = function omit(keys, object) {
    var _keys = castArray(keys);
    var copy = Object.assign({}, object);
    _keys.forEach(function(key) {
        delete copy[key];
    });
    return copy;
};
var pick = function pick(keys, obj) {
    var result = {};
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        if (key in obj) result[key] = obj[key];
    }
    return result;
};
var repeat = function repeat(list, length) {
    if (length === void 0) length = 0;
    var result = new Array(length);
    for(var i = 0; i < length; i += 1)result[i] = list;
    return result;
};
/**
 * Capitalize first letter of string
 *
 * @param {string} value string
 * @returns {string} capitalized string
 */ var upperFirst = function upperFirst(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};

},{"@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8TWdZ":[function(require,module,exports) {
var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);
var uLower = "u".charCodeAt(0);
var uUpper = "U".charCodeAt(0);
var plus = "+".charCodeAt(0);
var isUnicodeRange = /^[a-f0-9?-]+$/i;
module.exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos, parenthesesOpenPos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") {
                prev.after = token;
                prev.sourceEndIndex += token.length;
            } else if (code === comma || code === colon || code === slash && value.charCodeAt(next + 1) !== star && (!parent || parent && parent.type === "function" && parent.value !== "calc")) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === singleQuote || code === doubleQuote) {
            next = pos;
            quote = code === singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            token.sourceEndIndex = token.unclosed ? next : next + 1;
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === slash && value.charCodeAt(pos + 1) === star) {
            next = value.indexOf("*/", pos);
            token = {
                type: "comment",
                sourceIndex: pos,
                sourceEndIndex: next + 2
            };
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
                token.sourceEndIndex = next;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Operation within calc
        } else if ((code === slash || code === star) && parent && parent.type === "function" && parent.value === "calc") {
            token = value[pos];
            tokens.push({
                type: "word",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token
            });
            pos += 1;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === slash || code === comma || code === colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if (openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            parenthesesOpenPos = pos;
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(parenthesesOpenPos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== singleQuote && code !== doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (parenthesesOpenPos < whitespacePos) {
                    if (pos !== whitespacePos + 1) token.nodes = [
                        {
                            type: "word",
                            sourceIndex: pos,
                            sourceEndIndex: whitespacePos + 1,
                            value: value.slice(pos, whitespacePos + 1)
                        }
                    ];
                    else token.nodes = [];
                    if (token.unclosed && whitespacePos + 1 !== next) {
                        token.after = "";
                        token.nodes.push({
                            type: "space",
                            sourceIndex: whitespacePos + 1,
                            sourceEndIndex: next,
                            value: value.slice(whitespacePos + 1, next)
                        });
                    } else {
                        token.after = value.slice(whitespacePos + 1, next);
                        token.sourceEndIndex = next;
                    }
                } else {
                    token.after = "";
                    token.nodes = [];
                }
                pos = next + 1;
                token.sourceEndIndex = token.unclosed ? next : pos;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                token.sourceEndIndex = pos + 1;
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if (closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            parent.sourceEndIndex += after.length;
            after = "";
            balanced -= 1;
            stack[stack.length - 1].sourceEndIndex = pos;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === singleQuote || code === doubleQuote || code === comma || code === colon || code === slash || code === openParentheses || code === star && parent && parent.type === "function" && parent.value === "calc" || code === slash && parent.type === "function" && parent.value === "calc" || code === closeParentheses && balanced));
            token = value.slice(pos, next);
            if (openParentheses === code) name = token;
            else if ((uLower === token.charCodeAt(0) || uUpper === token.charCodeAt(0)) && plus === token.charCodeAt(1) && isUnicodeRange.test(token.slice(2))) tokens.push({
                type: "unicode-range",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1){
        stack[pos].unclosed = true;
        stack[pos].sourceEndIndex = value.length;
    }
    return stack[0].nodes;
};

},{}],"9CT8b":[function(require,module,exports) {
var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);
// Check if three code points would start a number
// https://www.w3.org/TR/css-syntax-3/#starts-with-a-number
function likeNumber(value) {
    var code = value.charCodeAt(0);
    var nextCode;
    if (code === plus || code === minus) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        var nextNextCode = value.charCodeAt(2);
        if (nextCode === dot && nextNextCode >= 48 && nextNextCode <= 57) return true;
        return false;
    }
    if (code === dot) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        return false;
    }
    if (code >= 48 && code <= 57) return true;
    return false;
}
// Consume a number
// https://www.w3.org/TR/css-syntax-3/#consume-number
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var code;
    var nextCode;
    var nextNextCode;
    if (length === 0 || !likeNumber(value)) return false;
    code = value.charCodeAt(pos);
    if (code === plus || code === minus) pos++;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code < 48 || code > 57) break;
        pos += 1;
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    if (code === dot && nextCode >= 48 && nextCode <= 57) {
        pos += 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    nextNextCode = value.charCodeAt(pos + 2);
    if ((code === exp || code === EXP) && (nextCode >= 48 && nextCode <= 57 || (nextCode === plus || nextCode === minus) && nextNextCode >= 48 && nextNextCode <= 57)) {
        pos += nextCode === plus || nextCode === minus ? 3 : 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    return {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    };
};

},{}],"7DyaM":[function(require,module,exports) {
// In our case, there's only one dependency
var toRgb = require("467415a3873c50a0");
// Typically all dependencies should be declared at the top of the file.
// Now let's define an API for our module, we're taking hue, saturation and luminosity values and outputting a CSS compatible hex string.
// Hue is in degrees, between 0 and 359. Since degrees a cyclical in nature, we'll support numbers greater than 359 or less than 0 by "spinning" them around until they fall within the 0 to 359 range.
// Saturation and luminosity are both percentages, we'll represent these percentages with whole numbers between 0 and 100. For these numbers we'll need to enforce a maximum and a minimum, anything below 0 will become 0, anything above 100 will become 100.
// Let's write some utility functions to handle this logic:
function max(val, n) {
    return val > n ? n : val;
}
function min(val, n) {
    return val < n ? n : val;
}
function cycle(val) {
    // for safety:
    val = max(val, 1e7);
    val = min(val, -10000000);
    // cycle value:
    while(val < 0)val += 360;
    while(val > 359)val -= 360;
    return val;
}
// Now for the main piece, the `hsl` function:
function hsl(hue, saturation, luminosity) {
    // resolve degrees to 0 - 359 range
    hue = cycle(hue);
    // enforce constraints
    saturation = min(max(saturation, 100), 0);
    luminosity = min(max(luminosity, 100), 0);
    // convert to 0 to 1 range used by hsl-to-rgb-for-reals
    saturation /= 100;
    luminosity /= 100;
    // let hsl-to-rgb-for-reals do the hard work
    var rgb = toRgb(hue, saturation, luminosity);
    // convert each value in the returned RGB array
    // to a 2 character hex value, join the array into
    // a string, prefixed with a hash
    return "#" + rgb.map(function(n) {
        return (256 + n).toString(16).substr(-2);
    }).join("");
}
// In order to make our code into a bona fide module we have to export it:
module.exports = hsl;

},{"467415a3873c50a0":"97t1P"}],"97t1P":[function(require,module,exports) {
// expected hue range: [0, 360)
// expected saturation range: [0, 1]
// expected lightness range: [0, 1]
var hslToRgb = function(hue, saturation, lightness) {
    // based on algorithm from http://en.wikipedia.org/wiki/HSL_and_HSV#Converting_to_RGB
    if (hue == undefined) return [
        0,
        0,
        0
    ];
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var huePrime = hue / 60;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    huePrime = Math.floor(huePrime);
    var red;
    var green;
    var blue;
    if (huePrime === 0) {
        red = chroma;
        green = secondComponent;
        blue = 0;
    } else if (huePrime === 1) {
        red = secondComponent;
        green = chroma;
        blue = 0;
    } else if (huePrime === 2) {
        red = 0;
        green = chroma;
        blue = secondComponent;
    } else if (huePrime === 3) {
        red = 0;
        green = secondComponent;
        blue = chroma;
    } else if (huePrime === 4) {
        red = secondComponent;
        green = 0;
        blue = chroma;
    } else if (huePrime === 5) {
        red = chroma;
        green = 0;
        blue = secondComponent;
    }
    var lightnessAdjustment = lightness - chroma / 2;
    red += lightnessAdjustment;
    green += lightnessAdjustment;
    blue += lightnessAdjustment;
    return [
        Math.abs(Math.round(red * 255)),
        Math.abs(Math.round(green * 255)),
        Math.abs(Math.round(blue * 255))
    ];
};
module.exports = hslToRgb;

},{}],"fMRDI":[function(require,module,exports) {
var Parser = require("87bc0e8707db2e9a");
module.exports = function(queries, options) {
    var result = {};
    Object.keys(queries).forEach(function(query) {
        if (Parser.parse(query).match(options)) Object.assign(result, queries[query]);
    });
    return result;
};

},{"87bc0e8707db2e9a":"e1LT8"}],"e1LT8":[function(require,module,exports) {
var Query = require("65352f2699c24bdf");
var Operator = require("7f5fc0bd01bcfeb3");
var NUMBERS = /[0-9]/;
var LETTERS = /[a-z|\-]/i;
var WHITESPACE = /\s/;
var COLON = /:/;
var COMMA = /,/;
var AND = /and$/;
var AT = /@/;
function tokenizer(input) {
    var current = 0;
    var tokens = [];
    while(current < input.length){
        var char = input[current];
        if (AT.test(char)) {
            char = input[++current];
            while(LETTERS.test(char) && char !== undefined)char = input[++current];
        }
        if (WHITESPACE.test(char) || char === ")" || char === "(") {
            current++;
            continue;
        }
        if (COLON.test(char) || COMMA.test(char)) {
            current++;
            tokens.push({
                type: "operator",
                value: char
            });
            continue;
        }
        if (NUMBERS.test(char)) {
            var value = "";
            while(NUMBERS.test(char)){
                value += char;
                char = input[++current];
            }
            tokens.push({
                type: "number",
                value: value
            });
            continue;
        }
        if (LETTERS.test(char)) {
            var value = "";
            while(LETTERS.test(char) && char !== undefined){
                value += char;
                char = input[++current];
            }
            if (AND.test(value)) tokens.push({
                type: "operator",
                value: value
            });
            else tokens.push({
                type: "literal",
                value: value
            });
            continue;
        }
        throw new TypeError("Tokenizer: I dont know what this character is: " + char);
    }
    return tokens;
}
function parser(tokens) {
    var output = [];
    var stack = [];
    while(tokens.length > 0){
        var token = tokens.shift();
        if (token.type === "number" || token.type === "literal") {
            output.push(token);
            continue;
        }
        if (token.type === "operator") {
            if (COLON.test(token.value)) {
                token = {
                    type: "query",
                    key: output.pop(),
                    value: tokens.shift()
                };
                output.push(token);
                continue;
            }
            while(stack.length > 0)output.unshift(stack.pop());
            stack.push(token);
        }
    }
    while(stack.length > 0)output.unshift(stack.pop());
    function walk() {
        var head = output.shift();
        if (head.type === "number") return parseInt(head.value);
        if (head.type === "literal") return head.value;
        if (head.type === "operator") {
            var l = walk();
            var r = walk();
            return Operator(head.value, l, r);
        }
        if (head.type === "query") {
            var l = head.key.value;
            var r = head.value.value;
            return Query(l, r);
        }
    }
    return walk();
}
module.exports = {
    parse: function(query) {
        var tokens = tokenizer(query);
        var ast = parser(tokens);
        return ast;
    }
};

},{"65352f2699c24bdf":"337Af","7f5fc0bd01bcfeb3":"6Gy8r"}],"337Af":[function(require,module,exports) {
function MaxHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.height;
    };
}
function MinHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.height;
    };
}
function MaxWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.width;
    };
}
function MinWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.width;
    };
}
function Orientation(value) {
    this.value = value;
    this.match = function(options) {
        return this.value === options.orientation;
    };
}
module.exports = function Query(type, value) {
    switch(type){
        case "max-height":
            return new MaxHeight(value);
        case "min-height":
            return new MinHeight(value);
        case "max-width":
            return new MaxWidth(value);
        case "min-width":
            return new MinWidth(value);
        case "orientation":
            return new Orientation(value);
        default:
            throw new Error(value);
    }
};

},{}],"6Gy8r":[function(require,module,exports) {
function And(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) && right.match(options);
    };
}
function Or(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) || right.match(options);
    };
}
module.exports = function Operator(type, left, right) {
    switch(type){
        case "and":
            return new And(left, right);
        case ",":
            return new Or(left, right);
        default:
            throw new Error(value);
    }
};

},{}],"4z9xT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>layoutEngine);
parcelHelpers.export(exports, "fontSubstitution", ()=>fontSubstitution);
parcelHelpers.export(exports, "justification", ()=>justification);
parcelHelpers.export(exports, "linebreaker", ()=>linebreaker);
parcelHelpers.export(exports, "scriptItemizer", ()=>scriptItemizer);
parcelHelpers.export(exports, "textDecoration", ()=>textDecoration);
parcelHelpers.export(exports, "wordHyphenation", ()=>wordHyphenation);
var _fns = require("@react-pdf/fns");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _createForOfIteratorHelperLoose = require("@babel/runtime/helpers/createForOfIteratorHelperLoose");
var _createForOfIteratorHelperLooseDefault = parcelHelpers.interopDefault(_createForOfIteratorHelperLoose);
var _unicodeProperties = require("unicode-properties");
var _unicodePropertiesDefault = parcelHelpers.interopDefault(_unicodeProperties);
var _hyphen = require("hyphen");
var _hyphenDefault = parcelHelpers.interopDefault(_hyphen);
var _enUs = require("hyphen/patterns/en-us");
var _enUsDefault = parcelHelpers.interopDefault(_enUs);
/**
 * Create attributed string from text fragments
 *
 * @param  {Array}  fragments
 * @return {Object} attributed string
 */ var fromFragments = function fromFragments(fragments) {
    var offset = 0;
    var string = "";
    var runs = [];
    fragments.forEach(function(fragment) {
        string += fragment.string;
        runs.push({
            start: offset,
            end: offset + fragment.string.length,
            attributes: fragment.attributes || {}
        });
        offset += fragment.string.length;
    });
    return {
        string: string,
        runs: runs
    };
};
/**
 * Default word hyphenation engine used when no one provided.
 * Does not perform word hyphenation at all
 *
 * @param  {String} word
 * @return {Array} same word
 */ var defaultHyphenationEngine = function defaultHyphenationEngine(word) {
    return [
        word
    ];
};
/**
 * Wrap words of attribute string
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string including syllables
 */ var wrapWords = function wrapWords(engines, options) {
    if (engines === void 0) engines = {};
    if (options === void 0) options = {};
    return function(attributedString) {
        var _engines$wordHyphenat, _engines;
        var syllables = [];
        var fragments = [];
        var hyphenateWord = options.hyphenationCallback || ((_engines$wordHyphenat = (_engines = engines).wordHyphenation) === null || _engines$wordHyphenat === void 0 ? void 0 : _engines$wordHyphenat.call(_engines, options)) || defaultHyphenationEngine;
        for(var i = 0; i < attributedString.runs.length; i += 1){
            var string = "";
            var run = attributedString.runs[i];
            var words = attributedString.string.slice(run.start, run.end).split(/([ ]+)/g).filter(Boolean);
            for(var j = 0; j < words.length; j += 1){
                var word = words[j];
                var parts = hyphenateWord(word);
                syllables.push.apply(syllables, parts);
                string += parts.join("");
            }
            fragments.push({
                string: string,
                attributes: run.attributes
            });
        }
        return (0, _extendsDefault.default)({}, fromFragments(fragments), {
            syllables: syllables
        });
    };
};
/**
 * Clone rect
 *
 * @param  {Object}  rect
 * @return {Object} cloned rect
 */ var copy = function copy(rect) {
    return Object.assign({}, rect);
};
var partition = function partition(rect, height) {
    var a = Object.assign({}, rect, {
        height: height
    });
    var b = Object.assign({}, rect, {
        y: rect.y + height,
        height: rect.height - height
    });
    return [
        a,
        b
    ];
};
/**
 * Crop upper section of rect
 *
 * @param  {Object}  rect
 * @return {Object} cropped rect
 */ var crop = function crop(height, rect) {
    var _partition = partition(rect, height), result = _partition[1];
    return result;
};
/**
 * Get paragraph block height
 *
 * @param  {Object}  paragraph block
 * @return {number} paragraph block height
 */ var height$2 = function height(paragraph) {
    return paragraph.reduce(function(acc, block) {
        return acc + block.box.height;
    }, 0);
};
/**
 * Calculate run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var calculateScale = function calculateScale(run) {
    var _attributes$font;
    var attributes = run.attributes || {};
    var fontSize = attributes.fontSize || 12;
    var unitsPerEm = (_attributes$font = attributes.font) === null || _attributes$font === void 0 ? void 0 : _attributes$font.unitsPerEm;
    return unitsPerEm ? fontSize / unitsPerEm : 0;
};
/**
 * Get run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var scale = function scale(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.scale) || calculateScale(run);
};
/**
 * Get ligature offset by index
 *
 * Ex. ffi ligature
 *
 *   glyphs:         l  o  f  f  i  m
 *   glyphIndices:   0  1  2  2  2  3
 *   offset:         0  0  0  1  2  0
 *
 * @param  {number}  index
 * @param  {Object}  run
 * @return {number} ligature offset
 */ var offset = function offset(index, run) {
    if (!run) return 0;
    var glyphIndices = run.glyphIndices || [];
    var value = glyphIndices[index];
    return glyphIndices.slice(0, index).filter(function(i) {
        return i === value;
    }).length;
};
/**
 * Get run font
 *
 * @param  {Object}  run
 * @return {Object} font
 */ var getFont = function getFont(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.font) || null;
};
/**
 * Slice glyph between codePoints range
 * Util for breaking ligatures
 *
 * @param  {number}  start code point index
 * @param  {number}  end code point index
 * @param  {Object}  font to generate new glyph
 * @param  {Object} glyph to be sliced
 * @return {Array} sliced glyph parts
 */ var slice$2 = function slice(start, end, font, glyph) {
    if (!glyph) return [];
    if (start === end) return [];
    if (start === 0 && end === glyph.codePoints.length) return [
        glyph
    ];
    var codePoints = glyph.codePoints.slice(start, end);
    var string = String.fromCodePoint.apply(String, codePoints);
    return font ? font.layout(string).glyphs : [
        glyph
    ];
};
/**
 * Return glyph index at string index, if glyph indices present.
 * Otherwise return string index
 *
 * @param  {number}  string index
 * @param  {Object}  run
 * @return {number}  glyph index
 */ var glyphIndexAt = function glyphIndexAt(index, run) {
    var _run$glyphIndices;
    var result = run === null || run === void 0 ? void 0 : (_run$glyphIndices = run.glyphIndices) === null || _run$glyphIndices === void 0 ? void 0 : _run$glyphIndices[index];
    return (0, _fns.isNil)(result) ? index : result;
};
/**
 * Returns new array starting with zero, and keeping same relation between consecutive values
 *
 * @param  {Array[number]}  list
 * @return {boolean} normalized array
 */ var normalize = function normalize(array) {
    var head = array[0];
    return array.map(function(value) {
        return value - head;
    });
};
/**
 * Slice run between glyph indices range
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} sliced run
 */ var slice$1 = function slice(start, end, run) {
    var _run$glyphs, _run$glyphs2;
    var runScale = scale(run);
    var font = getFont(run);
    // Get glyph start and end indices
    var startIndex = glyphIndexAt(start, run);
    var endIndex = glyphIndexAt(end, run);
    // Get start and end glyph
    var startGlyph = (_run$glyphs = run.glyphs) === null || _run$glyphs === void 0 ? void 0 : _run$glyphs[startIndex];
    var endGlyph = (_run$glyphs2 = run.glyphs) === null || _run$glyphs2 === void 0 ? void 0 : _run$glyphs2[endIndex];
    // Get start ligature chunks (if any)
    var startOffset = offset(start, run);
    var startGlyphs = startOffset > 0 ? slice$2(startOffset, Infinity, font, startGlyph) : [];
    // Get end ligature chunks (if any)
    var endOffset = offset(end, run);
    var endGlyphs = slice$2(0, endOffset, font, endGlyph);
    // Compute new glyphs
    var sliceStart = startIndex + Math.min(1, startOffset);
    var glyphs = (run.glyphs || []).slice(sliceStart, endIndex);
    // Compute new positions
    var glyphPosition = function glyphPosition(g) {
        return {
            xAdvance: g.advanceWidth * runScale
        };
    };
    var startPositions = startGlyphs.map(glyphPosition);
    var positions = (run.positions || []).slice(sliceStart, endIndex);
    var endPositions = endGlyphs.map(glyphPosition);
    return Object.assign({}, run, {
        start: run.start + start,
        end: Math.min(run.end, run.start + end),
        glyphIndices: normalize((run.glyphIndices || []).slice(start, end)),
        glyphs: [
            startGlyphs,
            glyphs,
            endGlyphs
        ].flat(),
        positions: [
            startPositions,
            positions,
            endPositions
        ].flat()
    });
};
/**
 * Get run index that contains passed index
 *
 * @param  {number}  char index
 * @param  {Array}  runs array
 * @return {Array} run index
 */ var runIndexAt$1 = function runIndexAt(n, runs) {
    if (!runs) return -1;
    return runs.findIndex(function(run) {
        return run.start <= n && n < run.end;
    });
};
/**
 * Filter runs contained between start and end
 *
 * @param  {number}  start
 * @param  {number}  end
 * @param  {Array}  runs
 * @return {boolean} filtered runs
 */ var filter = function filter(start, end, runs) {
    var startIndex = runIndexAt$1(start, runs);
    var endIndex = Math.max(runIndexAt$1(end - 1, runs), startIndex);
    return runs.slice(startIndex, endIndex + 1);
};
/**
 * Subtract scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} subtracted run
 */ var subtract = function subtract(n, run) {
    var start = run.start - n;
    var end = run.end - n;
    return Object.assign({}, run, {
        start: start,
        end: end
    });
};
/**
 * Slice array of runs
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Array}  runs
 * @return {Array} sliced runs
 */ var sliceRuns = function sliceRuns(start, end, runs) {
    var sliceFirstRun = function sliceFirstRun(a) {
        return slice$1(start - a.start, end - a.start, a);
    };
    var sliceLastRun = function sliceLastRun(a) {
        return slice$1(0, end - a.start, a);
    };
    return runs.map(function(run, i) {
        var result = run;
        var isFirst = i === 0;
        var isLast = !isFirst && i === runs.length - 1;
        if (isFirst) result = sliceFirstRun(run);
        if (isLast) result = sliceLastRun(run);
        return subtract(start, result);
    });
};
/**
 * Slice attributed string between two indices
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var slice = function slice(start, end, attributedString) {
    if (attributedString.string.length === 0) return attributedString;
    var string = attributedString.string.slice(start, end);
    var filteredRuns = filter(start, end, attributedString.runs);
    var slicedRuns = sliceRuns(start, end, filteredRuns);
    return Object.assign({}, attributedString, {
        string: string,
        runs: slicedRuns
    });
};
var findCharIndex = function findCharIndex(string) {
    return string.search(/\S/g);
};
var findLastCharIndex = function findLastCharIndex(string) {
    var match = string.match(/\S/g);
    return match ? string.lastIndexOf(match[match.length - 1]) : -1;
};
/**
 * Removes (strips) whitespace from both ends of the attributted string.
 *
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var trim = function trim(attributedString) {
    var start = findCharIndex(attributedString.string);
    var end = findLastCharIndex(attributedString.string);
    return slice(start, end + 1, attributedString);
};
/**
 * Returns empty run
 *
 * @return {Object} empty run
 */ var empty$1 = function empty() {
    return {
        start: 0,
        end: 0,
        glyphIndices: [],
        glyphs: [],
        positions: [],
        attributes: {}
    };
};
var isNumber = function isNumber(value) {
    return typeof value === "number";
};
/**
 * Append glyph indices with given length
 *
 * Ex. appendIndices(3, [0, 1, 2, 2]) => [0, 1, 2, 2, 3, 3, 3]
 *
 * @param  {number}  length
 * @param  {Array}  glyph indices
 * @return {Array}  extended glyph indices
 */ var appendIndices = function appendIndices(length, indices) {
    var lastIndex = (0, _fns.last)(indices);
    var value = (0, _fns.isNil)(lastIndex) ? 0 : lastIndex + 1;
    var newIndices = Array(length).fill(value);
    return indices.concat(newIndices);
};
/**
 * Get glyph for a given code point
 *
 * @param  {number}  codePoint
 * @param  {Object}  font
 * @return {Object}  glyph
 * */ var fromCodePoint = function fromCodePoint(value, font) {
    return font && value ? font.glyphForCodePoint(value) : null;
};
/**
 * Append glyph to run
 *
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var appendGlyph = function appendGlyph(glyph, run) {
    var _glyph$codePoints;
    var glyphLength = ((_glyph$codePoints = glyph.codePoints) === null || _glyph$codePoints === void 0 ? void 0 : _glyph$codePoints.length) || 0;
    var end = run.end + glyphLength;
    var glyphs = run.glyphs.concat(glyph);
    var glyphIndices = appendIndices(glyphLength, run.glyphIndices);
    if (!run.positions) return Object.assign({}, run, {
        end: end,
        glyphs: glyphs,
        glyphIndices: glyphIndices
    });
    var positions = run.positions.concat({
        xAdvance: glyph.advanceWidth * scale(run)
    });
    return Object.assign({}, run, {
        end: end,
        glyphs: glyphs,
        glyphIndices: glyphIndices,
        positions: positions
    });
};
/**
 * Append glyph or code point to run
 *
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var append$1 = function append(value, run) {
    if (!value) return run;
    var font = getFont(run);
    var glyph = isNumber(value) ? fromCodePoint(value, font) : value;
    return appendGlyph(glyph, run);
};
/**
 * Get string from array of code points
 *
 * @param {Array} code points
 * @return {String} string
 */ var stringFromCodePoints = function stringFromCodePoints(codePoints) {
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Append glyph into last run of attributed string
 *
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var append = function append(glyph, attributedString) {
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    var codePointsString = stringFromCodePoints(codePoints);
    var string = attributedString.string + codePointsString;
    var firstRuns = attributedString.runs.slice(0, -1);
    var lastRun = (0, _fns.last)(attributedString.runs) || empty$1();
    var runs = firstRuns.concat(append$1(glyph, lastRun));
    return Object.assign({}, attributedString, {
        string: string,
        runs: runs
    });
};
var ELLIPSIS_UNICODE = 8230;
var ELLIPSIS_STRING = String.fromCharCode(ELLIPSIS_UNICODE);
/**
 * Get ellipsis codepoint. This may be different in standard and embedded fonts
 *
 * @param  {number}  font
 * @return {Object} ellipsis codepoint
 */ var getEllipsisCodePoint = function getEllipsisCodePoint(font) {
    if (!font.encode) return ELLIPSIS_UNICODE;
    var _font$encode = font.encode(ELLIPSIS_STRING), codePoints = _font$encode[0];
    return parseInt(codePoints[0], 16);
};
/**
 * Trucante block with ellipsis
 *
 * @param  {number}  lines quantity
 * @param  {Object}  paragraph block
 * @return {Object} sliced paragraph block
 */ var truncate = function truncate(block) {
    var _last, _last2, _last2$attributes;
    var runs = ((_last = (0, _fns.last)(block)) === null || _last === void 0 ? void 0 : _last.runs) || [];
    var font = (_last2 = (0, _fns.last)(runs)) === null || _last2 === void 0 ? void 0 : (_last2$attributes = _last2.attributes) === null || _last2$attributes === void 0 ? void 0 : _last2$attributes.font;
    if (font) {
        var _Object$assign;
        var index = block.length - 1;
        var codePoint = getEllipsisCodePoint(font);
        var glyph = font.glyphForCodePoint(codePoint);
        var lastBlock = append(glyph, trim(block[index]));
        return Object.assign([], block, (_Object$assign = {}, _Object$assign[index] = lastBlock, _Object$assign));
    }
    return block;
};
/**
 * Omit attribute from run
 *
 * @param  {Object}  run
 * @return {Object} run without ommited attribute
 */ var omit = function omit(value, run) {
    var attributes = Object.assign({}, run.attributes);
    delete attributes[value];
    return Object.assign({}, run, {
        attributes: attributes
    });
};
/**
 * Get run ascent
 *
 * @param  {Object}  run
 * @return {boolean} ascent
 */ var ascent$1 = function ascent(run) {
    var _run$attributes, _run$attributes$attac, _run$attributes2, _run$attributes2$font;
    var attachmentHeight = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$attac = _run$attributes.attachment) === null || _run$attributes$attac === void 0 ? void 0 : _run$attributes$attac.height) || 0;
    var fontAscent = ((_run$attributes2 = run.attributes) === null || _run$attributes2 === void 0 ? void 0 : (_run$attributes2$font = _run$attributes2.font) === null || _run$attributes2$font === void 0 ? void 0 : _run$attributes2$font.ascent) || 0;
    return Math.max(attachmentHeight, fontAscent * scale(run));
};
/**
 * Get run descent
 *
 * @param  {Object}  run
 * @return {number} descent
 */ var descent = function descent(run) {
    var _run$attributes, _run$attributes$font;
    var fontDescent = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.descent) || 0;
    return scale(run) * fontDescent;
};
/**
 * Get run lineGap
 *
 * @param  {Object}  run
 * @return {number} lineGap
 */ var lineGap = function lineGap(run) {
    var _run$attributes, _run$attributes$font;
    return (((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.lineGap) || 0) * scale(run);
};
/**
 * Get run height
 *
 * @param  {Object}  run
 * @return {number} height
 */ var height$1 = function height(run) {
    var _run$attributes;
    var lineHeight = (_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.lineHeight;
    return lineHeight || lineGap(run) + ascent$1(run) - descent(run);
};
/**
 * Returns attributed string height
 *
 * @param {Object} attributed string
 * @return {number} height
 */ var height = function height(attributeString) {
    var reducer = function reducer(acc, run) {
        return Math.max(acc, height$1(run));
    };
    return attributeString.runs.reduce(reducer, 0);
};
/**
 * Checks if two rects intersect each other
 *
 * @param {Rect} a
 * @param {Rect} b
 * @returns {Boolean} rects intersects
 */ var intersects = function intersects(a, b) {
    var x = Math.max(a.x, b.x);
    var num1 = Math.min(a.x + a.width, b.x + b.width);
    var y = Math.max(a.y, b.y);
    var num2 = Math.min(a.y + a.height, b.y + b.height);
    return num1 >= x && num2 >= y;
};
var _excluded = [
    "excludeRects"
];
var getLineFragment = function getLineFragment(lineRect, excludeRect) {
    if (!intersects(excludeRect, lineRect)) return [
        lineRect
    ];
    var eStart = excludeRect.x;
    var eEnd = excludeRect.x + excludeRect.width;
    var lStart = lineRect.x;
    var lEnd = lineRect.x + lineRect.width;
    var a = Object.assign({}, lineRect, {
        width: eStart - lStart
    });
    var b = Object.assign({}, lineRect, {
        x: eEnd,
        width: lEnd - eEnd
    });
    return [
        a,
        b
    ].filter(function(r) {
        return r.width > 0;
    });
};
var getLineFragments = function getLineFragments(rect, excludeRects) {
    var fragments = [
        rect
    ];
    var _loop = function _loop() {
        var excludeRect = excludeRects[i];
        fragments = fragments.reduce(function(acc, fragment) {
            var pieces = getLineFragment(fragment, excludeRect);
            return acc.concat(pieces);
        }, []);
    };
    for(var i = 0; i < excludeRects.length; i += 1)_loop();
    return fragments;
};
var generateLineRects = function generateLineRects(container, height) {
    var excludeRects = container.excludeRects, rect = (0, _objectWithoutPropertiesLooseDefault.default)(container, _excluded);
    if (!excludeRects) return [
        rect
    ];
    var lineRects = [];
    var maxY = Math.max.apply(Math, excludeRects.map(function(r) {
        return r.y + r.height;
    }));
    var currentRect = rect;
    while(currentRect.y < maxY){
        var _partition = partition(currentRect, height), lineRect = _partition[0], rest = _partition[1];
        var lineRectFragments = getLineFragments(lineRect, excludeRects);
        currentRect = rest;
        lineRects.push.apply(lineRects, lineRectFragments);
    }
    return [].concat(lineRects, [
        currentRect
    ]);
};
var ATTACHMENT_CODE$1 = "\uFFFC"; // 65532
/**
 * Remove attachment attribute if no char present
 *
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */ var purgeAttachments = function purgeAttachments(attributedString) {
    var shouldPurge = !attributedString.string.includes(ATTACHMENT_CODE$1);
    if (!shouldPurge) return attributedString;
    var runs = attributedString.runs.map(function(run) {
        return omit("attachment", run);
    });
    return Object.assign({}, attributedString, {
        runs: runs
    });
};
/**
 * Layout paragraphs inside rectangle
 *
 * @param  {Object} rect
 * @param  {Array} attributed strings
 * @return {Object} layout blocks
 */ var layoutLines = function layoutLines(rects, lines, indent) {
    var rect = rects.shift();
    var currentY = rect.y;
    return lines.map(function(line, i) {
        var _line$runs, _line$runs$;
        var lineIndent = i === 0 ? indent : 0;
        var style = ((_line$runs = line.runs) === null || _line$runs === void 0 ? void 0 : (_line$runs$ = _line$runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes) || {};
        var height$1 = Math.max(height(line), style.lineHeight);
        if (currentY + height$1 > rect.y + rect.height && rects.length > 0) {
            rect = rects.shift();
            currentY = rect.y;
        }
        var newLine = Object.assign({}, line);
        delete newLine.syllables;
        newLine.box = {
            x: rect.x + lineIndent,
            y: currentY,
            width: rect.width - lineIndent,
            height: height$1
        };
        currentY += height$1;
        return purgeAttachments(newLine);
    });
};
/**
 * Performs line breaking and layout
 *
 * @param  {Object} engines
 * @param  {Object}  layout options
 * @param  {Object} rect
 * @param  {Object} attributed string
 * @return {Object} layout block
 */ var layoutParagraph = function layoutParagraph(engines, options) {
    return function(container, paragraph) {
        var _paragraph$runs, _paragraph$runs$, _paragraph$runs$$attr;
        var height$1 = height(paragraph);
        var indent = ((_paragraph$runs = paragraph.runs) === null || _paragraph$runs === void 0 ? void 0 : (_paragraph$runs$ = _paragraph$runs[0]) === null || _paragraph$runs$ === void 0 ? void 0 : (_paragraph$runs$$attr = _paragraph$runs$.attributes) === null || _paragraph$runs$$attr === void 0 ? void 0 : _paragraph$runs$$attr.indent) || 0;
        var rects = generateLineRects(container, height$1);
        var availableWidths = rects.map(function(r) {
            return r.width;
        });
        availableWidths[0] -= indent;
        var lines = engines.linebreaker(options)(paragraph, availableWidths);
        return layoutLines(rects, lines, indent);
    };
};
/**
 * Slice block at given height
 *
 * @param  {number}  height
 * @param  {Object}  paragraph block
 * @return {number} sliced paragraph block
 */ var sliceAtHeight = function sliceAtHeight(height, block) {
    var newBlock = [];
    var counter = 0;
    for(var i = 0; i < block.length; i += 1){
        var line = block[i];
        counter += line.box.height;
        if (counter < height) newBlock.push(line);
        else break;
    }
    return newBlock;
};
/**
 * Layout paragraphs inside container until it does not
 * fit anymore, performing line wrapping in the process.
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  container rect
 * @param  {Object}  attributed strings (paragraphs)
 * @return {Array} paragraph blocks
 */ var typesetter = function typesetter(engines, options, container) {
    return function(attributedStrings) {
        var blocks = [];
        var paragraphs = [].concat(attributedStrings);
        var layoutBlock = layoutParagraph(engines, options);
        var maxLines = (0, _fns.isNil)(container.maxLines) ? Infinity : container.maxLines;
        var truncateEllipsis = container.truncateMode === "ellipsis";
        var linesCount = maxLines;
        var paragraphRect = copy(container);
        var nextParagraph = paragraphs.shift();
        while(linesCount > 0 && nextParagraph){
            var block = layoutBlock(paragraphRect, nextParagraph);
            var slicedBlock = block.slice(0, linesCount);
            var linesHeight = height$2(slicedBlock);
            var shouldTruncate = truncateEllipsis && block.length !== slicedBlock.length;
            linesCount -= slicedBlock.length;
            if (paragraphRect.height >= linesHeight) {
                blocks.push(shouldTruncate ? truncate(slicedBlock) : slicedBlock);
                paragraphRect = crop(linesHeight, paragraphRect);
                nextParagraph = paragraphs.shift();
            } else {
                blocks.push(truncate(sliceAtHeight(paragraphRect.height, slicedBlock)));
                break;
            }
        }
        return blocks;
    };
};
var DUMMY_CODEPOINT = 123;
/**
 * Resolve string indices based on glyphs code points
 *
 * @param  {Array}  glyphs
 * @return {Array} glyph indices
 */ var resolve = function resolve(glyphs) {
    if (glyphs === void 0) glyphs = [];
    return glyphs.reduce(function(acc, glyph) {
        var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [
            DUMMY_CODEPOINT
        ];
        if (acc.length === 0) return codePoints.map(function() {
            return 0;
        });
        var last = acc[acc.length - 1];
        var next = codePoints.map(function() {
            return last + 1;
        });
        return [].concat(acc, next);
    }, []);
};
var getCharacterSpacing = function getCharacterSpacing(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.characterSpacing) || 0;
};
/**
 * Scale run positions
 *
 * @param  {Object}  run
 * @param  {Array}  positions
 * @return {Array} scaled positions
 */ var scalePositions = function scalePositions(run, positions) {
    var runScale = scale(run);
    var characterSpacing = getCharacterSpacing(run);
    return positions.map(function(position, i) {
        var isLast = i === positions.length;
        var xSpacing = isLast ? 0 : characterSpacing;
        return Object.assign({}, position, {
            xAdvance: position.xAdvance * runScale + xSpacing,
            yAdvance: position.yAdvance * runScale,
            xOffset: position.xOffset * runScale,
            yOffset: position.yOffset * runScale
        });
    });
};
/**
 * Create glyph run
 *
 * @param  {String}  string
 * @param  {Object}  run
 * @return {Object}  glyph run
 */ var layoutRun = function layoutRun(string) {
    return function(run) {
        var start = run.start, end = run.end, _run$attributes2 = run.attributes, attributes = _run$attributes2 === void 0 ? {} : _run$attributes2;
        var font = attributes.font;
        if (!font) return (0, _extendsDefault.default)({}, run, {
            glyphs: [],
            glyphIndices: [],
            positions: []
        });
        var runString = string.slice(start, end);
        var glyphRun = font.layout(runString);
        var positions = scalePositions(run, glyphRun.positions);
        var glyphIndices = resolve(glyphRun.glyphs);
        return (0, _extendsDefault.default)({}, run, {
            positions: positions,
            glyphIndices: glyphIndices,
            glyphs: glyphRun.glyphs
        });
    };
};
/**
 * Generate glyphs for single attributed string
 *
 * @param  {Object}  layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings
 * @return {Array} attributed string with glyphs
 */ var generateGlyphs = function generateGlyphs() {
    return function(attributedString) {
        var runs = attributedString.runs.map(layoutRun(attributedString.string));
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
/**
 * Resolves yOffset for run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunYOffset = function resolveRunYOffset(run) {
    var _run$attributes, _run$attributes$font, _run$attributes2;
    if (!run.positions) return run;
    var unitsPerEm = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.unitsPerEm) || 0;
    var yOffset = (((_run$attributes2 = run.attributes) === null || _run$attributes2 === void 0 ? void 0 : _run$attributes2.yOffset) || 0) * unitsPerEm;
    var positions = run.positions.map(function(p) {
        return Object.assign({}, p, {
            yOffset: yOffset
        });
    });
    return Object.assign({}, run, {
        positions: positions
    });
};
/**
 * Resolves yOffset for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveYOffset = function resolveYOffset() {
    return function(attributedString) {
        var runs = attributedString.runs.map(resolveRunYOffset);
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
/**
 * Sort runs in ascending order
 *
 * @param  {Array}  runs
 * @return {Array} sorted runs
 */ var sort = function sort(runs) {
    return runs.sort(function(a, b) {
        return a.start - b.start || a.end - b.end;
    });
};
/**
 * Is run empty (start === end)
 *
 * @param  {Object}  run
 * @return {Object} is run empty
 */ var isEmpty = function isEmpty(run) {
    return run.start === run.end;
};
var sortPoints = function sortPoints(a, b) {
    return a[1] - b[1] || a[3] - b[3];
};
var generatePoints = function generatePoints(runs) {
    var result = runs.reduce(function(acc, run, i) {
        return acc.concat([
            [
                "start",
                run.start,
                run.attributes,
                i
            ],
            [
                "end",
                run.end,
                run.attributes,
                i
            ]
        ]);
    }, []);
    return result.sort(sortPoints);
};
var mergeRuns = function mergeRuns(runs) {
    return runs.reduce(function(acc, run) {
        var attributes = Object.assign({}, acc.attributes, run.attributes);
        return Object.assign({}, run, {
            attributes: attributes
        });
    }, {});
};
var groupEmptyRuns = function groupEmptyRuns(runs) {
    var groups = runs.reduce(function(acc, run) {
        if (!acc[run.start]) acc[run.start] = [];
        acc[run.start].push(run);
        return acc;
    }, {});
    return Object.values(groups);
};
var flattenEmptyRuns = function flattenEmptyRuns(runs) {
    return groupEmptyRuns(runs).map(mergeRuns);
};
var flattenRegularRuns = function flattenRegularRuns(runs) {
    var res = [];
    var points = generatePoints(runs);
    var start = -1;
    var attrs = {};
    var stack = [];
    for(var i = 0; i < points.length; i += 1){
        var _points$i = points[i], type = _points$i[0], offset = _points$i[1], attributes = _points$i[2];
        if (start !== -1 && start < offset) res.push({
            start: start,
            end: offset,
            attributes: attrs
        });
        if (type === "start") {
            stack.push(attributes);
            attrs = Object.assign({}, attrs, attributes);
        } else {
            attrs = {};
            for(var j = 0; j < stack.length; j += 1)if (stack[j] === attributes) // eslint-disable-next-line no-plusplus
            stack.splice(j--, 1);
            else attrs = Object.assign({}, attrs, stack[j]);
        }
        start = offset;
    }
    return res;
};
/**
 * Flatten many runs
 *
 * @param  {Array}  runs
 * @return {Array} flatten runs
 */ var flatten = function flatten(runs) {
    if (runs === void 0) runs = [];
    var emptyRuns = flattenEmptyRuns(runs.filter(function(run) {
        return isEmpty(run);
    }));
    var regularRuns = flattenRegularRuns(runs.filter(function(run) {
        return !isEmpty(run);
    }));
    return sort(emptyRuns.concat(regularRuns));
};
/**
 * Returns empty attributed string
 *
 * @return {Object} empty attributed string
 */ var empty = function empty() {
    return {
        string: "",
        runs: []
    };
};
var omitFont = function omitFont(attributedString) {
    var runs = attributedString.runs.map(function(run) {
        return omit("font", run);
    });
    return Object.assign({}, attributedString, {
        runs: runs
    });
};
/**
 * Performs font substitution and script itemization on attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} processed attributed string
 */ var preprocessRuns = function preprocessRuns(engines, options) {
    return function(attributedString) {
        if ((0, _fns.isNil)(attributedString)) return empty();
        var string = attributedString.string;
        var fontSubstitution = engines.fontSubstitution, scriptItemizer = engines.scriptItemizer;
        var _omitFont = omitFont(attributedString), omittedFontRuns = _omitFont.runs;
        var _fontSubstitution = fontSubstitution(options)(attributedString), substitutedRuns = _fontSubstitution.runs;
        var _scriptItemizer = scriptItemizer(options)(attributedString), itemizationRuns = _scriptItemizer.runs;
        var runs = substitutedRuns.concat(itemizationRuns).concat(omittedFontRuns);
        return {
            string: string,
            runs: flatten(runs)
        };
    };
};
/**
 * Get attributed string start value
 *
 * @param  {Object}  attributed string
 * @return {number} start
 */ var start = function start(attributedString) {
    var runs = attributedString.runs;
    return runs.length === 0 ? 0 : runs[0].start;
};
/**
 * Get attributed string end value
 *
 * @param  {Object}  attributed string
 * @return {number} end
 */ var end = function end(attributedString) {
    var runs = attributedString.runs;
    return runs.length === 0 ? 0 : (0, _fns.last)(runs).end;
};
/**
 * Get attributed string length
 *
 * @param  {Object}  glyph string
 * @return {number} end
 */ var length$1 = function length(attributedString) {
    return end(attributedString) - start(attributedString);
};
/**
 * Breaks attributed string into paragraphs
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Array} attributed string array
 */ var splitParagraphs = function splitParagraphs() {
    return function(attributedString) {
        var res = [];
        var start = 0;
        var breakPoint = attributedString.string.indexOf("\n") + 1;
        while(breakPoint > 0){
            res.push(slice(start, breakPoint, attributedString));
            start = breakPoint;
            breakPoint = attributedString.string.indexOf("\n", breakPoint) + 1;
        }
        if (start === 0) res.push(attributedString);
        else if (start < attributedString.string.length) res.push(slice(start, length$1(attributedString), attributedString));
        return res;
    };
};
/**
 * Return positions advance width
 *
 * @param  {Object}  positions
 * @return {number} advance width
 */ var advanceWidth$2 = function advanceWidth(positions) {
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Return run advance width
 *
 * @param  {Object}  run
 * @return {number} advance width
 */ var advanceWidth$1 = function advanceWidth(run) {
    return advanceWidth$2(run.positions || []);
};
/**
 * Returns attributed string advancewidth
 *
 * @param {Object} attributed string
 * @return {number} advance width
 */ var advanceWidth = function advanceWidth(attributeString) {
    var reducer = function reducer(acc, run) {
        return acc + advanceWidth$1(run);
    };
    return attributeString.runs.reduce(reducer, 0);
};
var WHITE_SPACES_CODE = 32;
/**
 * Check if glyph is white space
 *
 * @param  {Object}  glyph
 * @return {Boolean}  is white space
 * */ var isWhiteSpace = function isWhiteSpace(glyph) {
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    return codePoints.includes(WHITE_SPACES_CODE);
};
/**
 * Get white space leading positions
 *
 * @param  {Object}  run
 * @return {Array} white space leading positions
 */ var leadingPositions = function leadingPositions(run) {
    var glyphs = run.glyphs || [];
    var positions = run.positions || [];
    var leadingWhitespaces = glyphs.findIndex(function(g) {
        return !isWhiteSpace(g);
    });
    return positions.slice(0, leadingWhitespaces);
};
/**
 * Get run leading white space offset
 *
 * @param  {Object}  run
 * @return {number} leading white space offset
 */ var leadingOffset$1 = function leadingOffset(run) {
    var positions = leadingPositions(run);
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Get attributed string leading white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} leading white space offset
 */ var leadingOffset = function leadingOffset(attributedString) {
    var runs = attributedString.runs || [];
    return leadingOffset$1(runs[0]);
};
var reverse = function reverse(array) {
    return [].concat(array).reverse();
};
/**
 * Get white space trailing positions
 *
 * @param  {Object}  run
 * @return {Array} white space trailing positions
 */ var trailingPositions = function trailingPositions(run) {
    var glyphs = reverse(run.glyphs || []);
    var positions = reverse(run.positions || []);
    var leadingWhitespaces = glyphs.findIndex(function(g) {
        return !isWhiteSpace(g);
    });
    return positions.slice(0, leadingWhitespaces);
};
/**
 * Get run trailing white space offset
 *
 * @param  {Object}  run
 * @return {number} trailing white space offset
 */ var trailingOffset$1 = function trailingOffset(run) {
    var positions = trailingPositions(run);
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Get attributed string trailing white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} trailing white space offset
 */ var trailingOffset = function trailingOffset(attributedString) {
    var runs = attributedString.runs || [];
    return trailingOffset$1((0, _fns.last)(runs));
};
/**
 * Drop last char of run
 *
 * @param  {Object}  run
 * @return {boolean} run without last char
 */ var dropLast$1 = function dropLast(run) {
    return slice$1(0, run.end - run.start - 1, run);
};
/**
 * Drop last glyph
 *
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var dropLast = function dropLast(attributeString) {
    var string = (0, _fns.dropLast)(attributeString.string);
    var runs = (0, _fns.adjust)(-1, dropLast$1, attributeString.runs);
    return Object.assign({}, attributeString, {
        string: string,
        runs: runs
    });
};
var ALIGNMENT_FACTORS = {
    center: 0.5,
    right: 1
};
/**
 * Remove new line char at the end of line if present
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var removeNewLine = function removeNewLine(line) {
    return (0, _fns.last)(line.string) === "\n" ? dropLast(line) : line;
};
var getOverflowLeft = function getOverflowLeft(line) {
    return leadingOffset(line) + (line.overflowLeft || 0);
};
var getOverflowRight = function getOverflowRight(line) {
    return trailingOffset(line) + (line.overflowRight || 0);
};
/**
 * Ignore whitespace at the start and end of a line for alignment
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var adjustOverflow = function adjustOverflow(line) {
    var overflowLeft = getOverflowLeft(line);
    var overflowRight = getOverflowRight(line);
    var x = line.box.x - overflowLeft;
    var width = line.box.width + overflowLeft + overflowRight;
    var box = Object.assign({}, line.box, {
        x: x,
        width: width
    });
    return Object.assign({}, line, {
        box: box,
        overflowLeft: overflowLeft,
        overflowRight: overflowRight
    });
};
/**
 * Performs line justification by calling appropiate engine
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {string}  text align
 * @param  {Object}  line
 * @return {Object} line
 */ var justifyLine$1 = function justifyLine(engines, options, align) {
    return function(line) {
        var lineWidth = advanceWidth(line);
        var alignFactor = ALIGNMENT_FACTORS[align] || 0;
        var remainingWidth = Math.max(0, line.box.width - lineWidth);
        var shouldJustify = align === "justify" || lineWidth > line.box.width;
        var x = line.box.x + remainingWidth * alignFactor;
        var box = Object.assign({}, line.box, {
            x: x
        });
        var newLine = Object.assign({}, line, {
            box: box
        });
        return shouldJustify ? engines.justification(options)(newLine) : newLine;
    };
};
var finalizeLine = function finalizeLine(line) {
    var lineAscent = 0;
    var lineDescent = 0;
    var lineHeight = 0;
    var lineXAdvance = 0;
    var runs = line.runs.map(function(run) {
        var height = height$1(run);
        var ascent = ascent$1(run);
        var descent$1 = descent(run);
        var xAdvance = advanceWidth$1(run);
        lineHeight = Math.max(lineHeight, height);
        lineAscent = Math.max(lineAscent, ascent);
        lineDescent = Math.max(lineDescent, descent$1);
        lineXAdvance += xAdvance;
        return Object.assign({}, run, {
            height: height,
            ascent: ascent,
            descent: descent$1,
            xAdvance: xAdvance
        });
    });
    return Object.assign({}, line, {
        runs: runs,
        height: lineHeight,
        ascent: lineAscent,
        descent: lineDescent,
        xAdvance: lineXAdvance
    });
};
/**
 * Finalize line by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  line
 * @param  {number}  line index
 * @param  {Array}  total lines
 * @return {Object} line
 */ var finalizeBlock = function finalizeBlock(engines, options) {
    if (engines === void 0) engines = {};
    return function(line, i, lines) {
        var _line$runs, _line$runs$;
        var isLastFragment = i === lines.length - 1;
        var style = ((_line$runs = line.runs) === null || _line$runs === void 0 ? void 0 : (_line$runs$ = _line$runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes) || {};
        var align = isLastFragment ? style.alignLastLine : style.align;
        return (0, _fns.compose)(finalizeLine, engines.textDecoration(options), justifyLine$1(engines, options, align), adjustOverflow, removeNewLine)(line);
    };
};
/**
 * Finalize line block by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Array}  line blocks
 * @return {Array} line blocks
 */ var finalizeFragments = function finalizeFragments(engines, options) {
    return function(blocks) {
        var blockFinalizer = finalizeBlock(engines, options);
        return blocks.map(function(block) {
            return block.map(blockFinalizer);
        });
    };
};
var ATTACHMENT_CODE = 0xfffc; // 65532
var isReplaceGlyph = function isReplaceGlyph(glyph) {
    return glyph.codePoints.includes(ATTACHMENT_CODE);
};
/**
 * Resolve attachments of run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunAttachments = function resolveRunAttachments(run) {
    var _run$attributes;
    if (!run.positions) return run;
    var glyphs = run.glyphs || [];
    var attachment = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.attachment) || {};
    var positions = run.positions.map(function(position, i) {
        var glyph = glyphs[i];
        if (attachment && attachment.width && isReplaceGlyph(glyph)) return Object.assign({}, position, {
            xAdvance: attachment.width
        });
        return Object.assign({}, position);
    });
    return Object.assign({}, run, {
        positions: positions
    });
};
/**
 * Resolve attachments for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveAttachments = function resolveAttachments() {
    return function(attributedString) {
        var runs = attributedString.runs.map(resolveRunAttachments);
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
var applyAttributes = function applyAttributes(a) {
    return {
        align: a.align || "left",
        alignLastLine: a.alignLastLine || (a.align === "justify" ? "left" : a.align || "left"),
        attachment: a.attachment || null,
        backgroundColor: a.backgroundColor || null,
        bidiLevel: a.bidiLevel || null,
        bullet: a.bullet || null,
        characterSpacing: a.characterSpacing || 0,
        color: a.color || "black",
        features: a.features || [],
        fill: a.fill !== false,
        font: a.font || null,
        fontSize: a.fontSize || 12,
        hangingPunctuation: a.hangingPunctuation || false,
        hyphenationFactor: a.hyphenationFactor || 0,
        indent: a.indent || 0,
        justificationFactor: a.justificationFactor || 1,
        lineHeight: a.lineHeight || null,
        lineSpacing: a.lineSpacing || 0,
        link: a.link || null,
        marginLeft: a.marginLeft || a.margin || 0,
        marginRight: a.marginRight || a.margin || 0,
        opacity: a.opacity,
        paddingTop: a.paddingTop || a.padding || 0,
        paragraphSpacing: a.paragraphSpacing || 0,
        underline: a.underline || false,
        underlineColor: a.underlineColor || a.color || "black",
        underlineStyle: a.underlineStyle || "solid",
        script: a.script || null,
        shrinkFactor: a.shrinkFactor || 0,
        strike: a.strike || false,
        strikeColor: a.strikeColor || a.color || "black",
        strikeStyle: a.strikeStyle || "solid",
        stroke: a.stroke || false,
        verticalAlign: a.verticalAlign || null,
        wordSpacing: a.wordSpacing || 0,
        yOffset: a.yOffset || 0
    };
};
/**
 * Apply default style to run
 *
 * @param  {Object}  run
 * @return {Object} run with styles
 */ var applyRunStyles = function applyRunStyles(run) {
    var attributes = applyAttributes(run.attributes);
    return Object.assign({}, run, {
        attributes: attributes
    });
};
/**
 * Apply default attributes for an attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var applyDefaultStyles = function applyDefaultStyles() {
    return function(attributedString) {
        var string = attributedString.string || "";
        var runs = (attributedString.runs || []).map(applyRunStyles);
        return {
            string: string,
            runs: runs
        };
    };
};
/* eslint-disable no-restricted-syntax */ /**
 * Apply scaling and yOffset for verticalAlign 'sub' and 'super'.
 *
 * @param  {Object} layout options
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */ var verticalAlignment = function verticalAlignment() {
    return function(attributedString) {
        attributedString.runs.forEach(function(run) {
            var attributes = run.attributes;
            var verticalAlign = attributes.verticalAlign;
            if (verticalAlign === "sub") attributes.yOffset = -0.2;
            else if (verticalAlign === "super") attributes.yOffset = 0.4;
        });
        return attributedString;
    };
};
/**
 * A LayoutEngine is the main object that performs text layout.
 * It accepts an AttributedString and a Container object
 * to layout text into, and uses several helper objects to perform
 * various layout tasks. These objects can be overridden to customize
 * layout behavior.
 *
 * @param  {Object}  engines
 * @param  {Object}  attributed string
 * @param  {Object}  container rect
 * @param  {Object}  layout options
 * @return {Array} paragraph blocks
 */ var layoutEngine = function layoutEngine(engines) {
    return function(attributedString, container, options) {
        if (options === void 0) options = {};
        var processParagraph = (0, _fns.compose)(resolveYOffset(), resolveAttachments(), generateGlyphs(), verticalAlignment(), wrapWords(engines, options));
        var processParagraphs = function processParagraphs(paragraphs) {
            return paragraphs.map(processParagraph);
        };
        return (0, _fns.compose)(finalizeFragments(engines, options), typesetter(engines, options, container), processParagraphs, splitParagraphs(), preprocessRuns(engines, options), applyDefaultStyles())(attributedString);
    };
};
/* eslint-disable no-plusplus */ var INFINITY = 10000;
var getNextBreakpoint = function getNextBreakpoint(subnodes, widths, lineNumber) {
    var position = null;
    var minimumBadness = Infinity;
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLength = widths[Math.min(lineNumber, widths.length - 1)];
    var calculateRatio = function calculateRatio(node) {
        if (sum.width < lineLength) return sum.stretch - node.stretch > 0 ? (lineLength - sum.width) / sum.stretch : INFINITY;
        if (sum.width > lineLength) return sum.shrink - node.shrink > 0 ? (lineLength - sum.width) / sum.shrink : INFINITY;
        return 0;
    };
    for(var i = 0; i < subnodes.length; i += 1){
        var node = subnodes[i];
        if (node.type === "box") sum.width += node.width;
        else if (node.type === "glue") {
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        }
        if (sum.width - sum.shrink > lineLength) {
            if (position === null) {
                var j = i === 0 ? i + 1 : i;
                while(j < subnodes.length && (subnodes[j].type === "glue" || subnodes[j].type === "penalty"))j++;
                position = j - 1;
            }
            break;
        }
        if (node.type === "penalty" || node.type === "glue") {
            var ratio = calculateRatio(node);
            var penalty = node.type === "penalty" ? node.penalty : 0;
            var badness = 100 * Math.pow(Math.abs(ratio), 3) + penalty;
            if (minimumBadness >= badness) {
                position = i;
                minimumBadness = badness;
            }
        }
    }
    return sum.width - sum.shrink > lineLength ? position : null;
};
var applyBestFit = function applyBestFit(nodes, widths) {
    var count = 0;
    var lineNumber = 0;
    var subnodes = nodes;
    var breakpoints = [
        {
            position: 0
        }
    ];
    while(subnodes.length > 0){
        var breakpoint = getNextBreakpoint(subnodes, widths, lineNumber);
        if (breakpoint !== null) {
            count += breakpoint;
            breakpoints.push({
                position: count
            });
            subnodes = subnodes.slice(breakpoint + 1, subnodes.length);
            count++;
            lineNumber++;
        } else subnodes = [];
    }
    return breakpoints;
};
/* eslint-disable no-param-reassign */ /* eslint-disable max-classes-per-file */ var Node = /*#__PURE__*/ function() {
    function Node(data) {
        this.prev = null;
        this.next = null;
        this.data = data;
    }
    var _proto = Node.prototype;
    _proto.toString = function toString() {
        return this.data.toString();
    };
    return Node;
}();
var LinkedList = /*#__PURE__*/ function() {
    function LinkedList() {
        this.head = null;
        this.tail = null;
        this.listSize = 0;
    }
    var _proto2 = LinkedList.prototype;
    _proto2.isLinked = function isLinked(node) {
        return !(node && node.prev === null && node.next === null && this.tail !== node && this.head !== node || this.isEmpty());
    };
    _proto2.size = function size() {
        return this.listSize;
    };
    _proto2.isEmpty = function isEmpty() {
        return this.listSize === 0;
    };
    _proto2.first = function first() {
        return this.head;
    };
    _proto2.last = function last() {
        return this.last;
    };
    _proto2.toString = function toString() {
        return this.toArray().toString();
    };
    _proto2.toArray = function toArray() {
        var node = this.head;
        var result = [];
        while(node !== null){
            result.push(node);
            node = node.next;
        }
        return result;
    };
    _proto2.forEach = function forEach(fun) {
        var node = this.head;
        while(node !== null){
            fun(node);
            node = node.next;
        }
    };
    _proto2.contains = function contains(n) {
        var node = this.head;
        if (!this.isLinked(n)) return false;
        while(node !== null){
            if (node === n) return true;
            node = node.next;
        }
        return false;
    };
    _proto2.at = function at(i) {
        var node = this.head;
        var index = 0;
        if (i >= this.listLength || i < 0) return null;
        while(node !== null){
            if (i === index) return node;
            node = node.next;
            index += 1;
        }
        return null;
    };
    _proto2.insertAfter = function insertAfter(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next === null) this.tail = newNode;
        else node.next.prev = newNode;
        node.next = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.insertBefore = function insertBefore(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev === null) this.head = newNode;
        else node.prev.next = newNode;
        node.prev = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.push = function push(node) {
        if (this.head === null) this.unshift(node);
        else this.insertAfter(this.tail, node);
        return this;
    };
    _proto2.unshift = function unshift(node) {
        if (this.head === null) {
            this.head = node;
            this.tail = node;
            node.prev = null;
            node.next = null;
            this.listSize += 1;
        } else this.insertBefore(this.head, node);
        return this;
    };
    _proto2.remove = function remove(node) {
        if (!this.isLinked(node)) return this;
        if (node.prev === null) this.head = node.next;
        else node.prev.next = node.next;
        if (node.next === null) this.tail = node.prev;
        else node.next.prev = node.prev;
        this.listSize -= 1;
        return this;
    };
    _proto2.pop = function pop() {
        var node = this.tail;
        this.tail.prev.next = null;
        this.tail = this.tail.prev;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    _proto2.shift = function shift() {
        var node = this.head;
        this.head.next.prev = null;
        this.head = this.head.next;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    return LinkedList;
}();
LinkedList.Node = Node;
/* eslint-disable no-restricted-properties */ /**
 * @preserve Knuth and Plass line breaking algorithm in JavaScript
 *
 * Licensed under the new BSD License.
 * Copyright 2009-2010, Bram Stein
 * All rights reserved.
 */ var linebreak = function linebreak(nodes, lines, settings) {
    var options = {
        demerits: {
            line: settings && settings.demerits && settings.demerits.line || 10,
            flagged: settings && settings.demerits && settings.demerits.flagged || 100,
            fitness: settings && settings.demerits && settings.demerits.fitness || 3000
        },
        tolerance: settings && settings.tolerance || 3
    };
    var activeNodes = new LinkedList();
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLengths = lines;
    var breaks = [];
    var tmp = {
        data: {
            demerits: Infinity
        }
    };
    function breakpoint(position, demerits, ratio, line, fitnessClass, totals, previous) {
        return {
            position: position,
            demerits: demerits,
            ratio: ratio,
            line: line,
            fitnessClass: fitnessClass,
            totals: totals || {
                width: 0,
                stretch: 0,
                shrink: 0
            },
            previous: previous
        };
    }
    function computeCost(start, end, active, currentLine) {
        var width = sum.width - active.totals.width;
        var stretch = 0;
        var shrink = 0;
        // If the current line index is within the list of linelengths, use it, otherwise use
        // the last line length of the list.
        var lineLength = currentLine < lineLengths.length ? lineLengths[currentLine - 1] : lineLengths[lineLengths.length - 1];
        if (nodes[end].type === "penalty") width += nodes[end].width;
        if (width < lineLength) {
            // Calculate the stretch ratio
            stretch = sum.stretch - active.totals.stretch;
            if (stretch > 0) return (lineLength - width) / stretch;
            return linebreak.infinity;
        }
        if (width > lineLength) {
            // Calculate the shrink ratio
            shrink = sum.shrink - active.totals.shrink;
            if (shrink > 0) return (lineLength - width) / shrink;
            return linebreak.infinity;
        }
        // perfect match
        return 0;
    }
    // Add width, stretch and shrink values from the current
    // break point up to the next box or forced penalty.
    function computeSum(breakPointIndex) {
        var result = {
            width: sum.width,
            stretch: sum.stretch,
            shrink: sum.shrink
        };
        for(var i = breakPointIndex; i < nodes.length; i += 1){
            if (nodes[i].type === "glue") {
                result.width += nodes[i].width;
                result.stretch += nodes[i].stretch;
                result.shrink += nodes[i].shrink;
            } else if (nodes[i].type === "box" || nodes[i].type === "penalty" && nodes[i].penalty === -linebreak.infinity && i > breakPointIndex) break;
        }
        return result;
    }
    // The main loop of the algorithm
    // eslint-disable-next-line no-shadow
    function mainLoop(node, index, nodes) {
        var active = activeNodes.first();
        var next = null;
        var ratio = 0;
        var demerits = 0;
        var candidates = [];
        var badness;
        var currentLine = 0;
        var tmpSum;
        var currentClass = 0;
        var fitnessClass;
        var candidate;
        var newNode;
        // The inner loop iterates through all the active nodes with line < currentLine and then
        // breaks out to insert the new active node candidates before looking at the next active
        // nodes for the next lines. The result of this is that the active node list is always
        // sorted by line number.
        while(active !== null){
            candidates = [
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                }
            ];
            // Iterate through the linked list of active nodes to find new potential active nodes
            // and deactivate current active nodes.
            while(active !== null){
                next = active.next;
                currentLine = active.data.line + 1;
                ratio = computeCost(active.data.position, index, active.data, currentLine);
                // Deactive nodes when the distance between the current active node and the
                // current node becomes too large (i.e. it exceeds the stretch limit and the stretch
                // ratio becomes negative) or when the current node is a forced break (i.e. the end
                // of the paragraph when we want to remove all active nodes, but possibly have a final
                // candidate active node---if the paragraph can be set using the given tolerance value.)
                if (ratio < -1 || node.type === "penalty" && node.penalty === -linebreak.infinity) activeNodes.remove(active);
                // If the ratio is within the valid range of -1 <= ratio <= tolerance calculate the
                // total demerits and record a candidate active node.
                if (ratio >= -1 && ratio <= options.tolerance) {
                    badness = 100 * Math.pow(Math.abs(ratio), 3);
                    // Positive penalty
                    if (node.type === "penalty" && node.penalty >= 0) demerits = Math.pow(options.demerits.line + badness, 2) + Math.pow(node.penalty, 2);
                    else if (node.type === "penalty" && node.penalty !== -linebreak.infinity) demerits = Math.pow(options.demerits.line + badness, 2) - Math.pow(node.penalty, 2);
                    else demerits = Math.pow(options.demerits.line + badness, 2);
                    if (node.type === "penalty" && nodes[active.data.position].type === "penalty") demerits += options.demerits.flagged * node.flagged * nodes[active.data.position].flagged;
                    // Calculate the fitness class for this candidate active node.
                    if (ratio < -0.5) currentClass = 0;
                    else if (ratio <= 0.5) currentClass = 1;
                    else if (ratio <= 1) currentClass = 2;
                    else currentClass = 3;
                    // Add a fitness penalty to the demerits if the fitness classes of two adjacent lines
                    // differ too much.
                    if (Math.abs(currentClass - active.data.fitnessClass) > 1) demerits += options.demerits.fitness;
                    // Add the total demerits of the active node to get the total demerits of this candidate node.
                    demerits += active.data.demerits;
                    // Only store the best candidate for each fitness class
                    if (demerits < candidates[currentClass].demerits) candidates[currentClass] = {
                        active: active,
                        demerits: demerits,
                        ratio: ratio
                    };
                }
                active = next;
                // Stop iterating through active nodes to insert new candidate active nodes in the active list
                // before moving on to the active nodes for the next line.
                // TODO: The Knuth and Plass paper suggests a conditional for currentLine < j0. This means paragraphs
                // with identical line lengths will not be sorted by line number. Find out if that is a desirable outcome.
                // For now I left this out, as it only adds minimal overhead to the algorithm and keeping the active node
                // list sorted has a higher priority.
                if (active !== null && active.data.line >= currentLine) break;
            }
            tmpSum = computeSum(index);
            for(fitnessClass = 0; fitnessClass < candidates.length; fitnessClass += 1){
                candidate = candidates[fitnessClass];
                if (candidate.demerits < Infinity) {
                    newNode = new LinkedList.Node(breakpoint(index, candidate.demerits, candidate.ratio, candidate.active.data.line + 1, fitnessClass, tmpSum, candidate.active));
                    if (active !== null) activeNodes.insertBefore(active, newNode);
                    else activeNodes.push(newNode);
                }
            }
        }
    }
    // Add an active node for the start of the paragraph.
    activeNodes.push(new LinkedList.Node(breakpoint(0, 0, 0, 0, 0, undefined, null)));
    // eslint-disable-next-line no-shadow
    nodes.forEach(function(node, index, nodes) {
        if (node.type === "box") sum.width += node.width;
        else if (node.type === "glue") {
            if (index > 0 && nodes[index - 1].type === "box") mainLoop(node, index, nodes);
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        } else if (node.type === "penalty" && node.penalty !== linebreak.infinity) mainLoop(node, index, nodes);
    });
    if (activeNodes.size() !== 0) {
        // Find the best active node (the one with the least total demerits.)
        activeNodes.forEach(function(node) {
            if (node.data.demerits < tmp.data.demerits) tmp = node;
        });
        while(tmp !== null){
            breaks.push({
                position: tmp.data.position,
                ratio: tmp.data.ratio
            });
            tmp = tmp.data.previous;
        }
        return breaks.reverse();
    }
    return [];
};
linebreak.infinity = 10000;
linebreak.glue = function(width, value, stretch, shrink) {
    return {
        type: "glue",
        value: value,
        width: width,
        stretch: stretch,
        shrink: shrink
    };
};
linebreak.box = function(width, value, hyphenated) {
    if (hyphenated === void 0) hyphenated = false;
    return {
        type: "box",
        width: width,
        value: value,
        hyphenated: hyphenated
    };
};
linebreak.penalty = function(width, penalty, flagged) {
    return {
        type: "penalty",
        width: width,
        penalty: penalty,
        flagged: flagged
    };
};
/**
 * Add scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} added run
 */ var add = function add(n, run) {
    var start = run.start + n;
    var end = run.end + n;
    return Object.assign({}, run, {
        start: start,
        end: end
    });
};
/**
 * Get run length
 *
 * @param  {Object}  run
 * @return {number} length
 */ var length = function length(run) {
    return run.end - run.start;
};
/**
 * Concats two runs into one
 *
 * @param  {Object}  first run
 * @param  {Object}  second run
 * @return {Object}  concatenated run
 */ var concat = function concat(runA, runB) {
    var end = runA.end + length(runB);
    var glyphs = (runA.glyphs || []).concat(runB.glyphs || []);
    var positions = (runA.positions || []).concat(runB.positions || []);
    var attributes = Object.assign({}, runA.attributes, runB.attributes);
    var runAIndices = runA.glyphIndices || [];
    var runALastIndex = (0, _fns.last)(runAIndices) || 0;
    var runBIndices = (runB.glyphIndices || []).map(function(i) {
        return i + runALastIndex + 1;
    });
    var glyphIndices = normalize(runAIndices.concat(runBIndices));
    return Object.assign({}, runA, {
        end: end,
        glyphs: glyphs,
        positions: positions,
        attributes: attributes,
        glyphIndices: glyphIndices
    });
};
/**
 * Insert glyph to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insertGlyph$1 = function insertGlyph(index, glyph, run) {
    if (!glyph) return run;
    // Split resolves ligature splitting in case new glyph breaks some
    var leadingRun = slice$1(0, index, run);
    var trailingRun = slice$1(index, Infinity, run);
    return concat(append$1(glyph, leadingRun), trailingRun);
};
/**
 * Insert either glyph or code point to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insert = function insert(index, value, run) {
    var font = getFont(run);
    var glyph = isNumber(value) ? fromCodePoint(value, font) : value;
    return insertGlyph$1(index, glyph, run);
};
/**
 * Get run index at char index
 *
 * @param  {number}  char index
 * @param  {Object}  attributedString
 * @return {number} run index
 */ var runIndexAt = function runIndexAt(n, string) {
    return runIndexAt$1(n, string.runs);
};
/**
 * Insert glyph into attributed string
 *
 * @param {number} index
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var insertGlyph = function insertGlyph(index, glyph, attributedString) {
    var runIndex = runIndexAt(index, attributedString);
    // Add glyph to the end if run index invalid
    if (runIndex === -1) return append(glyph, attributedString);
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    var string = attributedString.string.slice(0, index) + stringFromCodePoints(codePoints) + attributedString.string.slice(index);
    var runs = attributedString.runs.map(function(run, i) {
        if (i === runIndex) return insert(index - run.start, glyph, run);
        if (i > runIndex) return add(codePoints.length, run);
        return run;
    });
    return Object.assign({}, attributedString, {
        string: string,
        runs: runs
    });
};
/**
 * Advance width between two string indices
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} advanced width run
 */ var advanceWidthBetween$1 = function advanceWidthBetween(start, end, run) {
    var runStart = run.start || 0;
    var glyphStartIndex = Math.max(0, glyphIndexAt(start - runStart, run));
    var glyphEndIndex = Math.max(0, glyphIndexAt(end - runStart, run));
    var positions = (run.positions || []).slice(glyphStartIndex, glyphEndIndex);
    return advanceWidth$2(positions);
};
/**
 * Advance width between start and end
 * Does not consider ligature splitting for the moment.
 * Check performance impact on supporting this
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {number} advance width
 */ var advanceWidthBetween = function advanceWidthBetween(start, end, attributedString) {
    var runs = filter(start, end, attributedString.runs);
    return runs.reduce(function(acc, run) {
        return acc + advanceWidthBetween$1(start, end, run);
    }, 0);
};
var HYPHEN = 0x002d;
var TOLERANCE_STEPS = 5;
var TOLERANCE_LIMIT = 50;
var opts = {
    width: 3,
    stretch: 6,
    shrink: 9
};
/**
 * Slice attributed string to many lines
 *
 * @param {Object} attributed string
 * @param  {Array}  nodes
 * @param  {Array}  breaks
 * @return {Array} attributed strings
 */ var breakLines = function breakLines(string, nodes, breaks) {
    var start = 0;
    var end = null;
    var lines = breaks.reduce(function(acc, breakPoint) {
        var node = nodes[breakPoint.position];
        var prevNode = nodes[breakPoint.position - 1];
        // Last breakpoint corresponds to K&P mandatory final glue
        if (breakPoint.position === nodes.length - 1) return acc;
        var line;
        if (node.type === "penalty") {
            end = prevNode.value.end;
            line = slice(start, end, string);
            line = insertGlyph(line.length, HYPHEN, line);
        } else {
            end = node.value.end;
            line = slice(start, end, string);
        }
        start = end;
        return [].concat(acc, [
            line
        ]);
    }, []);
    // Last line
    lines.push(slice(start, string.string.length, string));
    return lines;
};
/**
 * Return Knuth & Plass nodes based on line and previously calculated syllables
 *
 * @param {Object} attributed string
 * @param  {Object}  attributed string
 * @param  {Object}  layout options
 * @return {Array} attributed strings
 */ var getNodes = function getNodes(attributedString, _ref, options) {
    var align = _ref.align;
    var start = 0;
    var hyphenWidth = 5;
    var syllables = attributedString.syllables;
    var hyphenPenalty = options.hyphenationPenalty || (align === "justify" ? 100 : 600);
    var result = syllables.reduce(function(acc, s, index) {
        var width = advanceWidthBetween(start, start + s.length, attributedString);
        if (s.trim() === "") {
            var stretch = width * opts.width / opts.stretch;
            var shrink = width * opts.width / opts.shrink;
            var value = {
                start: start,
                end: start + s.length
            };
            acc.push(linebreak.glue(width, value, stretch, shrink));
        } else {
            var hyphenated = syllables[index + 1] !== " ";
            var _value = {
                start: start,
                end: start + s.length
            };
            acc.push(linebreak.box(width, _value, hyphenated));
            if (syllables[index + 1] && hyphenated) acc.push(linebreak.penalty(hyphenWidth, hyphenPenalty, 1));
        }
        start += s.length;
        return acc;
    }, []);
    result.push(linebreak.glue(0, null, linebreak.infinity, 0));
    result.push(linebreak.penalty(0, -linebreak.infinity, 1));
    return result;
};
var getStyles = function getStyles(attributedString) {
    var _attributedString$run, _attributedString$run2;
    return ((_attributedString$run = attributedString.runs) === null || _attributedString$run === void 0 ? void 0 : (_attributedString$run2 = _attributedString$run[0]) === null || _attributedString$run2 === void 0 ? void 0 : _attributedString$run2.attributes) || {};
};
/**
 * Performs Knuth & Plass line breaking algorithm
 * Fallbacks to best fit algorithm if latter not successful
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @param {Object} attributed string
 * @return {Array} attributed strings
 */ var linebreaker = function linebreaker(options) {
    return function(attributedString, availableWidths) {
        var tolerance = options.tolerance || 4;
        var style = getStyles(attributedString);
        var nodes = getNodes(attributedString, style, options);
        var breaks = linebreak(nodes, availableWidths, {
            tolerance: tolerance
        });
        // Try again with a higher tolerance if the line breaking failed.
        while(breaks.length === 0 && tolerance < TOLERANCE_LIMIT){
            tolerance += TOLERANCE_STEPS;
            breaks = linebreak(nodes, availableWidths, {
                tolerance: tolerance
            });
        }
        if (breaks.length === 0 || breaks.length === 1 && breaks[0].position === 0) breaks = applyBestFit(nodes, availableWidths);
        return breakLines(attributedString, nodes, breaks.slice(1));
    };
};
var WHITESPACE_PRIORITY = 1;
var LETTER_PRIORITY = 2;
var EXPAND_WHITESPACE_FACTOR = {
    before: 0.5,
    after: 0.5,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var EXPAND_CHAR_FACTOR = {
    before: 0.14453125,
    // 37/256
    after: 0.14453125,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var SHRINK_WHITESPACE_FACTOR = {
    before: -0.04296875,
    // -11/256
    after: -0.04296875,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var SHRINK_CHAR_FACTOR = {
    before: -0.04296875,
    after: -0.04296875,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var getCharFactor = function getCharFactor(direction, options) {
    var expandCharFactor = options.expandCharFactor || {};
    var shrinkCharFactor = options.shrinkCharFactor || {};
    return direction === "GROW" ? Object.assign({}, EXPAND_CHAR_FACTOR, expandCharFactor) : Object.assign({}, SHRINK_CHAR_FACTOR, shrinkCharFactor);
};
var getWhitespaceFactor = function getWhitespaceFactor(direction, options) {
    var expandWhitespaceFactor = options.expandWhitespaceFactor || {};
    var shrinkWhitespaceFactor = options.shrinkWhitespaceFactor || {};
    return direction === "GROW" ? Object.assign({}, EXPAND_WHITESPACE_FACTOR, expandWhitespaceFactor) : Object.assign({}, SHRINK_WHITESPACE_FACTOR, shrinkWhitespaceFactor);
};
var factor = function factor(direction, options) {
    return function(glyphs) {
        var charFactor = getCharFactor(direction, options);
        var whitespaceFactor = getWhitespaceFactor(direction, options);
        var factors = [];
        for(var index = 0; index < glyphs.length; index += 1){
            var f = void 0;
            var glyph = glyphs[index];
            if (isWhiteSpace(glyph)) {
                f = Object.assign({}, whitespaceFactor);
                if (index === glyphs.length - 1) {
                    f.before = 0;
                    if (index > 0) factors[index - 1].after = 0;
                }
            } else if (glyph.isMark && index > 0) {
                f = Object.assign({}, factors[index - 1]);
                f.before = 0;
                factors[index - 1].after = 0;
            } else f = Object.assign({}, charFactor);
            factors.push(f);
        }
        return factors;
    };
};
var getFactors = function getFactors(gap, line, options) {
    var direction = gap > 0 ? "GROW" : "SHRINK";
    var getFactor = factor(direction, options);
    var factors = line.runs.reduce(function(acc, run) {
        return acc.concat(getFactor(run.glyphs));
    }, []);
    factors[0].before = 0;
    factors[factors.length - 1].after = 0;
    return factors;
};
/* eslint-disable no-multi-assign */ var KASHIDA_PRIORITY = 0;
var NULL_PRIORITY = 3;
var getDistances = function getDistances(gap, factors) {
    var total = 0;
    var priorities = [];
    var unconstrained = [];
    for(var _priority = KASHIDA_PRIORITY; _priority <= NULL_PRIORITY; _priority += 1)priorities[_priority] = unconstrained[_priority] = 0;
    // sum the factors at each priority
    for(var j = 0; j < factors.length; j += 1){
        var f = factors[j];
        var sum = f.before + f.after;
        total += sum;
        priorities[f.priority] += sum;
        if (f.unconstrained) unconstrained[f.priority] += sum;
    }
    // choose the priorities that need to be applied
    var highestPriority = -1;
    var highestPrioritySum = 0;
    var remainingGap = gap;
    var priority;
    for(priority = KASHIDA_PRIORITY; priority <= NULL_PRIORITY; priority += 1){
        var prioritySum = priorities[priority];
        if (prioritySum !== 0) {
            if (highestPriority === -1) {
                highestPriority = priority;
                highestPrioritySum = prioritySum;
            }
            // if this priority covers the remaining gap, we're done
            if (Math.abs(remainingGap) <= Math.abs(prioritySum)) {
                priorities[priority] = remainingGap / prioritySum;
                unconstrained[priority] = 0;
                remainingGap = 0;
                break;
            }
            // mark that we need to use 100% of the adjustment from
            // this priority, and subtract the space that it consumes
            priorities[priority] = 1;
            remainingGap -= prioritySum;
            // if this priority has unconstrained glyphs, let them consume the remaining space
            if (unconstrained[priority] !== 0) {
                unconstrained[priority] = remainingGap / unconstrained[priority];
                remainingGap = 0;
                break;
            }
        }
    }
    // zero out remaining priorities (if any)
    for(var p = priority + 1; p <= NULL_PRIORITY; p += 1){
        priorities[p] = 0;
        unconstrained[p] = 0;
    }
    // if there is still space left over, assign it to the highest priority that we saw.
    // this violates their factors, but it only happens in extreme cases
    if (remainingGap > 0 && highestPriority > -1) priorities[highestPriority] = (highestPrioritySum + (gap - total)) / highestPrioritySum;
    // create and return an array of distances to add to each glyph's advance
    var distances = [];
    for(var index = 0; index < factors.length; index += 1){
        // the distance to add to this glyph is the sum of the space to add
        // after this glyph, and the space to add before the next glyph
        var _f = factors[index];
        var next = factors[index + 1];
        var dist = _f.after * priorities[_f.priority];
        if (next) dist += next.before * priorities[next.priority];
        // if this glyph is unconstrained, add the unconstrained distance as well
        if (_f.unconstrained) {
            dist += _f.after * unconstrained[_f.priority];
            if (next) dist += next.before * unconstrained[next.priority];
        }
        distances.push(dist);
    }
    return distances;
};
/**
 * Adjust run positions by given distances
 *
 * @param {Array} distances
 * @param {Object} line
 * @returns {Object} line
 */ var justifyLine = function justifyLine(distances, line) {
    var index = 0;
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(line.runs), _step; !(_step = _iterator()).done;){
        var run = _step.value;
        for(var _iterator2 = (0, _createForOfIteratorHelperLooseDefault.default)(run.positions), _step2; !(_step2 = _iterator2()).done;){
            var position = _step2.value;
            position.xAdvance += distances[index++];
        }
    }
    return line;
};
/**
 * A JustificationEngine is used by a Typesetter to perform line fragment
 * justification. This implementation is based on a description of Apple's
 * justification algorithm from a PDF in the Apple Font Tools package.
 *
 * //TODO: Make it immutable
 *
 * @param {Object} layout options
 * @param {Object} line
 * @returns {Object} line
 */ var justification = function justification(options) {
    return function(line) {
        var gap = line.box.width - advanceWidth(line);
        if (gap === 0) return; // Exact fit
        var factors = getFactors(gap, line, options);
        var distances = getDistances(gap, factors);
        return justifyLine(distances, line);
    };
};
/**
 * Returns attributed string ascent
 *
 * @param {Object} attributed string
 * @return {number} ascent
 */ var ascent = function ascent(attributeString) {
    var reducer = function reducer(acc, run) {
        return Math.max(acc, ascent$1(run));
    };
    return attributeString.runs.reduce(reducer, 0);
};
/* eslint-disable no-param-reassign */ // The base font size used for calculating underline thickness.
var BASE_FONT_SIZE = 12;
/**
 * A TextDecorationEngine is used by a Typesetter to generate
 * DecorationLines for a line fragment, including underlines
 * and strikes.
 */ var textDecoration = function textDecoration() {
    return function(lineFragment) {
        var x = lineFragment.overflowLeft || 0;
        var overflowRight = lineFragment.overflowRight || 0;
        var maxX = advanceWidth(lineFragment) - overflowRight;
        lineFragment.decorationLines = [];
        for(var i = 0; i < lineFragment.runs.length; i += 1){
            var run = lineFragment.runs[i];
            var width = Math.min(maxX - x, advanceWidth$1(run));
            var thickness = Math.max(0.5, Math.floor(run.attributes.fontSize / BASE_FONT_SIZE));
            if (run.attributes.underline) {
                var rect = {
                    x: x,
                    y: ascent(lineFragment) + thickness * 2,
                    width: width,
                    height: thickness
                };
                var line = {
                    rect: rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.underlineColor || "black",
                    style: run.attributes.underlineStyle || "solid"
                };
                lineFragment.decorationLines.push(line);
            }
            if (run.attributes.strike) {
                var y = ascent(lineFragment) - ascent$1(run) / 3;
                var _rect = {
                    x: x,
                    y: y,
                    width: width,
                    height: thickness
                };
                var _line = {
                    rect: _rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.strikeColor || "black",
                    style: run.attributes.strikeStyle || "solid"
                };
                lineFragment.decorationLines.push(_line);
            }
            x += width;
        }
        return lineFragment;
    };
};
var ignoredScripts = [
    "Common",
    "Inherited",
    "Unknown"
];
/**
 * Resolves unicode script in runs, grouping equal runs together
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var scriptItemizer = function scriptItemizer() {
    return function(attributedString) {
        var string = attributedString.string;
        var lastScript = "Unknown";
        var lastIndex = 0;
        var index = 0;
        var res = [];
        if (!string) return empty();
        for(var i = 0; i < string.length; i += 1){
            var char = string[i];
            var codePoint = char.codePointAt();
            var script = (0, _unicodePropertiesDefault.default).getScript(codePoint);
            if (script !== lastScript && !ignoredScripts.includes(script)) {
                if (lastScript !== "Unknown") res.push({
                    start: lastIndex,
                    end: index,
                    attributes: {
                        script: lastScript
                    }
                });
                lastIndex = index;
                lastScript = script;
            }
            index += char.length;
        }
        if (lastIndex < string.length) res.push({
            start: lastIndex,
            end: string.length,
            attributes: {
                script: lastScript
            }
        });
        return {
            string: string,
            runs: res
        };
    };
};
var SOFT_HYPHEN = "\xad";
var hyphenator = (0, _hyphenDefault.default)((0, _enUsDefault.default));
var splitHyphen = function splitHyphen(word) {
    return word.split(SOFT_HYPHEN);
};
var cache = {};
var getParts = function getParts(word) {
    var base = word.includes(SOFT_HYPHEN) ? word : hyphenator(word);
    return splitHyphen(base);
};
var wordHyphenation = function wordHyphenation() {
    return function(word) {
        var cacheKey = "_" + word;
        if ((0, _fns.isNil)(word)) return [];
        if (cache[cacheKey]) return cache[cacheKey];
        cache[cacheKey] = getParts(word);
        return cache[cacheKey];
    };
};
var getFontSize = function getFontSize(value) {
    return value.attributes.fontSize || 12;
};
/**
 * Resolve font runs in an AttributedString, grouping equal
 * runs and performing font substitution where necessary.
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var fontSubstitution = function fontSubstitution() {
    return function(attributedString) {
        var string = attributedString.string, runs = attributedString.runs;
        var lastFont = null;
        var lastIndex = 0;
        var index = 0;
        var res = [];
        if (!string) return empty();
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(runs), _step; !(_step = _iterator()).done;){
            var run = _step.value;
            var _fontSize = getFontSize(run);
            var defaultFont = run.attributes.font;
            if (string.length === 0) {
                res.push({
                    start: 0,
                    end: 0,
                    attributes: {
                        font: defaultFont
                    }
                });
                break;
            }
            for(var _iterator2 = (0, _createForOfIteratorHelperLooseDefault.default)(string.slice(run.start, run.end)), _step2; !(_step2 = _iterator2()).done;){
                var char = _step2.value;
                var font = defaultFont;
                if (font !== lastFont) {
                    if (lastFont) res.push({
                        start: lastIndex,
                        end: index,
                        attributes: {
                            font: lastFont,
                            scale: lastFont ? _fontSize / lastFont.unitsPerEm : 0
                        }
                    });
                    lastFont = font;
                    lastIndex = index;
                }
                index += char.length;
            }
        }
        if (lastIndex < string.length) {
            var fontSize = getFontSize((0, _fns.last)(runs));
            res.push({
                start: lastIndex,
                end: string.length,
                attributes: {
                    font: lastFont,
                    scale: lastFont ? fontSize / lastFont.unitsPerEm : 0
                }
            });
        }
        return {
            string: string,
            runs: res
        };
    };
};

},{"@react-pdf/fns":"3vobK","@babel/runtime/helpers/extends":"lKkcq","@babel/runtime/helpers/objectWithoutPropertiesLoose":"6F7Pt","@babel/runtime/helpers/createForOfIteratorHelperLoose":"cBNai","unicode-properties":"bOC1E","hyphen":"8FXAC","hyphen/patterns/en-us":"8FzDH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8FXAC":[function(require,module,exports) {
var global = arguments[3];
/** Text hyphenation in Javascript.
 *  Copyright (C) 2024 Yevhen Tiurin (yevhentiurin@gmail.com)
 *  https://github.com/ytiurin/hyphen
 *
 *  Released under the ISC license
 *  https://github.com/ytiurin/hyphen/blob/master/LICENSE
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.createHyphenator = factory();
})(this, function() {
    function createTextReader(setup) {
        var char1 = "";
        var char2 = "";
        var i = 0;
        var verifier = setup();
        return function(text) {
            while(i < text.length){
                char1 = text.charAt(i++);
                char2 = text.charAt(i);
                var verified = verifier(char1, char2);
                if (verified !== void 0) return verified;
            }
        };
    }
    var isNotLetter = RegExp.prototype.test.bind(/\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/);
    function createHTMLVerifier() {
        var skip = false;
        return function(accumulate, chars) {
            if (skip) {
                if (chars[0] === ">") {
                    accumulate();
                    skip = false;
                }
            } else if (chars[0] === "<" && (!isNotLetter(chars[1]) || chars[1] === "/")) skip = true;
            return skip;
        };
    }
    function createHyphenCharVerifier(hyphenChar) {
        var skip = false;
        return function(accumulate, chars) {
            if (skip) {
                if (!isNotLetter(chars[0]) && isNotLetter(chars[1])) {
                    accumulate();
                    skip = false;
                }
            } else if (!isNotLetter(chars[0]) && chars[1] === hyphenChar) skip = true;
            return skip;
        };
    }
    function createHyphenationVerifier(verifiers, minWordLength) {
        return function() {
            var accum0 = "";
            var accum = "";
            function accumulate() {
                accum0 += accum;
                accum = "";
            }
            function resolveWith(value) {
                accum0 = "";
                accum = "";
                return value;
            }
            return function(char1, char2) {
                accum += char1;
                var skip = verifiers.reduce(function(skip2, verify) {
                    return skip2 || verify(accumulate, [
                        char1,
                        char2
                    ]);
                }, false);
                if (!skip) {
                    if (isNotLetter(char1) && !isNotLetter(char2)) accumulate();
                    if (!isNotLetter(char1) && isNotLetter(char2)) {
                        if (accum.length >= minWordLength) return resolveWith([
                            accum0,
                            accum
                        ]);
                        else accumulate();
                    }
                }
                if (char2 === "") {
                    if (accum.length < minWordLength || skip) accumulate();
                    return resolveWith([
                        accum0,
                        accum
                    ]);
                }
            };
        };
    }
    function createCharIterator(str) {
        var i = 0;
        function nextChar() {
            return str[i++];
        }
        function isLastLetter() {
            return str.length === i + 1;
        }
        return [
            nextChar,
            isLastLetter
        ];
    }
    function createStringSlicer(str) {
        var i = 0, slice = str;
        function next() {
            slice = str.slice(i++);
            if (slice.length < 3) return;
            return slice;
        }
        function isFirstCharacter() {
            return i === 2;
        }
        return [
            next,
            isFirstCharacter
        ];
    }
    function hyphenateWord(text, levelsTable, patternTree, debug, hyphenChar) {
        var levels = new Array(text.length + 1), loweredText = ("." + text.toLocaleLowerCase() + ".").split(""), wordSlice, letter, treePtr, nextPtr, patternLevelsIndex, patternLevels, patternEntityIndex = -1, slicer, nextSlice, isFirstCharacter, charIterator, nextLetter, isLastLetter;
        for(var i = levels.length; i--;)levels[i] = 0;
        slicer = createStringSlicer(loweredText);
        nextSlice = slicer[0];
        isFirstCharacter = slicer[1];
        while(wordSlice = nextSlice()){
            patternEntityIndex++;
            if (isFirstCharacter()) patternEntityIndex--;
            treePtr = patternTree;
            charIterator = createCharIterator(wordSlice);
            nextLetter = charIterator[0];
            isLastLetter = charIterator[1];
            while(letter = nextLetter()){
                if (treePtr[letter] === void 0) break;
                nextPtr = treePtr[letter];
                treePtr = nextPtr[0];
                patternLevelsIndex = nextPtr[1];
                if (treePtr === void 0) {
                    treePtr = {};
                    patternLevelsIndex = nextPtr;
                }
                if (isLastLetter()) continue;
                if (patternLevelsIndex === void 0) continue;
                if (!levelsTable[patternLevelsIndex].splice) levelsTable[patternLevelsIndex] = levelsTable[patternLevelsIndex].slice("");
                patternLevels = levelsTable[patternLevelsIndex];
                for(var k = 0; k < patternLevels.length; k++)levels[patternEntityIndex + k] = Math.max(patternLevels[k], levels[patternEntityIndex + k]);
            }
        }
        levels[0] = levels[1] = levels[levels.length - 1] = levels[levels.length - 2] = 0;
        var hyphenatedText = "";
        for(var i = 0; i < levels.length; i++)hyphenatedText += (levels[i] % 2 === 1 ? hyphenChar : "") + text.charAt(i);
        return hyphenatedText;
    }
    function start(text, levelsTable, patterns, cache, debug, hyphenChar, skipHTML, minWordLength, isAsync) {
        function done() {
            resolveNewText(newText);
        }
        var newText = "", fragments, readText = createTextReader(createHyphenationVerifier((skipHTML ? [
            createHTMLVerifier()
        ] : []).concat(createHyphenCharVerifier(hyphenChar)), minWordLength)), resolveNewText = function() {};
        function nextTick() {
            var loopStart = /* @__PURE__ */ new Date();
            while((!isAsync || /* @__PURE__ */ new Date() - loopStart < 10) && (fragments = readText(text))){
                if (fragments[1]) {
                    var cacheKey = fragments[1].length ? "~" + fragments[1] : "";
                    if (cache[cacheKey] === void 0) cache[cacheKey] = hyphenateWord(fragments[1], levelsTable, patterns, debug, hyphenChar);
                    fragments[1] = cache[cacheKey];
                }
                newText += fragments[0] + fragments[1];
            }
            if (!fragments) done();
            else setTimeout(nextTick);
        }
        if (isAsync) {
            setTimeout(nextTick);
            return new Promise(function(resolve) {
                resolveNewText = resolve;
            });
        } else {
            nextTick();
            return newText;
        }
    }
    var SETTING_DEFAULT_ASYNC = false;
    var SETTING_DEFAULT_DEBUG = false;
    var SETTING_DEFAULT_EXCEPTIONS = [];
    var SETTING_DEFAULT_HTML = true;
    var SETTING_DEFAULT_HYPH_CHAR = "\xad";
    var SETTING_DEFAULT_MIN_WORD_LENGTH = 5;
    var SETTING_NAME_ASYNC = "async";
    var SETTING_NAME_DEBUG = "debug";
    var SETTING_NAME_EXCEPTIONS = "exceptions";
    var SETTING_NAME_HTML = "html";
    var SETTING_NAME_HYPH_CHAR = "hyphenChar";
    var SETTING_NAME_MIN_WORD_LENGTH = "minWordLength";
    var _global = typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : {};
    function extend(target, source) {
        target = target || {};
        for(var key in source)target[key] = source[key];
        return target;
    }
    function validateArray(value) {
        return value instanceof Array;
    }
    function keyOrDefault(object, key, defaultValue, test) {
        if (key in object && (test ? test(object[key]) : true)) return object[key];
        return defaultValue;
    }
    function exceptionsFromDefinition(excetionsList, hyphenChar) {
        return excetionsList.reduce(function(exceptions, exception) {
            exceptions["~" + exception.replace(/\-/g, "")] = exception.replace(/\-/g, hyphenChar);
            return exceptions;
        }, {});
    }
    function createHyphenator(patternsDefinition, options) {
        options = options || {};
        var asyncMode = keyOrDefault(options, SETTING_NAME_ASYNC, SETTING_DEFAULT_ASYNC), caches = {}, debug = keyOrDefault(options, SETTING_NAME_DEBUG, SETTING_DEFAULT_DEBUG), exceptions = {}, hyphenChar = keyOrDefault(options, SETTING_NAME_HYPH_CHAR, SETTING_DEFAULT_HYPH_CHAR), levelsTable = patternsDefinition[0].split(","), patterns = JSON.parse(patternsDefinition[1]), minWordLength = keyOrDefault(options, SETTING_NAME_MIN_WORD_LENGTH, SETTING_DEFAULT_MIN_WORD_LENGTH) >> 0, skipHTML = keyOrDefault(options, SETTING_NAME_HTML, SETTING_DEFAULT_HTML), userExceptions = keyOrDefault(options, SETTING_NAME_EXCEPTIONS, SETTING_DEFAULT_EXCEPTIONS, validateArray);
        var cacheKey = hyphenChar + minWordLength;
        exceptions[cacheKey] = {};
        if (patternsDefinition[2]) exceptions[cacheKey] = exceptionsFromDefinition(patternsDefinition[2], hyphenChar);
        if (userExceptions && userExceptions.length) exceptions[cacheKey] = extend(exceptions[cacheKey], exceptionsFromDefinition(userExceptions, hyphenChar));
        caches[cacheKey] = extend({}, exceptions[cacheKey]);
        if (asyncMode && !("Promise" in _global)) throw new Error("Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode");
        return function(text, options2) {
            options2 = options2 || {};
            var localDebug = keyOrDefault(options2, SETTING_NAME_DEBUG, debug), localHyphenChar = keyOrDefault(options2, SETTING_NAME_HYPH_CHAR, hyphenChar), localMinWordLength = keyOrDefault(options2, SETTING_NAME_MIN_WORD_LENGTH, minWordLength) >> 0, localUserExceptions = keyOrDefault(options2, SETTING_NAME_EXCEPTIONS, SETTING_DEFAULT_EXCEPTIONS, validateArray), cacheKey2 = localHyphenChar + localMinWordLength;
            if (!exceptions[cacheKey2] && patternsDefinition[2]) {
                exceptions[cacheKey2] = exceptionsFromDefinition(patternsDefinition[2], localHyphenChar);
                caches[cacheKey2] = extend(caches[cacheKey2], exceptions[cacheKey2]);
            }
            if (localUserExceptions && localUserExceptions.length) {
                exceptions[cacheKey2] = extend(exceptions[cacheKey2], exceptionsFromDefinition(localUserExceptions, localHyphenChar));
                caches[cacheKey2] = extend(caches[cacheKey2], exceptions[cacheKey2]);
            }
            return start(text, levelsTable, patterns, caches[cacheKey2], localDebug, localHyphenChar, skipHTML, localMinWordLength, asyncMode);
        };
    }
    return createHyphenator;
});

},{}],"8FzDH":[function(require,module,exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.hyphenationPatternsEnUs = factory();
})(this, function() {
    return [
        "0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
        '{".":[{"a":[{"c":[{"h":0}],"d":[{"d":[{"e":[{"r":1}]}]}],"f":[{"t":2}],"l":[{"t":3}],"m":[{"a":[{"t":4}]}],"n":[{"c":4,"g":0,"i":[{"m":5}],"t":[{"e":3,"i":[{"s":6}]},0]}],"r":[{"s":4,"t":[{"i":[{"e":1}],"y":1}]}],"s":[{"c":3,"p":2,"s":2,"t":[{"e":[{"r":7}]}]}],"t":[{"o":[{"m":6}]}],"u":[{"d":2}],"v":[{"i":1}],"w":[{"n":0}]}],"b":[{"a":[{"g":1,"n":[{"a":4}],"s":[{"e":0}]}],"e":[{"r":[{"a":4},0],"s":[{"m":3,"t":[{"o":4}]}]}],"r":[{"i":8}],"u":[{"t":[{"t":[{"i":0}]}]}]}],"c":[{"a":[{"m":[{"p":[{"e":0}]}],"n":[{"c":5}],"p":[{"a":[{"b":6}]}],"r":[{"o":[{"l":5}]}],"t":1}],"e":[{"l":[{"a":1}]}],"h":[{"i":[{"l":[{"l":[{"i":7}]}]}]},1],"i":[{"t":[{"r":5}]},9],"o":[{"e":3,"r":[{"n":[{"e":[{"r":5}]}]},1],"n":[{"g":[{"r":5}]}]}]}],"d":[{"e":[{"m":[{"o":[{"i":1}]}],"o":3,"r":[{"a":3,"i":[{"v":[{"a":4}]},3]}],"s":[{"c":0}]}],"i":[{"c":[{"t":[{"i":[{"o":10}]}]}]}],"o":[{"t":1}],"u":[{"c":1,"m":[{"b":6}]}],"r":[{"i":[{"v":67}]}]}],"e":[{"a":[{"r":[{"t":[{"h":7}]}],"s":[{"i":11}]}],"b":1,"e":[{"r":0}],"g":9,"l":[{"d":4,"e":[{"m":3}]}],"n":[{"a":[{"m":12}],"g":3,"s":3}],"q":[{"u":[{"i":[{"t":13}]}]}],"r":[{"r":[{"i":1}]}],"s":3,"u":[{"l":[{"e":[{"r":1}]}]},3],"y":[{"e":5}],"t":[{"h":[{"y":[{"l":162}]}]}],"v":[{"e":[{"r":[{"s":[{"i":[{"b":158}]}]}]}]},9]}],"f":[{"e":[{"s":11}],"o":[{"r":[{"m":[{"e":[{"r":5}]}]}]}]}],"g":[{"a":[{"s":[{"o":[{"m":163}]}]},9],"e":[{"n":[{"t":14}],"o":[{"g":4,"m":[{"e":1}],"t":164}]},9],"i":[{"a":4,"b":1}],"o":[{"r":1}]}],"h":[{"a":[{"n":[{"d":[{"i":6}],"k":5}]}],"e":[{"r":[{"o":[{"i":6,"e":3}]}],"s":11,"t":11,"m":[{"o":165}],"p":[{"a":166}]},9],"i":[{"b":3,"e":[{"r":3}]}],"o":[{"n":[{"e":[{"y":5}],"o":11}],"v":5}]}],"i":[{"d":[{"l":1,"o":[{"l":12}]}],"m":[{"m":3,"p":[{"i":[{"n":4}]}]}],"n":[{"c":[{"i":3}],"e":8,"k":9,"s":3,"u":[{"t":167}]},2],"r":[{"r":4}],"s":[{"i":1}]}],"j":[{"u":[{"r":3}]}],"l":[{"a":[{"c":[{"y":1}],"m":1,"t":[{"e":[{"r":5}],"h":6}]}],"e":[{"g":[{"e":5}],"n":0,"p":5,"v":15,"i":[{"c":[{"e":[{"s":170}]}]}]},9],"i":[{"g":[{"a":5},1],"n":9,"o":3,"t":1}]}],"m":[{"a":[{"g":[{"a":16}],"l":[{"o":5}],"n":[{"a":5}],"r":[{"t":[{"i":5}]}]}],"e":[{"r":[{"c":11}],"t":[{"e":[{"r":4}],"a":[{"l":[{"a":0}]}]}],"g":[{"a":[{"l":171}]}]},9],"i":[{"s":[{"t":[{"i":6}],"e":[{"r":[{"s":173}]}]},15],"m":[{"i":[{"c":172}]}]}],"o":[{"n":[{"e":11}],"r":[{"o":3}]}],"u":[{"t":[{"a":[{"b":6},4]}]}]}],"n":[{"i":[{"c":1}],"e":[{"o":[{"f":174}]}],"o":[{"e":[{"t":[{"h":15}]}],"n":[{"e":[{"m":175}]}]}]}],"o":[{"d":[{"d":5},9],"f":[{"t":[{"e":4}]}],"r":[{"a":[{"t":[{"o":4}]}],"c":3,"d":2,"t":3}],"s":[{"t":[{"l":1}]},3],"t":[{"h":11}],"u":[{"t":11}]}],"p":[{"e":[{"d":[{"a":[{"l":5}]}],"t":[{"e":4,"i":[{"t":4}]}]}],"i":[{"e":1,"o":[{"n":5}],"t":9}],"r":[{"e":[{"m":11,"a":[{"m":15}]}]}],"o":[{"l":[{"y":[{"s":137}]}],"s":[{"t":[{"a":[{"m":137}]}]}]}]}],"r":[{"a":[{"c":1,"n":[{"t":0}],"t":[{"i":[{"o":[{"n":[{"a":7}]}]}]}],"v":[{"e":[{"n":[{"o":176}]}]}]}],"e":[{"e":[{"c":173},8],"m":[{"i":[{"t":4}]}],"s":[{"t":[{"a":[{"t":4}]}]},8]}],"i":[{"g":1,"t":[{"u":5}]}],"o":[{"q":1,"s":[{"t":5}],"w":[{"d":5}]}],"u":[{"d":1}]}],"s":[{"c":[{"i":[{"e":11}]}],"e":[{"l":[{"f":6,"l":6}],"n":9,"r":[{"i":[{"e":4}]}],"m":[{"i":[{"c":0,"d":177,"p":36,"r":36,"s":178,"v":36},6]}]}],"h":9,"i":[{"n":[{"g":17}]},9],"t":[{"a":[{"b":[{"l":5}]}]},1],"y":9,"p":[{"h":[{"i":[{"n":179}]}],"i":[{"n":[{"o":137}]}]}]}],"t":[{"a":[{"p":[{"e":[{"s":[{"t":[{"r":180}]}]}]}]},1],"e":[{"n":[{"a":[{"n":5}]}],"l":[{"e":[{"g":[{"r":3}]}]}]},1],"h":9,"i":[{"l":0,"m":[{"o":16}],"n":[{"g":17,"k":5}]},9],"o":[{"n":[{"a":0}],"p":[{"i":5,"o":[{"g":170}]},1],"u":[{"s":5}],"q":9}],"r":[{"i":[{"b":[{"u":[{"t":6}]}]}]}]}],"u":[{"n":[{"a":[{"t":[{"t":144}]},2],"c":[{"e":3}],"d":[{"e":[{"r":7}]}],"e":[{"r":[{"r":181}]},2],"k":4,"o":4,"u":3}],"p":3,"r":[{"e":11}],"s":[{"a":4}]}],"v":[{"e":[{"n":[{"d":[{"e":0}]}],"r":[{"a":4}]}],"i":[{"c":[{"a":[{"r":151}]}]}]}],"w":[{"i":[{"l":[{"i":5}]}],"e":[{"b":[{"l":131}]}]}],"y":[{"e":1}],"k":[{"i":[{"l":[{"n":[{"i":168}]}]}],"o":[{"r":[{"t":[{"e":169}]}]}]}]}],"a":[{"b":[{".":18,"a":[{"l":19,"n":19}],"e":[{"r":[{"d":4}]},8],"i":[{"a":5,"t":[{"a":[{"b":13}]}]}],"l":[{"a":[{"t":4}]}],"o":[{"l":[{"i":[{"z":20,"c":19}]}]}],"r":[{"o":[{"g":4}]},18],"u":[{"l":3}]}],"c":[{"a":[{"r":[{"d":4,"o":4},21],"b":[{"l":24}]}],"e":[{"o":[{"u":19}],"r":2}],"h":[{"e":[{"t":19}]}],"i":[{"e":23,"n":2,"o":23},22],"r":[{"o":[{"b":4}]}],"t":[{"i":[{"f":5}]}],"u":[{"l":3,"m":1}]}],"d":[{"d":[{"i":[{"n":1}]}],"e":[{"r":[{".":4}]}],"i":[{"a":23,"c":[{"a":3}],"e":[{"r":0}],"o":23,"t":23,"u":19},25],"l":[{"e":1}],"o":[{"w":3}],"r":[{"a":[{"n":4}]}],"s":[{"u":1}],"u":[{"c":23,"m":4},18]},24],"e":[{"r":[{"i":[{"e":17}]},1]}],"f":[{"f":[{"i":[{"s":[{"h":170}]}]},0]},24],"g":[{"a":[{"b":21,"n":0}],"e":[{"l":[{"l":4}],"o":0,"u":18}],"i":2,"l":26,"n":2,"o":[{"g":27,"n":[{"i":3}]},24],"u":[{"e":[{"r":19}],"l":4}],"y":21}],"h":[{"a":23,"e":23,"l":1,"o":23}],"i":[{"a":19,"c":[{".":23}],"l":[{"y":4}],"n":[{"i":[{"n":5}],"o":5},28],"t":[{"e":[{"n":5}]}]},9],"j":29,"k":[{"e":[{"n":2}]}],"l":[{"a":[{"b":4,"d":3,"r":21}],"d":[{"i":18}],"e":[{"n":[{"d":3,"t":[{"i":21}]}],"o":30},25],"i":[{"a":[{".":1}],"e":0},2],"l":[{"e":[{"v":4}],"i":[{"c":18}]}],"m":18,"o":[{"g":[{".":19}]}],"y":[{".":21,"s":[{"t":31},18],"t":32,"z":27}]}],"m":[{"a":[{"b":4,"g":3,"r":[{"a":5}],"s":[{"c":4}],"t":[{"i":[{"s":21}],"o":33}]},18],"e":[{"r":[{"a":4}],"n":[{"t":[{"a":[{"b":182}]}]}]}],"i":[{"c":3,"f":4,"l":[{"y":4}],"n":[{"o":0},2]}],"o":[{"n":19,"r":[{"i":6}]},24],"p":[{"e":[{"n":5}]}]}],"n":[{"a":[{"g":[{"e":3}],"l":[{"y":[{"s":183},27]}],"r":[{"c":3,"i":17},23],"t":[{"i":23}]}],"d":[{"e":[{"s":17}],"i":[{"s":3}],"l":2,"o":[{"w":1}]},18],"e":[{"e":19,"n":23,"s":[{"t":[{".":4}]}],"u":23}],"g":[{"i":[{"e":5}],"l":2},25],"i":[{"c":34,"e":[{"s":23}],"f":35,"m":[{"e":1,"i":19}],"n":[{"e":19}],"o":3,"p":23,"s":[{"h":3}],"t":3,"u":23}],"k":[{"l":[{"i":1}]}],"n":[{"i":[{"z":32}]}],"o":[{"t":[{"h":7},4],"a":[{"c":148}]},0],"s":[{"a":9,"c":[{"o":1}],"n":1,"p":[{"o":11},9],"t":1,"u":[{"r":1}],"g":[{"r":5}],"v":11}],"t":[{"a":[{"l":36}],"i":[{"e":1,"d":137,"n":184,"r":[{"e":137}]}],"o":18,"r":9,"w":1}],"u":[{"a":3,"l":3,"r":19}]},24],"o":18,"p":[{"a":[{"r":17,"t":4}],"e":[{"r":[{"o":4}],"a":[{"b":[{"l":[{"e":132}]}]}]}],"h":[{"e":[{"r":23}],"i":18}],"i":[{"l":[{"l":[{"a":[{"r":4},21]}]}],"n":3,"t":[{"a":3,"u":23}]}],"l":24,"o":[{"c":6,"l":[{"a":4}],"r":[{"i":6}],"s":[{"t":12}]}],"s":[{"e":[{"s":5}]}],"u":23}],"q":[{"u":[{"e":6}]}],"r":[{"a":[{"c":[{"t":3}],"d":[{"e":19,"i":[{"s":4}]}],"l":3,"m":[{"e":[{"t":[{"e":19}]}]}],"n":[{"g":17}],"p":11,"t":[{"i":[{"o":19,"v":4}]},1],"u":19,"v":38,"w":17}],"b":[{"a":[{"l":36}]}],"c":[{"h":[{"a":[{"n":1}],"e":[{"t":185}]}]}],"d":[{"i":[{"n":[{"e":4}]}],"r":1}],"e":[{"a":[{"s":4}],"e":23,"n":[{"t":3}],"s":[{"s":19}]}],"f":[{"i":1,"l":1}],"i":[{"a":[{"l":4,"n":3}],"e":[{"t":23}],"m":1,"n":[{"a":[{"t":4}]}],"o":3,"z":9},2],"m":[{"i":9}],"o":[{"d":20,"n":[{"i":19}],"o":23}],"p":9,"q":3,"r":[{"e":17,"a":[{"n":[{"g":[{"e":9}]}]}]}],"s":[{"a":1,"h":9}]},37],"s":[{".":18,"a":[{"b":1,"n":[{"t":3}]}],"h":[{"i":17}],"i":[{"a":[{".":19}],"b":23,"c":23,"t":39}],"k":[{"i":11}],"l":1,"o":[{"c":21}],"p":[{"h":4}],"s":[{"h":1}],"t":[{"e":[{"n":3}],"r":2}],"u":[{"r":[{"a":6}]}],"y":[{"m":[{"p":[{"t":[{"o":[{"t":4}]}]}]}]}]}],"t":[{"a":[{"b":[{"l":3}],"c":4,"l":[{"o":3}],"p":4},24],"e":[{"c":[{"h":4},5],"g":[{"o":3}],"n":[{".":3}],"r":[{"a":3,"n":[{"a":19},6]}],"s":[{"t":3}],"v":4}],"h":[{"e":[{"m":5,"n":19,"r":[{"o":[{"s":186}]}]}],"o":[{"m":5},1]},18],"i":[{".":18,"a":19,"b":20,"c":2,"f":3,"o":[{"n":[{"a":[{"r":7}]}]}],"t":[{"u":3}]}],"o":[{"g":21,"m":[{"i":[{"z":4}]},24],"p":21,"s":21}],"r":[{"o":[{"p":4}]},29],"s":[{"k":1}],"t":[{"a":[{"g":1}],"e":[{"s":[{".":170}]},4],"h":1}],"u":[{"a":4,"e":4,"l":3,"r":[{"a":3}]},24],"y":24}],"u":[{"b":1,"g":[{"h":[{"t":[{"l":17}]},12],"u":3}],"l":[{"i":[{"f":13}]},40],"n":[{"d":5}],"r":3,"s":[{"i":[{"b":4}]}],"t":[{"e":[{"n":5}],"h":2}]}],"v":[{"a":[{"g":3,"n":19},24],"e":[{"n":[{"o":0}],"r":[{"a":3,"n":4,"y":4}]}],"i":[{"e":[{"r":0}],"g":3,"o":[{"u":3}]},2],"o":[{"c":4,"r":29}]}],"w":[{"a":[{"y":27}],"i":3,"l":[{"y":1}],"s":0}],"x":[{"i":[{"c":1,"d":1}]}],"y":[{"a":[{"l":4}],"e":0,"s":0}],"z":[{"i":[{"e":[{"r":0}]}],"z":[{"i":5}]}]}],"b":[{"a":[{".":32,"d":[{"g":[{"e":[{"r":5}]}]}],"g":[{"e":1}],"l":[{"a":15}],"n":[{"d":[{"a":[{"g":5}]}],"e":0,"i":11}],"r":[{"b":[{"i":7}],"i":[{"a":17}],"o":[{"n":[{"i":[{"e":187}]}]}]}],"s":[{"s":[{"i":0}]}],"t":[{"h":[{"y":2}]},41],"z":1,"c":[{"k":[{"e":[{"r":[{".":84}]}]}]}]}],"b":[{"e":[{"r":23},24],"i":[{"n":[{"a":0}],"t":0}]},42],"d":43,"e":[{".":18,"a":[{"k":17,"t":12}],"d":[{"a":3,"e":3,"i":3},44],"g":[{"i":3,"u":4}],"l":[{"i":2,"o":3},41],"m":45,"n":[{"i":[{"g":4}],"u":4}],"s":[{"p":3,"t":[{"r":4}]},46],"t":[{"i":[{"z":5}],"r":4,"w":3},27],"w":3,"y":[{"o":4}],"v":[{"i":[{"e":9}]}]}],"f":25,"h":47,"i":[{"b":9,"d":[{"i":[{"f":167}]},1],"e":[{"n":4,"r":1},27],"f":48,"l":[{"i":[{"z":3}],"l":[{"a":[{"b":8}]}]},41],"n":[{"a":[{"r":49}],"d":0,"e":[{"t":4}]}],"o":[{"g":[{"r":3}],"u":4,"m":5,"r":[{"b":2,"h":15}]}],"t":[{"i":[{"o":50,"v":[{"e":188}]}],"r":3,"u":[{"a":51}],"z":19},9]}],"j":29,"k":1,"l":[{"a":[{"t":[{"h":7}],"n":[{"d":189}]}],"e":[{".":21,"n":17,"s":[{"p":32}]}],"i":[{"s":23,"n":[{"d":189}]}],"o":[{"n":[{"d":190}]},21],"u":[{"n":[{"t":17}]}]},52],"m":43,"n":[{"e":[{"g":5}]},47],"o":[{"d":[{"i":11},27],"e":1,"l":[{"i":[{"c":11}]}],"m":[{"b":[{"i":0}]}],"n":[{"a":[{"t":5},0]}],"o":27,"r":[{".":32,"a":43,"d":5,"e":32,"i":32,"n":[{"o":191}]}],"s":53,"t":[{"a":19,"h":6,"o":1,"u":[{"l":192}]}],"u":[{"n":[{"d":54}]}]}],"p":18,"r":[{"i":[{"t":18}],"o":[{"t":[{"h":54}]}],"u":[{"s":[{"q":17}]}]}],"s":[{"o":[{"r":17}]},55],"t":[{"l":1,"o":21,"r":23},25],"u":[{"f":[{"f":[{"e":[{"r":0}]}]}],"g":[{"a":1}],"l":[{"i":3}],"m":[{"i":17}],"n":[{"t":[{"i":17}]},1],"r":[{"e":3}],"s":[{"i":[{"e":[{"r":193,"s":193},5]}],"s":[{"e":17,"i":[{"n":[{"g":17}]}]}],"t":32}],"t":[{"a":18,"i":[{"o":27}],"o":19,"e":[{"d":[{".":8}]}],"t":[{"e":[{"d":0}]}]}]}],"v":29,"w":56,"y":[{".":32,"s":0}]}],"c":[{"a":[{"b":[{"i":[{"n":11}],"l":2}],"c":[{"h":17}],"d":[{"e":[{"n":4,"m":194}]}],"g":46,"h":57,"l":[{"a":[{"t":3}],"l":[{"a":0,"i":[{"n":6}]}],"o":18}],"n":[{"d":5,"e":0,"i":[{"c":0,"s":5,"z":11}],"t":[{"y":0}],"y":17}],"p":[{"e":[{"r":4}]}],"r":[{"o":[{"m":5}]}],"s":[{"t":[{"e":[{"r":6}],"i":[{"g":5}]}],"y":18}],"t":[{"h":1,"i":[{"v":18}],"a":[{"s":195}]}],"v":[{"a":[{"l":5}]}]},41],"c":[{"h":[{"a":6}],"i":[{"a":0}],"o":[{"m":[{"p":[{"a":10}]}],"n":17,"u":[{"t":12}]}]},23],"e":[{".":25,"d":[{".":18,"e":[{"n":18}]}],"i":27,"l":[{".":32,"l":27}],"n":[{"c":27,"e":58,"i":18,"t":27},41],"p":27,"r":[{"a":[{"m":4}]}],"s":[{"a":18,"s":[{"i":[{"b":59},27]}],"t":5}],"t":[{"a":60},0],"w":0}],"h":[{".":18,"a":[{"b":61,"n":[{"i":[{"c":32,"s":20}]}]}],"e":[{"a":[{"p":54}],"d":18,"l":[{"o":5}],"m":[{"i":27}],"n":[{"e":4}],"r":[{".":3,"s":3}]},8],"i":[{"n":[{"e":[{".":32,"s":[{"s":4}]}],"i":32},62],"o":32,"t":27,"z":8,"e":[{"v":[{"o":6}]}]}],"o":63,"t":[{"i":1}],"s":[{".":18,"h":[{"u":11}]}]},25],"i":[{"a":[{"b":64,"r":5},27],"c":4,"e":[{"r":18}],"f":[{"i":[{"c":[{".":32}]}]}],"i":18,"l":[{"a":1,"i":27}],"m":25,"n":[{"a":[{"t":27},21],"e":[{"m":11}],"g":[{".":19},29],"o":32,"q":8},25],"o":[{"n":17}],"p":[{"e":18,"h":3,"i":[{"c":18}]}],"s":[{"t":[{"a":18,"i":18}]}],"t":[{"i":[{"z":11}]},42],"z":32,"g":[{"a":[{"r":152}]}]},41],"k":[{"i":3},2],"l":[{"a":[{"r":[{"a":[{"t":[{"i":[{"o":19}]}]}],"e":32},18]}],"e":[{"m":0,"a":[{"r":0}]}],"i":[{"c":18,"m":17}],"y":0},65],"n":19,"o":[{"a":[{"g":4}],"e":8,"g":[{"r":1},25],"i":[{"n":[{"c":3}]},0],"l":[{"i":5,"o":[{"r":11},32]}],"m":[{"e":[{"r":5}]}],"n":[{"a":0,"e":21,"g":11,"t":5}],"p":[{"a":3,"i":[{"c":11}],"l":1,"h":[{"o":[{"n":196}]}]}],"r":[{"b":18,"o":[{"n":12}]}],"s":[{"e":0}],"v":[{"e":17},15],"w":[{"a":5}],"z":[{"e":5,"i":4}],"u":[{"s":[{"t":[{"i":84}]}]}]},41],"q":29,"r":[{"a":[{"s":[{"t":6}],"t":[{".":32,"i":[{"c":32}]}]}],"e":[{"a":[{"t":11}],"d":32,"t":[{"a":47}],"v":0}],"i":[{"f":5,"n":21,"s":17,"t":[{"i":[{"e":11},32]}]},8],"o":[{"p":[{"l":0,"o":6}],"s":[{"e":17}],"c":[{"o":[{"d":197}]}],"e":[{"c":[{"o":148}]}]}],"u":[{"d":0}]}],"s":66,"t":[{"a":[{"b":0,"n":[{"g":4,"t":19}]}],"e":[{"r":23},24],"i":[{"c":[{"u":21}],"m":[{"i":12}]}],"u":[{"r":0}],"w":21,"r":[{"o":[{"m":[{"e":[{"c":198}]}]}]}]},42],"u":[{"d":5,"f":21,"i":[{"t":[{"y":4}]},21],"l":[{"i":32,"t":[{"i":[{"s":0}],"u":27}]}],"m":[{"a":9,"e":23,"i":1}],"n":27,"p":[{"i":3,"y":4}],"r":[{"a":[{"b":67,"n":[{"c":[{"e":199}]}]}],"i":[{"a":4}]}],"s":[{"s":[{"i":17}]},41],"t":[{"i":[{"e":1,"v":56}],"r":18},68]}],"y":41,"z":[{"e":0}]}],"d":[{"a":[{".":32,"b":70,"c":[{"h":17}],"f":18,"g":25,"m":71,"n":[{"g":11}],"r":[{"d":6,"k":6,"y":18}],"t":[{"i":[{"v":18}],"o":18,"a":[{"b":137}]},27],"v":[{"e":5},53],"y":32,"l":[{"o":[{"n":[{"e":48}]}]}]},69],"b":29,"c":19,"d":[{"a":[{"b":20}],"i":[{"b":94}]},72],"e":[{".":25,"a":[{"f":6,"l":[{"s":[{".":1}]}]}],"b":[{"i":[{"t":5}],"o":[{"n":1}]}],"c":[{"a":[{"n":36}],"i":[{"l":1}],"o":[{"m":4}],"l":[{"a":[{"r":200}],"i":[{"n":[{"a":64}]}]}]}],"d":42,"e":[{".":18}],"i":[{"f":4}],"l":[{"i":[{"e":17,"q":16}],"o":4}],"m":[{".":32,"i":[{"c":[{".":5},27],"l":4}],"o":[{"n":[{"s":1}],"r":7,"s":9}]},21],"n":[{"a":[{"r":1}],"o":3,"t":[{"i":[{"f":7}]}],"u":3},41],"p":[{"a":3,"i":17,"u":9},2],"q":23,"r":[{"h":21,"m":32,"n":[{"i":[{"z":6}]}],"s":5}],"s":[{".":24,"c":2,"o":64,"t":[{"i":11,"r":3}],"u":1,"i":[{"c":11}]},8],"t":[{"o":9,"i":[{"c":9}]},2],"v":[{"i":[{"l":11}]},2],"y":18,"f":[{"i":[{"n":[{"i":[{"t":[{"i":201}]}]}]}]}]}],"f":43,"g":[{"a":21,"e":[{"t":73}],"i":2,"y":24}],"h":74,"i":[{".":32,"a":[{"b":5},75],"c":[{"a":[{"m":1,"i":[{"d":15}]}],"e":21,"t":27}],"d":27,"e":[{"n":76}],"f":[{"f":[{"r":[{"a":5}]}]},29],"g":[{"e":3}],"l":[{"a":[{"t":[{"o":1}]}]}],"n":[{"a":41,"e":[{".":27}],"i":[{"z":4},32]},29],"o":[{"g":5},41],"p":[{"l":1}],"r":[{"e":[{"n":9,"r":9},2],"t":[{"i":6}]},8],"s":[{"i":32,"t":77},15],"t":[{"i":24}],"v":78,"m":[{"e":[{"t":[{"h":[{"y":141}]}]}]}]}],"j":29,"k":79,"l":[{"a":56,"e":[{".":27,"d":27,"s":[{".":27,"s":18}],"a":[{"d":42}]}],"o":48,"u":56,"y":25,"i":[{"e":202}]}],"m":29,"n":80,"o":[{".":27,"d":[{"e":4}],"e":32,"f":57,"g":21,"l":[{"a":1,"i":17,"o":[{"r":4}]}],"m":[{"i":[{"z":5}]}],"n":[{"a":[{"t":3}],"i":17}],"o":[{"d":11}],"p":[{"p":0}],"r":21,"s":27,"u":[{"t":56}],"v":1,"x":27,"w":[{"o":[{"r":[{"d":203}]}]}]},41],"p":29,"r":[{"a":[{"g":[{"o":[{"n":6}]}],"i":18}],"e":[{"a":[{"r":6}],"n":[{"a":[{"l":204}]},32]},0],"i":[{"b":0,"l":17,"f":[{"t":[{"a":189}]}],"p":[{"l":[{"e":[{"g":205}]}]}]}],"o":[{"p":0,"w":18,"m":[{"e":[{"d":206}]}]}],"u":[{"p":[{"l":[{"i":32}]}]}],"y":18},41],"s":[{"p":1,"w":21,"y":21},81],"t":[{"h":24,"a":[{"b":23}]}],"u":[{"a":[{"l":[{".":9}]},82],"c":[{"a":29,"e":[{"r":5}],"t":[{".":18,"s":18}]},9],"e":[{"l":4}],"g":1,"l":[{"e":23}],"m":[{"b":[{"e":0}]}],"n":1,"p":[{"e":1},18],"o":[{"p":[{"o":[{"l":207}]}]}]},41],"v":29,"w":29,"y":[{"n":32,"s":[{"e":1,"p":5}]},24]}],"e":[{"a":[{"b":72,"c":[{"t":23}],"d":[{"i":[{"e":5}]},15],"g":[{"e":[{"r":4},1]}],"l":[{"e":[{"r":5}],"o":[{"u":11}]},1],"m":[{"e":[{"r":11}]}],"n":[{"d":19,"i":[{"e":[{"s":111}]}]}],"r":[{"a":11,"c":0,"e":[{"s":5}],"i":[{"c":0,"l":0}],"k":5,"t":[{"e":12},8]}],"s":[{"p":4,"s":23,"t":12}],"t":[{"e":[{"n":5}],"h":[{"i":12}],"i":[{"f":19}],"u":83},9],"v":[{"e":[{"n":11}],"i":5,"o":5},9]}],"b":[{"e":[{"l":[{".":21,"s":21}],"n":21}],"i":[{"t":21}],"r":23},42],"c":[{"a":[{"d":21,"n":[{"c":6}]}],"c":[{"a":6}],"e":[{"s":[{"s":[{"a":4}]}]},29],"i":[{"b":21,"f":[{"i":[{"c":[{"a":[{"t":4}]}],"e":4}],"y":4}],"m":3,"t":[{"e":19},0]},9],"l":[{"a":[{"m":21}],"u":[{"s":21}]}],"o":[{"l":24,"m":[{"m":21,"p":[{"e":21}]}],"n":[{"c":21}],"r":[{"a":3,"o":5},24]}],"r":[{"e":[{"m":21}]},29],"t":[{"a":[{"n":1}],"e":1}],"u":[{"l":[{"a":3},21]},29],"h":[{"a":[{"s":23}]}]}],"d":[{"a":37,"d":61,"e":[{"r":34,"s":0}],"i":[{"a":23,"b":3,"c":[{"a":3}],"m":3,"t":2,"z":5},18],"o":[{"l":21,"n":84},18],"r":[{"i":21}],"u":[{"l":[{"o":4,"i":[{"n":[{"g":2}]}]},21]}],"g":[{"l":15}]}],"e":[{"c":9,"d":[{"i":11}],"f":9,"l":[{"i":11,"y":1}],"m":9,"n":[{"a":1}],"p":85,"s":[{"t":17},86],"t":[{"y":1}],"x":19}],"f":[{"e":[{"r":[{"e":83}]}],"f":41,"i":[{"c":[{"i":32},21],"l":17,"n":[{"e":23,"i":[{"t":[{"e":20}]}]}],"t":27}],"o":[{"r":[{"e":[{"s":6}]}]}],"u":[{"s":[{"e":[{".":21}]}]}]},29],"g":[{"a":[{"l":18}],"e":[{"r":17}],"i":[{"b":4,"c":1,"n":[{"g":4}],"t":87}],"n":4,"o":[{".":21,"s":21}],"u":[{"l":2,"r":19}],"y":32}],"h":[{"e":[{"r":17}]},72],"i":[{"c":19,"d":4,"g":[{"l":4},8],"m":[{"b":23}],"n":[{"f":23,"g":29,"s":[{"t":19}]}],"r":[{"d":0}],"t":[{"e":11,"h":3,"y":19}]},9],"j":[{"u":[{"d":[{"i":4},21]}]},29],"k":[{"i":[{"n":0}],"l":[{"a":1}]}],"l":[{"a":[{".":21,"c":21,"n":[{"d":17}],"t":[{"i":[{"v":4}]}],"w":21,"x":[{"a":36}]},29],"e":[{"a":23,"b":[{"r":[{"a":4}]}],"c":32,"d":21,"g":[{"a":3}],"n":19,"r":34,"s":29}],"f":9,"i":[{"b":[{"e":23}],"c":[{".":33,"a":3}],"e":[{"r":23}],"g":[{"i":[{"b":4}]}],"m":19,"n":[{"g":83}],"o":23,"s":[{"h":4},24],"v":88,"t":[{"i":[{"s":208}]}]},9],"l":[{"a":[{"b":1},18],"o":17}],"o":[{"c":19,"g":4,"p":[{".":3}],"a":29}],"s":[{"h":9}],"t":[{"a":1}],"u":[{"d":19,"g":4}]}],"m":[{"a":[{"c":21,"g":21,"n":[{"a":4},19]}],"b":4,"e":[{"l":24,"t":21},29],"i":[{"c":[{"a":3}],"e":0,"g":[{"r":[{"a":4}]}],"n":[{"e":4,"i":35},89],"s":[{"h":4,"s":19},21],"z":3}],"n":[{"i":[{"z":32}]}],"o":[{"g":0,"n":[{"i":[{"o":7}]}]}],"p":[{"i":3}],"u":[{"l":[{"a":4},21],"n":11}],"y":23}],"n":[{"a":[{"m":[{"o":4}],"n":[{"t":21}]}],"c":[{"h":[{"e":[{"r":17}]}]}],"d":[{"i":[{"c":3,"x":2}]}],"e":[{"a":19,"e":19,"m":3,"r":[{"o":4}],"s":[{"i":4,"t":4}],"t":[{"r":3}],"w":23}],"i":[{"c":[{"s":4}],"e":19,"l":19,"o":23,"s":[{"h":3}],"t":3,"u":19,"z":32}],"n":18,"o":[{"g":0,"s":21,"v":3},18],"s":[{"w":1}],"t":[{"a":[{"g":[{"e":5}]}],"h":[{"e":[{"s":18}]}]}],"u":[{"a":3,"f":4}],"y":[{".":23}],"z":61}],"o":[{"f":19,"g":[{"r":[{"a":[{"p":3}]}]},9],"i":90,"l":23,"p":[{"a":[{"r":11}]}],"r":[{"e":3,"o":[{"l":4}]},29],"s":0,"t":[{"o":1},21],"u":[{"t":19}],"w":19}],"p":[{"a":[{"i":23,"n":[{"c":4}]},24],"e":[{"l":19,"n":[{"t":23}],"t":[{"i":[{"t":[{"i":[{"o":4}]}]}]}]}],"h":[{"e":17}],"l":[{"i":21}],"o":29,"r":[{"e":[{"c":[{"a":4},21],"d":21,"h":3}],"o":[{"b":21},23]}],"s":[{"h":1}],"t":[{"i":[{"b":13}]}],"u":[{"t":[{"a":4},21]}],"i":[{"n":[{"e":[{"p":[{"h":209}]}]}]}]}],"q":[{"u":[{"i":[{"l":12,"s":91}]}]},29],"r":[{"a":[{"b":0,"n":[{"d":18}],"r":3,"t":[{"i":[{".":18}]}]},2],"b":[{"l":1},25],"c":[{"h":[{"e":1},3]}],"e":[{".":25,"a":[{"l":23}],"c":[{"o":5}],"i":[{"n":11}],"l":[{".":4}],"m":[{"o":3}],"n":[{"a":4,"c":[{"e":4}],"e":18,"t":3}],"q":0,"s":[{"s":4,"t":3}],"t":17}],"h":2,"i":[{"a":[{"n":[{".":210}]},92],"c":[{"k":32}],"e":[{"n":23,"r":0}],"n":[{"e":3}],"o":29,"t":18,"u":1,"v":[{"a":21},0]},2],"m":93,"n":[{"i":[{"s":1,"t":18,"z":32}],"o":3}],"o":[{"b":4,"c":19,"r":0,"u":2},25],"s":[{"e":[{"t":3}]},2],"t":[{"e":[{"r":11}],"l":18,"w":3}],"u":[{"t":0},18],"w":[{"a":[{"u":32}]}]}],"s":[{"a":[{"g":[{"e":[{".":21,"s":21}]}]},72],"c":[{"a":[{"n":4},24],"r":23,"u":4},9],"e":[{"c":[{"r":4},24],"n":[{"c":4}],"r":[{"t":[{".":21,"s":21}],"v":[{"a":21}]}]},74],"h":[{"a":23,"e":[{"n":5}]},18],"i":[{"c":24,"d":[{"e":[{"n":4}]},24],"g":[{"n":[{"a":4}]}],"m":94,"n":95,"s":[{"t":[{"e":17}]}],"u":0},29],"k":[{"i":[{"n":19}]}],"m":[{"i":1}],"o":[{"l":[{"u":3},24],"n":[{"a":4},24]}],"p":[{"e":[{"r":3}],"i":[{"r":[{"a":4}]}],"r":[{"e":1}],"a":[{"c":[{"i":211}]}]},29],"s":[{"i":[{"b":96}]},25],"t":[{"a":[{"n":36}],"i":[{"g":3,"m":4}],"o":[{"n":23},44],"r":[{"o":19,"u":[{"c":10}]},25]}],"u":[{"r":[{"r":4},24]}],"w":1}],"t":[{"a":[{"b":0}],"e":[{"n":[{"d":17}],"o":23}],"h":[{"o":[{"d":54}],"y":[{"l":[{"e":[{"n":[{"e":162}]}]}]}]}],"i":[{"c":2,"d":[{"e":19}],"n":[{"o":0},17],"r":19,"t":[{"i":[{"o":19,"v":4}]}]}],"n":18,"o":[{"n":[{"a":4}]}],"r":[{"a":23,"e":23,"i":[{"c":3,"f":4}],"o":[{"g":3,"s":4}]}],"u":[{"a":3}],"y":[{"m":4}],"z":4}],"u":[{"n":19,"p":23,"r":[{"o":3}],"s":0,"t":[{"e":17,"i":[{"l":6}],"r":4}],"c":[{"l":[{"i":[{"d":212}]}]}]},18],"v":[{"a":[{"p":97,"s":[{"t":4},24]}],"e":[{"a":19,"l":[{"l":3,"o":12}],"n":[{"g":19,"i":17}],"r":[{"b":19},2]}],"i":[{"d":3,"l":0,"n":21,"v":0},29],"o":[{"c":19}],"u":19}],"w":[{"a":[{"g":21},29],"e":[{"e":19}],"h":23,"i":[{"l":6,"n":[{"g":3}],"t":23}]}],"x":[{"p":41}],"y":[{"c":32,"e":[{".":32}],"s":0}]}],"f":[{"a":[{"b":[{"l":3,"r":11}],"c":[{"e":1}],"g":18,"i":[{"n":17}],"l":[{"l":[{"e":6}]}],"m":[{"a":26,"i":[{"s":5}]}],"r":[{"t":[{"h":5}]},32],"t":[{"a":3,"h":[{"e":3}],"o":18}],"u":[{"l":[{"t":7}]}]},41],"b":56,"d":18,"e":[{".":18,"a":[{"s":17,"t":[{"h":54}]}],"b":[{"r":[{"u":[{"a":15}]}]},1],"c":[{"a":18,"t":32}],"d":25,"l":[{"i":3}],"m":[{"o":1}],"n":[{"d":[{"e":6},8]}],"r":[{"r":32,"m":[{"i":[{"o":213}]}]},15],"v":0}],"f":[{"e":[{"s":21}],"i":[{"e":21,"n":[{".":19}],"s":94}],"l":[{"y":21}],"y":24},43],"h":18,"i":[{"a":3,"c":[{".":48,"a":[{"l":47,"n":23,"t":[{"e":18}]}],"e":[{"n":23,"r":3}],"i":[{"a":32,"e":32},0],"s":18,"u":3,"h":27}],"d":[{"e":[{"l":4}]}],"g":[{"h":[{"t":7}]}],"l":[{"i":5,"l":[{"i":[{"n":6}]}],"y":18}],"n":[{"a":32,"d":97,"e":9,"g":98,"n":0},25],"s":[{"t":[{"i":0}]}],"t":[{"t":[{"e":[{"d":[{".":5}]}]}]}]},41],"l":[{"e":[{"s":[{"s":19}]}],"i":[{"n":17}],"o":[{"r":[{"e":11}],"w":[{"e":[{"r":[{".":84}]}]}]}],"y":100,"a":[{"g":[{"e":[{"l":214}]}]}],"u":[{"o":[{"r":27}]}]},99],"m":18,"n":18,"o":[{"n":[{"d":[{"e":0}],"t":0},32],"r":[{"a":[{"t":4,"y":5}],"e":[{"t":6}],"i":0,"t":[{"a":6}]},9],"s":5},41],"p":56,"r":[{"a":[{"t":0}],"e":[{"a":19,"s":[{"c":6}]}],"i":[{"l":17},8],"o":[{"l":6}]}],"s":48,"t":[{"o":21,"y":24},25],"u":[{"e":[{"l":4}],"g":18,"m":[{"i":[{"n":1}]}],"n":[{"e":4}],"r":[{"i":3}],"s":[{"i":17,"s":0}],"t":[{"a":18}]},27],"y":41}],"g":[{"a":[{"f":0,"l":[{".":32,"i":27,"o":3}],"m":[{"e":[{"t":4}],"o":19},25],"n":[{"i":[{"s":5,"z":[{"a":6},3]}],"o":18}],"r":[{"n":67}],"s":[{"s":17}],"t":[{"h":12,"i":[{"v":18}]}],"z":18},41],"b":23,"d":1,"e":[{".":25,"d":25,"e":[{"z":17}],"l":[{"i":[{"n":0,"s":4,"z":4}],"y":18}],"n":[{"a":[{"t":1}],"i":[{"z":4}],"o":18,"y":18,"c":[{"y":[{".":8}]}]},41],"o":[{"m":3,"d":215},41],"r":[{"y":21}],"s":[{"i":32}],"t":[{"h":6,"o":18,"y":1,"i":[{"c":[{".":8}]}]}],"v":1}],"g":[{"e":[{"r":23},24],"l":[{"u":6}],"o":0},101],"h":[{"i":[{"n":3}],"o":[{"u":[{"t":4}]}],"t":[{"o":1,"w":[{"e":15}]}]}],"i":[{".":32,"a":[{"r":5},102],"c":[{"i":[{"a":32}],"o":21},29],"e":[{"n":6,"s":[{".":32}]}],"l":0,"m":[{"e":[{"n":23}]}],"n":[{".":68,"g":[{"e":5}],"s":103}],"o":32,"r":[{"l":0},27],"s":[{"l":23}],"u":1,"v":32,"z":27}],"l":[{"a":[{"d":[{"i":6}],"s":32},0],"e":[{"a":[{"d":29}]},41],"i":[{"b":0,"g":23,"s":[{"h":43}]}],"o":[{"r":11,"b":[{"i":[{"n":106}]}]},27]},9],"m":[{"y":21},29],"n":[{"a":[{".":21,"c":69},1],"e":[{"t":[{"t":17,"i":[{"s":[{"m":137}]}]}]}],"i":[{"n":24,"o":21},29],"o":[{"n":21,"m":[{"o":5}],"r":[{".":216,"e":[{"s":[{"p":24}]}]}]},29]}],"o":[{".":27,"b":5,"e":32,"g":104,"i":[{"s":3}],"n":[{"a":105,"d":[{"o":7}],"i":[{"z":[{"a":217}]},3]},8],"o":32,"r":[{"i":[{"z":4}],"o":[{"u":5}]}],"s":[{".":32}],"v":15},41],"p":23,"r":[{"a":[{"d":[{"a":18}],"i":21,"n":84,"p":[{"h":[{".":32,"e":[{"r":[{".":7},19]}],"i":[{"c":32}],"y":18}]}],"y":18}],"e":[{"n":0,"s":[{"s":[{".":18}]}]}],"i":[{"t":18,"e":[{"v":213}]}],"o":21,"u":[{"f":17}]},41],"s":[{"t":[{"e":19}]},9],"t":[{"h":11}],"u":[{"a":[{"r":[{"d":27}]},1],"e":25,"i":[{"t":106}],"n":27,"s":27,"t":[{"a":[{"n":29}]},26]}],"w":23,"y":[{"n":107,"r":[{"a":4}]},41]}],"h":[{"a":[{"b":[{"l":73}],"c":[{"h":17}],"e":[{"m":0,"t":0}],"g":[{"u":19}],"l":[{"a":[{"m":12},3]}],"m":1,"n":[{"c":[{"i":0,"y":0}],"d":[{".":32}],"g":[{"e":[{"r":6}],"o":6},0],"i":[{"z":108}],"k":0,"t":[{"e":0}]}],"p":[{"l":11,"t":5,"a":[{"r":[{"r":218}]}]}],"r":[{"a":[{"n":3,"s":4}],"d":[{"e":12},8],"l":[{"e":0}],"p":[{"e":[{"n":6}]}],"t":[{"e":[{"r":5}]}]}],"s":[{"s":5}],"u":[{"n":17}],"z":[{"a":11},32],"i":[{"r":[{"s":137}]}],"t":[{"c":[{"h":213}]}]}],"b":29,"e":[{"a":[{"d":41,"r":27}],"c":[{"a":[{"n":1,"t":19}]}],"d":[{"o":13},21],"l":[{"i":93,"l":[{"i":[{"s":0}],"y":0}],"o":19}],"m":[{"p":0}],"n":[{"a":[{"t":5},17]},9],"o":[{"r":5}],"p":5,"r":[{"a":[{"p":12},21],"b":[{"a":0}],"e":[{"a":6}],"n":23,"o":[{"u":19}],"y":23}],"s":[{"p":64},29],"t":[{"e":[{"d":0}]},1],"u":0,"x":[{"a":168}]}],"f":29,"h":29,"i":[{"a":[{"n":4}],"c":[{"o":1}],"g":[{"h":6}],"l":109,"m":[{"e":[{"r":36}]}],"n":[{"a":21}],"o":[{"n":[{"e":17}]}],"p":[{"e":[{"l":[{"a":219}]}]},1],"r":[{"l":0,"o":3,"p":0,"r":0}],"s":[{"e":[{"l":11}],"s":0}],"t":[{"h":[{"e":[{"r":6}]}],"e":[{"s":[{"i":[{"d":12}]}]}]}],"v":9}],"k":18,"l":[{"a":[{"n":17}],"o":[{"r":[{"i":11}]},24]},80],"m":[{"e":[{"t":17}]},43],"n":[{"a":[{"u":[{"z":12}]}]},42],"o":[{"d":[{"i":[{"z":19}],"s":19}],"g":[{"e":17},1],"l":[{"a":[{"r":5}],"e":110}],"m":[{"a":1,"e":12}],"n":[{"a":0,"y":4}],"o":[{"d":27,"n":17}],"r":[{"a":[{"t":5}],"i":[{"s":4,"c":[{".":187}]}],"t":[{"e":12}],"u":4}],"s":[{"e":[{"n":4},0],"p":15}],"u":[{"s":[{"e":54},41]}],"v":[{"e":[{"l":5}]}]}],"p":56,"r":[{"e":[{"e":6}],"o":[{"n":[{"i":[{"z":5}]}],"p":[{"o":11}]}]},26],"s":[{"h":21},101],"t":[{"a":[{"r":21}],"e":[{"n":2,"s":4,"o":[{"u":216}]}],"y":21}],"u":[{"g":1,"m":[{"i":[{"n":1}]}],"n":[{"k":[{"e":5}],"t":0}],"s":[{"t":14}],"t":1}],"w":[{"a":[{"r":[{"t":21}]}]},29],"y":[{"p":[{"e":3,"h":3,"o":[{"t":[{"h":[{"a":137}]}]}]}],"s":9}]}],"i":[{"a":[{"l":24,"m":[{"e":[{"t":[{"e":5}]}]},0],"n":[{"c":18,"i":11,"t":46},24],"p":[{"e":4}],"s":[{"s":17}],"t":[{"i":[{"v":21}],"r":[{"i":[{"c":1}]}],"u":21}]},42],"b":[{"e":[{"r":[{"a":3,"t":4}]},0],"i":[{"a":4,"n":3,"t":[{".":4,"e":4}]}],"l":[{"i":3},29],"o":19,"r":[{"i":94},29],"u":[{"n":19}]}],"c":[{"a":[{"m":18,"p":32,"r":[{".":21,"a":21},18],"s":6,"y":21}],"c":[{"u":17}],"e":[{"o":18}],"h":18,"i":[{"d":19,"n":[{"a":4}],"p":[{"a":3},24]},25],"l":[{"y":21}],"o":[{"c":94}],"r":[{"a":32,"y":21},43],"t":[{"e":1,"u":[{"a":111},84]}],"u":[{"l":[{"a":3}],"m":1,"o":4,"r":23}]}],"d":[{"a":[{"i":21,"n":[{"c":4}]}],"d":4,"e":[{"a":[{"l":11}],"s":0}],"i":[{"a":[{"n":4,"r":0}],"e":19,"o":[{"u":5,"s":1},3],"t":2,"u":4},24],"l":[{"e":23}],"o":[{"m":21,"w":3}],"r":21,"u":[{"o":4},24]},25],"e":[{"d":[{"e":0}],"g":[{"a":113}],"l":[{"d":12}],"n":[{"a":67,"e":0,"n":19,"t":[{"i":23}]}],"r":[{".":29}],"s":[{"c":23,"t":29}],"t":23},112],"f":[{".":18,"e":[{"r":[{"o":4}]}],"f":[{"e":[{"n":5}],"r":1}],"i":[{"c":[{".":18}],"e":23}],"l":23,"t":18,"a":[{"c":[{"e":[{"t":137}]}]}]}],"g":[{"a":[{"b":5}],"e":[{"r":[{"a":3}]}],"h":[{"t":[{"i":12}]}],"i":[{"b":23,"l":3,"n":3,"t":3},18],"l":28,"o":[{"r":3,"t":4},24],"r":[{"e":19}],"u":[{"i":5,"r":2}],"n":[{"i":[{"t":[{"e":[{"r":213}]},0]}]}]},25],"h":23,"i":114,"j":[{"k":21},23],"k":18,"l":[{"a":[{"b":93,"d":[{"e":21}],"m":94,"r":[{"a":5}]},29],"e":[{"g":23,"r":2,"v":17}],"f":4,"i":[{"a":3,"b":9,"o":3,"s":[{"t":1}],"t":25,"z":9},2],"l":[{"a":[{"b":5}]}],"n":18,"o":[{"q":3}],"t":[{"y":1}],"u":[{"r":4}],"v":3}],"m":[{"a":[{"g":[{"e":3},21],"r":[{"y":5}]}],"e":[{"n":[{"t":[{"a":[{"r":10}]}]}],"t":18}],"i":[{"d":[{"a":4}],"l":[{"e":5}],"n":[{"i":19}],"t":18},2],"n":[{"i":1}],"o":[{"n":23}],"u":[{"l":[{"a":3}]},24],"p":[{"e":[{"d":[{"a":201}]}]}]}],"n":[{".":25,"a":[{"u":83,"v":18}],"c":[{"e":[{"l":36,"r":3}]}],"d":[{"l":[{"i":[{"n":[{"g":4}]}]}]},18],"e":[{"e":23,"r":[{"a":[{"r":17}]}],"s":[{"s":19}]},25],"g":[{"a":18,"e":[{"n":4},18],"i":18,"l":[{"i":[{"n":[{"g":4}]}]}],"o":18,"u":18}],"i":[{".":19,"a":21,"o":3,"s":2,"t":[{"e":[{".":19,"l":[{"y":[{".":19}]}]}],"i":[{"o":32}],"y":3}]},25],"k":18,"l":18,"n":25,"o":[{"c":90,"s":0,"t":21},42],"s":[{"e":3,"u":[{"r":[{"a":7}]}]},25],"t":[{".":25,"h":112}],"u":[{"s":19},2],"y":18,"f":[{"r":[{"a":[{"s":220}]}]}]}],"o":[{".":18,"g":[{"e":17,"r":9}],"l":29,"m":1,"n":[{"a":[{"t":11}],"e":[{"r":[{"y":0}]}],"i":11}],"p":[{"h":4}],"r":[{"i":11}],"s":21,"t":[{"h":4,"i":19,"o":1}],"u":[{"r":21}]},25],"p":[{"e":0,"h":[{"r":[{"a":[{"s":115}]}]}],"i":[{"c":1},3],"r":[{"e":96}],"u":[{"l":3}]},25],"q":[{"u":[{"a":23,"e":[{"f":4}],"i":[{"d":3,"t":116}]}]}],"r":[{"a":[{"b":0,"c":21},29],"d":[{"e":5}],"e":[{"d":[{"e":0}],"f":21,"l":117,"s":21}],"g":[{"i":4}],"i":[{"d":[{"e":5}],"s":1,"t":[{"u":11}],"z":118},2],"m":[{"i":[{"n":1}]}],"o":[{"g":0,"n":[{".":32}]}],"u":[{"l":4}],"r":[{"e":[{"v":[{"o":[{"c":221}]}]}]}]},18],"s":[{".":25,"a":[{"g":4,"r":3,"s":6}],"c":[{"h":3},119],"e":[{"r":3},18],"f":27,"h":[{"a":[{"n":4}],"o":[{"n":3,"p":5}]}],"i":[{"b":3,"d":0,"s":19,"t":[{"i":[{"v":4}]}]}],"k":26,"l":[{"a":[{"n":36}]}],"m":[{"s":18}],"o":[{"m":[{"e":[{"r":5}]}]},24],"p":[{"i":9,"y":1},2],"s":[{"a":[{"l":1}],"e":[{"n":36,"s":1}]},62],"t":[{"a":[{".":1}],"e":2,"i":2,"l":[{"y":0}],"r":[{"a":[{"l":18}]}]}],"u":[{"s":4},24]}],"t":[{"a":[{".":18,"b":[{"i":0}],"g":21,"m":120,"n":23,"t":23}],"e":[{"r":[{"a":3,"i":19}],"s":[{"i":[{"m":[{"a":29}]}]},1]},25],"h":[{"i":[{"l":148}]},25],"i":[{"a":18,"c":[{"a":3,"k":31},22],"g":3,"l":[{"l":4}],"m":24,"o":25,"s":[{"m":21},18],"n":[{"e":[{"r":[{"a":[{"r":158}]}]}]}]},29],"o":[{"m":121,"n":18}],"r":[{"a":[{"m":21}],"y":4}],"t":18,"u":[{"a":[{"t":3}],"d":19,"l":3}],"z":[{".":18}]}],"u":29,"v":[{"e":[{"l":[{"l":3}],"n":[{".":3}],"r":[{".":83,"s":[{".":21}]}]}],"i":[{"l":[{".":4}],"o":4,"t":2}],"o":[{"r":[{"e":19,"o":35}],"t":83}]},25],"w":56,"x":[{"o":1}],"y":18,"z":[{"a":[{"r":18}],"i":0,"o":[{"n":[{"t":32}]}]}]}],"j":[{"a":[{"c":[{"q":0}],"p":[{"a":[{"n":[{"e":[{"s":220}]}]}]},1],"n":[{"u":[{"a":12}]}]},32],"e":[{"r":[{"s":5,"e":[{"m":222}]}],"s":[{"t":[{"i":[{"e":18}],"y":18}]}],"w":11},41],"o":[{"p":1}],"u":[{"d":[{"g":32}]}]}],"k":[{"a":[{".":27,"b":23,"g":19,"i":[{"s":17}],"l":0}],"b":29,"e":[{"d":24,"e":41,"g":1,"l":[{"i":[{"n":[{"g":223}]},4]}],"n":[{"d":73}],"r":29,"s":[{"t":[{".":23}]},0],"t":[{"y":1}]}],"f":23,"h":1,"i":[{".":32,"c":122,"l":[{"l":21,"o":6}],"m":21,"n":[{".":21,"d":[{"e":0}],"e":[{"s":[{"s":19}],"t":[{"i":[{"c":224}]}]}],"g":0}],"p":1,"s":[{"h":19},0]},29],"k":1,"l":[{"e":[{"y":18}],"y":18},29],"m":29,"n":[{"e":[{"s":19}],"o":69}],"o":[{"r":4,"s":[{"h":17}],"u":23,"v":[{"i":[{"a":[{"n":41}]}]}]}],"r":[{"o":[{"n":5}]}],"s":[{"c":21,"l":1,"y":21,"h":[{"a":23}]},101],"t":19,"w":29}],"l":[{"a":[{"b":[{"i":[{"c":11}],"o":21}],"c":[{"i":[{"e":225},17]}],"d":[{"e":21,"y":3}],"g":[{"n":0}],"m":[{"o":11}],"n":[{"d":[{"l":0},27],"e":[{"t":5}],"t":[{"e":0}]}],"r":[{"g":0,"i":11,"c":[{"e":[{"n":176}]}]}],"s":[{"e":0}],"t":[{"a":[{"n":4}],"e":[{"l":[{"i":18}]}],"i":[{"v":18}]}],"v":[{"a":95},18],"i":[{"n":[{"e":[{"s":[{"s":226}]}]}]}]}],"b":[{"i":[{"n":17}]},42],"c":[{"e":0,"i":23,"h":[{"a":[{"i":23}],"i":[{"l":[{"d":227}]}]}]},101],"d":[{"e":[{"r":[{"e":1,"i":1}]},24],"i":[{"s":4},0],"r":[{"i":21},23]},25],"e":[{"a":[{"d":[{"e":[{"r":[{".":183}]}]}],"s":[{"a":228}]},9],"b":[{"i":1}],"f":[{"t":6}],"g":[{".":32,"g":32,"e":[{"n":[{"d":[{"r":[{"e":230}]}]}]}]}],"m":[{"a":[{"t":[{"i":[{"c":5}]},1]}]}],"n":[{".":18,"c":27,"e":[{".":32}],"t":41,"o":[{"i":[{"d":78}]}]}],"p":[{"h":3,"r":1}],"r":[{"a":[{"b":6}],"e":0,"g":27,"i":68,"o":21}],"s":[{"c":[{"o":4}],"q":32,"s":[{".":32},27]},8],"v":[{"a":23,"e":[{"r":[{".":0,"a":0,"s":0}]}]}],"y":[{"e":18},27],"c":[{"t":[{"a":[{"b":229}]}]}]}],"f":[{"r":19},25],"g":[{"a":[{"r":12},19],"e":[{"s":21}],"o":11},80],"h":48,"i":[{"a":[{"g":1,"m":9,"r":[{"i":[{"z":6}]}],"s":1,"t":[{"o":1}]}],"b":[{"i":4}],"c":[{"i":[{"o":32}],"o":[{"r":1}],"s":18,"t":[{".":18}],"u":21,"y":23}],"d":[{"a":23,"e":[{"r":5}],"i":27}],"f":[{"e":[{"r":11}],"f":21,"l":1}],"g":[{"a":[{"t":[{"e":32}]}],"h":27,"r":[{"a":1}]}],"k":27,"l":123,"m":[{"b":[{"l":0}],"i":11,"o":1,"p":90}],"n":[{"a":21,"e":[{"a":11},124],"i":11,"k":[{"e":[{"r":6}]}]}],"o":[{"g":4}],"q":125,"s":[{"p":0}],"t":[{".":24,"i":[{"c":[{"a":32,"s":108}]}],"h":[{"o":[{"g":204}]}]},29],"v":[{"e":[{"r":11}]}],"z":29}],"j":18,"k":[{"a":[{"l":23,"t":0},11]}],"l":[{"a":[{"w":21}],"e":[{"a":19,"c":23,"g":23,"l":23,"n":73,"t":73},24],"i":[{"n":[{"a":19},126],"s":[{"h":231}]},9],"o":[{"q":[{"u":[{"i":10}]}],"u":[{"t":4}],"w":19},1],"f":[{"l":2}]},29],"m":[{"e":[{"t":19}],"i":[{"n":[{"g":3}]}],"o":[{"d":21,"n":[{"e":[{"l":[{"l":232}]}]},17]}]},25],"n":81,"o":[{".":27,"b":[{"a":[{"l":5}],"o":[{"t":[{"o":233}]}]}],"c":[{"i":1}],"f":18,"g":[{"i":[{"c":27}],"o":19,"u":27,"e":[{"s":[{".":9}]}]}],"m":[{"e":[{"r":11}]}],"n":[{"g":32,"i":[{"z":127},0]}],"o":[{"d":6}],"p":[{"e":[{".":32}],"i":11,"m":23}],"r":[{"a":[{"t":[{"o":1}]},17],"i":[{"e":4}],"o":[{"u":5}]}],"s":[{".":32,"e":[{"t":5}],"o":[{"p":[{"h":[{"i":[{"z":32}],"y":32}]}]}],"t":0}],"t":[{"a":1}],"u":[{"n":[{"d":6}],"t":25}],"v":18,"a":[{"d":[{"e":[{"d":[{".":17}],"r":[{".":183}]}]}]}]}],"p":[{"a":[{"b":5}],"h":[{"a":23,"i":19}],"i":[{"n":[{"g":4}],"t":23}],"l":21,"r":19},25],"r":43,"s":[{"c":21,"e":24,"i":[{"e":21}]},81],"t":[{"a":[{"g":4,"n":[{"e":7}]}],"e":[{"n":17,"r":[{"a":36}],"a":23},29],"h":[{"i":[{"l":[{"y":148}]},11]}],"i":[{"e":[{"s":[{".":19}]}],"s":17}],"r":29,"u":[{"r":[{"a":12}]},8]},18],"u":[{"a":4,"b":[{"r":3}],"c":[{"h":17,"i":3}],"e":[{"n":3,"p":15}],"f":0,"i":[{"d":4}],"m":[{"a":1,"i":32,"n":[{".":19,"i":[{"a":32}]}],"b":[{"i":[{"a":[{".":235}]}]}]}],"o":[{"r":11},3],"p":18,"s":[{"s":17,"t":[{"e":11}]}],"t":41,"n":[{"k":[{"e":[{"r":234}]}]}]}],"v":[{"e":[{"n":19,"t":128}]}],"w":42,"y":[{"a":18,"b":18,"m":[{"e":4}],"n":[{"o":3}],"s":[{"e":19,"t":[{"y":[{"r":4}]}]},58],"g":[{"a":[{"m":[{"i":236}]}]}]},41]}],"m":[{"a":[{"b":25,"c":[{"a":9,"h":[{"i":[{"n":[{"e":4}]}]}],"l":1}],"g":[{"i":[{"n":5}],"n":32}],"h":25,"i":[{"d":6}],"l":[{"d":18,"i":[{"g":3,"n":4}],"l":[{"i":0}],"t":[{"y":0}],"a":[{"p":222}]}],"n":[{"i":[{"a":32,"s":5,"z":11}],".":24,"u":[{"s":[{"c":237}]}]}],"p":[{"h":[{"r":[{"o":244}]}]},18],"r":[{"i":[{"n":[{"e":[{".":4}]}],"z":4}],"l":[{"y":0}],"v":11,"g":[{"i":[{"n":238}]}]}],"s":[{"c":[{"e":4}],"e":0,"t":15}],"t":[{"e":32,"h":12,"i":[{"s":3,"z":[{"a":18}]}]}]},41],"b":[{"a":[{"t":129}],"i":[{"l":19,"n":[{"g":83}],"v":0}]},43],"c":56,"e":[{".":18,"d":[{".":18,"i":[{"a":32,"e":3,"c":[{"i":[{"n":152}]},84],"o":[{"c":239}]}],"y":108},25],"g":[{"r":[{"a":[{"n":240}]}]},9],"l":[{"o":[{"n":5}],"t":0}],"m":[{"o":130},9],"n":[{"a":[{"c":5},0],"d":[{"e":0}],"e":18,"i":0,"s":[{"u":7},17],"t":[{"e":0},27],".":24},41],"o":[{"n":4}],"r":[{"s":[{"a":19}]}],"s":[{"t":[{"i":27}]},25],"t":[{"a":[{"l":11},1],"e":2,"h":[{"i":4}],"r":[{"i":[{"c":32,"e":4}],"y":3},21]}],"v":1}],"f":43,"h":25,"i":[{".":32,"a":3,"d":[{"a":[{"b":241},0],"g":0}],"g":0,"l":[{"i":[{"a":27,"e":108,"t":[{"a":27}]}],"l":[{"a":[{"g":208}],"i":[{"l":[{"i":59}]}]},21]}],"n":[{"a":0,"d":27,"e":[{"e":19}],"g":[{"l":[{"i":5,"y":19},21]}],"t":0,"u":[{"t":[{"e":[{"r":242,"s":[{"t":242}]}]}]},21],"i":[{"s":[{".":174}]}]}],"o":[{"t":17}],"s":[{"e":[{"r":[{".":0}]}],"l":5,"t":[{"i":0,"r":[{"y":19}]}]},24],"t":[{"h":18}],"z":24}],"k":18,"l":43,"m":[{"a":[{"r":[{"y":5}],"b":243}]},29],"n":[{"a":1,"i":[{"n":21}],"o":1},43],"o":[{"c":[{"r":[{"a":[{"t":[{"i":[{"z":32}]},245]}]},18]}],"d":131,"g":[{"o":1}],"i":[{"s":[{"e":5},84]}],"k":18,"l":[{"e":[{"s":[{"t":4}],"c":246}]}],"m":[{"e":3}],"n":[{"e":[{"t":5,"y":[{"l":247}]}],"g":[{"e":5}],"i":[{"a":12,"s":[{"m":0,"t":0}],"z":3}],"o":[{"l":36,"c":[{"h":12}],"e":[{"n":171}],"s":249}],"y":[{".":3}]}],"r":[{"a":[{".":18}],"o":[{"n":[{"i":[{"s":248}]}]}]},9],"s":[{"e":[{"y":4}],"p":3},8],"t":[{"h":[{"e":[{"t":250}]},12]}],"u":[{"f":19,"s":[{"i":[{"n":98}]},27]}],"v":9,"e":[{"l":[{"a":[{"s":167}]}]}]},41],"p":[{"a":[{"r":[{"a":[{"b":5},7],"i":6}]}],"e":[{"t":23}],"h":[{"a":[{"s":36}]}],"i":[{"a":0,"e":[{"s":4}],"n":34,"r":19,"s":4},24],"o":[{"r":[{"i":11}],"s":[{"i":[{"t":[{"e":6}]}]}],"u":[{"s":21}],"v":6}],"t":[{"r":1}],"y":24},43],"r":47,"s":[{"h":[{"a":[{"c":[{"k":251}]}]},21],"i":19},101],"t":18,"u":[{"l":[{"a":[{"r":49}],"t":[{"i":[{"u":252},54]},32]}],"m":27,"n":8,"p":18,"u":1,"d":[{"r":[{"o":9}]}]},41],"w":18}],"n":[{"a":[{"b":[{"u":21},81],"c":[{".":18,"a":1,"t":19}],"g":[{"e":[{"r":[{".":5}]}]}],"k":0,"l":[{"i":[{"a":4},1],"t":18}],"m":[{"i":[{"t":4}]}],"n":[{"c":[{"i":36}],"i":[{"t":0}],"k":17},24],"r":[{"c":[{"h":[{"s":[{".":73}]}]},11],"e":18,"i":11,"l":0,"m":19}],"s":[{"c":0,"t":[{"i":5}]},21],"t":[{"a":[{"l":3}],"o":[{"m":[{"i":[{"z":6}]}]}]},24],"u":[{"s":[{"e":11}],"t":27},24],"v":[{"e":0}]},41],"b":80,"c":[{"a":[{"r":6}],"e":[{"s":[{".":21}]}],"h":[{"a":23,"e":[{"o":19,"s":[{"t":253}]}],"i":[{"l":19,"s":23}]}],"i":[{"n":2,"t":1}],"o":[{"u":[{"r":[{"a":7}]}]}],"r":29,"u":29}],"d":[{"a":[{"i":21,"n":19}],"e":[{"s":[{"t":[{".":4}]}]},29],"i":[{"b":0,"f":79,"t":29,"z":23,"e":[{"c":[{"k":29}]}]}],"u":[{"c":19,"r":0}],"w":[{"e":9}],"t":[{"h":[{"r":3}]}]}],"e":[{".":25,"a":[{"r":23}],"b":[{"u":11,"a":[{"c":[{"k":3}]}]},9],"c":[{"k":32},9],"d":25,"g":[{"a":[{"t":[{"i":[{"v":5}]},1]}],"e":32}],"l":[{"a":1,"i":[{"z":5}]}],"m":[{"i":4,"o":1}],"n":[{"e":18},41],"o":27,"p":[{"o":1}],"q":9,"r":[{"a":[{"b":6,"r":21}],"e":24,"i":132,"r":0},29],"s":[{".":25,"p":18,"t":25,"w":18,"k":[{"i":119}]},41],"t":[{"i":[{"c":27}]}],"v":[{"e":19},1],"w":1}],"f":[{"i":[{"n":[{"i":[{"t":[{"e":[{"s":226}]}]}]}]}]},23],"g":[{"a":[{"b":21}],"e":[{"l":23,"n":[{"e":[{"s":5},133]}],"r":[{"e":19,"i":23}]}],"h":[{"a":4,"o":2}],"i":[{"b":23,"n":2,"t":19}],"l":[{"a":21}],"o":[{"v":17}],"s":[{"h":4,"p":[{"r":2}]}],"u":[{"m":21},29],"y":24}],"h":[{"a":[{"b":12},0],"e":0},80],"i":[{"a":[{"n":[{".":114},3],"p":1},68],"b":[{"a":3,"l":1}],"d":[{"i":4},1],"e":[{"r":1}],"f":[{"i":[{"c":[{"a":[{"t":4}]}]},9]}],"g":[{"r":19}],"k":0,"m":[{"i":[{"z":3}]},29],"n":[{"e":[{".":32}],"g":0},29],"o":1,"s":[{".":32,"t":[{"a":0}]}],"t":[{"h":21,"i":[{"o":27}],"o":[{"r":23}],"r":3},24]}],"j":29,"k":[{"e":[{"r":[{"o":19}],"t":23}],"i":[{"n":3}],"l":29,"r":[{"u":[{"p":3}]}]},44],"l":[{"e":[{"s":[{"s":19}]}]},43],"m":[{"e":[{"t":17},0]},19],"n":[{"e":0,"i":[{"a":[{"l":11}],"v":0}]},101],"o":[{"b":[{"l":[{"e":3},0]}],"c":[{"l":19,"e":[{"r":[{"o":[{"s":254}]}]}]}],"d":66,"e":27,"g":[{"e":17},18],"i":[{"s":[{"i":6}]}],"l":[{"i":134,"o":[{"g":[{"i":[{"s":32}]}]}]}],"m":[{"i":[{"c":27,"z":108,"s":[{"t":82}]}],"o":1,"y":3,"a":[{"l":214}],"e":[{"n":[{"o":194}]}]}],"n":[{"a":[{"g":0}],"i":[{"z":19,"s":[{"o":255}]},5],"e":[{"q":15}]},1],"p":[{"o":[{"l":[{"i":135,"y":[{".":256}]}]}]},18],"r":[{"a":[{"b":5,"r":[{"y":1}]}]}],"s":[{"c":18,"e":0,"t":5}],"t":[{"a":4}],"u":[{"n":27},41],"v":[{"e":[{"l":136,"m":[{"b":2}]}]}],"w":[{"l":12}]}],"p":[{"i":0,"r":[{"e":[{"c":17}]}]},72],"q":29,"r":[{"u":0},29],"s":[{"a":[{"b":4,"t":[{"i":36}]}],"c":[{"e":[{"i":[{"v":4}]}]},1],"e":[{"s":83},24],"i":[{"d":137,"g":17}],"l":24,"m":[{"o":[{"o":1}]},3],"o":[{"c":21}],"p":[{"e":1,"i":19}],"t":[{"a":[{"b":[{"l":6}]}]}]},81],"t":[{"a":[{"b":0}],"e":[{"r":[{"s":12}]}],"i":[{"b":19,"e":[{"r":0}],"f":8,"n":[{"e":23,"g":83}],"p":0},9],"r":[{"o":[{"l":[{"l":[{"i":7}]}]}],"e":[{"p":137}]}],"s":1,"u":[{"m":[{"e":11}]}]},29],"u":[{"a":2,"d":1,"e":[{"n":4}],"f":[{"f":[{"e":0}]}],"i":[{"n":23,"t":50}],"m":[{"e":2,"i":19},21],"n":138,"o":23,"t":[{"r":3}]}],"v":74,"w":72,"y":[{"m":0,"p":0}],"z":[{"a":23},18]}],"o":[{"a":[{"d":11,"l":[{"e":[{"s":108}]}],"r":[{"d":12}],"s":[{"e":0,"t":[{"e":6}]}],"t":[{"i":5}]},18],"b":[{"a":[{"b":35,"r":19}],"e":[{"l":0}],"i":[{"n":[{"g":4},24]},29],"r":23,"u":[{"l":3}],"l":[{"i":[{"g":189}]}]}],"c":[{"e":29,"h":[{"e":[{"t":23}],"a":[{"s":23}]},0],"i":[{"f":12,"l":21}],"l":[{"a":[{"m":21}]}],"o":[{"d":21}],"r":[{"a":[{"c":3,"t":[{"i":[{"z":4}]}]}],"e":12,"i":[{"t":32}]}],"t":[{"o":[{"r":[{"a":7}]}]}],"u":[{"l":[{"a":3}],"r":[{"e":19}]}]}],"d":[{"d":[{"e":[{"d":4}]}],"i":[{"c":3,"o":11,"t":[{"i":[{"c":137}]}]}],"o":[{"r":12},139],"u":[{"c":[{"t":[{".":4,"s":4}]}]}],"e":[{"l":[{"l":[{"i":12}]}]}]}],"e":[{"l":21,"n":[{"g":19}],"r":[{"s":[{"t":257}]},23],"t":[{"a":1}],"v":23}],"f":[{"i":[{"t":[{"e":4,"t":17}]},24]}],"g":[{"a":[{"r":121,"t":[{"i":[{"v":4}],"o":21}]}],"e":[{"n":[{"e":19}],"o":19,"r":21},29],"i":[{"e":23,"s":140,"t":3}],"l":[{"y":79},21],"n":[{"i":[{"z":27}]}],"r":[{"o":21}],"u":[{"i":5}],"y":[{"n":25},41]}],"h":[{"a":[{"b":6}]},74],"i":[{"c":[{"e":[{"s":11}]}],"d":[{"e":[{"r":3}]}],"f":[{"f":17}],"g":0,"l":[{"e":[{"t":4}]}],"n":[{"g":23,"t":[{"e":[{"r":6}]}]}],"s":[{"m":19,"o":[{"n":4}],"t":[{"e":[{"n":6}]}]}],"t":[{"e":[{"r":3}]}]},9],"j":19,"k":[{"e":[{"n":23,"s":[{"t":15}]}],"i":[{"e":4}]},25],"l":[{"a":[{"n":21,"s":[{"s":36}]},29],"d":[{"e":15},9],"e":[{"r":3,"s":[{"c":23,"t":[{"e":[{"r":88}]}]}],"t":23}],"f":[{"i":1}],"i":[{"a":23,"c":[{"e":23}],"d":[{".":4}],"f":73,"l":19,"n":[{"g":3}],"o":19,"s":[{".":19,"h":3}],"t":[{"e":19,"i":[{"o":19}]}],"v":19,"g":[{"o":[{"p":[{"o":258}]}]}]},9],"l":[{"i":[{"e":17}]}],"o":[{"g":[{"i":[{"z":4}]}],"r":0,"n":[{"o":[{"m":259}]}]}],"p":[{"l":4}],"t":9,"u":[{"b":3,"m":[{"e":3}],"n":3,"s":19}],"v":9,"y":24}],"m":[{"a":[{"h":4,"l":5,"t":[{"i":[{"z":4}]}]}],"b":[{"e":9,"l":1}],"e":[{"n":[{"a":3}],"r":[{"s":[{"e":4}]}],"t":[{"r":[{"y":4}]},21],"c":[{"h":[{"a":260}]}]},24],"i":[{"a":23,"c":[{".":3,"a":3}],"d":19,"n":[{"i":19},2]}],"m":[{"e":[{"n":[{"d":32}]}]}],"o":[{"g":[{"e":0}],"n":21}],"p":[{"i":3,"r":[{"o":7}]}]}],"n":[{"a":[{"c":1,"n":23},2],"c":[{"i":[{"l":27}]},2],"d":[{"o":4},25],"e":[{"n":23,"s":[{"t":4}]}],"g":[{"u":1}],"i":[{"c":2,"o":23,"s":2,"u":19}],"k":[{"e":[{"y":3}]}],"o":[{"d":[{"i":1}],"m":[{"y":3,"i":[{"c":137}]}],"r":[{"m":[{"a":23}]}],"t":[{"o":[{"n":261}]}],"u":23}],"s":[{"p":[{"i":[{"r":[{"a":10}]},36]}],"u":17},3],"t":[{"e":[{"n":36}],"i":[{"f":7},93]}],"u":[{"m":4}],"v":[{"a":6}]},24],"o":[{"d":[{"e":5,"i":5}],"k":1,"p":[{"i":11}],"r":[{"d":23}],"s":[{"t":6}]},9],"p":[{"a":24,"e":[{"d":5,"r":[{"a":[{"g":18},27]},2]}],"h":[{"a":[{"n":19}],"e":[{"r":19}]},25],"i":[{"n":[{"g":3}],"t":23,"s":[{"m":[{".":2}]}]}],"o":[{"n":19,"s":[{"i":21}]}],"r":29,"u":2,"y":5}],"q":29,"r":[{"a":[{".":19,"g":83,"l":[{"i":[{"z":4}]}],"n":[{"g":[{"e":4}]}]},29],"e":[{"a":[{"l":19},5],"i":3,"s":[{"h":5,"t":[{".":4}]}],"w":17}],"g":[{"u":1}],"i":[{"a":56,"c":[{"a":3}],"l":19,"n":2,"o":29,"t":[{"y":3}],"u":23}],"m":[{"i":9}],"n":[{"e":8}],"o":[{"f":19,"u":[{"g":3}]}],"p":[{"e":4}],"r":[{"h":27}],"s":[{"e":[{"n":5},1],"t":17}],"t":[{"h":[{"i":3,"y":3,"o":[{"n":[{"i":[{"t":262}]}]}],"r":[{"i":137}]}],"y":1,"i":[{"v":[{"e":[{"l":[{"y":4}]}]}]}]}],"u":[{"m":19}],"y":29}],"s":[{"a":[{"l":3}],"c":[{"e":1,"o":[{"p":[{"i":18},23]}],"r":19},9],"i":[{"e":95,"t":[{"i":[{"v":4}],"o":3,"y":3}],"u":0}],"l":1,"o":24,"p":[{"a":1,"o":1,"h":[{"e":[{"r":83}]}]}],"t":[{"a":[{"t":[{"i":19}]},9],"i":[{"l":4,"t":4}]}]}],"t":[{"a":[{"n":21}],"e":[{"l":[{"e":[{"g":36}]}],"r":[{".":3,"s":4}],"s":[{"t":[{"e":[{"r":263}],"o":[{"r":264}]}]},21]}],"h":[{"e":[{"s":[{"i":5}],"o":[{"s":265}]}],"i":14},18],"i":[{"c":[{".":3,"a":4,"e":23}],"f":23,"s":23}],"o":[{"s":5}]}],"u":[{"b":[{"l":3,"a":[{"d":[{"o":116}]}]}],"c":[{"h":[{"i":6}]}],"e":[{"t":4}],"l":1,"n":[{"c":[{"e":[{"r":6}]}],"d":8}],"v":4},9],"v":[{"e":[{"n":1,"r":[{"n":[{"e":17}],"s":12,"t":1}]}],"i":[{"s":23,"t":[{"i":36}],"a":[{"n":[{".":266}]}]}],"o":[{"l":60}]}],"w":[{"d":[{"e":[{"r":3}]}],"e":[{"l":3,"s":[{"t":4}]}],"i":2,"n":[{"i":5}],"o":21}],"y":[{"a":2}],"x":[{"i":[{"d":[{"i":[{"c":267}]}]}]}]}],"p":[{"a":[{"c":[{"a":1,"e":1,"t":0}],"d":21,"g":[{"a":[{"n":32,"t":23}]}],"i":[{"n":17},21],"l":[{"m":[{"a":[{"t":268}]}]},21],"n":[{"a":0,"e":[{"l":11}],"t":[{"y":0}],"y":3}],"p":[{"u":1},2],"r":[{"a":[{"b":[{"l":6}],"g":[{"e":5,"r":[{"a":269}]}],"l":[{"e":228}],"m":[{"e":12},36]}],"d":[{"i":5}],"e":[{"l":5},27],"i":[{"s":0},28]}],"t":[{"e":[{"r":4},9],"h":[{"i":[{"c":32}],"y":4}],"r":[{"i":[{"c":1}]}]}],"v":0,"y":27},41],"b":43,"d":1,"e":[{".":18,"a":[{"r":[{"l":17}]},138],"c":9,"d":[{"e":27,"i":[{"a":36,"c":0},27]},37],"e":[{"d":0,"v":208},21],"k":0,"l":[{"a":1,"i":[{"e":17}]}],"n":[{"a":[{"n":1}],"c":21,"t":[{"h":0}]}],"o":[{"n":4}],"r":[{"a":[{".":21,"b":[{"l":6}],"g":21}],"i":[{"s":[{"t":6}]},21],"m":[{"a":[{"l":0}],"e":7}],"n":21,"o":11,"t":[{"i":11}],"u":4,"v":15}],"t":[{"e":[{"n":4}],"i":[{"z":4}]},9]}],"f":18,"g":18,"h":[{".":18,"a":[{"r":[{"i":6}]}],"e":[{"n":[{"o":11}],"r":1,"s":[{".":1}]}],"i":[{"c":2,"e":32,"n":[{"g":4}],"s":[{"t":[{"i":32}]}],"z":27,"l":[{"a":[{"n":[{"t":168}],"t":[{"e":[{"l":270}]}]}]}]}],"l":9,"o":[{"b":27,"n":[{"e":27,"i":32}],"r":0}],"s":18,"t":3,"u":32,"y":41}],"i":[{"a":[{"n":17},3],"c":[{"i":[{"e":1}],"y":1,"a":[{"d":271}]}],"d":[{"a":19,"e":3,"i":32},21],"e":[{"c":27,"n":3}],"g":[{"r":[{"a":[{"p":1}]}]}],"l":[{"o":3}],"n":[{".":21,"d":17,"o":21},9],"o":[{"n":17},141],"t":[{"h":[{"a":4},23],"u":9}]}],"k":142,"l":[{"a":[{"n":27,"s":[{"t":6}]}],"i":[{"a":11,"e":[{"r":5}],"g":18,"n":[{"a":[{"r":5}]},0],"c":[{"a":[{"b":208}]}]}],"o":[{"i":17}],"u":[{"m":[{"b":17},0]}]},143],"m":43,"n":48,"o":[{"c":1,"d":[{".":32}],"e":[{"m":4,"t":144}],"g":145,"i":[{"n":[{"t":32,"c":[{"a":12}]},84]}],"l":[{"y":[{"t":6,"e":137,"p":[{"h":[{"o":[{"n":[{"o":272}]}]}]}]}],"e":[{".":41}]}],"n":[{"i":1}],"p":1,"r":[{"y":1},124],"s":[{"s":15},41],"t":[{"a":1},21],"u":[{"n":32}]}],"p":[{"a":[{"r":[{"a":5}]}],"e":[{"d":21,"l":19,"n":23,"r":23,"t":23},24],"o":[{"s":[{"i":[{"t":[{"e":5}]}]}]}]},43],"r":[{"a":[{"y":[{"e":17}]}],"e":[{"c":[{"i":32,"o":5}],"e":[{"m":11}],"f":[{"a":[{"c":6}]}],"l":[{"a":0}],"r":11,"s":[{"e":23,"s":27,"p":[{"l":[{"i":84}]}]}],"t":[{"e":[{"n":5}]}],"v":11,"m":[{"a":[{"c":273}]}],"n":[{"e":[{"u":15}]}]}],"i":[{"e":53,"n":[{"t":146}],"s":[{"o":12},0]}],"o":[{"c":[{"a":23,"e":[{"s":[{"s":8}]}],"i":[{"t":[{"y":[{".":274}]}]}]}],"f":[{"i":[{"t":6}]}],"l":11,"s":[{"e":12}],"t":15,"g":[{"e":208}]}]},9],"s":[{"e":[{"u":[{"d":[{"o":[{"d":276,"f":276}]},275]}]},24],"h":1,"i":[{"b":21}]},81],"t":[{"a":[{"b":134}],"e":24,"h":24,"i":[{"m":11}],"u":[{"r":0}],"w":21,"o":[{"m":[{"a":[{"t":277}]}]}],"r":[{"o":[{"l":278}]}]},42],"u":[{"b":[{"e":[{"s":[{"c":181}]}]},11],"e":0,"f":0,"l":[{"c":11}],"m":1,"n":9,"r":[{"r":0}],"s":32,"t":[{"e":[{"r":11},32],"r":3,"t":[{"e":[{"d":0}],"i":[{"n":0}]}]},9]}],"w":23}],"q":[{"u":[{"a":[{"v":5,"i":[{"n":[{"t":[{"e":279}]}]}],"s":[{"i":[{"r":281,"s":281},280]}]}],"e":[{".":25,"r":27,"t":27}],"i":[{"n":[{"t":[{"e":[{"s":[{"s":282}]}]}]}],"v":[{"a":[{"r":14}]}]}]},9]}],"r":[{"a":[{"b":[{"i":3,"o":[{"l":[{"i":[{"c":29}],"o":[{"i":236}]}]}]},25],"c":[{"h":[{"e":17,"u":3}],"l":19}],"f":[{"f":[{"i":5}],"t":0}],"i":24,"l":[{"o":1}],"m":[{"e":[{"t":[{"r":[{"i":[{"z":283}]}]},11],"n":24}],"i":24,"o":[{"u":3}]}],"n":[{"e":[{"o":6}],"g":[{"e":0}],"i":21,"o":4,"h":[{"a":[{"s":167}]}]}],"p":[{"e":[{"r":11}],"h":[{"y":27}]}],"r":[{"c":5,"e":[{"f":5},17],"i":[{"l":18}]}],"s":24,"t":[{"i":[{"o":[{"n":115}]}]}],"u":[{"t":0}],"v":[{"a":[{"i":4}],"e":[{"l":11}]}],"z":[{"i":[{"e":4}]}],"d":[{"i":[{"g":127,"o":[{"g":249}]}]}],"o":[{"r":2}]}],"b":[{"a":[{"b":21,"g":21}],"i":[{"f":0,"n":[{"e":19,"g":[{".":4,"e":284}]},24]},8],"o":1},29],"c":[{"e":[{"n":17},24],"h":[{"a":23,"e":[{"r":0}]}],"i":[{"b":90,"t":1}],"u":[{"m":12}]},29],"d":[{"a":[{"l":21}],"i":[{"a":0,"e":[{"r":0}],"n":[{"g":3},17]},9]}],"e":[{".":25,"a":[{"l":2,"n":3,"r":[{"r":4}],"v":32,"w":1}],"b":[{"r":[{"a":[{"t":19}]}]}],"c":[{"o":[{"l":[{"l":5}],"m":[{"p":[{"e":5}]}]}],"r":[{"e":1}],"i":[{"p":[{"r":285}]}],"t":[{"a":[{"n":[{"g":286}]}]}]}],"d":[{"e":2,"i":[{"s":3,"t":5}]},37],"f":[{"a":[{"c":1}],"e":[{"r":[{".":4}]},9],"i":3,"y":1}],"g":[{"i":[{"s":11}]}],"i":[{"t":4}],"l":[{"i":2,"u":4}],"n":[{"t":[{"a":90,"e":0}]}],"o":2,"p":[{"i":[{"n":4}],"o":[{"s":[{"i":1}]}],"u":2}],"r":[{"i":21,"o":17,"u":4},147],"s":[{".":21,"p":[{"i":1}],"s":[{"i":[{"b":6}]}],"t":[{"a":[{"l":4}],"r":3},8]}],"t":[{"e":[{"r":1}],"i":[{"z":96}],"r":[{"i":[{"b":[{"u":85}]},3]}]}],"u":[{"t":[{"i":4}]},8],"v":[{"a":[{"l":1}],"e":[{"l":11,"r":[{".":30,"s":4,"t":4}]}],"i":[{"l":4}],"o":[{"l":[{"u":5}]}]},8],"w":[{"h":1}]}],"f":[{"u":0,"y":21},29],"g":[{"e":[{"r":3,"t":23}],"i":[{"c":23,"n":[{"g":3},0],"s":19,"t":19}],"l":29,"o":[{"n":0}],"u":23},9],"h":[{".":18,"a":[{"l":18}]},1],"i":[{"a":[{"b":0,"g":1,"l":[{".":23}]},3],"b":[{"a":11},21],"c":[{"a":[{"s":5}],"e":21,"i":[{"d":32,"e":1},18],"o":21}],"d":[{"e":[{"r":5}]}],"e":[{"n":[{"c":3,"t":3}],"r":2,"t":4}],"g":[{"a":[{"n":5}],"i":32}],"l":[{"i":[{"z":11}]}],"m":[{"a":[{"n":32}],"i":5,"o":27,"p":[{"e":0}]}],"n":[{"a":[{".":32},24],"d":0,"e":0,"g":0}],"o":2,"p":[{"h":[{"e":6},32],"l":[{"i":[{"c":5}]},9]}],"q":21,"s":[{".":21,"c":0,"h":23,"p":0},24],"t":[{"a":[{"b":116}],"e":[{"d":[{".":19}],"r":[{".":5,"s":5}]}],"i":[{"c":11}],"u":[{"r":5},9]}],"v":[{"e":[{"l":5,"t":11}],"i":11,"o":[{"l":287}]}]}],"j":23,"k":[{"e":[{"t":23}],"l":[{"e":1,"i":[{"n":1}]}],".":288,"h":[{"o":2}],"r":[{"a":[{"u":29}]}],"s":[{".":288}]}],"l":[{"e":[{"d":24,"q":[{"u":30}]},0],"i":[{"g":21,"s":[{"h":4},21]}],"o":73},29],"m":[{"a":[{"c":5}],"e":[{"n":23,"r":[{"s":4}]},24],"i":[{"n":[{"g":[{".":21},3]}],"o":21,"t":23}],"y":21},29],"n":[{"a":[{"r":21}],"e":[{"l":23,"r":21,"t":19,"y":23}],"i":[{"c":19,"s":92,"t":23,"v":23}],"o":[{"u":21},0],"u":23}],"o":[{"b":[{"l":11,"o":[{"t":289}]}],"c":[{"r":3},24],"e":[{"l":[{"a":[{"s":167}]}],"p":[{"i":[{"d":[{"e":290}]}]}]},1],"f":[{"e":2,"i":[{"l":4}]}],"k":[{"e":[{"r":4}]},8],"l":[{"e":[{".":32}]}],"m":[{"e":[{"t":[{"e":5}],"s":[{"h":3}]}],"i":0,"p":0}],"n":[{"a":[{"l":0}],"e":0,"i":[{"s":134}],"t":[{"a":0}]}],"o":[{"m":41,"t":32}],"p":[{"e":[{"l":3}],"i":[{"c":11}]}],"r":[{"i":11,"o":4}],"s":[{"p":[{"e":[{"r":5}]}],"s":0}],"t":[{"h":[{"e":1}],"y":1,"r":[{"o":[{"n":2}]}]}],"v":[{"a":1,"e":[{"l":5}]}],"x":5}],"p":[{"e":[{"a":21,"n":[{"t":19}],"r":[{".":4}],"t":23}],"h":95,"i":[{"n":[{"g":3}]}],"o":23,"a":[{"u":[{"l":[{"i":291}]}]}]},29],"r":[{"e":[{"c":0,"f":0,"o":21,"s":[{"t":0}]}],"i":[{"o":0,"v":0}],"o":[{"n":17,"s":17}],"y":[{"s":17}]},72],"s":[{"a":[{"t":[{"i":5}]},29],"c":1,"e":[{"c":[{"r":0},23],"r":[{".":4,"a":[{"d":[{"i":238}]}]}],"s":3,"v":148},24],"h":[{"a":19},29],"i":[{"b":90},29],"o":[{"n":12}],"p":29,"w":19},44],"t":[{"a":[{"c":[{"h":36}],"g":21}],"e":[{"b":23,"n":[{"d":17}],"o":5}],"i":[{"b":4,"d":0,"e":[{"r":21}],"g":23,"l":[{"i":12,"l":17,"y":21}],"s":[{"t":21}],"v":21},29],"r":[{"i":23,"o":[{"p":[{"h":115}]}],"e":[{"u":29}]}],"s":[{"h":1}],"h":[{"o":[{"u":29}]}]}],"u":[{"a":3,"e":[{"l":93,"n":3}],"g":[{"l":1}],"i":[{"n":3}],"m":[{"p":[{"l":11}]}],"n":[{"k":6,"t":[{"y":0}]},9],"s":[{"c":19}],"t":[{"i":[{"n":6}]}]}],"v":[{"e":[{"l":[{"i":17}],"n":23,"r":[{".":4}],"s":[{"t":19}],"y":23,"i":[{"l":29}]},1],"i":[{"c":23,"v":0}],"o":23}],"w":29,"y":[{"c":1,"n":[{"g":[{"e":32}]}],"t":3}],"z":[{"s":[{"c":2}]}]}],"s":[{"a":[{"b":42,"c":[{"k":32,"r":[{"i":11}],"t":23}],"i":32,"l":[{"a":[{"r":36}],"m":0,"o":4,"t":0,"e":[{"s":[{"c":54,"w":7}]}]}],"n":[{"c":27,"d":[{"e":0}]}],"p":[{"a":[{"r":[{"i":[{"l":292}]}]}]},29],"t":[{"a":4,"i":[{"o":76}],"u":11}],"u":0,"v":[{"o":[{"r":4}]}],"w":32},9],"b":56,"c":[{"a":[{"n":[{"t":149}],"p":[{"e":[{"r":267}]},0],"v":6,"t":[{"o":[{"l":208}]}]}],"e":[{"d":21,"i":18,"s":21}],"h":[{"o":21,"i":[{"t":[{"z":21}]}],"r":[{"o":[{"d":[{"i":[{"n":[{"g":293}]}]}]}]}]},8],"i":[{"e":68,"n":[{"d":150}],"u":[{"t":[{"t":294}]}]}],"l":[{"e":6,"i":21}],"o":[{"f":17,"p":[{"y":18}],"u":[{"r":[{"a":7}]}]}],"u":29,"r":[{"a":[{"p":[{"e":[{"r":[{".":36}]}]}]}]}],"y":[{"t":[{"h":247}]}]}],"d":56,"e":[{".":18,"a":[{"s":17,"w":5},1],"c":[{"o":151,"t":27}],"d":[{"e":95,"l":19},125],"g":[{"r":11},9],"i":32,"l":[{"e":2,"f":32,"v":32}],"m":[{"e":[{"s":[{"t":295}]},18],"o":[{"l":1}],"a":[{"p":[{"h":287}]}],"i":[{"t":[{"i":[{"c":296}]}]}]}],"n":[{"a":[{"t":5}],"c":18,"d":0,"e":[{"d":19}],"g":5,"i":[{"n":19}],"t":[{"d":18,"l":18}]}],"p":[{"a":152,"t":[{"e":[{"m":[{"b":11}]}]}]}],"r":[{".":43,"l":21,"o":0,"v":[{"o":18}]}],"s":[{"h":4,"t":5},72],"u":[{"m":113}],"v":[{"e":[{"n":11}]},32],"w":[{"i":0}],"x":32}],"f":47,"g":48,"h":[{".":25,"e":[{"r":2,"v":32}],"i":[{"n":2,"o":3,"p":27,"v":6}],"o":[{"l":[{"d":4}],"n":12,"r":[{"t":7},17],"e":[{"s":[{"t":137}]}]},0],"w":18},24],"i":[{"b":2,"c":[{"c":19}],"d":[{"e":[{".":27,"s":[{"t":6,"w":6},32],"d":[{".":8}]}],"i":[{"z":4},32]}],"g":[{"n":[{"a":18}]}],"l":[{"e":0,"y":18}],"n":[{"a":24,"e":[{".":32}],"g":23},42],"o":[{"n":[{"a":6},32]},41],"r":[{"a":5,"e":[{"s":[{"i":[{"d":4}]}]}]},9],"s":41,"t":[{"i":[{"o":27}]}],"u":32,"v":41,"z":32}],"k":[{"e":[{"t":23},18],"i":[{"n":[{"e":4,"g":4}]}],"y":[{"s":[{"c":15}]}]},9],"l":[{"a":[{"t":23}],"e":24,"i":[{"t":[{"h":7}]}],"o":[{"v":[{"a":[{"k":[{"i":[{"a":297}]}]}]}]}]},74],"m":[{"a":[{"l":[{"l":54}],"n":12},23],"e":[{"l":17,"n":19}],"i":[{"t":[{"h":32}]}],"o":[{"l":[{"d":49}]}]},42],"n":72,"o":[{"c":[{"e":1}],"f":[{"t":12}],"l":[{"a":[{"b":1}],"d":153,"i":[{"c":3}],"v":32,"u":[{"t":[{"e":9}]}]}],"m":27,"n":[{".":68,"a":17,"g":0}],"p":[{"h":[{"i":[{"c":32,"z":19}],"y":19}]},21],"r":[{"c":5,"d":5}],"v":[{"i":4},18],"g":[{"a":[{"m":[{"y":298}]}]}]},41],"p":[{"a":[{"i":32,"n":0,"c":[{"e":299,"i":[{"n":69}]}]},25],"e":[{"n":[{"d":17}],"o":57,"r":25,"c":[{"i":[{"o":11}]}]}],"h":[{"e":[{"r":[{"o":213},27]},24],"o":6}],"i":[{"l":17,"n":[{"g":4}],"o":18,"c":[{"i":[{"l":208}]}]}],"l":[{"y":21}],"o":[{"n":21,"r":[{"t":[{"s":[{"c":300,"w":300}]}]},17],"t":18,"k":[{"e":[{"s":[{"w":10}]}]}]}]}],"q":[{"u":[{"a":[{"l":[{"l":36}]}],"i":[{"t":[{"o":88}]}]}]}],"r":29,"s":[{"a":[{"s":12,"c":[{"h":[{"u":301}]}]},29],"c":94,"e":[{"l":23,"n":[{"g":19}],"s":[{".":21}],"t":19}],"i":[{"e":[{"r":0},21],"l":[{"y":4}],"a":[{"n":[{".":210}]}],"g":[{"n":[{"a":[{"b":302}]}]}]},29],"l":[{"i":1},21],"n":21,"p":[{"e":[{"n":[{"d":115}]}]}],"t":9,"u":[{"r":[{"a":6}]}],"w":4,"h":[{"a":[{"t":3}]}]},25],"t":[{".":25,"a":[{"g":24,"l":24,"m":[{"i":17,"p":69}],"n":[{"d":32,"t":[{"s":[{"h":[{"i":303}]}]}]}],"p":90,"t":[{".":32,"i":15}],"r":[{"t":[{"l":[{"i":12}]}]}]}],"e":[{"d":21,"r":[{"n":[{"i":7}],"o":19}],"w":[{"a":6},8]}],"h":[{"e":23}],"i":[{".":21,"a":19,"c":[{"k":32},29],"e":21,"f":23,"n":[{"g":3}],"r":32},9],"l":[{"e":29}],"o":[{"c":[{"k":32}],"m":[{"a":12}],"n":[{"e":32}],"p":21,"r":[{"e":27,"a":[{"b":304}]}]}],"r":[{"a":[{"d":21,"t":[{"u":32,"a":[{"g":305}]}],"y":21}],"i":[{"d":21,"b":[{"u":[{"t":7}]}]}],"y":18},1],"w":61,"y":[{"l":[{"i":[{"s":137}]}]},24],"b":4,"s":[{"c":[{"r":4}]}],"u":[{"p":[{"i":[{"d":306}]}]}]}],"u":[{"a":[{"l":2}],"b":111,"g":151,"i":[{"s":4,"t":12}],"l":21,"m":[{"i":11},9],"n":9,"r":9,"p":[{"e":[{"r":[{"e":307}]}]}]},41],"v":18,"w":[{"o":18,"i":[{"m":[{"m":177}]}]},9],"y":[{"c":18,"l":27,"n":[{"o":5,"c":41}],"r":[{"i":[{"n":4}]}],"t":[{"h":[{"i":308}]}]},21]}],"t":[{"a":[{".":27,"b":[{"l":[{"e":[{"s":4}]}],"o":[{"l":[{"i":[{"z":32,"s":[{"m":309}]}]}]}]},25],"c":[{"i":18}],"d":[{"o":4}],"f":46,"i":[{"l":[{"o":5}]}],"l":[{"a":4,"e":[{"n":5}],"i":11,"k":[{"a":204},18],"l":[{"i":[{"s":0}]}],"o":[{"g":4}]},9],"m":[{"o":4,"i":[{"n":82}]}],"n":[{"d":[{"e":0}],"t":[{"a":54}]}],"p":[{"e":[{"r":4}],"l":4,"a":[{"t":[{"h":310}]}]}],"r":[{"a":0,"c":18,"e":18,"i":[{"z":3}],"r":[{"h":311}]}],"s":[{"e":0,"y":4}],"t":[{"i":[{"c":18}],"u":[{"r":1}]}],"u":[{"n":17}],"v":0,"w":25,"x":[{"i":[{"s":0}]}],"g":[{"o":[{"n":[{".":3}]}]}]},41],"b":42,"c":[{"h":[{"e":[{"t":5}],"c":15,"i":[{"e":[{"r":237}]}]},21],"r":29},18],"d":43,"e":[{".":18,"a":[{"d":[{"i":17}],"t":18,"c":[{"h":[{"e":[{"r":[{".":36}]}]}]}]}],"c":[{"e":17,"t":32}],"d":[{"i":4},42],"e":41,"g":[{"e":[{"r":4}],"i":4},0],"l":[{".":27,"i":17,"s":32,"e":[{"g":84,"r":[{"o":249}]}]}],"m":[{"a":[{"t":11},154]}],"n":[{"a":[{"n":27}],"c":27,"d":27,"e":[{"s":18}],"t":[{"a":[{"g":0}]},41]}],"o":41,"p":[{"e":4},1],"r":[{"c":11,"d":155,"i":[{"e":[{"s":5}],"s":11,"z":[{"a":6}],"c":[{".":8}]},41],"n":[{"i":[{"t":32}]}],"v":5,"g":[{"e":[{"i":312}]}]}],"s":[{".":18,"s":[{".":23,"e":[{"s":313}]},18]}],"t":[{"h":[{"e":6}]}],"u":27,"x":27,"y":18}],"f":42,"g":43,"h":[{".":25,"a":[{"n":17,"l":[{"a":[{"m":228}]}]}],"e":[{"a":[{"s":3,"t":5},18],"i":[{"s":11}],"t":27},9],"i":[{"c":[{".":4,"a":4}],"l":18,"n":[{"k":32}]}],"l":18,"o":[{"d":[{"e":4,"i":[{"c":32}],"o":[{"n":11}]}],"o":18,"r":[{"i":[{"t":6,"z":5}]}],"g":[{"e":[{"n":[{"i":314}]}]}],"k":[{"e":[{"r":175}]}]}],"s":25,"y":[{"l":[{"a":[{"n":228}]}],"s":[{"c":11}]}]}],"i":[{"a":[{"b":1,"t":[{"o":1}],"n":[{".":70}]},41],"b":156,"c":[{"k":18,"o":21,"u":157}],"d":[{"i":32}],"e":[{"n":27}],"f":[{"y":4},8],"g":[{"u":32},25],"l":[{"l":[{"i":[{"n":6}]}]}],"m":[{"p":18,"u":[{"l":5}]},41],"n":[{"a":24,"e":[{".":27}],"i":27,"o":[{"m":285}]},42],"o":[{"c":4,"n":[{"e":[{"e":6}]}]},41],"q":32,"s":[{"a":3,"e":27,"m":0,"o":4,"p":0,"t":[{"i":[{"c":[{"a":32}]}]}]}],"t":[{"l":3}],"u":1,"v":[{"a":0},41],"z":[{"a":3,"e":[{"n":3}]},41]}],"l":[{"a":[{"n":17},19],"e":[{".":27,"d":27,"s":[{".":27}],"t":[{".":19}]}],"o":19,"i":[{"e":[{"r":315}]}]},25],"m":[{"e":0},43],"n":81,"o":[{"b":3,"c":[{"r":[{"a":[{"t":4}]}]}],"d":[{"o":18}],"f":25,"g":[{"r":9}],"i":[{"c":4}],"m":[{"a":9,"b":0,"y":3}],"n":[{"a":[{"l":[{"i":0}],"t":3}],"o":18,"y":18}],"r":[{"a":9,"i":[{"e":3,"z":5}]}],"s":8,"u":[{"r":32,"t":18}],"w":[{"a":[{"r":3}]}],"l":[{"o":[{"g":[{"y":84}]}]}],"t":[{"i":[{"c":11}]}]},41],"p":43,"r":[{"a":[{"b":11,"c":[{"h":5,"i":[{"t":17},36],"t":[{"e":17}]}],"s":17,"v":[{"e":[{"n":5,"s":158,"r":[{"s":[{"a":[{"b":317}]},15]}]}]}],"i":[{"t":[{"o":[{"r":316}]}]}]},41],"e":[{"f":5,"m":[{"i":6},0],"a":[{"c":[{"h":[{"e":318}]}]}]}],"i":[{"a":[{"l":[{".":1}]},32],"c":[{"e":[{"s":5}],"i":[{"a":32}],"s":18}],"m":25,"v":0}],"o":[{"m":[{"i":5}],"n":[{"i":6,"y":18}],"p":[{"h":[{"e":5}],"i":[{"s":175}],"o":[{"l":[{"e":[{"s":320}],"i":[{"s":320,"t":321}]}]}]}],"s":[{"p":11}],"v":11,"l":[{"e":[{"u":[{"m":319}]}]}],"f":[{"i":[{"c":[{".":17}],"t":11}]}]}],"u":[{"i":5,"s":17}]}],"s":[{"c":[{"h":[{"i":[{"e":12}]}]},21],"h":0,"w":21},101],"t":[{"e":[{"s":21}],"o":19,"u":0,"r":[{"i":[{"b":[{"u":[{"t":322}]}]}]}]},66],"u":[{"a":[{"r":3},2],"b":[{"i":1}],"d":8,"e":18,"f":46,"i":76,"m":27,"n":[{"i":[{"s":1}]}],"p":[{".":48}],"r":[{"e":27,"i":[{"s":11},32],"o":5,"y":4,"n":[{"a":[{"r":12}]}]}],"s":27},41],"v":18,"w":[{"a":43,"i":[{"s":17}],"o":18,"h":29},1],"y":[{"a":18,"l":25,"p":[{"e":12,"h":4,"a":[{"l":64}]}]},41],"z":[{"e":1},18]}],"u":[{"a":[{"b":18,"c":0,"n":[{"a":4,"i":0}],"r":[{"a":[{"n":[{"t":5}]}],"d":8,"i":11,"t":11}],"t":29,"v":0,"d":[{"r":[{"a":[{"t":[{"i":3,"u":15}]}]}]}]}],"b":[{"e":[{"l":21,"r":[{"o":21},23]},1],"i":[{"n":[{"g":33}]},72],"l":[{"e":[{".":23}]}]}],"c":[{"a":23,"i":[{"b":0,"t":1}],"l":[{"e":12}],"r":23,"u":23,"y":21}],"d":[{"d":4,"e":[{"r":3,"s":[{"t":4}],"v":17}],"i":[{"c":29,"e":[{"d":3,"s":3}],"s":4,"t":19}],"o":[{"n":[{"y":232},21]}],"s":[{"i":1}],"u":21}],"e":[{"n":[{"e":21,"s":17,"t":[{"e":0}]}],"r":[{"i":[{"l":0}]}],"a":[{"m":15}]}],"f":[{"a":27,"l":23}],"g":[{"h":[{"e":[{"n":11}]}],"i":[{"n":4}]}],"i":[{"l":[{"i":[{"z":5}]}],"n":[{"g":29},1],"r":[{"m":0}],"t":[{"a":17}],"v":[{"e":[{"r":[{".":0}]}]},11]},156],"j":19,"k":18,"l":[{"a":[{"b":5,"t":[{"i":19}]},29],"c":[{"h":[{"e":32},17]}],"d":[{"e":[{"r":3}]}],"e":[{"n":29},1],"g":[{"i":1}],"i":[{"a":19,"n":[{"g":3}],"s":[{"h":4}]},9],"l":[{"a":[{"r":1}],"i":[{"b":96,"s":1}]}],"m":61,"o":72,"s":[{"e":[{"s":5}]},18],"t":[{"i":2,"r":[{"a":54}],"u":18}],"u":[{"l":4},23],"v":4}],"m":[{"a":[{"b":4}],"b":[{"i":1,"l":[{"y":1}]}],"i":[{"n":[{"g":83}]},29],"o":[{"r":[{"o":6}]}],"p":9}],"n":[{"a":[{"t":17}],"e":[{"r":1},24],"i":[{"m":1,"n":24,"s":[{"h":4}],"v":11},29],"s":[{"w":1},93],"t":[{"a":[{"b":11}],"e":[{"r":[{".":1}],"s":1}]}],"u":0,"y":4,"z":4}],"o":[{"r":[{"s":21}],"s":19,"u":29}],"p":[{"e":[{"r":[{"s":6}]},29],"i":[{"a":19,"n":[{"g":3}]}],"l":23,"p":[{"o":[{"r":[{"t":10}]}]},3],"t":[{"i":[{"b":5}],"u":17}]}],"r":[{"a":[{".":18,"g":21,"s":21,"l":[{".":216}]},29],"b":[{"e":1}],"c":0,"d":2,"e":[{"a":[{"t":5}]}],"f":[{"e":[{"r":1}],"r":1}],"i":[{"f":[{"i":[{"c":0}]},23],"n":2,"o":23,"t":29,"z":3,"a":[{"l":[{".":0}]}]}],"l":[{"i":[{"n":[{"g":[{".":5}]}]}]},9],"n":[{"o":1}],"o":[{"s":17}],"p":[{"e":1,"i":1}],"s":[{"e":[{"r":5}]}],"t":[{"e":[{"s":4}],"h":[{"e":3}],"i":[{"e":1},17]}],"u":23}],"s":[{"a":[{"d":19,"n":19,"p":1}],"c":[{"i":3},8],"e":[{"a":5,"r":[{".":9}]}],"i":[{"a":19,"c":23}],"l":[{"i":[{"n":1}]}],"p":2,"s":[{"l":4}],"t":[{"e":[{"r":[{"e":4}]}],"r":2}],"u":[{"r":17},24]},25],"t":[{"a":[{"b":0,"t":23}],"e":[{".":18,"l":18,"n":[{"i":17},18]}],"i":[{"l":[{"i":[{"z":5}]}],"n":[{"e":23,"g":3}],"o":[{"n":[{"a":7}]}],"s":21,"z":31},101],"l":34,"o":[{"f":4,"g":5,"m":[{"a":[{"t":[{"i":[{"c":5}]}]}]}],"n":19,"u":21}],"s":0}],"u":[{"m":1},23],"v":74,"x":[{"u":11}],"z":[{"e":1}]}],"v":[{"a":[{".":32,"b":159,"c":[{"i":[{"l":5}],"u":11}],"g":[{"e":1,"u":[{"e":[{"r":170}]}]},0],"l":[{"i":[{"e":4}],"o":5,"u":15}],"m":[{"o":4}],"n":[{"i":[{"z":4}]}],"p":[{"i":4}],"r":[{"i":[{"e":[{"d":5}]}]}],"t":[{"i":[{"v":29}]},27],"u":[{"d":[{"e":[{"v":54}]}]}]},41],"e":[{".":18,"d":18,"g":11,"l":[{".":23,"l":[{"i":11}],"o":1,"y":21}],"n":[{"o":[{"m":11}],"u":[{"e":19}]}],"r":[{"d":21,"e":[{".":32,"l":[{"y":[{".":41}]},21],"n":[{"c":5},23],"s":21,"i":[{"g":324}]}],"i":[{"e":11}],"m":[{"i":[{"n":36}]}],"s":[{"e":27}],"t":[{"h":11}]}],"s":[{".":18,"t":[{"e":0,"i":[{"t":[{"e":15}]}]}]},99],"t":[{"e":[{"r":11},1],"y":1}]}],"i":[{"a":[{"l":[{"i":4}],"n":32}],"d":[{"e":[{".":32,"d":32,"n":47,"s":32}],"i":32}],"f":23,"g":[{"n":4}],"k":0,"l":[{"i":[{"t":32,"z":127}]},25],"n":[{"a":26,"c":24,"d":5,"g":18},29],"o":[{"l":11,"r":73,"u":2}],"p":1,"r":[{"o":4}],"s":[{"i":[{"t":11}],"o":3,"u":3}],"t":[{"i":18,"r":11,"y":18}],"v":[{"i":[{"p":[{"a":[{"r":325}]}]}]},27]}],"o":[{".":32,"i":[{"r":[{"d":[{"u":323}]}],"c":[{"e":[{"p":213}]}]},0],"k":27,"l":[{"a":1,"e":19,"t":32,"v":27}],"m":[{"i":5}],"r":[{"a":[{"b":5}],"i":17,"y":1}],"t":[{"a":1,"e":[{"e":18}]}]}],"v":26,"y":21}],"w":[{"a":[{"b":[{"l":19}],"c":25,"g":[{"e":[{"r":4}],"o":5}],"i":[{"t":6}],"l":[{".":19}],"m":0,"r":[{"t":0}],"s":[{"t":[{"e":[{"w":[{"a":326}]}]},0]}],"t":[{"e":2}],"v":[{"e":[{"r":4,"g":327}]}]}],"b":29,"e":[{"a":[{"r":[{"i":[{"e":5}]}],"t":[{"h":54}]}],"d":[{"n":0}],"e":[{"t":12,"v":5,"k":[{"n":137}]}],"l":[{"l":0}],"r":29,"s":[{"t":12}],"v":23}],"h":[{"i":0}],"i":[{"l":[{"l":[{"i":[{"n":6}]}]},8],"n":[{"d":[{"e":0}],"g":0}],"r":0,"s":[{"e":27}],"t":[{"h":12}],"z":5,"d":[{"e":[{"s":[{"p":6}]}]}]},9],"k":21,"l":[{"e":[{"s":1}],"i":[{"n":3}]}],"n":[{"o":21}],"o":[{"m":15,"v":[{"e":[{"n":4}]}],"k":[{"e":[{"n":85}]}]},160],"p":19,"r":[{"a":[{"p":[{"a":[{"r":[{"o":12}]}]}]},0],"i":[{"t":[{"a":36,"e":[{"r":[{".":183}]}]}]},0]}],"s":[{"h":23,"l":1,"p":[{"e":1}],"t":60}],"t":18,"y":1,"c":23}],"x":[{"a":[{"c":[{"e":5}],"g":[{"o":21}],"m":11,"p":21,"s":5},29],"c":161,"e":[{"c":[{"u":[{"t":[{"o":1}]}]}],"d":24,"r":[{"i":0,"o":4}]},29],"h":[{"i":[{"l":6},8],"u":0},29],"i":[{"a":4,"c":4,"d":[{"i":4}],"m":[{"e":21,"i":[{"z":4}]}]},23],"o":[{"b":21},23],"p":[{"a":[{"n":[{"d":17}]}],"e":[{"c":[{"t":[{"o":10}]}],"d":11}]},23],"t":[{"i":23},74],"u":[{"a":3},29],"x":1,"q":[{"u":[{"i":[{"s":54}]}]},29]}],"y":[{"a":[{"c":19,"r":110,"t":19}],"b":29,"c":[{"e":[{"r":4},24],"h":[{"e":[{"d":264},0]},23],"o":[{"m":17,"t":17}]},29],"d":29,"e":[{"e":19,"r":[{"f":21},29],"s":[{"t":[{"e":[{"r":[{"y":328}]}]}]},0],"t":1}],"g":[{"i":19}],"h":47,"i":29,"l":[{"a":23,"l":[{"a":[{"b":[{"l":6}]}]}],"o":23,"u":19}],"m":[{"b":[{"o":[{"l":7}]}],"e":[{"t":[{"r":[{"y":20}]}]},0],"p":[{"a":12}]}],"n":[{"c":[{"h":[{"r":3}]}],"d":4,"g":4,"i":[{"c":4}],"x":32}],"o":[{"d":4,"g":33,"m":0,"n":[{"e":[{"t":4}],"s":21}],"s":21},72],"p":[{"e":[{"d":21,"r":6}],"i":3,"o":[{"c":21},23],"t":[{"a":9}],"u":19}],"r":[{"a":[{"m":5}],"i":[{"a":4}],"o":23,"r":1}],"s":[{"c":1,"e":161,"i":[{"c":[{"a":3}],"o":3,"s":27}],"o":21,"s":0,"t":[{"a":3,"r":[{"o":29}]},2],"u":[{"r":17}]}],"t":[{"h":[{"i":[{"n":23}]}],"i":[{"c":3}]}],"w":29}],"z":[{"a":[{"b":79,"r":8},2],"b":18,"e":[{"n":1,"p":1,"r":[{"o":3},29],"t":0},25],"i":[{"l":21,"s":21,"a":[{"n":[{".":23}]}]},42],"l":32,"m":18,"o":[{"m":1,"o":[{"l":4}],"p":[{"h":[{"r":329}]}]},41],"t":[{"e":0}],"z":[{"y":21,"w":231},101]}]}',
        [
            "as-so-ciate",
            "as-so-ciates",
            "dec-li-na-tion",
            "oblig-a-tory",
            "phil-an-thropic",
            "present",
            "presents",
            "project",
            "projects",
            "reci-procity",
            "re-cog-ni-zance",
            "ref-or-ma-tion",
            "ret-ri-bu-tion",
            "ta-ble"
        ]
    ];
});

},{}],"5Hm5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = ()=>{
    // https://mths.be/emoji
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l7pXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveImage);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var _jayPeg = require("jay-peg");
var _jayPegDefault = parcelHelpers.interopDefault(_jayPeg);
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup[tmp >> 10];
        output += lookup[tmp >> 4 & 0x3F];
        output += lookup[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString = {}.toString;
var isArray = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
/*
 * Export kMaxLength after typed array support is determined.
 */ kMaxLength();
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species];
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray(buf);
    else return fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
(0, _pngJsDefault.default).isValid = function isValid(data) {
    try {
        return new (0, _pngJsDefault.default)(data), true;
    } catch (e) {
        return false;
    }
};
var JPEG = function JPEG(data) {
    this.data = null;
    this.width = null;
    this.height = null;
    this.data = data;
    if (data.readUInt16BE(0) !== 0xffd8) throw new Error("SOI not found in JPEG");
    var markers = (0, _jayPegDefault.default).decode(this.data);
    for(var i = 0; i < markers.length; i += 1){
        var marker = markers[i];
        if (marker.name === "EXIF" && marker.entries.orientation) this.orientation = marker.entries.orientation;
        if (marker.name === "SOF") {
            this.width || (this.width = marker.width);
            this.height || (this.height = marker.height);
        }
    }
    if (this.orientation > 4) {
        var _ref = [
            this.height,
            this.width
        ];
        this.width = _ref[0];
        this.height = _ref[1];
    }
};
JPEG.isValid = function(data) {
    return data && Buffer.isBuffer(data) && data.readUInt16BE(0) === 0xffd8;
};
var createCache = function createCache(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 100 : _ref$limit;
    var cache = {};
    var keys = [];
    return {
        get: function get(key) {
            return cache[key];
        },
        set: function set(key, value) {
            keys.push(key);
            if (keys.length > limit) delete cache[keys.shift()];
            cache[key] = value;
        },
        reset: function reset() {
            cache = {};
            keys = [];
        },
        length: function length() {
            return keys.length;
        }
    };
};
var IMAGE_CACHE = createCache({
    limit: 30
});
var fetchRemoteFile = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(uri, options) {
        var response, buffer;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(uri, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.buffer ? response.buffer() : response.arrayBuffer();
                case 5:
                    buffer = _context.sent;
                    return _context.abrupt("return", buffer.constructor.name === "Buffer" ? buffer : Buffer.from(buffer));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchRemoteFile(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isValidFormat = function isValidFormat(format) {
    var lower = format.toLowerCase();
    return lower === "jpg" || lower === "jpeg" || lower === "png";
};
var guessFormat = function guessFormat(buffer) {
    var format;
    if (JPEG.isValid(buffer)) format = "jpg";
    else if ((0, _pngJsDefault.default).isValid(buffer)) format = "png";
    return format;
};
var isCompatibleBase64 = function isCompatibleBase64(_ref2) {
    var uri = _ref2.uri;
    return /^data:image\/[a-zA-Z]*;base64,[^"]*/g.test(uri);
};
function getImage(body, extension) {
    switch(extension.toLowerCase()){
        case "jpg":
        case "jpeg":
            return new JPEG(body);
        case "png":
            return new (0, _pngJsDefault.default)(body);
        default:
            return null;
    }
}
var resolveBase64Image = function resolveBase64Image(_ref3) {
    var uri = _ref3.uri;
    var match = /^data:image\/([a-zA-Z]*);base64,([^"]*)/g.exec(uri);
    var format = match[1];
    var data = match[2];
    if (!isValidFormat(format)) throw new Error("Base64 image invalid format: " + format);
    return new Promise(function(resolve) {
        return resolve(getImage(Buffer.from(data, "base64"), format));
    });
};
var resolveImageFromData = function resolveImageFromData(src) {
    if (src.data && src.format) return new Promise(function(resolve) {
        return resolve(getImage(src.data, src.format));
    });
    throw new Error("Invalid data given for local file: " + JSON.stringify(src));
};
var resolveBufferImage = function resolveBufferImage(buffer) {
    var format = guessFormat(buffer);
    if (format) return new Promise(function(resolve) {
        return resolve(getImage(buffer, format));
    });
    return Promise.resolve();
};
var resolveBlobImage = /*#__PURE__*/ function() {
    var _ref4 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2(blob) {
        var type, arrayBuffer, _buffer, format, buffer;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    type = blob.type;
                    if (!(!type || type === "application/octet-stream")) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 4;
                    return blob.arrayBuffer();
                case 4:
                    arrayBuffer = _context2.sent;
                    _buffer = Buffer.from(arrayBuffer);
                    return _context2.abrupt("return", resolveBufferImage(_buffer));
                case 7:
                    if (type.startsWith("image/")) {
                        _context2.next = 9;
                        break;
                    }
                    throw new Error("Invalid blob type: " + type);
                case 9:
                    format = type.replace("image/", "");
                    if (isValidFormat(format)) {
                        _context2.next = 12;
                        break;
                    }
                    throw new Error("Invalid blob type: " + type);
                case 12:
                    _context2.next = 14;
                    return blob.arrayBuffer();
                case 14:
                    buffer = _context2.sent;
                    return _context2.abrupt("return", getImage(Buffer.from(buffer), format));
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function resolveBlobImage(_x3) {
        return _ref4.apply(this, arguments);
    };
}();
var getImageFormat = function getImageFormat(body) {
    var isPng = body[0] === 137 && body[1] === 80 && body[2] === 78 && body[3] === 71 && body[4] === 13 && body[5] === 10 && body[6] === 26 && body[7] === 10;
    var isJpg = body[0] === 255 && body[1] === 216 && body[2] === 255;
    var extension = "";
    if (isPng) extension = "png";
    else if (isJpg) extension = "jpg";
    else throw new Error("Not valid image extension");
    return extension;
};
var resolveImageFromUrl = /*#__PURE__*/ function() {
    var _ref5 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee3(src) {
        var uri, body, headers, _src$method, method, credentials, data, extension;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    uri = src.uri, body = src.body, headers = src.headers, _src$method = src.method, method = _src$method === void 0 ? "GET" : _src$method, credentials = src.credentials;
                    _context3.next = 7;
                    break;
                case 4:
                    _context3.t0 = _context3.sent;
                    _context3.next = 10;
                    break;
                case 7:
                    _context3.next = 9;
                    return fetchRemoteFile(uri, {
                        body: body,
                        headers: headers,
                        method: method,
                        credentials: credentials
                    });
                case 9:
                    _context3.t0 = _context3.sent;
                case 10:
                    data = _context3.t0;
                    extension = getImageFormat(data);
                    return _context3.abrupt("return", getImage(data, extension));
                case 13:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function resolveImageFromUrl(_x4) {
        return _ref5.apply(this, arguments);
    };
}();
var resolveImage = function resolveImage(src, _temp) {
    var _ref6 = _temp === void 0 ? {} : _temp, _ref6$cache = _ref6.cache, cache = _ref6$cache === void 0 ? true : _ref6$cache;
    var image;
    var cacheKey = src.data ? src.data.toString() : src.uri;
    if (typeof Blob !== "undefined" && src instanceof Blob) image = resolveBlobImage(src);
    else if (Buffer.isBuffer(src)) image = resolveBufferImage(src);
    else if (cache && IMAGE_CACHE.get(cacheKey)) return IMAGE_CACHE.get(cacheKey);
    else if (isCompatibleBase64(src)) image = resolveBase64Image(src);
    else if (typeof src === "object" && src.data) image = resolveImageFromData(src);
    else image = resolveImageFromUrl(src);
    if (!image) throw new Error("Cannot resolve image");
    if (cache) IMAGE_CACHE.set(cacheKey, image);
    return image;
};

},{"@babel/runtime/helpers/regeneratorRuntime":"lzux5","@babel/runtime/helpers/asyncToGenerator":"fs5T9","cross-fetch":"2oWud","@react-pdf/png-js":"gUjti","jay-peg":"bm3FR","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"26m2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var E = {};
E.ALIGN_AUTO = 0;
E.ALIGN_FLEX_START = 1;
E.ALIGN_CENTER = 2;
E.ALIGN_FLEX_END = 3;
E.ALIGN_STRETCH = 4;
E.ALIGN_BASELINE = 5;
E.ALIGN_SPACE_BETWEEN = 6;
E.ALIGN_SPACE_AROUND = 7;
E.DIMENSION_WIDTH = 0;
E.DIMENSION_HEIGHT = 1;
E.DIRECTION_INHERIT = 0;
E.DIRECTION_LTR = 1;
E.DIRECTION_RTL = 2;
E.DISPLAY_FLEX = 0;
E.DISPLAY_NONE = 1;
E.EDGE_LEFT = 0;
E.EDGE_TOP = 1;
E.EDGE_RIGHT = 2;
E.EDGE_BOTTOM = 3;
E.EDGE_START = 4;
E.EDGE_END = 5;
E.EDGE_HORIZONTAL = 6;
E.EDGE_VERTICAL = 7;
E.EDGE_ALL = 8;
E.EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS = 0;
E.EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE = 1;
E.EXPERIMENTAL_FEATURE_FIX_ABSOLUTE_TRAILING_COLUMN_MARGIN = 2;
E.FLEX_DIRECTION_COLUMN = 0;
E.FLEX_DIRECTION_COLUMN_REVERSE = 1;
E.FLEX_DIRECTION_ROW = 2;
E.FLEX_DIRECTION_ROW_REVERSE = 3;
E.GUTTER_COLUMN = 0;
E.GUTTER_ROW = 1;
E.GUTTER_ALL = 2;
E.JUSTIFY_FLEX_START = 0;
E.JUSTIFY_CENTER = 1;
E.JUSTIFY_FLEX_END = 2;
E.JUSTIFY_SPACE_BETWEEN = 3;
E.JUSTIFY_SPACE_AROUND = 4;
E.JUSTIFY_SPACE_EVENLY = 5;
E.LOG_LEVEL_ERROR = 0;
E.LOG_LEVEL_WARN = 1;
E.LOG_LEVEL_INFO = 2;
E.LOG_LEVEL_DEBUG = 3;
E.LOG_LEVEL_VERBOSE = 4;
E.LOG_LEVEL_FATAL = 5;
E.MEASURE_MODE_UNDEFINED = 0;
E.MEASURE_MODE_EXACTLY = 1;
E.MEASURE_MODE_AT_MOST = 2;
E.NODE_TYPE_DEFAULT = 0;
E.NODE_TYPE_TEXT = 1;
E.OVERFLOW_VISIBLE = 0;
E.OVERFLOW_HIDDEN = 1;
E.OVERFLOW_SCROLL = 2;
E.POSITION_TYPE_STATIC = 0;
E.POSITION_TYPE_RELATIVE = 1;
E.POSITION_TYPE_ABSOLUTE = 2;
E.PRINT_OPTIONS_LAYOUT = 1;
E.PRINT_OPTIONS_STYLE = 2;
E.PRINT_OPTIONS_CHILDREN = 4;
E.UNIT_UNDEFINED = 0;
E.UNIT_POINT = 1;
E.UNIT_PERCENT = 2;
E.UNIT_AUTO = 3;
E.WRAP_NO_WRAP = 0;
E.WRAP_WRAP = 1;
E.WRAP_WRAP_REVERSE = 2;
var rE = E;
var AE = function AE(E) {
    function a(E, a, _) {
        var s = E[a];
        E[a] = function() {
            for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++)E[_key] = arguments[_key];
            return _.call.apply(_, [
                this,
                s
            ].concat(E));
        };
    }
    var _loop = function _loop() {
        var _s;
        var _ = _arr[_i];
        var s = (_s = {}, _s[rE.UNIT_POINT] = E.Node.prototype[_], _s[rE.UNIT_PERCENT] = E.Node.prototype[_ + "Percent"], _s[rE.UNIT_AUTO] = E.Node.prototype[_ + "Auto"], _s);
        a(E.Node.prototype, _, function(E) {
            var _s$t, _s$t2;
            for(var _len2 = arguments.length, a = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)a[_key2 - 1] = arguments[_key2];
            var e = a.pop();
            var t, N;
            if ("auto" === e) t = rE.UNIT_AUTO, N = void 0;
            else if ("object" == typeof e) t = e.unit, N = e.valueOf();
            else if (t = "string" == typeof e && e.endsWith("%") ? rE.UNIT_PERCENT : rE.UNIT_POINT, N = parseFloat(e), !Number.isNaN(e) && Number.isNaN(N)) throw new Error("Invalid value " + e + " for " + _);
            if (!s[t]) throw new Error('Failed to execute "' + _ + "\": Unsupported unit '" + e + "'");
            return void 0 !== N ? (_s$t = s[t]).call.apply(_s$t, [
                this
            ].concat(a, [
                N
            ])) : (_s$t2 = s[t]).call.apply(_s$t2, [
                this
            ].concat(a));
        });
    };
    for(var _i = 0, _arr = [
        "setPosition",
        "setMargin",
        "setFlexBasis",
        "setWidth",
        "setHeight",
        "setMinWidth",
        "setMinHeight",
        "setMaxWidth",
        "setMaxHeight",
        "setPadding"
    ]; _i < _arr.length; _i++)_loop();
    return a(E.Node.prototype, "setMeasureFunc", function(a, _) {
        var s;
        return _ ? a.call(this, (s = _, E.MeasureCallback.implement({
            measure: function measure() {
                var _s2 = s.apply(void 0, arguments), a = _s2.width, _ = _s2.height;
                return {
                    width: a != null ? a : NaN,
                    height: _ != null ? _ : NaN
                };
            }
        }))) : this.unsetMeasureFunc();
    }), a(E.Node.prototype, "setDirtiedFunc", function(a, _) {
        var s;
        a.call(this, (s = _, E.DirtiedCallback.implement({
            dirtied: s
        })));
    }), a(E.Config.prototype, "free", function() {
        E.Config.destroy(this);
    }), a(E.Node, "create", function(a, _) {
        return _ ? E.Node.createWithConfig(_) : E.Node.createDefault();
    }), a(E.Node.prototype, "free", function() {
        E.Node.destroy(this);
    }), a(E.Node.prototype, "freeRecursive", function() {
        for(var _E2 = 0, _a = this.getChildCount(); _E2 < _a; ++_E2)this.getChild(0).freeRecursive();
        this.free();
    }), a(E.Node.prototype, "calculateLayout", function(E, a, _, s) {
        if (a === void 0) a = NaN;
        if (_ === void 0) _ = NaN;
        if (s === void 0) s = rE.DIRECTION_LTR;
        return E.call(this, a, _, s);
    }), (0, _extendsDefault.default)({
        Config: E.Config,
        Node: E.Node
    }, rE);
};
var rr, er = (rr = "undefined" != typeof document && document.currentScript ? document.currentScript.src : void 0, function(r) {
    if (r === void 0) r = {};
    var e, a, i;
    e || (e = void 0 !== r ? r : {}), e.ready = new Promise(function(r, e) {
        a = r, i = e;
    });
    var n = Object.assign({}, e), t = "";
    "undefined" != typeof document && document.currentScript && (t = document.currentScript.src), rr && (t = rr), t = 0 !== t.indexOf("blob:") ? t.substr(0, t.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "";
    var f, o = e.print || console.log.bind(console), c = e.printErr || console.warn.bind(console);
    function u() {}
    function b(r) {
        this.exports = function(r) {
            for(var e, a = new Uint8Array(123), i = 25; i >= 0; --i)a[48 + i] = 52 + i, a[65 + i] = i, a[97 + i] = 26 + i;
            function n(r, e, i) {
                for(var n, t, f = 0, o = e, c = i.length, u = e + (3 * c >> 2) - ("=" == i[c - 2]) - ("=" == i[c - 1]); f < c; f += 4)n = a[i.charCodeAt(f + 1)], t = a[i.charCodeAt(f + 2)], r[o++] = a[i.charCodeAt(f)] << 2 | n >> 4, o < u && (r[o++] = n << 4 | t >> 2), o < u && (r[o++] = t << 6 | a[i.charCodeAt(f + 3)]);
            }
            a[43] = 62, a[47] = 63;
            var t = new ArrayBuffer(16), f = new Int32Array(t), o = new Float32Array(t), c = new Float64Array(t);
            function u(r) {
                return f[r];
            }
            function b(r, e) {
                f[r] = e;
            }
            function s() {
                return c[0];
            }
            function A(r) {
                c[0] = r;
            }
            function k() {
                throw new Error("abort");
            }
            function l(r) {
                o[2] = r;
            }
            function d() {
                return o[2];
            }
            return function(r) {
                var a = r.a, i = a.a, t = i.buffer;
                i.grow = function(r) {
                    r |= 0;
                    var a = 0 | ia(), n = a + r | 0;
                    if (a < n && n < 65536) {
                        var u = new ArrayBuffer(w(n, 65536));
                        new Int8Array(u).set(f), f = new Int8Array(u), o = new Int16Array(u), c = new Int32Array(u), v = new Uint8Array(u), h = new Uint16Array(u), p = new Uint32Array(u), m = new Float32Array(u), N = new Float64Array(u), t = u, i.buffer = t, e = v;
                    }
                    return a;
                };
                var f = new Int8Array(t), o = new Int16Array(t), c = new Int32Array(t), v = new Uint8Array(t), h = new Uint16Array(t), p = new Uint32Array(t), m = new Float32Array(t), N = new Float64Array(t), w = Math.imul, y = Math.fround, E = Math.abs, G = Math.clz32, R = Math.min, g = Math.max, Z = a.b, W = a.c, V = a.d, B = a.e, T = a.f, I = a.g, X = a.h, O = a.i, L = a.j, _ = a.k, F = a.l, C = a.m, S = a.n, P = a.o, Y = a.p, U = a.q, M = a.r, H = a.s, Q = a.t, z = a.u, j = a.v, D = a.w, x = a.x, J = a.y, K = a.z, q = a.A, $ = a.B, rr = a.C, er = a.D, ar = 73632, ir = 0;
                function nr(r, e, a, i, n, t, o, u, s, A, l, h, p, N) {
                    var w, G = y(0), R = y(0), g = 0, Z = 0, W = 0, V = y(0), B = y(0), T = y(0), X = 0, O = 0, L = 0, _ = y(0), F = y(0), C = y(0), S = 0, P = y(0), Y = 0, U = y(0), M = y(0), H = 0, Q = 0, z = 0, j = 0, D = 0, x = y(0), J = 0, K = y(0), q = 0, $ = 0, rr = 0, er = 0, ir = y(0), nr = 0, tr = 0, fr = 0, cr = 0, br = y(0), lr = 0, dr = 0, vr = 0, hr = y(0), Nr = y(0), yr = 0, Er = y(0), Gr = y(0), Zr = y(0), _r = 0, Cr = 0, Sr = y(0), Pr = 0, Yr = y(0), Hr = y(0), jr = y(0), xr = y(0), Kr = 0, qr = 0, $r = 0, re = 0, ee = 0, ae = 0, ie = 0, ne = 0, te = 0, fe = y(0), oe = y(0);
                    ar = w = ar - 384 | 0;
                    r: {
                        e: {
                            a: {
                                if (!n || e == e) {
                                    if (!t || a == a) {
                                        if (c[(g = (s ? 0 : 4) + l | 0) >> 2] = c[g >> 2] + 1, Pr = (0 | i) <= 1 ? 1 : i, J = (g = 3 & c[r + 24 >> 2]) || Pr, f[r + 300 | 0] = 252 & v[r + 300 | 0] | 3 & J, g = r + 252 | 0, i = (1 != (0 | J)) << 3, B = Mr(r, lr = 2 == (0 | J) ? 3 : 2, o), m[g + i >> 2] = B, Z = g, g = (1 == (0 | J)) << 3, F = Ur(r, lr, o), m[Z + g >> 2] = F, _ = Mr(r, 0, o), m[r + 256 >> 2] = _, V = Ur(r, 0, o), m[r + 264 >> 2] = V, te = (W = r + 268 | 0) + i | 0, fe = zr(r, lr), m[te >> 2] = fe, te = g + W | 0, fe = Qr(r, lr), m[te >> 2] = fe, G = zr(r, 0), m[r + 272 >> 2] = G, T = Qr(r, 0), m[r + 280 >> 2] = T, te = (Z = i) + (i = r + 284 | 0) | 0, fe = Br(r, lr, o), m[te >> 2] = fe, te = i + g | 0, fe = Tr(r, lr, o), m[te >> 2] = fe, R = Br(r, 0, o), m[r + 288 >> 2] = R, P = Tr(r, 0, o), m[r + 296 >> 2] = P, B = y(B + F), F = y(_ + V), i = c[r + 8 >> 2]) {
                                            if (_ = y(y(y(m[r + 284 >> 2] + m[r + 292 >> 2]) + m[r + 268 >> 2]) + m[r + 276 >> 2]), a = y(t ? a - F : NaN), G = y(y(R + P) + G), (e = R = y(n ? e - B : NaN)) == e && (e = (e = y(R - _)) == e ? Re(e, y(0)) : y(0)), B = y(G + T), G = a, a == a && (G = (G = y(a - B)) == G ? Re(G, y(0)) : y(0)), !(1 != (0 | n) | 1 != (0 | t))) {
                                                e = (i = (e = ur(r, 2, R, o)) != e) | (G = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != G ? i ? G : e : Re(e, G), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, a, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                                break r;
                                            }
                                            16 & v[r + 4 | 0] ? aa[0 | i](w + 24 | 0, r, e, n, G, t, 0) : aa[0 | i](w + 24 | 0, r, e, n, G, t), c[l + 20 >> 2] = c[l + 20 >> 2] + 1, c[24 + (i = (N << 2) + l | 0) >> 2] = c[i + 24 >> 2] + 1, e = y(_ + m[w + 24 >> 2]), e = (i = (e = ur(r, 2, n ? 2 == (0 | n) ? e : R : e, o)) != e) | (G = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != G ? i ? G : e : Re(e, G), m[r + 516 >> 2] = e, e = y(B + m[w + 28 >> 2]), e = (i = (e = ur(r, 0, t ? 2 == (0 | t) ? e : a : e, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        if ((0 | (i = c[r + 556 >> 2])) == (0 | (N = c[r + 560 >> 2]))) {
                                            F = y(a - F), e = (i = (e = ur(r, 2, y(-3 & n ? e - B : y(y(m[r + 284 >> 2] + m[r + 292 >> 2]) + m[r + 268 >> 2]) + m[r + 276 >> 2]), o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, -3 & t ? F : y(y(y(R + P) + G) + T), u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        if (!(s || (R = y(e - B), G = y(a - F), !(2 == (0 | n) & R <= y(0) | !(!(G <= y(0)) | 2 != (0 | t)) & G == G) & (1 != (0 | n) | 1 != (0 | t))))) {
                                            e = (i = (e = ur(r, 2, R == R ? 2 == (0 | n) && R < y(0) ? y(0) : R : y(0), o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, G != G || 2 == (0 | t) && G < y(0) ? y(0) : G, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        for(er = (z = N - i | 0) >> 2; g = c[i >> 2], c[g + 552 >> 2] != (0 | r) && (W = c[r + 568 >> 2], g = Ir(c[W >> 2], v[W + 8 | 0], g, r, O, 0), c[i >> 2] = g, c[g + 552 >> 2] = r), O = O + 1 | 0, (0 | N) != (0 | (i = i + 4 | 0)););
                                        f[r + 300 | 0] = 251 & v[r + 300 | 0], O = 3, i = (yr = c[r + 24 >> 2]) >>> 2 & 3;
                                        i: {
                                            n: {
                                                t: {
                                                    if (2 == (0 | J)) {
                                                        N = 0;
                                                        f: switch(i - 2 | 0){
                                                            case 0:
                                                                break i;
                                                            case 1:
                                                                break f;
                                                            default:
                                                                break t;
                                                        }
                                                        O = 2;
                                                        break i;
                                                    }
                                                    if (O = 2, N = 0, i >>> 0 > 1) break n;
                                                }
                                                N = O;
                                            }
                                            O = i;
                                        }
                                        Yr = y(e - B), ir = y(y(Br(r, O, o) + zr(r, O)) + y(Tr(r, O, o) + Qr(r, O))), P = y(Br(r, N, o) + zr(r, N)), K = y(P + y(Tr(r, N, o) + Qr(r, N))), V = kr(r, 0, Yr, (q = O >>> 0 > 1) ? ir : K, o), U = kr(r, 1, Hr = y(a - F), q ? K : ir, u), M = q ? U : V, F = q ? V : U, nr = c[r + 560 >> 2], g = c[r + 556 >> 2];
                                        i: if (1 == (0 | (Y = q ? n : t))) {
                                            if ((0 | g) == (0 | nr)) break a;
                                            for(i = 0, W = g;;){
                                                Z = i;
                                                n: if (Dr(i = c[W >> 2])) {
                                                    if (X = 0, Z) break i;
                                                    if (!(Z = c[i + 552 >> 2])) break i;
                                                    t: {
                                                        if (!((a = m[i + 32 >> 2]) == a || (G = y(0), (a = m[i + 28 >> 2]) > y(0))) || (G = a, a == a)) {
                                                            if (y(E(G)) < y(9999999747378752e-20)) break i;
                                                            if (!Z) {
                                                                a = y(0);
                                                                break t;
                                                            }
                                                        }
                                                        if ((a = m[i + 36 >> 2]) != a) {
                                                            if (f[i + 4 | 0] < 0) {
                                                                a = y(1);
                                                                break t;
                                                            }
                                                            if (a = y(0), !((e = m[i + 28 >> 2]) < y(0))) break t;
                                                            a = y(-e);
                                                        }
                                                        if (a != a) break n;
                                                    }
                                                    if (y(E(a)) < y(9999999747378752e-20)) break i;
                                                } else i = Z;
                                                if (X = i, (0 | nr) == (0 | (W = W + 4 | 0))) break;
                                            }
                                        }
                                        if ((0 | g) == (0 | nr)) break a;
                                        for(j = (0 | J) <= 1 ? 1 : J, tr = (fr = V != V) | 1 != (0 | n), cr = U == U, dr = V == V, G = y(0);;){
                                            sr(L = c[g >> 2]);
                                            i: if (4194304 & (W = c[L + 24 >> 2])) {
                                                if (mr(L, 0), W = 1 | (i = v[L + 4 | 0]), f[L + 4 | 0] = W, !(4 & i)) break i;
                                                f[L + 4 | 0] = 251 & W;
                                            } else if (s && (Fr(L, (i = 3 & W) || j, F, M, V), W = c[L + 24 >> 2]), 131072 != (196608 & W)) {
                                                if ((0 | X) != (0 | L)) {
                                                    Z = (vr = c[r + 24 >> 2]) >>> 2 & 3;
                                                    n: {
                                                        t: if (2 == (0 | J)) {
                                                            i = 3;
                                                            f: switch(Z - 2 | 0){
                                                                case 0:
                                                                    break n;
                                                                case 1:
                                                                    break f;
                                                                default:
                                                                    break t;
                                                            }
                                                            i = 2;
                                                            break n;
                                                        }
                                                        i = Z;
                                                    }
                                                    R = ($ = i >>> 0 > 1) ? V : U, a = y(0), e = m[L + 40 >> 2];
                                                    n: {
                                                        t: {
                                                            f: if (2139156720 != (0 | (Z = c[L + 40 >> 2]))) {
                                                                if (2140081935 == (0 | Z)) break t;
                                                                S = 4276;
                                                                o: {
                                                                    if (2141891242 != (0 | Z)) {
                                                                        if (e == e) break o;
                                                                        S = 4268;
                                                                    }
                                                                    a = m[S >> 2];
                                                                    c: {
                                                                        u: switch(0 | (Z = c[S + 4 >> 2])){
                                                                            case 0:
                                                                            case 3:
                                                                                break u;
                                                                            default:
                                                                                break c;
                                                                        }
                                                                        if (e = y(NaN), !(m[L + 28 >> 2] > y(0))) break n;
                                                                        Z = (S = f[L + 4 | 0] < 0) ? 3 : 1, b(2, D = S ? 2143289344 : 0), a = d();
                                                                    }
                                                                    switch(e = y(NaN), Z - 1 | 0){
                                                                        case 0:
                                                                            break t;
                                                                        case 1:
                                                                            break f;
                                                                        default:
                                                                            break n;
                                                                    }
                                                                }
                                                                if (b(2, 536870912 + (-1073741825 & Z) | 0), a = d(), !(1073741824 & Z)) break t;
                                                            }
                                                            e = y(y(R * a) * y(.009999999776482582));
                                                            break n;
                                                        }
                                                        e = a;
                                                    }
                                                    a = m[L + 572 >> 2], Z = 0;
                                                    n: {
                                                        switch(0 | (Q = c[L + 576 >> 2])){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (1 != (0 | Q) | (B = m[L + 572 >> 2]) != B) Z = 1, 2 != (0 | Q) | B != B || (Z = 0, a < y(0) || (Z = dr));
                                                        else {
                                                            if (a < y(0)) break n;
                                                            Z = 1;
                                                        }
                                                    }
                                                    B = m[L + 580 >> 2], S = 0;
                                                    n: {
                                                        switch(0 | (H = c[L + 584 >> 2])){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (1 != (0 | H) | (T = m[L + 580 >> 2]) != T) S = 1, 2 != (0 | H) | T != T || (S = 0, B < y(0) || (S = cr));
                                                        else {
                                                            if (B < y(0)) break n;
                                                            S = 1;
                                                        }
                                                    }
                                                    n: {
                                                        t: if (e != e | R != R) {
                                                            if (Z & $) {
                                                                switch(R = y(y(Br(L, 2, V) + zr(L, 2)) + y(Tr(L, 2, V) + Qr(L, 2))), e = y(NaN), Q - 1 | 0){
                                                                    case 1:
                                                                        a = y(y(V * a) * y(.009999999776482582));
                                                                    case 0:
                                                                        if (R <= (e = a)) break t;
                                                                }
                                                                if (!(e == e | R == R)) {
                                                                    a = e;
                                                                    break t;
                                                                }
                                                                if (e < R) {
                                                                    a = R;
                                                                    break t;
                                                                }
                                                                a = e != e ? R : e;
                                                            } else if ($ | 1 ^ S) {
                                                                if (c[w + 360 >> 2] = 2143289344, c[w + 24 >> 2] = 2143289344, D = 0, c[w + 356 >> 2] = 0, c[w + 352 >> 2] = 0, T = y(Mr(L, 2, V) + Ur(L, 2, V)), _ = Mr(L, 0, V), C = Ur(L, 0, V), R = y(NaN), rr = 0, e = y(NaN), Z) {
                                                                    f: {
                                                                        o: switch(Q - 1 | 0){
                                                                            case 0:
                                                                                e = a;
                                                                                break f;
                                                                            case 1:
                                                                                break o;
                                                                            default:
                                                                                break f;
                                                                        }
                                                                        e = y(y(V * a) * y(.009999999776482582));
                                                                    }
                                                                    c[w + 356 >> 2] = 1, e = y(T + e), m[w + 24 >> 2] = e, rr = 1;
                                                                }
                                                                if (_ = y(_ + C), S) {
                                                                    a = y(NaN);
                                                                    f: {
                                                                        o: switch(H - 1 | 0){
                                                                            case 0:
                                                                                a = B;
                                                                                break f;
                                                                            case 1:
                                                                                break o;
                                                                            default:
                                                                                break f;
                                                                        }
                                                                        a = y(y(U * B) * y(.009999999776482582));
                                                                    }
                                                                    c[w + 352 >> 2] = 1, R = y(_ + a), m[w + 360 >> 2] = R, D = 1;
                                                                }
                                                                Q = i >>> 0 < 2;
                                                                f: {
                                                                    o: {
                                                                        c: {
                                                                            if (!(!$ & 2097152 == (0 | (H = 3145728 & vr)))) {
                                                                                if (fr | 2097152 == (0 | H)) break o;
                                                                                if (e != e) break c;
                                                                                break o;
                                                                            }
                                                                            if (fr | e == e) break f;
                                                                        }
                                                                        rr = 2, c[w + 356 >> 2] = 2, m[w + 24 >> 2] = V, e = V;
                                                                    }
                                                                    o: {
                                                                        if (!(!Q & 2097152 == (0 | H))) {
                                                                            if (2097152 == (0 | H) | U != U) break f;
                                                                            if (R != R) break o;
                                                                            break f;
                                                                        }
                                                                        if (R == R | U != U) break f;
                                                                    }
                                                                    D = 2, c[w + 352 >> 2] = 2, m[w + 360 >> 2] = U, R = U;
                                                                }
                                                                f: if (!(H = (a = m[L + 224 >> 2]) != a)) {
                                                                    if ($ | 1 != (0 | rr)) {
                                                                        if (Q | 1 != (0 | D)) break f;
                                                                        c[w + 356 >> 2] = 1, m[w + 24 >> 2] = y(y(R - _) * a) + T;
                                                                    } else c[w + 352 >> 2] = 1, m[w + 360 >> 2] = _ + y(y(e - T) / a);
                                                                    D = 1, rr = 1;
                                                                }
                                                                5 == (0 | (W = (W = W >>> 13 & 7) || vr >>> 10 & 7)) | 1 == (0 | rr) | $ | Z | tr | 4 != (0 | W) || (c[w + 356 >> 2] = 1, m[w + 24 >> 2] = V, H || (D = 1, c[w + 352 >> 2] = 1, m[w + 360 >> 2] = y(V - T) / a)), Q | 1 != (0 | t) | U != U | S | 4 != (0 | W) | 1 == (0 | D) || (c[w + 352 >> 2] = 1, m[w + 360 >> 2] = U, H || (c[w + 356 >> 2] = 1, m[w + 24 >> 2] = y(U - _) * a)), Vr(L, 2, V, V, w + 356 | 0, w + 24 | 0), Vr(L, 0, U, V, w + 352 | 0, w + 360 | 0), or(L, m[w + 24 >> 2], m[w + 360 >> 2], J, c[w + 356 >> 2], c[w + 352 >> 2], V, U, 0, 5, A, l, h, p), a = (W = (e = m[516 + (L + (c[4252 + (i << 2) >> 2] << 2) | 0) >> 2]) != e) | (a = y(y(Br(L, i, V) + zr(L, i)) + y(Tr(L, i, V) + Qr(L, i)))) != a ? W ? a : e : Re(e, a);
                                                            } else {
                                                                switch(e = y(y(Br(L, 0, V) + zr(L, 0)) + y(Tr(L, 0, V) + Qr(L, 0))), a = y(NaN), H - 1 | 0){
                                                                    case 1:
                                                                        B = y(y(U * B) * y(.009999999776482582));
                                                                    case 0:
                                                                        if (e <= (a = B)) break t;
                                                                }
                                                                if (a != a & e != e) break t;
                                                                if (e > a) {
                                                                    a = e;
                                                                    break t;
                                                                }
                                                                a = a != a ? e : a;
                                                            }
                                                        } else {
                                                            if (a = m[L + 308 >> 2], (!v[c[L + 568 >> 2] + 20 | 0] | c[L + 304 >> 2] == (0 | p)) & a == a) break n;
                                                            if (!((a = y(y(Br(L, i, V) + zr(L, i)) + y(Tr(L, i, V) + Qr(L, i)))) <= e) & e < a) break t;
                                                            a = e;
                                                        }
                                                        m[L + 308 >> 2] = a;
                                                    }
                                                    c[L + 304 >> 2] = p;
                                                } else c[X + 308 >> 2] = 0, c[X + 304 >> 2] = p, a = y(0);
                                                G = y(G + y(a + y(Mr(L, O, V) + Ur(L, O, V))));
                                            }
                                            if ((0 | nr) == (0 | (g = g + 4 | 0))) break;
                                        }
                                        break e;
                                    }
                                    c[w >> 2] = 3023, Xr(r, w), De(), k();
                                }
                                c[w + 16 >> 2] = 3105, Xr(r, w + 16 | 0), De(), k();
                            }
                            G = y(0);
                        }
                        e = y(G + y(0)), Er = q ? u : o, hr = q ? o : u, z >>> 0 >= 5 && (e = y(y(pr(r, O, M) * y(er - 1 >>> 0)) + e)), i = e > F, nr = 786432 & yr, cr = 2 == (0 | Y) && nr && i ? 1 : Y, qr = (fr = 1 == (0 | (L = q ? t : n))) & (1 ^ s), q = O >>> 0 < 2, $r = -3 & L, vr = r + 208 | 0, H = 4220 + (t = N << 2) | 0, re = fr & !nr, ee = 1 != (0 | L) | s, $ = 4220 + (g = O << 2) | 0, dr = g + 4252 | 0, ae = (rr = M == M) << 1, Q = t + 4252 | 0, ie = !Y | !i, yr = w + 52 | 0, jr = pr(r, N, M), W = 0, i = 0, D = 0;
                        e: {
                            for(;;){
                                if (S = i, Rr(w + 24 | 0, 0, 44), (0 | (i = c[r + 560 >> 2])) != (0 | (t = c[r + 556 >> 2]))) {
                                    if ((0 | (i = i - t | 0)) < 0) break e;
                                    g = pe(w + 360 | 0, i >> 2, 0, yr), i = c[w + 44 >> 2], t = c[w + 48 >> 2] - i | 0, t = wr(c[w + 364 >> 2] - t | 0, i, t), i = c[w + 44 >> 2], c[w + 364 >> 2] = i, c[w + 44 >> 2] = t, Z = c[w + 368 >> 2], X = c[w + 372 >> 2], t = c[w + 48 >> 2], c[w + 368 >> 2] = t, Y = c[w + 52 >> 2], c[w + 48 >> 2] = Z, c[w + 52 >> 2] = X, c[w + 372 >> 2] = Y, c[g >> 2] = i, (0 | i) != (0 | t) && (c[w + 368 >> 2] = t + (3 + (i - t | 0) & -4)), i && gr(i);
                                }
                                t = (X = c[r + 24 >> 2]) >>> 2 & 3;
                                a: {
                                    i: if (2 == (0 | ((i = 3 & X) || Pr))) {
                                        i = 3;
                                        n: switch(t - 2 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break n;
                                            default:
                                                break i;
                                        }
                                        i = 2;
                                        break a;
                                    }
                                    i = t;
                                }
                                G = pr(r, i, V);
                                a: if (!((g = W) >>> 0 >= (Z = c[r + 560 >> 2]) - (t = c[r + 556 >> 2]) >> 2 >>> 0)) for(Y = 786432 & X, a = y(0);;){
                                    if (Z - t >> 2 >>> 0 <= g >>> 0) break e;
                                    if (X = c[(g << 2) + t >> 2], !(4194304 & (z = c[X + 24 >> 2]) | 131072 == (196608 & z))) {
                                        if (c[X + 548 >> 2] = S, e = Mr(X, i, V), R = Ur(X, i, V), t = c[w + 24 >> 2], B = (0 | g) == (0 | W) ? y(0) : G, e = y(e + R), T = ur(X, i, R = m[X + 308 >> 2], hr), t && !(!(y(B + y(e + y(a + T))) > F) | !Y)) break a;
                                        if (c[w + 24 >> 2] = t + 1, B = y(B + y(e + T)), m[w + 28 >> 2] = B + m[w + 28 >> 2], Dr(X)) {
                                            i: if (c[X + 552 >> 2]) {
                                                if ((e = m[X + 32 >> 2]) != e && (e = (e = m[X + 28 >> 2]) > y(0) ? e : y(0)), m[w + 32 >> 2] = e + m[w + 32 >> 2], (e = m[X + 36 >> 2]) == e) break i;
                                                if (f[X + 4 | 0] < 0) {
                                                    e = y(1);
                                                    break i;
                                                }
                                                if (e = y(0), !((T = m[X + 28 >> 2]) < y(0))) break i;
                                                e = y(-T);
                                            } else e = y(0), m[w + 32 >> 2] = m[w + 32 >> 2] + y(0);
                                            m[w + 36 >> 2] = m[w + 36 >> 2] - y(e * R);
                                        }
                                        if ((0 | (t = c[w + 48 >> 2])) == c[w + 52 >> 2]) {
                                            if ((Z = 1 + (z = (t = t - c[w + 44 >> 2] | 0) >> 2) | 0) >>> 0 >= 1073741824) break e;
                                            j = t >>> 1 | 0, z = pe(w + 360 | 0, t >>> 0 >= 2147483644 ? 1073741823 : Z >>> 0 < j >>> 0 ? j : Z, z, yr), c[c[w + 368 >> 2] >> 2] = X, c[w + 368 >> 2] = c[w + 368 >> 2] + 4, t = c[w + 44 >> 2], Z = c[w + 48 >> 2] - t | 0, Z = wr(c[w + 364 >> 2] - Z | 0, t, Z), t = c[w + 44 >> 2], c[w + 364 >> 2] = t, c[w + 44 >> 2] = Z, X = c[w + 368 >> 2], j = c[w + 372 >> 2], Z = c[w + 48 >> 2], c[w + 368 >> 2] = Z, tr = c[w + 52 >> 2], c[w + 48 >> 2] = X, c[w + 52 >> 2] = j, c[w + 372 >> 2] = tr, c[z >> 2] = t, (0 | t) != (0 | Z) && (c[w + 368 >> 2] = Z + (3 + (t - Z | 0) & -4)), t && gr(t);
                                        } else c[t >> 2] = X, c[w + 48 >> 2] = t + 4;
                                        t = c[r + 556 >> 2], Z = c[r + 560 >> 2], a = y(a + B);
                                    }
                                    if (!((g = g + 1 | 0) >>> 0 < Z - t >> 2 >>> 0)) break;
                                }
                                !((C = m[w + 32 >> 2]) > y(0)) | !(C < y(1)) || (c[w + 32 >> 2] = 1065353216, C = y(1)), !((x = m[w + 36 >> 2]) > y(0)) | !(x < y(1)) || (c[w + 36 >> 2] = 1065353216, x = y(1)), c[w + 40 >> 2] = g, _ = m[w + 28 >> 2], Y = c[w + 24 >> 2], D && gr(D), B = m[w + 56 >> 2], z = c[w + 48 >> 2], D = c[w + 44 >> 2];
                                a: {
                                    i: {
                                        n: {
                                            if (1 != (0 | cr)) {
                                                a = y(0), e = m[vr >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[vr >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (e == e) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], e = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        e = y(y(a * o) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    e = a;
                                                }
                                                a = y(0), G = m[r + 216 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 216 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (G == G) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], G = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        G = y(y(a * o) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    G = a;
                                                }
                                                a = y(0), R = m[r + 212 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 212 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (R == R) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], T = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        T = y(y(a * u) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    T = a;
                                                }
                                                a = y(0), R = m[r + 220 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 220 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (R == R) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], R = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        R = y(y(a * u) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    R = a;
                                                }
                                                if ((a = y(((i = O >>> 0 > 1) ? e : T) - ir)) == a & a > _) break n;
                                                if ((a = y((i ? G : R) - ir)) == a & a < _) break n;
                                                if (!v[c[r + 568 >> 2] + 11 | 0]) {
                                                    if (a = _, !c[r + 552 >> 2] | C == y(0)) break i;
                                                    t: {
                                                        if ((e = m[r + 32 >> 2]) != e) {
                                                            if (!((a = m[r + 28 >> 2]) > y(0))) break t;
                                                        } else a = e;
                                                        if (a != a) {
                                                            a = F;
                                                            break i;
                                                        }
                                                        e = m[r + 32 >> 2];
                                                    }
                                                    if (e != e && (a = _, !((e = m[r + 28 >> 2]) > y(0)))) break i;
                                                    if (a = F, e != y(0)) break i;
                                                    a = _;
                                                    break i;
                                                }
                                            }
                                            a = F;
                                        }
                                        if (a == a) {
                                            B = y(a - _);
                                            break a;
                                        }
                                    }
                                    _ < y(0) && (B = y(-_));
                                }
                                if (F = a, !qr) {
                                    if ((0 | D) != (0 | z)) {
                                        for(R = y(0), t = D;;){
                                            a = ur(i = c[t >> 2], O, _ = m[i + 308 >> 2], hr);
                                            a: if (B < y(0)) {
                                                if ((X = c[i + 552 >> 2]) ? (G = m[i + 36 >> 2]) != G && (f[i + 4 | 0] < 0 ? G = y(1) : (G = y(0), (e = m[i + 28 >> 2]) < y(0) && (G = y(-e)))) : G = y(0), !((e = y(a * y(-G))) > y(0) | e < y(0))) break a;
                                                if ((G = y(y(y(B / x) * e) + a)) != G | (e = (Z = (e = ur(i, O, G, F)) != e) | (T = y(y(Br(i, O, V) + zr(i, O)) + y(Tr(i, O, V) + Qr(i, O)))) != T ? Z ? T : e : Re(e, T)) != e | e == G) break a;
                                                e = y(e - a), X ? (a = m[i + 36 >> 2]) != a && (f[i + 4 | 0] < 0 ? a = y(1) : (a = y(0), (G = m[i + 28 >> 2]) < y(0) && (a = y(-G)))) : a = y(0), R = y(R + e), x = y(y(a * _) + x);
                                            } else !(B > y(0)) | !c[i + 552 >> 2] || ((G = m[i + 32 >> 2]) == G || (G = m[i + 28 >> 2]) > y(0)) && G < y(0) | G > y(0) && ((T = y(y(y(B / C) * G) + a)) != T | (e = (Z = (e = ur(i, O, T, F)) != e) | (_ = y(y(Br(i, O, V) + zr(i, O)) + y(Tr(i, O, V) + Qr(i, O)))) != _ ? Z ? _ : e : Re(e, _)) != e | e == T || (C = y(C - G), R = y(R + y(e - a))));
                                            if ((0 | z) == (0 | (t = t + 4 | 0))) break;
                                        }
                                        for(_ = y(B - R), Gr = y(_ / x), Zr = y(_ / C), Cr = !(j = fr & (!(12 & v[r + 26 | 0]) | ie)), tr = c[Q >> 2], T = y(0), Z = D;;){
                                            a = ur(t = c[Z >> 2], O, m[t + 308 >> 2], hr);
                                            a: {
                                                if (_ < y(0)) {
                                                    if (c[t + 552 >> 2] ? (e = m[t + 36 >> 2]) != e && (f[t + 4 | 0] < 0 ? e = y(1) : (e = y(0), (G = m[t + 28 >> 2]) < y(0) && (e = y(-G)))) : e = y(0), G = a, (e = y(a * y(-e))) == y(0)) break a;
                                                    e = x == y(0) ? y(a + e) : y(y(Gr * e) + a);
                                                } else {
                                                    if (G = a, !(_ > y(0)) | !c[t + 552 >> 2]) break a;
                                                    if ((e = m[t + 32 >> 2]) != e && !((e = m[t + 28 >> 2]) > y(0))) break a;
                                                    if (!(e < y(0) | e > y(0))) break a;
                                                    e = y(y(Zr * e) + a);
                                                }
                                                G = (i = (e = ur(t, O, e, F)) != e) | (G = y(y(Br(t, O, V) + zr(t, O)) + y(Tr(t, O, V) + Qr(t, O)))) != G ? i ? G : e : Re(e, G);
                                            }
                                            if (e = Mr(t, O, V), R = Ur(t, O, V), C = Mr(t, N, V), Sr = Ur(t, N, V), R = y(e + R), xr = y(G + R), m[w + 352 >> 2] = xr, c[w + 344 >> 2] = 1, C = y(C + Sr), (e = m[t + 224 >> 2]) != e) {
                                                e = m[572 + (X = t + (tr << 3) | 0) >> 2];
                                                a: {
                                                    i: {
                                                        n: {
                                                            t: {
                                                                f: {
                                                                    o: {
                                                                        c: {
                                                                            u: {
                                                                                if (rr) {
                                                                                    R = m[X + 572 >> 2];
                                                                                    b: {
                                                                                        s: {
                                                                                            A: {
                                                                                                switch(0 | (i = c[X + 576 >> 2])){
                                                                                                    case 0:
                                                                                                    case 3:
                                                                                                        break A;
                                                                                                }
                                                                                                if (!(1 != (0 | i) | e != e)) {
                                                                                                    if (!(j & R < y(0))) break b;
                                                                                                    break s;
                                                                                                }
                                                                                                if (!(Cr | !(R < y(0)) | 2 != (0 | i) | e != e)) break s;
                                                                                                break b;
                                                                                            }
                                                                                            if (!j) break b;
                                                                                        }
                                                                                        if ((X = c[t + 24 >> 2] >>> 13 & 7) || (X = c[r + 24 >> 2] >>> 10 & 7), 4 == (0 | X) && (ve(w + 24 | 0, t, N), 3 != c[w + 28 >> 2] && (de(w + 360 | 0, t, N), 3 != c[w + 364 >> 2]))) break u;
                                                                                    }
                                                                                    e = R;
                                                                                } else R = m[X + 572 >> 2], i = c[X + 576 >> 2];
                                                                                switch(0 | i){
                                                                                    case 0:
                                                                                    case 3:
                                                                                        break o;
                                                                                    default:
                                                                                        break c;
                                                                                }
                                                                            }
                                                                            c[w + 348 >> 2] = 1;
                                                                            break i;
                                                                        }
                                                                        if (!(1 != (0 | i) | e != e)) {
                                                                            if ((e = R) < y(0)) break o;
                                                                            break n;
                                                                        }
                                                                        if (2 != (0 | i) | e != e) break f;
                                                                        if (M == M && !(R < y(0))) break t;
                                                                    }
                                                                    c[w + 348 >> 2] = ae;
                                                                    break i;
                                                                }
                                                                e = y(NaN);
                                                                f: switch(i - 1 | 0){
                                                                    case 1:
                                                                        break t;
                                                                    case 0:
                                                                        break f;
                                                                    default:
                                                                        break n;
                                                                }
                                                                e = R;
                                                                break n;
                                                            }
                                                            e = y(y(M * R) * y(.009999999776482582));
                                                        }
                                                        e = y(C + e), m[w + 356 >> 2] = e, c[w + 348 >> 2] = (fr | 2 != (0 | i)) & e == e;
                                                        break a;
                                                    }
                                                    m[w + 356 >> 2] = M;
                                                }
                                                e = R;
                                            } else c[w + 348 >> 2] = 1, R = y(xr - R), m[w + 356 >> 2] = C + y(q ? R * e : R / e), R = m[572 + (X = t + (tr << 3) | 0) >> 2], i = c[X + 576 >> 2], e = m[X + 572 >> 2];
                                            Vr(t, O, F, V, w + 344 | 0, w + 352 | 0), Vr(t, N, M, V, w + 348 | 0, w + 356 | 0);
                                            a: {
                                                i: {
                                                    n: {
                                                        switch(0 | i){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (!(1 != (0 | i) | e != e)) {
                                                            if (R < y(0)) break n;
                                                            break i;
                                                        }
                                                        if (2 != (0 | i) | e != e) break i;
                                                        if (!(R < y(0)) && (X = 0, rr)) break a;
                                                    }
                                                    if (X = 0, (i = c[t + 24 >> 2] >>> 13 & 7) || (i = c[r + 24 >> 2] >>> 10 & 7), 4 != (0 | i)) break a;
                                                    if (ve(w + 24 | 0, t, N), 3 == c[w + 28 >> 2]) break a;
                                                    de(w + 360 | 0, t, N), X = 3 != c[w + 364 >> 2];
                                                    break a;
                                                }
                                                X = 0;
                                            }
                                            e = m[w + 352 >> 2], R = m[w + 356 >> 2], C = (i = O >>> 0 > 1) ? e : R, e = i ? R : e, _r = c[w + 344 >> 2], Kr = c[w + 348 >> 2], ne = i ? _r : Kr, _r = i ? Kr : _r, i = (1 ^ X) & s, or(t, C, e, 3 & v[r + 300 | 0], ne, _r, V, U, i, i ? 4 : 7, A, l, h, p), T = y(T + y(G - a));
                                            a: {
                                                if (4 & (i = v[r + 300 | 0])) X = 251 & i;
                                                else if (X = 251 & i, i = 0, !(4 & v[t + 300 | 0])) break a;
                                                i = 4;
                                            }
                                            if (f[r + 300 | 0] = i | X, (0 | z) == (0 | (Z = Z + 4 | 0))) break;
                                        }
                                    } else T = y(0);
                                    B = y(B - T);
                                }
                                i = v[r + 300 | 0], f[r + 300 | 0] = 251 & i | (B < y(0) ? 4 : 4 & i), R = y(Br(r, O, o) + zr(r, O)), Gr = y(Tr(r, O, o) + Qr(r, O)), _ = pr(r, O, o);
                                a: if (!(B > y(0)) | 2 != (0 | cr)) T = B;
                                else {
                                    T = y(0), a = y(0);
                                    i: {
                                        n: {
                                            i = vr + (c[dr >> 2] << 2) | 0, e = m[i >> 2];
                                            t: {
                                                if (!(t = 2139156720 == (0 | (i = c[i >> 2])))) {
                                                    if (Z = 2140081935 == (0 | i)) break n;
                                                    if ((X = 2141891242 == (0 | i)) | e != e) break a;
                                                    if (Z) break n;
                                                    if (X) break a;
                                                    if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break t;
                                                }
                                                a = y(y(hr * a) * y(.009999999776482582));
                                            }
                                            if (a != a) break a;
                                            a = y(0);
                                            t: if (!t) {
                                                if (2140081935 == (0 | i)) break n;
                                                t = 4276;
                                                f: {
                                                    if (2141891242 != (0 | i)) {
                                                        if (e == e) break f;
                                                        t = 4268;
                                                    }
                                                    switch(a = m[t >> 2], G = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                        case 0:
                                                            break n;
                                                        case 1:
                                                            break t;
                                                        default:
                                                            break i;
                                                    }
                                                }
                                                if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break n;
                                            }
                                            G = y(y(hr * a) * y(.009999999776482582));
                                            break i;
                                        }
                                        G = a;
                                    }
                                    if ((e = y(y(y(G - R) - Gr) - y(F - B))) != e) break a;
                                    T = Re(e, y(0));
                                }
                                a: {
                                    if (!(X = g >>> 0 <= W >>> 0)) {
                                        for(z = c[r + 556 >> 2], j = (i = c[r + 560 >> 2] - z >> 2) >>> 0 < W >>> 0 ? W : i, Z = 0, i = W;;){
                                            if ((0 | i) == (0 | j)) break e;
                                            if (t = c[z + (i << 2) >> 2], 131072 != (196608 & c[t + 24 >> 2]) && (ve(tr = w + 24 | 0, t, O), Cr = c[w + 28 >> 2], de(tr, t, O), Z = ((3 == (0 | Cr)) + Z | 0) + (3 == c[w + 28 >> 2]) | 0), (0 | g) == (0 | (i = i + 1 | 0))) break;
                                        }
                                        if (C = y(0), a = _, Z) break a;
                                    }
                                    C = y(0), Z = 0, a = _;
                                    i: switch((c[r + 24 >> 2] >>> 4 & 7) - 1 | 0){
                                        case 0:
                                            C = y(T * y(.5));
                                            break a;
                                        case 1:
                                            C = T;
                                            break a;
                                        case 2:
                                            if (Y >>> 0 < 2) break a;
                                            a = y(_ + y((fe = y(0), oe = Re(T, y(0)), ((te = T != T) ? fe : oe) / y(Y - 1 >>> 0))));
                                            break a;
                                        case 4:
                                            C = y(T / y(Y + 1 >>> 0)), a = y(_ + C);
                                            break a;
                                        case 3:
                                            break i;
                                        default:
                                            break a;
                                    }
                                    C = y(y(T * y(.5)) / y(Y >>> 0)), a = y(y(C + C) + _);
                                }
                                if (e = y(R + C), B = y(0), Y = Jr(r), X) a = y(0);
                                else {
                                    for(z = g - 1 | 0, Zr = y(T / y(0 | Z)), R = y(0), G = y(0), i = W;;){
                                        if (t = c[r + 556 >> 2], c[r + 560 >> 2] - t >> 2 >>> 0 <= i >>> 0) break e;
                                        Ar(w + 24 | 0, Z = (t = c[t + (i << 2) >> 2]) + 228 | 0, 320), a = y(a - ((0 | i) == (0 | z) ? _ : y(0)));
                                        a: if (!(4194304 & (j = c[t + 24 >> 2]))) {
                                            i: {
                                                if (131072 == (196608 & j)) {
                                                    if (!se(t, O)) break i;
                                                    if (!s) break a;
                                                    T = Lr(t, O, F), x = zr(r, O), Sr = Mr(t, O, V), m[Z + (c[$ >> 2] << 2) >> 2] = Sr + y(T + x);
                                                    break a;
                                                }
                                                if (ve(w + 360 | 0, t, O), e = y(e + (3 == c[w + 364 >> 2] ? Zr : y(-0))), s && (j = Z, Z = c[$ >> 2] << 2, m[j + Z >> 2] = e + m[Z + (w + 24 | 0) >> 2]), de(w + 360 | 0, t, O), e = y(e + (3 == c[w + 364 >> 2] ? Zr : y(-0))), !ee) {
                                                    e = y(e + y(y(a + y(Mr(t, O, V) + Ur(t, O, V))) + m[w + 104 >> 2])), B = M;
                                                    break a;
                                                }
                                                if (e = y(e + y(a + y(m[(Z = t + 516 | 0) + (c[dr >> 2] << 2) >> 2] + y(Mr(t, O, V) + Ur(t, O, V))))), Y) {
                                                    if (T = Wr(t), x = Mr(t, 0, V), T = y(T + x), x = y(y(m[t + 520 >> 2] + y(Mr(t, 0, V) + Ur(t, 0, V))) - T), R = (t = R != R) | T != T ? t ? T : R : Re(R, T), !((t = G != G) | x != x)) {
                                                        G = Re(G, x);
                                                        break a;
                                                    }
                                                    G = t ? x : G;
                                                    break a;
                                                }
                                                if (!((T = y(m[Z + (c[Q >> 2] << 2) >> 2] + y(Mr(t, N, V) + Ur(t, N, V)))) != T | (t = B != B))) {
                                                    B = Re(B, T);
                                                    break a;
                                                }
                                                B = t ? T : B;
                                                break a;
                                            }
                                            s && (t = c[$ >> 2] << 2, T = m[t + (w + 24 | 0) >> 2], te = t + Z | 0, fe = y(C + y(T + zr(r, O))), m[te >> 2] = fe);
                                        }
                                        if ((0 | g) == (0 | (i = i + 1 | 0))) break;
                                    }
                                    a = y(G + R);
                                }
                                if (R = Y ? a : B, T = M, $r || (a = (i = (a = ur(r, N, y(K + R), Er)) != a) | (G = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != G ? i ? G : a : Re(a, G), T = y(a - K)), a = (i = (a = ur(r, N, y(K + (re ? M : R)), Er)) != a) | (G = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != G ? i ? G : a : Re(a, G), G = y(a - K), !(X | !s)) for(;;){
                                    if (i = c[r + 556 >> 2], c[r + 560 >> 2] - i >> 2 >>> 0 <= W >>> 0) break e;
                                    i = c[i + (W << 2) >> 2];
                                    a: if (!(4194304 & (t = c[i + 24 >> 2]))) {
                                        if (131072 != (196608 & t)) {
                                            (t = t >>> 13 & 7) || (t = c[r + 24 >> 2] >>> 10 & 7);
                                            i: {
                                                n: {
                                                    if (5 != (0 | t)) {
                                                        if (4 == (0 | t) && (ve(w + 24 | 0, i, N), t = 4, 3 != c[w + 28 >> 2])) {
                                                            if (de(w + 360 | 0, i, N), Z = c[Q >> 2], 3 == c[w + 364 >> 2]) break n;
                                                            R = m[572 + (Z = i + (Z << 3) | 0) >> 2];
                                                            t: {
                                                                switch(0 | (t = c[Z + 576 >> 2])){
                                                                    case 0:
                                                                    case 3:
                                                                        break t;
                                                                }
                                                                if (!(1 != (0 | t) | (B = m[Z + 572 >> 2]) != B)) {
                                                                    if (a = P, R < y(0)) break t;
                                                                    break i;
                                                                }
                                                                if (a = P, rr & !(R < y(0)) | 2 != (0 | t) | B != B) break i;
                                                            }
                                                            R = m[516 + (i + (c[dr >> 2] << 2) | 0) >> 2], a = (a = m[i + 224 >> 2]) == a ? y(y(Mr(i, N, V) + Ur(i, N, V)) + y(q ? R * a : R / a)) : G, m[w + 360 >> 2] = a, te = w, fe = y(R + y(Mr(i, O, V) + Ur(i, O, V))), m[te + 24 >> 2] = fe, c[w + 356 >> 2] = 1, c[w + 352 >> 2] = 1, Vr(i, O, F, V, w + 356 | 0, w + 24 | 0), Vr(i, N, M, V, w + 352 | 0, w + 360 | 0), R = m[w + 360 >> 2], B = m[w + 24 >> 2], a = (t = O >>> 0 > 1) ? R : B, or(i, R = t ? B : R, a, J, !((t = 0 != (0 | nr) & 512 != (896 & c[r + 24 >> 2])) & q | R != R), (q | !t) & a == a, V, U, 1, 2, A, l, h, p), a = P;
                                                            break i;
                                                        }
                                                    } else t = 8 & c[r + 24 >> 2] ? 5 : 1;
                                                    Z = c[Q >> 2];
                                                }
                                                if (a = m[516 + ((Z << 2) + i | 0) >> 2], R = Mr(i, N, V), B = Ur(i, N, V), ve(w + 24 | 0, i, N), R = y(T - y(a + y(R + B))), 3 != c[w + 28 >> 2] || (de(w + 360 | 0, i, N), 3 != c[w + 364 >> 2])) {
                                                    if (de(w + 24 | 0, i, N), a = P, 3 != c[w + 28 >> 2]) {
                                                        if (ve(w + 24 | 0, i, N), 3 != c[w + 28 >> 2]) {
                                                            switch(t - 1 | 0){
                                                                case 1:
                                                                    a = y(P + y(R * y(.5)));
                                                                    break i;
                                                                case 0:
                                                                    break i;
                                                            }
                                                            a = y(P + R);
                                                        } else a = y(P + (fe = y(0), oe = Re(R, y(0)), (te = R != R) ? fe : oe));
                                                    }
                                                } else a = y(R * y(.5)), a = y(P + (fe = y(0), oe = Re(a, y(0)), (te = a != a) ? fe : oe));
                                            }
                                            i = i + (c[H >> 2] << 2) | 0, m[i + 228 >> 2] = a + y(br + m[i + 228 >> 2]);
                                        } else {
                                            if (t = c[H >> 2], se(i, N) && (a = y(y(Lr(i, N, M) + zr(r, N)) + Mr(i, N, V)), m[228 + (i + (t << 2) | 0) >> 2] = a, a == a)) break a;
                                            te = i + (t << 2) | 0, fe = y(zr(r, N) + Mr(i, N, V)), m[te + 228 >> 2] = fe;
                                        }
                                    }
                                    if ((0 | (W = W + 1 | 0)) == (0 | g)) break;
                                }
                                if (a = y((S ? jr : y(0)) + G), Nr = (i = Nr != Nr) | (e = y(Gr + e)) != e ? i ? e : Nr : Re(Nr, e), br = y(br + a), i = S + 1 | 0, W = g, !(g >>> 0 < er >>> 0)) break;
                            }
                            a: if (s && (nr || Jr(r))) {
                                R = y(0);
                                i: {
                                    n: if (M == M) {
                                        e = y(M - br);
                                        t: switch((c[r + 24 >> 2] >>> 7 & 7) - 2 | 0){
                                            case 0:
                                                P = y(P + y(e * y(.5)));
                                                break n;
                                            case 2:
                                                if (!(M > br)) break n;
                                                R = y(e / y(i >>> 0));
                                                break n;
                                            case 5:
                                                if (M > br) {
                                                    if (P = y(P + y(e / y(i << 1 >>> 0))), i >>> 0 < 2) break n;
                                                    R = y(e / y(i >>> 0));
                                                    break i;
                                                }
                                                P = y(P + y(e * y(.5)));
                                                break n;
                                            case 4:
                                                if (!(M > br) | i >>> 0 < 2) break n;
                                                R = y(e / y(S >>> 0));
                                                break i;
                                            case 1:
                                                break t;
                                            default:
                                                break n;
                                        }
                                        P = y(P + e);
                                    }
                                    if (!i) break a;
                                }
                                for(Z = 0, i = 0, t = 0;;){
                                    if (B = y(0), a = y(0), e = y(0), G = y(0), g = i, i >>> 0 < er >>> 0) {
                                        i: {
                                            for(;;){
                                                if (t = c[r + 556 >> 2], c[r + 560 >> 2] - t >> 2 >>> 0 <= g >>> 0) break e;
                                                if (W = c[t + (g << 2) >> 2], !(4194304 & (X = c[W + 24 >> 2]) | 131072 == (196608 & X))) {
                                                    if (t = g, c[W + 548 >> 2] != (0 | Z)) break i;
                                                    (e = m[516 + (W + (c[Q >> 2] << 2) | 0) >> 2]) >= y(0) && (a = (t = a != a) | (e = y(e + y(Mr(W, N, V) + Ur(W, N, V)))) != e ? t ? e : a : Re(a, e)), (t = X >>> 13 & 7) || (t = c[r + 24 >> 2] >>> 10 & 7), !(8 & v[r + 24 | 0]) | 5 != (0 | t) || (e = Wr(W), T = Mr(W, 0, V), e = y(e + T), T = y(y(m[W + 520 >> 2] + y(Mr(W, 0, V) + Ur(W, 0, V))) - e), t = a != a, G = (W = G != G) | e != e ? W ? e : G : Re(G, e), B = (W = B != B) | T != T ? W ? T : B : Re(B, T), a = t | (e = y(G + B)) != e ? t ? e : a : Re(a, e));
                                                }
                                                if ((0 | er) == (0 | (g = g + 1 | 0))) break;
                                            }
                                            t = er;
                                        }
                                        e = a;
                                    }
                                    if (T = y(P + (Z ? jr : y(0))), a = y(R + e), P = y(T + a), i >>> 0 < t >>> 0) for(_ = y(T + G);;){
                                        if (g = c[r + 556 >> 2], c[r + 560 >> 2] - g >> 2 >>> 0 <= i >>> 0) break e;
                                        W = c[g + (i << 2) >> 2];
                                        i: if (!(4194304 & (g = c[W + 24 >> 2]) | 131072 == (196608 & g))) {
                                            (g = g >>> 13 & 7) || (g = c[r + 24 >> 2] >>> 10 & 7);
                                            n: {
                                                t: switch(g - 1 | 0){
                                                    case 4:
                                                        if (8 & v[r + 24 | 0]) break n;
                                                    case 0:
                                                        e = Mr(W, N, V), m[228 + (W + (c[H >> 2] << 2) | 0) >> 2] = T + e;
                                                        break i;
                                                    case 2:
                                                        e = Ur(W, N, V), m[(g = W + 228 | 0) + (c[H >> 2] << 2) >> 2] = y(P - e) - m[288 + (g + (c[Q >> 2] << 2) | 0) >> 2];
                                                        break i;
                                                    case 1:
                                                        m[(g = W + 228 | 0) + (c[H >> 2] << 2) >> 2] = T + y(y(a - m[288 + (g + (c[Q >> 2] << 2) | 0) >> 2]) * y(.5));
                                                        break i;
                                                    case 3:
                                                        break t;
                                                    default:
                                                        break i;
                                                }
                                                e = Mr(W, N, V), m[228 + (W + (c[H >> 2] << 2) | 0) >> 2] = T + e, X = W + (c[Q >> 2] << 3) | 0, e = m[(g = X) + 572 >> 2];
                                                t: {
                                                    switch(0 | (g = c[g + 576 >> 2])){
                                                        case 0:
                                                        case 3:
                                                            break t;
                                                    }
                                                    if (!(1 != (0 | g) | (G = m[X + 572 >> 2]) != G)) {
                                                        if (e < y(0)) break t;
                                                        break i;
                                                    }
                                                    if (rr & !(e < y(0)) | 2 != (0 | g) | G != G) break i;
                                                }
                                                O >>> 0 >= 2 ? (B = a, e = m[W + 516 >> 2], G = y(e + y(Mr(W, O, V) + Ur(W, O, V)))) : (B = y(m[W + 520 >> 2] + y(Mr(W, N, V) + Ur(W, N, V))), e = m[W + 516 >> 2], G = a);
                                                t: {
                                                    f: {
                                                        if (!(G != G | e != e)) {
                                                            if (y(E(y(G - e))) < y(9999999747378752e-20)) break f;
                                                            break t;
                                                        }
                                                        if (G == G | e == e) break t;
                                                    }
                                                    if (!((g = (e = m[W + 520 >> 2]) != e) | B != B)) {
                                                        if (!(y(E(y(B - e))) < y(9999999747378752e-20))) break t;
                                                        break i;
                                                    }
                                                    if (B != B && g) break i;
                                                }
                                                or(W, G, B, J, 1, 1, V, U, 1, 3, A, l, h, p);
                                                break i;
                                            }
                                            te = W, fe = y(y(_ - Wr(W)) + Lr(W, 0, M)), m[te + 232 >> 2] = fe;
                                        }
                                        if ((0 | t) == (0 | (i = i + 1 | 0))) break;
                                    }
                                    if (g = (0 | Z) != (0 | S), Z = Z + 1 | 0, i = t, !g) break;
                                }
                            }
                            Z = r + 516 | 0, e = (i = (e = ur(r, 2, Yr, o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[Z >> 2] = e, e = (i = (e = ur(r, 0, Hr, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                            a: {
                                i: if (cr && 2 == (0 | (i = c[r + 24 >> 2] >>> 20 & 3)) | 2 != (0 | cr)) {
                                    if (2 != (0 | cr) | 2 != (0 | i)) break a;
                                    e = (i = (e = (i = (a = y(ir + F)) != a) | (e = ur(r, O, Nr, hr)) != e ? i ? e : a : ge(a, e)) != e) | ir != ir ? i ? ir : e : Re(e, ir);
                                } else {
                                    if (!((i = (e = ur(r, O, Nr, hr)) != e) | (a = y(y(Br(r, O, o) + zr(r, O)) + y(Tr(r, O, o) + Qr(r, O)))) != a)) {
                                        e = Re(e, a);
                                        break i;
                                    }
                                    e = i ? a : e;
                                }
                                m[Z + (c[dr >> 2] << 2) >> 2] = e;
                            }
                            a: {
                                i: if (L && (t = 2 != (0 | L)) | 2 == (0 | (i = c[r + 24 >> 2] >>> 20 & 3))) {
                                    if (t | 2 != (0 | i)) break a;
                                    e = (i = (e = (i = (a = y(K + M)) != a) | (e = ur(r, N, y(K + br), Er)) != e ? i ? e : a : ge(a, e)) != e) | K != K ? i ? K : e : Re(e, K);
                                } else {
                                    if (!((i = (e = ur(r, N, y(K + br), Er)) != e) | (a = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != a)) {
                                        e = Re(e, a);
                                        break i;
                                    }
                                    e = i ? a : e;
                                }
                                m[Z + (c[Q >> 2] << 2) >> 2] = e;
                            }
                            if (s) {
                                if (i = c[r + 560 >> 2], W = c[r + 556 >> 2], 524288 == (786432 & c[r + 24 >> 2])) {
                                    for(t = er >>> 0 <= 1 ? 1 : er, s = i - W >> 2, i = 0; g = 0, g = i >>> 0 < s >>> 0 ? c[(i << 2) + W >> 2] : g, 131072 != (196608 & c[g + 24 >> 2]) && (X = (g = g + 228 | 0) + (c[H >> 2] << 2) | 0, S = c[Q >> 2] << 2, m[X >> 2] = y(m[S + Z >> 2] - m[X >> 2]) - m[288 + (g + S | 0) >> 2]), (0 | t) != (0 | (i = i + 1 | 0)););
                                    W = c[r + 556 >> 2], i = c[r + 560 >> 2];
                                }
                                if ((0 | i) != (0 | W)) for(S = 0 != (0 | (O >>> 0 > 1 ? cr : n));;){
                                    s = c[W >> 2];
                                    a: if (131072 == (4390912 & c[s + 24 >> 2])) {
                                        a = V, F = U, v[c[r + 568 >> 2] + 21 | 0] && (F = m[r + 520 >> 2], a = m[r + 516 >> 2]), n = c[r + 24 >> 2] >>> 2 & 3;
                                        i: {
                                            n: {
                                                if (2 == (0 | J)) {
                                                    t = 0, g = 3;
                                                    t: switch(n - 2 | 0){
                                                        case 0:
                                                            break i;
                                                        case 1:
                                                            break t;
                                                        default:
                                                            break n;
                                                    }
                                                    g = 2;
                                                    break i;
                                                }
                                                if (t = 0, !(n >>> 0 <= 1)) {
                                                    g = n;
                                                    break i;
                                                }
                                            }
                                            g = n, t = lr;
                                        }
                                        u = y(Mr(s, 2, a) + Ur(s, 2, a)), R = Mr(s, 0, a), B = Ur(s, 0, a), e = m[s + 572 >> 2];
                                        i: {
                                            n: {
                                                switch(0 | (n = c[s + 576 >> 2])){
                                                    case 0:
                                                    case 3:
                                                        break n;
                                                }
                                                t: {
                                                    if (!(1 != (0 | n) | (o = m[s + 572 >> 2]) != o)) {
                                                        if (G = e, !(e < y(0))) break t;
                                                        break n;
                                                    }
                                                    f: {
                                                        if (2 != (0 | n) | o != o) {
                                                            G = y(NaN);
                                                            o: switch(n - 1 | 0){
                                                                case 1:
                                                                    break f;
                                                                case 0:
                                                                    break o;
                                                                default:
                                                                    break t;
                                                            }
                                                            G = e;
                                                            break t;
                                                        }
                                                        if (a != a | e < y(0)) break n;
                                                    }
                                                    G = y(y(a * e) * y(.009999999776482582));
                                                }
                                                G = y(u + G);
                                                break i;
                                            }
                                            G = y(NaN), se(s, 2) && be(s, 2) && (G = (n = (e = ur(s, 2, y(y(m[r + 516 >> 2] - y(zr(r, 2) + Qr(r, 2))) - y(Lr(s, 2, a) + Or(s, 2, a))), a)) != e) | (o = y(y(Br(s, 2, a) + zr(s, 2)) + y(Tr(s, 2, a) + Qr(s, 2)))) != o ? n ? o : e : Re(e, o));
                                        }
                                        B = y(R + B);
                                        i: {
                                            n: {
                                                t: {
                                                    f: {
                                                        o: {
                                                            c: {
                                                                u: {
                                                                    X = G != G, o = m[s + 580 >> 2];
                                                                    b: {
                                                                        s: {
                                                                            switch(0 | (n = c[s + 584 >> 2])){
                                                                                case 0:
                                                                                case 3:
                                                                                    break s;
                                                                            }
                                                                            A: {
                                                                                if (!(1 != (0 | n) | (e = m[s + 580 >> 2]) != e)) {
                                                                                    if (!((e = o) < y(0))) break A;
                                                                                    break s;
                                                                                }
                                                                                k: {
                                                                                    if (2 != (0 | n) | e != e) {
                                                                                        e = y(NaN);
                                                                                        l: switch(n - 1 | 0){
                                                                                            case 1:
                                                                                                break k;
                                                                                            case 0:
                                                                                                break l;
                                                                                            default:
                                                                                                break A;
                                                                                        }
                                                                                        e = o;
                                                                                        break A;
                                                                                    }
                                                                                    if (F != F | o < y(0)) break s;
                                                                                }
                                                                                e = y(y(F * o) * y(.009999999776482582));
                                                                            }
                                                                            e = y(B + e);
                                                                            break b;
                                                                        }
                                                                        if (!se(s, 0) || !be(s, 0)) {
                                                                            if (e = y(NaN), G == G) break u;
                                                                            break t;
                                                                        }
                                                                        e = (n = (e = ur(s, 0, y(y(m[r + 520 >> 2] - y(zr(r, 0) + Qr(r, 0))) - y(Lr(s, 0, F) + Or(s, 0, F))), F)) != e) | (o = y(y(Br(s, 0, a) + zr(s, 0)) + y(Tr(s, 0, a) + Qr(s, 0)))) != o ? n ? o : e : Re(e, o);
                                                                    }
                                                                    if ((0 | X) == (e != e | 0)) break o;
                                                                    if ((R = m[s + 224 >> 2]) != R) break o;
                                                                    if (G != G) {
                                                                        G = y(y(y(e - B) * R) + u);
                                                                        break o;
                                                                    }
                                                                    if (e == e) break o;
                                                                    break c;
                                                                }
                                                                if ((R = m[s + 224 >> 2]) != R) break f;
                                                            }
                                                            e = y(B + y(y(G - u) / R));
                                                        }
                                                        if (G != G) break t;
                                                        if (e == e) break i;
                                                    }
                                                    n = 0;
                                                    break n;
                                                }
                                                n = 1;
                                            }
                                            X = a > y(0), Y = n & S & g >>> 0 < 2, n ^= 1, or(s, o = Y && X ? a : G, e, J, Y && X ? 2 : n, e == e, o, e, 0, 6, A, l, h, p), G = y(m[s + 516 >> 2] + Ue(s, 2, a)), e = y(m[s + 520 >> 2] + Ue(s, 0, a));
                                        }
                                        or(s, G, e, J, 1, 1, G, e, 1, 1, A, l, h, p), u = (n = g >>> 0 < 2) ? a : F, X = c[r + 568 >> 2], o = v[X + 22 | 0] ? u : a;
                                        i: {
                                            if (!be(s, g) || se(s, g)) {
                                                if (se(s, g) | 16 != (112 & c[r + 24 >> 2])) {
                                                    if (se(s, g) | 32 != (112 & c[r + 24 >> 2])) {
                                                        if (!v[X + 21 | 0]) break i;
                                                        if (!se(s, g)) break i;
                                                        e = m[Z + (c[4252 + (g << 2) >> 2] << 2) >> 2], e = y(y(Lr(s, g, e) + zr(r, g)) + Mr(s, g, e));
                                                    } else n = c[4252 + (g << 2) >> 2] << 2, e = y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]);
                                                } else n = c[4252 + (g << 2) >> 2] << 2, e = y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) * y(.5));
                                            } else Y = c[4252 + (g << 2) >> 2] << 2, e = y(y(y(y(m[Y + Z >> 2] - m[516 + (s + Y | 0) >> 2]) - Qr(r, g)) - Ur(s, g, o)) - Or(s, g, n ? F : a));
                                            m[228 + (s + (c[4220 + (g << 2) >> 2] << 2) | 0) >> 2] = e;
                                        }
                                        i: if (!be(s, t) || se(s, t)) {
                                            if (se(s, t) || ((n = c[s + 24 >> 2] >>> 13 & 7) || (n = c[r + 24 >> 2] >>> 10 & 7), 2 != (0 | n))) {
                                                n: if (!se(s, t)) {
                                                    g = c[s + 24 >> 2] >>> 13 & 7, n = c[r + 24 >> 2];
                                                    t: {
                                                        if (!(5 != (0 | (g = g || n >>> 10 & 7)) | 8 & n)) {
                                                            if (524288 == (786432 & n)) break t;
                                                            break n;
                                                        }
                                                        if ((524288 == (786432 & n) | 0) == (3 == (0 | g) | 0)) break n;
                                                    }
                                                    n = c[4252 + (t << 2) >> 2] << 2, e = y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]);
                                                    break i;
                                                }
                                                if (!v[X + 21 | 0]) break a;
                                                if (!se(s, t)) break a;
                                                e = m[Z + (c[4252 + (t << 2) >> 2] << 2) >> 2], e = y(y(Lr(s, t, e) + zr(r, t)) + Mr(s, t, e));
                                            } else n = c[4252 + (t << 2) >> 2] << 2, e = y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) * y(.5));
                                        } else n = c[4252 + (t << 2) >> 2] << 2, e = y(y(y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) - Qr(r, t)) - Ur(s, t, o)) - Or(s, t, u));
                                        m[228 + (s + (c[4220 + (t << 2) >> 2] << 2) | 0) >> 2] = e;
                                    }
                                    if ((0 | (W = W + 4 | 0)) == (0 | i)) break;
                                }
                                if (1 & (N | O)) for(t = 1 & N, s = 1 & O, A = er >>> 0 <= 1 ? 1 : er, l = 4236 + (N << 2) | 0, h = 4236 + (O << 2) | 0, p = c[r + 556 >> 2], N = c[r + 560 >> 2] - p >> 2, i = 0;;){
                                    if ((0 | i) == (0 | N)) break e;
                                    if (r = c[p + (i << 2) >> 2], 64 & v[r + 26 | 0] || (s && (n = r + 228 | 0, g = c[dr >> 2] << 2, m[n + (c[h >> 2] << 2) >> 2] = y(m[g + Z >> 2] - m[288 + (n + g | 0) >> 2]) - m[n + (c[$ >> 2] << 2) >> 2]), t && (r = r + 228 | 0, n = c[Q >> 2] << 2, m[r + (c[l >> 2] << 2) >> 2] = y(m[n + Z >> 2] - m[288 + (r + n | 0) >> 2]) - m[r + (c[H >> 2] << 2) >> 2])), (0 | A) == (0 | (i = i + 1 | 0))) break;
                                }
                            }
                            if (!D) break r;
                            gr(D);
                            break r;
                        }
                        I(), k();
                    }
                    ar = w + 384 | 0;
                }
                function tr() {
                    var r = 0, e = 0;
                    T(6952, 6953, 6954, 0, 4284, 17, 4287, 0, 4287, 0, 2528, 4289, 18), r = ye(8), c[r >> 2] = 8, c[r + 4 >> 2] = 1, Z(6952, 2873, 6, 4304, 4328, 19, 0 | r, 1), T(6956, 6957, 6958, 6952, 4284, 20, 4284, 21, 4284, 22, 2e3, 4289, 23), r = ye(4), c[r >> 2] = 24, Z(6956, 2358, 2, 4336, 4344, 25, 0 | r, 0), V(6952, 1397, 2, 4348, 4356, 26, 27), V(6952, 2978, 3, 4436, 4448, 28, 29), T(6976, 6977, 6978, 0, 4284, 30, 4287, 0, 4287, 0, 2544, 4289, 31), r = ye(8), c[r >> 2] = 8, c[r + 4 >> 2] = 1, Z(6976, 3244, 2, 4456, 4344, 32, 0 | r, 1), T(6979, 6980, 6981, 6976, 4284, 33, 4284, 34, 4284, 35, 2023, 4289, 36), r = ye(4), c[r >> 2] = 37, Z(6979, 2358, 2, 4464, 4344, 38, 0 | r, 0), V(6976, 1397, 2, 4472, 4356, 39, 40), V(6976, 2978, 3, 4436, 4448, 28, 41), T(6982, 6983, 6984, 0, 4284, 42, 4287, 0, 4287, 0, 2812, 4289, 43), Y(6982, 1, 4520, 4284, 44, 45), V(6982, 2866, 1, 4520, 4284, 44, 45), V(6982, 1128, 2, 4524, 4344, 46, 47), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 48, Z(6982, 3185, 4, 4544, 4560, 49, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 50, Z(6982, 1980, 3, 4568, 4580, 51, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 52, Z(6982, 1951, 3, 4588, 4600, 53, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 54, Z(6982, 1799, 3, 4588, 4600, 53, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 55, Z(6982, 3215, 3, 4608, 4448, 56, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 57, Z(6982, 1925, 2, 4620, 4356, 58, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 59, Z(6982, 1784, 2, 4620, 4356, 58, 0 | r, 0), F(6985, 1270, 4628, 60, 4289, 61), Be(1731, 0), Be(1611, 8), Be(2144, 16), Be(2454, 24), Be(2560, 32), Be(1617, 40), _(6985), F(6955, 2849, 4628, 62, 4289, 63), Ve(2560, 0), Ve(1617, 8), _(6955), F(6986, 2860, 4628, 64, 4289, 65), r = ye(4), c[r >> 2] = 8, e = ye(4), c[e >> 2] = 8, O(6986, 2854, 7018, 4630, 66, 0 | r, 7018, 4634, 67, 0 | e), r = ye(4), c[r >> 2] = 0, e = ye(4), c[e >> 2] = 0, O(6986, 1606, 7011, 4356, 68, 0 | r, 7011, 4600, 69, 0 | e), _(6986), T(6987, 6988, 6989, 0, 4284, 70, 4287, 0, 4287, 0, 2973, 4289, 71), Y(6987, 1, 4640, 4284, 72, 73), V(6987, 1592, 1, 4640, 4284, 72, 73), V(6987, 2802, 2, 4644, 4356, 74, 75), V(6987, 1128, 2, 4652, 4344, 76, 77), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 78, Z(6987, 1752, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 80, Z(6987, 2956, 3, 4660, 4600, 81, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 82, Z(6987, 2881, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 84, Z(6987, 2334, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 86, Z(6987, 1484, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 87, Z(6987, 1355, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 88, Z(6987, 1817, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 89, Z(6987, 2823, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 90, Z(6987, 2378, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 91, Z(6987, 2163, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 92, Z(6987, 1319, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 93, Z(6987, 2412, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 94, Z(6987, 1503, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 95, Z(6987, 2235, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 96, Z(6987, 1219, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 97, Z(6987, 1136, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 98, Z(6987, 1158, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 100, Z(6987, 1845, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 101, Z(6987, 1464, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 102, Z(6987, 2218, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 103, Z(6987, 1195, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 104, Z(6987, 2500, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 105, Z(6987, 2590, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 106, Z(6987, 1539, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 107, Z(6987, 2249, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 108, Z(6987, 1650, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 109, Z(6987, 1427, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 110, Z(6987, 2204, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 111, Z(6987, 2608, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 112, Z(6987, 1555, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 113, Z(6987, 1670, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 114, Z(6987, 1444, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 115, Z(6987, 2566, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 116, Z(6987, 1520, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 117, Z(6987, 1624, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 118, Z(6987, 1407, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 119, Z(6987, 2304, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 120, Z(6987, 2092, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 121, Z(6987, 2718, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 122, Z(6987, 1574, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 123, Z(6987, 2187, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 124, Z(6987, 2897, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 126, Z(6987, 2346, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 128, Z(6987, 1371, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 129, Z(6987, 1831, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 130, Z(6987, 2836, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 131, Z(6987, 2395, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 132, Z(6987, 2175, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 133, Z(6987, 1337, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 134, Z(6987, 2422, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 135, Z(6987, 1858, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 137, Z(6987, 1207, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 139, Z(6987, 2514, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 140, Z(6987, 2599, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 141, Z(6987, 1660, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 142, Z(6987, 2620, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 143, Z(6987, 1683, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 144, Z(6987, 2578, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 145, Z(6987, 1637, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 146, Z(6987, 2319, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 147, Z(6987, 2102, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 149, Z(6987, 1231, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 150, Z(6987, 1147, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 151, Z(6987, 2729, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 152, Z(6987, 2194, 3, 4780, 4792, 153, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 154, Z(6987, 2985, 4, 4800, 4560, 155, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 156, Z(6987, 3006, 3, 4816, 4600, 157, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 158, Z(6987, 1292, 2, 4828, 4356, 159, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 160, Z(6987, 1387, 2, 4836, 4356, 161, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 162, Z(6987, 2997, 3, 4844, 4448, 163, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 164, Z(6987, 2913, 2, 4856, 4356, 165, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 166, Z(6987, 2933, 3, 4864, 4600, 167, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 168, Z(6987, 3308, 3, 4876, 4600, 169, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 170, Z(6987, 3306, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 171, Z(6987, 3325, 3, 4888, 4600, 172, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 173, Z(6987, 3323, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 174, Z(6987, 1118, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 175, Z(6987, 1110, 2, 4900, 4356, 176, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 177, Z(6987, 1243, 5, 4912, 4932, 178, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 179, Z(6987, 1736, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 180, Z(6987, 1714, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 181, Z(6987, 2148, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 182, Z(6987, 2461, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 183, Z(6987, 2632, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 184, Z(6987, 1696, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 185, Z(6987, 1259, 2, 4940, 4356, 186, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 187, Z(6987, 2432, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 188, Z(6987, 2112, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 189, Z(6987, 2740, 3, 4760, 4772, 148, 0 | r, 0);
                }
                function fr(r, e, a, i, n, t, u) {
                    var b, s, A, k = 0, l = 0, d = 0, h = 0, p = 0, m = 0, y = 0, E = 0, G = 0, R = 0, g = 0, Z = 0, W = 0, V = 0, B = 0, T = 0, I = 0;
                    ar = b = ar - 80 | 0, c[b + 76 >> 2] = e, A = b + 55 | 0, s = b + 56 | 0;
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: for(;;){
                                        if (d = e, (2147483647 ^ E) < (0 | k)) break i;
                                        E = k + E | 0;
                                        t: {
                                            f: {
                                                o: {
                                                    if (l = v[0 | (k = d)]) for(;;){
                                                        c: {
                                                            u: if (e = 255 & l) {
                                                                if (37 != (0 | e)) break c;
                                                                for(l = k;;){
                                                                    if (37 != v[l + 1 | 0]) {
                                                                        e = l;
                                                                        break u;
                                                                    }
                                                                    if (k = k + 1 | 0, h = v[l + 2 | 0], l = e = l + 2 | 0, 37 != (0 | h)) break;
                                                                }
                                                            } else e = k;
                                                            if ((0 | (k = k - d | 0)) > (0 | (B = 2147483647 ^ E))) break i;
                                                            if (r && Pr(r, d, k), k) continue n;
                                                            c[b + 76 >> 2] = e, k = e + 1 | 0, R = -1, !xe(l = f[e + 1 | 0]) | 36 != v[e + 2 | 0] || (R = l - 48 | 0, Z = 1, k = e + 3 | 0), c[b + 76 >> 2] = k, y = 0;
                                                            u: if ((e = (l = f[0 | k]) - 32 | 0) >>> 0 > 31) h = k;
                                                            else if (h = k, 75913 & (e = 1 << e)) for(;;){
                                                                if (h = k + 1 | 0, c[b + 76 >> 2] = h, y |= e, (e = (l = f[k + 1 | 0]) - 32 | 0) >>> 0 >= 32) break u;
                                                                if (k = h, !(75913 & (e = 1 << e))) break;
                                                            }
                                                            u: if (42 != (0 | l)) {
                                                                if ((0 | (G = he(b + 76 | 0))) < 0) break i;
                                                                l = c[b + 76 >> 2];
                                                            } else {
                                                                if (!xe(e = f[h + 1 | 0]) | 36 != v[h + 2 | 0]) {
                                                                    if (Z) break o;
                                                                    if (l = h + 1 | 0, !r) {
                                                                        c[b + 76 >> 2] = l, Z = 0, G = 0;
                                                                        break u;
                                                                    }
                                                                    e = c[a >> 2], c[a >> 2] = e + 4, Z = 0, G = c[e >> 2];
                                                                } else c[((e << 2) + n | 0) - 192 >> 2] = 10, l = h + 3 | 0, Z = 1, G = c[((f[h + 1 | 0] << 3) + i | 0) - 384 >> 2];
                                                                if (c[b + 76 >> 2] = l, (0 | G) >= 0) break u;
                                                                G = 0 - G | 0, y |= 8192;
                                                            }
                                                            if (k = 0, m = -1, 46 == v[0 | l]) {
                                                                if (42 != v[l + 1 | 0]) c[b + 76 >> 2] = l + 1, m = he(b + 76 | 0), e = c[b + 76 >> 2], g = 1;
                                                                else {
                                                                    if (!xe(e = f[l + 2 | 0]) | 36 != v[l + 3 | 0]) {
                                                                        if (Z) break o;
                                                                        e = l + 2 | 0, m = 0, r && (l = c[a >> 2], c[a >> 2] = l + 4, m = c[l >> 2]);
                                                                    } else c[((e << 2) + n | 0) - 192 >> 2] = 10, e = l + 4 | 0, m = c[((f[l + 2 | 0] << 3) + i | 0) - 384 >> 2];
                                                                    c[b + 76 >> 2] = e, g = (-1 ^ m) >>> 31 | 0;
                                                                }
                                                            } else e = l, g = 0;
                                                            for(;;){
                                                                if (p = k, h = 28, W = e, (k = f[0 | e]) - 123 >>> 0 < 4294967238) break a;
                                                                if (e = W + 1 | 0, !((k = v[4895 + (k + w(p, 58) | 0) | 0]) - 1 >>> 0 < 8)) break;
                                                            }
                                                            c[b + 76 >> 2] = e;
                                                            u: {
                                                                b: {
                                                                    if (27 != (0 | k)) {
                                                                        if (!k) break a;
                                                                        if ((0 | R) >= 0) {
                                                                            c[(R << 2) + n >> 2] = k, l = c[4 + (k = (R << 3) + i | 0) >> 2], c[b + 64 >> 2] = c[k >> 2], c[b + 68 >> 2] = l;
                                                                            break b;
                                                                        }
                                                                        if (!r) break t;
                                                                        yr(b - -64 | 0, k, a, u);
                                                                        break u;
                                                                    }
                                                                    if ((0 | R) >= 0) break a;
                                                                }
                                                                if (k = 0, !r) continue n;
                                                            }
                                                            l = -65537 & y, y = 8192 & y ? l : y, R = 0, V = 1166, h = s;
                                                            u: {
                                                                b: {
                                                                    s: {
                                                                        A: {
                                                                            k: {
                                                                                l: {
                                                                                    d: {
                                                                                        v: {
                                                                                            h: {
                                                                                                p: {
                                                                                                    m: {
                                                                                                        N: {
                                                                                                            w: {
                                                                                                                y: {
                                                                                                                    E: {
                                                                                                                        switch(k = f[0 | W], (k = p && 3 == (15 & k) ? -33 & k : k) - 88 | 0){
                                                                                                                            case 11:
                                                                                                                                break u;
                                                                                                                            case 9:
                                                                                                                            case 13:
                                                                                                                            case 14:
                                                                                                                            case 15:
                                                                                                                                break b;
                                                                                                                            case 27:
                                                                                                                                break d;
                                                                                                                            case 12:
                                                                                                                            case 17:
                                                                                                                                break p;
                                                                                                                            case 23:
                                                                                                                                break m;
                                                                                                                            case 0:
                                                                                                                            case 32:
                                                                                                                                break N;
                                                                                                                            case 24:
                                                                                                                                break w;
                                                                                                                            case 22:
                                                                                                                                break y;
                                                                                                                            case 29:
                                                                                                                                break E;
                                                                                                                            case 1:
                                                                                                                            case 2:
                                                                                                                            case 3:
                                                                                                                            case 4:
                                                                                                                            case 5:
                                                                                                                            case 6:
                                                                                                                            case 7:
                                                                                                                            case 8:
                                                                                                                            case 10:
                                                                                                                            case 16:
                                                                                                                            case 18:
                                                                                                                            case 19:
                                                                                                                            case 20:
                                                                                                                            case 21:
                                                                                                                            case 25:
                                                                                                                            case 26:
                                                                                                                            case 28:
                                                                                                                            case 30:
                                                                                                                            case 31:
                                                                                                                                break f;
                                                                                                                        }
                                                                                                                        switch(k - 65 | 0){
                                                                                                                            case 0:
                                                                                                                            case 4:
                                                                                                                            case 5:
                                                                                                                            case 6:
                                                                                                                                break b;
                                                                                                                            case 2:
                                                                                                                                break k;
                                                                                                                            case 1:
                                                                                                                            case 3:
                                                                                                                                break f;
                                                                                                                        }
                                                                                                                        if (83 == (0 | k)) break l;
                                                                                                                        break f;
                                                                                                                    }
                                                                                                                    l = c[b + 64 >> 2], p = c[b + 68 >> 2], k = 1166;
                                                                                                                    break h;
                                                                                                                }
                                                                                                                k = 0;
                                                                                                                y: switch(255 & p){
                                                                                                                    case 0:
                                                                                                                    case 1:
                                                                                                                    case 6:
                                                                                                                        c[c[b + 64 >> 2] >> 2] = E;
                                                                                                                        continue n;
                                                                                                                    case 2:
                                                                                                                        d = c[b + 64 >> 2], c[d >> 2] = E, c[d + 4 >> 2] = E >> 31;
                                                                                                                        continue n;
                                                                                                                    case 3:
                                                                                                                        o[c[b + 64 >> 2] >> 1] = E;
                                                                                                                        continue n;
                                                                                                                    case 4:
                                                                                                                        f[c[b + 64 >> 2]] = E;
                                                                                                                        continue n;
                                                                                                                    case 7:
                                                                                                                        break y;
                                                                                                                    default:
                                                                                                                        continue n;
                                                                                                                }
                                                                                                                d = c[b + 64 >> 2], c[d >> 2] = E, c[d + 4 >> 2] = E >> 31;
                                                                                                                continue n;
                                                                                                            }
                                                                                                            m = m >>> 0 <= 8 ? 8 : m, y |= 8, k = 120;
                                                                                                        }
                                                                                                        if (d = s, (l = c[b + 64 >> 2]) | (p = c[b + 68 >> 2])) for(T = 32 & k; f[0 | (d = d - 1 | 0)] = T | v[5424 + (15 & l) | 0], I = !p & l >>> 0 > 15 | 0 != (0 | p), W = p, p = p >>> 4 | 0, l = (15 & W) << 28 | l >>> 4, I;);
                                                                                                        if (!(8 & y) | !(c[b + 64 >> 2] | c[b + 68 >> 2])) break v;
                                                                                                        V = 1166 + (k >>> 4 | 0) | 0, R = 2;
                                                                                                        break v;
                                                                                                    }
                                                                                                    if (k = s, p = d = c[b + 68 >> 2], d | (l = c[b + 64 >> 2])) for(; f[0 | (k = k - 1 | 0)] = 7 & l | 48, W = !p & l >>> 0 > 7 | 0 != (0 | p), p = (d = p) >>> 3 | 0, l = (7 & d) << 29 | l >>> 3, W;);
                                                                                                    if (d = k, !(8 & y)) break v;
                                                                                                    m = (0 | (k = s - d | 0)) < (0 | m) ? m : k + 1 | 0;
                                                                                                    break v;
                                                                                                }
                                                                                                l = c[b + 64 >> 2], p = k = c[b + 68 >> 2], (0 | k) < 0 ? (p = d = 0 - (p + (0 != (0 | l)) | 0) | 0, l = 0 - l | 0, c[b + 64 >> 2] = l, c[b + 68 >> 2] = d, R = 1, k = 1166) : 2048 & y ? (R = 1, k = 1167) : k = (R = 1 & y) ? 1168 : 1166;
                                                                                            }
                                                                                            V = k, d = re(l, p, s);
                                                                                        }
                                                                                        if ((0 | m) < 0 && g) break i;
                                                                                        if (y = g ? -65537 & y : y, !(0 != ((k = c[b + 64 >> 2]) | (l = c[b + 68 >> 2])) | m)) {
                                                                                            d = s, m = 0;
                                                                                            break f;
                                                                                        }
                                                                                        m = (0 | (k = !(k | l) + (s - d | 0) | 0)) < (0 | m) ? m : k;
                                                                                        break f;
                                                                                    }
                                                                                    y = 0, h = 0 != (0 | (p = g = m >>> 0 >= 2147483647 ? 2147483647 : m));
                                                                                    d: {
                                                                                        v: {
                                                                                            h: {
                                                                                                p: {
                                                                                                    m: if (!((k = d = (k = c[b + 64 >> 2]) || 4208, false) | !p)) for(;;){
                                                                                                        if (!(y = v[0 | k])) break p;
                                                                                                        if (h = 0 != (0 | (p = p - 1 | 0)), !(3 & (k = k + 1 | 0))) break m;
                                                                                                        if (!p) break;
                                                                                                    }
                                                                                                    if (!h) break v;
                                                                                                    m: {
                                                                                                        if (!(!v[0 | k] | p >>> 0 < 4)) for(;;){
                                                                                                            if ((-1 ^ (h = c[k >> 2])) & h - 16843009 & -2139062144) break m;
                                                                                                            if (k = k + 4 | 0, !((p = p - 4 | 0) >>> 0 > 3)) break;
                                                                                                        }
                                                                                                        if (!p) break v;
                                                                                                    }
                                                                                                    h = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                h = 1;
                                                                                            }
                                                                                            for(;;)if (h) {
                                                                                                if (!y) break d;
                                                                                                if (k = k + 1 | 0, !(p = p - 1 | 0)) break v;
                                                                                                h = 0;
                                                                                            } else y = v[0 | k], h = 1;
                                                                                        }
                                                                                        k = 0;
                                                                                    }
                                                                                    if (h = (k = k ? k - d | 0 : g) + d | 0, (0 | m) >= 0) {
                                                                                        y = l, m = k;
                                                                                        break f;
                                                                                    }
                                                                                    if (y = l, m = k, v[0 | h]) break i;
                                                                                    break f;
                                                                                }
                                                                                if (m) {
                                                                                    l = c[b + 64 >> 2];
                                                                                    break A;
                                                                                }
                                                                                k = 0, le(r, 32, G, 0, y);
                                                                                break s;
                                                                            }
                                                                            c[b + 12 >> 2] = 0, c[b + 8 >> 2] = c[b + 64 >> 2], l = b + 8 | 0, c[b + 64 >> 2] = l, m = -1;
                                                                        }
                                                                        k = 0;
                                                                        A: {
                                                                            for(;;){
                                                                                if (!(d = c[l >> 2])) break A;
                                                                                if (!((h = (0 | (d = We(b + 4 | 0, d))) < 0) | d >>> 0 > m - k >>> 0)) {
                                                                                    if (l = l + 4 | 0, m >>> 0 > (k = k + d | 0) >>> 0) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            if (h) break e;
                                                                        }
                                                                        if (h = 61, (0 | k) < 0) break a;
                                                                        if (le(r, 32, G, k, y), k) for(h = 0, l = c[b + 64 >> 2];;){
                                                                            if (!(d = c[l >> 2])) break s;
                                                                            if ((h = (d = We(b + 4 | 0, d)) + h | 0) >>> 0 > k >>> 0) break s;
                                                                            if (Pr(r, b + 4 | 0, d), l = l + 4 | 0, !(k >>> 0 > h >>> 0)) break;
                                                                        }
                                                                        else k = 0;
                                                                    }
                                                                    le(r, 32, G, k, 8192 ^ y), k = (0 | k) < (0 | G) ? G : k;
                                                                    continue n;
                                                                }
                                                                if ((0 | m) < 0 && g) break i;
                                                                if (h = 61, (0 | (k = 0 | aa[0 | t](r, N[b + 64 >> 3], G, m, y, k))) >= 0) continue n;
                                                                break a;
                                                            }
                                                            f[b + 55 | 0] = c[b + 64 >> 2], m = 1, d = A, y = l;
                                                            break f;
                                                        }
                                                        l = v[k + 1 | 0], k = k + 1 | 0;
                                                    }
                                                    if (r) break r;
                                                    if (!Z) break t;
                                                    for(k = 1;;){
                                                        if (r = c[(k << 2) + n >> 2]) {
                                                            if (yr((k << 3) + i | 0, r, a, u), E = 1, 10 != (0 | (k = k + 1 | 0))) continue;
                                                            break r;
                                                        }
                                                        break;
                                                    }
                                                    if (E = 1, k >>> 0 >= 10) break r;
                                                    for(;;){
                                                        if (c[(k << 2) + n >> 2]) break o;
                                                        if (10 == (0 | (k = k + 1 | 0))) break;
                                                    }
                                                    break r;
                                                }
                                                h = 28;
                                                break a;
                                            }
                                            if ((0 | (m = (0 | m) > (0 | (p = h - d | 0)) ? m : p)) > (2147483647 ^ R)) break i;
                                            if (h = 61, (0 | B) < (0 | (k = (0 | (l = m + R | 0)) < (0 | G) ? G : l))) break a;
                                            le(r, 32, k, l, y), Pr(r, V, R), le(r, 48, k, l, 65536 ^ y), le(r, 48, m, p, 0), Pr(r, d, p), le(r, 32, k, l, 8192 ^ y);
                                            continue;
                                        }
                                        break;
                                    }
                                    E = 0;
                                    break r;
                                }
                                h = 61;
                            }
                            c[1761] = h;
                        }
                        E = -1;
                    }
                    return ar = b + 80 | 0, E;
                }
                function or(r, e, a, i, n, t, o, u, b, s, A, k, l, d) {
                    var h, N = y(0), G = 0, R = 0, g = 0, Z = y(0), W = 0, V = 0, B = y(0);
                    (c[r + 312 >> 2] != (0 | d) && 4 & v[r + 4 | 0] || (W = 0, c[r + 316 >> 2] != (0 | i))) && (c[r + 540 >> 2] = -1082130432, c[r + 544 >> 2] = -1082130432, c[r + 532 >> 2] = 0, c[r + 536 >> 2] = 0, c[r + 524 >> 2] = -1082130432, c[r + 528 >> 2] = -1082130432, c[r + 320 >> 2] = 0, W = 1), h = l + 1 | 0;
                    r: {
                        e: {
                            a: {
                                i: if (c[r + 8 >> 2]) {
                                    if (Z = Mr(r, 2, o), B = Ur(r, 2, o), N = y(Mr(r, 0, o) + Ur(r, 0, o)), l = r + 524 | 0, Z = y(Z + B), lr(n, e, t, a, c[r + 532 >> 2], m[l >> 2], c[r + 536 >> 2], m[r + 528 >> 2], m[r + 540 >> 2], m[r + 544 >> 2], Z, N, A)) break a;
                                    if (!(R = c[r + 320 >> 2])) break i;
                                    for(G = r + 324 | 0;;){
                                        if (l = G + w(g, 24) | 0, lr(n, e, t, a, c[l + 8 >> 2], m[l >> 2], c[l + 12 >> 2], m[l + 4 >> 2], m[l + 16 >> 2], m[l + 20 >> 2], Z, N, A)) break a;
                                        if ((0 | R) == (0 | (g = g + 1 | 0))) break;
                                    }
                                } else {
                                    if (b) {
                                        n: {
                                            if (!((N = m[(l = r + 524 | 0) >> 2]) != N | e != e)) {
                                                if (y(E(y(N - e))) < y(9999999747378752e-20)) break n;
                                                break i;
                                            }
                                            if (N == N | e == e) break i;
                                        }
                                        G = c[r + 532 >> 2] == (0 | n) && c[r + 536 >> 2] == (0 | t) ? l : 0, (l = (N = m[r + 528 >> 2]) != N) | (R = a != a) ? l &= R : l = y(E(y(N - a))) < y(9999999747378752e-20), l = l ? G : 0;
                                        break a;
                                    }
                                    if (!(V = c[r + 320 >> 2])) break i;
                                    for(R = r + 324 | 0;;){
                                        G = w(g, 24);
                                        n: {
                                            t: {
                                                if (!((N = m[(l = G + R | 0) >> 2]) != N | e != e)) {
                                                    if (y(E(y(N - e))) < y(9999999747378752e-20)) break t;
                                                    break n;
                                                }
                                                if (N == N | e == e) break n;
                                            }
                                            t: {
                                                if (!((N = m[4 + (G = R + G | 0) >> 2]) != N | a != a)) {
                                                    if (y(E(y(N - a))) < y(9999999747378752e-20)) break t;
                                                    break n;
                                                }
                                                if (N == N | a == a) break n;
                                            }
                                            if (c[G + 8 >> 2] == (0 | n) && c[G + 12 >> 2] == (0 | t)) break a;
                                        }
                                        if ((0 | V) == (0 | (g = g + 1 | 0))) break;
                                    }
                                }
                                nr(r, e, a, i, n, t, o, u, b, A, k, h, d, s), c[r + 316 >> 2] = i;
                                break e;
                            }
                            if (!(!l | W)) {
                                m[r + 516 >> 2] = m[l + 16 >> 2], m[r + 520 >> 2] = m[l + 20 >> 2], c[(i = (b ? 12 : 16) + k | 0) >> 2] = c[i >> 2] + 1, i = 0;
                                break r;
                            }
                            if (nr(r, e, a, i, n, t, o, u, b, A, k, h, d, s), c[r + 316 >> 2] = i, i = 1, l) break r;
                        }
                        (i = (l = c[r + 320 >> 2]) + 1 | 0) >>> 0 > p[k + 8 >> 2] && (c[k + 8 >> 2] = i), 8 == (0 | l) && (c[r + 320 >> 2] = 0, l = 0), b ? i = r + 524 | 0 : (c[r + 320 >> 2] = l + 1, i = 324 + (w(l, 24) + r | 0) | 0), c[i + 12 >> 2] = t, c[i + 8 >> 2] = n, m[i + 4 >> 2] = a, m[i >> 2] = e, m[i + 16 >> 2] = m[r + 516 >> 2], m[i + 20 >> 2] = m[r + 520 >> 2], i = 1;
                    }
                    return b && (n = c[r + 520 >> 2], c[r + 244 >> 2] = c[r + 516 >> 2], c[r + 248 >> 2] = n, t = 1 | (n = v[r + 4 | 0]), f[r + 4 | 0] = t, 4 & n && (f[r + 4 | 0] = 251 & t)), c[r + 312 >> 2] = d, i;
                }
                function cr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0, f = 0, o = 0, u = 0, b = 0, s = 0, A = 0;
                    o = 8;
                    r: if (!((r |= 0) >>> 0 > 4294967239)) {
                        e: {
                            for(;;){
                                if (o = o >>> 0 <= 8 ? 8 : o, t = e = c[1731], n = c[1730], (r = r >>> 0 <= 8 ? 8 : r + 3 & -4) >>> 0 <= 127 ? f = (r >>> 3 | 0) - 1 | 0 : (f = 110 + ((r >>> 29 - (i = G(r)) ^ 4) - (i << 2) | 0) | 0, r >>> 0 <= 4095 || (f = (i = 71 + ((r >>> 30 - i ^ 2) - (i << 1) | 0) | 0) >>> 0 >= 63 ? 63 : i)), a = 31 & f, (63 & f) >>> 0 >= 32 ? (i = 0, e = e >>> a | 0) : (i = e >>> a | 0, e = ((1 << a) - 1 & e) << 32 - a | n >>> a), e | i) {
                                    for(;;){
                                        if (n = i, e | i ? (u = 1 + (a = i - 1 | 0) | 0, t = a, a = 63 - (i = 32 == (0 | (i = G(i ^ (t = -1 != (0 | (a = e - 1 | 0)) ? u : t)))) ? G(e ^ a) + 32 | 0 : i) | 0, ir = 0 - (i >>> 0 > 63) | 0) : (ir = 0, a = 64), a = 31 & (t = a), (63 & t) >>> 0 >= 32 ? (i = 0, e = n >>> a | 0) : (i = n >>> a | 0, e = ((1 << a) - 1 & n) << 32 - a | e >>> a), u = e, (0 | (e = c[5896 + (a = (f = t + f | 0) << 4) >> 2])) == (0 | (t = a + 5888 | 0))) b = c[1731], n = 31 & (e = t = 63 & f), e >>> 0 >= 32 ? (e = 0, a = -1 >>> n | 0) : a = (e = -1 >>> n | 0) | (1 << n) - 1 << 32 - n, a &= -2, n = 31 & t, t >>> 0 >= 32 ? (e = a << n, a = 0) : (e = (1 << n) - 1 & a >>> 32 - n | e << n, a <<= n), s = a, n = e, e = 31 & (a = t = 0 - f & 63), a >>> 0 >= 32 ? (e = -1 << e, a = 0) : e = (a = -1 << e) | (1 << e) - 1 & -1 >>> 32 - e, A = -2 & a, a = 31 & t, t >>> 0 >= 32 ? (t = 0, e = e >>> a | 0) : (t = e >>> a | 0, e = ((1 << a) - 1 & e) << 32 - a | A >>> a), e |= s, ir = n | t, c[1730] = c[1730] & e, c[1731] = ir & b, e = 1 ^ u;
                                        else {
                                            if (n = Nr(e, o, r)) break r;
                                            n = c[e + 4 >> 2], c[n + 8 >> 2] = c[e + 8 >> 2], c[c[e + 8 >> 2] + 4 >> 2] = n, c[e + 8 >> 2] = t, n = a + 5892 | 0, c[e + 4 >> 2] = c[n >> 2], c[n >> 2] = e, c[c[e + 4 >> 2] + 8 >> 2] = e, f = f + 1 | 0, e = (1 & i) << 31 | u >>> 1, i = i >>> 1 | 0;
                                        }
                                        if (!(e | i)) break;
                                    }
                                    t = c[1731], n = c[1730];
                                }
                                a: {
                                    if (n | t) {
                                        a = 63 - (32 == (0 | (i = G(t))) ? G(n) + 32 | 0 : i) | 0, i = c[5896 + (e = a << 4) >> 2];
                                        i: if (!(!t & n >>> 0 < 1073741824) && (f = 99, (0 | (e = e + 5888 | 0)) != (0 | i))) {
                                            for(;;){
                                                if (!f) break i;
                                                if (n = Nr(i, o, r)) break r;
                                                if (f = f - 1 | 0, (0 | e) == (0 | (i = c[i + 8 >> 2]))) break;
                                            }
                                            i = e;
                                        }
                                        if (vr(r + 48 | 0)) break a;
                                        if (!i) break e;
                                        if ((0 | (e = 5888 + (a << 4) | 0)) == (0 | i)) break e;
                                        for(;;){
                                            if (n = Nr(i, o, r)) break r;
                                            if ((0 | e) == (0 | (i = c[i + 8 >> 2]))) break;
                                        }
                                        break e;
                                    }
                                    if (!vr(r + 48 | 0)) break e;
                                }
                                if (n = 0, o - 1 & o) break r;
                                if (!(r >>> 0 <= 4294967239)) break;
                            }
                            break r;
                        }
                        n = 0;
                    }
                    return 0 | n;
                }
                function ur(r, e, a, i) {
                    var n = y(0), t = y(0), f = 0, o = y(0);
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: {
                                        t: {
                                            if (e >>> 0 <= 1) {
                                                t = m[r + 212 >> 2];
                                                f: if (2139156720 != (0 | (e = c[r + 212 >> 2]))) {
                                                    if (2140081935 == (0 | e)) break t;
                                                    f = 4276;
                                                    o: {
                                                        if (2141891242 != (0 | e)) {
                                                            if (t == t) break o;
                                                            f = 4268;
                                                        }
                                                        switch(n = m[f >> 2], t = y(NaN), c[f + 4 >> 2] - 1 | 0){
                                                            case 0:
                                                                break t;
                                                            case 1:
                                                                break f;
                                                            default:
                                                                break n;
                                                        }
                                                    }
                                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break t;
                                                }
                                                t = y(y(n * i) * y(.009999999776482582));
                                                break n;
                                            }
                                            t = m[r + 208 >> 2];
                                            f: {
                                                o: {
                                                    c: if (2139156720 != (0 | (e = c[r + 208 >> 2]))) {
                                                        if (2140081935 == (0 | e)) break o;
                                                        f = 4276;
                                                        u: {
                                                            if (2141891242 != (0 | e)) {
                                                                if (t == t) break u;
                                                                f = 4268;
                                                            }
                                                            switch(n = m[f >> 2], t = y(NaN), c[f + 4 >> 2] - 1 | 0){
                                                                case 0:
                                                                    break o;
                                                                case 1:
                                                                    break c;
                                                                default:
                                                                    break f;
                                                            }
                                                        }
                                                        if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break o;
                                                    }
                                                    t = y(y(n * i) * y(.009999999776482582));
                                                    break f;
                                                }
                                                t = n;
                                            }
                                            n = y(0), o = m[r + 216 >> 2];
                                            f: if (2139156720 != (0 | (r = c[r + 216 >> 2]))) {
                                                if (2140081935 == (0 | r)) break a;
                                                e = 4276;
                                                o: {
                                                    if (2141891242 != (0 | r)) {
                                                        if (o == o) break o;
                                                        e = 4268;
                                                    }
                                                    switch(n = m[e >> 2], c[e + 4 >> 2] - 1 | 0){
                                                        case 1:
                                                            break f;
                                                        case 0:
                                                            break i;
                                                        default:
                                                            break e;
                                                    }
                                                }
                                                if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break i;
                                            }
                                            n = y(y(n * i) * y(.009999999776482582));
                                            break i;
                                        }
                                        t = n;
                                    }
                                    n = y(0), o = m[r + 220 >> 2];
                                    n: if (2139156720 != (0 | (r = c[r + 220 >> 2]))) {
                                        if (2140081935 == (0 | r)) break a;
                                        e = 4276;
                                        t: {
                                            if (2141891242 != (0 | r)) {
                                                if (o == o) break t;
                                                e = 4268;
                                            }
                                            switch(n = m[e >> 2], c[e + 4 >> 2] - 1 | 0){
                                                case 1:
                                                    break n;
                                                case 0:
                                                    break i;
                                                default:
                                                    break e;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break i;
                                    }
                                    n = y(y(n * i) * y(.009999999776482582));
                                }
                                if (!(n >= y(0))) break e;
                            }
                            if (a > n) break r;
                        }
                        if (!(t >= y(0))) return a;
                        n = a < t ? t : a;
                    }
                    return n;
                }
                function br(r, e) {
                    var a = 0, i = 0;
                    for(c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, o[r + 4 >> 1] = 1, c[r >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, c[r + 24 >> 2] = 0, c[r + 36 >> 2] = 2143289344, c[r + 40 >> 2] = 2141891242, c[r + 28 >> 2] = 2143289344, c[r + 32 >> 2] = 2143289344, i = Rr(r + 44 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 80 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 116 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 152 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, c[r + 196 >> 2] = 0, c[(i = r + 188 | 0) >> 2] = 0, c[i + 4 >> 2] = 0; c[i + (a << 2) >> 2] = 2143289344, 3 != (0 | (a = a + 1 | 0)););
                    for(c[r + 24 >> 2] = 4224, c[r + 224 >> 2] = 2143289344, c[r + 216 >> 2] = 2143289344, c[r + 220 >> 2] = 2143289344, c[r + 208 >> 2] = 2143289344, c[r + 212 >> 2] = 2143289344, c[r + 200 >> 2] = 2141891242, c[r + 204 >> 2] = 2141891242, Rr(r + 228 | 0, 0, 288), c[r + 244 >> 2] = 2143289344, c[r + 248 >> 2] = 2143289344, Rr(r + 252 | 0, 0, 49), c[r + 308 >> 2] = 2143289344, i = r + 516 | 0, a = r + 324 | 0; c[a + 16 >> 2] = -1082130432, c[a + 20 >> 2] = -1082130432, c[a + 8 >> 2] = 0, c[a + 12 >> 2] = 0, c[a >> 2] = -1082130432, c[a + 4 >> 2] = -1082130432, (0 | i) != (0 | (a = a + 24 | 0)););
                    return c[r + 548 >> 2] = 0, c[r + 552 >> 2] = 0, c[r + 516 >> 2] = 2143289344, c[r + 520 >> 2] = 2143289344, c[r + 572 >> 2] = 2143289344, c[r + 576 >> 2] = 0, c[r + 568 >> 2] = e, c[r + 540 >> 2] = -1082130432, c[r + 544 >> 2] = -1082130432, c[r + 532 >> 2] = 0, c[r + 536 >> 2] = 0, c[r + 524 >> 2] = -1082130432, c[r + 528 >> 2] = -1082130432, c[r + 556 >> 2] = 0, c[r + 560 >> 2] = 0, c[r + 564 >> 2] = 0, c[r + 580 >> 2] = 2143289344, c[r + 584 >> 2] = 0, v[e + 10 | 0] && (c[r + 24 >> 2] = 4616, f[r + 4 | 0] = 128 | v[r + 4 | 0]), r;
                }
                function sr(r) {
                    var e, a, i, n, t, f = 0, o = 0, u = y(0), s = y(0), A = y(0), k = 0, l = 0, v = 0, h = 0;
                    for(c[8 + (e = ar - 16 | 0) >> 2] = 0, c[e + 12 >> 2] = 1, a = r + 200 | 0, i = r + 572 | 0, n = r + 208 | 0, t = r + 216 | 0, r = 0;;){
                        h = r, v = c[(e + 8 | 0) + (r << 2) >> 2], u = m[(r = t + (k = v << 2) | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: {
                                        n: {
                                            if (!(!((l = 2139156720 == (0 | (f = c[r >> 2]))) | 2140081935 == (0 | f) | 2141891242 == (0 | f)) & u != u)) {
                                                s = m[(r = k + n | 0) >> 2];
                                                t: {
                                                    f: {
                                                        if (2139156720 != (0 | (o = c[r >> 2]))) {
                                                            if (A = y(NaN), r = 3, 2141891242 == (0 | o)) break t;
                                                            if (2140081935 != (0 | o)) break f;
                                                            A = y(0), r = 1;
                                                            break t;
                                                        }
                                                        A = y(0), r = 2;
                                                        break t;
                                                    }
                                                    r = 0, s == s && (b(2, 536870912 + (-1073741825 & o) | 0), A = d(), r = 1073741824 & o ? 2 : 1);
                                                }
                                                o = r;
                                                t: {
                                                    f: {
                                                        if (!l) {
                                                            if (s = y(NaN), r = 3, 2141891242 == (0 | f)) break t;
                                                            if (2140081935 != (0 | f)) break f;
                                                            s = y(0), r = 1;
                                                            break t;
                                                        }
                                                        s = y(0), r = 2;
                                                        break t;
                                                    }
                                                    r = 0, u == u && (b(2, 536870912 + (-1073741825 & f) | 0), s = d(), r = 1073741824 & f ? 2 : 1);
                                                }
                                                if (!((0 | o) != (0 | r) | !(!r | s != s & A != A | y(E(y(s - A))) < y(9999999747378752e-20)))) {
                                                    if (r = 0, l) break n;
                                                    if (2140081935 == (0 | f)) break e;
                                                    if (2141891242 == (0 | f)) break a;
                                                    if (u != u) break i;
                                                    r = 536870912 + (-1073741825 & f) | 0, f = 1073741824 & f ? 2 : 1;
                                                    break r;
                                                }
                                            }
                                            if (r = 0, u = m[(f = k + a | 0) >> 2], 2139156720 != (0 | (f = c[f >> 2]))) {
                                                if (2140081935 == (0 | f)) break e;
                                                if (2141891242 == (0 | f)) break a;
                                                if (u != u) break i;
                                                r = 536870912 + (-1073741825 & f) | 0, f = 1073741824 & f ? 2 : 1;
                                                break r;
                                            }
                                        }
                                        f = 2;
                                        break r;
                                    }
                                    r = 2143289344, f = 0;
                                    break r;
                                }
                                r = 2143289344, f = 3;
                                break r;
                            }
                            f = 1;
                        }
                        if (c[4 + (o = (v << 3) + i | 0) >> 2] = f, c[o >> 2] = r, r = 1, 1 & h) break;
                    }
                }
                function Ar(r, e, a) {
                    var i, n = 0, t = 0;
                    if (a >>> 0 >= 512) return J(0 | r, 0 | e, 0 | a), r;
                    i = r + a | 0;
                    r: if (3 & (r ^ e)) {
                        if (i >>> 0 < 4) a = r;
                        else if ((n = i - 4 | 0) >>> 0 < r >>> 0) a = r;
                        else for(a = r; f[0 | a] = v[0 | e], f[a + 1 | 0] = v[e + 1 | 0], f[a + 2 | 0] = v[e + 2 | 0], f[a + 3 | 0] = v[e + 3 | 0], e = e + 4 | 0, n >>> 0 >= (a = a + 4 | 0) >>> 0;);
                    } else {
                        e: if (3 & r) {
                            if (a) for(a = r;;){
                                if (f[0 | a] = v[0 | e], e = e + 1 | 0, !(3 & (a = a + 1 | 0))) break e;
                                if (!(a >>> 0 < i >>> 0)) break;
                            }
                            else a = r;
                        } else a = r;
                        if (!((n = -4 & i) >>> 0 < 64 || (t = n + -64 | 0) >>> 0 < a >>> 0)) for(; c[a >> 2] = c[e >> 2], c[a + 4 >> 2] = c[e + 4 >> 2], c[a + 8 >> 2] = c[e + 8 >> 2], c[a + 12 >> 2] = c[e + 12 >> 2], c[a + 16 >> 2] = c[e + 16 >> 2], c[a + 20 >> 2] = c[e + 20 >> 2], c[a + 24 >> 2] = c[e + 24 >> 2], c[a + 28 >> 2] = c[e + 28 >> 2], c[a + 32 >> 2] = c[e + 32 >> 2], c[a + 36 >> 2] = c[e + 36 >> 2], c[a + 40 >> 2] = c[e + 40 >> 2], c[a + 44 >> 2] = c[e + 44 >> 2], c[a + 48 >> 2] = c[e + 48 >> 2], c[a + 52 >> 2] = c[e + 52 >> 2], c[a + 56 >> 2] = c[e + 56 >> 2], c[a + 60 >> 2] = c[e + 60 >> 2], e = e - -64 | 0, t >>> 0 >= (a = a - -64 | 0) >>> 0;);
                        if (a >>> 0 >= n >>> 0) break r;
                        for(; c[a >> 2] = c[e >> 2], e = e + 4 | 0, n >>> 0 > (a = a + 4 | 0) >>> 0;);
                    }
                    if (a >>> 0 < i >>> 0) for(; f[0 | a] = v[0 | e], e = e + 1 | 0, (0 | i) != (0 | (a = a + 1 | 0)););
                    return r;
                }
                function kr(r, e, a, i, n) {
                    var t, f = y(0), o = 0, u = y(0), s = y(0), A = 0, k = y(0), l = y(0);
                    if (!(t = (u = y(a - i)) != u)) {
                        a = y(0), f = m[208 + (o = (e << 2) + r | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: if (2139156720 != (0 | (o = c[o + 208 >> 2]))) {
                                        if (2140081935 == (0 | o)) break e;
                                        A = 4276;
                                        n: {
                                            if (2141891242 != (0 | o)) {
                                                if (f == f) break n;
                                                A = 4268;
                                            }
                                            switch(a = m[A >> 2], c[A + 4 >> 2] - 1 | 0){
                                                case 0:
                                                    break a;
                                                case 1:
                                                    break i;
                                                default:
                                                    break r;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & o) | 0), a = d(), !(1073741824 & o)) break a;
                                    }
                                    a = y(y(a * n) * y(.009999999776482582));
                                }
                                if (a != a) break r;
                            }
                            s = y(a - i);
                        }
                        a = y(0), f = m[216 + (r = (e << 2) + r | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: if (2139156720 != (0 | (e = c[r + 216 >> 2]))) {
                                        if (2140081935 == (0 | e)) break e;
                                        r = 4276;
                                        n: {
                                            if (2141891242 != (0 | e)) {
                                                if (f == f) break n;
                                                r = 4268;
                                            }
                                            switch(a = m[r >> 2], f = y(34028234663852886e22), c[r + 4 >> 2] - 1 | 0){
                                                case 0:
                                                    break a;
                                                case 1:
                                                    break i;
                                                default:
                                                    break r;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & e) | 0), a = d(), !(1073741824 & e)) break a;
                                    }
                                    a = y(y(a * n) * y(.009999999776482582));
                                }
                                if (a != a) {
                                    f = y(34028234663852886e22);
                                    break r;
                                }
                            }
                            f = y(a - i);
                        }
                        if (k = u, l = ge(u, f), !((r = (a = f != f | t ? k : l) != a) | s != s)) return Re(a, s);
                        u = r ? s : a;
                    }
                    return u;
                }
                function lr(r, e, a, i, n, t, f, o, c, u, b, s, A) {
                    var k = y(0), l = y(0), d = 0, v = 0, h = y(0), p = y(0), N = y(0), w = 0, G = 0;
                    if (c < y(0) | u < y(0)) r = 0;
                    else {
                        h = t, p = e, N = i, l = o, A && (l = o, (k = m[A + 16 >> 2]) != y(0) && (p = jr(+e, w = +k, 0, 0), N = jr(+i, w, 0, 0), h = jr(+t, w, 0, 0), l = jr(+o, w, 0, 0))), k = l, A = 0, (0 | r) == (0 | n) && ((G = h != h) | (A = p != p) ? A &= G : A = y(E(y(h - p))) < y(9999999747378752e-20)), G = A, (0 | a) == (0 | f) && ((d = k != k) | (A = N != N) ? d &= A : d = y(E(y(k - N))) < y(9999999747378752e-20)), v = 1, A = 1;
                        r: if (!G) {
                            e = y(e - b);
                            e: if (1 != (0 | r)) {
                                if (!((r = 2 != (0 | r)) | n)) {
                                    if (!(e >= c)) break e;
                                    break r;
                                }
                                if (A = 0, !(e < t) | r | 2 != (0 | n) | e != e | t != t | c != c) break r;
                                if (A = 1, e >= c) break r;
                            }
                            A = (n = e != e) | (r = c != c) ? r & n : y(E(y(e - c))) < y(9999999747378752e-20);
                        }
                        r: if (!d) {
                            e = y(i - s);
                            e: if (1 != (0 | a)) {
                                if (!((r = 2 != (0 | a)) | f)) {
                                    if (!(e >= u)) break e;
                                    break r;
                                }
                                if (v = 0, !(e < o) | r | 2 != (0 | f) | e != e | o != o | u != u) break r;
                                if (v = 1, e >= u) break r;
                            }
                            v = (a = e != e) | (r = u != u) ? r & a : y(E(y(e - u))) < y(9999999747378752e-20);
                        }
                        r = A & v;
                    }
                    return r;
                }
                function dr(r) {
                    var e, a, i = 0, n = 0, t = 0, f = 0, o = 0, c = 0;
                    if (A(+r), o = 0 | u(1), t = 0 | u(0), 2047 == (0 | (f = o >>> 20 & 2047))) return (r *= 1) / r;
                    if (!(i = t << 1) & 2145386496 == (0 | (c = o << 1 | t >>> 31)) | c >>> 0 < 2145386496) return !i & 2145386496 == (0 | c) ? 0 * r : r;
                    if (f) i = 1048575 & o | 1048576;
                    else {
                        if (f = 0, n = t << 12, (0 | (i = o << 12 | t >>> 20)) > 0 | (0 | i) >= 0) for(; f = f - 1 | 0, i = i << 1 | n >>> 31, n <<= 1, (0 | i) > 0 | (0 | i) >= 0;);
                        n = 31 & (i = 1 - f | 0), (63 & i) >>> 0 >= 32 ? (i = t << n, t = 0) : (i = (1 << n) - 1 & t >>> 32 - n | o << n, t <<= n);
                    }
                    if (n = t, (0 | f) > 1023) {
                        for(;;){
                            if (!((0 | (t = i + -1048576 | 0)) < 0 || (i = t) | n)) return 0 * r;
                            if (i = i << 1 | n >>> 31, n <<= 1, !((0 | (f = f - 1 | 0)) > 1023)) break;
                        }
                        f = 1023;
                    }
                    if (!((0 | (t = i + -1048576 | 0)) < 0 || (i = t) | n)) return 0 * r;
                    if (1048575 == (0 | i) | i >>> 0 < 1048575) for(; f = f - 1 | 0, t = i >>> 0 < 524288, c = i << 1 | n >>> 31, n <<= 1, i = c, t;);
                    return a = -2147483648 & o, c = i + -1048576 | f << 20, o = i, e = n, n = 31 & (t = 1 - f | 0), (63 & t) >>> 0 >= 32 ? (i = 0, t = o >>> n | 0) : (i = o >>> n | 0, t = ((1 << n) - 1 & o) << 32 - n | e >>> n), b(0, 0 | ((n = (0 | f) > 0) ? e : t)), b(1, (n ? c : i) | a), +s();
                }
                function vr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0;
                    if ((a = (i = c[1396]) + (e = r + 7 & -8) | 0) >>> 0 <= i >>> 0 && e || a >>> 0 > ia() << 16 >>> 0 && !(0 | x(0 | a)) ? (c[1761] = 48, i = -1) : c[1396] = a, -1 != (0 | i)) {
                        c[12 + (a = (e = r + i | 0) - 16 | 0) >> 2] = 16, c[a >> 2] = 16;
                        r: {
                            e: {
                                if ((0 | (t = (r = c[1728]) ? c[r + 8 >> 2] : 0)) == (0 | i)) {
                                    if (n = i - (-2 & c[i - 4 >> 2]) | 0, t = c[n - 4 >> 2], c[r + 8 >> 2] = e, e = -16, !(1 & f[((r = n - (-2 & t) | 0) + c[r >> 2] | 0) - 4 | 0])) break e;
                                    e = c[r + 4 >> 2], c[e + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = e, a = a - r | 0, c[r >> 2] = a;
                                    break r;
                                }
                                c[i + 12 >> 2] = 16, c[i >> 2] = 16, c[i + 8 >> 2] = e, c[i + 4 >> 2] = r, c[1728] = i, e = 16;
                            }
                            a = a - (r = e + i | 0) | 0, c[r >> 2] = a;
                        }
                        c[((-4 & a) + r | 0) - 4 >> 2] = 1 | a, (e = c[r >> 2] - 8 | 0) >>> 0 <= 127 ? a = (e >>> 3 | 0) - 1 | 0 : (a = 110 + ((e >>> 29 - (n = G(e)) ^ 4) - (n << 2) | 0) | 0, e >>> 0 <= 4095 || (a = (a = 71 + ((e >>> 30 - n ^ 2) - (n << 1) | 0) | 0) >>> 0 >= 63 ? 63 : a)), e = a << 4, c[r + 4 >> 2] = e + 5888, e = e + 5896 | 0, c[r + 8 >> 2] = c[e >> 2], c[e >> 2] = r, c[c[r + 8 >> 2] + 4 >> 2] = r, e = c[1730], n = c[1731], r = 31 & a, (63 & a) >>> 0 >= 32 ? (a = 1 << r, t = 0) : a = (t = 1 << r) - 1 & 1 >>> 32 - r, c[1730] = t | e, c[1731] = a | n;
                    }
                    return -1 != (0 | i);
                }
                function hr(r, e, a) {
                    var i = 0, n = 0, t = 0, f = 0, o = 0, c = 0, u = 0, b = 0, s = 0;
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: {
                                        t: {
                                            f: {
                                                o: {
                                                    c: {
                                                        u: {
                                                            if (e) {
                                                                if (!a) break u;
                                                                break c;
                                                            }
                                                            ir = 0, r = (r >>> 0) / (a >>> 0) | 0;
                                                            break r;
                                                        }
                                                        if (!r) break o;
                                                        break f;
                                                    }
                                                    if (!(a - 1 & a)) break t;
                                                    f = 0 - (t = (G(a) + 33 | 0) - G(e) | 0) | 0;
                                                    break i;
                                                }
                                                ir = 0, r = (e >>> 0) / 0 | 0;
                                                break r;
                                            }
                                            if ((i = 32 - G(e) | 0) >>> 0 < 31) break n;
                                            break a;
                                        }
                                        if (1 == (0 | a)) break e;
                                        a = 31 & (t = a ? 31 - G(a - 1 ^ a) | 0 : 32), (63 & t) >>> 0 >= 32 ? r = e >>> a | 0 : (i = e >>> a | 0, r = ((1 << a) - 1 & e) << 32 - a | r >>> a), ir = i;
                                        break r;
                                    }
                                    t = i + 1 | 0, f = 63 - i | 0;
                                }
                                if (n = 31 & (i = 63 & t), i >>> 0 >= 32 ? (i = 0, o = e >>> n | 0) : (i = e >>> n | 0, o = ((1 << n) - 1 & e) << 32 - n | r >>> n), n = 31 & (f &= 63), f >>> 0 >= 32 ? (e = r << n, r = 0) : (e = (1 << n) - 1 & r >>> 32 - n | e << n, r <<= n), t) for(s = -1 == (0 | (f = a - 1 | 0)) ? -1 : 0; c = i << 1 | o >>> 31, o = (i = o << 1 | e >>> 31) - (u = a & (n = s - (c + (i >>> 0 > f >>> 0) | 0) >> 31)) | 0, i = c - (i >>> 0 < u >>> 0) | 0, e = e << 1 | r >>> 31, r = b | r << 1, b = 1 & n, t = t - 1 | 0;);
                                ir = e << 1 | r >>> 31, r = b | r << 1;
                                break r;
                            }
                            r = 0, e = 0;
                        }
                        ir = e;
                    }
                    return r;
                }
                function pr(r, e, a) {
                    var i = y(0), n = y(0);
                    r: {
                        e: {
                            a: {
                                if (2 == (-2 & e)) {
                                    if (2139156720 == (0 | (e = c[r + 188 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 188 >> 2]) == i) break a;
                                    if (2139156720 == (0 | (e = c[r + 196 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 196 >> 2]) == i) break a;
                                    break e;
                                }
                                if (!(2139156720 == (0 | (e = c[r + 192 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 192 >> 2]) == i || (i = m[r + 196 >> 2], 2139156720 == (0 | (e = c[r + 196 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) || i == i))) break e;
                            }
                            i = y(0);
                            a: {
                                i: if (2139156720 != (0 | e)) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (i = d()) == i) break n;
                                            r = 4268;
                                        }
                                        switch(i = m[r >> 2], n = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break r;
                                            case 1:
                                                break i;
                                            default:
                                                break a;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), i = d(), !(1073741824 & e)) break r;
                                }
                                n = y(y(i * a) * y(.009999999776482582));
                            }
                            return n;
                        }
                        i = y(0);
                    }
                    return i;
                }
                function mr(r, e) {
                    var a, i, n = 0, t = 0, o = 0, u = 0;
                    for(ar = n = ar - 320 | 0, a = Rr(n, 0, 288), c[(n = a) + 16 >> 2] = 2143289344, c[n + 20 >> 2] = 2143289344, Rr(n + 24 | 0, 0, 49), c[n + 80 >> 2] = 2143289344, o = n + 288 | 0, t = n + 96 | 0; c[(n = t) + 16 >> 2] = -1082130432, c[n + 20 >> 2] = -1082130432, c[n + 8 >> 2] = 0, c[n + 12 >> 2] = 0, c[n >> 2] = -1082130432, c[n + 4 >> 2] = -1082130432, (0 | o) != (0 | (t = n + 24 | 0)););
                    if (c[a + 312 >> 2] = -1082130432, c[a + 316 >> 2] = -1082130432, c[a + 304 >> 2] = 0, c[a + 308 >> 2] = 0, c[a + 296 >> 2] = -1082130432, c[a + 300 >> 2] = -1082130432, c[a + 288 >> 2] = 2143289344, c[a + 292 >> 2] = 2143289344, Ar(r + 228 | 0, a, 320), c[r + 244 >> 2] = 0, c[r + 248 >> 2] = 0, f[r + 4 | 0] = 1 | v[r + 4 | 0], (0 | (t = c[r + 556 >> 2])) != (0 | (i = c[r + 560 >> 2]))) for(; n = c[t >> 2], c[n + 552 >> 2] != (0 | r) && (o = c[r + 568 >> 2], n = Ir(c[o >> 2], v[o + 8 | 0], n, r, u, e), c[t >> 2] = n, c[n + 552 >> 2] = r, n = c[t >> 2]), mr(n, e), u = u + 1 | 0, (0 | i) != (0 | (t = t + 4 | 0)););
                    ar = a + 320 | 0;
                }
                function Nr(r, e, a) {
                    var i = 0, n = 0, t = 0, f = 0;
                    return (n = ((i = r + 4 | 0) + e | 0) - 1 & 0 - e) + a >>> 0 <= ((e = c[r >> 2]) + r | 0) - 4 >>> 0 ? (t = c[r + 4 >> 2], c[t + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = t, (0 | i) != (0 | n) && (n = n - i | 0, t = r - (-2 & c[r - 4 >> 2]) | 0, i = n + c[t >> 2] | 0, c[t >> 2] = i, c[(t + (-4 & i) | 0) - 4 >> 2] = i, e = e - n | 0, c[(r = r + n | 0) >> 2] = e), a + 24 >>> 0 <= e >>> 0 ? (e = (e - a | 0) - 8 | 0, c[(i = 8 + (r + a | 0) | 0) >> 2] = e, c[(i + (-4 & e) | 0) - 4 >> 2] = 1 | e, (n = c[i >> 2] - 8 | 0) >>> 0 <= 127 ? e = (n >>> 3 | 0) - 1 | 0 : (e = 110 + ((n >>> 29 - (t = G(n)) ^ 4) - (t << 2) | 0) | 0, n >>> 0 <= 4095 || (e = (e = 71 + ((n >>> 30 - t ^ 2) - (t << 1) | 0) | 0) >>> 0 >= 63 ? 63 : e)), n = e << 4, c[i + 4 >> 2] = n + 5888, n = n + 5896 | 0, c[i + 8 >> 2] = c[n >> 2], c[n >> 2] = i, c[c[i + 8 >> 2] + 4 >> 2] = i, n = c[1730], t = c[1731], i = 31 & e, (63 & e) >>> 0 >= 32 ? (e = 1 << i, i = 0) : (e = (f = 1 << i) - 1 & 1 >>> 32 - i, i = f), c[1730] = i | n, c[1731] = e | t, e = a + 8 | 0, c[r >> 2] = e, c[((-4 & e) + r | 0) - 4 >> 2] = e) : c[(r + e | 0) - 4 >> 2] = e, r = r + 4 | 0) : r = 0, r;
                }
                function wr(r, e, a) {
                    var i = 0, n = 0;
                    r: if ((0 | r) != (0 | e)) {
                        if (e - (n = r + a | 0) >>> 0 <= 0 - (a << 1) >>> 0) return Ar(r, e, a);
                        if (i = 3 & (r ^ e), r >>> 0 < e >>> 0) {
                            if (i) i = r;
                            else {
                                if (3 & r) for(i = r;;){
                                    if (!a) break r;
                                    if (f[0 | i] = v[0 | e], e = e + 1 | 0, a = a - 1 | 0, !(3 & (i = i + 1 | 0))) break;
                                }
                                else i = r;
                                if (!(a >>> 0 <= 3)) for(; c[i >> 2] = c[e >> 2], e = e + 4 | 0, i = i + 4 | 0, (a = a - 4 | 0) >>> 0 > 3;);
                            }
                            if (a) for(; f[0 | i] = v[0 | e], i = i + 1 | 0, e = e + 1 | 0, a = a - 1 | 0;);
                        } else {
                            if (!i) {
                                if (3 & n) for(;;){
                                    if (!a) break r;
                                    if (f[0 | (i = (a = a - 1 | 0) + r | 0)] = v[e + a | 0], !(3 & i)) break;
                                }
                                if (!(a >>> 0 <= 3)) for(; c[(a = a - 4 | 0) + r >> 2] = c[e + a >> 2], a >>> 0 > 3;);
                            }
                            if (!a) break r;
                            for(; f[(a = a - 1 | 0) + r | 0] = v[e + a | 0], a;);
                        }
                    }
                    return r;
                }
                function yr(r, e, a, i) {
                    switch(e - 9 | 0){
                        case 0:
                            return e = c[a >> 2], c[a >> 2] = e + 4, void (c[r >> 2] = c[e >> 2]);
                        case 6:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = o[e >> 1], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 7:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = h[e >> 1], void (c[r + 4 >> 2] = 0);
                        case 8:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = f[0 | e], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 9:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = v[0 | e], void (c[r + 4 >> 2] = 0);
                        case 16:
                            return e = c[a >> 2] + 7 & -8, c[a >> 2] = e + 8, void (N[r >> 3] = N[e >> 3]);
                        case 17:
                            aa[0 | i](r, a);
                        default:
                            return;
                        case 1:
                        case 4:
                        case 14:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = c[e >> 2], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 2:
                        case 5:
                        case 11:
                        case 15:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = c[e >> 2], void (c[r + 4 >> 2] = 0);
                        case 3:
                        case 10:
                        case 12:
                        case 13:
                    }
                    e = c[a >> 2] + 7 & -8, c[a >> 2] = e + 8, a = c[e + 4 >> 2], c[r >> 2] = c[e >> 2], c[r + 4 >> 2] = a;
                }
                function Er(r, e, a, i) {
                    var n = 0, t = 0, f = 0, o = 0, u = 0, b = 0, s = 0, A = 0, k = 0, l = 0, d = 0, h = y(0), p = y(0), N = y(0), w = 0, G = y(0);
                    if (0 != e && (h = m[r + 248 >> 2], p = m[r + 244 >> 2], N = m[r + 232 >> 2], w = r, G = jr(A = +m[r + 228 >> 2], e, 0, n = (f = 8 & v[r + 4 | 0]) >>> 3 | 0), m[w + 228 >> 2] = G, w = r, G = jr(k = +N, e, 0, n), m[w + 232 >> 2] = G, n = (u = dr((l = +p) * e)) != u, t = (b = dr((d = +h) * e)) != b, a = A + a, o = n | (o = E(u) < 1e-4) ? n | !o : !(E(u + -1) < 1e-4), w = r, G = y(jr(a + l, e, o & (n = 0 != (0 | f)), n & !o) - jr(a, e, 0, n)), m[w + 244 >> 2] = G, i = k + i, t = t | (f = E(b) < 1e-4) ? t | !f : !(E(b + -1) < 1e-4), w = r, G = y(jr(i + d, e, n & t, n & !t) - jr(i, e, 0, n)), m[w + 248 >> 2] = G, (0 | (n = c[r + 560 >> 2])) != (0 | (t = c[r + 556 >> 2])))) for(t = (n = n - t >> 2) >>> 0 <= 1 ? 1 : n; n = c[r + 556 >> 2], Er(n = c[r + 560 >> 2] - n >> 2 >>> 0 > s >>> 0 ? c[n + (s << 2) >> 2] : 0, e, a, i), (0 | t) != (0 | (s = s + 1 | 0)););
                }
                function Gr() {
                    er(7004, 3018), rr(7005, 2479, 1, 1, 0), B(7006, 2139, 1, -128, 127), B(7007, 2132, 1, -128, 127), B(7008, 2130, 1, 0, 255), B(7009, 1286, 2, -32768, 32767), B(7010, 1277, 2, 0, 65535), B(7011, 1315, 4, -2147483648, 2147483647), B(7012, 1306, 4, 0, -1), B(7013, 2658, 4, -2147483648, 2147483647), B(7014, 2649, 4, 0, -1), Me(7015, 1776, -2147483648, 2147483647), Me(7016, 1775, 0, -1), S(7017, 1769, 4), S(7018, 2966, 8), P(7019, 2676), P(7020, 3835), L(7021, 4, 2663), L(7022, 2, 2688), L(7023, 4, 2703), $(7024, 2484), W(7025, 0, 3766), W(7026, 0, 3868), W(7027, 1, 3796), W(7028, 2, 3398), W(7029, 3, 3429), W(7030, 4, 3469), W(7031, 5, 3498), W(7032, 4, 3905), W(7033, 5, 3935), W(7026, 0, 3600), W(7027, 1, 3567), W(7028, 2, 3666), W(7029, 3, 3632), W(7030, 4, 3733), W(7031, 5, 3699), W(7034, 6, 3536), W(7035, 7, 3974);
                }
                function Rr(r, e, a) {
                    var i = 0, n = 0, t = 0, o = 0;
                    if (a && (f[0 | r] = e, f[(i = r + a | 0) - 1 | 0] = e, !(a >>> 0 < 3 || (f[r + 2 | 0] = e, f[r + 1 | 0] = e, f[i - 3 | 0] = e, f[i - 2 | 0] = e, a >>> 0 < 7 || (f[r + 3 | 0] = e, f[i - 4 | 0] = e, a >>> 0 < 9 || (n = (i = 0 - r & 3) + r | 0, e = w(255 & e, 16843009), c[n >> 2] = e, c[(a = (i = a - i & -4) + n | 0) - 4 >> 2] = e, i >>> 0 < 9 || (c[n + 8 >> 2] = e, c[n + 4 >> 2] = e, c[a - 8 >> 2] = e, c[a - 12 >> 2] = e, i >>> 0 < 25 || (c[n + 24 >> 2] = e, c[n + 20 >> 2] = e, c[n + 16 >> 2] = e, c[n + 12 >> 2] = e, c[a - 16 >> 2] = e, c[a - 20 >> 2] = e, c[a - 24 >> 2] = e, c[a - 28 >> 2] = e, (a = i - (o = 4 & n | 24) | 0) >>> 0 < 32)))))))) for(i = Ae(e, 0, 1, 1), t = ir, e = n + o | 0; c[e + 24 >> 2] = i, c[e + 28 >> 2] = t, c[e + 16 >> 2] = i, c[e + 20 >> 2] = t, c[e + 8 >> 2] = i, c[e + 12 >> 2] = t, c[e >> 2] = i, c[e + 4 >> 2] = t, e = e + 32 | 0, (a = a - 32 | 0) >>> 0 > 31;);
                    return r;
                }
                function gr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0;
                    (r |= 0) && (a = n = c[(e = r - 4 | 0) >> 2], i = e, (0 | (r = -2 & (t = c[r - 8 >> 2]))) != (0 | t) && (a = c[4 + (i = e - r | 0) >> 2], c[a + 8 >> 2] = c[i + 8 >> 2], c[c[i + 8 >> 2] + 4 >> 2] = a, a = r + n | 0), (0 | (e = c[(r = e + n | 0) >> 2])) != c[(r + e | 0) - 4 >> 2] && (n = c[r + 4 >> 2], c[n + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = n, a = e + a | 0), c[i >> 2] = a, c[((-4 & a) + i | 0) - 4 >> 2] = 1 | a, (e = c[i >> 2] - 8 | 0) >>> 0 <= 127 ? r = (e >>> 3 | 0) - 1 | 0 : (r = 110 + ((e >>> 29 - (a = G(e)) ^ 4) - (a << 2) | 0) | 0, e >>> 0 <= 4095 || (r = (r = 71 + ((e >>> 30 - a ^ 2) - (a << 1) | 0) | 0) >>> 0 >= 63 ? 63 : r)), e = r << 4, c[i + 4 >> 2] = e + 5888, e = e + 5896 | 0, c[i + 8 >> 2] = c[e >> 2], c[e >> 2] = i, c[c[i + 8 >> 2] + 4 >> 2] = i, e = c[1730], a = c[1731], i = 31 & r, (63 & r) >>> 0 >= 32 ? (r = 1 << i, n = 0) : r = (n = 1 << i) - 1 & 1 >>> 32 - i, c[1730] = n | e, c[1731] = r | a);
                }
                function Zr(r, e, a, i, n) {
                    var t, f = 0, o = 0;
                    if (ar = t = ar - 208 | 0, c[t + 204 >> 2] = a, Rr(a = t + 160 | 0, 0, 40), c[t + 200 >> 2] = c[t + 204 >> 2], (0 | fr(0, e, t + 200 | 0, t + 80 | 0, a, i, n)) < 0) n = -1;
                    else {
                        c[r + 76 >> 2], f = c[r >> 2], c[r + 72 >> 2] <= 0 && (c[r >> 2] = -33 & f);
                        r: {
                            e: {
                                if (c[r + 48 >> 2]) {
                                    if (c[r + 16 >> 2]) break e;
                                } else c[r + 48 >> 2] = 80, c[r + 28 >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, o = c[r + 44 >> 2], c[r + 44 >> 2] = t;
                                if (a = -1, me(r)) break r;
                            }
                            a = fr(r, e, t + 200 | 0, t + 80 | 0, t + 160 | 0, i, n);
                        }
                        o && (aa[c[r + 36 >> 2]](r, 0, 0), c[r + 48 >> 2] = 0, c[r + 44 >> 2] = o, c[r + 28 >> 2] = 0, e = c[r + 20 >> 2], c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, a = e ? a : -1), e = r, r = c[r >> 2], c[e >> 2] = r | 32 & f, n = 32 & r ? -1 : a;
                    }
                    return ar = t + 208 | 0, n;
                }
                function Wr(r) {
                    var e, a = 0, i = y(0), n = 0, t = 0, f = 0, o = 0, u = y(0), b = 0;
                    ar = e = ar - 16 | 0;
                    r: {
                        if (a = c[r + 12 >> 2]) {
                            if (u = m[r + 520 >> 2], i = m[r + 516 >> 2], (i = 32 & v[r + 4 | 0] ? y(aa[0 | a](r, i, u, 0)) : y(aa[0 | a](r, i, u))) == i) break r;
                            c[e >> 2] = 3340, Xr(r, e), De(), k();
                        }
                        e: {
                            a: {
                                if ((0 | (f = c[r + 556 >> 2])) != (0 | (a = c[r + 560 >> 2]))) {
                                    for(b = (a = a - f >> 2) >>> 0 <= 1 ? 1 : a;;){
                                        if (t = c[(o << 2) + f >> 2], !c[t + 548 >> 2]) {
                                            if (131072 != (196608 & (a = c[t + 24 >> 2]))) {
                                                if ((a = a >>> 13 & 7) || (a = c[r + 24 >> 2] >>> 10 & 7), 2 & v[t + 4 | 0] | (8 & v[r + 24 | 0] ? 5 == (0 | a) : 0)) break a;
                                                n = n || t;
                                            }
                                            if ((0 | b) != (0 | (o = o + 1 | 0))) continue;
                                        }
                                        break;
                                    }
                                    if (n) break e;
                                }
                                i = m[r + 520 >> 2];
                                break r;
                            }
                            n = t;
                        }
                        i = y(Wr(n) + m[n + 232 >> 2]);
                    }
                    return ar = e + 16 | 0, i;
                }
                function Vr(r, e, a, i, n, t) {
                    var f = 0, o = y(0), u = 0, s = y(0);
                    f = (c[4252 + (e << 2) >> 2] << 2) + r | 0, o = m[f + 216 >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (f = c[f + 216 >> 2]))) {
                                if (2140081935 == (0 | f)) break e;
                                u = 4276;
                                i: {
                                    if (2141891242 != (0 | f)) {
                                        if (o == o) break i;
                                        u = 4268;
                                    }
                                    switch(s = m[u >> 2], o = y(NaN), c[u + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break e;
                                        case 1:
                                            break a;
                                        default:
                                            break r;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & f) | 0), s = d(), !(1073741824 & f)) break e;
                            }
                            o = y(y(s * a) * y(.009999999776482582));
                            break r;
                        }
                        o = s;
                    }
                    i = y(o + y(Mr(r, e, i) + Ur(r, e, i)));
                    r: {
                        e: {
                            a: switch(c[n >> 2]){
                                case 1:
                                case 2:
                                    a = m[t >> 2], i = i != i || a < i ? a : i;
                                    break e;
                                case 0:
                                    break a;
                                default:
                                    break r;
                            }
                            if (i != i) break r;
                            c[n >> 2] = 2;
                        }
                        m[t >> 2] = i;
                    }
                }
                function Br(r, e, a) {
                    var i, n = y(0), t = y(0), f = y(0);
                    r = r + 116 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: {
                                i: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (n = d()) == n) break n;
                                            r = 4268;
                                        }
                                        switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break i;
                                            default:
                                                break e;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break a;
                                }
                                n = y(y(n * a) * y(.009999999776482582));
                            }
                            if (n >= y(0)) return n;
                            if (t = n, n < y(0)) break r;
                        }
                        f = t == t ? t : y(0);
                    }
                    return f;
                }
                function Tr(r, e, a) {
                    var i, n = y(0), t = y(0), f = y(0);
                    r = r + 116 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: {
                                i: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (n = d()) == n) break n;
                                            r = 4268;
                                        }
                                        switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break i;
                                            default:
                                                break e;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break a;
                                }
                                n = y(y(n * a) * y(.009999999776482582));
                            }
                            if (n >= y(0)) return n;
                            if (t = n, n < y(0)) break r;
                        }
                        f = t == t ? t : y(0);
                    }
                    return f;
                }
                function Ir(r, e, a, i, n, t) {
                    var f = 0;
                    r: {
                        if (!r || !(t = 255 & e ? 0 | aa[0 | r](a, i, n, t) : 0 | aa[0 | r](a, i, n))) {
                            if (e = Ar(t = ye(588), a, 552), c[e + 564 >> 2] = 0, c[e + 556 >> 2] = 0, c[e + 560 >> 2] = 0, (0 | (n = c[a + 556 >> 2])) != (0 | (i = c[a + 560 >> 2]))) {
                                if ((0 | (f = i - n | 0)) < 0) break r;
                                for(r = ye(f), c[e + 556 >> 2] = r, c[e + 564 >> 2] = r + f; c[r >> 2] = c[n >> 2], r = r + 4 | 0, (0 | i) != (0 | (n = n + 4 | 0)););
                                c[e + 560 >> 2] = r;
                            }
                            r = c[a + 572 >> 2], c[e + 568 >> 2] = c[a + 568 >> 2], c[e + 572 >> 2] = r, c[e + 584 >> 2] = c[a + 584 >> 2], r = c[a + 580 >> 2], c[e + 576 >> 2] = c[a + 576 >> 2], c[e + 580 >> 2] = r, c[e + 552 >> 2] = 0;
                        }
                        return t;
                    }
                    I(), k();
                }
                function Xr(r, e) {
                    var a, i = 0, n = 0;
                    ar = a = ar - 16 | 0, c[a + 12 >> 2] = e;
                    r: {
                        if (r) {
                            if (e = c[a + 12 >> 2], i = c[r + 568 >> 2]) {
                                if (n = c[i + 4 >> 2], v[i + 9 | 0]) {
                                    aa[0 | n](i, r, 5, 0, 4215, e);
                                    break r;
                                }
                                aa[0 | n](i, r, 5, 4215, e);
                                break r;
                            }
                        } else e = c[a + 12 >> 2];
                        if (v[6936]) {
                            if (i = c[1733], n = c[i + 4 >> 2], v[i + 9 | 0]) {
                                aa[0 | n](i, r, 5, 0, 4215, e);
                                break r;
                            }
                        } else i = ye(28), o[i + 20 >> 1] = 0, c[i + 16 >> 2] = 1065353216, o[i + 10 >> 1] = 0, o[i + 12 >> 1] = 0, c[i >> 2] = 0, c[i + 24 >> 2] = 0, f[i + 9 | 0] = 0, n = 1, c[i + 4 >> 2] = 1, f[i + 22 | 0] = 0, c[1733] = i, f[6936] = 1, c[1732] = c[1732] + 1;
                        aa[0 | n](i, r, 5, 4215, e);
                    }
                    ar = a + 16 | 0;
                }
                function Or(r, e, a) {
                    var i, n = y(0), t = y(0);
                    r = r + 80 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                                if (2140081935 == (0 | e)) break r;
                                r = 4276;
                                i: {
                                    if (2141891242 != (0 | e)) {
                                        if (b(2, e), (n = d()) == n) break i;
                                        r = 4268;
                                    }
                                    switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break a;
                                        default:
                                            break e;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break r;
                            }
                            t = y(y(n * a) * y(.009999999776482582));
                        }
                        return t;
                    }
                    return n;
                }
                function Lr(r, e, a) {
                    var i, n = y(0), t = y(0);
                    r = r + 80 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                                if (2140081935 == (0 | e)) break r;
                                r = 4276;
                                i: {
                                    if (2141891242 != (0 | e)) {
                                        if (b(2, e), (n = d()) == n) break i;
                                        r = 4268;
                                    }
                                    switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break a;
                                        default:
                                            break e;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break r;
                            }
                            t = y(y(n * a) * y(.009999999776482582));
                        }
                        return t;
                    }
                    return n;
                }
                function _r(r, e, a, i) {
                    var n = y(0);
                    return n = m[(e = (e << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | n == n || (n = m[(e = (a << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | n == n || 2139156720 == (0 | (e = c[r + 24 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (n = m[r + 24 >> 2]) == n || (n = m[r + 32 >> 2], (2139156720 == (0 | (r = c[r + 32 >> 2])) | 2140081935 == (0 | r) | 2141891242 == (0 | r) || (e = i, n == n)) && (e = r))), e;
                }
                function Fr(r, e, a, i, n) {
                    var t, f = 0, o = 0, u = y(0);
                    f = 2, o = c[r + 24 >> 2] >>> 2 & 3;
                    r: {
                        e: {
                            a: {
                                if (!(!c[r + 552 >> 2] | 2 != (0 | e))) {
                                    e = 0, f = 3;
                                    i: switch(o - 2 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break i;
                                        default:
                                            break a;
                                    }
                                    f = 2;
                                    break r;
                                }
                                if (e = 0, o >>> 0 > 1) break e;
                            }
                            e = f;
                        }
                        f = o;
                    }
                    a = _e(r, f, a), i = _e(r, e, i), u = Mr(r, f, n), m[(o = r + 228 | 0) + (c[4220 + (t = f << 2) >> 2] << 2) >> 2] = a + u, u = Ur(r, f, n), m[o + (c[t + 4236 >> 2] << 2) >> 2] = a + u, a = Mr(r, e, n), m[o + (c[4220 + (f = e << 2) >> 2] << 2) >> 2] = i + a, a = Ur(r, e, n), m[o + (c[f + 4236 >> 2] << 2) >> 2] = i + a;
                }
                function Cr(r) {
                    var e = 0, a = 0, i = 0, n = 0;
                    if (r |= 0) {
                        if (e = c[r >> 2], (a = c[e + 552 >> 2]) && (ee(a, e), c[e + 552 >> 2] = 0), (0 | (i = c[e + 560 >> 2])) != (0 | (a = c[e + 556 >> 2]))) for(n = (i = i - a >> 2) >>> 0 <= 1 ? 1 : i, i = 0; c[c[a + (i << 2) >> 2] + 552 >> 2] = 0, (0 | n) != (0 | (i = i + 1 | 0)););
                        c[e + 560 >> 2] = a, Sr(e + 556 | 0), (a = c[e + 556 >> 2]) && (c[e + 560 >> 2] = a, gr(a)), gr(e), e = c[r + 8 >> 2], c[r + 8 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), e = c[r + 4 >> 2], c[r + 4 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), gr(r);
                    }
                }
                function Sr(r) {
                    var e, a = 0, i = 0, n = 0, t = 0;
                    ar = e = ar - 32 | 0, a = c[r >> 2], (i = c[r + 4 >> 2] - a >> 2) >>> 0 >= c[r + 8 >> 2] - a >> 2 >>> 0 || (i = pe(e + 8 | 0, i, i, r + 8 | 0), a = c[r >> 2], n = c[r + 4 >> 2] - a | 0, n = wr(c[i + 4 >> 2] - n | 0, a, n), a = c[r >> 2], c[r >> 2] = n, c[i + 4 >> 2] = a, n = c[r + 4 >> 2], c[r + 4 >> 2] = c[i + 8 >> 2], c[i + 8 >> 2] = n, t = c[r + 8 >> 2], c[r + 8 >> 2] = c[i + 12 >> 2], c[i >> 2] = a, c[i + 12 >> 2] = t, (0 | a) != (0 | n) && (c[i + 8 >> 2] = n + (3 + (a - n | 0) & -4)), a && gr(a)), ar = e + 32 | 0;
                }
                function Pr(r, e, a) {
                    var i = 0, n = 0, t = 0;
                    if (!(32 & v[0 | r])) r: {
                        i = e;
                        e: {
                            if (!(r = c[(e = r) + 16 >> 2])) {
                                if (me(e)) break e;
                                r = c[e + 16 >> 2];
                            }
                            if (r - (t = c[e + 20 >> 2]) >>> 0 < a >>> 0) {
                                aa[c[e + 36 >> 2]](e, i, a);
                                break r;
                            }
                            a: if (!(c[e + 80 >> 2] < 0)) {
                                for(r = a;;){
                                    if (n = r, !r) break a;
                                    if (10 == v[i + (r = n - 1 | 0) | 0]) break;
                                }
                                if (aa[c[e + 36 >> 2]](e, i, n) >>> 0 < n >>> 0) break e;
                                i = i + n | 0, a = a - n | 0, t = c[e + 20 >> 2];
                            }
                            Ar(t, i, a), c[e + 20 >> 2] = c[e + 20 >> 2] + a;
                        }
                    }
                }
                function Yr(r, e, a) {
                    var i, n = 0, t = 0;
                    ar = i = ar - 16 | 0, n = r + 24 | 0, aa[0 | e](i + 8 | 0, n), t = c[i + 12 >> 2];
                    r: if ((c[c[i + 8 >> 2] >> 2] & 7 << t) >> t != (0 | a)) for(aa[0 | e](i + 8 | 0, n), n = e = c[i + 8 >> 2], t = c[e >> 2], e = c[i + 12 >> 2], c[n >> 2] = t & (7 << e ^ -1) | (7 & a) << e;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                    ar = i + 16 | 0;
                }
                function Ur(r, e, a) {
                    var i, n = y(0);
                    r = r + 44 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        if (2139156720 != (0 | (r = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                            if (2140081935 == (0 | r) | 2141891242 == (0 | r)) break r;
                            if (b(2, r), (n = d()) != n) return y(NaN);
                            if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break r;
                        }
                        n = y(y(n * a) * y(.009999999776482582));
                    }
                    return n;
                }
                function Mr(r, e, a) {
                    var i, n = y(0);
                    r = r + 44 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        if (2139156720 != (0 | (r = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                            if (2140081935 == (0 | r) | 2141891242 == (0 | r)) break r;
                            if (b(2, r), (n = d()) != n) return y(NaN);
                            if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break r;
                        }
                        n = y(y(n * a) * y(.009999999776482582));
                    }
                    return n;
                }
                function Hr(r, e, a) {
                    var i = y(0);
                    return i = m[(e = (e << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | i == i || 2139156720 == (0 | (e = c[r + 28 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 28 >> 2]) == i || (i = m[r + 32 >> 2], (2139156720 == (0 | (r = c[r + 32 >> 2])) | 2140081935 == (0 | r) | 2141891242 == (0 | r) || (e = a, i == i)) && (e = r)), e;
                }
                function Qr(r, e) {
                    var a, i = y(0);
                    return r = r + 152 | 0, a = c[4236 + (e << 2) >> 2], r = 2 != (-2 & e) ? Hr(r, a, 2140081935) : _r(r, 5, a, 2140081935), i = y(0), 2139156720 != (0 | r) && (i = y(0), 2140081935 != (0 | r) && (2141891242 == (0 | r) || (b(2, r), (i = d()) != i) ? i = y(NaN) : (b(2, 536870912 + (-1073741825 & r) | 0), i = d()))), Re(i, y(0));
                }
                function zr(r, e) {
                    var a, i = y(0);
                    return r = r + 152 | 0, a = c[4220 + (e << 2) >> 2], r = 2 != (-2 & e) ? Hr(r, a, 2140081935) : _r(r, 4, a, 2140081935), i = y(0), 2139156720 != (0 | r) && (i = y(0), 2140081935 != (0 | r) && (2141891242 == (0 | r) || (b(2, r), (i = d()) != i) ? i = y(NaN) : (b(2, 536870912 + (-1073741825 & r) | 0), i = d()))), Re(i, y(0));
                }
                function jr(r, e, a, i) {
                    var n, t = 0, f = 0;
                    r: if ((n = (t = (t = dr(r *= e)) < 0 ? t + 1 : t) != t) | !(E(t) < 1e-4)) {
                        if (t == t) {
                            if (r -= t, E(t + -1) < 1e-4) {
                                r += 1;
                                break r;
                            }
                        } else r -= t;
                        a ? r += 1 : i || (f = 0, n || (f = 1, t > .5 || (f = E(t + -0.5) < 1e-4 ? 1 : 0)), r += f);
                    } else r -= t;
                    return y(r != r | e != e ? NaN : r / e);
                }
                function Dr(r) {
                    var e = y(0), a = 0, i = y(0);
                    a = 0;
                    r: if (131072 != (196608 & c[r + 24 >> 2])) {
                        if (c[r + 552 >> 2]) {
                            if (((e = m[r + 32 >> 2]) == e || (e = m[r + 28 >> 2]) > y(0)) && (a = 1, e != y(0))) break r;
                            (e = m[r + 36 >> 2]) != e && (f[r + 4 | 0] < 0 ? e = y(1) : (e = y(0), (i = m[r + 28 >> 2]) < y(0) && (e = y(-i))));
                        }
                        a = e != y(0);
                    }
                    return a;
                }
                function xr(r, e) {
                    var a = y(0);
                    r: {
                        if (2139156720 != (0 | e)) {
                            if (2140081935 != (0 | e)) {
                                if (2141891242 != (0 | e)) break r;
                                return c[r >> 2] = 2143289344, void (c[r + 4 >> 2] = 3);
                            }
                            return c[r >> 2] = 0, void (c[r + 4 >> 2] = 1);
                        }
                        return c[r >> 2] = 0, void (c[r + 4 >> 2] = 2);
                    }
                    if (b(2, e), (a = d()) != a) return c[r >> 2] = 2143289344, void (c[r + 4 >> 2] = 0);
                    c[r + 4 >> 2] = 1073741824 & e ? 2 : 1, c[r >> 2] = 536870912 + (-1073741825 & e);
                }
                function Jr(r) {
                    var e = 0, a = 0, i = 0;
                    r: if (8 & (a = c[r + 24 >> 2]) && (e = 1, 5120 != (7168 & a) && (e = 0, (0 | (i = c[r + 560 >> 2])) != (0 | (a = c[r + 556 >> 2]))))) for(i = (r = i - a >> 2) >>> 0 <= 1 ? 1 : r, r = 0;;){
                        if (e = 131072 != (196608 & (e = c[c[a + (r << 2) >> 2] + 24 >> 2])) & 40960 == (57344 & e)) break r;
                        if ((0 | i) == (0 | (r = r + 1 | 0))) break;
                    }
                    return e;
                }
                function Kr(r) {
                    var e = 0, a = y(0);
                    return e = 2143289344, y(E(r)) == y(1 / 0) | r != r || (e = 2139156720, r < y(10842021724855044e-35) & r > y(-0.00000000000000000010842021724855044) | r == y(0) || (b(2, -2147483648 & (l(r), u(2)) | 1602224127), a = d(), e = 1073741824 | (l(r > y(0xffffff0000000000) || r < y(-18446742974197924000) ? a : r), u(2) - 536870912))), e;
                }
                function qr(r) {
                    var e = 0, a = y(0);
                    return e = 2143289344, y(E(r)) == y(1 / 0) | r != r || (e = 2140081935, r < y(10842021724855044e-35) & r > y(-0.00000000000000000010842021724855044) | r == y(0) || (b(2, -2147483648 & (l(r), u(2)) | 1610612735), a = d(), e = 0 | (l(r > y(0x1fffffe0000000000) || r < y(-36893485948395848000) ? a : r), u(2) - 536870912))), e;
                }
                function $r(r, e) {
                    return e ? e = Te(c[e >> 2]) : (v[6936] ? e = c[1733] : (e = ye(28), o[e + 20 >> 1] = 0, c[e + 16 >> 2] = 1065353216, o[e + 10 >> 1] = 0, o[e + 12 >> 1] = 0, c[e >> 2] = 0, c[e + 24 >> 2] = 0, f[e + 9 | 0] = 0, c[e + 4 >> 2] = 1, f[e + 22 | 0] = 0, c[1733] = e, f[6936] = 1, c[1732] = c[1732] + 1), e = Te(e)), c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, c[r >> 2] = e, c[e >> 2] = r, r;
                }
                function re(r, e, a) {
                    var i = 0, n = 0, t = 0;
                    if (e) for(; r = Ae(i = hr(r, e, 10), n = ir, 246, 0) + r | 0, f[0 | (a = a - 1 | 0)] = 48 | r, t = e >>> 0 > 9, r = i, e = n, t;);
                    else i = r;
                    if (i) for(; r = (i >>> 0) / 10 | 0, f[0 | (a = a - 1 | 0)] = w(r, 246) + i | 48, e = i >>> 0 > 9, i = r, e;);
                    return a;
                }
                function ee(r, e) {
                    var a = 0, i = 0;
                    r: {
                        e: if ((0 | (a = c[r + 556 >> 2])) != (0 | (i = c[r + 560 >> 2]))) {
                            for(;;){
                                if (c[a >> 2] == (0 | e)) break e;
                                if ((0 | i) == (0 | (a = a + 4 | 0))) break;
                            }
                            break r;
                        }
                        if ((0 | a) != (0 | i)) return wr(a, e = a + 4 | 0, i - e | 0), c[r + 560 >> 2] = i - 4, 1;
                    }
                    return 0;
                }
                function ae(r, e) {
                    var a, i, n = 0;
                    if (A(+r), a = 0 | u(1), i = 0 | u(0), 2047 != (0 | (n = a >>> 20 & 2047))) {
                        if (!n) return 0 == r ? n = 0 : (r = ae(0x10000000000000000 * r, e), n = c[e >> 2] + -64 | 0), c[e >> 2] = n, r;
                        c[e >> 2] = n - 1022, b(0, 0 | i), b(1, -2146435073 & a | 1071644672), r = +s();
                    }
                    return r;
                }
                function ie(r, e, a) {
                    var i = 0;
                    r: if (c[184 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[184 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ne(r, e, a) {
                    var i = 0;
                    r: if (c[192 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[192 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function te(r, e, a) {
                    var i = 0;
                    r: if (c[176 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[176 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function fe(r, e) {
                    var a = 0, i = 0, n = 0;
                    r: if (c[16 + (a = r + 24 | 0) >> 2] != (0 | e)) for(i = 0 | aa[9](a), n = e, c[i + 16 >> 2] = n;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function oe(r, e, a) {
                    var i = 0;
                    r: if (c[56 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[56 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ce(r, e, a) {
                    var i = 0;
                    r: if (c[92 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[92 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ue(r, e, a) {
                    var i = 0;
                    r: if (c[20 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[20 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function be(r, e) {
                    var a, i = y(0);
                    return r = r + 80 | 0, a = c[4236 + (e << 2) >> 2], 2139156720 == (0 | (r = 2 != (-2 & e) ? Hr(r, a, 2143289344) : _r(r, 5, a, 2143289344))) | 2140081935 == (0 | r) | 2141891242 == (0 | r) ? r = 1 : (b(2, r), r = (i = d()) == i), r;
                }
                function se(r, e) {
                    var a, i = y(0);
                    return r = r + 80 | 0, a = c[4220 + (e << 2) >> 2], 2139156720 == (0 | (r = 2 != (-2 & e) ? Hr(r, a, 2143289344) : _r(r, 4, a, 2143289344))) | 2140081935 == (0 | r) | 2141891242 == (0 | r) ? r = 1 : (b(2, r), r = (i = d()) == i), r;
                }
                function Ae(r, e, a, i) {
                    var n, t, f, o, c = 0, u = 0;
                    return o = w(c = a >>> 16 | 0, u = r >>> 16 | 0), c = (65535 & (u = ((f = w(n = 65535 & a, t = 65535 & r)) >>> 16 | 0) + w(u, n) | 0)) + w(c, t) | 0, ir = (w(e, a) + o | 0) + w(r, i) + (u >>> 16) + (c >>> 16) | 0, 65535 & f | c << 16;
                }
                function ke(r, e) {
                    var a, i, n = 0;
                    ar = a = ar - 16 | 0, i = -17 & (n = v[r + 4 | 0]), f[r + 4 | 0] = i;
                    r: {
                        if (e) {
                            if (c[r + 560 >> 2] != c[r + 556 >> 2]) break r;
                            n = 8 | i;
                        } else n &= 231;
                        return c[r + 8 >> 2] = e, f[r + 4 | 0] = n, void (ar = a + 16 | 0);
                    }
                    c[a >> 2] = 4059, Xr(r, a), De(), k();
                }
                function le(r, e, a, i, n) {
                    var t;
                    if (ar = t = ar - 256 | 0, !(73728 & n | (0 | a) <= (0 | i))) {
                        if (Rr(t, 255 & e, (a = (i = a - i | 0) >>> 0 < 256) ? i : 256), !a) for(; Pr(r, t, 256), (i = i - 256 | 0) >>> 0 > 255;);
                        Pr(r, t, i);
                    }
                    ar = t + 256 | 0;
                }
                function de(r, e, a) {
                    var i = 0, n = y(0);
                    2 == (-2 & a) && (n = m[(i = e - -64 | 0) >> 2], 2139156720 == (0 | (i = c[i >> 2])) | 2140081935 == (0 | i) | 2141891242 == (0 | i) | n == n) || (i = c[44 + ((c[4236 + (a << 2) >> 2] << 2) + e | 0) >> 2]), xr(r, i);
                }
                function ve(r, e, a) {
                    var i = 0, n = y(0);
                    2 == (-2 & a) && 2139156720 == (0 | (i = c[e + 60 >> 2])) | 2140081935 == (0 | i) | 2141891242 == (0 | i) | (n = m[e + 60 >> 2]) == n || (i = c[44 + ((c[4220 + (a << 2) >> 2] << 2) + e | 0) >> 2]), xr(r, i);
                }
                function he(r) {
                    var e = 0, a = 0, i = 0;
                    for(i = c[r >> 2]; xe(a = f[0 | i]);)i = i + 1 | 0, c[r >> 2] = i, e = e >>> 0 <= 214748364 ? (0 | (a = a - 48 | 0)) > (2147483647 ^ (e = w(e, 10))) ? -1 : a + e | 0 : -1;
                    return e;
                }
                function pe(r, e, a, i) {
                    var n = 0;
                    c[r + 12 >> 2] = 0, c[r + 16 >> 2] = i;
                    r: {
                        if (e) {
                            if (e >>> 0 >= 1073741824) break r;
                            n = ye(e << 2);
                        }
                        return c[r >> 2] = n, a = (a << 2) + n | 0, c[r + 8 >> 2] = a, c[r + 12 >> 2] = (e << 2) + n, c[r + 4 >> 2] = a, r;
                    }
                    ea(), k();
                }
                function me(r) {
                    var e = 0;
                    return e = c[r + 72 >> 2], c[r + 72 >> 2] = e - 1 | e, 8 & (e = c[r >> 2]) ? (c[r >> 2] = 32 | e, -1) : (c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, c[r + 16 >> 2] = e + c[r + 48 >> 2], 0);
                }
                function Ne(r, e, a, i) {
                    e |= 0, a |= 0, i |= 0;
                    var n = 0;
                    n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](e, a, i);
                }
                function we(r, e, a) {
                    e |= 0, a |= 0;
                    var i = 0;
                    return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), 0 | aa[0 | i](e, a);
                }
                function ye(r) {
                    var e = 0;
                    r = r || 1;
                    r: {
                        for(;;){
                            if (e = cr(r)) break r;
                            if (!(e = c[2022])) break;
                            aa[0 | e]();
                        }
                        I(), k();
                    }
                    return e;
                }
                function Ee(r, e, a) {
                    e |= 0, a |= 0;
                    var i = 0;
                    i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                }
                function Ge(r, e) {
                    e |= 0;
                    var a = 0;
                    return a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), 0 | aa[0 | a](e);
                }
                function Re(r, e) {
                    return (2147483647 & (l(r), u(2))) >>> 0 <= 2139095040 ? (2147483647 & (l(e), u(2))) >>> 0 > 2139095040 ? r : y(g(r, e)) : e;
                }
                function ge(r, e) {
                    return (2147483647 & (l(r), u(2))) >>> 0 <= 2139095040 ? (2147483647 & (l(e), u(2))) >>> 0 > 2139095040 ? r : y(R(r, e)) : e;
                }
                function Ze(r, e) {
                    var a;
                    return r |= 0, e |= 0, ar = a = ar - 16 | 0, c[a + 8 >> 2] = e, r = 0 | aa[0 | r](a + 8 | 0), X(c[a + 8 >> 2]), ar = a + 16 | 0, 0 | r;
                }
                function We(r, e) {
                    return r ? (57216 == (-128 & e) | e >>> 0 <= 127 ? (f[0 | r] = e, r = 1) : (c[1761] = 25, r = -1), r) : 0;
                }
                function Ve(r, e) {
                    var a, i;
                    a = ye(4), c[a >> 2] = e, i = ye(4), c[i >> 2] = e, O(6955, 0 | r, 7018, 4630, 192, 0 | a, 7018, 4634, 193, 0 | i);
                }
                function Be(r, e) {
                    var a, i;
                    a = ye(4), c[a >> 2] = e, i = ye(4), c[i >> 2] = e, O(6985, 0 | r, 7018, 4630, 190, 0 | a, 7018, 4634, 191, 0 | i);
                }
                function Te(r) {
                    var e, a;
                    return ar = e = ar - 16 | 0, a = br(ye(588), r), r || (c[e >> 2] = 2759, Xr(0, e), De(), k()), ar = e + 16 | 0, a;
                }
                function Ie(r, e) {
                    var a = 0;
                    1 & f[6964] ? a = c[1740] : (a = 0 | C(1, 4400), f[6964] = 1, c[1740] = a), z(0 | a, 0 | r, 0 | e, 0);
                }
                function Xe(r, e) {
                    e |= 0;
                    var a = 0;
                    a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), aa[0 | a](e);
                }
                function Oe(r) {
                    return c[(r |= 0) >> 2] = 4508, v[r + 4 | 0] && Ie(c[r + 8 >> 2], 1758), X(c[r + 8 >> 2]), 0 | r;
                }
                function Le(r) {
                    return c[(r |= 0) >> 2] = 4388, v[r + 4 | 0] && Ie(c[r + 8 >> 2], 1758), X(c[r + 8 >> 2]), 0 | r;
                }
                function _e(r, e, a) {
                    return se(r, e) ? Lr(r, e, a) : ((a = Or(r, e, a)) == a && (a = y(-a)), a);
                }
                function Fe(r) {
                    var e = 0;
                    (r |= 0) && ((e = c[r >> 2]) && gr(e), c[1732] = c[1732] - 1, gr(r));
                }
                function Ce(r, e, a) {
                    e |= 0, a = +a, N[c[(r |= 0) >> 2] + e >> 3] = a;
                }
                function Se(r, e) {
                    return e |= 0, +N[c[(r |= 0) >> 2] + e >> 3];
                }
                function Pe(r) {
                    (r |= 0) && aa[c[c[r >> 2] + 4 >> 2]](r);
                }
                function Ye(r) {
                    return r ? (c[1761] = r, -1) : 0;
                }
                function Ue(r, e, a) {
                    return y(Mr(r, e, a) + Ur(r, e, a));
                }
                function Me(r, e, a, i) {
                    D(0 | r, 0 | e, 8, 0, 0 | a, -1, 0 | i);
                }
                function He(r, e) {
                    e |= 0, aa[c[(r |= 0) >> 2]](e);
                }
                function Qe(r, e, a) {
                    return Zr(r, e, a, 2, 3);
                }
                function ze(r) {
                    return 0 | aa[0 | (r |= 0)]();
                }
                function je(r, e) {
                    e |= 0, aa[0 | (r |= 0)](e);
                }
                function De() {
                    aa[c[1470]](), ea(), k();
                }
                function xe(r) {
                    return r - 48 >>> 0 < 10;
                }
                function Je(r) {
                    (r |= 0) && gr(r);
                }
                function Ke(r) {
                    return 0 | r;
                }
                function qe(r) {
                    f[4 + (r |= 0) | 0] = 1;
                }
                function $e(r) {
                    k();
                }
                function ra() {
                    ea(), k();
                }
                function ea() {
                    I(), k();
                }
                n(e = v, 1024, "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"), n(e, 4270, "wH8AAAAAAADAfwMAAABpaQB2AHZp"), n(e, 4304, "KxsAACkbAABpGwAAYxsAAGkbAABjGwAAaWlpZmlmaQBcGwAALBsAAHZpaQAtGwAAcBsAAGlpaQ=="), n(e, 4368, "wwAAAMQAAADF"), n(e, 4388, "wwAAAMYAAADHAAAAXBs="), n(e, 4416, "KxsAAGkbAABjGwAAaRsAAGMbAABwGwAAaxsAAHAbAABpaWlpAAAAAFwbAABBGwAAXBsAAEMbAABEGwAAcBs="), n(e, 4488, "yAAAAMkAAADK"), n(e, 4508, "yAAAAMsAAADHAAAARxsAAFwbAABHGw=="), n(e, 4544, "XBsAAEcbAABjGwAAXRsAAHZpaWlpAAAAXBsAAEcbAABpGwAAdmlpZgAAAABcGwAARxsAAF0bAAB2aWlpAAAAAF0bAABIGwAAYxsAAF0bAABHGwAAaQBkaWkAdmlpZAAATBsAAEwbAABHGwAAXBsAAEwbAABcGwAATBsAAEsbAABcGwAATBsAAGMbAAAAAAAAXBsAAEwbAABjGwAAahsAAHZpaWlkAAAAXBsAAEwbAABqGwAAYxsAAE0bAABKGwAATRsAAGMbAABKGwAATRsAAGobAABNGwAAahsAAE0bAABjGwAAZGlpaQAAAABpGwAATBsAAGMbAABmaWlpAAAAAFwbAABMGwAATBsAAGQbAABcGwAATBsAAEwbAABkGwAATRsAAEwbAABMGwAATBsAAEwbAABkGwAAXRsAAEwbAABcGwAATBsAAF0bAABcGwAATBsAACkbAABcGwAATBsAAEEbAABdGwAATRsAAAAAAABcGwAATBsAAGobAABqGwAAYxsAAHZpaWRkaQAASRsAAE0b"), n(e, 4960, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), n(e, 5041, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), n(e, 5099, "DA=="), n(e, 5111, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), n(e, 5157, "EA=="), n(e, 5169, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), n(e, 5215, "Eg=="), n(e, 5227, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), n(e, 5282, "GgAAABoaGgAAAAAAAAk="), n(e, 5331, "FA=="), n(e, 5343, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), n(e, 5389, "Fg=="), n(e, 5401, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), n(e, 5476, "0Q=="), n(e, 5516, "//////////8="), n(e, 5584, "oB8BAAAAAAAF"), n(e, 5604, "zA=="), n(e, 5628, "zQAAAM4AAACEGw=="), n(e, 5652, "Ag=="), n(e, 5668, "//////////8="), n(e, 5736, "BQ=="), n(e, 5748, "zw=="), n(e, 5772, "zQAAANAAAACYGwAAAAQ="), n(e, 5796, "AQ=="), n(e, 5812, "/////wo="), n(e, 5880, "0g==");
                var aa = function(r) {
                    return r.set = function(r, e) {
                        this[r] = e;
                    }, r.get = function(r) {
                        return this[r];
                    }, r;
                }([
                    null,
                    function(r, e, a, i, n) {
                        return i |= 0, n |= 0, (a |= 0) && 5 != (0 | a) ? 0 | Qe(5736, i, n) : 0 | Qe(5592, i, n);
                    },
                    function(r, e, a, i, n, t) {
                        r |= 0, e = +e, a |= 0, i |= 0, n |= 0, t |= 0;
                        var o, b = 0, s = 0, k = 0, l = 0, d = 0, h = 0, p = 0, m = 0, N = 0, y = 0, G = 0, R = 0, g = 0, Z = 0, W = 0, V = 0, B = 0, T = 0;
                        ar = o = ar - 560 | 0, c[o + 44 >> 2] = 0, A(+e), b = 0 | u(1), u(0), (0 | b) < 0 ? (R = 1, B = 1176, A(+(e = -e)), b = 0 | u(1), u(0)) : 2048 & n ? (R = 1, B = 1179) : (B = (R = 1 & n) ? 1182 : 1177, T = !R);
                        r: if (2146435072 != (2146435072 & b)) {
                            Z = o + 16 | 0;
                            e: {
                                a: {
                                    i: {
                                        if (e = ae(e, o + 44 | 0), 0 != (e += e)) {
                                            if (b = c[o + 44 >> 2], c[o + 44 >> 2] = b - 1, 97 != (0 | (W = 32 | t))) break i;
                                            break e;
                                        }
                                        if (97 == (0 | (W = 32 | t))) break e;
                                        d = c[o + 44 >> 2], h = (0 | i) < 0 ? 6 : i;
                                        break a;
                                    }
                                    d = b - 29 | 0, c[o + 44 >> 2] = d, e *= 268435456, h = (0 | i) < 0 ? 6 : i;
                                }
                                for(s = y = (o + 48 | 0) + ((0 | d) >= 0 ? 288 : 0) | 0; i = e < 4294967296 & e >= 0 ? ~~e >>> 0 : 0, c[s >> 2] = i, s = s + 4 | 0, 0 != (e = 1e9 * (e - +(i >>> 0))););
                                if ((0 | d) <= 0) i = d, b = s, k = y;
                                else for(k = y, i = d;;){
                                    if (m = (0 | i) >= 29 ? 29 : i, !(k >>> 0 > (b = s - 4 | 0) >>> 0)) {
                                        for(i = 0; l = c[b >> 2], V = i, i = 31 & m, (63 & m) >>> 0 >= 32 ? (p = l << i, i = 0) : (p = (1 << i) - 1 & l >>> 32 - i, i = l << i), l = p + N | 0, l = Ae(i = hr(V = V + i | 0, i >>> 0 > V >>> 0 ? l + 1 | 0 : l, 1e9), ir, -1000000000, 0) + V | 0, c[b >> 2] = l, k >>> 0 <= (b = b - 4 | 0) >>> 0;);
                                        i && (c[(k = k - 4 | 0) >> 2] = i);
                                    }
                                    for(; k >>> 0 < (b = s) >>> 0 && !c[(s = b - 4 | 0) >> 2];);
                                    if (i = c[o + 44 >> 2] - m | 0, c[o + 44 >> 2] = i, s = b, !((0 | i) > 0)) break;
                                }
                                if ((0 | i) < 0) for(g = 1 + ((h + 25 >>> 0) / 9 | 0) | 0, N = 102 == (0 | W);;){
                                    if (p = (0 | (i = 0 - i | 0)) >= 9 ? 9 : i, b >>> 0 <= k >>> 0) s = c[k >> 2];
                                    else {
                                        for(m = 1e9 >>> p | 0, l = -1 << p ^ -1, i = 0, s = k; V = i, i = c[s >> 2], c[s >> 2] = V + (i >>> p | 0), i = w(m, i & l), (s = s + 4 | 0) >>> 0 < b >>> 0;);
                                        s = c[k >> 2], i && (c[b >> 2] = i, b = b + 4 | 0);
                                    }
                                    if (i = p + c[o + 44 >> 2] | 0, c[o + 44 >> 2] = i, k = (!s << 2) + k | 0, b = b - (s = N ? y : k) >> 2 > (0 | g) ? s + (g << 2) | 0 : b, !((0 | i) < 0)) break;
                                }
                                if (i = 0, !(b >>> 0 <= k >>> 0 || (i = w(y - k >> 2, 9), s = 10, (l = c[k >> 2]) >>> 0 < 10))) for(; i = i + 1 | 0, l >>> 0 >= (s = w(s, 10)) >>> 0;);
                                if ((0 | (s = (h - (102 != (0 | W) ? i : 0) | 0) - (103 == (0 | W) & 0 != (0 | h)) | 0)) < (w(b - y >> 2, 9) - 9 | 0)) {
                                    if (d = ((((0 | d) < 0 ? 4 : 292) + o | 0) + ((l = (0 | (m = s + 9216 | 0)) / 9 | 0) << 2) | 0) - 4048 | 0, s = 10, (0 | (p = m + w(l, -9) | 0)) <= 7) for(; s = w(s, 10), 8 != (0 | (p = p + 1 | 0)););
                                    if (!((0 | (m = c[d >> 2])) == (0 | (N = w(g = (m >>> 0) / (s >>> 0) | 0, s))) & (0 | (l = d + 4 | 0)) == (0 | b)) && (m = m - N | 0, !(1 & g) && (e = 9007199254740992, !(1 & f[d - 4 | 0]) | 1e9 != (0 | s) | k >>> 0 >= d >>> 0) || (e = 9007199254740994), G = (0 | b) == (0 | l) ? 1 : 1.5, G = (l = s >>> 1 | 0) >>> 0 > m >>> 0 ? .5 : (0 | l) == (0 | m) ? G : 1.5, 45 != v[0 | B] | T || (G = -G, e = -e), c[d >> 2] = N, e + G != e)) {
                                        if (i = s + N | 0, c[d >> 2] = i, i >>> 0 >= 1e9) for(; c[d >> 2] = 0, (d = d - 4 | 0) >>> 0 < k >>> 0 && (c[(k = k - 4 | 0) >> 2] = 0), i = c[d >> 2] + 1 | 0, c[d >> 2] = i, i >>> 0 > 999999999;);
                                        if (i = w(y - k >> 2, 9), s = 10, !((l = c[k >> 2]) >>> 0 < 10)) for(; i = i + 1 | 0, l >>> 0 >= (s = w(s, 10)) >>> 0;);
                                    }
                                    b = b >>> 0 > (s = d + 4 | 0) >>> 0 ? s : b;
                                }
                                for(; l = b, !(m = b >>> 0 <= k >>> 0) && !c[(b = l - 4 | 0) >> 2];);
                                if (103 == (0 | W)) {
                                    if (h = ((b = (0 | (s = h || 1)) > (0 | i) & (0 | i) > -5) ? -1 ^ i : -1) + s | 0, t = (b ? -1 : -2) + t | 0, !(d = 8 & n)) {
                                        if (b = -9, !m && (d = c[l - 4 >> 2]) && (p = 10, b = 0, !((d >>> 0) % 10 | 0))) {
                                            for(; s = b, b = b + 1 | 0, !((d >>> 0) % ((p = w(p, 10)) >>> 0) | 0););
                                            b = -1 ^ s;
                                        }
                                        s = w(l - y >> 2, 9), 70 != (-33 & t) ? (d = 0, h = (0 | (b = (0 | (b = ((i + s | 0) + b | 0) - 9 | 0)) > 0 ? b : 0)) > (0 | h) ? h : b) : (d = 0, h = (0 | (b = (0 | (b = (b + s | 0) - 9 | 0)) > 0 ? b : 0)) > (0 | h) ? h : b);
                                    }
                                } else d = 8 & n;
                                if (p = -1, (0 | ((m = d | h) ? 2147483645 : 2147483646)) < (0 | h)) break r;
                                if (N = 1 + ((0 != (0 | m)) + h | 0) | 0, 70 != (0 | (s = -33 & t))) {
                                    if ((Z - (b = re(((b = i >> 31) ^ i) - b | 0, 0, Z)) | 0) <= 1) for(; f[0 | (b = b - 1 | 0)] = 48, (Z - b | 0) < 2;);
                                    if (f[0 | (g = b - 2 | 0)] = t, f[b - 1 | 0] = (0 | i) < 0 ? 45 : 43, (0 | (b = Z - g | 0)) > (2147483647 ^ N)) break r;
                                } else {
                                    if ((2147483647 ^ N) < (0 | i)) break r;
                                    b = (0 | i) > 0 ? i : 0;
                                }
                                if ((0 | (i = b + N | 0)) > (2147483647 ^ R)) break r;
                                le(r, 32, a, N = i + R | 0, n), Pr(r, B, R), le(r, 48, a, N, 65536 ^ n);
                                a: {
                                    i: {
                                        n: {
                                            if (70 == (0 | s)) {
                                                for(i = 8 | (t = o + 16 | 0), d = 9 | t, k = s = k >>> 0 > y >>> 0 ? y : k;;){
                                                    b = re(c[k >> 2], 0, d);
                                                    t: if ((0 | s) == (0 | k)) (0 | b) == (0 | d) && (f[o + 24 | 0] = 48, b = i);
                                                    else {
                                                        if (o + 16 >>> 0 >= b >>> 0) break t;
                                                        for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                    }
                                                    if (Pr(r, b, d - b | 0), !(y >>> 0 >= (k = k + 4 | 0) >>> 0)) break;
                                                }
                                                if (m && Pr(r, 4206, 1), (0 | h) <= 0 | k >>> 0 >= l >>> 0) break n;
                                                for(;;){
                                                    if ((b = re(c[k >> 2], 0, d)) >>> 0 > o + 16 >>> 0) for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                    if (Pr(r, b, (0 | h) >= 9 ? 9 : h), b = h - 9 | 0, l >>> 0 <= (k = k + 4 | 0) >>> 0) break i;
                                                    if (i = (0 | h) > 9, h = b, !i) break;
                                                }
                                                break i;
                                            }
                                            t: if (!((0 | h) < 0)) for(y = k >>> 0 < l >>> 0 ? l : k + 4 | 0, i = 8 | (t = o + 16 | 0), l = 9 | t, s = k;;){
                                                (0 | l) == (0 | (b = re(c[s >> 2], 0, l))) && (f[o + 24 | 0] = 48, b = i);
                                                f: if ((0 | s) == (0 | k)) Pr(r, b, 1), b = b + 1 | 0, d | h && Pr(r, 4206, 1);
                                                else {
                                                    if (o + 16 >>> 0 >= b >>> 0) break f;
                                                    for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                }
                                                if (Pr(r, b, (0 | (t = l - b | 0)) > (0 | h) ? h : t), h = h - t | 0, y >>> 0 <= (s = s + 4 | 0) >>> 0) break t;
                                                if (!((0 | h) >= 0)) break;
                                            }
                                            le(r, 48, h + 18 | 0, 18, 0), Pr(r, g, Z - g | 0);
                                            break a;
                                        }
                                        b = h;
                                    }
                                    le(r, 48, b + 9 | 0, 9, 0);
                                }
                                le(r, 32, a, N, 8192 ^ n), p = (0 | a) < (0 | N) ? N : a;
                                break r;
                            }
                            if (d = (t << 26 >> 31 & 9) + B | 0, !(i >>> 0 > 11)) {
                                for(b = 12 - i | 0, G = 16; G *= 16, b = b - 1 | 0;);
                                e = 45 != v[0 | d] ? e + G - G : -(G + (-e - G));
                            }
                            for(y = 2 | R, k = 32 & t, (0 | Z) == (0 | (b = re(((b = (s = c[o + 44 >> 2]) >> 31) ^ s) - b | 0, 0, Z))) && (f[o + 15 | 0] = 48, b = o + 15 | 0), f[0 | (h = b - 2 | 0)] = t + 15, f[b - 1 | 0] = (0 | s) < 0 ? 45 : 43, b = 8 & n, s = o + 16 | 0; t = s, l = E(e) < 2147483648 ? ~~e : -2147483648, f[0 | s] = k | v[l + 5424 | 0], !(b | (0 | i) > 0) & 0 == (e = 16 * (e - +(0 | l))) | 1 != ((s = t + 1 | 0) - (o + 16 | 0) | 0) || (f[t + 1 | 0] = 46, s = t + 2 | 0), 0 != e;);
                            p = -1, (2147483645 - (t = (b = Z - h | 0) + y | 0) | 0) < (0 | i) || (le(r, 32, a, t = (i = !i || ((k = s - (o + 16 | 0) | 0) - 2 | 0) >= (0 | i) ? k = s - (o + 16 | 0) | 0 : i + 2 | 0) + t | 0, n), Pr(r, d, y), le(r, 48, a, t, 65536 ^ n), Pr(r, o + 16 | 0, k), le(r, 48, i - k | 0, 0, 0), Pr(r, h, b), le(r, 32, a, t, 8192 ^ n), p = (0 | a) < (0 | t) ? t : a);
                        } else le(r, 32, a, b = R + 3 | 0, -65537 & n), Pr(r, B, R), i = 32 & t, Pr(r, e != e ? i ? 2450 : 3390 : i ? 2819 : 3394, 3), le(r, 32, a, b, 8192 ^ n), p = (0 | a) < (0 | b) ? b : a;
                        return ar = o + 560 | 0, 0 | p;
                    },
                    function(r, e) {
                        r |= 0;
                        var a, i, n, t, f, o = 0, u = 0, A = 0, k = 0, l = 0, d = 0, v = 0, h = 0, p = 0, m = 0, w = 0;
                        o = e |= 0, e = c[e >> 2] + 7 & -8, c[o >> 2] = e + 16, n = r, d = c[e >> 2], u = c[e + 4 >> 2], i = r = c[e + 12 >> 2], ar = a = ar - 32 | 0, l = r &= 2147483647;
                        r: if ((0 | (A = r - 1006698496 | 0)) == (0 | (r = r - 1140785152 | 0)) & (e = o = c[e + 8 >> 2]) >>> 0 < e >>> 0 | r >>> 0 > A >>> 0) {
                            if (e = (r = o) << 4 | u >>> 28, r = o = i << 4 | r >>> 28, 134217728 == (0 | (u &= 268435455)) & 0 != (0 | d) | u >>> 0 > 134217728) {
                                r = r + 1073741824 | 0, r = (e = e + 1 | 0) ? r : r + 1 | 0;
                                break r;
                            }
                            if (r = r + 1073741824 | 0, d | 134217728 != (0 | u)) break r;
                            r = (e = (u = 1 & e) + e | 0) >>> 0 < u >>> 0 ? r + 1 | 0 : r;
                        } else (!e & 2147418112 == (0 | l) ? !(u | d) : l >>> 0 < 2147418112) ? (e = 0, r = 2146435072, l >>> 0 > 1140785151 || (r = 0, (m = l >>> 16 | 0) >>> 0 < 15249 || (e = d, r = u, l = A = 65535 & i | 65536, p = o, k = o, 64 & (v = m - 15233 | 0) ? (o = e, e = 31 & (A = v + -64 | 0), (63 & A) >>> 0 >= 32 ? (r = o << e, k = 0) : (r = (1 << e) - 1 & o >>> 32 - e | r << e, k = o << e), A = r, e = 0, r = 0) : v && (h = k, k = 31 & v, (63 & v) >>> 0 >= 32 ? (o = h << k, k = 0) : (o = (1 << k) - 1 & h >>> 32 - k | A << k, k = h << k), A = o, w = k, h = e, k = 31 & (o = 64 - v | 0), (63 & o) >>> 0 >= 32 ? (o = 0, e = r >>> k | 0) : (o = r >>> k | 0, e = ((1 << k) - 1 & r) << 32 - k | h >>> k), k = w | e, A |= o, e = 31 & v, (63 & v) >>> 0 >= 32 ? (o = h << e, e = 0) : (o = (1 << e) - 1 & h >>> 32 - e | r << e, e = h << e), r = o), c[a + 16 >> 2] = e, c[a + 20 >> 2] = r, c[a + 24 >> 2] = k, c[a + 28 >> 2] = A, 64 & (e = 15361 - m | 0) ? (u = p, r = 31 & (e = e + -64 | 0), (63 & e) >>> 0 >= 32 ? (o = 0, d = l >>> r | 0) : (o = l >>> r | 0, d = ((1 << r) - 1 & l) << 32 - r | u >>> r), u = o, p = 0, l = 0) : e && (A = p, o = 31 & (r = 64 - e | 0), (63 & r) >>> 0 >= 32 ? (r = A << o, k = 0) : (r = (1 << o) - 1 & A >>> 32 - o | l << o, k = A << o), A = d, d = 31 & e, (63 & e) >>> 0 >= 32 ? (o = 0, A = u >>> d | 0) : (o = u >>> d | 0, A = ((1 << d) - 1 & u) << 32 - d | A >>> d), d = k | A, u = r | o, A = p, o = 31 & e, (63 & e) >>> 0 >= 32 ? (r = 0, p = l >>> o | 0) : (r = l >>> o | 0, p = ((1 << o) - 1 & l) << 32 - o | A >>> o), l = r), c[a >> 2] = d, c[a + 4 >> 2] = u, c[a + 8 >> 2] = p, c[a + 12 >> 2] = l, e = c[a + 8 >> 2], r = c[a + 12 >> 2] << 4 | e >>> 28, e <<= 4, o = c[a >> 2], e |= (l = c[a + 4 >> 2]) >>> 28, 134217728 == (0 | (u = 268435455 & l)) & 0 != (0 | (o |= 0 != (c[a + 16 >> 2] | c[a + 24 >> 2] | c[a + 20 >> 2] | c[a + 28 >> 2]))) | u >>> 0 > 134217728 ? r = (e = e + 1 | 0) ? r : r + 1 | 0 : o | 134217728 != (0 | u) || (r = (o = e) >>> 0 > (e = e + (1 & e) | 0) >>> 0 ? r + 1 | 0 : r)))) : (e = (r = o) << 4 | u >>> 28, r = 524287 & (o = i << 4 | r >>> 28) | 2146959360);
                        ar = a + 32 | 0, b(0, 0 | e), b(1, -2147483648 & i | r), t = n, f = +s(), N[t >> 3] = f;
                    },
                    Ke,
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 7, c[r >> 2] = e;
                    },
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 10, c[r >> 2] = e;
                    },
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 13, c[r >> 2] = e;
                    },
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    function(r, e, a, i, n, t) {
                        var f;
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0, ar = f = ar - 16 | 0, e = c[c[e >> 2] + 4 >> 2], aa[c[c[e >> 2] + 8 >> 2]](f, e, a, i, n, t), m[r >> 2] = N[f >> 3], m[r + 4 >> 2] = N[f + 8 >> 3], ar = f + 16 | 0;
                    },
                    function(r) {
                        r = c[c[(r |= 0) >> 2] + 8 >> 2], aa[c[c[r >> 2] + 8 >> 2]](r);
                    },
                    tr,
                    function(r) {
                        return 6952;
                    },
                    Pe,
                    function(r, e, a, i, n, t) {
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0;
                        var f, o = 0;
                        return ar = f = ar - 16 | 0, o = c[r >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (o = c[o + c[e >> 2] >> 2]), aa[0 | o](f, e, a, i, n, t), r = ye(16), e = c[f + 12 >> 2], c[r + 8 >> 2] = c[f + 8 >> 2], c[r + 12 >> 2] = e, e = c[f + 4 >> 2], c[r >> 2] = c[f >> 2], c[r + 4 >> 2] = e, ar = f + 16 | 0, 0 | r;
                    },
                    function(r) {
                        return 6956;
                    },
                    Ke,
                    Ke,
                    Pe,
                    qe,
                    He,
                    Ze,
                    function(r) {
                        var e;
                        return r |= 0, e = ye(12), f[e + 4 | 0] = 0, c[e + 8 >> 2] = c[r >> 2], c[r >> 2] = 0, c[e >> 2] = 4368, 0 | e;
                    },
                    function(r, e, a) {
                        r |= 0, a |= 0;
                        var i, n, t = 0, o = 0;
                        if (ar = i = ar - 32 | 0, (n = c[(e |= 0) >> 2]) >>> 0 < 2147483632) {
                            r: {
                                if (n >>> 0 >= 11) o = ye(t = 1 + (15 | n) | 0), c[i + 16 >> 2] = -2147483648 | t, c[i + 8 >> 2] = o, c[i + 12 >> 2] = n, t = n + o | 0;
                                else if (f[i + 19 | 0] = n, t = (o = i + 8 | 0) + n | 0, !n) break r;
                                Ar(o, e + 4 | 0, n);
                            }
                            return f[0 | t] = 0, c[i >> 2] = a, aa[0 | r](i + 24 | 0, i + 8 | 0, i), M(c[i + 24 >> 2]), r = c[i + 24 >> 2], X(0 | r), X(c[i >> 2]), f[i + 19 | 0] < 0 && gr(c[i + 8 >> 2]), ar = i + 32 | 0, 0 | r;
                        }
                        I(), k();
                    },
                    function(r, e, a) {
                        var i, n;
                        a |= 0, i = r |= 0, n = 0 | U(0 | (f[11 + (e |= 0) | 0] < 0 ? c[e >> 2] : e), 6956, c[a >> 2]), c[i >> 2] = n;
                    },
                    function(r) {
                        return 6976;
                    },
                    Pe,
                    Xe,
                    function(r) {
                        return 6979;
                    },
                    Ke,
                    Ke,
                    Pe,
                    qe,
                    He,
                    Ze,
                    function(r) {
                        var e;
                        return r |= 0, e = ye(12), f[e + 4 | 0] = 0, c[e + 8 >> 2] = c[r >> 2], c[r >> 2] = 0, c[e >> 2] = 4488, 0 | e;
                    },
                    function(r, e, a) {
                        var i, n;
                        a |= 0, i = r |= 0, n = 0 | U(0 | (f[11 + (e |= 0) | 0] < 0 ? c[e >> 2] : e), 6979, c[a >> 2]), c[i >> 2] = n;
                    },
                    function(r) {
                        return 6982;
                    },
                    Fe,
                    ze,
                    function() {
                        var r, e;
                        return e = ye(4), r = ye(28), o[r + 20 >> 1] = 0, c[r + 16 >> 2] = 1065353216, o[r + 10 >> 1] = 0, o[r + 12 >> 1] = 0, c[r >> 2] = 0, c[r + 24 >> 2] = 0, f[r + 9 | 0] = 0, c[r + 4 >> 2] = 1, f[r + 22 | 0] = 0, c[1732] = c[1732] + 1, c[e >> 2] = r, 0 | e;
                    },
                    je,
                    Fe,
                    function(r, e, a) {
                        e |= 0, a |= 0, f[20 + (c[(r |= 0) >> 2] + e | 0) | 0] = a;
                    },
                    Ne,
                    function(r, e) {
                        r |= 0, e = y(e);
                        var a, i = 0, n = 0;
                        ar = a = ar - 16 | 0, r = c[r >> 2], e >= y(0) || (c[a >> 2] = 2262, ar = i = ar - 16 | 0, c[i + 12 >> 2] = a, r || (v[6936] ? r = c[1733] : (r = ye(28), o[r + 20 >> 1] = 0, c[r + 16 >> 2] = 1065353216, o[r + 10 >> 1] = 0, o[r + 12 >> 1] = 0, c[r >> 2] = 0, c[r + 24 >> 2] = 0, f[r + 9 | 0] = 0, c[r + 4 >> 2] = 1, f[r + 22 | 0] = 0, c[1733] = r, f[6936] = 1, c[1732] = c[1732] + 1)), n = c[r + 4 >> 2], v[r + 9 | 0] ? aa[0 | n](r, 0, 5, 0, 4215, a) : aa[0 | n](r, 0, 5, 4215, a), ar = i + 16 | 0, De(), k()), m[r + 16 >> 2] = e == y(0) ? y(0) : e, ar = a + 16 | 0;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a = y(a);
                        var i = 0;
                        i = c[r >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                    },
                    function(r, e) {
                        e |= 0, f[c[(r |= 0) >> 2] + 11 | 0] = e;
                    },
                    Ee,
                    function(r, e) {
                        e |= 0, f[c[(r |= 0) >> 2] + 10 | 0] = e;
                    },
                    function(r, e) {
                        return e |= 0, v[20 + (c[(r |= 0) >> 2] + e | 0) | 0];
                    },
                    we,
                    function(r) {
                        return v[c[(r |= 0) >> 2] + 11 | 0];
                    },
                    Ge,
                    function(r) {
                        return v[c[(r |= 0) >> 2] + 10 | 0];
                    },
                    function() {
                        return 0 | Rr(ye(48), 0, 48);
                    },
                    Je,
                    function() {
                        var r;
                        return r = ye(16), c[r >> 2] = 0, c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, 0 | r;
                    },
                    Je,
                    function() {
                        var r;
                        return r = ye(16), c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, c[r >> 2] = 0, 0 | r;
                    },
                    Je,
                    Se,
                    Ce,
                    function(r, e) {
                        return e |= 0, c[c[(r |= 0) >> 2] + e >> 2];
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0, c[c[(r |= 0) >> 2] + e >> 2] = a;
                    },
                    function(r) {
                        return 6987;
                    },
                    Cr,
                    ze,
                    function() {
                        return 0 | $r(ye(12), 0);
                    },
                    function(r, e) {
                        return e |= 0, 0 | aa[0 | (r |= 0)](e);
                    },
                    function(r) {
                        return r |= 0, 0 | $r(ye(12), r);
                    },
                    je,
                    Cr,
                    function(r) {
                        var e, a = 0, i = 0, n = 0;
                        ar = e = ar - 624 | 0, a = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = 0, a && aa[c[c[a >> 2] + 4 >> 2]](a), a = c[r + 8 >> 2], c[r + 8 >> 2] = 0, a && aa[c[c[a >> 2] + 4 >> 2]](a);
                        r: {
                            if (r = c[r >> 2], c[r + 560 >> 2] == c[r + 556 >> 2]) {
                                if (c[r + 552 >> 2]) break r;
                                return Sr(r + 556 | 0), n = f[r + 4 | 0], a = br(e + 32 | 0, c[r + 568 >> 2]), i = c[a + 4 >> 2], c[r >> 2] = c[a >> 2], c[r + 4 >> 2] = i, i = c[a + 20 >> 2], c[r + 16 >> 2] = c[a + 16 >> 2], c[r + 20 >> 2] = i, i = c[a + 12 >> 2], c[r + 8 >> 2] = c[a + 8 >> 2], c[r + 12 >> 2] = i, Ar(r + 24 | 0, a + 24 | 0, 204), Ar(r + 228 | 0, a + 228 | 0, 328), (i = c[r + 556 >> 2]) && (c[r + 560 >> 2] = i, gr(i)), c[r + 556 >> 2] = c[a + 556 >> 2], c[r + 560 >> 2] = c[a + 560 >> 2], c[r + 564 >> 2] = c[a + 564 >> 2], c[r + 584 >> 2] = c[a + 584 >> 2], i = c[a + 580 >> 2], c[r + 576 >> 2] = c[a + 576 >> 2], c[r + 580 >> 2] = i, i = c[a + 572 >> 2], c[r + 568 >> 2] = c[a + 568 >> 2], c[r + 572 >> 2] = i, (0 | n) < 0 && (f[r + 4 | 0] = 128 | v[r + 4 | 0], c[r + 24 >> 2] = -909 & c[r + 24 >> 2] | 520), void (ar = e + 624 | 0);
                            }
                            c[e + 16 >> 2] = 3252, Xr(r, e + 16 | 0), De(), k();
                        }
                        c[e >> 2] = 2046, Xr(r, e), De(), k();
                    },
                    Xe,
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0), n = 0, t = 0, o = y(0), u = 0, s = 0, A = 0, k = y(0);
                        r: {
                            s = c[e >> 2], e = c[r >> 2];
                            e: if (!(8388607 & (c[s + 24 >> 2] ^ c[e + 24 >> 2]))) {
                                k = m[s + 40 >> 2], n = c[s + 40 >> 2], i = m[e + 40 >> 2];
                                a: {
                                    i: {
                                        if (2139156720 != (0 | (a = c[e + 40 >> 2]))) {
                                            if (o = y(NaN), r = 3, 2141891242 == (0 | a)) break a;
                                            if (2140081935 != (0 | a)) break i;
                                            o = y(0), r = 1;
                                            break a;
                                        }
                                        r = 2;
                                        break a;
                                    }
                                    r = 0, i == i && (b(2, 536870912 + (-1073741825 & a) | 0), o = d(), r = 1073741824 & a ? 2 : 1);
                                }
                                a: {
                                    i: {
                                        if (2139156720 != (0 | n)) {
                                            if (i = y(NaN), a = 3, 2141891242 == (0 | n)) break a;
                                            if (2140081935 != (0 | n)) break i;
                                            i = y(0), a = 1;
                                            break a;
                                        }
                                        i = y(0), a = 2;
                                        break a;
                                    }
                                    a = 0, k == k && (b(2, 536870912 + (-1073741825 & n) | 0), i = d(), a = 1073741824 & n ? 2 : 1);
                                }
                                if (!((0 | a) != (0 | r) | !(!r | o != o & i != i | y(E(y(o - i))) < y(9999999747378752e-20))) && (t = s + 44 | 0, c[(a = e + 44 | 0) >> 2] == c[t >> 2])) {
                                    r = 0;
                                    a: {
                                        for(;;){
                                            if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                            if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                        }
                                        if (n >>> 0 < 8) break e;
                                    }
                                    if (t = s + 80 | 0, c[(a = e + 80 | 0) >> 2] == c[t >> 2]) {
                                        r = 0;
                                        a: {
                                            for(;;){
                                                if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                            }
                                            if (n >>> 0 < 8) break e;
                                        }
                                        if (t = s + 116 | 0, c[(a = e + 116 | 0) >> 2] == c[t >> 2]) {
                                            r = 0;
                                            a: {
                                                for(;;){
                                                    if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                    if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                }
                                                if (n >>> 0 < 8) break e;
                                            }
                                            if (t = s + 152 | 0, c[(a = e + 152 | 0) >> 2] == c[t >> 2]) {
                                                r = 0;
                                                a: {
                                                    for(;;){
                                                        if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                        if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                    }
                                                    if (n >>> 0 < 8) break e;
                                                }
                                                if (t = s + 188 | 0, c[(a = e + 188 | 0) >> 2] == c[t >> 2]) {
                                                    r = 0;
                                                    a: {
                                                        for(;;){
                                                            if (n = r, 3 == (0 | (r = r + 1 | 0))) break a;
                                                            if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                        }
                                                        if (n >>> 0 < 2) break e;
                                                    }
                                                    for(u = s + 200 | 0, A = e + 200 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                    if ((0 | a) == (0 | t)) {
                                                        for(u = s + 208 | 0, A = e + 208 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                        if ((0 | a) == (0 | t)) {
                                                            for(u = s + 216 | 0, A = e + 216 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                            if ((0 | a) == (0 | t) && !((0 | (r = (o = m[s + 28 >> 2]) != o)) == ((i = m[e + 28 >> 2]) == i | 0) | !(r | i != i) & i != o || ((i = m[e + 32 >> 2]) == i | 0) == ((o = m[s + 32 >> 2]) != o | 0) | i == i & i != o || (0 | (r = (o = m[s + 36 >> 2]) != o)) == ((i = m[e + 36 >> 2]) == i | 0) | !r & i != o)) {
                                                                if (r = 0, (i = m[e + 224 >> 2]) != i && (r = 1, (o = m[s + 224 >> 2]) != o)) break r;
                                                                if ((o = i) == (i = m[s + 224 >> 2]) | i != i & r) break r;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            for(Ar(e + 24 | 0, s + 24 | 0, 204);;){
                                if (4 & (r = v[e + 4 | 0])) break r;
                                if (f[e + 4 | 0] = 4 | r, (r = c[e + 20 >> 2]) && aa[0 | r](e), c[e + 308 >> 2] = 2143289344, !(e = c[e + 552 >> 2])) break;
                            }
                        }
                    },
                    Ee,
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 16 & 3) != (0 | e)) for(c[r + 24 >> 2] = -196609 & a | e << 16 & 196608;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    Ee,
                    function(r, e, a) {
                        e |= 0, a = +a, oe(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a, i) {
                        e |= 0, a |= 0, i = +i;
                        var n = 0;
                        n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](e, a, i);
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, oe(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 5, e);
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 6, e);
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 7, e);
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 2 & 3) != (0 | e)) for(c[r + 24 >> 2] = -13 & a | e << 2 & 12;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 18 & 3) != (0 | e)) for(c[r + 24 >> 2] = -786433 & a | e << 18 & 786432;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 4 & 7) != (0 | e)) for(c[r + 24 >> 2] = -113 & a | e << 4 & 112;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ue(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ue(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e) {
                        e |= 0, ue(c[(r |= 0) >> 2], e, 2141891242);
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 20 & 3) != (0 | e)) for(c[r + 24 >> 2] = -3145729 & a | e << 20 & 3145728;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 22 & 1) != (0 | e)) for(c[r + 24 >> 2] = -4194305 & a | e << 22 & 4194304;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 28 >> 2]) | i != i & n != n)) for(m[r + 28 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                    },
                    function(r, e) {
                        e = +e, fe(c[(r |= 0) >> 2], qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, fe(c[(r |= 0) >> 2], Kr(y(e)));
                    },
                    function(r) {
                        fe(c[(r |= 0) >> 2], 2141891242);
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 32 >> 2]) | i != i & n != n)) for(m[r + 32 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 36 >> 2]) | i != i & n != n)) for(m[r + 36 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r) {
                        te(c[(r |= 0) >> 2], 0, 2141891242);
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r) {
                        te(c[(r |= 0) >> 2], 1, 2141891242);
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 224 >> 2]) | i != i & n != n)) for(m[r + 224 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        r: if (r = c[(r |= 0) >> 2], (0 | c[152 + (e = r + (e << 2) | 0) >> 2]) != (0 | (i = qr(y(a))))) for(c[e + 152 >> 2] = i;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ce(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ce(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        r: if (r = c[(r |= 0) >> 2], (0 | c[188 + (e = r + (e << 2) | 0) >> 2]) != (0 | (i = qr(y(a))))) for(c[e + 188 >> 2] = i;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r) {
                        return 3 & h[c[(r |= 0) >> 2] + 26 >> 1];
                    },
                    Ge,
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 80 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 80 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0;
                        return ar = i = ar - 16 | 0, n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](i, e, a), r = ye(16), e = c[i + 12 >> 2], c[r + 8 >> 2] = c[i + 8 >> 2], c[r + 12 >> 2] = e, e = c[i + 4 >> 2], c[r >> 2] = c[i >> 2], c[r + 4 >> 2] = e, ar = i + 16 | 0, 0 | r;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 7 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 10 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 13 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 2 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 18 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 4 & 7;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 44 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 44 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0), n = y(0);
                        i = y(NaN), e = c[e >> 2], n = m[e + 40 >> 2], a = 3, 2141891242 != (0 | (e = c[e + 40 >> 2])) && (2140081935 != (0 | e) ? 2139156720 != (0 | e) ? (a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = d(), a = 1073741824 & e ? 2 : 1)) : (i = y(0), a = 2) : (i = y(0), a = 1)), c[r >> 2] = a, N[r + 8 >> 3] = i;
                    },
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return ar = a = ar - 16 | 0, i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](a, e), r = ye(16), e = c[a + 12 >> 2], c[r + 8 >> 2] = c[a + 8 >> 2], c[r + 12 >> 2] = e, e = c[a + 4 >> 2], c[r >> 2] = c[a >> 2], c[r + 4 >> 2] = e, ar = a + 16 | 0, 0 | r;
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return +((e = m[c[r >> 2] + 32 >> 2]) == e ? e : y(0));
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        return a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), +aa[0 | a](e);
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return r = c[r >> 2], (e = m[r + 36 >> 2]) != e && (e = v[c[r + 568 >> 2] + 10 | 0] ? y(1) : y(0)), +e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 200 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 200 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 204 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 204 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 208 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 208 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 212 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 212 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 216 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 216 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 220 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 220 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return +((e = m[c[r >> 2] + 224 >> 2]) != e ? y(NaN) : e);
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0);
                        r = c[r >> 2] + (e << 2) | 0, i = m[r + 152 >> 2];
                        r: {
                            if (!(2139156720 == (0 | (r = c[r + 152 >> 2])) | 2140081935 == (0 | r))) {
                                if (a = NaN, 2141891242 == (0 | r) | i != i) break r;
                                if (2139156720 != (0 | r)) return b(2, 536870912 + (-1073741825 & r) | 0), +d();
                            }
                            a = 0;
                        }
                        return +a;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i = 0;
                        return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), +aa[0 | i](e, a);
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 20 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 22 & 1;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 116 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 116 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = y(0), i = y(0);
                        r = c[r >> 2] + (e << 2) | 0, i = m[r + 188 >> 2];
                        r: {
                            if (!(2139156720 == (0 | (r = c[r + 188 >> 2])) | 2140081935 == (0 | r))) {
                                if (a = y(NaN), 2141891242 == (0 | r) | i != i) break r;
                                if (2139156720 != (0 | r)) return y((b(2, 536870912 + (-1073741825 & r) | 0), d()));
                            }
                            a = y(0);
                        }
                        return y(a);
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i = 0;
                        return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), y(y(aa[0 | i](e, a)));
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0, t = 0, o = 0, u = 0, b = 0, s = 0, A = 0, l = 0, d = 0;
                        ar = i = ar - 80 | 0, r = c[(r |= 0) >> 2];
                        r: {
                            e: {
                                if (b = c[e >> 2], !c[b + 552 >> 2]) {
                                    if (c[r + 8 >> 2]) break e;
                                    u = (e = c[r + 556 >> 2]) + (a << 2) | 0;
                                    a: if ((n = c[r + 560 >> 2]) >>> 0 < (o = c[(t = r + 564 | 0) >> 2]) >>> 0) {
                                        if ((0 | n) == (0 | u)) {
                                            c[u >> 2] = b, c[r + 560 >> 2] = u + 4;
                                            break a;
                                        }
                                        if (a = n, n >>> 0 > (e = n - 4 | 0) >>> 0) for(; c[a >> 2] = c[e >> 2], a = a + 4 | 0, n >>> 0 > (e = e + 4 | 0) >>> 0;);
                                        c[r + 560 >> 2] = a, (0 | (e = u + 4 | 0)) != (0 | n) && wr(n - (-4 & (e = n - e | 0)) | 0, u, e), c[u >> 2] = b;
                                    } else {
                                        if ((n = 1 + (n - e >> 2) | 0) >>> 0 >= 1073741824) break r;
                                        if (o = (e = o - e | 0) >>> 1 | 0, t = pe(i + 32 | 0, e >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 < o >>> 0 ? o : n, a, t), (0 | (a = c[t + 8 >> 2])) == c[t + 12 >> 2]) {
                                            if ((e = c[t + 4 >> 2]) >>> 0 > (n = c[t >> 2]) >>> 0) a = wr(s = (n = (1 + (e - n >> 2) | 0) / -2 << 2) + e | 0, o = e, e = a - e | 0) + e | 0, c[t + 8 >> 2] = a, c[t + 4 >> 2] = n + c[t + 4 >> 2];
                                            else {
                                                if (o = pe(i + 56 | 0, e = (0 | a) == (0 | n) ? 1 : a - n >> 1, e >>> 2 | 0, c[t + 16 >> 2]), n = c[o + 8 >> 2], (0 | (e = c[t + 4 >> 2])) != (0 | (a = c[t + 8 >> 2]))) {
                                                    for(a = (a - e | 0) + n | 0; c[n >> 2] = c[e >> 2], e = e + 4 | 0, (0 | (n = n + 4 | 0)) != (0 | a););
                                                    e = c[t + 8 >> 2], n = c[t + 4 >> 2];
                                                } else a = n, n = e;
                                                s = c[t >> 2], c[t >> 2] = c[o >> 2], c[o >> 2] = s, c[t + 4 >> 2] = c[o + 4 >> 2], c[o + 4 >> 2] = n, c[t + 8 >> 2] = a, c[o + 8 >> 2] = e, A = c[t + 12 >> 2], c[t + 12 >> 2] = c[o + 12 >> 2], c[o + 12 >> 2] = A, (0 | e) != (0 | n) && (c[o + 8 >> 2] = (3 + (n - e | 0) & -4) + e), s && (gr(s), a = c[t + 8 >> 2]);
                                            }
                                        }
                                        c[a >> 2] = b, c[t + 8 >> 2] = c[t + 8 >> 2] + 4, a = u - (e = c[r + 556 >> 2]) | 0, l = t, d = wr(c[t + 4 >> 2] - a | 0, e, a), c[l + 4 >> 2] = d, n = c[r + 560 >> 2] - u | 0, u = wr(c[t + 8 >> 2], u, n), e = c[r + 556 >> 2], c[r + 556 >> 2] = c[t + 4 >> 2], c[t + 4 >> 2] = e, a = c[r + 560 >> 2], c[r + 560 >> 2] = n + u, c[t + 8 >> 2] = a, n = c[r + 564 >> 2], c[r + 564 >> 2] = c[t + 12 >> 2], c[t >> 2] = e, c[t + 12 >> 2] = n, (0 | e) != (0 | a) && (c[t + 8 >> 2] = a + (3 + (e - a | 0) & -4)), e && gr(e);
                                    }
                                    for(c[b + 552 >> 2] = r; !(4 & (e = v[r + 4 | 0])) && (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, r = c[r + 552 >> 2]););
                                    return void (ar = i + 80 | 0);
                                }
                                c[i + 16 >> 2] = 4006, Xr(r, i + 16 | 0), De(), k();
                            }
                            c[i >> 2] = 4139, Xr(r, i), De(), k();
                        }
                        I(), k();
                    },
                    Ne,
                    function(r, e) {
                        e |= 0;
                        var a, i = 0, n = 0, t = 0;
                        ar = a = ar - 320 | 0, r = c[(r |= 0) >> 2];
                        r: if (c[r + 560 >> 2] != c[r + 556 >> 2] && (n = c[e >> 2], e = c[n + 552 >> 2], ee(r, n))) {
                            if ((0 | r) == (0 | e)) {
                                for(i = Rr(a, 0, 288), c[(e = i) + 16 >> 2] = 2143289344, c[e + 20 >> 2] = 2143289344, Rr(e + 24 | 0, 0, 49), c[e + 80 >> 2] = 2143289344, t = e + 288 | 0, e = e + 96 | 0; c[e + 16 >> 2] = -1082130432, c[e + 20 >> 2] = -1082130432, c[e + 8 >> 2] = 0, c[e + 12 >> 2] = 0, c[e >> 2] = -1082130432, c[e + 4 >> 2] = -1082130432, (0 | t) != (0 | (e = e + 24 | 0)););
                                c[i + 312 >> 2] = -1082130432, c[i + 316 >> 2] = -1082130432, c[i + 304 >> 2] = 0, c[i + 308 >> 2] = 0, c[i + 296 >> 2] = -1082130432, c[i + 300 >> 2] = -1082130432, c[i + 288 >> 2] = 2143289344, c[i + 292 >> 2] = 2143289344, Ar(n + 228 | 0, i, 320), c[n + 552 >> 2] = 0;
                            }
                            for(;;){
                                if (4 & (e = v[r + 4 | 0])) break r;
                                if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                            }
                        }
                        ar = a + 320 | 0;
                    },
                    Ee,
                    function(r) {
                        return r = c[(r |= 0) >> 2], c[r + 560 >> 2] - c[r + 556 >> 2] >> 2;
                    },
                    Ge,
                    function(r) {
                        return (r = c[c[(r |= 0) >> 2] + 552 >> 2]) ? c[r >> 2] : 0;
                    },
                    Ge,
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return a = c[(r |= 0) >> 2], r = c[a + 556 >> 2], c[a + 560 >> 2] - r >> 2 >>> 0 <= e >>> 0 || (r = c[r + (e << 2) >> 2]) && (i = c[r >> 2]), 0 | i;
                    },
                    we,
                    function(r) {
                        return (2 & v[c[(r |= 0) >> 2] + 4 | 0]) >>> 1 | 0;
                    },
                    Ge,
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((2 & (a = v[r + 4 | 0])) >>> 1 | 0) != (0 | e)) for(f[r + 4 | 0] = 253 & a | (e ? 2 : 0);;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    Ee,
                    function(r, e) {
                        var a;
                        e |= 0, a = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = e, a && aa[c[c[a >> 2] + 4 >> 2]](a), ke(c[r >> 2], 14);
                    },
                    Ee,
                    function(r) {
                        var e;
                        e = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), ke(c[r >> 2], 0);
                    },
                    function(r, e) {
                        var a;
                        e |= 0, a = c[8 + (r |= 0) >> 2], c[r + 8 >> 2] = e, a && aa[c[c[a >> 2] + 4 >> 2]](a), c[c[r >> 2] + 20 >> 2] = 15;
                    },
                    Ee,
                    function(r) {
                        var e;
                        e = c[8 + (r |= 0) >> 2], c[r + 8 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), c[c[r >> 2] + 20 >> 2] = 0;
                    },
                    function(r) {
                        var e, a = 0;
                        if (ar = e = ar - 16 | 0, r = c[(r |= 0) >> 2], c[r + 8 >> 2]) {
                            for(; !(4 & (a = v[r + 4 | 0])) && (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, r = c[r + 552 >> 2]););
                            ar = e + 16 | 0;
                        } else c[e >> 2] = 1024, Xr(r, e), De(), k();
                    },
                    function(r) {
                        return (4 & v[c[(r |= 0) >> 2] + 4 | 0]) >>> 2 | 0;
                    },
                    Ge,
                    function(r, e, a, i) {
                        r |= 0, e = +e, a = +a, i |= 0;
                        var n, t, f = y(0), o = y(0), u = y(0), s = 0, A = y(0), k = 0, l = y(0);
                        ar = t = ar + -64 | 0, n = c[r >> 2], Rr(t + 8 | 0, 0, 56), c[1735] = c[1735] + 1, sr(n), u = y(e), o = m[n + 572 >> 2];
                        r: {
                            e: {
                                switch(0 | (r = c[n + 576 >> 2])){
                                    case 0:
                                    case 3:
                                        break e;
                                }
                                a: {
                                    if (!(1 != (0 | r) | (f = m[n + 572 >> 2]) != f)) {
                                        if (!((f = o) < y(0))) break a;
                                        break e;
                                    }
                                    i: {
                                        if (2 != (0 | r) | f != f) {
                                            f = y(NaN);
                                            n: switch(r - 1 | 0){
                                                case 1:
                                                    break i;
                                                case 0:
                                                    break n;
                                                default:
                                                    break a;
                                            }
                                            f = o;
                                            break a;
                                        }
                                        if (u != u | o < y(0)) break e;
                                    }
                                    f = y(y(o * u) * y(.009999999776482582));
                                }
                                l = y(f + y(Mr(n, 2, u) + Ur(n, 2, u))), k = 1;
                                break r;
                            }
                            f = y(0), o = m[n + 216 >> 2];
                            e: {
                                a: {
                                    i: {
                                        n: if (2139156720 != (0 | (r = c[n + 216 >> 2]))) {
                                            if (2140081935 == (0 | r)) break e;
                                            k = 4276;
                                            t: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break t;
                                                    k = 4268;
                                                }
                                                switch(f = m[k >> 2], c[k + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break i;
                                                    case 1:
                                                        break n;
                                                    default:
                                                        break a;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break i;
                                        }
                                        f = y(y(f * u) * y(.009999999776482582));
                                    }
                                    if (f == f) {
                                        f = y(0);
                                        i: if (2139156720 != (0 | r)) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            n: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break n;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], l = y(NaN), k = 2, c[s + 4 >> 2] - 1 | 0){
                                                    case 1:
                                                        break i;
                                                    case 0:
                                                        break e;
                                                    default:
                                                        break r;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break e;
                                        }
                                        l = y(y(f * u) * y(.009999999776482582)), k = 2;
                                        break r;
                                    }
                                }
                                k = u == u, l = u;
                                break r;
                            }
                            k = 2, l = f;
                        }
                        A = y(a), o = m[n + 580 >> 2];
                        r: {
                            e: {
                                switch(0 | (r = c[n + 584 >> 2])){
                                    case 0:
                                    case 3:
                                        break e;
                                }
                                a: {
                                    if (!(1 != (0 | r) | (f = m[n + 580 >> 2]) != f)) {
                                        if (!((f = o) < y(0))) break a;
                                        break e;
                                    }
                                    i: {
                                        if (2 != (0 | r) | f != f) {
                                            f = y(NaN);
                                            n: switch(r - 1 | 0){
                                                case 1:
                                                    break i;
                                                case 0:
                                                    break n;
                                                default:
                                                    break a;
                                            }
                                            f = o;
                                            break a;
                                        }
                                        if (A != A | o < y(0)) break e;
                                    }
                                    f = y(y(o * A) * y(.009999999776482582));
                                }
                                o = y(f + y(Mr(n, 0, u) + Ur(n, 0, u))), r = 1;
                                break r;
                            }
                            f = y(0), o = m[n + 220 >> 2];
                            e: {
                                a: {
                                    i: {
                                        n: if (2139156720 != (0 | (r = c[n + 220 >> 2]))) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            t: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break t;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], c[s + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break i;
                                                    case 1:
                                                        break n;
                                                    default:
                                                        break a;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break i;
                                        }
                                        f = y(y(f * A) * y(.009999999776482582));
                                    }
                                    if (f == f) {
                                        f = y(0);
                                        i: if (2139156720 != (0 | r)) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            n: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break n;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], o = y(NaN), r = 2, c[s + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break e;
                                                    case 1:
                                                        break i;
                                                    default:
                                                        break r;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break e;
                                        }
                                        o = y(y(f * A) * y(.009999999776482582)), r = 2;
                                        break r;
                                    }
                                }
                                r = A == A, o = A;
                                break r;
                            }
                            r = 2, o = f;
                        }
                        or(n, l, o, i, k, r, u, A, 1, 0, c[n + 568 >> 2], t + 8 | 0, 0, c[1735]) && (Fr(n, 3 & v[n + 300 | 0], u, A, u), Er(n, +m[c[n + 568 >> 2] + 16 >> 2], 0, 0)), ar = t - -64 | 0;
                    },
                    function(r, e, a, i, n) {
                        e |= 0, a = +a, i = +i, n |= 0;
                        var t = 0;
                        t = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (t = c[t + c[e >> 2] >> 2]), aa[0 | t](e, a, i, n);
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 228 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 236 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 232 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 240 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 244 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 248 >> 2];
                    },
                    function(r, e) {
                        r |= 0, e = c[(e |= 0) >> 2], N[r >> 3] = m[e + 228 >> 2], N[r + 8 >> 3] = m[e + 236 >> 2], N[r + 16 >> 3] = m[e + 232 >> 2], N[r + 24 >> 3] = m[e + 240 >> 2], N[r + 32 >> 3] = m[e + 244 >> 2], N[r + 40 >> 3] = m[e + 248 >> 2];
                    },
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return ar = a = ar - 48 | 0, i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](a, e), r = Ar(ye(48), a, 48), ar = a + 48 | 0, 0 | r;
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 260 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 252 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 252 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 260 | 0;
                                        break r;
                                }
                                e = 252 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 276 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 268 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 268 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 276 | 0;
                                        break r;
                                }
                                e = 268 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 292 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 284 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 284 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 292 | 0;
                                        break r;
                                }
                                e = 284 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    Se,
                    Ce,
                    Se,
                    Ce,
                    Gr,
                    Le,
                    function(r) {
                        gr(Le(r |= 0));
                    },
                    function(r, e, a, i, n, t) {
                        var o, u, b;
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0, ar = o = ar - 48 | 0, b = c[e + 8 >> 2], 1 & f[6972] ? e = c[1742] : (e = 0 | C(5, 4416), f[6972] = 1, c[1742] = e), c[o + 40 >> 2] = t, m[o + 32 >> 2] = n, c[o + 24 >> 2] = i, m[o + 16 >> 2] = a, e = (u = +Q(0 | e, 0 | b, 2873, o + 12 | 0, o + 16 | 0)) < 4294967296 & u >= 0 ? ~~u >>> 0 : 0, i = c[o + 12 >> 2], t = c[e + 4 >> 2], c[r >> 2] = c[e >> 2], c[r + 4 >> 2] = t, t = c[e + 12 >> 2], c[r + 8 >> 2] = c[e + 8 >> 2], c[r + 12 >> 2] = t, H(0 | i), ar = o + 48 | 0;
                    },
                    $e,
                    ra,
                    Oe,
                    function(r) {
                        gr(Oe(r |= 0));
                    },
                    function(r) {
                        Ie(c[8 + (r |= 0) >> 2], 3244);
                    },
                    $e,
                    function(r) {
                        return 0 | q(c[60 + (r |= 0) >> 2]);
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0, t = 0, f = 0, o = 0, u = 0, b = 0;
                        ar = i = ar - 32 | 0, n = c[28 + (r |= 0) >> 2], c[i + 16 >> 2] = n, t = c[r + 20 >> 2], c[i + 28 >> 2] = a, c[i + 24 >> 2] = e, e = t - n | 0, c[i + 20 >> 2] = e, t = e + a | 0, u = 2, e = i + 16 | 0;
                        r: {
                            for(;;){
                                e: {
                                    a: {
                                        i: {
                                            if (!Ye(0 | K(c[r + 60 >> 2], 0 | e, 0 | u, i + 12 | 0))) {
                                                if ((0 | (f = c[i + 12 >> 2])) == (0 | t)) break i;
                                                if ((0 | f) >= 0) break a;
                                                break e;
                                            }
                                            if (-1 != (0 | t)) break e;
                                        }
                                        e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, c[r + 16 >> 2] = e + c[r + 48 >> 2], r = a;
                                        break r;
                                    }
                                    o = f - ((b = (o = c[e + 4 >> 2]) >>> 0 < f >>> 0) ? o : 0) | 0, c[(n = (b << 3) + e | 0) >> 2] = o + c[n >> 2], c[(e = (b ? 12 : 4) + e | 0) >> 2] = c[e >> 2] - o, t = t - f | 0, u = u - b | 0, e = n;
                                    continue;
                                }
                                break;
                            }
                            c[r + 28 >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, c[r >> 2] = 32 | c[r >> 2], r = 0, 2 != (0 | u) && (r = a - c[e + 4 >> 2] | 0);
                        }
                        return ar = i + 32 | 0, 0 | r;
                    },
                    function(r, e, a, i) {
                        var n;
                        return e |= 0, a |= 0, i |= 0, ar = n = ar - 16 | 0, r = Ye(0 | j(c[60 + (r |= 0) >> 2], 0 | e, 0 | a, 255 & i, n + 8 | 0)), ar = n + 16 | 0, ir = r ? -1 : c[n + 12 >> 2], 0 | (r ? -1 : c[n + 8 >> 2]);
                    },
                    function(r) {
                        return 0;
                    },
                    function(r, e, a, i) {
                        return ir = 0, 0;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n, t = 0, o = 0, u = 0;
                        return i = c[84 + (r |= 0) >> 2], o = c[i >> 2], t = c[i + 4 >> 2], n = c[r + 28 >> 2], (u = t >>> 0 < (u = c[r + 20 >> 2] - n | 0) >>> 0 ? t : u) && (Ar(o, n, u), o = u + c[i >> 2] | 0, c[i >> 2] = o, t = c[i + 4 >> 2] - u | 0, c[i + 4 >> 2] = t), (t = a >>> 0 > t >>> 0 ? t : a) && (Ar(o, e, t), o = t + c[i >> 2] | 0, c[i >> 2] = o, c[i + 4 >> 2] = c[i + 4 >> 2] - t), f[0 | o] = 0, e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, 0 | a;
                    },
                    ra
                ]);
                function ia() {
                    return t.byteLength / 65536 | 0;
                }
                return {
                    E: function E() {
                        for(var r = 0, e = 0, a = 0; a = 5888 + (e = r << 4) | 0, c[e + 5892 >> 2] = a, c[e + 5896 >> 2] = a, 64 != (0 | (r = r + 1 | 0)););
                        vr(48), c[1736] = 16, c[1737] = 0, tr(), c[1737] = c[1748], c[1748] = 6944, c[1749] = 194, c[1750] = 0, Gr(), c[1750] = c[1748], c[1748] = 6996;
                    },
                    F: function F(r) {
                        r |= 0;
                        var e, a, i = 0, n = 0, t = 0;
                        ar = e = ar - 96 | 0, c[e >> 2] = r, ar = n = ar - 16 | 0, c[n + 12 >> 2] = e, ar = r = ar - 144 | 0, r = Ar(r, 5440, 144), i = a = e + 16 | 0, c[r + 44 >> 2] = i, c[r + 20 >> 2] = i, t = (t = -2 - i | 0) >>> 0 >= 2147483647 ? 2147483647 : t, c[r + 48 >> 2] = t, i = i + t | 0, c[r + 28 >> 2] = i, c[r + 16 >> 2] = i, Zr(r, 2201, e, 0, 0), t && (i = c[r + 20 >> 2], f[i - ((0 | i) == c[r + 16 >> 2]) | 0] = 0), ar = r + 144 | 0, ar = n + 16 | 0;
                        r: {
                            if (3 & (r = a)) for(;;){
                                if (!v[0 | r]) break r;
                                if (!(3 & (r = r + 1 | 0))) break;
                            }
                            for(; i = r, r = r + 4 | 0, !((-1 ^ (n = c[i >> 2])) & n - 16843009 & -2139062144););
                            for(; i = (r = i) + 1 | 0, v[0 | r];);
                        }
                        return r = (i = cr(r = 1 + (r - a | 0) | 0)) ? Ar(i, a, r) : 0, ar = e + 96 | 0, 0 | r;
                    },
                    G: function G() {
                        var r = 0;
                        if (r = c[1748]) for(; aa[c[r >> 2]](), r = c[r + 4 >> 2];);
                    },
                    H: cr,
                    I: aa,
                    J: gr,
                    K: function K(r, e, a, i, n) {
                        return e |= 0, a |= 0, i |= 0, n |= 0, 0 | aa[0 | (r |= 0)](e, a, i, n);
                    }
                };
            }(r);
        }(r);
    }
    Object.assign(e, n), n = null, e.wasmBinary && (f = e.wasmBinary), e.noExitRuntime;
    var s = Error;
    f = [];
    var A, k, l, d, v, h, p, m, N, w = !1;
    function y(r, e, a) {
        a = e + a;
        for(var i = ""; !(e >= a);){
            var n = r[e++];
            if (!n) break;
            if (128 & n) {
                var t = 63 & r[e++];
                if (192 == (224 & n)) i += String.fromCharCode((31 & n) << 6 | t);
                else {
                    var f = 63 & r[e++];
                    65536 > (n = 224 == (240 & n) ? (15 & n) << 12 | t << 6 | f : (7 & n) << 18 | t << 12 | f << 6 | 63 & r[e++]) ? i += String.fromCharCode(n) : (n -= 65536, i += String.fromCharCode(55296 | n >> 10, 56320 | 1023 & n));
                }
            } else i += String.fromCharCode(n);
        }
        return i;
    }
    function E() {
        var r = A.buffer;
        e.HEAP8 = k = new Int8Array(r), e.HEAP16 = d = new Int16Array(r), e.HEAP32 = h = new Int32Array(r), e.HEAPU8 = l = new Uint8Array(r), e.HEAPU16 = v = new Uint16Array(r), e.HEAPU32 = p = new Uint32Array(r), e.HEAPF32 = m = new Float32Array(r), e.HEAPF64 = N = new Float64Array(r);
    }
    var G = e.INITIAL_MEMORY || 16777216;
    65536 <= G || X("INITIAL_MEMORY should be larger than STACK_SIZE, was " + G + "! (STACK_SIZE=65536)"), A = e.wasmMemory ? e.wasmMemory : new function() {
        this.buffer = new ArrayBuffer(G / 65536 * 65536);
    }(), E(), G = A.buffer.byteLength;
    var R, g = [], Z = [], W = [];
    function V() {
        var r = e.preRun.shift();
        g.unshift(r);
    }
    var B, T = 0, I = null;
    function X(r) {
        throw e.onAbort && e.onAbort(r), c(r = "Aborted(" + r + ")"), w = !0, r = new s(r + ". Build with -sASSERTIONS for more info."), i(r), r;
    }
    function O(r) {
        return r.startsWith("data:application/octet-stream;base64,");
    }
    if (!O(B = "yoga-asm.wasm")) {
        var L = B;
        B = e.locateFile ? e.locateFile(L, t) : t + L;
    }
    function _(r) {
        for(; 0 < r.length;)r.shift()(e);
    }
    function F(r) {
        if (void 0 === r) return "_unknown";
        var e = (r = r.replace(/[^a-zA-Z0-9_]/g, "$")).charCodeAt(0);
        return 48 <= e && 57 >= e ? "_" + r : r;
    }
    function C(r, e) {
        return r = F(r), function() {
            return e.apply(this, arguments);
        };
    }
    var S = [
        {},
        {
            value: void 0
        },
        {
            value: null
        },
        {
            value: !0
        },
        {
            value: !1
        }
    ], P = [];
    function Y(r) {
        var e = Error, a = C(r, function(e) {
            this.name = r, this.message = e, void 0 !== (e = Error(e).stack) && (this.stack = this.toString() + "\n" + e.replace(/^Error(:[^\n]*)?\n/, ""));
        });
        return a.prototype = Object.create(e.prototype), a.prototype.constructor = a, a.prototype.toString = function() {
            return void 0 === this.message ? this.name : this.name + ": " + this.message;
        }, a;
    }
    var U = void 0;
    function M(r) {
        throw new U(r);
    }
    var H = function H(r) {
        return r || M("Cannot use deleted val. handle = " + r), S[r].value;
    }, Q = function Q(r) {
        switch(r){
            case void 0:
                return 1;
            case null:
                return 2;
            case !0:
                return 3;
            case !1:
                return 4;
            default:
                var e = P.length ? P.pop() : S.length;
                return S[e] = {
                    fa: 1,
                    value: r
                }, e;
        }
    }, z = void 0, j = void 0;
    function _D(r) {
        for(var e = ""; l[r];)e += j[l[r++]];
        return e;
    }
    var x = [];
    function J() {
        for(; x.length;){
            var r = x.pop();
            r.L.Z = !1, r.delete();
        }
    }
    var K = void 0, _q = {};
    function $(r, e) {
        for(void 0 === e && M("ptr should not be undefined"); r.P;)e = r.aa(e), r = r.P;
        return e;
    }
    var er = {};
    function ar(r) {
        var e = _D(r = ee(r));
        return ne(r), e;
    }
    function ir(r, e) {
        var a = er[r];
        return void 0 === a && M(e + " has unknown type " + ar(r)), a;
    }
    function nr() {}
    var tr = !1;
    function fr(r) {
        --r.count.value, 0 === r.count.value && (r.S ? r.T.V(r.S) : r.O.M.V(r.N));
    }
    function or(r, e, a) {
        return e === a ? r : void 0 === a.P || null === (r = or(r, e, a.P)) ? null : a.ma(r);
    }
    var cr = {}, ur = void 0;
    function br(r) {
        throw new ur(r);
    }
    function sr(r, e) {
        return e.O && e.N || br("makeClassHandle requires ptr and ptrType"), !!e.T != !!e.S && br("Both smartPtrType and smartPtr must be specified"), e.count = {
            value: 1
        }, Ar(Object.create(r, {
            L: {
                value: e
            }
        }));
    }
    function Ar(r) {
        return "undefined" == typeof FinalizationRegistry ? (Ar = function Ar(r) {
            return r;
        }, r) : (tr = new FinalizationRegistry(function(r) {
            fr(r.L);
        }), nr = function nr(r) {
            tr.unregister(r);
        }, (Ar = function Ar(r) {
            var e = r.L;
            return e.S && tr.register(r, {
                L: e
            }, r), r;
        })(r));
    }
    var kr = {};
    function lr(r) {
        for(; r.length;){
            var e = r.pop();
            r.pop()(e);
        }
    }
    function dr(r) {
        return this.fromWireType(h[r >> 2]);
    }
    var vr = {}, hr = {};
    function pr(r, e, a) {
        function i(e) {
            (e = a(e)).length !== r.length && br("Mismatched type converter count");
            for(var i = 0; i < r.length; ++i)Nr(r[i], e[i]);
        }
        r.forEach(function(r) {
            hr[r] = e;
        });
        var n = Array(e.length), t = [], f = 0;
        e.forEach(function(r, e) {
            er.hasOwnProperty(r) ? n[e] = er[r] : (t.push(r), vr.hasOwnProperty(r) || (vr[r] = []), vr[r].push(function() {
                n[e] = er[r], ++f === t.length && i(n);
            }));
        }), 0 === t.length && i(n);
    }
    function mr(r) {
        switch(r){
            case 1:
                return 0;
            case 2:
                return 1;
            case 4:
                return 2;
            case 8:
                return 3;
            default:
                throw new TypeError("Unknown type size: " + r);
        }
    }
    function Nr(r, e, a) {
        if (a === void 0) a = {};
        if (!("argPackAdvance" in e)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
        var i = e.name;
        if (r || M('type "' + i + '" must have a positive integer typeid pointer'), er.hasOwnProperty(r)) {
            if (a.ta) return;
            M("Cannot register type '" + i + "' twice");
        }
        er[r] = e, delete hr[r], vr.hasOwnProperty(r) && (e = vr[r], delete vr[r], e.forEach(function(r) {
            return r();
        }));
    }
    function wr(r) {
        M(r.L.O.M.name + " instance already deleted");
    }
    function yr() {}
    function Er(r, e, a) {
        if (void 0 === r[e].R) {
            var i = r[e];
            r[e] = function() {
                return r[e].R.hasOwnProperty(arguments.length) || M("Function '" + a + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + r[e].R + ")!"), r[e].R[arguments.length].apply(this, arguments);
            }, r[e].R = [], r[e].R[i.Y] = i;
        }
    }
    function Gr(r, e, a, i, n, t, f, o) {
        this.name = r, this.constructor = e, this.W = a, this.V = i, this.P = n, this.oa = t, this.aa = f, this.ma = o, this.ia = [];
    }
    function Rr(r, e, a) {
        for(; e !== a;)e.aa || M("Expected null or instance of " + a.name + ", got an instance of " + e.name), r = e.aa(r), e = e.P;
        return r;
    }
    function gr(r, e) {
        return null === e ? (this.da && M("null is not a valid " + this.name), 0) : (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), Rr(e.L.N, e.L.O.M, this.M));
    }
    function Zr(r, e) {
        if (null === e) {
            if (this.da && M("null is not a valid " + this.name), this.ca) {
                var a = this.ea();
                return null !== r && r.push(this.V, a), a;
            }
            return 0;
        }
        if (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && e.L.O.ba && M("Cannot convert argument of type " + (e.L.T ? e.L.T.name : e.L.O.name) + " to parameter type " + this.name), a = Rr(e.L.N, e.L.O.M, this.M), this.ca) switch(void 0 === e.L.S && M("Passing raw pointer to smart pointer is illegal"), this.Aa){
            case 0:
                e.L.T === this ? a = e.L.S : M("Cannot convert argument of type " + (e.L.T ? e.L.T.name : e.L.O.name) + " to parameter type " + this.name);
                break;
            case 1:
                a = e.L.S;
                break;
            case 2:
                if (e.L.T === this) a = e.L.S;
                else {
                    var i = e.clone();
                    a = this.wa(a, Q(function() {
                        i.delete();
                    })), null !== r && r.push(this.V, a);
                }
                break;
            default:
                M("Unsupporting sharing policy");
        }
        return a;
    }
    function Wr(r, e) {
        return null === e ? (this.da && M("null is not a valid " + this.name), 0) : (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), e.L.O.ba && M("Cannot convert argument of type " + e.L.O.name + " to parameter type " + this.name), Rr(e.L.N, e.L.O.M, this.M));
    }
    function Vr(r, e, a, i) {
        this.name = r, this.M = e, this.da = a, this.ba = i, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, void 0 !== e.P ? this.toWireType = Zr : (this.toWireType = i ? gr : Wr, this.U = null);
    }
    function Br(r, a) {
        var i = (r = _D(r)).includes("j") ? function(r, a) {
            var i = [];
            return function() {
                if (i.length = 0, Object.assign(i, arguments), r.includes("j")) {
                    var n = e["dynCall_" + r];
                    n = i && i.length ? n.apply(null, [
                        a
                    ].concat(i)) : n.call(null, a);
                } else n = R.get(a).apply(null, i);
                return n;
            };
        }(r, a) : R.get(a);
        return "function" != typeof i && M("unknown function pointer with signature " + r + ": " + a), i;
    }
    var Tr = void 0;
    function Ir(r, e) {
        var a = [], i = {};
        throw e.forEach(function r(e) {
            i[e] || er[e] || (hr[e] ? hr[e].forEach(r) : (a.push(e), i[e] = !0));
        }), new Tr(r + ": " + a.map(ar).join([
            ", "
        ]));
    }
    function Xr(r, e, a, i, n) {
        var t = e.length;
        2 > t && M("argTypes array size mismatch! Must at least get return value and 'this' types!");
        var f = null !== e[1] && null !== a, o = !1;
        for(a = 1; a < e.length; ++a)if (null !== e[a] && void 0 === e[a].U) {
            o = !0;
            break;
        }
        var c = "void" !== e[0].name, u = t - 2, b = Array(u), s = [], A = [];
        return function() {
            if (arguments.length !== u && M("function " + r + " called with " + arguments.length + " arguments, expected " + u + " args!"), A.length = 0, s.length = f ? 2 : 1, s[0] = n, f) {
                var a = e[1].toWireType(A, this);
                s[1] = a;
            }
            for(var t = 0; t < u; ++t)b[t] = e[t + 2].toWireType(A, arguments[t]), s.push(b[t]);
            if (t = i.apply(null, s), o) lr(A);
            else for(var k = f ? 1 : 2; k < e.length; k++){
                var l = 1 === k ? a : b[k - 2];
                null !== e[k].U && e[k].U(l);
            }
            return c ? e[0].fromWireType(t) : void 0;
        };
    }
    function Or(r, e) {
        for(var a = [], i = 0; i < r; i++)a.push(p[e + 4 * i >> 2]);
        return a;
    }
    function Lr(r) {
        4 < r && 0 == --S[r].fa && (S[r] = void 0, P.push(r));
    }
    function _r(r) {
        if (null === r) return "null";
        var e = typeof r;
        return "object" === e || "array" === e || "function" === e ? r.toString() : "" + r;
    }
    function Fr(r, e) {
        switch(e){
            case 2:
                return function(r) {
                    return this.fromWireType(m[r >> 2]);
                };
            case 3:
                return function(r) {
                    return this.fromWireType(N[r >> 3]);
                };
            default:
                throw new TypeError("Unknown float type: " + r);
        }
    }
    function Cr(r, e, a) {
        switch(e){
            case 0:
                return a ? function(r) {
                    return k[r];
                } : function(r) {
                    return l[r];
                };
            case 1:
                return a ? function(r) {
                    return d[r >> 1];
                } : function(r) {
                    return v[r >> 1];
                };
            case 2:
                return a ? function(r) {
                    return h[r >> 2];
                } : function(r) {
                    return p[r >> 2];
                };
            default:
                throw new TypeError("Unknown integer type: " + r);
        }
    }
    function Sr(r, e) {
        for(var a = "", i = 0; !(i >= e / 2); ++i){
            var n = d[r + 2 * i >> 1];
            if (0 == n) break;
            a += String.fromCharCode(n);
        }
        return a;
    }
    function Pr(r, e, a) {
        if (void 0 === a && (a = 2147483647), 2 > a) return 0;
        var i = e;
        a = (a -= 2) < 2 * r.length ? a / 2 : r.length;
        for(var n = 0; n < a; ++n)d[e >> 1] = r.charCodeAt(n), e += 2;
        return d[e >> 1] = 0, e - i;
    }
    function Yr(r) {
        return 2 * r.length;
    }
    function Ur(r, e) {
        for(var a = 0, i = ""; !(a >= e / 4);){
            var n = h[r + 4 * a >> 2];
            if (0 == n) break;
            ++a, 65536 <= n ? (n -= 65536, i += String.fromCharCode(55296 | n >> 10, 56320 | 1023 & n)) : i += String.fromCharCode(n);
        }
        return i;
    }
    function Mr(r, e, a) {
        if (void 0 === a && (a = 2147483647), 4 > a) return 0;
        var i = e;
        a = i + a - 4;
        for(var n = 0; n < r.length; ++n){
            var t = r.charCodeAt(n);
            if (55296 <= t && 57343 >= t && (t = 65536 + ((1023 & t) << 10) | 1023 & r.charCodeAt(++n)), h[e >> 2] = t, (e += 4) + 4 > a) break;
        }
        return h[e >> 2] = 0, e - i;
    }
    function Hr(r) {
        for(var e = 0, a = 0; a < r.length; ++a){
            var i = r.charCodeAt(a);
            55296 <= i && 57343 >= i && ++a, e += 4;
        }
        return e;
    }
    var Qr = {};
    function zr(r) {
        var e = Qr[r];
        return void 0 === e ? _D(r) : e;
    }
    var jr = [], Dr = [], xr = [
        null,
        [],
        []
    ];
    U = e.BindingError = Y("BindingError"), e.count_emval_handles = function() {
        for(var r = 0, e = 5; e < S.length; ++e)void 0 !== S[e] && ++r;
        return r;
    }, e.get_first_emval = function() {
        for(var r = 5; r < S.length; ++r)if (void 0 !== S[r]) return S[r];
        return null;
    }, z = e.PureVirtualError = Y("PureVirtualError");
    for(var Jr = Array(256), Kr = 0; 256 > Kr; ++Kr)Jr[Kr] = String.fromCharCode(Kr);
    j = Jr, e.getInheritedInstanceCount = function() {
        return Object.keys(_q).length;
    }, e.getLiveInheritedInstances = function() {
        var r, e = [];
        for(r in _q)_q.hasOwnProperty(r) && e.push(_q[r]);
        return e;
    }, e.flushPendingDeletes = J, e.setDelayFunction = function(r) {
        K = r, x.length && K && K(J);
    }, ur = e.InternalError = Y("InternalError"), yr.prototype.isAliasOf = function(r) {
        if (!(this instanceof yr && r instanceof yr)) return !1;
        var e = this.L.O.M, a = this.L.N, i = r.L.O.M;
        for(r = r.L.N; e.P;)a = e.aa(a), e = e.P;
        for(; i.P;)r = i.aa(r), i = i.P;
        return e === i && a === r;
    }, yr.prototype.clone = function() {
        if (this.L.N || wr(this), this.L.$) return this.L.count.value += 1, this;
        var r = Ar, e = Object, a = e.create, i = Object.getPrototypeOf(this), n = this.L;
        return (r = r(a.call(e, i, {
            L: {
                value: {
                    count: n.count,
                    Z: n.Z,
                    $: n.$,
                    N: n.N,
                    O: n.O,
                    S: n.S,
                    T: n.T
                }
            }
        }))).L.count.value += 1, r.L.Z = !1, r;
    }, yr.prototype.delete = function() {
        this.L.N || wr(this), this.L.Z && !this.L.$ && M("Object already scheduled for deletion"), nr(this), fr(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
    }, yr.prototype.isDeleted = function() {
        return !this.L.N;
    }, yr.prototype.deleteLater = function() {
        return this.L.N || wr(this), this.L.Z && !this.L.$ && M("Object already scheduled for deletion"), x.push(this), 1 === x.length && K && K(J), this.L.Z = !0, this;
    }, Vr.prototype.pa = function(r) {
        return this.ja && (r = this.ja(r)), r;
    }, Vr.prototype.ga = function(r) {
        this.V && this.V(r);
    }, Vr.prototype.argPackAdvance = 8, Vr.prototype.readValueFromPointer = dr, Vr.prototype.deleteObject = function(r) {
        null !== r && r.delete();
    }, Vr.prototype.fromWireType = function(r) {
        function e() {
            return this.ca ? sr(this.M.W, {
                O: this.va,
                N: a,
                T: this,
                S: r
            }) : sr(this.M.W, {
                O: this,
                N: r
            });
        }
        var a = this.pa(r);
        if (!a) return this.ga(r), null;
        var i = function(r, e) {
            return e = $(r, e), _q[e];
        }(this.M, a);
        if (void 0 !== i) return 0 === i.L.count.value ? (i.L.N = a, i.L.S = r, i.clone()) : (i = i.clone(), this.ga(r), i);
        if (i = this.M.oa(a), !(i = cr[i])) return e.call(this);
        i = this.ba ? i.ka : i.pointerType;
        var n = or(a, this.M, i.M);
        return null === n ? e.call(this) : this.ca ? sr(i.M.W, {
            O: i,
            N: n,
            T: this,
            S: r
        }) : sr(i.M.W, {
            O: i,
            N: n
        });
    }, Tr = e.UnboundTypeError = Y("UnboundTypeError");
    var qr = "function" == typeof atob ? atob : function(r) {
        var e = "", a = 0;
        r = r.replace(/[^A-Za-z0-9\+\/=]/g, "");
        do {
            var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++));
            i = i << 2 | n >> 4, n = (15 & n) << 4 | t >> 2;
            var o = (3 & t) << 6 | f;
            e += String.fromCharCode(i), 64 !== t && (e += String.fromCharCode(n)), 64 !== f && (e += String.fromCharCode(o));
        }while (a < r.length);
        return e;
    }, $r = {
        q: function q(r, e, a) {
            r = _D(r), e = ir(e, "wrapper"), a = H(a);
            var i = [].slice, n = e.M, t = n.W, f = n.P.W, o = n.P.constructor;
            for(var c in r = C(r, function() {
                n.P.ia.forEach((function(r) {
                    if (this[r] === f[r]) throw new z("Pure virtual function " + r + " must be implemented in JavaScript");
                }).bind(this)), Object.defineProperty(this, "__parent", {
                    value: t
                }), this.__construct.apply(this, i.call(arguments));
            }), t.__construct = function() {
                this === t && M("Pass correct 'this' to __construct");
                var r = o.implement.apply(void 0, [
                    this
                ].concat(i.call(arguments)));
                nr(r);
                var e = r.L;
                r.notifyOnDestruction(), e.$ = !0, Object.defineProperties(this, {
                    L: {
                        value: e
                    }
                }), Ar(this), r = e.N, r = $(n, r), _q.hasOwnProperty(r) ? M("Tried to register registered instance: " + r) : _q[r] = this;
            }, t.__destruct = function() {
                this === t && M("Pass correct 'this' to __destruct"), nr(this);
                var r = this.L.N;
                r = $(n, r), _q.hasOwnProperty(r) ? delete _q[r] : M("Tried to unregister unregistered instance: " + r);
            }, r.prototype = Object.create(t), a)r.prototype[c] = a[c];
            return Q(r);
        },
        k: function k(r) {
            var e = kr[r];
            delete kr[r];
            var a = e.ea, i = e.V, n = e.ha;
            pr([
                r
            ], n.map(function(r) {
                return r.sa;
            }).concat(n.map(function(r) {
                return r.ya;
            })), function(r) {
                var t = {};
                return n.forEach(function(e, a) {
                    var i = r[a], f = e.qa, o = e.ra, c = r[a + n.length], u = e.xa, b = e.za;
                    t[e.na] = {
                        read: function read(r) {
                            return i.fromWireType(f(o, r));
                        },
                        write: function write(r, e) {
                            var a = [];
                            u(b, r, c.toWireType(a, e)), lr(a);
                        }
                    };
                }), [
                    {
                        name: e.name,
                        fromWireType: function fromWireType(r) {
                            var e, a = {};
                            for(e in t)a[e] = t[e].read(r);
                            return i(r), a;
                        },
                        toWireType: function toWireType(r, e) {
                            for(var n in t)if (!(n in e)) throw new TypeError('Missing field:  "' + n + '"');
                            var f = a();
                            for(n in t)t[n].write(f, e[n]);
                            return null !== r && r.push(i, f), f;
                        },
                        argPackAdvance: 8,
                        readValueFromPointer: dr,
                        U: i
                    }
                ];
            });
        },
        w: function w() {},
        C: function C(r, e, a, i, n) {
            var t = mr(a);
            Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    return !!r;
                },
                toWireType: function toWireType(r, e) {
                    return e ? i : n;
                },
                argPackAdvance: 8,
                readValueFromPointer: function readValueFromPointer(r) {
                    if (1 === a) var i = k;
                    else if (2 === a) i = d;
                    else {
                        if (4 !== a) throw new TypeError("Unknown boolean type size: " + e);
                        i = h;
                    }
                    return this.fromWireType(i[r >> t]);
                },
                U: null
            });
        },
        f: function f(r, a, i, n, t, _f, o, c, u, b, s, A, k) {
            s = _D(s), _f = Br(t, _f), c && (c = Br(o, c)), b && (b = Br(u, b)), k = Br(A, k);
            var l = F(s);
            !function(r, a) {
                e.hasOwnProperty(r) ? (M("Cannot register public name '" + r + "' twice"), Er(e, r, r), e.hasOwnProperty(void 0) && M("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), e[r].R[void 0] = a) : e[r] = a;
            }(l, function() {
                Ir("Cannot construct " + s + " due to unbound types", [
                    n
                ]);
            }), pr([
                r,
                a,
                i
            ], n ? [
                n
            ] : [], function(a) {
                if (a = a[0], n) var i = a.M, t = i.W;
                else t = yr.prototype;
                a = C(l, function() {
                    if (Object.getPrototypeOf(this) !== o) throw new U("Use 'new' to construct " + s);
                    if (void 0 === u.X) throw new U(s + " has no accessible constructor");
                    var r = u.X[arguments.length];
                    if (void 0 === r) throw new U("Tried to invoke ctor of " + s + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(u.X).toString() + ") parameters instead!");
                    return r.apply(this, arguments);
                });
                var o = Object.create(t, {
                    constructor: {
                        value: a
                    }
                });
                a.prototype = o;
                var u = new Gr(s, a, o, k, i, _f, c, b);
                i = new Vr(s, u, !0, !1), t = new Vr(s + "*", u, !1, !1);
                var A = new Vr(s + " const*", u, !1, !0);
                return cr[r] = {
                    pointerType: t,
                    ka: A
                }, function(r, a) {
                    e.hasOwnProperty(r) || br("Replacing nonexistant public symbol"), e[r] = a, e[r].Y = void 0;
                }(l, a), [
                    i,
                    t,
                    A
                ];
            });
        },
        d: function d(r, e, a, i, n, t, f) {
            var o = Or(a, i);
            e = _D(e), t = Br(n, t), pr([], [
                r
            ], function(r) {
                function i() {
                    Ir("Cannot call " + n + " due to unbound types", o);
                }
                var n = (r = r[0]).name + "." + e;
                e.startsWith("@@") && (e = Symbol[e.substring(2)]);
                var c = r.M.constructor;
                return void 0 === c[e] ? (i.Y = a - 1, c[e] = i) : (Er(c, e, n), c[e].R[a - 1] = i), pr([], o, function(r) {
                    return r = Xr(n, [
                        r[0],
                        null
                    ].concat(r.slice(1)), null, t, f), void 0 === c[e].R ? (r.Y = a - 1, c[e] = r) : c[e].R[a - 1] = r, [];
                }), [];
            });
        },
        p: function p(r, e, a, i, n, t) {
            0 < e || X();
            var f = Or(e, a);
            n = Br(i, n), pr([], [
                r
            ], function(r) {
                var a = "constructor " + (r = r[0]).name;
                if (void 0 === r.M.X && (r.M.X = []), void 0 !== r.M.X[e - 1]) throw new U("Cannot register multiple constructors with identical number of parameters (" + (e - 1) + ") for class '" + r.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
                return r.M.X[e - 1] = function() {
                    Ir("Cannot construct " + r.name + " due to unbound types", f);
                }, pr([], f, function(i) {
                    return i.splice(1, 0, null), r.M.X[e - 1] = Xr(a, i, null, n, t), [];
                }), [];
            });
        },
        b: function b(r, e, a, i, n, t, f, o) {
            var c = Or(a, i);
            e = _D(e), t = Br(n, t), pr([], [
                r
            ], function(r) {
                function i() {
                    Ir("Cannot call " + n + " due to unbound types", c);
                }
                var n = (r = r[0]).name + "." + e;
                e.startsWith("@@") && (e = Symbol[e.substring(2)]), o && r.M.ia.push(e);
                var u = r.M.W, b = u[e];
                return void 0 === b || void 0 === b.R && b.className !== r.name && b.Y === a - 2 ? (i.Y = a - 2, i.className = r.name, u[e] = i) : (Er(u, e, n), u[e].R[a - 2] = i), pr([], c, function(i) {
                    return i = Xr(n, i, r, t, f), void 0 === u[e].R ? (i.Y = a - 2, u[e] = i) : u[e].R[a - 2] = i, [];
                }), [];
            });
        },
        B: function B(r, e) {
            Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    var e = H(r);
                    return Lr(r), e;
                },
                toWireType: function toWireType(r, e) {
                    return Q(e);
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: null
            });
        },
        n: function n(r, e, a) {
            a = mr(a), Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    return r;
                },
                toWireType: function toWireType(r, e) {
                    return e;
                },
                argPackAdvance: 8,
                readValueFromPointer: Fr(e, a),
                U: null
            });
        },
        e: function e(r, _e2, a, i, n) {
            _e2 = _D(_e2), -1 === n && (n = 4294967295), n = mr(a);
            var t = function t(r) {
                return r;
            };
            if (0 === i) {
                var f = 32 - 8 * a;
                t = function t(r) {
                    return r << f >>> f;
                };
            }
            a = _e2.includes("unsigned") ? function(r, e) {
                return e >>> 0;
            } : function(r, e) {
                return e;
            }, Nr(r, {
                name: _e2,
                fromWireType: t,
                toWireType: a,
                argPackAdvance: 8,
                readValueFromPointer: Cr(_e2, n, 0 !== i),
                U: null
            });
        },
        c: function c(r, e, a) {
            function i(r) {
                r >>= 2;
                var e = p;
                return new n(e.buffer, e[r + 1], e[r]);
            }
            var n = [
                Int8Array,
                Uint8Array,
                Int16Array,
                Uint16Array,
                Int32Array,
                Uint32Array,
                Float32Array,
                Float64Array
            ][e];
            Nr(r, {
                name: a = _D(a),
                fromWireType: i,
                argPackAdvance: 8,
                readValueFromPointer: i
            }, {
                ta: !0
            });
        },
        o: function o(r, e) {
            var a = "std::string" === (e = _D(e));
            Nr(r, {
                name: e,
                fromWireType: function fromWireType(r) {
                    var e = p[r >> 2], i = r + 4;
                    if (a) for(var n = i, t = 0; t <= e; ++t){
                        var f = i + t;
                        if (t == e || 0 == l[f]) {
                            if (n = n ? y(l, n, f - n) : "", void 0 === o) var o = n;
                            else o += String.fromCharCode(0), o += n;
                            n = f + 1;
                        }
                    }
                    else {
                        for(o = Array(e), t = 0; t < e; ++t)o[t] = String.fromCharCode(l[i + t]);
                        o = o.join("");
                    }
                    return ne(r), o;
                },
                toWireType: function toWireType(r, e) {
                    e instanceof ArrayBuffer && (e = new Uint8Array(e));
                    var i, n = "string" == typeof e;
                    if (n || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || M("Cannot pass non-string to std::string"), a && n) {
                        var t = 0;
                        for(i = 0; i < e.length; ++i){
                            var f = e.charCodeAt(i);
                            127 >= f ? t++ : 2047 >= f ? t += 2 : 55296 <= f && 57343 >= f ? (t += 4, ++i) : t += 3;
                        }
                        i = t;
                    } else i = e.length;
                    if (f = (t = ie(4 + i + 1)) + 4, p[t >> 2] = i, a && n) {
                        if (n = f, f = i + 1, i = l, 0 < f) {
                            f = n + f - 1;
                            for(var o = 0; o < e.length; ++o){
                                var c = e.charCodeAt(o);
                                if (55296 <= c && 57343 >= c && (c = 65536 + ((1023 & c) << 10) | 1023 & e.charCodeAt(++o)), 127 >= c) {
                                    if (n >= f) break;
                                    i[n++] = c;
                                } else {
                                    if (2047 >= c) {
                                        if (n + 1 >= f) break;
                                        i[n++] = 192 | c >> 6;
                                    } else {
                                        if (65535 >= c) {
                                            if (n + 2 >= f) break;
                                            i[n++] = 224 | c >> 12;
                                        } else {
                                            if (n + 3 >= f) break;
                                            i[n++] = 240 | c >> 18, i[n++] = 128 | c >> 12 & 63;
                                        }
                                        i[n++] = 128 | c >> 6 & 63;
                                    }
                                    i[n++] = 128 | 63 & c;
                                }
                            }
                            i[n] = 0;
                        }
                    } else if (n) for(n = 0; n < i; ++n)255 < (o = e.charCodeAt(n)) && (ne(f), M("String has UTF-16 code units that do not fit in 8 bits")), l[f + n] = o;
                    else for(n = 0; n < i; ++n)l[f + n] = e[n];
                    return null !== r && r.push(ne, t), t;
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: function U(r) {
                    ne(r);
                }
            });
        },
        j: function j(r, e, a) {
            if (a = _D(a), 2 === e) var i = Sr, n = Pr, t = Yr, f = function f() {
                return v;
            }, o = 1;
            else 4 === e && (i = Ur, n = Mr, t = Hr, f = function f() {
                return p;
            }, o = 2);
            Nr(r, {
                name: a,
                fromWireType: function fromWireType(r) {
                    for(var a, n = p[r >> 2], t = f(), c = r + 4, u = 0; u <= n; ++u){
                        var b = r + 4 + u * e;
                        u != n && 0 != t[b >> o] || (c = i(c, b - c), void 0 === a ? a = c : (a += String.fromCharCode(0), a += c), c = b + e);
                    }
                    return ne(r), a;
                },
                toWireType: function toWireType(r, i) {
                    "string" != typeof i && M("Cannot pass non-string to C++ string type " + a);
                    var f = t(i), c = ie(4 + f + e);
                    return p[c >> 2] = f >> o, n(i, c + 4, f + e), null !== r && r.push(ne, c), c;
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: function U(r) {
                    ne(r);
                }
            });
        },
        l: function l(r, e, a, i, n, t) {
            kr[r] = {
                name: _D(e),
                ea: Br(a, i),
                V: Br(n, t),
                ha: []
            };
        },
        i: function i(r, e, a, _i, n, t, f, o, c, u) {
            kr[r].ha.push({
                na: _D(e),
                sa: a,
                qa: Br(_i, n),
                ra: t,
                ya: f,
                xa: Br(o, c),
                za: u
            });
        },
        D: function D(r, e) {
            Nr(r, {
                ua: !0,
                name: e = _D(e),
                argPackAdvance: 0,
                fromWireType: function fromWireType() {},
                toWireType: function toWireType() {}
            });
        },
        t: function t(r, e, a, i, n) {
            r = jr[r], e = H(e), a = zr(a);
            var t = [];
            return p[i >> 2] = Q(t), r(e, a, t, n);
        },
        u: function u(r, e, a, i) {
            (r = jr[r])(e = H(e), a = zr(a), null, i);
        },
        h: Lr,
        m: function m(r, e) {
            var a = function(r, e) {
                for(var a = Array(r), i = 0; i < r; ++i)a[i] = ir(p[e + 4 * i >> 2], "parameter " + i);
                return a;
            }(r, e), i = a[0];
            e = i.name + "_$" + a.slice(1).map(function(r) {
                return r.name;
            }).join("_") + "$";
            var n = Dr[e];
            if (void 0 !== n) return n;
            var t = Array(r - 1);
            return n = function(r) {
                var e = jr.length;
                return jr.push(r), e;
            }(function(e, n, f, o) {
                for(var c = 0, u = 0; u < r - 1; ++u)t[u] = a[u + 1].readValueFromPointer(o + c), c += a[u + 1].argPackAdvance;
                for(e = e[n].apply(e, t), u = 0; u < r - 1; ++u)a[u + 1].la && a[u + 1].la(t[u]);
                if (!i.ua) return i.toWireType(f, e);
            }), Dr[e] = n;
        },
        r: function r(_r2) {
            4 < _r2 && (S[_r2].fa += 1);
        },
        s: function s(r) {
            lr(H(r)), Lr(r);
        },
        g: function g() {
            X("");
        },
        y: function y(r, e, a) {
            l.copyWithin(r, e, e + a);
        },
        x: function x(r) {
            var e = l.length;
            if (2147483648 < (r >>>= 0)) return !1;
            for(var a = 1; 4 >= a; a *= 2){
                var i = e * (1 + .2 / a);
                i = Math.min(i, r + 100663296);
                var n = Math, t = n.min;
                i = Math.max(r, i), i += (65536 - i % 65536) % 65536;
                r: {
                    var f = A.buffer;
                    try {
                        A.grow(t.call(n, 2147483648, i) - f.byteLength + 65535 >>> 16), E();
                        var o = 1;
                        break r;
                    } catch (r) {}
                    o = void 0;
                }
                if (o) return !0;
            }
            return !1;
        },
        A: function A() {
            return 52;
        },
        v: function v() {
            return 70;
        },
        z: function z(r, e, a, i) {
            for(var n = 0, t = 0; t < a; t++){
                var f = p[e >> 2], u = p[e + 4 >> 2];
                e += 8;
                for(var b = 0; b < u; b++){
                    var s = l[f + b], A = xr[r];
                    0 === s || 10 === s ? ((1 === r ? o : c)(y(A, 0)), A.length = 0) : A.push(s);
                }
                n += u;
            }
            return p[i >> 2] = n, 0;
        },
        a: A
    }, re = function() {
        function r(r) {
            e.asm = r.exports, R = e.asm.I, Z.unshift(e.asm.E), T--, e.monitorRunDependencies && e.monitorRunDependencies(T), 0 == T && I && (r = I, I = null, r());
        }
        var a = {
            a: $r
        };
        if (T++, e.monitorRunDependencies && e.monitorRunDependencies(T), e.instantiateWasm) try {
            return e.instantiateWasm(a, r);
        } catch (r) {
            c("Module.instantiateWasm callback failed with error: " + r), i(r);
        }
        return a = function(r) {
            var e = B;
            try {
                try {
                    if (e == B && f) new Uint8Array(f);
                    else {
                        if (O(e)) {
                            try {
                                var a = qr(e.slice(37)), i = new Uint8Array(a.length);
                                for(e = 0; e < a.length; ++e)i[e] = a.charCodeAt(e);
                                var n = i;
                            } catch (r) {
                                throw Error("Converting base64 string to bytes failed.");
                            }
                            var t = n;
                        } else t = void 0;
                        if (!t) throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
                    }
                } catch (r) {
                    X(r);
                }
                var o = new u(), s = new b(r);
            } catch (e) {
                throw r = e.toString(), c("failed to compile wasm module: " + r), (r.includes("imported Memory") || r.includes("memory import")) && c("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), e;
            }
            return [
                s,
                o
            ];
        }(a), r(a[0]), e.asm;
    }(), ee = e.___getTypeName = re.F;
    e.__embind_initialize_bindings = re.G;
    var ae, ie = re.H, ne = re.J;
    function te() {
        function r() {
            if (!ae && (ae = !0, e.calledRun = !0, !w)) {
                if (_(Z), a(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun) for("function" == typeof e.postRun && (e.postRun = [
                    e.postRun
                ]); e.postRun.length;){
                    var r = e.postRun.shift();
                    W.unshift(r);
                }
                _(W);
            }
        }
        if (!(0 < T)) {
            if (e.preRun) for("function" == typeof e.preRun && (e.preRun = [
                e.preRun
            ]); e.preRun.length;)V();
            _(g), 0 < T || (e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
                setTimeout(function() {
                    e.setStatus("");
                }, 1), r();
            }, 1)) : r());
        }
    }
    if (e.dynCall_jiji = re.K, I = function r() {
        ae || te(), ae || (I = r);
    }, e.preInit) for("function" == typeof e.preInit && (e.preInit = [
        e.preInit
    ]); 0 < e.preInit.length;)e.preInit.pop()();
    return te(), r;
});
function ar() {
    return AE(er());
}
// eslint-disable-next-line import/no-unresolved
var index = ar();

},{"@babel/runtime/helpers/extends":"lKkcq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hAlka":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"3Mfyz":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"9XUUt"}],"9XUUt":[function(require,module,exports) {
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var f, g, h, k, l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null, q = null, t = function() {
        if (null !== p) try {
            var a = exports.unstable_now();
            p(!0, a);
            p = null;
        } catch (b) {
            throw setTimeout(t, 0), b;
        }
    }, u = Date.now();
    exports.unstable_now = function() {
        return Date.now() - u;
    };
    f = function(a) {
        null !== p ? setTimeout(f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function(a, b) {
        q = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(q);
    };
    k = function() {
        return !1;
    };
    l = exports.unstable_forceFrameRate = function() {};
} else {
    var w = window.performance, x = window.Date, y = window.setTimeout, z = window.clearTimeout, A = window.requestAnimationFrame, B = window.cancelAnimationFrame;
    "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function() {
        return w.now();
    };
    else {
        var C = x.now();
        exports.unstable_now = function() {
            return x.now() - C;
        };
    }
    var D = !1, E = null, F = -1, G = 5, H = 0;
    k = function() {
        return exports.unstable_now() >= H;
    };
    l = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : G = 0 < a ? Math.floor(1E3 / a) : 33.33;
    };
    var I = new MessageChannel, J = I.port2;
    I.port1.onmessage = function() {
        if (null !== E) {
            var a = exports.unstable_now();
            H = a + G;
            try {
                E(!0, a) ? J.postMessage(null) : (D = !1, E = null);
            } catch (b) {
                throw J.postMessage(null), b;
            }
        } else D = !1;
    };
    f = function(a) {
        E = a;
        D || (D = !0, J.postMessage(null));
    };
    g = function(a, b) {
        F = y(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        z(F);
        F = -1;
    };
}
function K(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = Math.floor((c - 1) / 2), e = a[d];
        if (void 0 !== e && 0 < L(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function M(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function N(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > L(n, c)) void 0 !== r && 0 > L(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > L(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function L(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var O = [], P = [], Q = 1, R = null, S = 3, T = !1, U = !1, V = !1;
function W(a) {
    for(var b = M(P); null !== b;){
        if (null === b.callback) N(P);
        else if (b.startTime <= a) N(P), b.sortIndex = b.expirationTime, K(O, b);
        else break;
        b = M(P);
    }
}
function X(a) {
    V = !1;
    W(a);
    if (!U) {
        if (null !== M(O)) U = !0, f(Y);
        else {
            var b = M(P);
            null !== b && g(X, b.startTime - a);
        }
    }
}
function Y(a, b) {
    U = !1;
    V && (V = !1, h());
    T = !0;
    var c = S;
    try {
        W(b);
        for(R = M(O); null !== R && (!(R.expirationTime > b) || a && !k());){
            var d = R.callback;
            if (null !== d) {
                R.callback = null;
                S = R.priorityLevel;
                var e = d(R.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? R.callback = e : R === M(O) && N(O);
                W(b);
            } else N(O);
            R = M(O);
        }
        if (null !== R) var m = !0;
        else {
            var n = M(P);
            null !== n && g(X, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        R = null, S = c, T = !1;
    }
}
function Z(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var aa = l;
exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 5;
exports.unstable_LowPriority = 4;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = S;
    S = a;
    try {
        return b();
    } finally{
        S = c;
    }
};
exports.unstable_next = function(a) {
    switch(S){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = S;
    }
    var c = S;
    S = b;
    try {
        return a();
    } finally{
        S = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : Z(a);
    } else c = Z(a), e = d;
    c = e + c;
    a = {
        id: Q++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, K(P, a), null === M(O) && a === M(P) && (V ? h() : V = !0, g(X, e - d))) : (a.sortIndex = c, K(O, a), U || T || (U = !0, f(Y)));
    return a;
};
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_wrapCallback = function(a) {
    var b = S;
    return function() {
        var c = S;
        S = b;
        try {
            return a.apply(this, arguments);
        } finally{
            S = c;
        }
    };
};
exports.unstable_getCurrentPriorityLevel = function() {
    return S;
};
exports.unstable_shouldYield = function() {
    var a = exports.unstable_now();
    W(a);
    var b = M(O);
    return b !== R && null !== R && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < R.expirationTime || k();
};
exports.unstable_requestPaint = aa;
exports.unstable_continueExecution = function() {
    U || T || (U = !0, f(Y));
};
exports.unstable_pauseExecution = function() {};
exports.unstable_getFirstCallbackNode = function() {
    return M(O);
};
exports.unstable_Profiling = null;

},{}],"f9RHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimesheet", ()=>getTimesheet);
parcelHelpers.export(exports, "buildTimesheet", ()=>buildTimesheet);
parcelHelpers.export(exports, "sumTimesheet", ()=>sumTimesheet);
var _dateFns = require("date-fns");
var _lib = require("../../lib");
const getTimesheet = async (sheet)=>{
    var _sheet_employee_clients;
    const timesheet = await buildTimesheet(sheet);
    const isApproved = timesheet.reduce((current, { approved })=>current === null || approved === null ? null : current || (approved !== null && approved !== void 0 ? approved : false), false);
    const sheetIds = timesheet.flatMap(({ approved, clientID })=>isApproved && approved ? clientID !== null && clientID !== void 0 ? clientID : [] : []);
    const activeIds = (await (0, _lib.filterNull)((_sheet_employee_clients = sheet.employee.clients) === null || _sheet_employee_clients === void 0 ? void 0 : _sheet_employee_clients.items)).map(({ clientID })=>clientID);
    return {
        timesheet,
        isApproved,
        clientIDs: [
            ...new Set(sheetIds.concat(isApproved ? [] : activeIds))
        ]
    };
};
const buildTimesheet = async ({ employee, week, client })=>{
    var _employee_clients, _employee_timelogs;
    return buildSheetData(employee.id, await (0, _lib.filterNull)((_employee_clients = employee.clients) === null || _employee_clients === void 0 ? void 0 : _employee_clients.items), await (0, _lib.filterNull)((_employee_timelogs = employee.timelogs) === null || _employee_timelogs === void 0 ? void 0 : _employee_timelogs.items, ({ clientID: id })=>!client || id === client.id), (0, _dateFns.eachDayOfInterval)(week).slice(0, 7));
};
const buildSheetData = async (employeeID, contracts, logs, dates)=>dates.map((val, idx)=>{
        var _contracts_;
        const date = val.toLocaleDateString("sv");
        const clientID = (_contracts_ = contracts[0]) === null || _contracts_ === void 0 ? void 0 : _contracts_.clientID;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { __typename, createdAt, updatedAt, ...log } = logs.length && date === logs[0].date ? logs.shift() : {
            __typename: "",
            createdAt: "",
            updatedAt: ""
        };
        return {
            id: idx.toString(),
            employeeID,
            clientID,
            ...log,
            date: date.replace(/-/g, "/")
        };
    });
const sumTimesheet = (timesheet)=>{
    const counts = timesheet.reduce((acc, sheet)=>{
        acc.standard += sheet.standard || 0;
        acc.overtime += sheet.overtime || 0;
        acc.sick += sheet.sick || 0;
        acc.holiday += sheet.holiday || 0;
        return acc;
    }, {
        standard: 0,
        overtime: 0,
        sick: 0,
        holiday: 0,
        total: 0
    });
    counts.total = counts.standard + counts.overtime + counts.sick + counts.holiday;
    return counts;
};

},{"date-fns":"5Pdd3","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gW0kq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimesheetPDF", ()=>TimesheetPDF);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _components = require("./components");
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ page: {},
    container: {
        marginHorizontal: 10,
        flex: 1,
        flexDirection: "column",
        justifyContent: "flex-start"
    }
});
(0, _renderer.Font).register({
    family: "Lato",
    src: "https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf"
});
(0, _renderer.Font).register({
    family: "Lato Italic",
    src: "https://fonts.gstatic.com/s/lato/v16/S6u8w4BMUTPHjxsAXC-v.ttf"
});
(0, _renderer.Font).register({
    family: "Lato Bold",
    src: "https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf"
});
const TimesheetPDF = ({ title, timesheet, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Document), {
        author: "Test Driven Solutions Ltd",
        subject: "Weekly client hours",
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
            orientation: "landscape",
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Header), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                    style: styles.container,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Overview), {
                            ...props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.WeekSummary), {
                            data: timesheet
                        })
                    ]
                })
            ]
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","./components":"l0oiY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l0oiY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _header = require("./Header");
parcelHelpers.exportAll(_header, exports);
var _info = require("./Info");
parcelHelpers.exportAll(_info, exports);
var _overview = require("./Overview");
parcelHelpers.exportAll(_overview, exports);
var _weekSummary = require("./WeekSummary");
parcelHelpers.exportAll(_weekSummary, exports);
var _weekEntry = require("./WeekEntry");
parcelHelpers.exportAll(_weekEntry, exports);

},{"./Header":"cmeEt","./Info":"c4R6l","./Overview":"f5h8q","./WeekSummary":"hvDlN","./WeekEntry":"3H2cf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cmeEt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _tdsLogoPng = require("../../../../assets/tds_logo.png");
var _tdsLogoPngDefault = parcelHelpers.interopDefault(_tdsLogoPng);
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ container: {
        flexDirection: "row",
        borderBottomWidth: 2,
        borderBottomColor: "#112131",
        borderBottomStyle: "solid",
        alignItems: "stretch"
    },
    detailColumn: {
        flexDirection: "column",
        flexGrow: 9,
        textTransform: "uppercase",
        margin: 10
    },
    logoColumn: {
        flexDirection: "column",
        flexGrow: 2,
        alignSelf: "flex-end",
        justifySelf: "flex-end"
    },
    name: {
        fontSize: 24,
        fontFamily: "Lato Bold"
    },
    subtitle: {
        fontSize: 10,
        justifySelf: "flex-end",
        fontFamily: "Lato"
    },
    image: {
        margin: 10,
        width: 80,
        alignSelf: "flex-end",
        justifySelf: "flex-end"
    }
});
const Header = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.detailColumn,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.name,
                        children: "Weekly Timesheet"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.subtitle,
                        children: "Test Driven Solutions Ltd."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: styles.logoColumn,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                    src: (0, _tdsLogoPngDefault.default),
                    style: styles.image
                })
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","../../../../assets/tds_logo.png":"fXoXz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fXoXz":[function(require,module,exports) {
module.exports = require("2a5cd96175f34070").getBundleURL("8E3eK") + "tds_logo.72882969.png";

},{"2a5cd96175f34070":"fGflc"}],"c4R6l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Info", ()=>Info);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ item: {
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between"
    },
    title: {
        margin: 4,
        fontSize: 14,
        fontFamily: "Lato Bold",
        textAlign: "justify"
    },
    content: {
        margin: 4,
        fontSize: 12,
        fontFamily: "Lato",
        textAlign: "justify"
    }
});
const Info = ({ title, content })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: styles.item,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.title,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.content,
                children: content
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f5h8q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overview", ()=>Overview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _dateFns = require("date-fns");
var _ = require(".");
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ container: {
        flexDirection: "row",
        "@media max-width: 400": {
            flexDirection: "column"
        }
    },
    column: {
        flexDirection: "column",
        flexGrow: 1,
        flexBasis: "auto",
        paddingTop: 15,
        paddingRight: 10,
        "@media max-width: 400": {
            width: "100%",
            paddingRight: 0
        }
    }
});
const Overview = ({ employee: { firstName, lastName, email }, client, week: { start }, address })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.column,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Address:",
                        content: `${address.line1}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        content: `${address.line2}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "City:",
                        content: `${address.line3}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Client:",
                        content: `${client.firstName} ${client.lastName} (${client.company.name})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.column,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Pay Period Start Date:",
                        content: (0, _dateFns.toDate)(start).toLocaleDateString()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Pay Period End Date:",
                        content: (0, _dateFns.nextFriday)(start).toLocaleDateString()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Employee:",
                        content: `${firstName} ${lastName}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Info), {
                        title: "Employee Email:",
                        content: email
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","date-fns":"5Pdd3",".":"l0oiY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hvDlN":[function(require,module,exports) {
/* eslint-disable no-sparse-arrays */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeekSummary", ()=>WeekSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _dateFns = require("date-fns");
var _weekEntry = require("./WeekEntry");
const HEADER = [
    "Day",
    "Date",
    "Standard",
    "Overtime",
    "Sick",
    "Holiday",
    "Total"
];
const FOOTER = [
    "",
    "Total Hours"
];
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ container: {
        paddingTop: 25,
        paddingLeft: 15,
        flexDirection: "column"
    },
    date: {
        fontSize: 11,
        fontFamily: "Lato Italic"
    }
});
const formatValues = ({ date: strDate, standard, overtime, sick, holiday })=>{
    const hours = [
        standard,
        overtime,
        sick,
        holiday
    ].map((v)=>v !== null && v !== void 0 ? v : 0);
    const total = hours.reduce((a, b)=>a + b, 0);
    const date = new Date(strDate);
    return {
        values: [
            (0, _dateFns.format)(date, "EEEE"),
            date.toLocaleDateString(),
            ...hours,
            total
        ],
        hours: [
            ...hours,
            total
        ]
    };
};
const WeekRow = ({ values, ...rest })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weekEntry.WeekEntry), {
        children: [
            ...values
        ].map((value, i)=>/*#__PURE__*/ (0, _react.createElement)((0, _weekEntry.Value), {
                ...rest,
                key: i,
                isNumber: typeof value === "number"
            }, value))
    });
const WeekSummary = ({ data })=>{
    let totals = [
        0,
        0,
        0,
        0,
        0
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: styles.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WeekRow, {
                values: HEADER,
                header: true
            }, data.length),
            data.map((data, idx)=>{
                const { values, hours } = formatValues(data);
                totals = totals.map((val, idx)=>val + hours[idx]);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WeekRow, {
                    values: values
                }, idx);
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WeekRow, {
                values: [
                    ...FOOTER,
                    ...totals
                ],
                footer: true
            }, data.length + 1)
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","date-fns":"5Pdd3","./WeekEntry":"3H2cf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3H2cf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeekEntry", ()=>WeekEntry);
parcelHelpers.export(exports, "Value", ()=>Value);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
const styles = (0, _renderer.StyleSheet).create({
    /* stylelint-disable */ entryContainer: {
        flexDirection: "row",
        flexGrow: 1,
        flexBasis: "auto",
        flex: 1
    },
    rowContainer: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-around"
    },
    header: {
        flex: 1,
        fontSize: 16,
        color: "black",
        textDecoration: "none",
        fontFamily: "Lato Bold",
        textAlign: "center",
        paddingBottom: 6
    },
    item: {
        flex: 1,
        fontSize: 14,
        fontFamily: "Lato",
        paddingHorizontal: 3,
        paddingVertical: 7
    },
    number: {
        textAlign: "right",
        borderLeft: 1
    },
    footer: {
        border: 1,
        borderRight: 0,
        backgroundColor: "#9a9a9a"
    }
});
const WeekEntry = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
        style: styles.rowContainer,
        children: children
    });
const Value = ({ header, footer, isNumber, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
        style: styles.entryContainer,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
            style: [
                header ? styles.header : styles.item,
                footer && children !== "" ? styles.footer : {},
                isNumber ? styles.number : {}
            ],
            children: children
        })
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@react-pdf/renderer":"dlG57","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hKqbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsDesktop", ()=>hiddenColumnsDesktop);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("../../components");
var _lib = require("../../lib");
const hourFields = Object.values((0, _lib.HourCategories)).reduce((fields, cat)=>[
        ...fields,
        {
            field: cat,
            headerName: cat[0].toUpperCase() + cat.slice(1),
            type: "number",
            width: 75,
            valueGetter: ({ row })=>row[cat].value
        }
    ], []);
const columns = ({ approveTimesheet })=>[
        {
            field: "approved",
            headerName: "Status",
            width: 60,
            align: "center",
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                    status: value
                })
        },
        {
            field: "employee",
            headerName: "Employee",
            minWidth: 200,
            flex: 1,
            renderCell: ({ row, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SummaryCell), {
                    data: row,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.UserCell), {
                        name: value !== null && value !== void 0 ? value : "",
                        clientIDs: row.total ? row.clientIDs : []
                    })
                })
        },
        ...hourFields,
        {
            field: "total",
            headerName: "Total",
            type: "number",
            width: 75
        },
        {
            field: "notes",
            headerName: "Notes",
            width: 200
        },
        {
            field: "logIds",
            headerName: "Approval",
            type: "actions",
            minWidth: 200,
            renderCell: ({ value: logIds, row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalCell), {
                    onApprove: ()=>{
                        approveTimesheet({
                            logIds,
                            approved: true
                        });
                        row.approved = "approved";
                    },
                    onReject: ()=>{
                        approveTimesheet({
                            logIds,
                            approved: false
                        });
                        row.approved = "rejected";
                    }
                })
        }
    ];
const hiddenColumnsDesktop = {
    overtime: false
};
const hiddenColumnsMobile = {
    ...hiddenColumnsDesktop,
    sick: false,
    holiday: false
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","../../components":"0272J","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5lLAa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "approvalQuery", ()=>approvalQuery);
var _lib = require("../../lib");
const emptyApproval = {
    log: {
        standard: {
            value: 0,
            dates: []
        },
        overtime: {
            value: 0,
            dates: []
        },
        sick: {
            value: 0,
            dates: []
        },
        holiday: {
            value: 0,
            dates: []
        }
    },
    approved: false,
    clientIDs: [],
    logIds: [],
    notes: []
};
const approvalQuery = ({ week, employeeID, companyID, logFilter })=>(input)=>{
        if (week === null) throw new Error(`Invalid date range. Value is ${week}`);
        const dateRange = (0, _lib.toDbDates)(week);
        const limit = 1000;
        var _input_key, _input_key1;
        const { queryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listEmployeesWithTimelogs",
            vars: {
                limit,
                ...input.vars,
                ...employeeID.length > 0 && {
                    employeeID
                },
                ...companyID.length > 0 && {
                    companyID
                },
                logFilter,
                dateRange
            },
            key: employeeID || companyID ? [
                dateRange,
                {
                    companyID,
                    employeeID
                },
                ...(_input_key = input.key) !== null && _input_key !== void 0 ? _input_key : []
            ] : [
                dateRange,
                ...(_input_key1 = input.key) !== null && _input_key1 !== void 0 ? _input_key1 : []
            ]
        });
        return {
            queryKey,
            queryFn: async ()=>{
                var _data_listEmployees, _data_listEmployees1;
                const { data, errors } = await queryFn();
                var _data_listEmployees_items;
                const employees = await (0, _lib.filterNull)((_data_listEmployees_items = data === null || data === void 0 ? void 0 : (_data_listEmployees = data.listEmployees) === null || _data_listEmployees === void 0 ? void 0 : _data_listEmployees.items) !== null && _data_listEmployees_items !== void 0 ? _data_listEmployees_items : [], (e)=>{
                    var _e_clients, _e_timelogs;
                    return !!(((_e_clients = e.clients) === null || _e_clients === void 0 ? void 0 : _e_clients.items.length) || ((_e_timelogs = e.timelogs) === null || _e_timelogs === void 0 ? void 0 : _e_timelogs.items.length));
                });
                var _data_listEmployees_nextToken;
                return {
                    employees,
                    items: await formatApprovalData(employees, !!logFilter),
                    nextToken: (_data_listEmployees_nextToken = data === null || data === void 0 ? void 0 : (_data_listEmployees1 = data.listEmployees) === null || _data_listEmployees1 === void 0 ? void 0 : _data_listEmployees1.nextToken) !== null && _data_listEmployees_nextToken !== void 0 ? _data_listEmployees_nextToken : undefined,
                    errors
                };
            },
            enabled: !companyID || !!logFilter
        };
    };
const formatApprovalData = async (employees, filterClients)=>Promise.all((filterClients ? employees.filter((e)=>{
        var _e_timelogs;
        var _e_timelogs_items_length;
        return ((_e_timelogs_items_length = (_e_timelogs = e.timelogs) === null || _e_timelogs === void 0 ? void 0 : _e_timelogs.items.length) !== null && _e_timelogs_items_length !== void 0 ? _e_timelogs_items_length : 0) > 0;
    }) : employees).map(buildApprovalRow));
const buildApprovalRow = async ({ timelogs, id, ...data })=>{
    const employee = `${data === null || data === void 0 ? void 0 : data.firstName} ${data === null || data === void 0 ? void 0 : data.lastName}`;
    var _timelogs_items;
    const { log, approved, clientIDs, logIds, notes } = (await (0, _lib.filterNull)((_timelogs_items = timelogs === null || timelogs === void 0 ? void 0 : timelogs.items) !== null && _timelogs_items !== void 0 ? _timelogs_items : [])).reduce(buildApprovalItem, emptyApproval);
    return {
        id,
        approved: approvedToString(approved),
        employee,
        clientIDs: [
            ...new Set(clientIDs)
        ],
        ...log,
        total: Object.values(log).reduce((a, b)=>a + b.value, 0),
        logIds,
        notes: (notes !== null && notes !== void 0 ? notes : []).filter(Boolean).join("; ")
    };
};
const buildApprovalItem = ({ log, approved, clientIDs, logIds, notes }, timelog)=>{
    var _timelog_approved;
    return {
        log: buildLogs(timelog, log),
        approved: approved === null ? null : (_timelog_approved = timelog.approved) !== null && _timelog_approved !== void 0 ? _timelog_approved : null,
        clientIDs: timelog.clientID ? [
            ...clientIDs,
            timelog.clientID
        ] : clientIDs,
        logIds: [
            ...logIds,
            timelog.id
        ],
        notes: (timelog === null || timelog === void 0 ? void 0 : timelog.notes) ? [
            ...notes,
            timelog.notes
        ] : notes
    };
};
const buildLogs = (log, init)=>Object.values((0, _lib.HourCategories)).reduce((curr, cat)=>{
        var _log_cat, _log_cat1;
        return {
            ...curr,
            [cat]: {
                value: curr[cat].value + ((_log_cat = log[cat]) !== null && _log_cat !== void 0 ? _log_cat : 0),
                dates: curr[cat].dates.concat({
                    date: log.date,
                    hours: (_log_cat1 = log[cat]) !== null && _log_cat1 !== void 0 ? _log_cat1 : 0
                })
            }
        };
    }, init);
const approvedToString = (val)=>val === null ? "pending" : val ? "approved" : "rejected";

},{"../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5EzgG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clients = require("./Clients");
parcelHelpers.exportAll(_clients, exports);

},{"./Clients":"cRhBJ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cRhBJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clients", ()=>Clients);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _lib = require("../../lib");
var _columns = require("./columns");
var _modals = require("./Modals");
const Clients = ()=>{
    const { isMd } = (0, _hooks.useResponsive)();
    const { showCreateModal, showUpdateModal, showDeactivateModal, showReactivateModal } = (0, _modals.useClientModals)();
    const [showActive, setShowActive] = (0, _react.useState)(true);
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)(({ vars, key })=>{
        const { queryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listCompaniesWithEmployees",
            vars: {
                ...vars
            },
            key
        });
        return {
            queryKey,
            queryFn: async ()=>{
                const { data, errors } = await queryFn();
                return {
                    ...data === null || data === void 0 ? void 0 : data.listCompanies,
                    errors
                };
            }
        };
    });
    const showActiveCompanies = {
        label: !showActive ? "Show Active" : "Show Inactive",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckCircleOutline), {}),
        onClick: ()=>setShowActive(!showActive)
    };
    var _data_items;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                action: {
                    label: "Add Client",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                    onClick: showCreateModal
                },
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Business), {}),
                title: "Clients",
                altAction: showActiveCompanies,
                testID: "add-client"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)(({ row })=>showUpdateModal({
                        row
                    })),
                data: ((_data_items = data === null || data === void 0 ? void 0 : data.items) !== null && _data_items !== void 0 ? _data_items : []).filter(({ inactiveAt })=>showActive != (!!inactiveAt && new Date(inactiveAt) < new Date())),
                emptyState: {
                    title: "No Client Entries",
                    description: "Get started by adding a client",
                    testID: "no-clients"
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                pagination: pagination,
                rowActions: [
                    {
                        label: "Edit",
                        onClick: ({ row })=>showUpdateModal({
                                row
                            }),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Edit), {})
                    },
                    showActive ? {
                        label: "Deactivate",
                        onClick: ({ row })=>showDeactivateModal(row),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Archive), {})
                    } : {
                        label: "Reactivate",
                        onClick: ({ row })=>showReactivateModal(row),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Unarchive), {})
                    }
                ],
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : (0, _columns.hiddenColumnsDesktop),
                testID: "clients"
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","../../components":"0272J","../../hooks":"9Pg07","../../lib":"lWrCo","./columns":"bxT8A","./Modals":"bWRdf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bxT8A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsDesktop", ()=>hiddenColumnsDesktop);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("../../components");
const columns = (onClick)=>[
        {
            field: "name",
            headerName: "Client",
            renderCell: ({ row, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ActionCell), {
                    onClick: ()=>onClick({
                            row
                        }),
                    children: value
                }),
            minWidth: 200,
            flex: 1
        },
        {
            field: "clientList",
            headerName: "Contact(s)",
            valueGetter: ({ row: { clients } })=>{
                var _clients_items_filter_map;
                return (_clients_items_filter_map = clients === null || clients === void 0 ? void 0 : clients.items.filter((i)=>!(i === null || i === void 0 ? void 0 : i.inactiveAt)).map((i)=>`${i === null || i === void 0 ? void 0 : i.firstName} ${i === null || i === void 0 ? void 0 : i.lastName}`)) !== null && _clients_items_filter_map !== void 0 ? _clients_items_filter_map : [];
            },
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ChipListCell), {
                    data: value !== null && value !== void 0 ? value : []
                }),
            minWidth: 200,
            flex: 1
        },
        {
            field: "contractors",
            headerName: "Consultant(s)",
            valueGetter: ({ row: { clients } })=>{
                var _clients_items_flatMap;
                return (_clients_items_flatMap = clients === null || clients === void 0 ? void 0 : clients.items.flatMap((i)=>{
                    var _i_employees;
                    var _i_employees_items;
                    return ((_i_employees_items = i === null || i === void 0 ? void 0 : (_i_employees = i.employees) === null || _i_employees === void 0 ? void 0 : _i_employees.items) !== null && _i_employees_items !== void 0 ? _i_employees_items : []).map((e)=>`${e === null || e === void 0 ? void 0 : e.employee.firstName} ${e === null || e === void 0 ? void 0 : e.employee.lastName}`);
                })) !== null && _clients_items_flatMap !== void 0 ? _clients_items_flatMap : [];
            },
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ChipListCell), {
                    data: value !== null && value !== void 0 ? value : []
                }),
            minWidth: 200,
            flex: 1
        }
    ];
const hiddenColumnsDesktop = {};
const hiddenColumnsMobile = {
    ...hiddenColumnsDesktop
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bWRdf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clientModal = require("./ClientModal");
parcelHelpers.exportAll(_clientModal, exports);
var _useClientModals = require("./useClientModals");
parcelHelpers.exportAll(_useClientModals, exports);

},{"./ClientModal":"e0Ox6","./useClientModals":"bhuvc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"e0Ox6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientModal", ()=>ClientModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _components = require("../../../components");
var _api = require("../../../API");
var _lib = require("../../../lib");
const ClientModal = ({ title, onSubmit, testID, params: { row }, ...rest })=>{
    const [saving, setSaving] = (0, _react.useState)(false);
    const { control, handleSubmit, setValue } = (0, _reactHookForm.useForm)({
        defaultValues: mapDefaultValues(row)
    });
    const { fields, append, update } = (0, _reactHookForm.useFieldArray)({
        control,
        name: "clients"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                setSaving(true);
                return onSubmit({
                    data: {
                        ...data,
                        removeClients: data.removeClients
                    }
                });
            }),
            testID: "save"
        },
        testID: testID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)"
                    },
                    alignItems: "center",
                    gap: 2,
                    mb: 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                        control: control,
                        name: "name",
                        label: "Company"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PrimaryButton), {
                        onClick: ()=>append({
                                firstName: "",
                                lastName: "",
                                email: ""
                            }),
                        size: "medium",
                        startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                        "data-testid": "client-modal-add-contact-button",
                        sx: {
                            height: 0.75,
                            mt: 0.5
                        },
                        children: "Add Contact"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)"
                    },
                    alignItems: "center",
                    gap: 2,
                    mb: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CountryField), {
                    control: control,
                    name: "country",
                    label: "Country",
                    onChange: (value)=>setValue("country", value)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.List), {
                children: fields.map((field, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ListItem), {
                        disablePadding: true,
                        divider: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Tooltip), {
                                title: !field.inactiveAt ? "Archive" : "Unarchive",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                                    onClick: ()=>{
                                        update(index, {
                                            ...field,
                                            inactiveAt: !field.inactiveAt ? (0, _lib.toAWSDate)(new Date()) : null
                                        });
                                    },
                                    children: !field.inactiveAt ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Archive), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Unarchive), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                sx: {
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        md: "repeat(3, 1fr)"
                                    },
                                    gap: 1,
                                    flexGrow: 1,
                                    mt: 1,
                                    mb: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                                        name: `clients.${index}.firstName`,
                                        control: control,
                                        label: "First Name",
                                        type: "firstName",
                                        disabled: !!field.inactiveAt
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                                        name: `clients.${index}.lastName`,
                                        control: control,
                                        label: "Last Name",
                                        type: "lastName",
                                        disabled: !!field.inactiveAt
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                                        name: `clients.${index}.email`,
                                        control: control,
                                        label: "Email",
                                        type: "email",
                                        disabled: !!field.inactiveAt
                                    })
                                ]
                            })
                        ]
                    }, field.id))
            })
        ]
    });
};
const mapDefaultValues = (value)=>{
    var _value_clients;
    var _value_name, _value_clients_items_map;
    return {
        id: value === null || value === void 0 ? void 0 : value.id,
        name: (_value_name = value === null || value === void 0 ? void 0 : value.name) !== null && _value_name !== void 0 ? _value_name : "",
        country: (value === null || value === void 0 ? void 0 : value.country) || (0, _api.Country).GB,
        clients: (_value_clients_items_map = value === null || value === void 0 ? void 0 : (_value_clients = value.clients) === null || _value_clients === void 0 ? void 0 : _value_clients.items.map((c)=>{
            var _c_employees;
            var _c_id, _c_firstName, _c_lastName, _c_email, _c_inactiveAt, _c_employees_items_filter;
            return {
                clientID: (_c_id = c === null || c === void 0 ? void 0 : c.id) !== null && _c_id !== void 0 ? _c_id : "",
                firstName: (_c_firstName = c === null || c === void 0 ? void 0 : c.firstName) !== null && _c_firstName !== void 0 ? _c_firstName : "",
                lastName: (_c_lastName = c === null || c === void 0 ? void 0 : c.lastName) !== null && _c_lastName !== void 0 ? _c_lastName : "",
                email: (_c_email = c === null || c === void 0 ? void 0 : c.email) !== null && _c_email !== void 0 ? _c_email : "",
                inactiveAt: (_c_inactiveAt = c === null || c === void 0 ? void 0 : c.inactiveAt) !== null && _c_inactiveAt !== void 0 ? _c_inactiveAt : null,
                employees: (_c_employees_items_filter = c === null || c === void 0 ? void 0 : (_c_employees = c.employees) === null || _c_employees === void 0 ? void 0 : _c_employees.items.filter((i)=>i !== null)) !== null && _c_employees_items_filter !== void 0 ? _c_employees_items_filter : []
            };
        })) !== null && _value_clients_items_map !== void 0 ? _value_clients_items_map : [],
        removeClients: []
    };
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","@mui/icons-material":"4DI4K","../../../components":"0272J","../../../API":"2KRIM","../../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bhuvc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientModals", ()=>useClientModals);
var _components = require("../../../components");
var _lib = require("../../../lib");
var _clientModal = require("./ClientModal");
const useClientModals = ()=>{
    const { setCompanyRecords, setCompanyInactiveDate } = (0, _lib.useCompanyLib)();
    const { setContracts } = (0, _lib.useContractsLib)();
    const { showModal: showCreateModal, hideModal: hideCreateModal } = (0, _components.useModal)({
        component: (0, _clientModal.ClientModal),
        data: {
            title: "Add Client",
            onSubmit: ({ data })=>setCompanyRecords(data, {
                    onSuccess: hideCreateModal
                }),
            testID: "add-client"
        }
    });
    const { showModal: showUpdateModal, hideModal: hideUpdateModal } = (0, _components.useModal)({
        component: (0, _clientModal.ClientModal),
        data: {
            title: "Update Client",
            onSubmit: ({ data })=>setCompanyRecords(data, {
                    onSuccess: hideUpdateModal
                }),
            testID: "update-client"
        }
    });
    const { showModal: showDeactivateModal, hideModal: hideDeactivateModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Deactivate Client",
            label: "Deactivate",
            description: "Are you sure you want to deactivate this entry?",
            onUpdate: ({ id, clients: { items } })=>{
                setCompanyInactiveDate({
                    id,
                    inactiveAt: new Date(),
                    clients: items
                }, {
                    onSettled: hideDeactivateModal
                });
            }
        }
    });
    const { showModal: showReactivateModal, hideModal: hideReactivateModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Reactivate Client",
            label: "Reactivate",
            description: "Are you sure you want to reactivate this entry?",
            onUpdate: ({ id })=>setCompanyInactiveDate({
                    id
                }, {
                    onSettled: hideReactivateModal
                })
        }
    });
    const { showModal: showContractsModal, hideModal: hideContractsModal } = (0, _components.useModal)({
        component: (0, _components.ContractsModal),
        data: {
            title: "Employees",
            onSubmit: (data)=>{
                setContracts(data, {
                    onSettled: hideContractsModal
                });
            },
            testID: "client-contracts"
        }
    });
    return {
        showCreateModal,
        showUpdateModal,
        showDeactivateModal,
        showReactivateModal,
        showContractsModal
    };
};

},{"../../../components":"0272J","../../../lib":"lWrCo","./ClientModal":"e0Ox6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b5KZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _employees = require("./Employees");
parcelHelpers.exportAll(_employees, exports);

},{"./Employees":"48EQz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"48EQz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Employees", ()=>Employees);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _reactQuery = require("@tanstack/react-query");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _lib = require("../../lib");
var _columns = require("./columns");
var _modals = require("./Modals");
const Employees = ()=>{
    var _companies_data_listCompanies, _companies_data;
    const [showActive, setShowActive] = (0, _react.useState)(true);
    const { data: companies } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listCompaniesWithEmployees"
    }));
    var _companies_data_listCompanies_items;
    const options = buildOptionsObj((_companies_data_listCompanies_items = companies === null || companies === void 0 ? void 0 : (_companies_data = companies.data) === null || _companies_data === void 0 ? void 0 : (_companies_data_listCompanies = _companies_data.listCompanies) === null || _companies_data_listCompanies === void 0 ? void 0 : _companies_data_listCompanies.items) !== null && _companies_data_listCompanies_items !== void 0 ? _companies_data_listCompanies_items : []);
    const { isMd } = (0, _hooks.useResponsive)();
    const { showCreateModal, showUpdateModal, showDeactivateModal, showReactivateModal, showContractsModal } = (0, _modals.useEmployeeModal)();
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)(({ vars, key })=>{
        const { queryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listEmployeesWithCompanies",
            vars: {
                ...vars
            },
            key
        });
        return {
            queryKey,
            queryFn: async ()=>{
                var _data_listEmployees, _data_listEmployees1;
                const { data, errors } = await queryFn();
                const nextToken = data === null || data === void 0 ? void 0 : (_data_listEmployees = data.listEmployees) === null || _data_listEmployees === void 0 ? void 0 : _data_listEmployees.nextToken;
                var _data_listEmployees_items;
                const items = ((_data_listEmployees_items = data === null || data === void 0 ? void 0 : (_data_listEmployees1 = data.listEmployees) === null || _data_listEmployees1 === void 0 ? void 0 : _data_listEmployees1.items) !== null && _data_listEmployees_items !== void 0 ? _data_listEmployees_items : []).map((e)=>{
                    var _e_clients;
                    // warning that employee is inactive since at least from today
                    const warning = (e === null || e === void 0 ? void 0 : e.inactiveAt) && new Date(e.inactiveAt) <= new Date();
                    // an employee has been inactive longer than a year
                    const isYearAgo = (e === null || e === void 0 ? void 0 : e.inactiveAt) && (0, _lib.checkIfIsBefore)(new Date(e === null || e === void 0 ? void 0 : e.inactiveAt), 1, "years");
                    // employee has active clients
                    const hasClients = !!(e === null || e === void 0 ? void 0 : (_e_clients = e.clients) === null || _e_clients === void 0 ? void 0 : _e_clients.items.length);
                    // danger if inactive client has clients or is over 1 year inactive
                    const danger = warning && (hasClients || isYearAgo);
                    return {
                        ...e,
                        warning,
                        danger
                    };
                });
                return {
                    items,
                    errors,
                    nextToken
                };
            }
        };
    });
    const hideInactiveEmployees = {
        label: !showActive ? "Show Active" : "Show Inactive",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckCircleOutline), {}),
        onClick: ()=>setShowActive(!showActive)
    };
    var _data_items;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                action: {
                    label: "Add Employee",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                    onClick: showCreateModal
                },
                altAction: hideInactiveEmployees,
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Group), {}),
                title: "Employees",
                testID: "add-employee"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)(({ row })=>showUpdateModal({
                        row
                    })),
                data: ((_data_items = data === null || data === void 0 ? void 0 : data.items) !== null && _data_items !== void 0 ? _data_items : []).filter(({ inactiveAt })=>showActive != (!!inactiveAt && new Date(inactiveAt) < new Date())),
                emptyState: {
                    title: "No Employees Found",
                    description: "Get started by adding a employees",
                    testID: "no-employees"
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                pagination: pagination,
                rowActions: [
                    {
                        label: "Clients",
                        disabled: !showActive,
                        onClick: ({ row })=>{
                            var _row_clients;
                            return (0, _lib.filterNull)((_row_clients = row.clients) === null || _row_clients === void 0 ? void 0 : _row_clients.items).then((contracts)=>{
                                showContractsModal({
                                    id: row.id,
                                    contracts,
                                    selected: getClientIds(row),
                                    options
                                });
                            });
                        },
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AddBusiness), {})
                    },
                    {
                        label: "Edit",
                        onClick: ({ row })=>showUpdateModal({
                                row
                            }),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Edit), {})
                    },
                    showActive ? {
                        label: "Deactivate",
                        onClick: ({ row })=>showDeactivateModal(row),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Archive), {})
                    } : {
                        label: "Reactivate",
                        onClick: ({ row })=>showReactivateModal(row),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Unarchive), {})
                    }
                ],
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : (0, _columns.hiddenColumnsDesktop),
                testID: "employees"
            })
        ]
    });
};
const getClientIds = (row)=>{
    var _row_clients;
    var _row_clients_items;
    return ((_row_clients_items = (_row_clients = row.clients) === null || _row_clients === void 0 ? void 0 : _row_clients.items) !== null && _row_clients_items !== void 0 ? _row_clients_items : []).map((i)=>{
        var _i_clientID;
        return (_i_clientID = i === null || i === void 0 ? void 0 : i.clientID) !== null && _i_clientID !== void 0 ? _i_clientID : "";
    });
};
const buildOptionsObj = (companies)=>companies.sort((a, b)=>{
        var _a_name, _b_name;
        return ((_a_name = a === null || a === void 0 ? void 0 : a.name) !== null && _a_name !== void 0 ? _a_name : "").toLowerCase().localeCompare(((_b_name = b === null || b === void 0 ? void 0 : b.name) !== null && _b_name !== void 0 ? _b_name : "").toLowerCase());
    }).flatMap((i)=>{
        var _i_clients;
        var _i_clients_items_filter_map;
        const clients = (_i_clients_items_filter_map = i === null || i === void 0 ? void 0 : (_i_clients = i.clients) === null || _i_clients === void 0 ? void 0 : _i_clients.items.filter((client)=>{
            var _client_employees;
            return !(client === null || client === void 0 ? void 0 : client.inactiveAt) || !!(client === null || client === void 0 ? void 0 : (_client_employees = client.employees) === null || _client_employees === void 0 ? void 0 : _client_employees.items.length);
        }).map((client)=>{
            var _client_id;
            return {
                label: `${client === null || client === void 0 ? void 0 : client.firstName} ${client === null || client === void 0 ? void 0 : client.lastName}`,
                value: (_client_id = client === null || client === void 0 ? void 0 : client.id) !== null && _client_id !== void 0 ? _client_id : "",
                header: false
            };
        })) !== null && _i_clients_items_filter_map !== void 0 ? _i_clients_items_filter_map : [];
        var _i_name, _i_name1, _i_id;
        const comps = [
            {
                label: clients.length ? (_i_name = i === null || i === void 0 ? void 0 : i.name) !== null && _i_name !== void 0 ? _i_name : "" : `${(_i_name1 = i === null || i === void 0 ? void 0 : i.name) !== null && _i_name1 !== void 0 ? _i_name1 : ""} (no active managers)`,
                value: (_i_id = i === null || i === void 0 ? void 0 : i.id) !== null && _i_id !== void 0 ? _i_id : "",
                header: true
            }
        ];
        return comps.concat(clients);
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","@tanstack/react-query":"j0XMv","../../components":"0272J","../../hooks":"9Pg07","../../lib":"lWrCo","./columns":"4KTKv","./Modals":"5Xrzb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4KTKv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsDesktop", ()=>hiddenColumnsDesktop);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("../../components");
const columns = (onClick)=>[
        {
            field: "fullName",
            headerName: "Name",
            valueGetter: ({ row })=>[
                    `${row.firstName} ${row.lastName}`
                ],
            valueFormatter: ({ value })=>value[0],
            renderCell: ({ row, formattedValue })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ActionCell), {
                    onClick: ()=>onClick({
                            row
                        }),
                    children: formattedValue
                }),
            minWidth: 200,
            flex: 1,
            sortComparator: (v1, v2)=>{
                var _v1_entries_next_value, _v2_entries_next_value;
                const v1Value = (_v1_entries_next_value = v1.entries().next().value) === null || _v1_entries_next_value === void 0 ? void 0 : _v1_entries_next_value[1];
                const v2Value = (_v2_entries_next_value = v2.entries().next().value) === null || _v2_entries_next_value === void 0 ? void 0 : _v2_entries_next_value[1];
                if (v1Value === undefined || v2Value === undefined) return 0;
                return v1Value.localeCompare(v2Value);
            }
        },
        {
            field: "email",
            headerName: "Email",
            minWidth: 200,
            flex: 1
        },
        {
            field: "companies",
            headerName: "Clients",
            valueGetter: ({ row: { clients } })=>{
                var _clients_items_flatMap;
                return (_clients_items_flatMap = clients === null || clients === void 0 ? void 0 : clients.items.flatMap((item)=>{
                    var _item_client_company_name;
                    return (_item_client_company_name = item === null || item === void 0 ? void 0 : item.client.company.name) !== null && _item_client_company_name !== void 0 ? _item_client_company_name : [];
                })) !== null && _clients_items_flatMap !== void 0 ? _clients_items_flatMap : [];
            },
            valueFormatter: ({ value })=>value.join(", "),
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ChipListCell), {
                    data: value !== null && value !== void 0 ? value : []
                }),
            minWidth: 200,
            flex: 1
        }
    ];
const hiddenColumnsDesktop = {};
const hiddenColumnsMobile = {
    ...hiddenColumnsDesktop
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Xrzb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _employeeModal = require("./EmployeeModal");
parcelHelpers.exportAll(_employeeModal, exports);
var _useEmployeeModal = require("./useEmployeeModal");
parcelHelpers.exportAll(_useEmployeeModal, exports);

},{"./EmployeeModal":"9beTv","./useEmployeeModal":"7YlTb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9beTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmployeeModal", ()=>EmployeeModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _dateHolidays = require("date-holidays");
var _dateHolidaysDefault = parcelHelpers.interopDefault(_dateHolidays);
var _components = require("../../../components");
var _api = require("../../../API");
var _lib = require("../../../lib");
var _dateControl = require("../../../components/DatePickers/DateControl");
var _dateControlDefault = parcelHelpers.interopDefault(_dateControl);
const EmployeeModal = ({ title, onSubmit, testID, params: { row }, ...rest })=>{
    var _row_clients;
    const hd = new (0, _dateHolidaysDefault.default)();
    var _row_inactiveAt;
    const initialInactiveAt = (_row_inactiveAt = row === null || row === void 0 ? void 0 : row.inactiveAt) !== null && _row_inactiveAt !== void 0 ? _row_inactiveAt : null;
    const contracts = row === null || row === void 0 ? void 0 : (_row_clients = row.clients) === null || _row_clients === void 0 ? void 0 : _row_clients.items;
    const [saving, setSaving] = (0, _react.useState)(false);
    const [isInactive, setIsInactive] = (0, _react.useState)(!!initialInactiveAt);
    var _row_country;
    const [regionOptions, setRegionOptions] = (0, _react.useState)((0, _lib.mapOptions)(hd.getStates((_row_country = row === null || row === void 0 ? void 0 : row.country) !== null && _row_country !== void 0 ? _row_country : (0, _api.Country).GB)));
    const { control, handleSubmit, setValue } = (0, _reactHookForm.useForm)({
        defaultValues: mapDefaultValues(row)
    });
    const handleInactiveChange = (e)=>{
        setIsInactive(e.target.checked);
        setValue("inactiveAt", e.target.checked ? initialInactiveAt || (0, _lib.toAWSDate)(new Date()) : null);
    };
    const handleCountryChange = (value)=>{
        setValue("country", value);
        setValue("region", "");
        setRegionOptions((0, _lib.mapOptions)(hd.getStates(value)));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                data.vacationAllowance = Number(data.vacationAllowance);
                setSaving(true);
                return onSubmit({
                    data,
                    contracts
                });
            }),
            testID: "save"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)"
                },
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                    control: control,
                    name: "firstName",
                    label: "First name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                    control: control,
                    name: "lastName",
                    label: "Last name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                    control: control,
                    name: "email",
                    label: "Email",
                    type: "email"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                    required: true,
                    control: control,
                    name: "vacationAllowance",
                    label: "Vacation Allowance",
                    type: "number",
                    inputProps: {
                        min: 0,
                        max: 365
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CountryField), {
                    control: control,
                    name: "country",
                    label: "Country",
                    onChange: (value)=>handleCountryChange(value)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SelectField), {
                    control: control,
                    name: "region",
                    label: "Region",
                    options: regionOptions,
                    optional: !regionOptions.length,
                    variant: "outlined"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                            labelPlacement: "start",
                            label: "Inactive",
                            sx: {
                                m: 0
                            },
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Switch), {
                                checked: isInactive,
                                onChange: handleInactiveChange
                            })
                        }),
                        isInactive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateControlDefault.default), {
                            name: "inactiveAt",
                            control: control,
                            label: "Leaving date",
                            onChange: (date)=>setValue("inactiveAt", (0, _lib.toAWSDate)(date))
                        })
                    ]
                })
            ]
        })
    });
};
const mapDefaultValues = (value)=>{
    var _value_firstName, _value_lastName, _value_email, _value_country, _value_region, _value_vacationAllowance, _value_inactiveAt;
    return {
        id: value === null || value === void 0 ? void 0 : value.id,
        firstName: (_value_firstName = value === null || value === void 0 ? void 0 : value.firstName) !== null && _value_firstName !== void 0 ? _value_firstName : "",
        lastName: (_value_lastName = value === null || value === void 0 ? void 0 : value.lastName) !== null && _value_lastName !== void 0 ? _value_lastName : "",
        email: (_value_email = value === null || value === void 0 ? void 0 : value.email) !== null && _value_email !== void 0 ? _value_email : "",
        country: (_value_country = value === null || value === void 0 ? void 0 : value.country) !== null && _value_country !== void 0 ? _value_country : (0, _api.Country).GB,
        region: (_value_region = value === null || value === void 0 ? void 0 : value.region) !== null && _value_region !== void 0 ? _value_region : "ENG",
        vacationAllowance: (_value_vacationAllowance = value === null || value === void 0 ? void 0 : value.vacationAllowance) !== null && _value_vacationAllowance !== void 0 ? _value_vacationAllowance : 0,
        inactiveAt: (_value_inactiveAt = value === null || value === void 0 ? void 0 : value.inactiveAt) !== null && _value_inactiveAt !== void 0 ? _value_inactiveAt : null
    };
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","date-holidays":"4EXP1","../../../components":"0272J","../../../API":"2KRIM","../../../lib":"lWrCo","../../../components/DatePickers/DateControl":"6PaYh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4EXP1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _holidaysJs.Holidays));
var _holidaysJs = require("./Holidays.js");

},{"./Holidays.js":"lNHGz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lNHGz":[function(require,module,exports) {
/**
 * @copyright 2015-present (c) commenthol
 * @license ISC
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @class
 * @param {String|Object} country - if object use `{ country: {String}, state: {String}, region: {String} }`
 * @param {String} [state] - specifies state
 * @param {String} [region] - specifies region
 * @param {Object} [opts] - options
 * @param {Array|String} opts.languages - set language(s) with ISO 639-1 shortcodes
 * @param {String} opts.timezone - set timezone
 * @param {Array} opts.types - holiday types to consider
 * @example
 * ```js
 * new Holiday('US', 'la', 'no') // is the same as
 * new Holiday('us.la.no')       // is the same as
 * new Holiday({ country: 'us', state: 'la', region: 'no'})
 * ```
 */ parcelHelpers.export(exports, "Holidays", ()=>Holidays);
var _dateHolidaysParser = require("date-holidays-parser");
var _dateHolidaysParserDefault = parcelHelpers.interopDefault(_dateHolidaysParser);
var _dataJs = require("./data.js");
class Holidays extends (0, _dateHolidaysParserDefault.default) {
    constructor(country, state, region, opts){
        super((0, _dataJs.data), country, state, region, opts);
    }
}

},{"date-holidays-parser":"eF8vc","./data.js":"2IYyI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eF8vc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _holidaysJs.Holidays));
var _holidaysJs = require("./Holidays.js");
var _holidayRuleJs = require("./HolidayRule.js");
parcelHelpers.exportAll(_holidayRuleJs, exports);

},{"./Holidays.js":"958XB","./HolidayRule.js":"4BQva","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"958XB":[function(require,module,exports) {
/**
 * @copyright 2016- (c) commenthol
 * @license ISC
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @class
 * @param {Object} data - holiday data object - see data/holidays.json
 * @param {String|Object} country - if object, use `{ country: {String}, state: {String}, region: {String} }`
 * @param {String} [state] - specifies state
 * @param {String} [region] - specifies region
 * @param {Object} [opts] - options
 * @param {Array|String} opts.languages - set language(s) with ISO 639-1 shortcodes
 * @param {String} opts.timezone - set timezone
 * @param {Array} opts.types - holiday types to consider
 * @example
 * ```js
 * new Holiday(data, 'US', 'la', 'no') // is the same as
 * new Holiday(data, 'us.la.no')       // is the same as
 * new Holiday(data, { country: 'us', state: 'la', region: 'no'})
 * ```
 */ parcelHelpers.export(exports, "Holidays", ()=>Holidays);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _utilsJs1 = require("./internal/utils.js");
var _dataJs = require("./Data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _dateFnJs = require("./DateFn.js");
var _dateFnJsDefault = parcelHelpers.interopDefault(_dateFnJs);
var _holidayRuleJs = require("./HolidayRule.js");
// priority in ascending order (low ... high)
const TYPES = [
    "observance",
    "optional",
    "school",
    "bank",
    "public"
];
class Holidays {
    /**
   * initialize holidays for a country/state/region
   * @param {String|Object} country - if object, use `{ country: {String}, state: {String}, region: {String} }`
   * @param {String} [state] - specifies state
   * @param {String} [region] - specifies region
   * @param {Object} [opts] - options
   * @param {Array|String} [opts.languages] - set language(s) with ISO 639-1 shortcodes
   * @param {String} [opts.timezone] - set timezone
   * @param {Array} [opts.types] - holiday types to consider; priority is in ascending order (low ... high)
   */ init(...args) {
        const [country, state, region, opts] = getArgs(...args);
        // reset settings
        this.__conf = null;
        this.__types = opts.types && opts.types.length ? opts.types : TYPES;
        this.holidays = {};
        this.setLanguages();
        this.__conf = (0, _dataJsDefault.default).splitName(country, state, region);
        this.__data = new (0, _dataJsDefault.default)(opts.data || this._data, this.__conf);
        if (opts.languages) this.setLanguages(opts.languages);
        else this.setLanguages(this.__data.getLanguages(this.__conf));
        const holidays = this.__data.getRules();
        if (holidays) {
            this.__timezone = opts.timezone || this.__data.getTimezones()[0];
            Object.keys(holidays).forEach((rule)=>{
                this.setHoliday(rule, holidays[rule]);
            });
            return true;
        }
    }
    /**
   * set (custom) holiday
   * @throws {TypeError}
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @param {Object|String} [opts] - holiday options (if String, then opts is used as name)
   * @param {Object} opts.name - translated holiday names e.g. `{ en: 'name', es: 'nombre', ... }`
   * @param {String} opts.type - holiday type `public|bank|school|observance`
   * @returns {Boolean} `true` if holiday could be set
   */ setHoliday(rule, opts) {
        // remove days
        if (opts === false) {
            if (this.holidays[rule]) {
                this.holidays[rule] = false;
                return true;
            }
            return false;
        }
        // assign a name to rule
        if (!opts || typeof opts === "string") {
            opts = opts || rule;
            const lang = this.getLanguages()[0];
            opts = (0, _utilsJsDefault.default).set({
                type: "public"
            }, [
                "name",
                lang
            ], opts);
        }
        // convert active properties to Date
        if (opts.active) {
            if (!Array.isArray(opts.active)) throw TypeError(".active is not of type Array: " + rule);
            opts.active = opts.active.map((a)=>{
                const from = (0, _utilsJs1.toDate)(a.from);
                const to = (0, _utilsJs1.toDate)(a.to);
                if (!(from || to)) throw TypeError(".active needs .from or .to property: " + rule);
                return {
                    from,
                    to
                };
            });
        }
        // check for supported type
        if (!this.__types.includes(opts.type)) return false;
        this.holidays[rule] = opts;
        const fn = new (0, _dateFnJsDefault.default)(rule, this.holidays);
        if (fn.ok) {
            this.holidays[rule].fn = fn;
            return true;
        } else // throw Error('could not parse rule: ' + rule) // NEXT
        console.error("could not parse rule: " + rule) // eslint-disable-line
        ;
        return false;
    }
    /**
   * get all holidays for `year` with names using preferred `language`
   * @param {String|Date} [year] - if omitted, the current year is chosen
   * @param {String} [language] - ISO 639-1 code for language
   * @returns {Holiday[]} of found holidays in given year sorted by Date:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */ getHolidays(year, language) {
        year = (0, _utilsJs1.toYear)(year);
        const langs = this.getLanguages();
        if (language) langs.unshift(language);
        const startSorter = (a, b)=>+a.start - +b.start;
        const typeIndex = (a)=>this.__types.indexOf(a.type);
        const typeSorter = (a, b)=>typeIndex(b) - typeIndex(a);
        const ruleIndex = (a)=>/substitutes|and if /.test(a.rule) ? 1 : 0;
        const ruleLength = (a)=>String(a.rule || "").length;
        const ruleSorter = (a, b)=>ruleIndex(a) - ruleIndex(b) || ruleLength(a) - ruleLength(b);
        const filterMap = {};
        const arr = Object.keys(this.holidays).reduce((arr, rule)=>{
            if (this.holidays[rule].fn) this._dateByRule(year, rule).forEach((o)=>{
                arr.push({
                    ...this._translate(o, langs),
                    rule
                });
            });
            return arr;
        }, [])// sort by date and type to filter by duplicate
        .sort((a, b)=>startSorter(a, b) || typeSorter(a, b) || ruleSorter(a, b)).filter((item)=>{
            const hash = item.name + +item.start;
            if (!filterMap[hash]) {
                filterMap[hash] = true;
                return true;
            }
            return false;
        });
        return arr;
    }
    /**
   * check whether `date` is a holiday or not
   * @param {Date|String} [date]
   * @returns {Holiday[]|false} holiday:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */ isHoliday(date) {
        date = date ? new Date(date) : new Date();
        const d = new (0, _caldateDefault.default)();
        d.fromTimezone(date, this.__timezone);
        const year = d.year;
        const rules = Object.keys(this.holidays);
        const days = [];
        for (const rule of rules){
            const hd = [].concat(this._dateByRule(year, rule));
            for (const hdrule of hd)if (hdrule && date >= hdrule.start && date < hdrule.end) days.push(this._translate(hdrule));
        }
        return days.length ? days : false;
    }
    /**
   * set or update rule
   * @param {HolidayRule|object} holidayRule
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */ setRule(holidayRule) {
        const { rule, ...opts } = holidayRule;
        return this.setHoliday(rule, opts);
    }
    /**
   * unset rule
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */ unsetRule(rule) {
        return this.setHoliday(rule, false);
    }
    /**
   * get available rules for selected country, (state, region)
   * @returns {HolidayRule[]}
   */ getRules() {
        return Object.entries(this.holidays).map(([ruleStr, obj])=>{
            return new (0, _holidayRuleJs.HolidayRule)({
                ...obj,
                rule: ruleStr
            });
        });
    }
    /**
   * get rule for selected country, (state, region)
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {HolidayRule|undefined}
   */ getRule(rule) {
        if (this.holidays[rule]) return new (0, _holidayRuleJs.HolidayRule)({
            ...this.holidays[rule],
            rule
        });
    }
    /**
   * Query for available Countries, States, Regions
   * @param {String} [country]
   * @param {String} [state]
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries, states, regions
   */ query(country, state, lang) {
        const o = (0, _dataJsDefault.default).splitName(country, state);
        if (!o || !o.country) return this.getCountries(lang);
        else if (!o.state) return this.getStates(o.country, lang);
        else return this.getRegions(o.country, o.state, lang);
    }
    /**
   * get supported countries
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries
   * ```js
   * { AD: 'Andorra',
   *   US: 'United States' }
   * ```
   */ getCountries(lang) {
        return this.__data.getCountries(lang);
    }
    /**
   * get supported states for a given country
   * @param {String} country - shortcode of country
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported states, regions
   * ```js
   * { al: 'Alabama', ...
   *   wy: 'Wyoming' }
   * ```
   */ getStates(country, lang) {
        return this.__data.getStates(country, lang);
    }
    /**
   * get supported regions for a given country, state
   * @param {String} country - shortcode of country
   * @param {String} state - shortcode of state
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported regions
   * ```js
   * { no: 'New Orleans' }
   * ```
   */ getRegions(country, state, lang) {
        return this.__data.getRegions(country, state, lang);
    }
    /**
   * sets timezone
   * @param {String} timezone - see `moment-timezone`
   * if `timezone` is `undefined`, then all dates are considered local dates
   */ setTimezone(timezone) {
        this.__timezone = timezone;
    }
    /**
   * get timezones for country, state, region
   * @returns {Array} of {String}s containing the timezones
   */ getTimezones() {
        if (this.__data) return this.__data.getTimezones();
    }
    /**
   * set language(s) for holiday names
   * @param {Array|String} language
   * @returns {Array} set languages
   */ setLanguages(language) {
        if (typeof language === "string") language = [
            language
        ];
        const tmp = {};
        this.__languages = [].concat(language, this.__conf ? this.__data.getLanguages(this.__conf) : [], "en").filter(function(l) {
            if (!l || tmp[l]) return false;
            tmp[l] = 1;
            return true;
        });
    }
    /**
   * get languages for selected country, state, region
   * @returns {Array} containing ISO 639-1 language shortcodes
   */ getLanguages() {
        return this.__languages;
    }
    /**
   * get default day off as weekday
   * @returns {String} weekday of day off
   */ getDayOff() {
        if (this.__conf) return this.__data.getDayOff();
    }
    /**
   * @private
   * @param {Number} year
   * @param {String} rule
   */ _dateByRule(year, rule) {
        const _rule = this.holidays[rule];
        const dates = _rule.fn.inYear(year).get(this.__timezone).map((date)=>{
            const odate = (0, _utilsJsDefault.default).merge({}, (0, _utilsJsDefault.default).omit(date, [
                "substitute"
            ]), (0, _utilsJsDefault.default).omit(_rule, [
                "fn",
                "enable",
                "disable",
                "substitute",
                "active"
            ]));
            if (_rule.substitute && date.substitute) odate.substitute = true;
            return odate;
        });
        return dates;
    }
    /**
   * translate holiday object `o` to a language
   * @private
   * @param {Object} o
   * @param {Array} langs - languages for translation
   * @returns {Object} translated holiday object
   */ _translate(o, langs) {
        if (o && typeof o.name === "object") {
            langs = langs || this.getLanguages();
            for (const lang of langs){
                const name = o.name[lang];
                if (name) {
                    o.name = name;
                    break;
                }
            }
            if (o.substitute) for (const lang of langs){
                const subst = this.__data.getSubstitueNames();
                const name = subst[lang];
                if (name) {
                    o.name += " (" + name + ")";
                    break;
                }
            }
        }
        return o;
    }
    constructor(data, country, state, region, opts){
        if (!data) throw new TypeError("need holiday data");
        this._data = data;
        this.init(country, state, region, opts);
    }
}
function getArgs(country, state, region, opts) {
    if (typeof region === "object") {
        opts = region;
        region = null;
    } else if (typeof state === "object") {
        opts = state;
        state = null;
    } else if (typeof country === "object" && !country.country) opts = country;
    opts = opts || {};
    return [
        country,
        state,
        region,
        opts
    ];
}

},{"caldate":"dgF7z","./utils.js":"3ags6","./internal/utils.js":"hs6zb","./Data.js":"luQVS","./DateFn.js":"kyKv6","./HolidayRule.js":"4BQva","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dgF7z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _calDateJs.CalDate));
var _calDateJs = require("./CalDate.js");

},{"./CalDate.js":"3LP0R","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3LP0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalDate", ()=>CalDate);
var _momentTimezone = require("moment-timezone");
var _momentTimezoneDefault = parcelHelpers.interopDefault(_momentTimezone);
var _utilsJs = require("./utils.js");
const PROPS = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second"
];
class CalDate {
    static toYear(year) {
        return (0, _utilsJs.toYear)(year);
    }
    /**
   * set calendar date
   * @param {Object|Date} [opts] - defaults to `1900-01-01`
   * @param {String} opts.year
   * @param {String} opts.month - January equals to 1, December to 12
   * @param {String} opts.day
   * @param {String} opts.hour
   * @param {String} opts.minute
   * @param {String} opts.second
   * @param {String} opts.duration - defaults to 24 hours
   */ set(opts) {
        opts = opts || {
            year: 1900,
            month: 1,
            day: 1
        };
        if ((0, _utilsJs.isDate)(opts)) {
            this.year = opts.getFullYear();
            this.month = opts.getMonth() + 1;
            this.day = opts.getDate();
            this.hour = opts.getHours();
            this.minute = opts.getMinutes();
            this.second = opts.getSeconds();
        } else {
            PROPS.forEach((p)=>{
                this[p] = (0, _utilsJs.toNumber)(opts[p]) || 0;
            });
            this.month = this.month || 1;
            this.day = this.day || 1;
        }
        this.duration = opts.duration || 24 // duration is in hours
        ;
        return this;
    }
    /**
   * checks if Date is equal to `calDate`
   * @param {CalDate} calDate
   * @return {Boolean} true if date matches
   */ isEqualDate(calDate) {
        let res = true;
        this.update();
        [
            "year",
            "month",
            "day"
        ].forEach((p)=>{
            res &= this[p] === calDate[p];
        });
        return !!res;
    }
    /**
   * get day of week
   * @return {Number} day of week 0=sunday, 1=monday, ...
   */ getDay() {
        return this.toDate().getDay();
    }
    /**
   * set offset per unit
   * @param {Number} number
   * @param {String} [unit='d'] - Unit in days `d`, hours `h, minutes `m`
   * @return {Object} this
   */ setOffset(number, unit) {
        if (number) {
            if (typeof number === "object") {
                unit = number.unit;
                number = number.number;
            }
            unit = unit || "d";
            number = parseFloat(number, 10);
            if (isNaN(number)) throw new Error("Number required");
            const o = {
                day: 0
            };
            if (unit === "d") {
                o.day = number | 0;
                number -= o.day;
                number *= 24;
            }
            if (unit === "d" || unit === "h") {
                o.hour = number % 24 | 0;
                number -= o.hour;
                number *= 60;
            }
            o.minute = number % 60 | 0;
            number -= o.minute;
            number *= 60;
            o.second = number % 60 | 0;
            this.day += o.day;
            this.hour += o.hour;
            this.minute += o.minute;
            this.second += o.second;
        }
        this.update();
        return this;
    }
    /**
   * set time per hour, minute or second while maintaining duration at midnight
   * @param {Number} [hour]
   * @param {Number} [minute]
   * @param {Number} [second]
   * @return {Object} this
   */ setTime(hour, minute, second) {
        hour = hour || 0;
        minute = minute || 0;
        second = second || 0;
        // the holiday usually ends at midnight - if this is not the case set different duration explicitely
        this.duration = 24 - (hour + minute / 60 + second / 3600);
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.update();
        return this;
    }
    /**
   * set duration in hours
   * @param {Number} duration in hours
   * @return {Object} this
   */ setDuration(duration) {
        this.duration = duration;
        return this;
    }
    /**
   * update internal data to real date
   * @return {Object} this
   */ update() {
        if (this.year) {
            const d = new CalDate(this.toDate());
            PROPS.forEach((p)=>{
                this[p] = d[p];
            });
        }
        return this;
    }
    /**
   * get end date of calendar date
   * @return {CalDate}
   */ toEndDate() {
        const d = new CalDate(this.toDate());
        d.minute += this.duration * 60 | 0;
        d.update();
        return d;
    }
    /**
   * move internal date to a date in `timezone`
   * @param {String} timezone - e.g. 'America/New_York'
   * @return {Date}
   */ toTimezone(timezone) {
        if (timezone) return new Date((0, _momentTimezoneDefault.default).tz(this.toString(), timezone).format());
        else return this.toDate();
    }
    /**
   * set date from a given `timezone`
   * @param {Date} dateUTC - date in UTC
   * @param {String} [timezone] - timezone of dateUTC, e.g. 'America/New_York'
   * @return {CalDate} self
   */ fromTimezone(dateUTC, timezone) {
        if (timezone) {
            const m = (0, _momentTimezoneDefault.default).tz(dateUTC, timezone);
            this.year = m.year();
            this.month = m.month() + 1;
            this.day = m.date();
            this.hour = m.hours();
            this.minute = m.minutes();
            this.second = m.seconds();
        } else this.set(dateUTC);
        return this;
    }
    /**
   * convert to Date
   * @return {Date}
   */ toDate() {
        return new Date(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, 0);
    }
    /**
   * get Date in ISO format
   */ toISOString() {
        return this.toString(true);
    }
    /**
   * get Date as String `YYYY-MM-DD HH:MM:SS`
   */ toString(iso) {
        const d = new CalDate(this.toDate());
        return (0, _utilsJs.pad0)(d.year, 4) + "-" + (0, _utilsJs.pad0)(d.month) + "-" + (0, _utilsJs.pad0)(d.day) + (iso ? "T" : " ") + (0, _utilsJs.pad0)(d.hour) + ":" + (0, _utilsJs.pad0)(d.minute) + ":" + (0, _utilsJs.pad0)(d.second) + (iso ? "Z" : "");
    }
    /**
   * constructs a new CalDate instance
   * @param {Object|Date} [opts] - See `set(opts)`
   * @example
   * const CalDate = require('caldate')
   * const caldate = new CalDate('2000-01-01 12:00:00')
   * caldate.year
   * //> 2000
   * caldate.month
   * //> 1
   */ constructor(opts){
        this.set(opts);
    }
}

},{"moment-timezone":"crvQd","./utils.js":"SqjJI","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"crvQd":[function(require,module,exports) {
var moment = module.exports = require("a3307e19e25878f5");
moment.tz.load(require("26482b68cc607116"));

},{"a3307e19e25878f5":"27E04","26482b68cc607116":"8HOMJ"}],"27E04":[function(require,module,exports) {
//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory(require("782152beb30574e4")); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(this, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.45", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

},{"782152beb30574e4":"3xZWN"}],"3xZWN":[function(require,module,exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

},{}],"8HOMJ":[function(require,module,exports) {
module.exports = JSON.parse('{"version":"2024a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}');

},{}],"SqjJI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isDate", ()=>isDate);
/**
 * pad number with `0`
 * @param {number} number
 * @param {number} [len] - length
 * @return {string} padded string
 */ parcelHelpers.export(exports, "pad0", ()=>pad0);
/**
 * convert string to number
 * @private
 * @param {String} str
 * @return {Number} converted number or undefined
 */ parcelHelpers.export(exports, "toNumber", ()=>toNumber);
/**
 * extract or set year
 * @private
 * @param {Number|Date|String} year
 * @return {Number} year
 */ parcelHelpers.export(exports, "toYear", ()=>toYear);
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
function pad0(number, len) {
    len = len || 2;
    number = Array(len).join("0") + number.toString();
    return number.substr(number.length - len, len);
}
function toNumber(str) {
    const num = parseInt(str, 10);
    if (!isNaN(num)) return num;
}
function toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (isDate(year)) year = year.getFullYear();
    else if (typeof year === "string") year = toNumber(year);
    return year;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3ags6":[function(require,module,exports) {
/**
 * lodash compatible methods
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
var _deepmerge = require("deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
const get = (obj, keys = [], def)=>{
    let o = obj;
    if (typeof keys === "string") keys = keys.split(".");
    for (const key of keys){
        if (o && o[key]) o = o[key];
        else return def;
    }
    return o;
};
const set = (obj, keys = [], value)=>{
    let key;
    let ref;
    let o = obj;
    for (key of keys){
        ref = o;
        if (toString.call(o[key]) !== "[object Object]") o[key] = {};
        o = o[key];
    }
    ref[key] = value;
    return obj;
};
const omit = (object, props = [])=>Object.keys(object).filter((p)=>!~props.indexOf(p)).reduce((o, p)=>{
        p in object && (o[p] = object[p]);
        return o;
    }, {});
const merge = (...args)=>(0, _deepmergeDefault.default).all(args);
const toNumber = (num, def)=>{
    const _num = Number(num);
    return isNaN(_num) ? def : _num;
};
exports.default = {
    get,
    set,
    omit,
    merge
};

},{"deepmerge":"fzLK7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fzLK7":[function(require,module,exports) {
"use strict";
var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function getMergeFunction(key, options) {
    if (!options.customMerge) return deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
    getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) return;
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return mergeObject(target, source, options);
}
deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
    }, {});
};
var deepmerge_1 = deepmerge;
module.exports = deepmerge_1;

},{}],"hs6zb":[function(require,module,exports) {
/**
 * {
 *   0: 'sunday', ...
 *   sunday: 0, ...
 * }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAYS", ()=>DAYS);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isNil", ()=>isNil);
/**
 * pad number with `0`
 * @param {number} number
 * @param {number} [len] - length
 * @return {string} padded string
 */ parcelHelpers.export(exports, "pad0", ()=>pad0);
/**
 * convert string to number
 * @private
 * @param {String} str
 * @return {Number} converted number or undefined
 */ parcelHelpers.export(exports, "toNumber", ()=>toNumber);
/**
 * extract or set year
 * @private
 * @param {Number|Date|String} year
 * @return {Number} year
 */ parcelHelpers.export(exports, "toYear", ()=>toYear);
/**
 * convert string to Date.
 * 2017        : year = 2017, month = 1, day = 1
 * '2017-07'   : year = 2017, month = 7, day = 1
 * '2017-07-03': year = 2017, month = 7, day = 3
 * @param {String} str
 * @param {Boolean} isUTC - return date in UTC
 * @return {Date}
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
const DAYS = function() {
    const o = {};
    "sunday|monday|tuesday|wednesday|thursday|friday|saturday".split("|").forEach((name, idx)=>{
        o[name] = idx;
        o[idx] = name;
    });
    return o;
}();
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
const isNil = (v)=>v === null || v === undefined;
function pad0(number, len) {
    len = len || 2;
    number = Array(len).join("0") + number.toString();
    return number.substr(number.length - len, len);
}
function toNumber(str) {
    const num = parseInt(str, 10);
    if (!isNaN(num)) return num;
}
function toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (year instanceof Date) year = year.getFullYear();
    else if (typeof year === "string") year = toNumber(year);
    return year;
}
function toDate(str, isUTC) {
    const m = /^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?.*$/.exec((str || "").toString());
    if (m) {
        m.shift();
        const [year, month, day] = m.map((num)=>parseInt(num || 1, 10));
        if (isUTC) return new Date(Date.UTC(year, month - 1, day));
        else return new Date(year, month - 1, day);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"luQVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handler for holiday data provided in the Json file
 * @class
 * @param {Object} [data]
 * @param {Object|String} [country]
 * @param {String} [state]
 * @param {String} [region]
 */ parcelHelpers.export(exports, "default", ()=>Data);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
class Data {
    /**
   * get all countries from the data
   * @param {String} lang - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ AT: 'Österreich', ... }`
   */ getCountries(lang) {
        const o = {};
        const countries = (0, _utilsJsDefault.default).get(this.data, "holidays", {});
        Object.keys(countries).forEach((country)=>{
            o[country] = this._name(countries, country, lang, {
                country
            });
        });
        return o;
    }
    /**
   * get all states for a given country from the data
   * @param {String|Object} country
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ b: 'Burgenland', ... }`
   */ getStates(country, lang) {
        const opts = Object.assign({}, Data.splitName(country));
        const states = (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            "states"
        ]) || (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            "regions"
        ]);
        if (states) {
            const o = {};
            Object.keys(states).forEach((state)=>{
                opts.state = state;
                o[state] = this._name(states, state, lang, opts);
            });
            return o;
        }
    }
    /**
   * get all regions for a given country/ state from the data
   * @param {String} country
   * @param {String} state
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs.
   */ getRegions(country, state, lang) {
        const opts = Object.assign({}, Data.splitName(country, state));
        const regions = (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            "states",
            opts.state,
            "regions"
        ]);
        if (regions) {
            const o = {};
            Object.keys(regions).forEach((region)=>{
                opts.region = region;
                o[region] = this._name(regions, region, lang, opts);
            });
            return o;
        }
    }
    /**
   * @private
   */ _name(obj, key, lang, opts) {
        const names = obj[key].names;
        const _lang = lang || this.getLanguages(opts)[0] || Object.keys(names)[0];
        const mlang = Data.majorLang(_lang);
        const name = obj[key].name || names[_lang] || names[mlang] || names[Object.keys(names)[0]];
        return name;
    }
    /**
   * get languages for selected country, state, region
   * @return {Array} containing ISO 639-1 language shortcodes
   */ getLanguages(opts) {
        return this._getValue("langs", opts) || [];
    }
    /**
   * get default day off as weekday
   * @return {String} weekday of day off
   */ getDayOff() {
        return this._getValue("dayoff");
    }
    /**
   * get timezones for country, state, region
   * @return {Array} of {String}s containing the timezones
   */ getTimezones() {
        return this._getValue("zones") || [];
    }
    /**
   * get list of raw holiday rules for country/ state/ region
   * @param {Object|String} [country]
   * @param {String} [state]
   * @param {String} [region]
   * @return {Object} holidayname <-> unparsed rule or date pairs
   */ getRules(country, state, region) {
        const rules = {};
        const opts = Data.splitName(country, state, region) || this.opts;
        if (!(opts && opts.country)) return rules;
        country = opts.country.toUpperCase();
        state = opts.state;
        region = opts.region;
        let tmp = (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            country
        ]);
        if (tmp) {
            this._assign(rules, tmp);
            if (state && tmp.regions && (tmp = tmp.regions[state]) || state && tmp.states && (tmp = tmp.states[state])) {
                this._assign(rules, tmp);
                if (region && tmp.regions && (tmp = tmp.regions[region])) this._assign(rules, tmp);
            }
            Object.keys(rules).forEach((key)=>{
                // assign name references with `_name`
                const _name = rules[key]._name;
                if (_name && this.data.names[_name]) {
                    delete rules[key]._name;
                    rules[key] = (0, _utilsJsDefault.default).merge({}, this.data.names[_name], rules[key]);
                }
            });
        }
        return rules;
    }
    /**
   * get name for substitute name
   * @return {Object} translations of substitute day names
   */ getSubstitueNames() {
        return (0, _utilsJsDefault.default).get(this.data, [
            "names",
            "substitutes",
            "name"
        ]);
    }
    /**
   * helper to assign objects based on properties
   * @private
   * @param {Object} out - object where obj gets assigned into
   * @param {Object} obj - input obj
   * @return {Object}
   */ _assign(out, obj) {
        let days = {};
        if (obj._days) {
            const path = [
                "holidays"
            ].concat(obj._days, "days");
            const ref = (0, _utilsJsDefault.default).get(this.data, path);
            if (!ref) throw new Error("unknown path for _days: " + path.join("."));
            days = Object.assign({}, ref);
        }
        if (days || obj.days) {
            days = Object.assign(days, obj.days);
            Object.keys(days).forEach(function(p) {
                if (days[p] === false) {
                    if (out[p]) delete out[p];
                    return;
                }
                out[p] = Object.assign({}, out[p], days[p]);
                if (!days[p].type) out[p].type = "public";
            });
        }
        return out;
    }
    /**
   * get a object from the data tree
   * @private
   * @param {String} key - key to look at
   * @return {Object} return object
   */ _getValue(key, opts = this.opts) {
        return (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            "states",
            opts.state,
            "regions",
            opts.regions,
            key
        ]) || (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            "states",
            opts.state,
            key
        ]) || (0, _utilsJsDefault.default).get(this.data, [
            "holidays",
            opts.country,
            key
        ]);
    }
    constructor(data, country, state, region){
        this.opts = Data.splitName(country, state, region) || {};
        this.data = data || {};
    }
}
// static functions
/**
 * split country state names if they appear in concatenated format e.g. 'at.b'
 * @param {String|Object} country
 * @param {String} [state]
 * @param {String} [region]
 * @return {Object}
 */ Data.splitName = function(country, state, region) {
    if (typeof country === "object" && country.country) return toUpperCase(country);
    else if (typeof country === "string") {
        const a = country.split(/[.-]/);
        const o = {
            country: a.shift(),
            state: a.shift() || state,
            region: a.shift() || region
        };
        return toUpperCase(o);
    }
};
Data.majorLang = function(lang) {
    return (lang || "").split(/-/)[0];
};
/**
 * @private
 */ function toUpperCase(obj) {
    [
        "country",
        "state",
        "region"
    ].forEach((key)=>{
        if (typeof obj[key] === "string") obj[key] = obj[key].toUpperCase();
    });
    return obj;
}

},{"./utils.js":"3ags6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kyKv6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * handles one rule
 */ parcelHelpers.export(exports, "default", ()=>DateFn);
var _parserJs = require("./Parser.js");
var _parserJsDefault = parcelHelpers.interopDefault(_parserJs);
var _ruleJs = require("./Rule.js");
var _ruleJsDefault = parcelHelpers.interopDefault(_ruleJs);
var _postRuleJs = require("./PostRule.js");
var _postRuleJsDefault = parcelHelpers.interopDefault(_postRuleJs);
var _calEventFactoryJs = require("./CalEventFactory.js");
var _calEventFactoryJsDefault = parcelHelpers.interopDefault(_calEventFactoryJs);
class DateFn {
    /**
   * @param {number} year
   * @returns {this}
   */ inYear(year) {
        if (this.cache.has(year)) {
            this.event = this.cache.get(year);
            return this;
        }
        let ruleFn // current rule
        ;
        const postProc = new (0, _postRuleJsDefault.default)(this.ruleStr, this.opts, this.holidays);
        this.rules.forEach((rule)=>{
            if (rule.fn) {
                const calEvent = new (0, _calEventFactoryJsDefault.default)(rule).inYear(year - 1) // run over neighboring dates to catch overlaps
                .inYear(year).inYear(year + 1);
                postProc.push(calEvent);
                ruleFn = new (0, _ruleJsDefault.default)(calEvent);
            } else if (ruleFn.resolve(rule)) postProc.resolve(rule, year);
        });
        const event = postProc.getEvent(year);
        this.cache.set(year, event);
        this.event = event;
        return this;
    }
    get(timezone) {
        return this.event.get(timezone);
    }
    /**
   * @param {string} rule - unparsed rule
   * @param {array} holidays - all holidays rules (required for bridge day calculations)
   */ constructor(ruleStr, holidays){
        const parser = new (0, _parserJsDefault.default)();
        this.ruleStr = ruleStr;
        this.rules = parser.parse(ruleStr);
        this.ok = !parser.error;
        this.holidays = holidays;
        this.opts = holidays ? holidays[ruleStr] : {};
        this.event = undefined;
        this.cache = new Map();
    }
}

},{"./Parser.js":"5Bmko","./Rule.js":"aMxGP","./PostRule.js":"7b8Pr","./CalEventFactory.js":"1mFJt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Bmko":[function(require,module,exports) {
/* eslint
   no-spaced-func: 0,
   no-unexpected-multiline: 0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// console.log(grammar)
parcelHelpers.export(exports, "default", ()=>Parser);
var _utilsJs = require("./internal/utils.js");
const WEEKDAYS = "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday".split("|");
const lowerCaseWeekday = (weekday)=>WEEKDAYS.includes(weekday) ? weekday.toLowerCase() : weekday;
const lowerCaseWeekdayWithoutDay = (weekday)=>weekday === "day" ? undefined : lowerCaseWeekday(weekday);
/**
 * regular expressions to parse holiday statements
 */ const grammar = function() {
    /**
   * combines different regexes
   * @private
   * @return {RegExp} combined regex
   */ function replace(regex, opt) {
        regex = regex.source;
        opt = opt || "";
        return function self(name, val) {
            if (!name) return new RegExp(regex, opt);
            val = val.source || val;
            val = val.replace(/(^|[^[])\^/g, "$1");
            regex = regex.replace(name, val);
            return self;
        };
    }
    // raw rules
    const raw = {
        _weekdays: "[Ss]unday|[Mm]onday|[Tt]uesday|[Ww]ednesday|[Tt]hursday|[Ff]riday|[Ss]aturday|day",
        _months: "January|February|March|April|May|June|July|August|September|October|November|December",
        _islamicMonths: "Muharram|Safar|Rabi al-awwal|Rabi al-thani|Jumada al-awwal|Jumada al-thani|Rajab|Shaban|Ramadan|Shawwal|Dhu al-Qidah|Dhu al-Hijjah",
        _hebrewMonths: "Nisan|Iyyar|Sivan|Tamuz|Av|Elul|Tishrei|Cheshvan|Kislev|Tevet|Shvat|AdarII|Adar",
        _jalaaliMonths: "Farvardin|Ordibehesht|Khordad|Tir|Mordad|Shahrivar|Mehr|Aban|Azar|Dey|Bahman|Esfand",
        _days: /(_weekdays)s?/,
        _direction: /(before|after|next|previous|in)/,
        _counts: /(\d+)(?:st|nd|rd|th)?/,
        _count_days: /([-+]?\d{1,2}) ?(?:days?|d)?/,
        _timezone: / in ([^\s]*|[+-]\d{2}:\d{2})/,
        _type: /(public|bank|school|observance|optional)/,
        dateMonth: /^(_months)/,
        date: /^(?:0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
        time: /^(?:T?0?(\d{1,2}):0?(\d{1,2})|T0?(\d{1,2}))/,
        duration: /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?)?/,
        julian: /^julian date/,
        easter: /^(easter|orthodox)(?: _count_days)?/,
        equinox: /^([Mm]arch|[Jj]une|[Ss]eptember|[Dd]ecember) (?:equinox|solstice)(?:_timezone)?/,
        hebrew: /^0?(\d{1,2}) (_hebrewMonths)(?: 0*(\d{1,}))?/,
        islamic: /^0?(\d{1,2}) (_islamicMonths)(?: 0*(\d{1,}))?/,
        jalaali: /^0?(\d{1,2}) (_jalaaliMonths)(?: 0*(\d{1,}))?/,
        chineseLunar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-([01])-(\d{1,2})/,
        chineseSolar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-(\d{1,2}) solarterm/,
        bengaliRevised: /^(bengali-revised) (?:-?0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
        modifier: /^(substitutes|and|if equal|then|if)\b/,
        rule_year: /^(?:in (even|odd|leap|non-leap) years|every (\d+) years? since 0*(\d{1,4}))/,
        rule_weekday: /(not )?on ((?:(?:_weekdays)(?:,\s?)?)*)/,
        rule_date_if_then: /^if ((?:(?:_weekdays)(?:,\s?)?)*) then (?:_direction _days)?/,
        rule_day_dir_date: /^(?:_counts )?_days _direction/,
        rule_bridge: /^is (?:_type )?holiday/,
        rule_if_holiday: /^if is (?:_type )?holiday then (?:_counts )?(?:_direction _days)?(?: omit ((?:(?:_weekdays)(?:,\s?)?)*))?/,
        rule_same_day: /^#\d+/,
        rule_active_from: /^since (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)(?: and|)/,
        rule_active_to: /^prior to (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)/,
        // rule_type_if_then: /if ((?:(?:_weekdays)(?:,\s?)?)*) then/,
        // rule_type_dir: /_days _direction$/,
        // rule_type_bridge: / if .* is .* holiday$/,
        space: /^\s+/
    };
    /* eslint-disable func-call-spacing */ raw._days = replace(raw._days)(/_weekdays/, raw._weekdays)();
    raw.julian = replace(raw.julian, "")(/date/, raw.date)();
    raw.easter = replace(raw.easter, "")(/_count_days/, raw._count_days)();
    raw.equinox = replace(raw.equinox, "")(/_count_days/g, raw._count_days)(/_direction/g, raw._direction)(/_timezone/g, raw._timezone)();
    raw.hebrew = replace(raw.hebrew, "")(/_hebrewMonths/, raw._hebrewMonths)();
    raw.islamic = replace(raw.islamic, "")(/_islamicMonths/, raw._islamicMonths)();
    raw.jalaali = replace(raw.jalaali, "")(/_jalaaliMonths/, raw._jalaaliMonths)();
    raw.dateMonth = replace(raw.dateMonth)(/_months/, raw._months)();
    raw.rule_weekday = replace(raw.rule_weekday, "")(/_weekdays/g, raw._weekdays)();
    raw.rule_date_if_then = replace(raw.rule_date_if_then, "")(/_direction/g, raw._direction)(/_weekdays/g, raw._weekdays)(/_days/g, raw._days)();
    raw.rule_bridge = replace(raw.rule_bridge, "")(/_type/g, raw._type)();
    raw.rule_if_holiday = replace(raw.rule_if_holiday, "")(/_type/g, raw._type)(/_counts/g, raw._counts)(/_direction/g, raw._direction)(/_days/g, raw._days)(/_weekdays/g, raw._weekdays)();
    raw.rule_day_dir_date = replace(raw.rule_day_dir_date, "")(/_counts/, raw._counts)(/_days/g, raw._days)(/_direction/g, raw._direction)();
    // raw.rule_type_if_then = replace(raw.rule_type_if_then, '')
    // (/_direction/g, raw._direction)
    // (/_days/g, raw._days)
    // ()
    let i = 1;
    raw.months = {};
    raw._months.split("|").forEach(function(m) {
        raw.months[m] = i++;
    });
    i = 1;
    raw.islamicMonths = {};
    raw._islamicMonths.split("|").forEach(function(m) {
        raw.islamicMonths[m] = i++;
    });
    i = 1;
    raw.hebrewMonths = {};
    raw._hebrewMonths.split("|").forEach(function(m) {
        raw.hebrewMonths[m] = i++;
    });
    // parser regex needs larger string before shorter AdarII and Adar pos needs correction
    raw.hebrewMonths.Adar = 12;
    raw.hebrewMonths.AdarII = 13;
    i = 1;
    raw.jalaaliMonths = {};
    raw._jalaaliMonths.split("|").forEach(function(m) {
        raw.jalaaliMonths[m] = i++;
    });
    return raw;
/* eslint-enable */ }();
class Parser {
    parse(rule) {
        this.setup = {
            str: rule,
            rule
        };
        this.error = 0;
        this.tokens = [];
        this._tokenize(this.setup);
        this._reorder();
        return this.tokens;
    }
    /**
   * reorder set of tokens for rule dateDir
   * dateDir: [dateDir2, dateDir1, fn] --> [fn, dateDir1, dateDir2]
   * dateIfThen: [fn, dateIfThen1, dateIfThen2] --> [fn, dateIfThen1, dateIfThen2]
   */ _reorder() {
        const tmp = [];
        const res = [];
        this.tokens.forEach((token)=>{
            if (token.rule === "dateDir") tmp.push(token);
            else {
                res.push(token);
                if (tmp.length) while(tmp.length)res.push(tmp.pop());
            }
            // no modifiers before a date
            if (token.fn && res[0].modifier) while(res[0].modifier)res.push(res.shift());
        });
        this.tokens = res;
    }
    _tokenize(o) {
        let last;
        while(o.str){
            for(let i = 0; i < this.fns.length; i++){
                if (this[this.fns[i]](o)) break;
            }
            this._space(o);
            if (last === o.str) {
                this.error++;
                break;
            }
            last = o.str;
        }
    }
    _shorten(o, cap0) {
        o.str = o.str.substr(cap0.length, o.str.length);
    }
    _date(o) {
        let cap;
        if (cap = grammar.date.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "gregorian",
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()),
                day: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _julian(o) {
        let cap;
        if (cap = grammar.julian.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "julian",
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()),
                day: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _easter(o) {
        let cap;
        if (cap = grammar.easter.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "easter",
                type: cap.shift(),
                offset: (0, _utilsJs.toNumber)(cap.shift()) || 0
            };
            this.tokens.push(res);
            return true;
        }
    }
    _equinox(o) {
        let cap;
        if (cap = grammar.equinox.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "equinox",
                season: cap.shift().toLowerCase(),
                timezone: cap.shift() || "GMT"
            };
            this.tokens.push(res);
            return true;
        }
    }
    _hebrew(o) {
        let cap;
        if (cap = grammar.hebrew.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "hebrew",
                day: (0, _utilsJs.toNumber)(cap.shift()),
                month: grammar.hebrewMonths[cap.shift()],
                year: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _islamic(o) {
        let cap;
        if (cap = grammar.islamic.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "islamic",
                day: (0, _utilsJs.toNumber)(cap.shift()),
                month: grammar.islamicMonths[cap.shift()],
                year: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _jalaali(o) {
        let cap;
        if (cap = grammar.jalaali.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "jalaali",
                day: (0, _utilsJs.toNumber)(cap.shift()),
                month: grammar.jalaaliMonths[cap.shift()],
                year: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _chineseSolar(o) {
        let cap;
        if (cap = grammar.chineseSolar.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: cap.shift(),
                cycle: (0, _utilsJs.toNumber)(cap.shift()),
                year: (0, _utilsJs.toNumber)(cap.shift()),
                solarterm: (0, _utilsJs.toNumber)(cap.shift()),
                day: (0, _utilsJs.toNumber)(cap.shift()),
                timezone: cap.shift()
            };
            this.tokens.push(res);
            return true;
        }
    }
    _chineseLunar(o) {
        let cap;
        if (cap = grammar.chineseLunar.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: cap.shift(),
                cycle: (0, _utilsJs.toNumber)(cap.shift()),
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()),
                leapMonth: !!(0, _utilsJs.toNumber)(cap.shift()),
                day: (0, _utilsJs.toNumber)(cap.shift()),
                timezone: cap.shift()
            };
            this.tokens.push(res);
            return true;
        }
    }
    _bengaliRevised(o) {
        let cap;
        if (cap = grammar.bengaliRevised.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: cap.shift(),
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()),
                day: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _dateMonth(o) {
        let cap;
        if (cap = grammar.dateMonth.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                fn: "gregorian",
                day: 1,
                month: grammar.months[cap.shift()],
                year: undefined
            };
            this.tokens.push(res);
            return true;
        }
    }
    _space(o) {
        let cap;
        if (cap = grammar.space.exec(o.str)) {
            this._shorten(o, cap[0]);
            return true;
        }
    }
    _ruleSameDay(o) {
        let cap;
        if (cap = grammar.rule_same_day.exec(o.str)) {
            this._shorten(o, cap[0]);
            return true;
        }
    }
    _ruleModifier(o) {
        let cap;
        if (cap = grammar.modifier.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                modifier: cap.shift()
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleTime(o) {
        let cap;
        if (cap = grammar.time.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "time",
                hour: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                minute: (0, _utilsJs.toNumber)(cap.shift()) || 0
            };
            res.hour = res.hour || (0, _utilsJs.toNumber)(cap.shift()) || 0;
            this.tokens.push(res);
            return true;
        }
    }
    _ruleDuration(o) {
        let cap;
        if (cap = grammar.duration.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const tmp = {
                days: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                hours: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                minutes: (0, _utilsJs.toNumber)(cap.shift()) || 0
            };
            const res = {
                rule: "duration",
                // duration is calculated in hours
                duration: tmp.days * 24 + tmp.hours + tmp.minutes / 60
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleDateIfThen(o) {
        let cap;
        if (cap = grammar.rule_date_if_then.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "dateIfThen",
                if: cap.shift().split(/(?:,\s?)/).map(lowerCaseWeekday),
                direction: cap.shift(),
                then: lowerCaseWeekday(cap.shift())
            };
            // create a sub-parser to only check for time, duration
            const p = new Parser([
                "_ruleTime",
                "_ruleDuration"
            ]);
            p.parse(o.str);
            if (p.tokens.length) res.rules = p.tokens;
            o.str = " " + p.setup.str // ' ' required such that the _tokenize function finalizes the loop
            ;
            this.tokens.push(res);
            return true;
        }
    }
    _ruleWeekday(o) {
        let cap;
        if (cap = grammar.rule_weekday.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "weekday",
                not: !!cap.shift(),
                if: cap.shift().split(/(?:,\s?)/).map(lowerCaseWeekday)
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleDateDir(o) {
        let cap;
        if (cap = grammar.rule_day_dir_date.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "dateDir",
                count: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                weekday: lowerCaseWeekday(cap.shift()),
                direction: cap.shift()
            };
            if (res.direction === "in") res.direction = "after";
            this.tokens.push(res);
            return true;
        }
    }
    _ruleYear(o) {
        let cap;
        if (cap = grammar.rule_year.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "year",
                cardinality: cap.shift(),
                every: (0, _utilsJs.toNumber)(cap.shift()),
                since: (0, _utilsJs.toNumber)(cap.shift())
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleIfHoliday(o) {
        let cap;
        if (cap = grammar.rule_if_holiday.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "ruleIfHoliday",
                type: cap.shift(),
                count: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                direction: cap.shift(),
                weekday: lowerCaseWeekday(cap.shift()),
                omit: (cap.shift() || "").split(/(?:,\s?)/).map(lowerCaseWeekdayWithoutDay).filter(Boolean)
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleBridge(o) {
        let cap;
        if (cap = grammar.rule_bridge.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "bridge",
                type: cap.shift()
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleActiveFrom(o) {
        let cap;
        if (cap = grammar.rule_active_from.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "activeFrom",
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                day: (0, _utilsJs.toNumber)(cap.shift()) || 1
            };
            this.tokens.push(res);
            return true;
        }
    }
    _ruleActiveTo(o) {
        let cap;
        if (cap = grammar.rule_active_to.exec(o.str)) {
            this._shorten(o, cap[0]);
            cap.shift();
            const res = {
                rule: "activeTo",
                year: (0, _utilsJs.toNumber)(cap.shift()),
                month: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                day: (0, _utilsJs.toNumber)(cap.shift()) || 1
            };
            this.tokens.push(res);
            return true;
        }
    }
    constructor(fns){
        this.fns = fns || [
            "_julian",
            "_date",
            "_easter",
            "_islamic",
            "_hebrew",
            "_jalaali",
            "_equinox",
            "_chineseSolar",
            "_chineseLunar",
            "_bengaliRevised",
            "_dateMonth",
            "_ruleDateIfThen",
            "_ruleWeekday",
            "_ruleYear",
            "_ruleDateDir",
            "_ruleIfHoliday",
            "_ruleBridge",
            "_ruleTime",
            "_ruleDuration",
            "_ruleModifier",
            "_ruleSameDay",
            "_ruleActiveFrom",
            "_ruleActiveTo"
        ];
        this.tokens = [];
    }
}

},{"./internal/utils.js":"hs6zb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aMxGP":[function(require,module,exports) {
/**
 * handle rule per event
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Rule);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _utilsJs = require("./internal/utils.js");
class Rule {
    /**
   * @param {CalEvent} calEvent
   */ setEvent(calEvent) {
        this.calEvent = calEvent;
        return this;
    }
    /**
   * @return {CalEvent}
   */ getEvent() {
        return this.calEvent;
    }
    /**
   * @param {string} modifier
   */ setModifier(modifier) {
        this.modifier = modifier;
    }
    /**
   * resolves rule to function
   * @param {object} rule
   */ resolve(rule) {
        if (rule.rule && typeof this[rule.rule] === "function") this[rule.rule](rule);
        else if (rule.modifier) this.modifier = rule.modifier;
        return this;
    }
    /**
   * @param {CalEvent} [calEvent]
   * @param {object} rule
   * {
   *   rule: "dateDir",
   *   count: 1,
   *   weekday: "tuesday",
   *   direction: "after",
   *   omit: ['sunday']
   * }
   */ dateDir(rule) {
        const omitWeekdays = [].concat(rule.omit).map((weekday)=>(0, _utilsJs.DAYS)[weekday]).filter((v)=>!(0, _utilsJs.isNil)(v));
        const isOmitDay = (offset, weekday)=>{
            let wd = offset + weekday;
            while(wd < 0)wd += 70;
            return omitWeekdays.includes(wd % 7);
        };
        this.calEvent.dates.forEach((date)=>{
            let offset;
            let count = rule.count - 1;
            const weekday = date.getDay();
            const ruleWeekday = (0, _utilsJs.DAYS)[rule.weekday];
            const isDirBefore = [
                "before",
                "previous"
            ].includes(rule.direction);
            // correct count if weekday is same for next direction
            if (rule.direction === "next" && weekday === ruleWeekday) count += 1;
            if (rule.weekday === "day") {
                let i = 0;
                if (isDirBefore) {
                    offset = (count + 1) * -1;
                    while(i++ < 7 && isOmitDay(offset, weekday))offset -= 1;
                } else {
                    offset = count + 1;
                    while(i++ < 7 && isOmitDay(offset, weekday))offset += 1;
                }
            } else if (isDirBefore) {
                if (weekday === ruleWeekday) count++;
                offset = ((7 + weekday - ruleWeekday) % 7 + count * 7) * -1;
            } else offset = (7 - weekday + ruleWeekday) % 7 + count * 7;
            if (offset) date.setOffset(offset);
        });
    }
    /**
   * @param {object} rule
   * {
   *   rule: "dateIfThen",
   *   if: ["sunday"],
   *   direction: "next",
   *   then: "sunday"
   * }
   */ dateIfThen(rule) {
        const dates = [];
        this.calEvent.dates = this.calEvent.dates.map((date)=>{
            if (date._lock) return date;
            const weekday = date.getDay();
            if (~rule.if.indexOf((0, _utilsJs.DAYS)[weekday])) {
                if (this.modifier === "and") {
                    dates.push(new (0, _caldateDefault.default)(date));
                    date.substitute = true;
                }
                date._filter = false;
                let offset = 0;
                const then = (0, _utilsJs.DAYS)[rule.then];
                if (rule.then && then !== "undefined") {
                    if (rule.direction === "previous") {
                        offset = -1 * ((7 + weekday - then) % 7);
                        if (!offset) offset = -7;
                    } else {
                        offset = (7 - weekday + then) % 7;
                        if (!offset) offset = 7;
                    }
                    date.setOffset(offset);
                    date._lock = true;
                    if (this.modifier === "substitutes") date.substitute = true;
                }
                (rule.rules || []).forEach((rule)=>{
                    switch(rule.rule){
                        case "time":
                            date.setTime(rule.hour, rule.minute);
                            break;
                        case "duration":
                            date.duration = rule.duration;
                            break;
                    }
                });
            } else if (this.modifier === "substitutes") date._filter = true;
            return date;
        });
        this.calEvent.dates = dates.concat(this.calEvent.dates);
    }
    /**
   * @param {object} rule
   * {
   *   rule: "weekday",
   *   if: ["sunday", "saturday"],
   *   not: false,
   * }
   */ weekday(rule) {
        this.calEvent.dates = this.calEvent.dates.map((date)=>{
            const weekday = date.getDay();
            let match = rule.if.indexOf((0, _utilsJs.DAYS)[weekday]) !== -1;
            if (rule.not) match = !match;
            if (match) return date;
        }).filter((date)=>date);
    }
    time(rule) {
        this.calEvent.dates.forEach((date)=>{
            date.setTime(rule.hour, rule.minute);
        });
    }
    duration(rule) {
        this.calEvent.dates.forEach((date)=>{
            date.duration = rule.duration;
        });
    }
    bridge() {
        return true // needs postprocessing
        ;
    }
    ruleIfHoliday() {
        return true // needs postprocessing
        ;
    }
    activeFrom(rule) {
        this.calEvent.setActive({
            from: new (0, _caldateDefault.default)(rule).toDate()
        });
    }
    activeTo(rule) {
        this.calEvent.setActive({
            to: new (0, _caldateDefault.default)(rule).toDate()
        });
    }
    /**
   * @param {object} rule
   * {
   *   rule: "year",
   *   cardinality: "leap",
   *   every: undefined,
   *   since: undefined
   * }
   */ year(rule) {
        this.calEvent.dates = this.calEvent.dates.map((date)=>{
            if (rule.cardinality) {
                if (rule.cardinality === "leap" && this._isLeapYear(date.year)) return date;
                else if (rule.cardinality === "non-leap" && !this._isLeapYear(date.year)) return date;
                else if (rule.cardinality === "even" && (date.year + 1) % 2) return date;
                else if (rule.cardinality === "odd" && date.year % 2) return date;
            } else if (rule.every !== undefined && rule.since !== undefined) {
                const tmp = (date.year - rule.since) % rule.every;
                if (tmp === 0) return date;
            }
        }).filter((date)=>date);
    }
    /**
   * @private
   * @return {Boolean} if true year is a leap year
   */ _isLeapYear(year) {
        if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) return true;
        return false;
    }
    /**
  * @param {CalEvent} [calEvent]
   * @param {array} [holidays]
   */ constructor(calEvent){
        this.calEvent = calEvent;
    }
}

},{"caldate":"dgF7z","./internal/utils.js":"hs6zb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7b8Pr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PostRule);
var _utilsJs = require("./utils.js");
var _ruleJs = require("./Rule.js");
var _ruleJsDefault = parcelHelpers.interopDefault(_ruleJs);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
class PostRule {
    push(calEvent) {
        this.events.push(calEvent);
    }
    /**
   * @param {number} year
   * @returns {CalEvent}
   */ getEvent(year) {
        const active = this.ruleSet && this.ruleSet.active;
        this.disable(year);
        const ev = this.events[0];
        ev.filterActive(year, active);
        return ev;
    }
    /**
   * @param {Array} rule
   * @param {number} year
   */ resolve(rule, year) {
        if (rule.rule && typeof this[rule.rule] === "function") this[rule.rule](rule, year);
    }
    /**
   * @param {Array} rule
   * @param {number} year
   */ bridge(rule, year) {
        const found = new Array(this.events.length).fill(false);
        found[0] = true;
        const type = rule.type || "public";
        // get all holidays of the given year
        for(const ruleStr in this.holidays){
            const dateFn = this.holidays[ruleStr].fn;
            if (dateFn && dateFn.ruleStr !== this.ruleStr) {
                const tmpEv = dateFn.inYear(year);
                const tmpEvType = (0, _utilsJs.get)(tmpEv, "opts.type") || "public";
                for(let i = 1; i < this.events.length; i++){
                    if (found[i]) continue;
                    const isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
                    if (isEqualDate && tmpEvType === type) found[i] = true;
                }
            }
            if (!~found.indexOf(false)) break;
        }
        if (~found.indexOf(false)) this.events[0].reset();
    }
    ruleIfHoliday(rule, year) {
        const type = rule.type || "public";
        // get all holidays of the given year
        for(const ruleStr in this.holidays){
            const dateFn = this.holidays[ruleStr].fn;
            if (dateFn && dateFn.ruleStr !== this.ruleStr) {
                const tmpEv = dateFn.inYear(year);
                const tmpEvType = (0, _utilsJs.get)(tmpEv, "opts.type") || "public";
                for(let i = 0; i < this.events.length; i++){
                    const isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
                    if (isEqualDate && tmpEvType === type) {
                        new (0, _ruleJsDefault.default)(this.events[i]).resolve({
                            ...rule,
                            rule: "dateDir"
                        });
                        return;
                    }
                }
            }
        }
    }
    /**
   * @param {number} year
   */ disable(year) {
        const { disable, enable } = this.opts || {};
        if (!disable || !disable.length) return;
        const ev = this.events[0];
        // check if exact event was disabled or moved
        let tmpEv = _findEventInYear(year, disable);
        if (tmpEv) {
            if (tmpEv.isEqualDate(ev)) {
                ev.reset();
                tmpEv = _findEventInYear(year, enable);
                if (tmpEv) this.events[0] = tmpEv;
            }
            return;
        }
        // simply check if the event can be disabled for year-(month)
        const [_year, _month] = _findDisabled(year, disable);
        ev.filterDisabled(_year, _month);
    }
    /**
   * @param {String} ruleStr
   * @param {Object} opts
   * @param {Array} [holidays]
   */ constructor(ruleStr, opts, holidays){
        this.opts = opts;
        this.ruleStr = ruleStr;
        this.ruleSet = holidays && holidays[ruleStr];
        this.holidays = holidays;
        this.events = [];
    }
}
const isoDate = (isoDateStr)=>String(isoDateStr).split("-").map((v)=>(0, _utilsJs.toNumber)(v));
function _findEventInYear(_year, arr = []) {
    for (const item of arr){
        const [year, month, day] = isoDate(item);
        if (year === _year && month && day) return new (0, _calEventJsDefault.default)({
            year,
            month,
            day
        }).inYear(year);
    }
}
function _findDisabled(_year, arr = []) {
    for (const isoDateStr of arr){
        const [year, month] = isoDate(isoDateStr);
        if (_year === year) return [
            year,
            month
        ];
    }
    return [];
}

},{"./utils.js":"3ags6","./Rule.js":"aMxGP","./CalEvent.js":"dCRj3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dCRj3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CalEvent);
var _utilsJs = require("./internal/utils.js");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
class CalEvent {
    /**
   * @param {number} year
   * @returns {this}
   */ inYear(year) {
        const d = new (0, _caldateDefault.default)(this.opts).setOffset(this.offset);
        if (!(d.year && d.year !== year)) {
            d.year = year;
            this.dates.push(d);
        }
        return this;
    }
    reset() {
        this.dates = [];
    }
    /**
   * @param {CalEvent} calEvent
   * @returns {boolean}
   */ isEqualDate(calEvent) {
        let res = false;
        for (const thisDate of this.dates)for (const date of calEvent.dates)res |= thisDate.isEqualDate(date);
        return !!res;
    }
    /**
   * Filter out disabled dates
   * @param {number} year
   * @param {number} month
   * @returns {this}
   */ filterDisabled(year, month) {
        if (!year) return this;
        this.dates = this.dates.filter((date)=>{
            const disable = month ? date.year === year && date.month === month : date.year === year;
            return !disable;
        });
        return this;
    }
    /**
   * @param {number} year - year to filter
   * @param {object[]} active - definition of active ranges `{from: {Date}, [to]: {Date}}`
   * @return {this} for chaining
   */ filterActive(year, active = this.active) {
        this.dates = this.dates.filter((date)=>{
            if (!date._filter && isActive(date, year, active)) return date;
        });
        return this;
    }
    /**
   * @param {object} active
   * @param {Date} [active.from ]
   * @param {Date} [active.to]
   * @returns
   */ setActive(active) {
        const { from, to } = active;
        let pushIt = true;
        this.active = this.active || [];
        if (to && !from) {
            const last = this.active[this.active.length - 1];
            if (last && last.from && !last.to) {
                last.to = to;
                pushIt = false;
            }
        }
        if (pushIt) this.active.push(active);
        return this;
    }
    /**
   * @param {CalEvent} calEvent
   */ push(calEvent) {
        if (calEvent && Array.isArray(calEvent.dates)) this.dates = this.dates.concat(calEvent.dates);
    }
    /**
   * @param {string} timezone
   * @returns
   */ get(timezone) {
        const arr = this.dates.map((date)=>{
            const cdate = new (0, _caldateDefault.default)(date);
            const o = {
                date: cdate.toString(),
                start: cdate.toTimezone(timezone),
                end: cdate.toEndDate().toTimezone(timezone)
            };
            this._addSubstitute(date, o);
            return o;
        });
        return arr;
    }
    _addSubstitute(date, obj) {
        if (this.substitute || date.substitute) obj.substitute = true;
    }
    /**
   * @param {object|Date} opts
   * @param {string} opts.fn function type
   * @param {number} [opts.day]
   * @param {number} [opts.month]
   * @param {number} [opts.year]
   * @param {number} [opts.offset]
   * @param {boolean} [opts.substitute]
   */ constructor(opts){
        opts = opts || {};
        this.substitute = opts.substitute;
        this.opts = opts;
        this.offset = opts.offset;
        this.dates = [];
        this.active = undefined // active props from prior to rule
        ;
        if ((0, _utilsJs.isDate)(opts)) this.opts = new (0, _caldateDefault.default)(opts);
    }
}
function isActive(date, year, active) {
    if (!active) return date.year === year;
    const _date = date.toDate();
    for (const a of active){
        const { from, to } = a;
        if (date.year === year && (from && to && from <= _date && to > _date || from && !to && from <= _date || !from && to && to > _date)) return true;
    }
}

},{"./internal/utils.js":"hs6zb","caldate":"dgF7z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1mFJt":[function(require,module,exports) {
/* eslint spaced-comment:0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// #endif
parcelHelpers.export(exports, "default", ()=>CalEventFactory);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _easterJs = require("./Easter.js");
var _easterJsDefault = parcelHelpers.interopDefault(_easterJs);
// --- pre-processor instructions for prepin ---
// #ifndef nojulian
var _julianJs = require("./Julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
// #endif
// #ifndef nohebrew
var _hebrewJs = require("./Hebrew.js");
var _hebrewJsDefault = parcelHelpers.interopDefault(_hebrewJs);
// #endif
// #ifndef noislamic
var _hijriJs = require("./Hijri.js");
var _hijriJsDefault = parcelHelpers.interopDefault(_hijriJs);
// #endif
// #ifndef nojalaali
var _jalaaliJs = require("./Jalaali.js");
var _jalaaliJsDefault = parcelHelpers.interopDefault(_jalaaliJs);
// #endif
// #ifndef noequinox
var _equinoxJs = require("./Equinox.js");
var _equinoxJsDefault = parcelHelpers.interopDefault(_equinoxJs);
// #endif
// #ifndef nochinese
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
// #endif
// #ifndef nobengali
var _bengaliRevisedJs = require("./BengaliRevised.js");
var _bengaliRevisedJsDefault = parcelHelpers.interopDefault(_bengaliRevisedJs);
class CalEventFactory {
    constructor(opts){
        switch(opts.fn){
            case "easter":
                return new (0, _easterJsDefault.default)(opts);
            // #ifndef nojulian
            case "julian":
                return new (0, _julianJsDefault.default)(opts);
            // #endif
            // #ifndef nohebrew
            case "hebrew":
                return new (0, _hebrewJsDefault.default)(opts);
            // #endif
            // #ifndef noislamic
            case "islamic":
                return new (0, _hijriJsDefault.default)(opts);
            // #endif
            // #ifndef nojalaali
            case "jalaali":
                return new (0, _jalaaliJsDefault.default)(opts);
            // #endif
            // #ifndef noequinox
            case "equinox":
                return new (0, _equinoxJsDefault.default)(opts);
            // #endif
            // #ifndef nochinese
            case "chinese":
            case "korean":
            case "vietnamese":
                return new (0, _chineseJsDefault.default)(opts);
            // #endif
            // #ifndef nobengali
            case "bengali-revised":
                return new (0, _bengaliRevisedJsDefault.default)(opts);
            // #endif
            default:
                return new (0, _calEventJsDefault.default)(opts);
        }
    }
}

},{"./CalEvent.js":"dCRj3","./Easter.js":"aStNf","./Julian.js":"b9nbV","./Hebrew.js":"ceOFO","./Hijri.js":"9SqVQ","./Jalaali.js":"9OXlM","./Equinox.js":"gEKQD","./Chinese.js":"6nNM5","./BengaliRevised.js":"fWJGQ","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aStNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Easter);
var _dateEaster = require("date-easter");
var _dateEasterDefault = parcelHelpers.interopDefault(_dateEaster);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
class Easter extends (0, _calEventJsDefault.default) {
    inYear(year) {
        const d = new (0, _caldateDefault.default)(this._fn(year)).setOffset(this.offset);
        this.dates.push(d);
        return this;
    }
    /**
   * @param {object} [opts]
   * @param {string} opts.type - type of eastern (easter|orthodox)
   * @param {number|string} opts.offset - offset in days
   */ constructor(opts){
        opts = opts || {};
        super(opts);
        this._fn = (0, _dateEasterDefault.default).easter;
        if (opts.type === "orthodox") this._fn = (0, _dateEasterDefault.default).orthodoxEaster;
    }
}

},{"date-easter":"7kZ96","caldate":"dgF7z","./CalEvent.js":"dCRj3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7kZ96":[function(require,module,exports) {
/**
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EasterDate", ()=>EasterDate);
/**
 * Calculate easter sunday in the gregorian calendar
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "gregorianEaster", ()=>gregorianEaster);
parcelHelpers.export(exports, "easter", ()=>easter);
/**
 * Calculate easter sunday in the julian calendar
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "julianEaster", ()=>julianEaster);
/**
 * Orthodox Easter in gregorian calender
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "orthodoxEaster", ()=>orthodoxEaster);
function _toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (year instanceof Date) year = year.getFullYear();
    else if (typeof year === "string") year = parseInt(year, 10);
    return year;
}
function pre(num, l) {
    l = l || 2;
    const s = "0000" + num;
    return s.substr(s.length - l, l);
}
class EasterDate {
    toString() {
        return [
            pre(this.year, 4),
            pre(this.month),
            pre(this.day)
        ].join("-");
    }
    constructor(year, month, day){
        this.year = year;
        this.month = month;
        this.day = day;
    }
}
/**
 * from https://de.wikipedia.org/wiki/Gau%C3%9Fsche_Osterformel
 * ergänzte Formel
 */ function _easter(year, julian, gregorian) {
    year = _toYear(year);
    const k = Math.floor(year / 100);
    let m = 15 + Math.floor((3 * k + 3) / 4) - Math.floor((8 * k + 13) / 25);
    let s = 2 - Math.floor((3 * k + 3) / 4);
    if (julian) {
        m = 15;
        s = 0;
    }
    const a = year % 19;
    const d = (19 * a + m) % 30;
    const r = Math.floor((d + a / 11) / 29);
    const og = 21 + d - r;
    const sz = 7 - Math.floor(year + year / 4 + s) % 7;
    const oe = 7 - (og - sz) % 7;
    let os = og + oe;
    if (gregorian) os = os + Math.floor(year / 100) - Math.floor(year / 400) - 2;
    //                        1   2   3   4   5   6   7   8
    const daysPerMonth = [
        0,
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31
    ];
    let day = os;
    let month;
    for(month = 3; month < 8; month++){
        if (day <= daysPerMonth[month]) break;
        day -= daysPerMonth[month];
    }
    return new EasterDate(year, month, day);
}
function gregorianEaster(year) {
    return _easter(year);
}
const easter = gregorianEaster;
function julianEaster(year) {
    return _easter(year, true);
}
function orthodoxEaster(year) {
    return _easter(year, true, true);
}
exports.default = {
    easter,
    gregorianEaster,
    julianEaster,
    orthodoxEaster
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"b9nbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Julian);
var _astronomia = require("astronomia");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
class Julian extends (0, _calEventJsDefault.default) {
    inYear(year) {
        if (this.opts.year && this.opts.year !== year) return this;
        const cal = new (0, _astronomia.julian).CalendarJulian(year, this.opts.month, this.opts.day).toGregorian();
        const d = new (0, _caldateDefault.default)(cal).setOffset(this.offset);
        this.dates.push(d);
        return this;
    }
}

},{"astronomia":"1WNVu","caldate":"dgF7z","./CalEvent.js":"dCRj3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1WNVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "angle", ()=>(0, _angleJsDefault.default));
parcelHelpers.export(exports, "apparent", ()=>(0, _apparentJsDefault.default));
parcelHelpers.export(exports, "apsis", ()=>(0, _apsisJsDefault.default));
parcelHelpers.export(exports, "base", ()=>(0, _baseJsDefault.default));
parcelHelpers.export(exports, "binary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "coord", ()=>(0, _coordJsDefault.default));
parcelHelpers.export(exports, "conjunction", ()=>(0, _conjunctionJsDefault.default));
parcelHelpers.export(exports, "circle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "deltat", ()=>(0, _deltatJsDefault.default));
parcelHelpers.export(exports, "elementequinox", ()=>(0, _elementequinoxJsDefault.default));
parcelHelpers.export(exports, "elliptic", ()=>(0, _ellipticJsDefault.default));
parcelHelpers.export(exports, "eclipse", ()=>(0, _eclipseJsDefault.default));
parcelHelpers.export(exports, "elp", ()=>(0, _elpJsDefault.default));
parcelHelpers.export(exports, "eqtime", ()=>(0, _eqtimeJsDefault.default));
parcelHelpers.export(exports, "fit", ()=>(0, _fitJsDefault.default));
parcelHelpers.export(exports, "globe", ()=>(0, _globeJsDefault.default));
parcelHelpers.export(exports, "illum", ()=>(0, _illumJsDefault.default));
parcelHelpers.export(exports, "interpolation", ()=>(0, _interpolationJsDefault.default));
parcelHelpers.export(exports, "iterate", ()=>(0, _iterateJsDefault.default));
parcelHelpers.export(exports, "jm", ()=>(0, _jmJsDefault.default));
parcelHelpers.export(exports, "julian", ()=>(0, _julianJsDefault.default));
parcelHelpers.export(exports, "jupiter", ()=>(0, _jupiterJsDefault.default));
parcelHelpers.export(exports, "jupitermoons", ()=>(0, _jupitermoonsJsDefault.default));
parcelHelpers.export(exports, "kepler", ()=>(0, _keplerJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "nearparabolic", ()=>(0, _nearparabolicJsDefault.default));
parcelHelpers.export(exports, "node", ()=>(0, _nodeJsDefault.default));
parcelHelpers.export(exports, "nutation", ()=>(0, _nutationJsDefault.default));
parcelHelpers.export(exports, "mars", ()=>(0, _marsJsDefault.default));
parcelHelpers.export(exports, "moon", ()=>(0, _moonJsDefault.default));
parcelHelpers.export(exports, "moonillum", ()=>(0, _moonillumJsDefault.default));
parcelHelpers.export(exports, "moonmaxdec", ()=>(0, _moonmaxdecJsDefault.default));
parcelHelpers.export(exports, "moonnode", ()=>(0, _moonnodeJsDefault.default));
parcelHelpers.export(exports, "moonphase", ()=>(0, _moonphaseJsDefault.default));
parcelHelpers.export(exports, "moonposition", ()=>(0, _moonpositionJsDefault.default));
parcelHelpers.export(exports, "parabolic", ()=>(0, _parabolicJsDefault.default));
parcelHelpers.export(exports, "parallax", ()=>(0, _parallaxJsDefault.default));
parcelHelpers.export(exports, "parallactic", ()=>(0, _parallacticJsDefault.default));
parcelHelpers.export(exports, "perihelion", ()=>(0, _perihelionJsDefault.default));
parcelHelpers.export(exports, "planetary", ()=>(0, _planetaryJsDefault.default));
parcelHelpers.export(exports, "planetposition", ()=>(0, _planetpositionJsDefault.default));
parcelHelpers.export(exports, "planetelements", ()=>(0, _planetelementsJsDefault.default));
parcelHelpers.export(exports, "pluto", ()=>(0, _plutoJsDefault.default));
parcelHelpers.export(exports, "precess", ()=>(0, _precessJsDefault.default));
parcelHelpers.export(exports, "refraction", ()=>(0, _refractionJsDefault.default));
parcelHelpers.export(exports, "rise", ()=>(0, _riseJsDefault.default));
parcelHelpers.export(exports, "saturnmoons", ()=>(0, _saturnmoonsJsDefault.default));
parcelHelpers.export(exports, "saturnring", ()=>(0, _saturnringJsDefault.default));
parcelHelpers.export(exports, "sexagesimal", ()=>(0, _sexagesimalJsDefault.default));
parcelHelpers.export(exports, "sidereal", ()=>(0, _siderealJsDefault.default));
parcelHelpers.export(exports, "solar", ()=>(0, _solarJsDefault.default));
parcelHelpers.export(exports, "solardisk", ()=>(0, _solardiskJsDefault.default));
parcelHelpers.export(exports, "solarxyz", ()=>(0, _solarxyzJsDefault.default));
parcelHelpers.export(exports, "solstice", ()=>(0, _solsticeJsDefault.default));
parcelHelpers.export(exports, "stellar", ()=>(0, _stellarJsDefault.default));
parcelHelpers.export(exports, "sundial", ()=>(0, _sundialJsDefault.default));
parcelHelpers.export(exports, "sunrise", ()=>(0, _sunriseJsDefault.default));
var _angleJs = require("./angle.js");
var _angleJsDefault = parcelHelpers.interopDefault(_angleJs);
var _apparentJs = require("./apparent.js");
var _apparentJsDefault = parcelHelpers.interopDefault(_apparentJs);
var _apsisJs = require("./apsis.js");
var _apsisJsDefault = parcelHelpers.interopDefault(_apsisJs);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _binaryJs = require("./binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _conjunctionJs = require("./conjunction.js");
var _conjunctionJsDefault = parcelHelpers.interopDefault(_conjunctionJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
var _elementequinoxJs = require("./elementequinox.js");
var _elementequinoxJsDefault = parcelHelpers.interopDefault(_elementequinoxJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
var _eclipseJs = require("./eclipse.js");
var _eclipseJsDefault = parcelHelpers.interopDefault(_eclipseJs);
var _elpJs = require("./elp.js");
var _elpJsDefault = parcelHelpers.interopDefault(_elpJs);
var _eqtimeJs = require("./eqtime.js");
var _eqtimeJsDefault = parcelHelpers.interopDefault(_eqtimeJs);
var _fitJs = require("./fit.js");
var _fitJsDefault = parcelHelpers.interopDefault(_fitJs);
var _globeJs = require("./globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _illumJs = require("./illum.js");
var _illumJsDefault = parcelHelpers.interopDefault(_illumJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _iterateJs = require("./iterate.js");
var _iterateJsDefault = parcelHelpers.interopDefault(_iterateJs);
var _jmJs = require("./jm.js");
var _jmJsDefault = parcelHelpers.interopDefault(_jmJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _jupiterJs = require("./jupiter.js");
var _jupiterJsDefault = parcelHelpers.interopDefault(_jupiterJs);
var _jupitermoonsJs = require("./jupitermoons.js");
var _jupitermoonsJsDefault = parcelHelpers.interopDefault(_jupitermoonsJs);
var _keplerJs = require("./kepler.js");
var _keplerJsDefault = parcelHelpers.interopDefault(_keplerJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _nearparabolicJs = require("./nearparabolic.js");
var _nearparabolicJsDefault = parcelHelpers.interopDefault(_nearparabolicJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _marsJs = require("./mars.js");
var _marsJsDefault = parcelHelpers.interopDefault(_marsJs);
var _moonJs = require("./moon.js");
var _moonJsDefault = parcelHelpers.interopDefault(_moonJs);
var _moonillumJs = require("./moonillum.js");
var _moonillumJsDefault = parcelHelpers.interopDefault(_moonillumJs);
var _moonmaxdecJs = require("./moonmaxdec.js");
var _moonmaxdecJsDefault = parcelHelpers.interopDefault(_moonmaxdecJs);
var _moonnodeJs = require("./moonnode.js");
var _moonnodeJsDefault = parcelHelpers.interopDefault(_moonnodeJs);
var _moonphaseJs = require("./moonphase.js");
var _moonphaseJsDefault = parcelHelpers.interopDefault(_moonphaseJs);
var _moonpositionJs = require("./moonposition.js");
var _moonpositionJsDefault = parcelHelpers.interopDefault(_moonpositionJs);
var _parabolicJs = require("./parabolic.js");
var _parabolicJsDefault = parcelHelpers.interopDefault(_parabolicJs);
var _parallaxJs = require("./parallax.js");
var _parallaxJsDefault = parcelHelpers.interopDefault(_parallaxJs);
var _parallacticJs = require("./parallactic.js");
var _parallacticJsDefault = parcelHelpers.interopDefault(_parallacticJs);
var _perihelionJs = require("./perihelion.js");
var _perihelionJsDefault = parcelHelpers.interopDefault(_perihelionJs);
var _planetaryJs = require("./planetary.js");
var _planetaryJsDefault = parcelHelpers.interopDefault(_planetaryJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _planetelementsJs = require("./planetelements.js");
var _planetelementsJsDefault = parcelHelpers.interopDefault(_planetelementsJs);
var _plutoJs = require("./pluto.js");
var _plutoJsDefault = parcelHelpers.interopDefault(_plutoJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _refractionJs = require("./refraction.js");
var _refractionJsDefault = parcelHelpers.interopDefault(_refractionJs);
var _riseJs = require("./rise.js");
var _riseJsDefault = parcelHelpers.interopDefault(_riseJs);
var _saturnmoonsJs = require("./saturnmoons.js");
var _saturnmoonsJsDefault = parcelHelpers.interopDefault(_saturnmoonsJs);
var _saturnringJs = require("./saturnring.js");
var _saturnringJsDefault = parcelHelpers.interopDefault(_saturnringJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _solardiskJs = require("./solardisk.js");
var _solardiskJsDefault = parcelHelpers.interopDefault(_solardiskJs);
var _solarxyzJs = require("./solarxyz.js");
var _solarxyzJsDefault = parcelHelpers.interopDefault(_solarxyzJs);
var _solsticeJs = require("./solstice.js");
var _solsticeJsDefault = parcelHelpers.interopDefault(_solsticeJs);
var _stellarJs = require("./stellar.js");
var _stellarJsDefault = parcelHelpers.interopDefault(_stellarJs);
var _sundialJs = require("./sundial.js");
var _sundialJsDefault = parcelHelpers.interopDefault(_sundialJs);
var _sunriseJs = require("./sunrise.js");
var _sunriseJsDefault = parcelHelpers.interopDefault(_sunriseJs);

},{"./angle.js":"k0eXD","./apparent.js":"4gNB9","./apsis.js":"1L1AY","./base.js":"cO06o","./binary.js":"egg9M","./coord.js":"1Ze6D","./conjunction.js":"5f3XR","./circle.js":"gchHS","./deltat.js":"2uWsU","./elementequinox.js":"bX2E4","./elliptic.js":"8qxM3","./eclipse.js":"l9bq7","./elp.js":"hXxwv","./eqtime.js":"8YjFi","./fit.js":"38f5t","./globe.js":"argxH","./illum.js":"9L14K","./interpolation.js":"isMMq","./iterate.js":"2zKvc","./jm.js":"7bTBa","./julian.js":"da2eV","./jupiter.js":"ddsvx","./jupitermoons.js":"60tNj","./kepler.js":"jVSJo","./line.js":"l9f2i","./nearparabolic.js":"hFm3Y","./node.js":"1yqmf","./nutation.js":"fWRWg","./mars.js":"6wSU0","./moon.js":"2ukWd","./moonillum.js":"45UAB","./moonmaxdec.js":"edIW8","./moonnode.js":"2W71j","./moonphase.js":"cRr38","./moonposition.js":"9Akcu","./parabolic.js":"jzdYv","./parallax.js":"28Zsn","./parallactic.js":"kj1pf","./perihelion.js":"22E7v","./planetary.js":"fQi8H","./planetposition.js":"cfC43","./planetelements.js":"3WPEg","./pluto.js":"aZzbH","./precess.js":"tAZZk","./refraction.js":"6Zuh5","./rise.js":"2pO5I","./saturnmoons.js":"1wLG4","./saturnring.js":"5ANWn","./sexagesimal.js":"1aKkU","./sidereal.js":"bOjdk","./solar.js":"aC6LU","./solardisk.js":"5dvpO","./solarxyz.js":"51rgn","./solstice.js":"iNko2","./stellar.js":"2XUNj","./sundial.js":"dq533","./sunrise.js":"6Q7Wz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k0eXD":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module angle
 */ /**
 * Angle: Chapter 17: Angular Separation.
 *
 * Functions in this package are useful for Ecliptic, Equatorial, or any
 * similar coordinate frame.  To avoid suggestion of a particular frame,
 * function parameters are specified simply as "r1, d1" to correspond to a
 * right ascenscion, declination pair or to a longitude, latitude pair.
 *
 * In function Sep, Meeus recommends 10 arc min as a threshold.  This
 * value is in package base as base.SmallAngle because it has general utility.
 *
 * All angles are in radians.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * `sep` returns the angular separation between two celestial bodies.
 *
 * The algorithm is numerically naïve, and while patched up a bit for
 * small separations, remains unstable for separations near π.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sep", ()=>sep);
/**
 * `minSep` returns the minimum separation between two moving objects.
 *
 * The motion is represented as an ephemeris of three rows, equally spaced
 * in time.  Jd1, jd3 are julian day times of the first and last rows.
 * R1, d1, r2, d2 are coordinates at the three times.  They must each be
 * slices of length 3.0
 *
 * Result is obtained by computing separation at each of the three times
 * and interpolating a minimum.  This may be invalid for sufficiently close
 * approaches.
 *
 * @throws Error
 * @param {Number} jd1 - Julian day - time at cs1[0], cs2[0]
 * @param {Number} jd3 - Julian day - time at cs1[2], cs2[2]
 * @param {Coord[]} cs1 - 3 coordinates of moving object 1
 * @param {Coord[]} cs2 - 3 coordinates of moving object 2
 * @param {function} [fnSep] - alternative `sep` function e.g. `angle.sepPauwels`, `angle.sepHav`
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "minSep", ()=>minSep);
/**
 * `minSepRect` returns the minimum separation between two moving objects.
 *
 * Like `minSep`, but using a method of rectangular coordinates that gives
 * accurate results even for close approaches.
 *
 * @throws Error
 * @param {Number} jd1 - Julian day - time at cs1[0], cs2[0]
 * @param {Number} jd3 - Julian day - time at cs1[2], cs2[2]
 * @param {Coord[]} cs1 - 3 coordinates of moving object 1
 * @param {Coord[]} cs2 - 3 coordinates of moving object 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "minSepRect", ()=>minSepRect);
/**
 * haversine function (17.5) p. 115
 */ parcelHelpers.export(exports, "hav", ()=>hav);
/**
 * `sepHav` returns the angular separation between two celestial bodies.
 *
 * The algorithm uses the haversine function and is superior to the naïve
 * algorithm of the Sep function.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sepHav", ()=>sepHav);
/**
 * Same as `minSep` but uses function `sepHav` to return the minimum separation
 * between two moving objects.
 */ parcelHelpers.export(exports, "minSepHav", ()=>minSepHav);
/**
 * `sepPauwels` returns the angular separation between two celestial bodies.
 *
 * The algorithm is a numerically stable form of that used in `sep`.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sepPauwels", ()=>sepPauwels);
/**
 * Same as `minSep` but uses function `sepPauwels` to return the minimum
 * separation between two moving objects.
 */ parcelHelpers.export(exports, "minSepPauwels", ()=>minSepPauwels);
/**
 * RelativePosition returns the position angle of one body with respect to
 * another.
 *
 * The position angle result `p` is measured counter-clockwise from North.
 * If negative then `p` is in the range of 90° ... 270°
 *
 * ````
 *                  North
 *                    |
 *             (p)  ..|
 *                 .  |
 *                V   |
 *    c1 x------------x c2
 *                    |
 * ````
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} position angle (p)
 */ parcelHelpers.export(exports, "relativePosition", ()=>relativePosition);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
const { abs, acos, asin, atan2, cos, hypot, sin, sqrt, tan } = Math;
function sep(c1, c2) {
    const [sind1, cosd1] = (0, _baseJsDefault.default).sincos(c1.dec);
    const [sind2, cosd2] = (0, _baseJsDefault.default).sincos(c2.dec);
    const cd = sind1 * sind2 + cosd1 * cosd2 * cos(c1.ra - c2.ra) // (17.1) p. 109
    ;
    if (cd < (0, _baseJsDefault.default).CosSmallAngle) return acos(cd);
    else {
        const cosd = cos((c2.dec + c1.dec) / 2) // average dec of two bodies
        ;
        return hypot((c2.ra - c1.ra) * cosd, c2.dec - c1.dec) // (17.2) p. 109
        ;
    }
}
function minSep(jd1, jd3, cs1, cs2, fnSep) {
    fnSep = fnSep || sep;
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, _interpolationJsDefault.default).errorNot3;
    const y = new Array(3);
    cs1.forEach((c, x)=>{
        y[x] = sep(cs1[x], cs2[x]);
    });
    const d3 = new (0, _interpolationJsDefault.default).Len3(jd1, jd3, y);
    const dMin = d3.extremum()[1];
    return dMin;
}
function minSepRect(jd1, jd3, cs1, cs2) {
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, _interpolationJsDefault.default).ErrorNot3;
    const uv = function(c1, c2) {
        const [sind1, cosd1] = (0, _baseJsDefault.default).sincos(c1.dec);
        const \u0394r = c2.ra - c1.ra;
        const tan\u0394r = tan(\u0394r);
        const tanh\u0394r = tan(\u0394r / 2);
        const K = 1 / (1 + sind1 * sind1 * tan\u0394r * tanh\u0394r);
        const sin\u0394d = sin(c2.dec - c1.dec);
        const u = -K * (1 - sind1 / cosd1 * sin\u0394d) * cosd1 * tan\u0394r;
        const v = K * (sin\u0394d + sind1 * cosd1 * tan\u0394r * tanh\u0394r);
        return [
            u,
            v
        ];
    };
    const us = new Array(3).fill(0);
    const vs = new Array(3).fill(0);
    cs1.forEach((c, x)=>{
        [us[x], vs[x]] = uv(cs1[x], cs2[x]);
    });
    const u3 = new (0, _interpolationJsDefault.default).Len3(-1, 1, us) // if line throws then bug not caller's fault.
    ;
    const v3 = new (0, _interpolationJsDefault.default).Len3(-1, 1, vs) // if line throws then bug not caller's fault.
    ;
    const up0 = (us[2] - us[0]) / 2;
    const vp0 = (vs[2] - vs[0]) / 2;
    const up1 = us[0] + us[2] - 2 * us[1];
    const vp1 = vs[0] + vs[2] - 2 * vs[1];
    const up = up0;
    const vp = vp0;
    let dn = -(us[1] * up + vs[1] * vp) / (up * up + vp * vp);
    let n = dn;
    let u;
    let v;
    for(let limit = 0; limit < 10; limit++){
        u = u3.interpolateN(n);
        v = v3.interpolateN(n);
        if (abs(dn) < 1e-5) return hypot(u, v) // success
        ;
        const up = up0 + n * up1;
        const vp = vp0 + n * vp1;
        dn = -(u * up + v * vp) / (up * up + vp * vp);
        n += dn;
    }
    throw new Error("minSepRect: failure to converge");
}
function hav(a) {
    return 0.5 * (1 - Math.cos(a));
}
function sepHav(c1, c2) {
    // using (17.5) p. 115
    return 2 * asin(sqrt(hav(c2.dec - c1.dec) + cos(c1.dec) * cos(c2.dec) * hav(c2.ra - c1.ra)));
}
function minSepHav(jd1, jd3, cs1, cs2) {
    return minSep(jd1, jd3, cs1, cs2, sepHav);
}
function sepPauwels(c1, c2) {
    const [sind1, cosd1] = (0, _baseJsDefault.default).sincos(c1.dec);
    const [sind2, cosd2] = (0, _baseJsDefault.default).sincos(c2.dec);
    const cosdr = cos(c2.ra - c1.ra);
    const x = cosd1 * sind2 - sind1 * cosd2 * cosdr;
    const y = cosd2 * sin(c2.ra - c1.ra);
    const z = sind1 * sind2 + cosd1 * cosd2 * cosdr;
    return atan2(hypot(x, y), z);
}
function minSepPauwels(jd1, jd3, cs1, cs2) {
    return minSep(jd1, jd3, cs1, cs2, sepPauwels);
}
function relativePosition(c1, c2) {
    const [sin\u0394r, cos\u0394r] = (0, _baseJsDefault.default).sincos(c1.ra - c2.ra);
    const [sind2, cosd2] = (0, _baseJsDefault.default).sincos(c2.dec);
    const p = atan2(sin\u0394r, cosd2 * tan(c1.dec) - sind2 * cos\u0394r);
    return p;
}
exports.default = {
    sep,
    minSep,
    minSepRect,
    hav,
    sepHav,
    minSepHav,
    sepPauwels,
    minSepPauwels,
    relativePosition
};

},{"./base.js":"cO06o","./interpolation.js":"isMMq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cO06o":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module base
 */ /**
 * Base: Functions and other definitions useful with multiple packages.
 *
 * Base contains various definitions and support functions useful in multiple
 * chapters.
 *
 * Bessellian and Julian Year
 *
 * Chapter 21, Precession actually contains these definitions.  They are moved
 * here because of their general utility.
 *
 * Chapter 22, Nutation contains the function for Julian centuries since J2000.
 *
 * Phase angle functions
 *
 * Two functions, Illuminated and Limb, concern the illumnated phase of a body
 * and are given in two chapters, 41 an 48.  They are collected here because
 * the identical functions apply in both chapters.
 *
 * General purpose math functions
 *
 * SmallAngle is recommended in chapter 17, p. 109.
 *
 * PMod addresses the issue on p. 7, chapter 1, in the section "Trigonometric
 * functions of large angles", but the function is not written to be specific
 * to angles and so has more general utility.
 *
 * Horner is described on p. 10, chapter 1.
 *
 * FloorDiv and FloorDiv64 are optimizations for the INT function described
 * on p. 60, chapter 7.
*/ // ---- constants ----
/** K is the Gaussian gravitational constant. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "K", ()=>K);
parcelHelpers.export(exports, "AU", ()=>AU);
parcelHelpers.export(exports, "SOblJ2000", ()=>SOblJ2000);
parcelHelpers.export(exports, "COblJ2000", ()=>COblJ2000);
// SOblJ2000, COblJ2000 from ch 33, p. 228, for example
/**
 * lightTime returns time for light to travel a given distance.
 * `dist` is distance in to earth in AU. √(x² + y² + z²)
 * Result in seconds of time.
 * @param {Number} dist - distance in to earth in AU
 * @returns {Number} time for light to travel a given distance in seconds
 */ parcelHelpers.export(exports, "lightTime", ()=>lightTime);
parcelHelpers.export(exports, "JMod", ()=>JMod);
parcelHelpers.export(exports, "J2000", ()=>J2000);
parcelHelpers.export(exports, "J1900", ()=>J1900);
parcelHelpers.export(exports, "B1900", ()=>B1900);
parcelHelpers.export(exports, "B1950", ()=>B1950);
parcelHelpers.export(exports, "JulianYear", ()=>JulianYear);
parcelHelpers.export(exports, "JulianCentury", ()=>JulianCentury);
parcelHelpers.export(exports, "BesselianYear", ()=>BesselianYear);
parcelHelpers.export(exports, "meanSiderealYear", ()=>meanSiderealYear);
/**
 * JulianYearToJDE returns the Julian ephemeris day for a Julian year.
 * @param {Number} jy - Julian year
 * @returns {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "JulianYearToJDE", ()=>JulianYearToJDE);
/**
 * JDEToJulianYear returns a Julian year for a Julian ephemeris day.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} jy - Julian year
 */ parcelHelpers.export(exports, "JDEToJulianYear", ()=>JDEToJulianYear);
/**
 * BesselianYearToJDE returns the Julian ephemeris day for a Besselian year.
 * @param {Number} by - Besselian year
 * @returns {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "BesselianYearToJDE", ()=>BesselianYearToJDE);
/**
 * JDEToBesselianYear returns the Besselian year for a Julian ephemeris day.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} by - Besselian year
 */ parcelHelpers.export(exports, "JDEToBesselianYear", ()=>JDEToBesselianYear);
/**
 * J2000Century returns the number of Julian centuries since J2000.
 *
 * The quantity appears as T in a number of time series.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} number of Julian centuries since J2000
 */ parcelHelpers.export(exports, "J2000Century", ()=>J2000Century);
// ---- phase ----
/**
 * illuminated returns the illuminated fraction of a body's disk.
 *
 * The illuminated body can be the Moon or a planet.
 *
 * @param {Number} i - phase angle in radians.
 * @returns {Number} illuminated fraction of a body's disk.
 */ parcelHelpers.export(exports, "illuminated", ()=>illuminated);
/**
 * celestial coordinates in right ascension and declination
 * or ecliptic coordinates in longitude and latitude
 */ parcelHelpers.export(exports, "Coord", ()=>Coord);
/**
 * Limb returns the position angle of the midpoint of an illuminated limb.
 *
 * The illuminated body can be the Moon or a planet.
 *
 * @param {Coord} equ - equatorial coordinates of the body `{ra, dec}` (in radians)
 * @param {Coord} appSun - apparent coordinates of the Sun `{ra, dec}` (In radians).
 * @returns {Number} position angle of the midpoint (in radians).
 */ parcelHelpers.export(exports, "limb", ()=>limb);
parcelHelpers.export(exports, "SmallAngle", ()=>SmallAngle);
parcelHelpers.export(exports, "CosSmallAngle", ()=>CosSmallAngle);
/**
 * pmod returns a positive floating-point x mod y.
 *
 * For a positive argument y, it returns a value in the range [0,y).
 *
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} x % y - The result may not be useful if y is negative.
 */ parcelHelpers.export(exports, "pmod", ()=>pmod);
/**
 * horner evaluates a polynomal with coefficients c at x.  The constant
 * term is c[0].
 * @param {Number} x
 * @param {Number[]} c - coefficients; c[0] may be of type Number[]
 * @returns {Number}
 */ parcelHelpers.export(exports, "horner", ()=>horner);
/**
 * FloorDiv returns the integer floor of the fractional value (x / y).
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} (int)
 */ parcelHelpers.export(exports, "floorDiv", ()=>floorDiv);
/**
 * Cmp compares two float64s and returns -1, 0, or 1 if a is <, ==, or > b,
 * respectively.
 * .
 * @param {Number} a
 * @param {Number} b
 * @returns {Number} comparison result
 */ parcelHelpers.export(exports, "cmp", ()=>cmp);
/**
 * shorthand function for Math.sin, Math.cos
 * @param {Number} ε
 * @returns {Number[]} [sin(ε), cos(ε)]
 */ parcelHelpers.export(exports, "sincos", ()=>sincos);
/**
 * Convert degrees to radians
 * @param  {Number} deg - Angle in degrees
 * @return {Number} Angle in radians
 */ parcelHelpers.export(exports, "toRad", ()=>toRad);
/**
 * Convert radians to degrees
 * @param  {Number} rad - Angle in radians
 * @return {Number} Angle in degrees
 */ parcelHelpers.export(exports, "toDeg", ()=>toDeg);
/**
 * separate fix `i` from fraction `f`
 * @param {Number} float
 * @returns {Array} [i, f]
 *  {Number} i - (int) fix value
 *  {Number} f - (float) fractional portion; always > 1
 */ parcelHelpers.export(exports, "modf", ()=>modf);
/**
 * Rounds `float` value by precision
 * @param {Number} float - value to round
 * @param {Number} [precision] - (int) number of post decimal positions
 * @return {Number} rounded `float`
 */ parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "errorCode", ()=>errorCode);
const K = 0.01720209895;
const AU = 149597870;
const SOblJ2000 = 0.397777156;
const COblJ2000 = 0.917482062;
function lightTime(dist) {
    // Formula given as (33.3) p. 224.
    return 0.0057755183 * dist;
}
const JMod = 2400000.5;
const J2000 = 2451545.0;
const J1900 = 2415020.0;
const B1900 = 2415020.3135;
const B1950 = 2433282.4235;
const JulianYear = 365.25 // days
;
const JulianCentury = 36525 // days
;
const BesselianYear = 365.2421988 // days
;
const meanSiderealYear = 365.25636 // days
;
function JulianYearToJDE(jy) {
    return J2000 + JulianYear * (jy - 2000);
}
function JDEToJulianYear(jde) {
    return 2000 + (jde - J2000) / JulianYear;
}
function BesselianYearToJDE(by) {
    return B1900 + BesselianYear * (by - 1900);
}
function JDEToBesselianYear(jde) {
    return 1900 + (jde - B1900) / BesselianYear;
}
function J2000Century(jde) {
    // The formula is given in a number of places in the book, for example
    // (12.1) p. 87.
    // (22.1) p. 143.
    // (25.1) p. 163.
    return (jde - J2000) / JulianCentury;
}
function illuminated(i) {
    // (41.1) p. 283, also (48.1) p. 345.
    return (1 + Math.cos(i)) * 0.5;
}
class Coord {
    /**
   * right ascension
   * @return {number}
   */ get ra() {
        return this._ra;
    }
    set ra(ra) {
        this._ra = ra;
    }
    /**
   * declination
   * @return {number}
   */ get dec() {
        return this._dec;
    }
    set dec(dec) {
        this._dec = dec;
    }
    /**
   * right ascension (or longitude)
   * @return {number}
   */ get lon() {
        return this._ra;
    }
    set lon(ra) {
        this._ra = ra;
    }
    /**
   * declination (or latitude)
   * @return {number}
   */ get lat() {
        return this._dec;
    }
    set lat(dec) {
        this._dec = dec;
    }
    /**
   * celestial coordinates in right ascension and declination
   * or ecliptic coordinates in longitude and latitude
   *
   * @param {number} ra - right ascension (or longitude)
   * @param {number} dec - declination (or latitude)
   * @param {number} [range] - distance
   * @param {number} [elongation] - elongation
   */ constructor(ra, dec, range, elongation){
        this._ra = ra || 0;
        this._dec = dec || 0;
        this.range = range;
        this.elongation = elongation;
    }
}
function limb(equ, appSun) {
    const \u03B1 = equ.ra;
    const \u03B4 = equ.dec;
    const \u03B10 = appSun.ra;
    const \u03B40 = appSun.dec;
    // Mentioned in ch 41, p. 283.  Formula (48.5) p. 346
    const s\u03B4 = Math.sin(\u03B4);
    const c\u03B4 = Math.cos(\u03B4);
    const s\u03B40 = Math.sin(\u03B40);
    const c\u03B40 = Math.cos(\u03B40);
    const s\u03B10\u03B1 = Math.sin(\u03B10 - \u03B1);
    const c\u03B10\u03B1 = Math.cos(\u03B10 - \u03B1);
    let \u03C7 = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1);
    if (\u03C7 < 0) \u03C7 += 2 * Math.PI;
    return \u03C7;
}
const SmallAngle = 10 * Math.PI / 180 / 60 // about .003 radians
;
const CosSmallAngle = Math.cos(SmallAngle) // about .999996
;
function pmod(x, y) {
    let r = x % y;
    if (r < 0) r += y;
    return r;
}
function horner(x, ...c) {
    if (Array.isArray(c[0])) c = c[0];
    let i = c.length - 1;
    let y = c[i];
    while(i > 0){
        i--;
        y = y * x + c[i];
    }
    return y;
}
function floorDiv(x, y) {
    const q = x / y;
    return Math.floor(q);
}
function cmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function sincos(\u03B5) {
    return [
        Math.sin(\u03B5),
        Math.cos(\u03B5)
    ];
}
function toRad(deg) {
    return Math.PI / 180.0 * deg;
}
function toDeg(rad) {
    return 180.0 / Math.PI * rad;
}
function modf(float) {
    const i = Math.trunc(float);
    const f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
function round(float, precision = 14) {
    return parseFloat(float.toFixed(precision));
}
function errorCode(msg, code) {
    const err = new Error(msg);
    // @ts-ignore
    err.code = code;
    return err;
}
exports.default = {
    K,
    AU,
    SOblJ2000,
    COblJ2000,
    lightTime,
    JMod,
    J2000,
    J1900,
    B1900,
    B1950,
    JulianYear,
    JulianCentury,
    BesselianYear,
    meanSiderealYear,
    JulianYearToJDE,
    JDEToJulianYear,
    BesselianYearToJDE,
    JDEToBesselianYear,
    J2000Century,
    illuminated,
    Coord,
    limb,
    SmallAngle,
    CosSmallAngle,
    pmod,
    horner,
    floorDiv,
    cmp,
    sincos,
    toRad,
    toDeg,
    modf,
    round,
    errorCode
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"isMMq":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module interpolation
 */ /**
 * Interp: Chapter 3, Interpolation.
 *
 * Len3 and Len5 types
 *
 * These types allow interpolation from a table of equidistant x values
 * and corresponding y values.  Since the x values are equidistant,
 * only the first and last values are supplied as arguments to the
 * constructors.  The interior x values are implicit.  All y values must be
 * supplied however.  They are passed as a slice, and the length of y is fixed.
 * For Len3 it must be 3 and for (Len5 it must be 5.0
 *
 * For these Len3 and Len5 functions, Meeus notes the importance of choosing
 * the 3 or 5 rows of a larger table that will minimize the interpolating
 * factor n.  He does not provide algorithms for doing this however.
 *
 * For an example of a selection function, see len3ForInterpolateX. This
 * was useful for computing Delta T.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorNot3", ()=>errorNot3);
parcelHelpers.export(exports, "errorNot4", ()=>errorNot4);
parcelHelpers.export(exports, "errorNot5", ()=>errorNot5);
parcelHelpers.export(exports, "errorNoXRange", ()=>errorNoXRange);
parcelHelpers.export(exports, "errorNOutOfRange", ()=>errorNOutOfRange);
parcelHelpers.export(exports, "errorNoExtremum", ()=>errorNoExtremum);
parcelHelpers.export(exports, "errorExtremumOutside", ()=>errorExtremumOutside);
parcelHelpers.export(exports, "errorZeroOutside", ()=>errorZeroOutside);
parcelHelpers.export(exports, "errorNoConverge", ()=>errorNoConverge);
/**
 * Len3 allows second difference interpolation.
 */ parcelHelpers.export(exports, "Len3", ()=>Len3);
/**
 * Len3ForInterpolateX is a special purpose Len3 constructor.
 *
 * Like NewLen3, it takes a table of x and y values, but it is not limited
 * to tables of 3 rows.  An X value is also passed that represents the
 * interpolation target x value.  Len3ForInterpolateX will locate the
 * appropriate three rows of the table for interpolating for x, and initialize
 * the Len3 object for those rows.
 *
 * @param {Number} x - is the target for interpolation
 * @param {Number} x1 - is the x value corresponding to the first y value of the table.
 * @param {Number} xN - is the x value corresponding to the last y value of the table.
 * @param {Number[]} y - is all y values in the table.  y.length should be >= 3.0
 * @returns {Len3} interpolation value
 */ parcelHelpers.export(exports, "len3ForInterpolateX", ()=>len3ForInterpolateX);
parcelHelpers.export(exports, "iterate", ()=>iterate);
/**
 * Len4Half interpolates a center value from a table of four rows.
 * @param {Number[]} y - 4 values
 * @returns {Number} interpolation result
 */ parcelHelpers.export(exports, "len4Half", ()=>len4Half);
/**
 * Len5 allows fourth Difference interpolation.
 */ parcelHelpers.export(exports, "Len5", ()=>Len5);
/**
 * Lagrange performs interpolation with unequally-spaced abscissae.
 *
 * Given a table of X and Y values, interpolate a new y value for argument x.
 *
 * X values in the table do not have to be equally spaced; they do not even
 * have to be in order. They must however, be distinct.
 *
 * @param {Number} x - x-value of interpolation
 * @param {Array} table - `[[x0, y0], ... [xN, yN]]` of x, y values
 * @returns {Number} interpolation result `y` of `x`
 */ parcelHelpers.export(exports, "lagrange", ()=>lagrange);
/**
 * LagrangePoly uses the formula of Lagrange to produce an interpolating
 * polynomial.
 *
 * X values in the table do not have to be equally spaced; they do not even
 * have to be in order.  They must however, be distinct.
 *
 * The returned polynomial will be of degree n-1 where n is the number of rows
 * in the table.  It can be evaluated for x using base.horner.
 *
 * @param {Array} table - `[[x0, y0], ... [xN, yN]]`
 * @returns {Array} - polynomial array
 */ parcelHelpers.export(exports, "lagrangePoly", ()=>lagrangePoly);
/**
 * Linear Interpolation of x
 */ parcelHelpers.export(exports, "linear", ()=>linear);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const int = Math.trunc;
const errorNot3 = new Error("Argument y must be length 3");
const errorNot4 = new Error("Argument y must be length 4");
const errorNot5 = new Error("Argument y must be length 5");
const errorNoXRange = new Error("Argument x3 (or x5) cannot equal x1");
const errorNOutOfRange = new Error("Interpolating factor n must be in range -1 to 1");
const errorNoExtremum = new Error("No extremum in table");
const errorExtremumOutside = new Error("Extremum falls outside of table");
const errorZeroOutside = new Error("Zero falls outside of table");
const errorNoConverge = new Error("Failure to converge");
class Len3 {
    /**
   * InterpolateX interpolates for a given x value.
   */ interpolateX(x) {
        const n = (2 * x - this.xSum) / this.xDiff;
        return this.interpolateN(n);
    }
    /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x3 given to the constructor NewLen3.
   */ interpolateXStrict(x) {
        const n = (2 * x - this.xSum) / this.xDiff;
        const y = this.interpolateNStrict(n);
        return y;
    }
    /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * This is interpolation formula (3.3)
   *
   * @param n - The interpolation factor n is x-x2 in units of the tabular x interval.
   * (See Meeus p. 24.)
   * @return {number} interpolation value
   */ interpolateN(n) {
        return this.y[1] + n * 0.5 * (this.abSum + n * this.c);
    }
    /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * @param {number} n - n is restricted to the range [-1..1] corresponding to the range x1 to x3
   * given to the constructor of Len3.
   * @return {number} interpolation value
   */ interpolateNStrict(n) {
        if (n < -1 || n > 1) throw errorNOutOfRange;
        return this.interpolateN(n);
    }
    /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * new Len3.
   */ extremum() {
        if (this.c === 0) throw errorNoExtremum;
        const n = this.abSum / (-2 * this.c // (3.5), p. 25
        );
        if (n < -1 || n > 1) throw errorExtremumOutside;
        const x = 0.5 * (this.xSum + this.xDiff * n);
        const y = this.y[1] - this.abSum * this.abSum / (8 * this.c // (3.4), p. 25
        );
        return [
            x,
            y
        ];
    }
    /**
   * Len3Zero finds a zero of the quadratic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen3.
   */ zero(strong) {
        let f;
        if (strong) // (3.7), p. 27
        f = (n0)=>{
            return n0 - (2 * this.y[1] + n0 * (this.abSum + this.c * n0)) / (this.abSum + 2 * this.c * n0);
        };
        else // (3.6), p. 26
        f = (n0)=>{
            return -2 * this.y[1] / (this.abSum + this.c * n0);
        };
        const [n0, ok] = iterate(0, f);
        if (!ok) throw errorNoConverge;
        if (n0 > 1 || n0 < -1) throw errorZeroOutside;
        return 0.5 * (this.xSum + this.xDiff * n0 // success
        );
    }
    /**
   * NewLen3 prepares a Len3 object from a table of three rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are supplied.
   * X1 must not equal to x3.  Y must be a slice of three y values.
   *
   * @throws Error
   * @param {Number} x1 - is the x value corresponding to the first y value of the table.
   * @param {Number} x3 - is the x value corresponding to the last y value of the table.
   * @param {Number[]} y - is all y values in the table. y.length should be >= 3.0
   */ constructor(x1, x3, y){
        if (y.length !== 3) throw errorNot3;
        if (x3 === x1) throw errorNoXRange;
        this.x1 = x1;
        this.x3 = x3;
        this.y = y;
        // differences. (3.1) p. 23
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = this.b - this.a;
        // other intermediate values
        this.abSum = this.a + this.b;
        this.xSum = x3 + x1;
        this.xDiff = x3 - x1;
    }
}
function len3ForInterpolateX(x, x1, xN, y) {
    let y3 = y;
    if (y.length > 3) {
        const interval = (xN - x1) / (y.length - 1);
        if (interval === 0) throw errorNoXRange;
        let nearestX = int((x - x1) / interval + 0.5);
        if (nearestX < 1) nearestX = 1;
        else if (nearestX > y.length - 2) nearestX = y.length - 2;
        y3 = y.slice(nearestX - 1, nearestX + 2);
        xN = x1 + (nearestX + 1) * interval;
        x1 = x1 + (nearestX - 1) * interval;
    }
    return new Len3(x1, xN, y3);
}
const iterate = function(n0, f) {
    for(let limit = 0; limit < 50; limit++){
        const n1 = f(n0);
        if (!isFinite(n1) || isNaN(n1)) break; // failure to converge
        if (Math.abs((n1 - n0) / n0) < 1e-15) return [
            n1,
            true
        ] // success
        ;
        n0 = n1;
    }
    return [
        0,
        false
    ] // failure to converge
    ;
};
function len4Half(y) {
    if (y.length !== 4) throw errorNot4;
    // (3.12) p. 32
    return (9 * (y[1] + y[2]) - y[0] - y[3]) / 16;
}
class Len5 {
    /**
   * InterpolateX interpolates for (a given x value.
   */ interpolateX(x) {
        const n = (4 * x - 2 * this.xSum) / this.xDiff;
        return this.interpolateN(n);
    }
    /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x5 given to the the constructor NewLen5.
   */ interpolateXStrict(x) {
        const n = (4 * x - 2 * this.xSum) / this.xDiff;
        const y = this.interpolateNStrict(n);
        return y;
    }
    /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * The interpolation factor n is x-x3 in units of the tabular x interval.
   * (See Meeus p. 28.)
   */ interpolateN(n) {
        return (0, _baseJsDefault.default).horner(n, ...this.interpCoeff);
    }
    /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * N is restricted to the range [-1..1].  This is only half the range given
   * to the constructor NewLen5, but is the recommendation given on p. 31.0
   */ interpolateNStrict(n) {
        if (n < -1 || n > 1) throw errorNOutOfRange;
        return (0, _baseJsDefault.default).horner(n, ...this.interpCoeff);
    }
    /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.  (Meeus actually recommends restricting the range to one unit of
   * the tabular interval, but that seems a little harsh.)
   */ extremum() {
        // (3.9) p. 29
        const nCoeff = [
            6 * (this.b + this.c) - this.h - this.j,
            0,
            3 * (this.h + this.j),
            2 * this.k
        ];
        const den = this.k - 12 * this.f;
        if (den === 0) throw errorExtremumOutside;
        const [n0, ok] = iterate(0, function(n0) {
            return (0, _baseJsDefault.default).horner(n0, ...nCoeff) / den;
        });
        if (!ok) throw errorNoConverge;
        if (n0 < -2 || n0 > 2) throw errorExtremumOutside;
        const x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
        const y = (0, _baseJsDefault.default).horner(n0, ...this.interpCoeff);
        return [
            x,
            y
        ];
    }
    /**
   * Len5Zero finds a zero of the quartic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.
   */ zero(strong) {
        let f;
        if (strong) {
            // (3.11), p. 29
            const M = this.k / 24;
            const N = (this.h + this.j) / 12;
            const P = this.f / 2 - M;
            const Q = (this.b + this.c) / 2 - N;
            const numCoeff = [
                this.y3,
                Q,
                P,
                N,
                M
            ];
            const denCoeff = [
                Q,
                2 * P,
                3 * N,
                4 * M
            ];
            f = function(n0) {
                return n0 - (0, _baseJsDefault.default).horner(n0, ...numCoeff) / (0, _baseJsDefault.default).horner(n0, ...denCoeff);
            };
        } else {
            // (3.10), p. 29
            const numCoeff = [
                -24 * this.y3,
                0,
                this.k - 12 * this.f,
                -2 * (this.h + this.j),
                -this.k
            ];
            const den = 12 * (this.b + this.c) - 2 * (this.h + this.j);
            f = function(n0) {
                return (0, _baseJsDefault.default).horner(n0, ...numCoeff) / den;
            };
        }
        const [n0, ok] = iterate(0, f);
        if (!ok) throw errorNoConverge;
        if (n0 > 2 || n0 < -2) throw errorZeroOutside;
        const x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
        return x;
    }
    /**
   * NewLen5 prepares a Len5 object from a table of five rows of x and y values.
   *
   * X values must be equally spaced, so only the first and last are suppliethis.
   * X1 must not equal x5.  Y must be a slice of five y values.
   */ constructor(x1, x5, y){
        if (y.length !== 5) throw errorNot5;
        if (x5 === x1) throw errorNoXRange;
        this.x1 = x1;
        this.x5 = x5;
        this.y = y;
        this.y3 = y[2];
        // differences
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = y[3] - y[2];
        this.d = y[4] - y[3];
        this.e = this.b - this.a;
        this.f = this.c - this.b;
        this.g = this.d - this.c;
        this.h = this.f - this.e;
        this.j = this.g - this.f;
        this.k = this.j - this.h;
        // other intermediate values
        this.xSum = x5 + x1;
        this.xDiff = x5 - x1;
        this.interpCoeff = [
            this.y3,
            (this.b + this.c) / 2 - (this.h + this.j) / 12,
            this.f / 2 - this.k / 24,
            (this.h + this.j) / 12,
            this.k / 24
        ];
    }
}
function lagrange(x, table) {
    // method of BASIC program, p. 33.0
    let sum = 0;
    table.forEach((ti, i)=>{
        const xi = ti[0];
        let prod = 1.0;
        table.forEach((tj, j)=>{
            if (i !== j) {
                const xj = tj[0];
                prod *= (x - xj) / (xi - xj);
            }
        });
        sum += ti[1] * prod;
    });
    return sum;
}
function lagrangePoly(table) {
    // Method not fully described by Meeus, but needed for (numerical solution
    // to Example 3.g.
    const sum = new Array(table.length).fill(0);
    const prod = new Array(table.length).fill(0);
    const last = table.length - 1;
    for(let i = 0; i < table.length; i++){
        const xi = table[i][0] || table[i].x || 0;
        const yi = table[i][1] || table[i].y || 0;
        prod[last] = 1;
        let den = 1.0;
        let n = last;
        for(let j = 0; j < table.length; j++)if (i !== j) {
            const xj = table[j][0] || table[j].x || 0;
            prod[n - 1] = prod[n] * -xj;
            for(let k = n; k < last; k++)prod[k] -= prod[k + 1] * xj;
            n--;
            den *= xi - xj;
        }
        prod.forEach((pj, j)=>{
            sum[j] += yi * pj / den;
        });
    }
    return sum;
}
function linear(x, x1, xN, y) {
    const interval = (xN - x1) / (y.length - 1);
    if (interval === 0) throw errorNoXRange;
    let nearestX = Math.floor((x - x1) / interval);
    if (nearestX < 0) nearestX = 0;
    else if (nearestX > y.length - 2) nearestX = y.length - 2;
    const y2 = y.slice(nearestX, nearestX + 2);
    const x01 = x1 + nearestX * interval;
    return y2[0] + (y[1] - y[0]) * (x - x01) / interval;
}
exports.default = {
    errorNot3,
    errorNot4,
    errorNot5,
    errorNoXRange,
    errorNOutOfRange,
    errorNoExtremum,
    errorExtremumOutside,
    errorZeroOutside,
    errorNoConverge,
    Len3,
    len3ForInterpolateX,
    iterate,
    len4Half,
    Len5,
    lagrange,
    lagrangePoly,
    linear
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4gNB9":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apparent
 */ /**
 * Apparent: Chapter 23, Apparent Place of a Star
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Nutation returns corrections due to nutation for equatorial coordinates
 * of an object.
 *
 * Results are invalid for objects very near the celestial poles.
 * @param {Number} α - right ascension
 * @param {Number} δ - declination
 * @param {Number} jd - Julian Day
 * @return {Number[]} [Δα1, Δδ1] -
*/ parcelHelpers.export(exports, "nutation", ()=>nutation);
/**
 * longitude of perihelian of Earth's orbit.
 */ parcelHelpers.export(exports, "perihelion", ()=>perihelion);
/**
 * EclipticAberration returns corrections due to aberration for ecliptic
 * coordinates of an object.
 */ parcelHelpers.export(exports, "eclipticAberration", ()=>eclipticAberration);
/**
 * Aberration returns corrections due to aberration for equatorial
 * coordinates of an object.
 */ parcelHelpers.export(exports, "aberration", ()=>aberration);
/**
 * Position computes the apparent position of an object.
 *
 * Position is computed for equatorial coordinates in eqFrom, considering
 * proper motion, precession, nutation, and aberration.  Result is in
 * eqTo.  EqFrom and eqTo must be non-nil, but may point to the same struct.
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * AberrationRonVondrak uses the Ron-Vondrák expression to compute corrections
 * due to aberration for equatorial coordinates of an object.
 */ parcelHelpers.export(exports, "aberrationRonVondrak", ()=>aberrationRonVondrak);
/**
 * PositionRonVondrak computes the apparent position of an object using
 * the Ron-Vondrák expression for aberration.
 *
 * Position is computed for equatorial coordinates in eqFrom, considering
 * proper motion, aberration, precession, and _nutation.  Result is in
 * eqTo.  EqFrom and eqTo must be non-nil, but may point to the same struct.
 *
 * Note the Ron-Vondrák expression is only valid for the epoch J2000.
 * EqFrom must be coordinates at epoch J2000.
 */ parcelHelpers.export(exports, "positionRonVondrak", ()=>positionRonVondrak);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
const { cos, tan } = Math;
function nutation(\u03B1, \u03B4, jd) {
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jd);
    const [sin\u03B5, cos\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jd);
    const [sin\u03B1, cos\u03B1] = (0, _baseJsDefault.default).sincos(\u03B1);
    const tan\u03B4 = tan(\u03B4);
    // (23.1) p. 151
    const \u0394\u03B11 = (cos\u03B5 + sin\u03B5 * sin\u03B1 * tan\u03B4) * \u0394\u03C8 - cos\u03B1 * tan\u03B4 * \u0394\u03B5;
    const \u0394\u03B41 = sin\u03B5 * cos\u03B1 * \u0394\u03C8 + sin\u03B1 * \u0394\u03B5;
    return [
        \u0394\u03B11,
        \u0394\u03B41
    ];
}
/**
 * κ is the constant of aberration in radians.
 */ const \u03BA = 20.49552 * Math.PI / 180 / 3600;
function perihelion(T) {
    return (0, _baseJsDefault.default).horner(T, 102.93735, 1.71946, 0.00046) * Math.PI / 180;
}
function eclipticAberration(\u03BB, \u03B2, jd) {
    const T = (0, _baseJsDefault.default).J2000Century(jd);
    const { lon, ano } = (0, _solarJsDefault.default).trueLongitude(T) // eslint-disable-line no-unused-vars
    ;
    const e = (0, _solarJsDefault.default).eccentricity(T);
    const \u03C0 = perihelion(T);
    const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(\u03B2);
    const [ss\u03BB, cs\u03BB] = (0, _baseJsDefault.default).sincos(lon - \u03BB);
    const [sin\u03C0\u03BB, cos\u03C0\u03BB] = (0, _baseJsDefault.default).sincos(\u03C0 - \u03BB);
    // (23.2) p. 151
    const \u0394\u03BB = \u03BA * (e * cos\u03C0\u03BB - cs\u03BB) / c\u03B2;
    const \u0394\u03B2 = -\u03BA * s\u03B2 * (ss\u03BB - e * sin\u03C0\u03BB);
    return [
        \u0394\u03BB,
        \u0394\u03B2
    ];
}
function aberration(\u03B1, \u03B4, jd) {
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jd);
    const T = (0, _baseJsDefault.default).J2000Century(jd);
    const { lon, ano } = (0, _solarJsDefault.default).trueLongitude(T) // eslint-disable-line no-unused-vars
    ;
    const e = (0, _solarJsDefault.default).eccentricity(T);
    const \u03C0 = perihelion(T);
    const [sin\u03B1, cos\u03B1] = (0, _baseJsDefault.default).sincos(\u03B1);
    const [sin\u03B4, cos\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const [sins, coss] = (0, _baseJsDefault.default).sincos(lon);
    const [sin\u03C0, cos\u03C0] = (0, _baseJsDefault.default).sincos(\u03C0);
    const cos\u03B5 = cos(\u03B5);
    const q1 = cos\u03B1 * cos\u03B5;
    // (23.3) p. 152
    const \u0394\u03B12 = \u03BA * (e * (q1 * cos\u03C0 + sin\u03B1 * sin\u03C0) - (q1 * coss + sin\u03B1 * sins)) / cos\u03B4;
    const q2 = cos\u03B5 * (tan(\u03B5) * cos\u03B4 - sin\u03B1 * sin\u03B4);
    const q3 = cos\u03B1 * sin\u03B4;
    const \u0394\u03B42 = \u03BA * (e * (cos\u03C0 * q2 + sin\u03C0 * q3) - (coss * q2 + sins * q3));
    return [
        \u0394\u03B12,
        \u0394\u03B42
    ];
}
function position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const eqTo = (0, _precessJsDefault.default).position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4);
    const jd = (0, _baseJsDefault.default).JulianYearToJDE(epochTo);
    const [\u0394\u03B11, \u0394\u03B41] = nutation(eqTo.ra, eqTo.dec, jd);
    const [\u0394\u03B12, \u0394\u03B42] = aberration(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B11 + \u0394\u03B12;
    eqTo.dec += \u0394\u03B41 + \u0394\u03B42;
    return eqTo;
}
function aberrationRonVondrak(\u03B1, \u03B4, jd) {
    const T = (0, _baseJsDefault.default).J2000Century(jd);
    const r = {
        T,
        L2: 3.1761467 + 1021.3285546 * T,
        L3: 1.7534703 + 628.3075849 * T,
        L4: 6.2034809 + 334.0612431 * T,
        L5: 0.5995465 + 52.9690965 * T,
        L6: 0.8740168 + 21.3299095 * T,
        L7: 5.4812939 + 7.4781599 * T,
        L8: 5.3118863 + 3.8133036 * T,
        Lp: 3.8103444 + 8399.6847337 * T,
        D: 5.1984667 + 7771.3771486 * T,
        Mp: 2.3555559 + 8328.6914289 * T,
        F: 1.6279052 + 8433.4661601 * T
    };
    let Xp = 0;
    let Yp = 0;
    let Zp = 0;
    // sum smaller terms first
    for(let i = 35; i >= 0; i--){
        const [x, y, z] = rvTerm[i](r);
        Xp += x;
        Yp += y;
        Zp += z;
    }
    const [sin\u03B1, cos\u03B1] = (0, _baseJsDefault.default).sincos(\u03B1);
    const [sin\u03B4, cos\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    // (23.4) p. 156
    return [
        (Yp * cos\u03B1 - Xp * sin\u03B1) / (c * cos\u03B4),
        -((Xp * cos\u03B1 + Yp * sin\u03B1) * sin\u03B4 - Zp * cos\u03B4) / c
    ];
}
const c = 17314463350 // unit is 1e-8 AU / day
;
// r = {T, L2, L3, L4, L5, L6, L7, L8, Lp, D, Mp, F}
const rvTerm = [
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L3);
        return [
            (-1719914 - 2 * r.T) * sinA - 25 * cosA,
            (25 - 13 * r.T) * sinA + (1578089 + 156 * r.T) * cosA,
            (10 + 32 * r.T) * sinA + (684185 - 358 * r.T) * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L3);
        return [
            (6434 + 141 * r.T) * sinA + (28007 - 107 * r.T) * cosA,
            (25697 - 95 * r.T) * sinA + (-5904 - 130 * r.T) * cosA,
            (11141 - 48 * r.T) * sinA + (-2559 - 55 * r.T) * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L5);
        return [
            715 * sinA,
            6 * sinA - 657 * cosA,
            -15 * sinA - 282 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.Lp);
        return [
            715 * sinA,
            -656 * cosA,
            -285 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L3);
        return [
            (486 - 5 * r.T) * sinA + (-236 - 4 * r.T) * cosA,
            (-216 - 4 * r.T) * sinA + (-446 + 5 * r.T) * cosA,
            -94 * sinA - 193 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L6);
        return [
            159 * sinA,
            2 * sinA - 147 * cosA,
            -6 * sinA - 61 * cosA
        ];
    },
    function(r) {
        const cosA = Math.cos(r.F);
        return [
            0,
            26 * cosA,
            -59 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.Lp + r.Mp);
        return [
            39 * sinA,
            -36 * cosA,
            -16 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L5);
        return [
            33 * sinA - 10 * cosA,
            -9 * sinA - 30 * cosA,
            -5 * sinA - 13 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L3 - r.L5);
        return [
            31 * sinA + cosA,
            sinA - 28 * cosA,
            -12 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L3 - 8 * r.L4 + 3 * r.L5);
        return [
            8 * sinA - 28 * cosA,
            25 * sinA + 8 * cosA,
            11 * sinA + 3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(5 * r.L3 - 8 * r.L4 + 3 * r.L5);
        return [
            8 * sinA - 28 * cosA,
            -25 * sinA - 8 * cosA,
            -11 * sinA + -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L2 - r.L3);
        return [
            21 * sinA,
            -19 * cosA,
            -8 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L2);
        return [
            -19 * sinA,
            17 * cosA,
            8 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L7);
        return [
            17 * sinA,
            -16 * cosA,
            -7 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L3 - 2 * r.L5);
        return [
            16 * sinA,
            15 * cosA,
            sinA + 7 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L8);
        return [
            16 * sinA,
            sinA - 15 * cosA,
            -3 * sinA - 6 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L3 + r.L5);
        return [
            11 * sinA - cosA,
            -sinA - 10 * cosA,
            -sinA - 5 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L2 - 2 * r.L3);
        return [
            -11 * cosA,
            -10 * sinA,
            -4 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L3 - r.L5);
        return [
            -11 * sinA - 2 * cosA,
            -2 * sinA + 9 * cosA,
            -sinA + 4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(4 * r.L3);
        return [
            -7 * sinA - 8 * cosA,
            -8 * sinA + 6 * cosA,
            -3 * sinA + 3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L3 - 2 * r.L5);
        return [
            -10 * sinA,
            9 * cosA,
            4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.L2 - 2 * r.L3);
        return [
            -9 * sinA,
            -9 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L2 - 3 * r.L3);
        return [
            -9 * sinA,
            -8 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L6);
        return [
            -9 * cosA,
            -8 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L2 - 4 * r.L3);
        return [
            -9 * cosA,
            8 * sinA,
            3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L3 - 2 * r.L4);
        return [
            8 * sinA,
            -8 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.Lp + 2 * r.D - r.Mp);
        return [
            8 * sinA,
            -7 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(8 * r.L2 - 12 * r.L3);
        return [
            -4 * sinA - 7 * cosA,
            -6 * sinA + 4 * cosA,
            -3 * sinA + 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(8 * r.L2 - 14 * r.L3);
        return [
            -4 * sinA - 7 * cosA,
            6 * sinA - 4 * cosA,
            3 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L4);
        return [
            -6 * sinA - 5 * cosA,
            -4 * sinA + 5 * cosA,
            -2 * sinA + 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L2 - 4 * r.L3);
        return [
            -sinA - cosA,
            -2 * sinA - 7 * cosA,
            sinA - 4 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L3 - 2 * r.L5);
        return [
            4 * sinA - 6 * cosA,
            -5 * sinA - 4 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(3 * r.L2 - 3 * r.L3);
        return [
            -7 * cosA,
            -6 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(2 * r.L3 - 2 * r.L4);
        return [
            5 * sinA - 5 * cosA,
            -4 * sinA - 5 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        const [sinA, cosA] = (0, _baseJsDefault.default).sincos(r.Lp - 2 * r.D);
        return [
            5 * sinA,
            -5 * cosA,
            -2 * cosA
        ];
    }
];
function positionRonVondrak(eqFrom, epochTo, m\u03B1, m\u03B4) {
    const t = epochTo - 2000;
    let eqTo = new (0, _coordJsDefault.default).Equatorial();
    eqTo.ra = eqFrom.ra + m\u03B1.rad() * t;
    eqTo.dec = eqFrom.dec + m\u03B4.rad() * t;
    const jd = (0, _baseJsDefault.default).JulianYearToJDE(epochTo);
    const [\u0394\u03B1, \u0394\u03B4] = aberrationRonVondrak(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B1;
    eqTo.dec += \u0394\u03B4;
    eqTo = (0, _precessJsDefault.default).position(eqTo, 2000, epochTo, 0, 0);
    const [\u0394\u03B11, \u0394\u03B41] = nutation(eqTo.ra, eqTo.dec, jd);
    eqTo.ra += \u0394\u03B11;
    eqTo.dec += \u0394\u03B41;
    return eqTo;
}
exports.default = {
    nutation,
    perihelion,
    eclipticAberration,
    aberration,
    position,
    aberrationRonVondrak,
    positionRonVondrak
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./nutation.js":"fWRWg","./precess.js":"tAZZk","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1Ze6D":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module coord
 */ /**
 * Coord: Chapter 13, Transformation of Coordinates.
 *
 * Transforms in this package are provided in two forms, function and method.
 * The results of the two forms should be identical.
 *
 * The function forms pass all arguments and results as single values.  These
 * forms are best used when you are transforming a single pair of coordinates
 * and wish to avoid memory allocation.
 *
 * The method forms take and return pointers to structs.  These forms are best
 * used when you are transforming multiple coordinates and can reuse one or
 * more of the structs.  In this case reuse of structs will minimize
 * allocations, and the struct pointers will pass more efficiently on the
 * stack.  These methods transform their arguments, placing the result in
 * the receiver.  The receiver is then returned for convenience.
 *
 * A number of the functions take sine and cosine of the obliquity of the
 * ecliptic.  This becomes an advantage when you doing multiple transformations
 * with the same obliquity.  The efficiency of computing sine and cosine once
 * and reuse these values far outweighs the overhead of passing one number as
 * opposed to two.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {object} LonLat
 * @property {Number} lon - Longitude (λ) in radians
 * @property {Number} lat - Latitude (β) in radians
 */ /**
* Ecliptic coordinates are referenced to the plane of the ecliptic.
*/ parcelHelpers.export(exports, "Ecliptic", ()=>Ecliptic);
/**
 * Equatorial coordinates are referenced to the Earth's rotational axis.
 */ parcelHelpers.export(exports, "Equatorial", ()=>Equatorial);
/**
 * Horizontal coordinates are referenced to the local horizon of an observer
 * on the surface of the Earth.
 * @param {Number} az - Azimuth (A) in radians
 * @param {Number} alt - Altitude (h) in radians
 */ parcelHelpers.export(exports, "Horizontal", ()=>Horizontal);
/**
 * Galactic coordinates are referenced to the plane of the Milky Way.
 * @param {Number} lon - Longitude (l) in radians
 * @param {Number} lat - Latitude (b) in radians
 */ parcelHelpers.export(exports, "Galactic", ()=>Galactic);
parcelHelpers.export(exports, "galacticNorth", ()=>galacticNorth);
parcelHelpers.export(exports, "galacticNorth1950", ()=>galacticNorth1950);
parcelHelpers.export(exports, "galacticLon0", ()=>galacticLon0);
parcelHelpers.export(exports, "galactic0Lon1950", ()=>galactic0Lon1950);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _globeJs = require("./globe.js"); // eslint-disable-line no-unused-vars
class Ecliptic {
    /**
   * converts ecliptic coordinates to equatorial coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Equatorial}
   */ toEquatorial(\u03B5) {
        const [\u03B5sin, \u03B5cos] = (0, _baseJsDefault.default).sincos(\u03B5);
        const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(this.lat);
        const [s\u03BB, c\u03BB] = (0, _baseJsDefault.default).sincos(this.lon);
        let ra = Math.atan2(s\u03BB * \u03B5cos - s\u03B2 / c\u03B2 * \u03B5sin, c\u03BB) // (13.3) p. 93
        ;
        if (ra < 0) ra += 2 * Math.PI;
        const dec = Math.asin(s\u03B2 * \u03B5cos + c\u03B2 * \u03B5sin * s\u03BB) // (13.4) p. 93
        ;
        return new Equatorial(ra, dec);
    }
    /**
   * IMPORTANT: Longitudes are measured *positively* westwards
   * e.g. Washington D.C. +77°04; Vienna -16°23'
   * @param {Number|LonLat} [lon] - Longitude (λ) in radians
   * @param {Number} [lat] - Latitude (β) in radians
   */ constructor(lon, lat){
        if (typeof lon === "object") {
            lat = lon.lat;
            lon = lon.lon;
        }
        this.lon = lon || 0;
        this.lat = lat || 0;
    }
}
class Equatorial {
    /**
   * EqToEcl converts equatorial coordinates to ecliptic coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Ecliptic}
   */ toEcliptic(\u03B5) {
        const [\u03B5sin, \u03B5cos] = (0, _baseJsDefault.default).sincos(\u03B5);
        const [s\u03B1, c\u03B1] = (0, _baseJsDefault.default).sincos(this.ra);
        const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(this.dec);
        const lon = Math.atan2(s\u03B1 * \u03B5cos + s\u03B4 / c\u03B4 * \u03B5sin, c\u03B1) // (13.1) p. 93
        ;
        const lat = Math.asin(s\u03B4 * \u03B5cos - c\u03B4 * \u03B5sin * s\u03B1) // (13.2) p. 93
        ;
        return new Ecliptic(lon, lat);
    }
    /**
   * EqToHz computes Horizontal coordinates from equatorial coordinates.
   *
   * Argument g is the location of the observer on the Earth.  Argument st
   * is the sidereal time at Greenwich.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   *
   * @param {GlobeCoord} g - coordinates of observer on Earth
   * @param {Number} st - sidereal time at Greenwich at time of observation
   * @returns {Horizontal}
   */ toHorizontal(g, st) {
        const H = new (0, _sexagesimalJsDefault.default).Time(st).rad() - g.lon - this.ra;
        const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
        const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(g.lat);
        const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(this.dec);
        const azimuth = Math.atan2(sH, cH * s\u03C6 - s\u03B4 / c\u03B4 * c\u03C6) // (13.5) p. 93
        ;
        const altitude = Math.asin(s\u03C6 * s\u03B4 + c\u03C6 * c\u03B4 * cH) // (13.6) p. 93
        ;
        return new Horizontal(azimuth, altitude);
    }
    /**
   * EqToGal converts equatorial coordinates to galactic coordinates.
   *
   * Equatorial coordinates must be referred to the standard equinox of B1950.0.
   * For conversion to B1950, see package precess and utility functions in
   * package "common".
   *
   * @returns {Galactic}
   */ toGalactic() {
        const [sd\u03B1, cd\u03B1] = (0, _baseJsDefault.default).sincos(galacticNorth1950.ra - this.ra);
        const [sg\u03B4, cg\u03B4] = (0, _baseJsDefault.default).sincos(galacticNorth1950.dec);
        const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(this.dec);
        const x = Math.atan2(sd\u03B1, cd\u03B1 * sg\u03B4 - s\u03B4 / c\u03B4 * cg\u03B4) // (13.7) p. 94
        ;
        // (galactic0Lon1950 + 1.5*math.Pi) = magic number of 303 deg
        const lon = (galactic0Lon1950 + 1.5 * Math.PI - x) % (2 * Math.PI // (13.8) p. 94
        );
        const lat = Math.asin(s\u03B4 * sg\u03B4 + c\u03B4 * cg\u03B4 * cd\u03B1);
        return new Galactic(lon, lat);
    }
    /**
   * @param {Number} ra - (float) Right ascension (α) in radians
   * @param {Number} dec - (float) Declination (δ) in radians
   */ constructor(ra = 0, dec = 0){
        this.ra = ra;
        this.dec = dec;
    }
}
class Horizontal {
    /**
   * transforms horizontal coordinates to equatorial coordinates.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   * @param {GlobeCoord} g - coordinates of observer on Earth (lat, lon)
   * @param {Number} st - sidereal time at Greenwich at time of observation.
   * @returns {Equatorial} (right ascension, declination)
   */ toEquatorial(g, st) {
        const [sA, cA] = (0, _baseJsDefault.default).sincos(this.az);
        const [sh, ch] = (0, _baseJsDefault.default).sincos(this.alt);
        const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(g.lat);
        const H = Math.atan2(sA, cA * s\u03C6 + sh / ch * c\u03C6);
        const ra = (0, _baseJsDefault.default).pmod(new (0, _sexagesimalJsDefault.default).Time(st).rad() - g.lon - H, 2 * Math.PI);
        const dec = Math.asin(s\u03C6 * sh - c\u03C6 * ch * cA);
        return new Equatorial(ra, dec);
    }
    constructor(az = 0, alt = 0){
        this.az = az;
        this.alt = alt;
    }
}
class Galactic {
    /**
   * GalToEq converts galactic coordinates to equatorial coordinates.
   *
   * Resulting equatorial coordinates will be referred to the standard equinox of
   * B1950.0.  For subsequent conversion to other epochs, see package precess and
   * utility functions in package meeus.
   *
   * @returns {Equatorial} (right ascension, declination)
   */ toEquatorial() {
        // (-galactic0Lon1950 - math.Pi/2) = magic number of -123 deg
        const [sdLon, cdLon] = (0, _baseJsDefault.default).sincos(this.lon - galactic0Lon1950 - Math.PI / 2);
        const [sg\u03B4, cg\u03B4] = (0, _baseJsDefault.default).sincos(galacticNorth1950.dec);
        const [sb, cb] = (0, _baseJsDefault.default).sincos(this.lat);
        const y = Math.atan2(sdLon, cdLon * sg\u03B4 - sb / cb * cg\u03B4);
        // (galacticNorth1950.RA.Rad() - math.Pi) = magic number of 12.25 deg
        const ra = (0, _baseJsDefault.default).pmod(y + galacticNorth1950.ra - Math.PI, 2 * Math.PI);
        const dec = Math.asin(sb * sg\u03B4 + cb * cg\u03B4 * cdLon);
        return new Equatorial(ra, dec);
    }
    constructor(lon = 0, lat = 0){
        this.lon = lon;
        this.lat = lat;
    }
}
const galacticNorth = new Equatorial(new (0, _sexagesimalJsDefault.default).RA(12, 49, 0).rad(), 27.4 * Math.PI / 180);
const galacticNorth1950 = galacticNorth;
const galacticLon0 = 33 * Math.PI / 180;
const galactic0Lon1950 = galacticLon0;
exports.default = {
    Ecliptic,
    Equatorial,
    Horizontal,
    Galactic,
    galacticNorth,
    galacticNorth1950,
    galacticLon0,
    galactic0Lon1950
};

},{"./base.js":"cO06o","./sexagesimal.js":"1aKkU","./globe.js":"argxH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1aKkU":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sexagesimal
 */ /**
 * Sexagesimal functions
 */ /**
 * Angle represents a general purpose angle.
 * Unit is radians.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Angle", ()=>Angle);
/**
 * HourAngle represents an angle corresponding to angular rotation of
 * the Earth in a specified time.
 *
 * Unit is radians.
 */ parcelHelpers.export(exports, "HourAngle", ()=>HourAngle);
/**
 * DMSToDeg converts from parsed sexagesimal angle components to decimal
 * degrees.
 * @param {Boolean} neg - sign, true if negative
 * @param {Number} d - (int) degree
 * @param {Number} m - (int) minute
 * @param {Number} s - (float) second
 * @returns {Number} angle in degree
 */ parcelHelpers.export(exports, "DMSToDeg", ()=>DMSToDeg);
/**
 * DegToDMS converts from decimal degrees to parsed sexagesimal angle component.
 * @param {Number} deg - angle in degree
 * @returns {Array} [neg, d, m, s]
 *  {Boolean} neg - sign, true if negative
 *  {Number} d - (int) degree
 *  {Number} m - (int) minute
 *  {Number} s - (float) second
 */ parcelHelpers.export(exports, "degToDMS", ()=>degToDMS);
parcelHelpers.export(exports, "RA", ()=>RA);
/**
 * Time Angle
 * Unit is time in seconds.
 */ parcelHelpers.export(exports, "Time", ()=>Time);
parcelHelpers.export(exports, "angleFromDeg", ()=>angleFromDeg);
parcelHelpers.export(exports, "angleFromMin", ()=>angleFromMin);
parcelHelpers.export(exports, "angleFromSec", ()=>angleFromSec);
parcelHelpers.export(exports, "degFromAngle", ()=>degFromAngle);
parcelHelpers.export(exports, "secFromAngle", ()=>secFromAngle);
parcelHelpers.export(exports, "secFromHourAngle", ()=>secFromHourAngle);
class Angle {
    /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} d - (int) degree
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ setDMS(neg = false, d = 0, m = 0, s = 0.0) {
        this.angle = DMSToDeg(neg, d, m, s) * Math.PI / 180;
        return this;
    }
    /**
   * sets angle
   * @param {Number} angle - (float) angle in radians
   * @returns {Angle}
   */ setAngle(angle) {
        this.angle = angle;
        return this;
    }
    /**
   * Rad returns the angle in radians.
   * @returns {Number} angle in radians
   */ rad() {
        return this.angle;
    }
    /**
   * Deg returns the angle in degrees.
   * @returns {Number} angle in degree
   */ deg() {
        return this.angle * 180 / Math.PI;
    }
    /**
   * toDMS converts to parsed sexagesimal angle component.
   */ toDMS() {
        return degToDMS(this.deg());
    }
    /**
   * Print angle in degree using `d°m´s.ss″`
   * @param {Number} [precision] - precision of `s.ss`
   * @returns {String}
   */ toString(precision) {
        let [neg, d, m, s] = this.toDMS();
        s = round(s, precision).toString().replace(/^0\./, ".");
        const str = (neg ? "-" : "") + (d + "\xb0") + (m + "\u2032") + (s + "\u2033");
        return str;
    }
    /**
   * Print angle in degree using `d°.ff`
   * @param {Number} [precision] - precision of `.ff`
   * @returns {String}
   */ toDegString(precision) {
        let [i, s] = modf(this.deg());
        s = round(s, precision).toString().replace(/^0\./, ".");
        const str = i + "\xb0" + s;
        return str;
    }
    /**
  * constructs a new Angle value from sign, degree, minute, and second
  * components.
  * @param {Number|Boolean} angleOrNeg - angle in radians or sign, true if negative (required to attribute -0°30')
  * __Four arguments__
  * @param {Number} [d] - (int) degree
  * @param {Number} [m] - (int) minute
  * @param {Number} [s] - (float) second
  */ constructor(angleOrNeg, d, m, s){
        if (arguments.length === 1) this.angle = Number(angleOrNeg);
        else this.setDMS(!!angleOrNeg, d, m, s);
    }
}
class HourAngle extends Angle {
    /**
   * NewHourAngle constructs a new HourAngle value from sign, hour, minute,
   * and second components.
   * @param {Boolean} neg
   * @param {Number} h - (int)
   * @param {Number} m - (int)
   * @param {Number} s - (float)
   * @constructor
   */ /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ setDMS(neg = false, h = 0, m = 0, s = 0.0) {
        this.angle = DMSToDeg(neg, h, m, s) * 15 * Math.PI / 180;
        return this;
    }
    /**
   * Hour returns the hour angle as hours of time.
   * @returns hour angle
   */ hour() {
        return this.angle * 12 / Math.PI // 12 = 180 / 15
        ;
    }
    deg() {
        return this.hour();
    }
    /**
   * Print angle in `HʰMᵐs.ssˢ`
   * @param {Number} precision - precision of `s.ss`
   * @returns {String}
   */ toString(precision) {
        let [neg, h, m, s] = this.toDMS();
        s = round(s, precision).toString().replace(/^0\./, ".");
        const str = (neg ? "-" : "") + (h + "\u02B0") + (m + "\u1D50") + (s + "\u02E2");
        return str;
    }
}
function DMSToDeg(neg, d, m, s) {
    s = ((d * 60 + m) * 60 + s) / 3600;
    if (neg) return -s;
    return s;
}
function degToDMS(deg) {
    const neg = deg < 0;
    deg = Math.abs(deg);
    let [d, s] = modf(deg % 360);
    const [m, s1] = modf(s * 60);
    s = round(s1 * 60) // may introduce an error < 1e13
    ;
    return [
        neg,
        d,
        m,
        s
    ];
}
class RA extends HourAngle {
    hour() {
        const h = this.angle * 12 / Math.PI;
        return (24 + h % 24) % 24;
    }
    /**
   * constructs a new RA value from hour, minute, and second components.
   * Negative values are not supported, RA wraps values larger than 24
   * to the range [0,24) hours.
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   */ constructor(h = 0, m = 0, s = 0){
        super(false, h, m, s);
        const args = [].slice.call(arguments);
        if (args.length === 1) this.angle = h;
        else {
            const hr = DMSToDeg(false, h, m, s) % 24;
            this.angle = hr * 15 * Math.PI / 180;
        }
    }
}
class Time {
    setHMS(neg = false, h = 0, m = 0, s = 0) {
        s += (h * 60 + m) * 60;
        if (neg) s = -s;
        this.time = s;
    }
    /**
   * @returns {Number} time in seconds.
   */ sec() {
        return this.time;
    }
    /**
   * @returns {Number} time in minutes.
   */ min() {
        return this.time / 60;
    }
    /**
   * @returns {Number} time in hours.
   */ hour() {
        return this.time / 3600;
    }
    /**
   * @returns {Number} time in days.
   */ day() {
        return this.time / 3600 / 24;
    }
    /**
   * @returns {Number} time in radians, where 1 day = 2 Pi radians.
   */ rad() {
        return this.time * Math.PI / 12 / 3600;
    }
    /**
   * convert time to HMS
   * @returns {Array} [neg, h, m, s]
   *  {Boolean} neg - sign, true if negative
   *  {Number} h - (int) hour
   *  {Number} m - (int) minute
   *  {Number} s - (float) second
   */ toHMS() {
        let t = this.time;
        const neg = t < 0;
        t = neg ? -t : t;
        const h = Math.trunc(t / 3600);
        t = t - h * 3600;
        const m = Math.trunc(t / 60);
        const s = t - m * 60;
        return [
            neg,
            h,
            m,
            s
        ];
    }
    /**
   * Print time using `HʰMᵐsˢ.ss`
   * @param {Number} precision - precision of `.ss`
   * @returns {String}
   */ toString(precision) {
        const [neg, h, m, s] = this.toHMS();
        let [si, sf] = modf(s);
        if (precision === 0) {
            si = round(s, 0);
            sf = 0;
        } else sf = round(sf, precision).toString().substr(1);
        const str = (neg ? "-" : "") + (h + "\u02B0") + (m + "\u1D50") + (si + "\u02E2") + (sf || "");
        return str;
    }
    /**
   * @param {boolean|number} negOrTimeInSecs - set `true` if negative; if type is number than time in seconds
   * @param {number} [h] - (int) hour
   * @param {number} [m] - (int) minute
   * @param {number} [s] - (float) second
   * @example
   * new sexa.Time(SECS_OF_DAY)
   * new sexa.Time(false, 15, 22, 7)
   */ constructor(negOrTimeInSecs, h, m, s){
        if (typeof negOrTimeInSecs === "number") this.time = negOrTimeInSecs;
        else this.setHMS(negOrTimeInSecs, h, m, s);
    }
}
const angleFromDeg = (deg)=>deg * Math.PI / 180;
const angleFromMin = (min)=>min / 60 * Math.PI / 180;
const angleFromSec = (sec)=>sec / 3600 * Math.PI / 180;
const degFromAngle = (angle)=>angle * 180 / Math.PI;
const secFromAngle = (angle)=>angle * 648000 / Math.PI;
const secFromHourAngle = (ha)=>ha * 43200 / Math.PI;
/**
 * separate fix `i` from fraction `f`
 * @private
 * @param {Number} float
 * @returns {Array} [i, f]
 *  {Number} i - (int) fix value
 *  {Number} f - (float) fractional portion; always > 1
 */ function modf(float) {
    const i = Math.trunc(float);
    const f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
/**
 * Rounds `float` value by precision
 * @private
 * @param {Number} float - value to round
 * @param {Number} [precision] - (int) number of post decimal positions
 * @return {Number} rounded `float`
 */ function round(float, precision = 10) {
    return parseFloat(float.toFixed(precision));
}
exports.default = {
    Angle,
    HourAngle,
    DMSToDeg,
    degToDMS,
    RA,
    Time,
    angleFromDeg,
    angleFromMin,
    angleFromSec,
    degFromAngle,
    secFromAngle,
    secFromHourAngle
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"argxH":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module globe
 */ /**
 * Globe: Chapter 11, The Earth's Globe.
 *
 * Globe contains functions concerning the surface of the Earth idealized as
 * an ellipsoid of revolution.
 */ /**
 * Ellipsoid represents an ellipsoid of revolution. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ellipsoid", ()=>Ellipsoid);
parcelHelpers.export(exports, "Earth76", ()=>Earth76);
parcelHelpers.export(exports, "RotationRate1996_5", ()=>RotationRate1996_5);
/**
 * oneDegreeOfLongitude returns the length of one degree of longitude.
 *
 * Argument `rp` is the radius in Km of a circle that is a parallel of latitude
 * (as returned by Ellipsoid.radiusAtLatitude.)
 * Result is distance in Km along one degree of the circle.
 *
 * @param {number} rp
 * @return {number} distance in Km
 */ parcelHelpers.export(exports, "oneDegreeOfLongitude", ()=>oneDegreeOfLongitude);
/**
 * oneDegreeOfLatitude returns the length of one degree of latitude.
 *
 * Argument `rm` is the radius in Km of curvature along a meridian.
 * (as returned by Ellipsoid.radiusOfCurvature.)
 * Result is distance in Km along one degree of the meridian.
 *
 * @param {number} rm
 * @return {number} distance in Km
 */ parcelHelpers.export(exports, "oneDegreeOfLatitude", ()=>oneDegreeOfLatitude);
/**
 * geocentricLatitudeDifference returns geographic latitude - geocentric
 * latitude (φ - φ′) with given geographic latitude (φ).
 *
 * Units are radians.
 * @param {number} φ
 * @returns {number} difference in Deg
 */ parcelHelpers.export(exports, "geocentricLatitudeDifference", ()=>geocentricLatitudeDifference);
/**
 * Coord represents geographic coordinates on the Earth.
 *
 * Longitude is measured positively westward from the Greenwich meridian.
 */ parcelHelpers.export(exports, "Coord", ()=>Coord);
/**
 * approxAngularDistance returns the cosine of the angle between two points.
 *
 * The accuracy deteriorates at small angles.
 *
 * @param {Coord} p1 - Point 1
 * @param {Coord} p2 - Point 2
 * @returns {number} cosine `cos` of the angle between two points.
 * Use `d = Math.acos(cos)` to obtain geocentric angular distance in radians
 */ parcelHelpers.export(exports, "approxAngularDistance", ()=>approxAngularDistance);
/**
 * approxLinearDistance computes a distance across the surface of the Earth.
 *
 * Approximating the Earth as a sphere, the function takes a geocentric angular
 * distance in radians and returns the corresponding linear distance in Km.
 *
 * @param {number} d - geocentric angular distance in radians
 * @returns linear distance in Km
 */ parcelHelpers.export(exports, "approxLinearDistance", ()=>approxLinearDistance);
class Ellipsoid {
    /** A is a common identifier for equatorial radius. */ A() {
        return this.radius;
    }
    /** B is a common identifier for polar radius. */ B() {
        return this.radius * (1 - this.flat);
    }
    /** eccentricity of a meridian. */ eccentricity() {
        return Math.sqrt((2 - this.flat) * this.flat);
    }
    /**
   * parallaxConstants computes parallax constants ρ sin φ′ and ρ cos φ′.
   *
   * Arguments are geographic latitude φ in radians and height h
   * in meters above the ellipsoid.
   *
   * @param {number} φ - geographic latitude in radians
   * @param {number} h - height in meters above the ellipsoid
   * @return {number[]} [ρ sin φ′, ρ cos φ] parallax constants [ρsφ, ρcφ]
   */ parallaxConstants(\u03C6, h) {
        const boa = 1 - this.flat;
        const su = Math.sin(Math.atan(boa * Math.tan(\u03C6)));
        const cu = Math.cos(Math.atan(boa * Math.tan(\u03C6)));
        const s = Math.sin(\u03C6);
        const c = Math.cos(\u03C6);
        const hoa = h * 1e-3 / this.radius;
        // (s, c float)
        const \u03C1s\u03C6 = su * boa + hoa * s;
        const \u03C1c\u03C6 = cu + hoa * c;
        return [
            \u03C1s\u03C6,
            \u03C1c\u03C6
        ];
    }
    /**
   * rho is distance from Earth center to a point on the ellipsoid.
   *
   * Result unit is fraction of the equatorial radius.
   * @param {number} φ - geographic latitude in radians
   * @returns {number} // TODO
   */ rho(\u03C6) {
        // Magic numbers...
        return 0.9983271 + 0.0016764 * Math.cos(2 * \u03C6) - 0.0000035 * Math.cos(4 * \u03C6);
    }
    /**
   * radiusAtLatitude returns the radius of the circle that is the parallel of
   * latitude at φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ radiusAtLatitude(\u03C6) {
        const s = Math.sin(\u03C6);
        const c = Math.cos(\u03C6);
        return this.A() * c / Math.sqrt(1 - (2 - this.flat) * this.flat * s * s);
    }
    /**
   * radiusOfCurvature of meridian at latitude φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ radiusOfCurvature(\u03C6) {
        const s = Math.sin(\u03C6);
        const e2 = (2 - this.flat) * this.flat;
        return this.A() * (1 - e2) / Math.pow(1 - e2 * s * s, 1.5);
    }
    /**
   * distance is distance between two points measured along the surface
   * of an ellipsoid.
   *
   * Accuracy is much better than that of approxAngularDistance or
   * approxLinearDistance.
   *
   * Result unit is Km.
   *
   * @param {Coord} c1
   * @param {Coord} c2
   * @return {number} radius in km
   */ distance(c1, c2) {
        // From AA, ch 11, p 84.
        const [s2f, c2f] = sincos2((c1.lat + c2.lat) / 2);
        const [s2g, c2g] = sincos2((c1.lat - c2.lat) / 2);
        const [s2\u03BB, c2\u03BB] = sincos2((c1.lon - c2.lon) / 2);
        const s = s2g * c2\u03BB + c2f * s2\u03BB;
        const c = c2g * c2\u03BB + s2f * s2\u03BB;
        const \u03C9 = Math.atan(Math.sqrt(s / c));
        const r = Math.sqrt(s * c) / \u03C9;
        const d = 2 * \u03C9 * this.radius;
        const h1 = (3 * r - 1) / (2 * c);
        const h2 = (3 * r + 1) / (2 * s);
        return d * (1 + this.flat * (h1 * s2f * c2g - h2 * c2f * s2g));
    }
    /**
   * @param {number} radius - equatorial radius
   * @param {number} flat - ellipsiod flattening
   */ constructor(radius, flat){
        this.radius = radius;
        this.flat = flat;
    }
}
const Earth76 = new Ellipsoid(6378.14, 1 / 298.257);
const RotationRate1996_5 = 7.292114992e-5 // eslint-disable-line camelcase
;
function oneDegreeOfLongitude(rp) {
    return rp * Math.PI / 180;
}
function oneDegreeOfLatitude(rm) {
    return rm * Math.PI / 180;
}
function geocentricLatitudeDifference(\u03C6) {
    // This appears to be an approximation with hard coded magic numbers.
    // No explanation is given in the text. The ellipsoid is not specified.
    // Perhaps the approximation works well enough for all ellipsoids?
    return (692.73 * Math.sin(2 * \u03C6) - 1.16 * Math.sin(4 * \u03C6)) * Math.PI / 648000;
}
class Coord {
    /**
   * @param {number} lat - latitude (φ) in radians
   * @param {number} lon - longitude (ψ, or L) in radians (measured positively westward)
   */ constructor(lat = 0, lon = 0){
        this.lat = lat;
        this.lon = lon;
    }
}
function approxAngularDistance(p1, p2) {
    const s1 = Math.sin(p1.lat);
    const c1 = Math.cos(p1.lat);
    const s2 = Math.sin(p2.lat);
    const c2 = Math.cos(p2.lat);
    return s1 * s2 + c1 * c2 * Math.cos(p1.lon - p2.lon);
}
function approxLinearDistance(d) {
    return 6371 * d;
}
/**
 * @private
 */ function sincos2(x) {
    const s = Math.sin(x);
    const c = Math.cos(x);
    return [
        s * s,
        c * c
    ];
}
exports.default = {
    Ellipsoid,
    Earth76,
    // eslint-disable-next-line camelcase
    RotationRate1996_5,
    oneDegreeOfLongitude,
    oneDegreeOfLatitude,
    geocentricLatitudeDifference,
    Coord,
    approxAngularDistance,
    approxLinearDistance
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fWRWg":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nutation
 */ /**
 * Nutation: Chapter 22, Nutation and the Obliquity of the Ecliptic.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Nutation: Chapter 22, Nutation and the Obliquity of the Ecliptic.
/**
 * Nutation returns nutation in longitude (Δψ) and nutation in obliquity (Δε)
 * for a given JDE.
 *
 * JDE = UT + ΔT, see package.
 *
 * Computation is by 1980 IAU theory, with terms < .0003″ neglected.
 *
 * Result units are radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number[]} [Δψ, Δε] - [longitude, obliquity] in radians
 */ parcelHelpers.export(exports, "nutation", ()=>nutation);
/**
 * ApproxNutation returns a fast approximation of nutation in longitude (Δψ)
 * and nutation in obliquity (Δε) for a given JDE.
 *
 * Accuracy is 0.5″ in Δψ, 0.1″ in Δε.
 *
 * Result units are radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number[]} [Δψ, Δε] - [longitude, obliquity] in radians
 */ parcelHelpers.export(exports, "approxNutation", ()=>approxNutation);
/**
 * MeanObliquity returns mean obliquity (ε₀) following the IAU 1980
 * polynomial.
 *
 * Accuracy is 1″ over the range 1000 to 3000 years and 10″ over the range
 * 0 to 4000 years.
 *
 * Result unit is radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} mean obliquity (ε₀)
 */ parcelHelpers.export(exports, "meanObliquity", ()=>meanObliquity);
/**
 * MeanObliquityLaskar returns mean obliquity (ε₀) following the Laskar
 * 1986 polynomial.
 *
 * Accuracy over the range 1000 to 3000 years is .01″.
 *
 * Accuracy over the valid date range of -8000 to +12000 years is
 * "a few seconds."
 *
 * Result unit is radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} mean obliquity (ε₀)
 */ parcelHelpers.export(exports, "meanObliquityLaskar", ()=>meanObliquityLaskar);
/**
 * NutationInRA returns "nutation in right ascension" or "equation of the
 * equinoxes."
 *
 * Result is an angle in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} nutation in right ascension
 */ parcelHelpers.export(exports, "nutationInRA", ()=>nutationInRA);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
function nutation(jde) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    // Mean elongation of the Moon from the sun
    const D = (0, _baseJsDefault.default).horner(T, 297.85036, 445267.11148, -0.0019142, 1.0 / 189474) * Math.PI / 180;
    // Mean anomaly of the Sun (Earth)
    const M = (0, _baseJsDefault.default).horner(T, 357.52772, 35999.050340, -0.0001603, -1 / 300000) * Math.PI / 180;
    // Mean anomaly of the Moon
    const N = (0, _baseJsDefault.default).horner(T, 134.96298, 477198.867398, 0.0086972, 1.0 / 56250) * Math.PI / 180;
    // Moon's argument of latitude
    const F = (0, _baseJsDefault.default).horner(T, 93.27191, 483202.017538, -0.0036825, 1.0 / 327270) * Math.PI / 180;
    // Longitude of the ascending node of the Moon's mean orbit on the ecliptic, measured from mean equinox of date
    const \u03A9 = (0, _baseJsDefault.default).horner(T, 125.04452, -1934.136261, 0.0020708, 1.0 / 450000) * Math.PI / 180;
    let \u0394\u03C8 = 0;
    let \u0394\u03B5 = 0;
    // sum in reverse order to accumulate smaller terms first
    for(let i = table22A.length - 1; i >= 0; i--){
        const row = table22A[i];
        const arg = row.d * D + row.m * M + row.n * N + row.f * F + row.\u03C9 * \u03A9;
        const [s, c] = (0, _baseJsDefault.default).sincos(arg);
        \u0394\u03C8 += s * (row.s0 + row.s1 * T);
        \u0394\u03B5 += c * (row.c0 + row.c1 * T);
    }
    \u0394\u03C8 *= 0.0001 / 3600 * (Math.PI / 180);
    \u0394\u03B5 *= 0.0001 / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function approxNutation(jde) {
    const T = (jde - (0, _baseJsDefault.default).J2000) / 36525;
    const \u03A9 = (125.04452 - 1934.136261 * T) * Math.PI / 180;
    const L = (280.4665 + 36000.7698 * T) * Math.PI / 180;
    const N = (218.3165 + 481267.8813 * T) * Math.PI / 180;
    const [s\u03A9, c\u03A9] = (0, _baseJsDefault.default).sincos(\u03A9);
    const [s2L, c2L] = (0, _baseJsDefault.default).sincos(2 * L);
    const [s2N, c2N] = (0, _baseJsDefault.default).sincos(2 * N);
    const [s2\u03A9, c2\u03A9] = (0, _baseJsDefault.default).sincos(2 * \u03A9);
    const \u0394\u03C8 = (-17.2 * s\u03A9 - 1.32 * s2L - 0.23 * s2N + 0.21 * s2\u03A9) / 3600 * (Math.PI / 180);
    const \u0394\u03B5 = (9.2 * c\u03A9 + 0.57 * c2L + 0.1 * c2N - 0.09 * c2\u03A9) / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function meanObliquity(jde) {
    // (22.2) p. 147
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), new (0, _sexagesimalJsDefault.default).Angle(false, 23, 26, 21.448).rad(), -46.815 / 3600 * (Math.PI / 180), -0.00059 / 3600 * (Math.PI / 180), 0.001813 / 3600 * (Math.PI / 180));
}
function meanObliquityLaskar(jde) {
    // (22.3) p. 147
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde) * 0.01, new (0, _sexagesimalJsDefault.default).Angle(false, 23, 26, 21.448).rad(), -4680.93 / 3600 * (Math.PI / 180), -1.55 / 3600 * (Math.PI / 180), 1999.25 / 3600 * (Math.PI / 180), -51.38 / 3600 * (Math.PI / 180), -249.67 / 3600 * (Math.PI / 180), -39.05 / 3600 * (Math.PI / 180), 7.12 / 3600 * (Math.PI / 180), 27.87 / 3600 * (Math.PI / 180), 5.79 / 3600 * (Math.PI / 180), 2.45 / 3600 * (Math.PI / 180));
}
function nutationInRA(jde) {
    const [\u0394\u03C8, \u0394\u03B5] = nutation(jde);
    const \u03B50 = meanObliquity(jde);
    return \u0394\u03C8 * Math.cos(\u03B50 + \u0394\u03B5);
}
const table22A = function() {
    const PROPS = "d,m,n,f,\u03C9,s0,s1,c0,c1".split(",");
    const tab = [
        [
            0,
            0,
            0,
            0,
            1,
            -171996,
            -174.2,
            92025,
            8.9
        ],
        [
            -2,
            0,
            0,
            2,
            2,
            -13187,
            -1.6,
            5736,
            -3.1
        ],
        [
            0,
            0,
            0,
            2,
            2,
            -2274,
            -0.2,
            977,
            -0.5
        ],
        [
            0,
            0,
            0,
            0,
            2,
            2062,
            0.2,
            -895,
            0.5
        ],
        [
            0,
            1,
            0,
            0,
            0,
            1426,
            -3.4,
            54,
            -0.1
        ],
        [
            0,
            0,
            1,
            0,
            0,
            712,
            0.1,
            -7,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            2,
            -517,
            1.2,
            224,
            -0.6
        ],
        [
            0,
            0,
            0,
            2,
            1,
            -386,
            -0.4,
            200,
            0
        ],
        [
            0,
            0,
            1,
            2,
            2,
            -301,
            0,
            129,
            -0.1
        ],
        [
            -2,
            -1,
            0,
            2,
            2,
            217,
            -0.5,
            -95,
            0.3
        ],
        [
            -2,
            0,
            1,
            0,
            0,
            -158,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            1,
            129,
            0.1,
            -70,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            2,
            123,
            0,
            -53,
            0
        ],
        [
            2,
            0,
            0,
            0,
            0,
            63,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            0,
            1,
            63,
            0.1,
            -33,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            2,
            -59,
            0,
            26,
            0
        ],
        [
            0,
            0,
            -1,
            0,
            1,
            -58,
            -0.1,
            32,
            0
        ],
        [
            0,
            0,
            1,
            2,
            1,
            -51,
            0,
            27,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            0,
            48,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            1,
            46,
            0,
            -24,
            0
        ],
        [
            2,
            0,
            0,
            2,
            2,
            -38,
            0,
            16,
            0
        ],
        [
            0,
            0,
            2,
            2,
            2,
            -31,
            0,
            13,
            0
        ],
        [
            0,
            0,
            2,
            0,
            0,
            29,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            2,
            29,
            0,
            -12,
            0
        ],
        [
            0,
            0,
            0,
            2,
            0,
            26,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            0,
            -22,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            1,
            21,
            0,
            -10,
            0
        ],
        [
            0,
            2,
            0,
            0,
            0,
            17,
            -0.1,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            0,
            1,
            16,
            0,
            -8,
            0
        ],
        [
            -2,
            2,
            0,
            2,
            2,
            -16,
            0.1,
            7,
            0
        ],
        [
            0,
            1,
            0,
            0,
            1,
            -15,
            0,
            9,
            0
        ],
        [
            -2,
            0,
            1,
            0,
            1,
            -13,
            0,
            7,
            0
        ],
        [
            0,
            -1,
            0,
            0,
            1,
            -12,
            0,
            6,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            0,
            11,
            0,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            1,
            -10,
            0,
            5,
            0
        ],
        [
            2,
            0,
            1,
            2,
            2,
            -8,
            0,
            3,
            0
        ],
        [
            0,
            1,
            0,
            2,
            2,
            7,
            0,
            -3,
            0
        ],
        [
            -2,
            1,
            1,
            0,
            0,
            -7,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            0,
            2,
            2,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            2,
            1,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            1,
            0,
            0,
            6,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            2,
            2,
            2,
            6,
            0,
            -3,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            1,
            6,
            0,
            -3,
            0
        ],
        [
            2,
            0,
            -2,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            0,
            -1,
            1,
            0,
            0,
            5,
            0,
            0,
            0
        ],
        [
            -2,
            -1,
            0,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            0,
            0,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            0,
            0,
            2,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            1,
            4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            1,
            4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            0,
            4,
            0,
            0,
            0
        ],
        [
            -1,
            0,
            1,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            1,
            0,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            2,
            0,
            3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            -1,
            -1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            -1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            3,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            0,
            2,
            2,
            -3,
            0,
            0,
            0
        ]
    ];
    return tab.map((row)=>{
        const o = {};
        PROPS.forEach((p, i)=>{
            o[p] = row[i];
        });
        return o;
    });
}();
exports.default = {
    nutation,
    approxNutation,
    meanObliquity,
    meanObliquityLaskar,
    nutationInRA
};

},{"./base.js":"cO06o","./sexagesimal.js":"1aKkU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"tAZZk":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module precess
 */ /**
 * Precession: Chapter 21, Precession.
 *
 * Functions in this package take Julian epoch argurments rather than Julian
 * days.  Use base.JDEToJulianYear() to convert.
 *
 * Also in package base are some definitions related to the Besselian and
 * Julian Year.
 *
 * Partial:  Precession from FK4 not implemented.  Meeus gives no test cases.
 * It's a fair amount of code and data, representing significant chances for
 * errors.  And precession from FK4 would seem to be of little interest today.
 *
 * Proper motion units
 *
 * Meeus gives some example annual proper motions in units of seconds of
 * right ascension and seconds of declination.  To make units clear,
 * functions in this package take proper motions with argument types of
 * sexa.HourAngle and sexa.Angle respectively.  Error-prone conversions
 * can be avoided by using the constructors for these base types.
 *
 * For example, given an annual proper motion in right ascension of -0ˢ.03847,
 * rather than
 *
 * mra = -0.03847 / 13751 // as Meeus suggests
 *
 * or
 *
 * mra = -0.03847 * (15/3600) * (pi/180) // less magic
 *
 * use
 *
 * mra = new sexa.HourAngle(false, 0, 0, -0.03847)
 *
 * Unless otherwise indicated, functions in this library expect proper motions
 * to be annual proper motions, so the unit denominator is years.
 * (The code, following Meeus's example, technically treats it as Julian years.)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * approxAnnualPrecession returns approximate annual precision in right
 * ascension and declination.
 *
 * The two epochs should be within a few hundred years.
 * The declinations should not be too close to the poles.
 *
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom - use `base.JDEToJulianYear(year)` to get epoch
 * @param {Number} epochTo - use `base.JDEToJulianYear(year)` to get epoch
 * @returns {Object}
 *  {sexa.HourAngle} seconds of right ascension
 *  {sexa.Angle} seconds of Declination
 */ parcelHelpers.export(exports, "approxAnnualPrecession", ()=>approxAnnualPrecession);
/**
 * @param {Number} epochFrom - use `base.JDEToJulianYear(year)` to get epoch
 * @param {Number} epochTo - use `base.JDEToJulianYear(year)` to get epoch
 * @returns {Number[]}
 */ parcelHelpers.export(exports, "mn", ()=>mn);
/**
 * ApproxPosition uses ApproxAnnualPrecession to compute a simple and quick
 * precession while still considering proper motion.
 *
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom
 * @param {Number} epochTo
 * @param {Number} mα - in radians
 * @param {Number} mδ - in radians
 * @returns {Equatorial} eqTo
 */ parcelHelpers.export(exports, "approxPosition", ()=>approxPosition);
/**
 * Precessor represents precession from one epoch to another.
 *
 * Construct with NewPrecessor, then call method Precess.
 * After construction, Precess may be called multiple times to precess
 * different coordinates with the same initial and final epochs.
 */ parcelHelpers.export(exports, "Precessor", ()=>Precessor);
/**
 * Position precesses equatorial coordinates from one epoch to another,
 * including proper motions.
 *
 * If proper motions are not to be considered or are not applicable, pass 0, 0
 * for mα, mδ
 *
 * Both eqFrom and eqTo must be non-nil, although they may point to the same
 * struct.  EqTo is returned for convenience.
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom
 * @param {Number} epochTo
 * @param {Number} mα - in radians
 * @param {Number} mδ - in radians
 * @returns {Equatorial} [eqTo]
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * EclipticPrecessor represents precession from one epoch to another.
 *
 * Construct with NewEclipticPrecessor, then call method Precess.
 * After construction, Precess may be called multiple times to precess
 * different coordinates with the same initial and final epochs.
 */ parcelHelpers.export(exports, "EclipticPrecessor", ()=>EclipticPrecessor);
/**
 * eclipticPosition precesses ecliptic coordinates from one epoch to another,
 * including proper motions.
 * While eclFrom is given as ecliptic coordinates, proper motions mα, mδ are
 * still expected to be equatorial.  If proper motions are not to be considered
 * or are not applicable, pass 0, 0.
 * Both eclFrom and eclTo must be non-nil, although they may point to the same
 * struct.  EclTo is returned for convenience.
 *
 * @param {Ecliptic} eclFrom,
 * @param {Number} epochFrom
 * @param {HourAngle} [mα]
 * @param {Angle} [mδ]
 * @returns {Ecliptic} eclTo
 */ parcelHelpers.export(exports, "eclipticPosition", ()=>eclipticPosition);
/**
 * @param {Number} mα - anual proper motion (ra)
 * @param {Number} mδ - anual proper motion (dec)
 * @param {Number} epoch
 * @param {Ecliptic} ecl
 * @returns {Ecliptic} {lon, lat}
 */ parcelHelpers.export(exports, "properMotion", ()=>properMotion);
/**
 * ProperMotion3D takes the 3D equatorial coordinates of an object
 * at one epoch and computes its coordinates at a new epoch, considering
 * proper motion and radial velocity.
 *
 * Radial distance (r) must be in parsecs, radial velocitiy (mr) in
 * parsecs per year.
 *
 * Both eqFrom and eqTo must be non-nil, although they may point to the same
 * struct.  EqTo is returned for convenience.
 *
 * @param {Equatorial} eqFrom,
 * @param {Number} epochFrom
 * @param {Number} r
 * @param {Number} mr
 * @param {HourAngle} mα
 * @param {Angle} mδ
 * @returns {Equatorial} eqTo
 */ parcelHelpers.export(exports, "properMotion3D", ()=>properMotion3D);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _elementequinoxJs = require("./elementequinox.js");
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _sexagesimalJs = require("./sexagesimal.js");
function approxAnnualPrecession(eqFrom, epochFrom, epochTo) {
    const [m, na, nd] = mn(epochFrom, epochTo);
    const [sa, ca] = (0, _baseJsDefault.default).sincos(eqFrom.ra);
    // (21.1) p. 132
    const \u0394\u03B1s = m + na * sa * Math.tan(eqFrom.dec) // seconds of RA
    ;
    const \u0394\u03B4s = nd * ca // seconds of Dec
    ;
    const ra = new (0, _sexagesimalJs.HourAngle)(false, 0, 0, \u0394\u03B1s).rad();
    const dec = new (0, _sexagesimalJs.Angle)(false, 0, 0, \u0394\u03B4s).rad();
    return {
        ra,
        dec
    };
}
function mn(epochFrom, epochTo) {
    const T = (epochTo - epochFrom) * 0.01;
    const m = 3.07496 + 0.00186 * T;
    const na = 1.33621 - 0.00057 * T;
    const nd = 20.0431 - 0.0085 * T;
    return [
        m,
        na,
        nd
    ];
}
function approxPosition(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const { ra, dec } = approxAnnualPrecession(eqFrom, epochFrom, epochTo);
    const dy = epochTo - epochFrom;
    const eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = eqFrom.ra + (ra + m\u03B1) * dy;
    eqTo.dec = eqFrom.dec + (dec + m\u03B4) * dy;
    return eqTo;
}
// constants
const d = Math.PI / 180;
const s = d / 3600;
// coefficients from (21.2) p. 134
const \u03B6T = [
    2306.2181 * s,
    1.39656 * s,
    -0.000139 * s
];
const zT = [
    2306.2181 * s,
    1.39656 * s,
    -0.000139 * s
];
const \u03B8T = [
    2004.3109 * s,
    -0.8533 * s,
    -0.000217 * s
];
// coefficients from (21.3) p. 134
const \u03B6t = [
    2306.2181 * s,
    0.30188 * s,
    0.017998 * s
];
const zt = [
    2306.2181 * s,
    1.09468 * s,
    0.018203 * s
];
const \u03B8t = [
    2004.3109 * s,
    -0.42665 * s,
    -0.041833 * s
];
class Precessor {
    /**
   * Precess precesses coordinates eqFrom, leaving result in eqTo.
   *
   * @param {Equatorial} eqFrom
   * @returns {Equatorial} eqTo
   */ precess(eqFrom) {
        // (21.4) p. 134
        const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(eqFrom.dec);
        const [s\u03B1\u03B6, c\u03B1\u03B6] = (0, _baseJsDefault.default).sincos(eqFrom.ra + this.\u03B6);
        const A = c\u03B4 * s\u03B1\u03B6;
        const B = this.c\u03B8 * c\u03B4 * c\u03B1\u03B6 - this.s\u03B8 * s\u03B4;
        const C = this.s\u03B8 * c\u03B4 * c\u03B1\u03B6 + this.c\u03B8 * s\u03B4;
        const eqTo = new (0, _coordJs.Equatorial)();
        eqTo.ra = Math.atan2(A, B) + this.z;
        if (C < (0, _baseJsDefault.default).CosSmallAngle) eqTo.dec = Math.asin(C);
        else eqTo.dec = Math.acos(Math.hypot(A, B)) // near pole
        ;
        return eqTo;
    }
    /**
   * constructs a Precessor object and initializes it to precess
   * coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */ constructor(epochFrom, epochTo){
        // (21.2) p. 134
        let \u03B6Coeff = \u03B6t;
        let zCoeff = zt;
        let \u03B8Coeff = \u03B8t;
        if (epochFrom !== 2000) {
            const T = (epochFrom - 2000) * 0.01;
            \u03B6Coeff = [
                (0, _baseJsDefault.default).horner(T, ...\u03B6T),
                0.30188 * s - 0.000344 * s * T,
                0.017998 * s
            ];
            zCoeff = [
                (0, _baseJsDefault.default).horner(T, ...zT),
                1.09468 * s + 0.000066 * s * T,
                0.018203 * s
            ];
            \u03B8Coeff = [
                (0, _baseJsDefault.default).horner(T, ...\u03B8T),
                -0.42665 * s - 0.000217 * s * T,
                -0.041833 * s
            ];
        }
        const t = (epochTo - epochFrom) * 0.01;
        this.\u03B6 = (0, _baseJsDefault.default).horner(t, ...\u03B6Coeff) * t;
        this.z = (0, _baseJsDefault.default).horner(t, ...zCoeff) * t;
        const \u03B8 = (0, _baseJsDefault.default).horner(t, ...\u03B8Coeff) * t;
        this.s\u03B8 = Math.sin(\u03B8);
        this.c\u03B8 = Math.cos(\u03B8);
    }
}
function position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const p = new Precessor(epochFrom, epochTo);
    const t = epochTo - epochFrom;
    const eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = eqFrom.ra + m\u03B1 * t;
    eqTo.dec = eqFrom.dec + m\u03B4 * t;
    return p.precess(eqTo);
}
// coefficients from (21.5) p. 136
const \u03B7T = [
    47.0029 * s,
    -0.06603 * s,
    0.000598 * s
];
const \u03C0T = [
    174.876384 * d,
    3289.4789 * s,
    0.60622 * s
];
const pT = [
    5029.0966 * s,
    2.22226 * s,
    -0.000042 * s
];
const \u03B7t = [
    47.0029 * s,
    -0.03302 * s,
    0.000060 * s
];
const \u03C0t = [
    174.876384 * d,
    -869.8089 * s,
    0.03536 * s
];
const pt = [
    5029.0966 * s,
    1.11113 * s,
    -0.000006 * s
];
class EclipticPrecessor {
    /**
   * EclipticPrecess precesses coordinates eclFrom, leaving result in eclTo.
   *
   * The same struct may be used for eclFrom and eclTo.
   * EclTo is returned for convenience.
   * @param {Ecliptic} eclFrom
   * @returns {Ecliptic} [eclTo]
   */ precess(eclFrom) {
        // (21.7) p. 137
        const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(eclFrom.lat);
        const [sd, cd] = (0, _baseJsDefault.default).sincos(this.\u03C0 - eclFrom.lon);
        const A = this.c\u03B7 * c\u03B2 * sd - this.s\u03B7 * s\u03B2;
        const B = c\u03B2 * cd;
        const C = this.c\u03B7 * s\u03B2 + this.s\u03B7 * c\u03B2 * sd;
        const eclTo = new (0, _coordJs.Ecliptic)(this.p + this.\u03C0 - Math.atan2(A, B));
        if (C < (0, _baseJsDefault.default).CosSmallAngle) eclTo.lat = Math.asin(C);
        else eclTo.lat = Math.acos(Math.hypot(A, B)) // near pole
        ;
        return eclTo;
    }
    /**
   * ReduceElements reduces orbital elements of a solar system body from one
   * equinox to another.
   *
   * This function is described in chapter 24, but is located in this
   * package so it can be a method of EclipticPrecessor.
   *
   * @param {Elements} eFrom
   * @returns {Elements} eTo
   */ reduceElements(eFrom) {
        const \u03C8 = this.\u03C0 + this.p;
        const [si, ci] = (0, _baseJsDefault.default).sincos(eFrom.inc);
        const [snp, cnp] = (0, _baseJsDefault.default).sincos(eFrom.node - this.\u03C0);
        const eTo = new (0, _elementequinoxJs.Elements)();
        // (24.1) p. 159
        eTo.inc = Math.acos(ci * this.c\u03B7 + si * this.s\u03B7 * cnp);
        // (24.2) p. 159
        eTo.node = Math.atan2(si * snp, this.c\u03B7 * si * cnp - this.s\u03B7 * ci) + \u03C8;
        // (24.3) p. 159
        eTo.peri = Math.atan2(-this.s\u03B7 * snp, si * this.c\u03B7 - ci * this.s\u03B7 * cnp) + eFrom.peri;
        return eTo;
    }
    /**
   * constructs an EclipticPrecessor object and initializes
   * it to precess coordinates from epochFrom to epochTo.
   * @param {Number} epochFrom
   * @param {Number} epochTo
   */ constructor(epochFrom, epochTo){
        // (21.5) p. 136
        let \u03B7Coeff = \u03B7t;
        let \u03C0Coeff = \u03C0t;
        let pCoeff = pt;
        if (epochFrom !== 2000) {
            const T = (epochFrom - 2000) * 0.01;
            \u03B7Coeff = [
                (0, _baseJsDefault.default).horner(T, ...\u03B7T),
                -0.03302 * s + 0.000598 * s * T,
                0.000060 * s
            ];
            \u03C0Coeff = [
                (0, _baseJsDefault.default).horner(T, ...\u03C0T),
                -869.8089 * s - 0.50491 * s * T,
                0.03536 * s
            ];
            pCoeff = [
                (0, _baseJsDefault.default).horner(T, ...pT),
                1.11113 * s - 0.000042 * s * T,
                -0.000006 * s
            ];
        }
        const t = (epochTo - epochFrom) * 0.01;
        this.\u03C0 = (0, _baseJsDefault.default).horner(t, ...\u03C0Coeff);
        this.p = (0, _baseJsDefault.default).horner(t, ...pCoeff) * t;
        const \u03B7 = (0, _baseJsDefault.default).horner(t, ...\u03B7Coeff) * t;
        this.s\u03B7 = Math.sin(\u03B7);
        this.c\u03B7 = Math.cos(\u03B7);
    }
}
function eclipticPosition(eclFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    const p = new EclipticPrecessor(epochFrom, epochTo);
    if (m\u03B1 && m\u03B4 && (m\u03B1.rad() !== 0 || m\u03B4.rad() !== 0)) {
        const { lon, lat } = properMotion(m\u03B1.rad(), m\u03B4.rad(), epochFrom, eclFrom);
        const t = epochTo - epochFrom;
        eclFrom.lon += lon * t;
        eclFrom.lat += lat * t;
    }
    return p.precess(eclFrom);
}
function properMotion(m\u03B1, m\u03B4, epoch, ecl) {
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity((0, _baseJsDefault.default).JulianYearToJDE(epoch));
    const [\u03B5sin, \u03B5cos] = (0, _baseJsDefault.default).sincos(\u03B5);
    const { ra, dec } = ecl.toEquatorial(\u03B5);
    const [s\u03B1, c\u03B1] = (0, _baseJsDefault.default).sincos(ra);
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(dec);
    const c\u03B2 = Math.cos(ecl.lat);
    const lon = (m\u03B4 * \u03B5sin * c\u03B1 + m\u03B1 * c\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1)) / (c\u03B2 * c\u03B2);
    const lat = (m\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1) - m\u03B1 * \u03B5sin * c\u03B1 * c\u03B4) / c\u03B2;
    return new (0, _coordJs.Ecliptic)(lon, lat);
}
function properMotion3D(eqFrom, epochFrom, epochTo, r, mr, m\u03B1, m\u03B4) {
    const [s\u03B1, c\u03B1] = (0, _baseJsDefault.default).sincos(eqFrom.ra);
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(eqFrom.dec);
    const x = r * c\u03B4 * c\u03B1;
    const y = r * c\u03B4 * s\u03B1;
    const z = r * s\u03B4;
    const mrr = mr / r;
    const zm\u03B4 = z * m\u03B4.rad();
    const mx = x * mrr - zm\u03B4 * c\u03B1 - y * m\u03B1.rad();
    const my = y * mrr - zm\u03B4 * s\u03B1 + x * m\u03B1.rad();
    const mz = z * mrr + r * m\u03B4.rad() * c\u03B4;
    const t = epochTo - epochFrom;
    const xp = x + t * mx;
    const yp = y + t * my;
    const zp = z + t * mz;
    const eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = Math.atan2(yp, xp);
    eqTo.dec = Math.atan2(zp, Math.hypot(xp, yp));
    return eqTo;
}
exports.default = {
    approxAnnualPrecession,
    mn,
    approxPosition,
    Precessor,
    position,
    EclipticPrecessor,
    eclipticPosition,
    properMotion,
    properMotion3D
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./elementequinox.js":"bX2E4","./nutation.js":"fWRWg","./sexagesimal.js":"1aKkU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bX2E4":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elementequinox
 */ /**
 * Elementequinox: Chapter 24, Reduction of Ecliptical Elements
 * from one Equinox to another one.
 *
 * See package precess for the method EclipticPrecessor.ReduceElements and
 * associated example.  The method is described in this chapter but located
 * in package precess so that it can be a method of EclipticPrecessor.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Elements are the orbital elements of a solar system object which change
 * from one equinox to another.
 *
 * @param {Number} inc  - inclination
 * @param {Number} node - longitude of ascending node (Ω)
 * @param {Number} peri - argument of perihelion (ω)
 */ parcelHelpers.export(exports, "Elements", ()=>Elements);
/**
 * ReduceB1950ToJ2000 reduces orbital elements of a solar system body from
 * equinox B1950 to J2000.
 *
 * @param {Elements} eFrom
 * @returns {Elements} eTo
 */ parcelHelpers.export(exports, "reduceB1950ToJ2000", ()=>reduceB1950ToJ2000);
/**
 * ReduceB1950ToJ2000 reduces orbital elements of a solar system body from
 * equinox B1950 in the FK4 system to equinox J2000 in the FK5 system.
 *
 * @param {Elements} eFrom
 * @returns {Elements} eTo
 */ parcelHelpers.export(exports, "reduceB1950FK4ToJ2000FK5", ()=>reduceB1950FK4ToJ2000FK5);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
class Elements {
    constructor(inc, node, peri){
        if (typeof inc === "object") {
            node = inc.pode;
            peri = inc.peri;
            inc = inc.inc;
        }
        this.inc = inc || 0;
        this.node = node || 0;
        this.peri = peri || 0;
    }
}
// (24.4) p. 161
const S = 0.0001139788;
const C = 0.9999999935;
function reduceB1950ToJ2000(eFrom) {
    const W = eFrom.node - 174.298782 * Math.PI / 180;
    const [si, ci] = (0, _baseJsDefault.default).sincos(eFrom.inc);
    const [sW, cW] = (0, _baseJsDefault.default).sincos(W);
    const A = si * sW;
    const B = C * si * cW - S * ci;
    const eTo = new Elements();
    eTo.inc = Math.asin(Math.hypot(A, B));
    eTo.node = (0, _baseJsDefault.default).pmod(174.997194 * Math.PI / 180 + Math.atan2(A, B), 2 * Math.PI);
    eTo.peri = (0, _baseJsDefault.default).pmod(eFrom.peri + Math.atan2(-S * sW, C * si - S * ci * cW), 2 * Math.PI);
    return eTo;
}
const Lp = 4.50001688 * Math.PI / 180;
const L = 5.19856209 * Math.PI / 180;
const J = 0.00651966 * Math.PI / 180;
function reduceB1950FK4ToJ2000FK5(eFrom) {
    const W = L + eFrom.node;
    const [si, ci] = (0, _baseJsDefault.default).sincos(eFrom.inc);
    const [sJ, cJ] = (0, _baseJsDefault.default).sincos(J);
    const [sW, cW] = (0, _baseJsDefault.default).sincos(W);
    const eTo = new Elements();
    eTo.inc = Math.acos(ci * cJ - si * sJ * cW);
    eTo.node = (0, _baseJsDefault.default).pmod(Math.atan2(si * sW, ci * sJ + si * cJ * cW) - Lp, 2 * Math.PI);
    eTo.peri = (0, _baseJsDefault.default).pmod(eFrom.peri + Math.atan2(sJ * sW, si * cJ + ci * sJ * cW), 2 * Math.PI);
    return eTo;
}
exports.default = {
    Elements,
    reduceB1950ToJ2000,
    reduceB1950FK4ToJ2000FK5
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aC6LU":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solar
 */ /**
 * Solar: Chapter 25, Solar Coordinates.
 *
 * Partial implementation:
 *
 * 1. Higher accuracy positions are not computed with Appendix III but with
 * full VSOP87 as implemented in package planetposition.
 *
 * 2. Higher accuracy correction for aberration (using the formula for
 * variation Δλ on p. 168) is not implemented.  Results for example 25.b
 * already match the full VSOP87 values on p. 165 even with the low accuracy
 * correction for aberration, thus there are no more significant digits that
 * would check a more accurate result.  Also the size of the formula presents
 * significant chance of typographical error.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True returns true geometric longitude and anomaly of the sun referenced to the mean equinox of date.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Object}
 *   {Number} lon = true geometric longitude, ☉, in radians
 *   {Number} ano = true anomaly in radians
 */ parcelHelpers.export(exports, "trueLongitude", ()=>trueLongitude);
/**
 * meanAnomaly returns the mean anomaly of Earth at the given T.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} Result is in radians and is not normalized to the range 0..2π.
 */ parcelHelpers.export(exports, "meanAnomaly", ()=>meanAnomaly);
/**
 * eccentricity returns eccentricity of the Earth's orbit around the sun.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} eccentricity of the Earth's orbit around the sun.
 */ parcelHelpers.export(exports, "eccentricity", ()=>eccentricity);
/**
 * Radius returns the Sun-Earth distance in AU.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} Sun-Earth distance in AU
 */ parcelHelpers.export(exports, "radius", ()=>radius);
/**
 * ApparentLongitude returns apparent longitude of the Sun referenced to the true equinox of date.
 * Result includes correction for nutation and aberration.  Unit is radians.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} apparent longitude of the Sun referenced to the true equinox of date.
 */ parcelHelpers.export(exports, "apparentLongitude", ()=>apparentLongitude);
/**
 * true2000 returns true geometric longitude and anomaly of the sun referenced to equinox J2000.
 * Results are accurate to .01 degree for years 1900 to 2100.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Object}
 *   {Number} lon - true geometric longitude, ☉, in radians
 *   {Number} ano - true anomaly in radians
 */ parcelHelpers.export(exports, "true2000", ()=>true2000);
/**
 * trueEquatorial returns the true geometric position of the Sun as equatorial coordinates.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 */ parcelHelpers.export(exports, "trueEquatorial", ()=>trueEquatorial);
/**
 * apparentEquatorial returns the apparent position of the Sun as equatorial coordinates.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 */ parcelHelpers.export(exports, "apparentEquatorial", ()=>apparentEquatorial);
/**
 * trueVSOP87 returns the true geometric position of the sun as ecliptic coordinates.
 *
 * Result computed by full VSOP87 theory.  Result is at equator and equinox
 * of date in the FK5 frame.  It does not include nutation or aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Object}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "trueVSOP87", ()=>trueVSOP87);
/**
 * apparentVSOP87 returns the apparent position of the sun as ecliptic coordinates.
 *
 * Result computed by VSOP87, at equator and equinox of date in the FK5 frame,
 * and includes effects of nutation and aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "apparentVSOP87", ()=>apparentVSOP87);
/**
 * apparentEquatorialVSOP87 returns the apparent position of the sun as equatorial coordinates.
 *
 * Result computed by VSOP87, at equator and equinox of date in the FK5 frame,
 * and includes effects of nutation and aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "apparentEquatorialVSOP87", ()=>apparentEquatorialVSOP87);
/**
 * Low precision formula.  The high precision formula is not implemented
 * because the low precision formula already gives position results to the
 * accuracy given on p. 165.  The high precision formula represents lots
 * of typing with associated chance of typos, and no way to test the result.
 * @param {Number} range
 * @returns {Number} aberation
 */ parcelHelpers.export(exports, "aberration", ()=>aberration);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
function trueLongitude(T) {
    // (25.2) p. 163
    const L0 = (0, _baseJsDefault.default).horner(T, 280.46646, 36000.76983, 0.0003032) * Math.PI / 180;
    const m = meanAnomaly(T);
    const C = ((0, _baseJsDefault.default).horner(T, 1.914602, -0.004817, -0.000014) * Math.sin(m) + (0.019993 - 0.000101 * T) * Math.sin(2 * m) + 0.000289 * Math.sin(3 * m)) * Math.PI / 180;
    const lon = (0, _baseJsDefault.default).pmod(L0 + C, 2 * Math.PI);
    const ano = (0, _baseJsDefault.default).pmod(m + C, 2 * Math.PI);
    return {
        lon,
        ano
    };
}
function meanAnomaly(T) {
    // (25.3) p. 163
    return (0, _baseJsDefault.default).horner(T, 357.52911, 35999.05029, -0.0001537) * Math.PI / 180;
}
function eccentricity(T) {
    // (25.4) p. 163
    return (0, _baseJsDefault.default).horner(T, 0.016708634, -0.000042037, -0.0000001267);
}
function radius(T) {
    const { lon, ano } = trueLongitude(T) // eslint-disable-line
    ;
    const e = eccentricity(T);
    // (25.5) p. 164
    return 1.000001018 * (1 - e * e) / (1 + e * Math.cos(ano));
}
function apparentLongitude(T) {
    const \u03A9 = node(T);
    const { lon, ano } = trueLongitude(T) // eslint-disable-line
    ;
    return lon - 0.00569 * Math.PI / 180 - 0.00478 * Math.PI / 180 * Math.sin(\u03A9);
}
/**
 * @private
 */ function node(T) {
    return 125.04 * Math.PI / 180 - 1934.136 * Math.PI / 180 * T;
}
function true2000(T) {
    let { lon, ano } = trueLongitude(T);
    lon -= 0.01397 * Math.PI / 180 * T * 100;
    return {
        lon,
        ano
    };
}
function trueEquatorial(jde) {
    const { lon, ano } = trueLongitude((0, _baseJsDefault.default).J2000Century(jde)) // eslint-disable-line
    ;
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    const [ss, cs] = (0, _baseJsDefault.default).sincos(lon);
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    // (25.6, 25.7) p. 165
    const ra = Math.atan2(c\u03B5 * ss, cs);
    const dec = s\u03B5 * ss;
    return new (0, _baseJsDefault.default).Coord(ra, dec);
}
function apparentEquatorial(jde) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const \u03BB = apparentLongitude(T);
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    const [s\u03BB, c\u03BB] = (0, _baseJsDefault.default).sincos(\u03BB);
    // (25.8) p. 165
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5 + 0.00256 * Math.PI / 180 * Math.cos(node(T)));
    const ra = Math.atan2(c\u03B5 * s\u03BB, c\u03BB);
    const dec = Math.asin(s\u03B5 * s\u03BB);
    return new (0, _baseJsDefault.default).Coord(ra, dec);
}
function trueVSOP87(planet, jde) {
    let { lon, lat, range } = planet.position(jde);
    const s = lon + Math.PI;
    // FK5 correction.
    const \u03BBp = (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), s, -1.397 * Math.PI / 180, -0.00031 * Math.PI / 180);
    const [s\u03BBp, c\u03BBp] = (0, _baseJsDefault.default).sincos(\u03BBp);
    const \u0394\u03B2 = 0.03916 / 3600 * Math.PI / 180 * (c\u03BBp - s\u03BBp);
    // (25.9) p. 166
    lon = (0, _baseJsDefault.default).pmod(s - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
    lat = \u0394\u03B2 - lat;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
function apparentVSOP87(planet, jde) {
    // note: see duplicated code in ApparentEquatorialVSOP87.
    let { lon, lat, range } = trueVSOP87(planet, jde);
    const \u0394\u03C8 = (0, _nutationJsDefault.default).nutation(jde)[0];
    const a = aberration(range);
    lon = lon + \u0394\u03C8 + a;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
function apparentEquatorialVSOP87(planet, jde) {
    // note: duplicate code from ApparentVSOP87 so we can keep Δε.
    // see also duplicate code in time.E().
    const { lon, lat, range } = trueVSOP87(planet, jde);
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
    const a = aberration(range);
    const \u03BB = lon + \u0394\u03C8 + a;
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    const { ra, dec } = new (0, _coordJsDefault.default).Ecliptic(\u03BB, lat).toEquatorial(\u03B5);
    return new (0, _baseJs.Coord)(ra, dec, range);
}
function aberration(range) {
    // (25.10) p. 167
    return -20.4898 / 3600 * Math.PI / 180 / range;
}
exports.default = {
    trueLongitude,
    true: trueLongitude,
    meanAnomaly,
    eccentricity,
    radius,
    apparentLongitude,
    true2000,
    trueEquatorial,
    apparentEquatorial,
    trueVSOP87,
    apparentVSOP87,
    apparentEquatorialVSOP87,
    aberration
};

},{"./base.js":"cO06o","./planetposition.js":"cfC43","./coord.js":"1Ze6D","./nutation.js":"fWRWg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cfC43":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetposition
 */ /**
 * Planetposition: Chapter 32, Positions of the Planets.
 *
 * Incomplete:
 *
 * 1. The package does not implement algorithms that use appendix III,
 * but instead implements a full VSOP87 solution.  I do not have a copy
 * of the supplimentary disk with appendix III in machine readable form
 * and as the appendix is rather large, retyping it by hand is problematic.
 * The full VSOP87 data set on the other hand is freely downloadable from
 * the internet, so I implement here code that can use that data directly.
 *
 * 2. The formula for accuracy of results is not implemented.  It is
 * not needed for full VSOP87 solutions.
 *
 * 3. Polynomial expressions are not implemented.  Again, implementation
 * would involve typing rather large tables of numbers with associated
 * risk of typographical errors.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Planet", ()=>Planet);
/**
 * ToFK5 converts ecliptic longitude and latitude from dynamical frame to FK5.
 *
 * @param {Number} lon - ecliptic longitude in radians
 * @param {Number} lat - ecliptic latitude in radians
 * @param {Number} jde - Julian ephemeris day
 * @return {Coord}
 *    {Number} lon - FK5 longitude
 *    {Number} lat - FK5 latitude
 */ parcelHelpers.export(exports, "toFK5", ()=>toFK5);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
function sum(t, series) {
    const coeffs = [];
    Object.keys(series).forEach((x)=>{
        coeffs[x] = 0;
        let y = series[x].length - 1;
        for(y; y >= 0; y--){
            const term = {
                a: series[x][y][0],
                b: series[x][y][1],
                c: series[x][y][2]
            };
            coeffs[x] += term.a * Math.cos(term.b + term.c * t);
        }
    });
    const res = (0, _baseJsDefault.default).horner(t, ...coeffs);
    return res;
}
class Planet {
    /**
   * Position2000 returns ecliptic position of planets by full VSOP87 theory.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are for the dynamical equinox and ecliptic J2000.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ position2000(jde) {
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const \u03C4 = T * 0.1;
        const lon = (0, _baseJsDefault.default).pmod(sum(\u03C4, this.series.L), 2 * Math.PI);
        const lat = sum(\u03C4, this.series.B);
        const range = sum(\u03C4, this.series.R);
        switch(this.type){
            case "B":
                return new (0, _baseJsDefault.default).Coord(lon, lat, range);
            case "D":
                {
                    const eclFrom = new (0, _coordJsDefault.default).Ecliptic(lon, lat);
                    const epochFrom = (0, _baseJsDefault.default).JDEToJulianYear(jde);
                    const epochTo = 2000.0;
                    const eclTo = (0, _precessJsDefault.default).eclipticPosition(eclFrom, epochFrom, epochTo);
                    return new (0, _baseJsDefault.default).Coord(eclTo.lon, eclTo.lat, range);
                }
        }
    }
    /**
   * Position returns ecliptic position of planets at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those from Meeus's
   * Apendix III, that is, at equinox and ecliptic of date.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ position(jde) {
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const \u03C4 = T * 0.1;
        const lon = (0, _baseJsDefault.default).pmod(sum(\u03C4, this.series.L), 2 * Math.PI);
        const lat = sum(\u03C4, this.series.B);
        const range = sum(\u03C4, this.series.R);
        switch(this.type){
            case "B":
                {
                    const eclFrom = new (0, _coordJsDefault.default).Ecliptic(lon, lat);
                    const epochFrom = 2000.0;
                    const epochTo = (0, _baseJsDefault.default).JDEToJulianYear(jde);
                    const eclTo = (0, _precessJsDefault.default).eclipticPosition(eclFrom, epochFrom, epochTo);
                    return new (0, _baseJsDefault.default).Coord(eclTo.lon, eclTo.lat, range);
                }
            case "D":
                return new (0, _baseJsDefault.default).Coord(lon, lat, range);
        }
    }
    /**
   * VSOP87 representation of a Planet
   * @constructs Planet
   * @param {object} planet - planet data series
   * @example
   * ```js
   * // for use in browser
   * import {data} from 'astronomia'
   * const earth = new planetposition.Planet(data.vsop87Bearth)
   * ```
   */ constructor(planet){
        if (typeof planet !== "object") throw new TypeError("need planet vsop87 data");
        this.name = planet.name;
        this.type = planet.type || "B";
        this.series = planet;
    }
}
function toFK5(lon, lat, jde) {
    // formula 32.3, p. 219.
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    // const Lp = lon - 1.397 * Math.PI / 180 * T - 0.00031 * Math.PI / 180 * T * T
    const Lp = lon - (0, _sexagesimalJsDefault.default).angleFromDeg((1.397 + 0.00031 * T) * T);
    const [sLp, cLp] = (0, _baseJsDefault.default).sincos(Lp);
    // (32.3) p. 219
    const L5 = lon + (0, _sexagesimalJsDefault.default).angleFromSec(-0.09033 + 0.03916 * (cLp + sLp) * Math.tan(lat));
    const B5 = lat + (0, _sexagesimalJsDefault.default).angleFromSec(0.03916 * (cLp - sLp));
    return new (0, _baseJsDefault.default).Coord(L5, B5);
}
exports.default = {
    Planet,
    toFK5
};

},{"./base.js":"cO06o","./sexagesimal.js":"1aKkU","./coord.js":"1Ze6D","./precess.js":"tAZZk","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1L1AY":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apsis
 */ /**
 * Apsis: Chapter 50, Perigee and apogee of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EARTH_RADIUS", ()=>EARTH_RADIUS);
parcelHelpers.export(exports, "MOON_RADIUS", ()=>MOON_RADIUS);
/**
 * meanPerigee returns the jde of the mean perigee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "meanPerigee", ()=>meanPerigee);
/**
 * perigee returns the jde of perigee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "perigee", ()=>perigee);
/**
 * meanApogee returns the jde of the mean apogee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "meanApogee", ()=>meanApogee);
/**
 * apogee returns the jde of apogee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "apogee", ()=>apogee);
/**
 * apogeeParallax returns equatorial horizontal parallax of the Moon at the Apogee nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} equatorial horizontal parallax in radians
 */ parcelHelpers.export(exports, "apogeeParallax", ()=>apogeeParallax);
/**
 * perigeeParallax returns equatorial horizontal parallax of the Moon at the Apogee nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} equatorial horizontal parallax in radians
 */ parcelHelpers.export(exports, "perigeeParallax", ()=>perigeeParallax);
/**
 * Calculate the distance earth - moon (center to center) using the parallax angle in radians
 *
 * @param {Number} parallax - parallax angle in radians
 * @return {Number} distance in `km`
 */ parcelHelpers.export(exports, "distance", ()=>distance);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const { sin, cos } = Math;
/**
 * conversion factor from k to T, given in (50.3) p. 356
 */ const ck = 1 / 1325.55;
const D2R = Math.PI / 180;
const EARTH_RADIUS = 6378.137 // km
;
const MOON_RADIUS = 1738.1 // km
;
/**
 * mean time of perigee or apogee
 * (50.1) p. 355
 */ const mean = function(T) {
    return (0, _baseJsDefault.default).horner(T, 2451534.6698, 27.55454989 / ck, -0.0006691, -0.000001098, 0.0000000052);
};
/**
 * snap returns k at half h nearest year y.
 */ const snap = function(y, h) {
    const k = (y - 1999.97) * 13.2555 // (50.2) p. 355
    ;
    return Math.floor(k - h + 0.5) + h;
};
function meanPerigee(year) {
    return mean(snap(year, 0) * ck);
}
function perigee(year) {
    const l = new La(year, 0);
    return mean(l.T) + l.perigeeCorr();
}
function meanApogee(year) {
    return mean(snap(year, 0.5) * ck);
}
function apogee(year) {
    const l = new La(year, 0.5);
    return mean(l.T) + l.apogeeCorr();
}
function apogeeParallax(year) {
    return new La(year, 0.5).apogeeParallax();
}
function perigeeParallax(year) {
    return new La(year, 0).perigeeParallax();
}
function distance(parallax) {
    return EARTH_RADIUS / sin(parallax);
}
class La {
    /**
   * perigee correction
   */ perigeeCorr() {
        const l = this;
        return -1.6769 * sin(2 * l.D) + 0.4589 * sin(4 * l.D) + -0.1856 * sin(6 * l.D) + 0.0883 * sin(8 * l.D) + (-0.0773 + 0.00019 * l.T) * sin(2 * l.D - l.M) + (0.0502 - 0.00013 * l.T) * sin(l.M) + -0.046 * sin(10 * l.D) + (0.0422 - 0.00011 * l.T) * sin(4 * l.D - l.M) + -0.0256 * sin(6 * l.D - l.M) + 0.0253 * sin(12 * l.D) + 0.0237 * sin(l.D) + 0.0162 * sin(8 * l.D - l.M) + -0.0145 * sin(14 * l.D) + 0.0129 * sin(2 * l.F) + -0.0112 * sin(3 * l.D) + -0.0104 * sin(10 * l.D - l.M) + 0.0086 * sin(16 * l.D) + 0.0069 * sin(12 * l.D - l.M) + 0.0066 * sin(5 * l.D) + -0.0053 * sin(2 * (l.D + l.F)) + -0.0052 * sin(18 * l.D) + -0.0046 * sin(14 * l.D - l.M) + -0.0041 * sin(7 * l.D) + 0.004 * sin(2 * l.D + l.M) + 0.0032 * sin(20 * l.D) + -0.0032 * sin(l.D + l.M) + 0.0031 * sin(16 * l.D - l.M) + -0.0029 * sin(4 * l.D + l.M) + 0.0027 * sin(9 * l.D) + 0.0027 * sin(4 * l.D + 2 * l.F) + -0.0027 * sin(2 * (l.D - l.M)) + 0.0024 * sin(4 * l.D - 2 * l.M) + -0.0021 * sin(6 * l.D - 2 * l.M) + -0.0021 * sin(22 * l.D) + -0.0021 * sin(18 * l.D - l.M) + 0.0019 * sin(6 * l.D + l.M) + -0.0018 * sin(11 * l.D) + -0.0014 * sin(8 * l.D + l.M) + -0.0014 * sin(4 * l.D - 2 * l.F) + -0.0014 * sin(6 * l.D + 2 * l.F) + 0.0014 * sin(3 * l.D + l.M) + -0.0014 * sin(5 * l.D + l.M) + 0.0013 * sin(13 * l.D) + 0.0013 * sin(20 * l.D - l.M) + 0.0011 * sin(3 * l.D + 2 * l.M) + -0.0011 * sin(2 * (2 * l.D + l.F - l.M)) + -0.001 * sin(l.D + 2 * l.M) + -0.0009 * sin(22 * l.D - l.M) + -0.0008 * sin(4 * l.F) + 0.0008 * sin(6 * l.D - 2 * l.F) + 0.0008 * sin(2 * (l.D - l.F) + l.M) + 0.0007 * sin(2 * l.M) + 0.0007 * sin(2 * l.F - l.M) + 0.0007 * sin(2 * l.D + 4 * l.F) + -0.0006 * sin(2 * (l.F - l.M)) + -0.0006 * sin(2 * (l.D - l.F + l.M)) + 0.0006 * sin(24 * l.D) + 0.0005 * sin(4 * (l.D - l.F)) + 0.0005 * sin(2 * (l.D + l.M)) + -0.0004 * sin(l.D - l.M);
    }
    /**
   * apogee correction
   */ apogeeCorr() {
        const l = this;
        return 0.4392 * sin(2 * l.D) + 0.0684 * sin(4 * l.D) + (0.0456 - 0.00011 * l.T) * sin(l.M) + (0.0426 - 0.00011 * l.T) * sin(2 * l.D - l.M) + 0.0212 * sin(2 * l.F) + -0.0189 * sin(l.D) + 0.0144 * sin(6 * l.D) + 0.0113 * sin(4 * l.D - l.M) + 0.0047 * sin(2 * (l.D + l.F)) + 0.0036 * sin(l.D + l.M) + 0.0035 * sin(8 * l.D) + 0.0034 * sin(6 * l.D - l.M) + -0.0034 * sin(2 * (l.D - l.F)) + 0.0022 * sin(2 * (l.D - l.M)) + -0.0017 * sin(3 * l.D) + 0.0013 * sin(4 * l.D + 2 * l.F) + 0.0011 * sin(8 * l.D - l.M) + 0.001 * sin(4 * l.D - 2 * l.M) + 0.0009 * sin(10 * l.D) + 0.0007 * sin(3 * l.D + l.M) + 0.0006 * sin(2 * l.M) + 0.0005 * sin(2 * l.D + l.M) + 0.0005 * sin(2 * (l.D + l.M)) + 0.0004 * sin(6 * l.D + 2 * l.F) + 0.0004 * sin(6 * l.D - 2 * l.M) + 0.0004 * sin(10 * l.D - l.M) + -0.0004 * sin(5 * l.D) + -0.0004 * sin(4 * l.D - 2 * l.F) + 0.0003 * sin(2 * l.F + l.M) + 0.0003 * sin(12 * l.D) + 0.0003 * sin(2 * l.D + 2 * l.F - l.M) + -0.0003 * sin(l.D - l.M);
    }
    /**
   * apogee parallax
   */ apogeeParallax() {
        const s = Math.PI / 180 / 3600;
        const l = this;
        return 3245.251 * s + -9.147 * s * cos(2 * l.D) + -0.841 * s * cos(l.D) + 0.697 * s * cos(2 * l.F) + (-0.656 * s + 0.0016 * s * l.T) * cos(l.M) + 0.355 * s * cos(4 * l.D) + 0.159 * s * cos(2 * l.D - l.M) + 0.127 * s * cos(l.D + l.M) + 0.065 * s * cos(4 * l.D - l.M) + 0.052 * s * cos(6 * l.D) + 0.043 * s * cos(2 * l.D + l.M) + 0.031 * s * cos(2 * (l.D + l.F)) + -0.023 * s * cos(2 * (l.D - l.F)) + 0.022 * s * cos(2 * (l.D - l.M)) + 0.019 * s * cos(2 * (l.D + l.M)) + -0.016 * s * cos(2 * l.M) + 0.014 * s * cos(6 * l.D - l.M) + 0.01 * s * cos(8 * l.D);
    }
    /**
   * perigee parallax
   */ perigeeParallax() {
        const s = Math.PI / 180 / 3600;
        const l = this;
        return 3629.215 * s + 63.224 * s * cos(2 * l.D) + -6.99 * s * cos(4 * l.D) + (2.834 * s - 0.0071 * l.T * s) * cos(2 * l.D - l.M) + 1.927 * s * cos(6 * l.D) + -1.263 * s * cos(l.D) + -0.702 * s * cos(8 * l.D) + (0.696 * s - 0.0017 * l.T * s) * cos(l.M) + -0.69 * s * cos(2 * l.F) + (-0.629 * s + 0.0016 * l.T * s) * cos(4 * l.D - l.M) + -0.392 * s * cos(2 * (l.D - l.F)) + 0.297 * s * cos(10 * l.D) + 0.260 * s * cos(6 * l.D - l.M) + 0.201 * s * cos(3 * l.D) + -0.161 * s * cos(2 * l.D + l.M) + 0.157 * s * cos(l.D + l.M) + -0.138 * s * cos(12 * l.D) + -0.127 * s * cos(8 * l.D - l.M) + 0.104 * s * cos(2 * (l.D + l.F)) + 0.104 * s * cos(2 * (l.D - l.M)) + -0.079 * s * cos(5 * l.D) + 0.068 * s * cos(14 * l.D) + 0.067 * s * cos(10 * l.D - l.M) + 0.054 * s * cos(4 * l.D + l.M) + -0.038 * s * cos(12 * l.D - l.M) + -0.038 * s * cos(4 * l.D - 2 * l.M) + 0.037 * s * cos(7 * l.D) + -0.037 * s * cos(4 * l.D + 2 * l.F) + -0.035 * s * cos(16 * l.D) + -0.03 * s * cos(3 * l.D + l.M) + 0.029 * s * cos(l.D - l.M) + -0.025 * s * cos(6 * l.D + l.M) + 0.023 * s * cos(2 * l.M) + 0.023 * s * cos(14 * l.D - l.M) + -0.023 * s * cos(2 * (l.D + l.M)) + 0.022 * s * cos(6 * l.D - 2 * l.M) + -0.021 * s * cos(2 * l.D - 2 * l.F - l.M) + -0.02 * s * cos(9 * l.D) + 0.019 * s * cos(18 * l.D) + 0.017 * s * cos(6 * l.D + 2 * l.F) + 0.014 * s * cos(2 * l.F - l.M) + -0.014 * s * cos(16 * l.D - l.M) + 0.013 * s * cos(4 * l.D - 2 * l.F) + 0.012 * s * cos(8 * l.D + l.M) + 0.011 * s * cos(11 * l.D) + 0.010 * s * cos(5 * l.D + l.M) + -0.01 * s * cos(20 * l.D);
    }
    constructor(y, h){
        this.k = snap(y, h);
        this.T = this.k * ck // (50.3) p. 350
        ;
        this.D = (0, _baseJsDefault.default).horner(this.T, 171.9179 * D2R, 335.9106046 * D2R / ck, -0.0100383 * D2R, -0.00001156 * D2R, 0.000000055 * D2R);
        this.M = (0, _baseJsDefault.default).horner(this.T, 347.3477 * D2R, 27.1577721 * D2R / ck, -0.000813 * D2R, -0.000001 * D2R);
        this.F = (0, _baseJsDefault.default).horner(this.T, 316.6109 * D2R, 364.5287911 * D2R / ck, -0.0125053 * D2R, -0.0000148 * D2R);
        return this;
    }
}
exports.default = {
    EARTH_RADIUS,
    MOON_RADIUS,
    meanPerigee,
    perigee,
    meanApogee,
    apogee,
    apogeeParallax,
    perigeeParallax,
    distance
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"egg9M":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module binary
 */ /**
 * Binary: Chapter 57, Binary Stars
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * computes mean anomaly for the given date.
 *
 * @param {Number} year - is a decimal year specifying the date
 * @param {Number} T - is time of periastron, as a decimal year
 * @param {Number} P - is period of revolution in mean solar years
 * @returns {Number} mean anomaly in radians.
 */ parcelHelpers.export(exports, "meanAnomaly", ()=>meanAnomaly);
/**
 * Position computes apparent position angle and angular distance of
 * components of a binary star.
 *
 * @param {Number} a - is apparent semimajor axis in arc seconds
 * @param {Number} e - is eccentricity of the true orbit
 * @param {Number} i - is inclination relative to the line of sight
 * @param {Number} Ω - is position angle of the ascending node
 * @param {Number} ω - is longitude of periastron
 * @param {Number} E - is eccentric anomaly, computed for example with package kepler
 *  and the mean anomaly as returned by function M in this package.
 * @returns {Number[]} [θ, ρ]
 *  {Number} θ -is the apparent position angle in radians,
 *  {Number} ρ is the angular distance in arc seconds.
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * ApparentEccentricity returns apparent eccenticity of a binary star
 * given true orbital elements.
 *
 * @param {Number} e - is eccentricity of the true orbit
 * @param {Number} i - is inclination relative to the line of sight
 * @param {Number} ω - is longitude of periastron
 * @returns {Number} apparent eccenticity of a binary star
 */ parcelHelpers.export(exports, "apparentEccentricity", ()=>apparentEccentricity);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const { atan, atan2, cos, sqrt, tan } = Math;
function meanAnomaly(year, T, P) {
    const n = 2 * Math.PI / P;
    return (0, _baseJsDefault.default).pmod(n * (year - T), 2 * Math.PI);
}
function position(a, e, i, \u03A9, \u03C9, E) {
    const r = a * (1 - e * cos(E));
    const \u03BD = 2 * atan(sqrt((1 + e) / (1 - e)) * tan(E / 2));
    const [sin\u03BD\u03C9, cos\u03BD\u03C9] = (0, _baseJsDefault.default).sincos(\u03BD + \u03C9);
    const cosi = cos(i);
    const num = sin\u03BD\u03C9 * cosi;
    let \u03B8 = atan2(num, cos\u03BD\u03C9) + \u03A9;
    if (\u03B8 < 0) \u03B8 += 2 * Math.PI;
    const \u03C1 = r * sqrt(num * num + cos\u03BD\u03C9 * cos\u03BD\u03C9);
    return [
        \u03B8,
        \u03C1
    ];
}
function apparentEccentricity(e, i, \u03C9) {
    const cosi = cos(i);
    const [sin\u03C9, cos\u03C9] = (0, _baseJsDefault.default).sincos(\u03C9);
    const A = (1 - e * e * cos\u03C9 * cos\u03C9) * cosi * cosi;
    const B = e * e * sin\u03C9 * cos\u03C9 * cosi;
    const C = 1 - e * e * sin\u03C9 * sin\u03C9;
    const d = A - C;
    const sqrtD = sqrt(d * d + 4 * B * B);
    return sqrt(2 * sqrtD / (A + C + sqrtD));
}
exports.default = {
    meanAnomaly,
    position,
    apparentEccentricity
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5f3XR":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module conjunction
 */ /**
 * Conjunction: Chapter 18: Planetary Conjunctions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Planetary computes a conjunction between two moving objects, such as planets.
 *
 * Conjunction is found with interpolation against length 5 ephemerides.
 *
 * t1, t5 are times of first and last rows of ephemerides.  The scale is
 * arbitrary.
 *
 * cs1 is the ephemeris of the first object. The columns may be celestial
 * coordinates in right ascension and declination or ecliptic coordinates in
 * longitude and latitude.
 *
 * cs2 is the ephemeris of the second object, in the same frame as the first.
 *
 * Return value t is time of conjunction in the scale of t1, t5.
 *
 * @param {Number} t1 - julian ephemeris day of first row
 * @param {Number} t5 - julian ephemeris day of fifth row
 * @param {Coord[]} cs1 - ephemeris of first moving object
 * @param {Coord[]} cs2 - ephemeris of decond moving object
 * @return {Array}
 *    {Number} t - time of conjunction in JDE
 *    {Number} Δd - is the amount that object 2 was "above" object 1 at the time of conjunction.
 */ parcelHelpers.export(exports, "planetary", ()=>planetary);
/**
 * Stellar computes a conjunction between a moving and non-moving object.
 *
 * Arguments and return values same as with Planetary, except the non-moving
 * object is c1.  The ephemeris of the moving object is cs2.
 *
 * @param {Number} t1 - julian ephemeris day of first row
 * @param {Number} t5 - julian ephemeris day of fifth row
 * @param {Coord} c1 - ephemeris of non-moving object
 * @param {Coord[]} cs2 - ephemeris of moving object
 * @return {Array}
 *    {Number} t - time of conjunction in JDE
 *    {Number} Δd - is the amount that object 2 was "above" object 1 at the time of conjunction.
 */ parcelHelpers.export(exports, "stellar", ()=>stellar);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
function planetary(t1, t5, cs1, cs2) {
    if (cs1.length !== 5 || cs2.length !== 5) throw new Error("Five rows required in ephemerides");
    const dr = new Array(5);
    const dd = new Array(5);
    cs1.forEach((r, i)=>{
        dr[i] = cs2[i].ra - cs1[i].ra;
        dd[i] = cs2[i].dec - cs1[i].dec;
    });
    return conj(t1, t5, dr, dd);
}
function stellar(t1, t5, c1, cs2) {
    if (cs2.length !== 5) throw new Error("Five rows required in ephemerides");
    const dr = new Array(5);
    const dd = new Array(5);
    cs2.forEach((r, i)=>{
        dr[i] = cs2[i].ra - c1.ra;
        dd[i] = cs2[i].dec - c1.dec;
    });
    return conj(t1, t5, dr, dd);
}
const conj = function(t1, t5, dr, dd) {
    let l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, dr);
    const t = l5.zero(true);
    l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, dd);
    const \u0394d = l5.interpolateXStrict(t);
    return [
        t,
        \u0394d
    ];
};
exports.default = {
    planetary,
    stellar
};

},{"./base.js":"cO06o","./interpolation.js":"isMMq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gchHS":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module circle
 */ /**
 * Circle: Chapter 20, Smallest Circle containing three Celestial Bodies.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Smallest finds the smallest circle containing three points.
 *
 * Arguments should represent coordinates in right ascension and declination
 * or longitude and latitude.  Result Δ is the diameter of the circle, typeI
 * is true if solution is of type I.
 *
 * @param {Coord} c1 - ra, dec point 1
 * @param {Coord} c2 - ra, dec point 2
 * @param {Coord} c3 - ra, dec point 3
 * @returns {Array} [Δ, typeI]
 *  {Number} Δ - diameter of the circle
 *  {Number} typeI - true - Two points on circle, one interior.
 *                   false - All three points on circle.
 */ parcelHelpers.export(exports, "smallest", ()=>smallest);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
function smallest(c1, c2, c3) {
    // Using haversine formula
    const cd1 = Math.cos(c1.dec);
    const cd2 = Math.cos(c2.dec);
    const cd3 = Math.cos(c3.dec);
    let a = 2 * Math.asin(Math.sqrt(hav(c2.dec - c1.dec) + cd1 * cd2 * hav(c2.ra - c1.ra)));
    let b = 2 * Math.asin(Math.sqrt(hav(c3.dec - c2.dec) + cd2 * cd3 * hav(c3.ra - c2.ra)));
    let c = 2 * Math.asin(Math.sqrt(hav(c1.dec - c3.dec) + cd3 * cd1 * hav(c1.ra - c3.ra)));
    if (b > a) [a, b] = noswap(b, a);
    if (c > a) [a, c] = noswap(c, a);
    if (a * a >= b * b + c * c) return [
        a,
        true
    ];
    // (20.1) p. 128
    return [
        2 * a * b * c / Math.sqrt((a + b + c) * (a + b - c) * (b + c - a) * (a + c - b)),
        false
    ];
}
const noswap = function(a, b) {
    return [
        a,
        b
    ];
};
/**
 * haversine function (17.5) p. 115
 */ const hav = function(a) {
    return 0.5 * (1 - Math.cos(a));
};
exports.default = {
    smallest
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2uWsU":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module deltat
 */ /**
 * DeltaT: Chapter 10, Dynamical Time and Universal Time.
 *
 * This package uses no functions from the Chapter. Polynoms are from
 * <http://eclipse.gsfc.nasa.gov/SEcat5/deltatpoly.html>, data sets are from
 * <http://maia.usno.navy.mil/ser7/>
 *
 * Functions in this package compute ΔT for various ranges of dates.
 *
 * ΔT = TD - UT1
 *
 * TD = "Dynamical Time", which is related to:
 *   ET "Ephermis Time", an older term.
 *   TDB "Barycentric Dynamical Time", very close to TD.
 *   TDT "Terrestrial Dynamical Time", a more correct term.
 *   TT "Terrestrial Time", a newer and more correct term.
 *
 * UT = "Universal Time", which is related (if ambiguously) to GMT "Greenwich
 * Mean Time".
 *
 * Terrestrial Time is effectively equal to International Atomic Time (TAI)
 * plus 32.184 seconds exactly: TT = TAI + 32.184
 * The epoch designated "J2000.0" is specified as Julian date 2451545.0 TT,
 * or 2000 January 1, 12h TT. This epoch can also be expressed as
 * 2000 January 1, 11:59:27.816 TAI or 2000 January 1, 11:58:55.816 UTC.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * deltaT returns the difference ΔT = TD - UT between Dynamical Time TD and
 * Univeral Time (GMT+12) in seconds
 *
 * Polynoms are from <http://eclipse.gsfc.nasa.gov/SEcat5/deltatpoly.html>
 * and <http://www.staff.science.uu.nl/~gent0113/deltat/deltat_old.htm>
 *
 * @param {Number} dyear - decimal year
 * @returns {Number} ΔT in seconds.
 */ parcelHelpers.export(exports, "deltaT", ()=>deltaT);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _deltatJs = require("../data/deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
// avoids ciclic import { LeapYearGregorian } from './julian.js'
function LeapYearGregorian(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function deltaT(dyear) {
    let \u0394T;
    if (dyear < -500) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1820) * 0.01, -20, 0, 32);
    else if (dyear < 500) \u0394T = (0, _baseJsDefault.default).horner(dyear * 0.01, 10583.6, -1014.41, 33.78311, -5.952053, -0.1798452, 0.022174192, 0.0090316521);
    else if (dyear < 1600) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1000) * 0.01, 1574.2, -556.01, 71.23472, 0.319781, -0.8503463, -0.005050998, 0.0083572073);
    else if (dyear < (0, _deltatJsDefault.default).historic.first) \u0394T = (0, _baseJsDefault.default).horner(dyear - 1600, 120, -0.9808, -0.01532, 1 / 7129);
    else if (dyear < (0, _deltatJsDefault.default).data.first) \u0394T = interpolate(dyear, (0, _deltatJsDefault.default).historic);
    else if (dyear < (0, _deltatJsDefault.default).data.last - 0.25) \u0394T = interpolateData(dyear, (0, _deltatJsDefault.default).data);
    else if (dyear < (0, _deltatJsDefault.default).prediction.last) \u0394T = interpolate(dyear, (0, _deltatJsDefault.default).prediction);
    else if (dyear < 2050) \u0394T = (0, _baseJsDefault.default).horner((dyear - 2000) / 100, 62.92, 32.217, 55.89);
    else if (dyear < 2150) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1820) / 100, -205.72, 56.28, 32);
    else {
        const u = (dyear - 1820) / 100;
        \u0394T = -20 + 32 * u * u;
    }
    return \u0394T;
}
/**
 * interpolation of dataset
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function interpolate(dyear, data) {
    const d3 = (0, _interpolationJsDefault.default).len3ForInterpolateX(dyear, data.first, data.last, data.table);
    return d3.interpolateX(dyear);
}
/**
 * interpolation of dataset from finals2000A with is one entry per month
 * linear interpolation over whole dataset is inaccurate as points per month
 * are not equidistant. Therefore points are approximated using 2nd diff. interpolation
 * from current month using the following two points
 *
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function interpolateData(dyear, data) {
    const [fyear, fmonth] = data.firstYM;
    const { year, month, first, last } = monthOfYear(dyear);
    const pos = 12 * (year - fyear) + (month - fmonth);
    const table = data.table.slice(pos, pos + 3);
    const d3 = new (0, _interpolationJsDefault.default).Len3(first, last, table);
    return d3.interpolateX(dyear);
}
/**
 * Get month of Year from fraction. Fraction differs at leap years.
 * @private
 * @param {Number} dyear - decimal year
 * @return {Object} `{year: Number, month: Number, first: Number, last}`
 */ function monthOfYear(dyear) {
    // if (!monthOfYear.data) { // memoize yearly fractions per month
    //   monthOfYear.data = { 0: [], 1: [] }
    //   for (let m = 0; m <= 12; m++) {
    //     monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
    //     monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
    //   }
    // }
    // console.log(monthOfYear)
    const year = dyear | 0;
    const f = dyear - year;
    const d = LeapYearGregorian(year) ? 1 : 0;
    const data = monthOfYear.data[d];
    let month = 12 // TODO loop could be improved
    ;
    while(month > 0 && data[month] > f)month--;
    const first = year + data[month];
    const last = month < 11 ? year + data[month + 2] : year + 1 + data[(month + 2) % 12];
    return {
        year,
        month,
        first,
        last
    };
}
/**
  monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
  monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
 */ monthOfYear.data = [
    [
        0,
        0,
        0.08493150684921602,
        0.16164383561635987,
        0.24657534246580326,
        0.3287671232876619,
        0.4136986301368779,
        0.4958904109589639,
        0.5808219178081799,
        0.6657534246576233,
        0.747945205479482,
        0.832876712328698,
        0.915068493150784
    ],
    [
        0,
        0,
        0.08743169398917416,
        0.1639344262296163,
        0.24863387978143692,
        0.3306010928961314,
        0.4153005464481794,
        0.49726775956287383,
        0.5819672131146945,
        0.6666666666667425,
        0.7486338797814369,
        0.8333333333332575,
        0.9153005464481794
    ]
];
exports.default = {
    deltaT
};

},{"./base.js":"cO06o","./interpolation.js":"isMMq","../data/deltat.js":"gMlrK","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gMlrK":[function(require,module,exports) {
/**
 * DO NOT EDIT MANUALLY
 * Use `scripts/deltat.js` to generate file.
 * Datasets are from <https://maia.usno.navy.mil/ser7> and
 * <ftp://ftp.iers.org/products/eop/rapid/standard>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const m = {
    historic: {
        table: [
            44,
            43,
            43,
            41,
            40,
            39,
            38,
            37,
            37,
            36,
            36,
            36,
            37,
            37,
            38,
            37,
            36,
            36,
            35,
            35,
            34,
            33,
            33,
            32,
            32,
            31,
            31,
            30,
            30,
            29,
            29,
            29,
            29,
            29,
            28,
            28,
            27,
            27,
            26,
            26,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            25,
            25,
            25,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            23,
            23,
            23,
            23,
            22,
            22,
            22,
            22,
            22,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21.1,
            21,
            21,
            21,
            20.9,
            20.8,
            20.7,
            20.6,
            20.4,
            20.2,
            20,
            19.7,
            19.4,
            19.1,
            18.7,
            18.3,
            17.8,
            17.4,
            17,
            16.8,
            16.6,
            16.4,
            16.1,
            15.9,
            15.7,
            15.5,
            15.3,
            15,
            14.7,
            14.5,
            14.3,
            14.2,
            14.1,
            14.1,
            14.1,
            13.9,
            13.7,
            13.6,
            13.5,
            13.5,
            13.5,
            13.5,
            13.4,
            13.4,
            13.4,
            13.4,
            13.3,
            13.3,
            13.2,
            13.2,
            13.2,
            13.1,
            13.1,
            13.1,
            13,
            13.2,
            13.3,
            13.4,
            13.5,
            13.6,
            13.7,
            13.8,
            13.9,
            14,
            14,
            14.1,
            14.1,
            14.1,
            14.1,
            14.2,
            14.3,
            14.4,
            14.4,
            14.5,
            14.6,
            14.6,
            14.7,
            14.7,
            14.7,
            14.8,
            14.8,
            14.9,
            14.9,
            15,
            15,
            15.1,
            15.2,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.8,
            15.9,
            15.9,
            15.9,
            15.8,
            15.7,
            15.8,
            15.7,
            15.7,
            15.7,
            15.8,
            15.9,
            16.1,
            16.1,
            16,
            15.9,
            15.9,
            15.7,
            15.4,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.5,
            15.5,
            15.4,
            15.3,
            15.2,
            15.1,
            14.9,
            14.8,
            14.6,
            14.4,
            14.3,
            14.2,
            14.1,
            14.2,
            14.2,
            13.9,
            13.7,
            13.5,
            13.3,
            13.1,
            13,
            13.2,
            13.2,
            13.1,
            13.1,
            13.2,
            13.3,
            13.5,
            13.5,
            13.4,
            13.2,
            13.2,
            13.1,
            13.1,
            13,
            12.8,
            12.6,
            12.7,
            12.6,
            12.3,
            12,
            11.9,
            11.8,
            11.6,
            11.4,
            11.2,
            11.1,
            11.1,
            11.1,
            11.1,
            11.1,
            11.2,
            11.1,
            11.1,
            11.2,
            11.4,
            11.5,
            11.3,
            11.2,
            11.4,
            11.7,
            11.9,
            11.9,
            11.9,
            11.8,
            11.7,
            11.8,
            11.8,
            11.8,
            11.7,
            11.6,
            11.6,
            11.5,
            11.5,
            11.4,
            11.4,
            11.3,
            11.3,
            11.13,
            11.16,
            10.94,
            10.72,
            10.29,
            10.04,
            9.94,
            9.91,
            9.88,
            9.86,
            9.72,
            9.67,
            9.66,
            9.64,
            9.51,
            9.4,
            9.21,
            9,
            8.6,
            8.29,
            7.95,
            7.73,
            7.59,
            7.49,
            7.36,
            7.26,
            7.1,
            7,
            6.89,
            6.82,
            6.73,
            6.64,
            6.39,
            6.28,
            6.25,
            6.27,
            6.25,
            6.27,
            6.22,
            6.24,
            6.22,
            6.27,
            6.3,
            6.36,
            6.35,
            6.37,
            6.32,
            6.33,
            6.33,
            6.37,
            6.37,
            6.41,
            6.4,
            6.44,
            6.46,
            6.51,
            6.48,
            6.51,
            6.53,
            6.58,
            6.55,
            6.61,
            6.69,
            6.8,
            6.84,
            6.94,
            7.03,
            7.13,
            7.15,
            7.22,
            7.26,
            7.3,
            7.23,
            7.22,
            7.21,
            7.2,
            6.99,
            6.98,
            7.19,
            7.36,
            7.35,
            7.39,
            7.41,
            7.45,
            7.36,
            7.18,
            6.95,
            6.72,
            6.45,
            6.24,
            5.92,
            5.59,
            5.15,
            4.67,
            4.11,
            3.52,
            2.94,
            2.47,
            1.97,
            1.52,
            1.04,
            0.6,
            0.11,
            -0.34,
            -0.82,
            -1.25,
            -1.7,
            -2.08,
            -2.48,
            -2.82,
            -3.19,
            -3.5,
            -3.84,
            -4.14,
            -4.43,
            -4.59,
            -4.79,
            -4.92,
            -5.09,
            -5.24,
            -5.36,
            -5.34,
            -5.37,
            -5.32,
            -5.34,
            -5.33,
            -5.4,
            -5.47,
            -5.58,
            -5.66,
            -5.74,
            -5.68,
            -5.69,
            -5.65,
            -5.67,
            -5.68,
            -5.73,
            -5.72,
            -5.78,
            -5.79,
            -5.86,
            -5.89,
            -6.01,
            -6.13,
            -6.28,
            -6.41,
            -6.53,
            -6.49,
            -6.5,
            -6.45,
            -6.41,
            -6.26,
            -6.11,
            -5.9,
            -5.63,
            -5.13,
            -4.68,
            -4.19,
            -3.72,
            -3.21,
            -2.7,
            -2.09,
            -1.48,
            -0.75,
            -0.08,
            0.62,
            1.26,
            1.95,
            2.59,
            3.28,
            3.92,
            4.61,
            5.2,
            5.73,
            6.29,
            7,
            7.68,
            8.45,
            9.13,
            9.78,
            10.38,
            10.99,
            11.64,
            12.47,
            13.23,
            14,
            14.69,
            15.38,
            16,
            16.64,
            17.19,
            17.72,
            18.19,
            18.67,
            19.13,
            19.69,
            20.14,
            20.54,
            20.86,
            21.14,
            21.41,
            21.78,
            22.06,
            22.3,
            22.51,
            22.79,
            23.01,
            23.29,
            23.46,
            23.55,
            23.63,
            23.8,
            23.95,
            24.25,
            24.39,
            24.42,
            24.34,
            24.22,
            24.1,
            24.08,
            24.02,
            24.04,
            23.98,
            23.91,
            23.89,
            23.95,
            23.93,
            23.92,
            23.88,
            23.94,
            23.91,
            23.82,
            23.76,
            23.87,
            23.91,
            23.95,
            23.96,
            24,
            24.04,
            24.2,
            24.35,
            24.61,
            24.82,
            25.09,
            25.3,
            25.56,
            25.77,
            26.05,
            26.27,
            26.54,
            26.76,
            27.04,
            27.27,
            27.55,
            27.77,
            28.03,
            28.25,
            28.5,
            28.7,
            28.95,
            29.15,
            29.38,
            29.57,
            29.8,
            29.97,
            30.19,
            30.36,
            30.57,
            30.72,
            30.93,
            31.07,
            31.24,
            31.349,
            31.516,
            31.677,
            31.923,
            32.166,
            32.449,
            32.671,
            32.919,
            33.15,
            33.397,
            33.584,
            33.804,
            33.992,
            34.24,
            34.466,
            34.731,
            35.03,
            35.4,
            35.738,
            36.147,
            36.546,
            36.995,
            37.429,
            37.879,
            38.291,
            38.753,
            39.204,
            39.707,
            40.182,
            40.706,
            41.17,
            41.686,
            42.227,
            42.825,
            43.373,
            43.959,
            44.486,
            44.997,
            45.477,
            45.983,
            46.458,
            46.997,
            47.521,
            48.034,
            48.535,
            49.099,
            49.589,
            50.102,
            50.54,
            50.975,
            51.382,
            51.81,
            52.168,
            52.572,
            52.957,
            53.434,
            53.789,
            54.087
        ],
        first: 1657,
        last: 1984.5
    },
    data: {
        table: [
            43.4724372,
            43.5648351,
            43.6736863,
            43.7782156,
            43.8763273,
            43.9562443,
            44.0314956,
            44.1131788,
            44.1982187,
            44.2951747,
            44.3936471,
            44.4840562,
            44.5646335,
            44.6425099,
            44.7385767,
            44.8370135,
            44.9302138,
            44.9986146,
            45.0583549,
            45.1283911,
            45.2063835,
            45.2980068,
            45.3897017,
            45.476138,
            45.5632485,
            45.6450189,
            45.7374593,
            45.8283721,
            45.9132976,
            45.9819705,
            46.0407484,
            46.1067084,
            46.1825041,
            46.2788561,
            46.3713351,
            46.4567207,
            46.544486,
            46.6310899,
            46.7302231,
            46.8283588,
            46.9247443,
            46.9969757,
            47.0709148,
            47.1450515,
            47.2361542,
            47.3413241,
            47.4319364,
            47.5213815,
            47.6049313,
            47.6837388,
            47.7781381,
            47.8770756,
            47.9687104,
            48.0348257,
            48.0942021,
            48.1608205,
            48.2460028,
            48.3438529,
            48.4355405,
            48.5344163,
            48.6324506,
            48.7293718,
            48.8365414,
            48.9353232,
            49.0318781,
            49.1013205,
            49.1590844,
            49.2285534,
            49.3069683,
            49.4017939,
            49.4945263,
            49.5861495,
            49.6804907,
            49.7602264,
            49.8555805,
            49.9489224,
            50.0346777,
            50.1018531,
            50.1621723,
            50.2260014,
            50.2967905,
            50.3831254,
            50.4598772,
            50.5387068,
            50.6160484,
            50.6865941,
            50.7658362,
            50.8453698,
            50.918672,
            50.9761148,
            51.0278017,
            51.084323,
            51.1537928,
            51.2318645,
            51.306308,
            51.3807849,
            51.4526292,
            51.5160394,
            51.5985479,
            51.680924,
            51.7572854,
            51.8133335,
            51.8532385,
            51.9014358,
            51.9603433,
            52.0328072,
            52.0984957,
            52.1667826,
            52.2316418,
            52.2938376,
            52.3679897,
            52.4465221,
            52.5179552,
            52.5751485,
            52.6178012,
            52.666816,
            52.7340036,
            52.8055792,
            52.8792189,
            52.9564838,
            53.0444971,
            53.126769,
            53.2196749,
            53.3024139,
            53.3746645,
            53.4335399,
            53.4778015,
            53.5299937,
            53.5845392,
            53.6522628,
            53.7255844,
            53.7882418,
            53.8366625,
            53.8829665,
            53.9442904,
            54.0042478,
            54.0536342,
            54.085644,
            54.1084122,
            54.1462942,
            54.1913988,
            54.2452023,
            54.2957622,
            54.3427024,
            54.3910864,
            54.4319877,
            54.4897699,
            54.545636,
            54.597741,
            54.6354962,
            54.6532352,
            54.677594,
            54.7173643,
            54.7740957,
            54.8253023,
            54.8712512,
            54.916146,
            54.9580535,
            54.9997186,
            55.047571,
            55.0911778,
            55.1132386,
            55.132774,
            55.1532423,
            55.1898003,
            55.2415531,
            55.283803,
            55.3222105,
            55.3612676,
            55.406262,
            55.4628719,
            55.5110909,
            55.5523777,
            55.5811877,
            55.6004372,
            55.626202,
            55.6656271,
            55.7167999,
            55.7698097,
            55.8196609,
            55.8615028,
            55.9129883,
            55.9663474,
            56.0220102,
            56.0700015,
            56.0939035,
            56.110463,
            56.1313736,
            56.1610839,
            56.2068432,
            56.2582503,
            56.3000349,
            56.339902,
            56.3789995,
            56.4282839,
            56.4803947,
            56.5352164,
            56.5697487,
            56.5983102,
            56.6328326,
            56.6738814,
            56.7332116,
            56.7971596,
            56.8552701,
            56.9111378,
            56.9754725,
            57.0470772,
            57.1136128,
            57.173831,
            57.2226068,
            57.259731,
            57.3072742,
            57.3643368,
            57.4334281,
            57.5015747,
            57.5653127,
            57.6333396,
            57.6972844,
            57.7710774,
            57.8407427,
            57.9057801,
            57.9575663,
            57.9974929,
            58.0425517,
            58.1043319,
            58.1679128,
            58.2389092,
            58.3091659,
            58.3833021,
            58.4536748,
            58.5401438,
            58.6227714,
            58.6916662,
            58.7409628,
            58.7836189,
            58.8405543,
            58.898579,
            58.9713678,
            59.043837,
            59.1218414,
            59.2002687,
            59.274737,
            59.3574134,
            59.4433827,
            59.5242416,
            59.5849787,
            59.6343497,
            59.6927827,
            59.758805,
            59.8386448,
            59.9110567,
            59.9844537,
            60.056435,
            60.123065,
            60.2042185,
            60.2803745,
            60.3530352,
            60.4011891,
            60.4439959,
            60.4900257,
            60.5578054,
            60.6324446,
            60.7058569,
            60.7853482,
            60.8663504,
            60.9386672,
            61.0276757,
            61.1103448,
            61.1870458,
            61.2453891,
            61.2881024,
            61.3377799,
            61.4036165,
            61.4760366,
            61.5524599,
            61.6286593,
            61.6845819,
            61.743306,
            61.8132425,
            61.8823203,
            61.9496762,
            61.9968743,
            62.0342938,
            62.0714108,
            62.1202315,
            62.1809508,
            62.2382046,
            62.2950486,
            62.3506479,
            62.3995381,
            62.475395,
            62.5463091,
            62.6136031,
            62.6570739,
            62.6941742,
            62.7383271,
            62.7926305,
            62.8566986,
            62.9145607,
            62.9658689,
            63.0216632,
            63.0807052,
            63.1461718,
            63.2052946,
            63.2599441,
            63.2844088,
            63.2961369,
            63.3126092,
            63.3421622,
            63.3871303,
            63.4339302,
            63.4673369,
            63.4978642,
            63.5319327,
            63.5679441,
            63.6104432,
            63.6444291,
            63.6641815,
            63.6739403,
            63.692603,
            63.7147066,
            63.7518055,
            63.792717,
            63.8285221,
            63.8556871,
            63.8803854,
            63.9075025,
            63.9392787,
            63.9690744,
            63.9798604,
            63.9833077,
            63.9938011,
            64.0093384,
            64.0399621,
            64.0670429,
            64.0907881,
            64.1068077,
            64.1282125,
            64.1584211,
            64.1832722,
            64.2093975,
            64.2116628,
            64.2073173,
            64.2115565,
            64.2222858,
            64.2499625,
            64.2760973,
            64.2998037,
            64.3191858,
            64.345013,
            64.3734584,
            64.3943291,
            64.4151156,
            64.4132064,
            64.4118464,
            64.4096536,
            64.4167832,
            64.43292,
            64.4510529,
            64.4734276,
            64.4893377,
            64.5053342,
            64.5269189,
            64.5470942,
            64.5596729,
            64.5512293,
            64.5370906,
            64.5359472,
            64.5414947,
            64.5543634,
            64.5654298,
            64.5736111,
            64.5891142,
            64.6014759,
            64.6176147,
            64.6374397,
            64.6548674,
            64.6530021,
            64.6379271,
            64.637161,
            64.6399614,
            64.6543152,
            64.6723164,
            64.6876311,
            64.7051905,
            64.7313433,
            64.7575312,
            64.7811143,
            64.8000929,
            64.7994561,
            64.7876424,
            64.783095,
            64.7920604,
            64.8096421,
            64.8310888,
            64.8451826,
            64.8597013,
            64.8849929,
            64.9174991,
            64.9480298,
            64.9793881,
            64.9894772,
            65.0028155,
            65.0138193,
            65.0371432,
            65.0772597,
            65.112197,
            65.1464034,
            65.1832638,
            65.2145358,
            65.2493713,
            65.2920645,
            65.3279403,
            65.3413366,
            65.3451881,
            65.34964,
            65.3711307,
            65.3971998,
            65.4295547,
            65.4573487,
            65.486752,
            65.5152012,
            65.5449916,
            65.5780768,
            65.612728,
            65.6287505,
            65.6370091,
            65.6493375,
            65.6759928,
            65.7096966,
            65.746092,
            65.7768362,
            65.8024614,
            65.8236695,
            65.8595036,
            65.8973008,
            65.932291,
            65.950911,
            65.9534105,
            65.962833,
            65.9838647,
            66.0146733,
            66.042049,
            66.0699217,
            66.0961343,
            66.1310116,
            66.1682713,
            66.2071627,
            66.2355846,
            66.2408549,
            66.2335423,
            66.2349107,
            66.2441095,
            66.2751123,
            66.3054334,
            66.3245568,
            66.3405713,
            66.3624433,
            66.3957101,
            66.428903,
            66.4618675,
            66.4748837,
            66.4751281,
            66.4828678,
            66.5056165,
            66.5382912,
            66.5705628,
            66.6030198,
            66.6339689,
            66.6569117,
            66.6925011,
            66.7288729,
            66.7578719,
            66.7707625,
            66.7740427,
            66.7846288,
            66.810324,
            66.840048,
            66.8778601,
            66.9069091,
            66.944259,
            66.9762508,
            67.0258126,
            67.0716286,
            67.1100184,
            67.1266401,
            67.1331391,
            67.145797,
            67.17174,
            67.2091069,
            67.2459812,
            67.2810383,
            67.3136452,
            67.3456968,
            67.389003,
            67.4318433,
            67.4666209,
            67.4858459,
            67.4989147,
            67.5110936,
            67.5352658,
            67.571103,
            67.6070253,
            67.6439167,
            67.6765272,
            67.7116693,
            67.7590634,
            67.8011542,
            67.840213,
            67.8606318,
            67.8821576,
            67.9120101,
            67.9546462,
            68.0054839,
            68.051412,
            68.1024205,
            68.1577127,
            68.2043653,
            68.2664507,
            68.3188171,
            68.3703564,
            68.3964356,
            68.4094472,
            68.4304611,
            68.4629791,
            68.507818,
            68.5537018,
            68.5927179,
            68.6298107,
            68.6670627,
            68.7135208,
            68.7622755,
            68.8032843,
            68.8244838,
            68.8373427,
            68.847693,
            68.8688567,
            68.9005814,
            68.9354999,
            68.9676423,
            68.9875354,
            69.0175527,
            69.0499081,
            69.0823433,
            69.1070034,
            69.1134027,
            69.1141898,
            69.1207203,
            69.1355578,
            69.16459,
            69.1964228,
            69.2201632,
            69.2451564,
            69.2732758,
            69.3031979,
            69.3325675,
            69.3540507,
            69.3581722,
            69.3441594,
            69.3376329,
            69.3377424,
            69.3432191,
            69.3540144,
            69.3611554,
            69.3751703,
            69.3889904,
            69.4091639,
            69.4264662,
            69.4386335,
            69.4241335,
            69.3921241,
            69.3693422,
            69.3574782,
            69.3593242,
            69.3630244,
            69.359334,
            69.3510133,
            69.3537917,
            69.3582217,
            69.367306,
            69.3678649,
            69.3514228,
            69.3273414,
            69.3033273,
            69.2892463,
            69.2880419,
            69.2908014,
            69.2944974,
            69.2913953,
            69.286149,
            69.2835153,
            69.2815422,
            69.2806375,
            69.2553511,
            69.2125426,
            69.1847287,
            69.17207,
            69.1691531,
            69.173303,
            69.1698064,
            69.1589095,
            69.1556275,
            69.1672253,
            69.1771384
        ],
        first: 1973.0849315068492,
        firstYM: [
            1973,
            2
        ],
        last: 2023.3287671232877,
        lastYM: [
            2023,
            5
        ]
    },
    prediction: {
        table: [
            67.87818,
            67.96817999999999,
            68.02817999999999,
            68.04818,
            68.12818,
            68.21817999999999,
            68.26818,
            68.28818,
            68.36818,
            68.44818,
            68.50818,
            68.51818,
            68.59818,
            68.68818,
            68.73818,
            68.74817999999999,
            68.82818,
            68.91817999999999,
            68.96817999999999,
            68.98818,
            69.06818,
            69.14818,
            69.20818,
            69.22818,
            69.30818,
            69.39818,
            69.46817999999999,
            69.48818,
            69.57818,
            69.66817999999999,
            69.73818,
            69.75818,
            69.85817999999999,
            69.95818,
            70.02817999999999,
            70.05818,
            70.15818,
            70.25818,
            70.33818,
            70.36818,
            70.46817999999999
        ],
        first: 2022,
        last: 2032
    }
};
exports.default = m;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8qxM3":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elliptic
 */ /**
 * Elliptic: Chapter 33, Elliptic Motion.
 *
 * Partial: Various formulas and algorithms are unimplemented for lack of
 * examples or test cases.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Position returns observed equatorial coordinates of a planet at a given time.
 *
 * Argument p must be a valid V87Planet object for the observed planet.
 * Argument earth must be a valid V87Planet object for Earth.
 *
 * Results are right ascension and declination, α and δ in radians.
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * Elements holds keplerian elements.
 */ parcelHelpers.export(exports, "Elements", ()=>Elements);
/**
 * AstrometricJ2000 is a utility function for computing astrometric coordinates.
 *
 * It is used internally and only exported so that it can be used from
 * multiple packages.  It is not otherwise expected to be used.
 *
 * Argument f is a function that returns J2000 equatorial rectangular
 * coodinates of a body.
 *
 * Results are J2000 right ascention, declination, and elongation.
 */ parcelHelpers.export(exports, "astrometricJ2000", ()=>astrometricJ2000);
/**
 * Velocity returns instantaneous velocity of a body in elliptical orbit around the Sun.
 *
 * Argument a is the semimajor axis of the body, r is the instaneous distance
 * to the Sun, both in AU.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "velocity", ()=>velocity);
/**
 * Velocity returns the velocity of a body at aphelion.
 *
 * Argument a is the semimajor axis of the body in AU, e is eccentricity.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "vAphelion", ()=>vAphelion);
/**
 * Velocity returns the velocity of a body at perihelion.
 *
 * Argument a is the semimajor axis of the body in AU, e is eccentricity.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "vPerihelion", ()=>vPerihelion);
/**
 * Length1 returns Ramanujan's approximation for the length of an elliptical
 * orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length1", ()=>length1);
/**
 * Length2 returns an alternate approximation for the length of an elliptical
 * orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length2", ()=>length2);
/**
 * Length3 returns the length of an elliptical orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is exact, and in units used for semimajor axis, typically AU.
 */ /* As Meeus notes, Length4 converges faster.  There is no reason to use
this function
export function length3 (a, e) { // (a, e float64)  float64
  const sum0 = 1.0
  const e2 = e * e
  const term = e2 * 0.25
  const sum1 = 1.0 - term
  const nf = 1.0
  const df = 2.0
  while (sum1 !== sum0) {
    term *= nf
    nf += 2
    df += 2
    term *= nf * e2 / (df * df)
    sum0 = sum1
    sum1 -= term
  }
  return 2 * Math.PI * a * sum0
} */ /**
 * Length4 returns the length of an elliptical orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is exact, and in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length4", ()=>length4);
var _apparentJs = require("./apparent.js");
var _apparentJsDefault = parcelHelpers.interopDefault(_apparentJs);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _keplerJs = require("./kepler.js");
var _keplerJsDefault = parcelHelpers.interopDefault(_keplerJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _solarxyzJs = require("./solarxyz.js");
var _solarxyzJsDefault = parcelHelpers.interopDefault(_solarxyzJs);
function position(planet, earth, jde) {
    let x = 0;
    let y = 0;
    let z = 0;
    const posEarth = earth.position(jde);
    const [L0, B0, R0] = [
        posEarth.lon,
        posEarth.lat,
        posEarth.range
    ];
    const [sB0, cB0] = (0, _baseJsDefault.default).sincos(B0);
    const [sL0, cL0] = (0, _baseJsDefault.default).sincos(L0);
    function pos(\u03C4 = 0) {
        const pos = planet.position(jde - \u03C4);
        const [L, B, R] = [
            pos.lon,
            pos.lat,
            pos.range
        ];
        const [sB, cB] = (0, _baseJsDefault.default).sincos(B);
        const [sL, cL] = (0, _baseJsDefault.default).sincos(L);
        x = R * cB * cL - R0 * cB0 * cL0;
        y = R * cB * sL - R0 * cB0 * sL0;
        z = R * sB - R0 * sB0;
    }
    pos();
    const \u0394 = Math.sqrt(x * x + y * y + z * z) // (33.4) p. 224
    ;
    const \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    // repeating with jde-τ
    pos(\u03C4);
    let \u03BB = Math.atan2(y, x) // (33.1) p. 223
    ;
    let \u03B2 = Math.atan2(z, Math.hypot(x, y)) // (33.2) p. 223
    ;
    const [\u0394\u03BB, \u0394\u03B2] = (0, _apparentJsDefault.default).eclipticAberration(\u03BB, \u03B2, jde);
    const fk5 = (0, _planetpositionJsDefault.default).toFK5(\u03BB + \u0394\u03BB, \u03B2 + \u0394\u03B2, jde);
    \u03BB = fk5.lon;
    \u03B2 = fk5.lat;
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
    \u03BB += \u0394\u03C8;
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    return new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
// Meeus gives a formula for elongation but doesn't spell out how to
// obtaion term λ0 and doesn't give an example solution.
}
class Elements {
    /**
   * Position returns observed equatorial coordinates of a body with Keplerian elements.
   *
   * Argument e must be a valid V87Planet object for Earth.
   *
   * Results are right ascension and declination α and δ, and elongation ψ,
   * all in radians.
   */ position(jde, earth) {
        // (33.6) p. 227
        const n = (0, _baseJsDefault.default).K / this.axis / Math.sqrt(this.axis);
        const s\u03B5 = (0, _baseJsDefault.default).SOblJ2000;
        const c\u03B5 = (0, _baseJsDefault.default).COblJ2000;
        const [s\u03A9, c\u03A9] = (0, _baseJsDefault.default).sincos(this.node);
        const [si, ci] = (0, _baseJsDefault.default).sincos(this.inc);
        // (33.7) p. 228
        const F = c\u03A9;
        const G = s\u03A9 * c\u03B5;
        const H = s\u03A9 * s\u03B5;
        const P = -s\u03A9 * ci;
        const Q = c\u03A9 * ci * c\u03B5 - si * s\u03B5;
        const R = c\u03A9 * ci * s\u03B5 + si * c\u03B5;
        // (33.8) p. 229
        const A = Math.atan2(F, P);
        const B = Math.atan2(G, Q);
        const C = Math.atan2(H, R);
        const a = Math.hypot(F, P);
        const b = Math.hypot(G, Q);
        const c = Math.hypot(H, R);
        const f = (jde)=>{
            const M = n * (jde - this.timeP);
            let E;
            try {
                E = (0, _keplerJsDefault.default).kepler2b(this.ecc, M, 15);
            } catch (e) {
                E = (0, _keplerJsDefault.default).kepler3(this.ecc, M);
            }
            const \u03BD = (0, _keplerJsDefault.default).trueAnomaly(E, this.ecc);
            const r = (0, _keplerJsDefault.default).radius(E, this.ecc, this.axis);
            // (33.9) p. 229
            const x = r * a * Math.sin(A + this.argP + \u03BD);
            const y = r * b * Math.sin(B + this.argP + \u03BD);
            const z = r * c * Math.sin(C + this.argP + \u03BD);
            return {
                x,
                y,
                z
            };
        };
        return astrometricJ2000(f, jde, earth);
    }
    /*
  Axis  float64 // Semimajor axis, a, in AU
  Ecc   float64 // Eccentricity, e
  Inc   float64 // Inclination, i, in radians
  ArgP  float64 // Argument of perihelion, ω, in radians
  Node  float64 // Longitude of ascending node, Ω, in radians
  TimeP float64 // Time of perihelion, T, as jde
  */ constructor(axis, ecc, inc, argP, node, timeP){
        let o = {};
        if (typeof axis === "object") o = axis;
        this.axis = o.axis || axis;
        this.ecc = o.ecc || ecc;
        this.inc = o.inc || inc;
        this.argP = o.argP || argP;
        this.node = o.node || node;
        this.timeP = o.timeP || timeP;
    }
}
function astrometricJ2000(f, jde, earth) {
    const sol = (0, _solarxyzJsDefault.default).positionJ2000(earth, jde);
    const [X, Y, Z] = [
        sol.x,
        sol.y,
        sol.z
    ];
    let \u03BE = 0;
    let \u03B7 = 0;
    let \u03B6 = 0;
    let \u0394 = 0;
    function fn(\u03C4 = 0) {
        // (33.10) p. 229
        const { x, y, z } = f(jde - \u03C4);
        \u03BE = X + x;
        \u03B7 = Y + y;
        \u03B6 = Z + z;
        \u0394 = Math.sqrt(\u03BE * \u03BE + \u03B7 * \u03B7 + \u03B6 * \u03B6);
    }
    fn();
    const \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    fn(\u03C4);
    let \u03B1 = Math.atan2(\u03B7, \u03BE);
    if (\u03B1 < 0) \u03B1 += 2 * Math.PI;
    const \u03B4 = Math.asin(\u03B6 / \u0394);
    const R0 = Math.sqrt(X * X + Y * Y + Z * Z);
    const \u03C8 = Math.acos((\u03BE * X + \u03B7 * Y + \u03B6 * Z) / R0 / \u0394);
    return new (0, _baseJsDefault.default).Coord(\u03B1, \u03B4, undefined, \u03C8);
}
function velocity(a, r) {
    return 42.1219 * Math.sqrt(1 / r - 0.5 / a);
}
function vAphelion(a, e) {
    return 29.7847 * Math.sqrt((1 - e) / (1 + e) / a);
}
function vPerihelion(a, e) {
    return 29.7847 * Math.sqrt((1 + e) / (1 - e) / a);
}
function length1(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    return Math.PI * (3 * (a + b) - Math.sqrt((a + 3 * b) * (3 * a + b)));
}
function length2(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    const s = a + b;
    const p = a * b;
    const A = s * 0.5;
    const G = Math.sqrt(p);
    const H = 2 * p / s;
    return Math.PI * (21 * A - 2 * G - 3 * H) * 0.125;
}
function length4(a, e) {
    const b = a * Math.sqrt(1 - e * e);
    const m = (a - b) / (a + b);
    const m2 = m * m;
    let sum0 = 1.0;
    let term = m2 * 0.25;
    let sum1 = 1.0 + term;
    let nf = -1;
    let df = 2.0;
    while(sum1 !== sum0){
        nf += 2;
        df += 2;
        term *= nf * nf * m2 / (df * df);
        sum0 = sum1;
        sum1 += term;
    }
    return 2 * Math.PI * a * sum0 / (1 + m);
}
exports.default = {
    position,
    Elements,
    astrometricJ2000,
    velocity,
    vAphelion,
    vPerihelion,
    length1,
    length2,
    // length3,
    length4
};

},{"./apparent.js":"4gNB9","./base.js":"cO06o","./coord.js":"1Ze6D","./kepler.js":"jVSJo","./nutation.js":"fWRWg","./planetposition.js":"cfC43","./solarxyz.js":"51rgn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jVSJo":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module kepler
 */ /**
 * Kepler: Chapter 30, Equation of Kepler.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True returns true anomaly ν for given eccentric anomaly E.
 *
 * @param {number} e - eccentricity
 * @param {number} E - eccentric anomaly in radians.
 * @return true anomaly ν in radians.
 */ parcelHelpers.export(exports, "trueAnomaly", ()=>trueAnomaly);
/**
 * Radius returns radius distance r for given eccentric anomaly E.
 *
 * Result unit is the unit of semimajor axis a (typically AU.)
 *
 * @param {number} e - eccentricity
 * @param {number} E - eccentric anomaly in radians
 * @param {number} a - semimajor axis
 * @return {number} radius distance in unit of `a`
 */ parcelHelpers.export(exports, "radius", ()=>radius);
/**
 * Kepler1 solves Kepler's equation by iteration.
 *
 * The iterated formula is
 *
 *  E1 = m + e * sin(E0)
 *
 * For some vaues of e and M it will fail to converge and the
 * function will return an error.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler1", ()=>kepler1);
/**
 * Kepler2 solves Kepler's equation by iteration.
 *
 * The iterated formula is
 *
 *  E1 = E0 + (m + e * sin(E0) - E0) / (1 - e * cos(E0))
 *
 * The function converges over a wider range of inputs than does Kepler1
 * but it also fails to converge for some values of e and M.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2", ()=>kepler2);
/**
 * Kepler2a solves Kepler's equation by iteration.
 *
 * The iterated formula is the same as in Kepler2 but a limiting function
 * avoids divergence.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2a", ()=>kepler2a);
/**
 * Kepler2b solves Kepler's equation by iteration.
 *
 * The iterated formula is the same as in Kepler2 but a (different) limiting
 * function avoids divergence.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2b", ()=>kepler2b);
/**
 * Kepler3 solves Kepler's equation by binary search.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler3", ()=>kepler3);
/**
 * Kepler4 returns an approximate solution to Kepler's equation.
 *
 * It is valid only for small values of e.
 *
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler4", ()=>kepler4);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _iterateJs = require("./iterate.js");
var _iterateJsDefault = parcelHelpers.interopDefault(_iterateJs);
function trueAnomaly(E, e) {
    // (30.1) p. 195
    return 2 * Math.atan(Math.sqrt((1 + e) / (1 - e)) * Math.tan(E * 0.5));
}
function radius(E, e, a) {
    // (30.2) p. 195
    return a * (1 - e * Math.cos(E));
}
function kepler1(e, m, places) {
    const f = function(E0) {
        return m + e * Math.sin(E0) // (30.5) p. 195
        ;
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places * 5);
}
function kepler2(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, _baseJsDefault.default).sincos(E0);
        return E0 + (m + e * se - E0) / (1 - e * ce // (30.7) p. 199
        );
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places);
}
function kepler2a(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, _baseJsDefault.default).sincos(E0);
        // method of Leingärtner, p. 205
        return E0 + Math.asin(Math.sin((m + e * se - E0) / (1 - e * ce)));
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places * 5);
}
function kepler2b(e, m, places) {
    const f = function(E0) {
        const [se, ce] = (0, _baseJsDefault.default).sincos(E0);
        let d = (m + e * se - E0) / (1 - e * ce);
        // method of Steele, p. 205
        if (d > 0.5) d = 0.5;
        else if (d < -0.5) d = -0.5;
        return E0 + d;
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places);
}
function kepler3(e, m) {
    // adapted from BASIC, p. 206
    m = (0, _baseJsDefault.default).pmod(m, 2 * Math.PI);
    let f = 1;
    if (m > Math.PI) {
        f = -1;
        m = 2 * Math.PI - m;
    }
    let E0 = Math.PI * 0.5;
    let d = Math.PI * 0.25;
    for(let i = 0; i < 53; i++){
        const M1 = E0 - e * Math.sin(E0);
        if (m - M1 < 0) E0 -= d;
        else E0 += d;
        d *= 0.5;
    }
    if (f < 0) return -E0;
    return E0;
}
function kepler4(e, m) {
    const [sm, cm] = (0, _baseJsDefault.default).sincos(m);
    return Math.atan2(sm, cm - e) // (30.8) p. 206
    ;
}
exports.default = {
    trueAnomaly,
    true: trueAnomaly,
    radius,
    kepler1,
    kepler2,
    kepler2a,
    kepler2b,
    kepler3,
    kepler4
};

},{"./base.js":"cO06o","./iterate.js":"2zKvc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2zKvc":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module iterate
 */ /**
 * Iterate: Chapter 5, Iteration.
 *
 * This package is best considered illustrative.  While the functions are
 * usable, they are minimal in showing the points of the chapter text.  More
 * robust functions would handle more cases of overflow, loss of precision,
 * and divergence.
 */ /**
 * decimalPlaces iterates to a fixed number of decimal places.
 *
 * Inputs are an improvement function, a starting value, the number of
 * decimal places desired in the result, and an iteration limit.
 *
 * @throws Error
 * @param {Function} better
 * @param {Number} start - (float)
 * @param {Number} places - (int)
 * @param {Number} maxIterations - (int)
 * @returns {Number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimalPlaces", ()=>decimalPlaces);
/**
 * fullPrecison iterates to (nearly) the full precision of a float64.
 *
 * To allow for a little bit of floating point jitter, FullPrecision iterates
 * to 15 significant figures, which is the maximum number of full significant
 * figures representable in a float64, but still a couple of bits shy of the
 * full representable precision.
 *
 * @throws Error
 * @param {Function} better
 * @param {Number} start - (float)
 * @param {Number} maxIterations - (int)
 * @returns {Number}
 */ parcelHelpers.export(exports, "fullPrecision", ()=>fullPrecision);
/**
 * binaryRoot finds a root between given bounds by binary search.
 *
 * Inputs are a function on x and the bounds on x.  A root must exist between
 * the given bounds, otherwise the result is not meaningful.
 *
 * @param {Function} f - root function
 * @param {Number} lower - (float)
 * @param {Number} upper - (float)
 * @returns {Number}
 */ parcelHelpers.export(exports, "binaryRoot", ()=>binaryRoot);
function decimalPlaces(better, start, places, maxIterations) {
    const d = Math.pow(10, -places);
    for(let i = 0; i < maxIterations; i++){
        const n = better(start);
        if (Math.abs(n - start) < d) return n;
        start = n;
    }
    throw new Error("Maximum iterations reached");
}
function fullPrecision(better, start, maxIterations) {
    for(let i = 0; i < maxIterations; i++){
        const n = better(start);
        if (Math.abs((n - start) / n) < 1e-15) return n;
        start = n;
    }
    throw new Error("Maximum iterations reached");
}
function binaryRoot(f, lower, upper) {
    let yLower = f(lower);
    let mid = 0;
    for(let j = 0; j < 52; j++){
        mid = (lower + upper) / 2;
        const yMid = f(mid);
        if (yMid === 0) break;
        if (signbit(yLower) === signbit(yMid)) {
            lower = mid;
            yLower = yMid;
        } else upper = mid;
    }
    return mid;
}
function signbit(v) {
    return v < 0;
}
exports.default = {
    decimalPlaces,
    fullPrecision,
    binaryRoot
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"51rgn":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solarxyz
 */ /**
 * Solarxyz: Chapter 26, Rectangular Coordinates of the Sun.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Position returns rectangular coordinates referenced to the mean equinox of date.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * LongitudeJ2000 returns geometric longitude referenced to equinox J2000.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {Number} geometric longitude referenced to equinox J2000.
 */ parcelHelpers.export(exports, "longitudeJ2000", ()=>longitudeJ2000);
/**
 * PositionJ2000 returns rectangular coordinates referenced to equinox J2000.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionJ2000", ()=>positionJ2000);
parcelHelpers.export(exports, "xyz", ()=>xyz);
/**
 * PositionB1950 returns rectangular coordinates referenced to B1950.
 *
 * Results are referenced to the mean equator and equinox of the epoch B1950
 * in the FK5 system, not FK4.
 *
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionB1950", ()=>positionB1950);
/**
 * PositionEquinox returns rectangular coordinates referenced to an arbitrary epoch.
 *
 * Position will be computed for given Julian day "jde" but referenced to mean
 * equinox "epoch" (year).
 *
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @param {Number} epoch
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionEquinox", ()=>positionEquinox);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
function position(earth, jde) {
    // (26.1) p. 171
    const { lon, lat, range } = (0, _solarJsDefault.default).trueVSOP87(earth, jde);
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos((0, _nutationJsDefault.default).meanObliquity(jde));
    const [ss, cs] = (0, _baseJsDefault.default).sincos(lon);
    const s\u03B2 = Math.sin(lat);
    const x = range * cs;
    const y = range * (ss * c\u03B5 - s\u03B2 * s\u03B5);
    const z = range * (ss * s\u03B5 + s\u03B2 * c\u03B5);
    return {
        x,
        y,
        z
    };
}
function longitudeJ2000(earth, jde) {
    const lon = earth.position2000(jde).lon;
    return (0, _baseJsDefault.default).pmod(lon + Math.PI - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
}
function positionJ2000(earth, jde) {
    const { x, y, z } = xyz(earth, jde);
    // (26.3) p. 174
    return {
        x: x + 0.00000044036 * y - 0.000000190919 * z,
        y: -0.000000479966 * x + 0.917482137087 * y - 0.397776982902 * z,
        z: 0.397776982902 * y + 0.917482137087 * z
    };
}
function xyz(earth, jde) {
    const { lon, lat, range } = earth.position2000(jde);
    const s = lon + Math.PI;
    const \u03B2 = -lat;
    const [ss, cs] = (0, _baseJsDefault.default).sincos(s);
    const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(\u03B2);
    // (26.2) p. 172
    const x = range * c\u03B2 * cs;
    const y = range * c\u03B2 * ss;
    const z = range * s\u03B2;
    return {
        x,
        y,
        z
    };
}
function positionB1950(earth, jde) {
    const { x, y, z } = xyz(earth, jde);
    return {
        x: 0.999925702634 * x + 0.012189716217 * y + 0.000011134016 * z,
        y: -0.011179418036 * x + 0.917413998946 * y - 0.397777041885 * z,
        z: -0.004859003787 * x + 0.397747363646 * y + 0.917482111428 * z
    };
}
const \u03B6t = [
    2306.2181,
    0.30188,
    0.017998
];
const zt = [
    2306.2181,
    1.09468,
    0.018203
];
const \u03B8t = [
    2004.3109,
    -0.42665,
    -0.041833
];
function positionEquinox(earth, jde, epoch) {
    const xyz = positionJ2000(earth, jde);
    const x0 = xyz.x;
    const y0 = xyz.y;
    const z0 = xyz.z;
    const t = (epoch - 2000) * 0.01;
    const \u03B6 = (0, _baseJsDefault.default).horner(t, \u03B6t) * t * Math.PI / 180 / 3600;
    const z = (0, _baseJsDefault.default).horner(t, zt) * t * Math.PI / 180 / 3600;
    const \u03B8 = (0, _baseJsDefault.default).horner(t, \u03B8t) * t * Math.PI / 180 / 3600;
    const [s\u03B6, c\u03B6] = (0, _baseJsDefault.default).sincos(\u03B6);
    const [sz, cz] = (0, _baseJsDefault.default).sincos(z);
    const [s\u03B8, c\u03B8] = (0, _baseJsDefault.default).sincos(\u03B8);
    const xx = c\u03B6 * cz * c\u03B8 - s\u03B6 * sz;
    const xy = s\u03B6 * cz + c\u03B6 * sz * c\u03B8;
    const xz = c\u03B6 * s\u03B8;
    const yx = -c\u03B6 * sz - s\u03B6 * cz * c\u03B8;
    const yy = c\u03B6 * cz - s\u03B6 * sz * c\u03B8;
    const yz = -s\u03B6 * s\u03B8;
    const zx = -cz * s\u03B8;
    const zy = -sz * s\u03B8;
    const zz = c\u03B8;
    return {
        x: xx * x0 + yx * y0 + zx * z0,
        y: xy * x0 + yy * y0 + zy * z0,
        z: xz * x0 + yz * y0 + zz * z0
    };
}
exports.default = {
    position,
    longitudeJ2000,
    positionJ2000,
    xyz,
    positionB1950,
    positionEquinox
};

},{"./base.js":"cO06o","./nutation.js":"fWRWg","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9bq7":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eclipse
 */ /**
 * Eclipse: Chapter 54, Eclipses.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", ()=>TYPE);
/**
 * Solar computes quantities related to solar eclipses.
 *
 * Argument year is a decimal year specifying a date.
 *
 * eclipseType will be None, Partial, Annular, AnnularTotal, or Total.
 * If None, none of the other return values may be meaningful.
 *
 * central is true if the center of the eclipse shadow touches the Earth.
 *
 * jdeMax is the jde when the center of the eclipse shadow is closest to the
 * Earth center, in a plane through the center of the Earth.
 *
 * γ is the distance from the eclipse shadow center to the Earth center
 * at time jdeMax.
 *
 * u is the radius of the Moon's umbral cone in the plane of the Earth.
 *
 * p is the radius of the penumbral cone.
 *
 * mag is eclipse magnitude for partial eclipses.  It is not valid for other
 * eclipse types.
 *
 * γ, u, and p are in units of equatorial Earth radii.
 */ parcelHelpers.export(exports, "solar", ()=>solar);
/**
 * Lunar computes quantities related to lunar eclipses.
 *
 * Argument year is a decimal year specifying a date.
 *
 * eclipseType will be None, Penumbral, Umbral, or Total.
 * If None, none of the other return values may be meaningful.
 *
 * jdeMax is the jde when the center of the eclipse shadow is closest to the
 * Moon center, in a plane through the center of the Moon.
 *
 * γ is the distance from the eclipse shadow center to the moon center
 * at time jdeMax.
 *
 * σ is the radius of the umbral cone in the plane of the Moon.
 *
 * ρ is the radius of the penumbral cone.
 *
 * mag is eclipse magnitude.
 *
 * sd- return values are semidurations of the phases of the eclipse, in days.
 *
 * γ, σ, and ρ are in units of equatorial Earth radii.
 */ parcelHelpers.export(exports, "lunar", ()=>lunar);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _moonphaseJs = require("./moonphase.js");
var _moonphaseJsDefault = parcelHelpers.interopDefault(_moonphaseJs);
/**
 * @private
 */ const g = function(k, jm, c1, c2) {
    const ck = 1 / 1236.85;
    const p = Math.PI / 180;
    const T = k * ck;
    const F = (0, _baseJsDefault.default).horner(T, 160.7108 * p, 390.67050284 * p / ck, -0.0016118 * p, -0.00000227 * p, 0.000000011 * p);
    if (Math.abs(Math.sin(F)) > 0.36) return [
        false
    ] // no eclipse
    ;
    const eclipse = true;
    const E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    const M = (0, _baseJsDefault.default).horner(T, 2.5534 * p, 29.1053567 * p / ck, -0.0000014 * p, -0.00000011 * p);
    const M\u02B9 = (0, _baseJsDefault.default).horner(T, 201.5643 * p, 385.81693528 * p / ck, 0.0107582 * p, 0.00001238 * p, -0.000000058 * p);
    const \u03A9 = (0, _baseJsDefault.default).horner(T, 124.7746 * p, -1.56375588 * p / ck, 0.0020672 * p, 0.00000215 * p);
    const s\u03A9 = Math.sin(\u03A9);
    const F1 = F - 0.02665 * p * s\u03A9;
    const A1 = (0, _baseJsDefault.default).horner(T, 299.77 * p, 0.107408 * p / ck, -0.009173 * p);
    // (54.1) p. 380
    const jdeMax = jm + c1 * Math.sin(M\u02B9) + c2 * Math.sin(M) * E + 0.0161 * Math.sin(2 * M\u02B9) + -0.0097 * Math.sin(2 * F1) + 0.0073 * Math.sin(M\u02B9 - M) * E + -0.005 * Math.sin(M\u02B9 + M) * E + -0.0023 * Math.sin(M\u02B9 - 2 * F1) + 0.0021 * Math.sin(2 * M) * E + 0.0012 * Math.sin(M\u02B9 + 2 * F1) + 0.0006 * Math.sin(2 * M\u02B9 + M) * E + -0.0004 * Math.sin(3 * M\u02B9) + -0.0003 * Math.sin(M + 2 * F1) * E + 0.0003 * Math.sin(A1) + -0.0002 * Math.sin(M - 2 * F1) * E + -0.0002 * Math.sin(2 * M\u02B9 - M) * E + -0.0002 * s\u03A9;
    const P = 0.207 * Math.sin(M) * E + 0.0024 * Math.sin(2 * M) * E + -0.0392 * Math.sin(M\u02B9) + 0.0116 * Math.sin(2 * M\u02B9) + -0.0073 * Math.sin(M\u02B9 + M) * E + 0.0067 * Math.sin(M\u02B9 - M) * E + 0.0118 * Math.sin(2 * F1);
    const Q = 5.2207 + -0.0048 * Math.cos(M) * E + 0.002 * Math.cos(2 * M) * E + -0.3299 * Math.cos(M\u02B9) + -0.006 * Math.cos(M\u02B9 + M) * E + 0.0041 * Math.cos(M\u02B9 - M) * E;
    const [sF1, cF1] = (0, _baseJsDefault.default).sincos(F1);
    const W = Math.abs(cF1);
    const \u03B3 = (P * cF1 + Q * sF1) * (1 - 0.0048 * W);
    const u = 0.0059 + 0.0046 * Math.cos(M) * E + -0.0182 * Math.cos(M\u02B9) + 0.0004 * Math.cos(2 * M\u02B9) + -0.0005 * Math.cos(M + M\u02B9);
    return [
        eclipse,
        jdeMax,
        \u03B3,
        u,
        M\u02B9
    ] // (eclipse bool, jdeMax, γ, u, Mʹ float64)
    ;
};
const TYPE = {
    None: 0,
    Partial: 1,
    Annular: 2,
    AnnularTotal: 3,
    Penumbral: 4,
    Umbral: 5,
    Total: 6 // solar or lunar
};
/**
 * Snap returns k at specified quarter q nearest year y.
 * Cut and paste from moonphase.  Time corresponding to k needed in these
 * algorithms but otherwise not meaningful enough to export from moonphase.
 */ const snap = function(y, q) {
    const k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
};
function solar(year) {
    let eclipseType = TYPE.None;
    let mag;
    const [e, jdeMax, \u03B3, u, _] = g(snap(year, 0), (0, _moonphaseJsDefault.default).meanNew(year), -0.4075, 0.1721) // eslint-disable-line no-unused-vars
    ;
    const p = u + 0.5461;
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    const a\u03B3 = Math.abs(\u03B3);
    if (a\u03B3 > 1.5433 + u) return {
        type: eclipseType
    } // no eclipse
    ;
    const central = a\u03B3 < 0.9972 // eclipse center touches Earth
    ;
    if (!central) {
        eclipseType = TYPE.Partial // most common case
        ;
        if (a\u03B3 < 1.026) {
            if (a\u03B3 < 0.9972 + Math.abs(u)) eclipseType = TYPE.Total // report total in both cases
            ;
        }
    } else if (u < 0) eclipseType = TYPE.Total;
    else if (u > 0.0047) eclipseType = TYPE.Annular;
    else {
        const \u03C9 = 0.00464 * Math.sqrt(1 - \u03B3 * \u03B3);
        if (u < \u03C9) eclipseType = TYPE.AnnularTotal;
        else eclipseType = TYPE.Annular;
    }
    if (eclipseType === TYPE.Partial) // (54.2) p. 382
    mag = (1.5433 + u - a\u03B3) / (0.5461 + 2 * u);
    return {
        type: eclipseType,
        central,
        jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: u,
        penumbral: p
    };
}
function lunar(year) {
    let eclipseType = TYPE.None;
    let mag;
    let sdTotal;
    let sdPartial;
    let sdPenumbral;
    const [e, jdeMax, \u03B3, u, M\u02B9] = g(snap(year, 0.5), (0, _moonphaseJsDefault.default).meanFull(year), -0.4065, 0.1727);
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    const \u03C1 = 1.2848 + u;
    const \u03C3 = 0.7403 - u;
    const a\u03B3 = Math.abs(\u03B3);
    mag = (1.0128 - u - a\u03B3) / 0.545 // (54.3) p. 382
    ;
    if (mag > 1) eclipseType = TYPE.Total;
    else if (mag > 0) eclipseType = TYPE.Umbral;
    else {
        mag = (1.5573 + u - a\u03B3) / 0.545 // (54.4) p. 382
        ;
        if (mag < 0) return {
            type: eclipseType
        } // no eclipse
        ;
        eclipseType = TYPE.Penumbral;
    }
    const p = 1.0128 - u;
    const t = 0.4678 - u;
    const n = 0.5458 + 0.04 * Math.cos(M\u02B9);
    const \u03B32 = \u03B3 * \u03B3;
    /* eslint-disable no-fallthrough */ switch(eclipseType){
        case TYPE.Total:
            sdTotal = Math.sqrt(t * t - \u03B32) / n / 24;
        case TYPE.Umbral:
            sdPartial = Math.sqrt(p * p - \u03B32) / n / 24;
        default:
            {
                const h = 1.5573 + u;
                sdPenumbral = Math.sqrt(h * h - \u03B32) / n / 24;
            }
    }
    /* eslint-enable */ return {
        type: eclipseType,
        jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: \u03C3,
        penumbral: \u03C1,
        sdTotal,
        sdPartial,
        sdPenumbral
    };
}
exports.default = {
    TYPE,
    solar,
    lunar
};

},{"./base.js":"cO06o","./moonphase.js":"cRr38","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cRr38":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonphase
 */ /**
 * Moonphase: Chapter 49, Phases of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "meanLunarMonth", ()=>meanLunarMonth);
/**
 * MeanNew returns the jde of the mean New Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of New Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanNew", ()=>meanNew);
/**
 * MeanFirst returns the jde of the mean First Quarter Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of First Quarter Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanFirst", ()=>meanFirst);
/**
 * MeanFull returns the jde of the mean Full Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of Full Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanFull", ()=>meanFull);
/**
 * MeanLast returns the jde of the mean Last Quarter Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of Last Quarter Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanLast", ()=>meanLast);
/**
 * New returns the jde of New Moon nearest the given date.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "newMoon", ()=>newMoon);
/**
 * First returns the jde of First Quarter Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "first", ()=>first);
/**
 * Full returns the jde of Full Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "full", ()=>full);
/**
 * Last returns the jde of Last Quarter Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "last", ()=>last);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const { sin, cos } = Math;
const ck = 1 / 1236.85;
const D2R = Math.PI / 180;
const meanLunarMonth = 29.530588861;
// (49.1) p. 349
function mean(T) {
    return (0, _baseJsDefault.default).horner(T, 2451550.09766, 29.530588861 / ck, 0.00015437, -0.00000015, 0.00000000073);
}
/** snap returns k at specified quarter q nearest year y. */ function snap(y, q) {
    const k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
}
function meanNew(year) {
    return mean(snap(year, 0) * ck);
}
function meanFirst(year) {
    return mean(snap(year, 0.25) * ck);
}
function meanFull(year) {
    return mean(snap(year, 0.5) * ck);
}
function meanLast(year) {
    return mean(snap(year, 0.75) * ck);
}
function newMoon(year) {
    const m = new Mp(year, 0);
    return mean(m.T) + m.nfc(nc) + m.a();
}
function first(year) {
    const m = new Mp(year, 0.25);
    return mean(m.T) + m.flc() + m.w() + m.a();
}
function full(year) {
    const m = new Mp(year, 0.5);
    return mean(m.T) + m.nfc(fc) + m.a();
}
function last(year) {
    const m = new Mp(year, 0.75);
    return mean(m.T) + m.flc() - m.w() + m.a();
}
class Mp {
    // new or full corrections
    nfc(c) {
        const { M, M_, E, F, \u03A9 } = this;
        return c[0] * sin(M_) + c[1] * sin(M) * E + c[2] * sin(2 * M_) + c[3] * sin(2 * F) + c[4] * sin(M_ - M) * E + c[5] * sin(M_ + M) * E + c[6] * sin(2 * M) * E * E + c[7] * sin(M_ - 2 * F) + c[8] * sin(M_ + 2 * F) + c[9] * sin(2 * M_ + M) * E + c[10] * sin(3 * M_) + c[11] * sin(M + 2 * F) * E + c[12] * sin(M - 2 * F) * E + c[13] * sin(2 * M_ - M) * E + c[14] * sin(\u03A9) + c[15] * sin(M_ + 2 * M) + c[16] * sin(2 * (M_ - F)) + c[17] * sin(3 * M) + c[18] * sin(M_ + M - 2 * F) + c[19] * sin(2 * (M_ + F)) + c[20] * sin(M_ + M + 2 * F) + c[21] * sin(M_ - M + 2 * F) + c[22] * sin(M_ - M - 2 * F) + c[23] * sin(3 * M_ + M) + c[24] * sin(4 * M_);
    }
    // first or last corrections
    flc() {
        const { M, M_, E, F, \u03A9 } = this;
        return -0.62801 * sin(M_) + 0.17172 * sin(M) * E + -0.01183 * sin(M_ + M) * E + 0.00862 * sin(2 * M_) + 0.00804 * sin(2 * F) + 0.00454 * sin(M_ - M) * E + 0.00204 * sin(2 * M) * E * E + -0.0018 * sin(M_ - 2 * F) + -0.0007 * sin(M_ + 2 * F) + -0.0004 * sin(3 * M_) + -0.00034 * sin(2 * M_ - M) * E + 0.00032 * sin(M + 2 * F) * E + 0.00032 * sin(M - 2 * F) * E + -0.00028 * sin(M_ + 2 * M) * E * E + 0.00027 * sin(2 * M_ + M) * E + -0.00017 * sin(\u03A9) + -0.00005 * sin(M_ - M - 2 * F) + 0.00004 * sin(2 * M_ + 2 * F) + -0.00004 * sin(M_ + M + 2 * F) + 0.00004 * sin(M_ - 2 * M) + 0.00003 * sin(M_ + M - 2 * F) + 0.00003 * sin(3 * M) + 0.00002 * sin(2 * M_ - 2 * F) + 0.00002 * sin(M_ - M + 2 * F) + -0.00002 * sin(3 * M_ + M);
    }
    w() {
        const { M, M_, E, F } = this;
        return 0.00306 - 0.00038 * E * cos(M) + 0.00026 * cos(M_) - 0.00002 * (cos(M_ - M) - cos(M_ + M) - cos(2 * F));
    }
    // additional corrections
    a() {
        let a = 0;
        ac.forEach((c, i)=>{
            a += c * sin(this.A[i]);
        });
        return a;
    }
    constructor(y, q){
        this.A = new Array(14);
        const k = this.k = snap(y, q);
        const T = this.T = this.k * ck // (49.3) p. 350
        ;
        this.E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
        this.M = (0, _baseJsDefault.default).horner(T, 2.5534 * D2R, 29.1053567 * D2R / ck, -0.0000014 * D2R, -0.00000011 * D2R);
        this.M_ = (0, _baseJsDefault.default).horner(T, 201.5643 * D2R, 385.81693528 * D2R / ck, 0.0107582 * D2R, 0.00001238 * D2R, -0.000000058 * D2R);
        this.F = (0, _baseJsDefault.default).horner(T, 160.7108 * D2R, 390.67050284 * D2R / ck, -0.0016118 * D2R, -0.00000227 * D2R, 0.000000011 * D2R);
        this.\u03A9 = (0, _baseJsDefault.default).horner(T, 124.7746 * D2R, -1.56375588 * D2R / ck, 0.0020672 * D2R, 0.00000215 * D2R);
        this.A[0] = 299.7 * D2R + 0.107408 * D2R * k - 0.009173 * T * T;
        this.A[1] = 251.88 * D2R + 0.016321 * D2R * k;
        this.A[2] = 251.83 * D2R + 26.651886 * D2R * k;
        this.A[3] = 349.42 * D2R + 36.412478 * D2R * k;
        this.A[4] = 84.66 * D2R + 18.206239 * D2R * k;
        this.A[5] = 141.74 * D2R + 53.303771 * D2R * k;
        this.A[6] = 207.17 * D2R + 2.453732 * D2R * k;
        this.A[7] = 154.84 * D2R + 7.30686 * D2R * k;
        this.A[8] = 34.52 * D2R + 27.261239 * D2R * k;
        this.A[9] = 207.19 * D2R + 0.121824 * D2R * k;
        this.A[10] = 291.34 * D2R + 1.844379 * D2R * k;
        this.A[11] = 161.72 * D2R + 24.198154 * D2R * k;
        this.A[12] = 239.56 * D2R + 25.513099 * D2R * k;
        this.A[13] = 331.55 * D2R + 3.592518 * D2R * k;
    }
}
// new coefficients
const nc = [
    -0.4072,
    0.17241,
    0.01608,
    0.01039,
    0.00739,
    -0.00514,
    0.00208,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// full coefficients
const fc = [
    -0.40614,
    0.17302,
    0.01614,
    0.01043,
    0.00734,
    -0.00515,
    0.00209,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// additional corrections
const ac = [
    0.000325,
    0.000165,
    0.000164,
    0.000126,
    0.00011,
    0.000062,
    0.00006,
    0.000056,
    0.000047,
    0.000042,
    0.000040,
    0.000037,
    0.000035,
    0.000023
];
exports.default = {
    meanLunarMonth,
    meanNew,
    meanFirst,
    meanFull,
    meanLast,
    newMoon,
    new: newMoon,
    first,
    full,
    last
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hXxwv":[function(require,module,exports) {
/**
 * @copyright 2020 mdmunir
 * @copyright 2020 commenthol
 * @license MIT
 * @module elp
 */ /**
 * Elp Mpp02
 * source ftp://cyrano-se.obspm.fr/pub/2_lunar_solutions/2_elpmpp02/elpmpp02.pdf
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 */ parcelHelpers.export(exports, "Moon", ()=>Moon);
/**
 * Position returns the true geometric position of the moon as ecliptic coordinates.
 *
 * Result computed by Elp theory.  Result is at equator and equinox
 * of date in the FK5 frame.  It does not include nutation or aberration.
 *
 * @param {Object} elpData
 * @param {Number} jde - Julian ephemeris day
 * @returns {Object}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in KM
 */ parcelHelpers.export(exports, "position", ()=>position);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const SEC2RAD = 1 / 3600 * Math.PI / 180;
function sum(T, series) {
    const coeffs = [];
    Object.keys(series).forEach((x)=>{
        coeffs[x] = 0.0;
        let y = series[x].length - 1;
        for(y; y >= 0; y--){
            // A, t0, t1, t2, t3, t4
            const row = series[x][y];
            const \u03C6 = (0, _baseJsDefault.default).horner(T, row.slice(1));
            coeffs[x] += row[0] * Math.sin(\u03C6);
        }
    });
    return (0, _baseJsDefault.default).horner(T, ...coeffs);
}
class Moon {
    _calcLBR(T) {
        const L = (0, _baseJsDefault.default).horner(T, this.series.W1) + sum(T, this.series.L) * SEC2RAD;
        const B = sum(T, this.series.B) * SEC2RAD;
        const R = sum(T, this.series.R);
        return {
            L: (0, _baseJsDefault.default).pmod(L, 2 * Math.PI),
            B,
            R
        };
    }
    /**
   * Position returns rectangular coordinates referred to the inertial mean ecliptic and equinox of J2000.
   * @param {Number} jde - Julian ephemeris day
   * @return {object} rectangular coordinates
   *   {Number} x
   *   {Number} y
   *   {Number} z
   */ positionXYZ(jde) {
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const { L, B, R } = this._calcLBR(T);
        const x = R * Math.cos(L) * Math.cos(B);
        const y = R * Math.sin(L) * Math.cos(B);
        const z = R * Math.sin(B);
        const P = (0, _baseJsDefault.default).horner(T, 0, 0.10180391e-4, 0.47020439e-6, -0.0000000005417367, -0.000000000002507948, 0.463486e-14);
        const Q = (0, _baseJsDefault.default).horner(T, 0, -0.000113469002, 0.12372674e-6, 0.12654170e-8, -0.000000000001371808, -0.00000000000000320334);
        const sq = Math.sqrt(1 - P * P - Q * Q);
        const p11 = 1 - 2 * P * P;
        const p12 = 2 * P * Q;
        const p13 = 2 * P * sq;
        const p21 = 2 * P * Q;
        const p22 = 1 - 2 * Q * Q;
        const p23 = -2 * Q * sq;
        const p31 = -2 * P * sq;
        const p32 = 2 * Q * sq;
        const p33 = 1 - 2 * P * P - 2 * Q * Q;
        const result = {
            x: p11 * x + p12 * y + p13 * z,
            y: p21 * x + p22 * y + p23 * z,
            z: p31 * x + p32 * y + p33 * z
        };
        return result;
    }
    /**
   * Delay effect of light time
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Number} Delay time in days
   */ lightTime(jde) {
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const R = sum(T, this.series.R);
        return (0, _baseJsDefault.default).lightTime(R / (0, _baseJsDefault.default).AU);
    }
    /**
   * Position returns ecliptic position of moon at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those elp data,
   * that is, at equinox and ecliptic of date.
   *  {Number} lon - geocentric longitude in radians.
   *  {Number} lat - geocentric latitude in radians.
   *  {Number} range - geocentric range in KM.
   */ position(jde) {
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const { L, B, R } = this._calcLBR(T);
        // precession
        const pA = (0, _baseJsDefault.default).horner(T, 0, 5028.79695, 1.1120, 0.000077, -0.00002353) * SEC2RAD;
        return new (0, _baseJs.Coord)((0, _baseJsDefault.default).pmod(L + pA, 2 * Math.PI), B, R);
    }
    /**
   * ELP representation of a Moon
   * @constructs Moon
   * @param {object} data - elp data series
   * @example
   * ```js
   * // for use in browser
   * import {data} from 'astronomia.js'
   * const moon = new elp.Moon(data.elpMppDe)
   * ```
   */ constructor(data){
        if (typeof data !== "object") throw new TypeError("need Elp data");
        this.series = data;
    }
}
function position(elpData, jde) {
    const moon = new Moon(elpData);
    return moon.position(jde);
}
exports.default = {
    Moon,
    position
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8YjFi":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eqtime
 */ /**
 * Eqtime: Chapter 28, Equation of time.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * e computes the "equation of time" for the given JDE.
 *
 * Parameter planet must be a planetposition.Planet object for Earth obtained
 * with `new planetposition.Planet('earth')`.
 *
 * @param {Number} jde - Julian ephemeris day
 * @param {planetposition.Planet} earth - VSOP87 planet
 * @returns {Number} equation of time as an hour angle in radians.
 */ parcelHelpers.export(exports, "e", ()=>e);
/**
 * eSmart computes the "equation of time" for the given JDE.
 *
 * Result is less accurate that e() but the function has the advantage
 * of not requiring the V87Planet object.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} equation of time as an hour angle in radians.
 */ parcelHelpers.export(exports, "eSmart", ()=>eSmart);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
const { cos, sin, tan } = Math;
function e(jde, earth) {
    const \u03C4 = (0, _baseJsDefault.default).J2000Century(jde) * 0.1;
    const L0 = l0(\u03C4);
    // code duplicated from solar.ApparentEquatorialVSOP87 so that
    // we can keep Δψ and cε
    const { lon, lat, range } = (0, _solarJsDefault.default).trueVSOP87(earth, jde);
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
    const a = -20.4898 / 3600 * Math.PI / 180 / range;
    const \u03BB = lon + \u0394\u03C8 + a;
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    const eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, lat).toEquatorial(\u03B5);
    // (28.1) p. 183
    const E = L0 - 0.0057183 * Math.PI / 180 - eq.ra + \u0394\u03C8 * cos(\u03B5);
    return (0, _baseJsDefault.default).pmod(E + Math.PI, 2 * Math.PI) - Math.PI;
}
/**
 * (28.2) p. 183
 */ const l0 = function(\u03C4) {
    return (0, _baseJsDefault.default).horner(\u03C4, 280.4664567, 360007.6982779, 0.03032028, 1.0 / 49931, -1 / 15300, -0.0000005) * Math.PI / 180;
};
function eSmart(jde) {
    const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    const t = tan(\u03B5 * 0.5);
    const y = t * t;
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const L0 = l0(T * 0.1);
    const e = (0, _solarJsDefault.default).eccentricity(T);
    const M = (0, _solarJsDefault.default).meanAnomaly(T);
    const [sin2L0, cos2L0] = (0, _baseJsDefault.default).sincos(2 * L0);
    const sinM = sin(M);
    // (28.3) p. 185
    return y * sin2L0 - 2 * e * sinM + 4 * e * y * sinM * cos2L0 - y * y * sin2L0 * cos2L0 - 1.25 * e * e * sin(2 * M);
}
exports.default = {
    e,
    eSmart
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./nutation.js":"fWRWg","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"38f5t":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module fit
 */ /**
 * Fit: Chapter 4, Curve Fitting.
 */ /**
 * Linear fits a line to sample data.
 *
 * Argument p is a list of data points.  Results a and b are coefficients
 * of the best fit line y = ax + b.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", ()=>linear);
/**
 * CorrelationCoefficient returns a correlation coefficient for sample data.
 */ parcelHelpers.export(exports, "correlationCoefficient", ()=>correlationCoefficient);
/**
 * Quadratic fits y = ax² + bx + c to sample data.
 *
 * Argument p is a list of data points.  Results a, b, and c are coefficients
 * of the best fit quadratic y = ax² + bx + c.
 */ parcelHelpers.export(exports, "quadratic", ()=>quadratic);
/**
 * Func3 implements multiple linear regression for a linear combination
 * of three functions.
 *
 * Given sample data and three functions in x, Func3 returns coefficients
 * a, b, and c fitting y = aƒ₀(x) + bƒ₁(x) + cƒ₂(x) to sample data.
 */ parcelHelpers.export(exports, "func3", ()=>func3);
/**
 * Func1 fits a linear multiple of a function to sample data.
 *
 * Given sample data and a function in x, Func1 returns coefficient
 * a fitting y = aƒ(x).
 */ parcelHelpers.export(exports, "func1", ()=>func1);
function linear(points) {
    let sx = 0;
    let sy = 0;
    let sx2 = 0;
    let sxy = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        sx += x;
        sy += y;
        sx2 += x * x;
        sxy += x * y;
    }
    const n = points.length;
    const d = n * sx2 - sx * sx;
    // (4.2) p. 36
    const a = (n * sxy - sx * sy) / d;
    const b = (sy * sx2 - sx * sxy) / d;
    return [
        a,
        b
    ];
}
function correlationCoefficient(points) {
    let sx = 0;
    let sy = 0;
    let sx2 = 0;
    let sy2 = 0;
    let sxy = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        sx += x;
        sy += y;
        sx2 += x * x;
        sy2 += y * y;
        sxy += x * y;
    }
    const n = points.length;
    // (4.3) p. 38
    return (n * sxy - sx * sy) / (Math.sqrt(n * sx2 - sx * sx) * Math.sqrt(n * sy2 - sy * sy));
}
function quadratic(points) {
    let P = 0;
    let Q = 0;
    let R = 0;
    let S = 0;
    let T = 0;
    let U = 0;
    let V = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        const x2 = x * x;
        P += x;
        Q += x2;
        R += x * x2;
        S += x2 * x2;
        T += y;
        U += x * y;
        V += x2 * y;
    }
    const N = points.length;
    // (4.5) p. 43
    const D = N * Q * S + 2 * P * Q * R - Q * Q * Q - P * P * S - N * R * R;
    // (4.6) p. 43
    const a = (N * Q * V + P * R * T + P * Q * U - Q * Q * T - P * P * V - N * R * U) / D;
    const b = (N * S * U + P * Q * V + Q * R * T - Q * Q * U - P * S * T - N * R * V) / D;
    const c = (Q * S * T + Q * R * U + P * R * V - Q * Q * V - P * S * U - R * R * T) / D;
    return [
        a,
        b,
        c
    ];
}
function func3(points, f0, f1, f2) {
    let M = 0;
    let P = 0;
    let Q = 0;
    let R = 0;
    let S = 0;
    let T = 0;
    let U = 0;
    let V = 0;
    let W = 0;
    for (const p of points){
        const x = p.x;
        const y = p.y;
        const y0 = f0(x);
        const y1 = f1(x);
        const y2 = f2(x);
        M += y0 * y0;
        P += y0 * y1;
        Q += y0 * y2;
        R += y1 * y1;
        S += y1 * y2;
        T += y2 * y2;
        U += y * y0;
        V += y * y1;
        W += y * y2;
    }
    // (4.7) p. 44
    const D = M * R * T + 2 * P * Q * S - M * S * S - R * Q * Q - T * P * P;
    const a = (U * (R * T - S * S) + V * (Q * S - P * T) + W * (P * S - Q * R)) / D;
    const b = (U * (S * Q - P * T) + V * (M * T - Q * Q) + W * (P * Q - M * S)) / D;
    const c = (U * (P * S - R * Q) + V * (P * Q - M * S) + W * (M * R - P * P)) / D;
    return [
        a,
        b,
        c
    ];
}
function func1(points, f) {
    let syf = 0;
    let sf2 = 0;
    // (4.8) p. 45
    for (const p of points){
        const fx = f(p.x);
        const y = p.y;
        syf += y * fx;
        sf2 += fx * fx;
    }
    return syf / sf2;
}
exports.default = {
    linear,
    correlationCoefficient,
    quadratic,
    func3,
    func1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9L14K":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module illum
 */ /**
 * Illum: Chapter 41, Illuminated Fraction of the Disk and Magnitude of a Planet.
 *
 * Also see functions `illuminated` and `limb` in package base.  While this
 * chapter title includes "illumnated fraction," the function for computing
 * illuminated fraction given a phase angle is `base.illuminated`.
 * `base.limb` is the function mentioned at the bottom of p. 283.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PhaseAngle computes the phase angle of a planet.
 *
 * Argument r is planet's distance to Sun, Δ its distance to Earth, and R
 * the distance from Sun to Earth.  All distances in AU.
 *
 * Result in radians.
 */ parcelHelpers.export(exports, "phaseAngle", ()=>phaseAngle);
/**
 * Fraction computes the illuminated fraction of the disk of a planet.
 *
 * Argument r is planet's distance to Sun, Δ its distance to Earth, and R
 * the distance from Sun to Earth.  All distances in AU.
 */ parcelHelpers.export(exports, "fraction", ()=>fraction);
/**
 * PhaseAngle2 computes the phase angle of a planet.
 *
 * Arguments L, B, R are heliocentric ecliptical coordinates of the planet.
 * L0, R0 are longitude and radius for Earth, Δ is distance from Earth to
 * the planet.  All distances in AU, angles in radians.
 *
 * The phase angle result is in radians.
 */ parcelHelpers.export(exports, "phaseAngle2", ()=>phaseAngle2);
/**
 * PhaseAngle3 computes the phase angle of a planet.
 *
 * Arguments L, B are heliocentric ecliptical longitude and latitude of the
 * planet.  x, y, z are cartesian coordinates of the planet, Δ is distance
 * from Earth to the planet.  All distances in AU, angles in radians.
 *
 * The phase angle result is in radians.
 */ parcelHelpers.export(exports, "phaseAngle3", ()=>phaseAngle3);
/**
 * FractionVenus computes an approximation of the illumanted fraction of Venus.
 */ parcelHelpers.export(exports, "fractionVenus", ()=>fractionVenus);
/**
 * Mercury computes the visual magnitude of Mercury.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mercury", ()=>mercury);
/**
 * Venus computes the visual magnitude of Venus.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "venus", ()=>venus);
/**
 * Mars computes the visual magnitude of Mars.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mars", ()=>mars);
/**
 * Jupiter computes the visual magnitude of Jupiter.
 * Formula by G. Müller
 * Effect of phase not considered
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "jupiter", ()=>jupiter);
/**
 * Saturn computes the visual magnitude of Saturn.
 * Formula by G. Müller
 * Sun's altitude above the plane of the ring is not considered.
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 * B is the Saturnicentric latitude of the Earth referred to the plane of
 * Saturn's ring.
 * ΔU (in radians) is the difference between the Saturnicentric longitudes
 * of the Sun and the Earth, measured in the plane of the ring.
 * You can use saturndisk.Disk() to obtain B and ΔU.
 */ parcelHelpers.export(exports, "saturn", ()=>saturn);
/**
 * Uranus computes the visual magnitude of Uranus.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "uranus", ()=>uranus);
/**
 * Neptune computes the visual magnitude of Neptune.
 * Formulae by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "neptune", ()=>neptune);
/**
 * Mercury84 computes the visual magnitude of Mercury.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mercury84", ()=>mercury84);
/**
 * Venus84 computes the visual magnitude of Venus.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "venus84", ()=>venus84);
/**
 * Mars84 computes the visual magnitude of Mars.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mars84", ()=>mars84);
/**
 * Jupiter84 computes the visual magnitude of Jupiter.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "jupiter84", ()=>jupiter84);
/**
 * Saturn84 computes the visual magnitude of Saturn.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 * B is the Saturnicentric latitude of the Earth referred to the plane of
 * Saturn's ring.
 * ΔU (in radians) is the difference between the Saturnicentric longitudes
 * of the Sun and the Earth, measured in the plane of the ring.
 */ parcelHelpers.export(exports, "saturn84", ()=>saturn84);
/**
 * Uranus84 computes the visual magnitude of Uranus.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "uranus84", ()=>uranus84);
/**
 * Neptune84 computes the visual magnitude of Neptune.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "neptune84", ()=>neptune84);
/**
 * Pluto84 computes the visual magnitude of Pluto.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "pluto84", ()=>pluto84);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const { toDeg } = (0, _baseJsDefault.default);
const D2R = Math.PI / 180;
function phaseAngle(r, \u0394, R) {
    return Math.acos((r * r + \u0394 * \u0394 - R * R) / (2 * r * \u0394));
}
function fraction(r, \u0394, R) {
    // (41.2) p. 283
    const s = r + \u0394;
    return (s * s - R * R) / (4 * r * \u0394);
}
function phaseAngle2(L, B, R, L0, R0, \u0394) {
    // (41.3) p. 283
    return Math.acos((R - R0 * Math.cos(B) * Math.cos(L - L0)) / \u0394);
}
function phaseAngle3(L, B, x, y, z, \u0394) {
    // (41.4) p. 283
    const [sL, cL] = (0, _baseJsDefault.default).sincos(L);
    const [sB, cB] = (0, _baseJsDefault.default).sincos(B);
    return Math.acos((x * cB * cL + y * cB * sL + z * sB) / \u0394);
}
function fractionVenus(jde) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const V = (261.51 + 22518.443 * T) * D2R;
    const M = (177.53 + 35999.05 * T) * D2R;
    const N = (50.42 + 58517.811 * T) * D2R;
    const W = V + (1.91 * Math.sin(M) + 0.78 * Math.sin(N)) * D2R;
    const \u0394 = Math.sqrt(1.52321 + 1.44666 * Math.cos(W));
    const s = 0.72333 + \u0394;
    return (s * s - 1) / 2.89332 / \u0394;
}
function mercury(r, \u0394, i) {
    const s = toDeg(i) - 50;
    return 1.16 + 5 * Math.log10(r * \u0394) + (0.02838 + 0.0001023 * s) * s;
}
function venus(r, \u0394, i) {
    const iDeg = toDeg(i);
    return -4 + 5 * Math.log10(r * \u0394) + (0.01322 + 0.0000004247 * iDeg * iDeg) * iDeg;
}
function mars(r, \u0394, i) {
    return -1.3 + 5 * Math.log10(r * \u0394) + 0.01486 * toDeg(i);
}
function jupiter(r, \u0394) {
    return -8.93 + 5 * Math.log10(r * \u0394);
}
function saturn(r, \u0394, B, \u0394U) {
    const s = Math.sin(Math.abs(B));
    return -8.68 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs(toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function uranus(r, \u0394) {
    return -6.85 + 5 * Math.log10(r * \u0394);
}
function neptune(r, \u0394) {
    return -7.05 + 5 * Math.log10(r * \u0394);
}
function mercury84(r, \u0394, i) {
    return (0, _baseJsDefault.default).horner(toDeg(i), -0.42 + 5 * Math.log10(r * \u0394), 0.038, -0.000273, 0.000002);
}
function venus84(r, \u0394, i) {
    return (0, _baseJsDefault.default).horner(toDeg(i), -4.4 + 5 * Math.log10(r * \u0394), 0.0009, 0.000239, -0.00000065);
}
function mars84(r, \u0394, i) {
    return -1.52 + 5 * Math.log10(r * \u0394) + 0.016 * toDeg(i);
}
function jupiter84(r, \u0394, i) {
    return -9.4 + 5 * Math.log10(r * \u0394) + 0.005 * toDeg(i);
}
function saturn84(r, \u0394, B, \u0394U) {
    const s = Math.sin(Math.abs(B));
    return -8.88 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs(toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function uranus84(r, \u0394) {
    return -7.19 + 5 * Math.log10(r * \u0394);
}
function neptune84(r, \u0394) {
    return -6.87 + 5 * Math.log10(r * \u0394);
}
function pluto84(r, \u0394) {
    return -1 + 5 * Math.log10(r * \u0394);
}
exports.default = {
    phaseAngle,
    fraction,
    phaseAngle2,
    phaseAngle3,
    fractionVenus,
    mercury,
    venus,
    mars,
    jupiter,
    saturn,
    uranus,
    neptune,
    mercury84,
    venus84,
    mars84,
    jupiter84,
    saturn84,
    uranus84,
    neptune84,
    pluto84
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7bTBa":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jm
 */ /**
 * JM: Chapter 9, Jewish and Moslem Calendars.
 *
 * The Jewish calendar routines are implemented as a monolithic function,
 * because computations of the various results build off of common
 * intermediate results.
 *
 * The Moslem calendar routines break down nicely into some separate functions.
 *
 * Included in these are two functions that convert between Gregorian and
 * Julian calendar days without going through Julian day (JD).  As such,
 * I suppose, these or similar routines are not in chapter 7, Julian Day.
 * Package base might also be a suitable place for these, but I'm not sure
 * they are used anywhere else in the book.  Anyway, they have the quirk
 * that they are not direct inverses:  JulianToGregorian returns the day number
 * of the day of the Gregorian year, but GregorianToJulian wants the Gregorian
 * month and day of month as input.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * JewishCalendar returns interesting dates and facts about a given year.
 *
 * Input is a Julian or Gregorian year.
 *
 * Outputs:
 *  A:      (int) Year number in the Jewish Calendar
 *  mP:     (int) Month number of Pesach.
 *  dP:     (int) Day number of Pesach.
 *  mNY:    (int) Month number of the Jewish new year.
 *  dNY:    (int) Day number of the Jewish new year.
 *  months: (int) Number of months in this year.
 *  days:   (int) Number of days in this year.
 */ parcelHelpers.export(exports, "JewishCalendar", ()=>JewishCalendar);
/**
 * MoslemToJD converts a Moslem calendar date to a Julian Day.
 * @param {Number} y - year in moslem calendar
 * @param {Number} m - month
 * @param {Number} d - day
 * @returns {Number} jd - Julian day
 */ parcelHelpers.export(exports, "MoslemToJD", ()=>MoslemToJD);
/**
 * MoslemLeapYear returns true if year y of the Moslem calendar is a leap year.
 * @param {Number} year
 * @returns {Boolean} true if leap year
 */ parcelHelpers.export(exports, "MoslemLeapYear", ()=>MoslemLeapYear);
/**
 * @typedef {object} DateObj
 * @property {number} year
 * @property {number} month
 * @property {number} day
 */ /**
 * JulianToMoslem takes a year, month, and day of the Julian calendar and returns the equivalent year, month, and day of the Moslem calendar.
 *
 * @param {Number} y - julian year
 * @param {Number} m - julian month
 * @param {Number} d - julian day
 * @returns {DateObj}
 */ parcelHelpers.export(exports, "JulianToMoslem", ()=>JulianToMoslem);
/**
 * String returns the Romanization of the month ("Muḥarram", "Ṣafar", ...).
 */ parcelHelpers.export(exports, "moslemMonth", ()=>moslemMonth);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
const int = Math.trunc;
function JewishCalendar(y) {
    const A = y + 3760;
    const D = bigD(y);
    let mP = 3;
    let dP = D;
    if (dP > 31) {
        mP++;
        dP -= 31;
    }
    // A simplification of Meeus's rule to add 163 days.  Months of Pesach
    // are either March or April with D based off of March.  Months of New
    // year are either September or August so D+163-(days from March to
    // September == 184) = D-21 must be based off of September.
    let mNY = 9;
    let dNY = D - 21;
    if (dNY > 30) {
        mNY++;
        dNY -= 30;
    }
    let months = 12;
    switch(A % 19){
        case 0:
        case 3:
        case 6:
        case 8:
        case 11:
        case 14:
        case 17:
            months++;
            break;
    }
    // Similarly, A simplification of Meeus's rule to take the difference
    // in calendar days from NY of one year to NY of the next.  NY is based
    // on D, so difference in D is difference in day numbers of year.  Result
    // is sum of this number and the number of days in the Western calandar
    // year.
    const y1 = y + 1;
    let lf = (0, _julianJsDefault.default).LeapYearGregorian;
    if (y1 < 1583) lf = (0, _julianJsDefault.default).LeapYearJulian;
    let days = 365;
    if (lf(y1)) days++;
    days += bigD(y1) - D;
    return [
        A,
        mP,
        dP,
        mNY,
        dNY,
        months,
        days
    ];
}
const bigD = function(y) {
    const C = (0, _baseJsDefault.default).floorDiv(y, 100);
    // const S int
    let S = 0;
    if (y >= 1583) S = int((0, _baseJsDefault.default).floorDiv(3 * C - 5, 4));
    const a = (12 * y + 12) % 19;
    const b = y % 4;
    const Q = -1.904412361576 + 1.554241796621 * a + 0.25 * b - 0.003177794022 * y + S;
    const fq = Math.floor(Q);
    const iq = int(fq);
    const j = (iq + 3 * y + 5 * b + 2 - S) % 7;
    const r = Q - fq;
    // const D int
    let D;
    if (j === 2 || j === 4 || j === 6) D = iq + 23;
    else if (j === 1 && a > 6 && r >= 0.63287037) D = iq + 24;
    else if (j === 0 && a > 11 && r >= 0.897723765) D = iq + 23;
    else D = iq + 22;
    return int(D);
};
function MoslemToJD(y, m, d) {
    const N = d + (0, _baseJsDefault.default).floorDiv(295001 * (m - 1) + 9900, 10000);
    const Q = (0, _baseJsDefault.default).floorDiv(y, 30);
    const R = y % 30;
    const A = (0, _baseJsDefault.default).floorDiv(11 * R + 3, 30);
    const W = 404 * Q + 354 * R + 208 + A;
    const Q1 = (0, _baseJsDefault.default).floorDiv(W, 1461);
    const Q2 = W % 1461;
    const G = 621 + 28 * Q + 4 * Q1;
    const K = (0, _baseJsDefault.default).floorDiv(Q2 * 10000, 3652422);
    const E = (0, _baseJsDefault.default).floorDiv(3652422 * K, 10000);
    let J = Q2 - E + N - 1;
    let X = G + K;
    if (J > 366 && X % 4 === 0) {
        J -= 366;
        X++;
    } else if (J > 365 && X % 4 > 0) {
        J -= 365;
        X++;
    }
    const jd = (0, _baseJsDefault.default).floorDiv(36525 * (X - 1), 100) + 1721423 + J;
    return jd;
}
function MoslemLeapYear(year) {
    const R = year % 30;
    return (11 * R + 3) % 30 > 18;
}
function JulianToMoslem(y, m, d) {
    let W = 2;
    if (y % 4 === 0) W = 1;
    const N = (0, _baseJsDefault.default).floorDiv(275 * m, 9) - W * (0, _baseJsDefault.default).floorDiv(m + 9, 12) + d - 30;
    const A = int(y - 623);
    const B = (0, _baseJsDefault.default).floorDiv(A, 4);
    const C2 = function(A) {
        const C = A % 4;
        const C1 = 365.25001 * C;
        const C2 = Math.floor(C1);
        if (C1 - C2 > 0.5) return int(C2) + 1;
        return int(C2);
    }(A);
    const Dp = 1461 * B + 170 + C2;
    const Q = (0, _baseJsDefault.default).floorDiv(Dp, 10631);
    const R = Dp % 10631;
    const J = (0, _baseJsDefault.default).floorDiv(R, 354);
    const K = R % 354;
    const O = (0, _baseJsDefault.default).floorDiv(11 * J + 14, 30);
    let my = 30 * Q + J + 1;
    let JJ = K - O + N - 1;
    let days = 354;
    if (MoslemLeapYear(y)) days++;
    if (JJ > days) {
        JJ -= days;
        my++;
    }
    let mm;
    let md;
    if (JJ === 355) {
        mm = 12;
        md = 30;
    } else {
        const S = (0, _baseJsDefault.default).floorDiv((JJ - 1) * 10, 295);
        mm = 1 + S;
        md = (0, _baseJsDefault.default).floorDiv(10 * JJ - 295 * S, 10);
    }
    return {
        year: my,
        month: mm,
        day: md
    };
}
/**
 * An MMonth specifies a month of the Moslum Calendar (Muharram = 1, ...).
 *
 * Upgraded to Unicode from the spellings given by Meeus.
 * Source: http://en.wikipedia.org/wiki/Islamic_calendar.
 */ const mmonths = [
    "",
    "Mu\u1E25arram",
    "\u1E62afar",
    "Rab\u012B\u02BF I",
    "Rab\u012B\u02BF II",
    "Jum\u0101d\u0101 I",
    "Jum\u0101d\u0101 II",
    "Rajab",
    "Sha\u02BFb\u0101n",
    "Rama\u1E0D\u0101n",
    "Shaww\u0101l",
    "Dh\u016B al-Qa\u02BFda",
    "Dh\u016B al-\u1E24ijja"
];
function moslemMonth(m) {
    return mmonths[m];
}
exports.default = {
    JewishCalendar,
    MoslemToJD,
    MoslemLeapYear,
    JulianToMoslem,
    moslemMonth
};

},{"./base.js":"cO06o","./julian.js":"da2eV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"da2eV":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module julian
 */ /**
 * Julian: Chapter 7, Julian day.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GREGORIAN0JD", ()=>GREGORIAN0JD);
/**
 * Base class for CalendarJulian and CalendarGregorian
 * Respects the start of the Gregorian Calendar at `GREGORIAN0JD`
 */ parcelHelpers.export(exports, "Calendar", ()=>Calendar);
parcelHelpers.export(exports, "CalendarJulian", ()=>CalendarJulian);
parcelHelpers.export(exports, "CalendarGregorian", ()=>CalendarGregorian);
// -----------------------------------------------------------------------------
/**
 * base conversion from calendar date to julian day
 */ parcelHelpers.export(exports, "CalendarToJD", ()=>CalendarToJD);
/**
 * CalendarGregorianToJD converts a Gregorian year, month, and day of month
 * to Julian day.
 *
 * Negative years are valid, back to JD 0.  The result is not valid for
 * dates before JD 0.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "CalendarGregorianToJD", ()=>CalendarGregorianToJD);
/**
 * CalendarJulianToJD converts a Julian year, month, and day of month to Julian day.
 *
 * Negative years are valid, back to JD 0.  The result is not valid for
 * dates before JD 0.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "CalendarJulianToJD", ()=>CalendarJulianToJD);
/**
 * LeapYearJulian returns true if year y in the Julian calendar is a leap year.
 * @param {number} y - year (int)
 * @returns {boolean} true if leap year in Julian Calendar
 */ parcelHelpers.export(exports, "LeapYearJulian", ()=>LeapYearJulian);
/**
 * LeapYearGregorian returns true if year y in the Gregorian calendar is a leap year.
 * @param {number} y - year (int)
 * @returns {boolean} true if leap year in Gregorian Calendar
 */ parcelHelpers.export(exports, "LeapYearGregorian", ()=>LeapYearGregorian);
/**
 * JDToCalendar returns the calendar date for the given jd.
 *
 * Note that this function returns a date in either the Julian or Gregorian
 * Calendar, as appropriate.
 * @param {number} jd - Julian day (float)
 * @param {boolean} isJulian - set true for Julian Calendar, otherwise Gregorian is used
 * @returns {object} `{ (int) year, (int) month, (float) day }`
 */ parcelHelpers.export(exports, "JDToCalendar", ()=>JDToCalendar);
/**
 * JDToCalendarGregorian returns the calendar date for the given jd in the Gregorian Calendar.
 *
 * @param {number} jd - Julian day (float)
 * @returns {object} `{ (int) year, (int) month, (float) day }`
 */ parcelHelpers.export(exports, "JDToCalendarGregorian", ()=>JDToCalendarGregorian);
/**
 * JDToCalendarJulian returns the calendar date for the given jd in the Julian Calendar.
 *
 * @param {number} jd - Julian day (float)
 * @returns {object} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "JDToCalendarJulian", ()=>JDToCalendarJulian);
/**
 * isJDCalendarGregorian tests if Julian day `jd` falls into the Gregorian calendar
 * @param {number} jd - Julian day (float)
 * @returns {boolean} true for Gregorian, false for Julian calendar
 */ parcelHelpers.export(exports, "isJDCalendarGregorian", ()=>isJDCalendarGregorian);
/**
 * isCalendarGregorian tests if date falls into the Gregorian calendar
 * @param {number} year - julian/gregorian year
 * @param {number} [month] - month of julian/gregorian year
 * @param {number} [day] - day of julian/gregorian year
 * @returns {boolean} true for Gregorian, false for Julian calendar
 */ parcelHelpers.export(exports, "isCalendarGregorian", ()=>isCalendarGregorian);
/**
 * JDToDate converts a Julian day `jd` to a Date Object (Gregorian Calendar)
 *
 * Note: Javascript uses the the ISO-8601 calendar, which is a proleptic Gregorian
 * calendar, i.e. it acts as if this calendar was always in effect, even before
 * its year of introduction in 1582. Therefore dates between 1582-10-05 and
 * 1582-10-14 exists.
 *
 * @param {number} jd - Julian day (float)
 * @returns {Date}
 */ parcelHelpers.export(exports, "JDToDate", ()=>JDToDate);
/**
 * DateToJD converts a proleptic Gregorian Date into a Julian day `jd`
 * @param {Date} date
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "DateToJD", ()=>DateToJD);
/**
 * JDEToDate converts a Julian ephemeris day `jde` to a Date Object (Gregorian Calendar)
 * To obtain "Universal Time" (UT) from "Dynamical Time" (TD) the correction ΔT (in seconds) gets applied
 * ```
 * UT = TD - ΔT
 * ```
 * If your use case does not require such accuracy converting `jde` using `JDToDate` is fine.
 *
 * Note: Javascript uses the the ISO-8601 calendar, which is a proleptic Gregorian
 * calendar, i.e. it acts as if this calendar was always in effect, even before
 * its year of introduction in 1582. Therefore dates between 1582-10-05 and
 * 1582-10-14 exists.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns {Date} Javascript Date Object
 */ parcelHelpers.export(exports, "JDEToDate", ()=>JDEToDate);
/**
 * DateToJDE converts a Date Object (Gregorian Calendar) to a Julian ephemeris day `jde`
 * To obtain "Dynamical Time" (TD) from "Universal Time" (UT) the correction ΔT (in seconds) gets applied
 * ```
 * TD = UT + ΔT
 * ```
 * If your use case does not require such accuracy converting `Date` using `DateToJD` is fine.
 *
 * @param {Date} date - Javascript Date Object
 * @returns {number} jde - Julian ephemeris day (float)
 */ parcelHelpers.export(exports, "DateToJDE", ()=>DateToJDE);
/**
 * converts Modified Julian Day `mjd` to Julian Day `jd`
 * @param {Number} mjd - Modified Julian Day
 * @returns {Number} jd - Julian Day
 */ parcelHelpers.export(exports, "MJDToJD", ()=>MJDToJD);
/**
 * converts Julian Day `jd` to Modified Julian Day `mjd`
 * The MJD sometimes appear when mentioning orbital elements of artificial satellites.
 * Contrary to JD the MJD begins at Greenwich mean midnight.
 * @param {Number} jd - Julian Day
 * @returns {Number} mjd - Modified Julian Day MJD
 */ parcelHelpers.export(exports, "JDToMJD", ()=>JDToMJD);
/**
 * DayOfWeek determines the day of the week for a given JD.
 *
 * The value returned is an integer in the range 0 to 6, where 0 represents
 * Sunday.  This is the same convention followed in the time package of the
 * Javascript standard library.
 * @param {number} jd - Julian day (float)
 * @returns {number} (int) 0 == sunday; ...; 6 == saturday
 */ parcelHelpers.export(exports, "DayOfWeek", ()=>DayOfWeek);
/**
 * DayOfYearGregorian computes the day number within the year of the Gregorian
 * calendar.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYearGregorian", ()=>DayOfYearGregorian);
/**
 * DayOfYearJulian computes the day number within the year of the Julian
 * calendar.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYearJulian", ()=>DayOfYearJulian);
/**
 * DayOfYear computes the day number within the year.
 *
 * This form of the function is not specific to the Julian or Gregorian
 * calendar, but you must tell it whether the year is a leap year.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @param {boolean} leap - set `true` if `y` is leap year
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYear", ()=>DayOfYear);
/**
 * DayOfYearToCalendar returns the calendar month and day for a given
 * day of year and leap year status.
 * @param {number} n - day of year (int)
 * @param {boolean} leap - set `true` if `y` is leap year
 * @returns {object} `{ (int) month, (float) day }`
 */ parcelHelpers.export(exports, "DayOfYearToCalendar", ()=>DayOfYearToCalendar);
/**
 * DayOfYearToCalendarGregorian returns the calendar month and day for a given
 * day of year.
 * @param {number} year
 * @param {number} n - day of year (int)
 * @returns {CalendarGregorian} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "DayOfYearToCalendarGregorian", ()=>DayOfYearToCalendarGregorian);
/**
 * DayOfYearToCalendarJulian returns the calendar month and day for a given
 * day of year.
 * @param {number} year
 * @param {number} n - day of year (int)
 * @returns {CalendarJulian} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "DayOfYearToCalendarJulian", ()=>DayOfYearToCalendarJulian);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
const int = Math.trunc;
const GREGORIAN0JD = 2299160.5;
const DAYS_OF_YEAR = [
    0,
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
];
const SECS_OF_DAY = 86400 // 24 * 60 * 60
;
class Calendar {
    getDate() {
        return {
            year: this.year,
            month: this.month,
            day: Math.floor(this.day)
        };
    }
    getTime() {
        const t = new (0, _sexagesimalJsDefault.default).Time(this.day * SECS_OF_DAY);
        const [neg, h, m, _s] = t.toHMS() // eslint-disable-line no-unused-vars
        ;
        let [s, ms] = (0, _baseJsDefault.default).modf(_s);
        ms = Math.trunc(ms * 1000);
        return {
            hour: h % 24,
            minute: m,
            second: s,
            millisecond: ms
        };
    }
    toISOString() {
        const { year, month, day } = this.getDate();
        const { hour, minute, second, millisecond } = this.getTime();
        return `${pad(year, 4)}-${pad(month)}-${pad(day)}T` + `${pad(hour)}:${pad(minute)}:${pad(second)}.${pad(millisecond, 3)}Z`;
    }
    isGregorian() {
        return isCalendarGregorian(this.year, this.month, this.day);
    }
    /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @param {Date} date - proleptic Gregorian date
   */ fromDate(date) {
        this.year = date.getUTCFullYear();
        this.month = date.getUTCMonth() + 1;
        const day = date.getUTCDate();
        const hour = date.getUTCHours();
        const minute = date.getUTCMinutes();
        const second = date.getUTCSeconds();
        const ms = date.getMilliseconds();
        this.day = day + (hour + (minute + (second + ms / 1000) / 60) / 60) / 24;
        return this;
    }
    /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @returns {Date} proleptic Gregorian date
   */ toDate() {
        const [day, fhour] = (0, _baseJsDefault.default).modf(this.day);
        const [hour, fminute] = (0, _baseJsDefault.default).modf(fhour * 24);
        const [minute, fsecond] = (0, _baseJsDefault.default).modf(fminute * 60);
        const [second, fms] = (0, _baseJsDefault.default).modf(fsecond * 60);
        const date = new Date(Date.UTC(this.year, this.month - 1, day, hour, minute, second, Math.round(fms * 1000)));
        date.setUTCFullYear(this.year);
        return date;
    }
    /**
   * converts a calendar date to decimal year
   * @returns {number} decimal year
   */ toYear() {
        const [d, f] = (0, _baseJsDefault.default).modf(this.day) // eslint-disable-line no-unused-vars
        ;
        const n = this.dayOfYear() - 1 + f;
        const days = this.isLeapYear() ? 366 : 365;
        const decYear = this.year + n / days;
        return decYear;
    }
    /**
   * converts a decimal year to a calendar date
   * @param {number} year - decimal year
   */ fromYear(year) {
        const [y, f] = (0, _baseJsDefault.default).modf(year);
        this.year = y;
        const days = this.isLeapYear() ? 366 : 365;
        const dayOfYear = (0, _baseJsDefault.default).round(f * days, 5);
        let m = 12;
        while(m > 0 && DAYS_OF_YEAR[m] > dayOfYear)m--;
        this.month = m;
        this.day = 1 + dayOfYear - DAYS_OF_YEAR[this.month];
        return this;
    }
    isLeapYear() {
        if (this.isGregorian()) return LeapYearGregorian(this.year);
        else return LeapYearJulian(this.year);
    }
    toJD() {
        return CalendarToJD(this.year, this.month, this.day, !this.isGregorian());
    }
    fromJD(jd) {
        const isJulian = !isJDCalendarGregorian(jd);
        const { year, month, day } = JDToCalendar(jd, isJulian);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    fromJDE(jde) {
        this.fromJD(jde);
        const dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
        ;
        this.day -= dT / 86400;
        return this;
    }
    toJDE() {
        const dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
        ;
        this.day += dT / 86400;
        return this.toJD();
    }
    /**
   * set date to midnight UTC
   */ midnight() {
        this.day = Math.floor(this.day);
        return this;
    }
    /**
   * set date to noon UTC
   */ noon() {
        this.day = Math.floor(this.day) + 0.5;
        return this;
    }
    /**
   * @param {Boolean} td - if `true` calendar instance is in TD; date gets converted to UT
   *   true  - `UT = TD - ΔT`
   *   false - `TD = UT + ΔT`
   */ deltaT(td) {
        const dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
        ;
        if (td) this.day -= dT / 86400;
        else this.day += dT / 86400;
        return this;
    }
    dayOfWeek() {
        return DayOfWeek(this.toJD());
    }
    dayOfYear() {
        if (this.isGregorian()) return DayOfYearGregorian(this.year, this.month, this.day);
        else return DayOfYearJulian(this.year, this.month, this.day);
    }
    /**
   * @param {number|Date} [year] - If `Date` is given then year, month, day is taken from that. Shortcut to `new Calendar().fromDate(date)`
   * @param {number} [month]
   * @param {number} [day]
   */ constructor(year, month = 1, day = 1){
        if (year instanceof Date) this.fromDate(year);
        else {
            this.year = year;
            this.month = month;
            this.day = day;
        }
    }
}
class CalendarJulian extends Calendar {
    toJD() {
        return CalendarJulianToJD(this.year, this.month, this.day);
    }
    fromJD(jd) {
        const { year, month, day } = JDToCalendarJulian(jd);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    isLeapYear() {
        return LeapYearJulian(this.year);
    }
    dayOfYear() {
        return DayOfYearJulian(this.year, this.month, this.day);
    }
    /**
   * toGregorian converts a Julian calendar date to a year, month, and day
   * in the Gregorian calendar.
   * @returns {CalendarGregorian}
   */ toGregorian() {
        const jd = this.toJD();
        return new CalendarGregorian().fromJD(jd);
    }
}
class CalendarGregorian extends Calendar {
    toJD() {
        return CalendarGregorianToJD(this.year, this.month, this.day);
    }
    fromJD(jd) {
        const { year, month, day } = JDToCalendarGregorian(jd);
        this.year = year;
        this.month = month;
        this.day = day;
        return this;
    }
    isLeapYear() {
        return LeapYearGregorian(this.year);
    }
    dayOfYear() {
        return DayOfYearGregorian(this.year, this.month, this.day);
    }
    /*
  * toJulian converts a Gregorian calendar date to a year, month, and day
  * in the Julian calendar.
  * @returns {CalendarJulian}
  */ toJulian() {
        const jd = this.toJD();
        return new CalendarJulian().fromJD(jd);
    }
}
function CalendarToJD(y, m, d, isJulian) {
    let b = 0;
    if (m < 3) {
        y--;
        m += 12;
    }
    if (!isJulian) {
        const a = (0, _baseJsDefault.default).floorDiv(y, 100);
        b = 2 - a + (0, _baseJsDefault.default).floorDiv(a, 4);
    }
    // (7.1) p. 61
    const jd = (0, _baseJsDefault.default).floorDiv(36525 * int(y + 4716), 100) + ((0, _baseJsDefault.default).floorDiv(306 * (m + 1), 10) + b) + d - 1524.5;
    return jd;
}
function CalendarGregorianToJD(y, m, d) {
    return CalendarToJD(y, m, d, false);
}
function CalendarJulianToJD(y, m, d) {
    return CalendarToJD(y, m, d, true);
}
function LeapYearJulian(y) {
    return y % 4 === 0;
}
function LeapYearGregorian(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function JDToCalendar(jd, isJulian) {
    const [z, f] = (0, _baseJsDefault.default).modf(jd + 0.5);
    let a = z;
    if (!isJulian) {
        const \u03B1 = (0, _baseJsDefault.default).floorDiv(z * 100 - 186721625, 3652425);
        a = z + 1 + \u03B1 - (0, _baseJsDefault.default).floorDiv(\u03B1, 4);
    }
    const b = a + 1524;
    const c = (0, _baseJsDefault.default).floorDiv(b * 100 - 12210, 36525);
    const d = (0, _baseJsDefault.default).floorDiv(36525 * c, 100);
    const e = int((0, _baseJsDefault.default).floorDiv((b - d) * 1e4, 306001));
    // compute return values
    let year;
    let month;
    const day = int(b - d) - (0, _baseJsDefault.default).floorDiv(306001 * e, 1e4) + f;
    if (e === 14 || e === 15) month = e - 13;
    else month = e - 1;
    if (month < 3) year = int(c) - 4715;
    else year = int(c) - 4716;
    return {
        year,
        month,
        day
    };
}
function JDToCalendarGregorian(jd) {
    return JDToCalendar(jd, false);
}
function JDToCalendarJulian(jd) {
    return JDToCalendar(jd, true);
}
function isJDCalendarGregorian(jd) {
    return jd >= GREGORIAN0JD;
}
function isCalendarGregorian(year, month = 1, day = 1) {
    return year > 1582 || year === 1582 && month > 10 || year === 1582 && month === 10 && day >= 15;
}
function JDToDate(jd) {
    return new CalendarGregorian().fromJD(jd).toDate();
}
function DateToJD(date) {
    return new CalendarGregorian().fromDate(date).toJD();
}
function JDEToDate(jde) {
    return new CalendarGregorian().fromJDE(jde).toDate();
}
function DateToJDE(date) {
    return new CalendarGregorian().fromDate(date).toJDE();
}
function MJDToJD(mjd) {
    return mjd + (0, _baseJsDefault.default).JMod;
}
function JDToMJD(jd) {
    return jd - (0, _baseJsDefault.default).JMod;
}
function DayOfWeek(jd) {
    return int(jd + 1.5) % 7;
}
function DayOfYearGregorian(y, m, d) {
    return DayOfYear(y, m, int(d), LeapYearGregorian(y));
}
function DayOfYearJulian(y, m, d) {
    return DayOfYear(y, m, int(d), LeapYearJulian(y));
}
function DayOfYear(y, m, d, leap) {
    let k = 0;
    if (leap && m > 1) k = 1;
    return k + DAYS_OF_YEAR[m] + int(d);
}
function DayOfYearToCalendar(n, leap) {
    let month;
    let k = 0;
    if (leap) k = 1;
    for(month = 1; month <= 12; month++)if (k + DAYS_OF_YEAR[month] > n) {
        month = month - 1;
        break;
    }
    const day = n - k - DAYS_OF_YEAR[month];
    return {
        month,
        day
    };
}
function DayOfYearToCalendarGregorian(year, n) {
    const { month, day } = DayOfYearToCalendar(n, LeapYearGregorian(year));
    return new CalendarGregorian(year, month, day);
}
function DayOfYearToCalendarJulian(year, n) {
    const { month, day } = DayOfYearToCalendar(n, LeapYearJulian(year));
    return new CalendarJulian(year, month, day);
}
function pad(num, len) {
    len = len || 2;
    const neg = num < 0 ? "-" : "";
    num = Math.abs(num);
    const padded = "0000" + num;
    return neg + padded.substr(padded.length - len, len);
}
exports.default = {
    GREGORIAN0JD,
    Calendar,
    CalendarJulian,
    CalendarGregorian,
    CalendarToJD,
    CalendarGregorianToJD,
    CalendarJulianToJD,
    LeapYearJulian,
    LeapYearGregorian,
    JDToCalendar,
    JDToCalendarGregorian,
    JDToCalendarJulian,
    isJDCalendarGregorian,
    isCalendarGregorian,
    JDToDate,
    DateToJD,
    JDEToDate,
    DateToJDE,
    MJDToJD,
    JDToMJD,
    DayOfWeek,
    DayOfYearGregorian,
    DayOfYearJulian,
    DayOfYear,
    DayOfYearToCalendar,
    DayOfYearToCalendarGregorian,
    DayOfYearToCalendarJulian
};

},{"./base.js":"cO06o","./sexagesimal.js":"1aKkU","./deltat.js":"2uWsU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ddsvx":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupiter
 */ /**
 * Jupiter: Chapter 42, Ephemeris for Physical Observations of Jupiter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical computes quantities for physical observations of Jupiter.
 *
 * All angular results in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth
 * @param {Planet} jupiter
 * @return {Array}
 *    {number} DS - Planetocentric declination of the Sun.
 *    {number} DE - Planetocentric declination of the Earth.
 *    {number} ω1 - Longitude of the System I central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} ω2 - Longitude of the System II central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} P -  Geocentric position angle of Jupiter's northern rotation pole.
 */ parcelHelpers.export(exports, "physical", ()=>physical);
/**
 * Physical2 computes quantities for physical observations of Jupiter.
 *
 * Results are less accurate than with Physical().
 * All angular results in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {Array}
 *    {number} DS - Planetocentric declination of the Sun.
 *    {number} DE - Planetocentric declination of the Earth.
 *    {number} ω1 - Longitude of the System I central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} ω2 - Longitude of the System II central meridian of the illuminated disk,
 *                  as seen from Earth.
 */ parcelHelpers.export(exports, "physical2", ()=>physical2);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function physical(jde, earth, jupiter) {
    // Step 1.0
    const d = jde - 2433282.5;
    const T1 = d / (0, _baseJsDefault.default).JulianCentury;
    const p = Math.PI / 180;
    const \u03B10 = 268 * p + 0.1061 * p * T1;
    const \u03B40 = 64.5 * p - 0.0164 * p * T1;
    // Step 2.0
    const W1 = 17.71 * p + 877.90003539 * p * d;
    const W2 = 16.838 * p + 870.27003539 * p * d;
    // Step 3.0
    const pos = earth.position(jde);
    let [l0, b0, R] = [
        pos.lon,
        pos.lat,
        pos.range
    ];
    const fk5 = (0, _planetpositionJsDefault.default).toFK5(l0, b0, jde);
    l0 = fk5.lon;
    b0 = fk5.lat;
    // Steps 4-7.
    const [sl0, cl0] = (0, _baseJsDefault.default).sincos(l0);
    const sb0 = Math.sin(b0);
    let \u0394 = 4.0 // surely better than 0.0
    ;
    let l = 0;
    let b = 0;
    let r = 0;
    let x = 0;
    let y = 0;
    let z = 0;
    const f = function() {
        const \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        const pos = jupiter.position(jde - \u03C4);
        l = pos.lon;
        b = pos.lat;
        r = pos.range;
        const fk5 = (0, _planetpositionJsDefault.default).toFK5(l, b, jde);
        l = fk5.lon;
        b = fk5.lat;
        const [sb, cb] = (0, _baseJsDefault.default).sincos(b);
        const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    // Step 8.0
    const \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jde);
    // Step 9.0
    const [s\u03B50, c\u03B50] = (0, _baseJsDefault.default).sincos(\u03B50);
    const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
    const [sb, cb] = (0, _baseJsDefault.default).sincos(b);
    const \u03B1s = Math.atan2(c\u03B50 * sl - s\u03B50 * sb / cb, cl);
    const \u03B4s = Math.asin(c\u03B50 * sb + s\u03B50 * cb * sl);
    // Step 10.0
    const [s\u03B4s, c\u03B4s] = (0, _baseJsDefault.default).sincos(\u03B4s);
    const [s\u03B40, c\u03B40] = (0, _baseJsDefault.default).sincos(\u03B40);
    const DS = Math.asin(-s\u03B40 * s\u03B4s - c\u03B40 * c\u03B4s * Math.cos(\u03B10 - \u03B1s));
    // Step 11.0
    const u = y * c\u03B50 - z * s\u03B50;
    const v = y * s\u03B50 + z * c\u03B50;
    let \u03B1 = Math.atan2(u, x);
    let \u03B4 = Math.atan(v / Math.hypot(x, u));
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, _baseJsDefault.default).sincos(\u03B10 - \u03B1);
    const \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    const DE = Math.asin(-s\u03B40 * s\u03B4 - c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1));
    // Step 13.0
    let \u03C91 = W1 - \u03B6 - 5.07033 * p * \u0394;
    let \u03C92 = W2 - \u03B6 - 5.02626 * p * \u0394;
    // Step 14.0
    let C = (2 * r * \u0394 + R * R - r * r - \u0394 * \u0394) / (4 * r * \u0394);
    if (Math.sin(l - l0) < 0) C = -C;
    \u03C91 = (0, _baseJsDefault.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, _baseJsDefault.default).pmod(\u03C92 + C, 2 * Math.PI);
    // Step 15.0
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
    const \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    const [s\u03B1, c\u03B1] = (0, _baseJsDefault.default).sincos(\u03B1);
    \u03B1 += 0.005693 * p * (c\u03B1 * cl0 * c\u03B5 + s\u03B1 * sl0) / c\u03B4;
    \u03B4 += 0.005693 * p * (cl0 * c\u03B5 * (s\u03B5 / c\u03B5 * c\u03B4 - s\u03B1 * s\u03B4) + c\u03B1 * s\u03B4 * sl0);
    // Step 17.0
    const t\u03B4 = s\u03B4 / c\u03B4;
    const \u0394\u03B1 = (c\u03B5 + s\u03B5 * s\u03B1 * t\u03B4) * \u0394\u03C8 - c\u03B1 * t\u03B4 * \u0394\u03B5;
    const \u0394\u03B4 = s\u03B5 * c\u03B1 * \u0394\u03C8 + s\u03B1 * \u0394\u03B5;
    const \u03B1\u02B9 = \u03B1 + \u0394\u03B1;
    const \u03B4\u02B9 = \u03B4 + \u0394\u03B4;
    const [s\u03B10, c\u03B10] = (0, _baseJsDefault.default).sincos(\u03B10);
    const t\u03B40 = s\u03B40 / c\u03B40;
    const \u0394\u03B10 = (c\u03B5 + s\u03B5 * s\u03B10 * t\u03B40) * \u0394\u03C8 - c\u03B10 * t\u03B40 * \u0394\u03B5;
    const \u0394\u03B40 = s\u03B5 * c\u03B10 * \u0394\u03C8 + s\u03B10 * \u0394\u03B5;
    const \u03B10\u02B9 = \u03B10 + \u0394\u03B10;
    const \u03B40\u02B9 = \u03B40 + \u0394\u03B40;
    // Step 18.0
    const [s\u03B4\u02B9, c\u03B4\u02B9] = (0, _baseJsDefault.default).sincos(\u03B4\u02B9);
    const [s\u03B40\u02B9, c\u03B40\u02B9] = (0, _baseJsDefault.default).sincos(\u03B40\u02B9);
    const [s\u03B10\u02B9\u03B1\u02B9, c\u03B10\u02B9\u03B1\u02B9] = (0, _baseJsDefault.default).sincos(\u03B10\u02B9 - \u03B1\u02B9);
    // (42.4) p. 290
    let P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    return [
        DS,
        DE,
        \u03C91,
        \u03C92,
        P
    ];
}
function physical2(jde) {
    const d = jde - (0, _baseJsDefault.default).J2000;
    const p = Math.PI / 180;
    const V = 172.74 * p + 0.00111588 * p * d;
    const M = 357.529 * p + 0.9856003 * p * d;
    const sV = Math.sin(V);
    const N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    const J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    const [sM, cM] = (0, _baseJsDefault.default).sincos(M);
    const [sN, cN] = (0, _baseJsDefault.default).sincos(N);
    const [s2M, c2M] = (0, _baseJsDefault.default).sincos(2 * M);
    const [s2N, c2N] = (0, _baseJsDefault.default).sincos(2 * N);
    const A = 1.915 * p * sM + 0.02 * p * s2M;
    const B = 5.555 * p * sN + 0.168 * p * s2N;
    const K = J + A - B;
    const R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    const r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    const [sK, cK] = (0, _baseJsDefault.default).sincos(K);
    const \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    const \u03C8 = Math.asin(R / \u0394 * sK);
    const dd = d - \u0394 / 173;
    let \u03C91 = 210.98 * p + 877.8169088 * p * dd + \u03C8 - B;
    let \u03C92 = 187.23 * p + 870.1869088 * p * dd + \u03C8 - B;
    let C = Math.sin(\u03C8 / 2);
    C *= C;
    if (sK > 0) C = -C;
    \u03C91 = (0, _baseJsDefault.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, _baseJsDefault.default).pmod(\u03C92 + C, 2 * Math.PI);
    const \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    const DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    const DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    return [
        DS,
        DE,
        \u03C91,
        \u03C92
    ];
}
exports.default = {
    physical,
    physical2
};

},{"./base.js":"cO06o","./nutation.js":"fWRWg","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"60tNj":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupitermoons
 */ /**
 * Jupitermoons: Chapter 44, Positions of the Satellites of Jupiter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "io", ()=>io);
parcelHelpers.export(exports, "europa", ()=>europa);
parcelHelpers.export(exports, "ganymede", ()=>ganymede);
parcelHelpers.export(exports, "callisto", ()=>callisto);
/**
 * Positions computes positions of moons of Jupiter.
 *
 * Returned coordinates are in units of Jupiter radii.
 *
 * @param {Number} jde - Julian ephemeris day
 * @return {Array} x, y - coordinates of the 4 Satellites of jupiter
 */ parcelHelpers.export(exports, "positions", ()=>positions);
/**
 * Positions computes positions of moons of Jupiter.
 *
 * High accuracy method based on theory "E5"  Results returned in
 * argument pos, which must not be undefined.  Returned coordinates in units
 * of Jupiter radii.
 *
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet earth
 * @param {Planet} jupiter - VSOP87 Planet jupiter
 * @param {Array} [pos] - reference to array of positions (same as return value)
 * @return {Array} x, y - coordinates of the 4 Satellites of jupiter
 */ parcelHelpers.export(exports, "e5", ()=>e5);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _planetelementsJs = require("./planetelements.js");
var _planetelementsJsDefault = parcelHelpers.interopDefault(_planetelementsJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
const io = 0;
const europa = 1;
const ganymede = 2;
const callisto = 3;
const k = [
    17295,
    21819,
    27558,
    36548
];
/**
 * XY used for returning coordinates of moons.
 * @param {number} x - in units of Jupiter radii
 * @param {number} y - in units of Jupiter radii
 */ function XY(x, y) {
    this.x = x;
    this.y = y;
}
function positions(jde) {
    const d = jde - (0, _baseJsDefault.default).J2000;
    const p = Math.PI / 180;
    const V = 172.74 * p + 0.00111588 * p * d;
    const M = 357.529 * p + 0.9856003 * p * d;
    const sV = Math.sin(V);
    const N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    const J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    const [sM, cM] = (0, _baseJsDefault.default).sincos(M);
    const [sN, cN] = (0, _baseJsDefault.default).sincos(N);
    const [s2M, c2M] = (0, _baseJsDefault.default).sincos(2 * M);
    const [s2N, c2N] = (0, _baseJsDefault.default).sincos(2 * N);
    const A = 1.915 * p * sM + 0.02 * p * s2M;
    const B = 5.555 * p * sN + 0.168 * p * s2N;
    const K = J + A - B;
    const R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    const r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    const [sK, cK] = (0, _baseJsDefault.default).sincos(K);
    const \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    const \u03C8 = Math.asin(R / \u0394 * sK);
    const \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    const DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    const DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    const dd = d - \u0394 / 173;
    const u1 = 163.8069 * p + 203.4058646 * p * dd + \u03C8 - B;
    const u2 = 358.414 * p + 101.2916335 * p * dd + \u03C8 - B;
    const u3 = 5.7176 * p + 50.234518 * p * dd + \u03C8 - B;
    const u4 = 224.8092 * p + 21.48798 * p * dd + \u03C8 - B;
    const G = 331.18 * p + 50.310482 * p * dd;
    const H = 87.45 * p + 21.569231 * p * dd;
    const [s212, c212] = (0, _baseJsDefault.default).sincos(2 * (u1 - u2));
    const [s223, c223] = (0, _baseJsDefault.default).sincos(2 * (u2 - u3));
    const [sG, cG] = (0, _baseJsDefault.default).sincos(G);
    const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
    const c1 = 0.473 * p * s212;
    const c2 = 1.065 * p * s223;
    const c3 = 0.165 * p * sG;
    const c4 = 0.843 * p * sH;
    const r1 = 5.9057 - 0.0244 * c212;
    const r2 = 9.3966 - 0.0882 * c223;
    const r3 = 14.9883 - 0.0216 * cG;
    const r4 = 26.3627 - 0.1939 * cH;
    const sDE = Math.sin(DE);
    const xy = function(u, r) {
        const [su, cu] = (0, _baseJsDefault.default).sincos(u);
        return new XY(r * su, -r * cu * sDE);
    };
    return [
        xy(u1 + c1, r1),
        xy(u2 + c2, r2),
        xy(u3 + c3, r3),
        xy(u4 + c4, r4)
    ];
}
function e5(jde, earth, jupiter, pos) {
    pos = pos || new Array(4);
    // variables assigned in following block
    let \u03BB0, \u03B20, t;
    let \u0394 = 5.0;
    (function() {
        const { lon, lat, range } = (0, _solarJsDefault.default).trueVSOP87(earth, jde);
        const [s, \u03B2, R] = [
            lon,
            lat,
            range
        ];
        const [ss, cs] = (0, _baseJsDefault.default).sincos(s);
        const s\u03B2 = Math.sin(\u03B2);
        let \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        let x = 0;
        let y = 0;
        let z = 0;
        function f() {
            const { lon, lat, range } = jupiter.position(jde - \u03C4);
            const [sl, cl] = (0, _baseJsDefault.default).sincos(lon);
            const [sb, cb] = (0, _baseJsDefault.default).sincos(lat);
            x = range * cb * cl + R * cs;
            y = range * cb * sl + R * ss;
            z = range * sb + R * s\u03B2;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
            \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        }
        f();
        f();
        \u03BB0 = Math.atan2(y, x);
        \u03B20 = Math.atan(z / Math.hypot(x, y));
        t = jde - 2443000.5 - \u03C4;
    })();
    const p = Math.PI / 180;
    const l1 = 106.07719 * p + 203.48895579 * p * t;
    const l2 = 175.73161 * p + 101.374724735 * p * t;
    const l3 = 120.55883 * p + 50.317609207 * p * t;
    const l4 = 84.44459 * p + 21.571071177 * p * t;
    const \u03C01 = 97.0881 * p + 0.16138586 * p * t;
    const \u03C02 = 154.8663 * p + 0.04726307 * p * t;
    const \u03C03 = 188.184 * p + 0.00712734 * p * t;
    const \u03C04 = 335.2868 * p + 0.00184 * p * t;
    const \u03C91 = 312.3346 * p - 0.13279386 * p * t;
    const \u03C92 = 100.4411 * p - 0.03263064 * p * t;
    const \u03C93 = 119.1942 * p - 0.00717703 * p * t;
    const \u03C94 = 322.6186 * p - 0.00175934 * p * t;
    const \u0393 = 0.33033 * p * Math.sin(163.679 * p + 0.0010512 * p * t) + 0.03439 * p * Math.sin(34.486 * p - 0.0161731 * p * t);
    const \u03A6\u03BB = 199.6766 * p + 0.1737919 * p * t;
    let \u03C8 = 316.5182 * p - 0.00000208 * p * t;
    const G = 30.23756 * p + 0.0830925701 * p * t + \u0393;
    const G\u02B9 = 31.97853 * p + 0.0334597339 * p * t;
    const \u03A0 = 13.469942 * p;
    const \u03A31 = 0.47259 * p * Math.sin(2 * (l1 - l2)) + -0.03478 * p * Math.sin(\u03C03 - \u03C04) + 0.01081 * p * Math.sin(l2 - 2 * l3 + \u03C03) + 0.00738 * p * Math.sin(\u03A6\u03BB) + 0.00713 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00674 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00666 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00445 * p * Math.sin(l1 - \u03C03) + -0.00354 * p * Math.sin(l1 - l2) + -0.00317 * p * Math.sin(2 * \u03C8 - 2 * \u03A0) + 0.00265 * p * Math.sin(l1 - \u03C04) + -0.00186 * p * Math.sin(G) + 0.00162 * p * Math.sin(\u03C02 - \u03C03) + 0.00158 * p * Math.sin(4 * (l1 - l2)) + -0.00155 * p * Math.sin(l1 - l3) + -0.00138 * p * Math.sin(\u03C8 + \u03C93 - 2 * \u03A0 - 2 * G) + -0.00115 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + 0.00089 * p * Math.sin(\u03C02 - \u03C04) + 0.00085 * p * Math.sin(l1 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00083 * p * Math.sin(\u03C92 - \u03C93) + 0.00053 * p * Math.sin(\u03C8 - \u03C92);
    const \u03A32 = 1.06476 * p * Math.sin(2 * (l2 - l3)) + 0.04256 * p * Math.sin(l1 - 2 * l2 + \u03C03) + 0.03581 * p * Math.sin(l2 - \u03C03) + 0.02395 * p * Math.sin(l1 - 2 * l2 + \u03C04) + 0.01984 * p * Math.sin(l2 - \u03C04) + -0.01778 * p * Math.sin(\u03A6\u03BB) + 0.01654 * p * Math.sin(l2 - \u03C02) + 0.01334 * p * Math.sin(l2 - 2 * l3 + \u03C02) + 0.01294 * p * Math.sin(\u03C03 - \u03C04) + -0.01142 * p * Math.sin(l2 - l3) + -0.01057 * p * Math.sin(G) + -0.00775 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00524 * p * Math.sin(2 * (l1 - l2)) + -0.0046 * p * Math.sin(l1 - l3) + 0.00316 * p * Math.sin(\u03C8 - 2 * G + \u03C93 - 2 * \u03A0) + -0.00203 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00146 * p * Math.sin(\u03C8 - \u03C93) + -0.00145 * p * Math.sin(2 * G) + 0.00125 * p * Math.sin(\u03C8 - \u03C94) + -0.00115 * p * Math.sin(l1 - 2 * l3 + \u03C03) + -0.00094 * p * Math.sin(2 * (l2 - \u03C92)) + 0.00086 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + -0.00086 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00078 * p * Math.sin(l2 - l4) + -0.00064 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00064 * p * Math.sin(\u03C01 - \u03C04) + -0.00063 * p * Math.sin(l1 - 2 * l3 + \u03C04) + 0.00058 * p * Math.sin(\u03C93 - \u03C94) + 0.00056 * p * Math.sin(2 * (\u03C8 - \u03A0 - G)) + 0.00056 * p * Math.sin(2 * (l2 - l4)) + 0.00055 * p * Math.sin(2 * (l1 - l3)) + 0.00052 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00043 * p * Math.sin(l1 - \u03C03) + 0.00041 * p * Math.sin(5 * (l2 - l3)) + 0.00041 * p * Math.sin(\u03C04 - \u03A0) + 0.00032 * p * Math.sin(\u03C92 - \u03C93) + 0.00032 * p * Math.sin(2 * (l3 - G - \u03A0));
    const \u03A33 = 0.1649 * p * Math.sin(l3 - \u03C03) + 0.09081 * p * Math.sin(l3 - \u03C04) + -0.06907 * p * Math.sin(l2 - l3) + 0.03784 * p * Math.sin(\u03C03 - \u03C04) + 0.01846 * p * Math.sin(2 * (l3 - l4)) + -0.0134 * p * Math.sin(G) + -0.01014 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00704 * p * Math.sin(l2 - 2 * l3 + \u03C03) + -0.0062 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00541 * p * Math.sin(l3 - l4) + 0.00381 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00235 * p * Math.sin(\u03C8 - \u03C93) + 0.00198 * p * Math.sin(\u03C8 - \u03C94) + 0.00176 * p * Math.sin(\u03A6\u03BB) + 0.0013 * p * Math.sin(3 * (l3 - l4)) + 0.00125 * p * Math.sin(l1 - l3) + -0.00119 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + 0.00109 * p * Math.sin(l1 - l2) + -0.001 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00091 * p * Math.sin(\u03C93 - \u03C94) + 0.0008 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00075 * p * Math.sin(2 * l2 - 3 * l3 + \u03C03) + 0.00072 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00069 * p * Math.sin(\u03C04 - \u03A0) + -0.00058 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + -0.00057 * p * Math.sin(l3 - 2 * l4 + \u03C04) + 0.00056 * p * Math.sin(l3 + \u03C03 - 2 * \u03A0 - 2 * G) + -0.00052 * p * Math.sin(l2 - 2 * l3 + \u03C01) + -0.0005 * p * Math.sin(\u03C02 - \u03C03) + 0.00048 * p * Math.sin(l3 - 2 * l4 + \u03C03) + -0.00045 * p * Math.sin(2 * l2 - 3 * l3 + \u03C04) + -0.00041 * p * Math.sin(\u03C02 - \u03C04) + -0.00038 * p * Math.sin(2 * G) + -0.00037 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00032 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.0003 * p * Math.sin(4 * (l3 - l4)) + 0.00029 * p * Math.sin(l3 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.00028 * p * Math.sin(\u03C93 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.00026 * p * Math.sin(l3 - \u03A0 - G) + 0.00024 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + 0.00021 * p * Math.sin(2 * (l3 - \u03A0 - G)) + -0.00021 * p * Math.sin(l3 - \u03C02) + 0.00017 * p * Math.sin(2 * (l3 - \u03C03));
    const \u03A34 = 0.84287 * p * Math.sin(l4 - \u03C04) + 0.03431 * p * Math.sin(\u03C04 - \u03C03) + -0.03305 * p * Math.sin(2 * (\u03C8 - \u03A0)) + -0.03211 * p * Math.sin(G) + -0.01862 * p * Math.sin(l4 - \u03C03) + 0.01186 * p * Math.sin(\u03C8 - \u03C94) + 0.00623 * p * Math.sin(l4 + \u03C04 - 2 * G - 2 * \u03A0) + 0.00387 * p * Math.sin(2 * (l4 - \u03C04)) + -0.00284 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00234 * p * Math.sin(2 * (\u03C8 - \u03C04)) + -0.00223 * p * Math.sin(l3 - l4) + -0.00208 * p * Math.sin(l4 - \u03A0) + 0.00178 * p * Math.sin(\u03C8 + \u03C94 - 2 * \u03C04) + 0.00134 * p * Math.sin(\u03C04 - \u03A0) + 0.00125 * p * Math.sin(2 * (l4 - G - \u03A0)) + -0.00117 * p * Math.sin(2 * G) + -0.00112 * p * Math.sin(2 * (l3 - l4)) + 0.00107 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00102 * p * Math.sin(l4 - G - \u03A0) + 0.00096 * p * Math.sin(2 * l4 - \u03C8 - \u03C94) + 0.00087 * p * Math.sin(2 * (\u03C8 - \u03C94)) + -0.00085 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + 0.00085 * p * Math.sin(l3 - 2 * l4 + \u03C04) + -0.00081 * p * Math.sin(2 * (l4 - \u03C8)) + 0.00071 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.00061 * p * Math.sin(l1 - l4) + -0.00056 * p * Math.sin(\u03C8 - \u03C93) + -0.00054 * p * Math.sin(l3 - 2 * l4 + \u03C03) + 0.00051 * p * Math.sin(l2 - l4) + 0.00042 * p * Math.sin(2 * (\u03C8 - G - \u03A0)) + 0.00039 * p * Math.sin(2 * (\u03C04 - \u03C94)) + 0.00036 * p * Math.sin(\u03C8 + \u03A0 - \u03C04 - \u03C94) + 0.00035 * p * Math.sin(2 * G\u02B9 - G + 188.37 * p) + -0.00035 * p * Math.sin(l4 - \u03C04 + 2 * \u03A0 - 2 * \u03C8) + -0.00032 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - G) + 0.0003 * p * Math.sin(2 * G\u02B9 - 2 * G + 149.15 * p) + 0.00029 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.00028 * p * Math.sin(l4 - \u03C04 + 2 * \u03C8 - 2 * \u03A0) + -0.00028 * p * Math.sin(2 * (l4 - \u03C94)) + -0.00027 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00026 * p * Math.sin(5 * G\u02B9 - 3 * G + 188.37 * p) + 0.00025 * p * Math.sin(\u03C94 - \u03C93) + -0.00025 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + -0.00023 * p * Math.sin(3 * (l3 - l4)) + 0.00021 * p * Math.sin(2 * l4 - 2 * \u03A0 - 3 * G) + -0.00021 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + 0.00019 * p * Math.sin(l4 - \u03C04 - G) + -0.00019 * p * Math.sin(2 * l4 - \u03C03 - \u03C04) + -0.00018 * p * Math.sin(l4 - \u03C04 + G) + -0.00016 * p * Math.sin(l4 + \u03C03 - 2 * \u03A0 - 2 * G);
    const L1 = l1 + \u03A31;
    const L2 = l2 + \u03A32;
    const L3 = l3 + \u03A33;
    const L4 = l4 + \u03A34;
    // variables assigned in following block
    let I;
    const X = new Array(5).fill(0);
    const Y = new Array(5).fill(0);
    const Z = new Array(5).fill(0);
    let R;
    (function() {
        const L = [
            L1,
            L2,
            L3,
            L4
        ];
        const B = [
            Math.atan(0.0006393 * Math.sin(L1 - \u03C91) + 0.0001825 * Math.sin(L1 - \u03C92) + 0.0000329 * Math.sin(L1 - \u03C93) + -0.0000311 * Math.sin(L1 - \u03C8) + 0.0000093 * Math.sin(L1 - \u03C94) + 0.0000075 * Math.sin(3 * L1 - 4 * l2 - 1.9927 * \u03A31 + \u03C92) + 0.0000046 * Math.sin(L1 + \u03C8 - 2 * \u03A0 - 2 * G)),
            Math.atan(0.0081004 * Math.sin(L2 - \u03C92) + 0.0004512 * Math.sin(L2 - \u03C93) + -0.0003284 * Math.sin(L2 - \u03C8) + 0.0001160 * Math.sin(L2 - \u03C94) + 0.0000272 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C92) + -0.0000144 * Math.sin(L2 - \u03C91) + 0.0000143 * Math.sin(L2 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000035 * Math.sin(L2 - \u03C8 + G) + -0.0000028 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C93)),
            Math.atan(0.0032402 * Math.sin(L3 - \u03C93) + -0.0016911 * Math.sin(L3 - \u03C8) + 0.0006847 * Math.sin(L3 - \u03C94) + -0.0002797 * Math.sin(L3 - \u03C92) + 0.0000321 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000051 * Math.sin(L3 - \u03C8 + G) + -0.0000045 * Math.sin(L3 - \u03C8 - G) + -0.0000045 * Math.sin(L3 + \u03C8 - 2 * \u03A0) + 0.0000037 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 3 * G) + 0.000003 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C92) + -0.0000021 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C93)),
            Math.atan(-0.0076579 * Math.sin(L4 - \u03C8) + 0.0044134 * Math.sin(L4 - \u03C94) + -0.0005112 * Math.sin(L4 - \u03C93) + 0.0000773 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000104 * Math.sin(L4 - \u03C8 + G) + -0.0000102 * Math.sin(L4 - \u03C8 - G) + 0.0000088 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 3 * G) + -0.0000038 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - G))
        ];
        R = [
            5.90569 * (1 + -0.0041339 * Math.cos(2 * (l1 - l2)) + -0.0000387 * Math.cos(l1 - \u03C03) + -0.0000214 * Math.cos(l1 - \u03C04) + 0.000017 * Math.cos(l1 - l2) + -0.0000131 * Math.cos(4 * (l1 - l2)) + 0.0000106 * Math.cos(l1 - l3) + -0.0000066 * Math.cos(l1 + \u03C03 - 2 * \u03A0 - 2 * G)),
            9.39657 * (1 + 0.0093848 * Math.cos(l1 - l2) + -0.0003116 * Math.cos(l2 - \u03C03) + -0.0001744 * Math.cos(l2 - \u03C04) + -0.0001442 * Math.cos(l2 - \u03C02) + 0.0000553 * Math.cos(l2 - l3) + 0.0000523 * Math.cos(l1 - l3) + -0.000029 * Math.cos(2 * (l1 - l2)) + 0.0000164 * Math.cos(2 * (l2 - \u03C92)) + 0.0000107 * Math.cos(l1 - 2 * l3 + \u03C03) + -0.0000102 * Math.cos(l2 - \u03C01) + -0.0000091 * Math.cos(2 * (l1 - l3))),
            14.98832 * (1 + -0.0014388 * Math.cos(l3 - \u03C03) + -0.0007917 * Math.cos(l3 - \u03C04) + 0.0006342 * Math.cos(l2 - l3) + -0.0001761 * Math.cos(2 * (l3 - l4)) + 0.0000294 * Math.cos(l3 - l4) + -0.0000156 * Math.cos(3 * (l3 - l4)) + 0.0000156 * Math.cos(l1 - l3) + -0.0000153 * Math.cos(l1 - l2) + 0.000007 * Math.cos(2 * l2 - 3 * l3 + \u03C03) + -0.0000051 * Math.cos(l3 + \u03C03 - 2 * \u03A0 - 2 * G)),
            26.36273 * (1 + -0.0073546 * Math.cos(l4 - \u03C04) + 0.0001621 * Math.cos(l4 - \u03C03) + 0.0000974 * Math.cos(l3 - l4) + -0.0000543 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.0000271 * Math.cos(2 * (l4 - \u03C04)) + 0.0000182 * Math.cos(l4 - \u03A0) + 0.0000177 * Math.cos(2 * (l3 - l4)) + -0.0000167 * Math.cos(2 * l4 - \u03C8 - \u03C94) + 0.0000167 * Math.cos(\u03C8 - \u03C94) + -0.0000155 * Math.cos(2 * (l4 - \u03A0 - G)) + 0.0000142 * Math.cos(2 * (l4 - \u03C8)) + 0.0000105 * Math.cos(l1 - l4) + 0.0000092 * Math.cos(l2 - l4) + -0.0000089 * Math.cos(l4 - \u03A0 - G) + -0.0000062 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.0000048 * Math.cos(2 * (l4 - \u03C94)))
        ];
        // p. 311
        const T0 = (jde - 2433282.423) / (0, _baseJsDefault.default).JulianCentury;
        const P = (1.3966626 * p + 0.0003088 * p * T0) * T0;
        for(const i in L)L[i] += P;
        \u03C8 += P;
        const T = (jde - (0, _baseJsDefault.default).J1900) / (0, _baseJsDefault.default).JulianCentury;
        I = 3.120262 * p + 0.0006 * p * T;
        for(const i in L){
            const [sL\u03C8, cL\u03C8] = (0, _baseJsDefault.default).sincos(L[i] - \u03C8);
            const [sB, cB] = (0, _baseJsDefault.default).sincos(B[i]);
            X[i] = R[i] * cL\u03C8 * cB;
            Y[i] = R[i] * sL\u03C8 * cB;
            Z[i] = R[i] * sB;
        }
    })();
    Z[4] = 1;
    // p. 312
    const A = new Array(5).fill(0);
    const B = new Array(5).fill(0);
    const C = new Array(5).fill(0);
    const [sI, cI] = (0, _baseJsDefault.default).sincos(I);
    const \u03A9 = (0, _planetelementsJsDefault.default).node((0, _planetelementsJsDefault.default).jupiter, jde);
    const [s\u03A9, c\u03A9] = (0, _baseJsDefault.default).sincos(\u03A9);
    const [s\u03A6, c\u03A6] = (0, _baseJsDefault.default).sincos(\u03C8 - \u03A9);
    const [si, ci] = (0, _baseJsDefault.default).sincos((0, _planetelementsJsDefault.default).inc((0, _planetelementsJsDefault.default).jupiter, jde));
    const [s\u03BB0, c\u03BB0] = (0, _baseJsDefault.default).sincos(\u03BB0);
    const [s\u03B20, c\u03B20] = (0, _baseJsDefault.default).sincos(\u03B20);
    for(const i in A){
        let a0;
        // step 1
        let a = X[i];
        let b = Y[i] * cI - Z[i] * sI;
        let c = Y[i] * sI + Z[i] * cI;
        // step 2
        a0 = a * c\u03A6 - b * s\u03A6;
        b = a * s\u03A6 + b * c\u03A6;
        a = a0;
        // step 3
        const b0 = b * ci - c * si;
        c = b * si + c * ci;
        b = b0;
        // step 4
        a0 = a * c\u03A9 - b * s\u03A9;
        b = a * s\u03A9 + b * c\u03A9;
        a = a0;
        // step 5
        a0 = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        a = a0;
        // step 6
        A[i] = a;
        B[i] = c * s\u03B20 + b * c\u03B20;
        C[i] = c * c\u03B20 - b * s\u03B20;
    }
    const [sD, cD] = (0, _baseJsDefault.default).sincos(Math.atan2(A[4], C[4]));
    // p. 313
    for(let i = 0; i < 4; i++){
        let x = A[i] * cD - C[i] * sD;
        const y = A[i] * sD + C[i] * cD;
        const z = B[i];
        // differential light time
        const d = x / R[i];
        x += Math.abs(z) / k[i] * Math.sqrt(1 - d * d);
        // perspective effect
        const W = \u0394 / (\u0394 + z / 2095);
        pos[i] = new XY(x * W, y * W);
    }
    return pos;
}
exports.default = {
    io,
    europa,
    ganymede,
    callisto,
    positions,
    e5
};

},{"./base.js":"cO06o","./planetelements.js":"3WPEg","./solar.js":"aC6LU","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3WPEg":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetelements
 */ /**
 * Planetelements: Chapter 31, Elements of Planetary Orbits.
 *
 * Partial:  Only implemented for mean equinox of date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercury", ()=>mercury);
parcelHelpers.export(exports, "venus", ()=>venus);
parcelHelpers.export(exports, "earth", ()=>earth);
parcelHelpers.export(exports, "mars", ()=>mars);
parcelHelpers.export(exports, "jupiter", ()=>jupiter);
parcelHelpers.export(exports, "saturn", ()=>saturn);
parcelHelpers.export(exports, "uranus", ()=>uranus);
parcelHelpers.export(exports, "neptune", ()=>neptune);
/**
 * Elements contains orbital elements as returned by functions in this package.
 *
 * Some other elements easily derived from these are
 *
 *  Mean Anomolay, M = Lon - Peri
 *  Argument of Perihelion, ω = Peri - Node
 *
 * @param {Number|Object} [lon]  - mean longitude, L
 * @param {Number} [axis] - semimajor axis, a
 * @param {Number} [ecc]  - eccentricity, e
 * @param {Number} [inc]  - inclination, i
 * @param {Number} [node] - longitude of ascending node, Ω
 * @param {Number} [peri] - longitude of perihelion, ϖ (Meeus likes π better)
 */ parcelHelpers.export(exports, "Elements", ()=>Elements);
/**
 * Mean returns mean orbital elements for a planet
 *
 * Argument p must be a planet const as defined above, argument e is
 * a result parameter.  A valid non-undefined pointer to an Elements struct
 * must be passed in.
 *
 * Results are referenced to mean dynamical ecliptic and equinox of date.
 *
 * Semimajor axis is in AU, angular elements are in radians.
 */ parcelHelpers.export(exports, "mean", ()=>mean);
/**
 * Inc returns mean inclination for a planet at a date.
 *
 * Result is the same as the Inc field returned by function Mean.  That is,
 * radians, referenced to mean dynamical ecliptic and equinox of date.
 */ parcelHelpers.export(exports, "inc", ()=>inc);
/**
 * Node returns mean longitude of ascending node for a planet at a date.
 *
 * Result is the same as the Node field returned by function Mean.  That is,
 * radians, referenced to mean dynamical ecliptic and equinox of date.
 */ parcelHelpers.export(exports, "node", ()=>node);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const mercury = "mercury";
const venus = "venus";
const earth = "earth";
const mars = "mars";
const jupiter = "jupiter";
const saturn = "saturn";
const uranus = "uranus";
const neptune = "neptune";
function Elements(lon, axis, ecc, inc, node, peri) {
    const o = typeof lon === "object" ? lon : {};
    this.lon = o.lon || lon;
    this.axis = o.axis || axis;
    this.ecc = o.ecc || ecc;
    this.inc = o.inc || inc;
    this.node = o.node || node;
    this.peri = o.peri || peri;
}
/**
 * Table 31.A, p. 212
 */ const cMean = {
    mercury: {
        L: [
            252.250906,
            149474.0722491,
            0.0003035,
            0.000000018
        ],
        a: [
            0.38709831
        ],
        e: [
            0.20563175,
            0.000020407,
            -0.0000000283,
            -0.00000000018
        ],
        i: [
            7.004986,
            0.0018215,
            -0.0000181,
            0.000000056
        ],
        \u03A9: [
            48.330893,
            1.1861883,
            0.00017542,
            0.000000215
        ],
        \u03D6: [
            77.456119,
            1.5564776,
            0.00029544,
            0.000000009
        ]
    },
    venus: {
        L: [
            181.979801,
            58519.2130302,
            0.00031014,
            0.000000015
        ],
        a: [
            0.72332982
        ],
        e: [
            0.00677192,
            -0.000047765,
            0.0000000981,
            0.00000000046
        ],
        i: [
            3.394662,
            0.0010037,
            -0.00000088,
            -0.000000007
        ],
        \u03A9: [
            76.67992,
            0.9011206,
            0.00040618,
            -0.000000093
        ],
        \u03D6: [
            131.563703,
            1.4022288,
            -0.00107618,
            -0.000005678
        ]
    },
    earth: {
        L: [
            100.466457,
            36000.7698278,
            0.00030322,
            0.00000002
        ],
        a: [
            1.000001018
        ],
        e: [
            0.01670863,
            -0.000042037,
            -0.0000001267,
            0.00000000014
        ],
        i: [
            0
        ],
        \u03A9: undefined,
        \u03D6: [
            102.937348,
            1.7195366,
            0.00045688,
            -0.000000018
        ]
    },
    mars: {
        L: [
            355.433,
            19141.6964471,
            0.00031052,
            0.000000016
        ],
        a: [
            1.523679342
        ],
        e: [
            0.09340065,
            0.000090484,
            -0.0000000806,
            -0.00000000025
        ],
        i: [
            1.849726,
            -0.0006011,
            0.00001276,
            -0.000000007
        ],
        \u03A9: [
            49.558093,
            0.7720959,
            0.00001557,
            0.000002267
        ],
        \u03D6: [
            336.060234,
            1.8410449,
            0.00013477,
            0.000000536
        ]
    },
    jupiter: {
        L: [
            34.351519,
            3036.3027748,
            0.0002233,
            0.000000037
        ],
        a: [
            5.202603209,
            0.0000001913
        ],
        e: [
            0.04849793,
            0.000163225,
            -0.0000004714,
            -0.00000000201
        ],
        i: [
            1.303267,
            -0.0054965,
            0.00000466,
            -0.000000002
        ],
        \u03A9: [
            100.464407,
            1.0209774,
            0.00040315,
            0.000000404
        ],
        \u03D6: [
            14.331207,
            1.6126352,
            0.00103042,
            -0.000004464
        ]
    },
    saturn: {
        L: [
            50.077444,
            1223.5110686,
            0.00051908,
            -0.00000003
        ],
        a: [
            9.554909192,
            -0.000002139,
            0.000000004
        ],
        e: [
            0.05554814,
            -0.000346641,
            -0.0000006436,
            0.0000000034
        ],
        i: [
            2.488879,
            -0.0037362,
            -0.00001519,
            0.000000087
        ],
        \u03A9: [
            113.665503,
            0.877088,
            -0.00012176,
            -0.000002249
        ],
        \u03D6: [
            93.057237,
            1.9637613,
            0.00083753,
            0.000004928
        ]
    },
    uranus: {
        L: [
            314.055005,
            429.8640561,
            0.0003039,
            0.000000026
        ],
        a: [
            19.218446062,
            -0.0000000372,
            0.00000000098
        ],
        e: [
            0.04638122,
            -0.000027293,
            0.0000000789,
            0.00000000024
        ],
        i: [
            0.773197,
            0.0007744,
            0.00003749,
            -0.000000092
        ],
        \u03A9: [
            74.005957,
            0.5211278,
            0.00133947,
            0.000018484
        ],
        \u03D6: [
            173.005291,
            1.486379,
            0.00021406,
            0.000000434
        ]
    },
    neptune: {
        L: [
            304.348665,
            219.8833092,
            0.00030882,
            0.000000018
        ],
        a: [
            30.110386869,
            -0.0000001663,
            0.00000000069
        ],
        e: [
            0.00945575,
            0.000006033,
            0,
            -0.00000000005
        ],
        i: [
            1.769953,
            -0.0093082,
            -0.00000708,
            0.000000027
        ],
        \u03A9: [
            131.784057,
            1.1022039,
            0.00025952,
            -0.000000637
        ],
        \u03D6: [
            48.120276,
            1.4262957,
            0.00038434,
            0.00000002
        ]
    }
};
function mean(p, jde, e) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const c = cMean[p];
    e = e || new Elements();
    e.lon = (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner(T, c.L) * Math.PI / 180, 2 * Math.PI);
    e.axis = (0, _baseJsDefault.default).horner(T, c.a);
    e.ecc = (0, _baseJsDefault.default).horner(T, c.e);
    e.inc = (0, _baseJsDefault.default).horner(T, c.i) * Math.PI / 180;
    e.node = (0, _baseJsDefault.default).horner(T, c.\u03A9) * Math.PI / 180;
    e.peri = (0, _baseJsDefault.default).horner(T, c.\u03D6) * Math.PI / 180;
    return e;
}
function inc(p, jde) {
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), cMean[p].i) * Math.PI / 180;
}
function node(p, jde) {
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), cMean[p].\u03A9) * Math.PI / 180;
}
exports.default = {
    mercury,
    venus,
    earth,
    mars,
    jupiter,
    saturn,
    uranus,
    neptune,
    Elements,
    mean,
    inc,
    node
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"l9f2i":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module line
 */ /**
 * Line: Chapter 19, Bodies in Straight Line
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Time computes the time at which a moving body is on a straight line (great
 * circle) between two fixed points, such as stars.
 *
 * Coordinates may be right ascensions and declinations or longitudes and
 * latitudes.  Fixed points are r1, d1, r2, d2.  Moving body is an ephemeris
 * of 5 rows, r3, d3, starting at time t1 and ending at time t5.  Time scale
 * is arbitrary.
 *
 * @throws Error
 * @param {Number} r1 - right ascension Coordinate 1
 * @param {Number} d1 - declination Coordinate 1
 * @param {Number} r2 - right ascension Coordinate 2
 * @param {Number} d2 - declination Coordinate 2
 * @param {Number[]} r3 - right ascension Coordinate 3
 * @param {Number[]} d3 - declination Coordinate 3
 * @param {Number} t1 - time in Julian Days
 * @param {Number} t5 - time in Julian Days
 * @returns {Number} time of alignment in Julian Days
 */ parcelHelpers.export(exports, "time", ()=>time);
/**
 * Angle returns the angle between great circles defined by three points.
 *
 * Coordinates may be right ascensions and declinations or longitudes and
 * latitudes.  If r1, d1, r2, d2 defines one line and r2, d2, r3, d3 defines
 * another, the result is the angle between the two lines.
 *
 * Algorithm by Meeus.
 */ parcelHelpers.export(exports, "angle", ()=>angle);
/**
 * Error returns an error angle of three nearly co-linear points.
 *
 * For the line defined by r1, d1, r2, d2, the result is the anglular distance
 * between that line and r0, d0.
 *
 * Algorithm by Meeus.
 */ parcelHelpers.export(exports, "error", ()=>error);
/**
 * AngleError returns both an angle as in the function Angle, and an error
 * as in the function Error.
 *
 * The algorithm is by B. Pessens.
 *
 * @returns {Number[]} [ψ, ω]
 *  {Number} ψ - angle between great circles defined by three points.
 *  {Number} ω - error angle of three nearly co-linear points
 */ parcelHelpers.export(exports, "angleError", ()=>angleError);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
function time(r1, d1, r2, d2, r3, d3, t1, t5) {
    if (r3.length !== 5 || d3.length !== 5) throw new Error("r3, d3 must be length 5");
    const gc = new Array(5);
    r3.forEach((r3i, i)=>{
        // (19.1) p. 121
        gc[i] = Math.tan(d1) * Math.sin(r2 - r3i) + Math.tan(d2) * Math.sin(r3i - r1) + Math.tan(d3[i]) * Math.sin(r1 - r2);
    });
    const l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, gc);
    return l5.zero(false);
}
function angle(r1, d1, r2, d2, r3, d3) {
    const [sd2, cd2] = (0, _baseJsDefault.default).sincos(d2);
    const [sr21, cr21] = (0, _baseJsDefault.default).sincos(r2 - r1);
    const [sr32, cr32] = (0, _baseJsDefault.default).sincos(r3 - r2);
    const C1 = Math.atan2(sr21, cd2 * Math.tan(d1) - sd2 * cr21);
    const C2 = Math.atan2(sr32, cd2 * Math.tan(d3) - sd2 * cr32);
    return C1 + C2;
}
function error(r1, d1, r2, d2, r0, d0) {
    const [sr1, cr1] = (0, _baseJsDefault.default).sincos(r1);
    const [sd1, cd1] = (0, _baseJsDefault.default).sincos(d1);
    const [sr2, cr2] = (0, _baseJsDefault.default).sincos(r2);
    const [sd2, cd2] = (0, _baseJsDefault.default).sincos(d2);
    const X1 = cd1 * cr1;
    const X2 = cd2 * cr2;
    const Y1 = cd1 * sr1;
    const Y2 = cd2 * sr2;
    const Z1 = sd1;
    const Z2 = sd2;
    const A = Y1 * Z2 - Z1 * Y2;
    const B = Z1 * X2 - X1 * Z2;
    const C = X1 * Y2 - Y1 * X2;
    const m = Math.tan(r0);
    const n = Math.tan(d0) / Math.cos(r0);
    return Math.asin((A + B * m + C * n) / (Math.sqrt(A * A + B * B + C * C) * Math.sqrt(1 + m * m + n * n)));
}
function angleError(r1, d1, r2, d2, r3, d3) {
    const [sr1, cr1] = (0, _baseJsDefault.default).sincos(r1);
    const [c1, cd1] = (0, _baseJsDefault.default).sincos(d1);
    const [sr2, cr2] = (0, _baseJsDefault.default).sincos(r2);
    const [c2, cd2] = (0, _baseJsDefault.default).sincos(d2);
    const [sr3, cr3] = (0, _baseJsDefault.default).sincos(r3);
    const [c3, cd3] = (0, _baseJsDefault.default).sincos(d3);
    const a1 = cd1 * cr1;
    const a2 = cd2 * cr2;
    const a3 = cd3 * cr3;
    const b1 = cd1 * sr1;
    const b2 = cd2 * sr2;
    const b3 = cd3 * sr3;
    const l1 = b1 * c2 - b2 * c1;
    const l2 = b2 * c3 - b3 * c2;
    const l3 = b1 * c3 - b3 * c1;
    const m1 = c1 * a2 - c2 * a1;
    const m2 = c2 * a3 - c3 * a2;
    const m3 = c1 * a3 - c3 * a1;
    const n1 = a1 * b2 - a2 * b1;
    const n2 = a2 * b3 - a3 * b2;
    const n3 = a1 * b3 - a3 * b1;
    const \u03C8 = Math.acos((l1 * l2 + m1 * m2 + n1 * n2) / (Math.sqrt(l1 * l1 + m1 * m1 + n1 * n1) * Math.sqrt(l2 * l2 + m2 * m2 + n2 * n2)));
    const \u03C9 = Math.asin((a2 * l3 + b2 * m3 + c2 * n3) / (Math.sqrt(a2 * a2 + b2 * b2 + c2 * c2) * Math.sqrt(l3 * l3 + m3 * m3 + n3 * n3)));
    return [
        \u03C8,
        \u03C9
    ];
}
exports.default = {
    time,
    angle,
    error,
    angleError
};

},{"./base.js":"cO06o","./interpolation.js":"isMMq","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hFm3Y":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nearparabolic
 */ /**
 * Nearparabolic: Chapter 35, Near-parabolic Motion.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Elements holds orbital elements for near-parabolic orbits.
 */ parcelHelpers.export(exports, "Elements", ()=>Elements);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
class Elements {
    /**
   * AnomalyDistance returns true anomaly and distance for near-parabolic orbits.
   *
   * True anomaly ν returned in radians. Distance r returned in AU.
   * An error is returned if the algorithm fails to converge.
   */ anomalyDistance(jde) {
        // fairly literal translation of code on p. 246
        const q1 = (0, _baseJsDefault.default).K * Math.sqrt((1 + this.ecc) / this.pDis) / (2 * this.pDis // line 20
        );
        const g = (1 - this.ecc) / (1 + this.ecc // line 20
        );
        const t = jde - this.timeP // line 22
        ;
        if (t === 0) return {
            ano: 0,
            dist: this.pDis,
            err: null
        };
        const d1 = 1e4;
        const d = 1e-9 // line 14
        ;
        const q2 = q1 * t // line 28
        ;
        let s = 2.0 / (3 * Math.abs(q2) // line 30
        );
        s = 2 / Math.tan(2 * Math.atan(Math.cbrt(Math.tan(Math.atan(s) / 2))));
        if (t < 0) s = -s;
        if (this.ecc !== 1) {
            let l = 0 // line 38
            ;
            for(;;){
                const s0 = s // line 40
                ;
                let z = 1.0;
                const y = s * s;
                let g1 = -y * s;
                let q3 = q2 + 2 * g * s * y / 3 // line 42
                ;
                for(;;){
                    z += 1 // line 44
                    ;
                    g1 = -g1 * g * y // line 46
                    ;
                    const z1 = (z - (z + 1) * g) / (2 * z + 1 // line 48
                    );
                    const f = z1 * g1 // line 50
                    ;
                    q3 += f // line 52
                    ;
                    if (z > 50 || Math.abs(f) > d1) return {
                        err: new Error("No convergence")
                    };
                    if (Math.abs(f) <= d) break;
                }
                l++ // line 58
                ;
                if (l > 50) return {
                    err: new Error("No convergence")
                };
                for(;;){
                    const s1 = s // line 60
                    ;
                    s = (2 * s * s * s / 3 + q3) / (s * s + 1);
                    if (Math.abs(s - s1) <= d) break;
                }
                if (Math.abs(s - s0) <= d) break;
            }
        }
        let \u03BD = 2 * Math.atan(s) // line 66
        ;
        const r = this.pDis * (1 + this.ecc) / (1 + this.ecc * Math.cos(\u03BD) // line 68
        );
        if (\u03BD < 0) \u03BD += 2 * Math.PI;
        return {
            ano: \u03BD,
            dist: r,
            err: null
        };
    }
    /**
   * @param {Number} timeP - time of Perihelion, T
   * @param {Number} pDis - Perihelion distance, q
   * @param {Number} ecc - eccentricity, e
   */ constructor(timeP, pDis, ecc){
        this.timeP = timeP;
        this.pDis = pDis;
        this.ecc = ecc;
    }
}
exports.default = {
    Elements
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1yqmf":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module node
 */ /**
 * Node: Chapter 39, Passages through the Nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * EllipticAscending computes time and distance of passage through the ascending node of a body in an elliptical orbit.
 *
 * Argument axis is semimajor axis in AU, ecc is eccentricity, argP is argument
 * of perihelion in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "ellipticAscending", ()=>ellipticAscending);
/**
 * EllipticAscending computes time and distance of passage through the descending node of a body in an elliptical orbit.
 *
 * Argument axis is semimajor axis in AU, ecc is eccentricity, argP is argument
 * of perihelion in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "ellipticDescending", ()=>ellipticDescending);
parcelHelpers.export(exports, "el", ()=>el);
/**
 * ParabolicAscending computes time and distance of passage through the ascending node of a body in a parabolic orbit.
 *
 * Argument q is perihelion distance in AU, argP is argument of perihelion
 * in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "parabolicAscending", ()=>parabolicAscending);
/**
 * ParabolicDescending computes time and distance of passage through the descending node of a body in a parabolic orbit.
 *
 * Argument q is perihelion distance in AU, argP is argument of perihelion
 * in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "parabolicDescending", ()=>parabolicDescending);
parcelHelpers.export(exports, "pa", ()=>pa);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function ellipticAscending(axis, ecc, argP, timeP) {
    return el(-argP, axis, ecc, timeP);
}
function ellipticDescending(axis, ecc, argP, timeP) {
    return el(Math.PI - argP, axis, ecc, timeP);
}
function el(\u03BD, axis, ecc, timeP) {
    const E = 2 * Math.atan(Math.sqrt((1 - ecc) / (1 + ecc)) * Math.tan(\u03BD * 0.5));
    const [sE, cE] = (0, _baseJsDefault.default).sincos(E);
    const M = E - ecc * sE;
    const n = (0, _baseJsDefault.default).K / axis / Math.sqrt(axis);
    const jde = timeP + M / n;
    const r = axis * (1 - ecc * cE);
    return [
        jde,
        r
    ];
}
function parabolicAscending(q, argP, timeP) {
    return pa(-argP, q, timeP);
}
function parabolicDescending(q, argP, timeP) {
    return pa(Math.PI - argP, q, timeP);
}
function pa(\u03BD, q, timeP) {
    const s = Math.tan(\u03BD * 0.5);
    const jde = timeP + 27.403895 * s * (s * s + 3) * q * Math.sqrt(q);
    const r = q * (1 + s * s);
    return [
        jde,
        r
    ];
}
exports.default = {
    ellipticAscending,
    ellipticDescending,
    el,
    parabolicAscending,
    parabolicDescending,
    pa
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6wSU0":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module mars
 */ /**
 * Mars: Chapter 42, Ephemeris for Physical Observations of Mars.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical computes quantities for physical observations of Mars.
 *
 * Results:
 *  DE  planetocentric declination of the Earth.
 *  DS  planetocentric declination of the Sun.
 *  ω   Areographic longitude of the central meridian, as seen from Earth.
 *  P   Geocentric position angle of Mars' northern rotation pole.
 *  Q   Position angle of greatest defect of illumination.
 *  d   Apparent diameter of Mars.
 *  k   Illuminated fraction of the disk.
 *  q   Greatest defect of illumination.
 *
 * All angular results (all results except k) are in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth
 * @param {Planet} mars
 */ parcelHelpers.export(exports, "physical", ()=>physical);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _illumJs = require("./illum.js");
var _illumJsDefault = parcelHelpers.interopDefault(_illumJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function physical(jde, earth, mars) {
    // Step 1.0
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const p = Math.PI / 180;
    // (42.1) p. 288
    let \u03BB0 = 352.9065 * p + 1.1733 * p * T;
    const \u03B20 = 63.2818 * p - 0.00394 * p * T;
    // Step 2.0
    const earthPos = earth.position(jde);
    const R = earthPos.range;
    const fk5 = (0, _planetpositionJsDefault.default).toFK5(earthPos.lon, earthPos.lat, jde);
    const [l0, b0] = [
        fk5.lon,
        fk5.lat
    ];
    // Steps 3, 4.0
    const [sl0, cl0] = (0, _baseJsDefault.default).sincos(l0);
    const sb0 = Math.sin(b0);
    let \u0394 = 0.5 // surely better than 0.0
    ;
    let \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    let l = 0;
    let b = 0;
    let r = 0;
    let x = 0;
    let y = 0;
    let z = 0;
    function f() {
        const marsPos = mars.position(jde - \u03C4);
        r = marsPos.range;
        const fk5 = (0, _planetpositionJsDefault.default).toFK5(marsPos.lon, marsPos.lat, jde);
        l = fk5.lon;
        b = fk5.lat;
        const [sb, cb] = (0, _baseJsDefault.default).sincos(b);
        const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
        \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    }
    f();
    f();
    // Step 5.0
    let \u03BB = Math.atan2(y, x);
    let \u03B2 = Math.atan(z / Math.hypot(x, y));
    // Step 6.0
    const [s\u03B20, c\u03B20] = (0, _baseJsDefault.default).sincos(\u03B20);
    const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(\u03B2);
    const DE = Math.asin(-s\u03B20 * s\u03B2 - c\u03B20 * c\u03B2 * Math.cos(\u03BB0 - \u03BB));
    // Step 7.0
    const N = 49.5581 * p + 0.7721 * p * T;
    const l\u02B9 = l - 0.00697 * p / r;
    const b\u02B9 = b - 0.000225 * p * Math.cos(l - N) / r;
    // Step 8.0
    const [sb\u02B9, cb\u02B9] = (0, _baseJsDefault.default).sincos(b\u02B9);
    const DS = Math.asin(-s\u03B20 * sb\u02B9 - c\u03B20 * cb\u02B9 * Math.cos(\u03BB0 - l\u02B9));
    // Step 9.0
    const W = 11.504 * p + 350.89200025 * p * (jde - \u03C4 - 2433282.5);
    // Step 10.0
    const \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jde);
    const [s\u03B50, c\u03B50] = (0, _baseJsDefault.default).sincos(\u03B50);
    let eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B50);
    const [\u03B10, \u03B40] = [
        eq.ra,
        eq.dec
    ];
    // Step 11.0
    const u = y * c\u03B50 - z * s\u03B50;
    const v = y * s\u03B50 + z * c\u03B50;
    const \u03B1 = Math.atan2(u, x);
    const \u03B4 = Math.atan(v / Math.hypot(x, u));
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const [s\u03B40, c\u03B40] = (0, _baseJsDefault.default).sincos(\u03B40);
    const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, _baseJsDefault.default).sincos(\u03B10 - \u03B1);
    const \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    const \u03C9 = (0, _baseJsDefault.default).pmod(W - \u03B6, 2 * Math.PI);
    // Step 13.0
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
    // Step 14.0
    const [sl0\u03BB, cl0\u03BB] = (0, _baseJsDefault.default).sincos(l0 - \u03BB);
    \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
    \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
    // Step 15.0
    \u03BB0 += \u0394\u03C8;
    \u03BB += \u0394\u03C8;
    const \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
    const [\u03B10\u02B9, \u03B40\u02B9] = [
        eq.ra,
        eq.dec
    ];
    eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
    const [\u03B1\u02B9, \u03B4\u02B9] = [
        eq.ra,
        eq.dec
    ];
    // Step 17.0
    const [s\u03B40\u02B9, c\u03B40\u02B9] = (0, _baseJsDefault.default).sincos(\u03B40\u02B9);
    const [s\u03B4\u02B9, c\u03B4\u02B9] = (0, _baseJsDefault.default).sincos(\u03B4\u02B9);
    const [s\u03B10\u02B9\u03B1\u02B9, c\u03B10\u02B9\u03B1\u02B9] = (0, _baseJsDefault.default).sincos(\u03B10\u02B9 - \u03B1\u02B9);
    // (42.4) p. 290
    let P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    // Step 18.0
    const s = l0 + Math.PI;
    const [ss, cs] = (0, _baseJsDefault.default).sincos(s);
    const \u03B1s = Math.atan2(c\u03B5 * ss, cs);
    const \u03B4s = Math.asin(s\u03B5 * ss);
    const [s\u03B4s, c\u03B4s] = (0, _baseJsDefault.default).sincos(\u03B4s);
    const [s\u03B1s\u03B1, c\u03B1s\u03B1] = (0, _baseJsDefault.default).sincos(\u03B1s - \u03B1);
    const \u03C7 = Math.atan2(c\u03B4s * s\u03B1s\u03B1, s\u03B4s * c\u03B4 - c\u03B4s * s\u03B4 * c\u03B1s\u03B1);
    const Q = \u03C7 + Math.PI;
    // Step 19.0
    const d = 0.0026 * Math.PI / 180 / \u0394;
    const k = (0, _illumJsDefault.default).fraction(r, \u0394, R);
    const q = (1 - k) * d;
    return [
        DE,
        DS,
        \u03C9,
        P,
        Q,
        d,
        k,
        q
    ];
}
exports.default = {
    physical
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./illum.js":"9L14K","./nutation.js":"fWRWg","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2ukWd":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moon
 */ /**
 * Moon: Chapter 53, Ephemeris for Physical Observations of the Moon.
 *
 * Incomplete.  Topocentric functions are commented out for lack of test data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical returns quantities useful for physical observation of the Moon.
 *
 * Returned l, b are librations in selenographic longitude and latitude.
 * They represent combined optical and physical librations.  Topocentric
 * librations are not considered.
 *
 * Returned P is the the position angle of the Moon's axis of rotation.
 *
 * Returned l0, b0 are the selenographic coordinates of the Sun.
 *
 * Returned values all in radians.

 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return {Array}
 *    {base.Coord} cMoon - selenographic longitude, latitude of the Moon
 *    {number} P - position angle of the Moon's axis of rotation
 *    {base.Coord} cSun - selenographic longitude, latitude of the Sun.
 */ parcelHelpers.export(exports, "physical", ()=>physical);
/**
 * Quantities computed for a jde and used in computing return values of
 * physical().  Computations are broken into several methods to organize
 * the code.
 */ parcelHelpers.export(exports, "Moon", ()=>Moon);
/* commented out for lack of test data
export function Topocentric (jde, ρsφ_, ρcφ_, L) { // (jde, ρsφ_, ρcφ_, L float64)  (l, b, P float64)
  λ, β, Δ := moonposition.Position(jde) // (λ without nutation)
  Δψ, Δε := nutation.Nutation(jde)
  sε, cε := base.sincos(nutation.MeanObliquity(jde) + Δε)
  α, δ := coord.EclToEq(λ+Δψ, β, sε, cε)
  α, δ = parallax.Topocentric(α, δ, Δ/base.AU, ρsφ_, ρcφ_, L, jde)
  λ, β = coord.EqToEcl(α, δ, sε, cε)
  const m = newMoon(jde)
  l, b = m.lib(λ, β)
  P = m.pa(λ, β, b)
  return
}

export function TopocentricCorrections (jde, b, P, φ, δ, H, π) { // (jde, b, P, φ, δ, H, π float64)  (Δl, Δb, ΔP float64)
  sφ, cφ := base.sincos(φ)
  sH, cH := base.sincos(H)
  sδ, cδ := base.sincos(δ)
  const Q = Math.atan(cφ * sH / (cδ*sφ - sδ*cφ*cH))
  const z = Math.acos(sδ*sφ + cδ*cφ*cH)
  const π_ = π * (sin(z) + 0.0084*sin(2*z))
  sQP, cQP := base.sincos(Q - P)
  Δl = -π_ * sQP / cos(b)
  Δb = π_ * cQP
  ΔP = Δl*sin(b+Δb) - π_*sin(Q)*Math.tan(δ)
  return
}
*/ /**
 * SunAltitude returns altitude of the Sun above the lunar horizon.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Coord} cSun - selenographic coordinates of the Sun (as returned by physical(), for example.)
 * @return altitude in radians.
 */ parcelHelpers.export(exports, "sunAltitude", ()=>sunAltitude);
/**
 * Sunrise returns time of sunrise for a point on the Moon near the given date.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return time of sunrise as a jde nearest the given jde.
 */ parcelHelpers.export(exports, "sunrise", ()=>sunrise);
/**
 * Sunset returns time of sunset for a point on the Moon near the given date.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return time of sunset as a jde nearest the given jde.
 */ parcelHelpers.export(exports, "sunset", ()=>sunset);
parcelHelpers.export(exports, "selenographic", ()=>selenographic);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _moonpositionJs = require("./moonposition.js");
var _moonpositionJsDefault = parcelHelpers.interopDefault(_moonpositionJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
const { sin, cos, asin, atan2 } = Math;
const D2R = Math.PI / 180;
const _I = 1.54242 * D2R // IAU value of inclination of mean lunar equator
;
const [sI, cI] = (0, _baseJsDefault.default).sincos(_I);
function physical(jde, earth) {
    const { lon, lat, range } = (0, _moonpositionJsDefault.default).position(jde) // (λ without nutation)
    ;
    // [λ, β, Δ]
    const m = new Moon(jde);
    const [l, b] = m.lib(lon, lat);
    const P = m.pa(lon, lat, b);
    const [l0, b0] = m.sun(lon, lat, range, earth);
    const cMoon = new (0, _baseJsDefault.default).Coord(l, b);
    const cSun = new (0, _baseJsDefault.default).Coord(l0, b0);
    return [
        cMoon,
        P,
        cSun
    ];
}
class Moon {
    /**
   * lib() curiously serves for computing both librations and solar coordinates,
   * depending on the coordinates λ, β passed in.  Quantity A not described in
   * the book, but clearly depends on the λ, β of the current context and so
   * does not belong in the moon struct.  Instead just return it from optical
   * and pass it along to physical.
   */ lib(\u03BB, \u03B2) {
        const [l_, b_, A] = this.optical(\u03BB, \u03B2);
        const [l$, b$] = this.physical(A, b_);
        let l = l_ + l$;
        if (l > Math.PI) l -= 2 * Math.PI;
        const b = b_ + b$;
        return [
            l,
            b
        ];
    }
    optical(\u03BB, \u03B2) {
        // (53.1) p. 372
        const W = \u03BB - this.\u03A9 // (λ without nutation)
        ;
        const [sW, cW] = (0, _baseJsDefault.default).sincos(W);
        const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(\u03B2);
        const A = atan2(sW * c\u03B2 * cI - s\u03B2 * sI, cW * c\u03B2);
        const l_ = (0, _baseJsDefault.default).pmod(A - this.F, 2 * Math.PI);
        const b_ = asin(-sW * c\u03B2 * sI - s\u03B2 * cI);
        return [
            l_,
            b_,
            A
        ];
    }
    physical(A, b_) {
        // (53.2) p. 373
        const [sA, cA] = (0, _baseJsDefault.default).sincos(A);
        const l$ = -this.\u03C4 + (this.\u03C1 * cA + this.\u03C3 * sA) * Math.tan(b_);
        const b$ = this.\u03C3 * cA - this.\u03C1 * sA;
        return [
            l$,
            b$
        ];
    }
    pa(\u03BB, \u03B2, b) {
        const V = this.\u03A9 + this.\u0394\u03C8 + this.\u03C3 / sI;
        const [sV, cV] = (0, _baseJsDefault.default).sincos(V);
        const [sI\u03C1, cI\u03C1] = (0, _baseJsDefault.default).sincos(_I + this.\u03C1);
        const X = sI\u03C1 * sV;
        const Y = sI\u03C1 * cV * this.c\u03B5 - cI\u03C1 * this.s\u03B5;
        const \u03C9 = Math.atan2(X, Y);
        const ecl = new (0, _coordJsDefault.default).Ecliptic(\u03BB + this.\u0394\u03C8, \u03B2).toEquatorial(this.\u03B5) // eslint-disable-line no-unused-vars
        ;
        let P = asin(Math.hypot(X, Y) * cos(ecl.ra - \u03C9) / cos(b));
        if (P < 0) P += 2 * Math.PI;
        return P;
    }
    sun(\u03BB, \u03B2, \u0394, earth) {
        const { lon, lat, range } = (0, _solarJsDefault.default).apparentVSOP87(earth, this.jde) // eslint-disable-line no-unused-vars
        ;
        const \u0394R = \u0394 / (range * (0, _baseJsDefault.default).AU);
        const \u03BBH = lon + Math.PI + 57.296 * D2R * \u0394R * cos(\u03B2) * sin(lon - \u03BB);
        const \u03B2H = \u0394R * \u03B2;
        return this.lib(\u03BBH, \u03B2H);
    }
    constructor(jde){
        this.jde = jde;
        // Δψ, F, Ω, p. 372.0
        const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
        this.\u0394\u03C8 = \u0394\u03C8;
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        const F = this.F = (0, _baseJsDefault.default).horner(T, 93.272095 * D2R, 483202.0175233 * D2R, -0.0036539 * D2R, -D2R / 3526000, D2R / 863310000);
        this.\u03A9 = (0, _baseJsDefault.default).horner(T, 125.0445479 * D2R, -1934.1362891 * D2R, 0.0020754 * D2R, D2R / 467441, -D2R / 60616000);
        // true ecliptic
        this.\u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
        this.s\u03B5 = sin(this.\u03B5);
        this.c\u03B5 = cos(this.\u03B5);
        // ρ, σ, τ, p. 372,373
        const D = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
        const M = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
        const M_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
        const E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
        const K1 = 119.75 * D2R + 131.849 * D2R * T;
        const K2 = 72.56 * D2R + 20.186 * D2R * T;
        this.\u03C1 = -0.02752 * D2R * cos(M_) + -0.02245 * D2R * sin(F) + 0.00684 * D2R * cos(M_ - 2 * F) + -0.00293 * D2R * cos(2 * F) + -0.00085 * D2R * cos(2 * (F - D)) + -0.00054 * D2R * cos(M_ - 2 * D) + -0.0002 * D2R * sin(M_ + F) + -0.0002 * D2R * cos(M_ + 2 * F) + -0.0002 * D2R * cos(M_ - F) + 0.00014 * D2R * cos(M_ + 2 * (F - D));
        this.\u03C3 = -0.02816 * D2R * sin(M_) + 0.02244 * D2R * cos(F) + -0.00682 * D2R * sin(M_ - 2 * F) + -0.00279 * D2R * sin(2 * F) + -0.00083 * D2R * sin(2 * (F - D)) + 0.00069 * D2R * sin(M_ - 2 * D) + 0.0004 * D2R * cos(M_ + F) + -0.00025 * D2R * sin(2 * M_) + -0.00023 * D2R * sin(M_ + 2 * F) + 0.0002 * D2R * cos(M_ - F) + 0.00019 * D2R * sin(M_ - F) + 0.00013 * D2R * sin(M_ + 2 * (F - D)) + -0.0001 * D2R * cos(M_ - 3 * F);
        this.\u03C4 = 0.0252 * D2R * sin(M) * E + 0.00473 * D2R * sin(2 * (M_ - F)) + -0.00467 * D2R * sin(M_) + 0.00396 * D2R * sin(K1) + 0.00276 * D2R * sin(2 * (M_ - D)) + 0.00196 * D2R * sin(this.\u03A9) + -0.00183 * D2R * cos(M_ - F) + 0.00115 * D2R * sin(M_ - 2 * D) + -0.00096 * D2R * sin(M_ - D) + 0.00046 * D2R * sin(2 * (F - D)) + -0.00039 * D2R * sin(M_ - F) + -0.00032 * D2R * sin(M_ - M - D) + 0.00027 * D2R * sin(2 * (M_ - D) - M) + 0.00023 * D2R * sin(K2) + -0.00014 * D2R * sin(2 * D) + 0.00014 * D2R * cos(2 * (M_ - F)) + -0.00012 * D2R * sin(M_ - 2 * F) + -0.00012 * D2R * sin(2 * M_) + 0.00011 * D2R * sin(2 * (M_ - M - D));
    }
}
function sunAltitude(cOnMoon, cSun) {
    const c0 = Math.PI / 2 - cSun.lon;
    const [sb0, cb0] = (0, _baseJsDefault.default).sincos(cSun.lat);
    const [s\u03B8, c\u03B8] = (0, _baseJsDefault.default).sincos(cOnMoon.lat);
    return asin(sb0 * s\u03B8 + cb0 * c\u03B8 * sin(c0 + cOnMoon.lon));
}
function sunrise(cOnMoon, jde, earth) {
    jde -= srCorr(cOnMoon, jde, earth);
    return jde - srCorr(cOnMoon, jde, earth);
}
function sunset(cOnMoon, jde, earth) {
    jde += srCorr(cOnMoon, jde, earth);
    return jde + srCorr(cOnMoon, jde, earth);
}
/**
 * @private
 */ function srCorr(cOnMoon, jde, earth) {
    const phy = physical(jde, earth);
    const h = sunAltitude(cOnMoon, phy[2]);
    return h / (12.19075 * D2R * cos(cOnMoon.lat));
}
const lunarCoord = (\u03B7, \u03B8)=>new (0, _baseJsDefault.default).Coord(\u03B7 * D2R, \u03B8 * D2R);
const selenographic = {
    archimedes: lunarCoord(-3.9, 29.7),
    aristarchus: lunarCoord(-47.5, 23.7),
    aristillus: lunarCoord(1.2, 33.9),
    aristoteles: lunarCoord(17.3, 50.1),
    arzachel: lunarCoord(-1.9, -17.7),
    autolycus: lunarCoord(1.5, 30.7),
    billy: lunarCoord(-50, -13.8),
    birt: lunarCoord(-8.5, -22.3),
    campanus: lunarCoord(-27.7, -28),
    censorinus: lunarCoord(32.7, -0.4),
    clavius: lunarCoord(-14, -58),
    copernicus: lunarCoord(-20, 9.7),
    delambre: lunarCoord(17.5, -1.9),
    dionysius: lunarCoord(17.3, 2.8),
    endymion: lunarCoord(56.4, 53.6),
    eratosthenes: lunarCoord(-11.3, 14.5),
    eudoxus: lunarCoord(16.3, 44.3),
    fracastorius: lunarCoord(33.2, -21),
    fraMauro: lunarCoord(-17, -6),
    gassendi: lunarCoord(-39.9, -17.5),
    goclenius: lunarCoord(45, -10.1),
    grimaldi: lunarCoord(-68.5, -5.8),
    harpalus: lunarCoord(-43.4, 52.6),
    horrocks: lunarCoord(5.9, -4),
    kepler: lunarCoord(-38, 8.1),
    langrenus: lunarCoord(60.9, -8.9),
    lansberg: lunarCoord(-26.6, -0.3),
    letronne: lunarCoord(-43, -10),
    macrobius: lunarCoord(46, 21.2),
    manilius: lunarCoord(9.1, 14.5),
    menelaus: lunarCoord(16, 16.3),
    messier: lunarCoord(47.6, -1.9),
    petavius: lunarCoord(61, -25),
    pico: lunarCoord(-8.8, 45.8),
    pitatus: lunarCoord(-13.5, -29.8),
    piton: lunarCoord(-0.8, 40.8),
    plato: lunarCoord(-9.2, 51.4),
    plinius: lunarCoord(23.6, 15.3),
    posidonius: lunarCoord(30, 31.9),
    proclus: lunarCoord(46.9, 16.1),
    ptolemeusA: lunarCoord(-0.8, -8.5),
    pytheas: lunarCoord(-20.6, 20.5),
    reinhold: lunarCoord(-22.8, 3.2),
    riccioli: lunarCoord(-74.3, -3.2),
    schickard: lunarCoord(-54.5, -44),
    schiller: lunarCoord(-39, -52),
    tauruntius: lunarCoord(46.5, 5.6),
    theophilus: lunarCoord(26.5, -11.4),
    timocharis: lunarCoord(-13.1, 26.7),
    tycho: lunarCoord(-11, -43.2),
    vitruvius: lunarCoord(31.3, 17.6),
    walter: lunarCoord(1, -33)
};
exports.default = {
    physical,
    Moon,
    // Topocentric,
    // TopocentricCorrections,
    sunAltitude,
    sunrise,
    sunset,
    selenographic
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./moonposition.js":"9Akcu","./nutation.js":"fWRWg","./solar.js":"aC6LU","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9Akcu":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonposition
 */ /**
 * Moonposition: Chapter 47, Position of the Moon.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * parallax returns equatorial horizontal parallax of the Moon.
 *
 * @param {Number} distance - distance between centers of the Earth and Moon, in km.
 * @returns {Number} Result in radians.
 */ parcelHelpers.export(exports, "parallax", ()=>parallax);
/**
 * position returns geocentric location of the Moon.
 *
 * Results are referenced to mean equinox of date and do not include
 * the effect of nutation.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns {Coord}
 *  {number} lon - Geocentric longitude λ, in radians.
 *  {number} lat - Geocentric latitude β, in radians.
 *  {number} range - Distance Δ between centers of the Earth and Moon, in km.
 */ parcelHelpers.export(exports, "position", ()=>position);
/**
 * Node returns longitude of the mean ascending node of the lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "node", ()=>node);
/**
 * perigee returns longitude of perigee of the lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "perigee", ()=>perigee);
/**
 * trueNode returns longitude of the true ascending node.
 *
 * That is, the node of the instantaneous lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "trueNode", ()=>trueNode);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const { asin, sin } = Math;
const D2R = Math.PI / 180;
const EARTH_RADIUS = 6378.137 // km
;
function parallax(distance) {
    // p. 337
    return asin(EARTH_RADIUS / distance);
}
function dmf(T) {
    const d = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
    const m = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
    const m_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
    const f = (0, _baseJsDefault.default).horner(T, 93.272095 * D2R, 483202.0175233 * D2R, -0.0036539 * D2R, -D2R / 3526000, D2R / 863310000);
    return [
        d,
        m,
        m_,
        f
    ];
}
function position(jde) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const l_ = (0, _baseJsDefault.default).horner(T, 218.3164477 * D2R, 481267.88123421 * D2R, -0.0015786 * D2R, D2R / 538841, -D2R / 65194000);
    const [d, m, m_, f] = dmf(T);
    const a1 = 119.75 * D2R + 131.849 * D2R * T;
    const a2 = 53.09 * D2R + 479264.29 * D2R * T;
    const a3 = 313.45 * D2R + 481266.484 * D2R * T;
    const e = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    const e2 = e * e;
    let \u03A3l = 3958 * sin(a1) + 1962 * sin(l_ - f) + 318 * sin(a2);
    let \u03A3r = 0.0;
    let \u03A3b = -2235 * sin(l_) + 382 * sin(a3) + 175 * sin(a1 - f) + 175 * sin(a1 + f) + 127 * sin(l_ - m_) - 115 * sin(l_ + m_);
    ta.forEach((r)=>{
        const [sina, cosa] = (0, _baseJsDefault.default).sincos(d * r.d + m * r.m + m_ * r.m_ + f * r.f);
        switch(r.m){
            case 0:
                \u03A3l += r.\u03A3l * sina;
                \u03A3r += r.\u03A3r * cosa;
                break;
            case -1:
            case 1:
                \u03A3l += r.\u03A3l * sina * e;
                \u03A3r += r.\u03A3r * cosa * e;
                break;
            case -2:
            case 2:
                \u03A3l += r.\u03A3l * sina * e2;
                \u03A3r += r.\u03A3r * cosa * e2;
                break;
        }
    });
    tb.forEach((r)=>{
        const sb = sin(d * r.d + m * r.m + m_ * r.m_ + f * r.f);
        switch(r.m){
            case 0:
                \u03A3b += r.\u03A3b * sb;
                break;
            case -1:
            case 1:
                \u03A3b += r.\u03A3b * sb * e;
                break;
            case -2:
            case 2:
                \u03A3b += r.\u03A3b * sb * e2;
                break;
        }
    });
    const lon = (0, _baseJsDefault.default).pmod(l_, 2 * Math.PI) + \u03A3l * 1e-6 * D2R;
    const lat = \u03A3b * 1e-6 * D2R;
    const range = 385000.56 + \u03A3r * 1e-3;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
const ta = function() {
    const ta = [
        [
            0,
            0,
            1,
            0,
            6288774,
            -20905355
        ],
        [
            2,
            0,
            -1,
            0,
            1274027,
            -3699111
        ],
        [
            2,
            0,
            0,
            0,
            658314,
            -2955968
        ],
        [
            0,
            0,
            2,
            0,
            213618,
            -569925
        ],
        [
            0,
            1,
            0,
            0,
            -185116,
            48888
        ],
        [
            0,
            0,
            0,
            2,
            -114332,
            -3149
        ],
        [
            2,
            0,
            -2,
            0,
            58793,
            246158
        ],
        [
            2,
            -1,
            -1,
            0,
            57066,
            -152138
        ],
        [
            2,
            0,
            1,
            0,
            53322,
            -170733
        ],
        [
            2,
            -1,
            0,
            0,
            45758,
            -204586
        ],
        [
            0,
            1,
            -1,
            0,
            -40923,
            -129620
        ],
        [
            1,
            0,
            0,
            0,
            -34720,
            108743
        ],
        [
            0,
            1,
            1,
            0,
            -30383,
            104755
        ],
        [
            2,
            0,
            0,
            -2,
            15327,
            10321
        ],
        [
            0,
            0,
            1,
            2,
            -12528,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            10980,
            79661
        ],
        [
            4,
            0,
            -1,
            0,
            10675,
            -34782
        ],
        [
            0,
            0,
            3,
            0,
            10034,
            -23210
        ],
        [
            4,
            0,
            -2,
            0,
            8548,
            -21636
        ],
        [
            2,
            1,
            -1,
            0,
            -7888,
            24208
        ],
        [
            2,
            1,
            0,
            0,
            -6766,
            30824
        ],
        [
            1,
            0,
            -1,
            0,
            -5163,
            -8379
        ],
        [
            1,
            1,
            0,
            0,
            4987,
            -16675
        ],
        [
            2,
            -1,
            1,
            0,
            4036,
            -12831
        ],
        [
            2,
            0,
            2,
            0,
            3994,
            -10445
        ],
        [
            4,
            0,
            0,
            0,
            3861,
            -11650
        ],
        [
            2,
            0,
            -3,
            0,
            3665,
            14403
        ],
        [
            0,
            1,
            -2,
            0,
            -2689,
            -7003
        ],
        [
            2,
            0,
            -1,
            2,
            -2602,
            0
        ],
        [
            2,
            -1,
            -2,
            0,
            2390,
            10056
        ],
        [
            1,
            0,
            1,
            0,
            -2348,
            6322
        ],
        [
            2,
            -2,
            0,
            0,
            2236,
            -9884
        ],
        [
            0,
            1,
            2,
            0,
            -2120,
            5751
        ],
        [
            0,
            2,
            0,
            0,
            -2069,
            0
        ],
        [
            2,
            -2,
            -1,
            0,
            2048,
            -4950
        ],
        [
            2,
            0,
            1,
            -2,
            -1773,
            4130
        ],
        [
            2,
            0,
            0,
            2,
            -1595,
            0
        ],
        [
            4,
            -1,
            -1,
            0,
            1215,
            -3958
        ],
        [
            0,
            0,
            2,
            2,
            -1110,
            0
        ],
        [
            3,
            0,
            -1,
            0,
            -892,
            3258
        ],
        [
            2,
            1,
            1,
            0,
            -810,
            2616
        ],
        [
            4,
            -1,
            -2,
            0,
            759,
            -1897
        ],
        [
            0,
            2,
            -1,
            0,
            -713,
            -2117
        ],
        [
            2,
            2,
            -1,
            0,
            -700,
            2354
        ],
        [
            2,
            1,
            -2,
            0,
            691,
            0
        ],
        [
            2,
            -1,
            0,
            -2,
            596,
            0
        ],
        [
            4,
            0,
            1,
            0,
            549,
            -1423
        ],
        [
            0,
            0,
            4,
            0,
            537,
            -1117
        ],
        [
            4,
            -1,
            0,
            0,
            520,
            -1571
        ],
        [
            1,
            0,
            -2,
            0,
            -487,
            -1739
        ],
        [
            2,
            1,
            0,
            -2,
            -399,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            -381,
            -4421
        ],
        [
            1,
            1,
            1,
            0,
            351,
            0
        ],
        [
            3,
            0,
            -2,
            0,
            -340,
            0
        ],
        [
            4,
            0,
            -3,
            0,
            330,
            0
        ],
        [
            2,
            -1,
            2,
            0,
            327,
            0
        ],
        [
            0,
            2,
            1,
            0,
            -323,
            1165
        ],
        [
            1,
            1,
            -1,
            0,
            299,
            0
        ],
        [
            2,
            0,
            3,
            0,
            294,
            0
        ],
        [
            2,
            0,
            -1,
            -2,
            0,
            8752
        ]
    ];
    return ta.map((row)=>{
        const o = {};
        const vals = [
            "d",
            "m",
            "m_",
            "f",
            "\u03A3l",
            "\u03A3r"
        ];
        vals.forEach((D2R, i)=>{
            o[D2R] = row[i];
        });
        return o;
    });
}();
const tb = function() {
    const tb = [
        [
            0,
            0,
            0,
            1,
            5128122
        ],
        [
            0,
            0,
            1,
            1,
            280602
        ],
        [
            0,
            0,
            1,
            -1,
            277693
        ],
        [
            2,
            0,
            0,
            -1,
            173237
        ],
        [
            2,
            0,
            -1,
            1,
            55413
        ],
        [
            2,
            0,
            -1,
            -1,
            46271
        ],
        [
            2,
            0,
            0,
            1,
            32573
        ],
        [
            0,
            0,
            2,
            1,
            17198
        ],
        [
            2,
            0,
            1,
            -1,
            9266
        ],
        [
            0,
            0,
            2,
            -1,
            8822
        ],
        [
            2,
            -1,
            0,
            -1,
            8216
        ],
        [
            2,
            0,
            -2,
            -1,
            4324
        ],
        [
            2,
            0,
            1,
            1,
            4200
        ],
        [
            2,
            1,
            0,
            -1,
            -3359
        ],
        [
            2,
            -1,
            -1,
            1,
            2463
        ],
        [
            2,
            -1,
            0,
            1,
            2211
        ],
        [
            2,
            -1,
            -1,
            -1,
            2065
        ],
        [
            0,
            1,
            -1,
            -1,
            -1870
        ],
        [
            4,
            0,
            -1,
            -1,
            1828
        ],
        [
            0,
            1,
            0,
            1,
            -1794
        ],
        [
            0,
            0,
            0,
            3,
            -1749
        ],
        [
            0,
            1,
            -1,
            1,
            -1565
        ],
        [
            1,
            0,
            0,
            1,
            -1491
        ],
        [
            0,
            1,
            1,
            1,
            -1475
        ],
        [
            0,
            1,
            1,
            -1,
            -1410
        ],
        [
            0,
            1,
            0,
            -1,
            -1344
        ],
        [
            1,
            0,
            0,
            -1,
            -1335
        ],
        [
            0,
            0,
            3,
            1,
            1107
        ],
        [
            4,
            0,
            0,
            -1,
            1021
        ],
        [
            4,
            0,
            -1,
            1,
            833
        ],
        [
            0,
            0,
            1,
            -3,
            777
        ],
        [
            4,
            0,
            -2,
            1,
            671
        ],
        [
            2,
            0,
            0,
            -3,
            607
        ],
        [
            2,
            0,
            2,
            -1,
            596
        ],
        [
            2,
            -1,
            1,
            -1,
            491
        ],
        [
            2,
            0,
            -2,
            1,
            -451
        ],
        [
            0,
            0,
            3,
            -1,
            439
        ],
        [
            2,
            0,
            2,
            1,
            422
        ],
        [
            2,
            0,
            -3,
            -1,
            421
        ],
        [
            2,
            1,
            -1,
            1,
            -366
        ],
        [
            2,
            1,
            0,
            1,
            -351
        ],
        [
            4,
            0,
            0,
            1,
            331
        ],
        [
            2,
            -1,
            1,
            1,
            315
        ],
        [
            2,
            -2,
            0,
            -1,
            302
        ],
        [
            0,
            0,
            1,
            3,
            -283
        ],
        [
            2,
            1,
            1,
            -1,
            -229
        ],
        [
            1,
            1,
            0,
            -1,
            223
        ],
        [
            1,
            1,
            0,
            1,
            223
        ],
        [
            0,
            1,
            -2,
            -1,
            -220
        ],
        [
            2,
            1,
            -1,
            -1,
            -220
        ],
        [
            1,
            0,
            1,
            1,
            -185
        ],
        [
            2,
            -1,
            -2,
            -1,
            181
        ],
        [
            0,
            1,
            2,
            1,
            -177
        ],
        [
            4,
            0,
            -2,
            -1,
            176
        ],
        [
            4,
            -1,
            -1,
            -1,
            166
        ],
        [
            1,
            0,
            1,
            -1,
            -164
        ],
        [
            4,
            0,
            1,
            -1,
            132
        ],
        [
            1,
            0,
            -1,
            -1,
            -119
        ],
        [
            4,
            -1,
            0,
            -1,
            115
        ],
        [
            2,
            -2,
            0,
            1,
            107
        ]
    ];
    return tb.map((row)=>{
        const o = {};
        const vals = [
            "d",
            "m",
            "m_",
            "f",
            "\u03A3b"
        ];
        vals.forEach((D2R, i)=>{
            o[D2R] = row[i];
        });
        return o;
    });
}();
function node(jde) {
    return (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), 125.0445479 * D2R, -1934.1362891 * D2R, 0.0020754 * D2R, D2R / 467441, -D2R / 60616000), 2 * Math.PI);
}
function perigee(jde) {
    return (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), 83.3532465 * D2R, 4069.0137287 * D2R, -0.01032 * D2R, -D2R / 80053, D2R / 18999000), 2 * Math.PI);
}
function trueNode(jde) {
    const [d, m, m_, f] = dmf((0, _baseJsDefault.default).J2000Century(jde));
    return node(jde) + -1.4979 * D2R * sin(2 * (d - f)) + -0.15 * D2R * sin(m) + -0.1226 * D2R * sin(2 * d) + 0.1176 * D2R * sin(2 * f) + -0.0801 * D2R * sin(2 * (m_ - f));
}
exports.default = {
    parallax,
    position,
    node,
    perigee,
    trueNode
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"45UAB":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonillum
 */ /**
 * Moonillum: Chapter 48, Illuminated Fraction of the Moon's Disk
 *
 * Also see functions `illuminated` and `limb` in package base.  The function
 * for computing illuminated fraction given a phase angle (48.1) is
 * base.illuminated.  Formula (48.3) is implemented as base.limb.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * phaseAngleEquatorial computes the phase angle of the Moon given equatorial coordinates.
 *
 * @param {Coord} cMoon - geocentric right ascension,  declination and distance to the Moon
 * @param {Coord} cSun - coordinates and distance of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEquatorial", ()=>phaseAngleEquatorial);
/**
 * phaseAngleEquatorial2 computes the phase angle of the Moon given equatorial coordinates.
 *
 * Less accurate than phaseAngleEquatorial.
 *
 * Arguments α, δ are geocentric right ascension and declination of the Moon;
 * α0, δ0  are coordinates of the Sun.  Angles must be in radians.
 *
 * @param {Coord} cMoon - eocentric right ascension and declination of the Moon
 * @param {Coord} cSun - coordinates of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEquatorial2", ()=>phaseAngleEquatorial2);
/**
 * phaseAngleEcliptic computes the phase angle of the Moon given ecliptic coordinates.
 *
 * Distances must be in the same units as each other.
 *
 * @param {Coord} cMoon - geocentric longitude, latitude and distance to the Moon
 * @param {Coord} cSun -  longitude and distance to the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEcliptic", ()=>phaseAngleEcliptic);
/**
 * phaseAngleEcliptic2 computes the phase angle of the Moon given ecliptic coordinates.
 *
 * Less accurate than phaseAngleEcliptic.
 *
 * Angles must be in radians.
 *
 * @param {Coord} cMoon - geocentric longitude, latitude of the Moon
 * @param {Coord} cSun -  longitude of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEcliptic2", ()=>phaseAngleEcliptic2);
/**
 * phaseAngle3 computes the phase angle of the Moon given a julian day.
 *
 * Less accurate than phaseAngle functions taking coordinates.
 *
 * Result in radians.
 */ parcelHelpers.export(exports, "phaseAngle3", ()=>phaseAngle3);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
const D2R = Math.PI / 180;
function phaseAngleEquatorial(cMoon, cSun) {
    return pa(cMoon.range, cSun.range, cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
/**
 * cos elongation from equatorial coordinates
 * @private
 */ function cosEq(\u03B1, \u03B4, \u03B10, \u03B40) {
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const [s\u03B40, c\u03B40] = (0, _baseJsDefault.default).sincos(\u03B40);
    return s\u03B40 * s\u03B4 + c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1);
}
/**
 * phase angle from cos elongation and distances
 * @private
 * @param {number} Δ
 * @param {number} R
 * @param {number} cψ
 * @returns {number}
 */ function pa(\u0394, R, c\u03C8) {
    const s\u03C8 = Math.sin(Math.acos(c\u03C8));
    let i = Math.atan(R * s\u03C8 / (\u0394 - R * c\u03C8));
    if (i < 0) i += Math.PI;
    return i;
}
function phaseAngleEquatorial2(cMoon, cSun) {
    return Math.acos(-cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
function phaseAngleEcliptic(cMoon, cSun) {
    return pa(cMoon.range, cSun.range, cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
/**
 * cos elongation from ecliptic coordinates
 * @private
 */ function cosEcl(\u03BB, \u03B2, \u03BB0) {
    return Math.cos(\u03B2) * Math.cos(\u03BB - \u03BB0);
}
function phaseAngleEcliptic2(cMoon, cSun) {
    return Math.acos(-cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
function phaseAngle3(jde) {
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const D = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
    const m = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
    const m_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
    return Math.PI - (0, _baseJsDefault.default).pmod(D, 2 * Math.PI) + -6.289 * D2R * Math.sin(m_) + 2.1 * D2R * Math.sin(m) + -1.274 * D2R * Math.sin(2 * D - m_) + -0.658 * D2R * Math.sin(2 * D) + -0.214 * D2R * Math.sin(2 * m_) + -0.11 * D2R * Math.sin(D);
}
exports.default = {
    phaseAngleEquatorial,
    phaseAngleEquatorial2,
    phaseAngleEcliptic,
    phaseAngleEcliptic2,
    phaseAngle3
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"edIW8":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonmaxdec
 */ /**
 * Moonmaxdec: Chapter 52, Maximum Declinations of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * North computes the maximum northern declination of the Moon near a given date.
 *
 * Argument year is a decimal year specifying a date near the event.
 *
 * Returned is the jde of the event nearest the given date and the declination
 * of the Moon at that time.
 */ parcelHelpers.export(exports, "north", ()=>north);
/**
 * South computes the maximum southern declination of the Moon near a given date.
 *
 * Argument year is a decimal year specifying a date near the event.
 *
 * Returned is the jde of the event nearest the given date and the declination
 * of the Moon at that time.
 */ parcelHelpers.export(exports, "south", ()=>south);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function north(y) {
    return max(y, nc);
}
function south(y) {
    return max(y, sc);
}
const p = Math.PI / 180;
const ck = 1 / 1336.86;
/**
 * @private
 */ function max(y, c) {
    let k = (y - 2000.03) * 13.3686 // (52.1) p. 367
    ;
    k = Math.floor(k + 0.5);
    const T = k * ck;
    const D = (0, _baseJsDefault.default).horner(T, c.D, 333.0705546 * p / ck, -0.0004214 * p, 0.00000011 * p);
    const m = (0, _baseJsDefault.default).horner(T, c.m, 26.9281592 * p / ck, -0.0000355 * p, -0.0000001 * p);
    const m_ = (0, _baseJsDefault.default).horner(T, c.m_, 356.9562794 * p / ck, 0.0103066 * p, 0.00001251 * p);
    const f = (0, _baseJsDefault.default).horner(T, c.f, 1.4467807 * p / ck, -0.002069 * p, -0.00000215 * p);
    const E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    const jde = (0, _baseJsDefault.default).horner(T, c.JDE, 27.321582247 / ck, 0.000119804, -0.000000141) + c.tc[0] * Math.cos(f) + c.tc[1] * Math.sin(m_) + c.tc[2] * Math.sin(2 * f) + c.tc[3] * Math.sin(2 * D - m_) + c.tc[4] * Math.cos(m_ - f) + c.tc[5] * Math.cos(m_ + f) + c.tc[6] * Math.sin(2 * D) + c.tc[7] * Math.sin(m) * E + c.tc[8] * Math.cos(3 * f) + c.tc[9] * Math.sin(m_ + 2 * f) + c.tc[10] * Math.cos(2 * D - f) + c.tc[11] * Math.cos(2 * D - m_ - f) + c.tc[12] * Math.cos(2 * D - m_ + f) + c.tc[13] * Math.cos(2 * D + f) + c.tc[14] * Math.sin(2 * m_) + c.tc[15] * Math.sin(m_ - 2 * f) + c.tc[16] * Math.cos(2 * m_ - f) + c.tc[17] * Math.sin(m_ + 3 * f) + c.tc[18] * Math.sin(2 * D - m - m_) * E + c.tc[19] * Math.cos(m_ - 2 * f) + c.tc[20] * Math.sin(2 * (D - m_)) + c.tc[21] * Math.sin(f) + c.tc[22] * Math.sin(2 * D + m_) + c.tc[23] * Math.cos(m_ + 2 * f) + c.tc[24] * Math.sin(2 * D - m) * E + c.tc[25] * Math.sin(m_ + f) + c.tc[26] * Math.sin(m - m_) * E + c.tc[27] * Math.sin(m_ - 3 * f) + c.tc[28] * Math.sin(2 * m_ + f) + c.tc[29] * Math.cos(2 * (D - m_) - f) + c.tc[30] * Math.sin(3 * f) + c.tc[31] * Math.cos(m_ + 3 * f) + c.tc[32] * Math.cos(2 * m_) + c.tc[33] * Math.cos(2 * D - m_) + c.tc[34] * Math.cos(2 * D + m_ + f) + c.tc[35] * Math.cos(m_) + c.tc[36] * Math.sin(3 * m_ + f) + c.tc[37] * Math.sin(2 * D - m_ + f) + c.tc[38] * Math.cos(2 * (D - m_)) + c.tc[39] * Math.cos(D + f) + c.tc[40] * Math.sin(m + m_) * E + c.tc[41] * Math.sin(2 * (D - f)) + c.tc[42] * Math.cos(2 * m_ + f) + c.tc[43] * Math.cos(3 * m_ + f);
    const \u03B4 = 23.6961 * p - 0.013004 * p * T + c.dc[0] * Math.sin(f) + c.dc[1] * Math.cos(2 * f) + c.dc[2] * Math.sin(2 * D - f) + c.dc[3] * Math.sin(3 * f) + c.dc[4] * Math.cos(2 * (D - f)) + c.dc[5] * Math.cos(2 * D) + c.dc[6] * Math.sin(m_ - f) + c.dc[7] * Math.sin(m_ + 2 * f) + c.dc[8] * Math.cos(f) + c.dc[9] * Math.sin(2 * D + m - f) * E + c.dc[10] * Math.sin(m_ + 3 * f) + c.dc[11] * Math.sin(D + f) + c.dc[12] * Math.sin(m_ - 2 * f) + c.dc[13] * Math.sin(2 * D - m - f) * E + c.dc[14] * Math.sin(2 * D - m_ - f) + c.dc[15] * Math.cos(m_ + f) + c.dc[16] * Math.cos(m_ + 2 * f) + c.dc[17] * Math.cos(2 * m_ + f) + c.dc[18] * Math.cos(m_ - 3 * f) + c.dc[19] * Math.cos(2 * m_ - f) + c.dc[20] * Math.cos(m_ - 2 * f) + c.dc[21] * Math.sin(2 * m_) + c.dc[22] * Math.sin(3 * m_ + f) + c.dc[23] * Math.cos(2 * D + m - f) * E + c.dc[24] * Math.cos(m_ - f) + c.dc[25] * Math.cos(3 * f) + c.dc[26] * Math.sin(2 * D + f) + c.dc[27] * Math.cos(m_ + 3 * f) + c.dc[28] * Math.cos(D + f) + c.dc[29] * Math.sin(2 * m_ - f) + c.dc[30] * Math.cos(3 * m_ + f) + c.dc[31] * Math.cos(2 * (D + m_) + f) + c.dc[32] * Math.sin(2 * (D - m_) - f) + c.dc[33] * Math.cos(2 * m_) + c.dc[34] * Math.cos(m_) + c.dc[35] * Math.sin(2 * f) + c.dc[36] * Math.sin(m_ + f);
    return {
        jde,
        dec: c.s * \u03B4
    };
}
/**
 * north coefficients
 */ const nc = {
    D: 152.2029 * p,
    m: 14.8591 * p,
    m_: 4.6881 * p,
    f: 325.8867 * p,
    JDE: 2451562.5897,
    s: 1,
    tc: [
        0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        -0.0462,
        -0.0461,
        -0.0438,
        0.0162,
        -0.0157,
        0.0145,
        0.0136,
        -0.0095,
        -0.0091,
        -0.0089,
        0.0075,
        -0.0068,
        0.0061,
        -0.0047,
        -0.0043,
        -0.004,
        -0.0037,
        0.0031,
        0.0030,
        -0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        0.0019,
        0.0018,
        0.0018,
        0.0017,
        0.0017,
        -0.0014,
        0.0013,
        0.0013,
        0.0012,
        0.0011,
        -0.0011,
        0.001,
        0.001,
        -0.0009,
        0.0007,
        -0.0007
    ],
    dc: [
        5.1093 * p,
        0.2658 * p,
        0.1448 * p,
        -0.0322 * p,
        0.0133 * p,
        0.0125 * p,
        -0.0124 * p,
        -0.0101 * p,
        0.0097 * p,
        -0.0087 * p,
        0.0074 * p,
        0.0067 * p,
        0.0063 * p,
        0.0060 * p,
        -0.0057 * p,
        -0.0056 * p,
        0.0052 * p,
        0.0041 * p,
        -0.004 * p,
        0.0038 * p,
        -0.0034 * p,
        -0.0029 * p,
        0.0029 * p,
        -0.0028 * p,
        -0.0028 * p,
        -0.0023 * p,
        -0.0021 * p,
        0.0019 * p,
        0.0018 * p,
        0.0017 * p,
        0.0015 * p,
        0.0014 * p,
        -0.0012 * p,
        -0.0012 * p,
        -0.001 * p,
        -0.001 * p,
        0.0006 * p
    ]
};
/**
 * south coefficients
 */ const sc = {
    D: 345.6676 * p,
    m: 1.3951 * p,
    m_: 186.21 * p,
    f: 145.1633 * p,
    JDE: 2451548.9289,
    s: -1,
    tc: [
        -0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        0.0541,
        0.0516,
        -0.0438,
        0.0112,
        0.0157,
        0.0023,
        -0.0136,
        0.011,
        0.0091,
        0.0089,
        0.0075,
        -0.003,
        -0.0061,
        -0.0047,
        -0.0043,
        0.004,
        -0.0037,
        -0.0031,
        0.0030,
        0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        -0.0019,
        -0.0006,
        -0.0018,
        -0.0017,
        0.0017,
        0.0014,
        -0.0013,
        -0.0013,
        0.0012,
        0.0011,
        0.0011,
        0.001,
        0.001,
        -0.0009,
        -0.0007,
        -0.0007
    ],
    dc: [
        -5.1093 * p,
        0.2658 * p,
        -0.1448 * p,
        0.0322 * p,
        0.0133 * p,
        0.0125 * p,
        -0.0015 * p,
        0.0101 * p,
        -0.0097 * p,
        0.0087 * p,
        0.0074 * p,
        0.0067 * p,
        -0.0063 * p,
        -0.006 * p,
        0.0057 * p,
        -0.0056 * p,
        -0.0052 * p,
        -0.0041 * p,
        -0.004 * p,
        -0.0038 * p,
        0.0034 * p,
        -0.0029 * p,
        0.0029 * p,
        0.0028 * p,
        -0.0028 * p,
        0.0023 * p,
        0.0021 * p,
        0.0019 * p,
        0.0018 * p,
        -0.0017 * p,
        0.0015 * p,
        0.0014 * p,
        0.0012 * p,
        -0.0012 * p,
        0.001 * p,
        -0.001 * p,
        0.0037 * p
    ]
};
exports.default = {
    north,
    south
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2W71j":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonnode
 */ /**
 * Moonnode: Chapter 51, Passages of the Moon through the Nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ascending returns the date of passage of the Moon through an ascending node.
 *
 * @param {Number} year - decimal year specifying a date near the event.
 * @returns {Number} jde of the event nearest the given date.
 */ parcelHelpers.export(exports, "ascending", ()=>ascending);
/**
 * Descending returns the date of passage of the Moon through a descending node.
 *
 * @param {Number} year - decimal year specifying a date near the event.
 * @returns {Number} jde of the event nearest the given date.
 */ parcelHelpers.export(exports, "descending", ()=>descending);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function ascending(year) {
    return node(year, 0);
}
function descending(year) {
    return node(year, 0.5);
}
/**
 * @private
 */ function node(y, h) {
    let k = (y - 2000.05) * 13.4223 // (50.1) p. 355
    ;
    k = Math.floor(k - h + 0.5) + h // snap to half orbit
    ;
    const p = Math.PI / 180;
    const ck = 1 / 1342.23;
    const T = k * ck;
    const D = (0, _baseJsDefault.default).horner(T, 183.638 * p, 331.73735682 * p / ck, 0.0014852 * p, 0.00000209 * p, -0.00000001 * p);
    const M = (0, _baseJsDefault.default).horner(T, 17.4006 * p, 26.8203725 * p / ck, 0.0001186 * p, 0.00000006 * p);
    const m_ = (0, _baseJsDefault.default).horner(T, 38.3776 * p, 355.52747313 * p / ck, 0.0123499 * p, 0.000014627 * p, -0.000000069 * p);
    const \u03A9 = (0, _baseJsDefault.default).horner(T, 123.9767 * p, -1.44098956 * p / ck, 0.0020608 * p, 0.00000214 * p, -0.000000016 * p);
    const V = (0, _baseJsDefault.default).horner(T, 299.75 * p, 132.85 * p, -0.009173 * p);
    const P = \u03A9 + 272.75 * p - 2.3 * p * T;
    const E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    return (0, _baseJsDefault.default).horner(T, 2451565.1619, 27.212220817 / ck, 0.0002762, 0.000000021, -0.000000000088) + -0.4721 * Math.sin(m_) + -0.1649 * Math.sin(2 * D) + -0.0868 * Math.sin(2 * D - m_) + 0.0084 * Math.sin(2 * D + m_) + -0.0083 * Math.sin(2 * D - M) * E + -0.0039 * Math.sin(2 * D - M - m_) * E + 0.0034 * Math.sin(2 * m_) + -0.0031 * Math.sin(2 * (D - m_)) + 0.003 * Math.sin(2 * D + M) * E + 0.0028 * Math.sin(M - m_) * E + 0.0026 * Math.sin(M) * E + 0.0025 * Math.sin(4 * D) + 0.0024 * Math.sin(D) + 0.0022 * Math.sin(M + m_) * E + 0.0017 * Math.sin(\u03A9) + 0.0014 * Math.sin(4 * D - m_) + 0.0005 * Math.sin(2 * D + M - m_) * E + 0.0004 * Math.sin(2 * D - M + m_) * E + -0.0003 * Math.sin(2 * (D - M)) * E + 0.0003 * Math.sin(4 * D - M) * E + 0.0003 * Math.sin(V) + 0.0003 * Math.sin(P);
}
exports.default = {
    ascending,
    descending
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jzdYv":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parabolic
 */ /**
 * Parabolic: Chapter 34, Parabolic Motion.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Elements holds parabolic elements needed for computing true anomaly and distance.
 */ parcelHelpers.export(exports, "Elements", ()=>Elements);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
class Elements {
    /**
   * AnomalyDistance returns true anomaly and distance of a body in a parabolic orbit of the Sun.
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Object} {ano, dist}
   *   {Number} ano - True anomaly ν in radians.
   *   {Number} dist - Distance r returned in AU.
   */ anomalyDistance(jde) {
        const W = 3 * (0, _baseJsDefault.default).K / Math.SQRT2 * (jde - this.timeP) / this.pDis / Math.sqrt(this.pDis);
        const G = W * 0.5;
        const Y = Math.cbrt(G + Math.sqrt(G * G + 1));
        const s = Y - 1 / Y;
        const \u03BD = 2 * Math.atan(s);
        const r = this.pDis * (1 + s * s);
        return {
            ano: \u03BD,
            dist: r
        };
    }
    /**
   * @param {Number} timeP - time of perihelion, T
   * @param {Number} pDis - perihelion distance, q
   */ constructor(timeP, pDis){
        this.timeP = timeP;
        this.pDis = pDis;
    }
}
exports.default = {
    Elements
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"28Zsn":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallax
 */ /**
 * Parallax: Chapter 40, Correction for Parallax.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Horizontal returns equatorial horizontal parallax of a body.
 *
 * @param {number} Δ - distance in AU.
 * @return {number} parallax in radians.
 */ parcelHelpers.export(exports, "horizontal", ()=>horizontal);
/**
 * Topocentric returns topocentric positions including parallax.
 *
 * Arguments α, δ are geocentric right ascension and declination in radians.
 * Δ is distance to the observed object in AU. ρsφ, ρcφ are parallax
 * constants (see package globe.) lon is geographic longitude of the observer,
 * jde is time of observation.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Coord} observed topocentric ra and dec in radians.
 */ parcelHelpers.export(exports, "topocentric", ()=>topocentric);
/**
 * Topocentric2 returns topocentric corrections including parallax.
 *
 * This function implements the "non-rigorous" method descripted in the text.
 *
 * Note that results are corrections, not corrected coordinates.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Coord} observed topocentric ra and dec in radians.
 */ parcelHelpers.export(exports, "topocentric2", ()=>topocentric2);
/**
 * Topocentric3 returns topocentric hour angle and declination including parallax.
 *
 * This function implements the "alternative" method described in the text.
 * The method should be similarly rigorous to that of Topocentric() and results
 * should be virtually consistent.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Array}
 *    {number} H_ - topocentric hour angle
 *    {number} δ_ - topocentric declination
 */ parcelHelpers.export(exports, "topocentric3", ()=>topocentric3);
/**
 * TopocentricEcliptical returns topocentric ecliptical coordinates including parallax.
 *
 * Arguments `c` are geocentric ecliptical longitude and latitude of a body,
 * s is its geocentric semidiameter. φ, h are the observer's latitude and
 * and height above the ellipsoid in meters.  ε is the obliquity of the
 * ecliptic, θ is local sidereal time, π is equatorial horizontal parallax
 * of the body (see Horizonal()).
 *
 * All angular parameters and results are in radians.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} s - geocentric semidiameter of `c`
 * @param {number} φ - observer's latitude
 * @param {number} h - observer's height above the ellipsoid in meters
 * @param {number} ε - is the obliquity of the ecliptic
 * @param {number} θ - local sidereal time
 * @param {number} π - equatorial horizontal parallax of the body
 * @return {Array}
 *    {number} λ_ - observed topocentric longitude
 *    {number} β_ - observed topocentric latitude
 *    {number} s_ - observed topocentric semidiameter
 */ parcelHelpers.export(exports, "topocentricEcliptical", ()=>topocentricEcliptical);
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _globeJs = require("./globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
const horPar = 8.794 / 3600 * Math.PI / 180 // 8".794 arcseconds in radians
;
function horizontal(\u0394) {
    // (40.1) p. 279
    return Math.asin(Math.sin(horPar) / \u0394);
// return horPar / Δ // with sufficient accuracy
}
function topocentric(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = horizontal(\u0394);
    const \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    const H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const s\u03C0 = Math.sin(\u03C0);
    const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const \u0394\u03B1 = Math.atan2(-\u03C1c\u03C6 * s\u03C0 * sH, c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.2) p. 279
    ;
    const \u03B1_ = \u03B1 + \u0394\u03B1;
    const \u03B4_ = Math.atan2((s\u03B4 - \u03C1s\u03C6 * s\u03C0) * Math.cos(\u0394\u03B1), c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.3) p. 279
    ;
    return new (0, _baseJs.Coord)(\u03B1_, \u03B4_);
}
function topocentric2(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = horizontal(\u0394);
    const \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    const H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const \u0394\u03B1 = -\u03C0 * \u03C1c\u03C6 * sH / c\u03B4 // (40.4) p. 280
    ;
    const \u0394\u03B4 = -\u03C0 * (\u03C1s\u03C6 * c\u03B4 - \u03C1c\u03C6 * cH * s\u03B4 // (40.5) p. 280
    );
    return new (0, _baseJsDefault.default).Coord(\u0394\u03B1, \u0394\u03B4);
}
function topocentric3(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    const [\u03B1, \u03B4, \u0394] = [
        c.ra,
        c.dec,
        c.range
    ];
    const \u03C0 = horizontal(\u0394);
    const \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    const H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    const s\u03C0 = Math.sin(\u03C0);
    const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const A = c\u03B4 * sH;
    const B = c\u03B4 * cH - \u03C1c\u03C6 * s\u03C0;
    const C = s\u03B4 - \u03C1s\u03C6 * s\u03C0;
    const q = Math.sqrt(A * A + B * B + C * C);
    const H_ = Math.atan2(A, B);
    const \u03B4_ = Math.asin(C / q);
    return [
        H_,
        \u03B4_
    ];
}
function topocentricEcliptical(c, s, \u03C6, h, \u03B5, \u03B8, \u03C0) {
    const [\u03BB, \u03B2] = [
        c.lon,
        c.lat
    ];
    const [S, C] = (0, _globeJsDefault.default).Earth76.parallaxConstants(\u03C6, h);
    const [s\u03BB, c\u03BB] = (0, _baseJsDefault.default).sincos(\u03BB);
    const [s\u03B2, c\u03B2] = (0, _baseJsDefault.default).sincos(\u03B2);
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    const [s\u03B8, c\u03B8] = (0, _baseJsDefault.default).sincos(\u03B8);
    const s\u03C0 = Math.sin(\u03C0);
    const N = c\u03BB * c\u03B2 - C * s\u03C0 * c\u03B8;
    let \u03BB_ = Math.atan2(s\u03BB * c\u03B2 - s\u03C0 * (S * s\u03B5 + C * c\u03B5 * s\u03B8), N);
    if (\u03BB_ < 0) \u03BB_ += 2 * Math.PI;
    const c\u03BB_ = Math.cos(\u03BB_);
    const \u03B2_ = Math.atan(c\u03BB_ * (s\u03B2 - s\u03C0 * (S * c\u03B5 - C * s\u03B5 * s\u03B8)) / N);
    const s_ = Math.asin(c\u03BB_ * Math.cos(\u03B2_) * Math.sin(s) / N);
    return [
        \u03BB_,
        \u03B2_,
        s_
    ];
}
exports.default = {
    horizontal,
    topocentric,
    topocentric2,
    topocentric3,
    topocentricEcliptical
};

},{"./base.js":"cO06o","./globe.js":"argxH","./sidereal.js":"bOjdk","./sexagesimal.js":"1aKkU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bOjdk":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sidereal
 */ /**
 * Sidereal: Chapter 12, Sidereal Time at Greenwich.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * JDToCFrac returns values for use in computing sidereal time at Greenwich.
 *
 * Cen is centuries from J2000 of the JD at 0h UT of argument jd.  This is
 * the value to use for evaluating the IAU sidereal time polynomial.
 * DayFrac is the fraction of jd after 0h UT.  It is used to compute the
 * final value of sidereal time.
 *
 * @param {number} jd - Julian Days
 * @return {number[]} [century, fraction] century and fraction of jd after 0h UT
 */ parcelHelpers.export(exports, "JDToCFrac", ()=>JDToCFrac);
parcelHelpers.export(exports, "iau82", ()=>iau82);
/**
 * Mean returns mean sidereal time at Greenwich for a given JD.
 *
 * Computation is by IAU 1982 coefficients.  The result is in seconds of
 * time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "mean", ()=>mean);
/**
 * Mean0UT returns mean sidereal time at Greenwich at 0h UT on the given JD.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "mean0UT", ()=>mean0UT);
/**
 * Apparent returns apparent sidereal time at Greenwich for the given JD.
 *
 * Apparent is mean plus the nutation in right ascension.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "apparent", ()=>apparent);
/**
 * Apparent0UT returns apparent sidereal time at Greenwich at 0h UT
 * on the given JD.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "apparent0UT", ()=>apparent0UT);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
function JDToCFrac(jd) {
    const [j0, f] = (0, _baseJsDefault.default).modf(jd + 0.5);
    return [
        (0, _baseJsDefault.default).J2000Century(j0 - 0.5),
        f
    ] // (cen, dayFrac /* float */)
    ;
}
const iau82 = [
    24110.54841,
    8640184.812866,
    0.093104,
    -0.0000062
];
function mean(jd) {
    return (0, _baseJsDefault.default).pmod(_mean(jd), 86400);
}
/**
 * @private
 */ function _mean(jd) {
    const [s, f] = _mean0UT(jd);
    return s + f * 86636.55536784;
}
function mean0UT(jd /* float */ ) {
    const [s, _] = _mean0UT(jd) // eslint-disable-line
    ;
    return (0, _baseJsDefault.default).pmod(s, 86400);
}
/**
 * @private
 */ function _mean0UT(jd /* float */ ) {
    const [cen, f] = JDToCFrac(jd);
    // (12.2) p. 87
    return [
        (0, _baseJsDefault.default).horner(cen, ...iau82),
        f
    ] // (sidereal, dayFrac /* float */)
    ;
}
function apparent(jd) {
    const s = _mean(jd) // seconds of time
    ;
    const n = (0, _nutationJsDefault.default).nutationInRA(jd) // angle (radians) of RA
    ;
    const ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, _baseJsDefault.default).pmod(s + ns, 86400);
}
function apparent0UT(jd) {
    const [j0, f] = (0, _baseJsDefault.default).modf(jd + 0.5);
    const cen = (j0 - 0.5 - (0, _baseJsDefault.default).J2000) / 36525;
    const s = (0, _baseJsDefault.default).horner(cen, ...iau82) + f * 86636.55536784;
    const n = (0, _nutationJsDefault.default).nutationInRA(j0) // angle (radians) of RA
    ;
    const ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, _baseJsDefault.default).pmod(s + ns, 86400);
}
exports.default = {
    JDToCFrac,
    iau82,
    mean,
    mean0UT,
    apparent,
    apparent0UT
};

},{"./base.js":"cO06o","./nutation.js":"fWRWg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kj1pf":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallactic
 */ /**
 * Parallactic: Chapter 14, The Parallactic Angle, and three other Topics.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ParallacticAngle returns parallactic angle of a celestial object.
 *
 *  φ is geographic latitude of observer.
 *  δ is declination of observed object.
 *  H is hour angle of observed object.
 *
 * All angles including result are in radians.
 */ parcelHelpers.export(exports, "parallacticAngle", ()=>parallacticAngle);
/**
 * ParallacticAngleOnHorizon is a special case of ParallacticAngle.
 *
 * The hour angle is not needed as an input and the math inside simplifies.
 */ parcelHelpers.export(exports, "parallacticAngleOnHorizon", ()=>parallacticAngleOnHorizon);
/**
 * EclipticAtHorizon computes how the plane of the ecliptic intersects
 * the horizon at a given local sidereal time as observed from a given
 * geographic latitude.
 *
 *  ε is obliquity of the ecliptic.
 *  φ is geographic latitude of observer.
 *  θ is local sidereal time expressed as an hour angle.
 *
 *  λ1 and λ2 are ecliptic longitudes where the ecliptic intersects the horizon.
 *  I is the angle at which the ecliptic intersects the horizon.
 *
 * All angles, arguments and results, are in radians.
 */ parcelHelpers.export(exports, "eclipticAtHorizon", ()=>eclipticAtHorizon);
/**
 * EclipticAtEquator computes the angle between the ecliptic and the parallels
 * of ecliptic latitude at a given ecliptic longitude.
 *
 * (The function name EclipticAtEquator is for consistency with the Meeus text,
 * and works if you consider the equator a nominal parallel of latitude.)
 *
 *  λ is ecliptic longitude.
 *  ε is obliquity of the ecliptic.
 *
 * All angles in radians.
 */ parcelHelpers.export(exports, "eclipticAtEquator", ()=>eclipticAtEquator);
/**
 * DiurnalPathAtHorizon computes the angle of the path a celestial object
 * relative to the horizon at the time of its rising or setting.
 *
 *  δ is declination of the object.
 *  φ is geographic latitude of observer.
 *
 * All angles in radians.
 */ parcelHelpers.export(exports, "diurnalPathAtHorizon", ()=>diurnalPathAtHorizon);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function parallacticAngle(\u03C6, \u03B4, H) {
    const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
    const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
    return Math.atan2(sH, Math.tan(\u03C6) * c\u03B4 - s\u03B4 * cH) // (14.1) p. 98
    ;
}
function parallacticAngleOnHorizon(\u03C6, \u03B4) {
    return Math.acos(Math.sin(\u03C6) / Math.cos(\u03B4));
}
function eclipticAtHorizon(\u03B5, \u03C6, \u03B8) {
    const [s\u03B5, c\u03B5] = (0, _baseJsDefault.default).sincos(\u03B5);
    const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(\u03C6);
    const [s\u03B8, c\u03B8] = (0, _baseJsDefault.default).sincos(\u03B8);
    let \u03BB = Math.atan2(-c\u03B8, s\u03B5 * (s\u03C6 / c\u03C6) + c\u03B5 * s\u03B8) // (14.2) p. 99
    ;
    if (\u03BB < 0) \u03BB += Math.PI;
    return [
        \u03BB,
        \u03BB + Math.PI,
        Math.acos(c\u03B5 * s\u03C6 - s\u03B5 * c\u03C6 * s\u03B8)
    ] // (14.3) p. 99
    ;
}
function eclipticAtEquator(\u03BB, \u03B5) {
    return Math.atan(-Math.cos(\u03BB) * Math.tan(\u03B5));
}
function diurnalPathAtHorizon(\u03B4, \u03C6) {
    const t\u03C6 = Math.tan(\u03C6);
    const b = Math.tan(\u03B4) * t\u03C6;
    const c = Math.sqrt(1 - b * b);
    return Math.atan(c * Math.cos(\u03B4) / t\u03C6);
}
exports.default = {
    parallacticAngle,
    parallacticAngleOnHorizon,
    eclipticAtHorizon,
    eclipticAtEquator,
    diurnalPathAtHorizon
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"22E7v":[function(require,module,exports) {
/* eslint-disable n/no-callback-literal */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module perihelion
 */ /**
 * Perihelion: Chapter 38, Planets in Perihelion and Aphelion.
 *
 * Functions Aphelion and Perihelion implement algorithms from the book
 * to return approximate results.
 *
 * For accurate results, Meeus describes the general technique of
 * interpolating from a precise ephemeris but does not give a complete
 * algorithm.  The algorithm implemented here for Aphelion2 and Perihelion2
 * is to start with the approximate result and then crawl along the curve
 * at the specified time resolution until the desired extremum is found.
 * This algorithm slows down as higher accuracy is demanded.  1 day accuracy
 * is generally quick for planets other than Neptune.
 *
 * Meeus doesn't give an algorithm to handle the double extrema of Neptune.
 * The algorithm here is to pick starting points several years either side
 * of the approximate date and follow the slopes inward.  The consequence of
 * starting farther from the extremum is that these functions are particularly
 * slow for Neptune.  They are offered here though as a simple implementation
 * of Meeus's presentation in the book.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercury", ()=>mercury);
parcelHelpers.export(exports, "venus", ()=>venus);
parcelHelpers.export(exports, "earth", ()=>earth);
parcelHelpers.export(exports, "mars", ()=>mars);
parcelHelpers.export(exports, "jupiter", ()=>jupiter);
parcelHelpers.export(exports, "saturn", ()=>saturn);
parcelHelpers.export(exports, "uranus", ()=>uranus);
parcelHelpers.export(exports, "neptune", ()=>neptune);
parcelHelpers.export(exports, "embary", ()=>embary);
/**
 * Perihelion returns an approximate jde of the perihelion event nearest the given time.
 *
 * @param {planetsEnum} p - planet constant from above
 * @param {Number} year - year number indicating a time near the perihelion event.
 * @returns {Number} jde - time of the event
 */ parcelHelpers.export(exports, "perihelion", ()=>perihelion);
/**
 * Aphelion returns an approximate jde of the aphelion event nearest the given time.
 *
 * @param {planetsEnum} p - planet constant from above
 * @param {Number} year - year number indicating a time near the aphelion event.
 * @returns {Number} jde - time of the event
 */ parcelHelpers.export(exports, "aphelion", ()=>aphelion);
/**
 * Perihelion2 returns the perihelion event nearest the given time.
 *
 * @param {Planet} planet - VSOP87 planet (EMBary is not allowed)
 * @param {Number} year - (float) decimal year number near the perihelion event
 * @param {Number} precision - desired precision of the time result, in days
 * @param {Function} [cb] - callback function for asynchronous processing `cb([jde, r])`
 * @returns {Array} [jde, r]
 *   {Number} jde - time of the event
 *   {Number} r - the distance of the planet from the Sun in AU.
 */ parcelHelpers.export(exports, "perihelion2", ()=>perihelion2);
/**
 * Aphelion2 returns the aphelion event nearest the given time.
 *
 * @param {Planet} planet - VSOP87 planet (EMBary is not allowed)
 * @param {Number} year - (float) decimal year number near the perihelion event
 * @param {Number} precision - desired precision of the time result, in days
 * @param {Function} [cb] - callback function for asynchronous processing `cb([jde, r])`
 * @returns {Array} [jde, r]
 *   {Number} jde - time of the event
 *   {Number} r - the distance of the planet from the Sun in AU.
 */ parcelHelpers.export(exports, "aphelion2", ()=>aphelion2);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
/**
 * Planet constants for first argument of Perihelion and Aphelion functions.
 * @enum {number}
 */ const planetsEnum = {
    mercury: 0,
    venus: 1,
    earth: 2,
    mars: 3,
    jupiter: 4,
    saturn: 5,
    uranus: 6,
    neptune: 7,
    embary: 8
};
const mercury = planetsEnum.mercury;
const venus = planetsEnum.venus;
const earth = planetsEnum.earth;
const mars = planetsEnum.mars;
const jupiter = planetsEnum.jupiter;
const saturn = planetsEnum.saturn;
const uranus = planetsEnum.uranus;
const neptune = planetsEnum.neptune;
const embary = planetsEnum.embary;
function perihelion(p, year) {
    return ap(p, year, false, pf);
}
function aphelion(p, year) {
    return ap(p, year, true, af);
}
const pf = function(x) {
    return Math.floor(x + 0.5);
};
const af = function(x) {
    return Math.floor(x) + 0.5;
};
const ap = function(p, y, a, f) {
    let i = p;
    if (i === embary) i = earth;
    const k = f(ka[i].a * (y - ka[i].b));
    let j = (0, _baseJsDefault.default).horner(k, ...c[i]);
    if (p === earth) {
        let c = ep;
        if (a) c = ea;
        for(let i = 0; i < 5; i++)j += c[i] * Math.sin((ec[i].a + ec[i].b * k) * Math.PI / 180);
    }
    return j;
};
const ka = [
    {
        a: 4.15201,
        b: 2000.12
    },
    {
        a: 1.62549,
        b: 2000.53
    },
    {
        a: 0.99997,
        b: 2000.01
    },
    {
        a: 0.53166,
        b: 2001.78
    },
    {
        a: 0.0843,
        b: 2011.2
    },
    {
        a: 0.03393,
        b: 2003.52
    },
    {
        a: 0.0119,
        b: 2051.1
    },
    {
        a: 0.00607,
        b: 2047.5
    } // neptune
];
const c = [
    [
        2451590.257,
        87.96934963
    ],
    [
        2451738.233,
        224.7008188,
        -0.0000000327
    ],
    [
        2451547.507,
        365.2596358,
        0.0000000156
    ],
    [
        2452195.026,
        686.9957857,
        -0.0000001187
    ],
    [
        2455636.936,
        4332.897065,
        0.0001367
    ],
    [
        2452830.12,
        10764.21676,
        0.000827
    ],
    [
        2470213.5,
        30694.8767,
        -0.00541
    ],
    [
        2468895.1,
        60190.33,
        0.03429
    ] // neptune
];
const ec = [
    {
        a: 328.41,
        b: 132.788585
    },
    {
        a: 316.13,
        b: 584.903153
    },
    {
        a: 346.2,
        b: 450.380738
    },
    {
        a: 136.95,
        b: 659.306737
    },
    {
        a: 249.52,
        b: 329.653368
    }
];
const ep = [
    1.278,
    -0.055,
    -0.091,
    -0.056,
    -0.045
];
const ea = [
    -1.352,
    0.061,
    0.062,
    0.029,
    0.031
];
function perihelion2(planet, year, precision, cb) {
    return ap2(planetsEnum[planet.name], year, precision, planet, false, pf, cb);
}
function aphelion2(planet, year, precision, cb) {
    return ap2(planetsEnum[planet.name], year, precision, planet, true, af, cb);
}
if (typeof setImmediate !== "function") {
    const setImmediate1 = setTimeout // eslint-disable-line no-unused-vars
    ;
}
const ap2 = function(p, y, d, v, a, f, cb) {
    const j1 = ap(p, y, a, f);
    if (p !== neptune) return ap2a(j1, d, a, v, cb);
    // handle the double extrema of Neptune
    if (cb) ap2a(j1 - 5000, d, a, v, ([j0, r0])=>{
        ap2a(j1 + 5000, d, a, v, ([j2, r2])=>{
            if (r0 > r2 === a) {
                cb([
                    j0,
                    r0
                ]);
                return;
            }
            cb([
                j2,
                r2
            ]);
        });
    });
    else {
        const [j0, r0] = ap2a(j1 - 5000, d, a, v);
        const [j2, r2] = ap2a(j1 + 5000, d, a, v);
        if (r0 > r2 === a) return [
            j0,
            r0
        ];
        return [
            j2,
            r2
        ];
    }
};
const ap2a = function(j1, d, a, v, cb) {
    let j0 = j1 - d;
    let j2 = j1 + d;
    const rr = new Array(3);
    rr[1] = v.position2000(j1).range;
    rr[0] = v.position2000(j0).range;
    rr[2] = v.position2000(j2).range;
    function end() {
        const l = new (0, _interpolationJsDefault.default).Len3(j0, j2, rr);
        const [jde, r] = l.extremum();
        return [
            jde,
            r
        ];
    }
    function run() {
        if (a) {
            if (rr[1] > rr[0] && rr[1] > rr[2]) {
                cb && cb(end());
                return true;
            }
        } else if (rr[1] < rr[0] && rr[1] < rr[2]) {
            cb && cb(end());
            return true;
        }
        if (rr[0] < rr[2] === a) {
            j0 = j1;
            j1 = j2;
            j2 += d;
            rr[0] = rr[1];
            rr[1] = rr[2];
            rr[2] = v.position2000(j2).range;
        } else {
            j2 = j1;
            j1 = j0;
            j0 -= d;
            rr[2] = rr[1];
            rr[1] = rr[0];
            rr[0] = v.position2000(j0).range;
        }
        if (cb) setImmediate(run, 0);
    }
    if (cb) run();
    else for(;;){
        if (run()) return end();
    }
};
exports.default = {
    mercury,
    venus,
    earth,
    mars,
    jupiter,
    saturn,
    uranus,
    neptune,
    embary,
    perihelion,
    aphelion,
    perihelion2,
    aphelion2
};

},{"./base.js":"cO06o","./interpolation.js":"isMMq","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fQi8H":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetary
 */ /**
 * Planetary: Chapter 36, The Calculation of some Planetary Phenomena.
 *
 * Incomplete: Some functions unimplemented for lack of test data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Mean computes some intermediate values for a mean planetary configuration
 * given a year and a row of coefficients from Table 36.A, p. 250.0
 */ parcelHelpers.export(exports, "mean", ()=>mean);
/**
 * Sum computes a sum of periodic terms.
 */ parcelHelpers.export(exports, "sum", ()=>sum);
/**
 * ms returns a mean time corrected by a sum.
 */ parcelHelpers.export(exports, "ms", ()=>ms);
/**
 * MercuryInfConj returns the time of an inferior conjunction of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryInfConj", ()=>mercuryInfConj);
/**
 * MercurySupConj returns the time of a superior conjunction of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercurySupConj", ()=>mercurySupConj);
/**
 * VenusInfConj returns the time of an inferior conjunction of Venus.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "venusInfConj", ()=>venusInfConj);
/**
 * MarsOpp returns the time of an opposition of Mars.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "marsOpp", ()=>marsOpp);
/**
 * SumA computes the sum of periodic terms with "additional angles"
 */ parcelHelpers.export(exports, "sumA", ()=>sumA);
/**
 * Msa returns a mean time corrected by a sum.
 */ parcelHelpers.export(exports, "msa", ()=>msa);
/**
 * JupiterOpp returns the time of an opposition of Jupiter.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "jupiterOpp", ()=>jupiterOpp);
/**
 * SaturnOpp returns the time of an opposition of Saturn.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "saturnOpp", ()=>saturnOpp);
/**
 * SaturnConj returns the time of a conjunction of Saturn.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "saturnConj", ()=>saturnConj);
/**
 * UranusOpp returns the time of an opposition of Uranus.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "uranusOpp", ()=>uranusOpp);
/**
 * NeptuneOpp returns the time of an opposition of Neptune.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "neptuneOpp", ()=>neptuneOpp);
/**
 * El computes time and elongation of a greatest elongation event.
 */ parcelHelpers.export(exports, "el", ()=>el);
/**
 * MercuryEastElongation returns the time and elongation of a greatest eastern elongation of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryEastElongation", ()=>mercuryEastElongation);
/**
 * MercuryWestElongation returns the time and elongation of a greatest western elongation of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryWestElongation", ()=>mercuryWestElongation);
parcelHelpers.export(exports, "marsStation2", ()=>marsStation2);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function mean(y, a) {
    // (36.1) p. 250
    const k = Math.floor((365.2425 * y + 1721060 - a.A) / a.B + 0.5);
    const J = a.A + k * a.B;
    const M = (0, _baseJsDefault.default).pmod(a.M0 + k * a.M1, 360) * Math.PI / 180;
    const T = (0, _baseJsDefault.default).J2000Century(J);
    return [
        J,
        M,
        T
    ];
}
function sum(T, M, c) {
    let j = (0, _baseJsDefault.default).horner(T, c[0]);
    let mm = 0.0;
    for(let i = 1; i < c.length; i++){
        mm += M;
        const [smm, cmm] = (0, _baseJsDefault.default).sincos(mm);
        j += smm * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
        j += cmm * (0, _baseJsDefault.default).horner(T, c[i]);
    }
    return j;
}
function ms(y, a, c) {
    const [J, M, T] = mean(y, a);
    return J + sum(T, M, c);
}
function mercuryInfConj(y) {
    return ms(y, micA, micB);
}
function mercurySupConj(y) {
    return ms(y, mscA, mscB);
}
function venusInfConj(y) {
    return ms(y, vicA, vicB);
}
function marsOpp(y) {
    return ms(y, moA, moB);
}
function sumA(T, M, c, aa) {
    let i = c.length - 2 * aa.length;
    let j = sum(T, M, c.slice(0, i));
    for(let k = 0; k < aa.length; k++){
        const [saa, caa] = (0, _baseJsDefault.default).sincos((aa[k].c + aa[k].f * T) * Math.PI / 180);
        j += saa * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
        j += caa * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
    }
    return j;
}
function msa(y, a, c, aa) {
    const [J, M, T] = mean(y, a);
    return J + sumA(T, M, c, aa);
}
function jupiterOpp(y) {
    return msa(y, joA, joB, jaa);
}
function saturnOpp(y) {
    return msa(y, soA, soB, saa);
}
function saturnConj(y) {
    return msa(y, scA, scB, saa);
}
function uranusOpp(y) {
    return msa(y, uoA, uoB, uaa);
}
function neptuneOpp(y) {
    return msa(y, noA, noB, naa);
}
function el(y, a, t, e) {
    const [J, M, T] = mean(y, micA);
    return [
        J + sum(T, M, t),
        sum(T, M, e) * Math.PI / 180
    ];
}
function mercuryEastElongation(y) {
    return el(y, micA, met, mee);
}
function mercuryWestElongation(y) {
    return el(y, micA, mwt, mwe);
}
function marsStation2(y) {
    const [J, M, T] = mean(y, moA);
    return J + sum(T, M, ms2);
}
/**
 * ca holds coefficients from one line of table 36.A, p. 250
 */ function Ca(A, B, M0, M1) {
    this.A = A;
    this.B = B;
    this.M0 = M0;
    this.M1 = M1;
}
/**
 * Table 36.A, p. 250
 */ const micA = new Ca(2451612.023, 115.8774771, 63.5867, 114.2088742);
const mscA = new Ca(2451554.084, 115.8774771, 6.4822, 114.2088742);
const vicA = new Ca(2451996.706, 583.921361, 82.7311, 215.513058);
const moA = new Ca(2452097.382, 779.936104, 181.9573, 48.705244);
const joA = new Ca(2451870.628, 398.884046, 318.4681, 33.140229);
const soA = new Ca(2451870.17, 378.091904, 318.0172, 12.647487);
const scA = new Ca(2451681.124, 378.091904, 131.6934, 12.647487);
const uoA = new Ca(2451764.317, 369.656035, 213.6884, 4.333093);
const noA = new Ca(2451753.122, 367.486703, 202.6544, 2.194998);
/**
 * caa holds coefficients for "additional angles" for outer planets
 * as given on p. 251
 */ function Caa(c, f) {
    this.c = c;
    this.f = f;
}
const jaa = [
    new Caa(82.74, 40.76)
];
const saa = [
    new Caa(82.74, 40.76),
    new Caa(29.86, 1181.36),
    new Caa(14.13, 590.68),
    new Caa(220.02, 1262.87)
];
const uaa = [
    new Caa(207.83, 8.51),
    new Caa(108.84, 419.96)
];
const naa = [
    new Caa(207.83, 8.51),
    new Caa(276.74, 209.98)
];
/**
 * Table 33.B, p. 256
 */ /**
 * Mercury inferior conjunction
 */ const micB = [
    [
        0.0545,
        0.0002
    ],
    [
        -6.2008,
        0.0074,
        0.00003
    ],
    [
        -3.275,
        -0.0197,
        0.00001
    ],
    [
        0.4737,
        -0.0052,
        -0.00001
    ],
    [
        0.8111,
        0.0033,
        -0.00002
    ],
    [
        0.0037,
        0.0018
    ],
    [
        -0.1768,
        0,
        0.00001
    ],
    [
        -0.0211,
        -0.0004
    ],
    [
        0.0326,
        -0.0003
    ],
    [
        0.0083,
        0.0001
    ],
    [
        -0.004,
        0.0001
    ]
];
/**
 * Mercury superior conjunction
 */ const mscB = [
    [
        -0.0548,
        -0.0002
    ],
    [
        7.3894,
        -0.01,
        -0.00003
    ],
    [
        3.22,
        0.0197,
        -0.00001
    ],
    [
        0.8383,
        -0.0064,
        -0.00001
    ],
    [
        0.9666,
        0.0039,
        -0.00003
    ],
    [
        0.077,
        -0.0026
    ],
    [
        0.2758,
        0.0002,
        -0.00002
    ],
    [
        -0.0128,
        -0.0008
    ],
    [
        0.0734,
        -0.0004,
        -0.00001
    ],
    [
        -0.0122,
        -0.0002
    ],
    [
        0.0173,
        -0.0002
    ]
];
/**
 * Venus inferior conjunction
 */ const vicB = [
    [
        -0.0096,
        0.0002,
        -0.00001
    ],
    [
        2.0009,
        -0.0033,
        -0.00001
    ],
    [
        0.598,
        -0.0104,
        0.00001
    ],
    [
        0.0967,
        -0.0018,
        -0.00003
    ],
    [
        0.0913,
        0.0009,
        -0.00002
    ],
    [
        0.0046,
        -0.0002
    ],
    [
        0.0079,
        0.0001
    ]
];
/**
 * Mars opposition
 */ const moB = [
    [
        -0.3088,
        0,
        0.00002
    ],
    [
        -17.6965,
        0.0363,
        0.00005
    ],
    [
        18.3131,
        0.0467,
        -0.00006
    ],
    [
        -0.2162,
        -0.0198,
        -0.00001
    ],
    [
        -4.5028,
        -0.0019,
        0.00007
    ],
    [
        0.8987,
        0.0058,
        -0.00002
    ],
    [
        0.7666,
        -0.005,
        -0.00003
    ],
    [
        -0.3636,
        -0.0001,
        0.00002
    ],
    [
        0.0402,
        0.0032
    ],
    [
        0.0737,
        -0.0008
    ],
    [
        -0.098,
        -0.0011
    ]
];
/**
 * Jupiter opposition
 */ const joB = [
    [
        -0.1029,
        0,
        -0.00009
    ],
    [
        -1.9658,
        -0.0056,
        0.00007
    ],
    [
        6.1537,
        0.021,
        -0.00006
    ],
    [
        -0.2081,
        -0.0013
    ],
    [
        -0.1116,
        -0.001
    ],
    [
        0.0074,
        0.0001
    ],
    [
        -0.0097,
        -0.0001
    ],
    [
        0,
        0.0144,
        -0.00008
    ],
    [
        0.3642,
        -0.0019,
        -0.00029
    ]
];
/**
 * Saturn opposition
 */ const soB = [
    [
        -0.0209,
        0.0006,
        0.00023
    ],
    [
        4.5795,
        -0.0312,
        -0.00017
    ],
    [
        1.1462,
        -0.0351,
        0.00011
    ],
    [
        0.0985,
        -0.0015
    ],
    [
        0.0733,
        -0.0031,
        0.00001
    ],
    [
        0.0025,
        -0.0001
    ],
    [
        0.005,
        -0.0002
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Saturn conjunction
 */ const scB = [
    [
        0.0172,
        -0.0006,
        0.00023
    ],
    [
        -8.5885,
        0.0411,
        0.00020
    ],
    [
        -1.147,
        0.0352,
        -0.00011
    ],
    [
        0.3331,
        -0.0034,
        -0.00001
    ],
    [
        0.1145,
        -0.0045,
        0.00002
    ],
    [
        -0.0169,
        0.0002
    ],
    [
        -0.0109,
        0.0004
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Uranus opposition
 */ const uoB = [
    [
        0.0844,
        -0.0006
    ],
    [
        -0.1048,
        0.0246
    ],
    [
        -5.1221,
        0.0104,
        0.00003
    ],
    [
        -0.1428,
        0.0005
    ],
    [
        -0.0148,
        -0.0013
    ],
    [
        0
    ],
    [
        0.0055
    ],
    [
        0
    ],
    [
        0.885
    ],
    [
        0
    ],
    [
        0.2153
    ]
];
/**
 * Neptune opposition [
 */ const noB = [
    [
        -0.014,
        0,
        0.00001
    ],
    [
        -1.3486,
        0.001,
        0.00001
    ],
    [
        0.8597,
        0.0037
    ],
    [
        -0.0082,
        -0.0002,
        0.00001
    ],
    [
        0.0037,
        -0.0003
    ],
    [
        0
    ],
    [
        -0.5964
    ],
    [
        0
    ],
    [
        0.0728
    ]
];
/**
 * Table 36.C, p. 259
 */ /**
 * Mercury east time correction
 */ const met = [
    [
        -21.6106,
        0.0002
    ],
    [
        -1.9803,
        -0.006,
        0.00001
    ],
    [
        1.4151,
        -0.0072,
        -0.00001
    ],
    [
        0.5528,
        -0.0005,
        -0.00001
    ],
    [
        0.2905,
        0.0034,
        0.00001
    ],
    [
        -0.1121,
        -0.0001,
        0.00001
    ],
    [
        -0.0098,
        -0.0015
    ],
    [
        0.0192
    ],
    [
        0.0111,
        0.0004
    ],
    [
        -0.0061
    ],
    [
        -0.0032,
        -0.0001
    ]
];
/**
 * Mercury east elongation
 */ const mee = [
    [
        22.4697
    ],
    [
        -4.2666,
        0.0054,
        0.00002
    ],
    [
        -1.8537,
        -0.0137
    ],
    [
        0.3598,
        0.0008,
        -0.00001
    ],
    [
        -0.068,
        0.0026
    ],
    [
        -0.0524,
        -0.0003
    ],
    [
        0.0052,
        -0.0006
    ],
    [
        0.0107,
        0.0001
    ],
    [
        -0.0013,
        0.0001
    ],
    [
        -0.0021
    ],
    [
        0.0003
    ]
];
/**
 * Mercury west time correction
 */ const mwt = [
    [
        21.6249,
        -0.0002
    ],
    [
        0.1306,
        0.0065
    ],
    [
        -2.7661,
        -0.0011,
        0.00001
    ],
    [
        0.2438,
        -0.0024,
        -0.00001
    ],
    [
        0.5767,
        0.0023
    ],
    [
        0.1041
    ],
    [
        -0.0184,
        0.0007
    ],
    [
        -0.0051,
        -0.0001
    ],
    [
        0.0048,
        0.0001
    ],
    [
        0.0026
    ],
    [
        0.0037
    ]
];
/**
 * Mercury west elongation
 */ const mwe = [
    [
        22.4143,
        -0.0001
    ],
    [
        4.3651,
        -0.0048,
        -0.00002
    ],
    [
        2.3787,
        0.0121,
        -0.00001
    ],
    [
        0.2674,
        0.0022
    ],
    [
        -0.3873,
        0.0008,
        0.00001
    ],
    [
        -0.0369,
        -0.0001
    ],
    [
        0.0017,
        -0.0001
    ],
    [
        0.0059
    ],
    [
        0.0061,
        0.0001
    ],
    [
        0.0007
    ],
    [
        -0.0011
    ]
];
/**
 * Table 36.D, p. 261
 */ /**
 * Mars Station 2
 */ const ms2 = [
    [
        36.7191,
        0.0016,
        0.00003
    ],
    [
        -12.6163,
        0.0417,
        -0.00001
    ],
    [
        20.1218,
        0.0379,
        -0.00006
    ],
    [
        -1.636,
        -0.019
    ],
    [
        -3.9657,
        0.0045,
        0.00007
    ],
    [
        1.1546,
        0.0029,
        -0.00003
    ],
    [
        0.2888,
        -0.0073,
        -0.00002
    ],
    [
        -0.3128,
        0.0017,
        0.00002
    ],
    [
        0.2513,
        0.0026,
        -0.00002
    ],
    [
        -0.0021,
        -0.0016
    ],
    [
        -0.1497,
        -0.0006
    ]
];
exports.default = {
    mean,
    sum,
    ms,
    mercuryInfConj,
    mercurySupConj,
    venusInfConj,
    marsOpp,
    sumA,
    msa,
    jupiterOpp,
    saturnOpp,
    saturnConj,
    uranusOpp,
    neptuneOpp,
    el,
    mercuryEastElongation,
    mercuryWestElongation,
    marsStation2
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aZzbH":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module pluto
 */ /**
 * Pluto: Chapter 37, Pluto.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Heliocentric returns J2000 heliocentric coordinates of Pluto.
 *
 * Results l, b are solar longitude and latitude in radians.
 * Result r is distance in AU.
 */ parcelHelpers.export(exports, "heliocentric", ()=>heliocentric);
/**
 * Astrometric returns J2000 astrometric coordinates of Pluto.
 */ parcelHelpers.export(exports, "astrometric", ()=>astrometric);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
function heliocentric(jde) {
    let l = 0;
    let b = 0;
    let r = 0;
    const T = (0, _baseJsDefault.default).J2000Century(jde);
    const J = 34.35 + 3034.9057 * T;
    const S = 50.08 + 1222.1138 * T;
    const P = 238.96 + 144.96 * T;
    for(const i in t37){
        const t = t37[i];
        const [s\u03B1, c\u03B1] = (0, _baseJsDefault.default).sincos((t.i * J + t.j * S + t.k * P) * Math.PI / 180);
        l += t.lA * s\u03B1 + t.lB * c\u03B1;
        b += t.bA * s\u03B1 + t.bB * c\u03B1;
        r += t.rA * s\u03B1 + t.rB * c\u03B1;
    }
    l = (l + 238.958116 + 144.96 * T) * Math.PI / 180;
    b = (b - 3.908239) * Math.PI / 180;
    r += 40.7241346;
    return {
        lon: l,
        lat: b,
        range: r
    };
}
function astrometric(jde, earth) {
    const s\u03B5 = (0, _baseJsDefault.default).SOblJ2000;
    const c\u03B5 = (0, _baseJsDefault.default).COblJ2000;
    const f = function(jde) {
        const { lon, lat, range } = heliocentric(jde);
        const [sl, cl] = (0, _baseJsDefault.default).sincos(lon);
        const [sb, cb] = (0, _baseJsDefault.default).sincos(lat);
        // (37.1) p. 264
        const x = range * cl * cb;
        const y = range * (sl * cb * c\u03B5 - sb * s\u03B5);
        const z = range * (sl * cb * s\u03B5 + sb * c\u03B5);
        return {
            x,
            y,
            z
        };
    };
    const c = (0, _ellipticJsDefault.default).astrometricJ2000(f, jde, earth) // eslint-disable-line no-unused-vars
    ;
    return new (0, _baseJsDefault.default).Coord(c.ra, c.dec);
}
function Pt(i, j, k, lA, lB, bA, bB, rA, rB) {
    this.i = i;
    this.j = j;
    this.k = k;
    this.lA = lA;
    this.lB = lB;
    this.bA = bA;
    this.bB = bB;
    this.rA = rA;
    this.rB = rB;
}
const t37 = [
    new Pt(0, 0, 1, -19.799805, 19.850055, -5.452852, -14.974862, 6.6865439, 6.8951812),
    new Pt(0, 0, 2, 0.897144, -4.954829, 3.527812, 1.67279, -1.1827535, -0.0332538),
    new Pt(0, 0, 3, 0.611149, 1.211027, -1.050748, 0.327647, 0.1593179, -0.143889),
    new Pt(0, 0, 4, -0.341243, -0.189585, 0.17869, -0.292153, -0.0018444, 0.048322),
    new Pt(0, 0, 5, 0.129287, -0.034992, 0.01865, 0.10034, -0.0065977, -0.0085431),
    new Pt(0, 0, 6, -0.038164, 0.030893, -0.030697, -0.025823, 0.0031174, -0.0006032),
    new Pt(0, 1, -1, 0.020442, -0.009987, 0.004878, 0.011248, -0.0005794, 0.0022161),
    new Pt(0, 1, 0, -0.004063, -0.005071, 0.000226, -0.000064, 0.0004601, 0.0004032),
    new Pt(0, 1, 1, -0.006016, -0.003336, 0.00203, -0.000836, -0.0001729, 0.0000234),
    new Pt(0, 1, 2, -0.003956, 0.003039, 0.000069, -0.000604, -0.0000415, 0.0000702),
    new Pt(0, 1, 3, -0.000667, 0.003572, -0.000247, -0.000567, 0.0000239, 0.0000723),
    new Pt(0, 2, -2, 0.001276, 0.000501, -0.000057, 0.000001, 0.0000067, -0.0000067),
    new Pt(0, 2, -1, 0.001152, -0.000917, -0.000122, 0.000175, 0.0001034, -0.0000451),
    new Pt(0, 2, 0, 0.00063, -0.001277, -0.000049, -0.000164, -0.0000129, 0.0000504),
    new Pt(1, -1, 0, 0.002571, -0.000459, -0.000197, 0.000199, 0.000048, -0.0000231),
    new Pt(1, -1, 1, 0.000899, -0.001449, -0.000025, 0.000217, 0.0000002, -0.0000441),
    new Pt(1, 0, -3, -0.001016, 0.001043, 0.000589, -0.000248, -0.0003359, 0.0000265),
    new Pt(1, 0, -2, -0.002343, -0.001012, -0.000269, 0.000711, 0.0007856, -0.0007832),
    new Pt(1, 0, -1, 0.007042, 0.000788, 0.000185, 0.000193, 0.0000036, 0.0045763),
    new Pt(1, 0, 0, 0.001199, -0.000338, 0.000315, 0.000807, 0.0008663, 0.0008547),
    new Pt(1, 0, 1, 0.000418, -0.000067, -0.00013, -0.000043, -0.0000809, -0.0000769),
    new Pt(1, 0, 2, 0.00012, -0.000274, 0.000005, 0.000003, 0.0000263, -0.0000144),
    new Pt(1, 0, 3, -0.00006, -0.000159, 0.000002, 0.000017, -0.0000126, 0.0000032),
    new Pt(1, 0, 4, -0.000082, -0.000029, 0.000002, 0.000005, -0.0000035, -0.0000016),
    new Pt(1, 1, -3, -0.000036, -0.000029, 0.000002, 0.000003, -0.0000019, -0.0000004),
    new Pt(1, 1, -2, -0.00004, 0.000007, 0.000003, 0.000001, -0.0000015, 0.0000008),
    new Pt(1, 1, -1, -0.000014, 0.000022, 0.000002, -0.000001, -0.0000004, 0.0000012),
    new Pt(1, 1, 0, 0.000004, 0.000013, 0.000001, -0.000001, 0.0000005, 0.0000006),
    new Pt(1, 1, 1, 0.000005, 0.000002, 0, -0.000001, 0.0000003, 0.0000001),
    new Pt(1, 1, 3, -0.000001, 0, 0, 0, 0.0000006, -0.0000002),
    new Pt(2, 0, -6, 0.000002, 0, 0, -0.000002, 0.0000002, 0.0000002),
    new Pt(2, 0, -5, -0.000004, 0.000005, 0.000002, 0.000002, -0.0000002, -0.0000002),
    new Pt(2, 0, -4, 0.000004, -0.000007, -0.000007, 0, 0.0000014, 0.0000013),
    new Pt(2, 0, -3, 0.000014, 0.000024, 0.00001, -0.000008, -0.0000063, 0.0000013),
    new Pt(2, 0, -2, -0.000049, -0.000034, -0.000003, 0.00002, 0.0000136, -0.0000236),
    new Pt(2, 0, -1, 0.000163, -0.000048, 0.000006, 0.000005, 0.0000273, 0.0001065),
    new Pt(2, 0, 0, 0.000009, -0.000024, 0.000014, 0.000017, 0.0000251, 0.0000149),
    new Pt(2, 0, 1, -0.000004, 0.000001, -0.000002, 0, -0.0000025, -0.0000009),
    new Pt(2, 0, 2, -0.000003, 0.000001, 0, 0, 0.0000009, -0.0000002),
    new Pt(2, 0, 3, 0.000001, 0.000003, 0, 0, -0.0000008, 0.0000007),
    new Pt(3, 0, -2, -0.000003, -0.000001, 0, 0.000001, 0.0000002, -0.000001),
    new Pt(3, 0, -1, 0.000005, -0.000003, 0, 0, 0.0000019, 0.0000035),
    new Pt(3, 0, 0, 0, 0, 0.000001, 0, 0.000001, 0.0000003)
];
exports.default = {
    heliocentric,
    astrometric
};

},{"./base.js":"cO06o","./elliptic.js":"8qxM3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Zuh5":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module refraction
 */ /**
 * Refraction: Chapter 16: Atmospheric Refraction.
 *
 * Functions here assume atmospheric pressure of 1010 mb, temperature of
 * 10°C, and yellow light.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * gt15True returns refraction for obtaining true altitude when altitude
 * is greater than 15 degrees (about 0.26 radians.)
 *
 * h0 must be a measured apparent altitude of a celestial body in radians.
 *
 * Result is refraction to be subtracted from h0 to obtain the true altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "gt15True", ()=>gt15True);
/**
 * gt15Apparent returns refraction for obtaining apparent altitude when
 * altitude is greater than 15 degrees (about 0.26 radians.)
 *
 * h must be a computed true "airless" altitude of a celestial body in radians.
 *
 * Result is refraction to be added to h to obtain the apparent altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "gt15Apparent", ()=>gt15Apparent);
/**
 * Bennett returns refraction for obtaining true altitude.
 *
 * h0 must be a measured apparent altitude of a celestial body in radians.
 *
 * Results are accurate to 0.07 arc min from horizon to zenith.
 *
 * Result is refraction to be subtracted from h0 to obtain the true altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "bennett", ()=>bennett);
/**
 * Bennett2 returns refraction for obtaining true altitude.
 *
 * Similar to Bennett, but a correction is applied to give a more accurate
 * result.
 *
 * Results are accurate to 0.015 arc min.  Result unit is radians.
 */ parcelHelpers.export(exports, "bennett2", ()=>bennett2);
/**
 * Saemundsson returns refraction for obtaining apparent altitude.
 *
 * h must be a computed true "airless" altitude of a celestial body in radians.
 *
 * Result is refraction to be added to h to obtain the apparent altitude
 * of the body.
 *
 * Results are consistent with Bennett to within 4 arc sec.
 * Result unit is radians.
 */ parcelHelpers.export(exports, "saemundsson", ()=>saemundsson);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
const { sin, tan } = Math;
const D2R = Math.PI / 180;
const gt15true1 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 58.294).rad();
const gt15true2 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 0.0668).rad();
const gt15app1 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 58.276).rad();
const gt15app2 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 0.0824).rad();
function gt15True(h0) {
    // (16.1) p. 105
    const t = tan(Math.PI / 2 - h0);
    return gt15true1 * t - gt15true2 * t * t * t;
}
function gt15Apparent(h) {
    // (16.2) p. 105
    const t = tan(Math.PI / 2 - h);
    return gt15app1 * t - gt15app2 * t * t * t;
}
function bennett(h0) {
    // (16.3) p. 106
    const c1 = D2R / 60;
    const c731 = 7.31 * D2R * D2R;
    const c44 = 4.4 * D2R;
    return c1 / tan(h0 + c731 / (h0 + c44));
}
function bennett2(h0) {
    const cMin = 60 / D2R;
    const c06 = 0.06 / cMin;
    const c147 = 14.7 * cMin * D2R;
    const c13 = 13 * D2R;
    const R = bennett(h0);
    return R - c06 * sin(c147 * R + c13);
}
function saemundsson(h) {
    // (16.4) p. 106
    const c102 = 1.02 * D2R / 60;
    const c103 = 10.3 * D2R * D2R;
    const c511 = 5.11 * D2R;
    return c102 / tan(h + c103 / (h + c511));
}
exports.default = {
    gt15True,
    gt15Apparent,
    bennett,
    bennett2,
    saemundsson
};

},{"./sexagesimal.js":"1aKkU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2pO5I":[function(require,module,exports) {
/* eslint key-spacing: 1 */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module rise
 */ /**
 * Rise: Chapter 15, Rising, Transit, and Setting.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorAboveHorizon", ()=>errorAboveHorizon);
parcelHelpers.export(exports, "errorBelowHorizon", ()=>errorBelowHorizon);
parcelHelpers.export(exports, "meanRefraction", ()=>meanRefraction);
parcelHelpers.export(exports, "stdh0", ()=>stdh0);
/**
 * Helper function to obtain corrected refraction
 * @param {number} h0 - altitude of the body in radians containing `meanRefraction` of 0°34'
 * @param {number} [corr] - the calcluated refraction e.g. from package `refraction` in radians
 * @return {number} refraction value in radians
 */ parcelHelpers.export(exports, "refraction", ()=>refraction);
parcelHelpers.export(exports, "stdh0Stellar", ()=>stdh0Stellar);
parcelHelpers.export(exports, "Stdh0Stellar", ()=>Stdh0Stellar);
parcelHelpers.export(exports, "stdh0Solar", ()=>stdh0Solar);
parcelHelpers.export(exports, "Stdh0Solar", ()=>Stdh0Solar);
parcelHelpers.export(exports, "stdh0LunarMean", ()=>stdh0LunarMean);
parcelHelpers.export(exports, "Stdh0LunarMean", ()=>Stdh0LunarMean);
parcelHelpers.export(exports, "stdh0Lunar", ()=>stdh0Lunar);
parcelHelpers.export(exports, "Stdh0Lunar", ()=>Stdh0Lunar);
/**
 * @return {number} local angle in radians
 */ parcelHelpers.export(exports, "hourAngle", ()=>hourAngle);
/**
 * ApproxTimes computes approximate UT rise, transit and set times for
 * a celestial object on a day of interest.
 *
 * The function argurments do not actually include the day, but do include
 * values computed from the day.
 *
 * @param {GlobeCoord} p - is geographic coordinates of observer.
 * @param {number} h0 - is "standard altitude" of the body in radians
 * @param {number} Th0 - is apparent sidereal time at 0h UT at Greenwich in seconds
 *        (range 0...86400) must be the time on the day of interest, in seconds.
 *        See sidereal.apparent0UT
 * @param {number} α - right ascension (radians)
 * @param {number} δ - declination (radians)
 * @return {RiseObj} Result units are seconds and are in the range [0,86400)
 * @throws Error
 */ parcelHelpers.export(exports, "approxTimes", ()=>approxTimes);
/**
 * Times computes UT rise, transit and set times for a celestial object on
 * a day of interest.
 *
 * The function argurments do not actually include the day, but do include
 * a number of values computed from the day.
 *
 * @param {GlobeCoord} p - is geographic coordinates of observer.
 * @param {number} ΔT - is delta T in seconds
 * @param {number} h0 - is "standard altitude" of the body in radians
 * @param {number} Th0 - is apparent sidereal time at 0h UT at Greenwich in seconds
 *        (range 0...86400) must be the time on the day of interest, in seconds.
 *        See sidereal.apparent0UT
 * @param {Array<number>} α3 - slices of three right ascensions
 * @param {Array<number>} δ3 - slices of three declinations.
 *        α3, δ3 must be values at 0h dynamical time for the day before, the day of,
 *        and the day after the day of interest.  Units are radians.
 *
 * @return {RiseObj} Result units are seconds and are in the range [0,86400)
 * @throws Error
 */ parcelHelpers.export(exports, "times", ()=>times);
/**
 * RisePlanet computes rise, transit and set times for a planet on a day of interest.
 */ parcelHelpers.export(exports, "PlanetRise", ()=>PlanetRise);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _globeJs = require("./globe.js"); // eslint-disable-line no-unused-vars
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
const { acos, asin, cos, sin } = Math;
/**
 * @typedef {object} RiseObj
 * @property {number} rise - in seconds
 * @property {number} transit - in seconds
 * @property {number} set - in seconds
 */ const SECS_PER_DEGREE = 240 // = 86400 / 360
;
const SECS_PER_DAY = 86400;
const D2R = Math.PI / 180;
const errorAboveHorizon = (0, _baseJsDefault.default).errorCode("always above horizon", -1);
const errorBelowHorizon = (0, _baseJsDefault.default).errorCode("always below horizon", 1);
const meanRefraction = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 34, 0).rad();
const stdh0 = {
    stellar: -meanRefraction,
    solar: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 50, 0).rad(),
    // not containing meanRefraction
    lunar: (0, _sexagesimalJsDefault.default).angleFromDeg(0.7275),
    lunarMean: (0, _sexagesimalJsDefault.default).angleFromDeg(0.125)
};
function refraction(h0, corr) {
    if (!corr) return h0;
    else return h0 - meanRefraction - corr;
}
const stdh0Stellar = (_refraction)=>refraction(stdh0.stellar, _refraction);
const Stdh0Stellar = stdh0Stellar() // for backward-compatibility
;
const stdh0Solar = (_refraction)=>refraction(stdh0.solar, _refraction);
const Stdh0Solar = stdh0Solar() // for backward-compatibility
;
const stdh0LunarMean = (_refraction)=>{
    return stdh0.lunarMean - refraction(_refraction);
};
const Stdh0LunarMean = stdh0LunarMean() // for backward-compatibility
;
const stdh0Lunar = (\u03C0, refraction)=>{
    return stdh0.lunar * \u03C0 - (refraction || meanRefraction);
};
const Stdh0Lunar = stdh0Lunar // for backward-compatibility
;
function hourAngle(lat, h0, \u03B4) {
    // approximate local hour angle
    const cosH = (sin(h0) - sin(lat) * sin(\u03B4)) / (cos(lat) * cos(\u03B4) // (15.1) p. 102
    );
    if (cosH < -1) throw errorAboveHorizon;
    else if (cosH > 1) throw errorBelowHorizon;
    const H = acos(cosH);
    return H;
}
/**
 * @param {number} lon - longitude in radians
 * @param {number} α - right ascension in radians
 * @param {number} th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @return {number} time of transit in seconds of day `[0, 86400[`
 */ function _mt(lon, \u03B1, th0) {
    // const mt = (((lon + α) * 180 / Math.PI - (th0 * 360 / 86400)) * 86400 / 360)
    const mt = (lon + \u03B1) * SECS_PER_DEGREE * 180 / Math.PI - th0;
    return mt;
}
/**
 * @param {number} Th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @param {number} m - motion in seconds of day `[0...86400[`
 * @return {number} new siderial time seconds of day `[0...86400[`
 */ function _th0(Th0, m) {
    // in original formula Th0 = 0...360 and m = 0...1 -> return value would be in 0...360 degrees
    // Th0 /= 240
    // m /= 86400
    const th0 = (0, _baseJsDefault.default).pmod(Th0 + m * 360.985647 / 360, SECS_PER_DAY) // p103
    ;
    return th0 // 0...86400 in seconds angle
    ;
}
/**
 * maintain backward compatibility - will be removed in v2
 * return value in future will be an object not an array
 * @private
 * @param {RiseObj} rs
 * @return {RiseObj}
 */ function _compatibility(rs) {
    const _rs = [
        rs.rise,
        rs.transit,
        rs.set
    ];
    _rs.rise = rs.rise;
    _rs.transit = rs.transit;
    _rs.set = rs.set;
    return _rs;
}
function approxTimes(p, h0, Th0, \u03B1, \u03B4) {
    const H0 = hourAngle(p.lat, h0, \u03B4) * SECS_PER_DEGREE * 180 / Math.PI // in degrees per day === seconds
    ;
    // approximate transit, rise, set times.
    // (15.2) p. 102.0
    const mt = _mt(p.lon, \u03B1, Th0);
    const rs = {};
    rs.transit = (0, _baseJsDefault.default).pmod(mt, SECS_PER_DAY);
    rs.rise = (0, _baseJsDefault.default).pmod(mt - H0, SECS_PER_DAY);
    rs.set = (0, _baseJsDefault.default).pmod(mt + H0, SECS_PER_DAY);
    return _compatibility(rs);
}
function times(p, \u0394T, h0, Th0, \u03B13, \u03B43) {
    const rs = approxTimes(p, h0, Th0, \u03B13[1], \u03B43[1]);
    const d3\u03B1 = new (0, _interpolationJsDefault.default).Len3(-SECS_PER_DAY, SECS_PER_DAY, \u03B13);
    const d3\u03B4 = new (0, _interpolationJsDefault.default).Len3(-SECS_PER_DAY, SECS_PER_DAY, \u03B43);
    // adjust mTransit
    const ut = rs.transit + \u0394T;
    const \u03B1 = d3\u03B1.interpolateX(ut);
    const th0 = _th0(Th0, rs.transit);
    const H = -1 * _mt(p.lon, \u03B1, th0) // in secs // Hmeus = 0...360
    ;
    rs.transit -= H;
    // adjust mRise, mSet
    const [sLat, cLat] = (0, _baseJsDefault.default).sincos(p.lat);
    const adjustRS = function(m) {
        const ut = m + \u0394T;
        const \u03B1 = d3\u03B1.interpolateX(ut);
        const \u03B4 = d3\u03B4.interpolateX(ut);
        const th0 = _th0(Th0, m);
        const H = -1 * _mt(p.lon, \u03B1, th0);
        const Hrad = H / SECS_PER_DEGREE * D2R;
        const h = asin(sLat * sin(\u03B4) + cLat * cos(\u03B4) * cos(Hrad)) // formula 13.6
        ;
        const \u0394m = SECS_PER_DAY * (h - h0) / (cos(\u03B4) * cLat * sin(Hrad) * 2 * Math.PI) // formula p103 3
        ;
        return m + \u0394m;
    };
    rs.rise = adjustRS(rs.rise);
    rs.set = adjustRS(rs.set);
    return _compatibility(rs);
}
class PlanetRise {
    approxTimes() {
        const body = (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde);
        const Th0 = (0, _siderealJsDefault.default).apparent0UT(this.jd);
        const rs = approxTimes({
            lat: this.lat,
            lon: this.lon
        }, this.refraction, Th0, body.ra, body.dec);
        return this._rsToJD(rs);
    }
    times() {
        const body = [
            (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde - 1),
            (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde),
            (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde + 1)
        ];
        const Th0 = (0, _siderealJsDefault.default).apparent0UT(this.jd);
        const rs = times({
            lat: this.lat,
            lon: this.lon
        }, this.\u0394T, this.refraction, Th0, this._toArr(body, "ra"), this._toArr(body, "dec"));
        return this._rsToJD(rs);
    }
    /** @private */ _toArr(body, p) {
        return body.map((item)=>{
            return item[p];
        });
    }
    /** @private */ _rsToJD(rs) {
        return {
            rise: this._toJD(rs.rise),
            transit: this._toJD(rs.transit),
            set: this._toJD(rs.set)
        };
    }
    /** @private */ _toJD(secs) {
        const jd = this.jd + secs / 86400;
        if (this.opts.date) return new (0, _julianJsDefault.default).Calendar().fromJD(jd).toDate();
        else return jd;
    }
    /**
   * @param {number|Date} jd - Julian Day starting at midnight or Date object
   * @param {number} lat - geographic latitude of the observerin degrees
   * @param {number} lon - geographic longitude of the observer in degrees (measured positively westward)
   * @param {Planet} earth - VSOP87 Planet object for Earth
   * @param {Planet} planet - VSOP87 Planet object of observed body
   * @param {object} [opts]
   * @param {boolean} [opts.date] - return times as Date objects
   * @param {number} [opts.refraction] - use different refraction than `stdh0Stellar`
   */ constructor(jd, lat, lon, earth, planet, opts){
        this.opts = opts || {};
        this.refraction = this.opts.refraction || stdh0Stellar();
        if (jd instanceof Date) jd = new (0, _julianJsDefault.default).Calendar().fromDate(jd).toJD();
        this.jd = Math.floor(jd - 0.5) + 0.5 // start at midnight
        ;
        this.lat = lat * D2R // convert to radians
        ;
        this.lon = lon * D2R;
        const cal = new (0, _julianJsDefault.default).Calendar().fromJD(this.jd);
        this.jde = cal.toJDE();
        this.\u0394T = (0, _deltatJsDefault.default).deltaT(cal.toYear());
        this.earth = earth;
        this.planet = planet;
    }
}
exports.default = {
    errorAboveHorizon,
    errorBelowHorizon,
    meanRefraction,
    stdh0,
    refraction,
    stdh0Stellar,
    Stdh0Stellar,
    stdh0Solar,
    Stdh0Solar,
    stdh0LunarMean,
    Stdh0LunarMean,
    stdh0Lunar,
    Stdh0Lunar,
    hourAngle,
    approxTimes,
    times,
    PlanetRise
};

},{"./base.js":"cO06o","./deltat.js":"2uWsU","./elliptic.js":"8qxM3","./interpolation.js":"isMMq","./julian.js":"da2eV","./sexagesimal.js":"1aKkU","./sidereal.js":"bOjdk","./globe.js":"argxH","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1wLG4":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnmoons
 */ /**
 * Saturnmoons: Chapter 46, Positions of the Satellites of Saturn
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mimas", ()=>mimas);
parcelHelpers.export(exports, "enceladus", ()=>enceladus);
parcelHelpers.export(exports, "tethys", ()=>tethys);
parcelHelpers.export(exports, "dione", ()=>dione);
parcelHelpers.export(exports, "rhea", ()=>rhea);
parcelHelpers.export(exports, "titan", ()=>titan);
parcelHelpers.export(exports, "hyperion", ()=>hyperion);
parcelHelpers.export(exports, "iapetus", ()=>iapetus);
/**
 * Positions returns positions of the eight major moons of Saturn.
 *
 * Results returned in argument pos, which must not be undefined.
 *
 * Result units are Saturn radii.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 planet Earth // eslint-disable-line no-unused-vars
 * @param {Planet} saturn - VSOP87 planet Saturn // eslint-disable-line no-unused-vars
 * @return {XY[]} Array of Moon Positions in `XY`
 *   Use `M.mimas ... M.iapetus` to resolve to Moon and its position at `jde`
 */ parcelHelpers.export(exports, "positions", ()=>positions);
parcelHelpers.export(exports, "Qs", ()=>Qs);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
const mimas = 0;
const enceladus = 1;
const tethys = 2;
const dione = 3;
const rhea = 4;
const titan = 5;
const hyperion = 6;
const iapetus = 7;
/**
 * XY holds coordinates returned from positions().
 */ function XY(x, y) {
    this.x = x;
    this.y = y;
}
const d = Math.PI / 180;
function positions(jde, earth, saturn) {
    const sol = (0, _solarJsDefault.default).trueVSOP87(earth, jde);
    const [s, \u03B2, R] = [
        sol.lon,
        sol.lat,
        sol.range
    ];
    const [ss, cs] = (0, _baseJsDefault.default).sincos(s);
    const s\u03B2 = Math.sin(\u03B2);
    let \u0394 = 9.0;
    let x;
    let y;
    let z = 0;
    let _jde;
    const f = function() {
        const \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        _jde = jde - \u03C4;
        const { lon, lat, range } = saturn.position(_jde);
        const fk5 = (0, _planetpositionJsDefault.default).toFK5(lon, lat, _jde) // eslint-disable-line no-unused-vars
        ;
        const [l, b] = [
            fk5.lon,
            fk5.lat
        ];
        const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
        const [sb, cb] = (0, _baseJsDefault.default).sincos(b);
        x = range * cb * cl + R * cs;
        y = range * cb * sl + R * ss;
        z = range * sb + R * s\u03B2;
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    let \u03BB0 = Math.atan2(y, x);
    let \u03B20 = Math.atan(z / Math.hypot(x, y));
    let ecl = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20);
    ecl = (0, _precessJsDefault.default).eclipticPosition(ecl, (0, _baseJsDefault.default).JDEToJulianYear(jde), (0, _baseJsDefault.default).JDEToJulianYear((0, _baseJsDefault.default).B1950));
    \u03BB0 = ecl.lon;
    \u03B20 = ecl.lat;
    const q = new Qs(_jde);
    const s4 = [
        new R4(),
        q.mimas(),
        q.enceladus(),
        q.tethys(),
        q.dione(),
        q.rhea(),
        q.titan(),
        q.hyperion(),
        q.iapetus()
    ];
    const X = new Array(9).fill(0);
    const Y = new Array(9).fill(0);
    const Z = new Array(9).fill(0);
    for(let j = 1; j <= 8; j++){
        const u = s4[j].\u03BB - s4[j].\u03A9;
        const w = s4[j].\u03A9 - 168.8112 * d;
        const [su, cu] = (0, _baseJsDefault.default).sincos(u);
        const [sw, cw] = (0, _baseJsDefault.default).sincos(w);
        const [s\u03B3, c\u03B3] = (0, _baseJsDefault.default).sincos(s4[j].\u03B3);
        const r = s4[j].r;
        X[j] = r * (cu * cw - su * c\u03B3 * sw);
        Y[j] = r * (su * cw * c\u03B3 + cu * sw);
        Z[j] = r * su * s\u03B3;
    }
    Z[0] = 1;
    const [s\u03BB0, c\u03BB0] = (0, _baseJsDefault.default).sincos(\u03BB0);
    const [s\u03B20, c\u03B20] = (0, _baseJsDefault.default).sincos(\u03B20);
    const A = new Array(9).fill(0);
    const B = new Array(9).fill(0);
    const C = new Array(9).fill(0);
    for(const j in X){
        let a = X[j];
        let b = q.c1 * Y[j] - q.s1 * Z[j];
        const c = q.s1 * Y[j] + q.c1 * Z[j];
        const a0 = q.c2 * a - q.s2 * b;
        b = q.s2 * a + q.c2 * b;
        a = a0;
        A[j] = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        B[j] = b * c\u03B20 + c * s\u03B20;
        C[j] = c * c\u03B20 - b * s\u03B20;
    }
    const pos = new Array(9);
    const D = Math.atan2(A[0], C[0]);
    const [sD, cD] = (0, _baseJsDefault.default).sincos(D);
    for(let j = 1; j <= 8; j++){
        X[j] = A[j] * cD - C[j] * sD;
        Y[j] = A[j] * sD + C[j] * cD;
        Z[j] = B[j];
        const d = X[j] / s4[j].r;
        X[j] += Math.abs(Z[j]) / k[j] * Math.sqrt(1 - d * d);
        const W = \u0394 / (\u0394 + Z[j] / 2475);
        pos[j - 1] = new XY(X[j] * W, Y[j] * W);
    }
    return pos;
}
const k = [
    0,
    20947,
    23715,
    26382,
    29876,
    35313,
    53800,
    59222,
    91820
];
function R4(\u03BB, r, \u03B3, \u03A9) {
    this.\u03BB = \u03BB || 0;
    this.r = r || 0;
    this.\u03B3 = \u03B3 || 0;
    this.\u03A9 = \u03A9 || 0;
}
function Qs(jde) {
    this.t1 = jde - 2411093;
    this.t2 = this.t1 / 365.25;
    this.t3 = (jde - 2433282.423) / 365.25 + 1950;
    this.t4 = jde - 2411368;
    this.t5 = this.t4 / 365.25;
    this.t6 = jde - 2415020;
    this.t7 = this.t6 / 36525;
    this.t8 = this.t6 / 365.25;
    this.t9 = (jde - 2442000.5) / 365.25;
    this.t10 = jde - 2409786;
    this.t11 = this.t10 / 36525;
    this.W0 = 5.095 * d * (this.t3 - 1866.39);
    this.W1 = 74.4 * d + 32.39 * d * this.t2;
    this.W2 = 134.3 * d + 92.62 * d * this.t2;
    this.W3 = 42 * d - 0.5118 * d * this.t5;
    this.W4 = 276.59 * d + 0.5118 * d * this.t5;
    this.W5 = 267.2635 * d + 1222.1136 * d * this.t7;
    this.W6 = 175.4762 * d + 1221.5515 * d * this.t7;
    this.W7 = 2.4891 * d + 0.002435 * d * this.t7;
    this.W8 = 113.35 * d - 0.2597 * d * this.t7;
    this.s1 = Math.sin(28.0817 * d);
    this.c1 = Math.cos(28.0817 * d);
    this.s2 = Math.sin(168.8112 * d);
    this.c2 = Math.cos(168.8112 * d);
    this.e1 = 0.05589 - 0.000346 * this.t7;
    this.sW0 = Math.sin(this.W0);
    this.s3W0 = Math.sin(3 * this.W0);
    this.s5W0 = Math.sin(5 * this.W0);
    this.sW1 = Math.sin(this.W1);
    this.sW2 = Math.sin(this.W2);
    this.sW3 = Math.sin(this.W3);
    this.cW3 = Math.cos(this.W3);
    this.sW4 = Math.sin(this.W4);
    this.cW4 = Math.cos(this.W4);
    this.sW7 = Math.sin(this.W7);
    this.cW7 = Math.cos(this.W7);
    return this;
}
Qs.prototype.mimas = function() {
    const r = new R4();
    const L = 127.64 * d + 381.994497 * d * this.t1 - 43.57 * d * this.sW0 - 0.72 * d * this.s3W0 - 0.02144 * d * this.s5W0;
    const p = 106.1 * d + 365.549 * d * this.t2;
    const M = L - p;
    const C = 2.18287 * d * Math.sin(M) + 0.025988 * d * Math.sin(2 * M) + 0.00043 * d * Math.sin(3 * M);
    r.\u03BB = L + C;
    r.r = 3.06879 / (1 + 0.01905 * Math.cos(M + C));
    r.\u03B3 = 1.563 * d;
    r.\u03A9 = 54.5 * d - 365.072 * d * this.t2;
    return r;
};
Qs.prototype.enceladus = function() {
    const r = new R4();
    const L = 200.317 * d + 262.7319002 * d * this.t1 + 0.25667 * d * this.sW1 + 0.20883 * d * this.sW2;
    const p = 309.107 * d + 123.44121 * d * this.t2;
    const M = L - p;
    const C = 0.55577 * d * Math.sin(M) + 0.00168 * d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 3.94118 / (1 + 0.00485 * Math.cos(M + C));
    r.\u03B3 = 0.0262 * d;
    r.\u03A9 = 348 * d - 151.95 * d * this.t2;
    return r;
};
Qs.prototype.tethys = function() {
    const r = new R4();
    r.\u03BB = 285.306 * d + 190.69791226 * d * this.t1 + 2.063 * d * this.sW0 + 0.03409 * d * this.s3W0 + 0.001015 * d * this.s5W0;
    r.r = 4.880998;
    r.\u03B3 = 1.0976 * d;
    r.\u03A9 = 111.33 * d - 72.2441 * d * this.t2;
    return r;
};
Qs.prototype.dione = function() {
    const r = new R4();
    const L = 254.712 * d + 131.53493193 * d * this.t1 - 0.0215 * d * this.sW1 - 0.01733 * d * this.sW2;
    const p = 174.8 * d + 30.82 * d * this.t2;
    const M = L - p;
    const C = 0.24717 * d * Math.sin(M) + 0.00033 * d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 6.24871 / (1 + 0.002157 * Math.cos(M + C));
    r.\u03B3 = 0.0139 * d;
    r.\u03A9 = 232 * d - 30.27 * d * this.t2;
    return r;
};
Qs.prototype.rhea = function() {
    const p\u02B9 = 342.7 * d + 10.057 * d * this.t2;
    const [sp\u02B9, cp\u02B9] = (0, _baseJsDefault.default).sincos(p\u02B9);
    const a1 = 0.000265 * sp\u02B9 + 0.001 * this.sW4;
    const a2 = 0.000265 * cp\u02B9 + 0.001 * this.cW4;
    const e = Math.hypot(a1, a2);
    const p = Math.atan2(a1, a2);
    const N = 345 * d - 10.057 * d * this.t2;
    const [sN, cN] = (0, _baseJsDefault.default).sincos(N);
    const \u03BB\u02B9 = 359.244 * d + 79.6900472 * d * this.t1 + 0.086754 * d * sN;
    const i = 28.0362 * d + 0.346898 * d * cN + 0.0193 * d * this.cW3;
    const \u03A9 = 168.8034 * d + 0.736936 * d * sN + 0.041 * d * this.sW3;
    const a = 8.725924;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.subr = function(\u03BB\u02B9, p, e, a, \u03A9, i) {
    const r = new R4();
    const M = \u03BB\u02B9 - p;
    const e2 = e * e;
    const e3 = e2 * e;
    const e4 = e2 * e2;
    const e5 = e3 * e2;
    const C = (2 * e - 0.25 * e3 + 0.0520833333 * e5) * Math.sin(M) + (1.25 * e2 - 0.458333333 * e4) * Math.sin(2 * M) + (1.083333333 * e3 - 0.671875 * e5) * Math.sin(3 * M) + 1.072917 * e4 * Math.sin(4 * M) + 1.142708 * e5 * Math.sin(5 * M);
    r.r = a * (1 - e2) / (1 + e * Math.cos(M + C) // return value
    );
    const g = \u03A9 - 168.8112 * d;
    const [si, ci] = (0, _baseJsDefault.default).sincos(i);
    const [sg, cg] = (0, _baseJsDefault.default).sincos(g);
    const a1 = si * sg;
    const a2 = this.c1 * si * cg - this.s1 * ci;
    r.\u03B3 = Math.asin(Math.hypot(a1, a2)) // return value
    ;
    const u = Math.atan2(a1, a2);
    r.\u03A9 = 168.8112 * d + u // return value (w)
    ;
    const h = this.c1 * si - this.s1 * ci * cg;
    const \u03C8 = Math.atan2(this.s1 * sg, h);
    r.\u03BB = \u03BB\u02B9 + C + u - g - \u03C8 // return value
    ;
    return r;
};
Qs.prototype.titan = function() {
    const L = 261.1582 * d + 22.57697855 * d * this.t4 + 0.074025 * d * this.sW3;
    const i\u02B9 = 27.45141 * d + 0.295999 * d * this.cW3;
    const \u03A9\u02B9 = 168.66925 * d + 0.628808 * d * this.sW3;
    const [si\u02B9, ci\u02B9] = (0, _baseJsDefault.default).sincos(i\u02B9);
    const [s\u03A9\u02B9W8, c\u03A9\u02B9W8] = (0, _baseJsDefault.default).sincos(\u03A9\u02B9 - this.W8);
    const a1 = this.sW7 * s\u03A9\u02B9W8;
    const a2 = this.cW7 * si\u02B9 - this.sW7 * ci\u02B9 * c\u03A9\u02B9W8;
    const g0 = 102.8623 * d;
    const \u03C8 = Math.atan2(a1, a2);
    const s = Math.hypot(a1, a2);
    let g = this.W4 - \u03A9\u02B9 - \u03C8;
    let \u03D6 = 0;
    const [s2g0, c2g0] = (0, _baseJsDefault.default).sincos(2 * g0);
    const f = ()=>{
        \u03D6 = this.W4 + 0.37515 * d * (Math.sin(2 * g) - s2g0);
        g = \u03D6 - \u03A9\u02B9 - \u03C8;
    };
    f();
    f();
    f();
    const e\u02B9 = 0.029092 + 0.00019048 * (Math.cos(2 * g) - c2g0);
    const qq = 2 * (this.W5 - \u03D6);
    const b1 = si\u02B9 * s\u03A9\u02B9W8;
    const b2 = this.cW7 * si\u02B9 * c\u03A9\u02B9W8 - this.sW7 * ci\u02B9;
    const \u03B8 = Math.atan2(b1, b2) + this.W8;
    const [sq, cq] = (0, _baseJsDefault.default).sincos(qq);
    const e = e\u02B9 + 0.002778797 * e\u02B9 * cq;
    const p = \u03D6 + 0.159215 * d * sq;
    const u = 2 * this.W5 - 2 * \u03B8 + \u03C8;
    const [su, cu] = (0, _baseJsDefault.default).sincos(u);
    const h = 0.9375 * e\u02B9 * e\u02B9 * sq + 0.1875 * s * s * Math.sin(2 * (this.W5 - \u03B8));
    const \u03BB\u02B9 = L - 0.254744 * d * (this.e1 * Math.sin(this.W6) + 0.75 * this.e1 * this.e1 * Math.sin(2 * this.W6) + h);
    const i = i\u02B9 + 0.031843 * d * s * cu;
    const \u03A9 = \u03A9\u02B9 + 0.031843 * d * s * su / si\u02B9;
    const a = 20.216193;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.hyperion = function() {
    const \u03B7 = 92.39 * d + 0.5621071 * d * this.t6;
    const \u03B6 = 148.19 * d - 19.18 * d * this.t8;
    const \u03B8 = 184.8 * d - 35.41 * d * this.t9;
    const \u03B8\u02B9 = \u03B8 - 7.5 * d;
    const as = 176 * d + 12.22 * d * this.t8;
    const bs = 8 * d + 24.44 * d * this.t8;
    const cs = bs + 5 * d;
    const \u03D6 = 69.898 * d - 18.67088 * d * this.t8;
    const \u03C6 = 2 * (\u03D6 - this.W5);
    const \u03C7 = 94.9 * d - 2.292 * d * this.t8;
    const [s\u03B7, c\u03B7] = (0, _baseJsDefault.default).sincos(\u03B7);
    const [s\u03B6, c\u03B6] = (0, _baseJsDefault.default).sincos(\u03B6);
    const [s2\u03B6, c2\u03B6] = (0, _baseJsDefault.default).sincos(2 * \u03B6);
    const [s3\u03B6, c3\u03B6] = (0, _baseJsDefault.default).sincos(3 * \u03B6);
    const [s\u03B6p\u03B7, c\u03B6p\u03B7] = (0, _baseJsDefault.default).sincos(\u03B6 + \u03B7);
    const [s\u03B6m\u03B7, c\u03B6m\u03B7] = (0, _baseJsDefault.default).sincos(\u03B6 - \u03B7);
    const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(\u03C6);
    const [s\u03C7, c\u03C7] = (0, _baseJsDefault.default).sincos(\u03C7);
    const [scs, ccs] = (0, _baseJsDefault.default).sincos(cs);
    const a = 24.50601 - 0.08686 * c\u03B7 - 0.00166 * c\u03B6p\u03B7 + 0.00175 * c\u03B6m\u03B7;
    const e = 0.103458 - 0.004099 * c\u03B7 - 0.000167 * c\u03B6p\u03B7 + 0.000235 * c\u03B6m\u03B7 + 0.02303 * c\u03B6 - 0.00212 * c2\u03B6 + 0.000151 * c3\u03B6 + 0.00013 * c\u03C6;
    const p = \u03D6 + 0.15648 * d * s\u03C7 - 0.4457 * d * s\u03B7 - 0.2657 * d * s\u03B6p\u03B7 - 0.3573 * d * s\u03B6m\u03B7 - 12.872 * d * s\u03B6 + 1.668 * d * s2\u03B6 - 0.2419 * d * s3\u03B6 - 0.07 * d * s\u03C6;
    const \u03BB\u02B9 = 177.047 * d + 16.91993829 * d * this.t6 + 0.15648 * d * s\u03C7 + 9.142 * d * s\u03B7 + 0.007 * d * Math.sin(2 * \u03B7) - 0.014 * d * Math.sin(3 * \u03B7) + 0.2275 * d * s\u03B6p\u03B7 + 0.2112 * d * s\u03B6m\u03B7 - 0.26 * d * s\u03B6 - 0.0098 * d * s2\u03B6 - 0.013 * d * Math.sin(as) + 0.017 * d * Math.sin(bs) - 0.0303 * d * s\u03C6;
    const i = 27.3347 * d + 0.6434886 * d * c\u03C7 + 0.315 * d * this.cW3 + 0.018 * d * Math.cos(\u03B8) - 0.018 * d * ccs;
    const \u03A9 = 168.6812 * d + 1.40136 * d * c\u03C7 + 0.68599 * d * this.sW3 - 0.0392 * d * scs + 0.0366 * d * Math.sin(\u03B8\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.iapetus = function() {
    const L = 261.1582 * d + 22.57697855 * d * this.t4;
    const \u03D6\u02B9 = 91.796 * d + 0.562 * d * this.t7;
    const \u03C8 = 4.367 * d - 0.195 * d * this.t7;
    const \u03B8 = 146.819 * d - 3.198 * d * this.t7;
    const \u03C6 = 60.47 * d + 1.521 * d * this.t7;
    const \u03A6 = 205.055 * d - 2.091 * d * this.t7;
    const e\u02B9 = 0.028298 + 0.001156 * this.t11;
    const \u03D60 = 352.91 * d + 11.71 * d * this.t11;
    const \u03BC = 76.3852 * d + 4.53795125 * d * this.t10;
    const i\u02B9 = (0, _baseJsDefault.default).horner(this.t11, 18.4602 * d, -0.9518 * d, -0.072 * d, 0.0054 * d);
    const \u03A9\u02B9 = (0, _baseJsDefault.default).horner(this.t11, 143.198 * d, -3.919 * d, 0.116 * d, 0.008 * d);
    const l = \u03BC - \u03D60;
    const g = \u03D60 - \u03A9\u02B9 - \u03C8;
    const g1 = \u03D60 - \u03A9\u02B9 - \u03C6;
    const ls = this.W5 - \u03D6\u02B9;
    const gs = \u03D6\u02B9 - \u03B8;
    const lT = L - this.W4;
    const gT = this.W4 - \u03A6;
    const u1 = 2 * (l + g - ls - gs);
    const u2 = l + g1 - lT - gT;
    const u3 = l + 2 * (g - ls - gs);
    const u4 = lT + gT - g1;
    const u5 = 2 * (ls + gs);
    const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
    const [su1, cu1] = (0, _baseJsDefault.default).sincos(u1);
    const [su2, cu2] = (0, _baseJsDefault.default).sincos(u2);
    const [su3, cu3] = (0, _baseJsDefault.default).sincos(u3);
    const [su4, cu4] = (0, _baseJsDefault.default).sincos(u4);
    const [slu2, clu2] = (0, _baseJsDefault.default).sincos(l + u2);
    const [sg1gT, cg1gT] = (0, _baseJsDefault.default).sincos(g1 - gT);
    const [su52g, cu52g] = (0, _baseJsDefault.default).sincos(u5 - 2 * g);
    const [su5\u03C8, cu5\u03C8] = (0, _baseJsDefault.default).sincos(u5 + \u03C8);
    const [su2\u03C6, cu2\u03C6] = (0, _baseJsDefault.default).sincos(u2 + \u03C6);
    const [s5, c5] = (0, _baseJsDefault.default).sincos(l + g1 + lT + gT + \u03C6);
    const a = 58.935028 + 0.004638 * cu1 + 0.058222 * cu2;
    const e = e\u02B9 - 0.0014097 * cg1gT + 0.0003733 * cu52g + 0.000118 * cu3 + 0.0002408 * cl + 0.0002849 * clu2 + 0.000619 * cu4;
    const w = 0.08077 * d * sg1gT + 0.02139 * d * su52g - 0.00676 * d * su3 + 0.0138 * d * sl + 0.01632 * d * slu2 + 0.03547 * d * su4;
    const p = \u03D60 + w / e\u02B9;
    const \u03BB\u02B9 = \u03BC - 0.04299 * d * su2 - 0.00789 * d * su1 - 0.06312 * d * Math.sin(ls) - 0.00295 * d * Math.sin(2 * ls) - 0.02231 * d * Math.sin(u5) + 0.0065 * d * su5\u03C8;
    const i = i\u02B9 + 0.04204 * d * cu5\u03C8 + 0.00235 * d * c5 + 0.0036 * d * cu2\u03C6;
    const w\u02B9 = 0.04204 * d * su5\u03C8 + 0.00235 * d * s5 + 0.00358 * d * su2\u03C6;
    const \u03A9 = \u03A9\u02B9 + w\u02B9 / Math.sin(i\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
exports.default = {
    mimas,
    enceladus,
    tethys,
    dione,
    rhea,
    titan,
    hyperion,
    iapetus,
    positions,
    Qs
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./planetposition.js":"cfC43","./precess.js":"tAZZk","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5ANWn":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnring
 */ /**
 * Saturnrings: Chapter 45, The Ring of Saturn
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ring computes quantities of the ring of Saturn.
 *
 *  B  Saturnicentric latitude of the Earth referred to the plane of the ring.
 *  Bʹ  Saturnicentric latitude of the Sun referred to the plane of the ring.
 *  ΔU  Difference between Saturnicentric longitudes of the Sun and the Earth.
 *  P  Geometric position angle of the northern semiminor axis of the ring.
 *  aEdge  Major axis of the out edge of the outer ring.
 *  bEdge  Minor axis of the out edge of the outer ring.
 *
 * All results in radians.
 */ parcelHelpers.export(exports, "ring", ()=>ring);
/**
 * UB computes quantities required by illum.Saturn().
 *
 * Same as ΔU and B returned by Ring().  Results in radians.
 */ parcelHelpers.export(exports, "ub", ()=>ub);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function ring(jde, earth, saturn) {
    const [f1, f2] = cl(jde, earth, saturn);
    const [\u0394U, B] = f1();
    const [B\u02B9, P, aEdge, bEdge] = f2();
    return [
        B,
        B\u02B9,
        \u0394U,
        P,
        aEdge,
        bEdge
    ];
}
function ub(jde, earth, saturn) {
    const [f1, f2] = cl(jde, earth, saturn) // eslint-disable-line no-unused-vars
    ;
    return f1();
}
/**
 * cl splits the work into two closures.
 */ function cl(jde, earth, saturn) {
    // f2 func() (Bʹ, P, aEdge, bEdge float64))
    const p = Math.PI / 180;
    let i, \u03A9;
    let l0, b0, R;
    let \u0394 = 9.0;
    let \u03BB, \u03B2;
    let si, ci, s\u03B2, c\u03B2, sB;
    let sb\u02B9, cb\u02B9, sl\u02B9\u03A9, cl\u02B9\u03A9;
    const f1 = function() {
        // (45.1), p. 318
        const T = (0, _baseJsDefault.default).J2000Century(jde);
        i = (0, _baseJsDefault.default).horner(T, 28.075216 * p, -0.012998 * p, 0.000004 * p);
        \u03A9 = (0, _baseJsDefault.default).horner(T, 169.50847 * p, 1.394681 * p, 0.000412 * p);
        // Step 2.0
        const earthPos = earth.position(jde);
        R = earthPos.range;
        const fk5 = (0, _planetpositionJsDefault.default).toFK5(earthPos.lon, earthPos.lat, jde);
        l0 = fk5.lon;
        b0 = fk5.lat;
        const [sl0, cl0] = (0, _baseJsDefault.default).sincos(l0);
        const sb0 = Math.sin(b0);
        // Steps 3, 4.0
        let l = 0;
        let b = 0;
        let r = 0;
        let x = 0;
        let y = 0;
        let z = 0;
        const f = function() {
            const \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
            const saturnPos = saturn.position(jde - \u03C4);
            r = saturnPos.range;
            const fk5 = (0, _planetpositionJsDefault.default).toFK5(saturnPos.lon, saturnPos.lat, jde);
            l = fk5.lon;
            b = fk5.lat;
            const [sl, cl] = (0, _baseJsDefault.default).sincos(l);
            const [sb, cb] = (0, _baseJsDefault.default).sincos(b);
            x = r * cb * cl - R * cl0;
            y = r * cb * sl - R * sl0;
            z = r * sb - R * sb0;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
        };
        f();
        f();
        // Step 5.0
        \u03BB = Math.atan2(y, x);
        \u03B2 = Math.atan(z / Math.hypot(x, y));
        // First part of step 6.0
        si = Math.sin(i);
        ci = Math.cos(i);
        s\u03B2 = Math.sin(\u03B2);
        c\u03B2 = Math.cos(\u03B2);
        sB = si * c\u03B2 * Math.sin(\u03BB - \u03A9) - ci * s\u03B2;
        const B = Math.asin(sB) // return value
        ;
        // Step 7.0
        const N = 113.6655 * p + 0.8771 * p * T;
        const l\u02B9 = l - 0.01759 * p / r;
        const b\u02B9 = b - 0.000764 * p * Math.cos(l - N) / r;
        // Setup for steps 8, 9.0
        sb\u02B9 = Math.sin(b\u02B9);
        cb\u02B9 = Math.cos(b\u02B9);
        sl\u02B9\u03A9 = Math.sin(l\u02B9 - \u03A9);
        cl\u02B9\u03A9 = Math.cos(l\u02B9 - \u03A9);
        // Step 9.0
        const [s\u03BB\u03A9, c\u03BB\u03A9] = (0, _baseJsDefault.default).sincos(\u03BB - \u03A9);
        const U1 = Math.atan2(si * sb\u02B9 + ci * cb\u02B9 * sl\u02B9\u03A9, cb\u02B9 * cl\u02B9\u03A9);
        const U2 = Math.atan2(si * s\u03B2 + ci * c\u03B2 * s\u03BB\u03A9, c\u03B2 * c\u03BB\u03A9);
        const \u0394U = Math.abs(U1 - U2) // return value
        ;
        return [
            \u0394U,
            B
        ];
    };
    const f2 = function() {
        // Remainder of step 6.0
        const aEdge = 375.35 / 3600 * p / \u0394 // return value
        ;
        const bEdge = aEdge * Math.abs(sB) // return value
        ;
        // Step 8.0
        const sB\u02B9 = si * cb\u02B9 * sl\u02B9\u03A9 - ci * sb\u02B9;
        const B\u02B9 = Math.asin(sB\u02B9) // return value
        ;
        // Step 10.0
        const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jde);
        const \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
        // Step 11.0
        let \u03BB0 = \u03A9 - Math.PI / 2;
        const \u03B20 = Math.PI / 2 - i;
        // Step 12.0
        const [sl0\u03BB, cl0\u03BB] = (0, _baseJsDefault.default).sincos(l0 - \u03BB);
        \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
        \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
        // Step 13.0
        \u03BB0 += \u0394\u03C8;
        \u03BB += \u0394\u03C8;
        // Step 14.0
        let eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
        const [\u03B10, \u03B40] = [
            eq.ra,
            eq.dec
        ];
        eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
        const [\u03B1, \u03B4] = [
            eq.ra,
            eq.dec
        ];
        // Step 15.0
        const [s\u03B40, c\u03B40] = (0, _baseJsDefault.default).sincos(\u03B40);
        const [s\u03B4, c\u03B4] = (0, _baseJsDefault.default).sincos(\u03B4);
        const [s\u03B10\u03B1, c\u03B10\u03B1] = (0, _baseJsDefault.default).sincos(\u03B10 - \u03B1);
        const P = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1) // return value
        ;
        return [
            B\u02B9,
            P,
            aEdge,
            bEdge
        ];
    };
    return [
        f1,
        f2
    ];
}
exports.default = {
    ring,
    ub
};

},{"./base.js":"cO06o","./coord.js":"1Ze6D","./nutation.js":"fWRWg","./planetposition.js":"cfC43","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5dvpO":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solardisk
 */ /**
 * Solardisk: Chapter 29, Ephemeris for Physical Observations of the Sun.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ephemeris returns the apparent orientation of the sun at the given jd.
 *
 * Results:
 *  P:  Position angle of the solar north pole.
 *  B0: Heliographic latitude of the center of the solar disk.
 *  L0: Heliographic longitude of the center of the solar disk.
 *
 * All results in radians.
 */ parcelHelpers.export(exports, "ephemeris", ()=>ephemeris);
/**
 * Cycle returns the jd of the start of the given synodic rotation.
 *
 * Argument c is the "Carrington" cycle number.
 *
 * Result is a dynamical time (not UT).
 */ parcelHelpers.export(exports, "cycle", ()=>cycle);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
function ephemeris(jd, earth) {
    const \u03B8 = (jd - 2398220) * 2 * Math.PI / 25.38;
    const I = 7.25 * Math.PI / 180;
    const K = 73.6667 * Math.PI / 180 + 1.3958333 * Math.PI / 180 * (jd - 2396758) / (0, _baseJsDefault.default).JulianCentury;
    const solarPos = (0, _solarJsDefault.default).trueVSOP87(earth, jd);
    const L = solarPos.lon;
    const R = solarPos.range;
    const [\u0394\u03C8, \u0394\u03B5] = (0, _nutationJsDefault.default).nutation(jd);
    const \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jd);
    const \u03B5 = \u03B50 + \u0394\u03B5;
    const \u03BB = L - 20.4898 / 3600 * Math.PI / 180 / R;
    const \u03BBp = \u03BB + \u0394\u03C8;
    const [s\u03BBK, c\u03BBK] = (0, _baseJsDefault.default).sincos(\u03BB - K);
    const [sI, cI] = (0, _baseJsDefault.default).sincos(I);
    const tx = -Math.cos(\u03BBp) * Math.tan(\u03B5);
    const ty = -c\u03BBK * Math.tan(I);
    const P = Math.atan(tx) + Math.atan(ty);
    const B0 = Math.asin(s\u03BBK * sI);
    const \u03B7 = Math.atan2(-s\u03BBK * cI, -c\u03BBK);
    const L0 = (0, _baseJsDefault.default).pmod(\u03B7 - \u03B8, 2 * Math.PI);
    return [
        P,
        B0,
        L0
    ];
}
function cycle(c) {
    const jde = 2398140.227 + 27.2752316 * c;
    const m = 281.96 * Math.PI / 180 + 26.882476 * Math.PI / 180 * c;
    const [s2m, c2m] = (0, _baseJsDefault.default).sincos(2 * m);
    return jde + 0.1454 * Math.sin(m) - 0.0085 * s2m - 0.0141 * c2m;
}
exports.default = {
    ephemeris,
    cycle
};

},{"./base.js":"cO06o","./nutation.js":"fWRWg","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iNko2":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solstice
 */ /**
 * Solstice: Chapter 27: Equinoxes and Solstices.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * March returns the JDE of the March equinox for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "march", ()=>march);
/**
 * June returns the JDE of the June solstice for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "june", ()=>june);
/**
 * September returns the JDE of the September equinox for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "september", ()=>september);
/**
 * December returns the JDE of the December solstice for a given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "december", ()=>december);
/**
 * March2 returns a more accurate JDE of the March equinox.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "march2", ()=>march2);
/**
 * June2 returns a more accurate JDE of the June solstice.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "june2", ()=>june2);
/**
 * September2 returns a more accurate JDE of the September equinox.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "september2", ()=>september2);
/**
 * December2 returns a more accurate JDE of the December solstice.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "december2", ()=>december2);
/**
 * Longitude returns the JDE for a given `year`, VSOP87 Planet `planet` at a
 * given geocentric solar longitude `lon`
 * @param {Number} year - (int)
 * @param {planetposition.Planet} planet
 * @param {Number} lon - geocentric solar longitude in radians
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "longitude", ()=>longitude);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
const { abs, cos, sin } = Math;
const D2R = Math.PI / 180;
// table 27.a - for years from -1000 to +1000
const mc0 = [
    1721139.29189,
    365242.13740,
    0.06134,
    0.00111,
    -0.00071
];
const jc0 = [
    1721233.25401,
    365241.72562,
    -0.05323,
    0.00907,
    0.00025
];
const sc0 = [
    1721325.70455,
    365242.49558,
    -0.11677,
    -0.00297,
    0.00074
];
const dc0 = [
    1721414.39987,
    365242.88257,
    -0.00769,
    -0.00933,
    -0.00006
];
// table 27.b - for years from +1000 to +3000
const mc2 = [
    2451623.80984,
    365242.37404,
    0.05169,
    -0.00411,
    -0.00057
];
const jc2 = [
    2451716.56767,
    365241.62603,
    0.00325,
    0.00888,
    -0.0003
];
const sc2 = [
    2451810.21715,
    365242.01767,
    -0.11575,
    0.00337,
    0.00078
];
const dc2 = [
    2451900.05952,
    365242.74049,
    -0.06223,
    -0.00823,
    0.00032
];
// table 27.c
const terms = function() {
    const term = [
        [
            485,
            324.96,
            1934.136
        ],
        [
            203,
            337.23,
            32964.467
        ],
        [
            199,
            342.08,
            20.186
        ],
        [
            182,
            27.85,
            445267.112
        ],
        [
            156,
            73.14,
            45036.886
        ],
        [
            136,
            171.52,
            22518.443
        ],
        [
            77,
            222.54,
            65928.934
        ],
        [
            74,
            296.72,
            3034.906
        ],
        [
            70,
            243.58,
            9037.513
        ],
        [
            58,
            119.81,
            33718.147
        ],
        [
            52,
            297.17,
            150.678
        ],
        [
            50,
            21.02,
            2281.226
        ],
        [
            45,
            247.54,
            29929.562
        ],
        [
            44,
            325.15,
            31555.956
        ],
        [
            29,
            60.93,
            4443.417
        ],
        [
            18,
            155.12,
            67555.328
        ],
        [
            17,
            288.79,
            4562.452
        ],
        [
            16,
            198.04,
            62894.029
        ],
        [
            14,
            199.76,
            31436.921
        ],
        [
            12,
            95.39,
            14577.848
        ],
        [
            12,
            287.11,
            31931.756
        ],
        [
            12,
            320.81,
            34777.259
        ],
        [
            9,
            227.73,
            1222.114
        ],
        [
            8,
            15.45,
            16859.074
        ]
    ];
    return term.map((t)=>{
        return {
            a: t[0],
            b: t[1],
            c: t[2]
        };
    });
}();
function march(y) {
    if (y < 1000) return eq(y, mc0);
    return eq(y - 2000, mc2);
}
function june(y) {
    if (y < 1000) return eq(y, jc0);
    return eq(y - 2000, jc2);
}
function september(y) {
    if (y < 1000) return eq(y, sc0);
    return eq(y - 2000, sc2);
}
function december(y) {
    if (y < 1000) return eq(y, dc0);
    return eq(y - 2000, dc2);
}
/**
 * Fast calculation of solstices/ equinoxes
 * Accuracy is within one minute of time for the years 1951-2050.
 *
 * @param {Number} y - (int) year
 * @param {Array} c - term from table 27.a / 27.b
 * @returns {Number} JDE
 */ function eq(y, c) {
    const J0 = (0, _baseJsDefault.default).horner(y * 0.001, c);
    const T = (0, _baseJsDefault.default).J2000Century(J0);
    const W = 35999.373 * D2R * T - 2.47 * D2R;
    const \u0394\u03BB = 1 + 0.0334 * cos(W) + 0.0007 * cos(2 * W);
    let S = 0;
    for(let i = terms.length - 1; i >= 0; i--){
        const t = terms[i];
        S += t.a * cos((t.b + t.c * T) * D2R);
    }
    return J0 + 0.00001 * S / \u0394\u03BB;
}
function march2(year, planet) {
    return longitude(year, planet, 0);
}
function june2(year, planet) {
    return longitude(year, planet, Math.PI / 2);
}
function september2(year, planet) {
    return longitude(year, planet, Math.PI);
}
function december2(year, planet) {
    return longitude(year, planet, Math.PI * 3 / 2);
}
function longitude(year, planet, lon) {
    let c;
    let ct;
    if (year < 1000) ct = [
        mc0,
        jc0,
        sc0,
        dc0
    ];
    else {
        ct = [
            mc2,
            jc2,
            sc2,
            dc2
        ];
        year -= 2000;
    }
    lon = lon % (Math.PI * 2);
    if (lon < Math.PI / 2) c = ct[0];
    else if (lon < Math.PI) c = ct[1];
    else if (lon < Math.PI * 3 / 2) c = ct[2];
    else c = ct[3];
    return eq2(year, planet, lon, c);
}
/**
  * Accurate calculation of solstices/ equinoxes
  * Result is accurate to one second of time.
  *
  * @param {Number} year - (int) year
  * @param {planetposition.Planet} planet - vsop87 planet
  * @param {Number} lon - longitude in radians
  * @param {Array} c - term from table 27.a / 27.b
  * @returns {Number} JDE
  */ function eq2(year, planet, lon, c) {
    let J0 = (0, _baseJsDefault.default).horner(year * 0.001, c);
    for(;;){
        const a = (0, _solarJsDefault.default).apparentVSOP87(planet, J0);
        const c = 58 * sin(lon - a.lon) // (27.1) p. 180
        ;
        J0 += c;
        if (abs(c) < 0.000005) break;
    }
    return J0;
}
exports.default = {
    march,
    june,
    september,
    december,
    march2,
    june2,
    september2,
    december2,
    longitude
};

},{"./base.js":"cO06o","./solar.js":"aC6LU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2XUNj":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module stellar
 */ /**
 * Stellar: Chapter 56, Stellar Magnitudes.
 */ /**
 * Sum returns the combined apparent magnitude of two stars.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sum", ()=>sum);
/**
 * SumN returns the combined apparent magnitude of a number of stars.
 */ parcelHelpers.export(exports, "sumN", ()=>sumN);
/**
 * Ratio returns the brightness ratio of two stars.
 *
 * Arguments m1, m2 are apparent magnitudes.
 */ parcelHelpers.export(exports, "ratio", ()=>ratio);
/**
 * Difference returns the difference in apparent magnitude of two stars
 * given their brightness ratio.
 */ parcelHelpers.export(exports, "difference", ()=>difference);
/**
 * AbsoluteByParallax returns absolute magnitude given annual parallax.
 *
 * Argument m is apparent magnitude, π is annual parallax in arc seconds.
 */ parcelHelpers.export(exports, "absoluteByParallax", ()=>absoluteByParallax);
/**
 * AbsoluteByDistance returns absolute magnitude given distance.
 *
 * Argument m is apparent magnitude, d is distance in parsecs.
 */ parcelHelpers.export(exports, "absoluteByDistance", ()=>absoluteByDistance);
function sum(m1, m2) {
    const x = 0.4 * (m2 - m1);
    return m2 - 2.5 * Math.log10(Math.pow(10, x) + 1);
}
function sumN(m) {
    let s = 0;
    for (const mi of m)s += Math.pow(10, -0.4 * mi);
    return -2.5 * Math.log10(s);
}
function ratio(m1, m2) {
    const x = 0.4 * (m2 - m1);
    return Math.pow(10, x);
}
function difference(ratio) {
    return 2.5 * Math.log10(ratio);
}
function absoluteByParallax(m, \u03C0) {
    return m + 5 + 5 * Math.log10(\u03C0);
}
function absoluteByDistance(m, d) {
    return m + 5 - 5 * Math.log10(d);
}
exports.default = {
    sum,
    sumN,
    ratio,
    difference,
    absoluteByParallax,
    absoluteByDistance
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dq533":[function(require,module,exports) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sundial
 */ /**
 * Sundial: Chapter 58, Calculation of a Planar Sundial.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * General computes data for the general case of a planar sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located.
 * D is gnomonic declination, the azimuth of the perpendicular to the plane
 * of the sundial, measured from the southern meridian towards the west.
 * Argument a is the length of a straight stylus perpendicular to the plane
 * of the sundial, z is zenithal distance of the direction defined by the
 * stylus.  Angles φ, D, and z are in radians.  Units of stylus length a
 * are arbitrary.
 *
 * Results consist of a set of lines, a center point, u, the length of a
 * polar stylus, and ψ, the angle which the polar stylus makes with the plane
 * of the sundial.  The center point, the points defining the hour lines, and
 * u are in units of a, the stylus length.  ψ is in radians.
 */ parcelHelpers.export(exports, "general", ()=>general);
/**
 * Equatorial computes data for a sundial level with the equator.
 *
 * Argument φ is geographic latitude at which the sundial will be located;
 * a is the length of a straight stylus perpendicular to the plane of the
 * sundial.
 *
 * The sundial will have two sides, north and south.  Results n and s define
 * lines on the north and south sides of the sundial.  Result coordinates
 * are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "equatorial", ()=>equatorial);
/**
 * Horizontal computes data for a horizontal sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located,
 * a is the length of a straight stylus perpendicular to the plane of the
 * sundial.
 *
 * Results consist of a set of lines, a center point, and u, the length of a
 * polar stylus.  They are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "horizontal", ()=>horizontal);
/**
 * Vertical computes data for a vertical sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located.
 * D is gnomonic declination, the azimuth of the perpendicular to the plane
 * of the sundial, measured from the southern meridian towards the west.
 * Argument a is the length of a straight stylus perpendicular to the plane
 * of the sundial.
 *
 * Results consist of a set of lines, a center point, and u, the length of a
 * polar stylus.  They are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "vertical", ()=>vertical);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
/**
 * Point return type represents a point to be used in constructing the sundial.
 */ function Point(x, y) {
    this.x = x || 0;
    this.y = y || 0;
}
/**
 * Line holds data to draw an hour line on the sundial.
 */ function Line(hour, points) {
    this.hour = hour // 0 to 24
    ;
    this.points = points || [] // One or more points corresponding to the hour.
    ;
}
const m = [
    -23.44,
    -20.15,
    -11.47,
    0,
    11.47,
    20.15,
    23.44
];
function general(\u03C6, D, a, z) {
    const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const [sD, cD] = (0, _baseJsDefault.default).sincos(D);
    const [sz, cz] = (0, _baseJsDefault.default).sincos(z);
    const P = s\u03C6 * cz - c\u03C6 * sz * cD;
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
        for (const d of m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = sD * sz * sH + (c\u03C6 * cz + s\u03C6 * sz * cD) * cH + P * t\u03B4;
            if (Q < 0) continue; // sun below plane of sundial
            const Nx = cD * sH - sD * (s\u03C6 * cH - c\u03C6 * t\u03B4);
            const Ny = cz * sD * sH - (c\u03C6 * sz - s\u03C6 * cz * cD) * cH - (s\u03C6 * sz + c\u03C6 * cz * cD) * t\u03B4;
            l.points.push(new Point(a * Nx / Q, a * Ny / Q));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new Point();
    center.x = a / P * c\u03C6 * sD;
    center.y = -a / P * (s\u03C6 * sz + c\u03C6 * cz * cD);
    const aP = Math.abs(P);
    const u = a / aP;
    const \u03C8 = Math.asin(aP);
    return {
        lines,
        center,
        length: u,
        angle: \u03C8
    };
}
function equatorial(\u03C6, a) {
    const t\u03C6 = Math.tan(\u03C6);
    const n = [];
    const s = [];
    for(let i = 0; i < 24; i++){
        const nl = new Line(i);
        const sl = new Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
        for (const d of m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue;
            const x = -a * sH / t\u03B4;
            const yy = a * cH / t\u03B4;
            if (t\u03B4 < 0) sl.points.push(new Point(x, yy));
            else nl.points.push(new Point(x, -yy));
        }
        if (nl.points.length > 0) n.push(nl);
        if (sl.points.length > 0) s.push(sl);
    }
    return {
        north: n,
        south: s
    };
}
function horizontal(\u03C6, a) {
    const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
        for (const d of m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = c\u03C6 * cH + s\u03C6 * t\u03B4;
            const x = a * sH / Q;
            const y = a * (s\u03C6 * cH - c\u03C6 * t\u03B4) / Q;
            l.points.push(new Point(x, y));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new Point(0, -a / t\u03C6);
    const u = a / Math.abs(s\u03C6);
    return {
        lines,
        center,
        length: u
    };
}
function vertical(\u03C6, D, a) {
    const [s\u03C6, c\u03C6] = (0, _baseJsDefault.default).sincos(\u03C6);
    const t\u03C6 = s\u03C6 / c\u03C6;
    const [sD, cD] = (0, _baseJsDefault.default).sincos(D);
    const lines = [];
    for(let i = 0; i < 24; i++){
        const l = new Line(i);
        const H = (i - 12) * 15 * Math.PI / 180;
        const aH = Math.abs(H);
        const [sH, cH] = (0, _baseJsDefault.default).sincos(H);
        for (const d of m){
            const t\u03B4 = Math.tan(d * Math.PI / 180);
            const H0 = Math.acos(-t\u03C6 * t\u03B4);
            if (aH > H0) continue; // sun below horizon
            const Q = sD * sH + s\u03C6 * cD * cH - c\u03C6 * cD * t\u03B4;
            if (Q < 0) continue; // sun below plane of sundial
            const x = a * (cD * sH - s\u03C6 * sD * cH + c\u03C6 * sD * t\u03B4) / Q;
            const y = -a * (c\u03C6 * cH + s\u03C6 * t\u03B4) / Q;
            l.points.push(new Point(x, y));
        }
        if (l.points.length > 0) lines.push(l);
    }
    const center = new Point();
    center.x = -a * sD / cD;
    center.y = a * t\u03C6 / cD;
    const u = a / Math.abs(c\u03C6 * cD);
    return {
        lines,
        center,
        length: u
    };
}
exports.default = {
    general,
    equatorial,
    horizontal,
    vertical
};

},{"./base.js":"cO06o","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6Q7Wz":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 * @module sunrise
 */ /**
 * Sunrise: Compute rise, noon, set of the Sun for an earth observer
 */ /* eslint key-spacing: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sunrise", ()=>Sunrise);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _eqtimeJs = require("./eqtime.js");
var _eqtimeJsDefault = parcelHelpers.interopDefault(_eqtimeJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _riseJs = require("./rise.js");
var _riseJsDefault = parcelHelpers.interopDefault(_riseJs);
const stdh0 = {
    sunrise: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 50, 0).rad(),
    sunriseEnd: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 18, 0).rad(),
    twilight: new (0, _sexagesimalJsDefault.default).Angle(true, 6, 0, 0).rad(),
    nauticalTwilight: new (0, _sexagesimalJsDefault.default).Angle(true, 12, 0, 0).rad(),
    night: new (0, _sexagesimalJsDefault.default).Angle(true, 18, 0, 0).rad(),
    goldenHour: new (0, _sexagesimalJsDefault.default).Angle(false, 6, 0, 0).rad()
};
const stdh0Sunrise = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.sunrise, refraction);
const stdh0SunriseEnd = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.sunriseEnd, refraction);
const stdh0Twilight = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.twilight, refraction);
const stdh0NauticalTwilight = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.nauticalTwilight, refraction);
const stdh0Night = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.night, refraction);
const stdh0GoldenHour = (refraction)=>(0, _riseJsDefault.default).refraction(stdh0.goldenHour, refraction);
class Sunrise {
    _calcNoon(jde) {
        const etime = (0, _sexagesimalJsDefault.default).secFromHourAngle((0, _eqtimeJsDefault.default).eSmart(jde));
        const delta = (0, _sexagesimalJsDefault.default).secFromHourAngle(this.lon);
        const time = 43200 /* noon */  + delta - etime // in seconds
        ;
        return (0, _baseJsDefault.default).pmod(time / 86400, 86400);
    }
    _calcRiseOrSet(jde, h0, isSet) {
        const etime = (0, _sexagesimalJsDefault.default).secFromHourAngle((0, _eqtimeJsDefault.default).eSmart(jde));
        const solarDec = (0, _solarJsDefault.default).apparentEquatorial(jde).dec;
        let ha = (0, _riseJsDefault.default).hourAngle(this.lat, h0, solarDec);
        if (isSet) ha = -ha;
        const delta = (0, _sexagesimalJsDefault.default).secFromHourAngle(ha - this.lon);
        const time = 43200 /* noon */  - delta - etime // in seconds
        ;
        return time / 86400;
    }
    _calcPolarDayNight(h0, isSet, step) {
        let jde = this.jde;
        let t;
        let failCnt = 0;
        while(failCnt < 190){
            jde += step;
            try {
                t = this._calcRiseOrSet(jde, h0, isSet);
                t = this._calcRiseOrSet(jde + t, h0, isSet);
                break;
            } catch (e) {
                t = undefined;
                failCnt++;
            }
        }
        if (t === undefined) return;
        return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
    }
    _calc(h0, isSet) {
        let t;
        const jde = this.jde;
        // calc 2times for higher accuracy
        try {
            t = this._calcRiseOrSet(jde, h0, isSet);
            t = this._calcRiseOrSet(jde + t, h0, isSet);
            return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
        } catch (e) {
            let step = isSet ? -1 : 1;
            const doy = this.date.dayOfYear();
            if (this.lat > 0 && doy > 76 && doy < 267 || // northern hemisphere
            this.lat < 0 && (doy < 83 || doy > 262) // southern hemisphere
            ) step = -step;
            return this._calcPolarDayNight(h0, isSet, step);
        }
    }
    /**
   * time of solar transit
   * @return {julian.Calendar} time of noon
   */ noon() {
        const jde = this.jde;
        // calc 2times for higher accuracy
        let t = this._calcNoon(jde + this.lon / (2 * Math.PI));
        t = this._calcNoon(jde + t);
        return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
    }
    /**
   * Solar limb appears over the easter horizon in the morning
   * @return {julian.Calendar} time of sunrise
   */ rise() {
        return this._calc(stdh0Sunrise(this.refraction), false);
    }
    /**
   * @return {julian.Calendar} time of sunset
   * Solar limb disappears on the western horizon in the evening
   */ set() {
        return this._calc(stdh0Sunrise(this.refraction), true);
    }
    /**
   * Solar limb is fully visible at the easter horizon
   * @return {julian.Calendar} time of sunrise end
   */ riseEnd() {
        return this._calc(stdh0SunriseEnd(this.refraction), false);
    }
    /**
   * Solar limb starts disappearing on the western horizon in the evening
   * @return {julian.Calendar} time of sunset start
   */ setStart() {
        return this._calc(stdh0SunriseEnd(this.refraction), true);
    }
    /**
   * Dawn, there is still enough light for objects to be distinguishable,
   * @return {julian.Calendar} time of dawn
   */ dawn() {
        return this._calc(stdh0Twilight(this.refraction), false);
    }
    /**
   * Dusk, there is still enough light for objects to be distinguishable
   * Bright stars and planets are visible by naked eye
   * @return {julian.Calendar} time of dusk
   */ dusk() {
        return this._calc(stdh0Twilight(this.refraction), true);
    }
    /**
   * nautical dawn - Horizon gets visible by naked eye
   * @return {julian.Calendar} time of nautical dawn
   */ nauticalDawn() {
        return this._calc(stdh0NauticalTwilight(this.refraction), false);
    }
    /**
   * nautical dusk - Horizon is no longer visible by naked eye
   * @return {julian.Calendar} time of nautical dusk
   */ nauticalDusk() {
        return this._calc(stdh0NauticalTwilight(this.refraction), true);
    }
    /**
   * night starts - No sunlight illumination of the sky, such no intereferance
   * with astronomical observations.
   * @return {julian.Calendar} time of start of night
   */ nightStart() {
        return this._calc(stdh0Night(this.refraction), true);
    }
    /**
   * night end - Sunlight starts illumination of the sky and interferes
   * with astronomical observations.
   * @return {julian.Calendar} time of end of night
   */ nightEnd() {
        return this._calc(stdh0Night(this.refraction), false);
    }
    /**
   * Start of "golden hour" before sunset
   * @return {julian.Calendar} time of start of golden hour
   */ goldenHourStart() {
        return this._calc(stdh0GoldenHour(this.refraction), true);
    }
    /**
   * End of "golden hour" after sunrise
   * @return {julian.Calendar} time of end of golden hour
   */ goldenHourEnd() {
        return this._calc(stdh0GoldenHour(this.refraction), false);
    }
    /**
   * Computes time of sunrise, sunset for a given day `date` of an observer on earth given by latitude and longitude.
   * Methods may return `undefined` instead of `julian.Calendar` for latitudes very near the poles.
   * @param {julian.Calendar} date - calendar date
   * @param {number} lat - latitude of observer in the range of (-89.6, 89.6)
   * @param {number} lon - longitude of observer (measured positively westwards, New York = 40.7° lat, 74° lon)
   * @param {number} [refraction] - optional refraction
   */ constructor(date, lat, lon, refraction){
        this.date = date;
        this.jde = date.midnight().toJDE();
        this.lat = (0, _sexagesimalJsDefault.default).angleFromDeg(lat);
        this.lon = (0, _sexagesimalJsDefault.default).angleFromDeg(lon);
        this.refraction = refraction;
    }
}
exports.default = {
    Sunrise
};

},{"./base.js":"cO06o","./eqtime.js":"8YjFi","./sexagesimal.js":"1aKkU","./solar.js":"aC6LU","./julian.js":"da2eV","./rise.js":"2pO5I","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"ceOFO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Hebrew);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventMapJs = require("./CalEventMap.js");
var _calEventMapJsDefault = parcelHelpers.interopDefault(_calEventMapJs);
var _hebrewCalendarJs = require("./internal/hebrew-calendar.js");
class Hebrew extends (0, _calEventMapJsDefault.default) {
    get(timezone) {
        const arr = this.dates.map((date)=>{
            const cdate = new (0, _caldateDefault.default)(date);
            const o = {
                date: cdate.toString() + " -0600",
                start: cdate.setOffset(-6, "h").toTimezone(timezone),
                end: cdate.toEndDate().toTimezone(timezone)
            };
            this._addSubstitute(date, o);
            return o;
        });
        return arr;
    }
    constructor(opts){
        super(opts);
        this.calendar = (0, _hebrewCalendarJs.calendar);
    }
}

},{"caldate":"dgF7z","./CalEventMap.js":"YaAJX","./internal/hebrew-calendar.js":"hSGzT","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"YaAJX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Mapper class for mapped calenders like hijri and hebrew
 * `this.calender` needs to be set in child classes
 */ parcelHelpers.export(exports, "default", ()=>CalEventMap);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
class CalEventMap extends (0, _calEventJsDefault.default) {
    inYear(year) {
        if (!(this.calendar[year] && this.calendar[year + 1] && this.calendar[year - 1])) return this;
        for(let y = year - 1; y <= year + 1; y++){
            // resolve date in `calendar` as gregorian date
            const firstDays = this.calendar[y][this.opts.month - 1];
            // firstDays `[M, D, diffYear, ...] | null`
            if (!firstDays) continue;
            for(let i = 0; i < firstDays.length; i += 3){
                if (this.opts.year) {
                    const calYear = this.calendar.year + firstDays[i + 2];
                    if (this.opts.year !== calYear) continue;
                }
                const d = new (0, _caldateDefault.default)({
                    year: y,
                    month: firstDays[i] + 1,
                    day: firstDays[i + 1]
                }).setOffset(this.opts.day - 1);
                if (d.year === year) this.dates.push(d);
            }
        }
        return this;
    }
    constructor(opts){
        super(opts);
        this.calendar = {};
    }
}

},{"./CalEvent.js":"dCRj3","caldate":"dgF7z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hSGzT":[function(require,module,exports) {
/*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
const calendar = {
    1968: [
        null,
        null,
        null,
        null,
        null,
        null,
        [
            8,
            23,
            0
        ],
        [
            9,
            23,
            0
        ],
        [
            10,
            22,
            0
        ],
        [
            11,
            22,
            0
        ]
    ],
    1969: [
        [
            2,
            20,
            0
        ],
        [
            3,
            19,
            0
        ],
        [
            4,
            18,
            0
        ],
        [
            5,
            17,
            0
        ],
        [
            6,
            16,
            0
        ],
        [
            7,
            15,
            0
        ],
        [
            8,
            13,
            1
        ],
        [
            9,
            13,
            1
        ],
        [
            10,
            11,
            1
        ],
        [
            11,
            10,
            1
        ],
        [
            0,
            20,
            0
        ],
        [
            1,
            19,
            0
        ],
        [
            1,
            19,
            0
        ]
    ],
    1970: [
        [
            3,
            7,
            1
        ],
        [
            4,
            7,
            1
        ],
        [
            5,
            5,
            1
        ],
        [
            6,
            5,
            1
        ],
        [
            7,
            3,
            1
        ],
        [
            8,
            2,
            1
        ],
        [
            9,
            1,
            2
        ],
        [
            9,
            31,
            2
        ],
        [
            10,
            29,
            2
        ],
        [
            11,
            29,
            2
        ],
        [
            0,
            8,
            1
        ],
        [
            1,
            7,
            1
        ],
        [
            2,
            9,
            1
        ]
    ],
    1971: [
        [
            2,
            27,
            2
        ],
        [
            3,
            26,
            2
        ],
        [
            4,
            25,
            2
        ],
        [
            5,
            24,
            2
        ],
        [
            6,
            23,
            2
        ],
        [
            7,
            22,
            2
        ],
        [
            8,
            20,
            3
        ],
        [
            9,
            20,
            3
        ],
        [
            10,
            19,
            3
        ],
        [
            11,
            19,
            3
        ],
        [
            0,
            27,
            2
        ],
        [
            1,
            26,
            2
        ],
        [
            1,
            26,
            2
        ]
    ],
    1972: [
        [
            2,
            16,
            3
        ],
        [
            3,
            15,
            3
        ],
        [
            4,
            14,
            3
        ],
        [
            5,
            13,
            3
        ],
        [
            6,
            12,
            3
        ],
        [
            7,
            11,
            3
        ],
        [
            8,
            9,
            4
        ],
        [
            9,
            9,
            4
        ],
        [
            10,
            7,
            4
        ],
        [
            11,
            6,
            4
        ],
        [
            0,
            17,
            3
        ],
        [
            1,
            16,
            3
        ],
        [
            1,
            16,
            3
        ]
    ],
    1973: [
        [
            3,
            3,
            4
        ],
        [
            4,
            3,
            4
        ],
        [
            5,
            1,
            4
        ],
        [
            6,
            1,
            4
        ],
        [
            6,
            30,
            4
        ],
        [
            7,
            29,
            4
        ],
        [
            8,
            27,
            5
        ],
        [
            9,
            27,
            5
        ],
        [
            10,
            26,
            5
        ],
        [
            11,
            26,
            5
        ],
        [
            0,
            4,
            4
        ],
        [
            1,
            3,
            4
        ],
        [
            2,
            5,
            4
        ]
    ],
    1974: [
        [
            2,
            24,
            5
        ],
        [
            3,
            23,
            5
        ],
        [
            4,
            22,
            5
        ],
        [
            5,
            21,
            5
        ],
        [
            6,
            20,
            5
        ],
        [
            7,
            19,
            5
        ],
        [
            8,
            17,
            6
        ],
        [
            9,
            17,
            6
        ],
        [
            10,
            15,
            6
        ],
        [
            11,
            15,
            6
        ],
        [
            0,
            24,
            5
        ],
        [
            1,
            23,
            5
        ],
        [
            1,
            23,
            5
        ]
    ],
    1975: [
        [
            2,
            13,
            6
        ],
        [
            3,
            12,
            6
        ],
        [
            4,
            11,
            6
        ],
        [
            5,
            10,
            6
        ],
        [
            6,
            9,
            6
        ],
        [
            7,
            8,
            6
        ],
        [
            8,
            6,
            7
        ],
        [
            9,
            6,
            7
        ],
        [
            10,
            5,
            7
        ],
        [
            11,
            5,
            7
        ],
        [
            0,
            13,
            6
        ],
        [
            1,
            12,
            6
        ],
        [
            1,
            12,
            6
        ]
    ],
    1976: [
        [
            3,
            1,
            7
        ],
        [
            4,
            1,
            7
        ],
        [
            4,
            30,
            7
        ],
        [
            5,
            29,
            7
        ],
        [
            6,
            28,
            7
        ],
        [
            7,
            27,
            7
        ],
        [
            8,
            25,
            8
        ],
        [
            9,
            25,
            8
        ],
        [
            10,
            23,
            8
        ],
        [
            11,
            22,
            8
        ],
        [
            0,
            3,
            7
        ],
        [
            1,
            2,
            7
        ],
        [
            2,
            3,
            7
        ]
    ],
    1977: [
        [
            2,
            20,
            8
        ],
        [
            3,
            19,
            8
        ],
        [
            4,
            18,
            8
        ],
        [
            5,
            17,
            8
        ],
        [
            6,
            16,
            8
        ],
        [
            7,
            15,
            8
        ],
        [
            8,
            13,
            9
        ],
        [
            9,
            13,
            9
        ],
        [
            10,
            11,
            9
        ],
        [
            11,
            11,
            9
        ],
        [
            0,
            20,
            8
        ],
        [
            1,
            19,
            8
        ],
        [
            1,
            19,
            8
        ]
    ],
    1978: [
        [
            3,
            8,
            9
        ],
        [
            4,
            8,
            9
        ],
        [
            5,
            6,
            9
        ],
        [
            6,
            6,
            9
        ],
        [
            7,
            4,
            9
        ],
        [
            8,
            3,
            9
        ],
        [
            9,
            2,
            10
        ],
        [
            10,
            1,
            10
        ],
        [
            11,
            1,
            10
        ],
        [
            11,
            31,
            10
        ],
        [
            0,
            9,
            9
        ],
        [
            1,
            8,
            9
        ],
        [
            2,
            10,
            9
        ]
    ],
    1979: [
        [
            2,
            29,
            10
        ],
        [
            3,
            28,
            10
        ],
        [
            4,
            27,
            10
        ],
        [
            5,
            26,
            10
        ],
        [
            6,
            25,
            10
        ],
        [
            7,
            24,
            10
        ],
        [
            8,
            22,
            11
        ],
        [
            9,
            22,
            11
        ],
        [
            10,
            21,
            11
        ],
        [
            11,
            21,
            11
        ],
        [
            0,
            29,
            10
        ],
        [
            1,
            28,
            10
        ],
        [
            1,
            28,
            10
        ]
    ],
    1980: [
        [
            2,
            18,
            11
        ],
        [
            3,
            17,
            11
        ],
        [
            4,
            16,
            11
        ],
        [
            5,
            15,
            11
        ],
        [
            6,
            14,
            11
        ],
        [
            7,
            13,
            11
        ],
        [
            8,
            11,
            12
        ],
        [
            9,
            11,
            12
        ],
        [
            10,
            9,
            12
        ],
        [
            11,
            8,
            12
        ],
        [
            0,
            19,
            11
        ],
        [
            1,
            18,
            11
        ],
        [
            1,
            18,
            11
        ]
    ],
    1981: [
        [
            3,
            5,
            12
        ],
        [
            4,
            5,
            12
        ],
        [
            5,
            3,
            12
        ],
        [
            6,
            3,
            12
        ],
        [
            7,
            1,
            12
        ],
        [
            7,
            31,
            12
        ],
        [
            8,
            29,
            13
        ],
        [
            9,
            29,
            13
        ],
        [
            10,
            27,
            13
        ],
        [
            11,
            27,
            13
        ],
        [
            0,
            6,
            12
        ],
        [
            1,
            5,
            12
        ],
        [
            2,
            7,
            12
        ]
    ],
    1982: [
        [
            2,
            25,
            13
        ],
        [
            3,
            24,
            13
        ],
        [
            4,
            23,
            13
        ],
        [
            5,
            22,
            13
        ],
        [
            6,
            21,
            13
        ],
        [
            7,
            20,
            13
        ],
        [
            8,
            18,
            14
        ],
        [
            9,
            18,
            14
        ],
        [
            10,
            17,
            14
        ],
        [
            11,
            17,
            14
        ],
        [
            0,
            25,
            13
        ],
        [
            1,
            24,
            13
        ],
        [
            1,
            24,
            13
        ]
    ],
    1983: [
        [
            2,
            15,
            14
        ],
        [
            3,
            14,
            14
        ],
        [
            4,
            13,
            14
        ],
        [
            5,
            12,
            14
        ],
        [
            6,
            11,
            14
        ],
        [
            7,
            10,
            14
        ],
        [
            8,
            8,
            15
        ],
        [
            9,
            8,
            15
        ],
        [
            10,
            7,
            15
        ],
        [
            11,
            7,
            15
        ],
        [
            0,
            15,
            14
        ],
        [
            1,
            14,
            14
        ],
        [
            1,
            14,
            14
        ]
    ],
    1984: [
        [
            3,
            3,
            15
        ],
        [
            4,
            3,
            15
        ],
        [
            5,
            1,
            15
        ],
        [
            6,
            1,
            15
        ],
        [
            6,
            30,
            15
        ],
        [
            7,
            29,
            15
        ],
        [
            8,
            27,
            16
        ],
        [
            9,
            27,
            16
        ],
        [
            10,
            25,
            16
        ],
        [
            11,
            25,
            16
        ],
        [
            0,
            5,
            15
        ],
        [
            1,
            4,
            15
        ],
        [
            2,
            5,
            15
        ]
    ],
    1985: [
        [
            2,
            23,
            16
        ],
        [
            3,
            22,
            16
        ],
        [
            4,
            21,
            16
        ],
        [
            5,
            20,
            16
        ],
        [
            6,
            19,
            16
        ],
        [
            7,
            18,
            16
        ],
        [
            8,
            16,
            17
        ],
        [
            9,
            16,
            17
        ],
        [
            10,
            14,
            17
        ],
        [
            11,
            13,
            17
        ],
        [
            0,
            23,
            16
        ],
        [
            1,
            22,
            16
        ],
        [
            1,
            22,
            16
        ]
    ],
    1986: [
        [
            3,
            10,
            17
        ],
        [
            4,
            10,
            17
        ],
        [
            5,
            8,
            17
        ],
        [
            6,
            8,
            17
        ],
        [
            7,
            6,
            17
        ],
        [
            8,
            5,
            17
        ],
        [
            9,
            4,
            18
        ],
        [
            10,
            3,
            18
        ],
        [
            11,
            3,
            18
        ],
        null,
        [
            0,
            11,
            17
        ],
        [
            1,
            10,
            17
        ],
        [
            2,
            12,
            17
        ]
    ],
    1987: [
        [
            2,
            31,
            18
        ],
        [
            3,
            30,
            18
        ],
        [
            4,
            29,
            18
        ],
        [
            5,
            28,
            18
        ],
        [
            6,
            27,
            18
        ],
        [
            7,
            26,
            18
        ],
        [
            8,
            24,
            19
        ],
        [
            9,
            24,
            19
        ],
        [
            10,
            22,
            19
        ],
        [
            0,
            2,
            18,
            11,
            22,
            19
        ],
        [
            0,
            31,
            18
        ],
        [
            2,
            2,
            18
        ],
        [
            2,
            2,
            18
        ]
    ],
    1988: [
        [
            2,
            19,
            19
        ],
        [
            3,
            18,
            19
        ],
        [
            4,
            17,
            19
        ],
        [
            5,
            16,
            19
        ],
        [
            6,
            15,
            19
        ],
        [
            7,
            14,
            19
        ],
        [
            8,
            12,
            20
        ],
        [
            9,
            12,
            20
        ],
        [
            10,
            10,
            20
        ],
        [
            11,
            9,
            20
        ],
        [
            0,
            20,
            19
        ],
        [
            1,
            19,
            19
        ],
        [
            1,
            19,
            19
        ]
    ],
    1989: [
        [
            3,
            6,
            20
        ],
        [
            4,
            6,
            20
        ],
        [
            5,
            4,
            20
        ],
        [
            6,
            4,
            20
        ],
        [
            7,
            2,
            20
        ],
        [
            8,
            1,
            20
        ],
        [
            8,
            30,
            21
        ],
        [
            9,
            30,
            21
        ],
        [
            10,
            29,
            21
        ],
        [
            11,
            29,
            21
        ],
        [
            0,
            7,
            20
        ],
        [
            1,
            6,
            20
        ],
        [
            2,
            8,
            20
        ]
    ],
    1990: [
        [
            2,
            27,
            21
        ],
        [
            3,
            26,
            21
        ],
        [
            4,
            25,
            21
        ],
        [
            5,
            24,
            21
        ],
        [
            6,
            23,
            21
        ],
        [
            7,
            22,
            21
        ],
        [
            8,
            20,
            22
        ],
        [
            9,
            20,
            22
        ],
        [
            10,
            18,
            22
        ],
        [
            11,
            18,
            22
        ],
        [
            0,
            27,
            21
        ],
        [
            1,
            26,
            21
        ],
        [
            1,
            26,
            21
        ]
    ],
    1991: [
        [
            2,
            16,
            22
        ],
        [
            3,
            15,
            22
        ],
        [
            4,
            14,
            22
        ],
        [
            5,
            13,
            22
        ],
        [
            6,
            12,
            22
        ],
        [
            7,
            11,
            22
        ],
        [
            8,
            9,
            23
        ],
        [
            9,
            9,
            23
        ],
        [
            10,
            8,
            23
        ],
        [
            11,
            8,
            23
        ],
        [
            0,
            16,
            22
        ],
        [
            1,
            15,
            22
        ],
        [
            1,
            15,
            22
        ]
    ],
    1992: [
        [
            3,
            4,
            23
        ],
        [
            4,
            4,
            23
        ],
        [
            5,
            2,
            23
        ],
        [
            6,
            2,
            23
        ],
        [
            6,
            31,
            23
        ],
        [
            7,
            30,
            23
        ],
        [
            8,
            28,
            24
        ],
        [
            9,
            28,
            24
        ],
        [
            10,
            26,
            24
        ],
        [
            11,
            25,
            24
        ],
        [
            0,
            6,
            23
        ],
        [
            1,
            5,
            23
        ],
        [
            2,
            6,
            23
        ]
    ],
    1993: [
        [
            2,
            23,
            24
        ],
        [
            3,
            22,
            24
        ],
        [
            4,
            21,
            24
        ],
        [
            5,
            20,
            24
        ],
        [
            6,
            19,
            24
        ],
        [
            7,
            18,
            24
        ],
        [
            8,
            16,
            25
        ],
        [
            9,
            16,
            25
        ],
        [
            10,
            15,
            25
        ],
        [
            11,
            15,
            25
        ],
        [
            0,
            23,
            24
        ],
        [
            1,
            22,
            24
        ],
        [
            1,
            22,
            24
        ]
    ],
    1994: [
        [
            2,
            13,
            25
        ],
        [
            3,
            12,
            25
        ],
        [
            4,
            11,
            25
        ],
        [
            5,
            10,
            25
        ],
        [
            6,
            9,
            25
        ],
        [
            7,
            8,
            25
        ],
        [
            8,
            6,
            26
        ],
        [
            9,
            6,
            26
        ],
        [
            10,
            4,
            26
        ],
        [
            11,
            4,
            26
        ],
        [
            0,
            13,
            25
        ],
        [
            1,
            12,
            25
        ],
        [
            1,
            12,
            25
        ]
    ],
    1995: [
        [
            3,
            1,
            26
        ],
        [
            4,
            1,
            26
        ],
        [
            4,
            30,
            26
        ],
        [
            5,
            29,
            26
        ],
        [
            6,
            28,
            26
        ],
        [
            7,
            27,
            26
        ],
        [
            8,
            25,
            27
        ],
        [
            9,
            25,
            27
        ],
        [
            10,
            24,
            27
        ],
        [
            11,
            24,
            27
        ],
        [
            0,
            2,
            26
        ],
        [
            1,
            1,
            26
        ],
        [
            2,
            3,
            26
        ]
    ],
    1996: [
        [
            2,
            21,
            27
        ],
        [
            3,
            20,
            27
        ],
        [
            4,
            19,
            27
        ],
        [
            5,
            18,
            27
        ],
        [
            6,
            17,
            27
        ],
        [
            7,
            16,
            27
        ],
        [
            8,
            14,
            28
        ],
        [
            9,
            14,
            28
        ],
        [
            10,
            12,
            28
        ],
        [
            11,
            11,
            28
        ],
        [
            0,
            22,
            27
        ],
        [
            1,
            21,
            27
        ],
        [
            1,
            21,
            27
        ]
    ],
    1997: [
        [
            3,
            8,
            28
        ],
        [
            4,
            8,
            28
        ],
        [
            5,
            6,
            28
        ],
        [
            6,
            6,
            28
        ],
        [
            7,
            4,
            28
        ],
        [
            8,
            3,
            28
        ],
        [
            9,
            2,
            29
        ],
        [
            10,
            1,
            29
        ],
        [
            10,
            30,
            29
        ],
        [
            11,
            30,
            29
        ],
        [
            0,
            9,
            28
        ],
        [
            1,
            8,
            28
        ],
        [
            2,
            10,
            28
        ]
    ],
    1998: [
        [
            2,
            28,
            29
        ],
        [
            3,
            27,
            29
        ],
        [
            4,
            26,
            29
        ],
        [
            5,
            25,
            29
        ],
        [
            6,
            24,
            29
        ],
        [
            7,
            23,
            29
        ],
        [
            8,
            21,
            30
        ],
        [
            9,
            21,
            30
        ],
        [
            10,
            20,
            30
        ],
        [
            11,
            20,
            30
        ],
        [
            0,
            28,
            29
        ],
        [
            1,
            27,
            29
        ],
        [
            1,
            27,
            29
        ]
    ],
    1999: [
        [
            2,
            18,
            30
        ],
        [
            3,
            17,
            30
        ],
        [
            4,
            16,
            30
        ],
        [
            5,
            15,
            30
        ],
        [
            6,
            14,
            30
        ],
        [
            7,
            13,
            30
        ],
        [
            8,
            11,
            31
        ],
        [
            9,
            11,
            31
        ],
        [
            10,
            10,
            31
        ],
        [
            11,
            10,
            31
        ],
        [
            0,
            18,
            30
        ],
        [
            1,
            17,
            30
        ],
        [
            1,
            17,
            30
        ]
    ],
    2000: [
        [
            3,
            6,
            31
        ],
        [
            4,
            6,
            31
        ],
        [
            5,
            4,
            31
        ],
        [
            6,
            4,
            31
        ],
        [
            7,
            2,
            31
        ],
        [
            8,
            1,
            31
        ],
        [
            8,
            30,
            32
        ],
        [
            9,
            30,
            32
        ],
        [
            10,
            28,
            32
        ],
        [
            11,
            27,
            32
        ],
        [
            0,
            8,
            31
        ],
        [
            1,
            7,
            31
        ],
        [
            2,
            8,
            31
        ]
    ],
    2001: [
        [
            2,
            25,
            32
        ],
        [
            3,
            24,
            32
        ],
        [
            4,
            23,
            32
        ],
        [
            5,
            22,
            32
        ],
        [
            6,
            21,
            32
        ],
        [
            7,
            20,
            32
        ],
        [
            8,
            18,
            33
        ],
        [
            9,
            18,
            33
        ],
        [
            10,
            16,
            33
        ],
        [
            11,
            16,
            33
        ],
        [
            0,
            25,
            32
        ],
        [
            1,
            24,
            32
        ],
        [
            1,
            24,
            32
        ]
    ],
    2002: [
        [
            2,
            14,
            33
        ],
        [
            3,
            13,
            33
        ],
        [
            4,
            12,
            33
        ],
        [
            5,
            11,
            33
        ],
        [
            6,
            10,
            33
        ],
        [
            7,
            9,
            33
        ],
        [
            8,
            7,
            34
        ],
        [
            9,
            7,
            34
        ],
        [
            10,
            6,
            34
        ],
        [
            11,
            6,
            34
        ],
        [
            0,
            14,
            33
        ],
        [
            1,
            13,
            33
        ],
        [
            1,
            13,
            33
        ]
    ],
    2003: [
        [
            3,
            3,
            34
        ],
        [
            4,
            3,
            34
        ],
        [
            5,
            1,
            34
        ],
        [
            6,
            1,
            34
        ],
        [
            6,
            30,
            34
        ],
        [
            7,
            29,
            34
        ],
        [
            8,
            27,
            35
        ],
        [
            9,
            27,
            35
        ],
        [
            10,
            26,
            35
        ],
        [
            11,
            26,
            35
        ],
        [
            0,
            4,
            34
        ],
        [
            1,
            3,
            34
        ],
        [
            2,
            5,
            34
        ]
    ],
    2004: [
        [
            2,
            23,
            35
        ],
        [
            3,
            22,
            35
        ],
        [
            4,
            21,
            35
        ],
        [
            5,
            20,
            35
        ],
        [
            6,
            19,
            35
        ],
        [
            7,
            18,
            35
        ],
        [
            8,
            16,
            36
        ],
        [
            9,
            16,
            36
        ],
        [
            10,
            14,
            36
        ],
        [
            11,
            13,
            36
        ],
        [
            0,
            24,
            35
        ],
        [
            1,
            23,
            35
        ],
        [
            1,
            23,
            35
        ]
    ],
    2005: [
        [
            3,
            10,
            36
        ],
        [
            4,
            10,
            36
        ],
        [
            5,
            8,
            36
        ],
        [
            6,
            8,
            36
        ],
        [
            7,
            6,
            36
        ],
        [
            8,
            5,
            36
        ],
        [
            9,
            4,
            37
        ],
        [
            10,
            3,
            37
        ],
        [
            11,
            2,
            37
        ],
        null,
        [
            0,
            11,
            36
        ],
        [
            1,
            10,
            36
        ],
        [
            2,
            12,
            36
        ]
    ],
    2006: [
        [
            2,
            30,
            37
        ],
        [
            3,
            29,
            37
        ],
        [
            4,
            28,
            37
        ],
        [
            5,
            27,
            37
        ],
        [
            6,
            26,
            37
        ],
        [
            7,
            25,
            37
        ],
        [
            8,
            23,
            38
        ],
        [
            9,
            23,
            38
        ],
        [
            10,
            22,
            38
        ],
        [
            0,
            1,
            37,
            11,
            22,
            38
        ],
        [
            0,
            30,
            37
        ],
        [
            2,
            1,
            37
        ],
        [
            2,
            1,
            37
        ]
    ],
    2007: [
        [
            2,
            20,
            38
        ],
        [
            3,
            19,
            38
        ],
        [
            4,
            18,
            38
        ],
        [
            5,
            17,
            38
        ],
        [
            6,
            16,
            38
        ],
        [
            7,
            15,
            38
        ],
        [
            8,
            13,
            39
        ],
        [
            9,
            13,
            39
        ],
        [
            10,
            11,
            39
        ],
        [
            11,
            10,
            39
        ],
        [
            0,
            20,
            38
        ],
        [
            1,
            19,
            38
        ],
        [
            1,
            19,
            38
        ]
    ],
    2008: [
        [
            3,
            6,
            39
        ],
        [
            4,
            6,
            39
        ],
        [
            5,
            4,
            39
        ],
        [
            6,
            4,
            39
        ],
        [
            7,
            2,
            39
        ],
        [
            8,
            1,
            39
        ],
        [
            8,
            30,
            40
        ],
        [
            9,
            30,
            40
        ],
        [
            10,
            28,
            40
        ],
        [
            11,
            28,
            40
        ],
        [
            0,
            8,
            39
        ],
        [
            1,
            7,
            39
        ],
        [
            2,
            8,
            39
        ]
    ],
    2009: [
        [
            2,
            26,
            40
        ],
        [
            3,
            25,
            40
        ],
        [
            4,
            24,
            40
        ],
        [
            5,
            23,
            40
        ],
        [
            6,
            22,
            40
        ],
        [
            7,
            21,
            40
        ],
        [
            8,
            19,
            41
        ],
        [
            9,
            19,
            41
        ],
        [
            10,
            18,
            41
        ],
        [
            11,
            18,
            41
        ],
        [
            0,
            26,
            40
        ],
        [
            1,
            25,
            40
        ],
        [
            1,
            25,
            40
        ]
    ],
    2010: [
        [
            2,
            16,
            41
        ],
        [
            3,
            15,
            41
        ],
        [
            4,
            14,
            41
        ],
        [
            5,
            13,
            41
        ],
        [
            6,
            12,
            41
        ],
        [
            7,
            11,
            41
        ],
        [
            8,
            9,
            42
        ],
        [
            9,
            9,
            42
        ],
        [
            10,
            8,
            42
        ],
        [
            11,
            8,
            42
        ],
        [
            0,
            16,
            41
        ],
        [
            1,
            15,
            41
        ],
        [
            1,
            15,
            41
        ]
    ],
    2011: [
        [
            3,
            5,
            42
        ],
        [
            4,
            5,
            42
        ],
        [
            5,
            3,
            42
        ],
        [
            6,
            3,
            42
        ],
        [
            7,
            1,
            42
        ],
        [
            7,
            31,
            42
        ],
        [
            8,
            29,
            43
        ],
        [
            9,
            29,
            43
        ],
        [
            10,
            27,
            43
        ],
        [
            11,
            27,
            43
        ],
        [
            0,
            6,
            42
        ],
        [
            1,
            5,
            42
        ],
        [
            2,
            7,
            42
        ]
    ],
    2012: [
        [
            2,
            24,
            43
        ],
        [
            3,
            23,
            43
        ],
        [
            4,
            22,
            43
        ],
        [
            5,
            21,
            43
        ],
        [
            6,
            20,
            43
        ],
        [
            7,
            19,
            43
        ],
        [
            8,
            17,
            44
        ],
        [
            9,
            17,
            44
        ],
        [
            10,
            15,
            44
        ],
        [
            11,
            14,
            44
        ],
        [
            0,
            25,
            43
        ],
        [
            1,
            24,
            43
        ],
        [
            1,
            24,
            43
        ]
    ],
    2013: [
        [
            2,
            12,
            44
        ],
        [
            3,
            11,
            44
        ],
        [
            4,
            10,
            44
        ],
        [
            5,
            9,
            44
        ],
        [
            6,
            8,
            44
        ],
        [
            7,
            7,
            44
        ],
        [
            8,
            5,
            45
        ],
        [
            9,
            5,
            45
        ],
        [
            10,
            4,
            45
        ],
        [
            11,
            4,
            45
        ],
        [
            0,
            12,
            44
        ],
        [
            1,
            11,
            44
        ],
        [
            1,
            11,
            44
        ]
    ],
    2014: [
        [
            3,
            1,
            45
        ],
        [
            4,
            1,
            45
        ],
        [
            4,
            30,
            45
        ],
        [
            5,
            29,
            45
        ],
        [
            6,
            28,
            45
        ],
        [
            7,
            27,
            45
        ],
        [
            8,
            25,
            46
        ],
        [
            9,
            25,
            46
        ],
        [
            10,
            23,
            46
        ],
        [
            11,
            23,
            46
        ],
        [
            0,
            2,
            45
        ],
        [
            1,
            1,
            45
        ],
        [
            2,
            3,
            45
        ]
    ],
    2015: [
        [
            2,
            21,
            46
        ],
        [
            3,
            20,
            46
        ],
        [
            4,
            19,
            46
        ],
        [
            5,
            18,
            46
        ],
        [
            6,
            17,
            46
        ],
        [
            7,
            16,
            46
        ],
        [
            8,
            14,
            47
        ],
        [
            9,
            14,
            47
        ],
        [
            10,
            13,
            47
        ],
        [
            11,
            13,
            47
        ],
        [
            0,
            21,
            46
        ],
        [
            1,
            20,
            46
        ],
        [
            1,
            20,
            46
        ]
    ],
    2016: [
        [
            3,
            9,
            47
        ],
        [
            4,
            9,
            47
        ],
        [
            5,
            7,
            47
        ],
        [
            6,
            7,
            47
        ],
        [
            7,
            5,
            47
        ],
        [
            8,
            4,
            47
        ],
        [
            9,
            3,
            48
        ],
        [
            10,
            2,
            48
        ],
        [
            11,
            1,
            48
        ],
        [
            11,
            30,
            48
        ],
        [
            0,
            11,
            47
        ],
        [
            1,
            10,
            47
        ],
        [
            2,
            11,
            47
        ]
    ],
    2017: [
        [
            2,
            28,
            48
        ],
        [
            3,
            27,
            48
        ],
        [
            4,
            26,
            48
        ],
        [
            5,
            25,
            48
        ],
        [
            6,
            24,
            48
        ],
        [
            7,
            23,
            48
        ],
        [
            8,
            21,
            49
        ],
        [
            9,
            21,
            49
        ],
        [
            10,
            19,
            49
        ],
        [
            11,
            19,
            49
        ],
        [
            0,
            28,
            48
        ],
        [
            1,
            27,
            48
        ],
        [
            1,
            27,
            48
        ]
    ],
    2018: [
        [
            2,
            17,
            49
        ],
        [
            3,
            16,
            49
        ],
        [
            4,
            15,
            49
        ],
        [
            5,
            14,
            49
        ],
        [
            6,
            13,
            49
        ],
        [
            7,
            12,
            49
        ],
        [
            8,
            10,
            50
        ],
        [
            9,
            10,
            50
        ],
        [
            10,
            9,
            50
        ],
        [
            11,
            9,
            50
        ],
        [
            0,
            17,
            49
        ],
        [
            1,
            16,
            49
        ],
        [
            1,
            16,
            49
        ]
    ],
    2019: [
        [
            3,
            6,
            50
        ],
        [
            4,
            6,
            50
        ],
        [
            5,
            4,
            50
        ],
        [
            6,
            4,
            50
        ],
        [
            7,
            2,
            50
        ],
        [
            8,
            1,
            50
        ],
        [
            8,
            30,
            51
        ],
        [
            9,
            30,
            51
        ],
        [
            10,
            29,
            51
        ],
        [
            11,
            29,
            51
        ],
        [
            0,
            7,
            50
        ],
        [
            1,
            6,
            50
        ],
        [
            2,
            8,
            50
        ]
    ],
    2020: [
        [
            2,
            26,
            51
        ],
        [
            3,
            25,
            51
        ],
        [
            4,
            24,
            51
        ],
        [
            5,
            23,
            51
        ],
        [
            6,
            22,
            51
        ],
        [
            7,
            21,
            51
        ],
        [
            8,
            19,
            52
        ],
        [
            9,
            19,
            52
        ],
        [
            10,
            17,
            52
        ],
        [
            11,
            16,
            52
        ],
        [
            0,
            27,
            51
        ],
        [
            1,
            26,
            51
        ],
        [
            1,
            26,
            51
        ]
    ],
    2021: [
        [
            2,
            14,
            52
        ],
        [
            3,
            13,
            52
        ],
        [
            4,
            12,
            52
        ],
        [
            5,
            11,
            52
        ],
        [
            6,
            10,
            52
        ],
        [
            7,
            9,
            52
        ],
        [
            8,
            7,
            53
        ],
        [
            9,
            7,
            53
        ],
        [
            10,
            5,
            53
        ],
        [
            11,
            5,
            53
        ],
        [
            0,
            14,
            52
        ],
        [
            1,
            13,
            52
        ],
        [
            1,
            13,
            52
        ]
    ],
    2022: [
        [
            3,
            2,
            53
        ],
        [
            4,
            2,
            53
        ],
        [
            4,
            31,
            53
        ],
        [
            5,
            30,
            53
        ],
        [
            6,
            29,
            53
        ],
        [
            7,
            28,
            53
        ],
        [
            8,
            26,
            54
        ],
        [
            9,
            26,
            54
        ],
        [
            10,
            25,
            54
        ],
        [
            11,
            25,
            54
        ],
        [
            0,
            3,
            53
        ],
        [
            1,
            2,
            53
        ],
        [
            2,
            4,
            53
        ]
    ],
    2023: [
        [
            2,
            23,
            54
        ],
        [
            3,
            22,
            54
        ],
        [
            4,
            21,
            54
        ],
        [
            5,
            20,
            54
        ],
        [
            6,
            19,
            54
        ],
        [
            7,
            18,
            54
        ],
        [
            8,
            16,
            55
        ],
        [
            9,
            16,
            55
        ],
        [
            10,
            14,
            55
        ],
        [
            11,
            13,
            55
        ],
        [
            0,
            23,
            54
        ],
        [
            1,
            22,
            54
        ],
        [
            1,
            22,
            54
        ]
    ],
    2024: [
        [
            3,
            9,
            55
        ],
        [
            4,
            9,
            55
        ],
        [
            5,
            7,
            55
        ],
        [
            6,
            7,
            55
        ],
        [
            7,
            5,
            55
        ],
        [
            8,
            4,
            55
        ],
        [
            9,
            3,
            56
        ],
        [
            10,
            2,
            56
        ],
        [
            11,
            2,
            56
        ],
        null,
        [
            0,
            11,
            55
        ],
        [
            1,
            10,
            55
        ],
        [
            2,
            11,
            55
        ]
    ],
    2025: [
        [
            2,
            30,
            56
        ],
        [
            3,
            29,
            56
        ],
        [
            4,
            28,
            56
        ],
        [
            5,
            27,
            56
        ],
        [
            6,
            26,
            56
        ],
        [
            7,
            25,
            56
        ],
        [
            8,
            23,
            57
        ],
        [
            9,
            23,
            57
        ],
        [
            10,
            21,
            57
        ],
        [
            0,
            1,
            56,
            11,
            21,
            57
        ],
        [
            0,
            30,
            56
        ],
        [
            2,
            1,
            56
        ],
        [
            2,
            1,
            56
        ]
    ],
    2026: [
        [
            2,
            19,
            57
        ],
        [
            3,
            18,
            57
        ],
        [
            4,
            17,
            57
        ],
        [
            5,
            16,
            57
        ],
        [
            6,
            15,
            57
        ],
        [
            7,
            14,
            57
        ],
        [
            8,
            12,
            58
        ],
        [
            9,
            12,
            58
        ],
        [
            10,
            11,
            58
        ],
        [
            11,
            11,
            58
        ],
        [
            0,
            19,
            57
        ],
        [
            1,
            18,
            57
        ],
        [
            1,
            18,
            57
        ]
    ],
    2027: [
        [
            3,
            8,
            58
        ],
        [
            4,
            8,
            58
        ],
        [
            5,
            6,
            58
        ],
        [
            6,
            6,
            58
        ],
        [
            7,
            4,
            58
        ],
        [
            8,
            3,
            58
        ],
        [
            9,
            2,
            59
        ],
        [
            10,
            1,
            59
        ],
        [
            11,
            1,
            59
        ],
        [
            11,
            31,
            59
        ],
        [
            0,
            9,
            58
        ],
        [
            1,
            8,
            58
        ],
        [
            2,
            10,
            58
        ]
    ],
    2028: [
        [
            2,
            28,
            59
        ],
        [
            3,
            27,
            59
        ],
        [
            4,
            26,
            59
        ],
        [
            5,
            25,
            59
        ],
        [
            6,
            24,
            59
        ],
        [
            7,
            23,
            59
        ],
        [
            8,
            21,
            60
        ],
        [
            9,
            21,
            60
        ],
        [
            10,
            19,
            60
        ],
        [
            11,
            19,
            60
        ],
        [
            0,
            29,
            59
        ],
        [
            1,
            28,
            59
        ],
        [
            1,
            28,
            59
        ]
    ],
    2029: [
        [
            2,
            17,
            60
        ],
        [
            3,
            16,
            60
        ],
        [
            4,
            15,
            60
        ],
        [
            5,
            14,
            60
        ],
        [
            6,
            13,
            60
        ],
        [
            7,
            12,
            60
        ],
        [
            8,
            10,
            61
        ],
        [
            9,
            10,
            61
        ],
        [
            10,
            8,
            61
        ],
        [
            11,
            7,
            61
        ],
        [
            0,
            17,
            60
        ],
        [
            1,
            16,
            60
        ],
        [
            1,
            16,
            60
        ]
    ],
    2030: [
        [
            3,
            4,
            61
        ],
        [
            4,
            4,
            61
        ],
        [
            5,
            2,
            61
        ],
        [
            6,
            2,
            61
        ],
        [
            6,
            31,
            61
        ],
        [
            7,
            30,
            61
        ],
        [
            8,
            28,
            62
        ],
        [
            9,
            28,
            62
        ],
        [
            10,
            27,
            62
        ],
        [
            11,
            27,
            62
        ],
        [
            0,
            5,
            61
        ],
        [
            1,
            4,
            61
        ],
        [
            2,
            6,
            61
        ]
    ],
    2031: [
        [
            2,
            25,
            62
        ],
        [
            3,
            24,
            62
        ],
        [
            4,
            23,
            62
        ],
        [
            5,
            22,
            62
        ],
        [
            6,
            21,
            62
        ],
        [
            7,
            20,
            62
        ],
        [
            8,
            18,
            63
        ],
        [
            9,
            18,
            63
        ],
        [
            10,
            16,
            63
        ],
        [
            11,
            16,
            63
        ],
        [
            0,
            25,
            62
        ],
        [
            1,
            24,
            62
        ],
        [
            1,
            24,
            62
        ]
    ],
    2032: [
        [
            2,
            13,
            63
        ],
        [
            3,
            12,
            63
        ],
        [
            4,
            11,
            63
        ],
        [
            5,
            10,
            63
        ],
        [
            6,
            9,
            63
        ],
        [
            7,
            8,
            63
        ],
        [
            8,
            6,
            64
        ],
        [
            9,
            6,
            64
        ],
        [
            10,
            4,
            64
        ],
        [
            11,
            3,
            64
        ],
        [
            0,
            14,
            63
        ],
        [
            1,
            13,
            63
        ],
        [
            1,
            13,
            63
        ]
    ],
    2033: [
        [
            2,
            31,
            64
        ],
        [
            3,
            30,
            64
        ],
        [
            4,
            29,
            64
        ],
        [
            5,
            28,
            64
        ],
        [
            6,
            27,
            64
        ],
        [
            7,
            26,
            64
        ],
        [
            8,
            24,
            65
        ],
        [
            9,
            24,
            65
        ],
        [
            10,
            23,
            65
        ],
        [
            11,
            23,
            65
        ],
        [
            0,
            1,
            64
        ],
        [
            0,
            31,
            64
        ],
        [
            2,
            2,
            64
        ]
    ],
    2034: [
        [
            2,
            21,
            65
        ],
        [
            3,
            20,
            65
        ],
        [
            4,
            19,
            65
        ],
        [
            5,
            18,
            65
        ],
        [
            6,
            17,
            65
        ],
        [
            7,
            16,
            65
        ],
        [
            8,
            14,
            66
        ],
        [
            9,
            14,
            66
        ],
        [
            10,
            13,
            66
        ],
        [
            11,
            13,
            66
        ],
        [
            0,
            21,
            65
        ],
        [
            1,
            20,
            65
        ],
        [
            1,
            20,
            65
        ]
    ],
    2035: [
        [
            3,
            10,
            66
        ],
        [
            4,
            10,
            66
        ],
        [
            5,
            8,
            66
        ],
        [
            6,
            8,
            66
        ],
        [
            7,
            6,
            66
        ],
        [
            8,
            5,
            66
        ],
        [
            9,
            4,
            67
        ],
        [
            10,
            3,
            67
        ],
        [
            11,
            2,
            67
        ],
        null,
        [
            0,
            11,
            66
        ],
        [
            1,
            10,
            66
        ],
        [
            2,
            12,
            66
        ]
    ],
    2036: [
        [
            2,
            29,
            67
        ],
        [
            3,
            28,
            67
        ],
        [
            4,
            27,
            67
        ],
        [
            5,
            26,
            67
        ],
        [
            6,
            25,
            67
        ],
        [
            7,
            24,
            67
        ],
        [
            8,
            22,
            68
        ],
        [
            9,
            22,
            68
        ],
        [
            10,
            20,
            68
        ],
        [
            0,
            1,
            67,
            11,
            19,
            68
        ],
        [
            0,
            30,
            67
        ],
        [
            1,
            29,
            67
        ],
        [
            1,
            29,
            67
        ]
    ],
    2037: [
        [
            2,
            17,
            68
        ],
        [
            3,
            16,
            68
        ],
        [
            4,
            15,
            68
        ],
        [
            5,
            14,
            68
        ],
        [
            6,
            13,
            68
        ],
        [
            7,
            12,
            68
        ],
        [
            8,
            10,
            69
        ],
        [
            9,
            10,
            69
        ],
        [
            10,
            9,
            69
        ],
        [
            11,
            9,
            69
        ],
        [
            0,
            17,
            68
        ],
        [
            1,
            16,
            68
        ],
        [
            1,
            16,
            68
        ]
    ],
    2038: [
        [
            3,
            6,
            69
        ],
        [
            4,
            6,
            69
        ],
        [
            5,
            4,
            69
        ],
        [
            6,
            4,
            69
        ],
        [
            7,
            2,
            69
        ],
        [
            8,
            1,
            69
        ],
        [
            8,
            30,
            70
        ],
        [
            9,
            30,
            70
        ],
        [
            10,
            28,
            70
        ],
        [
            11,
            28,
            70
        ],
        [
            0,
            7,
            69
        ],
        [
            1,
            6,
            69
        ],
        [
            2,
            8,
            69
        ]
    ],
    2039: [
        [
            2,
            26,
            70
        ],
        [
            3,
            25,
            70
        ],
        [
            4,
            24,
            70
        ],
        [
            5,
            23,
            70
        ],
        [
            6,
            22,
            70
        ],
        [
            7,
            21,
            70
        ],
        [
            8,
            19,
            71
        ],
        [
            9,
            19,
            71
        ],
        [
            10,
            18,
            71
        ],
        [
            11,
            18,
            71
        ],
        [
            0,
            26,
            70
        ],
        [
            1,
            25,
            70
        ],
        [
            1,
            25,
            70
        ]
    ],
    2040: [
        [
            2,
            15,
            71
        ],
        [
            3,
            14,
            71
        ],
        [
            4,
            13,
            71
        ],
        [
            5,
            12,
            71
        ],
        [
            6,
            11,
            71
        ],
        [
            7,
            10,
            71
        ],
        [
            8,
            8,
            72
        ],
        [
            9,
            8,
            72
        ],
        [
            10,
            6,
            72
        ],
        [
            11,
            5,
            72
        ],
        [
            0,
            16,
            71
        ],
        [
            1,
            15,
            71
        ],
        [
            1,
            15,
            71
        ]
    ],
    2041: [
        [
            3,
            2,
            72
        ],
        [
            4,
            2,
            72
        ],
        [
            4,
            31,
            72
        ],
        [
            5,
            30,
            72
        ],
        [
            6,
            29,
            72
        ],
        [
            7,
            28,
            72
        ],
        [
            8,
            26,
            73
        ],
        [
            9,
            26,
            73
        ],
        [
            10,
            24,
            73
        ],
        [
            11,
            24,
            73
        ],
        [
            0,
            3,
            72
        ],
        [
            1,
            2,
            72
        ],
        [
            2,
            4,
            72
        ]
    ],
    2042: [
        [
            2,
            22,
            73
        ],
        [
            3,
            21,
            73
        ],
        [
            4,
            20,
            73
        ],
        [
            5,
            19,
            73
        ],
        [
            6,
            18,
            73
        ],
        [
            7,
            17,
            73
        ],
        [
            8,
            15,
            74
        ],
        [
            9,
            15,
            74
        ],
        [
            10,
            14,
            74
        ],
        [
            11,
            14,
            74
        ],
        [
            0,
            22,
            73
        ],
        [
            1,
            21,
            73
        ],
        [
            1,
            21,
            73
        ]
    ],
    2043: [
        [
            3,
            11,
            74
        ],
        [
            4,
            11,
            74
        ],
        [
            5,
            9,
            74
        ],
        [
            6,
            9,
            74
        ],
        [
            7,
            7,
            74
        ],
        [
            8,
            6,
            74
        ],
        [
            9,
            5,
            75
        ],
        [
            10,
            4,
            75
        ],
        [
            11,
            3,
            75
        ],
        null,
        [
            0,
            12,
            74
        ],
        [
            1,
            11,
            74
        ],
        [
            2,
            13,
            74
        ]
    ],
    2044: [
        [
            2,
            29,
            75
        ],
        [
            3,
            28,
            75
        ],
        [
            4,
            27,
            75
        ],
        [
            5,
            26,
            75
        ],
        [
            6,
            25,
            75
        ],
        [
            7,
            24,
            75
        ],
        [
            8,
            22,
            76
        ],
        [
            9,
            22,
            76
        ],
        [
            10,
            21,
            76
        ],
        [
            0,
            1,
            75,
            11,
            21,
            76
        ],
        [
            0,
            30,
            75
        ],
        [
            1,
            29,
            75
        ],
        [
            1,
            29,
            75
        ]
    ],
    2045: [
        [
            2,
            19,
            76
        ],
        [
            3,
            18,
            76
        ],
        [
            4,
            17,
            76
        ],
        [
            5,
            16,
            76
        ],
        [
            6,
            15,
            76
        ],
        [
            7,
            14,
            76
        ],
        [
            8,
            12,
            77
        ],
        [
            9,
            12,
            77
        ],
        [
            10,
            10,
            77
        ],
        [
            11,
            10,
            77
        ],
        [
            0,
            19,
            76
        ],
        [
            1,
            18,
            76
        ],
        [
            1,
            18,
            76
        ]
    ],
    2046: [
        [
            3,
            7,
            77
        ],
        [
            4,
            7,
            77
        ],
        [
            5,
            5,
            77
        ],
        [
            6,
            5,
            77
        ],
        [
            7,
            3,
            77
        ],
        [
            8,
            2,
            77
        ],
        [
            9,
            1,
            78
        ],
        [
            9,
            31,
            78
        ],
        [
            10,
            30,
            78
        ],
        [
            11,
            30,
            78
        ],
        [
            0,
            8,
            77
        ],
        [
            1,
            7,
            77
        ],
        [
            2,
            9,
            77
        ]
    ],
    2047: [
        [
            2,
            28,
            78
        ],
        [
            3,
            27,
            78
        ],
        [
            4,
            26,
            78
        ],
        [
            5,
            25,
            78
        ],
        [
            6,
            24,
            78
        ],
        [
            7,
            23,
            78
        ],
        [
            8,
            21,
            79
        ],
        [
            9,
            21,
            79
        ],
        [
            10,
            19,
            79
        ],
        [
            11,
            18,
            79
        ],
        [
            0,
            28,
            78
        ],
        [
            1,
            27,
            78
        ],
        [
            1,
            27,
            78
        ]
    ],
    2048: [
        [
            2,
            15,
            79
        ],
        [
            3,
            14,
            79
        ],
        [
            4,
            13,
            79
        ],
        [
            5,
            12,
            79
        ],
        [
            6,
            11,
            79
        ],
        [
            7,
            10,
            79
        ],
        [
            8,
            8,
            80
        ],
        [
            9,
            8,
            80
        ],
        [
            10,
            6,
            80
        ],
        [
            11,
            6,
            80
        ],
        [
            0,
            16,
            79
        ],
        [
            1,
            15,
            79
        ],
        [
            1,
            15,
            79
        ]
    ],
    2049: [
        [
            3,
            3,
            80
        ],
        [
            4,
            3,
            80
        ],
        [
            5,
            1,
            80
        ],
        [
            6,
            1,
            80
        ],
        [
            6,
            30,
            80
        ],
        [
            7,
            29,
            80
        ],
        [
            8,
            27,
            81
        ],
        [
            9,
            27,
            81
        ],
        [
            10,
            26,
            81
        ],
        [
            11,
            26,
            81
        ],
        [
            0,
            4,
            80
        ],
        [
            1,
            3,
            80
        ],
        [
            2,
            5,
            80
        ]
    ],
    2050: [
        [
            2,
            24,
            81
        ],
        [
            3,
            23,
            81
        ],
        [
            4,
            22,
            81
        ],
        [
            5,
            21,
            81
        ],
        [
            6,
            20,
            81
        ],
        [
            7,
            19,
            81
        ],
        [
            8,
            17,
            82
        ],
        [
            9,
            17,
            82
        ],
        [
            10,
            16,
            82
        ],
        [
            11,
            16,
            82
        ],
        [
            0,
            24,
            81
        ],
        [
            1,
            23,
            81
        ],
        [
            1,
            23,
            81
        ]
    ],
    2051: [
        [
            2,
            14,
            82
        ],
        [
            3,
            13,
            82
        ],
        [
            4,
            12,
            82
        ],
        [
            5,
            11,
            82
        ],
        [
            6,
            10,
            82
        ],
        [
            7,
            9,
            82
        ],
        [
            8,
            7,
            83
        ],
        [
            9,
            7,
            83
        ],
        [
            10,
            5,
            83
        ],
        [
            11,
            4,
            83
        ],
        [
            0,
            14,
            82
        ],
        [
            1,
            13,
            82
        ],
        [
            1,
            13,
            82
        ]
    ],
    2052: [
        [
            2,
            31,
            83
        ],
        [
            3,
            30,
            83
        ],
        [
            4,
            29,
            83
        ],
        [
            5,
            28,
            83
        ],
        [
            6,
            27,
            83
        ],
        [
            7,
            26,
            83
        ],
        [
            8,
            24,
            84
        ],
        [
            9,
            24,
            84
        ],
        [
            10,
            22,
            84
        ],
        [
            11,
            22,
            84
        ],
        [
            0,
            2,
            83
        ],
        [
            1,
            1,
            83
        ],
        [
            2,
            2,
            83
        ]
    ],
    2053: [
        [
            2,
            20,
            84
        ],
        [
            3,
            19,
            84
        ],
        [
            4,
            18,
            84
        ],
        [
            5,
            17,
            84
        ],
        [
            6,
            16,
            84
        ],
        [
            7,
            15,
            84
        ],
        [
            8,
            13,
            85
        ],
        [
            9,
            13,
            85
        ],
        [
            10,
            12,
            85
        ],
        [
            11,
            12,
            85
        ],
        [
            0,
            20,
            84
        ],
        [
            1,
            19,
            84
        ],
        [
            1,
            19,
            84
        ]
    ],
    2054: [
        [
            3,
            9,
            85
        ],
        [
            4,
            9,
            85
        ],
        [
            5,
            7,
            85
        ],
        [
            6,
            7,
            85
        ],
        [
            7,
            5,
            85
        ],
        [
            8,
            4,
            85
        ],
        [
            9,
            3,
            86
        ],
        [
            10,
            2,
            86
        ],
        [
            11,
            2,
            86
        ],
        null,
        [
            0,
            10,
            85
        ],
        [
            1,
            9,
            85
        ],
        [
            2,
            11,
            85
        ]
    ],
    2055: [
        [
            2,
            30,
            86
        ],
        [
            3,
            29,
            86
        ],
        [
            4,
            28,
            86
        ],
        [
            5,
            27,
            86
        ],
        [
            6,
            26,
            86
        ],
        [
            7,
            25,
            86
        ],
        [
            8,
            23,
            87
        ],
        [
            9,
            23,
            87
        ],
        [
            10,
            21,
            87
        ],
        [
            0,
            1,
            86,
            11,
            21,
            87
        ],
        [
            0,
            30,
            86
        ],
        [
            2,
            1,
            86
        ],
        [
            2,
            1,
            86
        ]
    ],
    2056: [
        [
            2,
            18,
            87
        ],
        [
            3,
            17,
            87
        ],
        [
            4,
            16,
            87
        ],
        [
            5,
            15,
            87
        ],
        [
            6,
            14,
            87
        ],
        [
            7,
            13,
            87
        ],
        [
            8,
            11,
            88
        ],
        [
            9,
            11,
            88
        ],
        [
            10,
            9,
            88
        ],
        [
            11,
            8,
            88
        ],
        [
            0,
            19,
            87
        ],
        [
            1,
            18,
            87
        ],
        [
            1,
            18,
            87
        ]
    ],
    2057: [
        [
            3,
            5,
            88
        ],
        [
            4,
            5,
            88
        ],
        [
            5,
            3,
            88
        ],
        [
            6,
            3,
            88
        ],
        [
            7,
            1,
            88
        ],
        [
            7,
            31,
            88
        ],
        [
            8,
            29,
            89
        ],
        [
            9,
            29,
            89
        ],
        [
            10,
            28,
            89
        ],
        [
            11,
            28,
            89
        ],
        [
            0,
            6,
            88
        ],
        [
            1,
            5,
            88
        ],
        [
            2,
            7,
            88
        ]
    ],
    2058: [
        [
            2,
            26,
            89
        ],
        [
            3,
            25,
            89
        ],
        [
            4,
            24,
            89
        ],
        [
            5,
            23,
            89
        ],
        [
            6,
            22,
            89
        ],
        [
            7,
            21,
            89
        ],
        [
            8,
            19,
            90
        ],
        [
            9,
            19,
            90
        ],
        [
            10,
            17,
            90
        ],
        [
            11,
            17,
            90
        ],
        [
            0,
            26,
            89
        ],
        [
            1,
            25,
            89
        ],
        [
            1,
            25,
            89
        ]
    ],
    2059: [
        [
            2,
            15,
            90
        ],
        [
            3,
            14,
            90
        ],
        [
            4,
            13,
            90
        ],
        [
            5,
            12,
            90
        ],
        [
            6,
            11,
            90
        ],
        [
            7,
            10,
            90
        ],
        [
            8,
            8,
            91
        ],
        [
            9,
            8,
            91
        ],
        [
            10,
            6,
            91
        ],
        [
            11,
            5,
            91
        ],
        [
            0,
            15,
            90
        ],
        [
            1,
            14,
            90
        ],
        [
            1,
            14,
            90
        ]
    ],
    2060: [
        [
            3,
            1,
            91
        ],
        [
            4,
            1,
            91
        ],
        [
            4,
            30,
            91
        ],
        [
            5,
            29,
            91
        ],
        [
            6,
            28,
            91
        ],
        [
            7,
            27,
            91
        ],
        [
            8,
            25,
            92
        ],
        [
            9,
            25,
            92
        ],
        [
            10,
            24,
            92
        ],
        [
            11,
            24,
            92
        ],
        [
            0,
            3,
            91
        ],
        [
            1,
            2,
            91
        ],
        [
            2,
            3,
            91
        ]
    ],
    2061: [
        [
            2,
            22,
            92
        ],
        [
            3,
            21,
            92
        ],
        [
            4,
            20,
            92
        ],
        [
            5,
            19,
            92
        ],
        [
            6,
            18,
            92
        ],
        [
            7,
            17,
            92
        ],
        [
            8,
            15,
            93
        ],
        [
            9,
            15,
            93
        ],
        [
            10,
            14,
            93
        ],
        [
            11,
            14,
            93
        ],
        [
            0,
            22,
            92
        ],
        [
            1,
            21,
            92
        ],
        [
            1,
            21,
            92
        ]
    ],
    2062: [
        [
            3,
            11,
            93
        ],
        [
            4,
            11,
            93
        ],
        [
            5,
            9,
            93
        ],
        [
            6,
            9,
            93
        ],
        [
            7,
            7,
            93
        ],
        [
            8,
            6,
            93
        ],
        [
            9,
            5,
            94
        ],
        [
            10,
            4,
            94
        ],
        [
            11,
            3,
            94
        ],
        null,
        [
            0,
            12,
            93
        ],
        [
            1,
            11,
            93
        ],
        [
            2,
            13,
            93
        ]
    ],
    2063: [
        [
            2,
            31,
            94
        ],
        [
            3,
            30,
            94
        ],
        [
            4,
            29,
            94
        ],
        [
            5,
            28,
            94
        ],
        [
            6,
            27,
            94
        ],
        [
            7,
            26,
            94
        ],
        [
            8,
            24,
            95
        ],
        [
            9,
            24,
            95
        ],
        [
            10,
            22,
            95
        ],
        [
            0,
            2,
            94,
            11,
            21,
            95
        ],
        [
            0,
            31,
            94
        ],
        [
            2,
            2,
            94
        ],
        [
            2,
            2,
            94
        ]
    ],
    2064: [
        [
            2,
            18,
            95
        ],
        [
            3,
            17,
            95
        ],
        [
            4,
            16,
            95
        ],
        [
            5,
            15,
            95
        ],
        [
            6,
            14,
            95
        ],
        [
            7,
            13,
            95
        ],
        [
            8,
            11,
            96
        ],
        [
            9,
            11,
            96
        ],
        [
            10,
            10,
            96
        ],
        [
            11,
            10,
            96
        ],
        [
            0,
            19,
            95
        ],
        [
            1,
            18,
            95
        ],
        [
            1,
            18,
            95
        ]
    ],
    2065: [
        [
            3,
            7,
            96
        ],
        [
            4,
            7,
            96
        ],
        [
            5,
            5,
            96
        ],
        [
            6,
            5,
            96
        ],
        [
            7,
            3,
            96
        ],
        [
            8,
            2,
            96
        ],
        [
            9,
            1,
            97
        ],
        [
            9,
            31,
            97
        ],
        [
            10,
            29,
            97
        ],
        [
            11,
            29,
            97
        ],
        [
            0,
            8,
            96
        ],
        [
            1,
            7,
            96
        ],
        [
            2,
            9,
            96
        ]
    ],
    2066: [
        [
            2,
            27,
            97
        ],
        [
            3,
            26,
            97
        ],
        [
            4,
            25,
            97
        ],
        [
            5,
            24,
            97
        ],
        [
            6,
            23,
            97
        ],
        [
            7,
            22,
            97
        ],
        [
            8,
            20,
            98
        ],
        [
            9,
            20,
            98
        ],
        [
            10,
            19,
            98
        ],
        [
            11,
            19,
            98
        ],
        [
            0,
            27,
            97
        ],
        [
            1,
            26,
            97
        ],
        [
            1,
            26,
            97
        ]
    ],
    2067: [
        [
            2,
            17,
            98
        ],
        [
            3,
            16,
            98
        ],
        [
            4,
            15,
            98
        ],
        [
            5,
            14,
            98
        ],
        [
            6,
            13,
            98
        ],
        [
            7,
            12,
            98
        ],
        [
            8,
            10,
            99
        ],
        [
            9,
            10,
            99
        ],
        [
            10,
            8,
            99
        ],
        [
            11,
            7,
            99
        ],
        [
            0,
            17,
            98
        ],
        [
            1,
            16,
            98
        ],
        [
            1,
            16,
            98
        ]
    ],
    2068: [
        [
            3,
            3,
            99
        ],
        [
            4,
            3,
            99
        ],
        [
            5,
            1,
            99
        ],
        [
            6,
            1,
            99
        ],
        [
            6,
            30,
            99
        ],
        [
            7,
            29,
            99
        ],
        [
            8,
            27,
            100
        ],
        [
            9,
            27,
            100
        ],
        [
            10,
            25,
            100
        ],
        [
            11,
            25,
            100
        ],
        [
            0,
            5,
            99
        ],
        [
            1,
            4,
            99
        ],
        [
            2,
            5,
            99
        ]
    ],
    2069: [
        [
            2,
            23,
            100
        ],
        [
            3,
            22,
            100
        ],
        [
            4,
            21,
            100
        ],
        [
            5,
            20,
            100
        ],
        [
            6,
            19,
            100
        ],
        [
            7,
            18,
            100
        ],
        [
            8,
            16,
            101
        ],
        [
            9,
            16,
            101
        ],
        [
            10,
            15,
            101
        ],
        [
            11,
            15,
            101
        ],
        [
            0,
            23,
            100
        ],
        [
            1,
            22,
            100
        ],
        [
            1,
            22,
            100
        ]
    ],
    2070: [
        [
            2,
            13,
            101
        ],
        [
            3,
            12,
            101
        ],
        [
            4,
            11,
            101
        ],
        [
            5,
            10,
            101
        ],
        [
            6,
            9,
            101
        ],
        [
            7,
            8,
            101
        ],
        [
            8,
            6,
            102
        ],
        [
            9,
            6,
            102
        ],
        [
            10,
            4,
            102
        ],
        [
            11,
            3,
            102
        ],
        [
            0,
            13,
            101
        ],
        [
            1,
            12,
            101
        ],
        [
            1,
            12,
            101
        ]
    ],
    2071: [
        [
            2,
            31,
            102
        ],
        [
            3,
            30,
            102
        ],
        [
            4,
            29,
            102
        ],
        [
            5,
            28,
            102
        ],
        [
            6,
            27,
            102
        ],
        [
            7,
            26,
            102
        ],
        [
            8,
            24,
            103
        ],
        [
            9,
            24,
            103
        ],
        [
            10,
            23,
            103
        ],
        [
            11,
            23,
            103
        ],
        [
            0,
            1,
            102
        ],
        [
            0,
            31,
            102
        ],
        [
            2,
            2,
            102
        ]
    ],
    2072: [
        [
            2,
            20,
            103
        ],
        [
            3,
            19,
            103
        ],
        [
            4,
            18,
            103
        ],
        [
            5,
            17,
            103
        ],
        [
            6,
            16,
            103
        ],
        [
            7,
            15,
            103
        ],
        [
            8,
            13,
            104
        ],
        [
            9,
            13,
            104
        ],
        [
            10,
            11,
            104
        ],
        [
            11,
            11,
            104
        ],
        [
            0,
            21,
            103
        ],
        [
            1,
            20,
            103
        ],
        [
            1,
            20,
            103
        ]
    ],
    2073: [
        [
            3,
            8,
            104
        ],
        [
            4,
            8,
            104
        ],
        [
            5,
            6,
            104
        ],
        [
            6,
            6,
            104
        ],
        [
            7,
            4,
            104
        ],
        [
            8,
            3,
            104
        ],
        [
            9,
            2,
            105
        ],
        [
            10,
            1,
            105
        ],
        [
            11,
            1,
            105
        ],
        [
            11,
            31,
            105
        ],
        [
            0,
            9,
            104
        ],
        [
            1,
            8,
            104
        ],
        [
            2,
            10,
            104
        ]
    ],
    2074: [
        [
            2,
            29,
            105
        ],
        [
            3,
            28,
            105
        ],
        [
            4,
            27,
            105
        ],
        [
            5,
            26,
            105
        ],
        [
            6,
            25,
            105
        ],
        [
            7,
            24,
            105
        ],
        [
            8,
            22,
            106
        ],
        [
            9,
            22,
            106
        ],
        [
            10,
            20,
            106
        ],
        [
            11,
            19,
            106
        ],
        [
            0,
            29,
            105
        ],
        [
            1,
            28,
            105
        ],
        [
            1,
            28,
            105
        ]
    ],
    2075: [
        [
            2,
            17,
            106
        ],
        [
            3,
            16,
            106
        ],
        [
            4,
            15,
            106
        ],
        [
            5,
            14,
            106
        ],
        [
            6,
            13,
            106
        ],
        [
            7,
            12,
            106
        ],
        [
            8,
            10,
            107
        ],
        [
            9,
            10,
            107
        ],
        [
            10,
            8,
            107
        ],
        [
            11,
            8,
            107
        ],
        [
            0,
            17,
            106
        ],
        [
            1,
            16,
            106
        ],
        [
            1,
            16,
            106
        ]
    ],
    2076: [
        [
            3,
            4,
            107
        ],
        [
            4,
            4,
            107
        ],
        [
            5,
            2,
            107
        ],
        [
            6,
            2,
            107
        ],
        [
            6,
            31,
            107
        ],
        [
            7,
            30,
            107
        ],
        [
            8,
            28,
            108
        ],
        [
            9,
            28,
            108
        ],
        [
            10,
            27,
            108
        ],
        [
            11,
            27,
            108
        ],
        [
            0,
            6,
            107
        ],
        [
            1,
            5,
            107
        ],
        [
            2,
            6,
            107
        ]
    ],
    2077: [
        [
            2,
            25,
            108
        ],
        [
            3,
            24,
            108
        ],
        [
            4,
            23,
            108
        ],
        [
            5,
            22,
            108
        ],
        [
            6,
            21,
            108
        ],
        [
            7,
            20,
            108
        ],
        [
            8,
            18,
            109
        ],
        [
            9,
            18,
            109
        ],
        [
            10,
            17,
            109
        ],
        [
            11,
            17,
            109
        ],
        [
            0,
            25,
            108
        ],
        [
            1,
            24,
            108
        ],
        [
            1,
            24,
            108
        ]
    ],
    2078: [
        [
            2,
            15,
            109
        ],
        [
            3,
            14,
            109
        ],
        [
            4,
            13,
            109
        ],
        [
            5,
            12,
            109
        ],
        [
            6,
            11,
            109
        ],
        [
            7,
            10,
            109
        ],
        [
            8,
            8,
            110
        ],
        [
            9,
            8,
            110
        ],
        [
            10,
            6,
            110
        ],
        [
            11,
            5,
            110
        ],
        [
            0,
            15,
            109
        ],
        [
            1,
            14,
            109
        ],
        [
            1,
            14,
            109
        ]
    ],
    2079: [
        [
            3,
            2,
            110
        ],
        [
            4,
            2,
            110
        ],
        [
            4,
            31,
            110
        ],
        [
            5,
            30,
            110
        ],
        [
            6,
            29,
            110
        ],
        [
            7,
            28,
            110
        ],
        [
            8,
            26,
            111
        ],
        [
            9,
            26,
            111
        ],
        [
            10,
            24,
            111
        ],
        [
            11,
            24,
            111
        ],
        [
            0,
            3,
            110
        ],
        [
            1,
            2,
            110
        ],
        [
            2,
            4,
            110
        ]
    ],
    2080: [
        [
            2,
            21,
            111
        ],
        [
            3,
            20,
            111
        ],
        [
            4,
            19,
            111
        ],
        [
            5,
            18,
            111
        ],
        [
            6,
            17,
            111
        ],
        [
            7,
            16,
            111
        ],
        [
            8,
            14,
            112
        ],
        [
            9,
            14,
            112
        ],
        [
            10,
            13,
            112
        ],
        [
            11,
            13,
            112
        ],
        [
            0,
            22,
            111
        ],
        [
            1,
            21,
            111
        ],
        [
            1,
            21,
            111
        ]
    ],
    2081: [
        [
            3,
            10,
            112
        ],
        [
            4,
            10,
            112
        ],
        [
            5,
            8,
            112
        ],
        [
            6,
            8,
            112
        ],
        [
            7,
            6,
            112
        ],
        [
            8,
            5,
            112
        ],
        [
            9,
            4,
            113
        ],
        [
            10,
            3,
            113
        ],
        [
            11,
            3,
            113
        ],
        null,
        [
            0,
            11,
            112
        ],
        [
            1,
            10,
            112
        ],
        [
            2,
            12,
            112
        ]
    ],
    2082: [
        [
            2,
            31,
            113
        ],
        [
            3,
            30,
            113
        ],
        [
            4,
            29,
            113
        ],
        [
            5,
            28,
            113
        ],
        [
            6,
            27,
            113
        ],
        [
            7,
            26,
            113
        ],
        [
            8,
            24,
            114
        ],
        [
            9,
            24,
            114
        ],
        [
            10,
            22,
            114
        ],
        [
            0,
            2,
            113,
            11,
            22,
            114
        ],
        [
            0,
            31,
            113
        ],
        [
            2,
            2,
            113
        ],
        [
            2,
            2,
            113
        ]
    ],
    2083: [
        [
            2,
            20,
            114
        ],
        [
            3,
            19,
            114
        ],
        [
            4,
            18,
            114
        ],
        [
            5,
            17,
            114
        ],
        [
            6,
            16,
            114
        ],
        [
            7,
            15,
            114
        ],
        [
            8,
            13,
            115
        ],
        [
            9,
            13,
            115
        ],
        [
            10,
            11,
            115
        ],
        [
            11,
            10,
            115
        ],
        [
            0,
            20,
            114
        ],
        [
            1,
            19,
            114
        ],
        [
            1,
            19,
            114
        ]
    ],
    2084: [
        [
            3,
            6,
            115
        ],
        [
            4,
            6,
            115
        ],
        [
            5,
            4,
            115
        ],
        [
            6,
            4,
            115
        ],
        [
            7,
            2,
            115
        ],
        [
            8,
            1,
            115
        ],
        [
            8,
            30,
            116
        ],
        [
            9,
            30,
            116
        ],
        [
            10,
            29,
            116
        ],
        [
            11,
            29,
            116
        ],
        [
            0,
            8,
            115
        ],
        [
            1,
            7,
            115
        ],
        [
            2,
            8,
            115
        ]
    ],
    2085: [
        [
            2,
            27,
            116
        ],
        [
            3,
            26,
            116
        ],
        [
            4,
            25,
            116
        ],
        [
            5,
            24,
            116
        ],
        [
            6,
            23,
            116
        ],
        [
            7,
            22,
            116
        ],
        [
            8,
            20,
            117
        ],
        [
            9,
            20,
            117
        ],
        [
            10,
            18,
            117
        ],
        [
            11,
            18,
            117
        ],
        [
            0,
            27,
            116
        ],
        [
            1,
            26,
            116
        ],
        [
            1,
            26,
            116
        ]
    ],
    2086: [
        [
            2,
            16,
            117
        ],
        [
            3,
            15,
            117
        ],
        [
            4,
            14,
            117
        ],
        [
            5,
            13,
            117
        ],
        [
            6,
            12,
            117
        ],
        [
            7,
            11,
            117
        ],
        [
            8,
            9,
            118
        ],
        [
            9,
            9,
            118
        ],
        [
            10,
            7,
            118
        ],
        [
            11,
            6,
            118
        ],
        [
            0,
            16,
            117
        ],
        [
            1,
            15,
            117
        ],
        [
            1,
            15,
            117
        ]
    ],
    2087: [
        [
            3,
            3,
            118
        ],
        [
            4,
            3,
            118
        ],
        [
            5,
            1,
            118
        ],
        [
            6,
            1,
            118
        ],
        [
            6,
            30,
            118
        ],
        [
            7,
            29,
            118
        ],
        [
            8,
            27,
            119
        ],
        [
            9,
            27,
            119
        ],
        [
            10,
            26,
            119
        ],
        [
            11,
            26,
            119
        ],
        [
            0,
            4,
            118
        ],
        [
            1,
            3,
            118
        ],
        [
            2,
            5,
            118
        ]
    ],
    2088: [
        [
            2,
            23,
            119
        ],
        [
            3,
            22,
            119
        ],
        [
            4,
            21,
            119
        ],
        [
            5,
            20,
            119
        ],
        [
            6,
            19,
            119
        ],
        [
            7,
            18,
            119
        ],
        [
            8,
            16,
            120
        ],
        [
            9,
            16,
            120
        ],
        [
            10,
            14,
            120
        ],
        [
            11,
            14,
            120
        ],
        [
            0,
            24,
            119
        ],
        [
            1,
            23,
            119
        ],
        [
            1,
            23,
            119
        ]
    ],
    2089: [
        [
            2,
            12,
            120
        ],
        [
            3,
            11,
            120
        ],
        [
            4,
            10,
            120
        ],
        [
            5,
            9,
            120
        ],
        [
            6,
            8,
            120
        ],
        [
            7,
            7,
            120
        ],
        [
            8,
            5,
            121
        ],
        [
            9,
            5,
            121
        ],
        [
            10,
            4,
            121
        ],
        [
            11,
            4,
            121
        ],
        [
            0,
            12,
            120
        ],
        [
            1,
            11,
            120
        ],
        [
            1,
            11,
            120
        ]
    ],
    2090: [
        [
            3,
            1,
            121
        ],
        [
            4,
            1,
            121
        ],
        [
            4,
            30,
            121
        ],
        [
            5,
            29,
            121
        ],
        [
            6,
            28,
            121
        ],
        [
            7,
            27,
            121
        ],
        [
            8,
            25,
            122
        ],
        [
            9,
            25,
            122
        ],
        [
            10,
            23,
            122
        ],
        [
            11,
            22,
            122
        ],
        [
            0,
            2,
            121
        ],
        [
            1,
            1,
            121
        ],
        [
            2,
            3,
            121
        ]
    ],
    2091: [
        [
            2,
            20,
            122
        ],
        [
            3,
            19,
            122
        ],
        [
            4,
            18,
            122
        ],
        [
            5,
            17,
            122
        ],
        [
            6,
            16,
            122
        ],
        [
            7,
            15,
            122
        ],
        [
            8,
            13,
            123
        ],
        [
            9,
            13,
            123
        ],
        [
            10,
            12,
            123
        ],
        [
            11,
            12,
            123
        ],
        [
            0,
            20,
            122
        ],
        [
            1,
            19,
            122
        ],
        [
            1,
            19,
            122
        ]
    ],
    2092: [
        [
            3,
            8,
            123
        ],
        [
            4,
            8,
            123
        ],
        [
            5,
            6,
            123
        ],
        [
            6,
            6,
            123
        ],
        [
            7,
            4,
            123
        ],
        [
            8,
            3,
            123
        ],
        [
            9,
            2,
            124
        ],
        [
            10,
            1,
            124
        ],
        [
            10,
            30,
            124
        ],
        [
            11,
            30,
            124
        ],
        [
            0,
            10,
            123
        ],
        [
            1,
            9,
            123
        ],
        [
            2,
            10,
            123
        ]
    ],
    2093: [
        [
            2,
            28,
            124
        ],
        [
            3,
            27,
            124
        ],
        [
            4,
            26,
            124
        ],
        [
            5,
            25,
            124
        ],
        [
            6,
            24,
            124
        ],
        [
            7,
            23,
            124
        ],
        [
            8,
            21,
            125
        ],
        [
            9,
            21,
            125
        ],
        [
            10,
            20,
            125
        ],
        [
            11,
            20,
            125
        ],
        [
            0,
            28,
            124
        ],
        [
            1,
            27,
            124
        ],
        [
            1,
            27,
            124
        ]
    ],
    2094: [
        [
            2,
            18,
            125
        ],
        [
            3,
            17,
            125
        ],
        [
            4,
            16,
            125
        ],
        [
            5,
            15,
            125
        ],
        [
            6,
            14,
            125
        ],
        [
            7,
            13,
            125
        ],
        [
            8,
            11,
            126
        ],
        [
            9,
            11,
            126
        ],
        [
            10,
            9,
            126
        ],
        [
            11,
            8,
            126
        ],
        [
            0,
            18,
            125
        ],
        [
            1,
            17,
            125
        ],
        [
            1,
            17,
            125
        ]
    ],
    2095: [
        [
            3,
            5,
            126
        ],
        [
            4,
            5,
            126
        ],
        [
            5,
            3,
            126
        ],
        [
            6,
            3,
            126
        ],
        [
            7,
            1,
            126
        ],
        [
            7,
            31,
            126
        ],
        [
            8,
            29,
            127
        ],
        [
            9,
            29,
            127
        ],
        [
            10,
            27,
            127
        ],
        [
            11,
            27,
            127
        ],
        [
            0,
            6,
            126
        ],
        [
            1,
            5,
            126
        ],
        [
            2,
            7,
            126
        ]
    ],
    2096: [
        [
            2,
            24,
            127
        ],
        [
            3,
            23,
            127
        ],
        [
            4,
            22,
            127
        ],
        [
            5,
            21,
            127
        ],
        [
            6,
            20,
            127
        ],
        [
            7,
            19,
            127
        ],
        [
            8,
            17,
            128
        ],
        [
            9,
            17,
            128
        ],
        [
            10,
            16,
            128
        ],
        [
            11,
            16,
            128
        ],
        [
            0,
            25,
            127
        ],
        [
            1,
            24,
            127
        ],
        [
            1,
            24,
            127
        ]
    ],
    2097: [
        [
            2,
            14,
            128
        ],
        [
            3,
            13,
            128
        ],
        [
            4,
            12,
            128
        ],
        [
            5,
            11,
            128
        ],
        [
            6,
            10,
            128
        ],
        [
            7,
            9,
            128
        ],
        [
            8,
            7,
            129
        ],
        [
            9,
            7,
            129
        ],
        [
            10,
            6,
            129
        ],
        [
            11,
            6,
            129
        ],
        [
            0,
            14,
            128
        ],
        [
            1,
            13,
            128
        ],
        [
            1,
            13,
            128
        ]
    ],
    2098: [
        [
            3,
            3,
            129
        ],
        [
            4,
            3,
            129
        ],
        [
            5,
            1,
            129
        ],
        [
            6,
            1,
            129
        ],
        [
            6,
            30,
            129
        ],
        [
            7,
            29,
            129
        ],
        [
            8,
            27,
            130
        ],
        [
            9,
            27,
            130
        ],
        [
            10,
            25,
            130
        ],
        [
            11,
            24,
            130
        ],
        [
            0,
            4,
            129
        ],
        [
            1,
            3,
            129
        ],
        [
            2,
            5,
            129
        ]
    ],
    2099: [
        [
            2,
            22,
            130
        ],
        [
            3,
            21,
            130
        ],
        [
            4,
            20,
            130
        ],
        [
            5,
            19,
            130
        ],
        [
            6,
            18,
            130
        ],
        [
            7,
            17,
            130
        ],
        [
            8,
            15,
            131
        ],
        [
            9,
            15,
            131
        ],
        [
            10,
            13,
            131
        ],
        [
            11,
            13,
            131
        ],
        [
            0,
            22,
            130
        ],
        [
            1,
            21,
            130
        ],
        [
            1,
            21,
            130
        ]
    ],
    2100: [
        [
            3,
            10,
            131
        ],
        [
            4,
            10,
            131
        ],
        [
            5,
            8,
            131
        ],
        [
            6,
            8,
            131
        ],
        [
            7,
            6,
            131
        ],
        [
            8,
            5,
            131
        ],
        null,
        null,
        null,
        null,
        [
            0,
            11,
            131
        ],
        [
            1,
            10,
            131
        ],
        [
            2,
            12,
            131
        ]
    ],
    months: 13,
    year: 5729
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9SqVQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Hijri);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventMapJs = require("./CalEventMap.js");
var _calEventMapJsDefault = parcelHelpers.interopDefault(_calEventMapJs);
var _hijriCalendarJs = require("./internal/hijri-calendar.js");
class Hijri extends (0, _calEventMapJsDefault.default) {
    get(timezone) {
        const arr = this.dates.map((date)=>{
            const cdate = new (0, _caldateDefault.default)(date);
            const o = {
                date: cdate.toString() + " -0600",
                start: cdate.setOffset(-6, "h").toTimezone(timezone),
                end: cdate.toEndDate().toTimezone(timezone)
            };
            this._addSubstitute(date, o);
            return o;
        });
        return arr;
    }
    constructor(opts){
        super(opts);
        this.calendar = (0, _hijriCalendarJs.calendar);
    }
}

},{"caldate":"dgF7z","./CalEventMap.js":"YaAJX","./internal/hijri-calendar.js":"jJQI6","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jJQI6":[function(require,module,exports) {
/*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
const calendar = {
    1969: [
        [
            2,
            19,
            0
        ],
        [
            3,
            18,
            0
        ],
        [
            4,
            17,
            0
        ],
        [
            5,
            16,
            0
        ],
        [
            6,
            15,
            0
        ],
        [
            7,
            14,
            0
        ],
        [
            8,
            12,
            0
        ],
        [
            9,
            12,
            0
        ],
        [
            10,
            10,
            0
        ],
        [
            11,
            10,
            0
        ]
    ],
    1970: [
        [
            2,
            9,
            1
        ],
        [
            3,
            8,
            1
        ],
        [
            4,
            7,
            1
        ],
        [
            5,
            6,
            1
        ],
        [
            6,
            5,
            1
        ],
        [
            7,
            4,
            1
        ],
        [
            8,
            2,
            1
        ],
        [
            9,
            2,
            1
        ],
        [
            10,
            1,
            1
        ],
        [
            10,
            30,
            1
        ],
        [
            0,
            8,
            0,
            11,
            30,
            1
        ],
        [
            1,
            7,
            0
        ]
    ],
    1971: [
        [
            1,
            26,
            2
        ],
        [
            2,
            28,
            2
        ],
        [
            3,
            26,
            2
        ],
        [
            4,
            26,
            2
        ],
        [
            5,
            24,
            2
        ],
        [
            6,
            24,
            2
        ],
        [
            7,
            22,
            2
        ],
        [
            8,
            21,
            2
        ],
        [
            9,
            20,
            2
        ],
        [
            10,
            19,
            2
        ],
        [
            11,
            18,
            2
        ],
        [
            0,
            28,
            1
        ]
    ],
    1972: [
        [
            1,
            16,
            3
        ],
        [
            2,
            16,
            3
        ],
        [
            3,
            14,
            3
        ],
        [
            4,
            14,
            3
        ],
        [
            5,
            12,
            3
        ],
        [
            6,
            12,
            3
        ],
        [
            7,
            10,
            3
        ],
        [
            8,
            9,
            3
        ],
        [
            9,
            8,
            3
        ],
        [
            10,
            7,
            3
        ],
        [
            11,
            6,
            3
        ],
        [
            0,
            17,
            2
        ]
    ],
    1973: [
        [
            1,
            4,
            4
        ],
        [
            2,
            6,
            4
        ],
        [
            3,
            4,
            4
        ],
        [
            4,
            4,
            4
        ],
        [
            5,
            2,
            4
        ],
        [
            6,
            1,
            4
        ],
        [
            6,
            30,
            4
        ],
        [
            7,
            29,
            4
        ],
        [
            8,
            27,
            4
        ],
        [
            9,
            27,
            4
        ],
        [
            10,
            25,
            4
        ],
        [
            0,
            5,
            3,
            11,
            25,
            4
        ]
    ],
    1974: [
        [
            0,
            24,
            5
        ],
        [
            1,
            23,
            5
        ],
        [
            2,
            24,
            5
        ],
        [
            3,
            23,
            5
        ],
        [
            4,
            22,
            5
        ],
        [
            5,
            21,
            5
        ],
        [
            6,
            20,
            5
        ],
        [
            7,
            19,
            5
        ],
        [
            8,
            17,
            5
        ],
        [
            9,
            16,
            5
        ],
        [
            10,
            15,
            5
        ],
        [
            11,
            15,
            5
        ]
    ],
    1975: [
        [
            0,
            13,
            6
        ],
        [
            1,
            12,
            6
        ],
        [
            2,
            13,
            6
        ],
        [
            3,
            12,
            6
        ],
        [
            4,
            12,
            6
        ],
        [
            5,
            10,
            6
        ],
        [
            6,
            10,
            6
        ],
        [
            7,
            8,
            6
        ],
        [
            8,
            6,
            6
        ],
        [
            9,
            6,
            6
        ],
        [
            10,
            4,
            6
        ],
        [
            11,
            4,
            6
        ]
    ],
    1976: [
        [
            0,
            2,
            7,
            11,
            22,
            8
        ],
        [
            1,
            1,
            7
        ],
        [
            2,
            1,
            7
        ],
        [
            2,
            31,
            7
        ],
        [
            3,
            30,
            7
        ],
        [
            4,
            30,
            7
        ],
        [
            5,
            28,
            7
        ],
        [
            6,
            28,
            7
        ],
        [
            7,
            26,
            7
        ],
        [
            8,
            24,
            7
        ],
        [
            9,
            24,
            7
        ],
        [
            10,
            22,
            7
        ]
    ],
    1977: [
        [
            11,
            11,
            9
        ],
        [
            0,
            20,
            8
        ],
        [
            1,
            19,
            8
        ],
        [
            2,
            20,
            8
        ],
        [
            3,
            19,
            8
        ],
        [
            4,
            19,
            8
        ],
        [
            5,
            17,
            8
        ],
        [
            6,
            17,
            8
        ],
        [
            7,
            15,
            8
        ],
        [
            8,
            14,
            8
        ],
        [
            9,
            13,
            8
        ],
        [
            10,
            12,
            8
        ]
    ],
    1978: [
        [
            11,
            1,
            10
        ],
        [
            0,
            10,
            9,
            11,
            30,
            10
        ],
        [
            1,
            8,
            9
        ],
        [
            2,
            10,
            9
        ],
        [
            3,
            8,
            9
        ],
        [
            4,
            8,
            9
        ],
        [
            5,
            6,
            9
        ],
        [
            6,
            6,
            9
        ],
        [
            7,
            5,
            9
        ],
        [
            8,
            3,
            9
        ],
        [
            9,
            3,
            9
        ],
        [
            10,
            1,
            9
        ]
    ],
    1979: [
        [
            10,
            20,
            11
        ],
        [
            11,
            20,
            11
        ],
        [
            0,
            29,
            10
        ],
        [
            1,
            27,
            10
        ],
        [
            2,
            29,
            10
        ],
        [
            3,
            27,
            10
        ],
        [
            4,
            27,
            10
        ],
        [
            5,
            25,
            10
        ],
        [
            6,
            25,
            10
        ],
        [
            7,
            23,
            10
        ],
        [
            8,
            22,
            10
        ],
        [
            9,
            22,
            10
        ]
    ],
    1980: [
        [
            10,
            9,
            12
        ],
        [
            11,
            8,
            12
        ],
        [
            0,
            19,
            11
        ],
        [
            1,
            17,
            11
        ],
        [
            2,
            18,
            11
        ],
        [
            3,
            16,
            11
        ],
        [
            4,
            15,
            11
        ],
        [
            5,
            14,
            11
        ],
        [
            6,
            13,
            11
        ],
        [
            7,
            12,
            11
        ],
        [
            8,
            10,
            11
        ],
        [
            9,
            10,
            11
        ]
    ],
    1981: [
        [
            9,
            28,
            13
        ],
        [
            10,
            27,
            13
        ],
        [
            0,
            7,
            12,
            11,
            27,
            13
        ],
        [
            1,
            5,
            12
        ],
        [
            2,
            7,
            12
        ],
        [
            3,
            5,
            12
        ],
        [
            4,
            5,
            12
        ],
        [
            5,
            3,
            12
        ],
        [
            6,
            2,
            12
        ],
        [
            7,
            1,
            12
        ],
        [
            7,
            30,
            12
        ],
        [
            8,
            29,
            12
        ]
    ],
    1982: [
        [
            9,
            18,
            14
        ],
        [
            10,
            16,
            14
        ],
        [
            11,
            16,
            14
        ],
        [
            0,
            26,
            13
        ],
        [
            1,
            24,
            13
        ],
        [
            2,
            26,
            13
        ],
        [
            3,
            24,
            13
        ],
        [
            4,
            24,
            13
        ],
        [
            5,
            22,
            13
        ],
        [
            6,
            21,
            13
        ],
        [
            7,
            20,
            13
        ],
        [
            8,
            18,
            13
        ]
    ],
    1983: [
        [
            9,
            7,
            15
        ],
        [
            10,
            5,
            15
        ],
        [
            11,
            5,
            15
        ],
        [
            0,
            15,
            14
        ],
        [
            1,
            14,
            14
        ],
        [
            2,
            15,
            14
        ],
        [
            3,
            14,
            14
        ],
        [
            4,
            13,
            14
        ],
        [
            5,
            12,
            14
        ],
        [
            6,
            11,
            14
        ],
        [
            7,
            9,
            14
        ],
        [
            8,
            8,
            14
        ]
    ],
    1984: [
        [
            8,
            26,
            16
        ],
        [
            9,
            25,
            16
        ],
        [
            10,
            23,
            16
        ],
        [
            0,
            4,
            15,
            11,
            23,
            16
        ],
        [
            1,
            2,
            15
        ],
        [
            2,
            3,
            15
        ],
        [
            3,
            2,
            15
        ],
        [
            4,
            2,
            15
        ],
        [
            4,
            31,
            15
        ],
        [
            5,
            30,
            15
        ],
        [
            6,
            29,
            15
        ],
        [
            7,
            27,
            15
        ]
    ],
    1985: [
        [
            8,
            15,
            17
        ],
        [
            9,
            15,
            17
        ],
        [
            10,
            13,
            17
        ],
        [
            11,
            13,
            17
        ],
        [
            0,
            22,
            16
        ],
        [
            1,
            20,
            16
        ],
        [
            2,
            22,
            16
        ],
        [
            3,
            21,
            16
        ],
        [
            4,
            20,
            16
        ],
        [
            5,
            19,
            16
        ],
        [
            6,
            18,
            16
        ],
        [
            7,
            17,
            16
        ]
    ],
    1986: [
        [
            8,
            5,
            18
        ],
        [
            9,
            4,
            18
        ],
        [
            10,
            3,
            18
        ],
        [
            11,
            2,
            18
        ],
        [
            0,
            11,
            17
        ],
        [
            1,
            10,
            17
        ],
        [
            2,
            11,
            17
        ],
        [
            3,
            10,
            17
        ],
        [
            4,
            9,
            17
        ],
        [
            5,
            8,
            17
        ],
        [
            6,
            8,
            17
        ],
        [
            7,
            6,
            17
        ]
    ],
    1987: [
        [
            7,
            25,
            19
        ],
        [
            8,
            24,
            19
        ],
        [
            9,
            23,
            19
        ],
        [
            10,
            22,
            19
        ],
        [
            0,
            1,
            18,
            11,
            21,
            19
        ],
        [
            0,
            30,
            18
        ],
        [
            2,
            1,
            18
        ],
        [
            2,
            30,
            18
        ],
        [
            3,
            29,
            18
        ],
        [
            4,
            28,
            18
        ],
        [
            5,
            27,
            18
        ],
        [
            6,
            26,
            18
        ]
    ],
    1988: [
        [
            7,
            13,
            20
        ],
        [
            8,
            12,
            20
        ],
        [
            9,
            11,
            20
        ],
        [
            10,
            10,
            20
        ],
        [
            11,
            10,
            20
        ],
        [
            0,
            20,
            19
        ],
        [
            1,
            18,
            19
        ],
        [
            2,
            19,
            19
        ],
        [
            3,
            17,
            19
        ],
        [
            4,
            16,
            19
        ],
        [
            5,
            15,
            19
        ],
        [
            6,
            14,
            19
        ]
    ],
    1989: [
        [
            7,
            2,
            21
        ],
        [
            8,
            1,
            21
        ],
        [
            8,
            30,
            21
        ],
        [
            9,
            30,
            21
        ],
        [
            10,
            29,
            21
        ],
        [
            0,
            8,
            20,
            11,
            29,
            21
        ],
        [
            1,
            7,
            20
        ],
        [
            2,
            8,
            20
        ],
        [
            3,
            7,
            20
        ],
        [
            4,
            6,
            20
        ],
        [
            5,
            4,
            20
        ],
        [
            6,
            4,
            20
        ]
    ],
    1990: [
        [
            6,
            23,
            22
        ],
        [
            7,
            21,
            22
        ],
        [
            8,
            20,
            22
        ],
        [
            9,
            19,
            22
        ],
        [
            10,
            18,
            22
        ],
        [
            11,
            18,
            22
        ],
        [
            0,
            27,
            21
        ],
        [
            1,
            26,
            21
        ],
        [
            2,
            27,
            21
        ],
        [
            3,
            26,
            21
        ],
        [
            4,
            25,
            21
        ],
        [
            5,
            23,
            21
        ]
    ],
    1991: [
        [
            6,
            12,
            23
        ],
        [
            7,
            11,
            23
        ],
        [
            8,
            9,
            23
        ],
        [
            9,
            8,
            23
        ],
        [
            10,
            7,
            23
        ],
        [
            11,
            7,
            23
        ],
        [
            0,
            16,
            22
        ],
        [
            1,
            15,
            22
        ],
        [
            2,
            17,
            22
        ],
        [
            3,
            15,
            22
        ],
        [
            4,
            15,
            22
        ],
        [
            5,
            13,
            22
        ]
    ],
    1992: [
        [
            6,
            1,
            24
        ],
        [
            6,
            30,
            24
        ],
        [
            7,
            29,
            24
        ],
        [
            8,
            27,
            24
        ],
        [
            9,
            26,
            24
        ],
        [
            10,
            25,
            24
        ],
        [
            0,
            5,
            23,
            11,
            25,
            24
        ],
        [
            1,
            4,
            23
        ],
        [
            2,
            5,
            23
        ],
        [
            3,
            4,
            23
        ],
        [
            4,
            3,
            23
        ],
        [
            5,
            2,
            23
        ]
    ],
    1993: [
        [
            5,
            21,
            25
        ],
        [
            6,
            20,
            25
        ],
        [
            7,
            18,
            25
        ],
        [
            8,
            17,
            25
        ],
        [
            9,
            16,
            25
        ],
        [
            10,
            14,
            25
        ],
        [
            11,
            14,
            25
        ],
        [
            0,
            23,
            24
        ],
        [
            1,
            22,
            24
        ],
        [
            2,
            24,
            24
        ],
        [
            3,
            22,
            24
        ],
        [
            4,
            22,
            24
        ]
    ],
    1994: [
        [
            5,
            10,
            26
        ],
        [
            6,
            9,
            26
        ],
        [
            7,
            8,
            26
        ],
        [
            8,
            6,
            26
        ],
        [
            9,
            6,
            26
        ],
        [
            10,
            4,
            26
        ],
        [
            11,
            3,
            26
        ],
        [
            0,
            12,
            25
        ],
        [
            1,
            11,
            25
        ],
        [
            2,
            13,
            25
        ],
        [
            3,
            12,
            25
        ],
        [
            4,
            11,
            25
        ]
    ],
    1995: [
        [
            4,
            30,
            27
        ],
        [
            5,
            29,
            27
        ],
        [
            6,
            28,
            27
        ],
        [
            7,
            27,
            27
        ],
        [
            8,
            25,
            27
        ],
        [
            9,
            25,
            27
        ],
        [
            10,
            23,
            27
        ],
        [
            0,
            2,
            26,
            11,
            23,
            27
        ],
        [
            0,
            31,
            26
        ],
        [
            2,
            2,
            26
        ],
        [
            3,
            1,
            26
        ],
        [
            3,
            30,
            26
        ]
    ],
    1996: [
        [
            4,
            18,
            28
        ],
        [
            5,
            17,
            28
        ],
        [
            6,
            16,
            28
        ],
        [
            7,
            15,
            28
        ],
        [
            8,
            13,
            28
        ],
        [
            9,
            13,
            28
        ],
        [
            10,
            12,
            28
        ],
        [
            11,
            11,
            28
        ],
        [
            0,
            21,
            27
        ],
        [
            1,
            19,
            27
        ],
        [
            2,
            20,
            27
        ],
        [
            3,
            18,
            27
        ]
    ],
    1997: [
        [
            4,
            7,
            29
        ],
        [
            5,
            6,
            29
        ],
        [
            6,
            5,
            29
        ],
        [
            7,
            4,
            29
        ],
        [
            8,
            2,
            29
        ],
        [
            9,
            2,
            29
        ],
        [
            10,
            1,
            29
        ],
        [
            11,
            1,
            29
        ],
        [
            0,
            10,
            28,
            11,
            30,
            29
        ],
        [
            1,
            8,
            28
        ],
        [
            2,
            10,
            28
        ],
        [
            3,
            8,
            28
        ]
    ],
    1998: [
        [
            3,
            27,
            30
        ],
        [
            4,
            26,
            30
        ],
        [
            5,
            25,
            30
        ],
        [
            6,
            24,
            30
        ],
        [
            7,
            23,
            30
        ],
        [
            8,
            21,
            30
        ],
        [
            9,
            21,
            30
        ],
        [
            10,
            20,
            30
        ],
        [
            11,
            19,
            30
        ],
        [
            0,
            29,
            29
        ],
        [
            1,
            27,
            29
        ],
        [
            2,
            29,
            29
        ]
    ],
    1999: [
        [
            3,
            17,
            31
        ],
        [
            4,
            16,
            31
        ],
        [
            5,
            15,
            31
        ],
        [
            6,
            14,
            31
        ],
        [
            7,
            12,
            31
        ],
        [
            8,
            11,
            31
        ],
        [
            9,
            10,
            31
        ],
        [
            10,
            9,
            31
        ],
        [
            11,
            9,
            31
        ],
        [
            0,
            18,
            30
        ],
        [
            1,
            17,
            30
        ],
        [
            2,
            18,
            30
        ]
    ],
    2000: [
        [
            3,
            6,
            32
        ],
        [
            4,
            5,
            32
        ],
        [
            5,
            3,
            32
        ],
        [
            6,
            3,
            32
        ],
        [
            7,
            1,
            32
        ],
        [
            7,
            30,
            32
        ],
        [
            8,
            28,
            32
        ],
        [
            9,
            28,
            32
        ],
        [
            10,
            27,
            32
        ],
        [
            0,
            8,
            31,
            11,
            27,
            32
        ],
        [
            1,
            7,
            31
        ],
        [
            2,
            7,
            31
        ]
    ],
    2001: [
        [
            2,
            26,
            33
        ],
        [
            3,
            25,
            33
        ],
        [
            4,
            24,
            33
        ],
        [
            5,
            22,
            33
        ],
        [
            6,
            22,
            33
        ],
        [
            7,
            20,
            33
        ],
        [
            8,
            18,
            33
        ],
        [
            9,
            17,
            33
        ],
        [
            10,
            16,
            33
        ],
        [
            11,
            16,
            33
        ],
        [
            0,
            26,
            32
        ],
        [
            1,
            24,
            32
        ]
    ],
    2002: [
        [
            2,
            15,
            34
        ],
        [
            3,
            14,
            34
        ],
        [
            4,
            13,
            34
        ],
        [
            5,
            12,
            34
        ],
        [
            6,
            11,
            34
        ],
        [
            7,
            10,
            34
        ],
        [
            8,
            8,
            34
        ],
        [
            9,
            7,
            34
        ],
        [
            10,
            6,
            34
        ],
        [
            11,
            5,
            34
        ],
        [
            0,
            15,
            33
        ],
        [
            1,
            13,
            33
        ]
    ],
    2003: [
        [
            2,
            4,
            35
        ],
        [
            3,
            3,
            35
        ],
        [
            4,
            2,
            35
        ],
        [
            5,
            1,
            35
        ],
        [
            6,
            1,
            35
        ],
        [
            6,
            30,
            35
        ],
        [
            7,
            29,
            35
        ],
        [
            8,
            27,
            35
        ],
        [
            9,
            26,
            35
        ],
        [
            10,
            25,
            35
        ],
        [
            0,
            4,
            34,
            11,
            24,
            35
        ],
        [
            1,
            2,
            34
        ]
    ],
    2004: [
        [
            1,
            21,
            36
        ],
        [
            2,
            22,
            36
        ],
        [
            3,
            20,
            36
        ],
        [
            4,
            20,
            36
        ],
        [
            5,
            19,
            36
        ],
        [
            6,
            18,
            36
        ],
        [
            7,
            17,
            36
        ],
        [
            8,
            15,
            36
        ],
        [
            9,
            15,
            36
        ],
        [
            10,
            14,
            36
        ],
        [
            11,
            13,
            36
        ],
        [
            0,
            23,
            35
        ]
    ],
    2005: [
        [
            1,
            10,
            37
        ],
        [
            2,
            11,
            37
        ],
        [
            3,
            10,
            37
        ],
        [
            4,
            9,
            37
        ],
        [
            5,
            8,
            37
        ],
        [
            6,
            7,
            37
        ],
        [
            7,
            6,
            37
        ],
        [
            8,
            5,
            37
        ],
        [
            9,
            4,
            37
        ],
        [
            10,
            3,
            37
        ],
        [
            11,
            3,
            37
        ],
        [
            0,
            12,
            36
        ]
    ],
    2006: [
        [
            0,
            31,
            38
        ],
        [
            2,
            1,
            38
        ],
        [
            2,
            30,
            38
        ],
        [
            3,
            29,
            38
        ],
        [
            4,
            28,
            38
        ],
        [
            5,
            26,
            38
        ],
        [
            6,
            26,
            38
        ],
        [
            7,
            25,
            38
        ],
        [
            8,
            24,
            38
        ],
        [
            9,
            23,
            38
        ],
        [
            10,
            22,
            38
        ],
        [
            0,
            1,
            37,
            11,
            22,
            38
        ]
    ],
    2007: [
        [
            0,
            20,
            39
        ],
        [
            1,
            19,
            39
        ],
        [
            2,
            20,
            39
        ],
        [
            3,
            18,
            39
        ],
        [
            4,
            18,
            39
        ],
        [
            5,
            16,
            39
        ],
        [
            6,
            15,
            39
        ],
        [
            7,
            14,
            39
        ],
        [
            8,
            13,
            39
        ],
        [
            9,
            13,
            39
        ],
        [
            10,
            11,
            39
        ],
        [
            11,
            11,
            39
        ]
    ],
    2008: [
        [
            0,
            10,
            40,
            11,
            29,
            41
        ],
        [
            1,
            8,
            40
        ],
        [
            2,
            9,
            40
        ],
        [
            3,
            7,
            40
        ],
        [
            4,
            6,
            40
        ],
        [
            5,
            5,
            40
        ],
        [
            6,
            4,
            40
        ],
        [
            7,
            2,
            40
        ],
        [
            8,
            1,
            40
        ],
        [
            9,
            1,
            40
        ],
        [
            9,
            30,
            40
        ],
        [
            10,
            29,
            40
        ]
    ],
    2009: [
        [
            11,
            18,
            42
        ],
        [
            0,
            27,
            41
        ],
        [
            1,
            26,
            41
        ],
        [
            2,
            28,
            41
        ],
        [
            3,
            26,
            41
        ],
        [
            4,
            25,
            41
        ],
        [
            5,
            24,
            41
        ],
        [
            6,
            23,
            41
        ],
        [
            7,
            22,
            41
        ],
        [
            8,
            20,
            41
        ],
        [
            9,
            20,
            41
        ],
        [
            10,
            18,
            41
        ]
    ],
    2010: [
        [
            11,
            7,
            43
        ],
        [
            0,
            16,
            42
        ],
        [
            1,
            15,
            42
        ],
        [
            2,
            17,
            42
        ],
        [
            3,
            15,
            42
        ],
        [
            4,
            15,
            42
        ],
        [
            5,
            13,
            42
        ],
        [
            6,
            13,
            42
        ],
        [
            7,
            11,
            42
        ],
        [
            8,
            10,
            42
        ],
        [
            9,
            9,
            42
        ],
        [
            10,
            7,
            42
        ]
    ],
    2011: [
        [
            10,
            26,
            44
        ],
        [
            0,
            5,
            43,
            11,
            26,
            44
        ],
        [
            1,
            4,
            43
        ],
        [
            2,
            6,
            43
        ],
        [
            3,
            5,
            43
        ],
        [
            4,
            4,
            43
        ],
        [
            5,
            3,
            43
        ],
        [
            6,
            2,
            43
        ],
        [
            7,
            1,
            43
        ],
        [
            7,
            30,
            43
        ],
        [
            8,
            29,
            43
        ],
        [
            9,
            28,
            43
        ]
    ],
    2012: [
        [
            10,
            15,
            45
        ],
        [
            11,
            14,
            45
        ],
        [
            0,
            24,
            44
        ],
        [
            1,
            23,
            44
        ],
        [
            2,
            24,
            44
        ],
        [
            3,
            22,
            44
        ],
        [
            4,
            22,
            44
        ],
        [
            5,
            21,
            44
        ],
        [
            6,
            20,
            44
        ],
        [
            7,
            19,
            44
        ],
        [
            8,
            17,
            44
        ],
        [
            9,
            17,
            44
        ]
    ],
    2013: [
        [
            10,
            4,
            46
        ],
        [
            11,
            4,
            46
        ],
        [
            0,
            13,
            45
        ],
        [
            1,
            11,
            45
        ],
        [
            2,
            13,
            45
        ],
        [
            3,
            11,
            45
        ],
        [
            4,
            11,
            45
        ],
        [
            5,
            10,
            45
        ],
        [
            6,
            9,
            45
        ],
        [
            7,
            8,
            45
        ],
        [
            8,
            7,
            45
        ],
        [
            9,
            6,
            45
        ]
    ],
    2014: [
        [
            9,
            25,
            47
        ],
        [
            10,
            23,
            47
        ],
        [
            0,
            2,
            46,
            11,
            23,
            47
        ],
        [
            1,
            1,
            46
        ],
        [
            2,
            2,
            46
        ],
        [
            3,
            1,
            46
        ],
        [
            3,
            30,
            46
        ],
        [
            4,
            30,
            46
        ],
        [
            5,
            28,
            46
        ],
        [
            6,
            28,
            46
        ],
        [
            7,
            27,
            46
        ],
        [
            8,
            25,
            46
        ]
    ],
    2015: [
        [
            9,
            14,
            48
        ],
        [
            10,
            13,
            48
        ],
        [
            11,
            12,
            48
        ],
        [
            0,
            21,
            47
        ],
        [
            1,
            20,
            47
        ],
        [
            2,
            21,
            47
        ],
        [
            3,
            20,
            47
        ],
        [
            4,
            19,
            47
        ],
        [
            5,
            18,
            47
        ],
        [
            6,
            17,
            47
        ],
        [
            7,
            16,
            47
        ],
        [
            8,
            14,
            47
        ]
    ],
    2016: [
        [
            9,
            2,
            49
        ],
        [
            10,
            1,
            49
        ],
        [
            10,
            30,
            49
        ],
        [
            0,
            11,
            48,
            11,
            30,
            49
        ],
        [
            1,
            10,
            48
        ],
        [
            2,
            10,
            48
        ],
        [
            3,
            8,
            48
        ],
        [
            4,
            8,
            48
        ],
        [
            5,
            6,
            48
        ],
        [
            6,
            6,
            48
        ],
        [
            7,
            4,
            48
        ],
        [
            8,
            2,
            48
        ]
    ],
    2017: [
        [
            8,
            21,
            50
        ],
        [
            9,
            21,
            50
        ],
        [
            10,
            19,
            50
        ],
        [
            11,
            19,
            50
        ],
        [
            0,
            29,
            49
        ],
        [
            1,
            28,
            49
        ],
        [
            2,
            29,
            49
        ],
        [
            3,
            27,
            49
        ],
        [
            4,
            27,
            49
        ],
        [
            5,
            25,
            49
        ],
        [
            6,
            24,
            49
        ],
        [
            7,
            23,
            49
        ]
    ],
    2018: [
        [
            8,
            11,
            51
        ],
        [
            9,
            10,
            51
        ],
        [
            10,
            9,
            51
        ],
        [
            11,
            8,
            51
        ],
        [
            0,
            18,
            50
        ],
        [
            1,
            17,
            50
        ],
        [
            2,
            18,
            50
        ],
        [
            3,
            17,
            50
        ],
        [
            4,
            16,
            50
        ],
        [
            5,
            15,
            50
        ],
        [
            6,
            14,
            50
        ],
        [
            7,
            12,
            50
        ]
    ],
    2019: [
        [
            7,
            31,
            52
        ],
        [
            8,
            30,
            52
        ],
        [
            9,
            29,
            52
        ],
        [
            10,
            28,
            52
        ],
        [
            0,
            7,
            51,
            11,
            27,
            52
        ],
        [
            1,
            6,
            51
        ],
        [
            2,
            8,
            51
        ],
        [
            3,
            6,
            51
        ],
        [
            4,
            6,
            51
        ],
        [
            5,
            4,
            51
        ],
        [
            6,
            4,
            51
        ],
        [
            7,
            2,
            51
        ]
    ],
    2020: [
        [
            7,
            20,
            53
        ],
        [
            8,
            18,
            53
        ],
        [
            9,
            18,
            53
        ],
        [
            10,
            16,
            53
        ],
        [
            11,
            16,
            53
        ],
        [
            0,
            26,
            52
        ],
        [
            1,
            25,
            52
        ],
        [
            2,
            25,
            52
        ],
        [
            3,
            24,
            52
        ],
        [
            4,
            24,
            52
        ],
        [
            5,
            22,
            52
        ],
        [
            6,
            22,
            52
        ]
    ],
    2021: [
        [
            7,
            9,
            54
        ],
        [
            8,
            8,
            54
        ],
        [
            9,
            7,
            54
        ],
        [
            10,
            6,
            54
        ],
        [
            11,
            5,
            54
        ],
        [
            0,
            14,
            53
        ],
        [
            1,
            13,
            53
        ],
        [
            2,
            14,
            53
        ],
        [
            3,
            13,
            53
        ],
        [
            4,
            13,
            53
        ],
        [
            5,
            11,
            53
        ],
        [
            6,
            11,
            53
        ]
    ],
    2022: [
        [
            6,
            30,
            55
        ],
        [
            7,
            28,
            55
        ],
        [
            8,
            27,
            55
        ],
        [
            9,
            26,
            55
        ],
        [
            10,
            25,
            55
        ],
        [
            0,
            4,
            54,
            11,
            25,
            55
        ],
        [
            1,
            2,
            54
        ],
        [
            2,
            4,
            54
        ],
        [
            3,
            2,
            54
        ],
        [
            4,
            2,
            54
        ],
        [
            4,
            31,
            54
        ],
        [
            5,
            30,
            54
        ]
    ],
    2023: [
        [
            6,
            19,
            56
        ],
        [
            7,
            17,
            56
        ],
        [
            8,
            16,
            56
        ],
        [
            9,
            16,
            56
        ],
        [
            10,
            15,
            56
        ],
        [
            11,
            14,
            56
        ],
        [
            0,
            23,
            55
        ],
        [
            1,
            21,
            55
        ],
        [
            2,
            23,
            55
        ],
        [
            3,
            21,
            55
        ],
        [
            4,
            21,
            55
        ],
        [
            5,
            19,
            55
        ]
    ],
    2024: [
        [
            6,
            7,
            57
        ],
        [
            7,
            5,
            57
        ],
        [
            8,
            4,
            57
        ],
        [
            9,
            4,
            57
        ],
        [
            10,
            3,
            57
        ],
        [
            11,
            3,
            57
        ],
        [
            0,
            13,
            56
        ],
        [
            1,
            11,
            56
        ],
        [
            2,
            11,
            56
        ],
        [
            3,
            10,
            56
        ],
        [
            4,
            9,
            56
        ],
        [
            5,
            7,
            56
        ]
    ],
    2025: [
        [
            5,
            26,
            58
        ],
        [
            6,
            26,
            58
        ],
        [
            7,
            24,
            58
        ],
        [
            8,
            23,
            58
        ],
        [
            9,
            23,
            58
        ],
        [
            10,
            22,
            58
        ],
        [
            0,
            1,
            57,
            11,
            21,
            58
        ],
        [
            0,
            31,
            57
        ],
        [
            2,
            1,
            57
        ],
        [
            2,
            30,
            57
        ],
        [
            3,
            29,
            57
        ],
        [
            4,
            28,
            57
        ]
    ],
    2026: [
        [
            5,
            16,
            59
        ],
        [
            6,
            15,
            59
        ],
        [
            7,
            14,
            59
        ],
        [
            8,
            12,
            59
        ],
        [
            9,
            12,
            59
        ],
        [
            10,
            11,
            59
        ],
        [
            11,
            10,
            59
        ],
        [
            0,
            20,
            58
        ],
        [
            1,
            18,
            58
        ],
        [
            2,
            20,
            58
        ],
        [
            3,
            18,
            58
        ],
        [
            4,
            18,
            58
        ]
    ],
    2027: [
        [
            5,
            6,
            60
        ],
        [
            6,
            5,
            60
        ],
        [
            7,
            3,
            60
        ],
        [
            8,
            2,
            60
        ],
        [
            9,
            1,
            60
        ],
        [
            9,
            31,
            60
        ],
        [
            10,
            29,
            60
        ],
        [
            0,
            9,
            59,
            11,
            29,
            60
        ],
        [
            1,
            8,
            59
        ],
        [
            2,
            9,
            59
        ],
        [
            3,
            8,
            59
        ],
        [
            4,
            7,
            59
        ]
    ],
    2028: [
        [
            4,
            25,
            61
        ],
        [
            5,
            24,
            61
        ],
        [
            6,
            23,
            61
        ],
        [
            7,
            22,
            61
        ],
        [
            8,
            20,
            61
        ],
        [
            9,
            19,
            61
        ],
        [
            10,
            18,
            61
        ],
        [
            11,
            17,
            61
        ],
        [
            0,
            28,
            60
        ],
        [
            1,
            26,
            60
        ],
        [
            2,
            27,
            60
        ],
        [
            3,
            26,
            60
        ]
    ],
    2029: [
        [
            4,
            14,
            62
        ],
        [
            5,
            13,
            62
        ],
        [
            6,
            13,
            62
        ],
        [
            7,
            11,
            62
        ],
        [
            8,
            10,
            62
        ],
        [
            9,
            9,
            62
        ],
        [
            10,
            7,
            62
        ],
        [
            11,
            7,
            62
        ],
        [
            0,
            16,
            61
        ],
        [
            1,
            14,
            61
        ],
        [
            2,
            16,
            61
        ],
        [
            3,
            15,
            61
        ]
    ],
    2030: [
        [
            4,
            3,
            63
        ],
        [
            5,
            2,
            63
        ],
        [
            6,
            2,
            63
        ],
        [
            7,
            1,
            63
        ],
        [
            7,
            30,
            63
        ],
        [
            8,
            29,
            63
        ],
        [
            9,
            28,
            63
        ],
        [
            10,
            26,
            63
        ],
        [
            0,
            5,
            62,
            11,
            26,
            63
        ],
        [
            1,
            4,
            62
        ],
        [
            2,
            5,
            62
        ],
        [
            3,
            4,
            62
        ]
    ],
    2031: [
        [
            3,
            23,
            64
        ],
        [
            4,
            22,
            64
        ],
        [
            5,
            21,
            64
        ],
        [
            6,
            21,
            64
        ],
        [
            7,
            20,
            64
        ],
        [
            8,
            18,
            64
        ],
        [
            9,
            17,
            64
        ],
        [
            10,
            16,
            64
        ],
        [
            11,
            15,
            64
        ],
        [
            0,
            24,
            63
        ],
        [
            1,
            23,
            63
        ],
        [
            2,
            24,
            63
        ]
    ],
    2032: [
        [
            3,
            11,
            65
        ],
        [
            4,
            10,
            65
        ],
        [
            5,
            9,
            65
        ],
        [
            6,
            9,
            65
        ],
        [
            7,
            8,
            65
        ],
        [
            8,
            6,
            65
        ],
        [
            9,
            6,
            65
        ],
        [
            10,
            4,
            65
        ],
        [
            11,
            4,
            65
        ],
        [
            0,
            14,
            64
        ],
        [
            1,
            12,
            64
        ],
        [
            2,
            13,
            64
        ]
    ],
    2033: [
        [
            3,
            1,
            66
        ],
        [
            3,
            30,
            66
        ],
        [
            4,
            29,
            66
        ],
        [
            5,
            28,
            66
        ],
        [
            6,
            28,
            66
        ],
        [
            7,
            26,
            66
        ],
        [
            8,
            25,
            66
        ],
        [
            9,
            24,
            66
        ],
        [
            10,
            23,
            66
        ],
        [
            0,
            2,
            65,
            11,
            23,
            66
        ],
        [
            1,
            1,
            65
        ],
        [
            2,
            2,
            65
        ]
    ],
    2034: [
        [
            2,
            21,
            67
        ],
        [
            3,
            20,
            67
        ],
        [
            4,
            19,
            67
        ],
        [
            5,
            17,
            67
        ],
        [
            6,
            17,
            67
        ],
        [
            7,
            15,
            67
        ],
        [
            8,
            14,
            67
        ],
        [
            9,
            13,
            67
        ],
        [
            10,
            12,
            67
        ],
        [
            11,
            12,
            67
        ],
        [
            0,
            21,
            66
        ],
        [
            1,
            20,
            66
        ]
    ],
    2035: [
        [
            2,
            11,
            68
        ],
        [
            3,
            9,
            68
        ],
        [
            4,
            9,
            68
        ],
        [
            5,
            7,
            68
        ],
        [
            6,
            6,
            68
        ],
        [
            7,
            5,
            68
        ],
        [
            8,
            3,
            68
        ],
        [
            9,
            2,
            68
        ],
        [
            10,
            1,
            68
        ],
        [
            11,
            1,
            68
        ],
        [
            0,
            11,
            67,
            11,
            30,
            68
        ],
        [
            1,
            9,
            67
        ]
    ],
    2036: [
        [
            1,
            28,
            69
        ],
        [
            2,
            29,
            69
        ],
        [
            3,
            27,
            69
        ],
        [
            4,
            27,
            69
        ],
        [
            5,
            25,
            69
        ],
        [
            6,
            24,
            69
        ],
        [
            7,
            23,
            69
        ],
        [
            8,
            21,
            69
        ],
        [
            9,
            20,
            69
        ],
        [
            10,
            19,
            69
        ],
        [
            11,
            19,
            69
        ],
        [
            0,
            29,
            68
        ]
    ],
    2037: [
        [
            1,
            16,
            70
        ],
        [
            2,
            18,
            70
        ],
        [
            3,
            17,
            70
        ],
        [
            4,
            16,
            70
        ],
        [
            5,
            15,
            70
        ],
        [
            6,
            14,
            70
        ],
        [
            7,
            12,
            70
        ],
        [
            8,
            11,
            70
        ],
        [
            9,
            10,
            70
        ],
        [
            10,
            8,
            70
        ],
        [
            11,
            8,
            70
        ],
        [
            0,
            17,
            69
        ]
    ],
    2038: [
        [
            1,
            5,
            71
        ],
        [
            2,
            7,
            71
        ],
        [
            3,
            6,
            71
        ],
        [
            4,
            5,
            71
        ],
        [
            5,
            4,
            71
        ],
        [
            6,
            3,
            71
        ],
        [
            7,
            2,
            71
        ],
        [
            7,
            31,
            71
        ],
        [
            8,
            30,
            71
        ],
        [
            9,
            29,
            71
        ],
        [
            10,
            27,
            71
        ],
        [
            0,
            7,
            70,
            11,
            27,
            71
        ]
    ],
    2039: [
        [
            0,
            26,
            72
        ],
        [
            1,
            24,
            72
        ],
        [
            2,
            26,
            72
        ],
        [
            3,
            24,
            72
        ],
        [
            4,
            24,
            72
        ],
        [
            5,
            23,
            72
        ],
        [
            6,
            22,
            72
        ],
        [
            7,
            21,
            72
        ],
        [
            8,
            19,
            72
        ],
        [
            9,
            19,
            72
        ],
        [
            10,
            17,
            72
        ],
        [
            11,
            17,
            72
        ]
    ],
    2040: [
        [
            0,
            15,
            73
        ],
        [
            1,
            14,
            73
        ],
        [
            2,
            14,
            73
        ],
        [
            3,
            13,
            73
        ],
        [
            4,
            12,
            73
        ],
        [
            5,
            11,
            73
        ],
        [
            6,
            10,
            73
        ],
        [
            7,
            9,
            73
        ],
        [
            8,
            7,
            73
        ],
        [
            9,
            7,
            73
        ],
        [
            10,
            6,
            73
        ],
        [
            11,
            5,
            73
        ]
    ],
    2041: [
        [
            0,
            4,
            74,
            11,
            24,
            75
        ],
        [
            1,
            2,
            74
        ],
        [
            2,
            4,
            74
        ],
        [
            3,
            2,
            74
        ],
        [
            4,
            1,
            74
        ],
        [
            4,
            31,
            74
        ],
        [
            5,
            29,
            74
        ],
        [
            6,
            29,
            74
        ],
        [
            7,
            28,
            74
        ],
        [
            8,
            26,
            74
        ],
        [
            9,
            26,
            74
        ],
        [
            10,
            25,
            74
        ]
    ],
    2042: [
        [
            11,
            14,
            76
        ],
        [
            0,
            23,
            75
        ],
        [
            1,
            21,
            75
        ],
        [
            2,
            23,
            75
        ],
        [
            3,
            21,
            75
        ],
        [
            4,
            20,
            75
        ],
        [
            5,
            19,
            75
        ],
        [
            6,
            18,
            75
        ],
        [
            7,
            17,
            75
        ],
        [
            8,
            15,
            75
        ],
        [
            9,
            15,
            75
        ],
        [
            10,
            14,
            75
        ]
    ],
    2043: [
        [
            11,
            3,
            77
        ],
        [
            0,
            12,
            76
        ],
        [
            1,
            11,
            76
        ],
        [
            2,
            12,
            76
        ],
        [
            3,
            11,
            76
        ],
        [
            4,
            10,
            76
        ],
        [
            5,
            8,
            76
        ],
        [
            6,
            8,
            76
        ],
        [
            7,
            6,
            76
        ],
        [
            8,
            4,
            76
        ],
        [
            9,
            4,
            76
        ],
        [
            10,
            3,
            76
        ]
    ],
    2044: [
        [
            10,
            21,
            78
        ],
        [
            0,
            2,
            77,
            11,
            21,
            78
        ],
        [
            0,
            31,
            77
        ],
        [
            2,
            1,
            77
        ],
        [
            2,
            30,
            77
        ],
        [
            3,
            29,
            77
        ],
        [
            4,
            28,
            77
        ],
        [
            5,
            26,
            77
        ],
        [
            6,
            26,
            77
        ],
        [
            7,
            24,
            77
        ],
        [
            8,
            23,
            77
        ],
        [
            9,
            22,
            77
        ]
    ],
    2045: [
        [
            10,
            10,
            79
        ],
        [
            11,
            10,
            79
        ],
        [
            0,
            19,
            78
        ],
        [
            1,
            18,
            78
        ],
        [
            2,
            20,
            78
        ],
        [
            3,
            18,
            78
        ],
        [
            4,
            18,
            78
        ],
        [
            5,
            16,
            78
        ],
        [
            6,
            15,
            78
        ],
        [
            7,
            14,
            78
        ],
        [
            8,
            12,
            78
        ],
        [
            9,
            12,
            78
        ]
    ],
    2046: [
        [
            9,
            31,
            80
        ],
        [
            10,
            29,
            80
        ],
        [
            0,
            8,
            79,
            11,
            28,
            80
        ],
        [
            1,
            7,
            79
        ],
        [
            2,
            9,
            79
        ],
        [
            3,
            7,
            79
        ],
        [
            4,
            7,
            79
        ],
        [
            5,
            5,
            79
        ],
        [
            6,
            5,
            79
        ],
        [
            7,
            3,
            79
        ],
        [
            8,
            2,
            79
        ],
        [
            9,
            1,
            79
        ]
    ],
    2047: [
        [
            9,
            20,
            81
        ],
        [
            10,
            19,
            81
        ],
        [
            11,
            18,
            81
        ],
        [
            0,
            27,
            80
        ],
        [
            1,
            26,
            80
        ],
        [
            2,
            27,
            80
        ],
        [
            3,
            26,
            80
        ],
        [
            4,
            26,
            80
        ],
        [
            5,
            24,
            80
        ],
        [
            6,
            24,
            80
        ],
        [
            7,
            23,
            80
        ],
        [
            8,
            21,
            80
        ]
    ],
    2048: [
        [
            9,
            9,
            82
        ],
        [
            10,
            7,
            82
        ],
        [
            11,
            7,
            82
        ],
        [
            0,
            16,
            81
        ],
        [
            1,
            15,
            81
        ],
        [
            2,
            16,
            81
        ],
        [
            3,
            14,
            81
        ],
        [
            4,
            14,
            81
        ],
        [
            5,
            12,
            81
        ],
        [
            6,
            12,
            81
        ],
        [
            7,
            11,
            81
        ],
        [
            8,
            10,
            81
        ]
    ],
    2049: [
        [
            8,
            28,
            83
        ],
        [
            9,
            28,
            83
        ],
        [
            10,
            26,
            83
        ],
        [
            0,
            5,
            82,
            11,
            26,
            83
        ],
        [
            1,
            3,
            82
        ],
        [
            2,
            5,
            82
        ],
        [
            3,
            3,
            82
        ],
        [
            4,
            3,
            82
        ],
        [
            5,
            2,
            82
        ],
        [
            6,
            1,
            82
        ],
        [
            6,
            31,
            82
        ],
        [
            7,
            30,
            82
        ]
    ],
    2050: [
        [
            8,
            17,
            84
        ],
        [
            9,
            17,
            84
        ],
        [
            10,
            15,
            84
        ],
        [
            11,
            15,
            84
        ],
        [
            0,
            24,
            83
        ],
        [
            1,
            23,
            83
        ],
        [
            2,
            24,
            83
        ],
        [
            3,
            22,
            83
        ],
        [
            4,
            22,
            83
        ],
        [
            5,
            20,
            83
        ],
        [
            6,
            20,
            83
        ],
        [
            7,
            19,
            83
        ]
    ],
    2051: [
        [
            8,
            6,
            85
        ],
        [
            9,
            6,
            85
        ],
        [
            10,
            5,
            85
        ],
        [
            11,
            4,
            85
        ],
        [
            0,
            14,
            84
        ],
        [
            1,
            12,
            84
        ],
        [
            2,
            14,
            84
        ],
        [
            3,
            12,
            84
        ],
        [
            4,
            11,
            84
        ],
        [
            5,
            10,
            84
        ],
        [
            6,
            9,
            84
        ],
        [
            7,
            8,
            84
        ]
    ],
    2052: [
        [
            7,
            26,
            86
        ],
        [
            8,
            24,
            86
        ],
        [
            9,
            24,
            86
        ],
        [
            10,
            22,
            86
        ],
        [
            0,
            3,
            85,
            11,
            22,
            86
        ],
        [
            1,
            2,
            85
        ],
        [
            2,
            2,
            85
        ],
        [
            3,
            1,
            85
        ],
        [
            3,
            30,
            85
        ],
        [
            4,
            29,
            85
        ],
        [
            5,
            28,
            85
        ],
        [
            6,
            27,
            85
        ]
    ],
    2053: [
        [
            7,
            15,
            87
        ],
        [
            8,
            13,
            87
        ],
        [
            9,
            13,
            87
        ],
        [
            10,
            11,
            87
        ],
        [
            11,
            11,
            87
        ],
        [
            0,
            21,
            86
        ],
        [
            1,
            20,
            86
        ],
        [
            2,
            21,
            86
        ],
        [
            3,
            20,
            86
        ],
        [
            4,
            19,
            86
        ],
        [
            5,
            17,
            86
        ],
        [
            6,
            17,
            86
        ]
    ],
    2054: [
        [
            7,
            5,
            88
        ],
        [
            8,
            3,
            88
        ],
        [
            9,
            2,
            88
        ],
        [
            10,
            1,
            88
        ],
        [
            10,
            30,
            88
        ],
        [
            0,
            10,
            87,
            11,
            30,
            88
        ],
        [
            1,
            9,
            87
        ],
        [
            2,
            10,
            87
        ],
        [
            3,
            9,
            87
        ],
        [
            4,
            9,
            87
        ],
        [
            5,
            7,
            87
        ],
        [
            6,
            6,
            87
        ]
    ],
    2055: [
        [
            6,
            25,
            89
        ],
        [
            7,
            24,
            89
        ],
        [
            8,
            22,
            89
        ],
        [
            9,
            21,
            89
        ],
        [
            10,
            20,
            89
        ],
        [
            11,
            19,
            89
        ],
        [
            0,
            29,
            88
        ],
        [
            1,
            27,
            88
        ],
        [
            2,
            29,
            88
        ],
        [
            3,
            28,
            88
        ],
        [
            4,
            28,
            88
        ],
        [
            5,
            26,
            88
        ]
    ],
    2056: [
        [
            6,
            14,
            90
        ],
        [
            7,
            12,
            90
        ],
        [
            8,
            11,
            90
        ],
        [
            9,
            10,
            90
        ],
        [
            10,
            8,
            90
        ],
        [
            11,
            8,
            90
        ],
        [
            0,
            18,
            89
        ],
        [
            1,
            17,
            89
        ],
        [
            2,
            17,
            89
        ],
        [
            3,
            16,
            89
        ],
        [
            4,
            16,
            89
        ],
        [
            5,
            14,
            89
        ]
    ],
    2057: [
        [
            6,
            3,
            91
        ],
        [
            7,
            1,
            91
        ],
        [
            7,
            31,
            91
        ],
        [
            8,
            30,
            91
        ],
        [
            9,
            29,
            91
        ],
        [
            10,
            27,
            91
        ],
        [
            0,
            6,
            90,
            11,
            27,
            91
        ],
        [
            1,
            5,
            90
        ],
        [
            2,
            6,
            90
        ],
        [
            3,
            5,
            90
        ],
        [
            4,
            5,
            90
        ],
        [
            5,
            3,
            90
        ]
    ],
    2058: [
        [
            5,
            22,
            92
        ],
        [
            6,
            21,
            92
        ],
        [
            7,
            20,
            92
        ],
        [
            8,
            19,
            92
        ],
        [
            9,
            18,
            92
        ],
        [
            10,
            17,
            92
        ],
        [
            11,
            17,
            92
        ],
        [
            0,
            25,
            91
        ],
        [
            1,
            24,
            91
        ],
        [
            2,
            25,
            91
        ],
        [
            3,
            24,
            91
        ],
        [
            4,
            23,
            91
        ]
    ],
    2059: [
        [
            5,
            11,
            93
        ],
        [
            6,
            11,
            93
        ],
        [
            7,
            9,
            93
        ],
        [
            8,
            8,
            93
        ],
        [
            9,
            8,
            93
        ],
        [
            10,
            6,
            93
        ],
        [
            11,
            6,
            93
        ],
        [
            0,
            15,
            92
        ],
        [
            1,
            14,
            92
        ],
        [
            2,
            15,
            92
        ],
        [
            3,
            13,
            92
        ],
        [
            4,
            13,
            92
        ]
    ],
    2060: [
        [
            4,
            31,
            94
        ],
        [
            5,
            29,
            94
        ],
        [
            6,
            28,
            94
        ],
        [
            7,
            27,
            94
        ],
        [
            8,
            26,
            94
        ],
        [
            9,
            25,
            94
        ],
        [
            10,
            24,
            94
        ],
        [
            0,
            5,
            93,
            11,
            24,
            94
        ],
        [
            1,
            3,
            93
        ],
        [
            2,
            4,
            93
        ],
        [
            3,
            2,
            93
        ],
        [
            4,
            1,
            93
        ]
    ],
    2061: [
        [
            4,
            20,
            95
        ],
        [
            5,
            19,
            95
        ],
        [
            6,
            18,
            95
        ],
        [
            7,
            16,
            95
        ],
        [
            8,
            15,
            95
        ],
        [
            9,
            15,
            95
        ],
        [
            10,
            13,
            95
        ],
        [
            11,
            13,
            95
        ],
        [
            0,
            23,
            94
        ],
        [
            1,
            21,
            94
        ],
        [
            2,
            23,
            94
        ],
        [
            3,
            21,
            94
        ]
    ],
    2062: [
        [
            4,
            10,
            96
        ],
        [
            5,
            8,
            96
        ],
        [
            6,
            8,
            96
        ],
        [
            7,
            6,
            96
        ],
        [
            8,
            4,
            96
        ],
        [
            9,
            4,
            96
        ],
        [
            10,
            3,
            96
        ],
        [
            11,
            2,
            96
        ],
        [
            0,
            12,
            95
        ],
        [
            1,
            10,
            95
        ],
        [
            2,
            12,
            95
        ],
        [
            3,
            11,
            95
        ]
    ],
    2063: [
        [
            3,
            30,
            97
        ],
        [
            4,
            29,
            97
        ],
        [
            5,
            27,
            97
        ],
        [
            6,
            27,
            97
        ],
        [
            7,
            25,
            97
        ],
        [
            8,
            24,
            97
        ],
        [
            9,
            23,
            97
        ],
        [
            10,
            22,
            97
        ],
        [
            0,
            1,
            96,
            11,
            21,
            97
        ],
        [
            0,
            31,
            96
        ],
        [
            2,
            1,
            96
        ],
        [
            2,
            31,
            96
        ]
    ],
    2064: [
        [
            3,
            18,
            98
        ],
        [
            4,
            17,
            98
        ],
        [
            5,
            16,
            98
        ],
        [
            6,
            15,
            98
        ],
        [
            7,
            14,
            98
        ],
        [
            8,
            12,
            98
        ],
        [
            9,
            12,
            98
        ],
        [
            10,
            10,
            98
        ],
        [
            11,
            9,
            98
        ],
        [
            0,
            20,
            97
        ],
        [
            1,
            18,
            97
        ],
        [
            2,
            19,
            97
        ]
    ],
    2065: [
        [
            3,
            7,
            99
        ],
        [
            4,
            6,
            99
        ],
        [
            5,
            5,
            99
        ],
        [
            6,
            5,
            99
        ],
        [
            7,
            3,
            99
        ],
        [
            8,
            2,
            99
        ],
        [
            9,
            1,
            99
        ],
        [
            9,
            31,
            99
        ],
        [
            10,
            29,
            99
        ],
        [
            0,
            8,
            98,
            11,
            28,
            99
        ],
        [
            1,
            6,
            98
        ],
        [
            2,
            8,
            98
        ]
    ],
    2066: [
        [
            2,
            27,
            100
        ],
        [
            3,
            25,
            100
        ],
        [
            4,
            25,
            100
        ],
        [
            5,
            24,
            100
        ],
        [
            6,
            24,
            100
        ],
        [
            7,
            22,
            100
        ],
        [
            8,
            21,
            100
        ],
        [
            9,
            20,
            100
        ],
        [
            10,
            19,
            100
        ],
        [
            11,
            18,
            100
        ],
        [
            0,
            27,
            99
        ],
        [
            1,
            25,
            99
        ]
    ],
    2067: [
        [
            2,
            16,
            101
        ],
        [
            3,
            15,
            101
        ],
        [
            4,
            14,
            101
        ],
        [
            5,
            13,
            101
        ],
        [
            6,
            13,
            101
        ],
        [
            7,
            11,
            101
        ],
        [
            8,
            10,
            101
        ],
        [
            9,
            10,
            101
        ],
        [
            10,
            8,
            101
        ],
        [
            11,
            8,
            101
        ],
        [
            0,
            16,
            100
        ],
        [
            1,
            15,
            100
        ]
    ],
    2068: [
        [
            2,
            5,
            102
        ],
        [
            3,
            3,
            102
        ],
        [
            4,
            3,
            102
        ],
        [
            5,
            1,
            102
        ],
        [
            6,
            1,
            102
        ],
        [
            6,
            30,
            102
        ],
        [
            7,
            29,
            102
        ],
        [
            8,
            28,
            102
        ],
        [
            9,
            27,
            102
        ],
        [
            10,
            26,
            102
        ],
        [
            0,
            6,
            101,
            11,
            25,
            102
        ],
        [
            1,
            4,
            101
        ]
    ],
    2069: [
        [
            1,
            23,
            103
        ],
        [
            2,
            24,
            103
        ],
        [
            3,
            22,
            103
        ],
        [
            4,
            22,
            103
        ],
        [
            5,
            20,
            103
        ],
        [
            6,
            20,
            103
        ],
        [
            7,
            18,
            103
        ],
        [
            8,
            17,
            103
        ],
        [
            9,
            16,
            103
        ],
        [
            10,
            15,
            103
        ],
        [
            11,
            15,
            103
        ],
        [
            0,
            24,
            102
        ]
    ],
    2070: [
        [
            1,
            12,
            104
        ],
        [
            2,
            14,
            104
        ],
        [
            3,
            12,
            104
        ],
        [
            4,
            11,
            104
        ],
        [
            5,
            10,
            104
        ],
        [
            6,
            9,
            104
        ],
        [
            7,
            8,
            104
        ],
        [
            8,
            6,
            104
        ],
        [
            9,
            5,
            104
        ],
        [
            10,
            4,
            104
        ],
        [
            11,
            4,
            104
        ],
        [
            0,
            13,
            103
        ]
    ],
    2071: [
        [
            1,
            1,
            105
        ],
        [
            2,
            3,
            105
        ],
        [
            3,
            2,
            105
        ],
        [
            4,
            1,
            105
        ],
        [
            4,
            30,
            105
        ],
        [
            5,
            29,
            105
        ],
        [
            6,
            28,
            105
        ],
        [
            7,
            26,
            105
        ],
        [
            8,
            25,
            105
        ],
        [
            9,
            24,
            105
        ],
        [
            10,
            23,
            105
        ],
        [
            0,
            2,
            104,
            11,
            22,
            105
        ]
    ],
    2072: [
        [
            0,
            21,
            106
        ],
        [
            1,
            20,
            106
        ],
        [
            2,
            21,
            106
        ],
        [
            3,
            19,
            106
        ],
        [
            4,
            19,
            106
        ],
        [
            5,
            17,
            106
        ],
        [
            6,
            17,
            106
        ],
        [
            7,
            15,
            106
        ],
        [
            8,
            13,
            106
        ],
        [
            9,
            13,
            106
        ],
        [
            10,
            11,
            106
        ],
        [
            11,
            11,
            106
        ]
    ],
    2073: [
        [
            0,
            9,
            107,
            11,
            30,
            108
        ],
        [
            1,
            8,
            107
        ],
        [
            2,
            10,
            107
        ],
        [
            3,
            9,
            107
        ],
        [
            4,
            8,
            107
        ],
        [
            5,
            7,
            107
        ],
        [
            6,
            6,
            107
        ],
        [
            7,
            5,
            107
        ],
        [
            8,
            3,
            107
        ],
        [
            9,
            2,
            107
        ],
        [
            10,
            1,
            107
        ],
        [
            10,
            30,
            107
        ]
    ],
    2074: [
        [
            11,
            19,
            109
        ],
        [
            0,
            28,
            108
        ],
        [
            1,
            27,
            108
        ],
        [
            2,
            29,
            108
        ],
        [
            3,
            27,
            108
        ],
        [
            4,
            27,
            108
        ],
        [
            5,
            26,
            108
        ],
        [
            6,
            25,
            108
        ],
        [
            7,
            23,
            108
        ],
        [
            8,
            22,
            108
        ],
        [
            9,
            21,
            108
        ],
        [
            10,
            20,
            108
        ]
    ],
    2075: [
        [
            11,
            9,
            110
        ],
        [
            0,
            18,
            109
        ],
        [
            1,
            16,
            109
        ],
        [
            2,
            18,
            109
        ],
        [
            3,
            16,
            109
        ],
        [
            4,
            16,
            109
        ],
        [
            5,
            15,
            109
        ],
        [
            6,
            14,
            109
        ],
        [
            7,
            13,
            109
        ],
        [
            8,
            11,
            109
        ],
        [
            9,
            11,
            109
        ],
        [
            10,
            9,
            109
        ]
    ],
    2076: [
        [
            10,
            27,
            111
        ],
        [
            0,
            7,
            110,
            11,
            27,
            111
        ],
        [
            1,
            6,
            110
        ],
        [
            2,
            6,
            110
        ],
        [
            3,
            5,
            110
        ],
        [
            4,
            4,
            110
        ],
        [
            5,
            3,
            110
        ],
        [
            6,
            2,
            110
        ],
        [
            7,
            1,
            110
        ],
        [
            7,
            30,
            110
        ],
        [
            8,
            29,
            110
        ],
        [
            9,
            29,
            110
        ]
    ],
    2077: [
        null,
        null,
        [
            0,
            26,
            111
        ],
        [
            1,
            24,
            111
        ],
        [
            2,
            25,
            111
        ],
        [
            3,
            24,
            111
        ],
        [
            4,
            23,
            111
        ],
        [
            5,
            21,
            111
        ],
        [
            6,
            21,
            111
        ],
        [
            7,
            19,
            111
        ],
        [
            8,
            18,
            111
        ],
        [
            9,
            18,
            111
        ]
    ],
    year: 1389
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9OXlM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Jalaali);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _jalaaliJs = require("jalaali-js");
var _jalaaliJsDefault = parcelHelpers.interopDefault(_jalaaliJs);
const { toJalaali, toGregorian } = (0, _jalaaliJsDefault.default);
class Jalaali extends (0, _calEventJsDefault.default) {
    /**
   * @param {number} year gregorian year
   * @returns
   */ inYear(year) {
        const nowruz = toJalaali(year, 1, 1);
        if (this.opts.year && nowruz.jy !== this.opts.year) return this;
        const { gy, gm, gd } = toGregorian(this.opts.year || nowruz.jy, this.opts.month, this.opts.day);
        const d = new (0, _caldateDefault.default)({
            year: gy,
            month: gm,
            day: gd
        }).setOffset(this.offset);
        this.dates.push(d);
        return this;
    }
}

},{"caldate":"dgF7z","./CalEvent.js":"dCRj3","jalaali-js":"6hCh0","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6hCh0":[function(require,module,exports) {
/*
  Expose functions.
*/ module.exports = {
    toJalaali: toJalaali,
    toGregorian: toGregorian,
    isValidJalaaliDate: isValidJalaaliDate,
    isLeapJalaaliYear: isLeapJalaaliYear,
    jalaaliMonthLength: jalaaliMonthLength,
    jalCal: jalCal,
    j2d: j2d,
    d2j: d2j,
    g2d: g2d,
    d2g: d2g,
    jalaaliToDateObject: jalaaliToDateObject,
    jalaaliWeek: jalaaliWeek
};
/*
  Jalaali years starting the 33-year rule.
*/ var breaks = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
/*
  Converts a Gregorian date to Jalaali.
*/ function toJalaali(gy, gm, gd) {
    if (Object.prototype.toString.call(gy) === "[object Date]") {
        gd = gy.getDate();
        gm = gy.getMonth() + 1;
        gy = gy.getFullYear();
    }
    return d2j(g2d(gy, gm, gd));
}
/*
  Converts a Jalaali date to Gregorian.
*/ function toGregorian(jy, jm, jd) {
    return d2g(j2d(jy, jm, jd));
}
/*
  Checks whether a Jalaali date is valid or not.
*/ function isValidJalaaliDate(jy, jm, jd) {
    return jy >= -61 && jy <= 3177 && jm >= 1 && jm <= 12 && jd >= 1 && jd <= jalaaliMonthLength(jy, jm);
}
/*
  Is this a leap year or not?
*/ function isLeapJalaaliYear(jy) {
    return jalCalLeap(jy) === 0;
}
/*
  Number of days in a given month in a Jalaali year.
*/ function jalaaliMonthLength(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    if (isLeapJalaaliYear(jy)) return 30;
    return 29;
}
/*
    This function determines if the Jalaali (Persian) year is
    leap (366-day long) or is the common year (365 days)

    @param jy Jalaali calendar year (-61 to 3177)
    @returns number of years since the last leap year (0 to 4)
 */ function jalCalLeap(jy) {
    var bl = breaks.length, jp = breaks[0], jm, jump, leap, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        jp = jm;
    }
    n = jy - jp;
    if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) leap = 4;
    return leap;
}
/*
  This function determines if the Jalaali (Persian) year is
  leap (366-day long) or is the common year (365 days), and
  finds the day in March (Gregorian calendar) of the first
  day of the Jalaali year (jy).

  @param jy Jalaali calendar year (-61 to 3177)
  @param withoutLeap when don't need leap (true or false) default is false
  @return
    leap: number of years since the last leap year (0 to 4)
    gy: Gregorian year of the beginning of Jalaali year
    march: the March day of Farvardin the 1st (1st day of jy)
  @see: http://www.astro.uni.torun.pl/~kb/Papers/EMP/PersianC-EMP.htm
  @see: http://www.fourmilab.ch/documents/calendar/
*/ function jalCal(jy, withoutLeap) {
    var bl = breaks.length, gy = jy + 621, leapJ = -14, jp = breaks[0], jm, jump, leap, leapG, march, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error("Invalid Jalaali year " + jy);
    // Find the limiting years for the Jalaali year jy.
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
        jp = jm;
    }
    n = jy - jp;
    // Find the number of leap years from AD 621 to the beginning
    // of the current Jalaali year in the Persian calendar.
    leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
    if (mod(jump, 33) === 4 && jump - n === 4) leapJ += 1;
    // And the same in the Gregorian calendar (until the year gy).
    leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
    // Determine the Gregorian date of Farvardin the 1st.
    march = 20 + leapJ - leapG;
    // return with gy and march when we don't need leap
    if (withoutLeap) return {
        gy: gy,
        march: march
    };
    // Find how many years have passed since the last leap year.
    if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) leap = 4;
    return {
        leap: leap,
        gy: gy,
        march: march
    };
}
/*
  Converts a date of the Jalaali calendar to the Julian Day number.

  @param jy Jalaali year (1 to 3100)
  @param jm Jalaali month (1 to 12)
  @param jd Jalaali day (1 to 29/31)
  @return Julian Day number
*/ function j2d(jy, jm, jd) {
    var r = jalCal(jy, true);
    return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
/*
  Converts the Julian Day number to a date in the Jalaali calendar.

  @param jdn Julian Day number
  @return
    jy: Jalaali year (1 to 3100)
    jm: Jalaali month (1 to 12)
    jd: Jalaali day (1 to 29/31)
*/ function d2j(jdn) {
    var gy = d2g(jdn).gy // Calculate Gregorian year (gy).
    , jy = gy - 621, r = jalCal(jy, false), jdn1f = g2d(gy, 3, r.march), jd, jm, k;
    // Find number of days that passed since 1 Farvardin.
    k = jdn - jdn1f;
    if (k >= 0) {
        if (k <= 185) {
            // The first 6 months.
            jm = 1 + div(k, 31);
            jd = mod(k, 31) + 1;
            return {
                jy: jy,
                jm: jm,
                jd: jd
            };
        } else // The remaining months.
        k -= 186;
    } else {
        // Previous Jalaali year.
        jy -= 1;
        k += 179;
        if (r.leap === 1) k += 1;
    }
    jm = 7 + div(k, 30);
    jd = mod(k, 30) + 1;
    return {
        jy: jy,
        jm: jm,
        jd: jd
    };
}
/*
  Calculates the Julian Day number from Gregorian or Julian
  calendar dates. This integer number corresponds to the noon of
  the date (i.e. 12 hours of Universal Time).
  The procedure was tested to be good since 1 March, -100100 (of both
  calendars) up to a few million years into the future.

  @param gy Calendar year (years BC numbered 0, -1, -2, ...)
  @param gm Calendar month (1 to 12)
  @param gd Calendar day of the month (1 to 28/29/30/31)
  @return Julian Day number
*/ function g2d(gy, gm, gd) {
    var d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
    d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
    return d;
}
/*
  Calculates Gregorian and Julian calendar dates from the Julian Day number
  (jdn) for the period since jdn=-34839655 (i.e. the year -100100 of both
  calendars) to some millions years ahead of the present.

  @param jdn Julian Day number
  @return
    gy: Calendar year (years BC numbered 0, -1, -2, ...)
    gm: Calendar month (1 to 12)
    gd: Calendar day of the month M (1 to 28/29/30/31)
*/ function d2g(jdn) {
    var j, i, gd, gm, gy;
    j = 4 * jdn + 139361631;
    j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
    i = div(mod(j, 1461), 4) * 5 + 308;
    gd = div(mod(i, 153), 5) + 1;
    gm = mod(div(i, 153), 12) + 1;
    gy = div(j, 1461) - 100100 + div(8 - gm, 6);
    return {
        gy: gy,
        gm: gm,
        gd: gd
    };
}
/**
 * Return Saturday and Friday day of current week(week start in Saturday)
 * @param {number} jy jalaali year
 * @param {number} jm jalaali month
 * @param {number} jd jalaali day
 * @returns Saturday and Friday of current week
 */ function jalaaliWeek(jy, jm, jd) {
    var dayOfWeek = jalaaliToDateObject(jy, jm, jd).getDay();
    var startDayDifference = dayOfWeek == 6 ? 0 : -(dayOfWeek + 1);
    var endDayDifference = 6 + startDayDifference;
    return {
        saturday: d2j(j2d(jy, jm, jd + startDayDifference)),
        friday: d2j(j2d(jy, jm, jd + endDayDifference))
    };
}
/**
 * Convert Jalaali calendar dates to javascript Date object
 * @param {number} jy jalaali year
 * @param {number} jm jalaali month
 * @param {number} jd jalaali day
 * @param {number} [h] hours
 * @param {number} [m] minutes
 * @param {number} [s] seconds
 * @param {number} [ms] milliseconds
 * @returns Date object of the jalaali calendar dates
 */ function jalaaliToDateObject(jy, jm, jd, h, m, s, ms) {
    var gregorianCalenderDate = toGregorian(jy, jm, jd);
    return new Date(gregorianCalenderDate.gy, gregorianCalenderDate.gm - 1, gregorianCalenderDate.gd, h || 0, m || 0, s || 0, ms || 0);
}
/*
  Utility helper functions.
*/ function div(a, b) {
    return ~~(a / b);
}
function mod(a, b) {
    return a - ~~(a / b) * b;
}

},{}],"gEKQD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Equinox);
var _astronomia = require("astronomia");
var _vsop87BearthJs = require("./vsop87Bearth.js");
var _momentTimezone = require("moment-timezone");
var _momentTimezoneDefault = parcelHelpers.interopDefault(_momentTimezone);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
const earth = new (0, _astronomia.planetposition).Planet((0, _vsop87BearthJs.vsop87Bearth));
class Equinox extends (0, _calEventJsDefault.default) {
    inYear(year) {
        let jde;
        switch(this._season){
            case "march":
                jde = (0, _astronomia.solstice).march2(year, earth);
                break;
            case "june":
                jde = (0, _astronomia.solstice).june2(year, earth);
                break;
            case "september":
                jde = (0, _astronomia.solstice).september2(year, earth);
                break;
            case "december":
                jde = (0, _astronomia.solstice).december2(year, earth);
                break;
        }
        const str = new (0, _astronomia.julian).Calendar().fromJDE(jde).toDate().toISOString();
        let date;
        if (/^[+-]\d{2}:\d{2}?$/.test(this._timezone)) date = (0, _momentTimezoneDefault.default)(str).utcOffset(this._timezone);
        else date = (0, _momentTimezoneDefault.default)(str).tz(this._timezone) // move to timezone
        ;
        const floorDate = {
            year,
            month: date.month() + 1,
            day: date.date()
        };
        const d = new (0, _caldateDefault.default)(floorDate).setOffset(this.offset);
        this.dates.push(d);
        return this;
    }
    /**
   * @param {object} [opts]
   * @param {string} opts.season - type of season (spring|summer|autumn|winter)
   * @param {number|string} opts.offset - offset in days
   */ constructor(opts){
        opts = opts || {};
        super(opts);
        this._season = opts.season;
        this._timezone = opts.timezone || "GMT";
    }
}

},{"astronomia":"1WNVu","./vsop87Bearth.js":"cYdEa","moment-timezone":"crvQd","caldate":"dgF7z","./CalEvent.js":"dCRj3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cYdEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vsop87Bearth", ()=>vsop87Bearth);
var _vsop87Bearth = require("astronomia/data/vsop87Bearth");
var _vsop87BearthDefault = parcelHelpers.interopDefault(_vsop87Bearth);
const vsop87Bearth = (0, _vsop87BearthDefault.default);

},{"astronomia/data/vsop87Bearth":"hIa37","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hIa37":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const m = {
    L: {
        "0": [
            [
                1.75347045673,
                0,
                0
            ],
            [
                0.03341656453,
                4.66925680415,
                6283.0758499914
            ],
            [
                0.00034894275,
                4.62610242189,
                12566.1516999828
            ],
            [
                0.00003417572,
                2.82886579754,
                3.523118349
            ],
            [
                0.00003497056,
                2.74411783405,
                5753.3848848968
            ],
            [
                0.00003135899,
                3.62767041756,
                77713.7714681205
            ],
            [
                0.00002676218,
                4.41808345438,
                7860.4193924392
            ],
            [
                0.00002342691,
                6.13516214446,
                3930.2096962196
            ],
            [
                0.00001273165,
                2.03709657878,
                529.6909650946
            ],
            [
                0.00001324294,
                0.74246341673,
                11506.7697697936
            ],
            [
                0.00000901854,
                2.04505446477,
                26.2983197998
            ],
            [
                0.00001199167,
                1.10962946234,
                1577.3435424478
            ],
            [
                0.00000857223,
                3.50849152283,
                398.1490034082
            ],
            [
                0.00000779786,
                1.17882681962,
                5223.6939198022
            ],
            [
                0.0000099025,
                5.23268072088,
                5884.9268465832
            ],
            [
                0.00000753141,
                2.53339052847,
                5507.5532386674
            ],
            [
                0.00000505267,
                4.58292599973,
                18849.2275499742
            ],
            [
                0.00000492392,
                4.20505711826,
                775.522611324
            ],
            [
                0.00000356672,
                2.91954114478,
                0.0673103028
            ],
            [
                0.00000284125,
                1.89869240932,
                796.2980068164
            ],
            [
                0.00000242879,
                0.34481445893,
                5486.777843175
            ],
            [
                0.00000317087,
                5.84901948512,
                11790.6290886588
            ],
            [
                0.00000271112,
                0.31486255375,
                10977.078804699
            ],
            [
                0.00000206217,
                4.80646631478,
                2544.3144198834
            ],
            [
                0.00000205478,
                1.86953770281,
                5573.1428014331
            ],
            [
                0.00000202318,
                2.45767790232,
                6069.7767545534
            ],
            [
                0.00000126225,
                1.08295459501,
                20.7753954924
            ],
            [
                0.00000155516,
                0.83306084617,
                213.299095438
            ],
            [
                0.00000115132,
                0.64544911683,
                0.9803210682
            ],
            [
                0.00000102851,
                0.63599845579,
                4694.0029547076
            ],
            [
                0.00000101724,
                4.2667980198,
                7.1135470008
            ],
            [
                9.9206e-7,
                6.20992926918,
                2146.1654164752
            ],
            [
                0.00000132212,
                3.41118292683,
                2942.4634232916
            ],
            [
                9.7607e-7,
                0.68101342359,
                155.4203994342
            ],
            [
                8.5128e-7,
                1.29870764804,
                6275.9623029906
            ],
            [
                7.4651e-7,
                1.755089133,
                5088.6288397668
            ],
            [
                0.00000101895,
                0.97569280312,
                15720.8387848784
            ],
            [
                8.4711e-7,
                3.67080093031,
                71430.69561812909
            ],
            [
                7.3547e-7,
                4.67926633877,
                801.8209311238
            ],
            [
                7.3874e-7,
                3.50319414955,
                3154.6870848956
            ],
            [
                7.8757e-7,
                3.03697458703,
                12036.4607348882
            ],
            [
                7.9637e-7,
                1.80791287082,
                17260.1546546904
            ],
            [
                8.5803e-7,
                5.9832263126,
                161000.6857376741
            ],
            [
                5.6963e-7,
                2.78430458592,
                6286.5989683404
            ],
            [
                6.1148e-7,
                1.81839892984,
                7084.8967811152
            ],
            [
                6.9627e-7,
                0.83297621398,
                9437.762934887
            ],
            [
                5.6116e-7,
                4.38694865354,
                14143.4952424306
            ],
            [
                6.2449e-7,
                3.97763912806,
                8827.3902698748
            ],
            [
                5.1145e-7,
                0.28306832879,
                5856.4776591154
            ],
            [
                5.5577e-7,
                3.47006059924,
                6279.5527316424
            ],
            [
                4.1036e-7,
                5.36817592855,
                8429.2412664666
            ],
            [
                5.1605e-7,
                1.33282739866,
                1748.016413067
            ],
            [
                5.1992e-7,
                0.18914947184,
                12139.5535091068
            ],
            [
                4.9e-7,
                0.48735014197,
                1194.4470102246
            ],
            [
                3.92e-7,
                6.16833020996,
                10447.3878396044
            ],
            [
                3.557e-7,
                1.775968892,
                6812.766815086
            ],
            [
                3.677e-7,
                6.04133863162,
                10213.285546211
            ],
            [
                3.6596e-7,
                2.56957481827,
                1059.3819301892
            ],
            [
                3.3296e-7,
                0.59310278598,
                17789.845619785
            ],
            [
                3.5954e-7,
                1.70875808777,
                2352.8661537718
            ],
            [
                4.0938e-7,
                2.39850938714,
                19651.048481098
            ],
            [
                3.0047e-7,
                2.73975124088,
                1349.8674096588
            ],
            [
                3.0412e-7,
                0.44294464169,
                83996.84731811189
            ],
            [
                2.3663e-7,
                0.48473622521,
                8031.0922630584
            ],
            [
                2.3574e-7,
                2.06528133162,
                3340.6124266998
            ],
            [
                2.1089e-7,
                4.14825468851,
                951.7184062506
            ],
            [
                2.4738e-7,
                0.21484762138,
                3.5904286518
            ],
            [
                2.5352e-7,
                3.16470891653,
                4690.4798363586
            ],
            [
                2.2823e-7,
                5.22195230819,
                4705.7323075436
            ],
            [
                2.1419e-7,
                1.42563910473,
                16730.4636895958
            ],
            [
                2.1891e-7,
                5.55594302779,
                553.5694028424
            ],
            [
                1.7481e-7,
                4.56052900312,
                135.0650800354
            ],
            [
                1.9927e-7,
                5.22209149316,
                12168.0026965746
            ],
            [
                1.986e-7,
                5.77470242235,
                6309.3741697912
            ],
            [
                2.03e-7,
                0.37133792946,
                283.8593188652
            ],
            [
                1.4421e-7,
                4.19315052005,
                242.728603974
            ],
            [
                1.6225e-7,
                5.98837767951,
                11769.8536931664
            ],
            [
                1.5077e-7,
                4.1956716337,
                6256.7775301916
            ],
            [
                1.9124e-7,
                3.82219958698,
                23581.2581773176
            ],
            [
                1.8888e-7,
                5.38626892076,
                149854.4001348079
            ],
            [
                1.4346e-7,
                3.72355084422,
                38.0276726358
            ],
            [
                1.7898e-7,
                2.21490566029,
                13367.9726311066
            ],
            [
                1.2054e-7,
                2.62229602614,
                955.5997416086
            ],
            [
                1.1287e-7,
                0.17739329984,
                4164.311989613
            ],
            [
                1.3973e-7,
                4.40134615007,
                6681.2248533996
            ],
            [
                1.3621e-7,
                1.88934516495,
                7632.9432596502
            ],
            [
                1.2503e-7,
                1.13052412208,
                5.5229243074
            ],
            [
                1.0498e-7,
                5.35909979317,
                1592.5960136328
            ],
            [
                9.803e-8,
                0.99948172646,
                11371.7046897582
            ],
            [
                9.22e-8,
                4.57138585348,
                4292.3308329504
            ],
            [
                1.0327e-7,
                6.19982170609,
                6438.4962494256
            ],
            [
                1.2003e-7,
                1.00351462266,
                632.7837393132
            ],
            [
                1.0827e-7,
                0.32734523824,
                103.0927742186
            ],
            [
                8.356e-8,
                4.53902748706,
                25132.3033999656
            ],
            [
                1.0005e-7,
                6.0291496328,
                5746.271337896
            ],
            [
                8.409e-8,
                3.29946177848,
                7234.794256242
            ],
            [
                8.006e-8,
                5.82145271855,
                28.4491874678
            ],
            [
                1.0523e-7,
                0.93870455544,
                11926.2544136688
            ],
            [
                7.686e-8,
                3.1214364064,
                7238.6755916
            ],
            [
                9.378e-8,
                2.62413793196,
                5760.4984318976
            ],
            [
                8.127e-8,
                6.11227839253,
                4732.0306273434
            ],
            [
                9.232e-8,
                0.48344234496,
                522.5774180938
            ],
            [
                9.802e-8,
                5.24413877132,
                27511.4678735372
            ],
            [
                7.871e-8,
                0.99590133077,
                5643.1785636774
            ],
            [
                8.123e-8,
                6.27053020099,
                426.598190876
            ],
            [
                9.048e-8,
                5.33686323585,
                6386.16862421
            ],
            [
                8.621e-8,
                4.16537179089,
                7058.5984613154
            ],
            [
                6.297e-8,
                4.71723143652,
                6836.6452528338
            ],
            [
                7.575e-8,
                3.97381357237,
                11499.6562227928
            ],
            [
                7.756e-8,
                2.95728422442,
                23013.5395395872
            ],
            [
                7.314e-8,
                0.60652522715,
                11513.8833167944
            ],
            [
                5.955e-8,
                2.87641047954,
                6283.14316029419
            ],
            [
                6.534e-8,
                5.79046406784,
                18073.7049386502
            ],
            [
                7.188e-8,
                3.99831461988,
                74.7815985673
            ],
            [
                7.346e-8,
                4.38582423903,
                316.3918696566
            ],
            [
                5.413e-8,
                5.39199023275,
                419.4846438752
            ],
            [
                5.127e-8,
                2.36059551778,
                10973.55568635
            ],
            [
                7.056e-8,
                0.32258442532,
                263.0839233728
            ],
            [
                6.624e-8,
                3.6647416584,
                17298.1823273262
            ],
            [
                6.762e-8,
                5.91131766896,
                90955.5516944961
            ],
            [
                4.938e-8,
                5.73672172371,
                9917.6968745098
            ],
            [
                5.547e-8,
                2.45152589382,
                12352.8526045448
            ],
            [
                5.958e-8,
                3.3205134466,
                6283.0085396886
            ],
            [
                4.471e-8,
                2.06386138131,
                7079.3738568078
            ],
            [
                6.153e-8,
                1.45823347458,
                233141.3144043615
            ],
            [
                4.348e-8,
                4.42338625285,
                5216.5803728014
            ],
            [
                6.124e-8,
                1.07494838623,
                19804.8272915828
            ],
            [
                4.488e-8,
                3.65285033073,
                206.1855484372
            ],
            [
                4.02e-8,
                0.83995823171,
                20.3553193988
            ],
            [
                5.188e-8,
                4.06503864016,
                6208.2942514241
            ],
            [
                5.307e-8,
                0.38216728132,
                31441.6775697568
            ],
            [
                3.785e-8,
                2.34369213733,
                3.881335358
            ],
            [
                4.497e-8,
                3.27230792447,
                11015.1064773348
            ],
            [
                4.132e-8,
                0.92129851256,
                3738.761430108
            ],
            [
                3.521e-8,
                5.9784480361,
                3894.1818295422
            ],
            [
                4.215e-8,
                1.90601721876,
                245.8316462294
            ],
            [
                3.701e-8,
                5.03067498875,
                536.8045120954
            ],
            [
                3.866e-8,
                1.82632980909,
                11856.2186514245
            ],
            [
                3.652e-8,
                1.01840564429,
                16200.7727245012
            ],
            [
                3.39e-8,
                0.97784870142,
                8635.9420037632
            ],
            [
                3.737e-8,
                2.9537891957,
                3128.3887650958
            ],
            [
                3.507e-8,
                3.71291946317,
                6290.1893969922
            ],
            [
                3.086e-8,
                3.64646921512,
                10.6366653498
            ],
            [
                3.397e-8,
                1.10589356888,
                14712.317116458
            ],
            [
                3.334e-8,
                0.83684903082,
                6496.3749454294
            ],
            [
                2.805e-8,
                2.58503711584,
                14314.1681130498
            ],
            [
                3.65e-8,
                1.08344142571,
                88860.05707098669
            ],
            [
                3.388e-8,
                3.20182380957,
                5120.6011455836
            ],
            [
                3.252e-8,
                3.47857474229,
                6133.5126528568
            ],
            [
                2.553e-8,
                3.9486902726,
                1990.745017041
            ],
            [
                3.52e-8,
                2.05559692878,
                244287.60000722768
            ],
            [
                2.565e-8,
                1.56072409371,
                23543.23050468179
            ],
            [
                2.621e-8,
                3.85639359951,
                266.6070417218
            ],
            [
                2.954e-8,
                3.39692614359,
                9225.539273283
            ],
            [
                2.876e-8,
                6.02633318445,
                154717.6098876827
            ],
            [
                2.395e-8,
                1.16130078696,
                10984.1923516998
            ],
            [
                3.161e-8,
                1.32798862116,
                10873.9860304804
            ],
            [
                3.163e-8,
                5.08946546862,
                21228.3920235458
            ],
            [
                2.361e-8,
                4.27212461943,
                6040.3472460174
            ],
            [
                3.03e-8,
                1.80210001168,
                35371.8872659764
            ],
            [
                2.343e-8,
                3.57688971514,
                10969.9652576982
            ],
            [
                2.618e-8,
                2.57870151918,
                22483.84857449259
            ],
            [
                2.113e-8,
                3.71711179417,
                65147.6197681377
            ],
            [
                2.019e-8,
                0.81393923319,
                170.6728706192
            ],
            [
                2.003e-8,
                0.38091017375,
                6172.869528772
            ],
            [
                2.506e-8,
                3.74378169126,
                10575.4066829418
            ],
            [
                2.381e-8,
                0.10581361289,
                7.046236698
            ],
            [
                1.949e-8,
                4.86892513469,
                36.0278666774
            ],
            [
                2.074e-8,
                4.22802468213,
                5650.2921106782
            ],
            [
                1.924e-8,
                5.59460549844,
                6282.0955289232
            ],
            [
                1.949e-8,
                1.06999605576,
                5230.807466803
            ],
            [
                1.988e-8,
                5.19734705445,
                6262.300454499
            ],
            [
                1.887e-8,
                3.74365662683,
                23.8784377478
            ],
            [
                1.787e-8,
                1.25929659066,
                12559.038152982
            ],
            [
                1.883e-8,
                1.90364058477,
                15.252471185
            ],
            [
                1.816e-8,
                3.68083794819,
                15110.4661198662
            ],
            [
                1.701e-8,
                4.41109562589,
                110.2063212194
            ],
            [
                1.99e-8,
                3.93295788548,
                6206.8097787158
            ],
            [
                2.103e-8,
                0.75354936681,
                13521.7514415914
            ],
            [
                1.774e-8,
                0.48750515837,
                1551.045222648
            ],
            [
                1.882e-8,
                0.86685462305,
                22003.9146348698
            ],
            [
                1.924e-8,
                1.22901099088,
                709.9330485583
            ],
            [
                2.073e-8,
                4.62531597856,
                6037.244203762
            ],
            [
                1.924e-8,
                0.60231842492,
                6284.0561710596
            ],
            [
                1.596e-8,
                3.98332879712,
                13916.0191096416
            ],
            [
                1.664e-8,
                4.41947015623,
                8662.240323563
            ],
            [
                1.971e-8,
                1.04560686192,
                18209.33026366019
            ],
            [
                1.942e-8,
                4.31335979989,
                6244.9428143536
            ],
            [
                1.476e-8,
                0.93274523818,
                2379.1644735716
            ],
            [
                1.81e-8,
                0.49112137707,
                1.4844727083
            ],
            [
                1.346e-8,
                1.51574753411,
                4136.9104335162
            ],
            [
                1.528e-8,
                5.61833568587,
                6127.6554505572
            ],
            [
                1.791e-8,
                3.22191142746,
                39302.096962196
            ],
            [
                1.747e-8,
                3.05595292589,
                18319.5365848796
            ],
            [
                1.432e-8,
                4.51123984264,
                20426.571092422
            ],
            [
                1.695e-8,
                0.22049418623,
                25158.6017197654
            ],
            [
                1.242e-8,
                4.46665354536,
                17256.6315363414
            ],
            [
                1.463e-8,
                4.69248613506,
                14945.3161735544
            ],
            [
                1.205e-8,
                1.86911906771,
                4590.910180489
            ],
            [
                1.19e-8,
                2.74169967367,
                12569.6748183318
            ],
            [
                1.222e-8,
                5.18120087481,
                5333.9002410216
            ],
            [
                1.39e-8,
                5.42888623322,
                143571.32428481648
            ],
            [
                1.473e-8,
                1.70487100866,
                11712.9553182308
            ],
            [
                1.362e-8,
                2.61069503292,
                6062.6632075526
            ],
            [
                1.148e-8,
                6.0300843061,
                3634.6210245184
            ],
            [
                1.198e-8,
                5.15296117339,
                10177.2576795336
            ],
            [
                1.266e-8,
                0.11422490557,
                18422.62935909819
            ],
            [
                1.411e-8,
                1.09910890045,
                3496.032826134
            ],
            [
                1.349e-8,
                2.99804623019,
                17654.7805397496
            ],
            [
                1.253e-8,
                2.79844902576,
                167283.7615876655
            ],
            [
                1.311e-8,
                1.609410743,
                5481.2549188676
            ],
            [
                1.079e-8,
                6.20304501787,
                3.2863574178
            ],
            [
                1.181e-8,
                1.20653777627,
                131.5419616864
            ],
            [
                1.254e-8,
                5.45103277799,
                6076.8903015542
            ],
            [
                1.036e-8,
                2.32136959491,
                7342.4577801806
            ],
            [
                1.117e-8,
                0.38842340979,
                949.1756089698
            ],
            [
                9.66e-9,
                3.18352079941,
                11087.2851259184
            ],
            [
                1.171e-8,
                3.39635167732,
                12562.6285816338
            ],
            [
                1.121e-8,
                0.72631814699,
                220.4126424388
            ],
            [
                1.024e-8,
                2.19381113265,
                11403.676995575
            ],
            [
                8.88e-9,
                3.91167196431,
                4686.8894077068
            ],
            [
                9.1e-9,
                1.98802695087,
                735.8765135318
            ],
            [
                8.23e-9,
                0.48822202854,
                24072.9214697764
            ],
            [
                1.096e-8,
                6.17377835617,
                5436.9930152402
            ],
            [
                9.08e-9,
                0.44959148878,
                7477.522860216
            ],
            [
                9.74e-9,
                1.52996313552,
                9623.6882766912
            ],
            [
                8.4e-9,
                1.79540573407,
                5429.8794682394
            ],
            [
                7.78e-9,
                6.17703744517,
                38.1330356378
            ],
            [
                7.76e-9,
                4.09859968447,
                14.2270940016
            ],
            [
                1.068e-8,
                4.64209577648,
                43232.3066584156
            ],
            [
                9.54e-9,
                1.49985885818,
                1162.4747044078
            ],
            [
                9.07e-9,
                0.86986870809,
                10344.2950653858
            ],
            [
                9.31e-9,
                4.06049877517,
                28766.924424484
            ],
            [
                7.39e-9,
                5.04368192034,
                639.897286314
            ],
            [
                9.65e-9,
                3.44286716197,
                1589.0728952838
            ],
            [
                7.63e-9,
                5.86304776787,
                16858.4825329332
            ],
            [
                9.53e-9,
                4.20801492835,
                11190.377900137
            ],
            [
                7.08e-9,
                1.72432323967,
                13095.8426650774
            ],
            [
                9.69e-9,
                1.64437243011,
                29088.811415985
            ],
            [
                7.17e-9,
                0.16688678895,
                11.729352836
            ],
            [
                9.62e-9,
                3.53101876172,
                12416.5885028482
            ],
            [
                7.45e-9,
                5.77741082302,
                12592.4500197826
            ],
            [
                6.72e-9,
                1.91091228744,
                3.9321532631
            ],
            [
                6.71e-9,
                5.46240758839,
                18052.9295431578
            ],
            [
                6.75e-9,
                6.28311649798,
                4535.0594369244
            ],
            [
                6.84e-9,
                0.39975011401,
                5849.3641121146
            ],
            [
                7.99e-9,
                0.29859056777,
                12132.439962106
            ],
            [
                7.58e-9,
                0.96370719224,
                1052.2683831884
            ],
            [
                7.82e-9,
                5.33875702541,
                13517.8701062334
            ],
            [
                7.3e-9,
                1.70114998543,
                17267.26820169119
            ],
            [
                7.49e-9,
                2.59607005624,
                11609.8625440122
            ],
            [
                7.34e-9,
                2.7842049778,
                640.8776073822
            ],
            [
                6.88e-9,
                5.15097673557,
                16496.3613962024
            ],
            [
                7.7e-9,
                1.62459252416,
                4701.1165017084
            ],
            [
                6.33e-9,
                2.20588443066,
                25934.1243310894
            ],
            [
                7.6e-9,
                4.21317219403,
                377.3736079158
            ],
            [
                5.84e-9,
                2.13420121623,
                10557.5941608238
            ],
            [
                5.72e-9,
                0.24649745829,
                9779.1086761254
            ],
            [
                5.73e-9,
                3.16435264609,
                533.2140834436
            ],
            [
                6.85e-9,
                3.19344289472,
                12146.6670561076
            ],
            [
                6.75e-9,
                0.96179234176,
                10454.5013866052
            ],
            [
                6.48e-9,
                1.46327342554,
                6268.8487559898
            ],
            [
                5.89e-9,
                2.50543543638,
                3097.88382272579
            ],
            [
                5.51e-9,
                5.28106257475,
                9388.0059094152
            ],
            [
                6.96e-9,
                3.6534215555,
                4804.209275927
            ],
            [
                6.69e-9,
                2.5103005926,
                2388.8940204492
            ],
            [
                5.5e-9,
                0.06883090057,
                20199.094959633
            ],
            [
                6.29e-9,
                4.13350997495,
                45892.73043315699
            ],
            [
                6.78e-9,
                6.09190163533,
                135.62532501
            ],
            [
                5.93e-9,
                1.50129499103,
                226858.23855437007
            ],
            [
                5.42e-9,
                3.58582033525,
                6148.010769956
            ],
            [
                5.99e-9,
                6.12058050643,
                18875.525869774
            ],
            [
                6.82e-9,
                5.0221361683,
                17253.04110768959
            ],
            [
                5.65e-9,
                4.29309214275,
                11933.3679606696
            ],
            [
                4.86e-9,
                0.77746204893,
                27.4015560968
            ],
            [
                5.03e-9,
                0.58974557727,
                15671.0817594066
            ],
            [
                6.16e-9,
                4.06539884128,
                227.476132789
            ],
            [
                5.37e-9,
                2.15064382406,
                21954.15760939799
            ],
            [
                6.69e-9,
                6.06995500278,
                47162.5163546352
            ],
            [
                5.4e-9,
                2.83444221432,
                5326.7866940208
            ],
            [
                4.74e-9,
                0.40346826846,
                6915.8595893046
            ],
            [
                5.32e-9,
                5.26131065063,
                10988.808157535
            ],
            [
                5.82e-9,
                3.24533095664,
                153.7788104848
            ],
            [
                6.41e-9,
                3.24711790399,
                2107.0345075424
            ],
            [
                6.19e-9,
                3.08302108547,
                33019.0211122046
            ],
            [
                4.66e-9,
                3.14982369789,
                10440.2742926036
            ],
            [
                4.66e-9,
                0.90708835651,
                5966.6839803348
            ],
            [
                5.28e-9,
                0.8192645447,
                813.5502839598
            ],
            [
                6.03e-9,
                3.81378921927,
                316428.22867391503
            ],
            [
                5.59e-9,
                1.8189498573,
                17996.0311682222
            ],
            [
                4.37e-9,
                2.28631745987,
                6303.8512454838
            ],
            [
                5.18e-9,
                4.86068318058,
                20597.2439630412
            ],
            [
                4.24e-9,
                6.23520018697,
                6489.2613984286
            ],
            [
                5.18e-9,
                6.17617826756,
                0.2438174835
            ],
            [
                4.04e-9,
                5.72804304258,
                5642.1982426092
            ],
            [
                4.58e-9,
                1.34117773914,
                6287.0080032545
            ],
            [
                5.48e-9,
                5.6845445832,
                155427.542936241
            ],
            [
                5.47e-9,
                1.03391472434,
                3646.3503773544
            ],
            [
                4.28e-9,
                4.6980968782,
                846.0828347512
            ],
            [
                4.13e-9,
                6.0252069939,
                6279.4854213396
            ],
            [
                5.34e-9,
                3.03030638223,
                66567.48586525429
            ],
            [
                3.83e-9,
                1.4905558804,
                19800.9459562248
            ],
            [
                4.11e-9,
                5.28384176408,
                18451.07854656599
            ],
            [
                3.52e-9,
                4.68891600525,
                4907.3020501456
            ],
            [
                4.8e-9,
                5.36572651091,
                348.924420448
            ],
            [
                3.44e-9,
                5.89157452889,
                6546.1597733642
            ],
            [
                3.4e-9,
                0.37557440365,
                13119.72110282519
            ],
            [
                4.34e-9,
                4.98417856239,
                6702.5604938666
            ],
            [
                3.32e-9,
                2.6890934443,
                29296.6153895786
            ],
            [
                4.48e-9,
                2.16478480251,
                5905.7022420756
            ],
            [
                3.44e-9,
                2.06546633735,
                49.7570254718
            ],
            [
                3.15e-9,
                1.24023810969,
                4061.2192153944
            ],
            [
                3.24e-9,
                2.30897526929,
                5017.508371365
            ],
            [
                4.13e-9,
                0.17171692945,
                6286.6662786432
            ],
            [
                4.31e-9,
                3.8660110138,
                12489.8856287072
            ],
            [
                3.49e-9,
                4.55372493131,
                4933.2084403326
            ],
            [
                3.23e-9,
                0.41971136084,
                10770.8932562618
            ],
            [
                3.41e-9,
                2.68612860807,
                11.0457002639
            ],
            [
                3.16e-9,
                3.52966641606,
                17782.7320727842
            ],
            [
                3.15e-9,
                5.63357264999,
                568.8218740274
            ],
            [
                3.4e-9,
                3.83571212349,
                10660.6869350424
            ],
            [
                2.96e-9,
                0.62703270489,
                20995.3929664494
            ],
            [
                4.05e-9,
                1.00084965393,
                16460.33352952499
            ],
            [
                4.14e-9,
                1.21998752076,
                51092.7260508548
            ],
            [
                3.36e-9,
                4.71465945215,
                6179.9830757728
            ],
            [
                3.61e-9,
                3.71235613733,
                28237.2334593894
            ],
            [
                3.27e-9,
                1.05606504715,
                11919.140866668
            ],
            [
                3.27e-9,
                6.1422242098,
                6254.6266625236
            ],
            [
                2.68e-9,
                2.47224339737,
                664.75604513
            ],
            [
                2.69e-9,
                1.86210872453,
                23141.5583829246
            ],
            [
                3.45e-9,
                0.93461290184,
                6058.7310542895
            ],
            [
                3.53e-9,
                4.50033650657,
                36949.2308084242
            ],
            [
                3.44e-9,
                6.26166140367,
                24356.7807886416
            ],
            [
                3e-9,
                4.46964001975,
                6418.1409300268
            ],
            [
                2.6e-9,
                4.04967464725,
                6525.8044539654
            ],
            [
                2.98e-9,
                2.20018811054,
                156137.47598479927
            ],
            [
                2.53e-9,
                3.49930797865,
                29864.334027309
            ],
            [
                2.54e-9,
                2.44883530154,
                5331.3574437408
            ],
            [
                2.96e-9,
                0.84341183907,
                5729.506447149
            ],
            [
                2.41e-9,
                2.00721298729,
                16737.5772365966
            ],
            [
                3.11e-9,
                1.23668016336,
                6281.5913772831
            ],
            [
                3.32e-9,
                3.55576945724,
                7668.6374249425
            ],
            [
                2.36e-9,
                2.47437156031,
                6245.0481773556
            ],
            [
                2.64e-9,
                4.43924412283,
                12964.300703391
            ],
            [
                2.57e-9,
                1.79654471948,
                11080.1715789176
            ],
            [
                2.6e-9,
                3.3307759606,
                5888.4499649322
            ],
            [
                2.85e-9,
                0.3088636143,
                11823.1616394502
            ],
            [
                2.9e-9,
                5.70141882483,
                77.673770428
            ],
            [
                2.55e-9,
                4.00939662024,
                5881.4037282342
            ],
            [
                2.53e-9,
                4.73318512715,
                16723.350142595
            ],
            [
                2.28e-9,
                0.95333661324,
                5540.0857894588
            ],
            [
                2.81e-9,
                1.29199646396,
                22805.7355659936
            ],
            [
                3.19e-9,
                1.38633229189,
                163096.18036118348
            ],
            [
                2.24e-9,
                1.65156322696,
                10027.9031957292
            ],
            [
                2.26e-9,
                0.34125379653,
                17796.9591667858
            ],
            [
                2.36e-9,
                4.19817431922,
                19.66976089979
            ],
            [
                2.81e-9,
                4.14114899916,
                12539.853380183
            ],
            [
                2.75e-9,
                5.50306930248,
                32.5325507914
            ],
            [
                2.23e-9,
                5.23334210294,
                56.8983749356
            ],
            [
                2.17e-9,
                6.08598789777,
                6805.6532680852
            ],
            [
                2.28e-9,
                5.17114391778,
                11720.0688652316
            ],
            [
                2.74e-9,
                4.50716805713,
                6016.4688082696
            ],
            [
                2.45e-9,
                3.96486270306,
                22.7752014508
            ],
            [
                2.2e-9,
                4.7207808197,
                6.62855890001
            ],
            [
                2.07e-9,
                5.71701403951,
                41.5507909848
            ],
            [
                2.04e-9,
                3.9122741125,
                2699.7348193176
            ],
            [
                2.09e-9,
                0.86881969024,
                6321.1035226272
            ],
            [
                2e-9,
                2.11984442601,
                4274.5183108324
            ],
            [
                2e-9,
                5.39839888151,
                6019.9919266186
            ],
            [
                2.09e-9,
                5.67606291663,
                11293.4706743556
            ],
            [
                2.52e-9,
                1.6496572935,
                9380.9596727172
            ],
            [
                2.75e-9,
                5.04826903506,
                73.297125859
            ],
            [
                2.08e-9,
                1.88207277133,
                11300.5842213564
            ],
            [
                2.06e-9,
                5.0728488933,
                6277.552925684
            ],
            [
                2.72e-9,
                0.74640924904,
                1975.492545856
            ],
            [
                1.99e-9,
                3.30813142103,
                22743.4093795164
            ],
            [
                2.69e-9,
                4.48560812155,
                64471.99124174489
            ],
            [
                1.92e-9,
                2.17463565107,
                5863.5912061162
            ],
            [
                2.28e-9,
                5.85373115869,
                128.0188433374
            ],
            [
                2.61e-9,
                2.64321183295,
                55022.9357470744
            ],
            [
                1.96e-9,
                2.4853762232,
                16062.1845261168
            ],
            [
                1.87e-9,
                1.3189176028,
                29826.3063546732
            ],
            [
                2.2e-9,
                5.75012110079,
                29.429508536
            ],
            [
                1.87e-9,
                4.03230554718,
                467.9649903544
            ],
            [
                2e-9,
                5.60555262896,
                1066.49547719
            ],
            [
                2.31e-9,
                1.09802712785,
                12341.8069042809
            ],
            [
                1.98e-9,
                0.29474229005,
                149.5631971346
            ],
            [
                2.49e-9,
                5.1047702317,
                7875.6718636242
            ],
            [
                1.79e-9,
                0.87066197995,
                12721.572099417
            ],
            [
                2.03e-9,
                1.56914310573,
                28286.9904848612
            ],
            [
                1.98e-9,
                3.54061588502,
                30.914125635
            ],
            [
                1.71e-9,
                3.45366018621,
                5327.4761083828
            ],
            [
                1.83e-9,
                0.72325421604,
                6272.0301497275
            ],
            [
                2.16e-9,
                2.97175184412,
                19402.7969528166
            ],
            [
                1.68e-9,
                2.51559879907,
                23937.856389741
            ],
            [
                1.95e-9,
                0.09045393425,
                156.4007205024
            ],
            [
                2.16e-9,
                0.42162375972,
                23539.7073863328
            ],
            [
                1.89e-9,
                0.37542530191,
                9814.6041002912
            ],
            [
                2.07e-9,
                2.01752547259,
                238004.5241572363
            ],
            [
                2.18e-9,
                2.36835893645,
                16627.3709153772
            ],
            [
                1.66e-9,
                4.23182960518,
                16840.67001081519
            ],
            [
                2e-9,
                2.02153258098,
                16097.6799502826
            ],
            [
                1.69e-9,
                0.91318727,
                95.9792272178
            ],
            [
                2.11e-9,
                5.73370637657,
                151.8972810852
            ],
            [
                2.04e-9,
                0.42643085174,
                515.463871093
            ],
            [
                2.12e-9,
                3.00223140894,
                12043.574281889
            ],
            [
                1.92e-9,
                5.46153589821,
                6379.0550772092
            ],
            [
                1.6e-9,
                6.23798383332,
                202.2533951741
            ],
            [
                2.15e-9,
                0.20889073407,
                5621.8429232104
            ],
            [
                1.5e-9,
                3.12999753018,
                799.8211251654
            ],
            [
                1.87e-9,
                2.12345787867,
                491.6632924588
            ],
            [
                1.92e-9,
                1.33928820063,
                394.6258850592
            ],
            [
                1.49e-9,
                2.65697593276,
                21.335640467
            ],
            [
                1.46e-9,
                5.58021191726,
                412.3710968744
            ],
            [
                1.56e-9,
                3.7565767638,
                12323.4230960088
            ],
            [
                1.43e-9,
                3.28248547724,
                29.8214381488
            ],
            [
                1.44e-9,
                1.07862546598,
                1265.5674786264
            ],
            [
                1.48e-9,
                0.2338663109,
                10021.8372800994
            ],
            [
                1.64e-9,
                0.94288727597,
                14919.0178537546
            ],
            [
                1.93e-9,
                5.92751083827,
                40879.4405046438
            ],
            [
                1.4e-9,
                4.97612440269,
                158.9435177832
            ],
            [
                1.48e-9,
                2.61651818006,
                17157.0618804718
            ],
            [
                1.4e-9,
                3.66947933935,
                26084.0218062162
            ],
            [
                1.47e-9,
                5.09968173403,
                661.232926781
            ],
            [
                1.47e-9,
                1.36976712162,
                4171.4255366138
            ],
            [
                1.34e-9,
                4.79432636012,
                111.1866422876
            ],
            [
                1.4e-9,
                1.27748013377,
                107.6635239386
            ],
            [
                1.71e-9,
                2.77586207403,
                26735.9452622132
            ],
            [
                1.83e-9,
                5.43418358741,
                369.6998159404
            ],
            [
                1.34e-9,
                3.09132862833,
                17.812522118
            ],
            [
                1.32e-9,
                3.05633896779,
                22490.9621214934
            ],
            [
                1.81e-9,
                4.22950689891,
                966.9708774356
            ],
            [
                1.66e-9,
                3.67660435776,
                15508.6151232744
            ],
            [
                1.52e-9,
                5.28885813387,
                12669.2444742014
            ],
            [
                1.5e-9,
                5.86819430895,
                97238.62754448749
            ],
            [
                1.45e-9,
                5.07330784304,
                87.30820453981
            ],
            [
                1.33e-9,
                5.65471067133,
                31.9723058168
            ],
            [
                1.24e-9,
                2.83326216907,
                12566.2190102856
            ],
            [
                1.4e-9,
                5.84212721453,
                22476.73502749179
            ],
            [
                1.34e-9,
                3.12858101887,
                32217.2001810808
            ],
            [
                1.37e-9,
                0.86487461904,
                9924.8104215106
            ],
            [
                1.72e-9,
                1.98369595114,
                174242.4659640497
            ],
            [
                1.7e-9,
                4.41115280254,
                327574.51427678124
            ],
            [
                1.28e-9,
                4.49087631612,
                31415.379249957
            ],
            [
                1.51e-9,
                0.46542092001,
                39609.6545831656
            ],
            [
                1.53e-9,
                3.78801830344,
                17363.24742890899
            ],
            [
                1.65e-9,
                5.31654110459,
                16943.7627850338
            ],
            [
                1.65e-9,
                4.06747587817,
                58953.145443294
            ],
            [
                1.18e-9,
                0.63846333239,
                6.0659156298
            ],
            [
                1.59e-9,
                0.86086959274,
                221995.02880149524
            ],
            [
                1.19e-9,
                5.96432932413,
                1385.8952763362
            ],
            [
                1.14e-9,
                5.16516114595,
                25685.872802808
            ],
            [
                1.12e-9,
                4.92889233335,
                56.8032621698
            ],
            [
                1.19e-9,
                2.40626699328,
                18635.9284545362
            ],
            [
                1.15e-9,
                0.23374479051,
                418.9243989006
            ],
            [
                1.13e-9,
                2.7938757674,
                6272.4391846416
            ],
            [
                1.22e-9,
                0.936940724,
                24492.40611365159
            ],
            [
                1.33e-9,
                4.87155573413,
                22345.2603761082
            ],
            [
                1.13e-9,
                3.80362889046,
                6293.7125153412
            ],
            [
                1.3e-9,
                3.72996018683,
                12573.2652469836
            ],
            [
                1.07e-9,
                3.40227152756,
                21393.5419698576
            ],
            [
                1.22e-9,
                1.00385670948,
                95143.1329209781
            ],
            [
                1.4e-9,
                1.094130757,
                44809.6502008634
            ],
            [
                1.12e-9,
                6.05462382871,
                433.7117378768
            ],
            [
                1.23e-9,
                4.55640196386,
                239424.39025435288
            ],
            [
                1.04e-9,
                1.54931540602,
                127.9515330346
            ],
            [
                1.11e-9,
                3.04186517428,
                8982.810669309
            ],
            [
                1.02e-9,
                4.12448497391,
                15664.03552270859
            ],
            [
                1.07e-9,
                4.67919356465,
                77690.75950573849
            ],
            [
                1.18e-9,
                4.5232017012,
                19004.6479494084
            ],
            [
                1.07e-9,
                5.71774478555,
                77736.78343050249
            ],
            [
                1.03e-9,
                4.79332126649,
                33794.5437235286
            ],
            [
                1.43e-9,
                1.81201813018,
                4214.0690150848
            ],
            [
                1.02e-9,
                3.7581778657,
                58864.5439181463
            ],
            [
                1.25e-9,
                1.14419195615,
                625.6701923124
            ],
            [
                1.24e-9,
                3.27736513892,
                12566.08438968
            ],
            [
                1.1e-9,
                1.08705709966,
                2787.0430238574
            ],
            [
                1.02e-9,
                4.75119578149,
                12242.6462833254
            ],
            [
                1.01e-9,
                4.91289409429,
                401.6721217572
            ],
            [
                1.38e-9,
                2.89578979744,
                9411.4646150872
            ],
            [
                1.29e-9,
                1.23516042371,
                12029.3471878874
            ],
            [
                1.38e-9,
                2.45654707076,
                7576.560073574
            ],
            [
                9.8e-10,
                5.4477176502,
                29026.48522950779
            ],
            [
                1.34e-9,
                1.43105174912,
                86464.6133168312
            ],
            [
                1.08e-9,
                0.9898977494,
                5636.0650166766
            ],
            [
                1.17e-9,
                5.17362847134,
                34520.3093093808
            ],
            [
                9.7e-10,
                3.34717130592,
                16310.9790457206
            ],
            [
                1.07e-9,
                2.94547931851,
                24602.61243487099
            ],
            [
                9.8e-10,
                4.37041908717,
                34513.2630726828
            ],
            [
                1.25e-9,
                2.72182830814,
                24065.80792277559
            ],
            [
                1.11e-9,
                0.58899131543,
                6303.4311693902
            ],
            [
                1.02e-9,
                0.66938025772,
                10239.5838660108
            ],
            [
                1.19e-9,
                1.21666517886,
                1478.8665740644
            ],
            [
                1.11e-9,
                1.04321934681,
                16522.6597160022
            ],
            [
                9.4e-10,
                4.31076339857,
                26880.3198130326
            ],
            [
                9.8e-10,
                4.14248433763,
                6599.467719648
            ],
            [
                9.5e-10,
                2.89807657534,
                34911.412076091
            ],
            [
                9.7e-10,
                0.89642320201,
                71980.63357473118
            ],
            [
                9.5e-10,
                0.65717727948,
                6288.5987742988
            ],
            [
                1.16e-9,
                4.19967201116,
                206.7007372966
            ],
            [
                9.5e-10,
                1.78315464297,
                18139.2945014159
            ],
            [
                9.9e-10,
                1.37437847718,
                1039.0266107904
            ],
            [
                1.26e-9,
                3.21642544972,
                305281.9430710488
            ],
            [
                9.4e-10,
                0.6899503186,
                7834.1210726394
            ],
            [
                9.5e-10,
                5.58111421744,
                3104.9300594238
            ],
            [
                1.08e-9,
                0.52696637156,
                276.7457718644
            ],
            [
                1.24e-9,
                3.43899862683,
                172146.9713405403
            ],
            [
                8.7e-10,
                1.18764938806,
                18842.11400297339
            ],
            [
                8.7e-10,
                0.09094166389,
                15141.390794312
            ],
            [
                1.08e-9,
                1.03363414379,
                82576.9812209953
            ],
            [
                1.19e-9,
                2.86729109648,
                90394.82301305079
            ],
            [
                1.04e-9,
                3.39218586218,
                290.972865866
            ],
            [
                9.4e-10,
                5.68284937444,
                32367.0976562076
            ],
            [
                1.17e-9,
                0.78475956902,
                83286.91426955358
            ],
            [
                1.05e-9,
                3.96551057233,
                6357.8574485587
            ],
            [
                9.4e-10,
                4.03443174853,
                13341.6743113068
            ],
            [
                9.6e-10,
                0.92742567538,
                1062.9050485382
            ],
            [
                8.9e-10,
                4.45371820659,
                792.7748884674
            ],
            [
                8.7e-10,
                0.40013481685,
                90279.92316810328
            ],
            [
                1.13e-9,
                2.48165313368,
                48739.859897083
            ],
            [
                8.7e-10,
                3.43122851097,
                27707.5424942948
            ],
            [
                1.01e-9,
                5.32081603011,
                2301.58581590939
            ],
            [
                8.4e-10,
                0.67020912458,
                28628.3362260996
            ],
            [
                8.2e-10,
                0.87060089842,
                10241.2022911672
            ],
            [
                8.6e-10,
                4.6206479229,
                36147.4098773004
            ],
            [
                8e-10,
                4.77649625396,
                6819.8803620868
            ],
            [
                9.5e-10,
                2.87032913492,
                23020.65308658799
            ],
            [
                1.07e-9,
                5.77864921649,
                34115.1140692746
            ],
            [
                1.1e-9,
                3.32898859416,
                72140.6286666874
            ],
            [
                8.7e-10,
                4.40657711727,
                142.1786270362
            ],
            [
                1.03e-9,
                4.2250672681,
                30666.1549584328
            ],
            [
                8.2e-10,
                3.89404392552,
                5547.1993364596
            ],
            [
                1.09e-9,
                1.94546065204,
                24279.10701821359
            ],
            [
                8.7e-10,
                4.32472045435,
                742.9900605326
            ],
            [
                1.07e-9,
                4.91580912547,
                277.0349937414
            ],
            [
                8.8e-10,
                2.10180817713,
                26482.1708096244
            ],
            [
                8.6e-10,
                4.01895021483,
                12491.3701014155
            ],
            [
                1.06e-9,
                5.49092372854,
                62883.3551395136
            ],
            [
                8e-10,
                6.1978570495,
                6709.6740408674
            ],
            [
                1.05e-9,
                2.44166529175,
                6298.3283211764
            ],
            [
                8.3e-10,
                4.90662164029,
                51.28033786241
            ],
            [
                7.4e-10,
                2.34622575625,
                7018.9523635232
            ],
            [
                7.8e-10,
                6.06947270265,
                148434.53403769128
            ],
            [
                7.9e-10,
                3.03048221644,
                838.9692877504
            ],
            [
                7.3e-10,
                3.05008665738,
                567.7186377304
            ],
            [
                1.02e-9,
                3.59223815483,
                22380.755800274
            ],
            [
                8.4e-10,
                0.46604373274,
                45.1412196366
            ],
            [
                9.2e-10,
                4.12917744733,
                18216.443810661
            ],
            [
                9.1e-10,
                0.49382398887,
                6453.7487206106
            ],
            [
                7.3e-10,
                1.72446569088,
                21424.4666443034
            ],
            [
                6.9e-10,
                1.4937267773,
                21548.9623692918
            ],
            [
                6.9e-10,
                4.73181018058,
                8858.3149443206
            ],
            [
                7.7e-10,
                0.47683782532,
                11520.9968637952
            ],
            [
                7.8e-10,
                5.4394263099,
                15265.8865193004
            ],
            [
                7.7e-10,
                2.53773750372,
                76.2660712756
            ],
            [
                6.9e-10,
                2.53932635192,
                9910.583327509
            ],
            [
                7.5e-10,
                0.1559472921,
                23006.42599258639
            ],
            [
                7.8e-10,
                2.41004950269,
                6393.2821712108
            ],
            [
                6.7e-10,
                5.05152846816,
                57375.8019008462
            ],
            [
                7.7e-10,
                3.9107560486,
                24383.0791084414
            ],
            [
                6.7e-10,
                0.78239147387,
                12779.4507954208
            ],
            [
                7.1e-10,
                1.24817900687,
                10419.9862835076
            ],
            [
                6.7e-10,
                5.7785122776,
                6311.5250374592
            ],
            [
                6.1e-10,
                2.66705754411,
                18852.7506683232
            ],
            [
                7.9e-10,
                1.89137330427,
                6528.9074962208
            ],
            [
                8.4e-10,
                5.11523704221,
                50317.2034395308
            ],
            [
                5.9e-10,
                3.38290426621,
                35707.7100829074
            ],
            [
                6.5e-10,
                4.66767908854,
                26709.6469424134
            ],
            [
                7.9e-10,
                5.59773848156,
                71960.38658322369
            ],
            [
                6.1e-10,
                3.30733768968,
                18845.7044316252
            ],
            [
                5.7e-10,
                3.90831298022,
                5999.2165311262
            ],
            [
                5.8e-10,
                3.92572820333,
                30348.883772767
            ],
            [
                6.1e-10,
                0.05695045822,
                7856.89627409019
            ],
            [
                6.1e-10,
                5.63297960691,
                7863.9425107882
            ],
            [
                6.8e-10,
                2.53986117507,
                20452.8694122218
            ],
            [
                5.3e-10,
                5.44021645443,
                32370.9789915656
            ],
            [
                5.9e-10,
                4.95695131145,
                11925.2740926006
            ],
            [
                5.9e-10,
                5.34668243273,
                137288.2484348251
            ],
            [
                5.6e-10,
                4.05779957425,
                17892.93839400359
            ],
            [
                5.3e-10,
                3.94182462468,
                18624.8827542723
            ],
            [
                4.9e-10,
                2.11782803206,
                22594.05489571199
            ],
            [
                6.2e-10,
                2.47154086715,
                12345.739057544
            ],
            [
                4.9e-10,
                5.7659693738,
                18606.4989460002
            ],
            [
                5.2e-10,
                6.20902099741,
                21947.1113727
            ],
            [
                5.1e-10,
                3.13287981215,
                33326.5787331742
            ],
            [
                5.7e-10,
                6.17003357597,
                61306.0115970658
            ],
            [
                6.4e-10,
                5.66596451842,
                34596.3646546524
            ],
            [
                6.6e-10,
                3.922623355,
                69853.3520756813
            ],
            [
                5.3e-10,
                5.51119362049,
                77710.24834977149
            ],
            [
                5.3e-10,
                4.88573986965,
                77717.29458646949
            ],
            [
                4.8e-10,
                2.71399112516,
                20760.4270331914
            ],
            [
                4.6e-10,
                6.08376164442,
                29822.7832363242
            ],
            [
                5.2e-10,
                0.3139748138,
                37724.7534197482
            ],
            [
                4.5e-10,
                5.53587248663,
                6262.7205305926
            ],
            [
                5.9e-10,
                2.45437896854,
                69166.430989505
            ],
            [
                6e-10,
                5.24261569842,
                56600.2792895222
            ],
            [
                5.1e-10,
                6.15794342172,
                11616.976091013
            ],
            [
                6e-10,
                1.74758109828,
                44034.1275895394
            ],
            [
                4.9e-10,
                5.08973141046,
                33990.6183442862
            ],
            [
                4.4e-10,
                3.28270864884,
                29424.634232916
            ],
            [
                5.2e-10,
                5.34866947943,
                28313.288804661
            ],
            [
                5.9e-10,
                2.12384971916,
                36173.7081971002
            ],
            [
                5e-10,
                0.46480931695,
                25287.7237993998
            ],
            [
                4.4e-10,
                2.0550351721,
                63658.8777508376
            ],
            [
                4.4e-10,
                1.71009200258,
                13362.4497067992
            ],
            [
                4.1e-10,
                3.91721318316,
                6279.1945146334
            ],
            [
                4.2e-10,
                1.52106001448,
                23550.34405168259
            ],
            [
                4.2e-10,
                3.10938258068,
                84672.47584450469
            ],
            [
                4.1e-10,
                3.78863023321,
                35050.00027447539
            ],
            [
                4.2e-10,
                5.57543459263,
                38500.2760310722
            ],
            [
                4e-10,
                5.55145719363,
                12565.1713789146
            ],
            [
                5.4e-10,
                0.889354921,
                50290.905119731
            ],
            [
                5.5e-10,
                2.50268487636,
                77828.671313068
            ],
            [
                5.4e-10,
                4.16257918787,
                22910.44676536859
            ],
            [
                4.1e-10,
                2.32141215064,
                6286.9571853494
            ],
            [
                4.5e-10,
                3.18590576311,
                45585.1728121874
            ],
            [
                4.5e-10,
                2.24348941683,
                23646.32327890039
            ],
            [
                4.3e-10,
                3.8789211095,
                6549.6828917132
            ],
            [
                4.8e-10,
                2.11364139445,
                31570.7996493912
            ],
            [
                4.3e-10,
                5.55099558987,
                12359.9661515456
            ],
            [
                4.1e-10,
                4.88191569433,
                23536.11695768099
            ],
            [
                4.9e-10,
                2.44790922235,
                13613.804277336
            ],
            [
                4.7e-10,
                3.5818169391,
                4797.0957289262
            ]
        ],
        "1": [
            [
                6283.0758499914,
                0,
                0
            ],
            [
                0.00206058863,
                2.67823455808,
                6283.0758499914
            ],
            [
                0.00004303419,
                2.63512233481,
                12566.1516999828
            ],
            [
                0.00000425264,
                1.59046982018,
                3.523118349
            ],
            [
                0.00000109017,
                2.96631010675,
                1577.3435424478
            ],
            [
                9.3479e-7,
                2.59211109542,
                18849.2275499742
            ],
            [
                0.00000119305,
                5.79555765566,
                26.2983197998
            ],
            [
                7.2121e-7,
                1.13840581212,
                529.6909650946
            ],
            [
                6.7784e-7,
                1.87453300345,
                398.1490034082
            ],
            [
                6.735e-7,
                4.40932832004,
                5507.5532386674
            ],
            [
                5.9045e-7,
                2.88815790631,
                5223.6939198022
            ],
            [
                5.5976e-7,
                2.17471740035,
                155.4203994342
            ],
            [
                4.5411e-7,
                0.39799502896,
                796.2980068164
            ],
            [
                3.6298e-7,
                0.46875437227,
                775.522611324
            ],
            [
                2.8962e-7,
                2.64732254645,
                7.1135470008
            ],
            [
                1.9097e-7,
                1.84628376049,
                5486.777843175
            ],
            [
                2.0844e-7,
                5.34138275149,
                0.9803210682
            ],
            [
                1.8508e-7,
                4.96855179468,
                213.299095438
            ],
            [
                1.6233e-7,
                0.03216587315,
                2544.3144198834
            ],
            [
                1.7293e-7,
                2.9911676063,
                6275.9623029906
            ],
            [
                1.5832e-7,
                1.43049301283,
                2146.1654164752
            ],
            [
                1.4608e-7,
                1.2046979369,
                10977.078804699
            ],
            [
                1.1877e-7,
                3.25805082007,
                5088.6288397668
            ],
            [
                1.1514e-7,
                2.07502080082,
                4694.0029547076
            ],
            [
                9.721e-8,
                4.2392586526,
                1349.8674096588
            ],
            [
                9.969e-8,
                1.30263423409,
                6286.5989683404
            ],
            [
                9.452e-8,
                2.69956827011,
                242.728603974
            ],
            [
                1.2461e-7,
                2.83432282119,
                1748.016413067
            ],
            [
                1.1808e-7,
                5.27379760438,
                1194.4470102246
            ],
            [
                8.577e-8,
                5.6447608598,
                951.7184062506
            ],
            [
                1.0641e-7,
                0.76614722966,
                553.5694028424
            ],
            [
                7.576e-8,
                5.30056172859,
                2352.8661537718
            ],
            [
                5.764e-8,
                1.77228445837,
                1059.3819301892
            ],
            [
                6.385e-8,
                2.65034514038,
                9437.762934887
            ],
            [
                5.223e-8,
                5.66135782131,
                71430.69561812909
            ],
            [
                5.315e-8,
                0.91110018969,
                3154.6870848956
            ],
            [
                6.101e-8,
                4.66633726278,
                4690.4798363586
            ],
            [
                4.335e-8,
                0.23934560382,
                6812.766815086
            ],
            [
                5.041e-8,
                1.42489704722,
                6438.4962494256
            ],
            [
                4.259e-8,
                0.77355543889,
                10447.3878396044
            ],
            [
                5.2e-8,
                1.85528830215,
                801.8209311238
            ],
            [
                3.744e-8,
                2.00119905572,
                8031.0922630584
            ],
            [
                3.553e-8,
                2.42789590229,
                14143.4952424306
            ],
            [
                3.372e-8,
                3.86210786421,
                1592.5960136328
            ],
            [
                3.38e-8,
                0.88545388924,
                12036.4607348882
            ],
            [
                3.196e-8,
                3.19713328141,
                4705.7323075436
            ],
            [
                3.221e-8,
                0.6160104899,
                8429.2412664666
            ],
            [
                4.132e-8,
                5.23992584671,
                7084.8967811152
            ],
            [
                2.97e-8,
                6.07029819073,
                4292.3308329504
            ],
            [
                2.9e-8,
                2.32464208411,
                20.3553193988
            ],
            [
                3.504e-8,
                4.79976712702,
                6279.5527316424
            ],
            [
                2.95e-8,
                1.43108874817,
                5746.271337896
            ],
            [
                2.697e-8,
                4.80365209201,
                7234.794256242
            ],
            [
                2.531e-8,
                6.22289990904,
                6836.6452528338
            ],
            [
                2.745e-8,
                0.93466065396,
                5760.4984318976
            ],
            [
                3.25e-8,
                3.39951915286,
                7632.9432596502
            ],
            [
                2.278e-8,
                5.00339914806,
                17789.845619785
            ],
            [
                2.076e-8,
                3.95551309007,
                10213.285546211
            ],
            [
                2.061e-8,
                2.2240771919,
                5856.4776591154
            ],
            [
                2.252e-8,
                5.67166717686,
                11499.6562227928
            ],
            [
                2.148e-8,
                5.20182663314,
                11513.8833167944
            ],
            [
                1.886e-8,
                0.53198539077,
                3340.6124266998
            ],
            [
                1.875e-8,
                4.73511969924,
                83996.84731811189
            ],
            [
                2.06e-8,
                2.54985307819,
                25132.3033999656
            ],
            [
                1.794e-8,
                1.47435300254,
                4164.311989613
            ],
            [
                1.778e-8,
                3.02473091781,
                5.5229243074
            ],
            [
                2.036e-8,
                0.90908165072,
                6256.7775301916
            ],
            [
                2.064e-8,
                2.27051326957,
                522.5774180938
            ],
            [
                1.773e-8,
                3.03090500693,
                5753.3848848968
            ],
            [
                1.569e-8,
                6.12406216872,
                5216.5803728014
            ],
            [
                1.59e-8,
                4.63713748247,
                3.2863574178
            ],
            [
                1.533e-8,
                4.20305593883,
                13367.9726311066
            ],
            [
                1.427e-8,
                1.19087535126,
                3894.1818295422
            ],
            [
                1.376e-8,
                4.24955891338,
                426.598190876
            ],
            [
                1.375e-8,
                3.09301252193,
                135.0650800354
            ],
            [
                1.308e-8,
                3.0849213889,
                5643.1785636774
            ],
            [
                1.34e-8,
                5.76513167968,
                6040.3472460174
            ],
            [
                1.25e-8,
                3.07748196332,
                11926.2544136688
            ],
            [
                1.551e-8,
                3.07664090662,
                6681.2248533996
            ],
            [
                1.148e-8,
                3.24144202282,
                12168.0026965746
            ],
            [
                1.268e-8,
                2.09201189992,
                6290.1893969922
            ],
            [
                1.248e-8,
                3.44506939791,
                536.8045120954
            ],
            [
                1.118e-8,
                2.31830078762,
                16730.4636895958
            ],
            [
                1.105e-8,
                5.31966001019,
                23.8784377478
            ],
            [
                1.012e-8,
                3.74953487087,
                7860.4193924392
            ],
            [
                1.025e-8,
                2.4468377161,
                1990.745017041
            ],
            [
                9.62e-9,
                0.81771017882,
                3.881335358
            ],
            [
                9.11e-9,
                0.41724352112,
                7079.3738568078
            ],
            [
                1.091e-8,
                3.98233608618,
                11506.7697697936
            ],
            [
                9.57e-9,
                4.07671436153,
                6127.6554505572
            ],
            [
                8.35e-9,
                5.28348689371,
                11790.6290886588
            ],
            [
                8.02e-9,
                3.88779080089,
                10973.55568635
            ],
            [
                7.73e-9,
                2.41044394817,
                1589.0728952838
            ],
            [
                7.58e-9,
                1.30034365873,
                103.0927742186
            ],
            [
                7.49e-9,
                4.96281442361,
                6496.3749454294
            ],
            [
                7.65e-9,
                3.36312388424,
                36.0278666774
            ],
            [
                9.15e-9,
                5.41549763095,
                206.1855484372
            ],
            [
                7.76e-9,
                2.57589060224,
                11371.7046897582
            ],
            [
                7.72e-9,
                3.98363364977,
                955.5997416086
            ],
            [
                7.49e-9,
                5.17900231417,
                10969.9652576982
            ],
            [
                8.06e-9,
                0.34226117299,
                9917.6968745098
            ],
            [
                7.28e-9,
                5.20962563787,
                38.0276726358
            ],
            [
                6.85e-9,
                2.77592961854,
                20.7753954924
            ],
            [
                6.36e-9,
                4.28242193632,
                28.4491874678
            ],
            [
                6.08e-9,
                5.63278510221,
                10984.1923516998
            ],
            [
                7.04e-9,
                5.60739437733,
                3738.761430108
            ],
            [
                6.85e-9,
                0.38876148682,
                15.252471185
            ],
            [
                6.01e-9,
                0.73489602442,
                419.4846438752
            ],
            [
                7.16e-9,
                2.65286869987,
                6309.3741697912
            ],
            [
                5.84e-9,
                5.54508741381,
                17298.1823273262
            ],
            [
                6.28e-9,
                1.11733054796,
                7058.5984613154
            ],
            [
                6.88e-9,
                2.59684132401,
                3496.032826134
            ],
            [
                4.85e-9,
                0.44470714066,
                12352.8526045448
            ],
            [
                5.62e-9,
                2.82510352358,
                3930.2096962196
            ],
            [
                5.97e-9,
                5.27675789973,
                10575.4066829418
            ],
            [
                5.83e-9,
                3.1893153986,
                4732.0306273434
            ],
            [
                5.26e-9,
                5.01737745304,
                5884.9268465832
            ],
            [
                5.4e-9,
                1.29182747488,
                640.8776073822
            ],
            [
                4.81e-9,
                5.49721461067,
                5230.807466803
            ],
            [
                4.06e-9,
                5.21253018484,
                220.4126424388
            ],
            [
                3.95e-9,
                1.87489912123,
                16200.7727245012
            ],
            [
                3.67e-9,
                0.88533542945,
                6283.14316029419
            ],
            [
                3.69e-9,
                3.84778078192,
                18073.7049386502
            ],
            [
                3.79e-9,
                0.37991716505,
                10177.2576795336
            ],
            [
                3.56e-9,
                3.84152910109,
                11712.9553182308
            ],
            [
                3.74e-9,
                5.01577520608,
                7.046236698
            ],
            [
                3.81e-9,
                4.30250406634,
                6062.6632075526
            ],
            [
                4.71e-9,
                0.86388942467,
                6069.7767545534
            ],
            [
                3.67e-9,
                1.3294383993,
                6283.0085396886
            ],
            [
                4.6e-9,
                5.19667219582,
                6284.0561710596
            ],
            [
                3.33e-9,
                5.54250425107,
                4686.8894077068
            ],
            [
                3.41e-9,
                4.36524495363,
                7238.6755916
            ],
            [
                3.36e-9,
                4.00205876835,
                3097.88382272579
            ],
            [
                3.59e-9,
                6.22679790284,
                245.8316462294
            ],
            [
                3.07e-9,
                2.35299010924,
                170.6728706192
            ],
            [
                3.43e-9,
                3.77164927142,
                6076.8903015542
            ],
            [
                2.96e-9,
                5.44138799494,
                17260.1546546904
            ],
            [
                3.28e-9,
                0.13817705132,
                11015.1064773348
            ],
            [
                2.69e-9,
                1.13308244952,
                12569.6748183318
            ],
            [
                2.63e-9,
                0.0055073751,
                4136.9104335162
            ],
            [
                2.82e-9,
                5.04399588559,
                7477.522860216
            ],
            [
                2.8e-9,
                3.13703211405,
                12559.038152982
            ],
            [
                2.59e-9,
                0.93882269388,
                5642.1982426092
            ],
            [
                2.92e-9,
                1.98426314297,
                12132.439962106
            ],
            [
                2.47e-9,
                3.84244798673,
                5429.8794682394
            ],
            [
                3.19e-9,
                5.0417014879,
                90617.7374312997
            ],
            [
                2.45e-9,
                5.70469737024,
                65147.6197681377
            ],
            [
                3.18e-9,
                1.35581968834,
                78051.5857313169
            ],
            [
                2.41e-9,
                0.99469787369,
                3634.6210245184
            ],
            [
                2.46e-9,
                3.06168069393,
                110.2063212194
            ],
            [
                2.39e-9,
                6.11854529589,
                11856.2186514245
            ],
            [
                2.67e-9,
                0.65297608414,
                21228.3920235458
            ],
            [
                2.62e-9,
                1.51070507866,
                12146.6670561076
            ],
            [
                2.3e-9,
                1.75923794017,
                9779.1086761254
            ],
            [
                2.23e-9,
                2.00967043606,
                6172.869528772
            ],
            [
                2.46e-9,
                1.10411690861,
                6282.0955289232
            ],
            [
                2.14e-9,
                4.03840492266,
                14314.1681130498
            ],
            [
                2.12e-9,
                2.13695623228,
                5849.3641121146
            ],
            [
                2.07e-9,
                3.07724246401,
                11.729352836
            ],
            [
                2.07e-9,
                6.10303325026,
                23543.23050468179
            ],
            [
                2.66e-9,
                1.00720021877,
                2388.8940204492
            ],
            [
                2.17e-9,
                6.27840212312,
                17267.26820169119
            ],
            [
                2.31e-9,
                5.37372783468,
                13916.0191096416
            ],
            [
                2.04e-9,
                2.34615348695,
                266.6070417218
            ],
            [
                1.95e-9,
                5.55015549753,
                6133.5126528568
            ],
            [
                2.03e-9,
                4.65616806503,
                24072.9214697764
            ],
            [
                1.88e-9,
                2.52682282169,
                6525.8044539654
            ],
            [
                1.77e-9,
                1.73426919199,
                154717.6098876827
            ],
            [
                1.87e-9,
                4.76501318048,
                4535.0594369244
            ],
            [
                1.86e-9,
                4.63080493407,
                10440.2742926036
            ],
            [
                1.83e-9,
                3.20060840641,
                8635.9420037632
            ],
            [
                1.72e-9,
                1.45551703877,
                9225.539273283
            ],
            [
                1.62e-9,
                3.30665137166,
                639.897286314
            ],
            [
                1.68e-9,
                2.17671416605,
                27.4015560968
            ],
            [
                1.6e-9,
                1.6816871275,
                15110.4661198662
            ],
            [
                1.94e-9,
                2.79243768345,
                7342.4577801806
            ],
            [
                1.83e-9,
                0.56273524797,
                13517.8701062334
            ],
            [
                1.72e-9,
                5.97039514134,
                4701.1165017084
            ],
            [
                1.79e-9,
                3.58450811616,
                87.30820453981
            ],
            [
                1.52e-9,
                2.84070476839,
                5650.2921106782
            ],
            [
                1.56e-9,
                1.07156076421,
                18319.5365848796
            ],
            [
                1.82e-9,
                0.44053620124,
                17253.04110768959
            ],
            [
                1.42e-9,
                1.4629013752,
                11087.2851259184
            ],
            [
                1.31e-9,
                5.40912137746,
                2699.7348193176
            ],
            [
                1.44e-9,
                2.07312089638,
                25158.6017197654
            ],
            [
                1.47e-9,
                6.15107800602,
                9623.6882766912
            ],
            [
                1.41e-9,
                5.55739979498,
                10454.5013866052
            ],
            [
                1.35e-9,
                0.0609812943,
                16723.350142595
            ],
            [
                1.23e-9,
                5.81194797368,
                17256.6315363414
            ],
            [
                1.24e-9,
                2.36269386269,
                4933.2084403326
            ],
            [
                1.26e-9,
                3.47483886466,
                22483.84857449259
            ],
            [
                1.59e-9,
                5.63944722033,
                5729.506447149
            ],
            [
                1.37e-9,
                1.93811728826,
                20426.571092422
            ],
            [
                1.23e-9,
                3.92815962825,
                17996.0311682222
            ],
            [
                1.48e-9,
                3.02542567608,
                1551.045222648
            ],
            [
                1.21e-9,
                0.05537321071,
                13095.8426650774
            ],
            [
                1.2e-9,
                5.91904349732,
                6206.8097787158
            ],
            [
                1.34e-9,
                3.11122937825,
                21954.15760939799
            ],
            [
                1.19e-9,
                5.52143897201,
                709.9330485583
            ],
            [
                1.22e-9,
                3.00840036775,
                19800.9459562248
            ],
            [
                1.27e-9,
                1.37534182407,
                14945.3161735544
            ],
            [
                1.41e-9,
                2.56886299638,
                1052.2683831884
            ],
            [
                1.23e-9,
                2.83671175442,
                11919.140866668
            ],
            [
                1.18e-9,
                0.81918292547,
                5331.3574437408
            ],
            [
                1.51e-9,
                2.68728567951,
                11769.8536931664
            ],
            [
                1.19e-9,
                5.08654046247,
                5481.2549188676
            ],
            [
                1.13e-9,
                4.42675663942,
                18422.62935909819
            ],
            [
                1.53e-9,
                2.46021790779,
                11933.3679606696
            ],
            [
                1.08e-9,
                1.04936452151,
                11403.676995575
            ],
            [
                1.28e-9,
                0.99810456461,
                8827.3902698748
            ],
            [
                1.44e-9,
                2.54869747042,
                227.476132789
            ],
            [
                1.5e-9,
                4.50631437136,
                2379.1644735716
            ],
            [
                1.09e-9,
                0.29269062317,
                16737.5772365966
            ],
            [
                1.22e-9,
                4.23040027813,
                29.429508536
            ],
            [
                1.11e-9,
                5.16970710025,
                17782.7320727842
            ],
            [
                1.05e-9,
                1.61738153441,
                13119.72110282519
            ],
            [
                1e-9,
                3.52204690579,
                18052.9295431578
            ],
            [
                1.08e-9,
                1.08493117155,
                16858.4825329332
            ],
            [
                1.35e-9,
                3.2016061697,
                6262.300454499
            ],
            [
                1.06e-9,
                1.96085069786,
                74.7815985673
            ],
            [
                1.29e-9,
                4.85949366504,
                16496.3613962024
            ],
            [
                1.1e-9,
                2.30605777952,
                16460.33352952499
            ],
            [
                9.7e-10,
                3.5091894021,
                5333.9002410216
            ],
            [
                9.9e-10,
                3.56417337974,
                735.8765135318
            ],
            [
                9.6e-10,
                3.40918487598,
                15720.8387848784
            ],
            [
                9.4e-10,
                5.01601027363,
                3128.3887650958
            ],
            [
                9.7e-10,
                1.65579893894,
                533.2140834436
            ],
            [
                9.2e-10,
                0.89219199493,
                29296.6153895786
            ],
            [
                1.23e-9,
                3.16062062663,
                9380.9596727172
            ],
            [
                1.02e-9,
                1.20493500565,
                23020.65308658799
            ],
            [
                8.8e-10,
                2.21265504437,
                12721.572099417
            ],
            [
                8.9e-10,
                1.5432266957,
                20199.094959633
            ],
            [
                1.21e-9,
                6.19860353182,
                9388.0059094152
            ],
            [
                8.9e-10,
                4.08082274765,
                22805.7355659936
            ],
            [
                9.8e-10,
                1.09176668094,
                12043.574281889
            ],
            [
                8.6e-10,
                1.13649001466,
                143571.32428481648
            ],
            [
                8.8e-10,
                5.96980472191,
                107.6635239386
            ],
            [
                8.2e-10,
                5.01561173481,
                22003.9146348698
            ],
            [
                9.4e-10,
                1.69615700473,
                23006.42599258639
            ],
            [
                8.1e-10,
                3.00664741995,
                2118.7638603784
            ],
            [
                9.8e-10,
                1.39215287161,
                8662.240323563
            ],
            [
                8e-10,
                5.16340988714,
                17796.9591667858
            ],
            [
                8.2e-10,
                5.86893959287,
                2787.0430238574
            ],
            [
                7.7e-10,
                0.80723694712,
                167283.7615876655
            ],
            [
                9.1e-10,
                5.74902425304,
                21424.4666443034
            ],
            [
                7.6e-10,
                5.67183650604,
                14.2270940016
            ],
            [
                8.1e-10,
                6.16619455699,
                1039.0266107904
            ],
            [
                7.6e-10,
                3.21449884756,
                111.1866422876
            ],
            [
                7.8e-10,
                1.37531518377,
                21947.1113727
            ],
            [
                7.4e-10,
                3.58814195051,
                11609.8625440122
            ],
            [
                7.7e-10,
                4.84846488388,
                22743.4093795164
            ],
            [
                9e-10,
                1.48869013606,
                15671.0817594066
            ],
            [
                8.2e-10,
                3.48618398216,
                29088.811415985
            ],
            [
                7.1e-10,
                2.2159156119,
                12029.3471878874
            ],
            [
                6.9e-10,
                1.93625656075,
                135.62532501
            ],
            [
                7e-10,
                2.66552760898,
                18875.525869774
            ],
            [
                6.9e-10,
                5.41478093731,
                26735.9452622132
            ],
            [
                7.9e-10,
                5.15158156951,
                12323.4230960088
            ],
            [
                7.8e-10,
                4.17014063638,
                1066.49547719
            ],
            [
                6.5e-10,
                5.64584720343,
                12139.5535091068
            ],
            [
                7.1e-10,
                3.89804774037,
                22779.4372461938
            ],
            [
                6.3e-10,
                4.53968787714,
                8982.810669309
            ],
            [
                7.6e-10,
                3.29088891716,
                2942.4634232916
            ],
            [
                6.9e-10,
                0.94232113005,
                14919.0178537546
            ],
            [
                6.3e-10,
                4.0918653549,
                16062.1845261168
            ],
            [
                6.5e-10,
                3.34580407184,
                51.28033786241
            ],
            [
                6.5e-10,
                5.75757544877,
                52670.0695933026
            ],
            [
                5.7e-10,
                5.25050277534,
                20995.3929664494
            ],
            [
                6.1e-10,
                1.92290673861,
                6805.6532680852
            ],
            [
                6.1e-10,
                0.08878901558,
                13362.4497067992
            ],
            [
                7.6e-10,
                1.86947679415,
                25287.7237993998
            ],
            [
                5.6e-10,
                4.25396542622,
                6709.6740408674
            ],
            [
                5.8e-10,
                4.79429715781,
                6286.3622074092
            ],
            [
                7.3e-10,
                0.53299090807,
                2301.58581590939
            ],
            [
                7e-10,
                4.31243357502,
                19402.7969528166
            ],
            [
                6.7e-10,
                2.53852336668,
                377.3736079158
            ],
            [
                5.6e-10,
                3.20816844695,
                24889.5747959916
            ],
            [
                5.4e-10,
                5.17336469511,
                26084.0218062162
            ],
            [
                5.3e-10,
                3.17675406016,
                18451.07854656599
            ],
            [
                5.3e-10,
                3.61529270216,
                77.673770428
            ],
            [
                5.3e-10,
                0.45467549335,
                30666.1549584328
            ],
            [
                5.3e-10,
                2.97761644192,
                21548.9623692918
            ],
            [
                6.1e-10,
                0.14805728543,
                23013.5395395872
            ],
            [
                5.1e-10,
                3.32803972907,
                56.8983749356
            ],
            [
                5.2e-10,
                3.41304011355,
                23141.5583829246
            ],
            [
                5.8e-10,
                3.13638677202,
                309.2783226558
            ],
            [
                5.4e-10,
                1.60896548545,
                13341.6743113068
            ],
            [
                5.3e-10,
                5.81426394852,
                16193.65917750039
            ],
            [
                6.7e-10,
                6.27917920454,
                22345.2603761082
            ],
            [
                5e-10,
                0.42577644151,
                25685.872802808
            ],
            [
                4.8e-10,
                0.70204553352,
                1162.4747044078
            ],
            [
                6.6e-10,
                3.64350022359,
                15265.8865193004
            ],
            [
                5e-10,
                5.7438291744,
                19.66976089979
            ],
            [
                5.4e-10,
                1.97277370837,
                23581.2581773176
            ],
            [
                5.1e-10,
                1.23713196525,
                12539.853380183
            ],
            [
                4.6e-10,
                5.41431704639,
                33019.0211122046
            ],
            [
                4.6e-10,
                4.80640843261,
                19651.048481098
            ],
            [
                5e-10,
                1.23847511223,
                22476.73502749179
            ],
            [
                5.1e-10,
                4.91913434178,
                12592.4500197826
            ],
            [
                4.6e-10,
                2.41369976086,
                98068.53671630539
            ],
            [
                4.5e-10,
                3.45227074337,
                30774.5016425748
            ],
            [
                4.5e-10,
                4.39659083856,
                433.7117378768
            ],
            [
                4.5e-10,
                3.71921056816,
                18209.33026366019
            ],
            [
                4.4e-10,
                2.47683925106,
                24356.7807886416
            ],
            [
                4.9e-10,
                2.17835058609,
                13521.7514415914
            ],
            [
                4.6e-10,
                0.26142733448,
                11.0457002639
            ],
            [
                4.5e-10,
                2.46230645202,
                51868.2486621788
            ],
            [
                4.3e-10,
                4.29458463014,
                28230.18722269139
            ],
            [
                4.8e-10,
                0.89551707131,
                56600.2792895222
            ],
            [
                4.2e-10,
                3.63410684699,
                4590.910180489
            ],
            [
                4.9e-10,
                3.17757670967,
                6303.8512454838
            ],
            [
                4.3e-10,
                4.93350349236,
                10021.8372800994
            ],
            [
                5.2e-10,
                3.65410195699,
                7872.1487452752
            ],
            [
                4.1e-10,
                4.82166756935,
                10988.808157535
            ],
            [
                4e-10,
                1.81891629936,
                34596.3646546524
            ],
            [
                4.3e-10,
                1.94164978061,
                1903.4368125012
            ],
            [
                4.1e-10,
                0.74461854136,
                23937.856389741
            ],
            [
                4.5e-10,
                5.4557501753,
                60530.4889857418
            ],
            [
                5e-10,
                5.67355640472,
                18216.443810661
            ],
            [
                4e-10,
                0.04502010161,
                38526.574350872
            ],
            [
                5.3e-10,
                3.64807615995,
                11925.2740926006
            ],
            [
                4.2e-10,
                5.19292937193,
                19004.6479494084
            ],
            [
                4.1e-10,
                0.94309683296,
                9924.8104215106
            ],
            [
                3.9e-10,
                4.61184303844,
                95.9792272178
            ],
            [
                4.9e-10,
                2.05532526216,
                12573.2652469836
            ],
            [
                4.5e-10,
                3.73717824543,
                7875.6718636242
            ],
            [
                4.3e-10,
                1.14078465002,
                49.7570254718
            ],
            [
                3.9e-10,
                1.70539366023,
                32217.2001810808
            ],
            [
                3.7e-10,
                1.29390383811,
                310.8407988684
            ],
            [
                3.8e-10,
                0.9597092595,
                664.75604513
            ],
            [
                3.9e-10,
                0.85957361635,
                16522.6597160022
            ],
            [
                4e-10,
                1.00170796001,
                36949.2308084242
            ],
            [
                4e-10,
                3.78164718776,
                55798.4583583984
            ],
            [
                3.7e-10,
                5.42237070904,
                6286.6662786432
            ],
            [
                3.6e-10,
                1.68167662194,
                10344.2950653858
            ],
            [
                4e-10,
                5.13217319067,
                15664.03552270859
            ],
            [
                4.9e-10,
                3.62741283878,
                77713.7714681205
            ],
            [
                4.5e-10,
                6.15877872538,
                28286.9904848612
            ],
            [
                3.6e-10,
                3.32158458257,
                16207.886271502
            ],
            [
                3.5e-10,
                5.83917764292,
                6321.1035226272
            ],
            [
                3.6e-10,
                1.80784164083,
                6279.7894925736
            ],
            [
                3.5e-10,
                4.60279245362,
                28237.2334593894
            ],
            [
                3.3e-10,
                0.47301775923,
                18635.9284545362
            ],
            [
                3.5e-10,
                4.36571027474,
                48739.859897083
            ],
            [
                3.1e-10,
                3.06828028412,
                6819.8803620868
            ],
            [
                3.1e-10,
                2.4020319848,
                28628.3362260996
            ],
            [
                3.4e-10,
                1.90096411242,
                12964.300703391
            ],
            [
                2.9e-10,
                6.09291010354,
                18606.4989460002
            ],
            [
                2.8e-10,
                3.42046112698,
                6288.5987742988
            ],
            [
                2.8e-10,
                3.437361406,
                34115.1140692746
            ],
            [
                2.9e-10,
                1.48920816078,
                6489.2613984286
            ],
            [
                2.8e-10,
                3.07474749886,
                29822.7832363242
            ],
            [
                3.8e-10,
                2.44608264663,
                31415.379249957
            ],
            [
                2.8e-10,
                2.98392582088,
                6277.552925684
            ],
            [
                2.7e-10,
                5.03556015623,
                12779.4507954208
            ],
            [
                2.7e-10,
                5.40812977287,
                26087.9031415742
            ],
            [
                3.8e-10,
                5.56439937893,
                27832.0382192832
            ],
            [
                2.6e-10,
                3.87685883153,
                6262.7205305926
            ],
            [
                2.7e-10,
                6.1556539284,
                28759.81087748319
            ],
            [
                2.5e-10,
                5.17122153205,
                6915.8595893046
            ],
            [
                2.7e-10,
                4.03132006944,
                9910.583327509
            ],
            [
                3.3e-10,
                3.97763407373,
                12410.7313005486
            ],
            [
                2.4e-10,
                5.31307120044,
                29026.48522950779
            ],
            [
                2.5e-10,
                0.81055213297,
                36173.7081971002
            ],
            [
                2.4e-10,
                1.2870610131,
                24491.4257925834
            ],
            [
                2.1e-10,
                2.02548478742,
                28766.924424484
            ],
            [
                2.1e-10,
                6.07545114034,
                18139.2945014159
            ],
            [
                2.2e-10,
                2.31199937131,
                6303.4311693902
            ],
            [
                2.3e-10,
                1.35235057478,
                49515.382508407
            ],
            [
                2.3e-10,
                2.92765926961,
                65236.2212932854
            ],
            [
                1.9e-10,
                0.03636659763,
                29864.334027309
            ],
            [
                2e-10,
                0.91374066194,
                45585.1728121874
            ],
            [
                2.1e-10,
                4.45003013294,
                22490.9621214934
            ],
            [
                2.2e-10,
                1.97119365888,
                34513.2630726828
            ],
            [
                2e-10,
                4.11682669951,
                17157.0618804718
            ],
            [
                2.4e-10,
                1.40243942415,
                14712.317116458
            ],
            [
                2.2e-10,
                2.19759737115,
                31570.7996493912
            ],
            [
                2.1e-10,
                1.48739821208,
                61306.0115970658
            ],
            [
                2.5e-10,
                5.71465573409,
                25934.1243310894
            ]
        ],
        "2": [
            [
                0.00008721859,
                1.07253635559,
                6283.0758499914
            ],
            [
                0.0000099099,
                3.14159265359,
                0
            ],
            [
                0.00000294833,
                0.43717350256,
                12566.1516999828
            ],
            [
                2.7338e-7,
                0.05295636147,
                3.523118349
            ],
            [
                1.6333e-7,
                5.18820215724,
                26.2983197998
            ],
            [
                1.5745e-7,
                3.68504712183,
                155.4203994342
            ],
            [
                9.425e-8,
                0.29667114694,
                18849.2275499742
            ],
            [
                8.938e-8,
                2.05706319592,
                77713.7714681205
            ],
            [
                6.94e-8,
                0.82691541038,
                775.522611324
            ],
            [
                5.061e-8,
                4.6624323168,
                1577.3435424478
            ],
            [
                4.06e-8,
                1.03067032318,
                7.1135470008
            ],
            [
                3.464e-8,
                5.14021224609,
                796.2980068164
            ],
            [
                3.172e-8,
                6.05479318507,
                5507.5532386674
            ],
            [
                3.02e-8,
                1.19240008524,
                242.728603974
            ],
            [
                2.885e-8,
                6.11705865396,
                529.6909650946
            ],
            [
                3.809e-8,
                3.44043369494,
                5573.1428014331
            ],
            [
                2.719e-8,
                0.30363248164,
                398.1490034082
            ],
            [
                2.365e-8,
                4.37666117992,
                5223.6939198022
            ],
            [
                2.538e-8,
                2.27966434314,
                553.5694028424
            ],
            [
                2.078e-8,
                3.75435095487,
                0.9803210682
            ],
            [
                1.675e-8,
                0.90149951436,
                951.7184062506
            ],
            [
                1.534e-8,
                5.75895831192,
                1349.8674096588
            ],
            [
                1.224e-8,
                2.97285792195,
                2146.1654164752
            ],
            [
                1.449e-8,
                4.36401639552,
                1748.016413067
            ],
            [
                1.341e-8,
                3.72019379666,
                1194.4470102246
            ],
            [
                1.253e-8,
                2.9488872631,
                6438.4962494256
            ],
            [
                9.99e-9,
                5.98665341008,
                6286.5989683404
            ],
            [
                9.17e-9,
                4.79722195184,
                5088.6288397668
            ],
            [
                8.29e-9,
                3.31021398862,
                213.299095438
            ],
            [
                1.102e-8,
                1.27094359244,
                161000.6857376741
            ],
            [
                7.64e-9,
                3.41231607038,
                5486.777843175
            ],
            [
                1.046e-8,
                0.60374190029,
                3154.6870848956
            ],
            [
                8.87e-9,
                5.23364022595,
                7084.8967811152
            ],
            [
                6.44e-9,
                1.59974355582,
                2544.3144198834
            ],
            [
                6.81e-9,
                3.42742947469,
                4694.0029547076
            ],
            [
                6.06e-9,
                2.47688996663,
                10977.078804699
            ],
            [
                7.06e-9,
                6.19369692903,
                4690.4798363586
            ],
            [
                6.43e-9,
                1.98119869589,
                801.8209311238
            ],
            [
                5.02e-9,
                1.44415463861,
                6836.6452528338
            ],
            [
                4.9e-9,
                2.33889753806,
                1592.5960136328
            ],
            [
                4.58e-9,
                1.30867922972,
                4292.3308329504
            ],
            [
                4.31e-9,
                0.03542536476,
                7234.794256242
            ],
            [
                3.49e-9,
                0.98779272263,
                6040.3472460174
            ],
            [
                3.85e-9,
                1.57065592218,
                71430.69561812909
            ],
            [
                3.71e-9,
                3.16149051601,
                6309.3741697912
            ],
            [
                3.48e-9,
                0.64980950594,
                1059.3819301892
            ],
            [
                4.58e-9,
                3.81505682017,
                149854.4001348079
            ],
            [
                3.02e-9,
                1.91723873447,
                10447.3878396044
            ],
            [
                3.06e-9,
                3.55405857884,
                8031.0922630584
            ],
            [
                3.95e-9,
                4.93742673052,
                7632.9432596502
            ],
            [
                3.14e-9,
                3.18058352846,
                2352.8661537718
            ],
            [
                2.81e-9,
                4.41751404023,
                9437.762934887
            ],
            [
                2.76e-9,
                2.71075791682,
                3894.1818295422
            ],
            [
                2.98e-9,
                2.52045757001,
                6127.6554505572
            ],
            [
                2.72e-9,
                0.24370191144,
                25132.3033999656
            ],
            [
                2.51e-9,
                0.55449375765,
                6279.5527316424
            ],
            [
                2.24e-9,
                1.40790249012,
                4705.7323075436
            ],
            [
                2.58e-9,
                5.29510765044,
                6812.766815086
            ],
            [
                1.78e-9,
                0.92636669742,
                1990.745017041
            ],
            [
                2.17e-9,
                0.68543630022,
                6256.7775301916
            ],
            [
                1.54e-9,
                0.77808632062,
                14143.4952424306
            ],
            [
                1.5e-9,
                2.40636982736,
                426.598190876
            ],
            [
                1.96e-9,
                6.06877865012,
                640.8776073822
            ],
            [
                1.37e-9,
                2.21947617717,
                8429.2412664666
            ],
            [
                1.27e-9,
                5.47380312768,
                12036.4607348882
            ],
            [
                1.21e-9,
                3.32740512021,
                17789.845619785
            ],
            [
                1.23e-9,
                2.16004509785,
                10213.285546211
            ],
            [
                1.16e-9,
                0.49705139709,
                7058.5984613154
            ],
            [
                1.38e-9,
                2.36181661472,
                11506.7697697936
            ],
            [
                1.01e-9,
                0.86299995919,
                6290.1893969922
            ],
            [
                1.18e-9,
                5.82317768355,
                7860.4193924392
            ],
            [
                9.2e-10,
                5.11639978593,
                7079.3738568078
            ],
            [
                1.25e-9,
                2.65424538513,
                88860.05707098669
            ],
            [
                8.8e-10,
                4.3118823616,
                83996.84731811189
            ],
            [
                8.4e-10,
                3.57682769713,
                16730.4636895958
            ],
            [
                9.7e-10,
                5.58011309774,
                13367.9726311066
            ],
            [
                1.02e-9,
                2.05853060226,
                87.30820453981
            ],
            [
                8e-10,
                4.73827128421,
                11926.2544136688
            ],
            [
                8e-10,
                5.41344057121,
                10973.55568635
            ],
            [
                1.06e-9,
                4.10978997399,
                3496.032826134
            ],
            [
                7.5e-10,
                4.89166898876,
                5643.1785636774
            ],
            [
                1e-9,
                3.62645659087,
                244287.60000722768
            ],
            [
                9.6e-10,
                1.39443577787,
                6681.2248533996
            ],
            [
                6.9e-10,
                1.88399189965,
                10177.2576795336
            ],
            [
                8.7e-10,
                0.40842153208,
                11015.1064773348
            ],
            [
                6.6e-10,
                0.99444831932,
                6525.8044539654
            ],
            [
                6.6e-10,
                1.42471816453,
                9917.6968745098
            ],
            [
                6.7e-10,
                5.5124099707,
                3097.88382272579
            ],
            [
                7.6e-10,
                2.7156469351,
                4164.311989613
            ],
            [
                8.5e-10,
                0.4965552367,
                10575.4066829418
            ],
            [
                7.7e-10,
                3.51693861509,
                11856.2186514245
            ],
            [
                6.2e-10,
                3.6258762869,
                16496.3613962024
            ],
            [
                5.4e-10,
                5.25957420065,
                3340.6124266998
            ],
            [
                5.3e-10,
                1.10902178415,
                8635.9420037632
            ],
            [
                4.9e-10,
                5.65761054625,
                20426.571092422
            ],
            [
                6.4e-10,
                5.79211164779,
                2388.8940204492
            ],
            [
                4.6e-10,
                5.45092696155,
                6275.9623029906
            ],
            [
                5.7e-10,
                4.97077155798,
                14945.3161735544
            ],
            [
                4.3e-10,
                3.30685683359,
                9779.1086761254
            ],
            [
                4.2e-10,
                1.61412785248,
                12168.0026965746
            ],
            [
                4.9e-10,
                3.92715473768,
                5729.506447149
            ],
            [
                4.2e-10,
                0.6348125893,
                2699.7348193176
            ],
            [
                5.6e-10,
                4.34038639086,
                90955.5516944961
            ],
            [
                4e-10,
                5.66871428338,
                11712.9553182308
            ],
            [
                3.9e-10,
                3.10911294009,
                16200.7727245012
            ],
            [
                4e-10,
                5.71338386146,
                709.9330485583
            ],
            [
                5.3e-10,
                6.17067257683,
                233141.3144043615
            ],
            [
                3.7e-10,
                0.32095173508,
                24356.7807886416
            ],
            [
                3.5e-10,
                0.95557073457,
                17298.1823273262
            ],
            [
                3.5e-10,
                0.64913397996,
                25158.6017197654
            ],
            [
                4.1e-10,
                1.53850422484,
                65147.6197681377
            ],
            [
                3.5e-10,
                0.77655626359,
                13916.0191096416
            ],
            [
                3.1e-10,
                5.35897350775,
                5331.3574437408
            ],
            [
                3e-10,
                4.48114682755,
                23543.23050468179
            ],
            [
                3.2e-10,
                3.45976963453,
                7477.522860216
            ],
            [
                2.9e-10,
                3.46648040769,
                13119.72110282519
            ],
            [
                3.8e-10,
                2.90863974625,
                12721.572099417
            ],
            [
                2.9e-10,
                3.13390968321,
                4136.9104335162
            ],
            [
                3.5e-10,
                3.79717126309,
                143571.32428481648
            ],
            [
                2.7e-10,
                0.95726093828,
                12559.038152982
            ],
            [
                2.6e-10,
                4.9532687703,
                5753.3848848968
            ],
            [
                3.2e-10,
                3.49943896928,
                6284.0561710596
            ],
            [
                2.6e-10,
                4.59276256636,
                5884.9268465832
            ],
            [
                2.6e-10,
                1.53958920253,
                154717.6098876827
            ],
            [
                2.3e-10,
                4.88012908735,
                13095.8426650774
            ],
            [
                2.3e-10,
                0.35935706511,
                31415.379249957
            ],
            [
                2.4e-10,
                5.11515116629,
                18319.5365848796
            ],
            [
                2.1e-10,
                5.73872879912,
                12569.6748183318
            ],
            [
                2.1e-10,
                1.32901200081,
                10988.808157535
            ],
            [
                1.9e-10,
                2.24263229491,
                18073.7049386502
            ],
            [
                1.9e-10,
                3.14253175605,
                6496.3749454294
            ],
            [
                2.1e-10,
                2.80122025076,
                6282.0955289232
            ],
            [
                2.3e-10,
                0.14288760398,
                6283.0085396886
            ],
            [
                1.9e-10,
                4.28209473754,
                3930.2096962196
            ],
            [
                1.6e-10,
                0.25933207663,
                11790.6290886588
            ],
            [
                1.5e-10,
                6.0962350124,
                13517.8701062334
            ],
            [
                2e-10,
                5.06358906224,
                6283.14316029419
            ],
            [
                1.5e-10,
                1.0768066315,
                4933.2084403326
            ],
            [
                1.9e-10,
                5.74000581249,
                3128.3887650958
            ],
            [
                1.6e-10,
                6.18924226747,
                7342.4577801806
            ],
            [
                1.3e-10,
                1.69105044945,
                4535.0594369244
            ],
            [
                1.5e-10,
                3.36968394452,
                17260.1546546904
            ],
            [
                1e-10,
                3.78885035015,
                22003.9146348698
            ],
            [
                1.1e-10,
                2.12851973876,
                7875.6718636242
            ]
        ],
        "3": [
            [
                0.00000289058,
                5.84173149732,
                6283.0758499914
            ],
            [
                2.0712e-7,
                6.0498393902,
                12566.1516999828
            ],
            [
                2.962e-8,
                5.1956057957,
                155.4203994342
            ],
            [
                2.527e-8,
                3.14159265359,
                0
            ],
            [
                1.288e-8,
                4.7219761197,
                3.523118349
            ],
            [
                6.35e-9,
                5.96904899168,
                242.728603974
            ],
            [
                5.7e-9,
                5.54182903238,
                18849.2275499742
            ],
            [
                4.02e-9,
                3.78606612895,
                553.5694028424
            ],
            [
                7.2e-10,
                4.37131884946,
                6286.5989683404
            ],
            [
                6.7e-10,
                0.91133898967,
                6127.6554505572
            ],
            [
                3.7e-10,
                5.28611190997,
                6438.4962494256
            ],
            [
                2.1e-10,
                2.94917211527,
                6309.3741697912
            ],
            [
                1.5e-10,
                3.63037493932,
                71430.69561812909
            ],
            [
                1.1e-10,
                4.83261533939,
                25132.3033999656
            ],
            [
                1.1e-10,
                5.84259014283,
                6525.8044539654
            ],
            [
                1.2e-10,
                3.82296977522,
                7058.5984613154
            ],
            [
                1.3e-10,
                2.39991715131,
                5729.506447149
            ],
            [
                8e-11,
                0.55390332094,
                6040.3472460174
            ],
            [
                8e-11,
                1.46298993048,
                11856.2186514245
            ],
            [
                8e-11,
                5.07535888338,
                6256.7775301916
            ],
            [
                6e-11,
                2.88803526743,
                5507.5532386674
            ],
            [
                5e-11,
                3.87019253131,
                12036.4607348882
            ],
            [
                5e-11,
                2.70838853362,
                83996.84731811189
            ]
        ],
        "4": [
            [
                7.714e-8,
                4.14117321449,
                6283.0758499914
            ],
            [
                1.016e-8,
                3.27573644241,
                12566.1516999828
            ],
            [
                4.2e-9,
                0.41892851415,
                155.4203994342
            ],
            [
                4.7e-10,
                3.50591071186,
                18849.2275499742
            ],
            [
                4.1e-10,
                3.14032562331,
                3.523118349
            ],
            [
                3.5e-10,
                5.0111077,
                5573.1428014331
            ],
            [
                1e-10,
                5.64816633449,
                6127.6554505572
            ],
            [
                1.3e-10,
                0.48609240774,
                77713.7714681205
            ],
            [
                7e-11,
                2.84139222289,
                161000.6857376741
            ],
            [
                4e-11,
                3.6550904707,
                25132.3033999656
            ],
            [
                2e-11,
                0.54880603487,
                6438.4962494256
            ]
        ],
        "5": [
            [
                1.72e-9,
                2.74854172392,
                6283.0758499914
            ],
            [
                5e-10,
                2.01352986713,
                155.4203994342
            ],
            [
                2.8e-10,
                2.93369985477,
                12566.1516999828
            ],
            [
                5e-11,
                1.93829214518,
                18849.2275499742
            ]
        ]
    },
    B: {
        "0": [
            [
                0.0000027962,
                3.19870156017,
                84334.66158130829
            ],
            [
                0.00000101643,
                5.42248619256,
                5507.5532386674
            ],
            [
                8.0445e-7,
                3.88013204458,
                5223.6939198022
            ],
            [
                4.3806e-7,
                3.70444689759,
                2352.8661537718
            ],
            [
                3.1933e-7,
                4.00026369781,
                1577.3435424478
            ],
            [
                2.2724e-7,
                3.9847383156,
                1047.7473117547
            ],
            [
                1.6392e-7,
                3.56456119782,
                5856.4776591154
            ],
            [
                1.8141e-7,
                4.98367470262,
                6283.0758499914
            ],
            [
                1.4443e-7,
                3.70275614915,
                9437.762934887
            ],
            [
                1.4304e-7,
                3.41117857526,
                10213.285546211
            ],
            [
                1.1246e-7,
                4.82820690527,
                14143.4952424306
            ],
            [
                1.09e-7,
                2.08574562329,
                6812.766815086
            ],
            [
                9.714e-8,
                3.47303947751,
                4694.0029547076
            ],
            [
                1.0367e-7,
                4.05663927945,
                71092.88135493269
            ],
            [
                8.775e-8,
                4.44016515666,
                5753.3848848968
            ],
            [
                8.366e-8,
                4.99251512183,
                7084.8967811152
            ],
            [
                6.921e-8,
                4.32559054073,
                6275.9623029906
            ],
            [
                9.145e-8,
                1.14182646613,
                6620.8901131878
            ],
            [
                7.194e-8,
                3.60193205744,
                529.6909650946
            ],
            [
                7.698e-8,
                5.55425745881,
                167621.5758508619
            ],
            [
                5.285e-8,
                2.48446991536,
                4705.7323075436
            ],
            [
                5.208e-8,
                6.24992674532,
                18073.7049386502
            ],
            [
                4.529e-8,
                2.33827747356,
                6309.3741697912
            ],
            [
                5.579e-8,
                4.41023653719,
                7860.4193924392
            ],
            [
                4.743e-8,
                0.70995680136,
                5884.9268465832
            ],
            [
                4.301e-8,
                1.10255777773,
                6681.2248533996
            ],
            [
                3.849e-8,
                1.82229412532,
                5486.777843175
            ],
            [
                4.093e-8,
                5.11700141197,
                13367.9726311066
            ],
            [
                3.681e-8,
                0.43793170336,
                3154.6870848956
            ],
            [
                3.42e-8,
                5.42034800952,
                6069.7767545534
            ],
            [
                3.617e-8,
                6.04641937568,
                3930.2096962196
            ],
            [
                3.67e-8,
                4.58210192227,
                12194.0329146209
            ],
            [
                2.918e-8,
                1.95463881136,
                10977.078804699
            ],
            [
                2.797e-8,
                5.61259274877,
                11790.6290886588
            ],
            [
                2.502e-8,
                0.60499729368,
                6496.3749454294
            ],
            [
                2.319e-8,
                5.01648216088,
                1059.3819301892
            ],
            [
                2.684e-8,
                1.39470396487,
                22003.9146348698
            ],
            [
                2.428e-8,
                3.24183056545,
                78051.5857313169
            ],
            [
                2.12e-8,
                4.30691000285,
                5643.1785636774
            ],
            [
                2.257e-8,
                3.15557225087,
                90617.7374312997
            ],
            [
                1.813e-8,
                3.75574218286,
                3340.6124266998
            ],
            [
                2.226e-8,
                2.79699346673,
                12036.4607348882
            ],
            [
                1.888e-8,
                0.86991545944,
                8635.9420037632
            ],
            [
                1.517e-8,
                1.9585205571,
                398.1490034082
            ],
            [
                1.581e-8,
                3.19976230948,
                5088.6288397668
            ],
            [
                1.421e-8,
                6.25530883828,
                2544.3144198834
            ],
            [
                1.595e-8,
                0.25619915132,
                17298.1823273262
            ],
            [
                1.391e-8,
                4.69964175574,
                7058.5984613154
            ],
            [
                1.478e-8,
                2.81808207569,
                25934.1243310894
            ],
            [
                1.481e-8,
                3.6582355461,
                11506.7697697936
            ],
            [
                1.693e-8,
                4.95689385293,
                156475.2902479957
            ],
            [
                1.183e-8,
                1.29343060777,
                775.522611324
            ],
            [
                1.114e-8,
                2.37889311847,
                3738.761430108
            ],
            [
                9.94e-9,
                4.30088900425,
                9225.539273283
            ],
            [
                9.24e-9,
                3.06451026809,
                4164.311989613
            ],
            [
                8.67e-9,
                0.55606931068,
                8429.2412664666
            ],
            [
                9.88e-9,
                5.97286104208,
                7079.3738568078
            ],
            [
                8.24e-9,
                1.50984806177,
                10447.3878396044
            ],
            [
                9.15e-9,
                0.12635654605,
                11015.1064773348
            ],
            [
                7.42e-9,
                1.99159139281,
                26087.9031415742
            ],
            [
                1.039e-8,
                3.14159265359,
                0
            ],
            [
                8.5e-9,
                4.24120016095,
                29864.334027309
            ],
            [
                7.55e-9,
                2.89631873314,
                4732.0306273434
            ],
            [
                7.14e-9,
                1.37548118605,
                2146.1654164752
            ],
            [
                7.08e-9,
                1.91406542362,
                8031.0922630584
            ],
            [
                7.46e-9,
                0.57893808622,
                796.2980068164
            ],
            [
                8.02e-9,
                5.12339137235,
                2942.4634232916
            ],
            [
                7.51e-9,
                1.67479850166,
                21228.3920235458
            ],
            [
                6.02e-9,
                4.099765389,
                64809.80550494129
            ],
            [
                5.94e-9,
                3.49580704849,
                16496.3613962024
            ],
            [
                5.92e-9,
                4.59481504319,
                4690.4798363586
            ],
            [
                5.3e-9,
                5.73979295194,
                8827.3902698748
            ],
            [
                5.03e-9,
                5.66433137112,
                33794.5437235286
            ],
            [
                4.83e-9,
                1.57106522322,
                801.8209311238
            ],
            [
                4.38e-9,
                0.0670773372,
                3128.3887650958
            ],
            [
                4.23e-9,
                2.86944596145,
                12566.1516999828
            ],
            [
                5.04e-9,
                3.2620766916,
                7632.9432596502
            ],
            [
                5.52e-9,
                1.02926440457,
                239762.20451754928
            ],
            [
                4.27e-9,
                3.67434378208,
                213.299095438
            ],
            [
                4.04e-9,
                1.4619329736,
                15720.8387848784
            ],
            [
                5.03e-9,
                4.85802444134,
                6290.1893969922
            ],
            [
                4.17e-9,
                0.81920713533,
                5216.5803728014
            ],
            [
                3.65e-9,
                0.01002966145,
                12168.0026965746
            ],
            [
                3.63e-9,
                1.28376436579,
                6206.8097787158
            ],
            [
                3.53e-9,
                4.7005913311,
                7234.794256242
            ],
            [
                4.15e-9,
                0.96862624176,
                4136.9104335162
            ],
            [
                3.87e-9,
                3.09145061418,
                25158.6017197654
            ],
            [
                3.73e-9,
                2.65119262808,
                7342.4577801806
            ],
            [
                3.61e-9,
                2.97762937735,
                9623.6882766912
            ],
            [
                4.18e-9,
                3.75759994446,
                5230.807466803
            ],
            [
                3.96e-9,
                1.22507712354,
                6438.4962494256
            ],
            [
                3.22e-9,
                1.21162178805,
                8662.240323563
            ],
            [
                2.84e-9,
                5.64170320179,
                1589.0728952838
            ],
            [
                3.79e-9,
                1.72248432756,
                14945.3161735544
            ],
            [
                3.2e-9,
                3.94161159658,
                7330.8231617461
            ],
            [
                3.13e-9,
                5.47602376451,
                1194.4470102246
            ],
            [
                2.92e-9,
                1.38971327568,
                11769.8536931664
            ],
            [
                3.05e-9,
                0.80429352049,
                37724.7534197482
            ],
            [
                2.57e-9,
                5.81382810029,
                426.598190876
            ],
            [
                2.65e-9,
                6.10358507671,
                6836.6452528338
            ],
            [
                2.5e-9,
                4.56452895547,
                7477.522860216
            ],
            [
                2.66e-9,
                2.62926282354,
                7238.6755916
            ],
            [
                2.63e-9,
                6.22089501237,
                6133.5126528568
            ],
            [
                3.06e-9,
                2.79682380532,
                1748.016413067
            ],
            [
                2.36e-9,
                2.46093023707,
                11371.7046897582
            ],
            [
                3.16e-9,
                1.62662805006,
                250908.4901204155
            ],
            [
                2.16e-9,
                3.68721275185,
                5849.3641121146
            ],
            [
                2.3e-9,
                0.36165162947,
                5863.5912061162
            ],
            [
                2.33e-9,
                5.03509933618,
                20426.571092422
            ],
            [
                2e-9,
                5.86073159059,
                4535.0594369244
            ],
            [
                2.77e-9,
                4.65400292395,
                82239.1669577989
            ],
            [
                2.09e-9,
                3.72323200803,
                10973.55568635
            ],
            [
                1.99e-9,
                5.05186622555,
                5429.8794682394
            ],
            [
                2.56e-9,
                2.40923279886,
                19651.048481098
            ],
            [
                2.1e-9,
                4.50691909144,
                29088.811415985
            ],
            [
                1.81e-9,
                6.00294783127,
                4292.3308329504
            ],
            [
                2.49e-9,
                0.12900984422,
                154379.7956244863
            ],
            [
                2.09e-9,
                3.87759458541,
                17789.845619785
            ],
            [
                2.25e-9,
                3.18339652605,
                18875.525869774
            ],
            [
                1.91e-9,
                4.53897489216,
                18477.1087646123
            ],
            [
                1.72e-9,
                2.0969418273,
                13095.8426650774
            ],
            [
                1.82e-9,
                3.16107943487,
                16730.4636895958
            ],
            [
                1.88e-9,
                2.22746128596,
                41654.9631159678
            ],
            [
                1.64e-9,
                5.18686274999,
                5481.2549188676
            ],
            [
                1.6e-9,
                2.4929885502,
                12592.4500197826
            ],
            [
                1.55e-9,
                1.59595438224,
                10021.8372800994
            ],
            [
                1.35e-9,
                0.21349051305,
                10988.808157535
            ],
            [
                1.78e-9,
                3.80375178044,
                23581.2581773176
            ],
            [
                1.23e-9,
                1.66800739151,
                15110.4661198662
            ],
            [
                1.22e-9,
                2.72678272224,
                18849.2275499742
            ],
            [
                1.26e-9,
                1.17675512872,
                14919.0178537546
            ],
            [
                1.42e-9,
                3.95053440992,
                337.8142631964
            ],
            [
                1.16e-9,
                6.06340906212,
                6709.6740408674
            ],
            [
                1.37e-9,
                3.52143246244,
                12139.5535091068
            ],
            [
                1.36e-9,
                2.92179113491,
                32217.2001810808
            ],
            [
                1.1e-9,
                3.51203379263,
                18052.9295431578
            ],
            [
                1.47e-9,
                4.63371971408,
                22805.7355659936
            ],
            [
                1.08e-9,
                5.45280815225,
                7.1135470008
            ],
            [
                1.48e-9,
                0.65447253687,
                95480.9471841745
            ],
            [
                1.19e-9,
                5.92110458985,
                33019.0211122046
            ],
            [
                1.1e-9,
                5.34824206403,
                639.897286314
            ],
            [
                1.06e-9,
                3.71081682614,
                14314.1681130498
            ],
            [
                1.39e-9,
                6.17607198262,
                24356.7807886416
            ],
            [
                1.18e-9,
                5.59738712949,
                161338.5000008705
            ],
            [
                1.17e-9,
                3.6506527164,
                45585.1728121874
            ],
            [
                1.27e-9,
                4.74596574209,
                49515.382508407
            ],
            [
                1.2e-9,
                1.04211499785,
                6915.8595893046
            ],
            [
                1.2e-9,
                5.60638811846,
                5650.2921106782
            ],
            [
                1.15e-9,
                3.10668213303,
                14712.317116458
            ],
            [
                9.9e-10,
                0.6901893993,
                12779.4507954208
            ],
            [
                9.7e-10,
                1.07908724794,
                9917.6968745098
            ],
            [
                9.3e-10,
                2.62295197146,
                17260.1546546904
            ],
            [
                9.9e-10,
                4.45774681732,
                4933.2084403326
            ],
            [
                1.23e-9,
                1.37488921994,
                28286.9904848612
            ],
            [
                1.21e-9,
                5.19767249869,
                27511.4678735372
            ],
            [
                1.05e-9,
                0.87192268229,
                77375.95720492408
            ],
            [
                8.7e-10,
                3.9363781295,
                17654.7805397496
            ],
            [
                1.22e-9,
                2.2395606868,
                83997.09113559539
            ],
            [
                8.7e-10,
                4.18201600921,
                22779.4372461938
            ],
            [
                1.04e-9,
                4.59580877285,
                1349.8674096588
            ],
            [
                1.02e-9,
                2.83545248595,
                12352.8526045448
            ],
            [
                1.02e-9,
                3.97386522171,
                10818.1352869158
            ],
            [
                1.01e-9,
                4.32892825818,
                36147.4098773004
            ],
            [
                9.4e-10,
                5.00001709338,
                150192.2143980043
            ],
            [
                7.7e-10,
                3.971993693,
                1592.5960136328
            ],
            [
                1e-9,
                6.07733097102,
                26735.9452622132
            ],
            [
                8.6e-10,
                5.2602963825,
                28313.288804661
            ],
            [
                9.3e-10,
                4.31900620254,
                44809.6502008634
            ],
            [
                7.6e-10,
                6.22743405935,
                13521.7514415914
            ],
            [
                7.2e-10,
                1.55820597747,
                6256.7775301916
            ],
            [
                8.2e-10,
                4.95202664555,
                10575.4066829418
            ],
            [
                8.2e-10,
                1.69647647075,
                1990.745017041
            ],
            [
                7.5e-10,
                2.29836095644,
                3634.6210245184
            ],
            [
                7.5e-10,
                2.66367876557,
                16200.7727245012
            ],
            [
                8.7e-10,
                0.26630214764,
                31441.6775697568
            ],
            [
                7.7e-10,
                2.25530952876,
                5235.3285382367
            ],
            [
                7.6e-10,
                1.09869730334,
                12903.9659631792
            ],
            [
                5.8e-10,
                4.28246137794,
                12559.038152982
            ],
            [
                6.4e-10,
                5.51112829602,
                173904.65170085328
            ],
            [
                5.6e-10,
                2.60133794851,
                73188.3759784421
            ],
            [
                5.5e-10,
                5.81483150022,
                143233.51002162008
            ],
            [
                5.4e-10,
                3.38482031504,
                323049.11878710287
            ],
            [
                3.9e-10,
                3.28500401937,
                71768.50988132549
            ],
            [
                3.9e-10,
                3.11239910096,
                96900.81328129109
            ]
        ],
        "1": [
            [
                0.00227777722,
                3.4137662053,
                6283.0758499914
            ],
            [
                0.00003805678,
                3.37063423795,
                12566.1516999828
            ],
            [
                0.00003619589,
                0,
                0
            ],
            [
                7.1542e-7,
                3.32777549735,
                18849.2275499742
            ],
            [
                7.655e-8,
                1.79489607186,
                5223.6939198022
            ],
            [
                8.107e-8,
                3.89190403643,
                5507.5532386674
            ],
            [
                6.456e-8,
                5.1978942475,
                2352.8661537718
            ],
            [
                3.894e-8,
                2.15568517178,
                6279.5527316424
            ],
            [
                3.892e-8,
                1.53021064904,
                6286.5989683404
            ],
            [
                3.897e-8,
                4.87293945629,
                10213.285546211
            ],
            [
                3.812e-8,
                1.43523182316,
                12036.4607348882
            ],
            [
                3.577e-8,
                2.32913869227,
                83996.84731811189
            ],
            [
                3.57e-8,
                4.92637739003,
                71430.69561812909
            ],
            [
                3.494e-8,
                2.20864641831,
                529.6909650946
            ],
            [
                2.421e-8,
                6.22876183393,
                7860.4193924392
            ],
            [
                2.056e-8,
                3.06747139741,
                14143.4952424306
            ],
            [
                1.399e-8,
                0.50107877909,
                6309.3741697912
            ],
            [
                1.417e-8,
                3.28454570977,
                25132.3033999656
            ],
            [
                1.544e-8,
                1.82062047625,
                5856.4776591154
            ],
            [
                1.457e-8,
                1.75339303307,
                5884.9268465832
            ],
            [
                1.497e-8,
                2.19673914456,
                9437.762934887
            ],
            [
                1.549e-8,
                5.73650061398,
                17789.845619785
            ],
            [
                1.277e-8,
                3.9672171733,
                4705.7323075436
            ],
            [
                1.038e-8,
                2.9481870117,
                6256.7775301916
            ],
            [
                1.018e-8,
                2.24114547164,
                6681.2248533996
            ],
            [
                1.021e-8,
                1.4679502613,
                11790.6290886588
            ],
            [
                9.16e-9,
                3.72965830745,
                1059.3819301892
            ],
            [
                1.156e-8,
                6.04591336669,
                398.1490034082
            ],
            [
                1.24e-8,
                0.77195902957,
                6812.766815086
            ],
            [
                1.115e-8,
                3.92255876225,
                12168.0026965746
            ],
            [
                9.08e-9,
                1.78447918237,
                3930.2096962196
            ],
            [
                8.33e-9,
                0.09941579828,
                11506.7697697936
            ],
            [
                7.9e-9,
                2.45555993228,
                775.522611324
            ],
            [
                6.66e-9,
                4.40761401665,
                5753.3848848968
            ],
            [
                5.2e-9,
                1.60179602491,
                4694.0029547076
            ],
            [
                3.82e-9,
                0.26754532042,
                1577.3435424478
            ],
            [
                4.05e-9,
                1.97558286872,
                6283.0085396886
            ],
            [
                4.05e-9,
                1.53147989887,
                6283.14316029419
            ],
            [
                3.88e-9,
                2.59563818411,
                7058.5984613154
            ],
            [
                3.41e-9,
                3.61275156842,
                13367.9726311066
            ],
            [
                2.8e-9,
                4.63052251735,
                796.2980068164
            ],
            [
                2.76e-9,
                0.43350778219,
                7079.3738568078
            ],
            [
                3.11e-9,
                5.28219636656,
                17260.1546546904
            ],
            [
                2.75e-9,
                5.27597553634,
                11769.8536931664
            ],
            [
                2.86e-9,
                2.98639716345,
                6275.9623029906
            ],
            [
                2.51e-9,
                2.81315684448,
                6290.1893969922
            ],
            [
                2.39e-9,
                5.77837903893,
                10977.078804699
            ],
            [
                2.28e-9,
                0.14375973844,
                3738.761430108
            ],
            [
                2.27e-9,
                2.51020991853,
                7084.8967811152
            ],
            [
                2.11e-9,
                4.7202946547,
                6496.3749454294
            ],
            [
                2.34e-9,
                3.1153527401,
                709.9330485583
            ],
            [
                2.34e-9,
                0.5707581762,
                11856.2186514245
            ],
            [
                2.37e-9,
                2.38791907394,
                213.299095438
            ],
            [
                2.27e-9,
                1.12059781634,
                12352.8526045448
            ],
            [
                1.69e-9,
                3.20148089605,
                5486.777843175
            ],
            [
                1.59e-9,
                3.14604135756,
                8827.3902698748
            ],
            [
                1.6e-9,
                1.14784478002,
                5643.1785636774
            ],
            [
                1.44e-9,
                5.23285657431,
                78051.5857313169
            ],
            [
                1.44e-9,
                1.16454654602,
                90617.7374312997
            ],
            [
                1.44e-9,
                3.81203756929,
                6262.300454499
            ],
            [
                1.43e-9,
                5.97809021355,
                6303.8512454838
            ],
            [
                1.38e-9,
                4.29829933273,
                1589.0728952838
            ],
            [
                1.61e-9,
                3.03298851492,
                20426.571092422
            ],
            [
                1.65e-9,
                5.09134896587,
                17298.1823273262
            ],
            [
                1.28e-9,
                4.41590143012,
                6127.6554505572
            ],
            [
                1.58e-9,
                2.00984506334,
                5230.807466803
            ],
            [
                1.3e-9,
                1.44170683802,
                12569.6748183318
            ],
            [
                1.25e-9,
                1.69950379498,
                3128.3887650958
            ],
            [
                1.52e-9,
                4.96946111415,
                65147.6197681377
            ],
            [
                1.31e-9,
                4.24961399629,
                6282.0955289232
            ],
            [
                1.31e-9,
                5.54051222995,
                6284.0561710596
            ],
            [
                1.61e-9,
                3.32421999691,
                6283.3196674749
            ],
            [
                1.23e-9,
                2.93221463795,
                15720.8387848784
            ],
            [
                1.52e-9,
                1.56488157456,
                18319.5365848796
            ],
            [
                1.14e-9,
                1.89110005546,
                18073.7049386502
            ],
            [
                1.13e-9,
                4.95214866677,
                4136.9104335162
            ],
            [
                1.11e-9,
                4.79699611405,
                8429.2412664666
            ],
            [
                1.18e-9,
                3.06184958762,
                22003.9146348698
            ],
            [
                1.28e-9,
                2.09693027395,
                12562.6285816338
            ],
            [
                1.38e-9,
                0.84648544836,
                6069.7767545534
            ],
            [
                1e-9,
                0.41938790104,
                5481.2549188676
            ],
            [
                1.01e-9,
                4.43791289246,
                19651.048481098
            ],
            [
                1.16e-9,
                1.87002428935,
                77713.7714681205
            ],
            [
                9.5e-10,
                0.68638183645,
                3340.6124266998
            ],
            [
                1.04e-9,
                4.90822646457,
                8635.9420037632
            ],
            [
                1.14e-9,
                0.36008214928,
                23543.23050468179
            ],
            [
                9.1e-10,
                1.1761121931,
                9225.539273283
            ],
            [
                9.1e-10,
                2.74682631104,
                5216.5803728014
            ],
            [
                8.6e-10,
                3.09315282195,
                1194.4470102246
            ],
            [
                9.3e-10,
                6.2764351319,
                12559.038152982
            ],
            [
                8.7e-10,
                3.64926989547,
                7.1135470008
            ],
            [
                8.3e-10,
                0.37008971174,
                11371.7046897582
            ],
            [
                9.8e-10,
                4.68473306376,
                167283.7615876655
            ],
            [
                9.8e-10,
                0.99865886857,
                154717.6098876827
            ],
            [
                8.6e-10,
                4.41152307486,
                25934.1243310894
            ],
            [
                9.8e-10,
                4.98209568932,
                16496.3613962024
            ],
            [
                8.5e-10,
                2.35438163823,
                3154.6870848956
            ],
            [
                8.3e-10,
                0.24859477658,
                21228.3920235458
            ],
            [
                7.6e-10,
                5.46661600296,
                29864.334027309
            ],
            [
                6.9e-10,
                3.22045334237,
                801.8209311238
            ],
            [
                6.8e-10,
                2.19928242745,
                37724.7534197482
            ],
            [
                7e-10,
                5.33711014698,
                2544.3144198834
            ],
            [
                5.5e-10,
                5.37872238211,
                11015.1064773348
            ],
            [
                5.1e-10,
                5.03600618727,
                5863.5912061162
            ],
            [
                5.9e-10,
                3.54984809612,
                4535.0594369244
            ],
            [
                5.3e-10,
                1.50812064137,
                7342.4577801806
            ],
            [
                4.4e-10,
                1.33712241647,
                4164.311989613
            ],
            [
                5.5e-10,
                5.38460045253,
                7477.522860216
            ],
            [
                4.9e-10,
                5.61844340512,
                24072.9214697764
            ],
            [
                5.7e-10,
                6.17973522898,
                8031.0922630584
            ],
            [
                5.2e-10,
                4.24379064407,
                5088.6288397668
            ],
            [
                4.1e-10,
                3.41960196246,
                26087.9031415742
            ],
            [
                5.2e-10,
                1.68150981131,
                25158.6017197654
            ],
            [
                5.3e-10,
                0.11041408311,
                29088.811415985
            ],
            [
                4.3e-10,
                0.53354396923,
                2146.1654164752
            ],
            [
                5e-10,
                0.60270799844,
                33794.5437235286
            ],
            [
                4.5e-10,
                1.69577010458,
                6702.5604938666
            ],
            [
                3.7e-10,
                6.09033460795,
                64809.80550494129
            ],
            [
                4.4e-10,
                2.67993061247,
                15110.4661198662
            ],
            [
                4.7e-10,
                3.62555676035,
                41654.9631159678
            ],
            [
                3.6e-10,
                0.47219666269,
                13095.8426650774
            ],
            [
                3.5e-10,
                5.99520523215,
                23581.2581773176
            ],
            [
                4.3e-10,
                4.08726331262,
                156137.47598479927
            ],
            [
                4.3e-10,
                5.17376496602,
                18422.62935909819
            ],
            [
                3.4e-10,
                2.14460100274,
                4933.2084403326
            ],
            [
                3e-10,
                4.12992793541,
                426.598190876
            ],
            [
                3.6e-10,
                2.28596930002,
                90279.92316810328
            ],
            [
                3.2e-10,
                0.81117747619,
                26.2983197998
            ],
            [
                2.8e-10,
                4.07036560467,
                14712.317116458
            ],
            [
                2.5e-10,
                1.92905243842,
                1748.016413067
            ],
            [
                2.4e-10,
                5.06152880842,
                16730.4636895958
            ],
            [
                2.3e-10,
                3.24047012195,
                31415.379249957
            ],
            [
                2.7e-10,
                3.90672018305,
                18451.07854656599
            ],
            [
                2.1e-10,
                3.51419811826,
                10447.3878396044
            ]
        ],
        "2": [
            [
                0.00009721424,
                5.1519280992,
                6283.0758499914
            ],
            [
                0.00000233002,
                3.14159265359,
                0
            ],
            [
                0.00000134188,
                0.64406212977,
                12566.1516999828
            ],
            [
                6.504e-8,
                1.07333397797,
                18849.2275499742
            ],
            [
                1.662e-8,
                1.62746869551,
                84334.66158130829
            ],
            [
                6.35e-9,
                3.51985338656,
                6279.5527316424
            ],
            [
                4.92e-9,
                2.41382223971,
                1047.7473117547
            ],
            [
                3.07e-9,
                6.10181422085,
                5223.6939198022
            ],
            [
                3.22e-9,
                0.37660897389,
                6286.5989683404
            ],
            [
                3.26e-9,
                2.35727931602,
                5507.5532386674
            ],
            [
                2.74e-9,
                1.65307581765,
                7860.4193924392
            ],
            [
                2.28e-9,
                1.14082932988,
                25132.3033999656
            ],
            [
                2.02e-9,
                0.4983668253,
                2352.8661537718
            ],
            [
                2.01e-9,
                0.155527656,
                10213.285546211
            ],
            [
                1.67e-9,
                3.98005254015,
                529.6909650946
            ],
            [
                1.7e-9,
                5.28668290523,
                6256.7775301916
            ],
            [
                1.66e-9,
                3.04613930284,
                12036.4607348882
            ],
            [
                1.53e-9,
                4.06779216239,
                83996.84731811189
            ],
            [
                1.5e-9,
                3.18772213951,
                71430.69561812909
            ],
            [
                1.2e-9,
                3.13558669517,
                5884.9268465832
            ],
            [
                1.23e-9,
                4.17102530625,
                6309.3741697912
            ],
            [
                1e-9,
                1.46356761368,
                11506.7697697936
            ],
            [
                1e-9,
                3.00322421365,
                11790.6290886588
            ],
            [
                7.7e-10,
                1.65643898948,
                4705.7323075436
            ],
            [
                6.8e-10,
                6.03791904123,
                6812.766815086
            ],
            [
                7.5e-10,
                4.85191600582,
                14143.4952424306
            ],
            [
                7.9e-10,
                4.12628805658,
                5753.3848848968
            ],
            [
                6.4e-10,
                2.7194416046,
                6127.6554505572
            ],
            [
                6.3e-10,
                0.78655326011,
                6438.4962494256
            ],
            [
                7.5e-10,
                0.84213523741,
                167621.5758508619
            ],
            [
                5.1e-10,
                4.55059044701,
                5486.777843175
            ],
            [
                5e-10,
                5.29314320585,
                7079.3738568078
            ],
            [
                4.5e-10,
                0.33147576416,
                775.522611324
            ],
            [
                4.3e-10,
                3.6179371164,
                1577.3435424478
            ],
            [
                5.7e-10,
                6.15295833679,
                12194.0329146209
            ],
            [
                4.5e-10,
                1.18274698508,
                17789.845619785
            ],
            [
                4.7e-10,
                1.11643162773,
                398.1490034082
            ],
            [
                4.7e-10,
                5.5298423843,
                12168.0026965746
            ],
            [
                4.2e-10,
                2.6437530062,
                10988.808157535
            ],
            [
                3.7e-10,
                0.31226891972,
                6681.2248533996
            ],
            [
                4.6e-10,
                3.38617099014,
                156475.2902479957
            ],
            [
                3.3e-10,
                1.26266496002,
                6290.1893969922
            ],
            [
                3.3e-10,
                2.25067065498,
                6275.9623029906
            ],
            [
                2.7e-10,
                1.72859626293,
                1059.3819301892
            ],
            [
                2.8e-10,
                2.88681054153,
                796.2980068164
            ],
            [
                3e-10,
                5.52021264181,
                7058.5984613154
            ],
            [
                2.1e-10,
                6.22275008403,
                6069.7767545534
            ],
            [
                2.4e-10,
                5.83690442827,
                6282.0955289232
            ],
            [
                2.4e-10,
                3.95322179797,
                6284.0561710596
            ],
            [
                2.1e-10,
                4.87022458966,
                3738.761430108
            ],
            [
                2.1e-10,
                3.58048145762,
                6496.3749454294
            ],
            [
                2.2e-10,
                1.97770318395,
                7.1135470008
            ],
            [
                1.9e-10,
                3.4597988877,
                4136.9104335162
            ],
            [
                1.5e-10,
                2.81379880771,
                1589.0728952838
            ],
            [
                1.5e-10,
                1.61313151838,
                1194.4470102246
            ],
            [
                1.5e-10,
                0.63083434831,
                11769.8536931664
            ],
            [
                1.9e-10,
                0.28082047767,
                17260.1546546904
            ],
            [
                1.7e-10,
                1.35165136146,
                78051.5857313169
            ],
            [
                1.5e-10,
                2.3094159956,
                11856.2186514245
            ],
            [
                1.2e-10,
                1.12997370513,
                90617.7374312997
            ],
            [
                1.2e-10,
                0.00611601597,
                18073.7049386502
            ],
            [
                1.2e-10,
                1.70058636365,
                12559.038152982
            ]
        ],
        "3": [
            [
                0.00000275993,
                0.59480097092,
                6283.0758499914
            ],
            [
                1.7034e-7,
                3.14159265359,
                0
            ],
            [
                3.617e-8,
                0.11750575325,
                12566.1516999828
            ],
            [
                3.39e-9,
                5.66087461682,
                18849.2275499742
            ],
            [
                5.6e-10,
                5.02765554835,
                6279.5527316424
            ],
            [
                1.9e-10,
                5.99007646261,
                6256.7775301916
            ],
            [
                1.8e-10,
                3.80004734567,
                6309.3741697912
            ],
            [
                1.8e-10,
                1.21049250774,
                6127.6554505572
            ],
            [
                1.8e-10,
                2.29734567137,
                6438.4962494256
            ],
            [
                1.5e-10,
                4.72881467263,
                6286.5989683404
            ],
            [
                1.2e-10,
                0.41481671808,
                83996.84731811189
            ],
            [
                1.3e-10,
                5.54637369296,
                25132.3033999656
            ],
            [
                1e-10,
                2.91937214232,
                71430.69561812909
            ],
            [
                6e-11,
                2.1417324121,
                11856.2186514245
            ]
        ],
        "4": [
            [
                5.745e-8,
                2.26734029843,
                6283.0758499914
            ],
            [
                8.7e-9,
                0,
                0
            ],
            [
                1.19e-9,
                4.26807972611,
                12566.1516999828
            ],
            [
                1.7e-10,
                4.0742262044,
                18849.2275499742
            ],
            [
                5e-11,
                0.84308705203,
                1047.7473117547
            ],
            [
                5e-11,
                0.05711572303,
                84334.66158130829
            ]
        ],
        "5": [
            [
                1.14e-9,
                4.31455980099,
                6283.0758499914
            ],
            [
                2.4e-10,
                0,
                0
            ]
        ]
    },
    R: {
        "0": [
            [
                1.00013988784,
                0,
                0
            ],
            [
                0.01670699632,
                3.09846350258,
                6283.0758499914
            ],
            [
                0.00013956024,
                3.05524609456,
                12566.1516999828
            ],
            [
                0.0000308372,
                5.19846674381,
                77713.7714681205
            ],
            [
                0.00001628463,
                1.17387558054,
                5753.3848848968
            ],
            [
                0.00001575572,
                2.84685214877,
                7860.4193924392
            ],
            [
                0.00000924799,
                5.45292236722,
                11506.7697697936
            ],
            [
                0.00000542439,
                4.56409151453,
                3930.2096962196
            ],
            [
                0.0000047211,
                3.66100022149,
                5884.9268465832
            ],
            [
                0.0000032878,
                5.89983686142,
                5223.6939198022
            ],
            [
                0.00000345969,
                0.96368627272,
                5507.5532386674
            ],
            [
                0.00000306784,
                0.29867139512,
                5573.1428014331
            ],
            [
                0.00000174844,
                3.01193636733,
                18849.2275499742
            ],
            [
                0.00000243181,
                4.2734953079,
                11790.6290886588
            ],
            [
                0.00000211836,
                5.84714461348,
                1577.3435424478
            ],
            [
                0.0000018574,
                5.02199710705,
                10977.078804699
            ],
            [
                0.00000109835,
                5.0551063586,
                5486.777843175
            ],
            [
                9.8316e-7,
                0.88681311278,
                6069.7767545534
            ],
            [
                8.65e-7,
                5.68956418946,
                15720.8387848784
            ],
            [
                8.5831e-7,
                1.27079125277,
                161000.6857376741
            ],
            [
                6.2917e-7,
                0.92177053978,
                529.6909650946
            ],
            [
                5.7056e-7,
                2.01374292245,
                83996.84731811189
            ],
            [
                6.4908e-7,
                0.27251341435,
                17260.1546546904
            ],
            [
                4.9384e-7,
                3.24501240359,
                2544.3144198834
            ],
            [
                5.5736e-7,
                5.2415979917,
                71430.69561812909
            ],
            [
                4.252e-7,
                6.01110257982,
                6275.9623029906
            ],
            [
                4.6966e-7,
                2.57799853213,
                775.522611324
            ],
            [
                3.8963e-7,
                5.36063832897,
                4694.0029547076
            ],
            [
                4.4666e-7,
                5.53715663816,
                9437.762934887
            ],
            [
                3.5661e-7,
                1.67447135798,
                12036.4607348882
            ],
            [
                3.1922e-7,
                0.18368299942,
                5088.6288397668
            ],
            [
                3.1846e-7,
                1.77775642078,
                398.1490034082
            ],
            [
                3.3193e-7,
                0.24370221704,
                7084.8967811152
            ],
            [
                3.8245e-7,
                2.39255343973,
                8827.3902698748
            ],
            [
                2.8468e-7,
                1.21344887533,
                6286.5989683404
            ],
            [
                3.7486e-7,
                0.82961281844,
                19651.048481098
            ],
            [
                3.6957e-7,
                4.90107587287,
                12139.5535091068
            ],
            [
                3.4537e-7,
                1.84270693281,
                2942.4634232916
            ],
            [
                2.6275e-7,
                4.58896863104,
                10447.3878396044
            ],
            [
                2.4596e-7,
                3.78660838036,
                8429.2412664666
            ],
            [
                2.3587e-7,
                0.26866098169,
                796.2980068164
            ],
            [
                2.7795e-7,
                1.89934427832,
                6279.5527316424
            ],
            [
                2.3927e-7,
                4.99598548145,
                5856.4776591154
            ],
            [
                2.0345e-7,
                4.65282190725,
                2146.1654164752
            ],
            [
                2.3287e-7,
                2.80783632869,
                14143.4952424306
            ],
            [
                2.2099e-7,
                1.95002636847,
                3154.6870848956
            ],
            [
                1.9509e-7,
                5.38233922479,
                2352.8661537718
            ],
            [
                1.7958e-7,
                0.1987136996,
                6812.766815086
            ],
            [
                1.7178e-7,
                4.43322156854,
                10213.285546211
            ],
            [
                1.619e-7,
                5.23159323213,
                17789.845619785
            ],
            [
                1.7315e-7,
                6.15224075188,
                16730.4636895958
            ],
            [
                1.3814e-7,
                5.18962074032,
                8031.0922630584
            ],
            [
                1.8834e-7,
                0.67280058021,
                149854.4001348079
            ],
            [
                1.833e-7,
                2.25348717053,
                23581.2581773176
            ],
            [
                1.3639e-7,
                3.68511810757,
                4705.7323075436
            ],
            [
                1.3142e-7,
                0.65267698994,
                13367.9726311066
            ],
            [
                1.0414e-7,
                4.33285688501,
                11769.8536931664
            ],
            [
                9.978e-8,
                4.20126336356,
                6309.3741697912
            ],
            [
                1.017e-7,
                1.59366684542,
                4690.4798363586
            ],
            [
                7.564e-8,
                2.62560597391,
                6256.7775301916
            ],
            [
                9.654e-8,
                3.67583728703,
                27511.4678735372
            ],
            [
                6.743e-8,
                0.56269927047,
                3340.6124266998
            ],
            [
                8.743e-8,
                6.06359123461,
                1748.016413067
            ],
            [
                7.786e-8,
                3.67371235367,
                12168.0026965746
            ],
            [
                6.633e-8,
                5.66149277789,
                11371.7046897582
            ],
            [
                7.712e-8,
                0.31242577788,
                7632.9432596502
            ],
            [
                6.586e-8,
                3.13580054586,
                801.8209311238
            ],
            [
                7.46e-8,
                5.6475806666,
                11926.2544136688
            ],
            [
                6.933e-8,
                2.92384586372,
                6681.2248533996
            ],
            [
                6.805e-8,
                1.42327153767,
                23013.5395395872
            ],
            [
                6.118e-8,
                5.13395999022,
                1194.4470102246
            ],
            [
                6.477e-8,
                2.64986648493,
                19804.8272915828
            ],
            [
                5.233e-8,
                4.62432817299,
                6438.4962494256
            ],
            [
                6.147e-8,
                3.02863936662,
                233141.3144043615
            ],
            [
                4.608e-8,
                1.72194702724,
                7234.794256242
            ],
            [
                4.221e-8,
                1.55697533726,
                7238.6755916
            ],
            [
                5.31e-8,
                2.40821524293,
                11499.6562227928
            ],
            [
                5.128e-8,
                5.3239896569,
                11513.8833167944
            ],
            [
                4.77e-8,
                0.2555431173,
                11856.2186514245
            ],
            [
                5.519e-8,
                2.09089153789,
                17298.1823273262
            ],
            [
                5.625e-8,
                4.34052903053,
                90955.5516944961
            ],
            [
                4.578e-8,
                4.4656964157,
                5746.271337896
            ],
            [
                3.788e-8,
                4.9072829481,
                4164.311989613
            ],
            [
                5.337e-8,
                5.09957905103,
                31441.6775697568
            ],
            [
                3.967e-8,
                1.20054555175,
                1349.8674096588
            ],
            [
                4.005e-8,
                3.02853885902,
                1059.3819301892
            ],
            [
                3.48e-8,
                0.76066308841,
                10973.55568635
            ],
            [
                4.232e-8,
                1.05485713117,
                5760.4984318976
            ],
            [
                4.582e-8,
                3.76570026763,
                6386.16862421
            ],
            [
                3.335e-8,
                3.13829943354,
                6836.6452528338
            ],
            [
                3.42e-8,
                3.00043974511,
                4292.3308329504
            ],
            [
                3.595e-8,
                5.70703236079,
                5643.1785636774
            ],
            [
                3.236e-8,
                4.16387400645,
                9917.6968745098
            ],
            [
                4.154e-8,
                2.59940749519,
                7058.5984613154
            ],
            [
                3.362e-8,
                4.54577164994,
                4732.0306273434
            ],
            [
                2.978e-8,
                1.3056126882,
                6283.14316029419
            ],
            [
                2.765e-8,
                0.51311975671,
                26.2983197998
            ],
            [
                2.807e-8,
                5.66230537649,
                8635.9420037632
            ],
            [
                2.927e-8,
                5.7378783408,
                16200.7727245012
            ],
            [
                3.167e-8,
                1.691817599,
                11015.1064773348
            ],
            [
                2.598e-8,
                2.96244118358,
                25132.3033999656
            ],
            [
                3.519e-8,
                3.62639325753,
                244287.60000722768
            ],
            [
                2.676e-8,
                4.20727719487,
                18073.7049386502
            ],
            [
                2.978e-8,
                1.74971565805,
                6283.0085396886
            ],
            [
                2.287e-8,
                1.06976449088,
                14314.1681130498
            ],
            [
                2.863e-8,
                5.92838917309,
                14712.317116458
            ],
            [
                3.071e-8,
                0.23793217,
                35371.8872659764
            ],
            [
                2.656e-8,
                0.89959301615,
                12352.8526045448
            ],
            [
                2.415e-8,
                2.799751768,
                709.9330485583
            ],
            [
                2.811e-8,
                3.51513864541,
                21228.3920235458
            ],
            [
                1.977e-8,
                2.61358297551,
                951.7184062506
            ],
            [
                2.548e-8,
                2.47684686575,
                6208.2942514241
            ],
            [
                1.999e-8,
                0.56090396506,
                7079.3738568078
            ],
            [
                2.305e-8,
                1.05376463592,
                22483.84857449259
            ],
            [
                1.855e-8,
                2.86093570752,
                5216.5803728014
            ],
            [
                2.157e-8,
                1.31395211105,
                154717.6098876827
            ],
            [
                1.97e-8,
                4.36931551625,
                167283.7615876655
            ],
            [
                1.754e-8,
                2.14452400686,
                6290.1893969922
            ],
            [
                1.628e-8,
                5.85704450617,
                10984.1923516998
            ],
            [
                2.154e-8,
                6.03828353794,
                10873.9860304804
            ],
            [
                1.714e-8,
                3.70158195222,
                1592.5960136328
            ],
            [
                1.541e-8,
                6.21599512982,
                23543.23050468179
            ],
            [
                1.602e-8,
                1.99860679677,
                10969.9652576982
            ],
            [
                1.712e-8,
                1.34295218697,
                3128.3887650958
            ],
            [
                1.647e-8,
                5.54948299069,
                6496.3749454294
            ],
            [
                1.495e-8,
                5.43980459648,
                155.4203994342
            ],
            [
                1.827e-8,
                5.91227480351,
                3738.761430108
            ],
            [
                1.726e-8,
                2.16765465036,
                10575.4066829418
            ],
            [
                1.532e-8,
                5.35683107063,
                13521.7514415914
            ],
            [
                1.824e-8,
                1.66056145084,
                39302.096962196
            ],
            [
                1.605e-8,
                1.90930973224,
                6133.5126528568
            ],
            [
                1.282e-8,
                2.46013372544,
                13916.0191096416
            ],
            [
                1.211e-8,
                4.4136063155,
                3894.1818295422
            ],
            [
                1.394e-8,
                1.7780192925,
                9225.539273283
            ],
            [
                1.571e-8,
                4.95512957606,
                25158.6017197654
            ],
            [
                1.205e-8,
                1.19212756308,
                3.523118349
            ],
            [
                1.132e-8,
                2.69830084955,
                6040.3472460174
            ],
            [
                1.504e-8,
                5.77577388271,
                18209.33026366019
            ],
            [
                1.393e-8,
                1.62625077326,
                5120.6011455836
            ],
            [
                1.081e-8,
                2.93726744446,
                17256.6315363414
            ],
            [
                1.232e-8,
                0.71651766504,
                143571.32428481648
            ],
            [
                1.087e-8,
                0.99769687961,
                955.5997416086
            ],
            [
                1.068e-8,
                5.28472576591,
                65147.6197681377
            ],
            [
                1.169e-8,
                3.11663802316,
                14945.3161735544
            ],
            [
                9.75e-9,
                5.1088726078,
                6172.869528772
            ],
            [
                1.202e-8,
                4.02992510403,
                553.5694028424
            ],
            [
                9.79e-9,
                2.00000879106,
                15110.4661198662
            ],
            [
                9.62e-9,
                4.023807714,
                6282.0955289232
            ],
            [
                9.99e-9,
                3.6264300279,
                6262.300454499
            ],
            [
                1.03e-8,
                5.84987815239,
                213.299095438
            ],
            [
                1.014e-8,
                2.84227679965,
                8662.240323563
            ],
            [
                1.185e-8,
                1.51330629149,
                17654.7805397496
            ],
            [
                9.67e-9,
                2.67081017562,
                5650.2921106782
            ],
            [
                1.222e-8,
                2.65423784904,
                88860.05707098669
            ],
            [
                9.86e-9,
                2.36212814824,
                6206.8097787158
            ],
            [
                1.034e-8,
                0.13634950642,
                11712.9553182308
            ],
            [
                1.103e-8,
                3.08477302937,
                43232.3066584156
            ],
            [
                7.81e-9,
                2.53374971725,
                16496.3613962024
            ],
            [
                1.019e-8,
                3.04569392376,
                6037.244203762
            ],
            [
                7.95e-9,
                5.80662989126,
                5230.807466803
            ],
            [
                8.13e-9,
                3.57702871938,
                10177.2576795336
            ],
            [
                9.62e-9,
                5.31470594766,
                6284.0561710596
            ],
            [
                7.17e-9,
                5.95797471837,
                12559.038152982
            ],
            [
                9.67e-9,
                2.74413738053,
                6244.9428143536
            ],
            [
                9.21e-9,
                0.1016016083,
                29088.811415985
            ],
            [
                7.19e-9,
                5.91788189939,
                4136.9104335162
            ],
            [
                6.88e-9,
                3.89489045092,
                1589.0728952838
            ],
            [
                7.72e-9,
                4.05505380285,
                6127.6554505572
            ],
            [
                7.06e-9,
                5.49323197725,
                22003.9146348698
            ],
            [
                6.65e-9,
                1.60002747134,
                11087.2851259184
            ],
            [
                6.9e-9,
                4.50539825729,
                426.598190876
            ],
            [
                8.54e-9,
                3.2610464506,
                20426.571092422
            ],
            [
                6.56e-9,
                4.3241018294,
                16858.4825329332
            ],
            [
                8.4e-9,
                2.59572585212,
                28766.924424484
            ],
            [
                6.86e-9,
                0.61944033771,
                11403.676995575
            ],
            [
                7e-9,
                3.40901412473,
                7.1135470008
            ],
            [
                7.28e-9,
                0.04050185963,
                5481.2549188676
            ],
            [
                6.53e-9,
                1.0386945123,
                6062.6632075526
            ],
            [
                5.59e-9,
                4.79221805695,
                20199.094959633
            ],
            [
                6.33e-9,
                5.70229959167,
                45892.73043315699
            ],
            [
                5.91e-9,
                6.10986487621,
                9623.6882766912
            ],
            [
                5.2e-9,
                3.62310356479,
                5333.9002410216
            ],
            [
                6.02e-9,
                5.58381898589,
                10344.2950653858
            ],
            [
                4.96e-9,
                2.21027756314,
                1990.745017041
            ],
            [
                6.91e-9,
                1.96733114988,
                12416.5885028482
            ],
            [
                6.4e-9,
                1.59062417043,
                18319.5365848796
            ],
            [
                6.25e-9,
                3.82358168221,
                13517.8701062334
            ],
            [
                4.75e-9,
                1.1702590418,
                12569.6748183318
            ],
            [
                6.6e-9,
                5.08498512995,
                283.8593188652
            ],
            [
                6.64e-9,
                4.50029469969,
                47162.5163546352
            ],
            [
                5.69e-9,
                0.16318535463,
                17267.26820169119
            ],
            [
                5.68e-9,
                3.86100969474,
                6076.8903015542
            ],
            [
                4.62e-9,
                0.26368763517,
                4590.910180489
            ],
            [
                5.35e-9,
                4.83225423196,
                18422.62935909819
            ],
            [
                4.66e-9,
                0.75873879417,
                7342.4577801806
            ],
            [
                5.41e-9,
                3.07212190556,
                226858.23855437007
            ],
            [
                6.1e-9,
                1.53597089605,
                33019.0211122046
            ],
            [
                6.17e-9,
                2.62356328726,
                11190.377900137
            ],
            [
                5.48e-9,
                4.55798855803,
                18875.525869774
            ],
            [
                6.33e-9,
                4.60110281228,
                66567.48586525429
            ],
            [
                5.87e-9,
                5.78087907808,
                632.7837393132
            ],
            [
                6.03e-9,
                5.38458554802,
                316428.22867391503
            ],
            [
                5.25e-9,
                5.01522072363,
                12132.439962106
            ],
            [
                4.69e-9,
                0.59975173763,
                21954.15760939799
            ],
            [
                5.48e-9,
                3.50627043672,
                17253.04110768959
            ],
            [
                5.02e-9,
                0.98804327589,
                11609.8625440122
            ],
            [
                5.68e-9,
                1.98497313089,
                7668.6374249425
            ],
            [
                4.82e-9,
                1.62460405687,
                12146.6670561076
            ],
            [
                3.91e-9,
                3.68718382972,
                18052.9295431578
            ],
            [
                4.57e-9,
                3.7721489661,
                156137.47598479927
            ],
            [
                4.01e-9,
                5.2922154024,
                15671.0817594066
            ],
            [
                4.69e-9,
                1.80963351735,
                12562.6285816338
            ],
            [
                5.14e-9,
                3.37031288919,
                20597.2439630412
            ],
            [
                4.52e-9,
                5.66811219778,
                10454.5013866052
            ],
            [
                3.75e-9,
                4.98528185039,
                9779.1086761254
            ],
            [
                5.23e-9,
                0.97215560834,
                155427.542936241
            ],
            [
                4.03e-9,
                5.1394818977,
                1551.045222648
            ],
            [
                3.72e-9,
                3.69883738807,
                9388.0059094152
            ],
            [
                3.67e-9,
                4.43875659833,
                4535.0594369244
            ],
            [
                4.06e-9,
                4.20863156497,
                12592.4500197826
            ],
            [
                3.62e-9,
                2.55099560446,
                242.728603974
            ],
            [
                4.71e-9,
                4.61907324819,
                5436.9930152402
            ],
            [
                3.88e-9,
                4.960209284,
                24356.7807886416
            ],
            [
                4.41e-9,
                5.83872966262,
                3496.032826134
            ],
            [
                3.49e-9,
                6.16307810648,
                19800.9459562248
            ],
            [
                3.56e-9,
                0.2381908124,
                5429.8794682394
            ],
            [
                3.46e-9,
                5.60809622572,
                2379.1644735716
            ],
            [
                3.8e-9,
                2.72105213132,
                11933.3679606696
            ],
            [
                4.32e-9,
                0.24215988572,
                17996.0311682222
            ],
            [
                3.78e-9,
                5.22516848076,
                7477.522860216
            ],
            [
                3.37e-9,
                5.10885555836,
                5849.3641121146
            ],
            [
                3.15e-9,
                0.57827745123,
                10557.5941608238
            ],
            [
                3.18e-9,
                4.4994900732,
                3634.6210245184
            ],
            [
                3.23e-9,
                1.55850824803,
                10440.2742926036
            ],
            [
                3.14e-9,
                5.77154773334,
                20.7753954924
            ],
            [
                3.03e-9,
                2.34615580398,
                4686.8894077068
            ],
            [
                4.14e-9,
                5.9323760231,
                51092.7260508548
            ],
            [
                3.62e-9,
                2.17561997119,
                28237.2334593894
            ],
            [
                2.88e-9,
                0.18377405421,
                13095.8426650774
            ],
            [
                2.77e-9,
                5.1295220503,
                13119.72110282519
            ],
            [
                3.25e-9,
                6.18608287927,
                6268.8487559898
            ],
            [
                2.73e-9,
                0.30522428863,
                23141.5583829246
            ],
            [
                2.67e-9,
                5.76152585786,
                5966.6839803348
            ],
            [
                3.45e-9,
                2.94246040875,
                36949.2308084242
            ],
            [
                2.53e-9,
                5.20994580359,
                24072.9214697764
            ],
            [
                3.42e-9,
                5.76212804329,
                16460.33352952499
            ],
            [
                3.07e-9,
                6.01039067183,
                22805.7355659936
            ],
            [
                2.61e-9,
                2.00304796059,
                6148.010769956
            ],
            [
                2.38e-9,
                5.08241964961,
                6915.8595893046
            ],
            [
                2.49e-9,
                2.94762789744,
                135.0650800354
            ],
            [
                3.06e-9,
                3.89765478921,
                10988.808157535
            ],
            [
                3.08e-9,
                0.05451027736,
                4701.1165017084
            ],
            [
                3.19e-9,
                2.95712862064,
                163096.18036118348
            ],
            [
                2.72e-9,
                2.07967681309,
                4804.209275927
            ],
            [
                2.09e-9,
                4.43768461442,
                6546.1597733642
            ],
            [
                2.17e-9,
                0.73691592312,
                6303.8512454838
            ],
            [
                2.03e-9,
                0.32033085531,
                25934.1243310894
            ],
            [
                2.05e-9,
                5.22936478995,
                20995.3929664494
            ],
            [
                2.13e-9,
                0.20671418919,
                28286.9904848612
            ],
            [
                1.97e-9,
                0.4828613129,
                16737.5772365966
            ],
            [
                2.3e-9,
                6.06567392849,
                6287.0080032545
            ],
            [
                2.19e-9,
                1.291942163,
                5326.7866940208
            ],
            [
                2.01e-9,
                1.74700937253,
                22743.4093795164
            ],
            [
                2.07e-9,
                4.45440927276,
                6279.4854213396
            ],
            [
                2.69e-9,
                6.0564044503,
                64471.99124174489
            ],
            [
                1.9e-9,
                0.99261116842,
                29296.6153895786
            ],
            [
                1.94e-9,
                3.82656562755,
                419.4846438752
            ],
            [
                2.62e-9,
                5.26961924126,
                522.5774180938
            ],
            [
                2.1e-9,
                4.68618183158,
                6254.6266625236
            ],
            [
                1.97e-9,
                2.80624554186,
                4933.2084403326
            ],
            [
                2.52e-9,
                4.3622015462,
                40879.4405046438
            ],
            [
                2.61e-9,
                1.07241516738,
                55022.9357470744
            ],
            [
                2.33e-9,
                5.41751014958,
                39609.6545831656
            ],
            [
                1.85e-9,
                4.14324541379,
                5642.1982426092
            ],
            [
                2.47e-9,
                3.44855612987,
                6702.5604938666
            ],
            [
                2.05e-9,
                4.04424043226,
                536.8045120954
            ],
            [
                1.91e-9,
                3.15807087926,
                16723.350142595
            ],
            [
                2.22e-9,
                5.16259496507,
                23539.7073863328
            ],
            [
                1.8e-9,
                4.56214752149,
                6489.2613984286
            ],
            [
                2.27e-9,
                0.60156339452,
                5905.7022420756
            ],
            [
                1.7e-9,
                0.93185903228,
                16062.1845261168
            ],
            [
                1.59e-9,
                0.92751013112,
                23937.856389741
            ],
            [
                1.57e-9,
                4.69607868164,
                6805.6532680852
            ],
            [
                2.18e-9,
                0.8553337343,
                16627.3709153772
            ],
            [
                1.69e-9,
                0.94641052064,
                3097.88382272579
            ],
            [
                2.07e-9,
                4.88410451334,
                6286.6662786432
            ],
            [
                1.6e-9,
                4.95943826819,
                10021.8372800994
            ],
            [
                1.75e-9,
                6.12762824563,
                239424.39025435288
            ],
            [
                1.73e-9,
                3.13887234973,
                6179.9830757728
            ],
            [
                1.57e-9,
                3.62822057807,
                18451.07854656599
            ],
            [
                2.06e-9,
                5.74617821138,
                3646.3503773544
            ],
            [
                1.57e-9,
                4.67695912207,
                6709.6740408674
            ],
            [
                1.46e-9,
                3.09506069745,
                4907.3020501456
            ],
            [
                1.65e-9,
                2.2713912876,
                10660.6869350424
            ],
            [
                1.44e-9,
                3.96947747592,
                6019.9919266186
            ],
            [
                1.71e-9,
                5.91302216729,
                6058.7310542895
            ],
            [
                1.44e-9,
                2.1315565512,
                26084.0218062162
            ],
            [
                1.51e-9,
                0.67417383565,
                2388.8940204492
            ],
            [
                1.96e-9,
                1.67718461229,
                2107.0345075424
            ],
            [
                1.46e-9,
                5.10373877968,
                10770.8932562618
            ],
            [
                1.87e-9,
                1.23915444627,
                19402.7969528166
            ],
            [
                1.37e-9,
                1.26247412216,
                12566.2190102856
            ],
            [
                1.91e-9,
                5.03547476279,
                263.0839233728
            ],
            [
                1.37e-9,
                3.52825454595,
                639.897286314
            ],
            [
                1.35e-9,
                0.73840670927,
                5017.508371365
            ],
            [
                1.64e-9,
                2.39195095081,
                6357.8574485587
            ],
            [
                1.68e-9,
                0.05515907462,
                9380.9596727172
            ],
            [
                1.61e-9,
                1.15721259392,
                26735.9452622132
            ],
            [
                1.44e-9,
                1.76097645199,
                5888.4499649322
            ],
            [
                1.31e-9,
                2.51859277344,
                6599.467719648
            ],
            [
                1.42e-9,
                2.43802911123,
                5881.4037282342
            ],
            [
                1.59e-9,
                5.90325893762,
                6281.5913772831
            ],
            [
                1.51e-9,
                3.72338532519,
                12669.2444742014
            ],
            [
                1.32e-9,
                2.38417741883,
                6525.8044539654
            ],
            [
                1.27e-9,
                0.00254936441,
                10027.9031957292
            ],
            [
                1.48e-9,
                2.85102145528,
                6418.1409300268
            ],
            [
                1.43e-9,
                5.7446027956,
                26087.9031415742
            ],
            [
                1.72e-9,
                0.4128996224,
                174242.4659640497
            ],
            [
                1.36e-9,
                4.15497742275,
                6311.5250374592
            ],
            [
                1.7e-9,
                5.98194913129,
                327574.51427678124
            ],
            [
                1.36e-9,
                2.48430537541,
                13341.6743113068
            ],
            [
                1.49e-9,
                0.33002271275,
                245.8316462294
            ],
            [
                1.65e-9,
                2.496679246,
                58953.145443294
            ],
            [
                1.23e-9,
                1.67328384813,
                32217.2001810808
            ],
            [
                1.23e-9,
                3.45660563754,
                6277.552925684
            ],
            [
                1.17e-9,
                0.86065134175,
                6245.0481773556
            ],
            [
                1.49e-9,
                5.61358281003,
                5729.506447149
            ],
            [
                1.28e-9,
                0.71204006448,
                103.0927742186
            ],
            [
                1.59e-9,
                2.43166592149,
                221995.02880149524
            ],
            [
                1.37e-9,
                1.706577092,
                12566.08438968
            ],
            [
                1.29e-9,
                2.80667872683,
                6016.4688082696
            ],
            [
                1.13e-9,
                3.58302904101,
                25685.872802808
            ],
            [
                1.09e-9,
                3.26403795962,
                6819.8803620868
            ],
            [
                1.22e-9,
                0.34120688202,
                1162.4747044078
            ],
            [
                1.06e-9,
                1.59721172719,
                17782.7320727842
            ],
            [
                1.44e-9,
                2.28891651774,
                12489.8856287072
            ],
            [
                1.37e-9,
                5.82029768354,
                44809.6502008634
            ],
            [
                1.34e-9,
                1.26539983018,
                5331.3574437408
            ],
            [
                1.03e-9,
                5.96518130595,
                6321.1035226272
            ],
            [
                1.09e-9,
                0.33808549034,
                11300.5842213564
            ],
            [
                1.29e-9,
                5.8918727719,
                12029.3471878874
            ],
            [
                1.22e-9,
                5.77325634636,
                11919.140866668
            ],
            [
                1.07e-9,
                6.2499898935,
                77690.75950573849
            ],
            [
                1.07e-9,
                1.00535580713,
                77736.78343050249
            ],
            [
                1.15e-9,
                5.86963518266,
                12721.572099417
            ],
            [
                1.02e-9,
                5.66283467269,
                5540.0857894588
            ],
            [
                1.43e-9,
                0.24122178432,
                4214.0690150848
            ],
            [
                1.43e-9,
                0.88529649733,
                7576.560073574
            ],
            [
                1.07e-9,
                2.92124030351,
                31415.379249957
            ],
            [
                1e-9,
                5.99485644501,
                4061.2192153944
            ],
            [
                1.03e-9,
                2.41941934525,
                5547.1993364596
            ],
            [
                1.04e-9,
                4.44106051277,
                2118.7638603784
            ],
            [
                1.1e-9,
                0.37559635174,
                5863.5912061162
            ],
            [
                1.24e-9,
                2.55619029611,
                12539.853380183
            ],
            [
                1.1e-9,
                3.66952094465,
                238004.5241572363
            ],
            [
                1.12e-9,
                4.32512422724,
                97238.62754448749
            ],
            [
                1.2e-9,
                1.26895630075,
                12043.574281889
            ],
            [
                9.7e-10,
                5.42612959752,
                7834.1210726394
            ],
            [
                9.4e-10,
                2.56461130309,
                19004.6479494084
            ],
            [
                1.05e-9,
                5.68272475301,
                16522.6597160022
            ],
            [
                1.17e-9,
                3.65425622684,
                34520.3093093808
            ],
            [
                1.08e-9,
                1.24206843948,
                84672.47584450469
            ],
            [
                9.8e-10,
                0.13589994287,
                11080.1715789176
            ],
            [
                9.7e-10,
                2.46722096722,
                71980.63357473118
            ],
            [
                9.5e-10,
                5.36958330451,
                6288.5987742988
            ],
            [
                9.6e-10,
                0.20796618776,
                18139.2945014159
            ],
            [
                1.11e-9,
                5.01961920313,
                11823.1616394502
            ],
            [
                9e-10,
                2.72355843779,
                26880.3198130326
            ],
            [
                9.9e-10,
                0.90164266199,
                18635.9284545362
            ],
            [
                1.26e-9,
                4.78722177847,
                305281.9430710488
            ],
            [
                1.24e-9,
                5.00979495566,
                172146.9713405403
            ],
            [
                9e-10,
                4.50544881196,
                40077.61957352
            ],
            [
                1.04e-9,
                5.6367968071,
                2787.0430238574
            ],
            [
                9.1e-10,
                5.43564326147,
                6272.0301497275
            ],
            [
                1e-9,
                2.00639461597,
                12323.4230960088
            ],
            [
                1.17e-9,
                2.35555589778,
                83286.91426955358
            ],
            [
                1.05e-9,
                2.59824000109,
                30666.1549584328
            ],
            [
                9e-10,
                2.35779490026,
                12491.3701014155
            ],
            [
                8.9e-10,
                3.57152453732,
                11720.0688652316
            ],
            [
                9.5e-10,
                5.67015349858,
                14919.0178537546
            ],
            [
                8.7e-10,
                1.86043406047,
                27707.5424942948
            ],
            [
                1.06e-9,
                3.04150600352,
                22345.2603761082
            ],
            [
                8.2e-10,
                5.58298993353,
                10241.2022911672
            ],
            [
                8.3e-10,
                3.10607039533,
                36147.4098773004
            ],
            [
                9.4e-10,
                5.47749711149,
                9924.8104215106
            ],
            [
                8.2e-10,
                4.71988314145,
                15141.390794312
            ],
            [
                9.6e-10,
                3.89073946348,
                6379.0550772092
            ],
            [
                1.1e-9,
                4.92131611151,
                5621.8429232104
            ],
            [
                1.1e-9,
                4.89978492291,
                72140.6286666874
            ],
            [
                9.7e-10,
                5.20764563059,
                6303.4311693902
            ],
            [
                8.5e-10,
                1.61269222311,
                33326.5787331742
            ],
            [
                9.3e-10,
                1.32651591333,
                23020.65308658799
            ],
            [
                9e-10,
                0.5773301638,
                26482.1708096244
            ],
            [
                7.8e-10,
                3.99588630754,
                11293.4706743556
            ],
            [
                1.06e-9,
                3.92012705073,
                62883.3551395136
            ],
            [
                9.8e-10,
                2.94397773524,
                316.3918696566
            ],
            [
                7.6e-10,
                3.96310417608,
                29026.48522950779
            ],
            [
                9.8e-10,
                0.95914722366,
                48739.859897083
            ],
            [
                7.8e-10,
                1.97068528043,
                90279.92316810328
            ],
            [
                7.6e-10,
                0.23027966596,
                21424.4666443034
            ],
            [
                7.9e-10,
                1.46227790922,
                8982.810669309
            ],
            [
                7.8e-10,
                2.28840998832,
                266.6070417218
            ],
            [
                7.1e-10,
                1.5194076559,
                33794.5437235286
            ],
            [
                7.6e-10,
                0.22880641443,
                57375.8019008462
            ],
            [
                9.7e-10,
                0.39449562097,
                24279.10701821359
            ],
            [
                7.5e-10,
                2.77638584795,
                12964.300703391
            ],
            [
                7.7e-10,
                5.18846946344,
                11520.9968637952
            ],
            [
                6.8e-10,
                0.50006599129,
                4274.5183108324
            ],
            [
                7.5e-10,
                2.07323762803,
                15664.03552270859
            ],
            [
                7.7e-10,
                0.4666517878,
                16207.886271502
            ],
            [
                8.1e-10,
                4.10452219483,
                161710.6187862324
            ],
            [
                7.1e-10,
                3.91415328513,
                7875.6718636242
            ],
            [
                8.1e-10,
                0.91938383406,
                74.7815985673
            ],
            [
                8.3e-10,
                4.69916218791,
                23006.42599258639
            ],
            [
                6.9e-10,
                0.98999300277,
                6393.2821712108
            ],
            [
                6.5e-10,
                5.41938745446,
                28628.3362260996
            ],
            [
                7.3e-10,
                2.45564765251,
                15508.6151232744
            ],
            [
                6.5e-10,
                3.02336771694,
                5959.570433334
            ],
            [
                6.4e-10,
                0.18375587635,
                1066.49547719
            ],
            [
                8e-10,
                5.81239171612,
                12341.8069042809
            ],
            [
                6.6e-10,
                2.15105504851,
                38.0276726358
            ],
            [
                6.7e-10,
                5.14047250153,
                9814.6041002912
            ],
            [
                6.2e-10,
                2.43313614978,
                10138.1095169486
            ],
            [
                6.8e-10,
                2.24442548639,
                24383.0791084414
            ],
            [
                7.8e-10,
                1.39649333997,
                9411.4646150872
            ],
            [
                5.9e-10,
                4.95362151577,
                35707.7100829074
            ],
            [
                7.3e-10,
                1.35229143121,
                5327.4761083828
            ],
            [
                5.7e-10,
                3.16018882154,
                5490.300961524
            ],
            [
                7.2e-10,
                5.91833527334,
                10881.0995774812
            ],
            [
                6.7e-10,
                0.66414713064,
                29864.334027309
            ],
            [
                6.5e-10,
                0.30352816135,
                7018.9523635232
            ],
            [
                5.9e-10,
                5.36231868425,
                10239.5838660108
            ],
            [
                5.6e-10,
                3.22196331515,
                2636.725472637
            ],
            [
                6.8e-10,
                5.32086226658,
                3116.6594122598
            ],
            [
                5.9e-10,
                1.63156134967,
                61306.0115970658
            ],
            [
                5.4e-10,
                4.29491690425,
                21947.1113727
            ],
            [
                7e-10,
                0.29271565928,
                6528.9074962208
            ],
            [
                5.7e-10,
                5.89190132575,
                34513.2630726828
            ],
            [
                5.4e-10,
                2.51856815404,
                6279.1945146334
            ],
            [
                7.4e-10,
                1.38235845304,
                9967.4538999816
            ],
            [
                5.4e-10,
                0.92276712152,
                6286.9571853494
            ],
            [
                7e-10,
                5.00933012248,
                6453.7487206106
            ],
            [
                5.3e-10,
                3.86543309344,
                32370.9789915656
            ],
            [
                5.5e-10,
                4.51794544854,
                34911.412076091
            ],
            [
                6.3e-10,
                5.41479412056,
                11502.8376165305
            ],
            [
                6.3e-10,
                2.34416220742,
                11510.7019230567
            ],
            [
                5.6e-10,
                0.91310629913,
                9910.583327509
            ],
            [
                6.7e-10,
                4.03308763854,
                34596.3646546524
            ],
            [
                6e-10,
                5.57024703495,
                5756.9080032458
            ],
            [
                7.2e-10,
                2.80863088166,
                10866.8724834796
            ],
            [
                6.6e-10,
                6.12047940728,
                12074.488407524
            ],
            [
                5.1e-10,
                2.59519527563,
                11396.5634485742
            ],
            [
                6.2e-10,
                5.14746754396,
                25287.7237993998
            ],
            [
                5.4e-10,
                2.50994032776,
                5999.2165311262
            ],
            [
                5.1e-10,
                4.51195861837,
                29822.7832363242
            ],
            [
                5.9e-10,
                0.44167237876,
                250570.6758572191
            ],
            [
                5.1e-10,
                3.6884906676,
                6262.7205305926
            ],
            [
                4.9e-10,
                0.54704693048,
                22594.05489571199
            ],
            [
                6.5e-10,
                2.38423614501,
                52670.0695933026
            ],
            [
                6.9e-10,
                5.34363738671,
                66813.5648357332
            ],
            [
                5.6e-10,
                2.67216180349,
                17892.93839400359
            ],
            [
                4.9e-10,
                4.18361320516,
                18606.4989460002
            ],
            [
                5.5e-10,
                0.83886167974,
                20452.8694122218
            ],
            [
                5e-10,
                1.46327331958,
                37455.7264959744
            ],
            [
                5.8e-10,
                3.34847975377,
                33990.6183442862
            ],
            [
                6.5e-10,
                1.45522693982,
                76251.32777062019
            ],
            [
                5.6e-10,
                2.356506642,
                37724.7534197482
            ],
            [
                4.8e-10,
                1.80689447612,
                206.1855484372
            ],
            [
                5.6e-10,
                3.84224878744,
                5483.254724826
            ],
            [
                5.3e-10,
                0.17334326094,
                77717.29458646949
            ],
            [
                5.3e-10,
                0.79879700631,
                77710.24834977149
            ],
            [
                4.7e-10,
                0.43240779709,
                735.8765135318
            ],
            [
                5.3e-10,
                4.58786566028,
                11616.976091013
            ],
            [
                4.8e-10,
                6.20230111054,
                4171.4255366138
            ],
            [
                5.2e-10,
                2.9171905303,
                6993.0088985497
            ],
            [
                5.7e-10,
                3.42008310383,
                50317.2034395308
            ],
            [
                4.8e-10,
                0.12356889012,
                13362.4497067992
            ],
            [
                6e-10,
                5.52056066934,
                949.1756089698
            ],
            [
                4.5e-10,
                3.37963782356,
                10763.779709261
            ],
            [
                4.7e-10,
                5.50958184902,
                12779.4507954208
            ],
            [
                5.2e-10,
                5.42770349015,
                310145.1528239236
            ],
            [
                6.1e-10,
                2.93237974631,
                5791.4125575326
            ],
            [
                4.4e-10,
                2.87440620802,
                8584.6616659008
            ],
            [
                4.6e-10,
                4.0314179656,
                10667.8004820432
            ],
            [
                4.4e-10,
                1.21579107625,
                6272.4391846416
            ],
            [
                4.7e-10,
                2.57670800912,
                11492.542675792
            ],
            [
                4.4e-10,
                3.62570223167,
                63658.8777508376
            ],
            [
                5.1e-10,
                0.84531181151,
                12345.739057544
            ],
            [
                4.6e-10,
                1.17584556517,
                149.5631971346
            ],
            [
                4.3e-10,
                0.01524970172,
                37853.8754993826
            ],
            [
                4.3e-10,
                0.79038834934,
                640.8776073822
            ],
            [
                4.4e-10,
                2.22554419931,
                6293.7125153412
            ],
            [
                4.9e-10,
                1.01528394907,
                149144.46708624958
            ],
            [
                4.1e-10,
                3.27146326065,
                8858.3149443206
            ],
            [
                4.5e-10,
                3.03765521215,
                65236.2212932854
            ],
            [
                5.8e-10,
                5.45843180927,
                1975.492545856
            ],
            [
                4.1e-10,
                1.32190847146,
                2547.8375382324
            ],
            [
                4.7e-10,
                3.67626039848,
                28313.288804661
            ],
            [
                4.7e-10,
                6.21438985953,
                10991.3058987006
            ],
            [
                4e-10,
                2.37237751212,
                8273.8208670324
            ],
            [
                5.6e-10,
                1.09773690181,
                77376.2010224076
            ],
            [
                4e-10,
                2.35698541041,
                2699.7348193176
            ],
            [
                4.3e-10,
                5.28030897946,
                17796.9591667858
            ],
            [
                5.4e-10,
                2.59175932091,
                22910.44676536859
            ],
            [
                5.5e-10,
                0.07988985505,
                83467.15635301729
            ],
            [
                4.1e-10,
                4.47510694062,
                5618.3198048614
            ],
            [
                4e-10,
                1.35670430524,
                27177.8515292002
            ],
            [
                4.1e-10,
                2.48011323946,
                6549.6828917132
            ],
            [
                5e-10,
                2.56387920528,
                82576.9812209953
            ],
            [
                4.2e-10,
                4.78798367468,
                7856.89627409019
            ],
            [
                4.7e-10,
                2.75482175292,
                18202.21671665939
            ],
            [
                3.9e-10,
                1.97008298629,
                24491.4257925834
            ],
            [
                4.2e-10,
                4.04346599946,
                7863.9425107882
            ],
            [
                3.9e-10,
                3.0103393642,
                853.196381752
            ],
            [
                3.8e-10,
                0.49178679251,
                38650.173506199
            ],
            [
                4.4e-10,
                1.35931241699,
                21393.5419698576
            ],
            [
                3.6e-10,
                4.86047906533,
                4157.1984426122
            ],
            [
                4.3e-10,
                5.64354880978,
                1062.9050485382
            ],
            [
                3.9e-10,
                3.92736779879,
                3903.9113764198
            ],
            [
                4e-10,
                5.3969491832,
                9498.2122306346
            ],
            [
                4.3e-10,
                2.40863861919,
                29424.634232916
            ],
            [
                4.6e-10,
                2.08022244271,
                12573.2652469836
            ],
            [
                5e-10,
                6.15760345261,
                78051.34191383338
            ]
        ],
        "1": [
            [
                0.00103018607,
                1.10748968172,
                6283.0758499914
            ],
            [
                0.00001721238,
                1.06442300386,
                12566.1516999828
            ],
            [
                0.00000702217,
                3.14159265359,
                0
            ],
            [
                3.2345e-7,
                1.02168583254,
                18849.2275499742
            ],
            [
                3.0801e-7,
                2.84358443952,
                5507.5532386674
            ],
            [
                2.4978e-7,
                1.31906570344,
                5223.6939198022
            ],
            [
                1.8487e-7,
                1.42428709076,
                1577.3435424478
            ],
            [
                1.0077e-7,
                5.91385248388,
                10977.078804699
            ],
            [
                8.635e-8,
                0.27158192945,
                5486.777843175
            ],
            [
                8.654e-8,
                1.42046854427,
                6275.9623029906
            ],
            [
                5.069e-8,
                1.68613408916,
                5088.6288397668
            ],
            [
                4.985e-8,
                6.01402338185,
                6286.5989683404
            ],
            [
                4.667e-8,
                5.98749245692,
                529.6909650946
            ],
            [
                4.395e-8,
                0.51800423445,
                4694.0029547076
            ],
            [
                3.87e-8,
                4.74932206877,
                2544.3144198834
            ],
            [
                3.755e-8,
                5.07053801166,
                796.2980068164
            ],
            [
                4.1e-8,
                1.08424801084,
                9437.762934887
            ],
            [
                3.518e-8,
                0.02290216978,
                83996.84731811189
            ],
            [
                3.436e-8,
                0.94937503872,
                71430.69561812909
            ],
            [
                3.221e-8,
                6.15628775321,
                2146.1654164752
            ],
            [
                3.418e-8,
                5.4115158188,
                775.522611324
            ],
            [
                2.863e-8,
                5.48433323746,
                10447.3878396044
            ],
            [
                2.525e-8,
                0.24296913555,
                398.1490034082
            ],
            [
                2.205e-8,
                4.94892172085,
                6812.766815086
            ],
            [
                2.186e-8,
                0.41991932164,
                8031.0922630584
            ],
            [
                2.828e-8,
                3.41986300734,
                2352.8661537718
            ],
            [
                2.554e-8,
                6.13241770582,
                6438.4962494256
            ],
            [
                1.932e-8,
                5.31374587091,
                8429.2412664666
            ],
            [
                2.427e-8,
                3.09118902115,
                4690.4798363586
            ],
            [
                1.73e-8,
                1.53685999718,
                4705.7323075436
            ],
            [
                2.25e-8,
                3.6883639562,
                7084.8967811152
            ],
            [
                2.094e-8,
                1.281690604,
                1748.016413067
            ],
            [
                1.483e-8,
                3.22226346483,
                7234.794256242
            ],
            [
                1.434e-8,
                0.81293662216,
                14143.4952424306
            ],
            [
                1.754e-8,
                3.22883705112,
                6279.5527316424
            ],
            [
                1.583e-8,
                4.09815978783,
                11499.6562227928
            ],
            [
                1.575e-8,
                5.53890314149,
                3154.6870848956
            ],
            [
                1.847e-8,
                1.82041234937,
                7632.9432596502
            ],
            [
                1.499e-8,
                3.63177937611,
                11513.8833167944
            ],
            [
                1.337e-8,
                4.64442556061,
                6836.6452528338
            ],
            [
                1.275e-8,
                2.69329661394,
                1349.8674096588
            ],
            [
                1.348e-8,
                6.15284035323,
                5746.271337896
            ],
            [
                1.126e-8,
                3.35676107739,
                17789.845619785
            ],
            [
                1.47e-8,
                3.65282991735,
                1194.4470102246
            ],
            [
                1.101e-8,
                4.4974742767,
                4292.3308329504
            ],
            [
                1.168e-8,
                2.58033028504,
                13367.9726311066
            ],
            [
                1.236e-8,
                5.64980098028,
                5760.4984318976
            ],
            [
                9.85e-9,
                0.65326301914,
                5856.4776591154
            ],
            [
                9.28e-9,
                2.3255501829,
                10213.285546211
            ],
            [
                1.073e-8,
                5.82672338169,
                12036.4607348882
            ],
            [
                9.18e-9,
                0.76907130762,
                16730.4636895958
            ],
            [
                8.76e-9,
                1.50335727807,
                11926.2544136688
            ],
            [
                1.023e-8,
                5.62071200879,
                6256.7775301916
            ],
            [
                8.53e-9,
                0.6567813463,
                155.4203994342
            ],
            [
                8.02e-9,
                4.10519132094,
                951.7184062506
            ],
            [
                8.59e-9,
                1.42880883564,
                5753.3848848968
            ],
            [
                9.92e-9,
                1.1423800161,
                1059.3819301892
            ],
            [
                8.14e-9,
                1.63584008733,
                6681.2248533996
            ],
            [
                6.64e-9,
                4.55039663226,
                5216.5803728014
            ],
            [
                6.27e-9,
                1.50782904323,
                5643.1785636774
            ],
            [
                6.44e-9,
                4.19480024859,
                6040.3472460174
            ],
            [
                5.9e-9,
                6.18371704849,
                4164.311989613
            ],
            [
                6.35e-9,
                0.5242358477,
                6290.1893969922
            ],
            [
                6.5e-9,
                0.97935492869,
                25132.3033999656
            ],
            [
                5.68e-9,
                2.30121525349,
                10973.55568635
            ],
            [
                5.49e-9,
                5.26737827342,
                3340.6124266998
            ],
            [
                5.47e-9,
                2.20143332641,
                1592.5960136328
            ],
            [
                5.26e-9,
                0.92464258271,
                11371.7046897582
            ],
            [
                4.93e-9,
                5.91036281399,
                3894.1818295422
            ],
            [
                4.83e-9,
                1.6600571154,
                12168.0026965746
            ],
            [
                5.14e-9,
                3.59683072524,
                10969.9652576982
            ],
            [
                5.16e-9,
                3.97164781773,
                17298.1823273262
            ],
            [
                5.29e-9,
                5.0353867768,
                9917.6968745098
            ],
            [
                4.87e-9,
                2.50544745305,
                6127.6554505572
            ],
            [
                4.19e-9,
                4.05235655996,
                10984.1923516998
            ],
            [
                5.38e-9,
                5.54081539813,
                553.5694028424
            ],
            [
                4.02e-9,
                2.16859478359,
                7860.4193924392
            ],
            [
                5.52e-9,
                2.32219865498,
                11506.7697697936
            ],
            [
                3.67e-9,
                3.39145698451,
                6496.3749454294
            ],
            [
                3.6e-9,
                5.34467204596,
                7079.3738568078
            ],
            [
                3.34e-9,
                3.61346365667,
                11790.6290886588
            ],
            [
                4.54e-9,
                0.28755421898,
                801.8209311238
            ],
            [
                4.19e-9,
                3.69613970002,
                10575.4066829418
            ],
            [
                3.19e-9,
                0.30793759304,
                16200.7727245012
            ],
            [
                3.76e-9,
                5.81560210508,
                7058.5984613154
            ],
            [
                3.64e-9,
                1.08425056923,
                6309.3741697912
            ],
            [
                2.94e-9,
                4.54798604178,
                11856.2186514245
            ],
            [
                2.9e-9,
                1.26451946335,
                8635.9420037632
            ],
            [
                3.94e-9,
                4.15683669084,
                26.2983197998
            ],
            [
                2.6e-9,
                5.09424572996,
                10177.2576795336
            ],
            [
                2.41e-9,
                2.25766000302,
                11712.9553182308
            ],
            [
                2.39e-9,
                1.06936978753,
                242.728603974
            ],
            [
                2.76e-9,
                3.44260568764,
                5884.9268465832
            ],
            [
                2.55e-9,
                5.38496803122,
                21228.3920235458
            ],
            [
                3.07e-9,
                4.24313885601,
                3738.761430108
            ],
            [
                2.13e-9,
                3.44661200485,
                213.299095438
            ],
            [
                1.98e-9,
                0.69427265195,
                1990.745017041
            ],
            [
                1.95e-9,
                5.16563409007,
                12352.8526045448
            ],
            [
                2.13e-9,
                3.89937836808,
                13916.0191096416
            ],
            [
                2.14e-9,
                4.00445200772,
                5230.807466803
            ],
            [
                1.84e-9,
                5.59805976614,
                6283.14316029419
            ],
            [
                1.84e-9,
                2.85275392124,
                7238.6755916
            ],
            [
                1.79e-9,
                2.54259058252,
                14314.1681130498
            ],
            [
                2.36e-9,
                5.58826125715,
                6069.7767545534
            ],
            [
                1.89e-9,
                2.72689937708,
                6062.6632075526
            ],
            [
                1.84e-9,
                6.04216273598,
                6283.0085396886
            ],
            [
                2.25e-9,
                1.66128561344,
                4732.0306273434
            ],
            [
                2.3e-9,
                3.62591335086,
                6284.0561710596
            ],
            [
                1.72e-9,
                0.97566476085,
                3930.2096962196
            ],
            [
                1.62e-9,
                2.19467339429,
                18073.7049386502
            ],
            [
                2.15e-9,
                1.04672844028,
                3496.032826134
            ],
            [
                1.82e-9,
                5.17782354566,
                17253.04110768959
            ],
            [
                1.67e-9,
                2.17754938066,
                6076.8903015542
            ],
            [
                1.67e-9,
                4.75672473773,
                17267.26820169119
            ],
            [
                1.49e-9,
                0.80944185798,
                709.9330485583
            ],
            [
                1.49e-9,
                0.17584214812,
                9779.1086761254
            ],
            [
                1.92e-9,
                5.00680790235,
                11015.1064773348
            ],
            [
                1.41e-9,
                4.38420380014,
                4136.9104335162
            ],
            [
                1.58e-9,
                4.60969054283,
                9623.6882766912
            ],
            [
                1.33e-9,
                3.30507062245,
                154717.6098876827
            ],
            [
                1.66e-9,
                6.13191098325,
                3.523118349
            ],
            [
                1.81e-9,
                1.60715321141,
                7.1135470008
            ],
            [
                1.5e-9,
                5.28136702046,
                13517.8701062334
            ],
            [
                1.42e-9,
                0.49788089569,
                25158.6017197654
            ],
            [
                1.24e-9,
                6.03440459813,
                9225.539273283
            ],
            [
                1.24e-9,
                0.99251562639,
                65147.6197681377
            ],
            [
                1.28e-9,
                1.92032744711,
                22483.84857449259
            ],
            [
                1.24e-9,
                3.99739675184,
                4686.8894077068
            ],
            [
                1.21e-9,
                2.37814805239,
                167283.7615876655
            ],
            [
                1.23e-9,
                5.6231511294,
                5642.1982426092
            ],
            [
                1.17e-9,
                5.81755956156,
                12569.6748183318
            ],
            [
                1.57e-9,
                3.40236948518,
                16496.3613962024
            ],
            [
                1.3e-9,
                2.10499918142,
                1589.0728952838
            ],
            [
                1.16e-9,
                0.55839966736,
                5849.3641121146
            ],
            [
                1.23e-9,
                5.81645568991,
                6282.0955289232
            ],
            [
                1.1e-9,
                0.42176497674,
                6172.869528772
            ],
            [
                1.5e-9,
                4.26279600865,
                3128.3887650958
            ],
            [
                1.06e-9,
                2.27436561182,
                5429.8794682394
            ],
            [
                1.14e-9,
                1.52894564202,
                12559.038152982
            ],
            [
                1.21e-9,
                0.39459045915,
                12132.439962106
            ],
            [
                1.04e-9,
                2.41845930933,
                426.598190876
            ],
            [
                1.09e-9,
                5.82786999856,
                16858.4825329332
            ],
            [
                1.02e-9,
                4.4662648491,
                23543.23050468179
            ],
            [
                1e-9,
                2.93812275274,
                4535.0594369244
            ],
            [
                9.7e-10,
                3.97935904984,
                6133.5126528568
            ],
            [
                9.8e-10,
                0.87616810121,
                6525.8044539654
            ],
            [
                1.1e-9,
                6.22339014386,
                12146.6670561076
            ],
            [
                9.8e-10,
                3.17344332543,
                10440.2742926036
            ],
            [
                9.6e-10,
                2.44128701699,
                3097.88382272579
            ],
            [
                9.9e-10,
                5.75642493267,
                7342.4577801806
            ],
            [
                9e-10,
                0.18984343165,
                13119.72110282519
            ],
            [
                9.9e-10,
                5.58884724219,
                2388.8940204492
            ],
            [
                9.1e-10,
                6.04278320182,
                20426.571092422
            ],
            [
                8e-10,
                1.29028142103,
                5650.2921106782
            ],
            [
                8.6e-10,
                3.94529200528,
                10454.5013866052
            ],
            [
                8.5e-10,
                1.92836879835,
                29088.811415985
            ],
            [
                7.6e-10,
                2.70726317966,
                143571.32428481648
            ],
            [
                9.1e-10,
                5.63859073351,
                8827.3902698748
            ],
            [
                7.6e-10,
                1.80783856698,
                28286.9904848612
            ],
            [
                7.5e-10,
                3.40858032804,
                5481.2549188676
            ],
            [
                7e-10,
                4.53719487231,
                17256.6315363414
            ],
            [
                8.9e-10,
                1.10064490942,
                11769.8536931664
            ],
            [
                6.6e-10,
                2.78384937771,
                536.8045120954
            ],
            [
                6.8e-10,
                3.88199295043,
                17260.1546546904
            ],
            [
                8.8e-10,
                3.88075269535,
                7477.522860216
            ],
            [
                6.1e-10,
                6.17558202197,
                11087.2851259184
            ],
            [
                6e-10,
                4.34824715818,
                6206.8097787158
            ],
            [
                8.2e-10,
                4.59843208943,
                9388.0059094152
            ],
            [
                7.9e-10,
                1.63139280394,
                4933.2084403326
            ],
            [
                8.1e-10,
                1.55550779371,
                9380.9596727172
            ],
            [
                7.8e-10,
                4.20905757519,
                5729.506447149
            ],
            [
                5.8e-10,
                5.76889633224,
                3634.6210245184
            ],
            [
                6e-10,
                0.93813100594,
                12721.572099417
            ],
            [
                7.1e-10,
                6.11408885148,
                8662.240323563
            ],
            [
                5.7e-10,
                5.48112524468,
                18319.5365848796
            ],
            [
                7e-10,
                0.01749174864,
                14945.3161735544
            ],
            [
                7.4e-10,
                1.0997604582,
                16460.33352952499
            ],
            [
                5.6e-10,
                1.63036186739,
                15720.8387848784
            ],
            [
                5.5e-10,
                4.86788348404,
                13095.8426650774
            ],
            [
                6e-10,
                5.93729841267,
                12539.853380183
            ],
            [
                5.4e-10,
                0.22608242982,
                15110.4661198662
            ],
            [
                5.4e-10,
                2.30250047594,
                16062.1845261168
            ],
            [
                6.4e-10,
                2.13513754101,
                7875.6718636242
            ],
            [
                5.9e-10,
                5.87963500139,
                5331.3574437408
            ],
            [
                5.8e-10,
                2.30546168615,
                955.5997416086
            ],
            [
                4.9e-10,
                1.93839278478,
                5333.9002410216
            ],
            [
                5.4e-10,
                5.80331607119,
                12043.574281889
            ],
            [
                5.4e-10,
                4.44671053809,
                4701.1165017084
            ],
            [
                4.9e-10,
                0.30241161485,
                6805.6532680852
            ],
            [
                4.6e-10,
                2.76898193028,
                6709.6740408674
            ],
            [
                4.6e-10,
                3.98449608961,
                98068.53671630539
            ],
            [
                4.9e-10,
                3.72022009896,
                12323.4230960088
            ],
            [
                4.5e-10,
                3.30065998328,
                22003.9146348698
            ],
            [
                4.8e-10,
                0.71071357303,
                6303.4311693902
            ],
            [
                6.1e-10,
                1.66030429494,
                6262.300454499
            ],
            [
                4.7e-10,
                1.26317154881,
                11919.140866668
            ],
            [
                5.1e-10,
                1.08020906825,
                10988.808157535
            ],
            [
                4.5e-10,
                0.89150445122,
                51868.2486621788
            ],
            [
                4.3e-10,
                0.57756724285,
                24356.7807886416
            ],
            [
                4.3e-10,
                1.61526242998,
                6277.552925684
            ],
            [
                4.5e-10,
                2.96132920534,
                8982.810669309
            ],
            [
                4.3e-10,
                5.74295325645,
                11403.676995575
            ],
            [
                5.5e-10,
                3.14274403422,
                33019.0211122046
            ],
            [
                5.7e-10,
                0.06379726305,
                15671.0817594066
            ],
            [
                4.1e-10,
                2.53761820726,
                6262.7205305926
            ],
            [
                4e-10,
                1.53130436944,
                18451.07854656599
            ],
            [
                5.2e-10,
                1.71451922581,
                1551.045222648
            ],
            [
                5.5e-10,
                0.89439119424,
                11933.3679606696
            ],
            [
                4.5e-10,
                3.88495384656,
                60530.4889857418
            ],
            [
                4e-10,
                4.75740908001,
                38526.574350872
            ],
            [
                4e-10,
                3.77498297348,
                26087.9031415742
            ],
            [
                3.9e-10,
                2.97113832621,
                2118.7638603784
            ],
            [
                4e-10,
                3.36050962605,
                10021.8372800994
            ],
            [
                4.7e-10,
                1.67051113434,
                6303.8512454838
            ],
            [
                5.2e-10,
                5.21827368711,
                77713.7714681205
            ],
            [
                4.7e-10,
                4.26356628717,
                21424.4666443034
            ],
            [
                3.7e-10,
                1.66712389942,
                6819.8803620868
            ],
            [
                3.7e-10,
                0.65746800933,
                12029.3471878874
            ],
            [
                3.5e-10,
                3.36255650927,
                24072.9214697764
            ],
            [
                3.6e-10,
                0.11087914947,
                10344.2950653858
            ],
            [
                4e-10,
                4.14725582115,
                2787.0430238574
            ],
            [
                3.5e-10,
                5.93650887012,
                31570.7996493912
            ],
            [
                3.6e-10,
                2.15108874765,
                30774.5016425748
            ],
            [
                3.6e-10,
                1.75078825382,
                16207.886271502
            ],
            [
                3.4e-10,
                2.75708224536,
                12139.5535091068
            ],
            [
                3.4e-10,
                6.168913788,
                24491.4257925834
            ],
            [
                3.4e-10,
                2.31528650443,
                55798.4583583984
            ],
            [
                3.2e-10,
                4.21446357042,
                15664.03552270859
            ],
            [
                3.4e-10,
                3.19783054699,
                32217.2001810808
            ],
            [
                3.9e-10,
                1.24979117796,
                6418.1409300268
            ],
            [
                3.8e-10,
                5.89832942685,
                640.8776073822
            ],
            [
                3.3e-10,
                4.80200120107,
                16723.350142595
            ],
            [
                3.2e-10,
                1.72442327688,
                27433.88921587499
            ],
            [
                3.5e-10,
                4.44608896525,
                18202.21671665939
            ],
            [
                3.1e-10,
                4.5279073128,
                6702.5604938666
            ],
            [
                3.4e-10,
                3.96287980676,
                18216.443810661
            ],
            [
                3e-10,
                5.06259854444,
                226858.23855437007
            ],
            [
                3.4e-10,
                1.43910280005,
                49515.382508407
            ],
            [
                3e-10,
                0.29303163371,
                13521.7514415914
            ],
            [
                2.9e-10,
                2.0263384022,
                11609.8625440122
            ],
            [
                3e-10,
                2.5492323024,
                9924.8104215106
            ],
            [
                3.2e-10,
                4.91793198558,
                11300.5842213564
            ],
            [
                3e-10,
                0.23284423547,
                23581.2581773176
            ],
            [
                2.9e-10,
                1.62807736495,
                639.897286314
            ],
            [
                2.8e-10,
                3.84568936822,
                2699.7348193176
            ],
            [
                2.9e-10,
                1.83149729794,
                29822.7832363242
            ],
            [
                3.3e-10,
                4.60320094415,
                19004.6479494084
            ],
            [
                2.7e-10,
                1.86151121799,
                6288.5987742988
            ],
            [
                3e-10,
                4.4649407224,
                36147.4098773004
            ],
            [
                2.8e-10,
                5.19684492912,
                5863.5912061162
            ],
            [
                3.5e-10,
                4.52695674113,
                36949.2308084242
            ],
            [
                2.7e-10,
                3.52528177609,
                10770.8932562618
            ],
            [
                2.6e-10,
                1.48499438453,
                11080.1715789176
            ],
            [
                3.5e-10,
                2.82154380962,
                19402.7969528166
            ],
            [
                2.5e-10,
                2.46339998836,
                6279.4854213396
            ],
            [
                2.6e-10,
                4.97688894643,
                16737.5772365966
            ],
            [
                2.7e-10,
                0.408271125,
                12964.300703391
            ],
            [
                2.9e-10,
                4.15148654061,
                45892.73043315699
            ],
            [
                2.6e-10,
                4.56404104286,
                17796.9591667858
            ],
            [
                2.5e-10,
                2.89309528854,
                6286.6662786432
            ],
            [
                2.6e-10,
                4.82914580957,
                1066.49547719
            ],
            [
                3.1e-10,
                3.93096113738,
                29864.334027309
            ],
            [
                2.4e-10,
                6.14987193584,
                18606.4989460002
            ],
            [
                2.4e-10,
                3.74225964547,
                29026.48522950779
            ],
            [
                2.5e-10,
                5.70460621565,
                27707.5424942948
            ],
            [
                2.5e-10,
                5.33928840652,
                15141.390794312
            ],
            [
                2.3e-10,
                2.37624087345,
                17996.0311682222
            ],
            [
                2.6e-10,
                1.34231351782,
                18875.525869774
            ],
            [
                2.2e-10,
                5.5079162612,
                6245.0481773556
            ],
            [
                2.4e-10,
                1.33998410121,
                19800.9459562248
            ],
            [
                2.3e-10,
                0.2251228089,
                6279.7894925736
            ],
            [
                2.2e-10,
                1.17576471775,
                11925.2740926006
            ],
            [
                2.2e-10,
                3.5860360664,
                6915.8595893046
            ],
            [
                2.3e-10,
                3.21621246666,
                6286.3622074092
            ],
            [
                2.9e-10,
                2.09564449439,
                15265.8865193004
            ],
            [
                2.2e-10,
                4.74660932338,
                28230.18722269139
            ],
            [
                2.1e-10,
                2.30688751432,
                5999.2165311262
            ],
            [
                2.8e-10,
                3.92087592807,
                18208.349942592
            ],
            [
                2.1e-10,
                3.22643339385,
                25934.1243310894
            ],
            [
                2.1e-10,
                3.04956726238,
                6566.9351688566
            ],
            [
                2.7e-10,
                5.35645770522,
                33794.5437235286
            ],
            [
                2.5e-10,
                5.91542362188,
                6489.2613984286
            ],
            [
                2e-10,
                1.52296293311,
                135.0650800354
            ],
            [
                1.9e-10,
                1.78134428631,
                156137.47598479927
            ],
            [
                1.9e-10,
                0.34388684087,
                5327.4761083828
            ],
            [
                2.6e-10,
                3.41701003233,
                25287.7237993998
            ],
            [
                1.9e-10,
                2.86664271911,
                18422.62935909819
            ],
            [
                1.9e-10,
                4.71432851499,
                77690.75950573849
            ],
            [
                1.9e-10,
                2.54227398241,
                77736.78343050249
            ],
            [
                2e-10,
                5.91915117116,
                48739.859897083
            ]
        ],
        "2": [
            [
                0.00004359385,
                5.78455133808,
                6283.0758499914
            ],
            [
                0.00000123633,
                5.57935427994,
                12566.1516999828
            ],
            [
                1.2342e-7,
                3.14159265359,
                0
            ],
            [
                8.792e-8,
                3.62777893099,
                77713.7714681205
            ],
            [
                5.689e-8,
                1.86958905084,
                5573.1428014331
            ],
            [
                3.302e-8,
                5.47034879713,
                18849.2275499742
            ],
            [
                1.471e-8,
                4.47964125007,
                5507.5532386674
            ],
            [
                1.013e-8,
                2.81323115556,
                5223.6939198022
            ],
            [
                8.54e-9,
                3.107765669,
                1577.3435424478
            ],
            [
                1.102e-8,
                2.84173992403,
                161000.6857376741
            ],
            [
                6.48e-9,
                5.47348203398,
                775.522611324
            ],
            [
                6.08e-9,
                1.37894173533,
                6438.4962494256
            ],
            [
                4.99e-9,
                4.4164924225,
                6286.5989683404
            ],
            [
                4.16e-9,
                0.90332697974,
                10977.078804699
            ],
            [
                4.04e-9,
                3.2056726953,
                5088.6288397668
            ],
            [
                3.51e-9,
                1.81081728907,
                5486.777843175
            ],
            [
                4.66e-9,
                3.65086758149,
                7084.8967811152
            ],
            [
                4.58e-9,
                5.38585314743,
                149854.4001348079
            ],
            [
                3.04e-9,
                3.51015066341,
                796.2980068164
            ],
            [
                2.66e-9,
                6.17413982699,
                6836.6452528338
            ],
            [
                2.81e-9,
                1.8387467254,
                4694.0029547076
            ],
            [
                2.62e-9,
                1.41420110644,
                2146.1654164752
            ],
            [
                2.64e-9,
                3.14103683911,
                71430.69561812909
            ],
            [
                3.19e-9,
                5.35037932146,
                3154.6870848956
            ],
            [
                2.38e-9,
                2.17695432424,
                155.4203994342
            ],
            [
                2.29e-9,
                4.7596958807,
                7234.794256242
            ],
            [
                2.91e-9,
                4.61776401638,
                4690.4798363586
            ],
            [
                2.11e-9,
                0.21864885298,
                4705.7323075436
            ],
            [
                2.04e-9,
                4.22895113488,
                1349.8674096588
            ],
            [
                1.95e-9,
                4.58550676556,
                529.6909650946
            ],
            [
                2.55e-9,
                2.81442711144,
                1748.016413067
            ],
            [
                1.82e-9,
                5.70454011389,
                6040.3472460174
            ],
            [
                1.8e-9,
                6.02147727878,
                4292.3308329504
            ],
            [
                1.86e-9,
                1.58690991244,
                6309.3741697912
            ],
            [
                1.67e-9,
                2.88802733052,
                9437.762934887
            ],
            [
                1.66e-9,
                1.99990574734,
                8031.0922630584
            ],
            [
                1.6e-9,
                0.04412738495,
                2544.3144198834
            ],
            [
                1.97e-9,
                2.01089431842,
                1194.4470102246
            ],
            [
                1.65e-9,
                5.78372596774,
                83996.84731811189
            ],
            [
                2.14e-9,
                3.38300910371,
                7632.9432596502
            ],
            [
                1.4e-9,
                0.36669664351,
                10447.3878396044
            ],
            [
                1.51e-9,
                0.95519595275,
                6127.6554505572
            ],
            [
                1.36e-9,
                1.48417295645,
                2352.8661537718
            ],
            [
                1.28e-9,
                5.48057748834,
                951.7184062506
            ],
            [
                1.26e-9,
                5.26866506592,
                6279.5527316424
            ],
            [
                1.27e-9,
                3.77552907014,
                6812.766815086
            ],
            [
                1.03e-9,
                4.95897533789,
                398.1490034082
            ],
            [
                1.04e-9,
                0.70183576826,
                1592.5960136328
            ],
            [
                1.01e-9,
                1.14481598642,
                3894.1818295422
            ],
            [
                1.31e-9,
                0.76624310306,
                553.5694028424
            ],
            [
                1.09e-9,
                5.41063597567,
                6256.7775301916
            ],
            [
                7.8e-10,
                5.84775340741,
                242.728603974
            ],
            [
                9.7e-10,
                1.94685257714,
                11856.2186514245
            ],
            [
                1e-9,
                5.19725292131,
                244287.60000722768
            ],
            [
                7.6e-10,
                0.70480774041,
                8429.2412664666
            ],
            [
                8e-10,
                6.18430772683,
                1059.3819301892
            ],
            [
                6.8e-10,
                5.29561709093,
                14143.4952424306
            ],
            [
                8.5e-10,
                5.39487308005,
                25132.3033999656
            ],
            [
                5.5e-10,
                5.16874637579,
                7058.5984613154
            ],
            [
                6.3e-10,
                0.48494730699,
                801.8209311238
            ],
            [
                5.8e-10,
                4.07254840265,
                13367.9726311066
            ],
            [
                5.1e-10,
                3.89696552232,
                12036.4607348882
            ],
            [
                5.1e-10,
                5.56335232286,
                1990.745017041
            ],
            [
                6e-10,
                2.2504659671,
                8635.9420037632
            ],
            [
                4.9e-10,
                5.58163417371,
                6290.1893969922
            ],
            [
                5.1e-10,
                3.87240194908,
                26.2983197998
            ],
            [
                5.1e-10,
                4.19300909995,
                7860.4193924392
            ],
            [
                4.1e-10,
                3.97169191582,
                10973.55568635
            ],
            [
                4.1e-10,
                3.5708091923,
                7079.3738568078
            ],
            [
                5.6e-10,
                2.76959005761,
                90955.5516944961
            ],
            [
                4.2e-10,
                1.91461189163,
                7477.522860216
            ],
            [
                4.2e-10,
                0.42775891995,
                10213.285546211
            ],
            [
                4.2e-10,
                1.06925480488,
                709.9330485583
            ],
            [
                3.8e-10,
                6.17935925345,
                9917.6968745098
            ],
            [
                5e-10,
                0.81691517401,
                11506.7697697936
            ],
            [
                5.3e-10,
                1.45828359397,
                233141.3144043615
            ],
            [
                3.8e-10,
                3.32444534628,
                5643.1785636774
            ],
            [
                4.7e-10,
                6.21543665927,
                6681.2248533996
            ],
            [
                3.7e-10,
                0.3635930998,
                10177.2576795336
            ],
            [
                4.5e-10,
                5.29587706357,
                10575.4066829418
            ],
            [
                3.4e-10,
                5.63446915337,
                6525.8044539654
            ],
            [
                3.4e-10,
                5.36385158519,
                4933.2084403326
            ],
            [
                3.5e-10,
                5.36152295839,
                25158.6017197654
            ],
            [
                4.2e-10,
                5.08837645072,
                11015.1064773348
            ],
            [
                4.2e-10,
                4.22496037505,
                88860.05707098669
            ],
            [
                3.9e-10,
                1.99171699618,
                6284.0561710596
            ],
            [
                2.9e-10,
                3.1908862817,
                11926.2544136688
            ],
            [
                2.9e-10,
                0.14996158324,
                12168.0026965746
            ],
            [
                3e-10,
                1.58346276808,
                9779.1086761254
            ],
            [
                2.6e-10,
                4.16210340581,
                12569.6748183318
            ],
            [
                3.6e-10,
                2.74684637873,
                3738.761430108
            ],
            [
                2.6e-10,
                0.7282491532,
                1589.0728952838
            ],
            [
                3.1e-10,
                5.34906371821,
                143571.32428481648
            ],
            [
                2.5e-10,
                0.10240267494,
                22483.84857449259
            ],
            [
                3e-10,
                3.47110495524,
                14945.3161735544
            ],
            [
                2.6e-10,
                3.89359701125,
                5753.3848848968
            ],
            [
                2.4e-10,
                1.18744224678,
                4535.0594369244
            ],
            [
                3.3e-10,
                2.99317143244,
                3930.2096962196
            ],
            [
                2.4e-10,
                1.57253767584,
                6496.3749454294
            ],
            [
                2.4e-10,
                3.47434797542,
                4136.9104335162
            ],
            [
                2.2e-10,
                3.91230073719,
                6275.9623029906
            ],
            [
                2.5e-10,
                4.02978941287,
                3128.3887650958
            ],
            [
                2.3e-10,
                1.07724492065,
                12721.572099417
            ],
            [
                2.1e-10,
                1.89591807148,
                16730.4636895958
            ],
            [
                2.5e-10,
                2.42198937013,
                5729.506447149
            ],
            [
                2e-10,
                1.78163489101,
                17789.845619785
            ],
            [
                2.1e-10,
                0.49258939822,
                29088.811415985
            ],
            [
                2.6e-10,
                4.14947806747,
                2388.8940204492
            ],
            [
                2.7e-10,
                2.54785812264,
                3496.032826134
            ],
            [
                2e-10,
                4.29944129273,
                16858.4825329332
            ],
            [
                2.1e-10,
                5.97796936723,
                7.1135470008
            ],
            [
                1.9e-10,
                0.80292033311,
                16062.1845261168
            ],
            [
                2.4e-10,
                4.89894141052,
                17260.1546546904
            ],
            [
                2.5e-10,
                1.37003752175,
                6282.0955289232
            ],
            [
                2.2e-10,
                4.92663152168,
                18875.525869774
            ],
            [
                2.3e-10,
                5.68902059771,
                16460.33352952499
            ],
            [
                2.3e-10,
                3.03021283729,
                66567.48586525429
            ],
            [
                1.6e-10,
                3.89713736666,
                5331.3574437408
            ],
            [
                1.6e-10,
                5.68562539832,
                12559.038152982
            ],
            [
                1.6e-10,
                3.95085099736,
                3097.88382272579
            ],
            [
                1.6e-10,
                3.99041783945,
                6283.14316029419
            ],
            [
                2e-10,
                6.106439191,
                167283.7615876655
            ],
            [
                1.5e-10,
                4.09775914607,
                11712.9553182308
            ],
            [
                1.6e-10,
                5.717699407,
                17298.1823273262
            ],
            [
                1.6e-10,
                3.28894009404,
                5884.9268465832
            ],
            [
                1.5e-10,
                4.4256424368,
                13517.8701062334
            ],
            [
                1.6e-10,
                4.4345208093,
                6283.0085396886
            ],
            [
                1.4e-10,
                1.44384279999,
                4164.311989613
            ],
            [
                1.4e-10,
                4.47380919159,
                11790.6290886588
            ],
            [
                1.4e-10,
                4.77646531825,
                7342.4577801806
            ],
            [
                1.1e-10,
                2.56768522896,
                5481.2549188676
            ],
            [
                1.1e-10,
                1.514433322,
                16200.7727245012
            ],
            [
                1.1e-10,
                0.88708889185,
                21228.3920235458
            ],
            [
                1.4e-10,
                4.50116508534,
                640.8776073822
            ]
        ],
        "3": [
            [
                0.00000144595,
                4.27319433901,
                6283.0758499914
            ],
            [
                6.729e-8,
                3.91706261708,
                12566.1516999828
            ],
            [
                7.74e-9,
                0,
                0
            ],
            [
                2.47e-9,
                3.73021571217,
                18849.2275499742
            ],
            [
                3.6e-10,
                2.8008140905,
                6286.5989683404
            ],
            [
                3.3e-10,
                5.62990083112,
                6127.6554505572
            ],
            [
                1.8e-10,
                3.72826142555,
                6438.4962494256
            ],
            [
                1.6e-10,
                4.26011484232,
                6525.8044539654
            ],
            [
                1.4e-10,
                3.47817116396,
                6256.7775301916
            ],
            [
                1.2e-10,
                3.55747379482,
                25132.3033999656
            ],
            [
                1e-10,
                4.43995693209,
                4705.7323075436
            ],
            [
                1e-10,
                4.2804525547,
                83996.84731811189
            ],
            [
                9e-11,
                5.36457057335,
                6040.3472460174
            ],
            [
                8e-11,
                1.78458957263,
                5507.5532386674
            ],
            [
                9e-11,
                0.4727519993,
                6279.5527316424
            ],
            [
                9e-11,
                1.34741231639,
                6309.3741697912
            ],
            [
                9e-11,
                0.77092900708,
                5729.506447149
            ],
            [
                7e-11,
                3.50146897332,
                7058.5984613154
            ],
            [
                5e-11,
                2.890710617,
                775.522611324
            ],
            [
                6e-11,
                2.36514111314,
                6836.6452528338
            ]
        ],
        "4": [
            [
                3.858e-8,
                2.56389016346,
                6283.0758499914
            ],
            [
                3.06e-9,
                2.26911740541,
                12566.1516999828
            ],
            [
                5.3e-10,
                3.44031471924,
                5573.1428014331
            ],
            [
                1.5e-10,
                2.03136359366,
                18849.2275499742
            ],
            [
                1.3e-10,
                2.05688873673,
                77713.7714681205
            ],
            [
                7e-11,
                4.4121885448,
                161000.6857376741
            ],
            [
                4e-11,
                5.33854414781,
                6438.4962494256
            ],
            [
                6e-11,
                3.81514213664,
                149854.4001348079
            ],
            [
                4e-11,
                4.26602478239,
                6127.6554505572
            ]
        ],
        "5": [
            [
                8.6e-10,
                1.21805304895,
                6283.0758499914
            ],
            [
                1.2e-10,
                0.65572878044,
                12566.1516999828
            ]
        ]
    },
    name: "earth",
    type: "B"
};
exports.default = m;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6nNM5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chinese);
var _dateChinese = require("date-chinese");
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
class Chinese extends (0, _calEventJsDefault.default) {
    inYear(year) {
        let d;
        let jde;
        let date;
        const opts = this.opts;
        if (opts.solarterm) {
            jde = this.cal.solarTerm(opts.solarterm, year);
            date = this.cal.fromJDE(jde).toGregorian();
            d = new (0, _caldateDefault.default)(date).setOffset(opts.day - 1);
        } else {
            this.cal.set(opts.cycle, opts.year, opts.month, opts.leapMonth, opts.day);
            jde = this.cal.toJDE(year);
            date = this.cal.fromJDE(jde).toGregorian();
            d = new (0, _caldateDefault.default)(date);
        }
        this.dates.push(d);
        return this;
    }
    /**
   * @param {object} [opts]
   */ constructor(opts){
        opts = opts || {};
        super(opts);
        switch(opts.fn){
            case "chinese":
                this.cal = new (0, _dateChinese.CalendarChinese)();
                break;
            case "korean":
                this.cal = new (0, _dateChinese.CalendarKorean)();
                break;
            case "vietnamese":
                this.cal = new (0, _dateChinese.CalendarVietnamese)();
                break;
        }
    }
}

},{"date-chinese":"jqzvL","./CalEvent.js":"dCRj3","caldate":"dgF7z","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jqzvL":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarChinese", ()=>(0, _chineseJsDefault.default));
parcelHelpers.export(exports, "CalendarKorean", ()=>(0, _koreanJsDefault.default));
parcelHelpers.export(exports, "CalendarVietnamese", ()=>(0, _vietnameseJsDefault.default));
parcelHelpers.export(exports, "CalendarJapanese", ()=>(0, _japaneseJsDefault.default));
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
var _koreanJs = require("./Korean.js");
var _koreanJsDefault = parcelHelpers.interopDefault(_koreanJs);
var _vietnameseJs = require("./Vietnamese.js");
var _vietnameseJsDefault = parcelHelpers.interopDefault(_vietnameseJs);
var _japaneseJs = require("./Japanese.js");
var _japaneseJsDefault = parcelHelpers.interopDefault(_japaneseJs);

},{"./Chinese.js":"3eq91","./Korean.js":"f4Sw8","./Vietnamese.js":"lDRl6","./Japanese.js":"jJVy8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3eq91":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CalendarChinese);
var _astronomia = require("astronomia");
var _vsop87BearthJs = require("./vsop87Bearth.js");
const earth = new (0, _astronomia.planetposition).Planet((0, _vsop87BearthJs.vsop87Bearth));
const lunarOffset = (0, _astronomia.moonphase).meanLunarMonth / 2;
const p = 180 / Math.PI;
// Start of Chinese Calendar in 2636 BCE by Chalmers
const epochY = -2636;
const epoch = new (0, _astronomia.julian).CalendarGregorian(epochY, 2, 15).toJDE();
function toYear(jde) {
    return new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde).toYear();
}
// prevent rounding errors
function toFixed(val, e) {
    return parseFloat(val.toFixed(e), 10);
}
class CalendarChinese {
    /**
   * set a new chinese date
   *
   * @param {Number|Array|Object} cycle - chinese 60 year cicle; if `{Array}` than `[cycle, year, ..., day]`
   * @param {Number} year - chinese year of cycle
   * @param {Number} month - chinese month
   * @param {Number} leap - `true` if leap month
   * @param {Number} day - chinese day
   */ set(cycle, year, month, leap, day) {
        if (cycle instanceof CalendarChinese) {
            this.cycle = cycle.cycle;
            this.year = cycle.year;
            this.month = cycle.month;
            this.leap = cycle.leap;
            this.day = cycle.day;
        } else if (Array.isArray(cycle)) {
            this.cycle = cycle[0];
            this.year = cycle[1];
            this.month = cycle[2];
            this.leap = cycle[3];
            this.day = cycle[4];
        } else {
            this.cycle = cycle;
            this.year = year;
            this.month = month;
            this.leap = leap;
            this.day = day;
        }
        return this;
    }
    /**
   * returns chinese date
   * @returns {Array}
   */ get() {
        return [
            this.cycle,
            this.year,
            this.month,
            this.leap,
            this.day
        ];
    }
    /**
   * get Gregorian year from Epoch / Cycle
   * @return {Number} year
   */ yearFromEpochCycle() {
        return this._epochY + (this.cycle - 1) * 60 + (this.year - 1);
    }
    /**
   * convert gregorian date to chinese calendar date
   *
   * @param {Number} year - (int) year in Gregorian or Julian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - needs to be in correct (chinese) timezone
   * @return {Object} this
   */ fromGregorian(year, month, day) {
        const j = this.midnight(new (0, _astronomia.julian).CalendarGregorian(year, month, day).toJDE());
        if (month === 1 && day <= 20) year-- // chinese new year never starts before 20/01
        ;
        this._from(j, year);
        return this;
    }
    /**
   * convert date to chinese calendar date
   *
   * @param {Date} date - javascript date object
   * @return {Object} this
   */ fromDate(date) {
        const j = this.midnight(new (0, _astronomia.julian).CalendarGregorian().fromDate(date).toJDE());
        this._from(j, date.getFullYear());
        return this;
    }
    /**
   * convert JDE to chinese calendar date
   *
   * @param {Number} jde - date in JDE
   * @return {Object} this
   */ fromJDE(jde) {
        const j = this.midnight(jde);
        const gc = new (0, _astronomia.julian).CalendarGregorian().fromJDE(j);
        if (gc.month === 1 && gc.day < 20) gc.year-- // chinese new year never starts before 20/01
        ;
        this._from(j, gc.year);
        return this;
    }
    /**
   * common conversion from JDE, year to chinese date
   *
   * @private
   * @param {Number} j - date in JDE
   * @param {Number} year - gregorian year
   */ _from(j, year) {
        let ny = this.newYear(year);
        if (ny > j) ny = this.newYear(year - 1);
        let nm = this.previousNewMoon(j);
        if (nm < ny) nm = ny;
        const years = 1.5 + (ny - this._epoch) / (0, _astronomia.base).BesselianYear;
        this.cycle = 1 + Math.trunc((years - 1) / 60);
        this.year = 1 + Math.trunc((years - 1) % 60);
        this.month = this.inMajorSolarTerm(nm).term;
        const m = Math.round((nm - ny) / (0, _astronomia.moonphase).meanLunarMonth);
        if (m === 0) {
            this.month = 1;
            this.leap = false;
        } else this.leap = this.isLeapMonth(nm);
        if (m > this.month) this.month = m;
        else if (this.leap) this.month--;
        this.day = 1 + Math.trunc(toFixed(j, 3) - toFixed(nm, 3));
    }
    /**
   * convert chinese date to gregorian date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Object} date in gregorian (preleptic) calendar; Timezone is Standard Chinese / Bejing Time
   *   {Number} year - (int)
   *   {Number} month - (int)
   *   {Number} day - (int)
   */ toGregorian(gyear) {
        const jde = this.toJDE(gyear);
        const gc = new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde + 0.5) // add 0.5 as day get truncated
        ;
        return {
            year: gc.year,
            month: gc.month,
            day: Math.trunc(gc.day)
        };
    }
    /**
   * convert chinese date to Date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */ toDate(gyear) {
        const jde = this.toJDE(gyear);
        return new (0, _astronomia.julian).CalendarGregorian().fromJDE(toFixed(jde, 4)).toDate();
    }
    /**
   * convert chinese date to JDE
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Number} date in JDE
   */ toJDE(gyear) {
        const years = gyear || this.yearFromEpochCycle();
        const ny = this.newYear(years);
        let nm = ny;
        if (this.month > 1) {
            nm = this.previousNewMoon(ny + this.month * 29);
            const st = this.inMajorSolarTerm(nm).term;
            const lm = this.isLeapMonth(nm);
            if (st > this.month) nm = this.previousNewMoon(nm - 1);
            else if (st < this.month || lm && !this.leap) nm = this.nextNewMoon(nm + 1);
        }
        if (this.leap) nm = this.nextNewMoon(nm + 1);
        const jde = nm + this.day - 1;
        return jde;
    }
    /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ timeshiftUTC(gcal) {
        if (gcal.toYear() >= 1929) return 8 / 24 // +8:00:00h Standard China time zone (120° East)
        ;
        return 1397 / 180 / 24 // +7:45:40h Beijing (116°25´ East)
        ;
    }
    /**
   * time/date at midnight - truncate `jde` to actual day
   *
   * @param {Number} jde - julian ephemeris day
   * @return {Number} truncated jde
   */ midnight(jde) {
        const gcal = new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde);
        const ts = 0.5 - this.timeshiftUTC(gcal);
        let mn = Math.trunc(gcal.toJD() - ts) + ts;
        mn = gcal.fromJD(mn).toJDE();
        if (toFixed(jde, 5) === toFixed(mn, 5) + 1) return jde;
        return mn;
    }
    /**
   * get major solar term `Z1...Z12` for a given date in JDE
   *
   * @param {Number} jde - date of new moon
   * @returns {Number} major solar term part of that month
   */ inMajorSolarTerm(jde) {
        const lon = this._cache.lon[jde] || (0, _astronomia.solar).apparentVSOP87(earth, jde).lon;
        this._cache.lon[jde] = lon;
        const lonDeg = lon * p - 1e-13;
        const term = (2 + Math.floor(lonDeg / 30)) % 12 + 1;
        return {
            term,
            lon: lonDeg
        };
    }
    /**
   * Test if date `jde` is inside a leap month
   * `jde` and previous new moon need to have the same major solar term
   *
   * @param {Number} jde - date of new moon
   * @returns {Boolean} `true` if previous new moon falls into same solar term
   */ isLeapMonth(jde) {
        const t1 = this.inMajorSolarTerm(jde);
        const next = this.nextNewMoon(this.midnight(jde + lunarOffset));
        const t2 = this.inMajorSolarTerm(next);
        const r = t1.term === t2.term;
        return r;
    }
    /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */ nextNewMoon(jde) {
        let nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde)));
        let cnt = 0;
        while(nm < jde && cnt++ < 4)nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde + cnt * lunarOffset)));
        return nm;
    }
    /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */ previousNewMoon(jde) {
        let nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde)));
        let cnt = 0;
        while(nm > jde && cnt++ < 4)nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde - cnt * lunarOffset)));
        return nm;
    }
    /**
   * chinese new year for a given gregorian year
   *
   * @param {Number} gyear - gregorian year (int)
   * @param {Number} jde at midnight
   */ newYear(gyear) {
        gyear = Math.trunc(gyear);
        if (this._cache.ny[gyear]) return this._cache.ny[gyear];
        const sue1 = this._cache.sue[gyear - 1] || (0, _astronomia.solstice).december2(gyear - 1, earth);
        const sue2 = this._cache.sue[gyear] || (0, _astronomia.solstice).december2(gyear, earth);
        this._cache.sue[gyear - 1] = sue1;
        this._cache.sue[gyear] = sue2;
        const m11n = this.previousNewMoon(this.midnight(sue2 + 1));
        const m12 = this.nextNewMoon(this.midnight(sue1 + 1));
        const m13 = this.nextNewMoon(this.midnight(m12 + lunarOffset));
        this.leapSui = Math.round((m11n - m12) / (0, _astronomia.moonphase).meanLunarMonth) === 12;
        let ny = m13;
        if (this.leapSui && (this.isLeapMonth(m12) || this.isLeapMonth(m13))) ny = this.nextNewMoon(this.midnight(m13 + (0, _astronomia.moonphase).meanLunarMonth / 2));
        this._cache.ny[gyear] = ny;
        return ny;
    }
    /**
   * get solar term from solar longitude
   *
   * @param {Number} term - jiéqì solar term 1 .. 24
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ solarTerm(term, gyear) {
        if (gyear && term <= 3) gyear--;
        const years = gyear || this.yearFromEpochCycle();
        const lon = (term + 20) % 24 * 15 % 360;
        let st = (0, _astronomia.solstice).longitude(years, earth, lon / p);
        st = this.midnight(st);
        return st;
    }
    /**
   * get major solar term
   *
   * @param {Number} term - zhōngqì solar term Z1 .. Z12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ majorSolarTerm(term, gyear) {
        return this.solarTerm(term * 2, gyear);
    }
    /**
   * get minor solar term
   *
   * @param {Number} term - jiéqì solar term J1 .. J12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ minorSolarTerm(term, gyear) {
        return this.solarTerm(term * 2 - 1, gyear);
    }
    /**
   * Qı̄ngmíng - Pure brightness Festival
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ qingming(gyear) {
        return this.solarTerm(5, gyear);
    }
    /**
   * constructor
   *
   * @param {Number|Array|Object} cycle - chinese 60 year cicle; if `{Array}` than `[cycle, year, ..., day]`
   * @param {Number} year - chinese year of cycle
   * @param {Number} month - chinese month
   * @param {Number} leap - `true` if leap month
   * @param {Number} day - chinese day
   */ constructor(cycle, year, month, leap, day){
        this.set(cycle, year, month, leap, day);
        this._epochY = epochY;
        this._epoch = epoch;
        this._cache = {
            lon: {},
            sue: {},
            ny: {}
        };
    }
}

},{"astronomia":"1WNVu","./vsop87Bearth.js":"d3wOz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"d3wOz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vsop87Bearth", ()=>vsop87Bearth);
var _vsop87Bearth = require("astronomia/data/vsop87Bearth");
var _vsop87BearthDefault = parcelHelpers.interopDefault(_vsop87Bearth);
const vsop87Bearth = (0, _vsop87BearthDefault.default);

},{"astronomia/data/vsop87Bearth":"hIa37","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f4Sw8":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CalendarKorean);
var _astronomia = require("astronomia");
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
// Start of Korean Calendar in 2333 BCE (단군기원 http://ko.wikipedia.org/wiki/단기)
const epochY = -2333;
const epoch = new (0, _astronomia.julian).CalendarGregorian(epochY, 1, 27).toJDE();
/**
 * change of timezone shifts during the last century
 * @see https://en.wikipedia.org/wiki/Time_in_South_Korea
 */ const UTC_DATES = [
    {
        date: new Date("1961-10-09T15:00:00.000Z"),
        shift: 9 / 24
    },
    {
        date: new Date("1954-03-20T15:30:00.000Z"),
        shift: 8.5 / 24
    },
    {
        date: new Date("1911-12-31T15:00:00.000Z"),
        shift: 9 / 24
    },
    {
        date: new Date("1908-03-31T15:30:00.000Z"),
        shift: 8.5 / 24
    }
];
class CalendarKorean extends (0, _chineseJsDefault.default) {
    /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ timeshiftUTC(gcal) {
        const date = gcal.toDate();
        for(const i in UTC_DATES){
            if (date >= UTC_DATES[i].date) return UTC_DATES[i].shift;
        }
        return 3809 / 450 / 24 // +8:27:52h Seoul City Hall 126°58'E
        ;
    }
    constructor(cycle, year, month, leap, day){
        super(cycle, year, month, leap, day);
        this._epochY = epochY;
        this._epoch = epoch;
    }
}

},{"astronomia":"1WNVu","./Chinese.js":"3eq91","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"lDRl6":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CalendarVietnamese);
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
class CalendarVietnamese extends (0, _chineseJsDefault.default) {
    /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ timeshiftUTC(gcal) {
        if (gcal.toYear() >= 1968) return 7 / 24 // +7:00:00h
        ;
        return 8 / 24 // +8:00:00h Standard China time zone (120° East)
        ;
    }
}

},{"./Chinese.js":"3eq91","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jJVy8":[function(require,module,exports) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Note: I could not find details about the epoch(s) for the year zero of the
 * Japanese calendar dating before 1873. Therefore this calendar uses (wrongly)
 * the Chinese epoch.
 *
 * According to <https://en.wikipedia.org/wiki/History_of_Japan> the eras are:
 *
 * Yayoi  300 BC – 250 AD
 * Kofun  250 – 538
 * Asuka  538 – 710
 * Nara   710 – 794
 * Heian  794 – 1185
 * Kamakura   1185 – 1333
 * Kenmu Restoration  1333 – 1336
 * Muromachi 1336 – 1573
 * Azuchi–Momoyama 1568 – 1603
 * Edo  1603 – 1868
 * Meiji  1868 – 1912
 * Taishō 1912 – 1926
 * Shōwa  1926 – 1989
 * Heisei 1989 – present
 *
 * Unfortunately the linking from era to calendar era (especially to the Chinese
 * pre 1873 one) is unknown to me.
 */ parcelHelpers.export(exports, "default", ()=>CalendarJapanese);
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
/**
 * @see http://law.e-gov.go.jp/htmldata/M19/M19CO051.html
 */ const UTC_DATES = [
    {
        date: new Date("1888-02-11T15:00:00.000Z"),
        shift: 9 / 24
    } // +9:00:00h (135° East) Japanese standard meridian
];
class CalendarJapanese extends (0, _chineseJsDefault.default) {
    /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ timeshiftUTC(gcal) {
        const date = gcal.toDate();
        for(const i in UTC_DATES){
            if (date >= UTC_DATES[i].date) return UTC_DATES[i].shift;
        }
        return 4193 / 450 / 24 // +9:19:04h (139°46'E)
        ;
    }
}

},{"./Chinese.js":"3eq91","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fWJGQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BengaliRevised);
var _dateBengaliRevised = require("date-bengali-revised");
var _dateBengaliRevisedDefault = parcelHelpers.interopDefault(_dateBengaliRevised);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
class BengaliRevised extends (0, _calEventJsDefault.default) {
    inYear(year) {
        const opts = this.opts;
        const date = new (0, _dateBengaliRevisedDefault.default)(year - 593, opts.month, opts.day).toGregorian();
        const d = new (0, _caldateDefault.default)(date);
        this.dates.push(d);
        return this;
    }
    /**
   * @param {object} [opts]
   */ constructor(opts){
        opts = opts || {};
        super(opts);
    }
}

},{"date-bengali-revised":"f7tCf","caldate":"dgF7z","./CalEvent.js":"dCRj3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f7tCf":[function(require,module,exports) {
/**
 * @copyright 2018-present commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarBengaliRevised", ()=>CalendarBengaliRevised);
var _convertJs = require("./convert.js");
const YEAR0 = 593;
const MILLISECONDS_PER_DAY = 86400000;
const monthDaysNorm = [
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    30,
    30
];
const monthDaysLeap = [
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    31,
    30
];
const isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
const UTC6 = 6 // timezone offset UTC+6
;
const toEpoch = (year)=>Date.UTC(year, 3, 13, UTC6);
class CalendarBengaliRevised {
    /**
   * convert gregorian date to bengali calendar date
   * @param {Number} year - (int) year in Gregorian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - (int)
   * @return {Object} this
   */ fromGregorian(year, month, day) {
        const monthDays = isLeapYear(year) ? monthDaysLeap : monthDaysNorm;
        let _year = year;
        if (month < 4 || month === 4 && day < 14) _year -= 1;
        this.year = _year - YEAR0;
        const date = Date.UTC(year, month - 1, day, UTC6);
        let days = Math.floor((date - toEpoch(_year)) / MILLISECONDS_PER_DAY);
        for(let i = 0; i < monthDays.length; i++){
            if (days <= monthDays[i]) {
                this.month = i + 1;
                break;
            }
            days -= monthDays[i];
        }
        this.day = days;
        return this;
    }
    /**
   * convert date to bengali calendar date
   * @param {Date} date - javascript date object - uses local date
   * @return {Object} this
   */ fromDate(date) {
        return this.fromGregorian(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
    /**
   * convert bengali date to gregorian date
   * @return {Object} date in gregorian (preleptic) calendar
   *   {Number} year - (int)
   *   {Number} month - (int) 1...12
   *   {Number} day - (int) 1...31
   */ toGregorian() {
        const date = this.toDate();
        return {
            year: date.getUTCFullYear(),
            month: date.getUTCMonth() + 1,
            day: date.getUTCDate()
        };
    }
    /**
   * convert bengali date to Date
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */ toDate() {
        const year = this.year + YEAR0;
        const epoch = toEpoch(year);
        const _year = this.month > 10 ? year + 1 : year;
        const monthDays = isLeapYear(_year) ? monthDaysLeap : monthDaysNorm;
        let days = this.day;
        for(let i = 0; i < this.month - 1; i++)days += monthDays[i];
        const date = new Date(days * MILLISECONDS_PER_DAY + epoch);
        return date;
    }
    /**
   * format date in bengali
   * @param {String} formatStr - string formatter
   *
   * | Input | Description  |
   * | ----- | ------------ |
   * | Y     | Year with any number of digits and sign |
   * | Q     | Season Name  |
   * | M     | Month number |
   * | MMMM  | Month name   |
   * | D     | Day of month |
   * | dddd  | Day name     |
   *
   * @return {String}
   */ format(formatStr) {
        formatStr = formatStr || "D M, Y";
        if (/dddd/.test(formatStr)) {
            const date = this.toDate();
            formatStr = formatStr.replace(/dddd/g, (0, _convertJs.weekDay)(date.getUTCDay()));
        }
        return formatStr.replace(/Y/g, (0, _convertJs.digitToBangla)(this.year)).replace(/Q/g, (0, _convertJs.seasonName)(this.month)).replace(/MMMM/g, (0, _convertJs.monthName)(this.month)).replace(/M/g, (0, _convertJs.digitToBangla)(this.month)).replace(/D/g, (0, _convertJs.digitToBangla)(this.day));
    }
    /**
   * @constructor
   * @param {Number|String} year - bengali year
   * @param {Number|String} month - (int) 1...12
   * @param {Number|String} day - 1...31
   * @return {Object} this
   */ constructor(year, month, day){
        Object.assign(this, {
            year: (0, _convertJs.banglaToDigit)(year),
            month: (0, _convertJs.banglaToDigit)(month) || 1,
            day: (0, _convertJs.banglaToDigit)(day) || 1
        });
    }
}
exports.default = CalendarBengaliRevised;

},{"./convert.js":"eyOYM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eyOYM":[function(require,module,exports) {
/**
 * bengali names were taken from https://github.com/nuhil/bangla-calendar - MIT licensed
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "digitToBangla", ()=>digitToBangla);
parcelHelpers.export(exports, "banglaToDigit", ()=>banglaToDigit);
parcelHelpers.export(exports, "weekDay", ()=>weekDay);
parcelHelpers.export(exports, "monthName", ()=>monthName);
parcelHelpers.export(exports, "seasonName", ()=>seasonName);
const monthNames = [
    "\u09AC\u09C8\u09B6\u09BE\u0996",
    "\u099C\u09CD\u09AF\u09C8\u09B7\u09CD\u09A0",
    "\u0986\u09B7\u09BE\u09A2\u09BC",
    "\u09B6\u09CD\u09B0\u09BE\u09AC\u09A3",
    "\u09AD\u09BE\u09A6\u09CD\u09B0",
    "\u0986\u09B6\u09CD\u09AC\u09BF\u09A8",
    "\u0995\u09BE\u09B0\u09CD\u09A4\u09BF\u0995",
    "\u0985\u0997\u09CD\u09B0\u09B9\u09BE\u09AF\u09BC\u09A3",
    "\u09AA\u09CC\u09B7",
    "\u09AE\u09BE\u0998",
    "\u09AB\u09BE\u09B2\u09CD\u0997\u09C1\u09A8",
    "\u099A\u09C8\u09A4\u09CD\u09B0"
];
const weekDays = [
    "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
    "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
    "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
    "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
    "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
    "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
    "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
];
const seasonNames = [
    "\u0997\u09CD\u09B0\u09C0\u09B7\u09CD\u09AE",
    "\u09AC\u09B0\u09CD\u09B7\u09BE",
    "\u09B6\u09B0\u09CE",
    "\u09B9\u09C7\u09AE\u09A8\u09CD\u09A4",
    "\u09B6\u09C0\u09A4",
    "\u09AC\u09B8\u09A8\u09CD\u09A4"
];
const digits = [
    "\u09E6",
    "\u09E7",
    "\u09E8",
    "\u09E9",
    "\u09EA",
    "\u09EB",
    "\u09EC",
    "\u09ED",
    "\u09EE",
    "\u09EF"
];
let banglas;
const createBanglas = ()=>{
    banglas = digits.reduce((o, c, i)=>{
        o[c] = i;
        return o;
    }, {});
};
const digitToBangla = (number)=>String(number).replace(/\d/g, (digit)=>digits[digit]);
const banglaToDigit = (bangla)=>{
    if (!banglas) createBanglas() // memoize
    ;
    const month = monthNames.indexOf(bangla);
    const str = month !== -1 ? month + 1 : String(bangla).replace(/./g, (bangla)=>{
        const r = banglas[bangla];
        return r !== undefined ? r : bangla;
    });
    return Number(str);
};
const weekDay = (day)=>weekDays[day];
const monthName = (month)=>monthNames[month - 1];
const seasonName = (month)=>seasonNames[Math.floor((month - 1) / 2)] // ('পৌষ' + 'মাঘ') = 'শীত'. Every consecutive two index in 'banglaMonths' indicates a single index in 'banglaSeasons'.
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4BQva":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Holiday Rule
 * Apart from `rule` and `name` other options may be set
 * @constructor
 * @param {object} ruleObj
 * @param {string} ruleObj.rule - the rule string
 * @param {string|object} [ruleObj.name] - the name of the holiday, plain or with i18n
 * @param {string} [ruleObj.type] - type of holiday
 * @param {boolean} [ruleObj.substitute] - substitute holiday
 * @param {object[]} [ruleObj.active] - active `[{from?: str, to?: str}]`
 */ parcelHelpers.export(exports, "HolidayRule", ()=>HolidayRule);
var _utilsJs = require("./internal/utils.js");
class HolidayRule {
    /**
   * disable rule in year (month)
   * @param {number} year
   * @param {number} [month] - 1..12
   */ disableIn(year, month) {
        if (!(0, _utilsJs.toNumber)(year)) return;
        month = month < 1 && month > 12 ? undefined : month < 10 ? "0" + Number(month) : month;
        const dateStr = [
            year,
            month
        ].filter(Boolean).join("-");
        this.disable = (this.disable || []).concat(dateStr).sort();
    }
    constructor(ruleObj){
        const { rule, fn, opts, ...other } = ruleObj;
        Object.assign(this, {
            rule,
            ...other
        });
    }
}

},{"./internal/utils.js":"hs6zb","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2IYyI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "data", ()=>data);
const data = {
    version: "2024-02-08",
    license: "CC-BY-SA-3",
    holidays: {
        AD: {
            names: {
                ca: "Andorra",
                es: "Andorra",
                en: "Andorra"
            },
            dayoff: "sunday",
            langs: [
                "ca",
                "es"
            ],
            zones: [
                "Europe/Andorra"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "03-14": {
                    _name: "Constitution Day"
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-15": {
                    _name: "08-15"
                },
                "09-08": {
                    name: {
                        en: "Our Lady of Meritxell",
                        es: "Nuestra Sra. De Meritxell",
                        ca: "Mare de D\xe9u de Meritxell"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-24": {
                    type: "bank",
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "easter -3 14:00": {
                    type: "bank",
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                }
            },
            regions: {
                "07": {
                    name: "Andorra la Vella",
                    days: {
                        "1st saturday in August P3D": {
                            name: {
                                en: "Andorra La Vella Festival",
                                ca: "Andorra La Vella Festival"
                            }
                        }
                    }
                }
            }
        },
        AE: {
            names: {
                en: "United Arab Emirates",
                ar: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"
            },
            langs: [
                "ar"
            ],
            zones: [
                "Asia/Dubai"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01",
                    name: {
                        ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0645\u064A\u0644\u0627\u062F\u064A\u0629"
                    }
                },
                "12-02": {
                    name: {
                        en: "National Day",
                        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A"
                    }
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                },
                "27 Rajab": {
                    _name: "27 Rajab"
                },
                "1 Ramadan": {
                    _name: "1 Ramadan"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                }
            }
        },
        AG: {
            names: {
                en: "Antigua & Barbuda"
            },
            langs: [
                "en"
            ],
            dayoff: "sunday",
            weekend: [
                "saturday",
                "sunday"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "08-01": {
                    name: {
                        en: "J'Ouvert Morning"
                    }
                },
                "08-02": {
                    name: {
                        en: "Last Lap"
                    }
                },
                "11-01 if saturday,sunday then next monday": {
                    _name: "Independence Day"
                },
                "12-09": {
                    name: {
                        en: "V.C Bird Day"
                    }
                },
                "12-25 and if saturday then next monday if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                }
            },
            regions: {
                10: {
                    name: "Barbuda",
                    days: {
                        "easter 47 P4D": {
                            name: {
                                en: "Caribana"
                            },
                            type: "observance"
                        }
                    }
                }
            }
        },
        AI: {
            names: {
                en: "Anguilla"
            },
            langs: [
                "en"
            ],
            dayoff: "sunday",
            weekend: [
                "saturday",
                "sunday"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-02": {
                    name: {
                        en: "James Ronald Webster Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-30": {
                    name: {
                        en: "Anguilla Day"
                    }
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "2nd monday in June": {
                    name: {
                        en: "Celebration of the Birthday of Her Majesty the Queen"
                    }
                },
                "1st monday in August": {
                    name: {
                        en: "August Monday"
                    }
                },
                "1st thursday in August": {
                    name: {
                        en: "August Thursday"
                    }
                },
                "1st friday in August": {
                    _name: "Constitution Day"
                },
                "12-19": {
                    name: {
                        en: "National Heroes and Heroines Day"
                    }
                },
                "12-25 and if saturday then next monday if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                }
            }
        },
        AL: {
            names: {
                sq: "Shqip\xebri",
                en: "Albania"
            },
            dayoff: "sunday",
            langs: [
                "sq",
                "es"
            ],
            zones: [
                "Europe/Tirane"
            ],
            days: {
                "01-01 and if sunday then next tuesday": {
                    _name: "01-01",
                    substitute: true
                },
                "01-02 and if sunday then next monday": {
                    name: {
                        sq: "Festa e Vitit t\xeb Ri",
                        en: "New Year Holiday"
                    },
                    substitute: true
                },
                "03-02": {
                    name: {
                        sq: "Dita e Bes\xeblidhjes s\xeb Lezh\xebs",
                        en: "League of Lezh\xeb day"
                    },
                    type: "observance"
                },
                "03-07": {
                    name: {
                        sq: "Dita e M\xebsuesit",
                        en: "Teacher's Day"
                    },
                    type: "observance"
                },
                "03-08": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "03-14 and if sunday then next monday": {
                    name: {
                        sq: "Dita e Ver\xebs",
                        en: "Summer Day"
                    },
                    substitute: true
                },
                "03-22 and if sunday then next monday": {
                    name: {
                        sq: "Dita e Sulltan Nevruzit",
                        en: "Sultan Nevruz's Day"
                    },
                    substitute: true
                },
                "04-01": {
                    _name: "04-01",
                    type: "observance"
                },
                easter: {
                    name: {
                        sq: "Pashk\xebt Katolike",
                        en: "Catholic Easter"
                    }
                },
                "easter 1": {
                    name: {
                        sq: "Pashk\xebt Katolike",
                        en: "Catholic Easter"
                    }
                },
                orthodox: {
                    name: {
                        sq: "Pashk\xebt Ortodokse",
                        en: "Orthodox Easter"
                    }
                },
                "orthodox 1": {
                    name: {
                        sq: "Pashk\xebt Ortodokse",
                        en: "Orthodox Easter"
                    }
                },
                "05-01 and if sunday then next monday": {
                    _name: "05-01",
                    substitute: true
                },
                "06-01": {
                    name: {
                        sq: "Dita Nd\xebrkomb\xebtare e F\xebmij\xebve",
                        en: "Children's Day"
                    },
                    type: "observance"
                },
                "10-19 and if sunday then next monday": {
                    name: {
                        sq: "Dita e N\xebn\xeb Terez\xebs",
                        en: "Mother Teresa Day"
                    },
                    substitute: true,
                    active: [
                        {
                            from: 2004
                        }
                    ]
                },
                "11-22": {
                    name: {
                        sq: "Dita e Alfabetit",
                        en: "Alphabet Day"
                    },
                    type: "observance"
                },
                "11-28 and if sunday then next monday": {
                    _name: "Independence Day",
                    substitute: true
                },
                "11-29 and if sunday then next monday": {
                    _name: "Liberation Day",
                    substitute: true
                },
                "12-08 and if sunday then next monday": {
                    name: {
                        sq: "Dita Komb\xebtare e Rinis\xeb",
                        en: "Youth Day"
                    },
                    substitute: true,
                    active: [
                        {
                            from: 2010
                        }
                    ]
                },
                "12-24": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25 and if sunday then next monday": {
                    _name: "12-25",
                    substitute: true
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            },
            regions: {}
        },
        AM: {
            names: {
                hy: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
                en: "Armenia"
            },
            dayoff: "sunday",
            langs: [
                "hy"
            ],
            zones: [
                "Asia/Yerevan"
            ],
            days: {
                "12-31": {
                    _name: "12-31"
                },
                "01-01 P2D": {
                    _name: "01-01"
                },
                "01-03 P3D": {
                    name: {
                        en: "Pre-Christmas holidays",
                        hy: "\u0546\u0561\u056D\u0561\u056E\u0576\u0576\u0564\u0575\u0561\u0576 \u057F\u0578\u0576\u0565\u0580"
                    }
                },
                "01-06": {
                    _name: "12-25"
                },
                "01-28": {
                    name: {
                        en: "Army Day",
                        hy: "\u0532\u0561\u0576\u0561\u056F\u056B \u0585\u0580"
                    }
                },
                "02-21": {
                    name: {
                        en: "Mother Language Day",
                        hy: "\u0544\u0561\u0575\u0580\u0565\u0576\u056B \u056C\u0565\u0566\u057E\u056B \u0585\u0580"
                    },
                    type: "observance"
                },
                "easter -52": {
                    name: {
                        en: "St. Vartan the good work and the duty days",
                        hy: "\u054D\u0578\u0582\u0580\u0562 \u054E\u0561\u0580\u0564\u0561\u0576\u0561\u0576\u0581 \u057F\u0578\u0576\u055D \u0562\u0561\u0580\u056B \u0563\u0578\u0580\u056E\u056B \u0565\u0582 \u0561\u0566\u0563\u0561\u0575\u056B\u0576 \u057F\u0578\u0582\u0580\u0584\u056B \u0585\u0580"
                    },
                    type: "observance"
                },
                "03-08": {
                    _name: "03-08"
                },
                "04-07": {
                    name: {
                        en: "Motherhood and Beauty Day",
                        hy: "\u0544\u0561\u0575\u0580\u0578\u0582\u0569\u0575\u0561\u0576, \u0563\u0565\u0572\u0565\u0581\u056F\u0578\u0582\u0569\u0575\u0561\u0576 \u0565\u0582 \u057D\u056B\u0580\u0578 \u057F\u0578\u0576"
                    },
                    type: "observance"
                },
                "04-24": {
                    _name: "Mothers Day"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-08": {
                    name: {
                        en: "Yerkrapah Day",
                        hy: "\u0535\u0580\u056F\u0580\u0561\u057A\u0561\u0570\u056B \u0585\u0580"
                    },
                    type: "observance"
                },
                "05-09": {
                    name: {
                        en: "Victory and Peace Day",
                        hy: "\u0540\u0561\u0572\u0569\u0561\u0576\u0561\u056F\u056B \u0565\u0582 \u053D\u0561\u0572\u0561\u0572\u0578\u0582\u0569\u0575\u0561\u0576 \u057F\u0578\u0576"
                    }
                },
                "05-28": {
                    name: {
                        en: "Republic Day",
                        hy: "\u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    }
                },
                "06-01": {
                    name: {
                        en: "The day of protection of children rights",
                        hy: "\u0535\u0580\u0565\u056D\u0561\u0576\u0565\u0580\u056B \u056B\u0580\u0561\u057E\u0578\u0582\u0576\u0584\u0576\u0565\u0580\u056B \u057A\u0561\u0577\u057F\u057A\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    },
                    type: "observance"
                },
                "07-05": {
                    _name: "Constitution Day"
                },
                "09-01": {
                    name: {
                        en: "Knowledge, Literacy and Education Day",
                        hy: "\u0533\u056B\u057F\u0565\u056C\u056B\u0584\u056B, \u0563\u0580\u056B \u0565\u0582 \u0564\u057A\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    },
                    type: "observance"
                },
                "09-21": {
                    _name: "Independence Day"
                },
                "2nd saturday in October": {
                    name: {
                        en: "Translator's Day",
                        hy: "\u0539\u0561\u0580\u0563\u0574\u0561\u0576\u0579\u0561\u0581 \u057F\u0578\u0576"
                    },
                    type: "observance"
                },
                "12-07": {
                    name: {
                        en: "Earthquake Remembrance Day",
                        hy: "\u0535\u0580\u056F\u0580\u0561\u0577\u0561\u0580\u056A\u056B \u0566\u0578\u0570\u0565\u0580\u056B \u0570\u056B\u0577\u0561\u057F\u0561\u056F\u056B \u0585\u0580"
                    },
                    type: "observance"
                }
            }
        },
        AO: {
            names: {
                pt: "Angola",
                en: "Angola"
            },
            dayoff: "sunday",
            zones: [
                "Africa/Lagos"
            ],
            langs: [
                "pt"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-04": {
                    name: {
                        pt: "Dia do In\xedcio da Luta Armada de Liberta\xe7\xe3o Nacional",
                        en: "Liberation Day"
                    }
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "03-08": {
                    name: {
                        pt: "Dia Internacional da Mulher",
                        en: "International Woman's Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-04": {
                    name: {
                        pt: "Dia da Paz",
                        en: "Peace Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "09-17": {
                    name: {
                        pt: "Fundador da Na\xe7\xe3o e Dia dos Her\xf3is Nacionais",
                        en: "National Hero Day"
                    }
                },
                "11-02": {
                    _name: "11-02"
                },
                "11-11": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        AR: {
            names: {
                es: "Argentina",
                en: "Argentina"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Argentina/Buenos_Aires",
                "America/Argentina/Cordoba",
                "America/Argentina/Salta",
                "America/Argentina/Jujuy",
                "America/Argentina/Tucuman",
                "America/Argentina/Catamarca",
                "America/Argentina/La_Rioja",
                "America/Argentina/San_Juan",
                "America/Argentina/Mendoza",
                "America/Argentina/San_Luis",
                "America/Argentina/Rio_Gallegos",
                "America/Argentina/Ushuaia"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day",
                    disable: [
                        2015
                    ]
                },
                "easter -48": {
                    _name: "easter -48"
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "03-24": {
                    name: {
                        en: "Day of Remembrance for Truth and Justice",
                        es: "D\xeda de la Memoria por la Verdad y la Justicia"
                    }
                },
                "substitutes 03-24 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "2020-03-30": {
                    _name: "Bridge Day"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "04-02": {
                    name: {
                        en: "Day of the veterans and the fallen in Malvinas War",
                        es: "D\xeda del Veterano y de los Ca\xeddos en la Guerra de Malvinas"
                    }
                },
                "substitutes 04-02 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "05-01": {
                    _name: "05-01"
                },
                "substitutes 05-01 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "05-25": {
                    name: {
                        en: "Day of the First National Government",
                        es: "Primer Gobierno Patrio"
                    }
                },
                "substitutes 05-25 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "06-20": {
                    name: {
                        en: "National Flag Day",
                        es: "D\xeda de la Bandera"
                    }
                },
                "substitutes 06-20 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "07-09": {
                    _name: "Independence Day"
                },
                "substitutes 07-09 if tuesday then previous monday if thursday then next friday if saturday then previous friday": {
                    _name: "Bridge Day",
                    disable: [
                        2015,
                        2022
                    ]
                },
                "3rd monday in August": {
                    name: {
                        en: "Anniversary of the death of General Jos\xe9 de San Mart\xedn",
                        es: "D\xeda del Libertador Jos\xe9 de San Mart\xedn"
                    }
                },
                "10-12 if tuesday,wednesday then previous monday if thursday,friday,saturday,sunday then next monday": {
                    name: {
                        en: "Day of Respect for Cultural Diversity",
                        es: "D\xeda del Respeto a la Diversidad Cultural"
                    }
                },
                "substitutes 10-12 if monday,tuesday,wednesday then previous friday": {
                    _name: "Bridge Day",
                    disable: [
                        2015,
                        2016,
                        2020
                    ]
                },
                "11-20 if tuesday,wednesday then previous monday if friday then next monday": {
                    name: {
                        en: "Day of National Sovereignty",
                        es: "D\xeda de la Soberan\xeda nacional"
                    }
                },
                "substitutes 11-20 if saturday,sunday then next monday": {
                    _name: "Bridge Day",
                    disable: [
                        2016
                    ]
                },
                "12-08": {
                    _name: "12-08"
                },
                "substitutes 12-08 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "12-24 12:00": {
                    _name: "12-24",
                    type: "optional"
                },
                "substitutes 12-24 if tuesday then previous monday": {
                    _name: "Bridge Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if tuesday then previous monday if thursday then next friday": {
                    _name: "Bridge Day"
                },
                "12-31 12:00": {
                    _name: "12-31",
                    type: "optional"
                }
            }
        },
        AS: {
            names: {
                en: "American Samoa"
            },
            dayoff: "sunday",
            zones: [
                "Pacific/Pago_Pago"
            ],
            langs: [
                "en"
            ],
            _days: [
                "US"
            ],
            days: {
                "3rd monday in February": {
                    name: {
                        en: "Washington's Birthday"
                    }
                },
                "03-17": false,
                "04-15 if friday then next monday if saturday,sunday then next tuesday": false,
                "04-17 and if sunday then next monday": {
                    name: {
                        en: "American Samoa Flag Day"
                    },
                    substitute: true
                },
                "07-16": {
                    name: {
                        en: "Manu'a Cession Day"
                    },
                    type: "optional",
                    note: "Goverment offices closed"
                },
                "2nd sunday in October": {
                    name: {
                        en: "White Sunday"
                    },
                    type: "observance",
                    note: "christian"
                },
                "12-24 12:00": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-31 12:00": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        AT: {
            names: {
                "de-at": "\xd6sterreich",
                en: "Austria"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Vienna"
            ],
            langs: [
                "de-at",
                "de"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "easter -2 prior to 2019": {
                    _name: "easter -2",
                    type: "optional"
                },
                "easter -1": {
                    _name: "easter -1",
                    type: "observance"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    name: {
                        "de-at": "Staatsfeiertag"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-26": {
                    _name: "National Holiday"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-24 14:00 if sunday then 00:00": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 14:00 if sunday then 00:00": {
                    _name: "12-31",
                    type: "bank"
                }
            },
            states: {
                1: {
                    name: "Burgenland",
                    days: {
                        "11-11": {
                            name: {
                                "de-at": "Martinstag"
                            }
                        }
                    }
                },
                2: {
                    names: {
                        de: "K\xe4rnten",
                        en: "Carinthia"
                    },
                    days: {
                        "03-19": {
                            _name: "03-19",
                            type: "school"
                        },
                        "10-10": {
                            name: {
                                "de-at": "Tag der Volksabstimmung"
                            }
                        }
                    }
                },
                3: {
                    names: {
                        de: "Nieder\xf6sterreich",
                        en: "Lower Austria"
                    },
                    days: {
                        "11-15": {
                            name: {
                                "de-at": "Leopoldi-Tag"
                            },
                            type: "optional",
                            note: "In Nieder\xf6sterreich haben nur Sch\xfcler und Beamten frei"
                        }
                    }
                },
                4: {
                    names: {
                        de: "Ober\xf6sterreich",
                        en: "Upper Austria"
                    },
                    days: {
                        "05-04": {
                            name: {
                                "de-at": "Florian"
                            }
                        }
                    }
                },
                5: {
                    names: {
                        de: "Land Salzburg",
                        en: "Salzburg"
                    },
                    days: {
                        "09-24": {
                            name: {
                                "de-at": "Rupert"
                            }
                        }
                    }
                },
                6: {
                    names: {
                        de: "Steiermark",
                        en: "Styria"
                    },
                    days: {
                        "03-19": {
                            _name: "03-19",
                            type: "school"
                        }
                    }
                },
                7: {
                    names: {
                        de: "Tirol",
                        en: "Tyrol"
                    },
                    days: {
                        "03-19": {
                            _name: "03-19",
                            type: "school"
                        }
                    }
                },
                8: {
                    name: "Vorarlberg",
                    days: {
                        "03-19": {
                            _name: "03-19",
                            type: "school"
                        }
                    }
                },
                9: {
                    names: {
                        de: "Wien",
                        en: "Vienna"
                    },
                    days: {
                        "11-15": {
                            name: {
                                "de-at": "Leopoldi-Tag"
                            },
                            type: "optional",
                            note: "In Wien haben nur Sch\xfcler frei"
                        }
                    }
                }
            }
        },
        AU: {
            names: {
                en: "Australia"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Australia/Sydney",
                "Australia/Lord_Howe",
                "Antarctica/Macquarie",
                "Australia/Hobart",
                "Australia/Currie",
                "Australia/Melbourne",
                "Australia/Broken_Hill",
                "Australia/Brisbane",
                "Australia/Lindeman",
                "Australia/Adelaide",
                "Australia/Darwin",
                "Australia/Perth",
                "Australia/Eucla"
            ],
            days: {
                "01-01 and if saturday,sunday then next monday": {
                    _name: "01-01"
                },
                "01-26 if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Australia Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-25": {
                    name: {
                        en: "Anzac Day"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "1st sunday in September": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "12-25 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-26"
                },
                "2022-09-22": {
                    name: {
                        en: "National Day of Mourning for Queen Elizabeth II"
                    }
                }
            },
            states: {
                ACT: {
                    name: "Australian Capital Territory",
                    zones: [
                        "Australia/Sydney"
                    ],
                    days: {
                        "2nd monday in March": {
                            name: {
                                en: "Canberra Day"
                            }
                        },
                        "04-25": false,
                        "04-25 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Anzac Day"
                            }
                        },
                        "2020-04-27": {
                            name: {
                                en: "Declared public holiday"
                            },
                            type: "public"
                        },
                        "monday after 05-27": {
                            name: {
                                en: "Reconciliation Day"
                            }
                        },
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in October": {
                            name: {
                                en: "Labour Day"
                            }
                        }
                    }
                },
                NSW: {
                    name: "New South Wales",
                    zones: [
                        "Australia/Sydney"
                    ],
                    days: {
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in August": {
                            name: {
                                en: "Bank Holiday"
                            },
                            type: "bank"
                        },
                        "1st monday in October": {
                            name: {
                                en: "Labour Day"
                            }
                        }
                    }
                },
                NT: {
                    name: "Northern Territory",
                    zones: [
                        "Australia/Darwin"
                    ],
                    days: {
                        easter: false,
                        "04-25": false,
                        "04-25 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Anzac Day"
                            }
                        },
                        "1st monday in May": {
                            name: {
                                en: "May Day"
                            }
                        },
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in August": {
                            name: {
                                en: "Picnic Day"
                            }
                        },
                        "1st monday in October": false,
                        "12-24 19:00": {
                            _name: "12-24"
                        },
                        "12-25 and if saturday then next monday if sunday then next tuesday": false,
                        "12-25 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            _name: "12-25"
                        },
                        "12-26 and if saturday then next monday if sunday then next tuesday": false,
                        "12-26 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            _name: "12-26"
                        },
                        "12-31 19:00": {
                            _name: "12-31"
                        }
                    }
                },
                QLD: {
                    name: "Queensland",
                    zones: [
                        "Australia/Brisbane",
                        "Australia/Lindeman"
                    ],
                    days: {
                        "04-25": false,
                        "04-25 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Anzac Day"
                            }
                        },
                        "1st monday in May": {
                            name: {
                                en: "Labour Day"
                            }
                        },
                        "2nd monday in June": false,
                        "1st monday in October": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "1st monday in October #1": {
                            name: "King's Birthday",
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "12-24 18:00": {
                            _name: "12-24"
                        }
                    }
                },
                SA: {
                    name: "South Australia",
                    zones: [
                        "Australia/Adelaide"
                    ],
                    days: {
                        easter: false,
                        "2nd monday in March": {
                            name: {
                                en: "Adelaide Cup Day"
                            }
                        },
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in October": {
                            name: {
                                en: "Labour Day"
                            }
                        },
                        "12-24 19:00": {
                            _name: "12-24"
                        },
                        "12-25 and if saturday then next monday if sunday then next tuesday": false,
                        "12-25 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            _name: "12-25"
                        },
                        "12-26 and if saturday then next monday if sunday then next tuesday": false,
                        "12-26 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            name: "Proclamation Day"
                        },
                        "12-31 19:00": {
                            _name: "12-31"
                        }
                    }
                },
                TAS: {
                    name: "Tasmania",
                    zones: [
                        "Australia/Hobart"
                    ],
                    days: {
                        "01-01 and if saturday,sunday then next monday": false,
                        "01-01 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            _name: "01-01"
                        },
                        "2nd monday in March": {
                            name: {
                                en: "Eight Hours Day"
                            }
                        },
                        "easter -1": false,
                        easter: false,
                        "easter +2": {
                            name: "Easter Tuesday",
                            type: "optional",
                            note: "Public Service employees or contract dependent"
                        },
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in October": false,
                        "12-26 and if saturday then next monday if sunday then next tuesday": false,
                        "12-26 if saturday then next monday if sunday then next tuesday": {
                            substitute: true,
                            _name: "12-26"
                        }
                    }
                },
                VIC: {
                    name: "Victoria",
                    zones: [
                        "Australia/Melbourne"
                    ],
                    days: {
                        "2nd monday in March": {
                            name: {
                                en: "Labour Day"
                            }
                        },
                        "2nd monday in June": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "2nd monday in June #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in October": false,
                        "1st friday before October": {
                            name: {
                                en: "AFL Grand Final Friday"
                            },
                            note: "Date might differ as dependent on AFL schedule"
                        },
                        "1st tuesday in November": {
                            name: {
                                en: "Melbourne Cup"
                            }
                        }
                    }
                },
                WA: {
                    name: "Western Australia",
                    zones: [
                        "Australia/Perth",
                        "Australia/Eucla"
                    ],
                    days: {
                        "1st monday in March": {
                            name: {
                                en: "Labour Day"
                            }
                        },
                        "easter -1": false,
                        easter: false,
                        "04-25": false,
                        "04-25 and if saturday,sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Anzac Day"
                            }
                        },
                        "1st monday in June": {
                            name: {
                                en: "Western Australia Day"
                            }
                        },
                        "2nd monday in June": false,
                        "monday before October": {
                            name: {
                                en: "Queen's Birthday"
                            },
                            note: "Might be on a different day; is proclaimed by Governor",
                            active: [
                                {
                                    to: "2022-09-08"
                                }
                            ]
                        },
                        "monday before October #1": {
                            name: {
                                en: "King's Birthday"
                            },
                            note: "Might be on a different day; is proclaimed by Governor",
                            active: [
                                {
                                    from: "2022-09-09"
                                }
                            ]
                        },
                        "1st monday in October": false
                    }
                }
            }
        },
        AW: {
            names: {
                pap: "Aruba",
                nl: "Aruba",
                en: "Aruba"
            },
            dayoff: "sunday",
            zones: [
                "America/Curacao"
            ],
            langs: [
                "pap",
                "nl"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-25": {
                    name: {
                        pap: "Dia di Betico",
                        nl: "Herdenking G. F. Croes",
                        en: "Betico Croes Day"
                    }
                },
                "easter -48": {
                    _name: "easter -48"
                },
                "03-18 and if saturday then previous friday if sunday then next monday": {
                    substitute: true,
                    name: {
                        pap: "Dia di Himno y Bandera",
                        nl: "Herdenking Vlag en Volkslied",
                        en: "National Anthem and Flag Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27": {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: "Koningsdag",
                        en: "Kings Day"
                    }
                },
                "05-01 if sunday then next monday": {
                    _name: "05-01"
                },
                "06-24": {
                    name: {
                        pap: "Dera Gai",
                        nl: "Dera Gai",
                        en: "Dera Gai"
                    },
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "12-05": {
                    name: {
                        nl: "Sinterklaasavond",
                        en: "St. Nicholas' Eve"
                    },
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        AX: {
            names: {
                sv: "Landskapet \xc5land",
                en: "\xc5land Islands"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Helsinki"
            ],
            langs: [
                "sv"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "03-30": {
                    name: {
                        sv: "\xc5lands demilitariseringsdag",
                        en: "Demilitarization Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "06-09": {
                    name: {
                        sv: "Sj\xe4lvstyrelsedagen",
                        en: "Autonomy Day"
                    }
                },
                "friday after 06-19": {
                    name: {
                        sv: "Midsommarafton",
                        en: "Midsummer Eve"
                    },
                    type: "bank"
                },
                "saturday after 06-20": {
                    name: {
                        sv: "Midsommardagen",
                        en: "Midsummer Day"
                    }
                },
                "12-06": {
                    _name: "Independence Day"
                },
                "12-24 12:00": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 12:00": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        AZ: {
            names: {
                az: "Az\u0259rbaycan Respublikas\u0131",
                en: "Azerbaijan"
            },
            dayoff: "sunday",
            weekend: [
                "saturday",
                "sunday"
            ],
            zones: [
                "Asia/Baku"
            ],
            langs: [
                "az"
            ],
            days: {
                "01-01 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-02 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-20": {
                    name: {
                        az: "Qara Yanvar",
                        en: "Martyrs' Day"
                    },
                    type: "observance"
                },
                "03-08 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "03-08"
                },
                "03-20": {
                    name: {
                        az: "Novruz",
                        en: "Spring Festival"
                    },
                    active: [
                        {
                            from: 2011
                        }
                    ]
                },
                "05-09 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "Fa\u015Fizm \xfcz\u0259rind\u0259 q\u0259l\u0259b\u0259 g\xfcn\xfc",
                        en: "Day of Victory over Fascism"
                    }
                },
                "05-28 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "Respublika g\xfcn\xfc",
                        en: "Republic Day"
                    }
                },
                "06-15 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "Az\u0259rbaycan xalq\u0131n\u0131n Milli Qurtulu\u015F g\xfcn\xfc",
                        en: "National Salvation Day"
                    }
                },
                "06-26 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "Az\u0259rbaycan Respublikas\u0131n\u0131n Silahl\u0131 Q\xfcvv\u0259l\u0259ri g\xfcn\xfc",
                        en: "Azerbaijan Armed Forces Day"
                    }
                },
                "10-18 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "D\xf6vl\u0259t M\xfcst\u0259qilliyi g\xfcn\xfc",
                        en: "Independence Day"
                    }
                },
                "11-09 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "D\xf6vl\u0259t Bayra\u011F\u0131 g\xfcn\xfc",
                        en: "Flag Day"
                    }
                },
                "11-12": {
                    name: {
                        az: "Konstitusiya g\xfcn\xfc",
                        en: "Constitution Day"
                    }
                },
                "11-17": {
                    name: {
                        az: "Milli Dir\xe7\u0259li\u015F g\xfcn\xfc",
                        en: "National Revival Day"
                    }
                },
                "12-31 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        az: "D\xfcnya az\u0259rbaycanl\u0131lar\u0131n h\u0259mr\u0259yliyi g\xfcn\xfc",
                        en: "International Solidarity Day of Azerbaijanis"
                    }
                },
                "1 Shawwal and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "1 Shawwal"
                },
                "2 Shawwal and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "10 Dhu al-Hijjah"
                },
                "11 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        BA: {
            names: {
                bs: "Bosna i Hercegovina",
                sr: "\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
                hr: "Bosna i Hercegovina",
                en: "Bosnia and Herzegovina"
            },
            langs: [
                "bs",
                "sr",
                "hr"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if sunday then next tuesday": {
                    _name: "01-01",
                    substitute: true
                },
                "01-02 and if sunday then next monday": {
                    name: {
                        en: "2nd day of the New Year",
                        bs: "Drugi dan Nove Godine"
                    },
                    substitute: true
                },
                "05-01 and if sunday then next tuesday": {
                    _name: "05-01",
                    substitute: true
                },
                "05-02 and if sunday then next monday": {
                    name: {
                        en: "2nd day of the Labour Day",
                        bs: "Drugi dan Dana rada"
                    },
                    substitute: true
                },
                "01-06": {
                    _name: "01-06"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-02": {
                    _name: "11-02"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "julian 01-01": {
                    _name: "julian 01-01"
                },
                orthodox: {
                    _name: "orthodox"
                },
                "julian 08-15": {
                    _name: "08-15",
                    note: "orthodox"
                },
                "julian 12-25": {
                    _name: "julian 12-25"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "10 Dhu al-Hijjah P4D": {
                    _name: "10 Dhu al-Hijjah"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                }
            },
            states: {
                BIH: {
                    name: "Federation of Bosnia and Herzegovina",
                    days: {
                        "03-01": {
                            _name: "Independence Day"
                        },
                        "11-25": {
                            name: {
                                en: "Statehood Day",
                                bs: "Dan dr\u017Eavnosti"
                            }
                        }
                    },
                    regions: {
                        W: {
                            name: "Western Herzegovina",
                            days: {
                                "11-25": false
                            }
                        }
                    }
                },
                BRC: {
                    name: "Br\u010Dko District",
                    days: {
                        "03-08": {
                            name: {
                                en: "Day of the Establishment of the District"
                            }
                        }
                    }
                },
                SRP: {
                    name: "Republika Srpska",
                    days: {
                        "01-09": {
                            name: {
                                en: "Republic Day",
                                bs: "Dan Republike"
                            }
                        },
                        "05-09": {
                            name: {
                                en: "Victory Day",
                                bs: "Dan pobjede"
                            }
                        },
                        "11-21": {
                            name: {
                                en: "Dayton Agreement Day",
                                bs: "Dan uspostave Op\u0161teg okvirnog sporazuma za mir u Bosni i Hercegovini"
                            }
                        }
                    }
                }
            }
        },
        BB: {
            names: {
                en: "Barbados"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Barbados"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-21": {
                    name: {
                        en: "Errol Barrow Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-28": {
                    name: {
                        en: "National Heroes Day"
                    }
                },
                "05-01 if sunday then next monday": {
                    name: {
                        en: "May Day"
                    }
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "08-01": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "1st monday in August": {
                    name: {
                        en: "Kadooment Day"
                    }
                },
                "11-30": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if sunday then next tuesday": {
                    _name: "Public Holiday"
                },
                "12-26": {
                    _name: "12-26"
                },
                "substitutes 12-26 if sunday then next monday": {
                    _name: "Public Holiday"
                }
            }
        },
        BD: {
            names: {
                bn: "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6",
                en: "People's Republic of Bangladesh"
            },
            langs: [
                "bn"
            ],
            zones: [
                "Asia/Dhaka"
            ],
            dayoff: "friday",
            weekend: [
                "friday",
                "saturday"
            ],
            days: {
                "bengali-revised 11-9": {
                    name: {
                        bn: "\u09B6\u09B9\u09C0\u09A6 \u09A6\u09BF\u09AC\u09B8",
                        en: "Language Martyrs' Day"
                    }
                },
                "bengali-revised 12-3": {
                    name: {
                        bn: "\u09AE\u09C1\u099C\u09BF\u09AC \u099C\u09AF\u09BC\u09A8",
                        en: "Mujib's Birthday & Children's Day"
                    }
                },
                "bengali-revised 12-12": {
                    name: {
                        bn: "\u09B8\u09CD\u09AC\u09BE\u09A7\u09C0\u09A8\u09A4\u09BE \u09A6\u09BF\u09AC\u09B8",
                        en: "Independence Day"
                    }
                },
                "bengali-revised 1-1": {
                    name: {
                        bn: "\u09AA\u09B9\u09C7\u09B2\u09BE \u09AC\u09C8\u09B6\u09BE\u0996",
                        en: "Bengali New Year's Day"
                    }
                },
                "bengali-revised 1-18": {
                    _name: "05-01",
                    name: {
                        bn: "\u09AE\u09C7 \u09A6\u09BF\u09AC\u09B8",
                        en: "May Day"
                    }
                },
                "bengali-revised 4-31": {
                    name: {
                        bn: "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09B6\u09CB\u0995 \u09A6\u09BF\u09AC\u09B8",
                        en: "National Mourning Day"
                    }
                },
                "bengali-revised 9-2": {
                    name: {
                        bn: "\u09AC\u09BF\u099C\u09AF\u09BC \u09A6\u09BF\u09AC\u09B8",
                        en: "Victory Day"
                    }
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                },
                "05-19": {
                    name: {
                        bn: "\u09AC\u09C1\u09A6\u09CD\u09A7 \u09AA\u09C2\u09B0\u09CD\u09A3\u09BF\u09AE\u09BE",
                        en: "Buddha's Birthday"
                    },
                    enable: [
                        "2016-05-21",
                        "2017-05-10",
                        "2018-04-29",
                        "2019-05-19",
                        "2020-05-07"
                    ],
                    disable: [
                        "2016-05-19",
                        "2017-05-19",
                        "2018-05-19",
                        "2019-05-19",
                        "2020-05-19"
                    ]
                },
                "08-24": {
                    name: {
                        bn: "\u099C\u09A8\u09CD\u09AE\u09BE\u09B7\u09CD\u099F\u09AE\u09C0",
                        en: "Krishna Janmashtami"
                    },
                    enable: [
                        "2016-08-25",
                        "2017-08-14",
                        "2018-09-02",
                        "2019-08-24",
                        "2020-08-11"
                    ],
                    disable: [
                        "2016-08-24",
                        "2017-08-24",
                        "2018-08-24",
                        "2019-08-24",
                        "2020-08-24"
                    ]
                },
                "10-08": {
                    name: {
                        bn: "\u09A6\u09C1\u09B0\u09CD\u0997\u09BE \u09AA\u09C2\u099C\u09BE",
                        en: "Durga Puja"
                    },
                    enable: [
                        "2016-10-11",
                        "2017-09-30",
                        "2018-10-19",
                        "2019-10-08",
                        "2020-10-25"
                    ],
                    disable: [
                        "2016-10-08",
                        "2017-10-08",
                        "2018-10-08",
                        "2019-10-08",
                        "2020-10-08"
                    ]
                },
                "bengali-revised 9-11": {
                    _name: "12-25"
                },
                "03-25": {
                    name: {
                        en: "Genocide Remembrance Day"
                    },
                    type: "observance"
                },
                "11-21": {
                    name: {
                        en: "Armed Forces Day"
                    },
                    type: "observance"
                },
                "12-14": {
                    name: {
                        en: "Martyred Intellectuals Day"
                    },
                    type: "observance"
                }
            }
        },
        BE: {
            names: {
                fr: "Belgique",
                nl: "Belgi\xeb",
                de: "Belgien",
                en: "Belgium"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Brussels"
            ],
            langs: [
                "fr",
                "nl",
                "de"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    name: {
                        de: "Erscheinung des Herrn"
                    },
                    type: "observance"
                },
                "02-14": {
                    _name: "02-14",
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "07-21": {
                    _name: "National Holiday"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-02": {
                    _name: "11-02",
                    type: "observance"
                },
                "11-11": {
                    name: {
                        de: "Waffenstillstand",
                        fr: "Armistice",
                        nl: "Wapenstilstand"
                    }
                },
                "11-15": {
                    name: {
                        nl: "Koningsdag",
                        fr: "F\xeate du Roi",
                        de: "Festtag des K\xf6nigs"
                    },
                    type: "observance"
                },
                "12-06": {
                    _name: "12-06",
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                }
            },
            states: {
                BRU: {
                    name: "Bruxelles",
                    langs: [
                        "fr",
                        "nl"
                    ],
                    days: {
                        "05-08": {
                            name: {
                                nl: "Feest van de Iris",
                                fr: "F\xeate de l'Iris"
                            },
                            type: "observance"
                        }
                    }
                },
                DE: {
                    name: "Deutschsprachige Gemeinschaft",
                    langs: [
                        "de"
                    ],
                    days: {
                        "11-15": {
                            name: {
                                de: "Tag der Deutschsprachigen Gemeinschaft",
                                fr: "Jour de la Communaut\xe9 Germanophone",
                                nl: "Feestdag van de Duitstalige Gemeenschap"
                            },
                            type: "observance"
                        }
                    }
                },
                VLG: {
                    name: "Vlaamse Gemeenschap",
                    langs: [
                        "nl"
                    ],
                    days: {
                        "07-11": {
                            name: {
                                de: "Festtag der Wallonischen Region",
                                fr: "F\xeate de la R\xe9gion wallonne",
                                nl: "Feestdag van de Vlaamse Gemeenschap"
                            },
                            type: "observance"
                        },
                        "11-02": {
                            _name: "11-02",
                            type: "observance",
                            note: "day-off for employees of the flemish government"
                        },
                        "11-15": {
                            name: {
                                nl: "Koningsdag",
                                fr: "F\xeate du Roi",
                                de: "Festtag des K\xf6nigs"
                            },
                            type: "observance",
                            note: "day-off for employees of the flemish government"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "observance",
                            note: "day-off for employees of the flemish government"
                        }
                    }
                },
                WAL: {
                    name: "Communaut\xe9 fran\xe7aise",
                    langs: [
                        "fr"
                    ],
                    days: {
                        "09-27": {
                            name: {
                                de: "Tag der Franz\xf6sischsprachigen Gemeinschaft",
                                fr: "La f\xeate de la communaut\xe9 fran\xe7aise",
                                nl: "Feestdag van de Franse Gemeenschap"
                            },
                            type: "observance"
                        }
                    }
                }
            }
        },
        BF: {
            names: {
                fr: "Burkina Faso",
                en: "Burkina Faso"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-03": {
                    name: {
                        fr: "Soul\xe8vement populaire",
                        en: "Anniversary of the 1966 Upper Voltan coup d'\xe9tat"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-05": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-11": {
                    name: {
                        fr: "F\xeate nationale",
                        en: "Proclamation of the Republic"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        BG: {
            names: {
                bg: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
                en: "Bulgaria"
            },
            langs: [
                "bg"
            ],
            zones: [
                "Europe/Sofia"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-01": {
                    name: {
                        bg: "\u0411\u0430\u0431\u0430 \u041C\u0430\u0440\u0442\u0430",
                        en: "Granny March Day"
                    },
                    type: "observance"
                },
                "03-03": {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u041E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0435\u043D\u0438\u0435\u0442\u043E \u043D\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F \u043E\u0442 \u041E\u0441\u043C\u0430\u043D\u0441\u043A\u0430\u0442\u0430 \u0418\u043C\u043F\u0435\u0440\u0438\u044F",
                        en: "Liberation Day"
                    }
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-06": {
                    name: {
                        bg: "\u0413\u0435\u0440\u0433\u044C\u043E\u0432\u0434\u0435\u043D",
                        en: "St. George's Day"
                    }
                },
                "05-07": {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0440\u0430\u0434\u0438\u043E\u0442\u043E \u0438 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u0438\u044F\u0442\u0430",
                        en: "Radio and Television Day"
                    },
                    type: "observance"
                },
                "05-24": {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0430\u0437\u0431\u0443\u043A\u0430\u0442\u0430, \u043A\u0443\u043B\u0442\u0443\u0440\u0430\u0442\u0430 \u0438 \u043F\u0440\u043E\u0441\u0432\u0435\u0442\u0430\u0442\u0430",
                        en: "Bulgarian Education and Culture, and Slavonic Literature Day"
                    }
                },
                "09-06": {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0441\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0442\u043E",
                        en: "Unification Day"
                    }
                },
                "09-22": {
                    _name: "Independence Day"
                },
                "11-01": {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0442\u0435 \u0431\u0443\u0434\u0438\u0442\u0435\u043B\u0438",
                        en: "Revival Leaders' Day"
                    },
                    type: "school"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    type: "observance"
                }
            }
        },
        BH: {
            names: {
                ar: "\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0628\u062D\u0631\u064A\u0646",
                en: "Bahrain"
            },
            langs: [
                "ar"
            ],
            zones: [
                "Asia/Qatar"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u0639\u0645\u0627\u0644"
                    }
                },
                "12-16": {
                    name: {
                        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
                        en: "National Day"
                    }
                },
                "12-17": {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u062C\u0644\u0648\u0633",
                        en: "Accession Day"
                    }
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "9 Dhu al-Hijjah": {
                    _name: "9 Dhu al-Hijjah"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        BI: {
            names: {
                rn: "Republika y'Uburundi",
                fr: "R\xe9publique du Burundi",
                en: "Burundi"
            },
            dayoff: "sunday",
            langs: [
                "fr",
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-05": {
                    name: {
                        fr: "Jour de l'Unit\xe9",
                        en: "Unity Day"
                    }
                },
                "04-06": {
                    name: {
                        fr: "Jour de Ntaryamira",
                        en: "Ntaryamira Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "07-01": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-13": {
                    name: {
                        fr: "Jour de Rwagasore",
                        en: "Rwagasore Day"
                    }
                },
                "10-21": {
                    name: {
                        fr: "Jour de Ndadaye",
                        en: "Ndadaye Day"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "2015-07-24": {
                    _name: "Public Holiday",
                    name: {
                        fr: "Jour l'\xe9lection des S\xe9nateurs"
                    }
                }
            }
        },
        BJ: {
            names: {
                fr: "R\xe9publique du B\xe9nin",
                en: "Benin"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Lagos"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-10": {
                    name: {
                        fr: "F\xeate du Vodoun"
                    }
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-01": {
                    _name: "Independence Day",
                    name: {
                        fr: "F\xeate Nationale"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                }
            }
        },
        BL: {
            names: {
                fr: "St. Barth\xe9lemy",
                en: "St. Barths"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/St_Barthelemy"
            ],
            _days: "FR",
            days: {
                "easter -48": {
                    _name: "easter -48",
                    type: "observance"
                },
                "easter -47": {
                    _name: "easter -47",
                    type: "Observance"
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "easter -21": {
                    name: {
                        fr: "Mi-Car\xeame",
                        en: "Laetare Sunday"
                    },
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "bank"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "08-24": {
                    name: {
                        fr: "F\xeate de Saint Barth\xe9lemy",
                        en: "Saint Barth"
                    },
                    type: "observance"
                },
                "10-09": {
                    _name: "Abolition of Slavery"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        BM: {
            names: {
                en: "Bermuda"
            },
            langs: [
                "en"
            ],
            zones: [
                "Atlantic/Bermuda"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if saturday, sunday then next monday": {
                    _name: "01-01",
                    substitute: true,
                    type: "bank",
                    note: "Goverment offices close"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "friday before 06-01": {
                    name: {
                        en: "Bermuda Day"
                    }
                },
                "3nd monday in June": {
                    name: {
                        en: "National Heroes Day"
                    }
                },
                "thursday before 08-04": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "friday before 08-05": {
                    name: {
                        en: "Somers' Day"
                    }
                },
                "monday after 09-01": {
                    name: {
                        en: "Labour Day"
                    }
                },
                "11-11": {
                    name: {
                        en: "Remembrance Day"
                    }
                },
                "substitutes 11-11 if saturday, sunday then next monday": {
                    name: {
                        en: "Remembrance Day"
                    },
                    substitute: true,
                    type: "bank",
                    note: "Goverment offices close"
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if saturday then next monday if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true,
                    type: "bank",
                    note: "Goverment offices close"
                },
                "12-26": {
                    _name: "12-26"
                },
                "substitutes 12-26 if saturday then next monday if sunday then next tuesday": {
                    _name: "12-26",
                    substitute: true,
                    type: "bank",
                    note: "Goverment offices close"
                }
            }
        },
        BN: {
            names: {
                ms: "Negara Brunei Darussalam",
                en: "Brunei"
            },
            langs: [
                "ms",
                "en"
            ],
            zones: [
                "Asia/Brunei"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01",
                    name: {
                        ms: "Awal Tahun Masihi"
                    }
                },
                "02-23": {
                    name: {
                        en: "National Day",
                        ms: "Hari Kebangsaan"
                    }
                },
                "03-31": {
                    name: {
                        en: "Armed Forces Day",
                        ms: "Hari Angkatan Bersenjata Diraja Brunei"
                    }
                },
                "07-15": {
                    name: {
                        en: "Sultan's Birthday",
                        ms: "Hari Keputeraan KDYMM Sultan Brunei"
                    }
                },
                "1 Ramadan": {
                    _name: "1 Ramadan"
                },
                "17 Ramadan": {
                    name: {
                        en: "Nuzul Al-Quran",
                        ms: "Hari Nuzul Al-Quran"
                    }
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "27 Rajab": {
                    _name: "27 Rajab"
                },
                "12-25": {
                    _name: "12-25"
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Chinese New Year",
                        ms: "Tahun Baru Cina"
                    }
                }
            }
        },
        BO: {
            names: {
                es: "Bolivia",
                en: "Bolivia"
            },
            dayoff: "sunday",
            langs: [
                "es",
                "qu",
                "ay"
            ],
            zones: [
                "America/La_Paz"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    name: {
                        en: "New Year's Day (substitutes)",
                        es: "A\xf1o Nuevo (substituto)"
                    }
                },
                "01-22": {
                    name: {
                        en: "Plurinational State Foundation Day",
                        es: "D\xeda de la Creaci\xf3n del Estado Plurinacional de Bolivia"
                    }
                },
                "substitutes 01-22 if sunday then next monday": {
                    name: {
                        en: "Plurinational State Foundation Day (substitutes)",
                        es: "D\xeda de la Creaci\xf3n del Estado Plurinacional de Bolivia (substituto)"
                    }
                },
                "02-02": {
                    name: {
                        en: "Feast of the Virgin of Candelaria",
                        qu: "Mamacha Candelaria",
                        es: "Fiesta de la Virgen de Candelaria"
                    },
                    type: "observance"
                },
                "easter -48": {
                    _name: "easter -48",
                    name: {
                        es: "Lunes de Carnaval"
                    }
                },
                "easter -47": {
                    _name: "easter -47",
                    name: {
                        es: "Martes de Carnaval"
                    }
                },
                "03-19": {
                    name: {
                        en: "Father's Day",
                        es: "D\xeda del Padre"
                    },
                    type: "observance"
                },
                "03-23": {
                    name: {
                        en: "Day of the Sea",
                        es: "D\xeda del Mar"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "04-12": {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del Ni\xf1o"
                    },
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "substitutes 05-01 if sunday then next monday": {
                    _name: "05-01",
                    name: {
                        en: "Labour Day (substitutes)",
                        es: "D\xeda del Trabajo (substituto)"
                    }
                },
                "05-27": {
                    name: {
                        en: "Mother's Day",
                        es: "D\xeda de la Madre"
                    },
                    type: "observance"
                },
                "06-06": {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: "observance"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "06-21": {
                    name: {
                        en: "Andean Amazonian Chaque\xf1o New Year",
                        ay: "Willkakuti",
                        es: "A\xf1o Nuevo Andino Amaz\xf3nico Chaque\xf1o"
                    }
                },
                "substitutes 06-21 if sunday then next monday": {
                    name: {
                        en: "Andean Amazonic Chacoan New Year (substitutes)",
                        ay: "Willkakuti (substituto)",
                        es: "A\xf1o Nuevo Andino Amaz\xf3nico Chaque\xf1o (substituto)"
                    }
                },
                "08-06": {
                    _name: "Independence Day"
                },
                "substitutes 08-06 if sunday then next monday": {
                    name: {
                        en: "Independence Day (substitutes)",
                        es: "D\xeda de la Independencia (substituto)"
                    }
                },
                "08-17": {
                    name: {
                        en: "Flag Day",
                        es: "D\xeda de la Bandera"
                    },
                    type: "observance"
                },
                "09-21": {
                    name: {
                        en: "Student's Day",
                        es: "D\xeda del Estudiante"
                    },
                    type: "observance"
                },
                "10-11": {
                    name: {
                        es: "D\xeda de la Mujer Boliviana",
                        en: "Bolivian Woman's Day"
                    },
                    type: "observance"
                },
                "11-01": {
                    _name: "11-01",
                    name: {
                        es: "Todos Santos"
                    },
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02",
                    name: {
                        es: "Todos Santos"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if sunday then next monday": {
                    _name: "12-25",
                    name: {
                        en: "Christmas Day (substitutes)",
                        es: "Navidad (substituto)"
                    }
                }
            },
            states: {
                B: {
                    name: "Beni",
                    days: {
                        "11-18": {
                            name: {
                                es: "Efem\xe9rides del Beni",
                                en: "Beni Day"
                            }
                        },
                        "substitutes 11-18 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides del Beni (substituto)",
                                en: "Beni Day (substitutes)"
                            }
                        }
                    }
                },
                C: {
                    name: "Cochabamba",
                    days: {
                        "09-14": {
                            name: {
                                es: "Efem\xe9rides de Cochabamba",
                                en: "Cochabamba Day"
                            }
                        },
                        "substitutes 09-14 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Cochabamba (substituto)",
                                en: "Cochabamba Day (substitutes)"
                            }
                        }
                    }
                },
                H: {
                    name: "Chuquisaca",
                    days: {
                        "05-25": {
                            name: {
                                es: "Efem\xe9rides de Chuquisaca",
                                en: "Chuquisaca Day"
                            }
                        },
                        "substitutes 05-25 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Chuquisaca (substituto)",
                                en: "Chuquisaca Day (substitutes)"
                            }
                        }
                    }
                },
                L: {
                    name: "La Paz",
                    days: {
                        "07-16": {
                            name: {
                                es: "Efem\xe9rides de La Paz",
                                en: "La Paz Day"
                            }
                        },
                        "substitutes 07-16 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de La Paz (substituto)",
                                en: "La Paz Day (substitutes)"
                            }
                        }
                    }
                },
                N: {
                    name: "Pando",
                    days: {
                        "09-24": {
                            name: {
                                es: "Efem\xe9rides de Pando",
                                en: "Pando Day"
                            }
                        },
                        "substitutes 09-24 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Pando (substituto)",
                                en: "Pando Day (substitutes)"
                            }
                        }
                    }
                },
                O: {
                    name: "Oruro",
                    days: {
                        "02-10": {
                            name: {
                                es: "Efem\xe9rides de Oruro",
                                en: "Oruro Day"
                            }
                        },
                        "substitutes 02-10 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Oruro (substituto)",
                                en: "Oruro Day (substitutes)"
                            }
                        }
                    }
                },
                P: {
                    name: "Potos\xed",
                    days: {
                        "11-10": {
                            name: {
                                es: "Efem\xe9rides de Potos\xed",
                                en: "Potos\xed Day"
                            }
                        },
                        "substitutes 11-10 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Potos\xed (substituto)",
                                en: "Potos\xed Day (substitutes)"
                            }
                        }
                    }
                },
                S: {
                    name: "Santa Cruz",
                    days: {
                        "09-24": {
                            name: {
                                es: "Efem\xe9rides de Santa Cruz",
                                en: "Santa Cruz Day"
                            }
                        },
                        "substitutes 09-24 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Santa Cruz (substituto)",
                                en: "Santa Cruz Day (substitutes)"
                            }
                        }
                    }
                },
                T: {
                    name: "Tarija",
                    days: {
                        "04-15": {
                            name: {
                                es: "Efem\xe9rides de Tarija",
                                en: "Tarija Day"
                            }
                        },
                        "substitutes 04-15 if sunday then next monday": {
                            name: {
                                es: "Efem\xe9rides de Tarija (substituto)",
                                en: "Tarija Day (substitutes)"
                            }
                        }
                    }
                }
            }
        },
        BQ: {
            names: {
                nl: "Caribisch Nederland",
                en: "Caribbean Netherlands"
            },
            dayoff: "sunday",
            zones: [
                "America/Curacao"
            ],
            langs: [
                "nl",
                "en",
                "pap"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27": {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: "Koningsdag",
                        en: "Kings Day"
                    }
                },
                "05-01 if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "12-05": {
                    name: {
                        nl: "Sinterklaasavond",
                        en: "St. Nicholas' Eve"
                    },
                    type: "observance"
                },
                "12-15": {
                    name: {
                        pap: "Dia di Reino",
                        nl: "Koninkrijksdag",
                        en: "Kingdom Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            },
            regions: {
                BO: {
                    name: "Bonaire",
                    days: {
                        "easter -48": {
                            _name: "easter -48",
                            name: {
                                en: "Carnival Monday"
                            }
                        },
                        "04-30": {
                            name: {
                                en: "Rincon Day",
                                pap: "Dia di Rincon"
                            }
                        },
                        "09-06": {
                            name: {
                                nl: "Boneiru Dag",
                                en: "Bonaire Day",
                                pap: "Dia di Boneiru"
                            }
                        }
                    }
                },
                SA: {
                    name: "Saba",
                    days: {
                        "1st monday in August": {
                            _name: "easter -48",
                            name: {
                                en: "Carnival Monday"
                            }
                        },
                        "1st friday in December": {
                            name: {
                                en: "Saba Day"
                            }
                        }
                    }
                },
                SE: {
                    name: "Sint Eustatius",
                    days: {
                        "08-01": {
                            name: {
                                en: "Emancipation Day"
                            }
                        },
                        "11-16": {
                            name: {
                                en: "Statia Day"
                            }
                        }
                    }
                }
            }
        },
        BR: {
            names: {
                pt: "Brasil",
                en: "Brazil"
            },
            dayoff: "sunday",
            langs: [
                "pt"
            ],
            zones: [
                "America/Sao_Paulo",
                "America/Noronha",
                "America/Belem",
                "America/Fortaleza",
                "America/Recife",
                "America/Araguaina",
                "America/Maceio",
                "America/Bahia",
                "America/Campo_Grande",
                "America/Cuiaba",
                "America/Santarem",
                "America/Porto_Velho",
                "America/Boa_Vista",
                "America/Manaus",
                "America/Eirunepe",
                "America/Rio_Branco"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "04-21": {
                    name: {
                        pt: "Dia de Tiradentes",
                        en: "Tiradentes' Day"
                    }
                },
                "easter -50 PT110H": {
                    name: {
                        pt: "Carnaval",
                        en: "Carnival"
                    },
                    type: "optional"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 60": {
                    _name: "easter 60",
                    type: "optional"
                },
                "06-12": {
                    name: {
                        pt: "Dia dos Namorados",
                        en: "Lovers' Day"
                    },
                    type: "observance"
                },
                "2nd sunday in August": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "09-07": {
                    _name: "Independence Day"
                },
                "10-12": {
                    name: {
                        pt: "Nossa Senhora Aparecida",
                        en: "Our Lady of Aparecida"
                    }
                },
                "1st sunday in October in even years": {
                    name: {
                        pt: "Dia de Elei\xe7\xe3o",
                        en: "Election Day"
                    }
                },
                "1st sunday before 11-01 in even years": {
                    name: {
                        pt: "Dia de Elei\xe7\xe3o",
                        en: "Election Day"
                    }
                },
                "11-02": {
                    _name: "11-02"
                },
                "11-15": {
                    name: {
                        pt: "Proclama\xe7\xe3o da Rep\xfablica",
                        en: "Republic Day"
                    }
                },
                "12-24 14:00": {
                    _name: "12-24",
                    type: "optional"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31 14:00": {
                    _name: "12-31",
                    type: "optional"
                }
            },
            states: {
                AC: {
                    name: "Acre",
                    zones: [
                        "America/Rio_Branco"
                    ],
                    days: {
                        "01-12": {
                            name: {
                                pt: "Dia do evang\xe9lico"
                            },
                            active: [
                                {
                                    from: "2004-01-29T00:00:00.000Z"
                                }
                            ]
                        },
                        "03-08": {
                            name: {
                                pt: "Alusivo ao Dia Internacional da Mulher"
                            },
                            active: [
                                {
                                    from: "2001-09-14T00:00:00.000Z"
                                }
                            ]
                        },
                        "06-15": {
                            name: {
                                pt: "Anivers\xe1rio do estado"
                            },
                            active: [
                                {
                                    from: "1964-09-02T00:00:00.000Z"
                                }
                            ]
                        },
                        "09-05": {
                            name: {
                                pt: "Dia da Amaz\xf4nia"
                            },
                            active: [
                                {
                                    from: "2004-01-05T00:00:00.000Z"
                                }
                            ]
                        },
                        "11-17": {
                            name: {
                                pt: "Assinatura do Tratado de Petr\xf3polis"
                            },
                            type: "optional",
                            active: [
                                {
                                    from: "2012-02-21T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                AL: {
                    name: "Alagoas",
                    zones: [
                        "America/Maceio"
                    ],
                    days: {
                        "06-24": {
                            name: {
                                pt: "S\xe3o Jo\xe3o"
                            },
                            active: [
                                {
                                    from: "1993-07-07T00:00:00.000Z"
                                }
                            ]
                        },
                        "06-29": {
                            name: {
                                pt: "S\xe3o Pedro"
                            },
                            active: [
                                {
                                    from: "1993-07-07T00:00:00.000Z"
                                }
                            ]
                        },
                        "09-16": {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica"
                            }
                        },
                        "11-20": {
                            name: {
                                pt: "Morte de Zumbi dos Palmares"
                            },
                            active: [
                                {
                                    from: "1995-08-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                AM: {
                    name: "Amazonas",
                    zones: [
                        "America/Manaus"
                    ],
                    days: {
                        "09-05": {
                            name: {
                                pt: "Eleva\xe7\xe3o do Amazonas \xe0 categoria de prov\xedncia"
                            },
                            active: [
                                {
                                    from: "1977-12-21T00:00:00.000Z"
                                }
                            ]
                        },
                        "11-20": {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: "2010-07-08T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                AP: {
                    name: "Amap\xe1",
                    zones: [
                        "America/Belem"
                    ],
                    days: {
                        "03-19": {
                            name: {
                                pt: "Dia de S\xe3o Jos\xe9"
                            },
                            note: "Santo padroeiro do Estado do Amap\xe1",
                            active: [
                                {
                                    from: "2002-04-16T00:00:00.000Z"
                                }
                            ]
                        },
                        "09-13": {
                            name: {
                                pt: "Cria\xe7\xe3o do Territ\xf3rio Federal"
                            }
                        }
                    }
                },
                BA: {
                    name: "Bahia",
                    zones: [
                        "America/Bahia"
                    ],
                    days: {
                        "07-02": {
                            name: {
                                pt: "Independ\xeancia da Bahia"
                            }
                        }
                    }
                },
                CE: {
                    name: "Cear\xe1",
                    zones: [
                        "America/Fortaleza"
                    ],
                    days: {
                        "03-25": {
                            name: {
                                pt: "Data magna do estado"
                            },
                            active: [
                                {
                                    from: "2011-12-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                DF: {
                    name: "Distrito Federal",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "04-21": {
                            name: {
                                pt: "Funda\xe7\xe3o de Bras\xedlia"
                            }
                        },
                        "11-30": {
                            name: {
                                pt: "Dia do Evang\xe9lico"
                            },
                            type: "public",
                            active: [
                                {
                                    from: "1995-12-04T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                MA: {
                    name: "Maranh\xe3o",
                    zones: [
                        "America/Belem"
                    ],
                    days: {
                        "07-28": {
                            name: {
                                pt: "Ades\xe3o do Maranh\xe3o \xe0 independ\xeancia do Brasil"
                            },
                            active: [
                                {
                                    from: "1964-10-02T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                MG: {
                    name: "Minas Gerais",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "04-21": {
                            name: {
                                pt: "Data magna do estado"
                            }
                        }
                    },
                    regions: {
                        BH: {
                            name: "Belo Horizonte",
                            days: {
                                "08-15": {
                                    _name: "08-15",
                                    name: {
                                        pt: "Assun\xe7\xe3o de Nossa Senhora"
                                    },
                                    type: "public"
                                },
                                "12-08": {
                                    _name: "12-08",
                                    type: "public"
                                }
                            }
                        }
                    }
                },
                MS: {
                    name: "Mato Grosso do Sul",
                    zones: [
                        "America/Campo_Grande"
                    ],
                    days: {
                        "10-11": {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: "1979-10-29T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                MT: {
                    name: "Mato Grosso",
                    zones: [
                        "America/Cuiaba"
                    ],
                    days: {
                        "11-20": {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: "2002-12-27T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                PA: {
                    name: "Par\xe1",
                    zones: [
                        "America/Santarem"
                    ],
                    days: {
                        "08-15": {
                            name: {
                                pt: "Ades\xe3o do Gr\xe3o-Par\xe1 \xe0 independ\xeancia do Brasil"
                            },
                            active: [
                                {
                                    from: "1996-09-10T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                PB: {
                    name: "Para\xedba",
                    zones: [
                        "America/Recife"
                    ],
                    days: {
                        "07-26": {
                            name: {
                                pt: "Homenagem \xe0 mem\xf3ria do ex-presidente Jo\xe3o Pessoa"
                            }
                        },
                        "08-05": {
                            name: {
                                pt: "Nossa Senhora das Neves"
                            },
                            note: "Funda\xe7\xe3o do Estado em 1585 e dia da sua padroeira",
                            active: [
                                {
                                    from: "1967-08-30T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                PE: {
                    name: "Pernambuco",
                    zones: [
                        "America/Recife"
                    ],
                    days: {
                        "1st sunday in March": {
                            name: {
                                pt: "Revolu\xe7\xe3o Pernambucana de 1817"
                            },
                            active: [
                                {
                                    from: "2009-07-02T00:00:00.000Z"
                                }
                            ]
                        }
                    },
                    regions: {
                        RE: {
                            name: "Recife",
                            days: {
                                "06-24": {
                                    name: {
                                        pt: "S\xe3o Jo\xe3o",
                                        en: "Saint John's Day"
                                    },
                                    type: "public"
                                },
                                "07-16": {
                                    name: {
                                        pt: "Nossa Senhora do Carmo"
                                    },
                                    type: "public"
                                },
                                "12-08": {
                                    _name: "12-08",
                                    name: {
                                        pt: "Nossa Senhora da Concei\xe7\xe3o"
                                    },
                                    type: "public"
                                }
                            }
                        }
                    }
                },
                PI: {
                    name: "Piau\xed",
                    zones: [
                        "America/Fortaleza"
                    ],
                    days: {
                        "10-19": {
                            name: {
                                pt: "Dia do Piau\xed"
                            },
                            active: [
                                {
                                    from: "1937-01-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                PR: {
                    name: "Paran\xe1",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "12-19": {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica do estado do Paran\xe1"
                            },
                            active: [
                                {
                                    from: "1962-12-18T00:00:00.000Z"
                                }
                            ]
                        }
                    },
                    regions: {
                        CU: {
                            name: "Curitiba",
                            days: {
                                "09-08": {
                                    name: {
                                        pt: "Nossa Senhora da Luz dos Pinhais"
                                    },
                                    type: "public"
                                }
                            }
                        }
                    }
                },
                RJ: {
                    name: "Rio de Janeiro",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "easter -47": {
                            name: {
                                pt: "Carnaval"
                            },
                            active: [
                                {
                                    from: "2008-05-14T00:00:00.000Z"
                                }
                            ]
                        },
                        "04-23": {
                            name: {
                                pt: "Dia de S\xe3o Jorge"
                            },
                            active: [
                                {
                                    from: "2008-03-05T00:00:00.000Z"
                                }
                            ]
                        },
                        "3rd tuesday in October": {
                            name: {
                                pt: "Dia do Com\xe9rcio"
                            },
                            type: "observance",
                            note: "feriado para os comerciantes e trabalhadores da constru\xe7\xe3o civil"
                        },
                        "11-20": {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: "2002-11-11T00:00:00.000Z"
                                }
                            ]
                        }
                    },
                    regions: {
                        RJ: {
                            name: "Rio de Janeiro",
                            days: {
                                "01-20": {
                                    name: {
                                        pt: "Dia de S\xe3o Sebasti\xe3o"
                                    },
                                    type: "public",
                                    active: [
                                        {
                                            from: "1988-06-27T00:00:00.000Z"
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                RN: {
                    name: "Rio Grande do Norte",
                    zones: [
                        "America/Recife"
                    ],
                    days: {
                        "10-03": {
                            name: {
                                pt: "M\xe1rtires de Cunha\xfa e Urua\xe7u"
                            },
                            active: [
                                {
                                    from: "2006-12-06T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                RO: {
                    name: "Rond\xf4nia",
                    zones: [
                        "America/Porto_Velho"
                    ],
                    days: {
                        "01-04": {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: "2010-04-22T00:00:00.000Z"
                                }
                            ]
                        },
                        "06-18": {
                            name: {
                                pt: "Dia do evang\xe9lico"
                            },
                            active: [
                                {
                                    from: "2001-12-20T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                RR: {
                    name: "Roraima",
                    zones: [
                        "America/Boa_Vista"
                    ],
                    days: {
                        "10-05": {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            }
                        }
                    }
                },
                RS: {
                    name: "Rio Grande do Sul",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "09-20": {
                            name: {
                                pt: "Proclama\xe7\xe3o da Rep\xfablica Rio-Grandense"
                            }
                        }
                    }
                },
                SC: {
                    name: "Santa Catarina",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "08-11": {
                            name: {
                                pt: "Dia de Santa Catarina"
                            },
                            active: [
                                {
                                    from: "2004-01-22T00:00:00.000Z",
                                    to: "2005-07-15T00:00:00.000Z"
                                }
                            ]
                        },
                        "08-11 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday": {
                            name: {
                                pt: "Dia de Santa Catarina"
                            },
                            active: [
                                {
                                    from: "2005-07-15T00:00:00.000Z"
                                }
                            ]
                        },
                        "11-25": {
                            name: {
                                pt: "Dia de Santa Catarina de Alexandria"
                            },
                            active: [
                                {
                                    from: "1996-12-26T00:00:00.000Z",
                                    to: "2005-07-15T00:00:00.000Z"
                                }
                            ]
                        },
                        "11-25 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday": {
                            name: {
                                pt: "Dia de Santa Catarina de Alexandria"
                            },
                            active: [
                                {
                                    from: "2005-07-15T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                SE: {
                    name: "Sergipe",
                    zones: [
                        "America/Recife"
                    ],
                    days: {
                        "07-08": {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica de Sergipe"
                            }
                        }
                    }
                },
                SP: {
                    name: "S\xe3o Paulo",
                    zones: [
                        "America/Sao_Paulo"
                    ],
                    days: {
                        "07-09": {
                            name: {
                                pt: "Revolu\xe7\xe3o Constitucionalista"
                            },
                            active: [
                                {
                                    from: "1997-03-05T00:00:00.000Z"
                                }
                            ]
                        },
                        "11-20": {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: "2023-09-12T00:00:00.000Z"
                                }
                            ]
                        }
                    },
                    regions: {
                        SP: {
                            name: "S\xe3o Paulo",
                            days: {
                                "01-25": {
                                    name: {
                                        pt: "Anivers\xe1rio da Cidade",
                                        en: "City Birthday"
                                    },
                                    type: "public"
                                },
                                "11-20": {
                                    name: {
                                        pt: "Dia da Consci\xeancia Negra"
                                    },
                                    active: [
                                        {
                                            from: "2004-01-07T00:00:00.000Z"
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                TO: {
                    name: "Tocantins",
                    zones: [
                        "America/Araguaina"
                    ],
                    days: {
                        "10-05": {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: "1989-11-17T00:00:00.000Z"
                                }
                            ]
                        },
                        "03-18": {
                            name: {
                                pt: "Autonomia do Estado"
                            },
                            active: [
                                {
                                    from: "1998-03-17T00:00:00.000Z"
                                }
                            ]
                        },
                        "09-08": {
                            name: {
                                pt: "Nossa Senhora da Natividade"
                            },
                            note: "Padroeira do Estado",
                            active: [
                                {
                                    from: "1993-12-28T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                }
            }
        },
        BS: {
            names: {
                en: "Bahamas"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Nassau"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-10 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Majority Rule Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "1st friday in June": {
                    _name: "05-01",
                    name: {
                        en: "Randol Fawkes Labour Day"
                    }
                },
                "07-10 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "1st monday in August": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "10-12 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        BW: {
            names: {
                en: "Botswana"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    note: "except mining industy"
                },
                "01-02": {
                    name: {
                        en: "New Year's Holiday"
                    },
                    note: "except mining industy"
                },
                "substitutes 01-02 if monday then next tuesday": {
                    name: {
                        en: "Public Holiday"
                    },
                    note: "except mining industy"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1",
                    note: "except mining industy"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1",
                    note: "except mining industy"
                },
                "easter 39": {
                    _name: "easter 39",
                    note: "except mining industy"
                },
                "05-01": {
                    _name: "05-01",
                    note: "except mining industy"
                },
                "substitutes 05-01 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    },
                    note: "except mining industy"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "07-01": {
                    name: {
                        en: "Sir Seretse Khama Day"
                    },
                    note: "except mining industy"
                },
                "substitutes 07-01 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    },
                    note: "except mining industy"
                },
                "3rd monday in July": {
                    name: {
                        en: "President\u2019s Day"
                    },
                    note: "except mining industy"
                },
                "tuesday after 3rd monday in July": {
                    name: {
                        en: "President\u2019s Day Holiday"
                    },
                    note: "except mining industy"
                },
                "09-30": {
                    name: {
                        en: "Botswana Day"
                    }
                },
                "substitutes 09-30 if saturday,sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        en: "Family Day"
                    },
                    note: "except mining industy"
                },
                "substitutes 12-26 if monday then next tuesday": {
                    name: {
                        en: "Public Holiday"
                    }
                }
            }
        },
        BY: {
            names: {
                be: "\u0420\u044D\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
                ru: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
                en: "Belarus"
            },
            zones: [
                "Europe/Minsk"
            ],
            langs: [
                "be",
                "ru"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "julian 12-25": {
                    _name: "12-25",
                    name: {
                        be: "\u041A\u0430\u043B\u044F\u0434\u044B \u043F\u0440\u0430\u0432\u0430\u0441\u043B\u0430\u045E\u043D\u044B\u044F"
                    }
                },
                easter: {
                    _name: "easter",
                    name: {
                        be: "\u0412\u044F\u043Bi\u043A\u0434\u0437\u0435\u043D\u044C \u043A\u0430\u0442\u0430\u043Bi\u0446\u043Ai"
                    },
                    type: "observance"
                },
                orthodox: {
                    name: {
                        en: "Orthodox Easter",
                        be: "\u0412\u044F\u043Bi\u043A\u0434\u0437\u0435\u043D\u044C \u043F\u0440\u0430\u0432\u0430\u0441\u043B\u0430\u045E\u043D\u044B"
                    },
                    type: "observance"
                },
                "orthodox +9": {
                    name: {
                        en: "Commemoration Day",
                        be: "\u0420\u0430\u0434\u0443\u043Di\u0446\u0430"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-09": {
                    name: {
                        en: "Victory Day",
                        be: "\u0414\u0437\u0435\u043D\u044C \u041F\u0435\u0440\u0430\u043C\u043E\u0433i"
                    }
                },
                "07-03": {
                    _name: "Independence Day",
                    active: [
                        {
                            from: 1996
                        }
                    ]
                },
                "11-07": {
                    name: {
                        en: "October Revolution Day",
                        be: "\u0414\u0437\u0435\u043D\u044C \u041A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u0446\u043A\u0430\u0439 \u0440\u044D\u0432\u0430\u043B\u044E\u0446\u044B\u0456"
                    }
                },
                "12-25": {
                    _name: "12-25",
                    name: {
                        be: "\u041A\u0430\u043B\u044F\u0434\u044B \u043A\u0430\u0442\u0430\u043Bi\u0446\u043Ai\u044F"
                    }
                }
            }
        },
        BZ: {
            names: {
                en: "Belize"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Belize"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-09 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
                    name: {
                        en: "Baron Bliss Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 if sunday then next monday": {
                    _name: "05-01"
                },
                "05-24 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
                    name: {
                        en: "Commonwealth Day, Sovereign's Day"
                    }
                },
                "09-10 if sunday then next monday": {
                    name: {
                        en: "Saint George's Caye Day, National Day"
                    }
                },
                "09-21 if sunday then next monday": {
                    _name: "Independence Day"
                },
                "10-12 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday": {
                    name: {
                        en: "Day of the Americas"
                    }
                },
                "11-19 if sunday then next monday": {
                    name: {
                        en: "Garifuna Settlement Day"
                    }
                },
                "12-25 and if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                }
            }
        },
        CA: {
            names: {
                en: "Canada",
                fr: "Canada"
            },
            zones: [
                "America/Toronto",
                "America/St_Johns",
                "America/Halifax",
                "America/Glace_Bay",
                "America/Moncton",
                "America/Goose_Bay",
                "America/Blanc-Sablon",
                "America/Nipigon",
                "America/Thunder_Bay",
                "America/Iqaluit",
                "America/Pangnirtung",
                "America/Resolute",
                "America/Atikokan",
                "America/Rankin_Inlet",
                "America/Winnipeg",
                "America/Rainy_River",
                "America/Regina",
                "America/Swift_Current",
                "America/Edmonton",
                "America/Cambridge_Bay",
                "America/Yellowknife",
                "America/Inuvik",
                "America/Creston",
                "America/Dawson_Creek",
                "America/Fort_Nelson",
                "America/Vancouver",
                "America/Whitehorse",
                "America/Dawson"
            ],
            langs: [
                "en",
                "fr"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-02": {
                    name: {
                        en: "Groundhog Day",
                        fr: "Jour de la marmotte"
                    },
                    type: "observance"
                },
                "02-14": {
                    _name: "02-14",
                    type: "observance"
                },
                "03-17": {
                    name: {
                        en: "St. Patrick\u2019s Day",
                        fr: "F\xeate de la Saint-Patrick"
                    },
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "2nd sunday after 05-01": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "monday before 05-25": {
                    name: {
                        en: "Victoria Day",
                        fr: "F\xeate de la Reine"
                    }
                },
                "3rd sunday after 06-01": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "07-01": {
                    name: {
                        en: "Canada Day",
                        fr: "F\xeate du Canada"
                    }
                },
                "monday after 08-01": {
                    name: {
                        en: "Civic Holiday",
                        fr: "Premier lundi d\u2019ao\xfbt"
                    }
                },
                "1st monday in September": {
                    _name: "05-01"
                },
                "09-30 since 2021": {
                    name: {
                        en: "National Day for Truth and Reconciliation",
                        fr: "Journ\xe9e nationale de la v\xe9rit\xe9 et de la r\xe9conciliation"
                    }
                },
                "2nd monday after 10-01": {
                    name: {
                        en: "Thanksgiving",
                        fr: "Action de gr\xe2ce"
                    }
                },
                "10-31 18:00": {
                    name: {
                        en: "Halloween",
                        fr: "l'Halloween"
                    },
                    type: "observance"
                },
                "11-11": {
                    name: {
                        en: "Remembrance Day",
                        fr: "Jour du Souvenir"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            },
            states: {
                AB: {
                    name: "Alberta",
                    zones: [
                        "America/Edmonton"
                    ],
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Family Day",
                                fr: "F\xeate de la famille"
                            }
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "monday after 08-01": {
                            name: {
                                en: "Heritage Day",
                                fr: "F\xeate du patrimoine"
                            },
                            type: "optional"
                        }
                    }
                },
                BC: {
                    name: "British Columbia",
                    zones: [
                        "America/Vancouver",
                        "America/Edmonton",
                        "America/Creston",
                        "America/Dawson_Creek"
                    ],
                    days: {
                        "2nd monday after 02-01": {
                            name: {
                                en: "Family Day",
                                fr: "F\xeate de la famille"
                            },
                            active: [
                                {
                                    to: 2019
                                }
                            ]
                        },
                        "3rd monday after 02-01": {
                            name: {
                                en: "Family Day",
                                fr: "F\xeate de la famille"
                            },
                            active: [
                                {
                                    from: 2019
                                }
                            ]
                        }
                    }
                },
                MB: {
                    name: "Manitoba",
                    zones: [
                        "America/Winnipeg"
                    ],
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Louis Riel Day",
                                fr: "Journ\xe9e Louis Riel"
                            }
                        }
                    }
                },
                NB: {
                    name: "New Brunswick",
                    zones: [
                        "America/Moncton"
                    ],
                    days: {
                        "monday after 08-01": {
                            name: {
                                en: "New Brunswick Day",
                                fr: "Jour de Nouveau Brunswick"
                            }
                        }
                    }
                },
                NL: {
                    name: "Newfoundland and Labrador",
                    zones: [
                        "America/St_Johns",
                        "America/Goose_Bay"
                    ],
                    days: {
                        "03-17": {
                            name: {
                                en: "Saint Patrick's Day",
                                fr: "Jour de la Saint-Patrick"
                            },
                            type: "optional"
                        },
                        "04-23": {
                            name: {
                                en: "Saint George's Day",
                                fr: "Jour de St. George"
                            },
                            type: "optional"
                        },
                        "06-24": {
                            name: {
                                en: "Discovery Day",
                                fr: "Journ\xe9e d\xe9couverte"
                            },
                            type: "optional"
                        },
                        "07-12": {
                            name: {
                                en: "Orangemen's Day",
                                fr: "F\xeate des orangistes"
                            },
                            type: "optional"
                        },
                        "11-11": {
                            name: {
                                en: "Armistice Day",
                                fr: "Jour de l'Armistice"
                            }
                        }
                    }
                },
                NS: {
                    name: "Nova Scotia",
                    zones: [
                        "America/Halifax",
                        "America/Moncton"
                    ],
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Heritage Day",
                                fr: "F\xeate du Patrimoine"
                            }
                        },
                        "monday after 08-01": {
                            name: {
                                en: "Natal Day",
                                fr: "Jour de la Fondation"
                            }
                        }
                    }
                },
                NT: {
                    name: "Northwest Territories",
                    zones: [
                        "America/Yellowknife",
                        "America/Inuvik"
                    ],
                    days: {
                        "06-21": {
                            name: {
                                en: "National Indigenous Peoples Day",
                                fr: "Journ\xe9e nationale des Autochthones"
                            }
                        }
                    }
                },
                NU: {
                    name: "Nunavut",
                    zones: [
                        "America/Iqaluit",
                        "America/Pangnirtung",
                        "America/Resolute",
                        "America/Rankin_Inlet",
                        "America/Atikokan",
                        "America/Cambridge_Bay"
                    ],
                    days: {
                        "07-09": {
                            name: {
                                en: "Nunavut Day"
                            },
                            type: "bank"
                        }
                    }
                },
                ON: {
                    name: "Ontario",
                    zones: [
                        "America/Toronto",
                        "America/Nipigon",
                        "America/Thunder_Bay",
                        "America/Atikokan",
                        "America/Rainy_River",
                        "America/Winnipeg"
                    ],
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Family Day",
                                fr: "F\xeate de la famille"
                            }
                        },
                        "easter 1": {
                            _name: "easter 1"
                        }
                    }
                },
                PE: {
                    name: "Prince Edward Island",
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Islander Day",
                                fr: "F\xeate des Insulaires"
                            }
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "3rd friday after 08-01": {
                            name: {
                                en: "Gold Cup Parade Day",
                                fr: "D\xe9fil\xe9 de la Coupe d'or"
                            }
                        }
                    }
                },
                QC: {
                    name: "Quebec",
                    zones: [
                        "America/Blanc-Sablon",
                        "America/Toronto",
                        "America/Nipigon"
                    ],
                    days: {
                        "easter -2": {
                            _name: "easter -2",
                            note: "Either Good Friday or Easter Monday, at the employer\u2019s option"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            note: "Either Good Friday or Easter Monday, at the employer\u2019s option"
                        },
                        "monday before 05-25": {
                            name: {
                                en: "National Patriots' Day",
                                fr: "Journ\xe9e nationale des patriotes"
                            }
                        },
                        "06-24": {
                            name: {
                                en: "National Holiday",
                                fr: "F\xeate nationale du Qu\xe9bec"
                            }
                        },
                        "monday after 08-01": false
                    }
                },
                SK: {
                    name: "Saskatchewan",
                    zones: [
                        "America/Regina",
                        "America/Swift_Current",
                        "America/Edmonton"
                    ],
                    days: {
                        "3rd monday after 02-01": {
                            name: {
                                en: "Family Day",
                                fr: "F\xeate de la famille"
                            }
                        },
                        "3rd monday after 08-01": {
                            name: {
                                en: "Saskatchewan Day"
                            }
                        }
                    }
                },
                YT: {
                    name: "Yukon",
                    zones: [
                        "America/Whitehorse",
                        "America/Dawson"
                    ],
                    days: {
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "3rd monday after 08-01": {
                            name: {
                                en: "Discovery Day",
                                fr: "Jour de la D\xe9couverte"
                            }
                        }
                    }
                }
            }
        },
        CC: {
            names: {
                en: "Cocos (Keeling) Islands"
            },
            langs: [
                "en"
            ],
            zones: [
                "Indian/Cocos"
            ],
            dayoff: "sunday",
            days: {
                "chinese 01-0-01 and if sunday then next tuesday if saturday then next monday": {
                    name: {
                        en: "Chinese New Year"
                    },
                    substitute: true
                },
                "chinese 01-0-02 and if sunday then next tuesday if saturday then next monday": {
                    name: {
                        en: "Chinese New Year (2nd Day)"
                    },
                    substitute: true
                },
                "01-01": {
                    _name: "01-01"
                },
                "01-26": {
                    name: {
                        en: "Australia Day"
                    }
                },
                "03-20": {
                    name: {
                        en: "Labour Day"
                    }
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-06": {
                    name: {
                        en: "Self Determination Day"
                    }
                },
                "04-25": {
                    name: {
                        en: "Anzac Day"
                    }
                },
                "12-25 and if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                },
                "1 Muharram and if sunday then next monday": {
                    substitute: true,
                    _name: "1 Muharram"
                },
                "1 Shawwal and if sunday then next monday": {
                    substitute: true,
                    _name: "1 Shawwal",
                    name: {
                        en: "Hari Raya Puasa"
                    }
                },
                "10 Dhu al-Hijjah and if sunday then next monday": {
                    substitute: true,
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Hari Raya Haji"
                    }
                },
                "12 Rabi al-awwal and if sunday then next monday": {
                    substitute: true,
                    _name: "12 Rabi al-awwal",
                    name: {
                        en: "Hari Maulaud Nabi"
                    }
                }
            }
        },
        CD: {
            names: {
                fr: "R\xe9publique d\xe9mocratique du Congo",
                en: "Democratic Republic of the Congo"
            },
            dayoff: "sunday",
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Maputo",
                "Africa/Lagos"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-04 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        fr: "Martyrs de l'Ind\xe9pendance",
                        en: "Day of the Martyrs"
                    }
                },
                "01-16 and if sunday then next tuesday": {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e du H\xe9ro National Laurent D\xe9sir\xe9 Kabila",
                        en: "Anniversary of President Laurent Kabila"
                    }
                },
                "01-17 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e du H\xe9ro National Patrice Emery Lumumba",
                        en: "Anniversary of Prime Minister Patrice Emery Lumumba"
                    }
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "05-17 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e de la R\xe9volution et des Forces Arm\xe9es",
                        en: "Liberation Day"
                    }
                },
                "06-30 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day",
                    name: {
                        fr: "Anniversaire de Ind\xe9pendance"
                    }
                },
                "08-01 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        fr: "F\xeate des parents",
                        en: "Parents' Day"
                    }
                },
                "12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "2016-01-15": {
                    _name: "Public Holiday"
                }
            }
        },
        CF: {
            names: {
                fr: "R\xe9publique centrafricaine",
                sg: "K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka",
                en: "Central African Republic"
            },
            dayoff: "sunday",
            langs: [
                "fr",
                "sg"
            ],
            zones: [
                "Africa/Lagos"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-29": {
                    name: {
                        fr: "D\xe9c\xe8s du Fondateur Barth\xe9l\xe9my Boganda",
                        en: "Boganda Day"
                    }
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-30": {
                    name: {
                        fr: "Journ\xe9e de pri\xe8re",
                        en: "General Prayer Day"
                    }
                },
                "08-13": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-01": {
                    name: {
                        fr: "Jour de la R\xe9publique",
                        en: "Republic Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        CG: {
            names: {
                fr: "R\xe9publique du Congo",
                en: "Republic of the Congo"
            },
            dayoff: "sunday",
            langs: [
                "fr",
                "en"
            ],
            zones: [
                "Africa/Lagos"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-10": {
                    name: {
                        fr: "F\xeate de la comm\xe9moration de la conf\xe9rence nationale souveraine"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-28": {
                    name: {
                        fr: "Journ\xe9e nationale de la R\xe9publique"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        CH: {
            names: {
                de: "Schweiz",
                fr: "Suisse",
                it: "Svizzera",
                en: "Switzerland"
            },
            dayoff: "sunday",
            langs: [
                "de-ch",
                "de",
                "fr",
                "it"
            ],
            zones: [
                "Europe/Zurich"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 39": {
                    _name: "easter 39",
                    name: {
                        de: "Auffahrt"
                    }
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "1st sunday in June": {
                    name: {
                        de: "V\xe4tertag",
                        fr: "F\xeate des p\xe8res"
                    },
                    type: "observance",
                    active: [
                        {
                            from: "2009-01-01"
                        }
                    ]
                },
                "08-01": {
                    name: {
                        de: "Bundesfeiertag",
                        fr: "F\xeate nationale",
                        it: "Giorno festivo federale"
                    }
                },
                "3rd sunday after 09-01": {
                    name: {
                        de: "Eidg. Dank-, Buss- und Bettag",
                        fr: "Je\xfbne f\xe9d\xe9ral",
                        it: "Digiuno federale",
                        en: "Federal Day of Thanksgiving, Repentance and Prayer"
                    }
                },
                "12-25": {
                    _name: "12-25",
                    name: {
                        de: "Weihnachtstag"
                    }
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        de: "Stephanstag",
                        fr: "Saint-Etienne"
                    }
                }
            },
            states: {
                ZH: {
                    names: {
                        de: "Kanton Z\xfcrich",
                        fr: "Canton de Zurich",
                        it: "Canton Zurigo",
                        en: "Canton of Z\xfcrich"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "05-01": {
                            _name: "05-01"
                        },
                        "easter 50": {
                            _name: "easter 50"
                        },
                        "monday after 2nd saturday in September 13:00": {
                            name: {
                                de: "Knabenschiessen"
                            },
                            type: "optional"
                        }
                    }
                },
                BE: {
                    names: {
                        de: "Kanton Bern",
                        fr: "Canton de Berne",
                        it: "Canton Berna",
                        en: "Canton of Bern"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 janvier"
                            }
                        }
                    }
                },
                LU: {
                    names: {
                        de: "Kanton Luzern",
                        fr: "Canton de Lucerne",
                        it: "Canton Lucerna",
                        en: "Canton of Lucerne"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "03-19": {
                            _name: "03-19",
                            type: "observance"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        }
                    }
                },
                UR: {
                    names: {
                        de: "Kanton Uri",
                        fr: "Canton d'Uri",
                        it: "Canton Uri",
                        en: "Canton of Uri"
                    },
                    days: {
                        "01-06": {
                            _name: "01-06"
                        },
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        },
                        "12-26": false,
                        "12-26 not on monday, friday": {
                            _name: "12-26"
                        }
                    }
                },
                SZ: {
                    names: {
                        de: "Kanton Schwyz",
                        fr: "Canton de Schwytz",
                        it: "Canton Svitto",
                        en: "Canton of Schwyz"
                    },
                    days: {
                        "01-06": {
                            _name: "01-06"
                        },
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        }
                    }
                },
                OW: {
                    names: {
                        de: "Kanton Obwalden",
                        fr: "Canton d'Obwald",
                        it: "Canton Obvaldo",
                        en: "Canton of Obwalden"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "09-25": {
                            name: {
                                de: "Bruderklausenfest",
                                fr: "Saint-Nicholas-de-Fl\xfce",
                                en: "Saint Nicholas of Fl\xfce"
                            }
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "optional"
                        }
                    }
                },
                NW: {
                    names: {
                        de: "Kanton Nidwalden",
                        fr: "Canton de Nidwald",
                        it: "Canton Nidvaldo",
                        en: "Canton of Nidwalden"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "bank"
                        },
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "optional"
                        }
                    }
                },
                GL: {
                    sources: [
                        "https://www.gl.ch/verwaltung/staatskanzlei/oeffentliche-feiertage.html/1335"
                    ],
                    names: {
                        de: "Kanton Glarus",
                        fr: "Canton de Glaris",
                        it: "Canton Glarona",
                        en: "Canton of Glarus"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "Thursday after 04-02 if is observance holiday then next Thursday": {
                            name: {
                                de: "N\xe4felser Fahrt",
                                fr: "Bataille de N\xe4fels"
                            }
                        },
                        "3rd sunday after 09-01": false,
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-24": {
                            _name: "12-24"
                        },
                        "12-31": {
                            _name: "12-31"
                        }
                    }
                },
                ZG: {
                    names: {
                        de: "Kanton Zug",
                        fr: "Canton de Zoug",
                        it: "Canton Zugo",
                        en: "Canton of Zug"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "optional"
                        }
                    }
                },
                FR: {
                    names: {
                        fr: "Canton de Fribourg",
                        de: "Kanton Freiburg",
                        it: "Canton Friburgo",
                        en: "Canton of Fribourg"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60",
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        "08-15": {
                            _name: "08-15",
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        "11-01": {
                            _name: "11-01",
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        "12-08": {
                            _name: "12-08",
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "optional"
                        }
                    }
                },
                SO: {
                    names: {
                        de: "Kanton Solothurn",
                        fr: "Canton de Soleure",
                        it: "Canton Soletta",
                        en: "Canton of Solothurn"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "03-19": {
                            _name: "03-19",
                            note: "Only in communities: Fulenbach, Walterswil, Wisen, Metzerlen, Nulgar-St. Pantaleon, Rodersdorf, B\xe4rschwil, B\xfcsserach\n"
                        },
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "05-01 12:00": {
                            _name: "05-01"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60",
                            note: "is optional in Bucheggberg"
                        },
                        "08-15": {
                            _name: "08-15",
                            note: "is optional in Bucheggberg"
                        },
                        "11-01": {
                            _name: "11-01",
                            note: "is optional in Bucheggberg"
                        },
                        "12-26": {
                            _name: "12-26",
                            type: "optional"
                        }
                    }
                },
                BS: {
                    names: {
                        de: "Kanton Basel-Stadt",
                        fr: "Canton de B\xe2le-Ville",
                        it: "Canton Basilea Citt\xe0",
                        en: "Canton of Basel-City"
                    },
                    days: {
                        "05-01": {
                            _name: "05-01"
                        }
                    }
                },
                BL: {
                    names: {
                        de: "Kanton Basel-Landschaft",
                        fr: "Canton de B\xe2le-Campagne",
                        it: "Canton Basilea Campagna",
                        en: "Canton of Basel-Country"
                    },
                    days: {
                        "05-01": {
                            _name: "05-01"
                        },
                        "easter 60": {
                            _name: "easter 60",
                            type: "observance"
                        }
                    }
                },
                SH: {
                    names: {
                        de: "Kanton Schaffhausen",
                        fr: "Canton de Schaffhouse",
                        it: "Canton Sciaffusa",
                        en: "Canton of Schaffhausen"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "optional"
                        },
                        "05-01": {
                            _name: "05-01"
                        }
                    }
                },
                AR: {
                    names: {
                        de: "Kanton Appenzell Ausserrhoden",
                        fr: "Canton d'Appenzell Rhodes-Ext\xe9rieures",
                        it: "Canton Appenzello Esterno",
                        en: "Canton of Appenzell Outer Rhodes"
                    },
                    days: {
                        "12-26": false,
                        "12-26 not on monday": {
                            _name: "12-26"
                        }
                    }
                },
                AI: {
                    names: {
                        de: "Kanton Appenzell Innerrhoden",
                        fr: "Canton d'Appenzell Rhodes-Int\xe9rieures",
                        it: "Canton Appenzello Interno",
                        en: "Canton of Appenzell Inner-Rhodes"
                    },
                    days: {
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "09-22": {
                            name: {
                                de: "Mauritiustag"
                            },
                            note: "excluding: Bezirk Oberegg\n"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-26": {
                            type: "observance"
                        },
                        "12-26 not on tuesday, saturday": {
                            _name: "12-26"
                        }
                    }
                },
                SG: {
                    names: {
                        de: "Kanton St. Gallen",
                        fr: "Canton de Saint-Gall",
                        it: "Canton San Gallo",
                        en: "Canton of St. Gallen"
                    },
                    days: {
                        "11-01": {
                            _name: "11-01"
                        }
                    }
                },
                GR: {
                    names: {
                        de: "Kanton Graub\xfcnden",
                        it: "Cantone dei Grigioni",
                        fr: "Canton des Grisons",
                        en: "Canton of Grisons"
                    },
                    langs: [
                        "de-ch",
                        "de",
                        "it",
                        "fr"
                    ],
                    days: {
                        "01-06": {
                            _name: "01-06",
                            type: "observance"
                        },
                        "03-19": {
                            _name: "03-19",
                            type: "observance"
                        },
                        "easter -2": {
                            _name: "easter -2",
                            type: "optional"
                        },
                        "easter 60": {
                            _name: "easter 60",
                            type: "observance"
                        },
                        "08-15": {
                            _name: "08-15",
                            type: "observance"
                        },
                        "11-01": {
                            _name: "11-01",
                            type: "observance"
                        },
                        "12-08": {
                            _name: "12-08",
                            type: "observance"
                        }
                    }
                },
                AG: {
                    names: {
                        de: "Kanton Aargau",
                        fr: "Canton d'Argovie",
                        it: "Canton Argovia",
                        en: "Canton of Aargau"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            }
                        },
                        "05-01": {
                            _name: "05-01"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        }
                    }
                },
                TG: {
                    names: {
                        de: "Kanton Thurgau",
                        fr: "Canton de Thurgovie",
                        it: "Canton Turgovia",
                        en: "Canton of Thurgau"
                    },
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            }
                        },
                        "05-01": {
                            _name: "05-01"
                        }
                    }
                },
                TI: {
                    names: {
                        it: "Canton Ticino",
                        de: "Kanton Tessin",
                        fr: "Canton du Tessin",
                        en: "Canton of Ticino"
                    },
                    langs: [
                        "it",
                        "de-ch",
                        "de",
                        "fr"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "bank"
                        },
                        "01-06": {
                            _name: "01-06",
                            name: {
                                it: "Epifania"
                            }
                        },
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter -2": false,
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "05-01": {
                            _name: "05-01"
                        },
                        "06-29": {
                            _name: "06-29"
                        },
                        "1st sunday in June": false,
                        "08-15": {
                            _name: "08-15",
                            name: {
                                it: "Assunzione"
                            }
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        }
                    }
                },
                VD: {
                    names: {
                        fr: "Canton de Vaud",
                        de: "Kanton Waadt",
                        it: "Canton Vaud",
                        en: "Canton of Vaud"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 Janvier"
                            }
                        },
                        "monday after 3rd sunday in September": {
                            name: {
                                de: "Bettagsmontag",
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
                            }
                        },
                        "12-26": false
                    }
                },
                VS: {
                    names: {
                        fr: "Canton du Valais",
                        de: "Kanton Wallis",
                        it: "Canton Vallese",
                        en: "Canton of Valais"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "Saint-Berthold"
                            },
                            type: "bank"
                        },
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter -2": false,
                        "easter 1": {
                            _name: "easter 1",
                            type: "optional"
                        },
                        "05-01 12:00": {
                            _name: "05-01"
                        },
                        "easter 50": {
                            _name: "easter 50"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "monday after 3rd sunday after 09-01": {
                            name: {
                                de: "Bettagsmontag",
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
                            },
                            type: "bank"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-08": {
                            _name: "12-08"
                        },
                        "12-24 12:00": {
                            _name: "12-24"
                        },
                        "12-26": {
                            type: "optional"
                        }
                    }
                },
                NE: {
                    names: {
                        fr: "Canton de Neuch\xe2tel",
                        de: "Kanton Neuenburg",
                        it: "Canton Neuch\xe2tel",
                        en: "Canton of Neuch\xe2tel"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02 on monday": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 Janvier"
                            }
                        },
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 Janvier"
                            },
                            type: "observance"
                        },
                        "03-01": {
                            name: {
                                fr: "Instauration de la R\xe9publique",
                                de: "Jahrestag Ausrufung der Republik"
                            }
                        },
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "05-01": {
                            _name: "05-01"
                        },
                        "easter 50": {
                            _name: "easter 50",
                            type: "observance"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "monday after 3rd sunday in September": {
                            name: {
                                de: "Bettagsmontag",
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: "Monday after Federal Day of Thanksgiving, Repentance and Prayer"
                            },
                            type: "optional"
                        },
                        "12-26": {
                            type: "observance"
                        },
                        "12-26 on monday": {
                            _name: "12-26"
                        }
                    }
                },
                GE: {
                    names: {
                        fr: "Canton de Gen\xe8ve",
                        de: "Kanton Genf",
                        it: "Canton Ginevra",
                        en: "Canton of Geneva"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 Janvier"
                            },
                            type: "bank"
                        },
                        "thursday after 1st sunday after 09-01": {
                            name: {
                                de: "Genfer Bettag",
                                fr: "Je\xfbne Genevois"
                            }
                        },
                        "12-26": {
                            type: "bank"
                        },
                        "12-31": {
                            name: {
                                de: "Wiederherstellung der Republik",
                                fr: "Restauration de la R\xe9publique",
                                en: "Restoration of the Republic"
                            }
                        },
                        "3rd sunday after 09-01": false
                    }
                },
                JU: {
                    names: {
                        fr: "Canton du Jura",
                        de: "Kanton Jura",
                        it: "Canton Giura",
                        en: "Canton of Jura"
                    },
                    langs: [
                        "fr",
                        "de-ch",
                        "de",
                        "it"
                    ],
                    days: {
                        "01-02": {
                            name: {
                                de: "Berchtoldstag",
                                fr: "2 Janvier"
                            }
                        },
                        "05-01": {
                            _name: "05-01"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "06-23": {
                            name: {
                                fr: "Pl\xe9biscite jurassien",
                                en: "Jura Plebiscite",
                                de: "Fest der Unabh\xe4ngigkeit"
                            }
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "12-26": false
                    }
                }
            }
        },
        CI: {
            names: {
                fr: "R\xe9publique de C\xf4te d'Ivoire",
                en: "Republic of C\xf4te d'Ivoire"
            },
            langs: [
                "fr",
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "08-07 since 1960": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-15 since 1996": {
                    name: {
                        en: "National Peace Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "27 Ramadan": {
                    _name: "27 Ramadan"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        CK: {
            names: {
                rar: "K\u016Bki '\u0100irani",
                en: "Cook Islands"
            },
            langs: [
                "en",
                "rar"
            ],
            zones: [
                "Pacific/Rarotonga"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-02 and if Saturday then next Monday if Monday, Sunday then next Tuesday": {
                    substitute: true,
                    name: {
                        en: "Day after New Year's Day"
                    }
                },
                "04-25": {
                    name: {
                        en: "Anzac Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1st Monday in June": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "1st Friday in July": {
                    name: {
                        en: "Ra o te Ui Ariki (House of Ariki)",
                        rar: "Ra o te Ui Ariki"
                    }
                },
                "08-04 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "Constitution Day"
                },
                "10-26 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Gospel Day"
                    }
                },
                "12-25 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Saturday then next Monday if Monday, Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-26"
                }
            },
            states: {
                Aitutaki: {
                    names: {
                        en: "Aitutaki"
                    },
                    days: {
                        "10-26 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Aitutaki Gospel Day"
                            }
                        }
                    }
                },
                Atiu: {
                    names: {
                        en: "Atiu"
                    },
                    days: {
                        "07-19 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Atiu Gospel Day"
                            }
                        }
                    }
                },
                Mangaia: {
                    names: {
                        en: "Mangaia"
                    },
                    days: {
                        "06-15 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Mangaia Gospel Day"
                            }
                        }
                    }
                },
                Manihiki: {
                    names: {
                        en: "Manihiki"
                    },
                    days: {
                        "08-08 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Manihiki Gospel Day"
                            }
                        }
                    }
                },
                Mitiaro: {
                    names: {
                        en: "Mitiaro"
                    },
                    days: {
                        "07-21 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Mitiaro Gospel Day"
                            }
                        }
                    }
                },
                Palmerston: {
                    names: {
                        en: "Palmerston"
                    },
                    days: {
                        "05-25 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Palmerston Gospel Day"
                            }
                        }
                    }
                },
                Penrhyn: {
                    names: {
                        en: "Penrhyn"
                    },
                    days: {
                        "05-13 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Penrhyn Gospel Day"
                            }
                        }
                    }
                },
                Pukapuka: {
                    names: {
                        en: "Pukapuka"
                    },
                    days: {
                        "12-06 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Pukapuka Gospel Day"
                            }
                        }
                    }
                },
                Rakahanga: {
                    names: {
                        en: "Rakahanga"
                    },
                    days: {
                        "08-15 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Rakahanga Gospel Day"
                            }
                        }
                    }
                },
                Rarotonga: {
                    names: {
                        en: "Rarotonga"
                    },
                    days: {
                        "07-25 and if Saturday, Sunday then next Monday": {
                            substitute: true,
                            name: {
                                en: "Rarotonga Gospel Day"
                            }
                        }
                    }
                }
            }
        },
        CL: {
            names: {
                es: "Chile",
                en: "Chile"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Santiago",
                "Pacific/Easter"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02 on monday since 2017": {
                    name: "D\xeda adicional",
                    active: [
                        {
                            from: 2017
                        }
                    ]
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-21": {
                    name: {
                        en: "Navy Day",
                        es: "D\xeda de las Glorias Navales"
                    }
                },
                "06-21 since 2023": {
                    name: {
                        en: "Indigenous People's Day",
                        es: "D\xeda de los Pueblos Ind\xedgenas"
                    }
                },
                "06-29 if tuesday, wednesday, thursday then previous monday if friday then next monday": {
                    _name: "06-29"
                },
                "07-16": {
                    name: {
                        en: "Our Lady of Mount Carmel",
                        es: "Virgen del Carmen"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "2022-09-16": {
                    name: {
                        es: "Fiestas Patrias",
                        en: "National Holiday"
                    }
                },
                "09-17 on friday, monday since 2017": {
                    name: {
                        en: "National holiday",
                        es: "Feriado Adicional Fiestas Patrias"
                    }
                },
                "09-18": {
                    name: {
                        en: "National holiday",
                        es: "Fiestas Patrias"
                    }
                },
                "09-19": {
                    name: {
                        en: "Army Day",
                        es: "D\xeda de las Glorias del Ej\xe9rcito"
                    }
                },
                "09-20 on friday": {
                    name: {
                        es: "Feriado Adicional Fiestas Patrias",
                        en: "National Holiday"
                    }
                },
                "10-12 if tuesday, wednesday, thursday then previous monday if friday then next monday": {
                    name: {
                        en: "Columbus Day",
                        es: "Encuentro de Dos Mundos"
                    }
                },
                "10-31 if wednesday then next friday if tuesday then previous friday": {
                    _name: "Reformation Day"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            },
            states: {
                AP: {
                    name: "Arica y Parinacota",
                    days: {
                        "06-07": {
                            name: {
                                en: "Battle of Arica",
                                es: "Asalto y Toma del Morro de Arica"
                            }
                        }
                    }
                },
                BI: {
                    name: "Biob\xedo",
                    regions: {
                        CH: {
                            name: "Chill\xe1n y Chill\xe1n Viejo",
                            days: {
                                "08-20": {
                                    name: {
                                        en: "Nativity of Liberator Bernardo O'Higgins",
                                        es: "Nacimiento del Pr\xf3cer de la Independencia"
                                    },
                                    active: [
                                        {
                                            to: "2017-08-19"
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                NU: {
                    name: "\xd1uble",
                    regions: {
                        CH: {
                            name: "Chill\xe1n y Chill\xe1n Viejo",
                            days: {
                                "08-20": {
                                    name: {
                                        en: "Nativity of Liberator Bernardo O'Higgins",
                                        es: "Nacimiento del Pr\xf3cer de la Independencia"
                                    },
                                    active: [
                                        {
                                            from: "2017-08-19"
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                TA: {
                    name: "Tarapac\xe1",
                    days: {
                        "08-10": {
                            name: {
                                en: "Saint Lawrence",
                                es: "San Lorenzo de Tarapac\xe1"
                            },
                            type: "observance",
                            disable: [
                                2015
                            ]
                        },
                        "2015-08-10": {
                            name: {
                                en: "Saint Lawrence",
                                es: "San Lorenzo de Tarapac\xe1"
                            }
                        }
                    }
                }
            }
        },
        CM: {
            names: {
                fr: "Cameroun",
                en: "Cameroon"
            },
            dayoff: "sunday",
            langs: [
                "fr",
                "en"
            ],
            zones: [
                "Africa/Lagos"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-11": {
                    name: {
                        fr: "F\xeate de la Jeunesse",
                        en: "Youth Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01 if sunday then next monday": {
                    _name: "05-01"
                },
                "05-20": {
                    name: {
                        fr: "F\xeate nationale ou de l'unit\xe9",
                        en: "National Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "08-15": {
                    _name: "08-15"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        CN: {
            names: {
                en: "China",
                zh: "\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD"
            },
            dayoff: "sunday",
            langs: [
                "zh",
                "en"
            ],
            zones: [
                "Asia/Shanghai",
                "Asia/Urumqi"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-08 12:00": {
                    _name: "03-08",
                    note: "Women"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-04 12:00": {
                    name: {
                        en: "Youth Day",
                        zh: "\u9752\u5E74\u8282"
                    },
                    note: "Youth from the age of 14 to 28"
                },
                "06-01": {
                    name: {
                        en: "Children's Day",
                        zh: "\u516D\u4E00\u513F\u7AE5\u8282"
                    },
                    note: "Children below the age of 14"
                },
                "08-01 12:00": {
                    name: {
                        en: "Army Day",
                        zh: "\u5EFA\u519B\u8282"
                    },
                    note: "Military personnel in active service"
                },
                "10-01": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                "10-02": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                "10-03": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                "chinese 01-0-00": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "chinese 01-0-02": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "chinese 5-01 solarterm": {
                    name: {
                        en: "Qingming Festival",
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                "chinese 05-0-05": {
                    name: {
                        en: "Dragon Boat Festival",
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                "chinese 08-0-15": {
                    name: {
                        en: "Mid-Autumn Festival",
                        zh: "\u4E2D\u79CB\u8282"
                    }
                },
                "2021-01-02": {
                    _name: "01-01"
                },
                "2021-01-03": {
                    _name: "01-01"
                },
                "2021-02-14": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    },
                    note: "Work on Sun February 7 and Sat February 20."
                },
                "2021-02-15": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "2021-02-16": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "2021-02-17": {
                    name: {
                        en: "Spring Festival",
                        zh: "\u6625\u8282"
                    }
                },
                "2021-04-03": {
                    name: {
                        en: "Qingming Festival",
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                "2021-04-05": {
                    name: {
                        en: "Qingming Festival",
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                "2021-05-02": {
                    _name: "05-01",
                    note: "Work on Sun April 25 and Sat May 8."
                },
                "2021-05-03": {
                    _name: "05-01"
                },
                "2021-05-04": {
                    _name: "05-01"
                },
                "2021-05-05": {
                    _name: "05-01"
                },
                "2021-06-12": {
                    name: {
                        en: "Dragon Boat Festival",
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                "2021-06-13": {
                    name: {
                        en: "Dragon Boat Festival",
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                "2021-09-19": {
                    name: {
                        en: "Mid-Autumn Festival",
                        zh: "\u4E2D\u79CB\u8282"
                    },
                    note: "Work on Sat September 18."
                },
                "2021-09-20": {
                    name: {
                        en: "Mid-Autumn Festival",
                        zh: "\u4E2D\u79CB\u8282"
                    }
                },
                "2021-10-04": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    },
                    note: "Work on Sun September 26 and Sat October 9."
                },
                "2021-10-05": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                "2021-10-06": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                "2021-10-07": {
                    name: {
                        en: "National Day",
                        zh: "\u56FD\u5E86\u8282"
                    }
                }
            }
        },
        CO: {
            names: {
                es: "Colombia",
                en: "Colombia"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Bogota"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "monday after 01-06": {
                    _name: "01-06"
                },
                "monday after 03-19": {
                    _name: "03-19"
                },
                "easter -7": {
                    _name: "easter -7",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 43": {
                    _name: "easter 39"
                },
                "easter 64": {
                    _name: "easter 60"
                },
                "easter 71": {
                    name: {
                        es: "Sagrado Coraz\xf3n de Jes\xfas",
                        en: "Sacred Heart"
                    }
                },
                "monday after 06-29": {
                    _name: "06-29"
                },
                "07-20": {
                    _name: "Independence Day"
                },
                "08-07": {
                    name: {
                        en: "Battle of Boyac\xe1",
                        es: "Batalla de Boyac\xe1"
                    }
                },
                "monday after 08-15": {
                    _name: "08-15"
                },
                "monday after 10-12": {
                    name: {
                        es: "D\xeda de la Raza",
                        en: "Columbus Day"
                    }
                },
                "1st monday in November": {
                    _name: "11-01"
                },
                "monday after 11-11": {
                    name: {
                        es: "Independencia de Cartagena",
                        en: "Independence of Cartagena"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        CR: {
            names: {
                es: "Costa Rica",
                en: "Costa Rica"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Costa_Rica"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-11": {
                    name: {
                        es: "Gesta Heroica de Juan Santamar\xeda"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-25": {
                    name: {
                        en: "Guanacaste Day",
                        es: "Anexi\xf3n del Partido de Nicoya"
                    }
                },
                "08-02": {
                    name: {
                        en: "Our Lady of Los \xc1ngeles",
                        es: "D\xeda de la Virgen de los \xc1ngeles"
                    }
                },
                "08-15": {
                    _name: "Mothers Day"
                },
                "09-15": {
                    _name: "Independence Day"
                },
                "10-12 if monday then previous friday": {
                    name: {
                        en: "Columbus Day",
                        es: "D\xeda de la Raza"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        CU: {
            names: {
                es: "Cuba",
                en: "Cuba"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Havana"
            ],
            days: {
                "01-01": {
                    name: {
                        es: "Triunfo de la Revoluci\xf3n",
                        en: "Triumph of the Revolution"
                    }
                },
                "01-02": {
                    name: {
                        es: "D\xeda de Victoria de las Fuerzas Armadas",
                        en: "Victory of Armed Forces Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-25": {
                    name: {
                        es: "Conmemoraci\xf3n del asalto a Moncada",
                        en: "Day before the Commemoration of the Assault of the Moncada garrison"
                    }
                },
                "07-26": {
                    name: {
                        es: "D\xeda de la Rebeld\xeda Nacional",
                        en: "Commemoration of the Assault of the Moncada garrison"
                    }
                },
                "07-27": {
                    name: {
                        es: "Conmemoraci\xf3n del asalto a Moncada",
                        en: "Day after the Commemoration of the Assault of the Moncada garrison"
                    }
                },
                "10-10": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        CV: {
            names: {
                pt: "Rep\xfablica de Cabo Verde",
                en: "Cape Verde"
            },
            langs: [
                "pt"
            ],
            zones: [
                "Atlantic/Cape_Verde"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-13": {
                    name: {
                        pt: "Dia da Democracia",
                        en: "Democracy Day"
                    }
                },
                "01-20": {
                    name: {
                        pt: "Dia dos Her\xf3is Nacionais",
                        en: "Heroes' Day"
                    }
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "easter -46": {
                    _name: "easter -46"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-01": {
                    name: {
                        pt: "Dia das Crian\xe7as",
                        en: "Children's Day"
                    }
                },
                "07-05": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15",
                    name: {
                        pt: "Dia da Padroeira Nacional"
                    }
                },
                "09-12": {
                    name: {
                        pt: "Dia Nacional",
                        en: "National Day"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                }
            },
            states: {
                S: {
                    name: "Sotavento Islands",
                    regions: {
                        PR: {
                            name: "Praia",
                            days: {
                                "05-19": {
                                    name: {
                                        pt: "Dia do Munic\xedpio da Praia"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        CW: {
            names: {
                nl: "Cura\xe7ao",
                pap: "K\xf2rsou",
                en: "Cura\xe7ao"
            },
            langs: [
                "nl",
                "pap",
                "en"
            ],
            zones: [
                "America/Curacao"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -48": {
                    _name: "easter -48",
                    name: {
                        en: "Carnival Monday"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27": {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: "Koningsdag",
                        en: "Kings Day"
                    }
                },
                "05-01 if sunday then next monday": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "1st sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39",
                    name: {
                        nl: "Hemelvaartsdag"
                    }
                },
                "07-02": {
                    name: {
                        nl: "Dag van het volkslied en de Vlag",
                        pap: "Dia di Himno i Bandera",
                        en: "Flag Day"
                    }
                },
                "10-10": {
                    name: {
                        nl: "Dag van het land Cura\xe7ao",
                        pap: "Pais K\xf2rsou",
                        en: "Cura\xe7ao Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 12:00": {
                    _name: "12-31"
                }
            }
        },
        CX: {
            names: {
                en: "Christmas Island"
            },
            langs: [
                "en",
                "ms"
            ],
            zones: [
                "Indian/Christmas"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-26": {
                    name: {
                        en: "Australia Day"
                    }
                },
                "chinese 01-0-01 P2D": {
                    name: {
                        en: "Chinese New Year",
                        zh: "\u6625\u8282"
                    }
                },
                "4th monday in March": {
                    _name: "05-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "04-25": {
                    name: {
                        en: "Anzac Day"
                    }
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    name: {
                        ms: "Hari Raya Puasa"
                    }
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        ms: "Hari Raya Haji"
                    }
                },
                "10-06": {
                    name: {
                        en: "Territory Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        CY: {
            names: {
                el: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
                en: "Cyprus"
            },
            dayoff: "",
            langs: [
                "el"
            ],
            zones: [
                "Asia/Nicosia"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "orthodox -48": {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: "Ash Sunday"
                    },
                    type: "observance"
                },
                "orthodox -47": {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: "Clean Monday"
                    }
                },
                "03-25": {
                    name: {
                        el: "\u0395\u03C5\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2, \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE",
                        en: "Annunciation, Anniversary of 1821 Revolution"
                    }
                },
                "04-01": {
                    name: {
                        en: "Cyprus National Day",
                        el: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2 \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE"
                    }
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "orthodox 49": {
                    _name: "easter 49"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-01": {
                    name: {
                        en: "Cyprus Independence Day",
                        el: "\u0397\u03BC\u03AD\u03C1\u03B1 \u03C4\u03B7\u03C2 \u0391\u03BD\u03B5\u03BE\u03B1\u03C1\u03C4\u03B7\u03C3\u03AF\u03B1\u03C2 \u039A\u03CD\u03C0\u03C1\u03BF\u03C2"
                    }
                },
                "10-28": {
                    _name: "National Holiday",
                    name: {
                        el: "\u0395\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2 \u03C4\u03BF\u03C5 \u038C\u03C7\u03B9"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        CZ: {
            names: {
                cz: "\u010Cesk\xe1 republika",
                en: "Czech Republic"
            },
            langs: [
                "cz"
            ],
            zones: [
                "Europe/Prague"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    name: {
                        cz: "Nov\xfd rok a Den obnovy samostatn\xe9ho \u010Desk\xe9ho st\xe1tu"
                    }
                },
                "easter -4": {
                    name: {
                        cz: "\u0160kared\xe1 st\u0159eda",
                        en: "Ugly Wednesday"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1",
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-08": {
                    name: {
                        cz: "Den v\xedt\u011Bzstv\xed",
                        en: "Liberation Day"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "07-05": {
                    name: {
                        cz: "Den slovansk\xfdch v\u011Brozv\u011Bst\u016F Cyrila a Metod\u011Bje",
                        en: "Saints Cyril and Methodius Day"
                    }
                },
                "07-06": {
                    name: {
                        cz: "Den up\xe1len\xed mistra Jana Husa",
                        en: "Jan Hus Day"
                    }
                },
                "09-28": {
                    name: {
                        cz: "Den \u010Desk\xe9 st\xe1tnosti",
                        en: "St. Wenceslas Day (Czech Statehood Day)"
                    }
                },
                "10-28": {
                    name: {
                        cz: "Den vzniku samostatn\xe9ho \u010Deskoslovensk\xe9ho st\xe1tu",
                        en: "Independent Czechoslovak State Day"
                    }
                },
                "11-17": {
                    name: {
                        cz: "Den boje za svobodu a demokracii",
                        en: "Struggle for Freedom and Democracy Day"
                    }
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        DE: {
            names: {
                de: "Deutschland",
                en: "Germany"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Berlin"
            ],
            langs: [
                "de"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-14": {
                    _name: "02-14",
                    type: "observance"
                },
                "easter -52": {
                    name: {
                        de: "Weiberfastnacht",
                        en: "Women's Carnival Day"
                    },
                    type: "observance"
                },
                "easter -48": {
                    name: {
                        de: "Rosenmontag",
                        en: "Shrove Monday"
                    },
                    type: "observance"
                },
                "easter -47 14:00": {
                    _name: "easter -47",
                    type: "observance"
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        de: "Maifeiertag"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "10-03": {
                    _name: "National Holiday",
                    name: {
                        de: "Tag der Deutschen Einheit"
                    }
                },
                "11-01": {
                    _name: "11-01",
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02",
                    type: "observance"
                },
                "11-11": {
                    _name: "11-11",
                    type: "observance"
                },
                "wednesday before 11-23": {
                    _name: "Bu\xdf- und Bettag",
                    type: "observance"
                },
                "6th sunday before 12-25": {
                    name: {
                        de: "Volkstrauertag",
                        en: "Memorial Day"
                    },
                    type: "observance"
                },
                "5th sunday before 12-25": {
                    name: {
                        de: "Totensonntag"
                    },
                    type: "observance"
                },
                "4th sunday before 12-25": {
                    name: {
                        de: "1. Advent"
                    },
                    type: "observance"
                },
                "3th sunday before 12-25": {
                    name: {
                        de: "2. Advent"
                    },
                    type: "observance"
                },
                "2nd sunday before 12-25": {
                    name: {
                        de: "3. Advent"
                    },
                    type: "observance"
                },
                "1st sunday before 12-25": {
                    name: {
                        de: "4. Advent"
                    },
                    type: "observance"
                },
                "12-24 14:00 if sunday then 00:00": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25",
                    name: {
                        de: "1. Weihnachtstag"
                    }
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 14:00 if sunday then 00:00": {
                    _name: "12-31",
                    type: "bank"
                },
                "2017-10-31": {
                    _name: "Reformation Day"
                }
            },
            states: {
                BB: {
                    name: "Brandenburg",
                    days: {
                        easter: {
                            _name: "easter"
                        },
                        "easter 49": {
                            _name: "easter 49"
                        },
                        "10-31": {
                            _name: "Reformation Day"
                        }
                    }
                },
                BE: {
                    name: "Berlin",
                    days: {
                        "03-08": {
                            _name: "03-08",
                            active: [
                                {
                                    from: "2019-01-01T00:00:00.000Z"
                                }
                            ]
                        },
                        easter: {
                            _name: "easter",
                            type: "observance"
                        },
                        "easter 49": {
                            _name: "easter 49",
                            type: "observance"
                        },
                        "2020-05-08": {
                            name: {
                                de: "Tag der Befreiung (75. Jahrestag)",
                                en: "Liberation Day (75th Anniversary)"
                            }
                        }
                    }
                },
                BW: {
                    name: "Baden-W\xfcrttemberg",
                    days: {
                        "01-06": {
                            _name: "01-06"
                        },
                        "easter -3": {
                            _name: "easter -3",
                            type: "school"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "10-31": {
                            _name: "Reformation Day",
                            type: "school"
                        },
                        "11-01": {
                            _name: "11-01"
                        }
                    }
                },
                BY: {
                    name: "Bayern",
                    days: {
                        "01-06": {
                            _name: "01-06"
                        },
                        "02-02": {
                            _name: "02-02",
                            type: "observance"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        },
                        "wednesday before 11-23": {
                            _name: "Bu\xdf- und Bettag",
                            type: "school"
                        }
                    },
                    regions: {
                        A: {
                            name: "Stadt Augsburg",
                            days: {
                                "08-08": {
                                    name: {
                                        de: "Augsburger Friedensfest",
                                        en: "Augsburg Peace Festival"
                                    }
                                }
                            }
                        },
                        EVANG: {
                            names: {
                                de: "\xdcberwiegend evangelische Gemeinden",
                                en: "Predominantly protestant communities"
                            },
                            days: {
                                "08-15": {
                                    _name: "08-15",
                                    type: "school"
                                }
                            }
                        }
                    }
                },
                HB: {
                    name: "Hansestadt Bremen",
                    days: {
                        "10-31": {
                            _name: "Reformation Day",
                            active: [
                                {
                                    from: "2018-01-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                HE: {
                    name: "Hessen",
                    days: {
                        easter: {
                            _name: "easter"
                        },
                        "easter 49": {
                            _name: "easter 49"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        }
                    }
                },
                HH: {
                    name: "Hansestadt Hamburg",
                    days: {
                        "10-31": {
                            _name: "Reformation Day",
                            active: [
                                {
                                    from: "2018-01-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                MV: {
                    name: "Mecklenburg Vorpommern",
                    days: {
                        "03-08 since 2023": {
                            _name: "03-08"
                        },
                        "10-31": {
                            _name: "Reformation Day"
                        }
                    }
                },
                NI: {
                    name: "Niedersachsen",
                    days: {
                        "10-31": {
                            _name: "Reformation Day",
                            active: [
                                {
                                    from: "2018-01-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                NW: {
                    name: "Nordrhein-Westfalen",
                    days: {
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "11-01": {
                            _name: "11-01"
                        }
                    }
                },
                RP: {
                    name: "Rheinland-Pfalz",
                    days: {
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "11-01": {
                            _name: "11-01"
                        }
                    }
                },
                SH: {
                    name: "Schleswig-Holstein",
                    days: {
                        "10-31": {
                            _name: "Reformation Day",
                            active: [
                                {
                                    from: "2018-01-01T00:00:00.000Z"
                                }
                            ]
                        }
                    }
                },
                SL: {
                    name: "Saarland",
                    days: {
                        "easter 60": {
                            _name: "easter 60"
                        },
                        "08-15": {
                            _name: "08-15"
                        },
                        "11-01": {
                            _name: "11-01"
                        }
                    }
                },
                SN: {
                    name: "Sachsen",
                    days: {
                        "easter 60": {
                            _name: "easter 60",
                            type: "observance"
                        },
                        "10-31": {
                            _name: "Reformation Day"
                        },
                        "wednesday before 11-23": {
                            _name: "Bu\xdf- und Bettag"
                        }
                    },
                    regions: {
                        BZ: {
                            name: "Landkreis Bautzen",
                            days: {
                                "easter 60": {
                                    _name: "easter 60",
                                    type: "public",
                                    note: "Bautzen (nur in den Ortsteilen Bolbritz und Salzenforst), Crostwitz, G\xf6da (nur im Ortsteil Prischwitz), Gro\xdfdubrau (nur im Ortsteil Sdier), Hoyerswerda (nur im Ortsteil D\xf6rgenhausen), K\xf6nigswartha (nicht im Ortsteil Wartha), Nebelsch\xfctz, Neschwitz (nur in den Ortsteilen Neschwitz und Saritsch), Panschwitz-Kuckau, Puschwitz, R\xe4ckelwitz, Radibor, Ralbitz-Rosenthal und Wittichenau."
                                }
                            }
                        }
                    }
                },
                ST: {
                    name: "Sachsen-Anhalt",
                    days: {
                        "01-06": {
                            _name: "01-06"
                        },
                        "10-31": {
                            _name: "Reformation Day"
                        }
                    }
                },
                TH: {
                    name: "Th\xfcringen",
                    days: {
                        "easter 60": {
                            _name: "easter 60",
                            type: "observance"
                        },
                        "09-20": {
                            name: {
                                de: "Weltkindertag",
                                en: "International Children's Day"
                            },
                            active: [
                                {
                                    from: 2019
                                }
                            ]
                        },
                        "10-31": {
                            _name: "Reformation Day"
                        }
                    },
                    regions: {
                        EIC: {
                            name: "Landkreis Eichfeld",
                            days: {
                                "easter 60": {
                                    _name: "easter 60",
                                    type: "public"
                                }
                            }
                        },
                        UH: {
                            name: "Unstrut-Hainich-Kreis",
                            days: {
                                "easter 60": {
                                    _name: "easter 60",
                                    type: "public",
                                    note: "In Anrode (nur in den Ortsteilen Bickenriede und Zella), D\xfcnwald (nur in den Ortsteilen Beberstedt und H\xfcpstedt), Rodeberg (nur im Ortsteil Struth), S\xfcdeichsfeld"
                                }
                            }
                        },
                        WAK: {
                            name: "Wartburgkreis",
                            days: {
                                "easter 60": {
                                    _name: "easter 60",
                                    type: "public",
                                    note: "In Brunnhartshausen (nur in den Ortsteilen F\xf6hlritz und Steinberg), Buttlar, Geisa, Schleid, Zella/Rh\xf6n"
                                }
                            }
                        }
                    }
                }
            }
        },
        DJ: {
            names: {
                fr: "R\xe9publique de Djibouti",
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062C\u064A\u0628\u0648\u062A\u064A",
                so: "Jamhuuriyadda Jabuuti",
                aa: "Gabuutih Ummuuno",
                en: "Djibouti"
            },
            langs: [
                "fr",
                "ar",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-27 since 1977": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "27 Rajab": {
                    _name: "27 Rajab"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "9 Dhu al-Hijjah": {
                    _name: "9 Dhu al-Hijjah"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        DK: {
            names: {
                da: "Danmark",
                en: "Denmark"
            },
            langs: [
                "da"
            ],
            zones: [
                "Europe/Copenhagen"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -48": {
                    name: {
                        da: "Fastelavn"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 26 prior to 2024": {
                    name: {
                        da: "Store Bededag",
                        en: "Prayer Day",
                        de: "Bu\xdf- und Bettag"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "05-01": {
                    _name: "05-01",
                    type: "observance",
                    note: "Full holiday for blue collar workers"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-05": {
                    _name: "Constitution Day",
                    type: "observance",
                    note: "Shops are closed"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "12-24": {
                    _name: "12-24",
                    type: "observance",
                    note: "Shops are closed"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        DM: {
            names: {
                en: "Dominica"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if sunday then next monday": {
                    _name: "01-01",
                    substitute: true
                },
                "easter -48": {
                    _name: "easter -48",
                    name: {
                        en: "Carnival Monday"
                    }
                },
                "easter -47": {
                    _name: "easter -47",
                    name: {
                        en: "Carnival Tuesday"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "1st monday in August": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "11-03 if sunday then next monday": {
                    _name: "Independence Day"
                },
                "11-04 if sunday then next monday if monday then next tuesday": {
                    name: {
                        en: "National Day of Community Service"
                    }
                },
                "12-25 and if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                }
            }
        },
        DO: {
            names: {
                es: "Rep\xfablica Dominicana",
                en: "Dominican Republic"
            },
            dayoff: "sunday",
            zones: [
                "America/Santo_Domingo"
            ],
            langs: [
                "es"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
                    _name: "01-06"
                },
                "01-21": {
                    name: {
                        es: "Nuestra Se\xf1ora de la Altagracia",
                        en: "Our Lady of Altagracia"
                    }
                },
                "01-26 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
                    name: {
                        es: "D\xeda de Duarte",
                        en: "Duarte's Birthday"
                    }
                },
                "02-27": {
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01 if tuesday,wednesday then previous monday if thursday,friday,sunday then next monday": {
                    _name: "05-01"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "08-16": {
                    name: {
                        es: "D\xeda de la Restauraci\xf3n",
                        en: "Restoration Day"
                    }
                },
                "09-24": {
                    name: {
                        es: "Nuestra Se\xf1ora de las Mercedes",
                        en: "Our Lady of las Mercedes"
                    }
                },
                "11-06 if tuesday,wednesday,thursday,friday,saturday then next monday": {
                    _name: "Constitution Day"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        DZ: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062C\u0632\u0627\u0626\u0631\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629 \u0627\u0644\u0634\u0639\u0628\u064A\u0629",
                fr: "R\xe9publique alg\xe9rienne d\xe9mocratique et populaire",
                en: "Algeria"
            },
            langs: [
                "ar",
                "fr",
                "en"
            ],
            zones: [
                "Africa/Algiers"
            ],
            dayoff: "saturday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-12": {
                    name: {
                        ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0623\u0645\u0627\u0632\u064A\u063A\u064A\u0629",
                        fr: "Nouvel an amazigh",
                        en: "Amazigh New Year"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-05": {
                    _name: "Independence Day"
                },
                "11-01": {
                    _name: "Revolution Day"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        EC: {
            names: {
                es: "Ecuador",
                en: "Ecuador"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Guayaquil",
                "Pacific/Galapagos"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -48": {
                    name: {
                        en: "Carnival",
                        es: "Carnaval"
                    }
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-24": {
                    name: {
                        en: "The Battle of Pichincha",
                        es: "Batalla del Pichincha"
                    }
                },
                "07-24": {
                    name: {
                        en: "The Birthday of Sim\xf3n Bol\xedvar",
                        es: "El Natalicio de Sim\xf3n Bol\xedvar"
                    },
                    type: "observance"
                },
                "08-10": {
                    name: {
                        en: "Declaration of Independence of Quito",
                        es: "D\xeda del Primer Grito de Independencia de Quito"
                    }
                },
                "09-10": {
                    name: {
                        en: "Independence of Guayaquil",
                        es: "Independencia de Guayaquil"
                    }
                },
                "10-31": {
                    name: {
                        en: "Flag Day",
                        es: "Dia de La Bandera"
                    },
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02"
                },
                "11-03": {
                    name: {
                        en: "Independence of Cuenca",
                        es: "Independencia de Cuenca"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                }
            },
            states: {
                P: {
                    name: "Pichincha",
                    regions: {
                        QU: {
                            name: "Quito",
                            days: {
                                "12-06": {
                                    name: {
                                        en: "Foundation of Quito",
                                        es: "Aniversario de la fundaci\xf3n de Quito"
                                    },
                                    type: "observance"
                                }
                            }
                        }
                    }
                }
            }
        },
        EE: {
            names: {
                et: "Eesti",
                en: "Estonia"
            },
            dayoff: "sunday",
            langs: [
                "et"
            ],
            zones: [
                "Europe/Tallinn"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    type: "observance"
                },
                "02-02": {
                    name: {
                        et: "Tartu rahulepingu aastap\xe4ev",
                        en: "Anniversary of the Tartu Peace Treaty"
                    },
                    type: "observance"
                },
                "02-24": {
                    _name: "Independence Day",
                    type: "public"
                },
                "03-14": {
                    name: {
                        et: "emakeelep\xe4ev",
                        en: "Native Language Day"
                    },
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "06-04": {
                    name: {
                        et: "Eesti lipu p\xe4ev",
                        en: "National Flag Day"
                    },
                    type: "observance"
                },
                "06-14": {
                    name: {
                        et: "leinap\xe4ev",
                        en: "Day of Mourning and Commemoration"
                    },
                    type: "observance"
                },
                "06-23": {
                    name: {
                        et: "v\xf5idup\xfcha",
                        en: "Victory Day"
                    }
                },
                "06-24": {
                    name: {
                        et: "jaanip\xe4ev",
                        en: "Midsummer Day"
                    }
                },
                "08-20": {
                    name: {
                        et: "taasiseseisvumisp\xe4ev",
                        en: "Day of Restoration of Independence"
                    }
                },
                "08-23": {
                    name: {
                        et: "kommunismi ja natsismi ohvrite m\xe4lestusp\xe4ev",
                        en: "European Day of Remembrance for Victims of Stalinism and Nazism"
                    },
                    type: "observance"
                },
                "2nd sunday in September": {
                    name: {
                        et: "vanavanemate p\xe4ev",
                        en: "Grandparents Day"
                    },
                    type: "observance"
                },
                "09-22": {
                    name: {
                        et: "vastupanuv\xf5itluse p\xe4ev",
                        en: "Resistance Fighting Day"
                    },
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02",
                    type: "observance"
                },
                "2nd sunday in November": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "11-16": {
                    name: {
                        et: "taass\xfcnni p\xe4ev",
                        en: "Day of Declaration of Sovereignty"
                    },
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        EG: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0645\u0635\u0631 \u0627\u0644\u0639\u0631\u0628\u064A\u0629",
                en: "Egypt"
            },
            langs: [
                "ar",
                "en"
            ],
            zones: [
                "Africa/Cairo"
            ],
            dayoff: "saturday",
            days: {
                "01-25 since 2011": {
                    name: {
                        ar: "\u0639\u064A\u062F \u062B\u0648\u0631\u0629 25 \u064A\u0646\u0627\u064A\u0631",
                        en: "Revolution Day 2011"
                    }
                },
                "01-25": {
                    name: {
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0631\u0637\u0629",
                        en: "National Police Day"
                    }
                },
                "04-25": {
                    name: {
                        ar: "\u0639\u064A\u062F \u062A\u062D\u0631\u064A\u0631 \u0633\u064A\u0646\u0627\u0621",
                        en: "Sinai Liberation Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-30": {
                    name: {
                        ar: "\u0639\u064A\u062F \u062B\u0648\u0631\u0629 30 \u064A\u0648\u0646\u064A\u0648",
                        en: "30 June Day"
                    }
                },
                "07-23": {
                    _name: "Revolution Day"
                },
                "10-06": {
                    name: {
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0642\u0648\u0627\u062A \u0627\u0644\u0645\u0633\u0644\u062D\u0629",
                        en: "Armed Forces Day"
                    }
                },
                "orthodox 1": {
                    name: {
                        ar: "\u0634\u0645 \u0627\u0644\u0646\u0633\u064A\u0645",
                        en: "Sham El Nessim"
                    }
                },
                "julian 12-25": {
                    _name: "12-25"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P4D": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        EH: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0635\u062D\u0631\u0627\u0648\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629",
                en: "Western Sahara"
            },
            langs: [],
            zones: [
                "Africa/El_Aaiun"
            ],
            dayoff: "",
            days: {
                "02-27": {
                    _name: "Independence Day"
                },
                "03-08": {
                    name: {
                        en: "First Martyr"
                    }
                },
                "05-10": {
                    name: {
                        en: "May 20 Revolution"
                    }
                },
                "06-09": {
                    name: {
                        en: "Day of the Martyrs"
                    }
                },
                "06-17": {
                    name: {
                        en: "Day of National Unity"
                    }
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P2D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P2D": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        ER: {
            names: {
                en: "Eritrea"
            },
            langs: [
                "ti",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "julian 12-25": {
                    _name: "julian 12-25"
                },
                "julian 01-06": {
                    _name: "01-06"
                },
                "02-10": {
                    name: {
                        ti: "\u1348\u1295\u1245\u120D",
                        en: "Fenkil Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "orthodox -2": {
                    _name: "orthodox -2"
                },
                orthodox: {
                    _name: "orthodox"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-24": {
                    _name: "Independence Day"
                },
                "06-20": {
                    name: {
                        en: "Martyrs' Day",
                        ti: "\u1218\u12D3\u120D\u1272 \u1235\u12CD\u12A3\u1275"
                    }
                },
                "09-01": {
                    _name: "Revolution Day"
                },
                "09-11 in non-leap years": {
                    name: {
                        en: "Geez New Year",
                        ti: "\u130D\u12D5\u12DD \u12A0\u12F2\u1235 \u12D3\u1218\u1275"
                    }
                },
                "09-12 in leap years": {
                    name: {
                        en: "Geez New Year",
                        ti: "\u130D\u12D5\u12DD \u12A0\u12F2\u1235 \u12D3\u1218\u1275"
                    }
                },
                "09-27 in non-leap years": {
                    name: {
                        en: "Meskel"
                    }
                },
                "09-28 in leap years": {
                    name: {
                        en: "Meskel"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        ES: {
            names: {
                es: "Espa\xf1a",
                ca: "Espanya",
                en: "Spain"
            },
            langs: [
                "es"
            ],
            zones: [
                "Europe/Madrid",
                "Africa/Ceuta",
                "Atlantic/Canary"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    type: "observance",
                    substitute: true,
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "substitutes 01-06 if sunday then next monday": {
                    type: "observance",
                    substitute: true,
                    _name: "01-06"
                },
                "03-19": {
                    _name: "03-19",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "07-25": {
                    name: {
                        es: "Santiago Apostol"
                    },
                    type: "observance",
                    note: "regional"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-12": {
                    name: {
                        es: "Fiesta Nacional de Espa\xf1a"
                    }
                },
                "substitutes 10-12 if sunday then next monday": {
                    substitute: true,
                    type: "observance",
                    name: {
                        es: "Fiesta Nacional de Espa\xf1a"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "substitutes 11-01 if sunday then next monday": {
                    substitute: true,
                    type: "observance",
                    _name: "11-01"
                },
                "12-06": {
                    name: {
                        es: "D\xeda de la Constituci\xf3n Espa\xf1ola"
                    }
                },
                "substitutes 12-06 if sunday then next monday": {
                    type: "observance",
                    substitute: true,
                    name: {
                        es: "D\xeda de la Constituci\xf3n Espa\xf1ola"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "substitutes 12-08 if sunday then next monday": {
                    type: "observance",
                    substitute: true,
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                }
            },
            states: {
                AN: {
                    name: "Andaluc\xeda",
                    days: {
                        "02-28": {
                            name: {
                                es: "D\xeda de Andaluc\xeda"
                            }
                        },
                        "substitutes 02-28 if Sunday then next Monday": {
                            substitute: true,
                            name: {
                                es: "D\xeda de Andaluc\xeda"
                            }
                        },
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "substitutes 08-15 if Sunday then next Monday": {
                            substitute: true,
                            _name: "08-15"
                        },
                        "easter -3": {
                            _name: "easter -3"
                        }
                    }
                },
                AR: {
                    name: "Arag\xf3n",
                    days: {
                        "04-23": {
                            name: {
                                es: "D\xeda de Arag\xf3n"
                            }
                        },
                        "substitutes 04-23 if Sunday then next Monday": {
                            substitute: true,
                            name: {
                                es: "D\xeda de Arag\xf3n"
                            }
                        },
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "substitutes 08-15 if Sunday then next Monday": {
                            substitute: true,
                            _name: "08-15"
                        }
                    }
                },
                AS: {
                    name: "Asturias",
                    days: {
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "substitutes 08-15 if Sunday then next Monday": {
                            substitute: true,
                            _name: "08-15"
                        },
                        "09-08": {
                            name: "D\xeda de Asturias"
                        },
                        "substitutes 09-08 if Sunday then next Monday": {
                            substitute: true,
                            name: "D\xeda de Asturias"
                        }
                    }
                },
                CB: {
                    name: "Cantabria",
                    days: {
                        "06-28": {
                            name: "D\xeda de las Instituciones de Cantabria"
                        },
                        "substitutes 06-28 if Sunday then next Monday": {
                            name: "D\xeda de las Instituciones de Cantabria"
                        },
                        "09-15": {
                            name: "La Bien Aparecida"
                        },
                        "substitutes 09-15 if Sunday then next Monday": {
                            name: "La Bien Aparecida"
                        }
                    }
                },
                CE: {
                    name: "Ciudad de Ceuta",
                    days: {
                        "08-05": {
                            name: "Nuestra Se\xf1ora de \xc1frica"
                        },
                        "substitutes 08-05 if Sunday then next Monday": {
                            substitute: true,
                            name: "Nuestra Se\xf1ora de \xc1frica"
                        },
                        "09-02": {
                            name: "D\xeda de Ceuta"
                        },
                        "substitutes 09-02 if Sunday then next Monday": {
                            substitute: true,
                            name: "D\xeda de Ceuta"
                        },
                        "9 Dhu al-Hijjah": {
                            _name: "9 Dhu al-Hijjah"
                        }
                    }
                },
                CL: {
                    names: {
                        es: "Castilla y Le\xf3n",
                        en: "Castile and Le\xf3n"
                    },
                    days: {
                        "04-23": {
                            name: "Fiesta de Castilla y Le\xf3n"
                        },
                        "substitutes 04-23 if Sunday then next Monday": {
                            substitute: true,
                            name: "Fiesta de Castilla y Le\xf3n"
                        },
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "substitutes 08-15 if Sunday then next Monday": {
                            substitute: true,
                            _name: "08-15"
                        }
                    }
                },
                CM: {
                    name: "Castile-La Mancha",
                    days: {
                        "05-31 since 2020": {
                            name: "D\xeda de Castilla-La Mancha"
                        },
                        "substitutes 05-31 if Sunday then next Monday since 2020": {
                            substitute: true,
                            name: "D\xeda de Castilla-La Mancha"
                        },
                        "easter 60": {
                            _name: "easter 60"
                        }
                    }
                },
                CN: {
                    names: {
                        es: "Islas Canarias",
                        en: "Canary Islands"
                    },
                    zones: [
                        "Atlantic/Canary"
                    ],
                    dayoff: "sunday",
                    _days: "IC",
                    regions: {
                        EH: {
                            names: {
                                es: "El Hierro"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "EH"
                            ]
                        },
                        FU: {
                            names: {
                                es: "Fuerteventura"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "FU"
                            ]
                        },
                        GC: {
                            names: {
                                es: "Gran Canaria"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "GC"
                            ]
                        },
                        LG: {
                            names: {
                                es: "La Gomera"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "LG"
                            ]
                        },
                        LP: {
                            names: {
                                es: "La Palma"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "LP"
                            ]
                        },
                        LA: {
                            names: {
                                es: "Lanzarote"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "LA"
                            ]
                        },
                        TE: {
                            names: {
                                es: "Tenerife"
                            },
                            _days: [
                                "IC",
                                "regions",
                                "TE"
                            ]
                        }
                    }
                },
                CT: {
                    names: {
                        ca: "Catalunya",
                        es: "Catalu\xf1a",
                        en: "Catalonia"
                    },
                    days: {
                        "09-11": {
                            name: {
                                ca: "Diada de Catalunya",
                                es: "Dia de Catalu\xf1a"
                            }
                        },
                        "06-24": {
                            name: {
                                ca: "Sant Joan",
                                es: "San Juan"
                            }
                        },
                        "easter -3": {
                            _name: "easter -3",
                            type: "observance"
                        },
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "easter 50": {
                            _name: "easter 50"
                        },
                        "substitutes 05-01 if Saturday, Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "09-24 if sunday then next monday": {
                            name: {
                                es: "Mare de D\xe9u de la Merc\xe8"
                            }
                        },
                        "12-26": {
                            name: {
                                ca: "Sant Esteve",
                                es: "San Esteban"
                            },
                            type: "observance"
                        }
                    }
                },
                EX: {
                    name: "Extremadura",
                    days: {
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        },
                        "09-08": {
                            name: "D\xeda de Extremadura"
                        },
                        "substitutes 09-08 if Sunday then next Monday": {
                            substitute: true,
                            name: "D\xeda de Extremadura"
                        }
                    }
                },
                GA: {
                    name: "Galicia",
                    days: {
                        "05-17": {
                            name: "D\xeda de las Letras Gallegas"
                        },
                        "substitutes 05-17 if Sunday then next Monday": {
                            substitute: true,
                            name: "D\xeda de las Letras Gallegas"
                        },
                        "07-25": {
                            name: "D\xeda Nacional de Galicia"
                        },
                        "substitutes 07-25 if Sunday then next Monday": {
                            substitute: true,
                            name: "D\xeda Nacional de Galicia"
                        }
                    }
                },
                IB: {
                    names: {
                        es: "Illes Balears",
                        en: "Balearic Islands"
                    },
                    days: {
                        "03-01": {
                            name: {
                                es: "D\xeda de les Illes Balears"
                            }
                        },
                        "substitutes 03-01 if Sunday then next Monday": {
                            substitute: true,
                            name: {
                                es: "D\xeda de les Illes Balears"
                            }
                        },
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "12-26": {
                            name: {
                                es: "Sant Esteve"
                            },
                            type: "observance"
                        }
                    }
                },
                MC: {
                    name: "Murcia Region",
                    days: {
                        "substitutes 05-01 if Sunday then next Monday": {
                            substitute: true,
                            _name: "05-01"
                        }
                    }
                },
                MD: {
                    name: "Comunidad de Madrid",
                    days: {
                        "05-02 if Sunday then next Monday": {
                            name: {
                                es: "D\xeda de la Comunidad de Madrid"
                            }
                        },
                        "substitutes 05-02 if Sunday then next Monday": {
                            substitute: true,
                            name: {
                                es: "D\xeda de la Comunidad de Madrid"
                            }
                        },
                        "05-16": {
                            name: {
                                es: "San Isidro Labrador"
                            },
                            type: "observance"
                        },
                        "07-25": {
                            name: "Santiago Ap\xf3stol"
                        },
                        "substitutes 07-25 if Sunday then next Monday": {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        },
                        "11-09 if sunday then next monday": {
                            name: {
                                es: "Nuestra Se\xf1ora de la Almudena"
                            },
                            type: "observance"
                        }
                    }
                },
                ML: {
                    name: "Ciudad de Melilla",
                    days: {
                        "1 Shawwal": {
                            _name: "1 Shawwal"
                        },
                        "10 Dhu al-Hijjah": {
                            _name: "10 Dhu al-Hijjah"
                        }
                    }
                },
                NC: {
                    names: {
                        es: "Comunidad Foral de Navarra",
                        en: "Navarra Chartered Community"
                    },
                    days: {
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "07-25": {
                            name: "Santiago Ap\xf3stol"
                        },
                        "substitutes 07-25 if Sunday then next Monday": {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        }
                    }
                },
                PV: {
                    names: {
                        es: "Pa\xeds Vasco",
                        en: "Basque Country"
                    },
                    days: {
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "07-25": {
                            name: "Santiago Ap\xf3stol"
                        },
                        "substitutes 07-25 if Sunday then next Monday": {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        },
                        "2022-09-06": {
                            name: "V Centenario Vuelta al Mundo"
                        }
                    }
                },
                RI: {
                    name: "La Rioja",
                    days: {
                        "easter 1": {
                            _name: "easter 1"
                        }
                    }
                },
                VC: {
                    names: {
                        es: "Comunitat Valenciana",
                        en: "Valencian Community"
                    },
                    days: {
                        "03-19": {
                            _name: "03-19"
                        },
                        "easter 1": {
                            _name: "easter 1"
                        }
                    }
                }
            }
        },
        ET: {
            names: {
                am: "\u12A2\u1275\u12EE\u1335\u12EB",
                en: "Ethiopia"
            },
            dayoff: "sunday",
            langs: [
                "am",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-06 in non-leap years": {
                    _name: "12-25"
                },
                "01-07 in leap years": {
                    _name: "12-25"
                },
                "01-19": {
                    _name: "01-06"
                },
                "03-02": {
                    name: {
                        am: "\u12E8\u12D3\u12F5\u12CB \u12F5\u120D \u1260\u12D3\u120D",
                        en: "Victory at Adwa Day"
                    }
                },
                "03-28": {
                    name: {
                        am: "\u12E8\u1240\u12ED \u123D\u1265\u122D \u1218\u1273\u1230\u1262\u12EB \u1240\u1295",
                        en: "Day of Lament"
                    }
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "05-28": {
                    name: {
                        am: "\u12F0\u122D\u130D \u12E8\u12C8\u12F0\u1240\u1260\u1275 \u1240\u1295",
                        en: "Derg Downfall Day"
                    }
                },
                "09-11 in non-leap years": {
                    _name: "01-01"
                },
                "09-12 in leap years": {
                    _name: "01-01"
                },
                "09-27 in non-leap years": {
                    name: {
                        am: "\u1265\u122D\u1210\u1290-\u1218\u1235\u1240\u120D",
                        en: "Finding of the True Cross"
                    }
                },
                "09-28 in leap years": {
                    name: {
                        am: "\u1265\u122D\u1210\u1290-\u1218\u1235\u1240\u120D",
                        en: "Finding of the True Cross"
                    }
                },
                "1 Ramadan": {
                    _name: "1 Ramadan"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        FI: {
            names: {
                fi: "Suomi",
                en: "Finland"
            },
            dayoff: "sunday",
            langs: [
                "fi"
            ],
            zones: [
                "Europe/Helsinki"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "friday after 06-19": {
                    name: {
                        fi: "Juhannusaatto",
                        en: "Midsummer Eve",
                        sv: "Midsommarafton"
                    },
                    type: "bank"
                },
                "saturday after 06-20": {
                    name: {
                        fi: "Juhannusp\xe4iv\xe4",
                        en: "Midsummer Day",
                        sv: "Midsommardagen"
                    }
                },
                "saturday after 10-31": {
                    _name: "11-01"
                },
                "2nd sunday in November": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "12-06": {
                    _name: "Independence Day"
                },
                "12-24": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        FJ: {
            names: {
                fj: "Matanitu Tugalala o Viti",
                en: "Fiji"
            },
            langs: [
                "fj",
                "en"
            ],
            zones: [
                "Pacific/Fiji"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "09-07": {
                    _name: "Constitution Day"
                },
                "10-10 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Fiji Day"
                    }
                },
                "12-25 if Sunday then next Monday": {
                    _name: "12-25"
                },
                "12-26 if Sunday then next Monday if Monday then next Tuesday": {
                    _name: "12-26"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "2014-10-22": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2015-11-10": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2016-10-29": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2017-10-19": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2018-11-07": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2019-10-27": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2019-10-28": {
                    substitute: true,
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2020-11-14": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2020-11-16": {
                    substitute: true,
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2021-11-04": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2022-10-24": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2023-11-12": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2023-11-13": {
                    substitute: true,
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2024-11-01": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                },
                "2025-10-21": {
                    _name: "Deepavali",
                    name: {
                        en: "Diwali"
                    }
                }
            }
        },
        FO: {
            names: {
                fo: "F\xf8royar",
                da: "F\xe6r\xf8erne",
                en: "Faroe Islands"
            },
            langs: [
                "fo",
                "da"
            ],
            zones: [
                "Atlantic/Faroe"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-24": {
                    name: {
                        fo: "Flaggdagur",
                        da: "Flagdag",
                        en: "Flag Day"
                    }
                },
                "easter 26": {
                    name: {
                        fo: "D\xfdri bi\xf0idagur",
                        en: "Great Prayer Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-05 12:00 if sunday then 00:00": {
                    _name: "Constitution Day"
                },
                "07-28 12:00 if sunday then 00:00": {
                    name: {
                        da: "Sankt Olavsaften",
                        en: "St.Olav's Eve"
                    },
                    note: "half-day holiday for some workers' unions",
                    type: "observance"
                },
                "07-29": {
                    name: {
                        fo: "\xd3lavs\xf8ka",
                        da: "Sankt Olavs Dag",
                        en: "St.Olav's Day"
                    },
                    note: "full holiday for most workers' unions",
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 12:00 if sunday then 00:00": {
                    _name: "12-31"
                }
            }
        },
        FR: {
            names: {
                fr: "France",
                en: "France"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Paris"
            ],
            langs: [
                "fr"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-08": {
                    name: {
                        fr: "F\xeate de la Victoire 1945",
                        en: "Victory Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "sunday before 06-01": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "07-14": {
                    name: {
                        fr: "F\xeate Nationale de la France",
                        en: "Bastille Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-11": {
                    name: {
                        fr: "Armistice 1918",
                        en: "Armistice Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            },
            states: {
                57: {
                    name: "D\xe9partement Moselle",
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "12-26": {
                            _name: "12-26"
                        }
                    }
                },
                67: {
                    name: "D\xe9partement Bas-Rhin",
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "12-26": {
                            _name: "12-26"
                        }
                    }
                },
                68: {
                    name: "D\xe9partement Haut-Rhin",
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "12-26": {
                            _name: "12-26"
                        }
                    }
                },
                YT: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Mayotte",
                    zones: [
                        "Africa/Nairobi"
                    ],
                    _days: "YT"
                },
                MQ: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Martinique",
                    zones: [
                        "America/Martinique"
                    ],
                    _days: "MQ"
                },
                GP: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Guadeloupe",
                    zones: [
                        "America/Port_of_Spain"
                    ],
                    _days: "GP"
                },
                GF: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Guyane",
                    zones: [
                        "America/Cayenne"
                    ],
                    _days: "GF"
                },
                RE: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer La R\xe9union",
                    zones: [
                        "Indian/Reunion"
                    ],
                    _days: "RE"
                },
                MF: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Saint Martin",
                    zones: [
                        "America/Marigot"
                    ],
                    _days: "MF"
                },
                BL: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Saint Barth\xe9lemy",
                    zones: [
                        "America/St_Barthelemy"
                    ],
                    _days: "BL"
                }
            }
        },
        GA: {
            names: {
                fr: "Gabon",
                en: "Gabon"
            },
            dayoff: "sunday",
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Lagos"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-17": {
                    name: {
                        fr: "Journ\xe9e des droits de la femme",
                        en: "Women's Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "08-15": {
                    _name: "08-15"
                },
                "08-16 P2D": {
                    _name: "Independence Day"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        GB: {
            names: {
                en: "United Kingdom"
            },
            dayoff: "sunday",
            zones: [
                "Europe/London"
            ],
            langs: [
                "en"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "substitutes 01-01 if saturday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -21": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1st monday in May": {
                    name: {
                        en: "Early May bank holiday"
                    },
                    disable: [
                        "2020-05-04"
                    ]
                },
                "1st monday before 06-01": {
                    name: {
                        en: "Spring bank holiday"
                    },
                    disable: [
                        "2022-05-30"
                    ],
                    enable: [
                        "2022-06-02"
                    ]
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "substitutes 12-26 if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-26"
                },
                "2012-06-05": {
                    name: {
                        en: "Queen\u2019s Diamond Jubilee"
                    }
                },
                "2020-05-08": {
                    name: {
                        en: "Early May bank holiday (VE day)"
                    }
                },
                "2022-06-03": {
                    name: {
                        en: "Queen\u2019s Platinum Jubilee"
                    }
                },
                "2022-09-19": {
                    name: {
                        en: "Queen Elizabeth's Funeral Day"
                    }
                },
                "2023-05-08": {
                    name: {
                        en: "King Charles III's Coronation"
                    }
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                }
            },
            states: {
                ALD: {
                    name: "Alderney",
                    zones: [
                        "Europe/Guernsey"
                    ],
                    days: {
                        "12-15": {
                            name: {
                                en: "Homecoming Day"
                            }
                        }
                    }
                },
                ENG: {
                    name: "England",
                    days: {
                        "1st monday before 09-01": {
                            name: {
                                en: "Summer bank holiday"
                            }
                        }
                    }
                },
                NIR: {
                    name: "Northern Ireland",
                    zones: [
                        "Europe/Belfast"
                    ],
                    days: {
                        "03-17": {
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        "substitutes 03-17 if saturday then next monday": {
                            substitute: true,
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        "substitutes 03-17 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        "07-12": {
                            name: {
                                en: "Battle of the Boyne, Orangemen\u2019s Day"
                            }
                        },
                        "substitutes 07-12 if saturday then next monday": {
                            substitute: true,
                            name: {
                                en: "Battle of the Boyne"
                            }
                        },
                        "substitutes 07-12 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Battle of the Boyne"
                            }
                        },
                        "1st monday before 09-01": {
                            name: {
                                en: "Summer bank holiday"
                            }
                        }
                    }
                },
                SCT: {
                    name: "Scotland",
                    days: {
                        "substitutes 01-01 if sunday then next monday": false,
                        "substitutes 01-01 if saturday then next monday": false,
                        "substitutes 01-01 if saturday then next tuesday": {
                            substitute: true,
                            _name: "01-01"
                        },
                        "substitutes 01-01 if sunday then next tuesday": {
                            substitute: true,
                            _name: "01-01"
                        },
                        "01-02": {
                            name: {
                                en: "January 2nd"
                            }
                        },
                        "substitutes 01-02 if saturday then next monday": {
                            substitute: true,
                            name: {
                                en: "January 2nd"
                            }
                        },
                        "substitutes 01-02 if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "January 2nd"
                            }
                        },
                        "easter 1": {
                            _name: "easter 1"
                        },
                        "1st monday in August": {
                            name: {
                                en: "Summer bank holiday"
                            }
                        },
                        "11-30": {
                            name: {
                                en: "St Andrew\u2019s Day"
                            }
                        }
                    }
                },
                WLS: {
                    name: "Wales",
                    days: {
                        "1st monday before 09-01": {
                            name: {
                                en: "Summer bank holiday"
                            }
                        }
                    },
                    regions: {}
                }
            }
        },
        GD: {
            names: {
                en: "Grenada"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-07": {
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-24 P3D": {
                    name: {
                        en: "Carriacou Maroon and String Band Music Festival"
                    },
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "1st monday in August": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "2nd monday in August": {
                    name: {
                        en: "Carnival Monday"
                    }
                },
                "tuesday after 2nd monday in August": {
                    name: {
                        en: "Carnival Tuesday"
                    }
                },
                "09-01": {
                    name: {
                        en: "Kirani Day"
                    },
                    type: "observance"
                },
                "10-15 P5D": {
                    name: {
                        en: "Aunty Tek Spice Word Festival"
                    },
                    type: "observance"
                },
                "10-25": {
                    name: {
                        en: "Thanksgiving Day"
                    }
                },
                "12-04 P3D": {
                    name: {
                        en: "Camerhogne Folk Festival"
                    },
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        GE: {
            names: {
                ge: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
                en: "Georgia"
            },
            langs: [
                "ge"
            ],
            zones: [
                "Asia/Tbilisi"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    name: {
                        ge: "\u10D1\u10D4\u10D3\u10DD\u10D1\u10D0",
                        en: "Bedoba"
                    }
                },
                "01-07": {
                    name: {
                        ge: "\u10E8\u10DD\u10D1\u10D0",
                        en: "Orthodox Christmas"
                    }
                },
                "01-19": {
                    name: {
                        ge: "\u10DC\u10D0\u10D7\u10DA\u10D8\u10E1\u10E6\u10D4\u10D1\u10D0",
                        en: "Orthodox Epiphany"
                    }
                },
                "03-03": {
                    name: {
                        ge: "\u10D3\u10D4\u10D3\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "Mother's Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "04-09": {
                    name: {
                        ge: "\u10D4\u10E0\u10DD\u10D5\u10DC\u10E3\u10DA\u10D8 \u10D4\u10E0\u10D7\u10D8\u10D0\u10DC\u10DD\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "National Unity Day"
                    }
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                "orthodox -1": {
                    _name: "easter -1"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "05-09": {
                    name: {
                        ge: "\u10E4\u10D0\u10E8\u10D8\u10D6\u10DB\u10D6\u10D4 \u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "Victory Day"
                    }
                },
                "05-12": {
                    name: {
                        ge: "\u10EC\u10DB\u10D8\u10DC\u10D3\u10D0 \u10D0\u10DC\u10D3\u10E0\u10D8\u10D0 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10E1 \u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "Saint Andrew the First-Called Day"
                    }
                },
                "05-26": {
                    name: {
                        ge: "\u10D3\u10D0\u10DB\u10DD\u10E3\u10D9\u10D8\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "Independence Day"
                    }
                },
                "08-28": {
                    name: {
                        ge: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB\u10DD\u10D1\u10D0",
                        en: "Saint Mary's Day"
                    }
                },
                "10-14": {
                    name: {
                        ge: "\u10E1\u10D5\u10D4\u10E2\u10D8\u10EA\u10EE\u10DD\u10D5\u10DA\u10DD\u10D1\u10D0",
                        en: "Svetitskhovloba"
                    }
                },
                "11-23": {
                    name: {
                        ge: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10DD\u10D1\u10D0",
                        en: "Saint George's Day"
                    }
                }
            }
        },
        GF: {
            names: {
                fr: "Guyane",
                en: "French Guiana"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/Cayenne"
            ],
            dayoff: "sunday",
            _days: "FR",
            days: {
                "06-10": {
                    _name: "Abolition of Slavery"
                }
            }
        },
        GG: {
            names: {
                en: "Guernsey"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Guernsey"
            ],
            langs: [
                "en"
            ],
            _days: [
                "GB"
            ],
            days: {
                "05-09": {
                    name: {
                        en: "Liberation Day"
                    }
                }
            }
        },
        GH: {
            names: {
                en: "Ghana"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Accra"
            ],
            dayoff: "",
            days: {
                "01-01 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-07 since 2019": {
                    _name: "Constitution Day"
                },
                "03-06 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "08-04 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Founders Day"
                    }
                },
                "09-21 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Kwame Nkrumah Memorial Day"
                    }
                },
                "1st Friday in December since 1988": {
                    name: {
                        en: "Farmers Day"
                    }
                },
                "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-26"
                },
                "1 Shawwal and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        GI: {
            names: {
                en: "Gibraltar"
            },
            langs: [
                "en"
            ],
            zones: [
                "Europe/Gibraltar"
            ],
            dayoff: "sunday",
            _days: "GB",
            days: {
                "2nd monday in March": {
                    name: {
                        en: "Commonwealth Day"
                    }
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-28": {
                    name: {
                        en: "Workers Memorial Day"
                    },
                    disable: [
                        "2015-04-28"
                    ],
                    enable: [
                        "2015-04-27"
                    ]
                },
                "05-01 if sunday, saturday then next monday": {
                    substitute: true,
                    name: {
                        en: "May Day"
                    }
                },
                "1st monday in May": false,
                "2020-05-08": {
                    name: {
                        en: "Victory in Europe Day (VE Day)"
                    }
                },
                "monday before 06-20": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "monday before September": {
                    name: {
                        en: "Late Summer Bank Holiday"
                    }
                },
                "09-10": {
                    name: {
                        en: "Gibraltar National Day"
                    },
                    active: [
                        {
                            to: 2015
                        }
                    ]
                },
                "09-10 and if sunday, saturday then previous monday": {
                    substitute: true,
                    name: {
                        en: "Gibraltar National Day"
                    },
                    active: [
                        {
                            from: 2015
                        }
                    ]
                }
            }
        },
        GL: {
            names: {
                kl: "Kalaallit Nunaat",
                da: "Gr\xf8nland",
                en: "Greenland"
            },
            langs: [
                "kl",
                "da"
            ],
            zones: [
                "America/Godthab",
                "America/Danmarkshavn",
                "America/Scoresbysund",
                "America/Thule"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 26": {
                    name: {
                        kl: "tussiarfissuaq",
                        da: "Store Bededag",
                        en: "Prayer Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "06-21": {
                    name: {
                        kl: "ullortuneq",
                        da: "Nationaldag",
                        en: "National Day"
                    }
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        GM: {
            names: {
                en: "The Gambia"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-18": {
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-25": {
                    name: {
                        en: "Africa Day"
                    }
                },
                "07-22": {
                    name: {
                        en: "Revolution Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "12-25": {
                    _name: "12-25"
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "23 Ramadan": {
                    _name: "23 Ramadan"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    name: {
                        en: "Korit\xe9"
                    }
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Tabaski"
                    }
                }
            }
        },
        GN: {
            names: {
                fr: "Guin\xe9e",
                en: "Guinea"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-03": {
                    name: {
                        fr: "F\xeate Nationale de la deuxi\xe8me R\xe9publique",
                        en: "National Holiday"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-25": {
                    name: {
                        fr: "Anniversaire de l'Organisation de l'unit\xe9 africaine (OUA)",
                        en: "Africa Day"
                    }
                },
                "27 Ramadan": {
                    _name: "27 Ramadan"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-02": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                }
            }
        },
        GP: {
            names: {
                fr: "Guadeloupe",
                en: "Guadeloupe"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            _days: "FR",
            days: {
                "easter 49": false,
                "easter -2": {
                    _name: "easter -2"
                },
                "05-27": {
                    _name: "Abolition of Slavery"
                },
                "07-21": {
                    name: {
                        fr: "Jour de Victor Shoelcher",
                        en: "Victor Shoelcher Day"
                    }
                }
            }
        },
        GQ: {
            names: {
                es: "Rep\xfablica de Guinea Ecuatorial",
                fr: "R\xe9publique de Guin\xe9e \xe9quatoriale",
                pt: "Rep\xfablica da Guin\xe9 Equatorial",
                en: "Republic of Equatorial Guinea"
            },
            dayoff: "sunday",
            weekend: [
                "saturday",
                "sunday"
            ],
            langs: [
                "es",
                "fr",
                "pt"
            ],
            zones: [
                "Africa/Lagos"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "06-05 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        es: "Natalicio de Teodoro Obiang",
                        en: "President's Day"
                    }
                },
                "08-03 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        es: "D\xeda del Golpe de Libertad",
                        en: "Armed Forces Day"
                    }
                },
                "08-15 and if sunday then next monday": {
                    substitute: true,
                    _name: "Constitution Day"
                },
                "10-12 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "12-08 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-08"
                },
                "12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                }
            }
        },
        GR: {
            names: {
                el: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
                en: "Greece"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Athens"
            ],
            langs: [
                "el"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                "orthodox -48": {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: "Ash Sunday"
                    }
                },
                "03-25": {
                    name: {
                        el: "\u0395\u03C5\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2, \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE",
                        en: "Annunciation, Anniversary of 1821 Revolution"
                    }
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "orthodox 49": {
                    _name: "easter 49"
                },
                "orthodox 50": {
                    _name: "easter 50"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-28": {
                    _name: "National Holiday",
                    name: {
                        el: "\u0395\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2 \u03C4\u03BF\u03C5 \u038C\u03C7\u03B9"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        GT: {
            names: {
                es: "Guatemala",
                en: "Guatemala"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Guatemala"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-30 if tuesday then previous monday if wednesday,thursday then next friday": {
                    name: {
                        es: "D\xeda de las Fuerzas Armadas",
                        en: "Army Day"
                    }
                },
                "09-15": {
                    _name: "Independence Day"
                },
                "10-20": {
                    _name: "Revolution Day"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-24 12:00": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31 12:00": {
                    _name: "12-31"
                }
            }
        },
        GU: {
            names: {
                en: "Guam"
            },
            dayoff: "sunday",
            langs: [
                "en-us",
                "en"
            ],
            zones: [
                "Pacific/Guam"
            ],
            _days: [
                "US"
            ],
            days: {
                "3rd monday in February": false,
                "03-17": false,
                "1st monday in March": {
                    name: {
                        en: "Guam History and Chamorro Heritage Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "observance"
                },
                "07-21 if sunday then next monday": {
                    name: {
                        en: "Liberation Day"
                    }
                },
                "11-02": {
                    _name: "11-02"
                },
                "12-08 if sunday then next monday": {
                    name: {
                        en: "Our Lady of Camarin Day"
                    }
                }
            }
        },
        GW: {
            names: {
                pt: "Guin\xe9-Bissau",
                en: "Guinea-Bissau"
            },
            langs: [
                "pt"
            ],
            zones: [
                "Africa/Bissau"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-20": {
                    name: {
                        pt: "Dia dos her\xf3is",
                        en: "Heroes Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-03": {
                    name: {
                        pt: "Pidjiguiti Day"
                    }
                },
                "09-24": {
                    _name: "Independence Day"
                },
                "11-14": {
                    name: {
                        pt: "Dia do Movimento de Reajustamento",
                        en: "Readjustment Movement Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        GY: {
            names: {
                en: "Guyana"
            },
            coord: {
                lat: 6.8045,
                lng: -58.1553
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Guyana"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-23": {
                    name: {
                        en: "Republic Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-05": {
                    name: {
                        en: "Arrival Day"
                    }
                },
                "05-26": {
                    _name: "Independence Day"
                },
                "monday after 07-01": {
                    name: {
                        en: "CARICOM Day"
                    }
                },
                "08-01": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal",
                    name: {
                        en: "Youman Nabi"
                    },
                    note: "tentative",
                    disable: [
                        "2016-12-11",
                        "2015-12-23",
                        "2013-01-24"
                    ],
                    enable: [
                        "2016-12-12",
                        "2015-12-24",
                        "2013-01-23"
                    ]
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Eid Ul Adha"
                    },
                    note: "tentative",
                    disable: [
                        "2015-09-23"
                    ],
                    enable: [
                        "2015-09-24"
                    ]
                },
                "2015-03-05": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2016-03-23": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2017-03-12": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2017-03-13": {
                    substitute: true,
                    name: {
                        en: "Phagwah"
                    }
                },
                "2018-03-02": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2019-03-21": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2020-03-10": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2021-03-29": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2022-03-18": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2023-03-07": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2024-03-25": {
                    name: {
                        en: "Phagwah"
                    }
                },
                "2015-11-11": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2017-10-18": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2018-11-07": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2019-10-27": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2019-10-28": {
                    substitute: true,
                    name: {
                        en: "Deepavali"
                    }
                },
                "2020-11-14": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2021-11-04": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2022-10-24": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2023-11-12": {
                    name: {
                        en: "Deepavali"
                    }
                },
                "2023-11-13": {
                    substitute: true,
                    name: {
                        en: "Deepavali"
                    }
                },
                "2024-10-31": {
                    name: {
                        en: "Deepavali"
                    }
                }
            }
        },
        HK: {
            names: {
                zh: "\u9999\u6E2F",
                en: "Hong Kong"
            },
            langs: [
                "zh",
                "en"
            ],
            zones: [
                "Asia/Hong_Kong"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01",
                    name: {
                        zh: "\u4E00\u6708\u4E00\u65E5"
                    }
                },
                "chinese 01-0-01 and if Saturday then next Tuesday": {
                    name: {
                        en: "Lunar New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E00"
                    }
                },
                "chinese 01-0-02 and if Saturday then next Monday": {
                    name: {
                        en: "The second day of the Lunar New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E8C"
                    }
                },
                "chinese 01-0-03 and if Saturday then next Monday": {
                    name: {
                        en: "The third day of the Lunar New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E09"
                    }
                },
                "chinese 5-01 solarterm and if Sunday then next Monday": {
                    name: {
                        en: "Qingming Festival",
                        zh: "\u6E05\u660E\u7BC0"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1",
                    disable: [
                        "2021-04-05"
                    ],
                    enable: [
                        "2021-04-06"
                    ]
                },
                "05-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "chinese 04-0-08 and if Sunday then next Monday": {
                    name: {
                        en: "Birthday of the Buddha",
                        zh: "\u4F5B\u8A95"
                    }
                },
                "chinese 05-0-05": {
                    name: {
                        en: "Dragon Boat Festival",
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                "07-01 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Hong Kong Special Administrative Region Establishment Day",
                        zh: "\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340\u6210\u7ACB\u7D00\u5FF5\u65E5"
                    }
                },
                "chinese 08-0-16 and if Sunday then next Monday if is public holiday then next day omit Saturday, Sunday": {
                    substitute: true,
                    name: {
                        en: "The day following the Chinese Mid-Autumn Festival",
                        zh: "\u4E2D\u79CB\u7BC0\u7FCC\u65E5"
                    }
                },
                "10-01 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Day",
                        zh: "\u570B\u6176\u65E5"
                    }
                },
                "chinese 09-0-09 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Chung Yeung Festival",
                        zh: "\u91CD\u9633\u8282"
                    }
                },
                "12-25 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Sunday then next Monday if Monday then next Tuesday": {
                    substitute: true,
                    name: {
                        en: "The first weekday after Christmas Day",
                        zh: "\u5723\u8BDE\u8282\u540E\u7684\u7B2C\u4E00\u4E2A\u5DE5\u4F5C\u65E5"
                    }
                }
            }
        },
        HN: {
            names: {
                es: "Honduras",
                en: "Honduras"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Tegucigalpa"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-19": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-14": {
                    name: {
                        es: "D\xeda de las Am\xe9ricas"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd monday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-11": {
                    name: {
                        en: "Pupil's Day",
                        es: "D\xeda del Estudiante"
                    },
                    type: "observance"
                },
                "09-10": {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del Ni\xf1o"
                    },
                    type: "observance"
                },
                "09-15": {
                    _name: "Independence Day"
                },
                "09-17": {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: "observance"
                },
                "10-03": {
                    name: {
                        en: "Soldier's Day",
                        es: "D\xeda del Soldado"
                    }
                },
                "10-12": {
                    name: {
                        es: "D\xeda de la Raza",
                        en: "Columbus Day"
                    }
                },
                "10-21": {
                    name: {
                        es: "D\xeda de las Fuerzas Armadas",
                        en: "Armed forces Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        HR: {
            names: {
                hr: "Hrvatska",
                en: "Croatia"
            },
            langs: [
                "hr"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    type: "public"
                },
                "01-06": {
                    _name: "01-06",
                    type: "public"
                },
                "easter -47": {
                    _name: "easter -47",
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "public"
                },
                "easter 1": {
                    _name: "easter 1",
                    type: "public"
                },
                "easter 60": {
                    _name: "easter 60",
                    type: "public"
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01",
                    type: "public"
                },
                "05-30": {
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        en: "National Day"
                    },
                    type: "public",
                    active: [
                        {
                            from: "2020-01-01"
                        }
                    ]
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-22": {
                    name: {
                        hr: "Dan antifa\u0161isti\u010Dke borbe",
                        en: "Anti-Fascist Struggle Day"
                    },
                    type: "public"
                },
                "06-25 #1": {
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        en: "Statehood Day"
                    },
                    type: "public",
                    active: [
                        {
                            to: "2020-01-01"
                        }
                    ]
                },
                "06-25": {
                    name: {
                        hr: "Dan neovisnosti",
                        en: "Independence Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: "2020-01-01"
                        }
                    ]
                },
                "08-05": {
                    name: {
                        hr: "Dan pobjede i domovinske zahvalnosti i Dan hrvatskih branitelja",
                        en: "Victory and Homeland Thanksgiving Day and the Day of Croatian defenders"
                    },
                    type: "public"
                },
                "08-15": {
                    _name: "08-15",
                    type: "public"
                },
                "10-08 #1": {
                    name: {
                        hr: "Dan neovisnosti",
                        en: "Independence Day"
                    },
                    type: "public",
                    active: [
                        {
                            to: "2020-01-01"
                        }
                    ]
                },
                "10-08": {
                    name: {
                        hr: "Dan Hrvatskoga sabora",
                        en: "Day of the Croatian Parliament"
                    },
                    type: "observence",
                    active: [
                        {
                            from: "2020-01-01"
                        }
                    ]
                },
                "11-01": {
                    _name: "11-01",
                    type: "public"
                },
                "11-18 #1": {
                    name: {
                        hr: "Dan sje\u0107anja na \u017Ertvu Vukovara i \u0160kabrnje",
                        en: "Remembrance Day"
                    },
                    type: "observance",
                    active: [
                        {
                            to: "2020-01-01"
                        }
                    ]
                },
                "11-18": {
                    name: {
                        hr: "Dan sje\u0107anja na \u017Ertve Domovinskog rata i Dan sje\u0107anja na \u017Ertvu Vukovara i \u0160kabrnje",
                        en: "Remembrance Day"
                    },
                    type: "public",
                    active: [
                        {
                            from: "2020-01-01"
                        }
                    ]
                },
                "12-25": {
                    _name: "12-25",
                    type: "public"
                },
                "12-26": {
                    _name: "12-26",
                    type: "public"
                },
                orthodox: {
                    _name: "orthodox",
                    type: "optional",
                    note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
                },
                "orthodox 1": {
                    _name: "orthodox 1",
                    type: "optional",
                    note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
                },
                "julian 12-25": {
                    _name: "julian 12-25",
                    type: "optional",
                    note: "Orthodox believers (legally defined as Christians who follow the Julian Calender)"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    type: "optional",
                    note: "Muslim believers"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    type: "optional",
                    note: "Muslim believers"
                },
                "1 Tishrei": {
                    _name: "10 Tishrei",
                    type: "optional",
                    note: "Jewish believers"
                },
                "10 Tishrei": {
                    _name: "10 Tishrei",
                    type: "optional",
                    note: "Jewish believers"
                }
            },
            regions: {
                17: {
                    name: "Split-Dalmatia",
                    days: {
                        "05-07": {
                            name: {
                                hr: "Sveti Duje",
                                en: "Saint Domnius"
                            },
                            type: "optional"
                        }
                    }
                },
                19: {
                    name: "Dubrovnik-Neretva",
                    days: {
                        "02-03": {
                            name: {
                                hr: "Sveti Vlaho",
                                en: "Saint Blaise"
                            },
                            type: "optional"
                        }
                    }
                }
            }
        },
        HT: {
            names: {
                fr: "Ha\xefti",
                en: "Haiti"
            },
            dayoff: "sunday",
            langs: [
                "fr"
            ],
            zones: [
                "America/Port-au-Prince"
            ],
            days: {
                "01-01": {
                    _name: "Independence Day"
                },
                "01-02": {
                    name: {
                        fr: "Jour des Aieux",
                        en: "Ancestry Day"
                    }
                },
                "01-06": {
                    _name: "01-06",
                    name: {
                        fr: "Le Jour des Rois"
                    },
                    type: "observance"
                },
                "easter -48 14:00": {
                    name: {
                        fr: "Lundi Gras",
                        en: "Lundi Gras"
                    }
                },
                "easter -47": {
                    name: {
                        fr: "Mardi Gras",
                        en: "Mardi Gras"
                    }
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-18": {
                    name: {
                        fr: "Jour du Drapeau et de l'Universit\xe9",
                        en: "Flag and Universities' Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-17": {
                    name: {
                        fr: "Anniversaire de la mort de Dessalines",
                        en: "Anniversary of the death of Dessalines"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-02": {
                    _name: "11-02"
                },
                "11-18": {
                    name: {
                        fr: "Verti\xe8res",
                        en: "Battle of Verti\xe8res Day"
                    }
                },
                "12-05": {
                    name: {
                        fr: "D\xe9couverte d'Ha\xefti",
                        en: "Discovery Day"
                    },
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        HU: {
            names: {
                hu: "Magyarorsz\xe1g",
                en: "Hungary"
            },
            dayoff: "sunday",
            langs: [
                "hu"
            ],
            zones: [
                "Europe/Budapest"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    type: "public"
                },
                "02-01": {
                    name: {
                        hu: "A k\xf6zt\xe1rsas\xe1g eml\xe9knapja",
                        en: "Memorial Day of the Republic"
                    },
                    type: "observance"
                },
                "02-25": {
                    name: {
                        hu: "A kommunista diktat\xfar\xe1k \xe1ldozatainak eml\xe9knapja",
                        en: "Memorial Day for the Victims of the Communist Dictatorships"
                    },
                    type: "observance"
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "03-15": {
                    name: {
                        hu: "1948-as forradalom",
                        en: "National Day"
                    },
                    type: "public"
                },
                "04-16": {
                    name: {
                        en: "Memorial Day for the Victims of the Holocaust",
                        hu: "A holokauszt \xe1ldozatainak eml\xe9knapja"
                    },
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "public",
                    active: [
                        {
                            from: "2017-01-01"
                        }
                    ]
                },
                easter: {
                    _name: "easter",
                    type: "public"
                },
                "easter 1": {
                    _name: "easter 1",
                    type: "public"
                },
                "05-01": {
                    _name: "05-01",
                    type: "public"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "05-21": {
                    name: {
                        en: "National Defense Day",
                        hu: "Honv\xe9delmi nap"
                    },
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "public"
                },
                "easter 50": {
                    _name: "easter 50",
                    type: "public"
                },
                "06-04": {
                    name: {
                        en: "Day of National Unity",
                        hu: "A nemzeti \xf6sszetartoz\xe1s napja"
                    },
                    type: "observance"
                },
                "06-19": {
                    name: {
                        en: "Day of the Independent Hungary",
                        hu: "A f\xfcggetlen Magyarorsz\xe1g napja"
                    },
                    type: "observance"
                },
                "08-20": {
                    name: {
                        hu: "Szent Istv\xe1n \xfcnnepe",
                        en: "Saint Stephen's Day"
                    },
                    type: "public"
                },
                "10-06": {
                    name: {
                        en: "Memorial Day for the Martyrs of Arad",
                        hu: "Az aradi v\xe9rtan\xfak eml\xe9knapja"
                    },
                    type: "observance"
                },
                "10-23": {
                    name: {
                        hu: "1956-os forradalom",
                        en: "National Day"
                    },
                    type: "public"
                },
                "11-01": {
                    _name: "11-01",
                    type: "public"
                },
                "12-06": {
                    _name: "12-06",
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24",
                    type: "optional"
                },
                "12-25": {
                    _name: "12-25",
                    type: "public"
                },
                "12-26": {
                    _name: "12-26",
                    type: "public"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                },
                "2023-10-30": {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: "Autumn school holiday"
                    },
                    type: "school"
                },
                "2023-10-31": {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: "Autumn school holiday"
                    },
                    type: "school"
                },
                "2023-11-02": {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: "Autumn school holiday"
                    },
                    type: "school"
                },
                "2023-11-03": {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: "Autumn school holiday"
                    },
                    type: "school"
                },
                "2023-12-22": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                },
                "2023-12-27": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                },
                "2024-01-02": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                },
                "2024-01-03": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                },
                "2024-01-04": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                },
                "2024-01-05": {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: "Winter school holiday"
                    },
                    type: "school"
                }
            }
        },
        IC: {
            names: {
                es: "Islas Canarias",
                en: "Canary Islands"
            },
            langs: [
                "es"
            ],
            zones: [
                "Atlantic/Canary"
            ],
            dayoff: "sunday",
            _days: "ES",
            days: {
                "05-30": {
                    name: {
                        es: "D\xeda de Canarias",
                        en: "Canary Islands Day"
                    }
                },
                "substitutes 05-30 if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        es: "D\xeda de Canarias",
                        en: "Canary Islands Day"
                    }
                },
                "substitutes 08-15 if Sunday then next Monday": {
                    substitute: true,
                    _name: "08-15"
                }
            },
            regions: {
                EH: {
                    names: {
                        es: "El Hierro"
                    },
                    days: {
                        "09-24": {
                            name: {
                                es: "Nuestra Se\xf1ora de los Reyes"
                            }
                        }
                    }
                },
                FU: {
                    names: {
                        es: "Fuerteventura"
                    },
                    days: {
                        "09-18": {
                            name: {
                                es: "Nuestra Se\xf1ora de la Pe\xf1a"
                            }
                        }
                    }
                },
                GC: {
                    names: {
                        es: "Gran Canaria"
                    },
                    days: {
                        "09-08": {
                            name: {
                                es: "Nuestra Se\xf1ora del Pino"
                            }
                        }
                    }
                },
                LG: {
                    names: {
                        es: "La Gomera"
                    },
                    days: {
                        "10-05": {
                            name: {
                                es: "Nuestra Se\xf1ora de Guadalupe"
                            }
                        }
                    }
                },
                LP: {
                    names: {
                        es: "La Palma"
                    },
                    days: {
                        "08-05": {
                            name: {
                                es: "Nuestra Se\xf1ora de las Nieves"
                            }
                        }
                    }
                },
                LA: {
                    names: {
                        es: "Lanzarote"
                    },
                    days: {
                        "09-15": {
                            name: {
                                es: "Nuestra Se\xf1ora de los Dolores"
                            }
                        }
                    }
                },
                TE: {
                    names: {
                        es: "Tenerife"
                    },
                    days: {
                        "09-07": {
                            name: {
                                es: "La Bajada de la Virgen del Socorro"
                            }
                        }
                    }
                }
            }
        },
        ID: {
            names: {
                en: "Indonesia",
                id: "Indonesia"
            },
            langs: [
                "id"
            ],
            zones: [
                "Asia/Jakarta",
                "Asia/Pontianak",
                "Asia/Makassar",
                "Asia/Jayapura"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Chinese New Year",
                        id: "Tahun Baru Imlek"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "06-01": {
                    name: {
                        en: "Pancasila Day",
                        id: "Hari Lahir Pancasila"
                    }
                },
                "08-17": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "27 Rajab": {
                    _name: "27 Rajab"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "2 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "2009-03-26": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2010-03-16": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2011-03-05": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2012-03-23": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2013-03-12": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2014-03-31": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2015-03-21": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2016-03-09": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2017-03-28": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2018-03-17": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2019-03-07": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2020-03-25": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2021-03-14": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2022-03-03": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2023-03-22": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2024-03-11": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2025-03-29": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2026-03-19": {
                    name: {
                        en: "Nyepi",
                        id: "Hari Raya Nyepi"
                    }
                },
                "2001-05-07": {
                    _name: "Vesak"
                },
                "2002-05-26": {
                    _name: "Vesak"
                },
                "2003-05-16": {
                    _name: "Vesak"
                },
                "2004-06-03": {
                    _name: "Vesak"
                },
                "2005-05-24": {
                    _name: "Vesak"
                },
                "2006-05-13": {
                    _name: "Vesak"
                },
                "2007-06-01": {
                    _name: "Vesak"
                },
                "2008-05-20": {
                    _name: "Vesak"
                },
                "2009-05-09": {
                    _name: "Vesak"
                },
                "2010-05-28": {
                    _name: "Vesak"
                },
                "2011-05-17": {
                    _name: "Vesak"
                },
                "2012-05-06": {
                    _name: "Vesak"
                },
                "2013-05-25": {
                    _name: "Vesak"
                },
                "2014-05-15": {
                    _name: "Vesak"
                },
                "2015-06-02": {
                    _name: "Vesak"
                },
                "2016-05-22": {
                    _name: "Vesak"
                },
                "2017-05-11": {
                    _name: "Vesak"
                },
                "2018-05-29": {
                    _name: "Vesak"
                },
                "2019-05-19": {
                    _name: "Vesak"
                },
                "2020-05-07": {
                    _name: "Vesak"
                },
                "2021-05-26": {
                    _name: "Vesak"
                },
                "2022-05-16": {
                    _name: "Vesak"
                },
                "2023-05-06": {
                    _name: "Vesak"
                },
                "2024-05-23": {
                    _name: "Vesak"
                }
            }
        },
        IE: {
            names: {
                en: "Ireland"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Dublin"
            ],
            langs: [
                "en"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "1st monday in January": {
                    name: {
                        en: "Bank Holiday"
                    },
                    type: "bank"
                },
                "02-01 if Tuesday,Wednesday,Thursday,Saturday,Sunday then next Monday since 2023": {
                    name: {
                        en: "St. Brigid\u2019s Day"
                    }
                },
                "03-17": {
                    name: {
                        en: "St. Patrick\u2019s Day"
                    }
                },
                "03-17 and if saturday then next monday if sunday then next monday": {
                    name: {
                        en: "St. Patrick\u2019s Day"
                    },
                    substitute: true,
                    type: "bank"
                },
                "easter -21": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "bank"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1st monday in May": {
                    name: {
                        en: "May Day"
                    }
                },
                "1st monday in June": {
                    name: {
                        en: "First Monday in June"
                    }
                },
                "1st monday in August": {
                    name: {
                        en: "First Monday in August"
                    }
                },
                "1st Monday before 11-01": {
                    name: {
                        en: "October Bank Holiday",
                        type: "bank"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        en: "St. Stephen's Day"
                    }
                },
                "12-26 and if saturday then next monday if sunday then next monday": {
                    _name: "12-26",
                    name: {
                        en: "St. Stephen's Day"
                    },
                    substitute: true,
                    type: "bank"
                },
                "12-27 and if saturday then next monday if sunday then next tuesday": {
                    name: {
                        en: "Christmas Bank Holiday"
                    },
                    type: "bank"
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                }
            }
        },
        IL: {
            names: {
                he: "\u05DE\u05B0\u05D3\u05B4\u05D9\u05E0\u05B7\u05EA \u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
                en: "Israel"
            },
            langs: [
                "he"
            ],
            zones: [
                "Asia/Jerusalem"
            ],
            dayoff: "Saturday",
            days: {
                "1 Tishrei": {
                    name: {
                        he: "\u05E8\u05D0\u05E9 \u05D4\u05E9\u05E0\u05D4",
                        en: "Rosh Hashanah (Yom Teruah)"
                    }
                },
                "2 Tishrei": {
                    name: {
                        he: "\u05E8\u05D0\u05E9 \u05D4\u05E9\u05E0\u05D4 \u05D9\u05D5\u05DD 2",
                        en: "Rosh Hashanah (Day 2)"
                    }
                },
                "3 Tishrei if Saturday then next Sunday": {
                    name: {
                        he: "\u05E6\u05D5\u05DD \u05D2\u05D3\u05DC\u05D9\u05D4",
                        en: "Fast of Gedaliah (Tzom Gedalya)"
                    },
                    type: "observance"
                },
                "10 Tishrei": {
                    name: {
                        he: "\u05D9\u05D5\u05DD \u05DB\u05D9\u05E4\u05D5\u05E8",
                        en: "Day of Atonement (Yom Kippur)"
                    }
                },
                "15 Tishrei": {
                    name: {
                        he: "\u05E1\u05D5\u05DB\u05D5\u05EA",
                        en: "Feast of Tabernacles (Sukkot)"
                    }
                },
                "16 Tishrei P6D": {
                    name: {
                        he: "\u05D7\u05D5\u05DC \u05D4\u05DE\u05D5\u05E2\u05D3 \u05E1\u05D5\u05DB\u05D5\u05EA",
                        en: "The week of Sukkot"
                    },
                    type: "school",
                    note: "Collective paid leave in many businesses and government offices"
                },
                "22 Tishrei": {
                    name: {
                        he: "\u05E9\u05DE\u05D7\u05EA \u05EA\u05D5\u05E8\u05D4/\u05E9\u05DE\u05D9\u05E0\u05D9 \u05E2\u05E6\u05E8\u05EA",
                        en: "Simchat Torah/ Shmini Atzeret"
                    }
                },
                "12 Cheshvan if Friday,Saturday then previous Thursday since 1997": {
                    name: {
                        he: "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05DF",
                        en: "Rabin Day"
                    },
                    type: "observance",
                    note: "National remembrance day, business as usual"
                },
                "29 Cheshvan": {
                    name: {
                        he: "\u05E1\u05D9\u05D2\u05D3",
                        en: "Sigd"
                    },
                    type: "observance",
                    note: "Festival of the Ethiopian Jews, optional paid leave, business as usual"
                },
                "6 Kislev if Saturday then next Sunday": {
                    name: {
                        en: "Ben-Gurion Day",
                        he: "\u05D9\u05D5\u05DD \u05D1\u05DF-\u05D2\u05D5\u05E8\u05D9\u05D5\u05DF"
                    },
                    type: "observance",
                    note: "Day marked by the Knesset"
                },
                "25 Kislev P8D": {
                    name: {
                        en: "Hanukkah",
                        he: "\u05D7\u05E0\u05D5\u05DB\u05D4"
                    },
                    type: "school"
                },
                "10 Tevet": {
                    name: {
                        en: "Tenth of Tevet",
                        he: "\u05E6\u05D5\u05DD \u05E2\u05E9\u05E8\u05D4 \u05D1\u05D8\u05D1\u05EA"
                    },
                    type: "observance"
                },
                "15 Shvat": {
                    name: {
                        en: "Tu Bishvat (Arbor Day)",
                        he: '\u05D8"\u05D5 \u05D1\u05E9\u05D1\u05D8'
                    },
                    type: "observance"
                },
                "13 AdarII if Saturday then previous Thursday": {
                    name: {
                        en: "Fast of Esther",
                        he: "\u05EA\u05E2\u05E0\u05D9\u05EA \u05D0\u05E1\u05EA\u05E8"
                    },
                    type: "school"
                },
                "14 AdarII P2D": {
                    name: {
                        en: "Purim",
                        he: "\u05E4\u05D5\u05E8\u05D9\u05DD"
                    },
                    type: "school",
                    note: "optional paid leave"
                },
                "10 Nisan": {
                    name: {
                        en: "Aliyah Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E2\u05DC\u05D9\u05D9\u05D4"
                    },
                    type: "observance",
                    note: "Official holiday, business as usual"
                },
                "15 Nisan": {
                    name: {
                        en: "Passover (Pesach)",
                        he: "\u05E4\u05E1\u05D7"
                    }
                },
                "16 Nisan P5D": {
                    name: {
                        en: "Passover (intermediate days)",
                        he: "\u05D7\u05D5\u05DC \u05D4\u05DE\u05D5\u05E2\u05D3 \u05E4\u05E1\u05D7"
                    },
                    type: "school",
                    note: "School holiday, collective paid leave in many businesses and government offices"
                },
                "21 Nisan": {
                    name: {
                        en: "Mimouna, Seventh day of Passover",
                        he: "\u05DE\u05D9\u05DE\u05D5\u05E0\u05D4, \u05E9\u05D1\u05D9\u05E2\u05D9 \u05E9\u05DC \u05E4\u05E1\u05D7"
                    }
                },
                "27 Nisan if Friday then previous Thursday if Sunday then next Monday": {
                    name: {
                        en: "Holocaust Remembrance Day (Yom HaShoah)",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D6\u05D9\u05DB\u05E8\u05D5\u05DF \u05DC\u05E9\u05D5\u05D0\u05D4 \u05D5\u05DC\u05D2\u05D1\u05D5\u05E8\u05D4"
                    },
                    type: "observance",
                    note: "National remembrance day, business as usual except places of public entertainment"
                },
                "05-09": {
                    name: {
                        en: "Victory in Europe Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E0\u05D9\u05E6\u05D7\u05D5\u05DF \u05E2\u05DC \u05D2\u05E8\u05DE\u05E0\u05D9\u05D4 \u05D4\u05E0\u05D0\u05E6\u05D9\u05EA"
                    },
                    type: "observance"
                },
                "4 Iyyar if Thursday,Friday then previous Wednesday if Sunday then next Monday": {
                    name: {
                        en: "Fallen Soldiers and Victims of Terrorism Remembrance Day (Yom HaZikaron)",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D6\u05D9\u05DB\u05E8\u05D5\u05DF \u05DC\u05D7\u05DC\u05DC\u05D9 \u05DE\u05E2\u05E8\u05DB\u05D5\u05EA \u05D9\u05E9\u05E8\u05D0\u05DC \u05D5\u05E0\u05E4\u05D2\u05E2\u05D9 \u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05D4\u05D0\u05D9\u05D1\u05D4"
                    },
                    type: "observance",
                    note: "National remembrance day, business as usual except places of public entertainment"
                },
                "5 Iyyar if Friday,Saturday then previous Thursday if Monday then next Tuesday": {
                    name: {
                        en: "Independence Day (Yom HaAtzmaut)",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E2\u05E6\u05DE\u05D0\u05D5\u05EA"
                    }
                },
                "10 Iyyar if Saturday then next Sunday since 2004": {
                    name: {
                        en: "Herzl Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E8\u05E6\u05DC"
                    },
                    type: "observance",
                    note: "Day marked by the Knesset"
                },
                "18 Iyyar": {
                    name: {
                        en: "Lag BaOmer",
                        he: '\u05DC"\u05D2 \u05D1\u05E2\u05D5\u05DE\u05E8'
                    },
                    type: "school"
                },
                "28 Iyyar": {
                    name: {
                        en: "Jerusalem Day (Yom Yerushalayim)",
                        he: "\u05D9\u05D5\u05DD \u05D9\u05E8\u05D5\u05E9\u05DC\u05D9\u05DD"
                    },
                    type: "observance",
                    note: "Optional paid leave"
                },
                "6 Sivan": {
                    name: {
                        en: "Shavuot (Feast of Weeks)",
                        he: "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
                    }
                },
                "17 Tamuz if Saturday then next Sunday": {
                    name: {
                        en: "Seventeenth of Tamuz, fast",
                        he: "\u05E9\u05D1\u05E2\u05D4 \u05E2\u05E9\u05E8 \u05D1\u05EA\u05DE\u05D5\u05D6"
                    },
                    type: "observance"
                },
                "29 Tamuz if Saturday then next Sunday": {
                    name: {
                        en: "Jabotinsky Day",
                        he: "\u05D9\u05D5\u05DD \u05D6'\u05D1\u05D5\u05D8\u05D9\u05E0\u05E1\u05E7\u05D9"
                    },
                    type: "observance",
                    note: "Day marked by the Knesset"
                },
                "9 Av if Saturday then next Sunday": {
                    name: {
                        en: "Tisha B'Av, fast",
                        he: "\u05EA\u05E9\u05E2\u05D4 \u05D1\u05D0\u05D1"
                    },
                    type: "observance",
                    note: "Optional paid leave, business as usual except places of public entertainment"
                },
                "15 Av": {
                    name: {
                        en: "Tu B'Av (Fifteenth of Av)",
                        he: '\u05D8"\u05D5 \u05D1\u05D0\u05D1'
                    },
                    type: "observance"
                },
                "2015-03-17": {
                    name: {
                        en: "Election Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                "2019-04-09": {
                    name: {
                        en: "Election Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                "2019-09-17": {
                    name: {
                        en: "Election Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                "2020-03-02": {
                    name: {
                        en: "Election Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                "2021-03-23": {
                    name: {
                        en: "Election Day",
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                }
            }
        },
        IM: {
            names: {
                en: "Isle of Man"
            },
            zones: [
                "Europe/Isle_of_Man"
            ],
            langs: [
                "en"
            ],
            _days: [
                "GB"
            ],
            days: {
                "2nd friday in June": {
                    name: {
                        en: "Tourist Trophy, Senior Race Day"
                    }
                },
                "07-05": {
                    name: {
                        en: "Tynwald Day"
                    }
                }
            }
        },
        IR: {
            names: {
                fa: "\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u06CC\u0631\u0627\u0646",
                en: "Iran"
            },
            langs: [
                "fa",
                "en"
            ],
            zones: [
                "Asia/Tehran"
            ],
            dayoff: "Friday",
            days: {
                "1 Farvardin": {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: "Nowruz"
                    }
                },
                "2 Farvardin": {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: "Nowruz"
                    }
                },
                "3 Farvardin": {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: "Nowruz"
                    }
                },
                "4 Farvardin": {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: "Nowruz"
                    }
                },
                "12 Farvardin": {
                    name: {
                        fa: "\u0631\u0648\u0632 \u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC",
                        en: "Islamic Republic Day"
                    }
                },
                "13 Farvardin": {
                    name: {
                        fa: "\u0633\u06CC\u0632\u062F\u0647 \u0628\u062F\u0631",
                        en: "Sizdah Bedar"
                    }
                },
                "14 Khordad": {
                    name: {
                        fa: "\u0631\uFEA3\uFEE0\uFE96 \u0627\uFEE3\uFE8E\u0645 \uFEA7\uFEE4\uFBFF\uFEE8\uFBFD",
                        en: "Imam Khomeini's Demise"
                    }
                },
                "15 Khordad": {
                    name: {
                        fa: "\u0642\u06CC\u0627\u0645 \u06F1\u06F5 \u062E\u0631\u062F\u0627\u062F",
                        en: "Revolt of Khordad 15"
                    }
                },
                "22 Bahman": {
                    name: {
                        fa: "\u0627\u0646\u0642\u0644\u0627\u0628 \u0627\u0633\u0644\u0627\u0645\u06CC \u067E\u0646\u062C\u0627\u0647 \u0648 \u0647\u0641\u062A",
                        en: "Anniversary of Islamic Revolution"
                    }
                },
                "29 Esfand": {
                    name: {
                        fa: "\u0645\u0644\u06CC \u0634\u062F\u0646 \u0635\u0646\u0639\u062A \u0646\u0641\u062A",
                        en: "Nationalization of the Iranian oil industry"
                    }
                },
                "9 Muharram": {
                    name: {
                        fa: "\uFE97\uFE8E\uFEB3\uFEEE\uFECB\uFE8E\u06CC \uFEA3\uFEB4\uFBFF\uFEE8\uFBFD",
                        en: "Tasoua"
                    }
                },
                "10 Muharram": {
                    name: {
                        fa: "\uFECB\uFE8E\uFEB7\uFEEE\u0631\u0627\u06CC \uFEA3\uFEB4\uFBFF\uFEE8\uFBFD",
                        en: "Ashoura"
                    }
                },
                "20 Safar": {
                    name: {
                        fa: "\u0627\u0631\u0628\u0639\u06CC\u0646 \u062D\u0633\u06CC\u0646\u06CC",
                        en: "Arbaeen-e Hosseini"
                    }
                },
                "28 Safar": {
                    name: {
                        fa: "\u0631\uFEA3\uFEE0\uFE96 \uFEA3\uFEC0\uFEAE\u062A \u0631\uFEB3\uFEEE\u0644 \u0627\uFB90\uFEAE\u0645 \u0635\u0644\u0651\u06CC \u0627\u0644\u0644\u0647 \u0639\u0644\u06CC\u0647 \u0648\u0622\u0644\u0647 \u0648 \u0633\u0644\u0651\u0645",
                        en: "Demise of Prophet Muhammad and Imam Hassan (Mujtaba)"
                    }
                },
                "30 Safar": {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \u0631\uFEBF\uFE8E \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: "Martyrdom of Imam Reza"
                    }
                },
                "8 Rabi al-awwal": {
                    name: {
                        fa: "\u0634\u0647\u0627\u062F\u062A \u0627\u0645\u0627\u0645 \u062D\u0633\u0646 \u0639\u0633\u0643\u0631\u06CC \u0639\u0644\u06CC\u0647\u200C\u0627\u0644\u0633\u0644\u0627\u0645",
                        en: "Martyrdom of Imam Hassan"
                    }
                },
                "17 Rabi al-awwal": {
                    name: {
                        fa: "\u0648\u0644\u0627\u062F\u062A \u062D\u0636\u0631\u062A \u0631\u0633\u0648\u0644 \u0627\u06A9\u0631\u0645 \u0635\u0644\u0651\u06CC \u0627\u0644\u0644\u0647 \u0639\u0644\u06CC\u0647 \u0648\u0622\u0644\u0647 \u0648 \u0633\u0644\u0651\u0645",
                        en: "Birthday of Muhammad Prophet"
                    }
                },
                "3 Jumada al-thani": {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFED3\uFE8E\uFEC3\uFEE4\uFEEA \u0632\uFEEB\uFEAE\u0627 \uFEB3\uFEFC\u0645 \u0627\uFDF2 \uFECB\uFEE0\uFBFF\uFEEC\uFE8E",
                        en: "Martyrdom of Fatima-Zahara"
                    }
                },
                "13 Rajab": {
                    name: {
                        fa: "\u0648\uFEFB\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \uFECB\uFEE0\uFBFD \uFECB\uFEE0\uFBFF\uFEEA \u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: "Birthday of Imam Ali"
                    }
                },
                "27 Rajab": {
                    name: {
                        fa: "\uFEE3\uFE92\uFECC\uFE9A \uFEA3\uFEC0\uFEAE\u062A \u0631\uFEB3\uFEEE\u0644 \u0627\uFB90\uFEAE\u0645 \uFEBB\uFEE0\uFBFD \u0627\uFDF2 \uFECB\uFEE0\uFBFF\uFEEA \u0648 \u0622\uFEDF\uFEEA",
                        en: "Mabaas of Muhammad"
                    }
                },
                "15 Shaban": {
                    name: {
                        fa: "\u0648\uFEFB\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFED7\uFE8E\uFE8B\uFEE2 \uFECB\uFEA0\uFEDE\u0627\uFDF2 \uFE97\uFECC\uFE8E\uFEDF\uFBFD \uFED3\uFEAE\uFE9F\uFEEA \u0634\u0631\u06CC\u0641",
                        en: "Birthday of Imam Mahdi"
                    }
                },
                "21 Ramadan": {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFECB\uFEE0\uFBFD \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: "Martyrdom of Imam Ali"
                    }
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "2 Shawwal": {
                    name: {
                        fa: "\uFE91\uFEEA \uFEE3\uFEE8\uFE8E\uFEB3\uFE92\uFE96 \uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED3\uFEC4\uFEAE",
                        en: "Holyday for Fetr Eeid"
                    }
                },
                "25 Shawwal": {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \uFE9F\uFECC\uFED4\uFEAE \uFEBB\uFE8E\u062F\u0642 \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: "Martyrdom of Imam Jafar"
                    }
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "18 Dhu al-Hijjah": {
                    name: {
                        fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFECF\uFEAA\uFBFE\uFEAE \uFEA7\uFEE2",
                        en: "Eid al-Ghadeer"
                    }
                }
            }
        },
        IS: {
            names: {
                is: "\xcdsland",
                en: "Iceland"
            },
            dayoff: "sunday",
            zones: [
                "Atlantic/Reykjavik"
            ],
            langs: [
                "is"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    type: "observance"
                },
                "friday after 01-18": {
                    name: {
                        is: "B\xf3ndadagur"
                    },
                    type: "observance"
                },
                "02-18": {
                    name: {
                        is: "Konudagur",
                        en: "Woman's Day"
                    },
                    type: "observance"
                },
                "easter -48": {
                    name: {
                        is: "Bolludagur"
                    },
                    type: "observance"
                },
                "easter -47": {
                    name: {
                        is: "Sprengidagur"
                    },
                    type: "observance"
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "easter -7": {
                    _name: "easter -7",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "thursday after 04-18": {
                    name: {
                        is: "Sumardagurinn fyrsti",
                        en: "First Day of Summer"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "1st sunday in June": {
                    name: {
                        is: "Sj\xf3mannadagurinn",
                        en: "The Seamen's Day"
                    },
                    type: "observance"
                },
                "06-17": {
                    name: {
                        is: "\xcdslenski \xfej\xf3\xf0h\xe1t\xed\xf0ardagurinn",
                        en: "Icelandic National Day"
                    }
                },
                "1st monday in August": {
                    name: {
                        is: "Fr\xeddagur verslunarmanna",
                        en: "Commerce Day"
                    }
                },
                "saturday after 10-21": {
                    name: {
                        is: "Fyrsti vetrardagur",
                        en: "First Day of Winter"
                    },
                    type: "observance"
                },
                "11-16": {
                    name: {
                        is: "Dagur \xedslenskrar tungu",
                        en: "Icelandic Language Day"
                    },
                    type: "observance"
                },
                "12-23": {
                    name: {
                        is: "\xdeorl\xe1ksmessa",
                        en: "St \xdeorl\xe1kur's Day"
                    },
                    type: "observance"
                },
                "12-24 13:00 if sunday then 00:00": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 13:00 if sunday then 00:00": {
                    _name: "12-31"
                }
            }
        },
        IT: {
            names: {
                it: "Italia",
                en: "Italia"
            },
            dayoff: "sunday",
            zones: [
                "Europe/Rome"
            ],
            langs: [
                "it"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-25": {
                    name: {
                        it: "Anniversario della Liberazione",
                        en: "Liberation Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-02": {
                    name: {
                        it: "Festa della Repubblica",
                        en: "Republic Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "2011-03-17": {
                    name: {
                        it: "Festa Nazionale 2011",
                        en: "National Day 2011"
                    }
                }
            },
            states: {
                25: {
                    name: "Lombardy",
                    regions: {
                        MI: {
                            name: "Milan",
                            days: {
                                "12-07": {
                                    name: {
                                        it: "Sant'Ambrogio",
                                        en: "Saint Ambrose"
                                    }
                                }
                            }
                        }
                    }
                },
                32: {
                    name: "S\xfcdtirol, Alto Adige",
                    days: {
                        "easter 50": {
                            _name: "easter 50"
                        }
                    }
                }
            }
        },
        JE: {
            names: {
                en: "Jersey"
            },
            zones: [
                "Europe/Jersey"
            ],
            langs: [
                "en"
            ],
            _days: [
                "GB"
            ],
            days: {
                "05-09": {
                    name: {
                        en: "Liberation Day"
                    }
                }
            }
        },
        JM: {
            names: {
                en: "Jamaica"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "America/Jamaica"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    _name: "01-01",
                    substitute: true
                },
                "easter -46": {
                    _name: "easter -46"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-23 if saturday,sunday then next monday": {
                    _name: "05-01"
                },
                "08-01 if sunday then next monday": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "08-06 and if sunday then next monday": {
                    _name: "Independence Day",
                    substitute: true
                },
                "3rd monday in October": {
                    name: {
                        en: "National Heroes Day"
                    }
                },
                "12-25 and if sunday then next tuesday": {
                    _name: "12-25",
                    substitute: true
                },
                "12-26 and if sunday then next monday": {
                    _name: "12-26",
                    substitute: true
                }
            }
        },
        JP: {
            names: {
                jp: "\u65E5\u672C",
                en: "Japan"
            },
            dayoff: "sunday",
            langs: [
                "jp"
            ],
            zones: [
                "Asia/Tokyo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    substitute: true,
                    _name: "01-01",
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "01-02": {
                    name: {
                        en: "January 2nd",
                        jp: "\u9280\u884C\u4F11\u696D\u65E5"
                    },
                    type: "bank"
                },
                "01-03": {
                    name: {
                        en: "January 3rd",
                        jp: "\u9280\u884C\u4F11\u696D\u65E5"
                    },
                    type: "bank"
                },
                "01-15": {
                    name: {
                        en: "Coming of Age Day",
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z",
                            to: "1999-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 01-15 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Coming of Age Day",
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z",
                            to: "1999-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "2nd monday in January": {
                    name: {
                        en: "Coming of Age Day",
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "2000-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "02-11": {
                    name: {
                        en: "Foundation Day",
                        jp: "\u5EFA\u56FD\u8A18\u5FF5\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1967-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 02-11 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Foundation Day",
                        jp: "\u5EFA\u56FD\u8A18\u5FF5\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "02-23 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: "2020-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "1989-02-24": {
                    name: {
                        en: "State Funeral of Emperor Showa",
                        jp: "\u5927\u55AA\u306E\u793C"
                    }
                },
                "march equinox in +09:00": {
                    name: {
                        en: "Spring Equinox Day",
                        jp: "\u6625\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes march equinox in +09:00 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Spring Equinox Day",
                        jp: "\u6625\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "1959-04-10": {
                    name: {
                        en: "Marriage of Crown Prince Akihito",
                        jp: "\u7D50\u5A5A\u306E\u5100"
                    }
                },
                "04-29": {
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z",
                            to: "1988-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 04-29 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z",
                            to: "1988-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "04-29 and if sunday then next monday #1": {
                    substitute: true,
                    name: {
                        en: "Greenery Day",
                        jp: "\u307F\u3069\u308A\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1989-01-01T00:00:00.000Z",
                            to: "2006-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "04-29 and if sunday then next monday #2": {
                    substitute: true,
                    name: {
                        en: "Showa Day",
                        jp: "\u662D\u548C\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "2007-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "2019-04-30": {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                "2019-05-01": {
                    name: {
                        en: "Coronation Day",
                        jp: "\u5373\u4F4D\u306E\u65E5"
                    }
                },
                "2019-05-02": {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                "05-03": {
                    _name: "Constitution Day"
                },
                "substitutes 05-03 if sunday then next monday": {
                    substitute: true,
                    _name: "Constitution Day",
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z",
                            to: "2006-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 05-03 if sunday then next wednesday": {
                    substitute: true,
                    _name: "Constitution Day",
                    active: [
                        {
                            from: "2007-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "05-04 not on sunday, monday": {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    },
                    active: [
                        {
                            from: "1986-01-01T00:00:00.000Z",
                            to: "2006-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "05-04 and if sunday then next tuesday": {
                    substitute: true,
                    name: {
                        en: "Greenery Day",
                        jp: "\u307F\u3069\u308A\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "2007-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "05-05": {
                    name: {
                        en: "Children's Day",
                        jp: "\u3053\u3069\u3082\u306E\u65E5"
                    }
                },
                "substitutes 05-05 if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Children's Day",
                        jp: "\u3053\u3069\u3082\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "1993-06-09": {
                    name: {
                        en: "Marriage of Crown Prince Naruhito",
                        jp: "\u7D50\u5A5A\u306E\u5100"
                    }
                },
                "07-20": {
                    name: {
                        en: "Marine Day",
                        jp: "\u6D77\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1996-01-01T00:00:00.000Z",
                            to: "2002-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 07-20 if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Marine Day",
                        jp: "\u6D77\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1996-01-01T00:00:00.000Z",
                            to: "2002-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "3rd monday in July": {
                    name: {
                        en: "Marine Day",
                        jp: "\u6D77\u306E\u65E5"
                    },
                    disable: [
                        "2020-07-20",
                        "2021-07-19"
                    ],
                    enable: [
                        "2020-07-23",
                        "2021-07-22"
                    ],
                    active: [
                        {
                            from: "2003-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 2021-08-08 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Mountain Day",
                        jp: "\u5C71\u306E\u65E5"
                    }
                },
                "substitutes 08-11 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Mountain Day",
                        jp: "\u5C71\u306E\u65E5"
                    },
                    disable: [
                        "2020-08-11",
                        "2021-08-11"
                    ],
                    enable: [
                        "2020-08-10"
                    ],
                    active: [
                        {
                            from: "2016-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "09-15": {
                    name: {
                        en: "Respect-for-the-Aged Day",
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1966-01-01T00:00:00.000Z",
                            to: "2002-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 09-15 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Respect-for-the-Aged Day",
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z",
                            to: "2002-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "3rd monday in September": {
                    name: {
                        en: "Respect-for-the-Aged Day",
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "2003-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "09-22 if 09-21 and 09-23 is public holiday": {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                "september equinox in +09:00": {
                    name: {
                        en: "Autumnal Equinox Day",
                        jp: "\u79CB\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes september equinox in +09:00 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Autumnal Equinox Day",
                        jp: "\u79CB\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "10-10": {
                    name: {
                        en: "Sports Day",
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1966-01-01T00:00:00.000Z",
                            to: "1999-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 10-10 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Sports Day",
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z",
                            to: "1999-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "2nd monday in October #1": {
                    name: {
                        en: "Sports Day",
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "2000-01-01T00:00:00.000Z",
                            to: "2019-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "2nd monday in October #2": {
                    name: {
                        en: "Sports Day",
                        jp: "\u30B9\u30DD\u30FC\u30C4\u306E\u65E5"
                    },
                    disable: [
                        "2020-10-12",
                        "2021-10-11"
                    ],
                    enable: [
                        "2020-07-24",
                        "2021-07-23"
                    ],
                    active: [
                        {
                            from: "2020-01-01T00:00:00.000Z"
                        }
                    ]
                },
                "2019-10-22": {
                    name: {
                        en: "Enthronement Ceremony Day",
                        jp: "\u5373\u4F4D\u793C\u6B63\u6BBF\u306E\u5100"
                    }
                },
                "11-03": {
                    substitute: true,
                    name: {
                        en: "Culture Day",
                        jp: "\u6587\u5316\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 11-03 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Culture Day",
                        jp: "\u6587\u5316\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "1990-11-12": {
                    name: {
                        en: "Official Enthronement Ceremony of Emperor Heisei (Akihito)",
                        jp: "\u5373\u4F4D\u793C\u6B63\u6BBF\u306E\u5100"
                    }
                },
                "11-15": {
                    name: {
                        en: "Seven-Five-Three Festival",
                        jp: "\u4E03\u4E94\u4E09"
                    },
                    type: "observance"
                },
                "11-23": {
                    name: {
                        en: "Labor Thanksgiving Day",
                        jp: "\u52E4\u52B4\u611F\u8B1D\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1948-07-20T00:00:00.000Z"
                        }
                    ]
                },
                "substitutes 11-23 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Labor Thanksgiving Day",
                        jp: "\u52E4\u52B4\u611F\u8B1D\u306E\u65E5"
                    },
                    active: [
                        {
                            from: "1973-04-12T00:00:00.000Z"
                        }
                    ]
                },
                "12-23 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: "1989-01-01T00:00:00.000Z",
                            to: "2018-12-31T00:00:00.000Z"
                        }
                    ]
                },
                "12-25": {
                    _name: "12-25",
                    type: "observance"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        KE: {
            names: {
                en: "Kenya"
            },
            dayoff: "sunday",
            langs: [
                "sw",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "06-01 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        sw: "Siku ya Madaraka",
                        en: "Madaraka Day"
                    }
                },
                "10-10 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Moi Day"
                    }
                },
                "10-20 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        sw: "Siku ya Mashujaa",
                        en: "Mashujaa Day"
                    }
                },
                "12-12 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        sw: "Siku ya Jamhuri",
                        en: "Jamhuri Day"
                    }
                },
                "12-25 and if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-26"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    note: "For all persons belonging to the Islamic faith."
                }
            }
        },
        KM: {
            names: {
                fr: "Union des Comores",
                en: "Comoros"
            },
            langs: [
                "fr",
                "ar",
                "swb",
                "wlc",
                "wni",
                "zdj"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-18": {
                    name: {
                        fr: "Journ\xe9e de Cheikh Al Maarouf",
                        en: "Cheikh Al Maarouf Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-06": {
                    _name: "Independence Day"
                },
                "11-12": {
                    name: {
                        fr: "Journ\xe9e Maor\xe9",
                        en: "Maore Day"
                    }
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P3DT0H0M": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P2DT0H0M": {
                    _name: "10 Dhu al-Hijjah"
                },
                "27 Rajab": {
                    _name: "27 Rajab"
                }
            }
        },
        KN: {
            names: {
                en: "St. Kitts & Nevis"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-02": {
                    name: {
                        en: "Carnival Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "1st Monday in May": {
                    _name: "05-01"
                },
                "1st Monday in August": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "1st Tuesday in August": {
                    name: {
                        en: "Culturama Day"
                    }
                },
                "09-16 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                "09-19 if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        KR: {
            names: {
                ko: "\uB300\uD55C\uBBFC\uAD6D",
                en: "South Korea"
            },
            dayoff: "sunday",
            langs: [
                "ko"
            ],
            zones: [
                "Asia/Seoul"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "korean 01-0-01 P3D": {
                    name: {
                        en: "Korean New Year",
                        ko: "\uC124\uB0A0"
                    }
                },
                "03-01": {
                    name: {
                        en: "Independence Movement Day",
                        ko: "3\xb71\uC808"
                    }
                },
                "05-05": {
                    name: {
                        en: "Children's Day",
                        ko: "\uC5B4\uB9B0\uC774\uB0A0"
                    }
                },
                "korean 4-0-8": {
                    name: {
                        en: "Buddha's Birthday",
                        ko: "\uC11D\uAC00\uD0C4\uC2E0\uC77C"
                    }
                },
                "06-06": {
                    name: {
                        en: "Memorial Day",
                        ko: "\uD604\uCDA9\uC77C"
                    }
                },
                "07-17": {
                    _name: "Constitution Day",
                    type: "observance"
                },
                "08-15": {
                    name: {
                        en: "Liberation Day",
                        ko: "\uAD11\uBCF5\uC808"
                    }
                },
                "korean 8-0-15 P3D": {
                    name: {
                        en: "Korean Thanksgiving",
                        ko: "\uCD94\uC11D"
                    }
                },
                "10-03": {
                    name: {
                        en: "National Foundation Day",
                        ko: "\uAC1C\uCC9C\uC808"
                    }
                },
                "10-09": {
                    name: {
                        en: "Hangul Day",
                        ko: "\uD55C\uAE00\uB0A0"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        KY: {
            names: {
                en: "Cayman Islands"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Panama"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "4th Monday in January": {
                    name: {
                        en: "National Heroes Day"
                    }
                },
                "easter -46": {
                    _name: "easter -46"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "3rd Monday in May": {
                    name: {
                        en: "Discovery Day"
                    }
                },
                "07-02": {
                    name: {
                        en: "Constitution Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "2017-05-24": {
                    name: "General Election Day"
                },
                "2021-04-14": {
                    name: "General Election Day"
                },
                "2016-06-13": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2017-06-19": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2018-06-11": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2019-06-10": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2020-06-15": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2021-06-14": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2022-06-20": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2023-06-19": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2024-06-17": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2025-06-16": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "2026-06-15": {
                    name: {
                        en: "Queen's Birthday"
                    }
                }
            }
        },
        LC: {
            names: {
                en: "St. Lucia"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    name: {
                        en: "Second New Year's Day"
                    }
                },
                "02-22": {
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "1st Friday after 07-10 P4D": {
                    name: {
                        en: "Carnival"
                    }
                },
                "08-01": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "1st Monday in October": {
                    name: {
                        en: "Thanksgiving"
                    }
                },
                "12-13": {
                    name: {
                        en: "National Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        LI: {
            names: {
                de: "Lichtenstein",
                en: "Lichtenstein"
            },
            dayoff: "sunday",
            langs: [
                "de"
            ],
            zones: [
                "Europe/Zurich"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    name: {
                        de: "Berchtoldstag",
                        en: "Berchtold Day"
                    },
                    type: "bank"
                },
                "01-06": {
                    _name: "01-06"
                },
                "02-02": {
                    _name: "02-02",
                    type: "observance"
                },
                "03-19": {
                    _name: "03-19",
                    type: "observance"
                },
                "easter -47": {
                    _name: "easter -47",
                    type: "bank"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39",
                    name: {
                        de: "Auffahrt"
                    }
                },
                "easter 40": {
                    name: {
                        de: "Feiertagsbr\xfccke"
                    }
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "easter 61": {
                    name: {
                        de: "Feiertagsbr\xfccke"
                    }
                },
                "08-15": {
                    name: {
                        de: "Staatsfeiertag"
                    },
                    type: "observance"
                },
                "09-08": {
                    name: {
                        de: "Mari\xe4 Geburt"
                    }
                },
                "11-01": {
                    _name: "11-01",
                    type: "observance"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-24": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        de: "Stephanstag"
                    }
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        LR: {
            names: {
                en: "Liberia"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Monrovia"
            ],
            dayoff: "Sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-11": {
                    name: {
                        en: "Armed Forces Day"
                    }
                },
                "2nd Wednesday in March": {
                    name: {
                        en: "Decoration Day"
                    }
                },
                "03-15": {
                    name: {
                        en: "J. J. Robert's Day"
                    }
                },
                "2nd Friday in April": {
                    name: {
                        en: "Fast and Prayer Day"
                    }
                },
                "05-14": {
                    name: {
                        en: "National Unification Day"
                    }
                },
                "07-26": {
                    _name: "Independence Day"
                },
                "08-24": {
                    name: {
                        en: "Flag Day"
                    }
                },
                "1st Thursday in November": {
                    name: {
                        en: "Thanksgiving"
                    }
                },
                "11-29": {
                    name: {
                        en: "William Tubman's Birthday"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        LS: {
            names: {
                st: "\\'Muso oa Lesotho",
                en: "Lesotho"
            },
            langs: [
                "st",
                "en"
            ],
            zones: [
                "Africa/Johannesburg"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-11": {
                    name: {
                        en: "Moshoeshoe Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Workers' Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "05-25": {
                    name: {
                        en: "Africa Day/ Heroes' Day"
                    }
                },
                "07-17": {
                    name: {
                        en: "King Letsie III's Birthday"
                    }
                },
                "10-04": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        LT: {
            names: {
                lt: "Lietuva",
                en: "Lithuania"
            },
            dayoff: "sunday",
            langs: [
                "lt"
            ],
            zones: [
                "Europe/Vilnius"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-16": {
                    name: {
                        en: "Day of Restoration of the State of Lithuania",
                        lt: "Lietuvos valstyb\u0117s atk\u016Brimo diena"
                    }
                },
                "03-11": {
                    name: {
                        en: "Day of Restoration of Independence of Lithuania",
                        lt: "Lietuvos nepriklausomyb\u0117s atk\u016Brimo diena"
                    }
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "1st sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "06-24": {
                    name: {
                        en: "St. John's Day",
                        lt: "Jonin\u0117s, Rasos"
                    }
                },
                "07-06": {
                    name: {
                        en: "Statehood Day",
                        lt: "Valstyb\u0117s diena"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-02": {
                    _name: "11-02",
                    active: [
                        {
                            from: 2020
                        }
                    ]
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        LU: {
            names: {
                fr: "Luxembourg",
                en: "Luxembourg",
                de: "Luxemburg",
                lb: "L\xebtzebuerg",
                pt: "Luxemburgo"
            },
            langs: [
                "fr",
                "de",
                "lb"
            ],
            zones: [
                "Europe/Luxembourg"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-23": {
                    _name: "National Holiday",
                    active: [
                        {
                            from: "1947-08-08",
                            to: "1961-12-23"
                        }
                    ]
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1",
                    active: [
                        {
                            from: "1892-02-16"
                        }
                    ]
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        fr: "1er mai"
                    },
                    active: [
                        {
                            from: "1946-04-23"
                        }
                    ]
                },
                "05-09": {
                    _name: "05-09",
                    active: [
                        {
                            from: "2019-01-01"
                        }
                    ]
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50",
                    active: [
                        {
                            from: "1892-02-16"
                        }
                    ]
                },
                "06-23": {
                    _name: "National Holiday",
                    active: [
                        {
                            from: "1961-12-23"
                        }
                    ]
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    active: [
                        {
                            from: "1892-02-16"
                        }
                    ]
                }
            }
        },
        LV: {
            names: {
                lv: "Latvija",
                en: "Latvia"
            },
            dayoff: "sunday",
            langs: [
                "lv"
            ],
            zones: [
                "Europe/Riga"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-04 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Restoration of Independence day",
                        lv: "Latvijas Republikas Neatkar\u012Bbas atjauno\u0161anas diena"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-23": {
                    name: {
                        en: "Midsummer Eve",
                        lv: "L\u012Bgo Diena"
                    }
                },
                "06-24": {
                    name: {
                        en: "Midsummer",
                        lv: "J\u0101\u0146i"
                    }
                },
                "11-18 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Republic Day",
                        lv: "Latvijas Republikas proklam\u0113\u0161anas diena"
                    }
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31": {
                    _name: "12-31"
                },
                "2023-05-29": {
                    name: {
                        en: "Bronze medal of the Latvian hockey team at the 2023 World Hockey Championship",
                        lv: "Latvijas hokeja komandas 2023. gada Pasaules hokeja \u010Dempion\u0101t\u0101 bronzas meda\u013Ca"
                    }
                }
            }
        },
        LY: {
            names: {
                ar: "\u062F\u0648\u0644\u0629 \u0644\u064A\u0628\u064A\u0627",
                en: "Libya"
            },
            langs: [
                "ar"
            ],
            zones: [
                "Africa/Tripoli"
            ],
            dayoff: "",
            days: {
                "02-17": {
                    _name: "Revolution Day"
                },
                "05-01": {
                    _name: "05-01"
                },
                "09-16": {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u0634\u0647\u062F\u0627\u0621",
                        en: "Martyrs' Day"
                    }
                },
                "10-23": {
                    _name: "Liberation Day"
                },
                "12-24": {
                    _name: "Independence Day"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "9 Dhu al-Hijjah": {
                    _name: "9 Dhu al-Hijjah"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        MA: {
            names: {
                ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629",
                fr: "Royaume du Maroc",
                en: "Kingdom of Morocco"
            },
            langs: [
                "ar",
                "ber",
                "fr"
            ],
            zones: [
                "Africa/Casablanca"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-11": {
                    name: {
                        fr: "Manifeste de l'ind\xe9pendance",
                        ar: "\u0630\u0643\u0631\u0649 \u062A\u0642\u062F\u064A\u0645 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0627\u0633\u062A\u0642\u0644\u0627\u0644",
                        en: "Anniversary of the Independence Manifesto"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-30": {
                    name: {
                        fr: "F\xeate du tr\xf4ne",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0639\u0631\u0634",
                        en: "Feast of the Throne"
                    }
                },
                "08-14": {
                    name: {
                        fr: "Journ\xe9e de Oued Ed-Dahab",
                        ar: "\u064A\u0648\u0645 \u0648\u0627\u062F\u064A \u0627\u0644\u0630\u0647\u0628",
                        en: "Anniversary of the Recovery Oued Ed-Dahab"
                    }
                },
                "08-20": {
                    name: {
                        fr: "F\xeate de la r\xe9volution du roi et du peuple",
                        ar: "\u062B\u0648\u0631\u0629 \u0627\u0644\u0645\u0644\u0643 \u0648\u0627\u0644\u0634\u0639\u0628",
                        en: "Anniversary of the Revolution of the King and the People"
                    }
                },
                "08-21": {
                    name: {
                        fr: "Journ\xe9e de la jeunesse",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0628\u0627\u0628",
                        en: "Youth Day"
                    }
                },
                "11-06": {
                    name: {
                        fr: "La Marche verte",
                        ar: "\u0627\u0644\u0645\u0633\u064A\u0631\u0629 \u0627\u0644\u062E\u0636\u0631\u0627\u0621",
                        en: "Anniversary of the Green March"
                    }
                },
                "11-18": {
                    _name: "Independence Day",
                    name: {
                        fr: "F\xeate de l'ind\xe9pendance"
                    }
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        MC: {
            names: {
                fr: "Monaco",
                en: "Monaco"
            },
            dayoff: "sunday",
            langs: [
                "fr"
            ],
            zones: [
                "Europe/Monaco"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-27 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Saint Devota's Day",
                        fr: "Sainte D\xe9vote"
                    }
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01",
                    name: {
                        fr: "1er mai"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-19 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "H.S.H. the Sovereign Prince's Day",
                        fr: "La F\xeate du Prince"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                }
            }
        },
        MD: {
            names: {
                ro: "Republica Moldova",
                en: "Moldova"
            },
            langs: [
                "ro"
            ],
            zones: [
                "Europe/Chisinau"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "julian 12-25 P2D": {
                    _name: "julian 12-25",
                    name: {
                        ro: "Craciun pe Rit Vechi"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "orthodox 8": {
                    name: {
                        ro: "Pa\u015Ftele Bl\u0103jinilor",
                        en: "Memorial Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-09": {
                    name: {
                        ro: "Ziua Victoriei",
                        en: "Victory Day"
                    }
                },
                "08-27": {
                    _name: "Independence Day"
                },
                "08-31": {
                    name: {
                        ro: "Limba noastr\u0103",
                        en: "National Language Day"
                    }
                },
                "1st saturday in October P2D": {
                    name: {
                        ro: "Ziua vinului",
                        en: "Wine Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2013
                        }
                    ]
                },
                "12-25": {
                    _name: "12-25",
                    name: {
                        ro: "Craciun pe stil Nou"
                    }
                }
            },
            states: {
                CA: {
                    name: "Cahul",
                    days: {
                        "11-21": {
                            name: {
                                ro: "Ziua Cahul",
                                en: "Cahul Day"
                            }
                        }
                    }
                },
                CU: {
                    name: "Chi\u0219in\u0103u",
                    days: {
                        "10-14": {
                            name: {
                                ro: "Ziua capitalului",
                                en: "Capital's Day"
                            }
                        }
                    }
                }
            }
        },
        ME: {
            names: {
                hr: "Crna Gora",
                sr: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
                bs: "Crna Gora",
                sq: "Mali i Zi",
                en: "Montenegro"
            },
            dayoff: "sunday",
            langs: [
                "hr",
                "sr",
                "bs",
                "sq"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            days: {
                "05-21 and if sunday then next tuesday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "05-22 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "07-13 and if sunday then next tuesday": {
                    substitute: true,
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438",
                        en: "Statehood Day"
                    }
                },
                "07-14 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438",
                        en: "Statehood Day"
                    }
                },
                "01-01 and if sunday then next tuesday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-02 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "05-01 and if sunday then next tuesday": {
                    substitute: true,
                    _name: "05-01"
                },
                "05-02 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "julian 12-24": {
                    _name: "12-24"
                },
                "julian 12-25": {
                    _name: "12-25"
                },
                "julian 12-26": {
                    _name: "12-26"
                },
                "julian 01-01": {
                    _name: "julian 01-01",
                    type: "observance"
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-25"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter"
                },
                "08-15": {
                    _name: "08-15",
                    type: "observance"
                },
                "11-01": {
                    _name: "11-01"
                },
                "1 Shawwal P3D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                },
                "1 Muharram": {
                    _name: "1 Muharram",
                    type: "observance"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal",
                    type: "observance"
                },
                "27 Rajab": {
                    _name: "27 Rajab",
                    type: "observance"
                },
                "15 Shaban": {
                    _name: "15 Shaban",
                    type: "observance"
                },
                "1 Ramadan": {
                    _name: "1 Ramadan",
                    type: "observance"
                },
                "27 Ramadan": {
                    _name: "27 Ramadan",
                    type: "observance"
                },
                "15 Nisan P2D": {
                    _name: "15 Nisan"
                },
                "1 Tishrei": {
                    _name: "1 Tishrei",
                    type: "observance"
                },
                "10 Tishrei P2D": {
                    _name: "10 Tishrei"
                }
            }
        },
        MF: {
            names: {
                en: "St. Martin",
                fr: "Saint Martin"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/Marigot"
            ],
            dayoff: "sunday",
            _days: "FR",
            days: {
                "05-27": {
                    name: {
                        fr: "Abolition de l'esclavage",
                        en: "abolition of slavery"
                    }
                }
            }
        },
        MG: {
            names: {
                mg: "Repoblikan'i Madagasikara",
                fr: "R\xe9publique de Madagascar",
                en: "Madagascar"
            },
            dayoff: "sunday",
            langs: [
                "mg",
                "fr",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-08": {
                    name: {
                        mg: "Andro iraisam-pirenena ho an'ny vehivavy",
                        fr: "Journ\xe9e internationale de la femme",
                        en: "International Women's Day"
                    },
                    note: "only for women"
                },
                "03-29": {
                    name: {
                        mg: "Martioran'ny tolona tamin'ny 1947",
                        fr: "Comm\xe9moration des martyrs de l'insurrection de 1947.",
                        en: "Martyrs' Day"
                    }
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-25": {
                    name: {
                        mg: "Andron'i Afrika",
                        fr: "Jour de l'Afrique",
                        en: "Africa Day"
                    }
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-26": {
                    _name: "Independence Day",
                    name: {
                        mg: "Fetim-pirenena",
                        fr: "F\xeate Nationale"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    note: "For Muslim"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    note: "For Muslim"
                }
            }
        },
        MK: {
            names: {
                mk: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
                en: "Macedonia"
            },
            langs: [
                "mk"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "julian 12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "julian 12-25"
                },
                orthodox: {
                    _name: "orthodox"
                },
                "orthodox 1": {
                    _name: "orthodox 1"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "05-24 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        mk: "\u0421\u0432. \u041A\u0438\u0440\u0438\u043B \u0438 \u041C\u0435\u0442\u043E\u0434\u0438\u0458",
                        en: "Saints Cyril and Methodius Day"
                    }
                },
                "08-02 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0442\u0430",
                        en: "Day of the Republic"
                    }
                },
                "09-08 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "10-11 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0432\u043E\u0441\u0442\u0430\u043D\u0438\u0435\u0442\u043E",
                        en: "Revolution Day"
                    }
                },
                "10-23 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0430\u0442\u0430 \u0440\u0435\u0432\u043E\u043B\u0443\u0446\u0438\u043E\u043D\u0435\u0440\u043D\u0430 \u0431\u043E\u0440\u0431\u0430",
                        en: "Day of the Macedonian Revolutionary Struggle"
                    }
                },
                "12-08 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        mk: "\u0421\u0432. \u041A\u043B\u0438\u043C\u0435\u043D\u0442 \u041E\u0445\u0440\u0438\u0434\u0441\u043A\u0438",
                        en: "Saint Clement of Ohrid Day"
                    }
                },
                "1 Shawwal and if sunday then next monday": {
                    substitute: true,
                    _name: "1 Shawwal"
                },
                "julian 12-24": {
                    _name: "julian 12-24",
                    type: "optional",
                    note: "Orthodox believers"
                },
                "julian 01-06": {
                    _name: "01-06",
                    type: "optional",
                    note: "Orthodox believers"
                },
                "orthodox -2": {
                    _name: "orthodox -2",
                    type: "optional",
                    note: "Orthodox believers"
                },
                "orthodox 47": {
                    name: {
                        mk: "\u043F\u0435\u0442\u043E\u043A \u043F\u0440\u0435\u0434 \u0414\u0443\u0445\u043E\u0432\u0434\u0435\u043D",
                        en: "Friday before Pentecost"
                    },
                    type: "optional",
                    note: "Orthodox believers"
                },
                "orthodox 49": {
                    _name: "easter 49",
                    type: "optional",
                    note: "Orthodox believers"
                },
                "julian 08-15": {
                    _name: "08-15",
                    type: "optional",
                    note: "Orthodox believers"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    type: "optional",
                    note: "Muslim believers"
                },
                "10 Tishrei": {
                    _name: "10 Tishrei",
                    type: "optional",
                    note: "Jewish believers"
                },
                "easter 1": {
                    _name: "easter 1",
                    type: "optional",
                    note: "Catholic believers"
                },
                "11-01": {
                    _name: "11-01",
                    type: "optional",
                    note: "Catholic believers"
                },
                "12-25": {
                    _name: "12-25",
                    type: "optional",
                    note: "Catholic believers"
                },
                "11-22": {
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0410\u043B\u0431\u0430\u043D\u0441\u043A\u0430\u0442\u0430 \u0430\u0437\u0431\u0443\u043A\u0430",
                        en: "Day of the Albanian Alphabet"
                    },
                    type: "optional",
                    note: "For members of the Albanian community"
                },
                "12-21": {
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0430 \u043D\u0430 \u0442\u0443\u0440\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A",
                        en: "Turkish Language Day"
                    },
                    type: "optional",
                    note: "For members of the the Turkish community"
                },
                "01-27": {
                    name: {
                        mk: "\u0421\u0432\u0435\u0442\u0438 \u0421\u0430\u0432\u0430",
                        en: "St. Sava"
                    },
                    type: "optional",
                    note: "For members of the Serbian community"
                },
                "04-08": {
                    name: {
                        mk: "\u041C\u0435\u0453\u0443\u043D\u0430\u0440\u043E\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0420\u043E\u043C\u0438\u0442\u0435",
                        en: "International Roma Day"
                    },
                    type: "optional",
                    note: "For members of the the Roma community"
                },
                "05-23": {
                    name: {
                        mk: "\u041D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0412\u043B\u0430\u0441\u0442\u0438\u0442\u0435",
                        en: "National Day of Authorities"
                    },
                    type: "optional",
                    note: "For members of the Vlach community"
                },
                "09-28": {
                    name: {
                        mk: "\u041C\u0435\u0453\u0443\u043D\u0430\u0440\u043E\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0411\u043E\u0448\u045A\u0430\u0446\u0438\u0442\u0435",
                        en: "International Day of Bosniaks"
                    },
                    type: "optional",
                    note: "For Members of the Bosniak community."
                }
            }
        },
        ML: {
            names: {
                fr: "R\xe9publique du Mali",
                en: "Republic of Mali"
            },
            langs: [
                "fr",
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-20": {
                    name: {
                        fr: "F\xeate de l'arm\xe9e",
                        en: "Army Day"
                    }
                },
                "03-26": {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        en: "Martyrs' Day"
                    }
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "05-25": {
                    name: "Jour de l'Afrique"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "09-22": {
                    _name: "Independence Day",
                    name: {
                        fr: "F\xeate nationale de l'ind\xe9pendance"
                    }
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                }
            }
        },
        MQ: {
            names: {
                fr: "Martinique",
                en: "Martinique"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/Martinique"
            ],
            dayoff: "sunday",
            _days: "FR",
            days: {
                "easter -2": {
                    _name: "easter -2"
                },
                "05-22": {
                    _name: "Abolition of Slavery"
                },
                "07-21": {
                    name: {
                        fr: "Jour de Victor Schoelcher",
                        en: "Victor Shoelcher Day"
                    }
                }
            }
        },
        MR: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0627\u0644\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0629",
                en: "Mauritania"
            },
            langs: [
                "ar",
                "fr"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-25": {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0641\u0631\u064A\u0642\u064A\u0627",
                        en: "Africa Day"
                    }
                },
                "11-28": {
                    _name: "Independence Day"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        MS: {
            names: {
                en: "Montserrat"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "01-01"
                },
                "03-17 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Saint Patrick's Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1st Monday in May": {
                    _name: "05-01"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "2nd Monday after 06-02": {
                    name: {
                        en: "Queen's Birthday Celebration"
                    }
                },
                "08-01 if Saturday, Sunday then next Monday": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-26"
                },
                "12-31 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-31",
                    name: {
                        en: "Festival Day"
                    }
                }
            }
        },
        MT: {
            names: {
                mt: "Malta",
                en: "Malta"
            },
            dayoff: "sunday",
            langs: [
                "mt"
            ],
            zones: [
                "Europe/Malta"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-10": {
                    name: {
                        en: "Feast of Saint Paul's Shipwreck in Malta",
                        mt: "Nawfra\u0121ju ta' San Pawl"
                    }
                },
                "03-19": {
                    _name: "03-19"
                },
                "03-31": {
                    name: {
                        en: "Freedom Day",
                        mt: "Jum il-\u0126elsien"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-07": {
                    name: {
                        mt: "Sette Giugno",
                        en: "June 7th"
                    }
                },
                "06-29": {
                    _name: "06-29"
                },
                "08-15": {
                    _name: "08-15"
                },
                "09-08": {
                    name: {
                        en: "Victory Day",
                        mt: "Jum il-Vitorja"
                    }
                },
                "09-21": {
                    _name: "Independence Day"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-13": {
                    name: {
                        en: "Republic Day",
                        mt: "Jum ir-Repubblika"
                    }
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        MW: {
            names: {
                en: "Malawi"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-15 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "John Chilembwe Day"
                    }
                },
                "03-03 and if saturday,sunday then next monday": {
                    name: {
                        en: "Martyrs' Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if saturday,sunday then next monday": {
                    _name: "05-01"
                },
                "05-14 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Kamuzu Day"
                    }
                },
                "07-06 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "10-15 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "Mothers Day"
                },
                "12-25 and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "1 Shawwal and if saturday,sunday then next monday": {
                    substitute: true,
                    _name: "1 Shawwal",
                    name: {
                        en: "Eid al Fitri"
                    }
                }
            }
        },
        MX: {
            names: {
                es: "M\xe9xico",
                en: "Mexico"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Mexico_City",
                "America/Cancun",
                "America/Merida",
                "America/Monterrey",
                "America/Matamoros",
                "America/Mazatlan",
                "America/Chihuahua",
                "America/Ojinaga",
                "America/Hermosillo",
                "America/Tijuana",
                "America/Santa_Isabel",
                "America/Bahia_Banderas"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-05": {
                    _name: "Constitution Day"
                },
                "1st monday in February": {
                    name: {
                        en: "Constitution Day (day off)",
                        es: "D\xeda de la Constituci\xf3n (d\xeda libre)"
                    }
                },
                "03-21": {
                    name: {
                        en: "Benito Ju\xe1rez's birthday",
                        es: "Natalicio de Benito Ju\xe1rez"
                    }
                },
                "3rd monday in March": {
                    name: {
                        en: "Benito Ju\xe1rez's birthday (day off)",
                        es: "Natalicio de Benito Ju\xe1rez (d\xeda libre)"
                    }
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "bank"
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "bank"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-10": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "09-16": {
                    _name: "Independence Day"
                },
                "11-02": {
                    _name: "11-02",
                    type: "bank"
                },
                "11-20": {
                    _name: "Revolution Day"
                },
                "3rd monday in November": {
                    name: {
                        en: "Revolution Day (day off)",
                        es: "D\xeda de la Revoluci\xf3n (d\xeda libre)"
                    }
                },
                "12-01 every 6 years since 1934": {
                    name: {
                        en: "Change of Federal Government",
                        es: "Transmisi\xf3n del Poder Ejecutivo Federal"
                    }
                },
                "12-12": {
                    name: {
                        en: "Day of the Virgin of Guadalupe",
                        es: "D\xeda de la Virgen de Guadalupe"
                    },
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        MY: {
            names: {
                en: "Malaysia"
            },
            langs: [
                "ms"
            ],
            zones: [
                "Asia/Kuala_Lumpur",
                "Asia/Kuching"
            ],
            dayoff: "Saturday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Chinese New Year",
                        ms: "Tahun Baru Cina"
                    }
                },
                "chinese 01-0-02": {
                    name: {
                        en: "Chinese New Year",
                        ms: "Tahun Baru Cina"
                    }
                },
                "substitutes chinese 01-0-01 if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Chinese New Year",
                        ms: "Tahun Baru Cina"
                    }
                },
                "substitutes chinese 01-0-02 if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Chinese New Year",
                        ms: "Tahun Baru Cina"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "substitutes 05-01 if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "1st Monday in June": {
                    name: {
                        en: "Yang di-Pertuan Agong's Birthday",
                        ms: "Hari Keputeraan Yang di-Pertuan Agong"
                    }
                },
                "08-31": {
                    _name: "Independence Day"
                },
                "substitutes 08-31 if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "09-16": {
                    name: {
                        en: "Malaysia Day",
                        ms: "Hari Malaysia"
                    }
                },
                "substitutes 09-16 if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Malaysia Day",
                        ms: "Hari Malaysia"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "17 Ramadan": {
                    _name: "17 Ramadan",
                    disable: [
                        "2022-04-18"
                    ],
                    enable: [
                        "2022-04-19"
                    ]
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    disable: [
                        "2022-05-02"
                    ],
                    enable: [
                        "2022-05-03"
                    ]
                },
                "2 Shawwal": {
                    _name: "1 Shawwal",
                    disable: [
                        "2022-05-03"
                    ],
                    enable: [
                        "2022-05-04"
                    ]
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    disable: [
                        "2022-07-09"
                    ],
                    enable: [
                        "2022-07-10"
                    ]
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal",
                    disable: [
                        "2022-10-08"
                    ],
                    enable: [
                        "2022-10-09"
                    ]
                },
                "2010-05-28": {
                    _name: "Vesak"
                },
                "2011-05-17": {
                    _name: "Vesak"
                },
                "2012-05-06": {
                    _name: "Vesak"
                },
                "2013-05-25": {
                    _name: "Vesak"
                },
                "2014-05-15": {
                    _name: "Vesak"
                },
                "2015-06-02": {
                    _name: "Vesak"
                },
                "2016-05-22": {
                    _name: "Vesak"
                },
                "2017-05-10": {
                    _name: "Vesak"
                },
                "2018-05-29": {
                    _name: "Vesak"
                },
                "2019-05-19": {
                    _name: "Vesak"
                },
                "2020-05-07": {
                    _name: "Vesak"
                },
                "2021-05-26": {
                    _name: "Vesak"
                },
                "2022-05-15": {
                    _name: "Vesak"
                },
                "2022-05-16": {
                    substitute: true,
                    _name: "Vesak"
                },
                "2023-05-04": {
                    _name: "Vesak"
                },
                "2024-05-22": {
                    _name: "Vesak"
                },
                "2025-05-12": {
                    _name: "Vesak"
                },
                "2026-05-31": {
                    _name: "Vesak"
                },
                "2016-10-29": {
                    _name: "Deepavali"
                },
                "2017-10-18": {
                    _name: "Deepavali"
                },
                "2018-11-06": {
                    _name: "Deepavali"
                },
                "2019-10-27": {
                    _name: "Deepavali"
                },
                "2019-10-28": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2020-11-14": {
                    _name: "Deepavali"
                },
                "2021-11-04": {
                    _name: "Deepavali"
                },
                "2022-10-24": {
                    _name: "Deepavali"
                },
                "2023-11-12": {
                    _name: "Deepavali"
                },
                "2023-11-13": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2024-10-31": {
                    _name: "Deepavali"
                },
                "2025-10-20": {
                    _name: "Deepavali"
                },
                "2026-11-09": {
                    _name: "Deepavali"
                },
                "2027-10-28": {
                    _name: "Deepavali"
                },
                "2028-11-15": {
                    _name: "Deepavali"
                },
                "2029-11-05": {
                    _name: "Deepavali"
                },
                "2030-10-25": {
                    _name: "Deepavali"
                }
            },
            states: {
                10: {
                    name: "Selangor",
                    days: {
                        "12-11": {
                            name: {
                                en: "Sultan of Selangor's Birthday",
                                id: "Hari Keputeraan Sultan Selangor"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                11: {
                    name: "Terengganu",
                    days: {
                        "01-01": false,
                        "03-04": {
                            name: {
                                en: "Anniversary of Installation of the Sultan of Terengganu",
                                ms: "Hari Ulang Tahun Pertabalan Sultan Terengganu"
                            }
                        },
                        "04-26": {
                            name: {
                                en: "Sultan of Terengganu's Birthday",
                                ms: "Hari Keputeraan Sultan Terengganu"
                            }
                        },
                        "27 Rajab": {
                            _name: "27 Rajab"
                        },
                        "9 Dhu al-Hijjah": {
                            _name: "9 Dhu al-Hijjah"
                        },
                        "11 Dhu al-Hijjah": {
                            _name: "10 Dhu al-Hijjah"
                        }
                    }
                },
                12: {
                    name: "Sabah",
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "05-30": {
                            name: {
                                en: "Tadau Kaamatan",
                                ms: "Pesta Kaamatan"
                            }
                        },
                        "05-31": {
                            name: {
                                en: "Tadau Kaamatan",
                                ms: "Pesta Kaamatan"
                            }
                        },
                        "1st Saturday in October": {
                            name: {
                                en: "Sabah State Governor's Birthday",
                                ms: "Hari Jadi Yang di-Pertua Negeri Sabah"
                            }
                        },
                        "12-24": {
                            _name: "12-24"
                        },
                        "17 Ramadan": false
                    }
                },
                13: {
                    name: "Sarawak",
                    days: {
                        "2016-10-29": false,
                        "2017-10-18": false,
                        "2018-11-06": false,
                        "2019-10-27": false,
                        "2020-11-14": false,
                        "2021-11-04": false,
                        "2022-10-24": false,
                        "2023-11-13": false,
                        "2024-10-31": false,
                        "2025-10-20": false,
                        "2026-11-09": false,
                        "2027-10-28": false,
                        "2028-11-15": false,
                        "2029-11-05": false,
                        "2030-10-25": false,
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "06-01": {
                            name: {
                                en: "Gawai Dayak",
                                ms: "Perayaan Hari Gawai Dayak"
                            }
                        },
                        "06-02": {
                            name: {
                                en: "Gawai Dayak",
                                ms: "Perayaan Hari Gawai Dayak"
                            }
                        },
                        "07-22": {
                            name: {
                                en: "Sarawak Independence Day",
                                ms: "Hari Kemerdekaan Sarawak"
                            }
                        },
                        "2nd Saturday in October": {
                            name: {
                                en: "Sarawak State Governor's Birthday",
                                ms: "Hari Jadi Yang di-Pertua Negeri Sarawak"
                            }
                        },
                        "17 Ramadan": false
                    }
                },
                14: {
                    name: "Kuala Lumpur",
                    days: {
                        "02-01": {
                            name: {
                                en: "Federal Territory Day",
                                ms: "Hari Wilayah Persekutuan"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                15: {
                    name: "Labuan",
                    days: {
                        "02-01": {
                            name: {
                                en: "Federal Territory Day",
                                ms: "Hari Wilayah Persekutuan"
                            }
                        },
                        "05-30": {
                            name: {
                                en: "Tadau Kaamatan",
                                ms: "Pesta Kaamatan"
                            }
                        },
                        "05-31": {
                            name: {
                                en: "Tadau Kaamatan",
                                ms: "Pesta Kaamatan"
                            }
                        }
                    }
                },
                16: {
                    name: "Putrajaya",
                    days: {
                        "02-01": {
                            name: {
                                en: "Federal Territory Day",
                                ms: "Hari Wilayah Persekutuan"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "01": {
                    name: "Johor",
                    days: {
                        "01-01": false,
                        "03-23": {
                            name: {
                                en: "Sultan of Johor's Birthday",
                                ms: "Hari Keputeraan Sultan Johor"
                            }
                        },
                        "1 Ramadan": {
                            _name: "1 Ramadan"
                        },
                        "17 Ramadan": false,
                        "6 Safar": {
                            name: {
                                en: "Hari Hol of Sultan Iskandar of Johor",
                                ms: "Hari Hol Almarhum Sultan Iskandar"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "02": {
                    name: "Kedah",
                    days: {
                        "01-01": false,
                        "3rd Sunday in June": {
                            name: {
                                en: "Sultan of Kedah's Birthday",
                                ms: "Hari Keputeraan Sultan Kedah"
                            }
                        },
                        "27 Rajab": {
                            _name: "27 Rajab"
                        },
                        "1 Ramadan": {
                            _name: "1 Ramadan"
                        },
                        "17 Ramadan": false,
                        "11 Dhu al-Hijjah": {
                            _name: "10 Dhu al-Hijjah"
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "03": {
                    name: "Kelantan",
                    days: {
                        "01-01": false,
                        "11 Dhu al-Hijjah": {
                            _name: "10 Dhu al-Hijjah"
                        },
                        "11-11": {
                            name: {
                                en: "Sultan of Kelantan's Birthday",
                                ms: "Hari Keputeraan Sultan Kelantan"
                            }
                        },
                        "11-12": {
                            name: {
                                en: "Sultan of Kelantan's Birthday",
                                ms: "Hari Keputeraan Sultan Kelantan"
                            }
                        }
                    }
                },
                "04": {
                    name: "Malacca",
                    days: {
                        "04-15": {
                            name: {
                                en: "Declaration of Malacca City as Historical City",
                                ms: "Hari Perisytiharan Bandar Melaka sebagai Bandaraya Bersejarah"
                            }
                        },
                        "08-24": {
                            name: {
                                en: "Melaka State Governor's Birthday",
                                ms: "Hari Jadi Yang di-Pertua Negeri Melaka"
                            }
                        },
                        "1 Ramadan": {
                            _name: "1 Ramadan"
                        },
                        "17 Ramadan": false
                    }
                },
                "05": {
                    name: "Negeri Sembilan",
                    days: {
                        "01-14": {
                            name: {
                                en: "Yang di-Pertuan Besar of Negeri Sembilan's Birthday",
                                ms: "Hari Keputeraan Yang di-Pertuan Besar Negeri Sembilan"
                            }
                        },
                        "27 Rajab": {
                            _name: "27 Rajab"
                        },
                        "17 Ramadan": false,
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "06": {
                    name: "Pahang",
                    days: {
                        "05-22": {
                            name: {
                                en: "Hari Hol of Pahang",
                                ms: "Hari Hol Pahang"
                            }
                        },
                        "07-30": {
                            name: {
                                en: "Sultan of Pahang's Birthday",
                                ms: "Hari Keputeraan Sultan Pahang"
                            }
                        }
                    }
                },
                "07": {
                    name: "Penang",
                    days: {
                        "07-07": {
                            name: {
                                en: "Declaration of George Town as World Heritage Site",
                                id: "Hari Ulang Tahun Perisytiharan Tapak Warisan Dunia"
                            }
                        },
                        "2nd Saturday in July": {
                            name: {
                                en: "Penang State Governor's Birthday",
                                ms: "Hari Jadi Yang di-Pertua Negeri Pulau Pinang"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "08": {
                    name: "Perak",
                    days: {
                        "1st Friday in November": {
                            name: {
                                en: "Sultan of Perak's Birthday",
                                ms: "Hari Keputeraan Sultan Perak"
                            }
                        },
                        "2016-01-24": {
                            _name: "Thaipusam"
                        },
                        "2017-02-10": {
                            _name: "Thaipusam"
                        },
                        "2018-01-31": {
                            _name: "Thaipusam"
                        },
                        "2019-01-21": {
                            _name: "Thaipusam"
                        },
                        "2020-02-08": {
                            _name: "Thaipusam"
                        },
                        "2021-01-28": {
                            _name: "Thaipusam"
                        },
                        "2022-01-18": {
                            _name: "Thaipusam"
                        },
                        "2023-02-05": {
                            _name: "Thaipusam"
                        },
                        "2024-01-25": {
                            _name: "Thaipusam"
                        },
                        "2025-02-11": {
                            _name: "Thaipusam"
                        },
                        "2026-02-01": {
                            _name: "Thaipusam"
                        }
                    }
                },
                "09": {
                    name: "Perlis",
                    days: {
                        "01-01": false,
                        "07-17": {
                            name: {
                                en: "Raja of Perlis's Birthday",
                                id: "Hari Keputeraan Raja Perlis"
                            }
                        },
                        "27 Rajab": {
                            _name: "27 Rajab"
                        },
                        "11 Dhu al-Hijjah": {
                            _name: "10 Dhu al-Hijjah"
                        }
                    }
                }
            }
        },
        MZ: {
            names: {
                pt: "Mo\xe7ambique",
                en: "Mozambique"
            },
            dayoff: "sunday",
            langs: [
                "pt"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    name: {
                        pt: "Dia da Fraternidade universal"
                    }
                },
                "substitutes 01-01 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "02-03": {
                    name: {
                        pt: "Dia dos her\xf3is mo\xe7ambicanos",
                        en: "Heroes\u2019 Day"
                    }
                },
                "substitutes 02-03 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "04-07": {
                    name: {
                        pt: "Dia da Mulher Mo\xe7ambicana",
                        en: "Women\u2019s Day"
                    }
                },
                "substitutes 04-07 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        pt: "Dia Internacional dos Trabalhadores",
                        en: "Workers' Day"
                    }
                },
                "substitutes 05-01 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-25": {
                    _name: "Independence Day",
                    name: {
                        pt: "Dia da Independ\xeancia Nacional"
                    }
                },
                "substitutes 06-25 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "09-07": {
                    name: {
                        pt: "Dia da Vit\xf3ria",
                        en: "Lusaka Peace Agreement"
                    }
                },
                "substitutes 09-07 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "09-25": {
                    name: {
                        pt: "Dia das For\xe7as Armadas de Liberta\xe7\xe3o Nacional",
                        en: "Defense Force\u2019s Day"
                    }
                },
                "substitutes 09-25 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "10-04": {
                    name: {
                        pt: "Dia da Paz e Reconcilia\xe7\xe3o",
                        en: "Peace and Reconciliation Day"
                    }
                },
                "substitutes 10-04 if sunday then next monday": {
                    _name: "Public Holiday"
                },
                "12-25": {
                    _name: "12-25",
                    name: {
                        pt: "Dia da Fam\xedlia",
                        en: "Family Day"
                    }
                },
                "substitutes 12-25 if sunday then next monday": {
                    _name: "Public Holiday"
                }
            }
        },
        NA: {
            names: {
                en: "Namibia"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Windhoek"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "03-21": {
                    _name: "Independence Day"
                },
                "substitutes 03-21 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Workers Day"
                    }
                },
                "substitutes 05-01 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "05-04": {
                    name: {
                        en: "Cassinga Day"
                    }
                },
                "substitutes 05-04 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "05-25": {
                    name: {
                        en: "Africa Day"
                    }
                },
                "substitutes 05-25 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "08-26": {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                "substitutes 08-26 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "12-10": {
                    name: {
                        en: "Human Rights Day"
                    }
                },
                "substitutes 12-10 if sunday then next monday": {
                    name: "Public Holiday"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        en: "Day of Goodwill"
                    }
                },
                "substitutes 12-26 if sunday then next monday": {
                    name: "Public Holiday"
                }
            }
        },
        NC: {
            names: {
                fr: "Nouvelle-Cal\xe9donie",
                en: "New Caledonia"
            },
            dayoff: "sunday",
            zones: [
                "Pacific/Noumea"
            ],
            langs: [
                "fr"
            ],
            _days: "FR",
            days: {
                "01-01": {
                    name: {
                        fr: "Jour de l'an"
                    }
                },
                "09-24": {
                    name: {
                        fr: "F\xeate de la Citonneyet\xe9",
                        en: "New Caledonia Day"
                    }
                }
            }
        },
        NE: {
            names: {
                fr: "R\xe9publique du Niger",
                en: "Republic of the Niger"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Lagos"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "04-24": {
                    name: {
                        fr: "Journ\xe9e Nationale de la Concorde",
                        en: "Concord Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-03": {
                    _name: "Independence Day",
                    name: {
                        fr: "Proclamation de l'ind\xe9pendance"
                    }
                },
                "12-18": {
                    name: {
                        fr: "Proclamation de la R\xe9publique",
                        en: "Republic Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "27 Ramadan": {
                    _name: "27 Ramadan"
                }
            }
        },
        NG: {
            names: {
                en: "Nigeria"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Lagos"
            ],
            dayoff: "Saturday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "05-01 and if Saturday then next Monday": {
                    substitute: true,
                    _name: "05-01",
                    name: {
                        en: "Worker's Day"
                    }
                },
                "05-27": {
                    name: {
                        en: "Children's Day",
                        type: "school"
                    }
                },
                "05-29 prior to 2018": {
                    name: {
                        en: "Democracy Day"
                    }
                },
                "06-12 prior to 2018": {
                    name: {
                        en: "M.K.O Abiola Day"
                    }
                },
                "06-12 and if Saturday then next Monday since 2018": {
                    substitute: true,
                    name: {
                        en: "Democracy Day"
                    }
                },
                "10-01": {
                    _name: "Independence Day"
                },
                "11-01 since 2020": {
                    name: {
                        en: "National Youth Day"
                    }
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P2D": {
                    _name: "1 Shawwal",
                    name: {
                        en: "Id el Fitr"
                    }
                },
                "10 Dhu al-Hijjah P2D": {
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Id el Kabir"
                    }
                }
            }
        },
        NI: {
            names: {
                es: "Nicaragua",
                en: "Nicaragua"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Managua"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-18": {
                    name: {
                        en: "Birthday of Rub\xe9n Dar\xedo",
                        es: "Natalicio de Rub\xe9n Dar\xedo"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-30": {
                    _name: "Mothers Day",
                    name: {
                        es: "D\xeda de la madre nicarag\xfcense"
                    },
                    type: "observance"
                },
                "06-01": {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del ni\xf1o"
                    }
                },
                "06-23": {
                    _name: "Fathers Day",
                    name: {
                        es: "D\xeda del padre nicarag\xfcense"
                    },
                    type: "observance"
                },
                "07-19": {
                    name: {
                        en: "Revolution Day",
                        es: "Triunfo de la Revoluci\xf3n Popular"
                    }
                },
                "09-14": {
                    name: {
                        en: "Battle of San Jacinto",
                        es: "Batalla de San Jacinto"
                    }
                },
                "09-15": {
                    _name: "Independence Day"
                },
                "10-12": {
                    name: {
                        en: "Indigenous Resistance Day",
                        es: "D\xeda de la resistencia ind\xedgena"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-24": {
                    _name: "12-24",
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                }
            }
        },
        NL: {
            names: {
                nl: "Nederland",
                en: "Netherlands"
            },
            dayoff: "sunday",
            langs: [
                "nl"
            ],
            zones: [
                "Europe/Amsterdam"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "school"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27 if sunday then previous saturday since 2014": {
                    name: {
                        nl: "Koningsdag",
                        en: "King's Day"
                    }
                },
                "04-30 if sunday then next monday since 1949 and prior to 1980": {
                    name: {
                        nl: "Koninginnedag",
                        en: "Queen's Day"
                    }
                },
                "04-30 if sunday then previous saturday since 1980 and prior to 2014": {
                    name: {
                        nl: "Koninginnedag",
                        en: "Queen's Day"
                    }
                },
                "05-04": {
                    name: {
                        nl: "Nationale Dodenherdenking"
                    },
                    type: "observance"
                },
                "05-05": {
                    name: {
                        nl: "Bevrijdingsdag",
                        en: "Liberation Day"
                    },
                    type: "school"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 39": {
                    _name: "easter 39",
                    name: {
                        nl: "Hemelvaartsdag"
                    }
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "08-31 since 1885 and prior to 1891": {
                    name: {
                        nl: "Princessedag",
                        en: "Princess Day"
                    }
                },
                "08-31 since 1891 and prior to 1949": {
                    name: {
                        nl: "Koninginnedag",
                        en: "Queen's Day"
                    }
                },
                "3rd tuesday in September": {
                    name: {
                        nl: "Prinsjesdag",
                        en: "Prince's Day"
                    },
                    note: "Scholen in Den Haag geven meestal 1 dag vrij",
                    type: "observance"
                },
                "11-11": {
                    _name: "11-11",
                    type: "observance"
                },
                "12-05": {
                    name: {
                        nl: "Sinterklaasavond",
                        en: "St Nicholas' Eve"
                    },
                    type: "observance"
                },
                "12-15": {
                    name: {
                        nl: "Koninkrijksdag",
                        en: "Kingdom Day"
                    },
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        NO: {
            names: {
                no: "Norge",
                en: "Norway"
            },
            dayoff: "sunday",
            langs: [
                "no"
            ],
            zones: [
                "Europe/Oslo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-21": {
                    name: {
                        no: "H.K.H. prinsesse Ingrid Alexandra",
                        en: "Birthday of Princess Ingrid Alexandra"
                    },
                    type: "observance"
                },
                "02-06": {
                    name: {
                        no: "Samefolkets dag",
                        en: "Day of the Sami people"
                    },
                    type: "observance"
                },
                "2nd sunday in February": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "02-14": {
                    _name: "02-14",
                    type: "observance"
                },
                "02-21": {
                    name: {
                        no: "H.M. kong Harald V",
                        en: "Birthday of King Harald V"
                    },
                    type: "observance"
                },
                "easter -49": {
                    name: {
                        no: "Fastelavn",
                        en: "Carnival"
                    },
                    type: "observance"
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "easter -7": {
                    _name: "easter -7",
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-01": {
                    _name: "04-01",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-08": {
                    _name: "Liberation Day",
                    type: "observance"
                },
                "05-17": {
                    _name: "Constitution Day"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-07": {
                    name: {
                        no: "Unionsoppl\xf8sningen",
                        en: "Union Dissolution Day"
                    },
                    type: "observance"
                },
                "06-23": {
                    name: {
                        no: "Sankthansaften",
                        en: "Midsummar Eve"
                    },
                    type: "observance"
                },
                "07-04": {
                    name: {
                        no: "H.M. dronning Sonja",
                        en: "Birthday of Queen Sonja"
                    },
                    type: "observance"
                },
                "07-20": {
                    name: {
                        no: "H.K.H. kronprins Haakon Magnus",
                        en: "Birthday of Crown Prince Haakon Magnus"
                    },
                    type: "observance"
                },
                "07-29": {
                    name: {
                        no: "Olsok",
                        en: "Olsok"
                    },
                    type: "optional"
                },
                "08-19": {
                    name: {
                        no: "H.K.H. kronprinsesse Mette-Marit",
                        en: "Birthday of Crown Princess Mette-Marit"
                    },
                    type: "observance"
                },
                "1st sunday in November": {
                    name: {
                        no: "Allehelgensaften",
                        en: "All Saints' Day"
                    },
                    type: "observance"
                },
                "2nd sunday in November": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "4th sunday before 12-25": {
                    name: {
                        no: "F\xf8rste s\xf8ndag i advent",
                        en: "First Sunday of Advent"
                    },
                    type: "observance"
                },
                "3rd sunday before 12-25": {
                    name: {
                        no: "Andre s\xf8ndag i advent",
                        en: "Second Sunday of Advent"
                    },
                    type: "observance"
                },
                "2nd sunday before 12-25": {
                    name: {
                        no: "Tredje s\xf8ndag i advent",
                        en: "Third Sunday of Advent"
                    },
                    type: "observance"
                },
                "1st sunday before 12-25": {
                    name: {
                        no: "Fjerde s\xf8ndag i advent",
                        en: "Fourth Sunday of Advent"
                    },
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31 14:00 if sunday then 00:00": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        NZ: {
            names: {
                en: "New Zealand",
                mi: "Aotearoa"
            },
            dayoff: "sunday",
            langs: [
                "en",
                "mi"
            ],
            zones: [
                "Pacific/Auckland",
                "Pacific/Chatham"
            ],
            days: {
                "01-01 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-02 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    name: {
                        en: "Day after New Year's Day"
                    }
                },
                "02-06 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Waitangi Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-25 and if saturday,sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "ANZAC Day"
                    }
                },
                "1st monday in June prior to 2023": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "1st monday in June since 2023": {
                    name: {
                        en: "King's Birthday"
                    }
                },
                "4th monday in October": {
                    _name: "05-01"
                },
                "12-25 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if saturday then next monday if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-26"
                },
                "2022-06-24": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2023-07-14": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2024-06-28": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2025-06-20": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2026-07-10": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2027-06-25": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2028-07-14": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2029-07-06": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2030-06-21": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2031-07-11": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2032-07-02": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2033-06-24": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2034-07-07": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2035-06-29": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2036-07-18": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2037-07-10": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2038-06-25": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2039-07-15": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2040-07-06": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2041-07-19": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2042-07-11": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2043-07-03": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2044-06-24": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2045-07-07": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2046-06-29": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2047-07-19": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2048-07-03": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2049-06-25": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2050-07-15": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2051-06-30": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2052-06-21": {
                    name: {
                        en: "Matariki"
                    }
                },
                "2022-09-26": {
                    name: {
                        en: "National Day of Mourning for Queen Elizabeth II"
                    }
                }
            },
            states: {
                AUK: {
                    names: {
                        en: "Auckland Province",
                        mi: "T\u0101maki-makau-rau"
                    },
                    days: {
                        "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                BOP: {
                    names: {
                        en: "Bay of Plenty",
                        mi: "Te Moana-a-Toi"
                    },
                    days: {
                        "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                CAN: {
                    names: {
                        en: "Canterbury",
                        mi: "Waitaha"
                    },
                    days: {
                        "friday after 2nd tuesday in November": {
                            name: {
                                en: "Christchurch Show Day"
                            },
                            note: "May differ in parts of North Canterbury"
                        }
                    },
                    regions: {
                        Timaru: {
                            name: "Timaru District",
                            days: {
                                "friday after 2nd tuesday in November": false,
                                "4th monday in September": {
                                    name: {
                                        en: "Dominion Day"
                                    }
                                }
                            }
                        }
                    }
                },
                CIT: {
                    names: {
                        en: "Chatham Islands",
                        mi: "Wharekauri"
                    },
                    days: {
                        "11-30 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                GIS: {
                    names: {
                        en: "Gisborne",
                        mi: "Te Tai R\u0101whiti"
                    },
                    days: {
                        "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                HKB: {
                    names: {
                        en: "Hawke's Bay",
                        mi: "Te Matau-a-M\u0101ui"
                    },
                    days: {
                        "friday before 4th monday in October": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                MBH: {
                    names: {
                        en: "Marlborough",
                        mi: "Te Tauihu-o-te-waka"
                    },
                    days: {
                        "5th monday in October": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                MWT: {
                    name: "Manawatu-Wanganui",
                    days: {
                        "01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                NSN: {
                    names: {
                        en: "Nelson",
                        mi: "Whakat\u016B"
                    },
                    days: {
                        "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                NTL: {
                    names: {
                        en: "Northland",
                        mi: "Te Tai Tokerau"
                    },
                    days: {
                        "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                OTA: {
                    names: {
                        en: "Otago Province",
                        mi: "\u014Ct\u0101kou"
                    },
                    days: {
                        "03-23 if Tuesday,Wednesday,Thursday then previous Monday if Friday,Saturday,Sunday then next Monday if is public holiday then next Monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                STL: {
                    names: {
                        en: "Southland",
                        mi: "Murihiku"
                    },
                    days: {
                        "easter 2": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                TAS: {
                    names: {
                        en: "Tasman",
                        mi: "Te Tai-o-Aorere"
                    },
                    days: {
                        "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                TKI: {
                    name: "Taranaki",
                    days: {
                        "2nd monday in March": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                WKO: {
                    name: "Waikato",
                    days: {
                        "01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                WGN: {
                    names: {
                        en: "Wellington Province",
                        mi: "Te Whanga-nui-a-Tara"
                    },
                    days: {
                        "01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    }
                },
                WTC: {
                    names: {
                        en: "Westland",
                        mi: "Te Tai Poutini"
                    },
                    days: {
                        "12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                            name: {
                                en: "Provincial anniversary day"
                            }
                        }
                    },
                    regions: {
                        Buller: {
                            name: "Buller district",
                            days: {
                                "12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": false,
                                "02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday": {
                                    name: {
                                        en: "Provincial anniversary day"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        PA: {
            names: {
                es: "Panam\xe1",
                en: "Panama"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Panama"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "01-09 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Martyrs' Day",
                        es: "D\xeda de los M\xe1rtires Ca\xeddos en la Gesta Patri\xf3tica"
                    }
                },
                "easter -48": {
                    _name: "easter -48",
                    type: "observance"
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "07-01 every 5 years since 2014": {
                    name: {
                        en: "Presidential Inauguration"
                    }
                },
                "11-03 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Separation Day (from Columbia)",
                        es: "D\xeda de la Separaci\xf3n (de Colombia)"
                    }
                },
                "11-10 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        es: "Primer Grito de Independencia"
                    }
                },
                "11-28 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "12-08 and if sunday then next monday": {
                    substitute: true,
                    _name: "Mothers Day"
                },
                "12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                }
            }
        },
        PE: {
            names: {
                es: "Per\xfa",
                en: "Peru"
            },
            dayoff: "sunday",
            langs: [
                "es",
                "qu"
            ],
            zones: [
                "America/Lima"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-29": {
                    _name: "06-29"
                },
                "07-28": {
                    _name: "Independence Day"
                },
                "07-29": {
                    _name: "Independence Day"
                },
                "08-30": {
                    name: {
                        en: "Santa Rosa de Lima",
                        es: "D\xeda de Santa Rosa de Lima"
                    }
                },
                "10-08": {
                    name: {
                        en: "Battle of Angamos",
                        es: "Combate de Angamos"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                }
            },
            regions: {
                CUS: {
                    name: "Cuzco",
                    days: {
                        "06-24": {
                            name: {
                                en: "Festival of the Sun",
                                es: "Fiesta Inca del Sol",
                                qu: "Inti Raymi"
                            },
                            type: "observance"
                        }
                    }
                }
            }
        },
        PH: {
            names: {
                en: "Philippines"
            },
            langs: [
                "en",
                "fil"
            ],
            zones: [
                "Asia/Manila"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-23": {
                    type: "observance",
                    name: {
                        en: "First Philippine Republic Day",
                        fil: "Araw ng Unang Republika ng Pilipinas"
                    }
                },
                "chinese 01-0-01": {
                    type: "optional",
                    name: {
                        en: "Chinese New Year",
                        fil: "Bagong Taon ng mga Tsino"
                    }
                },
                "02-02": {
                    type: "observance",
                    _name: "Constitution Day"
                },
                "chinese 01-0-15": {
                    type: "observance",
                    name: {
                        en: "Lantern Festival",
                        fil: "Piyesta ng mga Parol Tsino"
                    }
                },
                "02-25": {
                    name: {
                        en: "EDSA Revolution Anniversary",
                        fil: "Anibersaryo ng Rebolusyon sa EDSA"
                    },
                    type: "optional",
                    note: "Non-working Day"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1",
                    type: "optional",
                    note: "Non-working Day"
                },
                easter: {
                    _name: "easter"
                },
                "04-09": {
                    name: {
                        en: "Day of Valor",
                        fil: "Araw ng Kagitingan"
                    }
                },
                "04-27": {
                    type: "observance",
                    name: {
                        en: "Lapu-Lapu Day",
                        fil: "Araw ni Lapu-Lapu"
                    }
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Labour Day",
                        fil: "Araw ng mga Manggagawa"
                    }
                },
                "06-12": {
                    _name: "Independence Day"
                },
                "06-19": {
                    type: "observance",
                    name: {
                        en: "Jos\xe9 Rizal's birthday",
                        fil: "Araw ng Kapanganakan ni Jos\xe9 Rizal"
                    },
                    active: [
                        {
                            from: "1961-01-01T00:00:00.000Z"
                        }
                    ],
                    disable: [
                        "2011-06-19"
                    ]
                },
                "2011-06-19": {
                    name: {
                        en: "Jos\xe9 Rizal's birthday",
                        fil: "Araw ng Kapanganakan ni Jos\xe9 Rizal"
                    }
                },
                "07-27": {
                    type: "observance",
                    name: {
                        en: "Iglesia ni Cristo Day",
                        fil: "Araw ng Iglesia ni Cristo"
                    }
                },
                "08-21": {
                    name: {
                        en: "Ninoy Aquino Day",
                        fil: "Araw ng Kabayanihan ni Ninoy Aquino"
                    },
                    type: "optional",
                    note: "Non-working Day"
                },
                "1st monday before September": {
                    name: {
                        en: "National Heroes' Day",
                        fil: "Araw ng mga Bayani"
                    }
                },
                "chinese 08-0-15": {
                    type: "observance",
                    name: {
                        en: "Mid-Autumn Festival",
                        fil: "Piyestang Zh\u014Dngqi\u016B Ji\xe9"
                    }
                },
                "11-01": {
                    _name: "11-01",
                    type: "optional",
                    note: "Non-working Day"
                },
                "11-02": {
                    _name: "11-02",
                    type: "optional",
                    note: "Non-working Day"
                },
                "11-30": {
                    name: {
                        en: "Bonifacio Day",
                        fil: "Araw ng Kapanganakan ni Bonifacio"
                    }
                },
                "12-08": {
                    _name: "12-08",
                    name: {
                        en: "Feast of the Immaculate Conception of the Blessed Virgin Mary",
                        fil: "Pagdiriwang ng Kalinis-linisang Paglilihi sa Mahal na Birheng Maria"
                    },
                    type: "optional",
                    note: "Non-working Day"
                },
                "12-24": {
                    _name: "12-24",
                    type: "optional",
                    note: "Non-working Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-30": {
                    name: {
                        en: "Rizal Day",
                        fil: "Paggunita sa Kamatayan ni Dr. Jose Rizal"
                    }
                },
                "12-31": {
                    _name: "12-31",
                    type: "optional",
                    note: "Non-working Day"
                },
                "1 Muharram": {
                    type: "observance",
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    type: "observance",
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        PL: {
            names: {
                pl: "Polska",
                en: "Poland"
            },
            dayoff: "sunday",
            langs: [
                "pl"
            ],
            zones: [
                "Europe/Warsaw"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        pl: "\u015Awi\u0119to Pa\u0144stwowe; \u015Awi\u0119to Pracy"
                    }
                },
                "05-03": {
                    name: {
                        pl: "\u015Awi\u0119to Narodowe Trzeciego Maja",
                        en: "Constitution Day"
                    }
                },
                "05-26": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-11": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        PM: {
            names: {
                en: "St. Pierre & Miquelon"
            },
            langs: [
                "fr"
            ],
            zones: [
                "America/Miquelon"
            ],
            dayoff: "sunday",
            days: {},
            _days: "FR"
        },
        PR: {
            names: {
                en: "Puerto Rico"
            },
            langs: [
                "es",
                "en"
            ],
            zones: [
                "America/Puerto_Rico"
            ],
            dayoff: "sunday",
            _days: "US",
            days: {
                "01-06": {
                    _name: "01-06"
                },
                "2nd Monday in January": {
                    name: {
                        es: "Natalicio de Eugenio Mar\xeda de Hostos",
                        en: "Birthday of Eugenio Mar\xeda de Hostos"
                    }
                },
                "02-18": {
                    name: {
                        es: "Natalicio de Luis Mu\xf1oz Mar\xedn",
                        en: "Birthday of Luis Mu\xf1oz Mar\xedn"
                    }
                },
                "03-02 since 2017": {
                    name: {
                        es: "D\xeda de la Ciudadan\xeda Americana",
                        en: "American Citizenship Day"
                    }
                },
                "03-17": false,
                "03-22": {
                    name: {
                        es: "D\xeda de la Abolici\xf3n de Esclavitud",
                        en: "Emancipation Day"
                    }
                },
                "04-16": {
                    name: {
                        es: "Natalicio de Jos\xe9 de Diego",
                        en: "Birthday of Jos\xe9 de Diego"
                    }
                },
                "3rd Monday in July": {
                    name: {
                        es: "Natalicio de Don Luis Mu\xf1oz Rivera",
                        en: "Birthday of Don Luis Mu\xf1oz Rivera"
                    }
                },
                "07-25": {
                    name: {
                        es: "Constituci\xf3n de Puerto Rico",
                        en: "Puerto Rico Constitution Day"
                    }
                },
                "07-27": {
                    name: {
                        es: "Natalicio de Dr. Jos\xe9 Celso Barbosa",
                        en: "Birthday of Dr. Jos\xe9 Celso Barbosa"
                    }
                },
                "11-19": {
                    name: {
                        es: "D\xeda del Descubrimiento de Puerto Rico",
                        en: "Discovery of Puerto Rico"
                    }
                }
            }
        },
        PT: {
            names: {
                pt: "Portugal",
                en: "Portugal"
            },
            dayoff: "sunday",
            langs: [
                "pt"
            ],
            zones: [
                "Europe/Lisbon",
                "Atlantic/Madeira",
                "Atlantic/Azores"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -47": {
                    _name: "easter -47",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "04-25": {
                    name: {
                        pt: "Dia da Liberdade",
                        en: "Liberty Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "06-10": {
                    name: {
                        pt: "Dia de Portugal",
                        en: "Portugal Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "10-05": {
                    name: {
                        pt: "Implanta\xe7\xe3o da Rep\xfablica"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-01": {
                    name: {
                        pt: "Restaura\xe7\xe3o da Independ\xeancia"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-24": {
                    _name: "12-24",
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                }
            }
        },
        PY: {
            names: {
                es: "Paraguay",
                en: "Paraguay"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Asuncion"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "03-01": {
                    disable: [
                        "2017-03-01"
                    ],
                    enable: [
                        "2017-02-27"
                    ],
                    name: {
                        en: "Heroes' Day",
                        es: "Dia de los h\xe9roes"
                    }
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "04-30": {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: "optional",
                    note: "Affects educational institutions"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-14": {
                    _name: "Independence Day"
                },
                "05-15": {
                    _name: "Independence Day"
                },
                "06-12": {
                    name: {
                        en: "Chaco Armistice",
                        es: "D\xeda de la Paz del Chaco"
                    },
                    disable: [
                        "2020-06-12"
                    ],
                    enable: [
                        "2020-06-15"
                    ]
                },
                "08-15": {
                    _name: "08-15",
                    disable: [
                        "2017-08-15"
                    ],
                    enable: [
                        "2017-08-14"
                    ]
                },
                "09-29": {
                    disable: [
                        "2017-09-29"
                    ],
                    enable: [
                        "2017-10-02"
                    ],
                    name: {
                        en: "Boqueron Battle Victory Day",
                        es: "Victoria de Boquer\xf3n"
                    }
                },
                "12-08": {
                    _name: "12-08",
                    name: {
                        en: "Virgin of Caacupe",
                        es: "Virgen de Caacup\xe9"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        RE: {
            names: {
                fr: "R\xe9union",
                en: "R\xe9union"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Indian/Reunion"
            ],
            dayoff: "",
            _days: "FR",
            days: {
                "12-20": {
                    _name: "Abolition of Slavery"
                }
            }
        },
        RO: {
            names: {
                ro: "Romania",
                en: "Romania"
            },
            dayoff: "sunday",
            langs: [
                "ro"
            ],
            zones: [
                "Europe/Bucharest"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-24": {
                    name: {
                        ro: "Ziua Unirii",
                        en: "Unification Day"
                    }
                },
                "03-08": {
                    name: {
                        ro: "Ziua Mamei"
                    },
                    type: "observance"
                },
                "orthodox -2": {
                    _name: "easter -2"
                },
                orthodox: {
                    _name: "easter"
                },
                "orthodox 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "orthodox 39": {
                    _name: "easter 39",
                    type: "observance"
                },
                "orthodox 49": {
                    _name: "easter 49"
                },
                "orthodox 50": {
                    _name: "easter 50"
                },
                "1st sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-01": {
                    name: {
                        ro: "Ziua Copilului",
                        en: "Children's Day"
                    }
                },
                "06-26": {
                    name: {
                        ro: "Ziua drapelului national",
                        en: "Flag Day"
                    },
                    type: "observance"
                },
                "07-29": {
                    name: {
                        ro: "Ziua Imnului na\u021Bional",
                        en: "National Anthem Day"
                    },
                    type: "observance"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-30": {
                    name: {
                        ro: "Sf\xe2ntul Andrei",
                        en: "St Andrew's Day"
                    }
                },
                "12-01": {
                    name: {
                        ro: "Ziua na\u021Bional\u0103, Ziua Marii Uniri",
                        en: "National holiday"
                    }
                },
                "12-08": {
                    _name: "Constitution Day",
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        RS: {
            names: {
                sr: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430",
                en: "Serbia"
            },
            langs: [
                "sr"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            dayoff: "sunday",
            days: {
                "01-01 if sunday then next tuesday": {
                    _name: "01-01"
                },
                "01-02 if sunday then next monday": {
                    _name: "01-01"
                },
                "julian 12-25": {
                    _name: "julian 12-25"
                },
                "02-15 if sunday then next tuesday": {
                    name: {
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438 \u0421\u0440\u0431\u0438\u0458\u0435",
                        en: "Statehood Day"
                    }
                },
                "02-16 if sunday then next monday": {
                    name: {
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438 \u0421\u0440\u0431\u0438\u0458\u0435",
                        en: "Statehood Day"
                    }
                },
                "orthodox -2": {
                    _name: "orthodox -2"
                },
                orthodox: {
                    _name: "orthodox"
                },
                "orthodox 1": {
                    _name: "orthodox 1"
                },
                "05-01 if sunday then next tuesday": {
                    _name: "05-01"
                },
                "05-02 if sunday then next monday": {
                    _name: "05-01"
                },
                "11-11 if sunday then next monday": {
                    name: {
                        sr: "\u0414\u0430\u043D \u043F\u0440\u0438\u043C\u0438\u0440\u0458\u0430",
                        en: "Armistice Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2",
                    type: "optional",
                    note: "Catholic believers"
                },
                easter: {
                    _name: "easter",
                    type: "optional",
                    note: "Catholic believers"
                },
                "easter 1": {
                    _name: "easter 1",
                    type: "optional",
                    note: "Catholic believers"
                },
                "12-25": {
                    _name: "12-25",
                    type: "optional",
                    note: "Catholic believers"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    type: "optional",
                    note: "Muslim believers"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    type: "optional",
                    note: "Muslim believers"
                },
                "10 Tishrei": {
                    _name: "10 Tishrei",
                    type: "optional",
                    note: "Jewish believers"
                },
                "julian 01-14": {
                    name: {
                        sr: "\u0421\u0432\u0435\u0442\u0438 \u0421\u0430\u0432\u0430",
                        en: "Saint Sava Day"
                    },
                    type: "observance"
                },
                "04-22": {
                    name: {
                        sr: "\u0414\u0430\u043D \u0441\u0435\u045B\u0430\u045A\u0430 \u043D\u0430 \u0436\u0440\u0442\u0432\u0435 \u0445\u043E\u043B\u043E\u043A\u0430\u0443\u0441\u0442\u0430",
                        en: "Holocaust Remembrance Day"
                    },
                    type: "observance"
                },
                "05-09": {
                    name: {
                        sr: "\u0414\u0430\u043D \u043F\u043E\u0431\u0435\u0434\u0435",
                        en: "Victory Day"
                    },
                    type: "observance"
                },
                "julian 06-15": {
                    name: {
                        sr: "\u0412\u0438\u0434\u043E\u0432\u0434\u0430\u043D",
                        en: "Saint Vitus Day"
                    },
                    type: "observance"
                },
                "10-21": {
                    name: {
                        sr: "\u0414\u0430\u043D \u0441\u0435\u045B\u0430\u045A\u0430 \u043D\u0430 \u0441\u0440\u043F\u0441\u043A\u0435 \u0436\u0440\u0442\u0432\u0435 \u0443 \u0414\u0440\u0443\u0433\u043E\u043C \u0441\u0432\u0435\u0442\u0441\u043A\u043E\u043C \u0440\u0430\u0442\u0443",
                        en: "World War II Serbian Victims Remembrance Day"
                    },
                    type: "observance"
                }
            }
        },
        RU: {
            names: {
                ru: "\u0420\u043E\u0441\u0441\u0438\u044F",
                en: "Russia"
            },
            dayoff: "sunday",
            langs: [
                "ru"
            ],
            zones: [
                "Europe/Moscow",
                "Europe/Kaliningrad",
                "Europe/Simferopol",
                "Europe/Volgograd",
                "Europe/Samara",
                "Asia/Yekaterinburg",
                "Asia/Omsk",
                "Asia/Novosibirsk",
                "Asia/Novokuznetsk",
                "Asia/Krasnoyarsk",
                "Asia/Irkutsk",
                "Asia/Chita",
                "Asia/Yakutsk",
                "Asia/Khandyga",
                "Asia/Vladivostok",
                "Asia/Sakhalin",
                "Asia/Ust-Nera",
                "Asia/Magadan",
                "Asia/Srednekolymsk",
                "Asia/Kamchatka",
                "Asia/Anadyr"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02 P5D": {
                    name: {
                        ru: "\u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                        en: "New Year Holiday"
                    }
                },
                "julian 12-25": {
                    _name: "12-25"
                },
                "01-08": {
                    name: {
                        ru: "\u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                        en: "New Year Holiday"
                    }
                },
                "02-23": {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                        en: "Defender of the Fatherland Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "05-01": {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0432\u0435\u0441\u043D\u044B \u0438 \u0442\u0440\u0443\u0434\u0430",
                        en: "Spring and Labour Day"
                    }
                },
                "05-09": {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                        en: "Victory Day"
                    }
                },
                "06-12": {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                        en: "Russia Day"
                    }
                },
                "11-04": {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                        en: "Unity Day"
                    }
                }
            }
        },
        RW: {
            names: {
                en: "Rwanda",
                fr: "R\xe9publique du Rwanda",
                rw: "Repubulika y'u Rwanda"
            },
            dayoff: "sunday",
            langs: [
                "en",
                "fr",
                "rw"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    _name: "Public Holiday"
                },
                "02-01": {
                    name: {
                        en: "Heroes Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "04-07": {
                    name: {
                        fr: "Jour de M\xe9morial du G\xe9nocide",
                        en: "Genocide Memorial Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-01": {
                    _name: "Independence Day"
                },
                "07-04": {
                    name: {
                        fr: "Jour de la Lib\xe9ration",
                        en: "Liberation Day"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "1st friday in August": {
                    name: {
                        rw: "Umuganura",
                        fr: "Journ\xe9e nationale de r\xe9colte",
                        en: "National Harvest Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        SC: {
            names: {
                en: "Seychelles",
                fr: "R\xe9publique des Seychelles",
                crs: "Repiblik Sesel"
            },
            langs: [
                "en",
                "fr",
                "crs"
            ],
            zones: [
                "Indian/Mahe"
            ],
            dayoff: "sunday",
            days: {
                "01-01 P2D": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-18": {
                    _name: "National Holiday"
                },
                "06-29": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                }
            }
        },
        SD: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0646",
                en: "Sudan"
            },
            langs: [],
            zones: [
                "Africa/Khartoum"
            ],
            dayoff: "",
            days: {
                "01-01": {
                    _name: "Independence Day"
                },
                "12-19": {
                    _name: "Revolution Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal P4D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah P3D": {
                    _name: "10 Dhu al-Hijjah"
                },
                "julian 12-25": {
                    _name: "julian 12-25",
                    name: {
                        en: "Coptic Christmas"
                    }
                },
                orthodox: {
                    _name: "orthodox",
                    name: {
                        en: "Coptic Easter"
                    }
                }
            }
        },
        SE: {
            names: {
                sv: "Sverige",
                en: "Sweden"
            },
            dayoff: "sunday",
            langs: [
                "sv"
            ],
            zones: [
                "Europe/Stockholm"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-05 12:00": {
                    name: {
                        sv: "Trettondagsafton",
                        en: "Twelfth Night"
                    },
                    type: "optional"
                },
                "01-06": {
                    _name: "01-06"
                },
                "01-13": {
                    name: {
                        sv: "Tjugondag Knut",
                        en: "Saint Knut's Day"
                    },
                    type: "observance"
                },
                "1st sunday in March": {
                    name: {
                        sv: "Vasaloppet"
                    },
                    type: "observance"
                },
                "03-25": {
                    name: {
                        sv: "Marie Beb\xe5delsedag",
                        en: "Annunciation Day",
                        lat: "Annuntiatio Mari\xe6"
                    },
                    type: "observance"
                },
                "04-30 12:00": {
                    name: {
                        sv: "Valborgsm\xe4ssoafton",
                        en: "Walpurgis Night"
                    },
                    type: "optional"
                },
                "easter -3": {
                    _name: "easter -3",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter -1": {
                    _name: "easter -1",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 48": {
                    name: {
                        sv: "Pingstafton",
                        en: "Whitsun Eve"
                    },
                    type: "observance"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "public"
                },
                "easter 50": {
                    _name: "easter 50",
                    type: "observance"
                },
                "sunday before 06-01": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-06": {
                    name: {
                        sv: "Sveriges nationaldag",
                        en: "National Day"
                    }
                },
                "friday after 06-19": {
                    name: {
                        sv: "Midsommarafton",
                        en: "Midsummer Eve",
                        fi: "Juhannusaatto"
                    },
                    type: "bank"
                },
                "saturday after 06-20": {
                    name: {
                        sv: "Midsommardagen",
                        en: "Midsummer Day",
                        fi: "Juhannusp\xe4iv\xe4"
                    }
                },
                "friday after 10-30 12:00": {
                    name: {
                        sv: "Allhelgonaafton",
                        en: "Halloween"
                    },
                    type: "optional"
                },
                "saturday after 10-31": {
                    _name: "11-01"
                },
                "11-06": {
                    name: {
                        sv: "Gustav-Adolf-dagen",
                        en: "Gustavus Adolphus Day"
                    },
                    type: "observance"
                },
                "11-11": {
                    name: {
                        sv: "M\xe5rtensg\xe5s",
                        en: "Saint Martin's Day"
                    },
                    type: "observance"
                },
                "12-10": {
                    name: {
                        sv: "Nobeldagen",
                        en: "Nobel Day"
                    },
                    type: "observance"
                },
                "12-13": {
                    name: {
                        sv: "Luciadagen",
                        en: "Saint Lucy's Day"
                    },
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24",
                    type: "bank"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31": {
                    _name: "12-31",
                    type: "bank"
                }
            }
        },
        SG: {
            names: {
                en: "Singapore"
            },
            langs: [
                "en"
            ],
            zones: [
                "Asia/Singapore"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Chinese New Year"
                    }
                },
                "chinese 01-0-02": {
                    name: {
                        en: "Chinese New Year"
                    }
                },
                "substitutes chinese 01-0-01 if sunday then next tuesday": {
                    substitute: true,
                    name: {
                        en: "Chinese New Year"
                    }
                },
                "substitutes chinese 01-0-02 if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Chinese New Year"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "05-01": {
                    _name: "05-01"
                },
                "substitutes 05-01 if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "08-09": {
                    name: {
                        en: "National Day"
                    }
                },
                "substitutes 08-09 if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "National Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal",
                    name: {
                        en: "Hari Raya Puasa"
                    },
                    disable: [
                        "2022-05-02",
                        "2023-04-21",
                        "2024-04-09"
                    ],
                    enable: [
                        "2022-05-03",
                        "2023-04-22",
                        "2024-04-10"
                    ]
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Hari Raya Haji"
                    },
                    disable: [
                        "2022-07-09",
                        "2023-06-28"
                    ],
                    enable: [
                        "2022-07-10",
                        "2023-06-29"
                    ]
                },
                "2001-05-07": {
                    _name: "Vesak"
                },
                "2002-05-27": {
                    _name: "Vesak"
                },
                "2003-05-15": {
                    _name: "Vesak"
                },
                "2004-06-02": {
                    _name: "Vesak"
                },
                "2005-05-23": {
                    _name: "Vesak"
                },
                "2006-05-12": {
                    _name: "Vesak"
                },
                "2007-05-31": {
                    _name: "Vesak"
                },
                "2008-05-19": {
                    _name: "Vesak"
                },
                "2009-05-09": {
                    _name: "Vesak"
                },
                "2010-05-28": {
                    _name: "Vesak"
                },
                "2011-05-17": {
                    _name: "Vesak"
                },
                "2012-05-05": {
                    _name: "Vesak"
                },
                "2013-05-24": {
                    _name: "Vesak"
                },
                "2014-05-13": {
                    _name: "Vesak"
                },
                "2015-06-01": {
                    _name: "Vesak"
                },
                "2016-05-21": {
                    _name: "Vesak"
                },
                "2017-05-10": {
                    _name: "Vesak"
                },
                "2018-05-29": {
                    _name: "Vesak"
                },
                "2019-05-19": {
                    _name: "Vesak"
                },
                "2019-05-20": {
                    substitute: true,
                    _name: "Vesak"
                },
                "2020-05-07": {
                    _name: "Vesak"
                },
                "2021-05-26": {
                    _name: "Vesak"
                },
                "2022-05-15": {
                    _name: "Vesak"
                },
                "2022-05-16": {
                    substitute: true,
                    _name: "Vesak"
                },
                "2023-06-02": {
                    _name: "Vesak"
                },
                "2024-05-23": {
                    _name: "Vesak"
                },
                "2000-10-26": {
                    _name: "Deepavali"
                },
                "2001-11-14": {
                    _name: "Deepavali"
                },
                "2002-11-03": {
                    _name: "Deepavali"
                },
                "2002-11-04": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2003-10-23": {
                    _name: "Deepavali"
                },
                "2004-11-11": {
                    _name: "Deepavali"
                },
                "2005-11-01": {
                    _name: "Deepavali"
                },
                "2006-10-21": {
                    _name: "Deepavali"
                },
                "2007-11-08": {
                    _name: "Deepavali"
                },
                "2008-10-27": {
                    _name: "Deepavali"
                },
                "2009-10-17": {
                    _name: "Deepavali"
                },
                "2010-11-05": {
                    _name: "Deepavali"
                },
                "2011-10-26": {
                    _name: "Deepavali"
                },
                "2012-11-13": {
                    _name: "Deepavali"
                },
                "2013-11-03": {
                    _name: "Deepavali"
                },
                "2013-11-04": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2014-10-22": {
                    _name: "Deepavali"
                },
                "2015-11-10": {
                    _name: "Deepavali"
                },
                "2016-10-29": {
                    _name: "Deepavali"
                },
                "2017-10-18": {
                    _name: "Deepavali"
                },
                "2018-11-06": {
                    _name: "Deepavali"
                },
                "2019-10-27": {
                    _name: "Deepavali"
                },
                "2019-10-28": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2020-11-14": {
                    _name: "Deepavali"
                },
                "2021-11-04": {
                    _name: "Deepavali"
                },
                "2022-10-24": {
                    _name: "Deepavali"
                },
                "2023-11-13": {
                    _name: "Deepavali"
                },
                "2024-10-31": {
                    _name: "Deepavali"
                },
                "2025-10-20": {
                    _name: "Deepavali"
                },
                "2026-11-09": {
                    _name: "Deepavali"
                },
                "2027-10-28": {
                    _name: "Deepavali"
                },
                "2028-11-15": {
                    _name: "Deepavali"
                },
                "2029-11-05": {
                    _name: "Deepavali"
                },
                "2030-10-25": {
                    _name: "Deepavali"
                },
                "2023-09-1": {
                    name: {
                        en: "Presidential Election Day"
                    },
                    type: "public"
                }
            }
        },
        SH: {
            names: {
                en: "St. Helena"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "substitutes 01-01 if saturday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "3rd monday in April": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "05-21": {
                    name: {
                        en: "Saint Helena Day"
                    }
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "monday before 09-01": {
                    name: {
                        en: "August Bank Holiday"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "substitutes 12-25 if saturday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "substitutes 12-25 if sunday then next tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "substitutes 12-26 if saturday then next monday": {
                    substitute: true,
                    _name: "12-26"
                },
                "substitutes 12-26 if sunday then next monday": {
                    substitute: true,
                    _name: "12-26"
                }
            },
            states: {
                AC: {
                    name: "Ascension Island",
                    days: {
                        "easter 39": {
                            _name: "easter 39"
                        }
                    }
                },
                HL: {
                    name: "Saint Helena",
                    days: {}
                },
                TA: {
                    name: "Tristan da Cunha",
                    days: {
                        "easter 39": {
                            _name: "easter 39"
                        },
                        "2012-04-23": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2013-05-03": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2014-05-02": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2015-05-16": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2016-04-30": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2017-05-26": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "2018-06-02": {
                            name: {
                                en: "Ratting Day"
                            }
                        },
                        "08-14": {
                            name: {
                                en: "Anniversary Day"
                            }
                        },
                        "monday before 09-01": false
                    }
                }
            }
        },
        SI: {
            names: {
                sl: "Republika Slovenija",
                en: "Slovenia"
            },
            langs: [
                "sl"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    _name: "01-01",
                    active: [
                        {
                            to: 1955
                        },
                        {
                            from: 2017
                        }
                    ]
                },
                "02-08": {
                    name: {
                        en: "Pre\u0161eren Day, the Slovenian Cultural Holiday",
                        sl: "Pre\u0161ernov dan, slovenski kulturni praznik"
                    },
                    active: [
                        {
                            from: 1991
                        }
                    ]
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "04-23": {
                    name: {
                        sl: "Jurjevanje",
                        en: "St. George's Day"
                    },
                    type: "observance"
                },
                "easter -49": {
                    name: {
                        sl: "Pust",
                        en: "Carnival"
                    },
                    type: "observance"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27": {
                    name: {
                        sl: "Dan upora proti okupatorju",
                        en: "Day of Uprising Against Occupation"
                    }
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Labour Day"
                    },
                    active: [
                        {
                            from: 1949
                        }
                    ]
                },
                "05-02": {
                    _name: "05-01",
                    name: {
                        en: "Labour Day"
                    },
                    active: [
                        {
                            from: 1949
                        }
                    ]
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "06-08": {
                    name: {
                        sl: "Dan Primo\u017Ea Trubarja",
                        en: "Primo\u017E Trubar Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2010
                        }
                    ]
                },
                "06-25": {
                    name: {
                        sl: "Dan dr\u017Eavnosti",
                        en: "Statehood Day"
                    },
                    active: [
                        {
                            from: 1991
                        }
                    ]
                },
                "08-15": {
                    _name: "08-15",
                    active: [
                        {
                            from: 1992
                        }
                    ]
                },
                "08-17": {
                    name: {
                        sl: "Zdru\u017Eitev prekmurskih Slovencev z mati\u010Dnim narodom",
                        en: "Unification of Prekmurje Slovenes with the Mother Nation"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2006
                        }
                    ]
                },
                "09-15": {
                    name: {
                        sl: "Vrnitev Primorske k mati\u010Dni domovini",
                        en: "Return of Primorska to the Motherland"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2005
                        }
                    ]
                },
                "09-23": {
                    name: {
                        sl: "Dan slovenskega \u0161porta",
                        en: "Slovenian Sports Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2020
                        }
                    ]
                },
                "10-25": {
                    name: {
                        sl: "Dan suverenosti",
                        en: "Sovereignty Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2015
                        }
                    ]
                },
                "10-31": {
                    name: {
                        sl: "Dan reformacije",
                        en: "Reformation Day"
                    }
                },
                "11-01": {
                    name: {
                        sl: "Dan spomina na mrtve",
                        en: "Day of Remembrance for the Dead"
                    }
                },
                "11-11": {
                    name: {
                        sl: "Martinovanje",
                        en: "St. Martin's Day"
                    },
                    type: "observance"
                },
                "11-23": {
                    name: {
                        sl: "Dan Rudolfa Maistra",
                        en: "Rudolf Maister Day"
                    },
                    type: "observance",
                    active: [
                        {
                            from: 2015
                        }
                    ]
                },
                "12-06": {
                    name: {
                        sl: "Miklav\u017E",
                        en: "Saint Nicholas Day"
                    },
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25",
                    active: [
                        {
                            to: 1953
                        },
                        {
                            from: 1991
                        }
                    ]
                },
                "12-26": {
                    name: {
                        sl: "Dan samostojnosti in enotnosti",
                        en: "Independence and Unity Day"
                    }
                }
            }
        },
        SJ: {
            names: {
                en: "Svalbard & Jan Mayen"
            },
            langs: [
                "no"
            ],
            zones: [
                "Europe/Oslo"
            ],
            dayoff: "sunday",
            _days: "NO"
        },
        SK: {
            names: {
                sk: "Slovensk\xe1 republika",
                en: "Slovakia"
            },
            langs: [
                "sk"
            ],
            zones: [
                "Europe/Prague"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01",
                    name: {
                        sk: "De\u0148 vzniku Slovenskej republiky"
                    }
                },
                "01-06": {
                    _name: "01-06"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-08": {
                    name: {
                        sk: "De\u0148 v\xed\u0165azstva nad fa\u0161izmom",
                        en: "Day of victory over fascism"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "07-05": {
                    name: {
                        sk: "Sviatok sv\xe4t\xe9ho Cyrila a Metoda",
                        en: "Saints Cyril and Methodius Day"
                    }
                },
                "08-29": {
                    name: {
                        sk: "V\xfdro\u010Die Slovensk\xe9ho n\xe1rodn\xe9ho povstania",
                        en: "Slovak National Uprising anniversary"
                    }
                },
                "09-01": {
                    _name: "Constitution Day"
                },
                "09-15": {
                    name: {
                        sk: "Sviatok Panny M\xe1rie Sedembolestnej",
                        en: "Day of Our Lady of the Seven Sorrows"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-17": {
                    name: {
                        sk: "De\u0148 boja za slobodu a demokraciu",
                        en: "Struggle for Freedom and Democracy Day"
                    }
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        SL: {
            names: {
                en: "Sierra Leone"
            },
            langs: [
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "02-18 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Armed Forces Day"
                    }
                },
                "03-08 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "03-08"
                },
                "04-27 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1 Shawwal and if Sunday then next Monday": {
                    substitute: true,
                    _name: "1 Shawwal",
                    name: {
                        en: "Korit\xe9"
                    }
                },
                "10 Dhu al-Hijjah and if Sunday then next Monday": {
                    substitute: true,
                    _name: "10 Dhu al-Hijjah",
                    name: {
                        en: "Tabaski"
                    }
                },
                "12 Rabi al-awwal and if Sunday then next Monday": {
                    substitute: true,
                    _name: "12 Rabi al-awwal",
                    name: {
                        en: "Mawlid"
                    }
                },
                "12-25 and if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-26"
                }
            }
        },
        SM: {
            names: {
                it: "San Marino",
                en: "San Marino"
            },
            langs: [
                "it"
            ],
            zones: [
                "Europe/Rome"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    name: {
                        it: "Epifania"
                    }
                },
                "02-05": {
                    name: {
                        it: "Festa di Sant\u2019Agata",
                        en: "Feast of Saint Agatha"
                    }
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "03-25": {
                    name: {
                        it: "Anniversario dell'Arengo",
                        en: "Anniversary of the Arengo"
                    }
                },
                "04-01": {
                    name: {
                        it: "Cerimonia di investitura dei Capitani Reggenti",
                        en: "Inauguration Ceremony"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "07-28": {
                    name: {
                        it: "Anniversario della caduta del Fascismo e Festa della Libert\xe0",
                        en: "Liberation from Fascism"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "09-03": {
                    name: {
                        it: "Festa di San Marino e di Fondazione della Repubblica",
                        en: "The Feast of San Marino and the Republic"
                    }
                },
                "10-01": {
                    name: {
                        it: "Cerimonia di investitura dei Capitani Reggenti"
                    }
                },
                "11-01": {
                    _name: "11-01",
                    name: {
                        it: "Tutti i Santi"
                    }
                },
                "11-02": {
                    name: {
                        it: "Commemorazione dei defunti",
                        en: "Commemoration of the deceased"
                    }
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "12-31": {
                    _name: "12-31",
                    type: "optional"
                }
            }
        },
        SN: {
            names: {
                fr: "R\xe9publique du S\xe9n\xe9gal",
                wo: "R\xe9ewum Senegaal",
                en: "Senegal"
            },
            langs: [
                "fr",
                "wo"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "04-04": {
                    _name: "National Holiday"
                },
                "05-01": {
                    _name: "05-01"
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal and if sunday then next monday": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah and if sunday then next monday": {
                    _name: "10 Dhu al-Hijjah"
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "18 Safar": {
                    name: "Magal de Touba"
                }
            }
        },
        SO: {
            names: {
                so: "Jamhuuriyadda Federaalka Soomaaliya",
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0635\u0648\u0645\u0627\u0644 \u0627\u0644\u0641\u062F\u0631\u0627\u0644\u064A\u0629",
                en: "Somalia"
            },
            dayoff: "?",
            langs: [
                "so",
                "ar",
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-26": {
                    name: {
                        ar: "\u0627\u0633\u062A\u0642\u0644\u0627\u0644 \u0627\u0644\u0635\u0648\u0645\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A",
                        en: "Independence of British Somaliland"
                    }
                },
                "07-01": {
                    _name: "Independence Day"
                },
                "10 Muharram": {
                    _name: "10 Muharram"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            },
            states: {
                AW: {
                    name: "Awdal",
                    days: {
                        "01-01": false,
                        "05-18 P2D": {
                            name: {
                                en: "Restoration of Somaliland Sovereignty"
                            }
                        },
                        "07-01": false,
                        "1 Muharram": {
                            _name: "1 Muharram"
                        },
                        "10 Muharram": false,
                        "27 Rajab": {
                            _name: "27 Rajab"
                        }
                    }
                },
                SA: {
                    name: "Sanaag",
                    _days: [
                        "SO",
                        "states",
                        "AW"
                    ]
                },
                SO: {
                    name: "Sool",
                    _days: [
                        "SO",
                        "states",
                        "AW"
                    ]
                },
                TO: {
                    name: "Togdheer",
                    _days: [
                        "SO",
                        "states",
                        "AW"
                    ]
                },
                WO: {
                    name: "Woqooyi Galbeed",
                    _days: [
                        "SO",
                        "states",
                        "AW"
                    ]
                }
            }
        },
        SR: {
            names: {
                en: "Suriname"
            },
            langs: [
                "nl",
                "srn"
            ],
            zones: [
                "America/Paramaribo"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "chinese 01-0-01": {
                    name: {
                        nl: "Chinees Nieuwjaar",
                        en: "Chinese New Year"
                    }
                },
                "02-25": {
                    name: {
                        nl: "Dag van Bevrijding en Vernieuwing",
                        en: "Day of Liberation and Innovation"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-01": {
                    name: {
                        nl: "Dag der Vrijheden (Keti koti)",
                        srn: "Keti koti",
                        en: "Emancipation Day"
                    }
                },
                "08-09": {
                    name: {
                        nl: "Dag der Inheemsen",
                        en: "Indigenous People's Day"
                    }
                },
                "10-10": {
                    name: {
                        nl: "Dag van de Marrons",
                        en: "Day of the Maroons"
                    }
                },
                "11-25": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "2015-03-06": {
                    _name: "Holi"
                },
                "2016-03-23": {
                    _name: "Holi"
                },
                "2017-03-12": {
                    _name: "Holi"
                },
                "2018-03-02": {
                    _name: "Holi"
                },
                "2019-03-21": {
                    _name: "Holi"
                },
                "2020-03-09": {
                    _name: "Holi"
                },
                "2021-03-28": {
                    _name: "Holi"
                },
                "2022-03-18": {
                    _name: "Holi"
                },
                "2023-03-07": {
                    _name: "Holi"
                },
                "2024-03-25": {
                    _name: "Holi"
                },
                "2025-03-14": {
                    _name: "Holi"
                },
                "2026-03-03": {
                    _name: "Holi"
                },
                "2027-03-22": {
                    _name: "Holi"
                },
                "2028-03-11": {
                    _name: "Holi"
                },
                "2029-03-28": {
                    _name: "Holi"
                },
                "2030-03-19": {
                    _name: "Holi"
                },
                "2014-10-23": {
                    _name: "Deepavali"
                },
                "2015-11-11": {
                    _name: "Deepavali"
                },
                "2016-10-30": {
                    _name: "Deepavali"
                },
                "2017-10-19": {
                    _name: "Deepavali"
                },
                "2018-11-07": {
                    _name: "Deepavali"
                },
                "2019-10-27": {
                    _name: "Deepavali"
                },
                "2020-11-14": {
                    _name: "Deepavali"
                },
                "2021-11-04": {
                    _name: "Deepavali"
                },
                "2022-10-24": {
                    _name: "Deepavali"
                },
                "2023-11-12": {
                    _name: "Deepavali"
                },
                "2024-10-31": {
                    _name: "Deepavali"
                },
                "2025-10-20": {
                    _name: "Deepavali"
                },
                "2026-11-08": {
                    _name: "Deepavali"
                },
                "2027-10-28": {
                    _name: "Deepavali"
                },
                "2028-10-17": {
                    _name: "Deepavali"
                },
                "2029-11-05": {
                    _name: "Deepavali"
                },
                "2030-10-25": {
                    _name: "Deepavali"
                }
            }
        },
        SS: {
            names: {
                en: "South Sudan"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-09": {
                    name: {
                        en: "Peace Agreement Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "05-16": {
                    name: {
                        en: "SPLA Day"
                    }
                },
                "1st monday in July": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "07-09": {
                    _name: "Independence Day"
                },
                "07-30": {
                    name: {
                        en: "Martyrs Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-28": {
                    name: {
                        en: "Republic Day"
                    }
                },
                "12-31": {
                    _name: "12-31"
                },
                "2 Shawwal": {
                    _name: "1 Shawwal"
                },
                "12 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        ST: {
            names: {
                pt: "S\xe3o Tom\xe9 & Pr\xedncipe",
                en: "S\xe3o Tom\xe9 & Pr\xedncipe"
            },
            langs: [
                "pt",
                "en"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "02-03 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Martyrs' Day",
                        pt: "Dia dos M\xe1rtires"
                    }
                },
                "05-01 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "07-12 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "09-06 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Armed Forces Day",
                        pt: "Dia das For\xe7as Armadas"
                    }
                },
                "09-30 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Agricultural Reform Day",
                        pt: "Dia da Reforma Agr\xe1ria"
                    }
                },
                "12-21 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "S\xe3o Tom\xe9 Day",
                        pt: "Dia de S\xe3o Tom\xe9"
                    }
                },
                "12-25 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-25"
                }
            }
        },
        SV: {
            names: {
                es: "El Salvador",
                en: "El Salvador"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/El_Salvador"
            ],
            days: {
                "01-01": {
                    _name: "01-01",
                    type: "observance"
                },
                "01-16": {
                    name: {
                        es: "Firma de los Acuerdos de Paz"
                    },
                    type: "observance"
                },
                "03-08": {
                    name: {
                        es: "D\xeda de la Mujer"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter -1": {
                    _name: "easter -1"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-07": {
                    name: {
                        en: "Soldier's Day",
                        es: "D\xeda del Soldado"
                    },
                    type: "observance"
                },
                "05-10": {
                    _name: "Mothers Day",
                    type: "optional",
                    note: "Public Offices only"
                },
                "06-17": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "06-22": {
                    name: {
                        es: "D\xeda del Maestro"
                    },
                    type: "optional",
                    note: "Dayoff for teachers only"
                },
                "08-06": {
                    name: {
                        es: "Celebraci\xf3n del Divino Salvador del Mundo"
                    }
                },
                "09-15": {
                    _name: "Independence Day"
                },
                "11-02": {
                    _name: "11-02"
                },
                "12-25": {
                    _name: "12-25"
                }
            },
            regions: {
                SS: {
                    name: "San Salvador",
                    days: {
                        "08-03": {
                            name: {
                                es: "Fiestas Agostinas"
                            }
                        },
                        "08-05": {
                            name: {
                                es: "Fiestas Agostinas"
                            }
                        }
                    }
                }
            }
        },
        SX: {
            names: {
                en: "Sint Maarten"
            },
            langs: [
                "nl"
            ],
            zones: [
                "America/Curacao"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-27": {
                    name: {
                        nl: "Koningsdag",
                        en: "King's Day"
                    }
                },
                "04-30 if Sunday then next Tuesday prior to 2017": {
                    name: {
                        nl: "Carnaval",
                        en: "Carnival"
                    }
                },
                "04-30 if Saturday then previous Friday if Sunday then next Tuesday since 2017": {
                    name: {
                        nl: "Carnaval",
                        en: "Carnival"
                    }
                },
                "05-01 if Sunday then next Monday": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 49": {
                    _name: "easter 49"
                },
                "07-01": {
                    name: {
                        nl: "Emancipatiedag",
                        en: "Emancipation Day"
                    }
                },
                "10-09": {
                    _name: "Constitution Day"
                },
                "11-11": {
                    name: {
                        en: "Sint Maarten Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        SZ: {
            names: {
                ss: "Eswatini",
                en: "Swaziland"
            },
            langs: [
                "ss",
                "en"
            ],
            zones: [
                "Africa/Johannesburg"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-19 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Birthday of King Mswati III"
                    }
                },
                "04-25 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Flag Day"
                    }
                },
                "05-01 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "07-22 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Birthday of the late King Sobhuza"
                    }
                },
                "1st Monday in September": {
                    name: {
                        ss: "Umhlanga Reed Dance",
                        en: "Umhlanga Reed Dance"
                    }
                },
                "09-06 and if Saturday, Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day",
                    name: {
                        ss: "Somhlolo Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26 and if Sunday then next Monday": {
                    _name: "12-26"
                },
                "12-28 P6D": {
                    name: {
                        ss: "Incwala",
                        en: "Incwala Festival"
                    }
                }
            }
        },
        TC: {
            names: {
                en: "Turks & Caicos Islands"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Grand_Turk"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Saturday, Sunday then next Monday": {
                    _name: "01-01"
                },
                "2nd Monday in March": {
                    name: {
                        en: "Commonwealth Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "1st Monday before 06-01": {
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                "2nd Monday after 06-02": {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                "1st Monday in August": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "1st Friday before 10-01": {
                    name: {
                        en: "National Youth Day"
                    }
                },
                "2nd Monday in October": {
                    name: {
                        en: "National Heritage Day"
                    }
                },
                "4th Friday in November": {
                    name: {
                        en: "National Day of Thanksgiving"
                    }
                },
                "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-26"
                }
            }
        },
        TD: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062A\u0634\u0627\u062F",
                fr: "R\xe9publique du Tchad",
                en: "Chad"
            },
            langs: [
                "ar",
                "fr"
            ],
            zones: [
                "Africa/Ndjamena"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if sunday then next monday": {
                    _name: "01-01"
                },
                "05-01 and if sunday then next monday": {
                    _name: "05-01"
                },
                "08-11 and if sunday then next monday": {
                    name: {
                        fr: "F\xeate Nationale (Ind\xe9pendance)",
                        en: "Independence Day"
                    }
                },
                "12-01 and if sunday then next monday": {
                    name: {
                        fr: "Journ\xe9e de la lib\xe9ration et de la d\xe9mocratie",
                        en: "Freedom and Democracy Day"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "11-28": {
                    name: {
                        fr: "Anniversaire de la Proclamation de la R\xe9publique",
                        en: "Proclamation of the Republic"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        TG: {
            names: {
                fr: "R\xe9publique togolaise",
                en: "Togolese Republic"
            },
            dayoff: "sunday",
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Abidjan"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-13": {
                    name: {
                        fr: "Jour de la lib\xe9ration",
                        en: "Liberation Day"
                    }
                },
                "04-27": {
                    _name: "Independence Day"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "06-21": {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        en: "Day of the Martyrs"
                    }
                },
                "08-15": {
                    _name: "08-15"
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-25": {
                    _name: "12-25"
                },
                "13 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "2 Shawwal": {
                    _name: "1 Shawwal"
                },
                "11 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        TH: {
            names: {
                en: "Thailand"
            },
            langs: [
                "en",
                "th"
            ],
            zones: [
                "Asia/Bangkok"
            ],
            dayoff: "Saturday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "04-06": {
                    name: {
                        en: "Chakri Memorial Day",
                        th: "\u0E27\u0E31\u0E19\u0E08\u0E31\u0E01\u0E23\u0E35"
                    }
                },
                "04-13": {
                    name: {
                        en: "Songkran Festival",
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                "04-14": {
                    name: {
                        en: "Songkran Festival",
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                "04-15": {
                    name: {
                        en: "Songkran Festival",
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                "05-04": {
                    name: {
                        en: "Coronation Day",
                        th: "\u0E27\u0E31\u0E19\u0E09\u0E31\u0E15\u0E23\u0E21\u0E07\u0E04\u0E25"
                    }
                },
                "06-03": {
                    name: {
                        en: "Queen Suthida's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E19\u0E32\u0E07\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E38\u0E17\u0E34\u0E14\u0E32 \u0E1E\u0E31\u0E0A\u0E23\u0E2A\u0E38\u0E18\u0E32\u0E1E\u0E34\u0E21\u0E25\u0E25\u0E31\u0E01\u0E29\u0E13 \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E34\u0E19\u0E35"
                    }
                },
                "07-28": {
                    name: {
                        en: "King's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E27\u0E0A\u0E34\u0E23\u0E40\u0E01\u0E25\u0E49\u0E32\u0E40\u0E08\u0E49\u0E32\u0E2D\u0E22\u0E39\u0E48\u0E2B\u0E31\u0E27"
                    }
                },
                "08-12": {
                    name: {
                        en: "The Queen Mother's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E19\u0E32\u0E07\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E34\u0E23\u0E34\u0E01\u0E34\u0E15\u0E34\u0E4C \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E34\u0E19\u0E35\u0E19\u0E32\u0E16 \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E0A\u0E19\u0E19\u0E35\u0E1E\u0E31\u0E19\u0E1B\u0E35\u0E2B\u0E25\u0E27\u0E07"
                    }
                },
                "10-13": {
                    name: {
                        en: "King Bhumibol Adulyadej Memorial Day",
                        th: "\u0E27\u0E31\u0E19\u0E04\u0E25\u0E49\u0E32\u0E22\u0E27\u0E31\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E15\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E0A\u0E19\u0E01\u0E32\u0E18\u0E34\u0E40\u0E1A\u0E28\u0E23 \u0E21\u0E2B\u0E32\u0E20\u0E39\u0E21\u0E34\u0E1E\u0E25\u0E2D\u0E14\u0E38\u0E25\u0E22\u0E40\u0E14\u0E0A\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A \u0E1A\u0E23\u0E21\u0E19\u0E32\u0E16\u0E1A\u0E1E\u0E34\u0E15\u0E23"
                    }
                },
                "10-23": {
                    name: {
                        en: "King Chulalongkorn Day",
                        th: "\u0E27\u0E31\u0E19\u0E1B\u0E34\u0E22\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A"
                    }
                },
                "12-05": {
                    name: {
                        en: "King Bhumibol Adulyadej's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E04\u0E25\u0E49\u0E32\u0E22\u0E27\u0E31\u0E19\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E2A\u0E21\u0E20\u0E1E \u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E0A\u0E19\u0E01\u0E32\u0E18\u0E34\u0E40\u0E1A\u0E28\u0E23 \u0E21\u0E2B\u0E32\u0E20\u0E39\u0E21\u0E34\u0E1E\u0E25\u0E2D\u0E14\u0E38\u0E25\u0E22\u0E40\u0E14\u0E0A\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A \u0E1A\u0E23\u0E21\u0E19\u0E32\u0E16\u0E1A\u0E1E\u0E34\u0E15\u0E23"
                    }
                },
                "12-10": {
                    name: {
                        en: "Constitution Day",
                        th: "\u0E27\u0E31\u0E19\u0E23\u0E31\u0E10\u0E18\u0E23\u0E23\u0E21\u0E19\u0E39\u0E0D"
                    }
                },
                "12-31": {
                    _name: "12-31"
                },
                "2010-03-01": {
                    _name: "Makha Bucha"
                },
                "2011-02-18": {
                    _name: "Makha Bucha"
                },
                "2012-03-07": {
                    _name: "Makha Bucha"
                },
                "2013-02-25": {
                    _name: "Makha Bucha"
                },
                "2014-02-14": {
                    _name: "Makha Bucha"
                },
                "2015-03-04": {
                    _name: "Makha Bucha"
                },
                "2016-02-22": {
                    _name: "Makha Bucha"
                },
                "2017-02-11": {
                    _name: "Makha Bucha"
                },
                "2018-03-01": {
                    _name: "Makha Bucha"
                },
                "2019-02-19": {
                    _name: "Makha Bucha"
                },
                "2020-02-08": {
                    _name: "Makha Bucha"
                },
                "2021-02-26": {
                    _name: "Makha Bucha"
                },
                "2022-02-16": {
                    _name: "Makha Bucha"
                },
                "2023-03-06": {
                    _name: "Makha Bucha"
                },
                "2024-02-24": {
                    _name: "Makha Bucha"
                },
                "2025-02-13": {
                    _name: "Makha Bucha"
                },
                "2026-03-03": {
                    _name: "Makha Bucha"
                },
                "2010-05-28": {
                    _name: "Vesak"
                },
                "2011-05-17": {
                    _name: "Vesak"
                },
                "2012-05-06": {
                    _name: "Vesak"
                },
                "2013-05-25": {
                    _name: "Vesak"
                },
                "2014-05-15": {
                    _name: "Vesak"
                },
                "2015-06-02": {
                    _name: "Vesak"
                },
                "2016-05-22": {
                    _name: "Vesak"
                },
                "2017-05-10": {
                    _name: "Vesak"
                },
                "2018-05-29": {
                    _name: "Vesak"
                },
                "2019-05-19": {
                    _name: "Vesak"
                },
                "2020-05-07": {
                    _name: "Vesak"
                },
                "2021-05-26": {
                    _name: "Vesak"
                },
                "2022-05-15": {
                    _name: "Vesak"
                },
                "2022-05-16": {
                    substitute: true,
                    _name: "Vesak"
                },
                "2023-05-04": {
                    _name: "Vesak"
                },
                "2024-05-22": {
                    _name: "Vesak"
                },
                "2025-05-12": {
                    _name: "Vesak"
                },
                "2026-05-31": {
                    _name: "Vesak"
                },
                "2010-07-25": {
                    _name: "Asalha Puja"
                },
                "2011-07-15": {
                    _name: "Asalha Puja"
                },
                "2012-08-02": {
                    _name: "Asalha Puja"
                },
                "2013-07-22": {
                    _name: "Asalha Puja"
                },
                "2014-07-11": {
                    _name: "Asalha Puja"
                },
                "2015-07-30": {
                    _name: "Asalha Puja"
                },
                "2016-07-19": {
                    _name: "Asalha Puja"
                },
                "2017-07-08": {
                    _name: "Asalha Puja"
                },
                "2018-07-27": {
                    _name: "Asalha Puja"
                },
                "2019-07-16": {
                    _name: "Asalha Puja"
                },
                "2020-07-04": {
                    _name: "Asalha Puja"
                },
                "2021-07-24": {
                    _name: "Asalha Puja"
                },
                "2022-07-13": {
                    _name: "Asalha Puja"
                },
                "2023-07-31": {
                    _name: "Asalha Puja"
                },
                "2024-07-19": {
                    _name: "Asalha Puja"
                },
                "2025-07-10": {
                    _name: "Asalha Puja"
                },
                "2026-07-29": {
                    _name: "Asalha Puja"
                },
                "2010-07-26": {
                    _name: "Buddhist Lent"
                },
                "2011-07-16": {
                    _name: "Buddhist Lent"
                },
                "2012-08-03": {
                    _name: "Buddhist Lent"
                },
                "2013-07-23": {
                    _name: "Buddhist Lent"
                },
                "2014-07-12": {
                    _name: "Buddhist Lent"
                },
                "2015-07-31": {
                    _name: "Buddhist Lent"
                },
                "2016-07-20": {
                    _name: "Buddhist Lent"
                },
                "2017-07-09": {
                    _name: "Buddhist Lent"
                },
                "2018-07-28": {
                    _name: "Buddhist Lent"
                },
                "2019-07-17": {
                    _name: "Buddhist Lent"
                },
                "2020-07-05": {
                    _name: "Buddhist Lent"
                },
                "2021-07-25": {
                    _name: "Buddhist Lent"
                },
                "2022-07-14": {
                    _name: "Buddhist Lent"
                },
                "2023-08-01": {
                    _name: "Buddhist Lent"
                },
                "2024-07-20": {
                    _name: "Buddhist Lent"
                },
                "2025-07-11": {
                    _name: "Buddhist Lent"
                },
                "2026-07-30": {
                    _name: "Buddhist Lent"
                }
            }
        },
        TN: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629",
                fr: "R\xe9publique tunisienne",
                en: "Tunisia"
            },
            langs: [
                "ar",
                "fr"
            ],
            zones: [
                "Africa/Tunis"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-14": {
                    name: {
                        fr: "F\xeate de la R\xe9volution et de la Jeunesse",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062B\u0648\u0631\u0629 \u0648 \u0627\u0644\u0634\u0628\u0627\u0628"
                    }
                },
                "03-20": {
                    name: {
                        fr: "F\xeate de l'ind\xe9pendance",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0625\u0633\u062A\u0642\u0644\u0627\u0644"
                    }
                },
                "04-09": {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0647\u062F\u0627\u0621"
                    }
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal"
                },
                "1 Muharram": {
                    _name: "1 Muharram"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-25": {
                    name: {
                        fr: "F\xeate de la R\xe9publique",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629"
                    }
                },
                "08-13": {
                    name: {
                        fr: "F\xeate de la Femme et de la Famille",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0645\u0631\u0623\u0629"
                    }
                },
                "10-15": {
                    name: {
                        fr: "F\xeate de l'\xc9vacuation",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062C\u0644\u0627\u0621"
                    }
                }
            }
        },
        TO: {
            names: {
                to: "Pule\u02BBanga Fakatu\u02BBi \u02BBo Tonga",
                en: "Tonga"
            },
            langs: [
                "to",
                "en"
            ],
            zones: [
                "Pacific/Tongatapu"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-25": {
                    name: {
                        en: "ANZAC Day"
                    }
                },
                "06-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "07-04": {
                    name: {
                        en: "Official Birthday of His Majesty King Tupou VI"
                    }
                },
                "09-17 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
                    name: {
                        en: "Birthday of His Royal Highness The Crown Prince Tupoto\u02BBa-\u02BBUlukalala"
                    }
                },
                "11-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
                    _name: "Constitution Day",
                    name: {
                        en: "Constitutional Day"
                    }
                },
                "12-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday": {
                    name: {
                        en: "Tupou I Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        },
        TR: {
            names: {
                tr: "T\xfcrkiye",
                en: "Turkey"
            },
            dayoff: "saturday",
            langs: [
                "tr"
            ],
            zones: [
                "Europe/Istanbul"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "04-23": {
                    name: {
                        en: "National Sovereignty and Children's Day",
                        tr: "Ulusal Egemenlik ve \xc7ocuk Bayram\u0131"
                    }
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Labour and Solidarity Day",
                        tr: "Emek ve Dayan\u0131\u015Fma G\xfcn\xfc"
                    }
                },
                "05-19": {
                    name: {
                        en: "Commemoration of Atat\xfcrk, Youth and Sports Day",
                        tr: "Atat\xfcrk'\xfc Anma Gen\xe7lik ve Spor Bayram\u0131"
                    }
                },
                "07-15": {
                    name: {
                        en: "Democracy and National Unity Day",
                        tr: "Demokrasi ve Mill\xee Birlik G\xfcn\xfc"
                    }
                },
                "08-30": {
                    name: {
                        en: "Victory Day",
                        tr: "Zafer Bayram\u0131"
                    }
                },
                "10-29": {
                    name: {
                        en: "Republic Day",
                        tr: "Cumhuriyet Bayram\u0131"
                    }
                },
                "1 Shawwal PT90H": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah PT114H": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        TT: {
            names: {
                en: "Trinidad & Tobago"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1",
                    type: "observance"
                },
                "03-30 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Spiritual Baptist Liberation Day"
                    }
                },
                "easter 60": {
                    _name: "easter 60"
                },
                "05-30 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Indian Arrival Day"
                    }
                },
                "06-19 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "08-01 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "08-31 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "09-24 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Republic Day"
                    }
                },
                "12-25 and if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-26"
                },
                "1 Shawwal and if Sunday then next Monday": {
                    substitute: true,
                    _name: "1 Shawwal"
                },
                "2012-11-13": {
                    _name: "Deepavali"
                },
                "2013-11-03": {
                    _name: "Deepavali"
                },
                "2013-11-04": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2014-10-23": {
                    _name: "Deepavali"
                },
                "2015-11-11": {
                    _name: "Deepavali"
                },
                "2016-10-29": {
                    _name: "Deepavali"
                },
                "2017-10-19": {
                    _name: "Deepavali"
                },
                "2018-11-07": {
                    _name: "Deepavali"
                },
                "2019-10-27": {
                    _name: "Deepavali"
                },
                "2019-10-28": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2020-11-14": {
                    _name: "Deepavali"
                },
                "2021-11-04": {
                    _name: "Deepavali"
                },
                "2022-10-24": {
                    _name: "Deepavali"
                },
                "2023-11-12": {
                    _name: "Deepavali"
                },
                "2023-11-13": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2024-10-31": {
                    _name: "Deepavali"
                },
                "2025-10-20": {
                    _name: "Deepavali"
                },
                "2026-11-08": {
                    _name: "Deepavali"
                },
                "2026-11-09": {
                    substitute: true,
                    _name: "Deepavali"
                },
                "2027-10-28": {
                    _name: "Deepavali"
                },
                "2028-10-17": {
                    _name: "Deepavali"
                },
                "2029-11-05": {
                    _name: "Deepavali"
                },
                "2030-10-25": {
                    _name: "Deepavali"
                }
            }
        },
        TW: {
            names: {
                zh: "\u4E2D\u83EF\u6C11\u570B",
                en: "Taiwan"
            },
            langs: [
                "zh"
            ],
            zones: [
                "Asia/Taipei"
            ],
            dayoff: "",
            days: {
                "01-01 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01",
                    name: {
                        zh: "\u4E2D\u83EF\u6C11\u570B\u958B\u570B\u7D00\u5FF5\u65E5 / \u5143\u65E6",
                        en: "Founding of the Republic of China"
                    }
                },
                "chinese 01-0-00": {
                    name: {
                        en: "Chinese New Year's Eve",
                        zh: "\u8FB2\u66C6\u9664\u5915"
                    }
                },
                "chinese 01-0-01": {
                    name: {
                        en: "Chinese New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E00"
                    }
                },
                "chinese 01-0-01 if Monday then next Friday if Tuesday then next Saturdayif Wednesday then next Sunday if Thursday then next Monday if Friday then next Tuesday if Saturday then next Wednesday if Sunday then next Thursday": {
                    name: {
                        en: "Chinese New Year Holiday",
                        zh: "\u519C\u5386\u65B0\u5E74\u5047\u671F"
                    }
                },
                "chinese 01-0-02": {
                    name: {
                        en: "The second day of the Chinese New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E8C"
                    }
                },
                "chinese 01-0-03": {
                    name: {
                        en: "The third day of the Chinese New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E09"
                    }
                },
                "chinese 01-0-04": {
                    name: {
                        en: "The forth day of the Chinese New Year",
                        zh: "\u8FB2\u66C6\u5E74\u521D\u56DB"
                    }
                },
                "02-28 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Peace Memorial Day",
                        zh: "228\u548C\u5E73\u7D00\u5FF5\u65E5"
                    }
                },
                "04-04 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Children's Day",
                        zh: "\u5152\u7AE5\u7BC0"
                    }
                },
                "chinese 5-01 solarterm and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Tomb Sweeping Day",
                        zh: "\u6DF8\u660E\u7BC0"
                    }
                },
                "chinese 05-0-05 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Dragon Boat Festival",
                        zh: "\u7AEF\u5348\u7BC0"
                    }
                },
                "chinese 08-0-15 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Mid-Autumn Festival",
                        zh: "\u4E2D\u79CB\u7BC0"
                    }
                },
                "10-10 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Day / Double Tenth Day",
                        zh: "\u570B\u6176\u65E5 / \u96D9\u5341\u7BC0"
                    }
                },
                "02-04": {
                    name: {
                        en: "Farmer's Day",
                        zh: "\u8FB2\u6C11\u7BC0"
                    },
                    type: "observance"
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "03-12": {
                    name: {
                        en: "Arbor Day",
                        zh: "\u570B\u7236\u901D\u4E16\u7D00\u5FF5\u65E5"
                    },
                    type: "observance"
                },
                "03-29": {
                    name: {
                        en: "Youth Day",
                        zh: "\u9751\u5E74\u7BC0"
                    },
                    type: "observance"
                },
                "05-01 and if Saturday then previous Friday if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01",
                    name: {
                        zh: "\u52DE\u52D5\u7BC0"
                    },
                    type: "observance",
                    note: "private sector"
                },
                "05-04": {
                    name: {
                        en: "Literary Day",
                        zh: "\u6587\u85DD\u7BC0"
                    },
                    type: "observance"
                },
                "2nd Sunday in May": {
                    _name: "Mothers Day",
                    name: {
                        zh: "\u6BCD\u89AA\u7BC0"
                    },
                    type: "observance"
                },
                "06-03": {
                    name: {
                        en: "Opium Suppression Movement Day",
                        zh: "\u7981\u83F8\u7BC0"
                    },
                    type: "observance"
                },
                "08-08": {
                    _name: "Fathers Day",
                    name: {
                        zh: "\u7236\u89AA\u7BC0"
                    },
                    type: "observance"
                },
                "09-01": {
                    name: {
                        en: "Journalist' Day",
                        zh: "\u8A18\u8005\u7BC0"
                    },
                    type: "observance"
                },
                "09-03": {
                    name: {
                        en: "Armed Forces Day",
                        zh: "\u8ECD\u4EBA\u7BC0"
                    },
                    type: "observance"
                },
                "09-28": {
                    name: {
                        en: "Teachers' Day",
                        zh: "\u5B54\u5B50\u8A95\u8FB0\u7D00\u5FF5\u65E5"
                    },
                    type: "observance"
                },
                "10-21": {
                    name: {
                        en: "Overseas Chinese Day",
                        zh: "\u83EF\u50D1\u7BC0"
                    },
                    type: "observance"
                },
                "10-25": {
                    name: {
                        en: "Taiwan Retrocession Day",
                        zh: "\u81FA\u7063\u5149\u5FA9\u7BC0"
                    },
                    type: "observance"
                },
                "11-12": {
                    name: {
                        en: "Sun Yat-sen's Birthday",
                        zh: "\u570B\u7236\u8A95\u8FB0\u7D00\u5FF5\u65E5"
                    },
                    note: "Also Doctors' Day and Cultural Renaissance Day",
                    type: "observance"
                },
                "december solstice": {
                    name: {
                        en: "Dongzhi Festival",
                        zh: "\u51AC\u81F3"
                    },
                    type: "observance"
                },
                "12-25": {
                    name: {
                        en: "Constitution Day",
                        zh: "\u884C\u61B2\u7D00\u5FF5\u65E5"
                    },
                    type: "observance"
                },
                "chinese 01-0-15": {
                    name: {
                        en: "Lantern Festival",
                        zh: "\u5143\u5BB5\u7BC0"
                    },
                    type: "observance"
                },
                "chinese 01-0-15 #1": {
                    name: {
                        en: "Tourism Day",
                        zh: "\u89C0\u5149\u7BC0"
                    },
                    type: "observance"
                },
                "chinese 02-0-02": {
                    name: {
                        en: "Earth God's Birthday",
                        zh: "\u571F\u5730\u516C\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 02-0-19": {
                    name: {
                        en: "Kuan Yin's Birthday",
                        zh: "\u89C0\u97F3\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 03-0-15": {
                    name: {
                        en: "God of Medicine's Birthday",
                        zh: "\u4FDD\u751F\u5927\u5E1D\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 03-0-23": {
                    name: {
                        en: "Matsu's Birthday",
                        zh: "\u5ABD\u7956\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 04-0-08": {
                    name: {
                        en: "Buddha's Birthday",
                        zh: "\u4F5B\u8A95\u65E5"
                    },
                    type: "observance"
                },
                "chinese 05-0-13": {
                    name: {
                        en: "Kuan Kung's Birthday",
                        zh: "\u95DC\u516C\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 05-0-13 #1": {
                    name: {
                        en: "Cheng Huang's Birthday",
                        zh: "\u57CE\u968D\u723A\u8A95\u8FB0"
                    },
                    type: "observance"
                },
                "chinese 07-0-07": {
                    name: {
                        en: "Qixi Festival",
                        zh: "\u4E03\u5915"
                    },
                    type: "observance"
                },
                "chinese 07-0-15": {
                    name: {
                        en: "Ghost Festival",
                        zh: "\u4E2D\u5143\u7BC0"
                    },
                    type: "observance"
                },
                "chinese 09-0-09": {
                    name: {
                        en: "Double Ninth Festival",
                        zh: "\u91CD\u967D\u7BC0"
                    },
                    type: "observance"
                },
                "chinese 10-0-15": {
                    name: {
                        en: "Saisiat Festival",
                        zh: "\u8CFD\u590F\u7BC0"
                    },
                    type: "observance"
                }
            }
        },
        TZ: {
            names: {
                en: "Tanzania"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-02": {
                    name: {
                        en: "Zanzibar Revolution Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-07": {
                    name: {
                        en: "Karume Day"
                    }
                },
                "04-26": {
                    name: {
                        en: "Union Day"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "07-07": {
                    name: {
                        en: "Saba Saba Day"
                    }
                },
                "08-08": {
                    name: {
                        en: "Nane Nane Day"
                    }
                },
                "10-14": {
                    name: {
                        en: "Nyerere Day"
                    }
                },
                "12-09": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-25"
                },
                "1 Shawwal P2D": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                },
                "12 Rabi al-awwal": {
                    _name: "12 Rabi al-awwal",
                    name: {
                        en: "Maulid Day"
                    }
                }
            }
        },
        UA: {
            names: {
                uk: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
                en: "Ukraine"
            },
            langs: [
                "uk"
            ],
            zones: [
                "Europe/Kiev",
                "Europe/Uzhgorod",
                "Europe/Zaporozhye"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if saturday, sunday then next tuesday": {
                    _name: "01-01",
                    name: {
                        en: "New Year"
                    },
                    substitute: true
                },
                "01-02 and if saturday, sunday then next monday": {
                    _name: "01-01",
                    name: {
                        en: "New Year"
                    },
                    substitute: true
                },
                "julian 12-25 and if saturday, sunday then next monday prior to 2023": {
                    _name: "julian 12-25",
                    substitute: true
                },
                "03-08 and if saturday, sunday then next monday": {
                    _name: "03-08"
                },
                "orthodox and if sunday then next monday": {
                    _name: "orthodox"
                },
                "orthodox 49 and if sunday then next monday": {
                    _name: "easter 49"
                },
                "05-01 and if saturday, sunday then next tuesday": {
                    _name: "05-01",
                    substitute: true
                },
                "05-02 and if saturday, sunday then next monday prior to 2018": {
                    _name: "05-01",
                    substitute: true
                },
                "05-09 and if saturday, sunday then next monday": {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u043F\u0435\u0440\u0435\u043C\u043E\u0433\u0438 \u043D\u0430\u0434 \u043D\u0430\u0446\u0438\u0437\u043C\u043E\u043C \u0443 \u0414\u0440\u0443\u0433\u0456\u0439 \u0441\u0432\u0456\u0442\u043E\u0432\u0456\u0439 \u0432\u0456\u0439\u043D\u0456",
                        en: "Victory Day"
                    },
                    substitute: true
                },
                "06-28 and if saturday, sunday then next monday": {
                    _name: "Constitution Day",
                    substitute: true
                },
                "07-15 and if saturday, sunday then next monday since 2023": {
                    name: {
                        en: "Statehood Day",
                        uk: "\u0414\u0435\u043D\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u0457 \u0414\u0435\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0456"
                    }
                },
                "07-28 and if saturday, sunday then next monday prior to 2023": {
                    name: {
                        en: "Statehood Day",
                        uk: "\u0414\u0435\u043D\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u0457 \u0414\u0435\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0456"
                    }
                },
                "08-24 and if saturday, sunday then next monday": {
                    _name: "Independence Day",
                    substitute: true
                },
                "10-14 and if saturday, sunday then next monday since 2015 and prior to 2023": {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u043A\u0430 \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
                        en: "Defenders of Ukraine Day"
                    },
                    substitute: true
                },
                "10-01 and if saturday, sunday then next monday since 2023": {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u043A\u0456\u0432 \u0456 \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u0446\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
                        en: "Defenders of Ukraine Day"
                    },
                    substitute: true
                },
                "12-25 and if saturday, sunday then next monday since 2017": {
                    _name: "12-25"
                }
            }
        },
        UG: {
            names: {
                en: "Uganda"
            },
            dayoff: "sundays",
            langs: [
                "en",
                "sw"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-26": {
                    name: {
                        en: "Liberation Day"
                    }
                },
                "02-16": {
                    name: {
                        en: "Archbishop Janan Luwum Day"
                    }
                },
                "03-08": {
                    _name: "03-08"
                },
                "easter -46": {
                    _name: "easter -46",
                    type: "observance"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-03": {
                    name: {
                        en: "Martyr's Day"
                    }
                },
                "06-09": {
                    name: {
                        en: "National Heroes Day"
                    }
                },
                "10-09": {
                    _name: "Independence Day"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        US: {
            names: {
                en: "United States of America"
            },
            dayoff: "sunday",
            zones: [
                "America/New_York",
                "America/Detroit",
                "America/Kentucky/Louisville",
                "America/Kentucky/Monticello",
                "America/Indiana/Indianapolis",
                "America/Indiana/Vincennes",
                "America/Indiana/Winamac",
                "America/Indiana/Marengo",
                "America/Indiana/Petersburg",
                "America/Indiana/Vevay",
                "America/Chicago",
                "America/Indiana/Tell_City",
                "America/Indiana/Knox",
                "America/Menominee",
                "America/North_Dakota/Center",
                "America/North_Dakota/New_Salem",
                "America/North_Dakota/Beulah",
                "America/Denver",
                "America/Boise",
                "America/Phoenix",
                "America/Los_Angeles",
                "America/Metlakatla",
                "America/Anchorage",
                "America/Juneau",
                "America/Sitka",
                "America/Yakutat",
                "America/Nome",
                "America/Adak",
                "Pacific/Honolulu"
            ],
            langs: [
                "en-us",
                "en"
            ],
            days: {
                "01-01 and if sunday then next monday if saturday then previous friday": {
                    substitute: true,
                    _name: "01-01"
                },
                "3rd monday in January": {
                    name: {
                        en: "Martin Luther King Jr. Day",
                        es: "Natalicio de Martin Luther King, Jr."
                    }
                },
                "3rd monday in February": {
                    name: {
                        en: "Washington's Birthday",
                        es: "D\xeda de los Presidentes"
                    }
                },
                "02-14": {
                    _name: "02-14",
                    type: "observance"
                },
                "03-17": {
                    name: {
                        en: "St. Patrick's Day"
                    },
                    type: "observance"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-15 if friday then next monday if saturday,sunday then next tuesday": {
                    name: {
                        en: "Tax Day"
                    },
                    type: "observance"
                },
                "wednesday before 04-28": {
                    name: {
                        en: "Administrative Professionals Day"
                    },
                    type: "observance"
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "monday before 06-01": {
                    name: {
                        en: "Memorial Day",
                        es: "Recordaci\xf3n de los Muertos de la Guerra"
                    }
                },
                "06-19 and if sunday then next monday if saturday then previous friday since 2021": {
                    substitute: true,
                    name: {
                        en: "Juneteenth"
                    }
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "07-04 and if sunday then next monday if saturday then previous friday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "1st monday in September": {
                    _name: "05-01"
                },
                "2nd monday in October": {
                    name: {
                        en: "Columbus Day",
                        es: "Descubrimiento de Am\xe9rica"
                    }
                },
                "10-31 18:00": {
                    name: {
                        en: "Halloween"
                    },
                    type: "observance"
                },
                "11-11": {
                    name: {
                        en: "Veterans Day",
                        es: "D\xeda del Veterano"
                    }
                },
                "substitutes 11-11 if sunday then next monday if saturday then previous friday": {
                    substitute: true,
                    name: {
                        en: "Veterans Day",
                        es: "D\xeda del Veterano"
                    },
                    type: "bank",
                    note: "Federal Government offices are closed"
                },
                "tuesday after 1st monday in November every 4 years since 1848": {
                    name: {
                        en: "Election Day"
                    },
                    type: "observance"
                },
                "4th thursday in November": {
                    name: {
                        en: "Thanksgiving Day",
                        es: "Acci\xf3n de Gracias"
                    }
                },
                "friday after 4th thursday in November": {
                    name: {
                        en: "Day after Thanksgiving Day",
                        es: "Dia despues Acci\xf3n de Gracias"
                    },
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24",
                    type: "optional"
                },
                "12-25 and if sunday then next monday if saturday then previous friday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                }
            },
            states: {
                AL: {
                    name: "Alabama",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Robert E. Lee/Martin Luther King Birthday"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "George Washington/Thomas Jefferson Birthday"
                            }
                        },
                        "4th monday in April": {
                            name: {
                                en: "Confederate Memorial Day"
                            }
                        },
                        "1st monday in June": {
                            name: {
                                en: "Jefferson Davis' birthday"
                            }
                        }
                    }
                },
                AK: {
                    name: "Alaska",
                    zones: [
                        "America/Anchorage",
                        "America/Metlakatla",
                        "America/Juneau",
                        "America/Sitka",
                        "America/Yakutat",
                        "America/Nome"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "monday before April": {
                            name: {
                                en: "Seward's Day"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2017-01-01"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2017-01-01"
                                }
                            ]
                        },
                        "10-18": {
                            name: {
                                en: "Alaska Day"
                            }
                        }
                    }
                },
                AZ: {
                    name: "Arizona",
                    zones: [
                        "America/Phoenix",
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Dr. Martin Luther King Jr./ Civil Rights Day"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "Lincoln/Washington Presidents' Day"
                            }
                        }
                    }
                },
                AR: {
                    name: "Arkansas",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Dr. Martin Luther King Jr./Robert E. Lee's Birthdays"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "George Washington's Birthday/Daisy Gatson Bates Day"
                            }
                        },
                        "12-24": {
                            _name: "12-24"
                        }
                    }
                },
                CA: {
                    name: "California",
                    zones: [
                        "America/Los_Angeles"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "2nd monday in October": false,
                        "02-15": {
                            type: "observance",
                            name: {
                                en: "Susan B. Anthony Day"
                            }
                        },
                        "03-31 and if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "C\xe9sar Ch\xe1vez Day"
                            }
                        },
                        "05-19": {
                            type: "observance",
                            name: {
                                en: "Malcolm X Day"
                            }
                        },
                        "05-23": {
                            type: "observance",
                            name: {
                                en: "Harvey Milk Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving Day"
                            },
                            type: "public"
                        }
                    },
                    regions: {
                        LA: {
                            name: "Los Angeles",
                            days: {
                                "08-24": {
                                    name: {
                                        en: "Kobe Bryant Day"
                                    },
                                    type: "observance",
                                    active: [
                                        {
                                            from: 2016
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                CO: {
                    name: "Colorado",
                    zones: [
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Washington-Lincoln Day"
                            }
                        },
                        "2nd monday in October": {
                            type: "observance"
                        }
                    }
                },
                CT: {
                    name: "Connecticut",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "easter -2": {
                            _name: "easter -2"
                        }
                    }
                },
                DE: {
                    name: "Delaware",
                    days: {
                        "2nd monday in October": false,
                        "3rd monday in February": false,
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day After Thanksgiving"
                            }
                        },
                        "tuesday after 1st monday in November in even years": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    }
                },
                DC: {
                    name: "District of Columbia",
                    days: {
                        "04-16": {
                            name: {
                                en: "Emancipation Day"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2019-10-08"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2019-10-09"
                                }
                            ]
                        }
                    }
                },
                FL: {
                    name: "Florida",
                    days: {
                        "2nd monday in October": false,
                        "3rd monday in February": false,
                        "02-15": {
                            name: {
                                en: "Susan B. Anthony Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day After Thanksgiving"
                            }
                        }
                    }
                },
                GA: {
                    name: "Georgia",
                    days: {
                        "3rd monday in February": false,
                        "monday before 05-01 #1": {
                            name: {
                                en: "Confederate Memorial Day"
                            },
                            active: [
                                {
                                    to: "2016-01-01"
                                }
                            ]
                        },
                        "monday before 05-01 #2": {
                            name: {
                                en: "State Holiday"
                            },
                            note: "Known as Confederate Memorial Day prior to 2016",
                            active: [
                                {
                                    from: "2016-01-01"
                                }
                            ]
                        },
                        "friday after 4th thursday in November #1": {
                            name: {
                                en: "Robert E. Lee's Birthday"
                            },
                            note: "General Lee was born on 1807-01-19 but this holiday was traditionally observed the day after Thanksgiving.",
                            active: [
                                {
                                    to: "2016-01-01"
                                }
                            ]
                        },
                        "friday after 4th thursday in November #2": {
                            name: {
                                en: "State Holiday"
                            },
                            note: "Known as Robert E. Lee's Birtday prior to 2016",
                            active: [
                                {
                                    from: "2016-01-01"
                                }
                            ]
                        },
                        "12-24": {
                            name: {
                                en: "Washington's Birthday"
                            }
                        },
                        "substitutes 12-24 if wednesday then next friday": {
                            substitute: true,
                            name: {
                                en: "Washington's Birthday"
                            }
                        }
                    }
                },
                HI: {
                    name: "Hawaii",
                    zones: [
                        "Pacific/Honolulu"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "03-26 and if saturday then previous friday if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Prince Jonah Kuhio Kalanianaole Day"
                            }
                        },
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "06-11 and if saturday then previous friday if sunday then next monday": {
                            substitute: true,
                            name: {
                                en: "Kamehameha Day"
                            }
                        },
                        "3rd friday in August": {
                            name: {
                                en: "Statehood Day"
                            }
                        },
                        "2nd monday in October": false,
                        "tuesday after 1st monday in November in even years": {
                            name: {
                                en: "General Election Day"
                            }
                        }
                    }
                },
                ID: {
                    name: "Idaho",
                    zones: [
                        "America/Boise",
                        "America/Los_Angeles"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Martin Luther King, Jr./ Idaho Human Rights Day"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        }
                    }
                },
                IL: {
                    name: "Illinois",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "1st monday in March": {
                            name: {
                                en: "Casimir Pulaski Day"
                            }
                        },
                        "05-19": {
                            name: {
                                en: "Malcolm X Day"
                            }
                        },
                        "tuesday after 1st monday in November in even years": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    }
                },
                IN: {
                    name: "Indiana",
                    zones: [
                        "America/Indiana/Indianapolis",
                        "America/Indiana/Vincennes",
                        "America/Indiana/Winamac",
                        "America/Indiana/Marengo",
                        "America/Indiana/Petersburg",
                        "America/Indiana/Vevay",
                        "America/Indiana/Tell_City",
                        "America/Indiana/Knox"
                    ],
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "tuesday after 1st monday in May": {
                            name: {
                                en: "Primary Election Day"
                            }
                        },
                        "tuesday after 1st monday in November": {
                            name: {
                                en: "Election Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        }
                    }
                },
                IA: {
                    name: "Iowa",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2018-10-07"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2018-10-08"
                                }
                            ]
                        }
                    }
                },
                KS: {
                    name: "Kansas",
                    zones: [
                        "America/Chicago",
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": false
                    }
                },
                KY: {
                    name: "Kentucky",
                    zones: [
                        "America/Kentucky/Louisville",
                        "America/Kentucky/Monticello"
                    ],
                    days: {
                        "3rd monday in February": false,
                        "easter -2 14:00": {
                            _name: "easter -2"
                        },
                        "12-24": {
                            _name: "12-24"
                        },
                        "12-31": {
                            _name: "12-31"
                        }
                    }
                },
                LA: {
                    name: "Louisiana",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "tuesday after 1st monday in November in even years": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    },
                    regions: {
                        NO: {
                            name: "New Orleans",
                            days: {
                                "easter -47": {
                                    _name: "easter -47",
                                    name: {
                                        en: "Mardi Gras"
                                    }
                                }
                            }
                        }
                    }
                },
                ME: {
                    name: "Maine",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Washington's Birthday/President's Day"
                            }
                        },
                        "3rd monday in April": {
                            name: {
                                en: "Patriots' Day"
                            }
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2019-04-26"
                                }
                            ]
                        }
                    }
                },
                MD: {
                    name: "Maryland",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "friday before 1st monday before 06-01 since 2009 and prior to 2016": {
                            name: {
                                en: "Service Reduction Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Native American Heritage Day"
                            }
                        }
                    }
                },
                MA: {
                    name: "Massachusetts",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "03-17": {
                            name: {
                                en: "Evacuation Day"
                            }
                        },
                        "3rd monday in April": {
                            name: {
                                en: "Patriots' Day"
                            }
                        },
                        "06-17": {
                            name: {
                                en: "Bunker Hill Day"
                            }
                        }
                    }
                },
                MI: {
                    name: "Michigan",
                    zones: [
                        "America/Detroit",
                        "America/Menominee"
                    ],
                    days: {
                        "12-24": {
                            _name: "12-24"
                        },
                        "12-31": {
                            _name: "12-31"
                        }
                    }
                },
                MN: {
                    name: "Minnesota",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Washington's and Lincoln's Birthday"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2017-01-01"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2017-01-01"
                                }
                            ]
                        }
                    }
                },
                MS: {
                    name: "Mississippi",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Martin Luther King's and Robert E. Lee's Birthdays"
                            }
                        },
                        "monday before 05-01": {
                            name: {
                                en: "Confederate Memorial Day"
                            }
                        }
                    }
                },
                MO: {
                    name: "Missouri",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "05-08": {
                            name: {
                                en: "Truman Day"
                            }
                        }
                    }
                },
                MT: {
                    name: "Montana",
                    zones: [
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Lincoln's and Washington's Birthday"
                            }
                        },
                        "tuesday after 1st monday in November": {
                            name: {
                                en: "Election Day"
                            }
                        },
                        "12-24": {
                            _name: "12-24"
                        },
                        "12-31": {
                            _name: "12-31"
                        }
                    }
                },
                NE: {
                    name: "Nebraska",
                    zones: [
                        "America/Chicago",
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "friday before 05-01": {
                            name: {
                                en: "Arbor Day"
                            }
                        }
                    }
                },
                NV: {
                    name: "Nevada",
                    zones: [
                        "America/Los_Angeles"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents Day"
                            }
                        },
                        "2nd monday in October": false,
                        "08-09": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2017-01-01"
                                }
                            ],
                            type: "observance"
                        },
                        "friday before 11-01": {
                            name: {
                                en: "Nevada Day"
                            }
                        },
                        "4th friday in November": {
                            name: {
                                en: "Family Day"
                            }
                        }
                    }
                },
                NH: {
                    name: "New Hampshire",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in January": {
                            name: {
                                en: "Martin Luther King, Jr./ Civil Rights Day"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "2nd monday in October": {
                            type: "observance"
                        },
                        "tuesday after 1st monday in November in even years": {
                            name: {
                                en: "Election Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving"
                            }
                        }
                    }
                },
                NJ: {
                    name: "New Jersey",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "Presidents Day"
                            }
                        },
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "tuesday after 1st monday in November": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    }
                },
                NM: {
                    name: "New Mexico",
                    zones: [
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2019-04-01"
                                }
                            ]
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving"
                            }
                        }
                    }
                },
                NY: {
                    name: "New York",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "02-12": {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        "02-15": {
                            name: {
                                en: "Susan B. Anthony Day"
                            }
                        },
                        "tuesday after 1st monday in November": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    }
                },
                NC: {
                    name: "North Carolina",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": false,
                        "2nd monday in October": false,
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving"
                            }
                        },
                        "12-24 and if friday then previous thursday if saturday,sunday then previous friday": {
                            substitute: true,
                            _name: "12-24"
                        }
                    }
                },
                ND: {
                    name: "North Dakota",
                    zones: [
                        "America/North_Dakota/Center",
                        "America/North_Dakota/New_Salem",
                        "America/North_Dakota/Beulah"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        }
                    }
                },
                OH: {
                    name: "Ohio",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Washington-Lincoln Day"
                            }
                        }
                    }
                },
                OK: {
                    name: "Oklahoma",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving"
                            }
                        }
                    }
                },
                OR: {
                    name: "Oregon",
                    zones: [
                        "America/Los_Angeles"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents Day"
                            }
                        }
                    }
                },
                PA: {
                    name: "Pennsylvania",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "06-14": {
                            name: {
                                en: "Flag Day"
                            }
                        }
                    }
                },
                RI: {
                    name: "Rhode Island",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "2nd monday in August": {
                            name: {
                                en: "Victory Day"
                            }
                        }
                    }
                },
                SC: {
                    name: "South Carolina",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "05-10": {
                            name: {
                                en: "Confederate Memorial Day"
                            }
                        },
                        "12-26": {
                            _name: "12-26"
                        }
                    }
                },
                SD: {
                    name: "South Dakota",
                    zones: [
                        "America/Chicago",
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2015-01-01"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Native American Day"
                            },
                            active: [
                                {
                                    from: "2015-01-01"
                                }
                            ]
                        }
                    }
                },
                TN: {
                    name: "Tennessee",
                    zones: [
                        "America/Chicago",
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "easter -2": {
                            _name: "easter -2"
                        },
                        "12-24": {
                            _name: "12-24"
                        }
                    }
                },
                TX: {
                    name: "Texas",
                    zones: [
                        "America/Chicago",
                        "America/Denver"
                    ],
                    days: {
                        "01-19": {
                            name: {
                                en: "Confederate Heroes Day"
                            },
                            type: "observance",
                            note: "state agencies are partially staffed"
                        },
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "03-02": {
                            name: {
                                en: "Texas Independence Day"
                            },
                            type: "observance",
                            note: "state agencies are partially staffed"
                        },
                        "03-31": {
                            name: {
                                en: "Cesar Chavez Day"
                            },
                            type: "observance"
                        },
                        "easter -2": {
                            _name: "easter -2",
                            type: "observance"
                        },
                        "04-21": {
                            name: {
                                en: "San Jacinto Day"
                            },
                            type: "observance",
                            note: "state agencies are partially staffed"
                        },
                        "06-19": {
                            name: {
                                en: "Emancipation Day In Texas"
                            },
                            type: "observance",
                            note: "state agencies are partially staffed"
                        },
                        "08-27": {
                            name: {
                                en: "Lyndon Baines Johnson Day"
                            },
                            type: "observance",
                            note: "state agencies are partially staffed"
                        },
                        "friday after 4th thursday in November": {
                            name: {
                                en: "Day after Thanksgiving"
                            }
                        },
                        "12-24": {
                            _name: "12-24"
                        },
                        "12-26": {
                            _name: "12-26",
                            name: {
                                en: "Day after Christmas"
                            }
                        }
                    }
                },
                UT: {
                    name: "Utah",
                    zones: [
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Washington and Lincoln Day"
                            }
                        },
                        "07-24": {
                            name: {
                                en: "Pioneer Day"
                            }
                        }
                    }
                },
                VT: {
                    name: "Vermont",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        "1st tuesday in March": {
                            name: {
                                en: "Town Meeting Day"
                            }
                        },
                        "3rd monday in August": {
                            name: {
                                en: "Bennington Battle Day"
                            }
                        },
                        "2nd monday in October": {
                            name: {
                                en: "Columbus Day"
                            },
                            active: [
                                {
                                    to: "2017-09-01"
                                }
                            ]
                        },
                        "2nd monday in October #1": {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: "2017-09-01"
                                }
                            ]
                        }
                    }
                },
                VA: {
                    name: "Virginia",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "George Washington Day"
                            }
                        },
                        "friday before 3rd monday in January prior to 2021": {
                            name: {
                                en: "Lee\u2013Jackson Day"
                            }
                        },
                        "tuesday after 1st monday in November in even years since 2020": {
                            name: "Election Day"
                        }
                    }
                },
                WA: {
                    name: "Washington",
                    zones: [
                        "America/Los_Angeles"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "Presidents' Day"
                            }
                        }
                    }
                },
                WV: {
                    name: "West Virginia",
                    zones: [
                        "America/New_York"
                    ],
                    days: {
                        "02-15": {
                            name: {
                                en: "Susan B. Anthony Day"
                            }
                        },
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        },
                        "06-20": {
                            name: {
                                en: "West Virginia Day"
                            }
                        },
                        "4th friday in November": {
                            name: {
                                en: "Lincoln's Day"
                            }
                        }
                    }
                },
                WI: {
                    name: "Wisconsin",
                    zones: [
                        "America/Chicago"
                    ],
                    days: {
                        "02-15": {
                            name: {
                                en: "Susan B. Anthony Day"
                            }
                        },
                        "2nd tuesday in September": {
                            name: {
                                en: "Primary Election Day"
                            }
                        },
                        "tuesday after 1st monday in November": {
                            name: {
                                en: "Election Day"
                            }
                        }
                    }
                },
                WY: {
                    name: "Wyoming",
                    zones: [
                        "America/Denver"
                    ],
                    days: {
                        "3rd monday in February": {
                            name: {
                                en: "President's Day"
                            }
                        }
                    }
                }
            }
        },
        UY: {
            names: {
                es: "Uruguay",
                en: "Uruguay"
            },
            dayoff: "sunday",
            langs: [
                "es"
            ],
            zones: [
                "America/Montevideo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    type: "observance"
                },
                "easter -48": {
                    name: {
                        en: "Carnival",
                        es: "Carnaval"
                    },
                    type: "observance"
                },
                "easter -47": {
                    _name: "easter -47",
                    type: "observance"
                },
                "easter -6 P5D": {
                    name: {
                        en: "Tourism Week",
                        es: "Semana de Turismo"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "04-19 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
                    name: {
                        en: "Landing of the 33 Orientals",
                        es: "Desembarco de los 33 Orientales"
                    },
                    type: "observance"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-18 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
                    name: {
                        en: "Battle of Las Piedras",
                        es: "Batalla de las Piedras"
                    },
                    type: "observance"
                },
                "06-19": {
                    name: {
                        en: "Birthday of Jos\xe9 Gervasio Artigas and Never Again Day",
                        es: "Natalicio de Artigas y D\xeda del Nunca M\xe1s"
                    },
                    type: "observance"
                },
                "07-18": {
                    _name: "Constitution Day"
                },
                "08-25": {
                    _name: "Independence Day"
                },
                "10-12 if tuesday,wednesday then previous monday if thursday,friday then next monday": {
                    name: {
                        en: "Columbus Day",
                        es: "D\xeda de la Raza"
                    },
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02",
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24",
                    type: "observance"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31",
                    type: "observance"
                }
            }
        },
        VA: {
            names: {
                it: "Stato della Citt\xe0 del Vaticano",
                la: "Status Civitatis Vaticanae",
                en: "Vatican City"
            },
            langs: [
                "it"
            ],
            zones: [
                "Europe/Rome"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    name: {
                        en: "Solemnity of Mary, Mother of God",
                        it: "Maria Santissima Madre di Dio"
                    }
                },
                "01-06": {
                    name: {
                        en: "Epiphany",
                        it: "Epifania del Signore"
                    }
                },
                "02-11": {
                    name: {
                        en: "Anniversary of the foundation of Vatican City",
                        it: "Anniversario della istituzione dello Stato della Citt\xe0 del Vaticano"
                    }
                },
                "03-19": {
                    _name: "03-19"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 39": {
                    _name: "easter 39",
                    active: [
                        {
                            to: 2009
                        }
                    ]
                },
                "easter 60": {
                    _name: "easter 60",
                    active: [
                        {
                            to: 2009
                        }
                    ]
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Saint Joseph the Worker",
                        it: "San Giuseppe lavoratore"
                    }
                },
                "06-29": {
                    _name: "06-29"
                },
                "08-15": {
                    _name: "08-15",
                    name: {
                        it: "Assunzione di Maria in Cielo"
                    }
                },
                "09-08": {
                    name: {
                        en: "Nativity of Mary",
                        it: "Festa della nativit\xe0 della madonna"
                    }
                },
                "11-01": {
                    _name: "11-01"
                },
                "12-08": {
                    _name: "12-08"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                },
                "10-16": {
                    name: {
                        en: "Anniversary of the election of Pope John Paul II",
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 1978,
                            to: 2005
                        }
                    ]
                },
                "11-04": {
                    name: {
                        en: "Saint Charles Borromeo - Name day of the Holy Father",
                        it: "San Carlo Borromeo - Onomastico del Santo Padre"
                    },
                    note: "Name day of Pope John Paul II (Karol J\xf3zef Wojty\u0142a)",
                    active: [
                        {
                            from: 1978,
                            to: 2005
                        }
                    ]
                },
                "04-19": {
                    name: {
                        en: "Anniversary of the election of Pope Benedict XVI",
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 2005,
                            to: 2013
                        }
                    ]
                },
                "03-19#1": {
                    name: {
                        en: "Saint Joseph - Name day of the Holy Father",
                        it: "San Giuseppe - Onomastico del Santo Padre"
                    },
                    note: "Name day of Pope Benedict XVI (Josef Ratzinger)",
                    active: [
                        {
                            from: 2005,
                            to: 2013
                        }
                    ]
                },
                "03-13": {
                    name: {
                        en: "Anniversary of the election of Pope Francis",
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 2013
                        }
                    ]
                },
                "04-23": {
                    name: {
                        en: "Saint George - Name day of the Holy Father",
                        it: "San Giorgio - Onomastico del Santo Padre"
                    },
                    note: "Name day of Pope Francis (Jorge Mario Bergoglio)",
                    active: [
                        {
                            from: 2013
                        }
                    ]
                }
            }
        },
        VC: {
            names: {
                en: "St. Vincent & Grenadines"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "03-14 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "National Hero\u2032s Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "1st Monday in July": {
                    name: {
                        en: "Carnival Monday"
                    },
                    disable: [
                        "2021-06-05"
                    ],
                    enable: [
                        "2021-09-06"
                    ]
                },
                "Tuesday after 1st Monday in July": {
                    name: {
                        en: "Carnival Tuesday"
                    },
                    disable: [
                        "2021-06-06"
                    ],
                    enable: [
                        "2021-09-07"
                    ]
                },
                "08-01 and if Sunday then next Monday": {
                    substitute: true,
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "10-27 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "12-25 and if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Sunday then next Monday": {
                    substitute: true,
                    _name: "12-26"
                }
            }
        },
        VE: {
            names: {
                es: "Venezuela",
                en: "Venezuela"
            },
            dayoff: "sundays",
            langs: [
                "es"
            ],
            zones: [
                "America/Caracas"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "01-06": {
                    _name: "01-06",
                    type: "observance"
                },
                "01-15": {
                    name: {
                        es: "D\xeda del Maestro",
                        en: "Teacher's Day"
                    },
                    type: "optional",
                    note: "teachers only"
                },
                "03-19": {
                    _name: "03-19",
                    type: "observance"
                },
                "easter -48": {
                    name: {
                        en: "Carnival",
                        es: "Carnaval"
                    }
                },
                "easter -47": {
                    _name: "easter -47"
                },
                "easter -6 P7D": {
                    name: {
                        en: "Holy Week",
                        es: "Semana Santa"
                    },
                    type: "observance"
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter"
                },
                "04-19": {
                    name: {
                        en: "Declaration of Independence",
                        es: "Declaraci\xf3n de la Independencia"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "06-24": {
                    name: {
                        en: "Battle of Carabobo",
                        es: "Aniversario de la Batalla de Carabobo"
                    }
                },
                "07-05": {
                    _name: "Independence Day"
                },
                "07-24": {
                    name: {
                        en: "Birthday of Sim\xf3n Bol\xedvar",
                        es: "Natalicio de Sim\xf3n Bol\xedvar"
                    }
                },
                "08-03": {
                    name: {
                        en: "Flag Day",
                        es: "D\xeda de la Bandera"
                    },
                    type: "observance"
                },
                "09-11": {
                    name: {
                        en: "Our Lady of Coromoto",
                        es: "D\xeda de Nuestra Se\xf1ora de Coromoto"
                    },
                    type: "observance"
                },
                "10-12": {
                    name: {
                        en: "Day of Indigenous Resistance",
                        es: "D\xeda de la resistencia ind\xedgena"
                    }
                },
                "11-01": {
                    _name: "11-01",
                    type: "observance"
                },
                "11-02": {
                    _name: "11-02",
                    type: "observance"
                },
                "12-08": {
                    _name: "12-08",
                    type: "observance"
                },
                "12-10": {
                    name: {
                        en: "Venezuelan Air Force Day",
                        es: "D\xeda de la Aviaci\xf3n Nacional"
                    },
                    type: "observance"
                },
                "12-24": {
                    _name: "12-24"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-31": {
                    _name: "12-31"
                }
            },
            states: {
                B: {
                    name: "Anzo\xe1tegui",
                    days: {
                        "11-14": {
                            name: {
                                es: "Natalicio de Jos\xe9 Antonio Anzo\xe1tegui"
                            }
                        }
                    }
                },
                G: {
                    name: "Carabobo",
                    days: {
                        "11-13": {
                            name: {
                                es: "D\xeda de la Virgen del Socorro"
                            }
                        }
                    }
                },
                K: {
                    name: "Lara",
                    days: {
                        "01-14": {
                            name: {
                                es: "D\xeda de La Divina Pastora"
                            }
                        },
                        "05-28": {
                            name: {
                                es: "Natalicio de Jacinto Lara"
                            }
                        }
                    },
                    regions: {
                        BA: {
                            name: "Barquisimeto",
                            days: {
                                "09-14": {
                                    name: {
                                        es: "D\xeda de Barquisimeto"
                                    }
                                }
                            }
                        }
                    }
                },
                M: {
                    name: "Miranda",
                    days: {
                        "03-19": {
                            _name: "03-19"
                        }
                    }
                },
                N: {
                    name: "Monagas",
                    days: {
                        "12-07": {
                            name: {
                                es: "D\xeda de Maturin"
                            }
                        }
                    }
                },
                S: {
                    name: "T\xe1chira",
                    days: {
                        "08-15": {
                            _name: "08-15",
                            name: {
                                es: "D\xeda de la Virgen de Consolaci\xf3n"
                            }
                        }
                    }
                },
                V: {
                    name: "Zulia",
                    days: {
                        "10-24": {
                            name: {
                                es: "Natalicio de Rafael Urdaneta"
                            }
                        },
                        "11-18": {
                            name: {
                                es: "D\xeda de la Virgen de la Chinita"
                            }
                        }
                    }
                }
            }
        },
        VG: {
            names: {
                en: "British Virgin Islands"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "Monday before 03-08": {
                    name: {
                        en: "The Anniversary of the Birth of Hamilton Lavity Stoutt"
                    }
                },
                "2nd Monday in March": {
                    name: {
                        en: "Commonwealth Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "easter 49": {
                    _name: "easter 49",
                    type: "observance"
                },
                "easter 50": {
                    _name: "easter 50"
                },
                "2nd Saturday after 06-02 prior to 2020": {
                    name: {
                        en: "Sovereign\u2019s Birthday"
                    },
                    disable: [
                        "2017-06-10",
                        "2019-06-15"
                    ],
                    enable: [
                        "2017-06-17",
                        "2019-06-07"
                    ]
                },
                "2nd Friday after 06-02 since 2020": {
                    name: {
                        en: "Sovereign\u2019s Birthday"
                    }
                },
                "07-01 if Sunday,Thursday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday": {
                    name: {
                        en: "Virgin Islands Day"
                    }
                },
                "10-21 if Sunday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday if Thursday then next Friday": {
                    name: {
                        en: "St. Ursula\u2019s Day"
                    },
                    disable: [
                        "2016-10-23",
                        "2020-10-19",
                        "2021-10-22"
                    ],
                    enable: [
                        "2016-10-19",
                        "2020-10-23"
                    ]
                },
                "1st Monday in August": {
                    name: {
                        en: "Emancipation Monday"
                    }
                },
                "Tuesday after 1st Monday in August": {
                    name: {
                        en: "Emancipation Tuesday"
                    }
                },
                "Wednesday after 1st Monday in August": {
                    name: {
                        en: "Emancipation Wednesday"
                    }
                },
                "2021-10-18": {
                    name: {
                        en: "Heroes\u2019 and Forefathers Day"
                    }
                },
                "2021-11-08": {
                    name: {
                        en: "Commemoration of the Great March of 1949"
                    }
                },
                "12-25 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-25"
                },
                "12-26 and if Saturday then next Monday if Sunday then next Tuesday": {
                    substitute: true,
                    _name: "12-26"
                }
            }
        },
        VI: {
            names: {
                en: "U.S. Virgin Islands"
            },
            langs: [
                "en"
            ],
            zones: [
                "America/Port_of_Spain"
            ],
            dayoff: "sunday",
            _days: "US",
            days: {
                "01-06": {
                    _name: "01-06",
                    name: {
                        en: "Three Kings Day"
                    }
                },
                "3rd monday in February": {
                    name: {
                        en: "President's Day"
                    }
                },
                "03-17": false,
                "03-31": {
                    name: {
                        en: "Transfer Day"
                    }
                },
                "easter -3": {
                    _name: "easter -3"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "07-03": {
                    name: {
                        en: "Emancipation Day"
                    }
                },
                "4th Monday in July": {
                    name: {
                        en: "Hurricane Supplication Day"
                    }
                },
                "2nd monday in October": {
                    name: {
                        en: "Virgin Islands\u2013Puerto Rico Friendship Day"
                    }
                },
                "10-25": {
                    name: {
                        en: "Hurricane Thanksgiving"
                    },
                    type: "observance"
                },
                "friday after 4th thursday in November": {
                    name: {
                        en: "Day after Thanksgiving Day"
                    },
                    type: "school"
                }
            }
        },
        VN: {
            names: {
                vi: "C\u1ED9ng h\xf2a X\xe3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam",
                en: "Vietnam"
            },
            dayoff: "",
            langs: [
                "vi"
            ],
            zones: [
                "Asia/Ho_Chi_Minh",
                "Asia/Bangkok"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "vietnamese 1-0-1": {
                    name: {
                        en: "Vietnamese New Year",
                        vi: "T\u1EBFt Nguy\xean \u0110\xe1n"
                    }
                },
                "1 day before vietnamese 1-0-1 P5D": {
                    name: {
                        en: "Vietnamese New Year Holidays",
                        vi: "Giao th\u1EEBa T\u1EBFt Nguy\xean \u0110\xe1n"
                    }
                },
                "vietnamese 3-0-10": {
                    name: {
                        en: "Hung Kings Commemorations",
                        vi: "Gi\u1ED7 t\u1ED5 H\xf9ng V\u01B0\u01A1ng"
                    }
                },
                "04-30": {
                    name: {
                        en: "Day of liberating the South for national reunification",
                        vi: "Ng\xe0y Gi\u1EA3i ph\xf3ng mi\u1EC1n Nam"
                    }
                },
                "05-01": {
                    _name: "05-01"
                },
                "09-02": {
                    name: {
                        en: "National Day",
                        vi: "Qu\u1ED1c kh\xe1nh"
                    }
                },
                "02-03": {
                    name: {
                        en: "Communist Party of Viet Nam Foundation Anniversary",
                        vi: "Ng\xe0y th\xe0nh l\u1EADp \u0110\u1EA3ng"
                    },
                    type: "observance"
                },
                "03-08": {
                    _name: "03-08",
                    type: "observance"
                },
                "04-21": {
                    name: {
                        en: "Vietnam Book Day",
                        vi: "Ng\xe0y S\xe1ch Vi\u1EC7t Nam"
                    },
                    type: "observance"
                },
                "05-07": {
                    name: {
                        en: "Dien Bien Phu Victory Day",
                        vi: "Ng\xe0y Chi\u1EBFn th\u1EAFng \u0110i\u1EC7n Bi\u1EC7n Ph\u1EE7"
                    },
                    type: "observance"
                },
                "05-19": {
                    name: {
                        en: "President Ho Chi Minh's Birthday",
                        vi: "Ng\xe0y sinh Ch\u1EE7 t\u1ECBch H\u1ED3 Ch\xed Minh"
                    },
                    type: "observance"
                },
                "06-01": {
                    name: {
                        en: "International Children's Day",
                        vi: "Ng\xe0y qu\u1ED1c t\u1EBF Thi\u1EBFu nhi"
                    },
                    type: "observance"
                },
                "06-28": {
                    name: {
                        en: "Vietnamese Family Day",
                        vi: "Ng\xe0y Gia \u0111\xecnh Vi\u1EC7t Nam"
                    },
                    type: "observance"
                },
                "07-27": {
                    name: {
                        en: "Remembrance Day",
                        vi: "Ng\xe0y Th\u01B0\u01A1ng Binh Li\u1EC7t S\u0129"
                    },
                    type: "observance"
                },
                "08-19": {
                    name: {
                        en: "August Revolution Commemoration Day",
                        vi: "Ng\xe0y c\xe1ch m\u1EA1ng Th\xe1ng T\xe1m"
                    },
                    type: "observance"
                },
                "10-10": {
                    name: {
                        en: "Capital Liberation Day",
                        vi: "Ng\xe0y gi\u1EA3i ph\xf3ng Th\u1EE7 \u0110\xf4"
                    },
                    type: "observance"
                },
                "10-20": {
                    name: {
                        en: "Vietnamese Women's Day",
                        vi: "Ng\xe0y Ph\u1EE5 n\u1EEF Vi\u1EC7t Nam"
                    },
                    type: "observance"
                },
                "11-20": {
                    name: {
                        en: "Vietnamese Teacher's Day",
                        vi: "Ng\xe0y Nh\xe0 gi\xe1o Vi\u1EC7t Nam"
                    },
                    type: "observance"
                },
                "12-22": {
                    name: {
                        en: "National Defence Day",
                        vi: "Ng\xe0y h\u1ED9i Qu\u1ED1c ph\xf2ng To\xe0n d\xe2n"
                    },
                    type: "observance"
                },
                "vietnamese 1-0-5": {
                    name: {
                        en: "Victory of Ng\u1ECDc H\u1ED3i-\u0110\u1ED1ng \u0110a",
                        vi: "Chi\u1EBFn th\u1EAFng Ng\u1ECDc H\u1ED3i - \u0110\u1ED1ng \u0110a"
                    },
                    type: "observance"
                },
                "vietnamese 1-0-15": {
                    name: {
                        en: "Lantern Festival",
                        vi: "T\u1EBFt Nguy\xean Ti\xeau"
                    },
                    type: "observance"
                },
                "vietnamese 4-0-15": {
                    name: {
                        en: "Buddha's Birthday",
                        vi: "L\u1EC5 Ph\u1EADt \u0111\u1EA3n"
                    },
                    type: "observance"
                },
                "vietnamese 5-0-5": {
                    name: {
                        en: "Mid-year Festival",
                        vi: "T\u1EBFt \u0110oan ng\u1ECD"
                    },
                    type: "observance"
                },
                "vietnamese 7-0-15": {
                    name: {
                        en: "Ghost Festival",
                        vi: "R\u1EB1m Th\xe1ng B\u1EA3y, Vu Lan"
                    },
                    type: "observance"
                },
                "vietnamese 8-0-15": {
                    name: {
                        en: "Mid-Autumn Festival",
                        vi: "T\u1EBFt Trung thu"
                    },
                    type: "observance"
                },
                "vietnamese 12-0-23": {
                    name: {
                        en: "Kitchen guardians",
                        vi: "\xd4ng T\xe1o ch\u1EA7u tr\u1EDDi"
                    },
                    type: "observance"
                }
            }
        },
        VU: {
            names: {
                en: "Vanuatu",
                fr: "R\xe9publique de Vanuatu"
            },
            langs: [
                "fr",
                "en",
                "bi"
            ],
            zones: [
                "Pacific/Efate"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "02-21": {
                    name: "M\xe9moire du p\xe8re de l'ind\xe9pendance R\xe9v. Dr. W.H. Lini"
                },
                "02-22": {
                    _name: "Public Holiday"
                },
                "03-05": {
                    name: "F\xeate des chefs coutumiers"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01": {
                    _name: "05-01"
                },
                "easter 39": {
                    _name: "easter 39"
                },
                "07-24": {
                    name: "Journ\xe9e Mondiale des Enfants"
                },
                "07-30": {
                    _name: "Independence Day"
                },
                "08-15": {
                    _name: "08-15"
                },
                "08-16": {
                    _name: "Public Holiday"
                },
                "10-05": {
                    _name: "Constitution Day"
                },
                "10-29": {
                    name: "Jour de l'Unit\xe9"
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    name: "F\xeate de Famille"
                },
                "12-27": {
                    _name: "Public Holiday"
                }
            }
        },
        XK: {
            names: {
                sq: "Republika e Kosov\xebs",
                sr: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E",
                en: "Kosovo"
            },
            langs: [
                "sq",
                "sr"
            ],
            zones: [
                "Europe/Belgrade"
            ],
            dayoff: "sunday",
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "julian 12-25": {
                    _name: "julian 12-25"
                },
                "02-17": {
                    _name: "Independence Day"
                },
                "04-09": {
                    _name: "Constitution Day"
                },
                easter: {
                    _name: "easter"
                },
                orthodox: {
                    _name: "orthodox"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-09": {
                    _name: "05-09"
                },
                "12-25": {
                    _name: "12-25"
                },
                "1 Shawwal": {
                    _name: "1 Shawwal"
                },
                "10 Dhu al-Hijjah": {
                    _name: "10 Dhu al-Hijjah"
                }
            }
        },
        YT: {
            names: {
                fr: "Mayotte",
                en: "Mayotte"
            },
            langs: [
                "fr"
            ],
            zones: [
                "Africa/Nairobi"
            ],
            dayoff: "sunday",
            _days: "FR",
            days: {
                "04-27": {
                    _name: "Abolition of Slavery"
                }
            }
        },
        ZA: {
            names: {
                en: "South Africa"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Johannesburg"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "substitutes 01-01 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "03-21": {
                    name: {
                        en: "Human Rights Day"
                    }
                },
                "substitutes 03-21 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1",
                    name: {
                        en: "Family Day"
                    }
                },
                "04-27": {
                    name: {
                        en: "Freedom Day"
                    }
                },
                "substitutes 04-27 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "05-01": {
                    _name: "05-01",
                    name: {
                        en: "Workers' Day"
                    }
                },
                "substitutes 05-01 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "06-16": {
                    name: {
                        en: "Youth Day"
                    }
                },
                "substitutes 06-16 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "08-09": {
                    name: {
                        en: "National Women's Day"
                    }
                },
                "substitutes 08-09 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "07-18": {
                    name: {
                        en: "Nelson Mandela Day"
                    },
                    type: "observance"
                },
                "09-24": {
                    name: {
                        en: "Heritage Day"
                    }
                },
                "substitutes 09-24 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "12-16": {
                    name: {
                        en: "Day of Reconciliation"
                    }
                },
                "substitutes 12-16 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26",
                    name: {
                        en: "Day of Goodwill"
                    }
                },
                "substitutes 12-26 if sunday then next monday": {
                    name: {
                        en: "Public Holiday"
                    }
                },
                "2023-12-15": {
                    name: {
                        en: "Rugby World Cup Win Public Holiday"
                    }
                }
            }
        },
        ZM: {
            names: {
                en: "Zambia"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "01-01"
                },
                "03-09": {
                    name: {
                        en: "Women\u2019s Day"
                    }
                },
                "03-12 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "Youth Day"
                    }
                },
                "easter -2": {
                    _name: "easter -2"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "05-01 and if sunday then next monday": {
                    substitute: true,
                    _name: "05-01"
                },
                "05-25 and if sunday then next monday": {
                    substitute: true,
                    name: {
                        en: "African Freedom Day"
                    }
                },
                "1st monday in July": {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                "tuesday after 1st monday in July": {
                    name: {
                        en: "Unity Day"
                    }
                },
                "1st monday in August": {
                    name: {
                        en: "Farmers' Day"
                    }
                },
                "2015-10-18": {
                    name: {
                        en: "National day of Prayers"
                    }
                },
                "10-24 and if sunday then next monday": {
                    substitute: true,
                    _name: "Independence Day"
                },
                "12-25 and if sunday then next monday": {
                    substitute: true,
                    _name: "12-25"
                }
            }
        },
        ZW: {
            names: {
                sn: "Nyika yeZimbabwe",
                nd: "iRiphabhuliki yeZimbabwe",
                xh: "iRiphubliki eyeZimbabwe",
                kck: "Nyika yeZimbabwe",
                en: "Zimbabwe"
            },
            dayoff: "sunday",
            langs: [
                "en"
            ],
            zones: [
                "Africa/Maputo"
            ],
            days: {
                "01-01": {
                    _name: "01-01"
                },
                "easter -2": {
                    _name: "easter -2"
                },
                easter: {
                    _name: "easter",
                    type: "observance"
                },
                "easter 1": {
                    _name: "easter 1"
                },
                "04-18": {
                    _name: "Independence Day"
                },
                "05-01": {
                    _name: "05-01"
                },
                "05-25": {
                    name: {
                        en: "Africa Day"
                    }
                },
                "2nd sunday in May": {
                    _name: "Mothers Day",
                    type: "observance"
                },
                "3rd sunday in June": {
                    _name: "Fathers Day",
                    type: "observance"
                },
                "2nd monday in August": {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                "2nd tuesday in August": {
                    name: {
                        en: "Defence Forces Day"
                    }
                },
                "12-22": {
                    name: {
                        en: "Unity Day"
                    }
                },
                "12-25": {
                    _name: "12-25"
                },
                "12-26": {
                    _name: "12-26"
                }
            }
        }
    },
    names: {
        "01-01": {
            name: {
                en: "New Year's Day",
                am: "\u12A5\u1295\u1241\u1323\u1323\u123D",
                ar: "\u0639\u064A\u062F \u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629",
                az: "Yeni il",
                be: "\u041D\u043E\u0432\u044B \u0433\u043E\u0434",
                bg: "\u041D\u043E\u0432\u0430 \u0413\u043E\u0434\u0438\u043D\u0430",
                bs: "Novogodisnji dan",
                ca: "Any nou",
                cz: "Nov\xfd rok",
                da: "Nyt\xe5r",
                de: "Neujahr",
                el: "\u03A0\u03C1\u03C9\u03C4\u03BF\u03C7\u03C1\u03BF\u03BD\u03B9\u03AC",
                es: "A\xf1o Nuevo",
                et: "uusaasta",
                fi: "Uudenvuodenp\xe4iv\xe4",
                fil: "Araw ng Bagong Taon",
                fo: "N\xfdggj\xe1rsdagur",
                fr: "Nouvel An",
                ge: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EC\u10D4\u10DA\u10D8",
                hr: "Nova godina",
                hu: "\xdaj\xe9v",
                hy: "\u0531\u0574\u0561\u0576\u0578\u0580",
                id: "Hari tahun baru",
                it: "Capodanno",
                is: "N\xfd\xe1rsdagur",
                jp: "\u5143\u65E5",
                kl: "ukiortaaq",
                ko: "\uC2E0\uC815",
                lb: "Neijoerschdag",
                lt: "Naujieji metai",
                lv: "Jaunais Gads",
                mg: "Taom-baovao",
                mk: "\u041D\u043E\u0432\u0430 \u0413\u043E\u0434\u0438\u043D\u0430",
                ms: "Hari Tahun Baru",
                mt: "L-Ewwel tas-Sena",
                nl: "Nieuwjaar",
                no: "F\xf8rste nytt\xe5rsdag",
                pap: "A\xf1a Nobo",
                pl: "Nowy Rok",
                pt: "Ano Novo",
                ro: "Anul nou",
                ru: "\u041D\u043E\u0432\u044B\u0439 \u0433\u043E\u0434",
                sl: "Novo leto",
                sq: "Viti i Ri",
                sr: "\u041D\u043E\u0432\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
                sv: "Ny\xe5rsdagen",
                sw: "Mwaka mpya",
                th: "\u0E27\u0E31\u0E19\u0E02\u0E36\u0E49\u0E19\u0E1B\u0E35\u0E43\u0E2B\u0E21\u0E48",
                ti: "\u1213\u12F2\u123D \u12D3\u1218\u1275",
                tr: "Y\u0131lba\u015F\u0131",
                uk: "\u041D\u043E\u0432\u0438\u0439 \u0420\u0456\u043A",
                vi: "T\u1EBFt D\u01B0\u01A1ng l\u1ECBch",
                zh: "\u5143\u65E6"
            }
        },
        "01-06": {
            name: {
                en: "Epiphany",
                am: "\u1265\u122D\u1210\u1290 \u1325\u121D\u1240\u1275",
                da: "\xc5benbaring",
                de: "Heilige Drei K\xf6nige",
                "de-ch": "Dreik\xf6nigstag",
                es: "D\xeda de los Reyes Magos",
                et: "kolmekuningap\xe4ev",
                fi: "Loppiainen",
                fr: "l'\xc9piphanie",
                el: "\u0398\u03B5\u03BF\u03C6\u03AC\u03BD\u03B5\u03B9\u03B1",
                hr: "Bogojavljenje, Sveta tri kralja",
                hu: "V\xedzkereszt",
                it: "Befana",
                is: "\xderett\xe1ndinn",
                lb: "Dr\xe4ikinneksdag",
                nl: "Driekoningen",
                mk: "\u0411\u043E\u0433\u043E\u0458\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
                pl: "\u015Awi\u0119to Trzech Kr\xf3li",
                sk: "Zjavenie P\xe1na",
                sv: "Trettondedag jul",
                ti: "\u1325\u121D\u1240\u1275",
                vi: "L\u1EC5 Hi\u1EC3n Linh"
            }
        },
        "02-02": {
            name: {
                en: "Candlemas",
                de: "Lichtmess",
                hu: "Gyertyaszentel\u0151 Boldogasszony",
                lb: "Liichtm\xebssdag",
                nl: "Lichtmis",
                vi: "L\u1EC5 \u0110\u1EE9c M\u1EB9 d\xe2ng Ch\xfaa Gi\xeasu trong \u0111\u1EC1n th\xe1nh"
            }
        },
        "02-14": {
            name: {
                en: "Valentine's Day",
                de: "Valentinstag",
                fr: "Saint-Valentin",
                hu: "Valentin nap",
                lb: "V\xe4ltesdag",
                nl: "Valentijnsdag",
                no: "Valentinsdag",
                vi: "L\u1EC5 t\xecnh nh\xe2n"
            }
        },
        "03-08": {
            name: {
                en: "International Women's Day",
                az: "Qad\u0131nlar g\xfcn\xfc",
                be: "\u041Ci\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u044B \u0436\u0430\u043D\u043E\u0447\u044B \u0434\u0437\u0435\u043D\u044C",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u0436\u0435\u043D\u0430\u0442\u0430",
                de: "Internationaler Frauentag",
                fr: "Journ\xe9e internationale des femmes",
                ge: "\u10E5\u10D0\u10DA\u10D7\u10D0 \u10E1\u10D0\u10D4\u10E0\u10D7\u10D0\u10E8\u10DD\u10E0\u10D8\u10E1\u10DD \u10D3\u10E6\u10D4",
                hu: "Nemzetk\xf6zi n\u0151nap",
                hy: "\u053F\u0561\u0576\u0561\u0576\u0581 \u057F\u0578\u0576",
                lb: "Internationale Fraendag",
                nl: "Internationale Vrouwendag",
                no: "Kvinnedagen",
                pt: "Dia Internacional da Mulher",
                ro: "Ziua Internationala a Femeii",
                ru: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                sl: "Mednarodni dan \u017Eena",
                uk: "\u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u0436\u0456\u043D\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C",
                vi: "Qu\u1ED1c t\u1EBF Ph\u1EE5 n\u1EEF",
                zh: "\u56FD\u9645\u5987\u5973\u8282",
                ti: "\u1218\u12D3\u120D\u1272 \u12A3\u1290\u1235\u1272"
            }
        },
        "03-19": {
            name: {
                en: "Saint Joseph",
                "de-at": "Josefitag",
                de: "Josefstag",
                es: "San Jos\xe9",
                it: "San Giuseppe",
                mt: "San \u0120u\u017Cepp",
                nl: "Hoogfeest van de Heilige Jozef",
                vi: "K\xednh Th\xe1nh Giuse"
            }
        },
        "04-01": {
            name: {
                en: "April Fools' Day",
                hu: "Bolondok napja",
                nl: "1 April",
                no: "Aprilsnarr",
                sq: "Dita e G\xebnjeshtrave",
                vi: "C\xe1 th\xe1ng t\u01B0"
            }
        },
        "05-01": {
            name: {
                en: "Labour Day",
                "en-us": "Labor Day",
                ar: "\u064A\u0648\u0645 \u0627\u0644\u0639\u0645\u0627\u0644",
                be: "\u0414\u0437\u0435\u043D\u044C \u043F\u0440\u0430\u0446\u044B",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u0442\u0440\u0443\u0434\u0430",
                bs: "Radni dan",
                cz: "Sv\xe1tek pr\xe1ce",
                da: "1. maj",
                de: "Tag der Arbeit",
                el: "\u0395\u03C1\u03B3\u03B1\u03C4\u03B9\u03BA\u03AE \u03A0\u03C1\u03C9\u03C4\u03BF\u03BC\u03B1\u03B3\u03B9\u03AC",
                es: "D\xeda del trabajador",
                et: "kevadp\xfcha",
                fi: "Vappu",
                fil: "Araw ng mga Manggagawa",
                fr: "F\xeate du travail",
                hr: "Praznik rada",
                hu: "A munka \xfcnnepe",
                hy: "\u0531\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u056B \u0585\u0580",
                id: "Hari Buruh Internasional",
                it: "Festa del Lavoro",
                is: "H\xe1t\xed\xf0isdagur Verkamanna",
                lb: "\xc9ischte Mee",
                lt: "Tarptautin\u0117 darbo diena",
                lv: "Darba sv\u0113tki",
                nl: "Dag van de Arbeid",
                no: "Arbeidernes dag",
                mg: "Fetin'ny asa",
                mk: "\u0414\u0435\u043D \u043D\u0430 \u0442\u0440\u0443\u0434\u043E\u0442",
                ms: "Hari Pekerja",
                mt: "Jum il-\u0126addiem",
                pap: "Dia di Obrero",
                pl: "\u015Awi\u0119to Pracy",
                pt: "Dia do trabalhador",
                ro: "Ziua muncii",
                sk: "Sviatok pr\xe1ce",
                sl: "Praznik dela",
                sq: "Dita Nd\xebrkomb\xebtare e Punonj\xebsve",
                sr: "\u041F\u0440\u0430\u0437\u043D\u0438\u043A \u0440\u0430\u0434\u0430",
                sv: "F\xf6rsta Maj",
                ti: "\u12E8\u120B\u1265 \u12A0\u12F0\u122E\u127D \u1240\u1295",
                uk: "\u0414\u0435\u043D\u044C \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0457 \u0441\u043E\u043B\u0456\u0434\u0430\u0440\u043D\u043E\u0441\u0442\u0456 \u0442\u0440\u0443\u0434\u044F\u0449\u0438\u0445",
                vi: "Qu\u1ED1c t\u1EBF Lao \u0111\u1ED9ng",
                zh: "\u52B3\u52A8\u8282"
            }
        },
        "05-09": {
            name: {
                en: "Europe Day",
                bg: "\u0414\u0435\u043D\u044F\u0442 \u043D\u0430 \u0415\u0432\u0440\u043E\u043F\u0430",
                cs: "Den Evropy",
                da: "Europadagen",
                de: "Europatag",
                el: "\u0397\u03BC\u03AD\u03C1\u03B1 \u03C4\u03B7\u03C2 \u0395\u03C5\u03C1\u03CE\u03C0\u03B7\u03C2",
                es: "D\xeda de Europa",
                et: "Euroopa p\xe4ev",
                fi: "Eurooppa-p\xe4iv\xe4",
                fr: "Journ\xe9e de l'Europe",
                ga: "L\xe1 na hEorpa",
                hr: "Dan Europe",
                hu: "Eur\xf3pa-nap",
                it: "Festa dell'Europa",
                lb: "Europadag",
                ls: "Dan Evrope",
                lt: "Europos diena",
                lv: "Eiropas diena",
                mt: "Jum l-Ewropa",
                nl: "Dag van Europa ou Europadag",
                pl: "Dzie\u0144 Europy",
                pt: "Dia da Europa",
                ro: "Ziua Europei",
                sk: "De\u0148 Eur\xf3py",
                sq: "Dita e Evrop\xebs",
                sv: "Europadagen"
            }
        },
        "06-29": {
            name: {
                en: "Saints Peter and Paul",
                de: "Peter und Paul",
                es: "San Pedro y San Pablo",
                fr: "Saint Pierre et Paul",
                it: "Santi Pietro e Paolo",
                mt: "L-Imnarja",
                nl: "Hoogfeest van Petrus en Paulus",
                vi: "L\u1EC5 k\xednh Th\xe1nh Ph\xear\xf4"
            }
        },
        "08-15": {
            name: {
                en: "Assumption",
                de: "Mari\xe4 Himmelfahrt",
                es: "Asunci\xf3n",
                fr: "Assomption",
                el: "\u039A\u03BF\u03AF\u03BC\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u0398\u03B5\u03BF\u03C4\u03CC\u03BA\u03BF\u03C5",
                hr: "Velika Gospa",
                it: "Ferragosto",
                lb: "L\xe9iffraw\xebschdag",
                lt: "\u017Dolin\u0117",
                mg: "Asompsiona",
                mk: "\u0423\u0441\u043F\u0435\u043D\u0438\u0435 \u043D\u0430 \u041F\u0440\u0435\u0441\u0432\u0435\u0442\u0430 \u0411\u043E\u0433\u043E\u0440\u043E\u0434\u0438\u0446\u0430",
                mt: "Santa Marija",
                nl: "O.L.V. Hemelvaart",
                pl: "Wniebowzi\u0119cie Naj\u015Bwi\u0119tszej Maryi Panny",
                pt: "Assun\xe7\xe3o de Maria",
                ro: "Adormirea Maicii Domnului",
                sl: "Marijino vnebovzetje",
                sq: "Sh\xebn M\xebria e Gushtit",
                vi: "\u0110\u1EE9c M\u1EB9 L\xean Tr\u1EDDi"
            }
        },
        "11-01": {
            name: {
                en: "All Saints' Day",
                bs: "Dita e t\xeb gjith\xeb Shenjtor\xebve",
                de: "Allerheiligen",
                es: "Todos los Santos",
                fi: "Pyh\xe4inp\xe4iv\xe4",
                fil: "Und\xe1s; Todos los Santos; Araw ng mga Santo",
                fr: "Toussaint",
                hr: "Svi sveti",
                hu: "Mindenszentek",
                it: "Ognissanti",
                lb: "Allerhellegen",
                lt: "Vis\u0173 \u0161vent\u0173j\u0173 diena",
                mg: "Fetin'ny olo-masina",
                mk: "\u041F\u0440\u0430\u0437\u043D\u0438\u043A\u043E\u0442 \u043D\u0430 \u0441\u0438\u0442\u0435 \u0441\u0432\u0435\u0442\u0446\u0438",
                nl: "Allerheiligen",
                pl: "Wszystkich \u015Awi\u0119tych",
                pt: "Todos os santos",
                sk: "Sviatok v\u0161etk\xfdch sv\xe4t\xfdch",
                sq: "T\xeb gjitha Saints",
                sr: "\u0421\u0432\u0438 \u0421\u0432\u0435\u0442\u0438",
                sv: "Alla Helgons dag",
                vi: "L\u1EC5 C\xe1c Th\xe1nh"
            }
        },
        "11-02": {
            name: {
                en: "All Souls' Day",
                de: "Allerseelen",
                es: "D\xeda de los Difuntos",
                et: "hingedep\xe4ev",
                fil: "Araw ng mga Kaluluwa",
                fr: "F\xeate des morts",
                hr: "Du\u0161ni dan",
                hu: "Halottak napja",
                lb: "Allers\xe9ilen",
                nl: "Allerzielen",
                pt: "Dia de Finados",
                vi: "L\u1EC5 C\xe1c \u0110\u1EB3ng",
                lt: "V\u0117lin\u0117s"
            }
        },
        "11-11": {
            name: {
                en: "Saint Martin",
                de: "Sankt Martin (Faschingsbeginn)",
                hu: "M\xe1rton nap",
                nl: "Sint Maarten",
                vi: "L\u1EC5 th\xe1nh Martin"
            }
        },
        "12-06": {
            name: {
                en: "Saint Nicholas",
                de: "Sankt Nikolaus",
                fr: "Saint-Nicolas",
                hu: "Mikul\xe1s",
                lb: "Niklosdag",
                nl: "Sinterklaas",
                vi: "Th\xe1nh Saint Nicholas"
            }
        },
        "12-07": {
            name: {
                it: "Sant'Ambrogio",
                en: "Saint Ambrose"
            }
        },
        "12-08": {
            name: {
                en: "Immaculate Conception",
                de: "Mari\xe4 Empf\xe4ngnis",
                es: "La inmaculada concepci\xf3n",
                fr: "Immacul\xe9e Conception",
                it: "Immacolata Concezione",
                mt: "Il-Kun\u010Bizzjoni",
                nl: "Onbevlekte Ontvangenis van Maria",
                pt: "Imaculada Concei\xe7\xe3o"
            }
        },
        "12-24": {
            name: {
                en: "Christmas Eve",
                bg: "\u0411\u044A\u0434\u043D\u0438 \u0432\u0435\u0447\u0435\u0440",
                bs: "Badnji dan",
                cz: "\u0160t\u011Bdr\xfd den",
                da: "Juleaften",
                de: "Heiliger Abend",
                es: "Nochebuena",
                et: "j\xf5ululaup\xe4ev",
                fo: "J\xf3laaftan",
                fi: "Jouluaatto",
                fil: "Bisperas ng Pasko",
                fr: "Veille de No\xebl",
                hr: "Badnji dan",
                hu: "Szenteste",
                is: "A\xf0fangadagur",
                kl: "juulliaraq",
                lb: "Hellegowend",
                lt: "\u0160v. K\u016B\u010Dios",
                lv: "Ziemassv\u0113tku vakars",
                ms: "Hari Sebelum Krismas",
                nl: "Kerstavond",
                no: "Julaften",
                pt: "Noite de Natal",
                sk: "\u0160tedr\xfd de\u0148",
                sq: "Nata e Krishtlindjes",
                sr: "\u0411\u0430\u0434\u045A\u0438 \u0434\u0430\u043D",
                sv: "Julafton",
                vi: "\u0110\xeam Gi\xe1ng Sinh"
            }
        },
        "12-25": {
            name: {
                en: "Christmas Day",
                am: "\u120D\u12F0\u1270-\u1208\u12A5\u130D\u12DA\u12A5\u1290/ \u1308\u1293",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F \u0627\u0644\u0645\u062C\u064A\u062F",
                bg: "\u041A\u043E\u043B\u0435\u0434\u0430",
                bn: "\u09AC\u09A1\u09BC\u09A6\u09BF\u09A8",
                bs: "Bo\u017Ei\u0107",
                "de-at": "Christtag",
                ca: "Nadal",
                cz: "1. sv\xe1tek v\xe1no\u010Dn\xed",
                da: "Juledag",
                de: "Weihnachten",
                "de-ch": "Weihnachtstag",
                el: "\u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03B3\u03B5\u03BD\u03BD\u03B1",
                es: "Navidad",
                et: "esimene j\xf5ulup\xfcha",
                fi: "Joulup\xe4iv\xe4",
                fil: "Araw ng Pasko",
                fo: "Fyrsti j\xf3ladagur",
                fr: "No\xebl",
                hr: "Bo\u017Ei\u0107",
                hu: "Kar\xe1csony",
                hy: "\u054D\u0578\u0582\u0580\u0562 \u053E\u0576\u0578\u0582\u0576\u0564",
                id: "Hari Raya Natal",
                it: "Natale",
                is: "J\xf3ladagur",
                jp: "\u30CE\u30A8\u30EB",
                kl: "juullerujussuaq",
                ko: "\uAE30\uB3C5\uD0C4\uC2E0\uC77C",
                lb: "Chr\xebschtdag",
                lt: "\u0160v. Kal\u0117dos",
                lv: "Ziemassv\u0113tki",
                mg: "Krismasy",
                mk: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0411\u043E\u0436\u0438\u045C",
                ms: "Hari Krismas",
                mt: "Il-Milied",
                nl: "Kerstmis",
                no: "F\xf8rste Juledag",
                pap: "Dia Pasco di Nascimento",
                pl: "Pierwszy dzie\u0144 Bo\u017Cego Narodzenia",
                pt: "Natal",
                ro: "Cr\u0103ciunul",
                ru: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                sk: "Prv\xfd sviatok viano\u010Dn\xfd",
                sl: "Bo\u017Ei\u010D",
                sq: "Krishtlindja",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0411\u043E\u0436\u0438\u045B",
                sv: "Juldagen",
                sw: "Krismasi",
                ti: "\u120D\u12F0\u1275",
                uk: "\u0420\u0456\u0437\u0434\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u0435",
                vi: "L\u1EC5 Gi\xe1ng Sinh",
                zh: "\u8056\u8A95\u7BC0"
            }
        },
        "12-26": {
            name: {
                en: "Boxing Day",
                bg: "2-\u0440\u0438 \u0434\u0435\u043D \u043D\u0430 \u041A\u043E\u043B\u0435\u0434\u0430",
                cz: "2. sv\xe1tek v\xe1no\u010Dn\xed",
                da: "Anden Juledag",
                de: "2. Weihnachtstag",
                "de-at": "Stefanitag",
                "de-ch": "Stephanstag",
                el: "\u0394\u03B5\u03CD\u03C4\u03B5\u03C1\u03B7 \u03BC\u03AD\u03C1\u03B1 \u03C4\u03C9\u03BD \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03C5\u03B3\u03AD\u03BD\u03BD\u03C9\u03BD",
                es: "San Esteban",
                et: "teine j\xf5ulup\xfcha",
                fi: "2. joulup\xe4iv\xe4",
                fo: "Fyrsti gerandisdagur eftir j\xf3ladag",
                fr: "Lendemain de No\xebl",
                hr: "Svetog Stjepana",
                hu: "Kar\xe1csony m\xe1snapja",
                it: "Santo Stefano",
                is: "Annar \xed j\xf3lum",
                kl: "juullip aappaa",
                lb: "Stiefesdag",
                lt: "2. Kal\u0117d\u0173 diena",
                lv: "Otrie Ziemassv\u0113tki",
                nl: "Tweede kerstdag",
                no: "Andre juledag",
                pap: "Di dos Dia Pasco di Nascimento",
                pl: "Drugi dzie\u0144 Bo\u017Cego Narodzenia",
                ro: "A doua zi de Cr\u0103ciun",
                sk: "Druh\xfd sviatok viano\u010Dn\xfd",
                sv: "Annandag jul",
                vi: "Ng\xe0y t\u1EB7ng qu\xe0"
            }
        },
        "12-31": {
            name: {
                en: "New Year's Eve",
                da: "Nyt\xe5rsaften",
                de: "Silvester",
                es: "Fin del A\xf1o",
                fi: "Uudenvuodenaatto",
                fil: "Bisperas ng Bagong Taon",
                fo: "N\xfdggj\xe1rsaftan",
                fr: "Saint-Sylvestre",
                hu: "Szilveszter",
                hy: "\u0546\u0578\u0580 \u057F\u0561\u0580\u057E\u0561 \u0563\u056B\u0577\u0565\u0580",
                is: "Gaml\xe1rsdagur",
                it: "Ultimo dell\u2019anno",
                jp: "\u5927\u6666\u65E5",
                lb: "Silvester",
                lv: "Vecgada vakars",
                nl: "Oudejaarsavond",
                no: "Nytt\xe5rsaften",
                pt: "V\xe9spera de Ano Novo",
                sv: "Ny\xe5rsafton",
                th: "\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E1B\u0E35",
                vi: "\u0110\xeam giao th\u1EEBa"
            }
        },
        "easter -48": {
            name: {
                en: "Shrove Monday",
                de: "Rosenmontag",
                es: "Carnaval",
                fr: "Lundi de Carnaval",
                lb: "Fuesm\xe9indeg",
                nl: "Carnavalmaandag",
                pap: "Dialuna di Carnaval",
                vi: "Ng\xe0y th\u1EE9 hai hoa h\u1ED3ng"
            }
        },
        "easter -47": {
            name: {
                en: "Shrove Tuesday",
                es: "Carnaval",
                de: "Faschingsdienstag",
                hr: "Pokladni utorak",
                hu: "H\xfashagy\xf3 kedd",
                nl: "Vastenavond",
                pt: "Carnaval",
                vi: "Th\u1EE9 ba m\u1EADp b\xe9o"
            }
        },
        "easter -46": {
            name: {
                en: "Ash Wednesday",
                de: "Aschermittwoch",
                es: "Miercoles de Ceniza",
                fr: "Mercredi des Cendres",
                hu: "Hamvaz\xf3szerda",
                it: "Ceneri",
                is: "\xd6skudagur",
                lb: "\xc4scherm\xebttwoch",
                nl: "Aswoensdag",
                no: "Askeonsdag",
                pt: "Quarta-feira de Cinzas",
                sw: "Jumatano ya Majivu",
                vi: "Th\u1EE9 t\u01B0 L\u1EC5 Tro"
            }
        },
        "easter -7": {
            name: {
                en: "Palm Sunday",
                de: "Palmsonntag",
                es: "Domingo de Ramos",
                hu: "Vir\xe1gvas\xe1rnap",
                it: "Domenica delle Palme",
                is: "P\xe1lmasunnudagur",
                lb: "P\xe4llemsonndeg",
                nl: "Palmzondag",
                no: "Palmes\xf8ndag",
                vi: "Ch\xfaa nh\u1EADt L\u1EC5 L\xe1"
            }
        },
        "easter -3": {
            name: {
                en: "Maundy Thursday",
                cz: "Zelen\xfd \u010Dtvrtek",
                da: "Sk\xe6rtorsdag",
                de: "Gr\xfcndonnerstag",
                es: "Jueves Santo",
                fil: "Huwebes Santo",
                fo: "Sk\xedrh\xf3sdagur",
                fr: "Jeudi saint",
                is: "Sk\xedrdagur",
                it: "Gioved\xec santo",
                kl: "sisamanngortoq illernartoq",
                lb: "Gr\xe9ngen Donneschdeg",
                nl: "Witte donderdag",
                no: "Skj\xe6rtorsdag",
                sv: "Sk\xe4rtorsdagen",
                vi: "Th\u1EE9 n\u0103m Tu\u1EA7n Th\xe1nh"
            }
        },
        "easter -2": {
            name: {
                en: "Good Friday",
                am: "\u1235\u1245\u1208\u1275",
                bg: "\u0420\u0430\u0437\u043F\u0435\u0442\u0438 \u043F\u0435\u0442\u044A\u043A",
                bs: "Dobar petak",
                cz: "Velk\xfd p\xe1tek",
                da: "Langfredag",
                de: "Karfreitag",
                es: "Viernes Santo",
                fi: "Pitk\xe4perjantai",
                fil: "Biyernes Santo",
                fo: "Langafr\xedggjadagur",
                fr: "Vendredi saint",
                el: "\u039C\u03B5\u03B3\u03AC\u03BB\u03B7 \u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
                et: "suur reede",
                ge: "\u10EC\u10D8\u10D7\u10D4\u10DA\u10D8 \u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
                hr: "Veliki petak",
                hu: "Nagyp\xe9ntek",
                id: "Wafat Yesus Kristus",
                it: "Venerd\xec santo",
                is: "F\xf6studagurinn langi",
                kl: "tallimanngornersuaq",
                lb: "Karfreideg",
                lv: "Liel\u0101 Piektdiena",
                ms: "Jumat Agung",
                mt: "Il-\u0120img\u0127a l-Kbira",
                nl: "Goede Vrijdag",
                no: "Langfredag",
                pap: "Diabierna Santo",
                pt: "Sexta-Feira Santa",
                ro: "Vinerea Mare",
                sk: "Ve\u013Ekono\u010Dn\xfd piatok",
                sq: "E Premtja e Madhe",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u0435\u0442\u0430\u043A",
                sv: "L\xe5ngfredagen",
                sw: "Ijumaa Kuu",
                vi: "Th\u1EE9 s\xe1u Tu\u1EA7n Th\xe1nh",
                zh: "\u8036\u7A4C\u53D7\u96E3\u7BC0"
            }
        },
        "easter -1": {
            name: {
                en: "Easter Saturday",
                cz: "B\xedl\xe1 sobota",
                de: "Karsamstag",
                es: "Sabado Santo",
                fil: "Sabado de Gloria",
                fr: "Samedi saint",
                ge: "\u10D3\u10D8\u10D3\u10D8 \u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                hu: "Nagyszombat",
                it: "Sabado santo",
                lb: "Karsamschdeg",
                nl: "Dag voor Pasen",
                no: "P\xe5skeaften",
                sv: "P\xe5skafton",
                vi: "Th\u1EE9 b\u1EA3y Tu\u1EA7n Th\xe1nh",
                zh: "\u8036\u7A4C\u53D7\u96E3\u7BC0\u7FCC\u65E5"
            }
        },
        easter: {
            name: {
                en: "Easter Sunday",
                am: "\u134B\u1232\u12AB",
                bg: "\u0412\u0435\u043B\u0438\u043A\u0434\u0435\u043D",
                bs: "Vaskrs",
                cz: "Velikono\u010Dn\xed ned\u011Ble",
                da: "P\xe5skes\xf8ndag",
                de: "Ostersonntag",
                el: "\u03A0\u03AC\u03C3\u03C7\u03B1",
                es: "Pascua",
                et: "lihav\xf5tted",
                fi: "P\xe4\xe4si\xe4isp\xe4iv\xe4",
                fil: "Pasko ng Pagkabuhay",
                fo: "P\xe1skadagur",
                fr: "P\xe2ques",
                ge: "\u10D0\u10E6\u10D3\u10D2\u10DD\u10DB\u10D0",
                hr: "Uskrs",
                hu: "H\xfasv\xe9tvas\xe1rnap",
                it: "Domenica di Pasqua",
                is: "P\xe1skadagur",
                kl: "poorskip-ullua",
                lb: "Ouschtersonndeg",
                lt: "Velykos",
                lv: "Lieldienas",
                nl: "Pasen",
                no: "F\xf8rste p\xe5skedag",
                pap: "Dia Pasco di Resureccion",
                pl: "Niedziela Wielkanocna",
                pt: "P\xe1scoa",
                ro: "Pa\u0219tele",
                sk: "Ve\u013Ek\xe1 noc",
                sl: "Velika no\u010D",
                sq: "Pashk\xebt Katolike",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0430\u0441\u043A\u0440\u0441",
                sv: "P\xe5skdagen",
                sw: "Pasaka",
                vi: "L\u1EC5 Ph\u1EE5c Sinh",
                zh: "\u590D\u6D3B\u8282"
            }
        },
        "easter 1": {
            name: {
                en: "Easter Monday",
                bg: "\u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
                bs: "Uskrsni ponedjeljak",
                cz: "Velikono\u010Dn\xed pond\u011Bl\xed",
                da: "Anden p\xe5skedag",
                de: "Ostermontag",
                el: "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1 \u03C4\u03BF\u03C5 \u03A0\u03AC\u03C3\u03C7\u03B1",
                es: "Lunes de Pascua",
                fi: "2. p\xe4\xe4si\xe4isp\xe4iv\xe4",
                fo: "Annar p\xe1skadagur",
                fr: "Lundi de P\xe2ques",
                ge: "\u10D0\u10E6\u10D3\u10D2\u10DD\u10DB\u10D8\u10E1 \u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                hr: "Uskr\u0161nji ponedjeljak",
                hu: "H\xfasv\xe9th\xe9tf\u0151",
                it: "Luned\xec dell\u2019Angelo",
                is: "Annar \xed p\xe1skum",
                kl: "poorskip-aappaa",
                lb: "Ouschterm\xe9indeg",
                lt: "Velyk\u0173 pirmadienis",
                lv: "Otr\u0101s Lieldienas",
                mg: "Alatsinain'ny Paska",
                mk: "\u0432\u0442\u043E\u0440\u0438\u043E\u0442 \u0434\u0435\u043D \u043D\u0430 \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: "Tweede paasdag",
                no: "Andre p\xe5skedag",
                pap: "Di dos Dia Pasco di Resureccion",
                pl: "Drugi dzie\u0144 Wielkanocy",
                ro: "A doua zi de Pasti",
                sk: "Ve\u013Ekono\u010Dn\xfd pondelok",
                sl: "Velikono\u010Dni ponedeljek",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0430\u0441\u043A\u0440\u0441\u043D\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
                sv: "Annandag p\xe5sk",
                sw: "Jumatatu ya Pasaka",
                vi: "Th\u1EE9 hai ph\u1EE5c sinh",
                zh: "\u5FA9\u6D3B\u7BC0\u661F\u671F\u4E00"
            }
        },
        "easter 39": {
            name: {
                en: "Ascension Day",
                da: "Kristi Himmelfartsdag",
                de: "Christi Himmelfahrt",
                es: "La Asunci\xf3n",
                fi: "Helatorstai",
                fo: "Kristi Himmalsfer\xf0ardagur",
                fr: "Ascension",
                id: "Kenaikan Yesus Kristus",
                it: "Ascensione",
                is: "Uppstigningardagur",
                kl: "qilaliarfik",
                mg: "Andro niakarana",
                lb: "Christi Himmelfaart",
                nl: "O.L.H. Hemelvaart",
                no: "Kristi himmelfartsdag",
                pap: "Dia di Asuncion",
                ro: "Ziua Eroilor",
                sv: "Kristi himmelf\xe4rds dag",
                vi: "L\u1EC5 Th\u0103ng Thi\xean"
            }
        },
        "easter 49": {
            name: {
                en: "Pentecost",
                da: "Pinsedag",
                de: "Pfingstsonntag",
                el: "\u03A0\u03B5\u03BD\u03C4\u03B7\u03BA\u03BF\u03C3\u03C4\u03AE",
                es: "Pentecost\xe9s",
                et: "nelip\xfchade 1. p\xfcha",
                fi: "Helluntaip\xe4iv\xe4",
                fo: "Hv\xedtusunnudagur",
                fr: "Pentec\xf4te",
                hu: "P\xfcnk\xf6sdvas\xe1rnap",
                it: "Pentecoste",
                is: "Hv\xedtasunnudagur",
                kl: "piinsip ullua",
                lb: "P\xe4ischtsonndeg",
                nl: "Pinksteren",
                no: "F\xf8rste pinsedag",
                mk: "\u0414\u0443\u0445\u043E\u0432\u0434\u0435\u043D",
                pl: "Zielone \u015Awi\u0105tki",
                ro: "Rusaliile",
                sl: "Binko\u0161ti",
                sv: "Pingstdagen",
                uk: "\u0422\u0440\u0456\u0439\u0446\u044F",
                vi: "L\u1EC5 Ch\xfaa Th\xe1nh Th\u1EA7n Hi\u1EC7n Xu\u1ED1ng"
            }
        },
        "easter 50": {
            name: {
                en: "Whit Monday",
                da: "Anden Pinsedag",
                de: "Pfingstmontag",
                el: "\u0391\u03B3\u03AF\u03BF\u03C5 \u03A0\u03BD\u03B5\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2",
                es: "Lunes de Pentecost\xe9s",
                fo: "Annar hv\xedtusunnudagur",
                fr: "Lundi de Pentec\xf4te",
                hu: "P\xfcnk\xf6sdh\xe9tf\u0151",
                is: "Annar \xed hv\xedtasunnu",
                it: "Luned\xec di Pentecoste",
                kl: "piinsip aappaa",
                mg: "Alatsinain'ny Pentekosta",
                lb: "P\xe9ngschtm\xe9indeg",
                nl: "Tweede pinksterdag",
                no: "Andre pinsedag",
                ro: "A doua zi de Rusalii",
                sv: "Annandag pingst"
            }
        },
        "easter 60": {
            name: {
                en: "Corpus Christi",
                de: "Fronleichnam",
                es: "Corpus Christi",
                fr: "la F\xeate-Dieu",
                it: "Corpus Domini",
                hr: "Tijelovo",
                nl: "Sacramentsdag",
                pl: "Dzie\u0144 Bo\u017Cego Cia\u0142a",
                pt: "Corpo de Deus",
                vi: "L\u1EC5 M\xecnh v\xe0 M\xe1u Th\xe1nh Ch\xfaa Kit\xf4"
            }
        },
        "julian 01-01": {
            name: {
                en: "Orthodox New Year",
                bs: "Pravoslavni novogodi\u0161nji dan",
                hr: "Pravoslavna Nova Godina",
                nl: "Orthodox Nieuwjaar",
                sq: "Viti i Ri Ortodoks",
                sr: "\u041F\u0440\u0430\u0432\u043E\u0441\u043B\u0430\u0432\u043D\u0430 \u041D\u043E\u0432\u0430 \u0433\u043E\u0434\u0438\u043D\u0430"
            }
        },
        "julian 12-24": {
            name: {
                en: "Orthodox Christmas Eve",
                nl: "Orthodox Kerstavond",
                mk: "\u0411\u0430\u0434\u043D\u0438\u043A",
                ti: "\u120D\u12F0\u1275"
            }
        },
        "julian 12-25": {
            name: {
                en: "Orthodox Christmas",
                bs: "Pravoslavni Bo\u017Ei\u0107",
                hr: "Pravoslavni Bo\u017Ei\u0107",
                mk: "\u041F\u0440\u0432 \u0434\u0435\u043D \u0411\u043E\u0436\u0438\u043A",
                nl: "Orthodox Kerstmis",
                ro: "Craciun pe Rit Vechi",
                sq: "Krishtlindjet Ortodokse",
                sr: "\u0411\u043E\u0436\u0438\u045B",
                uk: "\u0420\u0456\u0437\u0434\u0432\u043E"
            }
        },
        "orthodox -2": {
            name: {
                en: "Orthodox Good Friday",
                mk: "\u0412\u0435\u043B\u0438\u043A\u0438 \u041F\u0435\u0442\u043E\u043A",
                nl: "Orthodoxe Goede vrijdag",
                sr: "\u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u0435\u0442\u0430\u043A",
                ti: "\u12D3\u122D\u1262 \u1235\u1245\u1208\u1275"
            }
        },
        orthodox: {
            name: {
                en: "Orthodox Easter",
                bs: "Pravoslavni Vaskrs",
                hr: "Pravoslavni Uskrs",
                mk: "\u041F\u0440\u0432 \u0434\u0435\u043D \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: "Orthodox Pasen",
                sq: "Pashk\xebt Ortodokse",
                sr: "\u0412\u0430\u0441\u043A\u0440\u0441",
                ti: "\u134B\u1232\u12AB",
                uk: "\u0412\u0435\u043B\u0438\u043A\u0434\u0435\u043D\u044C"
            }
        },
        "orthodox 1": {
            name: {
                en: "Orthodox Easter Monday",
                mk: "\u0412\u0442\u043E\u0440 \u0434\u0435\u043D \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: "Orthodoxe Tweede Paasdag",
                sr: "\u0412\u0430\u0441\u043A\u0440\u0441\u043D\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A"
            }
        },
        "1 Muharram": {
            name: {
                en: "Islamic New Year",
                ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0647\u062C\u0631\u064A\u0629",
                bs: "Nova hid\u017Eretska godina",
                fil: "Unang Araw ng Muharram",
                fr: "Nouvel an islamique",
                hr: "Nova hid\u017Eretska godina",
                id: "Tahun Baru Islam",
                ms: "Awal Muharram",
                nl: "Islamitisch Nieuwjaar",
                sq: "Viti i Ri hixhri"
            }
        },
        "10 Muharram": {
            name: {
                en: "Day of Ashura",
                ar: "\u0639\u0627\u0634\u0648\u0631\u0627\u0621",
                bn: "\u0986\u09B6\u09C1\u09B0\u09BE",
                nl: "Asjoera"
            }
        },
        "12 Rabi al-awwal": {
            name: {
                en: "Birthday of Muhammad (Mawlid)",
                am: "\u1218\u12CD\u120A\u12F5",
                ar: "\u0627\u0644\u0645\u0648\u0644\u062F \u0627\u0644\u0646\u0628\u0648\u064A\u0651",
                bn: "\u0988\u09A6\u09C7 \u09AE\u09BF\u09B2\u09BE\u09A6\u09C1\u09A8\u09CD\u09A8\u09AC\u09C0",
                bs: "Mevlud",
                fr: "Mawlid",
                id: "Maulid Nabi Muhammad",
                ms: "Hari Keputeraan Nabi Muhammad S.A.W.",
                nl: "Mawlid an-Nabi",
                sq: "Mevludi"
            }
        },
        "27 Rajab": {
            name: {
                en: "Laylat al-Mi'raj",
                ar: "\u0627\u0644\u0625\u0633\u0631\u0627\u0621 \u0648\u0627\u0644\u0645\u0639\u0631\u0627\u062C",
                bs: "Lejletul Mi'rad\u017E",
                id: "Maulid Nabi Muhammad",
                ms: "Israk dan Mikraj",
                nl: "Laylat al-Miraadj",
                sq: "Nata e Miraxhit",
                tr: "Mira\xe7 Gecesi"
            }
        },
        "15 Shaban": {
            name: {
                en: "Laylat al-Bara'at",
                ar: "\u0644\u064A\u0644\u0629 \u0627\u0644\u0628\u0631\u0627\u0621\u0629",
                bs: "Lejletul berat",
                nl: "Laylat al-Baraat",
                sq: "Nata e Beratit"
            }
        },
        "1 Ramadan": {
            name: {
                en: "First day of Ramadan",
                am: "\u1228\u1218\u12F3\u1295",
                ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u0648\u0644 \u0645\u0646 \u0631\u0645\u0636\u0627\u0646",
                bs: "Prvi dan posta",
                ms: "Awal Ramadan",
                nl: "Eerste dag van Ramadan",
                sq: "Dita e par\xeb e agj\xebrimit"
            }
        },
        "17 Ramadan": {
            name: {
                en: "Day of Nuzul Al-Quran",
                ms: "Hari Nuzul Al-Quran"
            }
        },
        "23 Ramadan": {
            name: {
                en: "Lailat al-Qadr"
            }
        },
        "27 Ramadan": {
            name: {
                en: "Laylat al-Qadr",
                ar: "\u0644\u06CC\u0644\u0629 \u0627\u0644\u0642\u062F\u0631",
                bs: "Lejletul kadr",
                nl: "Waardevolle Nacht (Laylat al-Qadr)",
                sq: "Nata e Kadrit"
            }
        },
        "1 Shawwal": {
            name: {
                en: "End of Ramadan (Eid al-Fitr)",
                am: "\u12D2\u12F5 \u12A0\u120D \u1348\u1325\u122D",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0641\u0637\u0631",
                az: "Ramazan Bayram\u0131",
                bn: "\u0988\u09A6\u09C1\u09B2 \u09AB\u09BF\u09A4\u09B0",
                bs: "Ramazanski bajram",
                de: "Zuckerfest",
                es: "Fiesta del Eid Fitr",
                fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED3\uFEC4\uFEAE",
                fil: "Pagwawakas ng Ramadan",
                fr: "F\xeate de fin du Ramadan",
                hr: "Ramazanski bajram",
                id: "Hari Raya Idul Fitri",
                nl: "Suikerfeest (Eid al-Fitr)",
                mk: "\u0420\u0430\u043C\u0430\u0437\u0430\u043D \u0411\u0430\u0458\u0440\u0430\u043C",
                ms: "Hari Raya Aidil Fitri",
                sq: "Fit\xebr Bajrami",
                tr: "Ramazan Bayram\u0131",
                sr: "\u0420\u0430\u043C\u0430\u0437\u0430\u043D\u0441\u043A\u0438 \u0411\u0430\u0458\u0440\u0430\u043C",
                sw: "Idd-ul-Fitr"
            }
        },
        "9 Dhu al-Hijjah": {
            name: {
                en: "Arafat Day",
                ar: "\u064A\u0648\u0645 \u0639\u0631\u0641\u0629",
                es: "Fiesta del Sacrificio-Eidul Adha",
                ms: "Hari Arafah"
            }
        },
        "10 Dhu al-Hijjah": {
            name: {
                en: "Feast of the Sacrifice (Eid al-Adha)",
                am: "\u12D2\u12F5 \u12A0\u120D \u12A0\u12F5\u1210",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0623\u0636\u062D\u0649",
                az: "Qurban Bayram\u0131",
                bn: "\u0988\u09A6\u09C1\u09B2 \u0986\u09AF\u09B9\u09BE",
                bs: "Kurbanski bajram",
                de: "Opferfest",
                es: "Fiesta del Sacrificio-Aid Al Adha",
                fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED7\uFEAE\uFE91\uFE8E\u0646",
                fil: "Eidul Adha",
                fr: "F\xeate du mouton",
                hr: "Kurban-bajram",
                id: "Hari Raya Idul Adha",
                nl: "Offerfeest (Eid Al-Adha)",
                mk: "\u041A\u0443\u0440\u0431\u0430\u043D \u0411\u0430\u0458\u0440\u0430\u043C",
                ms: "Hari Raya Haji",
                sq: "Kurban Bajrami",
                tr: "Kurban Bayram\u0131",
                sr: "\u041A\u0443\u0440\u0431\u0430\u043D\u0441\u043A\u0438 \u0411\u0430\u0458\u0440\u0430\u043C",
                sw: "Idd-ul-Azha"
            }
        },
        "15 Nisan": {
            name: {
                en: "Pesach",
                bs: "Pesah",
                de: "Pessach",
                hr: "Pesa\u010D",
                nl: "Pesach",
                sq: "Pesach",
                sr: "\u041F\u0435\u0441\u0430\u0445"
            }
        },
        "1 Tishrei": {
            name: {
                en: "Rosh Hashanah",
                bs: "Ro\u0161 Ha\u0161ana",
                de: "Rosch Haschana",
                hr: "Ro\u0161 Ha\u0161ane",
                nl: "Rosj Hasjana",
                sq: "Rosh Hashanah",
                sr: "\u0420\u043E\u0448 \u0425\u0430\u0448\u0430\u043D\u0430"
            }
        },
        "10 Tishrei": {
            name: {
                en: "Yom Kippur",
                bs: "Jom Kipur",
                de: "Jom Kippur",
                hr: "Jom Kipur",
                mk: "\u0408\u043E\u043C \u041A\u0438\u043F\u0443\u0440",
                nl: "Jom Kipoer",
                sq: "Yom Kippur",
                sr: "\u0408\u043E\u043C \u041A\u0438\u043F\u0443\u0440"
            }
        },
        Deepavali: {
            name: {
                en: "Deepavali",
                nl: "Divali"
            }
        },
        Vesak: {
            name: {
                en: "Vesak Day",
                id: "Hari Raya Waisak",
                th: "\u0E27\u0E31\u0E19\u0E27\u0E34\u0E2A\u0E32\u0E02\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        Holi: {
            name: {
                en: "Holi Phagwa",
                nl: "Holi-Phagwa"
            }
        },
        Thaipusam: {
            name: {
                en: "Thaipusam",
                ms: "Hari Thaipusam"
            }
        },
        "Makha Bucha": {
            name: {
                en: "Makha Bucha",
                th: "\u0E27\u0E31\u0E19\u0E21\u0E32\u0E06\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        "Asalha Puja": {
            name: {
                en: "Asalha Puja",
                th: "\u0E27\u0E31\u0E19\u0E2D\u0E32\u0E2A\u0E32\u0E2C\u0E2B\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        "Buddhist Lent": {
            name: {
                en: "Buddhist Lent",
                th: "\u0E27\u0E31\u0E19\u0E40\u0E02\u0E49\u0E32\u0E1E\u0E23\u0E23\u0E29\u0E32"
            }
        },
        "Abolition of Slavery": {
            name: {
                en: "Abolition of Slavery",
                fr: "Abolition de l\u2019esclavage",
                nl: "Afschaffing van de slavernij",
                vi: "B\xe3i b\u1ECF ch\u1EBF \u0111\u1ED9 N\xf4 l\u1EC7"
            }
        },
        "Bu\xdf- und Bettag": {
            name: {
                de: "Bu\xdf- und Bettag",
                en: "Day of Prayer and Repentance"
            }
        },
        "Constitution Day": {
            name: {
                en: "Constitution Day",
                da: "Grundlovsdag",
                de: "Tag der Verfassung",
                ca: "Dia de la Constituci\xf3",
                es: "D\xeda de la Constituci\xf3n",
                fil: "Araw ng Saligang Batas",
                fo: "Grundl\xf3gardagur",
                hy: "\u054D\u0561\u0570\u0574\u0561\u0576\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580",
                jp: "\u61B2\u6CD5\u8A18\u5FF5\u65E5",
                ko: "\uC81C\uD5CC\uC808",
                nl: "Dag van de Grondwet",
                no: "Grunnlovsdagen",
                pt: "Dia da Constitui\xe7\xe3o",
                ro: "Ziua Constitu\u021Biei",
                sk: "De\u0148 \xdastavy",
                sq: "Dita e Kushtetut\xebs",
                uk: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0456\u0457",
                vi: "Ng\xe0y ph\xe1p lu\u1EADt"
            }
        },
        "Fathers Day": {
            name: {
                en: "Father's Day",
                et: "isadep\xe4ev",
                fi: "Is\xe4np\xe4iv\xe4",
                fr: "F\xeate des P\xe8res",
                lt: "T\u0117vo diena",
                nl: "Vaderdag",
                pt: "Dia dos Pais",
                no: "Farsdag",
                sv: "Fars dag",
                vi: "Ng\xe0y c\u1EE7a cha"
            }
        },
        "Independence Day": {
            name: {
                en: "Independence Day",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0642\u0644\u0627\u0644",
                be: "\u0414\u0437\u0435\u043D\u044C \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u0430\u0441\u0446i",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0442\u0430",
                bs: "Dan nezavisnosti",
                de: "Unabh\xe4ngigkeitstag",
                es: "D\xeda de la Independencia",
                et: "iseseisvusp\xe4ev",
                fi: "Itsen\xe4isyysp\xe4iv\xe4",
                fil: "Araw ng Kalayaan",
                fr: "Jour de l'Ind\xe9pendance",
                hr: "Dan neovisnosti",
                hy: "\u0531\u0576\u056F\u0561\u056D\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580",
                id: "Hari Ulang Tahun Kemerdekaan Republik Indonesia",
                mk: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u043D\u043E\u0441\u0442\u0430",
                ms: "Hari Kebangsaan",
                mt: "Jum l-Indipendenza",
                nl: "Onafhankelijkheidsdag",
                pl: "Narodowe \u015Awi\u0119to Niepodleg\u0142o\u015Bci",
                pt: "Dia da Independ\xeancia",
                ro: "Ziua Independentei",
                sq: "Dita e Pavar\xebsis\xeb",
                sr: "\u0414\u0430\u043D \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u043D\u043E\u0441\u0442\u0438",
                sv: "Sj\xe4lvst\xe4ndighetsdagen",
                sw: "Siku ya uhuru",
                ti: "\u1218\u12D3\u120D\u1272 \u1293\u133D\u1290\u1275",
                uk: "\u0414\u0435\u043D\u044C \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0456",
                vi: "Ng\xe0y \u0110\u1ED9c l\u1EADp"
            }
        },
        "Liberation Day": {
            name: {
                en: "Liberation Day",
                ar: "\u064A\u0648\u0645 \u0627\u0644\u062A\u062D\u0631\u064A\u0631",
                nl: "Bevrijdingsdag",
                no: "Frigj\xf8ringsdagen",
                sq: "Dita e \xc7lirimit",
                vi: "Ng\xe0y Th\u1ED1ng nh\u1EA5t"
            }
        },
        "Mothers Day": {
            name: {
                en: "Mother's Day",
                cz: "Den matek",
                da: "Mors Dag",
                de: "Muttertag",
                el: "\u0393\u03B9\u03BF\u03C1\u03C4\u03AE \u03C4\u03B7\u03C2 \u03BC\u03B7\u03C4\u03AD\u03C1\u03B1\u03C2",
                es: "D\xeda de la Madre",
                et: "emadep\xe4ev",
                fi: "\xc4itienp\xe4iv\xe4",
                fr: "F\xeate des M\xe8res",
                hr: "Maj\u010Din dan",
                hu: "Any\xe1k napja",
                hy: "\u0551\u0565\u0572\u0561\u057D\u057A\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0566\u0578\u0570\u0565\u0580\u056B \u0570\u056B\u0577\u0561\u057F\u0561\u056F\u056B \u0585\u0580",
                is: "M\xe6\xf0radagurinn",
                it: "Festa della mamma",
                lt: "Motinos diena",
                lv: "M\u0101tes diena",
                nl: "Moederdag",
                no: "Morsdag",
                pt: "Dia das M\xe3es",
                pl: "Dzie\u0144 Matki",
                ro: "Ziua Mamei",
                sq: "Dita e N\xebn\xebs",
                sv: "Mors dag",
                vi: "Ng\xe0y c\u1EE7a m\u1EB9"
            }
        },
        "National Holiday": {
            name: {
                en: "National Holiday",
                de: "Nationalfeiertag",
                es: "Fiesta Nacional",
                fr: "F\xeate nationale",
                hu: "Nemzeti \xfcnnep",
                el: "\u03B5\u03B8\u03BD\u03B9\u03BA\u03AE \u03B5\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2",
                lb: "Nationalfeierdag",
                nl: "Nationale feestdag",
                vi: "Qu\u1ED1c L\u1EC5"
            }
        },
        "Public Holiday": {
            name: {
                en: "Public Holiday",
                fr: "Jour f\xe9ri\xe9 l\xe9gaux",
                nl: "Wettelijke feestdag",
                pt: "Feriado Obrigat\xf3rio",
                vi: "Ngh\u1EC9 l\u1EC5 To\xe0n Qu\u1ED1c"
            }
        },
        "Reformation Day": {
            name: {
                en: "Reformation Day",
                de: "Reformationstag",
                es: "D\xeda Nacional de las Iglesias Evang\xe9licas y Protestantes",
                nl: "Hervormingsdag",
                vi: "Kh\xe1ng C\xe1ch"
            }
        },
        "Revolution Day": {
            name: {
                en: "Revolution Day",
                ar: "\u064A\u0648\u0645 \u0627\u0644\u062B\u0648\u0631\u0629",
                es: "D\xeda de la Revoluci\xf3n",
                nl: "Dag van de revolutie",
                ti: "\u1263\u1215\u1272 \u1218\u1235\u12A8\u1228\u121D",
                vi: "T\u1ED5ng kh\u1EDFi ngh\u0129a"
            }
        },
        "Bridge Day": {
            name: {
                en: "Bridge Day",
                es: "Feriado Puente Tur\xedstico"
            }
        },
        substitutes: {
            name: {
                en: "substitute day",
                az: "\u0259v\u0259z g\xfcn",
                bs: "zamjena dan",
                de: "Ersatztag",
                es: "d\xeda sustituto",
                fr: "jour substitut",
                hr: "zamjena dan",
                jp: "\u632F\u66FF\u4F11\u65E5",
                lv: "aizst\u0101j\u0113js diena",
                mk: "\u0437\u0430\u043C\u0435\u043D\u0435\u0442 \u0434\u0435\u043D",
                nl: "substituut",
                sq: "dit\xeb z\xebvend\xebsuese",
                sr: "\u0437\u0430\u043C\u0435\u043D\u0430 \u0434\u0430\u043D",
                uk: "\u0437\u0430\u043C\u0456\u043D\u0438\u0442\u0438 \u0434\u0435\u043D\u044C",
                vi: "ng\xe0y thay th\u1EBF",
                zh: "\u66F4\u6362\u65E5"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6PaYh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _lib = require("../../lib");
var _datePicker = require("./DatePicker");
const DateControl = ({ name, control, label, inputFormat = "dd/MM/yyyy", onChange })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
        name: name,
        control: control,
        render: ({ field: { value } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePicker.DatePicker), {
                value: (0, _lib.parseDate)(value !== null && value !== void 0 ? value : ""),
                label: label,
                inputFormat: inputFormat,
                onChange: onChange
            })
    });
exports.default = DateControl;

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","../../lib":"lWrCo","./DatePicker":"zPeK4","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7YlTb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEmployeeModal", ()=>useEmployeeModal);
var _lib = require("../../../lib");
var _components = require("../../../components");
var _employeeModal = require("./EmployeeModal");
const useEmployeeModal = ()=>{
    const { createEmployeeRecord, updateEmployeeRecord } = (0, _lib.useEmployeeLib)();
    const { setContracts } = (0, _lib.useContractsLib)();
    const { showModal: showCreateModal, hideModal: hideCreateModal } = (0, _components.useModal)({
        component: (0, _employeeModal.EmployeeModal),
        data: {
            title: "Add Employee",
            onSubmit: ({ data })=>createEmployeeRecord(data, {
                    onSuccess: hideCreateModal
                }),
            testID: "add-employee"
        }
    });
    const { showModal: showUpdateModal, hideModal: hideUpdateModal } = (0, _components.useModal)({
        component: (0, _employeeModal.EmployeeModal),
        data: {
            title: "Update Employee",
            onSubmit: ({ data: { id, inactiveAt, ...rest }, contracts })=>id && updateEmployeeRecord({
                    ...rest,
                    inactiveAt,
                    id
                }, {
                    onSuccess: hideUpdateModal
                }, contracts),
            testID: "update-employee"
        }
    });
    const { showModal: showDeactivateModal, hideModal: hideDeactivateModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Deactivate Employee",
            label: "Deactivate",
            description: "Are you sure you want to deactivate this employee?",
            onUpdate: ({ id, clients: { items: contracts } })=>updateEmployeeRecord({
                    id,
                    inactiveAt: (0, _lib.toAWSDate)(new Date())
                }, {
                    onSuccess: hideDeactivateModal
                }, contracts)
        }
    });
    const { showModal: showReactivateModal, hideModal: hideReactivateModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Reactivate Employee",
            label: "Reactivate",
            description: "Are you sure you want to reactivate this employee?",
            onUpdate: ({ id })=>updateEmployeeRecord({
                    id,
                    inactiveAt: null
                }, {
                    onSuccess: hideReactivateModal
                })
        }
    });
    const { showModal: showContractsModal, hideModal: hideContractsModal } = (0, _components.useModal)({
        component: (0, _components.ContractsModal),
        data: {
            title: "Clients",
            onSubmit: (data)=>setContracts(data, {
                    onSettled: hideContractsModal
                }),
            testID: "employee-contracts"
        }
    });
    return {
        showCreateModal,
        showUpdateModal,
        showDeactivateModal,
        showReactivateModal,
        showContractsModal
    };
};

},{"../../../lib":"lWrCo","../../../components":"0272J","./EmployeeModal":"9beTv","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"68E3U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _login = require("./Login");
parcelHelpers.exportAll(_login, exports);

},{"./Login":"8Ppon","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8Ppon":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Login", ()=>Login);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _uiReact = require("@aws-amplify/ui-react");
var _stylesCss = require("@aws-amplify/ui-react/styles.css");
var _tdsLogoPng = require("../../assets/tds_logo.png");
var _tdsLogoPngDefault = parcelHelpers.interopDefault(_tdsLogoPng);
const Login = ()=>{
    var _location_state_from, _location_state;
    const theme = (0, _material.useTheme)();
    const authTheme = {
        name: "Custom Auth Coloring",
        tokens: {
            colors: {
                background: {
                    primary: {
                        value: theme.palette.background.default
                    },
                    secondary: {
                        value: theme.palette.grey[50]
                    }
                },
                font: {
                    primary: {
                        value: theme.palette.text.primary
                    },
                    interactive: {
                        value: theme.palette.secondary.main
                    }
                },
                brand: {
                    primary: {
                        "10": {
                            value: theme.palette.primary.light
                        },
                        "80": {
                            value: theme.palette.primary.main
                        },
                        "90": {
                            value: theme.palette.primary.main
                        },
                        "100": {
                            value: theme.palette.primary.dark
                        }
                    }
                }
            },
            components: {
                tabs: {
                    item: {
                        _focus: {
                            color: {
                                value: theme.palette.secondary.dark
                            }
                        },
                        _hover: {
                            color: {
                                value: theme.palette.secondary.light
                            }
                        },
                        _active: {
                            color: {
                                value: theme.palette.secondary.main
                            }
                        }
                    }
                }
            }
        }
    };
    const { route } = (0, _uiReact.useAuthenticator)((context)=>[
            context.route
        ]);
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const from = ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : (_location_state_from = _location_state.from) === null || _location_state_from === void 0 ? void 0 : _location_state_from.pathname) || "/";
    (0, _react.useEffect)(()=>{
        if (route === "authenticated") navigate(from, {
            replace: true
        });
    }, [
        route,
        navigate,
        from
    ]);
    const components = {
        Header () {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.View), {
                textAlign: "center",
                padding: "12px",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.Image), {
                    src: (0, _tdsLogoPngDefault.default),
                    alt: "logo",
                    height: 30,
                    width: 70
                })
            });
        },
        SignIn: {
            Footer () {
                const { toResetPassword } = (0, _uiReact.useAuthenticator)();
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _uiReact.View), {
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.Text), {
                            as: "p",
                            variation: "info",
                            fontSize: 12,
                            textAlign: "center",
                            children: "To fill in your timesheet choose 'Sign in With Google' and use your TDS Google account. Any issues, reach out on Slack."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.Button), {
                            fontWeight: "normal",
                            onClick: toResetPassword,
                            size: "small",
                            variation: "link",
                            margin: "12px 0",
                            children: "Forgot your password?"
                        })
                    ]
                });
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.ThemeProvider), {
        theme: authTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uiReact.Authenticator), {
            hideSignUp: true,
            variation: "modal",
            components: components
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/material":"iknXc","@aws-amplify/ui-react":"40VMD","@aws-amplify/ui-react/styles.css":"6hJmP","../../assets/tds_logo.png":"fXoXz","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6hJmP":[function() {},{}],"inlSP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _main = require("./Main");
parcelHelpers.exportAll(_main, exports);

},{"./Main":"7thaY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"7thaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Main", ()=>Main);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _components = require("../../components");
var _hooks = require("../../hooks");
const Main = ()=>{
    const u = (0, _hooks.useUser)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Dashboard), {}),
                title: "Dashboard",
                testID: "dashboard"
            }),
            u && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                children: [
                    "Welcome back ",
                    u.fullName,
                    "!"
                ]
            }),
            u && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                children: [
                    "Your current TDS email is ",
                    u.email,
                    "!"
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","../../components":"0272J","../../hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3rtGP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _notFound = require("./NotFound");
parcelHelpers.exportAll(_notFound, exports);

},{"./NotFound":"a5ZHY","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"a5ZHY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
const NotFound = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "cemter",
            textAlign: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                variant: "h1",
                mb: 3,
                "data-testid": "title",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                "data-testid": "not-found",
                children: "404 - PAGE NOT FOUND"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                mb: 3,
                children: "The page you are looking for doesn't exist"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                    component: (0, _reactRouterDom.NavLink),
                    to: "/",
                    variant: "contained",
                    "data-testid": "home-btn",
                    children: "Go Home"
                })
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/material":"iknXc","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"IYT9l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reports = require("./Reports");
parcelHelpers.exportAll(_reports, exports);

},{"./Reports":"2oHCN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2oHCN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reports", ()=>Reports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _reactQuery = require("@tanstack/react-query");
var _components = require("../../components");
var _lib = require("../../lib");
var _columns = require("./columns");
var _utils = require("./utils");
const Reports = ()=>{
    const [selectionModel, setSelectionModel] = (0, _react.useState)([]);
    const [employeeID, setEmployeeID] = (0, _react.useState)("");
    const [companyID, setCompanyID] = (0, _react.useState)("");
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfMonth)(new Date()),
        end: (0, _dateFns.endOfMonth)(new Date())
    });
    const { data: company } = (0, _reactQuery.useQuery)((0, _lib.getCompanyClientIDs)(companyID));
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)((0, _utils.reportsQuery)({
        dates,
        employeeID,
        companyID,
        logFilter: company === null || company === void 0 ? void 0 : company.clientFilter
    }));
    const fileName = `${dates ? `${(0, _lib.toIntervalString)(dates)} - ` : ""}${(company === null || company === void 0 ? void 0 : company.name) ? `${company.name}_` : ""}Time_Report`;
    var _data_items;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.StackedLineChart), {}),
                title: "Reports",
                testID: "reports"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                company: {
                    value: companyID,
                    onChange: setCompanyID
                },
                employee: {
                    value: employeeID,
                    onChange: setEmployeeID
                },
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "range"
                },
                testID: "reports"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                header: dates ? (0, _lib.toIntervalString)(dates) : undefined,
                csvOptions: {
                    fileName
                },
                columns: (0, _columns.columns),
                data: (_data_items = data === null || data === void 0 ? void 0 : data.items) !== null && _data_items !== void 0 ? _data_items : [],
                emptyState: {
                    title: "Timesheet Reports",
                    description: "No available timesheet data in specified period",
                    testID: "reports"
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                pagination: pagination,
                testID: "reports",
                checkboxSelection: true,
                selectionModel: selectionModel,
                onSelectionModelChange: setSelectionModel
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","@tanstack/react-query":"j0XMv","../../components":"0272J","../../lib":"lWrCo","./columns":"9UM1t","./utils":"fbQcA","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9UM1t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
const columns = [
    {
        field: "company",
        headerName: "Company",
        type: "string",
        width: 130
    },
    {
        field: "client",
        headerName: "Manager(s)",
        type: "string",
        width: 130
    },
    {
        field: "days",
        headerName: "Days",
        type: "number",
        valueGetter: ({ row })=>row.hours / 8,
        width: 100
    },
    {
        field: "hours",
        headerName: "Hours",
        type: "number",
        width: 100
    },
    {
        field: "overtime",
        headerName: "Overtime hours",
        type: "number",
        width: 120
    },
    {
        field: "total",
        headerName: "Total hours",
        type: "number",
        width: 100
    },
    {
        field: "sick",
        headerName: "Sick days",
        type: "number",
        valueGetter: ({ row })=>row.sick / 8,
        width: 100
    },
    {
        field: "vacation",
        headerName: "Vacation days",
        type: "number",
        valueGetter: ({ row })=>row.vacation / 8,
        width: 120
    },
    {
        field: "employee",
        headerName: "Consultant",
        type: "string",
        minWidth: 160,
        flex: 1
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fbQcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportsQuery", ()=>reportsQuery);
var _lib = require("../../lib");
const reportsQuery = ({ dates, employeeID, companyID, logFilter })=>(input)=>{
        if (dates === null) throw new Error(`Incorrect date range. Value is ${dates}`);
        const dateRange = (0, _lib.toDbDates)(dates);
        var _input_key, _input_key1;
        const { queryFn: listEmployeesQueryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listEmployeesWithTimelogs",
            vars: {
                ...input.vars,
                ...employeeID.length > 0 && {
                    employeeID
                },
                ...companyID.length > 0 && {
                    companyID
                },
                logFilter,
                dateRange
            },
            key: employeeID || companyID ? [
                dateRange,
                {
                    companyID,
                    employeeID
                },
                ...(_input_key = input.key) !== null && _input_key !== void 0 ? _input_key : []
            ] : [
                dateRange,
                ...(_input_key1 = input.key) !== null && _input_key1 !== void 0 ? _input_key1 : []
            ]
        });
        const { queryFn: listClientsQueryFn } = (0, _lib.gqlQuery)({
            req: "listClients"
        });
        return {
            queryKey,
            queryFn: async ()=>{
                var _employeeData_listEmployees, _clientsData_listClients, _employeeData_listEmployees1;
                const { data: employeeData, errors: employeeErrors = [] } = await listEmployeesQueryFn();
                var _employeeData_listEmployees_items;
                const employees = await (0, _lib.filterNull)((_employeeData_listEmployees_items = employeeData === null || employeeData === void 0 ? void 0 : (_employeeData_listEmployees = employeeData.listEmployees) === null || _employeeData_listEmployees === void 0 ? void 0 : _employeeData_listEmployees.items) !== null && _employeeData_listEmployees_items !== void 0 ? _employeeData_listEmployees_items : []);
                const { data: clientsData, errors: clientsErrors = [] } = await listClientsQueryFn();
                var _clientsData_listClients_items;
                const clients = await (0, _lib.filterNull)((_clientsData_listClients_items = clientsData === null || clientsData === void 0 ? void 0 : (_clientsData_listClients = clientsData.listClients) === null || _clientsData_listClients === void 0 ? void 0 : _clientsData_listClients.items) !== null && _clientsData_listClients_items !== void 0 ? _clientsData_listClients_items : []);
                return {
                    employees,
                    items: await buildSummaryReport(employees, clients),
                    errors: [
                        ...employeeErrors,
                        ...clientsErrors
                    ],
                    nextToken: employeeData === null || employeeData === void 0 ? void 0 : (_employeeData_listEmployees1 = employeeData.listEmployees) === null || _employeeData_listEmployees1 === void 0 ? void 0 : _employeeData_listEmployees1.nextToken
                };
            },
            enabled: !companyID || !!logFilter
        };
    };
const buildSummaryReport = async (employees, clients)=>(await Promise.all(employees.map(async ({ firstName, lastName, timelogs })=>{
        // An Employee will have a SummaryReportRow for each Client they have worked on in the report search criteria.
        const summaryReport = {};
        const approvedLogs = await (0, _lib.filterNull)(timelogs === null || timelogs === void 0 ? void 0 : timelogs.items, ({ approved })=>!!approved);
        return Object.values(approvedLogs.reduce(calcEmployeeHours(clients, `${firstName} ${lastName}`), summaryReport));
    }))).flat();
const calcEmployeeHours = (clients, employeeName)=>(summary, { employeeID, clientID, standard, overtime, sick, holiday })=>{
        var _summary_id, _summary_id1, _summary_id2, _summary_id3, _summary_id4;
        const id = `${clientID}-${employeeID}`;
        var _clients_find;
        const client = (_clients_find = clients.find((client)=>client.id === clientID)) !== null && _clients_find !== void 0 ? _clients_find : {
            company: {
                name: "Unknown Company"
            },
            firstName: "ID",
            lastName: clientID
        };
        var _summary_id_total, _summary_id_hours, _summary_id_overtime, _summary_id_sick, _summary_id_vacation;
        return {
            ...summary,
            [id]: {
                id,
                company: client.company.name,
                client: `${client.firstName} ${client.lastName}`,
                employee: employeeName,
                total: ((_summary_id_total = (_summary_id = summary[id]) === null || _summary_id === void 0 ? void 0 : _summary_id.total) !== null && _summary_id_total !== void 0 ? _summary_id_total : 0) + (standard !== null && standard !== void 0 ? standard : 0) + (overtime !== null && overtime !== void 0 ? overtime : 0),
                hours: ((_summary_id_hours = (_summary_id1 = summary[id]) === null || _summary_id1 === void 0 ? void 0 : _summary_id1.hours) !== null && _summary_id_hours !== void 0 ? _summary_id_hours : 0) + (standard !== null && standard !== void 0 ? standard : 0),
                overtime: ((_summary_id_overtime = (_summary_id2 = summary[id]) === null || _summary_id2 === void 0 ? void 0 : _summary_id2.overtime) !== null && _summary_id_overtime !== void 0 ? _summary_id_overtime : 0) + (overtime !== null && overtime !== void 0 ? overtime : 0),
                sick: ((_summary_id_sick = (_summary_id3 = summary[id]) === null || _summary_id3 === void 0 ? void 0 : _summary_id3.sick) !== null && _summary_id_sick !== void 0 ? _summary_id_sick : 0) + (sick !== null && sick !== void 0 ? sick : 0),
                vacation: ((_summary_id_vacation = (_summary_id4 = summary[id]) === null || _summary_id4 === void 0 ? void 0 : _summary_id4.vacation) !== null && _summary_id_vacation !== void 0 ? _summary_id_vacation : 0) + (holiday !== null && holiday !== void 0 ? holiday : 0)
            }
        };
    };

},{"../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"10gRb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _timesheet = require("./Timesheet");
parcelHelpers.exportAll(_timesheet, exports);

},{"./Timesheet":"8vmIm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8vmIm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timesheet", ()=>Timesheet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _notistack = require("notistack");
var _components = require("../../components");
var _lib = require("../../lib");
var _hooks = require("../../hooks");
var _columns = require("./columns");
var _modals = require("./Modals");
var _useTimesheetQuery = require("./useTimesheetQuery");
var _utils = require("./utils");
const Timesheet = ()=>{
    const user = (0, _hooks.useUser)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const [filterUser, setFilterUser] = (0, _react.useState)(user === null || user === void 0 ? void 0 : user.id);
    const { setTimelogs } = (0, _lib.useTimelogLib)();
    const { showModal } = (0, _modals.useTimesheetModal)();
    const [status, setStatus] = (0, _react.useState)(true);
    const [week, setWeek] = (0, _react.useState)({
        start: (0, _dateFns.startOfWeek)(new Date()),
        end: (0, _dateFns.endOfWeek)(new Date())
    });
    const [showOnCall, setShowOnCall] = (0, _react.useState)(false);
    const { timesheet, isApproved, contracts, isError, error, isPending } = (0, _useTimesheetQuery.useTimesheetQuery)({
        id: filterUser || (user === null || user === void 0 ? void 0 : user.id),
        week
    });
    const isEditable = (user === null || user === void 0 ? void 0 : user.isAdmin) || !isApproved;
    const timesheetNotis = {
        onSuccess: ()=>{
            setStatus(true);
        },
        onError: ()=>{
            setStatus(false);
            enqueueSnackbar("Error saving timesheet, please reload.", {
                variant: "error"
            });
        }
    };
    const handleRowUpdate = ({ id, standard, overtime, sick, holiday, onCall, ...rest })=>{
        setStatus(null);
        const _ = (v)=>(typeof v === "number" ? v : -1) < 0 ? 0 : v;
        const data = {
            id: (id === null || id === void 0 ? void 0 : id.at(1)) ? id : undefined,
            standard: _(standard),
            overtime: _(overtime),
            sick: _(sick),
            holiday: _(holiday),
            onCall,
            ...rest
        };
        setTimelogs(data, timesheetNotis);
        return {
            ...data,
            id
        };
    };
    (0, _react.useEffect)(()=>{
        const hasOnCall = timesheet === null || timesheet === void 0 ? void 0 : timesheet.some((el)=>el.onCall);
        setShowOnCall(!!hasOnCall);
    }, [
        timesheet
    ]);
    const showOnCallColumn = {
        label: "On-Call",
        icon: !showOnCall ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.RadioButtonUnchecked), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckCircleOutline), {}),
        onClick: ()=>timesheet === null || timesheet === void 0 ? void 0 : timesheet.forEach((row)=>{
                handleRowUpdate({
                    ...row,
                    onCall: !showOnCall
                });
            })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AccessAlarm), {}),
                title: "Timesheets",
                testID: "timesheets",
                altIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TimesheetIcon), {
                    status: status
                }),
                action: showOnCallColumn
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: user && (user === null || user === void 0 ? void 0 : user.isAdmin) ? {
                    value: filterUser || user.id,
                    onChange: setFilterUser
                } : undefined,
                dates: {
                    value: week,
                    onChange: setWeek,
                    type: "week",
                    InputIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                        status: isApproved !== null && isApproved !== void 0 ? isApproved : null
                    })
                },
                testID: "timesheets"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    contracts,
                    onOpenModal: ({ row })=>showModal({
                            contracts,
                            row
                        }),
                    onUpdateOnCall: ({ row })=>handleRowUpdate(row),
                    editable: isEditable,
                    showOnCall
                }),
                data: timesheet !== null && timesheet !== void 0 ? timesheet : [],
                loading: isPending,
                emptyState: {
                    title: "Timesheets",
                    description: isError ? error.message : "Select an employee to view",
                    testID: "timesheets"
                },
                processRowUpdate: handleRowUpdate,
                hideColumnSelector: true,
                hideExport: true,
                testID: "timesheets",
                disableColumnMenu: true,
                customFooterContent: (timesheet === null || timesheet === void 0 ? void 0 : timesheet.length) ? `Total hours for week: ${(0, _utils.sumTimesheet)(timesheet !== null && timesheet !== void 0 ? timesheet : []).total}` : " "
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","notistack":"3Lc8y","../../components":"0272J","../../lib":"lWrCo","../../hooks":"9Pg07","./columns":"k2cCE","./Modals":"cTBZd","./useTimesheetQuery":"kqGTl","./utils":"f9RHL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"k2cCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _lib = require("../../lib");
const PLACEHOLDER = "No clients";
const hourFields = (editable)=>Object.values((0, _lib.HourCategories)).reduce((fields, cat)=>[
            ...fields,
            {
                field: cat,
                headerName: cat[0].toUpperCase() + cat.slice(1),
                type: "number",
                editable,
                minWidth: 125,
                flex: 1,
                sortable: false
            }
        ], []);
const columns = ({ contracts, onOpenModal, onUpdateOnCall, editable, showOnCall })=>[
        {
            field: "day",
            headerName: "Day",
            minWidth: 170,
            valueGetter: ({ row })=>(0, _dateFns.format)(new Date(row.date), "EEEE"),
            renderCell: ({ row, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ActionCell), {
                    disabled: !editable,
                    onClick: ()=>onOpenModal({
                            row
                        }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        sx: {
                            display: "flex",
                            flex: 1,
                            justifyContent: "space-between",
                            alignItems: "center"
                        },
                        children: [
                            value,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.OpenInNew), {
                                fontSize: "small"
                            })
                        ]
                    })
                }),
            cellClassName: ()=>editable ? "" : "success",
            sortable: false
        },
        {
            field: "date",
            headerName: "Date",
            type: "date",
            minWidth: 115,
            valueGetter: ({ value })=>(0, _dateFns.format)(new Date(value), "dd/MM/yyyy"),
            sortable: false
        },
        {
            field: "clientID",
            headerName: "Client",
            type: "singleSelect",
            editable,
            minWidth: 150,
            valueOptions: contracts,
            valueFormatter: ({ value: clientID })=>{
                var _contracts_find;
                var _contracts_find_label;
                return (_contracts_find_label = (_contracts_find = contracts.find(({ value })=>value === clientID)) === null || _contracts_find === void 0 ? void 0 : _contracts_find.label) !== null && _contracts_find_label !== void 0 ? _contracts_find_label : PLACEHOLDER;
            },
            sortable: false
        },
        {
            field: "onCall",
            headerName: "On-call",
            type: "boolean",
            editable,
            hide: !showOnCall,
            width: 75,
            align: "center",
            renderCell: ({ value, row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ActionCell), {
                    disabled: !editable,
                    onClick: ()=>onUpdateOnCall({
                            row: {
                                ...row,
                                onCall: !value
                            }
                        }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        sx: {
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckBox), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CheckBoxOutlineBlankOutlined), {})
                    })
                }),
            sortable: false
        },
        ...hourFields(editable),
        {
            field: "total",
            headerName: "Total",
            type: "number",
            minWidth: 125,
            valueGetter: ({ row })=>[
                    row.standard,
                    row.overtime,
                    row.sick,
                    row.holiday
                ].map((v)=>v !== null && v !== void 0 ? v : 0).reduce((a, b)=>a + b, 0).toString(),
            cellClassName: ({ value })=>value === "0" ? "error" : value === "8" ? "success" : "warning",
            sortable: false
        }
    ];

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../components":"0272J","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cTBZd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _timesheetModal = require("./TimesheetModal");
parcelHelpers.exportAll(_timesheetModal, exports);
var _useTimesheetModal = require("./useTimesheetModal");
parcelHelpers.exportAll(_useTimesheetModal, exports);

},{"./TimesheetModal":"1P0Oh","./useTimesheetModal":"2TbAi","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1P0Oh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimesheetModal", ()=>TimesheetModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _components = require("../../../components");
const TimesheetModal = ({ onSubmit, testID, params: { contracts = [], row }, ...rest })=>{
    const [saving, setSaving] = (0, _react.useState)(false);
    const { control, handleSubmit } = (0, _reactHookForm.useForm)({
        defaultValues: mapDefaultValues(row),
        mode: "onBlur"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalSkeleton), {
        ...rest,
        isForm: true,
        title: `Enter time for ${new Date(row.date).toLocaleDateString()}`,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit(({ standard, overtime, sick, holiday, ...rest })=>{
                setSaving(true);
                return onSubmit({
                    data: {
                        standard: Number(standard),
                        overtime: Number(overtime),
                        sick: Number(sick),
                        holiday: Number(holiday),
                        ...rest
                    }
                });
            }),
            testID: "save"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "grid",
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(1, 1fr)",
                            md: "repeat(2, 1fr)"
                        },
                        gap: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                            control: control,
                            name: "date",
                            label: "Date",
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SelectField), {
                            control: control,
                            name: "clientID",
                            label: "Client",
                            options: contracts,
                            displayEmpty: true,
                            variant: "outlined"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                            control: control,
                            name: "standard",
                            label: "Standard",
                            type: "number",
                            inputProps: {
                                min: 0
                            },
                            optional: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                            control: control,
                            name: "overtime",
                            label: "Overtime",
                            type: "number",
                            inputProps: {
                                min: 0
                            },
                            optional: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                            control: control,
                            name: "sick",
                            label: "Sick",
                            type: "number",
                            inputProps: {
                                min: 0
                            },
                            optional: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                            control: control,
                            name: "holiday",
                            label: "Holiday",
                            type: "number",
                            inputProps: {
                                min: 0
                            },
                            optional: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    sx: {
                        display: "grid",
                        gap: 2
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                        control: control,
                        name: "notes",
                        label: "Notes",
                        type: "text",
                        multiline: true,
                        minRows: 2,
                        optional: true
                    })
                })
            ]
        })
    });
};
const mapDefaultValues = (value)=>{
    var _value_standard, _value_overtime, _value_sick, _value_holiday, _value_notes;
    return {
        id: value.id,
        date: value.date,
        clientID: value.clientID,
        employeeID: value.employeeID,
        standard: (_value_standard = value.standard) !== null && _value_standard !== void 0 ? _value_standard : 0,
        overtime: (_value_overtime = value.overtime) !== null && _value_overtime !== void 0 ? _value_overtime : 0,
        sick: (_value_sick = value.sick) !== null && _value_sick !== void 0 ? _value_sick : 0,
        holiday: (_value_holiday = value.holiday) !== null && _value_holiday !== void 0 ? _value_holiday : 0,
        notes: (_value_notes = value.notes) !== null && _value_notes !== void 0 ? _value_notes : ""
    };
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","../../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2TbAi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimesheetModal", ()=>useTimesheetModal);
var _components = require("../../../components");
var _lib = require("../../../lib");
var _timesheetModal = require("./TimesheetModal");
const useTimesheetModal = ()=>{
    const { setTimelogs } = (0, _lib.useTimelogLib)();
    const { showModal, hideModal } = (0, _components.useModal)({
        component: (0, _timesheetModal.TimesheetModal),
        data: {
            onSubmit: ({ data: { id, ...data } })=>{
                setTimelogs({
                    ...data,
                    id: (id === null || id === void 0 ? void 0 : id.at(1)) ? id : undefined
                }, {
                    onSettled: hideModal
                });
            },
            testID: "add-time-entry"
        }
    });
    return {
        showModal
    };
};

},{"../../../components":"0272J","../../../lib":"lWrCo","./TimesheetModal":"1P0Oh","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kqGTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimesheetQuery", ()=>useTimesheetQuery);
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _lib = require("../../lib");
var _hooks = require("../../hooks");
var _utils = require("./utils");
const getTimesheetQuery = ({ id, week, user, nullEmployeeHandler, dupeLogHandler })=>{
    if (week === null) throw new Error("Cannot pull data, date range is undefined.");
    if (!user) throw new Error("Error loading user details. If problems persist contact a manager to create a record manually.");
    if (!user.isGoogle && !user.isAdmin) throw new Error("Sign in with Google to submit timesheets.");
    const { queryFn, queryKey } = (0, _lib.gqlQuery)({
        req: "getEmployeeWithCompany",
        vars: {
            id,
            dateRange: (0, _lib.toDbDates)(week)
        },
        key: [
            id,
            week
        ]
    });
    return {
        queryKey,
        queryFn: async ()=>{
            if (user.isAdmin && id === user.id) return {
                timesheet: [],
                isApproved: false,
                clientIDs: []
            };
            const { data } = await queryFn();
            var _data_getEmployee;
            const employee = (_data_getEmployee = data === null || data === void 0 ? void 0 : data.getEmployee) !== null && _data_getEmployee !== void 0 ? _data_getEmployee : null;
            if (employee === null) {
                await nullEmployeeHandler();
                throw new Error("Employee ID returns null record");
            }
            if (employee.timelogs) employee.timelogs.items.forEach((log, idx, logs)=>{
                var _logs_;
                if (log && idx && ((_logs_ = logs[idx - 1]) === null || _logs_ === void 0 ? void 0 : _logs_.date) === (log === null || log === void 0 ? void 0 : log.date)) {
                    dupeLogHandler(log.id);
                    logs.splice(idx, 1);
                }
            });
            return await (0, _utils.getTimesheet)({
                week,
                employee
            });
        }
    };
};
const useTimesheetQuery = ({ id, week })=>{
    const { createEmployeeRecord } = (0, _lib.useEmployeeLib)();
    const { deleteTimelogById } = (0, _lib.useTimelogLib)();
    const user = (0, _hooks.useUser)();
    id = (0, _react.useMemo)(()=>id || (user === null || user === void 0 ? void 0 : user.id), [
        id,
        user === null || user === void 0 ? void 0 : user.id
    ]);
    const { data: emailRecord, isSuccess } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listEmployeesWithCompanies",
        vars: {
            filter: {
                and: [
                    {
                        email: {
                            eq: user === null || user === void 0 ? void 0 : user.email
                        },
                        id: {
                            notContains: "google"
                        }
                    }
                ]
            }
        }
    }));
    const nullEmployeeHandler = async ()=>{
        var _emailRecord_data_listEmployees, _emailRecord_data;
        var _emailRecord_data_listEmployees_items_;
        createEmployeeRecord(user === null || user === void 0 ? void 0 : user.input, {}, (_emailRecord_data_listEmployees_items_ = emailRecord === null || emailRecord === void 0 ? void 0 : (_emailRecord_data = emailRecord.data) === null || _emailRecord_data === void 0 ? void 0 : (_emailRecord_data_listEmployees = _emailRecord_data.listEmployees) === null || _emailRecord_data_listEmployees === void 0 ? void 0 : _emailRecord_data_listEmployees.items[0]) !== null && _emailRecord_data_listEmployees_items_ !== void 0 ? _emailRecord_data_listEmployees_items_ : undefined);
    };
    const { data, isError, isLoading, isFetching, isPreviousData, error } = (0, _reactQuery.useQuery)({
        ...getTimesheetQuery({
            id,
            week,
            user,
            nullEmployeeHandler,
            dupeLogHandler: async (id)=>{
                deleteTimelogById(id);
            }
        }),
        enabled: isSuccess
    });
    var _data_clientIDs;
    const clientIDs = ((_data_clientIDs = data === null || data === void 0 ? void 0 : data.clientIDs) !== null && _data_clientIDs !== void 0 ? _data_clientIDs : []).filter((id)=>id.length);
    const contracts = (0, _lib.useGetClient)(clientIDs).map(({ id, company })=>({
            label: company.name,
            value: id
        }));
    return {
        ...data,
        contracts,
        error: error,
        isError,
        isPending: isLoading || isPreviousData || isFetching
    };
};

},{"react":"gVheC","@tanstack/react-query":"j0XMv","../../lib":"lWrCo","../../hooks":"9Pg07","./utils":"f9RHL","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eRKqv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _timeOff = require("./TimeOff");
parcelHelpers.exportAll(_timeOff, exports);

},{"./TimeOff":"aizfC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aizfC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeOff", ()=>TimeOff);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _api = require("../../API");
var _modals = require("./Modals");
var _columns = require("./columns");
var _useTimeOffQuery = require("./useTimeOffQuery");
const TEST_ID = "time-off";
const TimeOff = ()=>{
    const user = (0, _hooks.useUser)();
    const { showCreateModal, showUpdateModal, showDeleteModal } = (0, _modals.useRequestModals)();
    const { isMd } = (0, _hooks.useResponsive)();
    var _user_id;
    const [filterUser, setFilterUser] = (0, _react.useState)((_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : "");
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfYear)(new Date()),
        end: (0, _dateFns.endOfYear)(new Date())
    });
    const { items, error, isPending, daysUsed, vacationAllowance, country } = (0, _useTimeOffQuery.useTimeOffQuery)(filterUser, dates);
    const remaining = (vacationAllowance !== null && vacationAllowance !== void 0 ? vacationAllowance : 0) - (daysUsed !== null && daysUsed !== void 0 ? daysUsed : 0);
    const handleUserSearch = (val)=>{
        var _user_id;
        setFilterUser(val ? val : (_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : "");
    };
    const fileName = `${filterUser ? `${filterUser}_${Date.now()}_` : ""}TimeOff_Report`;
    var _error_message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                action: {
                    label: "Time Off",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                    onClick: ()=>showCreateModal({
                            maxAmount: remaining,
                            absences: items,
                            country: country !== null && country !== void 0 ? country : (0, _api.Country).GB,
                            employeeID: filterUser,
                            maxDate: (dates === null || dates === void 0 ? void 0 : dates.end) ? new Date(dates.end) : new Date(),
                            minDate: (dates === null || dates === void 0 ? void 0 : dates.start) ? new Date(dates.start) : new Date()
                        }),
                    disabled: remaining <= 0
                },
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AlarmOff), {}),
                title: "Time Off",
                testID: TEST_ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: user && (user === null || user === void 0 ? void 0 : user.isAdmin) ? {
                    value: filterUser || user.id,
                    onChange: handleUserSearch
                } : undefined,
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "year"
                },
                testID: "timeoff"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        sm: "repeat(3, 1fr)",
                        md: "repeat(4, 1fr)",
                        lg: "repeat(5, 1fr)",
                        xl: "repeat(6, 1fr)"
                    },
                    alignItems: "center",
                    gap: 2,
                    mb: 1
                },
                "data-testid": `${TEST_ID}-tiles`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Tiles), {
                    items: [
                        `Allowance: ${vacationAllowance !== null && vacationAllowance !== void 0 ? vacationAllowance : 0}`,
                        `Used: ${daysUsed !== null && daysUsed !== void 0 ? daysUsed : 0}`,
                        `Remaining: ${remaining}`
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    showUpdateModal,
                    showDeleteModal,
                    remaining,
                    absences: items,
                    vacationAllowance,
                    country: country !== null && country !== void 0 ? country : (0, _api.Country).GB,
                    employeeID: filterUser,
                    maxDate: (dates === null || dates === void 0 ? void 0 : dates.end) ? new Date(dates.end) : new Date(),
                    minDate: (dates === null || dates === void 0 ? void 0 : dates.start) ? new Date(dates.start) : new Date()
                }),
                data: items !== null && items !== void 0 ? items : [],
                loading: isPending,
                csvOptions: {
                    fileName
                },
                emptyState: {
                    title: "Time Off",
                    description: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "You have no time off requests.",
                    testID: TEST_ID
                },
                hideColumnSelector: true,
                hideExport: (user === null || user === void 0 ? void 0 : user.isAdmin) === true ? false : true,
                testID: TEST_ID,
                disableColumnMenu: true,
                hideFooterPagination: true,
                disableSelectionOnClick: true,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : {},
                sortModel: [
                    {
                        field: "startDate",
                        sort: "asc"
                    }
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","../../API":"2KRIM","./Modals":"65oa7","./columns":"fUcvO","./useTimeOffQuery":"930T9","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"65oa7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requestModal = require("./RequestModal");
parcelHelpers.exportAll(_requestModal, exports);
var _useRequestModals = require("./useRequestModals");
parcelHelpers.exportAll(_useRequestModals, exports);

},{"./RequestModal":"AsIOV","./useRequestModals":"5Cvu3","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"AsIOV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestModal", ()=>RequestModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _dateFns = require("date-fns");
var _notistack = require("notistack");
var _components = require("../../../components");
var _api = require("../../../API");
var _hooks = require("../../../hooks");
var _lib = require("../../../lib");
var _utils = require("../utils");
var _useTimeOffQuery = require("../useTimeOffQuery");
var _dateControl = require("../../../components/DatePickers/DateControl");
var _dateControlDefault = parcelHelpers.interopDefault(_dateControl);
var _useBankHolidayQuery = require("../../BankHolidays/useBankHolidayQuery");
var _useTimeInLieuQuery = require("../../TimeInLieu/useTimeInLieuQuery");
var _timeOffDates = require("./TimeOffDates");
var _utils1 = require("./utils");
const TEST_ID = "request-modal";
const RequestModal = ({ title, onSubmit, testID, params: { row, maxAmount, absences, country, employeeID, maxDate, minDate }, ...rest })=>{
    const user = (0, _hooks.useUser)();
    const { control, handleSubmit, setValue, getValues } = (0, _reactHookForm.useForm)({
        defaultValues: (0, _utils1.mapDefaultValues)(row, user, employeeID, minDate)
    });
    const getPickerDays = (0, _react.useCallback)(()=>({
            start: (0, _dateFns.endOfDay)((0, _dateFns.parseISO)(getValues("startDate"))),
            end: (0, _dateFns.endOfDay)((0, _dateFns.parseISO)(getValues("endDate")))
        }), [
        getValues
    ]);
    const [pickerDays, setPickerDays] = (0, _react.useState)(getPickerDays());
    const [absenceType, setAbsenceType] = (0, _react.useState)(getValues("type"));
    const [saving, setSaving] = (0, _react.useState)(false);
    const { timeInLieuHoursUsed } = (0, _useTimeOffQuery.useTimeOffQuery)(employeeID, {
        start: maxDate,
        end: minDate
    });
    const { timeInLieuHours } = (0, _useTimeInLieuQuery.useEmployeeTimeInLieusQuery)(employeeID, {
        start: new Date(minDate),
        end: new Date(maxDate)
    });
    const { count: amountOfDaysWithinPeriod, items: bankHolidays } = (0, _useBankHolidayQuery.useBankHolidayQuery)(pickerDays, country);
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const maxAvailable = (row === null || row === void 0 ? void 0 : row.amount) ? row.amount + maxAmount : maxAmount;
    (0, _react.useEffect)(()=>{
        const { start, end } = getPickerDays();
        const isAnnualLeave = getValues("type") === (0, _api.AbsenceType).holiday;
        let amountOfDays = (0, _lib.getBusinessDayDifference)(start, end);
        if (isAnnualLeave) {
            amountOfDays = Math.max(0, amountOfDays - amountOfDaysWithinPeriod);
            var _getValues;
            const description = (_getValues = getValues("description")) !== null && _getValues !== void 0 ? _getValues : "";
            setValue("description", (0, _utils1.getDescription)({
                amountOfDaysWithinPeriod,
                description
            }));
        }
        setValue("amount", amountOfDays);
    }, [
        pickerDays,
        amountOfDaysWithinPeriod,
        getPickerDays,
        getValues,
        setValue
    ]);
    const updateDates = (field, date)=>{
        setValue(field, date.toISOString());
    };
    const handleDateChange = (value, field)=>{
        if (!value) return;
        const { start, end } = getPickerDays();
        if (field === "startDate" && value > end || field === "endDate" && value < start) {
            updateDates("startDate", value);
            updateDates("endDate", value);
            setPickerDays({
                start: value,
                end: value
            });
        } else {
            updateDates(field, value);
            if (field === "startDate") setPickerDays({
                start: value,
                end
            });
            if (field === "endDate") setPickerDays({
                end: value,
                start
            });
        }
    };
    const handleTimeInLieuDateChange = (value)=>{
        const newDate = new Date(value !== null && value !== void 0 ? value : "").toISOString();
        if (!newDate) return;
        setValue("startDate", newDate);
        setValue("endDate", newDate);
        var _getValues;
        const hoursTakenValue = (_getValues = getValues("hoursTaken")) !== null && _getValues !== void 0 ? _getValues : 8;
        setValue("hoursTaken", newDate ? hoursTakenValue : 0);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                if (!data.approvedByClient) {
                    showSnackbar("Time off must by approved by a Client first, before submitting it", true);
                    return;
                }
                if (absences && (0, _utils1.checkExistingAbsences)({
                    absences,
                    formStartDate: data.startDate,
                    formEndDate: data.endDate,
                    currentAbsenceId: data.id
                })) {
                    showSnackbar("Time off dates already exist in the system", true);
                    return;
                }
                if (data.type === (0, _api.AbsenceType).timeInLieu) {
                    if (!data.hoursTaken) {
                        showSnackbar("Need to specify amount of hours taken from time in lieu", true);
                        return;
                    }
                    if (bankHolidays.find((bh)=>bh.date === (0, _lib.toAWSDate)(new Date(data.startDate)))) {
                        showSnackbar("Can't take time in lieu off, which is already a holiday", true);
                        return;
                    }
                    var _row_hoursTaken;
                    if (timeInLieuHours < timeInLieuHoursUsed + (data.hoursTaken - ((_row_hoursTaken = row === null || row === void 0 ? void 0 : row.hoursTaken) !== null && _row_hoursTaken !== void 0 ? _row_hoursTaken : 0))) {
                        showSnackbar("There aren't enough time in lieu to request a time off", true);
                        return;
                    }
                    data.endDate = data.startDate;
                }
                data.hoursTaken = data.type === (0, _api.AbsenceType).timeInLieu ? data.hoursTaken : Number(data.amount) * 8;
                data.amount = data.type === (0, _api.AbsenceType).holiday ? Number(data.amount) : 0;
                if (data === null || data === void 0 ? void 0 : data.employeeID) {
                    setSaving(true);
                    return onSubmit({
                        data
                    });
                }
                return;
            }),
            testID: "save-request"
        },
        testID: testID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        md: "repeat(3, 1fr)"
                    },
                    alignItems: "center",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SelectField), {
                        label: "Type",
                        placeholder: "Select type",
                        options: (0, _utils.absenceTypeOptions),
                        name: "type",
                        control: control,
                        onChange: (e)=>{
                            setValue("type", e.target.value);
                            setAbsenceType(e.target.value);
                        },
                        required: true
                    }),
                    absenceType === (0, _api.AbsenceType).timeInLieu && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateControlDefault.default), {
                                label: "Select day off",
                                control: control,
                                name: "startDate",
                                disabled: !timeInLieuHours || timeInLieuHours < timeInLieuHoursUsed,
                                onChange: handleTimeInLieuDateChange
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                                label: "Hours",
                                control: control,
                                name: "hoursTaken",
                                onChange: (e)=>setValue("hoursTaken", (0, _lib.formatHoursChange)(e.target.value, 8))
                            })
                        ]
                    })
                ]
            }),
            absenceType && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)",
                                md: "repeat(1, 1fr)"
                            },
                            alignItems: "center",
                            gap: 2,
                            my: 2
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                            variant: "caption",
                            color: "info",
                            children: "To request Time off from a future year, select a different year"
                        })
                    }),
                    absenceType !== (0, _api.AbsenceType).timeInLieu && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeOffDates.TimeOffDates), {
                        control: control,
                        minDate: minDate,
                        maxDate: maxDate,
                        maxAvailable: maxAvailable,
                        minEndDate: getValues("startDate") ? new Date(getValues("startDate")) : undefined,
                        pickerDays: pickerDays,
                        handleDateChange: handleDateChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        sx: {
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "repeat(1, 1fr)"
                            },
                            alignItems: "center",
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                                required: true,
                                control: control,
                                name: "approvedByClient",
                                label: "Checked and approved by client?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                                variant: "caption",
                                color: "info",
                                mb: 2,
                                children: "In case of no client, mark it as approved"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                                control: control,
                                name: "description",
                                label: "Description",
                                multiline: true,
                                rows: 2,
                                "data-testid": `${TEST_ID}-description`,
                                optional: true,
                                helperText: "Use this field to provide additional information about your request, such as the allocation time for each day if you want to fractionate them."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","date-fns":"5Pdd3","notistack":"3Lc8y","../../../components":"0272J","../../../API":"2KRIM","../../../hooks":"9Pg07","../../../lib":"lWrCo","../utils":"jy6Ws","../useTimeOffQuery":"930T9","../../../components/DatePickers/DateControl":"6PaYh","../../BankHolidays/useBankHolidayQuery":"1LO7A","../../TimeInLieu/useTimeInLieuQuery":"nBlzt","./TimeOffDates":"iPCik","./utils":"79kvm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jy6Ws":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validTimeOff", ()=>validTimeOff);
parcelHelpers.export(exports, "isValidTimeOff", ()=>isValidTimeOff);
parcelHelpers.export(exports, "absenceTypeOptions", ()=>absenceTypeOptions);
var _api = require("../../API");
var _absences = require("../../lib/types/absences");
const validTimeOff = [
    (0, _absences.TimeOffEnum).Approved,
    (0, _absences.TimeOffEnum).Pending
];
const isValidTimeOff = (status = "")=>validTimeOff.includes(status !== null && status !== void 0 ? status : "");
const absenceTypeOptions = [
    {
        label: "Select Absence Type",
        value: "",
        disabled: true
    },
    ...Object.values((0, _api.AbsenceType)).map((type)=>({
            label: type.slice(0, 1).toUpperCase() + type.slice(1).toLowerCase(),
            value: type
        }))
];

},{"../../API":"2KRIM","../../lib/types/absences":"xOG3F","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"xOG3F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeOffEnum", ()=>TimeOffEnum);
var TimeOffEnum;
(function(TimeOffEnum) {
    TimeOffEnum["Approved"] = "approved";
    TimeOffEnum["Pending"] = "pending";
    TimeOffEnum["Rejected"] = "rejected";
    TimeOffEnum["Expired"] = "expired";
})(TimeOffEnum || (TimeOffEnum = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"930T9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimeOffQuery", ()=>useTimeOffQuery);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _lib = require("../../lib");
var _api = require("../../API");
var _utils = require("./utils");
const useTimeOffQuery = (userId, dates)=>{
    var _data_data;
    var _dates_start, _dates_end, _dates_start1;
    const { data, isLoading, isFetching, isPreviousData, error, ...rest } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "getEmployeeWithAbsences",
        vars: {
            id: userId,
            startDate: [
                (0, _lib.toAWSDate)((0, _dateFns.startOfYear)((_dates_start = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start !== void 0 ? _dates_start : new Date())),
                (0, _lib.toAWSDate)((0, _dateFns.endOfYear)((_dates_end = dates === null || dates === void 0 ? void 0 : dates.end) !== null && _dates_end !== void 0 ? _dates_end : new Date()))
            ]
        },
        key: [
            userId,
            (_dates_start1 = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start1 !== void 0 ? _dates_start1 : new Date()
        ]
    }));
    var _data_data_getEmployee;
    const { vacationAllowance, absences, country } = (_data_data_getEmployee = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.getEmployee) !== null && _data_data_getEmployee !== void 0 ? _data_data_getEmployee : {};
    var _absences_items;
    const items = (_absences_items = absences === null || absences === void 0 ? void 0 : absences.items) !== null && _absences_items !== void 0 ? _absences_items : [];
    const validItems = items.filter((i)=>(0, _utils.isValidTimeOff)(i === null || i === void 0 ? void 0 : i.approvalStatus));
    const timeInLieuItems = validItems.filter((i)=>i.type === (0, _api.AbsenceType).timeInLieu);
    const count = (acc, curr)=>{
        var _curr_amount;
        return acc + ((_curr_amount = curr === null || curr === void 0 ? void 0 : curr.amount) !== null && _curr_amount !== void 0 ? _curr_amount : 0);
    };
    const countTimeInLieuHours = (acc, curr)=>{
        var _curr_hoursTaken;
        return acc + ((_curr_hoursTaken = curr.hoursTaken) !== null && _curr_hoursTaken !== void 0 ? _curr_hoursTaken : 8);
    };
    return {
        items,
        country,
        daysUsed: validItems.reduce(count, 0),
        timeInLieuHoursUsed: timeInLieuItems.reduce(countTimeInLieuHours, 0),
        isPending: isLoading || isPreviousData || isFetching,
        error: error,
        vacationAllowance,
        ...rest
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","../../lib":"lWrCo","../../API":"2KRIM","./utils":"jy6Ws","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"1LO7A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBankHolidayQuery", ()=>useBankHolidayQuery);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _lib = require("../../lib");
const useBankHolidayQuery = (dates, country)=>{
    var _data_data_listBankHolidays, _data_data;
    var _dates_start, _dates_end;
    const dateFilter = {
        between: [
            (0, _lib.toAWSDate)(new Date((_dates_start = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start !== void 0 ? _dates_start : (0, _dateFns.startOfYear)(new Date()))),
            (0, _lib.toAWSDate)(new Date((_dates_end = dates === null || dates === void 0 ? void 0 : dates.end) !== null && _dates_end !== void 0 ? _dates_end : (0, _dateFns.endOfYear)(new Date())))
        ]
    };
    var _dates_start1, _dates_end1;
    const { data, isLoading, isFetching, isPreviousData, error, isError, refetch, ...rest } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listBankHolidays",
        vars: {
            filter: country ? {
                countryCode: {
                    eq: country
                },
                date: dateFilter
            } : {
                date: dateFilter
            }
        },
        key: [
            country !== null && country !== void 0 ? country : "",
            (_dates_start1 = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start1 !== void 0 ? _dates_start1 : new Date(),
            (_dates_end1 = dates === null || dates === void 0 ? void 0 : dates.end) !== null && _dates_end1 !== void 0 ? _dates_end1 : new Date()
        ]
    }));
    var _data_data_listBankHolidays_items;
    const items = (_data_data_listBankHolidays_items = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_listBankHolidays = _data_data.listBankHolidays) === null || _data_data_listBankHolidays === void 0 ? void 0 : _data_data_listBankHolidays.items) !== null && _data_data_listBankHolidays_items !== void 0 ? _data_data_listBankHolidays_items : [];
    return {
        items,
        count: items.length,
        isPending: isLoading || isPreviousData || isFetching,
        error: error,
        isError,
        refetch,
        ...rest
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"nBlzt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validTimeInLieu", ()=>validTimeInLieu);
parcelHelpers.export(exports, "isValidTimeInLieu", ()=>isValidTimeInLieu);
parcelHelpers.export(exports, "useEmployeeTimeInLieusQuery", ()=>useEmployeeTimeInLieusQuery);
var _reactQuery = require("@tanstack/react-query");
var _dateFns = require("date-fns");
var _lib = require("../../lib");
var _absences = require("../../lib/types/absences");
const validTimeInLieu = [
    (0, _absences.TimeOffEnum).Approved
];
const isValidTimeInLieu = (status = "")=>validTimeInLieu.includes(status !== null && status !== void 0 ? status : "");
const useEmployeeTimeInLieusQuery = (userId, dates)=>{
    var _data_data;
    var _dates_start, _dates_end, _dates_start1;
    const { data, isLoading, isFetching, isPreviousData, error, ...rest } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "getEmployeeWithTimeInLieus",
        vars: {
            id: userId,
            dateTaken: [
                (0, _lib.toAWSDate)((0, _dateFns.startOfYear)((_dates_start = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start !== void 0 ? _dates_start : new Date())),
                (0, _lib.toAWSDate)((0, _dateFns.endOfYear)((_dates_end = dates === null || dates === void 0 ? void 0 : dates.end) !== null && _dates_end !== void 0 ? _dates_end : new Date()))
            ]
        },
        key: [
            userId,
            (_dates_start1 = dates === null || dates === void 0 ? void 0 : dates.start) !== null && _dates_start1 !== void 0 ? _dates_start1 : new Date()
        ]
    }));
    var _data_data_getEmployee;
    const { timeInLieus } = (_data_data_getEmployee = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.getEmployee) !== null && _data_data_getEmployee !== void 0 ? _data_data_getEmployee : {};
    var _timeInLieus_items;
    const validItems = ((_timeInLieus_items = timeInLieus === null || timeInLieus === void 0 ? void 0 : timeInLieus.items) !== null && _timeInLieus_items !== void 0 ? _timeInLieus_items : []).filter((tl)=>tl && isValidTimeInLieu(tl.approvalStatus));
    const countHours = (acc, curr)=>{
        var _curr_hoursTaken;
        return acc + ((_curr_hoursTaken = curr.hoursTaken) !== null && _curr_hoursTaken !== void 0 ? _curr_hoursTaken : 8);
    };
    return {
        items: timeInLieus === null || timeInLieus === void 0 ? void 0 : timeInLieus.items,
        validItems,
        count: validItems.length,
        timeInLieuHours: validItems.reduce(countHours, 0),
        isPending: isLoading || isPreviousData || isFetching,
        error: error,
        ...rest
    };
};

},{"@tanstack/react-query":"j0XMv","date-fns":"5Pdd3","../../lib":"lWrCo","../../lib/types/absences":"xOG3F","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"iPCik":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeOffDates", ()=>TimeOffDates);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _components = require("../../../components");
const TEST_ID = "time-off";
const TimeOffDates = ({ maxAvailable, maxDate, minDate, pickerDays, minEndDate, control, handleDateChange })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        sx: {
            display: "grid",
            gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                md: "repeat(3, 1fr)"
            },
            alignItems: "start",
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ControlledRangePicker), {
                control: control,
                name: "startDate",
                label: "Start Date",
                views: [
                    "month",
                    "day"
                ],
                onChange: async (date)=>{
                    await handleDateChange(date, "startDate");
                },
                pickerDays: pickerDays,
                disablePast: true,
                minDate: minDate,
                maxDate: maxDate,
                "data-testid": `${TEST_ID}-startDate-picker`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ControlledRangePicker), {
                control: control,
                name: "endDate",
                label: "End Date",
                views: [
                    "month",
                    "day"
                ],
                onChange: async (date)=>{
                    await handleDateChange(date, "endDate");
                },
                pickerDays: pickerDays,
                minDate: minEndDate,
                maxDate: maxDate,
                disablePast: true,
                "data-testid": `${TEST_ID}-endDate-picker`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                control: control,
                name: "amount",
                label: "Amount",
                type: "number",
                helperText: " ",
                inputProps: {
                    min: 0.5,
                    step: 0.5,
                    max: maxAvailable
                },
                "data-testid": `${TEST_ID}-amount`
            })
        ]
    });

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","../../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"79kvm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDescription", ()=>getDescription);
parcelHelpers.export(exports, "checkExistingAbsences", ()=>checkExistingAbsences);
parcelHelpers.export(exports, "mapDefaultValues", ()=>mapDefaultValues);
var _dateFns = require("date-fns");
var _api = require("../../../API");
var _lib = require("../../../lib");
var _utils = require("../utils");
const getDescription = ({ amountOfDaysWithinPeriod, description })=>{
    let updatedDescription = description !== null && description !== void 0 ? description : "";
    if (amountOfDaysWithinPeriod > 0) {
        var _description_match;
        const holidayExclusionNote = `\n(${amountOfDaysWithinPeriod} Holiday day${amountOfDaysWithinPeriod > 1 ? "s" : ""} ha${amountOfDaysWithinPeriod == 1 ? "s" : "ve"} been excluded from the request.)`;
        if (// if we haven't written the note, write it
        !((_description_match = description.match(/\r?\n\(\d+ Holiday days? ha(?:s|ve) been excluded from the request\.\)/g)) === null || _description_match === void 0 ? void 0 : _description_match.length)) updatedDescription = description + holidayExclusionNote;
        else updatedDescription = description.replace(/\r?\n\(\d+ Holiday days? ha(?:s|ve) been excluded from the request\.\)/g, holidayExclusionNote);
    }
    if (amountOfDaysWithinPeriod == 0) // going from 1 holiday to exclude, to 0
    updatedDescription = description.replace(/\r?\n\(\d+ Holiday days? ha(?:s|ve) been excluded from the request\.\)/g, "");
    return updatedDescription;
};
const checkExistingAbsences = ({ absences, currentAbsenceId, formStartDate, formEndDate })=>{
    if (!absences || absences.length === 0) return false;
    return !!(absences === null || absences === void 0 ? void 0 : absences.find((a)=>{
        // If Updating current Absence ignore
        if (a.id === currentAbsenceId) return false;
        const startDate = a.startDate;
        const endDate = a.endDate;
        const newStartDate = (0, _lib.toAWSDate)(new Date(formStartDate));
        const newEndDate = (0, _lib.toAWSDate)(new Date(formEndDate));
        var _a_approvalStatus;
        const isValidRequest = (0, _utils.validTimeOff).includes((_a_approvalStatus = a === null || a === void 0 ? void 0 : a.approvalStatus) !== null && _a_approvalStatus !== void 0 ? _a_approvalStatus : "");
        return(// check if starts before and end is within the existing range
        (newStartDate <= startDate && newEndDate >= startDate || // check if end is after and start is within the existing range
        newEndDate >= endDate && newStartDate <= endDate || // check if start and end is within the existing range
        newStartDate >= startDate && newEndDate < endDate || // check if start is before and end is after the range - existing range is within the new on
        newStartDate < startDate && newEndDate >= endDate) && isValidRequest);
    }));
};
const DEFAULT_AMOUNT = 1;
const mapDefaultValues = (value, user, employeeID, minDate = new Date())=>{
    var _value_startDate, _value_endDate, _value_amount, _value_description, _value_hoursTaken, _value_type, _value_employeeID, _ref, _ref1, _value_approvalStatus, _value_approvedByClient;
    return {
        id: value === null || value === void 0 ? void 0 : value.id,
        startDate: (_value_startDate = value === null || value === void 0 ? void 0 : value.startDate) !== null && _value_startDate !== void 0 ? _value_startDate : (0, _dateFns.max)([
            minDate,
            new Date()
        ]).toISOString(),
        endDate: (_value_endDate = value === null || value === void 0 ? void 0 : value.endDate) !== null && _value_endDate !== void 0 ? _value_endDate : (0, _dateFns.max)([
            minDate,
            new Date()
        ]).toISOString(),
        amount: (_value_amount = value === null || value === void 0 ? void 0 : value.amount) !== null && _value_amount !== void 0 ? _value_amount : DEFAULT_AMOUNT,
        description: (_value_description = value === null || value === void 0 ? void 0 : value.description) !== null && _value_description !== void 0 ? _value_description : "",
        hoursTaken: (_value_hoursTaken = value === null || value === void 0 ? void 0 : value.hoursTaken) !== null && _value_hoursTaken !== void 0 ? _value_hoursTaken : 0,
        type: (_value_type = value === null || value === void 0 ? void 0 : value.type) !== null && _value_type !== void 0 ? _value_type : (0, _api.AbsenceType).holiday,
        employeeID: (_ref1 = (_ref = (_value_employeeID = value === null || value === void 0 ? void 0 : value.employeeID) !== null && _value_employeeID !== void 0 ? _value_employeeID : employeeID) !== null && _ref !== void 0 ? _ref : user === null || user === void 0 ? void 0 : user.id) !== null && _ref1 !== void 0 ? _ref1 : "",
        approvalStatus: (_value_approvalStatus = value === null || value === void 0 ? void 0 : value.approvalStatus) !== null && _value_approvalStatus !== void 0 ? _value_approvalStatus : (0, _api.ApprovalStatus).pending,
        approvedByClient: (_value_approvedByClient = value === null || value === void 0 ? void 0 : value.approvedByClient) !== null && _value_approvedByClient !== void 0 ? _value_approvedByClient : false
    };
};

},{"date-fns":"5Pdd3","../../../API":"2KRIM","../../../lib":"lWrCo","../utils":"jy6Ws","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"5Cvu3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRequestModals", ()=>useRequestModals);
var _notistack = require("notistack");
var _components = require("../../../components");
var _lib = require("../../../lib");
var _requestModal = require("./RequestModal");
const useRequestModals = ()=>{
    const { createAbsenceRecord, updateAbsenceRecord, deleteAbsenceRecord } = (0, _lib.useAbsenceLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const postAction = (message, isError, callback)=>{
        showSnackbar(message, isError);
        callback();
    };
    const { showModal: showCreateModal, hideModal: hideCreateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Request Time Off",
            onSubmit: ({ data })=>createAbsenceRecord(data, {
                    onSuccess: ()=>postAction("Your time off request has been submitted.", false, hideCreateModal),
                    onError: ()=>postAction("Error requesting time off. Please try again in a few seconds", true, hideCreateModal)
                }),
            testID: "create-request"
        }
    });
    const { showModal: showUpdateModal, hideModal: hideUpdateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Update Time Off",
            onSubmit: ({ data })=>!data.id ? null : updateAbsenceRecord({
                    ...data,
                    id: data.id
                }, {
                    onSuccess: ()=>postAction("Your time off request has been submitted.", false, hideUpdateModal),
                    onError: ()=>postAction("Error requesting time off. Please try again in a few seconds", true, hideUpdateModal)
                }),
            testID: "update-request"
        }
    });
    const { showModal: showDeleteModal, hideModal: hideDeleteModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Remove Time Off Request",
            label: "Remove",
            description: "Are you sure you want to remove this entry?",
            onUpdate: ({ id })=>deleteAbsenceRecord(id, {
                    onSuccess: ()=>postAction("Your time off request has been deleted.", false, hideDeleteModal),
                    onError: ()=>postAction("Error deleting time off. Please try again in a few seconds", true, hideDeleteModal)
                })
        }
    });
    return {
        showCreateModal,
        showUpdateModal,
        showDeleteModal
    };
};

},{"notistack":"3Lc8y","../../../components":"0272J","../../../lib":"lWrCo","./RequestModal":"AsIOV","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"fUcvO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xDataGrid = require("@mui/x-data-grid");
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _api = require("../../API");
var _components = require("../../components");
var _lib = require("../../lib");
const displayStatus = (sts)=>sts[0].toUpperCase() + sts.slice(1);
const disabledAction = (status)=>status !== (0, _api.ApprovalStatus).pending;
const renderActionButton = ({ icon, label, onClick }, params, remaining, absences, employeeID, country, maxDate, minDate)=>disabledAction(params.row.approvalStatus) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Tooltip), {
        title: label,
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": `grid-${label.toLowerCase()}-button`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridActionsCellItem), {
                label: label,
                onClick: ()=>{
                    onClick({
                        ...params,
                        maxAmount: remaining,
                        absences,
                        employeeID,
                        country,
                        maxDate,
                        minDate
                    });
                },
                icon: icon
            })
        })
    });
const columns = ({ showUpdateModal, showDeleteModal, remaining, absences, vacationAllowance, employeeID, country, maxDate, minDate })=>[
        {
            field: "startDate",
            headerName: "Start",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _lib.parseDate)(value), "dd/MM/yyyy")
        },
        {
            field: "endDate",
            headerName: "End",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _lib.parseDate)(value), "dd/MM/yyyy")
        },
        {
            field: "hoursTaken",
            headerName: "Hours"
        },
        {
            field: "amount",
            headerName: "Amount",
            align: "left",
            valueGetter: ({ row })=>{
                if (row.type !== (0, _api.AbsenceType).holiday) return (0, _lib.getBusinessDayDifference)(new Date(row.startDate), new Date(row.endDate));
                return row.amount;
            }
        },
        {
            field: "type",
            headerName: "Type",
            align: "left"
        },
        {
            field: "remaining",
            headerName: "Remaining days",
            align: "left",
            valueGetter: ({ row })=>{
                const allowance = vacationAllowance;
                if (!allowance) return 0;
                if (row.type !== (0, _api.AbsenceType).holiday) return "";
                // support either row.employee.id or row.employeeID
                const employeeId = row.employeeID;
                // parse current row start date to compute cumulative usage up to this row
                const rowStart = row.startDate ? (0, _dateFns.parseISO)(row.startDate) : null;
                const used = (absences !== null && absences !== void 0 ? absences : []).filter((usedAbsence)=>{
                    const aEmployeeId = usedAbsence === null || usedAbsence === void 0 ? void 0 : usedAbsence.employeeID;
                    // only same employee (or all if employeeId is missing)
                    if (employeeId != null && aEmployeeId !== employeeId) return false;
                    var _usedAbsence_approvalStatus;
                    // only count approved or pending
                    const isCounted = [
                        (0, _api.ApprovalStatus).approved,
                        (0, _api.ApprovalStatus).pending
                    ].includes((_usedAbsence_approvalStatus = usedAbsence === null || usedAbsence === void 0 ? void 0 : usedAbsence.approvalStatus) !== null && _usedAbsence_approvalStatus !== void 0 ? _usedAbsence_approvalStatus : "");
                    if (!isCounted) return false;
                    // if we have dates, only include absences that start on or before this row's start
                    if (!rowStart || !(usedAbsence === null || usedAbsence === void 0 ? void 0 : usedAbsence.startDate)) return true;
                    try {
                        // include if usedAbsence.startDate <= row.startDate
                        return (0, _dateFns.parseISO)(usedAbsence.startDate) <= rowStart;
                    } catch  {
                        return true;
                    }
                }).reduce((sum, usedAbsence)=>{
                    var _usedAbsence_amount;
                    return sum + ((_usedAbsence_amount = usedAbsence === null || usedAbsence === void 0 ? void 0 : usedAbsence.amount) !== null && _usedAbsence_amount !== void 0 ? _usedAbsence_amount : 0);
                }, 0);
                return Math.max(allowance - used, 0);
            }
        },
        {
            field: "approvalStatus",
            headerName: "Approval status",
            width: 128,
            renderCell: ({ value })=>displayStatus(value !== null && value !== void 0 ? value : "pending")
        },
        {
            field: "description",
            headerName: "Applicant Description",
            flex: 1,
            renderCell: ({ value })=>value
        },
        {
            field: "notes",
            headerName: "Approver notes",
            flex: 1,
            renderCell: ({ value })=>value
        },
        {
            field: "actions",
            headerName: "Actions",
            cellClassName: "actions",
            width: 96,
            sortable: false,
            headerAlign: "left",
            renderCell: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        renderActionButton({
                            label: "Edit",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Edit), {}),
                            onClick: showUpdateModal
                        }, params, remaining, absences, employeeID, country, maxDate, minDate),
                        renderActionButton({
                            label: "Delete",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Delete), {}),
                            onClick: showDeleteModal
                        }, params)
                    ]
                })
        }
    ];
const hiddenColumnsMobile = {
    endDate: false,
    amount: false,
    approver: false,
    description: true,
    actions: false
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/x-data-grid":"1d1Aj","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../API":"2KRIM","../../components":"0272J","../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9cGG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _absenceTracker = require("./AbsenceTracker");
parcelHelpers.exportAll(_absenceTracker, exports);

},{"./AbsenceTracker":"dkHDl","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dkHDl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbsenceTracker", ()=>AbsenceTracker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _iconsMaterial = require("@mui/icons-material");
var _notistack = require("notistack");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _lib = require("../../lib");
var _columns = require("./columns");
var _modals = require("./Modals");
var _utils = require("./utils");
const TEST_ID = "absences";
const AbsenceTracker = ()=>{
    const [employeeID, setEmployeeID] = (0, _react.useState)("");
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfYear)(new Date()),
        end: (0, _dateFns.endOfYear)(new Date())
    });
    const { isMd } = (0, _hooks.useResponsive)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { showActionModal } = (0, _modals.useActionModals)();
    const { updateAbsenceRecord } = (0, _lib.useAbsenceLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)((0, _utils.absencesReportQuery)({
        dates,
        id: employeeID
    }));
    const handleRowUpdate = (row)=>{
        const { description, id, endDate, startDate } = row;
        const data = {
            description,
            id,
            endDate,
            startDate
        };
        updateAbsenceRecord(data, {
            onSuccess: ()=>postAction("Time Off request has been updated.", false),
            onError: ()=>postAction("Error updating Time Off request. Please try again in a few seconds", true)
        });
        return {
            ...data,
            id: row.id
        };
    };
    const postAction = (message, isError)=>{
        showSnackbar(message, isError);
    };
    const fileName = `${dates ? `${(0, _lib.toIntervalString)(dates)} - ` : ""}${employeeID}Absence_Report`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                action: {
                    label: "View Calendar",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CalendarMonth), {}),
                    onClick: ()=>navigate("/admin/calendar")
                },
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.EventBusy), {}),
                title: "Absence Tracker",
                testID: TEST_ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: {
                    value: employeeID,
                    onChange: setEmployeeID
                },
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "range",
                    inputFormat: "yyyy-MM-dd"
                },
                testID: "absence"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    showActionModal
                }),
                data: (data === null || data === void 0 ? void 0 : data.items) || [],
                csvOptions: {
                    fileName
                },
                pagination: pagination,
                emptyState: {
                    title: "Time Off Requests",
                    description: "Time Off requests that are pending will appear here for you to approve.",
                    testID: TEST_ID
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                sortModel: [
                    {
                        field: "startDate",
                        sort: "asc"
                    }
                ],
                testID: TEST_ID,
                disableColumnMenu: true,
                hideFooterPagination: true,
                disableSelectionOnClick: true,
                hideColumnSelector: true,
                processRowUpdate: handleRowUpdate,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : {}
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-router-dom":"k10Fc","@mui/icons-material":"4DI4K","notistack":"3Lc8y","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","../../lib":"lWrCo","./columns":"3w9dL","./Modals":"6dpOB","./utils":"jIJzH","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3w9dL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsDesktop", ()=>hiddenColumnsDesktop);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _components = require("../../components");
var _api = require("../../API");
const columns = ({ showActionModal })=>[
        {
            field: "approvalStatus",
            headerName: "Status",
            width: 72,
            align: "center",
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                    status: value
                })
        },
        {
            field: "employee",
            headerName: "Employee",
            minWidth: 100,
            flex: 1,
            align: "left",
            valueGetter: ({ row: { employee } })=>`${employee.firstName} ${employee.lastName}`
        },
        {
            field: "approvedByClient",
            headerName: "Approved by Client",
            width: 100,
            align: "left",
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                    status: value ? "approved" : "pending"
                })
        },
        {
            field: "startDate",
            headerName: "Start",
            align: "left",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _dateFns.parseISO)(value), "dd/MM/yyyy")
        },
        {
            field: "endDate",
            headerName: "End",
            align: "left",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _dateFns.parseISO)(value), "dd/MM/yyyy")
        },
        {
            field: "hoursTaken",
            headerName: "Hours",
            align: "left"
        },
        {
            field: "amount",
            headerName: "Amount",
            align: "left"
        },
        {
            field: "description",
            headerName: "Description",
            align: "left",
            minWidth: 200
        },
        {
            field: "logIds",
            headerName: "Approval",
            type: "actions",
            minWidth: 200,
            renderCell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalCell), {
                    disable: {
                        approve: row.approvalStatus === "approved" || row.approvalStatus === "rejected",
                        reject: row.approvalStatus === "rejected"
                    },
                    onApprove: ()=>showActionModal({
                            row,
                            status: (0, _api.ApprovalStatus).approved
                        }),
                    onReject: ()=>showActionModal({
                            row,
                            status: (0, _api.ApprovalStatus).rejected
                        })
                })
        }
    ];
const hiddenColumnsDesktop = {
    overtime: false
};
const hiddenColumnsMobile = {
    ...hiddenColumnsDesktop,
    sick: false,
    holiday: false
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","date-fns":"5Pdd3","../../components":"0272J","../../API":"2KRIM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"6dpOB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionModal = require("./ActionModal");
parcelHelpers.exportAll(_actionModal, exports);
var _useActionModal = require("./useActionModal");
parcelHelpers.exportAll(_useActionModal, exports);

},{"./ActionModal":"dF0H7","./useActionModal":"kBUNM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dF0H7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionModal", ()=>ActionModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _components = require("../../../components");
var _api = require("../../../API");
var _hooks = require("../../../hooks");
const TEST_ID = "absence-modal";
const ActionModal = ({ onSubmit, testID, params: { row, status }, ...rest })=>{
    const user = (0, _hooks.useUser)();
    const { control, handleSubmit } = (0, _reactHookForm.useForm)({
        defaultValues: mapDefaultValues(row, user, status)
    });
    const [saving, setSaving] = (0, _react.useState)(false);
    const statusToTitle = status === (0, _api.ApprovalStatus).approved ? "Approve" : "Reject";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalSkeleton), {
        ...rest,
        title: `${statusToTitle} Time Off Request`,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                setSaving(true);
                const x = data;
                return onSubmit({
                    data: x
                });
            }),
            testID: "save-request"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)"
                },
                alignItems: "center",
                gap: 2,
                mb: 1
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                control: control,
                name: "notes",
                label: "Notes",
                multiline: true,
                rows: 2,
                "data-testid": `${TEST_ID}-notes`,
                required: true,
                helperText: "Use this field to provide additional information about your approval/denial."
            })
        })
    });
};
const mapDefaultValues = (value, user, status)=>{
    var _value_id, _value_startDate, _value_endDate, _value_notes;
    return {
        id: (_value_id = value === null || value === void 0 ? void 0 : value.id) !== null && _value_id !== void 0 ? _value_id : "",
        startDate: (_value_startDate = value === null || value === void 0 ? void 0 : value.startDate) !== null && _value_startDate !== void 0 ? _value_startDate : new Date().toISOString(),
        endDate: (_value_endDate = value === null || value === void 0 ? void 0 : value.endDate) !== null && _value_endDate !== void 0 ? _value_endDate : new Date().toISOString(),
        notes: (_value_notes = value === null || value === void 0 ? void 0 : value.notes) !== null && _value_notes !== void 0 ? _value_notes : "",
        approvalStatus: status !== null && status !== void 0 ? status : (0, _api.ApprovalStatus).pending
    };
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","../../../components":"0272J","../../../API":"2KRIM","../../../hooks":"9Pg07","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"kBUNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useActionModals", ()=>useActionModals);
var _notistack = require("notistack");
var _components = require("../../../components");
var _lib = require("../../../lib");
var _actionModal = require("./ActionModal");
const useActionModals = ()=>{
    const { updateAbsenceRecord } = (0, _lib.useAbsenceLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const postAction = (message, isError, callback)=>{
        showSnackbar(message, isError);
        callback();
    };
    const { showModal: showActionModal, hideModal } = (0, _components.useModal)({
        component: (0, _actionModal.ActionModal),
        data: {
            onSubmit: ({ data })=>updateAbsenceRecord(data, {
                    onSuccess: ()=>postAction("The Time Off request has been updated.", false, hideModal),
                    onError: ()=>postAction("Error updating the Time Off request. Please try again in a few seconds", true, hideModal)
                }),
            testID: "manage-request"
        }
    });
    return {
        showActionModal
    };
};

},{"notistack":"3Lc8y","../../../components":"0272J","../../../lib":"lWrCo","./ActionModal":"dF0H7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jIJzH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "absencesReportQuery", ()=>absencesReportQuery);
var _lib = require("../../lib");
const absencesReportQuery = ({ dates, id })=>(input)=>{
        if (dates === null) throw new Error(`Incorrect date range. Value is ${dates}`);
        const dateRange = (0, _lib.toDbDates)(dates);
        var _input_key, _input_key1;
        const { queryFn: listAbsencesQueryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listAbsences",
            vars: {
                filter: id.length > 0 ? {
                    employeeID: {
                        contains: id
                    },
                    startDate: {
                        ge: dateRange[0]
                    },
                    endDate: {
                        le: dateRange[1]
                    }
                } : {
                    startDate: {
                        ge: dateRange[0]
                    },
                    endDate: {
                        le: dateRange[1]
                    }
                },
                ...input.vars,
                ...id.length > 0 && {
                    id
                }
            },
            key: id ? [
                dateRange,
                {
                    id
                },
                ...(_input_key = input.key) !== null && _input_key !== void 0 ? _input_key : []
            ] : [
                dateRange,
                ...(_input_key1 = input.key) !== null && _input_key1 !== void 0 ? _input_key1 : []
            ]
        });
        return {
            queryKey,
            queryFn: async ()=>{
                var _absenceData_listAbsences, _absenceData_listAbsences1;
                const { data: absenceData, errors: absenceErrors = [] } = await listAbsencesQueryFn();
                return {
                    items: absenceData === null || absenceData === void 0 ? void 0 : (_absenceData_listAbsences = absenceData.listAbsences) === null || _absenceData_listAbsences === void 0 ? void 0 : _absenceData_listAbsences.items,
                    errors: [
                        ...absenceErrors
                    ],
                    nextToken: absenceData === null || absenceData === void 0 ? void 0 : (_absenceData_listAbsences1 = absenceData.listAbsences) === null || _absenceData_listAbsences1 === void 0 ? void 0 : _absenceData_listAbsences1.nextToken
                };
            }
        };
    };

},{"../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4IppG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calendar = require("./Calendar");
parcelHelpers.exportAll(_calendar, exports);

},{"./Calendar":"8cnBp","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"8cnBp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Calendar", ()=>Calendar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _eventManager = require("event-manager");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _styles = require("../../lib/styles");
var _useCalendarQuery = require("./useCalendarQuery");
const TEST_ID = "calendar";
const Calendar = ()=>{
    const user = (0, _hooks.useUser)();
    const [employeeID, setEmployeeID] = (0, _react.useState)("");
    const [month, setMonth] = (0, _react.useState)({
        start: (0, _dateFns.startOfMonth)(new Date()),
        end: (0, _dateFns.endOfMonth)(new Date())
    });
    const [page, setPage] = (0, _react.useState)({
        current: 0,
        rowsPerPage: 10
    });
    const { items, total, isPending } = (0, _useCalendarQuery.useCalendarQuery)({
        date: month,
        employeeID,
        page
    });
    const handleDateChange = (value)=>{
        if (value) {
            setMonth(value);
            setPage({
                ...page,
                current: 0
            });
            setEmployeeID(employeeID);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CalendarMonth), {}),
                title: "Calendar",
                testID: TEST_ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: user && (user === null || user === void 0 ? void 0 : user.isAdmin) ? {
                    value: employeeID,
                    onChange: setEmployeeID
                } : undefined,
                dates: {
                    value: month,
                    onChange: handleDateChange,
                    type: "month"
                },
                testID: "calendar"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventManager.EventManager), {
                resources: items,
                tableId: 1,
                showTooltip: true,
                legendItem: (0, _styles.colors),
                flat: true,
                hasWeekends: false,
                loading: isPending,
                multiLine: true,
                date: new Date(month.start),
                pagination: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TablePagination), {
                    component: "div",
                    count: total,
                    page: page.current,
                    rowsPerPage: page.rowsPerPage,
                    onPageChange: (_event, newPage)=>setPage({
                            ...page,
                            current: Number(newPage)
                        }),
                    onRowsPerPageChange: (e)=>setPage({
                            ...page,
                            rowsPerPage: Number(e.target.value)
                        })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/material":"iknXc","@mui/icons-material":"4DI4K","event-manager":"gWTyZ","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","../../lib/styles":"9AcuN","./useCalendarQuery":"eXGPF","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"gWTyZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventManager", ()=>ye);
var _styleCss = require("./style.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const _ = (e, t = !0)=>{
    const l = [], o = new Date(e);
    for(; o.getMonth() === e.getMonth();)(t || !t && !T(o)) && l.push(new Date(o)), o.setDate(o.getDate() + 1);
    return l;
}, N = (e = /* @__PURE__ */ new Date())=>{
    const t = e.getFullYear(), l = e.getMonth() + 1;
    return /* @__PURE__ */ new Date(`${t}/${l}/1`);
}, k = (e)=>{
    const t = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ], l = e.getDate(), o = z(l);
    return `${t[e.getDay()]} ${l}${o}`;
}, M = (e)=>{
    const t = e.getDate();
    let l = "th";
    t === 1 || t === 21 || t === 31 ? l = "st" : t === 2 || t === 22 ? l = "nd" : (t === 3 || t === 23) && (l = "rd");
    const o = e.toLocaleString("default", {
        month: "short"
    });
    return `${t}${l} ${o}`;
}, z = (e)=>{
    if (e >= 11 && e <= 13) return "th";
    switch(e % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}, O = (e, t)=>{
    const l = [], o = new Date(e);
    for(; o <= t;)l.push(new Date(o)), o.setDate(o.getDate() + 1);
    return l;
}, H = (e)=>{
    const t = new Date(e).toLocaleString("en-GB", {
        month: "long",
        year: "numeric"
    }), [l, o] = t.split(" ");
    return `${l}/${o}`;
}, T = (e)=>{
    const t = e.getDay();
    return t === 0 || t === 6;
}, Y = "_eventCell_18n8v_1", F = "_tooltip_18n8v_23", Z = "_fadeIn_18n8v_1", I = {
    eventCell: Y,
    tooltip: F,
    fadeIn: Z,
    "duration-cell": "_duration-cell_18n8v_28"
}, Q = ({ id: e, onClick: t })=>{
    const l = (o)=>{
        let d;
        const { textContent: a } = o.currentTarget;
        a && typeof a == "string" && (d = JSON.parse(a.split(`
`)[0])), t && t(d);
    };
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("td", {
        id: e,
        className: I.eventCell,
        onClick: l
    });
}, W = (e, t)=>{
    if (e.getElementsByClassName("tooltip").length <= 0) {
        const o = document.createElement("div");
        o.classList.add(I.tooltip), o.innerHTML = `
    <b>${t.label}</b><br>
    ${t.event.title}<br>
    ${M(t.event.start)} ${t.event.end ? ` - ${M(t.event.end)}` : ""}
    `, e.appendChild(o);
    }
}, P = "_legend_190oy_1", G = "_type_190oy_12", X = "_color_190oy_25", p = {
    legend: P,
    type: G,
    color: X
}, J = ({ legendItem: e })=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: p.legend
    }, Object.keys(e).map((t)=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            key: t,
            className: p.type
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement("span", null, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
            className: p.color,
            style: {
                backgroundColor: e[t]
            }
        })), t.charAt(0).toUpperCase() + t.slice(1)))), q = "_timelineActions_lvi6x_1", U = "_btn_lvi6x_15", E = {
    timelineActions: q,
    btn: U
}, K = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Ik01NzUtMjQ2IDM0MS00ODBsMjM0LTIzNCA0NyA0OC0xODYgMTg2IDE4NiAxODYtNDcgNDhaIi8+PC9zdmc+", V = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Ik01MjQtNDgwIDMzOC02NjZsNDctNDggMjM0IDIzNC0yMzQgMjM0LTQ3LTQ4IDE4Ni0xODZaIi8+PC9zdmc+", ee = ({ monthYear: e, onUpdate: t })=>{
    const l = ()=>{
        let a;
        e.getMonth() <= 0 ? a = /* @__PURE__ */ new Date(`${e.getFullYear()}/12/1`) : a = /* @__PURE__ */ new Date(`${e.getFullYear()}/${e.getMonth()}/1`), t(a);
    }, o = ()=>{
        let a;
        e.getMonth() >= 11 ? a = /* @__PURE__ */ new Date(`${e.getFullYear() + 1}/1/1`) : a = /* @__PURE__ */ new Date(`${e.getFullYear()}/${e.getMonth() + 2}/1`), t(a);
    }, d = ()=>{
        t(N());
    };
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: E.timelineActions
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        className: E.btn,
        onClick: l
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("img", {
        src: K,
        alt: "<"
    })), /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        className: E.btn,
        onClick: d
    }, "Today"), /* @__PURE__ */ (0, _reactDefault.default).createElement("button", {
        className: E.btn,
        onClick: o
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("img", {
        src: V,
        alt: "<"
    })));
}, te = "_rollerContainer_1xzg1_1", ne = "_ldsRoller_1xzg1_8", b = {
    rollerContainer: te,
    ldsRoller: ne
}, le = ()=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: b.rollerContainer
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: b.ldsRoller
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null))), oe = "_tableContainer_f5y05_1", ae = "_timelineTable_f5y05_10", h = {
    tableContainer: oe,
    timelineTable: ae
}, se = ({ title: e, monthYear: t, daysInMonth: l, resources: o, hasWeekends: d, tableId: a, multiLine: c, flat: g, showTooltip: m, onClick: r })=>{
    const u = me({
        resources: o,
        multiLine: c
    });
    de({
        resources: u,
        monthYear: t,
        key: a,
        flat: g,
        showTooltip: m
    });
    const i = (s)=>d ? !0 : !d && !T(s);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: h.tableContainer
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("table", {
        className: h.timelineTable
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("thead", null, /* @__PURE__ */ (0, _reactDefault.default).createElement("tr", null, /* @__PURE__ */ (0, _reactDefault.default).createElement("th", null, e), l.map((s)=>i(s) && /* @__PURE__ */ (0, _reactDefault.default).createElement("th", {
            key: s.toDateString()
        }, k(s))))), /* @__PURE__ */ (0, _reactDefault.default).createElement("tbody", null, u.map((s)=>/* @__PURE__ */ (0, _reactDefault.default).createElement("tr", {
            key: s.id,
            id: s.id
        }, /* @__PURE__ */ (0, _reactDefault.default).createElement("td", {
            id: s.title
        }, s.title), l.map((f)=>i(f) && /* @__PURE__ */ (0, _reactDefault.default).createElement(Q, {
                key: `${f.toDateString()}-${s.id}-${a}`,
                id: `${f.toDateString()}-${s.id}-${a}`,
                resource: s,
                onClick: r
            })))))));
}, ce = "_footer_mal4a_1", ie = {
    footer: ce
}, re = ({ legendItem: e, pagination: t, children: l })=>/* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: ie.footer
    }, e && /* @__PURE__ */ (0, _reactDefault.default).createElement(J, {
        legendItem: e
    }), l, t), de = ({ resources: e, monthYear: t, key: l, flat: o, showTooltip: d })=>{
    (0, _react.useEffect)(()=>{
        if (o) {
            const a = document.getElementById(`${l} timeline-container`);
            a && (a.style.boxShadow = "none");
        }
        e.forEach((a)=>{
            a.events.forEach((c)=>{
                var _c_end;
                O(c.start, (_c_end = c.end) !== null && _c_end !== void 0 ? _c_end : c.start).forEach((m, r, u)=>{
                    const i = document.getElementById(`${m.toDateString()}-${a.id}-${l}`);
                    if (i) {
                        var _c_color;
                        i.classList.add("duration-cell"), i.style.backgroundColor = (_c_color = c.color) !== null && _c_color !== void 0 ? _c_color : "", i.style.cursor = "pointer", i.style.boxShadow = "0 1px 0 0 rgba(0, 0, 0, 0.15)", r === 0 && (i.style.borderTopLeftRadius = "5px", i.style.borderBottomLeftRadius = "5px"), r === u.length - 1 && (i.style.borderTopRightRadius = "5px", i.style.borderBottomRightRadius = "5px");
                        const s = {
                            event: c,
                            resourceId: a.id.split("-")[0]
                        };
                        var _a_label;
                        i.textContent = JSON.stringify(s), d && W(i, {
                            label: (_a_label = a.label) !== null && _a_label !== void 0 ? _a_label : "",
                            event: c
                        });
                    }
                });
            });
        });
    }, [
        t,
        e
    ]);
}, me = ({ resources: e, multiLine: t })=>{
    const [l, o] = (0, _react.useState)([]);
    return t ? ((0, _react.useMemo)(()=>{
        const d = e.flatMap((a)=>{
            const c = {}, g = [];
            for (const r of a.events)r.title in c ? c[r.title].events.push(r) : c[r.title] = {
                title: r.title,
                events: [
                    r
                ]
            };
            let m = 1;
            for(const r in c){
                const u = `${a.id}-${m}`;
                g.push({
                    id: u,
                    title: m === 1 ? a.title : "",
                    label: a.title,
                    events: c[r].events
                }), m++;
            }
            return g;
        });
        o(d);
    }, [
        e
    ]), l) : e;
}, ue = "_timelineContainer_1eiii_1", ge = "_timelineHeadline_1eiii_16", fe = "_spacer_1eiii_36", Ee = "_noData_1eiii_40", C = {
    timelineContainer: ue,
    timelineHeadline: ge,
    spacer: fe,
    noData: Ee
}, ye = ({ resources: e, tableId: t, hasWeekends: l = !1, flat: o = !1, showTooltip: d = !1, multiLine: a = !0, title: c = null, loading: g = !1, headline: m = null, pagination: r = null, actionsPosition: u = "top", noDataText: i = "No data", date: s, legendItem: f = null, onClick: x })=>{
    const [y, w] = (0, _react.useState)(N()), [v, A] = (0, _react.useState)(c), [R, j] = (0, _react.useState)(_(y));
    (0, _react.useEffect)(()=>{
        j(_(s, l)), A(H(s));
    }, [
        l,
        s
    ]);
    const B = m || /* @__PURE__ */ (0, _reactDefault.default).createElement(ee, {
        monthYear: y,
        onUpdate: (L)=>w(new Date(L))
    });
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: C.timelineContainer,
        id: `${t} timeline-container`
    }, g ? /* @__PURE__ */ (0, _reactDefault.default).createElement(le, null) : e.length > 0 ? /* @__PURE__ */ (0, _reactDefault.default).createElement(se, {
        resources: e,
        title: v,
        daysInMonth: R,
        monthYear: y,
        hasWeekends: l,
        tableId: t,
        flat: o,
        multiLine: a,
        showTooltip: d,
        onClick: x
    }) : /* @__PURE__ */ (0, _reactDefault.default).createElement("div", {
        className: C.noData
    }, /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null, /* @__PURE__ */ (0, _reactDefault.default).createElement("h3", null, v), /* @__PURE__ */ (0, _reactDefault.default).createElement("div", null, i))), /* @__PURE__ */ (0, _reactDefault.default).createElement(re, {
        legendItem: f,
        pagination: r
    }, u === "bottom" && B));
};

},{"./style.css":"3Z6l6","react":"gVheC","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3Z6l6":[function() {},{}],"9AcuN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colors", ()=>colors);
const colors = {
    pending: "#FFD54F",
    approved: "#81C784",
    rejected: "#FFAB91",
    expired: "#9E9E9E"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eXGPF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarQuery", ()=>useCalendarQuery);
var _material = require("@mui/material");
var _reactQuery = require("@tanstack/react-query");
var _lib = require("../../lib");
var _styles = require("../../lib/styles");
const useCalendarQuery = ({ date, employeeID, page })=>{
    const dateRange = [
        (0, _lib.toAWSDate)(new Date(date.start)),
        (0, _lib.toAWSDate)(new Date(date.end))
    ];
    var _toAWSDate;
    const { data: absenceData, isLoading, isFetching, isPreviousData, error } = (0, _reactQuery.useQuery)((0, _lib.gqlQuery)({
        req: "listAbsencesWithEmployees",
        vars: {
            filter: {
                or: [
                    {
                        startDate: {
                            between: dateRange
                        }
                    },
                    {
                        endDate: {
                            between: dateRange
                        }
                    }
                ]
            }
        },
        key: [
            (_toAWSDate = (0, _lib.toAWSDate)(new Date(date.start))) !== null && _toAWSDate !== void 0 ? _toAWSDate : "Invalid date"
        ]
    }));
    var _absenceData_data;
    const { listAbsences } = (_absenceData_data = absenceData === null || absenceData === void 0 ? void 0 : absenceData.data) !== null && _absenceData_data !== void 0 ? _absenceData_data : {};
    var _listAbsences_items;
    const absences = (_listAbsences_items = listAbsences === null || listAbsences === void 0 ? void 0 : listAbsences.items) !== null && _listAbsences_items !== void 0 ? _listAbsences_items : [];
    const employeeData = (absences !== null && absences !== void 0 ? absences : []).map((absence)=>absence.employee);
    const employees = filterUniqueEmployees(employeeData);
    var _employees_map;
    let items = (_employees_map = employees.map((e)=>({
            ...e,
            absences: {
                items: (absences !== null && absences !== void 0 ? absences : []).filter((a)=>a.employeeID === e.id),
                __typename: "ModelAbsenceConnection"
            }
        }))) !== null && _employees_map !== void 0 ? _employees_map : [];
    if (employeeID) items = items.filter((employee)=>employee.id === employeeID);
    const employeesWithAbsences = (items !== null && items !== void 0 ? items : []).map((employee)=>{
        var _employee_absences;
        const fullName = `${employee === null || employee === void 0 ? void 0 : employee.firstName} ${employee === null || employee === void 0 ? void 0 : employee.lastName}`;
        var _employee_id;
        return {
            id: (_employee_id = employee === null || employee === void 0 ? void 0 : employee.id) !== null && _employee_id !== void 0 ? _employee_id : "",
            title: fullName,
            label: fullName,
            events: (employee === null || employee === void 0 ? void 0 : (_employee_absences = employee.absences) === null || _employee_absences === void 0 ? void 0 : _employee_absences.items).map((a)=>{
                var _a_startDate_replace, _a_endDate_replace, _a_approvalStatus, _a_approvalStatus1;
                return {
                    start: new Date((_a_startDate_replace = a === null || a === void 0 ? void 0 : a.startDate.replace(/-/g, "/")) !== null && _a_startDate_replace !== void 0 ? _a_startDate_replace : ""),
                    end: new Date((_a_endDate_replace = a === null || a === void 0 ? void 0 : a.endDate.replace(/-/g, "/")) !== null && _a_endDate_replace !== void 0 ? _a_endDate_replace : ""),
                    title: (0, _material.capitalize)((_a_approvalStatus = a === null || a === void 0 ? void 0 : a.approvalStatus) !== null && _a_approvalStatus !== void 0 ? _a_approvalStatus : ""),
                    color: (0, _styles.colors)[(_a_approvalStatus1 = a === null || a === void 0 ? void 0 : a.approvalStatus) !== null && _a_approvalStatus1 !== void 0 ? _a_approvalStatus1 : "default"]
                };
            })
        };
    });
    const total = employeesWithAbsences.length;
    const paginated = employeesWithAbsences.slice(page.current * page.rowsPerPage, (page.current + 1) * page.rowsPerPage);
    return {
        items: paginated,
        total,
        isPending: isLoading || isPreviousData || isFetching,
        error: error
    };
};
const filterUniqueEmployees = (employees)=>{
    const uniqueKeys = new Set();
    return employees.filter((obj)=>{
        if (!uniqueKeys.has(obj.id)) {
            uniqueKeys.add(obj.id);
            return true;
        }
        return false;
    });
};

},{"@mui/material":"iknXc","@tanstack/react-query":"j0XMv","../../lib":"lWrCo","../../lib/styles":"9AcuN","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3uRvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _timeInLieu = require("./TimeInLieu");
parcelHelpers.exportAll(_timeInLieu, exports);

},{"./TimeInLieu":"f39sn","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f39sn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeInLieuTracker", ()=>TimeInLieuTracker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _notistack = require("notistack");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _lib = require("../../lib");
var _columns = require("./columns");
var _modals = require("./Modals");
var _utils = require("./utils");
const TEST_ID = "time-in-lieu-tracking";
const TimeInLieuTracker = ()=>{
    const [employeeID, setEmployeeID] = (0, _react.useState)("");
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfYear)(new Date()),
        end: (0, _dateFns.endOfYear)(new Date())
    });
    const { isMd } = (0, _hooks.useResponsive)();
    const { showActionModal } = (0, _modals.useActionModals)();
    const { updateTimeInLieuRecord } = (0, _lib.useTimeInLieuLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const { data, isError, refetch, isPending, pagination } = (0, _components.useQueryPagination)((0, _utils.timeInLieusQuery)({
        dates,
        id: employeeID
    }));
    const handleRowUpdate = (row)=>{
        const { description, id, endDate, startDate } = row;
        const data = {
            description,
            id,
            endDate,
            startDate
        };
        updateTimeInLieuRecord(data, {
            onSuccess: ()=>postAction("Time in Lieu request has been updated.", false),
            onError: ()=>postAction("Error updating Time in Lieu request. Please try again in a few seconds", true)
        });
        return {
            ...data,
            id: row.id
        };
    };
    const postAction = (message, isError)=>{
        showSnackbar(message, isError);
    };
    const fileName = `${dates ? `${(0, _lib.toIntervalString)(dates)} - ` : ""}${employeeID}TimeInLieu_Report`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.CalendarMonth), {}),
                title: "TimeInLieu Tracker",
                testID: TEST_ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: {
                    value: employeeID,
                    onChange: setEmployeeID
                },
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "range",
                    inputFormat: "yyyy-MM-dd"
                },
                testID: "TimeInLieu"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    showActionModal
                }),
                data: (data === null || data === void 0 ? void 0 : data.items) || [],
                csvOptions: {
                    fileName
                },
                pagination: pagination,
                emptyState: {
                    title: "Time in Lieu Requests",
                    description: "Time in Lieu requests that are pending will appear here for you to approve.",
                    testID: TEST_ID
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                sortModel: [
                    {
                        field: "dateTaken",
                        sort: "asc"
                    }
                ],
                testID: TEST_ID,
                disableColumnMenu: true,
                hideFooterPagination: true,
                disableSelectionOnClick: true,
                hideColumnSelector: true,
                processRowUpdate: handleRowUpdate,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : {}
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","notistack":"3Lc8y","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","../../lib":"lWrCo","./columns":"f34N9","./Modals":"3OIhs","./utils":"eQH9O","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"f34N9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsDesktop", ()=>hiddenColumnsDesktop);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _components = require("../../components");
var _api = require("../../API");
const columns = ({ showActionModal })=>[
        {
            field: "approvalStatus",
            headerName: "Status",
            width: 72,
            align: "center",
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                    status: value
                })
        },
        {
            field: "employee",
            headerName: "Employee",
            minWidth: 100,
            flex: 1,
            align: "left",
            valueGetter: ({ row: { employee } })=>`${employee.firstName} ${employee.lastName}`
        },
        {
            field: "approvedByClient",
            headerName: "Approved by Client",
            width: 100,
            align: "left",
            renderCell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalIcon), {
                    status: value ? "approved" : "pending"
                })
        },
        {
            field: "dateTaken",
            headerName: "Date Taken",
            align: "left",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _dateFns.parseISO)(value), "dd/MM/yyyy")
        },
        {
            field: "hoursTaken",
            headerName: "Hours"
        },
        {
            field: "description",
            headerName: "Description",
            align: "left",
            minWidth: 200
        },
        {
            field: "logIds",
            headerName: "Approval",
            type: "actions",
            minWidth: 200,
            renderCell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ApprovalCell), {
                    disable: {
                        approve: row.approvalStatus === "approved" || row.approvalStatus === "rejected",
                        reject: row.approvalStatus === "rejected"
                    },
                    onApprove: ()=>showActionModal({
                            row,
                            status: (0, _api.ApprovalStatus).approved
                        }),
                    onReject: ()=>showActionModal({
                            row,
                            status: (0, _api.ApprovalStatus).rejected
                        })
                })
        }
    ];
const hiddenColumnsDesktop = {};
const hiddenColumnsMobile = {
    ...hiddenColumnsDesktop
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","date-fns":"5Pdd3","../../components":"0272J","../../API":"2KRIM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3OIhs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actionModal = require("./ActionModal");
parcelHelpers.exportAll(_actionModal, exports);
var _useActionModal = require("./useActionModal");
parcelHelpers.exportAll(_useActionModal, exports);

},{"./ActionModal":"4gAYU","./useActionModal":"jjFRd","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4gAYU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionModal", ()=>ActionModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _components = require("../../../components");
var _api = require("../../../API");
const TEST_ID = "timeinlieu-modal";
const ActionModal = ({ onSubmit, testID, params: { row, status }, ...rest })=>{
    const { control, handleSubmit } = (0, _reactHookForm.useForm)({
        defaultValues: mapDefaultValues(row, status)
    });
    const [saving, setSaving] = (0, _react.useState)(false);
    const statusToTitle = status === (0, _api.ApprovalStatus).approved ? "Approve" : "Reject";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalSkeleton), {
        ...rest,
        title: `${statusToTitle} Time Off Request`,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                setSaving(true);
                const x = data;
                return onSubmit({
                    data: x
                });
            }),
            testID: "save-request"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)"
                },
                alignItems: "center",
                gap: 2,
                mb: 1
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                control: control,
                name: "notes",
                label: "Notes",
                multiline: true,
                rows: 2,
                "data-testid": `${TEST_ID}-notes`,
                required: true,
                helperText: "Use this field to provide additional information about your approval/denial."
            })
        })
    });
};
const mapDefaultValues = (value, status)=>{
    var _value_id, _value_dateTaken, _value_notes;
    return {
        id: (_value_id = value === null || value === void 0 ? void 0 : value.id) !== null && _value_id !== void 0 ? _value_id : "",
        dateTaken: (_value_dateTaken = value === null || value === void 0 ? void 0 : value.dateTaken) !== null && _value_dateTaken !== void 0 ? _value_dateTaken : new Date().toISOString(),
        notes: (_value_notes = value === null || value === void 0 ? void 0 : value.notes) !== null && _value_notes !== void 0 ? _value_notes : "",
        approvalStatus: status !== null && status !== void 0 ? status : (0, _api.ApprovalStatus).pending
    };
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","../../../components":"0272J","../../../API":"2KRIM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"jjFRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useActionModals", ()=>useActionModals);
var _notistack = require("notistack");
var _components = require("../../../components");
var _lib = require("../../../lib");
var _actionModal = require("./ActionModal");
const useActionModals = ()=>{
    const { updateTimeInLieuRecord } = (0, _lib.useTimeInLieuLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const postAction = (message, isError, callback)=>{
        showSnackbar(message, isError);
        callback();
    };
    const { showModal: showActionModal, hideModal } = (0, _components.useModal)({
        component: (0, _actionModal.ActionModal),
        data: {
            onSubmit: ({ data })=>updateTimeInLieuRecord(data, {
                    onSuccess: ()=>postAction("Time in Lieu request has been updated.", false, hideModal),
                    onError: ()=>postAction("Error updating Time in Lieu request. Please try again in a few seconds", true, hideModal)
                }),
            testID: "manage-request"
        }
    });
    return {
        showActionModal
    };
};

},{"notistack":"3Lc8y","../../../components":"0272J","../../../lib":"lWrCo","./ActionModal":"4gAYU","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eQH9O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInLieusQuery", ()=>timeInLieusQuery);
var _lib = require("../../lib");
const timeInLieusQuery = ({ dates, id })=>(input)=>{
        if (dates === null) throw new Error(`Incorrect date range. Value is ${dates}`);
        const dateRange = (0, _lib.toDbDates)(dates);
        var _input_key, _input_key1;
        const { queryFn: listTimeInLieusQueryFn, queryKey } = (0, _lib.gqlQuery)({
            req: "listTimeInLieus",
            vars: {
                filter: id.length > 0 ? {
                    employeeID: {
                        contains: id
                    },
                    dateTaken: {
                        between: dateRange
                    }
                } : {
                    dateTaken: {
                        between: dateRange
                    }
                },
                ...input.vars,
                ...id.length > 0 && {
                    id
                }
            },
            key: id ? [
                dateRange,
                {
                    id
                },
                ...(_input_key = input.key) !== null && _input_key !== void 0 ? _input_key : []
            ] : [
                dateRange,
                ...(_input_key1 = input.key) !== null && _input_key1 !== void 0 ? _input_key1 : []
            ]
        });
        return {
            queryKey,
            queryFn: async ()=>{
                var _absenceData_listTimeInLieus, _absenceData_listTimeInLieus1;
                const { data: absenceData, errors: absenceErrors = [] } = await listTimeInLieusQueryFn();
                return {
                    items: absenceData === null || absenceData === void 0 ? void 0 : (_absenceData_listTimeInLieus = absenceData.listTimeInLieus) === null || _absenceData_listTimeInLieus === void 0 ? void 0 : _absenceData_listTimeInLieus.items,
                    errors: [
                        ...absenceErrors
                    ],
                    nextToken: absenceData === null || absenceData === void 0 ? void 0 : (_absenceData_listTimeInLieus1 = absenceData.listTimeInLieus) === null || _absenceData_listTimeInLieus1 === void 0 ? void 0 : _absenceData_listTimeInLieus1.nextToken
                };
            }
        };
    };

},{"../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"bNs0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bankHolidays = require("./BankHolidays");
parcelHelpers.exportAll(_bankHolidays, exports);

},{"./BankHolidays":"hH5M7","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"hH5M7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BankHolidays", ()=>BankHolidays);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _notistack = require("notistack");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _lib = require("../../lib");
var _columns = require("./columns");
var _modals = require("./Modals");
var _useBankHolidayQuery = require("./useBankHolidayQuery");
const TEST_ID = "bank-holidays";
const BankHolidays = ()=>{
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfYear)(new Date()),
        end: (0, _dateFns.endOfYear)(new Date())
    });
    const [country, setCountry] = (0, _react.useState)("");
    const { isMd } = (0, _hooks.useResponsive)();
    const { updateBankHolidayRecord } = (0, _lib.useBankHolidayLib)();
    const { showCreateModal, showDeleteModal, showUpdateModal } = (0, _modals.useRequestModals)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const { items, isError, refetch, isPending } = (0, _useBankHolidayQuery.useBankHolidayQuery)(dates, country);
    const handleRowUpdate = (row)=>{
        const { description, id, endDate, startDate } = row;
        const data = {
            description,
            id,
            endDate,
            startDate
        };
        updateBankHolidayRecord(data, {
            onSuccess: ()=>postAction("Bank Holiday has been updated.", false),
            onError: ()=>postAction("Error updating Bank Holiday. Please try again in a few seconds", true)
        });
        return {
            ...data,
            id: row.id
        };
    };
    const postAction = (message, isError)=>{
        showSnackbar(message, isError);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.HolidayVillage), {}),
                title: "Bank Holiday Management",
                testID: TEST_ID,
                action: {
                    label: "Add Holiday",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                    onClick: ()=>showCreateModal({
                            bankHolidays: items
                        })
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "range",
                    inputFormat: "yyyy-MM-dd"
                },
                country: {
                    value: country,
                    onChange: (val)=>{
                        setCountry(val);
                    }
                },
                testID: "BankHoliday"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    showUpdateModal,
                    showDeleteModal,
                    bankHolidays: items !== null && items !== void 0 ? items : []
                }),
                data: items || [],
                emptyState: {
                    title: "Bank Holidays",
                    description: "Bank Holidays will appear here for you.",
                    testID: TEST_ID
                },
                errorState: {
                    isError,
                    onClick: refetch
                },
                loading: isPending,
                sortModel: [
                    {
                        field: "date",
                        sort: "asc"
                    }
                ],
                testID: TEST_ID,
                disableColumnMenu: true,
                hideExport: true,
                hideFooterPagination: true,
                disableSelectionOnClick: true,
                hideColumnSelector: true,
                processRowUpdate: handleRowUpdate,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : {}
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","notistack":"3Lc8y","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","../../lib":"lWrCo","./columns":"2RsYV","./Modals":"3aAmf","./useBankHolidayQuery":"1LO7A","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2RsYV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xDataGrid = require("@mui/x-data-grid");
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _components = require("../../components");
const renderActionButton = ({ icon, label, onClick }, params, bankHolidays)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Tooltip), {
        title: label,
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": `grid-${label.toLowerCase()}-button`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridActionsCellItem), {
                label: label,
                onClick: ()=>{
                    onClick({
                        ...params,
                        bankHolidays
                    });
                },
                icon: icon
            })
        })
    });
const columns = ({ showUpdateModal, showDeleteModal, bankHolidays })=>[
        {
            field: "date",
            headerName: "Date",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _dateFns.parseISO)(value), "dd/MM/yyyy")
        },
        {
            field: "localName",
            headerName: "Name",
            minWidth: 50
        },
        {
            field: "countryCode",
            headerName: "Country",
            minWidth: 50
        },
        {
            field: "counties",
            headerName: "Counties",
            align: "left",
            flex: 1,
            valueGetter: ({ row })=>{
                var _row_counties;
                return ((_row_counties = row.counties) !== null && _row_counties !== void 0 ? _row_counties : []).join("; ");
            }
        },
        {
            field: "actions",
            headerName: "Actions",
            cellClassName: "actions",
            width: 96,
            sortable: false,
            headerAlign: "left",
            renderCell: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        renderActionButton({
                            label: "Edit",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Edit), {}),
                            onClick: showUpdateModal
                        }, params, bankHolidays),
                        renderActionButton({
                            label: "Delete",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Delete), {}),
                            onClick: showDeleteModal
                        }, params)
                    ]
                })
        }
    ];
const hiddenColumnsMobile = {};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/x-data-grid":"1d1Aj","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"3aAmf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requestModal = require("./RequestModal");
parcelHelpers.exportAll(_requestModal, exports);
var _useRequestModals = require("./useRequestModals");
parcelHelpers.exportAll(_useRequestModals, exports);

},{"./RequestModal":"9xgzm","./useRequestModals":"85Umg","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"9xgzm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestModal", ()=>RequestModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _notistack = require("notistack");
var _dateHolidays = require("date-holidays");
var _dateHolidaysDefault = parcelHelpers.interopDefault(_dateHolidays);
var _components = require("../../../components");
var _api = require("../../../API");
var _lib = require("../../../lib");
var _dateControl = require("../../../components/DatePickers/DateControl");
var _dateControlDefault = parcelHelpers.interopDefault(_dateControl);
var _utils = require("../../../lib/utils");
var _utils1 = require("./utils");
const RequestModal = ({ title, onSubmit, testID, params: { row, bankHolidays }, ...rest })=>{
    const hd = new (0, _dateHolidaysDefault.default)();
    const { control, handleSubmit, setValue } = (0, _reactHookForm.useForm)({
        defaultValues: (0, _utils1.mapDefaultValues)(row)
    });
    var _row_countryCode;
    const [countyOptions, setCountyOptions] = (0, _react.useState)((0, _lib.mapOptions)(hd.getStates((_row_countryCode = row === null || row === void 0 ? void 0 : row.countryCode) !== null && _row_countryCode !== void 0 ? _row_countryCode : (0, _api.Country).GB)));
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const handleCountryChange = (value)=>{
        setValue("countryCode", value);
        setValue("counties", []);
        setCountyOptions((0, _lib.mapOptions)(hd.getStates(value)));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            onSubmit: handleSubmit((data)=>{
                if ((0, _utils1.checkIfExistingBankHoliday)({
                    bankHolidays,
                    counties: data.counties,
                    country: data.countryCode,
                    currentBankHolidayId: data.id,
                    date: data.date
                })) {
                    showSnackbar("Bank holiday already exist in the system", true);
                    return;
                }
                return onSubmit({
                    data
                });
            }),
            testID: "save-request"
        },
        testID: testID,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            sx: {
                display: "grid",
                gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)"
                },
                alignItems: "center",
                gap: 2
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SelectField), {
                    name: "countryCode",
                    control: control,
                    label: "Country",
                    placeholder: "Select country",
                    options: (0, _utils.countryOptions),
                    onChange: (e)=>handleCountryChange(e.target.value),
                    required: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateControlDefault.default), {
                    name: "date",
                    control: control,
                    label: "Holiday Date",
                    onChange: (val)=>setValue("date", val !== null && val !== void 0 ? val : "")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                    name: "localName",
                    control: control,
                    label: "Holiday Name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SelectField), {
                    name: "counties",
                    control: control,
                    label: "Counties",
                    options: countyOptions,
                    multiple: true
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","notistack":"3Lc8y","date-holidays":"4EXP1","../../../components":"0272J","../../../API":"2KRIM","../../../lib":"lWrCo","../../../components/DatePickers/DateControl":"6PaYh","../../../lib/utils":"2QLpi","./utils":"4Inu8","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"4Inu8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkIfExistingBankHoliday", ()=>checkIfExistingBankHoliday);
parcelHelpers.export(exports, "mapDefaultValues", ()=>mapDefaultValues);
var _api = require("../../../API");
var _lib = require("../../../lib");
const checkIfExistingBankHoliday = ({ bankHolidays, currentBankHolidayId, country, counties, date })=>{
    if (!bankHolidays || bankHolidays.length === 0) return false;
    return !!(bankHolidays === null || bankHolidays === void 0 ? void 0 : bankHolidays.find((a)=>{
        // If Updating current Bank Holiday ignore
        if (a.id === currentBankHolidayId) return false;
        const currDate = a.date;
        const newDate = (0, _lib.toAWSDate)(new Date(date));
        const currCountry = a.countryCode;
        const currCounties = a.counties;
        return currDate === newDate && currCountry === country && (currCounties === null || currCounties === void 0 ? void 0 : currCounties.some((c)=>counties && counties.includes(c !== null && c !== void 0 ? c : "")));
    }));
};
const mapDefaultValues = (value)=>{
    var _value_date, _value_countryCode, _value_localName, _value_counties;
    return {
        id: value === null || value === void 0 ? void 0 : value.id,
        date: (_value_date = value === null || value === void 0 ? void 0 : value.date) !== null && _value_date !== void 0 ? _value_date : new Date(),
        countryCode: (_value_countryCode = value === null || value === void 0 ? void 0 : value.countryCode) !== null && _value_countryCode !== void 0 ? _value_countryCode : (0, _api.Country).GB,
        localName: (_value_localName = value === null || value === void 0 ? void 0 : value.localName) !== null && _value_localName !== void 0 ? _value_localName : "",
        counties: (_value_counties = value === null || value === void 0 ? void 0 : value.counties) !== null && _value_counties !== void 0 ? _value_counties : []
    };
};

},{"../../../API":"2KRIM","../../../lib":"lWrCo","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"85Umg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRequestModals", ()=>useRequestModals);
var _notistack = require("notistack");
var _components = require("../../../components");
var _lib = require("../../../lib");
var _requestModal = require("./RequestModal");
const useRequestModals = ()=>{
    const { createBankHolidayRecord, updateBankHolidayRecord, deleteBankHolidayRecord } = (0, _lib.useBankHolidayLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const postAction = (message, isError, callback)=>{
        showSnackbar(message, isError);
        callback();
    };
    const { showModal: showCreateModal, hideModal: hideCreateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Create Bank Holiday",
            onSubmit: ({ data })=>createBankHolidayRecord(data, {
                    onSuccess: ()=>postAction("Bank Holiday has been created", false, hideCreateModal),
                    onError: ()=>postAction("Error creating Bank Holiday. Please try again in a few seconds", true, hideCreateModal)
                }),
            testID: "create-request"
        }
    });
    const { showModal: showUpdateModal, hideModal: hideUpdateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Update Bank Holiday record",
            onSubmit: ({ data })=>!data.id ? null : updateBankHolidayRecord({
                    ...data,
                    id: data.id
                }, {
                    onSuccess: ()=>postAction("Bank holiday has been updated.", false, hideUpdateModal),
                    onError: ()=>postAction("Error updating Bank holiday. Please try again in a few seconds", true, hideUpdateModal)
                }),
            testID: "update-request"
        }
    });
    const { showModal: showDeleteModal, hideModal: hideDeleteModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Remove Bank holiday",
            label: "Remove",
            description: "Are you sure you want to remove this entry?",
            onUpdate: ({ id })=>deleteBankHolidayRecord(id, {
                    onSuccess: ()=>postAction("Bank holiday has been deleted.", false, hideDeleteModal),
                    onError: ()=>postAction("Error deleting Bank Holiday. Please try again in a few seconds", true, hideDeleteModal)
                })
        }
    });
    return {
        showCreateModal,
        showUpdateModal,
        showDeleteModal
    };
};

},{"notistack":"3Lc8y","../../../components":"0272J","../../../lib":"lWrCo","./RequestModal":"9xgzm","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eY9o1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _timeInLieu = require("./TimeInLieu");
parcelHelpers.exportAll(_timeInLieu, exports);

},{"./TimeInLieu":"aPcOM","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"aPcOM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeInLieu", ()=>TimeInLieu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _components = require("../../components");
var _hooks = require("../../hooks");
var _modals = require("./Modals");
var _columns = require("./columns");
var _useTimeInLieuQuery = require("./useTimeInLieuQuery");
const TEST_ID = "time-in-lieu";
const TimeInLieu = ()=>{
    const user = (0, _hooks.useUser)();
    var _user_id;
    const [filterUser, setFilterUser] = (0, _react.useState)((_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : "");
    const [dates, setDates] = (0, _react.useState)({
        start: (0, _dateFns.startOfYear)(new Date()),
        end: (0, _dateFns.endOfYear)(new Date())
    });
    const handleUserSearch = (val)=>{
        var _user_id;
        setFilterUser(val ? val : (_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : "");
    };
    const { showCreateModal, showUpdateModal, showDeleteModal } = (0, _modals.useRequestModals)();
    const { isMd } = (0, _hooks.useResponsive)();
    const { items, error, isPending } = (0, _useTimeInLieuQuery.useEmployeeTimeInLieusQuery)(filterUser, dates);
    var _error_message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PageTitle), {
                action: {
                    label: "Time in Lieu",
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Add), {}),
                    onClick: ()=>showCreateModal({
                            timeInLieus: [],
                            employeeID: filterUser
                        }),
                    disabled: !filterUser
                },
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.AlarmOff), {}),
                title: "Time In Lieu",
                testID: TEST_ID
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterBar), {
                employee: user && (user === null || user === void 0 ? void 0 : user.isAdmin) ? {
                    value: filterUser || user.id,
                    onChange: handleUserSearch
                } : undefined,
                dates: {
                    value: dates,
                    onChange: setDates,
                    type: "year"
                },
                testID: "timeoff"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DataGrid), {
                columns: (0, _columns.columns)({
                    showUpdateModal,
                    showDeleteModal,
                    timeInLieus: items,
                    employeeID: filterUser,
                    maxDate: (dates === null || dates === void 0 ? void 0 : dates.end) ? new Date(dates.end) : new Date(),
                    minDate: (dates === null || dates === void 0 ? void 0 : dates.start) ? new Date(dates.start) : new Date()
                }),
                data: items !== null && items !== void 0 ? items : [],
                loading: isPending,
                emptyState: {
                    title: "Time In Lieu",
                    description: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : "You have no time in lieu requests.",
                    testID: TEST_ID
                },
                hideColumnSelector: true,
                hideExport: true,
                testID: TEST_ID,
                disableColumnMenu: true,
                hideFooterPagination: true,
                disableSelectionOnClick: true,
                columnVisibility: isMd ? (0, _columns.hiddenColumnsMobile) : {},
                sortModel: [
                    {
                        field: "startDate",
                        sort: "asc"
                    }
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../components":"0272J","../../hooks":"9Pg07","./Modals":"eYAKp","./columns":"cLmVR","./useTimeInLieuQuery":"nBlzt","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"eYAKp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requestModal = require("./RequestModal");
parcelHelpers.exportAll(_requestModal, exports);
var _useRequestModals = require("./useRequestModals");
parcelHelpers.exportAll(_useRequestModals, exports);

},{"./RequestModal":"2Fw7p","./useRequestModals":"dcDxB","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Fw7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestModal", ()=>RequestModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHookForm = require("react-hook-form");
var _material = require("@mui/material");
var _notistack = require("notistack");
var _components = require("../../../components");
var _hooks = require("../../../hooks");
var _lib = require("../../../lib");
var _dateControl = require("../../../components/DatePickers/DateControl");
var _dateControlDefault = parcelHelpers.interopDefault(_dateControl);
var _utils = require("./utils");
const RequestModal = ({ title, onSubmit, testID, params: { row, timeInLieus, employeeID }, ...rest })=>{
    const user = (0, _hooks.useUser)();
    const { control, handleSubmit, getValues, setValue } = (0, _reactHookForm.useForm)({
        defaultValues: (0, _utils.mapDefaultValues)(row, user, employeeID)
    });
    const [saving, setSaving] = (0, _react.useState)(false);
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.ModalSkeleton), {
        ...rest,
        title: title,
        isForm: true,
        primaryAction: {
            label: "Save",
            pending: saving,
            onSubmit: handleSubmit((data)=>{
                if (!getValues("approvedByClient")) {
                    showSnackbar("Time in Lieu must by approved by a Client first, before submitting it", true);
                    return;
                }
                if (!data.description || data.description.trim() === "") {
                    showSnackbar("Description is required", true);
                    return;
                }
                if ((0, _utils.checkExistingTimeInLieu)({
                    timeInLieus,
                    existingTimeInLieuId: data.id,
                    formDateTaken: data.dateTaken
                })) {
                    showSnackbar("Time in Lieu dates already exist in the system", true);
                    return;
                }
                data.dateEarned = (0, _lib.toAWSDate)(new Date());
                setSaving(true);
                if (data === null || data === void 0 ? void 0 : data.employeeID) return onSubmit({
                    data
                });
                return;
            }),
            testID: "save-request"
        },
        testID: testID,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        md: "repeat(3, 1fr)"
                    },
                    alignItems: "start",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateControlDefault.default), {
                        name: "dateTaken",
                        control: control,
                        label: "Time in Lieu Date",
                        onChange: (date)=>{
                            setValue("dateTaken", new Date(date !== null && date !== void 0 ? date : "").toISOString());
                            setValue("hoursTaken", date ? 8 : 0);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                        name: "hoursTaken",
                        control: control,
                        label: "Hours",
                        required: true,
                        type: "number",
                        onChange: (e)=>setValue("hoursTaken", (0, _lib.formatHoursChange)(e.target.value))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TextField), {
                        name: "description",
                        control: control,
                        label: "Description",
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                sx: {
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)"
                    },
                    alignItems: "center",
                    my: 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                        required: true,
                        control: control,
                        name: "approvedByClient",
                        label: "Checked and approved by client?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                        variant: "caption",
                        color: "info",
                        mb: 2,
                        children: "In case of no client, mark it as approved"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"1elNt","react":"gVheC","react-hook-form":"a5Zq3","@mui/material":"iknXc","notistack":"3Lc8y","../../../components":"0272J","../../../hooks":"9Pg07","../../../lib":"lWrCo","../../../components/DatePickers/DateControl":"6PaYh","./utils":"2Bzxf","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"2Bzxf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkExistingTimeInLieu", ()=>checkExistingTimeInLieu);
parcelHelpers.export(exports, "mapDefaultValues", ()=>mapDefaultValues);
var _api = require("../../../API");
var _lib = require("../../../lib");
var _absences = require("../../../lib/types/absences");
const validTimeInLieu = [
    (0, _absences.TimeOffEnum).Approved,
    (0, _absences.TimeOffEnum).Pending,
    (0, _absences.TimeOffEnum).Expired
];
const checkExistingTimeInLieu = ({ timeInLieus, existingTimeInLieuId, formDateTaken })=>{
    if (!timeInLieus || timeInLieus.length === 0) return false;
    return !!(timeInLieus === null || timeInLieus === void 0 ? void 0 : timeInLieus.find((a)=>{
        // If Updating current Absence ignore
        if (a.id === existingTimeInLieuId || !formDateTaken) return false;
        const dateTaken = a.dateTaken;
        const newDateTaken = (0, _lib.toAWSDate)(new Date(formDateTaken));
        var _a_approvalStatus;
        const isValidRequest = validTimeInLieu.includes((_a_approvalStatus = a === null || a === void 0 ? void 0 : a.approvalStatus) !== null && _a_approvalStatus !== void 0 ? _a_approvalStatus : "");
        return(// check if starts before and end is within the existing range
        newDateTaken === dateTaken && isValidRequest);
    }));
};
const mapDefaultValues = (value, user, employeeID)=>{
    var _value_dateTaken, _value_hoursTaken, _value_dateEarned, _value_description, _value_employeeID, _ref, _ref1, _value_approvalStatus, _value_approvedByClient;
    return {
        id: value === null || value === void 0 ? void 0 : value.id,
        dateTaken: (_value_dateTaken = value === null || value === void 0 ? void 0 : value.dateTaken) !== null && _value_dateTaken !== void 0 ? _value_dateTaken : "",
        hoursTaken: (_value_hoursTaken = value === null || value === void 0 ? void 0 : value.hoursTaken) !== null && _value_hoursTaken !== void 0 ? _value_hoursTaken : 0,
        dateEarned: (_value_dateEarned = value === null || value === void 0 ? void 0 : value.dateEarned) !== null && _value_dateEarned !== void 0 ? _value_dateEarned : "",
        description: (_value_description = value === null || value === void 0 ? void 0 : value.description) !== null && _value_description !== void 0 ? _value_description : "",
        employeeID: (_ref1 = (_ref = (_value_employeeID = value === null || value === void 0 ? void 0 : value.employeeID) !== null && _value_employeeID !== void 0 ? _value_employeeID : employeeID) !== null && _ref !== void 0 ? _ref : user === null || user === void 0 ? void 0 : user.id) !== null && _ref1 !== void 0 ? _ref1 : "",
        approvalStatus: (_value_approvalStatus = value === null || value === void 0 ? void 0 : value.approvalStatus) !== null && _value_approvalStatus !== void 0 ? _value_approvalStatus : (0, _api.ApprovalStatus).pending,
        approvedByClient: (_value_approvedByClient = value === null || value === void 0 ? void 0 : value.approvedByClient) !== null && _value_approvedByClient !== void 0 ? _value_approvedByClient : false
    };
};

},{"../../../API":"2KRIM","../../../lib":"lWrCo","../../../lib/types/absences":"xOG3F","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"dcDxB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRequestModals", ()=>useRequestModals);
var _notistack = require("notistack");
var _components = require("../../../components");
var _lib = require("../../../lib");
var _requestModal = require("./RequestModal");
const useRequestModals = ()=>{
    const { createTimeInLieuRecord, updateTimeInLieuRecord, deleteTimeInLieuRecord } = (0, _lib.useTimeInLieuLib)();
    const { enqueueSnackbar } = (0, _notistack.useSnackbar)();
    const showSnackbar = (message, error = false)=>{
        enqueueSnackbar(message, {
            variant: error ? "error" : "success"
        });
    };
    const postAction = (message, isError, callback)=>{
        showSnackbar(message, isError);
        callback();
    };
    const { showModal: showCreateModal, hideModal: hideCreateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Request Time In Lieu",
            onSubmit: ({ data })=>createTimeInLieuRecord(data, {
                    onSuccess: ()=>postAction("Your time in lieu request has been submitted.", false, hideCreateModal),
                    onError: ()=>postAction("Error requesting time in lieu. Please try again in a few seconds", true, hideCreateModal)
                }),
            testID: "create-time-in-lieu-request"
        }
    });
    const { showModal: showUpdateModal, hideModal: hideUpdateModal } = (0, _components.useModal)({
        component: (0, _requestModal.RequestModal),
        data: {
            title: "Update Time In Lieu",
            onSubmit: ({ data })=>!data.id ? null : updateTimeInLieuRecord({
                    ...data,
                    id: data.id
                }, {
                    onSuccess: ()=>postAction("Your time in lieu request has been submitted.", false, hideUpdateModal),
                    onError: ()=>postAction("Error requesting time in lieu. Please try again in a few seconds", true, hideUpdateModal)
                }),
            testID: "update-request"
        }
    });
    const { showModal: showDeleteModal, hideModal: hideDeleteModal } = (0, _components.useModal)({
        component: (0, _components.UpdateModal),
        data: {
            title: "Remove Time In Lieu Request",
            label: "Remove",
            description: "Are you sure you want to remove this entry?",
            onUpdate: ({ id })=>deleteTimeInLieuRecord(id, {
                    onSuccess: ()=>postAction("Your time in lieu request has been deleted.", false, hideDeleteModal),
                    onError: ()=>postAction("Error deleting time in lieu. Please try again in a few seconds", true, hideDeleteModal)
                })
        }
    });
    return {
        showCreateModal,
        showUpdateModal,
        showDeleteModal
    };
};

},{"notistack":"3Lc8y","../../../components":"0272J","../../../lib":"lWrCo","./RequestModal":"2Fw7p","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}],"cLmVR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
parcelHelpers.export(exports, "hiddenColumnsMobile", ()=>hiddenColumnsMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _xDataGrid = require("@mui/x-data-grid");
var _iconsMaterial = require("@mui/icons-material");
var _dateFns = require("date-fns");
var _lib = require("../../lib");
var _api = require("../../API");
var _components = require("../../components");
const displayStatus = (sts)=>sts[0].toUpperCase() + sts.slice(1);
const disabledAction = (status)=>status !== (0, _api.ApprovalStatus).pending;
const renderActionButton = ({ icon, label, onClick }, params, timeInLieus, employeeID, maxDate, minDate)=>disabledAction(params.row.approvalStatus) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Tooltip), {
        title: label,
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            "data-testid": `grid-${label.toLowerCase()}-button`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _xDataGrid.GridActionsCellItem), {
                label: label,
                onClick: ()=>{
                    onClick({
                        ...params,
                        timeInLieus,
                        employeeID,
                        maxDate,
                        minDate
                    });
                },
                icon: icon
            })
        })
    });
const columns = ({ showUpdateModal, showDeleteModal, timeInLieus, employeeID, maxDate, minDate })=>[
        {
            field: "dateTaken",
            headerName: "Date",
            minWidth: 112,
            renderCell: ({ value })=>(0, _dateFns.format)((0, _lib.parseDate)(value), "dd/MM/yyyy")
        },
        {
            field: "hoursTaken",
            headerName: "Hours"
        },
        {
            field: "description",
            headerName: "Description",
            flex: 1
        },
        {
            field: "approvalStatus",
            headerName: "Approval status",
            width: 128,
            renderCell: ({ value })=>displayStatus(value !== null && value !== void 0 ? value : "pending")
        },
        {
            field: "actions",
            headerName: "Actions",
            cellClassName: "actions",
            width: 96,
            sortable: false,
            headerAlign: "left",
            renderCell: (params)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        renderActionButton({
                            label: "Edit",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Edit), {}),
                            onClick: showUpdateModal
                        }, params, timeInLieus, employeeID, maxDate, minDate),
                        renderActionButton({
                            label: "Delete",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsMaterial.Delete), {}),
                            onClick: showDeleteModal
                        }, params)
                    ]
                })
        }
    ];
const hiddenColumnsMobile = {};

},{"react/jsx-runtime":"1elNt","react":"gVheC","@mui/x-data-grid":"1d1Aj","@mui/icons-material":"4DI4K","date-fns":"5Pdd3","../../lib":"lWrCo","../../API":"2KRIM","../../components":"0272J","@parcel/transformer-js/src/esmodule-helpers.js":"kznVD"}]},["gX9nn"], "gX9nn", "parcelRequire8ed2")

//# sourceMappingURL=index.f5f0a73e.js.map
